
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequiree9f1"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequiree9f1"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("i3UfC", function(module, exports) {
$parcel$export(module.exports, "Fragment", () => $d264241760fafaed$export$ffb0004e005737fa);
$parcel$export(module.exports, "jsx", () => $d264241760fafaed$export$34b9dba7ce09269b);
$parcel$export(module.exports, "jsxs", () => $d264241760fafaed$export$25062201e9e25d76);

var $lxNpW = parcelRequire("lxNpW");
const $d264241760fafaed$export$ffb0004e005737fa = $lxNpW.Fragment;
const $d264241760fafaed$export$34b9dba7ce09269b = $lxNpW.jsx;
const $d264241760fafaed$export$25062201e9e25d76 = $lxNpW.jsxs;

});
parcelRegister("lxNpW", function(module, exports) {
'use strict';

module.exports = (parcelRequire("eumjn"));

});
parcelRegister("eumjn", function(module, exports) {
$parcel$export(module.exports, "Fragment", () => $a8c52ca0fff03671$export$ffb0004e005737fa, (v) => $a8c52ca0fff03671$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "jsx", () => $a8c52ca0fff03671$export$34b9dba7ce09269b, (v) => $a8c52ca0fff03671$export$34b9dba7ce09269b = v);
$parcel$export(module.exports, "jsxs", () => $a8c52ca0fff03671$export$25062201e9e25d76, (v) => $a8c52ca0fff03671$export$25062201e9e25d76 = v);
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $a8c52ca0fff03671$export$ffb0004e005737fa;
var $a8c52ca0fff03671$export$34b9dba7ce09269b;
var $a8c52ca0fff03671$export$25062201e9e25d76;
'use strict';

var $5FkrB = parcelRequire("5FkrB");
var $a8c52ca0fff03671$var$k = Symbol.for("react.element"), $a8c52ca0fff03671$var$l = Symbol.for("react.fragment"), $a8c52ca0fff03671$var$m = Object.prototype.hasOwnProperty, $a8c52ca0fff03671$var$n = $5FkrB.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $a8c52ca0fff03671$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $a8c52ca0fff03671$var$q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for(b in a)$a8c52ca0fff03671$var$m.call(a, b) && !$a8c52ca0fff03671$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $a8c52ca0fff03671$var$k,
        type: c,
        key: e,
        ref: h,
        props: d,
        _owner: $a8c52ca0fff03671$var$n.current
    };
}
$a8c52ca0fff03671$export$ffb0004e005737fa = $a8c52ca0fff03671$var$l;
$a8c52ca0fff03671$export$34b9dba7ce09269b = $a8c52ca0fff03671$var$q;
$a8c52ca0fff03671$export$25062201e9e25d76 = $a8c52ca0fff03671$var$q;

});
parcelRegister("5FkrB", function(module, exports) {
'use strict';

module.exports = (parcelRequire("abbvA"));

});
parcelRegister("abbvA", function(module, exports) {
$parcel$export(module.exports, "Children", () => $7693dbd047ade921$export$dca3b0875bd9a954, (v) => $7693dbd047ade921$export$dca3b0875bd9a954 = v);
$parcel$export(module.exports, "Component", () => $7693dbd047ade921$export$16fa2f45be04daa8, (v) => $7693dbd047ade921$export$16fa2f45be04daa8 = v);
$parcel$export(module.exports, "Fragment", () => $7693dbd047ade921$export$ffb0004e005737fa, (v) => $7693dbd047ade921$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Profiler", () => $7693dbd047ade921$export$e2c29f18771995cb, (v) => $7693dbd047ade921$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "PureComponent", () => $7693dbd047ade921$export$221d75b3f55bb0bd, (v) => $7693dbd047ade921$export$221d75b3f55bb0bd = v);
$parcel$export(module.exports, "StrictMode", () => $7693dbd047ade921$export$5f8d39834fd61797, (v) => $7693dbd047ade921$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $7693dbd047ade921$export$74bf444e3cd11ea5, (v) => $7693dbd047ade921$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", () => $7693dbd047ade921$export$ae55be85d98224ed, (v) => $7693dbd047ade921$export$ae55be85d98224ed = v);
$parcel$export(module.exports, "act", () => $7693dbd047ade921$export$3ba232387fd5d6dd, (v) => $7693dbd047ade921$export$3ba232387fd5d6dd = v);
$parcel$export(module.exports, "cloneElement", () => $7693dbd047ade921$export$e530037191fcd5d7, (v) => $7693dbd047ade921$export$e530037191fcd5d7 = v);
$parcel$export(module.exports, "createContext", () => $7693dbd047ade921$export$fd42f52fd3ae1109, (v) => $7693dbd047ade921$export$fd42f52fd3ae1109 = v);
$parcel$export(module.exports, "createElement", () => $7693dbd047ade921$export$c8a8987d4410bf2d, (v) => $7693dbd047ade921$export$c8a8987d4410bf2d = v);
$parcel$export(module.exports, "createFactory", () => $7693dbd047ade921$export$d38cd72104c1f0e9, (v) => $7693dbd047ade921$export$d38cd72104c1f0e9 = v);
$parcel$export(module.exports, "createRef", () => $7693dbd047ade921$export$7d1e3a5e95ceca43, (v) => $7693dbd047ade921$export$7d1e3a5e95ceca43 = v);
$parcel$export(module.exports, "forwardRef", () => $7693dbd047ade921$export$257a8862b851cb5b, (v) => $7693dbd047ade921$export$257a8862b851cb5b = v);
$parcel$export(module.exports, "isValidElement", () => $7693dbd047ade921$export$a8257692ac88316c, (v) => $7693dbd047ade921$export$a8257692ac88316c = v);
$parcel$export(module.exports, "lazy", () => $7693dbd047ade921$export$488013bae63b21da, (v) => $7693dbd047ade921$export$488013bae63b21da = v);
$parcel$export(module.exports, "memo", () => $7693dbd047ade921$export$7c73462e0d25e514, (v) => $7693dbd047ade921$export$7c73462e0d25e514 = v);
$parcel$export(module.exports, "startTransition", () => $7693dbd047ade921$export$7568632d0d33d16d, (v) => $7693dbd047ade921$export$7568632d0d33d16d = v);
$parcel$export(module.exports, "unstable_act", () => $7693dbd047ade921$export$88948ce120ea2619, (v) => $7693dbd047ade921$export$88948ce120ea2619 = v);
$parcel$export(module.exports, "useCallback", () => $7693dbd047ade921$export$35808ee640e87ca7, (v) => $7693dbd047ade921$export$35808ee640e87ca7 = v);
$parcel$export(module.exports, "useContext", () => $7693dbd047ade921$export$fae74005e78b1a27, (v) => $7693dbd047ade921$export$fae74005e78b1a27 = v);
$parcel$export(module.exports, "useDebugValue", () => $7693dbd047ade921$export$dc8fbce3eb94dc1e, (v) => $7693dbd047ade921$export$dc8fbce3eb94dc1e = v);
$parcel$export(module.exports, "useDeferredValue", () => $7693dbd047ade921$export$6a7bc4e911dc01cf, (v) => $7693dbd047ade921$export$6a7bc4e911dc01cf = v);
$parcel$export(module.exports, "useEffect", () => $7693dbd047ade921$export$6d9c69b0de29b591, (v) => $7693dbd047ade921$export$6d9c69b0de29b591 = v);
$parcel$export(module.exports, "useId", () => $7693dbd047ade921$export$f680877a34711e37, (v) => $7693dbd047ade921$export$f680877a34711e37 = v);
$parcel$export(module.exports, "useImperativeHandle", () => $7693dbd047ade921$export$d5a552a76deda3c2, (v) => $7693dbd047ade921$export$d5a552a76deda3c2 = v);
$parcel$export(module.exports, "useInsertionEffect", () => $7693dbd047ade921$export$aaabe4eda9ed9969, (v) => $7693dbd047ade921$export$aaabe4eda9ed9969 = v);
$parcel$export(module.exports, "useLayoutEffect", () => $7693dbd047ade921$export$e5c5a5f917a5871c, (v) => $7693dbd047ade921$export$e5c5a5f917a5871c = v);
$parcel$export(module.exports, "useMemo", () => $7693dbd047ade921$export$1538c33de8887b59, (v) => $7693dbd047ade921$export$1538c33de8887b59 = v);
$parcel$export(module.exports, "useReducer", () => $7693dbd047ade921$export$13e3392192263954, (v) => $7693dbd047ade921$export$13e3392192263954 = v);
$parcel$export(module.exports, "useRef", () => $7693dbd047ade921$export$b8f5890fc79d6aca, (v) => $7693dbd047ade921$export$b8f5890fc79d6aca = v);
$parcel$export(module.exports, "useState", () => $7693dbd047ade921$export$60241385465d0a34, (v) => $7693dbd047ade921$export$60241385465d0a34 = v);
$parcel$export(module.exports, "useSyncExternalStore", () => $7693dbd047ade921$export$306c0aa65ff9ec16, (v) => $7693dbd047ade921$export$306c0aa65ff9ec16 = v);
$parcel$export(module.exports, "useTransition", () => $7693dbd047ade921$export$7b286972b8d8ccbf, (v) => $7693dbd047ade921$export$7b286972b8d8ccbf = v);
$parcel$export(module.exports, "version", () => $7693dbd047ade921$export$83d89fbfd8236492, (v) => $7693dbd047ade921$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $7693dbd047ade921$export$dca3b0875bd9a954;
var $7693dbd047ade921$export$16fa2f45be04daa8;
var $7693dbd047ade921$export$ffb0004e005737fa;
var $7693dbd047ade921$export$e2c29f18771995cb;
var $7693dbd047ade921$export$221d75b3f55bb0bd;
var $7693dbd047ade921$export$5f8d39834fd61797;
var $7693dbd047ade921$export$74bf444e3cd11ea5;
var $7693dbd047ade921$export$ae55be85d98224ed;
var $7693dbd047ade921$export$3ba232387fd5d6dd;
var $7693dbd047ade921$export$e530037191fcd5d7;
var $7693dbd047ade921$export$fd42f52fd3ae1109;
var $7693dbd047ade921$export$c8a8987d4410bf2d;
var $7693dbd047ade921$export$d38cd72104c1f0e9;
var $7693dbd047ade921$export$7d1e3a5e95ceca43;
var $7693dbd047ade921$export$257a8862b851cb5b;
var $7693dbd047ade921$export$a8257692ac88316c;
var $7693dbd047ade921$export$488013bae63b21da;
var $7693dbd047ade921$export$7c73462e0d25e514;
var $7693dbd047ade921$export$7568632d0d33d16d;
var $7693dbd047ade921$export$88948ce120ea2619;
var $7693dbd047ade921$export$35808ee640e87ca7;
var $7693dbd047ade921$export$fae74005e78b1a27;
var $7693dbd047ade921$export$dc8fbce3eb94dc1e;
var $7693dbd047ade921$export$6a7bc4e911dc01cf;
var $7693dbd047ade921$export$6d9c69b0de29b591;
var $7693dbd047ade921$export$f680877a34711e37;
var $7693dbd047ade921$export$d5a552a76deda3c2;
var $7693dbd047ade921$export$aaabe4eda9ed9969;
var $7693dbd047ade921$export$e5c5a5f917a5871c;
var $7693dbd047ade921$export$1538c33de8887b59;
var $7693dbd047ade921$export$13e3392192263954;
var $7693dbd047ade921$export$b8f5890fc79d6aca;
var $7693dbd047ade921$export$60241385465d0a34;
var $7693dbd047ade921$export$306c0aa65ff9ec16;
var $7693dbd047ade921$export$7b286972b8d8ccbf;
var $7693dbd047ade921$export$83d89fbfd8236492;
'use strict';
var $7693dbd047ade921$var$l = Symbol.for("react.element"), $7693dbd047ade921$var$n = Symbol.for("react.portal"), $7693dbd047ade921$var$p = Symbol.for("react.fragment"), $7693dbd047ade921$var$q = Symbol.for("react.strict_mode"), $7693dbd047ade921$var$r = Symbol.for("react.profiler"), $7693dbd047ade921$var$t = Symbol.for("react.provider"), $7693dbd047ade921$var$u = Symbol.for("react.context"), $7693dbd047ade921$var$v = Symbol.for("react.forward_ref"), $7693dbd047ade921$var$w = Symbol.for("react.suspense"), $7693dbd047ade921$var$x = Symbol.for("react.memo"), $7693dbd047ade921$var$y = Symbol.for("react.lazy"), $7693dbd047ade921$var$z = Symbol.iterator;
function $7693dbd047ade921$var$A(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $7693dbd047ade921$var$z && a[$7693dbd047ade921$var$z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $7693dbd047ade921$var$B = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $7693dbd047ade921$var$C = Object.assign, $7693dbd047ade921$var$D = {};
function $7693dbd047ade921$var$E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $7693dbd047ade921$var$D;
    this.updater = e || $7693dbd047ade921$var$B;
}
$7693dbd047ade921$var$E.prototype.isReactComponent = {};
$7693dbd047ade921$var$E.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
$7693dbd047ade921$var$E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $7693dbd047ade921$var$F() {}
$7693dbd047ade921$var$F.prototype = $7693dbd047ade921$var$E.prototype;
function $7693dbd047ade921$var$G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $7693dbd047ade921$var$D;
    this.updater = e || $7693dbd047ade921$var$B;
}
var $7693dbd047ade921$var$H = $7693dbd047ade921$var$G.prototype = new $7693dbd047ade921$var$F;
$7693dbd047ade921$var$H.constructor = $7693dbd047ade921$var$G;
$7693dbd047ade921$var$C($7693dbd047ade921$var$H, $7693dbd047ade921$var$E.prototype);
$7693dbd047ade921$var$H.isPureReactComponent = !0;
var $7693dbd047ade921$var$I = Array.isArray, $7693dbd047ade921$var$J = Object.prototype.hasOwnProperty, $7693dbd047ade921$var$K = {
    current: null
}, $7693dbd047ade921$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $7693dbd047ade921$var$M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$7693dbd047ade921$var$J.call(b, d) && !$7693dbd047ade921$var$L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: $7693dbd047ade921$var$l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: $7693dbd047ade921$var$K.current
    };
}
function $7693dbd047ade921$var$N(a, b) {
    return {
        $$typeof: $7693dbd047ade921$var$l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $7693dbd047ade921$var$O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $7693dbd047ade921$var$l;
}
function $7693dbd047ade921$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $7693dbd047ade921$var$P = /\/+/g;
function $7693dbd047ade921$var$Q(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $7693dbd047ade921$var$escape("" + a.key) : b.toString(36);
}
function $7693dbd047ade921$var$R(a, b, e, d, c) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $7693dbd047ade921$var$l:
                case $7693dbd047ade921$var$n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + $7693dbd047ade921$var$Q(h, 0) : d, $7693dbd047ade921$var$I(c) ? (e = "", null != a && (e = a.replace($7693dbd047ade921$var$P, "$&/") + "/"), $7693dbd047ade921$var$R(c, b, e, "", function(a) {
        return a;
    })) : null != c && ($7693dbd047ade921$var$O(c) && (c = $7693dbd047ade921$var$N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace($7693dbd047ade921$var$P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if ($7693dbd047ade921$var$I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + $7693dbd047ade921$var$Q(k, g);
        h += $7693dbd047ade921$var$R(k, b, e, f, c);
    }
    else if (f = $7693dbd047ade921$var$A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + $7693dbd047ade921$var$Q(k, g++), h += $7693dbd047ade921$var$R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function $7693dbd047ade921$var$S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    $7693dbd047ade921$var$R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function $7693dbd047ade921$var$T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var $7693dbd047ade921$var$U = {
    current: null
}, $7693dbd047ade921$var$V = {
    transition: null
}, $7693dbd047ade921$var$W = {
    ReactCurrentDispatcher: $7693dbd047ade921$var$U,
    ReactCurrentBatchConfig: $7693dbd047ade921$var$V,
    ReactCurrentOwner: $7693dbd047ade921$var$K
};
function $7693dbd047ade921$var$X() {
    throw Error("act(...) is not supported in production builds of React.");
}
$7693dbd047ade921$export$dca3b0875bd9a954 = {
    map: $7693dbd047ade921$var$S,
    forEach: function(a, b, e) {
        $7693dbd047ade921$var$S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function(a) {
        var b = 0;
        $7693dbd047ade921$var$S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return $7693dbd047ade921$var$S(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!$7693dbd047ade921$var$O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
$7693dbd047ade921$export$16fa2f45be04daa8 = $7693dbd047ade921$var$E;
$7693dbd047ade921$export$ffb0004e005737fa = $7693dbd047ade921$var$p;
$7693dbd047ade921$export$e2c29f18771995cb = $7693dbd047ade921$var$r;
$7693dbd047ade921$export$221d75b3f55bb0bd = $7693dbd047ade921$var$G;
$7693dbd047ade921$export$5f8d39834fd61797 = $7693dbd047ade921$var$q;
$7693dbd047ade921$export$74bf444e3cd11ea5 = $7693dbd047ade921$var$w;
$7693dbd047ade921$export$ae55be85d98224ed = $7693dbd047ade921$var$W;
$7693dbd047ade921$export$3ba232387fd5d6dd = $7693dbd047ade921$var$X;
$7693dbd047ade921$export$e530037191fcd5d7 = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = $7693dbd047ade921$var$C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $7693dbd047ade921$var$K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$7693dbd047ade921$var$J.call(b, f) && !$7693dbd047ade921$var$L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: $7693dbd047ade921$var$l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
$7693dbd047ade921$export$fd42f52fd3ae1109 = function(a) {
    a = {
        $$typeof: $7693dbd047ade921$var$u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: $7693dbd047ade921$var$t,
        _context: a
    };
    return a.Consumer = a;
};
$7693dbd047ade921$export$c8a8987d4410bf2d = $7693dbd047ade921$var$M;
$7693dbd047ade921$export$d38cd72104c1f0e9 = function(a) {
    var b = $7693dbd047ade921$var$M.bind(null, a);
    b.type = a;
    return b;
};
$7693dbd047ade921$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$7693dbd047ade921$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $7693dbd047ade921$var$v,
        render: a
    };
};
$7693dbd047ade921$export$a8257692ac88316c = $7693dbd047ade921$var$O;
$7693dbd047ade921$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $7693dbd047ade921$var$y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $7693dbd047ade921$var$T
    };
};
$7693dbd047ade921$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $7693dbd047ade921$var$x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$7693dbd047ade921$export$7568632d0d33d16d = function(a) {
    var b = $7693dbd047ade921$var$V.transition;
    $7693dbd047ade921$var$V.transition = {};
    try {
        a();
    } finally{
        $7693dbd047ade921$var$V.transition = b;
    }
};
$7693dbd047ade921$export$88948ce120ea2619 = $7693dbd047ade921$var$X;
$7693dbd047ade921$export$35808ee640e87ca7 = function(a, b) {
    return $7693dbd047ade921$var$U.current.useCallback(a, b);
};
$7693dbd047ade921$export$fae74005e78b1a27 = function(a) {
    return $7693dbd047ade921$var$U.current.useContext(a);
};
$7693dbd047ade921$export$dc8fbce3eb94dc1e = function() {};
$7693dbd047ade921$export$6a7bc4e911dc01cf = function(a) {
    return $7693dbd047ade921$var$U.current.useDeferredValue(a);
};
$7693dbd047ade921$export$6d9c69b0de29b591 = function(a, b) {
    return $7693dbd047ade921$var$U.current.useEffect(a, b);
};
$7693dbd047ade921$export$f680877a34711e37 = function() {
    return $7693dbd047ade921$var$U.current.useId();
};
$7693dbd047ade921$export$d5a552a76deda3c2 = function(a, b, e) {
    return $7693dbd047ade921$var$U.current.useImperativeHandle(a, b, e);
};
$7693dbd047ade921$export$aaabe4eda9ed9969 = function(a, b) {
    return $7693dbd047ade921$var$U.current.useInsertionEffect(a, b);
};
$7693dbd047ade921$export$e5c5a5f917a5871c = function(a, b) {
    return $7693dbd047ade921$var$U.current.useLayoutEffect(a, b);
};
$7693dbd047ade921$export$1538c33de8887b59 = function(a, b) {
    return $7693dbd047ade921$var$U.current.useMemo(a, b);
};
$7693dbd047ade921$export$13e3392192263954 = function(a, b, e) {
    return $7693dbd047ade921$var$U.current.useReducer(a, b, e);
};
$7693dbd047ade921$export$b8f5890fc79d6aca = function(a) {
    return $7693dbd047ade921$var$U.current.useRef(a);
};
$7693dbd047ade921$export$60241385465d0a34 = function(a) {
    return $7693dbd047ade921$var$U.current.useState(a);
};
$7693dbd047ade921$export$306c0aa65ff9ec16 = function(a, b, e) {
    return $7693dbd047ade921$var$U.current.useSyncExternalStore(a, b, e);
};
$7693dbd047ade921$export$7b286972b8d8ccbf = function() {
    return $7693dbd047ade921$var$U.current.useTransition();
};
$7693dbd047ade921$export$83d89fbfd8236492 = "18.3.1";

});





parcelRegister("hLm8s", function(module, exports) {
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", () => $cee7ff159d524e18$export$ae55be85d98224ed, (v) => $cee7ff159d524e18$export$ae55be85d98224ed = v);
$parcel$export(module.exports, "createPortal", () => $cee7ff159d524e18$export$d39a5bbd09211389, (v) => $cee7ff159d524e18$export$d39a5bbd09211389 = v);
$parcel$export(module.exports, "createRoot", () => $cee7ff159d524e18$export$882461b6382ed46c, (v) => $cee7ff159d524e18$export$882461b6382ed46c = v);
$parcel$export(module.exports, "findDOMNode", () => $cee7ff159d524e18$export$466bfc07425424d5, (v) => $cee7ff159d524e18$export$466bfc07425424d5 = v);
$parcel$export(module.exports, "flushSync", () => $cee7ff159d524e18$export$cd75ccfd720a3cd4, (v) => $cee7ff159d524e18$export$cd75ccfd720a3cd4 = v);
$parcel$export(module.exports, "hydrate", () => $cee7ff159d524e18$export$fa8d919ba61d84db, (v) => $cee7ff159d524e18$export$fa8d919ba61d84db = v);
$parcel$export(module.exports, "hydrateRoot", () => $cee7ff159d524e18$export$757ceba2d55c277e, (v) => $cee7ff159d524e18$export$757ceba2d55c277e = v);
$parcel$export(module.exports, "render", () => $cee7ff159d524e18$export$b3890eb0ae9dca99, (v) => $cee7ff159d524e18$export$b3890eb0ae9dca99 = v);
$parcel$export(module.exports, "unmountComponentAtNode", () => $cee7ff159d524e18$export$502457920280e6be, (v) => $cee7ff159d524e18$export$502457920280e6be = v);
$parcel$export(module.exports, "unstable_batchedUpdates", () => $cee7ff159d524e18$export$c78a37762a8d58e1, (v) => $cee7ff159d524e18$export$c78a37762a8d58e1 = v);
$parcel$export(module.exports, "unstable_renderSubtreeIntoContainer", () => $cee7ff159d524e18$export$dc54d992c10e8a18, (v) => $cee7ff159d524e18$export$dc54d992c10e8a18 = v);
$parcel$export(module.exports, "version", () => $cee7ff159d524e18$export$83d89fbfd8236492, (v) => $cee7ff159d524e18$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $cee7ff159d524e18$export$ae55be85d98224ed;
var $cee7ff159d524e18$export$d39a5bbd09211389;
var $cee7ff159d524e18$export$882461b6382ed46c;
var $cee7ff159d524e18$export$466bfc07425424d5;
var $cee7ff159d524e18$export$cd75ccfd720a3cd4;
var $cee7ff159d524e18$export$fa8d919ba61d84db;
var $cee7ff159d524e18$export$757ceba2d55c277e;
var $cee7ff159d524e18$export$b3890eb0ae9dca99;
var $cee7ff159d524e18$export$502457920280e6be;
var $cee7ff159d524e18$export$c78a37762a8d58e1;
var $cee7ff159d524e18$export$dc54d992c10e8a18;
var $cee7ff159d524e18$export$83d89fbfd8236492;
'use strict';

var $5FkrB = parcelRequire("5FkrB");

var $2tm1P = parcelRequire("2tm1P");
function $cee7ff159d524e18$var$p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $cee7ff159d524e18$var$da = new Set, $cee7ff159d524e18$var$ea = {};
function $cee7ff159d524e18$var$fa(a, b) {
    $cee7ff159d524e18$var$ha(a, b);
    $cee7ff159d524e18$var$ha(a + "Capture", b);
}
function $cee7ff159d524e18$var$ha(a, b) {
    $cee7ff159d524e18$var$ea[a] = b;
    for(a = 0; a < b.length; a++)$cee7ff159d524e18$var$da.add(b[a]);
}
var $cee7ff159d524e18$var$ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $cee7ff159d524e18$var$ja = Object.prototype.hasOwnProperty, $cee7ff159d524e18$var$ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $cee7ff159d524e18$var$la = {}, $cee7ff159d524e18$var$ma = {};
function $cee7ff159d524e18$var$oa(a) {
    if ($cee7ff159d524e18$var$ja.call($cee7ff159d524e18$var$ma, a)) return !0;
    if ($cee7ff159d524e18$var$ja.call($cee7ff159d524e18$var$la, a)) return !1;
    if ($cee7ff159d524e18$var$ka.test(a)) return $cee7ff159d524e18$var$ma[a] = !0;
    $cee7ff159d524e18$var$la[a] = !0;
    return !1;
}
function $cee7ff159d524e18$var$pa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function $cee7ff159d524e18$var$qa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || $cee7ff159d524e18$var$pa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function $cee7ff159d524e18$var$v(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var $cee7ff159d524e18$var$z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $cee7ff159d524e18$var$z[a] = new $cee7ff159d524e18$var$v(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $cee7ff159d524e18$var$z[b] = new $cee7ff159d524e18$var$v(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $cee7ff159d524e18$var$z[a] = new $cee7ff159d524e18$var$v(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $cee7ff159d524e18$var$z[a] = new $cee7ff159d524e18$var$v(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $cee7ff159d524e18$var$z[a] = new $cee7ff159d524e18$var$v(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $cee7ff159d524e18$var$z[a] = new $cee7ff159d524e18$var$v(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $cee7ff159d524e18$var$z[a] = new $cee7ff159d524e18$var$v(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $cee7ff159d524e18$var$z[a] = new $cee7ff159d524e18$var$v(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $cee7ff159d524e18$var$z[a] = new $cee7ff159d524e18$var$v(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $cee7ff159d524e18$var$ra = /[\-:]([a-z])/g;
function $cee7ff159d524e18$var$sa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($cee7ff159d524e18$var$ra, $cee7ff159d524e18$var$sa);
    $cee7ff159d524e18$var$z[b] = new $cee7ff159d524e18$var$v(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($cee7ff159d524e18$var$ra, $cee7ff159d524e18$var$sa);
    $cee7ff159d524e18$var$z[b] = new $cee7ff159d524e18$var$v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($cee7ff159d524e18$var$ra, $cee7ff159d524e18$var$sa);
    $cee7ff159d524e18$var$z[b] = new $cee7ff159d524e18$var$v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $cee7ff159d524e18$var$z[a] = new $cee7ff159d524e18$var$v(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$cee7ff159d524e18$var$z.xlinkHref = new $cee7ff159d524e18$var$v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $cee7ff159d524e18$var$z[a] = new $cee7ff159d524e18$var$v(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function $cee7ff159d524e18$var$ta(a, b, c, d) {
    var e = $cee7ff159d524e18$var$z.hasOwnProperty(b) ? $cee7ff159d524e18$var$z[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) $cee7ff159d524e18$var$qa(b, c, e, d) && (c = null), d || null === e ? $cee7ff159d524e18$var$oa(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}
var $cee7ff159d524e18$var$ua = $5FkrB.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, $cee7ff159d524e18$var$va = Symbol.for("react.element"), $cee7ff159d524e18$var$wa = Symbol.for("react.portal"), $cee7ff159d524e18$var$ya = Symbol.for("react.fragment"), $cee7ff159d524e18$var$za = Symbol.for("react.strict_mode"), $cee7ff159d524e18$var$Aa = Symbol.for("react.profiler"), $cee7ff159d524e18$var$Ba = Symbol.for("react.provider"), $cee7ff159d524e18$var$Ca = Symbol.for("react.context"), $cee7ff159d524e18$var$Da = Symbol.for("react.forward_ref"), $cee7ff159d524e18$var$Ea = Symbol.for("react.suspense"), $cee7ff159d524e18$var$Fa = Symbol.for("react.suspense_list"), $cee7ff159d524e18$var$Ga = Symbol.for("react.memo"), $cee7ff159d524e18$var$Ha = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var $cee7ff159d524e18$var$Ia = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.cache");
Symbol.for("react.tracing_marker");
var $cee7ff159d524e18$var$Ja = Symbol.iterator;
function $cee7ff159d524e18$var$Ka(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $cee7ff159d524e18$var$Ja && a[$cee7ff159d524e18$var$Ja] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $cee7ff159d524e18$var$A = Object.assign, $cee7ff159d524e18$var$La;
function $cee7ff159d524e18$var$Ma(a) {
    if (void 0 === $cee7ff159d524e18$var$La) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        $cee7ff159d524e18$var$La = b && b[1] || "";
    }
    return "\n" + $cee7ff159d524e18$var$La + a;
}
var $cee7ff159d524e18$var$Na = !1;
function $cee7ff159d524e18$var$Oa(a, b) {
    if (!a || $cee7ff159d524e18$var$Na) return "";
    $cee7ff159d524e18$var$Na = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (l) {
                    var d = l;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (l) {
                    d = l;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (l) {
                d = l;
            }
            a();
        }
    } catch (l) {
        if (l && d && "string" === typeof l.stack) {
            for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) {
                        var k = "\n" + e[g].replace(" at new ", " at ");
                        a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                        return k;
                    }
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        $cee7ff159d524e18$var$Na = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? $cee7ff159d524e18$var$Ma(a) : "";
}
function $cee7ff159d524e18$var$Pa(a) {
    switch(a.tag){
        case 5:
            return $cee7ff159d524e18$var$Ma(a.type);
        case 16:
            return $cee7ff159d524e18$var$Ma("Lazy");
        case 13:
            return $cee7ff159d524e18$var$Ma("Suspense");
        case 19:
            return $cee7ff159d524e18$var$Ma("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = $cee7ff159d524e18$var$Oa(a.type, !1), a;
        case 11:
            return a = $cee7ff159d524e18$var$Oa(a.type.render, !1), a;
        case 1:
            return a = $cee7ff159d524e18$var$Oa(a.type, !0), a;
        default:
            return "";
    }
}
function $cee7ff159d524e18$var$Qa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $cee7ff159d524e18$var$ya:
            return "Fragment";
        case $cee7ff159d524e18$var$wa:
            return "Portal";
        case $cee7ff159d524e18$var$Aa:
            return "Profiler";
        case $cee7ff159d524e18$var$za:
            return "StrictMode";
        case $cee7ff159d524e18$var$Ea:
            return "Suspense";
        case $cee7ff159d524e18$var$Fa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $cee7ff159d524e18$var$Ca:
            return (a.displayName || "Context") + ".Consumer";
        case $cee7ff159d524e18$var$Ba:
            return (a._context.displayName || "Context") + ".Provider";
        case $cee7ff159d524e18$var$Da:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $cee7ff159d524e18$var$Ga:
            return b = a.displayName || null, null !== b ? b : $cee7ff159d524e18$var$Qa(a.type) || "Memo";
        case $cee7ff159d524e18$var$Ha:
            b = a._payload;
            a = a._init;
            try {
                return $cee7ff159d524e18$var$Qa(a(b));
            } catch (c) {}
    }
    return null;
}
function $cee7ff159d524e18$var$Ra(a) {
    var b = a.type;
    switch(a.tag){
        case 24:
            return "Cache";
        case 9:
            return (b.displayName || "Context") + ".Consumer";
        case 10:
            return (b._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 5:
            return b;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return $cee7ff159d524e18$var$Qa(b);
        case 8:
            return b === $cee7ff159d524e18$var$za ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if ("function" === typeof b) return b.displayName || b.name || null;
            if ("string" === typeof b) return b;
    }
    return null;
}
function $cee7ff159d524e18$var$Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return a;
        case "object":
            return a;
        default:
            return "";
    }
}
function $cee7ff159d524e18$var$Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function $cee7ff159d524e18$var$Ua(a) {
    var b = $cee7ff159d524e18$var$Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function $cee7ff159d524e18$var$Va(a) {
    a._valueTracker || (a._valueTracker = $cee7ff159d524e18$var$Ua(a));
}
function $cee7ff159d524e18$var$Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = $cee7ff159d524e18$var$Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function $cee7ff159d524e18$var$Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function $cee7ff159d524e18$var$Ya(a, b) {
    var c = b.checked;
    return $cee7ff159d524e18$var$A({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function $cee7ff159d524e18$var$Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = $cee7ff159d524e18$var$Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $cee7ff159d524e18$var$ab(a, b) {
    b = b.checked;
    null != b && $cee7ff159d524e18$var$ta(a, "checked", b, !1);
}
function $cee7ff159d524e18$var$bb(a, b) {
    $cee7ff159d524e18$var$ab(a, b);
    var c = $cee7ff159d524e18$var$Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? $cee7ff159d524e18$var$cb(a, b.type, c) : b.hasOwnProperty("defaultValue") && $cee7ff159d524e18$var$cb(a, b.type, $cee7ff159d524e18$var$Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function $cee7ff159d524e18$var$db(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function $cee7ff159d524e18$var$cb(a, b, c) {
    if ("number" !== b || $cee7ff159d524e18$var$Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var $cee7ff159d524e18$var$eb = Array.isArray;
function $cee7ff159d524e18$var$fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + $cee7ff159d524e18$var$Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function $cee7ff159d524e18$var$gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error($cee7ff159d524e18$var$p(91));
    return $cee7ff159d524e18$var$A({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function $cee7ff159d524e18$var$hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error($cee7ff159d524e18$var$p(92));
            if ($cee7ff159d524e18$var$eb(c)) {
                if (1 < c.length) throw Error($cee7ff159d524e18$var$p(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: $cee7ff159d524e18$var$Sa(c)
    };
}
function $cee7ff159d524e18$var$ib(a, b) {
    var c = $cee7ff159d524e18$var$Sa(b.value), d = $cee7ff159d524e18$var$Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function $cee7ff159d524e18$var$jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function $cee7ff159d524e18$var$kb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function $cee7ff159d524e18$var$lb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? $cee7ff159d524e18$var$kb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var $cee7ff159d524e18$var$mb, $cee7ff159d524e18$var$nb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
        $cee7ff159d524e18$var$mb = $cee7ff159d524e18$var$mb || document.createElement("div");
        $cee7ff159d524e18$var$mb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = $cee7ff159d524e18$var$mb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function $cee7ff159d524e18$var$ob(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var $cee7ff159d524e18$var$pb = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $cee7ff159d524e18$var$qb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($cee7ff159d524e18$var$pb).forEach(function(a) {
    $cee7ff159d524e18$var$qb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $cee7ff159d524e18$var$pb[b] = $cee7ff159d524e18$var$pb[a];
    });
});
function $cee7ff159d524e18$var$rb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || $cee7ff159d524e18$var$pb.hasOwnProperty(a) && $cee7ff159d524e18$var$pb[a] ? ("" + b).trim() : b + "px";
}
function $cee7ff159d524e18$var$sb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = $cee7ff159d524e18$var$rb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var $cee7ff159d524e18$var$tb = $cee7ff159d524e18$var$A({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function $cee7ff159d524e18$var$ub(a, b) {
    if (b) {
        if ($cee7ff159d524e18$var$tb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error($cee7ff159d524e18$var$p(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error($cee7ff159d524e18$var$p(60));
            if ("object" !== typeof b.dangerouslySetInnerHTML || !("__html" in b.dangerouslySetInnerHTML)) throw Error($cee7ff159d524e18$var$p(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error($cee7ff159d524e18$var$p(62));
    }
}
function $cee7ff159d524e18$var$vb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $cee7ff159d524e18$var$wb = null;
function $cee7ff159d524e18$var$xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var $cee7ff159d524e18$var$yb = null, $cee7ff159d524e18$var$zb = null, $cee7ff159d524e18$var$Ab = null;
function $cee7ff159d524e18$var$Bb(a) {
    if (a = $cee7ff159d524e18$var$Cb(a)) {
        if ("function" !== typeof $cee7ff159d524e18$var$yb) throw Error($cee7ff159d524e18$var$p(280));
        var b = a.stateNode;
        b && (b = $cee7ff159d524e18$var$Db(b), $cee7ff159d524e18$var$yb(a.stateNode, a.type, b));
    }
}
function $cee7ff159d524e18$var$Eb(a) {
    $cee7ff159d524e18$var$zb ? $cee7ff159d524e18$var$Ab ? $cee7ff159d524e18$var$Ab.push(a) : $cee7ff159d524e18$var$Ab = [
        a
    ] : $cee7ff159d524e18$var$zb = a;
}
function $cee7ff159d524e18$var$Fb() {
    if ($cee7ff159d524e18$var$zb) {
        var a = $cee7ff159d524e18$var$zb, b = $cee7ff159d524e18$var$Ab;
        $cee7ff159d524e18$var$Ab = $cee7ff159d524e18$var$zb = null;
        $cee7ff159d524e18$var$Bb(a);
        if (b) for(a = 0; a < b.length; a++)$cee7ff159d524e18$var$Bb(b[a]);
    }
}
function $cee7ff159d524e18$var$Gb(a, b) {
    return a(b);
}
function $cee7ff159d524e18$var$Hb() {}
var $cee7ff159d524e18$var$Ib = !1;
function $cee7ff159d524e18$var$Jb(a, b, c) {
    if ($cee7ff159d524e18$var$Ib) return a(b, c);
    $cee7ff159d524e18$var$Ib = !0;
    try {
        return $cee7ff159d524e18$var$Gb(a, b, c);
    } finally{
        if ($cee7ff159d524e18$var$Ib = !1, null !== $cee7ff159d524e18$var$zb || null !== $cee7ff159d524e18$var$Ab) $cee7ff159d524e18$var$Hb(), $cee7ff159d524e18$var$Fb();
    }
}
function $cee7ff159d524e18$var$Kb(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = $cee7ff159d524e18$var$Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error($cee7ff159d524e18$var$p(231, b, typeof c));
    return c;
}
var $cee7ff159d524e18$var$Lb = !1;
if ($cee7ff159d524e18$var$ia) try {
    var $cee7ff159d524e18$var$Mb = {};
    Object.defineProperty($cee7ff159d524e18$var$Mb, "passive", {
        get: function() {
            $cee7ff159d524e18$var$Lb = !0;
        }
    });
    window.addEventListener("test", $cee7ff159d524e18$var$Mb, $cee7ff159d524e18$var$Mb);
    window.removeEventListener("test", $cee7ff159d524e18$var$Mb, $cee7ff159d524e18$var$Mb);
} catch (a) {
    $cee7ff159d524e18$var$Lb = !1;
}
function $cee7ff159d524e18$var$Nb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var $cee7ff159d524e18$var$Ob = !1, $cee7ff159d524e18$var$Pb = null, $cee7ff159d524e18$var$Qb = !1, $cee7ff159d524e18$var$Rb = null, $cee7ff159d524e18$var$Sb = {
    onError: function(a) {
        $cee7ff159d524e18$var$Ob = !0;
        $cee7ff159d524e18$var$Pb = a;
    }
};
function $cee7ff159d524e18$var$Tb(a, b, c, d, e, f, g, h, k) {
    $cee7ff159d524e18$var$Ob = !1;
    $cee7ff159d524e18$var$Pb = null;
    $cee7ff159d524e18$var$Nb.apply($cee7ff159d524e18$var$Sb, arguments);
}
function $cee7ff159d524e18$var$Ub(a, b, c, d, e, f, g, h, k) {
    $cee7ff159d524e18$var$Tb.apply(this, arguments);
    if ($cee7ff159d524e18$var$Ob) {
        if ($cee7ff159d524e18$var$Ob) {
            var l = $cee7ff159d524e18$var$Pb;
            $cee7ff159d524e18$var$Ob = !1;
            $cee7ff159d524e18$var$Pb = null;
        } else throw Error($cee7ff159d524e18$var$p(198));
        $cee7ff159d524e18$var$Qb || ($cee7ff159d524e18$var$Qb = !0, $cee7ff159d524e18$var$Rb = l);
    }
}
function $cee7ff159d524e18$var$Vb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $cee7ff159d524e18$var$Wb(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function $cee7ff159d524e18$var$Xb(a) {
    if ($cee7ff159d524e18$var$Vb(a) !== a) throw Error($cee7ff159d524e18$var$p(188));
}
function $cee7ff159d524e18$var$Yb(a) {
    var b = a.alternate;
    if (!b) {
        b = $cee7ff159d524e18$var$Vb(a);
        if (null === b) throw Error($cee7ff159d524e18$var$p(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return $cee7ff159d524e18$var$Xb(e), a;
                if (f === d) return $cee7ff159d524e18$var$Xb(e), b;
                f = f.sibling;
            }
            throw Error($cee7ff159d524e18$var$p(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error($cee7ff159d524e18$var$p(189));
            }
        }
        if (c.alternate !== d) throw Error($cee7ff159d524e18$var$p(190));
    }
    if (3 !== c.tag) throw Error($cee7ff159d524e18$var$p(188));
    return c.stateNode.current === c ? a : b;
}
function $cee7ff159d524e18$var$Zb(a) {
    a = $cee7ff159d524e18$var$Yb(a);
    return null !== a ? $cee7ff159d524e18$var$$b(a) : null;
}
function $cee7ff159d524e18$var$$b(a) {
    if (5 === a.tag || 6 === a.tag) return a;
    for(a = a.child; null !== a;){
        var b = $cee7ff159d524e18$var$$b(a);
        if (null !== b) return b;
        a = a.sibling;
    }
    return null;
}
var $cee7ff159d524e18$var$ac = $2tm1P.unstable_scheduleCallback, $cee7ff159d524e18$var$bc = $2tm1P.unstable_cancelCallback, $cee7ff159d524e18$var$cc = $2tm1P.unstable_shouldYield, $cee7ff159d524e18$var$dc = $2tm1P.unstable_requestPaint, $cee7ff159d524e18$var$B = $2tm1P.unstable_now, $cee7ff159d524e18$var$ec = $2tm1P.unstable_getCurrentPriorityLevel, $cee7ff159d524e18$var$fc = $2tm1P.unstable_ImmediatePriority, $cee7ff159d524e18$var$gc = $2tm1P.unstable_UserBlockingPriority, $cee7ff159d524e18$var$hc = $2tm1P.unstable_NormalPriority, $cee7ff159d524e18$var$ic = $2tm1P.unstable_LowPriority, $cee7ff159d524e18$var$jc = $2tm1P.unstable_IdlePriority, $cee7ff159d524e18$var$kc = null, $cee7ff159d524e18$var$lc = null;
function $cee7ff159d524e18$var$mc(a) {
    if ($cee7ff159d524e18$var$lc && "function" === typeof $cee7ff159d524e18$var$lc.onCommitFiberRoot) try {
        $cee7ff159d524e18$var$lc.onCommitFiberRoot($cee7ff159d524e18$var$kc, a, void 0, 128 === (a.current.flags & 128));
    } catch (b) {}
}
var $cee7ff159d524e18$var$oc = Math.clz32 ? Math.clz32 : $cee7ff159d524e18$var$nc, $cee7ff159d524e18$var$pc = Math.log, $cee7ff159d524e18$var$qc = Math.LN2;
function $cee7ff159d524e18$var$nc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($cee7ff159d524e18$var$pc(a) / $cee7ff159d524e18$var$qc | 0) | 0;
}
var $cee7ff159d524e18$var$rc = 64, $cee7ff159d524e18$var$sc = 4194304;
function $cee7ff159d524e18$var$tc(a) {
    switch(a & -a){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return a & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return a & 130023424;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return a;
    }
}
function $cee7ff159d524e18$var$uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
        var h = g & ~e;
        0 !== h ? d = $cee7ff159d524e18$var$tc(h) : (f &= g, 0 !== f && (d = $cee7ff159d524e18$var$tc(f)));
    } else g = c & ~e, 0 !== g ? d = $cee7ff159d524e18$var$tc(g) : 0 !== f && (d = $cee7ff159d524e18$var$tc(f));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
    0 !== (d & 4) && (d |= c & 16);
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - $cee7ff159d524e18$var$oc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function $cee7ff159d524e18$var$vc(a, b) {
    switch(a){
        case 1:
        case 2:
        case 4:
            return b + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return b + 5E3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $cee7ff159d524e18$var$wc(a, b) {
    for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
        var g = 31 - $cee7ff159d524e18$var$oc(f), h = 1 << g, k = e[g];
        if (-1 === k) {
            if (0 === (h & c) || 0 !== (h & d)) e[g] = $cee7ff159d524e18$var$vc(h, b);
        } else k <= b && (a.expiredLanes |= h);
        f &= ~h;
    }
}
function $cee7ff159d524e18$var$xc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function $cee7ff159d524e18$var$yc() {
    var a = $cee7ff159d524e18$var$rc;
    $cee7ff159d524e18$var$rc <<= 1;
    0 === ($cee7ff159d524e18$var$rc & 4194240) && ($cee7ff159d524e18$var$rc = 64);
    return a;
}
function $cee7ff159d524e18$var$zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $cee7ff159d524e18$var$Ac(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - $cee7ff159d524e18$var$oc(b);
    a[b] = c;
}
function $cee7ff159d524e18$var$Bc(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes;
    for(a = a.expirationTimes; 0 < c;){
        var e = 31 - $cee7ff159d524e18$var$oc(c), f = 1 << e;
        b[e] = 0;
        d[e] = -1;
        a[e] = -1;
        c &= ~f;
    }
}
function $cee7ff159d524e18$var$Cc(a, b) {
    var c = a.entangledLanes |= b;
    for(a = a.entanglements; c;){
        var d = 31 - $cee7ff159d524e18$var$oc(c), e = 1 << d;
        e & b | a[d] & b && (a[d] |= b);
        c &= ~e;
    }
}
var $cee7ff159d524e18$var$C = 0;
function $cee7ff159d524e18$var$Dc(a) {
    a &= -a;
    return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}
var $cee7ff159d524e18$var$Ec, $cee7ff159d524e18$var$Fc, $cee7ff159d524e18$var$Gc, $cee7ff159d524e18$var$Hc, $cee7ff159d524e18$var$Ic, $cee7ff159d524e18$var$Jc = !1, $cee7ff159d524e18$var$Kc = [], $cee7ff159d524e18$var$Lc = null, $cee7ff159d524e18$var$Mc = null, $cee7ff159d524e18$var$Nc = null, $cee7ff159d524e18$var$Oc = new Map, $cee7ff159d524e18$var$Pc = new Map, $cee7ff159d524e18$var$Qc = [], $cee7ff159d524e18$var$Rc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function $cee7ff159d524e18$var$Sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            $cee7ff159d524e18$var$Lc = null;
            break;
        case "dragenter":
        case "dragleave":
            $cee7ff159d524e18$var$Mc = null;
            break;
        case "mouseover":
        case "mouseout":
            $cee7ff159d524e18$var$Nc = null;
            break;
        case "pointerover":
        case "pointerout":
            $cee7ff159d524e18$var$Oc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $cee7ff159d524e18$var$Pc.delete(b.pointerId);
    }
}
function $cee7ff159d524e18$var$Tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = {
        blockedOn: b,
        domEventName: c,
        eventSystemFlags: d,
        nativeEvent: f,
        targetContainers: [
            e
        ]
    }, null !== b && (b = $cee7ff159d524e18$var$Cb(b), null !== b && $cee7ff159d524e18$var$Fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function $cee7ff159d524e18$var$Uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return $cee7ff159d524e18$var$Lc = $cee7ff159d524e18$var$Tc($cee7ff159d524e18$var$Lc, a, b, c, d, e), !0;
        case "dragenter":
            return $cee7ff159d524e18$var$Mc = $cee7ff159d524e18$var$Tc($cee7ff159d524e18$var$Mc, a, b, c, d, e), !0;
        case "mouseover":
            return $cee7ff159d524e18$var$Nc = $cee7ff159d524e18$var$Tc($cee7ff159d524e18$var$Nc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            $cee7ff159d524e18$var$Oc.set(f, $cee7ff159d524e18$var$Tc($cee7ff159d524e18$var$Oc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, $cee7ff159d524e18$var$Pc.set(f, $cee7ff159d524e18$var$Tc($cee7ff159d524e18$var$Pc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function $cee7ff159d524e18$var$Vc(a) {
    var b = $cee7ff159d524e18$var$Wc(a.target);
    if (null !== b) {
        var c = $cee7ff159d524e18$var$Vb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $cee7ff159d524e18$var$Wb(c), null !== b) {
                    a.blockedOn = b;
                    $cee7ff159d524e18$var$Ic(a.priority, function() {
                        $cee7ff159d524e18$var$Gc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function $cee7ff159d524e18$var$Xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = $cee7ff159d524e18$var$Yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null === c) {
            c = a.nativeEvent;
            var d = new c.constructor(c.type, c);
            $cee7ff159d524e18$var$wb = d;
            c.target.dispatchEvent(d);
            $cee7ff159d524e18$var$wb = null;
        } else return b = $cee7ff159d524e18$var$Cb(c), null !== b && $cee7ff159d524e18$var$Fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function $cee7ff159d524e18$var$Zc(a, b, c) {
    $cee7ff159d524e18$var$Xc(a) && c.delete(b);
}
function $cee7ff159d524e18$var$$c() {
    $cee7ff159d524e18$var$Jc = !1;
    null !== $cee7ff159d524e18$var$Lc && $cee7ff159d524e18$var$Xc($cee7ff159d524e18$var$Lc) && ($cee7ff159d524e18$var$Lc = null);
    null !== $cee7ff159d524e18$var$Mc && $cee7ff159d524e18$var$Xc($cee7ff159d524e18$var$Mc) && ($cee7ff159d524e18$var$Mc = null);
    null !== $cee7ff159d524e18$var$Nc && $cee7ff159d524e18$var$Xc($cee7ff159d524e18$var$Nc) && ($cee7ff159d524e18$var$Nc = null);
    $cee7ff159d524e18$var$Oc.forEach($cee7ff159d524e18$var$Zc);
    $cee7ff159d524e18$var$Pc.forEach($cee7ff159d524e18$var$Zc);
}
function $cee7ff159d524e18$var$ad(a, b) {
    a.blockedOn === b && (a.blockedOn = null, $cee7ff159d524e18$var$Jc || ($cee7ff159d524e18$var$Jc = !0, $2tm1P.unstable_scheduleCallback($2tm1P.unstable_NormalPriority, $cee7ff159d524e18$var$$c)));
}
function $cee7ff159d524e18$var$bd(a) {
    function b(b) {
        return $cee7ff159d524e18$var$ad(b, a);
    }
    if (0 < $cee7ff159d524e18$var$Kc.length) {
        $cee7ff159d524e18$var$ad($cee7ff159d524e18$var$Kc[0], a);
        for(var c = 1; c < $cee7ff159d524e18$var$Kc.length; c++){
            var d = $cee7ff159d524e18$var$Kc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== $cee7ff159d524e18$var$Lc && $cee7ff159d524e18$var$ad($cee7ff159d524e18$var$Lc, a);
    null !== $cee7ff159d524e18$var$Mc && $cee7ff159d524e18$var$ad($cee7ff159d524e18$var$Mc, a);
    null !== $cee7ff159d524e18$var$Nc && $cee7ff159d524e18$var$ad($cee7ff159d524e18$var$Nc, a);
    $cee7ff159d524e18$var$Oc.forEach(b);
    $cee7ff159d524e18$var$Pc.forEach(b);
    for(c = 0; c < $cee7ff159d524e18$var$Qc.length; c++)d = $cee7ff159d524e18$var$Qc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < $cee7ff159d524e18$var$Qc.length && (c = $cee7ff159d524e18$var$Qc[0], null === c.blockedOn);)$cee7ff159d524e18$var$Vc(c), null === c.blockedOn && $cee7ff159d524e18$var$Qc.shift();
}
var $cee7ff159d524e18$var$cd = $cee7ff159d524e18$var$ua.ReactCurrentBatchConfig, $cee7ff159d524e18$var$dd = !0;
function $cee7ff159d524e18$var$ed(a, b, c, d) {
    var e = $cee7ff159d524e18$var$C, f = $cee7ff159d524e18$var$cd.transition;
    $cee7ff159d524e18$var$cd.transition = null;
    try {
        $cee7ff159d524e18$var$C = 1, $cee7ff159d524e18$var$fd(a, b, c, d);
    } finally{
        $cee7ff159d524e18$var$C = e, $cee7ff159d524e18$var$cd.transition = f;
    }
}
function $cee7ff159d524e18$var$gd(a, b, c, d) {
    var e = $cee7ff159d524e18$var$C, f = $cee7ff159d524e18$var$cd.transition;
    $cee7ff159d524e18$var$cd.transition = null;
    try {
        $cee7ff159d524e18$var$C = 4, $cee7ff159d524e18$var$fd(a, b, c, d);
    } finally{
        $cee7ff159d524e18$var$C = e, $cee7ff159d524e18$var$cd.transition = f;
    }
}
function $cee7ff159d524e18$var$fd(a, b, c, d) {
    if ($cee7ff159d524e18$var$dd) {
        var e = $cee7ff159d524e18$var$Yc(a, b, c, d);
        if (null === e) $cee7ff159d524e18$var$hd(a, b, d, $cee7ff159d524e18$var$id, c), $cee7ff159d524e18$var$Sc(a, d);
        else if ($cee7ff159d524e18$var$Uc(e, a, b, c, d)) d.stopPropagation();
        else if ($cee7ff159d524e18$var$Sc(a, d), b & 4 && -1 < $cee7ff159d524e18$var$Rc.indexOf(a)) {
            for(; null !== e;){
                var f = $cee7ff159d524e18$var$Cb(e);
                null !== f && $cee7ff159d524e18$var$Ec(f);
                f = $cee7ff159d524e18$var$Yc(a, b, c, d);
                null === f && $cee7ff159d524e18$var$hd(a, b, d, $cee7ff159d524e18$var$id, c);
                if (f === e) break;
                e = f;
            }
            null !== e && d.stopPropagation();
        } else $cee7ff159d524e18$var$hd(a, b, d, null, c);
    }
}
var $cee7ff159d524e18$var$id = null;
function $cee7ff159d524e18$var$Yc(a, b, c, d) {
    $cee7ff159d524e18$var$id = null;
    a = $cee7ff159d524e18$var$xb(d);
    a = $cee7ff159d524e18$var$Wc(a);
    if (null !== a) {
        if (b = $cee7ff159d524e18$var$Vb(a), null === b) a = null;
        else if (c = b.tag, 13 === c) {
            a = $cee7ff159d524e18$var$Wb(b);
            if (null !== a) return a;
            a = null;
        } else if (3 === c) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a = null;
        } else b !== a && (a = null);
    }
    $cee7ff159d524e18$var$id = a;
    return null;
}
function $cee7ff159d524e18$var$jd(a) {
    switch(a){
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 4;
        case "message":
            switch($cee7ff159d524e18$var$ec()){
                case $cee7ff159d524e18$var$fc:
                    return 1;
                case $cee7ff159d524e18$var$gc:
                    return 4;
                case $cee7ff159d524e18$var$hc:
                case $cee7ff159d524e18$var$ic:
                    return 16;
                case $cee7ff159d524e18$var$jc:
                    return 536870912;
                default:
                    return 16;
            }
        default:
            return 16;
    }
}
var $cee7ff159d524e18$var$kd = null, $cee7ff159d524e18$var$ld = null, $cee7ff159d524e18$var$md = null;
function $cee7ff159d524e18$var$nd() {
    if ($cee7ff159d524e18$var$md) return $cee7ff159d524e18$var$md;
    var a, b = $cee7ff159d524e18$var$ld, c = b.length, d, e = "value" in $cee7ff159d524e18$var$kd ? $cee7ff159d524e18$var$kd.value : $cee7ff159d524e18$var$kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $cee7ff159d524e18$var$md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function $cee7ff159d524e18$var$od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function $cee7ff159d524e18$var$pd() {
    return !0;
}
function $cee7ff159d524e18$var$qd() {
    return !1;
}
function $cee7ff159d524e18$var$rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? $cee7ff159d524e18$var$pd : $cee7ff159d524e18$var$qd;
        this.isPropagationStopped = $cee7ff159d524e18$var$qd;
        return this;
    }
    $cee7ff159d524e18$var$A(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = $cee7ff159d524e18$var$pd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = $cee7ff159d524e18$var$pd);
        },
        persist: function() {},
        isPersistent: $cee7ff159d524e18$var$pd
    });
    return b;
}
var $cee7ff159d524e18$var$sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $cee7ff159d524e18$var$td = $cee7ff159d524e18$var$rd($cee7ff159d524e18$var$sd), $cee7ff159d524e18$var$ud = $cee7ff159d524e18$var$A({}, $cee7ff159d524e18$var$sd, {
    view: 0,
    detail: 0
}), $cee7ff159d524e18$var$vd = $cee7ff159d524e18$var$rd($cee7ff159d524e18$var$ud), $cee7ff159d524e18$var$wd, $cee7ff159d524e18$var$xd, $cee7ff159d524e18$var$yd, $cee7ff159d524e18$var$Ad = $cee7ff159d524e18$var$A({}, $cee7ff159d524e18$var$ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $cee7ff159d524e18$var$zd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== $cee7ff159d524e18$var$yd && ($cee7ff159d524e18$var$yd && "mousemove" === a.type ? ($cee7ff159d524e18$var$wd = a.screenX - $cee7ff159d524e18$var$yd.screenX, $cee7ff159d524e18$var$xd = a.screenY - $cee7ff159d524e18$var$yd.screenY) : $cee7ff159d524e18$var$xd = $cee7ff159d524e18$var$wd = 0, $cee7ff159d524e18$var$yd = a);
        return $cee7ff159d524e18$var$wd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : $cee7ff159d524e18$var$xd;
    }
}), $cee7ff159d524e18$var$Bd = $cee7ff159d524e18$var$rd($cee7ff159d524e18$var$Ad), $cee7ff159d524e18$var$Cd = $cee7ff159d524e18$var$A({}, $cee7ff159d524e18$var$Ad, {
    dataTransfer: 0
}), $cee7ff159d524e18$var$Dd = $cee7ff159d524e18$var$rd($cee7ff159d524e18$var$Cd), $cee7ff159d524e18$var$Ed = $cee7ff159d524e18$var$A({}, $cee7ff159d524e18$var$ud, {
    relatedTarget: 0
}), $cee7ff159d524e18$var$Fd = $cee7ff159d524e18$var$rd($cee7ff159d524e18$var$Ed), $cee7ff159d524e18$var$Gd = $cee7ff159d524e18$var$A({}, $cee7ff159d524e18$var$sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $cee7ff159d524e18$var$Hd = $cee7ff159d524e18$var$rd($cee7ff159d524e18$var$Gd), $cee7ff159d524e18$var$Id = $cee7ff159d524e18$var$A({}, $cee7ff159d524e18$var$sd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), $cee7ff159d524e18$var$Jd = $cee7ff159d524e18$var$rd($cee7ff159d524e18$var$Id), $cee7ff159d524e18$var$Kd = $cee7ff159d524e18$var$A({}, $cee7ff159d524e18$var$sd, {
    data: 0
}), $cee7ff159d524e18$var$Ld = $cee7ff159d524e18$var$rd($cee7ff159d524e18$var$Kd), $cee7ff159d524e18$var$Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $cee7ff159d524e18$var$Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $cee7ff159d524e18$var$Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $cee7ff159d524e18$var$Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = $cee7ff159d524e18$var$Od[a]) ? !!b[a] : !1;
}
function $cee7ff159d524e18$var$zd() {
    return $cee7ff159d524e18$var$Pd;
}
var $cee7ff159d524e18$var$Qd = $cee7ff159d524e18$var$A({}, $cee7ff159d524e18$var$ud, {
    key: function(a) {
        if (a.key) {
            var b = $cee7ff159d524e18$var$Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = $cee7ff159d524e18$var$od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? $cee7ff159d524e18$var$Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $cee7ff159d524e18$var$zd,
    charCode: function(a) {
        return "keypress" === a.type ? $cee7ff159d524e18$var$od(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? $cee7ff159d524e18$var$od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), $cee7ff159d524e18$var$Rd = $cee7ff159d524e18$var$rd($cee7ff159d524e18$var$Qd), $cee7ff159d524e18$var$Sd = $cee7ff159d524e18$var$A({}, $cee7ff159d524e18$var$Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $cee7ff159d524e18$var$Td = $cee7ff159d524e18$var$rd($cee7ff159d524e18$var$Sd), $cee7ff159d524e18$var$Ud = $cee7ff159d524e18$var$A({}, $cee7ff159d524e18$var$ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $cee7ff159d524e18$var$zd
}), $cee7ff159d524e18$var$Vd = $cee7ff159d524e18$var$rd($cee7ff159d524e18$var$Ud), $cee7ff159d524e18$var$Wd = $cee7ff159d524e18$var$A({}, $cee7ff159d524e18$var$sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $cee7ff159d524e18$var$Xd = $cee7ff159d524e18$var$rd($cee7ff159d524e18$var$Wd), $cee7ff159d524e18$var$Yd = $cee7ff159d524e18$var$A({}, $cee7ff159d524e18$var$Ad, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $cee7ff159d524e18$var$Zd = $cee7ff159d524e18$var$rd($cee7ff159d524e18$var$Yd), $cee7ff159d524e18$var$$d = [
    9,
    13,
    27,
    32
], $cee7ff159d524e18$var$ae = $cee7ff159d524e18$var$ia && "CompositionEvent" in window, $cee7ff159d524e18$var$be = null;
$cee7ff159d524e18$var$ia && "documentMode" in document && ($cee7ff159d524e18$var$be = document.documentMode);
var $cee7ff159d524e18$var$ce = $cee7ff159d524e18$var$ia && "TextEvent" in window && !$cee7ff159d524e18$var$be, $cee7ff159d524e18$var$de = $cee7ff159d524e18$var$ia && (!$cee7ff159d524e18$var$ae || $cee7ff159d524e18$var$be && 8 < $cee7ff159d524e18$var$be && 11 >= $cee7ff159d524e18$var$be), $cee7ff159d524e18$var$ee = String.fromCharCode(32), $cee7ff159d524e18$var$fe = !1;
function $cee7ff159d524e18$var$ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $cee7ff159d524e18$var$$d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $cee7ff159d524e18$var$he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var $cee7ff159d524e18$var$ie = !1;
function $cee7ff159d524e18$var$je(a, b) {
    switch(a){
        case "compositionend":
            return $cee7ff159d524e18$var$he(b);
        case "keypress":
            if (32 !== b.which) return null;
            $cee7ff159d524e18$var$fe = !0;
            return $cee7ff159d524e18$var$ee;
        case "textInput":
            return a = b.data, a === $cee7ff159d524e18$var$ee && $cee7ff159d524e18$var$fe ? null : a;
        default:
            return null;
    }
}
function $cee7ff159d524e18$var$ke(a, b) {
    if ($cee7ff159d524e18$var$ie) return "compositionend" === a || !$cee7ff159d524e18$var$ae && $cee7ff159d524e18$var$ge(a, b) ? (a = $cee7ff159d524e18$var$nd(), $cee7ff159d524e18$var$md = $cee7ff159d524e18$var$ld = $cee7ff159d524e18$var$kd = null, $cee7ff159d524e18$var$ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return $cee7ff159d524e18$var$de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var $cee7ff159d524e18$var$le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $cee7ff159d524e18$var$me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!$cee7ff159d524e18$var$le[a.type] : "textarea" === b ? !0 : !1;
}
function $cee7ff159d524e18$var$ne(a, b, c, d) {
    $cee7ff159d524e18$var$Eb(d);
    b = $cee7ff159d524e18$var$oe(b, "onChange");
    0 < b.length && (c = new $cee7ff159d524e18$var$td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var $cee7ff159d524e18$var$pe = null, $cee7ff159d524e18$var$qe = null;
function $cee7ff159d524e18$var$re(a) {
    $cee7ff159d524e18$var$se(a, 0);
}
function $cee7ff159d524e18$var$te(a) {
    var b = $cee7ff159d524e18$var$ue(a);
    if ($cee7ff159d524e18$var$Wa(b)) return a;
}
function $cee7ff159d524e18$var$ve(a, b) {
    if ("change" === a) return b;
}
var $cee7ff159d524e18$var$we = !1;
if ($cee7ff159d524e18$var$ia) {
    var $cee7ff159d524e18$var$xe;
    if ($cee7ff159d524e18$var$ia) {
        var $cee7ff159d524e18$var$ye = "oninput" in document;
        if (!$cee7ff159d524e18$var$ye) {
            var $cee7ff159d524e18$var$ze = document.createElement("div");
            $cee7ff159d524e18$var$ze.setAttribute("oninput", "return;");
            $cee7ff159d524e18$var$ye = "function" === typeof $cee7ff159d524e18$var$ze.oninput;
        }
        $cee7ff159d524e18$var$xe = $cee7ff159d524e18$var$ye;
    } else $cee7ff159d524e18$var$xe = !1;
    $cee7ff159d524e18$var$we = $cee7ff159d524e18$var$xe && (!document.documentMode || 9 < document.documentMode);
}
function $cee7ff159d524e18$var$Ae() {
    $cee7ff159d524e18$var$pe && ($cee7ff159d524e18$var$pe.detachEvent("onpropertychange", $cee7ff159d524e18$var$Be), $cee7ff159d524e18$var$qe = $cee7ff159d524e18$var$pe = null);
}
function $cee7ff159d524e18$var$Be(a) {
    if ("value" === a.propertyName && $cee7ff159d524e18$var$te($cee7ff159d524e18$var$qe)) {
        var b = [];
        $cee7ff159d524e18$var$ne(b, $cee7ff159d524e18$var$qe, a, $cee7ff159d524e18$var$xb(a));
        $cee7ff159d524e18$var$Jb($cee7ff159d524e18$var$re, b);
    }
}
function $cee7ff159d524e18$var$Ce(a, b, c) {
    "focusin" === a ? ($cee7ff159d524e18$var$Ae(), $cee7ff159d524e18$var$pe = b, $cee7ff159d524e18$var$qe = c, $cee7ff159d524e18$var$pe.attachEvent("onpropertychange", $cee7ff159d524e18$var$Be)) : "focusout" === a && $cee7ff159d524e18$var$Ae();
}
function $cee7ff159d524e18$var$De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return $cee7ff159d524e18$var$te($cee7ff159d524e18$var$qe);
}
function $cee7ff159d524e18$var$Ee(a, b) {
    if ("click" === a) return $cee7ff159d524e18$var$te(b);
}
function $cee7ff159d524e18$var$Fe(a, b) {
    if ("input" === a || "change" === a) return $cee7ff159d524e18$var$te(b);
}
function $cee7ff159d524e18$var$Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $cee7ff159d524e18$var$He = "function" === typeof Object.is ? Object.is : $cee7ff159d524e18$var$Ge;
function $cee7ff159d524e18$var$Ie(a, b) {
    if ($cee7ff159d524e18$var$He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++){
        var e = c[d];
        if (!$cee7ff159d524e18$var$ja.call(b, e) || !$cee7ff159d524e18$var$He(a[e], b[e])) return !1;
    }
    return !0;
}
function $cee7ff159d524e18$var$Je(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function $cee7ff159d524e18$var$Ke(a, b) {
    var c = $cee7ff159d524e18$var$Je(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = $cee7ff159d524e18$var$Je(c);
    }
}
function $cee7ff159d524e18$var$Le(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? $cee7ff159d524e18$var$Le(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function $cee7ff159d524e18$var$Me() {
    for(var a = window, b = $cee7ff159d524e18$var$Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = $cee7ff159d524e18$var$Xa(a.document);
    }
    return b;
}
function $cee7ff159d524e18$var$Ne(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function $cee7ff159d524e18$var$Oe(a) {
    var b = $cee7ff159d524e18$var$Me(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && $cee7ff159d524e18$var$Le(c.ownerDocument.documentElement, c)) {
        if (null !== d && $cee7ff159d524e18$var$Ne(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = $cee7ff159d524e18$var$Ke(c, f);
                var g = $cee7ff159d524e18$var$Ke(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var $cee7ff159d524e18$var$Pe = $cee7ff159d524e18$var$ia && "documentMode" in document && 11 >= document.documentMode, $cee7ff159d524e18$var$Qe = null, $cee7ff159d524e18$var$Re = null, $cee7ff159d524e18$var$Se = null, $cee7ff159d524e18$var$Te = !1;
function $cee7ff159d524e18$var$Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    $cee7ff159d524e18$var$Te || null == $cee7ff159d524e18$var$Qe || $cee7ff159d524e18$var$Qe !== $cee7ff159d524e18$var$Xa(d) || (d = $cee7ff159d524e18$var$Qe, "selectionStart" in d && $cee7ff159d524e18$var$Ne(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), $cee7ff159d524e18$var$Se && $cee7ff159d524e18$var$Ie($cee7ff159d524e18$var$Se, d) || ($cee7ff159d524e18$var$Se = d, d = $cee7ff159d524e18$var$oe($cee7ff159d524e18$var$Re, "onSelect"), 0 < d.length && (b = new $cee7ff159d524e18$var$td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = $cee7ff159d524e18$var$Qe)));
}
function $cee7ff159d524e18$var$Ve(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var $cee7ff159d524e18$var$We = {
    animationend: $cee7ff159d524e18$var$Ve("Animation", "AnimationEnd"),
    animationiteration: $cee7ff159d524e18$var$Ve("Animation", "AnimationIteration"),
    animationstart: $cee7ff159d524e18$var$Ve("Animation", "AnimationStart"),
    transitionend: $cee7ff159d524e18$var$Ve("Transition", "TransitionEnd")
}, $cee7ff159d524e18$var$Xe = {}, $cee7ff159d524e18$var$Ye = {};
$cee7ff159d524e18$var$ia && ($cee7ff159d524e18$var$Ye = document.createElement("div").style, "AnimationEvent" in window || (delete $cee7ff159d524e18$var$We.animationend.animation, delete $cee7ff159d524e18$var$We.animationiteration.animation, delete $cee7ff159d524e18$var$We.animationstart.animation), "TransitionEvent" in window || delete $cee7ff159d524e18$var$We.transitionend.transition);
function $cee7ff159d524e18$var$Ze(a) {
    if ($cee7ff159d524e18$var$Xe[a]) return $cee7ff159d524e18$var$Xe[a];
    if (!$cee7ff159d524e18$var$We[a]) return a;
    var b = $cee7ff159d524e18$var$We[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in $cee7ff159d524e18$var$Ye) return $cee7ff159d524e18$var$Xe[a] = b[c];
    return a;
}
var $cee7ff159d524e18$var$$e = $cee7ff159d524e18$var$Ze("animationend"), $cee7ff159d524e18$var$af = $cee7ff159d524e18$var$Ze("animationiteration"), $cee7ff159d524e18$var$bf = $cee7ff159d524e18$var$Ze("animationstart"), $cee7ff159d524e18$var$cf = $cee7ff159d524e18$var$Ze("transitionend"), $cee7ff159d524e18$var$df = new Map, $cee7ff159d524e18$var$ef = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function $cee7ff159d524e18$var$ff(a, b) {
    $cee7ff159d524e18$var$df.set(a, b);
    $cee7ff159d524e18$var$fa(b, [
        a
    ]);
}
for(var $cee7ff159d524e18$var$gf = 0; $cee7ff159d524e18$var$gf < $cee7ff159d524e18$var$ef.length; $cee7ff159d524e18$var$gf++){
    var $cee7ff159d524e18$var$hf = $cee7ff159d524e18$var$ef[$cee7ff159d524e18$var$gf], $cee7ff159d524e18$var$jf = $cee7ff159d524e18$var$hf.toLowerCase(), $cee7ff159d524e18$var$kf = $cee7ff159d524e18$var$hf[0].toUpperCase() + $cee7ff159d524e18$var$hf.slice(1);
    $cee7ff159d524e18$var$ff($cee7ff159d524e18$var$jf, "on" + $cee7ff159d524e18$var$kf);
}
$cee7ff159d524e18$var$ff($cee7ff159d524e18$var$$e, "onAnimationEnd");
$cee7ff159d524e18$var$ff($cee7ff159d524e18$var$af, "onAnimationIteration");
$cee7ff159d524e18$var$ff($cee7ff159d524e18$var$bf, "onAnimationStart");
$cee7ff159d524e18$var$ff("dblclick", "onDoubleClick");
$cee7ff159d524e18$var$ff("focusin", "onFocus");
$cee7ff159d524e18$var$ff("focusout", "onBlur");
$cee7ff159d524e18$var$ff($cee7ff159d524e18$var$cf, "onTransitionEnd");
$cee7ff159d524e18$var$ha("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$cee7ff159d524e18$var$ha("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$cee7ff159d524e18$var$ha("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$cee7ff159d524e18$var$ha("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$cee7ff159d524e18$var$fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$cee7ff159d524e18$var$fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$cee7ff159d524e18$var$fa("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$cee7ff159d524e18$var$fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$cee7ff159d524e18$var$fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$cee7ff159d524e18$var$fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $cee7ff159d524e18$var$lf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $cee7ff159d524e18$var$mf = new Set("cancel close invalid load scroll toggle".split(" ").concat($cee7ff159d524e18$var$lf));
function $cee7ff159d524e18$var$nf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    $cee7ff159d524e18$var$Ub(d, b, void 0, a);
    a.currentTarget = null;
}
function $cee7ff159d524e18$var$se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $cee7ff159d524e18$var$nf(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $cee7ff159d524e18$var$nf(e, h, l);
                f = k;
            }
        }
    }
    if ($cee7ff159d524e18$var$Qb) throw a = $cee7ff159d524e18$var$Rb, $cee7ff159d524e18$var$Qb = !1, $cee7ff159d524e18$var$Rb = null, a;
}
function $cee7ff159d524e18$var$D(a, b) {
    var c = b[$cee7ff159d524e18$var$of];
    void 0 === c && (c = b[$cee7ff159d524e18$var$of] = new Set);
    var d = a + "__bubble";
    c.has(d) || ($cee7ff159d524e18$var$pf(b, a, 2, !1), c.add(d));
}
function $cee7ff159d524e18$var$qf(a, b, c) {
    var d = 0;
    b && (d |= 4);
    $cee7ff159d524e18$var$pf(c, a, d, b);
}
var $cee7ff159d524e18$var$rf = "_reactListening" + Math.random().toString(36).slice(2);
function $cee7ff159d524e18$var$sf(a) {
    if (!a[$cee7ff159d524e18$var$rf]) {
        a[$cee7ff159d524e18$var$rf] = !0;
        $cee7ff159d524e18$var$da.forEach(function(b) {
            "selectionchange" !== b && ($cee7ff159d524e18$var$mf.has(b) || $cee7ff159d524e18$var$qf(b, !1, a), $cee7ff159d524e18$var$qf(b, !0, a));
        });
        var b = 9 === a.nodeType ? a : a.ownerDocument;
        null === b || b[$cee7ff159d524e18$var$rf] || (b[$cee7ff159d524e18$var$rf] = !0, $cee7ff159d524e18$var$qf("selectionchange", !1, b));
    }
}
function $cee7ff159d524e18$var$pf(a, b, c, d) {
    switch($cee7ff159d524e18$var$jd(b)){
        case 1:
            var e = $cee7ff159d524e18$var$ed;
            break;
        case 4:
            e = $cee7ff159d524e18$var$gd;
            break;
        default:
            e = $cee7ff159d524e18$var$fd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !$cee7ff159d524e18$var$Lb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function $cee7ff159d524e18$var$hd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = $cee7ff159d524e18$var$Wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    $cee7ff159d524e18$var$Jb(function() {
        var d = f, e = $cee7ff159d524e18$var$xb(c), g = [];
        a: {
            var h = $cee7ff159d524e18$var$df.get(a);
            if (void 0 !== h) {
                var k = $cee7ff159d524e18$var$td, n = a;
                switch(a){
                    case "keypress":
                        if (0 === $cee7ff159d524e18$var$od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = $cee7ff159d524e18$var$Rd;
                        break;
                    case "focusin":
                        n = "focus";
                        k = $cee7ff159d524e18$var$Fd;
                        break;
                    case "focusout":
                        n = "blur";
                        k = $cee7ff159d524e18$var$Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = $cee7ff159d524e18$var$Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = $cee7ff159d524e18$var$Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = $cee7ff159d524e18$var$Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = $cee7ff159d524e18$var$Vd;
                        break;
                    case $cee7ff159d524e18$var$$e:
                    case $cee7ff159d524e18$var$af:
                    case $cee7ff159d524e18$var$bf:
                        k = $cee7ff159d524e18$var$Hd;
                        break;
                    case $cee7ff159d524e18$var$cf:
                        k = $cee7ff159d524e18$var$Xd;
                        break;
                    case "scroll":
                        k = $cee7ff159d524e18$var$vd;
                        break;
                    case "wheel":
                        k = $cee7ff159d524e18$var$Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = $cee7ff159d524e18$var$Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = $cee7ff159d524e18$var$Td;
                }
                var t = 0 !== (b & 4), J = !t && "scroll" === a, x = t ? null !== h ? h + "Capture" : null : h;
                t = [];
                for(var w = d, u; null !== w;){
                    u = w;
                    var F = u.stateNode;
                    5 === u.tag && null !== F && (u = F, null !== x && (F = $cee7ff159d524e18$var$Kb(w, x), null != F && t.push($cee7ff159d524e18$var$tf(w, F, u))));
                    if (J) break;
                    w = w.return;
                }
                0 < t.length && (h = new k(h, n, null, c, e), g.push({
                    event: h,
                    listeners: t
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && c !== $cee7ff159d524e18$var$wb && (n = c.relatedTarget || c.fromElement) && ($cee7ff159d524e18$var$Wc(n) || n[$cee7ff159d524e18$var$uf])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (n = c.relatedTarget || c.toElement, k = d, n = n ? $cee7ff159d524e18$var$Wc(n) : null, null !== n && (J = $cee7ff159d524e18$var$Vb(n), n !== J || 5 !== n.tag && 6 !== n.tag)) n = null;
                    } else k = null, n = d;
                    if (k !== n) {
                        t = $cee7ff159d524e18$var$Bd;
                        F = "onMouseLeave";
                        x = "onMouseEnter";
                        w = "mouse";
                        if ("pointerout" === a || "pointerover" === a) t = $cee7ff159d524e18$var$Td, F = "onPointerLeave", x = "onPointerEnter", w = "pointer";
                        J = null == k ? h : $cee7ff159d524e18$var$ue(k);
                        u = null == n ? h : $cee7ff159d524e18$var$ue(n);
                        h = new t(F, w + "leave", k, c, e);
                        h.target = J;
                        h.relatedTarget = u;
                        F = null;
                        $cee7ff159d524e18$var$Wc(e) === d && (t = new t(x, w + "enter", n, c, e), t.target = u, t.relatedTarget = J, F = t);
                        J = F;
                        if (k && n) b: {
                            t = k;
                            x = n;
                            w = 0;
                            for(u = t; u; u = $cee7ff159d524e18$var$vf(u))w++;
                            u = 0;
                            for(F = x; F; F = $cee7ff159d524e18$var$vf(F))u++;
                            for(; 0 < w - u;)t = $cee7ff159d524e18$var$vf(t), w--;
                            for(; 0 < u - w;)x = $cee7ff159d524e18$var$vf(x), u--;
                            for(; w--;){
                                if (t === x || null !== x && t === x.alternate) break b;
                                t = $cee7ff159d524e18$var$vf(t);
                                x = $cee7ff159d524e18$var$vf(x);
                            }
                            t = null;
                        }
                        else t = null;
                        null !== k && $cee7ff159d524e18$var$wf(g, h, k, t, !1);
                        null !== n && null !== J && $cee7ff159d524e18$var$wf(g, J, n, t, !0);
                    }
                }
            }
            a: {
                h = d ? $cee7ff159d524e18$var$ue(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var na = $cee7ff159d524e18$var$ve;
                else if ($cee7ff159d524e18$var$me(h)) {
                    if ($cee7ff159d524e18$var$we) na = $cee7ff159d524e18$var$Fe;
                    else {
                        na = $cee7ff159d524e18$var$De;
                        var xa = $cee7ff159d524e18$var$Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (na = $cee7ff159d524e18$var$Ee);
                if (na && (na = na(a, d))) {
                    $cee7ff159d524e18$var$ne(g, na, c, e);
                    break a;
                }
                xa && xa(a, h, d);
                "focusout" === a && (xa = h._wrapperState) && xa.controlled && "number" === h.type && $cee7ff159d524e18$var$cb(h, "number", h.value);
            }
            xa = d ? $cee7ff159d524e18$var$ue(d) : window;
            switch(a){
                case "focusin":
                    if ($cee7ff159d524e18$var$me(xa) || "true" === xa.contentEditable) $cee7ff159d524e18$var$Qe = xa, $cee7ff159d524e18$var$Re = d, $cee7ff159d524e18$var$Se = null;
                    break;
                case "focusout":
                    $cee7ff159d524e18$var$Se = $cee7ff159d524e18$var$Re = $cee7ff159d524e18$var$Qe = null;
                    break;
                case "mousedown":
                    $cee7ff159d524e18$var$Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $cee7ff159d524e18$var$Te = !1;
                    $cee7ff159d524e18$var$Ue(g, c, e);
                    break;
                case "selectionchange":
                    if ($cee7ff159d524e18$var$Pe) break;
                case "keydown":
                case "keyup":
                    $cee7ff159d524e18$var$Ue(g, c, e);
            }
            var $a;
            if ($cee7ff159d524e18$var$ae) b: {
                switch(a){
                    case "compositionstart":
                        var ba = "onCompositionStart";
                        break b;
                    case "compositionend":
                        ba = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        ba = "onCompositionUpdate";
                        break b;
                }
                ba = void 0;
            }
            else $cee7ff159d524e18$var$ie ? $cee7ff159d524e18$var$ge(a, c) && (ba = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (ba = "onCompositionStart");
            ba && ($cee7ff159d524e18$var$de && "ko" !== c.locale && ($cee7ff159d524e18$var$ie || "onCompositionStart" !== ba ? "onCompositionEnd" === ba && $cee7ff159d524e18$var$ie && ($a = $cee7ff159d524e18$var$nd()) : ($cee7ff159d524e18$var$kd = e, $cee7ff159d524e18$var$ld = "value" in $cee7ff159d524e18$var$kd ? $cee7ff159d524e18$var$kd.value : $cee7ff159d524e18$var$kd.textContent, $cee7ff159d524e18$var$ie = !0)), xa = $cee7ff159d524e18$var$oe(d, ba), 0 < xa.length && (ba = new $cee7ff159d524e18$var$Ld(ba, a, null, c, e), g.push({
                event: ba,
                listeners: xa
            }), $a ? ba.data = $a : ($a = $cee7ff159d524e18$var$he(c), null !== $a && (ba.data = $a))));
            if ($a = $cee7ff159d524e18$var$ce ? $cee7ff159d524e18$var$je(a, c) : $cee7ff159d524e18$var$ke(a, c)) d = $cee7ff159d524e18$var$oe(d, "onBeforeInput"), 0 < d.length && (e = new $cee7ff159d524e18$var$Ld("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = $a);
        }
        $cee7ff159d524e18$var$se(g, b);
    });
}
function $cee7ff159d524e18$var$tf(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function $cee7ff159d524e18$var$oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = $cee7ff159d524e18$var$Kb(a, c), null != f && d.unshift($cee7ff159d524e18$var$tf(a, f, e)), f = $cee7ff159d524e18$var$Kb(a, b), null != f && d.push($cee7ff159d524e18$var$tf(a, f, e)));
        a = a.return;
    }
    return d;
}
function $cee7ff159d524e18$var$vf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function $cee7ff159d524e18$var$wf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = $cee7ff159d524e18$var$Kb(c, f), null != k && g.unshift($cee7ff159d524e18$var$tf(c, k, h))) : e || (k = $cee7ff159d524e18$var$Kb(c, f), null != k && g.push($cee7ff159d524e18$var$tf(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
var $cee7ff159d524e18$var$xf = /\r\n?/g, $cee7ff159d524e18$var$yf = /\u0000|\uFFFD/g;
function $cee7ff159d524e18$var$zf(a) {
    return ("string" === typeof a ? a : "" + a).replace($cee7ff159d524e18$var$xf, "\n").replace($cee7ff159d524e18$var$yf, "");
}
function $cee7ff159d524e18$var$Af(a, b, c) {
    b = $cee7ff159d524e18$var$zf(b);
    if ($cee7ff159d524e18$var$zf(a) !== b && c) throw Error($cee7ff159d524e18$var$p(425));
}
function $cee7ff159d524e18$var$Bf() {}
var $cee7ff159d524e18$var$Cf = null, $cee7ff159d524e18$var$Df = null;
function $cee7ff159d524e18$var$Ef(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var $cee7ff159d524e18$var$Ff = "function" === typeof setTimeout ? setTimeout : void 0, $cee7ff159d524e18$var$Gf = "function" === typeof clearTimeout ? clearTimeout : void 0, $cee7ff159d524e18$var$Hf = "function" === typeof Promise ? Promise : void 0, $cee7ff159d524e18$var$Jf = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $cee7ff159d524e18$var$Hf ? function(a) {
    return $cee7ff159d524e18$var$Hf.resolve(null).then(a).catch($cee7ff159d524e18$var$If);
} : $cee7ff159d524e18$var$Ff;
function $cee7ff159d524e18$var$If(a) {
    setTimeout(function() {
        throw a;
    });
}
function $cee7ff159d524e18$var$Kf(a, b) {
    var c = b, d = 0;
    do {
        var e = c.nextSibling;
        a.removeChild(c);
        if (e && 8 === e.nodeType) {
            if (c = e.data, "/$" === c) {
                if (0 === d) {
                    a.removeChild(e);
                    $cee7ff159d524e18$var$bd(b);
                    return;
                }
                d--;
            } else "$" !== c && "$?" !== c && "$!" !== c || d++;
        }
        c = e;
    }while (c);
    $cee7ff159d524e18$var$bd(b);
}
function $cee7ff159d524e18$var$Lf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
        if (8 === b) {
            b = a.data;
            if ("$" === b || "$!" === b || "$?" === b) break;
            if ("/$" === b) return null;
        }
    }
    return a;
}
function $cee7ff159d524e18$var$Mf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var $cee7ff159d524e18$var$Nf = Math.random().toString(36).slice(2), $cee7ff159d524e18$var$Of = "__reactFiber$" + $cee7ff159d524e18$var$Nf, $cee7ff159d524e18$var$Pf = "__reactProps$" + $cee7ff159d524e18$var$Nf, $cee7ff159d524e18$var$uf = "__reactContainer$" + $cee7ff159d524e18$var$Nf, $cee7ff159d524e18$var$of = "__reactEvents$" + $cee7ff159d524e18$var$Nf, $cee7ff159d524e18$var$Qf = "__reactListeners$" + $cee7ff159d524e18$var$Nf, $cee7ff159d524e18$var$Rf = "__reactHandles$" + $cee7ff159d524e18$var$Nf;
function $cee7ff159d524e18$var$Wc(a) {
    var b = a[$cee7ff159d524e18$var$Of];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[$cee7ff159d524e18$var$uf] || c[$cee7ff159d524e18$var$Of]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = $cee7ff159d524e18$var$Mf(a); null !== a;){
                if (c = a[$cee7ff159d524e18$var$Of]) return c;
                a = $cee7ff159d524e18$var$Mf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function $cee7ff159d524e18$var$Cb(a) {
    a = a[$cee7ff159d524e18$var$Of] || a[$cee7ff159d524e18$var$uf];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function $cee7ff159d524e18$var$ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error($cee7ff159d524e18$var$p(33));
}
function $cee7ff159d524e18$var$Db(a) {
    return a[$cee7ff159d524e18$var$Pf] || null;
}
var $cee7ff159d524e18$var$Sf = [], $cee7ff159d524e18$var$Tf = -1;
function $cee7ff159d524e18$var$Uf(a) {
    return {
        current: a
    };
}
function $cee7ff159d524e18$var$E(a) {
    0 > $cee7ff159d524e18$var$Tf || (a.current = $cee7ff159d524e18$var$Sf[$cee7ff159d524e18$var$Tf], $cee7ff159d524e18$var$Sf[$cee7ff159d524e18$var$Tf] = null, $cee7ff159d524e18$var$Tf--);
}
function $cee7ff159d524e18$var$G(a, b) {
    $cee7ff159d524e18$var$Tf++;
    $cee7ff159d524e18$var$Sf[$cee7ff159d524e18$var$Tf] = a.current;
    a.current = b;
}
var $cee7ff159d524e18$var$Vf = {}, $cee7ff159d524e18$var$H = $cee7ff159d524e18$var$Uf($cee7ff159d524e18$var$Vf), $cee7ff159d524e18$var$Wf = $cee7ff159d524e18$var$Uf(!1), $cee7ff159d524e18$var$Xf = $cee7ff159d524e18$var$Vf;
function $cee7ff159d524e18$var$Yf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return $cee7ff159d524e18$var$Vf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function $cee7ff159d524e18$var$Zf(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $cee7ff159d524e18$var$$f() {
    $cee7ff159d524e18$var$E($cee7ff159d524e18$var$Wf);
    $cee7ff159d524e18$var$E($cee7ff159d524e18$var$H);
}
function $cee7ff159d524e18$var$ag(a, b, c) {
    if ($cee7ff159d524e18$var$H.current !== $cee7ff159d524e18$var$Vf) throw Error($cee7ff159d524e18$var$p(168));
    $cee7ff159d524e18$var$G($cee7ff159d524e18$var$H, b);
    $cee7ff159d524e18$var$G($cee7ff159d524e18$var$Wf, c);
}
function $cee7ff159d524e18$var$bg(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in b)) throw Error($cee7ff159d524e18$var$p(108, $cee7ff159d524e18$var$Ra(a) || "Unknown", e));
    return $cee7ff159d524e18$var$A({}, c, d);
}
function $cee7ff159d524e18$var$cg(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || $cee7ff159d524e18$var$Vf;
    $cee7ff159d524e18$var$Xf = $cee7ff159d524e18$var$H.current;
    $cee7ff159d524e18$var$G($cee7ff159d524e18$var$H, a);
    $cee7ff159d524e18$var$G($cee7ff159d524e18$var$Wf, $cee7ff159d524e18$var$Wf.current);
    return !0;
}
function $cee7ff159d524e18$var$dg(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error($cee7ff159d524e18$var$p(169));
    c ? (a = $cee7ff159d524e18$var$bg(a, b, $cee7ff159d524e18$var$Xf), d.__reactInternalMemoizedMergedChildContext = a, $cee7ff159d524e18$var$E($cee7ff159d524e18$var$Wf), $cee7ff159d524e18$var$E($cee7ff159d524e18$var$H), $cee7ff159d524e18$var$G($cee7ff159d524e18$var$H, a)) : $cee7ff159d524e18$var$E($cee7ff159d524e18$var$Wf);
    $cee7ff159d524e18$var$G($cee7ff159d524e18$var$Wf, c);
}
var $cee7ff159d524e18$var$eg = null, $cee7ff159d524e18$var$fg = !1, $cee7ff159d524e18$var$gg = !1;
function $cee7ff159d524e18$var$hg(a) {
    null === $cee7ff159d524e18$var$eg ? $cee7ff159d524e18$var$eg = [
        a
    ] : $cee7ff159d524e18$var$eg.push(a);
}
function $cee7ff159d524e18$var$ig(a) {
    $cee7ff159d524e18$var$fg = !0;
    $cee7ff159d524e18$var$hg(a);
}
function $cee7ff159d524e18$var$jg() {
    if (!$cee7ff159d524e18$var$gg && null !== $cee7ff159d524e18$var$eg) {
        $cee7ff159d524e18$var$gg = !0;
        var a = 0, b = $cee7ff159d524e18$var$C;
        try {
            var c = $cee7ff159d524e18$var$eg;
            for($cee7ff159d524e18$var$C = 1; a < c.length; a++){
                var d = c[a];
                do d = d(!0);
                while (null !== d);
            }
            $cee7ff159d524e18$var$eg = null;
            $cee7ff159d524e18$var$fg = !1;
        } catch (e) {
            throw null !== $cee7ff159d524e18$var$eg && ($cee7ff159d524e18$var$eg = $cee7ff159d524e18$var$eg.slice(a + 1)), $cee7ff159d524e18$var$ac($cee7ff159d524e18$var$fc, $cee7ff159d524e18$var$jg), e;
        } finally{
            $cee7ff159d524e18$var$C = b, $cee7ff159d524e18$var$gg = !1;
        }
    }
    return null;
}
var $cee7ff159d524e18$var$kg = [], $cee7ff159d524e18$var$lg = 0, $cee7ff159d524e18$var$mg = null, $cee7ff159d524e18$var$ng = 0, $cee7ff159d524e18$var$og = [], $cee7ff159d524e18$var$pg = 0, $cee7ff159d524e18$var$qg = null, $cee7ff159d524e18$var$rg = 1, $cee7ff159d524e18$var$sg = "";
function $cee7ff159d524e18$var$tg(a, b) {
    $cee7ff159d524e18$var$kg[$cee7ff159d524e18$var$lg++] = $cee7ff159d524e18$var$ng;
    $cee7ff159d524e18$var$kg[$cee7ff159d524e18$var$lg++] = $cee7ff159d524e18$var$mg;
    $cee7ff159d524e18$var$mg = a;
    $cee7ff159d524e18$var$ng = b;
}
function $cee7ff159d524e18$var$ug(a, b, c) {
    $cee7ff159d524e18$var$og[$cee7ff159d524e18$var$pg++] = $cee7ff159d524e18$var$rg;
    $cee7ff159d524e18$var$og[$cee7ff159d524e18$var$pg++] = $cee7ff159d524e18$var$sg;
    $cee7ff159d524e18$var$og[$cee7ff159d524e18$var$pg++] = $cee7ff159d524e18$var$qg;
    $cee7ff159d524e18$var$qg = a;
    var d = $cee7ff159d524e18$var$rg;
    a = $cee7ff159d524e18$var$sg;
    var e = 32 - $cee7ff159d524e18$var$oc(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f = 32 - $cee7ff159d524e18$var$oc(b) + e;
    if (30 < f) {
        var g = e - e % 5;
        f = (d & (1 << g) - 1).toString(32);
        d >>= g;
        e -= g;
        $cee7ff159d524e18$var$rg = 1 << 32 - $cee7ff159d524e18$var$oc(b) + e | c << e | d;
        $cee7ff159d524e18$var$sg = f + a;
    } else $cee7ff159d524e18$var$rg = 1 << f | c << e | d, $cee7ff159d524e18$var$sg = a;
}
function $cee7ff159d524e18$var$vg(a) {
    null !== a.return && ($cee7ff159d524e18$var$tg(a, 1), $cee7ff159d524e18$var$ug(a, 1, 0));
}
function $cee7ff159d524e18$var$wg(a) {
    for(; a === $cee7ff159d524e18$var$mg;)$cee7ff159d524e18$var$mg = $cee7ff159d524e18$var$kg[--$cee7ff159d524e18$var$lg], $cee7ff159d524e18$var$kg[$cee7ff159d524e18$var$lg] = null, $cee7ff159d524e18$var$ng = $cee7ff159d524e18$var$kg[--$cee7ff159d524e18$var$lg], $cee7ff159d524e18$var$kg[$cee7ff159d524e18$var$lg] = null;
    for(; a === $cee7ff159d524e18$var$qg;)$cee7ff159d524e18$var$qg = $cee7ff159d524e18$var$og[--$cee7ff159d524e18$var$pg], $cee7ff159d524e18$var$og[$cee7ff159d524e18$var$pg] = null, $cee7ff159d524e18$var$sg = $cee7ff159d524e18$var$og[--$cee7ff159d524e18$var$pg], $cee7ff159d524e18$var$og[$cee7ff159d524e18$var$pg] = null, $cee7ff159d524e18$var$rg = $cee7ff159d524e18$var$og[--$cee7ff159d524e18$var$pg], $cee7ff159d524e18$var$og[$cee7ff159d524e18$var$pg] = null;
}
var $cee7ff159d524e18$var$xg = null, $cee7ff159d524e18$var$yg = null, $cee7ff159d524e18$var$I = !1, $cee7ff159d524e18$var$zg = null;
function $cee7ff159d524e18$var$Ag(a, b) {
    var c = $cee7ff159d524e18$var$Bg(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c.return = a;
    b = a.deletions;
    null === b ? (a.deletions = [
        c
    ], a.flags |= 16) : b.push(c);
}
function $cee7ff159d524e18$var$Cg(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, $cee7ff159d524e18$var$xg = a, $cee7ff159d524e18$var$yg = $cee7ff159d524e18$var$Lf(b.firstChild), !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, $cee7ff159d524e18$var$xg = a, $cee7ff159d524e18$var$yg = null, !0) : !1;
        case 13:
            return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== $cee7ff159d524e18$var$qg ? {
                id: $cee7ff159d524e18$var$rg,
                overflow: $cee7ff159d524e18$var$sg
            } : null, a.memoizedState = {
                dehydrated: b,
                treeContext: c,
                retryLane: 1073741824
            }, c = $cee7ff159d524e18$var$Bg(18, null, null, 0), c.stateNode = b, c.return = a, a.child = c, $cee7ff159d524e18$var$xg = a, $cee7ff159d524e18$var$yg = null, !0) : !1;
        default:
            return !1;
    }
}
function $cee7ff159d524e18$var$Dg(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function $cee7ff159d524e18$var$Eg(a) {
    if ($cee7ff159d524e18$var$I) {
        var b = $cee7ff159d524e18$var$yg;
        if (b) {
            var c = b;
            if (!$cee7ff159d524e18$var$Cg(a, b)) {
                if ($cee7ff159d524e18$var$Dg(a)) throw Error($cee7ff159d524e18$var$p(418));
                b = $cee7ff159d524e18$var$Lf(c.nextSibling);
                var d = $cee7ff159d524e18$var$xg;
                b && $cee7ff159d524e18$var$Cg(a, b) ? $cee7ff159d524e18$var$Ag(d, c) : (a.flags = a.flags & -4097 | 2, $cee7ff159d524e18$var$I = !1, $cee7ff159d524e18$var$xg = a);
            }
        } else {
            if ($cee7ff159d524e18$var$Dg(a)) throw Error($cee7ff159d524e18$var$p(418));
            a.flags = a.flags & -4097 | 2;
            $cee7ff159d524e18$var$I = !1;
            $cee7ff159d524e18$var$xg = a;
        }
    }
}
function $cee7ff159d524e18$var$Fg(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    $cee7ff159d524e18$var$xg = a;
}
function $cee7ff159d524e18$var$Gg(a) {
    if (a !== $cee7ff159d524e18$var$xg) return !1;
    if (!$cee7ff159d524e18$var$I) return $cee7ff159d524e18$var$Fg(a), $cee7ff159d524e18$var$I = !0, !1;
    var b;
    (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !$cee7ff159d524e18$var$Ef(a.type, a.memoizedProps));
    if (b && (b = $cee7ff159d524e18$var$yg)) {
        if ($cee7ff159d524e18$var$Dg(a)) throw $cee7ff159d524e18$var$Hg(), Error($cee7ff159d524e18$var$p(418));
        for(; b;)$cee7ff159d524e18$var$Ag(a, b), b = $cee7ff159d524e18$var$Lf(b.nextSibling);
    }
    $cee7ff159d524e18$var$Fg(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error($cee7ff159d524e18$var$p(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            $cee7ff159d524e18$var$yg = $cee7ff159d524e18$var$Lf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            $cee7ff159d524e18$var$yg = null;
        }
    } else $cee7ff159d524e18$var$yg = $cee7ff159d524e18$var$xg ? $cee7ff159d524e18$var$Lf(a.stateNode.nextSibling) : null;
    return !0;
}
function $cee7ff159d524e18$var$Hg() {
    for(var a = $cee7ff159d524e18$var$yg; a;)a = $cee7ff159d524e18$var$Lf(a.nextSibling);
}
function $cee7ff159d524e18$var$Ig() {
    $cee7ff159d524e18$var$yg = $cee7ff159d524e18$var$xg = null;
    $cee7ff159d524e18$var$I = !1;
}
function $cee7ff159d524e18$var$Jg(a) {
    null === $cee7ff159d524e18$var$zg ? $cee7ff159d524e18$var$zg = [
        a
    ] : $cee7ff159d524e18$var$zg.push(a);
}
var $cee7ff159d524e18$var$Kg = $cee7ff159d524e18$var$ua.ReactCurrentBatchConfig;
function $cee7ff159d524e18$var$Lg(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error($cee7ff159d524e18$var$p(309));
                var d = c.stateNode;
            }
            if (!d) throw Error($cee7ff159d524e18$var$p(147, a));
            var e = d, f = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
            b = function(a) {
                var b = e.refs;
                null === a ? delete b[f] : b[f] = a;
            };
            b._stringRef = f;
            return b;
        }
        if ("string" !== typeof a) throw Error($cee7ff159d524e18$var$p(284));
        if (!c._owner) throw Error($cee7ff159d524e18$var$p(290, a));
    }
    return a;
}
function $cee7ff159d524e18$var$Mg(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error($cee7ff159d524e18$var$p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function $cee7ff159d524e18$var$Ng(a) {
    var b = a._init;
    return b(a._payload);
}
function $cee7ff159d524e18$var$Og(a) {
    function b(b, c) {
        if (a) {
            var d = b.deletions;
            null === d ? (b.deletions = [
                c
            ], b.flags |= 16) : d.push(c);
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = $cee7ff159d524e18$var$Pg(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return b.flags |= 1048576, c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
        b.flags |= 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags |= 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = $cee7ff159d524e18$var$Qg(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        var f = c.type;
        if (f === $cee7ff159d524e18$var$ya) return m(a, b, c.props.children, d, c.key);
        if (null !== b && (b.elementType === f || "object" === typeof f && null !== f && f.$$typeof === $cee7ff159d524e18$var$Ha && $cee7ff159d524e18$var$Ng(f) === b.type)) return d = e(b, c.props), d.ref = $cee7ff159d524e18$var$Lg(a, b, c), d.return = a, d;
        d = $cee7ff159d524e18$var$Rg(c.type, c.key, c.props, null, a.mode, d);
        d.ref = $cee7ff159d524e18$var$Lg(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = $cee7ff159d524e18$var$Sg(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = $cee7ff159d524e18$var$Tg(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function q(a, b, c) {
        if ("string" === typeof b && "" !== b || "number" === typeof b) return b = $cee7ff159d524e18$var$Qg("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case $cee7ff159d524e18$var$va:
                    return c = $cee7ff159d524e18$var$Rg(b.type, b.key, b.props, null, a.mode, c), c.ref = $cee7ff159d524e18$var$Lg(a, null, b), c.return = a, c;
                case $cee7ff159d524e18$var$wa:
                    return b = $cee7ff159d524e18$var$Sg(b, a.mode, c), b.return = a, b;
                case $cee7ff159d524e18$var$Ha:
                    var d = b._init;
                    return q(a, d(b._payload), c);
            }
            if ($cee7ff159d524e18$var$eb(b) || $cee7ff159d524e18$var$Ka(b)) return b = $cee7ff159d524e18$var$Tg(b, a.mode, c, null), b.return = a, b;
            $cee7ff159d524e18$var$Mg(a, b);
        }
        return null;
    }
    function r(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case $cee7ff159d524e18$var$va:
                    return c.key === e ? k(a, b, c, d) : null;
                case $cee7ff159d524e18$var$wa:
                    return c.key === e ? l(a, b, c, d) : null;
                case $cee7ff159d524e18$var$Ha:
                    return e = c._init, r(a, b, e(c._payload), d);
            }
            if ($cee7ff159d524e18$var$eb(c) || $cee7ff159d524e18$var$Ka(c)) return null !== e ? null : m(a, b, c, d, null);
            $cee7ff159d524e18$var$Mg(a, c);
        }
        return null;
    }
    function y(a, b, c, d, e) {
        if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case $cee7ff159d524e18$var$va:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                case $cee7ff159d524e18$var$wa:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                case $cee7ff159d524e18$var$Ha:
                    var f = d._init;
                    return y(a, b, c, f(d._payload), e);
            }
            if ($cee7ff159d524e18$var$eb(d) || $cee7ff159d524e18$var$Ka(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            $cee7ff159d524e18$var$Mg(b, d);
        }
        return null;
    }
    function n(e, g, h, k) {
        for(var l = null, m = null, u = g, w = g = 0, x = null; null !== u && w < h.length; w++){
            u.index > w ? (x = u, u = null) : x = u.sibling;
            var n = r(e, u, h[w], k);
            if (null === n) {
                null === u && (u = x);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, w);
            null === m ? l = n : m.sibling = n;
            m = n;
            u = x;
        }
        if (w === h.length) return c(e, u), $cee7ff159d524e18$var$I && $cee7ff159d524e18$var$tg(e, w), l;
        if (null === u) {
            for(; w < h.length; w++)u = q(e, h[w], k), null !== u && (g = f(u, g, w), null === m ? l = u : m.sibling = u, m = u);
            $cee7ff159d524e18$var$I && $cee7ff159d524e18$var$tg(e, w);
            return l;
        }
        for(u = d(e, u); w < h.length; w++)x = y(u, e, w, h[w], k), null !== x && (a && null !== x.alternate && u.delete(null === x.key ? w : x.key), g = f(x, g, w), null === m ? l = x : m.sibling = x, m = x);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        $cee7ff159d524e18$var$I && $cee7ff159d524e18$var$tg(e, w);
        return l;
    }
    function t(e, g, h, k) {
        var l = $cee7ff159d524e18$var$Ka(h);
        if ("function" !== typeof l) throw Error($cee7ff159d524e18$var$p(150));
        h = l.call(h);
        if (null == h) throw Error($cee7ff159d524e18$var$p(151));
        for(var u = l = null, m = g, w = g = 0, x = null, n = h.next(); null !== m && !n.done; w++, n = h.next()){
            m.index > w ? (x = m, m = null) : x = m.sibling;
            var t = r(e, m, n.value, k);
            if (null === t) {
                null === m && (m = x);
                break;
            }
            a && m && null === t.alternate && b(e, m);
            g = f(t, g, w);
            null === u ? l = t : u.sibling = t;
            u = t;
            m = x;
        }
        if (n.done) return c(e, m), $cee7ff159d524e18$var$I && $cee7ff159d524e18$var$tg(e, w), l;
        if (null === m) {
            for(; !n.done; w++, n = h.next())n = q(e, n.value, k), null !== n && (g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
            $cee7ff159d524e18$var$I && $cee7ff159d524e18$var$tg(e, w);
            return l;
        }
        for(m = d(e, m); !n.done; w++, n = h.next())n = y(m, e, w, n.value, k), null !== n && (a && null !== n.alternate && m.delete(null === n.key ? w : n.key), g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        $cee7ff159d524e18$var$I && $cee7ff159d524e18$var$tg(e, w);
        return l;
    }
    function J(a, d, f, h) {
        "object" === typeof f && null !== f && f.type === $cee7ff159d524e18$var$ya && null === f.key && (f = f.props.children);
        if ("object" === typeof f && null !== f) {
            switch(f.$$typeof){
                case $cee7ff159d524e18$var$va:
                    a: {
                        for(var k = f.key, l = d; null !== l;){
                            if (l.key === k) {
                                k = f.type;
                                if (k === $cee7ff159d524e18$var$ya) {
                                    if (7 === l.tag) {
                                        c(a, l.sibling);
                                        d = e(l, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                } else if (l.elementType === k || "object" === typeof k && null !== k && k.$$typeof === $cee7ff159d524e18$var$Ha && $cee7ff159d524e18$var$Ng(k) === l.type) {
                                    c(a, l.sibling);
                                    d = e(l, f.props);
                                    d.ref = $cee7ff159d524e18$var$Lg(a, l, f);
                                    d.return = a;
                                    a = d;
                                    break a;
                                }
                                c(a, l);
                                break;
                            } else b(a, l);
                            l = l.sibling;
                        }
                        f.type === $cee7ff159d524e18$var$ya ? (d = $cee7ff159d524e18$var$Tg(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = $cee7ff159d524e18$var$Rg(f.type, f.key, f.props, null, a.mode, h), h.ref = $cee7ff159d524e18$var$Lg(a, d, f), h.return = a, a = h);
                    }
                    return g(a);
                case $cee7ff159d524e18$var$wa:
                    a: {
                        for(l = f.key; null !== d;){
                            if (d.key === l) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || []);
                                    d.return = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = $cee7ff159d524e18$var$Sg(f, a.mode, h);
                        d.return = a;
                        a = d;
                    }
                    return g(a);
                case $cee7ff159d524e18$var$Ha:
                    return l = f._init, J(a, d, l(f._payload), h);
            }
            if ($cee7ff159d524e18$var$eb(f)) return n(a, d, f, h);
            if ($cee7ff159d524e18$var$Ka(f)) return t(a, d, f, h);
            $cee7ff159d524e18$var$Mg(a, f);
        }
        return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = $cee7ff159d524e18$var$Qg(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
    }
    return J;
}
var $cee7ff159d524e18$var$Ug = $cee7ff159d524e18$var$Og(!0), $cee7ff159d524e18$var$Vg = $cee7ff159d524e18$var$Og(!1), $cee7ff159d524e18$var$Wg = $cee7ff159d524e18$var$Uf(null), $cee7ff159d524e18$var$Xg = null, $cee7ff159d524e18$var$Yg = null, $cee7ff159d524e18$var$Zg = null;
function $cee7ff159d524e18$var$$g() {
    $cee7ff159d524e18$var$Zg = $cee7ff159d524e18$var$Yg = $cee7ff159d524e18$var$Xg = null;
}
function $cee7ff159d524e18$var$ah(a) {
    var b = $cee7ff159d524e18$var$Wg.current;
    $cee7ff159d524e18$var$E($cee7ff159d524e18$var$Wg);
    a._currentValue = b;
}
function $cee7ff159d524e18$var$bh(a, b, c) {
    for(; null !== a;){
        var d = a.alternate;
        (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
        if (a === c) break;
        a = a.return;
    }
}
function $cee7ff159d524e18$var$ch(a, b) {
    $cee7ff159d524e18$var$Xg = a;
    $cee7ff159d524e18$var$Zg = $cee7ff159d524e18$var$Yg = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && ($cee7ff159d524e18$var$dh = !0), a.firstContext = null);
}
function $cee7ff159d524e18$var$eh(a) {
    var b = a._currentValue;
    if ($cee7ff159d524e18$var$Zg !== a) {
        if (a = {
            context: a,
            memoizedValue: b,
            next: null
        }, null === $cee7ff159d524e18$var$Yg) {
            if (null === $cee7ff159d524e18$var$Xg) throw Error($cee7ff159d524e18$var$p(308));
            $cee7ff159d524e18$var$Yg = a;
            $cee7ff159d524e18$var$Xg.dependencies = {
                lanes: 0,
                firstContext: a
            };
        } else $cee7ff159d524e18$var$Yg = $cee7ff159d524e18$var$Yg.next = a;
    }
    return b;
}
var $cee7ff159d524e18$var$fh = null;
function $cee7ff159d524e18$var$gh(a) {
    null === $cee7ff159d524e18$var$fh ? $cee7ff159d524e18$var$fh = [
        a
    ] : $cee7ff159d524e18$var$fh.push(a);
}
function $cee7ff159d524e18$var$hh(a, b, c, d) {
    var e = b.interleaved;
    null === e ? (c.next = c, $cee7ff159d524e18$var$gh(b)) : (c.next = e.next, e.next = c);
    b.interleaved = c;
    return $cee7ff159d524e18$var$ih(a, d);
}
function $cee7ff159d524e18$var$ih(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
var $cee7ff159d524e18$var$jh = !1;
function $cee7ff159d524e18$var$kh(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            interleaved: null,
            lanes: 0
        },
        effects: null
    };
}
function $cee7ff159d524e18$var$lh(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function $cee7ff159d524e18$var$mh(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $cee7ff159d524e18$var$nh(a, b, c) {
    var d = a.updateQueue;
    if (null === d) return null;
    d = d.shared;
    if (0 !== ($cee7ff159d524e18$var$K & 2)) {
        var e = d.pending;
        null === e ? b.next = b : (b.next = e.next, e.next = b);
        d.pending = b;
        return $cee7ff159d524e18$var$ih(a, c);
    }
    e = d.interleaved;
    null === e ? (b.next = b, $cee7ff159d524e18$var$gh(d)) : (b.next = e.next, e.next = b);
    d.interleaved = b;
    return $cee7ff159d524e18$var$ih(a, c);
}
function $cee7ff159d524e18$var$oh(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $cee7ff159d524e18$var$Cc(a, c);
    }
}
function $cee7ff159d524e18$var$ph(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function $cee7ff159d524e18$var$qh(a, b, c, d) {
    var e = a.updateQueue;
    $cee7ff159d524e18$var$jh = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var m = a.alternate;
        null !== m && (m = m.updateQueue, h = m.lastBaseUpdate, h !== g && (null === h ? m.firstBaseUpdate = l : h.next = l, m.lastBaseUpdate = k));
    }
    if (null !== f) {
        var q = e.baseState;
        g = 0;
        m = l = k = null;
        h = f;
        do {
            var r = h.lane, y = h.eventTime;
            if ((d & r) === r) {
                null !== m && (m = m.next = {
                    eventTime: y,
                    lane: 0,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                });
                a: {
                    var n = a, t = h;
                    r = b;
                    y = c;
                    switch(t.tag){
                        case 1:
                            n = t.payload;
                            if ("function" === typeof n) {
                                q = n.call(y, q, r);
                                break a;
                            }
                            q = n;
                            break a;
                        case 3:
                            n.flags = n.flags & -65537 | 128;
                        case 0:
                            n = t.payload;
                            r = "function" === typeof n ? n.call(y, q, r) : n;
                            if (null === r || void 0 === r) break a;
                            q = $cee7ff159d524e18$var$A({}, q, r);
                            break a;
                        case 2:
                            $cee7ff159d524e18$var$jh = !0;
                    }
                }
                null !== h.callback && 0 !== h.lane && (a.flags |= 64, r = e.effects, null === r ? e.effects = [
                    h
                ] : r.push(h));
            } else y = {
                eventTime: y,
                lane: r,
                tag: h.tag,
                payload: h.payload,
                callback: h.callback,
                next: null
            }, null === m ? (l = m = y, k = q) : m = m.next = y, g |= r;
            h = h.next;
            if (null === h) {
                if (h = e.shared.pending, null === h) break;
                else r = h, h = r.next, r.next = null, e.lastBaseUpdate = r, e.shared.pending = null;
            }
        }while (1);
        null === m && (k = q);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = m;
        b = e.shared.interleaved;
        if (null !== b) {
            e = b;
            do g |= e.lane, e = e.next;
            while (e !== b);
        } else null === f && (e.shared.lanes = 0);
        $cee7ff159d524e18$var$rh |= g;
        a.lanes = g;
        a.memoizedState = q;
    }
}
function $cee7ff159d524e18$var$sh(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error($cee7ff159d524e18$var$p(191, e));
            e.call(d);
        }
    }
}
var $cee7ff159d524e18$var$th = {}, $cee7ff159d524e18$var$uh = $cee7ff159d524e18$var$Uf($cee7ff159d524e18$var$th), $cee7ff159d524e18$var$vh = $cee7ff159d524e18$var$Uf($cee7ff159d524e18$var$th), $cee7ff159d524e18$var$wh = $cee7ff159d524e18$var$Uf($cee7ff159d524e18$var$th);
function $cee7ff159d524e18$var$xh(a) {
    if (a === $cee7ff159d524e18$var$th) throw Error($cee7ff159d524e18$var$p(174));
    return a;
}
function $cee7ff159d524e18$var$yh(a, b) {
    $cee7ff159d524e18$var$G($cee7ff159d524e18$var$wh, b);
    $cee7ff159d524e18$var$G($cee7ff159d524e18$var$vh, a);
    $cee7ff159d524e18$var$G($cee7ff159d524e18$var$uh, $cee7ff159d524e18$var$th);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : $cee7ff159d524e18$var$lb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = $cee7ff159d524e18$var$lb(b, a);
    }
    $cee7ff159d524e18$var$E($cee7ff159d524e18$var$uh);
    $cee7ff159d524e18$var$G($cee7ff159d524e18$var$uh, b);
}
function $cee7ff159d524e18$var$zh() {
    $cee7ff159d524e18$var$E($cee7ff159d524e18$var$uh);
    $cee7ff159d524e18$var$E($cee7ff159d524e18$var$vh);
    $cee7ff159d524e18$var$E($cee7ff159d524e18$var$wh);
}
function $cee7ff159d524e18$var$Ah(a) {
    $cee7ff159d524e18$var$xh($cee7ff159d524e18$var$wh.current);
    var b = $cee7ff159d524e18$var$xh($cee7ff159d524e18$var$uh.current);
    var c = $cee7ff159d524e18$var$lb(b, a.type);
    b !== c && ($cee7ff159d524e18$var$G($cee7ff159d524e18$var$vh, a), $cee7ff159d524e18$var$G($cee7ff159d524e18$var$uh, c));
}
function $cee7ff159d524e18$var$Bh(a) {
    $cee7ff159d524e18$var$vh.current === a && ($cee7ff159d524e18$var$E($cee7ff159d524e18$var$uh), $cee7ff159d524e18$var$E($cee7ff159d524e18$var$vh));
}
var $cee7ff159d524e18$var$L = $cee7ff159d524e18$var$Uf(0);
function $cee7ff159d524e18$var$Ch(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 128)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var $cee7ff159d524e18$var$Dh = [];
function $cee7ff159d524e18$var$Eh() {
    for(var a = 0; a < $cee7ff159d524e18$var$Dh.length; a++)$cee7ff159d524e18$var$Dh[a]._workInProgressVersionPrimary = null;
    $cee7ff159d524e18$var$Dh.length = 0;
}
var $cee7ff159d524e18$var$Fh = $cee7ff159d524e18$var$ua.ReactCurrentDispatcher, $cee7ff159d524e18$var$Gh = $cee7ff159d524e18$var$ua.ReactCurrentBatchConfig, $cee7ff159d524e18$var$Hh = 0, $cee7ff159d524e18$var$M = null, $cee7ff159d524e18$var$N = null, $cee7ff159d524e18$var$O = null, $cee7ff159d524e18$var$Ih = !1, $cee7ff159d524e18$var$Jh = !1, $cee7ff159d524e18$var$Kh = 0, $cee7ff159d524e18$var$Lh = 0;
function $cee7ff159d524e18$var$P() {
    throw Error($cee7ff159d524e18$var$p(321));
}
function $cee7ff159d524e18$var$Mh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$cee7ff159d524e18$var$He(a[c], b[c])) return !1;
    return !0;
}
function $cee7ff159d524e18$var$Nh(a, b, c, d, e, f) {
    $cee7ff159d524e18$var$Hh = f;
    $cee7ff159d524e18$var$M = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    $cee7ff159d524e18$var$Fh.current = null === a || null === a.memoizedState ? $cee7ff159d524e18$var$Oh : $cee7ff159d524e18$var$Ph;
    a = c(d, e);
    if ($cee7ff159d524e18$var$Jh) {
        f = 0;
        do {
            $cee7ff159d524e18$var$Jh = !1;
            $cee7ff159d524e18$var$Kh = 0;
            if (25 <= f) throw Error($cee7ff159d524e18$var$p(301));
            f += 1;
            $cee7ff159d524e18$var$O = $cee7ff159d524e18$var$N = null;
            b.updateQueue = null;
            $cee7ff159d524e18$var$Fh.current = $cee7ff159d524e18$var$Qh;
            a = c(d, e);
        }while ($cee7ff159d524e18$var$Jh);
    }
    $cee7ff159d524e18$var$Fh.current = $cee7ff159d524e18$var$Rh;
    b = null !== $cee7ff159d524e18$var$N && null !== $cee7ff159d524e18$var$N.next;
    $cee7ff159d524e18$var$Hh = 0;
    $cee7ff159d524e18$var$O = $cee7ff159d524e18$var$N = $cee7ff159d524e18$var$M = null;
    $cee7ff159d524e18$var$Ih = !1;
    if (b) throw Error($cee7ff159d524e18$var$p(300));
    return a;
}
function $cee7ff159d524e18$var$Sh() {
    var a = 0 !== $cee7ff159d524e18$var$Kh;
    $cee7ff159d524e18$var$Kh = 0;
    return a;
}
function $cee7ff159d524e18$var$Th() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $cee7ff159d524e18$var$O ? $cee7ff159d524e18$var$M.memoizedState = $cee7ff159d524e18$var$O = a : $cee7ff159d524e18$var$O = $cee7ff159d524e18$var$O.next = a;
    return $cee7ff159d524e18$var$O;
}
function $cee7ff159d524e18$var$Uh() {
    if (null === $cee7ff159d524e18$var$N) {
        var a = $cee7ff159d524e18$var$M.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = $cee7ff159d524e18$var$N.next;
    var b = null === $cee7ff159d524e18$var$O ? $cee7ff159d524e18$var$M.memoizedState : $cee7ff159d524e18$var$O.next;
    if (null !== b) $cee7ff159d524e18$var$O = b, $cee7ff159d524e18$var$N = a;
    else {
        if (null === a) throw Error($cee7ff159d524e18$var$p(310));
        $cee7ff159d524e18$var$N = a;
        a = {
            memoizedState: $cee7ff159d524e18$var$N.memoizedState,
            baseState: $cee7ff159d524e18$var$N.baseState,
            baseQueue: $cee7ff159d524e18$var$N.baseQueue,
            queue: $cee7ff159d524e18$var$N.queue,
            next: null
        };
        null === $cee7ff159d524e18$var$O ? $cee7ff159d524e18$var$M.memoizedState = $cee7ff159d524e18$var$O = a : $cee7ff159d524e18$var$O = $cee7ff159d524e18$var$O.next = a;
    }
    return $cee7ff159d524e18$var$O;
}
function $cee7ff159d524e18$var$Vh(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $cee7ff159d524e18$var$Wh(a) {
    var b = $cee7ff159d524e18$var$Uh(), c = b.queue;
    if (null === c) throw Error($cee7ff159d524e18$var$p(311));
    c.lastRenderedReducer = a;
    var d = $cee7ff159d524e18$var$N, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        f = e.next;
        d = d.baseState;
        var h = g = null, k = null, l = f;
        do {
            var m = l.lane;
            if (($cee7ff159d524e18$var$Hh & m) === m) null !== k && (k = k.next = {
                lane: 0,
                action: l.action,
                hasEagerState: l.hasEagerState,
                eagerState: l.eagerState,
                next: null
            }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
            else {
                var q = {
                    lane: m,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                };
                null === k ? (h = k = q, g = d) : k = k.next = q;
                $cee7ff159d524e18$var$M.lanes |= m;
                $cee7ff159d524e18$var$rh |= m;
            }
            l = l.next;
        }while (null !== l && l !== f);
        null === k ? g = d : k.next = h;
        $cee7ff159d524e18$var$He(d, b.memoizedState) || ($cee7ff159d524e18$var$dh = !0);
        b.memoizedState = d;
        b.baseState = g;
        b.baseQueue = k;
        c.lastRenderedState = d;
    }
    a = c.interleaved;
    if (null !== a) {
        e = a;
        do f = e.lane, $cee7ff159d524e18$var$M.lanes |= f, $cee7ff159d524e18$var$rh |= f, e = e.next;
        while (e !== a);
    } else null === e && (c.lanes = 0);
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function $cee7ff159d524e18$var$Xh(a) {
    var b = $cee7ff159d524e18$var$Uh(), c = b.queue;
    if (null === c) throw Error($cee7ff159d524e18$var$p(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        $cee7ff159d524e18$var$He(f, b.memoizedState) || ($cee7ff159d524e18$var$dh = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function $cee7ff159d524e18$var$Yh() {}
function $cee7ff159d524e18$var$Zh(a, b) {
    var c = $cee7ff159d524e18$var$M, d = $cee7ff159d524e18$var$Uh(), e = b(), f = !$cee7ff159d524e18$var$He(d.memoizedState, e);
    f && (d.memoizedState = e, $cee7ff159d524e18$var$dh = !0);
    d = d.queue;
    $cee7ff159d524e18$var$$h($cee7ff159d524e18$var$ai.bind(null, c, d, a), [
        a
    ]);
    if (d.getSnapshot !== b || f || null !== $cee7ff159d524e18$var$O && $cee7ff159d524e18$var$O.memoizedState.tag & 1) {
        c.flags |= 2048;
        $cee7ff159d524e18$var$bi(9, $cee7ff159d524e18$var$ci.bind(null, c, d, e, b), void 0, null);
        if (null === $cee7ff159d524e18$var$Q) throw Error($cee7ff159d524e18$var$p(349));
        0 !== ($cee7ff159d524e18$var$Hh & 30) || $cee7ff159d524e18$var$di(c, b, e);
    }
    return e;
}
function $cee7ff159d524e18$var$di(a, b, c) {
    a.flags |= 16384;
    a = {
        getSnapshot: b,
        value: c
    };
    b = $cee7ff159d524e18$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $cee7ff159d524e18$var$M.updateQueue = b, b.stores = [
        a
    ]) : (c = b.stores, null === c ? b.stores = [
        a
    ] : c.push(a));
}
function $cee7ff159d524e18$var$ci(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    $cee7ff159d524e18$var$ei(b) && $cee7ff159d524e18$var$fi(a);
}
function $cee7ff159d524e18$var$ai(a, b, c) {
    return c(function() {
        $cee7ff159d524e18$var$ei(b) && $cee7ff159d524e18$var$fi(a);
    });
}
function $cee7ff159d524e18$var$ei(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var c = b();
        return !$cee7ff159d524e18$var$He(a, c);
    } catch (d) {
        return !0;
    }
}
function $cee7ff159d524e18$var$fi(a) {
    var b = $cee7ff159d524e18$var$ih(a, 1);
    null !== b && $cee7ff159d524e18$var$gi(b, a, 1, -1);
}
function $cee7ff159d524e18$var$hi(a) {
    var b = $cee7ff159d524e18$var$Th();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $cee7ff159d524e18$var$Vh,
        lastRenderedState: a
    };
    b.queue = a;
    a = a.dispatch = $cee7ff159d524e18$var$ii.bind(null, $cee7ff159d524e18$var$M, a);
    return [
        b.memoizedState,
        a
    ];
}
function $cee7ff159d524e18$var$bi(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = $cee7ff159d524e18$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $cee7ff159d524e18$var$M.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function $cee7ff159d524e18$var$ji() {
    return $cee7ff159d524e18$var$Uh().memoizedState;
}
function $cee7ff159d524e18$var$ki(a, b, c, d) {
    var e = $cee7ff159d524e18$var$Th();
    $cee7ff159d524e18$var$M.flags |= a;
    e.memoizedState = $cee7ff159d524e18$var$bi(1 | b, c, void 0, void 0 === d ? null : d);
}
function $cee7ff159d524e18$var$li(a, b, c, d) {
    var e = $cee7ff159d524e18$var$Uh();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== $cee7ff159d524e18$var$N) {
        var g = $cee7ff159d524e18$var$N.memoizedState;
        f = g.destroy;
        if (null !== d && $cee7ff159d524e18$var$Mh(d, g.deps)) {
            e.memoizedState = $cee7ff159d524e18$var$bi(b, c, f, d);
            return;
        }
    }
    $cee7ff159d524e18$var$M.flags |= a;
    e.memoizedState = $cee7ff159d524e18$var$bi(1 | b, c, f, d);
}
function $cee7ff159d524e18$var$mi(a, b) {
    return $cee7ff159d524e18$var$ki(8390656, 8, a, b);
}
function $cee7ff159d524e18$var$$h(a, b) {
    return $cee7ff159d524e18$var$li(2048, 8, a, b);
}
function $cee7ff159d524e18$var$ni(a, b) {
    return $cee7ff159d524e18$var$li(4, 2, a, b);
}
function $cee7ff159d524e18$var$oi(a, b) {
    return $cee7ff159d524e18$var$li(4, 4, a, b);
}
function $cee7ff159d524e18$var$pi(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $cee7ff159d524e18$var$qi(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return $cee7ff159d524e18$var$li(4, 4, $cee7ff159d524e18$var$pi.bind(null, b, a), c);
}
function $cee7ff159d524e18$var$ri() {}
function $cee7ff159d524e18$var$si(a, b) {
    var c = $cee7ff159d524e18$var$Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $cee7ff159d524e18$var$Mh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $cee7ff159d524e18$var$ti(a, b) {
    var c = $cee7ff159d524e18$var$Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $cee7ff159d524e18$var$Mh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $cee7ff159d524e18$var$ui(a, b, c) {
    if (0 === ($cee7ff159d524e18$var$Hh & 21)) return a.baseState && (a.baseState = !1, $cee7ff159d524e18$var$dh = !0), a.memoizedState = c;
    $cee7ff159d524e18$var$He(c, b) || (c = $cee7ff159d524e18$var$yc(), $cee7ff159d524e18$var$M.lanes |= c, $cee7ff159d524e18$var$rh |= c, a.baseState = !0);
    return b;
}
function $cee7ff159d524e18$var$vi(a, b) {
    var c = $cee7ff159d524e18$var$C;
    $cee7ff159d524e18$var$C = 0 !== c && 4 > c ? c : 4;
    a(!0);
    var d = $cee7ff159d524e18$var$Gh.transition;
    $cee7ff159d524e18$var$Gh.transition = {};
    try {
        a(!1), b();
    } finally{
        $cee7ff159d524e18$var$C = c, $cee7ff159d524e18$var$Gh.transition = d;
    }
}
function $cee7ff159d524e18$var$wi() {
    return $cee7ff159d524e18$var$Uh().memoizedState;
}
function $cee7ff159d524e18$var$xi(a, b, c) {
    var d = $cee7ff159d524e18$var$yi(a);
    c = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($cee7ff159d524e18$var$zi(a)) $cee7ff159d524e18$var$Ai(b, c);
    else if (c = $cee7ff159d524e18$var$hh(a, b, c, d), null !== c) {
        var e = $cee7ff159d524e18$var$R();
        $cee7ff159d524e18$var$gi(c, a, d, e);
        $cee7ff159d524e18$var$Bi(c, b, d);
    }
}
function $cee7ff159d524e18$var$ii(a, b, c) {
    var d = $cee7ff159d524e18$var$yi(a), e = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($cee7ff159d524e18$var$zi(a)) $cee7ff159d524e18$var$Ai(b, e);
    else {
        var f = a.alternate;
        if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.hasEagerState = !0;
            e.eagerState = h;
            if ($cee7ff159d524e18$var$He(h, g)) {
                var k = b.interleaved;
                null === k ? (e.next = e, $cee7ff159d524e18$var$gh(b)) : (e.next = k.next, k.next = e);
                b.interleaved = e;
                return;
            }
        } catch (l) {} finally{}
        c = $cee7ff159d524e18$var$hh(a, b, e, d);
        null !== c && (e = $cee7ff159d524e18$var$R(), $cee7ff159d524e18$var$gi(c, a, d, e), $cee7ff159d524e18$var$Bi(c, b, d));
    }
}
function $cee7ff159d524e18$var$zi(a) {
    var b = a.alternate;
    return a === $cee7ff159d524e18$var$M || null !== b && b === $cee7ff159d524e18$var$M;
}
function $cee7ff159d524e18$var$Ai(a, b) {
    $cee7ff159d524e18$var$Jh = $cee7ff159d524e18$var$Ih = !0;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
}
function $cee7ff159d524e18$var$Bi(a, b, c) {
    if (0 !== (c & 4194240)) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $cee7ff159d524e18$var$Cc(a, c);
    }
}
var $cee7ff159d524e18$var$Rh = {
    readContext: $cee7ff159d524e18$var$eh,
    useCallback: $cee7ff159d524e18$var$P,
    useContext: $cee7ff159d524e18$var$P,
    useEffect: $cee7ff159d524e18$var$P,
    useImperativeHandle: $cee7ff159d524e18$var$P,
    useInsertionEffect: $cee7ff159d524e18$var$P,
    useLayoutEffect: $cee7ff159d524e18$var$P,
    useMemo: $cee7ff159d524e18$var$P,
    useReducer: $cee7ff159d524e18$var$P,
    useRef: $cee7ff159d524e18$var$P,
    useState: $cee7ff159d524e18$var$P,
    useDebugValue: $cee7ff159d524e18$var$P,
    useDeferredValue: $cee7ff159d524e18$var$P,
    useTransition: $cee7ff159d524e18$var$P,
    useMutableSource: $cee7ff159d524e18$var$P,
    useSyncExternalStore: $cee7ff159d524e18$var$P,
    useId: $cee7ff159d524e18$var$P,
    unstable_isNewReconciler: !1
}, $cee7ff159d524e18$var$Oh = {
    readContext: $cee7ff159d524e18$var$eh,
    useCallback: function(a, b) {
        $cee7ff159d524e18$var$Th().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: $cee7ff159d524e18$var$eh,
    useEffect: $cee7ff159d524e18$var$mi,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return $cee7ff159d524e18$var$ki(4194308, 4, $cee7ff159d524e18$var$pi.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return $cee7ff159d524e18$var$ki(4194308, 4, a, b);
    },
    useInsertionEffect: function(a, b) {
        return $cee7ff159d524e18$var$ki(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = $cee7ff159d524e18$var$Th();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = $cee7ff159d524e18$var$Th();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        d.queue = a;
        a = a.dispatch = $cee7ff159d524e18$var$xi.bind(null, $cee7ff159d524e18$var$M, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function(a) {
        var b = $cee7ff159d524e18$var$Th();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: $cee7ff159d524e18$var$hi,
    useDebugValue: $cee7ff159d524e18$var$ri,
    useDeferredValue: function(a) {
        return $cee7ff159d524e18$var$Th().memoizedState = a;
    },
    useTransition: function() {
        var a = $cee7ff159d524e18$var$hi(!1), b = a[0];
        a = $cee7ff159d524e18$var$vi.bind(null, a[1]);
        $cee7ff159d524e18$var$Th().memoizedState = a;
        return [
            b,
            a
        ];
    },
    useMutableSource: function() {},
    useSyncExternalStore: function(a, b, c) {
        var d = $cee7ff159d524e18$var$M, e = $cee7ff159d524e18$var$Th();
        if ($cee7ff159d524e18$var$I) {
            if (void 0 === c) throw Error($cee7ff159d524e18$var$p(407));
            c = c();
        } else {
            c = b();
            if (null === $cee7ff159d524e18$var$Q) throw Error($cee7ff159d524e18$var$p(349));
            0 !== ($cee7ff159d524e18$var$Hh & 30) || $cee7ff159d524e18$var$di(d, b, c);
        }
        e.memoizedState = c;
        var f = {
            value: c,
            getSnapshot: b
        };
        e.queue = f;
        $cee7ff159d524e18$var$mi($cee7ff159d524e18$var$ai.bind(null, d, f, a), [
            a
        ]);
        d.flags |= 2048;
        $cee7ff159d524e18$var$bi(9, $cee7ff159d524e18$var$ci.bind(null, d, f, c, b), void 0, null);
        return c;
    },
    useId: function() {
        var a = $cee7ff159d524e18$var$Th(), b = $cee7ff159d524e18$var$Q.identifierPrefix;
        if ($cee7ff159d524e18$var$I) {
            var c = $cee7ff159d524e18$var$sg;
            var d = $cee7ff159d524e18$var$rg;
            c = (d & ~(1 << 32 - $cee7ff159d524e18$var$oc(d) - 1)).toString(32) + c;
            b = ":" + b + "R" + c;
            c = $cee7ff159d524e18$var$Kh++;
            0 < c && (b += "H" + c.toString(32));
            b += ":";
        } else c = $cee7ff159d524e18$var$Lh++, b = ":" + b + "r" + c.toString(32) + ":";
        return a.memoizedState = b;
    },
    unstable_isNewReconciler: !1
}, $cee7ff159d524e18$var$Ph = {
    readContext: $cee7ff159d524e18$var$eh,
    useCallback: $cee7ff159d524e18$var$si,
    useContext: $cee7ff159d524e18$var$eh,
    useEffect: $cee7ff159d524e18$var$$h,
    useImperativeHandle: $cee7ff159d524e18$var$qi,
    useInsertionEffect: $cee7ff159d524e18$var$ni,
    useLayoutEffect: $cee7ff159d524e18$var$oi,
    useMemo: $cee7ff159d524e18$var$ti,
    useReducer: $cee7ff159d524e18$var$Wh,
    useRef: $cee7ff159d524e18$var$ji,
    useState: function() {
        return $cee7ff159d524e18$var$Wh($cee7ff159d524e18$var$Vh);
    },
    useDebugValue: $cee7ff159d524e18$var$ri,
    useDeferredValue: function(a) {
        var b = $cee7ff159d524e18$var$Uh();
        return $cee7ff159d524e18$var$ui(b, $cee7ff159d524e18$var$N.memoizedState, a);
    },
    useTransition: function() {
        var a = $cee7ff159d524e18$var$Wh($cee7ff159d524e18$var$Vh)[0], b = $cee7ff159d524e18$var$Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $cee7ff159d524e18$var$Yh,
    useSyncExternalStore: $cee7ff159d524e18$var$Zh,
    useId: $cee7ff159d524e18$var$wi,
    unstable_isNewReconciler: !1
}, $cee7ff159d524e18$var$Qh = {
    readContext: $cee7ff159d524e18$var$eh,
    useCallback: $cee7ff159d524e18$var$si,
    useContext: $cee7ff159d524e18$var$eh,
    useEffect: $cee7ff159d524e18$var$$h,
    useImperativeHandle: $cee7ff159d524e18$var$qi,
    useInsertionEffect: $cee7ff159d524e18$var$ni,
    useLayoutEffect: $cee7ff159d524e18$var$oi,
    useMemo: $cee7ff159d524e18$var$ti,
    useReducer: $cee7ff159d524e18$var$Xh,
    useRef: $cee7ff159d524e18$var$ji,
    useState: function() {
        return $cee7ff159d524e18$var$Xh($cee7ff159d524e18$var$Vh);
    },
    useDebugValue: $cee7ff159d524e18$var$ri,
    useDeferredValue: function(a) {
        var b = $cee7ff159d524e18$var$Uh();
        return null === $cee7ff159d524e18$var$N ? b.memoizedState = a : $cee7ff159d524e18$var$ui(b, $cee7ff159d524e18$var$N.memoizedState, a);
    },
    useTransition: function() {
        var a = $cee7ff159d524e18$var$Xh($cee7ff159d524e18$var$Vh)[0], b = $cee7ff159d524e18$var$Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $cee7ff159d524e18$var$Yh,
    useSyncExternalStore: $cee7ff159d524e18$var$Zh,
    useId: $cee7ff159d524e18$var$wi,
    unstable_isNewReconciler: !1
};
function $cee7ff159d524e18$var$Ci(a, b) {
    if (a && a.defaultProps) {
        b = $cee7ff159d524e18$var$A({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
function $cee7ff159d524e18$var$Di(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $cee7ff159d524e18$var$A({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var $cee7ff159d524e18$var$Ei = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? $cee7ff159d524e18$var$Vb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = $cee7ff159d524e18$var$R(), e = $cee7ff159d524e18$var$yi(a), f = $cee7ff159d524e18$var$mh(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $cee7ff159d524e18$var$nh(a, f, e);
        null !== b && ($cee7ff159d524e18$var$gi(b, a, e, d), $cee7ff159d524e18$var$oh(b, a, e));
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = $cee7ff159d524e18$var$R(), e = $cee7ff159d524e18$var$yi(a), f = $cee7ff159d524e18$var$mh(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $cee7ff159d524e18$var$nh(a, f, e);
        null !== b && ($cee7ff159d524e18$var$gi(b, a, e, d), $cee7ff159d524e18$var$oh(b, a, e));
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = $cee7ff159d524e18$var$R(), d = $cee7ff159d524e18$var$yi(a), e = $cee7ff159d524e18$var$mh(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        b = $cee7ff159d524e18$var$nh(a, e, d);
        null !== b && ($cee7ff159d524e18$var$gi(b, a, d, c), $cee7ff159d524e18$var$oh(b, a, d));
    }
};
function $cee7ff159d524e18$var$Fi(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !$cee7ff159d524e18$var$Ie(c, d) || !$cee7ff159d524e18$var$Ie(e, f) : !0;
}
function $cee7ff159d524e18$var$Gi(a, b, c) {
    var d = !1, e = $cee7ff159d524e18$var$Vf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = $cee7ff159d524e18$var$eh(f) : (e = $cee7ff159d524e18$var$Zf(b) ? $cee7ff159d524e18$var$Xf : $cee7ff159d524e18$var$H.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? $cee7ff159d524e18$var$Yf(a, e) : $cee7ff159d524e18$var$Vf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = $cee7ff159d524e18$var$Ei;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function $cee7ff159d524e18$var$Hi(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && $cee7ff159d524e18$var$Ei.enqueueReplaceState(b, b.state, null);
}
function $cee7ff159d524e18$var$Ii(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = {};
    $cee7ff159d524e18$var$kh(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = $cee7ff159d524e18$var$eh(f) : (f = $cee7ff159d524e18$var$Zf(b) ? $cee7ff159d524e18$var$Xf : $cee7ff159d524e18$var$H.current, e.context = $cee7ff159d524e18$var$Yf(a, f));
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && ($cee7ff159d524e18$var$Di(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && $cee7ff159d524e18$var$Ei.enqueueReplaceState(e, e.state, null), $cee7ff159d524e18$var$qh(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
function $cee7ff159d524e18$var$Ji(a, b) {
    try {
        var c = "", d = b;
        do c += $cee7ff159d524e18$var$Pa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e,
        digest: null
    };
}
function $cee7ff159d524e18$var$Ki(a, b, c) {
    return {
        value: a,
        source: null,
        stack: null != c ? c : null,
        digest: null != b ? b : null
    };
}
function $cee7ff159d524e18$var$Li(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var $cee7ff159d524e18$var$Mi = "function" === typeof WeakMap ? WeakMap : Map;
function $cee7ff159d524e18$var$Ni(a, b, c) {
    c = $cee7ff159d524e18$var$mh(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        $cee7ff159d524e18$var$Oi || ($cee7ff159d524e18$var$Oi = !0, $cee7ff159d524e18$var$Pi = d);
        $cee7ff159d524e18$var$Li(a, b);
    };
    return c;
}
function $cee7ff159d524e18$var$Qi(a, b, c) {
    c = $cee7ff159d524e18$var$mh(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
        c.callback = function() {
            $cee7ff159d524e18$var$Li(a, b);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        $cee7ff159d524e18$var$Li(a, b);
        "function" !== typeof d && (null === $cee7ff159d524e18$var$Ri ? $cee7ff159d524e18$var$Ri = new Set([
            this
        ]) : $cee7ff159d524e18$var$Ri.add(this));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
function $cee7ff159d524e18$var$Si(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
        d = a.pingCache = new $cee7ff159d524e18$var$Mi;
        var e = new Set;
        d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
    e.has(c) || (e.add(c), a = $cee7ff159d524e18$var$Ti.bind(null, a, b, c), b.then(a, a));
}
function $cee7ff159d524e18$var$Ui(a) {
    do {
        var b;
        if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
        if (b) return a;
        a = a.return;
    }while (null !== a);
    return null;
}
function $cee7ff159d524e18$var$Vi(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = $cee7ff159d524e18$var$mh(-1, 1), b.tag = 2, $cee7ff159d524e18$var$nh(c, b, 1))), c.lanes |= 1), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
}
var $cee7ff159d524e18$var$Wi = $cee7ff159d524e18$var$ua.ReactCurrentOwner, $cee7ff159d524e18$var$dh = !1;
function $cee7ff159d524e18$var$Xi(a, b, c, d) {
    b.child = null === a ? $cee7ff159d524e18$var$Vg(b, null, c, d) : $cee7ff159d524e18$var$Ug(b, a.child, c, d);
}
function $cee7ff159d524e18$var$Yi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    $cee7ff159d524e18$var$ch(b, e);
    d = $cee7ff159d524e18$var$Nh(a, b, c, d, f, e);
    c = $cee7ff159d524e18$var$Sh();
    if (null !== a && !$cee7ff159d524e18$var$dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $cee7ff159d524e18$var$Zi(a, b, e);
    $cee7ff159d524e18$var$I && c && $cee7ff159d524e18$var$vg(b);
    b.flags |= 1;
    $cee7ff159d524e18$var$Xi(a, b, d, e);
    return b.child;
}
function $cee7ff159d524e18$var$$i(a, b, c, d, e) {
    if (null === a) {
        var f = c.type;
        if ("function" === typeof f && !$cee7ff159d524e18$var$aj(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, $cee7ff159d524e18$var$bj(a, b, f, d, e);
        a = $cee7ff159d524e18$var$Rg(c.type, null, d, b, b.mode, e);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    f = a.child;
    if (0 === (a.lanes & e)) {
        var g = f.memoizedProps;
        c = c.compare;
        c = null !== c ? c : $cee7ff159d524e18$var$Ie;
        if (c(g, d) && a.ref === b.ref) return $cee7ff159d524e18$var$Zi(a, b, e);
    }
    b.flags |= 1;
    a = $cee7ff159d524e18$var$Pg(f, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function $cee7ff159d524e18$var$bj(a, b, c, d, e) {
    if (null !== a) {
        var f = a.memoizedProps;
        if ($cee7ff159d524e18$var$Ie(f, d) && a.ref === b.ref) {
            if ($cee7ff159d524e18$var$dh = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && ($cee7ff159d524e18$var$dh = !0);
            else return b.lanes = a.lanes, $cee7ff159d524e18$var$Zi(a, b, e);
        }
    }
    return $cee7ff159d524e18$var$cj(a, b, c, d, e);
}
function $cee7ff159d524e18$var$dj(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode) {
        if (0 === (b.mode & 1)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, $cee7ff159d524e18$var$G($cee7ff159d524e18$var$ej, $cee7ff159d524e18$var$fj), $cee7ff159d524e18$var$fj |= c;
        else {
            if (0 === (c & 1073741824)) return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a,
                cachePool: null,
                transitions: null
            }, b.updateQueue = null, $cee7ff159d524e18$var$G($cee7ff159d524e18$var$ej, $cee7ff159d524e18$var$fj), $cee7ff159d524e18$var$fj |= a, null;
            b.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null
            };
            d = null !== f ? f.baseLanes : c;
            $cee7ff159d524e18$var$G($cee7ff159d524e18$var$ej, $cee7ff159d524e18$var$fj);
            $cee7ff159d524e18$var$fj |= d;
        }
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, $cee7ff159d524e18$var$G($cee7ff159d524e18$var$ej, $cee7ff159d524e18$var$fj), $cee7ff159d524e18$var$fj |= d;
    $cee7ff159d524e18$var$Xi(a, b, e, c);
    return b.child;
}
function $cee7ff159d524e18$var$gj(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function $cee7ff159d524e18$var$cj(a, b, c, d, e) {
    var f = $cee7ff159d524e18$var$Zf(c) ? $cee7ff159d524e18$var$Xf : $cee7ff159d524e18$var$H.current;
    f = $cee7ff159d524e18$var$Yf(b, f);
    $cee7ff159d524e18$var$ch(b, e);
    c = $cee7ff159d524e18$var$Nh(a, b, c, d, f, e);
    d = $cee7ff159d524e18$var$Sh();
    if (null !== a && !$cee7ff159d524e18$var$dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $cee7ff159d524e18$var$Zi(a, b, e);
    $cee7ff159d524e18$var$I && d && $cee7ff159d524e18$var$vg(b);
    b.flags |= 1;
    $cee7ff159d524e18$var$Xi(a, b, c, e);
    return b.child;
}
function $cee7ff159d524e18$var$hj(a, b, c, d, e) {
    if ($cee7ff159d524e18$var$Zf(c)) {
        var f = !0;
        $cee7ff159d524e18$var$cg(b);
    } else f = !1;
    $cee7ff159d524e18$var$ch(b, e);
    if (null === b.stateNode) $cee7ff159d524e18$var$ij(a, b), $cee7ff159d524e18$var$Gi(b, c, d), $cee7ff159d524e18$var$Ii(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = $cee7ff159d524e18$var$eh(l) : (l = $cee7ff159d524e18$var$Zf(c) ? $cee7ff159d524e18$var$Xf : $cee7ff159d524e18$var$H.current, l = $cee7ff159d524e18$var$Yf(b, l));
        var m = c.getDerivedStateFromProps, q = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        q || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && $cee7ff159d524e18$var$Hi(b, g, d, l);
        $cee7ff159d524e18$var$jh = !1;
        var r = b.memoizedState;
        g.state = r;
        $cee7ff159d524e18$var$qh(b, d, g, e);
        k = b.memoizedState;
        h !== d || r !== k || $cee7ff159d524e18$var$Wf.current || $cee7ff159d524e18$var$jh ? ("function" === typeof m && ($cee7ff159d524e18$var$Di(b, c, m, d), k = b.memoizedState), (h = $cee7ff159d524e18$var$jh || $cee7ff159d524e18$var$Fi(b, c, h, d, r, k, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
    } else {
        g = b.stateNode;
        $cee7ff159d524e18$var$lh(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : $cee7ff159d524e18$var$Ci(b.type, h);
        g.props = l;
        q = b.pendingProps;
        r = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = $cee7ff159d524e18$var$eh(k) : (k = $cee7ff159d524e18$var$Zf(c) ? $cee7ff159d524e18$var$Xf : $cee7ff159d524e18$var$H.current, k = $cee7ff159d524e18$var$Yf(b, k));
        var y = c.getDerivedStateFromProps;
        (m = "function" === typeof y || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== q || r !== k) && $cee7ff159d524e18$var$Hi(b, g, d, k);
        $cee7ff159d524e18$var$jh = !1;
        r = b.memoizedState;
        g.state = r;
        $cee7ff159d524e18$var$qh(b, d, g, e);
        var n = b.memoizedState;
        h !== q || r !== n || $cee7ff159d524e18$var$Wf.current || $cee7ff159d524e18$var$jh ? ("function" === typeof y && ($cee7ff159d524e18$var$Di(b, c, y, d), n = b.memoizedState), (l = $cee7ff159d524e18$var$jh || $cee7ff159d524e18$var$Fi(b, c, l, d, r, n, k) || !1) ? (m || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, n, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, n, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = n), g.props = d, g.state = n, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), d = !1);
    }
    return $cee7ff159d524e18$var$jj(a, b, c, d, f, e);
}
function $cee7ff159d524e18$var$jj(a, b, c, d, e, f) {
    $cee7ff159d524e18$var$gj(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && $cee7ff159d524e18$var$dg(b, c, !1), $cee7ff159d524e18$var$Zi(a, b, f);
    d = b.stateNode;
    $cee7ff159d524e18$var$Wi.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = $cee7ff159d524e18$var$Ug(b, a.child, null, f), b.child = $cee7ff159d524e18$var$Ug(b, null, h, f)) : $cee7ff159d524e18$var$Xi(a, b, h, f);
    b.memoizedState = d.state;
    e && $cee7ff159d524e18$var$dg(b, c, !0);
    return b.child;
}
function $cee7ff159d524e18$var$kj(a) {
    var b = a.stateNode;
    b.pendingContext ? $cee7ff159d524e18$var$ag(a, b.pendingContext, b.pendingContext !== b.context) : b.context && $cee7ff159d524e18$var$ag(a, b.context, !1);
    $cee7ff159d524e18$var$yh(a, b.containerInfo);
}
function $cee7ff159d524e18$var$lj(a, b, c, d, e) {
    $cee7ff159d524e18$var$Ig();
    $cee7ff159d524e18$var$Jg(e);
    b.flags |= 256;
    $cee7ff159d524e18$var$Xi(a, b, c, d);
    return b.child;
}
var $cee7ff159d524e18$var$mj = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function $cee7ff159d524e18$var$nj(a) {
    return {
        baseLanes: a,
        cachePool: null,
        transitions: null
    };
}
function $cee7ff159d524e18$var$oj(a, b, c) {
    var d = b.pendingProps, e = $cee7ff159d524e18$var$L.current, f = !1, g = 0 !== (b.flags & 128), h;
    (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    if (h) f = !0, b.flags &= -129;
    else if (null === a || null !== a.memoizedState) e |= 1;
    $cee7ff159d524e18$var$G($cee7ff159d524e18$var$L, e & 1);
    if (null === a) {
        $cee7ff159d524e18$var$Eg(b);
        a = b.memoizedState;
        if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
        g = d.children;
        a = d.fallback;
        return f ? (d = b.mode, f = b.child, g = {
            mode: "hidden",
            children: g
        }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = g) : f = $cee7ff159d524e18$var$pj(g, d, 0, null), a = $cee7ff159d524e18$var$Tg(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = $cee7ff159d524e18$var$nj(c), b.memoizedState = $cee7ff159d524e18$var$mj, a) : $cee7ff159d524e18$var$qj(b, g);
    }
    e = a.memoizedState;
    if (null !== e && (h = e.dehydrated, null !== h)) return $cee7ff159d524e18$var$rj(a, b, g, d, h, e, c);
    if (f) {
        f = d.fallback;
        g = b.mode;
        e = a.child;
        h = e.sibling;
        var k = {
            mode: "hidden",
            children: d.children
        };
        0 === (g & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k, b.deletions = null) : (d = $cee7ff159d524e18$var$Pg(e, k), d.subtreeFlags = e.subtreeFlags & 14680064);
        null !== h ? f = $cee7ff159d524e18$var$Pg(h, f) : (f = $cee7ff159d524e18$var$Tg(f, g, c, null), f.flags |= 2);
        f.return = b;
        d.return = b;
        d.sibling = f;
        b.child = d;
        d = f;
        f = b.child;
        g = a.child.memoizedState;
        g = null === g ? $cee7ff159d524e18$var$nj(c) : {
            baseLanes: g.baseLanes | c,
            cachePool: null,
            transitions: g.transitions
        };
        f.memoizedState = g;
        f.childLanes = a.childLanes & ~c;
        b.memoizedState = $cee7ff159d524e18$var$mj;
        return d;
    }
    f = a.child;
    a = f.sibling;
    d = $cee7ff159d524e18$var$Pg(f, {
        mode: "visible",
        children: d.children
    });
    0 === (b.mode & 1) && (d.lanes = c);
    d.return = b;
    d.sibling = null;
    null !== a && (c = b.deletions, null === c ? (b.deletions = [
        a
    ], b.flags |= 16) : c.push(a));
    b.child = d;
    b.memoizedState = null;
    return d;
}
function $cee7ff159d524e18$var$qj(a, b) {
    b = $cee7ff159d524e18$var$pj({
        mode: "visible",
        children: b
    }, a.mode, 0, null);
    b.return = a;
    return a.child = b;
}
function $cee7ff159d524e18$var$sj(a, b, c, d) {
    null !== d && $cee7ff159d524e18$var$Jg(d);
    $cee7ff159d524e18$var$Ug(b, a.child, null, c);
    a = $cee7ff159d524e18$var$qj(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
}
function $cee7ff159d524e18$var$rj(a, b, c, d, e, f, g) {
    if (c) {
        if (b.flags & 256) return b.flags &= -257, d = $cee7ff159d524e18$var$Ki(Error($cee7ff159d524e18$var$p(422))), $cee7ff159d524e18$var$sj(a, b, g, d);
        if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
        f = d.fallback;
        e = b.mode;
        d = $cee7ff159d524e18$var$pj({
            mode: "visible",
            children: d.children
        }, e, 0, null);
        f = $cee7ff159d524e18$var$Tg(f, e, g, null);
        f.flags |= 2;
        d.return = b;
        f.return = b;
        d.sibling = f;
        b.child = d;
        0 !== (b.mode & 1) && $cee7ff159d524e18$var$Ug(b, a.child, null, g);
        b.child.memoizedState = $cee7ff159d524e18$var$nj(g);
        b.memoizedState = $cee7ff159d524e18$var$mj;
        return f;
    }
    if (0 === (b.mode & 1)) return $cee7ff159d524e18$var$sj(a, b, g, null);
    if ("$!" === e.data) {
        d = e.nextSibling && e.nextSibling.dataset;
        if (d) var h = d.dgst;
        d = h;
        f = Error($cee7ff159d524e18$var$p(419));
        d = $cee7ff159d524e18$var$Ki(f, d, void 0);
        return $cee7ff159d524e18$var$sj(a, b, g, d);
    }
    h = 0 !== (g & a.childLanes);
    if ($cee7ff159d524e18$var$dh || h) {
        d = $cee7ff159d524e18$var$Q;
        if (null !== d) {
            switch(g & -g){
                case 4:
                    e = 2;
                    break;
                case 16:
                    e = 8;
                    break;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                    e = 32;
                    break;
                case 536870912:
                    e = 268435456;
                    break;
                default:
                    e = 0;
            }
            e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
            0 !== e && e !== f.retryLane && (f.retryLane = e, $cee7ff159d524e18$var$ih(a, e), $cee7ff159d524e18$var$gi(d, a, e, -1));
        }
        $cee7ff159d524e18$var$tj();
        d = $cee7ff159d524e18$var$Ki(Error($cee7ff159d524e18$var$p(421)));
        return $cee7ff159d524e18$var$sj(a, b, g, d);
    }
    if ("$?" === e.data) return b.flags |= 128, b.child = a.child, b = $cee7ff159d524e18$var$uj.bind(null, a), e._reactRetry = b, null;
    a = f.treeContext;
    $cee7ff159d524e18$var$yg = $cee7ff159d524e18$var$Lf(e.nextSibling);
    $cee7ff159d524e18$var$xg = b;
    $cee7ff159d524e18$var$I = !0;
    $cee7ff159d524e18$var$zg = null;
    null !== a && ($cee7ff159d524e18$var$og[$cee7ff159d524e18$var$pg++] = $cee7ff159d524e18$var$rg, $cee7ff159d524e18$var$og[$cee7ff159d524e18$var$pg++] = $cee7ff159d524e18$var$sg, $cee7ff159d524e18$var$og[$cee7ff159d524e18$var$pg++] = $cee7ff159d524e18$var$qg, $cee7ff159d524e18$var$rg = a.id, $cee7ff159d524e18$var$sg = a.overflow, $cee7ff159d524e18$var$qg = b);
    b = $cee7ff159d524e18$var$qj(b, d.children);
    b.flags |= 4096;
    return b;
}
function $cee7ff159d524e18$var$vj(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    $cee7ff159d524e18$var$bh(a.return, b, c);
}
function $cee7ff159d524e18$var$wj(a, b, c, d, e) {
    var f = a.memoizedState;
    null === f ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e
    } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}
function $cee7ff159d524e18$var$xj(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    $cee7ff159d524e18$var$Xi(a, b, d.children, c);
    d = $cee7ff159d524e18$var$L.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
        if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && $cee7ff159d524e18$var$vj(a, c, b);
            else if (19 === a.tag) $cee7ff159d524e18$var$vj(a, c, b);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    $cee7ff159d524e18$var$G($cee7ff159d524e18$var$L, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === $cee7ff159d524e18$var$Ch(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            $cee7ff159d524e18$var$wj(b, !1, e, c, f);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === $cee7ff159d524e18$var$Ch(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            $cee7ff159d524e18$var$wj(b, !0, c, null, f);
            break;
        case "together":
            $cee7ff159d524e18$var$wj(b, !1, null, null, void 0);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $cee7ff159d524e18$var$ij(a, b) {
    0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
}
function $cee7ff159d524e18$var$Zi(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    $cee7ff159d524e18$var$rh |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error($cee7ff159d524e18$var$p(153));
    if (null !== b.child) {
        a = b.child;
        c = $cee7ff159d524e18$var$Pg(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = $cee7ff159d524e18$var$Pg(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
function $cee7ff159d524e18$var$yj(a, b, c) {
    switch(b.tag){
        case 3:
            $cee7ff159d524e18$var$kj(b);
            $cee7ff159d524e18$var$Ig();
            break;
        case 5:
            $cee7ff159d524e18$var$Ah(b);
            break;
        case 1:
            $cee7ff159d524e18$var$Zf(b.type) && $cee7ff159d524e18$var$cg(b);
            break;
        case 4:
            $cee7ff159d524e18$var$yh(b, b.stateNode.containerInfo);
            break;
        case 10:
            var d = b.type._context, e = b.memoizedProps.value;
            $cee7ff159d524e18$var$G($cee7ff159d524e18$var$Wg, d._currentValue);
            d._currentValue = e;
            break;
        case 13:
            d = b.memoizedState;
            if (null !== d) {
                if (null !== d.dehydrated) return $cee7ff159d524e18$var$G($cee7ff159d524e18$var$L, $cee7ff159d524e18$var$L.current & 1), b.flags |= 128, null;
                if (0 !== (c & b.child.childLanes)) return $cee7ff159d524e18$var$oj(a, b, c);
                $cee7ff159d524e18$var$G($cee7ff159d524e18$var$L, $cee7ff159d524e18$var$L.current & 1);
                a = $cee7ff159d524e18$var$Zi(a, b, c);
                return null !== a ? a.sibling : null;
            }
            $cee7ff159d524e18$var$G($cee7ff159d524e18$var$L, $cee7ff159d524e18$var$L.current & 1);
            break;
        case 19:
            d = 0 !== (c & b.childLanes);
            if (0 !== (a.flags & 128)) {
                if (d) return $cee7ff159d524e18$var$xj(a, b, c);
                b.flags |= 128;
            }
            e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
            $cee7ff159d524e18$var$G($cee7ff159d524e18$var$L, $cee7ff159d524e18$var$L.current);
            if (d) break;
            else return null;
        case 22:
        case 23:
            return b.lanes = 0, $cee7ff159d524e18$var$dj(a, b, c);
    }
    return $cee7ff159d524e18$var$Zi(a, b, c);
}
var $cee7ff159d524e18$var$zj, $cee7ff159d524e18$var$Aj, $cee7ff159d524e18$var$Bj, $cee7ff159d524e18$var$Cj;
$cee7ff159d524e18$var$zj = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
$cee7ff159d524e18$var$Aj = function() {};
$cee7ff159d524e18$var$Bj = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        $cee7ff159d524e18$var$xh($cee7ff159d524e18$var$uh.current);
        var f = null;
        switch(c){
            case "input":
                e = $cee7ff159d524e18$var$Ya(a, e);
                d = $cee7ff159d524e18$var$Ya(a, d);
                f = [];
                break;
            case "select":
                e = $cee7ff159d524e18$var$A({}, e, {
                    value: void 0
                });
                d = $cee7ff159d524e18$var$A({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = $cee7ff159d524e18$var$gb(a, e);
                d = $cee7ff159d524e18$var$gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = $cee7ff159d524e18$var$Bf);
        }
        $cee7ff159d524e18$var$ub(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && ($cee7ff159d524e18$var$ea.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && ($cee7ff159d524e18$var$ea.hasOwnProperty(l) ? (null != k && "onScroll" === l && $cee7ff159d524e18$var$D("scroll", a), f || h === k || (f = [])) : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
$cee7ff159d524e18$var$Cj = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function $cee7ff159d524e18$var$Dj(a, b) {
    if (!$cee7ff159d524e18$var$I) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function $cee7ff159d524e18$var$S(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) for(var e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
    else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
}
function $cee7ff159d524e18$var$Ej(a, b, c) {
    var d = b.pendingProps;
    $cee7ff159d524e18$var$wg(b);
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $cee7ff159d524e18$var$S(b), null;
        case 1:
            return $cee7ff159d524e18$var$Zf(b.type) && $cee7ff159d524e18$var$$f(), $cee7ff159d524e18$var$S(b), null;
        case 3:
            d = b.stateNode;
            $cee7ff159d524e18$var$zh();
            $cee7ff159d524e18$var$E($cee7ff159d524e18$var$Wf);
            $cee7ff159d524e18$var$E($cee7ff159d524e18$var$H);
            $cee7ff159d524e18$var$Eh();
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) $cee7ff159d524e18$var$Gg(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== $cee7ff159d524e18$var$zg && ($cee7ff159d524e18$var$Fj($cee7ff159d524e18$var$zg), $cee7ff159d524e18$var$zg = null));
            $cee7ff159d524e18$var$Aj(a, b);
            $cee7ff159d524e18$var$S(b);
            return null;
        case 5:
            $cee7ff159d524e18$var$Bh(b);
            var e = $cee7ff159d524e18$var$xh($cee7ff159d524e18$var$wh.current);
            c = b.type;
            if (null !== a && null != b.stateNode) $cee7ff159d524e18$var$Bj(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error($cee7ff159d524e18$var$p(166));
                    $cee7ff159d524e18$var$S(b);
                    return null;
                }
                a = $cee7ff159d524e18$var$xh($cee7ff159d524e18$var$uh.current);
                if ($cee7ff159d524e18$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[$cee7ff159d524e18$var$Of] = b;
                    d[$cee7ff159d524e18$var$Pf] = f;
                    a = 0 !== (b.mode & 1);
                    switch(c){
                        case "dialog":
                            $cee7ff159d524e18$var$D("cancel", d);
                            $cee7ff159d524e18$var$D("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            $cee7ff159d524e18$var$D("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < $cee7ff159d524e18$var$lf.length; e++)$cee7ff159d524e18$var$D($cee7ff159d524e18$var$lf[e], d);
                            break;
                        case "source":
                            $cee7ff159d524e18$var$D("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            $cee7ff159d524e18$var$D("error", d);
                            $cee7ff159d524e18$var$D("load", d);
                            break;
                        case "details":
                            $cee7ff159d524e18$var$D("toggle", d);
                            break;
                        case "input":
                            $cee7ff159d524e18$var$Za(d, f);
                            $cee7ff159d524e18$var$D("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            $cee7ff159d524e18$var$D("invalid", d);
                            break;
                        case "textarea":
                            $cee7ff159d524e18$var$hb(d, f), $cee7ff159d524e18$var$D("invalid", d);
                    }
                    $cee7ff159d524e18$var$ub(c, f);
                    e = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (!0 !== f.suppressHydrationWarning && $cee7ff159d524e18$var$Af(d.textContent, h, a), e = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (!0 !== f.suppressHydrationWarning && $cee7ff159d524e18$var$Af(d.textContent, h, a), e = [
                            "children",
                            "" + h
                        ]) : $cee7ff159d524e18$var$ea.hasOwnProperty(g) && null != h && "onScroll" === g && $cee7ff159d524e18$var$D("scroll", d);
                    }
                    switch(c){
                        case "input":
                            $cee7ff159d524e18$var$Va(d);
                            $cee7ff159d524e18$var$db(d, f, !0);
                            break;
                        case "textarea":
                            $cee7ff159d524e18$var$Va(d);
                            $cee7ff159d524e18$var$jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = $cee7ff159d524e18$var$Bf);
                    }
                    d = e;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    "http://www.w3.org/1999/xhtml" === a && (a = $cee7ff159d524e18$var$kb(c));
                    "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script>\x3c/script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[$cee7ff159d524e18$var$Of] = b;
                    a[$cee7ff159d524e18$var$Pf] = d;
                    $cee7ff159d524e18$var$zj(a, b, !1, !1);
                    b.stateNode = a;
                    a: {
                        g = $cee7ff159d524e18$var$vb(c, d);
                        switch(c){
                            case "dialog":
                                $cee7ff159d524e18$var$D("cancel", a);
                                $cee7ff159d524e18$var$D("close", a);
                                e = d;
                                break;
                            case "iframe":
                            case "object":
                            case "embed":
                                $cee7ff159d524e18$var$D("load", a);
                                e = d;
                                break;
                            case "video":
                            case "audio":
                                for(e = 0; e < $cee7ff159d524e18$var$lf.length; e++)$cee7ff159d524e18$var$D($cee7ff159d524e18$var$lf[e], a);
                                e = d;
                                break;
                            case "source":
                                $cee7ff159d524e18$var$D("error", a);
                                e = d;
                                break;
                            case "img":
                            case "image":
                            case "link":
                                $cee7ff159d524e18$var$D("error", a);
                                $cee7ff159d524e18$var$D("load", a);
                                e = d;
                                break;
                            case "details":
                                $cee7ff159d524e18$var$D("toggle", a);
                                e = d;
                                break;
                            case "input":
                                $cee7ff159d524e18$var$Za(a, d);
                                e = $cee7ff159d524e18$var$Ya(a, d);
                                $cee7ff159d524e18$var$D("invalid", a);
                                break;
                            case "option":
                                e = d;
                                break;
                            case "select":
                                a._wrapperState = {
                                    wasMultiple: !!d.multiple
                                };
                                e = $cee7ff159d524e18$var$A({}, d, {
                                    value: void 0
                                });
                                $cee7ff159d524e18$var$D("invalid", a);
                                break;
                            case "textarea":
                                $cee7ff159d524e18$var$hb(a, d);
                                e = $cee7ff159d524e18$var$gb(a, d);
                                $cee7ff159d524e18$var$D("invalid", a);
                                break;
                            default:
                                e = d;
                        }
                        $cee7ff159d524e18$var$ub(c, e);
                        h = e;
                        for(f in h)if (h.hasOwnProperty(f)) {
                            var k = h[f];
                            "style" === f ? $cee7ff159d524e18$var$sb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && $cee7ff159d524e18$var$nb(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && $cee7ff159d524e18$var$ob(a, k) : "number" === typeof k && $cee7ff159d524e18$var$ob(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && ($cee7ff159d524e18$var$ea.hasOwnProperty(f) ? null != k && "onScroll" === f && $cee7ff159d524e18$var$D("scroll", a) : null != k && $cee7ff159d524e18$var$ta(a, f, k, g));
                        }
                        switch(c){
                            case "input":
                                $cee7ff159d524e18$var$Va(a);
                                $cee7ff159d524e18$var$db(a, d, !1);
                                break;
                            case "textarea":
                                $cee7ff159d524e18$var$Va(a);
                                $cee7ff159d524e18$var$jb(a);
                                break;
                            case "option":
                                null != d.value && a.setAttribute("value", "" + $cee7ff159d524e18$var$Sa(d.value));
                                break;
                            case "select":
                                a.multiple = !!d.multiple;
                                f = d.value;
                                null != f ? $cee7ff159d524e18$var$fb(a, !!d.multiple, f, !1) : null != d.defaultValue && $cee7ff159d524e18$var$fb(a, !!d.multiple, d.defaultValue, !0);
                                break;
                            default:
                                "function" === typeof e.onClick && (a.onclick = $cee7ff159d524e18$var$Bf);
                        }
                        switch(c){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                d = !!d.autoFocus;
                                break a;
                            case "img":
                                d = !0;
                                break a;
                            default:
                                d = !1;
                        }
                    }
                    d && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            }
            $cee7ff159d524e18$var$S(b);
            return null;
        case 6:
            if (a && null != b.stateNode) $cee7ff159d524e18$var$Cj(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error($cee7ff159d524e18$var$p(166));
                c = $cee7ff159d524e18$var$xh($cee7ff159d524e18$var$wh.current);
                $cee7ff159d524e18$var$xh($cee7ff159d524e18$var$uh.current);
                if ($cee7ff159d524e18$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.memoizedProps;
                    d[$cee7ff159d524e18$var$Of] = b;
                    if (f = d.nodeValue !== c) {
                        if (a = $cee7ff159d524e18$var$xg, null !== a) switch(a.tag){
                            case 3:
                                $cee7ff159d524e18$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                                break;
                            case 5:
                                !0 !== a.memoizedProps.suppressHydrationWarning && $cee7ff159d524e18$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                        }
                    }
                    f && (b.flags |= 4);
                } else d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[$cee7ff159d524e18$var$Of] = b, b.stateNode = d;
            }
            $cee7ff159d524e18$var$S(b);
            return null;
        case 13:
            $cee7ff159d524e18$var$E($cee7ff159d524e18$var$L);
            d = b.memoizedState;
            if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
                if ($cee7ff159d524e18$var$I && null !== $cee7ff159d524e18$var$yg && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) $cee7ff159d524e18$var$Hg(), $cee7ff159d524e18$var$Ig(), b.flags |= 98560, f = !1;
                else if (f = $cee7ff159d524e18$var$Gg(b), null !== d && null !== d.dehydrated) {
                    if (null === a) {
                        if (!f) throw Error($cee7ff159d524e18$var$p(318));
                        f = b.memoizedState;
                        f = null !== f ? f.dehydrated : null;
                        if (!f) throw Error($cee7ff159d524e18$var$p(317));
                        f[$cee7ff159d524e18$var$Of] = b;
                    } else $cee7ff159d524e18$var$Ig(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4;
                    $cee7ff159d524e18$var$S(b);
                    f = !1;
                } else null !== $cee7ff159d524e18$var$zg && ($cee7ff159d524e18$var$Fj($cee7ff159d524e18$var$zg), $cee7ff159d524e18$var$zg = null), f = !0;
                if (!f) return b.flags & 65536 ? b : null;
            }
            if (0 !== (b.flags & 128)) return b.lanes = c, b;
            d = null !== d;
            d !== (null !== a && null !== a.memoizedState) && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== ($cee7ff159d524e18$var$L.current & 1) ? 0 === $cee7ff159d524e18$var$T && ($cee7ff159d524e18$var$T = 3) : $cee7ff159d524e18$var$tj()));
            null !== b.updateQueue && (b.flags |= 4);
            $cee7ff159d524e18$var$S(b);
            return null;
        case 4:
            return $cee7ff159d524e18$var$zh(), $cee7ff159d524e18$var$Aj(a, b), null === a && $cee7ff159d524e18$var$sf(b.stateNode.containerInfo), $cee7ff159d524e18$var$S(b), null;
        case 10:
            return $cee7ff159d524e18$var$ah(b.type._context), $cee7ff159d524e18$var$S(b), null;
        case 17:
            return $cee7ff159d524e18$var$Zf(b.type) && $cee7ff159d524e18$var$$f(), $cee7ff159d524e18$var$S(b), null;
        case 19:
            $cee7ff159d524e18$var$E($cee7ff159d524e18$var$L);
            f = b.memoizedState;
            if (null === f) return $cee7ff159d524e18$var$S(b), null;
            d = 0 !== (b.flags & 128);
            g = f.rendering;
            if (null === g) {
                if (d) $cee7ff159d524e18$var$Dj(f, !1);
                else {
                    if (0 !== $cee7ff159d524e18$var$T || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                        g = $cee7ff159d524e18$var$Ch(a);
                        if (null !== g) {
                            b.flags |= 128;
                            $cee7ff159d524e18$var$Dj(f, !1);
                            d = g.updateQueue;
                            null !== d && (b.updateQueue = d, b.flags |= 4);
                            b.subtreeFlags = 0;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 14680066, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.subtreeFlags = 0, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.subtreeFlags = 0, f.deletions = null, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            $cee7ff159d524e18$var$G($cee7ff159d524e18$var$L, $cee7ff159d524e18$var$L.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== f.tail && $cee7ff159d524e18$var$B() > $cee7ff159d524e18$var$Gj && (b.flags |= 128, d = !0, $cee7ff159d524e18$var$Dj(f, !1), b.lanes = 4194304);
                }
            } else {
                if (!d) {
                    if (a = $cee7ff159d524e18$var$Ch(g), null !== a) {
                        if (b.flags |= 128, d = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), $cee7ff159d524e18$var$Dj(f, !0), null === f.tail && "hidden" === f.tailMode && !g.alternate && !$cee7ff159d524e18$var$I) return $cee7ff159d524e18$var$S(b), null;
                    } else 2 * $cee7ff159d524e18$var$B() - f.renderingStartTime > $cee7ff159d524e18$var$Gj && 1073741824 !== c && (b.flags |= 128, d = !0, $cee7ff159d524e18$var$Dj(f, !1), b.lanes = 4194304);
                }
                f.isBackwards ? (g.sibling = b.child, b.child = g) : (c = f.last, null !== c ? c.sibling = g : b.child = g, f.last = g);
            }
            if (null !== f.tail) return b = f.tail, f.rendering = b, f.tail = b.sibling, f.renderingStartTime = $cee7ff159d524e18$var$B(), b.sibling = null, c = $cee7ff159d524e18$var$L.current, $cee7ff159d524e18$var$G($cee7ff159d524e18$var$L, d ? c & 1 | 2 : c & 1), b;
            $cee7ff159d524e18$var$S(b);
            return null;
        case 22:
        case 23:
            return $cee7ff159d524e18$var$Hj(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== ($cee7ff159d524e18$var$fj & 1073741824) && ($cee7ff159d524e18$var$S(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : $cee7ff159d524e18$var$S(b), null;
        case 24:
            return null;
        case 25:
            return null;
    }
    throw Error($cee7ff159d524e18$var$p(156, b.tag));
}
function $cee7ff159d524e18$var$Ij(a, b) {
    $cee7ff159d524e18$var$wg(b);
    switch(b.tag){
        case 1:
            return $cee7ff159d524e18$var$Zf(b.type) && $cee7ff159d524e18$var$$f(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 3:
            return $cee7ff159d524e18$var$zh(), $cee7ff159d524e18$var$E($cee7ff159d524e18$var$Wf), $cee7ff159d524e18$var$E($cee7ff159d524e18$var$H), $cee7ff159d524e18$var$Eh(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
        case 5:
            return $cee7ff159d524e18$var$Bh(b), null;
        case 13:
            $cee7ff159d524e18$var$E($cee7ff159d524e18$var$L);
            a = b.memoizedState;
            if (null !== a && null !== a.dehydrated) {
                if (null === b.alternate) throw Error($cee7ff159d524e18$var$p(340));
                $cee7ff159d524e18$var$Ig();
            }
            a = b.flags;
            return a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 19:
            return $cee7ff159d524e18$var$E($cee7ff159d524e18$var$L), null;
        case 4:
            return $cee7ff159d524e18$var$zh(), null;
        case 10:
            return $cee7ff159d524e18$var$ah(b.type._context), null;
        case 22:
        case 23:
            return $cee7ff159d524e18$var$Hj(), null;
        case 24:
            return null;
        default:
            return null;
    }
}
var $cee7ff159d524e18$var$Jj = !1, $cee7ff159d524e18$var$U = !1, $cee7ff159d524e18$var$Kj = "function" === typeof WeakSet ? WeakSet : Set, $cee7ff159d524e18$var$V = null;
function $cee7ff159d524e18$var$Lj(a, b) {
    var c = a.ref;
    if (null !== c) {
        if ("function" === typeof c) try {
            c(null);
        } catch (d) {
            $cee7ff159d524e18$var$W(a, b, d);
        }
        else c.current = null;
    }
}
function $cee7ff159d524e18$var$Mj(a, b, c) {
    try {
        c();
    } catch (d) {
        $cee7ff159d524e18$var$W(a, b, d);
    }
}
var $cee7ff159d524e18$var$Nj = !1;
function $cee7ff159d524e18$var$Oj(a, b) {
    $cee7ff159d524e18$var$Cf = $cee7ff159d524e18$var$dd;
    a = $cee7ff159d524e18$var$Me();
    if ($cee7ff159d524e18$var$Ne(a)) {
        if ("selectionStart" in a) var c = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            c = (c = a.ownerDocument) && c.defaultView || window;
            var d = c.getSelection && c.getSelection();
            if (d && 0 !== d.rangeCount) {
                c = d.anchorNode;
                var e = d.anchorOffset, f = d.focusNode;
                d = d.focusOffset;
                try {
                    c.nodeType, f.nodeType;
                } catch (F) {
                    c = null;
                    break a;
                }
                var g = 0, h = -1, k = -1, l = 0, m = 0, q = a, r = null;
                b: for(;;){
                    for(var y;;){
                        q !== c || 0 !== e && 3 !== q.nodeType || (h = g + e);
                        q !== f || 0 !== d && 3 !== q.nodeType || (k = g + d);
                        3 === q.nodeType && (g += q.nodeValue.length);
                        if (null === (y = q.firstChild)) break;
                        r = q;
                        q = y;
                    }
                    for(;;){
                        if (q === a) break b;
                        r === c && ++l === e && (h = g);
                        r === f && ++m === d && (k = g);
                        if (null !== (y = q.nextSibling)) break;
                        q = r;
                        r = q.parentNode;
                    }
                    q = y;
                }
                c = -1 === h || -1 === k ? null : {
                    start: h,
                    end: k
                };
            } else c = null;
        }
        c = c || {
            start: 0,
            end: 0
        };
    } else c = null;
    $cee7ff159d524e18$var$Df = {
        focusedElem: a,
        selectionRange: c
    };
    $cee7ff159d524e18$var$dd = !1;
    for($cee7ff159d524e18$var$V = b; null !== $cee7ff159d524e18$var$V;)if (b = $cee7ff159d524e18$var$V, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a.return = b, $cee7ff159d524e18$var$V = a;
    else for(; null !== $cee7ff159d524e18$var$V;){
        b = $cee7ff159d524e18$var$V;
        try {
            var n = b.alternate;
            if (0 !== (b.flags & 1024)) switch(b.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    if (null !== n) {
                        var t = n.memoizedProps, J = n.memoizedState, x = b.stateNode, w = x.getSnapshotBeforeUpdate(b.elementType === b.type ? t : $cee7ff159d524e18$var$Ci(b.type, t), J);
                        x.__reactInternalSnapshotBeforeUpdate = w;
                    }
                    break;
                case 3:
                    var u = b.stateNode.containerInfo;
                    1 === u.nodeType ? u.textContent = "" : 9 === u.nodeType && u.documentElement && u.removeChild(u.documentElement);
                    break;
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error($cee7ff159d524e18$var$p(163));
            }
        } catch (F) {
            $cee7ff159d524e18$var$W(b, b.return, F);
        }
        a = b.sibling;
        if (null !== a) {
            a.return = b.return;
            $cee7ff159d524e18$var$V = a;
            break;
        }
        $cee7ff159d524e18$var$V = b.return;
    }
    n = $cee7ff159d524e18$var$Nj;
    $cee7ff159d524e18$var$Nj = !1;
    return n;
}
function $cee7ff159d524e18$var$Pj(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
        var e = d = d.next;
        do {
            if ((e.tag & a) === a) {
                var f = e.destroy;
                e.destroy = void 0;
                void 0 !== f && $cee7ff159d524e18$var$Mj(b, c, f);
            }
            e = e.next;
        }while (e !== d);
    }
}
function $cee7ff159d524e18$var$Qj(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function $cee7ff159d524e18$var$Rj(a) {
    var b = a.ref;
    if (null !== b) {
        var c = a.stateNode;
        switch(a.tag){
            case 5:
                a = c;
                break;
            default:
                a = c;
        }
        "function" === typeof b ? b(a) : b.current = a;
    }
}
function $cee7ff159d524e18$var$Sj(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, $cee7ff159d524e18$var$Sj(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && (delete b[$cee7ff159d524e18$var$Of], delete b[$cee7ff159d524e18$var$Pf], delete b[$cee7ff159d524e18$var$of], delete b[$cee7ff159d524e18$var$Qf], delete b[$cee7ff159d524e18$var$Rf]));
    a.stateNode = null;
    a.return = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
}
function $cee7ff159d524e18$var$Tj(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function $cee7ff159d524e18$var$Uj(a) {
    a: for(;;){
        for(; null === a.sibling;){
            if (null === a.return || $cee7ff159d524e18$var$Tj(a.return)) return null;
            a = a.return;
        }
        a.sibling.return = a.return;
        for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
            if (a.flags & 2) continue a;
            if (null === a.child || 4 === a.tag) continue a;
            else a.child.return = a, a = a.child;
        }
        if (!(a.flags & 2)) return a.stateNode;
    }
}
function $cee7ff159d524e18$var$Vj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = $cee7ff159d524e18$var$Bf));
    else if (4 !== d && (a = a.child, null !== a)) for($cee7ff159d524e18$var$Vj(a, b, c), a = a.sibling; null !== a;)$cee7ff159d524e18$var$Vj(a, b, c), a = a.sibling;
}
function $cee7ff159d524e18$var$Wj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for($cee7ff159d524e18$var$Wj(a, b, c), a = a.sibling; null !== a;)$cee7ff159d524e18$var$Wj(a, b, c), a = a.sibling;
}
var $cee7ff159d524e18$var$X = null, $cee7ff159d524e18$var$Xj = !1;
function $cee7ff159d524e18$var$Yj(a, b, c) {
    for(c = c.child; null !== c;)$cee7ff159d524e18$var$Zj(a, b, c), c = c.sibling;
}
function $cee7ff159d524e18$var$Zj(a, b, c) {
    if ($cee7ff159d524e18$var$lc && "function" === typeof $cee7ff159d524e18$var$lc.onCommitFiberUnmount) try {
        $cee7ff159d524e18$var$lc.onCommitFiberUnmount($cee7ff159d524e18$var$kc, c);
    } catch (h) {}
    switch(c.tag){
        case 5:
            $cee7ff159d524e18$var$U || $cee7ff159d524e18$var$Lj(c, b);
        case 6:
            var d = $cee7ff159d524e18$var$X, e = $cee7ff159d524e18$var$Xj;
            $cee7ff159d524e18$var$X = null;
            $cee7ff159d524e18$var$Yj(a, b, c);
            $cee7ff159d524e18$var$X = d;
            $cee7ff159d524e18$var$Xj = e;
            null !== $cee7ff159d524e18$var$X && ($cee7ff159d524e18$var$Xj ? (a = $cee7ff159d524e18$var$X, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : $cee7ff159d524e18$var$X.removeChild(c.stateNode));
            break;
        case 18:
            null !== $cee7ff159d524e18$var$X && ($cee7ff159d524e18$var$Xj ? (a = $cee7ff159d524e18$var$X, c = c.stateNode, 8 === a.nodeType ? $cee7ff159d524e18$var$Kf(a.parentNode, c) : 1 === a.nodeType && $cee7ff159d524e18$var$Kf(a, c), $cee7ff159d524e18$var$bd(a)) : $cee7ff159d524e18$var$Kf($cee7ff159d524e18$var$X, c.stateNode));
            break;
        case 4:
            d = $cee7ff159d524e18$var$X;
            e = $cee7ff159d524e18$var$Xj;
            $cee7ff159d524e18$var$X = c.stateNode.containerInfo;
            $cee7ff159d524e18$var$Xj = !0;
            $cee7ff159d524e18$var$Yj(a, b, c);
            $cee7ff159d524e18$var$X = d;
            $cee7ff159d524e18$var$Xj = e;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            if (!$cee7ff159d524e18$var$U && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                e = d = d.next;
                do {
                    var f = e, g = f.destroy;
                    f = f.tag;
                    void 0 !== g && (0 !== (f & 2) ? $cee7ff159d524e18$var$Mj(c, b, g) : 0 !== (f & 4) && $cee7ff159d524e18$var$Mj(c, b, g));
                    e = e.next;
                }while (e !== d);
            }
            $cee7ff159d524e18$var$Yj(a, b, c);
            break;
        case 1:
            if (!$cee7ff159d524e18$var$U && ($cee7ff159d524e18$var$Lj(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                d.props = c.memoizedProps, d.state = c.memoizedState, d.componentWillUnmount();
            } catch (h) {
                $cee7ff159d524e18$var$W(c, b, h);
            }
            $cee7ff159d524e18$var$Yj(a, b, c);
            break;
        case 21:
            $cee7ff159d524e18$var$Yj(a, b, c);
            break;
        case 22:
            c.mode & 1 ? ($cee7ff159d524e18$var$U = (d = $cee7ff159d524e18$var$U) || null !== c.memoizedState, $cee7ff159d524e18$var$Yj(a, b, c), $cee7ff159d524e18$var$U = d) : $cee7ff159d524e18$var$Yj(a, b, c);
            break;
        default:
            $cee7ff159d524e18$var$Yj(a, b, c);
    }
}
function $cee7ff159d524e18$var$ak(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new $cee7ff159d524e18$var$Kj);
        b.forEach(function(b) {
            var d = $cee7ff159d524e18$var$bk.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function $cee7ff159d524e18$var$ck(a, b) {
    var c = b.deletions;
    if (null !== c) for(var d = 0; d < c.length; d++){
        var e = c[d];
        try {
            var f = a, g = b, h = g;
            a: for(; null !== h;){
                switch(h.tag){
                    case 5:
                        $cee7ff159d524e18$var$X = h.stateNode;
                        $cee7ff159d524e18$var$Xj = !1;
                        break a;
                    case 3:
                        $cee7ff159d524e18$var$X = h.stateNode.containerInfo;
                        $cee7ff159d524e18$var$Xj = !0;
                        break a;
                    case 4:
                        $cee7ff159d524e18$var$X = h.stateNode.containerInfo;
                        $cee7ff159d524e18$var$Xj = !0;
                        break a;
                }
                h = h.return;
            }
            if (null === $cee7ff159d524e18$var$X) throw Error($cee7ff159d524e18$var$p(160));
            $cee7ff159d524e18$var$Zj(f, g, e);
            $cee7ff159d524e18$var$X = null;
            $cee7ff159d524e18$var$Xj = !1;
            var k = e.alternate;
            null !== k && (k.return = null);
            e.return = null;
        } catch (l) {
            $cee7ff159d524e18$var$W(e, b, l);
        }
    }
    if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)$cee7ff159d524e18$var$dk(b, a), b = b.sibling;
}
function $cee7ff159d524e18$var$dk(a, b) {
    var c = a.alternate, d = a.flags;
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $cee7ff159d524e18$var$ck(b, a);
            $cee7ff159d524e18$var$ek(a);
            if (d & 4) {
                try {
                    $cee7ff159d524e18$var$Pj(3, a, a.return), $cee7ff159d524e18$var$Qj(3, a);
                } catch (t) {
                    $cee7ff159d524e18$var$W(a, a.return, t);
                }
                try {
                    $cee7ff159d524e18$var$Pj(5, a, a.return);
                } catch (t) {
                    $cee7ff159d524e18$var$W(a, a.return, t);
                }
            }
            break;
        case 1:
            $cee7ff159d524e18$var$ck(b, a);
            $cee7ff159d524e18$var$ek(a);
            d & 512 && null !== c && $cee7ff159d524e18$var$Lj(c, c.return);
            break;
        case 5:
            $cee7ff159d524e18$var$ck(b, a);
            $cee7ff159d524e18$var$ek(a);
            d & 512 && null !== c && $cee7ff159d524e18$var$Lj(c, c.return);
            if (a.flags & 32) {
                var e = a.stateNode;
                try {
                    $cee7ff159d524e18$var$ob(e, "");
                } catch (t) {
                    $cee7ff159d524e18$var$W(a, a.return, t);
                }
            }
            if (d & 4 && (e = a.stateNode, null != e)) {
                var f = a.memoizedProps, g = null !== c ? c.memoizedProps : f, h = a.type, k = a.updateQueue;
                a.updateQueue = null;
                if (null !== k) try {
                    "input" === h && "radio" === f.type && null != f.name && $cee7ff159d524e18$var$ab(e, f);
                    $cee7ff159d524e18$var$vb(h, g);
                    var l = $cee7ff159d524e18$var$vb(h, f);
                    for(g = 0; g < k.length; g += 2){
                        var m = k[g], q = k[g + 1];
                        "style" === m ? $cee7ff159d524e18$var$sb(e, q) : "dangerouslySetInnerHTML" === m ? $cee7ff159d524e18$var$nb(e, q) : "children" === m ? $cee7ff159d524e18$var$ob(e, q) : $cee7ff159d524e18$var$ta(e, m, q, l);
                    }
                    switch(h){
                        case "input":
                            $cee7ff159d524e18$var$bb(e, f);
                            break;
                        case "textarea":
                            $cee7ff159d524e18$var$ib(e, f);
                            break;
                        case "select":
                            var r = e._wrapperState.wasMultiple;
                            e._wrapperState.wasMultiple = !!f.multiple;
                            var y = f.value;
                            null != y ? $cee7ff159d524e18$var$fb(e, !!f.multiple, y, !1) : r !== !!f.multiple && (null != f.defaultValue ? $cee7ff159d524e18$var$fb(e, !!f.multiple, f.defaultValue, !0) : $cee7ff159d524e18$var$fb(e, !!f.multiple, f.multiple ? [] : "", !1));
                    }
                    e[$cee7ff159d524e18$var$Pf] = f;
                } catch (t) {
                    $cee7ff159d524e18$var$W(a, a.return, t);
                }
            }
            break;
        case 6:
            $cee7ff159d524e18$var$ck(b, a);
            $cee7ff159d524e18$var$ek(a);
            if (d & 4) {
                if (null === a.stateNode) throw Error($cee7ff159d524e18$var$p(162));
                e = a.stateNode;
                f = a.memoizedProps;
                try {
                    e.nodeValue = f;
                } catch (t) {
                    $cee7ff159d524e18$var$W(a, a.return, t);
                }
            }
            break;
        case 3:
            $cee7ff159d524e18$var$ck(b, a);
            $cee7ff159d524e18$var$ek(a);
            if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
                $cee7ff159d524e18$var$bd(b.containerInfo);
            } catch (t) {
                $cee7ff159d524e18$var$W(a, a.return, t);
            }
            break;
        case 4:
            $cee7ff159d524e18$var$ck(b, a);
            $cee7ff159d524e18$var$ek(a);
            break;
        case 13:
            $cee7ff159d524e18$var$ck(b, a);
            $cee7ff159d524e18$var$ek(a);
            e = a.child;
            e.flags & 8192 && (f = null !== e.memoizedState, e.stateNode.isHidden = f, !f || null !== e.alternate && null !== e.alternate.memoizedState || ($cee7ff159d524e18$var$fk = $cee7ff159d524e18$var$B()));
            d & 4 && $cee7ff159d524e18$var$ak(a);
            break;
        case 22:
            m = null !== c && null !== c.memoizedState;
            a.mode & 1 ? ($cee7ff159d524e18$var$U = (l = $cee7ff159d524e18$var$U) || m, $cee7ff159d524e18$var$ck(b, a), $cee7ff159d524e18$var$U = l) : $cee7ff159d524e18$var$ck(b, a);
            $cee7ff159d524e18$var$ek(a);
            if (d & 8192) {
                l = null !== a.memoizedState;
                if ((a.stateNode.isHidden = l) && !m && 0 !== (a.mode & 1)) for($cee7ff159d524e18$var$V = a, m = a.child; null !== m;){
                    for(q = $cee7ff159d524e18$var$V = m; null !== $cee7ff159d524e18$var$V;){
                        r = $cee7ff159d524e18$var$V;
                        y = r.child;
                        switch(r.tag){
                            case 0:
                            case 11:
                            case 14:
                            case 15:
                                $cee7ff159d524e18$var$Pj(4, r, r.return);
                                break;
                            case 1:
                                $cee7ff159d524e18$var$Lj(r, r.return);
                                var n = r.stateNode;
                                if ("function" === typeof n.componentWillUnmount) {
                                    d = r;
                                    c = r.return;
                                    try {
                                        b = d, n.props = b.memoizedProps, n.state = b.memoizedState, n.componentWillUnmount();
                                    } catch (t) {
                                        $cee7ff159d524e18$var$W(d, c, t);
                                    }
                                }
                                break;
                            case 5:
                                $cee7ff159d524e18$var$Lj(r, r.return);
                                break;
                            case 22:
                                if (null !== r.memoizedState) {
                                    $cee7ff159d524e18$var$gk(q);
                                    continue;
                                }
                        }
                        null !== y ? (y.return = r, $cee7ff159d524e18$var$V = y) : $cee7ff159d524e18$var$gk(q);
                    }
                    m = m.sibling;
                }
                a: for(m = null, q = a;;){
                    if (5 === q.tag) {
                        if (null === m) {
                            m = q;
                            try {
                                e = q.stateNode, l ? (f = e.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (h = q.stateNode, k = q.memoizedProps.style, g = void 0 !== k && null !== k && k.hasOwnProperty("display") ? k.display : null, h.style.display = $cee7ff159d524e18$var$rb("display", g));
                            } catch (t) {
                                $cee7ff159d524e18$var$W(a, a.return, t);
                            }
                        }
                    } else if (6 === q.tag) {
                        if (null === m) try {
                            q.stateNode.nodeValue = l ? "" : q.memoizedProps;
                        } catch (t) {
                            $cee7ff159d524e18$var$W(a, a.return, t);
                        }
                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === a) && null !== q.child) {
                        q.child.return = q;
                        q = q.child;
                        continue;
                    }
                    if (q === a) break a;
                    for(; null === q.sibling;){
                        if (null === q.return || q.return === a) break a;
                        m === q && (m = null);
                        q = q.return;
                    }
                    m === q && (m = null);
                    q.sibling.return = q.return;
                    q = q.sibling;
                }
            }
            break;
        case 19:
            $cee7ff159d524e18$var$ck(b, a);
            $cee7ff159d524e18$var$ek(a);
            d & 4 && $cee7ff159d524e18$var$ak(a);
            break;
        case 21:
            break;
        default:
            $cee7ff159d524e18$var$ck(b, a), $cee7ff159d524e18$var$ek(a);
    }
}
function $cee7ff159d524e18$var$ek(a) {
    var b = a.flags;
    if (b & 2) {
        try {
            a: {
                for(var c = a.return; null !== c;){
                    if ($cee7ff159d524e18$var$Tj(c)) {
                        var d = c;
                        break a;
                    }
                    c = c.return;
                }
                throw Error($cee7ff159d524e18$var$p(160));
            }
            switch(d.tag){
                case 5:
                    var e = d.stateNode;
                    d.flags & 32 && ($cee7ff159d524e18$var$ob(e, ""), d.flags &= -33);
                    var f = $cee7ff159d524e18$var$Uj(a);
                    $cee7ff159d524e18$var$Wj(a, f, e);
                    break;
                case 3:
                case 4:
                    var g = d.stateNode.containerInfo, h = $cee7ff159d524e18$var$Uj(a);
                    $cee7ff159d524e18$var$Vj(a, h, g);
                    break;
                default:
                    throw Error($cee7ff159d524e18$var$p(161));
            }
        } catch (k) {
            $cee7ff159d524e18$var$W(a, a.return, k);
        }
        a.flags &= -3;
    }
    b & 4096 && (a.flags &= -4097);
}
function $cee7ff159d524e18$var$hk(a, b, c) {
    $cee7ff159d524e18$var$V = a;
    $cee7ff159d524e18$var$ik(a, b, c);
}
function $cee7ff159d524e18$var$ik(a, b, c) {
    for(var d = 0 !== (a.mode & 1); null !== $cee7ff159d524e18$var$V;){
        var e = $cee7ff159d524e18$var$V, f = e.child;
        if (22 === e.tag && d) {
            var g = null !== e.memoizedState || $cee7ff159d524e18$var$Jj;
            if (!g) {
                var h = e.alternate, k = null !== h && null !== h.memoizedState || $cee7ff159d524e18$var$U;
                h = $cee7ff159d524e18$var$Jj;
                var l = $cee7ff159d524e18$var$U;
                $cee7ff159d524e18$var$Jj = g;
                if (($cee7ff159d524e18$var$U = k) && !l) for($cee7ff159d524e18$var$V = e; null !== $cee7ff159d524e18$var$V;)g = $cee7ff159d524e18$var$V, k = g.child, 22 === g.tag && null !== g.memoizedState ? $cee7ff159d524e18$var$jk(e) : null !== k ? (k.return = g, $cee7ff159d524e18$var$V = k) : $cee7ff159d524e18$var$jk(e);
                for(; null !== f;)$cee7ff159d524e18$var$V = f, $cee7ff159d524e18$var$ik(f, b, c), f = f.sibling;
                $cee7ff159d524e18$var$V = e;
                $cee7ff159d524e18$var$Jj = h;
                $cee7ff159d524e18$var$U = l;
            }
            $cee7ff159d524e18$var$kk(a, b, c);
        } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, $cee7ff159d524e18$var$V = f) : $cee7ff159d524e18$var$kk(a, b, c);
    }
}
function $cee7ff159d524e18$var$kk(a) {
    for(; null !== $cee7ff159d524e18$var$V;){
        var b = $cee7ff159d524e18$var$V;
        if (0 !== (b.flags & 8772)) {
            var c = b.alternate;
            try {
                if (0 !== (b.flags & 8772)) switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        $cee7ff159d524e18$var$U || $cee7ff159d524e18$var$Qj(5, b);
                        break;
                    case 1:
                        var d = b.stateNode;
                        if (b.flags & 4 && !$cee7ff159d524e18$var$U) {
                            if (null === c) d.componentDidMount();
                            else {
                                var e = b.elementType === b.type ? c.memoizedProps : $cee7ff159d524e18$var$Ci(b.type, c.memoizedProps);
                                d.componentDidUpdate(e, c.memoizedState, d.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        var f = b.updateQueue;
                        null !== f && $cee7ff159d524e18$var$sh(b, f, d);
                        break;
                    case 3:
                        var g = b.updateQueue;
                        if (null !== g) {
                            c = null;
                            if (null !== b.child) switch(b.child.tag){
                                case 5:
                                    c = b.child.stateNode;
                                    break;
                                case 1:
                                    c = b.child.stateNode;
                            }
                            $cee7ff159d524e18$var$sh(b, g, c);
                        }
                        break;
                    case 5:
                        var h = b.stateNode;
                        if (null === c && b.flags & 4) {
                            c = h;
                            var k = b.memoizedProps;
                            switch(b.type){
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    k.autoFocus && c.focus();
                                    break;
                                case "img":
                                    k.src && (c.src = k.src);
                            }
                        }
                        break;
                    case 6:
                        break;
                    case 4:
                        break;
                    case 12:
                        break;
                    case 13:
                        if (null === b.memoizedState) {
                            var l = b.alternate;
                            if (null !== l) {
                                var m = l.memoizedState;
                                if (null !== m) {
                                    var q = m.dehydrated;
                                    null !== q && $cee7ff159d524e18$var$bd(q);
                                }
                            }
                        }
                        break;
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                    case 25:
                        break;
                    default:
                        throw Error($cee7ff159d524e18$var$p(163));
                }
                $cee7ff159d524e18$var$U || b.flags & 512 && $cee7ff159d524e18$var$Rj(b);
            } catch (r) {
                $cee7ff159d524e18$var$W(b, b.return, r);
            }
        }
        if (b === a) {
            $cee7ff159d524e18$var$V = null;
            break;
        }
        c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $cee7ff159d524e18$var$V = c;
            break;
        }
        $cee7ff159d524e18$var$V = b.return;
    }
}
function $cee7ff159d524e18$var$gk(a) {
    for(; null !== $cee7ff159d524e18$var$V;){
        var b = $cee7ff159d524e18$var$V;
        if (b === a) {
            $cee7ff159d524e18$var$V = null;
            break;
        }
        var c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $cee7ff159d524e18$var$V = c;
            break;
        }
        $cee7ff159d524e18$var$V = b.return;
    }
}
function $cee7ff159d524e18$var$jk(a) {
    for(; null !== $cee7ff159d524e18$var$V;){
        var b = $cee7ff159d524e18$var$V;
        try {
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    var c = b.return;
                    try {
                        $cee7ff159d524e18$var$Qj(4, b);
                    } catch (k) {
                        $cee7ff159d524e18$var$W(b, c, k);
                    }
                    break;
                case 1:
                    var d = b.stateNode;
                    if ("function" === typeof d.componentDidMount) {
                        var e = b.return;
                        try {
                            d.componentDidMount();
                        } catch (k) {
                            $cee7ff159d524e18$var$W(b, e, k);
                        }
                    }
                    var f = b.return;
                    try {
                        $cee7ff159d524e18$var$Rj(b);
                    } catch (k) {
                        $cee7ff159d524e18$var$W(b, f, k);
                    }
                    break;
                case 5:
                    var g = b.return;
                    try {
                        $cee7ff159d524e18$var$Rj(b);
                    } catch (k) {
                        $cee7ff159d524e18$var$W(b, g, k);
                    }
            }
        } catch (k) {
            $cee7ff159d524e18$var$W(b, b.return, k);
        }
        if (b === a) {
            $cee7ff159d524e18$var$V = null;
            break;
        }
        var h = b.sibling;
        if (null !== h) {
            h.return = b.return;
            $cee7ff159d524e18$var$V = h;
            break;
        }
        $cee7ff159d524e18$var$V = b.return;
    }
}
var $cee7ff159d524e18$var$lk = Math.ceil, $cee7ff159d524e18$var$mk = $cee7ff159d524e18$var$ua.ReactCurrentDispatcher, $cee7ff159d524e18$var$nk = $cee7ff159d524e18$var$ua.ReactCurrentOwner, $cee7ff159d524e18$var$ok = $cee7ff159d524e18$var$ua.ReactCurrentBatchConfig, $cee7ff159d524e18$var$K = 0, $cee7ff159d524e18$var$Q = null, $cee7ff159d524e18$var$Y = null, $cee7ff159d524e18$var$Z = 0, $cee7ff159d524e18$var$fj = 0, $cee7ff159d524e18$var$ej = $cee7ff159d524e18$var$Uf(0), $cee7ff159d524e18$var$T = 0, $cee7ff159d524e18$var$pk = null, $cee7ff159d524e18$var$rh = 0, $cee7ff159d524e18$var$qk = 0, $cee7ff159d524e18$var$rk = 0, $cee7ff159d524e18$var$sk = null, $cee7ff159d524e18$var$tk = null, $cee7ff159d524e18$var$fk = 0, $cee7ff159d524e18$var$Gj = Infinity, $cee7ff159d524e18$var$uk = null, $cee7ff159d524e18$var$Oi = !1, $cee7ff159d524e18$var$Pi = null, $cee7ff159d524e18$var$Ri = null, $cee7ff159d524e18$var$vk = !1, $cee7ff159d524e18$var$wk = null, $cee7ff159d524e18$var$xk = 0, $cee7ff159d524e18$var$yk = 0, $cee7ff159d524e18$var$zk = null, $cee7ff159d524e18$var$Ak = -1, $cee7ff159d524e18$var$Bk = 0;
function $cee7ff159d524e18$var$R() {
    return 0 !== ($cee7ff159d524e18$var$K & 6) ? $cee7ff159d524e18$var$B() : -1 !== $cee7ff159d524e18$var$Ak ? $cee7ff159d524e18$var$Ak : $cee7ff159d524e18$var$Ak = $cee7ff159d524e18$var$B();
}
function $cee7ff159d524e18$var$yi(a) {
    if (0 === (a.mode & 1)) return 1;
    if (0 !== ($cee7ff159d524e18$var$K & 2) && 0 !== $cee7ff159d524e18$var$Z) return $cee7ff159d524e18$var$Z & -$cee7ff159d524e18$var$Z;
    if (null !== $cee7ff159d524e18$var$Kg.transition) return 0 === $cee7ff159d524e18$var$Bk && ($cee7ff159d524e18$var$Bk = $cee7ff159d524e18$var$yc()), $cee7ff159d524e18$var$Bk;
    a = $cee7ff159d524e18$var$C;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 16 : $cee7ff159d524e18$var$jd(a.type);
    return a;
}
function $cee7ff159d524e18$var$gi(a, b, c, d) {
    if (50 < $cee7ff159d524e18$var$yk) throw $cee7ff159d524e18$var$yk = 0, $cee7ff159d524e18$var$zk = null, Error($cee7ff159d524e18$var$p(185));
    $cee7ff159d524e18$var$Ac(a, c, d);
    if (0 === ($cee7ff159d524e18$var$K & 2) || a !== $cee7ff159d524e18$var$Q) a === $cee7ff159d524e18$var$Q && (0 === ($cee7ff159d524e18$var$K & 2) && ($cee7ff159d524e18$var$qk |= c), 4 === $cee7ff159d524e18$var$T && $cee7ff159d524e18$var$Ck(a, $cee7ff159d524e18$var$Z)), $cee7ff159d524e18$var$Dk(a, d), 1 === c && 0 === $cee7ff159d524e18$var$K && 0 === (b.mode & 1) && ($cee7ff159d524e18$var$Gj = $cee7ff159d524e18$var$B() + 500, $cee7ff159d524e18$var$fg && $cee7ff159d524e18$var$jg());
}
function $cee7ff159d524e18$var$Dk(a, b) {
    var c = a.callbackNode;
    $cee7ff159d524e18$var$wc(a, b);
    var d = $cee7ff159d524e18$var$uc(a, a === $cee7ff159d524e18$var$Q ? $cee7ff159d524e18$var$Z : 0);
    if (0 === d) null !== c && $cee7ff159d524e18$var$bc(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
        null != c && $cee7ff159d524e18$var$bc(c);
        if (1 === b) 0 === a.tag ? $cee7ff159d524e18$var$ig($cee7ff159d524e18$var$Ek.bind(null, a)) : $cee7ff159d524e18$var$hg($cee7ff159d524e18$var$Ek.bind(null, a)), $cee7ff159d524e18$var$Jf(function() {
            0 === ($cee7ff159d524e18$var$K & 6) && $cee7ff159d524e18$var$jg();
        }), c = null;
        else {
            switch($cee7ff159d524e18$var$Dc(d)){
                case 1:
                    c = $cee7ff159d524e18$var$fc;
                    break;
                case 4:
                    c = $cee7ff159d524e18$var$gc;
                    break;
                case 16:
                    c = $cee7ff159d524e18$var$hc;
                    break;
                case 536870912:
                    c = $cee7ff159d524e18$var$jc;
                    break;
                default:
                    c = $cee7ff159d524e18$var$hc;
            }
            c = $cee7ff159d524e18$var$Fk(c, $cee7ff159d524e18$var$Gk.bind(null, a));
        }
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function $cee7ff159d524e18$var$Gk(a, b) {
    $cee7ff159d524e18$var$Ak = -1;
    $cee7ff159d524e18$var$Bk = 0;
    if (0 !== ($cee7ff159d524e18$var$K & 6)) throw Error($cee7ff159d524e18$var$p(327));
    var c = a.callbackNode;
    if ($cee7ff159d524e18$var$Hk() && a.callbackNode !== c) return null;
    var d = $cee7ff159d524e18$var$uc(a, a === $cee7ff159d524e18$var$Q ? $cee7ff159d524e18$var$Z : 0);
    if (0 === d) return null;
    if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = $cee7ff159d524e18$var$Ik(a, d);
    else {
        b = d;
        var e = $cee7ff159d524e18$var$K;
        $cee7ff159d524e18$var$K |= 2;
        var f = $cee7ff159d524e18$var$Jk();
        if ($cee7ff159d524e18$var$Q !== a || $cee7ff159d524e18$var$Z !== b) $cee7ff159d524e18$var$uk = null, $cee7ff159d524e18$var$Gj = $cee7ff159d524e18$var$B() + 500, $cee7ff159d524e18$var$Kk(a, b);
        for(;;)try {
            $cee7ff159d524e18$var$Lk();
            break;
        } catch (h) {
            $cee7ff159d524e18$var$Mk(a, h);
        }
        $cee7ff159d524e18$var$$g();
        $cee7ff159d524e18$var$mk.current = f;
        $cee7ff159d524e18$var$K = e;
        null !== $cee7ff159d524e18$var$Y ? b = 0 : ($cee7ff159d524e18$var$Q = null, $cee7ff159d524e18$var$Z = 0, b = $cee7ff159d524e18$var$T);
    }
    if (0 !== b) {
        2 === b && (e = $cee7ff159d524e18$var$xc(a), 0 !== e && (d = e, b = $cee7ff159d524e18$var$Nk(a, e)));
        if (1 === b) throw c = $cee7ff159d524e18$var$pk, $cee7ff159d524e18$var$Kk(a, 0), $cee7ff159d524e18$var$Ck(a, d), $cee7ff159d524e18$var$Dk(a, $cee7ff159d524e18$var$B()), c;
        if (6 === b) $cee7ff159d524e18$var$Ck(a, d);
        else {
            e = a.current.alternate;
            if (0 === (d & 30) && !$cee7ff159d524e18$var$Ok(e) && (b = $cee7ff159d524e18$var$Ik(a, d), 2 === b && (f = $cee7ff159d524e18$var$xc(a), 0 !== f && (d = f, b = $cee7ff159d524e18$var$Nk(a, f))), 1 === b)) throw c = $cee7ff159d524e18$var$pk, $cee7ff159d524e18$var$Kk(a, 0), $cee7ff159d524e18$var$Ck(a, d), $cee7ff159d524e18$var$Dk(a, $cee7ff159d524e18$var$B()), c;
            a.finishedWork = e;
            a.finishedLanes = d;
            switch(b){
                case 0:
                case 1:
                    throw Error($cee7ff159d524e18$var$p(345));
                case 2:
                    $cee7ff159d524e18$var$Pk(a, $cee7ff159d524e18$var$tk, $cee7ff159d524e18$var$uk);
                    break;
                case 3:
                    $cee7ff159d524e18$var$Ck(a, d);
                    if ((d & 130023424) === d && (b = $cee7ff159d524e18$var$fk + 500 - $cee7ff159d524e18$var$B(), 10 < b)) {
                        if (0 !== $cee7ff159d524e18$var$uc(a, 0)) break;
                        e = a.suspendedLanes;
                        if ((e & d) !== d) {
                            $cee7ff159d524e18$var$R();
                            a.pingedLanes |= a.suspendedLanes & e;
                            break;
                        }
                        a.timeoutHandle = $cee7ff159d524e18$var$Ff($cee7ff159d524e18$var$Pk.bind(null, a, $cee7ff159d524e18$var$tk, $cee7ff159d524e18$var$uk), b);
                        break;
                    }
                    $cee7ff159d524e18$var$Pk(a, $cee7ff159d524e18$var$tk, $cee7ff159d524e18$var$uk);
                    break;
                case 4:
                    $cee7ff159d524e18$var$Ck(a, d);
                    if ((d & 4194240) === d) break;
                    b = a.eventTimes;
                    for(e = -1; 0 < d;){
                        var g = 31 - $cee7ff159d524e18$var$oc(d);
                        f = 1 << g;
                        g = b[g];
                        g > e && (e = g);
                        d &= ~f;
                    }
                    d = e;
                    d = $cee7ff159d524e18$var$B() - d;
                    d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * $cee7ff159d524e18$var$lk(d / 1960)) - d;
                    if (10 < d) {
                        a.timeoutHandle = $cee7ff159d524e18$var$Ff($cee7ff159d524e18$var$Pk.bind(null, a, $cee7ff159d524e18$var$tk, $cee7ff159d524e18$var$uk), d);
                        break;
                    }
                    $cee7ff159d524e18$var$Pk(a, $cee7ff159d524e18$var$tk, $cee7ff159d524e18$var$uk);
                    break;
                case 5:
                    $cee7ff159d524e18$var$Pk(a, $cee7ff159d524e18$var$tk, $cee7ff159d524e18$var$uk);
                    break;
                default:
                    throw Error($cee7ff159d524e18$var$p(329));
            }
        }
    }
    $cee7ff159d524e18$var$Dk(a, $cee7ff159d524e18$var$B());
    return a.callbackNode === c ? $cee7ff159d524e18$var$Gk.bind(null, a) : null;
}
function $cee7ff159d524e18$var$Nk(a, b) {
    var c = $cee7ff159d524e18$var$sk;
    a.current.memoizedState.isDehydrated && ($cee7ff159d524e18$var$Kk(a, b).flags |= 256);
    a = $cee7ff159d524e18$var$Ik(a, b);
    2 !== a && (b = $cee7ff159d524e18$var$tk, $cee7ff159d524e18$var$tk = c, null !== b && $cee7ff159d524e18$var$Fj(b));
    return a;
}
function $cee7ff159d524e18$var$Fj(a) {
    null === $cee7ff159d524e18$var$tk ? $cee7ff159d524e18$var$tk = a : $cee7ff159d524e18$var$tk.push.apply($cee7ff159d524e18$var$tk, a);
}
function $cee7ff159d524e18$var$Ok(a) {
    for(var b = a;;){
        if (b.flags & 16384) {
            var c = b.updateQueue;
            if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                var e = c[d], f = e.getSnapshot;
                e = e.value;
                try {
                    if (!$cee7ff159d524e18$var$He(f(), e)) return !1;
                } catch (g) {
                    return !1;
                }
            }
        }
        c = b.child;
        if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
        else {
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return !0;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return !0;
}
function $cee7ff159d524e18$var$Ck(a, b) {
    b &= ~$cee7ff159d524e18$var$rk;
    b &= ~$cee7ff159d524e18$var$qk;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - $cee7ff159d524e18$var$oc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function $cee7ff159d524e18$var$Ek(a) {
    if (0 !== ($cee7ff159d524e18$var$K & 6)) throw Error($cee7ff159d524e18$var$p(327));
    $cee7ff159d524e18$var$Hk();
    var b = $cee7ff159d524e18$var$uc(a, 0);
    if (0 === (b & 1)) return $cee7ff159d524e18$var$Dk(a, $cee7ff159d524e18$var$B()), null;
    var c = $cee7ff159d524e18$var$Ik(a, b);
    if (0 !== a.tag && 2 === c) {
        var d = $cee7ff159d524e18$var$xc(a);
        0 !== d && (b = d, c = $cee7ff159d524e18$var$Nk(a, d));
    }
    if (1 === c) throw c = $cee7ff159d524e18$var$pk, $cee7ff159d524e18$var$Kk(a, 0), $cee7ff159d524e18$var$Ck(a, b), $cee7ff159d524e18$var$Dk(a, $cee7ff159d524e18$var$B()), c;
    if (6 === c) throw Error($cee7ff159d524e18$var$p(345));
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    $cee7ff159d524e18$var$Pk(a, $cee7ff159d524e18$var$tk, $cee7ff159d524e18$var$uk);
    $cee7ff159d524e18$var$Dk(a, $cee7ff159d524e18$var$B());
    return null;
}
function $cee7ff159d524e18$var$Qk(a, b) {
    var c = $cee7ff159d524e18$var$K;
    $cee7ff159d524e18$var$K |= 1;
    try {
        return a(b);
    } finally{
        $cee7ff159d524e18$var$K = c, 0 === $cee7ff159d524e18$var$K && ($cee7ff159d524e18$var$Gj = $cee7ff159d524e18$var$B() + 500, $cee7ff159d524e18$var$fg && $cee7ff159d524e18$var$jg());
    }
}
function $cee7ff159d524e18$var$Rk(a) {
    null !== $cee7ff159d524e18$var$wk && 0 === $cee7ff159d524e18$var$wk.tag && 0 === ($cee7ff159d524e18$var$K & 6) && $cee7ff159d524e18$var$Hk();
    var b = $cee7ff159d524e18$var$K;
    $cee7ff159d524e18$var$K |= 1;
    var c = $cee7ff159d524e18$var$ok.transition, d = $cee7ff159d524e18$var$C;
    try {
        if ($cee7ff159d524e18$var$ok.transition = null, $cee7ff159d524e18$var$C = 1, a) return a();
    } finally{
        $cee7ff159d524e18$var$C = d, $cee7ff159d524e18$var$ok.transition = c, $cee7ff159d524e18$var$K = b, 0 === ($cee7ff159d524e18$var$K & 6) && $cee7ff159d524e18$var$jg();
    }
}
function $cee7ff159d524e18$var$Hj() {
    $cee7ff159d524e18$var$fj = $cee7ff159d524e18$var$ej.current;
    $cee7ff159d524e18$var$E($cee7ff159d524e18$var$ej);
}
function $cee7ff159d524e18$var$Kk(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, $cee7ff159d524e18$var$Gf(c));
    if (null !== $cee7ff159d524e18$var$Y) for(c = $cee7ff159d524e18$var$Y.return; null !== c;){
        var d = c;
        $cee7ff159d524e18$var$wg(d);
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $cee7ff159d524e18$var$$f();
                break;
            case 3:
                $cee7ff159d524e18$var$zh();
                $cee7ff159d524e18$var$E($cee7ff159d524e18$var$Wf);
                $cee7ff159d524e18$var$E($cee7ff159d524e18$var$H);
                $cee7ff159d524e18$var$Eh();
                break;
            case 5:
                $cee7ff159d524e18$var$Bh(d);
                break;
            case 4:
                $cee7ff159d524e18$var$zh();
                break;
            case 13:
                $cee7ff159d524e18$var$E($cee7ff159d524e18$var$L);
                break;
            case 19:
                $cee7ff159d524e18$var$E($cee7ff159d524e18$var$L);
                break;
            case 10:
                $cee7ff159d524e18$var$ah(d.type._context);
                break;
            case 22:
            case 23:
                $cee7ff159d524e18$var$Hj();
        }
        c = c.return;
    }
    $cee7ff159d524e18$var$Q = a;
    $cee7ff159d524e18$var$Y = a = $cee7ff159d524e18$var$Pg(a.current, null);
    $cee7ff159d524e18$var$Z = $cee7ff159d524e18$var$fj = b;
    $cee7ff159d524e18$var$T = 0;
    $cee7ff159d524e18$var$pk = null;
    $cee7ff159d524e18$var$rk = $cee7ff159d524e18$var$qk = $cee7ff159d524e18$var$rh = 0;
    $cee7ff159d524e18$var$tk = $cee7ff159d524e18$var$sk = null;
    if (null !== $cee7ff159d524e18$var$fh) {
        for(b = 0; b < $cee7ff159d524e18$var$fh.length; b++)if (c = $cee7ff159d524e18$var$fh[b], d = c.interleaved, null !== d) {
            c.interleaved = null;
            var e = d.next, f = c.pending;
            if (null !== f) {
                var g = f.next;
                f.next = e;
                d.next = g;
            }
            c.pending = d;
        }
        $cee7ff159d524e18$var$fh = null;
    }
    return a;
}
function $cee7ff159d524e18$var$Mk(a, b) {
    do {
        var c = $cee7ff159d524e18$var$Y;
        try {
            $cee7ff159d524e18$var$$g();
            $cee7ff159d524e18$var$Fh.current = $cee7ff159d524e18$var$Rh;
            if ($cee7ff159d524e18$var$Ih) {
                for(var d = $cee7ff159d524e18$var$M.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                $cee7ff159d524e18$var$Ih = !1;
            }
            $cee7ff159d524e18$var$Hh = 0;
            $cee7ff159d524e18$var$O = $cee7ff159d524e18$var$N = $cee7ff159d524e18$var$M = null;
            $cee7ff159d524e18$var$Jh = !1;
            $cee7ff159d524e18$var$Kh = 0;
            $cee7ff159d524e18$var$nk.current = null;
            if (null === c || null === c.return) {
                $cee7ff159d524e18$var$T = 1;
                $cee7ff159d524e18$var$pk = b;
                $cee7ff159d524e18$var$Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = $cee7ff159d524e18$var$Z;
                h.flags |= 32768;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k, m = h, q = m.tag;
                    if (0 === (m.mode & 1) && (0 === q || 11 === q || 15 === q)) {
                        var r = m.alternate;
                        r ? (m.updateQueue = r.updateQueue, m.memoizedState = r.memoizedState, m.lanes = r.lanes) : (m.updateQueue = null, m.memoizedState = null);
                    }
                    var y = $cee7ff159d524e18$var$Ui(g);
                    if (null !== y) {
                        y.flags &= -257;
                        $cee7ff159d524e18$var$Vi(y, g, h, f, b);
                        y.mode & 1 && $cee7ff159d524e18$var$Si(f, l, b);
                        b = y;
                        k = l;
                        var n = b.updateQueue;
                        if (null === n) {
                            var t = new Set;
                            t.add(k);
                            b.updateQueue = t;
                        } else n.add(k);
                        break a;
                    } else {
                        if (0 === (b & 1)) {
                            $cee7ff159d524e18$var$Si(f, l, b);
                            $cee7ff159d524e18$var$tj();
                            break a;
                        }
                        k = Error($cee7ff159d524e18$var$p(426));
                    }
                } else if ($cee7ff159d524e18$var$I && h.mode & 1) {
                    var J = $cee7ff159d524e18$var$Ui(g);
                    if (null !== J) {
                        0 === (J.flags & 65536) && (J.flags |= 256);
                        $cee7ff159d524e18$var$Vi(J, g, h, f, b);
                        $cee7ff159d524e18$var$Jg($cee7ff159d524e18$var$Ji(k, h));
                        break a;
                    }
                }
                f = k = $cee7ff159d524e18$var$Ji(k, h);
                4 !== $cee7ff159d524e18$var$T && ($cee7ff159d524e18$var$T = 2);
                null === $cee7ff159d524e18$var$sk ? $cee7ff159d524e18$var$sk = [
                    f
                ] : $cee7ff159d524e18$var$sk.push(f);
                f = g;
                do {
                    switch(f.tag){
                        case 3:
                            f.flags |= 65536;
                            b &= -b;
                            f.lanes |= b;
                            var x = $cee7ff159d524e18$var$Ni(f, k, b);
                            $cee7ff159d524e18$var$ph(f, x);
                            break a;
                        case 1:
                            h = k;
                            var w = f.type, u = f.stateNode;
                            if (0 === (f.flags & 128) && ("function" === typeof w.getDerivedStateFromError || null !== u && "function" === typeof u.componentDidCatch && (null === $cee7ff159d524e18$var$Ri || !$cee7ff159d524e18$var$Ri.has(u)))) {
                                f.flags |= 65536;
                                b &= -b;
                                f.lanes |= b;
                                var F = $cee7ff159d524e18$var$Qi(f, h, b);
                                $cee7ff159d524e18$var$ph(f, F);
                                break a;
                            }
                    }
                    f = f.return;
                }while (null !== f);
            }
            $cee7ff159d524e18$var$Sk(c);
        } catch (na) {
            b = na;
            $cee7ff159d524e18$var$Y === c && null !== c && ($cee7ff159d524e18$var$Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function $cee7ff159d524e18$var$Jk() {
    var a = $cee7ff159d524e18$var$mk.current;
    $cee7ff159d524e18$var$mk.current = $cee7ff159d524e18$var$Rh;
    return null === a ? $cee7ff159d524e18$var$Rh : a;
}
function $cee7ff159d524e18$var$tj() {
    if (0 === $cee7ff159d524e18$var$T || 3 === $cee7ff159d524e18$var$T || 2 === $cee7ff159d524e18$var$T) $cee7ff159d524e18$var$T = 4;
    null === $cee7ff159d524e18$var$Q || 0 === ($cee7ff159d524e18$var$rh & 268435455) && 0 === ($cee7ff159d524e18$var$qk & 268435455) || $cee7ff159d524e18$var$Ck($cee7ff159d524e18$var$Q, $cee7ff159d524e18$var$Z);
}
function $cee7ff159d524e18$var$Ik(a, b) {
    var c = $cee7ff159d524e18$var$K;
    $cee7ff159d524e18$var$K |= 2;
    var d = $cee7ff159d524e18$var$Jk();
    if ($cee7ff159d524e18$var$Q !== a || $cee7ff159d524e18$var$Z !== b) $cee7ff159d524e18$var$uk = null, $cee7ff159d524e18$var$Kk(a, b);
    for(;;)try {
        $cee7ff159d524e18$var$Tk();
        break;
    } catch (e) {
        $cee7ff159d524e18$var$Mk(a, e);
    }
    $cee7ff159d524e18$var$$g();
    $cee7ff159d524e18$var$K = c;
    $cee7ff159d524e18$var$mk.current = d;
    if (null !== $cee7ff159d524e18$var$Y) throw Error($cee7ff159d524e18$var$p(261));
    $cee7ff159d524e18$var$Q = null;
    $cee7ff159d524e18$var$Z = 0;
    return $cee7ff159d524e18$var$T;
}
function $cee7ff159d524e18$var$Tk() {
    for(; null !== $cee7ff159d524e18$var$Y;)$cee7ff159d524e18$var$Uk($cee7ff159d524e18$var$Y);
}
function $cee7ff159d524e18$var$Lk() {
    for(; null !== $cee7ff159d524e18$var$Y && !$cee7ff159d524e18$var$cc();)$cee7ff159d524e18$var$Uk($cee7ff159d524e18$var$Y);
}
function $cee7ff159d524e18$var$Uk(a) {
    var b = $cee7ff159d524e18$var$Vk(a.alternate, a, $cee7ff159d524e18$var$fj);
    a.memoizedProps = a.pendingProps;
    null === b ? $cee7ff159d524e18$var$Sk(a) : $cee7ff159d524e18$var$Y = b;
    $cee7ff159d524e18$var$nk.current = null;
}
function $cee7ff159d524e18$var$Sk(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 32768)) {
            if (c = $cee7ff159d524e18$var$Ej(c, b, $cee7ff159d524e18$var$fj), null !== c) {
                $cee7ff159d524e18$var$Y = c;
                return;
            }
        } else {
            c = $cee7ff159d524e18$var$Ij(c, b);
            if (null !== c) {
                c.flags &= 32767;
                $cee7ff159d524e18$var$Y = c;
                return;
            }
            if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
            else {
                $cee7ff159d524e18$var$T = 6;
                $cee7ff159d524e18$var$Y = null;
                return;
            }
        }
        b = b.sibling;
        if (null !== b) {
            $cee7ff159d524e18$var$Y = b;
            return;
        }
        $cee7ff159d524e18$var$Y = b = a;
    }while (null !== b);
    0 === $cee7ff159d524e18$var$T && ($cee7ff159d524e18$var$T = 5);
}
function $cee7ff159d524e18$var$Pk(a, b, c) {
    var d = $cee7ff159d524e18$var$C, e = $cee7ff159d524e18$var$ok.transition;
    try {
        $cee7ff159d524e18$var$ok.transition = null, $cee7ff159d524e18$var$C = 1, $cee7ff159d524e18$var$Wk(a, b, c, d);
    } finally{
        $cee7ff159d524e18$var$ok.transition = e, $cee7ff159d524e18$var$C = d;
    }
    return null;
}
function $cee7ff159d524e18$var$Wk(a, b, c, d) {
    do $cee7ff159d524e18$var$Hk();
    while (null !== $cee7ff159d524e18$var$wk);
    if (0 !== ($cee7ff159d524e18$var$K & 6)) throw Error($cee7ff159d524e18$var$p(327));
    c = a.finishedWork;
    var e = a.finishedLanes;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error($cee7ff159d524e18$var$p(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var f = c.lanes | c.childLanes;
    $cee7ff159d524e18$var$Bc(a, f);
    a === $cee7ff159d524e18$var$Q && ($cee7ff159d524e18$var$Y = $cee7ff159d524e18$var$Q = null, $cee7ff159d524e18$var$Z = 0);
    0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || $cee7ff159d524e18$var$vk || ($cee7ff159d524e18$var$vk = !0, $cee7ff159d524e18$var$Fk($cee7ff159d524e18$var$hc, function() {
        $cee7ff159d524e18$var$Hk();
        return null;
    }));
    f = 0 !== (c.flags & 15990);
    if (0 !== (c.subtreeFlags & 15990) || f) {
        f = $cee7ff159d524e18$var$ok.transition;
        $cee7ff159d524e18$var$ok.transition = null;
        var g = $cee7ff159d524e18$var$C;
        $cee7ff159d524e18$var$C = 1;
        var h = $cee7ff159d524e18$var$K;
        $cee7ff159d524e18$var$K |= 4;
        $cee7ff159d524e18$var$nk.current = null;
        $cee7ff159d524e18$var$Oj(a, c);
        $cee7ff159d524e18$var$dk(c, a);
        $cee7ff159d524e18$var$Oe($cee7ff159d524e18$var$Df);
        $cee7ff159d524e18$var$dd = !!$cee7ff159d524e18$var$Cf;
        $cee7ff159d524e18$var$Df = $cee7ff159d524e18$var$Cf = null;
        a.current = c;
        $cee7ff159d524e18$var$hk(c, a, e);
        $cee7ff159d524e18$var$dc();
        $cee7ff159d524e18$var$K = h;
        $cee7ff159d524e18$var$C = g;
        $cee7ff159d524e18$var$ok.transition = f;
    } else a.current = c;
    $cee7ff159d524e18$var$vk && ($cee7ff159d524e18$var$vk = !1, $cee7ff159d524e18$var$wk = a, $cee7ff159d524e18$var$xk = e);
    f = a.pendingLanes;
    0 === f && ($cee7ff159d524e18$var$Ri = null);
    $cee7ff159d524e18$var$mc(c.stateNode, d);
    $cee7ff159d524e18$var$Dk(a, $cee7ff159d524e18$var$B());
    if (null !== b) for(d = a.onRecoverableError, c = 0; c < b.length; c++)e = b[c], d(e.value, {
        componentStack: e.stack,
        digest: e.digest
    });
    if ($cee7ff159d524e18$var$Oi) throw $cee7ff159d524e18$var$Oi = !1, a = $cee7ff159d524e18$var$Pi, $cee7ff159d524e18$var$Pi = null, a;
    0 !== ($cee7ff159d524e18$var$xk & 1) && 0 !== a.tag && $cee7ff159d524e18$var$Hk();
    f = a.pendingLanes;
    0 !== (f & 1) ? a === $cee7ff159d524e18$var$zk ? $cee7ff159d524e18$var$yk++ : ($cee7ff159d524e18$var$yk = 0, $cee7ff159d524e18$var$zk = a) : $cee7ff159d524e18$var$yk = 0;
    $cee7ff159d524e18$var$jg();
    return null;
}
function $cee7ff159d524e18$var$Hk() {
    if (null !== $cee7ff159d524e18$var$wk) {
        var a = $cee7ff159d524e18$var$Dc($cee7ff159d524e18$var$xk), b = $cee7ff159d524e18$var$ok.transition, c = $cee7ff159d524e18$var$C;
        try {
            $cee7ff159d524e18$var$ok.transition = null;
            $cee7ff159d524e18$var$C = 16 > a ? 16 : a;
            if (null === $cee7ff159d524e18$var$wk) var d = !1;
            else {
                a = $cee7ff159d524e18$var$wk;
                $cee7ff159d524e18$var$wk = null;
                $cee7ff159d524e18$var$xk = 0;
                if (0 !== ($cee7ff159d524e18$var$K & 6)) throw Error($cee7ff159d524e18$var$p(331));
                var e = $cee7ff159d524e18$var$K;
                $cee7ff159d524e18$var$K |= 4;
                for($cee7ff159d524e18$var$V = a.current; null !== $cee7ff159d524e18$var$V;){
                    var f = $cee7ff159d524e18$var$V, g = f.child;
                    if (0 !== ($cee7ff159d524e18$var$V.flags & 16)) {
                        var h = f.deletions;
                        if (null !== h) {
                            for(var k = 0; k < h.length; k++){
                                var l = h[k];
                                for($cee7ff159d524e18$var$V = l; null !== $cee7ff159d524e18$var$V;){
                                    var m = $cee7ff159d524e18$var$V;
                                    switch(m.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            $cee7ff159d524e18$var$Pj(8, m, f);
                                    }
                                    var q = m.child;
                                    if (null !== q) q.return = m, $cee7ff159d524e18$var$V = q;
                                    else for(; null !== $cee7ff159d524e18$var$V;){
                                        m = $cee7ff159d524e18$var$V;
                                        var r = m.sibling, y = m.return;
                                        $cee7ff159d524e18$var$Sj(m);
                                        if (m === l) {
                                            $cee7ff159d524e18$var$V = null;
                                            break;
                                        }
                                        if (null !== r) {
                                            r.return = y;
                                            $cee7ff159d524e18$var$V = r;
                                            break;
                                        }
                                        $cee7ff159d524e18$var$V = y;
                                    }
                                }
                            }
                            var n = f.alternate;
                            if (null !== n) {
                                var t = n.child;
                                if (null !== t) {
                                    n.child = null;
                                    do {
                                        var J = t.sibling;
                                        t.sibling = null;
                                        t = J;
                                    }while (null !== t);
                                }
                            }
                            $cee7ff159d524e18$var$V = f;
                        }
                    }
                    if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, $cee7ff159d524e18$var$V = g;
                    else b: for(; null !== $cee7ff159d524e18$var$V;){
                        f = $cee7ff159d524e18$var$V;
                        if (0 !== (f.flags & 2048)) switch(f.tag){
                            case 0:
                            case 11:
                            case 15:
                                $cee7ff159d524e18$var$Pj(9, f, f.return);
                        }
                        var x = f.sibling;
                        if (null !== x) {
                            x.return = f.return;
                            $cee7ff159d524e18$var$V = x;
                            break b;
                        }
                        $cee7ff159d524e18$var$V = f.return;
                    }
                }
                var w = a.current;
                for($cee7ff159d524e18$var$V = w; null !== $cee7ff159d524e18$var$V;){
                    g = $cee7ff159d524e18$var$V;
                    var u = g.child;
                    if (0 !== (g.subtreeFlags & 2064) && null !== u) u.return = g, $cee7ff159d524e18$var$V = u;
                    else b: for(g = w; null !== $cee7ff159d524e18$var$V;){
                        h = $cee7ff159d524e18$var$V;
                        if (0 !== (h.flags & 2048)) try {
                            switch(h.tag){
                                case 0:
                                case 11:
                                case 15:
                                    $cee7ff159d524e18$var$Qj(9, h);
                            }
                        } catch (na) {
                            $cee7ff159d524e18$var$W(h, h.return, na);
                        }
                        if (h === g) {
                            $cee7ff159d524e18$var$V = null;
                            break b;
                        }
                        var F = h.sibling;
                        if (null !== F) {
                            F.return = h.return;
                            $cee7ff159d524e18$var$V = F;
                            break b;
                        }
                        $cee7ff159d524e18$var$V = h.return;
                    }
                }
                $cee7ff159d524e18$var$K = e;
                $cee7ff159d524e18$var$jg();
                if ($cee7ff159d524e18$var$lc && "function" === typeof $cee7ff159d524e18$var$lc.onPostCommitFiberRoot) try {
                    $cee7ff159d524e18$var$lc.onPostCommitFiberRoot($cee7ff159d524e18$var$kc, a);
                } catch (na) {}
                d = !0;
            }
            return d;
        } finally{
            $cee7ff159d524e18$var$C = c, $cee7ff159d524e18$var$ok.transition = b;
        }
    }
    return !1;
}
function $cee7ff159d524e18$var$Xk(a, b, c) {
    b = $cee7ff159d524e18$var$Ji(c, b);
    b = $cee7ff159d524e18$var$Ni(a, b, 1);
    a = $cee7ff159d524e18$var$nh(a, b, 1);
    b = $cee7ff159d524e18$var$R();
    null !== a && ($cee7ff159d524e18$var$Ac(a, 1, b), $cee7ff159d524e18$var$Dk(a, b));
}
function $cee7ff159d524e18$var$W(a, b, c) {
    if (3 === a.tag) $cee7ff159d524e18$var$Xk(a, a, c);
    else for(; null !== b;){
        if (3 === b.tag) {
            $cee7ff159d524e18$var$Xk(b, a, c);
            break;
        } else if (1 === b.tag) {
            var d = b.stateNode;
            if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === $cee7ff159d524e18$var$Ri || !$cee7ff159d524e18$var$Ri.has(d))) {
                a = $cee7ff159d524e18$var$Ji(c, a);
                a = $cee7ff159d524e18$var$Qi(b, a, 1);
                b = $cee7ff159d524e18$var$nh(b, a, 1);
                a = $cee7ff159d524e18$var$R();
                null !== b && ($cee7ff159d524e18$var$Ac(b, 1, a), $cee7ff159d524e18$var$Dk(b, a));
                break;
            }
        }
        b = b.return;
    }
}
function $cee7ff159d524e18$var$Ti(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = $cee7ff159d524e18$var$R();
    a.pingedLanes |= a.suspendedLanes & c;
    $cee7ff159d524e18$var$Q === a && ($cee7ff159d524e18$var$Z & c) === c && (4 === $cee7ff159d524e18$var$T || 3 === $cee7ff159d524e18$var$T && ($cee7ff159d524e18$var$Z & 130023424) === $cee7ff159d524e18$var$Z && 500 > $cee7ff159d524e18$var$B() - $cee7ff159d524e18$var$fk ? $cee7ff159d524e18$var$Kk(a, 0) : $cee7ff159d524e18$var$rk |= c);
    $cee7ff159d524e18$var$Dk(a, b);
}
function $cee7ff159d524e18$var$Yk(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 1 : (b = $cee7ff159d524e18$var$sc, $cee7ff159d524e18$var$sc <<= 1, 0 === ($cee7ff159d524e18$var$sc & 130023424) && ($cee7ff159d524e18$var$sc = 4194304)));
    var c = $cee7ff159d524e18$var$R();
    a = $cee7ff159d524e18$var$ih(a, b);
    null !== a && ($cee7ff159d524e18$var$Ac(a, b, c), $cee7ff159d524e18$var$Dk(a, c));
}
function $cee7ff159d524e18$var$uj(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    $cee7ff159d524e18$var$Yk(a, c);
}
function $cee7ff159d524e18$var$bk(a, b) {
    var c = 0;
    switch(a.tag){
        case 13:
            var d = a.stateNode;
            var e = a.memoizedState;
            null !== e && (c = e.retryLane);
            break;
        case 19:
            d = a.stateNode;
            break;
        default:
            throw Error($cee7ff159d524e18$var$p(314));
    }
    null !== d && d.delete(b);
    $cee7ff159d524e18$var$Yk(a, c);
}
var $cee7ff159d524e18$var$Vk;
$cee7ff159d524e18$var$Vk = function(a, b, c) {
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || $cee7ff159d524e18$var$Wf.current) $cee7ff159d524e18$var$dh = !0;
        else {
            if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return $cee7ff159d524e18$var$dh = !1, $cee7ff159d524e18$var$yj(a, b, c);
            $cee7ff159d524e18$var$dh = 0 !== (a.flags & 131072) ? !0 : !1;
        }
    } else $cee7ff159d524e18$var$dh = !1, $cee7ff159d524e18$var$I && 0 !== (b.flags & 1048576) && $cee7ff159d524e18$var$ug(b, $cee7ff159d524e18$var$ng, b.index);
    b.lanes = 0;
    switch(b.tag){
        case 2:
            var d = b.type;
            $cee7ff159d524e18$var$ij(a, b);
            a = b.pendingProps;
            var e = $cee7ff159d524e18$var$Yf(b, $cee7ff159d524e18$var$H.current);
            $cee7ff159d524e18$var$ch(b, c);
            e = $cee7ff159d524e18$var$Nh(null, b, d, a, e, c);
            var f = $cee7ff159d524e18$var$Sh();
            b.flags |= 1;
            "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, $cee7ff159d524e18$var$Zf(d) ? (f = !0, $cee7ff159d524e18$var$cg(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, $cee7ff159d524e18$var$kh(b), e.updater = $cee7ff159d524e18$var$Ei, b.stateNode = e, e._reactInternals = b, $cee7ff159d524e18$var$Ii(b, d, a, c), b = $cee7ff159d524e18$var$jj(null, b, d, !0, f, c)) : (b.tag = 0, $cee7ff159d524e18$var$I && f && $cee7ff159d524e18$var$vg(b), $cee7ff159d524e18$var$Xi(null, b, e, c), b = b.child);
            return b;
        case 16:
            d = b.elementType;
            a: {
                $cee7ff159d524e18$var$ij(a, b);
                a = b.pendingProps;
                e = d._init;
                d = e(d._payload);
                b.type = d;
                e = b.tag = $cee7ff159d524e18$var$Zk(d);
                a = $cee7ff159d524e18$var$Ci(d, a);
                switch(e){
                    case 0:
                        b = $cee7ff159d524e18$var$cj(null, b, d, a, c);
                        break a;
                    case 1:
                        b = $cee7ff159d524e18$var$hj(null, b, d, a, c);
                        break a;
                    case 11:
                        b = $cee7ff159d524e18$var$Yi(null, b, d, a, c);
                        break a;
                    case 14:
                        b = $cee7ff159d524e18$var$$i(null, b, d, $cee7ff159d524e18$var$Ci(d.type, a), c);
                        break a;
                }
                throw Error($cee7ff159d524e18$var$p(306, d, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $cee7ff159d524e18$var$Ci(d, e), $cee7ff159d524e18$var$cj(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $cee7ff159d524e18$var$Ci(d, e), $cee7ff159d524e18$var$hj(a, b, d, e, c);
        case 3:
            a: {
                $cee7ff159d524e18$var$kj(b);
                if (null === a) throw Error($cee7ff159d524e18$var$p(387));
                d = b.pendingProps;
                f = b.memoizedState;
                e = f.element;
                $cee7ff159d524e18$var$lh(a, b);
                $cee7ff159d524e18$var$qh(b, d, null, c);
                var g = b.memoizedState;
                d = g.element;
                if (f.isDehydrated) {
                    if (f = {
                        element: d,
                        isDehydrated: !1,
                        cache: g.cache,
                        pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                        transitions: g.transitions
                    }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                        e = $cee7ff159d524e18$var$Ji(Error($cee7ff159d524e18$var$p(423)), b);
                        b = $cee7ff159d524e18$var$lj(a, b, d, c, e);
                        break a;
                    } else if (d !== e) {
                        e = $cee7ff159d524e18$var$Ji(Error($cee7ff159d524e18$var$p(424)), b);
                        b = $cee7ff159d524e18$var$lj(a, b, d, c, e);
                        break a;
                    } else for($cee7ff159d524e18$var$yg = $cee7ff159d524e18$var$Lf(b.stateNode.containerInfo.firstChild), $cee7ff159d524e18$var$xg = b, $cee7ff159d524e18$var$I = !0, $cee7ff159d524e18$var$zg = null, c = $cee7ff159d524e18$var$Vg(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                } else {
                    $cee7ff159d524e18$var$Ig();
                    if (d === e) {
                        b = $cee7ff159d524e18$var$Zi(a, b, c);
                        break a;
                    }
                    $cee7ff159d524e18$var$Xi(a, b, d, c);
                }
                b = b.child;
            }
            return b;
        case 5:
            return $cee7ff159d524e18$var$Ah(b), null === a && $cee7ff159d524e18$var$Eg(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, $cee7ff159d524e18$var$Ef(d, e) ? g = null : null !== f && $cee7ff159d524e18$var$Ef(d, f) && (b.flags |= 32), $cee7ff159d524e18$var$gj(a, b), $cee7ff159d524e18$var$Xi(a, b, g, c), b.child;
        case 6:
            return null === a && $cee7ff159d524e18$var$Eg(b), null;
        case 13:
            return $cee7ff159d524e18$var$oj(a, b, c);
        case 4:
            return $cee7ff159d524e18$var$yh(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = $cee7ff159d524e18$var$Ug(b, null, d, c) : $cee7ff159d524e18$var$Xi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $cee7ff159d524e18$var$Ci(d, e), $cee7ff159d524e18$var$Yi(a, b, d, e, c);
        case 7:
            return $cee7ff159d524e18$var$Xi(a, b, b.pendingProps, c), b.child;
        case 8:
            return $cee7ff159d524e18$var$Xi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return $cee7ff159d524e18$var$Xi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                f = b.memoizedProps;
                g = e.value;
                $cee7ff159d524e18$var$G($cee7ff159d524e18$var$Wg, d._currentValue);
                d._currentValue = g;
                if (null !== f) {
                    if ($cee7ff159d524e18$var$He(f.value, g)) {
                        if (f.children === e.children && !$cee7ff159d524e18$var$Wf.current) {
                            b = $cee7ff159d524e18$var$Zi(a, b, c);
                            break a;
                        }
                    } else for(f = b.child, null !== f && (f.return = b); null !== f;){
                        var h = f.dependencies;
                        if (null !== h) {
                            g = f.child;
                            for(var k = h.firstContext; null !== k;){
                                if (k.context === d) {
                                    if (1 === f.tag) {
                                        k = $cee7ff159d524e18$var$mh(-1, c & -c);
                                        k.tag = 2;
                                        var l = f.updateQueue;
                                        if (null !== l) {
                                            l = l.shared;
                                            var m = l.pending;
                                            null === m ? k.next = k : (k.next = m.next, m.next = k);
                                            l.pending = k;
                                        }
                                    }
                                    f.lanes |= c;
                                    k = f.alternate;
                                    null !== k && (k.lanes |= c);
                                    $cee7ff159d524e18$var$bh(f.return, c, b);
                                    h.lanes |= c;
                                    break;
                                }
                                k = k.next;
                            }
                        } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                        else if (18 === f.tag) {
                            g = f.return;
                            if (null === g) throw Error($cee7ff159d524e18$var$p(341));
                            g.lanes |= c;
                            h = g.alternate;
                            null !== h && (h.lanes |= c);
                            $cee7ff159d524e18$var$bh(g, c, b);
                            g = f.sibling;
                        } else g = f.child;
                        if (null !== g) g.return = f;
                        else for(g = f; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            f = g.sibling;
                            if (null !== f) {
                                f.return = g.return;
                                g = f;
                                break;
                            }
                            g = g.return;
                        }
                        f = g;
                    }
                }
                $cee7ff159d524e18$var$Xi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, d = b.pendingProps.children, $cee7ff159d524e18$var$ch(b, c), e = $cee7ff159d524e18$var$eh(e), d = d(e), b.flags |= 1, $cee7ff159d524e18$var$Xi(a, b, d, c), b.child;
        case 14:
            return d = b.type, e = $cee7ff159d524e18$var$Ci(d, b.pendingProps), e = $cee7ff159d524e18$var$Ci(d.type, e), $cee7ff159d524e18$var$$i(a, b, d, e, c);
        case 15:
            return $cee7ff159d524e18$var$bj(a, b, b.type, b.pendingProps, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $cee7ff159d524e18$var$Ci(d, e), $cee7ff159d524e18$var$ij(a, b), b.tag = 1, $cee7ff159d524e18$var$Zf(d) ? (a = !0, $cee7ff159d524e18$var$cg(b)) : a = !1, $cee7ff159d524e18$var$ch(b, c), $cee7ff159d524e18$var$Gi(b, d, e), $cee7ff159d524e18$var$Ii(b, d, e, c), $cee7ff159d524e18$var$jj(null, b, d, !0, a, c);
        case 19:
            return $cee7ff159d524e18$var$xj(a, b, c);
        case 22:
            return $cee7ff159d524e18$var$dj(a, b, c);
    }
    throw Error($cee7ff159d524e18$var$p(156, b.tag));
};
function $cee7ff159d524e18$var$Fk(a, b) {
    return $cee7ff159d524e18$var$ac(a, b);
}
function $cee7ff159d524e18$var$$k(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $cee7ff159d524e18$var$Bg(a, b, c, d) {
    return new $cee7ff159d524e18$var$$k(a, b, c, d);
}
function $cee7ff159d524e18$var$aj(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function $cee7ff159d524e18$var$Zk(a) {
    if ("function" === typeof a) return $cee7ff159d524e18$var$aj(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === $cee7ff159d524e18$var$Da) return 11;
        if (a === $cee7ff159d524e18$var$Ga) return 14;
    }
    return 2;
}
function $cee7ff159d524e18$var$Pg(a, b) {
    var c = a.alternate;
    null === c ? (c = $cee7ff159d524e18$var$Bg(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function $cee7ff159d524e18$var$Rg(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) $cee7ff159d524e18$var$aj(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case $cee7ff159d524e18$var$ya:
            return $cee7ff159d524e18$var$Tg(c.children, e, f, b);
        case $cee7ff159d524e18$var$za:
            g = 8;
            e |= 8;
            break;
        case $cee7ff159d524e18$var$Aa:
            return a = $cee7ff159d524e18$var$Bg(12, c, b, e | 2), a.elementType = $cee7ff159d524e18$var$Aa, a.lanes = f, a;
        case $cee7ff159d524e18$var$Ea:
            return a = $cee7ff159d524e18$var$Bg(13, c, b, e), a.elementType = $cee7ff159d524e18$var$Ea, a.lanes = f, a;
        case $cee7ff159d524e18$var$Fa:
            return a = $cee7ff159d524e18$var$Bg(19, c, b, e), a.elementType = $cee7ff159d524e18$var$Fa, a.lanes = f, a;
        case $cee7ff159d524e18$var$Ia:
            return $cee7ff159d524e18$var$pj(c, e, f, b);
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case $cee7ff159d524e18$var$Ba:
                    g = 10;
                    break a;
                case $cee7ff159d524e18$var$Ca:
                    g = 9;
                    break a;
                case $cee7ff159d524e18$var$Da:
                    g = 11;
                    break a;
                case $cee7ff159d524e18$var$Ga:
                    g = 14;
                    break a;
                case $cee7ff159d524e18$var$Ha:
                    g = 16;
                    d = null;
                    break a;
            }
            throw Error($cee7ff159d524e18$var$p(130, null == a ? a : typeof a, ""));
    }
    b = $cee7ff159d524e18$var$Bg(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function $cee7ff159d524e18$var$Tg(a, b, c, d) {
    a = $cee7ff159d524e18$var$Bg(7, a, d, b);
    a.lanes = c;
    return a;
}
function $cee7ff159d524e18$var$pj(a, b, c, d) {
    a = $cee7ff159d524e18$var$Bg(22, a, d, b);
    a.elementType = $cee7ff159d524e18$var$Ia;
    a.lanes = c;
    a.stateNode = {
        isHidden: !1
    };
    return a;
}
function $cee7ff159d524e18$var$Qg(a, b, c) {
    a = $cee7ff159d524e18$var$Bg(6, a, null, b);
    a.lanes = c;
    return a;
}
function $cee7ff159d524e18$var$Sg(a, b, c) {
    b = $cee7ff159d524e18$var$Bg(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function $cee7ff159d524e18$var$al(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = $cee7ff159d524e18$var$zc(0);
    this.expirationTimes = $cee7ff159d524e18$var$zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $cee7ff159d524e18$var$zc(0);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.mutableSourceEagerHydrationData = null;
}
function $cee7ff159d524e18$var$bl(a, b, c, d, e, f, g, h, k) {
    a = new $cee7ff159d524e18$var$al(a, b, c, h, k);
    1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
    f = $cee7ff159d524e18$var$Bg(3, null, null, b);
    a.current = f;
    f.stateNode = a;
    f.memoizedState = {
        element: d,
        isDehydrated: c,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null
    };
    $cee7ff159d524e18$var$kh(f);
    return a;
}
function $cee7ff159d524e18$var$cl(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $cee7ff159d524e18$var$wa,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function $cee7ff159d524e18$var$dl(a) {
    if (!a) return $cee7ff159d524e18$var$Vf;
    a = a._reactInternals;
    a: {
        if ($cee7ff159d524e18$var$Vb(a) !== a || 1 !== a.tag) throw Error($cee7ff159d524e18$var$p(170));
        var b = a;
        do {
            switch(b.tag){
                case 3:
                    b = b.stateNode.context;
                    break a;
                case 1:
                    if ($cee7ff159d524e18$var$Zf(b.type)) {
                        b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                        break a;
                    }
            }
            b = b.return;
        }while (null !== b);
        throw Error($cee7ff159d524e18$var$p(171));
    }
    if (1 === a.tag) {
        var c = a.type;
        if ($cee7ff159d524e18$var$Zf(c)) return $cee7ff159d524e18$var$bg(a, c, b);
    }
    return b;
}
function $cee7ff159d524e18$var$el(a, b, c, d, e, f, g, h, k) {
    a = $cee7ff159d524e18$var$bl(c, d, !0, a, e, f, g, h, k);
    a.context = $cee7ff159d524e18$var$dl(null);
    c = a.current;
    d = $cee7ff159d524e18$var$R();
    e = $cee7ff159d524e18$var$yi(c);
    f = $cee7ff159d524e18$var$mh(d, e);
    f.callback = void 0 !== b && null !== b ? b : null;
    $cee7ff159d524e18$var$nh(c, f, e);
    a.current.lanes = e;
    $cee7ff159d524e18$var$Ac(a, e, d);
    $cee7ff159d524e18$var$Dk(a, d);
    return a;
}
function $cee7ff159d524e18$var$fl(a, b, c, d) {
    var e = b.current, f = $cee7ff159d524e18$var$R(), g = $cee7ff159d524e18$var$yi(e);
    c = $cee7ff159d524e18$var$dl(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = $cee7ff159d524e18$var$mh(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    a = $cee7ff159d524e18$var$nh(e, b, g);
    null !== a && ($cee7ff159d524e18$var$gi(a, e, g, f), $cee7ff159d524e18$var$oh(a, e, g));
    return g;
}
function $cee7ff159d524e18$var$gl(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function $cee7ff159d524e18$var$hl(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function $cee7ff159d524e18$var$il(a, b) {
    $cee7ff159d524e18$var$hl(a, b);
    (a = a.alternate) && $cee7ff159d524e18$var$hl(a, b);
}
function $cee7ff159d524e18$var$jl() {
    return null;
}
var $cee7ff159d524e18$var$kl = "function" === typeof reportError ? reportError : function(a) {
    console.error(a);
};
function $cee7ff159d524e18$var$ll(a) {
    this._internalRoot = a;
}
$cee7ff159d524e18$var$ml.prototype.render = $cee7ff159d524e18$var$ll.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error($cee7ff159d524e18$var$p(409));
    $cee7ff159d524e18$var$fl(a, b, null, null);
};
$cee7ff159d524e18$var$ml.prototype.unmount = $cee7ff159d524e18$var$ll.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
        this._internalRoot = null;
        var b = a.containerInfo;
        $cee7ff159d524e18$var$Rk(function() {
            $cee7ff159d524e18$var$fl(null, a, null, null);
        });
        b[$cee7ff159d524e18$var$uf] = null;
    }
};
function $cee7ff159d524e18$var$ml(a) {
    this._internalRoot = a;
}
$cee7ff159d524e18$var$ml.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
        var b = $cee7ff159d524e18$var$Hc();
        a = {
            blockedOn: null,
            target: a,
            priority: b
        };
        for(var c = 0; c < $cee7ff159d524e18$var$Qc.length && 0 !== b && b < $cee7ff159d524e18$var$Qc[c].priority; c++);
        $cee7ff159d524e18$var$Qc.splice(c, 0, a);
        0 === c && $cee7ff159d524e18$var$Vc(a);
    }
};
function $cee7ff159d524e18$var$nl(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function $cee7ff159d524e18$var$ol(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function $cee7ff159d524e18$var$pl() {}
function $cee7ff159d524e18$var$ql(a, b, c, d, e) {
    if (e) {
        if ("function" === typeof d) {
            var f = d;
            d = function() {
                var a = $cee7ff159d524e18$var$gl(g);
                f.call(a);
            };
        }
        var g = $cee7ff159d524e18$var$el(b, d, a, 0, null, !1, !1, "", $cee7ff159d524e18$var$pl);
        a._reactRootContainer = g;
        a[$cee7ff159d524e18$var$uf] = g.current;
        $cee7ff159d524e18$var$sf(8 === a.nodeType ? a.parentNode : a);
        $cee7ff159d524e18$var$Rk();
        return g;
    }
    for(; e = a.lastChild;)a.removeChild(e);
    if ("function" === typeof d) {
        var h = d;
        d = function() {
            var a = $cee7ff159d524e18$var$gl(k);
            h.call(a);
        };
    }
    var k = $cee7ff159d524e18$var$bl(a, 0, !1, null, null, !1, !1, "", $cee7ff159d524e18$var$pl);
    a._reactRootContainer = k;
    a[$cee7ff159d524e18$var$uf] = k.current;
    $cee7ff159d524e18$var$sf(8 === a.nodeType ? a.parentNode : a);
    $cee7ff159d524e18$var$Rk(function() {
        $cee7ff159d524e18$var$fl(b, k, c, d);
    });
    return k;
}
function $cee7ff159d524e18$var$rl(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = $cee7ff159d524e18$var$gl(g);
                h.call(a);
            };
        }
        $cee7ff159d524e18$var$fl(b, g, a, e);
    } else g = $cee7ff159d524e18$var$ql(c, b, a, e, d);
    return $cee7ff159d524e18$var$gl(g);
}
$cee7ff159d524e18$var$Ec = function(a) {
    switch(a.tag){
        case 3:
            var b = a.stateNode;
            if (b.current.memoizedState.isDehydrated) {
                var c = $cee7ff159d524e18$var$tc(b.pendingLanes);
                0 !== c && ($cee7ff159d524e18$var$Cc(b, c | 1), $cee7ff159d524e18$var$Dk(b, $cee7ff159d524e18$var$B()), 0 === ($cee7ff159d524e18$var$K & 6) && ($cee7ff159d524e18$var$Gj = $cee7ff159d524e18$var$B() + 500, $cee7ff159d524e18$var$jg()));
            }
            break;
        case 13:
            $cee7ff159d524e18$var$Rk(function() {
                var b = $cee7ff159d524e18$var$ih(a, 1);
                if (null !== b) {
                    var c = $cee7ff159d524e18$var$R();
                    $cee7ff159d524e18$var$gi(b, a, 1, c);
                }
            }), $cee7ff159d524e18$var$il(a, 1);
    }
};
$cee7ff159d524e18$var$Fc = function(a) {
    if (13 === a.tag) {
        var b = $cee7ff159d524e18$var$ih(a, 134217728);
        if (null !== b) {
            var c = $cee7ff159d524e18$var$R();
            $cee7ff159d524e18$var$gi(b, a, 134217728, c);
        }
        $cee7ff159d524e18$var$il(a, 134217728);
    }
};
$cee7ff159d524e18$var$Gc = function(a) {
    if (13 === a.tag) {
        var b = $cee7ff159d524e18$var$yi(a), c = $cee7ff159d524e18$var$ih(a, b);
        if (null !== c) {
            var d = $cee7ff159d524e18$var$R();
            $cee7ff159d524e18$var$gi(c, a, b, d);
        }
        $cee7ff159d524e18$var$il(a, b);
    }
};
$cee7ff159d524e18$var$Hc = function() {
    return $cee7ff159d524e18$var$C;
};
$cee7ff159d524e18$var$Ic = function(a, b) {
    var c = $cee7ff159d524e18$var$C;
    try {
        return $cee7ff159d524e18$var$C = a, b();
    } finally{
        $cee7ff159d524e18$var$C = c;
    }
};
$cee7ff159d524e18$var$yb = function(a, b, c) {
    switch(b){
        case "input":
            $cee7ff159d524e18$var$bb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = $cee7ff159d524e18$var$Db(d);
                        if (!e) throw Error($cee7ff159d524e18$var$p(90));
                        $cee7ff159d524e18$var$Wa(d);
                        $cee7ff159d524e18$var$bb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            $cee7ff159d524e18$var$ib(a, c);
            break;
        case "select":
            b = c.value, null != b && $cee7ff159d524e18$var$fb(a, !!c.multiple, b, !1);
    }
};
$cee7ff159d524e18$var$Gb = $cee7ff159d524e18$var$Qk;
$cee7ff159d524e18$var$Hb = $cee7ff159d524e18$var$Rk;
var $cee7ff159d524e18$var$sl = {
    usingClientEntryPoint: !1,
    Events: [
        $cee7ff159d524e18$var$Cb,
        $cee7ff159d524e18$var$ue,
        $cee7ff159d524e18$var$Db,
        $cee7ff159d524e18$var$Eb,
        $cee7ff159d524e18$var$Fb,
        $cee7ff159d524e18$var$Qk
    ]
}, $cee7ff159d524e18$var$tl = {
    findFiberByHostInstance: $cee7ff159d524e18$var$Wc,
    bundleType: 0,
    version: "18.3.1",
    rendererPackageName: "react-dom"
};
var $cee7ff159d524e18$var$ul = {
    bundleType: $cee7ff159d524e18$var$tl.bundleType,
    version: $cee7ff159d524e18$var$tl.version,
    rendererPackageName: $cee7ff159d524e18$var$tl.rendererPackageName,
    rendererConfig: $cee7ff159d524e18$var$tl.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: $cee7ff159d524e18$var$ua.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = $cee7ff159d524e18$var$Zb(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: $cee7ff159d524e18$var$tl.findFiberByHostInstance || $cee7ff159d524e18$var$jl,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.3.1-next-f1338f8080-20240426"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $cee7ff159d524e18$var$vl = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$cee7ff159d524e18$var$vl.isDisabled && $cee7ff159d524e18$var$vl.supportsFiber) try {
        $cee7ff159d524e18$var$kc = $cee7ff159d524e18$var$vl.inject($cee7ff159d524e18$var$ul), $cee7ff159d524e18$var$lc = $cee7ff159d524e18$var$vl;
    } catch (a) {}
}
$cee7ff159d524e18$export$ae55be85d98224ed = $cee7ff159d524e18$var$sl;
$cee7ff159d524e18$export$d39a5bbd09211389 = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!$cee7ff159d524e18$var$nl(b)) throw Error($cee7ff159d524e18$var$p(200));
    return $cee7ff159d524e18$var$cl(a, b, null, c);
};
$cee7ff159d524e18$export$882461b6382ed46c = function(a, b) {
    if (!$cee7ff159d524e18$var$nl(a)) throw Error($cee7ff159d524e18$var$p(299));
    var c = !1, d = "", e = $cee7ff159d524e18$var$kl;
    null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = $cee7ff159d524e18$var$bl(a, 1, !1, null, null, c, !1, d, e);
    a[$cee7ff159d524e18$var$uf] = b.current;
    $cee7ff159d524e18$var$sf(8 === a.nodeType ? a.parentNode : a);
    return new $cee7ff159d524e18$var$ll(b);
};
$cee7ff159d524e18$export$466bfc07425424d5 = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error($cee7ff159d524e18$var$p(188));
        a = Object.keys(a).join(",");
        throw Error($cee7ff159d524e18$var$p(268, a));
    }
    a = $cee7ff159d524e18$var$Zb(b);
    a = null === a ? null : a.stateNode;
    return a;
};
$cee7ff159d524e18$export$cd75ccfd720a3cd4 = function(a) {
    return $cee7ff159d524e18$var$Rk(a);
};
$cee7ff159d524e18$export$fa8d919ba61d84db = function(a, b, c) {
    if (!$cee7ff159d524e18$var$ol(b)) throw Error($cee7ff159d524e18$var$p(200));
    return $cee7ff159d524e18$var$rl(null, a, b, !0, c);
};
$cee7ff159d524e18$export$757ceba2d55c277e = function(a, b, c) {
    if (!$cee7ff159d524e18$var$nl(a)) throw Error($cee7ff159d524e18$var$p(405));
    var d = null != c && c.hydratedSources || null, e = !1, f = "", g = $cee7ff159d524e18$var$kl;
    null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = $cee7ff159d524e18$var$el(b, null, a, 1, null != c ? c : null, e, !1, f, g);
    a[$cee7ff159d524e18$var$uf] = b.current;
    $cee7ff159d524e18$var$sf(a);
    if (d) for(a = 0; a < d.length; a++)c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [
        c,
        e
    ] : b.mutableSourceEagerHydrationData.push(c, e);
    return new $cee7ff159d524e18$var$ml(b);
};
$cee7ff159d524e18$export$b3890eb0ae9dca99 = function(a, b, c) {
    if (!$cee7ff159d524e18$var$ol(b)) throw Error($cee7ff159d524e18$var$p(200));
    return $cee7ff159d524e18$var$rl(null, a, b, !1, c);
};
$cee7ff159d524e18$export$502457920280e6be = function(a) {
    if (!$cee7ff159d524e18$var$ol(a)) throw Error($cee7ff159d524e18$var$p(40));
    return a._reactRootContainer ? ($cee7ff159d524e18$var$Rk(function() {
        $cee7ff159d524e18$var$rl(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[$cee7ff159d524e18$var$uf] = null;
        });
    }), !0) : !1;
};
$cee7ff159d524e18$export$c78a37762a8d58e1 = $cee7ff159d524e18$var$Qk;
$cee7ff159d524e18$export$dc54d992c10e8a18 = function(a, b, c, d) {
    if (!$cee7ff159d524e18$var$ol(c)) throw Error($cee7ff159d524e18$var$p(200));
    if (null == a || void 0 === a._reactInternals) throw Error($cee7ff159d524e18$var$p(38));
    return $cee7ff159d524e18$var$rl(a, b, c, !1, d);
};
$cee7ff159d524e18$export$83d89fbfd8236492 = "18.3.1-next-f1338f8080-20240426";

});
parcelRegister("2tm1P", function(module, exports) {
'use strict';

module.exports = (parcelRequire("aki8O"));

});
parcelRegister("aki8O", function(module, exports) {
$parcel$export(module.exports, "unstable_now", () => $7849d819ce7d68ad$export$c4744153514ff05d, (v) => $7849d819ce7d68ad$export$c4744153514ff05d = v);
$parcel$export(module.exports, "unstable_IdlePriority", () => $7849d819ce7d68ad$export$3e506c1ccc9cc1a7, (v) => $7849d819ce7d68ad$export$3e506c1ccc9cc1a7 = v);
$parcel$export(module.exports, "unstable_ImmediatePriority", () => $7849d819ce7d68ad$export$e26fe2ed2fa76875, (v) => $7849d819ce7d68ad$export$e26fe2ed2fa76875 = v);
$parcel$export(module.exports, "unstable_LowPriority", () => $7849d819ce7d68ad$export$502329bbf4b505b1, (v) => $7849d819ce7d68ad$export$502329bbf4b505b1 = v);
$parcel$export(module.exports, "unstable_NormalPriority", () => $7849d819ce7d68ad$export$6e3807111c4874c4, (v) => $7849d819ce7d68ad$export$6e3807111c4874c4 = v);
$parcel$export(module.exports, "unstable_Profiling", () => $7849d819ce7d68ad$export$c27134553091fb3a, (v) => $7849d819ce7d68ad$export$c27134553091fb3a = v);
$parcel$export(module.exports, "unstable_UserBlockingPriority", () => $7849d819ce7d68ad$export$33ee1acdc04fd2a2, (v) => $7849d819ce7d68ad$export$33ee1acdc04fd2a2 = v);
$parcel$export(module.exports, "unstable_cancelCallback", () => $7849d819ce7d68ad$export$b00a404bbd5edef2, (v) => $7849d819ce7d68ad$export$b00a404bbd5edef2 = v);
$parcel$export(module.exports, "unstable_continueExecution", () => $7849d819ce7d68ad$export$8352ce38b91d0c62, (v) => $7849d819ce7d68ad$export$8352ce38b91d0c62 = v);
$parcel$export(module.exports, "unstable_forceFrameRate", () => $7849d819ce7d68ad$export$d66a1c1c77bd778b, (v) => $7849d819ce7d68ad$export$d66a1c1c77bd778b = v);
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", () => $7849d819ce7d68ad$export$d3dfb8e4810cb555, (v) => $7849d819ce7d68ad$export$d3dfb8e4810cb555 = v);
$parcel$export(module.exports, "unstable_getFirstCallbackNode", () => $7849d819ce7d68ad$export$839f9183b0465a69, (v) => $7849d819ce7d68ad$export$839f9183b0465a69 = v);
$parcel$export(module.exports, "unstable_next", () => $7849d819ce7d68ad$export$72fdf0e06517287b, (v) => $7849d819ce7d68ad$export$72fdf0e06517287b = v);
$parcel$export(module.exports, "unstable_pauseExecution", () => $7849d819ce7d68ad$export$4b844e58a3e414b4, (v) => $7849d819ce7d68ad$export$4b844e58a3e414b4 = v);
$parcel$export(module.exports, "unstable_requestPaint", () => $7849d819ce7d68ad$export$816d2913ae6b83b1, (v) => $7849d819ce7d68ad$export$816d2913ae6b83b1 = v);
$parcel$export(module.exports, "unstable_runWithPriority", () => $7849d819ce7d68ad$export$61bcfe829111a1d0, (v) => $7849d819ce7d68ad$export$61bcfe829111a1d0 = v);
$parcel$export(module.exports, "unstable_scheduleCallback", () => $7849d819ce7d68ad$export$7ee8c9beb337bc3f, (v) => $7849d819ce7d68ad$export$7ee8c9beb337bc3f = v);
$parcel$export(module.exports, "unstable_shouldYield", () => $7849d819ce7d68ad$export$b5836b71941fa3ed, (v) => $7849d819ce7d68ad$export$b5836b71941fa3ed = v);
$parcel$export(module.exports, "unstable_wrapCallback", () => $7849d819ce7d68ad$export$cf845f2c119da08a, (v) => $7849d819ce7d68ad$export$cf845f2c119da08a = v);
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $7849d819ce7d68ad$export$c4744153514ff05d;
var $7849d819ce7d68ad$export$3e506c1ccc9cc1a7;
var $7849d819ce7d68ad$export$e26fe2ed2fa76875;
var $7849d819ce7d68ad$export$502329bbf4b505b1;
var $7849d819ce7d68ad$export$6e3807111c4874c4;
var $7849d819ce7d68ad$export$c27134553091fb3a;
var $7849d819ce7d68ad$export$33ee1acdc04fd2a2;
var $7849d819ce7d68ad$export$b00a404bbd5edef2;
var $7849d819ce7d68ad$export$8352ce38b91d0c62;
var $7849d819ce7d68ad$export$d66a1c1c77bd778b;
var $7849d819ce7d68ad$export$d3dfb8e4810cb555;
var $7849d819ce7d68ad$export$839f9183b0465a69;
var $7849d819ce7d68ad$export$72fdf0e06517287b;
var $7849d819ce7d68ad$export$4b844e58a3e414b4;
var $7849d819ce7d68ad$export$816d2913ae6b83b1;
var $7849d819ce7d68ad$export$61bcfe829111a1d0;
var $7849d819ce7d68ad$export$7ee8c9beb337bc3f;
var $7849d819ce7d68ad$export$b5836b71941fa3ed;
var $7849d819ce7d68ad$export$cf845f2c119da08a;
'use strict';
function $7849d819ce7d68ad$var$f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < $7849d819ce7d68ad$var$g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $7849d819ce7d68ad$var$h(a) {
    return 0 === a.length ? null : a[0];
}
function $7849d819ce7d68ad$var$k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > $7849d819ce7d68ad$var$g(C, c)) n < e && 0 > $7849d819ce7d68ad$var$g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > $7849d819ce7d68ad$var$g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function $7849d819ce7d68ad$var$g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $7849d819ce7d68ad$var$l = performance;
    $7849d819ce7d68ad$export$c4744153514ff05d = function() {
        return $7849d819ce7d68ad$var$l.now();
    };
} else {
    var $7849d819ce7d68ad$var$p = Date, $7849d819ce7d68ad$var$q = $7849d819ce7d68ad$var$p.now();
    $7849d819ce7d68ad$export$c4744153514ff05d = function() {
        return $7849d819ce7d68ad$var$p.now() - $7849d819ce7d68ad$var$q;
    };
}
var $7849d819ce7d68ad$var$r = [], $7849d819ce7d68ad$var$t = [], $7849d819ce7d68ad$var$u = 1, $7849d819ce7d68ad$var$v = null, $7849d819ce7d68ad$var$y = 3, $7849d819ce7d68ad$var$z = !1, $7849d819ce7d68ad$var$A = !1, $7849d819ce7d68ad$var$B = !1, $7849d819ce7d68ad$var$D = "function" === typeof setTimeout ? setTimeout : null, $7849d819ce7d68ad$var$E = "function" === typeof clearTimeout ? clearTimeout : null, $7849d819ce7d68ad$var$F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function $7849d819ce7d68ad$var$G(a) {
    for(var b = $7849d819ce7d68ad$var$h($7849d819ce7d68ad$var$t); null !== b;){
        if (null === b.callback) $7849d819ce7d68ad$var$k($7849d819ce7d68ad$var$t);
        else if (b.startTime <= a) $7849d819ce7d68ad$var$k($7849d819ce7d68ad$var$t), b.sortIndex = b.expirationTime, $7849d819ce7d68ad$var$f($7849d819ce7d68ad$var$r, b);
        else break;
        b = $7849d819ce7d68ad$var$h($7849d819ce7d68ad$var$t);
    }
}
function $7849d819ce7d68ad$var$H(a) {
    $7849d819ce7d68ad$var$B = !1;
    $7849d819ce7d68ad$var$G(a);
    if (!$7849d819ce7d68ad$var$A) {
        if (null !== $7849d819ce7d68ad$var$h($7849d819ce7d68ad$var$r)) $7849d819ce7d68ad$var$A = !0, $7849d819ce7d68ad$var$I($7849d819ce7d68ad$var$J);
        else {
            var b = $7849d819ce7d68ad$var$h($7849d819ce7d68ad$var$t);
            null !== b && $7849d819ce7d68ad$var$K($7849d819ce7d68ad$var$H, b.startTime - a);
        }
    }
}
function $7849d819ce7d68ad$var$J(a, b) {
    $7849d819ce7d68ad$var$A = !1;
    $7849d819ce7d68ad$var$B && ($7849d819ce7d68ad$var$B = !1, $7849d819ce7d68ad$var$E($7849d819ce7d68ad$var$L), $7849d819ce7d68ad$var$L = -1);
    $7849d819ce7d68ad$var$z = !0;
    var c = $7849d819ce7d68ad$var$y;
    try {
        $7849d819ce7d68ad$var$G(b);
        for($7849d819ce7d68ad$var$v = $7849d819ce7d68ad$var$h($7849d819ce7d68ad$var$r); null !== $7849d819ce7d68ad$var$v && (!($7849d819ce7d68ad$var$v.expirationTime > b) || a && !$7849d819ce7d68ad$var$M());){
            var d = $7849d819ce7d68ad$var$v.callback;
            if ("function" === typeof d) {
                $7849d819ce7d68ad$var$v.callback = null;
                $7849d819ce7d68ad$var$y = $7849d819ce7d68ad$var$v.priorityLevel;
                var e = d($7849d819ce7d68ad$var$v.expirationTime <= b);
                b = $7849d819ce7d68ad$export$c4744153514ff05d();
                "function" === typeof e ? $7849d819ce7d68ad$var$v.callback = e : $7849d819ce7d68ad$var$v === $7849d819ce7d68ad$var$h($7849d819ce7d68ad$var$r) && $7849d819ce7d68ad$var$k($7849d819ce7d68ad$var$r);
                $7849d819ce7d68ad$var$G(b);
            } else $7849d819ce7d68ad$var$k($7849d819ce7d68ad$var$r);
            $7849d819ce7d68ad$var$v = $7849d819ce7d68ad$var$h($7849d819ce7d68ad$var$r);
        }
        if (null !== $7849d819ce7d68ad$var$v) var w = !0;
        else {
            var m = $7849d819ce7d68ad$var$h($7849d819ce7d68ad$var$t);
            null !== m && $7849d819ce7d68ad$var$K($7849d819ce7d68ad$var$H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        $7849d819ce7d68ad$var$v = null, $7849d819ce7d68ad$var$y = c, $7849d819ce7d68ad$var$z = !1;
    }
}
var $7849d819ce7d68ad$var$N = !1, $7849d819ce7d68ad$var$O = null, $7849d819ce7d68ad$var$L = -1, $7849d819ce7d68ad$var$P = 5, $7849d819ce7d68ad$var$Q = -1;
function $7849d819ce7d68ad$var$M() {
    return $7849d819ce7d68ad$export$c4744153514ff05d() - $7849d819ce7d68ad$var$Q < $7849d819ce7d68ad$var$P ? !1 : !0;
}
function $7849d819ce7d68ad$var$R() {
    if (null !== $7849d819ce7d68ad$var$O) {
        var a = $7849d819ce7d68ad$export$c4744153514ff05d();
        $7849d819ce7d68ad$var$Q = a;
        var b = !0;
        try {
            b = $7849d819ce7d68ad$var$O(!0, a);
        } finally{
            b ? $7849d819ce7d68ad$var$S() : ($7849d819ce7d68ad$var$N = !1, $7849d819ce7d68ad$var$O = null);
        }
    } else $7849d819ce7d68ad$var$N = !1;
}
var $7849d819ce7d68ad$var$S;
if ("function" === typeof $7849d819ce7d68ad$var$F) $7849d819ce7d68ad$var$S = function() {
    $7849d819ce7d68ad$var$F($7849d819ce7d68ad$var$R);
};
else if ("undefined" !== typeof MessageChannel) {
    var $7849d819ce7d68ad$var$T = new MessageChannel, $7849d819ce7d68ad$var$U = $7849d819ce7d68ad$var$T.port2;
    $7849d819ce7d68ad$var$T.port1.onmessage = $7849d819ce7d68ad$var$R;
    $7849d819ce7d68ad$var$S = function() {
        $7849d819ce7d68ad$var$U.postMessage(null);
    };
} else $7849d819ce7d68ad$var$S = function() {
    $7849d819ce7d68ad$var$D($7849d819ce7d68ad$var$R, 0);
};
function $7849d819ce7d68ad$var$I(a) {
    $7849d819ce7d68ad$var$O = a;
    $7849d819ce7d68ad$var$N || ($7849d819ce7d68ad$var$N = !0, $7849d819ce7d68ad$var$S());
}
function $7849d819ce7d68ad$var$K(a, b) {
    $7849d819ce7d68ad$var$L = $7849d819ce7d68ad$var$D(function() {
        a($7849d819ce7d68ad$export$c4744153514ff05d());
    }, b);
}
$7849d819ce7d68ad$export$3e506c1ccc9cc1a7 = 5;
$7849d819ce7d68ad$export$e26fe2ed2fa76875 = 1;
$7849d819ce7d68ad$export$502329bbf4b505b1 = 4;
$7849d819ce7d68ad$export$6e3807111c4874c4 = 3;
$7849d819ce7d68ad$export$c27134553091fb3a = null;
$7849d819ce7d68ad$export$33ee1acdc04fd2a2 = 2;
$7849d819ce7d68ad$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$7849d819ce7d68ad$export$8352ce38b91d0c62 = function() {
    $7849d819ce7d68ad$var$A || $7849d819ce7d68ad$var$z || ($7849d819ce7d68ad$var$A = !0, $7849d819ce7d68ad$var$I($7849d819ce7d68ad$var$J));
};
$7849d819ce7d68ad$export$d66a1c1c77bd778b = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $7849d819ce7d68ad$var$P = 0 < a ? Math.floor(1E3 / a) : 5;
};
$7849d819ce7d68ad$export$d3dfb8e4810cb555 = function() {
    return $7849d819ce7d68ad$var$y;
};
$7849d819ce7d68ad$export$839f9183b0465a69 = function() {
    return $7849d819ce7d68ad$var$h($7849d819ce7d68ad$var$r);
};
$7849d819ce7d68ad$export$72fdf0e06517287b = function(a) {
    switch($7849d819ce7d68ad$var$y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $7849d819ce7d68ad$var$y;
    }
    var c = $7849d819ce7d68ad$var$y;
    $7849d819ce7d68ad$var$y = b;
    try {
        return a();
    } finally{
        $7849d819ce7d68ad$var$y = c;
    }
};
$7849d819ce7d68ad$export$4b844e58a3e414b4 = function() {};
$7849d819ce7d68ad$export$816d2913ae6b83b1 = function() {};
$7849d819ce7d68ad$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $7849d819ce7d68ad$var$y;
    $7849d819ce7d68ad$var$y = a;
    try {
        return b();
    } finally{
        $7849d819ce7d68ad$var$y = c;
    }
};
$7849d819ce7d68ad$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $7849d819ce7d68ad$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $7849d819ce7d68ad$var$u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $7849d819ce7d68ad$var$f($7849d819ce7d68ad$var$t, a), null === $7849d819ce7d68ad$var$h($7849d819ce7d68ad$var$r) && a === $7849d819ce7d68ad$var$h($7849d819ce7d68ad$var$t) && ($7849d819ce7d68ad$var$B ? ($7849d819ce7d68ad$var$E($7849d819ce7d68ad$var$L), $7849d819ce7d68ad$var$L = -1) : $7849d819ce7d68ad$var$B = !0, $7849d819ce7d68ad$var$K($7849d819ce7d68ad$var$H, c - d))) : (a.sortIndex = e, $7849d819ce7d68ad$var$f($7849d819ce7d68ad$var$r, a), $7849d819ce7d68ad$var$A || $7849d819ce7d68ad$var$z || ($7849d819ce7d68ad$var$A = !0, $7849d819ce7d68ad$var$I($7849d819ce7d68ad$var$J)));
    return a;
};
$7849d819ce7d68ad$export$b5836b71941fa3ed = $7849d819ce7d68ad$var$M;
$7849d819ce7d68ad$export$cf845f2c119da08a = function(a) {
    var b = $7849d819ce7d68ad$var$y;
    return function() {
        var c = $7849d819ce7d68ad$var$y;
        $7849d819ce7d68ad$var$y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $7849d819ce7d68ad$var$y = c;
        }
    };
};

});



parcelRegister("3gsre", function(module, exports) {
$parcel$export(module.exports, "AsyncMode", () => $2608ecfb9154a3b7$export$2b8d127b894957b9, (v) => $2608ecfb9154a3b7$export$2b8d127b894957b9 = v);
$parcel$export(module.exports, "ConcurrentMode", () => $2608ecfb9154a3b7$export$cea3a54a6425200c, (v) => $2608ecfb9154a3b7$export$cea3a54a6425200c = v);
$parcel$export(module.exports, "ContextConsumer", () => $2608ecfb9154a3b7$export$a7c73072b1a182ae, (v) => $2608ecfb9154a3b7$export$a7c73072b1a182ae = v);
$parcel$export(module.exports, "ContextProvider", () => $2608ecfb9154a3b7$export$9f27bc3417b4524d, (v) => $2608ecfb9154a3b7$export$9f27bc3417b4524d = v);
$parcel$export(module.exports, "Element", () => $2608ecfb9154a3b7$export$db77ccec0bb4ccac, (v) => $2608ecfb9154a3b7$export$db77ccec0bb4ccac = v);
$parcel$export(module.exports, "ForwardRef", () => $2608ecfb9154a3b7$export$8392c0c9d3dcbd35, (v) => $2608ecfb9154a3b7$export$8392c0c9d3dcbd35 = v);
$parcel$export(module.exports, "Fragment", () => $2608ecfb9154a3b7$export$ffb0004e005737fa, (v) => $2608ecfb9154a3b7$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Lazy", () => $2608ecfb9154a3b7$export$b624eff549462981, (v) => $2608ecfb9154a3b7$export$b624eff549462981 = v);
$parcel$export(module.exports, "Memo", () => $2608ecfb9154a3b7$export$7897aa7841a5380c, (v) => $2608ecfb9154a3b7$export$7897aa7841a5380c = v);
$parcel$export(module.exports, "Portal", () => $2608ecfb9154a3b7$export$602eac185826482c, (v) => $2608ecfb9154a3b7$export$602eac185826482c = v);
$parcel$export(module.exports, "Profiler", () => $2608ecfb9154a3b7$export$e2c29f18771995cb, (v) => $2608ecfb9154a3b7$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "StrictMode", () => $2608ecfb9154a3b7$export$5f8d39834fd61797, (v) => $2608ecfb9154a3b7$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $2608ecfb9154a3b7$export$74bf444e3cd11ea5, (v) => $2608ecfb9154a3b7$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "isAsyncMode", () => $2608ecfb9154a3b7$export$92387174baf9b227, (v) => $2608ecfb9154a3b7$export$92387174baf9b227 = v);
$parcel$export(module.exports, "isConcurrentMode", () => $2608ecfb9154a3b7$export$ec112efeb987d9c6, (v) => $2608ecfb9154a3b7$export$ec112efeb987d9c6 = v);
$parcel$export(module.exports, "isContextConsumer", () => $2608ecfb9154a3b7$export$b706b080d889d2c9, (v) => $2608ecfb9154a3b7$export$b706b080d889d2c9 = v);
$parcel$export(module.exports, "isContextProvider", () => $2608ecfb9154a3b7$export$5be5a87408f70ddc, (v) => $2608ecfb9154a3b7$export$5be5a87408f70ddc = v);
$parcel$export(module.exports, "isElement", () => $2608ecfb9154a3b7$export$45a5e7f76e0caa8d, (v) => $2608ecfb9154a3b7$export$45a5e7f76e0caa8d = v);
$parcel$export(module.exports, "isForwardRef", () => $2608ecfb9154a3b7$export$455c2e768291efa6, (v) => $2608ecfb9154a3b7$export$455c2e768291efa6 = v);
$parcel$export(module.exports, "isFragment", () => $2608ecfb9154a3b7$export$9522e17588c12572, (v) => $2608ecfb9154a3b7$export$9522e17588c12572 = v);
$parcel$export(module.exports, "isLazy", () => $2608ecfb9154a3b7$export$2110ac352bb060b9, (v) => $2608ecfb9154a3b7$export$2110ac352bb060b9 = v);
$parcel$export(module.exports, "isMemo", () => $2608ecfb9154a3b7$export$56885ab8b9c456ab, (v) => $2608ecfb9154a3b7$export$56885ab8b9c456ab = v);
$parcel$export(module.exports, "isPortal", () => $2608ecfb9154a3b7$export$d927fcb6adf8f9de, (v) => $2608ecfb9154a3b7$export$d927fcb6adf8f9de = v);
$parcel$export(module.exports, "isProfiler", () => $2608ecfb9154a3b7$export$b82d16f27459e05a, (v) => $2608ecfb9154a3b7$export$b82d16f27459e05a = v);
$parcel$export(module.exports, "isStrictMode", () => $2608ecfb9154a3b7$export$522c17b4f5e123e8, (v) => $2608ecfb9154a3b7$export$522c17b4f5e123e8 = v);
$parcel$export(module.exports, "isSuspense", () => $2608ecfb9154a3b7$export$1aabd8a0274ecfd6, (v) => $2608ecfb9154a3b7$export$1aabd8a0274ecfd6 = v);
$parcel$export(module.exports, "isValidElementType", () => $2608ecfb9154a3b7$export$9b621391a187a31a, (v) => $2608ecfb9154a3b7$export$9b621391a187a31a = v);
$parcel$export(module.exports, "typeOf", () => $2608ecfb9154a3b7$export$f5bbd400c2f4426f, (v) => $2608ecfb9154a3b7$export$f5bbd400c2f4426f = v);
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $2608ecfb9154a3b7$export$2b8d127b894957b9;
var $2608ecfb9154a3b7$export$cea3a54a6425200c;
var $2608ecfb9154a3b7$export$a7c73072b1a182ae;
var $2608ecfb9154a3b7$export$9f27bc3417b4524d;
var $2608ecfb9154a3b7$export$db77ccec0bb4ccac;
var $2608ecfb9154a3b7$export$8392c0c9d3dcbd35;
var $2608ecfb9154a3b7$export$ffb0004e005737fa;
var $2608ecfb9154a3b7$export$b624eff549462981;
var $2608ecfb9154a3b7$export$7897aa7841a5380c;
var $2608ecfb9154a3b7$export$602eac185826482c;
var $2608ecfb9154a3b7$export$e2c29f18771995cb;
var $2608ecfb9154a3b7$export$5f8d39834fd61797;
var $2608ecfb9154a3b7$export$74bf444e3cd11ea5;
var $2608ecfb9154a3b7$export$92387174baf9b227;
var $2608ecfb9154a3b7$export$ec112efeb987d9c6;
var $2608ecfb9154a3b7$export$b706b080d889d2c9;
var $2608ecfb9154a3b7$export$5be5a87408f70ddc;
var $2608ecfb9154a3b7$export$45a5e7f76e0caa8d;
var $2608ecfb9154a3b7$export$455c2e768291efa6;
var $2608ecfb9154a3b7$export$9522e17588c12572;
var $2608ecfb9154a3b7$export$2110ac352bb060b9;
var $2608ecfb9154a3b7$export$56885ab8b9c456ab;
var $2608ecfb9154a3b7$export$d927fcb6adf8f9de;
var $2608ecfb9154a3b7$export$b82d16f27459e05a;
var $2608ecfb9154a3b7$export$522c17b4f5e123e8;
var $2608ecfb9154a3b7$export$1aabd8a0274ecfd6;
var $2608ecfb9154a3b7$export$9b621391a187a31a;
var $2608ecfb9154a3b7$export$f5bbd400c2f4426f;
'use strict';
var $2608ecfb9154a3b7$var$b = "function" === typeof Symbol && Symbol.for, $2608ecfb9154a3b7$var$c = $2608ecfb9154a3b7$var$b ? Symbol.for("react.element") : 60103, $2608ecfb9154a3b7$var$d = $2608ecfb9154a3b7$var$b ? Symbol.for("react.portal") : 60106, $2608ecfb9154a3b7$var$e = $2608ecfb9154a3b7$var$b ? Symbol.for("react.fragment") : 60107, $2608ecfb9154a3b7$var$f = $2608ecfb9154a3b7$var$b ? Symbol.for("react.strict_mode") : 60108, $2608ecfb9154a3b7$var$g = $2608ecfb9154a3b7$var$b ? Symbol.for("react.profiler") : 60114, $2608ecfb9154a3b7$var$h = $2608ecfb9154a3b7$var$b ? Symbol.for("react.provider") : 60109, $2608ecfb9154a3b7$var$k = $2608ecfb9154a3b7$var$b ? Symbol.for("react.context") : 60110, $2608ecfb9154a3b7$var$l = $2608ecfb9154a3b7$var$b ? Symbol.for("react.async_mode") : 60111, $2608ecfb9154a3b7$var$m = $2608ecfb9154a3b7$var$b ? Symbol.for("react.concurrent_mode") : 60111, $2608ecfb9154a3b7$var$n = $2608ecfb9154a3b7$var$b ? Symbol.for("react.forward_ref") : 60112, $2608ecfb9154a3b7$var$p = $2608ecfb9154a3b7$var$b ? Symbol.for("react.suspense") : 60113, $2608ecfb9154a3b7$var$q = $2608ecfb9154a3b7$var$b ? Symbol.for("react.suspense_list") : 60120, $2608ecfb9154a3b7$var$r = $2608ecfb9154a3b7$var$b ? Symbol.for("react.memo") : 60115, $2608ecfb9154a3b7$var$t = $2608ecfb9154a3b7$var$b ? Symbol.for("react.lazy") : 60116, $2608ecfb9154a3b7$var$v = $2608ecfb9154a3b7$var$b ? Symbol.for("react.block") : 60121, $2608ecfb9154a3b7$var$w = $2608ecfb9154a3b7$var$b ? Symbol.for("react.fundamental") : 60117, $2608ecfb9154a3b7$var$x = $2608ecfb9154a3b7$var$b ? Symbol.for("react.responder") : 60118, $2608ecfb9154a3b7$var$y = $2608ecfb9154a3b7$var$b ? Symbol.for("react.scope") : 60119;
function $2608ecfb9154a3b7$var$z(a) {
    if ("object" === typeof a && null !== a) {
        var u = a.$$typeof;
        switch(u){
            case $2608ecfb9154a3b7$var$c:
                switch(a = a.type, a){
                    case $2608ecfb9154a3b7$var$l:
                    case $2608ecfb9154a3b7$var$m:
                    case $2608ecfb9154a3b7$var$e:
                    case $2608ecfb9154a3b7$var$g:
                    case $2608ecfb9154a3b7$var$f:
                    case $2608ecfb9154a3b7$var$p:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $2608ecfb9154a3b7$var$k:
                            case $2608ecfb9154a3b7$var$n:
                            case $2608ecfb9154a3b7$var$t:
                            case $2608ecfb9154a3b7$var$r:
                            case $2608ecfb9154a3b7$var$h:
                                return a;
                            default:
                                return u;
                        }
                }
            case $2608ecfb9154a3b7$var$d:
                return u;
        }
    }
}
function $2608ecfb9154a3b7$var$A(a) {
    return $2608ecfb9154a3b7$var$z(a) === $2608ecfb9154a3b7$var$m;
}
$2608ecfb9154a3b7$export$2b8d127b894957b9 = $2608ecfb9154a3b7$var$l;
$2608ecfb9154a3b7$export$cea3a54a6425200c = $2608ecfb9154a3b7$var$m;
$2608ecfb9154a3b7$export$a7c73072b1a182ae = $2608ecfb9154a3b7$var$k;
$2608ecfb9154a3b7$export$9f27bc3417b4524d = $2608ecfb9154a3b7$var$h;
$2608ecfb9154a3b7$export$db77ccec0bb4ccac = $2608ecfb9154a3b7$var$c;
$2608ecfb9154a3b7$export$8392c0c9d3dcbd35 = $2608ecfb9154a3b7$var$n;
$2608ecfb9154a3b7$export$ffb0004e005737fa = $2608ecfb9154a3b7$var$e;
$2608ecfb9154a3b7$export$b624eff549462981 = $2608ecfb9154a3b7$var$t;
$2608ecfb9154a3b7$export$7897aa7841a5380c = $2608ecfb9154a3b7$var$r;
$2608ecfb9154a3b7$export$602eac185826482c = $2608ecfb9154a3b7$var$d;
$2608ecfb9154a3b7$export$e2c29f18771995cb = $2608ecfb9154a3b7$var$g;
$2608ecfb9154a3b7$export$5f8d39834fd61797 = $2608ecfb9154a3b7$var$f;
$2608ecfb9154a3b7$export$74bf444e3cd11ea5 = $2608ecfb9154a3b7$var$p;
$2608ecfb9154a3b7$export$92387174baf9b227 = function(a) {
    return $2608ecfb9154a3b7$var$A(a) || $2608ecfb9154a3b7$var$z(a) === $2608ecfb9154a3b7$var$l;
};
$2608ecfb9154a3b7$export$ec112efeb987d9c6 = $2608ecfb9154a3b7$var$A;
$2608ecfb9154a3b7$export$b706b080d889d2c9 = function(a) {
    return $2608ecfb9154a3b7$var$z(a) === $2608ecfb9154a3b7$var$k;
};
$2608ecfb9154a3b7$export$5be5a87408f70ddc = function(a) {
    return $2608ecfb9154a3b7$var$z(a) === $2608ecfb9154a3b7$var$h;
};
$2608ecfb9154a3b7$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $2608ecfb9154a3b7$var$c;
};
$2608ecfb9154a3b7$export$455c2e768291efa6 = function(a) {
    return $2608ecfb9154a3b7$var$z(a) === $2608ecfb9154a3b7$var$n;
};
$2608ecfb9154a3b7$export$9522e17588c12572 = function(a) {
    return $2608ecfb9154a3b7$var$z(a) === $2608ecfb9154a3b7$var$e;
};
$2608ecfb9154a3b7$export$2110ac352bb060b9 = function(a) {
    return $2608ecfb9154a3b7$var$z(a) === $2608ecfb9154a3b7$var$t;
};
$2608ecfb9154a3b7$export$56885ab8b9c456ab = function(a) {
    return $2608ecfb9154a3b7$var$z(a) === $2608ecfb9154a3b7$var$r;
};
$2608ecfb9154a3b7$export$d927fcb6adf8f9de = function(a) {
    return $2608ecfb9154a3b7$var$z(a) === $2608ecfb9154a3b7$var$d;
};
$2608ecfb9154a3b7$export$b82d16f27459e05a = function(a) {
    return $2608ecfb9154a3b7$var$z(a) === $2608ecfb9154a3b7$var$g;
};
$2608ecfb9154a3b7$export$522c17b4f5e123e8 = function(a) {
    return $2608ecfb9154a3b7$var$z(a) === $2608ecfb9154a3b7$var$f;
};
$2608ecfb9154a3b7$export$1aabd8a0274ecfd6 = function(a) {
    return $2608ecfb9154a3b7$var$z(a) === $2608ecfb9154a3b7$var$p;
};
$2608ecfb9154a3b7$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $2608ecfb9154a3b7$var$e || a === $2608ecfb9154a3b7$var$m || a === $2608ecfb9154a3b7$var$g || a === $2608ecfb9154a3b7$var$f || a === $2608ecfb9154a3b7$var$p || a === $2608ecfb9154a3b7$var$q || "object" === typeof a && null !== a && (a.$$typeof === $2608ecfb9154a3b7$var$t || a.$$typeof === $2608ecfb9154a3b7$var$r || a.$$typeof === $2608ecfb9154a3b7$var$h || a.$$typeof === $2608ecfb9154a3b7$var$k || a.$$typeof === $2608ecfb9154a3b7$var$n || a.$$typeof === $2608ecfb9154a3b7$var$w || a.$$typeof === $2608ecfb9154a3b7$var$x || a.$$typeof === $2608ecfb9154a3b7$var$y || a.$$typeof === $2608ecfb9154a3b7$var$v);
};
$2608ecfb9154a3b7$export$f5bbd400c2f4426f = $2608ecfb9154a3b7$var$z;

});

parcelRegister("iw5eO", function(module, exports) {

var $ds2UT = parcelRequire("ds2UT");
var $d7af47457e8943a7$var$_typeof = $ds2UT.default;
function $d7af47457e8943a7$var$_regeneratorRuntime() {
    "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ 
    module.exports = $d7af47457e8943a7$var$_regeneratorRuntime = function _regeneratorRuntime() {
        return e;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports;
    var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function(t, e, r) {
        t[e] = r.value;
    }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag";
    function define(t, e, r) {
        return Object.defineProperty(t, e, {
            value: r,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }), t[e];
    }
    try {
        define({}, "");
    } catch (t) {
        define = function define(t, e, r) {
            return t[e] = r;
        };
    }
    function wrap(t, e, r, n) {
        var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []);
        return o(a, "_invoke", {
            value: makeInvokeMethod(t, r, c)
        }), a;
    }
    function tryCatch(t, e, r) {
        try {
            return {
                type: "normal",
                arg: t.call(e, r)
            };
        } catch (t) {
            return {
                type: "throw",
                arg: t
            };
        }
    }
    e.wrap = wrap;
    var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {};
    function Generator() {}
    function GeneratorFunction() {}
    function GeneratorFunctionPrototype() {}
    var p = {};
    define(p, a, function() {
        return this;
    });
    var d = Object.getPrototypeOf, v = d && d(d(values([])));
    v && v !== r && n.call(v, a) && (p = v);
    var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p);
    function defineIteratorMethods(t) {
        [
            "next",
            "throw",
            "return"
        ].forEach(function(e) {
            define(t, e, function(t) {
                return this._invoke(e, t);
            });
        });
    }
    function AsyncIterator(t, e) {
        function invoke(r, o, i, a) {
            var c = tryCatch(t[r], t, o);
            if ("throw" !== c.type) {
                var u = c.arg, h = u.value;
                return h && "object" == $d7af47457e8943a7$var$_typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function(t) {
                    invoke("next", t, i, a);
                }, function(t) {
                    invoke("throw", t, i, a);
                }) : e.resolve(h).then(function(t) {
                    u.value = t, i(u);
                }, function(t) {
                    return invoke("throw", t, i, a);
                });
            }
            a(c.arg);
        }
        var r;
        o(this, "_invoke", {
            value: function value(t, n) {
                function callInvokeWithMethodAndArg() {
                    return new e(function(e, r) {
                        invoke(t, n, e, r);
                    });
                }
                return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
            }
        });
    }
    function makeInvokeMethod(e, r, n) {
        var o = h;
        return function(i, a) {
            if (o === f) throw Error("Generator is already running");
            if (o === s) {
                if ("throw" === i) throw a;
                return {
                    value: t,
                    done: !0
                };
            }
            for(n.method = i, n.arg = a;;){
                var c = n.delegate;
                if (c) {
                    var u = maybeInvokeDelegate(c, n);
                    if (u) {
                        if (u === y) continue;
                        return u;
                    }
                }
                if ("next" === n.method) n.sent = n._sent = n.arg;
                else if ("throw" === n.method) {
                    if (o === h) throw o = s, n.arg;
                    n.dispatchException(n.arg);
                } else "return" === n.method && n.abrupt("return", n.arg);
                o = f;
                var p = tryCatch(e, r, n);
                if ("normal" === p.type) {
                    if (o = n.done ? s : l, p.arg === y) continue;
                    return {
                        value: p.arg,
                        done: n.done
                    };
                }
                "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg);
            }
        };
    }
    function maybeInvokeDelegate(e, r) {
        var n = r.method, o = e.iterator[n];
        if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y;
        var i = tryCatch(o, e.iterator, r.arg);
        if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y;
        var a = i.arg;
        return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y);
    }
    function pushTryEntry(t) {
        var e = {
            tryLoc: t[0]
        };
        1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e);
    }
    function resetTryEntry(t) {
        var e = t.completion || {};
        e.type = "normal", delete e.arg, t.completion = e;
    }
    function Context(t) {
        this.tryEntries = [
            {
                tryLoc: "root"
            }
        ], t.forEach(pushTryEntry, this), this.reset(!0);
    }
    function values(e) {
        if (e || "" === e) {
            var r = e[a];
            if (r) return r.call(e);
            if ("function" == typeof e.next) return e;
            if (!isNaN(e.length)) {
                var o = -1, i = function next() {
                    for(; ++o < e.length;)if (n.call(e, o)) return next.value = e[o], next.done = !1, next;
                    return next.value = t, next.done = !0, next;
                };
                return i.next = i;
            }
        }
        throw new TypeError($d7af47457e8943a7$var$_typeof(e) + " is not iterable");
    }
    return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", {
        value: GeneratorFunctionPrototype,
        configurable: !0
    }), o(GeneratorFunctionPrototype, "constructor", {
        value: GeneratorFunction,
        configurable: !0
    }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function(t) {
        var e = "function" == typeof t && t.constructor;
        return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name));
    }, e.mark = function(t) {
        return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t;
    }, e.awrap = function(t) {
        return {
            __await: t
        };
    }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function() {
        return this;
    }), e.AsyncIterator = AsyncIterator, e.async = function(t, r, n, o, i) {
        void 0 === i && (i = Promise);
        var a = new AsyncIterator(wrap(t, r, n, o), i);
        return e.isGeneratorFunction(r) ? a : a.next().then(function(t) {
            return t.done ? t.value : a.next();
        });
    }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function() {
        return this;
    }), define(g, "toString", function() {
        return "[object Generator]";
    }), e.keys = function(t) {
        var e = Object(t), r = [];
        for(var n in e)r.push(n);
        return r.reverse(), function next() {
            for(; r.length;){
                var t = r.pop();
                if (t in e) return next.value = t, next.done = !1, next;
            }
            return next.done = !0, next;
        };
    }, e.values = values, Context.prototype = {
        constructor: Context,
        reset: function reset(e) {
            if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for(var r in this)"t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t);
        },
        stop: function stop() {
            this.done = !0;
            var t = this.tryEntries[0].completion;
            if ("throw" === t.type) throw t.arg;
            return this.rval;
        },
        dispatchException: function dispatchException(e) {
            if (this.done) throw e;
            var r = this;
            function handle(n, o) {
                return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o;
            }
            for(var o = this.tryEntries.length - 1; o >= 0; --o){
                var i = this.tryEntries[o], a = i.completion;
                if ("root" === i.tryLoc) return handle("end");
                if (i.tryLoc <= this.prev) {
                    var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc");
                    if (c && u) {
                        if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
                        if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
                    } else if (c) {
                        if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
                    } else {
                        if (!u) throw Error("try statement without catch or finally");
                        if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
                    }
                }
            }
        },
        abrupt: function abrupt(t, e) {
            for(var r = this.tryEntries.length - 1; r >= 0; --r){
                var o = this.tryEntries[r];
                if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
                    var i = o;
                    break;
                }
            }
            i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null);
            var a = i ? i.completion : {};
            return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a);
        },
        complete: function complete(t, e) {
            if ("throw" === t.type) throw t.arg;
            return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y;
        },
        finish: function finish(t) {
            for(var e = this.tryEntries.length - 1; e >= 0; --e){
                var r = this.tryEntries[e];
                if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y;
            }
        },
        "catch": function _catch(t) {
            for(var e = this.tryEntries.length - 1; e >= 0; --e){
                var r = this.tryEntries[e];
                if (r.tryLoc === t) {
                    var n = r.completion;
                    if ("throw" === n.type) {
                        var o = n.arg;
                        resetTryEntry(r);
                    }
                    return o;
                }
            }
            throw Error("illegal catch attempt");
        },
        delegateYield: function delegateYield(e, r, n) {
            return this.delegate = {
                iterator: values(e),
                resultName: r,
                nextLoc: n
            }, "next" === this.method && (this.arg = t), y;
        }
    }, e;
}
module.exports = $d7af47457e8943a7$var$_regeneratorRuntime, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("ds2UT", function(module, exports) {
function $9cb0270eae4420e7$var$_typeof(o) {
    "@babel/helpers - typeof";
    return module.exports = $9cb0270eae4420e7$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $9cb0270eae4420e7$var$_typeof(o);
}
module.exports = $9cb0270eae4420e7$var$_typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("dtn6l", function(module, exports) {
"use strict";
var $9cefe737490148f0$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $9cefe737490148f0$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $9cefe737490148f0$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Storage = module.exports.Log = module.exports.EventLogger = module.exports.Diagnostics = void 0;



Object.defineProperty(module.exports, "Diagnostics", {
    enumerable: true,
    get: function() {
        return (parcelRequire("cNxHP")).Diagnostics;
    }
});

var $lT0oC = parcelRequire("lT0oC");
Object.defineProperty(module.exports, "EventLogger", {
    enumerable: true,
    get: function() {
        return $lT0oC.EventLogger;
    }
});

Object.defineProperty(module.exports, "Log", {
    enumerable: true,
    get: function() {
        return (parcelRequire("fvY6A")).Log;
    }
});


Object.defineProperty(module.exports, "Storage", {
    enumerable: true,
    get: function() {
        return (parcelRequire("cUOGL")).Storage;
    }
});

$9cefe737490148f0$var$__exportStar((parcelRequire("6zYf6")), module.exports);

$9cefe737490148f0$var$__exportStar((parcelRequire("6ZtBQ")), module.exports);

$9cefe737490148f0$var$__exportStar((parcelRequire("IwlSQ")), module.exports);

$9cefe737490148f0$var$__exportStar((parcelRequire("hPIlK")), module.exports);

$9cefe737490148f0$var$__exportStar((parcelRequire("cNxHP")), module.exports);

$9cefe737490148f0$var$__exportStar((parcelRequire("audqG")), module.exports);

$9cefe737490148f0$var$__exportStar((parcelRequire("a7dQ0")), module.exports);

$9cefe737490148f0$var$__exportStar((parcelRequire("7A9u9")), module.exports);

$9cefe737490148f0$var$__exportStar((parcelRequire("cpYjX")), module.exports);

$9cefe737490148f0$var$__exportStar((parcelRequire("lUUuL")), module.exports);

$9cefe737490148f0$var$__exportStar((parcelRequire("drWJh")), module.exports);

$9cefe737490148f0$var$__exportStar((parcelRequire("fvY6A")), module.exports);

$9cefe737490148f0$var$__exportStar((parcelRequire("g4vOj")), module.exports);

$9cefe737490148f0$var$__exportStar((parcelRequire("4JLTD")), module.exports);

$9cefe737490148f0$var$__exportStar((parcelRequire("4neZ1")), module.exports);

$9cefe737490148f0$var$__exportStar((parcelRequire("am110")), module.exports);

$9cefe737490148f0$var$__exportStar((parcelRequire("J5dlM")), module.exports);

$9cefe737490148f0$var$__exportStar((parcelRequire("jjgcN")), module.exports);

$9cefe737490148f0$var$__exportStar((parcelRequire("6OyqX")), module.exports);

$9cefe737490148f0$var$__exportStar((parcelRequire("6cbWs")), module.exports);

$9cefe737490148f0$var$__exportStar((parcelRequire("kS7H6")), module.exports);

$9cefe737490148f0$var$__exportStar((parcelRequire("lbAhi")), module.exports);

$9cefe737490148f0$var$__exportStar((parcelRequire("uj5Sb")), module.exports);

$9cefe737490148f0$var$__exportStar((parcelRequire("dbFUm")), module.exports);

$9cefe737490148f0$var$__exportStar((parcelRequire("4kZUp")), module.exports);

$9cefe737490148f0$var$__exportStar((parcelRequire("bfSbh")), module.exports);

$9cefe737490148f0$var$__exportStar((parcelRequire("9tDUz")), module.exports);

$9cefe737490148f0$var$__exportStar((parcelRequire("fFtli")), module.exports);

$9cefe737490148f0$var$__exportStar((parcelRequire("eEYg8")), module.exports);

$9cefe737490148f0$var$__exportStar((parcelRequire("boH9C")), module.exports);

$9cefe737490148f0$var$__exportStar((parcelRequire("3G1qf")), module.exports);

$9cefe737490148f0$var$__exportStar((parcelRequire("8Nbnq")), module.exports);

$9cefe737490148f0$var$__exportStar((parcelRequire("cUOGL")), module.exports);

$9cefe737490148f0$var$__exportStar((parcelRequire("1I57i")), module.exports);

$9cefe737490148f0$var$__exportStar((parcelRequire("fOOnv")), module.exports);

$9cefe737490148f0$var$__exportStar((parcelRequire("12s6q")), module.exports);

$9cefe737490148f0$var$__exportStar((parcelRequire("5G12m")), module.exports);

$9cefe737490148f0$var$__exportStar((parcelRequire("71rjN")), module.exports);

$9cefe737490148f0$var$__exportStar((parcelRequire("bhG9g")), module.exports);

$9cefe737490148f0$var$__exportStar((parcelRequire("cd98p")), module.exports);
Object.assign((0, (parcelRequire("6zYf6"))._getStatsigGlobal)(), {
    Log: (parcelRequire("fvY6A")).Log,
    SDK_VERSION: (parcelRequire("9tDUz")).SDK_VERSION
});

});
parcelRegister("6zYf6", function(module, exports) {
"use strict";
/* eslint-disable @typescript-eslint/no-unsafe-assignment */ var $4ca4bde10f45d2ff$var$_a, $4ca4bde10f45d2ff$var$_b, $4ca4bde10f45d2ff$var$_c;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._getInstance = module.exports._getStatsigGlobalFlag = module.exports._getStatsigGlobal = void 0;

var $fvY6A = parcelRequire("fvY6A");
const $4ca4bde10f45d2ff$var$_getStatsigGlobal = ()=>{
    // Avoid ReferenceError, which is happening with Cloudflare pages
    try {
        return typeof __STATSIG__ !== 'undefined' ? __STATSIG__ : $4ca4bde10f45d2ff$var$statsigGlobal;
    } catch (e) {
        return $4ca4bde10f45d2ff$var$statsigGlobal;
    }
};
module.exports._getStatsigGlobal = $4ca4bde10f45d2ff$var$_getStatsigGlobal;
const $4ca4bde10f45d2ff$var$_getStatsigGlobalFlag = (flag)=>{
    return (0, module.exports._getStatsigGlobal)()[flag];
};
module.exports._getStatsigGlobalFlag = $4ca4bde10f45d2ff$var$_getStatsigGlobalFlag;
const $4ca4bde10f45d2ff$var$_getInstance = (sdkKey)=>{
    const gbl = (0, module.exports._getStatsigGlobal)();
    if (!sdkKey) {
        if (gbl.instances && Object.keys(gbl.instances).length > 1) $fvY6A.Log.warn('Call made to Statsig global instance without an SDK key but there is more than one client instance. If you are using mulitple clients, please specify the SDK key.');
        return gbl.firstInstance;
    }
    return gbl.instances && gbl.instances[sdkKey];
};
module.exports._getInstance = $4ca4bde10f45d2ff$var$_getInstance;
const $4ca4bde10f45d2ff$var$GLOBAL_KEY = '__STATSIG__';
const $4ca4bde10f45d2ff$var$_window = typeof window !== 'undefined' ? window : {};
const $4ca4bde10f45d2ff$var$_global = typeof $parcel$global !== 'undefined' ? $parcel$global : {};
const $4ca4bde10f45d2ff$var$_globalThis = typeof globalThis !== 'undefined' ? globalThis : {};
const $4ca4bde10f45d2ff$var$statsigGlobal = ($4ca4bde10f45d2ff$var$_c = ($4ca4bde10f45d2ff$var$_b = ($4ca4bde10f45d2ff$var$_a = $4ca4bde10f45d2ff$var$_window[$4ca4bde10f45d2ff$var$GLOBAL_KEY]) !== null && $4ca4bde10f45d2ff$var$_a !== void 0 ? $4ca4bde10f45d2ff$var$_a : $4ca4bde10f45d2ff$var$_global[$4ca4bde10f45d2ff$var$GLOBAL_KEY]) !== null && $4ca4bde10f45d2ff$var$_b !== void 0 ? $4ca4bde10f45d2ff$var$_b : $4ca4bde10f45d2ff$var$_globalThis[$4ca4bde10f45d2ff$var$GLOBAL_KEY]) !== null && $4ca4bde10f45d2ff$var$_c !== void 0 ? $4ca4bde10f45d2ff$var$_c : {
    instance: module.exports._getInstance
};
$4ca4bde10f45d2ff$var$_window[$4ca4bde10f45d2ff$var$GLOBAL_KEY] = $4ca4bde10f45d2ff$var$statsigGlobal;
$4ca4bde10f45d2ff$var$_global[$4ca4bde10f45d2ff$var$GLOBAL_KEY] = $4ca4bde10f45d2ff$var$statsigGlobal;
$4ca4bde10f45d2ff$var$_globalThis[$4ca4bde10f45d2ff$var$GLOBAL_KEY] = $4ca4bde10f45d2ff$var$statsigGlobal;

});
parcelRegister("fvY6A", function(module, exports) {
"use strict";
/* eslint-disable no-console */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Log = module.exports.LogLevel = void 0;
// intentionally spaced for formatting
const $b4b85fe3d12d0071$var$DEBUG = ' DEBUG ';
const $b4b85fe3d12d0071$var$_INFO = '  INFO ';
const $b4b85fe3d12d0071$var$_WARN = '  WARN ';
const $b4b85fe3d12d0071$var$ERROR = ' ERROR ';
function $b4b85fe3d12d0071$var$addTag(args) {
    args.unshift('[Statsig]');
    return args; // ['[Statsig]', ...args];
}
module.exports.LogLevel = {
    None: 0,
    Error: 1,
    Warn: 2,
    Info: 3,
    Debug: 4
};
class $b4b85fe3d12d0071$var$Log {
    static info(...args) {
        if ($b4b85fe3d12d0071$var$Log.level >= module.exports.LogLevel.Info) console.info($b4b85fe3d12d0071$var$_INFO, ...$b4b85fe3d12d0071$var$addTag(args));
    }
    static debug(...args) {
        if ($b4b85fe3d12d0071$var$Log.level >= module.exports.LogLevel.Debug) console.debug($b4b85fe3d12d0071$var$DEBUG, ...$b4b85fe3d12d0071$var$addTag(args));
    }
    static warn(...args) {
        if ($b4b85fe3d12d0071$var$Log.level >= module.exports.LogLevel.Warn) console.warn($b4b85fe3d12d0071$var$_WARN, ...$b4b85fe3d12d0071$var$addTag(args));
    }
    static error(...args) {
        if ($b4b85fe3d12d0071$var$Log.level >= module.exports.LogLevel.Error) console.error($b4b85fe3d12d0071$var$ERROR, ...$b4b85fe3d12d0071$var$addTag(args));
    }
}
module.exports.Log = $b4b85fe3d12d0071$var$Log;
$b4b85fe3d12d0071$var$Log.level = module.exports.LogLevel.Warn;

});


parcelRegister("cNxHP", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Diagnostics = void 0;
const $951434f10e36012f$var$MARKER_MAP = new Map();
const $951434f10e36012f$var$ACT_START = 'start';
const $951434f10e36012f$var$ACT_END = 'end';
const $951434f10e36012f$var$DIAGNOSTICS_EVENT = 'statsig::diagnostics';
module.exports.Diagnostics = {
    _getMarkers: (sdkKey)=>{
        return $951434f10e36012f$var$MARKER_MAP.get(sdkKey);
    },
    _markInitOverallStart: (sdkKey)=>{
        $951434f10e36012f$var$_addMarker(sdkKey, $951434f10e36012f$var$_createMarker({}, $951434f10e36012f$var$ACT_START, 'overall'));
    },
    _markInitOverallEnd: (sdkKey, success, evaluationDetails)=>{
        $951434f10e36012f$var$_addMarker(sdkKey, $951434f10e36012f$var$_createMarker({
            success: success,
            error: success ? undefined : {
                name: 'InitializeError',
                message: 'Failed to initialize'
            },
            evaluationDetails: evaluationDetails
        }, $951434f10e36012f$var$ACT_END, 'overall'));
    },
    _markInitNetworkReqStart: (sdkKey, data)=>{
        $951434f10e36012f$var$_addMarker(sdkKey, $951434f10e36012f$var$_createMarker(data, $951434f10e36012f$var$ACT_START, 'initialize', 'network_request'));
    },
    _markInitNetworkReqEnd: (sdkKey, data)=>{
        $951434f10e36012f$var$_addMarker(sdkKey, $951434f10e36012f$var$_createMarker(data, $951434f10e36012f$var$ACT_END, 'initialize', 'network_request'));
    },
    _markInitProcessStart: (sdkKey)=>{
        $951434f10e36012f$var$_addMarker(sdkKey, $951434f10e36012f$var$_createMarker({}, $951434f10e36012f$var$ACT_START, 'initialize', 'process'));
    },
    _markInitProcessEnd: (sdkKey, data)=>{
        $951434f10e36012f$var$_addMarker(sdkKey, $951434f10e36012f$var$_createMarker(data, $951434f10e36012f$var$ACT_END, 'initialize', 'process'));
    },
    _clearMarkers: (sdkKey)=>{
        $951434f10e36012f$var$MARKER_MAP.delete(sdkKey);
    },
    _formatError (e) {
        if (!(e && typeof e === 'object')) return;
        return {
            code: $951434f10e36012f$var$_safeGetField(e, 'code'),
            name: $951434f10e36012f$var$_safeGetField(e, 'name'),
            message: $951434f10e36012f$var$_safeGetField(e, 'message')
        };
    },
    _getDiagnosticsData (res, attempt, body, e) {
        var _a;
        return {
            success: (res === null || res === void 0 ? void 0 : res.ok) === true,
            statusCode: res === null || res === void 0 ? void 0 : res.status,
            sdkRegion: (_a = res === null || res === void 0 ? void 0 : res.headers) === null || _a === void 0 ? void 0 : _a.get('x-statsig-region'),
            isDelta: body.includes('"is_delta":true') === true ? true : undefined,
            attempt: attempt,
            error: module.exports.Diagnostics._formatError(e)
        };
    },
    _enqueueDiagnosticsEvent (user, logger, sdk, options) {
        const markers = module.exports.Diagnostics._getMarkers(sdk);
        if (markers == null || markers.length <= 0) return -1;
        const overallInitDuration = markers[markers.length - 1].timestamp - markers[0].timestamp;
        module.exports.Diagnostics._clearMarkers(sdk);
        const event = $951434f10e36012f$var$_makeDiagnosticsEvent(user, {
            context: 'initialize',
            markers: markers.slice(),
            statsigOptions: options
        });
        logger.enqueue(event);
        return overallInitDuration;
    }
};
function $951434f10e36012f$var$_createMarker(data, action, key, step) {
    return Object.assign({
        key: key,
        action: action,
        step: step,
        timestamp: Date.now()
    }, data);
}
function $951434f10e36012f$var$_makeDiagnosticsEvent(user, data) {
    const latencyEvent = {
        eventName: $951434f10e36012f$var$DIAGNOSTICS_EVENT,
        user: user,
        value: null,
        metadata: data,
        time: Date.now()
    };
    return latencyEvent;
}
function $951434f10e36012f$var$_addMarker(sdkKey, marker) {
    var _a;
    const markers = (_a = $951434f10e36012f$var$MARKER_MAP.get(sdkKey)) !== null && _a !== void 0 ? _a : [];
    markers.push(marker);
    $951434f10e36012f$var$MARKER_MAP.set(sdkKey, markers);
}
function $951434f10e36012f$var$_safeGetField(data, field) {
    if (field in data) return data[field];
    return undefined;
}

});

parcelRegister("lT0oC", function(module, exports) {
"use strict";
var $feef0aade80dd3d6$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.EventLogger = void 0;

var $ckbgC = parcelRequire("ckbgC");

var $6ZtBQ = parcelRequire("6ZtBQ");

var $3DiO3 = parcelRequire("3DiO3");

var $4L12F = parcelRequire("4L12F");

var $lUUuL = parcelRequire("lUUuL");

var $fvY6A = parcelRequire("fvY6A");

var $4JLTD = parcelRequire("4JLTD");

var $hbMhT = parcelRequire("hbMhT");

var $jjgcN = parcelRequire("jjgcN");

var $bfSbh = parcelRequire("bfSbh");

var $fFtli = parcelRequire("fFtli");

var $cUOGL = parcelRequire("cUOGL");

var $12s6q = parcelRequire("12s6q");

var $71rjN = parcelRequire("71rjN");
const $feef0aade80dd3d6$var$MAX_DEDUPER_KEYS = 1000;
const $feef0aade80dd3d6$var$DEDUPER_WINDOW_DURATION_MS = 600000;
const $feef0aade80dd3d6$var$EVENT_LOGGER_MAP = {};
class $feef0aade80dd3d6$var$EventLogger {
    static _safeFlushAndForget(sdkKey) {
        var _a;
        (_a = $feef0aade80dd3d6$var$EVENT_LOGGER_MAP[sdkKey]) === null || _a === void 0 || _a.flush().catch(()=>{
        // noop
        });
    }
    constructor(_sdkKey, _emitter, _network, _options, _errorBoundary){
        var _a;
        this._sdkKey = _sdkKey;
        this._emitter = _emitter;
        this._network = _network;
        this._options = _options;
        this._errorBoundary = _errorBoundary;
        this._pendingEvents = null;
        this._batchQueue = null;
        this._flushCoordinator = null;
        this._lastExposureTimeMap = {};
        this._nonExposedChecks = {};
        this._isShuttingDown = false;
        this._storageKey = null;
        this._pendingCompressionMode = null;
        this._loggingEnabled = (_a = _options === null || _options === void 0 ? void 0 : _options.loggingEnabled) !== null && _a !== void 0 ? _a : (_options === null || _options === void 0 ? void 0 : _options.disableLogging) === true ? $fFtli.LoggingEnabledOption.disabled : $fFtli.LoggingEnabledOption.browserOnly;
        if ((_options === null || _options === void 0 ? void 0 : _options.loggingEnabled) && _options.disableLogging !== undefined) $fvY6A.Log.warn('Detected both loggingEnabled and disableLogging options. loggingEnabled takes precedence - please remove disableLogging.');
        const config = _options === null || _options === void 0 ? void 0 : _options.networkConfig;
        this._logEventUrlConfig = new $12s6q.UrlConfiguration($4JLTD.Endpoint._rgstr, config === null || config === void 0 ? void 0 : config.logEventUrl, config === null || config === void 0 ? void 0 : config.api, config === null || config === void 0 ? void 0 : config.logEventFallbackUrls);
    }
    setLogEventCompressionMode(mode) {
        if (this._flushCoordinator) this._flushCoordinator.setLogEventCompressionMode(mode);
        else this._pendingCompressionMode = mode;
    }
    setLoggingEnabled(loggingEnabled) {
        const wasDisabled = this._loggingEnabled === 'disabled';
        const isNowEnabled = loggingEnabled !== 'disabled';
        this._loggingEnabled = loggingEnabled;
        if (this._flushCoordinator) this._flushCoordinator.setLoggingEnabled(loggingEnabled);
        if (wasDisabled && isNowEnabled) {
            const events = this._loadStoredEvents();
            $fvY6A.Log.debug(`Loaded ${events.length} stored event(s) from storage`);
            if (events.length > 0) {
                events.forEach((event)=>{
                    this._initFlushCoordinator().addEvent(event);
                });
                this.flush().catch((error)=>{
                    $fvY6A.Log.warn('Failed to flush events after enabling logging:', error);
                });
            }
        }
    }
    enqueue(event) {
        var _a;
        if (!this._shouldLogEvent(event)) return;
        const normalizedEvent = this._normalizeEvent(event);
        if (this._loggingEnabled === 'disabled') {
            this._storeEventToStorage(normalizedEvent);
            return;
        }
        this._initFlushCoordinator().addEvent(normalizedEvent);
        (_a = this._flushCoordinator) === null || _a === void 0 || _a.checkQuickFlush();
    }
    incrementNonExposureCount(name) {
        var _a;
        const current = (_a = this._nonExposedChecks[name]) !== null && _a !== void 0 ? _a : 0;
        this._nonExposedChecks[name] = current + 1;
    }
    reset() {
        // attempt to flush any remaining events
        this.flush().catch(()=>{
        // noop
        });
        this._lastExposureTimeMap = {};
    }
    start() {
        var _a;
        const isServerEnv = (0, $jjgcN._isServerEnv)();
        if (isServerEnv && ((_a = this._options) === null || _a === void 0 ? void 0 : _a.loggingEnabled) !== 'always') return;
        const flushCoordinator = this._initFlushCoordinator();
        $feef0aade80dd3d6$var$EVENT_LOGGER_MAP[this._sdkKey] = this;
        if (!isServerEnv) (0, $71rjN._subscribeToVisiblityChanged)((visibility)=>{
            if (visibility === 'background') $feef0aade80dd3d6$var$EventLogger._safeFlushAndForget(this._sdkKey);
            else if (visibility === 'foreground') flushCoordinator.startScheduledFlushCycle();
        });
        flushCoordinator.loadAndRetryShutdownFailedEvents().catch((error)=>{
            $fvY6A.Log.warn('Failed to load failed shutdown events:', error);
        });
        flushCoordinator.startScheduledFlushCycle();
    }
    stop() {
        return $feef0aade80dd3d6$var$__awaiter(this, void 0, void 0, function*() {
            this._isShuttingDown = true;
            if (this._flushCoordinator) yield this._flushCoordinator.processShutdown();
            delete $feef0aade80dd3d6$var$EVENT_LOGGER_MAP[this._sdkKey];
            this._flushCoordinator = null;
            this._pendingEvents = null;
            this._batchQueue = null;
        });
    }
    flush() {
        return $feef0aade80dd3d6$var$__awaiter(this, void 0, void 0, function*() {
            if (!this._flushCoordinator) return;
            return this._flushCoordinator.processManualFlush();
        });
    }
    appendAndResetNonExposedChecks() {
        if (Object.keys(this._nonExposedChecks).length === 0) return;
        const checks = Object.assign({}, this._nonExposedChecks);
        this._nonExposedChecks = {};
        const event = this._normalizeEvent({
            eventName: 'statsig::non_exposed_checks',
            user: null,
            time: Date.now(),
            metadata: {
                checks: checks
            }
        });
        if (!this._flushCoordinator) return;
        this._flushCoordinator.addEvent(event);
    }
    _shouldLogEvent(event) {
        var _a;
        if (((_a = this._options) === null || _a === void 0 ? void 0 : _a.loggingEnabled) !== 'always' && (0, $jjgcN._isServerEnv)()) return false;
        if (!(0, $bfSbh._isExposureEvent)(event)) return true;
        const user = event.user ? event.user : {
            statsigEnvironment: undefined
        };
        const userKey = (0, $6ZtBQ._getUserStorageKey)(this._sdkKey, user);
        const metadata = event.metadata ? event.metadata : {};
        const key = [
            event.eventName,
            userKey,
            metadata['gate'],
            metadata['config'],
            metadata['ruleID'],
            metadata['allocatedExperiment'],
            metadata['parameterName'],
            String(metadata['isExplicitParameter']),
            metadata['reason']
        ].join('|');
        const previous = this._lastExposureTimeMap[key];
        const now = Date.now();
        if (previous && now - previous < $feef0aade80dd3d6$var$DEDUPER_WINDOW_DURATION_MS) return false;
        if (Object.keys(this._lastExposureTimeMap).length > $feef0aade80dd3d6$var$MAX_DEDUPER_KEYS) this._lastExposureTimeMap = {};
        this._lastExposureTimeMap[key] = now;
        return true;
    }
    _getCurrentPageUrl() {
        var _a;
        if (((_a = this._options) === null || _a === void 0 ? void 0 : _a.includeCurrentPageUrlWithEvents) === false) return;
        return (0, $jjgcN._getCurrentPageUrlSafe)();
    }
    _getStorageKey() {
        if (!this._storageKey) this._storageKey = `statsig.pending_events.${(0, $lUUuL._DJB2)(this._sdkKey)}`;
        return this._storageKey;
    }
    _initFlushCoordinator() {
        var _a, _b;
        if (this._flushCoordinator) return this._flushCoordinator;
        const batchSize = (_b = (_a = this._options) === null || _a === void 0 ? void 0 : _a.loggingBufferMaxSize) !== null && _b !== void 0 ? _b : $3DiO3.EventRetryConstants.DEFAULT_BATCH_SIZE;
        this._pendingEvents = new $hbMhT.PendingEvents(batchSize);
        this._batchQueue = new $ckbgC.BatchQueue(batchSize);
        this._flushCoordinator = new $4L12F.FlushCoordinator(this._batchQueue, this._pendingEvents, ()=>this.appendAndResetNonExposedChecks(), this._sdkKey, this._network, this._emitter, this._logEventUrlConfig, this._options, this._loggingEnabled, this._errorBoundary);
        if (this._pendingCompressionMode) {
            this._flushCoordinator.setLogEventCompressionMode(this._pendingCompressionMode);
            this._pendingCompressionMode = null;
        }
        return this._flushCoordinator;
    }
    _storeEventToStorage(event) {
        const storageKey = this._getStorageKey();
        try {
            let existingEvents = this._getEventsFromStorage(storageKey);
            existingEvents.push(event);
            if (existingEvents.length > $3DiO3.EventRetryConstants.MAX_LOCAL_STORAGE) existingEvents = existingEvents.slice(-$3DiO3.EventRetryConstants.MAX_LOCAL_STORAGE);
            (0, $cUOGL._setObjectInStorage)(storageKey, existingEvents);
        } catch (error) {
            $fvY6A.Log.warn('Unable to save events to storage');
        }
    }
    _getEventsFromStorage(storageKey) {
        try {
            const events = (0, $cUOGL._getObjectFromStorage)(storageKey);
            if (Array.isArray(events)) return events;
            return [];
        } catch (_a) {
            return [];
        }
    }
    _loadStoredEvents() {
        const storageKey = this._getStorageKey();
        const events = this._getEventsFromStorage(storageKey);
        if (events.length > 0) $cUOGL.Storage.removeItem(storageKey);
        return events;
    }
    _normalizeEvent(event) {
        if (event.user) {
            event.user = Object.assign({}, event.user);
            delete event.user.privateAttributes;
        }
        const extras = {};
        const currentPage = this._getCurrentPageUrl();
        if (currentPage) extras.statsigMetadata = {
            currentPage: currentPage
        };
        return Object.assign(Object.assign({}, event), extras);
    }
}
module.exports.EventLogger = $feef0aade80dd3d6$var$EventLogger;

});
parcelRegister("ckbgC", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.BatchQueue = void 0;

var $5qShp = parcelRequire("5qShp");

var $3DiO3 = parcelRequire("3DiO3");
class $8f9017b7732bea16$var$BatchQueue {
    constructor(batchSize = $3DiO3.EventRetryConstants.DEFAULT_BATCH_SIZE){
        this._batches = [];
        this._batchSize = batchSize;
    }
    batchSize() {
        return this._batchSize;
    }
    requeueBatch(batch) {
        return this._enqueueBatch(batch);
    }
    hasFullBatch() {
        return this._batches.some((batch)=>batch.events.length >= this._batchSize);
    }
    takeNextBatch() {
        return this._batches.shift();
    }
    takeAllBatches() {
        const batches = this._batches;
        this._batches = [];
        return batches;
    }
    createBatches(events) {
        let i = 0;
        let droppedCount = 0;
        while(i < events.length){
            const chunk = events.slice(i, i + this._batchSize);
            droppedCount += this._enqueueBatch(new $5qShp.EventBatch(chunk));
            i += this._batchSize;
        }
        return droppedCount;
    }
    _enqueueBatch(batch) {
        this._batches.push(batch);
        let droppedEventCount = 0;
        while(this._batches.length > $3DiO3.EventRetryConstants.MAX_PENDING_BATCHES){
            const dropped = this._batches.shift();
            if (dropped) droppedEventCount += dropped.events.length;
        }
        return droppedEventCount;
    }
}
module.exports.BatchQueue = $8f9017b7732bea16$var$BatchQueue;

});
parcelRegister("5qShp", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.EventBatch = void 0;
class $3f497c45253baefa$var$EventBatch {
    constructor(events){
        this.attempts = 0;
        this.createdAt = Date.now();
        this.events = events;
    }
    incrementAttempts() {
        this.attempts++;
    }
}
module.exports.EventBatch = $3f497c45253baefa$var$EventBatch;

});

parcelRegister("3DiO3", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.EventRetryConstants = void 0;
module.exports.EventRetryConstants = {
    MAX_RETRY_ATTEMPTS: 8,
    DEFAULT_BATCH_SIZE: 100,
    MAX_PENDING_BATCHES: 40,
    TICK_INTERVAL_MS: 1000,
    QUICK_FLUSH_WINDOW_MS: 200,
    MAX_LOCAL_STORAGE: 500,
    get MAX_QUEUED_EVENTS () {
        return this.DEFAULT_BATCH_SIZE * this.MAX_PENDING_BATCHES;
    }
};

});


parcelRegister("6ZtBQ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._getStorageKey = module.exports._getUserStorageKey = void 0;

var $lUUuL = parcelRequire("lUUuL");
function $516f68604f39036a$var$_getUserStorageKey(sdkKey, user, customKeyGenerator) {
    var _a;
    if (customKeyGenerator) return customKeyGenerator(sdkKey, user);
    const cids = user && user.customIDs ? user.customIDs : {};
    const parts = [
        `uid:${(_a = user === null || user === void 0 ? void 0 : user.userID) !== null && _a !== void 0 ? _a : ''}`,
        `cids:${Object.keys(cids).sort((leftKey, rightKey)=>leftKey.localeCompare(rightKey)).map((key)=>`${key}-${cids[key]}`).join(',')}`,
        `k:${sdkKey}`
    ];
    return (0, $lUUuL._DJB2)(parts.join('|'));
}
module.exports._getUserStorageKey = $516f68604f39036a$var$_getUserStorageKey;
function $516f68604f39036a$var$_getStorageKey(sdkKey, user, customKeyGenerator) {
    if (user) return $516f68604f39036a$var$_getUserStorageKey(sdkKey, user, customKeyGenerator);
    return (0, $lUUuL._DJB2)(`k:${sdkKey}`);
}
module.exports._getStorageKey = $516f68604f39036a$var$_getStorageKey;

});
parcelRegister("lUUuL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._getSortedObject = module.exports._DJB2Object = module.exports._DJB2 = void 0;

var $fOOnv = parcelRequire("fOOnv");
const $ff4aa6ade9a90e99$var$_DJB2 = (value)=>{
    let hash = 0;
    for(let i = 0; i < value.length; i++){
        const character = value.charCodeAt(i);
        hash = (hash << 5) - hash + character;
        hash = hash & hash; // Convert to 32bit integer
    }
    return String(hash >>> 0);
};
module.exports._DJB2 = $ff4aa6ade9a90e99$var$_DJB2;
const $ff4aa6ade9a90e99$var$_DJB2Object = (value, maxLevels)=>{
    return (0, module.exports._DJB2)(JSON.stringify((0, module.exports._getSortedObject)(value, maxLevels)));
};
module.exports._DJB2Object = $ff4aa6ade9a90e99$var$_DJB2Object;
const $ff4aa6ade9a90e99$var$_getSortedObject = (object, maxDepth)=>{
    if (object == null) return null;
    const keys = Object.keys(object).sort();
    const sortedObject = {};
    keys.forEach((key)=>{
        const value = object[key];
        if (maxDepth === 0 || (0, $fOOnv._typeOf)(value) !== 'object') {
            sortedObject[key] = value;
            return;
        }
        sortedObject[key] = (0, module.exports._getSortedObject)(value, maxDepth != null ? maxDepth - 1 : maxDepth);
    });
    return sortedObject;
};
module.exports._getSortedObject = $ff4aa6ade9a90e99$var$_getSortedObject;

});
parcelRegister("fOOnv", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._isTypeMatch = module.exports._typeOf = void 0;
function $b8429a94efe702e2$var$_typeOf(input) {
    return Array.isArray(input) ? 'array' : typeof input;
}
module.exports._typeOf = $b8429a94efe702e2$var$_typeOf;
function $b8429a94efe702e2$var$_isTypeMatch(a, b) {
    const typeOf = (x)=>Array.isArray(x) ? 'array' : x === null ? 'null' : typeof x;
    return typeOf(a) === typeOf(b);
}
module.exports._isTypeMatch = $b8429a94efe702e2$var$_isTypeMatch;

});



parcelRegister("4L12F", function(module, exports) {
"use strict";
var $376c5c238ab4e044$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.FlushCoordinator = void 0;

var $3DiO3 = parcelRequire("3DiO3");

var $be0vG = parcelRequire("be0vG");

var $7gsSY = parcelRequire("7gsSY");

var $kKIdl = parcelRequire("kKIdl");

var $lUUuL = parcelRequire("lUUuL");

var $fvY6A = parcelRequire("fvY6A");

var $4neZ1 = parcelRequire("4neZ1");

var $jjgcN = parcelRequire("jjgcN");

var $6cbWs = parcelRequire("6cbWs");

var $fFtli = parcelRequire("fFtli");

var $cUOGL = parcelRequire("cUOGL");
const $376c5c238ab4e044$var$RETRYABLE_NO_RESPONSE_FAILURE_PATHS = new Set([
    'network_request_timed_out_no_response',
    'network_request_exception_no_response',
    'event_sender_post_returned_null',
    'event_sender_post_returned_undefined',
    'event_sender_post_exception'
]);
class $376c5c238ab4e044$var$FlushCoordinator {
    constructor(batchQueue, pendingEvents, onPrepareFlush, // For Event Sender
    sdkKey, network, emitter, logEventUrlConfig, options, loggingEnabled, errorBoundary){
        this._cooldownTimer = null;
        this._maxIntervalTimer = null;
        this._hasRunQuickFlush = false;
        this._currentFlushPromise = null;
        this._creationTime = Date.now();
        this._isShuttingDown = false;
        this._storageKey = null;
        this._flushInterval = new $7gsSY.FlushInterval();
        this._batchQueue = batchQueue;
        this._pendingEvents = pendingEvents;
        this._onPrepareFlush = onPrepareFlush;
        this._errorBoundary = errorBoundary;
        this._sdkKey = sdkKey;
        this._loggingEnabled = loggingEnabled;
        this._eventSender = new $be0vG.EventSender(sdkKey, network, emitter, logEventUrlConfig, options);
    }
    setLoggingEnabled(loggingEnabled) {
        this._loggingEnabled = loggingEnabled;
    }
    setLogEventCompressionMode(mode) {
        this._eventSender.setLogEventCompressionMode(mode);
    }
    startScheduledFlushCycle() {
        this._scheduleNextFlush();
    }
    stopScheduledFlushCycle() {
        this._clearAllTimers();
    }
    addEvent(event) {
        this._pendingEvents.addToPendingEventsQueue(event);
        if (this._currentFlushPromise) return;
        if (this._pendingEvents.hasEventsForFullBatch()) this.processLimitFlush();
    }
    processManualFlush() {
        return $376c5c238ab4e044$var$__awaiter(this, void 0, void 0, function*() {
            if (this._currentFlushPromise) yield this._currentFlushPromise;
            this._currentFlushPromise = this._executeFlush($kKIdl.FlushTypeValues.Manual).finally(()=>{
                this._currentFlushPromise = null;
                this._scheduleNextFlush();
            });
            return this._currentFlushPromise;
        });
    }
    processShutdown() {
        return $376c5c238ab4e044$var$__awaiter(this, void 0, void 0, function*() {
            this._isShuttingDown = true;
            this._clearAllTimers();
            if (this._currentFlushPromise) yield this._currentFlushPromise;
            this._currentFlushPromise = this._executeFlush($kKIdl.FlushTypeValues.Shutdown).catch((error)=>{
                $fvY6A.Log.error(`Error during shutdown flush: ${error}`);
            }).finally(()=>{
                this._currentFlushPromise = null;
            });
            return this._currentFlushPromise;
        });
    }
    _executeFlush(flushType) {
        return $376c5c238ab4e044$var$__awaiter(this, void 0, void 0, function*() {
            this._clearAllTimers();
            try {
                this._prepareQueueForFlush(flushType);
                const batches = this._batchQueue.takeAllBatches();
                if (batches.length === 0) return;
                yield Promise.all(batches.map((batch)=>this._processOneBatch(batch, flushType)));
            } finally{
                if (!this._isShuttingDown) this._scheduleNextFlush();
            }
        });
    }
    checkQuickFlush() {
        if (this._hasRunQuickFlush) return;
        if (Date.now() - this._creationTime > $3DiO3.EventRetryConstants.QUICK_FLUSH_WINDOW_MS) return;
        this._hasRunQuickFlush = true;
        setTimeout(()=>{
            this.processManualFlush().catch((error)=>{
                $fvY6A.Log.warn('Quick flush failed:', error);
            });
        }, $3DiO3.EventRetryConstants.QUICK_FLUSH_WINDOW_MS);
    }
    _attemptScheduledFlush() {
        if (this._currentFlushPromise) {
            this._scheduleNextFlush();
            return;
        }
        const shouldFlushBySize = this.containsAtLeastOneFullBatch();
        const shouldFlushByTime = this._flushInterval.hasReachedMaxInterval();
        if (!shouldFlushBySize && !shouldFlushByTime) {
            this._scheduleNoopPollTick();
            return;
        }
        this._flushInterval.markFlushAttempt();
        let flushType;
        if (shouldFlushBySize) flushType = $kKIdl.FlushTypeValues.ScheduledFullBatch;
        else flushType = $kKIdl.FlushTypeValues.ScheduledMaxTime;
        this._currentFlushPromise = this._processNextBatch(flushType).then(()=>{
        //This discards boolean result. Main goal here is to track completion
        }).catch((error)=>{
            $fvY6A.Log.error('Error during scheduled flush:', error);
        }).finally(()=>{
            this._currentFlushPromise = null;
            this._scheduleNextFlush();
        });
    }
    processLimitFlush() {
        if (!this._flushInterval.hasCompletelyRecoveredFromBackoff()) return;
        if (this._currentFlushPromise) return;
        this._currentFlushPromise = this._processLimitFlushInternal().catch((error)=>{
            $fvY6A.Log.error(`Error during limit flush`, error);
        }).finally(()=>{
            this._currentFlushPromise = null;
            this._scheduleNextFlush();
        });
    }
    _processLimitFlushInternal() {
        return $376c5c238ab4e044$var$__awaiter(this, void 0, void 0, function*() {
            const success = yield this._processNextBatch($kKIdl.FlushTypeValues.Limit);
            if (!success) return;
            while(this._flushInterval.hasCompletelyRecoveredFromBackoff() && this.containsAtLeastOneFullBatch()){
                const success = yield this._processNextBatch($kKIdl.FlushTypeValues.Limit);
                if (!success) break;
            }
        });
    }
    _scheduleNextFlush() {
        this._clearAllTimers();
        if (this._isShuttingDown) return;
        const cooldownDelay = Math.max(0, this._flushInterval.getTimeUntilNextFlush());
        this._cooldownTimer = setTimeout(()=>{
            this._cooldownTimer = null;
            $6cbWs.StatsigSession.checkForIdleSession(this._sdkKey);
            this._attemptScheduledFlush();
        }, cooldownDelay);
        const maxIntervalDelay = Math.max(0, this._flushInterval.getTimeTillMaxInterval());
        this._maxIntervalTimer = setTimeout(()=>{
            this._maxIntervalTimer = null;
            $6cbWs.StatsigSession.checkForIdleSession(this._sdkKey);
            this._attemptScheduledFlush();
        }, maxIntervalDelay);
    }
    _clearAllTimers() {
        if (this._cooldownTimer !== null) {
            clearTimeout(this._cooldownTimer);
            this._cooldownTimer = null;
        }
        if (this._maxIntervalTimer !== null) {
            clearTimeout(this._maxIntervalTimer);
            this._maxIntervalTimer = null;
        }
    }
    _scheduleNoopPollTick() {
        this._clearAllTimers();
        if (this._isShuttingDown) return;
        this._cooldownTimer = setTimeout(()=>{
            this._cooldownTimer = null;
            $6cbWs.StatsigSession.checkForIdleSession(this._sdkKey);
            this._attemptScheduledFlush();
        }, $3DiO3.EventRetryConstants.TICK_INTERVAL_MS);
        const maxIntervalDelay = Math.max(0, this._flushInterval.getTimeTillMaxInterval());
        this._maxIntervalTimer = setTimeout(()=>{
            this._maxIntervalTimer = null;
            $6cbWs.StatsigSession.checkForIdleSession(this._sdkKey);
            this._attemptScheduledFlush();
        }, maxIntervalDelay);
    }
    _processNextBatch(flushType) {
        return $376c5c238ab4e044$var$__awaiter(this, void 0, void 0, function*() {
            this._prepareQueueForFlush(flushType);
            const batch = this._batchQueue.takeNextBatch();
            if (!batch) return false;
            return this._processOneBatch(batch, flushType);
        });
    }
    _processOneBatch(batch, flushType) {
        return $376c5c238ab4e044$var$__awaiter(this, void 0, void 0, function*() {
            if (this._loggingEnabled !== $fFtli.LoggingEnabledOption.always && (0, $jjgcN._isServerEnv)()) {
                this._flushInterval.adjustForSuccess();
                return true;
            }
            const result = yield this._eventSender.sendBatch(batch);
            if (result.success) {
                this._flushInterval.adjustForSuccess();
                return true;
            }
            this._flushInterval.adjustForFailure();
            this._handleFailure(batch, flushType, result.statusCode, result.failurePath, result.failureErrorMessage, result.failureDiagnosticBucket, result.failureDiagnosticMetadata);
            return false;
        });
    }
    _prepareQueueForFlush(flushType) {
        this._onPrepareFlush();
        const droppedCount = this.convertPendingEventsToBatches();
        if (droppedCount > 0) {
            $fvY6A.Log.warn(`Dropped ${droppedCount} events`);
            this._errorBoundary.logDroppedEvents(droppedCount, `Batch queue limit reached during batching`, {
                loggingInterval: this._flushInterval.getCurrentIntervalMs(),
                batchSize: this._batchQueue.batchSize(),
                maxPendingBatches: $3DiO3.EventRetryConstants.MAX_PENDING_BATCHES,
                flushType: flushType,
                retries: 'dropped before batching'
            });
        }
    }
    containsAtLeastOneFullBatch() {
        return this._pendingEvents.hasEventsForFullBatch() || this._batchQueue.hasFullBatch();
    }
    convertPendingEventsToBatches() {
        if (this._pendingEvents.isEmpty()) return 0;
        const allEvents = this._pendingEvents.takeAll();
        return this._batchQueue.createBatches(allEvents);
    }
    _isRetryableBatch(statusCode, failurePath) {
        if ($4neZ1.RETRYABLE_CODES.has(statusCode)) return true;
        if (statusCode === -1 && failurePath && $376c5c238ab4e044$var$RETRYABLE_NO_RESPONSE_FAILURE_PATHS.has(failurePath)) return true;
        return false;
    }
    _handleFailure(batch, flushType, statusCode, failurePath, failureErrorMessage, failureDiagnosticBucket, failureDiagnosticMetadata) {
        if (flushType === $kKIdl.FlushTypeValues.Shutdown) {
            $fvY6A.Log.warn(`${flushType} flush failed during shutdown. ` + `${batch.events.length} event(s) will be saved to storage for retry in next session.`);
            this._saveShutdownFailedEventsToStorage(batch.events);
            return;
        }
        if (!this._isRetryableBatch(statusCode, failurePath)) {
            const reason = `non-retryable error`;
            $fvY6A.Log.warn(`${flushType} flush failed after ${batch.attempts} attempt(s). ` + `${batch.events.length} event(s) will be dropped. Non-retryable error: ${statusCode}`);
            this._errorBoundary.logEventRequestFailure(batch.events.length, reason, flushType, statusCode, batch.attempts, failurePath, failureErrorMessage, failureDiagnosticBucket, failureDiagnosticMetadata);
            return;
        }
        if (batch.attempts >= $3DiO3.EventRetryConstants.MAX_RETRY_ATTEMPTS) {
            const reason = `max retry attempts exceeded`;
            $fvY6A.Log.warn(`${flushType} flush failed after ${batch.attempts} attempt(s). ` + `${batch.events.length} event(s) will be dropped.`);
            this._errorBoundary.logEventRequestFailure(batch.events.length, reason, flushType, statusCode, batch.attempts, failurePath, failureErrorMessage, failureDiagnosticBucket, failureDiagnosticMetadata);
            return;
        }
        batch.incrementAttempts();
        const droppedCount = this._batchQueue.requeueBatch(batch);
        if (droppedCount > 0) {
            $fvY6A.Log.warn(`Failed to requeue batch : dropped ${droppedCount} events due to full queue`);
            this._errorBoundary.logDroppedEvents(droppedCount, `Batch queue limit reached during requeue`, {
                loggingInterval: this._flushInterval.getCurrentIntervalMs(),
                batchSize: this._batchQueue.batchSize(),
                maxPendingBatches: $3DiO3.EventRetryConstants.MAX_PENDING_BATCHES,
                flushType: flushType,
                retries: batch.attempts
            });
        }
    }
    loadAndRetryShutdownFailedEvents() {
        return $376c5c238ab4e044$var$__awaiter(this, void 0, void 0, function*() {
            const storageKey = this._getStorageKey();
            try {
                if (!$cUOGL.Storage.isReady()) yield $cUOGL.Storage.isReadyResolver();
                const events = this._getShutdownFailedEventsFromStorage(storageKey);
                if (events.length === 0) return;
                $fvY6A.Log.debug(`Loading ${events.length} failed shutdown event(s) from storage for retry`);
                $cUOGL.Storage.removeItem(storageKey);
                events.forEach((event)=>{
                    this.addEvent(event);
                });
                yield this.processManualFlush();
            } catch (error) {
                $fvY6A.Log.warn('Failed to load and retry failed shutdown events:', error);
            }
        });
    }
    _getStorageKey() {
        if (!this._storageKey) this._storageKey = `statsig.failed_shutdown_events.${(0, $lUUuL._DJB2)(this._sdkKey)}`;
        return this._storageKey;
    }
    _saveShutdownFailedEventsToStorage(events) {
        const storageKey = this._getStorageKey();
        try {
            const existingEvents = this._getShutdownFailedEventsFromStorage(storageKey);
            let allEvents = [
                ...existingEvents,
                ...events
            ];
            if (allEvents.length > $3DiO3.EventRetryConstants.MAX_LOCAL_STORAGE) allEvents = allEvents.slice(-$3DiO3.EventRetryConstants.MAX_LOCAL_STORAGE);
            (0, $cUOGL._setObjectInStorage)(storageKey, allEvents);
            $fvY6A.Log.debug(`Saved ${events.length} failed shutdown event(s) to storage (total stored: ${allEvents.length})`);
        } catch (error) {
            $fvY6A.Log.warn('Unable to save failed shutdown events to storage:', error);
        }
    }
    _getShutdownFailedEventsFromStorage(storageKey) {
        try {
            const events = (0, $cUOGL._getObjectFromStorage)(storageKey);
            if (Array.isArray(events)) return events;
            return [];
        } catch (_a) {
            return [];
        }
    }
}
module.exports.FlushCoordinator = $376c5c238ab4e044$var$FlushCoordinator;

});
parcelRegister("be0vG", function(module, exports) {
"use strict";
var $82c165c5160b2707$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.EventSender = void 0;

var $fvY6A = parcelRequire("fvY6A");

var $4JLTD = parcelRequire("4JLTD");

var $6OyqX = parcelRequire("6OyqX");

var $9tDUz = parcelRequire("9tDUz");

var $71rjN = parcelRequire("71rjN");
class $82c165c5160b2707$var$EventSender {
    constructor(sdkKey, network, emitter, logEventUrlConfig, options){
        this._sdkKey = sdkKey;
        this._network = network;
        this._emitter = emitter;
        this._options = options;
        this._logEventUrlConfig = logEventUrlConfig;
    }
    setLogEventCompressionMode(mode) {
        this._network.setLogEventCompressionMode(mode);
    }
    sendBatch(batch) {
        return $82c165c5160b2707$var$__awaiter(this, void 0, void 0, function*() {
            var _a, _b, _c;
            let failurePath = 'event_sender_unexpected_exception';
            const transportFailure = {};
            try {
                const isClosing = (0, $71rjN._isUnloading)();
                const shouldUseBeacon = isClosing && this._network.isBeaconSupported() && ((_b = (_a = this._options) === null || _a === void 0 ? void 0 : _a.networkConfig) === null || _b === void 0 ? void 0 : _b.networkOverrideFunc) == null;
                failurePath = 'event_sender_pre_logs_flushed_emitter_exception';
                this._emitter({
                    name: 'pre_logs_flushed',
                    events: batch.events
                });
                failurePath = shouldUseBeacon ? 'event_sender_unexpected_exception' : 'event_sender_post_exception';
                const response = shouldUseBeacon ? this._sendEventsViaBeacon(batch, transportFailure) : yield this._sendEventsViaPost(batch, transportFailure);
                if (response.success) {
                    failurePath = 'event_sender_logs_flushed_emitter_exception';
                    this._emitter({
                        name: 'logs_flushed',
                        events: batch.events
                    });
                    return response;
                }
                return Object.assign(Object.assign(Object.assign({
                    success: false,
                    statusCode: response.statusCode,
                    failurePath: response.failurePath
                }, response.failureErrorMessage ? {
                    failureErrorMessage: response.failureErrorMessage
                } : {}), response.failureDiagnosticBucket ? {
                    failureDiagnosticBucket: response.failureDiagnosticBucket
                } : {}), response.failureDiagnosticMetadata ? {
                    failureDiagnosticMetadata: response.failureDiagnosticMetadata
                } : {});
            } catch (error) {
                $fvY6A.Log.warn('Failed to send batch:', error);
                return Object.assign(Object.assign(Object.assign({
                    success: false,
                    statusCode: -1,
                    failurePath: (_c = transportFailure.path) !== null && _c !== void 0 ? _c : failurePath
                }, transportFailure.errorMessage ? {
                    failureErrorMessage: transportFailure.errorMessage
                } : {}), transportFailure.diagnosticBucket ? {
                    failureDiagnosticBucket: transportFailure.diagnosticBucket
                } : {}), transportFailure.diagnosticMetadata ? {
                    failureDiagnosticMetadata: transportFailure.diagnosticMetadata
                } : {});
            }
        });
    }
    _sendEventsViaPost(batch, failureInfo) {
        return $82c165c5160b2707$var$__awaiter(this, void 0, void 0, function*() {
            var _a, _b;
            const result = yield this._network.post(this._getRequestData(batch), failureInfo);
            const code = (_a = result === null || result === void 0 ? void 0 : result.code) !== null && _a !== void 0 ? _a : -1;
            if (code === -1) return Object.assign(Object.assign(Object.assign({
                success: false,
                statusCode: -1,
                failurePath: (_b = failureInfo.path) !== null && _b !== void 0 ? _b : result === undefined ? 'event_sender_post_returned_undefined' : 'event_sender_post_returned_null'
            }, failureInfo.errorMessage ? {
                failureErrorMessage: failureInfo.errorMessage
            } : {}), failureInfo.diagnosticBucket ? {
                failureDiagnosticBucket: failureInfo.diagnosticBucket
            } : {}), failureInfo.diagnosticMetadata ? {
                failureDiagnosticMetadata: failureInfo.diagnosticMetadata
            } : {});
            return {
                success: code >= 200 && code < 300,
                statusCode: code
            };
        });
    }
    _sendEventsViaBeacon(batch, failureInfo) {
        var _a;
        const success = this._network.beacon(this._getRequestData(batch), failureInfo);
        return Object.assign(Object.assign(Object.assign({
            success: success,
            statusCode: success ? 200 : -1,
            failurePath: success ? undefined : (_a = failureInfo.path) !== null && _a !== void 0 ? _a : 'beacon_send_false'
        }, !success && failureInfo.errorMessage ? {
            failureErrorMessage: failureInfo.errorMessage
        } : {}), !success && failureInfo.diagnosticBucket ? {
            failureDiagnosticBucket: failureInfo.diagnosticBucket
        } : {}), !success && failureInfo.diagnosticMetadata ? {
            failureDiagnosticMetadata: failureInfo.diagnosticMetadata
        } : {});
    }
    _getRequestData(batch) {
        return {
            sdkKey: this._sdkKey,
            data: {
                events: batch.events
            },
            urlConfig: this._logEventUrlConfig,
            retries: 3,
            preserveFailedStatusCode: true,
            isCompressable: true,
            params: {
                [$4JLTD.NetworkParam.EventCount]: String(batch.events.length)
            },
            headers: {
                'statsig-event-count': String(batch.events.length),
                'statsig-retry-count': String(batch.attempts),
                'statsig-sdk-type': $6OyqX.SDKType._get(this._sdkKey),
                'statsig-sdk-version': $9tDUz.SDK_VERSION
            },
            credentials: 'same-origin'
        };
    }
}
module.exports.EventSender = $82c165c5160b2707$var$EventSender;

});
parcelRegister("4JLTD", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.NetworkParam = module.exports.NetworkDefault = module.exports.Endpoint = void 0;
module.exports.Endpoint = {
    _initialize: 'initialize',
    _rgstr: 'rgstr',
    _download_config_specs: 'download_config_specs'
};
module.exports.NetworkDefault = {
    [module.exports.Endpoint._rgstr]: 'https://prodregistryv2.org/v1',
    [module.exports.Endpoint._initialize]: 'https://featureassets.org/v1',
    [module.exports.Endpoint._download_config_specs]: 'https://api.statsigcdn.com/v1'
};
module.exports.NetworkParam = {
    EventCount: 'ec',
    SdkKey: 'k',
    SdkType: 'st',
    SdkVersion: 'sv',
    Time: 't',
    SessionID: 'sid',
    StatsigEncoded: 'se',
    IsGzipped: 'gz'
};

});

parcelRegister("6OyqX", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SDKType = void 0;
const $4f621f727d71eed4$var$SDK_CLIENT = {};
let $4f621f727d71eed4$var$suffix;
module.exports.SDKType = {
    _get: (sdkKey)=>{
        var _a;
        return ((_a = $4f621f727d71eed4$var$SDK_CLIENT[sdkKey]) !== null && _a !== void 0 ? _a : 'js-mono') + ($4f621f727d71eed4$var$suffix !== null && $4f621f727d71eed4$var$suffix !== void 0 ? $4f621f727d71eed4$var$suffix : '');
    },
    _setClientType (sdkKey, client) {
        $4f621f727d71eed4$var$SDK_CLIENT[sdkKey] = client;
    },
    _setBindingType (binding) {
        if (!$4f621f727d71eed4$var$suffix || $4f621f727d71eed4$var$suffix === '-react') $4f621f727d71eed4$var$suffix = '-' + binding;
    }
};

});

parcelRegister("9tDUz", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.StatsigMetadataProvider = module.exports.SDK_VERSION = void 0;
module.exports.SDK_VERSION = '3.33.2';
let $6e65c810593ccaf7$var$metadata = {
    sdkVersion: module.exports.SDK_VERSION,
    sdkType: 'js-mono'
};
module.exports.StatsigMetadataProvider = {
    get: ()=>$6e65c810593ccaf7$var$metadata,
    add: (additions)=>{
        $6e65c810593ccaf7$var$metadata = Object.assign(Object.assign({}, $6e65c810593ccaf7$var$metadata), additions);
    }
};

});

parcelRegister("71rjN", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._notifyVisibilityChanged = module.exports._subscribeToVisiblityChanged = module.exports._isUnloading = module.exports._isCurrentlyVisible = void 0;

var $jjgcN = parcelRequire("jjgcN");
const $51cdd13d47b1548c$var$FOREGROUND = 'foreground';
const $51cdd13d47b1548c$var$BACKGROUND = 'background';
const $51cdd13d47b1548c$var$LISTENERS = [];
let $51cdd13d47b1548c$var$current = $51cdd13d47b1548c$var$FOREGROUND;
let $51cdd13d47b1548c$var$isUnloading = false;
const $51cdd13d47b1548c$var$_isCurrentlyVisible = ()=>{
    return $51cdd13d47b1548c$var$current === $51cdd13d47b1548c$var$FOREGROUND;
};
module.exports._isCurrentlyVisible = $51cdd13d47b1548c$var$_isCurrentlyVisible;
const $51cdd13d47b1548c$var$_isUnloading = ()=>$51cdd13d47b1548c$var$isUnloading;
module.exports._isUnloading = $51cdd13d47b1548c$var$_isUnloading;
const $51cdd13d47b1548c$var$_subscribeToVisiblityChanged = (listener)=>{
    $51cdd13d47b1548c$var$LISTENERS.unshift(listener);
};
module.exports._subscribeToVisiblityChanged = $51cdd13d47b1548c$var$_subscribeToVisiblityChanged;
const $51cdd13d47b1548c$var$_notifyVisibilityChanged = (visibility)=>{
    if (visibility === $51cdd13d47b1548c$var$current) return;
    $51cdd13d47b1548c$var$current = visibility;
    $51cdd13d47b1548c$var$LISTENERS.forEach((l)=>l(visibility));
};
module.exports._notifyVisibilityChanged = $51cdd13d47b1548c$var$_notifyVisibilityChanged;
(0, $jjgcN._addWindowEventListenerSafe)('focus', ()=>{
    $51cdd13d47b1548c$var$isUnloading = false;
    (0, module.exports._notifyVisibilityChanged)($51cdd13d47b1548c$var$FOREGROUND);
});
(0, $jjgcN._addWindowEventListenerSafe)('blur', ()=>(0, module.exports._notifyVisibilityChanged)($51cdd13d47b1548c$var$BACKGROUND));
(0, $jjgcN._addDocumentEventListenerSafe)('visibilitychange', ()=>{
    (0, module.exports._notifyVisibilityChanged)(document.visibilityState === 'visible' ? $51cdd13d47b1548c$var$FOREGROUND : $51cdd13d47b1548c$var$BACKGROUND);
});
(0, $jjgcN._addWindowEventListenerSafe)((0, $jjgcN._getUnloadEvent)(), ()=>{
    $51cdd13d47b1548c$var$isUnloading = true;
    (0, module.exports._notifyVisibilityChanged)($51cdd13d47b1548c$var$BACKGROUND);
});

});
parcelRegister("jjgcN", function(module, exports) {

var $3ZMUU = parcelRequire("3ZMUU");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._cloneObject = module.exports._getUnloadEvent = module.exports._getCurrentPageUrlSafe = module.exports._addDocumentEventListenerSafe = module.exports._addWindowEventListenerSafe = module.exports._isServerEnv = module.exports._getDocumentSafe = module.exports._getWindowSafe = void 0;

var $fvY6A = parcelRequire("fvY6A");
const $e0ec5cbb0c18f89e$var$_getWindowSafe = ()=>{
    return typeof window !== 'undefined' ? window : null;
};
module.exports._getWindowSafe = $e0ec5cbb0c18f89e$var$_getWindowSafe;
const $e0ec5cbb0c18f89e$var$_getDocumentSafe = ()=>{
    var _a;
    const win = (0, module.exports._getWindowSafe)();
    return (_a = win === null || win === void 0 ? void 0 : win.document) !== null && _a !== void 0 ? _a : null;
};
module.exports._getDocumentSafe = $e0ec5cbb0c18f89e$var$_getDocumentSafe;
const $e0ec5cbb0c18f89e$var$_isServerEnv = ()=>{
    if ((0, module.exports._getDocumentSafe)() !== null) return false;
    const isNode = typeof $3ZMUU !== 'undefined' && $3ZMUU.versions != null && $3ZMUU.versions.node != null;
    const isVercel = typeof EdgeRuntime === 'string';
    return isVercel || isNode;
};
module.exports._isServerEnv = $e0ec5cbb0c18f89e$var$_isServerEnv;
const $e0ec5cbb0c18f89e$var$_addWindowEventListenerSafe = (key, listener)=>{
    const win = (0, module.exports._getWindowSafe)();
    if (typeof (win === null || win === void 0 ? void 0 : win.addEventListener) === 'function') win.addEventListener(key, listener);
};
module.exports._addWindowEventListenerSafe = $e0ec5cbb0c18f89e$var$_addWindowEventListenerSafe;
const $e0ec5cbb0c18f89e$var$_addDocumentEventListenerSafe = (key, listener)=>{
    const doc = (0, module.exports._getDocumentSafe)();
    if (typeof (doc === null || doc === void 0 ? void 0 : doc.addEventListener) === 'function') doc.addEventListener(key, listener);
};
module.exports._addDocumentEventListenerSafe = $e0ec5cbb0c18f89e$var$_addDocumentEventListenerSafe;
const $e0ec5cbb0c18f89e$var$_getCurrentPageUrlSafe = ()=>{
    var _a;
    try {
        return (_a = (0, module.exports._getWindowSafe)()) === null || _a === void 0 ? void 0 : _a.location.href.split(/[?#]/)[0];
    } catch (_b) {
        return;
    }
};
module.exports._getCurrentPageUrlSafe = $e0ec5cbb0c18f89e$var$_getCurrentPageUrlSafe;
const $e0ec5cbb0c18f89e$var$_getUnloadEvent = ()=>{
    const win = (0, module.exports._getWindowSafe)();
    if (!win) return 'beforeunload';
    const eventType = 'onpagehide' in win ? 'pagehide' : 'beforeunload';
    return eventType;
};
module.exports._getUnloadEvent = $e0ec5cbb0c18f89e$var$_getUnloadEvent;
const $e0ec5cbb0c18f89e$var$_cloneObject = (tag, obj)=>{
    try {
        return JSON.parse(JSON.stringify(obj));
    } catch (error) {
        $fvY6A.Log.error(`Failed to clone object ${tag}`);
        return null;
    }
};
module.exports._cloneObject = $e0ec5cbb0c18f89e$var$_cloneObject;

});
parcelRegister("3ZMUU", function(module, exports) {
// shim for using process in browser
var $2e8d0374c7e0ead2$var$process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $2e8d0374c7e0ead2$var$cachedSetTimeout;
var $2e8d0374c7e0ead2$var$cachedClearTimeout;
function $2e8d0374c7e0ead2$var$defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function $2e8d0374c7e0ead2$var$defaultClearTimeout() {
    throw new Error('clearTimeout has not been defined');
}
(function() {
    try {
        if (typeof setTimeout === 'function') $2e8d0374c7e0ead2$var$cachedSetTimeout = setTimeout;
        else $2e8d0374c7e0ead2$var$cachedSetTimeout = $2e8d0374c7e0ead2$var$defaultSetTimout;
    } catch (e) {
        $2e8d0374c7e0ead2$var$cachedSetTimeout = $2e8d0374c7e0ead2$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') $2e8d0374c7e0ead2$var$cachedClearTimeout = clearTimeout;
        else $2e8d0374c7e0ead2$var$cachedClearTimeout = $2e8d0374c7e0ead2$var$defaultClearTimeout;
    } catch (e) {
        $2e8d0374c7e0ead2$var$cachedClearTimeout = $2e8d0374c7e0ead2$var$defaultClearTimeout;
    }
})();
function $2e8d0374c7e0ead2$var$runTimeout(fun) {
    if ($2e8d0374c7e0ead2$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($2e8d0374c7e0ead2$var$cachedSetTimeout === $2e8d0374c7e0ead2$var$defaultSetTimout || !$2e8d0374c7e0ead2$var$cachedSetTimeout) && setTimeout) {
        $2e8d0374c7e0ead2$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $2e8d0374c7e0ead2$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $2e8d0374c7e0ead2$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $2e8d0374c7e0ead2$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $2e8d0374c7e0ead2$var$runClearTimeout(marker) {
    if ($2e8d0374c7e0ead2$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($2e8d0374c7e0ead2$var$cachedClearTimeout === $2e8d0374c7e0ead2$var$defaultClearTimeout || !$2e8d0374c7e0ead2$var$cachedClearTimeout) && clearTimeout) {
        $2e8d0374c7e0ead2$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $2e8d0374c7e0ead2$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $2e8d0374c7e0ead2$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $2e8d0374c7e0ead2$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $2e8d0374c7e0ead2$var$queue = [];
var $2e8d0374c7e0ead2$var$draining = false;
var $2e8d0374c7e0ead2$var$currentQueue;
var $2e8d0374c7e0ead2$var$queueIndex = -1;
function $2e8d0374c7e0ead2$var$cleanUpNextTick() {
    if (!$2e8d0374c7e0ead2$var$draining || !$2e8d0374c7e0ead2$var$currentQueue) return;
    $2e8d0374c7e0ead2$var$draining = false;
    if ($2e8d0374c7e0ead2$var$currentQueue.length) $2e8d0374c7e0ead2$var$queue = $2e8d0374c7e0ead2$var$currentQueue.concat($2e8d0374c7e0ead2$var$queue);
    else $2e8d0374c7e0ead2$var$queueIndex = -1;
    if ($2e8d0374c7e0ead2$var$queue.length) $2e8d0374c7e0ead2$var$drainQueue();
}
function $2e8d0374c7e0ead2$var$drainQueue() {
    if ($2e8d0374c7e0ead2$var$draining) return;
    var timeout = $2e8d0374c7e0ead2$var$runTimeout($2e8d0374c7e0ead2$var$cleanUpNextTick);
    $2e8d0374c7e0ead2$var$draining = true;
    var len = $2e8d0374c7e0ead2$var$queue.length;
    while(len){
        $2e8d0374c7e0ead2$var$currentQueue = $2e8d0374c7e0ead2$var$queue;
        $2e8d0374c7e0ead2$var$queue = [];
        while(++$2e8d0374c7e0ead2$var$queueIndex < len)if ($2e8d0374c7e0ead2$var$currentQueue) $2e8d0374c7e0ead2$var$currentQueue[$2e8d0374c7e0ead2$var$queueIndex].run();
        $2e8d0374c7e0ead2$var$queueIndex = -1;
        len = $2e8d0374c7e0ead2$var$queue.length;
    }
    $2e8d0374c7e0ead2$var$currentQueue = null;
    $2e8d0374c7e0ead2$var$draining = false;
    $2e8d0374c7e0ead2$var$runClearTimeout(timeout);
}
$2e8d0374c7e0ead2$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $2e8d0374c7e0ead2$var$queue.push(new $2e8d0374c7e0ead2$var$Item(fun, args));
    if ($2e8d0374c7e0ead2$var$queue.length === 1 && !$2e8d0374c7e0ead2$var$draining) $2e8d0374c7e0ead2$var$runTimeout($2e8d0374c7e0ead2$var$drainQueue);
};
// v8 likes predictible objects
function $2e8d0374c7e0ead2$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$2e8d0374c7e0ead2$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$2e8d0374c7e0ead2$var$process.title = 'browser';
$2e8d0374c7e0ead2$var$process.browser = true;
$2e8d0374c7e0ead2$var$process.env = {};
$2e8d0374c7e0ead2$var$process.argv = [];
$2e8d0374c7e0ead2$var$process.version = ''; // empty string to avoid regexp issues
$2e8d0374c7e0ead2$var$process.versions = {};
function $2e8d0374c7e0ead2$var$noop() {}
$2e8d0374c7e0ead2$var$process.on = $2e8d0374c7e0ead2$var$noop;
$2e8d0374c7e0ead2$var$process.addListener = $2e8d0374c7e0ead2$var$noop;
$2e8d0374c7e0ead2$var$process.once = $2e8d0374c7e0ead2$var$noop;
$2e8d0374c7e0ead2$var$process.off = $2e8d0374c7e0ead2$var$noop;
$2e8d0374c7e0ead2$var$process.removeListener = $2e8d0374c7e0ead2$var$noop;
$2e8d0374c7e0ead2$var$process.removeAllListeners = $2e8d0374c7e0ead2$var$noop;
$2e8d0374c7e0ead2$var$process.emit = $2e8d0374c7e0ead2$var$noop;
$2e8d0374c7e0ead2$var$process.prependListener = $2e8d0374c7e0ead2$var$noop;
$2e8d0374c7e0ead2$var$process.prependOnceListener = $2e8d0374c7e0ead2$var$noop;
$2e8d0374c7e0ead2$var$process.listeners = function(name) {
    return [];
};
$2e8d0374c7e0ead2$var$process.binding = function(name) {
    throw new Error('process.binding is not supported');
};
$2e8d0374c7e0ead2$var$process.cwd = function() {
    return '/';
};
$2e8d0374c7e0ead2$var$process.chdir = function(dir) {
    throw new Error('process.chdir is not supported');
};
$2e8d0374c7e0ead2$var$process.umask = function() {
    return 0;
};

});




parcelRegister("7gsSY", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.FlushInterval = void 0;
const $54a06f21333a8a70$var$MIN_FLUSH_INTERVAL_MS = 1000;
const $54a06f21333a8a70$var$MAX_FLUSH_INTERVAL_MS = 60000;
class $54a06f21333a8a70$var$FlushInterval {
    constructor(){
        this._currentIntervalMs = $54a06f21333a8a70$var$MIN_FLUSH_INTERVAL_MS;
        this._lastFlushAttemptTime = Date.now();
    }
    getCurrentIntervalMs() {
        return this._currentIntervalMs;
    }
    markFlushAttempt() {
        this._lastFlushAttemptTime = Date.now();
    }
    getTimeSinceLastAttempt() {
        return Date.now() - this._lastFlushAttemptTime;
    }
    hasReachedMaxInterval() {
        return this.getTimeSinceLastAttempt() >= $54a06f21333a8a70$var$MAX_FLUSH_INTERVAL_MS;
    }
    getTimeTillMaxInterval() {
        return $54a06f21333a8a70$var$MAX_FLUSH_INTERVAL_MS - this.getTimeSinceLastAttempt();
    }
    hasCompletelyRecoveredFromBackoff() {
        return this._currentIntervalMs <= $54a06f21333a8a70$var$MIN_FLUSH_INTERVAL_MS;
    }
    adjustForSuccess() {
        const current = this._currentIntervalMs;
        if (current === $54a06f21333a8a70$var$MIN_FLUSH_INTERVAL_MS) return;
        this._currentIntervalMs = Math.max($54a06f21333a8a70$var$MIN_FLUSH_INTERVAL_MS, Math.floor(current / 2));
    }
    adjustForFailure() {
        const current = this._currentIntervalMs;
        this._currentIntervalMs = Math.min($54a06f21333a8a70$var$MAX_FLUSH_INTERVAL_MS, current * 2);
    }
    getTimeUntilNextFlush() {
        return this.getCurrentIntervalMs() - this.getTimeSinceLastAttempt();
    }
}
module.exports.FlushInterval = $54a06f21333a8a70$var$FlushInterval;

});

parcelRegister("kKIdl", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.FlushTypeValues = void 0;
module.exports.FlushTypeValues = {
    ScheduledMaxTime: 'scheduled:max_time',
    ScheduledFullBatch: 'scheduled:full_batch',
    Limit: 'limit',
    Manual: 'manual',
    Shutdown: 'shutdown'
};

});

parcelRegister("4neZ1", function(module, exports) {
"use strict";
var $32f4eec2dcf9f3a5$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.NetworkCore = module.exports.RETRYABLE_CODES = void 0;

var $6zYf6 = parcelRequire("6zYf6");

var $6zYf6 = parcelRequire("6zYf6");

var $cNxHP = parcelRequire("cNxHP");

var $fvY6A = parcelRequire("fvY6A");

var $4JLTD = parcelRequire("4JLTD");

var $9zIz8 = parcelRequire("9zIz8");

var $cd98p = parcelRequire("cd98p");

var $6OyqX = parcelRequire("6OyqX");

var $jjgcN = parcelRequire("jjgcN");

var $6cbWs = parcelRequire("6cbWs");

var $lbAhi = parcelRequire("lbAhi");

var $dbFUm = parcelRequire("dbFUm");

var $9tDUz = parcelRequire("9tDUz");

var $fFtli = parcelRequire("fFtli");

var $71rjN = parcelRequire("71rjN");
const $32f4eec2dcf9f3a5$var$DEFAULT_TIMEOUT_MS = 10000;
const $32f4eec2dcf9f3a5$var$BACKOFF_BASE_MS = 500;
const $32f4eec2dcf9f3a5$var$BACKOFF_MAX_MS = 30000;
const $32f4eec2dcf9f3a5$var$RATE_LIMIT_WINDOW_MS = 1000;
const $32f4eec2dcf9f3a5$var$RATE_LIMIT_MAX_REQ_COUNT = 50;
const $32f4eec2dcf9f3a5$var$LEAK_RATE = $32f4eec2dcf9f3a5$var$RATE_LIMIT_MAX_REQ_COUNT / $32f4eec2dcf9f3a5$var$RATE_LIMIT_WINDOW_MS;
module.exports.RETRYABLE_CODES = new Set([
    408,
    500,
    502,
    503,
    504,
    522,
    524,
    599
]);
class $32f4eec2dcf9f3a5$var$NetworkCore {
    constructor(options, _emitter){
        this._emitter = _emitter;
        this._errorBoundary = null;
        this._timeout = $32f4eec2dcf9f3a5$var$DEFAULT_TIMEOUT_MS;
        this._netConfig = {};
        this._options = {};
        this._leakyBucket = {};
        this._lastUsedInitUrl = null;
        if (options) this._options = options;
        if (this._options.networkConfig) this._netConfig = this._options.networkConfig;
        if (this._netConfig.networkTimeoutMs) this._timeout = this._netConfig.networkTimeoutMs;
        this._fallbackResolver = new $9zIz8.NetworkFallbackResolver(this._options);
        this.setLogEventCompressionMode(this._getLogEventCompressionMode(options));
    }
    setLogEventCompressionMode(mode) {
        this._options.logEventCompressionMode = mode;
    }
    setErrorBoundary(errorBoundary) {
        this._errorBoundary = errorBoundary;
        this._errorBoundary.wrap(this);
        this._errorBoundary.wrap(this._fallbackResolver);
        this._fallbackResolver.setErrorBoundary(errorBoundary);
    }
    isBeaconSupported() {
        return typeof navigator !== 'undefined' && typeof navigator.sendBeacon === 'function';
    }
    getLastUsedInitUrlAndReset() {
        const tempUrl = this._lastUsedInitUrl;
        this._lastUsedInitUrl = null;
        return tempUrl;
    }
    beacon(args, failureInfo) {
        if (!$32f4eec2dcf9f3a5$var$_ensureValidSdkKey(args)) {
            if (failureInfo) failureInfo.path = 'beacon_invalid_sdk_key';
            return false;
        }
        const argsInternal = this._getInternalRequestArgs('POST', args);
        const url = this._getPopulatedURL(argsInternal);
        const nav = navigator;
        try {
            const success = nav.sendBeacon.bind(nav)(url, argsInternal.body);
            if (!success) {
                if (failureInfo) failureInfo.path = 'beacon_send_false';
            }
            return success;
        } catch (error) {
            if (failureInfo) failureInfo.path = 'beacon_send_exception';
            throw error;
        }
    }
    post(args, failureInfo) {
        return $32f4eec2dcf9f3a5$var$__awaiter(this, void 0, void 0, function*() {
            const argsInternal = this._getInternalRequestArgs('POST', args);
            this._tryEncodeBody(argsInternal);
            yield this._tryToCompressBody(argsInternal);
            return this._sendRequest(argsInternal, failureInfo);
        });
    }
    get(args) {
        const argsInternal = this._getInternalRequestArgs('GET', args);
        return this._sendRequest(argsInternal);
    }
    _sendRequest(args, failureInfo) {
        return $32f4eec2dcf9f3a5$var$__awaiter(this, void 0, void 0, function*() {
            var _a, _b, _c, _d;
            if (!$32f4eec2dcf9f3a5$var$_ensureValidSdkKey(args)) {
                if (failureInfo) failureInfo.path = 'network_invalid_sdk_key';
                return null;
            }
            if (this._netConfig.preventAllNetworkTraffic) {
                if (failureInfo) failureInfo.path = 'network_prevent_all_network_traffic';
                return null;
            }
            const { method: method, body: body, retries: retries, attempt: attempt } = args;
            const endpoint = args.urlConfig.endpoint;
            if (this._isRateLimited(endpoint)) {
                $fvY6A.Log.warn(`Request to ${endpoint} was blocked because you are making requests too frequently.`);
                if (failureInfo) failureInfo.path = 'network_rate_limited';
                return null;
            }
            const currentAttempt = attempt !== null && attempt !== void 0 ? attempt : 1;
            let reqTimedOut = false;
            const populatedUrl = this._getPopulatedURL(args);
            const startTime = Date.now();
            let response = null;
            const keepalive = (0, $71rjN._isUnloading)();
            try {
                const config = {
                    method: method,
                    body: body,
                    headers: Object.assign({}, args.headers),
                    priority: args.priority,
                    keepalive: keepalive
                };
                $32f4eec2dcf9f3a5$var$_tryMarkInitStart(args, currentAttempt);
                const bucket = this._leakyBucket[endpoint];
                if (bucket) {
                    bucket.lastRequestTime = Date.now();
                    this._leakyBucket[endpoint] = bucket;
                }
                const func = (_a = this._netConfig.networkOverrideFunc) !== null && _a !== void 0 ? _a : fetch;
                let timeoutId;
                response = yield Promise.race([
                    func(populatedUrl, config).finally(()=>clearTimeout(timeoutId)),
                    new Promise((_, reject)=>{
                        timeoutId = setTimeout(()=>{
                            reqTimedOut = true;
                            reject(new Error(`Timeout of ${this._timeout}ms expired.`));
                        }, this._timeout);
                    })
                ]);
                if (!response.ok) {
                    const text = yield response.text().catch(()=>'No Text');
                    const err = new Error(`NetworkError: ${populatedUrl} ${text}`);
                    err.name = 'NetworkError';
                    throw err;
                }
                const text = yield response.text();
                $32f4eec2dcf9f3a5$var$_tryMarkInitEnd(args, response, currentAttempt, text);
                this._fallbackResolver.tryBumpExpiryTime(args.sdkKey, args.urlConfig);
                return {
                    body: text,
                    code: response.status
                };
            } catch (error) {
                const errorMessage = $32f4eec2dcf9f3a5$var$_getErrorMessage(error);
                const timedOut = $32f4eec2dcf9f3a5$var$_didTimeout(errorMessage !== null && errorMessage !== void 0 ? errorMessage : '', reqTimedOut);
                $32f4eec2dcf9f3a5$var$_tryMarkInitEnd(args, response, currentAttempt, '', error);
                const fallbackUpdated = yield this._fallbackResolver.tryFetchUpdatedFallbackInfo(args.sdkKey, args.urlConfig, errorMessage, timedOut);
                if (fallbackUpdated) args.fallbackUrl = this._fallbackResolver.getActiveFallbackUrl(args.sdkKey, args.urlConfig);
                if (!retries || currentAttempt > retries || !module.exports.RETRYABLE_CODES.has((_b = response === null || response === void 0 ? void 0 : response.status) !== null && _b !== void 0 ? _b : 500)) {
                    (_c = this._emitter) === null || _c === void 0 || _c.call(this, {
                        name: 'error',
                        error: error,
                        tag: $dbFUm.ErrorTag.NetworkError,
                        requestArgs: args
                    });
                    const formattedErrorMsg = `A networking error occurred during ${method} request to ${populatedUrl}.`;
                    $fvY6A.Log.error(formattedErrorMsg, errorMessage, error);
                    (_d = this._errorBoundary) === null || _d === void 0 || _d.attachErrorIfNoneExists(formattedErrorMsg);
                    if (args.preserveFailedStatusCode && response != null) return {
                        body: null,
                        code: response.status
                    };
                    if (response == null) {
                        if (failureInfo) {
                            failureInfo.path = timedOut ? 'network_request_timed_out_no_response' : 'network_request_exception_no_response';
                            if (errorMessage) failureInfo.errorMessage = errorMessage;
                            try {
                                const diagnostics = $32f4eec2dcf9f3a5$var$_getNoResponseDiagnostics(args, populatedUrl, timedOut, Date.now() - startTime);
                                failureInfo.diagnosticBucket = diagnostics.bucket;
                                failureInfo.diagnosticMetadata = diagnostics.metadata;
                            } catch (_e) {
                            // Diagnostics should not affect request failure handling.
                            }
                        }
                    }
                    return null;
                }
                yield $32f4eec2dcf9f3a5$var$_exponentialBackoff(currentAttempt);
                return this._sendRequest(Object.assign(Object.assign({}, args), {
                    retries: retries,
                    attempt: currentAttempt + 1
                }), failureInfo);
            }
        });
    }
    _getLogEventCompressionMode(options) {
        // Handle backward compatibility for deprecated disableCompression flag
        let compressionMode = options === null || options === void 0 ? void 0 : options.logEventCompressionMode;
        if (!compressionMode && (options === null || options === void 0 ? void 0 : options.disableCompression) === true) compressionMode = $fFtli.LogEventCompressionMode.Disabled;
        // Default to enabled if unset
        if (!compressionMode) compressionMode = $fFtli.LogEventCompressionMode.Enabled;
        return compressionMode;
    }
    _isRateLimited(endpoint) {
        var _a;
        const now = Date.now();
        const bucket = (_a = this._leakyBucket[endpoint]) !== null && _a !== void 0 ? _a : {
            count: 0,
            lastRequestTime: now
        };
        const elapsed = now - bucket.lastRequestTime;
        const leakedRequests = Math.floor(elapsed * $32f4eec2dcf9f3a5$var$LEAK_RATE);
        bucket.count = Math.max(0, bucket.count - leakedRequests);
        if (bucket.count >= $32f4eec2dcf9f3a5$var$RATE_LIMIT_MAX_REQ_COUNT) return true;
        bucket.count += 1;
        bucket.lastRequestTime = now;
        this._leakyBucket[endpoint] = bucket;
        return false;
    }
    _getPopulatedURL(args) {
        var _a;
        const url = (_a = args.fallbackUrl) !== null && _a !== void 0 ? _a : args.urlConfig.getUrl();
        if (args.urlConfig.endpoint === $4JLTD.Endpoint._initialize || args.urlConfig.endpoint === $4JLTD.Endpoint._download_config_specs) this._lastUsedInitUrl = url;
        const params = Object.assign({
            [$4JLTD.NetworkParam.SdkKey]: args.sdkKey,
            [$4JLTD.NetworkParam.SdkType]: $6OyqX.SDKType._get(args.sdkKey),
            [$4JLTD.NetworkParam.SdkVersion]: $9tDUz.SDK_VERSION,
            [$4JLTD.NetworkParam.Time]: String(Date.now()),
            [$4JLTD.NetworkParam.SessionID]: $6cbWs.SessionID.get(args.sdkKey)
        }, args.params);
        const query = Object.keys(params).map((key)=>{
            return `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`;
        }).join('&');
        return `${url}${query ? `?${query}` : ''}`;
    }
    _tryEncodeBody(args) {
        var _a;
        const win = (0, $jjgcN._getWindowSafe)();
        const body = args.body;
        if (!args.isStatsigEncodable || this._options.disableStatsigEncoding || typeof body !== 'string' || (0, $6zYf6._getStatsigGlobalFlag)('no-encode') != null || !(win === null || win === void 0 ? void 0 : win.btoa)) return;
        try {
            args.body = win.btoa(body).split('').reverse().join('');
            args.params = Object.assign(Object.assign({}, (_a = args.params) !== null && _a !== void 0 ? _a : {}), {
                [$4JLTD.NetworkParam.StatsigEncoded]: '1'
            });
        } catch (e) {
            $fvY6A.Log.warn(`Request encoding failed for ${args.urlConfig.getUrl()}`, e);
        }
    }
    _tryToCompressBody(args) {
        return $32f4eec2dcf9f3a5$var$__awaiter(this, void 0, void 0, function*() {
            var _a;
            const body = args.body;
            if (typeof body !== 'string' || !$32f4eec2dcf9f3a5$var$_allowCompression(args, this._options)) return;
            try {
                const bytes = new TextEncoder().encode(body);
                const stream = new CompressionStream('gzip');
                const writer = stream.writable.getWriter();
                writer.write(bytes).catch($fvY6A.Log.error);
                writer.close().catch($fvY6A.Log.error);
                const reader = stream.readable.getReader();
                const chunks = [];
                let result;
                // eslint-disable-next-line no-await-in-loop
                while(!(result = yield reader.read()).done)chunks.push(result.value);
                const totalLength = chunks.reduce((acc, chunk)=>acc + chunk.length, 0);
                const combined = new Uint8Array(totalLength);
                let offset = 0;
                for (const chunk of chunks){
                    combined.set(chunk, offset);
                    offset += chunk.length;
                }
                args.body = combined;
                args.params = Object.assign(Object.assign({}, (_a = args.params) !== null && _a !== void 0 ? _a : {}), {
                    [$4JLTD.NetworkParam.IsGzipped]: '1'
                });
            } catch (e) {
                $fvY6A.Log.warn(`Request compression failed for ${args.urlConfig.getUrl()}`, e);
            }
        });
    }
    _getInternalRequestArgs(method, args) {
        const fallbackUrl = this._fallbackResolver.getActiveFallbackUrl(args.sdkKey, args.urlConfig);
        const result = Object.assign(Object.assign({}, args), {
            method: method,
            fallbackUrl: fallbackUrl
        });
        if ('data' in args) $32f4eec2dcf9f3a5$var$_populateRequestBody(result, args.data);
        return result;
    }
}
module.exports.NetworkCore = $32f4eec2dcf9f3a5$var$NetworkCore;
const $32f4eec2dcf9f3a5$var$_ensureValidSdkKey = (args)=>{
    if (!args.sdkKey) {
        $fvY6A.Log.warn('Unable to make request without an SDK key');
        return false;
    }
    return true;
};
const $32f4eec2dcf9f3a5$var$_populateRequestBody = (args, data)=>{
    const { sdkKey: sdkKey, fallbackUrl: fallbackUrl } = args;
    const stableID = $lbAhi.StableID.get(sdkKey);
    const sessionID = $6cbWs.SessionID.get(sdkKey);
    const sdkType = $6OyqX.SDKType._get(sdkKey);
    args.body = JSON.stringify(Object.assign(Object.assign({}, data), {
        statsigMetadata: Object.assign(Object.assign({}, $9tDUz.StatsigMetadataProvider.get()), {
            stableID: stableID,
            sessionID: sessionID,
            sdkType: sdkType,
            fallbackUrl: fallbackUrl
        })
    }));
};
function $32f4eec2dcf9f3a5$var$_allowCompression(args, options) {
    if (!args.isCompressable) return false;
    // Never compress if 'no-compress' is set globally or required APIs are unavailable
    if ((0, $6zYf6._getStatsigGlobalFlag)('no-compress') != null || typeof CompressionStream === 'undefined' || typeof TextEncoder === 'undefined') return false;
    const isProxy = args.urlConfig.customUrl != null || args.urlConfig.fallbackUrls != null;
    const flagEnabled = $cd98p.SDKFlags.get(args.sdkKey, 'enable_log_event_compression') === true;
    switch(options.logEventCompressionMode){
        case $fFtli.LogEventCompressionMode.Disabled:
            return false;
        case $fFtli.LogEventCompressionMode.Enabled:
            // Only compress through proxy if flag is explicitly on
            if (isProxy && !flagEnabled) return false;
            return true;
        case $fFtli.LogEventCompressionMode.Forced:
            return true;
        default:
            return false;
    }
}
function $32f4eec2dcf9f3a5$var$_getErrorMessage(error) {
    if (typeof error === 'string') return error;
    if (error instanceof Error) return `${error.name}: ${error.message}`;
    return 'Unknown Error';
}
function $32f4eec2dcf9f3a5$var$_didTimeout(errorMsg, abortedByTimeout) {
    const timeout = errorMsg.includes('Timeout'); // probably not needed but just in case
    return timeout || abortedByTimeout;
}
function $32f4eec2dcf9f3a5$var$_getNoResponseDiagnostics(args, populatedUrl, timedOut, elapsedMs) {
    var _a, _b, _c;
    const win = (0, $jjgcN._getWindowSafe)();
    const doc = win === null || win === void 0 ? void 0 : win.document;
    const nav = typeof navigator !== 'undefined' ? navigator : null;
    const isUnloading = (0, $71rjN._isUnloading)();
    const online = nav && typeof nav.onLine === 'boolean' ? String(nav.onLine) : 'unknown';
    const visibilityState = (_a = doc === null || doc === void 0 ? void 0 : doc.visibilityState) !== null && _a !== void 0 ? _a : 'unknown';
    const hasCustomHeaders = Object.keys((_b = args.headers) !== null && _b !== void 0 ? _b : {}).length > 0;
    const crossOrigin = $32f4eec2dcf9f3a5$var$_isCrossOrigin(populatedUrl, (_c = win === null || win === void 0 ? void 0 : win.location) === null || _c === void 0 ? void 0 : _c.origin);
    const hasCustomUrl = args.urlConfig.customUrl != null;
    const hasFallbackUrl = args.fallbackUrl != null;
    const elapsedMsBucket = $32f4eec2dcf9f3a5$var$_bucketNumber(elapsedMs, [
        250,
        1000,
        5000,
        10000
    ]);
    const bodySizeBucket = $32f4eec2dcf9f3a5$var$_bucketNumber($32f4eec2dcf9f3a5$var$_getBodySize(args.body), [
        16384,
        65536,
        262144,
        1048576
    ]);
    let bucket = 'unknown_no_response';
    if (timedOut) bucket = 'timeout';
    else if (online === 'false') bucket = 'browser_offline';
    else if (isUnloading) bucket = 'page_unloading';
    else if (visibilityState === 'hidden') bucket = 'page_hidden';
    else if (crossOrigin && hasCustomHeaders) bucket = 'cross_origin_custom_headers_preflight_risk';
    else if (hasCustomUrl || hasFallbackUrl) bucket = 'custom_url_no_response';
    else if (elapsedMs < 250) bucket = 'immediate_network_rejection';
    return {
        bucket: bucket,
        metadata: {
            elapsedMsBucket: elapsedMsBucket,
            bodySizeBucket: bodySizeBucket,
            online: online,
            visibilityState: visibilityState,
            isUnloading: String(isUnloading),
            crossOrigin: String(crossOrigin),
            hasCustomUrl: String(hasCustomUrl)
        }
    };
}
function $32f4eec2dcf9f3a5$var$_isCrossOrigin(url, currentOrigin) {
    if (!currentOrigin) return true;
    return !url.startsWith(`${currentOrigin}/`) && !url.startsWith(`${currentOrigin}?`) && url !== currentOrigin;
}
function $32f4eec2dcf9f3a5$var$_getBodySize(body) {
    if (body == null) return 0;
    if (typeof body === 'string') return body.length;
    if (body instanceof Uint8Array) return body.byteLength;
    if (typeof Blob !== 'undefined' && body instanceof Blob) return body.size;
    return -1;
}
function $32f4eec2dcf9f3a5$var$_bucketNumber(value, thresholds) {
    if (value < 0) return 'unknown';
    for (const threshold of thresholds){
        if (value < threshold) return `<${threshold}`;
    }
    return `>=${thresholds[thresholds.length - 1]}`;
}
function $32f4eec2dcf9f3a5$var$_tryMarkInitStart(args, attempt) {
    if (args.urlConfig.endpoint !== $4JLTD.Endpoint._initialize) return;
    $cNxHP.Diagnostics._markInitNetworkReqStart(args.sdkKey, {
        attempt: attempt
    });
}
function $32f4eec2dcf9f3a5$var$_tryMarkInitEnd(args, response, attempt, body, err) {
    if (args.urlConfig.endpoint !== $4JLTD.Endpoint._initialize) return;
    $cNxHP.Diagnostics._markInitNetworkReqEnd(args.sdkKey, $cNxHP.Diagnostics._getDiagnosticsData(response, attempt, body, err));
}
function $32f4eec2dcf9f3a5$var$_exponentialBackoff(attempt) {
    return $32f4eec2dcf9f3a5$var$__awaiter(this, void 0, void 0, function*() {
        // 1*1*1000 1s
        // 2*2*1000 4s
        // 3*3*1000 9s
        // 4*4*1000 16s
        // 5*5*1000 25s
        yield new Promise((r)=>setTimeout(r, Math.min($32f4eec2dcf9f3a5$var$BACKOFF_BASE_MS * (attempt * attempt), $32f4eec2dcf9f3a5$var$BACKOFF_MAX_MS)));
    });
}

});
parcelRegister("9zIz8", function(module, exports) {
"use strict";
var $6f89f3be547c87c2$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._isDomainFailure = module.exports.NetworkFallbackResolver = void 0;

var $9NOma = parcelRequire("9NOma");

var $lUUuL = parcelRequire("lUUuL");

var $fvY6A = parcelRequire("fvY6A");

var $cUOGL = parcelRequire("cUOGL");
const $6f89f3be547c87c2$var$DEFAULT_TTL_MS = 604800000; // 7 days
const $6f89f3be547c87c2$var$COOLDOWN_TIME_MS = 14400000; // 4 hours
class $6f89f3be547c87c2$var$NetworkFallbackResolver {
    constructor(options){
        var _a;
        this._fallbackInfo = null;
        this._errorBoundary = null;
        this._dnsQueryCooldowns = {};
        this._networkOverrideFunc = (_a = options.networkConfig) === null || _a === void 0 ? void 0 : _a.networkOverrideFunc;
    }
    setErrorBoundary(errorBoundary) {
        this._errorBoundary = errorBoundary;
    }
    tryBumpExpiryTime(sdkKey, urlConfig) {
        var _a;
        const info = (_a = this._fallbackInfo) === null || _a === void 0 ? void 0 : _a[urlConfig.endpoint];
        if (!info) return;
        info.expiryTime = Date.now() + $6f89f3be547c87c2$var$DEFAULT_TTL_MS;
        $6f89f3be547c87c2$var$_tryWriteFallbackInfoToCache(sdkKey, Object.assign(Object.assign({}, this._fallbackInfo), {
            [urlConfig.endpoint]: info
        }));
    }
    getActiveFallbackUrl(sdkKey, urlConfig) {
        var _a, _b;
        if (urlConfig.customUrl != null && urlConfig.fallbackUrls != null) return null;
        let info = this._fallbackInfo;
        if (info == null) {
            info = (_a = $6f89f3be547c87c2$var$_readFallbackInfoFromCache(sdkKey)) !== null && _a !== void 0 ? _a : {};
            this._fallbackInfo = info;
        }
        const entry = info[urlConfig.endpoint];
        if (!entry || Date.now() > ((_b = entry.expiryTime) !== null && _b !== void 0 ? _b : 0) || urlConfig.getChecksum() !== entry.urlConfigChecksum) {
            delete info[urlConfig.endpoint];
            this._fallbackInfo = info;
            $6f89f3be547c87c2$var$_tryWriteFallbackInfoToCache(sdkKey, this._fallbackInfo);
            return null;
        }
        if (entry.url) return entry.url;
        return null;
    }
    tryFetchUpdatedFallbackInfo(sdkKey, urlConfig, errorMessage, timedOut) {
        return $6f89f3be547c87c2$var$__awaiter(this, void 0, void 0, function*() {
            var _a, _b;
            try {
                if (!$6f89f3be547c87c2$var$_isDomainFailure(errorMessage, timedOut)) return false;
                const canUseNetworkFallbacks = urlConfig.customUrl == null && urlConfig.fallbackUrls == null;
                const urls = canUseNetworkFallbacks ? yield this._tryFetchFallbackUrlsFromNetwork(urlConfig) : urlConfig.fallbackUrls;
                const newUrl = this._pickNewFallbackUrl((_a = this._fallbackInfo) === null || _a === void 0 ? void 0 : _a[urlConfig.endpoint], urls);
                if (!newUrl) return false;
                this._updateFallbackInfoWithNewUrl(sdkKey, urlConfig, newUrl);
                return true;
            } catch (error) {
                (_b = this._errorBoundary) === null || _b === void 0 || _b.logError('tryFetchUpdatedFallbackInfo', error);
                return false;
            }
        });
    }
    _updateFallbackInfoWithNewUrl(sdkKey, urlConfig, newUrl) {
        var _a, _b, _c;
        const newFallbackInfo = {
            urlConfigChecksum: urlConfig.getChecksum(),
            url: newUrl,
            expiryTime: Date.now() + $6f89f3be547c87c2$var$DEFAULT_TTL_MS,
            previous: []
        };
        const endpoint = urlConfig.endpoint;
        const previousInfo = (_a = this._fallbackInfo) === null || _a === void 0 ? void 0 : _a[endpoint];
        if (previousInfo) newFallbackInfo.previous.push(...previousInfo.previous);
        if (newFallbackInfo.previous.length > 10) newFallbackInfo.previous = [];
        const previousUrl = (_c = (_b = this._fallbackInfo) === null || _b === void 0 ? void 0 : _b[endpoint]) === null || _c === void 0 ? void 0 : _c.url;
        if (previousUrl != null) newFallbackInfo.previous.push(previousUrl);
        this._fallbackInfo = Object.assign(Object.assign({}, this._fallbackInfo), {
            [endpoint]: newFallbackInfo
        });
        $6f89f3be547c87c2$var$_tryWriteFallbackInfoToCache(sdkKey, this._fallbackInfo);
    }
    _tryFetchFallbackUrlsFromNetwork(urlConfig) {
        return $6f89f3be547c87c2$var$__awaiter(this, void 0, void 0, function*() {
            var _a;
            const cooldown = this._dnsQueryCooldowns[urlConfig.endpoint];
            if (cooldown && Date.now() < cooldown) return null;
            this._dnsQueryCooldowns[urlConfig.endpoint] = Date.now() + $6f89f3be547c87c2$var$COOLDOWN_TIME_MS;
            const result = [];
            const records = yield (0, $9NOma._fetchTxtRecords)((_a = this._networkOverrideFunc) !== null && _a !== void 0 ? _a : fetch);
            const path = $6f89f3be547c87c2$var$_extractPathFromUrl(urlConfig.defaultUrl);
            for (const record of records){
                if (!record.startsWith(urlConfig.endpointDnsKey + '=')) continue;
                const parts = record.split('=');
                if (parts.length > 1) {
                    let baseUrl = parts[1];
                    if (baseUrl.endsWith('/')) baseUrl = baseUrl.slice(0, -1);
                    result.push(`https://${baseUrl}${path}`);
                }
            }
            return result;
        });
    }
    _pickNewFallbackUrl(currentFallbackInfo, urls) {
        var _a;
        if (urls == null) return null;
        const previouslyUsed = new Set((_a = currentFallbackInfo === null || currentFallbackInfo === void 0 ? void 0 : currentFallbackInfo.previous) !== null && _a !== void 0 ? _a : []);
        const currentFallbackUrl = currentFallbackInfo === null || currentFallbackInfo === void 0 ? void 0 : currentFallbackInfo.url;
        let found = null;
        for (const loopUrl of urls){
            const url = loopUrl.endsWith('/') ? loopUrl.slice(0, -1) : loopUrl;
            if (!previouslyUsed.has(loopUrl) && url !== currentFallbackUrl) {
                found = url;
                break;
            }
        }
        return found;
    }
}
module.exports.NetworkFallbackResolver = $6f89f3be547c87c2$var$NetworkFallbackResolver;
function $6f89f3be547c87c2$var$_isDomainFailure(errorMsg, timedOut) {
    var _a;
    const lowerErrorMsg = (_a = errorMsg === null || errorMsg === void 0 ? void 0 : errorMsg.toLowerCase()) !== null && _a !== void 0 ? _a : '';
    return timedOut || lowerErrorMsg.includes('uncaught exception') || lowerErrorMsg.includes('failed to fetch') || lowerErrorMsg.includes('networkerror when attempting to fetch resource');
}
module.exports._isDomainFailure = $6f89f3be547c87c2$var$_isDomainFailure;
function $6f89f3be547c87c2$var$_getFallbackInfoStorageKey(sdkKey) {
    return `statsig.network_fallback.${(0, $lUUuL._DJB2)(sdkKey)}`;
}
function $6f89f3be547c87c2$var$_tryWriteFallbackInfoToCache(sdkKey, info) {
    const hashKey = $6f89f3be547c87c2$var$_getFallbackInfoStorageKey(sdkKey);
    if (!info || Object.keys(info).length === 0) {
        $cUOGL.Storage.removeItem(hashKey);
        return;
    }
    $cUOGL.Storage.setItem(hashKey, JSON.stringify(info));
}
function $6f89f3be547c87c2$var$_readFallbackInfoFromCache(sdkKey) {
    const hashKey = $6f89f3be547c87c2$var$_getFallbackInfoStorageKey(sdkKey);
    const data = $cUOGL.Storage.getItem(hashKey);
    if (!data) return null;
    try {
        return JSON.parse(data);
    } catch (_a) {
        $fvY6A.Log.error('Failed to parse FallbackInfo');
        return null;
    }
}
function $6f89f3be547c87c2$var$_extractPathFromUrl(urlString) {
    try {
        const url = new URL(urlString);
        return url.pathname;
    } catch (error) {
        return null;
    }
}

});
parcelRegister("9NOma", function(module, exports) {
"use strict";
var $722fc069dd1cc14d$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._fetchTxtRecords = void 0;
// See example: https://github.com/statsig-io/private-js-client-monorepo/pull/340
const $722fc069dd1cc14d$var$FEATURE_ASSETS_DNS_QUERY = new Uint8Array([
    0x00,
    0x00,
    0x01,
    0x00,
    0x00,
    0x01,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x0d,
    0x66,
    0x65,
    0x61,
    0x74,
    0x75,
    0x72,
    0x65,
    0x61,
    0x73,
    0x73,
    0x65,
    0x74,
    0x73,
    0x03,
    0x6f,
    0x72,
    0x67,
    0x00,
    0x00,
    0x10,
    0x00,
    0x01
]);
const $722fc069dd1cc14d$var$DNS_QUERY_ENDPOINT = 'https://cloudflare-dns.com/dns-query';
const $722fc069dd1cc14d$var$DOMAIN_CHARS = [
    'i',
    'e',
    'd'
];
const $722fc069dd1cc14d$var$MAX_START_LOOKUP = 200;
function $722fc069dd1cc14d$var$_fetchTxtRecords(networkFunc) {
    return $722fc069dd1cc14d$var$__awaiter(this, void 0, void 0, function*() {
        const response = yield networkFunc($722fc069dd1cc14d$var$DNS_QUERY_ENDPOINT, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/dns-message',
                Accept: 'application/dns-message'
            },
            body: $722fc069dd1cc14d$var$FEATURE_ASSETS_DNS_QUERY
        });
        if (!response.ok) {
            const err = new Error('Failed to fetch TXT records from DNS');
            err.name = 'DnsTxtFetchError';
            throw err;
        }
        const data = yield response.arrayBuffer();
        const bytes = new Uint8Array(data);
        return $722fc069dd1cc14d$var$_parseDnsResponse(bytes);
    });
}
module.exports._fetchTxtRecords = $722fc069dd1cc14d$var$_fetchTxtRecords;
function $722fc069dd1cc14d$var$_parseDnsResponse(input) {
    // loop until we find the first valid domain char. One of [i=, e=, d=]
    const start = input.findIndex((byte, index)=>index < $722fc069dd1cc14d$var$MAX_START_LOOKUP && String.fromCharCode(byte) === '=' && $722fc069dd1cc14d$var$DOMAIN_CHARS.includes(String.fromCharCode(input[index - 1])));
    if (start === -1) {
        const err = new Error('Failed to parse TXT records from DNS');
        err.name = 'DnsTxtParseError';
        throw err;
    }
    // decode the remaining bytes as a string
    let result = '';
    for(let i = start - 1; i < input.length; i++)result += String.fromCharCode(input[i]);
    return result.split(',');
}

});

parcelRegister("cUOGL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._setObjectInStorage = module.exports._getObjectFromStorage = module.exports.Storage = void 0;

var $fvY6A = parcelRequire("fvY6A");

var $jjgcN = parcelRequire("jjgcN");
const $967208b68a686b58$var$inMemoryStore = {};
const $967208b68a686b58$var$_inMemoryProvider = {
    isReady: ()=>true,
    isReadyResolver: ()=>null,
    getProviderName: ()=>'InMemory',
    getItem: (key)=>$967208b68a686b58$var$inMemoryStore[key] ? $967208b68a686b58$var$inMemoryStore[key] : null,
    setItem: (key, value)=>{
        $967208b68a686b58$var$inMemoryStore[key] = value;
    },
    removeItem: (key)=>{
        delete $967208b68a686b58$var$inMemoryStore[key];
    },
    getAllKeys: ()=>Object.keys($967208b68a686b58$var$inMemoryStore)
};
let $967208b68a686b58$var$_localStorageProvider = null;
try {
    const win = (0, $jjgcN._getWindowSafe)();
    if (win && win.localStorage && typeof win.localStorage.getItem === 'function') $967208b68a686b58$var$_localStorageProvider = {
        isReady: ()=>true,
        isReadyResolver: ()=>null,
        getProviderName: ()=>'LocalStorage',
        getItem: (key)=>win.localStorage.getItem(key),
        setItem: (key, value)=>win.localStorage.setItem(key, value),
        removeItem: (key)=>win.localStorage.removeItem(key),
        getAllKeys: ()=>Object.keys(win.localStorage)
    };
} catch (error) {
    $fvY6A.Log.warn('Failed to setup localStorageProvider.');
}
let $967208b68a686b58$var$_main = $967208b68a686b58$var$_localStorageProvider !== null && $967208b68a686b58$var$_localStorageProvider !== void 0 ? $967208b68a686b58$var$_localStorageProvider : $967208b68a686b58$var$_inMemoryProvider;
let $967208b68a686b58$var$_current = $967208b68a686b58$var$_main;
function $967208b68a686b58$var$_inMemoryBreaker(action) {
    try {
        return action();
    } catch (error) {
        if (error instanceof Error && error.name === 'SecurityError') {
            module.exports.Storage._setProvider($967208b68a686b58$var$_inMemoryProvider);
            return null;
        }
        throw error;
    }
}
module.exports.Storage = {
    isReady: ()=>$967208b68a686b58$var$_current.isReady(),
    isReadyResolver: ()=>$967208b68a686b58$var$_current.isReadyResolver(),
    getProviderName: ()=>$967208b68a686b58$var$_current.getProviderName(),
    getItem: (key)=>$967208b68a686b58$var$_inMemoryBreaker(()=>$967208b68a686b58$var$_current.getItem(key)),
    setItem: (key, value)=>$967208b68a686b58$var$_inMemoryBreaker(()=>$967208b68a686b58$var$_current.setItem(key, value)),
    removeItem: (key)=>$967208b68a686b58$var$_current.removeItem(key),
    getAllKeys: ()=>$967208b68a686b58$var$_current.getAllKeys(),
    // StorageProviderManagment
    _setProvider: (newProvider)=>{
        $967208b68a686b58$var$_main = newProvider;
        $967208b68a686b58$var$_current = newProvider;
    },
    _setDisabled: (isDisabled)=>{
        if (isDisabled) $967208b68a686b58$var$_current = $967208b68a686b58$var$_inMemoryProvider;
        else $967208b68a686b58$var$_current = $967208b68a686b58$var$_main;
    }
};
function $967208b68a686b58$var$_getObjectFromStorage(key) {
    const value = module.exports.Storage.getItem(key);
    try {
        return JSON.parse(value !== null && value !== void 0 ? value : 'null');
    } catch (e) {
        $fvY6A.Log.error(`Failed to parse value for key "${key}"`);
        return null;
    }
}
module.exports._getObjectFromStorage = $967208b68a686b58$var$_getObjectFromStorage;
function $967208b68a686b58$var$_setObjectInStorage(key, obj) {
    module.exports.Storage.setItem(key, JSON.stringify(obj));
}
module.exports._setObjectInStorage = $967208b68a686b58$var$_setObjectInStorage;

});


parcelRegister("cd98p", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SDKFlags = void 0;
const $8e3dc8e27d017159$var$FLAGMAP = {};
module.exports.SDKFlags = {
    setFlags: (sdkKey, flags)=>{
        $8e3dc8e27d017159$var$FLAGMAP[sdkKey] = flags;
    },
    get: (sdkKey, flagKey)=>{
        var _a, _b;
        return (_b = (_a = $8e3dc8e27d017159$var$FLAGMAP[sdkKey]) === null || _a === void 0 ? void 0 : _a[flagKey]) !== null && _b !== void 0 ? _b : false;
    }
};

});

parcelRegister("6cbWs", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.StatsigSession = module.exports.SessionID = void 0;

var $6ZtBQ = parcelRequire("6ZtBQ");

var $fvY6A = parcelRequire("fvY6A");

var $cUOGL = parcelRequire("cUOGL");

var $5G12m = parcelRequire("5G12m");

var $71rjN = parcelRequire("71rjN");
const $482d2078a26fb880$var$MAX_SESSION_IDLE_TIME = 1800000; // 30 minutes
const $482d2078a26fb880$var$MAX_SESSION_AGE = 14400000; // 4 hours
const $482d2078a26fb880$var$PERSIST_THROTTLE_MS = 15000;
const $482d2078a26fb880$var$SESSION_MAP = {};
(0, $71rjN._subscribeToVisiblityChanged)((visibility)=>{
    if (visibility === 'background') Object.values($482d2078a26fb880$var$SESSION_MAP).forEach((session)=>$482d2078a26fb880$var$_persistNow(session));
});
module.exports.SessionID = {
    get: (sdkKey)=>{
        return module.exports.StatsigSession.get(sdkKey).data.sessionID;
    }
};
module.exports.StatsigSession = {
    get: (sdkKey, bumpSession = true)=>{
        if ($482d2078a26fb880$var$SESSION_MAP[sdkKey] == null) $482d2078a26fb880$var$SESSION_MAP[sdkKey] = $482d2078a26fb880$var$_loadOrCreateSharedSession(sdkKey);
        const session = $482d2078a26fb880$var$SESSION_MAP[sdkKey];
        return $482d2078a26fb880$var$_maybeBumpSession(session, bumpSession);
    },
    overrideInitialSessionID: (override, sdkKey)=>{
        const now = Date.now();
        const session = {
            data: {
                sessionID: override,
                startTime: now,
                lastUpdate: now
            },
            sdkKey: sdkKey,
            lastPersistedAt: Date.now(),
            storageKey: $482d2078a26fb880$var$_getSessionIDStorageKey(sdkKey)
        };
        $482d2078a26fb880$var$_persistNow(session);
        $482d2078a26fb880$var$SESSION_MAP[sdkKey] = session;
    },
    checkForIdleSession: (sdkKey)=>{
        const session = $482d2078a26fb880$var$SESSION_MAP[sdkKey];
        if (!session) return;
        const sessionExpired = $482d2078a26fb880$var$_checkForExpiredSession(session);
        if (sessionExpired) $482d2078a26fb880$var$_persistNow(session);
    }
};
function $482d2078a26fb880$var$_maybeBumpSession(session, allowSessionBump) {
    const now = Date.now();
    const sessionExpired = $482d2078a26fb880$var$_checkForExpiredSession(session);
    if (sessionExpired) $482d2078a26fb880$var$_persistNow(session);
    else if (allowSessionBump) {
        session.data.lastUpdate = now;
        $482d2078a26fb880$var$_persistThrottled(session);
    }
    return session;
}
function $482d2078a26fb880$var$_checkForExpiredSession(session) {
    var _a;
    const data = session.data;
    const sessionExpired = $482d2078a26fb880$var$_isIdle(data) || $482d2078a26fb880$var$_hasRunTooLong(data);
    if (sessionExpired) {
        session.data = $482d2078a26fb880$var$_newSessionData();
        (_a = __STATSIG__ === null || __STATSIG__ === void 0 ? void 0 : __STATSIG__.instance(session.sdkKey)) === null || _a === void 0 || _a.$emt({
            name: 'session_expired'
        });
    }
    return sessionExpired;
}
function $482d2078a26fb880$var$_isIdle({ lastUpdate: lastUpdate }) {
    return Date.now() - lastUpdate > $482d2078a26fb880$var$MAX_SESSION_IDLE_TIME;
}
function $482d2078a26fb880$var$_hasRunTooLong({ startTime: startTime }) {
    return Date.now() - startTime > $482d2078a26fb880$var$MAX_SESSION_AGE;
}
function $482d2078a26fb880$var$_getSessionIDStorageKey(sdkKey) {
    return `statsig.session_id.${(0, $6ZtBQ._getStorageKey)(sdkKey)}`;
}
function $482d2078a26fb880$var$_persistNow(session) {
    try {
        (0, $cUOGL._setObjectInStorage)(session.storageKey, session.data);
        session.lastPersistedAt = Date.now();
    } catch (e) {
        $fvY6A.Log.warn('Failed to save SessionID');
    }
}
function $482d2078a26fb880$var$_persistThrottled(session) {
    const now = Date.now();
    if (now - session.lastPersistedAt > $482d2078a26fb880$var$PERSIST_THROTTLE_MS) $482d2078a26fb880$var$_persistNow(session);
}
function $482d2078a26fb880$var$_loadSessionFromStorage(storageKey) {
    const data = (0, $cUOGL._getObjectFromStorage)(storageKey);
    return data;
}
function $482d2078a26fb880$var$_loadOrCreateSharedSession(sdkKey) {
    const storageKey = $482d2078a26fb880$var$_getSessionIDStorageKey(sdkKey);
    const existing = $482d2078a26fb880$var$_loadSessionFromStorage(storageKey);
    if (existing && existing.sessionID && existing.startTime && existing.lastUpdate) return {
        data: existing,
        sdkKey: sdkKey,
        lastPersistedAt: 0,
        storageKey: storageKey
    };
    return {
        data: $482d2078a26fb880$var$_newSessionData(),
        sdkKey: sdkKey,
        lastPersistedAt: 0,
        storageKey: storageKey
    };
}
function $482d2078a26fb880$var$_newSessionData() {
    return {
        sessionID: (0, $5G12m.getUUID)(),
        startTime: Date.now(),
        lastUpdate: Date.now()
    };
}

});
parcelRegister("5G12m", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getUUID = void 0;
function $4221adf57cf05a89$var$getUUID() {
    if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') return crypto.randomUUID();
    let d = new Date().getTime();
    let d2 = typeof performance !== 'undefined' && performance.now && performance.now() * 1000 || 0;
    const y = '89ab'[Math.floor(Math.random() * 4)];
    return `xxxxxxxx-xxxx-4xxx-${y}xxx-xxxxxxxxxxxx`.replace(/[xy]/g, (c)=>{
        let r = Math.random() * 16;
        if (d > 0) {
            r = (d + r) % 16 | 0;
            d = Math.floor(d / 16);
        } else {
            r = (d2 + r) % 16 | 0;
            d2 = Math.floor(d2 / 16);
        }
        return (c === 'x' ? r : r & 0x7 | 0x8).toString(16);
    });
}
module.exports.getUUID = $4221adf57cf05a89$var$getUUID;

});


parcelRegister("lbAhi", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getCookieName = module.exports.StableID = void 0;

var $6ZtBQ = parcelRequire("6ZtBQ");

var $fvY6A = parcelRequire("fvY6A");

var $jjgcN = parcelRequire("jjgcN");

var $cUOGL = parcelRequire("cUOGL");

var $5G12m = parcelRequire("5G12m");
const $f6c6c4187dbee940$var$PROMISE_MAP = {};
const $f6c6c4187dbee940$var$COOKIE_ENABLED_MAP = {};
const $f6c6c4187dbee940$var$DISABLED_MAP = {};
module.exports.StableID = {
    cookiesEnabled: false,
    randomID: Math.random().toString(36),
    get: (sdkKey)=>{
        if ($f6c6c4187dbee940$var$DISABLED_MAP[sdkKey]) return null;
        if ($f6c6c4187dbee940$var$PROMISE_MAP[sdkKey] != null) return $f6c6c4187dbee940$var$PROMISE_MAP[sdkKey];
        let stableID = null;
        stableID = $f6c6c4187dbee940$var$_loadFromCookie(sdkKey);
        if (stableID != null) {
            $f6c6c4187dbee940$var$PROMISE_MAP[sdkKey] = stableID;
            $f6c6c4187dbee940$var$_persistToStorage(stableID, sdkKey);
            return stableID;
        }
        stableID = $f6c6c4187dbee940$var$_loadFromStorage(sdkKey);
        if (stableID == null) stableID = (0, $5G12m.getUUID)();
        $f6c6c4187dbee940$var$_persistToStorage(stableID, sdkKey);
        $f6c6c4187dbee940$var$_persistToCookie(stableID, sdkKey);
        $f6c6c4187dbee940$var$PROMISE_MAP[sdkKey] = stableID;
        return stableID;
    },
    setOverride: (override, sdkKey)=>{
        $f6c6c4187dbee940$var$PROMISE_MAP[sdkKey] = override;
        $f6c6c4187dbee940$var$_persistToStorage(override, sdkKey);
        $f6c6c4187dbee940$var$_persistToCookie(override, sdkKey);
    },
    _setCookiesEnabled: (sdkKey, cookiesEnabled)=>{
        $f6c6c4187dbee940$var$COOKIE_ENABLED_MAP[sdkKey] = cookiesEnabled;
    },
    _setDisabled: (sdkKey, disabled)=>{
        $f6c6c4187dbee940$var$DISABLED_MAP[sdkKey] = disabled;
    }
};
function $f6c6c4187dbee940$var$_getStableIDStorageKey(sdkKey) {
    return `statsig.stable_id.${(0, $6ZtBQ._getStorageKey)(sdkKey)}`;
}
function $f6c6c4187dbee940$var$_persistToStorage(stableID, sdkKey) {
    const storageKey = $f6c6c4187dbee940$var$_getStableIDStorageKey(sdkKey);
    try {
        (0, $cUOGL._setObjectInStorage)(storageKey, stableID);
    } catch (e) {
        $fvY6A.Log.warn('Failed to save StableID to storage');
    }
}
function $f6c6c4187dbee940$var$_loadFromStorage(sdkKey) {
    const storageKey = $f6c6c4187dbee940$var$_getStableIDStorageKey(sdkKey);
    return (0, $cUOGL._getObjectFromStorage)(storageKey);
}
function $f6c6c4187dbee940$var$_loadFromCookie(sdkKey) {
    if (!$f6c6c4187dbee940$var$COOKIE_ENABLED_MAP[sdkKey] || (0, $jjgcN._getDocumentSafe)() == null) return null;
    const cookies = document.cookie.split(';');
    for (const cookie of cookies){
        const [key, value] = cookie.trim().split('=');
        if (key === $f6c6c4187dbee940$var$getCookieName(sdkKey)) return decodeURIComponent(value);
    }
    return null;
}
function $f6c6c4187dbee940$var$_persistToCookie(stableID, sdkKey) {
    if (!$f6c6c4187dbee940$var$COOKIE_ENABLED_MAP[sdkKey] || (0, $jjgcN._getDocumentSafe)() == null) return;
    const expiryDate = new Date();
    expiryDate.setFullYear(expiryDate.getFullYear() + 1);
    document.cookie = `${$f6c6c4187dbee940$var$getCookieName(sdkKey)}=${encodeURIComponent(stableID)}; expires=${expiryDate.toUTCString()}; path=/`;
}
function $f6c6c4187dbee940$var$getCookieName(sdkKey) {
    return `statsig.stable_id.${(0, $6ZtBQ._getStorageKey)(sdkKey)}`;
}
module.exports.getCookieName = $f6c6c4187dbee940$var$getCookieName;

});

parcelRegister("dbFUm", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ErrorTag = void 0;
module.exports.ErrorTag = {
    NetworkError: 'NetworkError'
};

});

parcelRegister("fFtli", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LoggingEnabledOption = module.exports.LogEventCompressionMode = void 0;
module.exports.LogEventCompressionMode = {
    /** Do not compress request bodies */ Disabled: 'd',
    /** Compress request bodies unless a network proxy is configured */ Enabled: 'e',
    /** Always compress request bodies, even when a proxy is configured */ Forced: 'f'
};
module.exports.LoggingEnabledOption = {
    disabled: 'disabled',
    browserOnly: 'browser-only',
    always: 'always'
};

});



parcelRegister("hbMhT", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PendingEvents = void 0;

var $fvY6A = parcelRequire("fvY6A");
class $c838ebad2216faa3$var$PendingEvents {
    constructor(batchSize){
        this._pendingEvents = [];
        this._batchSize = batchSize;
    }
    addToPendingEventsQueue(event) {
        this._pendingEvents.push(event);
        $fvY6A.Log.debug('Enqueued Event:', event);
    }
    hasEventsForFullBatch() {
        return this._pendingEvents.length >= this._batchSize;
    }
    takeAll() {
        const events = this._pendingEvents;
        this._pendingEvents = [];
        return events;
    }
    isEmpty() {
        return this._pendingEvents.length === 0;
    }
}
module.exports.PendingEvents = $c838ebad2216faa3$var$PendingEvents;

});

parcelRegister("bfSbh", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._createLayerParameterExposure = module.exports._createConfigExposure = module.exports._mapExposures = module.exports._createGateExposure = module.exports._isExposureEvent = void 0;
const $831b1fa1d6ab26dc$var$CONFIG_EXPOSURE_NAME = 'statsig::config_exposure';
const $831b1fa1d6ab26dc$var$GATE_EXPOSURE_NAME = 'statsig::gate_exposure';
const $831b1fa1d6ab26dc$var$LAYER_EXPOSURE_NAME = 'statsig::layer_exposure';
const $831b1fa1d6ab26dc$var$_createExposure = (eventName, user, details, metadata, secondaryExposures)=>{
    if (details.bootstrapMetadata) metadata['bootstrapMetadata'] = details.bootstrapMetadata;
    return {
        eventName: eventName,
        user: user,
        value: null,
        metadata: $831b1fa1d6ab26dc$var$_addEvaluationDetailsToMetadata(details, metadata),
        secondaryExposures: secondaryExposures,
        time: Date.now()
    };
};
const $831b1fa1d6ab26dc$var$_isExposureEvent = ({ eventName: eventName })=>{
    return eventName === $831b1fa1d6ab26dc$var$GATE_EXPOSURE_NAME || eventName === $831b1fa1d6ab26dc$var$CONFIG_EXPOSURE_NAME || eventName === $831b1fa1d6ab26dc$var$LAYER_EXPOSURE_NAME;
};
module.exports._isExposureEvent = $831b1fa1d6ab26dc$var$_isExposureEvent;
const $831b1fa1d6ab26dc$var$_createGateExposure = (user, gate, exposureMapping)=>{
    var _a, _b, _c;
    const metadata = {
        gate: gate.name,
        gateValue: String(gate.value),
        ruleID: gate.ruleID
    };
    if (((_a = gate.__evaluation) === null || _a === void 0 ? void 0 : _a.version) != null) metadata['configVersion'] = gate.__evaluation.version;
    return $831b1fa1d6ab26dc$var$_createExposure($831b1fa1d6ab26dc$var$GATE_EXPOSURE_NAME, user, gate.details, metadata, $831b1fa1d6ab26dc$var$_mapExposures((_c = (_b = gate.__evaluation) === null || _b === void 0 ? void 0 : _b.secondary_exposures) !== null && _c !== void 0 ? _c : [], exposureMapping));
};
module.exports._createGateExposure = $831b1fa1d6ab26dc$var$_createGateExposure;
function $831b1fa1d6ab26dc$var$_mapExposures(exposures, exposureMapping) {
    return exposures.map((exposure)=>{
        if (typeof exposure === 'string') return (exposureMapping !== null && exposureMapping !== void 0 ? exposureMapping : {})[exposure];
        return exposure;
    }).filter((exposure)=>exposure != null);
}
module.exports._mapExposures = $831b1fa1d6ab26dc$var$_mapExposures;
const $831b1fa1d6ab26dc$var$_createConfigExposure = (user, config, exposureMapping)=>{
    var _a, _b, _c, _d;
    const metadata = {
        config: config.name,
        ruleID: config.ruleID
    };
    if (((_a = config.__evaluation) === null || _a === void 0 ? void 0 : _a.version) != null) metadata['configVersion'] = config.__evaluation.version;
    if (((_b = config.__evaluation) === null || _b === void 0 ? void 0 : _b.passed) != null) metadata['rulePassed'] = String(config.__evaluation.passed);
    return $831b1fa1d6ab26dc$var$_createExposure($831b1fa1d6ab26dc$var$CONFIG_EXPOSURE_NAME, user, config.details, metadata, $831b1fa1d6ab26dc$var$_mapExposures((_d = (_c = config.__evaluation) === null || _c === void 0 ? void 0 : _c.secondary_exposures) !== null && _d !== void 0 ? _d : [], exposureMapping));
};
module.exports._createConfigExposure = $831b1fa1d6ab26dc$var$_createConfigExposure;
const $831b1fa1d6ab26dc$var$_createLayerParameterExposure = (user, layer, parameterName, exposureMapping)=>{
    var _a, _b, _c, _d, _e, _f, _g;
    const evaluation = layer.__evaluation;
    const isExplicit = ((_a = evaluation === null || evaluation === void 0 ? void 0 : evaluation.explicit_parameters) === null || _a === void 0 ? void 0 : _a.includes(parameterName)) === true;
    let allocatedExperiment = '';
    let secondaryExposures = (_b = evaluation === null || evaluation === void 0 ? void 0 : evaluation.undelegated_secondary_exposures) !== null && _b !== void 0 ? _b : [];
    if (isExplicit) {
        allocatedExperiment = (_c = evaluation.allocated_experiment_name) !== null && _c !== void 0 ? _c : '';
        secondaryExposures = (_d = evaluation.secondary_exposures) !== null && _d !== void 0 ? _d : [];
    }
    const parameterRuleIDs = (_e = layer.__evaluation) === null || _e === void 0 ? void 0 : _e.parameter_rule_ids;
    const metadata = {
        config: layer.name,
        parameterName: parameterName,
        ruleID: (_f = parameterRuleIDs === null || parameterRuleIDs === void 0 ? void 0 : parameterRuleIDs[parameterName]) !== null && _f !== void 0 ? _f : layer.ruleID,
        allocatedExperiment: allocatedExperiment,
        isExplicitParameter: String(isExplicit)
    };
    if (((_g = layer.__evaluation) === null || _g === void 0 ? void 0 : _g.version) != null) metadata['configVersion'] = layer.__evaluation.version;
    return $831b1fa1d6ab26dc$var$_createExposure($831b1fa1d6ab26dc$var$LAYER_EXPOSURE_NAME, user, layer.details, metadata, $831b1fa1d6ab26dc$var$_mapExposures(secondaryExposures, exposureMapping));
};
module.exports._createLayerParameterExposure = $831b1fa1d6ab26dc$var$_createLayerParameterExposure;
const $831b1fa1d6ab26dc$var$_addEvaluationDetailsToMetadata = (details, metadata)=>{
    metadata['reason'] = details.reason;
    if (details.lcut) metadata['lcut'] = String(details.lcut);
    if (details.receivedAt) metadata['receivedAt'] = String(details.receivedAt);
    return metadata;
};

});

parcelRegister("12s6q", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.UrlConfiguration = void 0;

var $lUUuL = parcelRequire("lUUuL");

var $4JLTD = parcelRequire("4JLTD");
const $0c1bc6f7052054af$var$ENDPOINT_DNS_KEY_MAP = {
    [$4JLTD.Endpoint._initialize]: 'i',
    [$4JLTD.Endpoint._rgstr]: 'e',
    [$4JLTD.Endpoint._download_config_specs]: 'd'
};
class $0c1bc6f7052054af$var$UrlConfiguration {
    constructor(endpoint, customUrl, customApi, fallbackUrls){
        this.customUrl = null;
        this.fallbackUrls = null;
        this.endpoint = endpoint;
        this.endpointDnsKey = $0c1bc6f7052054af$var$ENDPOINT_DNS_KEY_MAP[endpoint];
        if (customUrl) this.customUrl = customUrl;
        if (!customUrl && customApi) this.customUrl = customApi.endsWith('/') ? `${customApi}${endpoint}` : `${customApi}/${endpoint}`;
        if (fallbackUrls) this.fallbackUrls = fallbackUrls;
        const defaultApi = $4JLTD.NetworkDefault[endpoint];
        this.defaultUrl = `${defaultApi}/${endpoint}`;
    }
    getUrl() {
        var _a;
        return (_a = this.customUrl) !== null && _a !== void 0 ? _a : this.defaultUrl;
    }
    getChecksum() {
        var _a;
        const fallbacks = ((_a = this.fallbackUrls) !== null && _a !== void 0 ? _a : []).sort().join(',');
        return (0, $lUUuL._DJB2)(this.customUrl + fallbacks);
    }
}
module.exports.UrlConfiguration = $0c1bc6f7052054af$var$UrlConfiguration;

});


parcelRegister("IwlSQ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PrecomputedEvaluationsContextHandle = void 0;

var $fvY6A = parcelRequire("fvY6A");

var $jjgcN = parcelRequire("jjgcN");

var $6cbWs = parcelRequire("6cbWs");

var $lbAhi = parcelRequire("lbAhi");
/**
 * A handle to the PrecomputedEvaluationsContext that computes fields lazily on access.
 * This avoids unnecessary computation (e.g., cloning the user) when only certain fields are needed.
 * The handle is created once and reused; individual getters fetch current values on each access.
 */ class $085d3499d81e9a00$var$PrecomputedEvaluationsContextHandle {
    constructor(sdkKey, getOptions, getErrorBoundary, getValues, getUser, getSdkInstanceID){
        this._sdkKey = sdkKey;
        this._getOptions = getOptions;
        this._getErrorBoundary = getErrorBoundary;
        this._getValues = getValues;
        this._getUser = getUser;
        this._getSdkInstanceID = getSdkInstanceID;
    }
    get sdkKey() {
        return this._sdkKey;
    }
    get options() {
        return this._getOptions();
    }
    get errorBoundary() {
        return this._getErrorBoundary();
    }
    get values() {
        return this._getValues();
    }
    get user() {
        let user = (0, $jjgcN._cloneObject)('StatsigUser', this._getUser());
        if (user == null) {
            $fvY6A.Log.error('Failed to clone user');
            user = {};
        }
        return user;
    }
    /**
     * Gets the current session.
     * @param {boolean} [bumpSession=true] - Whether to bump/update the session timing. Set to false to read without affecting session state.
     */ getSession(bumpSession = true) {
        return $6cbWs.StatsigSession.get(this._sdkKey, bumpSession);
    }
    get stableID() {
        return $lbAhi.StableID.get(this._sdkKey);
    }
    get sdkInstanceID() {
        return this._getSdkInstanceID();
    }
    /**
     * Returns the full PrecomputedEvaluationsContext object.
     * Use this when you need all fields at once.
     * @param {boolean} [bumpSession=true] - Whether to bump the session when building the context.
     */ toContext(bumpSession = true) {
        return {
            sdkKey: this.sdkKey,
            options: this.options,
            values: this.values,
            user: this.user,
            errorBoundary: this.errorBoundary,
            session: this.getSession(bumpSession),
            stableID: this.stableID,
            sdkInstanceID: this.sdkInstanceID
        };
    }
}
module.exports.PrecomputedEvaluationsContextHandle = $085d3499d81e9a00$var$PrecomputedEvaluationsContextHandle;

});

parcelRegister("hPIlK", function(module, exports) {
"use strict";
var $cfb99a0123e1f5cd$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._makeDataAdapterResult = module.exports.DataAdapterCore = void 0;

var $fvY6A = parcelRequire("fvY6A");

var $lbAhi = parcelRequire("lbAhi");

var $8Nbnq = parcelRequire("8Nbnq");

var $cUOGL = parcelRequire("cUOGL");

var $1I57i = parcelRequire("1I57i");
const $cfb99a0123e1f5cd$var$CACHE_LIMIT = 10;
const $cfb99a0123e1f5cd$var$MAX_CACHE_WRITE_ATTEMPTS = 8;
class $cfb99a0123e1f5cd$var$DataAdapterCore {
    constructor(_adapterName, _cacheSuffix){
        this._adapterName = _adapterName;
        this._cacheSuffix = _cacheSuffix;
        this._options = null;
        this._sdkKey = null;
        this._cacheLimit = $cfb99a0123e1f5cd$var$CACHE_LIMIT;
        this._lastModifiedStoreKey = `statsig.last_modified_time.${_cacheSuffix}`;
        this._inMemoryCache = new $cfb99a0123e1f5cd$var$InMemoryCache();
    }
    attach(sdkKey, options, _network) {
        this._sdkKey = sdkKey;
        this._options = options;
    }
    getDataSync(user) {
        const normalized = user && (0, $8Nbnq._normalizeUser)(user, this._options);
        const cacheKey = this._getCacheKey(normalized);
        const inMem = this._inMemoryCache.get(cacheKey, normalized);
        if (inMem && this._getIsCacheValueValid(inMem)) return inMem;
        const cache = this._loadFromCache(cacheKey);
        if (cache && this._getIsCacheValueValid(cache)) {
            this._inMemoryCache.add(cacheKey, cache, this._cacheLimit);
            return this._inMemoryCache.get(cacheKey, normalized);
        }
        return null;
    }
    setData(data, user) {
        const normalized = user && (0, $8Nbnq._normalizeUser)(user, this._options);
        const cacheKey = this._getCacheKey(normalized);
        this._inMemoryCache.add(cacheKey, $cfb99a0123e1f5cd$var$_makeDataAdapterResult('Bootstrap', data, null, normalized), this._cacheLimit);
    }
    _getIsCacheValueValid(current) {
        return current.stableID == null || current.stableID === $lbAhi.StableID.get(this._getSdkKey());
    }
    _getDataAsyncImpl(current, user, options) {
        return $cfb99a0123e1f5cd$var$__awaiter(this, void 0, void 0, function*() {
            if (!$cUOGL.Storage.isReady()) yield $cUOGL.Storage.isReadyResolver();
            const cache = current !== null && current !== void 0 ? current : this.getDataSync(user);
            const ops = [
                this._fetchAndPrepFromNetwork(cache, user, options)
            ];
            if (options === null || options === void 0 ? void 0 : options.timeoutMs) ops.push(new Promise((r)=>setTimeout(r, options.timeoutMs)).then(()=>{
                $fvY6A.Log.debug('Fetching latest value timed out');
                return null;
            }));
            return yield Promise.race(ops);
        });
    }
    _prefetchDataImpl(user, options) {
        return $cfb99a0123e1f5cd$var$__awaiter(this, void 0, void 0, function*() {
            const normalized = user && (0, $8Nbnq._normalizeUser)(user, this._options);
            const cacheKey = this._getCacheKey(normalized);
            const result = yield this._getDataAsyncImpl(null, normalized, options);
            if (result) this._inMemoryCache.add(cacheKey, Object.assign(Object.assign({}, result), {
                source: 'Prefetch'
            }), this._cacheLimit);
        });
    }
    _fetchAndPrepFromNetwork(cachedResult, user, options) {
        return $cfb99a0123e1f5cd$var$__awaiter(this, void 0, void 0, function*() {
            var _a;
            const cachedData = (_a = cachedResult === null || cachedResult === void 0 ? void 0 : cachedResult.data) !== null && _a !== void 0 ? _a : null;
            const isCacheValidFor204 = cachedResult != null && this._isCachedResultValidFor204(cachedResult, user);
            const latest = yield this._fetchFromNetwork(cachedData, user, options, isCacheValidFor204);
            if (!latest) {
                $fvY6A.Log.debug('No response returned for latest value');
                return null;
            }
            const response = (0, $1I57i._typedJsonParse)(latest, 'has_updates', 'Response');
            const sdkKey = this._getSdkKey();
            const stableID = $lbAhi.StableID.get(sdkKey);
            let result = null;
            if ((response === null || response === void 0 ? void 0 : response.has_updates) === true) result = $cfb99a0123e1f5cd$var$_makeDataAdapterResult('Network', latest, stableID, user);
            else if (cachedData && (response === null || response === void 0 ? void 0 : response.has_updates) === false) result = $cfb99a0123e1f5cd$var$_makeDataAdapterResult('NetworkNotModified', cachedData, stableID, user);
            else return null;
            const cacheKey = this._getCacheKey(user);
            this._inMemoryCache.add(cacheKey, result, this._cacheLimit);
            this._writeToCache(cacheKey, result);
            return result;
        });
    }
    _getSdkKey() {
        if (this._sdkKey != null) return this._sdkKey;
        $fvY6A.Log.error(`${this._adapterName} is not attached to a Client`);
        return '';
    }
    _loadFromCache(cacheKey) {
        var _a;
        const cache = (_a = $cUOGL.Storage.getItem) === null || _a === void 0 ? void 0 : _a.call($cUOGL.Storage, cacheKey);
        if (cache == null) return null;
        const result = (0, $1I57i._typedJsonParse)(cache, 'source', 'Cached Result');
        return result ? Object.assign(Object.assign({}, result), {
            source: 'Cache'
        }) : null;
    }
    _writeToCache(cacheKey, result) {
        const resultString = JSON.stringify(result);
        for(let i = 0; i < $cfb99a0123e1f5cd$var$MAX_CACHE_WRITE_ATTEMPTS; i++)try {
            $cUOGL.Storage.setItem(cacheKey, resultString);
            break;
        } catch (error) {
            if (!(error instanceof Error) || !(error.toString().includes('QuotaExceededError') || error.toString().includes('QUOTA_EXCEEDED_ERR')) || this._cacheLimit <= 1) throw error;
            this._cacheLimit = Math.ceil(this._cacheLimit / 2);
            this._runLocalStorageCacheEviction(cacheKey, this._cacheLimit - 1);
        }
        this._runLocalStorageCacheEviction(cacheKey);
    }
    _runLocalStorageCacheEviction(cacheKey, cacheLimit = this._cacheLimit) {
        var _a;
        const lastModifiedTimeMap = (_a = (0, $cUOGL._getObjectFromStorage)(this._lastModifiedStoreKey)) !== null && _a !== void 0 ? _a : {};
        lastModifiedTimeMap[cacheKey] = Date.now();
        const evictableKeys = $cfb99a0123e1f5cd$var$_getEvictableKeys(lastModifiedTimeMap, cacheLimit);
        for (const evictable of evictableKeys){
            delete lastModifiedTimeMap[evictable];
            $cUOGL.Storage.removeItem(evictable);
        }
        (0, $cUOGL._setObjectInStorage)(this._lastModifiedStoreKey, lastModifiedTimeMap);
    }
}
module.exports.DataAdapterCore = $cfb99a0123e1f5cd$var$DataAdapterCore;
function $cfb99a0123e1f5cd$var$_makeDataAdapterResult(source, data, stableID, user) {
    return {
        source: source,
        data: data,
        receivedAt: Date.now(),
        stableID: stableID,
        fullUserHash: (0, $8Nbnq._getFullUserHash)(user)
    };
}
module.exports._makeDataAdapterResult = $cfb99a0123e1f5cd$var$_makeDataAdapterResult;
class $cfb99a0123e1f5cd$var$InMemoryCache {
    constructor(){
        this._data = {};
    }
    get(cacheKey, user) {
        var _a;
        const result = this._data[cacheKey];
        const cached = result === null || result === void 0 ? void 0 : result.stableID;
        const provided = (_a = user === null || user === void 0 ? void 0 : user.customIDs) === null || _a === void 0 ? void 0 : _a.stableID;
        if (provided && cached && provided !== cached) {
            $fvY6A.Log.warn("'StatsigUser.customIDs.stableID' mismatch");
            return null;
        }
        return result;
    }
    add(cacheKey, value, cacheLimit) {
        const evictableKeys = $cfb99a0123e1f5cd$var$_getEvictableKeys(this._data, cacheLimit - 1);
        for (const evictable of evictableKeys)delete this._data[evictable];
        this._data[cacheKey] = value;
    }
    merge(values) {
        this._data = Object.assign(Object.assign({}, this._data), values);
    }
}
function $cfb99a0123e1f5cd$var$_getEvictableKeys(data, limit) {
    const keys = Object.keys(data);
    if (keys.length <= limit) return [];
    if (limit === 0) return keys;
    return keys.sort((keyA, keyB)=>{
        const valueA = data[keyA];
        const valueB = data[keyB];
        if (typeof valueA === 'object' && typeof valueB === 'object') return valueA.receivedAt - valueB.receivedAt;
        return valueA - valueB;
    }).slice(0, keys.length - limit);
}

});
parcelRegister("8Nbnq", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._getUnitIDFromUser = module.exports._getFullUserHash = module.exports._normalizeUser = void 0;

var $lUUuL = parcelRequire("lUUuL");

var $fvY6A = parcelRequire("fvY6A");

var $jjgcN = parcelRequire("jjgcN");
function $666bb98ace10d484$var$_normalizeUser(original, options, fallbackEnvironment) {
    const copy = (0, $jjgcN._cloneObject)('StatsigUser', original);
    if (copy == null) {
        $fvY6A.Log.error('Failed to clone user');
        return {
            statsigEnvironment: undefined
        };
    }
    if (options != null && options.environment != null) copy.statsigEnvironment = options.environment;
    else if (fallbackEnvironment != null) copy.statsigEnvironment = {
        tier: fallbackEnvironment
    };
    return copy;
}
module.exports._normalizeUser = $666bb98ace10d484$var$_normalizeUser;
function $666bb98ace10d484$var$_getFullUserHash(user) {
    return user ? (0, $lUUuL._DJB2Object)(user) : null;
}
module.exports._getFullUserHash = $666bb98ace10d484$var$_getFullUserHash;
function $666bb98ace10d484$var$_getUnitIDFromUser(user, idType) {
    var _a, _b, _c;
    if (typeof idType !== 'string') return user.userID;
    const lowered = idType.toLowerCase();
    if (lowered !== 'userid') return (_b = (_a = user.customIDs) === null || _a === void 0 ? void 0 : _a[idType]) !== null && _b !== void 0 ? _b : (_c = user.customIDs) === null || _c === void 0 ? void 0 : _c[lowered];
    return user.userID;
}
module.exports._getUnitIDFromUser = $666bb98ace10d484$var$_getUnitIDFromUser;

});

parcelRegister("1I57i", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._typedJsonParse = void 0;

var $fvY6A = parcelRequire("fvY6A");
/**
 *
 * @param {string} data The values to parse into T
 * @param {string} guard A field that must exists on the parsed object for the parse to be valid
 * @param {string} error An error to print via Log.error() when parsing fails
 * @returns {T | null} The parse object T or null if it failed
 */ function $13edde94128756b8$var$_typedJsonParse(data, guard, typeName) {
    try {
        const result = JSON.parse(data);
        if (result && typeof result === 'object' && guard in result) return result;
    } catch (_a) {
    // noop
    }
    $fvY6A.Log.error(`Failed to parse ${typeName}`);
    return null;
}
module.exports._typedJsonParse = $13edde94128756b8$var$_typedJsonParse;

});


parcelRegister("audqG", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("a7dQ0", function(module, exports) {
"use strict";
var $75d54abd189c1104$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ErrorBoundary = module.exports.EXCEPTION_ENDPOINT = void 0;

var $fvY6A = parcelRequire("fvY6A");

var $6OyqX = parcelRequire("6OyqX");

var $9tDUz = parcelRequire("9tDUz");
module.exports.EXCEPTION_ENDPOINT = 'https://statsigapi.net/v1/sdk_exception';
const $75d54abd189c1104$var$UNKNOWN_ERROR = '[Statsig] UnknownError';
class $75d54abd189c1104$var$ErrorBoundary {
    constructor(_sdkKey, _options, _emitter, _lastSeenError){
        this._sdkKey = _sdkKey;
        this._options = _options;
        this._emitter = _emitter;
        this._lastSeenError = _lastSeenError;
        this._seen = new Set();
    }
    wrap(instance, namePrefix) {
        try {
            const obj = instance;
            $75d54abd189c1104$var$_getAllInstanceMethodNames(obj).forEach((name)=>{
                const original = obj[name];
                if ('$EB' in original) return;
                obj[name] = (...args)=>{
                    return this._capture(namePrefix ? `${namePrefix}:${name}` : name, ()=>original.apply(instance, args));
                };
                obj[name].$EB = true;
            });
        } catch (err) {
            this._onError('eb:wrap', err);
        }
    }
    logError(tag, error) {
        this._onError(tag, error);
    }
    logDroppedEvents(count, reason, metadata) {
        const extra = {
            eventCount: String(count),
            reason: reason
        };
        if (metadata) Object.keys(metadata).forEach((key)=>{
            extra[key] = String(metadata[key]);
        });
        this._onError(`statsig::log_event_dropped_event_count`, new Error(reason), true, extra);
    }
    logEventRequestFailure(count, reason, flushType, statusCode, retries, failurePath, failureErrorMessage, failureDiagnosticBucket, failureDiagnosticMetadata) {
        const extra = {
            eventCount: String(count),
            flushType: flushType,
            statusCode: String(statusCode),
            reason: reason,
            retries: String(retries)
        };
        if (failurePath) extra['failurePath'] = failurePath;
        if (typeof failureErrorMessage === 'string' && failureErrorMessage.length > 0) extra['failureErrorMessage'] = failureErrorMessage;
        if (typeof failureDiagnosticBucket === 'string' && failureDiagnosticBucket.length > 0) extra['failureDiagnosticBucket'] = failureDiagnosticBucket;
        if (failureDiagnosticMetadata) Object.keys(failureDiagnosticMetadata).forEach((key)=>{
            const value = failureDiagnosticMetadata[key];
            if (value.length > 0) extra[`failureDiagnostic_${key}`] = value;
        });
        this._onError(`statsig::log_event_failed`, new Error(reason), true, extra);
    }
    getLastSeenErrorAndReset() {
        const tempError = this._lastSeenError;
        this._lastSeenError = undefined;
        return tempError !== null && tempError !== void 0 ? tempError : null;
    }
    attachErrorIfNoneExists(error) {
        if (this._lastSeenError) return;
        this._lastSeenError = $75d54abd189c1104$var$_resolveError(error);
    }
    _capture(tag, task) {
        try {
            const res = task();
            if (res && res instanceof Promise) return res.catch((err)=>this._onError(tag, err));
            return res;
        } catch (error) {
            this._onError(tag, error);
            return null;
        }
    }
    _onError(tag, error, bypassDedupe = false, extra) {
        try {
            $fvY6A.Log.warn(`Caught error in ${tag}`, {
                error: error
            });
            const impl = ()=>$75d54abd189c1104$var$__awaiter(this, void 0, void 0, function*() {
                    var _a, _b, _c, _d, _e, _f, _g;
                    const unwrapped = error ? error : Error($75d54abd189c1104$var$UNKNOWN_ERROR);
                    const isError = unwrapped instanceof Error;
                    const name = isError ? unwrapped.name : 'No Name';
                    const resolvedError = $75d54abd189c1104$var$_resolveError(unwrapped);
                    this._lastSeenError = resolvedError;
                    if (!bypassDedupe && this._seen.has(name)) return;
                    this._seen.add(name);
                    if ((_b = (_a = this._options) === null || _a === void 0 ? void 0 : _a.networkConfig) === null || _b === void 0 ? void 0 : _b.preventAllNetworkTraffic) {
                        (_c = this._emitter) === null || _c === void 0 || _c.call(this, {
                            name: 'error',
                            error: error,
                            tag: tag
                        });
                        return;
                    }
                    const sdkType = $6OyqX.SDKType._get(this._sdkKey);
                    const statsigMetadata = $9tDUz.StatsigMetadataProvider.get();
                    const info = isError ? unwrapped.stack : $75d54abd189c1104$var$_getDescription(unwrapped);
                    const body = Object.assign(Object.assign({
                        tag: tag,
                        exception: name,
                        info: info,
                        statsigOptions: $75d54abd189c1104$var$_getStatsigOptionLoggingCopy(this._options)
                    }, Object.assign(Object.assign({}, statsigMetadata), {
                        sdkType: sdkType
                    })), extra !== null && extra !== void 0 ? extra : {});
                    const networkConfig = (_d = this._options) === null || _d === void 0 ? void 0 : _d.networkConfig;
                    const func = (_e = networkConfig === null || networkConfig === void 0 ? void 0 : networkConfig.networkOverrideFunc) !== null && _e !== void 0 ? _e : fetch;
                    yield func((_f = networkConfig === null || networkConfig === void 0 ? void 0 : networkConfig.sdkExceptionUrl) !== null && _f !== void 0 ? _f : module.exports.EXCEPTION_ENDPOINT, {
                        method: 'POST',
                        headers: {
                            'STATSIG-API-KEY': this._sdkKey,
                            'STATSIG-SDK-TYPE': String(sdkType),
                            'STATSIG-SDK-VERSION': String(statsigMetadata.sdkVersion),
                            'Content-Type': 'application/json'
                        },
                        body: JSON.stringify(body)
                    });
                    (_g = this._emitter) === null || _g === void 0 || _g.call(this, {
                        name: 'error',
                        error: error,
                        tag: tag
                    });
                });
            impl().then(()=>{
            /* noop */ }).catch(()=>{
            /* noop */ });
        } catch (_error) {
        /* noop */ }
    }
}
module.exports.ErrorBoundary = $75d54abd189c1104$var$ErrorBoundary;
function $75d54abd189c1104$var$_resolveError(error) {
    if (error instanceof Error) return error;
    else if (typeof error === 'string') return new Error(error);
    else return new Error('An unknown error occurred.');
}
function $75d54abd189c1104$var$_getDescription(obj) {
    try {
        return JSON.stringify(obj);
    } catch (_a) {
        return $75d54abd189c1104$var$UNKNOWN_ERROR;
    }
}
function $75d54abd189c1104$var$_getAllInstanceMethodNames(instance) {
    const names = new Set();
    let proto = Object.getPrototypeOf(instance);
    while(proto && proto !== Object.prototype){
        Object.getOwnPropertyNames(proto).filter((prop)=>typeof (proto === null || proto === void 0 ? void 0 : proto[prop]) === 'function').forEach((name)=>names.add(name));
        proto = Object.getPrototypeOf(proto);
    }
    return Array.from(names);
}
function $75d54abd189c1104$var$_getStatsigOptionLoggingCopy(options) {
    if (!options) return {};
    const loggingCopy = {};
    Object.keys(options).forEach((key)=>{
        const option = key;
        const value = options[option];
        const valueType = typeof value;
        switch(valueType){
            case 'number':
            case 'bigint':
            case 'boolean':
                loggingCopy[String(option)] = value;
                break;
            case 'string':
                if (value.length < 50) loggingCopy[String(option)] = value;
                else loggingCopy[String(option)] = 'set';
                break;
            case 'object':
                if (option === 'environment') loggingCopy['environment'] = value;
                else if (option === 'networkConfig') loggingCopy['networkConfig'] = value;
                else loggingCopy[String(option)] = value != null ? 'set' : 'unset';
                break;
            default:
        }
    });
    return loggingCopy;
}

});

parcelRegister("7A9u9", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("cpYjX", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("drWJh", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("g4vOj", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.createMemoKey = module.exports.MemoPrefix = void 0;
module.exports.MemoPrefix = {
    _gate: 'g',
    _dynamicConfig: 'c',
    _experiment: 'e',
    _configList: 'cl',
    _layer: 'l',
    _paramStore: 'p'
};
const $bb35b1f34b6c714c$var$EXIST_KEYS = new Set([]);
const $bb35b1f34b6c714c$var$DO_NOT_MEMO_KEYS = new Set([
    // Add keys that if exist, should not be memoized
    'userPersistedValues'
]);
function $bb35b1f34b6c714c$var$createMemoKey(prefix, name, options) {
    let cacheKey = `${prefix}|${name}`;
    if (!options) return cacheKey;
    for (const key of Object.keys(options)){
        if ($bb35b1f34b6c714c$var$DO_NOT_MEMO_KEYS.has(key)) return undefined;
        if ($bb35b1f34b6c714c$var$EXIST_KEYS.has(key)) cacheKey += `|${key}=true`;
        else cacheKey += `|${key}=${options[key]}`;
    }
    return cacheKey;
}
module.exports.createMemoKey = $bb35b1f34b6c714c$var$createMemoKey;

});

parcelRegister("am110", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("J5dlM", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("kS7H6", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._fastApproxSizeOf = void 0;
const $f31ed1b25fdb1fa1$var$CURLY_AND_SQUARE_BRACKET_SIZE = 2; // [] for array, {} for object
const $f31ed1b25fdb1fa1$var$APPROX_ADDITIONAL_SIZE = 1; // additional size for comma and stuff
const $f31ed1b25fdb1fa1$var$_fastApproxSizeOf = (obj, max)=>{
    let size = 0;
    const keys = Object.keys(obj);
    for(let i = 0; i < keys.length; i++){
        const key = keys[i];
        const value = obj[key];
        size += key.length;
        if (typeof value === 'object' && value !== null) size += (0, module.exports._fastApproxSizeOf)(value, max) + $f31ed1b25fdb1fa1$var$CURLY_AND_SQUARE_BRACKET_SIZE;
        else size += String(value).length + $f31ed1b25fdb1fa1$var$APPROX_ADDITIONAL_SIZE;
        if (size >= max) // exit early if we've exceeded the max
        return size;
    }
    return size;
};
module.exports._fastApproxSizeOf = $f31ed1b25fdb1fa1$var$_fastApproxSizeOf;

});

parcelRegister("uj5Sb", function(module, exports) {
"use strict";
var $05b19d12b0b40110$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.StatsigClientBase = void 0;

var $6zYf6 = parcelRequire("6zYf6");

var $6zYf6 = parcelRequire("6zYf6");

var $a7dQ0 = parcelRequire("a7dQ0");

var $lT0oC = parcelRequire("lT0oC");

var $fvY6A = parcelRequire("fvY6A");

var $g4vOj = parcelRequire("g4vOj");

var $jjgcN = parcelRequire("jjgcN");

var $6cbWs = parcelRequire("6cbWs");

var $lbAhi = parcelRequire("lbAhi");

var $fFtli = parcelRequire("fFtli");

var $cUOGL = parcelRequire("cUOGL");
const $05b19d12b0b40110$var$MAX_MEMO_CACHE_SIZE = 3000;
class $05b19d12b0b40110$var$StatsigClientBase {
    constructor(sdkKey, adapter, network, options){
        var _a, _b, _c, _d;
        this.loadingStatus = 'Uninitialized';
        this._initializePromise = null;
        this._listeners = {};
        const emitter = this.$emt.bind(this);
        (options === null || options === void 0 ? void 0 : options.logLevel) != null && ($fvY6A.Log.level = options.logLevel);
        (options === null || options === void 0 ? void 0 : options.disableStorage) && $cUOGL.Storage._setDisabled(true);
        (options === null || options === void 0 ? void 0 : options.initialSessionID) && $6cbWs.StatsigSession.overrideInitialSessionID(options.initialSessionID, sdkKey);
        (options === null || options === void 0 ? void 0 : options.storageProvider) && $cUOGL.Storage._setProvider(options.storageProvider);
        (options === null || options === void 0 ? void 0 : options.enableCookies) && $lbAhi.StableID._setCookiesEnabled(sdkKey, options.enableCookies);
        (options === null || options === void 0 ? void 0 : options.disableStableID) && $lbAhi.StableID._setDisabled(sdkKey, true);
        this._sdkKey = sdkKey;
        this._options = options !== null && options !== void 0 ? options : {};
        this._memoCache = {};
        this.overrideAdapter = (_a = options === null || options === void 0 ? void 0 : options.overrideAdapter) !== null && _a !== void 0 ? _a : null;
        this._errorBoundary = new $a7dQ0.ErrorBoundary(sdkKey, options, emitter);
        this._logger = new $lT0oC.EventLogger(sdkKey, emitter, network, options, this._errorBoundary);
        this._errorBoundary.wrap(this);
        this._errorBoundary.wrap(adapter);
        this._errorBoundary.wrap(this._logger);
        network.setErrorBoundary(this._errorBoundary);
        this.dataAdapter = adapter;
        this.dataAdapter.attach(sdkKey, options, network);
        this.storageProvider = $cUOGL.Storage;
        (_d = (_c = (_b = this.overrideAdapter) === null || _b === void 0 ? void 0 : _b.loadFromStorage) === null || _c === void 0 ? void 0 : _c.call(_b)) === null || _d === void 0 || _d.catch((e)=>this._errorBoundary.logError('OA::loadFromStorage', e));
        this._primeReadyRipcord();
        $05b19d12b0b40110$var$_assignGlobalInstance(sdkKey, this);
    }
    /**
     * Updates runtime configuration options for the SDK, allowing toggling of certain behaviors such as logging and storage to comply with user preferences or regulations such as GDPR.
     *
     * @param {StatsigRuntimeMutableOptions} options - The configuration options that dictate the runtime behavior of the SDK.
     */ updateRuntimeOptions(options) {
        if (options.loggingEnabled) {
            this._options.loggingEnabled = options.loggingEnabled;
            this._logger.setLoggingEnabled(options.loggingEnabled);
        } else if (options.disableLogging != null) {
            this._options.disableLogging = options.disableLogging;
            this._logger.setLoggingEnabled(options.disableLogging ? 'disabled' : 'browser-only');
        }
        if (options.disableStorage != null) {
            this._options.disableStorage = options.disableStorage;
            $cUOGL.Storage._setDisabled(options.disableStorage);
        }
        if (options.enableCookies != null) {
            this._options.enableCookies = options.enableCookies;
            $lbAhi.StableID._setCookiesEnabled(this._sdkKey, options.enableCookies);
        }
        if (options.logEventCompressionMode) this._logger.setLogEventCompressionMode(options.logEventCompressionMode);
        else if (options.disableCompression) this._logger.setLogEventCompressionMode($fFtli.LogEventCompressionMode.Disabled);
    }
    /**
     * Flushes any currently queued events.
     */ flush() {
        return this._logger.flush();
    }
    /**
     * Gracefully shuts down the SDK, ensuring that all pending events are send before the SDK stops.
     * This function emits a 'pre_shutdown' event and then waits for the logger to complete its shutdown process.
     *
     * @returns {Promise<void>} A promise that resolves when all shutdown procedures, including logging shutdown, have been completed.
     */ shutdown() {
        return $05b19d12b0b40110$var$__awaiter(this, void 0, void 0, function*() {
            this.$emt({
                name: 'pre_shutdown'
            });
            this._setStatus('Uninitialized', null);
            this._initializePromise = null;
            yield this._logger.stop();
        });
    }
    /**
     * Subscribes a callback function to a specific {@link StatsigClientEvent} or all StatsigClientEvents if the wildcard '*' is used.
     * Once subscribed, the listener callback will be invoked whenever the specified event is emitted.
     *
     * @param {StatsigClientEventName} event - The name of the event to subscribe to, or '*' to subscribe to all events.
     * @param {StatsigClientEventCallback<T>} listener - The callback function to execute when the event occurs. The function receives event-specific data as its parameter.
     * @see {@link off} for unsubscribing from events.
     */ on(event, listener) {
        if (!this._listeners[event]) this._listeners[event] = [];
        this._listeners[event].push(listener);
    }
    /**
     * Unsubscribes a previously registered callback function from a specific {@link StatsigClientEvent} or all StatsigClientEvents if the wildcard '*' is used.
     *
     * @param {StatsigClientEventName} event - The name of the event from which to unsubscribe, or '*' to unsubscribe from all events.
     * @param {StatsigClientEventCallback<T>} listener - The callback function to remove from the event's notification list.
     * @see {@link on} for subscribing to events.
     */ off(event, listener) {
        if (this._listeners[event]) {
            const index = this._listeners[event].indexOf(listener);
            if (index !== -1) this._listeners[event].splice(index, 1);
        }
    }
    $on(event, listener) {
        listener.__isInternal = true;
        this.on(event, listener);
    }
    $emt(event) {
        var _a;
        const barrier = (listener)=>{
            try {
                listener(event);
            } catch (error) {
                if (listener.__isInternal === true) {
                    this._errorBoundary.logError(`__emit:${event.name}`, error);
                    return;
                }
                $fvY6A.Log.error(`An error occurred in a StatsigClientEvent listener. This is not an issue with Statsig.`, event);
            }
        };
        if (this._listeners[event.name]) this._listeners[event.name].forEach((l)=>barrier(l));
        (_a = this._listeners['*']) === null || _a === void 0 || _a.forEach(barrier);
    }
    _setStatus(newStatus, values) {
        this.loadingStatus = newStatus;
        this._memoCache = {};
        this.$emt({
            name: 'values_updated',
            status: newStatus,
            values: values
        });
    }
    _enqueueExposure(name, exposure, options) {
        if ((options === null || options === void 0 ? void 0 : options.disableExposureLog) === true) {
            this._logger.incrementNonExposureCount(name);
            return;
        }
        this._logger.enqueue(exposure);
    }
    _memoize(prefix, fn) {
        return (name, options)=>{
            if (this._options.disableEvaluationMemoization) return fn(name, options);
            const memoKey = (0, $g4vOj.createMemoKey)(prefix, name, options);
            if (!memoKey) return fn(name, options);
            if (!(memoKey in this._memoCache)) {
                if (Object.keys(this._memoCache).length >= $05b19d12b0b40110$var$MAX_MEMO_CACHE_SIZE) this._memoCache = {};
                this._memoCache[memoKey] = fn(name, options);
            }
            return this._memoCache[memoKey];
        };
    }
}
module.exports.StatsigClientBase = $05b19d12b0b40110$var$StatsigClientBase;
function $05b19d12b0b40110$var$_assignGlobalInstance(sdkKey, client) {
    var _a;
    if ((0, $jjgcN._isServerEnv)()) return;
    const statsigGlobal = (0, $6zYf6._getStatsigGlobal)();
    const instances = (_a = statsigGlobal.instances) !== null && _a !== void 0 ? _a : {};
    const inst = client;
    if (instances[sdkKey] != null) $fvY6A.Log.warn('Creating multiple Statsig clients with the same SDK key can lead to unexpected behavior. Multi-instance support requires different SDK keys.');
    instances[sdkKey] = inst;
    if (!statsigGlobal.firstInstance) statsigGlobal.firstInstance = inst;
    statsigGlobal.instances = instances;
    __STATSIG__ = statsigGlobal;
}

});

parcelRegister("4kZUp", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DataAdapterCachePrefix = void 0;
module.exports.DataAdapterCachePrefix = 'statsig.cached';

});

parcelRegister("eEYg8", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("boH9C", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._makeTypedGet = module.exports._mergeOverride = module.exports._makeLayer = module.exports._makeExperiment = module.exports._makeDynamicConfig = module.exports._makeFeatureGate = void 0;

var $fvY6A = parcelRequire("fvY6A");

var $fOOnv = parcelRequire("fOOnv");
function $84c36919a00c4c78$var$_makeEvaluation(name, details, evaluation, value) {
    var _a;
    return {
        name: name,
        details: details,
        ruleID: (_a = evaluation === null || evaluation === void 0 ? void 0 : evaluation.rule_id) !== null && _a !== void 0 ? _a : '',
        __evaluation: evaluation,
        value: value
    };
}
function $84c36919a00c4c78$var$_makeFeatureGate(name, details, evaluation) {
    var _a;
    return Object.assign(Object.assign({}, $84c36919a00c4c78$var$_makeEvaluation(name, details, evaluation, (evaluation === null || evaluation === void 0 ? void 0 : evaluation.value) === true)), {
        idType: (_a = evaluation === null || evaluation === void 0 ? void 0 : evaluation.id_type) !== null && _a !== void 0 ? _a : null
    });
}
module.exports._makeFeatureGate = $84c36919a00c4c78$var$_makeFeatureGate;
function $84c36919a00c4c78$var$_makeDynamicConfig(name, details, evaluation) {
    var _a, _b;
    const value = (_a = evaluation === null || evaluation === void 0 ? void 0 : evaluation.value) !== null && _a !== void 0 ? _a : {};
    return Object.assign(Object.assign({}, $84c36919a00c4c78$var$_makeEvaluation(name, details, evaluation, value)), {
        idType: (_b = evaluation === null || evaluation === void 0 ? void 0 : evaluation.id_type) !== null && _b !== void 0 ? _b : null,
        get: $84c36919a00c4c78$var$_makeTypedGet(name, evaluation === null || evaluation === void 0 ? void 0 : evaluation.value)
    });
}
module.exports._makeDynamicConfig = $84c36919a00c4c78$var$_makeDynamicConfig;
function $84c36919a00c4c78$var$_makeExperiment(name, details, evaluation) {
    var _a;
    const result = $84c36919a00c4c78$var$_makeDynamicConfig(name, details, evaluation);
    return Object.assign(Object.assign({}, result), {
        groupName: (_a = evaluation === null || evaluation === void 0 ? void 0 : evaluation.group_name) !== null && _a !== void 0 ? _a : null
    });
}
module.exports._makeExperiment = $84c36919a00c4c78$var$_makeExperiment;
function $84c36919a00c4c78$var$_makeLayer(name, details, evaluation, exposeFunc) {
    var _a, _b;
    return Object.assign(Object.assign({}, $84c36919a00c4c78$var$_makeEvaluation(name, details, evaluation, undefined)), {
        get: $84c36919a00c4c78$var$_makeTypedGet(name, evaluation === null || evaluation === void 0 ? void 0 : evaluation.value, exposeFunc),
        groupName: (_a = evaluation === null || evaluation === void 0 ? void 0 : evaluation.group_name) !== null && _a !== void 0 ? _a : null,
        __value: (_b = evaluation === null || evaluation === void 0 ? void 0 : evaluation.value) !== null && _b !== void 0 ? _b : {}
    });
}
module.exports._makeLayer = $84c36919a00c4c78$var$_makeLayer;
function $84c36919a00c4c78$var$_mergeOverride(original, overridden, value, exposeFunc) {
    return Object.assign(Object.assign(Object.assign({}, original), overridden), {
        get: $84c36919a00c4c78$var$_makeTypedGet(original.name, value, exposeFunc)
    });
}
module.exports._mergeOverride = $84c36919a00c4c78$var$_mergeOverride;
function $84c36919a00c4c78$var$_makeTypedGet(name, value, exposeFunc) {
    return (param, fallback)=>{
        var _a;
        const found = (_a = value === null || value === void 0 ? void 0 : value[param]) !== null && _a !== void 0 ? _a : null;
        if (found == null) return fallback !== null && fallback !== void 0 ? fallback : null;
        if (fallback != null && !(0, $fOOnv._isTypeMatch)(found, fallback)) {
            $fvY6A.Log.warn(`Parameter type mismatch. '${name}.${param}' was found to be type '${typeof found}' but fallback/return type is '${typeof fallback}'. See https://docs.statsig.com/client/javascript-sdk/#typed-getters`);
            return fallback !== null && fallback !== void 0 ? fallback : null;
        }
        exposeFunc === null || exposeFunc === void 0 || exposeFunc(param);
        return found;
    };
}
module.exports._makeTypedGet = $84c36919a00c4c78$var$_makeTypedGet;

});

parcelRegister("3G1qf", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("bhG9g", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.UPDATE_DETAIL_ERROR_MESSAGES = module.exports.createUpdateDetails = void 0;
const $8371fa073e270eba$var$createUpdateDetails = (success, source, initDuration, error, sourceUrl, warnings)=>{
    return {
        duration: initDuration,
        source: source,
        success: success,
        error: error,
        sourceUrl: sourceUrl,
        warnings: warnings
    };
};
module.exports.createUpdateDetails = $8371fa073e270eba$var$createUpdateDetails;
module.exports.UPDATE_DETAIL_ERROR_MESSAGES = {
    NO_NETWORK_DATA: 'No data was returned from the network. This may be due to a network timeout if a timeout value was specified in the options or ad blocker error.'
};

});


parcelRegister("lMtwZ", function(module, exports) {
$parcel$export(module.exports, "default", () => $fdb4fcee5e9f225e$export$2e2bcd8739ae039);

var $b29gf = parcelRequire("b29gf");
function $fdb4fcee5e9f225e$export$2e2bcd8739ae039(e, r, t) {
    return (r = (0, $b29gf.default)(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}

});
parcelRegister("b29gf", function(module, exports) {
$parcel$export(module.exports, "default", () => $808710accd22d56b$export$2e2bcd8739ae039);

var $kZkio = parcelRequire("kZkio");

var $9QmJZ = parcelRequire("9QmJZ");
function $808710accd22d56b$export$2e2bcd8739ae039(t) {
    var i = (0, $9QmJZ.default)(t, "string");
    return "symbol" == (0, $kZkio.default)(i) ? i : i + "";
}

});
parcelRegister("kZkio", function(module, exports) {
$parcel$export(module.exports, "default", () => $f4793f7237b4ce17$export$2e2bcd8739ae039);
function $f4793f7237b4ce17$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $f4793f7237b4ce17$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $f4793f7237b4ce17$export$2e2bcd8739ae039(o);
}

});

parcelRegister("9QmJZ", function(module, exports) {
$parcel$export(module.exports, "default", () => $72aa9c3ba94c8c19$export$2e2bcd8739ae039);

var $kZkio = parcelRequire("kZkio");
function $72aa9c3ba94c8c19$export$2e2bcd8739ae039(t, r) {
    if ("object" != (0, $kZkio.default)(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (0, $kZkio.default)(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}

});



parcelRegister("9KzpK", function(module, exports) {

var $bTl5Q = parcelRequire("bTl5Q");
var $7193e179558807e7$var$_typeof = $bTl5Q.default;
function $7193e179558807e7$var$_regeneratorRuntime() {
    "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ 
    module.exports = $7193e179558807e7$var$_regeneratorRuntime = function _regeneratorRuntime() {
        return e;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports;
    var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function(t, e, r) {
        t[e] = r.value;
    }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag";
    function define(t, e, r) {
        return Object.defineProperty(t, e, {
            value: r,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }), t[e];
    }
    try {
        define({}, "");
    } catch (t) {
        define = function define(t, e, r) {
            return t[e] = r;
        };
    }
    function wrap(t, e, r, n) {
        var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []);
        return o(a, "_invoke", {
            value: makeInvokeMethod(t, r, c)
        }), a;
    }
    function tryCatch(t, e, r) {
        try {
            return {
                type: "normal",
                arg: t.call(e, r)
            };
        } catch (t) {
            return {
                type: "throw",
                arg: t
            };
        }
    }
    e.wrap = wrap;
    var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {};
    function Generator() {}
    function GeneratorFunction() {}
    function GeneratorFunctionPrototype() {}
    var p = {};
    define(p, a, function() {
        return this;
    });
    var d = Object.getPrototypeOf, v = d && d(d(values([])));
    v && v !== r && n.call(v, a) && (p = v);
    var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p);
    function defineIteratorMethods(t) {
        [
            "next",
            "throw",
            "return"
        ].forEach(function(e) {
            define(t, e, function(t) {
                return this._invoke(e, t);
            });
        });
    }
    function AsyncIterator(t, e) {
        function invoke(r, o, i, a) {
            var c = tryCatch(t[r], t, o);
            if ("throw" !== c.type) {
                var u = c.arg, h = u.value;
                return h && "object" == $7193e179558807e7$var$_typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function(t) {
                    invoke("next", t, i, a);
                }, function(t) {
                    invoke("throw", t, i, a);
                }) : e.resolve(h).then(function(t) {
                    u.value = t, i(u);
                }, function(t) {
                    return invoke("throw", t, i, a);
                });
            }
            a(c.arg);
        }
        var r;
        o(this, "_invoke", {
            value: function value(t, n) {
                function callInvokeWithMethodAndArg() {
                    return new e(function(e, r) {
                        invoke(t, n, e, r);
                    });
                }
                return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
            }
        });
    }
    function makeInvokeMethod(e, r, n) {
        var o = h;
        return function(i, a) {
            if (o === f) throw Error("Generator is already running");
            if (o === s) {
                if ("throw" === i) throw a;
                return {
                    value: t,
                    done: !0
                };
            }
            for(n.method = i, n.arg = a;;){
                var c = n.delegate;
                if (c) {
                    var u = maybeInvokeDelegate(c, n);
                    if (u) {
                        if (u === y) continue;
                        return u;
                    }
                }
                if ("next" === n.method) n.sent = n._sent = n.arg;
                else if ("throw" === n.method) {
                    if (o === h) throw o = s, n.arg;
                    n.dispatchException(n.arg);
                } else "return" === n.method && n.abrupt("return", n.arg);
                o = f;
                var p = tryCatch(e, r, n);
                if ("normal" === p.type) {
                    if (o = n.done ? s : l, p.arg === y) continue;
                    return {
                        value: p.arg,
                        done: n.done
                    };
                }
                "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg);
            }
        };
    }
    function maybeInvokeDelegate(e, r) {
        var n = r.method, o = e.iterator[n];
        if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y;
        var i = tryCatch(o, e.iterator, r.arg);
        if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y;
        var a = i.arg;
        return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y);
    }
    function pushTryEntry(t) {
        var e = {
            tryLoc: t[0]
        };
        1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e);
    }
    function resetTryEntry(t) {
        var e = t.completion || {};
        e.type = "normal", delete e.arg, t.completion = e;
    }
    function Context(t) {
        this.tryEntries = [
            {
                tryLoc: "root"
            }
        ], t.forEach(pushTryEntry, this), this.reset(!0);
    }
    function values(e) {
        if (e || "" === e) {
            var r = e[a];
            if (r) return r.call(e);
            if ("function" == typeof e.next) return e;
            if (!isNaN(e.length)) {
                var o = -1, i = function next() {
                    for(; ++o < e.length;)if (n.call(e, o)) return next.value = e[o], next.done = !1, next;
                    return next.value = t, next.done = !0, next;
                };
                return i.next = i;
            }
        }
        throw new TypeError($7193e179558807e7$var$_typeof(e) + " is not iterable");
    }
    return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", {
        value: GeneratorFunctionPrototype,
        configurable: !0
    }), o(GeneratorFunctionPrototype, "constructor", {
        value: GeneratorFunction,
        configurable: !0
    }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function(t) {
        var e = "function" == typeof t && t.constructor;
        return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name));
    }, e.mark = function(t) {
        return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t;
    }, e.awrap = function(t) {
        return {
            __await: t
        };
    }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function() {
        return this;
    }), e.AsyncIterator = AsyncIterator, e.async = function(t, r, n, o, i) {
        void 0 === i && (i = Promise);
        var a = new AsyncIterator(wrap(t, r, n, o), i);
        return e.isGeneratorFunction(r) ? a : a.next().then(function(t) {
            return t.done ? t.value : a.next();
        });
    }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function() {
        return this;
    }), define(g, "toString", function() {
        return "[object Generator]";
    }), e.keys = function(t) {
        var e = Object(t), r = [];
        for(var n in e)r.push(n);
        return r.reverse(), function next() {
            for(; r.length;){
                var t = r.pop();
                if (t in e) return next.value = t, next.done = !1, next;
            }
            return next.done = !0, next;
        };
    }, e.values = values, Context.prototype = {
        constructor: Context,
        reset: function reset(e) {
            if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for(var r in this)"t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t);
        },
        stop: function stop() {
            this.done = !0;
            var t = this.tryEntries[0].completion;
            if ("throw" === t.type) throw t.arg;
            return this.rval;
        },
        dispatchException: function dispatchException(e) {
            if (this.done) throw e;
            var r = this;
            function handle(n, o) {
                return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o;
            }
            for(var o = this.tryEntries.length - 1; o >= 0; --o){
                var i = this.tryEntries[o], a = i.completion;
                if ("root" === i.tryLoc) return handle("end");
                if (i.tryLoc <= this.prev) {
                    var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc");
                    if (c && u) {
                        if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
                        if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
                    } else if (c) {
                        if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
                    } else {
                        if (!u) throw Error("try statement without catch or finally");
                        if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
                    }
                }
            }
        },
        abrupt: function abrupt(t, e) {
            for(var r = this.tryEntries.length - 1; r >= 0; --r){
                var o = this.tryEntries[r];
                if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
                    var i = o;
                    break;
                }
            }
            i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null);
            var a = i ? i.completion : {};
            return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a);
        },
        complete: function complete(t, e) {
            if ("throw" === t.type) throw t.arg;
            return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y;
        },
        finish: function finish(t) {
            for(var e = this.tryEntries.length - 1; e >= 0; --e){
                var r = this.tryEntries[e];
                if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y;
            }
        },
        "catch": function _catch(t) {
            for(var e = this.tryEntries.length - 1; e >= 0; --e){
                var r = this.tryEntries[e];
                if (r.tryLoc === t) {
                    var n = r.completion;
                    if ("throw" === n.type) {
                        var o = n.arg;
                        resetTryEntry(r);
                    }
                    return o;
                }
            }
            throw Error("illegal catch attempt");
        },
        delegateYield: function delegateYield(e, r, n) {
            return this.delegate = {
                iterator: values(e),
                resultName: r,
                nextLoc: n
            }, "next" === this.method && (this.arg = t), y;
        }
    }, e;
}
module.exports = $7193e179558807e7$var$_regeneratorRuntime, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("bTl5Q", function(module, exports) {
function $8a853176ff3bc5cf$var$_typeof(o) {
    "@babel/helpers - typeof";
    return module.exports = $8a853176ff3bc5cf$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $8a853176ff3bc5cf$var$_typeof(o);
}
module.exports = $8a853176ff3bc5cf$var$_typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("eP9zw", function(module, exports) {

var $lvDhm = parcelRequire("lvDhm");
var $acad40df70645ed8$var$_typeof = $lvDhm.default;
function $acad40df70645ed8$var$_regeneratorRuntime() {
    "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ 
    module.exports = $acad40df70645ed8$var$_regeneratorRuntime = function _regeneratorRuntime() {
        return e;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports;
    var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function(t, e, r) {
        t[e] = r.value;
    }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag";
    function define(t, e, r) {
        return Object.defineProperty(t, e, {
            value: r,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }), t[e];
    }
    try {
        define({}, "");
    } catch (t) {
        define = function define(t, e, r) {
            return t[e] = r;
        };
    }
    function wrap(t, e, r, n) {
        var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []);
        return o(a, "_invoke", {
            value: makeInvokeMethod(t, r, c)
        }), a;
    }
    function tryCatch(t, e, r) {
        try {
            return {
                type: "normal",
                arg: t.call(e, r)
            };
        } catch (t) {
            return {
                type: "throw",
                arg: t
            };
        }
    }
    e.wrap = wrap;
    var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {};
    function Generator() {}
    function GeneratorFunction() {}
    function GeneratorFunctionPrototype() {}
    var p = {};
    define(p, a, function() {
        return this;
    });
    var d = Object.getPrototypeOf, v = d && d(d(values([])));
    v && v !== r && n.call(v, a) && (p = v);
    var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p);
    function defineIteratorMethods(t) {
        [
            "next",
            "throw",
            "return"
        ].forEach(function(e) {
            define(t, e, function(t) {
                return this._invoke(e, t);
            });
        });
    }
    function AsyncIterator(t, e) {
        function invoke(r, o, i, a) {
            var c = tryCatch(t[r], t, o);
            if ("throw" !== c.type) {
                var u = c.arg, h = u.value;
                return h && "object" == $acad40df70645ed8$var$_typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function(t) {
                    invoke("next", t, i, a);
                }, function(t) {
                    invoke("throw", t, i, a);
                }) : e.resolve(h).then(function(t) {
                    u.value = t, i(u);
                }, function(t) {
                    return invoke("throw", t, i, a);
                });
            }
            a(c.arg);
        }
        var r;
        o(this, "_invoke", {
            value: function value(t, n) {
                function callInvokeWithMethodAndArg() {
                    return new e(function(e, r) {
                        invoke(t, n, e, r);
                    });
                }
                return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
            }
        });
    }
    function makeInvokeMethod(e, r, n) {
        var o = h;
        return function(i, a) {
            if (o === f) throw Error("Generator is already running");
            if (o === s) {
                if ("throw" === i) throw a;
                return {
                    value: t,
                    done: !0
                };
            }
            for(n.method = i, n.arg = a;;){
                var c = n.delegate;
                if (c) {
                    var u = maybeInvokeDelegate(c, n);
                    if (u) {
                        if (u === y) continue;
                        return u;
                    }
                }
                if ("next" === n.method) n.sent = n._sent = n.arg;
                else if ("throw" === n.method) {
                    if (o === h) throw o = s, n.arg;
                    n.dispatchException(n.arg);
                } else "return" === n.method && n.abrupt("return", n.arg);
                o = f;
                var p = tryCatch(e, r, n);
                if ("normal" === p.type) {
                    if (o = n.done ? s : l, p.arg === y) continue;
                    return {
                        value: p.arg,
                        done: n.done
                    };
                }
                "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg);
            }
        };
    }
    function maybeInvokeDelegate(e, r) {
        var n = r.method, o = e.iterator[n];
        if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y;
        var i = tryCatch(o, e.iterator, r.arg);
        if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y;
        var a = i.arg;
        return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y);
    }
    function pushTryEntry(t) {
        var e = {
            tryLoc: t[0]
        };
        1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e);
    }
    function resetTryEntry(t) {
        var e = t.completion || {};
        e.type = "normal", delete e.arg, t.completion = e;
    }
    function Context(t) {
        this.tryEntries = [
            {
                tryLoc: "root"
            }
        ], t.forEach(pushTryEntry, this), this.reset(!0);
    }
    function values(e) {
        if (e || "" === e) {
            var r = e[a];
            if (r) return r.call(e);
            if ("function" == typeof e.next) return e;
            if (!isNaN(e.length)) {
                var o = -1, i = function next() {
                    for(; ++o < e.length;)if (n.call(e, o)) return next.value = e[o], next.done = !1, next;
                    return next.value = t, next.done = !0, next;
                };
                return i.next = i;
            }
        }
        throw new TypeError($acad40df70645ed8$var$_typeof(e) + " is not iterable");
    }
    return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", {
        value: GeneratorFunctionPrototype,
        configurable: !0
    }), o(GeneratorFunctionPrototype, "constructor", {
        value: GeneratorFunction,
        configurable: !0
    }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function(t) {
        var e = "function" == typeof t && t.constructor;
        return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name));
    }, e.mark = function(t) {
        return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t;
    }, e.awrap = function(t) {
        return {
            __await: t
        };
    }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function() {
        return this;
    }), e.AsyncIterator = AsyncIterator, e.async = function(t, r, n, o, i) {
        void 0 === i && (i = Promise);
        var a = new AsyncIterator(wrap(t, r, n, o), i);
        return e.isGeneratorFunction(r) ? a : a.next().then(function(t) {
            return t.done ? t.value : a.next();
        });
    }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function() {
        return this;
    }), define(g, "toString", function() {
        return "[object Generator]";
    }), e.keys = function(t) {
        var e = Object(t), r = [];
        for(var n in e)r.push(n);
        return r.reverse(), function next() {
            for(; r.length;){
                var t = r.pop();
                if (t in e) return next.value = t, next.done = !1, next;
            }
            return next.done = !0, next;
        };
    }, e.values = values, Context.prototype = {
        constructor: Context,
        reset: function reset(e) {
            if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for(var r in this)"t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t);
        },
        stop: function stop() {
            this.done = !0;
            var t = this.tryEntries[0].completion;
            if ("throw" === t.type) throw t.arg;
            return this.rval;
        },
        dispatchException: function dispatchException(e) {
            if (this.done) throw e;
            var r = this;
            function handle(n, o) {
                return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o;
            }
            for(var o = this.tryEntries.length - 1; o >= 0; --o){
                var i = this.tryEntries[o], a = i.completion;
                if ("root" === i.tryLoc) return handle("end");
                if (i.tryLoc <= this.prev) {
                    var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc");
                    if (c && u) {
                        if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
                        if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
                    } else if (c) {
                        if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
                    } else {
                        if (!u) throw Error("try statement without catch or finally");
                        if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
                    }
                }
            }
        },
        abrupt: function abrupt(t, e) {
            for(var r = this.tryEntries.length - 1; r >= 0; --r){
                var o = this.tryEntries[r];
                if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
                    var i = o;
                    break;
                }
            }
            i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null);
            var a = i ? i.completion : {};
            return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a);
        },
        complete: function complete(t, e) {
            if ("throw" === t.type) throw t.arg;
            return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y;
        },
        finish: function finish(t) {
            for(var e = this.tryEntries.length - 1; e >= 0; --e){
                var r = this.tryEntries[e];
                if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y;
            }
        },
        "catch": function _catch(t) {
            for(var e = this.tryEntries.length - 1; e >= 0; --e){
                var r = this.tryEntries[e];
                if (r.tryLoc === t) {
                    var n = r.completion;
                    if ("throw" === n.type) {
                        var o = n.arg;
                        resetTryEntry(r);
                    }
                    return o;
                }
            }
            throw Error("illegal catch attempt");
        },
        delegateYield: function delegateYield(e, r, n) {
            return this.delegate = {
                iterator: values(e),
                resultName: r,
                nextLoc: n
            }, "next" === this.method && (this.arg = t), y;
        }
    }, e;
}
module.exports = $acad40df70645ed8$var$_regeneratorRuntime, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("lvDhm", function(module, exports) {
function $fa8af635609b88fa$var$_typeof(o) {
    "@babel/helpers - typeof";
    return module.exports = $fa8af635609b88fa$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $fa8af635609b88fa$var$_typeof(o);
}
module.exports = $fa8af635609b88fa$var$_typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("9AP5g", function(module, exports) {
$parcel$export(module.exports, "THEME_DATA_ATTRIBUTE", () => $6fbf1a0fc3bf0ef0$export$4ef52930e33717cd);
$parcel$export(module.exports, "COLOR_MODE_ATTRIBUTE", () => $6fbf1a0fc3bf0ef0$export$a00eac3f8684bcd0);
$parcel$export(module.exports, "CONTRAST_MODE_ATTRIBUTE", () => $6fbf1a0fc3bf0ef0$export$2112803007239c61);
$parcel$export(module.exports, "CUSTOM_THEME_ATTRIBUTE", () => $6fbf1a0fc3bf0ef0$export$352e418ed5b6193a);
$parcel$export(module.exports, "TOKEN_NOT_FOUND_CSS_VAR", () => $6fbf1a0fc3bf0ef0$export$dddac1532e822863);
var $6fbf1a0fc3bf0ef0$export$4ef52930e33717cd = 'data-theme';
var $6fbf1a0fc3bf0ef0$export$cb374d25ded7f6ab = 'data-subtree-theme';
var $6fbf1a0fc3bf0ef0$export$a00eac3f8684bcd0 = 'data-color-mode';
var $6fbf1a0fc3bf0ef0$export$2112803007239c61 = 'data-contrast-mode';
var $6fbf1a0fc3bf0ef0$export$352e418ed5b6193a = 'data-custom-theme';
var $6fbf1a0fc3bf0ef0$export$6f0c6fb8c80fcc92 = 'ds';
var $6fbf1a0fc3bf0ef0$export$4d0c7bbf80185957 = [
    'opacity',
    'font',
    'space',
    'border',
    'radius'
];
var $6fbf1a0fc3bf0ef0$export$dddac1532e822863 = "--".concat($6fbf1a0fc3bf0ef0$export$6f0c6fb8c80fcc92, "-token-not-found");
var $6fbf1a0fc3bf0ef0$export$9d7b58831ae93caa = "--".concat($6fbf1a0fc3bf0ef0$export$6f0c6fb8c80fcc92, "-elevation-surface-current");

});

parcelRegister("jAELq", function(module, exports) {
$parcel$export(module.exports, "default", () => $e430fff8b7c5bfa6$export$2e2bcd8739ae039);

var $c9Pje = parcelRequire("c9Pje");

var $hOA8z = parcelRequire("hOA8z");

var $a07JP = parcelRequire("a07JP");

var $bZseG = parcelRequire("bZseG");
function $e430fff8b7c5bfa6$export$2e2bcd8739ae039(r, e) {
    return (0, $c9Pje.default)(r) || (0, $hOA8z.default)(r, e) || (0, $a07JP.default)(r, e) || (0, $bZseG.default)();
}

});
parcelRegister("c9Pje", function(module, exports) {
$parcel$export(module.exports, "default", () => $8d9e2040f026e939$export$2e2bcd8739ae039);
function $8d9e2040f026e939$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return r;
}

});

parcelRegister("hOA8z", function(module, exports) {
$parcel$export(module.exports, "default", () => $cf8323452ede5d70$export$2e2bcd8739ae039);
function $cf8323452ede5d70$export$2e2bcd8739ae039(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}

});

parcelRegister("a07JP", function(module, exports) {
$parcel$export(module.exports, "default", () => $747fe82102cf5689$export$2e2bcd8739ae039);

var $79LsX = parcelRequire("79LsX");
function $747fe82102cf5689$export$2e2bcd8739ae039(r, a) {
    if (r) {
        if ("string" == typeof r) return (0, $79LsX.default)(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? (0, $79LsX.default)(r, a) : void 0;
    }
}

});
parcelRegister("79LsX", function(module, exports) {
$parcel$export(module.exports, "default", () => $535e31720930fa14$export$2e2bcd8739ae039);
function $535e31720930fa14$export$2e2bcd8739ae039(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}

});


parcelRegister("bZseG", function(module, exports) {
$parcel$export(module.exports, "default", () => $8bab4b3f2e32cbde$export$2e2bcd8739ae039);
function $8bab4b3f2e32cbde$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});


parcelRegister("6lN5g", function(module, exports) {
$parcel$export(module.exports, "themeStateDefaults", () => $49fac74827b8f0a3$export$9aedcfa7336a207);

var $50U6m = parcelRequire("50U6m");
/**
 * Can't evaluate typography feature flags at the module level,
 * it will always resolve to false when server side rendered or when flags are loaded async.
 */ function $49fac74827b8f0a3$var$getShapeDefault() {
    if ((0, $50U6m.fg)('platform-dst-shape-theme-default')) return 'shape';
    return undefined;
}
function $49fac74827b8f0a3$var$getMotionDefault() {
    return 'motion';
}
var $49fac74827b8f0a3$export$9aedcfa7336a207 = {
    colorMode: 'auto',
    contrastMode: 'auto',
    dark: 'dark',
    light: 'light',
    shape: $49fac74827b8f0a3$var$getShapeDefault,
    spacing: 'spacing',
    typography: 'typography',
    motion: $49fac74827b8f0a3$var$getMotionDefault,
    UNSAFE_themeOptions: undefined
};

});
parcelRegister("50U6m", function(module, exports) {
$parcel$export(module.exports, "fg", () => $3a687875757f8eea$export$b40ec24ac8275656);

var $i5SqG = parcelRequire("i5SqG");
function $3a687875757f8eea$export$b40ec24ac8275656(name) {
    return (0, $i5SqG.resolveBooleanFlag)(name);
}

});
parcelRegister("i5SqG", function(module, exports) {
$parcel$export(module.exports, "resolveBooleanFlag", () => $d2c2ea276273a3b9$export$6333b6aff9fc6275);

var $34h0K = parcelRequire("34h0K");

var $kjcRI = parcelRequire("kjcRI");

var $9i3MK = parcelRequire("9i3MK");

var $iuNyR = parcelRequire("iuNyR");

var $e2P9b = parcelRequire("e2P9b");

var $lLIS3 = parcelRequire("lLIS3");
var $d2c2ea276273a3b9$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE = (0, $9i3MK.ENV_ENABLE_PLATFORM_FF) || (0, $iuNyR.ENV_STORYBOOK_ENABLE_PLATFORM_FF);
function $d2c2ea276273a3b9$export$6333b6aff9fc6275(flagKey) {
    if ($d2c2ea276273a3b9$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE) {
        (0, $kjcRI.debug)('[%s]: The feature flags were enabled while running tests. The flag "%s" will be always enabled.', (0, $lLIS3.pkgName), flagKey);
        return true;
    }
    try {
        var _globalVar$PFF_GLOBAL, _globalVar$PFF_GLOBAL2, _globalVar$PFF_GLOBAL3;
        // booleanResolver will be empty for products like Trello, Elevate, Recruit etc.
        // Currently only Confluence, Jira and Bitbucket has set it.
        if (((_globalVar$PFF_GLOBAL = (0, $e2P9b.globalVar)[0, $lLIS3.PFF_GLOBAL_KEY]) === null || _globalVar$PFF_GLOBAL === void 0 ? void 0 : _globalVar$PFF_GLOBAL.booleanResolver) === undefined || ((_globalVar$PFF_GLOBAL2 = (0, $e2P9b.globalVar)[0, $lLIS3.PFF_GLOBAL_KEY]) === null || _globalVar$PFF_GLOBAL2 === void 0 ? void 0 : _globalVar$PFF_GLOBAL2.booleanResolver) === null) // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
        return (0, $34h0K.default).checkGate(flagKey);
        var result = (_globalVar$PFF_GLOBAL3 = (0, $e2P9b.globalVar)[0, $lLIS3.PFF_GLOBAL_KEY]) === null || _globalVar$PFF_GLOBAL3 === void 0 ? void 0 : _globalVar$PFF_GLOBAL3.booleanResolver(flagKey);
        if (typeof result !== 'boolean') {
            // eslint-disable-next-line no-console
            console.warn("".concat(flagKey, " resolved to a non-boolean value, returning false for safety"));
            return false;
        }
        return result;
    } catch (e) {
        return false;
    }
}

});
parcelRegister("34h0K", function(module, exports) {
$parcel$export(module.exports, "default", () => $23bef0dafa61fe97$export$2e2bcd8739ae039);

var $fQbYu = parcelRequire("fQbYu");

var $cHYPm = parcelRequire("cHYPm");

var $dyTr7 = parcelRequire("dyTr7");

var $3BZ2Q = parcelRequire("3BZ2Q");

var $6WhoI = parcelRequire("6WhoI");



var $23bef0dafa61fe97$var$_FeatureGates;
/**
 * Access the FeatureGates object via the default export.
 * ```ts
 * import FeatureGates from '@atlaskit/feature-gate-js-client';
 * ```
 */ var $23bef0dafa61fe97$var$FeatureGates = /*#__PURE__*/ function() {
    function FeatureGates() {
        (0, $fQbYu.default)(this, FeatureGates);
    }
    return (0, $cHYPm.default)(FeatureGates, null, [
        {
            key: "isGateExists",
            value: function isGateExists(gateName) {
                return this.client.isGateExist(gateName);
            }
        },
        {
            key: "isExperimentExists",
            value: function isExperimentExists(experimentName) {
                return this.client.isExperimentExist(experimentName);
            }
        }
    ]);
}();
$23bef0dafa61fe97$var$_FeatureGates = $23bef0dafa61fe97$var$FeatureGates;
(0, $dyTr7.default)($23bef0dafa61fe97$var$FeatureGates, "client", new (0, $3BZ2Q.Client)());
(0, $dyTr7.default)($23bef0dafa61fe97$var$FeatureGates, "hasCheckGateErrorOccurred", false);
(0, $dyTr7.default)($23bef0dafa61fe97$var$FeatureGates, "hasGetExperimentValueErrorOccurred", false);
(0, $dyTr7.default)($23bef0dafa61fe97$var$FeatureGates, "checkGate", function(gateName, options) {
    try {
        // Check if the CRITERION override mechanism is available
        if (typeof window !== 'undefined' && window.__CRITERION__ && typeof window.__CRITERION__.getFeatureFlagOverride === 'function') {
            // Attempt to retrieve an override value for the feature gate
            var overrideValue = window.__CRITERION__.getFeatureFlagOverride(gateName);
            // If an override value is found, return it immediately
            if (overrideValue !== undefined) return overrideValue;
        }
    } catch (error) {
        // Log the first occurrence of the error
        if (!$23bef0dafa61fe97$var$_FeatureGates.hasCheckGateErrorOccurred) {
            // eslint-disable-next-line no-console
            console.warn({
                msg: 'An error has occurred checking the feature gate from criterion override. Only the first occurrence of this error is logged.',
                gateName: gateName,
                error: error
            });
            $23bef0dafa61fe97$var$_FeatureGates.hasCheckGateErrorOccurred = true;
        }
    }
    // Proceed with the main logic if no override is found
    return $23bef0dafa61fe97$var$_FeatureGates.client.checkGate(gateName, options);
});
(0, $dyTr7.default)($23bef0dafa61fe97$var$FeatureGates, "getExperimentValue", function(experimentName, parameterName, defaultValue, options) {
    try {
        // Check if the CRITERION override mechanism is available
        if (typeof window !== 'undefined' && window.__CRITERION__ && typeof window.__CRITERION__.getExperimentValueOverride === 'function') {
            var overrideValue = window.__CRITERION__.getExperimentValueOverride(experimentName, parameterName);
            if (overrideValue !== undefined && overrideValue !== null) return overrideValue;
        }
    } catch (error) {
        // Log the first occurrence of the error
        if (!$23bef0dafa61fe97$var$_FeatureGates.hasGetExperimentValueErrorOccurred) {
            // eslint-disable-next-line no-console
            console.warn({
                msg: 'An error has occurred getting the experiment value from criterion override. Only the first occurrence of this error is logged.',
                experimentName: experimentName,
                defaultValue: defaultValue,
                options: options,
                error: error
            });
            $23bef0dafa61fe97$var$_FeatureGates.hasGetExperimentValueErrorOccurred = true;
        }
        return defaultValue;
    }
    // Proceed with the main logic if no override is found
    return $23bef0dafa61fe97$var$_FeatureGates.client.getExperimentValue(experimentName, parameterName, defaultValue, options);
});
(0, $dyTr7.default)($23bef0dafa61fe97$var$FeatureGates, "initializeCalled", $23bef0dafa61fe97$var$_FeatureGates.client.initializeCalled.bind($23bef0dafa61fe97$var$_FeatureGates.client));
(0, $dyTr7.default)($23bef0dafa61fe97$var$FeatureGates, "initializeCompleted", $23bef0dafa61fe97$var$_FeatureGates.client.initializeCompleted.bind($23bef0dafa61fe97$var$_FeatureGates.client));
(0, $dyTr7.default)($23bef0dafa61fe97$var$FeatureGates, "waitUntilInitializeCompleted", $23bef0dafa61fe97$var$_FeatureGates.client.waitUntilInitializeCompleted.bind($23bef0dafa61fe97$var$_FeatureGates.client));
(0, $dyTr7.default)($23bef0dafa61fe97$var$FeatureGates, "initialize", $23bef0dafa61fe97$var$_FeatureGates.client.initialize.bind($23bef0dafa61fe97$var$_FeatureGates.client));
(0, $dyTr7.default)($23bef0dafa61fe97$var$FeatureGates, "initializeWithProvider", $23bef0dafa61fe97$var$_FeatureGates.client.initializeWithProvider.bind($23bef0dafa61fe97$var$_FeatureGates.client));
(0, $dyTr7.default)($23bef0dafa61fe97$var$FeatureGates, "initializeFromValues", $23bef0dafa61fe97$var$_FeatureGates.client.initializeFromValues.bind($23bef0dafa61fe97$var$_FeatureGates.client));
(0, $dyTr7.default)($23bef0dafa61fe97$var$FeatureGates, "manuallyLogGateExposure", $23bef0dafa61fe97$var$_FeatureGates.client.manuallyLogGateExposure.bind($23bef0dafa61fe97$var$_FeatureGates.client));
(0, $dyTr7.default)($23bef0dafa61fe97$var$FeatureGates, "getExperiment", $23bef0dafa61fe97$var$_FeatureGates.client.getExperiment.bind($23bef0dafa61fe97$var$_FeatureGates.client));
(0, $dyTr7.default)($23bef0dafa61fe97$var$FeatureGates, "manuallyLogExperimentExposure", $23bef0dafa61fe97$var$_FeatureGates.client.manuallyLogExperimentExposure.bind($23bef0dafa61fe97$var$_FeatureGates.client));
(0, $dyTr7.default)($23bef0dafa61fe97$var$FeatureGates, "manuallyLogLayerExposure", $23bef0dafa61fe97$var$_FeatureGates.client.manuallyLogLayerExposure.bind($23bef0dafa61fe97$var$_FeatureGates.client));
(0, $dyTr7.default)($23bef0dafa61fe97$var$FeatureGates, "shutdownStatsig", $23bef0dafa61fe97$var$_FeatureGates.client.shutdownStatsig.bind($23bef0dafa61fe97$var$_FeatureGates.client));
(0, $dyTr7.default)($23bef0dafa61fe97$var$FeatureGates, "overrideGate", $23bef0dafa61fe97$var$_FeatureGates.client.overrideGate.bind($23bef0dafa61fe97$var$_FeatureGates.client));
(0, $dyTr7.default)($23bef0dafa61fe97$var$FeatureGates, "clearGateOverride", $23bef0dafa61fe97$var$_FeatureGates.client.clearGateOverride.bind($23bef0dafa61fe97$var$_FeatureGates.client));
(0, $dyTr7.default)($23bef0dafa61fe97$var$FeatureGates, "overrideConfig", $23bef0dafa61fe97$var$_FeatureGates.client.overrideConfig.bind($23bef0dafa61fe97$var$_FeatureGates.client));
(0, $dyTr7.default)($23bef0dafa61fe97$var$FeatureGates, "clearConfigOverride", $23bef0dafa61fe97$var$_FeatureGates.client.clearConfigOverride.bind($23bef0dafa61fe97$var$_FeatureGates.client));
(0, $dyTr7.default)($23bef0dafa61fe97$var$FeatureGates, "setOverrides", $23bef0dafa61fe97$var$_FeatureGates.client.setOverrides.bind($23bef0dafa61fe97$var$_FeatureGates.client));
(0, $dyTr7.default)($23bef0dafa61fe97$var$FeatureGates, "getOverrides", $23bef0dafa61fe97$var$_FeatureGates.client.getOverrides.bind($23bef0dafa61fe97$var$_FeatureGates.client));
(0, $dyTr7.default)($23bef0dafa61fe97$var$FeatureGates, "clearAllOverrides", $23bef0dafa61fe97$var$_FeatureGates.client.clearAllOverrides.bind($23bef0dafa61fe97$var$_FeatureGates.client));
(0, $dyTr7.default)($23bef0dafa61fe97$var$FeatureGates, "isCurrentUser", $23bef0dafa61fe97$var$_FeatureGates.client.isCurrentUser.bind($23bef0dafa61fe97$var$_FeatureGates.client));
(0, $dyTr7.default)($23bef0dafa61fe97$var$FeatureGates, "onGateUpdated", $23bef0dafa61fe97$var$_FeatureGates.client.onGateUpdated.bind($23bef0dafa61fe97$var$_FeatureGates.client));
(0, $dyTr7.default)($23bef0dafa61fe97$var$FeatureGates, "onExperimentValueUpdated", $23bef0dafa61fe97$var$_FeatureGates.client.onExperimentValueUpdated.bind($23bef0dafa61fe97$var$_FeatureGates.client));
(0, $dyTr7.default)($23bef0dafa61fe97$var$FeatureGates, "onAnyUpdated", $23bef0dafa61fe97$var$_FeatureGates.client.onAnyUpdated.bind($23bef0dafa61fe97$var$_FeatureGates.client));
(0, $dyTr7.default)($23bef0dafa61fe97$var$FeatureGates, "updateUser", $23bef0dafa61fe97$var$_FeatureGates.client.updateUser.bind($23bef0dafa61fe97$var$_FeatureGates.client));
(0, $dyTr7.default)($23bef0dafa61fe97$var$FeatureGates, "updateUserWithProvider", $23bef0dafa61fe97$var$_FeatureGates.client.updateUserWithProvider.bind($23bef0dafa61fe97$var$_FeatureGates.client));
(0, $dyTr7.default)($23bef0dafa61fe97$var$FeatureGates, "updateUserWithValues", $23bef0dafa61fe97$var$_FeatureGates.client.updateUserWithValues.bind($23bef0dafa61fe97$var$_FeatureGates.client));
(0, $dyTr7.default)($23bef0dafa61fe97$var$FeatureGates, "getPackageVersion", $23bef0dafa61fe97$var$_FeatureGates.client.getPackageVersion.bind($23bef0dafa61fe97$var$_FeatureGates.client));
(0, $dyTr7.default)($23bef0dafa61fe97$var$FeatureGates, "getTargetApp", $23bef0dafa61fe97$var$_FeatureGates.client.getTargetApp.bind($23bef0dafa61fe97$var$_FeatureGates.client));
(0, $dyTr7.default)($23bef0dafa61fe97$var$FeatureGates, "getLayer", $23bef0dafa61fe97$var$_FeatureGates.client.getLayer.bind($23bef0dafa61fe97$var$_FeatureGates.client));
(0, $dyTr7.default)($23bef0dafa61fe97$var$FeatureGates, "getLayerValue", $23bef0dafa61fe97$var$_FeatureGates.client.getLayerValue.bind($23bef0dafa61fe97$var$_FeatureGates.client));
var $23bef0dafa61fe97$var$boundFGJS = $23bef0dafa61fe97$var$FeatureGates;
// This makes it possible to get a reference to the FeatureGates client at runtime.
// This is important for overriding values in Cypress tests, as there needs to be a
// way to get the exact instance for a window in order to mock some of its methods.
if (typeof window !== 'undefined') {
    if (window.__FEATUREGATES_JS__ === undefined) window.__FEATUREGATES_JS__ = $23bef0dafa61fe97$var$FeatureGates;
    else {
        var $23bef0dafa61fe97$var$_boundFGJS, $23bef0dafa61fe97$var$_boundFGJS$getPackage;
        $23bef0dafa61fe97$var$boundFGJS = window.__FEATUREGATES_JS__;
        var $23bef0dafa61fe97$var$boundVersion = (($23bef0dafa61fe97$var$_boundFGJS = $23bef0dafa61fe97$var$boundFGJS) === null || $23bef0dafa61fe97$var$_boundFGJS === void 0 || ($23bef0dafa61fe97$var$_boundFGJS$getPackage = $23bef0dafa61fe97$var$_boundFGJS.getPackageVersion) === null || $23bef0dafa61fe97$var$_boundFGJS$getPackage === void 0 ? void 0 : $23bef0dafa61fe97$var$_boundFGJS$getPackage.call($23bef0dafa61fe97$var$_boundFGJS)) || '4.10.0 or earlier';
        if ($23bef0dafa61fe97$var$boundVersion !== (0, $6WhoI.CLIENT_VERSION)) {
            var $23bef0dafa61fe97$var$message = "Multiple versions of FeatureGateClients found on the current page.\n      The currently bound version is ".concat($23bef0dafa61fe97$var$boundVersion, " when module version ").concat((0, $6WhoI.CLIENT_VERSION), " was loading.");
            // eslint-disable-next-line no-console
            console.warn($23bef0dafa61fe97$var$message);
        }
    }
}
var /**
 * @property {FeatureGates} FeatureGate default export
 */ $23bef0dafa61fe97$export$2e2bcd8739ae039 = $23bef0dafa61fe97$var$boundFGJS;

});
parcelRegister("fQbYu", function(module, exports) {
$parcel$export(module.exports, "default", () => $b885004328563353$export$2e2bcd8739ae039);
function $b885004328563353$export$2e2bcd8739ae039(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}

});

parcelRegister("cHYPm", function(module, exports) {
$parcel$export(module.exports, "default", () => $9408af3a6b4b85dc$export$2e2bcd8739ae039);

var $bkn3Y = parcelRequire("bkn3Y");
function $9408af3a6b4b85dc$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, (0, $bkn3Y.default)(o.key), o);
    }
}
function $9408af3a6b4b85dc$export$2e2bcd8739ae039(e, r, t) {
    return r && $9408af3a6b4b85dc$var$_defineProperties(e.prototype, r), t && $9408af3a6b4b85dc$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}

});
parcelRegister("bkn3Y", function(module, exports) {
$parcel$export(module.exports, "default", () => $83f373d10c0be2ae$export$2e2bcd8739ae039);

var $hs8hh = parcelRequire("hs8hh");

var $5Lz9t = parcelRequire("5Lz9t");
function $83f373d10c0be2ae$export$2e2bcd8739ae039(t) {
    var i = (0, $5Lz9t.default)(t, "string");
    return "symbol" == (0, $hs8hh.default)(i) ? i : i + "";
}

});
parcelRegister("hs8hh", function(module, exports) {
$parcel$export(module.exports, "default", () => $cb4b78f9b6318ccb$export$2e2bcd8739ae039);
function $cb4b78f9b6318ccb$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $cb4b78f9b6318ccb$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $cb4b78f9b6318ccb$export$2e2bcd8739ae039(o);
}

});

parcelRegister("5Lz9t", function(module, exports) {
$parcel$export(module.exports, "default", () => $432c9bfa35c0e2fe$export$2e2bcd8739ae039);

var $hs8hh = parcelRequire("hs8hh");
function $432c9bfa35c0e2fe$export$2e2bcd8739ae039(t, r) {
    if ("object" != (0, $hs8hh.default)(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (0, $hs8hh.default)(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}

});



parcelRegister("dyTr7", function(module, exports) {
$parcel$export(module.exports, "default", () => $9df973ddefc62fec$export$2e2bcd8739ae039);

var $bkn3Y = parcelRequire("bkn3Y");
function $9df973ddefc62fec$export$2e2bcd8739ae039(e, r, t) {
    return (r = (0, $bkn3Y.default)(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}

});

parcelRegister("3BZ2Q", function(module, exports) {
$parcel$export(module.exports, "Client", () => $2a142e07fdcca311$export$1f2bb630327ac4b6);

var $b8P2v = parcelRequire("b8P2v");

var $94GB8 = parcelRequire("94GB8");

var $jt440 = parcelRequire("jt440");

var $fQbYu = parcelRequire("fQbYu");

var $cHYPm = parcelRequire("cHYPm");

var $dyTr7 = parcelRequire("dyTr7");

var $1KMt7 = parcelRequire("1KMt7");

var $iFR7a = parcelRequire("iFR7a");

var $kJAvC = parcelRequire("kJAvC");

var $bA77O = parcelRequire("bA77O");

var $gFo6M = parcelRequire("gFo6M");

var $icCTV = parcelRequire("icCTV");

var $f9px2 = parcelRequire("f9px2");

var $5MYIV = parcelRequire("5MYIV");

var $80LFe = parcelRequire("80LFe");

var $cXGvu = parcelRequire("cXGvu");

var $jGAYn = parcelRequire("jGAYn");

var $6WhoI = parcelRequire("6WhoI");
var $2a142e07fdcca311$var$_excluded = [
    "sdkKey",
    "environment",
    "updateUserCompletionCallback",
    "perimeter"
];
function $2a142e07fdcca311$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $2a142e07fdcca311$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $2a142e07fdcca311$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $dyTr7.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $2a142e07fdcca311$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $2a142e07fdcca311$var$DEFAULT_CLIENT_KEY = 'client-default-key';
// default event logging api is Atlassian proxy rather than Statsig's domain, to avoid ad blockers
var $2a142e07fdcca311$var$DEFAULT_EVENT_LOGGING_API = 'https://xp.atlassian.com/v1/rgstr';
var $2a142e07fdcca311$export$1f2bb630327ac4b6 = /*#__PURE__*/ function() {
    function Client() {
        var _this = this;
        var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, _ref$localStorageKey = _ref.localStorageKey, localStorageKey = _ref$localStorageKey === void 0 ? (0, $80LFe.LOCAL_STORAGE_KEY) : _ref$localStorageKey, overrideAdapter = _ref.overrideAdapter;
        (0, $fQbYu.default)(this, Client);
        (0, $dyTr7.default)(this, "initPromise", null);
        /** True if an initialize method was called and completed successfully. */ (0, $dyTr7.default)(this, "initCompleted", false);
        /**
     * True if an initialize method was called and completed, meaning the client is now usable.
     * However if there was an error during initialization it may have initialized with default
     * values. Use {@link initCompleted} to check for this.
     */ (0, $dyTr7.default)(this, "initWithDefaults", false);
        (0, $dyTr7.default)(this, "hasCheckGateErrorOccurred", false);
        (0, $dyTr7.default)(this, "hasGetExperimentErrorOccurred", false);
        (0, $dyTr7.default)(this, "hasGetExperimentValueErrorOccurred", false);
        (0, $dyTr7.default)(this, "hasGetLayerErrorOccurred", false);
        (0, $dyTr7.default)(this, "hasGetLayerValueErrorOccurred", false);
        (0, $dyTr7.default)(this, "subscriptions", new (0, $kJAvC.default)());
        (0, $dyTr7.default)(this, "dataAdapter", new (0, $5MYIV.NoFetchDataAdapter)());
        /**
     * Call this if modifying the values being served by the Statsig library since it has its own
     * memoization cache which will not be updated if the values are changed outside of the library.
     */ (0, $dyTr7.default)(this, "statsigValuesUpdated", function() {
            if (_this.user) // Trigger a reset of the memoize cache
            _this.statsigClient.updateUserSync(_this.user, {
                disableBackgroundCacheRefresh: true
            });
            _this.subscriptions.anyUpdated();
        });
        this.overrideAdapter = overrideAdapter || new (0, $80LFe.PersistentOverrideAdapter)(localStorageKey);
    }
    /**
   * @description
   * This method initializes the client using a network call to fetch the bootstrap values.
   * If the client is inialized with an `analyticsWebClient`, it will send an operational event
   * to GASv3 with the following attributes:
   * - targetApp: the target app of the client
   * - clientVersion: the version of the client
   * - success: whether the initialization was successful
   * - startTime: the time when the initialization started
   * - totalTime: the total time it took to initialize the client
   * - apiKey: the api key used to initialize the client
   * @param clientOptions {ClientOptions}
   * @param identifiers {Identifiers}
   * @param customAttributes {CustomAttributes}
   * @returns {Promise<void>}
   */ return (0, $cHYPm.default)(Client, [
        {
            key: "initialize",
            value: function() {
                var _initialize = (0, $jt440.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1KMt7))).mark(function _callee(clientOptions, identifiers, customAttributes) {
                    var _this2 = this;
                    var clientOptionsWithDefaults, startTime;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($1KMt7))).wrap(function(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                clientOptionsWithDefaults = (0, $jGAYn.getOptionsWithDefaults)(clientOptions);
                                if (!this.initPromise) {
                                    _context.next = 1;
                                    break;
                                }
                                if (!(0, $jGAYn.shallowEquals)(clientOptionsWithDefaults, this.initOptions)) // eslint-disable-next-line no-console
                                console.warn('Feature Gates client already initialized with different options. New options were not applied.');
                                return _context.abrupt("return", this.initPromise);
                            case 1:
                                startTime = performance.now();
                                this.initOptions = clientOptionsWithDefaults;
                                this.initPromise = this.init(clientOptionsWithDefaults, identifiers, customAttributes).then(function() {
                                    _this2.initCompleted = true;
                                    _this2.initWithDefaults = true;
                                }).finally(function() {
                                    var endTime = performance.now();
                                    var totalTime = endTime - startTime;
                                    _this2.fireClientEvent(startTime, totalTime, 'initialize', _this2.initCompleted, clientOptionsWithDefaults.apiKey);
                                });
                                return _context.abrupt("return", this.initPromise);
                            case 2:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee, this);
                }));
                function initialize(_x, _x2, _x3) {
                    return _initialize.apply(this, arguments);
                }
                return initialize;
            }()
        },
        {
            key: "initializeWithProvider",
            value: function() {
                var _initializeWithProvider = (0, $jt440.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1KMt7))).mark(function _callee2(clientOptions, provider, identifiers, customAttributes) {
                    var _this3 = this;
                    var clientOptionsWithDefaults, startTime;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($1KMt7))).wrap(function(_context2) {
                        while(true)switch(_context2.prev = _context2.next){
                            case 0:
                                clientOptionsWithDefaults = (0, $jGAYn.getOptionsWithDefaults)(clientOptions);
                                if (!this.initPromise) {
                                    _context2.next = 1;
                                    break;
                                }
                                if (!(0, $jGAYn.shallowEquals)(clientOptionsWithDefaults, this.initOptions)) // eslint-disable-next-line no-console
                                console.warn('Feature Gates client already initialized with different options. New options were not applied.');
                                return _context2.abrupt("return", this.initPromise);
                            case 1:
                                startTime = performance.now();
                                this.initOptions = clientOptionsWithDefaults;
                                this.provider = provider;
                                this.provider.setClientVersion((0, $6WhoI.CLIENT_VERSION));
                                if (this.provider.setApplyUpdateCallback) this.provider.setApplyUpdateCallback(this.applyUpdateCallback.bind(this));
                                this.initPromise = this.initWithProvider(clientOptionsWithDefaults, provider, identifiers, customAttributes).then(function() {
                                    _this3.initCompleted = true;
                                    _this3.initWithDefaults = true;
                                }).finally(function() {
                                    var endTime = performance.now();
                                    var totalTime = endTime - startTime;
                                    _this3.fireClientEvent(startTime, totalTime, 'initializeWithProvider', _this3.initCompleted, provider.getApiKey ? provider.getApiKey() : undefined);
                                });
                                return _context2.abrupt("return", this.initPromise);
                            case 2:
                            case "end":
                                return _context2.stop();
                        }
                    }, _callee2, this);
                }));
                function initializeWithProvider(_x4, _x5, _x6, _x7) {
                    return _initializeWithProvider.apply(this, arguments);
                }
                return initializeWithProvider;
            }()
        },
        {
            key: "applyUpdateCallback",
            value: function applyUpdateCallback(experimentsResult) {
                try {
                    if (this.initCompleted || this.initWithDefaults) {
                        this.assertInitialized(this.statsigClient);
                        this.dataAdapter.setBootstrapData(experimentsResult.experimentValues);
                        this.dataAdapter.setData(JSON.stringify(experimentsResult.experimentValues));
                        this.statsigValuesUpdated();
                    }
                } catch (error) {
                    // eslint-disable-next-line no-console
                    console.warn('Error when attempting to apply update', error);
                }
            }
        },
        {
            key: "fireClientEvent",
            value: function fireClientEvent(startTime, totalTime, action, success) {
                var _analyticsWebClient, _this4 = this;
                var apiKey = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;
                (_analyticsWebClient = this.initOptions.analyticsWebClient) === null || _analyticsWebClient === void 0 || _analyticsWebClient.then(function(analyticsWebClient) {
                    var attributes = $2a142e07fdcca311$var$_objectSpread({
                        targetApp: _this4.initOptions.targetApp,
                        clientVersion: (0, $6WhoI.CLIENT_VERSION),
                        success: success,
                        startTime: startTime,
                        totalTime: totalTime
                    }, apiKey && {
                        apiKey: apiKey
                    });
                    analyticsWebClient.sendOperationalEvent({
                        action: action,
                        actionSubject: 'featureGatesClient',
                        attributes: attributes,
                        tags: [
                            'measurement'
                        ],
                        source: '@atlaskit/feature-gate-js-client'
                    });
                }).catch(function(err) {
                    if (_this4.initOptions.environment !== (0, $cXGvu.FeatureGateEnvironment).Production) // eslint-disable-next-line no-console
                    console.error('Analytics web client promise did not resolve', err);
                });
            }
        },
        {
            key: "initializeFromValues",
            value: function() {
                var _initializeFromValues = (0, $jt440.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1KMt7))).mark(function _callee3(clientOptions, identifiers, customAttributes) {
                    var _this5 = this;
                    var initializeValues, clientOptionsWithDefaults, startTime, _args3 = arguments;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($1KMt7))).wrap(function(_context3) {
                        while(true)switch(_context3.prev = _context3.next){
                            case 0:
                                initializeValues = _args3.length > 3 && _args3[3] !== undefined ? _args3[3] : {};
                                clientOptionsWithDefaults = (0, $jGAYn.getOptionsWithDefaults)(clientOptions);
                                if (!this.initPromise) {
                                    _context3.next = 1;
                                    break;
                                }
                                if (!(0, $jGAYn.shallowEquals)(clientOptionsWithDefaults, this.initOptions)) // eslint-disable-next-line no-console
                                console.warn('Feature Gates client already initialized with different options. New options were not applied.');
                                return _context3.abrupt("return", this.initPromise);
                            case 1:
                                // This makes sure the new Statsig client behaves like the old when bootstrap data is
                                // passed, and `has_updates` isn't specified (which happens a lot in product integration tests).
                                if (!Object.prototype.hasOwnProperty.call(initializeValues, 'has_updates')) initializeValues['has_updates'] = true;
                                startTime = performance.now();
                                this.initOptions = clientOptionsWithDefaults;
                                this.initPromise = this.initFromValues(clientOptionsWithDefaults, identifiers, customAttributes, initializeValues).then(function() {
                                    _this5.initCompleted = true;
                                    _this5.initWithDefaults = true;
                                }).finally(function() {
                                    var endTime = performance.now();
                                    var totalTime = endTime - startTime;
                                    _this5.fireClientEvent(startTime, totalTime, 'initializeFromValues', _this5.initCompleted);
                                });
                                return _context3.abrupt("return", this.initPromise);
                            case 2:
                            case "end":
                                return _context3.stop();
                        }
                    }, _callee3, this);
                }));
                function initializeFromValues(_x8, _x9, _x0) {
                    return _initializeFromValues.apply(this, arguments);
                }
                return initializeFromValues;
            }()
        },
        {
            key: "assertInitialized",
            value: function assertInitialized(statsigClient) {
                if (!statsigClient) throw new Error('Client must be initialized before using this method');
            }
        },
        {
            key: "updateUser",
            value: function() {
                var _updateUser = (0, $jt440.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1KMt7))).mark(function _callee4(fetchOptions, identifiers, customAttributes) {
                    var fetchOptionsWithDefaults, initializeValuesProducer;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($1KMt7))).wrap(function(_context4) {
                        while(true)switch(_context4.prev = _context4.next){
                            case 0:
                                this.assertInitialized(this.statsigClient);
                                fetchOptionsWithDefaults = (0, $jGAYn.getOptionsWithDefaults)(fetchOptions);
                                initializeValuesProducer = function initializeValuesProducer() {
                                    return (0, $f9px2.default).fetchExperimentValues(fetchOptionsWithDefaults, identifiers, customAttributes).then(function(_ref2) {
                                        var experimentValues = _ref2.experimentValues, customAttributes = _ref2.customAttributes;
                                        return {
                                            experimentValues: experimentValues,
                                            customAttributesFromFetch: customAttributes
                                        };
                                    });
                                };
                                _context4.next = 1;
                                return this.updateUserUsingInitializeValuesProducer(initializeValuesProducer, identifiers, customAttributes);
                            case 1:
                            case "end":
                                return _context4.stop();
                        }
                    }, _callee4, this);
                }));
                function updateUser(_x1, _x10, _x11) {
                    return _updateUser.apply(this, arguments);
                }
                return updateUser;
            }()
        },
        {
            key: "updateUserWithProvider",
            value: function() {
                var _updateUserWithProvider = (0, $jt440.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1KMt7))).mark(function _callee5(identifiers, customAttributes) {
                    var _this6 = this;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($1KMt7))).wrap(function(_context5) {
                        while(true)switch(_context5.prev = _context5.next){
                            case 0:
                                this.assertInitialized(this.statsigClient);
                                if (this.provider) {
                                    _context5.next = 1;
                                    break;
                                }
                                throw new Error('Cannot update user using provider as the client was not initialised with a provider');
                            case 1:
                                _context5.next = 2;
                                return this.provider.setProfile(this.initOptions, identifiers, customAttributes);
                            case 2:
                                _context5.next = 3;
                                return this.updateUserUsingInitializeValuesProducer(function() {
                                    return _this6.provider.getExperimentValues();
                                }, identifiers, customAttributes);
                            case 3:
                            case "end":
                                return _context5.stop();
                        }
                    }, _callee5, this);
                }));
                function updateUserWithProvider(_x12, _x13) {
                    return _updateUserWithProvider.apply(this, arguments);
                }
                return updateUserWithProvider;
            }()
        },
        {
            key: "updateUserWithValues",
            value: function() {
                var _updateUserWithValues = (0, $jt440.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1KMt7))).mark(function _callee6(identifiers, customAttributes) {
                    var initializeValues, initializeValuesProducer, _args6 = arguments;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($1KMt7))).wrap(function(_context6) {
                        while(true)switch(_context6.prev = _context6.next){
                            case 0:
                                initializeValues = _args6.length > 2 && _args6[2] !== undefined ? _args6[2] : {};
                                this.assertInitialized(this.statsigClient);
                                initializeValuesProducer = function initializeValuesProducer() {
                                    return Promise.resolve({
                                        experimentValues: initializeValues,
                                        customAttributesFromFetch: customAttributes
                                    });
                                };
                                _context6.next = 1;
                                return this.updateUserUsingInitializeValuesProducer(initializeValuesProducer, identifiers, customAttributes);
                            case 1:
                            case "end":
                                return _context6.stop();
                        }
                    }, _callee6, this);
                }));
                function updateUserWithValues(_x14, _x15) {
                    return _updateUserWithValues.apply(this, arguments);
                }
                return updateUserWithValues;
            }()
        },
        {
            key: "initializeCalled",
            value: function initializeCalled() {
                return this.initPromise != null;
            }
        },
        {
            key: "initializeCompleted",
            value: function initializeCompleted() {
                return this.initCompleted;
            }
        },
        {
            key: "waitUntilInitializeCompleted",
            value: function() {
                var _waitUntilInitializeCompleted = (0, $jt440.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1KMt7))).mark(function _callee7() {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($1KMt7))).wrap(function(_context7) {
                        while(true)switch(_context7.prev = _context7.next){
                            case 0:
                                if (this.initPromise) {
                                    _context7.next = 1;
                                    break;
                                }
                                throw new Error('The client must be initialized before you can wait until initialized.');
                            case 1:
                                if (!this.initCompleted) {
                                    _context7.next = 2;
                                    break;
                                }
                                return _context7.abrupt("return");
                            case 2:
                                _context7.next = 3;
                                return this.initPromise;
                            case 3:
                            case "end":
                                return _context7.stop();
                        }
                    }, _callee7, this);
                }));
                function waitUntilInitializeCompleted() {
                    return _waitUntilInitializeCompleted.apply(this, arguments);
                }
                return waitUntilInitializeCompleted;
            }()
        },
        {
            key: "checkGate",
            value: function checkGate(gateName) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                try {
                    this.assertInitialized(this.statsigClient);
                    var _options$fireGateExpo = options.fireGateExposure, fireGateExposure = _options$fireGateExpo === void 0 ? true : _options$fireGateExpo;
                    return this.statsigClient.checkGate(gateName, {
                        disableExposureLog: !fireGateExposure
                    });
                } catch (error) {
                    // Log the first occurrence of the error
                    if (!this.hasCheckGateErrorOccurred) {
                        // eslint-disable-next-line no-console
                        console.warn({
                            msg: 'An error has occurred checking the feature gate. Only the first occurrence of this error is logged.',
                            gateName: gateName,
                            error: error
                        });
                        this.hasCheckGateErrorOccurred = true;
                    }
                    return false;
                }
            }
        },
        {
            key: "isGateExist",
            value: function isGateExist(gateName) {
                try {
                    this.assertInitialized(this.statsigClient);
                    var gate = this.statsigClient.getFeatureGate(gateName, {
                        disableExposureLog: true
                    });
                    return !gate.details.reason.includes('Unrecognized');
                } catch (error) {
                    // eslint-disable-next-line no-console
                    console.error("Error occurred when trying to check FeatureGate: ".concat(error));
                    // in case of error report true to avoid false positives.
                    return true;
                }
            }
        },
        {
            key: "isExperimentExist",
            value: function isExperimentExist(experimentName) {
                try {
                    this.assertInitialized(this.statsigClient);
                    var config = this.statsigClient.getExperiment(experimentName, {
                        disableExposureLog: true
                    });
                    return !config.details.reason.includes('Unrecognized');
                } catch (error) {
                    // eslint-disable-next-line no-console
                    console.error("Error occurred when trying to check Experiment: ".concat(error));
                    // in case of error report true to avoid false positives.
                    return true;
                }
            }
        },
        {
            key: "manuallyLogGateExposure",
            value: function manuallyLogGateExposure(gateName) {
                this.assertInitialized(this.statsigClient);
                // This is the approach recommended in the docs
                // https://docs.statsig.com/client/javascript-sdk/#manual-exposures-
                this.statsigClient.checkGate(gateName);
            }
        },
        {
            key: "getExperiment",
            value: function getExperiment(experimentName) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                try {
                    this.assertInitialized(this.statsigClient);
                    var _options$fireExperime = options.fireExperimentExposure, fireExperimentExposure = _options$fireExperime === void 0 ? true : _options$fireExperime;
                    return (0, $bA77O.DynamicConfig).fromExperiment(this.statsigClient.getExperiment(experimentName, {
                        disableExposureLog: !fireExperimentExposure
                    }));
                } catch (error) {
                    // Log the first occurrence of the error
                    if (!this.hasGetExperimentErrorOccurred) {
                        // eslint-disable-next-line no-console
                        console.warn({
                            msg: 'An error has occurred getting the experiment. Only the first occurrence of this error is logged.',
                            experimentName: experimentName,
                            error: error
                        });
                        this.hasGetExperimentErrorOccurred = true;
                    }
                    // Return a default value
                    return new (0, $bA77O.DynamicConfig)(experimentName, {}, '', {
                        time: Date.now(),
                        reason: (0, $icCTV.EvaluationReason).Error
                    });
                }
            }
        },
        {
            key: "getExperimentValue",
            value: function getExperimentValue(experimentName, parameterName, defaultValue) {
                var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var experiment = this.getExperiment(experimentName, options);
                try {
                    var typeGuard = options.typeGuard;
                    return experiment.get(parameterName, defaultValue, typeGuard);
                } catch (error) {
                    // Log the first occurrence of the error
                    if (!this.hasGetExperimentValueErrorOccurred) {
                        // eslint-disable-next-line no-console
                        console.warn({
                            msg: 'An error has occurred getting the experiment value. Only the first occurrence of this error is logged.',
                            experimentName: experimentName,
                            defaultValue: defaultValue,
                            options: options,
                            error: error
                        });
                        this.hasGetExperimentValueErrorOccurred = true;
                    }
                    return defaultValue;
                }
            }
        },
        {
            key: "manuallyLogExperimentExposure",
            value: function manuallyLogExperimentExposure(experimentName) {
                this.assertInitialized(this.statsigClient);
                // This is the approach recommended in the docs
                // https://docs.statsig.com/client/javascript-sdk/#manual-exposures-
                this.statsigClient.getExperiment(experimentName);
            }
        },
        {
            key: "manuallyLogLayerExposure",
            value: function manuallyLogLayerExposure(layerName, parameterName) {
                var _this$statsigClient$g;
                this.assertInitialized(this.statsigClient);
                // This is the approach recommended in the docs
                // https://docs.statsig.com/client/javascript-sdk/#manual-exposures-
                (_this$statsigClient$g = this.statsigClient.getLayer(layerName)) === null || _this$statsigClient$g === void 0 || _this$statsigClient$g.get(parameterName);
            }
        },
        {
            key: "shutdownStatsig",
            value: function shutdownStatsig() {
                this.assertInitialized(this.statsigClient);
                this.statsigClient.shutdown();
            }
        },
        {
            key: "overrideGate",
            value: function overrideGate(gateName, value) {
                this.overrideAdapter.overrideGate(gateName, value);
                // Trigger a reset of the memoized gate value
                if (this.user) {
                    var _this$statsigClient;
                    (_this$statsigClient = this.statsigClient) === null || _this$statsigClient === void 0 || _this$statsigClient.updateUserSync(this.user, {
                        disableBackgroundCacheRefresh: true
                    });
                }
                this.statsigValuesUpdated();
            }
        },
        {
            key: "clearGateOverride",
            value: function clearGateOverride(gateName) {
                this.overrideAdapter.removeGateOverride(gateName);
                this.statsigValuesUpdated();
            }
        },
        {
            key: "overrideConfig",
            value: function overrideConfig(experimentName, values) {
                this.overrideAdapter.overrideDynamicConfig(experimentName, values);
                this.statsigValuesUpdated();
            }
        },
        {
            key: "clearConfigOverride",
            value: function clearConfigOverride(experimentName) {
                this.overrideAdapter.removeDynamicConfigOverride(experimentName);
                this.statsigValuesUpdated();
            }
        },
        {
            key: "setOverrides",
            value: function setOverrides(overrides) {
                this.overrideAdapter.setOverrides(overrides);
                this.statsigValuesUpdated();
            }
        },
        {
            key: "getOverrides",
            value: function getOverrides() {
                return this.overrideAdapter.getOverrides();
            }
        },
        {
            key: "clearAllOverrides",
            value: function clearAllOverrides() {
                this.overrideAdapter.removeAllOverrides();
                this.statsigValuesUpdated();
            }
        },
        {
            key: "isCurrentUser",
            value: function isCurrentUser(identifiers, customAttributes) {
                return (0, $jGAYn.shallowEquals)(this.currentIdentifiers, identifiers) && (0, $jGAYn.shallowEquals)(this.currentAttributes, customAttributes);
            }
        },
        {
            key: "onGateUpdated",
            value: function onGateUpdated(gateName, callback) {
                var _this7 = this;
                var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                var wrapCallback = function wrapCallback(value) {
                    var _options$fireGateExpo2 = options.fireGateExposure, fireGateExposure = _options$fireGateExpo2 === void 0 ? true : _options$fireGateExpo2;
                    if (fireGateExposure) _this7.manuallyLogGateExposure(gateName);
                    try {
                        callback(value);
                    } catch (error) {
                        // eslint-disable-next-line no-console
                        console.warn("Error calling callback for gate ".concat(gateName, " with value ").concat(value), error);
                    }
                };
                return this.subscriptions.onGateUpdated(gateName, wrapCallback, this.checkGate.bind(this), options);
            }
        },
        {
            key: "onExperimentValueUpdated",
            value: function onExperimentValueUpdated(experimentName, parameterName, defaultValue, callback) {
                var _this8 = this;
                var options = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
                var wrapCallback = function wrapCallback(value) {
                    var _options$fireExperime2 = options.fireExperimentExposure, fireExperimentExposure = _options$fireExperime2 === void 0 ? true : _options$fireExperime2;
                    if (fireExperimentExposure) _this8.manuallyLogExperimentExposure(experimentName);
                    try {
                        callback(value);
                    } catch (error) {
                        // eslint-disable-next-line no-console
                        console.warn("Error calling callback for experiment ".concat(experimentName, " with value ").concat(value), error);
                    }
                };
                return this.subscriptions.onExperimentValueUpdated(experimentName, parameterName, defaultValue, wrapCallback, this.getExperimentValue.bind(this), options);
            }
        },
        {
            key: "onAnyUpdated",
            value: function onAnyUpdated(callback) {
                return this.subscriptions.onAnyUpdated(callback);
            }
        },
        {
            key: "init",
            value: function() {
                var _init = (0, $jt440.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1KMt7))).mark(function _callee8(clientOptions, identifiers, customAttributes) {
                    var fromValuesClientOptions, experimentValues, customAttributesFromResult, clientSdkKeyPromise, experimentValuesPromise, _yield$Promise$all, _yield$Promise$all2, experimentValuesResult, _t;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($1KMt7))).wrap(function(_context8) {
                        while(true)switch(_context8.prev = _context8.next){
                            case 0:
                                fromValuesClientOptions = $2a142e07fdcca311$var$_objectSpread({}, clientOptions);
                                if (!clientOptions.localMode) {
                                    _context8.next = 2;
                                    break;
                                }
                                _context8.next = 1;
                                return this.initFromValues(fromValuesClientOptions, identifiers, customAttributes);
                            case 1:
                                return _context8.abrupt("return");
                            case 2:
                                _context8.prev = 2;
                                // If client sdk key fetch fails, an error would be thrown and handled instead of waiting for
                                // the experiment values request to be settled, and it will fall back to use default values.
                                clientSdkKeyPromise = (0, $f9px2.default).fetchClientSdk(clientOptions).then(function(value) {
                                    return fromValuesClientOptions.sdkKey = value.clientSdkKey;
                                });
                                experimentValuesPromise = (0, $f9px2.default).fetchExperimentValues(clientOptions, identifiers, customAttributes); // Only wait for the experiment values request to finish and try to initialise the client
                                // with experiment values if both requests are successful. Else an error would be thrown and
                                // handled by the catch
                                _context8.next = 3;
                                return Promise.all([
                                    clientSdkKeyPromise,
                                    experimentValuesPromise
                                ]);
                            case 3:
                                _yield$Promise$all = _context8.sent;
                                _yield$Promise$all2 = (0, $94GB8.default)(_yield$Promise$all, 2);
                                experimentValuesResult = _yield$Promise$all2[1];
                                experimentValues = experimentValuesResult.experimentValues;
                                customAttributesFromResult = experimentValuesResult.customAttributes;
                                _context8.next = 6;
                                break;
                            case 4:
                                _context8.prev = 4;
                                _t = _context8["catch"](2);
                                if (_t instanceof Error) // eslint-disable-next-line no-console
                                console.error("Error occurred when trying to fetch the Feature Gates client values, error: ".concat(_t === null || _t === void 0 ? void 0 : _t.message));
                                // eslint-disable-next-line no-console
                                console.warn("Initialising Statsig client without values");
                                _context8.next = 5;
                                return this.initFromValues(fromValuesClientOptions, identifiers, customAttributes);
                            case 5:
                                throw _t;
                            case 6:
                                return _context8.abrupt("return", this.initFromValues(fromValuesClientOptions, identifiers, customAttributesFromResult, experimentValues));
                            case 7:
                            case "end":
                                return _context8.stop();
                        }
                    }, _callee8, this, [
                        [
                            2,
                            4
                        ]
                    ]);
                }));
                function init(_x16, _x17, _x18) {
                    return _init.apply(this, arguments);
                }
                return init;
            }()
        },
        {
            key: "initWithProvider",
            value: function() {
                var _initWithProvider = (0, $jt440.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1KMt7))).mark(function _callee9(baseClientOptions, provider, identifiers, customAttributes) {
                    var fromValuesClientOptions, experimentValues, customAttributesFromResult, clientSdkKeyPromise, experimentValuesPromise, _yield$Promise$all3, _yield$Promise$all4, experimentValuesResult, _t2;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($1KMt7))).wrap(function(_context9) {
                        while(true)switch(_context9.prev = _context9.next){
                            case 0:
                                fromValuesClientOptions = $2a142e07fdcca311$var$_objectSpread($2a142e07fdcca311$var$_objectSpread({}, baseClientOptions), {}, {
                                    disableCurrentPageLogging: true
                                });
                                _context9.prev = 1;
                                _context9.next = 2;
                                return provider.setProfile(baseClientOptions, identifiers, customAttributes);
                            case 2:
                                // If client sdk key fetch fails, an error would be thrown and handled instead of waiting for
                                // the experiment values request to be settled, and it will fall back to use default values.
                                clientSdkKeyPromise = provider.getClientSdkKey().then(function(value) {
                                    return fromValuesClientOptions.sdkKey = value;
                                });
                                experimentValuesPromise = provider.getExperimentValues(); // Only wait for the experiment values request to finish and try to initialise the client
                                // with experiment values if both requests are successful. Else an error would be thrown and
                                // handled by the catch
                                _context9.next = 3;
                                return Promise.all([
                                    clientSdkKeyPromise,
                                    experimentValuesPromise
                                ]);
                            case 3:
                                _yield$Promise$all3 = _context9.sent;
                                _yield$Promise$all4 = (0, $94GB8.default)(_yield$Promise$all3, 2);
                                experimentValuesResult = _yield$Promise$all4[1];
                                experimentValues = experimentValuesResult.experimentValues;
                                customAttributesFromResult = experimentValuesResult.customAttributesFromFetch;
                                _context9.next = 6;
                                break;
                            case 4:
                                _context9.prev = 4;
                                _t2 = _context9["catch"](1);
                                if (_t2 instanceof Error) // eslint-disable-next-line no-console
                                console.error("Error occurred when trying to fetch the Feature Gates client values, error: ".concat(_t2 === null || _t2 === void 0 ? void 0 : _t2.message));
                                // eslint-disable-next-line no-console
                                console.warn("Initialising Statsig client without values");
                                _context9.next = 5;
                                return this.initFromValues(fromValuesClientOptions, identifiers, customAttributes);
                            case 5:
                                throw _t2;
                            case 6:
                                return _context9.abrupt("return", this.initFromValues(fromValuesClientOptions, identifiers, customAttributesFromResult, experimentValues));
                            case 7:
                            case "end":
                                return _context9.stop();
                        }
                    }, _callee9, this, [
                        [
                            1,
                            4
                        ]
                    ]);
                }));
                function initWithProvider(_x19, _x20, _x21, _x22) {
                    return _initWithProvider.apply(this, arguments);
                }
                return initWithProvider;
            }()
        },
        {
            key: "initFromValues",
            value: function() {
                var _initFromValues = (0, $jt440.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1KMt7))).mark(function _callee0(clientOptions, identifiers, customAttributes) {
                    var _newClientOptions$net;
                    var initializeValues, newClientOptions, sdkKey, environment, _updateUserCompletionCallback, _perimeter, restClientOptions, frontendUser, statsigOptions, _args0 = arguments, _t3;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($1KMt7))).wrap(function(_context0) {
                        while(true)switch(_context0.prev = _context0.next){
                            case 0:
                                initializeValues = _args0.length > 3 && _args0[3] !== undefined ? _args0[3] : {};
                                this.overrideAdapter.initFromStoredOverrides();
                                this.currentIdentifiers = identifiers;
                                this.currentAttributes = customAttributes;
                                newClientOptions = (0, $jGAYn.migrateInitializationOptions)(clientOptions);
                                if (!newClientOptions.sdkKey) newClientOptions.sdkKey = $2a142e07fdcca311$var$DEFAULT_CLIENT_KEY;
                                if (!((_newClientOptions$net = newClientOptions.networkConfig) !== null && _newClientOptions$net !== void 0 && _newClientOptions$net.logEventUrl)) newClientOptions.networkConfig = $2a142e07fdcca311$var$_objectSpread($2a142e07fdcca311$var$_objectSpread({}, newClientOptions.networkConfig), {}, {
                                    logEventUrl: $2a142e07fdcca311$var$DEFAULT_EVENT_LOGGING_API
                                });
                                if (newClientOptions.perimeter === (0, $cXGvu.PerimeterType).FEDRAMP_MODERATE) // disable all logging in FedRAMP to prevent egress of sensitive data
                                newClientOptions.disableLogging = true;
                                sdkKey = newClientOptions.sdkKey, environment = newClientOptions.environment, _updateUserCompletionCallback = newClientOptions.updateUserCompletionCallback, _perimeter = newClientOptions.perimeter, restClientOptions = (0, $b8P2v.default)(newClientOptions, $2a142e07fdcca311$var$_excluded);
                                frontendUser = (0, $jGAYn.toStatsigUser)(identifiers, customAttributes);
                                this.user = (0, $jGAYn.deepAssign)({}, initializeValues.user, frontendUser);
                                statsigOptions = $2a142e07fdcca311$var$_objectSpread($2a142e07fdcca311$var$_objectSpread({}, restClientOptions), {}, {
                                    environment: {
                                        tier: environment
                                    },
                                    includeCurrentPageUrlWithEvents: false,
                                    dataAdapter: this.dataAdapter,
                                    overrideAdapter: this.overrideAdapter,
                                    logEventCompressionMode: (0, $iFR7a.LogEventCompressionMode).Forced
                                }); // Statsig validates the provided stableId against their own cookie, so we either need
                                // to update the cookie to match, or disable the validation completely.
                                if (identifiers.stableId) (0, $iFR7a.StableID).setOverride(identifiers.stableId, sdkKey);
                                else statsigOptions.disableStableID = true;
                                _context0.prev = 1;
                                this.statsigClient = new (0, $iFR7a.StatsigClient)(sdkKey, this.user, statsigOptions);
                                this.dataAdapter.setBootstrapData(initializeValues);
                                _context0.next = 2;
                                return this.statsigClient.initializeAsync();
                            case 2:
                                _context0.next = 5;
                                break;
                            case 3:
                                _context0.prev = 3;
                                _t3 = _context0["catch"](1);
                                if (_t3 instanceof Error) // eslint-disable-next-line no-console
                                console.error("Error occurred when trying to initialise the Statsig client, error: ".concat(_t3 === null || _t3 === void 0 ? void 0 : _t3.message));
                                // eslint-disable-next-line no-console
                                console.warn("Initialising Statsig client with default sdk key and without values");
                                this.statsigClient = new (0, $iFR7a.StatsigClient)($2a142e07fdcca311$var$DEFAULT_CLIENT_KEY, this.user, statsigOptions);
                                this.dataAdapter.setBootstrapData();
                                _context0.next = 4;
                                return this.statsigClient.initializeAsync();
                            case 4:
                                this.initWithDefaults = true;
                                throw _t3;
                            case 5:
                            case "end":
                                return _context0.stop();
                        }
                    }, _callee0, this, [
                        [
                            1,
                            3
                        ]
                    ]);
                }));
                function initFromValues(_x23, _x24, _x25) {
                    return _initFromValues.apply(this, arguments);
                }
                return initFromValues;
            }()
        },
        {
            key: "updateUserUsingInitializeValuesProducer",
            value: function() {
                var _updateUserUsingInitializeValuesProducer = (0, $jt440.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1KMt7))).mark(function _callee10(getInitializeValues, identifiers, customAttributes) {
                    var _this9 = this;
                    var originalInitPromise, initializeValuesPromise, updateUserPromise, _t4;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($1KMt7))).wrap(function(_context10) {
                        while(true)switch(_context10.prev = _context10.next){
                            case 0:
                                this.assertInitialized(this.statsigClient);
                                if (this.initPromise) {
                                    _context10.next = 1;
                                    break;
                                }
                                throw new Error('The client must be initialized before you can update the user.');
                            case 1:
                                if (!this.isCurrentUser(identifiers, customAttributes)) {
                                    _context10.next = 2;
                                    break;
                                }
                                return _context10.abrupt("return", this.initPromise);
                            case 2:
                                // Wait for the current initialize/update to finish
                                originalInitPromise = this.initPromise;
                                _context10.prev = 3;
                                _context10.next = 4;
                                return this.initPromise;
                            case 4:
                                _context10.next = 6;
                                break;
                            case 5:
                                _context10.prev = 5;
                                _t4 = _context10["catch"](3);
                            case 6:
                                initializeValuesPromise = getInitializeValues();
                                updateUserPromise = this.updateStatsigClientUser(initializeValuesPromise, identifiers, customAttributes); // We replace the init promise here since we are essentially re-initializing the client at this
                                // point. Any subsequent calls to await client.initialize() or client.updateUser()
                                // will now also await this user update.
                                this.initPromise = updateUserPromise.catch(/*#__PURE__*/ (0, $jt440.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1KMt7))).mark(function _callee1() {
                                    return (0, (/*@__PURE__*/$parcel$interopDefault($1KMt7))).wrap(function(_context1) {
                                        while(true)switch(_context1.prev = _context1.next){
                                            case 0:
                                                // If the update failed then it changed nothing, so revert back to the original promise.
                                                _this9.initPromise = originalInitPromise;
                                                // Set the user profile again to revert back to the current user
                                                if (!_this9.provider) {
                                                    _context1.next = 1;
                                                    break;
                                                }
                                                _context1.next = 1;
                                                return _this9.provider.setProfile(_this9.initOptions, _this9.currentIdentifiers, _this9.currentAttributes);
                                            case 1:
                                            case "end":
                                                return _context1.stop();
                                        }
                                    }, _callee1);
                                })));
                                return _context10.abrupt("return", updateUserPromise);
                            case 7:
                            case "end":
                                return _context10.stop();
                        }
                    }, _callee10, this, [
                        [
                            3,
                            5
                        ]
                    ]);
                }));
                function updateUserUsingInitializeValuesProducer(_x26, _x27, _x28) {
                    return _updateUserUsingInitializeValuesProducer.apply(this, arguments);
                }
                return updateUserUsingInitializeValuesProducer;
            }()
        },
        {
            key: "updateStatsigClientUser",
            value: function() {
                var _updateStatsigClientUser = (0, $jt440.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1KMt7))).mark(function _callee11(initializeValuesPromise, identifiers, customAttributes) {
                    var _this$initOptions, _this$initOptions$upd;
                    var initializeValues, user, frontendUser, _updateUserCompletion, _ref4, errMsg, success, errorMessage, _t5, _t6;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($1KMt7))).wrap(function(_context11) {
                        while(true)switch(_context11.prev = _context11.next){
                            case 0:
                                this.assertInitialized(this.statsigClient);
                                _context11.prev = 1;
                                _context11.next = 2;
                                return initializeValuesPromise;
                            case 2:
                                initializeValues = _context11.sent;
                                frontendUser = (0, $jGAYn.toStatsigUser)(identifiers, initializeValues.customAttributesFromFetch);
                                user = (0, $jGAYn.deepAssign)({}, initializeValues.experimentValues.user, frontendUser);
                                _context11.next = 4;
                                break;
                            case 3:
                                _context11.prev = 3;
                                _t5 = _context11["catch"](1);
                                // Make sure the updateUserCompletionCallback is called for any errors in our custom code.
                                // This is not necessary for the updateUserWithValues call, because the Statsig client will
                                // already invoke the callback itself.
                                errMsg = _t5 instanceof Error ? _t5.message : JSON.stringify(_t5);
                                (_updateUserCompletion = (_ref4 = this.initOptions).updateUserCompletionCallback) === null || _updateUserCompletion === void 0 || _updateUserCompletion.call(_ref4, false, errMsg);
                                throw _t5;
                            case 4:
                                success = true;
                                errorMessage = null;
                                _context11.prev = 5;
                                this.dataAdapter.setBootstrapData(initializeValues.experimentValues);
                                this.user = user;
                                if (!this.user) {
                                    _context11.next = 6;
                                    break;
                                }
                                _context11.next = 6;
                                return this.statsigClient.updateUserAsync(this.user);
                            case 6:
                                _context11.next = 8;
                                break;
                            case 7:
                                _context11.prev = 7;
                                _t6 = _context11["catch"](5);
                                success = false;
                                errorMessage = String(_t6);
                            case 8:
                                (_this$initOptions = this.initOptions) === null || _this$initOptions === void 0 || (_this$initOptions$upd = _this$initOptions.updateUserCompletionCallback) === null || _this$initOptions$upd === void 0 || _this$initOptions$upd.call(_this$initOptions, success, errorMessage);
                                if (!success) {
                                    _context11.next = 9;
                                    break;
                                }
                                this.currentIdentifiers = identifiers;
                                this.currentAttributes = customAttributes;
                                this.subscriptions.anyUpdated();
                                _context11.next = 10;
                                break;
                            case 9:
                                throw new Error('Failed to update user. An unexpected error occured.');
                            case 10:
                            case "end":
                                return _context11.stop();
                        }
                    }, _callee11, this, [
                        [
                            1,
                            3
                        ],
                        [
                            5,
                            7
                        ]
                    ]);
                }));
                function updateStatsigClientUser(_x29, _x30, _x31) {
                    return _updateStatsigClientUser.apply(this, arguments);
                }
                return updateStatsigClientUser;
            }()
        },
        {
            key: "getPackageVersion",
            value: /**
     * @returns string version of the current package in semver style.
     */ function getPackageVersion() {
                return 0, $6WhoI.CLIENT_VERSION;
            }
        },
        {
            key: "getTargetApp",
            value: function getTargetApp() {
                var _this$initOptions2;
                return (_this$initOptions2 = this.initOptions) === null || _this$initOptions2 === void 0 ? void 0 : _this$initOptions2.targetApp;
            }
        },
        {
            key: "getLayer",
            value: function getLayer(/** The name of the layer */ layerName) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                try {
                    this.assertInitialized(this.statsigClient);
                    var _options$fireLayerExp = options.fireLayerExposure, fireLayerExposure = _options$fireLayerExp === void 0 ? true : _options$fireLayerExp;
                    return (0, $gFo6M.Layer).fromLayer(this.statsigClient.getLayer(layerName, {
                        disableExposureLog: !fireLayerExposure
                    }));
                } catch (error) {
                    // Log the first occurrence of the error
                    if (!this.hasGetLayerErrorOccurred) {
                        // eslint-disable-next-line no-console
                        console.warn({
                            msg: 'An error has occurred getting the layer. Only the first occurrence of this error is logged.',
                            layerName: layerName,
                            error: error
                        });
                        this.hasGetLayerErrorOccurred = true;
                    }
                    // Return a default value
                    return (0, $gFo6M.Layer).fromLayer((0, $iFR7a._makeLayer)(layerName, {
                        reason: 'Error'
                    }, null));
                }
            }
        },
        {
            key: "getLayerValue",
            value: function getLayerValue(layerName, parameterName, defaultValue) {
                var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var layer = this.getLayer(layerName, options);
                try {
                    var typeGuard = options.typeGuard;
                    return layer.get(parameterName, defaultValue, typeGuard);
                } catch (error) {
                    // Log the first occurrence of the error
                    if (!this.hasGetLayerValueErrorOccurred) {
                        // eslint-disable-next-line no-console
                        console.warn({
                            msg: 'An error has occurred getting the layer value. Only the first occurrence of this error is logged.',
                            layerName: layerName,
                            defaultValue: defaultValue,
                            options: options,
                            error: error
                        });
                        this.hasGetLayerValueErrorOccurred = true;
                    }
                    return defaultValue;
                }
            }
        }
    ]);
}();

});
parcelRegister("b8P2v", function(module, exports) {
$parcel$export(module.exports, "default", () => $0217df1aa16feb88$export$2e2bcd8739ae039);

var $2JgIH = parcelRequire("2JgIH");
function $0217df1aa16feb88$export$2e2bcd8739ae039(e, t) {
    if (null == e) return {};
    var o, r, i = (0, $2JgIH.default)(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}

});
parcelRegister("2JgIH", function(module, exports) {
$parcel$export(module.exports, "default", () => $1fccc0fd2233e512$export$2e2bcd8739ae039);
function $1fccc0fd2233e512$export$2e2bcd8739ae039(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}

});


parcelRegister("94GB8", function(module, exports) {
$parcel$export(module.exports, "default", () => $69b587dde0aaaa80$export$2e2bcd8739ae039);

var $fhXtQ = parcelRequire("fhXtQ");

var $3Nsmw = parcelRequire("3Nsmw");

var $7pQFh = parcelRequire("7pQFh");

var $2z1pF = parcelRequire("2z1pF");
function $69b587dde0aaaa80$export$2e2bcd8739ae039(r, e) {
    return (0, $fhXtQ.default)(r) || (0, $3Nsmw.default)(r, e) || (0, $7pQFh.default)(r, e) || (0, $2z1pF.default)();
}

});
parcelRegister("fhXtQ", function(module, exports) {
$parcel$export(module.exports, "default", () => $b21695224297f76b$export$2e2bcd8739ae039);
function $b21695224297f76b$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return r;
}

});

parcelRegister("3Nsmw", function(module, exports) {
$parcel$export(module.exports, "default", () => $2c3bf2d7609047a1$export$2e2bcd8739ae039);
function $2c3bf2d7609047a1$export$2e2bcd8739ae039(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}

});

parcelRegister("7pQFh", function(module, exports) {
$parcel$export(module.exports, "default", () => $5663b854619a9109$export$2e2bcd8739ae039);

var $2fgnB = parcelRequire("2fgnB");
function $5663b854619a9109$export$2e2bcd8739ae039(r, a) {
    if (r) {
        if ("string" == typeof r) return (0, $2fgnB.default)(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? (0, $2fgnB.default)(r, a) : void 0;
    }
}

});
parcelRegister("2fgnB", function(module, exports) {
$parcel$export(module.exports, "default", () => $1a29b0252edb7e9b$export$2e2bcd8739ae039);
function $1a29b0252edb7e9b$export$2e2bcd8739ae039(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}

});


parcelRegister("2z1pF", function(module, exports) {
$parcel$export(module.exports, "default", () => $1ddff240f950db25$export$2e2bcd8739ae039);
function $1ddff240f950db25$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});


parcelRegister("jt440", function(module, exports) {
$parcel$export(module.exports, "default", () => $e2c3e0b50e916ae4$export$2e2bcd8739ae039);
function $e2c3e0b50e916ae4$var$asyncGeneratorStep(n, t, e, r, o, a, c) {
    try {
        var i = n[a](c), u = i.value;
    } catch (n) {
        return void e(n);
    }
    i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function $e2c3e0b50e916ae4$export$2e2bcd8739ae039(n) {
    return function() {
        var t = this, e = arguments;
        return new Promise(function(r, o) {
            var a = n.apply(t, e);
            function _next(n) {
                $e2c3e0b50e916ae4$var$asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
            }
            function _throw(n) {
                $e2c3e0b50e916ae4$var$asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
            }
            _next(void 0);
        });
    };
}

});

parcelRegister("1KMt7", function(module, exports) {
// TODO(Babel 8): Remove this file.

var $146faf32240cacb0$var$runtime = (parcelRequire("eP9zw"))();
module.exports = $146faf32240cacb0$var$runtime;
// Copied from https://github.com/facebook/regenerator/blob/main/packages/runtime/runtime.js#L736=
try {
    regeneratorRuntime = $146faf32240cacb0$var$runtime;
} catch (accidentalStrictMode) {
    if (typeof globalThis === "object") globalThis.regeneratorRuntime = $146faf32240cacb0$var$runtime;
    else Function("r", "regeneratorRuntime = r")($146faf32240cacb0$var$runtime);
}

});

parcelRegister("iFR7a", function(module, exports) {
"use strict";
var $d98541c52a8d8f29$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $d98541c52a8d8f29$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $d98541c52a8d8f29$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.StatsigClient = void 0;


var $i1p2j = parcelRequire("i1p2j");
module.exports.StatsigClient = $i1p2j.default;

$d98541c52a8d8f29$var$__exportStar((parcelRequire("dtn6l")), module.exports);
const $d98541c52a8d8f29$var$__STATSIG__ = Object.assign((0, (parcelRequire("dtn6l"))._getStatsigGlobal)(), {
    StatsigClient: $i1p2j.default
});
module.exports.default = $d98541c52a8d8f29$var$__STATSIG__;

});
parcelRegister("i1p2j", function(module, exports) {
"use strict";
var $d1ebbdb02ace9f76$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $dtn6l = parcelRequire("dtn6l");

var $i8QCG = parcelRequire("i8QCG");

var $e4Scn = parcelRequire("e4Scn");

var $9JsrP = parcelRequire("9JsrP");

var $j6Ssa = parcelRequire("j6Ssa");
class $d1ebbdb02ace9f76$var$StatsigClient extends $dtn6l.StatsigClientBase {
    /**
     * Retrieves an instance of the StatsigClient based on the provided SDK key.
     *  If no SDK key is provided, the method returns the most recently created instance of the StatsigClient.
     *  The method ensures that each unique SDK key corresponds to a single instance of StatsigClient, effectively implementing a singleton pattern for each key.
     *  If no instance exists for the given SDK key, a new StatsigClient instance will be created and returned.
     *
     * @param {string} [sdkKey] - Optional. The SDK key used to identify a specific instance of the StatsigClient. If omitted, the method returns the last created instance.
     * @returns {StatsigClient} Returns the StatsigClient instance associated with the given SDK key, creating a new one if needed.
     */ static instance(sdkKey) {
        const instance = (0, $dtn6l._getStatsigGlobal)().instance(sdkKey);
        if (instance instanceof $d1ebbdb02ace9f76$var$StatsigClient) return instance;
        $dtn6l.Log.warn((0, $dtn6l._isServerEnv)() ? 'StatsigClient.instance is not supported in server environments' : 'Unable to find StatsigClient instance');
        return new $d1ebbdb02ace9f76$var$StatsigClient(sdkKey !== null && sdkKey !== void 0 ? sdkKey : '', {});
    }
    /**
     * StatsigClient constructor
     *
     * @param {string} sdkKey A Statsig client SDK key. eg "client-xyz123..."
     * @param {StatsigUser} user StatsigUser object containing various attributes related to a user.
     * @param {StatsigOptions | null} options StatsigOptions, used to customize the behavior of the SDK.
     */ constructor(sdkKey, user, options = null){
        var _a, _b;
        $dtn6l.SDKType._setClientType(sdkKey, 'javascript-client');
        const network = new $e4Scn.default(options, (e)=>{
            this.$emt(e);
        });
        super(sdkKey, (_a = options === null || options === void 0 ? void 0 : options.dataAdapter) !== null && _a !== void 0 ? _a : new $j6Ssa.StatsigEvaluationsDataAdapter(), network, options);
        this._possibleFirstTouchMetadata = {};
        /**
         * Retrieves the value of a feature gate for the current user, represented as a {@link FeatureGate} object.
         *
         * @param {string} name - The name of the feature gate to retrieve.
         * @param {FeatureGateEvaluationOptions} [options] - Optional. Additional options to customize the method call.
         * @returns {FeatureGate} - The {@link FeatureGate} object representing the gate's current evaluation results for the user.
         */ this.getFeatureGate = this._memoize($dtn6l.MemoPrefix._gate, this._getFeatureGateImpl.bind(this));
        /**
         * Retrieves the value of a dynamic config for the current user.
         *
         * @param {string} name The name of the dynamic config to get.
         * @param {DynamicConfigEvaluationOptions} [options] - Optional. Additional options to customize the method call.
         * @returns {DynamicConfig} - The {@link DynamicConfig} object representing the dynamic configs's current evaluation results for the user.
         */ this.getDynamicConfig = this._memoize($dtn6l.MemoPrefix._dynamicConfig, this._getDynamicConfigImpl.bind(this));
        /**
         * Retrieves the value of a experiment for the current user.
         *
         * @param {string} name The name of the experiment to get.
         * @param {ExperimentEvaluationOptions} [options] - Optional. Additional options to customize the method call.
         * @returns {Experiment} - The {@link Experiment} object representing the experiments's current evaluation results for the user.
         */ this.getExperiment = this._memoize($dtn6l.MemoPrefix._experiment, this._getExperimentImpl.bind(this));
        /**
         * Retrieves the list of all Dynamic Configs and Experiments for the current user.
         *
         * @returns {string[]} The list of all Dynamic Config and Experiment names for the current user. Note - these will be hashed unless you've disabled hashing.
         * This is intended to be used for debugging.
         */ this.getConfigList = this._memoize($dtn6l.MemoPrefix._configList, this._getConfigListImpl.bind(this));
        /**
         * Retrieves the value of a layer for the current user.
         *
         * @param {string} name The name of the layer to get.
         * @param {LayerEvaluationOptions} [options] - Optional. Additional options to customize the method call.
         * @returns {Layer} - The {@link Layer} object representing the layers's current evaluation results for the user.
         */ this.getLayer = this._memoize($dtn6l.MemoPrefix._layer, this._getLayerImpl.bind(this));
        /**
         * Retrieves the value of a parameter store for the current user.
         *
         * @param {string} name The name of the parameter store to get.
         * @param {ParameterStoreEvaluationOptions} [options] - Optional. Additional options to customize the method call.
         * @returns {ParameterStore} - The {@link ParameterStore} object representing the parameter store's current mappings for the user.
         */ this.getParameterStore = this._memoize($dtn6l.MemoPrefix._paramStore, this._getParameterStoreImpl.bind(this));
        this._store = new $i8QCG.default(sdkKey, options !== null && options !== void 0 ? options : null);
        this._network = network;
        this._user = this._configureUser(user, options);
        this._sdkInstanceID = (0, $dtn6l.getUUID)();
        this._contextHandle = new $dtn6l.PrecomputedEvaluationsContextHandle(sdkKey, ()=>this._options, ()=>this._errorBoundary, ()=>this._store.getValues(), ()=>this._user, ()=>this._sdkInstanceID);
        const plugins = (_b = options === null || options === void 0 ? void 0 : options.plugins) !== null && _b !== void 0 ? _b : [];
        for (const plugin of plugins)plugin.bind(this);
    }
    /**
     * Initializes the StatsigClient using cached values. This method sets up the client synchronously by utilizing previously cached values.
     * After initialization, cache values are updated in the background for future use, either in subsequent sessions or when `updateUser` is called.
     * This is useful for quickly starting with the last-known-good configurations while refreshing data to keep settings up-to-date.
     *
     * @see {@link initializeAsync} for the asynchronous version of this method.
     */ initializeSync(options) {
        var _a;
        if (this.loadingStatus !== 'Uninitialized') return (0, $dtn6l.createUpdateDetails)(true, this._store.getSource(), -1, null, null, [
            'MultipleInitializations',
            ...(_a = this._store.getWarnings()) !== null && _a !== void 0 ? _a : []
        ]);
        this._logger.start();
        return this.updateUserSync(this._user, options);
    }
    /**
     * Initializes the StatsigClient asynchronously by first using cached values and then updating to the latest values from the network.
     * Once the network values are fetched, they replace the existing cached values. If this method's promise is not awaited,
     * there might be a transition from cached to network values during the session, which can affect consistency.
     * This method is useful when it's acceptable to begin with potentially stale data and switch to the latest configuration as it becomes available.
     *
     * @param {AsyncUpdateOptions} [options] - Optional. Additional options to customize the method call.
     * @returns {Promise<void>} A promise that resolves once the client is fully initialized with the latest values from the network or a timeout (if set) is hit.
     * @see {@link initializeSync} for the synchronous version of this method.
     */ initializeAsync(options) {
        return $d1ebbdb02ace9f76$var$__awaiter(this, void 0, void 0, function*() {
            if (this._initializePromise) return this._initializePromise;
            this._initializePromise = this._initializeAsyncImpl(options);
            return this._initializePromise;
        });
    }
    /**
     * Synchronously updates the user in the Statsig client and switches the internal state to use cached values for the newly specified user.
     * After the initial switch to cached values, this method updates these values in the background, preparing them for future sessions or subsequent calls to updateUser.
     * This method ensures the client is quickly ready with available data.
     *
     * @param {StatsigUser} user - The new StatsigUser for which the client should update its internal state.
     * @see {@link updateUserAsync} for the asynchronous version of this method.
     */ updateUserSync(user, options) {
        const startTime = performance.now();
        try {
            return this._updateUserSyncImpl(user, options, startTime);
        } catch (e) {
            const err = e instanceof Error ? e : new Error(String(e));
            return this._createErrorUpdateDetails(err, startTime);
        }
    }
    _updateUserSyncImpl(user, options, startTime) {
        var _a;
        const warnings = [
            ...(_a = this._store.getWarnings()) !== null && _a !== void 0 ? _a : []
        ];
        this._resetForUser(user);
        const result = this.dataAdapter.getDataSync(this._user);
        if (result == null) warnings.push('NoCachedValues');
        this._store.setValues(result, this._user);
        this._finalizeUpdate(result);
        const disable = options === null || options === void 0 ? void 0 : options.disableBackgroundCacheRefresh;
        if (disable === true || disable == null && (result === null || result === void 0 ? void 0 : result.source) === 'Bootstrap') return (0, $dtn6l.createUpdateDetails)(true, this._store.getSource(), performance.now() - startTime, this._errorBoundary.getLastSeenErrorAndReset(), this._network.getLastUsedInitUrlAndReset(), warnings);
        this._runPostUpdate(result !== null && result !== void 0 ? result : null, this._user);
        return (0, $dtn6l.createUpdateDetails)(true, this._store.getSource(), performance.now() - startTime, this._errorBoundary.getLastSeenErrorAndReset(), this._network.getLastUsedInitUrlAndReset(), warnings);
    }
    /**
     * Asynchronously updates the user in the Statsig client by initially using cached values and then fetching the latest values from the network.
     * When the latest values are fetched, they replace the cached values. If the promise returned by this method is not awaited,
     * the client's state may shift from cached to updated network values during the session, potentially affecting consistency.
     * This method is best used in scenarios where up-to-date configuration is critical and initial delays are acceptable.
     *
     * @param {StatsigUser} user - The new StatsigUser for which the client should update its internal state.
     * @param {AsyncUpdateOptions} [options] - Optional. Additional options to customize the method call.
     * @returns {Promise<void>} A promise that resolves once the client is fully updated with the latest values from the network or a timeout (if set) is hit.
     * @see {@link updateUserSync} for the synchronous version of this method.
     */ updateUserAsync(user, options) {
        return $d1ebbdb02ace9f76$var$__awaiter(this, void 0, void 0, function*() {
            const startTime = performance.now();
            try {
                return yield this._updateUserAsyncImpl(user, options);
            } catch (e) {
                const err = e instanceof Error ? e : new Error(String(e));
                return this._createErrorUpdateDetails(err, startTime);
            }
        });
    }
    _updateUserAsyncImpl(user, options) {
        return $d1ebbdb02ace9f76$var$__awaiter(this, void 0, void 0, function*() {
            this._resetForUser(user);
            const initiator = this._user;
            $dtn6l.Diagnostics._markInitOverallStart(this._sdkKey);
            let result = this.dataAdapter.getDataSync(initiator);
            this._store.setValues(result, this._user);
            this._setStatus('Loading', result);
            result = yield this.dataAdapter.getDataAsync(result, initiator, options);
            // ensure the user hasn't changed while we were waiting
            if (initiator !== this._user) return (0, $dtn6l.createUpdateDetails)(false, this._store.getSource(), -1, new Error('User changed during update'), this._network.getLastUsedInitUrlAndReset());
            let isUsingNetworkValues = false;
            if (result != null) {
                $dtn6l.Diagnostics._markInitProcessStart(this._sdkKey);
                isUsingNetworkValues = this._store.setValues(result, this._user);
                $dtn6l.Diagnostics._markInitProcessEnd(this._sdkKey, {
                    success: isUsingNetworkValues
                });
            }
            this._finalizeUpdate(result);
            if (!isUsingNetworkValues) {
                this._errorBoundary.attachErrorIfNoneExists($dtn6l.UPDATE_DETAIL_ERROR_MESSAGES.NO_NETWORK_DATA);
                this.$emt({
                    name: 'initialization_failure'
                });
            }
            $dtn6l.Diagnostics._markInitOverallEnd(this._sdkKey, isUsingNetworkValues, this._store.getCurrentSourceDetails());
            const initDuration = $dtn6l.Diagnostics._enqueueDiagnosticsEvent(this._user, this._logger, this._sdkKey, this._options);
            return (0, $dtn6l.createUpdateDetails)(isUsingNetworkValues, this._store.getSource(), initDuration, this._errorBoundary.getLastSeenErrorAndReset(), this._network.getLastUsedInitUrlAndReset(), this._store.getWarnings());
        });
    }
    /**
     * Retrieves a synchronous context containing data currently being used by the SDK. Represented as a {@link PrecomputedEvaluationsContext} object.
     *
     * @returns {PrecomputedEvaluationsContext} The current synchronous context for the this StatsigClient instance.
     */ getContext() {
        let user = (0, $dtn6l._cloneObject)('StatsigUser', this._user);
        if (user == null) {
            $dtn6l.Log.error('Failed to clone user');
            user = {};
        }
        return {
            sdkKey: this._sdkKey,
            options: this._options,
            values: this._store.getValues(),
            user: user,
            errorBoundary: this._errorBoundary,
            session: $dtn6l.StatsigSession.get(this._sdkKey),
            stableID: $dtn6l.StableID.get(this._sdkKey),
            sdkInstanceID: this._sdkInstanceID
        };
    }
    /**
     * Retrieves a context handle that computes fields lazily on access.
     * This is more efficient than getContext() when you only need certain fields,
     *
     * @returns {PrecomputedEvaluationsContextHandle} A handle with lazy getters for context fields.
     */ getContextHandle() {
        return this._contextHandle;
    }
    /**
     * Retrieves the value of a feature gate for the current user, represented as a simple boolean.
     *
     * @param {string} name - The name of the feature gate to retrieve.
     * @param {FeatureGateEvaluationOptions} [options] - Optional. Additional options to customize the method call.
     * @returns {boolean} - The boolean value representing the gate's current evaluation results for the user.
     */ checkGate(name, options) {
        return this.getFeatureGate(name, options).value;
    }
    /**
     * Logs an event to the internal logging system. This function allows logging by either passing a fully formed event object or by specifying the event name with optional value and metadata.
     *
     * @param {StatsigEvent|string} eventOrName - The event object conforming to the StatsigEvent interface, or the name of the event as a string.
     * @param {string|number} value - Optional. The value associated with the event, which can be a string or a number. This parameter is ignored if the first parameter is a StatsigEvent object.
     * @param {Record<string, string>} metadata - Optional. A key-value record containing metadata about the event. This is also ignored if the first parameter is an event object.
     */ logEvent(eventOrName, value, metadata) {
        const event = typeof eventOrName === 'string' ? {
            eventName: eventOrName,
            value: value,
            metadata: metadata
        } : eventOrName;
        this.$emt({
            name: 'log_event_called',
            event: event
        });
        this._logger.enqueue(Object.assign(Object.assign({}, event), {
            user: this._user,
            time: Date.now()
        }));
    }
    /**
     * Updates the user with analytics only metadata. This will override any existing analytics only metadata.
     *
     * @param {Record<string, string | number | boolean>} metadata - The metadata to add to the user.
     */ updateUserWithAnalyticsOnlyMetadata(metadata) {
        this._user = this._configureUser(Object.assign(Object.assign({}, this._user), {
            analyticsOnlyMetadata: metadata
        }), this._options);
    }
    _primeReadyRipcord() {
        this.$on('error', ()=>{
            this.loadingStatus === 'Loading' && this._finalizeUpdate(null);
        });
    }
    _initializeAsyncImpl(options) {
        return $d1ebbdb02ace9f76$var$__awaiter(this, void 0, void 0, function*() {
            if (!$dtn6l.Storage.isReady()) yield $dtn6l.Storage.isReadyResolver();
            this._logger.start();
            return this.updateUserAsync(this._user, options);
        });
    }
    _createErrorUpdateDetails(error, startTime) {
        var _a;
        return (0, $dtn6l.createUpdateDetails)(false, this._store.getSource(), performance.now() - startTime, error, null, [
            ...(_a = this._store.getWarnings()) !== null && _a !== void 0 ? _a : []
        ]);
    }
    _finalizeUpdate(values) {
        this._store.finalize();
        this._setStatus('Ready', values);
    }
    _runPostUpdate(current, user) {
        this.dataAdapter.getDataAsync(current, user, {
            priority: 'low'
        }).catch((err)=>{
            $dtn6l.Log.error('An error occurred after update.', err);
        });
    }
    _resetForUser(user) {
        this._logger.reset();
        this._store.reset();
        this._user = this._configureUser(user, this._options);
    }
    _configureUser(originalUser, options) {
        var _a, _b, _c;
        const user = (0, $dtn6l._normalizeUser)(originalUser, options);
        const stableIdOverride = (_a = user.customIDs) === null || _a === void 0 ? void 0 : _a.stableID;
        if (stableIdOverride) {
            const readyPromise = (_c = (_b = this.storageProvider).isReadyResolver) === null || _c === void 0 ? void 0 : _c.call(_b);
            if (readyPromise) readyPromise.then(()=>$dtn6l.StableID.setOverride(stableIdOverride, this._sdkKey), ()=>$dtn6l.StableID.setOverride(stableIdOverride, this._sdkKey));
            else $dtn6l.StableID.setOverride(stableIdOverride, this._sdkKey);
        }
        // Only attach first touch metadata if it's not empty
        if (Object.keys(this._possibleFirstTouchMetadata).length > 0) user.analyticsOnlyMetadata = Object.assign(Object.assign({}, user.analyticsOnlyMetadata), this._possibleFirstTouchMetadata);
        return user;
    }
    _getFeatureGateImpl(name, options) {
        var _a, _b;
        const { result: evaluation, details: details } = this._store.getGate(name);
        this._checkUserHasIdForEvaluation(evaluation === null || evaluation === void 0 ? void 0 : evaluation.id_type, name, 'Gate');
        this._checkInitializationStatus(details.reason);
        const gate = (0, $dtn6l._makeFeatureGate)(name, details, evaluation);
        const overridden = (_b = (_a = this.overrideAdapter) === null || _a === void 0 ? void 0 : _a.getGateOverride) === null || _b === void 0 ? void 0 : _b.call(_a, gate, this._user, options);
        const result = overridden !== null && overridden !== void 0 ? overridden : gate;
        this._enqueueExposure(name, (0, $dtn6l._createGateExposure)(this._user, result, this._store.getExposureMapping()), options);
        this.$emt({
            name: 'gate_evaluation',
            gate: result
        });
        return result;
    }
    _getDynamicConfigImpl(name, options) {
        var _a, _b;
        const { result: evaluation, details: details } = this._store.getConfig(name);
        this._checkUserHasIdForEvaluation(evaluation === null || evaluation === void 0 ? void 0 : evaluation.id_type, name, 'Dynamic config');
        this._checkInitializationStatus(details.reason);
        const config = (0, $dtn6l._makeDynamicConfig)(name, details, evaluation);
        const overridden = (_b = (_a = this.overrideAdapter) === null || _a === void 0 ? void 0 : _a.getDynamicConfigOverride) === null || _b === void 0 ? void 0 : _b.call(_a, config, this._user, options);
        const result = overridden !== null && overridden !== void 0 ? overridden : config;
        this._enqueueExposure(name, (0, $dtn6l._createConfigExposure)(this._user, result, this._store.getExposureMapping()), options);
        this.$emt({
            name: 'dynamic_config_evaluation',
            dynamicConfig: result
        });
        return result;
    }
    _getExperimentImpl(name, options) {
        var _a, _b, _c, _d;
        const { result: evaluation, details: details } = this._store.getConfig(name);
        this._checkUserHasIdForEvaluation(evaluation === null || evaluation === void 0 ? void 0 : evaluation.id_type, name, 'Experiment');
        this._checkInitializationStatus(details.reason);
        const experiment = (0, $dtn6l._makeExperiment)(name, details, evaluation);
        if (experiment.__evaluation != null) experiment.__evaluation.secondary_exposures = (0, $dtn6l._mapExposures)((_b = (_a = experiment.__evaluation) === null || _a === void 0 ? void 0 : _a.secondary_exposures) !== null && _b !== void 0 ? _b : [], this._store.getExposureMapping());
        const overridden = (_d = (_c = this.overrideAdapter) === null || _c === void 0 ? void 0 : _c.getExperimentOverride) === null || _d === void 0 ? void 0 : _d.call(_c, experiment, this._user, options);
        const result = overridden !== null && overridden !== void 0 ? overridden : experiment;
        this._enqueueExposure(name, (0, $dtn6l._createConfigExposure)(this._user, result, this._store.getExposureMapping()), options);
        this.$emt({
            name: 'experiment_evaluation',
            experiment: result
        });
        return result;
    }
    _getConfigListImpl() {
        return this._store.getConfigList();
    }
    _getLayerImpl(name, options) {
        var _a, _b, _c;
        const { result: evaluation, details: details } = this._store.getLayer(name);
        const layer = (0, $dtn6l._makeLayer)(name, details, evaluation);
        const overridden = (_b = (_a = this.overrideAdapter) === null || _a === void 0 ? void 0 : _a.getLayerOverride) === null || _b === void 0 ? void 0 : _b.call(_a, layer, this._user, options);
        if (options === null || options === void 0 ? void 0 : options.disableExposureLog) this._logger.incrementNonExposureCount(name);
        const result = (0, $dtn6l._mergeOverride)(layer, overridden, (_c = overridden === null || overridden === void 0 ? void 0 : overridden.__value) !== null && _c !== void 0 ? _c : layer.__value, (param)=>{
            if (options === null || options === void 0 ? void 0 : options.disableExposureLog) return;
            this._enqueueExposure(name, (0, $dtn6l._createLayerParameterExposure)(this._user, result, param, this._store.getExposureMapping()), options);
        });
        this.$emt({
            name: 'layer_evaluation',
            layer: result
        });
        return result;
    }
    _getParameterStoreImpl(name, options) {
        var _a, _b;
        const { result: configuration, details: details } = this._store.getParamStore(name);
        this._logger.incrementNonExposureCount(name);
        const paramStore = {
            name: name,
            details: details,
            __configuration: configuration,
            get: (0, $9JsrP._makeParamStoreGetter)(this, configuration, options)
        };
        const overridden = (_b = (_a = this.overrideAdapter) === null || _a === void 0 ? void 0 : _a.getParamStoreOverride) === null || _b === void 0 ? void 0 : _b.call(_a, paramStore, options);
        if (overridden != null) {
            paramStore.__configuration = overridden.config;
            paramStore.details = overridden.details;
            paramStore.get = (0, $9JsrP._makeParamStoreGetter)(this, overridden.config, options);
        }
        return paramStore;
    }
    _checkUserHasIdForEvaluation(idType, name, type) {
        if (!idType) return;
        if (!(0, $dtn6l._getUnitIDFromUser)(this._user, idType)) $dtn6l.Log.warn(`The user does not have the required id_type "${idType}" for ${type} "${name}"`);
    }
    _checkInitializationStatus(reason) {
        if (reason === 'Uninitialized' || reason.startsWith('Loading')) $dtn6l.Log.warn(`SDK initialization has not completed. Reason: ${reason}`);
    }
}
module.exports.default = $d1ebbdb02ace9f76$var$StatsigClient;

});
parcelRegister("i8QCG", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $dtn6l = parcelRequire("dtn6l");

var $7btVL = parcelRequire("7btVL");

var $3UfIi = parcelRequire("3UfIi");
class $d351cb260e1921f6$var$EvaluationStore {
    constructor(_sdkKey, _options){
        this._sdkKey = _sdkKey;
        this._options = _options;
        this._valuesForExternalUse = null;
        this._values = null;
        this._source = 'Uninitialized';
        this._lcut = 0;
        this._receivedAt = 0;
        this._bootstrapMetadata = null;
        this._warnings = new Set();
    }
    reset() {
        this._values = null;
        this._valuesForExternalUse = null;
        this._source = 'Loading';
        this._lcut = 0;
        this._receivedAt = 0;
        this._bootstrapMetadata = null;
        this._warnings.clear();
    }
    finalize() {
        if (this._values) return;
        this._source = 'NoValues';
    }
    getValues() {
        // we do not give out the actual _values object to avoid mutating it
        return this._valuesForExternalUse;
    }
    setValues(result, user) {
        var _a, _b;
        if (!result) return false;
        const values = (0, $dtn6l._typedJsonParse)(result.data, 'has_updates', 'EvaluationResponse');
        if (values == null) return false;
        this._source = result.source;
        if ((values === null || values === void 0 ? void 0 : values.has_updates) !== true) return true;
        const updatedLcut = (_a = values.time) !== null && _a !== void 0 ? _a : 0;
        if (updatedLcut < this._lcut) return true;
        this._valuesForExternalUse = (0, $dtn6l._typedJsonParse)(result.data, 'has_updates', 'EvaluationResponse');
        this._lcut = values.time;
        this._receivedAt = result.receivedAt;
        if (values.response_format === 'init-v2') this._values = new $3UfIi.V2InitializeContainer(values);
        else this._values = new $7btVL.V1InitializeContainer(values);
        this._bootstrapMetadata = this._extractBootstrapMetadata(result.source, values);
        if (result.source && values.user) this._setWarningState(user, values);
        $dtn6l.SDKFlags.setFlags(this._sdkKey, (_b = values.sdk_flags) !== null && _b !== void 0 ? _b : {});
        return true;
    }
    getWarnings() {
        if (this._warnings.size === 0) return undefined;
        return Array.from(this._warnings);
    }
    getGate(name) {
        const res = this._values ? this._values.getGate(name) : null;
        return this._getDetailedStoreResult(res);
    }
    getConfig(name) {
        const res = this._values ? this._values.getConfig(name) : null;
        return this._getDetailedStoreResult(res);
    }
    getConfigList() {
        if (!this._values) return [];
        return this._values.getConfigList();
    }
    getLayer(name) {
        const res = this._values ? this._values.getLayer(name) : null;
        return this._getDetailedStoreResult(res);
    }
    getParamStore(name) {
        const res = this._values ? this._values.getParamStore(name) : null;
        return this._getDetailedStoreResult(res);
    }
    getSource() {
        return this._source;
    }
    getExposureMapping() {
        var _a;
        return (_a = this._values) === null || _a === void 0 ? void 0 : _a.getExposureMapping();
    }
    _extractBootstrapMetadata(source, values) {
        if (source !== 'Bootstrap') return null;
        const bootstrapMetadata = {};
        if (values.user) bootstrapMetadata.user = values.user;
        if (values.sdkInfo) bootstrapMetadata.generatorSDKInfo = values.sdkInfo;
        bootstrapMetadata.lcut = values.time;
        return bootstrapMetadata;
    }
    _getDetailedStoreResult(result) {
        return {
            result: result,
            details: this._getDetails(result == null)
        };
    }
    _setWarningState(user, values) {
        var _a, _b, _c;
        const stableID = $dtn6l.StableID.get(this._sdkKey);
        if (((_a = user.customIDs) === null || _a === void 0 ? void 0 : _a.stableID) !== stableID && // don't throw if they're both undefined
        (((_b = user.customIDs) === null || _b === void 0 ? void 0 : _b.stableID) || stableID)) {
            this._warnings.add('StableIDMismatch');
            return;
        }
        if ('user' in values) {
            let bootstrapUser = values['user'];
            let userForComparison = Object.assign(Object.assign({}, user), {
                analyticsOnlyMetadata: undefined,
                privateAttributes: undefined
            });
            if ((_c = this._options) === null || _c === void 0 ? void 0 : _c.disableStableID) {
                userForComparison = Object.assign(Object.assign({}, userForComparison), {
                    customIDs: Object.assign(Object.assign({}, userForComparison.customIDs), {
                        stableID: undefined
                    })
                });
                bootstrapUser = Object.assign(Object.assign({}, bootstrapUser), {
                    customIDs: Object.assign(Object.assign({}, bootstrapUser.customIDs), {
                        stableID: undefined
                    })
                });
            }
            if ((0, $dtn6l._getFullUserHash)(userForComparison) !== (0, $dtn6l._getFullUserHash)(bootstrapUser)) this._warnings.add('PartialUserMatch');
        }
    }
    getCurrentSourceDetails() {
        if (this._source === 'Uninitialized' || this._source === 'NoValues') return {
            reason: this._source
        };
        const sourceDetails = {
            reason: this._source,
            lcut: this._lcut,
            receivedAt: this._receivedAt
        };
        if (this._warnings.size > 0) sourceDetails.warnings = Array.from(this._warnings);
        return sourceDetails;
    }
    _getDetails(isUnrecognized) {
        var _a, _b;
        const sourceDetails = this.getCurrentSourceDetails();
        let reason = sourceDetails.reason;
        const warnings = (_a = sourceDetails.warnings) !== null && _a !== void 0 ? _a : [];
        if (this._source === 'Bootstrap' && warnings.length > 0) reason = reason + warnings[0];
        if (reason !== 'Uninitialized' && reason !== 'NoValues') {
            const subreason = isUnrecognized ? 'Unrecognized' : 'Recognized';
            reason = `${reason}:${subreason}`;
        }
        const bootstrapMetadata = this._source === 'Bootstrap' ? (_b = this._bootstrapMetadata) !== null && _b !== void 0 ? _b : undefined : undefined;
        if (bootstrapMetadata) sourceDetails.bootstrapMetadata = bootstrapMetadata;
        return Object.assign(Object.assign({}, sourceDetails), {
            reason: reason
        });
    }
}
module.exports.default = $d351cb260e1921f6$var$EvaluationStore;

});
parcelRegister("7btVL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.V1InitializeContainer = void 0;

var $dtn6l = parcelRequire("dtn6l");
class $53b0c713f248c7f9$var$V1InitializeContainer {
    constructor(_values){
        this._values = _values;
    }
    getGate(name) {
        return this._getResultFromLookup(this._values.feature_gates, name);
    }
    getConfig(name) {
        return this._getResultFromLookup(this._values.dynamic_configs, name);
    }
    getLayer(name) {
        return this._getResultFromLookup(this._values.layer_configs, name);
    }
    getParamStore(name) {
        return this._getResultFromLookup(this._values.param_stores, name);
    }
    getConfigList() {
        return Object.keys(this._values.dynamic_configs);
    }
    getExposureMapping() {
        return this._values.exposures;
    }
    _getResultFromLookup(lookup, name) {
        var _a, _b;
        if (!lookup) return null;
        return (_b = (_a = lookup[name]) !== null && _a !== void 0 ? _a : lookup[(0, $dtn6l._DJB2)(name)]) !== null && _b !== void 0 ? _b : null;
    }
}
module.exports.V1InitializeContainer = $53b0c713f248c7f9$var$V1InitializeContainer;

});

parcelRegister("3UfIi", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.V2InitializeContainer = void 0;

var $dtn6l = parcelRequire("dtn6l");
class $2d82ca689190c304$var$V2InitializeContainer {
    constructor(_values){
        this._values = _values;
    }
    getGate(name) {
        var _a, _b, _c;
        const evalV2 = this._getResultFromLookup(this._values.feature_gates, name);
        if (!evalV2) return null;
        return {
            name: name,
            value: evalV2.v === true,
            rule_id: (_a = evalV2.r) !== null && _a !== void 0 ? _a : 'default',
            secondary_exposures: (_b = evalV2.s) !== null && _b !== void 0 ? _b : [],
            id_type: (_c = evalV2.i) !== null && _c !== void 0 ? _c : ''
        };
    }
    getConfig(name) {
        var _a, _b, _c, _d;
        const evalV2 = this._getResultFromLookup(this._values.dynamic_configs, name);
        if (!evalV2) return null;
        return {
            name: name,
            value: (_a = this._values.values[evalV2.v]) !== null && _a !== void 0 ? _a : {},
            rule_id: evalV2.r,
            secondary_exposures: (_b = evalV2.s) !== null && _b !== void 0 ? _b : [],
            id_type: (_c = evalV2.i) !== null && _c !== void 0 ? _c : '',
            is_user_in_experiment: evalV2.ue === true ? true : false,
            passed: evalV2.p === true,
            group_name: (_d = evalV2.gn) !== null && _d !== void 0 ? _d : undefined,
            is_experiment_active: evalV2.ea === true ? true : false,
            group: evalV2.r,
            is_device_based: evalV2.i === 'stableID'
        };
    }
    getLayer(name) {
        var _a, _b, _c, _d, _e, _f;
        const evalV2 = this._getResultFromLookup(this._values.layer_configs, name);
        if (!evalV2) return null;
        return {
            name: name,
            value: (_a = this._values.values[evalV2.v]) !== null && _a !== void 0 ? _a : {},
            rule_id: evalV2.r,
            secondary_exposures: (_b = evalV2.s) !== null && _b !== void 0 ? _b : [],
            is_user_in_experiment: evalV2.ue === true ? true : false,
            group_name: (_c = evalV2.gn) !== null && _c !== void 0 ? _c : undefined,
            is_experiment_active: evalV2.ea === true ? true : false,
            group: evalV2.r,
            is_device_based: evalV2.i === 'stableID',
            allocated_experiment_name: (_d = evalV2.ae) !== null && _d !== void 0 ? _d : '',
            explicit_parameters: (_e = evalV2.ep) !== null && _e !== void 0 ? _e : [],
            undelegated_secondary_exposures: (_f = evalV2.us) !== null && _f !== void 0 ? _f : [],
            parameter_rule_ids: evalV2.pr
        };
    }
    getParamStore(name) {
        return this._getResultFromLookup(this._values.param_stores, name);
    }
    getConfigList() {
        return Object.keys(this._values.dynamic_configs);
    }
    getExposureMapping() {
        return this._values.exposures;
    }
    _getResultFromLookup(lookup, name) {
        var _a, _b;
        if (!lookup) return null;
        return (_b = (_a = lookup[name]) !== null && _a !== void 0 ? _a : lookup[(0, $dtn6l._DJB2)(name)]) !== null && _b !== void 0 ? _b : null;
    }
}
module.exports.V2InitializeContainer = $2d82ca689190c304$var$V2InitializeContainer;

});


parcelRegister("e4Scn", function(module, exports) {
"use strict";
var $a3fb7b1b9752a99a$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $dtn6l = parcelRequire("dtn6l");

var $7TiGk = parcelRequire("7TiGk");
class $a3fb7b1b9752a99a$var$StatsigNetwork extends $dtn6l.NetworkCore {
    constructor(options, emitter){
        super(options, emitter);
        const config = options === null || options === void 0 ? void 0 : options.networkConfig;
        this._option = options;
        this._initializeUrlConfig = new $dtn6l.UrlConfiguration($dtn6l.Endpoint._initialize, config === null || config === void 0 ? void 0 : config.initializeUrl, config === null || config === void 0 ? void 0 : config.api, config === null || config === void 0 ? void 0 : config.initializeFallbackUrls);
    }
    fetchEvaluations(sdkKey, current, priority, user, isCacheValidFor204) {
        return $a3fb7b1b9752a99a$var$__awaiter(this, void 0, void 0, function*() {
            var _a, _b, _c, _d, _e, _f;
            const cache = current ? (0, $dtn6l._typedJsonParse)(current, 'has_updates', 'InitializeResponse') : null;
            let data = {
                user: user,
                hash: (_c = (_b = (_a = this._option) === null || _a === void 0 ? void 0 : _a.networkConfig) === null || _b === void 0 ? void 0 : _b.initializeHashAlgorithm) !== null && _c !== void 0 ? _c : 'djb2',
                deltasResponseRequested: false,
                full_checksum: null
            };
            if (cache === null || cache === void 0 ? void 0 : cache.has_updates) {
                const hasHashChanged = (cache === null || cache === void 0 ? void 0 : cache.hash_used) !== ((_f = (_e = (_d = this._option) === null || _d === void 0 ? void 0 : _d.networkConfig) === null || _e === void 0 ? void 0 : _e.initializeHashAlgorithm) !== null && _f !== void 0 ? _f : 'djb2');
                data = Object.assign(Object.assign({}, data), {
                    sinceTime: isCacheValidFor204 && !hasHashChanged ? cache.time : 0,
                    previousDerivedFields: 'derived_fields' in cache && isCacheValidFor204 ? cache.derived_fields : {},
                    deltasResponseRequested: true,
                    full_checksum: cache.full_checksum,
                    partialUserMatchSinceTime: !hasHashChanged ? cache.time : 0
                });
            }
            return this._fetchEvaluations(sdkKey, cache, data, priority);
        });
    }
    _fetchEvaluations(sdkKey, cache, data, priority) {
        return $a3fb7b1b9752a99a$var$__awaiter(this, void 0, void 0, function*() {
            var _a, _b;
            const response = yield this.post({
                sdkKey: sdkKey,
                urlConfig: this._initializeUrlConfig,
                data: data,
                retries: 2,
                isStatsigEncodable: true,
                priority: priority
            });
            if ((response === null || response === void 0 ? void 0 : response.code) === 204) return '{"has_updates": false}';
            if ((response === null || response === void 0 ? void 0 : response.code) !== 200) return (_a = response === null || response === void 0 ? void 0 : response.body) !== null && _a !== void 0 ? _a : null;
            if ((cache === null || cache === void 0 ? void 0 : cache.has_updates) !== true || ((_b = response.body) === null || _b === void 0 ? void 0 : _b.includes('"is_delta":true')) !== true || data.deltasResponseRequested !== true) return response.body;
            const result = (0, $7TiGk._resolveDeltasResponse)(cache, response.body);
            if (typeof result === 'string') return result;
            // retry without deltas
            return this._fetchEvaluations(sdkKey, cache, Object.assign(Object.assign(Object.assign({}, data), result), {
                deltasResponseRequested: false
            }), priority);
        });
    }
}
module.exports.default = $a3fb7b1b9752a99a$var$StatsigNetwork;

});
parcelRegister("7TiGk", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._resolveDeltasResponse = void 0;

var $dtn6l = parcelRequire("dtn6l");
const $5bec293bd088a842$var$MAX_DELTAS_SORT_DEPTH = 2;
function $5bec293bd088a842$var$_resolveDeltasResponse(cache, deltasString) {
    const deltas = (0, $dtn6l._typedJsonParse)(deltasString, 'checksum', 'DeltasEvaluationResponse');
    if (!deltas) return {
        hadBadDeltaChecksum: true
    };
    const merged = $5bec293bd088a842$var$_mergeDeltasIntoCache(cache, deltas);
    const resolved = $5bec293bd088a842$var$_handleDeletedEntries(merged);
    const actualChecksum = (0, $dtn6l._DJB2Object)({
        feature_gates: resolved.feature_gates,
        dynamic_configs: resolved.dynamic_configs,
        layer_configs: resolved.layer_configs
    }, $5bec293bd088a842$var$MAX_DELTAS_SORT_DEPTH);
    const isMatch = actualChecksum === deltas.checksumV2;
    if (!isMatch) return {
        hadBadDeltaChecksum: true,
        badChecksum: actualChecksum,
        badMergedConfigs: resolved,
        badFullResponse: deltas.deltas_full_response
    };
    return JSON.stringify(resolved);
}
module.exports._resolveDeltasResponse = $5bec293bd088a842$var$_resolveDeltasResponse;
function $5bec293bd088a842$var$_mergeDeltasIntoCache(cache, deltas) {
    return Object.assign(Object.assign(Object.assign({}, cache), deltas), {
        feature_gates: Object.assign(Object.assign({}, cache.feature_gates), deltas.feature_gates),
        layer_configs: Object.assign(Object.assign({}, cache.layer_configs), deltas.layer_configs),
        dynamic_configs: Object.assign(Object.assign({}, cache.dynamic_configs), deltas.dynamic_configs)
    });
}
function $5bec293bd088a842$var$_handleDeletedEntries(deltas) {
    const result = deltas;
    $5bec293bd088a842$var$_deleteEntriesInRecord(deltas.deleted_gates, result.feature_gates);
    delete result.deleted_gates;
    $5bec293bd088a842$var$_deleteEntriesInRecord(deltas.deleted_configs, result.dynamic_configs);
    delete result.deleted_configs;
    $5bec293bd088a842$var$_deleteEntriesInRecord(deltas.deleted_layers, result.layer_configs);
    delete result.deleted_layers;
    return result;
}
function $5bec293bd088a842$var$_deleteEntriesInRecord(keys, values) {
    keys === null || keys === void 0 || keys.forEach((key)=>{
        delete values[key];
    });
}

});


parcelRegister("9JsrP", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._makeParamStoreGetter = void 0;

var $dtn6l = parcelRequire("dtn6l");
const $715e622b11c913c1$var$NO_EXPOSURE_OPT = {
    disableExposureLog: true
};
function $715e622b11c913c1$var$_shouldLogExposure(options) {
    return options == null || options.disableExposureLog === false;
}
function $715e622b11c913c1$var$_shouldReturnFallback(value, fallback) {
    return fallback != null && !(0, $dtn6l._isTypeMatch)(value, fallback);
}
function $715e622b11c913c1$var$_getMappedStaticValue(param, _options) {
    return param.value;
}
function $715e622b11c913c1$var$_getMappedGateValue(client, param, options) {
    const gate = client.getFeatureGate(param.gate_name, $715e622b11c913c1$var$_shouldLogExposure(options) ? undefined : $715e622b11c913c1$var$NO_EXPOSURE_OPT);
    if (gate.value) return param.pass_value;
    return param.fail_value;
}
function $715e622b11c913c1$var$_getMappedDynamicConfigValue(client, param, fallback, options) {
    const config = client.getDynamicConfig(param.config_name, $715e622b11c913c1$var$_shouldLogExposure(options) ? undefined : $715e622b11c913c1$var$NO_EXPOSURE_OPT);
    const value = config.get(param.param_name);
    if ($715e622b11c913c1$var$_shouldReturnFallback(value, fallback)) return fallback;
    return value;
}
function $715e622b11c913c1$var$_getMappedExperimentValue(client, param, fallback, options) {
    const experiment = client.getExperiment(param.experiment_name, $715e622b11c913c1$var$_shouldLogExposure(options) ? undefined : $715e622b11c913c1$var$NO_EXPOSURE_OPT);
    const value = experiment.get(param.param_name);
    if ($715e622b11c913c1$var$_shouldReturnFallback(value, fallback)) return fallback;
    return value;
}
function $715e622b11c913c1$var$_getMappedLayerValue(client, param, fallback, options) {
    const layer = client.getLayer(param.layer_name, $715e622b11c913c1$var$_shouldLogExposure(options) ? undefined : $715e622b11c913c1$var$NO_EXPOSURE_OPT);
    const value = layer.get(param.param_name);
    if ($715e622b11c913c1$var$_shouldReturnFallback(value, fallback)) return fallback;
    return value;
}
function $715e622b11c913c1$var$_makeParamStoreGetter(client, config, options) {
    return (paramName, fallback)=>{
        if (config == null) return fallback;
        const param = config[paramName];
        if (param == null || fallback != null && (0, $dtn6l._typeOf)(fallback) !== param.param_type) return fallback;
        switch(param.ref_type){
            case 'static':
                return $715e622b11c913c1$var$_getMappedStaticValue(param, options);
            case 'gate':
                return $715e622b11c913c1$var$_getMappedGateValue(client, param, options);
            case 'dynamic_config':
                return $715e622b11c913c1$var$_getMappedDynamicConfigValue(client, param, fallback, options);
            case 'experiment':
                return $715e622b11c913c1$var$_getMappedExperimentValue(client, param, fallback, options);
            case 'layer':
                return $715e622b11c913c1$var$_getMappedLayerValue(client, param, fallback, options);
            default:
                return fallback;
        }
    };
}
module.exports._makeParamStoreGetter = $715e622b11c913c1$var$_makeParamStoreGetter;

});

parcelRegister("j6Ssa", function(module, exports) {
"use strict";
var $de98d1245d1fdec6$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.StatsigEvaluationsDataAdapter = void 0;

var $dtn6l = parcelRequire("dtn6l");

var $e4Scn = parcelRequire("e4Scn");
class $de98d1245d1fdec6$var$StatsigEvaluationsDataAdapter extends $dtn6l.DataAdapterCore {
    constructor(){
        super('EvaluationsDataAdapter', 'evaluations');
        this._network = null;
        this._options = null;
    }
    attach(sdkKey, options, network) {
        super.attach(sdkKey, options, network);
        if (network !== null && network instanceof $e4Scn.default) this._network = network;
        else this._network = new $e4Scn.default(options !== null && options !== void 0 ? options : {});
    }
    getDataAsync(current, user, options) {
        return this._getDataAsyncImpl(current, (0, $dtn6l._normalizeUser)(user, this._options), options);
    }
    prefetchData(user, options) {
        return this._prefetchDataImpl(user, options);
    }
    setData(data) {
        const values = (0, $dtn6l._typedJsonParse)(data, 'has_updates', 'data');
        if (values && 'user' in values) super.setData(data, values.user);
        else $dtn6l.Log.error('StatsigUser not found. You may be using an older server SDK version. Please upgrade your SDK or use setDataLegacy.');
    }
    setDataLegacy(data, user) {
        super.setData(data, user);
    }
    _fetchFromNetwork(current, user, options, isCacheValidFor204) {
        return $de98d1245d1fdec6$var$__awaiter(this, void 0, void 0, function*() {
            var _a;
            const result = yield (_a = this._network) === null || _a === void 0 ? void 0 : _a.fetchEvaluations(this._getSdkKey(), current, options === null || options === void 0 ? void 0 : options.priority, user, isCacheValidFor204);
            return result !== null && result !== void 0 ? result : null;
        });
    }
    _getCacheKey(user) {
        var _a;
        const key = (0, $dtn6l._getStorageKey)(this._getSdkKey(), user, (_a = this._options) === null || _a === void 0 ? void 0 : _a.customUserCacheKeyFunc);
        return `${$dtn6l.DataAdapterCachePrefix}.${this._cacheSuffix}.${key}`;
    }
    _isCachedResultValidFor204(result, user) {
        return result.fullUserHash != null && result.fullUserHash === (0, $dtn6l._getFullUserHash)(user);
    }
}
module.exports.StatsigEvaluationsDataAdapter = $de98d1245d1fdec6$var$StatsigEvaluationsDataAdapter;

});



parcelRegister("kJAvC", function(module, exports) {
$parcel$export(module.exports, "default", () => $f18454857a439bdd$export$2e2bcd8739ae039);

var $fQbYu = parcelRequire("fQbYu");

var $cHYPm = parcelRequire("cHYPm");

var $dyTr7 = parcelRequire("dyTr7");

var $hLfKH = parcelRequire("hLfKH");
function $f18454857a439bdd$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $f18454857a439bdd$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $f18454857a439bdd$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $dyTr7.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $f18454857a439bdd$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $f18454857a439bdd$export$a66cbd9b2289cd78 = '@all-features';
var $f18454857a439bdd$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function Subscriptions() {
        (0, $fQbYu.default)(this, Subscriptions);
        (0, $dyTr7.default)(this, "eventToValue", new Map());
        this.emitter = new (0, (/*@__PURE__*/$parcel$interopDefault($hLfKH)))();
    }
    return (0, $cHYPm.default)(Subscriptions, [
        {
            key: "onGateUpdated",
            value: function onGateUpdated(gateName, callback, checkGate, options) {
                var _this = this;
                var value = checkGate(gateName, $f18454857a439bdd$var$_objectSpread($f18454857a439bdd$var$_objectSpread({}, options), {}, {
                    fireGateExposure: false
                }));
                if (this.eventToValue.get(callback) === undefined) this.eventToValue.set(callback, value);
                var wrapCallback = function wrapCallback() {
                    var value = checkGate(gateName, $f18454857a439bdd$var$_objectSpread($f18454857a439bdd$var$_objectSpread({}, options), {}, {
                        fireGateExposure: false
                    }));
                    var existingValue = _this.eventToValue.get(callback);
                    if (existingValue !== value) {
                        _this.eventToValue.set(callback, value);
                        callback(value);
                    }
                };
                this.emitter.on(gateName, wrapCallback);
                return function() {
                    _this.emitter.off(gateName, wrapCallback);
                };
            }
        },
        {
            key: "onExperimentValueUpdated",
            value: function onExperimentValueUpdated(experimentName, parameterName, defaultValue, callback, getExperimentValue, options) {
                var _this2 = this;
                var experimentEventName = "".concat(experimentName, ".").concat(parameterName);
                var value = getExperimentValue(experimentName, parameterName, defaultValue, $f18454857a439bdd$var$_objectSpread($f18454857a439bdd$var$_objectSpread({}, options), {}, {
                    fireExperimentExposure: false
                }));
                if (this.eventToValue.get(callback) === undefined) this.eventToValue.set(callback, value);
                var wrapCallback = function wrapCallback() {
                    var value = getExperimentValue(experimentName, parameterName, defaultValue, $f18454857a439bdd$var$_objectSpread($f18454857a439bdd$var$_objectSpread({}, options), {}, {
                        fireExperimentExposure: false
                    }));
                    var existingValue = _this2.eventToValue.get(callback);
                    if (existingValue !== value) {
                        _this2.eventToValue.set(callback, value);
                        callback(value);
                    }
                };
                this.emitter.on(experimentEventName, wrapCallback);
                return function() {
                    _this2.emitter.off(experimentEventName, wrapCallback);
                };
            }
        },
        {
            key: "onAnyUpdated",
            value: function onAnyUpdated(callback) {
                var _this3 = this;
                this.emitter.on($f18454857a439bdd$export$a66cbd9b2289cd78, callback);
                return function() {
                    _this3.emitter.off($f18454857a439bdd$export$a66cbd9b2289cd78, callback);
                };
            }
        },
        {
            key: "anyUpdated",
            value: function anyUpdated() {
                var _this4 = this;
                this.emitter.emit($f18454857a439bdd$export$a66cbd9b2289cd78);
                this.emitter.eventNames().filter(function(name) {
                    return name !== $f18454857a439bdd$export$a66cbd9b2289cd78;
                }).forEach(function(event) {
                    _this4.emitter.emit(event);
                });
            }
        }
    ]);
}();

});
parcelRegister("hLfKH", function(module, exports) {
'use strict';
var $cee30b8789895425$var$has = Object.prototype.hasOwnProperty, $cee30b8789895425$var$prefix = '~';
/**
 * Constructor to create a storage for our `EE` objects.
 * An `Events` instance is a plain object whose properties are event names.
 *
 * @constructor
 * @private
 */ function $cee30b8789895425$var$Events() {}
//
// We try to not inherit from `Object.prototype`. In some engines creating an
// instance in this way is faster than calling `Object.create(null)` directly.
// If `Object.create(null)` is not supported we prefix the event names with a
// character to make sure that the built-in object properties are not
// overridden or used as an attack vector.
//
if (Object.create) {
    $cee30b8789895425$var$Events.prototype = Object.create(null);
    //
    // This hack is needed because the `__proto__` property is still inherited in
    // some old browsers like Android 4, iPhone 5.1, Opera 11 and Safari 5.
    //
    if (!new $cee30b8789895425$var$Events().__proto__) $cee30b8789895425$var$prefix = false;
}
/**
 * Representation of a single event listener.
 *
 * @param {Function} fn The listener function.
 * @param {*} context The context to invoke the listener with.
 * @param {Boolean} [once=false] Specify if the listener is a one-time listener.
 * @constructor
 * @private
 */ function $cee30b8789895425$var$EE(fn, context, once) {
    this.fn = fn;
    this.context = context;
    this.once = once || false;
}
/**
 * Add a listener for a given event.
 *
 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} context The context to invoke the listener with.
 * @param {Boolean} once Specify if the listener is a one-time listener.
 * @returns {EventEmitter}
 * @private
 */ function $cee30b8789895425$var$addListener(emitter, event, fn, context, once) {
    if (typeof fn !== 'function') throw new TypeError('The listener must be a function');
    var listener = new $cee30b8789895425$var$EE(fn, context || emitter, once), evt = $cee30b8789895425$var$prefix ? $cee30b8789895425$var$prefix + event : event;
    if (!emitter._events[evt]) emitter._events[evt] = listener, emitter._eventsCount++;
    else if (!emitter._events[evt].fn) emitter._events[evt].push(listener);
    else emitter._events[evt] = [
        emitter._events[evt],
        listener
    ];
    return emitter;
}
/**
 * Clear event by name.
 *
 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
 * @param {(String|Symbol)} evt The Event name.
 * @private
 */ function $cee30b8789895425$var$clearEvent(emitter, evt) {
    if (--emitter._eventsCount === 0) emitter._events = new $cee30b8789895425$var$Events();
    else delete emitter._events[evt];
}
/**
 * Minimal `EventEmitter` interface that is molded against the Node.js
 * `EventEmitter` interface.
 *
 * @constructor
 * @public
 */ function $cee30b8789895425$var$EventEmitter() {
    this._events = new $cee30b8789895425$var$Events();
    this._eventsCount = 0;
}
/**
 * Return an array listing the events for which the emitter has registered
 * listeners.
 *
 * @returns {Array}
 * @public
 */ $cee30b8789895425$var$EventEmitter.prototype.eventNames = function eventNames() {
    var names = [], events, name;
    if (this._eventsCount === 0) return names;
    for(name in events = this._events)if ($cee30b8789895425$var$has.call(events, name)) names.push($cee30b8789895425$var$prefix ? name.slice(1) : name);
    if (Object.getOwnPropertySymbols) return names.concat(Object.getOwnPropertySymbols(events));
    return names;
};
/**
 * Return the listeners registered for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Array} The registered listeners.
 * @public
 */ $cee30b8789895425$var$EventEmitter.prototype.listeners = function listeners(event) {
    var evt = $cee30b8789895425$var$prefix ? $cee30b8789895425$var$prefix + event : event, handlers = this._events[evt];
    if (!handlers) return [];
    if (handlers.fn) return [
        handlers.fn
    ];
    for(var i = 0, l = handlers.length, ee = new Array(l); i < l; i++)ee[i] = handlers[i].fn;
    return ee;
};
/**
 * Return the number of listeners listening to a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Number} The number of listeners.
 * @public
 */ $cee30b8789895425$var$EventEmitter.prototype.listenerCount = function listenerCount(event) {
    var evt = $cee30b8789895425$var$prefix ? $cee30b8789895425$var$prefix + event : event, listeners = this._events[evt];
    if (!listeners) return 0;
    if (listeners.fn) return 1;
    return listeners.length;
};
/**
 * Calls each of the listeners registered for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Boolean} `true` if the event had listeners, else `false`.
 * @public
 */ $cee30b8789895425$var$EventEmitter.prototype.emit = function emit(event, a1, a2, a3, a4, a5) {
    var evt = $cee30b8789895425$var$prefix ? $cee30b8789895425$var$prefix + event : event;
    if (!this._events[evt]) return false;
    var listeners = this._events[evt], len = arguments.length, args, i;
    if (listeners.fn) {
        if (listeners.once) this.removeListener(event, listeners.fn, undefined, true);
        switch(len){
            case 1:
                return listeners.fn.call(listeners.context), true;
            case 2:
                return listeners.fn.call(listeners.context, a1), true;
            case 3:
                return listeners.fn.call(listeners.context, a1, a2), true;
            case 4:
                return listeners.fn.call(listeners.context, a1, a2, a3), true;
            case 5:
                return listeners.fn.call(listeners.context, a1, a2, a3, a4), true;
            case 6:
                return listeners.fn.call(listeners.context, a1, a2, a3, a4, a5), true;
        }
        for(i = 1, args = new Array(len - 1); i < len; i++)args[i - 1] = arguments[i];
        listeners.fn.apply(listeners.context, args);
    } else {
        var length = listeners.length, j;
        for(i = 0; i < length; i++){
            if (listeners[i].once) this.removeListener(event, listeners[i].fn, undefined, true);
            switch(len){
                case 1:
                    listeners[i].fn.call(listeners[i].context);
                    break;
                case 2:
                    listeners[i].fn.call(listeners[i].context, a1);
                    break;
                case 3:
                    listeners[i].fn.call(listeners[i].context, a1, a2);
                    break;
                case 4:
                    listeners[i].fn.call(listeners[i].context, a1, a2, a3);
                    break;
                default:
                    if (!args) for(j = 1, args = new Array(len - 1); j < len; j++)args[j - 1] = arguments[j];
                    listeners[i].fn.apply(listeners[i].context, args);
            }
        }
    }
    return true;
};
/**
 * Add a listener for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @public
 */ $cee30b8789895425$var$EventEmitter.prototype.on = function on(event, fn, context) {
    return $cee30b8789895425$var$addListener(this, event, fn, context, false);
};
/**
 * Add a one-time listener for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @public
 */ $cee30b8789895425$var$EventEmitter.prototype.once = function once(event, fn, context) {
    return $cee30b8789895425$var$addListener(this, event, fn, context, true);
};
/**
 * Remove the listeners of a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn Only remove the listeners that match this function.
 * @param {*} context Only remove the listeners that have this context.
 * @param {Boolean} once Only remove one-time listeners.
 * @returns {EventEmitter} `this`.
 * @public
 */ $cee30b8789895425$var$EventEmitter.prototype.removeListener = function removeListener(event, fn, context, once) {
    var evt = $cee30b8789895425$var$prefix ? $cee30b8789895425$var$prefix + event : event;
    if (!this._events[evt]) return this;
    if (!fn) {
        $cee30b8789895425$var$clearEvent(this, evt);
        return this;
    }
    var listeners = this._events[evt];
    if (listeners.fn) {
        if (listeners.fn === fn && (!once || listeners.once) && (!context || listeners.context === context)) $cee30b8789895425$var$clearEvent(this, evt);
    } else {
        for(var i = 0, events = [], length = listeners.length; i < length; i++)if (listeners[i].fn !== fn || once && !listeners[i].once || context && listeners[i].context !== context) events.push(listeners[i]);
        //
        // Reset the array, or remove it completely if we have no more listeners.
        //
        if (events.length) this._events[evt] = events.length === 1 ? events[0] : events;
        else $cee30b8789895425$var$clearEvent(this, evt);
    }
    return this;
};
/**
 * Remove all listeners, or those of the specified event.
 *
 * @param {(String|Symbol)} [event] The event name.
 * @returns {EventEmitter} `this`.
 * @public
 */ $cee30b8789895425$var$EventEmitter.prototype.removeAllListeners = function removeAllListeners(event) {
    var evt;
    if (event) {
        evt = $cee30b8789895425$var$prefix ? $cee30b8789895425$var$prefix + event : event;
        if (this._events[evt]) $cee30b8789895425$var$clearEvent(this, evt);
    } else {
        this._events = new $cee30b8789895425$var$Events();
        this._eventsCount = 0;
    }
    return this;
};
//
// Alias methods names because people roll like that.
//
$cee30b8789895425$var$EventEmitter.prototype.off = $cee30b8789895425$var$EventEmitter.prototype.removeListener;
$cee30b8789895425$var$EventEmitter.prototype.addListener = $cee30b8789895425$var$EventEmitter.prototype.on;
//
// Expose the prefix.
//
$cee30b8789895425$var$EventEmitter.prefixed = $cee30b8789895425$var$prefix;
//
// Allow `EventEmitter` to be imported as module namespace.
//
$cee30b8789895425$var$EventEmitter.EventEmitter = $cee30b8789895425$var$EventEmitter;
module.exports = $cee30b8789895425$var$EventEmitter;

});


parcelRegister("bA77O", function(module, exports) {
$parcel$export(module.exports, "DynamicConfig", () => $86e895649208ddeb$export$6dc24881a3d96325);

var $hs8hh = parcelRequire("hs8hh");

var $fQbYu = parcelRequire("fQbYu");

var $cHYPm = parcelRequire("cHYPm");

var $jGAYn = parcelRequire("jGAYn");
var $86e895649208ddeb$export$6dc24881a3d96325 = /*#__PURE__*/ function() {
    function DynamicConfig(configName, configValue, ruleID, evaluationDetails) {
        var secondaryExposures = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : [];
        var allocatedExperimentName = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : '';
        var onDefaultValueFallback = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : null;
        (0, $fQbYu.default)(this, DynamicConfig);
        this.value = configValue;
        this._name = configName;
        this._ruleID = ruleID;
        this._secondaryExposures = secondaryExposures;
        this._allocatedExperimentName = allocatedExperimentName;
        this._evaluationDetails = evaluationDetails;
        this._onDefaultValueFallback = onDefaultValueFallback;
    }
    return (0, $cHYPm.default)(DynamicConfig, [
        {
            key: "get",
            value: function get(key, defaultValue, typeGuard) {
                var _this$_onDefaultValue2;
                var val = this.getValue(key, defaultValue);
                if (val == null) return defaultValue;
                var expectedType = Array.isArray(defaultValue) ? 'array' : (0, $hs8hh.default)(defaultValue);
                var actualType = Array.isArray(val) ? 'array' : (0, $hs8hh.default)(val);
                if (typeGuard) {
                    var _this$_onDefaultValue;
                    if (typeGuard(val)) {
                        this.fireExposure(key);
                        return val;
                    }
                    (_this$_onDefaultValue = this._onDefaultValueFallback) === null || _this$_onDefaultValue === void 0 || _this$_onDefaultValue.call(this, this, key, expectedType, actualType);
                    return defaultValue;
                }
                if (defaultValue == null || expectedType === actualType) {
                    this.fireExposure(key);
                    return val;
                }
                (_this$_onDefaultValue2 = this._onDefaultValueFallback) === null || _this$_onDefaultValue2 === void 0 || _this$_onDefaultValue2.call(this, this, key, expectedType, actualType);
                return defaultValue;
            }
        },
        {
            key: "getValue",
            value: function getValue(key, defaultValue) {
                if (key == null) return this.value;
                if (defaultValue == null) defaultValue = null;
                if (this.value[key] == null) return defaultValue;
                this.fireExposure(key);
                return this.value[key];
            }
        },
        {
            key: "fireExposure",
            value: function fireExposure(key) {
                // Call the wrapped experiment's get method to fire exposure
                if (this.experiment) this.experiment.get(key);
            }
        }
    ], [
        {
            key: "fromExperiment",
            value: function fromExperiment(experiment) {
                var _experiment$__evaluat, _experiment$__evaluat2, _experiment$groupName;
                var config = new DynamicConfig(experiment.name, experiment.value, experiment.ruleID, (0, $jGAYn.migrateEvaluationDetails)(experiment.details), (0, $jGAYn.migrateSecondaryExposures)((_experiment$__evaluat = (_experiment$__evaluat2 = experiment.__evaluation) === null || _experiment$__evaluat2 === void 0 ? void 0 : _experiment$__evaluat2.secondary_exposures) !== null && _experiment$__evaluat !== void 0 ? _experiment$__evaluat : []), (_experiment$groupName = experiment.groupName) !== null && _experiment$groupName !== void 0 ? _experiment$groupName : undefined);
                config.experiment = experiment;
                return config;
            }
        }
    ]);
}();

});
parcelRegister("jGAYn", function(module, exports) {
$parcel$export(module.exports, "getOptionsWithDefaults", () => $e54e9e9d69b6dd52$export$d119b37e5f788b43);
$parcel$export(module.exports, "shallowEquals", () => $e54e9e9d69b6dd52$export$fa1c2bbf4100b8bc);
$parcel$export(module.exports, "toStatsigUser", () => $e54e9e9d69b6dd52$export$3dad1db244472f32);
$parcel$export(module.exports, "deepAssign", () => $e54e9e9d69b6dd52$export$1148cb79ceecd5fa);
$parcel$export(module.exports, "migrateInitializationOptions", () => $e54e9e9d69b6dd52$export$202946b690d26d22);
$parcel$export(module.exports, "migrateEvaluationDetails", () => $e54e9e9d69b6dd52$export$18ad168d3dbac899);
$parcel$export(module.exports, "migrateSecondaryExposures", () => $e54e9e9d69b6dd52$export$55fd683752d01e67);

var $hs8hh = parcelRequire("hs8hh");

var $5IFAA = parcelRequire("5IFAA");

var $b8P2v = parcelRequire("b8P2v");

var $94GB8 = parcelRequire("94GB8");

var $dyTr7 = parcelRequire("dyTr7");

var $iKk24 = parcelRequire("iKk24");

var $icCTV = parcelRequire("icCTV");

var $cXGvu = parcelRequire("cXGvu");
var $e54e9e9d69b6dd52$var$_excluded = [
    "stableId"
], $e54e9e9d69b6dd52$var$_excluded2 = [
    "api",
    "disableCurrentPageLogging",
    "loggingIntervalMillis",
    "loggingBufferMaxSize",
    "localMode",
    "eventLoggingApi",
    "eventLoggingApiForRetries",
    "disableLocalStorage",
    "ignoreWindowUndefined",
    "disableAllLogging",
    "initTimeoutMs",
    "disableNetworkKeepalive",
    "overrideStableID",
    "disableErrorLogging",
    "disableAutoMetricsLogging"
];
function $e54e9e9d69b6dd52$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $e54e9e9d69b6dd52$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $e54e9e9d69b6dd52$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $dyTr7.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $e54e9e9d69b6dd52$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $e54e9e9d69b6dd52$export$d119b37e5f788b43 = function getOptionsWithDefaults(options) {
    return $e54e9e9d69b6dd52$var$_objectSpread({
        /**
     * If more federal PerimeterTypes are added in the future, this should be updated so
     * that isFedRamp() === true always returns the strictest perimeter.
     */ perimeter: (0, $iKk24.isFedRamp)() ? (0, $cXGvu.PerimeterType).FEDRAMP_MODERATE : (0, $cXGvu.PerimeterType).COMMERCIAL
    }, options);
};
var $e54e9e9d69b6dd52$export$fa1c2bbf4100b8bc = function shallowEquals(objectA, objectB) {
    if (!objectA && !objectB) return true;
    if (!objectA || !objectB) return false;
    var aEntries = Object.entries(objectA);
    var bEntries = Object.entries(objectB);
    if (aEntries.length !== bEntries.length) return false;
    var ascendingKeyOrder = function ascendingKeyOrder(_ref, _ref2) {
        var _ref3 = (0, $94GB8.default)(_ref, 1), key1 = _ref3[0];
        var _ref4 = (0, $94GB8.default)(_ref2, 1), key2 = _ref4[0];
        return key1.localeCompare(key2);
    };
    aEntries.sort(ascendingKeyOrder);
    bEntries.sort(ascendingKeyOrder);
    for(var i = 0; i < aEntries.length; i++){
        var _aEntries$i = (0, $94GB8.default)(aEntries[i], 2), aValue = _aEntries$i[1];
        var _bEntries$i = (0, $94GB8.default)(bEntries[i], 2), bValue = _bEntries$i[1];
        if (aValue !== bValue) return false;
    }
    return true;
};
var $e54e9e9d69b6dd52$export$3dad1db244472f32 = function toStatsigUser(identifiers, customAttributes) {
    // Re-map `stableId` to `stableID` to match Statsig's native type.
    var stableId = identifiers.stableId, otherIdentifiers = (0, $b8P2v.default)(identifiers, $e54e9e9d69b6dd52$var$_excluded);
    var user = {
        customIDs: $e54e9e9d69b6dd52$var$_objectSpread($e54e9e9d69b6dd52$var$_objectSpread({}, otherIdentifiers), stableId !== undefined ? {
            stableID: stableId
        } : {}),
        custom: customAttributes
    };
    if (identifiers.atlassianAccountId) user.userID = identifiers.atlassianAccountId;
    return user;
};
function $e54e9e9d69b6dd52$export$1148cb79ceecd5fa(target) {
    for(var _len = arguments.length, sources = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)sources[_key - 1] = arguments[_key];
    if (!sources.length) return target;
    var source = sources.shift();
    if (source === undefined || source === null) return $e54e9e9d69b6dd52$export$1148cb79ceecd5fa.apply(void 0, [
        target
    ].concat((0, $5IFAA.default)(sources)));
    for(var _i = 0, _Object$entries = Object.entries(source); _i < _Object$entries.length; _i++){
        var _Object$entries$_i = (0, $94GB8.default)(_Object$entries[_i], 2), key = _Object$entries$_i[0], src = _Object$entries$_i[1];
        var dst = target[key];
        var srcIsObj = src && (0, $hs8hh.default)(src) === 'object' && !Array.isArray(src);
        var dstIsObj = dst && (0, $hs8hh.default)(dst) === 'object' && !Array.isArray(dst);
        if (srcIsObj && dstIsObj) target[key] = $e54e9e9d69b6dd52$export$1148cb79ceecd5fa(dst, src);
        else target[key] = src;
    }
    return $e54e9e9d69b6dd52$export$1148cb79ceecd5fa.apply(void 0, [
        target
    ].concat((0, $5IFAA.default)(sources)));
}
var $e54e9e9d69b6dd52$export$202946b690d26d22 = function migrateInitializationOptions(options) {
    var api = options.api, disableCurrentPageLogging = options.disableCurrentPageLogging, loggingIntervalMillis = options.loggingIntervalMillis, loggingBufferMaxSize = options.loggingBufferMaxSize, localMode = options.localMode, eventLoggingApi = options.eventLoggingApi, eventLoggingApiForRetries = options.eventLoggingApiForRetries, disableLocalStorage = options.disableLocalStorage, ignoreWindowUndefined = options.ignoreWindowUndefined, disableAllLogging = options.disableAllLogging, _initTimeoutMs = options.initTimeoutMs, _disableNetworkKeepalive = options.disableNetworkKeepalive, _overrideStableID = options.overrideStableID, _disableErrorLogging = options.disableErrorLogging, _disableAutoMetricsLogging = options.disableAutoMetricsLogging, rest = (0, $b8P2v.default)(options, $e54e9e9d69b6dd52$var$_excluded2);
    return $e54e9e9d69b6dd52$var$_objectSpread($e54e9e9d69b6dd52$var$_objectSpread({}, rest), {}, {
        networkConfig: {
            api: api,
            logEventUrl: eventLoggingApi ? eventLoggingApi + 'rgstr' : undefined,
            logEventFallbackUrls: eventLoggingApiForRetries ? [
                eventLoggingApiForRetries
            ] : undefined,
            preventAllNetworkTraffic: localMode || !ignoreWindowUndefined && typeof window === 'undefined'
        },
        includeCurrentPageUrlWithEvents: !disableCurrentPageLogging,
        loggingIntervalMs: loggingIntervalMillis,
        loggingBufferMaxSize: loggingBufferMaxSize,
        disableStorage: disableLocalStorage === undefined ? localMode : disableLocalStorage,
        disableLogging: disableAllLogging === undefined ? localMode : disableAllLogging
    });
};
var $e54e9e9d69b6dd52$var$evaluationReasonMappings = Object.entries((0, $icCTV.EvaluationReason)).map(function(_ref5) {
    var _ref6 = (0, $94GB8.default)(_ref5, 2), key = _ref6[0], value = _ref6[1];
    return [
        key.toLowerCase(),
        value
    ];
});
var $e54e9e9d69b6dd52$export$18ad168d3dbac899 = function migrateEvaluationDetails(details) {
    var _evaluationReasonMapp, _evaluationReasonMapp2, _details$receivedAt;
    var reasonLower = details.reason.toLowerCase();
    return {
        reason: (_evaluationReasonMapp = (_evaluationReasonMapp2 = $e54e9e9d69b6dd52$var$evaluationReasonMappings.find(function(_ref7) {
            var _ref8 = (0, $94GB8.default)(_ref7, 1), key = _ref8[0];
            return reasonLower.includes(key);
        })) === null || _evaluationReasonMapp2 === void 0 ? void 0 : _evaluationReasonMapp2[1]) !== null && _evaluationReasonMapp !== void 0 ? _evaluationReasonMapp : (0, $icCTV.EvaluationReason).Unknown,
        time: (_details$receivedAt = details.receivedAt) !== null && _details$receivedAt !== void 0 ? _details$receivedAt : Date.now()
    };
};
var $e54e9e9d69b6dd52$export$55fd683752d01e67 = function migrateSecondaryExposures(secondaryExposures) {
    return secondaryExposures.map(function(exposure) {
        if (typeof exposure === 'string') // This should ideally have gateValue and ruleID fields too, but it's not possible for us
        // to determine the correct values for these.
        return {
            gate: exposure
        };
        return exposure;
    });
};

});
parcelRegister("5IFAA", function(module, exports) {
$parcel$export(module.exports, "default", () => $42a1528a0378a99a$export$2e2bcd8739ae039);

var $6ZU0a = parcelRequire("6ZU0a");

var $6Ertf = parcelRequire("6Ertf");

var $7pQFh = parcelRequire("7pQFh");

var $7n064 = parcelRequire("7n064");
function $42a1528a0378a99a$export$2e2bcd8739ae039(r) {
    return (0, $6ZU0a.default)(r) || (0, $6Ertf.default)(r) || (0, $7pQFh.default)(r) || (0, $7n064.default)();
}

});
parcelRegister("6ZU0a", function(module, exports) {
$parcel$export(module.exports, "default", () => $5183e15a47b03249$export$2e2bcd8739ae039);

var $2fgnB = parcelRequire("2fgnB");
function $5183e15a47b03249$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return (0, $2fgnB.default)(r);
}

});

parcelRegister("6Ertf", function(module, exports) {
$parcel$export(module.exports, "default", () => $4d7bc99cef37c426$export$2e2bcd8739ae039);
function $4d7bc99cef37c426$export$2e2bcd8739ae039(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}

});

parcelRegister("7n064", function(module, exports) {
$parcel$export(module.exports, "default", () => $55dac19ef62ec80b$export$2e2bcd8739ae039);
function $55dac19ef62ec80b$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});


parcelRegister("iKk24", function(module, exports) {
$parcel$export(module.exports, "isFedRamp", () => $da5c0fe6d91df387$export$64d6499adf9b2e51);

var $6ZY6s = parcelRequire("6ZY6s");
function $da5c0fe6d91df387$export$64d6499adf9b2e51() {
    var _global$location;
    var global = globalThis;
    // MICROS_PERIMETER is already used by few products, so we need to keep it for backward compatibility
    var env = global.MICROS_PERIMETER || global.UNSAFE_ATL_CONTEXT_BOUNDARY;
    if (env) return env === (0, $6ZY6s.FEDRAMP_MODERATE);
    var matches = (_global$location = global.location) === null || _global$location === void 0 || (_global$location = _global$location.hostname) === null || _global$location === void 0 ? void 0 : _global$location.match(/atlassian-us-gov-mod\.(com|net)|atlassian-us-gov\.(com|net)|atlassian-fex\.(com|net)|atlassian-stg-fedm\.(com|net)/);
    return matches ? matches.length > 0 : false;
}

});
parcelRegister("6ZY6s", function(module, exports) {
$parcel$export(module.exports, "FEDRAMP_MODERATE", () => $51870fd29f635ef0$export$ce553301d55c2fd8);
var $51870fd29f635ef0$export$ce553301d55c2fd8 = 'fedramp-moderate';
var $51870fd29f635ef0$export$f005e2e9f707cb5f = 'commercial';
var $51870fd29f635ef0$export$bd6b5a7802d76127 = 'fedramp-fedex';
var $51870fd29f635ef0$export$a739cd5aac835909 = 'stg';
var $51870fd29f635ef0$export$42dd0cdd351a4a9 = 'prod';
var $51870fd29f635ef0$export$404582bc18fe4d9e = 'dev';

});


parcelRegister("icCTV", function(module, exports) {
$parcel$export(module.exports, "EvaluationReason", () => $d40785e450291118$export$c62558b199e46828);
// Reference: https://github.com/statsig-io/js-lite/blob/main/src/StatsigStore.ts
var $d40785e450291118$export$c62558b199e46828 = {
    // Order is important since the logic for migrating from a new client reason to an old one
    // returns the first which is a substring of the new client reason
    Error: 'Error',
    LocalOverride: 'LocalOverride',
    Unrecognized: 'Unrecognized',
    Uninitialized: 'Uninitialized',
    NetworkNotModified: 'NetworkNotModified',
    Network: 'Network',
    InvalidBootstrap: 'InvalidBootstrap',
    Bootstrap: 'Bootstrap',
    Cache: 'Cache',
    // For when we could not migrate the reason from the new client
    Unknown: 'Unknown'
}; // Reference: https://github.com/statsig-io/js-lite/blob/main/src/StatsigSDKOptions.ts

});

parcelRegister("cXGvu", function(module, exports) {
$parcel$export(module.exports, "FeatureGateEnvironment", () => $96fbf7b5c7e04efa$export$479e7351a733299);
$parcel$export(module.exports, "PerimeterType", () => $96fbf7b5c7e04efa$export$c42b7bbc5e7ba555);
/**
 * The identifiers for the user. Options are restricted to the set that is currently supported.
 */ /**
 * Base client options. Does not include any options specific to providers
 * @interface BaseClientOptions
 * @property {FeatureGateEnvironment} environment - The environment for the client.
 * @property {string} targetApp - The target app for the client.
 * @property {AnalyticsWebClient} analyticsWebClient - The analytics web client.
 * @property {PerimeterType} perimeter - The perimeter for the client.
 */ /**
 * The options for the client.
 * @interface ClientOptions
 * @extends {BaseClientOptions}
 * @property {string} apiKey - The API key for the client.
 * @property {fetchTimeoutMs} fetchTimeoutMs - The timeout for the fetch request in milliseconds. Defaults to 5000.
 * @property {boolean} useGatewayURL - Whether to use the gateway URL. Defaults to false.
 */ /**
 * The custom attributes for the user.
 */ var $96fbf7b5c7e04efa$export$479e7351a733299 = {
    Development: 'development',
    Staging: 'staging',
    Production: 'production'
};
var $96fbf7b5c7e04efa$export$c42b7bbc5e7ba555 = {
    COMMERCIAL: 'commercial',
    FEDRAMP_MODERATE: 'fedramp-moderate'
};
var $96fbf7b5c7e04efa$export$42f4885608027d0c = 'non_boolean'; // Type magic to get the JSDoc comments from the Client class methods to appear on the static
 // methods in FeatureGates where the property name and function type are identical

});



parcelRegister("gFo6M", function(module, exports) {
$parcel$export(module.exports, "Layer", () => $c2232d11a9592b0d$export$936d0764594b6eb3);

var $hs8hh = parcelRequire("hs8hh");

var $fQbYu = parcelRequire("fQbYu");

var $cHYPm = parcelRequire("cHYPm");

var $jGAYn = parcelRequire("jGAYn");
var $c2232d11a9592b0d$export$936d0764594b6eb3 = /*#__PURE__*/ function() {
    function Layer(name, layerValue, ruleID, evaluationDetails) {
        var logParameterFunction = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;
        var secondaryExposures = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : [];
        var undelegatedSecondaryExposures = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : [];
        var allocatedExperimentName = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : '';
        var explicitParameters = arguments.length > 8 && arguments[8] !== undefined ? arguments[8] : [];
        (0, $fQbYu.default)(this, Layer);
        this._logParameterFunction = logParameterFunction;
        this._name = name;
        this._value = JSON.parse(JSON.stringify(layerValue !== null && layerValue !== void 0 ? layerValue : {}));
        this._ruleID = ruleID !== null && ruleID !== void 0 ? ruleID : '';
        this._evaluationDetails = evaluationDetails;
        this._secondaryExposures = secondaryExposures;
        this._undelegatedSecondaryExposures = undelegatedSecondaryExposures;
        this._allocatedExperimentName = allocatedExperimentName;
        this._explicitParameters = explicitParameters;
    }
    return (0, $cHYPm.default)(Layer, [
        {
            key: "get",
            value: function get(key, defaultValue, typeGuard) {
                var _this = this;
                var val = this._value[key];
                if (val == null) return defaultValue;
                var logAndReturn = function logAndReturn() {
                    _this._logLayerParameterExposure(key);
                    return val;
                };
                if (typeGuard) return typeGuard(val) ? logAndReturn() : defaultValue;
                if (defaultValue == null) return logAndReturn();
                if ((0, $hs8hh.default)(val) === (0, $hs8hh.default)(defaultValue) && Array.isArray(defaultValue) === Array.isArray(val)) return logAndReturn();
                return defaultValue;
            }
        },
        {
            key: "getValue",
            value: function getValue(key, defaultValue) {
                // eslint-disable-next-line eqeqeq
                if (defaultValue == undefined) defaultValue = null;
                var val = this._value[key];
                if (val != null) this._logLayerParameterExposure(key);
                return val !== null && val !== void 0 ? val : defaultValue;
            }
        },
        {
            key: "_logLayerParameterExposure",
            value: function _logLayerParameterExposure(parameterName) {
                var _this$_logParameterFu;
                (_this$_logParameterFu = this._logParameterFunction) === null || _this$_logParameterFu === void 0 || _this$_logParameterFu.call(this, this, parameterName);
            }
        }
    ], [
        {
            key: "fromLayer",
            value: function fromLayer(layer) {
                var _layer$__evaluation$s, _layer$__evaluation, _layer$__evaluation$u, _layer$__evaluation2, _layer$__evaluation3, _layer$__evaluation4;
                var value = new Layer(layer.name, layer.__value, layer.ruleID, (0, $jGAYn.migrateEvaluationDetails)(layer.details), function(_layer, parameterName) {
                    return layer.get(parameterName);
                }, (0, $jGAYn.migrateSecondaryExposures)((_layer$__evaluation$s = (_layer$__evaluation = layer.__evaluation) === null || _layer$__evaluation === void 0 ? void 0 : _layer$__evaluation.secondary_exposures) !== null && _layer$__evaluation$s !== void 0 ? _layer$__evaluation$s : []), (0, $jGAYn.migrateSecondaryExposures)((_layer$__evaluation$u = (_layer$__evaluation2 = layer.__evaluation) === null || _layer$__evaluation2 === void 0 ? void 0 : _layer$__evaluation2.undelegated_secondary_exposures) !== null && _layer$__evaluation$u !== void 0 ? _layer$__evaluation$u : []), (_layer$__evaluation3 = layer.__evaluation) === null || _layer$__evaluation3 === void 0 ? void 0 : _layer$__evaluation3.allocated_experiment_name, (_layer$__evaluation4 = layer.__evaluation) === null || _layer$__evaluation4 === void 0 ? void 0 : _layer$__evaluation4.explicit_parameters);
                return value;
            }
        }
    ]);
}();

});

parcelRegister("f9px2", function(module, exports) {
$parcel$export(module.exports, "default", () => $b07b8065f46b75ac$export$2e2bcd8739ae039);

var $dyTr7 = parcelRequire("dyTr7");

var $jt440 = parcelRequire("jt440");

var $fQbYu = parcelRequire("fQbYu");

var $cHYPm = parcelRequire("cHYPm");

var $1KMt7 = parcelRequire("1KMt7");

var $cXGvu = parcelRequire("cXGvu");

var $6WhoI = parcelRequire("6WhoI");

var $5otRh = parcelRequire("5otRh");
function $b07b8065f46b75ac$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $b07b8065f46b75ac$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $b07b8065f46b75ac$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $dyTr7.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $b07b8065f46b75ac$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $b07b8065f46b75ac$var$DEFAULT_REQUEST_TIMEOUT_MS = 5000;
var $b07b8065f46b75ac$export$250a58ecde616daa = 'https://api.atlassian.com/flags';
var $b07b8065f46b75ac$export$942ba04389b0d5a2 = 'https://api.stg.atlassian.com/flags';
var $b07b8065f46b75ac$export$f058dbf75c3bc647 = 'https://api.dev.atlassian.com/flags';
var $b07b8065f46b75ac$export$1a401a0da8da3565 = 'https://api.stg.atlassian-us-gov-mod.com/flags';
var $b07b8065f46b75ac$export$18c93900db9358a4 = 'https://api.atlassian-us-gov-mod.com/flags';
var $b07b8065f46b75ac$export$4e8a0415edbfa1f7 = 'https://atlassian-statsig-proxy-archetype.atl-paas.%s.atl-ic.net';
var $b07b8065f46b75ac$export$cb3cd156f70d7e94 = 'oasis-stg.com/flags';
var $b07b8065f46b75ac$export$921fbc6cdfd4eee0 = 'atlassian-isolated.net/flags';
var $b07b8065f46b75ac$export$450bd8fb2a6d7ace = '/gateway/api/flags';
var $b07b8065f46b75ac$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function Fetcher() {
        (0, $fQbYu.default)(this, Fetcher);
    }
    return (0, $cHYPm.default)(Fetcher, null, [
        {
            key: "fetchClientSdk",
            value: function() {
                var _fetchClientSdk = (0, $jt440.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1KMt7))).mark(function _callee(fetcherOptions) {
                    var targetApp, url, _t;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($1KMt7))).wrap(function(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                targetApp = fetcherOptions.targetApp;
                                url = "/api/v2/frontend/clientSdkKey/".concat(targetApp);
                                _context.prev = 1;
                                _context.next = 2;
                                return this.fetchRequest(url, 'GET', fetcherOptions);
                            case 2:
                                return _context.abrupt("return", _context.sent);
                            case 3:
                                _context.prev = 3;
                                _t = _context["catch"](1);
                                if (!(_t instanceof Error)) {
                                    _context.next = 4;
                                    break;
                                }
                                throw _t;
                            case 4:
                                throw Error('Failed to retrieve client sdk key');
                            case 5:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee, this, [
                        [
                            1,
                            3
                        ]
                    ]);
                }));
                function fetchClientSdk(_x) {
                    return _fetchClientSdk.apply(this, arguments);
                }
                return fetchClientSdk;
            }()
        },
        {
            key: "fetchExperimentValues",
            value: function() {
                var _fetchExperimentValues = (0, $jt440.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1KMt7))).mark(function _callee2(fetcherOptions, identifiers, customAttributes) {
                    var requestBody, _t2;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($1KMt7))).wrap(function(_context2) {
                        while(true)switch(_context2.prev = _context2.next){
                            case 0:
                                requestBody = {
                                    identifiers: identifiers,
                                    customAttributes: customAttributes,
                                    targetApp: fetcherOptions.targetApp
                                };
                                _context2.prev = 1;
                                _context2.next = 2;
                                return this.fetchRequest('/api/v2/frontend/experimentValues', 'POST', fetcherOptions, requestBody);
                            case 2:
                                return _context2.abrupt("return", _context2.sent);
                            case 3:
                                _context2.prev = 3;
                                _t2 = _context2["catch"](1);
                                if (!(_t2 instanceof Error)) {
                                    _context2.next = 4;
                                    break;
                                }
                                throw _t2;
                            case 4:
                                throw Error('Failed to retrieve experiment values');
                            case 5:
                            case "end":
                                return _context2.stop();
                        }
                    }, _callee2, this, [
                        [
                            1,
                            3
                        ]
                    ]);
                }));
                function fetchExperimentValues(_x2, _x3, _x4) {
                    return _fetchExperimentValues.apply(this, arguments);
                }
                return fetchExperimentValues;
            }()
        },
        {
            key: "handleResponseError",
            value: function() {
                var _handleResponseError = (0, $jt440.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1KMt7))).mark(function _callee3(response) {
                    var body;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($1KMt7))).wrap(function(_context3) {
                        while(true)switch(_context3.prev = _context3.next){
                            case 0:
                                if (response.ok) {
                                    _context3.next = 2;
                                    break;
                                }
                                _context3.next = 1;
                                return response.text();
                            case 1:
                                body = _context3.sent;
                                throw new (0, $5otRh.ResponseError)("Non 2xx response status received, status: ".concat(response.status, ", body: ").concat(JSON.stringify(body)));
                            case 2:
                                if (!(response.status === 204)) {
                                    _context3.next = 3;
                                    break;
                                }
                                throw new (0, $5otRh.ResponseError)('Unexpected 204 response');
                            case 3:
                            case "end":
                                return _context3.stop();
                        }
                    }, _callee3);
                }));
                function handleResponseError(_x5) {
                    return _handleResponseError.apply(this, arguments);
                }
                return handleResponseError;
            }()
        },
        {
            key: "extractResponseBody",
            value: function() {
                var _extractResponseBody = (0, $jt440.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1KMt7))).mark(function _callee4(response) {
                    var value;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($1KMt7))).wrap(function(_context4) {
                        while(true)switch(_context4.prev = _context4.next){
                            case 0:
                                _context4.next = 1;
                                return response.text();
                            case 1:
                                value = _context4.sent;
                                return _context4.abrupt("return", JSON.parse(value));
                            case 2:
                            case "end":
                                return _context4.stop();
                        }
                    }, _callee4);
                }));
                function extractResponseBody(_x6) {
                    return _extractResponseBody.apply(this, arguments);
                }
                return extractResponseBody;
            }()
        },
        {
            key: "getBaseUrl",
            value: function getBaseUrl(serviceEnv) {
                var useGatewayUrl = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
                var perimeter = arguments.length > 2 ? arguments[2] : undefined;
                var isolationContextId = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
                if (useGatewayUrl) return $b07b8065f46b75ac$export$450bd8fb2a6d7ace;
                if (perimeter === (0, $cXGvu.PerimeterType).FEDRAMP_MODERATE) switch(serviceEnv){
                    case (0, $cXGvu.FeatureGateEnvironment).Production:
                        return $b07b8065f46b75ac$export$18c93900db9358a4;
                    case (0, $cXGvu.FeatureGateEnvironment).Staging:
                        return $b07b8065f46b75ac$export$1a401a0da8da3565;
                    default:
                        throw new Error("Invalid environment \"".concat(serviceEnv, "\" for \"").concat(perimeter, "\" perimeter"));
                }
                else if (perimeter === (0, $cXGvu.PerimeterType).COMMERCIAL) switch(serviceEnv){
                    case (0, $cXGvu.FeatureGateEnvironment).Development:
                        return $b07b8065f46b75ac$export$f058dbf75c3bc647;
                    case (0, $cXGvu.FeatureGateEnvironment).Staging:
                        var apiUrl = this.getApiUrl(isolationContextId);
                        if (apiUrl !== null) return apiUrl;
                        return $b07b8065f46b75ac$export$942ba04389b0d5a2;
                    default:
                        var prodApiUrl = this.getApiUrl(isolationContextId);
                        if (prodApiUrl !== null) return prodApiUrl;
                        return $b07b8065f46b75ac$export$250a58ecde616daa;
                }
                else throw new Error("Invalid perimeter \"".concat(perimeter, "\""));
            }
        },
        {
            key: "fetchRequest",
            value: function() {
                var _fetchRequest = (0, $jt440.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1KMt7))).mark(function _callee5(path, method, fetcherOptions, body) {
                    var baseUrl, fetchTimeout, abortSignal, abortController, response;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($1KMt7))).wrap(function(_context5) {
                        while(true)switch(_context5.prev = _context5.next){
                            case 0:
                                baseUrl = Fetcher.getBaseUrl(fetcherOptions.environment, fetcherOptions.useGatewayURL, fetcherOptions.perimeter, fetcherOptions.isolationContextId);
                                fetchTimeout = fetcherOptions.fetchTimeoutMs || $b07b8065f46b75ac$var$DEFAULT_REQUEST_TIMEOUT_MS;
                                if (AbortSignal.timeout) abortSignal = AbortSignal.timeout(fetchTimeout);
                                else if (AbortController) {
                                    abortController = new AbortController();
                                    abortSignal = abortController.signal;
                                    setTimeout(function() {
                                        return abortController.abort();
                                    }, fetchTimeout);
                                }
                                _context5.next = 1;
                                return fetch("".concat(baseUrl).concat(path), $b07b8065f46b75ac$var$_objectSpread({
                                    method: method,
                                    headers: {
                                        'Content-Type': 'application/json',
                                        'X-Client-Name': 'feature-gate-js-client',
                                        'X-Client-Version': (0, $6WhoI.CLIENT_VERSION),
                                        'X-API-KEY': fetcherOptions.apiKey
                                    },
                                    signal: abortSignal
                                }, body && {
                                    body: JSON.stringify(body)
                                }));
                            case 1:
                                response = _context5.sent;
                                _context5.next = 2;
                                return this.handleResponseError(response);
                            case 2:
                                _context5.next = 3;
                                return this.extractResponseBody(response);
                            case 3:
                                return _context5.abrupt("return", _context5.sent);
                            case 4:
                            case "end":
                                return _context5.stop();
                        }
                    }, _callee5, this);
                }));
                function fetchRequest(_x7, _x8, _x9, _x0) {
                    return _fetchRequest.apply(this, arguments);
                }
                return fetchRequest;
            }()
        },
        {
            key: "getApiUrl",
            value: function getApiUrl(isolationContextId) {
                var window1 = this.getWindowLocation();
                if (window1 === undefined) {
                    //this is needed when this SDK is used for SSR or plugin use cases where secret keys not available to use backend SDKs
                    if (!isolationContextId) return null;
                    return $b07b8065f46b75ac$export$4e8a0415edbfa1f7.replace('%s', isolationContextId);
                }
                var protocol = window1.protocol, hostname = window1.hostname;
                // Match last subdomain fragment before oasis-stg.com
                var oasisMatch = hostname.match(/([^.]+)\.oasis-stg\.com$/);
                if (oasisMatch) return "".concat(protocol, "//api.").concat(oasisMatch[1], ".").concat($b07b8065f46b75ac$export$cb3cd156f70d7e94);
                // Match last subdomain fragment before atlassian-isolated.net
                var isolatedMatch = hostname.match(/([^.]+)\.atlassian-isolated\.net$/);
                if (isolatedMatch) return "".concat(protocol, "//api.").concat(isolatedMatch[1], ".").concat($b07b8065f46b75ac$export$921fbc6cdfd4eee0);
                return null;
            }
        },
        {
            key: "getWindowLocation",
            value: function getWindowLocation() {
                if (typeof window !== 'undefined' && window.location) return window.location;
                return undefined;
            }
        }
    ]);
}();

});
parcelRegister("6WhoI", function(module, exports) {
$parcel$export(module.exports, "CLIENT_VERSION", () => $50d5a7aca1523610$export$a59f8d67326bd1cb);
/// <reference types="node" />
var $50d5a7aca1523610$export$a59f8d67326bd1cb = "5.8.0";

});

parcelRegister("5otRh", function(module, exports) {
$parcel$export(module.exports, "ResponseError", () => $3ed65ae992f0316e$export$286baf652d0b1206);

var $cHYPm = parcelRequire("cHYPm");

var $fQbYu = parcelRequire("fQbYu");

var $jwgSF = parcelRequire("jwgSF");

var $k155n = parcelRequire("k155n");

var $bUGeJ = parcelRequire("bUGeJ");

var $9Cnqb = parcelRequire("9Cnqb");
function $3ed65ae992f0316e$var$_callSuper(t, o, e) {
    return o = (0, $k155n.default)(o), (0, $jwgSF.default)(t, $3ed65ae992f0316e$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, $k155n.default)(t).constructor) : o.apply(t, e));
}
function $3ed65ae992f0316e$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($3ed65ae992f0316e$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $3ed65ae992f0316e$export$286baf652d0b1206 = /*#__PURE__*/ function(_Error) {
    function ResponseError(message) {
        (0, $fQbYu.default)(this, ResponseError);
        return $3ed65ae992f0316e$var$_callSuper(this, ResponseError, [
            message
        ]);
    }
    (0, $bUGeJ.default)(ResponseError, _Error);
    return (0, $cHYPm.default)(ResponseError);
}(/*#__PURE__*/ (0, $9Cnqb.default)(Error));

});
parcelRegister("jwgSF", function(module, exports) {
$parcel$export(module.exports, "default", () => $e35e19a51c2d8787$export$2e2bcd8739ae039);

var $hs8hh = parcelRequire("hs8hh");

var $9WT3Z = parcelRequire("9WT3Z");
function $e35e19a51c2d8787$export$2e2bcd8739ae039(t, e) {
    if (e && ("object" == (0, $hs8hh.default)(e) || "function" == typeof e)) return e;
    if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
    return (0, $9WT3Z.default)(t);
}

});
parcelRegister("9WT3Z", function(module, exports) {
$parcel$export(module.exports, "default", () => $73e43e492fb6f119$export$2e2bcd8739ae039);
function $73e43e492fb6f119$export$2e2bcd8739ae039(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
}

});


parcelRegister("k155n", function(module, exports) {
$parcel$export(module.exports, "default", () => $e927d889c4b9a8f7$export$2e2bcd8739ae039);
function $e927d889c4b9a8f7$export$2e2bcd8739ae039(t) {
    return $e927d889c4b9a8f7$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
        return t.__proto__ || Object.getPrototypeOf(t);
    }, $e927d889c4b9a8f7$export$2e2bcd8739ae039(t);
}

});

parcelRegister("bUGeJ", function(module, exports) {
$parcel$export(module.exports, "default", () => $8ac5affd2d9cf6c8$export$2e2bcd8739ae039);

var $ZbITq = parcelRequire("ZbITq");
function $8ac5affd2d9cf6c8$export$2e2bcd8739ae039(t, e) {
    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
    t.prototype = Object.create(e && e.prototype, {
        constructor: {
            value: t,
            writable: !0,
            configurable: !0
        }
    }), Object.defineProperty(t, "prototype", {
        writable: !1
    }), e && (0, $ZbITq.default)(t, e);
}

});
parcelRegister("ZbITq", function(module, exports) {
$parcel$export(module.exports, "default", () => $0b7eca9434f27ee2$export$2e2bcd8739ae039);
function $0b7eca9434f27ee2$export$2e2bcd8739ae039(t, e) {
    return $0b7eca9434f27ee2$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, $0b7eca9434f27ee2$export$2e2bcd8739ae039(t, e);
}

});


parcelRegister("9Cnqb", function(module, exports) {
$parcel$export(module.exports, "default", () => $7009d4a77ea68ceb$export$2e2bcd8739ae039);

var $k155n = parcelRequire("k155n");

var $ZbITq = parcelRequire("ZbITq");

var $94pWb = parcelRequire("94pWb");

var $ioo9G = parcelRequire("ioo9G");
function $7009d4a77ea68ceb$export$2e2bcd8739ae039(t) {
    var r = "function" == typeof Map ? new Map() : void 0;
    return $7009d4a77ea68ceb$export$2e2bcd8739ae039 = function _wrapNativeSuper(t) {
        if (null === t || !(0, $94pWb.default)(t)) return t;
        if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function");
        if (void 0 !== r) {
            if (r.has(t)) return r.get(t);
            r.set(t, Wrapper);
        }
        function Wrapper() {
            return (0, $ioo9G.default)(t, arguments, (0, $k155n.default)(this).constructor);
        }
        return Wrapper.prototype = Object.create(t.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: !1,
                writable: !0,
                configurable: !0
            }
        }), (0, $ZbITq.default)(Wrapper, t);
    }, $7009d4a77ea68ceb$export$2e2bcd8739ae039(t);
}

});
parcelRegister("94pWb", function(module, exports) {
$parcel$export(module.exports, "default", () => $69a89b6ff42c5fc0$export$2e2bcd8739ae039);
function $69a89b6ff42c5fc0$export$2e2bcd8739ae039(t) {
    try {
        return -1 !== Function.toString.call(t).indexOf("[native code]");
    } catch (n) {
        return "function" == typeof t;
    }
}

});

parcelRegister("ioo9G", function(module, exports) {
$parcel$export(module.exports, "default", () => $d63d3496fe083813$export$2e2bcd8739ae039);

var $brFqX = parcelRequire("brFqX");

var $ZbITq = parcelRequire("ZbITq");
function $d63d3496fe083813$export$2e2bcd8739ae039(t, e, r) {
    if ((0, $brFqX.default)()) return Reflect.construct.apply(null, arguments);
    var o = [
        null
    ];
    o.push.apply(o, e);
    var p = new (t.bind.apply(t, o))();
    return r && (0, $ZbITq.default)(p, r.prototype), p;
}

});
parcelRegister("brFqX", function(module, exports) {
$parcel$export(module.exports, "default", () => $85525b31d5c68be3$export$2e2bcd8739ae039);
function $85525b31d5c68be3$export$2e2bcd8739ae039() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($85525b31d5c68be3$export$2e2bcd8739ae039 = function _isNativeReflectConstruct() {
        return !!t;
    })();
}

});





parcelRegister("5MYIV", function(module, exports) {
$parcel$export(module.exports, "NoFetchDataAdapter", () => $437089ddf0a30c62$export$55fffef3474104af);

var $jt440 = parcelRequire("jt440");

var $fQbYu = parcelRequire("fQbYu");

var $cHYPm = parcelRequire("cHYPm");

var $jwgSF = parcelRequire("jwgSF");

var $k155n = parcelRequire("k155n");

var $exQnV = parcelRequire("exQnV");

var $bUGeJ = parcelRequire("bUGeJ");

var $dyTr7 = parcelRequire("dyTr7");

var $1KMt7 = parcelRequire("1KMt7");

var $iFR7a = parcelRequire("iFR7a");
function $437089ddf0a30c62$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $437089ddf0a30c62$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $437089ddf0a30c62$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $dyTr7.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $437089ddf0a30c62$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $437089ddf0a30c62$var$_callSuper(t, o, e) {
    return o = (0, $k155n.default)(o), (0, $jwgSF.default)(t, $437089ddf0a30c62$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, $k155n.default)(t).constructor) : o.apply(t, e));
}
function $437089ddf0a30c62$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($437089ddf0a30c62$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $437089ddf0a30c62$var$_superPropGet(t, o, e, r) {
    var p = (0, $exQnV.default)((0, $k155n.default)(1 & r ? t.prototype : t), o, e);
    return 2 & r && "function" == typeof p ? function(t) {
        return p.apply(e, t);
    } : p;
}
var $437089ddf0a30c62$export$55fffef3474104af = /*#__PURE__*/ function(_DataAdapterCore) {
    function NoFetchDataAdapter() {
        var _this;
        (0, $fQbYu.default)(this, NoFetchDataAdapter);
        _this = $437089ddf0a30c62$var$_callSuper(this, NoFetchDataAdapter, [
            'NoFetchDataAdapter',
            'nofetch'
        ]);
        (0, $dyTr7.default)(_this, "bootstrapResult", null);
        return _this;
    }
    /**
   * Make sure to call this **before** calling `initializeAsync` or `updateUserAsync` but
   * after the Statsig client has been created!
   */ (0, $bUGeJ.default)(NoFetchDataAdapter, _DataAdapterCore);
    return (0, $cHYPm.default)(NoFetchDataAdapter, [
        {
            key: "setBootstrapData",
            value: function setBootstrapData(data) {
                this.bootstrapResult = data ? {
                    source: 'Bootstrap',
                    data: JSON.stringify(data),
                    receivedAt: Date.now(),
                    stableID: (0, $iFR7a.StableID).get(this._getSdkKey()),
                    fullUserHash: null
                } : null;
            }
        },
        {
            key: "prefetchData",
            value: function() {
                var _prefetchData = (0, $jt440.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1KMt7))).mark(function _callee(_user, _options) {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($1KMt7))).wrap(function(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee);
                }));
                function prefetchData(_x, _x2) {
                    return _prefetchData.apply(this, arguments);
                }
                return prefetchData;
            }()
        },
        {
            key: "getDataAsync",
            value: function() {
                var _getDataAsync = (0, $jt440.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1KMt7))).mark(function _callee2(_current, user, _options) {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($1KMt7))).wrap(function(_context2) {
                        while(true)switch(_context2.prev = _context2.next){
                            case 0:
                                return _context2.abrupt("return", this.bootstrapResult && $437089ddf0a30c62$var$_objectSpread($437089ddf0a30c62$var$_objectSpread({}, this.bootstrapResult), {}, {
                                    fullUserHash: (0, $iFR7a._getFullUserHash)(user)
                                }));
                            case 1:
                            case "end":
                                return _context2.stop();
                        }
                    }, _callee2, this);
                }));
                function getDataAsync(_x3, _x4, _x5) {
                    return _getDataAsync.apply(this, arguments);
                }
                return getDataAsync;
            }()
        },
        {
            key: "getDataSync",
            value: function getDataSync(user) {
                return this.bootstrapResult && $437089ddf0a30c62$var$_objectSpread($437089ddf0a30c62$var$_objectSpread({}, this.bootstrapResult), {}, {
                    fullUserHash: (0, $iFR7a._getFullUserHash)(user)
                });
            }
        },
        {
            key: "_fetchFromNetwork",
            value: function() {
                var _fetchFromNetwork2 = (0, $jt440.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1KMt7))).mark(function _callee3(_current, _user, _options) {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($1KMt7))).wrap(function(_context3) {
                        while(true)switch(_context3.prev = _context3.next){
                            case 0:
                                return _context3.abrupt("return", null);
                            case 1:
                            case "end":
                                return _context3.stop();
                        }
                    }, _callee3);
                }));
                function _fetchFromNetwork(_x6, _x7, _x8) {
                    return _fetchFromNetwork2.apply(this, arguments);
                }
                return _fetchFromNetwork;
            }()
        },
        {
            key: "_getCacheKey",
            value: function _getCacheKey(user) {
                // Same logic as default data adapter
                // https://github.com/statsig-io/js-client-monorepo/blob/main/packages/js-client/src/StatsigEvaluationsDataAdapter.ts
                var key = (0, $iFR7a._getStorageKey)(this._getSdkKey(), user);
                return "".concat((0, $iFR7a.DataAdapterCachePrefix), ".").concat(this._cacheSuffix, ".").concat(key);
            }
        },
        {
            key: "_isCachedResultValidFor204",
            value: function _isCachedResultValidFor204(_result, _user) {
                return false;
            }
        },
        {
            key: "setDataLegacy",
            value: function setDataLegacy(data, user) {
                $437089ddf0a30c62$var$_superPropGet(NoFetchDataAdapter, "setData", this, 3)([
                    data,
                    user
                ]);
            }
        },
        {
            key: "toJSON",
            value: function toJSON() {
                var result = $437089ddf0a30c62$var$_objectSpread({}, this);
                delete result._options;
                delete result._inMemoryCache;
                delete result.bootstrapResult;
                return result;
            }
        }
    ]);
}((0, $iFR7a.DataAdapterCore));

});
parcelRegister("exQnV", function(module, exports) {
$parcel$export(module.exports, "default", () => $a96cc849eb530fe3$export$2e2bcd8739ae039);

var $cHm9F = parcelRequire("cHm9F");
function $a96cc849eb530fe3$export$2e2bcd8739ae039() {
    return $a96cc849eb530fe3$export$2e2bcd8739ae039 = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function(e, t, r) {
        var p = (0, $cHm9F.default)(e, t);
        if (p) {
            var n = Object.getOwnPropertyDescriptor(p, t);
            return n.get ? n.get.call(arguments.length < 3 ? e : r) : n.value;
        }
    }, $a96cc849eb530fe3$export$2e2bcd8739ae039.apply(null, arguments);
}

});
parcelRegister("cHm9F", function(module, exports) {
$parcel$export(module.exports, "default", () => $93eaafb635d5b407$export$2e2bcd8739ae039);

var $k155n = parcelRequire("k155n");
function $93eaafb635d5b407$export$2e2bcd8739ae039(t, o) {
    for(; !({}).hasOwnProperty.call(t, o) && null !== (t = (0, $k155n.default)(t)););
    return t;
}

});



parcelRegister("80LFe", function(module, exports) {
$parcel$export(module.exports, "LOCAL_STORAGE_KEY", () => $5d534bea4a687e8a$export$d8474cff104280f3);
$parcel$export(module.exports, "PersistentOverrideAdapter", () => $5d534bea4a687e8a$export$bcb28fbac1def494);

var $dyTr7 = parcelRequire("dyTr7");

var $94GB8 = parcelRequire("94GB8");

var $fQbYu = parcelRequire("fQbYu");

var $cHYPm = parcelRequire("cHYPm");

var $dtn6l = parcelRequire("dtn6l");
function $5d534bea4a687e8a$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $5d534bea4a687e8a$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $5d534bea4a687e8a$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $dyTr7.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $5d534bea4a687e8a$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $5d534bea4a687e8a$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $5d534bea4a687e8a$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $5d534bea4a687e8a$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $5d534bea4a687e8a$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $5d534bea4a687e8a$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $5d534bea4a687e8a$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
var $5d534bea4a687e8a$var$LOCAL_OVERRIDE_REASON = 'LocalOverride:Recognized';
var $5d534bea4a687e8a$export$d8474cff104280f3 = 'STATSIG_OVERRIDES';
var $5d534bea4a687e8a$var$LEGACY_LOCAL_STORAGE_KEY = 'STATSIG_JS_LITE_LOCAL_OVERRIDES';
var $5d534bea4a687e8a$var$makeEmptyStore = function makeEmptyStore() {
    return {
        gates: {},
        configs: {},
        layers: {}
    };
};
var $5d534bea4a687e8a$var$djb2MapKey = function djb2MapKey(hash, kind) {
    return kind + ':' + hash;
};
var $5d534bea4a687e8a$export$bcb28fbac1def494 = /*#__PURE__*/ function() {
    function PersistentOverrideAdapter(localStorageKey) {
        (0, $fQbYu.default)(this, PersistentOverrideAdapter);
        this._overrides = $5d534bea4a687e8a$var$makeEmptyStore();
        this._djb2Map = new Map();
        this._localStorageKey = localStorageKey;
    }
    return (0, $cHYPm.default)(PersistentOverrideAdapter, [
        {
            key: "parseStoredOverrides",
            value: function parseStoredOverrides(localStorageKey) {
                try {
                    var json = window.localStorage.getItem(localStorageKey);
                    if (!json) return $5d534bea4a687e8a$var$makeEmptyStore();
                    return JSON.parse(json);
                } catch (_unused) {
                    return $5d534bea4a687e8a$var$makeEmptyStore();
                }
            }
        },
        {
            key: "mergeOverrides",
            value: function mergeOverrides() {
                var merged = $5d534bea4a687e8a$var$makeEmptyStore();
                for(var _len = arguments.length, allOverrides = new Array(_len), _key = 0; _key < _len; _key++)allOverrides[_key] = arguments[_key];
                for(var _i = 0, _allOverrides = allOverrides; _i < _allOverrides.length; _i++){
                    var overrides = _allOverrides[_i];
                    for(var _i2 = 0, _Object$entries = Object.entries((_overrides$gates = overrides.gates) !== null && _overrides$gates !== void 0 ? _overrides$gates : {}); _i2 < _Object$entries.length; _i2++){
                        var _overrides$gates;
                        var _Object$entries$_i = (0, $94GB8.default)(_Object$entries[_i2], 2), name = _Object$entries$_i[0], value = _Object$entries$_i[1];
                        merged.gates[name] = value;
                    }
                    for(var _i3 = 0, _Object$entries2 = Object.entries((_overrides$configs = overrides.configs) !== null && _overrides$configs !== void 0 ? _overrides$configs : {}); _i3 < _Object$entries2.length; _i3++){
                        var _overrides$configs;
                        var _Object$entries2$_i = (0, $94GB8.default)(_Object$entries2[_i3], 2), _name = _Object$entries2$_i[0], _value = _Object$entries2$_i[1];
                        merged.configs[_name] = _value;
                    }
                    for(var _i4 = 0, _Object$entries3 = Object.entries((_overrides$layers = overrides.layers) !== null && _overrides$layers !== void 0 ? _overrides$layers : {}); _i4 < _Object$entries3.length; _i4++){
                        var _overrides$layers;
                        var _Object$entries3$_i = (0, $94GB8.default)(_Object$entries3[_i4], 2), _name2 = _Object$entries3$_i[0], _value2 = _Object$entries3$_i[1];
                        merged.layers[_name2] = _value2;
                    }
                }
                return merged;
            }
        },
        {
            key: "initFromStoredOverrides",
            value: function initFromStoredOverrides() {
                var storedOverrides = this.mergeOverrides(this._overrides, this.parseStoredOverrides($5d534bea4a687e8a$var$LEGACY_LOCAL_STORAGE_KEY), this.parseStoredOverrides(this._localStorageKey));
                // Clear data from legacy local storage key now we've read from it.
                // This prevents things being stuck in there that are always read but never written to.
                try {
                    window.localStorage.removeItem($5d534bea4a687e8a$var$LEGACY_LOCAL_STORAGE_KEY);
                } catch (_unused2) {
                // ignored - window is not defined in non-browser environments, and we don't save things there
                // (things like SSR, etc)
                }
                // In version 4.24.0 we introduced hashes in this override adapter, but had a bug which would cause
                // multiple hashes to continue being created. This code here removes these hashes since we've moved
                // to using a more reliable and easier to maintain map in `_djb2Map`.
                for(var _i5 = 0, _Object$values = Object.values(storedOverrides); _i5 < _Object$values.length; _i5++){
                    var container = _Object$values[_i5];
                    var allKeys = new Set(Object.keys(container));
                    var _iterator = $5d534bea4a687e8a$var$_createForOfIteratorHelper(allKeys), _step;
                    try {
                        for(_iterator.s(); !(_step = _iterator.n()).done;){
                            var name = _step.value;
                            var hash = (0, $dtn6l._DJB2)(name);
                            if (allKeys.has(hash)) delete container[hash];
                        }
                    } catch (err) {
                        _iterator.e(err);
                    } finally{
                        _iterator.f();
                    }
                }
                this.applyOverrides(storedOverrides);
            }
        },
        {
            key: "saveOverrides",
            value: function saveOverrides() {
                try {
                    window.localStorage.setItem(this._localStorageKey, JSON.stringify(this._overrides));
                } catch (_unused3) {
                // ignored - window is not defined in non-browser environments, and we don't save things there
                // (things like SSR, etc)
                }
            }
        },
        {
            key: "getOverrides",
            value: function getOverrides() {
                return this.mergeOverrides(this._overrides);
            }
        },
        {
            key: "applyOverrides",
            value: function applyOverrides(overrides) {
                var newOverrides = $5d534bea4a687e8a$var$_objectSpread($5d534bea4a687e8a$var$_objectSpread({}, $5d534bea4a687e8a$var$makeEmptyStore()), overrides);
                this._djb2Map.clear();
                for(var _i6 = 0, _Object$entries4 = Object.entries(newOverrides); _i6 < _Object$entries4.length; _i6++){
                    var _Object$entries4$_i = (0, $94GB8.default)(_Object$entries4[_i6], 2), containerName = _Object$entries4$_i[0], container = _Object$entries4$_i[1];
                    for(var _i7 = 0, _Object$entries5 = Object.entries(container); _i7 < _Object$entries5.length; _i7++){
                        var _Object$entries5$_i = (0, $94GB8.default)(_Object$entries5[_i7], 2), name = _Object$entries5$_i[0], value = _Object$entries5$_i[1];
                        this._djb2Map.set($5d534bea4a687e8a$var$djb2MapKey((0, $dtn6l._DJB2)(name), containerName), value);
                    }
                }
                this._overrides = newOverrides;
            }
        },
        {
            key: "setOverrides",
            value: function setOverrides(overrides) {
                this.applyOverrides(overrides);
                this.saveOverrides();
            }
        },
        {
            key: "overrideGate",
            value: function overrideGate(name, value) {
                this._overrides.gates[name] = value;
                this._djb2Map.set($5d534bea4a687e8a$var$djb2MapKey((0, $dtn6l._DJB2)(name), 'gates'), value);
                this.saveOverrides();
            }
        },
        {
            key: "removeGateOverride",
            value: function removeGateOverride(name) {
                delete this._overrides.gates[name];
                this._djb2Map.delete($5d534bea4a687e8a$var$djb2MapKey((0, $dtn6l._DJB2)(name), 'gates'));
                this.saveOverrides();
            }
        },
        {
            key: "getGateOverride",
            value: function getGateOverride(current, _user) {
                var _this$_overrides$gate;
                var overridden = (_this$_overrides$gate = this._overrides.gates[current.name]) !== null && _this$_overrides$gate !== void 0 ? _this$_overrides$gate : this._djb2Map.get($5d534bea4a687e8a$var$djb2MapKey(current.name, 'gates'));
                if (overridden == null) return null;
                return $5d534bea4a687e8a$var$_objectSpread($5d534bea4a687e8a$var$_objectSpread({}, current), {}, {
                    value: overridden,
                    details: $5d534bea4a687e8a$var$_objectSpread($5d534bea4a687e8a$var$_objectSpread({}, current.details), {}, {
                        reason: $5d534bea4a687e8a$var$LOCAL_OVERRIDE_REASON
                    })
                });
            }
        },
        {
            key: "overrideDynamicConfig",
            value: function overrideDynamicConfig(name, value) {
                this._overrides.configs[name] = value;
                this._djb2Map.set($5d534bea4a687e8a$var$djb2MapKey((0, $dtn6l._DJB2)(name), 'configs'), value);
                this.saveOverrides();
            }
        },
        {
            key: "removeDynamicConfigOverride",
            value: function removeDynamicConfigOverride(name) {
                delete this._overrides.configs[name];
                this._djb2Map.delete($5d534bea4a687e8a$var$djb2MapKey((0, $dtn6l._DJB2)(name), 'configs'));
                this.saveOverrides();
            }
        },
        {
            key: "getDynamicConfigOverride",
            value: function getDynamicConfigOverride(current, _user) {
                return this._getConfigOverride(current, this._overrides.configs);
            }
        },
        {
            key: "overrideExperiment",
            value: function overrideExperiment(name, value) {
                this._overrides.configs[name] = value;
                this._djb2Map.set($5d534bea4a687e8a$var$djb2MapKey((0, $dtn6l._DJB2)(name), 'configs'), value);
                this.saveOverrides();
            }
        },
        {
            key: "removeExperimentOverride",
            value: function removeExperimentOverride(name) {
                delete this._overrides.configs[name];
                this._djb2Map.delete($5d534bea4a687e8a$var$djb2MapKey((0, $dtn6l._DJB2)(name), 'configs'));
                this.saveOverrides();
            }
        },
        {
            key: "getExperimentOverride",
            value: function getExperimentOverride(current, _user) {
                return this._getConfigOverride(current, this._overrides.configs);
            }
        },
        {
            key: "overrideLayer",
            value: function overrideLayer(name, value) {
                this._overrides.layers[name] = value;
                this._djb2Map.set($5d534bea4a687e8a$var$djb2MapKey((0, $dtn6l._DJB2)(name), 'layers'), value);
                this.saveOverrides();
            }
        },
        {
            key: "removeLayerOverride",
            value: function removeLayerOverride(name) {
                delete this._overrides.layers[name];
                this._djb2Map.delete($5d534bea4a687e8a$var$djb2MapKey((0, $dtn6l._DJB2)(name), 'layers'));
                this.saveOverrides();
            }
        },
        {
            key: "removeAllOverrides",
            value: function removeAllOverrides() {
                this._overrides = $5d534bea4a687e8a$var$makeEmptyStore();
                try {
                    window.localStorage.removeItem(this._localStorageKey);
                } catch (_unused4) {
                // ignored - window is not defined in non-browser environments, and we don't save things there
                // (things like SSR, etc)
                }
            }
        },
        {
            key: "getLayerOverride",
            value: function getLayerOverride(current, _user) {
                var _this$_overrides$laye;
                var overridden = (_this$_overrides$laye = this._overrides.layers[current.name]) !== null && _this$_overrides$laye !== void 0 ? _this$_overrides$laye : this._djb2Map.get($5d534bea4a687e8a$var$djb2MapKey(current.name, 'layers'));
                if (overridden == null) return null;
                return $5d534bea4a687e8a$var$_objectSpread($5d534bea4a687e8a$var$_objectSpread({}, current), {}, {
                    __value: overridden,
                    get: (0, $dtn6l._makeTypedGet)(current.name, overridden),
                    details: $5d534bea4a687e8a$var$_objectSpread($5d534bea4a687e8a$var$_objectSpread({}, current.details), {}, {
                        reason: $5d534bea4a687e8a$var$LOCAL_OVERRIDE_REASON
                    })
                });
            }
        },
        {
            key: "_getConfigOverride",
            value: function _getConfigOverride(current, lookup) {
                var _lookup$current$name;
                var overridden = (_lookup$current$name = lookup[current.name]) !== null && _lookup$current$name !== void 0 ? _lookup$current$name : this._djb2Map.get($5d534bea4a687e8a$var$djb2MapKey(current.name, 'configs'));
                if (overridden == null) return null;
                return $5d534bea4a687e8a$var$_objectSpread($5d534bea4a687e8a$var$_objectSpread({}, current), {}, {
                    value: overridden,
                    get: (0, $dtn6l._makeTypedGet)(current.name, overridden),
                    details: $5d534bea4a687e8a$var$_objectSpread($5d534bea4a687e8a$var$_objectSpread({}, current.details), {}, {
                        reason: $5d534bea4a687e8a$var$LOCAL_OVERRIDE_REASON
                    })
                });
            }
        }
    ]);
}();

});



parcelRegister("kjcRI", function(module, exports) {
$parcel$export(module.exports, "debug", () => $ec8f8fc8c8703c3d$export$1c9f709888824e05);
var $ec8f8fc8c8703c3d$var$_process, $ec8f8fc8c8703c3d$var$_process2;
// We can't rely on NODE_ENV === 'test' if its value is already configured by the consumer to some other value, so better to use JEST_WORKER_ID
// https://jestjs.io/docs/environment-variables#jest_worker_id
var $ec8f8fc8c8703c3d$var$TESTS_MODE = (globalThis === null || globalThis === void 0 || ($ec8f8fc8c8703c3d$var$_process = globalThis.process) === null || $ec8f8fc8c8703c3d$var$_process === void 0 || ($ec8f8fc8c8703c3d$var$_process = $ec8f8fc8c8703c3d$var$_process.env) === null || $ec8f8fc8c8703c3d$var$_process === void 0 ? void 0 : $ec8f8fc8c8703c3d$var$_process.JEST_WORKER_ID) !== undefined;
var $ec8f8fc8c8703c3d$var$DEBUG_MODE = !$ec8f8fc8c8703c3d$var$TESTS_MODE && (globalThis === null || globalThis === void 0 || ($ec8f8fc8c8703c3d$var$_process2 = globalThis.process) === null || $ec8f8fc8c8703c3d$var$_process2 === void 0 || ($ec8f8fc8c8703c3d$var$_process2 = $ec8f8fc8c8703c3d$var$_process2.env) === null || $ec8f8fc8c8703c3d$var$_process2 === void 0 ? void 0 : $ec8f8fc8c8703c3d$var$_process2.NODE_ENV) !== 'production';
var $ec8f8fc8c8703c3d$export$1c9f709888824e05 = function debug() {
    var _console;
    if (!$ec8f8fc8c8703c3d$var$DEBUG_MODE) return;
    // eslint-disable-next-line no-console
    (_console = console).debug.apply(_console, arguments);
};

});

parcelRegister("9i3MK", function(module, exports) {
$parcel$export(module.exports, "ENV_ENABLE_PLATFORM_FF", () => $6c38bb2859beab5d$export$b574c24e1e6490f5);

var $lLIS3 = parcelRequire("lLIS3");
var $6c38bb2859beab5d$export$b574c24e1e6490f5 = (0, $lLIS3.hasProcessEnv) ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;

});
parcelRegister("lLIS3", function(module, exports) {
$parcel$export(module.exports, "PFF_GLOBAL_KEY", () => $fd90cb3103826b9d$export$7e41b1b2bdee3f98);
$parcel$export(module.exports, "pkgName", () => $fd90cb3103826b9d$export$407f05df8e3ce9f3);
$parcel$export(module.exports, "hasProcessEnv", () => $fd90cb3103826b9d$export$75f4a1454eff2805);

var $3ZMUU = parcelRequire("3ZMUU");
var $fd90cb3103826b9d$export$7e41b1b2bdee3f98 = '__PLATFORM_FEATURE_FLAGS__';
var $fd90cb3103826b9d$export$407f05df8e3ce9f3 = '@atlaskit/platform-feature-flags';
var $fd90cb3103826b9d$export$75f4a1454eff2805 = typeof $3ZMUU !== 'undefined' && typeof $3ZMUU.env !== 'undefined';

});


parcelRegister("iuNyR", function(module, exports) {
$parcel$export(module.exports, "ENV_STORYBOOK_ENABLE_PLATFORM_FF", () => $d771792e1dd2dcb6$export$92f8b531feaeb23d);

var $lLIS3 = parcelRequire("lLIS3");
var $d771792e1dd2dcb6$export$92f8b531feaeb23d = (0, $lLIS3.hasProcessEnv) ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;

});

parcelRegister("e2P9b", function(module, exports) {
$parcel$export(module.exports, "globalVar", () => $a398ed5a30e3a949$export$54ea85357b4e0159);

var $lLIS3 = parcelRequire("lLIS3");
var $a398ed5a30e3a949$var$DEFAULT_PFF_GLOBAL = {
    booleanResolver: undefined
};
var $a398ed5a30e3a949$export$54ea85357b4e0159 = typeof window !== 'undefined' ? window : globalThis;
$a398ed5a30e3a949$export$54ea85357b4e0159[0, $lLIS3.PFF_GLOBAL_KEY] = $a398ed5a30e3a949$export$54ea85357b4e0159[0, $lLIS3.PFF_GLOBAL_KEY] || $a398ed5a30e3a949$var$DEFAULT_PFF_GLOBAL;

});




parcelRegister("3ENxc", function(module, exports) {
$parcel$export(module.exports, "hash", () => $2a9b880a994ef4e4$export$d6af199866bfb566);
var $2a9b880a994ef4e4$export$d6af199866bfb566 = function hash(str) {
    var hash = 0;
    for(var i = 0; i < str.length; i++){
        var char = str.charCodeAt(i);
        hash = (hash << 5) - hash + char;
        hash &= hash; // Convert to 32bit integer
    }
    return new Uint32Array([
        hash
    ])[0].toString(36);
};

});

parcelRegister("eoPms", function(module, exports) {
$parcel$export(module.exports, "default", () => $a7bb25d69b7fab84$export$2e2bcd8739ae039);
function $a7bb25d69b7fab84$export$2e2bcd8739ae039(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}

});

parcelRegister("eyhZN", function(module, exports) {
$parcel$export(module.exports, "default", () => $a98233429eeaf85a$export$2e2bcd8739ae039);

var $b29gf = parcelRequire("b29gf");
function $a98233429eeaf85a$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, (0, $b29gf.default)(o.key), o);
    }
}
function $a98233429eeaf85a$export$2e2bcd8739ae039(e, r, t) {
    return r && $a98233429eeaf85a$var$_defineProperties(e.prototype, r), t && $a98233429eeaf85a$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}

});

parcelRegister("bDSDt", function(module, exports) {

var $iKwew = parcelRequire("iKwew");
module.exports = $iKwew("8dpxt").then(()=>parcelRequire('dBLpv'));

});
parcelRegister("iKwew", function(module, exports) {
"use strict";

function $da6586bd2e851bf4$var$load(id) {
    // eslint-disable-next-line no-undef
    return import((parcelRequire("F8oyc")).resolve(id));
}
module.exports = $da6586bd2e851bf4$var$load;

});
parcelRegister("F8oyc", function(module, exports) {
$parcel$export(module.exports, "register", () => $07ba578472346502$export$6503ec6e8aabbaf, (v) => $07ba578472346502$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $07ba578472346502$export$f7ad0328861e2f03, (v) => $07ba578472346502$export$f7ad0328861e2f03 = v);
var $07ba578472346502$export$6503ec6e8aabbaf;
var $07ba578472346502$export$f7ad0328861e2f03;
"use strict";
var $07ba578472346502$var$mapping = new Map();
function $07ba578472346502$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$07ba578472346502$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $07ba578472346502$var$resolve(id) {
    var resolved = $07ba578472346502$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$07ba578472346502$export$6503ec6e8aabbaf = $07ba578472346502$var$register;
$07ba578472346502$export$f7ad0328861e2f03 = $07ba578472346502$var$resolve;

});



parcelRegister("8SV4m", function(module, exports) {

var $iKwew = parcelRequire("iKwew");
module.exports = $iKwew("6mk2N").then(()=>parcelRequire('d9oU7'));

});

parcelRegister("3sbKi", function(module, exports) {

var $iKwew = parcelRequire("iKwew");
module.exports = $iKwew("aNqkA").then(()=>parcelRequire('hJxyI'));

});

parcelRegister("clWHD", function(module, exports) {

var $iKwew = parcelRequire("iKwew");
module.exports = $iKwew("lbEn5").then(()=>parcelRequire('7pXzE'));

});

parcelRegister("10OzB", function(module, exports) {

var $iKwew = parcelRequire("iKwew");
module.exports = $iKwew("i8ZQs").then(()=>parcelRequire('19VjI'));

});

parcelRegister("8Ul61", function(module, exports) {

var $iKwew = parcelRequire("iKwew");
module.exports = $iKwew("fXI52").then(()=>parcelRequire('aYEHp'));

});

parcelRegister("fUMDb", function(module, exports) {

var $iKwew = parcelRequire("iKwew");
module.exports = $iKwew("hwaZz").then(()=>parcelRequire('c5rYc'));

});

parcelRegister("fONlQ", function(module, exports) {

var $iKwew = parcelRequire("iKwew");
module.exports = $iKwew("cUfjS").then(()=>parcelRequire('evOvQ'));

});

parcelRegister("89bQV", function(module, exports) {

var $iKwew = parcelRequire("iKwew");
module.exports = $iKwew("1QQmc").then(()=>parcelRequire('565l2'));

});

parcelRegister("5r8Y4", function(module, exports) {

var $iKwew = parcelRequire("iKwew");
module.exports = $iKwew("8g0D1").then(()=>parcelRequire('7cU8a'));

});

parcelRegister("9aLgs", function(module, exports) {

var $iKwew = parcelRequire("iKwew");
module.exports = $iKwew("8JRRA").then(()=>parcelRequire('d7lZx'));

});

parcelRegister("b3HFs", function(module, exports) {

var $iKwew = parcelRequire("iKwew");
module.exports = $iKwew("19czx").then(()=>parcelRequire('jyhWx'));

});

parcelRegister("1VnnL", function(module, exports) {

var $iKwew = parcelRequire("iKwew");
module.exports = $iKwew("8f3uh").then(()=>parcelRequire('all87'));

});

parcelRegister("2BLfh", function(module, exports) {

var $iKwew = parcelRequire("iKwew");
module.exports = $iKwew("lKdH4").then(()=>parcelRequire('dkaXG'));

});

parcelRegister("j7Ivm", function(module, exports) {

var $iKwew = parcelRequire("iKwew");
module.exports = $iKwew("iUl3e").then(()=>parcelRequire('JvPYp'));

});

parcelRegister("7tyYU", function(module, exports) {
$parcel$export(module.exports, "default", () => $5716606da9411bd9$export$2e2bcd8739ae039);

var $4364b = parcelRequire("4364b");

var $earJG = parcelRequire("earJG");

var $a07JP = parcelRequire("a07JP");

var $8yNS9 = parcelRequire("8yNS9");
function $5716606da9411bd9$export$2e2bcd8739ae039(r) {
    return (0, $4364b.default)(r) || (0, $earJG.default)(r) || (0, $a07JP.default)(r) || (0, $8yNS9.default)();
}

});
parcelRegister("4364b", function(module, exports) {
$parcel$export(module.exports, "default", () => $2f2c25e4940258d7$export$2e2bcd8739ae039);

var $79LsX = parcelRequire("79LsX");
function $2f2c25e4940258d7$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return (0, $79LsX.default)(r);
}

});

parcelRegister("earJG", function(module, exports) {
$parcel$export(module.exports, "default", () => $a507839d20489de6$export$2e2bcd8739ae039);
function $a507839d20489de6$export$2e2bcd8739ae039(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}

});

parcelRegister("8yNS9", function(module, exports) {
$parcel$export(module.exports, "default", () => $63b82f594b0725f7$export$2e2bcd8739ae039);
function $63b82f594b0725f7$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});


parcelRegister("6OciX", function(module, exports) {

var $iKwew = parcelRequire("iKwew");
module.exports = $iKwew("adg9C").then(()=>parcelRequire('jLYkO'));

});

parcelRegister("4Jvr6", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';

var $gz8WA = parcelRequire("gz8WA");
function $3723bff343046ecc$var$emptyFunction() {}
function $3723bff343046ecc$var$emptyFunctionWithReset() {}
$3723bff343046ecc$var$emptyFunctionWithReset.resetWarningCache = $3723bff343046ecc$var$emptyFunction;
module.exports = function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret === $gz8WA) // It is still safe when called from React.
        return;
        var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        err.name = 'Invariant Violation';
        throw err;
    }
    shim.isRequired = shim;
    function getShim() {
        return shim;
    }
    // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
    var ReactPropTypes = {
        array: shim,
        bigint: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: $3723bff343046ecc$var$emptyFunctionWithReset,
        resetWarningCache: $3723bff343046ecc$var$emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};

});
parcelRegister("gz8WA", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
var $c0f6da4afb440757$var$ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
module.exports = $c0f6da4afb440757$var$ReactPropTypesSecret;

});


parcelRegister("6lpBT", function(module, exports) {
$parcel$export(module.exports, "default", () => $49e891e5a49d83e2$export$2e2bcd8739ae039);

var $jRwnQ = parcelRequire("jRwnQ");
function $49e891e5a49d83e2$export$2e2bcd8739ae039(e, r, t) {
    return (r = (0, $jRwnQ.default)(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}

});
parcelRegister("jRwnQ", function(module, exports) {
$parcel$export(module.exports, "default", () => $e75c1649831a596f$export$2e2bcd8739ae039);

var $djefD = parcelRequire("djefD");

var $UPnEZ = parcelRequire("UPnEZ");
function $e75c1649831a596f$export$2e2bcd8739ae039(t) {
    var i = (0, $UPnEZ.default)(t, "string");
    return "symbol" == (0, $djefD.default)(i) ? i : i + "";
}

});
parcelRegister("djefD", function(module, exports) {
$parcel$export(module.exports, "default", () => $9b081ab8b9d5dad7$export$2e2bcd8739ae039);
function $9b081ab8b9d5dad7$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $9b081ab8b9d5dad7$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $9b081ab8b9d5dad7$export$2e2bcd8739ae039(o);
}

});

parcelRegister("UPnEZ", function(module, exports) {
$parcel$export(module.exports, "default", () => $0aad163265d3d7d6$export$2e2bcd8739ae039);

var $djefD = parcelRequire("djefD");
function $0aad163265d3d7d6$export$2e2bcd8739ae039(t, r) {
    if ("object" != (0, $djefD.default)(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (0, $djefD.default)(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}

});



parcelRegister("iOWlh", function(module, exports) {
$parcel$export(module.exports, "default", () => $db3a27101d22c2c2$export$2e2bcd8739ae039);

var $hsHr3 = parcelRequire("hsHr3");

var $cqTlz = parcelRequire("cqTlz");

var $3lyOK = parcelRequire("3lyOK");

var $94Kqu = parcelRequire("94Kqu");
function $db3a27101d22c2c2$export$2e2bcd8739ae039(r, e) {
    return (0, $hsHr3.default)(r) || (0, $cqTlz.default)(r, e) || (0, $3lyOK.default)(r, e) || (0, $94Kqu.default)();
}

});
parcelRegister("hsHr3", function(module, exports) {
$parcel$export(module.exports, "default", () => $cb66be8982cddc95$export$2e2bcd8739ae039);
function $cb66be8982cddc95$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return r;
}

});

parcelRegister("cqTlz", function(module, exports) {
$parcel$export(module.exports, "default", () => $90d2d87d2e9bb355$export$2e2bcd8739ae039);
function $90d2d87d2e9bb355$export$2e2bcd8739ae039(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}

});

parcelRegister("3lyOK", function(module, exports) {
$parcel$export(module.exports, "default", () => $26fe5746f80e549f$export$2e2bcd8739ae039);

var $khwyd = parcelRequire("khwyd");
function $26fe5746f80e549f$export$2e2bcd8739ae039(r, a) {
    if (r) {
        if ("string" == typeof r) return (0, $khwyd.default)(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? (0, $khwyd.default)(r, a) : void 0;
    }
}

});
parcelRegister("khwyd", function(module, exports) {
$parcel$export(module.exports, "default", () => $ec3ea5202bddfac6$export$2e2bcd8739ae039);
function $ec3ea5202bddfac6$export$2e2bcd8739ae039(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}

});


parcelRegister("94Kqu", function(module, exports) {
$parcel$export(module.exports, "default", () => $69b880153cb86d97$export$2e2bcd8739ae039);
function $69b880153cb86d97$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});


parcelRegister("ljOJO", function(module, exports) {

var $1zyRQ = parcelRequire("1zyRQ");
var $f852bacc52d7c1a3$var$_typeof = $1zyRQ.default;
function $f852bacc52d7c1a3$var$_regeneratorRuntime() {
    "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ 
    module.exports = $f852bacc52d7c1a3$var$_regeneratorRuntime = function _regeneratorRuntime() {
        return e;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports;
    var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function(t, e, r) {
        t[e] = r.value;
    }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag";
    function define(t, e, r) {
        return Object.defineProperty(t, e, {
            value: r,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }), t[e];
    }
    try {
        define({}, "");
    } catch (t) {
        define = function define(t, e, r) {
            return t[e] = r;
        };
    }
    function wrap(t, e, r, n) {
        var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []);
        return o(a, "_invoke", {
            value: makeInvokeMethod(t, r, c)
        }), a;
    }
    function tryCatch(t, e, r) {
        try {
            return {
                type: "normal",
                arg: t.call(e, r)
            };
        } catch (t) {
            return {
                type: "throw",
                arg: t
            };
        }
    }
    e.wrap = wrap;
    var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {};
    function Generator() {}
    function GeneratorFunction() {}
    function GeneratorFunctionPrototype() {}
    var p = {};
    define(p, a, function() {
        return this;
    });
    var d = Object.getPrototypeOf, v = d && d(d(values([])));
    v && v !== r && n.call(v, a) && (p = v);
    var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p);
    function defineIteratorMethods(t) {
        [
            "next",
            "throw",
            "return"
        ].forEach(function(e) {
            define(t, e, function(t) {
                return this._invoke(e, t);
            });
        });
    }
    function AsyncIterator(t, e) {
        function invoke(r, o, i, a) {
            var c = tryCatch(t[r], t, o);
            if ("throw" !== c.type) {
                var u = c.arg, h = u.value;
                return h && "object" == $f852bacc52d7c1a3$var$_typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function(t) {
                    invoke("next", t, i, a);
                }, function(t) {
                    invoke("throw", t, i, a);
                }) : e.resolve(h).then(function(t) {
                    u.value = t, i(u);
                }, function(t) {
                    return invoke("throw", t, i, a);
                });
            }
            a(c.arg);
        }
        var r;
        o(this, "_invoke", {
            value: function value(t, n) {
                function callInvokeWithMethodAndArg() {
                    return new e(function(e, r) {
                        invoke(t, n, e, r);
                    });
                }
                return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
            }
        });
    }
    function makeInvokeMethod(e, r, n) {
        var o = h;
        return function(i, a) {
            if (o === f) throw Error("Generator is already running");
            if (o === s) {
                if ("throw" === i) throw a;
                return {
                    value: t,
                    done: !0
                };
            }
            for(n.method = i, n.arg = a;;){
                var c = n.delegate;
                if (c) {
                    var u = maybeInvokeDelegate(c, n);
                    if (u) {
                        if (u === y) continue;
                        return u;
                    }
                }
                if ("next" === n.method) n.sent = n._sent = n.arg;
                else if ("throw" === n.method) {
                    if (o === h) throw o = s, n.arg;
                    n.dispatchException(n.arg);
                } else "return" === n.method && n.abrupt("return", n.arg);
                o = f;
                var p = tryCatch(e, r, n);
                if ("normal" === p.type) {
                    if (o = n.done ? s : l, p.arg === y) continue;
                    return {
                        value: p.arg,
                        done: n.done
                    };
                }
                "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg);
            }
        };
    }
    function maybeInvokeDelegate(e, r) {
        var n = r.method, o = e.iterator[n];
        if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y;
        var i = tryCatch(o, e.iterator, r.arg);
        if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y;
        var a = i.arg;
        return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y);
    }
    function pushTryEntry(t) {
        var e = {
            tryLoc: t[0]
        };
        1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e);
    }
    function resetTryEntry(t) {
        var e = t.completion || {};
        e.type = "normal", delete e.arg, t.completion = e;
    }
    function Context(t) {
        this.tryEntries = [
            {
                tryLoc: "root"
            }
        ], t.forEach(pushTryEntry, this), this.reset(!0);
    }
    function values(e) {
        if (e || "" === e) {
            var r = e[a];
            if (r) return r.call(e);
            if ("function" == typeof e.next) return e;
            if (!isNaN(e.length)) {
                var o = -1, i = function next() {
                    for(; ++o < e.length;)if (n.call(e, o)) return next.value = e[o], next.done = !1, next;
                    return next.value = t, next.done = !0, next;
                };
                return i.next = i;
            }
        }
        throw new TypeError($f852bacc52d7c1a3$var$_typeof(e) + " is not iterable");
    }
    return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", {
        value: GeneratorFunctionPrototype,
        configurable: !0
    }), o(GeneratorFunctionPrototype, "constructor", {
        value: GeneratorFunction,
        configurable: !0
    }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function(t) {
        var e = "function" == typeof t && t.constructor;
        return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name));
    }, e.mark = function(t) {
        return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t;
    }, e.awrap = function(t) {
        return {
            __await: t
        };
    }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function() {
        return this;
    }), e.AsyncIterator = AsyncIterator, e.async = function(t, r, n, o, i) {
        void 0 === i && (i = Promise);
        var a = new AsyncIterator(wrap(t, r, n, o), i);
        return e.isGeneratorFunction(r) ? a : a.next().then(function(t) {
            return t.done ? t.value : a.next();
        });
    }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function() {
        return this;
    }), define(g, "toString", function() {
        return "[object Generator]";
    }), e.keys = function(t) {
        var e = Object(t), r = [];
        for(var n in e)r.push(n);
        return r.reverse(), function next() {
            for(; r.length;){
                var t = r.pop();
                if (t in e) return next.value = t, next.done = !1, next;
            }
            return next.done = !0, next;
        };
    }, e.values = values, Context.prototype = {
        constructor: Context,
        reset: function reset(e) {
            if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for(var r in this)"t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t);
        },
        stop: function stop() {
            this.done = !0;
            var t = this.tryEntries[0].completion;
            if ("throw" === t.type) throw t.arg;
            return this.rval;
        },
        dispatchException: function dispatchException(e) {
            if (this.done) throw e;
            var r = this;
            function handle(n, o) {
                return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o;
            }
            for(var o = this.tryEntries.length - 1; o >= 0; --o){
                var i = this.tryEntries[o], a = i.completion;
                if ("root" === i.tryLoc) return handle("end");
                if (i.tryLoc <= this.prev) {
                    var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc");
                    if (c && u) {
                        if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
                        if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
                    } else if (c) {
                        if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
                    } else {
                        if (!u) throw Error("try statement without catch or finally");
                        if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
                    }
                }
            }
        },
        abrupt: function abrupt(t, e) {
            for(var r = this.tryEntries.length - 1; r >= 0; --r){
                var o = this.tryEntries[r];
                if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
                    var i = o;
                    break;
                }
            }
            i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null);
            var a = i ? i.completion : {};
            return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a);
        },
        complete: function complete(t, e) {
            if ("throw" === t.type) throw t.arg;
            return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y;
        },
        finish: function finish(t) {
            for(var e = this.tryEntries.length - 1; e >= 0; --e){
                var r = this.tryEntries[e];
                if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y;
            }
        },
        "catch": function _catch(t) {
            for(var e = this.tryEntries.length - 1; e >= 0; --e){
                var r = this.tryEntries[e];
                if (r.tryLoc === t) {
                    var n = r.completion;
                    if ("throw" === n.type) {
                        var o = n.arg;
                        resetTryEntry(r);
                    }
                    return o;
                }
            }
            throw Error("illegal catch attempt");
        },
        delegateYield: function delegateYield(e, r, n) {
            return this.delegate = {
                iterator: values(e),
                resultName: r,
                nextLoc: n
            }, "next" === this.method && (this.arg = t), y;
        }
    }, e;
}
module.exports = $f852bacc52d7c1a3$var$_regeneratorRuntime, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("1zyRQ", function(module, exports) {
function $12541b49421a2cd6$var$_typeof(o) {
    "@babel/helpers - typeof";
    return module.exports = $12541b49421a2cd6$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $12541b49421a2cd6$var$_typeof(o);
}
module.exports = $12541b49421a2cd6$var$_typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("6o2jv", function(module, exports) {
$parcel$export(module.exports, "THEME_DATA_ATTRIBUTE", () => $4a66c7671722008d$export$4ef52930e33717cd);
$parcel$export(module.exports, "SUBTREE_THEME_ATTRIBUTE", () => $4a66c7671722008d$export$cb374d25ded7f6ab);
$parcel$export(module.exports, "COLOR_MODE_ATTRIBUTE", () => $4a66c7671722008d$export$a00eac3f8684bcd0);
$parcel$export(module.exports, "CONTRAST_MODE_ATTRIBUTE", () => $4a66c7671722008d$export$2112803007239c61);
$parcel$export(module.exports, "CUSTOM_THEME_ATTRIBUTE", () => $4a66c7671722008d$export$352e418ed5b6193a);
var $4a66c7671722008d$export$4ef52930e33717cd = 'data-theme';
var $4a66c7671722008d$export$cb374d25ded7f6ab = 'data-subtree-theme';
var $4a66c7671722008d$export$a00eac3f8684bcd0 = 'data-color-mode';
var $4a66c7671722008d$export$2112803007239c61 = 'data-contrast-mode';
var $4a66c7671722008d$export$352e418ed5b6193a = 'data-custom-theme';
var $4a66c7671722008d$export$6f0c6fb8c80fcc92 = 'ds';
var $4a66c7671722008d$export$4d0c7bbf80185957 = [
    'opacity',
    'font',
    'space',
    'border',
    'radius'
];
var $4a66c7671722008d$export$dddac1532e822863 = "--".concat($4a66c7671722008d$export$6f0c6fb8c80fcc92, "-token-not-found");
var $4a66c7671722008d$export$9d7b58831ae93caa = "--".concat($4a66c7671722008d$export$6f0c6fb8c80fcc92, "-elevation-surface-current");

});

parcelRegister("ltcA1", function(module, exports) {
$parcel$export(module.exports, "themeStateDefaults", () => $fa16108669e2223b$export$9aedcfa7336a207);

var $50U6m = parcelRequire("50U6m");
/**
 * Can't evaluate typography feature flags at the module level,
 * it will always resolve to false when server side rendered or when flags are loaded async.
 */ function $fa16108669e2223b$var$getShapeDefault() {
    if ((0, $50U6m.fg)('platform-dst-shape-theme-default')) return 'shape';
    return undefined;
}
function $fa16108669e2223b$var$getMotionDefault() {
    return 'motion';
}
var $fa16108669e2223b$export$9aedcfa7336a207 = {
    colorMode: 'auto',
    contrastMode: 'auto',
    dark: 'dark',
    light: 'light',
    shape: $fa16108669e2223b$var$getShapeDefault,
    spacing: 'spacing',
    typography: 'typography',
    motion: $fa16108669e2223b$var$getMotionDefault,
    UNSAFE_themeOptions: undefined
};

});

parcelRegister("7lZkr", function(module, exports) {
$parcel$export(module.exports, "hash", () => $55aa1127ddfd7edb$export$d6af199866bfb566);
var $55aa1127ddfd7edb$export$d6af199866bfb566 = function hash(str) {
    var hash = 0;
    for(var i = 0; i < str.length; i++){
        var char = str.charCodeAt(i);
        hash = (hash << 5) - hash + char;
        hash &= hash; // Convert to 32bit integer
    }
    return new Uint32Array([
        hash
    ])[0].toString(36);
};

});

parcelRegister("6QlWs", function(module, exports) {
$parcel$export(module.exports, "default", () => $4fb89e9a30ae96a5$export$2e2bcd8739ae039);
function $4fb89e9a30ae96a5$export$2e2bcd8739ae039(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}

});

parcelRegister("bLKSF", function(module, exports) {
$parcel$export(module.exports, "default", () => $89187309201444f6$export$2e2bcd8739ae039);

var $jRwnQ = parcelRequire("jRwnQ");
function $89187309201444f6$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, (0, $jRwnQ.default)(o.key), o);
    }
}
function $89187309201444f6$export$2e2bcd8739ae039(e, r, t) {
    return r && $89187309201444f6$var$_defineProperties(e.prototype, r), t && $89187309201444f6$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}

});

parcelRegister("gFy4Z", function(module, exports) {

var $iKwew = parcelRequire("iKwew");
module.exports = $iKwew("5I07s").then(()=>parcelRequire('7uI3K'));

});

parcelRegister("6hxgO", function(module, exports) {

var $iKwew = parcelRequire("iKwew");
module.exports = $iKwew("gwmb8").then(()=>parcelRequire('aMQqP'));

});

parcelRegister("kGGQc", function(module, exports) {

var $iKwew = parcelRequire("iKwew");
module.exports = $iKwew("fYnd9").then(()=>parcelRequire('cEGNn'));

});

parcelRegister("1Px1h", function(module, exports) {

var $iKwew = parcelRequire("iKwew");
module.exports = $iKwew("fSFTN").then(()=>parcelRequire('a6sSM'));

});

parcelRegister("4zl6X", function(module, exports) {

var $iKwew = parcelRequire("iKwew");
module.exports = $iKwew("dqkBw").then(()=>parcelRequire('aVWut'));

});

parcelRegister("g5BOX", function(module, exports) {

var $iKwew = parcelRequire("iKwew");
module.exports = $iKwew("lDlyF").then(()=>parcelRequire('zeVCj'));

});

parcelRegister("7rzwA", function(module, exports) {

var $iKwew = parcelRequire("iKwew");
module.exports = $iKwew("bhV0H").then(()=>parcelRequire('2Z4VQ'));

});

parcelRegister("exeGs", function(module, exports) {

var $iKwew = parcelRequire("iKwew");
module.exports = $iKwew("1jw2B").then(()=>parcelRequire('fOXJq'));

});

parcelRegister("aC2aM", function(module, exports) {

var $iKwew = parcelRequire("iKwew");
module.exports = $iKwew("cljyZ").then(()=>parcelRequire('6t7Hp'));

});

parcelRegister("cQyB6", function(module, exports) {

var $iKwew = parcelRequire("iKwew");
module.exports = $iKwew("h2PDi").then(()=>parcelRequire('iOTci'));

});

parcelRegister("Lk5z5", function(module, exports) {
$parcel$export(module.exports, "default", () => $08e3f91bf6acad1f$export$2e2bcd8739ae039);

var $brbkG = parcelRequire("brbkG");

var $34BnL = parcelRequire("34BnL");

var $3lyOK = parcelRequire("3lyOK");

var $jQXp1 = parcelRequire("jQXp1");
function $08e3f91bf6acad1f$export$2e2bcd8739ae039(r) {
    return (0, $brbkG.default)(r) || (0, $34BnL.default)(r) || (0, $3lyOK.default)(r) || (0, $jQXp1.default)();
}

});
parcelRegister("brbkG", function(module, exports) {
$parcel$export(module.exports, "default", () => $853b01c01b2fd1e8$export$2e2bcd8739ae039);

var $khwyd = parcelRequire("khwyd");
function $853b01c01b2fd1e8$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return (0, $khwyd.default)(r);
}

});

parcelRegister("34BnL", function(module, exports) {
$parcel$export(module.exports, "default", () => $23cebe23476bb984$export$2e2bcd8739ae039);
function $23cebe23476bb984$export$2e2bcd8739ae039(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}

});

parcelRegister("jQXp1", function(module, exports) {
$parcel$export(module.exports, "default", () => $03badaa4180eb182$export$2e2bcd8739ae039);
function $03badaa4180eb182$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});


parcelRegister("hQcOh", function(module, exports) {

var $iKwew = parcelRequire("iKwew");
module.exports = $iKwew("gJRGR").then(()=>parcelRequire('AnDvQ'));

});

parcelRegister("6qplN", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => (parcelRequire("dwvT6")).default);
$parcel$export(module.exports, "Icon", () => (parcelRequire("dwvT6")).Icon);
/**
 * @deprecated Import from the generated per-export subpath instead.
 */ 
var $dwvT6 = parcelRequire("dwvT6");
 /**
 * @deprecated Import from the generated per-export subpath instead.
 */ 
});
parcelRegister("dwvT6", function(module, exports) {
$parcel$export(module.exports, "Icon", () => $9d86ffc9dfda17fb$export$f04a61298a47a40f);
$parcel$export(module.exports, "default", () => $9d86ffc9dfda17fb$export$2e2bcd8739ae039);
/* icon-new.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $5FkrB = parcelRequire("5FkrB");

var $fLcYb = parcelRequire("fLcYb");
/**
 * We are hiding this props from consumers as it's reserved for use by Icon Tile.
 */ var $9d86ffc9dfda17fb$var$svgStyles = null;
var $9d86ffc9dfda17fb$var$iconStyles = null;
var $9d86ffc9dfda17fb$var$smallIconStyles = null;
var $9d86ffc9dfda17fb$var$scaleStyles = null;
/**
 * For windows high contrast mode
 */ var $9d86ffc9dfda17fb$var$baseHcmStyles = null;
var $9d86ffc9dfda17fb$var$scaleSize = null;
var $9d86ffc9dfda17fb$var$coreSizeMedium = {
    none: "_1bsbpxbi _4t3ipxbi",
    compact: "_1bsb1ejb _4t3i1ejb",
    spacious: "_1bsb1ejb _4t3i1ejb"
};
var $9d86ffc9dfda17fb$var$coreSizeSmall = {
    none: "_1bsbutpp _4t3iutpp",
    compact: "_1bsbpxbi _4t3ipxbi",
    spacious: "_1bsb1ejb _4t3i1ejb"
};
var $9d86ffc9dfda17fb$var$paddingMap = {
    medium: {
        none: 0,
        compact: 4,
        spacious: 4
    },
    small: {
        none: 0,
        compact: 2.66,
        spacious: 8
    }
};
var $9d86ffc9dfda17fb$export$f04a61298a47a40f = /*#__PURE__*/ (0, $5FkrB.memo)(function Icon(props) {
    var _ref = props, _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, testId = _ref.testId, label = _ref.label, dangerouslySetGlyph = _ref.dangerouslySetGlyph, shouldScale = _ref.shouldScale, _ref$spacing = _ref.spacing, spacing = _ref$spacing === void 0 ? 'none' : _ref$spacing, name = _ref.name;
    var dangerouslySetInnerHTML = dangerouslySetGlyph ? {
        __html: dangerouslySetGlyph
    } : undefined;
    var size = 'medium';
    if ('size' in props && props.size !== undefined) {
        if (typeof props.size === 'string') size = props.size === 'small' || props.size === 'medium' ? props.size : size;
        else if (name) {
            var newSize = props.size(name);
            size = newSize === 'small' || newSize === 'medium' ? newSize : size;
        }
    }
    var baseSize = 16;
    var viewBoxPadding = $9d86ffc9dfda17fb$var$paddingMap[size][spacing];
    var viewBoxSize = baseSize + 2 * viewBoxPadding;
    return /*#__PURE__*/ $5FkrB.createElement("span", {
        "data-testid": testId,
        role: label ? 'img' : undefined,
        "aria-label": label ? label : undefined,
        "aria-hidden": label ? undefined : true,
        style: {
            color: color
        },
        className: (0, $fLcYb.default)([
            "_1e0c1o8l _vchhusvi _1o9zidpf _vwz4kb7n _y4ti1igz _bozg1mb9",
            "_12va1onz _jcxd1r8n",
            shouldScale && "_1bsb1kw7 _4t3i1kw7",
            size === 'small' && "_vwz4utpp"
        ])
    }, /*#__PURE__*/ $5FkrB.createElement("svg", {
        fill: "none",
        viewBox: "".concat(0 - viewBoxPadding, " ").concat(0 - viewBoxPadding, " ").concat(viewBoxSize, " ").concat(viewBoxSize),
        role: "presentation",
        dangerouslySetInnerHTML: dangerouslySetInnerHTML,
        className: (0, $fLcYb.default)([
            "_1reo15vq _18m915vq _syaz1r31 _lcxvglyw _s7n4yfq0 _vc881r31",
            shouldScale ? "_1bsb1kw7 _4t3i1kw7" : size === 'small' ? $9d86ffc9dfda17fb$var$coreSizeSmall[spacing] : $9d86ffc9dfda17fb$var$coreSizeMedium[spacing]
        ])
    }));
});
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$9d86ffc9dfda17fb$export$2e2bcd8739ae039 = $9d86ffc9dfda17fb$export$f04a61298a47a40f;

});
parcelRegister("fLcYb", function(module, exports) {
$parcel$export(module.exports, "default", () => $b7954e525583a71b$export$2e2bcd8739ae039);
/**
 * The length of the value hash portion of an atomic class name.
 * Atomic class names have the format: `_<group><value>`
 * where group is ATOMIC_GROUP_HASH_LENGTH chars and value is ATOMIC_VALUE_HASH_LENGTH chars.
 *
 * We extract the group key using: `className.slice(0, className.length - ATOMIC_VALUE_HASH_LENGTH)`
 *
 * We support both old-format classes (9 chars: `_` + 4 group + 4 value) and
 * new-format classes (11 chars: `_` + 6 group + 4 value) by using length-based
 * extraction rather than a hardcoded offset — old and new format group keys
 * are different lengths so they are structurally disjoint and never alias each other.
 */ const $b7954e525583a71b$var$ATOMIC_VALUE_HASH_LENGTH = 4;
function $b7954e525583a71b$export$2e2bcd8739ae039(classNames) {
    // Shortcut: nothing to do
    if (!classNames.length) return;
    // Shortcut: don't need to do anything if we only have a single classname
    if (classNames.length === 1 && classNames[0] && // checking to see if `classNames[0]` is a string that contains other classnames
    !classNames[0].includes(' ')) return classNames[0];
    // Using an object rather than a `Map` as it performed better in our benchmarks.
    // Would be happy to move to `Map` if it proved to be better under real conditions.
    const map = {};
    // Note: using loops to minimize iterations over the collection
    for (const value of classNames){
        // Exclude all falsy values, which leaves us with populated strings
        if (!value) continue;
        // a `value` can contain multiple classnames
        const list = value.split(' ');
        for (const className of list){
            /**
             * For atomic style classnames: the `key` is the `group`
             *
             * - Later atomic classnames with the same `group` will override earlier ones
             *   (which is what we want).
             * - Assumes atomic classnames are the only things that start with `_`
             * - Could use a regex to ensure that atomic classnames are structured how we expect,
             *   but did not add that for now as it did slow things down a bit.
             *
             * For other classnames: the `key` is the whole classname
             * - Okay to remove duplicates as doing so does not impact specificity
             *
             * */ const key = className.startsWith('_') ? className.slice(0, className.length - $b7954e525583a71b$var$ATOMIC_VALUE_HASH_LENGTH) : className;
            map[key] = className;
        }
    }
    /**
     * We are converting the `map` into a string.
     *
     * The simple way to do this would be `Object.values(map).join(' ')`.
     * However, the approach below performs 10%-20% better in benchmarks.
     *
     * For `ax()` it feels right to squeeze as much runtime performance out as we can.
     */ let result = '';
    for(const key in map)result += map[key] + ' ';
    // If we have an empty string, then our `map` was empty.
    if (!result) return;
    // remove last " " from the result (we added " " at the end of every value)
    return result.trimEnd();
}

});



parcelRegister("gDzom", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "Icon", () => $c1cbbdf3204a3ef0$export$f04a61298a47a40f);
$parcel$export(module.exports, "default", () => $c1cbbdf3204a3ef0$export$2e2bcd8739ae039);
/* icon-new.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $5FkrB = parcelRequire("5FkrB");

var $5Ejvu = parcelRequire("5Ejvu");
/**
 * We are hiding this props from consumers as it's reserved for use by Icon Tile.
 */ var $c1cbbdf3204a3ef0$var$svgStyles = null;
var $c1cbbdf3204a3ef0$var$iconStyles = null;
var $c1cbbdf3204a3ef0$var$smallIconStyles = null;
var $c1cbbdf3204a3ef0$var$scaleStyles = null;
/**
 * For windows high contrast mode
 */ var $c1cbbdf3204a3ef0$var$baseHcmStyles = null;
var $c1cbbdf3204a3ef0$var$scaleSize = null;
var $c1cbbdf3204a3ef0$var$coreSizeMedium = {
    none: "_1bsbpxbi _4t3ipxbi",
    compact: "_1bsb1ejb _4t3i1ejb",
    spacious: "_1bsb1ejb _4t3i1ejb"
};
var $c1cbbdf3204a3ef0$var$coreSizeSmall = {
    none: "_1bsbutpp _4t3iutpp",
    compact: "_1bsbpxbi _4t3ipxbi",
    spacious: "_1bsb1ejb _4t3i1ejb"
};
var $c1cbbdf3204a3ef0$var$paddingMap = {
    medium: {
        none: 0,
        compact: 4,
        spacious: 4
    },
    small: {
        none: 0,
        compact: 2.66,
        spacious: 8
    }
};
var $c1cbbdf3204a3ef0$export$f04a61298a47a40f = /*#__PURE__*/ (0, $5FkrB.memo)(function Icon(props) {
    var _ref = props, _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, testId = _ref.testId, label = _ref.label, dangerouslySetGlyph = _ref.dangerouslySetGlyph, shouldScale = _ref.shouldScale, _ref$spacing = _ref.spacing, spacing = _ref$spacing === void 0 ? 'none' : _ref$spacing, name = _ref.name;
    var dangerouslySetInnerHTML = dangerouslySetGlyph ? {
        __html: dangerouslySetGlyph
    } : undefined;
    var size = 'medium';
    if ('size' in props && props.size !== undefined) {
        if (typeof props.size === 'string') size = props.size === 'small' || props.size === 'medium' ? props.size : size;
        else if (name) {
            var newSize = props.size(name);
            size = newSize === 'small' || newSize === 'medium' ? newSize : size;
        }
    }
    var baseSize = 16;
    var viewBoxPadding = $c1cbbdf3204a3ef0$var$paddingMap[size][spacing];
    var viewBoxSize = baseSize + 2 * viewBoxPadding;
    return /*#__PURE__*/ $5FkrB.createElement("span", {
        "data-testid": testId,
        role: label ? 'img' : undefined,
        "aria-label": label ? label : undefined,
        "aria-hidden": label ? undefined : true,
        style: {
            color: color
        },
        className: (0, $5Ejvu.default)([
            "_1e0c1o8l _vchhusvi _1o9zidpf _vwz4kb7n _y4ti1igz _bozg1mb9",
            "_12va1onz _jcxd1r8n",
            shouldScale && "_1bsb1kw7 _4t3i1kw7",
            size === 'small' && "_vwz4utpp"
        ])
    }, /*#__PURE__*/ $5FkrB.createElement("svg", {
        fill: "none",
        viewBox: "".concat(0 - viewBoxPadding, " ").concat(0 - viewBoxPadding, " ").concat(viewBoxSize, " ").concat(viewBoxSize),
        role: "presentation",
        dangerouslySetInnerHTML: dangerouslySetInnerHTML,
        className: (0, $5Ejvu.default)([
            "_1reo15vq _18m915vq _syaz1r31 _lcxvglyw _s7n4yfq0 _vc881r31",
            shouldScale ? "_1bsb1kw7 _4t3i1kw7" : size === 'small' ? $c1cbbdf3204a3ef0$var$coreSizeSmall[spacing] : $c1cbbdf3204a3ef0$var$coreSizeMedium[spacing]
        ])
    }));
});
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$c1cbbdf3204a3ef0$export$2e2bcd8739ae039 = $c1cbbdf3204a3ef0$export$f04a61298a47a40f;

});
parcelRegister("5Ejvu", function(module, exports) {
$parcel$export(module.exports, "default", () => $41cfd1d1a954e956$export$2e2bcd8739ae039);
/**
 * The length of the value hash portion of an atomic class name.
 * Atomic class names have the format: `_<group><value>`
 * where group is ATOMIC_GROUP_HASH_LENGTH chars and value is ATOMIC_VALUE_HASH_LENGTH chars.
 *
 * We extract the group key using: `className.slice(0, className.length - ATOMIC_VALUE_HASH_LENGTH)`
 *
 * We support both old-format classes (9 chars: `_` + 4 group + 4 value) and
 * new-format classes (11 chars: `_` + 6 group + 4 value) by using length-based
 * extraction rather than a hardcoded offset — old and new format group keys
 * are different lengths so they are structurally disjoint and never alias each other.
 */ const $41cfd1d1a954e956$var$ATOMIC_VALUE_HASH_LENGTH = 4;
function $41cfd1d1a954e956$export$2e2bcd8739ae039(classNames) {
    // Shortcut: nothing to do
    if (!classNames.length) return;
    // Shortcut: don't need to do anything if we only have a single classname
    if (classNames.length === 1 && classNames[0] && // checking to see if `classNames[0]` is a string that contains other classnames
    !classNames[0].includes(' ')) return classNames[0];
    // Using an object rather than a `Map` as it performed better in our benchmarks.
    // Would be happy to move to `Map` if it proved to be better under real conditions.
    const map = {};
    // Note: using loops to minimize iterations over the collection
    for (const value of classNames){
        // Exclude all falsy values, which leaves us with populated strings
        if (!value) continue;
        // a `value` can contain multiple classnames
        const list = value.split(' ');
        for (const className of list){
            /**
             * For atomic style classnames: the `key` is the `group`
             *
             * - Later atomic classnames with the same `group` will override earlier ones
             *   (which is what we want).
             * - Assumes atomic classnames are the only things that start with `_`
             * - Could use a regex to ensure that atomic classnames are structured how we expect,
             *   but did not add that for now as it did slow things down a bit.
             *
             * For other classnames: the `key` is the whole classname
             * - Okay to remove duplicates as doing so does not impact specificity
             *
             * */ const key = className.startsWith('_') ? className.slice(0, className.length - $41cfd1d1a954e956$var$ATOMIC_VALUE_HASH_LENGTH) : className;
            map[key] = className;
        }
    }
    /**
     * We are converting the `map` into a string.
     *
     * The simple way to do this would be `Object.values(map).join(' ')`.
     * However, the approach below performs 10%-20% better in benchmarks.
     *
     * For `ax()` it feels right to squeeze as much runtime performance out as we can.
     */ let result = '';
    for(const key in map)result += map[key] + ' ';
    // If we have an empty string, then our `map` was empty.
    if (!result) return;
    // remove last " " from the result (we added " " at the end of every value)
    return result.trimEnd();
}

});


parcelRegister("jglJy", function(module, exports) {

var $lXlCB = parcelRequire("lXlCB");
var $e0605ed4b256d095$var$_typeof = $lXlCB.default;
function $e0605ed4b256d095$var$_regeneratorRuntime() {
    "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ 
    module.exports = $e0605ed4b256d095$var$_regeneratorRuntime = function _regeneratorRuntime() {
        return e;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports;
    var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function(t, e, r) {
        t[e] = r.value;
    }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag";
    function define(t, e, r) {
        return Object.defineProperty(t, e, {
            value: r,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }), t[e];
    }
    try {
        define({}, "");
    } catch (t) {
        define = function define(t, e, r) {
            return t[e] = r;
        };
    }
    function wrap(t, e, r, n) {
        var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []);
        return o(a, "_invoke", {
            value: makeInvokeMethod(t, r, c)
        }), a;
    }
    function tryCatch(t, e, r) {
        try {
            return {
                type: "normal",
                arg: t.call(e, r)
            };
        } catch (t) {
            return {
                type: "throw",
                arg: t
            };
        }
    }
    e.wrap = wrap;
    var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {};
    function Generator() {}
    function GeneratorFunction() {}
    function GeneratorFunctionPrototype() {}
    var p = {};
    define(p, a, function() {
        return this;
    });
    var d = Object.getPrototypeOf, v = d && d(d(values([])));
    v && v !== r && n.call(v, a) && (p = v);
    var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p);
    function defineIteratorMethods(t) {
        [
            "next",
            "throw",
            "return"
        ].forEach(function(e) {
            define(t, e, function(t) {
                return this._invoke(e, t);
            });
        });
    }
    function AsyncIterator(t, e) {
        function invoke(r, o, i, a) {
            var c = tryCatch(t[r], t, o);
            if ("throw" !== c.type) {
                var u = c.arg, h = u.value;
                return h && "object" == $e0605ed4b256d095$var$_typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function(t) {
                    invoke("next", t, i, a);
                }, function(t) {
                    invoke("throw", t, i, a);
                }) : e.resolve(h).then(function(t) {
                    u.value = t, i(u);
                }, function(t) {
                    return invoke("throw", t, i, a);
                });
            }
            a(c.arg);
        }
        var r;
        o(this, "_invoke", {
            value: function value(t, n) {
                function callInvokeWithMethodAndArg() {
                    return new e(function(e, r) {
                        invoke(t, n, e, r);
                    });
                }
                return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
            }
        });
    }
    function makeInvokeMethod(e, r, n) {
        var o = h;
        return function(i, a) {
            if (o === f) throw Error("Generator is already running");
            if (o === s) {
                if ("throw" === i) throw a;
                return {
                    value: t,
                    done: !0
                };
            }
            for(n.method = i, n.arg = a;;){
                var c = n.delegate;
                if (c) {
                    var u = maybeInvokeDelegate(c, n);
                    if (u) {
                        if (u === y) continue;
                        return u;
                    }
                }
                if ("next" === n.method) n.sent = n._sent = n.arg;
                else if ("throw" === n.method) {
                    if (o === h) throw o = s, n.arg;
                    n.dispatchException(n.arg);
                } else "return" === n.method && n.abrupt("return", n.arg);
                o = f;
                var p = tryCatch(e, r, n);
                if ("normal" === p.type) {
                    if (o = n.done ? s : l, p.arg === y) continue;
                    return {
                        value: p.arg,
                        done: n.done
                    };
                }
                "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg);
            }
        };
    }
    function maybeInvokeDelegate(e, r) {
        var n = r.method, o = e.iterator[n];
        if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y;
        var i = tryCatch(o, e.iterator, r.arg);
        if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y;
        var a = i.arg;
        return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y);
    }
    function pushTryEntry(t) {
        var e = {
            tryLoc: t[0]
        };
        1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e);
    }
    function resetTryEntry(t) {
        var e = t.completion || {};
        e.type = "normal", delete e.arg, t.completion = e;
    }
    function Context(t) {
        this.tryEntries = [
            {
                tryLoc: "root"
            }
        ], t.forEach(pushTryEntry, this), this.reset(!0);
    }
    function values(e) {
        if (e || "" === e) {
            var r = e[a];
            if (r) return r.call(e);
            if ("function" == typeof e.next) return e;
            if (!isNaN(e.length)) {
                var o = -1, i = function next() {
                    for(; ++o < e.length;)if (n.call(e, o)) return next.value = e[o], next.done = !1, next;
                    return next.value = t, next.done = !0, next;
                };
                return i.next = i;
            }
        }
        throw new TypeError($e0605ed4b256d095$var$_typeof(e) + " is not iterable");
    }
    return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", {
        value: GeneratorFunctionPrototype,
        configurable: !0
    }), o(GeneratorFunctionPrototype, "constructor", {
        value: GeneratorFunction,
        configurable: !0
    }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function(t) {
        var e = "function" == typeof t && t.constructor;
        return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name));
    }, e.mark = function(t) {
        return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t;
    }, e.awrap = function(t) {
        return {
            __await: t
        };
    }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function() {
        return this;
    }), e.AsyncIterator = AsyncIterator, e.async = function(t, r, n, o, i) {
        void 0 === i && (i = Promise);
        var a = new AsyncIterator(wrap(t, r, n, o), i);
        return e.isGeneratorFunction(r) ? a : a.next().then(function(t) {
            return t.done ? t.value : a.next();
        });
    }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function() {
        return this;
    }), define(g, "toString", function() {
        return "[object Generator]";
    }), e.keys = function(t) {
        var e = Object(t), r = [];
        for(var n in e)r.push(n);
        return r.reverse(), function next() {
            for(; r.length;){
                var t = r.pop();
                if (t in e) return next.value = t, next.done = !1, next;
            }
            return next.done = !0, next;
        };
    }, e.values = values, Context.prototype = {
        constructor: Context,
        reset: function reset(e) {
            if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for(var r in this)"t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t);
        },
        stop: function stop() {
            this.done = !0;
            var t = this.tryEntries[0].completion;
            if ("throw" === t.type) throw t.arg;
            return this.rval;
        },
        dispatchException: function dispatchException(e) {
            if (this.done) throw e;
            var r = this;
            function handle(n, o) {
                return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o;
            }
            for(var o = this.tryEntries.length - 1; o >= 0; --o){
                var i = this.tryEntries[o], a = i.completion;
                if ("root" === i.tryLoc) return handle("end");
                if (i.tryLoc <= this.prev) {
                    var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc");
                    if (c && u) {
                        if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
                        if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
                    } else if (c) {
                        if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
                    } else {
                        if (!u) throw Error("try statement without catch or finally");
                        if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
                    }
                }
            }
        },
        abrupt: function abrupt(t, e) {
            for(var r = this.tryEntries.length - 1; r >= 0; --r){
                var o = this.tryEntries[r];
                if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
                    var i = o;
                    break;
                }
            }
            i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null);
            var a = i ? i.completion : {};
            return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a);
        },
        complete: function complete(t, e) {
            if ("throw" === t.type) throw t.arg;
            return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y;
        },
        finish: function finish(t) {
            for(var e = this.tryEntries.length - 1; e >= 0; --e){
                var r = this.tryEntries[e];
                if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y;
            }
        },
        "catch": function _catch(t) {
            for(var e = this.tryEntries.length - 1; e >= 0; --e){
                var r = this.tryEntries[e];
                if (r.tryLoc === t) {
                    var n = r.completion;
                    if ("throw" === n.type) {
                        var o = n.arg;
                        resetTryEntry(r);
                    }
                    return o;
                }
            }
            throw Error("illegal catch attempt");
        },
        delegateYield: function delegateYield(e, r, n) {
            return this.delegate = {
                iterator: values(e),
                resultName: r,
                nextLoc: n
            }, "next" === this.method && (this.arg = t), y;
        }
    }, e;
}
module.exports = $e0605ed4b256d095$var$_regeneratorRuntime, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("lXlCB", function(module, exports) {
function $ffbfe1433e35d403$var$_typeof(o) {
    "@babel/helpers - typeof";
    return module.exports = $ffbfe1433e35d403$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $ffbfe1433e35d403$var$_typeof(o);
}
module.exports = $ffbfe1433e35d403$var$_typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("haMz6", function(module, exports) {

var $iKwew = parcelRequire("iKwew");
module.exports = $iKwew("f7rV8").then(()=>parcelRequire('64Vmu'));

});

parcelRegister("b5PJM", function(module, exports) {

var $iKwew = parcelRequire("iKwew");
module.exports = $iKwew("25gVO").then(()=>parcelRequire('5qWiP'));

});

parcelRegister("pUh1o", function(module, exports) {

var $iKwew = parcelRequire("iKwew");
module.exports = $iKwew("cvfhK").then(()=>parcelRequire('gbZSq'));

});

parcelRegister("hJIz5", function(module, exports) {

var $iKwew = parcelRequire("iKwew");
module.exports = $iKwew("foDZJ").then(()=>parcelRequire('7pMNV'));

});

parcelRegister("i5EFq", function(module, exports) {

var $iKwew = parcelRequire("iKwew");
module.exports = $iKwew("7KGob").then(()=>parcelRequire('h9dV4'));

});

parcelRegister("cTOZV", function(module, exports) {

var $iKwew = parcelRequire("iKwew");
module.exports = $iKwew("ddi0K").then(()=>parcelRequire('g0KET'));

});

parcelRegister("eIUU7", function(module, exports) {

var $iKwew = parcelRequire("iKwew");
module.exports = $iKwew("eLlNR").then(()=>parcelRequire('cQ5gU'));

});

parcelRegister("4Ob3J", function(module, exports) {

var $iKwew = parcelRequire("iKwew");
module.exports = $iKwew("lji21").then(()=>parcelRequire('9Hpga'));

});

parcelRegister("6bSAo", function(module, exports) {

var $iKwew = parcelRequire("iKwew");
module.exports = $iKwew("5tfws").then(()=>parcelRequire('21sXE'));

});

parcelRegister("b396J", function(module, exports) {

var $iKwew = parcelRequire("iKwew");
module.exports = $iKwew("5If7z").then(()=>parcelRequire('699yC'));

});

parcelRegister("98HMn", function(module, exports) {

var $iKwew = parcelRequire("iKwew");
module.exports = $iKwew("6gfDY").then(()=>parcelRequire('jmmoD'));

});

parcelRegister("lINaI", function(module, exports) {

var $iKwew = parcelRequire("iKwew");
module.exports = $iKwew("1yYUO").then(()=>parcelRequire('PpAPH'));

});

parcelRegister("5pEXZ", function(module, exports) {

var $iKwew = parcelRequire("iKwew");
module.exports = $iKwew("9QbCE").then(()=>parcelRequire('9pttb'));

});

parcelRegister("1pceg", function(module, exports) {

var $iKwew = parcelRequire("iKwew");
module.exports = $iKwew("iFc2Q").then(()=>parcelRequire('7BjWU'));

});

parcelRegister("83GJZ", function(module, exports) {

var $iKwew = parcelRequire("iKwew");
module.exports = $iKwew("2ZXm9").then(()=>parcelRequire('cju2n'));

});

parcelRegister("9sDTl", function(module, exports) {

var $iKwew = parcelRequire("iKwew");
module.exports = $iKwew("fTTbY").then(()=>parcelRequire('eINuI'));

});

parcelRegister("fyQBL", function(module, exports) {

var $iKwew = parcelRequire("iKwew");
module.exports = $iKwew("zNuA3").then(()=>parcelRequire('1QEPm'));

});

parcelRegister("hYjC7", function(module, exports) {

var $iKwew = parcelRequire("iKwew");
module.exports = $iKwew("6zbko").then(()=>parcelRequire('lcUfz'));

});

parcelRegister("4URDm", function(module, exports) {

var $iKwew = parcelRequire("iKwew");
module.exports = $iKwew("iTgDs").then(()=>parcelRequire('ffd9n'));

});

parcelRegister("izPbQ", function(module, exports) {

var $iKwew = parcelRequire("iKwew");
module.exports = $iKwew("7Sgrm").then(()=>parcelRequire('ls5Ib'));

});

parcelRegister("iBleh", function(module, exports) {

var $iKwew = parcelRequire("iKwew");
module.exports = $iKwew("89ypv").then(()=>parcelRequire('eLG9h'));

});

parcelRegister("hgetp", function(module, exports) {

var $iKwew = parcelRequire("iKwew");
module.exports = $iKwew("lfWI1").then(()=>parcelRequire('domIf'));

});

parcelRegister("dsSdF", function(module, exports) {

var $iKwew = parcelRequire("iKwew");
module.exports = $iKwew("etvpP").then(()=>parcelRequire('7T1so'));

});

parcelRegister("7UCkC", function(module, exports) {

var $iKwew = parcelRequire("iKwew");
module.exports = $iKwew("enmUX").then(()=>parcelRequire('hcHwe'));

});

parcelRegister("9Y2YI", function(module, exports) {

var $iKwew = parcelRequire("iKwew");
module.exports = $iKwew("5nd75").then(()=>parcelRequire('lFYPF'));

});

parcelRegister("1kaGM", function(module, exports) {

var $iKwew = parcelRequire("iKwew");
module.exports = $iKwew("1vPMF").then(()=>parcelRequire('iIQsE'));

});

parcelRegister("65kcv", function(module, exports) {

var $iKwew = parcelRequire("iKwew");
module.exports = $iKwew("3vbbx").then(()=>parcelRequire('h8Zl5'));

});

parcelRegister("69Vil", function(module, exports) {

var $iKwew = parcelRequire("iKwew");
module.exports = $iKwew("20pK4").then(()=>parcelRequire('8HQeO'));

});

parcelRegister("CXYQs", function(module, exports) {

var $iKwew = parcelRequire("iKwew");
module.exports = $iKwew("4QOjN").then(()=>parcelRequire('5ar98'));

});

parcelRegister("LP0zb", function(module, exports) {

var $iKwew = parcelRequire("iKwew");
module.exports = $iKwew("eTqpc").then(()=>parcelRequire('nc8A4'));

});

parcelRegister("3t9D4", function(module, exports) {

var $iKwew = parcelRequire("iKwew");
module.exports = $iKwew("d2ChU").then(()=>parcelRequire('aXUYB'));

});

parcelRegister("7CFjR", function(module, exports) {

var $iKwew = parcelRequire("iKwew");
module.exports = $iKwew("doo3w").then(()=>parcelRequire('eexHL'));

});

parcelRegister("4Vzmc", function(module, exports) {

var $iKwew = parcelRequire("iKwew");
module.exports = $iKwew("1hgDZ").then(()=>parcelRequire('2elrl'));

});

parcelRegister("l6gWb", function(module, exports) {

var $iKwew = parcelRequire("iKwew");
module.exports = $iKwew("v6Mi7").then(()=>parcelRequire('bh6Mh'));

});

parcelRegister("gRaCK", function(module, exports) {

var $iKwew = parcelRequire("iKwew");
module.exports = $iKwew("6U2Lb").then(()=>parcelRequire('4hYFX'));

});

parcelRegister("fxElF", function(module, exports) {

var $iKwew = parcelRequire("iKwew");
module.exports = $iKwew("cPgYJ").then(()=>parcelRequire('5AFLK'));

});

parcelRegister("2y1Vi", function(module, exports) {

var $iKwew = parcelRequire("iKwew");
module.exports = $iKwew("7MHOP").then(()=>parcelRequire('hUQ36'));

});

parcelRegister("74BOO", function(module, exports) {

var $iKwew = parcelRequire("iKwew");
module.exports = $iKwew("3LpYr").then(()=>parcelRequire('jIKMJ'));

});

parcelRegister("9zenb", function(module, exports) {

var $iKwew = parcelRequire("iKwew");
module.exports = $iKwew("bPL35").then(()=>parcelRequire('aFS8D'));

});

parcelRegister("9RiHi", function(module, exports) {

var $iKwew = parcelRequire("iKwew");
module.exports = $iKwew("4WrYW").then(()=>parcelRequire('eYf1l'));

});

parcelRegister("jNCUF", function(module, exports) {

var $iKwew = parcelRequire("iKwew");
module.exports = $iKwew("eMIqw").then(()=>parcelRequire('27Bqt'));

});

parcelRegister("1Psq8", function(module, exports) {

var $iKwew = parcelRequire("iKwew");
module.exports = $iKwew("1VvXi").then(()=>parcelRequire('bzqIo'));

});

parcelRegister("diOmO", function(module, exports) {

var $iKwew = parcelRequire("iKwew");
module.exports = $iKwew("gLuUl").then(()=>parcelRequire('6f2Pm'));

});

parcelRegister("hiOMe", function(module, exports) {

var $98QZy = parcelRequire("98QZy");
var $c98b815903f9523f$var$_typeof = $98QZy.default;
function $c98b815903f9523f$var$_regeneratorRuntime() {
    "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ 
    module.exports = $c98b815903f9523f$var$_regeneratorRuntime = function _regeneratorRuntime() {
        return e;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports;
    var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function(t, e, r) {
        t[e] = r.value;
    }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag";
    function define(t, e, r) {
        return Object.defineProperty(t, e, {
            value: r,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }), t[e];
    }
    try {
        define({}, "");
    } catch (t) {
        define = function define(t, e, r) {
            return t[e] = r;
        };
    }
    function wrap(t, e, r, n) {
        var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []);
        return o(a, "_invoke", {
            value: makeInvokeMethod(t, r, c)
        }), a;
    }
    function tryCatch(t, e, r) {
        try {
            return {
                type: "normal",
                arg: t.call(e, r)
            };
        } catch (t) {
            return {
                type: "throw",
                arg: t
            };
        }
    }
    e.wrap = wrap;
    var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {};
    function Generator() {}
    function GeneratorFunction() {}
    function GeneratorFunctionPrototype() {}
    var p = {};
    define(p, a, function() {
        return this;
    });
    var d = Object.getPrototypeOf, v = d && d(d(values([])));
    v && v !== r && n.call(v, a) && (p = v);
    var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p);
    function defineIteratorMethods(t) {
        [
            "next",
            "throw",
            "return"
        ].forEach(function(e) {
            define(t, e, function(t) {
                return this._invoke(e, t);
            });
        });
    }
    function AsyncIterator(t, e) {
        function invoke(r, o, i, a) {
            var c = tryCatch(t[r], t, o);
            if ("throw" !== c.type) {
                var u = c.arg, h = u.value;
                return h && "object" == $c98b815903f9523f$var$_typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function(t) {
                    invoke("next", t, i, a);
                }, function(t) {
                    invoke("throw", t, i, a);
                }) : e.resolve(h).then(function(t) {
                    u.value = t, i(u);
                }, function(t) {
                    return invoke("throw", t, i, a);
                });
            }
            a(c.arg);
        }
        var r;
        o(this, "_invoke", {
            value: function value(t, n) {
                function callInvokeWithMethodAndArg() {
                    return new e(function(e, r) {
                        invoke(t, n, e, r);
                    });
                }
                return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
            }
        });
    }
    function makeInvokeMethod(e, r, n) {
        var o = h;
        return function(i, a) {
            if (o === f) throw Error("Generator is already running");
            if (o === s) {
                if ("throw" === i) throw a;
                return {
                    value: t,
                    done: !0
                };
            }
            for(n.method = i, n.arg = a;;){
                var c = n.delegate;
                if (c) {
                    var u = maybeInvokeDelegate(c, n);
                    if (u) {
                        if (u === y) continue;
                        return u;
                    }
                }
                if ("next" === n.method) n.sent = n._sent = n.arg;
                else if ("throw" === n.method) {
                    if (o === h) throw o = s, n.arg;
                    n.dispatchException(n.arg);
                } else "return" === n.method && n.abrupt("return", n.arg);
                o = f;
                var p = tryCatch(e, r, n);
                if ("normal" === p.type) {
                    if (o = n.done ? s : l, p.arg === y) continue;
                    return {
                        value: p.arg,
                        done: n.done
                    };
                }
                "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg);
            }
        };
    }
    function maybeInvokeDelegate(e, r) {
        var n = r.method, o = e.iterator[n];
        if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y;
        var i = tryCatch(o, e.iterator, r.arg);
        if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y;
        var a = i.arg;
        return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y);
    }
    function pushTryEntry(t) {
        var e = {
            tryLoc: t[0]
        };
        1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e);
    }
    function resetTryEntry(t) {
        var e = t.completion || {};
        e.type = "normal", delete e.arg, t.completion = e;
    }
    function Context(t) {
        this.tryEntries = [
            {
                tryLoc: "root"
            }
        ], t.forEach(pushTryEntry, this), this.reset(!0);
    }
    function values(e) {
        if (e || "" === e) {
            var r = e[a];
            if (r) return r.call(e);
            if ("function" == typeof e.next) return e;
            if (!isNaN(e.length)) {
                var o = -1, i = function next() {
                    for(; ++o < e.length;)if (n.call(e, o)) return next.value = e[o], next.done = !1, next;
                    return next.value = t, next.done = !0, next;
                };
                return i.next = i;
            }
        }
        throw new TypeError($c98b815903f9523f$var$_typeof(e) + " is not iterable");
    }
    return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", {
        value: GeneratorFunctionPrototype,
        configurable: !0
    }), o(GeneratorFunctionPrototype, "constructor", {
        value: GeneratorFunction,
        configurable: !0
    }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function(t) {
        var e = "function" == typeof t && t.constructor;
        return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name));
    }, e.mark = function(t) {
        return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t;
    }, e.awrap = function(t) {
        return {
            __await: t
        };
    }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function() {
        return this;
    }), e.AsyncIterator = AsyncIterator, e.async = function(t, r, n, o, i) {
        void 0 === i && (i = Promise);
        var a = new AsyncIterator(wrap(t, r, n, o), i);
        return e.isGeneratorFunction(r) ? a : a.next().then(function(t) {
            return t.done ? t.value : a.next();
        });
    }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function() {
        return this;
    }), define(g, "toString", function() {
        return "[object Generator]";
    }), e.keys = function(t) {
        var e = Object(t), r = [];
        for(var n in e)r.push(n);
        return r.reverse(), function next() {
            for(; r.length;){
                var t = r.pop();
                if (t in e) return next.value = t, next.done = !1, next;
            }
            return next.done = !0, next;
        };
    }, e.values = values, Context.prototype = {
        constructor: Context,
        reset: function reset(e) {
            if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for(var r in this)"t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t);
        },
        stop: function stop() {
            this.done = !0;
            var t = this.tryEntries[0].completion;
            if ("throw" === t.type) throw t.arg;
            return this.rval;
        },
        dispatchException: function dispatchException(e) {
            if (this.done) throw e;
            var r = this;
            function handle(n, o) {
                return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o;
            }
            for(var o = this.tryEntries.length - 1; o >= 0; --o){
                var i = this.tryEntries[o], a = i.completion;
                if ("root" === i.tryLoc) return handle("end");
                if (i.tryLoc <= this.prev) {
                    var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc");
                    if (c && u) {
                        if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
                        if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
                    } else if (c) {
                        if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
                    } else {
                        if (!u) throw Error("try statement without catch or finally");
                        if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
                    }
                }
            }
        },
        abrupt: function abrupt(t, e) {
            for(var r = this.tryEntries.length - 1; r >= 0; --r){
                var o = this.tryEntries[r];
                if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
                    var i = o;
                    break;
                }
            }
            i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null);
            var a = i ? i.completion : {};
            return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a);
        },
        complete: function complete(t, e) {
            if ("throw" === t.type) throw t.arg;
            return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y;
        },
        finish: function finish(t) {
            for(var e = this.tryEntries.length - 1; e >= 0; --e){
                var r = this.tryEntries[e];
                if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y;
            }
        },
        "catch": function _catch(t) {
            for(var e = this.tryEntries.length - 1; e >= 0; --e){
                var r = this.tryEntries[e];
                if (r.tryLoc === t) {
                    var n = r.completion;
                    if ("throw" === n.type) {
                        var o = n.arg;
                        resetTryEntry(r);
                    }
                    return o;
                }
            }
            throw Error("illegal catch attempt");
        },
        delegateYield: function delegateYield(e, r, n) {
            return this.delegate = {
                iterator: values(e),
                resultName: r,
                nextLoc: n
            }, "next" === this.method && (this.arg = t), y;
        }
    }, e;
}
module.exports = $c98b815903f9523f$var$_regeneratorRuntime, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("98QZy", function(module, exports) {
function $6a7df780caad0384$var$_typeof(o) {
    "@babel/helpers - typeof";
    return module.exports = $6a7df780caad0384$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $6a7df780caad0384$var$_typeof(o);
}
module.exports = $6a7df780caad0384$var$_typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("hd2Rf", function(module, exports) {

var $2ERXP = parcelRequire("2ERXP");
var $c875de10f9334e71$var$_typeof = $2ERXP.default;
function $c875de10f9334e71$var$_regeneratorRuntime() {
    "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ 
    module.exports = $c875de10f9334e71$var$_regeneratorRuntime = function _regeneratorRuntime() {
        return e;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports;
    var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function(t, e, r) {
        t[e] = r.value;
    }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag";
    function define(t, e, r) {
        return Object.defineProperty(t, e, {
            value: r,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }), t[e];
    }
    try {
        define({}, "");
    } catch (t) {
        define = function define(t, e, r) {
            return t[e] = r;
        };
    }
    function wrap(t, e, r, n) {
        var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []);
        return o(a, "_invoke", {
            value: makeInvokeMethod(t, r, c)
        }), a;
    }
    function tryCatch(t, e, r) {
        try {
            return {
                type: "normal",
                arg: t.call(e, r)
            };
        } catch (t) {
            return {
                type: "throw",
                arg: t
            };
        }
    }
    e.wrap = wrap;
    var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {};
    function Generator() {}
    function GeneratorFunction() {}
    function GeneratorFunctionPrototype() {}
    var p = {};
    define(p, a, function() {
        return this;
    });
    var d = Object.getPrototypeOf, v = d && d(d(values([])));
    v && v !== r && n.call(v, a) && (p = v);
    var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p);
    function defineIteratorMethods(t) {
        [
            "next",
            "throw",
            "return"
        ].forEach(function(e) {
            define(t, e, function(t) {
                return this._invoke(e, t);
            });
        });
    }
    function AsyncIterator(t, e) {
        function invoke(r, o, i, a) {
            var c = tryCatch(t[r], t, o);
            if ("throw" !== c.type) {
                var u = c.arg, h = u.value;
                return h && "object" == $c875de10f9334e71$var$_typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function(t) {
                    invoke("next", t, i, a);
                }, function(t) {
                    invoke("throw", t, i, a);
                }) : e.resolve(h).then(function(t) {
                    u.value = t, i(u);
                }, function(t) {
                    return invoke("throw", t, i, a);
                });
            }
            a(c.arg);
        }
        var r;
        o(this, "_invoke", {
            value: function value(t, n) {
                function callInvokeWithMethodAndArg() {
                    return new e(function(e, r) {
                        invoke(t, n, e, r);
                    });
                }
                return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
            }
        });
    }
    function makeInvokeMethod(e, r, n) {
        var o = h;
        return function(i, a) {
            if (o === f) throw Error("Generator is already running");
            if (o === s) {
                if ("throw" === i) throw a;
                return {
                    value: t,
                    done: !0
                };
            }
            for(n.method = i, n.arg = a;;){
                var c = n.delegate;
                if (c) {
                    var u = maybeInvokeDelegate(c, n);
                    if (u) {
                        if (u === y) continue;
                        return u;
                    }
                }
                if ("next" === n.method) n.sent = n._sent = n.arg;
                else if ("throw" === n.method) {
                    if (o === h) throw o = s, n.arg;
                    n.dispatchException(n.arg);
                } else "return" === n.method && n.abrupt("return", n.arg);
                o = f;
                var p = tryCatch(e, r, n);
                if ("normal" === p.type) {
                    if (o = n.done ? s : l, p.arg === y) continue;
                    return {
                        value: p.arg,
                        done: n.done
                    };
                }
                "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg);
            }
        };
    }
    function maybeInvokeDelegate(e, r) {
        var n = r.method, o = e.iterator[n];
        if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y;
        var i = tryCatch(o, e.iterator, r.arg);
        if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y;
        var a = i.arg;
        return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y);
    }
    function pushTryEntry(t) {
        var e = {
            tryLoc: t[0]
        };
        1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e);
    }
    function resetTryEntry(t) {
        var e = t.completion || {};
        e.type = "normal", delete e.arg, t.completion = e;
    }
    function Context(t) {
        this.tryEntries = [
            {
                tryLoc: "root"
            }
        ], t.forEach(pushTryEntry, this), this.reset(!0);
    }
    function values(e) {
        if (e || "" === e) {
            var r = e[a];
            if (r) return r.call(e);
            if ("function" == typeof e.next) return e;
            if (!isNaN(e.length)) {
                var o = -1, i = function next() {
                    for(; ++o < e.length;)if (n.call(e, o)) return next.value = e[o], next.done = !1, next;
                    return next.value = t, next.done = !0, next;
                };
                return i.next = i;
            }
        }
        throw new TypeError($c875de10f9334e71$var$_typeof(e) + " is not iterable");
    }
    return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", {
        value: GeneratorFunctionPrototype,
        configurable: !0
    }), o(GeneratorFunctionPrototype, "constructor", {
        value: GeneratorFunction,
        configurable: !0
    }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function(t) {
        var e = "function" == typeof t && t.constructor;
        return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name));
    }, e.mark = function(t) {
        return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t;
    }, e.awrap = function(t) {
        return {
            __await: t
        };
    }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function() {
        return this;
    }), e.AsyncIterator = AsyncIterator, e.async = function(t, r, n, o, i) {
        void 0 === i && (i = Promise);
        var a = new AsyncIterator(wrap(t, r, n, o), i);
        return e.isGeneratorFunction(r) ? a : a.next().then(function(t) {
            return t.done ? t.value : a.next();
        });
    }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function() {
        return this;
    }), define(g, "toString", function() {
        return "[object Generator]";
    }), e.keys = function(t) {
        var e = Object(t), r = [];
        for(var n in e)r.push(n);
        return r.reverse(), function next() {
            for(; r.length;){
                var t = r.pop();
                if (t in e) return next.value = t, next.done = !1, next;
            }
            return next.done = !0, next;
        };
    }, e.values = values, Context.prototype = {
        constructor: Context,
        reset: function reset(e) {
            if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for(var r in this)"t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t);
        },
        stop: function stop() {
            this.done = !0;
            var t = this.tryEntries[0].completion;
            if ("throw" === t.type) throw t.arg;
            return this.rval;
        },
        dispatchException: function dispatchException(e) {
            if (this.done) throw e;
            var r = this;
            function handle(n, o) {
                return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o;
            }
            for(var o = this.tryEntries.length - 1; o >= 0; --o){
                var i = this.tryEntries[o], a = i.completion;
                if ("root" === i.tryLoc) return handle("end");
                if (i.tryLoc <= this.prev) {
                    var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc");
                    if (c && u) {
                        if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
                        if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
                    } else if (c) {
                        if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
                    } else {
                        if (!u) throw Error("try statement without catch or finally");
                        if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
                    }
                }
            }
        },
        abrupt: function abrupt(t, e) {
            for(var r = this.tryEntries.length - 1; r >= 0; --r){
                var o = this.tryEntries[r];
                if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
                    var i = o;
                    break;
                }
            }
            i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null);
            var a = i ? i.completion : {};
            return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a);
        },
        complete: function complete(t, e) {
            if ("throw" === t.type) throw t.arg;
            return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y;
        },
        finish: function finish(t) {
            for(var e = this.tryEntries.length - 1; e >= 0; --e){
                var r = this.tryEntries[e];
                if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y;
            }
        },
        "catch": function _catch(t) {
            for(var e = this.tryEntries.length - 1; e >= 0; --e){
                var r = this.tryEntries[e];
                if (r.tryLoc === t) {
                    var n = r.completion;
                    if ("throw" === n.type) {
                        var o = n.arg;
                        resetTryEntry(r);
                    }
                    return o;
                }
            }
            throw Error("illegal catch attempt");
        },
        delegateYield: function delegateYield(e, r, n) {
            return this.delegate = {
                iterator: values(e),
                resultName: r,
                nextLoc: n
            }, "next" === this.method && (this.arg = t), y;
        }
    }, e;
}
module.exports = $c875de10f9334e71$var$_regeneratorRuntime, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("2ERXP", function(module, exports) {
function $1ef92d4dca33ba97$var$_typeof(o) {
    "@babel/helpers - typeof";
    return module.exports = $1ef92d4dca33ba97$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $1ef92d4dca33ba97$var$_typeof(o);
}
module.exports = $1ef92d4dca33ba97$var$_typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("2X8pS", function(module, exports) {
module.exports = JSON.parse("{\"compositionKeyMap\":{\"cc\":\"commercial-cloud\",\"ic\":\"isolated-cloud-commercial\",\"fm\":\"fedramp-moderate\"},\"environmentBlocks\":{\"adminhub\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"admin-hub-threat-detection-system-for-custom-domains\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"adminhub-access-requests\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"adminhub-add-app-beta-grid\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"adminhub-add-app-collections-grid\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"adminhub-add-app-discover-grid\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"adminhub-add-app-enterprise-grid\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true}},\"adminhub-add-app-standalone-apps-grid\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"adminhub-add-product\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true}},\"adminhub-admin-insights\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"adminhub-ai-enabled-apps\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"adminhub-api-token-controls\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"adminhub-app-requests\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"adminhub-app-updates\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"adminhub-application-tunnels\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"adminhub-apps-discovery\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"adminhub-atlassian-intelligence\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"adminhub-audit-log\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"adminhub-authentication-policies\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"adminhub-automations\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"adminhub-backup-and-restore\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"adminhub-billing-console\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"adminhub-billing-preview\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"adminhub-byok\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"adminhub-cart\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"adminhub-cmk-encryption\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"adminhub-code-intelligence\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"adminhub-connected-emoji\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true}},\"adminhub-connected-sources\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"adminhub-connector-protection\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"adminhub-contacts\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"adminhub-custom-domain-email-notification\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true}},\"adminhub-custom-domains\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"adminhub-data-classifications\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"adminhub-data-management\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"adminhub-data-residency\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"adminhub-data-security-policies\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"adminhub-data-transfer\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"adminhub-delta-migrations\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"adminhub-disaster-recovery\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"adminhub-discover-apps-shadow-it\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"adminhub-discover-new-products\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"adminhub-enable-user-merge\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"adminhub-encryption\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"adminhub-environments\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"adminhub-experiment-controls\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"adminhub-external-user-security\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true}},\"adminhub-footprint\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"adminhub-freeze-windows\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"adminhub-guard-detect-alerts\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"adminhub-guard-detect-detections\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"adminhub-help\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true}},\"adminhub-hippa-compliance\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"adminhub-jsm-scim\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"adminhub-link-bitbucket\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"adminhub-llm\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"adminhub-login-customisation\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"adminhub-managed-accounts-export\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"adminhub-marketplace-apps\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"adminhub-mcp-settings\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"adminhub-mobile-app-policy\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"adminhub-nested-side-navigation\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true}},\"adminhub-org-audit-logs\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"adminhub-org-create\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"adminhub-org-deletion\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"adminhub-org-transfer\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"adminhub-performance-monitoring\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"adminhub-platform-usage\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"adminhub-policies\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"adminhub-product-insights-workflow-discovery\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"adminhub-product-insights\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"adminhub-product-links\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"adminhub-product-recommendation\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"adminhub-product-urls\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"adminhub-release-tracks\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"adminhub-revamped-organization-overview\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"adminhub-rovo-access\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"adminhub-rovo-chat-protection\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"adminhub-rovo-insights\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"adminhub-rovo-mcp-server\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"adminhub-rovo-settings\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"adminhub-saml-sso\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"adminhub-sandbox\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"adminhub-security-checklist\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"adminhub-sensitive-data-policies\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"adminhub-signup\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"adminhub-site-rename\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"adminhub-site-transfer\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"adminhub-system-health\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"adminhub-team-site-assignment\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"adminhub-teams\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"adminhub-teamwork-graph-cli\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"adminhub-units\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"adminhub-use-available-apps\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"adminhub-user-access-invites\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"adminhub-user-access-settings\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"adminhub-user-connected-apps\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"adminhub-user-counts\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"adminhub-user-last-active-timestamp\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true}},\"adminhub-workspaces-table-plans\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true}},\"core-adminhub\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}}}},\"assets\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"assets-data-manager\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"assets-recent-items\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true}},\"assets-reports\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true}},\"assets-rovo-search\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"core-assets\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}}}},\"atlassian-analytics\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true},\"features\":{\"atlassian-analytics-3p-data-source-connections\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"atlassian-analytics-chart-dashboard-pdf-png-exports\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"atlassian-analytics-chart-templates\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true}},\"atlassian-analytics-charts\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true}},\"atlassian-analytics-comments\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true}},\"atlassian-analytics-commerce-sentry\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"atlassian-analytics-cross-product-interaction-client\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"atlassian-analytics-dashboard-subscriptions\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true}},\"atlassian-analytics-dashboard-templates\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true}},\"atlassian-analytics-dashboards\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true}},\"atlassian-analytics-data-lake-connections\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true}},\"atlassian-analytics-data-shares\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"atlassian-analytics-jira-align-enterprise-insights-connections\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"core-atlassian-analytics\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true}}}},\"bitbucket\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false},\"features\":{\"bitbucket-development-events-and-status\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"bitbucket-merge-queue\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"bitbucket-slack-app\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"bitbucket-ssh-key-validation\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"pipelines\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}}}},\"chat\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false},\"features\":{}},\"compass\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false},\"features\":{}},\"confluence\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"ccma\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"confluence-ai\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"confluence-anonymous-access\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"confluence-comment-and-header-links\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"confluence-company-hub\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"confluence-content-archiving\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"confluence-content-manager\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"confluence-databases\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false},\"availabilityMetadata\":{\"fm\":{\"auditPhase\":\"internal-audit\"}}},\"confluence-editing-experience\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"confluence-edition-awareness\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"confluence-editor-offline-storage\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"confluence-embedded-pages\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"confluence-employee-directory\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"confluence-forge-apps-sidebar\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"confluence-inline-comments-in-edit-mode\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"confluence-inspect-permissions\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"confluence-invitations\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true}},\"confluence-loom-integration\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"confluence-mission-control\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"confluence-mobile-app\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"confluence-ms-teams-integration\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true}},\"confluence-page-analytics\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"confluence-pages-blogs-folders\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"confluence-premium-onboarding\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"confluence-presenter-mode\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"confluence-public-links\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"confluence-questions-native-experience\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"confluence-questions\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"confluence-recap\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"confluence-search\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"confluence-server\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"confluence-share-to-slack-button\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"confluence-single-space-guests\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"confluence-slack-integration\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"confluence-slides\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"confluence-smart-links\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"confluence-space-analytics\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"confluence-team-calendars\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"confluence-update-page-owners\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"confluence-whiteboards\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false},\"availabilityMetadata\":{\"fm\":{\"auditPhase\":\"internal-audit\"}}},\"core-confluence\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}}}},\"customer-service-management\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false},\"features\":{}},\"dx\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false},\"features\":{}},\"feedback\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{}},\"focus\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false},\"features\":{\"asks-and-planning\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}}}},\"goals\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false},\"features\":{}},\"guard-premium\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{}},\"home\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false},\"features\":{\"home-org-chart-analytics-pipeline\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"home-status-backend\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}}}},\"jira\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-jira\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"issue-transition-customisation-for-srb\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"jcma-x2c\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true}},\"jcma\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"jira-admin-oauth-credentials\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"jira-ai-issue-classification\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"jira-ai-snippet\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"jira-ai-upsell-in-editor-free\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"jira-apps-menu\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true}},\"jira-atlassian-intelligence\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"jira-atlassian-vs-code-extension\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"jira-audit-log\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"jira-backlogs\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"jira-boards-and-views\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"jira-calendar-view\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"jira-company-managed-projects\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"jira-components\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"jira-dashboard-public-sharing\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"jira-demux\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"jira-development-hub\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"jira-development-tab-druid-metric-cards\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"jira-development-tab\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true}},\"jira-devinfo-async-pull-request-icon\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"jira-devops-toolchain\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"jira-edition-awareness\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"jira-figma-integration\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"jira-forms\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"jira-github-for-jira\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true}},\"jira-github-workflows\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"jira-goals-nav\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"jira-import-work-sidebar\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"jira-in-product-help\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"jira-insights\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"jira-invite-people\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true}},\"jira-issue\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"jira-jpd-nav-recommendations\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"jira-jpd-roadmap-on-timeline-cross-sell\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"jira-loom-banner\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"jira-marketplace-sidebar-recommendations\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"jira-mobile-app\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"jira-ms-teams-integration\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"jira-next-best-task\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"jira-oasis-reports\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true}},\"jira-opsgenie\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"jira-plans\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"jira-project-archiving\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"jira-project-issue-navigator\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"jira-project-templates\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"jira-project-theme-unsplash\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"jira-quickstart-pages\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"jira-releases\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"jira-roadmap-in-nav\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"jira-share\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"jira-site-optimiser\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"jira-slack\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"jira-smart-links\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"jira-smart-related-issues\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"jira-software-devops\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"jira-software-reports-cycle-time\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"jira-software-reports-deployment-frequency\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"jira-spreadsheets-integration\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"jira-synced-blocks\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"jira-team-managed-projects\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"jira-unsplash\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"jira-whiteboards-backlog-experiment\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true}},\"jira-work-item-archiving\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"jira-work-suggestions\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"jira-workflow-configuration\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"jira-your-work-dashboard\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"modern-issue-transition-connect-app-fields\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}}}},\"jira-align\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false},\"features\":{}},\"jira-product-discovery\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false},\"features\":{}},\"jira-service-management\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-jira-service-management\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"jira-service-management-help-center\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"jsm-ai-ops\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"jsm-ai-services\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"jsm-alert-notifications\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"jsm-analytics-dashboards\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"jsm-approvals\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"jsm-assets-vertical\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"jsm-automation-playbook\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"jsm-boysenberry\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"jsm-canned-responses\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"jsm-change-ai-risk-assessment\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"jsm-change-calendar\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"jsm-change-management-deployment-vendors\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"jsm-change-management\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true}},\"jsm-change-risk-assessment\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"jsm-change-risk-reporter-configuration\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"jsm-chat-ops-ic-custom-apps\":{\"compositions\":{\"cc\":false,\"ic\":true,\"fm\":false}},\"jsm-chat-ops\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"jsm-chat\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"jsm-cloud-megatron\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"jsm-csat\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"jsm-csm-functionality\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"jsm-customer-access-internal-account\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"jsm-customer-notifications\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"jsm-customer-service-management\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"jsm-deployment-gating\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"jsm-deployment-tracking\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true}},\"jsm-developer-escalations\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"jsm-email-requests\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"jsm-embeddable-widget\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"jsm-entity-migration\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"jsm-err-governance-api\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"jsm-external-customer-accounts\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"jsm-external-customer-single-sign-on\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"jsm-external-customer-user-provisioning\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"jsm-forms\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"jsm-halp-admin-panel\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"jsm-help-center-change-password\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"jsm-help-center-password-login\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"jsm-help-center-rovo-agent\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"jsm-help-center-virtual-agent\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"jsm-help-center\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"jsm-incident-conference-calls\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"jsm-incident-management-integration\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"jsm-issue\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"jsm-journey-builder\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"jsm-knowledge-base\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"jsm-multi-language-support\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"jsm-on-call-schedule\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"jsm-ops-genie-reporting\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"jsm-opsgenie-conference-management\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"jsm-opsgenie-devops\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"jsm-portal-only-account-scim\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"jsm-post-incident-reviews\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"jsm-queues\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"jsm-related-issues\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true}},\"jsm-reports-operations\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"jsm-request-intake\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"jsm-services\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"jsm-shield\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"jsm-sla-management\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"jsm-status-page-integration\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"jsm-surveys\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"jsm-templates-and-views\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"jsm-virtual-service-agent\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"jsm-workforce\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"opsgenie\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}}}},\"loom\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false},\"features\":{\"loom-ai-evaluation\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}}}},\"projects\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false},\"features\":{}},\"rovo\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false},\"features\":{\"rovo-ai-app-availability\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"rovo-ai-atlassian-intelligence-app-availability\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"rovo-ai-generative-ai-editor\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"rovo-ai-machine-learning\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"rovo-ai-natural-language-in-automation-rule-creation\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"rovo-ai-projects\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"rovo-ai-smart-features-based-on-machine-learning-tecton-ai\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"rovo-editor-ai-panels\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}}}},\"rovo-dev\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false},\"features\":{\"rovo-dev-agents\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"rovo-dev-code-assist\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}}}},\"statuspage\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false},\"features\":{}},\"studio\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false},\"features\":{}},\"talent\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false},\"features\":{}},\"teams\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"teams-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"teams-profile-media-token-fetch\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"teams-third-party-invites\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"user-provided-banners-on-profile-pictures\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}}}},\"trello\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false},\"features\":{\"trello-ms-teams-integration\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}}}},\"anti-abuse-platform\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true},\"features\":{\"core-anti-abuse-platform\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true}}}},\"application-tunnels\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false},\"features\":{\"core-application-tunnels\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}}}},\"atlassian-cli\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false},\"features\":{}},\"atlassian-new-platform\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false},\"features\":{}},\"atlassian-visualization-platform\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true},\"features\":{\"atlassian-visualization-platform-kamino\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true}},\"atlassian-visualization-platform-manifold\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true}},\"atlassian-visualization-platform-rovo-skills\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}}}},\"central-ai\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false},\"features\":{\"ai-3p-connections\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"ai-managed-objects\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"ai-safety\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"collaboration-graph\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"gen-ai\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"knowledge-ai\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"knowledge-discovery\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"machine-learning-platform\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}}}},\"collaboration-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-collaboration-platform\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true}}}},\"commerce-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"commerce-platform-pls-changes-for-hams-cofs-in-boundary-deployment\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"commerce-platform-self-serve\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"core-commerce-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}}}},\"customer-data-lake\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-customer-data-lake\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}}}},\"customer-support-platform\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true},\"features\":{}},\"ecosystem-forge\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-ecosystem-forge\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"dac-get-help-widget\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"developer-atlassian-community\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"docs-atlassian-com\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"ecosystem-oauth\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"expression-playground\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"forge-cli\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"forge-remote-capabilities\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"forge-storage-service-rockmelon\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"forge-system-apps\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"forge-ui-ic-cdn-auth\":{\"compositions\":{\"cc\":false,\"ic\":true,\"fm\":false}}}},\"editor-collaboration-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"block-service\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"core-editor-collaboration-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"real-time-presence\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}}}},\"experience-platform\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true},\"features\":{\"core-experience-platform\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true}}}},\"gasv3\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-gasv3\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}}}},\"growth-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"bxp-signup\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"core-growth-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}}}},\"identity\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-identity\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"identity-mail-proxy\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"identity-virality\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}}}},\"learning-platform\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true},\"features\":{}},\"marketplace\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"marketplace-app-discovery\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"marketplace-app-migrations\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"marketplace-atlassian-labs\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"marketplace-audit-logs\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"marketplace-self-service-purchase-provision-install\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}}}},\"migrations\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"agc-migrations\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"commercial-cloud-to-agc\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"data-center-to-agc\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"migration-link-fixing\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}}}},\"migrations-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"brie\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"core-migrations-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"data-center-to-cloud-migration\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"media-migration\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true}}}},\"navigation\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-navigation\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"navigation-home-entry-mode\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"navigation-identity-ic-routing\":{\"compositions\":{\"cc\":false,\"ic\":true,\"fm\":false}},\"navigation-switcher-discovery\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"navigation-switcher-rovo-scas-visibility\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}}}},\"notification-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-notification-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"notifications-fpn-link\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true}}}},\"post-office\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-post-office\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}}}},\"product-integrations-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-product-integrations-platform\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true}},\"external-user-directory-integration\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"google-workspace-apps-integrations\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"sign-in-with-slack-usage-analytics\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}}}},\"search\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-search\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"search-townsquare-tab\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}}}},\"smartlinks\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-smartlinks\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}}}},\"user-management\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-user-management\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}}}},\"user-recommendations\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-user-recommendations\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}}}},\"atlassian-graphql-gateway\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-atlassian-graphql-gateway\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}}}},\"atlassian-platform-deployer\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{}},\"automation-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"automation-platform-actions\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"automation-platform-automation-templates\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"automation-platform-branches\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"automation-platform-conditions\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"automation-platform-event-processing\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"automation-platform-frontend\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true}},\"automation-platform-natural-language-rule-builder\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"automation-platform-rule-builder\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"automation-platform-templates\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"automation-platform-triggers\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"core-automation-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}}}},\"bifrost\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-bifrost\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}}}},\"build-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{}},\"cell-platform\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true},\"features\":{}},\"cloud-management\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{}},\"cloud-security\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{}},\"compliance-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{}},\"consent-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"consenthub\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}}}},\"core-network-automation\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-core-network-automation\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}}}},\"core-network-automation-cna-theia\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-core-network-automation-cna-theia\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}}}},\"core-network-automation-l2\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-core-network-automation-l2\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}}}},\"cross-gateway\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-cross-gateway\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}}}},\"customer-data-lake-layer2\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{}},\"data-access-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-data-access-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}}}},\"data-classification-governance-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-data-classification-governance-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}}}},\"data-depot-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-data-depot-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}}}},\"data-exchange-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"aqui\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}},\"eureka\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"kamino\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"shipyard\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"topic-osb\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}}}},\"data-exchange-platform-l3\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-data-exchange-platform-l3\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}}}},\"data-management-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-data-management-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"ers-import\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"ers\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"sql\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}}}},\"data-platform-services\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-data-platform-services\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}}}},\"data-store-gateway\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-data-store-gateway\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}}}},\"data-telemetry-platform\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true},\"features\":{\"core-data-telemetry-platform\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true}}}},\"decisions-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-decisions-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"experimentation\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}}}},\"detection-and-response-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{}},\"disaster-recovery\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{}},\"edge\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-edge\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"edge-cloudfront\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}}}},\"encryption-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"cryptor\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}}}},\"environment-management-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{}},\"flight-deck-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{}},\"golden-ami\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{}},\"incident-management-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{}},\"infrastructure\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-infrastructure\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}}}},\"internal-data-lake\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"airlock-platform\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}}}},\"internal-edge\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-internal-edge\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}}}},\"internal-edge-httpbin\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-internal-edge-httpbin\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}}}},\"job-execution-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-job-execution-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}}}},\"kitt-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"kitt-fleet\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}}}},\"media-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-media-platform\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true}},\"media-cdn-delivery\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true}}}},\"messaging-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{}},\"micros-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{}},\"network-fabric\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-network-fabric\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}}}},\"observability-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"sentry-opsgenie-integration\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}},\"tracing\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false}}}},\"pollinator\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-pollinator\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}}}},\"pollinator-l2\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-pollinator-l2\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}}}},\"provisioning\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-provisioning\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}}}},\"rate-limiting-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-rate-limiting-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}}}},\"resiliency-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{}},\"secrets\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false},\"features\":{}},\"security-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{}},\"service-to-service-fabric\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{}},\"slauth-auth-slack-notification-platform\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false},\"features\":{}},\"sliver\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":false},\"features\":{}},\"staff-authentication-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{}},\"streamhub\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-streamhub\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}}}},\"targeting-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-targeting-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}}}},\"teamwork-graph-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-teamwork-graph-platform\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}},\"flock\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true}}}},\"tenant-catalogue-service-record\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-tenant-catalogue-service-record\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}}}},\"tenant-context\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-tenant-context\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true}}}},\"tenant-lifecycle\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{\"core-tenant-platform\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true}},\"tenant-passivation-removal\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":false}}}},\"vdi\":{\"compositions\":{\"cc\":true,\"ic\":false,\"fm\":true},\"features\":{}},\"workplace-technology-solutions\":{\"compositions\":{\"cc\":true,\"ic\":true,\"fm\":true},\"features\":{}}}}");

});

parcelRegister("hFJK0", function(module, exports) {

var $fQpXh = parcelRequire("fQpXh");
var $0351f6b284ade142$var$_typeof = $fQpXh.default;
function $0351f6b284ade142$var$_regeneratorRuntime() {
    "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ 
    module.exports = $0351f6b284ade142$var$_regeneratorRuntime = function _regeneratorRuntime() {
        return e;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports;
    var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function(t, e, r) {
        t[e] = r.value;
    }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag";
    function define(t, e, r) {
        return Object.defineProperty(t, e, {
            value: r,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }), t[e];
    }
    try {
        define({}, "");
    } catch (t) {
        define = function define(t, e, r) {
            return t[e] = r;
        };
    }
    function wrap(t, e, r, n) {
        var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []);
        return o(a, "_invoke", {
            value: makeInvokeMethod(t, r, c)
        }), a;
    }
    function tryCatch(t, e, r) {
        try {
            return {
                type: "normal",
                arg: t.call(e, r)
            };
        } catch (t) {
            return {
                type: "throw",
                arg: t
            };
        }
    }
    e.wrap = wrap;
    var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {};
    function Generator() {}
    function GeneratorFunction() {}
    function GeneratorFunctionPrototype() {}
    var p = {};
    define(p, a, function() {
        return this;
    });
    var d = Object.getPrototypeOf, v = d && d(d(values([])));
    v && v !== r && n.call(v, a) && (p = v);
    var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p);
    function defineIteratorMethods(t) {
        [
            "next",
            "throw",
            "return"
        ].forEach(function(e) {
            define(t, e, function(t) {
                return this._invoke(e, t);
            });
        });
    }
    function AsyncIterator(t, e) {
        function invoke(r, o, i, a) {
            var c = tryCatch(t[r], t, o);
            if ("throw" !== c.type) {
                var u = c.arg, h = u.value;
                return h && "object" == $0351f6b284ade142$var$_typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function(t) {
                    invoke("next", t, i, a);
                }, function(t) {
                    invoke("throw", t, i, a);
                }) : e.resolve(h).then(function(t) {
                    u.value = t, i(u);
                }, function(t) {
                    return invoke("throw", t, i, a);
                });
            }
            a(c.arg);
        }
        var r;
        o(this, "_invoke", {
            value: function value(t, n) {
                function callInvokeWithMethodAndArg() {
                    return new e(function(e, r) {
                        invoke(t, n, e, r);
                    });
                }
                return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
            }
        });
    }
    function makeInvokeMethod(e, r, n) {
        var o = h;
        return function(i, a) {
            if (o === f) throw Error("Generator is already running");
            if (o === s) {
                if ("throw" === i) throw a;
                return {
                    value: t,
                    done: !0
                };
            }
            for(n.method = i, n.arg = a;;){
                var c = n.delegate;
                if (c) {
                    var u = maybeInvokeDelegate(c, n);
                    if (u) {
                        if (u === y) continue;
                        return u;
                    }
                }
                if ("next" === n.method) n.sent = n._sent = n.arg;
                else if ("throw" === n.method) {
                    if (o === h) throw o = s, n.arg;
                    n.dispatchException(n.arg);
                } else "return" === n.method && n.abrupt("return", n.arg);
                o = f;
                var p = tryCatch(e, r, n);
                if ("normal" === p.type) {
                    if (o = n.done ? s : l, p.arg === y) continue;
                    return {
                        value: p.arg,
                        done: n.done
                    };
                }
                "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg);
            }
        };
    }
    function maybeInvokeDelegate(e, r) {
        var n = r.method, o = e.iterator[n];
        if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y;
        var i = tryCatch(o, e.iterator, r.arg);
        if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y;
        var a = i.arg;
        return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y);
    }
    function pushTryEntry(t) {
        var e = {
            tryLoc: t[0]
        };
        1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e);
    }
    function resetTryEntry(t) {
        var e = t.completion || {};
        e.type = "normal", delete e.arg, t.completion = e;
    }
    function Context(t) {
        this.tryEntries = [
            {
                tryLoc: "root"
            }
        ], t.forEach(pushTryEntry, this), this.reset(!0);
    }
    function values(e) {
        if (e || "" === e) {
            var r = e[a];
            if (r) return r.call(e);
            if ("function" == typeof e.next) return e;
            if (!isNaN(e.length)) {
                var o = -1, i = function next() {
                    for(; ++o < e.length;)if (n.call(e, o)) return next.value = e[o], next.done = !1, next;
                    return next.value = t, next.done = !0, next;
                };
                return i.next = i;
            }
        }
        throw new TypeError($0351f6b284ade142$var$_typeof(e) + " is not iterable");
    }
    return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", {
        value: GeneratorFunctionPrototype,
        configurable: !0
    }), o(GeneratorFunctionPrototype, "constructor", {
        value: GeneratorFunction,
        configurable: !0
    }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function(t) {
        var e = "function" == typeof t && t.constructor;
        return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name));
    }, e.mark = function(t) {
        return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t;
    }, e.awrap = function(t) {
        return {
            __await: t
        };
    }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function() {
        return this;
    }), e.AsyncIterator = AsyncIterator, e.async = function(t, r, n, o, i) {
        void 0 === i && (i = Promise);
        var a = new AsyncIterator(wrap(t, r, n, o), i);
        return e.isGeneratorFunction(r) ? a : a.next().then(function(t) {
            return t.done ? t.value : a.next();
        });
    }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function() {
        return this;
    }), define(g, "toString", function() {
        return "[object Generator]";
    }), e.keys = function(t) {
        var e = Object(t), r = [];
        for(var n in e)r.push(n);
        return r.reverse(), function next() {
            for(; r.length;){
                var t = r.pop();
                if (t in e) return next.value = t, next.done = !1, next;
            }
            return next.done = !0, next;
        };
    }, e.values = values, Context.prototype = {
        constructor: Context,
        reset: function reset(e) {
            if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for(var r in this)"t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t);
        },
        stop: function stop() {
            this.done = !0;
            var t = this.tryEntries[0].completion;
            if ("throw" === t.type) throw t.arg;
            return this.rval;
        },
        dispatchException: function dispatchException(e) {
            if (this.done) throw e;
            var r = this;
            function handle(n, o) {
                return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o;
            }
            for(var o = this.tryEntries.length - 1; o >= 0; --o){
                var i = this.tryEntries[o], a = i.completion;
                if ("root" === i.tryLoc) return handle("end");
                if (i.tryLoc <= this.prev) {
                    var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc");
                    if (c && u) {
                        if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
                        if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
                    } else if (c) {
                        if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
                    } else {
                        if (!u) throw Error("try statement without catch or finally");
                        if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
                    }
                }
            }
        },
        abrupt: function abrupt(t, e) {
            for(var r = this.tryEntries.length - 1; r >= 0; --r){
                var o = this.tryEntries[r];
                if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
                    var i = o;
                    break;
                }
            }
            i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null);
            var a = i ? i.completion : {};
            return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a);
        },
        complete: function complete(t, e) {
            if ("throw" === t.type) throw t.arg;
            return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y;
        },
        finish: function finish(t) {
            for(var e = this.tryEntries.length - 1; e >= 0; --e){
                var r = this.tryEntries[e];
                if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y;
            }
        },
        "catch": function _catch(t) {
            for(var e = this.tryEntries.length - 1; e >= 0; --e){
                var r = this.tryEntries[e];
                if (r.tryLoc === t) {
                    var n = r.completion;
                    if ("throw" === n.type) {
                        var o = n.arg;
                        resetTryEntry(r);
                    }
                    return o;
                }
            }
            throw Error("illegal catch attempt");
        },
        delegateYield: function delegateYield(e, r, n) {
            return this.delegate = {
                iterator: values(e),
                resultName: r,
                nextLoc: n
            }, "next" === this.method && (this.arg = t), y;
        }
    }, e;
}
module.exports = $0351f6b284ade142$var$_regeneratorRuntime, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("fQpXh", function(module, exports) {
function $b88fd87d1ddf8991$var$_typeof(o) {
    "@babel/helpers - typeof";
    return module.exports = $b88fd87d1ddf8991$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $b88fd87d1ddf8991$var$_typeof(o);
}
module.exports = $b88fd87d1ddf8991$var$_typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("hY3Wi", function(module, exports) {

var $fQQ9y = parcelRequire("fQQ9y");
var $d14b18883cdff13a$var$_typeof = $fQQ9y.default;
function $d14b18883cdff13a$var$_regeneratorRuntime() {
    "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ 
    module.exports = $d14b18883cdff13a$var$_regeneratorRuntime = function _regeneratorRuntime() {
        return e;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports;
    var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function(t, e, r) {
        t[e] = r.value;
    }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag";
    function define(t, e, r) {
        return Object.defineProperty(t, e, {
            value: r,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }), t[e];
    }
    try {
        define({}, "");
    } catch (t) {
        define = function define(t, e, r) {
            return t[e] = r;
        };
    }
    function wrap(t, e, r, n) {
        var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []);
        return o(a, "_invoke", {
            value: makeInvokeMethod(t, r, c)
        }), a;
    }
    function tryCatch(t, e, r) {
        try {
            return {
                type: "normal",
                arg: t.call(e, r)
            };
        } catch (t) {
            return {
                type: "throw",
                arg: t
            };
        }
    }
    e.wrap = wrap;
    var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {};
    function Generator() {}
    function GeneratorFunction() {}
    function GeneratorFunctionPrototype() {}
    var p = {};
    define(p, a, function() {
        return this;
    });
    var d = Object.getPrototypeOf, v = d && d(d(values([])));
    v && v !== r && n.call(v, a) && (p = v);
    var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p);
    function defineIteratorMethods(t) {
        [
            "next",
            "throw",
            "return"
        ].forEach(function(e) {
            define(t, e, function(t) {
                return this._invoke(e, t);
            });
        });
    }
    function AsyncIterator(t, e) {
        function invoke(r, o, i, a) {
            var c = tryCatch(t[r], t, o);
            if ("throw" !== c.type) {
                var u = c.arg, h = u.value;
                return h && "object" == $d14b18883cdff13a$var$_typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function(t) {
                    invoke("next", t, i, a);
                }, function(t) {
                    invoke("throw", t, i, a);
                }) : e.resolve(h).then(function(t) {
                    u.value = t, i(u);
                }, function(t) {
                    return invoke("throw", t, i, a);
                });
            }
            a(c.arg);
        }
        var r;
        o(this, "_invoke", {
            value: function value(t, n) {
                function callInvokeWithMethodAndArg() {
                    return new e(function(e, r) {
                        invoke(t, n, e, r);
                    });
                }
                return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
            }
        });
    }
    function makeInvokeMethod(e, r, n) {
        var o = h;
        return function(i, a) {
            if (o === f) throw Error("Generator is already running");
            if (o === s) {
                if ("throw" === i) throw a;
                return {
                    value: t,
                    done: !0
                };
            }
            for(n.method = i, n.arg = a;;){
                var c = n.delegate;
                if (c) {
                    var u = maybeInvokeDelegate(c, n);
                    if (u) {
                        if (u === y) continue;
                        return u;
                    }
                }
                if ("next" === n.method) n.sent = n._sent = n.arg;
                else if ("throw" === n.method) {
                    if (o === h) throw o = s, n.arg;
                    n.dispatchException(n.arg);
                } else "return" === n.method && n.abrupt("return", n.arg);
                o = f;
                var p = tryCatch(e, r, n);
                if ("normal" === p.type) {
                    if (o = n.done ? s : l, p.arg === y) continue;
                    return {
                        value: p.arg,
                        done: n.done
                    };
                }
                "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg);
            }
        };
    }
    function maybeInvokeDelegate(e, r) {
        var n = r.method, o = e.iterator[n];
        if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y;
        var i = tryCatch(o, e.iterator, r.arg);
        if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y;
        var a = i.arg;
        return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y);
    }
    function pushTryEntry(t) {
        var e = {
            tryLoc: t[0]
        };
        1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e);
    }
    function resetTryEntry(t) {
        var e = t.completion || {};
        e.type = "normal", delete e.arg, t.completion = e;
    }
    function Context(t) {
        this.tryEntries = [
            {
                tryLoc: "root"
            }
        ], t.forEach(pushTryEntry, this), this.reset(!0);
    }
    function values(e) {
        if (e || "" === e) {
            var r = e[a];
            if (r) return r.call(e);
            if ("function" == typeof e.next) return e;
            if (!isNaN(e.length)) {
                var o = -1, i = function next() {
                    for(; ++o < e.length;)if (n.call(e, o)) return next.value = e[o], next.done = !1, next;
                    return next.value = t, next.done = !0, next;
                };
                return i.next = i;
            }
        }
        throw new TypeError($d14b18883cdff13a$var$_typeof(e) + " is not iterable");
    }
    return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", {
        value: GeneratorFunctionPrototype,
        configurable: !0
    }), o(GeneratorFunctionPrototype, "constructor", {
        value: GeneratorFunction,
        configurable: !0
    }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function(t) {
        var e = "function" == typeof t && t.constructor;
        return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name));
    }, e.mark = function(t) {
        return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t;
    }, e.awrap = function(t) {
        return {
            __await: t
        };
    }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function() {
        return this;
    }), e.AsyncIterator = AsyncIterator, e.async = function(t, r, n, o, i) {
        void 0 === i && (i = Promise);
        var a = new AsyncIterator(wrap(t, r, n, o), i);
        return e.isGeneratorFunction(r) ? a : a.next().then(function(t) {
            return t.done ? t.value : a.next();
        });
    }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function() {
        return this;
    }), define(g, "toString", function() {
        return "[object Generator]";
    }), e.keys = function(t) {
        var e = Object(t), r = [];
        for(var n in e)r.push(n);
        return r.reverse(), function next() {
            for(; r.length;){
                var t = r.pop();
                if (t in e) return next.value = t, next.done = !1, next;
            }
            return next.done = !0, next;
        };
    }, e.values = values, Context.prototype = {
        constructor: Context,
        reset: function reset(e) {
            if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for(var r in this)"t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t);
        },
        stop: function stop() {
            this.done = !0;
            var t = this.tryEntries[0].completion;
            if ("throw" === t.type) throw t.arg;
            return this.rval;
        },
        dispatchException: function dispatchException(e) {
            if (this.done) throw e;
            var r = this;
            function handle(n, o) {
                return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o;
            }
            for(var o = this.tryEntries.length - 1; o >= 0; --o){
                var i = this.tryEntries[o], a = i.completion;
                if ("root" === i.tryLoc) return handle("end");
                if (i.tryLoc <= this.prev) {
                    var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc");
                    if (c && u) {
                        if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
                        if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
                    } else if (c) {
                        if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
                    } else {
                        if (!u) throw Error("try statement without catch or finally");
                        if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
                    }
                }
            }
        },
        abrupt: function abrupt(t, e) {
            for(var r = this.tryEntries.length - 1; r >= 0; --r){
                var o = this.tryEntries[r];
                if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
                    var i = o;
                    break;
                }
            }
            i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null);
            var a = i ? i.completion : {};
            return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a);
        },
        complete: function complete(t, e) {
            if ("throw" === t.type) throw t.arg;
            return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y;
        },
        finish: function finish(t) {
            for(var e = this.tryEntries.length - 1; e >= 0; --e){
                var r = this.tryEntries[e];
                if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y;
            }
        },
        "catch": function _catch(t) {
            for(var e = this.tryEntries.length - 1; e >= 0; --e){
                var r = this.tryEntries[e];
                if (r.tryLoc === t) {
                    var n = r.completion;
                    if ("throw" === n.type) {
                        var o = n.arg;
                        resetTryEntry(r);
                    }
                    return o;
                }
            }
            throw Error("illegal catch attempt");
        },
        delegateYield: function delegateYield(e, r, n) {
            return this.delegate = {
                iterator: values(e),
                resultName: r,
                nextLoc: n
            }, "next" === this.method && (this.arg = t), y;
        }
    }, e;
}
module.exports = $d14b18883cdff13a$var$_regeneratorRuntime, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("fQQ9y", function(module, exports) {
function $b8a42ad6d64e0339$var$_typeof(o) {
    "@babel/helpers - typeof";
    return module.exports = $b8a42ad6d64e0339$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $b8a42ad6d64e0339$var$_typeof(o);
}
module.exports = $b8a42ad6d64e0339$var$_typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("7Jfiv", function(module, exports) {

var $5ta7c = parcelRequire("5ta7c");
var $5a089a1e17ba3393$var$_typeof = $5ta7c.default;
function $5a089a1e17ba3393$var$_regeneratorRuntime() {
    "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ 
    module.exports = $5a089a1e17ba3393$var$_regeneratorRuntime = function _regeneratorRuntime() {
        return e;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports;
    var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function(t, e, r) {
        t[e] = r.value;
    }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag";
    function define(t, e, r) {
        return Object.defineProperty(t, e, {
            value: r,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }), t[e];
    }
    try {
        define({}, "");
    } catch (t) {
        define = function define(t, e, r) {
            return t[e] = r;
        };
    }
    function wrap(t, e, r, n) {
        var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []);
        return o(a, "_invoke", {
            value: makeInvokeMethod(t, r, c)
        }), a;
    }
    function tryCatch(t, e, r) {
        try {
            return {
                type: "normal",
                arg: t.call(e, r)
            };
        } catch (t) {
            return {
                type: "throw",
                arg: t
            };
        }
    }
    e.wrap = wrap;
    var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {};
    function Generator() {}
    function GeneratorFunction() {}
    function GeneratorFunctionPrototype() {}
    var p = {};
    define(p, a, function() {
        return this;
    });
    var d = Object.getPrototypeOf, v = d && d(d(values([])));
    v && v !== r && n.call(v, a) && (p = v);
    var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p);
    function defineIteratorMethods(t) {
        [
            "next",
            "throw",
            "return"
        ].forEach(function(e) {
            define(t, e, function(t) {
                return this._invoke(e, t);
            });
        });
    }
    function AsyncIterator(t, e) {
        function invoke(r, o, i, a) {
            var c = tryCatch(t[r], t, o);
            if ("throw" !== c.type) {
                var u = c.arg, h = u.value;
                return h && "object" == $5a089a1e17ba3393$var$_typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function(t) {
                    invoke("next", t, i, a);
                }, function(t) {
                    invoke("throw", t, i, a);
                }) : e.resolve(h).then(function(t) {
                    u.value = t, i(u);
                }, function(t) {
                    return invoke("throw", t, i, a);
                });
            }
            a(c.arg);
        }
        var r;
        o(this, "_invoke", {
            value: function value(t, n) {
                function callInvokeWithMethodAndArg() {
                    return new e(function(e, r) {
                        invoke(t, n, e, r);
                    });
                }
                return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
            }
        });
    }
    function makeInvokeMethod(e, r, n) {
        var o = h;
        return function(i, a) {
            if (o === f) throw Error("Generator is already running");
            if (o === s) {
                if ("throw" === i) throw a;
                return {
                    value: t,
                    done: !0
                };
            }
            for(n.method = i, n.arg = a;;){
                var c = n.delegate;
                if (c) {
                    var u = maybeInvokeDelegate(c, n);
                    if (u) {
                        if (u === y) continue;
                        return u;
                    }
                }
                if ("next" === n.method) n.sent = n._sent = n.arg;
                else if ("throw" === n.method) {
                    if (o === h) throw o = s, n.arg;
                    n.dispatchException(n.arg);
                } else "return" === n.method && n.abrupt("return", n.arg);
                o = f;
                var p = tryCatch(e, r, n);
                if ("normal" === p.type) {
                    if (o = n.done ? s : l, p.arg === y) continue;
                    return {
                        value: p.arg,
                        done: n.done
                    };
                }
                "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg);
            }
        };
    }
    function maybeInvokeDelegate(e, r) {
        var n = r.method, o = e.iterator[n];
        if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y;
        var i = tryCatch(o, e.iterator, r.arg);
        if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y;
        var a = i.arg;
        return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y);
    }
    function pushTryEntry(t) {
        var e = {
            tryLoc: t[0]
        };
        1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e);
    }
    function resetTryEntry(t) {
        var e = t.completion || {};
        e.type = "normal", delete e.arg, t.completion = e;
    }
    function Context(t) {
        this.tryEntries = [
            {
                tryLoc: "root"
            }
        ], t.forEach(pushTryEntry, this), this.reset(!0);
    }
    function values(e) {
        if (e || "" === e) {
            var r = e[a];
            if (r) return r.call(e);
            if ("function" == typeof e.next) return e;
            if (!isNaN(e.length)) {
                var o = -1, i = function next() {
                    for(; ++o < e.length;)if (n.call(e, o)) return next.value = e[o], next.done = !1, next;
                    return next.value = t, next.done = !0, next;
                };
                return i.next = i;
            }
        }
        throw new TypeError($5a089a1e17ba3393$var$_typeof(e) + " is not iterable");
    }
    return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", {
        value: GeneratorFunctionPrototype,
        configurable: !0
    }), o(GeneratorFunctionPrototype, "constructor", {
        value: GeneratorFunction,
        configurable: !0
    }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function(t) {
        var e = "function" == typeof t && t.constructor;
        return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name));
    }, e.mark = function(t) {
        return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t;
    }, e.awrap = function(t) {
        return {
            __await: t
        };
    }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function() {
        return this;
    }), e.AsyncIterator = AsyncIterator, e.async = function(t, r, n, o, i) {
        void 0 === i && (i = Promise);
        var a = new AsyncIterator(wrap(t, r, n, o), i);
        return e.isGeneratorFunction(r) ? a : a.next().then(function(t) {
            return t.done ? t.value : a.next();
        });
    }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function() {
        return this;
    }), define(g, "toString", function() {
        return "[object Generator]";
    }), e.keys = function(t) {
        var e = Object(t), r = [];
        for(var n in e)r.push(n);
        return r.reverse(), function next() {
            for(; r.length;){
                var t = r.pop();
                if (t in e) return next.value = t, next.done = !1, next;
            }
            return next.done = !0, next;
        };
    }, e.values = values, Context.prototype = {
        constructor: Context,
        reset: function reset(e) {
            if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for(var r in this)"t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t);
        },
        stop: function stop() {
            this.done = !0;
            var t = this.tryEntries[0].completion;
            if ("throw" === t.type) throw t.arg;
            return this.rval;
        },
        dispatchException: function dispatchException(e) {
            if (this.done) throw e;
            var r = this;
            function handle(n, o) {
                return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o;
            }
            for(var o = this.tryEntries.length - 1; o >= 0; --o){
                var i = this.tryEntries[o], a = i.completion;
                if ("root" === i.tryLoc) return handle("end");
                if (i.tryLoc <= this.prev) {
                    var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc");
                    if (c && u) {
                        if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
                        if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
                    } else if (c) {
                        if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
                    } else {
                        if (!u) throw Error("try statement without catch or finally");
                        if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
                    }
                }
            }
        },
        abrupt: function abrupt(t, e) {
            for(var r = this.tryEntries.length - 1; r >= 0; --r){
                var o = this.tryEntries[r];
                if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
                    var i = o;
                    break;
                }
            }
            i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null);
            var a = i ? i.completion : {};
            return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a);
        },
        complete: function complete(t, e) {
            if ("throw" === t.type) throw t.arg;
            return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y;
        },
        finish: function finish(t) {
            for(var e = this.tryEntries.length - 1; e >= 0; --e){
                var r = this.tryEntries[e];
                if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y;
            }
        },
        "catch": function _catch(t) {
            for(var e = this.tryEntries.length - 1; e >= 0; --e){
                var r = this.tryEntries[e];
                if (r.tryLoc === t) {
                    var n = r.completion;
                    if ("throw" === n.type) {
                        var o = n.arg;
                        resetTryEntry(r);
                    }
                    return o;
                }
            }
            throw Error("illegal catch attempt");
        },
        delegateYield: function delegateYield(e, r, n) {
            return this.delegate = {
                iterator: values(e),
                resultName: r,
                nextLoc: n
            }, "next" === this.method && (this.arg = t), y;
        }
    }, e;
}
module.exports = $5a089a1e17ba3393$var$_regeneratorRuntime, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("5ta7c", function(module, exports) {
function $3fb781d78ed83f56$var$_typeof(o) {
    "@babel/helpers - typeof";
    return module.exports = $3fb781d78ed83f56$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $3fb781d78ed83f56$var$_typeof(o);
}
module.exports = $3fb781d78ed83f56$var$_typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("2oinO", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';

var $kNBL5 = parcelRequire("kNBL5");
function $1bdc1525a0f75b3d$var$emptyFunction() {}
function $1bdc1525a0f75b3d$var$emptyFunctionWithReset() {}
$1bdc1525a0f75b3d$var$emptyFunctionWithReset.resetWarningCache = $1bdc1525a0f75b3d$var$emptyFunction;
module.exports = function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret === $kNBL5) // It is still safe when called from React.
        return;
        var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        err.name = 'Invariant Violation';
        throw err;
    }
    shim.isRequired = shim;
    function getShim() {
        return shim;
    }
    // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
    var ReactPropTypes = {
        array: shim,
        bigint: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: $1bdc1525a0f75b3d$var$emptyFunctionWithReset,
        resetWarningCache: $1bdc1525a0f75b3d$var$emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};

});
parcelRegister("kNBL5", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
var $f245ac4eed006c20$var$ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
module.exports = $f245ac4eed006c20$var$ReactPropTypesSecret;

});


parcelRegister("jGhF1", function(module, exports) {

var $fFESW = parcelRequire("fFESW");
var $e53fa396386fbb67$var$_typeof = $fFESW.default;
function $e53fa396386fbb67$var$_regeneratorRuntime() {
    "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ 
    module.exports = $e53fa396386fbb67$var$_regeneratorRuntime = function _regeneratorRuntime() {
        return e;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports;
    var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function(t, e, r) {
        t[e] = r.value;
    }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag";
    function define(t, e, r) {
        return Object.defineProperty(t, e, {
            value: r,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }), t[e];
    }
    try {
        define({}, "");
    } catch (t) {
        define = function define(t, e, r) {
            return t[e] = r;
        };
    }
    function wrap(t, e, r, n) {
        var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []);
        return o(a, "_invoke", {
            value: makeInvokeMethod(t, r, c)
        }), a;
    }
    function tryCatch(t, e, r) {
        try {
            return {
                type: "normal",
                arg: t.call(e, r)
            };
        } catch (t) {
            return {
                type: "throw",
                arg: t
            };
        }
    }
    e.wrap = wrap;
    var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {};
    function Generator() {}
    function GeneratorFunction() {}
    function GeneratorFunctionPrototype() {}
    var p = {};
    define(p, a, function() {
        return this;
    });
    var d = Object.getPrototypeOf, v = d && d(d(values([])));
    v && v !== r && n.call(v, a) && (p = v);
    var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p);
    function defineIteratorMethods(t) {
        [
            "next",
            "throw",
            "return"
        ].forEach(function(e) {
            define(t, e, function(t) {
                return this._invoke(e, t);
            });
        });
    }
    function AsyncIterator(t, e) {
        function invoke(r, o, i, a) {
            var c = tryCatch(t[r], t, o);
            if ("throw" !== c.type) {
                var u = c.arg, h = u.value;
                return h && "object" == $e53fa396386fbb67$var$_typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function(t) {
                    invoke("next", t, i, a);
                }, function(t) {
                    invoke("throw", t, i, a);
                }) : e.resolve(h).then(function(t) {
                    u.value = t, i(u);
                }, function(t) {
                    return invoke("throw", t, i, a);
                });
            }
            a(c.arg);
        }
        var r;
        o(this, "_invoke", {
            value: function value(t, n) {
                function callInvokeWithMethodAndArg() {
                    return new e(function(e, r) {
                        invoke(t, n, e, r);
                    });
                }
                return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
            }
        });
    }
    function makeInvokeMethod(e, r, n) {
        var o = h;
        return function(i, a) {
            if (o === f) throw Error("Generator is already running");
            if (o === s) {
                if ("throw" === i) throw a;
                return {
                    value: t,
                    done: !0
                };
            }
            for(n.method = i, n.arg = a;;){
                var c = n.delegate;
                if (c) {
                    var u = maybeInvokeDelegate(c, n);
                    if (u) {
                        if (u === y) continue;
                        return u;
                    }
                }
                if ("next" === n.method) n.sent = n._sent = n.arg;
                else if ("throw" === n.method) {
                    if (o === h) throw o = s, n.arg;
                    n.dispatchException(n.arg);
                } else "return" === n.method && n.abrupt("return", n.arg);
                o = f;
                var p = tryCatch(e, r, n);
                if ("normal" === p.type) {
                    if (o = n.done ? s : l, p.arg === y) continue;
                    return {
                        value: p.arg,
                        done: n.done
                    };
                }
                "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg);
            }
        };
    }
    function maybeInvokeDelegate(e, r) {
        var n = r.method, o = e.iterator[n];
        if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y;
        var i = tryCatch(o, e.iterator, r.arg);
        if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y;
        var a = i.arg;
        return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y);
    }
    function pushTryEntry(t) {
        var e = {
            tryLoc: t[0]
        };
        1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e);
    }
    function resetTryEntry(t) {
        var e = t.completion || {};
        e.type = "normal", delete e.arg, t.completion = e;
    }
    function Context(t) {
        this.tryEntries = [
            {
                tryLoc: "root"
            }
        ], t.forEach(pushTryEntry, this), this.reset(!0);
    }
    function values(e) {
        if (e || "" === e) {
            var r = e[a];
            if (r) return r.call(e);
            if ("function" == typeof e.next) return e;
            if (!isNaN(e.length)) {
                var o = -1, i = function next() {
                    for(; ++o < e.length;)if (n.call(e, o)) return next.value = e[o], next.done = !1, next;
                    return next.value = t, next.done = !0, next;
                };
                return i.next = i;
            }
        }
        throw new TypeError($e53fa396386fbb67$var$_typeof(e) + " is not iterable");
    }
    return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", {
        value: GeneratorFunctionPrototype,
        configurable: !0
    }), o(GeneratorFunctionPrototype, "constructor", {
        value: GeneratorFunction,
        configurable: !0
    }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function(t) {
        var e = "function" == typeof t && t.constructor;
        return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name));
    }, e.mark = function(t) {
        return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t;
    }, e.awrap = function(t) {
        return {
            __await: t
        };
    }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function() {
        return this;
    }), e.AsyncIterator = AsyncIterator, e.async = function(t, r, n, o, i) {
        void 0 === i && (i = Promise);
        var a = new AsyncIterator(wrap(t, r, n, o), i);
        return e.isGeneratorFunction(r) ? a : a.next().then(function(t) {
            return t.done ? t.value : a.next();
        });
    }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function() {
        return this;
    }), define(g, "toString", function() {
        return "[object Generator]";
    }), e.keys = function(t) {
        var e = Object(t), r = [];
        for(var n in e)r.push(n);
        return r.reverse(), function next() {
            for(; r.length;){
                var t = r.pop();
                if (t in e) return next.value = t, next.done = !1, next;
            }
            return next.done = !0, next;
        };
    }, e.values = values, Context.prototype = {
        constructor: Context,
        reset: function reset(e) {
            if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for(var r in this)"t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t);
        },
        stop: function stop() {
            this.done = !0;
            var t = this.tryEntries[0].completion;
            if ("throw" === t.type) throw t.arg;
            return this.rval;
        },
        dispatchException: function dispatchException(e) {
            if (this.done) throw e;
            var r = this;
            function handle(n, o) {
                return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o;
            }
            for(var o = this.tryEntries.length - 1; o >= 0; --o){
                var i = this.tryEntries[o], a = i.completion;
                if ("root" === i.tryLoc) return handle("end");
                if (i.tryLoc <= this.prev) {
                    var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc");
                    if (c && u) {
                        if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
                        if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
                    } else if (c) {
                        if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
                    } else {
                        if (!u) throw Error("try statement without catch or finally");
                        if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
                    }
                }
            }
        },
        abrupt: function abrupt(t, e) {
            for(var r = this.tryEntries.length - 1; r >= 0; --r){
                var o = this.tryEntries[r];
                if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
                    var i = o;
                    break;
                }
            }
            i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null);
            var a = i ? i.completion : {};
            return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a);
        },
        complete: function complete(t, e) {
            if ("throw" === t.type) throw t.arg;
            return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y;
        },
        finish: function finish(t) {
            for(var e = this.tryEntries.length - 1; e >= 0; --e){
                var r = this.tryEntries[e];
                if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y;
            }
        },
        "catch": function _catch(t) {
            for(var e = this.tryEntries.length - 1; e >= 0; --e){
                var r = this.tryEntries[e];
                if (r.tryLoc === t) {
                    var n = r.completion;
                    if ("throw" === n.type) {
                        var o = n.arg;
                        resetTryEntry(r);
                    }
                    return o;
                }
            }
            throw Error("illegal catch attempt");
        },
        delegateYield: function delegateYield(e, r, n) {
            return this.delegate = {
                iterator: values(e),
                resultName: r,
                nextLoc: n
            }, "next" === this.method && (this.arg = t), y;
        }
    }, e;
}
module.exports = $e53fa396386fbb67$var$_regeneratorRuntime, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("fFESW", function(module, exports) {
function $b68a664f6437d80c$var$_typeof(o) {
    "@babel/helpers - typeof";
    return module.exports = $b68a664f6437d80c$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $b68a664f6437d80c$var$_typeof(o);
}
module.exports = $b68a664f6437d80c$var$_typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("ihrNW", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => (parcelRequire("7m4qE")).default);
$parcel$export(module.exports, "Icon", () => (parcelRequire("7m4qE")).Icon);
/**
 * @deprecated Import from the generated per-export subpath instead.
 */ 
var $7m4qE = parcelRequire("7m4qE");
 /**
 * @deprecated Import from the generated per-export subpath instead.
 */ 
});
parcelRegister("7m4qE", function(module, exports) {
$parcel$export(module.exports, "Icon", () => $55ae05f90f763cb3$export$f04a61298a47a40f);
$parcel$export(module.exports, "default", () => $55ae05f90f763cb3$export$2e2bcd8739ae039);
/* icon-new.tsx generated by @compiled/babel-plugin v0.40.0 */ 
var $5FkrB = parcelRequire("5FkrB");

var $lqU89 = parcelRequire("lqU89");
/**
 * We are hiding this props from consumers as it's reserved for use by Icon Tile.
 */ var $55ae05f90f763cb3$var$svgStyles = null;
var $55ae05f90f763cb3$var$iconStyles = null;
var $55ae05f90f763cb3$var$smallIconStyles = null;
var $55ae05f90f763cb3$var$scaleStyles = null;
/**
 * For windows high contrast mode
 */ var $55ae05f90f763cb3$var$baseHcmStyles = null;
var $55ae05f90f763cb3$var$scaleSize = null;
var $55ae05f90f763cb3$var$coreSizeMedium = {
    none: "_1bsbpxbi _4t3ipxbi",
    compact: "_1bsb1ejb _4t3i1ejb",
    spacious: "_1bsb1ejb _4t3i1ejb"
};
var $55ae05f90f763cb3$var$coreSizeSmall = {
    none: "_1bsbutpp _4t3iutpp",
    compact: "_1bsbpxbi _4t3ipxbi",
    spacious: "_1bsb1ejb _4t3i1ejb"
};
var $55ae05f90f763cb3$var$paddingMap = {
    medium: {
        none: 0,
        compact: 4,
        spacious: 4
    },
    small: {
        none: 0,
        compact: 2.66,
        spacious: 8
    }
};
var $55ae05f90f763cb3$export$f04a61298a47a40f = /*#__PURE__*/ (0, $5FkrB.memo)(function Icon(props) {
    var _ref = props, _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, testId = _ref.testId, label = _ref.label, dangerouslySetGlyph = _ref.dangerouslySetGlyph, shouldScale = _ref.shouldScale, _ref$spacing = _ref.spacing, spacing = _ref$spacing === void 0 ? 'none' : _ref$spacing, name = _ref.name;
    var dangerouslySetInnerHTML = dangerouslySetGlyph ? {
        __html: dangerouslySetGlyph
    } : undefined;
    var size = 'medium';
    if ('size' in props && props.size !== undefined) {
        if (typeof props.size === 'string') size = props.size === 'small' || props.size === 'medium' ? props.size : size;
        else if (name) {
            var newSize = props.size(name);
            size = newSize === 'small' || newSize === 'medium' ? newSize : size;
        }
    }
    var baseSize = 16;
    var viewBoxPadding = $55ae05f90f763cb3$var$paddingMap[size][spacing];
    var viewBoxSize = baseSize + 2 * viewBoxPadding;
    return /*#__PURE__*/ $5FkrB.createElement("span", {
        "data-testid": testId,
        role: label ? 'img' : undefined,
        "aria-label": label ? label : undefined,
        "aria-hidden": label ? undefined : true,
        style: {
            color: color
        },
        className: (0, $lqU89.default)([
            "_1e0c1o8l _vchhusvi _1o9zidpf _vwz4kb7n _y4ti1igz _bozg1mb9",
            "_12va1onz _jcxd1r8n",
            shouldScale && "_1bsb1kw7 _4t3i1kw7",
            size === 'small' && "_vwz4utpp"
        ])
    }, /*#__PURE__*/ $5FkrB.createElement("svg", {
        fill: "none",
        viewBox: "".concat(0 - viewBoxPadding, " ").concat(0 - viewBoxPadding, " ").concat(viewBoxSize, " ").concat(viewBoxSize),
        role: "presentation",
        dangerouslySetInnerHTML: dangerouslySetInnerHTML,
        className: (0, $lqU89.default)([
            "_1reo15vq _18m915vq _syaz1r31 _lcxvglyw _s7n4yfq0 _vc881r31",
            shouldScale ? "_1bsb1kw7 _4t3i1kw7" : size === 'small' ? $55ae05f90f763cb3$var$coreSizeSmall[spacing] : $55ae05f90f763cb3$var$coreSizeMedium[spacing]
        ])
    }));
});
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$55ae05f90f763cb3$export$2e2bcd8739ae039 = $55ae05f90f763cb3$export$f04a61298a47a40f;

});
parcelRegister("lqU89", function(module, exports) {
$parcel$export(module.exports, "default", () => $f9a7910af6f5dc50$export$2e2bcd8739ae039);
/**
 * The length of the value hash portion of an atomic class name.
 * Atomic class names have the format: `_<group><value>`
 * where group is ATOMIC_GROUP_HASH_LENGTH chars and value is ATOMIC_VALUE_HASH_LENGTH chars.
 *
 * We extract the group key using: `className.slice(0, className.length - ATOMIC_VALUE_HASH_LENGTH)`
 *
 * We support both old-format classes (9 chars: `_` + 4 group + 4 value) and
 * new-format classes (11 chars: `_` + 6 group + 4 value) by using length-based
 * extraction rather than a hardcoded offset — old and new format group keys
 * are different lengths so they are structurally disjoint and never alias each other.
 */ const $f9a7910af6f5dc50$var$ATOMIC_VALUE_HASH_LENGTH = 4;
function $f9a7910af6f5dc50$export$2e2bcd8739ae039(classNames) {
    // Shortcut: nothing to do
    if (!classNames.length) return;
    // Shortcut: don't need to do anything if we only have a single classname
    if (classNames.length === 1 && classNames[0] && // checking to see if `classNames[0]` is a string that contains other classnames
    !classNames[0].includes(' ')) return classNames[0];
    // Using an object rather than a `Map` as it performed better in our benchmarks.
    // Would be happy to move to `Map` if it proved to be better under real conditions.
    const map = {};
    // Note: using loops to minimize iterations over the collection
    for (const value of classNames){
        // Exclude all falsy values, which leaves us with populated strings
        if (!value) continue;
        // a `value` can contain multiple classnames
        const list = value.split(' ');
        for (const className of list){
            /**
             * For atomic style classnames: the `key` is the `group`
             *
             * - Later atomic classnames with the same `group` will override earlier ones
             *   (which is what we want).
             * - Assumes atomic classnames are the only things that start with `_`
             * - Could use a regex to ensure that atomic classnames are structured how we expect,
             *   but did not add that for now as it did slow things down a bit.
             *
             * For other classnames: the `key` is the whole classname
             * - Okay to remove duplicates as doing so does not impact specificity
             *
             * */ const key = className.startsWith('_') ? className.slice(0, className.length - $f9a7910af6f5dc50$var$ATOMIC_VALUE_HASH_LENGTH) : className;
            map[key] = className;
        }
    }
    /**
     * We are converting the `map` into a string.
     *
     * The simple way to do this would be `Object.values(map).join(' ')`.
     * However, the approach below performs 10%-20% better in benchmarks.
     *
     * For `ax()` it feels right to squeeze as much runtime performance out as we can.
     */ let result = '';
    for(const key in map)result += map[key] + ' ';
    // If we have an empty string, then our `map` was empty.
    if (!result) return;
    // remove last " " from the result (we added " " at the end of every value)
    return result.trimEnd();
}

});



parcelRegister("9cXjV", function(module, exports) {

var $eYBUw = parcelRequire("eYBUw");
var $6b433fda3343a84d$var$_typeof = $eYBUw.default;
function $6b433fda3343a84d$var$_regeneratorRuntime() {
    "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ 
    module.exports = $6b433fda3343a84d$var$_regeneratorRuntime = function _regeneratorRuntime() {
        return e;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports;
    var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function(t, e, r) {
        t[e] = r.value;
    }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag";
    function define(t, e, r) {
        return Object.defineProperty(t, e, {
            value: r,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }), t[e];
    }
    try {
        define({}, "");
    } catch (t) {
        define = function define(t, e, r) {
            return t[e] = r;
        };
    }
    function wrap(t, e, r, n) {
        var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []);
        return o(a, "_invoke", {
            value: makeInvokeMethod(t, r, c)
        }), a;
    }
    function tryCatch(t, e, r) {
        try {
            return {
                type: "normal",
                arg: t.call(e, r)
            };
        } catch (t) {
            return {
                type: "throw",
                arg: t
            };
        }
    }
    e.wrap = wrap;
    var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {};
    function Generator() {}
    function GeneratorFunction() {}
    function GeneratorFunctionPrototype() {}
    var p = {};
    define(p, a, function() {
        return this;
    });
    var d = Object.getPrototypeOf, v = d && d(d(values([])));
    v && v !== r && n.call(v, a) && (p = v);
    var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p);
    function defineIteratorMethods(t) {
        [
            "next",
            "throw",
            "return"
        ].forEach(function(e) {
            define(t, e, function(t) {
                return this._invoke(e, t);
            });
        });
    }
    function AsyncIterator(t, e) {
        function invoke(r, o, i, a) {
            var c = tryCatch(t[r], t, o);
            if ("throw" !== c.type) {
                var u = c.arg, h = u.value;
                return h && "object" == $6b433fda3343a84d$var$_typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function(t) {
                    invoke("next", t, i, a);
                }, function(t) {
                    invoke("throw", t, i, a);
                }) : e.resolve(h).then(function(t) {
                    u.value = t, i(u);
                }, function(t) {
                    return invoke("throw", t, i, a);
                });
            }
            a(c.arg);
        }
        var r;
        o(this, "_invoke", {
            value: function value(t, n) {
                function callInvokeWithMethodAndArg() {
                    return new e(function(e, r) {
                        invoke(t, n, e, r);
                    });
                }
                return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
            }
        });
    }
    function makeInvokeMethod(e, r, n) {
        var o = h;
        return function(i, a) {
            if (o === f) throw Error("Generator is already running");
            if (o === s) {
                if ("throw" === i) throw a;
                return {
                    value: t,
                    done: !0
                };
            }
            for(n.method = i, n.arg = a;;){
                var c = n.delegate;
                if (c) {
                    var u = maybeInvokeDelegate(c, n);
                    if (u) {
                        if (u === y) continue;
                        return u;
                    }
                }
                if ("next" === n.method) n.sent = n._sent = n.arg;
                else if ("throw" === n.method) {
                    if (o === h) throw o = s, n.arg;
                    n.dispatchException(n.arg);
                } else "return" === n.method && n.abrupt("return", n.arg);
                o = f;
                var p = tryCatch(e, r, n);
                if ("normal" === p.type) {
                    if (o = n.done ? s : l, p.arg === y) continue;
                    return {
                        value: p.arg,
                        done: n.done
                    };
                }
                "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg);
            }
        };
    }
    function maybeInvokeDelegate(e, r) {
        var n = r.method, o = e.iterator[n];
        if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y;
        var i = tryCatch(o, e.iterator, r.arg);
        if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y;
        var a = i.arg;
        return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y);
    }
    function pushTryEntry(t) {
        var e = {
            tryLoc: t[0]
        };
        1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e);
    }
    function resetTryEntry(t) {
        var e = t.completion || {};
        e.type = "normal", delete e.arg, t.completion = e;
    }
    function Context(t) {
        this.tryEntries = [
            {
                tryLoc: "root"
            }
        ], t.forEach(pushTryEntry, this), this.reset(!0);
    }
    function values(e) {
        if (e || "" === e) {
            var r = e[a];
            if (r) return r.call(e);
            if ("function" == typeof e.next) return e;
            if (!isNaN(e.length)) {
                var o = -1, i = function next() {
                    for(; ++o < e.length;)if (n.call(e, o)) return next.value = e[o], next.done = !1, next;
                    return next.value = t, next.done = !0, next;
                };
                return i.next = i;
            }
        }
        throw new TypeError($6b433fda3343a84d$var$_typeof(e) + " is not iterable");
    }
    return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", {
        value: GeneratorFunctionPrototype,
        configurable: !0
    }), o(GeneratorFunctionPrototype, "constructor", {
        value: GeneratorFunction,
        configurable: !0
    }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function(t) {
        var e = "function" == typeof t && t.constructor;
        return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name));
    }, e.mark = function(t) {
        return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t;
    }, e.awrap = function(t) {
        return {
            __await: t
        };
    }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function() {
        return this;
    }), e.AsyncIterator = AsyncIterator, e.async = function(t, r, n, o, i) {
        void 0 === i && (i = Promise);
        var a = new AsyncIterator(wrap(t, r, n, o), i);
        return e.isGeneratorFunction(r) ? a : a.next().then(function(t) {
            return t.done ? t.value : a.next();
        });
    }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function() {
        return this;
    }), define(g, "toString", function() {
        return "[object Generator]";
    }), e.keys = function(t) {
        var e = Object(t), r = [];
        for(var n in e)r.push(n);
        return r.reverse(), function next() {
            for(; r.length;){
                var t = r.pop();
                if (t in e) return next.value = t, next.done = !1, next;
            }
            return next.done = !0, next;
        };
    }, e.values = values, Context.prototype = {
        constructor: Context,
        reset: function reset(e) {
            if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for(var r in this)"t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t);
        },
        stop: function stop() {
            this.done = !0;
            var t = this.tryEntries[0].completion;
            if ("throw" === t.type) throw t.arg;
            return this.rval;
        },
        dispatchException: function dispatchException(e) {
            if (this.done) throw e;
            var r = this;
            function handle(n, o) {
                return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o;
            }
            for(var o = this.tryEntries.length - 1; o >= 0; --o){
                var i = this.tryEntries[o], a = i.completion;
                if ("root" === i.tryLoc) return handle("end");
                if (i.tryLoc <= this.prev) {
                    var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc");
                    if (c && u) {
                        if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
                        if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
                    } else if (c) {
                        if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
                    } else {
                        if (!u) throw Error("try statement without catch or finally");
                        if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
                    }
                }
            }
        },
        abrupt: function abrupt(t, e) {
            for(var r = this.tryEntries.length - 1; r >= 0; --r){
                var o = this.tryEntries[r];
                if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
                    var i = o;
                    break;
                }
            }
            i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null);
            var a = i ? i.completion : {};
            return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a);
        },
        complete: function complete(t, e) {
            if ("throw" === t.type) throw t.arg;
            return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y;
        },
        finish: function finish(t) {
            for(var e = this.tryEntries.length - 1; e >= 0; --e){
                var r = this.tryEntries[e];
                if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y;
            }
        },
        "catch": function _catch(t) {
            for(var e = this.tryEntries.length - 1; e >= 0; --e){
                var r = this.tryEntries[e];
                if (r.tryLoc === t) {
                    var n = r.completion;
                    if ("throw" === n.type) {
                        var o = n.arg;
                        resetTryEntry(r);
                    }
                    return o;
                }
            }
            throw Error("illegal catch attempt");
        },
        delegateYield: function delegateYield(e, r, n) {
            return this.delegate = {
                iterator: values(e),
                resultName: r,
                nextLoc: n
            }, "next" === this.method && (this.arg = t), y;
        }
    }, e;
}
module.exports = $6b433fda3343a84d$var$_regeneratorRuntime, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("eYBUw", function(module, exports) {
function $ae74138db6cabaaa$var$_typeof(o) {
    "@babel/helpers - typeof";
    return module.exports = $ae74138db6cabaaa$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $ae74138db6cabaaa$var$_typeof(o);
}
module.exports = $ae74138db6cabaaa$var$_typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("f28qG", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => (parcelRequire("cgSLx")).default);
$parcel$export(module.exports, "Icon", () => (parcelRequire("cgSLx")).Icon);
/**
 * @deprecated Import from the generated per-export subpath instead.
 */ 
var $cgSLx = parcelRequire("cgSLx");
 /**
 * @deprecated Import from the generated per-export subpath instead.
 */ 
});
parcelRegister("cgSLx", function(module, exports) {
$parcel$export(module.exports, "Icon", () => $8ef175fbb66f6c06$export$f04a61298a47a40f);
$parcel$export(module.exports, "default", () => $8ef175fbb66f6c06$export$2e2bcd8739ae039);
/* icon-new.tsx generated by @compiled/babel-plugin v0.40.0 */ 
var $5FkrB = parcelRequire("5FkrB");

var $jzAQA = parcelRequire("jzAQA");
/**
 * We are hiding this props from consumers as it's reserved for use by Icon Tile.
 */ var $8ef175fbb66f6c06$var$svgStyles = null;
var $8ef175fbb66f6c06$var$iconStyles = null;
var $8ef175fbb66f6c06$var$smallIconStyles = null;
var $8ef175fbb66f6c06$var$scaleStyles = null;
/**
 * For windows high contrast mode
 */ var $8ef175fbb66f6c06$var$baseHcmStyles = null;
var $8ef175fbb66f6c06$var$scaleSize = null;
var $8ef175fbb66f6c06$var$coreSizeMedium = {
    none: "_1bsbpxbi _4t3ipxbi",
    compact: "_1bsb1ejb _4t3i1ejb",
    spacious: "_1bsb1ejb _4t3i1ejb"
};
var $8ef175fbb66f6c06$var$coreSizeSmall = {
    none: "_1bsbutpp _4t3iutpp",
    compact: "_1bsbpxbi _4t3ipxbi",
    spacious: "_1bsb1ejb _4t3i1ejb"
};
var $8ef175fbb66f6c06$var$paddingMap = {
    medium: {
        none: 0,
        compact: 4,
        spacious: 4
    },
    small: {
        none: 0,
        compact: 2.66,
        spacious: 8
    }
};
var $8ef175fbb66f6c06$export$f04a61298a47a40f = /*#__PURE__*/ (0, $5FkrB.memo)(function Icon(props) {
    var _ref = props, _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, testId = _ref.testId, label = _ref.label, dangerouslySetGlyph = _ref.dangerouslySetGlyph, shouldScale = _ref.shouldScale, _ref$spacing = _ref.spacing, spacing = _ref$spacing === void 0 ? 'none' : _ref$spacing, name = _ref.name;
    var dangerouslySetInnerHTML = dangerouslySetGlyph ? {
        __html: dangerouslySetGlyph
    } : undefined;
    var size = 'medium';
    if ('size' in props && props.size !== undefined) {
        if (typeof props.size === 'string') size = props.size === 'small' || props.size === 'medium' ? props.size : size;
        else if (name) {
            var newSize = props.size(name);
            size = newSize === 'small' || newSize === 'medium' ? newSize : size;
        }
    }
    var baseSize = 16;
    var viewBoxPadding = $8ef175fbb66f6c06$var$paddingMap[size][spacing];
    var viewBoxSize = baseSize + 2 * viewBoxPadding;
    return /*#__PURE__*/ $5FkrB.createElement("span", {
        "data-testid": testId,
        role: label ? 'img' : undefined,
        "aria-label": label ? label : undefined,
        "aria-hidden": label ? undefined : true,
        style: {
            color: color
        },
        className: (0, $jzAQA.default)([
            "_1e0c1o8l _vchhusvi _1o9zidpf _vwz4kb7n _y4ti1igz _bozg1mb9",
            "_12va1onz _jcxd1r8n",
            shouldScale && "_1bsb1kw7 _4t3i1kw7",
            size === 'small' && "_vwz4utpp"
        ])
    }, /*#__PURE__*/ $5FkrB.createElement("svg", {
        fill: "none",
        viewBox: "".concat(0 - viewBoxPadding, " ").concat(0 - viewBoxPadding, " ").concat(viewBoxSize, " ").concat(viewBoxSize),
        role: "presentation",
        dangerouslySetInnerHTML: dangerouslySetInnerHTML,
        className: (0, $jzAQA.default)([
            "_1reo15vq _18m915vq _syaz1r31 _lcxvglyw _s7n4yfq0 _vc881r31",
            shouldScale ? "_1bsb1kw7 _4t3i1kw7" : size === 'small' ? $8ef175fbb66f6c06$var$coreSizeSmall[spacing] : $8ef175fbb66f6c06$var$coreSizeMedium[spacing]
        ])
    }));
});
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$8ef175fbb66f6c06$export$2e2bcd8739ae039 = $8ef175fbb66f6c06$export$f04a61298a47a40f;

});
parcelRegister("jzAQA", function(module, exports) {
$parcel$export(module.exports, "default", () => $e3fdde47028fe4d8$export$2e2bcd8739ae039);
/**
 * The length of the value hash portion of an atomic class name.
 * Atomic class names have the format: `_<group><value>`
 * where group is ATOMIC_GROUP_HASH_LENGTH chars and value is ATOMIC_VALUE_HASH_LENGTH chars.
 *
 * We extract the group key using: `className.slice(0, className.length - ATOMIC_VALUE_HASH_LENGTH)`
 *
 * We support both old-format classes (9 chars: `_` + 4 group + 4 value) and
 * new-format classes (11 chars: `_` + 6 group + 4 value) by using length-based
 * extraction rather than a hardcoded offset — old and new format group keys
 * are different lengths so they are structurally disjoint and never alias each other.
 */ const $e3fdde47028fe4d8$var$ATOMIC_VALUE_HASH_LENGTH = 4;
function $e3fdde47028fe4d8$export$2e2bcd8739ae039(classNames) {
    // Shortcut: nothing to do
    if (!classNames.length) return;
    // Shortcut: don't need to do anything if we only have a single classname
    if (classNames.length === 1 && classNames[0] && // checking to see if `classNames[0]` is a string that contains other classnames
    !classNames[0].includes(' ')) return classNames[0];
    // Using an object rather than a `Map` as it performed better in our benchmarks.
    // Would be happy to move to `Map` if it proved to be better under real conditions.
    const map = {};
    // Note: using loops to minimize iterations over the collection
    for (const value of classNames){
        // Exclude all falsy values, which leaves us with populated strings
        if (!value) continue;
        // a `value` can contain multiple classnames
        const list = value.split(' ');
        for (const className of list){
            /**
             * For atomic style classnames: the `key` is the `group`
             *
             * - Later atomic classnames with the same `group` will override earlier ones
             *   (which is what we want).
             * - Assumes atomic classnames are the only things that start with `_`
             * - Could use a regex to ensure that atomic classnames are structured how we expect,
             *   but did not add that for now as it did slow things down a bit.
             *
             * For other classnames: the `key` is the whole classname
             * - Okay to remove duplicates as doing so does not impact specificity
             *
             * */ const key = className.startsWith('_') ? className.slice(0, className.length - $e3fdde47028fe4d8$var$ATOMIC_VALUE_HASH_LENGTH) : className;
            map[key] = className;
        }
    }
    /**
     * We are converting the `map` into a string.
     *
     * The simple way to do this would be `Object.values(map).join(' ')`.
     * However, the approach below performs 10%-20% better in benchmarks.
     *
     * For `ax()` it feels right to squeeze as much runtime performance out as we can.
     */ let result = '';
    for(const key in map)result += map[key] + ' ';
    // If we have an empty string, then our `map` was empty.
    if (!result) return;
    // remove last " " from the result (we added " " at the end of every value)
    return result.trimEnd();
}

});



parcelRegister("amAaq", function(module, exports) {
$parcel$export(module.exports, "default", () => $78b8037a30e34162$export$2e2bcd8739ae039);

var $bk4Fz = parcelRequire("bk4Fz");

var $ddrTG = parcelRequire("ddrTG");

var $eGF4o = parcelRequire("eGF4o");

var $fczfy = parcelRequire("fczfy");
function $78b8037a30e34162$export$2e2bcd8739ae039(r, e) {
    return (0, $bk4Fz.default)(r) || (0, $ddrTG.default)(r, e) || (0, $eGF4o.default)(r, e) || (0, $fczfy.default)();
}

});
parcelRegister("bk4Fz", function(module, exports) {
$parcel$export(module.exports, "default", () => $022099892ca12d0d$export$2e2bcd8739ae039);
function $022099892ca12d0d$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return r;
}

});

parcelRegister("ddrTG", function(module, exports) {
$parcel$export(module.exports, "default", () => $99f2210dacebfd95$export$2e2bcd8739ae039);
function $99f2210dacebfd95$export$2e2bcd8739ae039(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}

});

parcelRegister("eGF4o", function(module, exports) {
$parcel$export(module.exports, "default", () => $ab14d88e41dcff7d$export$2e2bcd8739ae039);

var $2uysb = parcelRequire("2uysb");
function $ab14d88e41dcff7d$export$2e2bcd8739ae039(r, a) {
    if (r) {
        if ("string" == typeof r) return (0, $2uysb.default)(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? (0, $2uysb.default)(r, a) : void 0;
    }
}

});
parcelRegister("2uysb", function(module, exports) {
$parcel$export(module.exports, "default", () => $1d091be355e745b7$export$2e2bcd8739ae039);
function $1d091be355e745b7$export$2e2bcd8739ae039(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}

});


parcelRegister("fczfy", function(module, exports) {
$parcel$export(module.exports, "default", () => $b11351e94895b056$export$2e2bcd8739ae039);
function $b11351e94895b056$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});


parcelRegister("jgyhF", function(module, exports) {
$parcel$export(module.exports, "default", () => $e06a1b02df09a3d6$export$2e2bcd8739ae039);

var $dUVGk = parcelRequire("dUVGk");
function $e06a1b02df09a3d6$export$2e2bcd8739ae039(e, r, t) {
    return (r = (0, $dUVGk.default)(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}

});
parcelRegister("dUVGk", function(module, exports) {
$parcel$export(module.exports, "default", () => $a21d3fb5c2e2219b$export$2e2bcd8739ae039);

var $hCM0e = parcelRequire("hCM0e");

var $3OaQV = parcelRequire("3OaQV");
function $a21d3fb5c2e2219b$export$2e2bcd8739ae039(t) {
    var i = (0, $3OaQV.default)(t, "string");
    return "symbol" == (0, $hCM0e.default)(i) ? i : i + "";
}

});
parcelRegister("hCM0e", function(module, exports) {
$parcel$export(module.exports, "default", () => $cd4b38a370b0dd54$export$2e2bcd8739ae039);
function $cd4b38a370b0dd54$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $cd4b38a370b0dd54$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $cd4b38a370b0dd54$export$2e2bcd8739ae039(o);
}

});

parcelRegister("3OaQV", function(module, exports) {
$parcel$export(module.exports, "default", () => $2c5e75bc51aff02b$export$2e2bcd8739ae039);

var $hCM0e = parcelRequire("hCM0e");
function $2c5e75bc51aff02b$export$2e2bcd8739ae039(t, r) {
    if ("object" != (0, $hCM0e.default)(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (0, $hCM0e.default)(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}

});



parcelRegister("5MmUg", function(module, exports) {
$parcel$export(module.exports, "default", () => $4353342d29db5f69$export$2e2bcd8739ae039);

var $asMGE = parcelRequire("asMGE");

var $jmSoi = parcelRequire("jmSoi");

var $eGF4o = parcelRequire("eGF4o");

var $fsXKT = parcelRequire("fsXKT");
function $4353342d29db5f69$export$2e2bcd8739ae039(r) {
    return (0, $asMGE.default)(r) || (0, $jmSoi.default)(r) || (0, $eGF4o.default)(r) || (0, $fsXKT.default)();
}

});
parcelRegister("asMGE", function(module, exports) {
$parcel$export(module.exports, "default", () => $79e2491cc18f04b7$export$2e2bcd8739ae039);

var $2uysb = parcelRequire("2uysb");
function $79e2491cc18f04b7$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return (0, $2uysb.default)(r);
}

});

parcelRegister("jmSoi", function(module, exports) {
$parcel$export(module.exports, "default", () => $e19a434d02f14218$export$2e2bcd8739ae039);
function $e19a434d02f14218$export$2e2bcd8739ae039(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}

});

parcelRegister("fsXKT", function(module, exports) {
$parcel$export(module.exports, "default", () => $b427d2b8cdaf5312$export$2e2bcd8739ae039);
function $b427d2b8cdaf5312$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});


parcelRegister("cdRUW", function(module, exports) {
$parcel$export(module.exports, "default", () => $8e6085c9c00d3348$export$2e2bcd8739ae039);
function $8e6085c9c00d3348$export$2e2bcd8739ae039(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}

});

parcelRegister("i1Bei", function(module, exports) {
$parcel$export(module.exports, "default", () => $d1f53302826232fb$export$2e2bcd8739ae039);

var $dUVGk = parcelRequire("dUVGk");
function $d1f53302826232fb$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, (0, $dUVGk.default)(o.key), o);
    }
}
function $d1f53302826232fb$export$2e2bcd8739ae039(e, r, t) {
    return r && $d1f53302826232fb$var$_defineProperties(e.prototype, r), t && $d1f53302826232fb$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}

});

parcelRegister("3cecY", function(module, exports) {

var $7cv1K = parcelRequire("7cv1K");
var $253d83886f9a7444$var$_typeof = $7cv1K.default;
function $253d83886f9a7444$var$_regeneratorRuntime() {
    "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ 
    module.exports = $253d83886f9a7444$var$_regeneratorRuntime = function _regeneratorRuntime() {
        return e;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports;
    var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function(t, e, r) {
        t[e] = r.value;
    }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag";
    function define(t, e, r) {
        return Object.defineProperty(t, e, {
            value: r,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }), t[e];
    }
    try {
        define({}, "");
    } catch (t) {
        define = function define(t, e, r) {
            return t[e] = r;
        };
    }
    function wrap(t, e, r, n) {
        var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []);
        return o(a, "_invoke", {
            value: makeInvokeMethod(t, r, c)
        }), a;
    }
    function tryCatch(t, e, r) {
        try {
            return {
                type: "normal",
                arg: t.call(e, r)
            };
        } catch (t) {
            return {
                type: "throw",
                arg: t
            };
        }
    }
    e.wrap = wrap;
    var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {};
    function Generator() {}
    function GeneratorFunction() {}
    function GeneratorFunctionPrototype() {}
    var p = {};
    define(p, a, function() {
        return this;
    });
    var d = Object.getPrototypeOf, v = d && d(d(values([])));
    v && v !== r && n.call(v, a) && (p = v);
    var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p);
    function defineIteratorMethods(t) {
        [
            "next",
            "throw",
            "return"
        ].forEach(function(e) {
            define(t, e, function(t) {
                return this._invoke(e, t);
            });
        });
    }
    function AsyncIterator(t, e) {
        function invoke(r, o, i, a) {
            var c = tryCatch(t[r], t, o);
            if ("throw" !== c.type) {
                var u = c.arg, h = u.value;
                return h && "object" == $253d83886f9a7444$var$_typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function(t) {
                    invoke("next", t, i, a);
                }, function(t) {
                    invoke("throw", t, i, a);
                }) : e.resolve(h).then(function(t) {
                    u.value = t, i(u);
                }, function(t) {
                    return invoke("throw", t, i, a);
                });
            }
            a(c.arg);
        }
        var r;
        o(this, "_invoke", {
            value: function value(t, n) {
                function callInvokeWithMethodAndArg() {
                    return new e(function(e, r) {
                        invoke(t, n, e, r);
                    });
                }
                return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
            }
        });
    }
    function makeInvokeMethod(e, r, n) {
        var o = h;
        return function(i, a) {
            if (o === f) throw Error("Generator is already running");
            if (o === s) {
                if ("throw" === i) throw a;
                return {
                    value: t,
                    done: !0
                };
            }
            for(n.method = i, n.arg = a;;){
                var c = n.delegate;
                if (c) {
                    var u = maybeInvokeDelegate(c, n);
                    if (u) {
                        if (u === y) continue;
                        return u;
                    }
                }
                if ("next" === n.method) n.sent = n._sent = n.arg;
                else if ("throw" === n.method) {
                    if (o === h) throw o = s, n.arg;
                    n.dispatchException(n.arg);
                } else "return" === n.method && n.abrupt("return", n.arg);
                o = f;
                var p = tryCatch(e, r, n);
                if ("normal" === p.type) {
                    if (o = n.done ? s : l, p.arg === y) continue;
                    return {
                        value: p.arg,
                        done: n.done
                    };
                }
                "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg);
            }
        };
    }
    function maybeInvokeDelegate(e, r) {
        var n = r.method, o = e.iterator[n];
        if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y;
        var i = tryCatch(o, e.iterator, r.arg);
        if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y;
        var a = i.arg;
        return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y);
    }
    function pushTryEntry(t) {
        var e = {
            tryLoc: t[0]
        };
        1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e);
    }
    function resetTryEntry(t) {
        var e = t.completion || {};
        e.type = "normal", delete e.arg, t.completion = e;
    }
    function Context(t) {
        this.tryEntries = [
            {
                tryLoc: "root"
            }
        ], t.forEach(pushTryEntry, this), this.reset(!0);
    }
    function values(e) {
        if (e || "" === e) {
            var r = e[a];
            if (r) return r.call(e);
            if ("function" == typeof e.next) return e;
            if (!isNaN(e.length)) {
                var o = -1, i = function next() {
                    for(; ++o < e.length;)if (n.call(e, o)) return next.value = e[o], next.done = !1, next;
                    return next.value = t, next.done = !0, next;
                };
                return i.next = i;
            }
        }
        throw new TypeError($253d83886f9a7444$var$_typeof(e) + " is not iterable");
    }
    return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", {
        value: GeneratorFunctionPrototype,
        configurable: !0
    }), o(GeneratorFunctionPrototype, "constructor", {
        value: GeneratorFunction,
        configurable: !0
    }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function(t) {
        var e = "function" == typeof t && t.constructor;
        return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name));
    }, e.mark = function(t) {
        return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t;
    }, e.awrap = function(t) {
        return {
            __await: t
        };
    }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function() {
        return this;
    }), e.AsyncIterator = AsyncIterator, e.async = function(t, r, n, o, i) {
        void 0 === i && (i = Promise);
        var a = new AsyncIterator(wrap(t, r, n, o), i);
        return e.isGeneratorFunction(r) ? a : a.next().then(function(t) {
            return t.done ? t.value : a.next();
        });
    }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function() {
        return this;
    }), define(g, "toString", function() {
        return "[object Generator]";
    }), e.keys = function(t) {
        var e = Object(t), r = [];
        for(var n in e)r.push(n);
        return r.reverse(), function next() {
            for(; r.length;){
                var t = r.pop();
                if (t in e) return next.value = t, next.done = !1, next;
            }
            return next.done = !0, next;
        };
    }, e.values = values, Context.prototype = {
        constructor: Context,
        reset: function reset(e) {
            if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for(var r in this)"t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t);
        },
        stop: function stop() {
            this.done = !0;
            var t = this.tryEntries[0].completion;
            if ("throw" === t.type) throw t.arg;
            return this.rval;
        },
        dispatchException: function dispatchException(e) {
            if (this.done) throw e;
            var r = this;
            function handle(n, o) {
                return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o;
            }
            for(var o = this.tryEntries.length - 1; o >= 0; --o){
                var i = this.tryEntries[o], a = i.completion;
                if ("root" === i.tryLoc) return handle("end");
                if (i.tryLoc <= this.prev) {
                    var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc");
                    if (c && u) {
                        if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
                        if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
                    } else if (c) {
                        if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
                    } else {
                        if (!u) throw Error("try statement without catch or finally");
                        if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
                    }
                }
            }
        },
        abrupt: function abrupt(t, e) {
            for(var r = this.tryEntries.length - 1; r >= 0; --r){
                var o = this.tryEntries[r];
                if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
                    var i = o;
                    break;
                }
            }
            i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null);
            var a = i ? i.completion : {};
            return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a);
        },
        complete: function complete(t, e) {
            if ("throw" === t.type) throw t.arg;
            return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y;
        },
        finish: function finish(t) {
            for(var e = this.tryEntries.length - 1; e >= 0; --e){
                var r = this.tryEntries[e];
                if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y;
            }
        },
        "catch": function _catch(t) {
            for(var e = this.tryEntries.length - 1; e >= 0; --e){
                var r = this.tryEntries[e];
                if (r.tryLoc === t) {
                    var n = r.completion;
                    if ("throw" === n.type) {
                        var o = n.arg;
                        resetTryEntry(r);
                    }
                    return o;
                }
            }
            throw Error("illegal catch attempt");
        },
        delegateYield: function delegateYield(e, r, n) {
            return this.delegate = {
                iterator: values(e),
                resultName: r,
                nextLoc: n
            }, "next" === this.method && (this.arg = t), y;
        }
    }, e;
}
module.exports = $253d83886f9a7444$var$_regeneratorRuntime, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("7cv1K", function(module, exports) {
function $53e1b8b989ae8773$var$_typeof(o) {
    "@babel/helpers - typeof";
    return module.exports = $53e1b8b989ae8773$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $53e1b8b989ae8773$var$_typeof(o);
}
module.exports = $53e1b8b989ae8773$var$_typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("4lL0s", function(module, exports) {
$parcel$export(module.exports, "THEME_DATA_ATTRIBUTE", () => $32ad961236013234$export$4ef52930e33717cd);
$parcel$export(module.exports, "SUBTREE_THEME_ATTRIBUTE", () => $32ad961236013234$export$cb374d25ded7f6ab);
$parcel$export(module.exports, "COLOR_MODE_ATTRIBUTE", () => $32ad961236013234$export$a00eac3f8684bcd0);
$parcel$export(module.exports, "CONTRAST_MODE_ATTRIBUTE", () => $32ad961236013234$export$2112803007239c61);
$parcel$export(module.exports, "CUSTOM_THEME_ATTRIBUTE", () => $32ad961236013234$export$352e418ed5b6193a);
var $32ad961236013234$export$4ef52930e33717cd = 'data-theme';
var $32ad961236013234$export$cb374d25ded7f6ab = 'data-subtree-theme';
var $32ad961236013234$export$a00eac3f8684bcd0 = 'data-color-mode';
var $32ad961236013234$export$2112803007239c61 = 'data-contrast-mode';
var $32ad961236013234$export$352e418ed5b6193a = 'data-custom-theme';
var $32ad961236013234$export$6f0c6fb8c80fcc92 = 'ds';
var $32ad961236013234$export$4d0c7bbf80185957 = [
    'opacity',
    'font',
    'space',
    'border',
    'radius'
];
var $32ad961236013234$export$dddac1532e822863 = "--".concat($32ad961236013234$export$6f0c6fb8c80fcc92, "-token-not-found");
var $32ad961236013234$export$9d7b58831ae93caa = "--".concat($32ad961236013234$export$6f0c6fb8c80fcc92, "-elevation-surface-current");

});

parcelRegister("guClf", function(module, exports) {
$parcel$export(module.exports, "themeStateDefaults", () => $c01d308894a40c4b$export$9aedcfa7336a207);

var $iC6d4 = parcelRequire("iC6d4");
/**
 * Can't evaluate typography feature flags at the module level,
 * it will always resolve to false when server side rendered or when flags are loaded async.
 */ function $c01d308894a40c4b$var$getShapeDefault() {
    if ((0, $iC6d4.fg)('platform-dst-shape-theme-default')) return 'shape';
    return undefined;
}
function $c01d308894a40c4b$var$getMotionDefault() {
    return 'motion';
}
var $c01d308894a40c4b$export$9aedcfa7336a207 = {
    colorMode: 'auto',
    contrastMode: 'auto',
    dark: 'dark',
    light: 'light',
    shape: $c01d308894a40c4b$var$getShapeDefault,
    spacing: 'spacing',
    typography: 'typography',
    motion: $c01d308894a40c4b$var$getMotionDefault,
    UNSAFE_themeOptions: undefined
};

});
parcelRegister("iC6d4", function(module, exports) {
$parcel$export(module.exports, "fg", () => $d8d097bccac08fc6$export$b40ec24ac8275656);

var $ftODZ = parcelRequire("ftODZ");
function $d8d097bccac08fc6$export$ba05d765b8392e5e(flagResolver) {
    (0, $ftODZ.setBooleanResolver)(flagResolver);
}
function $d8d097bccac08fc6$export$470e5c2be1411c89(name) {
    return (0, $ftODZ.resolveBooleanFlag)(name);
}
function $d8d097bccac08fc6$export$b40ec24ac8275656(name) {
    return (0, $ftODZ.resolveBooleanFlag)(name);
}

});
parcelRegister("ftODZ", function(module, exports) {
$parcel$export(module.exports, "setBooleanResolver", () => $02e887a25146fbd6$export$f2b591175b3e424c);
$parcel$export(module.exports, "resolveBooleanFlag", () => $02e887a25146fbd6$export$6333b6aff9fc6275);

var $GmDrz = parcelRequire("GmDrz");

var $5DfHM = parcelRequire("5DfHM");

var $3ZMUU = parcelRequire("3ZMUU");
var $02e887a25146fbd6$var$pkgName = '@atlaskit/platform-feature-flags';
var $02e887a25146fbd6$export$7e41b1b2bdee3f98 = '__PLATFORM_FEATURE_FLAGS__';
var $02e887a25146fbd6$var$hasProcessEnv = typeof $3ZMUU !== 'undefined' && typeof $3ZMUU.env !== 'undefined';
// FF global overrides can be configured by test runners or Storybook
var $02e887a25146fbd6$var$ENV_ENABLE_PLATFORM_FF = $02e887a25146fbd6$var$hasProcessEnv ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;
// STORYBOOK_ENABLE_PLATFORM_FF is included as storybook only allows env vars prefixed with STORYBOOK
// https://github.com/storybookjs/storybook/issues/12270
var $02e887a25146fbd6$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF = $02e887a25146fbd6$var$hasProcessEnv ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;
var $02e887a25146fbd6$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE = $02e887a25146fbd6$var$ENV_ENABLE_PLATFORM_FF || $02e887a25146fbd6$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF;
var $02e887a25146fbd6$var$DEFAULT_PFF_GLOBAL = {
    booleanResolver: undefined
};
var $02e887a25146fbd6$var$globalVar = typeof window !== 'undefined' ? window : globalThis;
$02e887a25146fbd6$var$globalVar[$02e887a25146fbd6$export$7e41b1b2bdee3f98] = $02e887a25146fbd6$var$globalVar[$02e887a25146fbd6$export$7e41b1b2bdee3f98] || $02e887a25146fbd6$var$DEFAULT_PFF_GLOBAL;
function $02e887a25146fbd6$export$f2b591175b3e424c(resolver) {
    $02e887a25146fbd6$var$globalVar[$02e887a25146fbd6$export$7e41b1b2bdee3f98].booleanResolver = resolver;
}
function $02e887a25146fbd6$export$6333b6aff9fc6275(flagKey) {
    if ($02e887a25146fbd6$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE) {
        (0, $5DfHM.debug)('[%s]: The feature flags were enabled while running tests. The flag "%s" will be always enabled.', $02e887a25146fbd6$var$pkgName, flagKey);
        return true;
    }
    try {
        var _globalVar$PFF_GLOBAL, _globalVar$PFF_GLOBAL2, _globalVar$PFF_GLOBAL3;
        // booleanResolver will be empty for products like Trello, Elevate, Recruit etc.
        // Currently only Confluence, Jira and Bitbucket has set it.
        if (((_globalVar$PFF_GLOBAL = $02e887a25146fbd6$var$globalVar[$02e887a25146fbd6$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL === void 0 ? void 0 : _globalVar$PFF_GLOBAL.booleanResolver) === undefined || ((_globalVar$PFF_GLOBAL2 = $02e887a25146fbd6$var$globalVar[$02e887a25146fbd6$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL2 === void 0 ? void 0 : _globalVar$PFF_GLOBAL2.booleanResolver) === null) // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
        return (0, $GmDrz.default).checkGate(flagKey);
        var result = (_globalVar$PFF_GLOBAL3 = $02e887a25146fbd6$var$globalVar[$02e887a25146fbd6$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL3 === void 0 ? void 0 : _globalVar$PFF_GLOBAL3.booleanResolver(flagKey);
        if (typeof result !== 'boolean') {
            // eslint-disable-next-line no-console
            console.warn("".concat(flagKey, " resolved to a non-boolean value, returning false for safety"));
            return false;
        }
        return result;
    } catch (e) {
        return false;
    }
}

});
parcelRegister("GmDrz", function(module, exports) {
$parcel$export(module.exports, "default", () => $07f57b3c4ab854a4$export$2e2bcd8739ae039);

var $cdRUW = parcelRequire("cdRUW");

var $i1Bei = parcelRequire("i1Bei");

var $jgyhF = parcelRequire("jgyhF");

var $fGHg6 = parcelRequire("fGHg6");

var $48bCT = parcelRequire("48bCT");



var $07f57b3c4ab854a4$var$_FeatureGates;
/**
 * Access the FeatureGates object via the default export.
 * ```ts
 * import FeatureGates from '@atlaskit/feature-gate-js-client';
 * ```
 */ var $07f57b3c4ab854a4$var$FeatureGates = /*#__PURE__*/ function() {
    function FeatureGates() {
        (0, $cdRUW.default)(this, FeatureGates);
    }
    return (0, $i1Bei.default)(FeatureGates, null, [
        {
            key: "isGateExists",
            value: function isGateExists(gateName) {
                return this.client.isGateExist(gateName);
            }
        },
        {
            key: "isExperimentExists",
            value: function isExperimentExists(experimentName) {
                return this.client.isExperimentExist(experimentName);
            }
        }
    ]);
}();
$07f57b3c4ab854a4$var$_FeatureGates = $07f57b3c4ab854a4$var$FeatureGates;
(0, $jgyhF.default)($07f57b3c4ab854a4$var$FeatureGates, "client", new (0, $fGHg6.Client)());
(0, $jgyhF.default)($07f57b3c4ab854a4$var$FeatureGates, "hasCheckGateErrorOccurred", false);
(0, $jgyhF.default)($07f57b3c4ab854a4$var$FeatureGates, "hasGetExperimentValueErrorOccurred", false);
(0, $jgyhF.default)($07f57b3c4ab854a4$var$FeatureGates, "checkGate", function(gateName, options) {
    try {
        // Check if the CRITERION override mechanism is available
        if (typeof window !== 'undefined' && window.__CRITERION__ && typeof window.__CRITERION__.getFeatureFlagOverride === 'function') {
            // Attempt to retrieve an override value for the feature gate
            var overrideValue = window.__CRITERION__.getFeatureFlagOverride(gateName);
            // If an override value is found, return it immediately
            if (overrideValue !== undefined) return overrideValue;
        }
    } catch (error) {
        // Log the first occurrence of the error
        if (!$07f57b3c4ab854a4$var$_FeatureGates.hasCheckGateErrorOccurred) {
            // eslint-disable-next-line no-console
            console.warn({
                msg: 'An error has occurred checking the feature gate from criterion override. Only the first occurrence of this error is logged.',
                gateName: gateName,
                error: error
            });
            $07f57b3c4ab854a4$var$_FeatureGates.hasCheckGateErrorOccurred = true;
        }
    }
    // Proceed with the main logic if no override is found
    return $07f57b3c4ab854a4$var$_FeatureGates.client.checkGate(gateName, options);
});
(0, $jgyhF.default)($07f57b3c4ab854a4$var$FeatureGates, "getExperimentValue", function(experimentName, parameterName, defaultValue, options) {
    try {
        // Check if the CRITERION override mechanism is available
        if (typeof window !== 'undefined' && window.__CRITERION__ && typeof window.__CRITERION__.getExperimentValueOverride === 'function') {
            var overrideValue = window.__CRITERION__.getExperimentValueOverride(experimentName, parameterName);
            if (overrideValue !== undefined && overrideValue !== null) return overrideValue;
        }
    } catch (error) {
        // Log the first occurrence of the error
        if (!$07f57b3c4ab854a4$var$_FeatureGates.hasGetExperimentValueErrorOccurred) {
            // eslint-disable-next-line no-console
            console.warn({
                msg: 'An error has occurred getting the experiment value from criterion override. Only the first occurrence of this error is logged.',
                experimentName: experimentName,
                defaultValue: defaultValue,
                options: options,
                error: error
            });
            $07f57b3c4ab854a4$var$_FeatureGates.hasGetExperimentValueErrorOccurred = true;
        }
        return defaultValue;
    }
    // Proceed with the main logic if no override is found
    return $07f57b3c4ab854a4$var$_FeatureGates.client.getExperimentValue(experimentName, parameterName, defaultValue, options);
});
(0, $jgyhF.default)($07f57b3c4ab854a4$var$FeatureGates, "initializeCalled", $07f57b3c4ab854a4$var$_FeatureGates.client.initializeCalled.bind($07f57b3c4ab854a4$var$_FeatureGates.client));
(0, $jgyhF.default)($07f57b3c4ab854a4$var$FeatureGates, "initializeCompleted", $07f57b3c4ab854a4$var$_FeatureGates.client.initializeCompleted.bind($07f57b3c4ab854a4$var$_FeatureGates.client));
(0, $jgyhF.default)($07f57b3c4ab854a4$var$FeatureGates, "waitUntilInitializeCompleted", $07f57b3c4ab854a4$var$_FeatureGates.client.waitUntilInitializeCompleted.bind($07f57b3c4ab854a4$var$_FeatureGates.client));
(0, $jgyhF.default)($07f57b3c4ab854a4$var$FeatureGates, "initialize", $07f57b3c4ab854a4$var$_FeatureGates.client.initialize.bind($07f57b3c4ab854a4$var$_FeatureGates.client));
(0, $jgyhF.default)($07f57b3c4ab854a4$var$FeatureGates, "initializeWithProvider", $07f57b3c4ab854a4$var$_FeatureGates.client.initializeWithProvider.bind($07f57b3c4ab854a4$var$_FeatureGates.client));
(0, $jgyhF.default)($07f57b3c4ab854a4$var$FeatureGates, "initializeFromValues", $07f57b3c4ab854a4$var$_FeatureGates.client.initializeFromValues.bind($07f57b3c4ab854a4$var$_FeatureGates.client));
(0, $jgyhF.default)($07f57b3c4ab854a4$var$FeatureGates, "manuallyLogGateExposure", $07f57b3c4ab854a4$var$_FeatureGates.client.manuallyLogGateExposure.bind($07f57b3c4ab854a4$var$_FeatureGates.client));
(0, $jgyhF.default)($07f57b3c4ab854a4$var$FeatureGates, "getExperiment", $07f57b3c4ab854a4$var$_FeatureGates.client.getExperiment.bind($07f57b3c4ab854a4$var$_FeatureGates.client));
(0, $jgyhF.default)($07f57b3c4ab854a4$var$FeatureGates, "manuallyLogExperimentExposure", $07f57b3c4ab854a4$var$_FeatureGates.client.manuallyLogExperimentExposure.bind($07f57b3c4ab854a4$var$_FeatureGates.client));
(0, $jgyhF.default)($07f57b3c4ab854a4$var$FeatureGates, "manuallyLogLayerExposure", $07f57b3c4ab854a4$var$_FeatureGates.client.manuallyLogLayerExposure.bind($07f57b3c4ab854a4$var$_FeatureGates.client));
(0, $jgyhF.default)($07f57b3c4ab854a4$var$FeatureGates, "shutdownStatsig", $07f57b3c4ab854a4$var$_FeatureGates.client.shutdownStatsig.bind($07f57b3c4ab854a4$var$_FeatureGates.client));
(0, $jgyhF.default)($07f57b3c4ab854a4$var$FeatureGates, "overrideGate", $07f57b3c4ab854a4$var$_FeatureGates.client.overrideGate.bind($07f57b3c4ab854a4$var$_FeatureGates.client));
(0, $jgyhF.default)($07f57b3c4ab854a4$var$FeatureGates, "clearGateOverride", $07f57b3c4ab854a4$var$_FeatureGates.client.clearGateOverride.bind($07f57b3c4ab854a4$var$_FeatureGates.client));
(0, $jgyhF.default)($07f57b3c4ab854a4$var$FeatureGates, "overrideConfig", $07f57b3c4ab854a4$var$_FeatureGates.client.overrideConfig.bind($07f57b3c4ab854a4$var$_FeatureGates.client));
(0, $jgyhF.default)($07f57b3c4ab854a4$var$FeatureGates, "clearConfigOverride", $07f57b3c4ab854a4$var$_FeatureGates.client.clearConfigOverride.bind($07f57b3c4ab854a4$var$_FeatureGates.client));
(0, $jgyhF.default)($07f57b3c4ab854a4$var$FeatureGates, "setOverrides", $07f57b3c4ab854a4$var$_FeatureGates.client.setOverrides.bind($07f57b3c4ab854a4$var$_FeatureGates.client));
(0, $jgyhF.default)($07f57b3c4ab854a4$var$FeatureGates, "getOverrides", $07f57b3c4ab854a4$var$_FeatureGates.client.getOverrides.bind($07f57b3c4ab854a4$var$_FeatureGates.client));
(0, $jgyhF.default)($07f57b3c4ab854a4$var$FeatureGates, "clearAllOverrides", $07f57b3c4ab854a4$var$_FeatureGates.client.clearAllOverrides.bind($07f57b3c4ab854a4$var$_FeatureGates.client));
(0, $jgyhF.default)($07f57b3c4ab854a4$var$FeatureGates, "isCurrentUser", $07f57b3c4ab854a4$var$_FeatureGates.client.isCurrentUser.bind($07f57b3c4ab854a4$var$_FeatureGates.client));
(0, $jgyhF.default)($07f57b3c4ab854a4$var$FeatureGates, "onGateUpdated", $07f57b3c4ab854a4$var$_FeatureGates.client.onGateUpdated.bind($07f57b3c4ab854a4$var$_FeatureGates.client));
(0, $jgyhF.default)($07f57b3c4ab854a4$var$FeatureGates, "onExperimentValueUpdated", $07f57b3c4ab854a4$var$_FeatureGates.client.onExperimentValueUpdated.bind($07f57b3c4ab854a4$var$_FeatureGates.client));
(0, $jgyhF.default)($07f57b3c4ab854a4$var$FeatureGates, "onAnyUpdated", $07f57b3c4ab854a4$var$_FeatureGates.client.onAnyUpdated.bind($07f57b3c4ab854a4$var$_FeatureGates.client));
(0, $jgyhF.default)($07f57b3c4ab854a4$var$FeatureGates, "updateUser", $07f57b3c4ab854a4$var$_FeatureGates.client.updateUser.bind($07f57b3c4ab854a4$var$_FeatureGates.client));
(0, $jgyhF.default)($07f57b3c4ab854a4$var$FeatureGates, "updateUserWithProvider", $07f57b3c4ab854a4$var$_FeatureGates.client.updateUserWithProvider.bind($07f57b3c4ab854a4$var$_FeatureGates.client));
(0, $jgyhF.default)($07f57b3c4ab854a4$var$FeatureGates, "updateUserWithValues", $07f57b3c4ab854a4$var$_FeatureGates.client.updateUserWithValues.bind($07f57b3c4ab854a4$var$_FeatureGates.client));
(0, $jgyhF.default)($07f57b3c4ab854a4$var$FeatureGates, "getPackageVersion", $07f57b3c4ab854a4$var$_FeatureGates.client.getPackageVersion.bind($07f57b3c4ab854a4$var$_FeatureGates.client));
(0, $jgyhF.default)($07f57b3c4ab854a4$var$FeatureGates, "getTargetApp", $07f57b3c4ab854a4$var$_FeatureGates.client.getTargetApp.bind($07f57b3c4ab854a4$var$_FeatureGates.client));
(0, $jgyhF.default)($07f57b3c4ab854a4$var$FeatureGates, "getLayer", $07f57b3c4ab854a4$var$_FeatureGates.client.getLayer.bind($07f57b3c4ab854a4$var$_FeatureGates.client));
(0, $jgyhF.default)($07f57b3c4ab854a4$var$FeatureGates, "getLayerValue", $07f57b3c4ab854a4$var$_FeatureGates.client.getLayerValue.bind($07f57b3c4ab854a4$var$_FeatureGates.client));
var $07f57b3c4ab854a4$var$boundFGJS = $07f57b3c4ab854a4$var$FeatureGates;
// This makes it possible to get a reference to the FeatureGates client at runtime.
// This is important for overriding values in Cypress tests, as there needs to be a
// way to get the exact instance for a window in order to mock some of its methods.
if (typeof window !== 'undefined') {
    if (window.__FEATUREGATES_JS__ === undefined) window.__FEATUREGATES_JS__ = $07f57b3c4ab854a4$var$FeatureGates;
    else {
        var $07f57b3c4ab854a4$var$_boundFGJS, $07f57b3c4ab854a4$var$_boundFGJS$getPackage;
        $07f57b3c4ab854a4$var$boundFGJS = window.__FEATUREGATES_JS__;
        var $07f57b3c4ab854a4$var$boundVersion = (($07f57b3c4ab854a4$var$_boundFGJS = $07f57b3c4ab854a4$var$boundFGJS) === null || $07f57b3c4ab854a4$var$_boundFGJS === void 0 || ($07f57b3c4ab854a4$var$_boundFGJS$getPackage = $07f57b3c4ab854a4$var$_boundFGJS.getPackageVersion) === null || $07f57b3c4ab854a4$var$_boundFGJS$getPackage === void 0 ? void 0 : $07f57b3c4ab854a4$var$_boundFGJS$getPackage.call($07f57b3c4ab854a4$var$_boundFGJS)) || '4.10.0 or earlier';
        if ($07f57b3c4ab854a4$var$boundVersion !== (0, $48bCT.CLIENT_VERSION)) {
            var $07f57b3c4ab854a4$var$message = "Multiple versions of FeatureGateClients found on the current page.\n      The currently bound version is ".concat($07f57b3c4ab854a4$var$boundVersion, " when module version ").concat((0, $48bCT.CLIENT_VERSION), " was loading.");
            // eslint-disable-next-line no-console
            console.warn($07f57b3c4ab854a4$var$message);
        }
    }
}
var /**
 * @property {FeatureGates} FeatureGate default export
 */ $07f57b3c4ab854a4$export$2e2bcd8739ae039 = $07f57b3c4ab854a4$var$boundFGJS;

});
parcelRegister("fGHg6", function(module, exports) {
$parcel$export(module.exports, "Client", () => $b6bc558d3c27d3f7$export$1f2bb630327ac4b6);

var $74jTZ = parcelRequire("74jTZ");

var $amAaq = parcelRequire("amAaq");

var $dZJgY = parcelRequire("dZJgY");

var $cdRUW = parcelRequire("cdRUW");

var $i1Bei = parcelRequire("i1Bei");

var $jgyhF = parcelRequire("jgyhF");

var $emmWV = parcelRequire("emmWV");

var $iFR7a = parcelRequire("iFR7a");

var $gkFNw = parcelRequire("gkFNw");

var $fgnFJ = parcelRequire("fgnFJ");

var $5sKD5 = parcelRequire("5sKD5");

var $5qsP4 = parcelRequire("5qsP4");

var $d737b = parcelRequire("d737b");

var $55zJS = parcelRequire("55zJS");

var $55ZQu = parcelRequire("55ZQu");

var $l52tI = parcelRequire("l52tI");

var $1BRXt = parcelRequire("1BRXt");

var $48bCT = parcelRequire("48bCT");
var $b6bc558d3c27d3f7$var$_excluded = [
    "sdkKey",
    "environment",
    "updateUserCompletionCallback",
    "perimeter"
];
function $b6bc558d3c27d3f7$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $b6bc558d3c27d3f7$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $b6bc558d3c27d3f7$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $jgyhF.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $b6bc558d3c27d3f7$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $b6bc558d3c27d3f7$var$DEFAULT_CLIENT_KEY = 'client-default-key';
// default event logging api is Atlassian proxy rather than Statsig's domain, to avoid ad blockers
var $b6bc558d3c27d3f7$var$DEFAULT_EVENT_LOGGING_API = 'https://xp.atlassian.com/v1/rgstr';
var $b6bc558d3c27d3f7$export$1f2bb630327ac4b6 = /*#__PURE__*/ function() {
    function Client() {
        var _this = this;
        var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, _ref$localStorageKey = _ref.localStorageKey, localStorageKey = _ref$localStorageKey === void 0 ? (0, $55ZQu.LOCAL_STORAGE_KEY) : _ref$localStorageKey, overrideAdapter = _ref.overrideAdapter;
        (0, $cdRUW.default)(this, Client);
        (0, $jgyhF.default)(this, "initPromise", null);
        /** True if an initialize method was called and completed successfully. */ (0, $jgyhF.default)(this, "initCompleted", false);
        /**
     * True if an initialize method was called and completed, meaning the client is now usable.
     * However if there was an error during initialization it may have initialized with default
     * values. Use {@link initCompleted} to check for this.
     */ (0, $jgyhF.default)(this, "initWithDefaults", false);
        (0, $jgyhF.default)(this, "hasCheckGateErrorOccurred", false);
        (0, $jgyhF.default)(this, "hasGetExperimentErrorOccurred", false);
        (0, $jgyhF.default)(this, "hasGetExperimentValueErrorOccurred", false);
        (0, $jgyhF.default)(this, "hasGetLayerErrorOccurred", false);
        (0, $jgyhF.default)(this, "hasGetLayerValueErrorOccurred", false);
        (0, $jgyhF.default)(this, "subscriptions", new (0, $gkFNw.default)());
        (0, $jgyhF.default)(this, "dataAdapter", new (0, $55zJS.NoFetchDataAdapter)());
        /**
     * Call this if modifying the values being served by the Statsig library since it has its own
     * memoization cache which will not be updated if the values are changed outside of the library.
     */ (0, $jgyhF.default)(this, "statsigValuesUpdated", function() {
            if (_this.user) // Trigger a reset of the memoize cache
            _this.statsigClient.updateUserSync(_this.user, {
                disableBackgroundCacheRefresh: true
            });
            _this.subscriptions.anyUpdated();
        });
        this.overrideAdapter = overrideAdapter || new (0, $55ZQu.PersistentOverrideAdapter)(localStorageKey);
    }
    /**
   * @description
   * This method initializes the client using a network call to fetch the bootstrap values.
   * If the client is inialized with an `analyticsWebClient`, it will send an operational event
   * to GASv3 with the following attributes:
   * - targetApp: the target app of the client
   * - clientVersion: the version of the client
   * - success: whether the initialization was successful
   * - startTime: the time when the initialization started
   * - totalTime: the total time it took to initialize the client
   * - apiKey: the api key used to initialize the client
   * @param clientOptions {ClientOptions}
   * @param identifiers {Identifiers}
   * @param customAttributes {CustomAttributes}
   * @returns {Promise<void>}
   */ return (0, $i1Bei.default)(Client, [
        {
            key: "initialize",
            value: function() {
                var _initialize = (0, $dZJgY.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($emmWV))).mark(function _callee(clientOptions, identifiers, customAttributes) {
                    var _this2 = this;
                    var clientOptionsWithDefaults, startTime;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($emmWV))).wrap(function(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                clientOptionsWithDefaults = (0, $1BRXt.getOptionsWithDefaults)(clientOptions);
                                if (!this.initPromise) {
                                    _context.next = 1;
                                    break;
                                }
                                if (!(0, $1BRXt.shallowEquals)(clientOptionsWithDefaults, this.initOptions)) // eslint-disable-next-line no-console
                                console.warn('Feature Gates client already initialized with different options. New options were not applied.');
                                return _context.abrupt("return", this.initPromise);
                            case 1:
                                startTime = performance.now();
                                this.initOptions = clientOptionsWithDefaults;
                                this.initPromise = this.init(clientOptionsWithDefaults, identifiers, customAttributes).then(function() {
                                    _this2.initCompleted = true;
                                    _this2.initWithDefaults = true;
                                }).finally(function() {
                                    var endTime = performance.now();
                                    var totalTime = endTime - startTime;
                                    _this2.fireClientEvent(startTime, totalTime, 'initialize', _this2.initCompleted, clientOptionsWithDefaults.apiKey);
                                });
                                return _context.abrupt("return", this.initPromise);
                            case 2:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee, this);
                }));
                function initialize(_x, _x2, _x3) {
                    return _initialize.apply(this, arguments);
                }
                return initialize;
            }()
        },
        {
            key: "initializeWithProvider",
            value: function() {
                var _initializeWithProvider = (0, $dZJgY.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($emmWV))).mark(function _callee2(clientOptions, provider, identifiers, customAttributes) {
                    var _this3 = this;
                    var clientOptionsWithDefaults, startTime;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($emmWV))).wrap(function(_context2) {
                        while(true)switch(_context2.prev = _context2.next){
                            case 0:
                                clientOptionsWithDefaults = (0, $1BRXt.getOptionsWithDefaults)(clientOptions);
                                if (!this.initPromise) {
                                    _context2.next = 1;
                                    break;
                                }
                                if (!(0, $1BRXt.shallowEquals)(clientOptionsWithDefaults, this.initOptions)) // eslint-disable-next-line no-console
                                console.warn('Feature Gates client already initialized with different options. New options were not applied.');
                                return _context2.abrupt("return", this.initPromise);
                            case 1:
                                startTime = performance.now();
                                this.initOptions = clientOptionsWithDefaults;
                                this.provider = provider;
                                this.provider.setClientVersion((0, $48bCT.CLIENT_VERSION));
                                if (this.provider.setApplyUpdateCallback) this.provider.setApplyUpdateCallback(this.applyUpdateCallback.bind(this));
                                this.initPromise = this.initWithProvider(clientOptionsWithDefaults, provider, identifiers, customAttributes).then(function() {
                                    _this3.initCompleted = true;
                                    _this3.initWithDefaults = true;
                                }).finally(function() {
                                    var endTime = performance.now();
                                    var totalTime = endTime - startTime;
                                    _this3.fireClientEvent(startTime, totalTime, 'initializeWithProvider', _this3.initCompleted, provider.getApiKey ? provider.getApiKey() : undefined);
                                });
                                return _context2.abrupt("return", this.initPromise);
                            case 2:
                            case "end":
                                return _context2.stop();
                        }
                    }, _callee2, this);
                }));
                function initializeWithProvider(_x4, _x5, _x6, _x7) {
                    return _initializeWithProvider.apply(this, arguments);
                }
                return initializeWithProvider;
            }()
        },
        {
            key: "applyUpdateCallback",
            value: function applyUpdateCallback(experimentsResult) {
                try {
                    if (this.initCompleted || this.initWithDefaults) {
                        this.assertInitialized(this.statsigClient);
                        this.dataAdapter.setBootstrapData(experimentsResult.experimentValues);
                        this.dataAdapter.setData(JSON.stringify(experimentsResult.experimentValues));
                        this.statsigValuesUpdated();
                    }
                } catch (error) {
                    // eslint-disable-next-line no-console
                    console.warn('Error when attempting to apply update', error);
                }
            }
        },
        {
            key: "fireClientEvent",
            value: function fireClientEvent(startTime, totalTime, action, success) {
                var _analyticsWebClient, _this4 = this;
                var apiKey = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;
                (_analyticsWebClient = this.initOptions.analyticsWebClient) === null || _analyticsWebClient === void 0 || _analyticsWebClient.then(function(analyticsWebClient) {
                    var attributes = $b6bc558d3c27d3f7$var$_objectSpread({
                        targetApp: _this4.initOptions.targetApp,
                        clientVersion: (0, $48bCT.CLIENT_VERSION),
                        success: success,
                        startTime: startTime,
                        totalTime: totalTime
                    }, apiKey && {
                        apiKey: apiKey
                    });
                    analyticsWebClient.sendOperationalEvent({
                        action: action,
                        actionSubject: 'featureGatesClient',
                        attributes: attributes,
                        tags: [
                            'measurement'
                        ],
                        source: '@atlaskit/feature-gate-js-client'
                    });
                }).catch(function(err) {
                    if (_this4.initOptions.environment !== (0, $l52tI.FeatureGateEnvironment).Production) // eslint-disable-next-line no-console
                    console.error('Analytics web client promise did not resolve', err);
                });
            }
        },
        {
            key: "initializeFromValues",
            value: function() {
                var _initializeFromValues = (0, $dZJgY.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($emmWV))).mark(function _callee3(clientOptions, identifiers, customAttributes) {
                    var _this5 = this;
                    var initializeValues, clientOptionsWithDefaults, startTime, _args3 = arguments;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($emmWV))).wrap(function(_context3) {
                        while(true)switch(_context3.prev = _context3.next){
                            case 0:
                                initializeValues = _args3.length > 3 && _args3[3] !== undefined ? _args3[3] : {};
                                clientOptionsWithDefaults = (0, $1BRXt.getOptionsWithDefaults)(clientOptions);
                                if (!this.initPromise) {
                                    _context3.next = 1;
                                    break;
                                }
                                if (!(0, $1BRXt.shallowEquals)(clientOptionsWithDefaults, this.initOptions)) // eslint-disable-next-line no-console
                                console.warn('Feature Gates client already initialized with different options. New options were not applied.');
                                return _context3.abrupt("return", this.initPromise);
                            case 1:
                                // This makes sure the new Statsig client behaves like the old when bootstrap data is
                                // passed, and `has_updates` isn't specified (which happens a lot in product integration tests).
                                if (!Object.prototype.hasOwnProperty.call(initializeValues, 'has_updates')) initializeValues['has_updates'] = true;
                                startTime = performance.now();
                                this.initOptions = clientOptionsWithDefaults;
                                this.initPromise = this.initFromValues(clientOptionsWithDefaults, identifiers, customAttributes, initializeValues).then(function() {
                                    _this5.initCompleted = true;
                                    _this5.initWithDefaults = true;
                                }).finally(function() {
                                    var endTime = performance.now();
                                    var totalTime = endTime - startTime;
                                    _this5.fireClientEvent(startTime, totalTime, 'initializeFromValues', _this5.initCompleted);
                                });
                                return _context3.abrupt("return", this.initPromise);
                            case 2:
                            case "end":
                                return _context3.stop();
                        }
                    }, _callee3, this);
                }));
                function initializeFromValues(_x8, _x9, _x0) {
                    return _initializeFromValues.apply(this, arguments);
                }
                return initializeFromValues;
            }()
        },
        {
            key: "assertInitialized",
            value: function assertInitialized(statsigClient) {
                if (!statsigClient) throw new Error('Client must be initialized before using this method');
            }
        },
        {
            key: "updateUser",
            value: function() {
                var _updateUser = (0, $dZJgY.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($emmWV))).mark(function _callee4(fetchOptions, identifiers, customAttributes) {
                    var fetchOptionsWithDefaults, initializeValuesProducer;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($emmWV))).wrap(function(_context4) {
                        while(true)switch(_context4.prev = _context4.next){
                            case 0:
                                this.assertInitialized(this.statsigClient);
                                fetchOptionsWithDefaults = (0, $1BRXt.getOptionsWithDefaults)(fetchOptions);
                                initializeValuesProducer = function initializeValuesProducer() {
                                    return (0, $d737b.default).fetchExperimentValues(fetchOptionsWithDefaults, identifiers, customAttributes).then(function(_ref2) {
                                        var experimentValues = _ref2.experimentValues, customAttributes = _ref2.customAttributes;
                                        return {
                                            experimentValues: experimentValues,
                                            customAttributesFromFetch: customAttributes
                                        };
                                    });
                                };
                                _context4.next = 1;
                                return this.updateUserUsingInitializeValuesProducer(initializeValuesProducer, identifiers, customAttributes);
                            case 1:
                            case "end":
                                return _context4.stop();
                        }
                    }, _callee4, this);
                }));
                function updateUser(_x1, _x10, _x11) {
                    return _updateUser.apply(this, arguments);
                }
                return updateUser;
            }()
        },
        {
            key: "updateUserWithProvider",
            value: function() {
                var _updateUserWithProvider = (0, $dZJgY.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($emmWV))).mark(function _callee5(identifiers, customAttributes) {
                    var _this6 = this;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($emmWV))).wrap(function(_context5) {
                        while(true)switch(_context5.prev = _context5.next){
                            case 0:
                                this.assertInitialized(this.statsigClient);
                                if (this.provider) {
                                    _context5.next = 1;
                                    break;
                                }
                                throw new Error('Cannot update user using provider as the client was not initialised with a provider');
                            case 1:
                                _context5.next = 2;
                                return this.provider.setProfile(this.initOptions, identifiers, customAttributes);
                            case 2:
                                _context5.next = 3;
                                return this.updateUserUsingInitializeValuesProducer(function() {
                                    return _this6.provider.getExperimentValues();
                                }, identifiers, customAttributes);
                            case 3:
                            case "end":
                                return _context5.stop();
                        }
                    }, _callee5, this);
                }));
                function updateUserWithProvider(_x12, _x13) {
                    return _updateUserWithProvider.apply(this, arguments);
                }
                return updateUserWithProvider;
            }()
        },
        {
            key: "updateUserWithValues",
            value: function() {
                var _updateUserWithValues = (0, $dZJgY.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($emmWV))).mark(function _callee6(identifiers, customAttributes) {
                    var initializeValues, initializeValuesProducer, _args6 = arguments;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($emmWV))).wrap(function(_context6) {
                        while(true)switch(_context6.prev = _context6.next){
                            case 0:
                                initializeValues = _args6.length > 2 && _args6[2] !== undefined ? _args6[2] : {};
                                this.assertInitialized(this.statsigClient);
                                initializeValuesProducer = function initializeValuesProducer() {
                                    return Promise.resolve({
                                        experimentValues: initializeValues,
                                        customAttributesFromFetch: customAttributes
                                    });
                                };
                                _context6.next = 1;
                                return this.updateUserUsingInitializeValuesProducer(initializeValuesProducer, identifiers, customAttributes);
                            case 1:
                            case "end":
                                return _context6.stop();
                        }
                    }, _callee6, this);
                }));
                function updateUserWithValues(_x14, _x15) {
                    return _updateUserWithValues.apply(this, arguments);
                }
                return updateUserWithValues;
            }()
        },
        {
            key: "initializeCalled",
            value: function initializeCalled() {
                return this.initPromise != null;
            }
        },
        {
            key: "initializeCompleted",
            value: function initializeCompleted() {
                return this.initCompleted;
            }
        },
        {
            key: "waitUntilInitializeCompleted",
            value: function() {
                var _waitUntilInitializeCompleted = (0, $dZJgY.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($emmWV))).mark(function _callee7() {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($emmWV))).wrap(function(_context7) {
                        while(true)switch(_context7.prev = _context7.next){
                            case 0:
                                if (this.initPromise) {
                                    _context7.next = 1;
                                    break;
                                }
                                throw new Error('The client must be initialized before you can wait until initialized.');
                            case 1:
                                if (!this.initCompleted) {
                                    _context7.next = 2;
                                    break;
                                }
                                return _context7.abrupt("return");
                            case 2:
                                _context7.next = 3;
                                return this.initPromise;
                            case 3:
                            case "end":
                                return _context7.stop();
                        }
                    }, _callee7, this);
                }));
                function waitUntilInitializeCompleted() {
                    return _waitUntilInitializeCompleted.apply(this, arguments);
                }
                return waitUntilInitializeCompleted;
            }()
        },
        {
            key: "checkGate",
            value: function checkGate(gateName) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                try {
                    this.assertInitialized(this.statsigClient);
                    var _options$fireGateExpo = options.fireGateExposure, fireGateExposure = _options$fireGateExpo === void 0 ? true : _options$fireGateExpo;
                    return this.statsigClient.checkGate(gateName, {
                        disableExposureLog: !fireGateExposure
                    });
                } catch (error) {
                    // Log the first occurrence of the error
                    if (!this.hasCheckGateErrorOccurred) {
                        // eslint-disable-next-line no-console
                        console.warn({
                            msg: 'An error has occurred checking the feature gate. Only the first occurrence of this error is logged.',
                            gateName: gateName,
                            error: error
                        });
                        this.hasCheckGateErrorOccurred = true;
                    }
                    return false;
                }
            }
        },
        {
            key: "isGateExist",
            value: function isGateExist(gateName) {
                try {
                    this.assertInitialized(this.statsigClient);
                    var gate = this.statsigClient.getFeatureGate(gateName, {
                        disableExposureLog: true
                    });
                    return !gate.details.reason.includes('Unrecognized');
                } catch (error) {
                    // eslint-disable-next-line no-console
                    console.error("Error occurred when trying to check FeatureGate: ".concat(error));
                    // in case of error report true to avoid false positives.
                    return true;
                }
            }
        },
        {
            key: "isExperimentExist",
            value: function isExperimentExist(experimentName) {
                try {
                    this.assertInitialized(this.statsigClient);
                    var config = this.statsigClient.getExperiment(experimentName, {
                        disableExposureLog: true
                    });
                    return !config.details.reason.includes('Unrecognized');
                } catch (error) {
                    // eslint-disable-next-line no-console
                    console.error("Error occurred when trying to check Experiment: ".concat(error));
                    // in case of error report true to avoid false positives.
                    return true;
                }
            }
        },
        {
            key: "manuallyLogGateExposure",
            value: function manuallyLogGateExposure(gateName) {
                this.assertInitialized(this.statsigClient);
                // This is the approach recommended in the docs
                // https://docs.statsig.com/client/javascript-sdk/#manual-exposures-
                this.statsigClient.checkGate(gateName);
            }
        },
        {
            key: "getExperiment",
            value: function getExperiment(experimentName) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                try {
                    this.assertInitialized(this.statsigClient);
                    var _options$fireExperime = options.fireExperimentExposure, fireExperimentExposure = _options$fireExperime === void 0 ? true : _options$fireExperime;
                    return (0, $fgnFJ.DynamicConfig).fromExperiment(this.statsigClient.getExperiment(experimentName, {
                        disableExposureLog: !fireExperimentExposure
                    }));
                } catch (error) {
                    // Log the first occurrence of the error
                    if (!this.hasGetExperimentErrorOccurred) {
                        // eslint-disable-next-line no-console
                        console.warn({
                            msg: 'An error has occurred getting the experiment. Only the first occurrence of this error is logged.',
                            experimentName: experimentName,
                            error: error
                        });
                        this.hasGetExperimentErrorOccurred = true;
                    }
                    // Return a default value
                    return new (0, $fgnFJ.DynamicConfig)(experimentName, {}, '', {
                        time: Date.now(),
                        reason: (0, $5qsP4.EvaluationReason).Error
                    });
                }
            }
        },
        {
            key: "getExperimentValue",
            value: function getExperimentValue(experimentName, parameterName, defaultValue) {
                var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var experiment = this.getExperiment(experimentName, options);
                try {
                    var typeGuard = options.typeGuard;
                    return experiment.get(parameterName, defaultValue, typeGuard);
                } catch (error) {
                    // Log the first occurrence of the error
                    if (!this.hasGetExperimentValueErrorOccurred) {
                        // eslint-disable-next-line no-console
                        console.warn({
                            msg: 'An error has occurred getting the experiment value. Only the first occurrence of this error is logged.',
                            experimentName: experimentName,
                            defaultValue: defaultValue,
                            options: options,
                            error: error
                        });
                        this.hasGetExperimentValueErrorOccurred = true;
                    }
                    return defaultValue;
                }
            }
        },
        {
            key: "manuallyLogExperimentExposure",
            value: function manuallyLogExperimentExposure(experimentName) {
                this.assertInitialized(this.statsigClient);
                // This is the approach recommended in the docs
                // https://docs.statsig.com/client/javascript-sdk/#manual-exposures-
                this.statsigClient.getExperiment(experimentName);
            }
        },
        {
            key: "manuallyLogLayerExposure",
            value: function manuallyLogLayerExposure(layerName, parameterName) {
                var _this$statsigClient$g;
                this.assertInitialized(this.statsigClient);
                // This is the approach recommended in the docs
                // https://docs.statsig.com/client/javascript-sdk/#manual-exposures-
                (_this$statsigClient$g = this.statsigClient.getLayer(layerName)) === null || _this$statsigClient$g === void 0 || _this$statsigClient$g.get(parameterName);
            }
        },
        {
            key: "shutdownStatsig",
            value: function shutdownStatsig() {
                this.assertInitialized(this.statsigClient);
                this.statsigClient.shutdown();
            }
        },
        {
            key: "overrideGate",
            value: function overrideGate(gateName, value) {
                this.overrideAdapter.overrideGate(gateName, value);
                // Trigger a reset of the memoized gate value
                if (this.user) {
                    var _this$statsigClient;
                    (_this$statsigClient = this.statsigClient) === null || _this$statsigClient === void 0 || _this$statsigClient.updateUserSync(this.user, {
                        disableBackgroundCacheRefresh: true
                    });
                }
                this.statsigValuesUpdated();
            }
        },
        {
            key: "clearGateOverride",
            value: function clearGateOverride(gateName) {
                this.overrideAdapter.removeGateOverride(gateName);
                this.statsigValuesUpdated();
            }
        },
        {
            key: "overrideConfig",
            value: function overrideConfig(experimentName, values) {
                this.overrideAdapter.overrideDynamicConfig(experimentName, values);
                this.statsigValuesUpdated();
            }
        },
        {
            key: "clearConfigOverride",
            value: function clearConfigOverride(experimentName) {
                this.overrideAdapter.removeDynamicConfigOverride(experimentName);
                this.statsigValuesUpdated();
            }
        },
        {
            key: "setOverrides",
            value: function setOverrides(overrides) {
                this.overrideAdapter.setOverrides(overrides);
                this.statsigValuesUpdated();
            }
        },
        {
            key: "getOverrides",
            value: function getOverrides() {
                return this.overrideAdapter.getOverrides();
            }
        },
        {
            key: "clearAllOverrides",
            value: function clearAllOverrides() {
                this.overrideAdapter.removeAllOverrides();
                this.statsigValuesUpdated();
            }
        },
        {
            key: "isCurrentUser",
            value: function isCurrentUser(identifiers, customAttributes) {
                return (0, $1BRXt.shallowEquals)(this.currentIdentifiers, identifiers) && (0, $1BRXt.shallowEquals)(this.currentAttributes, customAttributes);
            }
        },
        {
            key: "onGateUpdated",
            value: function onGateUpdated(gateName, callback) {
                var _this7 = this;
                var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                var wrapCallback = function wrapCallback(value) {
                    var _options$fireGateExpo2 = options.fireGateExposure, fireGateExposure = _options$fireGateExpo2 === void 0 ? true : _options$fireGateExpo2;
                    if (fireGateExposure) _this7.manuallyLogGateExposure(gateName);
                    try {
                        callback(value);
                    } catch (error) {
                        // eslint-disable-next-line no-console
                        console.warn("Error calling callback for gate ".concat(gateName, " with value ").concat(value), error);
                    }
                };
                return this.subscriptions.onGateUpdated(gateName, wrapCallback, this.checkGate.bind(this), options);
            }
        },
        {
            key: "onExperimentValueUpdated",
            value: function onExperimentValueUpdated(experimentName, parameterName, defaultValue, callback) {
                var _this8 = this;
                var options = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
                var wrapCallback = function wrapCallback(value) {
                    var _options$fireExperime2 = options.fireExperimentExposure, fireExperimentExposure = _options$fireExperime2 === void 0 ? true : _options$fireExperime2;
                    if (fireExperimentExposure) _this8.manuallyLogExperimentExposure(experimentName);
                    try {
                        callback(value);
                    } catch (error) {
                        // eslint-disable-next-line no-console
                        console.warn("Error calling callback for experiment ".concat(experimentName, " with value ").concat(value), error);
                    }
                };
                return this.subscriptions.onExperimentValueUpdated(experimentName, parameterName, defaultValue, wrapCallback, this.getExperimentValue.bind(this), options);
            }
        },
        {
            key: "onAnyUpdated",
            value: function onAnyUpdated(callback) {
                return this.subscriptions.onAnyUpdated(callback);
            }
        },
        {
            key: "init",
            value: function() {
                var _init = (0, $dZJgY.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($emmWV))).mark(function _callee8(clientOptions, identifiers, customAttributes) {
                    var fromValuesClientOptions, experimentValues, customAttributesFromResult, clientSdkKeyPromise, experimentValuesPromise, _yield$Promise$all, _yield$Promise$all2, experimentValuesResult, _t;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($emmWV))).wrap(function(_context8) {
                        while(true)switch(_context8.prev = _context8.next){
                            case 0:
                                fromValuesClientOptions = $b6bc558d3c27d3f7$var$_objectSpread({}, clientOptions);
                                if (!clientOptions.localMode) {
                                    _context8.next = 2;
                                    break;
                                }
                                _context8.next = 1;
                                return this.initFromValues(fromValuesClientOptions, identifiers, customAttributes);
                            case 1:
                                return _context8.abrupt("return");
                            case 2:
                                _context8.prev = 2;
                                // If client sdk key fetch fails, an error would be thrown and handled instead of waiting for
                                // the experiment values request to be settled, and it will fall back to use default values.
                                clientSdkKeyPromise = (0, $d737b.default).fetchClientSdk(clientOptions).then(function(value) {
                                    return fromValuesClientOptions.sdkKey = value.clientSdkKey;
                                });
                                experimentValuesPromise = (0, $d737b.default).fetchExperimentValues(clientOptions, identifiers, customAttributes); // Only wait for the experiment values request to finish and try to initialise the client
                                // with experiment values if both requests are successful. Else an error would be thrown and
                                // handled by the catch
                                _context8.next = 3;
                                return Promise.all([
                                    clientSdkKeyPromise,
                                    experimentValuesPromise
                                ]);
                            case 3:
                                _yield$Promise$all = _context8.sent;
                                _yield$Promise$all2 = (0, $amAaq.default)(_yield$Promise$all, 2);
                                experimentValuesResult = _yield$Promise$all2[1];
                                experimentValues = experimentValuesResult.experimentValues;
                                customAttributesFromResult = experimentValuesResult.customAttributes;
                                _context8.next = 6;
                                break;
                            case 4:
                                _context8.prev = 4;
                                _t = _context8["catch"](2);
                                if (_t instanceof Error) // eslint-disable-next-line no-console
                                console.error("Error occurred when trying to fetch the Feature Gates client values, error: ".concat(_t === null || _t === void 0 ? void 0 : _t.message));
                                // eslint-disable-next-line no-console
                                console.warn("Initialising Statsig client without values");
                                _context8.next = 5;
                                return this.initFromValues(fromValuesClientOptions, identifiers, customAttributes);
                            case 5:
                                throw _t;
                            case 6:
                                return _context8.abrupt("return", this.initFromValues(fromValuesClientOptions, identifiers, customAttributesFromResult, experimentValues));
                            case 7:
                            case "end":
                                return _context8.stop();
                        }
                    }, _callee8, this, [
                        [
                            2,
                            4
                        ]
                    ]);
                }));
                function init(_x16, _x17, _x18) {
                    return _init.apply(this, arguments);
                }
                return init;
            }()
        },
        {
            key: "initWithProvider",
            value: function() {
                var _initWithProvider = (0, $dZJgY.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($emmWV))).mark(function _callee9(baseClientOptions, provider, identifiers, customAttributes) {
                    var fromValuesClientOptions, experimentValues, customAttributesFromResult, clientSdkKeyPromise, experimentValuesPromise, _yield$Promise$all3, _yield$Promise$all4, experimentValuesResult, _t2;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($emmWV))).wrap(function(_context9) {
                        while(true)switch(_context9.prev = _context9.next){
                            case 0:
                                fromValuesClientOptions = $b6bc558d3c27d3f7$var$_objectSpread($b6bc558d3c27d3f7$var$_objectSpread({}, baseClientOptions), {}, {
                                    disableCurrentPageLogging: true
                                });
                                _context9.prev = 1;
                                _context9.next = 2;
                                return provider.setProfile(baseClientOptions, identifiers, customAttributes);
                            case 2:
                                // If client sdk key fetch fails, an error would be thrown and handled instead of waiting for
                                // the experiment values request to be settled, and it will fall back to use default values.
                                clientSdkKeyPromise = provider.getClientSdkKey().then(function(value) {
                                    return fromValuesClientOptions.sdkKey = value;
                                });
                                experimentValuesPromise = provider.getExperimentValues(); // Only wait for the experiment values request to finish and try to initialise the client
                                // with experiment values if both requests are successful. Else an error would be thrown and
                                // handled by the catch
                                _context9.next = 3;
                                return Promise.all([
                                    clientSdkKeyPromise,
                                    experimentValuesPromise
                                ]);
                            case 3:
                                _yield$Promise$all3 = _context9.sent;
                                _yield$Promise$all4 = (0, $amAaq.default)(_yield$Promise$all3, 2);
                                experimentValuesResult = _yield$Promise$all4[1];
                                experimentValues = experimentValuesResult.experimentValues;
                                customAttributesFromResult = experimentValuesResult.customAttributesFromFetch;
                                _context9.next = 6;
                                break;
                            case 4:
                                _context9.prev = 4;
                                _t2 = _context9["catch"](1);
                                if (_t2 instanceof Error) // eslint-disable-next-line no-console
                                console.error("Error occurred when trying to fetch the Feature Gates client values, error: ".concat(_t2 === null || _t2 === void 0 ? void 0 : _t2.message));
                                // eslint-disable-next-line no-console
                                console.warn("Initialising Statsig client without values");
                                _context9.next = 5;
                                return this.initFromValues(fromValuesClientOptions, identifiers, customAttributes);
                            case 5:
                                throw _t2;
                            case 6:
                                return _context9.abrupt("return", this.initFromValues(fromValuesClientOptions, identifiers, customAttributesFromResult, experimentValues));
                            case 7:
                            case "end":
                                return _context9.stop();
                        }
                    }, _callee9, this, [
                        [
                            1,
                            4
                        ]
                    ]);
                }));
                function initWithProvider(_x19, _x20, _x21, _x22) {
                    return _initWithProvider.apply(this, arguments);
                }
                return initWithProvider;
            }()
        },
        {
            key: "initFromValues",
            value: function() {
                var _initFromValues = (0, $dZJgY.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($emmWV))).mark(function _callee0(clientOptions, identifiers, customAttributes) {
                    var _newClientOptions$net;
                    var initializeValues, newClientOptions, sdkKey, environment, _updateUserCompletionCallback, _perimeter, restClientOptions, frontendUser, statsigOptions, _args0 = arguments, _t3;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($emmWV))).wrap(function(_context0) {
                        while(true)switch(_context0.prev = _context0.next){
                            case 0:
                                initializeValues = _args0.length > 3 && _args0[3] !== undefined ? _args0[3] : {};
                                this.overrideAdapter.initFromStoredOverrides();
                                this.currentIdentifiers = identifiers;
                                this.currentAttributes = customAttributes;
                                newClientOptions = (0, $1BRXt.migrateInitializationOptions)(clientOptions);
                                if (!newClientOptions.sdkKey) newClientOptions.sdkKey = $b6bc558d3c27d3f7$var$DEFAULT_CLIENT_KEY;
                                if (!((_newClientOptions$net = newClientOptions.networkConfig) !== null && _newClientOptions$net !== void 0 && _newClientOptions$net.logEventUrl)) newClientOptions.networkConfig = $b6bc558d3c27d3f7$var$_objectSpread($b6bc558d3c27d3f7$var$_objectSpread({}, newClientOptions.networkConfig), {}, {
                                    logEventUrl: $b6bc558d3c27d3f7$var$DEFAULT_EVENT_LOGGING_API
                                });
                                if (newClientOptions.perimeter === (0, $l52tI.PerimeterType).FEDRAMP_MODERATE) // disable all logging in FedRAMP to prevent egress of sensitive data
                                newClientOptions.disableLogging = true;
                                sdkKey = newClientOptions.sdkKey, environment = newClientOptions.environment, _updateUserCompletionCallback = newClientOptions.updateUserCompletionCallback, _perimeter = newClientOptions.perimeter, restClientOptions = (0, $74jTZ.default)(newClientOptions, $b6bc558d3c27d3f7$var$_excluded);
                                frontendUser = (0, $1BRXt.toStatsigUser)(identifiers, customAttributes);
                                this.user = (0, $1BRXt.deepAssign)({}, initializeValues.user, frontendUser);
                                statsigOptions = $b6bc558d3c27d3f7$var$_objectSpread($b6bc558d3c27d3f7$var$_objectSpread({}, restClientOptions), {}, {
                                    environment: {
                                        tier: environment
                                    },
                                    includeCurrentPageUrlWithEvents: false,
                                    dataAdapter: this.dataAdapter,
                                    overrideAdapter: this.overrideAdapter,
                                    logEventCompressionMode: (0, $iFR7a.LogEventCompressionMode).Forced
                                }); // Statsig validates the provided stableId against their own cookie, so we either need
                                // to update the cookie to match, or disable the validation completely.
                                if (identifiers.stableId) (0, $iFR7a.StableID).setOverride(identifiers.stableId, sdkKey);
                                else statsigOptions.disableStableID = true;
                                _context0.prev = 1;
                                this.statsigClient = new (0, $iFR7a.StatsigClient)(sdkKey, this.user, statsigOptions);
                                this.dataAdapter.setBootstrapData(initializeValues);
                                _context0.next = 2;
                                return this.statsigClient.initializeAsync();
                            case 2:
                                _context0.next = 5;
                                break;
                            case 3:
                                _context0.prev = 3;
                                _t3 = _context0["catch"](1);
                                if (_t3 instanceof Error) // eslint-disable-next-line no-console
                                console.error("Error occurred when trying to initialise the Statsig client, error: ".concat(_t3 === null || _t3 === void 0 ? void 0 : _t3.message));
                                // eslint-disable-next-line no-console
                                console.warn("Initialising Statsig client with default sdk key and without values");
                                this.statsigClient = new (0, $iFR7a.StatsigClient)($b6bc558d3c27d3f7$var$DEFAULT_CLIENT_KEY, this.user, statsigOptions);
                                this.dataAdapter.setBootstrapData();
                                _context0.next = 4;
                                return this.statsigClient.initializeAsync();
                            case 4:
                                this.initWithDefaults = true;
                                throw _t3;
                            case 5:
                            case "end":
                                return _context0.stop();
                        }
                    }, _callee0, this, [
                        [
                            1,
                            3
                        ]
                    ]);
                }));
                function initFromValues(_x23, _x24, _x25) {
                    return _initFromValues.apply(this, arguments);
                }
                return initFromValues;
            }()
        },
        {
            key: "updateUserUsingInitializeValuesProducer",
            value: function() {
                var _updateUserUsingInitializeValuesProducer = (0, $dZJgY.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($emmWV))).mark(function _callee10(getInitializeValues, identifiers, customAttributes) {
                    var _this9 = this;
                    var originalInitPromise, initializeValuesPromise, updateUserPromise, _t4;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($emmWV))).wrap(function(_context10) {
                        while(true)switch(_context10.prev = _context10.next){
                            case 0:
                                this.assertInitialized(this.statsigClient);
                                if (this.initPromise) {
                                    _context10.next = 1;
                                    break;
                                }
                                throw new Error('The client must be initialized before you can update the user.');
                            case 1:
                                if (!this.isCurrentUser(identifiers, customAttributes)) {
                                    _context10.next = 2;
                                    break;
                                }
                                return _context10.abrupt("return", this.initPromise);
                            case 2:
                                // Wait for the current initialize/update to finish
                                originalInitPromise = this.initPromise;
                                _context10.prev = 3;
                                _context10.next = 4;
                                return this.initPromise;
                            case 4:
                                _context10.next = 6;
                                break;
                            case 5:
                                _context10.prev = 5;
                                _t4 = _context10["catch"](3);
                            case 6:
                                initializeValuesPromise = getInitializeValues();
                                updateUserPromise = this.updateStatsigClientUser(initializeValuesPromise, identifiers, customAttributes); // We replace the init promise here since we are essentially re-initializing the client at this
                                // point. Any subsequent calls to await client.initialize() or client.updateUser()
                                // will now also await this user update.
                                this.initPromise = updateUserPromise.catch(/*#__PURE__*/ (0, $dZJgY.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($emmWV))).mark(function _callee1() {
                                    return (0, (/*@__PURE__*/$parcel$interopDefault($emmWV))).wrap(function(_context1) {
                                        while(true)switch(_context1.prev = _context1.next){
                                            case 0:
                                                // If the update failed then it changed nothing, so revert back to the original promise.
                                                _this9.initPromise = originalInitPromise;
                                                // Set the user profile again to revert back to the current user
                                                if (!_this9.provider) {
                                                    _context1.next = 1;
                                                    break;
                                                }
                                                _context1.next = 1;
                                                return _this9.provider.setProfile(_this9.initOptions, _this9.currentIdentifiers, _this9.currentAttributes);
                                            case 1:
                                            case "end":
                                                return _context1.stop();
                                        }
                                    }, _callee1);
                                })));
                                return _context10.abrupt("return", updateUserPromise);
                            case 7:
                            case "end":
                                return _context10.stop();
                        }
                    }, _callee10, this, [
                        [
                            3,
                            5
                        ]
                    ]);
                }));
                function updateUserUsingInitializeValuesProducer(_x26, _x27, _x28) {
                    return _updateUserUsingInitializeValuesProducer.apply(this, arguments);
                }
                return updateUserUsingInitializeValuesProducer;
            }()
        },
        {
            key: "updateStatsigClientUser",
            value: function() {
                var _updateStatsigClientUser = (0, $dZJgY.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($emmWV))).mark(function _callee11(initializeValuesPromise, identifiers, customAttributes) {
                    var _this$initOptions, _this$initOptions$upd;
                    var initializeValues, user, frontendUser, _updateUserCompletion, _ref4, errMsg, success, errorMessage, _t5, _t6;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($emmWV))).wrap(function(_context11) {
                        while(true)switch(_context11.prev = _context11.next){
                            case 0:
                                this.assertInitialized(this.statsigClient);
                                _context11.prev = 1;
                                _context11.next = 2;
                                return initializeValuesPromise;
                            case 2:
                                initializeValues = _context11.sent;
                                frontendUser = (0, $1BRXt.toStatsigUser)(identifiers, initializeValues.customAttributesFromFetch);
                                user = (0, $1BRXt.deepAssign)({}, initializeValues.experimentValues.user, frontendUser);
                                _context11.next = 4;
                                break;
                            case 3:
                                _context11.prev = 3;
                                _t5 = _context11["catch"](1);
                                // Make sure the updateUserCompletionCallback is called for any errors in our custom code.
                                // This is not necessary for the updateUserWithValues call, because the Statsig client will
                                // already invoke the callback itself.
                                errMsg = _t5 instanceof Error ? _t5.message : JSON.stringify(_t5);
                                (_updateUserCompletion = (_ref4 = this.initOptions).updateUserCompletionCallback) === null || _updateUserCompletion === void 0 || _updateUserCompletion.call(_ref4, false, errMsg);
                                throw _t5;
                            case 4:
                                success = true;
                                errorMessage = null;
                                _context11.prev = 5;
                                this.dataAdapter.setBootstrapData(initializeValues.experimentValues);
                                this.user = user;
                                if (!this.user) {
                                    _context11.next = 6;
                                    break;
                                }
                                _context11.next = 6;
                                return this.statsigClient.updateUserAsync(this.user);
                            case 6:
                                _context11.next = 8;
                                break;
                            case 7:
                                _context11.prev = 7;
                                _t6 = _context11["catch"](5);
                                success = false;
                                errorMessage = String(_t6);
                            case 8:
                                (_this$initOptions = this.initOptions) === null || _this$initOptions === void 0 || (_this$initOptions$upd = _this$initOptions.updateUserCompletionCallback) === null || _this$initOptions$upd === void 0 || _this$initOptions$upd.call(_this$initOptions, success, errorMessage);
                                if (!success) {
                                    _context11.next = 9;
                                    break;
                                }
                                this.currentIdentifiers = identifiers;
                                this.currentAttributes = customAttributes;
                                this.subscriptions.anyUpdated();
                                _context11.next = 10;
                                break;
                            case 9:
                                throw new Error('Failed to update user. An unexpected error occured.');
                            case 10:
                            case "end":
                                return _context11.stop();
                        }
                    }, _callee11, this, [
                        [
                            1,
                            3
                        ],
                        [
                            5,
                            7
                        ]
                    ]);
                }));
                function updateStatsigClientUser(_x29, _x30, _x31) {
                    return _updateStatsigClientUser.apply(this, arguments);
                }
                return updateStatsigClientUser;
            }()
        },
        {
            key: "getPackageVersion",
            value: /**
     * @returns string version of the current package in semver style.
     */ function getPackageVersion() {
                return 0, $48bCT.CLIENT_VERSION;
            }
        },
        {
            key: "getTargetApp",
            value: function getTargetApp() {
                var _this$initOptions2;
                return (_this$initOptions2 = this.initOptions) === null || _this$initOptions2 === void 0 ? void 0 : _this$initOptions2.targetApp;
            }
        },
        {
            key: "getLayer",
            value: function getLayer(/** The name of the layer */ layerName) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                try {
                    this.assertInitialized(this.statsigClient);
                    var _options$fireLayerExp = options.fireLayerExposure, fireLayerExposure = _options$fireLayerExp === void 0 ? true : _options$fireLayerExp;
                    return (0, $5sKD5.Layer).fromLayer(this.statsigClient.getLayer(layerName, {
                        disableExposureLog: !fireLayerExposure
                    }));
                } catch (error) {
                    // Log the first occurrence of the error
                    if (!this.hasGetLayerErrorOccurred) {
                        // eslint-disable-next-line no-console
                        console.warn({
                            msg: 'An error has occurred getting the layer. Only the first occurrence of this error is logged.',
                            layerName: layerName,
                            error: error
                        });
                        this.hasGetLayerErrorOccurred = true;
                    }
                    // Return a default value
                    return (0, $5sKD5.Layer).fromLayer((0, $iFR7a._makeLayer)(layerName, {
                        reason: 'Error'
                    }, null));
                }
            }
        },
        {
            key: "getLayerValue",
            value: function getLayerValue(layerName, parameterName, defaultValue) {
                var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var layer = this.getLayer(layerName, options);
                try {
                    var typeGuard = options.typeGuard;
                    return layer.get(parameterName, defaultValue, typeGuard);
                } catch (error) {
                    // Log the first occurrence of the error
                    if (!this.hasGetLayerValueErrorOccurred) {
                        // eslint-disable-next-line no-console
                        console.warn({
                            msg: 'An error has occurred getting the layer value. Only the first occurrence of this error is logged.',
                            layerName: layerName,
                            defaultValue: defaultValue,
                            options: options,
                            error: error
                        });
                        this.hasGetLayerValueErrorOccurred = true;
                    }
                    return defaultValue;
                }
            }
        }
    ]);
}();

});
parcelRegister("74jTZ", function(module, exports) {
$parcel$export(module.exports, "default", () => $0154016c70fb6ce9$export$2e2bcd8739ae039);

var $liQ4N = parcelRequire("liQ4N");
function $0154016c70fb6ce9$export$2e2bcd8739ae039(e, t) {
    if (null == e) return {};
    var o, r, i = (0, $liQ4N.default)(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}

});
parcelRegister("liQ4N", function(module, exports) {
$parcel$export(module.exports, "default", () => $f823acb43593a18d$export$2e2bcd8739ae039);
function $f823acb43593a18d$export$2e2bcd8739ae039(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}

});


parcelRegister("dZJgY", function(module, exports) {
$parcel$export(module.exports, "default", () => $a304171bdfcdbb35$export$2e2bcd8739ae039);
function $a304171bdfcdbb35$var$asyncGeneratorStep(n, t, e, r, o, a, c) {
    try {
        var i = n[a](c), u = i.value;
    } catch (n) {
        return void e(n);
    }
    i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function $a304171bdfcdbb35$export$2e2bcd8739ae039(n) {
    return function() {
        var t = this, e = arguments;
        return new Promise(function(r, o) {
            var a = n.apply(t, e);
            function _next(n) {
                $a304171bdfcdbb35$var$asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
            }
            function _throw(n) {
                $a304171bdfcdbb35$var$asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
            }
            _next(void 0);
        });
    };
}

});

parcelRegister("emmWV", function(module, exports) {
// TODO(Babel 8): Remove this file.

var $a744ec0c3fe7f42c$var$runtime = (parcelRequire("3cecY"))();
module.exports = $a744ec0c3fe7f42c$var$runtime;
// Copied from https://github.com/facebook/regenerator/blob/main/packages/runtime/runtime.js#L736=
try {
    regeneratorRuntime = $a744ec0c3fe7f42c$var$runtime;
} catch (accidentalStrictMode) {
    if (typeof globalThis === "object") globalThis.regeneratorRuntime = $a744ec0c3fe7f42c$var$runtime;
    else Function("r", "regeneratorRuntime = r")($a744ec0c3fe7f42c$var$runtime);
}

});

parcelRegister("gkFNw", function(module, exports) {
$parcel$export(module.exports, "default", () => $be3eefbbfcdaf0f2$export$2e2bcd8739ae039);

var $cdRUW = parcelRequire("cdRUW");

var $i1Bei = parcelRequire("i1Bei");

var $jgyhF = parcelRequire("jgyhF");

var $hLfKH = parcelRequire("hLfKH");
function $be3eefbbfcdaf0f2$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $be3eefbbfcdaf0f2$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $be3eefbbfcdaf0f2$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $jgyhF.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $be3eefbbfcdaf0f2$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $be3eefbbfcdaf0f2$export$a66cbd9b2289cd78 = '@all-features';
var $be3eefbbfcdaf0f2$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function Subscriptions() {
        (0, $cdRUW.default)(this, Subscriptions);
        (0, $jgyhF.default)(this, "eventToValue", new Map());
        this.emitter = new (0, (/*@__PURE__*/$parcel$interopDefault($hLfKH)))();
    }
    return (0, $i1Bei.default)(Subscriptions, [
        {
            key: "onGateUpdated",
            value: function onGateUpdated(gateName, callback, checkGate, options) {
                var _this = this;
                var value = checkGate(gateName, $be3eefbbfcdaf0f2$var$_objectSpread($be3eefbbfcdaf0f2$var$_objectSpread({}, options), {}, {
                    fireGateExposure: false
                }));
                if (this.eventToValue.get(callback) === undefined) this.eventToValue.set(callback, value);
                var wrapCallback = function wrapCallback() {
                    var value = checkGate(gateName, $be3eefbbfcdaf0f2$var$_objectSpread($be3eefbbfcdaf0f2$var$_objectSpread({}, options), {}, {
                        fireGateExposure: false
                    }));
                    var existingValue = _this.eventToValue.get(callback);
                    if (existingValue !== value) {
                        _this.eventToValue.set(callback, value);
                        callback(value);
                    }
                };
                this.emitter.on(gateName, wrapCallback);
                return function() {
                    _this.emitter.off(gateName, wrapCallback);
                };
            }
        },
        {
            key: "onExperimentValueUpdated",
            value: function onExperimentValueUpdated(experimentName, parameterName, defaultValue, callback, getExperimentValue, options) {
                var _this2 = this;
                var experimentEventName = "".concat(experimentName, ".").concat(parameterName);
                var value = getExperimentValue(experimentName, parameterName, defaultValue, $be3eefbbfcdaf0f2$var$_objectSpread($be3eefbbfcdaf0f2$var$_objectSpread({}, options), {}, {
                    fireExperimentExposure: false
                }));
                if (this.eventToValue.get(callback) === undefined) this.eventToValue.set(callback, value);
                var wrapCallback = function wrapCallback() {
                    var value = getExperimentValue(experimentName, parameterName, defaultValue, $be3eefbbfcdaf0f2$var$_objectSpread($be3eefbbfcdaf0f2$var$_objectSpread({}, options), {}, {
                        fireExperimentExposure: false
                    }));
                    var existingValue = _this2.eventToValue.get(callback);
                    if (existingValue !== value) {
                        _this2.eventToValue.set(callback, value);
                        callback(value);
                    }
                };
                this.emitter.on(experimentEventName, wrapCallback);
                return function() {
                    _this2.emitter.off(experimentEventName, wrapCallback);
                };
            }
        },
        {
            key: "onAnyUpdated",
            value: function onAnyUpdated(callback) {
                var _this3 = this;
                this.emitter.on($be3eefbbfcdaf0f2$export$a66cbd9b2289cd78, callback);
                return function() {
                    _this3.emitter.off($be3eefbbfcdaf0f2$export$a66cbd9b2289cd78, callback);
                };
            }
        },
        {
            key: "anyUpdated",
            value: function anyUpdated() {
                var _this4 = this;
                this.emitter.emit($be3eefbbfcdaf0f2$export$a66cbd9b2289cd78);
                this.emitter.eventNames().filter(function(name) {
                    return name !== $be3eefbbfcdaf0f2$export$a66cbd9b2289cd78;
                }).forEach(function(event) {
                    _this4.emitter.emit(event);
                });
            }
        }
    ]);
}();

});

parcelRegister("fgnFJ", function(module, exports) {
$parcel$export(module.exports, "DynamicConfig", () => $b1cab66a8e493f17$export$6dc24881a3d96325);

var $hCM0e = parcelRequire("hCM0e");

var $cdRUW = parcelRequire("cdRUW");

var $i1Bei = parcelRequire("i1Bei");

var $1BRXt = parcelRequire("1BRXt");
var $b1cab66a8e493f17$export$6dc24881a3d96325 = /*#__PURE__*/ function() {
    function DynamicConfig(configName, configValue, ruleID, evaluationDetails) {
        var secondaryExposures = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : [];
        var allocatedExperimentName = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : '';
        var onDefaultValueFallback = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : null;
        (0, $cdRUW.default)(this, DynamicConfig);
        this.value = configValue;
        this._name = configName;
        this._ruleID = ruleID;
        this._secondaryExposures = secondaryExposures;
        this._allocatedExperimentName = allocatedExperimentName;
        this._evaluationDetails = evaluationDetails;
        this._onDefaultValueFallback = onDefaultValueFallback;
    }
    return (0, $i1Bei.default)(DynamicConfig, [
        {
            key: "get",
            value: function get(key, defaultValue, typeGuard) {
                var _this$_onDefaultValue2;
                var val = this.getValue(key, defaultValue);
                if (val == null) return defaultValue;
                var expectedType = Array.isArray(defaultValue) ? 'array' : (0, $hCM0e.default)(defaultValue);
                var actualType = Array.isArray(val) ? 'array' : (0, $hCM0e.default)(val);
                if (typeGuard) {
                    var _this$_onDefaultValue;
                    if (typeGuard(val)) {
                        this.fireExposure(key);
                        return val;
                    }
                    (_this$_onDefaultValue = this._onDefaultValueFallback) === null || _this$_onDefaultValue === void 0 || _this$_onDefaultValue.call(this, this, key, expectedType, actualType);
                    return defaultValue;
                }
                if (defaultValue == null || expectedType === actualType) {
                    this.fireExposure(key);
                    return val;
                }
                (_this$_onDefaultValue2 = this._onDefaultValueFallback) === null || _this$_onDefaultValue2 === void 0 || _this$_onDefaultValue2.call(this, this, key, expectedType, actualType);
                return defaultValue;
            }
        },
        {
            key: "getValue",
            value: function getValue(key, defaultValue) {
                if (key == null) return this.value;
                if (defaultValue == null) defaultValue = null;
                if (this.value[key] == null) return defaultValue;
                this.fireExposure(key);
                return this.value[key];
            }
        },
        {
            key: "fireExposure",
            value: function fireExposure(key) {
                // Call the wrapped experiment's get method to fire exposure
                if (this.experiment) this.experiment.get(key);
            }
        }
    ], [
        {
            key: "fromExperiment",
            value: function fromExperiment(experiment) {
                var _experiment$__evaluat, _experiment$__evaluat2, _experiment$groupName;
                var config = new DynamicConfig(experiment.name, experiment.value, experiment.ruleID, (0, $1BRXt.migrateEvaluationDetails)(experiment.details), (0, $1BRXt.migrateSecondaryExposures)((_experiment$__evaluat = (_experiment$__evaluat2 = experiment.__evaluation) === null || _experiment$__evaluat2 === void 0 ? void 0 : _experiment$__evaluat2.secondary_exposures) !== null && _experiment$__evaluat !== void 0 ? _experiment$__evaluat : []), (_experiment$groupName = experiment.groupName) !== null && _experiment$groupName !== void 0 ? _experiment$groupName : undefined);
                config.experiment = experiment;
                return config;
            }
        }
    ]);
}();

});
parcelRegister("1BRXt", function(module, exports) {
$parcel$export(module.exports, "getOptionsWithDefaults", () => $12c31a20be82a0b7$export$d119b37e5f788b43);
$parcel$export(module.exports, "shallowEquals", () => $12c31a20be82a0b7$export$fa1c2bbf4100b8bc);
$parcel$export(module.exports, "toStatsigUser", () => $12c31a20be82a0b7$export$3dad1db244472f32);
$parcel$export(module.exports, "deepAssign", () => $12c31a20be82a0b7$export$1148cb79ceecd5fa);
$parcel$export(module.exports, "migrateInitializationOptions", () => $12c31a20be82a0b7$export$202946b690d26d22);
$parcel$export(module.exports, "migrateEvaluationDetails", () => $12c31a20be82a0b7$export$18ad168d3dbac899);
$parcel$export(module.exports, "migrateSecondaryExposures", () => $12c31a20be82a0b7$export$55fd683752d01e67);

var $hCM0e = parcelRequire("hCM0e");

var $5MmUg = parcelRequire("5MmUg");

var $74jTZ = parcelRequire("74jTZ");

var $amAaq = parcelRequire("amAaq");

var $jgyhF = parcelRequire("jgyhF");

var $985QC = parcelRequire("985QC");

var $5qsP4 = parcelRequire("5qsP4");

var $l52tI = parcelRequire("l52tI");
var $12c31a20be82a0b7$var$_excluded = [
    "stableId"
], $12c31a20be82a0b7$var$_excluded2 = [
    "api",
    "disableCurrentPageLogging",
    "loggingIntervalMillis",
    "loggingBufferMaxSize",
    "localMode",
    "eventLoggingApi",
    "eventLoggingApiForRetries",
    "disableLocalStorage",
    "ignoreWindowUndefined",
    "disableAllLogging",
    "initTimeoutMs",
    "disableNetworkKeepalive",
    "overrideStableID",
    "disableErrorLogging",
    "disableAutoMetricsLogging"
];
function $12c31a20be82a0b7$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $12c31a20be82a0b7$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $12c31a20be82a0b7$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $jgyhF.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $12c31a20be82a0b7$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $12c31a20be82a0b7$export$d119b37e5f788b43 = function getOptionsWithDefaults(options) {
    return $12c31a20be82a0b7$var$_objectSpread({
        /**
     * If more federal PerimeterTypes are added in the future, this should be updated so
     * that isFedRamp() === true always returns the strictest perimeter.
     */ perimeter: (0, $985QC.isFedRamp)() ? (0, $l52tI.PerimeterType).FEDRAMP_MODERATE : (0, $l52tI.PerimeterType).COMMERCIAL
    }, options);
};
var $12c31a20be82a0b7$export$fa1c2bbf4100b8bc = function shallowEquals(objectA, objectB) {
    if (!objectA && !objectB) return true;
    if (!objectA || !objectB) return false;
    var aEntries = Object.entries(objectA);
    var bEntries = Object.entries(objectB);
    if (aEntries.length !== bEntries.length) return false;
    var ascendingKeyOrder = function ascendingKeyOrder(_ref, _ref2) {
        var _ref3 = (0, $amAaq.default)(_ref, 1), key1 = _ref3[0];
        var _ref4 = (0, $amAaq.default)(_ref2, 1), key2 = _ref4[0];
        return key1.localeCompare(key2);
    };
    aEntries.sort(ascendingKeyOrder);
    bEntries.sort(ascendingKeyOrder);
    for(var i = 0; i < aEntries.length; i++){
        var _aEntries$i = (0, $amAaq.default)(aEntries[i], 2), aValue = _aEntries$i[1];
        var _bEntries$i = (0, $amAaq.default)(bEntries[i], 2), bValue = _bEntries$i[1];
        if (aValue !== bValue) return false;
    }
    return true;
};
var $12c31a20be82a0b7$export$3dad1db244472f32 = function toStatsigUser(identifiers, customAttributes) {
    // Re-map `stableId` to `stableID` to match Statsig's native type.
    var stableId = identifiers.stableId, otherIdentifiers = (0, $74jTZ.default)(identifiers, $12c31a20be82a0b7$var$_excluded);
    var user = {
        customIDs: $12c31a20be82a0b7$var$_objectSpread($12c31a20be82a0b7$var$_objectSpread({}, otherIdentifiers), stableId !== undefined ? {
            stableID: stableId
        } : {}),
        custom: customAttributes
    };
    if (identifiers.atlassianAccountId) user.userID = identifiers.atlassianAccountId;
    return user;
};
function $12c31a20be82a0b7$export$1148cb79ceecd5fa(target) {
    for(var _len = arguments.length, sources = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)sources[_key - 1] = arguments[_key];
    if (!sources.length) return target;
    var source = sources.shift();
    if (source === undefined || source === null) return $12c31a20be82a0b7$export$1148cb79ceecd5fa.apply(void 0, [
        target
    ].concat((0, $5MmUg.default)(sources)));
    for(var _i = 0, _Object$entries = Object.entries(source); _i < _Object$entries.length; _i++){
        var _Object$entries$_i = (0, $amAaq.default)(_Object$entries[_i], 2), key = _Object$entries$_i[0], src = _Object$entries$_i[1];
        var dst = target[key];
        var srcIsObj = src && (0, $hCM0e.default)(src) === 'object' && !Array.isArray(src);
        var dstIsObj = dst && (0, $hCM0e.default)(dst) === 'object' && !Array.isArray(dst);
        if (srcIsObj && dstIsObj) target[key] = $12c31a20be82a0b7$export$1148cb79ceecd5fa(dst, src);
        else target[key] = src;
    }
    return $12c31a20be82a0b7$export$1148cb79ceecd5fa.apply(void 0, [
        target
    ].concat((0, $5MmUg.default)(sources)));
}
var $12c31a20be82a0b7$export$202946b690d26d22 = function migrateInitializationOptions(options) {
    var api = options.api, disableCurrentPageLogging = options.disableCurrentPageLogging, loggingIntervalMillis = options.loggingIntervalMillis, loggingBufferMaxSize = options.loggingBufferMaxSize, localMode = options.localMode, eventLoggingApi = options.eventLoggingApi, eventLoggingApiForRetries = options.eventLoggingApiForRetries, disableLocalStorage = options.disableLocalStorage, ignoreWindowUndefined = options.ignoreWindowUndefined, disableAllLogging = options.disableAllLogging, _initTimeoutMs = options.initTimeoutMs, _disableNetworkKeepalive = options.disableNetworkKeepalive, _overrideStableID = options.overrideStableID, _disableErrorLogging = options.disableErrorLogging, _disableAutoMetricsLogging = options.disableAutoMetricsLogging, rest = (0, $74jTZ.default)(options, $12c31a20be82a0b7$var$_excluded2);
    return $12c31a20be82a0b7$var$_objectSpread($12c31a20be82a0b7$var$_objectSpread({}, rest), {}, {
        networkConfig: {
            api: api,
            logEventUrl: eventLoggingApi ? eventLoggingApi + 'rgstr' : undefined,
            logEventFallbackUrls: eventLoggingApiForRetries ? [
                eventLoggingApiForRetries
            ] : undefined,
            preventAllNetworkTraffic: localMode || !ignoreWindowUndefined && typeof window === 'undefined'
        },
        includeCurrentPageUrlWithEvents: !disableCurrentPageLogging,
        loggingIntervalMs: loggingIntervalMillis,
        loggingBufferMaxSize: loggingBufferMaxSize,
        disableStorage: disableLocalStorage === undefined ? localMode : disableLocalStorage,
        disableLogging: disableAllLogging === undefined ? localMode : disableAllLogging
    });
};
var $12c31a20be82a0b7$var$evaluationReasonMappings = Object.entries((0, $5qsP4.EvaluationReason)).map(function(_ref5) {
    var _ref6 = (0, $amAaq.default)(_ref5, 2), key = _ref6[0], value = _ref6[1];
    return [
        key.toLowerCase(),
        value
    ];
});
var $12c31a20be82a0b7$export$18ad168d3dbac899 = function migrateEvaluationDetails(details) {
    var _evaluationReasonMapp, _evaluationReasonMapp2, _details$receivedAt;
    var reasonLower = details.reason.toLowerCase();
    return {
        reason: (_evaluationReasonMapp = (_evaluationReasonMapp2 = $12c31a20be82a0b7$var$evaluationReasonMappings.find(function(_ref7) {
            var _ref8 = (0, $amAaq.default)(_ref7, 1), key = _ref8[0];
            return reasonLower.includes(key);
        })) === null || _evaluationReasonMapp2 === void 0 ? void 0 : _evaluationReasonMapp2[1]) !== null && _evaluationReasonMapp !== void 0 ? _evaluationReasonMapp : (0, $5qsP4.EvaluationReason).Unknown,
        time: (_details$receivedAt = details.receivedAt) !== null && _details$receivedAt !== void 0 ? _details$receivedAt : Date.now()
    };
};
var $12c31a20be82a0b7$export$55fd683752d01e67 = function migrateSecondaryExposures(secondaryExposures) {
    return secondaryExposures.map(function(exposure) {
        if (typeof exposure === 'string') // This should ideally have gateValue and ruleID fields too, but it's not possible for us
        // to determine the correct values for these.
        return {
            gate: exposure
        };
        return exposure;
    });
};

});
parcelRegister("985QC", function(module, exports) {
$parcel$export(module.exports, "isFedRamp", () => $6a5965a6734fad92$export$64d6499adf9b2e51);

var $97thR = parcelRequire("97thR");
function $6a5965a6734fad92$export$64d6499adf9b2e51() {
    var _global$location;
    var global = globalThis;
    // MICROS_PERIMETER is already used by few products, so we need to keep it for backward compatibility
    var env = global.MICROS_PERIMETER || global.UNSAFE_ATL_CONTEXT_BOUNDARY;
    if (env) return env === (0, $97thR.FEDRAMP_MODERATE);
    var matches = (_global$location = global.location) === null || _global$location === void 0 || (_global$location = _global$location.hostname) === null || _global$location === void 0 ? void 0 : _global$location.match(/atlassian-us-gov-mod\.(com|net)|atlassian-us-gov\.(com|net)|atlassian-fex\.(com|net)|atlassian-stg-fedm\.(com|net)/);
    return matches ? matches.length > 0 : false;
}

});
parcelRegister("97thR", function(module, exports) {
$parcel$export(module.exports, "FEDRAMP_MODERATE", () => $6a3b7c5181bf0387$export$ce553301d55c2fd8);
var $6a3b7c5181bf0387$export$ce553301d55c2fd8 = 'fedramp-moderate';
var $6a3b7c5181bf0387$export$f005e2e9f707cb5f = 'commercial';
var $6a3b7c5181bf0387$export$bd6b5a7802d76127 = 'fedramp-fedex';
var $6a3b7c5181bf0387$export$a739cd5aac835909 = 'stg';
var $6a3b7c5181bf0387$export$42dd0cdd351a4a9 = 'prod';
var $6a3b7c5181bf0387$export$404582bc18fe4d9e = 'dev';

});


parcelRegister("5qsP4", function(module, exports) {
$parcel$export(module.exports, "EvaluationReason", () => $3f35bd0f356ae11c$export$c62558b199e46828);
// Reference: https://github.com/statsig-io/js-lite/blob/main/src/StatsigStore.ts
var $3f35bd0f356ae11c$export$c62558b199e46828 = {
    // Order is important since the logic for migrating from a new client reason to an old one
    // returns the first which is a substring of the new client reason
    Error: 'Error',
    LocalOverride: 'LocalOverride',
    Unrecognized: 'Unrecognized',
    Uninitialized: 'Uninitialized',
    NetworkNotModified: 'NetworkNotModified',
    Network: 'Network',
    InvalidBootstrap: 'InvalidBootstrap',
    Bootstrap: 'Bootstrap',
    Cache: 'Cache',
    // For when we could not migrate the reason from the new client
    Unknown: 'Unknown'
}; // Reference: https://github.com/statsig-io/js-lite/blob/main/src/StatsigSDKOptions.ts

});

parcelRegister("l52tI", function(module, exports) {
$parcel$export(module.exports, "FeatureGateEnvironment", () => $f58bfcb74082b876$export$479e7351a733299);
$parcel$export(module.exports, "PerimeterType", () => $f58bfcb74082b876$export$c42b7bbc5e7ba555);
/**
 * The identifiers for the user. Options are restricted to the set that is currently supported.
 */ /**
 * Base client options. Does not include any options specific to providers
 * @interface BaseClientOptions
 * @property {FeatureGateEnvironment} environment - The environment for the client.
 * @property {string} targetApp - The target app for the client.
 * @property {AnalyticsWebClient} analyticsWebClient - The analytics web client.
 * @property {PerimeterType} perimeter - The perimeter for the client.
 */ /**
 * The options for the client.
 * @interface ClientOptions
 * @extends {BaseClientOptions}
 * @property {string} apiKey - The API key for the client.
 * @property {fetchTimeoutMs} fetchTimeoutMs - The timeout for the fetch request in milliseconds. Defaults to 5000.
 * @property {boolean} useGatewayURL - Whether to use the gateway URL. Defaults to false.
 */ /**
 * The custom attributes for the user.
 */ var $f58bfcb74082b876$export$479e7351a733299 = {
    Development: 'development',
    Staging: 'staging',
    Production: 'production'
};
var $f58bfcb74082b876$export$c42b7bbc5e7ba555 = {
    COMMERCIAL: 'commercial',
    FEDRAMP_MODERATE: 'fedramp-moderate'
};
var $f58bfcb74082b876$export$42f4885608027d0c = 'non_boolean'; // Type magic to get the JSDoc comments from the Client class methods to appear on the static
 // methods in FeatureGates where the property name and function type are identical

});



parcelRegister("5sKD5", function(module, exports) {
$parcel$export(module.exports, "Layer", () => $3fa3bceda9fa21b3$export$936d0764594b6eb3);

var $hCM0e = parcelRequire("hCM0e");

var $cdRUW = parcelRequire("cdRUW");

var $i1Bei = parcelRequire("i1Bei");

var $1BRXt = parcelRequire("1BRXt");
var $3fa3bceda9fa21b3$export$936d0764594b6eb3 = /*#__PURE__*/ function() {
    function Layer(name, layerValue, ruleID, evaluationDetails) {
        var logParameterFunction = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;
        var secondaryExposures = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : [];
        var undelegatedSecondaryExposures = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : [];
        var allocatedExperimentName = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : '';
        var explicitParameters = arguments.length > 8 && arguments[8] !== undefined ? arguments[8] : [];
        (0, $cdRUW.default)(this, Layer);
        this._logParameterFunction = logParameterFunction;
        this._name = name;
        this._value = JSON.parse(JSON.stringify(layerValue !== null && layerValue !== void 0 ? layerValue : {}));
        this._ruleID = ruleID !== null && ruleID !== void 0 ? ruleID : '';
        this._evaluationDetails = evaluationDetails;
        this._secondaryExposures = secondaryExposures;
        this._undelegatedSecondaryExposures = undelegatedSecondaryExposures;
        this._allocatedExperimentName = allocatedExperimentName;
        this._explicitParameters = explicitParameters;
    }
    return (0, $i1Bei.default)(Layer, [
        {
            key: "get",
            value: function get(key, defaultValue, typeGuard) {
                var _this = this;
                var val = this._value[key];
                if (val == null) return defaultValue;
                var logAndReturn = function logAndReturn() {
                    _this._logLayerParameterExposure(key);
                    return val;
                };
                if (typeGuard) return typeGuard(val) ? logAndReturn() : defaultValue;
                if (defaultValue == null) return logAndReturn();
                if ((0, $hCM0e.default)(val) === (0, $hCM0e.default)(defaultValue) && Array.isArray(defaultValue) === Array.isArray(val)) return logAndReturn();
                return defaultValue;
            }
        },
        {
            key: "getValue",
            value: function getValue(key, defaultValue) {
                // eslint-disable-next-line eqeqeq
                if (defaultValue == undefined) defaultValue = null;
                var val = this._value[key];
                if (val != null) this._logLayerParameterExposure(key);
                return val !== null && val !== void 0 ? val : defaultValue;
            }
        },
        {
            key: "_logLayerParameterExposure",
            value: function _logLayerParameterExposure(parameterName) {
                var _this$_logParameterFu;
                (_this$_logParameterFu = this._logParameterFunction) === null || _this$_logParameterFu === void 0 || _this$_logParameterFu.call(this, this, parameterName);
            }
        }
    ], [
        {
            key: "fromLayer",
            value: function fromLayer(layer) {
                var _layer$__evaluation$s, _layer$__evaluation, _layer$__evaluation$u, _layer$__evaluation2, _layer$__evaluation3, _layer$__evaluation4;
                var value = new Layer(layer.name, layer.__value, layer.ruleID, (0, $1BRXt.migrateEvaluationDetails)(layer.details), function(_layer, parameterName) {
                    return layer.get(parameterName);
                }, (0, $1BRXt.migrateSecondaryExposures)((_layer$__evaluation$s = (_layer$__evaluation = layer.__evaluation) === null || _layer$__evaluation === void 0 ? void 0 : _layer$__evaluation.secondary_exposures) !== null && _layer$__evaluation$s !== void 0 ? _layer$__evaluation$s : []), (0, $1BRXt.migrateSecondaryExposures)((_layer$__evaluation$u = (_layer$__evaluation2 = layer.__evaluation) === null || _layer$__evaluation2 === void 0 ? void 0 : _layer$__evaluation2.undelegated_secondary_exposures) !== null && _layer$__evaluation$u !== void 0 ? _layer$__evaluation$u : []), (_layer$__evaluation3 = layer.__evaluation) === null || _layer$__evaluation3 === void 0 ? void 0 : _layer$__evaluation3.allocated_experiment_name, (_layer$__evaluation4 = layer.__evaluation) === null || _layer$__evaluation4 === void 0 ? void 0 : _layer$__evaluation4.explicit_parameters);
                return value;
            }
        }
    ]);
}();

});

parcelRegister("d737b", function(module, exports) {
$parcel$export(module.exports, "default", () => $0276aed8435eac4a$export$2e2bcd8739ae039);

var $jgyhF = parcelRequire("jgyhF");

var $dZJgY = parcelRequire("dZJgY");

var $cdRUW = parcelRequire("cdRUW");

var $i1Bei = parcelRequire("i1Bei");

var $emmWV = parcelRequire("emmWV");

var $l52tI = parcelRequire("l52tI");

var $48bCT = parcelRequire("48bCT");

var $6hqAr = parcelRequire("6hqAr");
function $0276aed8435eac4a$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $0276aed8435eac4a$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $0276aed8435eac4a$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $jgyhF.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $0276aed8435eac4a$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $0276aed8435eac4a$var$DEFAULT_REQUEST_TIMEOUT_MS = 5000;
var $0276aed8435eac4a$export$250a58ecde616daa = 'https://api.atlassian.com/flags';
var $0276aed8435eac4a$export$942ba04389b0d5a2 = 'https://api.stg.atlassian.com/flags';
var $0276aed8435eac4a$export$f058dbf75c3bc647 = 'https://api.dev.atlassian.com/flags';
var $0276aed8435eac4a$export$1a401a0da8da3565 = 'https://api.stg.atlassian-us-gov-mod.com/flags';
var $0276aed8435eac4a$export$18c93900db9358a4 = 'https://api.atlassian-us-gov-mod.com/flags';
var $0276aed8435eac4a$export$4e8a0415edbfa1f7 = 'https://atlassian-statsig-proxy-archetype.atl-paas.%s.atl-ic.net';
var $0276aed8435eac4a$export$cb3cd156f70d7e94 = 'oasis-stg.com/flags';
var $0276aed8435eac4a$export$921fbc6cdfd4eee0 = 'atlassian-isolated.net/flags';
var $0276aed8435eac4a$export$450bd8fb2a6d7ace = '/gateway/api/flags';
var $0276aed8435eac4a$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function Fetcher() {
        (0, $cdRUW.default)(this, Fetcher);
    }
    return (0, $i1Bei.default)(Fetcher, null, [
        {
            key: "fetchClientSdk",
            value: function() {
                var _fetchClientSdk = (0, $dZJgY.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($emmWV))).mark(function _callee(fetcherOptions) {
                    var targetApp, url, _t;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($emmWV))).wrap(function(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                targetApp = fetcherOptions.targetApp;
                                url = "/api/v2/frontend/clientSdkKey/".concat(targetApp);
                                _context.prev = 1;
                                _context.next = 2;
                                return this.fetchRequest(url, 'GET', fetcherOptions);
                            case 2:
                                return _context.abrupt("return", _context.sent);
                            case 3:
                                _context.prev = 3;
                                _t = _context["catch"](1);
                                if (!(_t instanceof Error)) {
                                    _context.next = 4;
                                    break;
                                }
                                throw _t;
                            case 4:
                                throw Error('Failed to retrieve client sdk key');
                            case 5:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee, this, [
                        [
                            1,
                            3
                        ]
                    ]);
                }));
                function fetchClientSdk(_x) {
                    return _fetchClientSdk.apply(this, arguments);
                }
                return fetchClientSdk;
            }()
        },
        {
            key: "fetchExperimentValues",
            value: function() {
                var _fetchExperimentValues = (0, $dZJgY.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($emmWV))).mark(function _callee2(fetcherOptions, identifiers, customAttributes) {
                    var requestBody, _t2;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($emmWV))).wrap(function(_context2) {
                        while(true)switch(_context2.prev = _context2.next){
                            case 0:
                                requestBody = {
                                    identifiers: identifiers,
                                    customAttributes: customAttributes,
                                    targetApp: fetcherOptions.targetApp
                                };
                                _context2.prev = 1;
                                _context2.next = 2;
                                return this.fetchRequest('/api/v2/frontend/experimentValues', 'POST', fetcherOptions, requestBody);
                            case 2:
                                return _context2.abrupt("return", _context2.sent);
                            case 3:
                                _context2.prev = 3;
                                _t2 = _context2["catch"](1);
                                if (!(_t2 instanceof Error)) {
                                    _context2.next = 4;
                                    break;
                                }
                                throw _t2;
                            case 4:
                                throw Error('Failed to retrieve experiment values');
                            case 5:
                            case "end":
                                return _context2.stop();
                        }
                    }, _callee2, this, [
                        [
                            1,
                            3
                        ]
                    ]);
                }));
                function fetchExperimentValues(_x2, _x3, _x4) {
                    return _fetchExperimentValues.apply(this, arguments);
                }
                return fetchExperimentValues;
            }()
        },
        {
            key: "handleResponseError",
            value: function() {
                var _handleResponseError = (0, $dZJgY.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($emmWV))).mark(function _callee3(response) {
                    var body;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($emmWV))).wrap(function(_context3) {
                        while(true)switch(_context3.prev = _context3.next){
                            case 0:
                                if (response.ok) {
                                    _context3.next = 2;
                                    break;
                                }
                                _context3.next = 1;
                                return response.text();
                            case 1:
                                body = _context3.sent;
                                throw new (0, $6hqAr.ResponseError)("Non 2xx response status received, status: ".concat(response.status, ", body: ").concat(JSON.stringify(body)));
                            case 2:
                                if (!(response.status === 204)) {
                                    _context3.next = 3;
                                    break;
                                }
                                throw new (0, $6hqAr.ResponseError)('Unexpected 204 response');
                            case 3:
                            case "end":
                                return _context3.stop();
                        }
                    }, _callee3);
                }));
                function handleResponseError(_x5) {
                    return _handleResponseError.apply(this, arguments);
                }
                return handleResponseError;
            }()
        },
        {
            key: "extractResponseBody",
            value: function() {
                var _extractResponseBody = (0, $dZJgY.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($emmWV))).mark(function _callee4(response) {
                    var value;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($emmWV))).wrap(function(_context4) {
                        while(true)switch(_context4.prev = _context4.next){
                            case 0:
                                _context4.next = 1;
                                return response.text();
                            case 1:
                                value = _context4.sent;
                                return _context4.abrupt("return", JSON.parse(value));
                            case 2:
                            case "end":
                                return _context4.stop();
                        }
                    }, _callee4);
                }));
                function extractResponseBody(_x6) {
                    return _extractResponseBody.apply(this, arguments);
                }
                return extractResponseBody;
            }()
        },
        {
            key: "getBaseUrl",
            value: function getBaseUrl(serviceEnv) {
                var useGatewayUrl = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
                var perimeter = arguments.length > 2 ? arguments[2] : undefined;
                var isolationContextId = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
                if (useGatewayUrl) return $0276aed8435eac4a$export$450bd8fb2a6d7ace;
                if (perimeter === (0, $l52tI.PerimeterType).FEDRAMP_MODERATE) switch(serviceEnv){
                    case (0, $l52tI.FeatureGateEnvironment).Production:
                        return $0276aed8435eac4a$export$18c93900db9358a4;
                    case (0, $l52tI.FeatureGateEnvironment).Staging:
                        return $0276aed8435eac4a$export$1a401a0da8da3565;
                    default:
                        throw new Error("Invalid environment \"".concat(serviceEnv, "\" for \"").concat(perimeter, "\" perimeter"));
                }
                else if (perimeter === (0, $l52tI.PerimeterType).COMMERCIAL) switch(serviceEnv){
                    case (0, $l52tI.FeatureGateEnvironment).Development:
                        return $0276aed8435eac4a$export$f058dbf75c3bc647;
                    case (0, $l52tI.FeatureGateEnvironment).Staging:
                        var apiUrl = this.getApiUrl(isolationContextId);
                        if (apiUrl !== null) return apiUrl;
                        return $0276aed8435eac4a$export$942ba04389b0d5a2;
                    default:
                        var prodApiUrl = this.getApiUrl(isolationContextId);
                        if (prodApiUrl !== null) return prodApiUrl;
                        return $0276aed8435eac4a$export$250a58ecde616daa;
                }
                else throw new Error("Invalid perimeter \"".concat(perimeter, "\""));
            }
        },
        {
            key: "fetchRequest",
            value: function() {
                var _fetchRequest = (0, $dZJgY.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($emmWV))).mark(function _callee5(path, method, fetcherOptions, body) {
                    var baseUrl, fetchTimeout, abortSignal, abortController, response;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($emmWV))).wrap(function(_context5) {
                        while(true)switch(_context5.prev = _context5.next){
                            case 0:
                                baseUrl = Fetcher.getBaseUrl(fetcherOptions.environment, fetcherOptions.useGatewayURL, fetcherOptions.perimeter, fetcherOptions.isolationContextId);
                                fetchTimeout = fetcherOptions.fetchTimeoutMs || $0276aed8435eac4a$var$DEFAULT_REQUEST_TIMEOUT_MS;
                                if (AbortSignal.timeout) abortSignal = AbortSignal.timeout(fetchTimeout);
                                else if (AbortController) {
                                    abortController = new AbortController();
                                    abortSignal = abortController.signal;
                                    setTimeout(function() {
                                        return abortController.abort();
                                    }, fetchTimeout);
                                }
                                _context5.next = 1;
                                return fetch("".concat(baseUrl).concat(path), $0276aed8435eac4a$var$_objectSpread({
                                    method: method,
                                    headers: {
                                        'Content-Type': 'application/json',
                                        'X-Client-Name': 'feature-gate-js-client',
                                        'X-Client-Version': (0, $48bCT.CLIENT_VERSION),
                                        'X-API-KEY': fetcherOptions.apiKey
                                    },
                                    signal: abortSignal
                                }, body && {
                                    body: JSON.stringify(body)
                                }));
                            case 1:
                                response = _context5.sent;
                                _context5.next = 2;
                                return this.handleResponseError(response);
                            case 2:
                                _context5.next = 3;
                                return this.extractResponseBody(response);
                            case 3:
                                return _context5.abrupt("return", _context5.sent);
                            case 4:
                            case "end":
                                return _context5.stop();
                        }
                    }, _callee5, this);
                }));
                function fetchRequest(_x7, _x8, _x9, _x0) {
                    return _fetchRequest.apply(this, arguments);
                }
                return fetchRequest;
            }()
        },
        {
            key: "getApiUrl",
            value: function getApiUrl(isolationContextId) {
                var window1 = this.getWindowLocation();
                if (window1 === undefined) {
                    //this is needed when this SDK is used for SSR or plugin use cases where secret keys not available to use backend SDKs
                    if (!isolationContextId) return null;
                    return $0276aed8435eac4a$export$4e8a0415edbfa1f7.replace('%s', isolationContextId);
                }
                var protocol = window1.protocol, hostname = window1.hostname;
                // Match last subdomain fragment before oasis-stg.com
                var oasisMatch = hostname.match(/([^.]+)\.oasis-stg\.com$/);
                if (oasisMatch) return "".concat(protocol, "//api.").concat(oasisMatch[1], ".").concat($0276aed8435eac4a$export$cb3cd156f70d7e94);
                // Match last subdomain fragment before atlassian-isolated.net
                var isolatedMatch = hostname.match(/([^.]+)\.atlassian-isolated\.net$/);
                if (isolatedMatch) return "".concat(protocol, "//api.").concat(isolatedMatch[1], ".").concat($0276aed8435eac4a$export$921fbc6cdfd4eee0);
                return null;
            }
        },
        {
            key: "getWindowLocation",
            value: function getWindowLocation() {
                if (typeof window !== 'undefined' && window.location) return window.location;
                return undefined;
            }
        }
    ]);
}();

});
parcelRegister("48bCT", function(module, exports) {
$parcel$export(module.exports, "CLIENT_VERSION", () => $3020ed84cf607658$export$a59f8d67326bd1cb);
/// <reference types="node" />
var $3020ed84cf607658$export$a59f8d67326bd1cb = "5.8.0";

});

parcelRegister("6hqAr", function(module, exports) {
$parcel$export(module.exports, "ResponseError", () => $4928f42cae424253$export$286baf652d0b1206);

var $i1Bei = parcelRequire("i1Bei");

var $cdRUW = parcelRequire("cdRUW");

var $52fzZ = parcelRequire("52fzZ");

var $hYFGc = parcelRequire("hYFGc");

var $1Gcz8 = parcelRequire("1Gcz8");

var $ho4at = parcelRequire("ho4at");
function $4928f42cae424253$var$_callSuper(t, o, e) {
    return o = (0, $hYFGc.default)(o), (0, $52fzZ.default)(t, $4928f42cae424253$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, $hYFGc.default)(t).constructor) : o.apply(t, e));
}
function $4928f42cae424253$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($4928f42cae424253$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $4928f42cae424253$export$286baf652d0b1206 = /*#__PURE__*/ function(_Error) {
    function ResponseError(message) {
        (0, $cdRUW.default)(this, ResponseError);
        return $4928f42cae424253$var$_callSuper(this, ResponseError, [
            message
        ]);
    }
    (0, $1Gcz8.default)(ResponseError, _Error);
    return (0, $i1Bei.default)(ResponseError);
}(/*#__PURE__*/ (0, $ho4at.default)(Error));

});
parcelRegister("52fzZ", function(module, exports) {
$parcel$export(module.exports, "default", () => $3aa9396cbbda121b$export$2e2bcd8739ae039);

var $hCM0e = parcelRequire("hCM0e");

var $7pkrj = parcelRequire("7pkrj");
function $3aa9396cbbda121b$export$2e2bcd8739ae039(t, e) {
    if (e && ("object" == (0, $hCM0e.default)(e) || "function" == typeof e)) return e;
    if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
    return (0, $7pkrj.default)(t);
}

});
parcelRegister("7pkrj", function(module, exports) {
$parcel$export(module.exports, "default", () => $564ab90b0c7eaa90$export$2e2bcd8739ae039);
function $564ab90b0c7eaa90$export$2e2bcd8739ae039(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
}

});


parcelRegister("hYFGc", function(module, exports) {
$parcel$export(module.exports, "default", () => $d1685efec0ae7022$export$2e2bcd8739ae039);
function $d1685efec0ae7022$export$2e2bcd8739ae039(t) {
    return $d1685efec0ae7022$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
        return t.__proto__ || Object.getPrototypeOf(t);
    }, $d1685efec0ae7022$export$2e2bcd8739ae039(t);
}

});

parcelRegister("1Gcz8", function(module, exports) {
$parcel$export(module.exports, "default", () => $139375f5263c8dad$export$2e2bcd8739ae039);

var $1jGPp = parcelRequire("1jGPp");
function $139375f5263c8dad$export$2e2bcd8739ae039(t, e) {
    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
    t.prototype = Object.create(e && e.prototype, {
        constructor: {
            value: t,
            writable: !0,
            configurable: !0
        }
    }), Object.defineProperty(t, "prototype", {
        writable: !1
    }), e && (0, $1jGPp.default)(t, e);
}

});
parcelRegister("1jGPp", function(module, exports) {
$parcel$export(module.exports, "default", () => $0f58c9938e149bae$export$2e2bcd8739ae039);
function $0f58c9938e149bae$export$2e2bcd8739ae039(t, e) {
    return $0f58c9938e149bae$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, $0f58c9938e149bae$export$2e2bcd8739ae039(t, e);
}

});


parcelRegister("ho4at", function(module, exports) {
$parcel$export(module.exports, "default", () => $ca87e93ddf2eb63b$export$2e2bcd8739ae039);

var $hYFGc = parcelRequire("hYFGc");

var $1jGPp = parcelRequire("1jGPp");

var $i0EjF = parcelRequire("i0EjF");

var $QiYXw = parcelRequire("QiYXw");
function $ca87e93ddf2eb63b$export$2e2bcd8739ae039(t) {
    var r = "function" == typeof Map ? new Map() : void 0;
    return $ca87e93ddf2eb63b$export$2e2bcd8739ae039 = function _wrapNativeSuper(t) {
        if (null === t || !(0, $i0EjF.default)(t)) return t;
        if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function");
        if (void 0 !== r) {
            if (r.has(t)) return r.get(t);
            r.set(t, Wrapper);
        }
        function Wrapper() {
            return (0, $QiYXw.default)(t, arguments, (0, $hYFGc.default)(this).constructor);
        }
        return Wrapper.prototype = Object.create(t.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: !1,
                writable: !0,
                configurable: !0
            }
        }), (0, $1jGPp.default)(Wrapper, t);
    }, $ca87e93ddf2eb63b$export$2e2bcd8739ae039(t);
}

});
parcelRegister("i0EjF", function(module, exports) {
$parcel$export(module.exports, "default", () => $d1c7800667334518$export$2e2bcd8739ae039);
function $d1c7800667334518$export$2e2bcd8739ae039(t) {
    try {
        return -1 !== Function.toString.call(t).indexOf("[native code]");
    } catch (n) {
        return "function" == typeof t;
    }
}

});

parcelRegister("QiYXw", function(module, exports) {
$parcel$export(module.exports, "default", () => $09d394ea4e182245$export$2e2bcd8739ae039);

var $bl9rW = parcelRequire("bl9rW");

var $1jGPp = parcelRequire("1jGPp");
function $09d394ea4e182245$export$2e2bcd8739ae039(t, e, r) {
    if ((0, $bl9rW.default)()) return Reflect.construct.apply(null, arguments);
    var o = [
        null
    ];
    o.push.apply(o, e);
    var p = new (t.bind.apply(t, o))();
    return r && (0, $1jGPp.default)(p, r.prototype), p;
}

});
parcelRegister("bl9rW", function(module, exports) {
$parcel$export(module.exports, "default", () => $8418fc60afd645e4$export$2e2bcd8739ae039);
function $8418fc60afd645e4$export$2e2bcd8739ae039() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($8418fc60afd645e4$export$2e2bcd8739ae039 = function _isNativeReflectConstruct() {
        return !!t;
    })();
}

});





parcelRegister("55zJS", function(module, exports) {
$parcel$export(module.exports, "NoFetchDataAdapter", () => $3b492463d39f62a1$export$55fffef3474104af);

var $dZJgY = parcelRequire("dZJgY");

var $cdRUW = parcelRequire("cdRUW");

var $i1Bei = parcelRequire("i1Bei");

var $52fzZ = parcelRequire("52fzZ");

var $hYFGc = parcelRequire("hYFGc");

var $3DHSS = parcelRequire("3DHSS");

var $1Gcz8 = parcelRequire("1Gcz8");

var $jgyhF = parcelRequire("jgyhF");

var $emmWV = parcelRequire("emmWV");

var $iFR7a = parcelRequire("iFR7a");
function $3b492463d39f62a1$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $3b492463d39f62a1$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $3b492463d39f62a1$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $jgyhF.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $3b492463d39f62a1$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $3b492463d39f62a1$var$_callSuper(t, o, e) {
    return o = (0, $hYFGc.default)(o), (0, $52fzZ.default)(t, $3b492463d39f62a1$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, $hYFGc.default)(t).constructor) : o.apply(t, e));
}
function $3b492463d39f62a1$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($3b492463d39f62a1$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $3b492463d39f62a1$var$_superPropGet(t, o, e, r) {
    var p = (0, $3DHSS.default)((0, $hYFGc.default)(1 & r ? t.prototype : t), o, e);
    return 2 & r && "function" == typeof p ? function(t) {
        return p.apply(e, t);
    } : p;
}
var $3b492463d39f62a1$export$55fffef3474104af = /*#__PURE__*/ function(_DataAdapterCore) {
    function NoFetchDataAdapter() {
        var _this;
        (0, $cdRUW.default)(this, NoFetchDataAdapter);
        _this = $3b492463d39f62a1$var$_callSuper(this, NoFetchDataAdapter, [
            'NoFetchDataAdapter',
            'nofetch'
        ]);
        (0, $jgyhF.default)(_this, "bootstrapResult", null);
        return _this;
    }
    /**
   * Make sure to call this **before** calling `initializeAsync` or `updateUserAsync` but
   * after the Statsig client has been created!
   */ (0, $1Gcz8.default)(NoFetchDataAdapter, _DataAdapterCore);
    return (0, $i1Bei.default)(NoFetchDataAdapter, [
        {
            key: "setBootstrapData",
            value: function setBootstrapData(data) {
                this.bootstrapResult = data ? {
                    source: 'Bootstrap',
                    data: JSON.stringify(data),
                    receivedAt: Date.now(),
                    stableID: (0, $iFR7a.StableID).get(this._getSdkKey()),
                    fullUserHash: null
                } : null;
            }
        },
        {
            key: "prefetchData",
            value: function() {
                var _prefetchData = (0, $dZJgY.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($emmWV))).mark(function _callee(_user, _options) {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($emmWV))).wrap(function(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee);
                }));
                function prefetchData(_x, _x2) {
                    return _prefetchData.apply(this, arguments);
                }
                return prefetchData;
            }()
        },
        {
            key: "getDataAsync",
            value: function() {
                var _getDataAsync = (0, $dZJgY.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($emmWV))).mark(function _callee2(_current, user, _options) {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($emmWV))).wrap(function(_context2) {
                        while(true)switch(_context2.prev = _context2.next){
                            case 0:
                                return _context2.abrupt("return", this.bootstrapResult && $3b492463d39f62a1$var$_objectSpread($3b492463d39f62a1$var$_objectSpread({}, this.bootstrapResult), {}, {
                                    fullUserHash: (0, $iFR7a._getFullUserHash)(user)
                                }));
                            case 1:
                            case "end":
                                return _context2.stop();
                        }
                    }, _callee2, this);
                }));
                function getDataAsync(_x3, _x4, _x5) {
                    return _getDataAsync.apply(this, arguments);
                }
                return getDataAsync;
            }()
        },
        {
            key: "getDataSync",
            value: function getDataSync(user) {
                return this.bootstrapResult && $3b492463d39f62a1$var$_objectSpread($3b492463d39f62a1$var$_objectSpread({}, this.bootstrapResult), {}, {
                    fullUserHash: (0, $iFR7a._getFullUserHash)(user)
                });
            }
        },
        {
            key: "_fetchFromNetwork",
            value: function() {
                var _fetchFromNetwork2 = (0, $dZJgY.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($emmWV))).mark(function _callee3(_current, _user, _options) {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($emmWV))).wrap(function(_context3) {
                        while(true)switch(_context3.prev = _context3.next){
                            case 0:
                                return _context3.abrupt("return", null);
                            case 1:
                            case "end":
                                return _context3.stop();
                        }
                    }, _callee3);
                }));
                function _fetchFromNetwork(_x6, _x7, _x8) {
                    return _fetchFromNetwork2.apply(this, arguments);
                }
                return _fetchFromNetwork;
            }()
        },
        {
            key: "_getCacheKey",
            value: function _getCacheKey(user) {
                // Same logic as default data adapter
                // https://github.com/statsig-io/js-client-monorepo/blob/main/packages/js-client/src/StatsigEvaluationsDataAdapter.ts
                var key = (0, $iFR7a._getStorageKey)(this._getSdkKey(), user);
                return "".concat((0, $iFR7a.DataAdapterCachePrefix), ".").concat(this._cacheSuffix, ".").concat(key);
            }
        },
        {
            key: "_isCachedResultValidFor204",
            value: function _isCachedResultValidFor204(_result, _user) {
                return false;
            }
        },
        {
            key: "setDataLegacy",
            value: function setDataLegacy(data, user) {
                $3b492463d39f62a1$var$_superPropGet(NoFetchDataAdapter, "setData", this, 3)([
                    data,
                    user
                ]);
            }
        },
        {
            key: "toJSON",
            value: function toJSON() {
                var result = $3b492463d39f62a1$var$_objectSpread({}, this);
                delete result._options;
                delete result._inMemoryCache;
                delete result.bootstrapResult;
                return result;
            }
        }
    ]);
}((0, $iFR7a.DataAdapterCore));

});
parcelRegister("3DHSS", function(module, exports) {
$parcel$export(module.exports, "default", () => $2a670e1609bfaadf$export$2e2bcd8739ae039);

var $j16cw = parcelRequire("j16cw");
function $2a670e1609bfaadf$export$2e2bcd8739ae039() {
    return $2a670e1609bfaadf$export$2e2bcd8739ae039 = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function(e, t, r) {
        var p = (0, $j16cw.default)(e, t);
        if (p) {
            var n = Object.getOwnPropertyDescriptor(p, t);
            return n.get ? n.get.call(arguments.length < 3 ? e : r) : n.value;
        }
    }, $2a670e1609bfaadf$export$2e2bcd8739ae039.apply(null, arguments);
}

});
parcelRegister("j16cw", function(module, exports) {
$parcel$export(module.exports, "default", () => $dd82ebaf62312a9f$export$2e2bcd8739ae039);

var $hYFGc = parcelRequire("hYFGc");
function $dd82ebaf62312a9f$export$2e2bcd8739ae039(t, o) {
    for(; !({}).hasOwnProperty.call(t, o) && null !== (t = (0, $hYFGc.default)(t)););
    return t;
}

});



parcelRegister("55ZQu", function(module, exports) {
$parcel$export(module.exports, "LOCAL_STORAGE_KEY", () => $3b5d64a7da124292$export$d8474cff104280f3);
$parcel$export(module.exports, "PersistentOverrideAdapter", () => $3b5d64a7da124292$export$bcb28fbac1def494);

var $jgyhF = parcelRequire("jgyhF");

var $amAaq = parcelRequire("amAaq");

var $cdRUW = parcelRequire("cdRUW");

var $i1Bei = parcelRequire("i1Bei");

var $dtn6l = parcelRequire("dtn6l");
function $3b5d64a7da124292$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $3b5d64a7da124292$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $3b5d64a7da124292$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $jgyhF.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $3b5d64a7da124292$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $3b5d64a7da124292$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $3b5d64a7da124292$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $3b5d64a7da124292$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $3b5d64a7da124292$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $3b5d64a7da124292$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $3b5d64a7da124292$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
var $3b5d64a7da124292$var$LOCAL_OVERRIDE_REASON = 'LocalOverride:Recognized';
var $3b5d64a7da124292$export$d8474cff104280f3 = 'STATSIG_OVERRIDES';
var $3b5d64a7da124292$var$LEGACY_LOCAL_STORAGE_KEY = 'STATSIG_JS_LITE_LOCAL_OVERRIDES';
var $3b5d64a7da124292$var$makeEmptyStore = function makeEmptyStore() {
    return {
        gates: {},
        configs: {},
        layers: {}
    };
};
var $3b5d64a7da124292$var$djb2MapKey = function djb2MapKey(hash, kind) {
    return kind + ':' + hash;
};
var $3b5d64a7da124292$export$bcb28fbac1def494 = /*#__PURE__*/ function() {
    function PersistentOverrideAdapter(localStorageKey) {
        (0, $cdRUW.default)(this, PersistentOverrideAdapter);
        this._overrides = $3b5d64a7da124292$var$makeEmptyStore();
        this._djb2Map = new Map();
        this._localStorageKey = localStorageKey;
    }
    return (0, $i1Bei.default)(PersistentOverrideAdapter, [
        {
            key: "parseStoredOverrides",
            value: function parseStoredOverrides(localStorageKey) {
                try {
                    var json = window.localStorage.getItem(localStorageKey);
                    if (!json) return $3b5d64a7da124292$var$makeEmptyStore();
                    return JSON.parse(json);
                } catch (_unused) {
                    return $3b5d64a7da124292$var$makeEmptyStore();
                }
            }
        },
        {
            key: "mergeOverrides",
            value: function mergeOverrides() {
                var merged = $3b5d64a7da124292$var$makeEmptyStore();
                for(var _len = arguments.length, allOverrides = new Array(_len), _key = 0; _key < _len; _key++)allOverrides[_key] = arguments[_key];
                for(var _i = 0, _allOverrides = allOverrides; _i < _allOverrides.length; _i++){
                    var overrides = _allOverrides[_i];
                    for(var _i2 = 0, _Object$entries = Object.entries((_overrides$gates = overrides.gates) !== null && _overrides$gates !== void 0 ? _overrides$gates : {}); _i2 < _Object$entries.length; _i2++){
                        var _overrides$gates;
                        var _Object$entries$_i = (0, $amAaq.default)(_Object$entries[_i2], 2), name = _Object$entries$_i[0], value = _Object$entries$_i[1];
                        merged.gates[name] = value;
                    }
                    for(var _i3 = 0, _Object$entries2 = Object.entries((_overrides$configs = overrides.configs) !== null && _overrides$configs !== void 0 ? _overrides$configs : {}); _i3 < _Object$entries2.length; _i3++){
                        var _overrides$configs;
                        var _Object$entries2$_i = (0, $amAaq.default)(_Object$entries2[_i3], 2), _name = _Object$entries2$_i[0], _value = _Object$entries2$_i[1];
                        merged.configs[_name] = _value;
                    }
                    for(var _i4 = 0, _Object$entries3 = Object.entries((_overrides$layers = overrides.layers) !== null && _overrides$layers !== void 0 ? _overrides$layers : {}); _i4 < _Object$entries3.length; _i4++){
                        var _overrides$layers;
                        var _Object$entries3$_i = (0, $amAaq.default)(_Object$entries3[_i4], 2), _name2 = _Object$entries3$_i[0], _value2 = _Object$entries3$_i[1];
                        merged.layers[_name2] = _value2;
                    }
                }
                return merged;
            }
        },
        {
            key: "initFromStoredOverrides",
            value: function initFromStoredOverrides() {
                var storedOverrides = this.mergeOverrides(this._overrides, this.parseStoredOverrides($3b5d64a7da124292$var$LEGACY_LOCAL_STORAGE_KEY), this.parseStoredOverrides(this._localStorageKey));
                // Clear data from legacy local storage key now we've read from it.
                // This prevents things being stuck in there that are always read but never written to.
                try {
                    window.localStorage.removeItem($3b5d64a7da124292$var$LEGACY_LOCAL_STORAGE_KEY);
                } catch (_unused2) {
                // ignored - window is not defined in non-browser environments, and we don't save things there
                // (things like SSR, etc)
                }
                // In version 4.24.0 we introduced hashes in this override adapter, but had a bug which would cause
                // multiple hashes to continue being created. This code here removes these hashes since we've moved
                // to using a more reliable and easier to maintain map in `_djb2Map`.
                for(var _i5 = 0, _Object$values = Object.values(storedOverrides); _i5 < _Object$values.length; _i5++){
                    var container = _Object$values[_i5];
                    var allKeys = new Set(Object.keys(container));
                    var _iterator = $3b5d64a7da124292$var$_createForOfIteratorHelper(allKeys), _step;
                    try {
                        for(_iterator.s(); !(_step = _iterator.n()).done;){
                            var name = _step.value;
                            var hash = (0, $dtn6l._DJB2)(name);
                            if (allKeys.has(hash)) delete container[hash];
                        }
                    } catch (err) {
                        _iterator.e(err);
                    } finally{
                        _iterator.f();
                    }
                }
                this.applyOverrides(storedOverrides);
            }
        },
        {
            key: "saveOverrides",
            value: function saveOverrides() {
                try {
                    window.localStorage.setItem(this._localStorageKey, JSON.stringify(this._overrides));
                } catch (_unused3) {
                // ignored - window is not defined in non-browser environments, and we don't save things there
                // (things like SSR, etc)
                }
            }
        },
        {
            key: "getOverrides",
            value: function getOverrides() {
                return this.mergeOverrides(this._overrides);
            }
        },
        {
            key: "applyOverrides",
            value: function applyOverrides(overrides) {
                var newOverrides = $3b5d64a7da124292$var$_objectSpread($3b5d64a7da124292$var$_objectSpread({}, $3b5d64a7da124292$var$makeEmptyStore()), overrides);
                this._djb2Map.clear();
                for(var _i6 = 0, _Object$entries4 = Object.entries(newOverrides); _i6 < _Object$entries4.length; _i6++){
                    var _Object$entries4$_i = (0, $amAaq.default)(_Object$entries4[_i6], 2), containerName = _Object$entries4$_i[0], container = _Object$entries4$_i[1];
                    for(var _i7 = 0, _Object$entries5 = Object.entries(container); _i7 < _Object$entries5.length; _i7++){
                        var _Object$entries5$_i = (0, $amAaq.default)(_Object$entries5[_i7], 2), name = _Object$entries5$_i[0], value = _Object$entries5$_i[1];
                        this._djb2Map.set($3b5d64a7da124292$var$djb2MapKey((0, $dtn6l._DJB2)(name), containerName), value);
                    }
                }
                this._overrides = newOverrides;
            }
        },
        {
            key: "setOverrides",
            value: function setOverrides(overrides) {
                this.applyOverrides(overrides);
                this.saveOverrides();
            }
        },
        {
            key: "overrideGate",
            value: function overrideGate(name, value) {
                this._overrides.gates[name] = value;
                this._djb2Map.set($3b5d64a7da124292$var$djb2MapKey((0, $dtn6l._DJB2)(name), 'gates'), value);
                this.saveOverrides();
            }
        },
        {
            key: "removeGateOverride",
            value: function removeGateOverride(name) {
                delete this._overrides.gates[name];
                this._djb2Map.delete($3b5d64a7da124292$var$djb2MapKey((0, $dtn6l._DJB2)(name), 'gates'));
                this.saveOverrides();
            }
        },
        {
            key: "getGateOverride",
            value: function getGateOverride(current, _user) {
                var _this$_overrides$gate;
                var overridden = (_this$_overrides$gate = this._overrides.gates[current.name]) !== null && _this$_overrides$gate !== void 0 ? _this$_overrides$gate : this._djb2Map.get($3b5d64a7da124292$var$djb2MapKey(current.name, 'gates'));
                if (overridden == null) return null;
                return $3b5d64a7da124292$var$_objectSpread($3b5d64a7da124292$var$_objectSpread({}, current), {}, {
                    value: overridden,
                    details: $3b5d64a7da124292$var$_objectSpread($3b5d64a7da124292$var$_objectSpread({}, current.details), {}, {
                        reason: $3b5d64a7da124292$var$LOCAL_OVERRIDE_REASON
                    })
                });
            }
        },
        {
            key: "overrideDynamicConfig",
            value: function overrideDynamicConfig(name, value) {
                this._overrides.configs[name] = value;
                this._djb2Map.set($3b5d64a7da124292$var$djb2MapKey((0, $dtn6l._DJB2)(name), 'configs'), value);
                this.saveOverrides();
            }
        },
        {
            key: "removeDynamicConfigOverride",
            value: function removeDynamicConfigOverride(name) {
                delete this._overrides.configs[name];
                this._djb2Map.delete($3b5d64a7da124292$var$djb2MapKey((0, $dtn6l._DJB2)(name), 'configs'));
                this.saveOverrides();
            }
        },
        {
            key: "getDynamicConfigOverride",
            value: function getDynamicConfigOverride(current, _user) {
                return this._getConfigOverride(current, this._overrides.configs);
            }
        },
        {
            key: "overrideExperiment",
            value: function overrideExperiment(name, value) {
                this._overrides.configs[name] = value;
                this._djb2Map.set($3b5d64a7da124292$var$djb2MapKey((0, $dtn6l._DJB2)(name), 'configs'), value);
                this.saveOverrides();
            }
        },
        {
            key: "removeExperimentOverride",
            value: function removeExperimentOverride(name) {
                delete this._overrides.configs[name];
                this._djb2Map.delete($3b5d64a7da124292$var$djb2MapKey((0, $dtn6l._DJB2)(name), 'configs'));
                this.saveOverrides();
            }
        },
        {
            key: "getExperimentOverride",
            value: function getExperimentOverride(current, _user) {
                return this._getConfigOverride(current, this._overrides.configs);
            }
        },
        {
            key: "overrideLayer",
            value: function overrideLayer(name, value) {
                this._overrides.layers[name] = value;
                this._djb2Map.set($3b5d64a7da124292$var$djb2MapKey((0, $dtn6l._DJB2)(name), 'layers'), value);
                this.saveOverrides();
            }
        },
        {
            key: "removeLayerOverride",
            value: function removeLayerOverride(name) {
                delete this._overrides.layers[name];
                this._djb2Map.delete($3b5d64a7da124292$var$djb2MapKey((0, $dtn6l._DJB2)(name), 'layers'));
                this.saveOverrides();
            }
        },
        {
            key: "removeAllOverrides",
            value: function removeAllOverrides() {
                this._overrides = $3b5d64a7da124292$var$makeEmptyStore();
                try {
                    window.localStorage.removeItem(this._localStorageKey);
                } catch (_unused4) {
                // ignored - window is not defined in non-browser environments, and we don't save things there
                // (things like SSR, etc)
                }
            }
        },
        {
            key: "getLayerOverride",
            value: function getLayerOverride(current, _user) {
                var _this$_overrides$laye;
                var overridden = (_this$_overrides$laye = this._overrides.layers[current.name]) !== null && _this$_overrides$laye !== void 0 ? _this$_overrides$laye : this._djb2Map.get($3b5d64a7da124292$var$djb2MapKey(current.name, 'layers'));
                if (overridden == null) return null;
                return $3b5d64a7da124292$var$_objectSpread($3b5d64a7da124292$var$_objectSpread({}, current), {}, {
                    __value: overridden,
                    get: (0, $dtn6l._makeTypedGet)(current.name, overridden),
                    details: $3b5d64a7da124292$var$_objectSpread($3b5d64a7da124292$var$_objectSpread({}, current.details), {}, {
                        reason: $3b5d64a7da124292$var$LOCAL_OVERRIDE_REASON
                    })
                });
            }
        },
        {
            key: "_getConfigOverride",
            value: function _getConfigOverride(current, lookup) {
                var _lookup$current$name;
                var overridden = (_lookup$current$name = lookup[current.name]) !== null && _lookup$current$name !== void 0 ? _lookup$current$name : this._djb2Map.get($3b5d64a7da124292$var$djb2MapKey(current.name, 'configs'));
                if (overridden == null) return null;
                return $3b5d64a7da124292$var$_objectSpread($3b5d64a7da124292$var$_objectSpread({}, current), {}, {
                    value: overridden,
                    get: (0, $dtn6l._makeTypedGet)(current.name, overridden),
                    details: $3b5d64a7da124292$var$_objectSpread($3b5d64a7da124292$var$_objectSpread({}, current.details), {}, {
                        reason: $3b5d64a7da124292$var$LOCAL_OVERRIDE_REASON
                    })
                });
            }
        }
    ]);
}();

});



parcelRegister("5DfHM", function(module, exports) {
$parcel$export(module.exports, "debug", () => $419cc6f83f02d683$export$1c9f709888824e05);
var $419cc6f83f02d683$var$_process, $419cc6f83f02d683$var$_process2;
// We can't rely on NODE_ENV === 'test' if its value is already configured by the consumer to some other value, so better to use JEST_WORKER_ID
// https://jestjs.io/docs/environment-variables#jest_worker_id
var $419cc6f83f02d683$var$TESTS_MODE = (globalThis === null || globalThis === void 0 || ($419cc6f83f02d683$var$_process = globalThis.process) === null || $419cc6f83f02d683$var$_process === void 0 || ($419cc6f83f02d683$var$_process = $419cc6f83f02d683$var$_process.env) === null || $419cc6f83f02d683$var$_process === void 0 ? void 0 : $419cc6f83f02d683$var$_process.JEST_WORKER_ID) !== undefined;
var $419cc6f83f02d683$var$DEBUG_MODE = !$419cc6f83f02d683$var$TESTS_MODE && (globalThis === null || globalThis === void 0 || ($419cc6f83f02d683$var$_process2 = globalThis.process) === null || $419cc6f83f02d683$var$_process2 === void 0 || ($419cc6f83f02d683$var$_process2 = $419cc6f83f02d683$var$_process2.env) === null || $419cc6f83f02d683$var$_process2 === void 0 ? void 0 : $419cc6f83f02d683$var$_process2.NODE_ENV) !== 'production';
var $419cc6f83f02d683$export$1c9f709888824e05 = function debug() {
    var _console;
    if (!$419cc6f83f02d683$var$DEBUG_MODE) return;
    // eslint-disable-next-line no-console
    (_console = console).debug.apply(_console, arguments);
};

});




parcelRegister("dNpMm", function(module, exports) {
$parcel$export(module.exports, "hash", () => $02978bc2a41e59ba$export$d6af199866bfb566);
var $02978bc2a41e59ba$export$d6af199866bfb566 = function hash(str) {
    var hash = 0;
    for(var i = 0; i < str.length; i++){
        var char = str.charCodeAt(i);
        hash = (hash << 5) - hash + char;
        hash &= hash; // Convert to 32bit integer
    }
    return new Uint32Array([
        hash
    ])[0].toString(36);
};

});

parcelRegister("axgie", function(module, exports) {

var $iKwew = parcelRequire("iKwew");
module.exports = $iKwew("95zrG").then(()=>parcelRequire('5pKIL'));

});

parcelRegister("g9rJF", function(module, exports) {

var $iKwew = parcelRequire("iKwew");
module.exports = $iKwew("2yJgD").then(()=>parcelRequire('jiKmE'));

});

parcelRegister("kT0v0", function(module, exports) {

var $iKwew = parcelRequire("iKwew");
module.exports = $iKwew("4nMLY").then(()=>parcelRequire('6g20Z'));

});

parcelRegister("4AHXc", function(module, exports) {

var $iKwew = parcelRequire("iKwew");
module.exports = $iKwew("5Yl25").then(()=>parcelRequire('5MGrN'));

});

parcelRegister("2WA54", function(module, exports) {

var $iKwew = parcelRequire("iKwew");
module.exports = $iKwew("aYv8w").then(()=>parcelRequire('cRLDQ'));

});

parcelRegister("mQdOo", function(module, exports) {

var $iKwew = parcelRequire("iKwew");
module.exports = $iKwew("eEX3a").then(()=>parcelRequire('cqRdD'));

});

parcelRegister("hWclh", function(module, exports) {

var $iKwew = parcelRequire("iKwew");
module.exports = $iKwew("6wfyj").then(()=>parcelRequire('aSyNC'));

});

parcelRegister("e7KbB", function(module, exports) {

var $iKwew = parcelRequire("iKwew");
module.exports = $iKwew("6OEgb").then(()=>parcelRequire('L74os'));

});

parcelRegister("cc6bl", function(module, exports) {

var $iKwew = parcelRequire("iKwew");
module.exports = $iKwew("8XdcR").then(()=>parcelRequire('bnCw4'));

});

parcelRegister("lEhau", function(module, exports) {

var $iKwew = parcelRequire("iKwew");
module.exports = $iKwew("jYnP7").then(()=>parcelRequire('dksAb'));

});

parcelRegister("k181C", function(module, exports) {

var $iKwew = parcelRequire("iKwew");
module.exports = $iKwew("h1k07").then(()=>parcelRequire('97Tcq'));

});

parcelRegister("8HikK", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => (parcelRequire("l7JtJ")).default);
$parcel$export(module.exports, "Icon", () => (parcelRequire("l7JtJ")).Icon);
/**
 * @deprecated Import from the generated per-export subpath instead.
 */ 
var $l7JtJ = parcelRequire("l7JtJ");
 /**
 * @deprecated Import from the generated per-export subpath instead.
 */ 
});
parcelRegister("l7JtJ", function(module, exports) {
$parcel$export(module.exports, "Icon", () => $f60d87875c3cfddc$export$f04a61298a47a40f);
$parcel$export(module.exports, "default", () => $f60d87875c3cfddc$export$2e2bcd8739ae039);
/* icon-new.tsx generated by @compiled/babel-plugin v0.40.0 */ 
var $5FkrB = parcelRequire("5FkrB");

var $gKzKW = parcelRequire("gKzKW");
/**
 * We are hiding this props from consumers as it's reserved for use by Icon Tile.
 */ var $f60d87875c3cfddc$var$svgStyles = null;
var $f60d87875c3cfddc$var$iconStyles = null;
var $f60d87875c3cfddc$var$smallIconStyles = null;
var $f60d87875c3cfddc$var$scaleStyles = null;
/**
 * For windows high contrast mode
 */ var $f60d87875c3cfddc$var$baseHcmStyles = null;
var $f60d87875c3cfddc$var$scaleSize = null;
var $f60d87875c3cfddc$var$coreSizeMedium = {
    none: "_1bsbpxbi _4t3ipxbi",
    compact: "_1bsb1ejb _4t3i1ejb",
    spacious: "_1bsb1ejb _4t3i1ejb"
};
var $f60d87875c3cfddc$var$coreSizeSmall = {
    none: "_1bsbutpp _4t3iutpp",
    compact: "_1bsbpxbi _4t3ipxbi",
    spacious: "_1bsb1ejb _4t3i1ejb"
};
var $f60d87875c3cfddc$var$paddingMap = {
    medium: {
        none: 0,
        compact: 4,
        spacious: 4
    },
    small: {
        none: 0,
        compact: 2.66,
        spacious: 8
    }
};
var $f60d87875c3cfddc$export$f04a61298a47a40f = /*#__PURE__*/ (0, $5FkrB.memo)(function Icon(props) {
    var _ref = props, _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, testId = _ref.testId, label = _ref.label, dangerouslySetGlyph = _ref.dangerouslySetGlyph, shouldScale = _ref.shouldScale, _ref$spacing = _ref.spacing, spacing = _ref$spacing === void 0 ? 'none' : _ref$spacing, name = _ref.name;
    var dangerouslySetInnerHTML = dangerouslySetGlyph ? {
        __html: dangerouslySetGlyph
    } : undefined;
    var size = 'medium';
    if ('size' in props && props.size !== undefined) {
        if (typeof props.size === 'string') size = props.size === 'small' || props.size === 'medium' ? props.size : size;
        else if (name) {
            var newSize = props.size(name);
            size = newSize === 'small' || newSize === 'medium' ? newSize : size;
        }
    }
    var baseSize = 16;
    var viewBoxPadding = $f60d87875c3cfddc$var$paddingMap[size][spacing];
    var viewBoxSize = baseSize + 2 * viewBoxPadding;
    return /*#__PURE__*/ $5FkrB.createElement("span", {
        "data-testid": testId,
        role: label ? 'img' : undefined,
        "aria-label": label ? label : undefined,
        "aria-hidden": label ? undefined : true,
        style: {
            color: color
        },
        className: (0, $gKzKW.default)([
            "_1e0c1o8l _vchhusvi _1o9zidpf _vwz4kb7n _y4ti1igz _bozg1mb9",
            "_12va1onz _jcxd1r8n",
            shouldScale && "_1bsb1kw7 _4t3i1kw7",
            size === 'small' && "_vwz4utpp"
        ])
    }, /*#__PURE__*/ $5FkrB.createElement("svg", {
        fill: "none",
        viewBox: "".concat(0 - viewBoxPadding, " ").concat(0 - viewBoxPadding, " ").concat(viewBoxSize, " ").concat(viewBoxSize),
        role: "presentation",
        dangerouslySetInnerHTML: dangerouslySetInnerHTML,
        className: (0, $gKzKW.default)([
            "_1reo15vq _18m915vq _syaz1r31 _lcxvglyw _s7n4yfq0 _vc881r31",
            shouldScale ? "_1bsb1kw7 _4t3i1kw7" : size === 'small' ? $f60d87875c3cfddc$var$coreSizeSmall[spacing] : $f60d87875c3cfddc$var$coreSizeMedium[spacing]
        ])
    }));
});
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$f60d87875c3cfddc$export$2e2bcd8739ae039 = $f60d87875c3cfddc$export$f04a61298a47a40f;

});
parcelRegister("gKzKW", function(module, exports) {
$parcel$export(module.exports, "default", () => $03259fb42017096f$export$2e2bcd8739ae039);
/**
 * The length of the value hash portion of an atomic class name.
 * Atomic class names have the format: `_<group><value>`
 * where group is ATOMIC_GROUP_HASH_LENGTH chars and value is ATOMIC_VALUE_HASH_LENGTH chars.
 *
 * We extract the group key using: `className.slice(0, className.length - ATOMIC_VALUE_HASH_LENGTH)`
 *
 * We support both old-format classes (9 chars: `_` + 4 group + 4 value) and
 * new-format classes (11 chars: `_` + 6 group + 4 value) by using length-based
 * extraction rather than a hardcoded offset — old and new format group keys
 * are different lengths so they are structurally disjoint and never alias each other.
 */ const $03259fb42017096f$var$ATOMIC_VALUE_HASH_LENGTH = 4;
function $03259fb42017096f$export$2e2bcd8739ae039(classNames) {
    // Shortcut: nothing to do
    if (!classNames.length) return;
    // Shortcut: don't need to do anything if we only have a single classname
    if (classNames.length === 1 && classNames[0] && // checking to see if `classNames[0]` is a string that contains other classnames
    !classNames[0].includes(' ')) return classNames[0];
    // Using an object rather than a `Map` as it performed better in our benchmarks.
    // Would be happy to move to `Map` if it proved to be better under real conditions.
    const map = {};
    // Note: using loops to minimize iterations over the collection
    for (const value of classNames){
        // Exclude all falsy values, which leaves us with populated strings
        if (!value) continue;
        // a `value` can contain multiple classnames
        const list = value.split(' ');
        for (const className of list){
            /**
             * For atomic style classnames: the `key` is the `group`
             *
             * - Later atomic classnames with the same `group` will override earlier ones
             *   (which is what we want).
             * - Assumes atomic classnames are the only things that start with `_`
             * - Could use a regex to ensure that atomic classnames are structured how we expect,
             *   but did not add that for now as it did slow things down a bit.
             *
             * For other classnames: the `key` is the whole classname
             * - Okay to remove duplicates as doing so does not impact specificity
             *
             * */ const key = className.startsWith('_') ? className.slice(0, className.length - $03259fb42017096f$var$ATOMIC_VALUE_HASH_LENGTH) : className;
            map[key] = className;
        }
    }
    /**
     * We are converting the `map` into a string.
     *
     * The simple way to do this would be `Object.values(map).join(' ')`.
     * However, the approach below performs 10%-20% better in benchmarks.
     *
     * For `ax()` it feels right to squeeze as much runtime performance out as we can.
     */ let result = '';
    for(const key in map)result += map[key] + ' ';
    // If we have an empty string, then our `map` was empty.
    if (!result) return;
    // remove last " " from the result (we added " " at the end of every value)
    return result.trimEnd();
}

});



parcelRegister("6qJuP", function(module, exports) {

var $j5xrf = parcelRequire("j5xrf");
var $4ae8765e8e1ed7f7$var$_typeof = $j5xrf.default;
function $4ae8765e8e1ed7f7$var$_regeneratorRuntime() {
    "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ 
    module.exports = $4ae8765e8e1ed7f7$var$_regeneratorRuntime = function _regeneratorRuntime() {
        return e;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports;
    var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function(t, e, r) {
        t[e] = r.value;
    }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag";
    function define(t, e, r) {
        return Object.defineProperty(t, e, {
            value: r,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }), t[e];
    }
    try {
        define({}, "");
    } catch (t) {
        define = function define(t, e, r) {
            return t[e] = r;
        };
    }
    function wrap(t, e, r, n) {
        var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []);
        return o(a, "_invoke", {
            value: makeInvokeMethod(t, r, c)
        }), a;
    }
    function tryCatch(t, e, r) {
        try {
            return {
                type: "normal",
                arg: t.call(e, r)
            };
        } catch (t) {
            return {
                type: "throw",
                arg: t
            };
        }
    }
    e.wrap = wrap;
    var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {};
    function Generator() {}
    function GeneratorFunction() {}
    function GeneratorFunctionPrototype() {}
    var p = {};
    define(p, a, function() {
        return this;
    });
    var d = Object.getPrototypeOf, v = d && d(d(values([])));
    v && v !== r && n.call(v, a) && (p = v);
    var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p);
    function defineIteratorMethods(t) {
        [
            "next",
            "throw",
            "return"
        ].forEach(function(e) {
            define(t, e, function(t) {
                return this._invoke(e, t);
            });
        });
    }
    function AsyncIterator(t, e) {
        function invoke(r, o, i, a) {
            var c = tryCatch(t[r], t, o);
            if ("throw" !== c.type) {
                var u = c.arg, h = u.value;
                return h && "object" == $4ae8765e8e1ed7f7$var$_typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function(t) {
                    invoke("next", t, i, a);
                }, function(t) {
                    invoke("throw", t, i, a);
                }) : e.resolve(h).then(function(t) {
                    u.value = t, i(u);
                }, function(t) {
                    return invoke("throw", t, i, a);
                });
            }
            a(c.arg);
        }
        var r;
        o(this, "_invoke", {
            value: function value(t, n) {
                function callInvokeWithMethodAndArg() {
                    return new e(function(e, r) {
                        invoke(t, n, e, r);
                    });
                }
                return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
            }
        });
    }
    function makeInvokeMethod(e, r, n) {
        var o = h;
        return function(i, a) {
            if (o === f) throw Error("Generator is already running");
            if (o === s) {
                if ("throw" === i) throw a;
                return {
                    value: t,
                    done: !0
                };
            }
            for(n.method = i, n.arg = a;;){
                var c = n.delegate;
                if (c) {
                    var u = maybeInvokeDelegate(c, n);
                    if (u) {
                        if (u === y) continue;
                        return u;
                    }
                }
                if ("next" === n.method) n.sent = n._sent = n.arg;
                else if ("throw" === n.method) {
                    if (o === h) throw o = s, n.arg;
                    n.dispatchException(n.arg);
                } else "return" === n.method && n.abrupt("return", n.arg);
                o = f;
                var p = tryCatch(e, r, n);
                if ("normal" === p.type) {
                    if (o = n.done ? s : l, p.arg === y) continue;
                    return {
                        value: p.arg,
                        done: n.done
                    };
                }
                "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg);
            }
        };
    }
    function maybeInvokeDelegate(e, r) {
        var n = r.method, o = e.iterator[n];
        if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y;
        var i = tryCatch(o, e.iterator, r.arg);
        if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y;
        var a = i.arg;
        return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y);
    }
    function pushTryEntry(t) {
        var e = {
            tryLoc: t[0]
        };
        1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e);
    }
    function resetTryEntry(t) {
        var e = t.completion || {};
        e.type = "normal", delete e.arg, t.completion = e;
    }
    function Context(t) {
        this.tryEntries = [
            {
                tryLoc: "root"
            }
        ], t.forEach(pushTryEntry, this), this.reset(!0);
    }
    function values(e) {
        if (e || "" === e) {
            var r = e[a];
            if (r) return r.call(e);
            if ("function" == typeof e.next) return e;
            if (!isNaN(e.length)) {
                var o = -1, i = function next() {
                    for(; ++o < e.length;)if (n.call(e, o)) return next.value = e[o], next.done = !1, next;
                    return next.value = t, next.done = !0, next;
                };
                return i.next = i;
            }
        }
        throw new TypeError($4ae8765e8e1ed7f7$var$_typeof(e) + " is not iterable");
    }
    return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", {
        value: GeneratorFunctionPrototype,
        configurable: !0
    }), o(GeneratorFunctionPrototype, "constructor", {
        value: GeneratorFunction,
        configurable: !0
    }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function(t) {
        var e = "function" == typeof t && t.constructor;
        return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name));
    }, e.mark = function(t) {
        return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t;
    }, e.awrap = function(t) {
        return {
            __await: t
        };
    }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function() {
        return this;
    }), e.AsyncIterator = AsyncIterator, e.async = function(t, r, n, o, i) {
        void 0 === i && (i = Promise);
        var a = new AsyncIterator(wrap(t, r, n, o), i);
        return e.isGeneratorFunction(r) ? a : a.next().then(function(t) {
            return t.done ? t.value : a.next();
        });
    }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function() {
        return this;
    }), define(g, "toString", function() {
        return "[object Generator]";
    }), e.keys = function(t) {
        var e = Object(t), r = [];
        for(var n in e)r.push(n);
        return r.reverse(), function next() {
            for(; r.length;){
                var t = r.pop();
                if (t in e) return next.value = t, next.done = !1, next;
            }
            return next.done = !0, next;
        };
    }, e.values = values, Context.prototype = {
        constructor: Context,
        reset: function reset(e) {
            if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for(var r in this)"t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t);
        },
        stop: function stop() {
            this.done = !0;
            var t = this.tryEntries[0].completion;
            if ("throw" === t.type) throw t.arg;
            return this.rval;
        },
        dispatchException: function dispatchException(e) {
            if (this.done) throw e;
            var r = this;
            function handle(n, o) {
                return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o;
            }
            for(var o = this.tryEntries.length - 1; o >= 0; --o){
                var i = this.tryEntries[o], a = i.completion;
                if ("root" === i.tryLoc) return handle("end");
                if (i.tryLoc <= this.prev) {
                    var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc");
                    if (c && u) {
                        if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
                        if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
                    } else if (c) {
                        if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
                    } else {
                        if (!u) throw Error("try statement without catch or finally");
                        if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
                    }
                }
            }
        },
        abrupt: function abrupt(t, e) {
            for(var r = this.tryEntries.length - 1; r >= 0; --r){
                var o = this.tryEntries[r];
                if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
                    var i = o;
                    break;
                }
            }
            i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null);
            var a = i ? i.completion : {};
            return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a);
        },
        complete: function complete(t, e) {
            if ("throw" === t.type) throw t.arg;
            return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y;
        },
        finish: function finish(t) {
            for(var e = this.tryEntries.length - 1; e >= 0; --e){
                var r = this.tryEntries[e];
                if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y;
            }
        },
        "catch": function _catch(t) {
            for(var e = this.tryEntries.length - 1; e >= 0; --e){
                var r = this.tryEntries[e];
                if (r.tryLoc === t) {
                    var n = r.completion;
                    if ("throw" === n.type) {
                        var o = n.arg;
                        resetTryEntry(r);
                    }
                    return o;
                }
            }
            throw Error("illegal catch attempt");
        },
        delegateYield: function delegateYield(e, r, n) {
            return this.delegate = {
                iterator: values(e),
                resultName: r,
                nextLoc: n
            }, "next" === this.method && (this.arg = t), y;
        }
    }, e;
}
module.exports = $4ae8765e8e1ed7f7$var$_regeneratorRuntime, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("j5xrf", function(module, exports) {
function $de586c24f3af541b$var$_typeof(o) {
    "@babel/helpers - typeof";
    return module.exports = $de586c24f3af541b$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $de586c24f3af541b$var$_typeof(o);
}
module.exports = $de586c24f3af541b$var$_typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("iT3Yw", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => (parcelRequire("5eS4t")).default);
$parcel$export(module.exports, "Icon", () => (parcelRequire("5eS4t")).Icon);

var $5eS4t = parcelRequire("5eS4t");

});
parcelRegister("5eS4t", function(module, exports) {
$parcel$export(module.exports, "Icon", () => $3d0833fcb2525383$export$f04a61298a47a40f);
$parcel$export(module.exports, "default", () => $3d0833fcb2525383$export$2e2bcd8739ae039);
/* icon-new.tsx generated by @compiled/babel-plugin v0.40.0 */ 
var $5FkrB = parcelRequire("5FkrB");

var $a7T2h = parcelRequire("a7T2h");
/**
 * We are hiding this props from consumers as it's reserved for use by Icon Tile.
 */ var $3d0833fcb2525383$var$svgStyles = null;
var $3d0833fcb2525383$var$iconStyles = null;
var $3d0833fcb2525383$var$smallIconStyles = null;
var $3d0833fcb2525383$var$scaleStyles = null;
/**
 * For windows high contrast mode
 */ var $3d0833fcb2525383$var$baseHcmStyles = null;
var $3d0833fcb2525383$var$scaleSize = null;
var $3d0833fcb2525383$var$coreSizeMedium = {
    none: "_1bsbpxbi _4t3ipxbi",
    compact: "_1bsb1ejb _4t3i1ejb",
    spacious: "_1bsb1ejb _4t3i1ejb"
};
var $3d0833fcb2525383$var$coreSizeSmall = {
    none: "_1bsbutpp _4t3iutpp",
    compact: "_1bsbpxbi _4t3ipxbi",
    spacious: "_1bsb1ejb _4t3i1ejb"
};
var $3d0833fcb2525383$var$paddingMap = {
    medium: {
        none: 0,
        compact: 4,
        spacious: 4
    },
    small: {
        none: 0,
        compact: 2.66,
        spacious: 8
    }
};
var $3d0833fcb2525383$export$f04a61298a47a40f = /*#__PURE__*/ (0, $5FkrB.memo)(function Icon(props) {
    var _ref = props, _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, testId = _ref.testId, label = _ref.label, dangerouslySetGlyph = _ref.dangerouslySetGlyph, shouldScale = _ref.shouldScale, _ref$spacing = _ref.spacing, spacing = _ref$spacing === void 0 ? 'none' : _ref$spacing, name = _ref.name;
    var dangerouslySetInnerHTML = dangerouslySetGlyph ? {
        __html: dangerouslySetGlyph
    } : undefined;
    var size = 'medium';
    if ('size' in props && props.size !== undefined) {
        if (typeof props.size === 'string') size = props.size === 'small' || props.size === 'medium' ? props.size : size;
        else if (name) {
            var newSize = props.size(name);
            size = newSize === 'small' || newSize === 'medium' ? newSize : size;
        }
    }
    var baseSize = 16;
    var viewBoxPadding = $3d0833fcb2525383$var$paddingMap[size][spacing];
    var viewBoxSize = baseSize + 2 * viewBoxPadding;
    return /*#__PURE__*/ $5FkrB.createElement("span", {
        "data-testid": testId,
        role: label ? 'img' : undefined,
        "aria-label": label ? label : undefined,
        "aria-hidden": label ? undefined : true,
        style: {
            color: color
        },
        className: (0, $a7T2h.default)([
            "_1e0c1o8l _vchhusvi _1o9zidpf _vwz4kb7n _y4ti1igz _bozg1mb9",
            "_12va1onz _jcxd1r8n",
            shouldScale && "_1bsb1kw7 _4t3i1kw7",
            size === 'small' && "_vwz4utpp"
        ])
    }, /*#__PURE__*/ $5FkrB.createElement("svg", {
        fill: "none",
        viewBox: "".concat(0 - viewBoxPadding, " ").concat(0 - viewBoxPadding, " ").concat(viewBoxSize, " ").concat(viewBoxSize),
        role: "presentation",
        dangerouslySetInnerHTML: dangerouslySetInnerHTML,
        className: (0, $a7T2h.default)([
            "_1reo15vq _18m915vq _syaz1r31 _lcxvglyw _s7n4yfq0 _vc881r31",
            shouldScale ? "_1bsb1kw7 _4t3i1kw7" : size === 'small' ? $3d0833fcb2525383$var$coreSizeSmall[spacing] : $3d0833fcb2525383$var$coreSizeMedium[spacing]
        ])
    }));
});
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$3d0833fcb2525383$export$2e2bcd8739ae039 = $3d0833fcb2525383$export$f04a61298a47a40f;

});
parcelRegister("a7T2h", function(module, exports) {
$parcel$export(module.exports, "default", () => $75f53fc60b576dd2$export$2e2bcd8739ae039);
/**
 * This length includes the underscore,
 * e.g. `"_1s4A"` would be a valid atomic group hash.
 */ const $75f53fc60b576dd2$var$ATOMIC_GROUP_LENGTH = 5;
function $75f53fc60b576dd2$export$2e2bcd8739ae039(classNames) {
    // Shortcut: nothing to do
    if (!classNames.length) return;
    // Shortcut: don't need to do anything if we only have a single classname
    if (classNames.length === 1 && classNames[0] && // checking to see if `classNames[0]` is a string that contains other classnames
    !classNames[0].includes(' ')) return classNames[0];
    // Using an object rather than a `Map` as it performed better in our benchmarks.
    // Would be happy to move to `Map` if it proved to be better under real conditions.
    const map = {};
    // Note: using loops to minimize iterations over the collection
    for (const value of classNames){
        // Exclude all falsy values, which leaves us with populated strings
        if (!value) continue;
        // a `value` can contain multiple classnames
        const list = value.split(' ');
        for (const className of list){
            /**
             * For atomic style classnames: the `key` is the `group`
             *
             * - Later atomic classnames with the same `group` will override earlier ones
             *   (which is what we want).
             * - Assumes atomic classnames are the only things that start with `_`
             * - Could use a regex to ensure that atomic classnames are structured how we expect,
             *   but did not add that for now as it did slow things down a bit.
             *
             * For other classnames: the `key` is the whole classname
             * - Okay to remove duplicates as doing so does not impact specificity
             *
             * */ const key = className.startsWith('_') ? className.slice(0, $75f53fc60b576dd2$var$ATOMIC_GROUP_LENGTH) : className;
            map[key] = className;
        }
    }
    /**
     * We are converting the `map` into a string.
     *
     * The simple way to do this would be `Object.values(map).join(' ')`.
     * However, the approach below performs 10%-20% better in benchmarks.
     *
     * For `ax()` it feels right to squeeze as much runtime performance out as we can.
     */ let result = '';
    for(const key in map)result += map[key] + ' ';
    // If we have an empty string, then our `map` was empty.
    if (!result) return;
    // remove last " " from the result (we added " " at the end of every value)
    return result.trimEnd();
}

});



parcelRegister("kWLEF", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => (parcelRequire("izWaI")).default);
$parcel$export(module.exports, "Icon", () => (parcelRequire("izWaI")).Icon);
/**
 * @deprecated Import from the generated per-export subpath instead.
 */ 
var $izWaI = parcelRequire("izWaI");
 /**
 * @deprecated Import from the generated per-export subpath instead.
 */ 
});
parcelRegister("izWaI", function(module, exports) {
$parcel$export(module.exports, "Icon", () => $d8689e95bc2df99d$export$f04a61298a47a40f);
$parcel$export(module.exports, "default", () => $d8689e95bc2df99d$export$2e2bcd8739ae039);
/* icon-new.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $5FkrB = parcelRequire("5FkrB");

var $bwjNt = parcelRequire("bwjNt");
/**
 * We are hiding this props from consumers as it's reserved for use by Icon Tile.
 */ var $d8689e95bc2df99d$var$svgStyles = null;
var $d8689e95bc2df99d$var$iconStyles = null;
var $d8689e95bc2df99d$var$smallIconStyles = null;
var $d8689e95bc2df99d$var$scaleStyles = null;
/**
 * For windows high contrast mode
 */ var $d8689e95bc2df99d$var$baseHcmStyles = null;
var $d8689e95bc2df99d$var$scaleSize = null;
var $d8689e95bc2df99d$var$coreSizeMedium = {
    none: "_1bsbpxbi _4t3ipxbi",
    compact: "_1bsb1ejb _4t3i1ejb",
    spacious: "_1bsb1ejb _4t3i1ejb"
};
var $d8689e95bc2df99d$var$coreSizeSmall = {
    none: "_1bsbutpp _4t3iutpp",
    compact: "_1bsbpxbi _4t3ipxbi",
    spacious: "_1bsb1ejb _4t3i1ejb"
};
var $d8689e95bc2df99d$var$paddingMap = {
    medium: {
        none: 0,
        compact: 4,
        spacious: 4
    },
    small: {
        none: 0,
        compact: 2.66,
        spacious: 8
    }
};
var $d8689e95bc2df99d$export$f04a61298a47a40f = /*#__PURE__*/ (0, $5FkrB.memo)(function Icon(props) {
    var _ref = props, _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, testId = _ref.testId, label = _ref.label, dangerouslySetGlyph = _ref.dangerouslySetGlyph, shouldScale = _ref.shouldScale, _ref$spacing = _ref.spacing, spacing = _ref$spacing === void 0 ? 'none' : _ref$spacing, name = _ref.name;
    var dangerouslySetInnerHTML = dangerouslySetGlyph ? {
        __html: dangerouslySetGlyph
    } : undefined;
    var size = 'medium';
    if ('size' in props && props.size !== undefined) {
        if (typeof props.size === 'string') size = props.size === 'small' || props.size === 'medium' ? props.size : size;
        else if (name) {
            var newSize = props.size(name);
            size = newSize === 'small' || newSize === 'medium' ? newSize : size;
        }
    }
    var baseSize = 16;
    var viewBoxPadding = $d8689e95bc2df99d$var$paddingMap[size][spacing];
    var viewBoxSize = baseSize + 2 * viewBoxPadding;
    return /*#__PURE__*/ $5FkrB.createElement("span", {
        "data-testid": testId,
        role: label ? 'img' : undefined,
        "aria-label": label ? label : undefined,
        "aria-hidden": label ? undefined : true,
        style: {
            color: color
        },
        className: (0, $bwjNt.default)([
            "_1e0c1o8l _vchhusvi _1o9zidpf _vwz4kb7n _y4ti1igz _bozg1mb9",
            "_12va1onz _jcxd1r8n",
            shouldScale && "_1bsb1kw7 _4t3i1kw7",
            size === 'small' && "_vwz4utpp"
        ])
    }, /*#__PURE__*/ $5FkrB.createElement("svg", {
        fill: "none",
        viewBox: "".concat(0 - viewBoxPadding, " ").concat(0 - viewBoxPadding, " ").concat(viewBoxSize, " ").concat(viewBoxSize),
        role: "presentation",
        dangerouslySetInnerHTML: dangerouslySetInnerHTML,
        className: (0, $bwjNt.default)([
            "_1reo15vq _18m915vq _syaz1r31 _lcxvglyw _s7n4yfq0 _vc881r31",
            shouldScale ? "_1bsb1kw7 _4t3i1kw7" : size === 'small' ? $d8689e95bc2df99d$var$coreSizeSmall[spacing] : $d8689e95bc2df99d$var$coreSizeMedium[spacing]
        ])
    }));
});
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$d8689e95bc2df99d$export$2e2bcd8739ae039 = $d8689e95bc2df99d$export$f04a61298a47a40f;

});
parcelRegister("bwjNt", function(module, exports) {
$parcel$export(module.exports, "default", () => $86320a214c09d6a8$export$2e2bcd8739ae039);
/**
 * The length of the value hash portion of an atomic class name.
 * Atomic class names have the format: `_<group><value>`
 * where group is ATOMIC_GROUP_HASH_LENGTH chars and value is ATOMIC_VALUE_HASH_LENGTH chars.
 *
 * We extract the group key using: `className.slice(0, className.length - ATOMIC_VALUE_HASH_LENGTH)`
 *
 * We support both old-format classes (9 chars: `_` + 4 group + 4 value) and
 * new-format classes (11 chars: `_` + 6 group + 4 value) by using length-based
 * extraction rather than a hardcoded offset — old and new format group keys
 * are different lengths so they are structurally disjoint and never alias each other.
 */ const $86320a214c09d6a8$var$ATOMIC_VALUE_HASH_LENGTH = 4;
function $86320a214c09d6a8$export$2e2bcd8739ae039(classNames) {
    // Shortcut: nothing to do
    if (!classNames.length) return;
    // Shortcut: don't need to do anything if we only have a single classname
    if (classNames.length === 1 && classNames[0] && // checking to see if `classNames[0]` is a string that contains other classnames
    !classNames[0].includes(' ')) return classNames[0];
    // Using an object rather than a `Map` as it performed better in our benchmarks.
    // Would be happy to move to `Map` if it proved to be better under real conditions.
    const map = {};
    // Note: using loops to minimize iterations over the collection
    for (const value of classNames){
        // Exclude all falsy values, which leaves us with populated strings
        if (!value) continue;
        // a `value` can contain multiple classnames
        const list = value.split(' ');
        for (const className of list){
            /**
             * For atomic style classnames: the `key` is the `group`
             *
             * - Later atomic classnames with the same `group` will override earlier ones
             *   (which is what we want).
             * - Assumes atomic classnames are the only things that start with `_`
             * - Could use a regex to ensure that atomic classnames are structured how we expect,
             *   but did not add that for now as it did slow things down a bit.
             *
             * For other classnames: the `key` is the whole classname
             * - Okay to remove duplicates as doing so does not impact specificity
             *
             * */ const key = className.startsWith('_') ? className.slice(0, className.length - $86320a214c09d6a8$var$ATOMIC_VALUE_HASH_LENGTH) : className;
            map[key] = className;
        }
    }
    /**
     * We are converting the `map` into a string.
     *
     * The simple way to do this would be `Object.values(map).join(' ')`.
     * However, the approach below performs 10%-20% better in benchmarks.
     *
     * For `ax()` it feels right to squeeze as much runtime performance out as we can.
     */ let result = '';
    for(const key in map)result += map[key] + ' ';
    // If we have an empty string, then our `map` was empty.
    if (!result) return;
    // remove last " " from the result (we added " " at the end of every value)
    return result.trimEnd();
}

});



parcelRegister("c4Up0", function(module, exports) {
"use strict";
var $8cb19c1afc4eedec$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.useExperimentValue = module.exports.useFeatureGate = void 0;

var $5FkrB = parcelRequire("5FkrB");

const $8cb19c1afc4eedec$var$feature_gate_js_client_1 = $8cb19c1afc4eedec$var$__importDefault((parcelRequire("jcX3Q")));
const $8cb19c1afc4eedec$var$useFeatureGate = (gateName, options = {})=>{
    const [gate, setGate] = (0, $5FkrB.useState)(()=>$8cb19c1afc4eedec$var$feature_gate_js_client_1.default.checkGate(gateName, options));
    (0, $5FkrB.useEffect)(()=>{
        const onGateChange = (newValue)=>setGate(newValue);
        return $8cb19c1afc4eedec$var$feature_gate_js_client_1.default.onGateUpdated(gateName, onGateChange, options);
    }, [
        gateName,
        options
    ]);
    return gate;
};
module.exports.useFeatureGate = $8cb19c1afc4eedec$var$useFeatureGate;
// eslint-disable-next-line @typescript-eslint/no-unnecessary-type-constraint
const $8cb19c1afc4eedec$var$useExperimentValue = (experimentName, parameterName, defaultValue, options = {})=>{
    const [experimentValue, setExperimentValue] = (0, $5FkrB.useState)(()=>$8cb19c1afc4eedec$var$feature_gate_js_client_1.default.getExperimentValue(experimentName, parameterName, defaultValue, options));
    (0, $5FkrB.useEffect)(()=>{
        const onExperimentValueChange = (newValue)=>setExperimentValue(newValue);
        return $8cb19c1afc4eedec$var$feature_gate_js_client_1.default.onExperimentValueUpdated(experimentName, parameterName, defaultValue, onExperimentValueChange, options);
    }, [
        experimentName,
        parameterName,
        defaultValue,
        options
    ]);
    return experimentValue;
};
module.exports.useExperimentValue = $8cb19c1afc4eedec$var$useExperimentValue;

});
parcelRegister("jcX3Q", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => (parcelRequire("ISKn7")).default);
$parcel$export(module.exports, "FeatureGateEnvironment", () => (parcelRequire("hiARP")).FeatureGateEnvironment);
$parcel$export(module.exports, "PerimeterType", () => (parcelRequire("hiARP")).PerimeterType);
$parcel$export(module.exports, "CLIENT_VERSION", () => (parcelRequire("7HOhT")).CLIENT_VERSION);
$parcel$export(module.exports, "DynamicConfig", () => (parcelRequire("kkQZA")).DynamicConfig);
$parcel$export(module.exports, "Layer", () => (parcelRequire("eVlof")).Layer);
$parcel$export(module.exports, "EvaluationReason", () => (parcelRequire("48eYA")).EvaluationReason);
/* eslint-disable @repo/internal/deprecations/deprecation-ticket-required -- VOLTC-139 tracks removal of these deprecated re-export shims. */ /**
 * @deprecated Use `import type { AnalyticsWebClient, BaseClientOptions, CheckGateOptions, ClientOptions, CustomAttributes, FrontendExperimentsResult, FromValuesClientOptions, GetExperimentOptions, GetExperimentValueOptions, Identifiers, InitializeValues, UpdateUserCompletionCallback, OptionsWithDefaults, Provider } from '@atlaskit/feature-gate-js-client/feature-gates'` instead.
 */ /**
 * @deprecated Use `import type { LocalOverrides } from '@atlaskit/feature-gate-js-client/persistent-override-adapter'` instead.
 */ /**
 * @deprecated Use `import { boundFGJS, FeatureGateEnvironment, PerimeterType, CLIENT_VERSION } from '@atlaskit/feature-gate-js-client/feature-gates'` instead.
 */ parcelRequire("ISKn7");
var $7HOhT = parcelRequire("7HOhT");
var $ISKn7 = parcelRequire("ISKn7");
var $hiARP = parcelRequire("hiARP");

var $kkQZA = parcelRequire("kkQZA");

var $eVlof = parcelRequire("eVlof");

var $48eYA = parcelRequire("48eYA");

});
parcelRegister("ISKn7", function(module, exports) {
$parcel$export(module.exports, "default", () => $086e93c69a5d1ec0$export$2e2bcd8739ae039);
$parcel$export(module.exports, "CLIENT_VERSION", () => (parcelRequire("7HOhT")).CLIENT_VERSION);

var $k2IPD = parcelRequire("k2IPD");

var $edw2y = parcelRequire("edw2y");

var $hZ7a4 = parcelRequire("hZ7a4");

var $5rlAb = parcelRequire("5rlAb");

var $7HOhT = parcelRequire("7HOhT");



var $hiARP = parcelRequire("hiARP");
var $086e93c69a5d1ec0$var$_FeatureGates;
/**
 * Access the FeatureGates object via the default export.
 * ```ts
 * import FeatureGates from '@atlaskit/feature-gate-js-client';
 * ```
 */ var $086e93c69a5d1ec0$var$FeatureGates = /*#__PURE__*/ function() {
    function FeatureGates() {
        (0, $k2IPD.default)(this, FeatureGates);
    }
    return (0, $edw2y.default)(FeatureGates, null, [
        {
            key: "isGateExists",
            value: function isGateExists(gateName) {
                return this.client.isGateExist(gateName);
            }
        },
        {
            key: "isExperimentExists",
            value: function isExperimentExists(experimentName) {
                return this.client.isExperimentExist(experimentName);
            }
        }
    ]);
}();
$086e93c69a5d1ec0$var$_FeatureGates = $086e93c69a5d1ec0$var$FeatureGates;
(0, $hZ7a4.default)($086e93c69a5d1ec0$var$FeatureGates, "client", new (0, $5rlAb.Client)());
(0, $hZ7a4.default)($086e93c69a5d1ec0$var$FeatureGates, "hasCheckGateErrorOccurred", false);
(0, $hZ7a4.default)($086e93c69a5d1ec0$var$FeatureGates, "hasGetExperimentValueErrorOccurred", false);
(0, $hZ7a4.default)($086e93c69a5d1ec0$var$FeatureGates, "checkGate", function(gateName, options) {
    try {
        // Check if the CRITERION override mechanism is available
        if (typeof window !== 'undefined' && window.__CRITERION__ && typeof window.__CRITERION__.getFeatureFlagOverride === 'function') {
            // Attempt to retrieve an override value for the feature gate
            var overrideValue = window.__CRITERION__.getFeatureFlagOverride(gateName);
            // If an override value is found, return it immediately
            if (overrideValue !== undefined) return overrideValue;
        }
    } catch (error) {
        // Log the first occurrence of the error
        if (!$086e93c69a5d1ec0$var$_FeatureGates.hasCheckGateErrorOccurred) {
            // eslint-disable-next-line no-console
            console.warn({
                msg: 'An error has occurred checking the feature gate from criterion override. Only the first occurrence of this error is logged.',
                gateName: gateName,
                error: error
            });
            $086e93c69a5d1ec0$var$_FeatureGates.hasCheckGateErrorOccurred = true;
        }
    }
    // Proceed with the main logic if no override is found
    return $086e93c69a5d1ec0$var$_FeatureGates.client.checkGate(gateName, options);
});
(0, $hZ7a4.default)($086e93c69a5d1ec0$var$FeatureGates, "getExperimentValue", function(experimentName, parameterName, defaultValue, options) {
    try {
        // Check if the CRITERION override mechanism is available
        if (typeof window !== 'undefined' && window.__CRITERION__ && typeof window.__CRITERION__.getExperimentValueOverride === 'function') {
            var overrideValue = window.__CRITERION__.getExperimentValueOverride(experimentName, parameterName);
            if (overrideValue !== undefined && overrideValue !== null) return overrideValue;
        }
    } catch (error) {
        // Log the first occurrence of the error
        if (!$086e93c69a5d1ec0$var$_FeatureGates.hasGetExperimentValueErrorOccurred) {
            // eslint-disable-next-line no-console
            console.warn({
                msg: 'An error has occurred getting the experiment value from criterion override. Only the first occurrence of this error is logged.',
                experimentName: experimentName,
                defaultValue: defaultValue,
                options: options,
                error: error
            });
            $086e93c69a5d1ec0$var$_FeatureGates.hasGetExperimentValueErrorOccurred = true;
        }
        return defaultValue;
    }
    // Proceed with the main logic if no override is found
    return $086e93c69a5d1ec0$var$_FeatureGates.client.getExperimentValue(experimentName, parameterName, defaultValue, options);
});
(0, $hZ7a4.default)($086e93c69a5d1ec0$var$FeatureGates, "initializeCalled", $086e93c69a5d1ec0$var$_FeatureGates.client.initializeCalled.bind($086e93c69a5d1ec0$var$_FeatureGates.client));
(0, $hZ7a4.default)($086e93c69a5d1ec0$var$FeatureGates, "initializeCompleted", $086e93c69a5d1ec0$var$_FeatureGates.client.initializeCompleted.bind($086e93c69a5d1ec0$var$_FeatureGates.client));
(0, $hZ7a4.default)($086e93c69a5d1ec0$var$FeatureGates, "waitUntilInitializeCompleted", $086e93c69a5d1ec0$var$_FeatureGates.client.waitUntilInitializeCompleted.bind($086e93c69a5d1ec0$var$_FeatureGates.client));
(0, $hZ7a4.default)($086e93c69a5d1ec0$var$FeatureGates, "initialize", $086e93c69a5d1ec0$var$_FeatureGates.client.initialize.bind($086e93c69a5d1ec0$var$_FeatureGates.client));
(0, $hZ7a4.default)($086e93c69a5d1ec0$var$FeatureGates, "initializeWithProvider", $086e93c69a5d1ec0$var$_FeatureGates.client.initializeWithProvider.bind($086e93c69a5d1ec0$var$_FeatureGates.client));
(0, $hZ7a4.default)($086e93c69a5d1ec0$var$FeatureGates, "initializeFromValues", $086e93c69a5d1ec0$var$_FeatureGates.client.initializeFromValues.bind($086e93c69a5d1ec0$var$_FeatureGates.client));
(0, $hZ7a4.default)($086e93c69a5d1ec0$var$FeatureGates, "manuallyLogGateExposure", $086e93c69a5d1ec0$var$_FeatureGates.client.manuallyLogGateExposure.bind($086e93c69a5d1ec0$var$_FeatureGates.client));
(0, $hZ7a4.default)($086e93c69a5d1ec0$var$FeatureGates, "getExperiment", $086e93c69a5d1ec0$var$_FeatureGates.client.getExperiment.bind($086e93c69a5d1ec0$var$_FeatureGates.client));
(0, $hZ7a4.default)($086e93c69a5d1ec0$var$FeatureGates, "manuallyLogExperimentExposure", $086e93c69a5d1ec0$var$_FeatureGates.client.manuallyLogExperimentExposure.bind($086e93c69a5d1ec0$var$_FeatureGates.client));
(0, $hZ7a4.default)($086e93c69a5d1ec0$var$FeatureGates, "manuallyLogLayerExposure", $086e93c69a5d1ec0$var$_FeatureGates.client.manuallyLogLayerExposure.bind($086e93c69a5d1ec0$var$_FeatureGates.client));
(0, $hZ7a4.default)($086e93c69a5d1ec0$var$FeatureGates, "shutdownStatsig", $086e93c69a5d1ec0$var$_FeatureGates.client.shutdownStatsig.bind($086e93c69a5d1ec0$var$_FeatureGates.client));
(0, $hZ7a4.default)($086e93c69a5d1ec0$var$FeatureGates, "overrideGate", $086e93c69a5d1ec0$var$_FeatureGates.client.overrideGate.bind($086e93c69a5d1ec0$var$_FeatureGates.client));
(0, $hZ7a4.default)($086e93c69a5d1ec0$var$FeatureGates, "clearGateOverride", $086e93c69a5d1ec0$var$_FeatureGates.client.clearGateOverride.bind($086e93c69a5d1ec0$var$_FeatureGates.client));
(0, $hZ7a4.default)($086e93c69a5d1ec0$var$FeatureGates, "overrideConfig", $086e93c69a5d1ec0$var$_FeatureGates.client.overrideConfig.bind($086e93c69a5d1ec0$var$_FeatureGates.client));
(0, $hZ7a4.default)($086e93c69a5d1ec0$var$FeatureGates, "clearConfigOverride", $086e93c69a5d1ec0$var$_FeatureGates.client.clearConfigOverride.bind($086e93c69a5d1ec0$var$_FeatureGates.client));
(0, $hZ7a4.default)($086e93c69a5d1ec0$var$FeatureGates, "setOverrides", $086e93c69a5d1ec0$var$_FeatureGates.client.setOverrides.bind($086e93c69a5d1ec0$var$_FeatureGates.client));
(0, $hZ7a4.default)($086e93c69a5d1ec0$var$FeatureGates, "getOverrides", $086e93c69a5d1ec0$var$_FeatureGates.client.getOverrides.bind($086e93c69a5d1ec0$var$_FeatureGates.client));
(0, $hZ7a4.default)($086e93c69a5d1ec0$var$FeatureGates, "clearAllOverrides", $086e93c69a5d1ec0$var$_FeatureGates.client.clearAllOverrides.bind($086e93c69a5d1ec0$var$_FeatureGates.client));
(0, $hZ7a4.default)($086e93c69a5d1ec0$var$FeatureGates, "isCurrentUser", $086e93c69a5d1ec0$var$_FeatureGates.client.isCurrentUser.bind($086e93c69a5d1ec0$var$_FeatureGates.client));
(0, $hZ7a4.default)($086e93c69a5d1ec0$var$FeatureGates, "onGateUpdated", $086e93c69a5d1ec0$var$_FeatureGates.client.onGateUpdated.bind($086e93c69a5d1ec0$var$_FeatureGates.client));
(0, $hZ7a4.default)($086e93c69a5d1ec0$var$FeatureGates, "onExperimentValueUpdated", $086e93c69a5d1ec0$var$_FeatureGates.client.onExperimentValueUpdated.bind($086e93c69a5d1ec0$var$_FeatureGates.client));
(0, $hZ7a4.default)($086e93c69a5d1ec0$var$FeatureGates, "onAnyUpdated", $086e93c69a5d1ec0$var$_FeatureGates.client.onAnyUpdated.bind($086e93c69a5d1ec0$var$_FeatureGates.client));
(0, $hZ7a4.default)($086e93c69a5d1ec0$var$FeatureGates, "updateUser", $086e93c69a5d1ec0$var$_FeatureGates.client.updateUser.bind($086e93c69a5d1ec0$var$_FeatureGates.client));
(0, $hZ7a4.default)($086e93c69a5d1ec0$var$FeatureGates, "updateUserWithProvider", $086e93c69a5d1ec0$var$_FeatureGates.client.updateUserWithProvider.bind($086e93c69a5d1ec0$var$_FeatureGates.client));
(0, $hZ7a4.default)($086e93c69a5d1ec0$var$FeatureGates, "updateUserWithValues", $086e93c69a5d1ec0$var$_FeatureGates.client.updateUserWithValues.bind($086e93c69a5d1ec0$var$_FeatureGates.client));
(0, $hZ7a4.default)($086e93c69a5d1ec0$var$FeatureGates, "getPackageVersion", $086e93c69a5d1ec0$var$_FeatureGates.client.getPackageVersion.bind($086e93c69a5d1ec0$var$_FeatureGates.client));
(0, $hZ7a4.default)($086e93c69a5d1ec0$var$FeatureGates, "getTargetApp", $086e93c69a5d1ec0$var$_FeatureGates.client.getTargetApp.bind($086e93c69a5d1ec0$var$_FeatureGates.client));
(0, $hZ7a4.default)($086e93c69a5d1ec0$var$FeatureGates, "getLayer", $086e93c69a5d1ec0$var$_FeatureGates.client.getLayer.bind($086e93c69a5d1ec0$var$_FeatureGates.client));
(0, $hZ7a4.default)($086e93c69a5d1ec0$var$FeatureGates, "getLayerValue", $086e93c69a5d1ec0$var$_FeatureGates.client.getLayerValue.bind($086e93c69a5d1ec0$var$_FeatureGates.client));
var $086e93c69a5d1ec0$var$boundFGJS = $086e93c69a5d1ec0$var$FeatureGates;
// This makes it possible to get a reference to the FeatureGates client at runtime.
// This is important for overriding values in Cypress tests, as there needs to be a
// way to get the exact instance for a window in order to mock some of its methods.
if (typeof window !== 'undefined') {
    if (window.__FEATUREGATES_JS__ === undefined) window.__FEATUREGATES_JS__ = $086e93c69a5d1ec0$var$FeatureGates;
    else {
        var $086e93c69a5d1ec0$var$_boundFGJS, $086e93c69a5d1ec0$var$_boundFGJS$getPackage;
        $086e93c69a5d1ec0$var$boundFGJS = window.__FEATUREGATES_JS__;
        var $086e93c69a5d1ec0$var$boundVersion = (($086e93c69a5d1ec0$var$_boundFGJS = $086e93c69a5d1ec0$var$boundFGJS) === null || $086e93c69a5d1ec0$var$_boundFGJS === void 0 || ($086e93c69a5d1ec0$var$_boundFGJS$getPackage = $086e93c69a5d1ec0$var$_boundFGJS.getPackageVersion) === null || $086e93c69a5d1ec0$var$_boundFGJS$getPackage === void 0 ? void 0 : $086e93c69a5d1ec0$var$_boundFGJS$getPackage.call($086e93c69a5d1ec0$var$_boundFGJS)) || '4.10.0 or earlier';
        if ($086e93c69a5d1ec0$var$boundVersion !== (0, $7HOhT.CLIENT_VERSION)) {
            var $086e93c69a5d1ec0$var$message = "Multiple versions of FeatureGateClients found on the current page.\n      The currently bound version is ".concat($086e93c69a5d1ec0$var$boundVersion, " when module version ").concat((0, $7HOhT.CLIENT_VERSION), " was loading.");
            // eslint-disable-next-line no-console
            console.warn($086e93c69a5d1ec0$var$message);
        }
    }
}
var /**
 * @property {FeatureGates} FeatureGate default export
 */ $086e93c69a5d1ec0$export$2e2bcd8739ae039 = $086e93c69a5d1ec0$var$boundFGJS;

});
parcelRegister("k2IPD", function(module, exports) {
$parcel$export(module.exports, "default", () => $e976c53911d4894e$export$2e2bcd8739ae039);
function $e976c53911d4894e$export$2e2bcd8739ae039(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}

});

parcelRegister("edw2y", function(module, exports) {
$parcel$export(module.exports, "default", () => $a59b221712079fdf$export$2e2bcd8739ae039);

var $fAaEA = parcelRequire("fAaEA");
function $a59b221712079fdf$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, (0, $fAaEA.default)(o.key), o);
    }
}
function $a59b221712079fdf$export$2e2bcd8739ae039(e, r, t) {
    return r && $a59b221712079fdf$var$_defineProperties(e.prototype, r), t && $a59b221712079fdf$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}

});
parcelRegister("fAaEA", function(module, exports) {
$parcel$export(module.exports, "default", () => $b5827b6404f3552c$export$2e2bcd8739ae039);

var $aAdgI = parcelRequire("aAdgI");

var $kcHH8 = parcelRequire("kcHH8");
function $b5827b6404f3552c$export$2e2bcd8739ae039(t) {
    var i = (0, $kcHH8.default)(t, "string");
    return "symbol" == (0, $aAdgI.default)(i) ? i : i + "";
}

});
parcelRegister("aAdgI", function(module, exports) {
$parcel$export(module.exports, "default", () => $7b478f0a8f84635a$export$2e2bcd8739ae039);
function $7b478f0a8f84635a$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $7b478f0a8f84635a$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $7b478f0a8f84635a$export$2e2bcd8739ae039(o);
}

});

parcelRegister("kcHH8", function(module, exports) {
$parcel$export(module.exports, "default", () => $eb56d27d9342fd76$export$2e2bcd8739ae039);

var $aAdgI = parcelRequire("aAdgI");
function $eb56d27d9342fd76$export$2e2bcd8739ae039(t, r) {
    if ("object" != (0, $aAdgI.default)(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (0, $aAdgI.default)(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}

});



parcelRegister("hZ7a4", function(module, exports) {
$parcel$export(module.exports, "default", () => $d17db047d702a883$export$2e2bcd8739ae039);

var $fAaEA = parcelRequire("fAaEA");
function $d17db047d702a883$export$2e2bcd8739ae039(e, r, t) {
    return (r = (0, $fAaEA.default)(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}

});

parcelRegister("5rlAb", function(module, exports) {
$parcel$export(module.exports, "Client", () => $3f603739ccb347dd$export$1f2bb630327ac4b6);

var $ciEnq = parcelRequire("ciEnq");

var $3OJNo = parcelRequire("3OJNo");

var $bLOvh = parcelRequire("bLOvh");

var $k2IPD = parcelRequire("k2IPD");

var $edw2y = parcelRequire("edw2y");

var $hZ7a4 = parcelRequire("hZ7a4");

var $a3FqH = parcelRequire("a3FqH");

var $a0vkc = parcelRequire("a0vkc");

var $5sFjq = parcelRequire("5sFjq");

var $kkQZA = parcelRequire("kkQZA");

var $eVlof = parcelRequire("eVlof");

var $48eYA = parcelRequire("48eYA");

var $9sCMD = parcelRequire("9sCMD");

var $hzt3R = parcelRequire("hzt3R");

var $2y8p6 = parcelRequire("2y8p6");

var $f0l1D = parcelRequire("f0l1D");

var $2usPa = parcelRequire("2usPa");

var $j3SRh = parcelRequire("j3SRh");

var $55r6R = parcelRequire("55r6R");

var $3yi6c = parcelRequire("3yi6c");

var $hiARP = parcelRequire("hiARP");

var $7HOhT = parcelRequire("7HOhT");
var $3f603739ccb347dd$var$_excluded = [
    "sdkKey",
    "environment",
    "updateUserCompletionCallback",
    "perimeter"
];
function $3f603739ccb347dd$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $3f603739ccb347dd$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $3f603739ccb347dd$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $hZ7a4.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $3f603739ccb347dd$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $3f603739ccb347dd$var$DEFAULT_CLIENT_KEY = 'client-default-key';
// default event logging api is Atlassian proxy rather than Statsig's domain, to avoid ad blockers
var $3f603739ccb347dd$var$DEFAULT_EVENT_LOGGING_API = 'https://xp.atlassian.com/v1/rgstr';
var $3f603739ccb347dd$export$1f2bb630327ac4b6 = /*#__PURE__*/ function() {
    function Client() {
        var _this = this;
        var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, _ref$localStorageKey = _ref.localStorageKey, localStorageKey = _ref$localStorageKey === void 0 ? (0, $j3SRh.LOCAL_STORAGE_KEY) : _ref$localStorageKey, overrideAdapter = _ref.overrideAdapter;
        (0, $k2IPD.default)(this, Client);
        (0, $hZ7a4.default)(this, "initPromise", null);
        /** True if an initialize method was called and completed successfully. */ (0, $hZ7a4.default)(this, "initCompleted", false);
        /**
     * True if an initialize method was called and completed, meaning the client is now usable.
     * However if there was an error during initialization it may have initialized with default
     * values. Use {@link initCompleted} to check for this.
     */ (0, $hZ7a4.default)(this, "initWithDefaults", false);
        (0, $hZ7a4.default)(this, "hasCheckGateErrorOccurred", false);
        (0, $hZ7a4.default)(this, "hasGetExperimentErrorOccurred", false);
        (0, $hZ7a4.default)(this, "hasGetExperimentValueErrorOccurred", false);
        (0, $hZ7a4.default)(this, "hasGetLayerErrorOccurred", false);
        (0, $hZ7a4.default)(this, "hasGetLayerValueErrorOccurred", false);
        (0, $hZ7a4.default)(this, "subscriptions", new (0, $5sFjq.default)());
        (0, $hZ7a4.default)(this, "dataAdapter", new (0, $2usPa.NoFetchDataAdapter)());
        /**
     * Call this if modifying the values being served by the Statsig library since it has its own
     * memoization cache which will not be updated if the values are changed outside of the library.
     */ (0, $hZ7a4.default)(this, "statsigValuesUpdated", function() {
            if (_this.user) // Trigger a reset of the memoize cache
            _this.statsigClient.updateUserSync(_this.user, {
                disableBackgroundCacheRefresh: true
            });
            _this.subscriptions.anyUpdated();
        });
        this.overrideAdapter = overrideAdapter || new (0, $j3SRh.PersistentOverrideAdapter)(localStorageKey);
    }
    /**
   * @description
   * This method initializes the client using a network call to fetch the bootstrap values.
   * If the client is inialized with an `analyticsWebClient`, it will send an operational event
   * to GASv3 with the following attributes:
   * - targetApp: the target app of the client
   * - clientVersion: the version of the client
   * - success: whether the initialization was successful
   * - startTime: the time when the initialization started
   * - totalTime: the total time it took to initialize the client
   * - apiKey: the api key used to initialize the client
   * @param clientOptions {ClientOptions}
   * @param identifiers {Identifiers}
   * @param customAttributes {CustomAttributes}
   * @returns {Promise<void>}
   */ return (0, $edw2y.default)(Client, [
        {
            key: "initialize",
            value: function() {
                var _initialize = (0, $bLOvh.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($a3FqH))).mark(function _callee(clientOptions, identifiers, customAttributes) {
                    var _this2 = this;
                    var clientOptionsWithDefaults, startTime;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($a3FqH))).wrap(function(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                clientOptionsWithDefaults = (0, $2y8p6.getOptionsWithDefaults)(clientOptions);
                                if (!this.initPromise) {
                                    _context.next = 1;
                                    break;
                                }
                                if (!(0, $55r6R.shallowEquals)(clientOptionsWithDefaults, this.initOptions)) // eslint-disable-next-line no-console
                                console.warn('Feature Gates client already initialized with different options. New options were not applied.');
                                return _context.abrupt("return", this.initPromise);
                            case 1:
                                startTime = performance.now();
                                this.initOptions = clientOptionsWithDefaults;
                                this.initPromise = this.init(clientOptionsWithDefaults, identifiers, customAttributes).then(function() {
                                    _this2.initCompleted = true;
                                    _this2.initWithDefaults = true;
                                }).finally(function() {
                                    var endTime = performance.now();
                                    var totalTime = endTime - startTime;
                                    _this2.fireClientEvent(startTime, totalTime, 'initialize', _this2.initCompleted, clientOptionsWithDefaults.apiKey);
                                });
                                return _context.abrupt("return", this.initPromise);
                            case 2:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee, this);
                }));
                function initialize(_x, _x2, _x3) {
                    return _initialize.apply(this, arguments);
                }
                return initialize;
            }()
        },
        {
            key: "initializeWithProvider",
            value: function() {
                var _initializeWithProvider = (0, $bLOvh.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($a3FqH))).mark(function _callee2(clientOptions, provider, identifiers, customAttributes) {
                    var _this3 = this;
                    var clientOptionsWithDefaults, startTime;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($a3FqH))).wrap(function(_context2) {
                        while(true)switch(_context2.prev = _context2.next){
                            case 0:
                                clientOptionsWithDefaults = (0, $2y8p6.getOptionsWithDefaults)(clientOptions);
                                if (!this.initPromise) {
                                    _context2.next = 1;
                                    break;
                                }
                                if (!(0, $55r6R.shallowEquals)(clientOptionsWithDefaults, this.initOptions)) // eslint-disable-next-line no-console
                                console.warn('Feature Gates client already initialized with different options. New options were not applied.');
                                return _context2.abrupt("return", this.initPromise);
                            case 1:
                                startTime = performance.now();
                                this.initOptions = clientOptionsWithDefaults;
                                this.provider = provider;
                                this.provider.setClientVersion((0, $7HOhT.CLIENT_VERSION));
                                if (this.provider.setApplyUpdateCallback) this.provider.setApplyUpdateCallback(this.applyUpdateCallback.bind(this));
                                this.initPromise = this.initWithProvider(clientOptionsWithDefaults, provider, identifiers, customAttributes).then(function() {
                                    _this3.initCompleted = true;
                                    _this3.initWithDefaults = true;
                                }).finally(function() {
                                    var endTime = performance.now();
                                    var totalTime = endTime - startTime;
                                    _this3.fireClientEvent(startTime, totalTime, 'initializeWithProvider', _this3.initCompleted, provider.getApiKey ? provider.getApiKey() : undefined);
                                });
                                return _context2.abrupt("return", this.initPromise);
                            case 2:
                            case "end":
                                return _context2.stop();
                        }
                    }, _callee2, this);
                }));
                function initializeWithProvider(_x4, _x5, _x6, _x7) {
                    return _initializeWithProvider.apply(this, arguments);
                }
                return initializeWithProvider;
            }()
        },
        {
            key: "applyUpdateCallback",
            value: function applyUpdateCallback(experimentsResult) {
                try {
                    if (this.initCompleted || this.initWithDefaults) {
                        this.assertInitialized(this.statsigClient);
                        this.dataAdapter.setBootstrapData(experimentsResult.experimentValues);
                        this.dataAdapter.setData(JSON.stringify(experimentsResult.experimentValues));
                        this.statsigValuesUpdated();
                    }
                } catch (error) {
                    // eslint-disable-next-line no-console
                    console.warn('Error when attempting to apply update', error);
                }
            }
        },
        {
            key: "fireClientEvent",
            value: function fireClientEvent(startTime, totalTime, action, success) {
                var _analyticsWebClient, _this4 = this;
                var apiKey = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;
                (_analyticsWebClient = this.initOptions.analyticsWebClient) === null || _analyticsWebClient === void 0 || _analyticsWebClient.then(function(analyticsWebClient) {
                    var attributes = $3f603739ccb347dd$var$_objectSpread({
                        targetApp: _this4.initOptions.targetApp,
                        clientVersion: (0, $7HOhT.CLIENT_VERSION),
                        success: success,
                        startTime: startTime,
                        totalTime: totalTime
                    }, apiKey && {
                        apiKey: apiKey
                    });
                    analyticsWebClient.sendOperationalEvent({
                        action: action,
                        actionSubject: 'featureGatesClient',
                        attributes: attributes,
                        tags: [
                            'measurement'
                        ],
                        source: '@atlaskit/feature-gate-js-client'
                    });
                }).catch(function(err) {
                    if (_this4.initOptions.environment !== (0, $hiARP.FeatureGateEnvironment).Production) // eslint-disable-next-line no-console
                    console.error('Analytics web client promise did not resolve', err);
                });
            }
        },
        {
            key: "initializeFromValues",
            value: function() {
                var _initializeFromValues = (0, $bLOvh.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($a3FqH))).mark(function _callee3(clientOptions, identifiers, customAttributes) {
                    var _this5 = this;
                    var initializeValues, clientOptionsWithDefaults, startTime, _args3 = arguments;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($a3FqH))).wrap(function(_context3) {
                        while(true)switch(_context3.prev = _context3.next){
                            case 0:
                                initializeValues = _args3.length > 3 && _args3[3] !== undefined ? _args3[3] : {};
                                clientOptionsWithDefaults = (0, $2y8p6.getOptionsWithDefaults)(clientOptions);
                                if (!this.initPromise) {
                                    _context3.next = 1;
                                    break;
                                }
                                if (!(0, $55r6R.shallowEquals)(clientOptionsWithDefaults, this.initOptions)) // eslint-disable-next-line no-console
                                console.warn('Feature Gates client already initialized with different options. New options were not applied.');
                                return _context3.abrupt("return", this.initPromise);
                            case 1:
                                // This makes sure the new Statsig client behaves like the old when bootstrap data is
                                // passed, and `has_updates` isn't specified (which happens a lot in product integration tests).
                                if (!Object.prototype.hasOwnProperty.call(initializeValues, 'has_updates')) initializeValues['has_updates'] = true;
                                startTime = performance.now();
                                this.initOptions = clientOptionsWithDefaults;
                                this.initPromise = this.initFromValues(clientOptionsWithDefaults, identifiers, customAttributes, initializeValues).then(function() {
                                    _this5.initCompleted = true;
                                    _this5.initWithDefaults = true;
                                }).finally(function() {
                                    var endTime = performance.now();
                                    var totalTime = endTime - startTime;
                                    _this5.fireClientEvent(startTime, totalTime, 'initializeFromValues', _this5.initCompleted);
                                });
                                return _context3.abrupt("return", this.initPromise);
                            case 2:
                            case "end":
                                return _context3.stop();
                        }
                    }, _callee3, this);
                }));
                function initializeFromValues(_x8, _x9, _x0) {
                    return _initializeFromValues.apply(this, arguments);
                }
                return initializeFromValues;
            }()
        },
        {
            key: "assertInitialized",
            value: function assertInitialized(statsigClient) {
                if (!statsigClient) throw new Error('Client must be initialized before using this method');
            }
        },
        {
            key: "updateUser",
            value: function() {
                var _updateUser = (0, $bLOvh.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($a3FqH))).mark(function _callee4(fetchOptions, identifiers, customAttributes) {
                    var fetchOptionsWithDefaults, initializeValuesProducer;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($a3FqH))).wrap(function(_context4) {
                        while(true)switch(_context4.prev = _context4.next){
                            case 0:
                                this.assertInitialized(this.statsigClient);
                                fetchOptionsWithDefaults = (0, $2y8p6.getOptionsWithDefaults)(fetchOptions);
                                initializeValuesProducer = function initializeValuesProducer() {
                                    return (0, $hzt3R.default).fetchExperimentValues(fetchOptionsWithDefaults, identifiers, customAttributes).then(function(_ref2) {
                                        var experimentValues = _ref2.experimentValues, customAttributes = _ref2.customAttributes;
                                        return {
                                            experimentValues: experimentValues,
                                            customAttributesFromFetch: customAttributes
                                        };
                                    });
                                };
                                _context4.next = 1;
                                return this.updateUserUsingInitializeValuesProducer(initializeValuesProducer, identifiers, customAttributes);
                            case 1:
                            case "end":
                                return _context4.stop();
                        }
                    }, _callee4, this);
                }));
                function updateUser(_x1, _x10, _x11) {
                    return _updateUser.apply(this, arguments);
                }
                return updateUser;
            }()
        },
        {
            key: "updateUserWithProvider",
            value: function() {
                var _updateUserWithProvider = (0, $bLOvh.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($a3FqH))).mark(function _callee5(identifiers, customAttributes) {
                    var _this6 = this;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($a3FqH))).wrap(function(_context5) {
                        while(true)switch(_context5.prev = _context5.next){
                            case 0:
                                this.assertInitialized(this.statsigClient);
                                if (this.provider) {
                                    _context5.next = 1;
                                    break;
                                }
                                throw new Error('Cannot update user using provider as the client was not initialised with a provider');
                            case 1:
                                _context5.next = 2;
                                return this.provider.setProfile(this.initOptions, identifiers, customAttributes);
                            case 2:
                                _context5.next = 3;
                                return this.updateUserUsingInitializeValuesProducer(function() {
                                    return _this6.provider.getExperimentValues();
                                }, identifiers, customAttributes);
                            case 3:
                            case "end":
                                return _context5.stop();
                        }
                    }, _callee5, this);
                }));
                function updateUserWithProvider(_x12, _x13) {
                    return _updateUserWithProvider.apply(this, arguments);
                }
                return updateUserWithProvider;
            }()
        },
        {
            key: "updateUserWithValues",
            value: function() {
                var _updateUserWithValues = (0, $bLOvh.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($a3FqH))).mark(function _callee6(identifiers, customAttributes) {
                    var initializeValues, initializeValuesProducer, _args6 = arguments;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($a3FqH))).wrap(function(_context6) {
                        while(true)switch(_context6.prev = _context6.next){
                            case 0:
                                initializeValues = _args6.length > 2 && _args6[2] !== undefined ? _args6[2] : {};
                                this.assertInitialized(this.statsigClient);
                                initializeValuesProducer = function initializeValuesProducer() {
                                    return Promise.resolve({
                                        experimentValues: initializeValues,
                                        customAttributesFromFetch: customAttributes
                                    });
                                };
                                _context6.next = 1;
                                return this.updateUserUsingInitializeValuesProducer(initializeValuesProducer, identifiers, customAttributes);
                            case 1:
                            case "end":
                                return _context6.stop();
                        }
                    }, _callee6, this);
                }));
                function updateUserWithValues(_x14, _x15) {
                    return _updateUserWithValues.apply(this, arguments);
                }
                return updateUserWithValues;
            }()
        },
        {
            key: "initializeCalled",
            value: function initializeCalled() {
                return this.initPromise != null;
            }
        },
        {
            key: "initializeCompleted",
            value: function initializeCompleted() {
                return this.initCompleted;
            }
        },
        {
            key: "waitUntilInitializeCompleted",
            value: function() {
                var _waitUntilInitializeCompleted = (0, $bLOvh.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($a3FqH))).mark(function _callee7() {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($a3FqH))).wrap(function(_context7) {
                        while(true)switch(_context7.prev = _context7.next){
                            case 0:
                                if (this.initPromise) {
                                    _context7.next = 1;
                                    break;
                                }
                                throw new Error('The client must be initialized before you can wait until initialized.');
                            case 1:
                                if (!this.initCompleted) {
                                    _context7.next = 2;
                                    break;
                                }
                                return _context7.abrupt("return");
                            case 2:
                                _context7.next = 3;
                                return this.initPromise;
                            case 3:
                            case "end":
                                return _context7.stop();
                        }
                    }, _callee7, this);
                }));
                function waitUntilInitializeCompleted() {
                    return _waitUntilInitializeCompleted.apply(this, arguments);
                }
                return waitUntilInitializeCompleted;
            }()
        },
        {
            key: "checkGate",
            value: function checkGate(gateName) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                try {
                    this.assertInitialized(this.statsigClient);
                    var _options$fireGateExpo = options.fireGateExposure, fireGateExposure = _options$fireGateExpo === void 0 ? true : _options$fireGateExpo;
                    return this.statsigClient.checkGate(gateName, {
                        disableExposureLog: !fireGateExposure
                    });
                } catch (error) {
                    // Log the first occurrence of the error
                    if (!this.hasCheckGateErrorOccurred) {
                        // eslint-disable-next-line no-console
                        console.warn({
                            msg: 'An error has occurred checking the feature gate. Only the first occurrence of this error is logged.',
                            gateName: gateName,
                            error: error
                        });
                        this.hasCheckGateErrorOccurred = true;
                    }
                    return false;
                }
            }
        },
        {
            key: "isGateExist",
            value: function isGateExist(gateName) {
                try {
                    this.assertInitialized(this.statsigClient);
                    var gate = this.statsigClient.getFeatureGate(gateName, {
                        disableExposureLog: true
                    });
                    return !gate.details.reason.includes('Unrecognized');
                } catch (error) {
                    // eslint-disable-next-line no-console
                    console.error("Error occurred when trying to check FeatureGate: ".concat(error));
                    // in case of error report true to avoid false positives.
                    return true;
                }
            }
        },
        {
            key: "isExperimentExist",
            value: function isExperimentExist(experimentName) {
                try {
                    this.assertInitialized(this.statsigClient);
                    var config = this.statsigClient.getExperiment(experimentName, {
                        disableExposureLog: true
                    });
                    return !config.details.reason.includes('Unrecognized');
                } catch (error) {
                    // eslint-disable-next-line no-console
                    console.error("Error occurred when trying to check Experiment: ".concat(error));
                    // in case of error report true to avoid false positives.
                    return true;
                }
            }
        },
        {
            key: "manuallyLogGateExposure",
            value: function manuallyLogGateExposure(gateName) {
                this.assertInitialized(this.statsigClient);
                // This is the approach recommended in the docs
                // https://docs.statsig.com/client/javascript-sdk/#manual-exposures-
                this.statsigClient.checkGate(gateName);
            }
        },
        {
            key: "getExperiment",
            value: function getExperiment(experimentName) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                try {
                    this.assertInitialized(this.statsigClient);
                    var _options$fireExperime = options.fireExperimentExposure, fireExperimentExposure = _options$fireExperime === void 0 ? true : _options$fireExperime;
                    return (0, $kkQZA.DynamicConfig).fromExperiment(this.statsigClient.getExperiment(experimentName, {
                        disableExposureLog: !fireExperimentExposure
                    }));
                } catch (error) {
                    // Log the first occurrence of the error
                    if (!this.hasGetExperimentErrorOccurred) {
                        // eslint-disable-next-line no-console
                        console.warn({
                            msg: 'An error has occurred getting the experiment. Only the first occurrence of this error is logged.',
                            experimentName: experimentName,
                            error: error
                        });
                        this.hasGetExperimentErrorOccurred = true;
                    }
                    // Return a default value
                    return new (0, $kkQZA.DynamicConfig)(experimentName, {}, '', {
                        time: Date.now(),
                        reason: (0, $48eYA.EvaluationReason).Error
                    });
                }
            }
        },
        {
            key: "getExperimentValue",
            value: function getExperimentValue(experimentName, parameterName, defaultValue) {
                var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var experiment = this.getExperiment(experimentName, options);
                try {
                    var typeGuard = options.typeGuard;
                    return experiment.get(parameterName, defaultValue, typeGuard);
                } catch (error) {
                    // Log the first occurrence of the error
                    if (!this.hasGetExperimentValueErrorOccurred) {
                        // eslint-disable-next-line no-console
                        console.warn({
                            msg: 'An error has occurred getting the experiment value. Only the first occurrence of this error is logged.',
                            experimentName: experimentName,
                            defaultValue: defaultValue,
                            options: options,
                            error: error
                        });
                        this.hasGetExperimentValueErrorOccurred = true;
                    }
                    return defaultValue;
                }
            }
        },
        {
            key: "manuallyLogExperimentExposure",
            value: function manuallyLogExperimentExposure(experimentName) {
                this.assertInitialized(this.statsigClient);
                // This is the approach recommended in the docs
                // https://docs.statsig.com/client/javascript-sdk/#manual-exposures-
                this.statsigClient.getExperiment(experimentName);
            }
        },
        {
            key: "manuallyLogLayerExposure",
            value: function manuallyLogLayerExposure(layerName, parameterName) {
                var _this$statsigClient$g;
                this.assertInitialized(this.statsigClient);
                // This is the approach recommended in the docs
                // https://docs.statsig.com/client/javascript-sdk/#manual-exposures-
                (_this$statsigClient$g = this.statsigClient.getLayer(layerName)) === null || _this$statsigClient$g === void 0 || _this$statsigClient$g.get(parameterName);
            }
        },
        {
            key: "shutdownStatsig",
            value: function shutdownStatsig() {
                this.assertInitialized(this.statsigClient);
                this.statsigClient.shutdown();
            }
        },
        {
            key: "overrideGate",
            value: function overrideGate(gateName, value) {
                this.overrideAdapter.overrideGate(gateName, value);
                // Trigger a reset of the memoized gate value
                if (this.user) {
                    var _this$statsigClient;
                    (_this$statsigClient = this.statsigClient) === null || _this$statsigClient === void 0 || _this$statsigClient.updateUserSync(this.user, {
                        disableBackgroundCacheRefresh: true
                    });
                }
                this.statsigValuesUpdated();
            }
        },
        {
            key: "clearGateOverride",
            value: function clearGateOverride(gateName) {
                this.overrideAdapter.removeGateOverride(gateName);
                this.statsigValuesUpdated();
            }
        },
        {
            key: "overrideConfig",
            value: function overrideConfig(experimentName, values) {
                this.overrideAdapter.overrideDynamicConfig(experimentName, values);
                this.statsigValuesUpdated();
            }
        },
        {
            key: "clearConfigOverride",
            value: function clearConfigOverride(experimentName) {
                this.overrideAdapter.removeDynamicConfigOverride(experimentName);
                this.statsigValuesUpdated();
            }
        },
        {
            key: "setOverrides",
            value: function setOverrides(overrides) {
                this.overrideAdapter.setOverrides(overrides);
                this.statsigValuesUpdated();
            }
        },
        {
            key: "getOverrides",
            value: function getOverrides() {
                return this.overrideAdapter.getOverrides();
            }
        },
        {
            key: "clearAllOverrides",
            value: function clearAllOverrides() {
                this.overrideAdapter.removeAllOverrides();
                this.statsigValuesUpdated();
            }
        },
        {
            key: "isCurrentUser",
            value: function isCurrentUser(identifiers, customAttributes) {
                return (0, $55r6R.shallowEquals)(this.currentIdentifiers, identifiers) && (0, $55r6R.shallowEquals)(this.currentAttributes, customAttributes);
            }
        },
        {
            key: "onGateUpdated",
            value: function onGateUpdated(gateName, callback) {
                var _this7 = this;
                var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                var wrapCallback = function wrapCallback(value) {
                    var _options$fireGateExpo2 = options.fireGateExposure, fireGateExposure = _options$fireGateExpo2 === void 0 ? true : _options$fireGateExpo2;
                    if (fireGateExposure) _this7.manuallyLogGateExposure(gateName);
                    try {
                        callback(value);
                    } catch (error) {
                        // eslint-disable-next-line no-console
                        console.warn("Error calling callback for gate ".concat(gateName, " with value ").concat(value), error);
                    }
                };
                return this.subscriptions.onGateUpdated(gateName, wrapCallback, this.checkGate.bind(this), options);
            }
        },
        {
            key: "onExperimentValueUpdated",
            value: function onExperimentValueUpdated(experimentName, parameterName, defaultValue, callback) {
                var _this8 = this;
                var options = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
                var wrapCallback = function wrapCallback(value) {
                    var _options$fireExperime2 = options.fireExperimentExposure, fireExperimentExposure = _options$fireExperime2 === void 0 ? true : _options$fireExperime2;
                    if (fireExperimentExposure) _this8.manuallyLogExperimentExposure(experimentName);
                    try {
                        callback(value);
                    } catch (error) {
                        // eslint-disable-next-line no-console
                        console.warn("Error calling callback for experiment ".concat(experimentName, " with value ").concat(value), error);
                    }
                };
                return this.subscriptions.onExperimentValueUpdated(experimentName, parameterName, defaultValue, wrapCallback, this.getExperimentValue.bind(this), options);
            }
        },
        {
            key: "onAnyUpdated",
            value: function onAnyUpdated(callback) {
                return this.subscriptions.onAnyUpdated(callback);
            }
        },
        {
            key: "init",
            value: function() {
                var _init = (0, $bLOvh.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($a3FqH))).mark(function _callee8(clientOptions, identifiers, customAttributes) {
                    var fromValuesClientOptions, experimentValues, customAttributesFromResult, clientSdkKeyPromise, experimentValuesPromise, _yield$Promise$all, _yield$Promise$all2, experimentValuesResult, _t;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($a3FqH))).wrap(function(_context8) {
                        while(true)switch(_context8.prev = _context8.next){
                            case 0:
                                fromValuesClientOptions = $3f603739ccb347dd$var$_objectSpread({}, clientOptions);
                                if (!clientOptions.localMode) {
                                    _context8.next = 2;
                                    break;
                                }
                                _context8.next = 1;
                                return this.initFromValues(fromValuesClientOptions, identifiers, customAttributes);
                            case 1:
                                return _context8.abrupt("return");
                            case 2:
                                _context8.prev = 2;
                                // If client sdk key fetch fails, an error would be thrown and handled instead of waiting for
                                // the experiment values request to be settled, and it will fall back to use default values.
                                clientSdkKeyPromise = (0, $hzt3R.default).fetchClientSdk(clientOptions).then(function(value) {
                                    return fromValuesClientOptions.sdkKey = value.clientSdkKey;
                                });
                                experimentValuesPromise = (0, $hzt3R.default).fetchExperimentValues(clientOptions, identifiers, customAttributes); // Only wait for the experiment values request to finish and try to initialise the client
                                // with experiment values if both requests are successful. Else an error would be thrown and
                                // handled by the catch
                                _context8.next = 3;
                                return Promise.all([
                                    clientSdkKeyPromise,
                                    experimentValuesPromise
                                ]);
                            case 3:
                                _yield$Promise$all = _context8.sent;
                                _yield$Promise$all2 = (0, $3OJNo.default)(_yield$Promise$all, 2);
                                experimentValuesResult = _yield$Promise$all2[1];
                                experimentValues = experimentValuesResult.experimentValues;
                                customAttributesFromResult = experimentValuesResult.customAttributes;
                                _context8.next = 6;
                                break;
                            case 4:
                                _context8.prev = 4;
                                _t = _context8["catch"](2);
                                if (_t instanceof Error) // eslint-disable-next-line no-console
                                console.error("Error occurred when trying to fetch the Feature Gates client values, error: ".concat(_t === null || _t === void 0 ? void 0 : _t.message));
                                // eslint-disable-next-line no-console
                                console.warn("Initialising Statsig client without values");
                                _context8.next = 5;
                                return this.initFromValues(fromValuesClientOptions, identifiers, customAttributes);
                            case 5:
                                throw _t;
                            case 6:
                                return _context8.abrupt("return", this.initFromValues(fromValuesClientOptions, identifiers, customAttributesFromResult, experimentValues));
                            case 7:
                            case "end":
                                return _context8.stop();
                        }
                    }, _callee8, this, [
                        [
                            2,
                            4
                        ]
                    ]);
                }));
                function init(_x16, _x17, _x18) {
                    return _init.apply(this, arguments);
                }
                return init;
            }()
        },
        {
            key: "initWithProvider",
            value: function() {
                var _initWithProvider = (0, $bLOvh.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($a3FqH))).mark(function _callee9(baseClientOptions, provider, identifiers, customAttributes) {
                    var fromValuesClientOptions, experimentValues, customAttributesFromResult, clientSdkKeyPromise, experimentValuesPromise, _yield$Promise$all3, _yield$Promise$all4, experimentValuesResult, _t2;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($a3FqH))).wrap(function(_context9) {
                        while(true)switch(_context9.prev = _context9.next){
                            case 0:
                                fromValuesClientOptions = $3f603739ccb347dd$var$_objectSpread($3f603739ccb347dd$var$_objectSpread({}, baseClientOptions), {}, {
                                    disableCurrentPageLogging: true
                                });
                                _context9.prev = 1;
                                _context9.next = 2;
                                return provider.setProfile(baseClientOptions, identifiers, customAttributes);
                            case 2:
                                // If client sdk key fetch fails, an error would be thrown and handled instead of waiting for
                                // the experiment values request to be settled, and it will fall back to use default values.
                                clientSdkKeyPromise = provider.getClientSdkKey().then(function(value) {
                                    return fromValuesClientOptions.sdkKey = value;
                                });
                                experimentValuesPromise = provider.getExperimentValues(); // Only wait for the experiment values request to finish and try to initialise the client
                                // with experiment values if both requests are successful. Else an error would be thrown and
                                // handled by the catch
                                _context9.next = 3;
                                return Promise.all([
                                    clientSdkKeyPromise,
                                    experimentValuesPromise
                                ]);
                            case 3:
                                _yield$Promise$all3 = _context9.sent;
                                _yield$Promise$all4 = (0, $3OJNo.default)(_yield$Promise$all3, 2);
                                experimentValuesResult = _yield$Promise$all4[1];
                                experimentValues = experimentValuesResult.experimentValues;
                                customAttributesFromResult = experimentValuesResult.customAttributesFromFetch;
                                _context9.next = 6;
                                break;
                            case 4:
                                _context9.prev = 4;
                                _t2 = _context9["catch"](1);
                                if (_t2 instanceof Error) // eslint-disable-next-line no-console
                                console.error("Error occurred when trying to fetch the Feature Gates client values, error: ".concat(_t2 === null || _t2 === void 0 ? void 0 : _t2.message));
                                // eslint-disable-next-line no-console
                                console.warn("Initialising Statsig client without values");
                                _context9.next = 5;
                                return this.initFromValues(fromValuesClientOptions, identifiers, customAttributes);
                            case 5:
                                throw _t2;
                            case 6:
                                return _context9.abrupt("return", this.initFromValues(fromValuesClientOptions, identifiers, customAttributesFromResult, experimentValues));
                            case 7:
                            case "end":
                                return _context9.stop();
                        }
                    }, _callee9, this, [
                        [
                            1,
                            4
                        ]
                    ]);
                }));
                function initWithProvider(_x19, _x20, _x21, _x22) {
                    return _initWithProvider.apply(this, arguments);
                }
                return initWithProvider;
            }()
        },
        {
            key: "initFromValues",
            value: function() {
                var _initFromValues = (0, $bLOvh.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($a3FqH))).mark(function _callee0(clientOptions, identifiers, customAttributes) {
                    var _newClientOptions$net;
                    var initializeValues, newClientOptions, sdkKey, environment, _updateUserCompletionCallback, _perimeter, restClientOptions, frontendUser, statsigOptions, _args0 = arguments, _t3;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($a3FqH))).wrap(function(_context0) {
                        while(true)switch(_context0.prev = _context0.next){
                            case 0:
                                initializeValues = _args0.length > 3 && _args0[3] !== undefined ? _args0[3] : {};
                                this.overrideAdapter.initFromStoredOverrides();
                                this.currentIdentifiers = identifiers;
                                this.currentAttributes = customAttributes;
                                newClientOptions = (0, $f0l1D.migrateInitializationOptions)(clientOptions);
                                if (!newClientOptions.sdkKey) newClientOptions.sdkKey = $3f603739ccb347dd$var$DEFAULT_CLIENT_KEY;
                                if (!((_newClientOptions$net = newClientOptions.networkConfig) !== null && _newClientOptions$net !== void 0 && _newClientOptions$net.logEventUrl)) newClientOptions.networkConfig = $3f603739ccb347dd$var$_objectSpread($3f603739ccb347dd$var$_objectSpread({}, newClientOptions.networkConfig), {}, {
                                    logEventUrl: $3f603739ccb347dd$var$DEFAULT_EVENT_LOGGING_API
                                });
                                if (newClientOptions.perimeter === (0, $hiARP.PerimeterType).FEDRAMP_MODERATE) // disable all logging in FedRAMP to prevent egress of sensitive data
                                newClientOptions.disableLogging = true;
                                sdkKey = newClientOptions.sdkKey, environment = newClientOptions.environment, _updateUserCompletionCallback = newClientOptions.updateUserCompletionCallback, _perimeter = newClientOptions.perimeter, restClientOptions = (0, $ciEnq.default)(newClientOptions, $3f603739ccb347dd$var$_excluded);
                                frontendUser = (0, $3yi6c.toStatsigUser)(identifiers, customAttributes);
                                this.user = (0, $9sCMD.deepAssign)({}, initializeValues.user, frontendUser);
                                statsigOptions = $3f603739ccb347dd$var$_objectSpread($3f603739ccb347dd$var$_objectSpread({}, restClientOptions), {}, {
                                    environment: {
                                        tier: environment
                                    },
                                    includeCurrentPageUrlWithEvents: false,
                                    dataAdapter: this.dataAdapter,
                                    overrideAdapter: this.overrideAdapter,
                                    logEventCompressionMode: (0, $a0vkc.LogEventCompressionMode).Forced
                                }); // Statsig validates the provided stableId against their own cookie, so we either need
                                // to update the cookie to match, or disable the validation completely.
                                if (identifiers.stableId) (0, $a0vkc.StableID).setOverride(identifiers.stableId, sdkKey);
                                else statsigOptions.disableStableID = true;
                                _context0.prev = 1;
                                this.statsigClient = new (0, $a0vkc.StatsigClient)(sdkKey, this.user, statsigOptions);
                                this.dataAdapter.setBootstrapData(initializeValues);
                                _context0.next = 2;
                                return this.statsigClient.initializeAsync();
                            case 2:
                                _context0.next = 5;
                                break;
                            case 3:
                                _context0.prev = 3;
                                _t3 = _context0["catch"](1);
                                if (_t3 instanceof Error) // eslint-disable-next-line no-console
                                console.error("Error occurred when trying to initialise the Statsig client, error: ".concat(_t3 === null || _t3 === void 0 ? void 0 : _t3.message));
                                // eslint-disable-next-line no-console
                                console.warn("Initialising Statsig client with default sdk key and without values");
                                this.statsigClient = new (0, $a0vkc.StatsigClient)($3f603739ccb347dd$var$DEFAULT_CLIENT_KEY, this.user, statsigOptions);
                                this.dataAdapter.setBootstrapData();
                                _context0.next = 4;
                                return this.statsigClient.initializeAsync();
                            case 4:
                                this.initWithDefaults = true;
                                throw _t3;
                            case 5:
                            case "end":
                                return _context0.stop();
                        }
                    }, _callee0, this, [
                        [
                            1,
                            3
                        ]
                    ]);
                }));
                function initFromValues(_x23, _x24, _x25) {
                    return _initFromValues.apply(this, arguments);
                }
                return initFromValues;
            }()
        },
        {
            key: "updateUserUsingInitializeValuesProducer",
            value: function() {
                var _updateUserUsingInitializeValuesProducer = (0, $bLOvh.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($a3FqH))).mark(function _callee10(getInitializeValues, identifiers, customAttributes) {
                    var _this9 = this;
                    var originalInitPromise, initializeValuesPromise, updateUserPromise, _t4;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($a3FqH))).wrap(function(_context10) {
                        while(true)switch(_context10.prev = _context10.next){
                            case 0:
                                this.assertInitialized(this.statsigClient);
                                if (this.initPromise) {
                                    _context10.next = 1;
                                    break;
                                }
                                throw new Error('The client must be initialized before you can update the user.');
                            case 1:
                                if (!this.isCurrentUser(identifiers, customAttributes)) {
                                    _context10.next = 2;
                                    break;
                                }
                                return _context10.abrupt("return", this.initPromise);
                            case 2:
                                // Wait for the current initialize/update to finish
                                originalInitPromise = this.initPromise;
                                _context10.prev = 3;
                                _context10.next = 4;
                                return this.initPromise;
                            case 4:
                                _context10.next = 6;
                                break;
                            case 5:
                                _context10.prev = 5;
                                _t4 = _context10["catch"](3);
                            case 6:
                                initializeValuesPromise = getInitializeValues();
                                updateUserPromise = this.updateStatsigClientUser(initializeValuesPromise, identifiers, customAttributes); // We replace the init promise here since we are essentially re-initializing the client at this
                                // point. Any subsequent calls to await client.initialize() or client.updateUser()
                                // will now also await this user update.
                                this.initPromise = updateUserPromise.catch(/*#__PURE__*/ (0, $bLOvh.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($a3FqH))).mark(function _callee1() {
                                    return (0, (/*@__PURE__*/$parcel$interopDefault($a3FqH))).wrap(function(_context1) {
                                        while(true)switch(_context1.prev = _context1.next){
                                            case 0:
                                                // If the update failed then it changed nothing, so revert back to the original promise.
                                                _this9.initPromise = originalInitPromise;
                                                // Set the user profile again to revert back to the current user
                                                if (!_this9.provider) {
                                                    _context1.next = 1;
                                                    break;
                                                }
                                                _context1.next = 1;
                                                return _this9.provider.setProfile(_this9.initOptions, _this9.currentIdentifiers, _this9.currentAttributes);
                                            case 1:
                                            case "end":
                                                return _context1.stop();
                                        }
                                    }, _callee1);
                                })));
                                return _context10.abrupt("return", updateUserPromise);
                            case 7:
                            case "end":
                                return _context10.stop();
                        }
                    }, _callee10, this, [
                        [
                            3,
                            5
                        ]
                    ]);
                }));
                function updateUserUsingInitializeValuesProducer(_x26, _x27, _x28) {
                    return _updateUserUsingInitializeValuesProducer.apply(this, arguments);
                }
                return updateUserUsingInitializeValuesProducer;
            }()
        },
        {
            key: "updateStatsigClientUser",
            value: function() {
                var _updateStatsigClientUser = (0, $bLOvh.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($a3FqH))).mark(function _callee11(initializeValuesPromise, identifiers, customAttributes) {
                    var _this$initOptions, _this$initOptions$upd;
                    var initializeValues, user, frontendUser, _updateUserCompletion, _ref4, errMsg, success, errorMessage, _t5, _t6;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($a3FqH))).wrap(function(_context11) {
                        while(true)switch(_context11.prev = _context11.next){
                            case 0:
                                this.assertInitialized(this.statsigClient);
                                _context11.prev = 1;
                                _context11.next = 2;
                                return initializeValuesPromise;
                            case 2:
                                initializeValues = _context11.sent;
                                frontendUser = (0, $3yi6c.toStatsigUser)(identifiers, initializeValues.customAttributesFromFetch);
                                user = (0, $9sCMD.deepAssign)({}, initializeValues.experimentValues.user, frontendUser);
                                _context11.next = 4;
                                break;
                            case 3:
                                _context11.prev = 3;
                                _t5 = _context11["catch"](1);
                                // Make sure the updateUserCompletionCallback is called for any errors in our custom code.
                                // This is not necessary for the updateUserWithValues call, because the Statsig client will
                                // already invoke the callback itself.
                                errMsg = _t5 instanceof Error ? _t5.message : JSON.stringify(_t5);
                                (_updateUserCompletion = (_ref4 = this.initOptions).updateUserCompletionCallback) === null || _updateUserCompletion === void 0 || _updateUserCompletion.call(_ref4, false, errMsg);
                                throw _t5;
                            case 4:
                                success = true;
                                errorMessage = null;
                                _context11.prev = 5;
                                this.dataAdapter.setBootstrapData(initializeValues.experimentValues);
                                this.user = user;
                                if (!this.user) {
                                    _context11.next = 6;
                                    break;
                                }
                                _context11.next = 6;
                                return this.statsigClient.updateUserAsync(this.user);
                            case 6:
                                _context11.next = 8;
                                break;
                            case 7:
                                _context11.prev = 7;
                                _t6 = _context11["catch"](5);
                                success = false;
                                errorMessage = String(_t6);
                            case 8:
                                (_this$initOptions = this.initOptions) === null || _this$initOptions === void 0 || (_this$initOptions$upd = _this$initOptions.updateUserCompletionCallback) === null || _this$initOptions$upd === void 0 || _this$initOptions$upd.call(_this$initOptions, success, errorMessage);
                                if (!success) {
                                    _context11.next = 9;
                                    break;
                                }
                                this.currentIdentifiers = identifiers;
                                this.currentAttributes = customAttributes;
                                this.subscriptions.anyUpdated();
                                _context11.next = 10;
                                break;
                            case 9:
                                throw new Error('Failed to update user. An unexpected error occured.');
                            case 10:
                            case "end":
                                return _context11.stop();
                        }
                    }, _callee11, this, [
                        [
                            1,
                            3
                        ],
                        [
                            5,
                            7
                        ]
                    ]);
                }));
                function updateStatsigClientUser(_x29, _x30, _x31) {
                    return _updateStatsigClientUser.apply(this, arguments);
                }
                return updateStatsigClientUser;
            }()
        },
        {
            key: "getPackageVersion",
            value: /**
     * @returns string version of the current package in semver style.
     */ function getPackageVersion() {
                return 0, $7HOhT.CLIENT_VERSION;
            }
        },
        {
            key: "getTargetApp",
            value: function getTargetApp() {
                var _this$initOptions2;
                return (_this$initOptions2 = this.initOptions) === null || _this$initOptions2 === void 0 ? void 0 : _this$initOptions2.targetApp;
            }
        },
        {
            key: "getLayer",
            value: function getLayer(/** The name of the layer */ layerName) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                try {
                    this.assertInitialized(this.statsigClient);
                    var _options$fireLayerExp = options.fireLayerExposure, fireLayerExposure = _options$fireLayerExp === void 0 ? true : _options$fireLayerExp;
                    return (0, $eVlof.Layer).fromLayer(this.statsigClient.getLayer(layerName, {
                        disableExposureLog: !fireLayerExposure
                    }));
                } catch (error) {
                    // Log the first occurrence of the error
                    if (!this.hasGetLayerErrorOccurred) {
                        // eslint-disable-next-line no-console
                        console.warn({
                            msg: 'An error has occurred getting the layer. Only the first occurrence of this error is logged.',
                            layerName: layerName,
                            error: error
                        });
                        this.hasGetLayerErrorOccurred = true;
                    }
                    // Return a default value
                    return (0, $eVlof.Layer).fromLayer((0, $a0vkc._makeLayer)(layerName, {
                        reason: 'Error'
                    }, null));
                }
            }
        },
        {
            key: "getLayerValue",
            value: function getLayerValue(layerName, parameterName, defaultValue) {
                var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var layer = this.getLayer(layerName, options);
                try {
                    var typeGuard = options.typeGuard;
                    return layer.get(parameterName, defaultValue, typeGuard);
                } catch (error) {
                    // Log the first occurrence of the error
                    if (!this.hasGetLayerValueErrorOccurred) {
                        // eslint-disable-next-line no-console
                        console.warn({
                            msg: 'An error has occurred getting the layer value. Only the first occurrence of this error is logged.',
                            layerName: layerName,
                            defaultValue: defaultValue,
                            options: options,
                            error: error
                        });
                        this.hasGetLayerValueErrorOccurred = true;
                    }
                    return defaultValue;
                }
            }
        }
    ]);
}();

});
parcelRegister("ciEnq", function(module, exports) {
$parcel$export(module.exports, "default", () => $8f467c739d7789f3$export$2e2bcd8739ae039);

var $jh81X = parcelRequire("jh81X");
function $8f467c739d7789f3$export$2e2bcd8739ae039(e, t) {
    if (null == e) return {};
    var o, r, i = (0, $jh81X.default)(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}

});
parcelRegister("jh81X", function(module, exports) {
$parcel$export(module.exports, "default", () => $e085d58c6dc1bd76$export$2e2bcd8739ae039);
function $e085d58c6dc1bd76$export$2e2bcd8739ae039(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}

});


parcelRegister("3OJNo", function(module, exports) {
$parcel$export(module.exports, "default", () => $2c7990adb02af733$export$2e2bcd8739ae039);

var $djIFW = parcelRequire("djIFW");

var $6czkw = parcelRequire("6czkw");

var $MzX8A = parcelRequire("MzX8A");

var $aZwOO = parcelRequire("aZwOO");
function $2c7990adb02af733$export$2e2bcd8739ae039(r, e) {
    return (0, $djIFW.default)(r) || (0, $6czkw.default)(r, e) || (0, $MzX8A.default)(r, e) || (0, $aZwOO.default)();
}

});
parcelRegister("djIFW", function(module, exports) {
$parcel$export(module.exports, "default", () => $9b1fb4533258f95d$export$2e2bcd8739ae039);
function $9b1fb4533258f95d$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return r;
}

});

parcelRegister("6czkw", function(module, exports) {
$parcel$export(module.exports, "default", () => $483f44dbe566f291$export$2e2bcd8739ae039);
function $483f44dbe566f291$export$2e2bcd8739ae039(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}

});

parcelRegister("MzX8A", function(module, exports) {
$parcel$export(module.exports, "default", () => $09205f4ae1b377f4$export$2e2bcd8739ae039);

var $e7Y6Y = parcelRequire("e7Y6Y");
function $09205f4ae1b377f4$export$2e2bcd8739ae039(r, a) {
    if (r) {
        if ("string" == typeof r) return (0, $e7Y6Y.default)(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? (0, $e7Y6Y.default)(r, a) : void 0;
    }
}

});
parcelRegister("e7Y6Y", function(module, exports) {
$parcel$export(module.exports, "default", () => $a490590a1b68d4bb$export$2e2bcd8739ae039);
function $a490590a1b68d4bb$export$2e2bcd8739ae039(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}

});


parcelRegister("aZwOO", function(module, exports) {
$parcel$export(module.exports, "default", () => $80090ef674aab409$export$2e2bcd8739ae039);
function $80090ef674aab409$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});


parcelRegister("bLOvh", function(module, exports) {
$parcel$export(module.exports, "default", () => $891b427635b24e68$export$2e2bcd8739ae039);
function $891b427635b24e68$var$asyncGeneratorStep(n, t, e, r, o, a, c) {
    try {
        var i = n[a](c), u = i.value;
    } catch (n) {
        return void e(n);
    }
    i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function $891b427635b24e68$export$2e2bcd8739ae039(n) {
    return function() {
        var t = this, e = arguments;
        return new Promise(function(r, o) {
            var a = n.apply(t, e);
            function _next(n) {
                $891b427635b24e68$var$asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
            }
            function _throw(n) {
                $891b427635b24e68$var$asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
            }
            _next(void 0);
        });
    };
}

});

parcelRegister("a3FqH", function(module, exports) {
// TODO(Babel 8): Remove this file.

var $752a523c9214637b$var$runtime = (parcelRequire("i2gMv"))();
module.exports = $752a523c9214637b$var$runtime;
// Copied from https://github.com/facebook/regenerator/blob/main/packages/runtime/runtime.js#L736=
try {
    regeneratorRuntime = $752a523c9214637b$var$runtime;
} catch (accidentalStrictMode) {
    if (typeof globalThis === "object") globalThis.regeneratorRuntime = $752a523c9214637b$var$runtime;
    else Function("r", "regeneratorRuntime = r")($752a523c9214637b$var$runtime);
}

});
parcelRegister("i2gMv", function(module, exports) {

var $aQAJs = parcelRequire("aQAJs");
var $d2156e593cb5cd1f$var$_typeof = $aQAJs.default;
function $d2156e593cb5cd1f$var$_regeneratorRuntime() {
    "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ 
    module.exports = $d2156e593cb5cd1f$var$_regeneratorRuntime = function _regeneratorRuntime() {
        return e;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports;
    var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function(t, e, r) {
        t[e] = r.value;
    }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag";
    function define(t, e, r) {
        return Object.defineProperty(t, e, {
            value: r,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }), t[e];
    }
    try {
        define({}, "");
    } catch (t) {
        define = function define(t, e, r) {
            return t[e] = r;
        };
    }
    function wrap(t, e, r, n) {
        var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []);
        return o(a, "_invoke", {
            value: makeInvokeMethod(t, r, c)
        }), a;
    }
    function tryCatch(t, e, r) {
        try {
            return {
                type: "normal",
                arg: t.call(e, r)
            };
        } catch (t) {
            return {
                type: "throw",
                arg: t
            };
        }
    }
    e.wrap = wrap;
    var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {};
    function Generator() {}
    function GeneratorFunction() {}
    function GeneratorFunctionPrototype() {}
    var p = {};
    define(p, a, function() {
        return this;
    });
    var d = Object.getPrototypeOf, v = d && d(d(values([])));
    v && v !== r && n.call(v, a) && (p = v);
    var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p);
    function defineIteratorMethods(t) {
        [
            "next",
            "throw",
            "return"
        ].forEach(function(e) {
            define(t, e, function(t) {
                return this._invoke(e, t);
            });
        });
    }
    function AsyncIterator(t, e) {
        function invoke(r, o, i, a) {
            var c = tryCatch(t[r], t, o);
            if ("throw" !== c.type) {
                var u = c.arg, h = u.value;
                return h && "object" == $d2156e593cb5cd1f$var$_typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function(t) {
                    invoke("next", t, i, a);
                }, function(t) {
                    invoke("throw", t, i, a);
                }) : e.resolve(h).then(function(t) {
                    u.value = t, i(u);
                }, function(t) {
                    return invoke("throw", t, i, a);
                });
            }
            a(c.arg);
        }
        var r;
        o(this, "_invoke", {
            value: function value(t, n) {
                function callInvokeWithMethodAndArg() {
                    return new e(function(e, r) {
                        invoke(t, n, e, r);
                    });
                }
                return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
            }
        });
    }
    function makeInvokeMethod(e, r, n) {
        var o = h;
        return function(i, a) {
            if (o === f) throw Error("Generator is already running");
            if (o === s) {
                if ("throw" === i) throw a;
                return {
                    value: t,
                    done: !0
                };
            }
            for(n.method = i, n.arg = a;;){
                var c = n.delegate;
                if (c) {
                    var u = maybeInvokeDelegate(c, n);
                    if (u) {
                        if (u === y) continue;
                        return u;
                    }
                }
                if ("next" === n.method) n.sent = n._sent = n.arg;
                else if ("throw" === n.method) {
                    if (o === h) throw o = s, n.arg;
                    n.dispatchException(n.arg);
                } else "return" === n.method && n.abrupt("return", n.arg);
                o = f;
                var p = tryCatch(e, r, n);
                if ("normal" === p.type) {
                    if (o = n.done ? s : l, p.arg === y) continue;
                    return {
                        value: p.arg,
                        done: n.done
                    };
                }
                "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg);
            }
        };
    }
    function maybeInvokeDelegate(e, r) {
        var n = r.method, o = e.iterator[n];
        if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y;
        var i = tryCatch(o, e.iterator, r.arg);
        if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y;
        var a = i.arg;
        return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y);
    }
    function pushTryEntry(t) {
        var e = {
            tryLoc: t[0]
        };
        1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e);
    }
    function resetTryEntry(t) {
        var e = t.completion || {};
        e.type = "normal", delete e.arg, t.completion = e;
    }
    function Context(t) {
        this.tryEntries = [
            {
                tryLoc: "root"
            }
        ], t.forEach(pushTryEntry, this), this.reset(!0);
    }
    function values(e) {
        if (e || "" === e) {
            var r = e[a];
            if (r) return r.call(e);
            if ("function" == typeof e.next) return e;
            if (!isNaN(e.length)) {
                var o = -1, i = function next() {
                    for(; ++o < e.length;)if (n.call(e, o)) return next.value = e[o], next.done = !1, next;
                    return next.value = t, next.done = !0, next;
                };
                return i.next = i;
            }
        }
        throw new TypeError($d2156e593cb5cd1f$var$_typeof(e) + " is not iterable");
    }
    return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", {
        value: GeneratorFunctionPrototype,
        configurable: !0
    }), o(GeneratorFunctionPrototype, "constructor", {
        value: GeneratorFunction,
        configurable: !0
    }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function(t) {
        var e = "function" == typeof t && t.constructor;
        return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name));
    }, e.mark = function(t) {
        return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t;
    }, e.awrap = function(t) {
        return {
            __await: t
        };
    }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function() {
        return this;
    }), e.AsyncIterator = AsyncIterator, e.async = function(t, r, n, o, i) {
        void 0 === i && (i = Promise);
        var a = new AsyncIterator(wrap(t, r, n, o), i);
        return e.isGeneratorFunction(r) ? a : a.next().then(function(t) {
            return t.done ? t.value : a.next();
        });
    }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function() {
        return this;
    }), define(g, "toString", function() {
        return "[object Generator]";
    }), e.keys = function(t) {
        var e = Object(t), r = [];
        for(var n in e)r.push(n);
        return r.reverse(), function next() {
            for(; r.length;){
                var t = r.pop();
                if (t in e) return next.value = t, next.done = !1, next;
            }
            return next.done = !0, next;
        };
    }, e.values = values, Context.prototype = {
        constructor: Context,
        reset: function reset(e) {
            if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for(var r in this)"t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t);
        },
        stop: function stop() {
            this.done = !0;
            var t = this.tryEntries[0].completion;
            if ("throw" === t.type) throw t.arg;
            return this.rval;
        },
        dispatchException: function dispatchException(e) {
            if (this.done) throw e;
            var r = this;
            function handle(n, o) {
                return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o;
            }
            for(var o = this.tryEntries.length - 1; o >= 0; --o){
                var i = this.tryEntries[o], a = i.completion;
                if ("root" === i.tryLoc) return handle("end");
                if (i.tryLoc <= this.prev) {
                    var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc");
                    if (c && u) {
                        if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
                        if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
                    } else if (c) {
                        if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
                    } else {
                        if (!u) throw Error("try statement without catch or finally");
                        if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
                    }
                }
            }
        },
        abrupt: function abrupt(t, e) {
            for(var r = this.tryEntries.length - 1; r >= 0; --r){
                var o = this.tryEntries[r];
                if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
                    var i = o;
                    break;
                }
            }
            i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null);
            var a = i ? i.completion : {};
            return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a);
        },
        complete: function complete(t, e) {
            if ("throw" === t.type) throw t.arg;
            return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y;
        },
        finish: function finish(t) {
            for(var e = this.tryEntries.length - 1; e >= 0; --e){
                var r = this.tryEntries[e];
                if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y;
            }
        },
        "catch": function _catch(t) {
            for(var e = this.tryEntries.length - 1; e >= 0; --e){
                var r = this.tryEntries[e];
                if (r.tryLoc === t) {
                    var n = r.completion;
                    if ("throw" === n.type) {
                        var o = n.arg;
                        resetTryEntry(r);
                    }
                    return o;
                }
            }
            throw Error("illegal catch attempt");
        },
        delegateYield: function delegateYield(e, r, n) {
            return this.delegate = {
                iterator: values(e),
                resultName: r,
                nextLoc: n
            }, "next" === this.method && (this.arg = t), y;
        }
    }, e;
}
module.exports = $d2156e593cb5cd1f$var$_regeneratorRuntime, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("aQAJs", function(module, exports) {
function $7e5b40f734ed77c8$var$_typeof(o) {
    "@babel/helpers - typeof";
    return module.exports = $7e5b40f734ed77c8$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $7e5b40f734ed77c8$var$_typeof(o);
}
module.exports = $7e5b40f734ed77c8$var$_typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;

});



parcelRegister("a0vkc", function(module, exports) {
"use strict";
var $749233e9e979ea20$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $749233e9e979ea20$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $749233e9e979ea20$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.StatsigClient = void 0;


var $lu3xa = parcelRequire("lu3xa");
module.exports.StatsigClient = $lu3xa.default;

$749233e9e979ea20$var$__exportStar((parcelRequire("328Ep")), module.exports);
const $749233e9e979ea20$var$__STATSIG__ = Object.assign((0, (parcelRequire("328Ep"))._getStatsigGlobal)(), {
    StatsigClient: $lu3xa.default
});
module.exports.default = $749233e9e979ea20$var$__STATSIG__;

});
parcelRegister("328Ep", function(module, exports) {
"use strict";
var $235844d7ff90dd27$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $235844d7ff90dd27$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $235844d7ff90dd27$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Storage = module.exports.Log = module.exports.EventLogger = module.exports.Diagnostics = void 0;



Object.defineProperty(module.exports, "Diagnostics", {
    enumerable: true,
    get: function() {
        return (parcelRequire("4EJwp")).Diagnostics;
    }
});

var $dJrZC = parcelRequire("dJrZC");
Object.defineProperty(module.exports, "EventLogger", {
    enumerable: true,
    get: function() {
        return $dJrZC.EventLogger;
    }
});

Object.defineProperty(module.exports, "Log", {
    enumerable: true,
    get: function() {
        return (parcelRequire("9Qn0V")).Log;
    }
});


Object.defineProperty(module.exports, "Storage", {
    enumerable: true,
    get: function() {
        return (parcelRequire("jKkqw")).Storage;
    }
});

$235844d7ff90dd27$var$__exportStar((parcelRequire("8ZzeR")), module.exports);

$235844d7ff90dd27$var$__exportStar((parcelRequire("4KuM7")), module.exports);

$235844d7ff90dd27$var$__exportStar((parcelRequire("fivtj")), module.exports);

$235844d7ff90dd27$var$__exportStar((parcelRequire("a5r3l")), module.exports);

$235844d7ff90dd27$var$__exportStar((parcelRequire("4EJwp")), module.exports);

$235844d7ff90dd27$var$__exportStar((parcelRequire("ceicM")), module.exports);

$235844d7ff90dd27$var$__exportStar((parcelRequire("hpmwp")), module.exports);

$235844d7ff90dd27$var$__exportStar((parcelRequire("6lwLe")), module.exports);

$235844d7ff90dd27$var$__exportStar((parcelRequire("80W8k")), module.exports);

$235844d7ff90dd27$var$__exportStar((parcelRequire("doPF1")), module.exports);

$235844d7ff90dd27$var$__exportStar((parcelRequire("6vMkI")), module.exports);

$235844d7ff90dd27$var$__exportStar((parcelRequire("9Qn0V")), module.exports);

$235844d7ff90dd27$var$__exportStar((parcelRequire("4wyC3")), module.exports);

$235844d7ff90dd27$var$__exportStar((parcelRequire("3wynb")), module.exports);

$235844d7ff90dd27$var$__exportStar((parcelRequire("jCkUF")), module.exports);

$235844d7ff90dd27$var$__exportStar((parcelRequire("goCQh")), module.exports);

$235844d7ff90dd27$var$__exportStar((parcelRequire("lUQm9")), module.exports);

$235844d7ff90dd27$var$__exportStar((parcelRequire("hmoSx")), module.exports);

$235844d7ff90dd27$var$__exportStar((parcelRequire("9JrW9")), module.exports);

$235844d7ff90dd27$var$__exportStar((parcelRequire("ldhqF")), module.exports);

$235844d7ff90dd27$var$__exportStar((parcelRequire("hZIMt")), module.exports);

$235844d7ff90dd27$var$__exportStar((parcelRequire("177Kh")), module.exports);

$235844d7ff90dd27$var$__exportStar((parcelRequire("3VNWn")), module.exports);

$235844d7ff90dd27$var$__exportStar((parcelRequire("83Y6N")), module.exports);

$235844d7ff90dd27$var$__exportStar((parcelRequire("4H43E")), module.exports);

$235844d7ff90dd27$var$__exportStar((parcelRequire("gQtPt")), module.exports);

$235844d7ff90dd27$var$__exportStar((parcelRequire("kVJXW")), module.exports);

$235844d7ff90dd27$var$__exportStar((parcelRequire("baWwc")), module.exports);

$235844d7ff90dd27$var$__exportStar((parcelRequire("c3WPJ")), module.exports);

$235844d7ff90dd27$var$__exportStar((parcelRequire("li0QC")), module.exports);

$235844d7ff90dd27$var$__exportStar((parcelRequire("gGLwe")), module.exports);

$235844d7ff90dd27$var$__exportStar((parcelRequire("619VR")), module.exports);

$235844d7ff90dd27$var$__exportStar((parcelRequire("jKkqw")), module.exports);

$235844d7ff90dd27$var$__exportStar((parcelRequire("7PZBS")), module.exports);

$235844d7ff90dd27$var$__exportStar((parcelRequire("cvjEj")), module.exports);

$235844d7ff90dd27$var$__exportStar((parcelRequire("e7KD1")), module.exports);

$235844d7ff90dd27$var$__exportStar((parcelRequire("h59qk")), module.exports);

$235844d7ff90dd27$var$__exportStar((parcelRequire("gmCzl")), module.exports);

$235844d7ff90dd27$var$__exportStar((parcelRequire("kyXOf")), module.exports);

$235844d7ff90dd27$var$__exportStar((parcelRequire("8Glek")), module.exports);
Object.assign((0, (parcelRequire("8ZzeR"))._getStatsigGlobal)(), {
    Log: (parcelRequire("9Qn0V")).Log,
    SDK_VERSION: (parcelRequire("kVJXW")).SDK_VERSION
});

});
parcelRegister("8ZzeR", function(module, exports) {
"use strict";
/* eslint-disable @typescript-eslint/no-unsafe-assignment */ var $68bf5ae524b8dc6b$var$_a, $68bf5ae524b8dc6b$var$_b, $68bf5ae524b8dc6b$var$_c;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._getInstance = module.exports._getStatsigGlobalFlag = module.exports._getStatsigGlobal = void 0;

var $9Qn0V = parcelRequire("9Qn0V");
const $68bf5ae524b8dc6b$var$_getStatsigGlobal = ()=>{
    // Avoid ReferenceError, which is happening with Cloudflare pages
    try {
        return typeof __STATSIG__ !== 'undefined' ? __STATSIG__ : $68bf5ae524b8dc6b$var$statsigGlobal;
    } catch (e) {
        return $68bf5ae524b8dc6b$var$statsigGlobal;
    }
};
module.exports._getStatsigGlobal = $68bf5ae524b8dc6b$var$_getStatsigGlobal;
const $68bf5ae524b8dc6b$var$_getStatsigGlobalFlag = (flag)=>{
    return (0, module.exports._getStatsigGlobal)()[flag];
};
module.exports._getStatsigGlobalFlag = $68bf5ae524b8dc6b$var$_getStatsigGlobalFlag;
const $68bf5ae524b8dc6b$var$_getInstance = (sdkKey)=>{
    const gbl = (0, module.exports._getStatsigGlobal)();
    if (!sdkKey) {
        if (gbl.instances && Object.keys(gbl.instances).length > 1) $9Qn0V.Log.warn('Call made to Statsig global instance without an SDK key but there is more than one client instance. If you are using mulitple clients, please specify the SDK key.');
        return gbl.firstInstance;
    }
    return gbl.instances && gbl.instances[sdkKey];
};
module.exports._getInstance = $68bf5ae524b8dc6b$var$_getInstance;
const $68bf5ae524b8dc6b$var$GLOBAL_KEY = '__STATSIG__';
const $68bf5ae524b8dc6b$var$_window = typeof window !== 'undefined' ? window : {};
const $68bf5ae524b8dc6b$var$_global = typeof $parcel$global !== 'undefined' ? $parcel$global : {};
const $68bf5ae524b8dc6b$var$_globalThis = typeof globalThis !== 'undefined' ? globalThis : {};
const $68bf5ae524b8dc6b$var$statsigGlobal = ($68bf5ae524b8dc6b$var$_c = ($68bf5ae524b8dc6b$var$_b = ($68bf5ae524b8dc6b$var$_a = $68bf5ae524b8dc6b$var$_window[$68bf5ae524b8dc6b$var$GLOBAL_KEY]) !== null && $68bf5ae524b8dc6b$var$_a !== void 0 ? $68bf5ae524b8dc6b$var$_a : $68bf5ae524b8dc6b$var$_global[$68bf5ae524b8dc6b$var$GLOBAL_KEY]) !== null && $68bf5ae524b8dc6b$var$_b !== void 0 ? $68bf5ae524b8dc6b$var$_b : $68bf5ae524b8dc6b$var$_globalThis[$68bf5ae524b8dc6b$var$GLOBAL_KEY]) !== null && $68bf5ae524b8dc6b$var$_c !== void 0 ? $68bf5ae524b8dc6b$var$_c : {
    instance: module.exports._getInstance
};
$68bf5ae524b8dc6b$var$_window[$68bf5ae524b8dc6b$var$GLOBAL_KEY] = $68bf5ae524b8dc6b$var$statsigGlobal;
$68bf5ae524b8dc6b$var$_global[$68bf5ae524b8dc6b$var$GLOBAL_KEY] = $68bf5ae524b8dc6b$var$statsigGlobal;
$68bf5ae524b8dc6b$var$_globalThis[$68bf5ae524b8dc6b$var$GLOBAL_KEY] = $68bf5ae524b8dc6b$var$statsigGlobal;

});
parcelRegister("9Qn0V", function(module, exports) {
"use strict";
/* eslint-disable no-console */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Log = module.exports.LogLevel = void 0;
// intentionally spaced for formatting
const $72aad2747eb95ea5$var$DEBUG = ' DEBUG ';
const $72aad2747eb95ea5$var$_INFO = '  INFO ';
const $72aad2747eb95ea5$var$_WARN = '  WARN ';
const $72aad2747eb95ea5$var$ERROR = ' ERROR ';
function $72aad2747eb95ea5$var$addTag(args) {
    args.unshift('[Statsig]');
    return args; // ['[Statsig]', ...args];
}
module.exports.LogLevel = {
    None: 0,
    Error: 1,
    Warn: 2,
    Info: 3,
    Debug: 4
};
class $72aad2747eb95ea5$var$Log {
    static info(...args) {
        if ($72aad2747eb95ea5$var$Log.level >= module.exports.LogLevel.Info) console.info($72aad2747eb95ea5$var$_INFO, ...$72aad2747eb95ea5$var$addTag(args));
    }
    static debug(...args) {
        if ($72aad2747eb95ea5$var$Log.level >= module.exports.LogLevel.Debug) console.debug($72aad2747eb95ea5$var$DEBUG, ...$72aad2747eb95ea5$var$addTag(args));
    }
    static warn(...args) {
        if ($72aad2747eb95ea5$var$Log.level >= module.exports.LogLevel.Warn) console.warn($72aad2747eb95ea5$var$_WARN, ...$72aad2747eb95ea5$var$addTag(args));
    }
    static error(...args) {
        if ($72aad2747eb95ea5$var$Log.level >= module.exports.LogLevel.Error) console.error($72aad2747eb95ea5$var$ERROR, ...$72aad2747eb95ea5$var$addTag(args));
    }
}
module.exports.Log = $72aad2747eb95ea5$var$Log;
$72aad2747eb95ea5$var$Log.level = module.exports.LogLevel.Warn;

});


parcelRegister("4EJwp", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Diagnostics = void 0;
const $363e358232e7468f$var$MARKER_MAP = new Map();
const $363e358232e7468f$var$ACT_START = 'start';
const $363e358232e7468f$var$ACT_END = 'end';
const $363e358232e7468f$var$DIAGNOSTICS_EVENT = 'statsig::diagnostics';
module.exports.Diagnostics = {
    _getMarkers: (sdkKey)=>{
        return $363e358232e7468f$var$MARKER_MAP.get(sdkKey);
    },
    _markInitOverallStart: (sdkKey)=>{
        $363e358232e7468f$var$_addMarker(sdkKey, $363e358232e7468f$var$_createMarker({}, $363e358232e7468f$var$ACT_START, 'overall'));
    },
    _markInitOverallEnd: (sdkKey, success, evaluationDetails)=>{
        $363e358232e7468f$var$_addMarker(sdkKey, $363e358232e7468f$var$_createMarker({
            success: success,
            error: success ? undefined : {
                name: 'InitializeError',
                message: 'Failed to initialize'
            },
            evaluationDetails: evaluationDetails
        }, $363e358232e7468f$var$ACT_END, 'overall'));
    },
    _markInitNetworkReqStart: (sdkKey, data)=>{
        $363e358232e7468f$var$_addMarker(sdkKey, $363e358232e7468f$var$_createMarker(data, $363e358232e7468f$var$ACT_START, 'initialize', 'network_request'));
    },
    _markInitNetworkReqEnd: (sdkKey, data)=>{
        $363e358232e7468f$var$_addMarker(sdkKey, $363e358232e7468f$var$_createMarker(data, $363e358232e7468f$var$ACT_END, 'initialize', 'network_request'));
    },
    _markInitProcessStart: (sdkKey)=>{
        $363e358232e7468f$var$_addMarker(sdkKey, $363e358232e7468f$var$_createMarker({}, $363e358232e7468f$var$ACT_START, 'initialize', 'process'));
    },
    _markInitProcessEnd: (sdkKey, data)=>{
        $363e358232e7468f$var$_addMarker(sdkKey, $363e358232e7468f$var$_createMarker(data, $363e358232e7468f$var$ACT_END, 'initialize', 'process'));
    },
    _clearMarkers: (sdkKey)=>{
        $363e358232e7468f$var$MARKER_MAP.delete(sdkKey);
    },
    _formatError (e) {
        if (!(e && typeof e === 'object')) return;
        return {
            code: $363e358232e7468f$var$_safeGetField(e, 'code'),
            name: $363e358232e7468f$var$_safeGetField(e, 'name'),
            message: $363e358232e7468f$var$_safeGetField(e, 'message')
        };
    },
    _getDiagnosticsData (res, attempt, body, e) {
        var _a;
        return {
            success: (res === null || res === void 0 ? void 0 : res.ok) === true,
            statusCode: res === null || res === void 0 ? void 0 : res.status,
            sdkRegion: (_a = res === null || res === void 0 ? void 0 : res.headers) === null || _a === void 0 ? void 0 : _a.get('x-statsig-region'),
            isDelta: body.includes('"is_delta":true') === true ? true : undefined,
            attempt: attempt,
            error: module.exports.Diagnostics._formatError(e)
        };
    },
    _enqueueDiagnosticsEvent (user, logger, sdk, options) {
        const markers = module.exports.Diagnostics._getMarkers(sdk);
        if (markers == null || markers.length <= 0) return -1;
        const overallInitDuration = markers[markers.length - 1].timestamp - markers[0].timestamp;
        module.exports.Diagnostics._clearMarkers(sdk);
        const event = $363e358232e7468f$var$_makeDiagnosticsEvent(user, {
            context: 'initialize',
            markers: markers.slice(),
            statsigOptions: options
        });
        logger.enqueue(event);
        return overallInitDuration;
    }
};
function $363e358232e7468f$var$_createMarker(data, action, key, step) {
    return Object.assign({
        key: key,
        action: action,
        step: step,
        timestamp: Date.now()
    }, data);
}
function $363e358232e7468f$var$_makeDiagnosticsEvent(user, data) {
    const latencyEvent = {
        eventName: $363e358232e7468f$var$DIAGNOSTICS_EVENT,
        user: user,
        value: null,
        metadata: data,
        time: Date.now()
    };
    return latencyEvent;
}
function $363e358232e7468f$var$_addMarker(sdkKey, marker) {
    var _a;
    const markers = (_a = $363e358232e7468f$var$MARKER_MAP.get(sdkKey)) !== null && _a !== void 0 ? _a : [];
    markers.push(marker);
    $363e358232e7468f$var$MARKER_MAP.set(sdkKey, markers);
}
function $363e358232e7468f$var$_safeGetField(data, field) {
    if (field in data) return data[field];
    return undefined;
}

});

parcelRegister("dJrZC", function(module, exports) {
"use strict";
var $9ff5311fd4543616$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.EventLogger = void 0;

var $4KuM7 = parcelRequire("4KuM7");

var $doPF1 = parcelRequire("doPF1");

var $9Qn0V = parcelRequire("9Qn0V");

var $3wynb = parcelRequire("3wynb");

var $hmoSx = parcelRequire("hmoSx");

var $gQtPt = parcelRequire("gQtPt");

var $baWwc = parcelRequire("baWwc");

var $jKkqw = parcelRequire("jKkqw");

var $e7KD1 = parcelRequire("e7KD1");

var $gmCzl = parcelRequire("gmCzl");
const $9ff5311fd4543616$var$DEFAULT_QUEUE_SIZE = 100;
const $9ff5311fd4543616$var$DEFAULT_FLUSH_INTERVAL_MS = 10000;
const $9ff5311fd4543616$var$MAX_DEDUPER_KEYS = 1000;
const $9ff5311fd4543616$var$DEDUPER_WINDOW_DURATION_MS = 600000;
const $9ff5311fd4543616$var$MAX_FAILED_LOGS = 500;
const $9ff5311fd4543616$var$QUICK_FLUSH_WINDOW_MS = 200;
const $9ff5311fd4543616$var$EVENT_LOGGER_MAP = {};
class $9ff5311fd4543616$var$EventLogger {
    static _safeFlushAndForget(sdkKey) {
        var _a;
        (_a = $9ff5311fd4543616$var$EVENT_LOGGER_MAP[sdkKey]) === null || _a === void 0 || _a.flush().catch(()=>{
        // noop
        });
    }
    static _safeRetryFailedLogs(sdkKey) {
        var _a;
        (_a = $9ff5311fd4543616$var$EVENT_LOGGER_MAP[sdkKey]) === null || _a === void 0 || _a._retryFailedLogs();
    }
    constructor(_sdkKey, _emitter, _network, _options){
        var _a, _b;
        this._sdkKey = _sdkKey;
        this._emitter = _emitter;
        this._network = _network;
        this._options = _options;
        this._queue = [];
        this._lastExposureTimeMap = {};
        this._nonExposedChecks = {};
        this._hasRunQuickFlush = false;
        this._creationTime = Date.now();
        this._loggingEnabled = (_a = _options === null || _options === void 0 ? void 0 : _options.loggingEnabled) !== null && _a !== void 0 ? _a : (_options === null || _options === void 0 ? void 0 : _options.disableLogging) === true ? $baWwc.LoggingEnabledOption.disabled : $baWwc.LoggingEnabledOption.browserOnly;
        if ((_options === null || _options === void 0 ? void 0 : _options.loggingEnabled) && _options.disableLogging !== undefined) $9Qn0V.Log.warn('Detected both loggingEnabled and disableLogging options. loggingEnabled takes precedence - please remove disableLogging.');
        this._maxQueueSize = (_b = _options === null || _options === void 0 ? void 0 : _options.loggingBufferMaxSize) !== null && _b !== void 0 ? _b : $9ff5311fd4543616$var$DEFAULT_QUEUE_SIZE;
        const config = _options === null || _options === void 0 ? void 0 : _options.networkConfig;
        this._logEventUrlConfig = new $e7KD1.UrlConfiguration($3wynb.Endpoint._rgstr, config === null || config === void 0 ? void 0 : config.logEventUrl, config === null || config === void 0 ? void 0 : config.api, config === null || config === void 0 ? void 0 : config.logEventFallbackUrls);
    }
    setLogEventCompressionMode(mode) {
        this._network.setLogEventCompressionMode(mode);
    }
    setLoggingEnabled(loggingEnabled) {
        if (this._loggingEnabled === 'disabled' && loggingEnabled !== 'disabled') {
            // load any pre consented events into memory
            const storageKey = this._getStorageKey();
            const events = (0, $jKkqw._getObjectFromStorage)(storageKey);
            if (events) this._queue.push(...events);
            $jKkqw.Storage.removeItem(storageKey);
        }
        this._loggingEnabled = loggingEnabled;
    }
    enqueue(event) {
        if (!this._shouldLogEvent(event)) return;
        this._normalizeAndAppendEvent(event);
        this._quickFlushIfNeeded();
        if (this._queue.length > this._maxQueueSize) $9ff5311fd4543616$var$EventLogger._safeFlushAndForget(this._sdkKey);
    }
    incrementNonExposureCount(name) {
        var _a;
        const current = (_a = this._nonExposedChecks[name]) !== null && _a !== void 0 ? _a : 0;
        this._nonExposedChecks[name] = current + 1;
    }
    reset() {
        // attempt to flush any remaining events
        this.flush().catch(()=>{
        // noop
        });
        this._lastExposureTimeMap = {};
    }
    start() {
        var _a;
        const isServerEnv = (0, $hmoSx._isServerEnv)();
        if (isServerEnv && ((_a = this._options) === null || _a === void 0 ? void 0 : _a.loggingEnabled) !== 'always') return;
        $9ff5311fd4543616$var$EVENT_LOGGER_MAP[this._sdkKey] = this;
        if (!isServerEnv) (0, $gmCzl._subscribeToVisiblityChanged)((visibility)=>{
            if (visibility === 'background') $9ff5311fd4543616$var$EventLogger._safeFlushAndForget(this._sdkKey);
            else if (visibility === 'foreground') $9ff5311fd4543616$var$EventLogger._safeRetryFailedLogs(this._sdkKey);
        });
        this._retryFailedLogs();
        this._startBackgroundFlushInterval();
    }
    stop() {
        return $9ff5311fd4543616$var$__awaiter(this, void 0, void 0, function*() {
            if (this._flushIntervalId) {
                clearInterval(this._flushIntervalId);
                this._flushIntervalId = null;
            }
            delete $9ff5311fd4543616$var$EVENT_LOGGER_MAP[this._sdkKey];
            yield this.flush();
        });
    }
    flush() {
        return $9ff5311fd4543616$var$__awaiter(this, void 0, void 0, function*() {
            this._appendAndResetNonExposedChecks();
            if (this._queue.length === 0) return;
            const events = this._queue;
            this._queue = [];
            yield this._sendEvents(events);
        });
    }
    /**
     * We 'Quick Flush' following the very first event enqueued
     * within the quick flush window
     */ _quickFlushIfNeeded() {
        if (this._hasRunQuickFlush) return;
        this._hasRunQuickFlush = true;
        if (Date.now() - this._creationTime > $9ff5311fd4543616$var$QUICK_FLUSH_WINDOW_MS) return;
        setTimeout(()=>$9ff5311fd4543616$var$EventLogger._safeFlushAndForget(this._sdkKey), $9ff5311fd4543616$var$QUICK_FLUSH_WINDOW_MS);
    }
    _shouldLogEvent(event) {
        var _a;
        if (((_a = this._options) === null || _a === void 0 ? void 0 : _a.loggingEnabled) !== 'always' && (0, $hmoSx._isServerEnv)()) return false;
        if (!(0, $gQtPt._isExposureEvent)(event)) return true;
        const user = event.user ? event.user : {
            statsigEnvironment: undefined
        };
        const userKey = (0, $4KuM7._getUserStorageKey)(this._sdkKey, user);
        const metadata = event.metadata ? event.metadata : {};
        const key = [
            event.eventName,
            userKey,
            metadata['gate'],
            metadata['config'],
            metadata['ruleID'],
            metadata['allocatedExperiment'],
            metadata['parameterName'],
            String(metadata['isExplicitParameter']),
            metadata['reason']
        ].join('|');
        const previous = this._lastExposureTimeMap[key];
        const now = Date.now();
        if (previous && now - previous < $9ff5311fd4543616$var$DEDUPER_WINDOW_DURATION_MS) return false;
        if (Object.keys(this._lastExposureTimeMap).length > $9ff5311fd4543616$var$MAX_DEDUPER_KEYS) this._lastExposureTimeMap = {};
        this._lastExposureTimeMap[key] = now;
        return true;
    }
    _sendEvents(events) {
        return $9ff5311fd4543616$var$__awaiter(this, void 0, void 0, function*() {
            var _a, _b;
            if (this._loggingEnabled === 'disabled') {
                this._saveFailedLogsToStorage(events);
                return false;
            }
            try {
                const isClosing = (0, $gmCzl._isUnloading)();
                const shouldUseBeacon = isClosing && this._network.isBeaconSupported() && ((_b = (_a = this._options) === null || _a === void 0 ? void 0 : _a.networkConfig) === null || _b === void 0 ? void 0 : _b.networkOverrideFunc) == null;
                this._emitter({
                    name: 'pre_logs_flushed',
                    events: events
                });
                const response = shouldUseBeacon ? this._sendEventsViaBeacon(events) : yield this._sendEventsViaPost(events);
                if (response.success) {
                    this._emitter({
                        name: 'logs_flushed',
                        events: events
                    });
                    return true;
                } else {
                    $9Qn0V.Log.warn('Failed to flush events.');
                    this._saveFailedLogsToStorage(events);
                    return false;
                }
            } catch (_c) {
                $9Qn0V.Log.warn('Failed to flush events.');
                return false;
            }
        });
    }
    _sendEventsViaPost(events) {
        return $9ff5311fd4543616$var$__awaiter(this, void 0, void 0, function*() {
            var _a;
            const result = yield this._network.post(this._getRequestData(events));
            const code = (_a = result === null || result === void 0 ? void 0 : result.code) !== null && _a !== void 0 ? _a : -1;
            return {
                success: code >= 200 && code < 300
            };
        });
    }
    _sendEventsViaBeacon(events) {
        return {
            success: this._network.beacon(this._getRequestData(events))
        };
    }
    _getRequestData(events) {
        return {
            sdkKey: this._sdkKey,
            data: {
                events: events
            },
            urlConfig: this._logEventUrlConfig,
            retries: 3,
            isCompressable: true,
            params: {
                [$3wynb.NetworkParam.EventCount]: String(events.length)
            },
            credentials: 'same-origin'
        };
    }
    _saveFailedLogsToStorage(events) {
        while(events.length > $9ff5311fd4543616$var$MAX_FAILED_LOGS)events.shift();
        const storageKey = this._getStorageKey();
        try {
            const savedEvents = this._getFailedLogsFromStorage(storageKey);
            (0, $jKkqw._setObjectInStorage)(storageKey, [
                ...savedEvents,
                ...events
            ]);
        } catch (_a) {
            $9Qn0V.Log.warn('Unable to save failed logs to storage');
        }
    }
    _getFailedLogsFromStorage(storageKey) {
        let savedEvents = [];
        try {
            const retrieved = (0, $jKkqw._getObjectFromStorage)(storageKey);
            if (Array.isArray(retrieved)) savedEvents = retrieved;
            return savedEvents;
        } catch (_a) {
            return [];
        }
    }
    _retryFailedLogs() {
        const storageKey = this._getStorageKey();
        (()=>$9ff5311fd4543616$var$__awaiter(this, void 0, void 0, function*() {
                if (!$jKkqw.Storage.isReady()) yield $jKkqw.Storage.isReadyResolver();
                const events = (0, $jKkqw._getObjectFromStorage)(storageKey);
                if (!events) return;
                $jKkqw.Storage.removeItem(storageKey);
                yield this._sendEvents(events);
            }))().catch(()=>{
            $9Qn0V.Log.warn('Failed to flush stored logs');
        });
    }
    _getStorageKey() {
        return `statsig.failed_logs.${(0, $doPF1._DJB2)(this._sdkKey)}`;
    }
    _normalizeAndAppendEvent(event) {
        if (event.user) {
            event.user = Object.assign({}, event.user);
            delete event.user.privateAttributes;
        }
        const extras = {};
        const currentPage = this._getCurrentPageUrl();
        if (currentPage) extras.statsigMetadata = {
            currentPage: currentPage
        };
        const final = Object.assign(Object.assign({}, event), extras);
        $9Qn0V.Log.debug('Enqueued Event:', final);
        this._queue.push(final);
    }
    _appendAndResetNonExposedChecks() {
        if (Object.keys(this._nonExposedChecks).length === 0) return;
        this._normalizeAndAppendEvent({
            eventName: 'statsig::non_exposed_checks',
            user: null,
            time: Date.now(),
            metadata: {
                checks: Object.assign({}, this._nonExposedChecks)
            }
        });
        this._nonExposedChecks = {};
    }
    _getCurrentPageUrl() {
        var _a;
        if (((_a = this._options) === null || _a === void 0 ? void 0 : _a.includeCurrentPageUrlWithEvents) === false) return;
        return (0, $hmoSx._getCurrentPageUrlSafe)();
    }
    _startBackgroundFlushInterval() {
        var _a, _b;
        const flushInterval = (_b = (_a = this._options) === null || _a === void 0 ? void 0 : _a.loggingIntervalMs) !== null && _b !== void 0 ? _b : $9ff5311fd4543616$var$DEFAULT_FLUSH_INTERVAL_MS;
        const intervalId = setInterval(()=>{
            const logger = $9ff5311fd4543616$var$EVENT_LOGGER_MAP[this._sdkKey];
            if (!logger || logger._flushIntervalId !== intervalId) clearInterval(intervalId);
            else $9ff5311fd4543616$var$EventLogger._safeFlushAndForget(this._sdkKey);
        }, flushInterval);
        this._flushIntervalId = intervalId;
    }
}
module.exports.EventLogger = $9ff5311fd4543616$var$EventLogger;

});
parcelRegister("4KuM7", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._getStorageKey = module.exports._getUserStorageKey = void 0;

var $doPF1 = parcelRequire("doPF1");
function $3753549ef8303d40$var$_getUserStorageKey(sdkKey, user, customKeyGenerator) {
    var _a;
    if (customKeyGenerator) return customKeyGenerator(sdkKey, user);
    const cids = user && user.customIDs ? user.customIDs : {};
    const parts = [
        `uid:${(_a = user === null || user === void 0 ? void 0 : user.userID) !== null && _a !== void 0 ? _a : ''}`,
        `cids:${Object.keys(cids).sort((leftKey, rightKey)=>leftKey.localeCompare(rightKey)).map((key)=>`${key}-${cids[key]}`).join(',')}`,
        `k:${sdkKey}`
    ];
    return (0, $doPF1._DJB2)(parts.join('|'));
}
module.exports._getUserStorageKey = $3753549ef8303d40$var$_getUserStorageKey;
function $3753549ef8303d40$var$_getStorageKey(sdkKey, user, customKeyGenerator) {
    if (user) return $3753549ef8303d40$var$_getUserStorageKey(sdkKey, user, customKeyGenerator);
    return (0, $doPF1._DJB2)(`k:${sdkKey}`);
}
module.exports._getStorageKey = $3753549ef8303d40$var$_getStorageKey;

});
parcelRegister("doPF1", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._getSortedObject = module.exports._DJB2Object = module.exports._DJB2 = void 0;

var $cvjEj = parcelRequire("cvjEj");
const $9c1596f7cf1506ee$var$_DJB2 = (value)=>{
    let hash = 0;
    for(let i = 0; i < value.length; i++){
        const character = value.charCodeAt(i);
        hash = (hash << 5) - hash + character;
        hash = hash & hash; // Convert to 32bit integer
    }
    return String(hash >>> 0);
};
module.exports._DJB2 = $9c1596f7cf1506ee$var$_DJB2;
const $9c1596f7cf1506ee$var$_DJB2Object = (value, maxLevels)=>{
    return (0, module.exports._DJB2)(JSON.stringify((0, module.exports._getSortedObject)(value, maxLevels)));
};
module.exports._DJB2Object = $9c1596f7cf1506ee$var$_DJB2Object;
const $9c1596f7cf1506ee$var$_getSortedObject = (object, maxDepth)=>{
    if (object == null) return null;
    const keys = Object.keys(object).sort();
    const sortedObject = {};
    keys.forEach((key)=>{
        const value = object[key];
        if (maxDepth === 0 || (0, $cvjEj._typeOf)(value) !== 'object') {
            sortedObject[key] = value;
            return;
        }
        sortedObject[key] = (0, module.exports._getSortedObject)(value, maxDepth != null ? maxDepth - 1 : maxDepth);
    });
    return sortedObject;
};
module.exports._getSortedObject = $9c1596f7cf1506ee$var$_getSortedObject;

});
parcelRegister("cvjEj", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._isTypeMatch = module.exports._typeOf = void 0;
function $91a79f34841955f8$var$_typeOf(input) {
    return Array.isArray(input) ? 'array' : typeof input;
}
module.exports._typeOf = $91a79f34841955f8$var$_typeOf;
function $91a79f34841955f8$var$_isTypeMatch(a, b) {
    const typeOf = (x)=>Array.isArray(x) ? 'array' : x === null ? 'null' : typeof x;
    return typeOf(a) === typeOf(b);
}
module.exports._isTypeMatch = $91a79f34841955f8$var$_isTypeMatch;

});



parcelRegister("3wynb", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.NetworkParam = module.exports.NetworkDefault = module.exports.Endpoint = void 0;
module.exports.Endpoint = {
    _initialize: 'initialize',
    _rgstr: 'rgstr',
    _download_config_specs: 'download_config_specs'
};
module.exports.NetworkDefault = {
    [module.exports.Endpoint._rgstr]: 'https://prodregistryv2.org/v1',
    [module.exports.Endpoint._initialize]: 'https://featureassets.org/v1',
    [module.exports.Endpoint._download_config_specs]: 'https://api.statsigcdn.com/v1'
};
module.exports.NetworkParam = {
    EventCount: 'ec',
    SdkKey: 'k',
    SdkType: 'st',
    SdkVersion: 'sv',
    Time: 't',
    SessionID: 'sid',
    StatsigEncoded: 'se',
    IsGzipped: 'gz'
};

});

parcelRegister("hmoSx", function(module, exports) {

var $3ZMUU = parcelRequire("3ZMUU");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._getUnloadEvent = module.exports._getCurrentPageUrlSafe = module.exports._addDocumentEventListenerSafe = module.exports._addWindowEventListenerSafe = module.exports._isServerEnv = module.exports._getDocumentSafe = module.exports._getWindowSafe = void 0;
const $ca37ca24bb1bb692$var$_getWindowSafe = ()=>{
    return typeof window !== 'undefined' ? window : null;
};
module.exports._getWindowSafe = $ca37ca24bb1bb692$var$_getWindowSafe;
const $ca37ca24bb1bb692$var$_getDocumentSafe = ()=>{
    var _a;
    const win = (0, module.exports._getWindowSafe)();
    return (_a = win === null || win === void 0 ? void 0 : win.document) !== null && _a !== void 0 ? _a : null;
};
module.exports._getDocumentSafe = $ca37ca24bb1bb692$var$_getDocumentSafe;
const $ca37ca24bb1bb692$var$_isServerEnv = ()=>{
    if ((0, module.exports._getDocumentSafe)() !== null) return false;
    const isNode = typeof $3ZMUU !== 'undefined' && $3ZMUU.versions != null && $3ZMUU.versions.node != null;
    const isVercel = typeof EdgeRuntime === 'string';
    return isVercel || isNode;
};
module.exports._isServerEnv = $ca37ca24bb1bb692$var$_isServerEnv;
const $ca37ca24bb1bb692$var$_addWindowEventListenerSafe = (key, listener)=>{
    const win = (0, module.exports._getWindowSafe)();
    if (typeof (win === null || win === void 0 ? void 0 : win.addEventListener) === 'function') win.addEventListener(key, listener);
};
module.exports._addWindowEventListenerSafe = $ca37ca24bb1bb692$var$_addWindowEventListenerSafe;
const $ca37ca24bb1bb692$var$_addDocumentEventListenerSafe = (key, listener)=>{
    const doc = (0, module.exports._getDocumentSafe)();
    if (typeof (doc === null || doc === void 0 ? void 0 : doc.addEventListener) === 'function') doc.addEventListener(key, listener);
};
module.exports._addDocumentEventListenerSafe = $ca37ca24bb1bb692$var$_addDocumentEventListenerSafe;
const $ca37ca24bb1bb692$var$_getCurrentPageUrlSafe = ()=>{
    var _a;
    try {
        return (_a = (0, module.exports._getWindowSafe)()) === null || _a === void 0 ? void 0 : _a.location.href.split(/[?#]/)[0];
    } catch (_b) {
        return;
    }
};
module.exports._getCurrentPageUrlSafe = $ca37ca24bb1bb692$var$_getCurrentPageUrlSafe;
const $ca37ca24bb1bb692$var$_getUnloadEvent = ()=>{
    const win = (0, module.exports._getWindowSafe)();
    if (!win) return 'beforeunload';
    const eventType = 'onpagehide' in win ? 'pagehide' : 'beforeunload';
    return eventType;
};
module.exports._getUnloadEvent = $ca37ca24bb1bb692$var$_getUnloadEvent;

});

parcelRegister("gQtPt", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._createLayerParameterExposure = module.exports._createConfigExposure = module.exports._mapExposures = module.exports._createGateExposure = module.exports._isExposureEvent = void 0;
const $c438a41d8ab9430d$var$CONFIG_EXPOSURE_NAME = 'statsig::config_exposure';
const $c438a41d8ab9430d$var$GATE_EXPOSURE_NAME = 'statsig::gate_exposure';
const $c438a41d8ab9430d$var$LAYER_EXPOSURE_NAME = 'statsig::layer_exposure';
const $c438a41d8ab9430d$var$_createExposure = (eventName, user, details, metadata, secondaryExposures)=>{
    if (details.bootstrapMetadata) metadata['bootstrapMetadata'] = details.bootstrapMetadata;
    return {
        eventName: eventName,
        user: user,
        value: null,
        metadata: $c438a41d8ab9430d$var$_addEvaluationDetailsToMetadata(details, metadata),
        secondaryExposures: secondaryExposures,
        time: Date.now()
    };
};
const $c438a41d8ab9430d$var$_isExposureEvent = ({ eventName: eventName })=>{
    return eventName === $c438a41d8ab9430d$var$GATE_EXPOSURE_NAME || eventName === $c438a41d8ab9430d$var$CONFIG_EXPOSURE_NAME || eventName === $c438a41d8ab9430d$var$LAYER_EXPOSURE_NAME;
};
module.exports._isExposureEvent = $c438a41d8ab9430d$var$_isExposureEvent;
const $c438a41d8ab9430d$var$_createGateExposure = (user, gate, exposureMapping)=>{
    var _a, _b, _c;
    const metadata = {
        gate: gate.name,
        gateValue: String(gate.value),
        ruleID: gate.ruleID
    };
    if (((_a = gate.__evaluation) === null || _a === void 0 ? void 0 : _a.version) != null) metadata['configVersion'] = gate.__evaluation.version;
    return $c438a41d8ab9430d$var$_createExposure($c438a41d8ab9430d$var$GATE_EXPOSURE_NAME, user, gate.details, metadata, $c438a41d8ab9430d$var$_mapExposures((_c = (_b = gate.__evaluation) === null || _b === void 0 ? void 0 : _b.secondary_exposures) !== null && _c !== void 0 ? _c : [], exposureMapping));
};
module.exports._createGateExposure = $c438a41d8ab9430d$var$_createGateExposure;
function $c438a41d8ab9430d$var$_mapExposures(exposures, exposureMapping) {
    return exposures.map((exposure)=>{
        if (typeof exposure === 'string') return (exposureMapping !== null && exposureMapping !== void 0 ? exposureMapping : {})[exposure];
        return exposure;
    }).filter((exposure)=>exposure != null);
}
module.exports._mapExposures = $c438a41d8ab9430d$var$_mapExposures;
const $c438a41d8ab9430d$var$_createConfigExposure = (user, config, exposureMapping)=>{
    var _a, _b, _c, _d;
    const metadata = {
        config: config.name,
        ruleID: config.ruleID
    };
    if (((_a = config.__evaluation) === null || _a === void 0 ? void 0 : _a.version) != null) metadata['configVersion'] = config.__evaluation.version;
    if (((_b = config.__evaluation) === null || _b === void 0 ? void 0 : _b.passed) != null) metadata['rulePassed'] = String(config.__evaluation.passed);
    return $c438a41d8ab9430d$var$_createExposure($c438a41d8ab9430d$var$CONFIG_EXPOSURE_NAME, user, config.details, metadata, $c438a41d8ab9430d$var$_mapExposures((_d = (_c = config.__evaluation) === null || _c === void 0 ? void 0 : _c.secondary_exposures) !== null && _d !== void 0 ? _d : [], exposureMapping));
};
module.exports._createConfigExposure = $c438a41d8ab9430d$var$_createConfigExposure;
const $c438a41d8ab9430d$var$_createLayerParameterExposure = (user, layer, parameterName, exposureMapping)=>{
    var _a, _b, _c, _d, _e, _f, _g;
    const evaluation = layer.__evaluation;
    const isExplicit = ((_a = evaluation === null || evaluation === void 0 ? void 0 : evaluation.explicit_parameters) === null || _a === void 0 ? void 0 : _a.includes(parameterName)) === true;
    let allocatedExperiment = '';
    let secondaryExposures = (_b = evaluation === null || evaluation === void 0 ? void 0 : evaluation.undelegated_secondary_exposures) !== null && _b !== void 0 ? _b : [];
    if (isExplicit) {
        allocatedExperiment = (_c = evaluation.allocated_experiment_name) !== null && _c !== void 0 ? _c : '';
        secondaryExposures = (_d = evaluation.secondary_exposures) !== null && _d !== void 0 ? _d : [];
    }
    const parameterRuleIDs = (_e = layer.__evaluation) === null || _e === void 0 ? void 0 : _e.parameter_rule_ids;
    const metadata = {
        config: layer.name,
        parameterName: parameterName,
        ruleID: (_f = parameterRuleIDs === null || parameterRuleIDs === void 0 ? void 0 : parameterRuleIDs[parameterName]) !== null && _f !== void 0 ? _f : layer.ruleID,
        allocatedExperiment: allocatedExperiment,
        isExplicitParameter: String(isExplicit)
    };
    if (((_g = layer.__evaluation) === null || _g === void 0 ? void 0 : _g.version) != null) metadata['configVersion'] = layer.__evaluation.version;
    return $c438a41d8ab9430d$var$_createExposure($c438a41d8ab9430d$var$LAYER_EXPOSURE_NAME, user, layer.details, metadata, $c438a41d8ab9430d$var$_mapExposures(secondaryExposures, exposureMapping));
};
module.exports._createLayerParameterExposure = $c438a41d8ab9430d$var$_createLayerParameterExposure;
const $c438a41d8ab9430d$var$_addEvaluationDetailsToMetadata = (details, metadata)=>{
    metadata['reason'] = details.reason;
    if (details.lcut) metadata['lcut'] = String(details.lcut);
    if (details.receivedAt) metadata['receivedAt'] = String(details.receivedAt);
    return metadata;
};

});

parcelRegister("baWwc", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LoggingEnabledOption = module.exports.LogEventCompressionMode = void 0;
module.exports.LogEventCompressionMode = {
    /** Do not compress request bodies */ Disabled: 'd',
    /** Compress request bodies unless a network proxy is configured */ Enabled: 'e',
    /** Always compress request bodies, even when a proxy is configured */ Forced: 'f'
};
module.exports.LoggingEnabledOption = {
    disabled: 'disabled',
    browserOnly: 'browser-only',
    always: 'always'
};

});

parcelRegister("jKkqw", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._setObjectInStorage = module.exports._getObjectFromStorage = module.exports.Storage = void 0;

var $9Qn0V = parcelRequire("9Qn0V");

var $hmoSx = parcelRequire("hmoSx");
const $e602288a720ce5c1$var$inMemoryStore = {};
const $e602288a720ce5c1$var$_inMemoryProvider = {
    isReady: ()=>true,
    isReadyResolver: ()=>null,
    getProviderName: ()=>'InMemory',
    getItem: (key)=>$e602288a720ce5c1$var$inMemoryStore[key] ? $e602288a720ce5c1$var$inMemoryStore[key] : null,
    setItem: (key, value)=>{
        $e602288a720ce5c1$var$inMemoryStore[key] = value;
    },
    removeItem: (key)=>{
        delete $e602288a720ce5c1$var$inMemoryStore[key];
    },
    getAllKeys: ()=>Object.keys($e602288a720ce5c1$var$inMemoryStore)
};
let $e602288a720ce5c1$var$_localStorageProvider = null;
try {
    const win = (0, $hmoSx._getWindowSafe)();
    if (win && win.localStorage && typeof win.localStorage.getItem === 'function') $e602288a720ce5c1$var$_localStorageProvider = {
        isReady: ()=>true,
        isReadyResolver: ()=>null,
        getProviderName: ()=>'LocalStorage',
        getItem: (key)=>win.localStorage.getItem(key),
        setItem: (key, value)=>win.localStorage.setItem(key, value),
        removeItem: (key)=>win.localStorage.removeItem(key),
        getAllKeys: ()=>Object.keys(win.localStorage)
    };
} catch (error) {
    $9Qn0V.Log.warn('Failed to setup localStorageProvider.');
}
let $e602288a720ce5c1$var$_main = $e602288a720ce5c1$var$_localStorageProvider !== null && $e602288a720ce5c1$var$_localStorageProvider !== void 0 ? $e602288a720ce5c1$var$_localStorageProvider : $e602288a720ce5c1$var$_inMemoryProvider;
let $e602288a720ce5c1$var$_current = $e602288a720ce5c1$var$_main;
function $e602288a720ce5c1$var$_inMemoryBreaker(action) {
    try {
        return action();
    } catch (error) {
        if (error instanceof Error && error.name === 'SecurityError') {
            module.exports.Storage._setProvider($e602288a720ce5c1$var$_inMemoryProvider);
            return null;
        }
        throw error;
    }
}
module.exports.Storage = {
    isReady: ()=>$e602288a720ce5c1$var$_current.isReady(),
    isReadyResolver: ()=>$e602288a720ce5c1$var$_current.isReadyResolver(),
    getProviderName: ()=>$e602288a720ce5c1$var$_current.getProviderName(),
    getItem: (key)=>$e602288a720ce5c1$var$_inMemoryBreaker(()=>$e602288a720ce5c1$var$_current.getItem(key)),
    setItem: (key, value)=>$e602288a720ce5c1$var$_inMemoryBreaker(()=>$e602288a720ce5c1$var$_current.setItem(key, value)),
    removeItem: (key)=>$e602288a720ce5c1$var$_current.removeItem(key),
    getAllKeys: ()=>$e602288a720ce5c1$var$_current.getAllKeys(),
    // StorageProviderManagment
    _setProvider: (newProvider)=>{
        $e602288a720ce5c1$var$_main = newProvider;
        $e602288a720ce5c1$var$_current = newProvider;
    },
    _setDisabled: (isDisabled)=>{
        if (isDisabled) $e602288a720ce5c1$var$_current = $e602288a720ce5c1$var$_inMemoryProvider;
        else $e602288a720ce5c1$var$_current = $e602288a720ce5c1$var$_main;
    }
};
function $e602288a720ce5c1$var$_getObjectFromStorage(key) {
    const value = module.exports.Storage.getItem(key);
    try {
        return JSON.parse(value !== null && value !== void 0 ? value : 'null');
    } catch (e) {
        $9Qn0V.Log.error(`Failed to parse value for key "${key}"`);
        return null;
    }
}
module.exports._getObjectFromStorage = $e602288a720ce5c1$var$_getObjectFromStorage;
function $e602288a720ce5c1$var$_setObjectInStorage(key, obj) {
    module.exports.Storage.setItem(key, JSON.stringify(obj));
}
module.exports._setObjectInStorage = $e602288a720ce5c1$var$_setObjectInStorage;

});

parcelRegister("e7KD1", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.UrlConfiguration = void 0;

var $doPF1 = parcelRequire("doPF1");

var $3wynb = parcelRequire("3wynb");
const $a485e38c64def78d$var$ENDPOINT_DNS_KEY_MAP = {
    [$3wynb.Endpoint._initialize]: 'i',
    [$3wynb.Endpoint._rgstr]: 'e',
    [$3wynb.Endpoint._download_config_specs]: 'd'
};
class $a485e38c64def78d$var$UrlConfiguration {
    constructor(endpoint, customUrl, customApi, fallbackUrls){
        this.customUrl = null;
        this.fallbackUrls = null;
        this.endpoint = endpoint;
        this.endpointDnsKey = $a485e38c64def78d$var$ENDPOINT_DNS_KEY_MAP[endpoint];
        if (customUrl) this.customUrl = customUrl;
        if (!customUrl && customApi) this.customUrl = customApi.endsWith('/') ? `${customApi}${endpoint}` : `${customApi}/${endpoint}`;
        if (fallbackUrls) this.fallbackUrls = fallbackUrls;
        const defaultApi = $3wynb.NetworkDefault[endpoint];
        this.defaultUrl = `${defaultApi}/${endpoint}`;
    }
    getUrl() {
        var _a;
        return (_a = this.customUrl) !== null && _a !== void 0 ? _a : this.defaultUrl;
    }
    getChecksum() {
        var _a;
        const fallbacks = ((_a = this.fallbackUrls) !== null && _a !== void 0 ? _a : []).sort().join(',');
        return (0, $doPF1._DJB2)(this.customUrl + fallbacks);
    }
}
module.exports.UrlConfiguration = $a485e38c64def78d$var$UrlConfiguration;

});

parcelRegister("gmCzl", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._notifyVisibilityChanged = module.exports._subscribeToVisiblityChanged = module.exports._isUnloading = module.exports._isCurrentlyVisible = void 0;

var $hmoSx = parcelRequire("hmoSx");
const $be9c9e6ef52ef65a$var$FOREGROUND = 'foreground';
const $be9c9e6ef52ef65a$var$BACKGROUND = 'background';
const $be9c9e6ef52ef65a$var$LISTENERS = [];
let $be9c9e6ef52ef65a$var$current = $be9c9e6ef52ef65a$var$FOREGROUND;
let $be9c9e6ef52ef65a$var$isUnloading = false;
const $be9c9e6ef52ef65a$var$_isCurrentlyVisible = ()=>{
    return $be9c9e6ef52ef65a$var$current === $be9c9e6ef52ef65a$var$FOREGROUND;
};
module.exports._isCurrentlyVisible = $be9c9e6ef52ef65a$var$_isCurrentlyVisible;
const $be9c9e6ef52ef65a$var$_isUnloading = ()=>$be9c9e6ef52ef65a$var$isUnloading;
module.exports._isUnloading = $be9c9e6ef52ef65a$var$_isUnloading;
const $be9c9e6ef52ef65a$var$_subscribeToVisiblityChanged = (listener)=>{
    $be9c9e6ef52ef65a$var$LISTENERS.unshift(listener);
};
module.exports._subscribeToVisiblityChanged = $be9c9e6ef52ef65a$var$_subscribeToVisiblityChanged;
const $be9c9e6ef52ef65a$var$_notifyVisibilityChanged = (visibility)=>{
    if (visibility === $be9c9e6ef52ef65a$var$current) return;
    $be9c9e6ef52ef65a$var$current = visibility;
    $be9c9e6ef52ef65a$var$LISTENERS.forEach((l)=>l(visibility));
};
module.exports._notifyVisibilityChanged = $be9c9e6ef52ef65a$var$_notifyVisibilityChanged;
(0, $hmoSx._addWindowEventListenerSafe)('focus', ()=>{
    $be9c9e6ef52ef65a$var$isUnloading = false;
    (0, module.exports._notifyVisibilityChanged)($be9c9e6ef52ef65a$var$FOREGROUND);
});
(0, $hmoSx._addWindowEventListenerSafe)('blur', ()=>(0, module.exports._notifyVisibilityChanged)($be9c9e6ef52ef65a$var$BACKGROUND));
(0, $hmoSx._addDocumentEventListenerSafe)('visibilitychange', ()=>{
    (0, module.exports._notifyVisibilityChanged)(document.visibilityState === 'visible' ? $be9c9e6ef52ef65a$var$FOREGROUND : $be9c9e6ef52ef65a$var$BACKGROUND);
});
(0, $hmoSx._addWindowEventListenerSafe)((0, $hmoSx._getUnloadEvent)(), ()=>{
    $be9c9e6ef52ef65a$var$isUnloading = true;
    (0, module.exports._notifyVisibilityChanged)($be9c9e6ef52ef65a$var$BACKGROUND);
});

});


parcelRegister("kVJXW", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.StatsigMetadataProvider = module.exports.SDK_VERSION = void 0;
module.exports.SDK_VERSION = '3.30.2';
let $f3ccc959e0f12c92$var$metadata = {
    sdkVersion: module.exports.SDK_VERSION,
    sdkType: 'js-mono'
};
module.exports.StatsigMetadataProvider = {
    get: ()=>$f3ccc959e0f12c92$var$metadata,
    add: (additions)=>{
        $f3ccc959e0f12c92$var$metadata = Object.assign(Object.assign({}, $f3ccc959e0f12c92$var$metadata), additions);
    }
};

});

parcelRegister("fivtj", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("a5r3l", function(module, exports) {
"use strict";
var $757f5b23eb01ac78$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._makeDataAdapterResult = module.exports.DataAdapterCore = void 0;

var $9Qn0V = parcelRequire("9Qn0V");

var $177Kh = parcelRequire("177Kh");

var $619VR = parcelRequire("619VR");

var $jKkqw = parcelRequire("jKkqw");

var $7PZBS = parcelRequire("7PZBS");
const $757f5b23eb01ac78$var$CACHE_LIMIT = 10;
const $757f5b23eb01ac78$var$MAX_CACHE_WRITE_ATTEMPTS = 8;
class $757f5b23eb01ac78$var$DataAdapterCore {
    constructor(_adapterName, _cacheSuffix){
        this._adapterName = _adapterName;
        this._cacheSuffix = _cacheSuffix;
        this._options = null;
        this._sdkKey = null;
        this._cacheLimit = $757f5b23eb01ac78$var$CACHE_LIMIT;
        this._lastModifiedStoreKey = `statsig.last_modified_time.${_cacheSuffix}`;
        this._inMemoryCache = new $757f5b23eb01ac78$var$InMemoryCache();
    }
    attach(sdkKey, options, _network) {
        this._sdkKey = sdkKey;
        this._options = options;
    }
    getDataSync(user) {
        const normalized = user && (0, $619VR._normalizeUser)(user, this._options);
        const cacheKey = this._getCacheKey(normalized);
        const inMem = this._inMemoryCache.get(cacheKey, normalized);
        if (inMem && this._getIsCacheValueValid(inMem)) return inMem;
        const cache = this._loadFromCache(cacheKey);
        if (cache && this._getIsCacheValueValid(cache)) {
            this._inMemoryCache.add(cacheKey, cache, this._cacheLimit);
            return this._inMemoryCache.get(cacheKey, normalized);
        }
        return null;
    }
    setData(data, user) {
        const normalized = user && (0, $619VR._normalizeUser)(user, this._options);
        const cacheKey = this._getCacheKey(normalized);
        this._inMemoryCache.add(cacheKey, $757f5b23eb01ac78$var$_makeDataAdapterResult('Bootstrap', data, null, normalized), this._cacheLimit);
    }
    _getIsCacheValueValid(current) {
        return current.stableID == null || current.stableID === $177Kh.StableID.get(this._getSdkKey());
    }
    _getDataAsyncImpl(current, user, options) {
        return $757f5b23eb01ac78$var$__awaiter(this, void 0, void 0, function*() {
            if (!$jKkqw.Storage.isReady()) yield $jKkqw.Storage.isReadyResolver();
            const cache = current !== null && current !== void 0 ? current : this.getDataSync(user);
            const ops = [
                this._fetchAndPrepFromNetwork(cache, user, options)
            ];
            if (options === null || options === void 0 ? void 0 : options.timeoutMs) ops.push(new Promise((r)=>setTimeout(r, options.timeoutMs)).then(()=>{
                $9Qn0V.Log.debug('Fetching latest value timed out');
                return null;
            }));
            return yield Promise.race(ops);
        });
    }
    _prefetchDataImpl(user, options) {
        return $757f5b23eb01ac78$var$__awaiter(this, void 0, void 0, function*() {
            const normalized = user && (0, $619VR._normalizeUser)(user, this._options);
            const cacheKey = this._getCacheKey(normalized);
            const result = yield this._getDataAsyncImpl(null, normalized, options);
            if (result) this._inMemoryCache.add(cacheKey, Object.assign(Object.assign({}, result), {
                source: 'Prefetch'
            }), this._cacheLimit);
        });
    }
    _fetchAndPrepFromNetwork(cachedResult, user, options) {
        return $757f5b23eb01ac78$var$__awaiter(this, void 0, void 0, function*() {
            var _a;
            const cachedData = (_a = cachedResult === null || cachedResult === void 0 ? void 0 : cachedResult.data) !== null && _a !== void 0 ? _a : null;
            const isCacheValidFor204 = cachedResult != null && this._isCachedResultValidFor204(cachedResult, user);
            const latest = yield this._fetchFromNetwork(cachedData, user, options, isCacheValidFor204);
            if (!latest) {
                $9Qn0V.Log.debug('No response returned for latest value');
                return null;
            }
            const response = (0, $7PZBS._typedJsonParse)(latest, 'has_updates', 'Response');
            const sdkKey = this._getSdkKey();
            const stableID = $177Kh.StableID.get(sdkKey);
            let result = null;
            if ((response === null || response === void 0 ? void 0 : response.has_updates) === true) result = $757f5b23eb01ac78$var$_makeDataAdapterResult('Network', latest, stableID, user);
            else if (cachedData && (response === null || response === void 0 ? void 0 : response.has_updates) === false) result = $757f5b23eb01ac78$var$_makeDataAdapterResult('NetworkNotModified', cachedData, stableID, user);
            else return null;
            const cacheKey = this._getCacheKey(user);
            this._inMemoryCache.add(cacheKey, result, this._cacheLimit);
            this._writeToCache(cacheKey, result);
            return result;
        });
    }
    _getSdkKey() {
        if (this._sdkKey != null) return this._sdkKey;
        $9Qn0V.Log.error(`${this._adapterName} is not attached to a Client`);
        return '';
    }
    _loadFromCache(cacheKey) {
        var _a;
        const cache = (_a = $jKkqw.Storage.getItem) === null || _a === void 0 ? void 0 : _a.call($jKkqw.Storage, cacheKey);
        if (cache == null) return null;
        const result = (0, $7PZBS._typedJsonParse)(cache, 'source', 'Cached Result');
        return result ? Object.assign(Object.assign({}, result), {
            source: 'Cache'
        }) : null;
    }
    _writeToCache(cacheKey, result) {
        const resultString = JSON.stringify(result);
        for(let i = 0; i < $757f5b23eb01ac78$var$MAX_CACHE_WRITE_ATTEMPTS; i++)try {
            $jKkqw.Storage.setItem(cacheKey, resultString);
            break;
        } catch (error) {
            if (!(error instanceof Error) || !(error.toString().includes('QuotaExceededError') || error.toString().includes('QUOTA_EXCEEDED_ERR')) || this._cacheLimit <= 1) throw error;
            this._cacheLimit = Math.ceil(this._cacheLimit / 2);
            this._runLocalStorageCacheEviction(cacheKey, this._cacheLimit - 1);
        }
        this._runLocalStorageCacheEviction(cacheKey);
    }
    _runLocalStorageCacheEviction(cacheKey, cacheLimit = this._cacheLimit) {
        var _a;
        const lastModifiedTimeMap = (_a = (0, $jKkqw._getObjectFromStorage)(this._lastModifiedStoreKey)) !== null && _a !== void 0 ? _a : {};
        lastModifiedTimeMap[cacheKey] = Date.now();
        const evictableKeys = $757f5b23eb01ac78$var$_getEvictableKeys(lastModifiedTimeMap, cacheLimit);
        for (const evictable of evictableKeys){
            delete lastModifiedTimeMap[evictable];
            $jKkqw.Storage.removeItem(evictable);
        }
        (0, $jKkqw._setObjectInStorage)(this._lastModifiedStoreKey, lastModifiedTimeMap);
    }
}
module.exports.DataAdapterCore = $757f5b23eb01ac78$var$DataAdapterCore;
function $757f5b23eb01ac78$var$_makeDataAdapterResult(source, data, stableID, user) {
    return {
        source: source,
        data: data,
        receivedAt: Date.now(),
        stableID: stableID,
        fullUserHash: (0, $619VR._getFullUserHash)(user)
    };
}
module.exports._makeDataAdapterResult = $757f5b23eb01ac78$var$_makeDataAdapterResult;
class $757f5b23eb01ac78$var$InMemoryCache {
    constructor(){
        this._data = {};
    }
    get(cacheKey, user) {
        var _a;
        const result = this._data[cacheKey];
        const cached = result === null || result === void 0 ? void 0 : result.stableID;
        const provided = (_a = user === null || user === void 0 ? void 0 : user.customIDs) === null || _a === void 0 ? void 0 : _a.stableID;
        if (provided && cached && provided !== cached) {
            $9Qn0V.Log.warn("'StatsigUser.customIDs.stableID' mismatch");
            return null;
        }
        return result;
    }
    add(cacheKey, value, cacheLimit) {
        const evictableKeys = $757f5b23eb01ac78$var$_getEvictableKeys(this._data, cacheLimit - 1);
        for (const evictable of evictableKeys)delete this._data[evictable];
        this._data[cacheKey] = value;
    }
    merge(values) {
        this._data = Object.assign(Object.assign({}, this._data), values);
    }
}
function $757f5b23eb01ac78$var$_getEvictableKeys(data, limit) {
    const keys = Object.keys(data);
    if (keys.length <= limit) return [];
    if (limit === 0) return keys;
    return keys.sort((keyA, keyB)=>{
        const valueA = data[keyA];
        const valueB = data[keyB];
        if (typeof valueA === 'object' && typeof valueB === 'object') return valueA.receivedAt - valueB.receivedAt;
        return valueA - valueB;
    }).slice(0, keys.length - limit);
}

});
parcelRegister("177Kh", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getCookieName = module.exports.StableID = void 0;

var $4KuM7 = parcelRequire("4KuM7");

var $9Qn0V = parcelRequire("9Qn0V");

var $hmoSx = parcelRequire("hmoSx");

var $jKkqw = parcelRequire("jKkqw");

var $h59qk = parcelRequire("h59qk");
const $0cfc73fcc033286b$var$PROMISE_MAP = {};
const $0cfc73fcc033286b$var$COOKIE_ENABLED_MAP = {};
const $0cfc73fcc033286b$var$DISABLED_MAP = {};
module.exports.StableID = {
    cookiesEnabled: false,
    randomID: Math.random().toString(36),
    get: (sdkKey)=>{
        if ($0cfc73fcc033286b$var$DISABLED_MAP[sdkKey]) return null;
        if ($0cfc73fcc033286b$var$PROMISE_MAP[sdkKey] != null) return $0cfc73fcc033286b$var$PROMISE_MAP[sdkKey];
        let stableID = null;
        stableID = $0cfc73fcc033286b$var$_loadFromCookie(sdkKey);
        if (stableID != null) {
            $0cfc73fcc033286b$var$PROMISE_MAP[sdkKey] = stableID;
            $0cfc73fcc033286b$var$_persistToStorage(stableID, sdkKey);
            return stableID;
        }
        stableID = $0cfc73fcc033286b$var$_loadFromStorage(sdkKey);
        if (stableID == null) stableID = (0, $h59qk.getUUID)();
        $0cfc73fcc033286b$var$_persistToStorage(stableID, sdkKey);
        $0cfc73fcc033286b$var$_persistToCookie(stableID, sdkKey);
        $0cfc73fcc033286b$var$PROMISE_MAP[sdkKey] = stableID;
        return stableID;
    },
    setOverride: (override, sdkKey)=>{
        $0cfc73fcc033286b$var$PROMISE_MAP[sdkKey] = override;
        $0cfc73fcc033286b$var$_persistToStorage(override, sdkKey);
        $0cfc73fcc033286b$var$_persistToCookie(override, sdkKey);
    },
    _setCookiesEnabled: (sdkKey, cookiesEnabled)=>{
        $0cfc73fcc033286b$var$COOKIE_ENABLED_MAP[sdkKey] = cookiesEnabled;
    },
    _setDisabled: (sdkKey, disabled)=>{
        $0cfc73fcc033286b$var$DISABLED_MAP[sdkKey] = disabled;
    }
};
function $0cfc73fcc033286b$var$_getStableIDStorageKey(sdkKey) {
    return `statsig.stable_id.${(0, $4KuM7._getStorageKey)(sdkKey)}`;
}
function $0cfc73fcc033286b$var$_persistToStorage(stableID, sdkKey) {
    const storageKey = $0cfc73fcc033286b$var$_getStableIDStorageKey(sdkKey);
    try {
        (0, $jKkqw._setObjectInStorage)(storageKey, stableID);
    } catch (e) {
        $9Qn0V.Log.warn('Failed to save StableID to storage');
    }
}
function $0cfc73fcc033286b$var$_loadFromStorage(sdkKey) {
    const storageKey = $0cfc73fcc033286b$var$_getStableIDStorageKey(sdkKey);
    return (0, $jKkqw._getObjectFromStorage)(storageKey);
}
function $0cfc73fcc033286b$var$_loadFromCookie(sdkKey) {
    if (!$0cfc73fcc033286b$var$COOKIE_ENABLED_MAP[sdkKey] || (0, $hmoSx._getDocumentSafe)() == null) return null;
    const cookies = document.cookie.split(';');
    for (const cookie of cookies){
        const [key, value] = cookie.trim().split('=');
        if (key === $0cfc73fcc033286b$var$getCookieName(sdkKey)) return decodeURIComponent(value);
    }
    return null;
}
function $0cfc73fcc033286b$var$_persistToCookie(stableID, sdkKey) {
    if (!$0cfc73fcc033286b$var$COOKIE_ENABLED_MAP[sdkKey] || (0, $hmoSx._getDocumentSafe)() == null) return;
    const expiryDate = new Date();
    expiryDate.setFullYear(expiryDate.getFullYear() + 1);
    document.cookie = `${$0cfc73fcc033286b$var$getCookieName(sdkKey)}=${encodeURIComponent(stableID)}; expires=${expiryDate.toUTCString()}; path=/`;
}
function $0cfc73fcc033286b$var$getCookieName(sdkKey) {
    return `statsig.stable_id.${(0, $4KuM7._getStorageKey)(sdkKey)}`;
}
module.exports.getCookieName = $0cfc73fcc033286b$var$getCookieName;

});
parcelRegister("h59qk", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getUUID = void 0;
function $c6fa36a4b16a38ad$var$getUUID() {
    if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') return crypto.randomUUID();
    let d = new Date().getTime();
    let d2 = typeof performance !== 'undefined' && performance.now && performance.now() * 1000 || 0;
    const y = '89ab'[Math.floor(Math.random() * 4)];
    return `xxxxxxxx-xxxx-4xxx-${y}xxx-xxxxxxxxxxxx`.replace(/[xy]/g, (c)=>{
        let r = Math.random() * 16;
        if (d > 0) {
            r = (d + r) % 16 | 0;
            d = Math.floor(d / 16);
        } else {
            r = (d2 + r) % 16 | 0;
            d2 = Math.floor(d2 / 16);
        }
        return (c === 'x' ? r : r & 0x7 | 0x8).toString(16);
    });
}
module.exports.getUUID = $c6fa36a4b16a38ad$var$getUUID;

});


parcelRegister("619VR", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._getFullUserHash = module.exports._normalizeUser = void 0;

var $doPF1 = parcelRequire("doPF1");

var $9Qn0V = parcelRequire("9Qn0V");
function $461a8a630e6a2b6d$var$_normalizeUser(original, options, fallbackEnvironment) {
    try {
        const copy = JSON.parse(JSON.stringify(original));
        if (options != null && options.environment != null) copy.statsigEnvironment = options.environment;
        else if (fallbackEnvironment != null) copy.statsigEnvironment = {
            tier: fallbackEnvironment
        };
        return copy;
    } catch (error) {
        $9Qn0V.Log.error('Failed to JSON.stringify user');
        return {
            statsigEnvironment: undefined
        };
    }
}
module.exports._normalizeUser = $461a8a630e6a2b6d$var$_normalizeUser;
function $461a8a630e6a2b6d$var$_getFullUserHash(user) {
    return user ? (0, $doPF1._DJB2Object)(user) : null;
}
module.exports._getFullUserHash = $461a8a630e6a2b6d$var$_getFullUserHash;

});

parcelRegister("7PZBS", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._typedJsonParse = void 0;

var $9Qn0V = parcelRequire("9Qn0V");
/**
 *
 * @param {string} data The values to parse into T
 * @param {string} guard A field that must exists on the parsed object for the parse to be valid
 * @param {string} error An error to print via Log.error() when parsing fails
 * @returns {T | null} The parse object T or null if it failed
 */ function $5b4d1642b922e1ea$var$_typedJsonParse(data, guard, typeName) {
    try {
        const result = JSON.parse(data);
        if (result && typeof result === 'object' && guard in result) return result;
    } catch (_a) {
    // noop
    }
    $9Qn0V.Log.error(`Failed to parse ${typeName}`);
    return null;
}
module.exports._typedJsonParse = $5b4d1642b922e1ea$var$_typedJsonParse;

});


parcelRegister("ceicM", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("hpmwp", function(module, exports) {
"use strict";
var $cac63dca052a47f5$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ErrorBoundary = module.exports.EXCEPTION_ENDPOINT = void 0;

var $9Qn0V = parcelRequire("9Qn0V");

var $9JrW9 = parcelRequire("9JrW9");

var $kVJXW = parcelRequire("kVJXW");
module.exports.EXCEPTION_ENDPOINT = 'https://statsigapi.net/v1/sdk_exception';
const $cac63dca052a47f5$var$UNKNOWN_ERROR = '[Statsig] UnknownError';
class $cac63dca052a47f5$var$ErrorBoundary {
    constructor(_sdkKey, _options, _emitter, _lastSeenError){
        this._sdkKey = _sdkKey;
        this._options = _options;
        this._emitter = _emitter;
        this._lastSeenError = _lastSeenError;
        this._seen = new Set();
    }
    wrap(instance, namePrefix) {
        try {
            const obj = instance;
            $cac63dca052a47f5$var$_getAllInstanceMethodNames(obj).forEach((name)=>{
                const original = obj[name];
                if ('$EB' in original) return;
                obj[name] = (...args)=>{
                    return this._capture(namePrefix ? `${namePrefix}:${name}` : name, ()=>original.apply(instance, args));
                };
                obj[name].$EB = true;
            });
        } catch (err) {
            this._onError('eb:wrap', err);
        }
    }
    logError(tag, error) {
        this._onError(tag, error);
    }
    getLastSeenErrorAndReset() {
        const tempError = this._lastSeenError;
        this._lastSeenError = undefined;
        return tempError !== null && tempError !== void 0 ? tempError : null;
    }
    attachErrorIfNoneExists(error) {
        if (this._lastSeenError) return;
        this._lastSeenError = $cac63dca052a47f5$var$_resolveError(error);
    }
    _capture(tag, task) {
        try {
            const res = task();
            if (res && res instanceof Promise) return res.catch((err)=>this._onError(tag, err));
            return res;
        } catch (error) {
            this._onError(tag, error);
            return null;
        }
    }
    _onError(tag, error) {
        try {
            $9Qn0V.Log.warn(`Caught error in ${tag}`, {
                error: error
            });
            const impl = ()=>$cac63dca052a47f5$var$__awaiter(this, void 0, void 0, function*() {
                    var _a, _b, _c, _d, _e, _f, _g;
                    const unwrapped = error ? error : Error($cac63dca052a47f5$var$UNKNOWN_ERROR);
                    const isError = unwrapped instanceof Error;
                    const name = isError ? unwrapped.name : 'No Name';
                    const resolvedError = $cac63dca052a47f5$var$_resolveError(unwrapped);
                    this._lastSeenError = resolvedError;
                    if (this._seen.has(name)) return;
                    this._seen.add(name);
                    if ((_b = (_a = this._options) === null || _a === void 0 ? void 0 : _a.networkConfig) === null || _b === void 0 ? void 0 : _b.preventAllNetworkTraffic) {
                        (_c = this._emitter) === null || _c === void 0 || _c.call(this, {
                            name: 'error',
                            error: error,
                            tag: tag
                        });
                        return;
                    }
                    const sdkType = $9JrW9.SDKType._get(this._sdkKey);
                    const statsigMetadata = $kVJXW.StatsigMetadataProvider.get();
                    const info = isError ? unwrapped.stack : $cac63dca052a47f5$var$_getDescription(unwrapped);
                    const body = Object.assign({
                        tag: tag,
                        exception: name,
                        info: info,
                        statsigOptions: $cac63dca052a47f5$var$_getStatsigOptionLoggingCopy(this._options)
                    }, Object.assign(Object.assign({}, statsigMetadata), {
                        sdkType: sdkType
                    }));
                    const func = (_f = (_e = (_d = this._options) === null || _d === void 0 ? void 0 : _d.networkConfig) === null || _e === void 0 ? void 0 : _e.networkOverrideFunc) !== null && _f !== void 0 ? _f : fetch;
                    yield func(module.exports.EXCEPTION_ENDPOINT, {
                        method: 'POST',
                        headers: {
                            'STATSIG-API-KEY': this._sdkKey,
                            'STATSIG-SDK-TYPE': String(sdkType),
                            'STATSIG-SDK-VERSION': String(statsigMetadata.sdkVersion),
                            'Content-Type': 'application/json'
                        },
                        body: JSON.stringify(body)
                    });
                    (_g = this._emitter) === null || _g === void 0 || _g.call(this, {
                        name: 'error',
                        error: error,
                        tag: tag
                    });
                });
            impl().then(()=>{
            /* noop */ }).catch(()=>{
            /* noop */ });
        } catch (_error) {
        /* noop */ }
    }
}
module.exports.ErrorBoundary = $cac63dca052a47f5$var$ErrorBoundary;
function $cac63dca052a47f5$var$_resolveError(error) {
    if (error instanceof Error) return error;
    else if (typeof error === 'string') return new Error(error);
    else return new Error('An unknown error occurred.');
}
function $cac63dca052a47f5$var$_getDescription(obj) {
    try {
        return JSON.stringify(obj);
    } catch (_a) {
        return $cac63dca052a47f5$var$UNKNOWN_ERROR;
    }
}
function $cac63dca052a47f5$var$_getAllInstanceMethodNames(instance) {
    const names = new Set();
    let proto = Object.getPrototypeOf(instance);
    while(proto && proto !== Object.prototype){
        Object.getOwnPropertyNames(proto).filter((prop)=>typeof (proto === null || proto === void 0 ? void 0 : proto[prop]) === 'function').forEach((name)=>names.add(name));
        proto = Object.getPrototypeOf(proto);
    }
    return Array.from(names);
}
function $cac63dca052a47f5$var$_getStatsigOptionLoggingCopy(options) {
    if (!options) return {};
    const loggingCopy = {};
    Object.keys(options).forEach((key)=>{
        const option = key;
        const value = options[option];
        const valueType = typeof value;
        switch(valueType){
            case 'number':
            case 'bigint':
            case 'boolean':
                loggingCopy[String(option)] = value;
                break;
            case 'string':
                if (value.length < 50) loggingCopy[String(option)] = value;
                else loggingCopy[String(option)] = 'set';
                break;
            case 'object':
                if (option === 'environment') loggingCopy['environment'] = value;
                else if (option === 'networkConfig') loggingCopy['networkConfig'] = value;
                else loggingCopy[String(option)] = value != null ? 'set' : 'unset';
                break;
            default:
        }
    });
    return loggingCopy;
}

});
parcelRegister("9JrW9", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SDKType = void 0;
const $715dfcb364c2ee2f$var$SDK_CLIENT = {};
let $715dfcb364c2ee2f$var$suffix;
module.exports.SDKType = {
    _get: (sdkKey)=>{
        var _a;
        return ((_a = $715dfcb364c2ee2f$var$SDK_CLIENT[sdkKey]) !== null && _a !== void 0 ? _a : 'js-mono') + ($715dfcb364c2ee2f$var$suffix !== null && $715dfcb364c2ee2f$var$suffix !== void 0 ? $715dfcb364c2ee2f$var$suffix : '');
    },
    _setClientType (sdkKey, client) {
        $715dfcb364c2ee2f$var$SDK_CLIENT[sdkKey] = client;
    },
    _setBindingType (binding) {
        if (!$715dfcb364c2ee2f$var$suffix || $715dfcb364c2ee2f$var$suffix === '-react') $715dfcb364c2ee2f$var$suffix = '-' + binding;
    }
};

});


parcelRegister("6lwLe", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("80W8k", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("6vMkI", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("4wyC3", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.createMemoKey = module.exports.MemoPrefix = void 0;
module.exports.MemoPrefix = {
    _gate: 'g',
    _dynamicConfig: 'c',
    _experiment: 'e',
    _configList: 'cl',
    _layer: 'l',
    _paramStore: 'p'
};
const $34b4fff33a7d988e$var$EXIST_KEYS = new Set([]);
const $34b4fff33a7d988e$var$DO_NOT_MEMO_KEYS = new Set([
    // Add keys that if exist, should not be memoized
    'userPersistedValues'
]);
function $34b4fff33a7d988e$var$createMemoKey(prefix, name, options) {
    let cacheKey = `${prefix}|${name}`;
    if (!options) return cacheKey;
    for (const key of Object.keys(options)){
        if ($34b4fff33a7d988e$var$DO_NOT_MEMO_KEYS.has(key)) return undefined;
        if ($34b4fff33a7d988e$var$EXIST_KEYS.has(key)) cacheKey += `|${key}=true`;
        else cacheKey += `|${key}=${options[key]}`;
    }
    return cacheKey;
}
module.exports.createMemoKey = $34b4fff33a7d988e$var$createMemoKey;

});

parcelRegister("jCkUF", function(module, exports) {
"use strict";
var $e481c9d6519761a4$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.NetworkCore = void 0;

var $8ZzeR = parcelRequire("8ZzeR");

var $8ZzeR = parcelRequire("8ZzeR");

var $4EJwp = parcelRequire("4EJwp");

var $9Qn0V = parcelRequire("9Qn0V");

var $3wynb = parcelRequire("3wynb");

var $a10qE = parcelRequire("a10qE");

var $8Glek = parcelRequire("8Glek");

var $9JrW9 = parcelRequire("9JrW9");

var $hmoSx = parcelRequire("hmoSx");

var $ldhqF = parcelRequire("ldhqF");

var $177Kh = parcelRequire("177Kh");

var $83Y6N = parcelRequire("83Y6N");

var $kVJXW = parcelRequire("kVJXW");

var $baWwc = parcelRequire("baWwc");

var $gmCzl = parcelRequire("gmCzl");
const $e481c9d6519761a4$var$DEFAULT_TIMEOUT_MS = 10000;
const $e481c9d6519761a4$var$BACKOFF_BASE_MS = 500;
const $e481c9d6519761a4$var$BACKOFF_MAX_MS = 30000;
const $e481c9d6519761a4$var$RATE_LIMIT_WINDOW_MS = 1000;
const $e481c9d6519761a4$var$RATE_LIMIT_MAX_REQ_COUNT = 50;
const $e481c9d6519761a4$var$LEAK_RATE = $e481c9d6519761a4$var$RATE_LIMIT_MAX_REQ_COUNT / $e481c9d6519761a4$var$RATE_LIMIT_WINDOW_MS;
const $e481c9d6519761a4$var$RETRYABLE_CODES = new Set([
    408,
    500,
    502,
    503,
    504,
    522,
    524,
    599
]);
class $e481c9d6519761a4$var$NetworkCore {
    constructor(options, _emitter){
        this._emitter = _emitter;
        this._errorBoundary = null;
        this._timeout = $e481c9d6519761a4$var$DEFAULT_TIMEOUT_MS;
        this._netConfig = {};
        this._options = {};
        this._leakyBucket = {};
        this._lastUsedInitUrl = null;
        if (options) this._options = options;
        if (this._options.networkConfig) this._netConfig = this._options.networkConfig;
        if (this._netConfig.networkTimeoutMs) this._timeout = this._netConfig.networkTimeoutMs;
        this._fallbackResolver = new $a10qE.NetworkFallbackResolver(this._options);
        this.setLogEventCompressionMode(this._getLogEventCompressionMode(options));
    }
    setLogEventCompressionMode(mode) {
        this._options.logEventCompressionMode = mode;
    }
    setErrorBoundary(errorBoundary) {
        this._errorBoundary = errorBoundary;
        this._errorBoundary.wrap(this);
        this._errorBoundary.wrap(this._fallbackResolver);
        this._fallbackResolver.setErrorBoundary(errorBoundary);
    }
    isBeaconSupported() {
        return typeof navigator !== 'undefined' && typeof navigator.sendBeacon === 'function';
    }
    getLastUsedInitUrlAndReset() {
        const tempUrl = this._lastUsedInitUrl;
        this._lastUsedInitUrl = null;
        return tempUrl;
    }
    beacon(args) {
        if (!$e481c9d6519761a4$var$_ensureValidSdkKey(args)) return false;
        const argsInternal = this._getInternalRequestArgs('POST', args);
        const url = this._getPopulatedURL(argsInternal);
        const nav = navigator;
        return nav.sendBeacon.bind(nav)(url, argsInternal.body);
    }
    post(args) {
        return $e481c9d6519761a4$var$__awaiter(this, void 0, void 0, function*() {
            const argsInternal = this._getInternalRequestArgs('POST', args);
            this._tryEncodeBody(argsInternal);
            yield this._tryToCompressBody(argsInternal);
            return this._sendRequest(argsInternal);
        });
    }
    get(args) {
        const argsInternal = this._getInternalRequestArgs('GET', args);
        return this._sendRequest(argsInternal);
    }
    _sendRequest(args) {
        return $e481c9d6519761a4$var$__awaiter(this, void 0, void 0, function*() {
            var _a, _b, _c, _d;
            if (!$e481c9d6519761a4$var$_ensureValidSdkKey(args)) return null;
            if (this._netConfig.preventAllNetworkTraffic) return null;
            const { method: method, body: body, retries: retries, attempt: attempt } = args;
            const endpoint = args.urlConfig.endpoint;
            if (this._isRateLimited(endpoint)) {
                $9Qn0V.Log.warn(`Request to ${endpoint} was blocked because you are making requests too frequently.`);
                return null;
            }
            const currentAttempt = attempt !== null && attempt !== void 0 ? attempt : 1;
            let reqTimedOut = false;
            const populatedUrl = this._getPopulatedURL(args);
            let response = null;
            const keepalive = (0, $gmCzl._isUnloading)();
            try {
                const config = {
                    method: method,
                    body: body,
                    headers: Object.assign({}, args.headers),
                    priority: args.priority,
                    keepalive: keepalive
                };
                $e481c9d6519761a4$var$_tryMarkInitStart(args, currentAttempt);
                const bucket = this._leakyBucket[endpoint];
                if (bucket) {
                    bucket.lastRequestTime = Date.now();
                    this._leakyBucket[endpoint] = bucket;
                }
                const func = (_a = this._netConfig.networkOverrideFunc) !== null && _a !== void 0 ? _a : fetch;
                let timeoutId;
                response = yield Promise.race([
                    func(populatedUrl, config).finally(()=>clearTimeout(timeoutId)),
                    new Promise((_, reject)=>{
                        timeoutId = setTimeout(()=>{
                            reqTimedOut = true;
                            reject(new Error(`Timeout of ${this._timeout}ms expired.`));
                        }, this._timeout);
                    })
                ]);
                if (!response.ok) {
                    const text = yield response.text().catch(()=>'No Text');
                    const err = new Error(`NetworkError: ${populatedUrl} ${text}`);
                    err.name = 'NetworkError';
                    throw err;
                }
                const text = yield response.text();
                $e481c9d6519761a4$var$_tryMarkInitEnd(args, response, currentAttempt, text);
                this._fallbackResolver.tryBumpExpiryTime(args.sdkKey, args.urlConfig);
                return {
                    body: text,
                    code: response.status
                };
            } catch (error) {
                const errorMessage = $e481c9d6519761a4$var$_getErrorMessage(error);
                const timedOut = $e481c9d6519761a4$var$_didTimeout(errorMessage !== null && errorMessage !== void 0 ? errorMessage : '', reqTimedOut);
                $e481c9d6519761a4$var$_tryMarkInitEnd(args, response, currentAttempt, '', error);
                const fallbackUpdated = yield this._fallbackResolver.tryFetchUpdatedFallbackInfo(args.sdkKey, args.urlConfig, errorMessage, timedOut);
                if (fallbackUpdated) args.fallbackUrl = this._fallbackResolver.getActiveFallbackUrl(args.sdkKey, args.urlConfig);
                if (!retries || currentAttempt > retries || !$e481c9d6519761a4$var$RETRYABLE_CODES.has((_b = response === null || response === void 0 ? void 0 : response.status) !== null && _b !== void 0 ? _b : 500)) {
                    (_c = this._emitter) === null || _c === void 0 || _c.call(this, {
                        name: 'error',
                        error: error,
                        tag: $83Y6N.ErrorTag.NetworkError,
                        requestArgs: args
                    });
                    const formattedErrorMsg = `A networking error occurred during ${method} request to ${populatedUrl}.`;
                    $9Qn0V.Log.error(formattedErrorMsg, errorMessage, error);
                    (_d = this._errorBoundary) === null || _d === void 0 || _d.attachErrorIfNoneExists(formattedErrorMsg);
                    return null;
                }
                yield $e481c9d6519761a4$var$_exponentialBackoff(currentAttempt);
                return this._sendRequest(Object.assign(Object.assign({}, args), {
                    retries: retries,
                    attempt: currentAttempt + 1
                }));
            }
        });
    }
    _getLogEventCompressionMode(options) {
        // Handle backward compatibility for deprecated disableCompression flag
        let compressionMode = options === null || options === void 0 ? void 0 : options.logEventCompressionMode;
        if (!compressionMode && (options === null || options === void 0 ? void 0 : options.disableCompression) === true) compressionMode = $baWwc.LogEventCompressionMode.Disabled;
        // Default to enabled if unset
        if (!compressionMode) compressionMode = $baWwc.LogEventCompressionMode.Enabled;
        return compressionMode;
    }
    _isRateLimited(endpoint) {
        var _a;
        const now = Date.now();
        const bucket = (_a = this._leakyBucket[endpoint]) !== null && _a !== void 0 ? _a : {
            count: 0,
            lastRequestTime: now
        };
        const elapsed = now - bucket.lastRequestTime;
        const leakedRequests = Math.floor(elapsed * $e481c9d6519761a4$var$LEAK_RATE);
        bucket.count = Math.max(0, bucket.count - leakedRequests);
        if (bucket.count >= $e481c9d6519761a4$var$RATE_LIMIT_MAX_REQ_COUNT) return true;
        bucket.count += 1;
        bucket.lastRequestTime = now;
        this._leakyBucket[endpoint] = bucket;
        return false;
    }
    _getPopulatedURL(args) {
        var _a;
        const url = (_a = args.fallbackUrl) !== null && _a !== void 0 ? _a : args.urlConfig.getUrl();
        if (args.urlConfig.endpoint === $3wynb.Endpoint._initialize || args.urlConfig.endpoint === $3wynb.Endpoint._download_config_specs) this._lastUsedInitUrl = url;
        const params = Object.assign({
            [$3wynb.NetworkParam.SdkKey]: args.sdkKey,
            [$3wynb.NetworkParam.SdkType]: $9JrW9.SDKType._get(args.sdkKey),
            [$3wynb.NetworkParam.SdkVersion]: $kVJXW.SDK_VERSION,
            [$3wynb.NetworkParam.Time]: String(Date.now()),
            [$3wynb.NetworkParam.SessionID]: $ldhqF.SessionID.get(args.sdkKey)
        }, args.params);
        const query = Object.keys(params).map((key)=>{
            return `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`;
        }).join('&');
        return `${url}${query ? `?${query}` : ''}`;
    }
    _tryEncodeBody(args) {
        var _a;
        const win = (0, $hmoSx._getWindowSafe)();
        const body = args.body;
        if (!args.isStatsigEncodable || this._options.disableStatsigEncoding || typeof body !== 'string' || (0, $8ZzeR._getStatsigGlobalFlag)('no-encode') != null || !(win === null || win === void 0 ? void 0 : win.btoa)) return;
        try {
            args.body = win.btoa(body).split('').reverse().join('');
            args.params = Object.assign(Object.assign({}, (_a = args.params) !== null && _a !== void 0 ? _a : {}), {
                [$3wynb.NetworkParam.StatsigEncoded]: '1'
            });
        } catch (e) {
            $9Qn0V.Log.warn(`Request encoding failed for ${args.urlConfig.getUrl()}`, e);
        }
    }
    _tryToCompressBody(args) {
        return $e481c9d6519761a4$var$__awaiter(this, void 0, void 0, function*() {
            var _a;
            const body = args.body;
            if (typeof body !== 'string' || !$e481c9d6519761a4$var$_allowCompression(args, this._options)) return;
            try {
                const bytes = new TextEncoder().encode(body);
                const stream = new CompressionStream('gzip');
                const writer = stream.writable.getWriter();
                writer.write(bytes).catch($9Qn0V.Log.error);
                writer.close().catch($9Qn0V.Log.error);
                const reader = stream.readable.getReader();
                const chunks = [];
                let result;
                // eslint-disable-next-line no-await-in-loop
                while(!(result = yield reader.read()).done)chunks.push(result.value);
                const totalLength = chunks.reduce((acc, chunk)=>acc + chunk.length, 0);
                const combined = new Uint8Array(totalLength);
                let offset = 0;
                for (const chunk of chunks){
                    combined.set(chunk, offset);
                    offset += chunk.length;
                }
                args.body = combined;
                args.params = Object.assign(Object.assign({}, (_a = args.params) !== null && _a !== void 0 ? _a : {}), {
                    [$3wynb.NetworkParam.IsGzipped]: '1'
                });
            } catch (e) {
                $9Qn0V.Log.warn(`Request compression failed for ${args.urlConfig.getUrl()}`, e);
            }
        });
    }
    _getInternalRequestArgs(method, args) {
        const fallbackUrl = this._fallbackResolver.getActiveFallbackUrl(args.sdkKey, args.urlConfig);
        const result = Object.assign(Object.assign({}, args), {
            method: method,
            fallbackUrl: fallbackUrl
        });
        if ('data' in args) $e481c9d6519761a4$var$_populateRequestBody(result, args.data);
        return result;
    }
}
module.exports.NetworkCore = $e481c9d6519761a4$var$NetworkCore;
const $e481c9d6519761a4$var$_ensureValidSdkKey = (args)=>{
    if (!args.sdkKey) {
        $9Qn0V.Log.warn('Unable to make request without an SDK key');
        return false;
    }
    return true;
};
const $e481c9d6519761a4$var$_populateRequestBody = (args, data)=>{
    const { sdkKey: sdkKey, fallbackUrl: fallbackUrl } = args;
    const stableID = $177Kh.StableID.get(sdkKey);
    const sessionID = $ldhqF.SessionID.get(sdkKey);
    const sdkType = $9JrW9.SDKType._get(sdkKey);
    args.body = JSON.stringify(Object.assign(Object.assign({}, data), {
        statsigMetadata: Object.assign(Object.assign({}, $kVJXW.StatsigMetadataProvider.get()), {
            stableID: stableID,
            sessionID: sessionID,
            sdkType: sdkType,
            fallbackUrl: fallbackUrl
        })
    }));
};
function $e481c9d6519761a4$var$_allowCompression(args, options) {
    if (!args.isCompressable) return false;
    // Never compress if 'no-compress' is set globally or required APIs are unavailable
    if ((0, $8ZzeR._getStatsigGlobalFlag)('no-compress') != null || typeof CompressionStream === 'undefined' || typeof TextEncoder === 'undefined') return false;
    const isProxy = args.urlConfig.customUrl != null || args.urlConfig.fallbackUrls != null;
    const flagEnabled = $8Glek.SDKFlags.get(args.sdkKey, 'enable_log_event_compression') === true;
    switch(options.logEventCompressionMode){
        case $baWwc.LogEventCompressionMode.Disabled:
            return false;
        case $baWwc.LogEventCompressionMode.Enabled:
            // Only compress through proxy if flag is explicitly on
            if (isProxy && !flagEnabled) return false;
            return true;
        case $baWwc.LogEventCompressionMode.Forced:
            return true;
        default:
            return false;
    }
}
function $e481c9d6519761a4$var$_getErrorMessage(error) {
    if (typeof error === 'string') return error;
    if (error instanceof Error) return `${error.name}: ${error.message}`;
    return 'Unknown Error';
}
function $e481c9d6519761a4$var$_didTimeout(errorMsg, abortedByTimeout) {
    const timeout = errorMsg.includes('Timeout'); // probably not needed but just in case
    return timeout || abortedByTimeout;
}
function $e481c9d6519761a4$var$_tryMarkInitStart(args, attempt) {
    if (args.urlConfig.endpoint !== $3wynb.Endpoint._initialize) return;
    $4EJwp.Diagnostics._markInitNetworkReqStart(args.sdkKey, {
        attempt: attempt
    });
}
function $e481c9d6519761a4$var$_tryMarkInitEnd(args, response, attempt, body, err) {
    if (args.urlConfig.endpoint !== $3wynb.Endpoint._initialize) return;
    $4EJwp.Diagnostics._markInitNetworkReqEnd(args.sdkKey, $4EJwp.Diagnostics._getDiagnosticsData(response, attempt, body, err));
}
function $e481c9d6519761a4$var$_exponentialBackoff(attempt) {
    return $e481c9d6519761a4$var$__awaiter(this, void 0, void 0, function*() {
        // 1*1*1000 1s
        // 2*2*1000 4s
        // 3*3*1000 9s
        // 4*4*1000 16s
        // 5*5*1000 25s
        yield new Promise((r)=>setTimeout(r, Math.min($e481c9d6519761a4$var$BACKOFF_BASE_MS * (attempt * attempt), $e481c9d6519761a4$var$BACKOFF_MAX_MS)));
    });
}

});
parcelRegister("a10qE", function(module, exports) {
"use strict";
var $74aa5485be603eda$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._isDomainFailure = module.exports.NetworkFallbackResolver = void 0;

var $bSP3T = parcelRequire("bSP3T");

var $doPF1 = parcelRequire("doPF1");

var $9Qn0V = parcelRequire("9Qn0V");

var $jKkqw = parcelRequire("jKkqw");
const $74aa5485be603eda$var$DEFAULT_TTL_MS = 604800000; // 7 days
const $74aa5485be603eda$var$COOLDOWN_TIME_MS = 14400000; // 4 hours
class $74aa5485be603eda$var$NetworkFallbackResolver {
    constructor(options){
        var _a;
        this._fallbackInfo = null;
        this._errorBoundary = null;
        this._dnsQueryCooldowns = {};
        this._networkOverrideFunc = (_a = options.networkConfig) === null || _a === void 0 ? void 0 : _a.networkOverrideFunc;
    }
    setErrorBoundary(errorBoundary) {
        this._errorBoundary = errorBoundary;
    }
    tryBumpExpiryTime(sdkKey, urlConfig) {
        var _a;
        const info = (_a = this._fallbackInfo) === null || _a === void 0 ? void 0 : _a[urlConfig.endpoint];
        if (!info) return;
        info.expiryTime = Date.now() + $74aa5485be603eda$var$DEFAULT_TTL_MS;
        $74aa5485be603eda$var$_tryWriteFallbackInfoToCache(sdkKey, Object.assign(Object.assign({}, this._fallbackInfo), {
            [urlConfig.endpoint]: info
        }));
    }
    getActiveFallbackUrl(sdkKey, urlConfig) {
        var _a, _b;
        if (urlConfig.customUrl != null && urlConfig.fallbackUrls != null) return null;
        let info = this._fallbackInfo;
        if (info == null) {
            info = (_a = $74aa5485be603eda$var$_readFallbackInfoFromCache(sdkKey)) !== null && _a !== void 0 ? _a : {};
            this._fallbackInfo = info;
        }
        const entry = info[urlConfig.endpoint];
        if (!entry || Date.now() > ((_b = entry.expiryTime) !== null && _b !== void 0 ? _b : 0) || urlConfig.getChecksum() !== entry.urlConfigChecksum) {
            delete info[urlConfig.endpoint];
            this._fallbackInfo = info;
            $74aa5485be603eda$var$_tryWriteFallbackInfoToCache(sdkKey, this._fallbackInfo);
            return null;
        }
        if (entry.url) return entry.url;
        return null;
    }
    tryFetchUpdatedFallbackInfo(sdkKey, urlConfig, errorMessage, timedOut) {
        return $74aa5485be603eda$var$__awaiter(this, void 0, void 0, function*() {
            var _a, _b;
            try {
                if (!$74aa5485be603eda$var$_isDomainFailure(errorMessage, timedOut)) return false;
                const canUseNetworkFallbacks = urlConfig.customUrl == null && urlConfig.fallbackUrls == null;
                const urls = canUseNetworkFallbacks ? yield this._tryFetchFallbackUrlsFromNetwork(urlConfig) : urlConfig.fallbackUrls;
                const newUrl = this._pickNewFallbackUrl((_a = this._fallbackInfo) === null || _a === void 0 ? void 0 : _a[urlConfig.endpoint], urls);
                if (!newUrl) return false;
                this._updateFallbackInfoWithNewUrl(sdkKey, urlConfig, newUrl);
                return true;
            } catch (error) {
                (_b = this._errorBoundary) === null || _b === void 0 || _b.logError('tryFetchUpdatedFallbackInfo', error);
                return false;
            }
        });
    }
    _updateFallbackInfoWithNewUrl(sdkKey, urlConfig, newUrl) {
        var _a, _b, _c;
        const newFallbackInfo = {
            urlConfigChecksum: urlConfig.getChecksum(),
            url: newUrl,
            expiryTime: Date.now() + $74aa5485be603eda$var$DEFAULT_TTL_MS,
            previous: []
        };
        const endpoint = urlConfig.endpoint;
        const previousInfo = (_a = this._fallbackInfo) === null || _a === void 0 ? void 0 : _a[endpoint];
        if (previousInfo) newFallbackInfo.previous.push(...previousInfo.previous);
        if (newFallbackInfo.previous.length > 10) newFallbackInfo.previous = [];
        const previousUrl = (_c = (_b = this._fallbackInfo) === null || _b === void 0 ? void 0 : _b[endpoint]) === null || _c === void 0 ? void 0 : _c.url;
        if (previousUrl != null) newFallbackInfo.previous.push(previousUrl);
        this._fallbackInfo = Object.assign(Object.assign({}, this._fallbackInfo), {
            [endpoint]: newFallbackInfo
        });
        $74aa5485be603eda$var$_tryWriteFallbackInfoToCache(sdkKey, this._fallbackInfo);
    }
    _tryFetchFallbackUrlsFromNetwork(urlConfig) {
        return $74aa5485be603eda$var$__awaiter(this, void 0, void 0, function*() {
            var _a;
            const cooldown = this._dnsQueryCooldowns[urlConfig.endpoint];
            if (cooldown && Date.now() < cooldown) return null;
            this._dnsQueryCooldowns[urlConfig.endpoint] = Date.now() + $74aa5485be603eda$var$COOLDOWN_TIME_MS;
            const result = [];
            const records = yield (0, $bSP3T._fetchTxtRecords)((_a = this._networkOverrideFunc) !== null && _a !== void 0 ? _a : fetch);
            const path = $74aa5485be603eda$var$_extractPathFromUrl(urlConfig.defaultUrl);
            for (const record of records){
                if (!record.startsWith(urlConfig.endpointDnsKey + '=')) continue;
                const parts = record.split('=');
                if (parts.length > 1) {
                    let baseUrl = parts[1];
                    if (baseUrl.endsWith('/')) baseUrl = baseUrl.slice(0, -1);
                    result.push(`https://${baseUrl}${path}`);
                }
            }
            return result;
        });
    }
    _pickNewFallbackUrl(currentFallbackInfo, urls) {
        var _a;
        if (urls == null) return null;
        const previouslyUsed = new Set((_a = currentFallbackInfo === null || currentFallbackInfo === void 0 ? void 0 : currentFallbackInfo.previous) !== null && _a !== void 0 ? _a : []);
        const currentFallbackUrl = currentFallbackInfo === null || currentFallbackInfo === void 0 ? void 0 : currentFallbackInfo.url;
        let found = null;
        for (const loopUrl of urls){
            const url = loopUrl.endsWith('/') ? loopUrl.slice(0, -1) : loopUrl;
            if (!previouslyUsed.has(loopUrl) && url !== currentFallbackUrl) {
                found = url;
                break;
            }
        }
        return found;
    }
}
module.exports.NetworkFallbackResolver = $74aa5485be603eda$var$NetworkFallbackResolver;
function $74aa5485be603eda$var$_isDomainFailure(errorMsg, timedOut) {
    var _a;
    const lowerErrorMsg = (_a = errorMsg === null || errorMsg === void 0 ? void 0 : errorMsg.toLowerCase()) !== null && _a !== void 0 ? _a : '';
    return timedOut || lowerErrorMsg.includes('uncaught exception') || lowerErrorMsg.includes('failed to fetch') || lowerErrorMsg.includes('networkerror when attempting to fetch resource');
}
module.exports._isDomainFailure = $74aa5485be603eda$var$_isDomainFailure;
function $74aa5485be603eda$var$_getFallbackInfoStorageKey(sdkKey) {
    return `statsig.network_fallback.${(0, $doPF1._DJB2)(sdkKey)}`;
}
function $74aa5485be603eda$var$_tryWriteFallbackInfoToCache(sdkKey, info) {
    const hashKey = $74aa5485be603eda$var$_getFallbackInfoStorageKey(sdkKey);
    if (!info || Object.keys(info).length === 0) {
        $jKkqw.Storage.removeItem(hashKey);
        return;
    }
    $jKkqw.Storage.setItem(hashKey, JSON.stringify(info));
}
function $74aa5485be603eda$var$_readFallbackInfoFromCache(sdkKey) {
    const hashKey = $74aa5485be603eda$var$_getFallbackInfoStorageKey(sdkKey);
    const data = $jKkqw.Storage.getItem(hashKey);
    if (!data) return null;
    try {
        return JSON.parse(data);
    } catch (_a) {
        $9Qn0V.Log.error('Failed to parse FallbackInfo');
        return null;
    }
}
function $74aa5485be603eda$var$_extractPathFromUrl(urlString) {
    try {
        const url = new URL(urlString);
        return url.pathname;
    } catch (error) {
        return null;
    }
}

});
parcelRegister("bSP3T", function(module, exports) {
"use strict";
var $8a6c58a7750079be$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._fetchTxtRecords = void 0;
// See example: https://github.com/statsig-io/private-js-client-monorepo/pull/340
const $8a6c58a7750079be$var$FEATURE_ASSETS_DNS_QUERY = new Uint8Array([
    0x00,
    0x00,
    0x01,
    0x00,
    0x00,
    0x01,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x0d,
    0x66,
    0x65,
    0x61,
    0x74,
    0x75,
    0x72,
    0x65,
    0x61,
    0x73,
    0x73,
    0x65,
    0x74,
    0x73,
    0x03,
    0x6f,
    0x72,
    0x67,
    0x00,
    0x00,
    0x10,
    0x00,
    0x01
]);
const $8a6c58a7750079be$var$DNS_QUERY_ENDPOINT = 'https://cloudflare-dns.com/dns-query';
const $8a6c58a7750079be$var$DOMAIN_CHARS = [
    'i',
    'e',
    'd'
];
const $8a6c58a7750079be$var$MAX_START_LOOKUP = 200;
function $8a6c58a7750079be$var$_fetchTxtRecords(networkFunc) {
    return $8a6c58a7750079be$var$__awaiter(this, void 0, void 0, function*() {
        const response = yield networkFunc($8a6c58a7750079be$var$DNS_QUERY_ENDPOINT, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/dns-message',
                Accept: 'application/dns-message'
            },
            body: $8a6c58a7750079be$var$FEATURE_ASSETS_DNS_QUERY
        });
        if (!response.ok) {
            const err = new Error('Failed to fetch TXT records from DNS');
            err.name = 'DnsTxtFetchError';
            throw err;
        }
        const data = yield response.arrayBuffer();
        const bytes = new Uint8Array(data);
        return $8a6c58a7750079be$var$_parseDnsResponse(bytes);
    });
}
module.exports._fetchTxtRecords = $8a6c58a7750079be$var$_fetchTxtRecords;
function $8a6c58a7750079be$var$_parseDnsResponse(input) {
    // loop until we find the first valid domain char. One of [i=, e=, d=]
    const start = input.findIndex((byte, index)=>index < $8a6c58a7750079be$var$MAX_START_LOOKUP && String.fromCharCode(byte) === '=' && $8a6c58a7750079be$var$DOMAIN_CHARS.includes(String.fromCharCode(input[index - 1])));
    if (start === -1) {
        const err = new Error('Failed to parse TXT records from DNS');
        err.name = 'DnsTxtParseError';
        throw err;
    }
    // decode the remaining bytes as a string
    let result = '';
    for(let i = start - 1; i < input.length; i++)result += String.fromCharCode(input[i]);
    return result.split(',');
}

});


parcelRegister("8Glek", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SDKFlags = void 0;
const $6522b6cedbd90136$var$FLAGMAP = {};
module.exports.SDKFlags = {
    setFlags: (sdkKey, flags)=>{
        $6522b6cedbd90136$var$FLAGMAP[sdkKey] = flags;
    },
    get: (sdkKey, flagKey)=>{
        var _a, _b;
        return (_b = (_a = $6522b6cedbd90136$var$FLAGMAP[sdkKey]) === null || _a === void 0 ? void 0 : _a[flagKey]) !== null && _b !== void 0 ? _b : false;
    }
};

});

parcelRegister("ldhqF", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.StatsigSession = module.exports.SessionID = void 0;

var $8ZzeR = parcelRequire("8ZzeR");

var $4KuM7 = parcelRequire("4KuM7");

var $9Qn0V = parcelRequire("9Qn0V");

var $jKkqw = parcelRequire("jKkqw");

var $h59qk = parcelRequire("h59qk");
const $f71854f025bff3f7$var$MAX_SESSION_IDLE_TIME = 1800000; // 30 minutes
const $f71854f025bff3f7$var$MAX_SESSION_AGE = 14400000; // 4 hours
const $f71854f025bff3f7$var$PROMISE_MAP = {};
module.exports.SessionID = {
    get: (sdkKey)=>{
        return module.exports.StatsigSession.get(sdkKey).data.sessionID;
    }
};
module.exports.StatsigSession = {
    get: (sdkKey)=>{
        if ($f71854f025bff3f7$var$PROMISE_MAP[sdkKey] == null) $f71854f025bff3f7$var$PROMISE_MAP[sdkKey] = $f71854f025bff3f7$var$_loadSession(sdkKey);
        const session = $f71854f025bff3f7$var$PROMISE_MAP[sdkKey];
        return $f71854f025bff3f7$var$_bumpSession(session);
    },
    overrideInitialSessionID: (override, sdkKey)=>{
        $f71854f025bff3f7$var$PROMISE_MAP[sdkKey] = $f71854f025bff3f7$var$_overrideSessionId(override, sdkKey);
    }
};
function $f71854f025bff3f7$var$_loadSession(sdkKey) {
    let data = $f71854f025bff3f7$var$_loadFromStorage(sdkKey);
    const now = Date.now();
    if (!data) data = {
        sessionID: (0, $h59qk.getUUID)(),
        startTime: now,
        lastUpdate: now
    };
    return {
        data: data,
        sdkKey: sdkKey
    };
}
function $f71854f025bff3f7$var$_overrideSessionId(override, sdkKey) {
    const now = Date.now();
    return {
        data: {
            sessionID: override,
            startTime: now,
            lastUpdate: now
        },
        sdkKey: sdkKey
    };
}
function $f71854f025bff3f7$var$_bumpSession(session) {
    const now = Date.now();
    const data = session.data;
    const sdkKey = session.sdkKey;
    if ($f71854f025bff3f7$var$_isIdle(data) || $f71854f025bff3f7$var$_hasRunTooLong(data)) {
        data.sessionID = (0, $h59qk.getUUID)();
        data.startTime = now;
        const client = __STATSIG__ === null || __STATSIG__ === void 0 ? void 0 : __STATSIG__.instance(sdkKey);
        if (client) client.$emt({
            name: 'session_expired'
        });
    }
    data.lastUpdate = now;
    $f71854f025bff3f7$var$_persistToStorage(data, session.sdkKey);
    clearTimeout(session.idleTimeoutID);
    clearTimeout(session.ageTimeoutID);
    const lifetime = now - data.startTime;
    session.idleTimeoutID = $f71854f025bff3f7$var$_createSessionTimeout(sdkKey, $f71854f025bff3f7$var$MAX_SESSION_IDLE_TIME);
    session.ageTimeoutID = $f71854f025bff3f7$var$_createSessionTimeout(sdkKey, $f71854f025bff3f7$var$MAX_SESSION_AGE - lifetime);
    return session;
}
function $f71854f025bff3f7$var$_createSessionTimeout(sdkKey, duration) {
    return setTimeout(()=>{
        var _a;
        const client = (_a = (0, $8ZzeR._getStatsigGlobal)()) === null || _a === void 0 ? void 0 : _a.instance(sdkKey);
        if (client) client.$emt({
            name: 'session_expired'
        });
    }, duration);
}
function $f71854f025bff3f7$var$_isIdle({ lastUpdate: lastUpdate }) {
    return Date.now() - lastUpdate > $f71854f025bff3f7$var$MAX_SESSION_IDLE_TIME;
}
function $f71854f025bff3f7$var$_hasRunTooLong({ startTime: startTime }) {
    return Date.now() - startTime > $f71854f025bff3f7$var$MAX_SESSION_AGE;
}
function $f71854f025bff3f7$var$_getSessionIDStorageKey(sdkKey) {
    return `statsig.session_id.${(0, $4KuM7._getStorageKey)(sdkKey)}`;
}
function $f71854f025bff3f7$var$_persistToStorage(session, sdkKey) {
    const storageKey = $f71854f025bff3f7$var$_getSessionIDStorageKey(sdkKey);
    try {
        (0, $jKkqw._setObjectInStorage)(storageKey, session);
    } catch (e) {
        $9Qn0V.Log.warn('Failed to save SessionID');
    }
}
function $f71854f025bff3f7$var$_loadFromStorage(sdkKey) {
    const storageKey = $f71854f025bff3f7$var$_getSessionIDStorageKey(sdkKey);
    return (0, $jKkqw._getObjectFromStorage)(storageKey);
}

});

parcelRegister("83Y6N", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ErrorTag = void 0;
module.exports.ErrorTag = {
    NetworkError: 'NetworkError'
};

});


parcelRegister("goCQh", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("lUQm9", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("hZIMt", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._fastApproxSizeOf = void 0;
const $d19adeb366b08cf8$var$CURLY_AND_SQUARE_BRACKET_SIZE = 2; // [] for array, {} for object
const $d19adeb366b08cf8$var$APPROX_ADDITIONAL_SIZE = 1; // additional size for comma and stuff
const $d19adeb366b08cf8$var$_fastApproxSizeOf = (obj, max)=>{
    let size = 0;
    const keys = Object.keys(obj);
    for(let i = 0; i < keys.length; i++){
        const key = keys[i];
        const value = obj[key];
        size += key.length;
        if (typeof value === 'object' && value !== null) size += (0, module.exports._fastApproxSizeOf)(value, max) + $d19adeb366b08cf8$var$CURLY_AND_SQUARE_BRACKET_SIZE;
        else size += String(value).length + $d19adeb366b08cf8$var$APPROX_ADDITIONAL_SIZE;
        if (size >= max) // exit early if we've exceeded the max
        return size;
    }
    return size;
};
module.exports._fastApproxSizeOf = $d19adeb366b08cf8$var$_fastApproxSizeOf;

});

parcelRegister("3VNWn", function(module, exports) {
"use strict";
var $2dcd6f2005c48552$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.StatsigClientBase = void 0;

var $8ZzeR = parcelRequire("8ZzeR");

var $8ZzeR = parcelRequire("8ZzeR");

var $hpmwp = parcelRequire("hpmwp");

var $dJrZC = parcelRequire("dJrZC");

var $9Qn0V = parcelRequire("9Qn0V");

var $4wyC3 = parcelRequire("4wyC3");

var $hmoSx = parcelRequire("hmoSx");

var $ldhqF = parcelRequire("ldhqF");

var $177Kh = parcelRequire("177Kh");

var $baWwc = parcelRequire("baWwc");

var $jKkqw = parcelRequire("jKkqw");
const $2dcd6f2005c48552$var$MAX_MEMO_CACHE_SIZE = 3000;
class $2dcd6f2005c48552$var$StatsigClientBase {
    constructor(sdkKey, adapter, network, options){
        var _a, _b, _c, _d;
        this.loadingStatus = 'Uninitialized';
        this._initializePromise = null;
        this._listeners = {};
        const emitter = this.$emt.bind(this);
        (options === null || options === void 0 ? void 0 : options.logLevel) != null && ($9Qn0V.Log.level = options.logLevel);
        (options === null || options === void 0 ? void 0 : options.disableStorage) && $jKkqw.Storage._setDisabled(true);
        (options === null || options === void 0 ? void 0 : options.initialSessionID) && $ldhqF.StatsigSession.overrideInitialSessionID(options.initialSessionID, sdkKey);
        (options === null || options === void 0 ? void 0 : options.storageProvider) && $jKkqw.Storage._setProvider(options.storageProvider);
        (options === null || options === void 0 ? void 0 : options.enableCookies) && $177Kh.StableID._setCookiesEnabled(sdkKey, options.enableCookies);
        (options === null || options === void 0 ? void 0 : options.disableStableID) && $177Kh.StableID._setDisabled(sdkKey, true);
        this._sdkKey = sdkKey;
        this._options = options !== null && options !== void 0 ? options : {};
        this._memoCache = {};
        this.overrideAdapter = (_a = options === null || options === void 0 ? void 0 : options.overrideAdapter) !== null && _a !== void 0 ? _a : null;
        this._logger = new $dJrZC.EventLogger(sdkKey, emitter, network, options);
        this._errorBoundary = new $hpmwp.ErrorBoundary(sdkKey, options, emitter);
        this._errorBoundary.wrap(this);
        this._errorBoundary.wrap(adapter);
        this._errorBoundary.wrap(this._logger);
        network.setErrorBoundary(this._errorBoundary);
        this.dataAdapter = adapter;
        this.dataAdapter.attach(sdkKey, options, network);
        this.storageProvider = $jKkqw.Storage;
        (_d = (_c = (_b = this.overrideAdapter) === null || _b === void 0 ? void 0 : _b.loadFromStorage) === null || _c === void 0 ? void 0 : _c.call(_b)) === null || _d === void 0 || _d.catch((e)=>this._errorBoundary.logError('OA::loadFromStorage', e));
        this._primeReadyRipcord();
        $2dcd6f2005c48552$var$_assignGlobalInstance(sdkKey, this);
    }
    /**
     * Updates runtime configuration options for the SDK, allowing toggling of certain behaviors such as logging and storage to comply with user preferences or regulations such as GDPR.
     *
     * @param {StatsigRuntimeMutableOptions} options - The configuration options that dictate the runtime behavior of the SDK.
     */ updateRuntimeOptions(options) {
        if (options.loggingEnabled) {
            this._options.loggingEnabled = options.loggingEnabled;
            this._logger.setLoggingEnabled(options.loggingEnabled);
        } else if (options.disableLogging != null) {
            this._options.disableLogging = options.disableLogging;
            this._logger.setLoggingEnabled(options.disableLogging ? 'disabled' : 'browser-only');
        }
        if (options.disableStorage != null) {
            this._options.disableStorage = options.disableStorage;
            $jKkqw.Storage._setDisabled(options.disableStorage);
        }
        if (options.enableCookies != null) {
            this._options.enableCookies = options.enableCookies;
            $177Kh.StableID._setCookiesEnabled(this._sdkKey, options.enableCookies);
        }
        if (options.logEventCompressionMode) this._logger.setLogEventCompressionMode(options.logEventCompressionMode);
        else if (options.disableCompression) this._logger.setLogEventCompressionMode($baWwc.LogEventCompressionMode.Disabled);
    }
    /**
     * Flushes any currently queued events.
     */ flush() {
        return this._logger.flush();
    }
    /**
     * Gracefully shuts down the SDK, ensuring that all pending events are send before the SDK stops.
     * This function emits a 'pre_shutdown' event and then waits for the logger to complete its shutdown process.
     *
     * @returns {Promise<void>} A promise that resolves when all shutdown procedures, including logging shutdown, have been completed.
     */ shutdown() {
        return $2dcd6f2005c48552$var$__awaiter(this, void 0, void 0, function*() {
            this.$emt({
                name: 'pre_shutdown'
            });
            this._setStatus('Uninitialized', null);
            this._initializePromise = null;
            yield this._logger.stop();
        });
    }
    /**
     * Subscribes a callback function to a specific {@link StatsigClientEvent} or all StatsigClientEvents if the wildcard '*' is used.
     * Once subscribed, the listener callback will be invoked whenever the specified event is emitted.
     *
     * @param {StatsigClientEventName} event - The name of the event to subscribe to, or '*' to subscribe to all events.
     * @param {StatsigClientEventCallback<T>} listener - The callback function to execute when the event occurs. The function receives event-specific data as its parameter.
     * @see {@link off} for unsubscribing from events.
     */ on(event, listener) {
        if (!this._listeners[event]) this._listeners[event] = [];
        this._listeners[event].push(listener);
    }
    /**
     * Unsubscribes a previously registered callback function from a specific {@link StatsigClientEvent} or all StatsigClientEvents if the wildcard '*' is used.
     *
     * @param {StatsigClientEventName} event - The name of the event from which to unsubscribe, or '*' to unsubscribe from all events.
     * @param {StatsigClientEventCallback<T>} listener - The callback function to remove from the event's notification list.
     * @see {@link on} for subscribing to events.
     */ off(event, listener) {
        if (this._listeners[event]) {
            const index = this._listeners[event].indexOf(listener);
            if (index !== -1) this._listeners[event].splice(index, 1);
        }
    }
    $on(event, listener) {
        listener.__isInternal = true;
        this.on(event, listener);
    }
    $emt(event) {
        var _a;
        const barrier = (listener)=>{
            try {
                listener(event);
            } catch (error) {
                if (listener.__isInternal === true) {
                    this._errorBoundary.logError(`__emit:${event.name}`, error);
                    return;
                }
                $9Qn0V.Log.error(`An error occurred in a StatsigClientEvent listener. This is not an issue with Statsig.`, event);
            }
        };
        if (this._listeners[event.name]) this._listeners[event.name].forEach((l)=>barrier(l));
        (_a = this._listeners['*']) === null || _a === void 0 || _a.forEach(barrier);
    }
    _setStatus(newStatus, values) {
        this.loadingStatus = newStatus;
        this._memoCache = {};
        this.$emt({
            name: 'values_updated',
            status: newStatus,
            values: values
        });
    }
    _enqueueExposure(name, exposure, options) {
        if ((options === null || options === void 0 ? void 0 : options.disableExposureLog) === true) {
            this._logger.incrementNonExposureCount(name);
            return;
        }
        this._logger.enqueue(exposure);
    }
    _memoize(prefix, fn) {
        return (name, options)=>{
            if (this._options.disableEvaluationMemoization) return fn(name, options);
            const memoKey = (0, $4wyC3.createMemoKey)(prefix, name, options);
            if (!memoKey) return fn(name, options);
            if (!(memoKey in this._memoCache)) {
                if (Object.keys(this._memoCache).length >= $2dcd6f2005c48552$var$MAX_MEMO_CACHE_SIZE) this._memoCache = {};
                this._memoCache[memoKey] = fn(name, options);
            }
            return this._memoCache[memoKey];
        };
    }
}
module.exports.StatsigClientBase = $2dcd6f2005c48552$var$StatsigClientBase;
function $2dcd6f2005c48552$var$_assignGlobalInstance(sdkKey, client) {
    var _a;
    if ((0, $hmoSx._isServerEnv)()) return;
    const statsigGlobal = (0, $8ZzeR._getStatsigGlobal)();
    const instances = (_a = statsigGlobal.instances) !== null && _a !== void 0 ? _a : {};
    const inst = client;
    if (instances[sdkKey] != null) $9Qn0V.Log.warn('Creating multiple Statsig clients with the same SDK key can lead to unexpected behavior. Multi-instance support requires different SDK keys.');
    instances[sdkKey] = inst;
    if (!statsigGlobal.firstInstance) statsigGlobal.firstInstance = inst;
    statsigGlobal.instances = instances;
    __STATSIG__ = statsigGlobal;
}

});

parcelRegister("4H43E", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DataAdapterCachePrefix = void 0;
module.exports.DataAdapterCachePrefix = 'statsig.cached';

});

parcelRegister("c3WPJ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("li0QC", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._makeTypedGet = module.exports._mergeOverride = module.exports._makeLayer = module.exports._makeExperiment = module.exports._makeDynamicConfig = module.exports._makeFeatureGate = void 0;

var $9Qn0V = parcelRequire("9Qn0V");

var $cvjEj = parcelRequire("cvjEj");
function $f7fbefbf171b454f$var$_makeEvaluation(name, details, evaluation, value) {
    var _a;
    return {
        name: name,
        details: details,
        ruleID: (_a = evaluation === null || evaluation === void 0 ? void 0 : evaluation.rule_id) !== null && _a !== void 0 ? _a : '',
        __evaluation: evaluation,
        value: value
    };
}
function $f7fbefbf171b454f$var$_makeFeatureGate(name, details, evaluation) {
    var _a;
    return Object.assign(Object.assign({}, $f7fbefbf171b454f$var$_makeEvaluation(name, details, evaluation, (evaluation === null || evaluation === void 0 ? void 0 : evaluation.value) === true)), {
        idType: (_a = evaluation === null || evaluation === void 0 ? void 0 : evaluation.id_type) !== null && _a !== void 0 ? _a : null
    });
}
module.exports._makeFeatureGate = $f7fbefbf171b454f$var$_makeFeatureGate;
function $f7fbefbf171b454f$var$_makeDynamicConfig(name, details, evaluation) {
    var _a, _b;
    const value = (_a = evaluation === null || evaluation === void 0 ? void 0 : evaluation.value) !== null && _a !== void 0 ? _a : {};
    return Object.assign(Object.assign({}, $f7fbefbf171b454f$var$_makeEvaluation(name, details, evaluation, value)), {
        idType: (_b = evaluation === null || evaluation === void 0 ? void 0 : evaluation.id_type) !== null && _b !== void 0 ? _b : null,
        get: $f7fbefbf171b454f$var$_makeTypedGet(name, evaluation === null || evaluation === void 0 ? void 0 : evaluation.value)
    });
}
module.exports._makeDynamicConfig = $f7fbefbf171b454f$var$_makeDynamicConfig;
function $f7fbefbf171b454f$var$_makeExperiment(name, details, evaluation) {
    var _a;
    const result = $f7fbefbf171b454f$var$_makeDynamicConfig(name, details, evaluation);
    return Object.assign(Object.assign({}, result), {
        groupName: (_a = evaluation === null || evaluation === void 0 ? void 0 : evaluation.group_name) !== null && _a !== void 0 ? _a : null
    });
}
module.exports._makeExperiment = $f7fbefbf171b454f$var$_makeExperiment;
function $f7fbefbf171b454f$var$_makeLayer(name, details, evaluation, exposeFunc) {
    var _a, _b;
    return Object.assign(Object.assign({}, $f7fbefbf171b454f$var$_makeEvaluation(name, details, evaluation, undefined)), {
        get: $f7fbefbf171b454f$var$_makeTypedGet(name, evaluation === null || evaluation === void 0 ? void 0 : evaluation.value, exposeFunc),
        groupName: (_a = evaluation === null || evaluation === void 0 ? void 0 : evaluation.group_name) !== null && _a !== void 0 ? _a : null,
        __value: (_b = evaluation === null || evaluation === void 0 ? void 0 : evaluation.value) !== null && _b !== void 0 ? _b : {}
    });
}
module.exports._makeLayer = $f7fbefbf171b454f$var$_makeLayer;
function $f7fbefbf171b454f$var$_mergeOverride(original, overridden, value, exposeFunc) {
    return Object.assign(Object.assign(Object.assign({}, original), overridden), {
        get: $f7fbefbf171b454f$var$_makeTypedGet(original.name, value, exposeFunc)
    });
}
module.exports._mergeOverride = $f7fbefbf171b454f$var$_mergeOverride;
function $f7fbefbf171b454f$var$_makeTypedGet(name, value, exposeFunc) {
    return (param, fallback)=>{
        var _a;
        const found = (_a = value === null || value === void 0 ? void 0 : value[param]) !== null && _a !== void 0 ? _a : null;
        if (found == null) return fallback !== null && fallback !== void 0 ? fallback : null;
        if (fallback != null && !(0, $cvjEj._isTypeMatch)(found, fallback)) {
            $9Qn0V.Log.warn(`Parameter type mismatch. '${name}.${param}' was found to be type '${typeof found}' but fallback/return type is '${typeof fallback}'. See https://docs.statsig.com/client/javascript-sdk/#typed-getters`);
            return fallback !== null && fallback !== void 0 ? fallback : null;
        }
        exposeFunc === null || exposeFunc === void 0 || exposeFunc(param);
        return found;
    };
}
module.exports._makeTypedGet = $f7fbefbf171b454f$var$_makeTypedGet;

});

parcelRegister("gGLwe", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("kyXOf", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.UPDATE_DETAIL_ERROR_MESSAGES = module.exports.createUpdateDetails = void 0;
const $ef85608773efd0e6$var$createUpdateDetails = (success, source, initDuration, error, sourceUrl, warnings)=>{
    return {
        duration: initDuration,
        source: source,
        success: success,
        error: error,
        sourceUrl: sourceUrl,
        warnings: warnings
    };
};
module.exports.createUpdateDetails = $ef85608773efd0e6$var$createUpdateDetails;
module.exports.UPDATE_DETAIL_ERROR_MESSAGES = {
    NO_NETWORK_DATA: 'No data was returned from the network. This may be due to a network timeout if a timeout value was specified in the options or ad blocker error.'
};

});


parcelRegister("lu3xa", function(module, exports) {
"use strict";
var $fa3f2418ee7c081d$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $328Ep = parcelRequire("328Ep");

var $fuXzR = parcelRequire("fuXzR");

var $hxRpg = parcelRequire("hxRpg");

var $kFTAR = parcelRequire("kFTAR");

var $5Mu2S = parcelRequire("5Mu2S");
class $fa3f2418ee7c081d$var$StatsigClient extends $328Ep.StatsigClientBase {
    /**
     * Retrieves an instance of the StatsigClient based on the provided SDK key.
     *  If no SDK key is provided, the method returns the most recently created instance of the StatsigClient.
     *  The method ensures that each unique SDK key corresponds to a single instance of StatsigClient, effectively implementing a singleton pattern for each key.
     *  If no instance exists for the given SDK key, a new StatsigClient instance will be created and returned.
     *
     * @param {string} [sdkKey] - Optional. The SDK key used to identify a specific instance of the StatsigClient. If omitted, the method returns the last created instance.
     * @returns {StatsigClient} Returns the StatsigClient instance associated with the given SDK key, creating a new one if needed.
     */ static instance(sdkKey) {
        const instance = (0, $328Ep._getStatsigGlobal)().instance(sdkKey);
        if (instance instanceof $fa3f2418ee7c081d$var$StatsigClient) return instance;
        $328Ep.Log.warn((0, $328Ep._isServerEnv)() ? 'StatsigClient.instance is not supported in server environments' : 'Unable to find StatsigClient instance');
        return new $fa3f2418ee7c081d$var$StatsigClient(sdkKey !== null && sdkKey !== void 0 ? sdkKey : '', {});
    }
    /**
     * StatsigClient constructor
     *
     * @param {string} sdkKey A Statsig client SDK key. eg "client-xyz123..."
     * @param {StatsigUser} user StatsigUser object containing various attributes related to a user.
     * @param {StatsigOptions | null} options StatsigOptions, used to customize the behavior of the SDK.
     */ constructor(sdkKey, user, options = null){
        var _a, _b;
        $328Ep.SDKType._setClientType(sdkKey, 'javascript-client');
        const network = new $hxRpg.default(options, (e)=>{
            this.$emt(e);
        });
        super(sdkKey, (_a = options === null || options === void 0 ? void 0 : options.dataAdapter) !== null && _a !== void 0 ? _a : new $5Mu2S.StatsigEvaluationsDataAdapter(), network, options);
        this._possibleFirstTouchMetadata = {};
        /**
         * Retrieves the value of a feature gate for the current user, represented as a {@link FeatureGate} object.
         *
         * @param {string} name - The name of the feature gate to retrieve.
         * @param {FeatureGateEvaluationOptions} [options] - Optional. Additional options to customize the method call.
         * @returns {FeatureGate} - The {@link FeatureGate} object representing the gate's current evaluation results for the user.
         */ this.getFeatureGate = this._memoize($328Ep.MemoPrefix._gate, this._getFeatureGateImpl.bind(this));
        /**
         * Retrieves the value of a dynamic config for the current user.
         *
         * @param {string} name The name of the dynamic config to get.
         * @param {DynamicConfigEvaluationOptions} [options] - Optional. Additional options to customize the method call.
         * @returns {DynamicConfig} - The {@link DynamicConfig} object representing the dynamic configs's current evaluation results for the user.
         */ this.getDynamicConfig = this._memoize($328Ep.MemoPrefix._dynamicConfig, this._getDynamicConfigImpl.bind(this));
        /**
         * Retrieves the value of a experiment for the current user.
         *
         * @param {string} name The name of the experiment to get.
         * @param {ExperimentEvaluationOptions} [options] - Optional. Additional options to customize the method call.
         * @returns {Experiment} - The {@link Experiment} object representing the experiments's current evaluation results for the user.
         */ this.getExperiment = this._memoize($328Ep.MemoPrefix._experiment, this._getExperimentImpl.bind(this));
        /**
         * Retrieves the list of all Dynamic Configs and Experiments for the current user.
         *
         * @returns {string[]} The list of all Dynamic Config and Experiment names for the current user. Note - these will be hashed unless you've disabled hashing.
         * This is intended to be used for debugging.
         */ this.getConfigList = this._memoize($328Ep.MemoPrefix._configList, this._getConfigListImpl.bind(this));
        /**
         * Retrieves the value of a layer for the current user.
         *
         * @param {string} name The name of the layer to get.
         * @param {LayerEvaluationOptions} [options] - Optional. Additional options to customize the method call.
         * @returns {Layer} - The {@link Layer} object representing the layers's current evaluation results for the user.
         */ this.getLayer = this._memoize($328Ep.MemoPrefix._layer, this._getLayerImpl.bind(this));
        /**
         * Retrieves the value of a parameter store for the current user.
         *
         * @param {string} name The name of the parameter store to get.
         * @param {ParameterStoreEvaluationOptions} [options] - Optional. Additional options to customize the method call.
         * @returns {ParameterStore} - The {@link ParameterStore} object representing the parameter store's current mappings for the user.
         */ this.getParameterStore = this._memoize($328Ep.MemoPrefix._paramStore, this._getParameterStoreImpl.bind(this));
        this._store = new $fuXzR.default(sdkKey);
        this._network = network;
        this._user = this._configureUser(user, options);
        this._sdkInstanceID = (0, $328Ep.getUUID)();
        const plugins = (_b = options === null || options === void 0 ? void 0 : options.plugins) !== null && _b !== void 0 ? _b : [];
        for (const plugin of plugins)plugin.bind(this);
    }
    /**
     * Initializes the StatsigClient using cached values. This method sets up the client synchronously by utilizing previously cached values.
     * After initialization, cache values are updated in the background for future use, either in subsequent sessions or when `updateUser` is called.
     * This is useful for quickly starting with the last-known-good configurations while refreshing data to keep settings up-to-date.
     *
     * @see {@link initializeAsync} for the asynchronous version of this method.
     */ initializeSync(options) {
        var _a;
        if (this.loadingStatus !== 'Uninitialized') return (0, $328Ep.createUpdateDetails)(true, this._store.getSource(), -1, null, null, [
            'MultipleInitializations',
            ...(_a = this._store.getWarnings()) !== null && _a !== void 0 ? _a : []
        ]);
        this._logger.start();
        return this.updateUserSync(this._user, options);
    }
    /**
     * Initializes the StatsigClient asynchronously by first using cached values and then updating to the latest values from the network.
     * Once the network values are fetched, they replace the existing cached values. If this method's promise is not awaited,
     * there might be a transition from cached to network values during the session, which can affect consistency.
     * This method is useful when it's acceptable to begin with potentially stale data and switch to the latest configuration as it becomes available.
     *
     * @param {AsyncUpdateOptions} [options] - Optional. Additional options to customize the method call.
     * @returns {Promise<void>} A promise that resolves once the client is fully initialized with the latest values from the network or a timeout (if set) is hit.
     * @see {@link initializeSync} for the synchronous version of this method.
     */ initializeAsync(options) {
        return $fa3f2418ee7c081d$var$__awaiter(this, void 0, void 0, function*() {
            if (this._initializePromise) return this._initializePromise;
            this._initializePromise = this._initializeAsyncImpl(options);
            return this._initializePromise;
        });
    }
    /**
     * Synchronously updates the user in the Statsig client and switches the internal state to use cached values for the newly specified user.
     * After the initial switch to cached values, this method updates these values in the background, preparing them for future sessions or subsequent calls to updateUser.
     * This method ensures the client is quickly ready with available data.
     *
     * @param {StatsigUser} user - The new StatsigUser for which the client should update its internal state.
     * @see {@link updateUserAsync} for the asynchronous version of this method.
     */ updateUserSync(user, options) {
        const startTime = performance.now();
        try {
            return this._updateUserSyncImpl(user, options, startTime);
        } catch (e) {
            const err = e instanceof Error ? e : new Error(String(e));
            return this._createErrorUpdateDetails(err, startTime);
        }
    }
    _updateUserSyncImpl(user, options, startTime) {
        var _a;
        const warnings = [
            ...(_a = this._store.getWarnings()) !== null && _a !== void 0 ? _a : []
        ];
        this._resetForUser(user);
        const result = this.dataAdapter.getDataSync(this._user);
        if (result == null) warnings.push('NoCachedValues');
        this._store.setValues(result, this._user);
        this._finalizeUpdate(result);
        const disable = options === null || options === void 0 ? void 0 : options.disableBackgroundCacheRefresh;
        if (disable === true || disable == null && (result === null || result === void 0 ? void 0 : result.source) === 'Bootstrap') return (0, $328Ep.createUpdateDetails)(true, this._store.getSource(), performance.now() - startTime, this._errorBoundary.getLastSeenErrorAndReset(), this._network.getLastUsedInitUrlAndReset(), warnings);
        this._runPostUpdate(result !== null && result !== void 0 ? result : null, this._user);
        return (0, $328Ep.createUpdateDetails)(true, this._store.getSource(), performance.now() - startTime, this._errorBoundary.getLastSeenErrorAndReset(), this._network.getLastUsedInitUrlAndReset(), warnings);
    }
    /**
     * Asynchronously updates the user in the Statsig client by initially using cached values and then fetching the latest values from the network.
     * When the latest values are fetched, they replace the cached values. If the promise returned by this method is not awaited,
     * the client's state may shift from cached to updated network values during the session, potentially affecting consistency.
     * This method is best used in scenarios where up-to-date configuration is critical and initial delays are acceptable.
     *
     * @param {StatsigUser} user - The new StatsigUser for which the client should update its internal state.
     * @param {AsyncUpdateOptions} [options] - Optional. Additional options to customize the method call.
     * @returns {Promise<void>} A promise that resolves once the client is fully updated with the latest values from the network or a timeout (if set) is hit.
     * @see {@link updateUserSync} for the synchronous version of this method.
     */ updateUserAsync(user, options) {
        return $fa3f2418ee7c081d$var$__awaiter(this, void 0, void 0, function*() {
            const startTime = performance.now();
            try {
                return yield this._updateUserAsyncImpl(user, options);
            } catch (e) {
                const err = e instanceof Error ? e : new Error(String(e));
                return this._createErrorUpdateDetails(err, startTime);
            }
        });
    }
    _updateUserAsyncImpl(user, options) {
        return $fa3f2418ee7c081d$var$__awaiter(this, void 0, void 0, function*() {
            this._resetForUser(user);
            const initiator = this._user;
            $328Ep.Diagnostics._markInitOverallStart(this._sdkKey);
            let result = this.dataAdapter.getDataSync(initiator);
            this._store.setValues(result, this._user);
            this._setStatus('Loading', result);
            result = yield this.dataAdapter.getDataAsync(result, initiator, options);
            // ensure the user hasn't changed while we were waiting
            if (initiator !== this._user) return (0, $328Ep.createUpdateDetails)(false, this._store.getSource(), -1, new Error('User changed during update'), this._network.getLastUsedInitUrlAndReset());
            let isUsingNetworkValues = false;
            if (result != null) {
                $328Ep.Diagnostics._markInitProcessStart(this._sdkKey);
                isUsingNetworkValues = this._store.setValues(result, this._user);
                $328Ep.Diagnostics._markInitProcessEnd(this._sdkKey, {
                    success: isUsingNetworkValues
                });
            }
            this._finalizeUpdate(result);
            if (!isUsingNetworkValues) {
                this._errorBoundary.attachErrorIfNoneExists($328Ep.UPDATE_DETAIL_ERROR_MESSAGES.NO_NETWORK_DATA);
                this.$emt({
                    name: 'initialization_failure'
                });
            }
            $328Ep.Diagnostics._markInitOverallEnd(this._sdkKey, isUsingNetworkValues, this._store.getCurrentSourceDetails());
            const initDuration = $328Ep.Diagnostics._enqueueDiagnosticsEvent(this._user, this._logger, this._sdkKey, this._options);
            return (0, $328Ep.createUpdateDetails)(isUsingNetworkValues, this._store.getSource(), initDuration, this._errorBoundary.getLastSeenErrorAndReset(), this._network.getLastUsedInitUrlAndReset(), this._store.getWarnings());
        });
    }
    /**
     * Retrieves a synchronous context containing data currently being used by the SDK. Represented as a {@link PrecomputedEvaluationsContext} object.
     *
     * @returns {PrecomputedEvaluationsContext} The current synchronous context for the this StatsigClient instance.
     */ getContext() {
        let user = {};
        try {
            user = JSON.parse(JSON.stringify(this._user));
        } catch (_a) {
            $328Ep.Log.error('Failed to parse user');
        }
        return {
            sdkKey: this._sdkKey,
            options: this._options,
            values: this._store.getValues(),
            user: user,
            errorBoundary: this._errorBoundary,
            session: $328Ep.StatsigSession.get(this._sdkKey),
            stableID: $328Ep.StableID.get(this._sdkKey),
            sdkInstanceID: this._sdkInstanceID
        };
    }
    /**
     * Retrieves the value of a feature gate for the current user, represented as a simple boolean.
     *
     * @param {string} name - The name of the feature gate to retrieve.
     * @param {FeatureGateEvaluationOptions} [options] - Optional. Additional options to customize the method call.
     * @returns {boolean} - The boolean value representing the gate's current evaluation results for the user.
     */ checkGate(name, options) {
        return this.getFeatureGate(name, options).value;
    }
    /**
     * Logs an event to the internal logging system. This function allows logging by either passing a fully formed event object or by specifying the event name with optional value and metadata.
     *
     * @param {StatsigEvent|string} eventOrName - The event object conforming to the StatsigEvent interface, or the name of the event as a string.
     * @param {string|number} value - Optional. The value associated with the event, which can be a string or a number. This parameter is ignored if the first parameter is a StatsigEvent object.
     * @param {Record<string, string>} metadata - Optional. A key-value record containing metadata about the event. This is also ignored if the first parameter is an event object.
     */ logEvent(eventOrName, value, metadata) {
        const event = typeof eventOrName === 'string' ? {
            eventName: eventOrName,
            value: value,
            metadata: metadata
        } : eventOrName;
        this.$emt({
            name: 'log_event_called',
            event: event
        });
        this._logger.enqueue(Object.assign(Object.assign({}, event), {
            user: this._user,
            time: Date.now()
        }));
    }
    /**
     * Updates the user with analytics only metadata. This will override any existing analytics only metadata.
     *
     * @param {Record<string, string | number | boolean>} metadata - The metadata to add to the user.
     */ updateUserWithAnalyticsOnlyMetadata(metadata) {
        this._user = this._configureUser(Object.assign(Object.assign({}, this._user), {
            analyticsOnlyMetadata: metadata
        }), this._options);
    }
    _primeReadyRipcord() {
        this.$on('error', ()=>{
            this.loadingStatus === 'Loading' && this._finalizeUpdate(null);
        });
    }
    _initializeAsyncImpl(options) {
        return $fa3f2418ee7c081d$var$__awaiter(this, void 0, void 0, function*() {
            if (!$328Ep.Storage.isReady()) yield $328Ep.Storage.isReadyResolver();
            this._logger.start();
            return this.updateUserAsync(this._user, options);
        });
    }
    _createErrorUpdateDetails(error, startTime) {
        var _a;
        return (0, $328Ep.createUpdateDetails)(false, this._store.getSource(), performance.now() - startTime, error, null, [
            ...(_a = this._store.getWarnings()) !== null && _a !== void 0 ? _a : []
        ]);
    }
    _finalizeUpdate(values) {
        this._store.finalize();
        this._setStatus('Ready', values);
    }
    _runPostUpdate(current, user) {
        this.dataAdapter.getDataAsync(current, user, {
            priority: 'low'
        }).catch((err)=>{
            $328Ep.Log.error('An error occurred after update.', err);
        });
    }
    _resetForUser(user) {
        this._logger.reset();
        this._store.reset();
        this._user = this._configureUser(user, this._options);
    }
    _configureUser(originalUser, options) {
        var _a, _b, _c;
        const user = (0, $328Ep._normalizeUser)(originalUser, options);
        const stableIdOverride = (_a = user.customIDs) === null || _a === void 0 ? void 0 : _a.stableID;
        if (stableIdOverride) {
            const readyPromise = (_c = (_b = this.storageProvider).isReadyResolver) === null || _c === void 0 ? void 0 : _c.call(_b);
            if (readyPromise) readyPromise.then(()=>$328Ep.StableID.setOverride(stableIdOverride, this._sdkKey), ()=>$328Ep.StableID.setOverride(stableIdOverride, this._sdkKey));
            else $328Ep.StableID.setOverride(stableIdOverride, this._sdkKey);
        }
        // Only attach first touch metadata if it's not empty
        if (Object.keys(this._possibleFirstTouchMetadata).length > 0) user.analyticsOnlyMetadata = Object.assign(Object.assign({}, user.analyticsOnlyMetadata), this._possibleFirstTouchMetadata);
        return user;
    }
    _getFeatureGateImpl(name, options) {
        var _a, _b;
        const { result: evaluation, details: details } = this._store.getGate(name);
        const gate = (0, $328Ep._makeFeatureGate)(name, details, evaluation);
        const overridden = (_b = (_a = this.overrideAdapter) === null || _a === void 0 ? void 0 : _a.getGateOverride) === null || _b === void 0 ? void 0 : _b.call(_a, gate, this._user, options);
        const result = overridden !== null && overridden !== void 0 ? overridden : gate;
        this._enqueueExposure(name, (0, $328Ep._createGateExposure)(this._user, result, this._store.getExposureMapping()), options);
        this.$emt({
            name: 'gate_evaluation',
            gate: result
        });
        return result;
    }
    _getDynamicConfigImpl(name, options) {
        var _a, _b;
        const { result: evaluation, details: details } = this._store.getConfig(name);
        const config = (0, $328Ep._makeDynamicConfig)(name, details, evaluation);
        const overridden = (_b = (_a = this.overrideAdapter) === null || _a === void 0 ? void 0 : _a.getDynamicConfigOverride) === null || _b === void 0 ? void 0 : _b.call(_a, config, this._user, options);
        const result = overridden !== null && overridden !== void 0 ? overridden : config;
        this._enqueueExposure(name, (0, $328Ep._createConfigExposure)(this._user, result, this._store.getExposureMapping()), options);
        this.$emt({
            name: 'dynamic_config_evaluation',
            dynamicConfig: result
        });
        return result;
    }
    _getExperimentImpl(name, options) {
        var _a, _b, _c, _d;
        const { result: evaluation, details: details } = this._store.getConfig(name);
        const experiment = (0, $328Ep._makeExperiment)(name, details, evaluation);
        if (experiment.__evaluation != null) experiment.__evaluation.secondary_exposures = (0, $328Ep._mapExposures)((_b = (_a = experiment.__evaluation) === null || _a === void 0 ? void 0 : _a.secondary_exposures) !== null && _b !== void 0 ? _b : [], this._store.getExposureMapping());
        const overridden = (_d = (_c = this.overrideAdapter) === null || _c === void 0 ? void 0 : _c.getExperimentOverride) === null || _d === void 0 ? void 0 : _d.call(_c, experiment, this._user, options);
        const result = overridden !== null && overridden !== void 0 ? overridden : experiment;
        this._enqueueExposure(name, (0, $328Ep._createConfigExposure)(this._user, result, this._store.getExposureMapping()), options);
        this.$emt({
            name: 'experiment_evaluation',
            experiment: result
        });
        return result;
    }
    _getConfigListImpl() {
        return this._store.getConfigList();
    }
    _getLayerImpl(name, options) {
        var _a, _b, _c;
        const { result: evaluation, details: details } = this._store.getLayer(name);
        const layer = (0, $328Ep._makeLayer)(name, details, evaluation);
        const overridden = (_b = (_a = this.overrideAdapter) === null || _a === void 0 ? void 0 : _a.getLayerOverride) === null || _b === void 0 ? void 0 : _b.call(_a, layer, this._user, options);
        if (options === null || options === void 0 ? void 0 : options.disableExposureLog) this._logger.incrementNonExposureCount(name);
        const result = (0, $328Ep._mergeOverride)(layer, overridden, (_c = overridden === null || overridden === void 0 ? void 0 : overridden.__value) !== null && _c !== void 0 ? _c : layer.__value, (param)=>{
            if (options === null || options === void 0 ? void 0 : options.disableExposureLog) return;
            this._enqueueExposure(name, (0, $328Ep._createLayerParameterExposure)(this._user, result, param, this._store.getExposureMapping()), options);
        });
        this.$emt({
            name: 'layer_evaluation',
            layer: result
        });
        return result;
    }
    _getParameterStoreImpl(name, options) {
        var _a, _b;
        const { result: configuration, details: details } = this._store.getParamStore(name);
        this._logger.incrementNonExposureCount(name);
        const paramStore = {
            name: name,
            details: details,
            __configuration: configuration,
            get: (0, $kFTAR._makeParamStoreGetter)(this, configuration, options)
        };
        const overridden = (_b = (_a = this.overrideAdapter) === null || _a === void 0 ? void 0 : _a.getParamStoreOverride) === null || _b === void 0 ? void 0 : _b.call(_a, paramStore, options);
        if (overridden != null) {
            paramStore.__configuration = overridden.config;
            paramStore.details = overridden.details;
            paramStore.get = (0, $kFTAR._makeParamStoreGetter)(this, overridden.config, options);
        }
        return paramStore;
    }
}
module.exports.default = $fa3f2418ee7c081d$var$StatsigClient;

});
parcelRegister("fuXzR", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $328Ep = parcelRequire("328Ep");

var $kPXiO = parcelRequire("kPXiO");

var $9Vohm = parcelRequire("9Vohm");
class $b487df3073f2a376$var$EvaluationStore {
    constructor(_sdkKey){
        this._sdkKey = _sdkKey;
        this._rawValues = null;
        this._values = null;
        this._source = 'Uninitialized';
        this._lcut = 0;
        this._receivedAt = 0;
        this._bootstrapMetadata = null;
        this._warnings = new Set();
    }
    reset() {
        this._values = null;
        this._rawValues = null;
        this._source = 'Loading';
        this._lcut = 0;
        this._receivedAt = 0;
        this._bootstrapMetadata = null;
        this._warnings.clear();
    }
    finalize() {
        if (this._values) return;
        this._source = 'NoValues';
    }
    getValues() {
        return this._rawValues ? (0, $328Ep._typedJsonParse)(this._rawValues, 'has_updates', 'EvaluationStoreValues') : null;
    }
    setValues(result, user) {
        var _a, _b;
        if (!result) return false;
        const values = (0, $328Ep._typedJsonParse)(result.data, 'has_updates', 'EvaluationResponse');
        if (values == null) return false;
        this._source = result.source;
        if ((values === null || values === void 0 ? void 0 : values.has_updates) !== true) return true;
        const updatedLcut = (_a = values.time) !== null && _a !== void 0 ? _a : 0;
        if (updatedLcut < this._lcut) return true;
        this._rawValues = result.data;
        this._lcut = values.time;
        this._receivedAt = result.receivedAt;
        if (values.response_format === 'init-v2') this._values = new $9Vohm.V2InitializeContainer(values);
        else this._values = new $kPXiO.V1InitializeContainer(values);
        this._bootstrapMetadata = this._extractBootstrapMetadata(result.source, values);
        if (result.source && values.user) this._setWarningState(user, values);
        $328Ep.SDKFlags.setFlags(this._sdkKey, (_b = values.sdk_flags) !== null && _b !== void 0 ? _b : {});
        return true;
    }
    getWarnings() {
        if (this._warnings.size === 0) return undefined;
        return Array.from(this._warnings);
    }
    getGate(name) {
        const res = this._values ? this._values.getGate(name) : null;
        return this._getDetailedStoreResult(res);
    }
    getConfig(name) {
        const res = this._values ? this._values.getConfig(name) : null;
        return this._getDetailedStoreResult(res);
    }
    getConfigList() {
        if (!this._values) return [];
        return this._values.getConfigList();
    }
    getLayer(name) {
        const res = this._values ? this._values.getLayer(name) : null;
        return this._getDetailedStoreResult(res);
    }
    getParamStore(name) {
        const res = this._values ? this._values.getParamStore(name) : null;
        return this._getDetailedStoreResult(res);
    }
    getSource() {
        return this._source;
    }
    getExposureMapping() {
        var _a;
        return (_a = this._values) === null || _a === void 0 ? void 0 : _a.getExposureMapping();
    }
    _extractBootstrapMetadata(source, values) {
        if (source !== 'Bootstrap') return null;
        const bootstrapMetadata = {};
        if (values.user) bootstrapMetadata.user = values.user;
        if (values.sdkInfo) bootstrapMetadata.generatorSDKInfo = values.sdkInfo;
        bootstrapMetadata.lcut = values.time;
        return bootstrapMetadata;
    }
    _getDetailedStoreResult(result) {
        return {
            result: result,
            details: this._getDetails(result == null)
        };
    }
    _setWarningState(user, values) {
        var _a, _b;
        const stableID = $328Ep.StableID.get(this._sdkKey);
        if (((_a = user.customIDs) === null || _a === void 0 ? void 0 : _a.stableID) !== stableID && // don't throw if they're both undefined
        (((_b = user.customIDs) === null || _b === void 0 ? void 0 : _b.stableID) || stableID)) {
            this._warnings.add('StableIDMismatch');
            return;
        }
        if ('user' in values) {
            const bootstrapUser = values['user'];
            const userForComparison = Object.assign(Object.assign({}, user), {
                analyticsOnlyMetadata: undefined,
                privateAttributes: undefined
            });
            if ((0, $328Ep._getFullUserHash)(userForComparison) !== (0, $328Ep._getFullUserHash)(bootstrapUser)) this._warnings.add('PartialUserMatch');
        }
    }
    getCurrentSourceDetails() {
        if (this._source === 'Uninitialized' || this._source === 'NoValues') return {
            reason: this._source
        };
        const sourceDetails = {
            reason: this._source,
            lcut: this._lcut,
            receivedAt: this._receivedAt
        };
        if (this._warnings.size > 0) sourceDetails.warnings = Array.from(this._warnings);
        return sourceDetails;
    }
    _getDetails(isUnrecognized) {
        var _a, _b;
        const sourceDetails = this.getCurrentSourceDetails();
        let reason = sourceDetails.reason;
        const warnings = (_a = sourceDetails.warnings) !== null && _a !== void 0 ? _a : [];
        if (this._source === 'Bootstrap' && warnings.length > 0) reason = reason + warnings[0];
        if (reason !== 'Uninitialized' && reason !== 'NoValues') {
            const subreason = isUnrecognized ? 'Unrecognized' : 'Recognized';
            reason = `${reason}:${subreason}`;
        }
        const bootstrapMetadata = this._source === 'Bootstrap' ? (_b = this._bootstrapMetadata) !== null && _b !== void 0 ? _b : undefined : undefined;
        if (bootstrapMetadata) sourceDetails.bootstrapMetadata = bootstrapMetadata;
        return Object.assign(Object.assign({}, sourceDetails), {
            reason: reason
        });
    }
}
module.exports.default = $b487df3073f2a376$var$EvaluationStore;

});
parcelRegister("kPXiO", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.V1InitializeContainer = void 0;

var $328Ep = parcelRequire("328Ep");
class $f2b6924ffe6e62a7$var$V1InitializeContainer {
    constructor(_values){
        this._values = _values;
    }
    getGate(name) {
        return this._getResultFromLookup(this._values.feature_gates, name);
    }
    getConfig(name) {
        return this._getResultFromLookup(this._values.dynamic_configs, name);
    }
    getLayer(name) {
        return this._getResultFromLookup(this._values.layer_configs, name);
    }
    getParamStore(name) {
        return this._getResultFromLookup(this._values.param_stores, name);
    }
    getConfigList() {
        return Object.keys(this._values.dynamic_configs);
    }
    getExposureMapping() {
        return this._values.exposures;
    }
    _getResultFromLookup(lookup, name) {
        var _a, _b;
        if (!lookup) return null;
        return (_b = (_a = lookup[name]) !== null && _a !== void 0 ? _a : lookup[(0, $328Ep._DJB2)(name)]) !== null && _b !== void 0 ? _b : null;
    }
}
module.exports.V1InitializeContainer = $f2b6924ffe6e62a7$var$V1InitializeContainer;

});

parcelRegister("9Vohm", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.V2InitializeContainer = void 0;

var $328Ep = parcelRequire("328Ep");
class $739c453cf4e8d3b8$var$V2InitializeContainer {
    constructor(_values){
        this._values = _values;
    }
    getGate(name) {
        var _a, _b, _c;
        const evalV2 = this._getResultFromLookup(this._values.feature_gates, name);
        if (!evalV2) return null;
        return {
            name: name,
            value: evalV2.v === true,
            rule_id: (_a = evalV2.r) !== null && _a !== void 0 ? _a : 'default',
            secondary_exposures: (_b = evalV2.s) !== null && _b !== void 0 ? _b : [],
            id_type: (_c = evalV2.i) !== null && _c !== void 0 ? _c : ''
        };
    }
    getConfig(name) {
        var _a, _b, _c, _d;
        const evalV2 = this._getResultFromLookup(this._values.dynamic_configs, name);
        if (!evalV2) return null;
        return {
            name: name,
            value: (_a = this._values.values[evalV2.v]) !== null && _a !== void 0 ? _a : {},
            rule_id: evalV2.r,
            secondary_exposures: (_b = evalV2.s) !== null && _b !== void 0 ? _b : [],
            id_type: (_c = evalV2.i) !== null && _c !== void 0 ? _c : '',
            is_user_in_experiment: evalV2.ue === true ? true : false,
            passed: evalV2.p === true,
            group_name: (_d = evalV2.gn) !== null && _d !== void 0 ? _d : undefined,
            is_experiment_active: evalV2.ea === true ? true : false,
            group: evalV2.r,
            is_device_based: evalV2.i === 'stableID'
        };
    }
    getLayer(name) {
        var _a, _b, _c, _d, _e, _f;
        const evalV2 = this._getResultFromLookup(this._values.layer_configs, name);
        if (!evalV2) return null;
        return {
            name: name,
            value: (_a = this._values.values[evalV2.v]) !== null && _a !== void 0 ? _a : {},
            rule_id: evalV2.r,
            secondary_exposures: (_b = evalV2.s) !== null && _b !== void 0 ? _b : [],
            is_user_in_experiment: evalV2.ue === true ? true : false,
            group_name: (_c = evalV2.gn) !== null && _c !== void 0 ? _c : undefined,
            is_experiment_active: evalV2.ea === true ? true : false,
            group: evalV2.r,
            is_device_based: evalV2.i === 'stableID',
            allocated_experiment_name: (_d = evalV2.ae) !== null && _d !== void 0 ? _d : '',
            explicit_parameters: (_e = evalV2.ep) !== null && _e !== void 0 ? _e : [],
            undelegated_secondary_exposures: (_f = evalV2.us) !== null && _f !== void 0 ? _f : [],
            parameter_rule_ids: evalV2.pr
        };
    }
    getParamStore(name) {
        return this._getResultFromLookup(this._values.param_stores, name);
    }
    getConfigList() {
        return Object.keys(this._values.dynamic_configs);
    }
    getExposureMapping() {
        return this._values.exposures;
    }
    _getResultFromLookup(lookup, name) {
        var _a, _b;
        if (!lookup) return null;
        return (_b = (_a = lookup[name]) !== null && _a !== void 0 ? _a : lookup[(0, $328Ep._DJB2)(name)]) !== null && _b !== void 0 ? _b : null;
    }
}
module.exports.V2InitializeContainer = $739c453cf4e8d3b8$var$V2InitializeContainer;

});


parcelRegister("hxRpg", function(module, exports) {
"use strict";
var $cc5ef2283efe5fdd$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $328Ep = parcelRequire("328Ep");

var $aberb = parcelRequire("aberb");
class $cc5ef2283efe5fdd$var$StatsigNetwork extends $328Ep.NetworkCore {
    constructor(options, emitter){
        super(options, emitter);
        const config = options === null || options === void 0 ? void 0 : options.networkConfig;
        this._option = options;
        this._initializeUrlConfig = new $328Ep.UrlConfiguration($328Ep.Endpoint._initialize, config === null || config === void 0 ? void 0 : config.initializeUrl, config === null || config === void 0 ? void 0 : config.api, config === null || config === void 0 ? void 0 : config.initializeFallbackUrls);
    }
    fetchEvaluations(sdkKey, current, priority, user, isCacheValidFor204) {
        return $cc5ef2283efe5fdd$var$__awaiter(this, void 0, void 0, function*() {
            var _a, _b, _c, _d, _e, _f;
            const cache = current ? (0, $328Ep._typedJsonParse)(current, 'has_updates', 'InitializeResponse') : null;
            let data = {
                user: user,
                hash: (_c = (_b = (_a = this._option) === null || _a === void 0 ? void 0 : _a.networkConfig) === null || _b === void 0 ? void 0 : _b.initializeHashAlgorithm) !== null && _c !== void 0 ? _c : 'djb2',
                deltasResponseRequested: false,
                full_checksum: null
            };
            if (cache === null || cache === void 0 ? void 0 : cache.has_updates) {
                const hasHashChanged = (cache === null || cache === void 0 ? void 0 : cache.hash_used) !== ((_f = (_e = (_d = this._option) === null || _d === void 0 ? void 0 : _d.networkConfig) === null || _e === void 0 ? void 0 : _e.initializeHashAlgorithm) !== null && _f !== void 0 ? _f : 'djb2');
                data = Object.assign(Object.assign({}, data), {
                    sinceTime: isCacheValidFor204 && !hasHashChanged ? cache.time : 0,
                    previousDerivedFields: 'derived_fields' in cache && isCacheValidFor204 ? cache.derived_fields : {},
                    deltasResponseRequested: true,
                    full_checksum: cache.full_checksum,
                    partialUserMatchSinceTime: !hasHashChanged ? cache.time : 0
                });
            }
            return this._fetchEvaluations(sdkKey, cache, data, priority);
        });
    }
    _fetchEvaluations(sdkKey, cache, data, priority) {
        return $cc5ef2283efe5fdd$var$__awaiter(this, void 0, void 0, function*() {
            var _a, _b;
            const response = yield this.post({
                sdkKey: sdkKey,
                urlConfig: this._initializeUrlConfig,
                data: data,
                retries: 2,
                isStatsigEncodable: true,
                priority: priority
            });
            if ((response === null || response === void 0 ? void 0 : response.code) === 204) return '{"has_updates": false}';
            if ((response === null || response === void 0 ? void 0 : response.code) !== 200) return (_a = response === null || response === void 0 ? void 0 : response.body) !== null && _a !== void 0 ? _a : null;
            if ((cache === null || cache === void 0 ? void 0 : cache.has_updates) !== true || ((_b = response.body) === null || _b === void 0 ? void 0 : _b.includes('"is_delta":true')) !== true || data.deltasResponseRequested !== true) return response.body;
            const result = (0, $aberb._resolveDeltasResponse)(cache, response.body);
            if (typeof result === 'string') return result;
            // retry without deltas
            return this._fetchEvaluations(sdkKey, cache, Object.assign(Object.assign(Object.assign({}, data), result), {
                deltasResponseRequested: false
            }), priority);
        });
    }
}
module.exports.default = $cc5ef2283efe5fdd$var$StatsigNetwork;

});
parcelRegister("aberb", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._resolveDeltasResponse = void 0;

var $328Ep = parcelRequire("328Ep");
const $76962169f2d7409a$var$MAX_DELTAS_SORT_DEPTH = 2;
function $76962169f2d7409a$var$_resolveDeltasResponse(cache, deltasString) {
    const deltas = (0, $328Ep._typedJsonParse)(deltasString, 'checksum', 'DeltasEvaluationResponse');
    if (!deltas) return {
        hadBadDeltaChecksum: true
    };
    const merged = $76962169f2d7409a$var$_mergeDeltasIntoCache(cache, deltas);
    const resolved = $76962169f2d7409a$var$_handleDeletedEntries(merged);
    const actualChecksum = (0, $328Ep._DJB2Object)({
        feature_gates: resolved.feature_gates,
        dynamic_configs: resolved.dynamic_configs,
        layer_configs: resolved.layer_configs
    }, $76962169f2d7409a$var$MAX_DELTAS_SORT_DEPTH);
    const isMatch = actualChecksum === deltas.checksumV2;
    if (!isMatch) return {
        hadBadDeltaChecksum: true,
        badChecksum: actualChecksum,
        badMergedConfigs: resolved,
        badFullResponse: deltas.deltas_full_response
    };
    return JSON.stringify(resolved);
}
module.exports._resolveDeltasResponse = $76962169f2d7409a$var$_resolveDeltasResponse;
function $76962169f2d7409a$var$_mergeDeltasIntoCache(cache, deltas) {
    return Object.assign(Object.assign(Object.assign({}, cache), deltas), {
        feature_gates: Object.assign(Object.assign({}, cache.feature_gates), deltas.feature_gates),
        layer_configs: Object.assign(Object.assign({}, cache.layer_configs), deltas.layer_configs),
        dynamic_configs: Object.assign(Object.assign({}, cache.dynamic_configs), deltas.dynamic_configs)
    });
}
function $76962169f2d7409a$var$_handleDeletedEntries(deltas) {
    const result = deltas;
    $76962169f2d7409a$var$_deleteEntriesInRecord(deltas.deleted_gates, result.feature_gates);
    delete result.deleted_gates;
    $76962169f2d7409a$var$_deleteEntriesInRecord(deltas.deleted_configs, result.dynamic_configs);
    delete result.deleted_configs;
    $76962169f2d7409a$var$_deleteEntriesInRecord(deltas.deleted_layers, result.layer_configs);
    delete result.deleted_layers;
    return result;
}
function $76962169f2d7409a$var$_deleteEntriesInRecord(keys, values) {
    keys === null || keys === void 0 || keys.forEach((key)=>{
        delete values[key];
    });
}

});


parcelRegister("kFTAR", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._makeParamStoreGetter = void 0;

var $328Ep = parcelRequire("328Ep");
const $f0d2c2b84e993347$var$NO_EXPOSURE_OPT = {
    disableExposureLog: true
};
function $f0d2c2b84e993347$var$_shouldLogExposure(options) {
    return options == null || options.disableExposureLog === false;
}
function $f0d2c2b84e993347$var$_shouldReturnFallback(value, fallback) {
    return fallback != null && !(0, $328Ep._isTypeMatch)(value, fallback);
}
function $f0d2c2b84e993347$var$_getMappedStaticValue(param, _options) {
    return param.value;
}
function $f0d2c2b84e993347$var$_getMappedGateValue(client, param, options) {
    const gate = client.getFeatureGate(param.gate_name, $f0d2c2b84e993347$var$_shouldLogExposure(options) ? undefined : $f0d2c2b84e993347$var$NO_EXPOSURE_OPT);
    if (gate.value) return param.pass_value;
    return param.fail_value;
}
function $f0d2c2b84e993347$var$_getMappedDynamicConfigValue(client, param, fallback, options) {
    const config = client.getDynamicConfig(param.config_name, $f0d2c2b84e993347$var$_shouldLogExposure(options) ? undefined : $f0d2c2b84e993347$var$NO_EXPOSURE_OPT);
    const value = config.get(param.param_name);
    if ($f0d2c2b84e993347$var$_shouldReturnFallback(value, fallback)) return fallback;
    return value;
}
function $f0d2c2b84e993347$var$_getMappedExperimentValue(client, param, fallback, options) {
    const experiment = client.getExperiment(param.experiment_name, $f0d2c2b84e993347$var$_shouldLogExposure(options) ? undefined : $f0d2c2b84e993347$var$NO_EXPOSURE_OPT);
    const value = experiment.get(param.param_name);
    if ($f0d2c2b84e993347$var$_shouldReturnFallback(value, fallback)) return fallback;
    return value;
}
function $f0d2c2b84e993347$var$_getMappedLayerValue(client, param, fallback, options) {
    const layer = client.getLayer(param.layer_name, $f0d2c2b84e993347$var$_shouldLogExposure(options) ? undefined : $f0d2c2b84e993347$var$NO_EXPOSURE_OPT);
    const value = layer.get(param.param_name);
    if ($f0d2c2b84e993347$var$_shouldReturnFallback(value, fallback)) return fallback;
    return value;
}
function $f0d2c2b84e993347$var$_makeParamStoreGetter(client, config, options) {
    return (paramName, fallback)=>{
        if (config == null) return fallback;
        const param = config[paramName];
        if (param == null || fallback != null && (0, $328Ep._typeOf)(fallback) !== param.param_type) return fallback;
        switch(param.ref_type){
            case 'static':
                return $f0d2c2b84e993347$var$_getMappedStaticValue(param, options);
            case 'gate':
                return $f0d2c2b84e993347$var$_getMappedGateValue(client, param, options);
            case 'dynamic_config':
                return $f0d2c2b84e993347$var$_getMappedDynamicConfigValue(client, param, fallback, options);
            case 'experiment':
                return $f0d2c2b84e993347$var$_getMappedExperimentValue(client, param, fallback, options);
            case 'layer':
                return $f0d2c2b84e993347$var$_getMappedLayerValue(client, param, fallback, options);
            default:
                return fallback;
        }
    };
}
module.exports._makeParamStoreGetter = $f0d2c2b84e993347$var$_makeParamStoreGetter;

});

parcelRegister("5Mu2S", function(module, exports) {
"use strict";
var $4358bdd71218f80e$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.StatsigEvaluationsDataAdapter = void 0;

var $328Ep = parcelRequire("328Ep");

var $hxRpg = parcelRequire("hxRpg");
class $4358bdd71218f80e$var$StatsigEvaluationsDataAdapter extends $328Ep.DataAdapterCore {
    constructor(){
        super('EvaluationsDataAdapter', 'evaluations');
        this._network = null;
        this._options = null;
    }
    attach(sdkKey, options, network) {
        super.attach(sdkKey, options, network);
        if (network !== null && network instanceof $hxRpg.default) this._network = network;
        else this._network = new $hxRpg.default(options !== null && options !== void 0 ? options : {});
    }
    getDataAsync(current, user, options) {
        return this._getDataAsyncImpl(current, (0, $328Ep._normalizeUser)(user, this._options), options);
    }
    prefetchData(user, options) {
        return this._prefetchDataImpl(user, options);
    }
    setData(data) {
        const values = (0, $328Ep._typedJsonParse)(data, 'has_updates', 'data');
        if (values && 'user' in values) super.setData(data, values.user);
        else $328Ep.Log.error('StatsigUser not found. You may be using an older server SDK version. Please upgrade your SDK or use setDataLegacy.');
    }
    setDataLegacy(data, user) {
        super.setData(data, user);
    }
    _fetchFromNetwork(current, user, options, isCacheValidFor204) {
        return $4358bdd71218f80e$var$__awaiter(this, void 0, void 0, function*() {
            var _a;
            const result = yield (_a = this._network) === null || _a === void 0 ? void 0 : _a.fetchEvaluations(this._getSdkKey(), current, options === null || options === void 0 ? void 0 : options.priority, user, isCacheValidFor204);
            return result !== null && result !== void 0 ? result : null;
        });
    }
    _getCacheKey(user) {
        var _a;
        const key = (0, $328Ep._getStorageKey)(this._getSdkKey(), user, (_a = this._options) === null || _a === void 0 ? void 0 : _a.customUserCacheKeyFunc);
        return `${$328Ep.DataAdapterCachePrefix}.${this._cacheSuffix}.${key}`;
    }
    _isCachedResultValidFor204(result, user) {
        return result.fullUserHash != null && result.fullUserHash === (0, $328Ep._getFullUserHash)(user);
    }
}
module.exports.StatsigEvaluationsDataAdapter = $4358bdd71218f80e$var$StatsigEvaluationsDataAdapter;

});



parcelRegister("5sFjq", function(module, exports) {
$parcel$export(module.exports, "default", () => $3f9f9d0f283704a1$export$2e2bcd8739ae039);

var $k2IPD = parcelRequire("k2IPD");

var $edw2y = parcelRequire("edw2y");

var $hZ7a4 = parcelRequire("hZ7a4");

var $hLfKH = parcelRequire("hLfKH");
function $3f9f9d0f283704a1$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $3f9f9d0f283704a1$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $3f9f9d0f283704a1$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $hZ7a4.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $3f9f9d0f283704a1$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $3f9f9d0f283704a1$export$a66cbd9b2289cd78 = '@all-features';
// eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
var $3f9f9d0f283704a1$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function Subscriptions() {
        (0, $k2IPD.default)(this, Subscriptions);
        (0, $hZ7a4.default)(this, "eventToValue", new Map());
        this.emitter = new (0, (/*@__PURE__*/$parcel$interopDefault($hLfKH)))();
    }
    return (0, $edw2y.default)(Subscriptions, [
        {
            key: "onGateUpdated",
            value: function onGateUpdated(gateName, callback, checkGate, options) {
                var _this = this;
                var value = checkGate(gateName, $3f9f9d0f283704a1$var$_objectSpread($3f9f9d0f283704a1$var$_objectSpread({}, options), {}, {
                    fireGateExposure: false
                }));
                if (this.eventToValue.get(callback) === undefined) this.eventToValue.set(callback, value);
                var wrapCallback = function wrapCallback() {
                    var value = checkGate(gateName, $3f9f9d0f283704a1$var$_objectSpread($3f9f9d0f283704a1$var$_objectSpread({}, options), {}, {
                        fireGateExposure: false
                    }));
                    var existingValue = _this.eventToValue.get(callback);
                    if (existingValue !== value) {
                        _this.eventToValue.set(callback, value);
                        callback(value);
                    }
                };
                this.emitter.on(gateName, wrapCallback);
                return function() {
                    _this.emitter.off(gateName, wrapCallback);
                };
            }
        },
        {
            key: "onExperimentValueUpdated",
            value: function onExperimentValueUpdated(experimentName, parameterName, defaultValue, callback, getExperimentValue, options) {
                var _this2 = this;
                var experimentEventName = "".concat(experimentName, ".").concat(parameterName);
                var value = getExperimentValue(experimentName, parameterName, defaultValue, $3f9f9d0f283704a1$var$_objectSpread($3f9f9d0f283704a1$var$_objectSpread({}, options), {}, {
                    fireExperimentExposure: false
                }));
                if (this.eventToValue.get(callback) === undefined) this.eventToValue.set(callback, value);
                var wrapCallback = function wrapCallback() {
                    var value = getExperimentValue(experimentName, parameterName, defaultValue, $3f9f9d0f283704a1$var$_objectSpread($3f9f9d0f283704a1$var$_objectSpread({}, options), {}, {
                        fireExperimentExposure: false
                    }));
                    var existingValue = _this2.eventToValue.get(callback);
                    if (existingValue !== value) {
                        _this2.eventToValue.set(callback, value);
                        callback(value);
                    }
                };
                this.emitter.on(experimentEventName, wrapCallback);
                return function() {
                    _this2.emitter.off(experimentEventName, wrapCallback);
                };
            }
        },
        {
            key: "onAnyUpdated",
            value: function onAnyUpdated(callback) {
                var _this3 = this;
                this.emitter.on($3f9f9d0f283704a1$export$a66cbd9b2289cd78, callback);
                return function() {
                    _this3.emitter.off($3f9f9d0f283704a1$export$a66cbd9b2289cd78, callback);
                };
            }
        },
        {
            key: "anyUpdated",
            value: function anyUpdated() {
                var _this4 = this;
                this.emitter.emit($3f9f9d0f283704a1$export$a66cbd9b2289cd78);
                this.emitter.eventNames().filter(function(name) {
                    return name !== $3f9f9d0f283704a1$export$a66cbd9b2289cd78;
                }).forEach(function(event) {
                    _this4.emitter.emit(event);
                });
            }
        }
    ]);
}();

});

parcelRegister("kkQZA", function(module, exports) {
$parcel$export(module.exports, "DynamicConfig", () => $ecdec8188da1c9fe$export$6dc24881a3d96325);

var $aAdgI = parcelRequire("aAdgI");

var $k2IPD = parcelRequire("k2IPD");

var $edw2y = parcelRequire("edw2y");

var $j7bB3 = parcelRequire("j7bB3");

var $9VHw5 = parcelRequire("9VHw5");
var $ecdec8188da1c9fe$export$6dc24881a3d96325 = /*#__PURE__*/ function() {
    function DynamicConfig(configName, configValue, ruleID, evaluationDetails) {
        var secondaryExposures = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : [];
        var allocatedExperimentName = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : '';
        var onDefaultValueFallback = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : null;
        (0, $k2IPD.default)(this, DynamicConfig);
        this.value = configValue;
        this._name = configName;
        this._ruleID = ruleID;
        this._secondaryExposures = secondaryExposures;
        this._allocatedExperimentName = allocatedExperimentName;
        this._evaluationDetails = evaluationDetails;
        this._onDefaultValueFallback = onDefaultValueFallback;
    }
    return (0, $edw2y.default)(DynamicConfig, [
        {
            key: "get",
            value: function get(key, defaultValue, typeGuard) {
                var _this$_onDefaultValue2;
                var val = this.getValue(key, defaultValue);
                if (val == null) return defaultValue;
                var expectedType = Array.isArray(defaultValue) ? 'array' : (0, $aAdgI.default)(defaultValue);
                var actualType = Array.isArray(val) ? 'array' : (0, $aAdgI.default)(val);
                if (typeGuard) {
                    var _this$_onDefaultValue;
                    if (typeGuard(val)) {
                        this.fireExposure(key);
                        return val;
                    }
                    (_this$_onDefaultValue = this._onDefaultValueFallback) === null || _this$_onDefaultValue === void 0 || _this$_onDefaultValue.call(this, this, key, expectedType, actualType);
                    return defaultValue;
                }
                if (defaultValue == null || expectedType === actualType) {
                    this.fireExposure(key);
                    return val;
                }
                (_this$_onDefaultValue2 = this._onDefaultValueFallback) === null || _this$_onDefaultValue2 === void 0 || _this$_onDefaultValue2.call(this, this, key, expectedType, actualType);
                return defaultValue;
            }
        },
        {
            key: "getValue",
            value: function getValue(key, defaultValue) {
                if (key == null) return this.value;
                if (defaultValue == null) defaultValue = null;
                if (this.value[key] == null) return defaultValue;
                this.fireExposure(key);
                return this.value[key];
            }
        },
        {
            key: "fireExposure",
            value: function fireExposure(key) {
                // Call the wrapped experiment's get method to fire exposure
                if (this.experiment) this.experiment.get(key);
            }
        }
    ], [
        {
            key: "fromExperiment",
            value: function fromExperiment(experiment) {
                var _experiment$__evaluat, _experiment$__evaluat2, _experiment$groupName;
                var config = new DynamicConfig(experiment.name, experiment.value, experiment.ruleID, (0, $j7bB3.migrateEvaluationDetails)(experiment.details), (0, $9VHw5.migrateSecondaryExposures)((_experiment$__evaluat = (_experiment$__evaluat2 = experiment.__evaluation) === null || _experiment$__evaluat2 === void 0 ? void 0 : _experiment$__evaluat2.secondary_exposures) !== null && _experiment$__evaluat !== void 0 ? _experiment$__evaluat : []), (_experiment$groupName = experiment.groupName) !== null && _experiment$groupName !== void 0 ? _experiment$groupName : undefined);
                config.experiment = experiment;
                return config;
            }
        }
    ]);
}();

});
parcelRegister("j7bB3", function(module, exports) {
$parcel$export(module.exports, "migrateEvaluationDetails", () => $dea7aaa0993ce0b6$export$18ad168d3dbac899);

var $3OJNo = parcelRequire("3OJNo");

var $48eYA = parcelRequire("48eYA");
var $dea7aaa0993ce0b6$var$evaluationReasonMappings = Object.entries((0, $48eYA.EvaluationReason)).map(function(_ref) {
    var _ref2 = (0, $3OJNo.default)(_ref, 2), key = _ref2[0], value = _ref2[1];
    return [
        key.toLowerCase(),
        value
    ];
});
var $dea7aaa0993ce0b6$export$18ad168d3dbac899 = function migrateEvaluationDetails(details) {
    var _evaluationReasonMapp, _evaluationReasonMapp2, _details$receivedAt;
    var reasonLower = details.reason.toLowerCase();
    return {
        reason: (_evaluationReasonMapp = (_evaluationReasonMapp2 = $dea7aaa0993ce0b6$var$evaluationReasonMappings.find(function(_ref3) {
            var _ref4 = (0, $3OJNo.default)(_ref3, 1), key = _ref4[0];
            return reasonLower.includes(key);
        })) === null || _evaluationReasonMapp2 === void 0 ? void 0 : _evaluationReasonMapp2[1]) !== null && _evaluationReasonMapp !== void 0 ? _evaluationReasonMapp : (0, $48eYA.EvaluationReason).Unknown,
        time: (_details$receivedAt = details.receivedAt) !== null && _details$receivedAt !== void 0 ? _details$receivedAt : Date.now()
    };
};

});
parcelRegister("48eYA", function(module, exports) {
$parcel$export(module.exports, "EvaluationReason", () => $302386bafd9817fa$export$c62558b199e46828);
// Reference: https://github.com/statsig-io/js-lite/blob/main/src/StatsigStore.ts
var $302386bafd9817fa$export$c62558b199e46828 = {
    // Order is important since the logic for migrating from a new client reason to an old one
    // returns the first which is a substring of the new client reason
    Error: 'Error',
    LocalOverride: 'LocalOverride',
    Unrecognized: 'Unrecognized',
    Uninitialized: 'Uninitialized',
    NetworkNotModified: 'NetworkNotModified',
    Network: 'Network',
    InvalidBootstrap: 'InvalidBootstrap',
    Bootstrap: 'Bootstrap',
    Cache: 'Cache',
    // For when we could not migrate the reason from the new client
    Unknown: 'Unknown'
}; // Reference: https://github.com/statsig-io/js-lite/blob/main/src/StatsigSDKOptions.ts

});


parcelRegister("9VHw5", function(module, exports) {
$parcel$export(module.exports, "migrateSecondaryExposures", () => $73ab3161307c3c32$export$55fd683752d01e67);
var $73ab3161307c3c32$export$55fd683752d01e67 = function migrateSecondaryExposures(secondaryExposures) {
    return secondaryExposures.map(function(exposure) {
        if (typeof exposure === 'string') // This should ideally have gateValue and ruleID fields too, but it's not possible for us
        // to determine the correct values for these.
        return {
            gate: exposure
        };
        return exposure;
    });
};

});


parcelRegister("eVlof", function(module, exports) {
$parcel$export(module.exports, "Layer", () => $add6fb2e41b0a16b$export$936d0764594b6eb3);

var $aAdgI = parcelRequire("aAdgI");

var $k2IPD = parcelRequire("k2IPD");

var $edw2y = parcelRequire("edw2y");

var $j7bB3 = parcelRequire("j7bB3");

var $9VHw5 = parcelRequire("9VHw5");
var $add6fb2e41b0a16b$export$936d0764594b6eb3 = /*#__PURE__*/ function() {
    function Layer(name, layerValue, ruleID, evaluationDetails) {
        var logParameterFunction = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;
        var secondaryExposures = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : [];
        var undelegatedSecondaryExposures = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : [];
        var allocatedExperimentName = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : '';
        var explicitParameters = arguments.length > 8 && arguments[8] !== undefined ? arguments[8] : [];
        (0, $k2IPD.default)(this, Layer);
        this._logParameterFunction = logParameterFunction;
        this._name = name;
        this._value = JSON.parse(JSON.stringify(layerValue !== null && layerValue !== void 0 ? layerValue : {}));
        this._ruleID = ruleID !== null && ruleID !== void 0 ? ruleID : '';
        this._evaluationDetails = evaluationDetails;
        this._secondaryExposures = secondaryExposures;
        this._undelegatedSecondaryExposures = undelegatedSecondaryExposures;
        this._allocatedExperimentName = allocatedExperimentName;
        this._explicitParameters = explicitParameters;
    }
    return (0, $edw2y.default)(Layer, [
        {
            key: "get",
            value: function get(key, defaultValue, typeGuard) {
                var _this = this;
                var val = this._value[key];
                if (val == null) return defaultValue;
                var logAndReturn = function logAndReturn() {
                    _this._logLayerParameterExposure(key);
                    return val;
                };
                if (typeGuard) return typeGuard(val) ? logAndReturn() : defaultValue;
                if (defaultValue == null) return logAndReturn();
                if ((0, $aAdgI.default)(val) === (0, $aAdgI.default)(defaultValue) && Array.isArray(defaultValue) === Array.isArray(val)) return logAndReturn();
                return defaultValue;
            }
        },
        {
            key: "getValue",
            value: function getValue(key, defaultValue) {
                // eslint-disable-next-line eqeqeq
                if (defaultValue == undefined) defaultValue = null;
                var val = this._value[key];
                if (val != null) this._logLayerParameterExposure(key);
                return val !== null && val !== void 0 ? val : defaultValue;
            }
        },
        {
            key: "_logLayerParameterExposure",
            value: function _logLayerParameterExposure(parameterName) {
                var _this$_logParameterFu;
                (_this$_logParameterFu = this._logParameterFunction) === null || _this$_logParameterFu === void 0 || _this$_logParameterFu.call(this, this, parameterName);
            }
        }
    ], [
        {
            key: "fromLayer",
            value: function fromLayer(layer) {
                var _layer$__evaluation$s, _layer$__evaluation, _layer$__evaluation$u, _layer$__evaluation2, _layer$__evaluation3, _layer$__evaluation4;
                var value = new Layer(layer.name, layer.__value, layer.ruleID, (0, $j7bB3.migrateEvaluationDetails)(layer.details), function(_layer, parameterName) {
                    return layer.get(parameterName);
                }, (0, $9VHw5.migrateSecondaryExposures)((_layer$__evaluation$s = (_layer$__evaluation = layer.__evaluation) === null || _layer$__evaluation === void 0 ? void 0 : _layer$__evaluation.secondary_exposures) !== null && _layer$__evaluation$s !== void 0 ? _layer$__evaluation$s : []), (0, $9VHw5.migrateSecondaryExposures)((_layer$__evaluation$u = (_layer$__evaluation2 = layer.__evaluation) === null || _layer$__evaluation2 === void 0 ? void 0 : _layer$__evaluation2.undelegated_secondary_exposures) !== null && _layer$__evaluation$u !== void 0 ? _layer$__evaluation$u : []), (_layer$__evaluation3 = layer.__evaluation) === null || _layer$__evaluation3 === void 0 ? void 0 : _layer$__evaluation3.allocated_experiment_name, (_layer$__evaluation4 = layer.__evaluation) === null || _layer$__evaluation4 === void 0 ? void 0 : _layer$__evaluation4.explicit_parameters);
                return value;
            }
        }
    ]);
}();

});

parcelRegister("9sCMD", function(module, exports) {
$parcel$export(module.exports, "deepAssign", () => $6e34d02efd8a8e5b$export$1148cb79ceecd5fa);

var $aAdgI = parcelRequire("aAdgI");

var $3OJNo = parcelRequire("3OJNo");

var $lnxp2 = parcelRequire("lnxp2");
function $6e34d02efd8a8e5b$export$1148cb79ceecd5fa(target) {
    for(var _len = arguments.length, sources = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)sources[_key - 1] = arguments[_key];
    if (!sources.length) return target;
    var source = sources.shift();
    if (source === undefined || source === null) return $6e34d02efd8a8e5b$export$1148cb79ceecd5fa.apply(void 0, [
        target
    ].concat((0, $lnxp2.default)(sources)));
    for(var _i = 0, _Object$entries = Object.entries(source); _i < _Object$entries.length; _i++){
        var _Object$entries$_i = (0, $3OJNo.default)(_Object$entries[_i], 2), key = _Object$entries$_i[0], src = _Object$entries$_i[1];
        var dst = target[key];
        var srcIsObj = src && (0, $aAdgI.default)(src) === 'object' && !Array.isArray(src);
        var dstIsObj = dst && (0, $aAdgI.default)(dst) === 'object' && !Array.isArray(dst);
        if (srcIsObj && dstIsObj) target[key] = $6e34d02efd8a8e5b$export$1148cb79ceecd5fa(dst, src);
        else target[key] = src;
    }
    return $6e34d02efd8a8e5b$export$1148cb79ceecd5fa.apply(void 0, [
        target
    ].concat((0, $lnxp2.default)(sources)));
}

});
parcelRegister("lnxp2", function(module, exports) {
$parcel$export(module.exports, "default", () => $f905a8110d867a33$export$2e2bcd8739ae039);

var $j7k3D = parcelRequire("j7k3D");

var $dq1nx = parcelRequire("dq1nx");

var $MzX8A = parcelRequire("MzX8A");

var $bpnhU = parcelRequire("bpnhU");
function $f905a8110d867a33$export$2e2bcd8739ae039(r) {
    return (0, $j7k3D.default)(r) || (0, $dq1nx.default)(r) || (0, $MzX8A.default)(r) || (0, $bpnhU.default)();
}

});
parcelRegister("j7k3D", function(module, exports) {
$parcel$export(module.exports, "default", () => $deae3acb55e6e762$export$2e2bcd8739ae039);

var $e7Y6Y = parcelRequire("e7Y6Y");
function $deae3acb55e6e762$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return (0, $e7Y6Y.default)(r);
}

});

parcelRegister("dq1nx", function(module, exports) {
$parcel$export(module.exports, "default", () => $9c4ec5d453183647$export$2e2bcd8739ae039);
function $9c4ec5d453183647$export$2e2bcd8739ae039(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}

});

parcelRegister("bpnhU", function(module, exports) {
$parcel$export(module.exports, "default", () => $84e417f8f0ac5666$export$2e2bcd8739ae039);
function $84e417f8f0ac5666$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});



parcelRegister("hzt3R", function(module, exports) {
$parcel$export(module.exports, "default", () => $ccac3f82e336f7d5$export$2e2bcd8739ae039);

var $hZ7a4 = parcelRequire("hZ7a4");

var $bLOvh = parcelRequire("bLOvh");

var $k2IPD = parcelRequire("k2IPD");

var $edw2y = parcelRequire("edw2y");

var $a3FqH = parcelRequire("a3FqH");

var $hiARP = parcelRequire("hiARP");

var $7HOhT = parcelRequire("7HOhT");

var $iIEZa = parcelRequire("iIEZa");
function $ccac3f82e336f7d5$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $ccac3f82e336f7d5$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $ccac3f82e336f7d5$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $hZ7a4.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $ccac3f82e336f7d5$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $ccac3f82e336f7d5$var$DEFAULT_REQUEST_TIMEOUT_MS = 5000;
var $ccac3f82e336f7d5$export$250a58ecde616daa = 'https://api.atlassian.com/flags';
var $ccac3f82e336f7d5$export$942ba04389b0d5a2 = 'https://api.stg.atlassian.com/flags';
var $ccac3f82e336f7d5$export$f058dbf75c3bc647 = 'https://api.dev.atlassian.com/flags';
var $ccac3f82e336f7d5$export$1a401a0da8da3565 = 'https://api.stg.atlassian-us-gov-mod.com/flags';
var $ccac3f82e336f7d5$export$18c93900db9358a4 = 'https://api.atlassian-us-gov-mod.com/flags';
var $ccac3f82e336f7d5$export$4e8a0415edbfa1f7 = 'https://atlassian-statsig-proxy-archetype.atl-paas.%s.atl-ic.net';
var $ccac3f82e336f7d5$export$cb3cd156f70d7e94 = 'oasis-stg.com/flags';
var $ccac3f82e336f7d5$export$921fbc6cdfd4eee0 = 'atlassian-isolated.net/flags';
var $ccac3f82e336f7d5$export$450bd8fb2a6d7ace = '/gateway/api/flags';
var $ccac3f82e336f7d5$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function Fetcher() {
        (0, $k2IPD.default)(this, Fetcher);
    }
    return (0, $edw2y.default)(Fetcher, null, [
        {
            key: "fetchClientSdk",
            value: function() {
                var _fetchClientSdk = (0, $bLOvh.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($a3FqH))).mark(function _callee(fetcherOptions) {
                    var targetApp, url, _t;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($a3FqH))).wrap(function(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                targetApp = fetcherOptions.targetApp;
                                url = "/api/v2/frontend/clientSdkKey/".concat(targetApp);
                                _context.prev = 1;
                                _context.next = 2;
                                return this.fetchRequest(url, 'GET', fetcherOptions);
                            case 2:
                                return _context.abrupt("return", _context.sent);
                            case 3:
                                _context.prev = 3;
                                _t = _context["catch"](1);
                                if (!(_t instanceof Error)) {
                                    _context.next = 4;
                                    break;
                                }
                                throw _t;
                            case 4:
                                throw Error('Failed to retrieve client sdk key');
                            case 5:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee, this, [
                        [
                            1,
                            3
                        ]
                    ]);
                }));
                function fetchClientSdk(_x) {
                    return _fetchClientSdk.apply(this, arguments);
                }
                return fetchClientSdk;
            }()
        },
        {
            key: "fetchExperimentValues",
            value: function() {
                var _fetchExperimentValues = (0, $bLOvh.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($a3FqH))).mark(function _callee2(fetcherOptions, identifiers, customAttributes) {
                    var requestBody, _t2;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($a3FqH))).wrap(function(_context2) {
                        while(true)switch(_context2.prev = _context2.next){
                            case 0:
                                requestBody = {
                                    identifiers: identifiers,
                                    customAttributes: customAttributes,
                                    targetApp: fetcherOptions.targetApp
                                };
                                _context2.prev = 1;
                                _context2.next = 2;
                                return this.fetchRequest('/api/v2/frontend/experimentValues', 'POST', fetcherOptions, requestBody);
                            case 2:
                                return _context2.abrupt("return", _context2.sent);
                            case 3:
                                _context2.prev = 3;
                                _t2 = _context2["catch"](1);
                                if (!(_t2 instanceof Error)) {
                                    _context2.next = 4;
                                    break;
                                }
                                throw _t2;
                            case 4:
                                throw Error('Failed to retrieve experiment values');
                            case 5:
                            case "end":
                                return _context2.stop();
                        }
                    }, _callee2, this, [
                        [
                            1,
                            3
                        ]
                    ]);
                }));
                function fetchExperimentValues(_x2, _x3, _x4) {
                    return _fetchExperimentValues.apply(this, arguments);
                }
                return fetchExperimentValues;
            }()
        },
        {
            key: "handleResponseError",
            value: function() {
                var _handleResponseError = (0, $bLOvh.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($a3FqH))).mark(function _callee3(response) {
                    var body;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($a3FqH))).wrap(function(_context3) {
                        while(true)switch(_context3.prev = _context3.next){
                            case 0:
                                if (response.ok) {
                                    _context3.next = 2;
                                    break;
                                }
                                _context3.next = 1;
                                return response.text();
                            case 1:
                                body = _context3.sent;
                                throw new (0, $iIEZa.ResponseError)("Non 2xx response status received, status: ".concat(response.status, ", body: ").concat(JSON.stringify(body)));
                            case 2:
                                if (!(response.status === 204)) {
                                    _context3.next = 3;
                                    break;
                                }
                                throw new (0, $iIEZa.ResponseError)('Unexpected 204 response');
                            case 3:
                            case "end":
                                return _context3.stop();
                        }
                    }, _callee3);
                }));
                function handleResponseError(_x5) {
                    return _handleResponseError.apply(this, arguments);
                }
                return handleResponseError;
            }()
        },
        {
            key: "extractResponseBody",
            value: function() {
                var _extractResponseBody = (0, $bLOvh.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($a3FqH))).mark(function _callee4(response) {
                    var value;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($a3FqH))).wrap(function(_context4) {
                        while(true)switch(_context4.prev = _context4.next){
                            case 0:
                                _context4.next = 1;
                                return response.text();
                            case 1:
                                value = _context4.sent;
                                return _context4.abrupt("return", JSON.parse(value));
                            case 2:
                            case "end":
                                return _context4.stop();
                        }
                    }, _callee4);
                }));
                function extractResponseBody(_x6) {
                    return _extractResponseBody.apply(this, arguments);
                }
                return extractResponseBody;
            }()
        },
        {
            key: "getBaseUrl",
            value: function getBaseUrl(serviceEnv) {
                var useGatewayUrl = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
                var perimeter = arguments.length > 2 ? arguments[2] : undefined;
                var isolationContextId = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
                if (useGatewayUrl) return $ccac3f82e336f7d5$export$450bd8fb2a6d7ace;
                if (perimeter === (0, $hiARP.PerimeterType).FEDRAMP_MODERATE) switch(serviceEnv){
                    case (0, $hiARP.FeatureGateEnvironment).Production:
                        return $ccac3f82e336f7d5$export$18c93900db9358a4;
                    case (0, $hiARP.FeatureGateEnvironment).Staging:
                        return $ccac3f82e336f7d5$export$1a401a0da8da3565;
                    default:
                        throw new Error("Invalid environment \"".concat(serviceEnv, "\" for \"").concat(perimeter, "\" perimeter"));
                }
                else if (perimeter === (0, $hiARP.PerimeterType).COMMERCIAL) switch(serviceEnv){
                    case (0, $hiARP.FeatureGateEnvironment).Development:
                        return $ccac3f82e336f7d5$export$f058dbf75c3bc647;
                    case (0, $hiARP.FeatureGateEnvironment).Staging:
                        var apiUrl = this.getApiUrl(isolationContextId);
                        if (apiUrl !== null) return apiUrl;
                        return $ccac3f82e336f7d5$export$942ba04389b0d5a2;
                    default:
                        var prodApiUrl = this.getApiUrl(isolationContextId);
                        if (prodApiUrl !== null) return prodApiUrl;
                        return $ccac3f82e336f7d5$export$250a58ecde616daa;
                }
                else throw new Error("Invalid perimeter \"".concat(perimeter, "\""));
            }
        },
        {
            key: "fetchRequest",
            value: function() {
                var _fetchRequest = (0, $bLOvh.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($a3FqH))).mark(function _callee5(path, method, fetcherOptions, body) {
                    var baseUrl, fetchTimeout, abortSignal, abortController, response;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($a3FqH))).wrap(function(_context5) {
                        while(true)switch(_context5.prev = _context5.next){
                            case 0:
                                baseUrl = Fetcher.getBaseUrl(fetcherOptions.environment, fetcherOptions.useGatewayURL, fetcherOptions.perimeter, fetcherOptions.isolationContextId);
                                fetchTimeout = fetcherOptions.fetchTimeoutMs || $ccac3f82e336f7d5$var$DEFAULT_REQUEST_TIMEOUT_MS;
                                if (AbortSignal.timeout) abortSignal = AbortSignal.timeout(fetchTimeout);
                                else if (AbortController) {
                                    abortController = new AbortController();
                                    abortSignal = abortController.signal;
                                    setTimeout(function() {
                                        return abortController.abort();
                                    }, fetchTimeout);
                                }
                                _context5.next = 1;
                                return fetch("".concat(baseUrl).concat(path), $ccac3f82e336f7d5$var$_objectSpread({
                                    method: method,
                                    headers: {
                                        'Content-Type': 'application/json',
                                        'X-Client-Name': 'feature-gate-js-client',
                                        'X-Client-Version': (0, $7HOhT.CLIENT_VERSION),
                                        'X-API-KEY': fetcherOptions.apiKey
                                    },
                                    signal: abortSignal
                                }, body && {
                                    body: JSON.stringify(body)
                                }));
                            case 1:
                                response = _context5.sent;
                                _context5.next = 2;
                                return this.handleResponseError(response);
                            case 2:
                                _context5.next = 3;
                                return this.extractResponseBody(response);
                            case 3:
                                return _context5.abrupt("return", _context5.sent);
                            case 4:
                            case "end":
                                return _context5.stop();
                        }
                    }, _callee5, this);
                }));
                function fetchRequest(_x7, _x8, _x9, _x0) {
                    return _fetchRequest.apply(this, arguments);
                }
                return fetchRequest;
            }()
        },
        {
            key: "getApiUrl",
            value: function getApiUrl(isolationContextId) {
                var window1 = this.getWindowLocation();
                if (window1 === undefined) {
                    //this is needed when this SDK is used for SSR or plugin use cases where secret keys not available to use backend SDKs
                    if (!isolationContextId) return null;
                    return $ccac3f82e336f7d5$export$4e8a0415edbfa1f7.replace('%s', isolationContextId);
                }
                var protocol = window1.protocol, hostname = window1.hostname;
                // Match last subdomain fragment before oasis-stg.com
                var oasisMatch = hostname.match(/([^.]+)\.oasis-stg\.com$/);
                if (oasisMatch) return "".concat(protocol, "//api.").concat(oasisMatch[1], ".").concat($ccac3f82e336f7d5$export$cb3cd156f70d7e94);
                // Match last subdomain fragment before atlassian-isolated.net
                var isolatedMatch = hostname.match(/([^.]+)\.atlassian-isolated\.net$/);
                if (isolatedMatch) return "".concat(protocol, "//api.").concat(isolatedMatch[1], ".").concat($ccac3f82e336f7d5$export$921fbc6cdfd4eee0);
                return null;
            }
        },
        {
            key: "getWindowLocation",
            value: function getWindowLocation() {
                if (typeof window !== 'undefined' && window.location) return window.location;
                return undefined;
            }
        }
    ]);
}();

});
parcelRegister("hiARP", function(module, exports) {
$parcel$export(module.exports, "FeatureGateEnvironment", () => $c980b728ce393d17$export$479e7351a733299);
$parcel$export(module.exports, "PerimeterType", () => $c980b728ce393d17$export$c42b7bbc5e7ba555);
/**
 * The identifiers for the user. Options are restricted to the set that is currently supported.
 */ /**
 * Base client options. Does not include any options specific to providers
 * @interface BaseClientOptions
 * @property {FeatureGateEnvironment} environment - The environment for the client.
 * @property {string} targetApp - The target app for the client.
 * @property {AnalyticsWebClient} analyticsWebClient - The analytics web client.
 * @property {PerimeterType} perimeter - The perimeter for the client.
 */ /**
 * The options for the client.
 * @interface ClientOptions
 * @extends {BaseClientOptions}
 * @property {string} apiKey - The API key for the client.
 * @property {fetchTimeoutMs} fetchTimeoutMs - The timeout for the fetch request in milliseconds. Defaults to 5000.
 * @property {boolean} useGatewayURL - Whether to use the gateway URL. Defaults to false.
 */ /**
 * The custom attributes for the user.
 */ var $c980b728ce393d17$export$479e7351a733299 = {
    Development: 'development',
    Staging: 'staging',
    Production: 'production'
};
var $c980b728ce393d17$export$c42b7bbc5e7ba555 = {
    COMMERCIAL: 'commercial',
    FEDRAMP_MODERATE: 'fedramp-moderate'
};
var $c980b728ce393d17$export$42f4885608027d0c = 'non_boolean'; // Type magic to get the JSDoc comments from the Client class methods to appear on the static
 // methods in FeatureGates where the property name and function type are identical

});

parcelRegister("7HOhT", function(module, exports) {
$parcel$export(module.exports, "CLIENT_VERSION", () => $59c38ea379168cf9$export$a59f8d67326bd1cb);
/// <reference types="node" />
var $59c38ea379168cf9$export$a59f8d67326bd1cb = "6.0.1";

});

parcelRegister("iIEZa", function(module, exports) {
$parcel$export(module.exports, "ResponseError", () => $da0c20ebcdf51855$export$286baf652d0b1206);

var $edw2y = parcelRequire("edw2y");

var $k2IPD = parcelRequire("k2IPD");

var $fHrTo = parcelRequire("fHrTo");

var $bdht6 = parcelRequire("bdht6");

var $6LA59 = parcelRequire("6LA59");

var $b5VKV = parcelRequire("b5VKV");
function $da0c20ebcdf51855$var$_callSuper(t, o, e) {
    return o = (0, $bdht6.default)(o), (0, $fHrTo.default)(t, $da0c20ebcdf51855$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, $bdht6.default)(t).constructor) : o.apply(t, e));
}
function $da0c20ebcdf51855$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($da0c20ebcdf51855$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $da0c20ebcdf51855$export$286baf652d0b1206 = /*#__PURE__*/ function(_Error) {
    function ResponseError(message) {
        (0, $k2IPD.default)(this, ResponseError);
        return $da0c20ebcdf51855$var$_callSuper(this, ResponseError, [
            message
        ]);
    }
    (0, $6LA59.default)(ResponseError, _Error);
    return (0, $edw2y.default)(ResponseError);
}(/*#__PURE__*/ (0, $b5VKV.default)(Error));

});
parcelRegister("fHrTo", function(module, exports) {
$parcel$export(module.exports, "default", () => $b6e0820493e744d1$export$2e2bcd8739ae039);

var $aAdgI = parcelRequire("aAdgI");

var $9NPuc = parcelRequire("9NPuc");
function $b6e0820493e744d1$export$2e2bcd8739ae039(t, e) {
    if (e && ("object" == (0, $aAdgI.default)(e) || "function" == typeof e)) return e;
    if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
    return (0, $9NPuc.default)(t);
}

});
parcelRegister("9NPuc", function(module, exports) {
$parcel$export(module.exports, "default", () => $7230a0b409ccd83e$export$2e2bcd8739ae039);
function $7230a0b409ccd83e$export$2e2bcd8739ae039(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
}

});


parcelRegister("bdht6", function(module, exports) {
$parcel$export(module.exports, "default", () => $829e75725649f865$export$2e2bcd8739ae039);
function $829e75725649f865$export$2e2bcd8739ae039(t) {
    return $829e75725649f865$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
        return t.__proto__ || Object.getPrototypeOf(t);
    }, $829e75725649f865$export$2e2bcd8739ae039(t);
}

});

parcelRegister("6LA59", function(module, exports) {
$parcel$export(module.exports, "default", () => $4ed31f019da66f4b$export$2e2bcd8739ae039);

var $3Eisy = parcelRequire("3Eisy");
function $4ed31f019da66f4b$export$2e2bcd8739ae039(t, e) {
    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
    t.prototype = Object.create(e && e.prototype, {
        constructor: {
            value: t,
            writable: !0,
            configurable: !0
        }
    }), Object.defineProperty(t, "prototype", {
        writable: !1
    }), e && (0, $3Eisy.default)(t, e);
}

});
parcelRegister("3Eisy", function(module, exports) {
$parcel$export(module.exports, "default", () => $2a836d33940f04e2$export$2e2bcd8739ae039);
function $2a836d33940f04e2$export$2e2bcd8739ae039(t, e) {
    return $2a836d33940f04e2$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, $2a836d33940f04e2$export$2e2bcd8739ae039(t, e);
}

});


parcelRegister("b5VKV", function(module, exports) {
$parcel$export(module.exports, "default", () => $813cf66cdceb3714$export$2e2bcd8739ae039);

var $bdht6 = parcelRequire("bdht6");

var $3Eisy = parcelRequire("3Eisy");

var $exMpA = parcelRequire("exMpA");

var $5QhQJ = parcelRequire("5QhQJ");
function $813cf66cdceb3714$export$2e2bcd8739ae039(t) {
    var r = "function" == typeof Map ? new Map() : void 0;
    return $813cf66cdceb3714$export$2e2bcd8739ae039 = function _wrapNativeSuper(t) {
        if (null === t || !(0, $exMpA.default)(t)) return t;
        if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function");
        if (void 0 !== r) {
            if (r.has(t)) return r.get(t);
            r.set(t, Wrapper);
        }
        function Wrapper() {
            return (0, $5QhQJ.default)(t, arguments, (0, $bdht6.default)(this).constructor);
        }
        return Wrapper.prototype = Object.create(t.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: !1,
                writable: !0,
                configurable: !0
            }
        }), (0, $3Eisy.default)(Wrapper, t);
    }, $813cf66cdceb3714$export$2e2bcd8739ae039(t);
}

});
parcelRegister("exMpA", function(module, exports) {
$parcel$export(module.exports, "default", () => $a969b34d62dec0cd$export$2e2bcd8739ae039);
function $a969b34d62dec0cd$export$2e2bcd8739ae039(t) {
    try {
        return -1 !== Function.toString.call(t).indexOf("[native code]");
    } catch (n) {
        return "function" == typeof t;
    }
}

});

parcelRegister("5QhQJ", function(module, exports) {
$parcel$export(module.exports, "default", () => $440fa799a6b20469$export$2e2bcd8739ae039);

var $MHYZB = parcelRequire("MHYZB");

var $3Eisy = parcelRequire("3Eisy");
function $440fa799a6b20469$export$2e2bcd8739ae039(t, e, r) {
    if ((0, $MHYZB.default)()) return Reflect.construct.apply(null, arguments);
    var o = [
        null
    ];
    o.push.apply(o, e);
    var p = new (t.bind.apply(t, o))();
    return r && (0, $3Eisy.default)(p, r.prototype), p;
}

});
parcelRegister("MHYZB", function(module, exports) {
$parcel$export(module.exports, "default", () => $092699de145821c4$export$2e2bcd8739ae039);
function $092699de145821c4$export$2e2bcd8739ae039() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($092699de145821c4$export$2e2bcd8739ae039 = function _isNativeReflectConstruct() {
        return !!t;
    })();
}

});





parcelRegister("2y8p6", function(module, exports) {
$parcel$export(module.exports, "getOptionsWithDefaults", () => $1db54690546f254d$export$d119b37e5f788b43);

var $hZ7a4 = parcelRequire("hZ7a4");

var $ygbGG = parcelRequire("ygbGG");

var $hiARP = parcelRequire("hiARP");
function $1db54690546f254d$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $1db54690546f254d$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $1db54690546f254d$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $hZ7a4.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $1db54690546f254d$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $1db54690546f254d$export$d119b37e5f788b43 = function getOptionsWithDefaults(options) {
    return $1db54690546f254d$var$_objectSpread({
        /**
     * If more federal PerimeterTypes are added in the future, this should be updated so
     * that isFedRamp() === true always returns the strictest perimeter.
     */ perimeter: (0, $ygbGG.isFedRamp)() ? (0, $hiARP.PerimeterType).FEDRAMP_MODERATE : (0, $hiARP.PerimeterType).COMMERCIAL
    }, options);
};

});
parcelRegister("ygbGG", function(module, exports) {
$parcel$export(module.exports, "isFedRamp", () => $066fbb979700de6b$export$64d6499adf9b2e51);

var $cThmQ = parcelRequire("cThmQ");
function $066fbb979700de6b$export$64d6499adf9b2e51() {
    var _global$location;
    var global = globalThis;
    // MICROS_PERIMETER is already used by few products, so we need to keep it for backward compatibility
    var env = global.MICROS_PERIMETER || global.UNSAFE_ATL_CONTEXT_BOUNDARY;
    if (env) return env === (0, $cThmQ.FEDRAMP_MODERATE);
    var matches = (_global$location = global.location) === null || _global$location === void 0 || (_global$location = _global$location.hostname) === null || _global$location === void 0 ? void 0 : _global$location.match(/atlassian-us-gov-mod\.(com|net)|atlassian-us-gov\.(com|net)|atlassian-fex\.(com|net)|atlassian-stg-fedm\.(com|net)/);
    return matches ? matches.length > 0 : false;
}

});
parcelRegister("cThmQ", function(module, exports) {
$parcel$export(module.exports, "FEDRAMP_MODERATE", () => $962817e776c3bc68$export$ce553301d55c2fd8);
var $962817e776c3bc68$export$ce553301d55c2fd8 = 'fedramp-moderate';
var $962817e776c3bc68$export$f005e2e9f707cb5f = 'commercial';
var $962817e776c3bc68$export$bd6b5a7802d76127 = 'fedramp-fedex';
var $962817e776c3bc68$export$a739cd5aac835909 = 'stg';
var $962817e776c3bc68$export$42dd0cdd351a4a9 = 'prod';
var $962817e776c3bc68$export$404582bc18fe4d9e = 'dev';

});



parcelRegister("f0l1D", function(module, exports) {
$parcel$export(module.exports, "migrateInitializationOptions", () => $aec72a525d87bbff$export$202946b690d26d22);

var $hZ7a4 = parcelRequire("hZ7a4");

var $ciEnq = parcelRequire("ciEnq");
var $aec72a525d87bbff$var$_excluded = [
    "api",
    "disableCurrentPageLogging",
    "loggingIntervalMillis",
    "loggingBufferMaxSize",
    "localMode",
    "eventLoggingApi",
    "eventLoggingApiForRetries",
    "disableLocalStorage",
    "ignoreWindowUndefined",
    "disableAllLogging",
    "initTimeoutMs",
    "disableNetworkKeepalive",
    "overrideStableID",
    "disableErrorLogging",
    "disableAutoMetricsLogging"
];
function $aec72a525d87bbff$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $aec72a525d87bbff$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $aec72a525d87bbff$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $hZ7a4.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $aec72a525d87bbff$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $aec72a525d87bbff$export$202946b690d26d22 = function migrateInitializationOptions(options) {
    var api = options.api, disableCurrentPageLogging = options.disableCurrentPageLogging, loggingIntervalMillis = options.loggingIntervalMillis, loggingBufferMaxSize = options.loggingBufferMaxSize, localMode = options.localMode, eventLoggingApi = options.eventLoggingApi, eventLoggingApiForRetries = options.eventLoggingApiForRetries, disableLocalStorage = options.disableLocalStorage, ignoreWindowUndefined = options.ignoreWindowUndefined, disableAllLogging = options.disableAllLogging, _initTimeoutMs = options.initTimeoutMs, _disableNetworkKeepalive = options.disableNetworkKeepalive, _overrideStableID = options.overrideStableID, _disableErrorLogging = options.disableErrorLogging, _disableAutoMetricsLogging = options.disableAutoMetricsLogging, rest = (0, $ciEnq.default)(options, $aec72a525d87bbff$var$_excluded);
    return $aec72a525d87bbff$var$_objectSpread($aec72a525d87bbff$var$_objectSpread({}, rest), {}, {
        networkConfig: {
            api: api,
            logEventUrl: eventLoggingApi ? eventLoggingApi + 'rgstr' : undefined,
            logEventFallbackUrls: eventLoggingApiForRetries ? [
                eventLoggingApiForRetries
            ] : undefined,
            preventAllNetworkTraffic: localMode || !ignoreWindowUndefined && typeof window === 'undefined'
        },
        includeCurrentPageUrlWithEvents: !disableCurrentPageLogging,
        loggingIntervalMs: loggingIntervalMillis,
        loggingBufferMaxSize: loggingBufferMaxSize,
        disableStorage: disableLocalStorage === undefined ? localMode : disableLocalStorage,
        disableLogging: disableAllLogging === undefined ? localMode : disableAllLogging
    });
};

});

parcelRegister("2usPa", function(module, exports) {
$parcel$export(module.exports, "NoFetchDataAdapter", () => $1d04be09211aff82$export$55fffef3474104af);

var $bLOvh = parcelRequire("bLOvh");

var $k2IPD = parcelRequire("k2IPD");

var $edw2y = parcelRequire("edw2y");

var $fHrTo = parcelRequire("fHrTo");

var $bdht6 = parcelRequire("bdht6");

var $agJ4A = parcelRequire("agJ4A");

var $6LA59 = parcelRequire("6LA59");

var $hZ7a4 = parcelRequire("hZ7a4");

var $a3FqH = parcelRequire("a3FqH");

var $a0vkc = parcelRequire("a0vkc");
function $1d04be09211aff82$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $1d04be09211aff82$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $1d04be09211aff82$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $hZ7a4.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $1d04be09211aff82$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $1d04be09211aff82$var$_callSuper(t, o, e) {
    return o = (0, $bdht6.default)(o), (0, $fHrTo.default)(t, $1d04be09211aff82$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, $bdht6.default)(t).constructor) : o.apply(t, e));
}
function $1d04be09211aff82$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($1d04be09211aff82$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $1d04be09211aff82$var$_superPropGet(t, o, e, r) {
    var p = (0, $agJ4A.default)((0, $bdht6.default)(1 & r ? t.prototype : t), o, e);
    return 2 & r && "function" == typeof p ? function(t) {
        return p.apply(e, t);
    } : p;
}
var $1d04be09211aff82$export$55fffef3474104af = /*#__PURE__*/ function(_DataAdapterCore) {
    function NoFetchDataAdapter() {
        var _this;
        (0, $k2IPD.default)(this, NoFetchDataAdapter);
        _this = $1d04be09211aff82$var$_callSuper(this, NoFetchDataAdapter, [
            'NoFetchDataAdapter',
            'nofetch'
        ]);
        (0, $hZ7a4.default)(_this, "bootstrapResult", null);
        return _this;
    }
    /**
   * Make sure to call this **before** calling `initializeAsync` or `updateUserAsync` but
   * after the Statsig client has been created!
   */ (0, $6LA59.default)(NoFetchDataAdapter, _DataAdapterCore);
    return (0, $edw2y.default)(NoFetchDataAdapter, [
        {
            key: "setBootstrapData",
            value: function setBootstrapData(data) {
                this.bootstrapResult = data ? {
                    source: 'Bootstrap',
                    data: JSON.stringify(data),
                    receivedAt: Date.now(),
                    stableID: (0, $a0vkc.StableID).get(this._getSdkKey()),
                    fullUserHash: null
                } : null;
            }
        },
        {
            key: "prefetchData",
            value: function() {
                var _prefetchData = (0, $bLOvh.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($a3FqH))).mark(function _callee(_user, _options) {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($a3FqH))).wrap(function(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee);
                }));
                function prefetchData(_x, _x2) {
                    return _prefetchData.apply(this, arguments);
                }
                return prefetchData;
            }()
        },
        {
            key: "getDataAsync",
            value: function() {
                var _getDataAsync = (0, $bLOvh.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($a3FqH))).mark(function _callee2(_current, user, _options) {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($a3FqH))).wrap(function(_context2) {
                        while(true)switch(_context2.prev = _context2.next){
                            case 0:
                                return _context2.abrupt("return", this.bootstrapResult && $1d04be09211aff82$var$_objectSpread($1d04be09211aff82$var$_objectSpread({}, this.bootstrapResult), {}, {
                                    fullUserHash: (0, $a0vkc._getFullUserHash)(user)
                                }));
                            case 1:
                            case "end":
                                return _context2.stop();
                        }
                    }, _callee2, this);
                }));
                function getDataAsync(_x3, _x4, _x5) {
                    return _getDataAsync.apply(this, arguments);
                }
                return getDataAsync;
            }()
        },
        {
            key: "getDataSync",
            value: function getDataSync(user) {
                return this.bootstrapResult && $1d04be09211aff82$var$_objectSpread($1d04be09211aff82$var$_objectSpread({}, this.bootstrapResult), {}, {
                    fullUserHash: (0, $a0vkc._getFullUserHash)(user)
                });
            }
        },
        {
            key: "_fetchFromNetwork",
            value: function() {
                var _fetchFromNetwork2 = (0, $bLOvh.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($a3FqH))).mark(function _callee3(_current, _user, _options) {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($a3FqH))).wrap(function(_context3) {
                        while(true)switch(_context3.prev = _context3.next){
                            case 0:
                                return _context3.abrupt("return", null);
                            case 1:
                            case "end":
                                return _context3.stop();
                        }
                    }, _callee3);
                }));
                function _fetchFromNetwork(_x6, _x7, _x8) {
                    return _fetchFromNetwork2.apply(this, arguments);
                }
                return _fetchFromNetwork;
            }()
        },
        {
            key: "_getCacheKey",
            value: function _getCacheKey(user) {
                // Same logic as default data adapter
                // https://github.com/statsig-io/js-client-monorepo/blob/main/packages/js-client/src/StatsigEvaluationsDataAdapter.ts
                var key = (0, $a0vkc._getStorageKey)(this._getSdkKey(), user);
                return "".concat((0, $a0vkc.DataAdapterCachePrefix), ".").concat(this._cacheSuffix, ".").concat(key);
            }
        },
        {
            key: "_isCachedResultValidFor204",
            value: function _isCachedResultValidFor204(_result, _user) {
                return false;
            }
        },
        {
            key: "setDataLegacy",
            value: function setDataLegacy(data, user) {
                $1d04be09211aff82$var$_superPropGet(NoFetchDataAdapter, "setData", this, 3)([
                    data,
                    user
                ]);
            }
        },
        {
            key: "toJSON",
            value: function toJSON() {
                var result = $1d04be09211aff82$var$_objectSpread({}, this);
                delete result._options;
                delete result._inMemoryCache;
                delete result.bootstrapResult;
                return result;
            }
        }
    ]);
}((0, $a0vkc.DataAdapterCore));

});
parcelRegister("agJ4A", function(module, exports) {
$parcel$export(module.exports, "default", () => $779e5c9366ebad65$export$2e2bcd8739ae039);

var $edWUy = parcelRequire("edWUy");
function $779e5c9366ebad65$export$2e2bcd8739ae039() {
    return $779e5c9366ebad65$export$2e2bcd8739ae039 = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function(e, t, r) {
        var p = (0, $edWUy.default)(e, t);
        if (p) {
            var n = Object.getOwnPropertyDescriptor(p, t);
            return n.get ? n.get.call(arguments.length < 3 ? e : r) : n.value;
        }
    }, $779e5c9366ebad65$export$2e2bcd8739ae039.apply(null, arguments);
}

});
parcelRegister("edWUy", function(module, exports) {
$parcel$export(module.exports, "default", () => $a5affa2030b5fa13$export$2e2bcd8739ae039);

var $bdht6 = parcelRequire("bdht6");
function $a5affa2030b5fa13$export$2e2bcd8739ae039(t, o) {
    for(; !({}).hasOwnProperty.call(t, o) && null !== (t = (0, $bdht6.default)(t)););
    return t;
}

});



parcelRegister("j3SRh", function(module, exports) {
$parcel$export(module.exports, "LOCAL_STORAGE_KEY", () => $de08d9d5ed18ea05$export$d8474cff104280f3);
$parcel$export(module.exports, "PersistentOverrideAdapter", () => $de08d9d5ed18ea05$export$bcb28fbac1def494);

var $hZ7a4 = parcelRequire("hZ7a4");

var $3OJNo = parcelRequire("3OJNo");

var $k2IPD = parcelRequire("k2IPD");

var $edw2y = parcelRequire("edw2y");

var $328Ep = parcelRequire("328Ep");
function $de08d9d5ed18ea05$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $de08d9d5ed18ea05$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $de08d9d5ed18ea05$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $hZ7a4.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $de08d9d5ed18ea05$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $de08d9d5ed18ea05$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $de08d9d5ed18ea05$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $de08d9d5ed18ea05$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $de08d9d5ed18ea05$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $de08d9d5ed18ea05$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $de08d9d5ed18ea05$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
var $de08d9d5ed18ea05$var$LOCAL_OVERRIDE_REASON = 'LocalOverride:Recognized';
var $de08d9d5ed18ea05$export$d8474cff104280f3 = 'STATSIG_OVERRIDES';
var $de08d9d5ed18ea05$var$LEGACY_LOCAL_STORAGE_KEY = 'STATSIG_JS_LITE_LOCAL_OVERRIDES';
var $de08d9d5ed18ea05$var$makeEmptyStore = function makeEmptyStore() {
    return {
        gates: {},
        configs: {},
        layers: {}
    };
};
var $de08d9d5ed18ea05$var$djb2MapKey = function djb2MapKey(hash, kind) {
    return kind + ':' + hash;
};
var $de08d9d5ed18ea05$export$bcb28fbac1def494 = /*#__PURE__*/ function() {
    function PersistentOverrideAdapter(localStorageKey) {
        (0, $k2IPD.default)(this, PersistentOverrideAdapter);
        this._overrides = $de08d9d5ed18ea05$var$makeEmptyStore();
        this._djb2Map = new Map();
        this._localStorageKey = localStorageKey;
    }
    return (0, $edw2y.default)(PersistentOverrideAdapter, [
        {
            key: "parseStoredOverrides",
            value: function parseStoredOverrides(localStorageKey) {
                try {
                    // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
                    var json = window.localStorage.getItem(localStorageKey);
                    if (!json) return $de08d9d5ed18ea05$var$makeEmptyStore();
                    return JSON.parse(json);
                } catch (_unused) {
                    return $de08d9d5ed18ea05$var$makeEmptyStore();
                }
            }
        },
        {
            key: "mergeOverrides",
            value: function mergeOverrides() {
                var merged = $de08d9d5ed18ea05$var$makeEmptyStore();
                for(var _len = arguments.length, allOverrides = new Array(_len), _key = 0; _key < _len; _key++)allOverrides[_key] = arguments[_key];
                for(var _i = 0, _allOverrides = allOverrides; _i < _allOverrides.length; _i++){
                    var overrides = _allOverrides[_i];
                    for(var _i2 = 0, _Object$entries = Object.entries((_overrides$gates = overrides.gates) !== null && _overrides$gates !== void 0 ? _overrides$gates : {}); _i2 < _Object$entries.length; _i2++){
                        var _overrides$gates;
                        var _Object$entries$_i = (0, $3OJNo.default)(_Object$entries[_i2], 2), name = _Object$entries$_i[0], value = _Object$entries$_i[1];
                        merged.gates[name] = value;
                    }
                    for(var _i3 = 0, _Object$entries2 = Object.entries((_overrides$configs = overrides.configs) !== null && _overrides$configs !== void 0 ? _overrides$configs : {}); _i3 < _Object$entries2.length; _i3++){
                        var _overrides$configs;
                        var _Object$entries2$_i = (0, $3OJNo.default)(_Object$entries2[_i3], 2), _name = _Object$entries2$_i[0], _value = _Object$entries2$_i[1];
                        merged.configs[_name] = _value;
                    }
                    for(var _i4 = 0, _Object$entries3 = Object.entries((_overrides$layers = overrides.layers) !== null && _overrides$layers !== void 0 ? _overrides$layers : {}); _i4 < _Object$entries3.length; _i4++){
                        var _overrides$layers;
                        var _Object$entries3$_i = (0, $3OJNo.default)(_Object$entries3[_i4], 2), _name2 = _Object$entries3$_i[0], _value2 = _Object$entries3$_i[1];
                        merged.layers[_name2] = _value2;
                    }
                }
                return merged;
            }
        },
        {
            key: "initFromStoredOverrides",
            value: function initFromStoredOverrides() {
                var storedOverrides = this.mergeOverrides(this._overrides, this.parseStoredOverrides($de08d9d5ed18ea05$var$LEGACY_LOCAL_STORAGE_KEY), this.parseStoredOverrides(this._localStorageKey));
                // Clear data from legacy local storage key now we've read from it.
                // This prevents things being stuck in there that are always read but never written to.
                try {
                    // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
                    window.localStorage.removeItem($de08d9d5ed18ea05$var$LEGACY_LOCAL_STORAGE_KEY);
                } catch (_unused2) {
                // ignored - window is not defined in non-browser environments, and we don't save things there
                // (things like SSR, etc)
                }
                // In version 4.24.0 we introduced hashes in this override adapter, but had a bug which would cause
                // multiple hashes to continue being created. This code here removes these hashes since we've moved
                // to using a more reliable and easier to maintain map in `_djb2Map`.
                for(var _i5 = 0, _Object$values = Object.values(storedOverrides); _i5 < _Object$values.length; _i5++){
                    var container = _Object$values[_i5];
                    var allKeys = new Set(Object.keys(container));
                    var _iterator = $de08d9d5ed18ea05$var$_createForOfIteratorHelper(allKeys), _step;
                    try {
                        for(_iterator.s(); !(_step = _iterator.n()).done;){
                            var name = _step.value;
                            var hash = (0, $328Ep._DJB2)(name);
                            if (allKeys.has(hash)) delete container[hash];
                        }
                    } catch (err) {
                        _iterator.e(err);
                    } finally{
                        _iterator.f();
                    }
                }
                this.applyOverrides(storedOverrides);
            }
        },
        {
            key: "saveOverrides",
            value: function saveOverrides() {
                try {
                    // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
                    window.localStorage.setItem(this._localStorageKey, JSON.stringify(this._overrides));
                } catch (_unused3) {
                // ignored - window is not defined in non-browser environments, and we don't save things there
                // (things like SSR, etc)
                }
            }
        },
        {
            key: "getOverrides",
            value: function getOverrides() {
                return this.mergeOverrides(this._overrides);
            }
        },
        {
            key: "applyOverrides",
            value: function applyOverrides(overrides) {
                var newOverrides = $de08d9d5ed18ea05$var$_objectSpread($de08d9d5ed18ea05$var$_objectSpread({}, $de08d9d5ed18ea05$var$makeEmptyStore()), overrides);
                this._djb2Map.clear();
                for(var _i6 = 0, _Object$entries4 = Object.entries(newOverrides); _i6 < _Object$entries4.length; _i6++){
                    var _Object$entries4$_i = (0, $3OJNo.default)(_Object$entries4[_i6], 2), containerName = _Object$entries4$_i[0], container = _Object$entries4$_i[1];
                    for(var _i7 = 0, _Object$entries5 = Object.entries(container); _i7 < _Object$entries5.length; _i7++){
                        var _Object$entries5$_i = (0, $3OJNo.default)(_Object$entries5[_i7], 2), name = _Object$entries5$_i[0], value = _Object$entries5$_i[1];
                        this._djb2Map.set($de08d9d5ed18ea05$var$djb2MapKey((0, $328Ep._DJB2)(name), containerName), value);
                    }
                }
                this._overrides = newOverrides;
            }
        },
        {
            key: "setOverrides",
            value: function setOverrides(overrides) {
                this.applyOverrides(overrides);
                this.saveOverrides();
            }
        },
        {
            key: "overrideGate",
            value: function overrideGate(name, value) {
                this._overrides.gates[name] = value;
                this._djb2Map.set($de08d9d5ed18ea05$var$djb2MapKey((0, $328Ep._DJB2)(name), 'gates'), value);
                this.saveOverrides();
            }
        },
        {
            key: "removeGateOverride",
            value: function removeGateOverride(name) {
                delete this._overrides.gates[name];
                this._djb2Map.delete($de08d9d5ed18ea05$var$djb2MapKey((0, $328Ep._DJB2)(name), 'gates'));
                this.saveOverrides();
            }
        },
        {
            key: "getGateOverride",
            value: function getGateOverride(current, _user) {
                var _this$_overrides$gate;
                var overridden = (_this$_overrides$gate = this._overrides.gates[current.name]) !== null && _this$_overrides$gate !== void 0 ? _this$_overrides$gate : this._djb2Map.get($de08d9d5ed18ea05$var$djb2MapKey(current.name, 'gates'));
                if (overridden == null) return null;
                return $de08d9d5ed18ea05$var$_objectSpread($de08d9d5ed18ea05$var$_objectSpread({}, current), {}, {
                    value: overridden,
                    details: $de08d9d5ed18ea05$var$_objectSpread($de08d9d5ed18ea05$var$_objectSpread({}, current.details), {}, {
                        reason: $de08d9d5ed18ea05$var$LOCAL_OVERRIDE_REASON
                    })
                });
            }
        },
        {
            key: "overrideDynamicConfig",
            value: function overrideDynamicConfig(name, value) {
                this._overrides.configs[name] = value;
                this._djb2Map.set($de08d9d5ed18ea05$var$djb2MapKey((0, $328Ep._DJB2)(name), 'configs'), value);
                this.saveOverrides();
            }
        },
        {
            key: "removeDynamicConfigOverride",
            value: function removeDynamicConfigOverride(name) {
                delete this._overrides.configs[name];
                this._djb2Map.delete($de08d9d5ed18ea05$var$djb2MapKey((0, $328Ep._DJB2)(name), 'configs'));
                this.saveOverrides();
            }
        },
        {
            key: "getDynamicConfigOverride",
            value: function getDynamicConfigOverride(current, _user) {
                return this._getConfigOverride(current, this._overrides.configs);
            }
        },
        {
            key: "overrideExperiment",
            value: function overrideExperiment(name, value) {
                this._overrides.configs[name] = value;
                this._djb2Map.set($de08d9d5ed18ea05$var$djb2MapKey((0, $328Ep._DJB2)(name), 'configs'), value);
                this.saveOverrides();
            }
        },
        {
            key: "removeExperimentOverride",
            value: function removeExperimentOverride(name) {
                delete this._overrides.configs[name];
                this._djb2Map.delete($de08d9d5ed18ea05$var$djb2MapKey((0, $328Ep._DJB2)(name), 'configs'));
                this.saveOverrides();
            }
        },
        {
            key: "getExperimentOverride",
            value: function getExperimentOverride(current, _user) {
                return this._getConfigOverride(current, this._overrides.configs);
            }
        },
        {
            key: "overrideLayer",
            value: function overrideLayer(name, value) {
                this._overrides.layers[name] = value;
                this._djb2Map.set($de08d9d5ed18ea05$var$djb2MapKey((0, $328Ep._DJB2)(name), 'layers'), value);
                this.saveOverrides();
            }
        },
        {
            key: "removeLayerOverride",
            value: function removeLayerOverride(name) {
                delete this._overrides.layers[name];
                this._djb2Map.delete($de08d9d5ed18ea05$var$djb2MapKey((0, $328Ep._DJB2)(name), 'layers'));
                this.saveOverrides();
            }
        },
        {
            key: "removeAllOverrides",
            value: function removeAllOverrides() {
                this._overrides = $de08d9d5ed18ea05$var$makeEmptyStore();
                try {
                    // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
                    window.localStorage.removeItem(this._localStorageKey);
                } catch (_unused4) {
                // ignored - window is not defined in non-browser environments, and we don't save things there
                // (things like SSR, etc)
                }
            }
        },
        {
            key: "getLayerOverride",
            value: function getLayerOverride(current, _user) {
                var _this$_overrides$laye;
                var overridden = (_this$_overrides$laye = this._overrides.layers[current.name]) !== null && _this$_overrides$laye !== void 0 ? _this$_overrides$laye : this._djb2Map.get($de08d9d5ed18ea05$var$djb2MapKey(current.name, 'layers'));
                if (overridden == null) return null;
                return $de08d9d5ed18ea05$var$_objectSpread($de08d9d5ed18ea05$var$_objectSpread({}, current), {}, {
                    __value: overridden,
                    get: (0, $328Ep._makeTypedGet)(current.name, overridden),
                    details: $de08d9d5ed18ea05$var$_objectSpread($de08d9d5ed18ea05$var$_objectSpread({}, current.details), {}, {
                        reason: $de08d9d5ed18ea05$var$LOCAL_OVERRIDE_REASON
                    })
                });
            }
        },
        {
            key: "_getConfigOverride",
            value: function _getConfigOverride(current, lookup) {
                var _lookup$current$name;
                var overridden = (_lookup$current$name = lookup[current.name]) !== null && _lookup$current$name !== void 0 ? _lookup$current$name : this._djb2Map.get($de08d9d5ed18ea05$var$djb2MapKey(current.name, 'configs'));
                if (overridden == null) return null;
                return $de08d9d5ed18ea05$var$_objectSpread($de08d9d5ed18ea05$var$_objectSpread({}, current), {}, {
                    value: overridden,
                    get: (0, $328Ep._makeTypedGet)(current.name, overridden),
                    details: $de08d9d5ed18ea05$var$_objectSpread($de08d9d5ed18ea05$var$_objectSpread({}, current.details), {}, {
                        reason: $de08d9d5ed18ea05$var$LOCAL_OVERRIDE_REASON
                    })
                });
            }
        }
    ]);
}();

});

parcelRegister("55r6R", function(module, exports) {
$parcel$export(module.exports, "shallowEquals", () => $3b4272c6781d50f0$export$fa1c2bbf4100b8bc);

var $3OJNo = parcelRequire("3OJNo");
var $3b4272c6781d50f0$export$fa1c2bbf4100b8bc = function shallowEquals(objectA, objectB) {
    if (!objectA && !objectB) return true;
    if (!objectA || !objectB) return false;
    var aEntries = Object.entries(objectA);
    var bEntries = Object.entries(objectB);
    if (aEntries.length !== bEntries.length) return false;
    var ascendingKeyOrder = function ascendingKeyOrder(_ref, _ref2) {
        var _ref3 = (0, $3OJNo.default)(_ref, 1), key1 = _ref3[0];
        var _ref4 = (0, $3OJNo.default)(_ref2, 1), key2 = _ref4[0];
        return key1.localeCompare(key2);
    };
    aEntries.sort(ascendingKeyOrder);
    bEntries.sort(ascendingKeyOrder);
    for(var i = 0; i < aEntries.length; i++){
        var _aEntries$i = (0, $3OJNo.default)(aEntries[i], 2), aValue = _aEntries$i[1];
        var _bEntries$i = (0, $3OJNo.default)(bEntries[i], 2), bValue = _bEntries$i[1];
        if (aValue !== bValue) return false;
    }
    return true;
};

});

parcelRegister("3yi6c", function(module, exports) {
$parcel$export(module.exports, "toStatsigUser", () => $2962962aef49b26f$export$3dad1db244472f32);

var $hZ7a4 = parcelRequire("hZ7a4");

var $ciEnq = parcelRequire("ciEnq");
var $2962962aef49b26f$var$_excluded = [
    "stableId"
];
function $2962962aef49b26f$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $2962962aef49b26f$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $2962962aef49b26f$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $hZ7a4.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $2962962aef49b26f$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $2962962aef49b26f$export$3dad1db244472f32 = function toStatsigUser(identifiers, customAttributes) {
    // Re-map `stableId` to `stableID` to match Statsig's native type.
    var stableId = identifiers.stableId, otherIdentifiers = (0, $ciEnq.default)(identifiers, $2962962aef49b26f$var$_excluded);
    var user = {
        customIDs: $2962962aef49b26f$var$_objectSpread($2962962aef49b26f$var$_objectSpread({}, otherIdentifiers), stableId !== undefined ? {
            stableID: stableId
        } : {}),
        custom: customAttributes
    };
    if (identifiers.atlassianAccountId) user.userID = identifiers.atlassianAccountId;
    return user;
};

});





parcelRegister("fb6VX", function(module, exports) {
"use strict";
var $b0cd42ffbfb0b3a7$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.FeatureGatesInitialization = void 0;

var $5FkrB = parcelRequire("5FkrB");

const $b0cd42ffbfb0b3a7$var$feature_gate_js_client_1 = $b0cd42ffbfb0b3a7$var$__importDefault((parcelRequire("jcX3Q")));

var $14MvJ = parcelRequire("14MvJ");
/**
 * This component initializes the @atlassian/feature-flag-js-client by fetching the gate and experiment
 * evaluations for the given user, and blocks rendering of the children until the rendering is complete.
 */ const $b0cd42ffbfb0b3a7$var$FeatureGatesInitialization = ({ children: children, enabled: enabled = true, identifiers: identifiers, customAttributes: customAttributes, options: options, initializingComponent: initializingComponent, overrides: overrides, onReady: onReady })=>{
    // Rather than checking the state of all overrides, we can just assume that if overrides are provided
    // then some sort of update will need to be performed, and hold off rendering until the useEffect is run.
    const [isInitialized, setInitialized] = (0, $5FkrB.useState)(!overrides && (0, $14MvJ.isClientAlreadyInCorrectState)(identifiers, customAttributes));
    // Use a ref for the options, so that we can use them within the following useEffect
    // without adding options as a dependency.
    // This avoids the user updating every time an option is changed.
    const optionsRef = (0, $5FkrB.useRef)(options);
    (0, $5FkrB.useEffect)(()=>{
        optionsRef.current = options;
    }, [
        options
    ]);
    (0, $5FkrB.useEffect)(()=>{
        if (enabled) {
            if ((0, $14MvJ.isClientAlreadyInCorrectState)(identifiers, customAttributes)) {
                (0, $14MvJ.applyOverrides)(overrides);
                setInitialized(true);
                onReady === null || onReady === void 0 || onReady();
            } else {
                setInitialized(false);
                const initPromise = $b0cd42ffbfb0b3a7$var$feature_gate_js_client_1.default.initializeCalled() ? $b0cd42ffbfb0b3a7$var$feature_gate_js_client_1.default.updateUser(optionsRef.current, identifiers, customAttributes) : $b0cd42ffbfb0b3a7$var$feature_gate_js_client_1.default.initialize(optionsRef.current, identifiers, customAttributes);
                initPromise.catch((err)=>(0, $14MvJ.toError)(err)).then((err)=>{
                    setInitialized(true);
                    (0, $14MvJ.applyOverrides)(overrides);
                    onReady === null || onReady === void 0 || onReady(err || undefined);
                });
            }
        } else {
            setInitialized(true);
            onReady === null || onReady === void 0 || onReady();
        }
        return ()=>(0, $14MvJ.clearOverrides)(overrides);
    }, [
        enabled,
        identifiers,
        customAttributes,
        overrides
    ]);
    return (0, $14MvJ.pickChildToRender)(enabled, isInitialized, children, initializingComponent);
};
module.exports.FeatureGatesInitialization = $b0cd42ffbfb0b3a7$var$FeatureGatesInitialization;
module.exports.default = module.exports.FeatureGatesInitialization;

});
parcelRegister("14MvJ", function(module, exports) {
"use strict";
var $0c8bcb631f9fa522$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isClientAlreadyInCorrectState = $0c8bcb631f9fa522$var$isClientAlreadyInCorrectState;
module.exports.pickChildToRender = $0c8bcb631f9fa522$var$pickChildToRender;
module.exports.toError = $0c8bcb631f9fa522$var$toError;
module.exports.applyOverrides = $0c8bcb631f9fa522$var$applyOverrides;
module.exports.clearOverrides = $0c8bcb631f9fa522$var$clearOverrides;

const $0c8bcb631f9fa522$var$react_1 = $0c8bcb631f9fa522$var$__importDefault((parcelRequire("5FkrB")));

const $0c8bcb631f9fa522$var$feature_gate_js_client_1 = $0c8bcb631f9fa522$var$__importDefault((parcelRequire("jcX3Q")));
let $0c8bcb631f9fa522$var$hasWarnedAboutMissingOverrideSupport = false;
function $0c8bcb631f9fa522$var$isClientAlreadyInCorrectState(identifiers, customAttributes) {
    var _a, _b;
    // If either of these methods don't exist (ie. if the product is using <v4.2.0), then this method will always return false
    return ((_a = $0c8bcb631f9fa522$var$feature_gate_js_client_1.default.initializeCompleted) === null || _a === void 0 ? void 0 : _a.call($0c8bcb631f9fa522$var$feature_gate_js_client_1.default)) && ((_b = $0c8bcb631f9fa522$var$feature_gate_js_client_1.default.isCurrentUser) === null || _b === void 0 ? void 0 : _b.call($0c8bcb631f9fa522$var$feature_gate_js_client_1.default, identifiers, customAttributes));
}
function $0c8bcb631f9fa522$var$pickChildToRender(enabled, isInitialized, children, initializingComponent) {
    if (!enabled || isInitialized) return $0c8bcb631f9fa522$var$react_1.default.createElement($0c8bcb631f9fa522$var$react_1.default.Fragment, null, children);
    if (initializingComponent != null) return $0c8bcb631f9fa522$var$react_1.default.createElement($0c8bcb631f9fa522$var$react_1.default.Fragment, null, initializingComponent);
    return null;
}
function $0c8bcb631f9fa522$var$toError(err) {
    if (err instanceof Error) return err;
    return new Error(err === null || err === void 0 ? void 0 : err.toString());
}
function $0c8bcb631f9fa522$var$applyOverrides(overrides) {
    // Allow newer versions of the React SDK to be used with older v3.x JS client versions,
    // provided the caller does not try to leverage the overrides which were introduced in v4.
    if (overrides && (!$0c8bcb631f9fa522$var$feature_gate_js_client_1.default.overrideGate || !$0c8bcb631f9fa522$var$feature_gate_js_client_1.default.overrideConfig)) {
        if (!$0c8bcb631f9fa522$var$hasWarnedAboutMissingOverrideSupport) {
            console.warn('Overrides are only supported in @atlaskit/feature-gate-js-client v4.0.0+');
            $0c8bcb631f9fa522$var$hasWarnedAboutMissingOverrideSupport = true;
        }
        return;
    }
    Object.entries((overrides === null || overrides === void 0 ? void 0 : overrides.gates) || {}).forEach(([gateName, value])=>{
        var _a;
        (_a = $0c8bcb631f9fa522$var$feature_gate_js_client_1.default.overrideGate) === null || _a === void 0 || _a.call($0c8bcb631f9fa522$var$feature_gate_js_client_1.default, gateName, value);
    });
    Object.entries((overrides === null || overrides === void 0 ? void 0 : overrides.configs) || {}).forEach(([configName, values])=>{
        var _a;
        (_a = $0c8bcb631f9fa522$var$feature_gate_js_client_1.default.overrideConfig) === null || _a === void 0 || _a.call($0c8bcb631f9fa522$var$feature_gate_js_client_1.default, configName, values);
    });
}
function $0c8bcb631f9fa522$var$clearOverrides(overrides) {
    Object.keys((overrides === null || overrides === void 0 ? void 0 : overrides.gates) || {}).forEach((gateName)=>{
        var _a;
        (_a = $0c8bcb631f9fa522$var$feature_gate_js_client_1.default.clearGateOverride) === null || _a === void 0 || _a.call($0c8bcb631f9fa522$var$feature_gate_js_client_1.default, gateName);
    });
    Object.keys((overrides === null || overrides === void 0 ? void 0 : overrides.configs) || {}).forEach((configName)=>{
        var _a;
        (_a = $0c8bcb631f9fa522$var$feature_gate_js_client_1.default.clearConfigOverride) === null || _a === void 0 || _a.call($0c8bcb631f9fa522$var$feature_gate_js_client_1.default, configName);
    });
}

});


parcelRegister("jlxKU", function(module, exports) {
"use strict";
var $e15a29a50c470b63$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.FeatureGatesInitializationWithProvider = void 0;

var $5FkrB = parcelRequire("5FkrB");

const $e15a29a50c470b63$var$feature_gate_js_client_1 = $e15a29a50c470b63$var$__importDefault((parcelRequire("jcX3Q")));

var $14MvJ = parcelRequire("14MvJ");
/**
 * This component initializes the @atlassian/feature-flag-js-client by fetching the gate and experiment
 * evaluations for the given user, and blocks rendering of the children until the rendering is complete.
 */ const $e15a29a50c470b63$var$FeatureGatesInitializationWithProvider = ({ children: children, enabled: enabled = true, identifiers: identifiers, customAttributes: customAttributes, options: options, initializingComponent: initializingComponent, overrides: overrides, onReady: onReady, provider: provider })=>{
    // Rather than checking the state of all overrides, we can just assume that if overrides are provided
    // then some sort of update will need to be performed, and hold off rendering until the useEffect is run.
    const [isInitialized, setInitialized] = (0, $5FkrB.useState)(!overrides && (0, $14MvJ.isClientAlreadyInCorrectState)(identifiers, customAttributes));
    // Use a ref for the options and provider, so that we can use them within the following useEffect
    // without adding options and provider as dependencies.
    // This avoids the user updating every time an option or provider is attempted to be changed.
    const optionsRef = (0, $5FkrB.useRef)(options);
    const providerRef = (0, $5FkrB.useRef)(provider);
    (0, $5FkrB.useEffect)(()=>{
        optionsRef.current = options;
        providerRef.current = provider;
    }, [
        options,
        provider
    ]);
    (0, $5FkrB.useEffect)(()=>{
        if (enabled) {
            if ((0, $14MvJ.isClientAlreadyInCorrectState)(identifiers, customAttributes)) {
                (0, $14MvJ.applyOverrides)(overrides);
                setInitialized(true);
                onReady === null || onReady === void 0 || onReady();
            } else {
                setInitialized(false);
                const initPromise = $e15a29a50c470b63$var$feature_gate_js_client_1.default.initializeCalled() ? $e15a29a50c470b63$var$feature_gate_js_client_1.default.updateUserWithProvider(identifiers, customAttributes) : $e15a29a50c470b63$var$feature_gate_js_client_1.default.initializeWithProvider(options, provider, identifiers, customAttributes);
                initPromise.catch((err)=>(0, $14MvJ.toError)(err)).then((err)=>{
                    setInitialized(true);
                    (0, $14MvJ.applyOverrides)(overrides);
                    onReady === null || onReady === void 0 || onReady(err || undefined);
                });
            }
        } else {
            setInitialized(true);
            onReady === null || onReady === void 0 || onReady();
        }
        return ()=>(0, $14MvJ.clearOverrides)(overrides);
    }, [
        enabled,
        identifiers,
        customAttributes,
        overrides
    ]);
    return (0, $14MvJ.pickChildToRender)(enabled, isInitialized, children, initializingComponent);
};
module.exports.FeatureGatesInitializationWithProvider = $e15a29a50c470b63$var$FeatureGatesInitializationWithProvider;
module.exports.default = module.exports.FeatureGatesInitializationWithProvider;

});

parcelRegister("glblS", function(module, exports) {
"use strict";
var $be5769be92103314$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.FeatureGatesInitializationWithDefaults = void 0;

var $5FkrB = parcelRequire("5FkrB");

const $be5769be92103314$var$feature_gate_js_client_1 = $be5769be92103314$var$__importDefault((parcelRequire("jcX3Q")));

var $14MvJ = parcelRequire("14MvJ");
/**
 * This component initializes the @atlassian/feature-flag-js-client by fetching the gate and experiment
 * evaluations for the given user, and blocks rendering of the children until the rendering is complete.
 */ const $be5769be92103314$var$FeatureGatesInitializationWithDefaults = ({ children: children, enabled: enabled = true, identifiers: identifiers, customAttributes: customAttributes, options: options, overrides: overrides, onReady: onReady })=>{
    // Rather than checking the state of all overrides, we can just assume that if overrides are provided
    // then some sort of update will need to be performed, and hold off rendering until the useEffect is run.
    const [isInitialized, setInitialized] = (0, $5FkrB.useState)(!overrides && (0, $14MvJ.isClientAlreadyInCorrectState)(identifiers, customAttributes));
    // Use a ref for the options, so that we can use them within the following useEffect
    // without adding options as a dependency.
    // This avoids the user updating every time an option is changed.
    const optionsRef = (0, $5FkrB.useRef)(options);
    (0, $5FkrB.useEffect)(()=>{
        optionsRef.current = options;
    }, [
        options
    ]);
    (0, $5FkrB.useEffect)(()=>{
        if (enabled) {
            if ((0, $14MvJ.isClientAlreadyInCorrectState)(identifiers, customAttributes)) {
                (0, $14MvJ.applyOverrides)(overrides);
                setInitialized(true);
                onReady === null || onReady === void 0 || onReady();
            } else {
                setInitialized(false);
                const initPromise = $be5769be92103314$var$feature_gate_js_client_1.default.initializeCalled() ? $be5769be92103314$var$feature_gate_js_client_1.default.updateUserWithValues(identifiers, customAttributes) : $be5769be92103314$var$feature_gate_js_client_1.default.initializeFromValues(Object.assign({
                    sdkKey: 'client-default-key'
                }, optionsRef.current || {}), identifiers, customAttributes);
                initPromise.catch((err)=>(0, $14MvJ.toError)(err)).then((err)=>{
                    setInitialized(true);
                    (0, $14MvJ.applyOverrides)(overrides);
                    onReady === null || onReady === void 0 || onReady(err || undefined);
                });
            }
        } else {
            setInitialized(true);
            onReady === null || onReady === void 0 || onReady();
        }
        return ()=>(0, $14MvJ.clearOverrides)(overrides);
    }, [
        enabled,
        identifiers,
        customAttributes,
        overrides
    ]);
    return (0, $14MvJ.pickChildToRender)(enabled, isInitialized, children);
};
module.exports.FeatureGatesInitializationWithDefaults = $be5769be92103314$var$FeatureGatesInitializationWithDefaults;
module.exports.default = module.exports.FeatureGatesInitializationWithDefaults;

});

parcelRegister("hn1YZ", function(module, exports) {
"use strict";
var $ca561f5aec499d8d$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.FeatureGatesInitializationWithValues = void 0;

var $5FkrB = parcelRequire("5FkrB");

const $ca561f5aec499d8d$var$feature_gate_js_client_1 = $ca561f5aec499d8d$var$__importDefault((parcelRequire("jcX3Q")));

var $14MvJ = parcelRequire("14MvJ");
/**
 * This component initializes the @atlassian/feature-flag-js-client by fetching the gate and experiment
 * evaluations for the given user, and blocks rendering of the children until the rendering is complete.
 */ const $ca561f5aec499d8d$var$FeatureGatesInitializationWithValues = ({ children: children, enabled: enabled = true, identifiers: identifiers, customAttributes: customAttributes, options: options, initializeValues: initializeValues, overrides: overrides, onReady: onReady })=>{
    // Rather than checking the state of all overrides, we can just assume that if overrides are provided
    // then some sort of update will need to be performed, and hold off rendering until the useEffect is run.
    const [isInitialized, setInitialized] = (0, $5FkrB.useState)(!overrides && (0, $14MvJ.isClientAlreadyInCorrectState)(identifiers, customAttributes));
    // Use a ref for the options, so that we can use them within the following useEffect
    // without adding options as a dependency.
    // This avoids the user updating every time an option is changed.
    const optionsRef = (0, $5FkrB.useRef)(options);
    (0, $5FkrB.useEffect)(()=>{
        optionsRef.current = options;
    }, [
        options
    ]);
    (0, $5FkrB.useEffect)(()=>{
        if (enabled) {
            if ((0, $14MvJ.isClientAlreadyInCorrectState)(identifiers, customAttributes)) {
                (0, $14MvJ.applyOverrides)(overrides);
                setInitialized(true);
                onReady === null || onReady === void 0 || onReady();
            } else {
                setInitialized(false);
                const initPromise = $ca561f5aec499d8d$var$feature_gate_js_client_1.default.initializeCalled() ? $ca561f5aec499d8d$var$feature_gate_js_client_1.default.updateUserWithValues(identifiers, customAttributes, initializeValues) : $ca561f5aec499d8d$var$feature_gate_js_client_1.default.initializeFromValues(optionsRef.current, identifiers, customAttributes, initializeValues);
                initPromise.catch((err)=>(0, $14MvJ.toError)(err)).then((err)=>{
                    setInitialized(true);
                    (0, $14MvJ.applyOverrides)(overrides);
                    onReady === null || onReady === void 0 || onReady(err || undefined);
                });
            }
        } else {
            setInitialized(true);
            onReady === null || onReady === void 0 || onReady();
        }
        return ()=>(0, $14MvJ.clearOverrides)(overrides);
    }, [
        enabled,
        identifiers,
        customAttributes,
        initializeValues,
        overrides
    ]);
    return (0, $14MvJ.pickChildToRender)(enabled, isInitialized, children);
};
module.exports.FeatureGatesInitializationWithValues = $ca561f5aec499d8d$var$FeatureGatesInitializationWithValues;
module.exports.default = module.exports.FeatureGatesInitializationWithValues;

});

parcelRegister("bNmp1", function(module, exports) {
$parcel$export(module.exports, "default", () => $8965a5fc1a5cfd30$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::bed93fe274604f7a0e4e565f6d589dc1>>
 * @codegenCommand yarn build tokens
 */ var $8965a5fc1a5cfd30$var$tokens = {
    'motion.avatar.enter': '--ds-avatar-enter',
    'motion.avatar.exit': '--ds-avatar-exit',
    'motion.avatar.hovered': '--ds-avatar-hovered',
    'motion.blanket.enter': '--ds-blanket-enter',
    'motion.blanket.exit': '--ds-blanket-exit',
    'motion.button.hovered': '--ds-button-hovered',
    'motion.button.pressed': '--ds-button-pressed',
    'motion.duration.instant': '--ds-duration-instant',
    'motion.duration.long': '--ds-duration-long',
    'motion.duration.medium': '--ds-duration-medium',
    'motion.duration.short': '--ds-duration-short',
    'motion.duration.xlong': '--ds-duration-xlong',
    'motion.duration.xshort': '--ds-duration-xshort',
    'motion.duration.xxlong': '--ds-duration-xxlong',
    'motion.duration.xxshort': '--ds-duration-xxshort',
    'motion.easing.in.practical': '--ds-easing-in-practical',
    'motion.easing.inout.bold': '--ds-easing-inout-bold',
    'motion.easing.out.practical': '--ds-easing-out-practical',
    'motion.easing.out.bold': '--ds-easing-out-bold',
    'motion.easing.spring': '--ds-easing-spring',
    'motion.flag.enter': '--ds-flag-enter',
    'motion.flag.exit': '--ds-flag-exit',
    'motion.flag.reposition': '--ds-flag-reposition',
    'motion.keyframe.fade.in': '--ds-keyframe-fade-in',
    'motion.keyframe.fade.out': '--ds-keyframe-fade-out',
    'motion.keyframe.scale.in.medium': '--ds-keyframe-scale-in-medium',
    'motion.keyframe.scale.in.small': '--ds-keyframe-scale-in-small',
    'motion.keyframe.scale.out.medium': '--ds-keyframe-scale-out-medium',
    'motion.keyframe.scale.out.small': '--ds-keyframe-scale-out-small',
    'motion.keyframe.slide.in.bottom.short': '--ds-keyframe-slide-in-bottom-short',
    'motion.keyframe.slide.in.left.half': '--ds-keyframe-slide-in-left-half',
    'motion.keyframe.slide.in.left.short': '--ds-keyframe-slide-in-left-short',
    'motion.keyframe.slide.in.right.short': '--ds-keyframe-slide-in-right-short',
    'motion.keyframe.slide.in.top.short': '--ds-keyframe-slide-in-top-short',
    'motion.keyframe.slide.out.bottom.short': '--ds-keyframe-slide-out-bottom-short',
    'motion.keyframe.slide.out.left.half': '--ds-keyframe-slide-out-left-half',
    'motion.keyframe.slide.out.left.short': '--ds-keyframe-slide-out-left-short',
    'motion.keyframe.slide.out.right.short': '--ds-keyframe-slide-out-right-short',
    'motion.keyframe.slide.out.top.short': '--ds-keyframe-slide-out-top-short',
    'motion.label.enter': '--ds-label-enter',
    'motion.label.exit': '--ds-label-exit',
    'motion.listitem.hovered': '--ds-listitem-hovered',
    'motion.listitem.pressed': '--ds-listitem-pressed',
    'motion.listitem.selected': '--ds-listitem-selected',
    'motion.modal.enter': '--ds-modal-enter',
    'motion.modal.exit': '--ds-modal-exit',
    'motion.panel.content.enter': '--ds-panel-content-enter',
    'motion.panel.content.exit': '--ds-panel-content-exit',
    'motion.panel.enter': '--ds-panel-enter',
    'motion.panel.enter.left': '--ds-panel-enter-left',
    'motion.panel.enter.right': '--ds-panel-enter-right',
    'motion.panel.exit': '--ds-panel-exit',
    'motion.panel.exit.left': '--ds-panel-exit-left',
    'motion.panel.exit.right': '--ds-panel-exit-right',
    'motion.popup.enter.bottom': '--ds-popup-enter-bottom',
    'motion.popup.enter.left': '--ds-popup-enter-left',
    'motion.popup.enter.right': '--ds-popup-enter-right',
    'motion.popup.enter.top': '--ds-popup-enter-top',
    'motion.popup.exit.bottom': '--ds-popup-exit-bottom',
    'motion.popup.exit.left': '--ds-popup-exit-left',
    'motion.popup.exit.right': '--ds-popup-exit-right',
    'motion.popup.exit.top': '--ds-popup-exit-top',
    'motion.sidenav.enter.left': '--ds-sidenav-enter-left',
    'motion.sidenav.enter.right': '--ds-sidenav-enter-right',
    'motion.sidenav.exit.left': '--ds-sidenav-exit-left',
    'motion.sidenav.exit.right': '--ds-sidenav-exit-right',
    'motion.spotlight.enter': '--ds-spotlight-enter',
    'motion.spotlight.exit': '--ds-spotlight-exit',
    'color.background.accent.lime.subtlest': '--ds-background-accent-lime-subtlest',
    'color.background.accent.lime.subtlest.hovered': '--ds-background-accent-lime-subtlest-hovered',
    'color.background.accent.lime.subtlest.pressed': '--ds-background-accent-lime-subtlest-pressed',
    'color.background.accent.lime.subtler': '--ds-background-accent-lime-subtler',
    'color.background.accent.lime.subtler.hovered': '--ds-background-accent-lime-subtler-hovered',
    'color.background.accent.lime.subtler.pressed': '--ds-background-accent-lime-subtler-pressed',
    'color.background.accent.lime.subtle': '--ds-background-accent-lime-subtle',
    'color.background.accent.lime.subtle.hovered': '--ds-background-accent-lime-subtle-hovered',
    'color.background.accent.lime.subtle.pressed': '--ds-background-accent-lime-subtle-pressed',
    'color.background.accent.lime.bolder': '--ds-background-accent-lime-bolder',
    'color.background.accent.lime.bolder.hovered': '--ds-background-accent-lime-bolder-hovered',
    'color.background.accent.lime.bolder.pressed': '--ds-background-accent-lime-bolder-pressed',
    'color.background.accent.red.subtlest': '--ds-background-accent-red-subtlest',
    'color.background.accent.red.subtlest.hovered': '--ds-background-accent-red-subtlest-hovered',
    'color.background.accent.red.subtlest.pressed': '--ds-background-accent-red-subtlest-pressed',
    'color.background.accent.red.subtler': '--ds-background-accent-red-subtler',
    'color.background.accent.red.subtler.hovered': '--ds-background-accent-red-subtler-hovered',
    'color.background.accent.red.subtler.pressed': '--ds-background-accent-red-subtler-pressed',
    'color.background.accent.red.subtle': '--ds-background-accent-red-subtle',
    'color.background.accent.red.subtle.hovered': '--ds-background-accent-red-subtle-hovered',
    'color.background.accent.red.subtle.pressed': '--ds-background-accent-red-subtle-pressed',
    'color.background.accent.red.bolder': '--ds-background-accent-red-bolder',
    'color.background.accent.red.bolder.hovered': '--ds-background-accent-red-bolder-hovered',
    'color.background.accent.red.bolder.pressed': '--ds-background-accent-red-bolder-pressed',
    'color.background.accent.orange.subtlest': '--ds-background-accent-orange-subtlest',
    'color.background.accent.orange.subtlest.hovered': '--ds-background-accent-orange-subtlest-hovered',
    'color.background.accent.orange.subtlest.pressed': '--ds-background-accent-orange-subtlest-pressed',
    'color.background.accent.orange.subtler': '--ds-background-accent-orange-subtler',
    'color.background.accent.orange.subtler.hovered': '--ds-background-accent-orange-subtler-hovered',
    'color.background.accent.orange.subtler.pressed': '--ds-background-accent-orange-subtler-pressed',
    'color.background.accent.orange.subtle': '--ds-background-accent-orange-subtle',
    'color.background.accent.orange.subtle.hovered': '--ds-background-accent-orange-subtle-hovered',
    'color.background.accent.orange.subtle.pressed': '--ds-background-accent-orange-subtle-pressed',
    'color.background.accent.orange.bolder': '--ds-background-accent-orange-bolder',
    'color.background.accent.orange.bolder.hovered': '--ds-background-accent-orange-bolder-hovered',
    'color.background.accent.orange.bolder.pressed': '--ds-background-accent-orange-bolder-pressed',
    'color.background.accent.yellow.subtlest': '--ds-background-accent-yellow-subtlest',
    'color.background.accent.yellow.subtlest.hovered': '--ds-background-accent-yellow-subtlest-hovered',
    'color.background.accent.yellow.subtlest.pressed': '--ds-background-accent-yellow-subtlest-pressed',
    'color.background.accent.yellow.subtler': '--ds-background-accent-yellow-subtler',
    'color.background.accent.yellow.subtler.hovered': '--ds-background-accent-yellow-subtler-hovered',
    'color.background.accent.yellow.subtler.pressed': '--ds-background-accent-yellow-subtler-pressed',
    'color.background.accent.yellow.subtle': '--ds-background-accent-yellow-subtle',
    'color.background.accent.yellow.subtle.hovered': '--ds-background-accent-yellow-subtle-hovered',
    'color.background.accent.yellow.subtle.pressed': '--ds-background-accent-yellow-subtle-pressed',
    'color.background.accent.yellow.bolder': '--ds-background-accent-yellow-bolder',
    'color.background.accent.yellow.bolder.hovered': '--ds-background-accent-yellow-bolder-hovered',
    'color.background.accent.yellow.bolder.pressed': '--ds-background-accent-yellow-bolder-pressed',
    'color.background.accent.green.subtlest': '--ds-background-accent-green-subtlest',
    'color.background.accent.green.subtlest.hovered': '--ds-background-accent-green-subtlest-hovered',
    'color.background.accent.green.subtlest.pressed': '--ds-background-accent-green-subtlest-pressed',
    'color.background.accent.green.subtler': '--ds-background-accent-green-subtler',
    'color.background.accent.green.subtler.hovered': '--ds-background-accent-green-subtler-hovered',
    'color.background.accent.green.subtler.pressed': '--ds-background-accent-green-subtler-pressed',
    'color.background.accent.green.subtle': '--ds-background-accent-green-subtle',
    'color.background.accent.green.subtle.hovered': '--ds-background-accent-green-subtle-hovered',
    'color.background.accent.green.subtle.pressed': '--ds-background-accent-green-subtle-pressed',
    'color.background.accent.green.bolder': '--ds-background-accent-green-bolder',
    'color.background.accent.green.bolder.hovered': '--ds-background-accent-green-bolder-hovered',
    'color.background.accent.green.bolder.pressed': '--ds-background-accent-green-bolder-pressed',
    'color.background.accent.teal.subtlest': '--ds-background-accent-teal-subtlest',
    'color.background.accent.teal.subtlest.hovered': '--ds-background-accent-teal-subtlest-hovered',
    'color.background.accent.teal.subtlest.pressed': '--ds-background-accent-teal-subtlest-pressed',
    'color.background.accent.teal.subtler': '--ds-background-accent-teal-subtler',
    'color.background.accent.teal.subtler.hovered': '--ds-background-accent-teal-subtler-hovered',
    'color.background.accent.teal.subtler.pressed': '--ds-background-accent-teal-subtler-pressed',
    'color.background.accent.teal.subtle': '--ds-background-accent-teal-subtle',
    'color.background.accent.teal.subtle.hovered': '--ds-background-accent-teal-subtle-hovered',
    'color.background.accent.teal.subtle.pressed': '--ds-background-accent-teal-subtle-pressed',
    'color.background.accent.teal.bolder': '--ds-background-accent-teal-bolder',
    'color.background.accent.teal.bolder.hovered': '--ds-background-accent-teal-bolder-hovered',
    'color.background.accent.teal.bolder.pressed': '--ds-background-accent-teal-bolder-pressed',
    'color.background.accent.blue.subtlest': '--ds-background-accent-blue-subtlest',
    'color.background.accent.blue.subtlest.hovered': '--ds-background-accent-blue-subtlest-hovered',
    'color.background.accent.blue.subtlest.pressed': '--ds-background-accent-blue-subtlest-pressed',
    'color.background.accent.blue.subtler': '--ds-background-accent-blue-subtler',
    'color.background.accent.blue.subtler.hovered': '--ds-background-accent-blue-subtler-hovered',
    'color.background.accent.blue.subtler.pressed': '--ds-background-accent-blue-subtler-pressed',
    'color.background.accent.blue.subtle': '--ds-background-accent-blue-subtle',
    'color.background.accent.blue.subtle.hovered': '--ds-background-accent-blue-subtle-hovered',
    'color.background.accent.blue.subtle.pressed': '--ds-background-accent-blue-subtle-pressed',
    'color.background.accent.blue.bolder': '--ds-background-accent-blue-bolder',
    'color.background.accent.blue.bolder.hovered': '--ds-background-accent-blue-bolder-hovered',
    'color.background.accent.blue.bolder.pressed': '--ds-background-accent-blue-bolder-pressed',
    'color.background.accent.purple.subtlest': '--ds-background-accent-purple-subtlest',
    'color.background.accent.purple.subtlest.hovered': '--ds-background-accent-purple-subtlest-hovered',
    'color.background.accent.purple.subtlest.pressed': '--ds-background-accent-purple-subtlest-pressed',
    'color.background.accent.purple.subtler': '--ds-background-accent-purple-subtler',
    'color.background.accent.purple.subtler.hovered': '--ds-background-accent-purple-subtler-hovered',
    'color.background.accent.purple.subtler.pressed': '--ds-background-accent-purple-subtler-pressed',
    'color.background.accent.purple.subtle': '--ds-background-accent-purple-subtle',
    'color.background.accent.purple.subtle.hovered': '--ds-background-accent-purple-subtle-hovered',
    'color.background.accent.purple.subtle.pressed': '--ds-background-accent-purple-subtle-pressed',
    'color.background.accent.purple.bolder': '--ds-background-accent-purple-bolder',
    'color.background.accent.purple.bolder.hovered': '--ds-background-accent-purple-bolder-hovered',
    'color.background.accent.purple.bolder.pressed': '--ds-background-accent-purple-bolder-pressed',
    'color.background.accent.magenta.subtlest': '--ds-background-accent-magenta-subtlest',
    'color.background.accent.magenta.subtlest.hovered': '--ds-background-accent-magenta-subtlest-hovered',
    'color.background.accent.magenta.subtlest.pressed': '--ds-background-accent-magenta-subtlest-pressed',
    'color.background.accent.magenta.subtler': '--ds-background-accent-magenta-subtler',
    'color.background.accent.magenta.subtler.hovered': '--ds-background-accent-magenta-subtler-hovered',
    'color.background.accent.magenta.subtler.pressed': '--ds-background-accent-magenta-subtler-pressed',
    'color.background.accent.magenta.subtle': '--ds-background-accent-magenta-subtle',
    'color.background.accent.magenta.subtle.hovered': '--ds-background-accent-magenta-subtle-hovered',
    'color.background.accent.magenta.subtle.pressed': '--ds-background-accent-magenta-subtle-pressed',
    'color.background.accent.magenta.bolder': '--ds-background-accent-magenta-bolder',
    'color.background.accent.magenta.bolder.hovered': '--ds-background-accent-magenta-bolder-hovered',
    'color.background.accent.magenta.bolder.pressed': '--ds-background-accent-magenta-bolder-pressed',
    'color.background.accent.gray.subtlest': '--ds-background-accent-gray-subtlest',
    'color.background.accent.gray.subtlest.hovered': '--ds-background-accent-gray-subtlest-hovered',
    'color.background.accent.gray.subtlest.pressed': '--ds-background-accent-gray-subtlest-pressed',
    'color.background.accent.gray.subtler': '--ds-background-accent-gray-subtler',
    'color.background.accent.gray.subtler.hovered': '--ds-background-accent-gray-subtler-hovered',
    'color.background.accent.gray.subtler.pressed': '--ds-background-accent-gray-subtler-pressed',
    'color.background.accent.gray.subtle': '--ds-background-accent-gray-subtle',
    'color.background.accent.gray.subtle.hovered': '--ds-background-accent-gray-subtle-hovered',
    'color.background.accent.gray.subtle.pressed': '--ds-background-accent-gray-subtle-pressed',
    'color.background.accent.gray.bolder': '--ds-background-accent-gray-bolder',
    'color.background.accent.gray.bolder.hovered': '--ds-background-accent-gray-bolder-hovered',
    'color.background.accent.gray.bolder.pressed': '--ds-background-accent-gray-bolder-pressed',
    'color.background.code.added.highlight': '--ds-background-code-added-highlight',
    'color.background.code.added.line': '--ds-background-code-added-line',
    'color.background.code.default': '--ds-background-code-default',
    'color.background.code.gutter': '--ds-background-code-gutter',
    'color.background.code.highlight': '--ds-background-code-highlight',
    'color.background.code.removed.highlight': '--ds-background-code-removed-highlight',
    'color.background.code.removed.line': '--ds-background-code-removed-line',
    'color.background.disabled': '--ds-background-disabled',
    'color.background.input': '--ds-background-input',
    'color.background.input.hovered': '--ds-background-input-hovered',
    'color.background.input.pressed': '--ds-background-input-pressed',
    'color.background.inverse.subtle': '--ds-background-inverse-subtle',
    'color.background.inverse.subtle.hovered': '--ds-background-inverse-subtle-hovered',
    'color.background.inverse.subtle.pressed': '--ds-background-inverse-subtle-pressed',
    'color.background.neutral': '--ds-background-neutral',
    'color.background.neutral.hovered': '--ds-background-neutral-hovered',
    'color.background.neutral.pressed': '--ds-background-neutral-pressed',
    'color.background.neutral.subtle': '--ds-background-neutral-subtle',
    'color.background.neutral.subtle.hovered': '--ds-background-neutral-subtle-hovered',
    'color.background.neutral.subtle.pressed': '--ds-background-neutral-subtle-pressed',
    'color.background.neutral.bold': '--ds-background-neutral-bold',
    'color.background.neutral.bold.hovered': '--ds-background-neutral-bold-hovered',
    'color.background.neutral.bold.pressed': '--ds-background-neutral-bold-pressed',
    'color.background.selected': '--ds-background-selected',
    'color.background.selected.hovered': '--ds-background-selected-hovered',
    'color.background.selected.pressed': '--ds-background-selected-pressed',
    'color.background.selected.bold': '--ds-background-selected-bold',
    'color.background.selected.bold.hovered': '--ds-background-selected-bold-hovered',
    'color.background.selected.bold.pressed': '--ds-background-selected-bold-pressed',
    'color.background.brand.subtlest': '--ds-background-brand-subtlest',
    'color.background.brand.subtlest.hovered': '--ds-background-brand-subtlest-hovered',
    'color.background.brand.subtlest.pressed': '--ds-background-brand-subtlest-pressed',
    'color.background.brand.bold': '--ds-background-brand-bold',
    'color.background.brand.bold.hovered': '--ds-background-brand-bold-hovered',
    'color.background.brand.bold.pressed': '--ds-background-brand-bold-pressed',
    'color.background.brand.boldest': '--ds-background-brand-boldest',
    'color.background.brand.boldest.hovered': '--ds-background-brand-boldest-hovered',
    'color.background.brand.boldest.pressed': '--ds-background-brand-boldest-pressed',
    'color.background.danger': '--ds-background-danger',
    'color.background.danger.hovered': '--ds-background-danger-hovered',
    'color.background.danger.pressed': '--ds-background-danger-pressed',
    'color.background.danger.subtler': '--ds-background-danger-subtler',
    'color.background.danger.subtler.hovered': '--ds-background-danger-subtler-hovered',
    'color.background.danger.subtler.pressed': '--ds-background-danger-subtler-pressed',
    'color.background.danger.subtle': '--ds-background-danger-subtle',
    'color.background.danger.bold': '--ds-background-danger-bold',
    'color.background.danger.bold.hovered': '--ds-background-danger-bold-hovered',
    'color.background.danger.bold.pressed': '--ds-background-danger-bold-pressed',
    'color.background.warning': '--ds-background-warning',
    'color.background.warning.hovered': '--ds-background-warning-hovered',
    'color.background.warning.pressed': '--ds-background-warning-pressed',
    'color.background.warning.subtler': '--ds-background-warning-subtler',
    'color.background.warning.subtler.hovered': '--ds-background-warning-subtler-hovered',
    'color.background.warning.subtler.pressed': '--ds-background-warning-subtler-pressed',
    'color.background.warning.subtle': '--ds-background-warning-subtle',
    'color.background.warning.bold': '--ds-background-warning-bold',
    'color.background.warning.bold.hovered': '--ds-background-warning-bold-hovered',
    'color.background.warning.bold.pressed': '--ds-background-warning-bold-pressed',
    'color.background.success': '--ds-background-success',
    'color.background.success.hovered': '--ds-background-success-hovered',
    'color.background.success.pressed': '--ds-background-success-pressed',
    'color.background.success.subtler': '--ds-background-success-subtler',
    'color.background.success.subtler.hovered': '--ds-background-success-subtler-hovered',
    'color.background.success.subtler.pressed': '--ds-background-success-subtler-pressed',
    'color.background.success.subtle': '--ds-background-success-subtle',
    'color.background.success.bold': '--ds-background-success-bold',
    'color.background.success.bold.hovered': '--ds-background-success-bold-hovered',
    'color.background.success.bold.pressed': '--ds-background-success-bold-pressed',
    'color.background.discovery': '--ds-background-discovery',
    'color.background.discovery.hovered': '--ds-background-discovery-hovered',
    'color.background.discovery.pressed': '--ds-background-discovery-pressed',
    'color.background.discovery.subtler': '--ds-background-discovery-subtler',
    'color.background.discovery.subtler.hovered': '--ds-background-discovery-subtler-hovered',
    'color.background.discovery.subtler.pressed': '--ds-background-discovery-subtler-pressed',
    'color.background.discovery.subtle': '--ds-background-discovery-subtle',
    'color.background.discovery.bold': '--ds-background-discovery-bold',
    'color.background.discovery.bold.hovered': '--ds-background-discovery-bold-hovered',
    'color.background.discovery.bold.pressed': '--ds-background-discovery-bold-pressed',
    'color.background.information': '--ds-background-information',
    'color.background.information.hovered': '--ds-background-information-hovered',
    'color.background.information.pressed': '--ds-background-information-pressed',
    'color.background.information.subtler': '--ds-background-information-subtler',
    'color.background.information.subtler.hovered': '--ds-background-information-subtler-hovered',
    'color.background.information.subtler.pressed': '--ds-background-information-subtler-pressed',
    'color.background.information.subtle': '--ds-background-information-subtle',
    'color.background.information.bold': '--ds-background-information-bold',
    'color.background.information.bold.hovered': '--ds-background-information-bold-hovered',
    'color.background.information.bold.pressed': '--ds-background-information-bold-pressed',
    'color.border': '--ds-border',
    'color.border.accent.lime': '--ds-border-accent-lime',
    'color.border.accent.lime.subtle': '--ds-border-accent-lime-subtle',
    'color.border.accent.red': '--ds-border-accent-red',
    'color.border.accent.red.subtle': '--ds-border-accent-red-subtle',
    'color.border.accent.orange': '--ds-border-accent-orange',
    'color.border.accent.orange.subtle': '--ds-border-accent-orange-subtle',
    'color.border.accent.yellow': '--ds-border-accent-yellow',
    'color.border.accent.yellow.subtle': '--ds-border-accent-yellow-subtle',
    'color.border.accent.green': '--ds-border-accent-green',
    'color.border.accent.green.subtle': '--ds-border-accent-green-subtle',
    'color.border.accent.teal': '--ds-border-accent-teal',
    'color.border.accent.teal.subtle': '--ds-border-accent-teal-subtle',
    'color.border.accent.blue': '--ds-border-accent-blue',
    'color.border.accent.blue.subtle': '--ds-border-accent-blue-subtle',
    'color.border.accent.purple': '--ds-border-accent-purple',
    'color.border.accent.purple.subtle': '--ds-border-accent-purple-subtle',
    'color.border.accent.magenta': '--ds-border-accent-magenta',
    'color.border.accent.magenta.subtle': '--ds-border-accent-magenta-subtle',
    'color.border.accent.gray': '--ds-border-accent-gray',
    'color.border.accent.gray.subtle': '--ds-border-accent-gray-subtle',
    'color.border.code': '--ds-border-code',
    'color.border.disabled': '--ds-border-disabled',
    'color.border.focused': '--ds-border-focused',
    'color.border.input': '--ds-border-input',
    'color.border.input.search': '--ds-border-input-search',
    'color.border.inverse': '--ds-border-inverse',
    'color.border.selected': '--ds-border-selected',
    'color.border.brand': '--ds-border-brand',
    'color.border.danger': '--ds-border-danger',
    'color.border.danger.subtle': '--ds-border-danger-subtle',
    'color.border.warning': '--ds-border-warning',
    'color.border.warning.subtle': '--ds-border-warning-subtle',
    'color.border.success': '--ds-border-success',
    'color.border.success.subtle': '--ds-border-success-subtle',
    'color.border.discovery': '--ds-border-discovery',
    'color.border.discovery.subtle': '--ds-border-discovery-subtle',
    'color.border.information': '--ds-border-information',
    'color.border.information.subtle': '--ds-border-information-subtle',
    'color.border.bold': '--ds-border-bold',
    'color.text': '--ds-text',
    'color.text.accent.lime': '--ds-text-accent-lime',
    'color.text.accent.lime.bolder': '--ds-text-accent-lime-bolder',
    'color.text.accent.red': '--ds-text-accent-red',
    'color.text.accent.red.bolder': '--ds-text-accent-red-bolder',
    'color.text.accent.orange': '--ds-text-accent-orange',
    'color.text.accent.orange.bolder': '--ds-text-accent-orange-bolder',
    'color.text.accent.yellow': '--ds-text-accent-yellow',
    'color.text.accent.yellow.bolder': '--ds-text-accent-yellow-bolder',
    'color.text.accent.green': '--ds-text-accent-green',
    'color.text.accent.green.bolder': '--ds-text-accent-green-bolder',
    'color.text.accent.teal': '--ds-text-accent-teal',
    'color.text.accent.teal.bolder': '--ds-text-accent-teal-bolder',
    'color.text.accent.blue': '--ds-text-accent-blue',
    'color.text.accent.blue.bolder': '--ds-text-accent-blue-bolder',
    'color.text.accent.purple': '--ds-text-accent-purple',
    'color.text.accent.purple.bolder': '--ds-text-accent-purple-bolder',
    'color.text.accent.magenta': '--ds-text-accent-magenta',
    'color.text.accent.magenta.bolder': '--ds-text-accent-magenta-bolder',
    'color.text.accent.gray': '--ds-text-accent-gray',
    'color.text.accent.gray.bolder': '--ds-text-accent-gray-bolder',
    'color.text.code.accent.1': '--ds-text-code-accent-1',
    'color.text.code.accent.2': '--ds-text-code-accent-2',
    'color.text.code.comments': '--ds-text-code-comments',
    'color.text.code.default': '--ds-text-code-default',
    'color.text.code.functions': '--ds-text-code-functions',
    'color.text.code.gutter': '--ds-text-code-gutter',
    'color.text.code.keywords': '--ds-text-code-keywords',
    'color.text.code.numbers': '--ds-text-code-numbers',
    'color.text.code.operators': '--ds-text-code-operators',
    'color.text.code.strings': '--ds-text-code-strings',
    'color.text.code.tags': '--ds-text-code-tags',
    'color.text.disabled': '--ds-text-disabled',
    'color.text.inverse': '--ds-text-inverse',
    'color.text.selected': '--ds-text-selected',
    'color.text.brand': '--ds-text-brand',
    'color.text.danger': '--ds-text-danger',
    'color.text.danger.bolder': '--ds-text-danger-bolder',
    'color.text.warning': '--ds-text-warning',
    'color.text.warning.inverse': '--ds-text-warning-inverse',
    'color.text.warning.bolder': '--ds-text-warning-bolder',
    'color.text.success': '--ds-text-success',
    'color.text.success.bolder': '--ds-text-success-bolder',
    'color.text.discovery': '--ds-text-discovery',
    'color.text.discovery.bolder': '--ds-text-discovery-bolder',
    'color.text.information': '--ds-text-information',
    'color.text.information.bolder': '--ds-text-information-bolder',
    'color.text.subtlest': '--ds-text-subtlest',
    'color.text.subtle': '--ds-text-subtle',
    'color.icon': '--ds-icon',
    'color.icon.accent.lime': '--ds-icon-accent-lime',
    'color.icon.accent.red': '--ds-icon-accent-red',
    'color.icon.accent.orange': '--ds-icon-accent-orange',
    'color.icon.accent.yellow': '--ds-icon-accent-yellow',
    'color.icon.accent.green': '--ds-icon-accent-green',
    'color.icon.accent.teal': '--ds-icon-accent-teal',
    'color.icon.accent.blue': '--ds-icon-accent-blue',
    'color.icon.accent.purple': '--ds-icon-accent-purple',
    'color.icon.accent.magenta': '--ds-icon-accent-magenta',
    'color.icon.accent.gray': '--ds-icon-accent-gray',
    'color.icon.disabled': '--ds-icon-disabled',
    'color.icon.inverse': '--ds-icon-inverse',
    'color.icon.selected': '--ds-icon-selected',
    'color.icon.brand': '--ds-icon-brand',
    'color.icon.danger': '--ds-icon-danger',
    'color.icon.warning': '--ds-icon-warning',
    'color.icon.warning.inverse': '--ds-icon-warning-inverse',
    'color.icon.success': '--ds-icon-success',
    'color.icon.discovery': '--ds-icon-discovery',
    'color.icon.information': '--ds-icon-information',
    'color.icon.subtlest': '--ds-icon-subtlest',
    'color.icon.subtle': '--ds-icon-subtle',
    'color.link': '--ds-link',
    'color.link.pressed': '--ds-link-pressed',
    'color.link.visited': '--ds-link-visited',
    'color.link.visited.pressed': '--ds-link-visited-pressed',
    'color.interaction.hovered': '--ds-interaction-hovered',
    'color.interaction.pressed': '--ds-interaction-pressed',
    'color.skeleton': '--ds-skeleton',
    'color.skeleton.subtle': '--ds-skeleton-subtle',
    'color.blanket': '--ds-blanket',
    'color.blanket.selected': '--ds-blanket-selected',
    'color.blanket.danger': '--ds-blanket-danger',
    'color.chart.categorical.1': '--ds-chart-categorical-1',
    'color.chart.categorical.1.hovered': '--ds-chart-categorical-1-hovered',
    'color.chart.categorical.2': '--ds-chart-categorical-2',
    'color.chart.categorical.2.hovered': '--ds-chart-categorical-2-hovered',
    'color.chart.categorical.3': '--ds-chart-categorical-3',
    'color.chart.categorical.3.hovered': '--ds-chart-categorical-3-hovered',
    'color.chart.categorical.4': '--ds-chart-categorical-4',
    'color.chart.categorical.4.hovered': '--ds-chart-categorical-4-hovered',
    'color.chart.categorical.5': '--ds-chart-categorical-5',
    'color.chart.categorical.5.hovered': '--ds-chart-categorical-5-hovered',
    'color.chart.categorical.6': '--ds-chart-categorical-6',
    'color.chart.categorical.6.hovered': '--ds-chart-categorical-6-hovered',
    'color.chart.categorical.7': '--ds-chart-categorical-7',
    'color.chart.categorical.7.hovered': '--ds-chart-categorical-7-hovered',
    'color.chart.categorical.8': '--ds-chart-categorical-8',
    'color.chart.categorical.8.hovered': '--ds-chart-categorical-8-hovered',
    'color.chart.lime.bold': '--ds-chart-lime-bold',
    'color.chart.lime.bold.hovered': '--ds-chart-lime-bold-hovered',
    'color.chart.lime.bolder': '--ds-chart-lime-bolder',
    'color.chart.lime.bolder.hovered': '--ds-chart-lime-bolder-hovered',
    'color.chart.lime.boldest': '--ds-chart-lime-boldest',
    'color.chart.lime.boldest.hovered': '--ds-chart-lime-boldest-hovered',
    'color.chart.neutral': '--ds-chart-neutral',
    'color.chart.neutral.hovered': '--ds-chart-neutral-hovered',
    'color.chart.red.bold': '--ds-chart-red-bold',
    'color.chart.red.bold.hovered': '--ds-chart-red-bold-hovered',
    'color.chart.red.bolder': '--ds-chart-red-bolder',
    'color.chart.red.bolder.hovered': '--ds-chart-red-bolder-hovered',
    'color.chart.red.boldest': '--ds-chart-red-boldest',
    'color.chart.red.boldest.hovered': '--ds-chart-red-boldest-hovered',
    'color.chart.orange.bold': '--ds-chart-orange-bold',
    'color.chart.orange.bold.hovered': '--ds-chart-orange-bold-hovered',
    'color.chart.orange.bolder': '--ds-chart-orange-bolder',
    'color.chart.orange.bolder.hovered': '--ds-chart-orange-bolder-hovered',
    'color.chart.orange.boldest': '--ds-chart-orange-boldest',
    'color.chart.orange.boldest.hovered': '--ds-chart-orange-boldest-hovered',
    'color.chart.yellow.bold': '--ds-chart-yellow-bold',
    'color.chart.yellow.bold.hovered': '--ds-chart-yellow-bold-hovered',
    'color.chart.yellow.bolder': '--ds-chart-yellow-bolder',
    'color.chart.yellow.bolder.hovered': '--ds-chart-yellow-bolder-hovered',
    'color.chart.yellow.boldest': '--ds-chart-yellow-boldest',
    'color.chart.yellow.boldest.hovered': '--ds-chart-yellow-boldest-hovered',
    'color.chart.green.bold': '--ds-chart-green-bold',
    'color.chart.green.bold.hovered': '--ds-chart-green-bold-hovered',
    'color.chart.green.bolder': '--ds-chart-green-bolder',
    'color.chart.green.bolder.hovered': '--ds-chart-green-bolder-hovered',
    'color.chart.green.boldest': '--ds-chart-green-boldest',
    'color.chart.green.boldest.hovered': '--ds-chart-green-boldest-hovered',
    'color.chart.teal.bold': '--ds-chart-teal-bold',
    'color.chart.teal.bold.hovered': '--ds-chart-teal-bold-hovered',
    'color.chart.teal.bolder': '--ds-chart-teal-bolder',
    'color.chart.teal.bolder.hovered': '--ds-chart-teal-bolder-hovered',
    'color.chart.teal.boldest': '--ds-chart-teal-boldest',
    'color.chart.teal.boldest.hovered': '--ds-chart-teal-boldest-hovered',
    'color.chart.blue.bold': '--ds-chart-blue-bold',
    'color.chart.blue.bold.hovered': '--ds-chart-blue-bold-hovered',
    'color.chart.blue.bolder': '--ds-chart-blue-bolder',
    'color.chart.blue.bolder.hovered': '--ds-chart-blue-bolder-hovered',
    'color.chart.blue.boldest': '--ds-chart-blue-boldest',
    'color.chart.blue.boldest.hovered': '--ds-chart-blue-boldest-hovered',
    'color.chart.purple.bold': '--ds-chart-purple-bold',
    'color.chart.purple.bold.hovered': '--ds-chart-purple-bold-hovered',
    'color.chart.purple.bolder': '--ds-chart-purple-bolder',
    'color.chart.purple.bolder.hovered': '--ds-chart-purple-bolder-hovered',
    'color.chart.purple.boldest': '--ds-chart-purple-boldest',
    'color.chart.purple.boldest.hovered': '--ds-chart-purple-boldest-hovered',
    'color.chart.magenta.bold': '--ds-chart-magenta-bold',
    'color.chart.magenta.bold.hovered': '--ds-chart-magenta-bold-hovered',
    'color.chart.magenta.bolder': '--ds-chart-magenta-bolder',
    'color.chart.magenta.bolder.hovered': '--ds-chart-magenta-bolder-hovered',
    'color.chart.magenta.boldest': '--ds-chart-magenta-boldest',
    'color.chart.magenta.boldest.hovered': '--ds-chart-magenta-boldest-hovered',
    'color.chart.gray.bold': '--ds-chart-gray-bold',
    'color.chart.gray.bold.hovered': '--ds-chart-gray-bold-hovered',
    'color.chart.gray.bolder': '--ds-chart-gray-bolder',
    'color.chart.gray.bolder.hovered': '--ds-chart-gray-bolder-hovered',
    'color.chart.gray.boldest': '--ds-chart-gray-boldest',
    'color.chart.gray.boldest.hovered': '--ds-chart-gray-boldest-hovered',
    'color.chart.brand': '--ds-chart-brand',
    'color.chart.brand.hovered': '--ds-chart-brand-hovered',
    'color.chart.danger': '--ds-chart-danger',
    'color.chart.danger.hovered': '--ds-chart-danger-hovered',
    'color.chart.danger.bold': '--ds-chart-danger-bold',
    'color.chart.danger.bold.hovered': '--ds-chart-danger-bold-hovered',
    'color.chart.warning': '--ds-chart-warning',
    'color.chart.warning.hovered': '--ds-chart-warning-hovered',
    'color.chart.warning.bold': '--ds-chart-warning-bold',
    'color.chart.warning.bold.hovered': '--ds-chart-warning-bold-hovered',
    'color.chart.success': '--ds-chart-success',
    'color.chart.success.hovered': '--ds-chart-success-hovered',
    'color.chart.success.bold': '--ds-chart-success-bold',
    'color.chart.success.bold.hovered': '--ds-chart-success-bold-hovered',
    'color.chart.discovery': '--ds-chart-discovery',
    'color.chart.discovery.hovered': '--ds-chart-discovery-hovered',
    'color.chart.discovery.bold': '--ds-chart-discovery-bold',
    'color.chart.discovery.bold.hovered': '--ds-chart-discovery-bold-hovered',
    'color.chart.information': '--ds-chart-information',
    'color.chart.information.hovered': '--ds-chart-information-hovered',
    'color.chart.information.bold': '--ds-chart-information-bold',
    'color.chart.information.bold.hovered': '--ds-chart-information-bold-hovered',
    'color.rovo.background.brand.bold': '--ds-rovo-background-brand-bold',
    'color.rovo.background.brand.bold.hovered': '--ds-rovo-background-brand-bold-hovered',
    'color.rovo.background.brand.bold.pressed': '--ds-rovo-background-brand-bold-pressed',
    'color.rovo.border.lime': '--ds-rovo-border-lime',
    'color.rovo.border.saffron': '--ds-rovo-border-saffron',
    'color.rovo.border.blue': '--ds-rovo-border-blue',
    'color.rovo.border.purple': '--ds-rovo-border-purple',
    'color.rovo.icon.lime': '--ds-rovo-icon-lime',
    'color.rovo.icon.saffron': '--ds-rovo-icon-saffron',
    'color.rovo.icon.blue': '--ds-rovo-icon-blue',
    'color.rovo.icon.purple': '--ds-rovo-icon-purple',
    'elevation.surface': '--ds-surface',
    'elevation.surface.hovered': '--ds-surface-hovered',
    'elevation.surface.pressed': '--ds-surface-pressed',
    'elevation.surface.container': '--ds-surface-container',
    'elevation.surface.container.hovered': '--ds-surface-container-hovered',
    'elevation.surface.container.pressed': '--ds-surface-container-pressed',
    'elevation.surface.overlay': '--ds-surface-overlay',
    'elevation.surface.overlay.hovered': '--ds-surface-overlay-hovered',
    'elevation.surface.overlay.pressed': '--ds-surface-overlay-pressed',
    'elevation.surface.raised': '--ds-surface-raised',
    'elevation.surface.raised.hovered': '--ds-surface-raised-hovered',
    'elevation.surface.raised.pressed': '--ds-surface-raised-pressed',
    'elevation.surface.sunken': '--ds-surface-sunken',
    'elevation.rovo.surface.overlay': '--ds-rovo-surface-overlay',
    'elevation.rovo.surface.overlay.hovered': '--ds-rovo-surface-overlay-hovered',
    'elevation.rovo.surface.overlay.pressed': '--ds-rovo-surface-overlay-pressed',
    'elevation.shadow.overflow': '--ds-shadow-overflow',
    'elevation.shadow.overflow.perimeter': '--ds-shadow-overflow-perimeter',
    'elevation.shadow.overflow.spread': '--ds-shadow-overflow-spread',
    'elevation.shadow.overlay': '--ds-shadow-overlay',
    'elevation.shadow.raised': '--ds-shadow-raised',
    'opacity.disabled': '--ds-opacity-disabled',
    'opacity.loading': '--ds-opacity-loading',
    'utility.UNSAFE.transparent': '--ds-UNSAFE-transparent',
    'utility.elevation.surface.current': '--ds-elevation-surface-current',
    'space.0': '--ds-space-0',
    'space.025': '--ds-space-025',
    'space.050': '--ds-space-050',
    'space.075': '--ds-space-075',
    'space.100': '--ds-space-100',
    'space.150': '--ds-space-150',
    'space.200': '--ds-space-200',
    'space.250': '--ds-space-250',
    'space.300': '--ds-space-300',
    'space.400': '--ds-space-400',
    'space.500': '--ds-space-500',
    'space.600': '--ds-space-600',
    'space.800': '--ds-space-800',
    'space.1000': '--ds-space-1000',
    'space.negative.025': '--ds-space-negative-025',
    'space.negative.050': '--ds-space-negative-050',
    'space.negative.075': '--ds-space-negative-075',
    'space.negative.100': '--ds-space-negative-100',
    'space.negative.150': '--ds-space-negative-150',
    'space.negative.200': '--ds-space-negative-200',
    'space.negative.250': '--ds-space-negative-250',
    'space.negative.300': '--ds-space-negative-300',
    'space.negative.400': '--ds-space-negative-400',
    'font.heading.xxlarge': '--ds-font-heading-xxlarge',
    'font.heading.xlarge': '--ds-font-heading-xlarge',
    'font.heading.large': '--ds-font-heading-large',
    'font.heading.medium': '--ds-font-heading-medium',
    'font.heading.small': '--ds-font-heading-small',
    'font.heading.xsmall': '--ds-font-heading-xsmall',
    'font.heading.xxsmall': '--ds-font-heading-xxsmall',
    'font.body.large': '--ds-font-body-large',
    'font.body': '--ds-font-body',
    'font.body.small': '--ds-font-body-small',
    'font.metric.large': '--ds-font-metric-large',
    'font.metric.medium': '--ds-font-metric-medium',
    'font.metric.small': '--ds-font-metric-small',
    'font.code': '--ds-font-code',
    'font.weight.regular': '--ds-font-weight-regular',
    'font.weight.medium': '--ds-font-weight-medium',
    'font.weight.semibold': '--ds-font-weight-semibold',
    'font.weight.bold': '--ds-font-weight-bold',
    'font.family.heading': '--ds-font-family-heading',
    'font.family.body': '--ds-font-family-body',
    'font.family.code': '--ds-font-family-code',
    'font.family.brand.heading': '--ds-font-family-brand-heading',
    'font.family.brand.body': '--ds-font-family-brand-body',
    'radius.xsmall': '--ds-radius-xsmall',
    'radius.small': '--ds-radius-small',
    'radius.medium': '--ds-radius-medium',
    'radius.large': '--ds-radius-large',
    'radius.xlarge': '--ds-radius-xlarge',
    'radius.xxlarge': '--ds-radius-xxlarge',
    'radius.full': '--ds-radius-full',
    'radius.tile': '--ds-radius-tile',
    'border.width': '--ds-border-width',
    'border.width.selected': '--ds-border-width-selected',
    'border.width.focused': '--ds-border-width-focused'
};
var $8965a5fc1a5cfd30$export$2e2bcd8739ae039 = $8965a5fc1a5cfd30$var$tokens;

});

parcelRegister("5T6u3", function(module, exports) {
/**
 * Relay v21.0.1
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 
module.exports = (parcelRequire("7TJSg"));

});
parcelRegister("7TJSg", function(module, exports) {
'use strict';

var $8FWpR = parcelRequire("8FWpR");

var $aWCOu = parcelRequire("aWCOu");

var $cQD5G = parcelRequire("cQD5G");

var $lxnIq = parcelRequire("lxnIq");

var $2gNok = parcelRequire("2gNok");

var $gai4Q = parcelRequire("gai4Q");

var $3ijZm = parcelRequire("3ijZm");

var $b2vkf = parcelRequire("b2vkf");

var $ejfNK = parcelRequire("ejfNK");
var $5c014120dec9092e$var$loadQuery = $ejfNK.loadQuery;

var $j5zXq = parcelRequire("j5zXq");

var $3JdSd = parcelRequire("3JdSd");

var $dIqcO = parcelRequire("dIqcO");

var $bVIjz = parcelRequire("bVIjz");

var $lelUi = parcelRequire("lelUi");

var $gskhu = parcelRequire("gskhu");

var $2zAPq = parcelRequire("2zAPq");

var $ceb2r = parcelRequire("ceb2r");

var $cyCW8 = parcelRequire("cyCW8");

var $8QvNU = parcelRequire("8QvNU");

var $ff9zd = parcelRequire("ff9zd");

var $gMQkI = parcelRequire("gMQkI");

var $jxUnU = parcelRequire("jxUnU");

var $23TM5 = parcelRequire("23TM5");

var $lSDJw = parcelRequire("lSDJw");

var $5UwvI = parcelRequire("5UwvI");

var $7eKmg = parcelRequire("7eKmg");
var $5c014120dec9092e$var$ConnectionHandler = $7eKmg.ConnectionHandler, $5c014120dec9092e$var$MutationTypes = $7eKmg.MutationTypes, $5c014120dec9092e$var$RangeOperations = $7eKmg.RangeOperations, $5c014120dec9092e$var$applyOptimisticMutation = $7eKmg.applyOptimisticMutation, $5c014120dec9092e$var$commitLocalUpdate = $7eKmg.commitLocalUpdate, $5c014120dec9092e$var$commitMutation = $7eKmg.commitMutation, $5c014120dec9092e$var$fetchQuery_DEPRECATED = $7eKmg.fetchQuery_DEPRECATED, $5c014120dec9092e$var$graphql = $7eKmg.graphql, $5c014120dec9092e$var$readInlineData = $7eKmg.readInlineData, $5c014120dec9092e$var$requestSubscription = $7eKmg.requestSubscription, $5c014120dec9092e$var$fetchQuery = $7eKmg.fetchQuery;
var $5c014120dec9092e$var$createFragmentContainer = $aWCOu.createContainer;
var $5c014120dec9092e$var$createPaginationContainer = $lxnIq.createContainer;
var $5c014120dec9092e$var$createRefetchContainer = $gai4Q.createContainer;
module.exports = {
    ConnectionHandler: $5c014120dec9092e$var$ConnectionHandler,
    QueryRenderer: $2gNok,
    LocalQueryRenderer: $cQD5G,
    MutationTypes: $5c014120dec9092e$var$MutationTypes,
    RangeOperations: $5c014120dec9092e$var$RangeOperations,
    ReactRelayContext: $8FWpR,
    applyOptimisticMutation: $5c014120dec9092e$var$applyOptimisticMutation,
    commitLocalUpdate: $5c014120dec9092e$var$commitLocalUpdate,
    commitMutation: $5c014120dec9092e$var$commitMutation,
    createFragmentContainer: $5c014120dec9092e$var$createFragmentContainer,
    createPaginationContainer: $5c014120dec9092e$var$createPaginationContainer,
    createRefetchContainer: $5c014120dec9092e$var$createRefetchContainer,
    fetchQuery_DEPRECATED: $5c014120dec9092e$var$fetchQuery_DEPRECATED,
    graphql: $5c014120dec9092e$var$graphql,
    readInlineData: $5c014120dec9092e$var$readInlineData,
    requestSubscription: $5c014120dec9092e$var$requestSubscription,
    EntryPointContainer: $3ijZm,
    RelayEnvironmentProvider: $3JdSd,
    ProfilerContext: $j5zXq,
    fetchQuery: $5c014120dec9092e$var$fetchQuery,
    loadQuery: $5c014120dec9092e$var$loadQuery,
    loadEntryPoint: $b2vkf,
    useClientQuery: $dIqcO,
    useFragment: $lelUi,
    useLazyLoadQuery: $gskhu,
    useEntryPointLoader: $bVIjz,
    useQueryLoader: $gMQkI,
    useMutation: $2zAPq,
    useMutationAction_EXPERIMENTAL: $ceb2r,
    usePaginationFragment: $cyCW8,
    usePreloadedQuery: $ff9zd,
    useRefetchableFragment: $jxUnU,
    usePrefetchableForwardPaginationFragment: $8QvNU,
    useRelayEnvironment: $23TM5,
    useSubscribeToInvalidationState: $lSDJw,
    useSubscription: $5UwvI
};

});
parcelRegister("8FWpR", function(module, exports) {
'use strict';

var $5FkrB = parcelRequire("5FkrB");

var $7eKmg = parcelRequire("7eKmg");
var $650f774e7c8a954f$var$createRelayContext = $7eKmg.__internal.createRelayContext;
module.exports = $650f774e7c8a954f$var$createRelayContext($5FkrB);

});
parcelRegister("7eKmg", function(module, exports) {
/**
 * Relay v21.0.1
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 
module.exports = (parcelRequire("tPPKZ"));

});
parcelRegister("tPPKZ", function(module, exports) {
'use strict';

var $5tdIO = parcelRequire("5tdIO");
var $059aeaa8b83ad1ab$var$isErrorResult = $5tdIO.isErrorResult, $059aeaa8b83ad1ab$var$isValueResult = $5tdIO.isValueResult;

var $qhT86 = parcelRequire("qhT86");

var $3h9bc = parcelRequire("3h9bc");

var $a3rTt = parcelRequire("a3rTt");

var $7NbNP = parcelRequire("7NbNP");

var $39DFs = parcelRequire("39DFs");

var $2vNtg = parcelRequire("2vNtg");

var $4S34J = parcelRequire("4S34J");

var $33gLb = parcelRequire("33gLb");

var $hM0OM = parcelRequire("hM0OM");

var $5bMXV = parcelRequire("5bMXV");

var $8Y0RR = parcelRequire("8Y0RR");

var $749Kc = parcelRequire("749Kc");

var $jywQ0 = parcelRequire("jywQ0");

var $3hl6N = parcelRequire("3hl6N");

var $kLQDK = parcelRequire("kLQDK");

var $kaSAu = parcelRequire("kaSAu");

var $9pidS = parcelRequire("9pidS");
var $059aeaa8b83ad1ab$var$generateClientID = $9pidS.generateClientID, $059aeaa8b83ad1ab$var$generateUniqueClientID = $9pidS.generateUniqueClientID, $059aeaa8b83ad1ab$var$isClientID = $9pidS.isClientID;

var $iqM8c = parcelRequire("iqM8c");

var $1ixaM = parcelRequire("1ixaM");

var $8ndPx = parcelRequire("8ndPx");

var $9pOE6 = parcelRequire("9pOE6");

var $jdpKt = parcelRequire("jdpKt");

var $fYxIJ = parcelRequire("fYxIJ");
var $059aeaa8b83ad1ab$var$isSuspenseSentinel = $fYxIJ.isSuspenseSentinel, $059aeaa8b83ad1ab$var$suspenseSentinel = $fYxIJ.suspenseSentinel;

var $eRaWx = parcelRequire("eRaWx");

var $kyemR = parcelRequire("kyemR");

var $1AjTQ = parcelRequire("1AjTQ");

var $adnaT = parcelRequire("adnaT");

var $b5YyQ = parcelRequire("b5YyQ");

var $gCG1q = parcelRequire("gCG1q");

var $7SC8Z = parcelRequire("7SC8Z");

var $iUq0k = parcelRequire("iUq0k");

var $1mBet = parcelRequire("1mBet");

var $fahOB = parcelRequire("fahOB");

var $3fbkc = parcelRequire("3fbkc");

var $ezyIu = parcelRequire("ezyIu");

var $hOB00 = parcelRequire("hOB00");

var $fsmz0 = parcelRequire("fsmz0");

var $bFqt0 = parcelRequire("bFqt0");

var $ihKxl = parcelRequire("ihKxl");

var $6GnlG = parcelRequire("6GnlG");

var $ishKi = parcelRequire("ishKi");

var $bEO5H = parcelRequire("bEO5H");

var $bA9MN = parcelRequire("bA9MN");

var $hqyg2 = parcelRequire("hqyg2");

var $1zv2Y = parcelRequire("1zv2Y");

var $fFdd7 = parcelRequire("fFdd7");

var $fST4p = parcelRequire("fST4p");

var $fTJz1 = parcelRequire("fTJz1");

var $ihTWZ = parcelRequire("ihTWZ");
var $059aeaa8b83ad1ab$var$handlePotentialSnapshotErrors = $ihTWZ.handlePotentialSnapshotErrors;

var $gYJUY = parcelRequire("gYJUY");

var $2YZAb = parcelRequire("2YZAb");

var $g0Xjw = parcelRequire("g0Xjw");

var $fT3Ou = parcelRequire("fT3Ou");

var $4cBjc = parcelRequire("4cBjc");

var $lFwfm = parcelRequire("lFwfm");

var $gZYpt = parcelRequire("gZYpt");

var $3u5Sb = parcelRequire("3u5Sb");

var $5kZs4 = parcelRequire("5kZs4");

var $4hUjJ = parcelRequire("4hUjJ");
var $059aeaa8b83ad1ab$var$hasCycle = $4hUjJ.hasCycle, $059aeaa8b83ad1ab$var$stableCopy = $4hUjJ.stableCopy;

var $lrIsZ = parcelRequire("lrIsZ");
var $059aeaa8b83ad1ab$var$mapStr, $059aeaa8b83ad1ab$var$setStr, $059aeaa8b83ad1ab$var$promiseStr, $059aeaa8b83ad1ab$var$objStr;
var $059aeaa8b83ad1ab$var$areEqualSelectors = $iUq0k.areEqualSelectors, $059aeaa8b83ad1ab$var$createNormalizationSelector = $iUq0k.createNormalizationSelector, $059aeaa8b83ad1ab$var$createReaderSelector = $iUq0k.createReaderSelector, $059aeaa8b83ad1ab$var$getDataIDsFromFragment = $iUq0k.getDataIDsFromFragment, $059aeaa8b83ad1ab$var$getDataIDsFromObject = $iUq0k.getDataIDsFromObject, $059aeaa8b83ad1ab$var$getPluralSelector = $iUq0k.getPluralSelector, $059aeaa8b83ad1ab$var$getSelector = $iUq0k.getSelector, $059aeaa8b83ad1ab$var$getSelectorsFromObject = $iUq0k.getSelectorsFromObject, $059aeaa8b83ad1ab$var$getSingularSelector = $iUq0k.getSingularSelector, $059aeaa8b83ad1ab$var$getVariablesFromFragment = $iUq0k.getVariablesFromFragment, $059aeaa8b83ad1ab$var$getVariablesFromObject = $iUq0k.getVariablesFromObject, $059aeaa8b83ad1ab$var$getVariablesFromPluralFragment = $iUq0k.getVariablesFromPluralFragment, $059aeaa8b83ad1ab$var$getVariablesFromSingularFragment = $iUq0k.getVariablesFromSingularFragment;
var $059aeaa8b83ad1ab$var$createOperationDescriptor = $gCG1q.createOperationDescriptor, $059aeaa8b83ad1ab$var$createRequestDescriptor = $gCG1q.createRequestDescriptor;
var $059aeaa8b83ad1ab$var$getArgumentValues = $ezyIu.getArgumentValues, $059aeaa8b83ad1ab$var$getModuleComponentKey = $ezyIu.getModuleComponentKey, $059aeaa8b83ad1ab$var$getModuleOperationKey = $ezyIu.getModuleOperationKey, $059aeaa8b83ad1ab$var$getStorageKey = $ezyIu.getStorageKey, $059aeaa8b83ad1ab$var$FRAGMENTS_KEY = $ezyIu.FRAGMENTS_KEY, $059aeaa8b83ad1ab$var$FRAGMENT_OWNER_KEY = $ezyIu.FRAGMENT_OWNER_KEY, $059aeaa8b83ad1ab$var$ID_KEY = $ezyIu.ID_KEY, $059aeaa8b83ad1ab$var$REF_KEY = $ezyIu.REF_KEY, $059aeaa8b83ad1ab$var$REFS_KEY = $ezyIu.REFS_KEY, $059aeaa8b83ad1ab$var$ROOT_ID = $ezyIu.ROOT_ID, $059aeaa8b83ad1ab$var$ROOT_TYPE = $ezyIu.ROOT_TYPE, $059aeaa8b83ad1ab$var$TYPENAME_KEY = $ezyIu.TYPENAME_KEY;
var $059aeaa8b83ad1ab$var$getNode = $kLQDK.getNode, $059aeaa8b83ad1ab$var$getFragment = $kLQDK.getFragment, $059aeaa8b83ad1ab$var$getInlineDataFragment = $kLQDK.getInlineDataFragment, $059aeaa8b83ad1ab$var$getPaginationFragment = $kLQDK.getPaginationFragment, $059aeaa8b83ad1ab$var$getRefetchableFragment = $kLQDK.getRefetchableFragment, $059aeaa8b83ad1ab$var$getRequest = $kLQDK.getRequest, $059aeaa8b83ad1ab$var$graphql = $kLQDK.graphql, $059aeaa8b83ad1ab$var$isFragment = $kLQDK.isFragment, $059aeaa8b83ad1ab$var$isInlineDataFragment = $kLQDK.isInlineDataFragment, $059aeaa8b83ad1ab$var$isRequest = $kLQDK.isRequest;
var $059aeaa8b83ad1ab$var$readFragment = $hOB00.readFragment;
var $059aeaa8b83ad1ab$var$DEFAULT_HANDLE_KEY = $4cBjc.DEFAULT_HANDLE_KEY;
var $059aeaa8b83ad1ab$var$MutationTypes = $33gLb.MutationTypes, $059aeaa8b83ad1ab$var$RangeOperations = $33gLb.RangeOperations;
var $059aeaa8b83ad1ab$var$VIEWER_ID = $fsmz0.VIEWER_ID, $059aeaa8b83ad1ab$var$VIEWER_TYPE = $fsmz0.VIEWER_TYPE;
var $059aeaa8b83ad1ab$var$__internal = {
    ResolverFragments: $hOB00,
    OperationTracker: $fahOB,
    createRelayContext: $1ixaM,
    createRelayLoggingContext: $8ndPx,
    defaultGetDataID: $9pOE6,
    getOperationVariables: $adnaT.getOperationVariables,
    getLocalVariables: $adnaT.getLocalVariables,
    fetchQuery: $3hl6N.fetchQuery,
    fetchQueryDeduped: $3hl6N.fetchQueryDeduped,
    getPromiseForActiveRequest: $3hl6N.getPromiseForActiveRequest,
    getObservableForActiveRequest: $3hl6N.getObservableForActiveRequest,
    NormalizationEngine: $eRaWx,
    normalizeResponse: $kyemR,
    withProvidedVariables: $lrIsZ
};
module.exports = {
    Environment: $b5YyQ,
    Network: $hM0OM,
    Observable: $5bMXV,
    QueryResponseCache: $8Y0RR,
    RecordSource: $3fbkc,
    Record: $7SC8Z,
    ReplaySubject: $5kZs4,
    Store: $1mBet,
    areEqualSelectors: $059aeaa8b83ad1ab$var$areEqualSelectors,
    createFragmentSpecResolver: $iqM8c,
    createNormalizationSelector: $059aeaa8b83ad1ab$var$createNormalizationSelector,
    createOperationDescriptor: $059aeaa8b83ad1ab$var$createOperationDescriptor,
    createReaderSelector: $059aeaa8b83ad1ab$var$createReaderSelector,
    createRequestDescriptor: $059aeaa8b83ad1ab$var$createRequestDescriptor,
    getArgumentValues: $059aeaa8b83ad1ab$var$getArgumentValues,
    getDataIDsFromFragment: $059aeaa8b83ad1ab$var$getDataIDsFromFragment,
    getDataIDsFromObject: $059aeaa8b83ad1ab$var$getDataIDsFromObject,
    getNode: $059aeaa8b83ad1ab$var$getNode,
    getFragment: $059aeaa8b83ad1ab$var$getFragment,
    getInlineDataFragment: $059aeaa8b83ad1ab$var$getInlineDataFragment,
    getModuleComponentKey: $059aeaa8b83ad1ab$var$getModuleComponentKey,
    getModuleOperationKey: $059aeaa8b83ad1ab$var$getModuleOperationKey,
    getPaginationFragment: $059aeaa8b83ad1ab$var$getPaginationFragment,
    getPluralSelector: $059aeaa8b83ad1ab$var$getPluralSelector,
    getRefetchableFragment: $059aeaa8b83ad1ab$var$getRefetchableFragment,
    getRequest: $059aeaa8b83ad1ab$var$getRequest,
    getRequestIdentifier: $fST4p,
    getSelector: $059aeaa8b83ad1ab$var$getSelector,
    getSelectorsFromObject: $059aeaa8b83ad1ab$var$getSelectorsFromObject,
    getSingularSelector: $059aeaa8b83ad1ab$var$getSingularSelector,
    getStorageKey: $059aeaa8b83ad1ab$var$getStorageKey,
    getVariablesFromFragment: $059aeaa8b83ad1ab$var$getVariablesFromFragment,
    getVariablesFromObject: $059aeaa8b83ad1ab$var$getVariablesFromObject,
    getVariablesFromPluralFragment: $059aeaa8b83ad1ab$var$getVariablesFromPluralFragment,
    getVariablesFromSingularFragment: $059aeaa8b83ad1ab$var$getVariablesFromSingularFragment,
    handlePotentialSnapshotErrors: $059aeaa8b83ad1ab$var$handlePotentialSnapshotErrors,
    graphql: $059aeaa8b83ad1ab$var$graphql,
    isErrorResult: $059aeaa8b83ad1ab$var$isErrorResult,
    isValueResult: $059aeaa8b83ad1ab$var$isValueResult,
    isFragment: $059aeaa8b83ad1ab$var$isFragment,
    isInlineDataFragment: $059aeaa8b83ad1ab$var$isInlineDataFragment,
    isSuspenseSentinel: $059aeaa8b83ad1ab$var$isSuspenseSentinel,
    suspenseSentinel: $059aeaa8b83ad1ab$var$suspenseSentinel,
    isRequest: $059aeaa8b83ad1ab$var$isRequest,
    readInlineData: $1AjTQ,
    readFragment: $059aeaa8b83ad1ab$var$readFragment,
    MutationTypes: $059aeaa8b83ad1ab$var$MutationTypes,
    RangeOperations: $059aeaa8b83ad1ab$var$RangeOperations,
    DefaultHandlerProvider: $7NbNP,
    ConnectionHandler: $qhT86,
    MutationHandlers: $a3rTt,
    VIEWER_ID: $059aeaa8b83ad1ab$var$VIEWER_ID,
    VIEWER_TYPE: $059aeaa8b83ad1ab$var$VIEWER_TYPE,
    applyOptimisticMutation: $39DFs,
    commitLocalUpdate: $2vNtg,
    commitMutation: $4S34J,
    fetchQuery: $749Kc,
    fetchQuery_DEPRECATED: $jywQ0,
    isRelayModernEnvironment: $jdpKt,
    requestSubscription: $bFqt0,
    ConnectionInterface: $3h9bc,
    PreloadableQueryRegistry: $kaSAu,
    RelayProfiler: $3u5Sb,
    createPayloadFor3DField: $ihKxl,
    RelayConcreteNode: $fT3Ou,
    RelayError: $lFwfm,
    RelayFeatureFlags: $gZYpt,
    DEFAULT_HANDLE_KEY: $059aeaa8b83ad1ab$var$DEFAULT_HANDLE_KEY,
    FRAGMENTS_KEY: $059aeaa8b83ad1ab$var$FRAGMENTS_KEY,
    FRAGMENT_OWNER_KEY: $059aeaa8b83ad1ab$var$FRAGMENT_OWNER_KEY,
    ID_KEY: $059aeaa8b83ad1ab$var$ID_KEY,
    REF_KEY: $059aeaa8b83ad1ab$var$REF_KEY,
    REFS_KEY: $059aeaa8b83ad1ab$var$REFS_KEY,
    ROOT_ID: $059aeaa8b83ad1ab$var$ROOT_ID,
    ROOT_TYPE: $059aeaa8b83ad1ab$var$ROOT_TYPE,
    TYPENAME_KEY: $059aeaa8b83ad1ab$var$TYPENAME_KEY,
    deepFreeze: $6GnlG,
    generateClientID: $059aeaa8b83ad1ab$var$generateClientID,
    generateUniqueClientID: $059aeaa8b83ad1ab$var$generateUniqueClientID,
    getRelayHandleKey: $fFdd7,
    isClientID: $059aeaa8b83ad1ab$var$isClientID,
    isPromise: $gYJUY,
    isScalarAndEqual: $2YZAb,
    recycleNodesInto: $g0Xjw,
    stableCopy: $059aeaa8b83ad1ab$var$stableCopy,
    hasCycle: $059aeaa8b83ad1ab$var$hasCycle,
    getFragmentIdentifier: $ishKi,
    getRefetchMetadata: $1zv2Y,
    getPaginationMetadata: $bEO5H,
    getPaginationVariables: $bA9MN,
    getPendingOperationsForFragment: $hqyg2,
    getValueAtPath: $fTJz1,
    __internal: $059aeaa8b83ad1ab$var$__internal
};

});
parcelRegister("5tdIO", function(module, exports) {
'use strict';

var $6sXeV = parcelRequire("6sXeV");

var $inpeC = parcelRequire("inpeC");
var $0107224a77eda748$var$observeFragment = $inpeC.observeFragment;

var $8PaRu = parcelRequire("8PaRu");
var $0107224a77eda748$var$observeQuery = $8PaRu.observeQuery;

var $gItWI = parcelRequire("gItWI");
var $0107224a77eda748$var$waitForFragmentData = $gItWI.waitForFragmentData;
function $0107224a77eda748$var$isValueResult(input) {
    return input.ok === true;
}
function $0107224a77eda748$var$isErrorResult(input) {
    return input.ok === false;
}
module.exports = {
    isErrorResult: $0107224a77eda748$var$isErrorResult,
    isValueResult: $0107224a77eda748$var$isValueResult,
    observeFragment: $0107224a77eda748$var$observeFragment,
    observeQuery: $0107224a77eda748$var$observeQuery,
    resolverDataInjector: $6sXeV,
    waitForFragmentData: $0107224a77eda748$var$waitForFragmentData
};

});
parcelRegister("6sXeV", function(module, exports) {
'use strict';

var $hOB00 = parcelRequire("hOB00");
var $4b534f65e985a87b$var$readFragment = $hOB00.readFragment;

var $jSI6G = parcelRequire("jSI6G");
function $4b534f65e985a87b$var$resolverDataInjector(fragment, _resolverFn, fieldName, isRequiredField) {
    var resolverFn = _resolverFn;
    return function(fragmentKey, args, resolverContext) {
        var data = $4b534f65e985a87b$var$readFragment(fragment, fragmentKey);
        if (fieldName != null) {
            if (data == null) {
                if (isRequiredField === true) $jSI6G(false);
                else return resolverFn(null, args, resolverContext);
            }
            if (fieldName in data) {
                if (isRequiredField === true) !(data[fieldName] != null) && $jSI6G(false);
                return resolverFn(data[fieldName], args, resolverContext);
            } else $jSI6G(false);
        } else return resolverFn(null, args, resolverContext);
    };
}
module.exports = $4b534f65e985a87b$var$resolverDataInjector;

});
parcelRegister("hOB00", function(module, exports) {
'use strict';

var $kLQDK = parcelRequire("kLQDK");
var $cf83ce6fe6f37065$var$getFragment = $kLQDK.getFragment;

var $ihTWZ = parcelRequire("ihTWZ");
var $cf83ce6fe6f37065$var$eventShouldThrow = $ihTWZ.eventShouldThrow;

var $iUq0k = parcelRequire("iUq0k");
var $cf83ce6fe6f37065$var$getSelector = $iUq0k.getSelector;

var $jSI6G = parcelRequire("jSI6G");
var $cf83ce6fe6f37065$var$contextStack = [];
function $cf83ce6fe6f37065$var$withResolverContext(context, cb) {
    $cf83ce6fe6f37065$var$contextStack.push(context);
    try {
        return cb();
    } finally{
        $cf83ce6fe6f37065$var$contextStack.pop();
    }
}
function $cf83ce6fe6f37065$var$readFragment(fragmentInput, fragmentKey) {
    if (!$cf83ce6fe6f37065$var$contextStack.length) throw new Error('readFragment should be called only from within a Relay Resolver function.');
    var context = $cf83ce6fe6f37065$var$contextStack[$cf83ce6fe6f37065$var$contextStack.length - 1];
    var fragmentNode = $cf83ce6fe6f37065$var$getFragment(fragmentInput);
    var fragmentSelector = $cf83ce6fe6f37065$var$getSelector(fragmentNode, fragmentKey);
    !(fragmentSelector != null) && $jSI6G(false);
    !(fragmentSelector.kind === 'SingularReaderSelector') && $jSI6G(false);
    var _context$getDataForRe = context.getDataForResolverFragment(fragmentSelector, fragmentKey), data = _context$getDataForRe.data, isMissingData = _context$getDataForRe.isMissingData, fieldErrors = _context$getDataForRe.fieldErrors;
    if (isMissingData || fieldErrors != null && fieldErrors.some($cf83ce6fe6f37065$var$eventShouldThrow)) throw $cf83ce6fe6f37065$var$RESOLVER_FRAGMENT_ERRORED_SENTINEL;
    return data;
}
var $cf83ce6fe6f37065$var$RESOLVER_FRAGMENT_ERRORED_SENTINEL = {};
module.exports = {
    RESOLVER_FRAGMENT_ERRORED_SENTINEL: $cf83ce6fe6f37065$var$RESOLVER_FRAGMENT_ERRORED_SENTINEL,
    readFragment: $cf83ce6fe6f37065$var$readFragment,
    withResolverContext: $cf83ce6fe6f37065$var$withResolverContext
};

});
parcelRegister("kLQDK", function(module, exports) {
'use strict';

var $fT3Ou = parcelRequire("fT3Ou");

var $jSI6G = parcelRequire("jSI6G");
parcelRequire("2OmBw");
function $f1f107a361a4c59b$var$graphql(strings) {
    $jSI6G(false);
}
function $f1f107a361a4c59b$var$getNode(taggedNode) {
    var node = taggedNode;
    if (typeof node === 'function') node = node();
    else if (node["default"]) node = node["default"];
    return node;
}
function $f1f107a361a4c59b$var$isFragment(node) {
    var fragment = $f1f107a361a4c59b$var$getNode(node);
    return typeof fragment === 'object' && fragment !== null && fragment.kind === $fT3Ou.FRAGMENT;
}
function $f1f107a361a4c59b$var$isRequest(node) {
    var request = $f1f107a361a4c59b$var$getNode(node);
    return typeof request === 'object' && request !== null && request.kind === $fT3Ou.REQUEST;
}
function $f1f107a361a4c59b$var$isUpdatableQuery(node) {
    var updatableQuery = $f1f107a361a4c59b$var$getNode(node);
    return typeof updatableQuery === 'object' && updatableQuery !== null && updatableQuery.kind === $fT3Ou.UPDATABLE_QUERY;
}
function $f1f107a361a4c59b$var$isInlineDataFragment(node) {
    var fragment = $f1f107a361a4c59b$var$getNode(node);
    return typeof fragment === 'object' && fragment !== null && fragment.kind === $fT3Ou.INLINE_DATA_FRAGMENT;
}
function $f1f107a361a4c59b$var$getFragment(taggedNode) {
    var fragment = $f1f107a361a4c59b$var$getNode(taggedNode);
    !$f1f107a361a4c59b$var$isFragment(fragment) && $jSI6G(false);
    return fragment;
}
function $f1f107a361a4c59b$var$getPaginationFragment(taggedNode) {
    var _fragment$metadata;
    var fragment = $f1f107a361a4c59b$var$getFragment(taggedNode);
    var refetch = (_fragment$metadata = fragment.metadata) === null || _fragment$metadata === void 0 ? void 0 : _fragment$metadata.refetch;
    var connection = refetch === null || refetch === void 0 ? void 0 : refetch.connection;
    if (refetch === null || typeof refetch !== 'object' || connection === null || typeof connection !== 'object') return null;
    return fragment;
}
function $f1f107a361a4c59b$var$getRefetchableFragment(taggedNode) {
    var _fragment$metadata2;
    var fragment = $f1f107a361a4c59b$var$getFragment(taggedNode);
    var refetch = (_fragment$metadata2 = fragment.metadata) === null || _fragment$metadata2 === void 0 ? void 0 : _fragment$metadata2.refetch;
    if (refetch === null || typeof refetch !== 'object') return null;
    return fragment;
}
function $f1f107a361a4c59b$var$getRequest(taggedNode) {
    var request = $f1f107a361a4c59b$var$getNode(taggedNode);
    !$f1f107a361a4c59b$var$isRequest(request) && $jSI6G(false);
    return request;
}
function $f1f107a361a4c59b$var$getUpdatableQuery(taggedNode) {
    var updatableQuery = $f1f107a361a4c59b$var$getNode(taggedNode);
    !$f1f107a361a4c59b$var$isUpdatableQuery(updatableQuery) && $jSI6G(false);
    return updatableQuery;
}
function $f1f107a361a4c59b$var$getInlineDataFragment(taggedNode) {
    var fragment = $f1f107a361a4c59b$var$getNode(taggedNode);
    !$f1f107a361a4c59b$var$isInlineDataFragment(fragment) && $jSI6G(false);
    return fragment;
}
module.exports = {
    getFragment: $f1f107a361a4c59b$var$getFragment,
    getInlineDataFragment: $f1f107a361a4c59b$var$getInlineDataFragment,
    getNode: $f1f107a361a4c59b$var$getNode,
    getPaginationFragment: $f1f107a361a4c59b$var$getPaginationFragment,
    getRefetchableFragment: $f1f107a361a4c59b$var$getRefetchableFragment,
    getRequest: $f1f107a361a4c59b$var$getRequest,
    getUpdatableQuery: $f1f107a361a4c59b$var$getUpdatableQuery,
    graphql: $f1f107a361a4c59b$var$graphql,
    isFragment: $f1f107a361a4c59b$var$isFragment,
    isInlineDataFragment: $f1f107a361a4c59b$var$isInlineDataFragment,
    isRequest: $f1f107a361a4c59b$var$isRequest,
    isUpdatableQuery: $f1f107a361a4c59b$var$isUpdatableQuery
};

});
parcelRegister("fT3Ou", function(module, exports) {
'use strict';
var $b90ef34ee3ee0b98$var$RelayConcreteNode = {
    ACTOR_CHANGE: 'ActorChange',
    CATCH_FIELD: 'CatchField',
    CONDITION: 'Condition',
    CLIENT_COMPONENT: 'ClientComponent',
    CLIENT_EDGE_TO_SERVER_OBJECT: 'ClientEdgeToServerObject',
    CLIENT_EDGE_TO_CLIENT_OBJECT: 'ClientEdgeToClientObject',
    CLIENT_EXTENSION: 'ClientExtension',
    DEFER: 'Defer',
    CONNECTION: 'Connection',
    FRAGMENT: 'Fragment',
    FRAGMENT_SPREAD: 'FragmentSpread',
    INLINE_DATA_FRAGMENT_SPREAD: 'InlineDataFragmentSpread',
    INLINE_DATA_FRAGMENT: 'InlineDataFragment',
    INLINE_FRAGMENT: 'InlineFragment',
    LINKED_FIELD: 'LinkedField',
    LINKED_HANDLE: 'LinkedHandle',
    LITERAL: 'Literal',
    LIST_VALUE: 'ListValue',
    LOCAL_ARGUMENT: 'LocalArgument',
    MODULE_IMPORT: 'ModuleImport',
    ALIASED_FRAGMENT_SPREAD: 'AliasedFragmentSpread',
    ALIASED_INLINE_FRAGMENT_SPREAD: 'AliasedInlineFragmentSpread',
    RELAY_RESOLVER: 'RelayResolver',
    RELAY_LIVE_RESOLVER: 'RelayLiveResolver',
    REQUIRED_FIELD: 'RequiredField',
    OBJECT_VALUE: 'ObjectValue',
    OPERATION: 'Operation',
    REQUEST: 'Request',
    ROOT_ARGUMENT: 'RootArgument',
    SCALAR_FIELD: 'ScalarField',
    SCALAR_HANDLE: 'ScalarHandle',
    SPLIT_OPERATION: 'SplitOperation',
    STREAM: 'Stream',
    TYPE_DISCRIMINATOR: 'TypeDiscriminator',
    UPDATABLE_QUERY: 'UpdatableQuery',
    VARIABLE: 'Variable'
};
module.exports = $b90ef34ee3ee0b98$var$RelayConcreteNode;

});

parcelRegister("jSI6G", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */ var $e795462a5dbdab0d$var$invariant = function(condition, format, a, b, c, d, e, f) {
    if (!condition) {
        var error;
        if (format === undefined) error = new Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");
        else {
            var args = [
                a,
                b,
                c,
                d,
                e,
                f
            ];
            var argIndex = 0;
            error = new Error(format.replace(/%s/g, function() {
                return args[argIndex++];
            }));
            error.name = 'Invariant Violation';
        }
        error.framesToPop = 1; // we don't care about invariant's own frame
        throw error;
    }
};
module.exports = $e795462a5dbdab0d$var$invariant;

});

parcelRegister("2OmBw", function(module, exports) {
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */ 'use strict';

var $4LJSO = parcelRequire("4LJSO");
/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */ function $20c1c9025c981ffb$var$printWarning(format) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
    var argIndex = 0;
    var message = 'Warning: ' + format.replace(/%s/g, function() {
        return args[argIndex++];
    });
    if (typeof console !== 'undefined') console.error(message);
    try {
        // --- Welcome to debugging React ---
        // This error was thrown as a convenience so that you can use this stack
        // to find the callsite that caused this warning to fire.
        throw new Error(message);
    } catch (x) {}
}
var $20c1c9025c981ffb$var$warning = $4LJSO;
module.exports = $20c1c9025c981ffb$var$warning;

});
parcelRegister("4LJSO", function(module, exports) {
"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */ function $378f24a4079daf0a$var$makeEmptyFunction(arg) {
    return function() {
        return arg;
    };
}
/**
 * This function accepts and discards inputs; it has no side effects. This is
 * primarily useful idiomatically for overridable function endpoints which
 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
 */ var $378f24a4079daf0a$var$emptyFunction = function emptyFunction() {};
$378f24a4079daf0a$var$emptyFunction.thatReturns = $378f24a4079daf0a$var$makeEmptyFunction;
$378f24a4079daf0a$var$emptyFunction.thatReturnsFalse = $378f24a4079daf0a$var$makeEmptyFunction(false);
$378f24a4079daf0a$var$emptyFunction.thatReturnsTrue = $378f24a4079daf0a$var$makeEmptyFunction(true);
$378f24a4079daf0a$var$emptyFunction.thatReturnsNull = $378f24a4079daf0a$var$makeEmptyFunction(null);
$378f24a4079daf0a$var$emptyFunction.thatReturnsThis = function() {
    return this;
};
$378f24a4079daf0a$var$emptyFunction.thatReturnsArgument = function(arg) {
    return arg;
};
module.exports = $378f24a4079daf0a$var$emptyFunction;

});



parcelRegister("ihTWZ", function(module, exports) {
'use strict';

var $e27SU = parcelRequire("e27SU");
var $d505371e39abebf4$var$_interopRequireDefault = $e27SU.default;

var $d505371e39abebf4$var$_objectSpread2 = $d505371e39abebf4$var$_interopRequireDefault((parcelRequire("caqem")));

var $d505371e39abebf4$var$_createForOfIteratorHelper2 = $d505371e39abebf4$var$_interopRequireDefault((parcelRequire("5dSyV")));

var $jSI6G = parcelRequire("jSI6G");
function $d505371e39abebf4$var$handleFieldErrors(environment, fieldErrors, loggingContext) {
    var _iterator = (0, $d505371e39abebf4$var$_createForOfIteratorHelper2["default"])(fieldErrors), _step;
    try {
        for(_iterator.s(); !(_step = _iterator.n()).done;){
            var fieldError = _step.value;
            environment.relayFieldLogger((0, $d505371e39abebf4$var$_objectSpread2["default"])((0, $d505371e39abebf4$var$_objectSpread2["default"])({}, fieldError), {}, {
                uiContext: loggingContext
            }));
        }
    } catch (err) {
        _iterator.e(err);
    } finally{
        _iterator.f();
    }
    var _iterator2 = (0, $d505371e39abebf4$var$_createForOfIteratorHelper2["default"])(fieldErrors), _step2;
    try {
        for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
            var _fieldError = _step2.value;
            if ($d505371e39abebf4$var$eventShouldThrow(_fieldError)) switch(_fieldError.kind){
                case 'relay_resolver.error':
                    throw new Error("Relay: Resolver error at path '".concat(_fieldError.fieldPath, "' in '").concat(_fieldError.owner, "'. Message: ").concat(_fieldError.error.message));
                case 'relay_field_payload.error':
                    throw new Error("Relay: Unexpected response payload - check server logs for details.");
                case 'missing_expected_data.throw':
                    throw new Error("Relay: Missing expected data at path '".concat(_fieldError.fieldPath, "' in '").concat(_fieldError.owner, "'."));
                case 'missing_required_field.throw':
                    throw new Error("Relay: Missing @required value at path '".concat(_fieldError.fieldPath, "' in '").concat(_fieldError.owner, "'."));
                case 'missing_required_field.log':
                case 'missing_expected_data.log':
                    break;
                default:
                    _fieldError.kind;
                    $jSI6G(false);
            }
        }
    } catch (err) {
        _iterator2.e(err);
    } finally{
        _iterator2.f();
    }
}
function $d505371e39abebf4$var$eventShouldThrow(event) {
    switch(event.kind){
        case 'relay_resolver.error':
        case 'relay_field_payload.error':
            return event.shouldThrow && !event.handled;
        case 'missing_expected_data.throw':
        case 'missing_required_field.throw':
            return !event.handled;
        case 'missing_required_field.log':
        case 'missing_expected_data.log':
            return false;
        default:
            event.kind;
            throw new Error('Relay: Unexpected event kind');
    }
}
function $d505371e39abebf4$var$handlePotentialSnapshotErrors(environment, fieldErrors, loggingContext) {
    if (fieldErrors != null) $d505371e39abebf4$var$handleFieldErrors(environment, fieldErrors, loggingContext);
}
module.exports = {
    eventShouldThrow: $d505371e39abebf4$var$eventShouldThrow,
    handlePotentialSnapshotErrors: $d505371e39abebf4$var$handlePotentialSnapshotErrors
};

});
parcelRegister("e27SU", function(module, exports) {
function $a3775e4ffd9c7f03$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
module.exports = $a3775e4ffd9c7f03$var$_interopRequireDefault, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("caqem", function(module, exports) {

var $2JBpp = parcelRequire("2JBpp");
function $8dbac41339d62a04$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $8dbac41339d62a04$var$_objectSpread2(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $8dbac41339d62a04$var$ownKeys(Object(t), !0).forEach(function(r) {
            $2JBpp(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $8dbac41339d62a04$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
module.exports = $8dbac41339d62a04$var$_objectSpread2, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("2JBpp", function(module, exports) {

var $g3TwN = parcelRequire("g3TwN");
function $1fdccd57615a7149$var$_defineProperty(e, r, t) {
    return (r = $g3TwN(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
module.exports = $1fdccd57615a7149$var$_defineProperty, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("g3TwN", function(module, exports) {

var $c63rI = parcelRequire("c63rI");
var $bb17ffdb79fe458d$var$_typeof = $c63rI.default;

var $8rZus = parcelRequire("8rZus");
function $bb17ffdb79fe458d$var$toPropertyKey(t) {
    var i = $8rZus(t, "string");
    return "symbol" == $bb17ffdb79fe458d$var$_typeof(i) ? i : i + "";
}
module.exports = $bb17ffdb79fe458d$var$toPropertyKey, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("c63rI", function(module, exports) {
function $8ce8b7df62b427d5$var$_typeof(o) {
    "@babel/helpers - typeof";
    return module.exports = $8ce8b7df62b427d5$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $8ce8b7df62b427d5$var$_typeof(o);
}
module.exports = $8ce8b7df62b427d5$var$_typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("8rZus", function(module, exports) {

var $c63rI = parcelRequire("c63rI");
var $62708b02f15064e7$var$_typeof = $c63rI.default;
function $62708b02f15064e7$var$toPrimitive(t, r) {
    if ("object" != $62708b02f15064e7$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $62708b02f15064e7$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
module.exports = $62708b02f15064e7$var$toPrimitive, module.exports.__esModule = true, module.exports["default"] = module.exports;

});




parcelRegister("5dSyV", function(module, exports) {

var $8Rp6O = parcelRequire("8Rp6O");
function $3cd87d906c3c17b9$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $8Rp6O(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t["return"] || t["return"]();
            } finally{
                if (u) throw o;
            }
        }
    };
}
module.exports = $3cd87d906c3c17b9$var$_createForOfIteratorHelper, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("8Rp6O", function(module, exports) {

var $dUIjq = parcelRequire("dUIjq");
function $6736c00cb3b13141$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $dUIjq(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $dUIjq(r, a) : void 0;
    }
}
module.exports = $6736c00cb3b13141$var$_unsupportedIterableToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("dUIjq", function(module, exports) {
function $a212e0d9fe8d9ff3$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
module.exports = $a212e0d9fe8d9ff3$var$_arrayLikeToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});




parcelRegister("iUq0k", function(module, exports) {
'use strict';

var $adnaT = parcelRequire("adnaT");
var $dc41a0e004a57f48$var$getFragmentVariables = $adnaT.getFragmentVariables;

var $ezyIu = parcelRequire("ezyIu");
var $dc41a0e004a57f48$var$CLIENT_EDGE_TRAVERSAL_PATH = $ezyIu.CLIENT_EDGE_TRAVERSAL_PATH, $dc41a0e004a57f48$var$FRAGMENT_OWNER_KEY = $ezyIu.FRAGMENT_OWNER_KEY, $dc41a0e004a57f48$var$FRAGMENT_POINTER_IS_WITHIN_UNMATCHED_TYPE_REFINEMENT = $ezyIu.FRAGMENT_POINTER_IS_WITHIN_UNMATCHED_TYPE_REFINEMENT, $dc41a0e004a57f48$var$FRAGMENTS_KEY = $ezyIu.FRAGMENTS_KEY, $dc41a0e004a57f48$var$ID_KEY = $ezyIu.ID_KEY;

var $bke7t = parcelRequire("bke7t");

var $jSI6G = parcelRequire("jSI6G");
parcelRequire("2OmBw");
function $dc41a0e004a57f48$var$getSingularSelector(fragment, item) {
    !(typeof item === 'object' && item !== null && !Array.isArray(item)) && $jSI6G(false);
    var dataID = item[$dc41a0e004a57f48$var$ID_KEY];
    var fragments = item[$dc41a0e004a57f48$var$FRAGMENTS_KEY];
    var mixedOwner = item[$dc41a0e004a57f48$var$FRAGMENT_OWNER_KEY];
    var mixedClientEdgeTraversalPath = item[$dc41a0e004a57f48$var$CLIENT_EDGE_TRAVERSAL_PATH];
    if (typeof dataID === 'string' && typeof fragments === 'object' && fragments !== null && typeof fragments[fragment.name] === 'object' && fragments[fragment.name] !== null && typeof mixedOwner === 'object' && mixedOwner !== null && (mixedClientEdgeTraversalPath == null || Array.isArray(mixedClientEdgeTraversalPath))) {
        var owner = mixedOwner;
        var clientEdgeTraversalPath = mixedClientEdgeTraversalPath;
        var argumentVariables = fragments[fragment.name];
        var fragmentVariables = $dc41a0e004a57f48$var$getFragmentVariables(fragment, owner.variables, argumentVariables);
        var isWithinUnmatchedTypeRefinement = argumentVariables[$dc41a0e004a57f48$var$FRAGMENT_POINTER_IS_WITHIN_UNMATCHED_TYPE_REFINEMENT] === true;
        return $dc41a0e004a57f48$var$createReaderSelector(fragment, dataID, fragmentVariables, owner, isWithinUnmatchedTypeRefinement, clientEdgeTraversalPath);
    }
    var stringifiedItem;
    return null;
}
function $dc41a0e004a57f48$var$getPluralSelector(fragment, items) {
    var selectors = null;
    items.forEach(function(item, ii) {
        var selector = item != null ? $dc41a0e004a57f48$var$getSingularSelector(fragment, item) : null;
        if (selector != null) {
            selectors = selectors || [];
            selectors.push(selector);
        }
    });
    if (selectors == null) return null;
    else return {
        kind: 'PluralReaderSelector',
        selectors: selectors
    };
}
function $dc41a0e004a57f48$var$getSelector(fragment, item) {
    if (item == null) return item;
    else if (fragment.metadata && fragment.metadata.plural === true) {
        !Array.isArray(item) && $jSI6G(false);
        return $dc41a0e004a57f48$var$getPluralSelector(fragment, item);
    } else {
        !!Array.isArray(item) && $jSI6G(false);
        return $dc41a0e004a57f48$var$getSingularSelector(fragment, item);
    }
}
function $dc41a0e004a57f48$var$getSelectorsFromObject(fragments, object) {
    var selectors = {};
    for(var key in fragments)if (fragments.hasOwnProperty(key)) {
        var fragment = fragments[key];
        var item = object[key];
        selectors[key] = $dc41a0e004a57f48$var$getSelector(fragment, item);
    }
    return selectors;
}
function $dc41a0e004a57f48$var$getDataIDsFromObject(fragments, object) {
    var ids = {};
    for(var key in fragments)if (fragments.hasOwnProperty(key)) {
        var fragment = fragments[key];
        var item = object[key];
        ids[key] = $dc41a0e004a57f48$var$getDataIDsFromFragment(fragment, item);
    }
    return ids;
}
function $dc41a0e004a57f48$var$getDataIDsFromFragment(fragment, item) {
    if (item == null) return item;
    else if (fragment.metadata && fragment.metadata.plural === true) {
        !Array.isArray(item) && $jSI6G(false);
        return $dc41a0e004a57f48$var$getDataIDs(fragment, item);
    } else {
        !!Array.isArray(item) && $jSI6G(false);
        return $dc41a0e004a57f48$var$getDataID(fragment, item);
    }
}
function $dc41a0e004a57f48$var$getDataIDs(fragment, items) {
    var ids = null;
    items.forEach(function(item) {
        var id = item != null ? $dc41a0e004a57f48$var$getDataID(fragment, item) : null;
        if (id != null) {
            ids = ids || [];
            ids.push(id);
        }
    });
    return ids;
}
function $dc41a0e004a57f48$var$getDataID(fragment, item) {
    !(typeof item === 'object' && item !== null && !Array.isArray(item)) && $jSI6G(false);
    var dataID = item[$dc41a0e004a57f48$var$ID_KEY];
    if (typeof dataID === 'string') return dataID;
    return null;
}
function $dc41a0e004a57f48$var$getVariablesFromObject(fragments, object) {
    var variables = {};
    for(var key in fragments)if (fragments.hasOwnProperty(key)) {
        var fragment = fragments[key];
        var item = object[key];
        var itemVariables = $dc41a0e004a57f48$var$getVariablesFromFragment(fragment, item);
        Object.assign(variables, itemVariables);
    }
    return variables;
}
function $dc41a0e004a57f48$var$getVariablesFromFragment(fragment, item) {
    var _fragment$metadata;
    if (item == null) return {};
    else if (((_fragment$metadata = fragment.metadata) === null || _fragment$metadata === void 0 ? void 0 : _fragment$metadata.plural) === true) {
        !Array.isArray(item) && $jSI6G(false);
        return $dc41a0e004a57f48$var$getVariablesFromPluralFragment(fragment, item);
    } else {
        !!Array.isArray(item) && $jSI6G(false);
        return $dc41a0e004a57f48$var$getVariablesFromSingularFragment(fragment, item) || {};
    }
}
function $dc41a0e004a57f48$var$getVariablesFromSingularFragment(fragment, item) {
    var selector = $dc41a0e004a57f48$var$getSingularSelector(fragment, item);
    if (!selector) return null;
    return selector.variables;
}
function $dc41a0e004a57f48$var$getVariablesFromPluralFragment(fragment, items) {
    var variables = {};
    items.forEach(function(value, ii) {
        if (value != null) {
            var itemVariables = $dc41a0e004a57f48$var$getVariablesFromSingularFragment(fragment, value);
            if (itemVariables != null) Object.assign(variables, itemVariables);
        }
    });
    return variables;
}
function $dc41a0e004a57f48$var$areEqualSingularSelectors(thisSelector, thatSelector) {
    return thisSelector.dataID === thatSelector.dataID && thisSelector.node === thatSelector.node && $bke7t(thisSelector.variables, thatSelector.variables) && $dc41a0e004a57f48$var$areEqualOwners(thisSelector.owner, thatSelector.owner) && thisSelector.isWithinUnmatchedTypeRefinement === thatSelector.isWithinUnmatchedTypeRefinement && $dc41a0e004a57f48$var$areEqualClientEdgeTraversalPaths(thisSelector.clientEdgeTraversalPath, thatSelector.clientEdgeTraversalPath);
}
function $dc41a0e004a57f48$var$areEqualOwners(thisOwner, thatOwner) {
    if (thisOwner === thatOwner) return true;
    else return thisOwner.identifier === thatOwner.identifier && $bke7t(thisOwner.cacheConfig, thatOwner.cacheConfig);
}
function $dc41a0e004a57f48$var$areEqualClientEdgeTraversalPaths(thisPath, thatPath) {
    if (thisPath === thatPath) return true;
    if (thisPath == null || thatPath == null || thisPath.length !== thatPath.length) return false;
    var idx = thisPath.length;
    while(idx--){
        var a = thisPath[idx];
        var b = thatPath[idx];
        if (a === b) continue;
        if (a == null || b == null || a.clientEdgeDestinationID !== b.clientEdgeDestinationID || a.readerClientEdge !== b.readerClientEdge) return false;
    }
    return true;
}
function $dc41a0e004a57f48$var$areEqualSelectors(a, b) {
    if (a === b) return true;
    else if (a == null) return b == null;
    else if (b == null) return a == null;
    else if (a.kind === 'SingularReaderSelector' && b.kind === 'SingularReaderSelector') return $dc41a0e004a57f48$var$areEqualSingularSelectors(a, b);
    else if (a.kind === 'PluralReaderSelector' && b.kind === 'PluralReaderSelector') return a.selectors.length === b.selectors.length && a.selectors.every(function(s, i) {
        return $dc41a0e004a57f48$var$areEqualSingularSelectors(s, b.selectors[i]);
    });
    else return false;
}
function $dc41a0e004a57f48$var$createReaderSelector(fragment, dataID, variables, request) {
    var isWithinUnmatchedTypeRefinement = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
    var clientEdgeTraversalPath = arguments.length > 5 ? arguments[5] : undefined;
    return {
        clientEdgeTraversalPath: clientEdgeTraversalPath !== null && clientEdgeTraversalPath !== void 0 ? clientEdgeTraversalPath : null,
        dataID: dataID,
        isWithinUnmatchedTypeRefinement: isWithinUnmatchedTypeRefinement,
        kind: 'SingularReaderSelector',
        node: fragment,
        owner: request,
        variables: variables
    };
}
function $dc41a0e004a57f48$var$createNormalizationSelector(node, dataID, variables) {
    return {
        dataID: dataID,
        node: node,
        variables: variables
    };
}
module.exports = {
    areEqualSelectors: $dc41a0e004a57f48$var$areEqualSelectors,
    createNormalizationSelector: $dc41a0e004a57f48$var$createNormalizationSelector,
    createReaderSelector: $dc41a0e004a57f48$var$createReaderSelector,
    getDataIDsFromFragment: $dc41a0e004a57f48$var$getDataIDsFromFragment,
    getDataIDsFromObject: $dc41a0e004a57f48$var$getDataIDsFromObject,
    getPluralSelector: $dc41a0e004a57f48$var$getPluralSelector,
    getSelector: $dc41a0e004a57f48$var$getSelector,
    getSelectorsFromObject: $dc41a0e004a57f48$var$getSelectorsFromObject,
    getSingularSelector: $dc41a0e004a57f48$var$getSingularSelector,
    getVariablesFromFragment: $dc41a0e004a57f48$var$getVariablesFromFragment,
    getVariablesFromObject: $dc41a0e004a57f48$var$getVariablesFromObject,
    getVariablesFromPluralFragment: $dc41a0e004a57f48$var$getVariablesFromPluralFragment,
    getVariablesFromSingularFragment: $dc41a0e004a57f48$var$getVariablesFromSingularFragment
};

});
parcelRegister("adnaT", function(module, exports) {
'use strict';

var $e27SU = parcelRequire("e27SU");
var $76fd184aee81c490$var$_interopRequireDefault = $e27SU.default;

var $76fd184aee81c490$var$_objectSpread2 = $76fd184aee81c490$var$_interopRequireDefault((parcelRequire("caqem")));

var $ezyIu = parcelRequire("ezyIu");
var $76fd184aee81c490$var$getArgumentValues = $ezyIu.getArgumentValues;

var $jSI6G = parcelRequire("jSI6G");
function $76fd184aee81c490$var$getFragmentVariables(fragment, rootVariables, argumentVariables) {
    if (fragment.argumentDefinitions == null) return argumentVariables;
    var variables;
    fragment.argumentDefinitions.forEach(function(definition) {
        if (argumentVariables.hasOwnProperty(definition.name)) return;
        variables = variables || (0, $76fd184aee81c490$var$_objectSpread2["default"])({}, argumentVariables);
        switch(definition.kind){
            case 'LocalArgument':
                variables[definition.name] = definition.defaultValue;
                break;
            case 'RootArgument':
                if (!rootVariables.hasOwnProperty(definition.name)) {
                    variables[definition.name] = undefined;
                    break;
                }
                variables[definition.name] = rootVariables[definition.name];
                break;
            default:
                definition;
                $jSI6G(false);
        }
    });
    return variables || argumentVariables;
}
function $76fd184aee81c490$var$getOperationVariables(operation, providedVariables, variables) {
    var operationVariables = {};
    operation.argumentDefinitions.forEach(function(def) {
        var value = def.defaultValue;
        if (variables[def.name] != null) value = variables[def.name];
        operationVariables[def.name] = value;
    });
    if (providedVariables != null) Object.keys(providedVariables).forEach(function(varName) {
        operationVariables[varName] = providedVariables[varName].get();
    });
    return operationVariables;
}
function $76fd184aee81c490$var$getLocalVariables(currentVariables, argumentDefinitions, args) {
    if (argumentDefinitions == null) return currentVariables;
    var nextVariables = (0, $76fd184aee81c490$var$_objectSpread2["default"])({}, currentVariables);
    var nextArgs = args ? $76fd184aee81c490$var$getArgumentValues(args, currentVariables) : {};
    argumentDefinitions.forEach(function(def) {
        var _nextArgs$def$name;
        var value = (_nextArgs$def$name = nextArgs[def.name]) !== null && _nextArgs$def$name !== void 0 ? _nextArgs$def$name : def.defaultValue;
        nextVariables[def.name] = value;
    });
    return nextVariables;
}
module.exports = {
    getFragmentVariables: $76fd184aee81c490$var$getFragmentVariables,
    getLocalVariables: $76fd184aee81c490$var$getLocalVariables,
    getOperationVariables: $76fd184aee81c490$var$getOperationVariables
};

});
parcelRegister("ezyIu", function(module, exports) {
'use strict';

var $e27SU = parcelRequire("e27SU");
var $a9bf438bdadd9461$var$_interopRequireDefault = $e27SU.default;

var $a9bf438bdadd9461$var$_toConsumableArray2 = $a9bf438bdadd9461$var$_interopRequireDefault((parcelRequire("lLsx3")));

var $fFdd7 = parcelRequire("fFdd7");

var $fT3Ou = parcelRequire("fT3Ou");

var $gZYpt = parcelRequire("gZYpt");

var $4hUjJ = parcelRequire("4hUjJ");
var $a9bf438bdadd9461$var$stableCopy = $4hUjJ.stableCopy;

var $jSI6G = parcelRequire("jSI6G");
var $a9bf438bdadd9461$var$VARIABLE = $fT3Ou.VARIABLE, $a9bf438bdadd9461$var$LITERAL = $fT3Ou.LITERAL, $a9bf438bdadd9461$var$OBJECT_VALUE = $fT3Ou.OBJECT_VALUE, $a9bf438bdadd9461$var$LIST_VALUE = $fT3Ou.LIST_VALUE;
var $a9bf438bdadd9461$var$ERRORS_KEY = '__errors';
var $a9bf438bdadd9461$var$FIELD_GRANULAR_NOTIFICATIONS_KEY = '__fieldGranularNotifications';
var $a9bf438bdadd9461$var$MODULE_COMPONENT_KEY_PREFIX = '__module_component_';
var $a9bf438bdadd9461$var$MODULE_OPERATION_KEY_PREFIX = '__module_operation_';
var $a9bf438bdadd9461$var$RELAY_READ_TIME_RESOLVER_KEY_PREFIX = '$r:';
function $a9bf438bdadd9461$var$getArgumentValue(arg, variables) {
    if (arg.kind === $a9bf438bdadd9461$var$VARIABLE) return $a9bf438bdadd9461$var$getStableVariableValue(arg.variableName, variables);
    else if (arg.kind === $a9bf438bdadd9461$var$LITERAL) return arg.value;
    else if (arg.kind === $a9bf438bdadd9461$var$OBJECT_VALUE) {
        var value = {};
        arg.fields.forEach(function(field) {
            value[field.name] = $a9bf438bdadd9461$var$getArgumentValue(field, variables);
        });
        return value;
    } else if (arg.kind === $a9bf438bdadd9461$var$LIST_VALUE) {
        var _value = [];
        arg.items.forEach(function(item) {
            item != null && _value.push($a9bf438bdadd9461$var$getArgumentValue(item, variables));
        });
        return _value;
    }
}
function $a9bf438bdadd9461$var$getArgumentValues(args, variables, isWithinUnmatchedTypeRefinement) {
    var values = {};
    if (isWithinUnmatchedTypeRefinement) values[$a9bf438bdadd9461$var$RelayStoreUtils.FRAGMENT_POINTER_IS_WITHIN_UNMATCHED_TYPE_REFINEMENT] = true;
    if (args) args.forEach(function(arg) {
        values[arg.name] = $a9bf438bdadd9461$var$getArgumentValue(arg, variables);
    });
    return values;
}
function $a9bf438bdadd9461$var$getHandleStorageKey(handleField, variables) {
    var dynamicKey = handleField.dynamicKey, handle = handleField.handle, key = handleField.key, name = handleField.name, args = handleField.args, filters = handleField.filters;
    var handleName = $fFdd7(handle, key, name);
    var filterArgs = null;
    if (args && filters && args.length !== 0 && filters.length !== 0) filterArgs = args.filter(function(arg) {
        return filters.indexOf(arg.name) > -1;
    });
    if (dynamicKey) filterArgs = filterArgs != null ? [
        dynamicKey
    ].concat((0, $a9bf438bdadd9461$var$_toConsumableArray2["default"])(filterArgs)) : [
        dynamicKey
    ];
    if (filterArgs === null) return handleName;
    else return $a9bf438bdadd9461$var$formatStorageKey(handleName, $a9bf438bdadd9461$var$getArgumentValues(filterArgs, variables));
}
function $a9bf438bdadd9461$var$getStorageKey(field, variables) {
    if (field.storageKey) return field.storageKey;
    var args = $a9bf438bdadd9461$var$getArguments(field);
    var name = field.name;
    return args && args.length !== 0 ? $a9bf438bdadd9461$var$formatStorageKey(name, $a9bf438bdadd9461$var$getArgumentValues(args, variables)) : name;
}
function $a9bf438bdadd9461$var$getReadTimeResolverStorageKey(field, variables) {
    var storageKey = $a9bf438bdadd9461$var$getStorageKey(field, variables);
    return $gZYpt.ENABLE_READ_TIME_RESOLVER_STORAGE_KEY_PREFIX ? '$r:' + storageKey : storageKey;
}
function $a9bf438bdadd9461$var$getArguments(field) {
    if (field.kind === 'RelayResolver' || field.kind === 'RelayLiveResolver') {
        var _field$fragment2;
        if (field.args == null) {
            var _field$fragment;
            return (_field$fragment = field.fragment) === null || _field$fragment === void 0 ? void 0 : _field$fragment.args;
        }
        if (((_field$fragment2 = field.fragment) === null || _field$fragment2 === void 0 ? void 0 : _field$fragment2.args) == null) return field.args;
        return field.args.concat(field.fragment.args);
    }
    var args = typeof field.args === 'undefined' ? undefined : field.args;
    return args;
}
function $a9bf438bdadd9461$var$getStableStorageKey(name, args) {
    return $a9bf438bdadd9461$var$formatStorageKey(name, $a9bf438bdadd9461$var$stableCopy(args));
}
function $a9bf438bdadd9461$var$formatStorageKey(name, argValues) {
    if (!argValues) return name;
    var values = [];
    for(var argName in argValues)if (argValues.hasOwnProperty(argName)) {
        var value = argValues[argName];
        if (value != null) {
            var _JSON$stringify;
            values.push(argName + ':' + ((_JSON$stringify = JSON.stringify(value)) !== null && _JSON$stringify !== void 0 ? _JSON$stringify : 'undefined'));
        }
    }
    return values.length === 0 ? name : name + "(".concat(values.join(','), ")");
}
function $a9bf438bdadd9461$var$getStableVariableValue(name, variables) {
    !variables.hasOwnProperty(name) && $jSI6G(false);
    return $a9bf438bdadd9461$var$stableCopy(variables[name]);
}
function $a9bf438bdadd9461$var$getModuleComponentKey(documentName) {
    return "".concat($a9bf438bdadd9461$var$MODULE_COMPONENT_KEY_PREFIX).concat(documentName);
}
function $a9bf438bdadd9461$var$getModuleOperationKey(documentName) {
    return "".concat($a9bf438bdadd9461$var$MODULE_OPERATION_KEY_PREFIX).concat(documentName);
}
function $a9bf438bdadd9461$var$getFieldNotificationKey(dataID, storageKey) {
    return "__fn:".concat(dataID, ":").concat(storageKey);
}
var $a9bf438bdadd9461$var$RelayStoreUtils = {
    ACTOR_IDENTIFIER_KEY: '__actorIdentifier',
    CLIENT_EDGE_TRAVERSAL_PATH: '__clientEdgeTraversalPath',
    FRAGMENTS_KEY: '__fragments',
    FRAGMENT_OWNER_KEY: '__fragmentOwner',
    FRAGMENT_POINTER_IS_WITHIN_UNMATCHED_TYPE_REFINEMENT: '$isWithinUnmatchedTypeRefinement',
    FRAGMENT_PROP_NAME_KEY: '__fragmentPropName',
    MODULE_COMPONENT_KEY: '__module_component',
    ERRORS_KEY: $a9bf438bdadd9461$var$ERRORS_KEY,
    FIELD_GRANULAR_NOTIFICATIONS_KEY: $a9bf438bdadd9461$var$FIELD_GRANULAR_NOTIFICATIONS_KEY,
    ID_KEY: '__id',
    REF_KEY: '__ref',
    REFS_KEY: '__refs',
    ROOT_ID: 'client:root',
    ROOT_TYPE: '__Root',
    TYPENAME_KEY: '__typename',
    INVALIDATED_AT_KEY: '__invalidated_at',
    RELAY_RESOLVER_VALUE_KEY: '__resolverValue',
    RELAY_RESOLVER_INVALIDATION_KEY: '__resolverValueMayBeInvalid',
    RELAY_RESOLVER_SNAPSHOT_KEY: '__resolverSnapshot',
    RELAY_RESOLVER_ERROR_KEY: '__resolverError',
    RELAY_RESOLVER_OUTPUT_TYPE_RECORD_IDS: '__resolverOutputTypeRecordIDs',
    RELAY_RESOLVER_RECORD_TYPENAME: '__RELAY_RESOLVER__',
    RELAY_READ_TIME_RESOLVER_KEY_PREFIX: $a9bf438bdadd9461$var$RELAY_READ_TIME_RESOLVER_KEY_PREFIX,
    formatStorageKey: $a9bf438bdadd9461$var$formatStorageKey,
    getArgumentValue: $a9bf438bdadd9461$var$getArgumentValue,
    getArgumentValues: $a9bf438bdadd9461$var$getArgumentValues,
    getHandleStorageKey: $a9bf438bdadd9461$var$getHandleStorageKey,
    getStorageKey: $a9bf438bdadd9461$var$getStorageKey,
    getReadTimeResolverStorageKey: $a9bf438bdadd9461$var$getReadTimeResolverStorageKey,
    getStableStorageKey: $a9bf438bdadd9461$var$getStableStorageKey,
    getModuleComponentKey: $a9bf438bdadd9461$var$getModuleComponentKey,
    getModuleOperationKey: $a9bf438bdadd9461$var$getModuleOperationKey,
    getFieldNotificationKey: $a9bf438bdadd9461$var$getFieldNotificationKey
};
module.exports = $a9bf438bdadd9461$var$RelayStoreUtils;

});
parcelRegister("lLsx3", function(module, exports) {

var $cNtsb = parcelRequire("cNtsb");

var $htuhV = parcelRequire("htuhV");

var $8Rp6O = parcelRequire("8Rp6O");

var $9HufL = parcelRequire("9HufL");
function $fd841ea06ec75907$var$_toConsumableArray(r) {
    return $cNtsb(r) || $htuhV(r) || $8Rp6O(r) || $9HufL();
}
module.exports = $fd841ea06ec75907$var$_toConsumableArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("cNtsb", function(module, exports) {

var $dUIjq = parcelRequire("dUIjq");
function $9510e87ae10c872f$var$_arrayWithoutHoles(r) {
    if (Array.isArray(r)) return $dUIjq(r);
}
module.exports = $9510e87ae10c872f$var$_arrayWithoutHoles, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("htuhV", function(module, exports) {
function $cb8ca3b6f3a0d77f$var$_iterableToArray(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}
module.exports = $cb8ca3b6f3a0d77f$var$_iterableToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("9HufL", function(module, exports) {
function $70ff98e656cc9344$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
module.exports = $70ff98e656cc9344$var$_nonIterableSpread, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("fFdd7", function(module, exports) {
'use strict';

var $4cBjc = parcelRequire("4cBjc");
var $b674eeb587fe88fe$var$DEFAULT_HANDLE_KEY = $4cBjc.DEFAULT_HANDLE_KEY;

var $jSI6G = parcelRequire("jSI6G");
function $b674eeb587fe88fe$var$getRelayHandleKey(handleName, key, fieldName) {
    if (key && key !== $b674eeb587fe88fe$var$DEFAULT_HANDLE_KEY) return "__".concat(key, "_").concat(handleName);
    !(fieldName != null) && $jSI6G(false);
    return "__".concat(fieldName, "_").concat(handleName);
}
module.exports = $b674eeb587fe88fe$var$getRelayHandleKey;

});
parcelRegister("4cBjc", function(module, exports) {
'use strict';
module.exports = {
    DEFAULT_HANDLE_KEY: ''
};

});


parcelRegister("gZYpt", function(module, exports) {
'use strict';
var $c60133f7d0b3609b$var$RelayFeatureFlags = {
    ENABLE_VARIABLE_CONNECTION_KEY: false,
    ENABLE_RELAY_RESOLVERS: false,
    ENABLE_GETFRAGMENTIDENTIFIER_OPTIMIZATION: false,
    ENABLE_FRIENDLY_QUERY_NAME_GQL_URL: false,
    ENABLE_DO_NOT_WRAP_LIVE_QUERY: false,
    ENABLE_NOTIFY_SUBSCRIPTION: false,
    BATCH_ASYNC_MODULE_UPDATES_FN: null,
    ENABLE_CONTAINERS_SUBSCRIBE_ON_COMMIT: false,
    MAX_DATA_ID_LENGTH: null,
    STRING_INTERN_LEVEL: 0,
    LOG_MISSING_RECORDS_IN_PROD: false,
    ENABLE_STORE_ID_COLLISION_LOGGING: false,
    ENABLE_NONCOMPLIANT_ERROR_HANDLING_ON_LISTS: false,
    ENABLE_LOOSE_SUBSCRIPTION_ATTRIBUTION: false,
    ENABLE_OPERATION_TRACKER_OPTIMISTIC_UPDATES: false,
    ENABLE_RELAY_OPERATION_TRACKER_SUSPENSE: false,
    PROCESS_OPTIMISTIC_UPDATE_BEFORE_SUBSCRIPTION: false,
    MARK_RESOLVER_VALUES_AS_CLEAN_AFTER_FRAGMENT_REREAD: false,
    ENABLE_CYLE_DETECTION_IN_VARIABLES: false,
    ENABLE_ACTIVITY_COMPATIBILITY: true,
    ENABLE_READ_TIME_RESOLVER_STORAGE_KEY_PREFIX: true,
    ENABLE_USE_PAGINATION_IS_LOADING_FIX: false,
    DISALLOW_NESTED_UPDATES: false,
    ENABLE_TYPENAME_PREFIXED_DATA_ID: false,
    ENABLE_UI_CONTEXT_ON_RELAY_LOGGER: false,
    CHECK_ALL_FRAGMENTS_FOR_MISSING_CLIENT_EDGES: false,
    FILTER_OUT_RELAY_RESOLVER_RECORDS: false,
    OPTIMIZE_NOTIFY: false,
    ENABLE_FIELD_GRANULAR_NOTIFICATIONS: false,
    ENABLE_READER_FRAGMENTS_LOGGING: false
};
module.exports = $c60133f7d0b3609b$var$RelayFeatureFlags;

});

parcelRegister("4hUjJ", function(module, exports) {
'use strict';
function $31f46f686908674d$var$stableCopy(value) {
    if (!value || typeof value !== 'object') return value;
    if (Array.isArray(value)) return value.map($31f46f686908674d$var$stableCopy);
    var keys = Object.keys(value).sort();
    var stable = {};
    for(var i = 0; i < keys.length; i++)stable[keys[i]] = $31f46f686908674d$var$stableCopy(value[keys[i]]);
    return stable;
}
function $31f46f686908674d$var$hasCycle(value) {
    var parents = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new Set();
    if (!value || typeof value !== 'object') return false;
    if (parents.has(value)) return true;
    var newParents = new Set(parents);
    newParents.add(value);
    var children = Array.isArray(value) ? value : Object.values(value);
    return children.some(function(v) {
        return $31f46f686908674d$var$hasCycle(v, newParents);
    });
}
module.exports = {
    hasCycle: $31f46f686908674d$var$hasCycle,
    stableCopy: $31f46f686908674d$var$stableCopy
};

});



parcelRegister("bke7t", function(module, exports) {
"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */ var $83ec83cceea112d9$var$aStackPool = [];
var $83ec83cceea112d9$var$bStackPool = [];
/**
 * Checks if two values are equal. Values may be primitives, arrays, or objects.
 * Returns true if both arguments have the same keys and values.
 *
 * @see http://underscorejs.org
 * @copyright 2009-2013 Jeremy Ashkenas, DocumentCloud Inc.
 * @license MIT
 */ function $83ec83cceea112d9$var$areEqual(a, b) {
    var aStack = $83ec83cceea112d9$var$aStackPool.length ? $83ec83cceea112d9$var$aStackPool.pop() : [];
    var bStack = $83ec83cceea112d9$var$bStackPool.length ? $83ec83cceea112d9$var$bStackPool.pop() : [];
    var result = $83ec83cceea112d9$var$eq(a, b, aStack, bStack);
    aStack.length = 0;
    bStack.length = 0;
    $83ec83cceea112d9$var$aStackPool.push(aStack);
    $83ec83cceea112d9$var$bStackPool.push(bStack);
    return result;
}
function $83ec83cceea112d9$var$eq(a, b, aStack, bStack) {
    if (a === b) // Identical objects are equal. `0 === -0`, but they aren't identical.
    return a !== 0 || 1 / a == 1 / b;
    if (a == null || b == null) // a or b can be `null` or `undefined`
    return false;
    if (typeof a != 'object' || typeof b != 'object') return false;
    var objToStr = Object.prototype.toString;
    var className = objToStr.call(a);
    if (className != objToStr.call(b)) return false;
    switch(className){
        case '[object String]':
            return a == String(b);
        case '[object Number]':
            return isNaN(a) || isNaN(b) ? false : a == Number(b);
        case '[object Date]':
        case '[object Boolean]':
            return +a == +b;
        case '[object RegExp]':
            return a.source == b.source && a.global == b.global && a.multiline == b.multiline && a.ignoreCase == b.ignoreCase;
    } // Assume equality for cyclic structures.
    var length = aStack.length;
    while(length--){
        if (aStack[length] == a) return bStack[length] == b;
    }
    aStack.push(a);
    bStack.push(b);
    var size = 0; // Recursively compare objects and arrays.
    if (className === '[object Array]') {
        size = a.length;
        if (size !== b.length) return false;
         // Deep compare the contents, ignoring non-numeric properties.
        while(size--){
            if (!$83ec83cceea112d9$var$eq(a[size], b[size], aStack, bStack)) return false;
        }
    } else {
        if (a.constructor !== b.constructor) return false;
        if (a.hasOwnProperty('valueOf') && b.hasOwnProperty('valueOf')) return a.valueOf() == b.valueOf();
        var keys = Object.keys(a);
        if (keys.length != Object.keys(b).length) return false;
        for(var i = 0; i < keys.length; i++){
            if (!$83ec83cceea112d9$var$eq(a[keys[i]], b[keys[i]], aStack, bStack)) return false;
        }
    }
    aStack.pop();
    bStack.pop();
    return true;
}
module.exports = $83ec83cceea112d9$var$areEqual;

});




parcelRegister("inpeC", function(module, exports) {
"use strict";

var $e27SU = parcelRequire("e27SU");
var $d60df3156ccad561$var$_interopRequireDefault = $e27SU.default;

var $dkCvo = parcelRequire("dkCvo");
var $d60df3156ccad561$require$_asyncToGenerator = $dkCvo.default;

var $d60df3156ccad561$var$_createForOfIteratorHelper2 = $d60df3156ccad561$var$_interopRequireDefault((parcelRequire("5dSyV")));

var $5bMXV = parcelRequire("5bMXV");

var $3hl6N = parcelRequire("3hl6N");
var $d60df3156ccad561$var$getObservableForActiveRequest = $3hl6N.getObservableForActiveRequest;

var $kLQDK = parcelRequire("kLQDK");
var $d60df3156ccad561$var$getFragment = $kLQDK.getFragment;

var $ihTWZ = parcelRequire("ihTWZ");
var $d60df3156ccad561$var$handlePotentialSnapshotErrors = $ihTWZ.handlePotentialSnapshotErrors;

var $iUq0k = parcelRequire("iUq0k");
var $d60df3156ccad561$var$getSelector = $iUq0k.getSelector;

var $jSI6G = parcelRequire("jSI6G");
function $d60df3156ccad561$var$waitForFragmentData(_x, _x2, _x3) {
    return $d60df3156ccad561$var$_waitForFragmentData.apply(this, arguments);
}
function $d60df3156ccad561$var$_waitForFragmentData() {
    $d60df3156ccad561$var$_waitForFragmentData = $d60df3156ccad561$require$_asyncToGenerator(function*(environment, fragment, fragmentRef) {
        var subscription;
        try {
            var _subscription;
            var data = yield new Promise(function(resolve, reject) {
                subscription = $d60df3156ccad561$var$observeFragment(environment, fragment, fragmentRef).subscribe({
                    next: function next(val) {
                        if (val.state === 'ok') resolve(val.value);
                        else if (val.state === 'error') reject(val.error);
                    }
                });
            });
            (_subscription = subscription) === null || _subscription === void 0 || _subscription.unsubscribe();
            return data;
        } catch (e) {
            var _subscription2;
            (_subscription2 = subscription) === null || _subscription2 === void 0 || _subscription2.unsubscribe();
            throw e;
        }
    });
    return $d60df3156ccad561$var$_waitForFragmentData.apply(this, arguments);
}
function $d60df3156ccad561$var$observeFragment(environment, fragment, fragmentRef) {
    var _fragmentNode$metadat;
    var fragmentNode = $d60df3156ccad561$var$getFragment(fragment);
    var fragmentSelector = $d60df3156ccad561$var$getSelector(fragmentNode, fragmentRef);
    !(fragmentSelector != null) && $jSI6G(false);
    !(((_fragmentNode$metadat = fragmentNode.metadata) === null || _fragmentNode$metadat === void 0 ? void 0 : _fragmentNode$metadat.hasClientEdges) == null || $d60df3156ccad561$var$fragmentSelectorUsesExecTimeResolver(fragmentSelector)) && $jSI6G(false);
    switch(fragmentSelector.kind){
        case 'SingularReaderSelector':
            return $d60df3156ccad561$var$observeSingularSelector(environment, fragment, fragmentSelector);
        case 'PluralReaderSelector':
            return $d60df3156ccad561$var$observePluralSelector(environment, fragment, fragmentSelector);
    }
    $jSI6G(false);
}
function $d60df3156ccad561$var$fragmentSelectorUsesExecTimeResolver(fragmentSelector) {
    var _fragmentSelector$own, _fragmentSelector$own2, _fragmentSelector$own3, _fragmentSelector$own4;
    switch(fragmentSelector === null || fragmentSelector === void 0 ? void 0 : fragmentSelector.kind){
        case 'SingularReaderSelector':
            return ((_fragmentSelector$own = (_fragmentSelector$own2 = fragmentSelector.owner.node.operation) === null || _fragmentSelector$own2 === void 0 ? void 0 : _fragmentSelector$own2.use_exec_time_resolvers) !== null && _fragmentSelector$own !== void 0 ? _fragmentSelector$own : (_fragmentSelector$own3 = fragmentSelector.owner.node.operation) === null || _fragmentSelector$own3 === void 0 ? void 0 : (_fragmentSelector$own4 = _fragmentSelector$own3.exec_time_resolvers_enabled_provider) === null || _fragmentSelector$own4 === void 0 ? void 0 : _fragmentSelector$own4.get()) === true;
        case 'PluralReaderSelector':
            var _fragmentSelector$sel;
            return (_fragmentSelector$sel = fragmentSelector.selectors) === null || _fragmentSelector$sel === void 0 ? void 0 : _fragmentSelector$sel.every(function(selector) {
                var _selector$owner$node$, _selector$owner$node$2, _selector$owner$node$3;
                return ((_selector$owner$node$ = selector.owner.node.operation.use_exec_time_resolvers) !== null && _selector$owner$node$ !== void 0 ? _selector$owner$node$ : (_selector$owner$node$2 = selector.owner.node.operation) === null || _selector$owner$node$2 === void 0 ? void 0 : (_selector$owner$node$3 = _selector$owner$node$2.exec_time_resolvers_enabled_provider) === null || _selector$owner$node$3 === void 0 ? void 0 : _selector$owner$node$3.get()) === true;
            });
    }
    return false;
}
function $d60df3156ccad561$var$observeSingularSelector(environment, fragmentNode, fragmentSelector) {
    var snapshot = environment.lookup(fragmentSelector);
    return $5bMXV.create(function(sink) {
        sink.next($d60df3156ccad561$var$snapshotToFragmentState(environment, fragmentNode, fragmentSelector.owner, snapshot));
        var subscription = environment.subscribe(snapshot, function(nextSnapshot) {
            sink.next($d60df3156ccad561$var$snapshotToFragmentState(environment, fragmentNode, fragmentSelector.owner, nextSnapshot));
        });
        return function() {
            return subscription.dispose();
        };
    });
}
function $d60df3156ccad561$var$observePluralSelector(environment, fragmentNode, fragmentSelector) {
    var snapshots = fragmentSelector.selectors.map(function(selector) {
        return environment.lookup(selector);
    });
    return $5bMXV.create(function(sink) {
        var states = snapshots.map(function(snapshot, index) {
            return $d60df3156ccad561$var$snapshotToFragmentState(environment, fragmentNode, fragmentSelector.selectors[index].owner, snapshot);
        });
        sink.next($d60df3156ccad561$var$mergeFragmentStates(states));
        var subscriptions = snapshots.map(function(snapshot, index) {
            return environment.subscribe(snapshot, function(latestSnapshot) {
                states[index] = $d60df3156ccad561$var$snapshotToFragmentState(environment, fragmentNode, fragmentSelector.selectors[index].owner, latestSnapshot);
                sink.next($d60df3156ccad561$var$mergeFragmentStates(states));
            });
        });
        return function() {
            return subscriptions.forEach(function(subscription) {
                return subscription.dispose();
            });
        };
    });
}
function $d60df3156ccad561$var$snapshotToFragmentState(environment, fragmentNode, owner, snapshot) {
    var missingLiveResolverFields = snapshot.missingLiveResolverFields != null && snapshot.missingLiveResolverFields.length > 0;
    var missingClientEdges = snapshot.missingClientEdges != null && snapshot.missingClientEdges.length > 0;
    if (missingLiveResolverFields || missingClientEdges) return {
        state: 'loading'
    };
    if (snapshot.isMissingData) {
        if ($d60df3156ccad561$var$getObservableForActiveRequest(environment, owner) != null || environment.getOperationTracker().getPendingOperationsAffectingOwner(owner) != null) return {
            state: 'loading'
        };
    }
    try {
        $d60df3156ccad561$var$handlePotentialSnapshotErrors(environment, snapshot.fieldErrors);
    } catch (error) {
        return {
            error: error,
            state: 'error'
        };
    }
    !(snapshot.data != null) && $jSI6G(false);
    return {
        state: 'ok',
        value: snapshot.data
    };
}
function $d60df3156ccad561$var$mergeFragmentStates(states) {
    var value = [];
    var _iterator = (0, $d60df3156ccad561$var$_createForOfIteratorHelper2["default"])(states), _step;
    try {
        for(_iterator.s(); !(_step = _iterator.n()).done;){
            var state = _step.value;
            if (state.state === 'ok') value.push(state.value);
            else return state;
        }
    } catch (err) {
        _iterator.e(err);
    } finally{
        _iterator.f();
    }
    return {
        state: 'ok',
        value: value
    };
}
module.exports = {
    observeFragment: $d60df3156ccad561$var$observeFragment,
    waitForFragmentData: $d60df3156ccad561$var$waitForFragmentData
};

});
parcelRegister("dkCvo", function(module, exports) {
function $028135b9c3360102$var$asyncGeneratorStep(n, t, e, r, o, a, c) {
    try {
        var i = n[a](c), u = i.value;
    } catch (n) {
        return void e(n);
    }
    i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function $028135b9c3360102$var$_asyncToGenerator(n) {
    return function() {
        var t = this, e = arguments;
        return new Promise(function(r, o) {
            var a = n.apply(t, e);
            function _next(n) {
                $028135b9c3360102$var$asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
            }
            function _throw(n) {
                $028135b9c3360102$var$asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
            }
            _next(void 0);
        });
    };
}
module.exports = $028135b9c3360102$var$_asyncToGenerator, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("5bMXV", function(module, exports) {
'use strict';

var $gYJUY = parcelRequire("gYJUY");
var $3c73f6609e9a9e0e$var$hostReportError = $3c73f6609e9a9e0e$var$swallowError;
var $3c73f6609e9a9e0e$var$RelayObservable = /*#__PURE__*/ function() {
    RelayObservable.create = function create(source) {
        return new RelayObservable(source);
    };
    function RelayObservable(source) {
        this._source = source;
    }
    RelayObservable.onUnhandledError = function onUnhandledError(callback) {
        $3c73f6609e9a9e0e$var$hostReportError = callback;
    };
    RelayObservable.from = function from(obj) {
        return $3c73f6609e9a9e0e$var$isObservable(obj) ? $3c73f6609e9a9e0e$var$fromObservable(obj) : $gYJUY(obj) ? $3c73f6609e9a9e0e$var$fromPromise(obj) : $3c73f6609e9a9e0e$var$fromValue(obj);
    };
    var _proto = RelayObservable.prototype;
    _proto["catch"] = function _catch(fn) {
        var _this = this;
        return RelayObservable.create(function(sink) {
            var subscription;
            _this.subscribe({
                start: function start(sub) {
                    subscription = sub;
                },
                next: sink.next,
                complete: sink.complete,
                error: function error(_error2) {
                    try {
                        fn(_error2).subscribe({
                            start: function start(sub) {
                                subscription = sub;
                            },
                            next: sink.next,
                            complete: sink.complete,
                            error: sink.error
                        });
                    } catch (error2) {
                        sink.error(error2, true);
                    }
                }
            });
            return function() {
                return subscription.unsubscribe();
            };
        });
    };
    _proto.concat = function concat(next) {
        var _this2 = this;
        return RelayObservable.create(function(sink) {
            var current;
            _this2.subscribe({
                start: function start(subscription) {
                    current = subscription;
                },
                next: sink.next,
                error: sink.error,
                complete: function complete() {
                    current = next.subscribe(sink);
                }
            });
            return function() {
                current && current.unsubscribe();
            };
        });
    };
    _proto["do"] = function _do(observer) {
        var _this3 = this;
        return RelayObservable.create(function(sink) {
            var both = function both(action) {
                return function() {
                    try {
                        observer[action] && observer[action].apply(observer, arguments);
                    } catch (error) {
                        $3c73f6609e9a9e0e$var$hostReportError(error, true);
                    }
                    sink[action] && sink[action].apply(sink, arguments);
                };
            };
            return _this3.subscribe({
                start: both('start'),
                next: both('next'),
                error: both('error'),
                complete: both('complete'),
                unsubscribe: both('unsubscribe')
            });
        });
    };
    _proto["finally"] = function _finally(fn) {
        var _this4 = this;
        return RelayObservable.create(function(sink) {
            var subscription = _this4.subscribe(sink);
            return function() {
                subscription.unsubscribe();
                fn();
            };
        });
    };
    _proto.ifEmpty = function ifEmpty(alternate) {
        var _this5 = this;
        return RelayObservable.create(function(sink) {
            var hasValue = false;
            var current;
            current = _this5.subscribe({
                next: function next(value) {
                    hasValue = true;
                    sink.next(value);
                },
                error: sink.error,
                complete: function complete() {
                    if (hasValue) sink.complete();
                    else current = alternate.subscribe(sink);
                }
            });
            return function() {
                current && current.unsubscribe();
            };
        });
    };
    _proto.subscribe = function subscribe(observer) {
        return $3c73f6609e9a9e0e$var$_subscribe(this._source, observer);
    };
    _proto.map = function map(fn) {
        var _this6 = this;
        return RelayObservable.create(function(sink) {
            var subscription = _this6.subscribe({
                complete: sink.complete,
                error: sink.error,
                next: function next(value) {
                    try {
                        var mapValue = fn(value);
                        sink.next(mapValue);
                    } catch (error) {
                        sink.error(error, true);
                    }
                }
            });
            return function() {
                subscription.unsubscribe();
            };
        });
    };
    _proto.mergeMap = function mergeMap(fn) {
        var _this7 = this;
        return RelayObservable.create(function(sink) {
            var subscriptions = [];
            function start(subscription) {
                this._sub = subscription;
                subscriptions.push(subscription);
            }
            function complete() {
                subscriptions.splice(subscriptions.indexOf(this._sub), 1);
                if (subscriptions.length === 0) sink.complete();
            }
            _this7.subscribe({
                start: start,
                next: function next(value) {
                    try {
                        if (!sink.closed) RelayObservable.from(fn(value)).subscribe({
                            start: start,
                            next: sink.next,
                            error: sink.error,
                            complete: complete
                        });
                    } catch (error) {
                        sink.error(error, true);
                    }
                },
                error: sink.error,
                complete: complete
            });
            return function() {
                subscriptions.forEach(function(sub) {
                    return sub.unsubscribe();
                });
                subscriptions.length = 0;
            };
        });
    };
    _proto.poll = function poll(pollInterval) {
        var _this8 = this;
        return RelayObservable.create(function(sink) {
            var subscription;
            var timeout;
            var poll = function poll() {
                subscription = _this8.subscribe({
                    next: sink.next,
                    error: sink.error,
                    complete: function complete() {
                        timeout = setTimeout(poll, pollInterval);
                    }
                });
            };
            poll();
            return function() {
                clearTimeout(timeout);
                subscription.unsubscribe();
            };
        });
    };
    _proto.toPromise = function toPromise() {
        var _this9 = this;
        return new Promise(function(resolve, reject) {
            var resolved = false;
            _this9.subscribe({
                next: function next(val) {
                    if (!resolved) {
                        resolved = true;
                        resolve(val);
                    }
                },
                error: reject,
                complete: resolve
            });
        });
    };
    return RelayObservable;
}();
function $3c73f6609e9a9e0e$var$isObservable(obj) {
    return typeof obj === 'object' && obj !== null && typeof obj.subscribe === 'function';
}
function $3c73f6609e9a9e0e$var$fromObservable(obj) {
    return obj instanceof $3c73f6609e9a9e0e$var$RelayObservable ? obj : $3c73f6609e9a9e0e$var$RelayObservable.create(function(sink) {
        return obj.subscribe(sink);
    });
}
function $3c73f6609e9a9e0e$var$fromPromise(promise) {
    return $3c73f6609e9a9e0e$var$RelayObservable.create(function(sink) {
        promise.then(function(value) {
            sink.next(value);
            sink.complete();
        }, sink.error);
    });
}
function $3c73f6609e9a9e0e$var$fromValue(value) {
    return $3c73f6609e9a9e0e$var$RelayObservable.create(function(sink) {
        sink.next(value);
        sink.complete();
    });
}
function $3c73f6609e9a9e0e$var$_subscribe(source, observer) {
    var closed = false;
    var cleanup;
    var withClosed = function withClosed(obj) {
        return Object.defineProperty(obj, 'closed', {
            get: function get() {
                return closed;
            }
        });
    };
    function doCleanup() {
        if (cleanup) {
            if (cleanup.unsubscribe) cleanup.unsubscribe();
            else try {
                cleanup();
            } catch (error) {
                $3c73f6609e9a9e0e$var$hostReportError(error, true);
            }
            cleanup = undefined;
        }
    }
    var subscription = withClosed({
        unsubscribe: function unsubscribe() {
            if (!closed) {
                closed = true;
                try {
                    observer.unsubscribe && observer.unsubscribe(subscription);
                } catch (error) {
                    $3c73f6609e9a9e0e$var$hostReportError(error, true);
                } finally{
                    doCleanup();
                }
            }
        }
    });
    try {
        observer.start && observer.start(subscription);
    } catch (error) {
        $3c73f6609e9a9e0e$var$hostReportError(error, true);
    }
    if (closed) return subscription;
    var sink = withClosed({
        next: function next(value) {
            if (!closed && observer.next) try {
                observer.next(value);
            } catch (error) {
                $3c73f6609e9a9e0e$var$hostReportError(error, true);
            }
        },
        error: function error(_error3, isUncaughtThrownError) {
            if (closed || !observer.error) {
                closed = true;
                $3c73f6609e9a9e0e$var$hostReportError(_error3, isUncaughtThrownError || false);
                doCleanup();
            } else {
                closed = true;
                try {
                    observer.error(_error3);
                } catch (error2) {
                    $3c73f6609e9a9e0e$var$hostReportError(error2, true);
                } finally{
                    doCleanup();
                }
            }
        },
        complete: function complete() {
            if (!closed) {
                closed = true;
                try {
                    observer.complete && observer.complete();
                } catch (error) {
                    $3c73f6609e9a9e0e$var$hostReportError(error, true);
                } finally{
                    doCleanup();
                }
            }
        }
    });
    try {
        cleanup = source(sink);
    } catch (error) {
        sink.error(error, true);
    }
    if (closed) doCleanup();
    return subscription;
}
function $3c73f6609e9a9e0e$var$swallowError(_error, _isUncaughtThrownError) {}
module.exports = $3c73f6609e9a9e0e$var$RelayObservable;

});
parcelRegister("gYJUY", function(module, exports) {
'use strict';
function $c5c5de4a6c942a1b$var$isPromise(p) {
    return p != null && typeof p === 'object' && typeof p.then === 'function';
}
module.exports = $c5c5de4a6c942a1b$var$isPromise;

});


parcelRegister("3hl6N", function(module, exports) {
'use strict';

var $5bMXV = parcelRequire("5bMXV");

var $5kZs4 = parcelRequire("5kZs4");

var $jSI6G = parcelRequire("jSI6G");
var $2633555b192d118b$var$WEAKMAP_SUPPORTED = typeof WeakMap === 'function';
var $2633555b192d118b$var$requestCachesByEnvironment = $2633555b192d118b$var$WEAKMAP_SUPPORTED ? new WeakMap() : new Map();
function $2633555b192d118b$var$fetchQuery(environment, operation) {
    return $2633555b192d118b$var$fetchQueryDeduped(environment, operation.request.identifier, function() {
        return environment.execute({
            operation: operation
        });
    });
}
function $2633555b192d118b$var$fetchQueryDeduped(environment, identifier, fetchFn) {
    return $5bMXV.create(function(sink) {
        var requestCache = $2633555b192d118b$var$getRequestCache(environment);
        var cachedRequest = requestCache.get(identifier);
        if (!cachedRequest) fetchFn()["finally"](function() {
            return requestCache["delete"](identifier);
        }).subscribe({
            start: function start(subscription) {
                cachedRequest = {
                    identifier: identifier,
                    subject: new $5kZs4(),
                    subjectForInFlightStatus: new $5kZs4(),
                    subscription: subscription,
                    promise: null
                };
                requestCache.set(identifier, cachedRequest);
            },
            next: function next(response) {
                var cachedReq = $2633555b192d118b$var$getCachedRequest(requestCache, identifier);
                cachedReq.subject.next(response);
                cachedReq.subjectForInFlightStatus.next(response);
            },
            error: function error(_error) {
                var cachedReq = $2633555b192d118b$var$getCachedRequest(requestCache, identifier);
                cachedReq.subject.error(_error);
                cachedReq.subjectForInFlightStatus.error(_error);
            },
            complete: function complete() {
                var cachedReq = $2633555b192d118b$var$getCachedRequest(requestCache, identifier);
                cachedReq.subject.complete();
                cachedReq.subjectForInFlightStatus.complete();
            },
            unsubscribe: function unsubscribe(subscription) {
                var cachedReq = $2633555b192d118b$var$getCachedRequest(requestCache, identifier);
                cachedReq.subject.unsubscribe();
                cachedReq.subjectForInFlightStatus.unsubscribe();
            }
        });
        !(cachedRequest != null) && $jSI6G(false);
        return $2633555b192d118b$var$getObservableForCachedRequest(requestCache, cachedRequest).subscribe(sink);
    });
}
function $2633555b192d118b$var$getObservableForCachedRequest(requestCache, cachedRequest) {
    return $5bMXV.create(function(sink) {
        var subscription = cachedRequest.subject.subscribe(sink);
        return function() {
            subscription.unsubscribe();
            var cachedRequestInstance = requestCache.get(cachedRequest.identifier);
            if (cachedRequestInstance) {
                var requestSubscription = cachedRequestInstance.subscription;
                if (requestSubscription != null && cachedRequestInstance.subject.getObserverCount() === 0) {
                    requestSubscription.unsubscribe();
                    requestCache["delete"](cachedRequest.identifier);
                }
            }
        };
    });
}
function $2633555b192d118b$var$getActiveStatusObservableForCachedRequest(environment, requestCache, cachedRequest) {
    return $5bMXV.create(function(sink) {
        var subscription = cachedRequest.subjectForInFlightStatus.subscribe({
            error: sink.error,
            next: function next(response) {
                if (!environment.isRequestActive(cachedRequest.identifier)) {
                    sink.complete();
                    return;
                }
                sink.next();
            },
            complete: sink.complete,
            unsubscribe: sink.complete
        });
        return function() {
            subscription.unsubscribe();
        };
    });
}
function $2633555b192d118b$var$getPromiseForActiveRequest(environment, request) {
    var requestCache = $2633555b192d118b$var$getRequestCache(environment);
    var cachedRequest = requestCache.get(request.identifier);
    if (!cachedRequest) return null;
    if (!environment.isRequestActive(cachedRequest.identifier)) return null;
    var promise = new Promise(function(resolve, reject) {
        var resolveOnNext = false;
        $2633555b192d118b$var$getActiveStatusObservableForCachedRequest(environment, requestCache, cachedRequest).subscribe({
            complete: resolve,
            error: reject,
            next: function next(response) {
                if (resolveOnNext) resolve(response);
            }
        });
        resolveOnNext = true;
    });
    return promise;
}
function $2633555b192d118b$var$getObservableForActiveRequest(environment, request) {
    var requestCache = $2633555b192d118b$var$getRequestCache(environment);
    var cachedRequest = requestCache.get(request.identifier);
    if (!cachedRequest) return null;
    if (!environment.isRequestActive(cachedRequest.identifier)) return null;
    return $2633555b192d118b$var$getActiveStatusObservableForCachedRequest(environment, requestCache, cachedRequest);
}
function $2633555b192d118b$var$getRequestCache(environment) {
    var cached = $2633555b192d118b$var$requestCachesByEnvironment.get(environment);
    if (cached != null) return cached;
    var requestCache = new Map();
    $2633555b192d118b$var$requestCachesByEnvironment.set(environment, requestCache);
    return requestCache;
}
function $2633555b192d118b$var$getCachedRequest(requestCache, identifier) {
    var cached = requestCache.get(identifier);
    !(cached != null) && $jSI6G(false);
    return cached;
}
module.exports = {
    fetchQuery: $2633555b192d118b$var$fetchQuery,
    fetchQueryDeduped: $2633555b192d118b$var$fetchQueryDeduped,
    getPromiseForActiveRequest: $2633555b192d118b$var$getPromiseForActiveRequest,
    getObservableForActiveRequest: $2633555b192d118b$var$getObservableForActiveRequest
};

});
parcelRegister("5kZs4", function(module, exports) {
'use strict';

var $e27SU = parcelRequire("e27SU");
var $3e2e7d0f9444df9c$var$_interopRequireDefault = $e27SU.default;

var $3e2e7d0f9444df9c$var$_createForOfIteratorHelper2 = $3e2e7d0f9444df9c$var$_interopRequireDefault((parcelRequire("5dSyV")));

var $3e2e7d0f9444df9c$var$_defineProperty2 = $3e2e7d0f9444df9c$var$_interopRequireDefault((parcelRequire("2JBpp")));

var $5bMXV = parcelRequire("5bMXV");

var $jSI6G = parcelRequire("jSI6G");
var $3e2e7d0f9444df9c$var$RelayReplaySubject = /*#__PURE__*/ function() {
    function RelayReplaySubject() {
        var _this = this;
        (0, $3e2e7d0f9444df9c$var$_defineProperty2["default"])(this, "_complete", false);
        (0, $3e2e7d0f9444df9c$var$_defineProperty2["default"])(this, "_events", []);
        (0, $3e2e7d0f9444df9c$var$_defineProperty2["default"])(this, "_sinks", new Set());
        (0, $3e2e7d0f9444df9c$var$_defineProperty2["default"])(this, "_subscription", []);
        this._observable = $5bMXV.create(function(sink) {
            _this._sinks.add(sink);
            var events = _this._events;
            for(var i = 0; i < events.length; i++){
                if (sink.closed) break;
                var event = events[i];
                switch(event.kind){
                    case 'complete':
                        sink.complete();
                        break;
                    case 'error':
                        sink.error(event.error);
                        break;
                    case 'next':
                        sink.next(event.data);
                        break;
                    default:
                        event.kind;
                        $jSI6G(false);
                }
            }
            return function() {
                _this._sinks["delete"](sink);
            };
        });
    }
    var _proto = RelayReplaySubject.prototype;
    _proto.complete = function complete() {
        if (this._complete === true) return;
        this._complete = true;
        this._events.push({
            kind: 'complete'
        });
        this._sinks.forEach(function(sink) {
            return sink.complete();
        });
    };
    _proto.error = function error(_error) {
        if (this._complete === true) return;
        this._complete = true;
        this._events.push({
            error: _error,
            kind: 'error'
        });
        this._sinks.forEach(function(sink) {
            return sink.error(_error);
        });
    };
    _proto.next = function next(data) {
        if (this._complete === true) return;
        this._events.push({
            data: data,
            kind: 'next'
        });
        this._sinks.forEach(function(sink) {
            return sink.next(data);
        });
    };
    _proto.subscribe = function subscribe(observer) {
        var subscription = this._observable.subscribe(observer);
        this._subscription.push(subscription);
        return subscription;
    };
    _proto.unsubscribe = function unsubscribe() {
        var _iterator = (0, $3e2e7d0f9444df9c$var$_createForOfIteratorHelper2["default"])(this._subscription), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var subscription = _step.value;
                subscription.unsubscribe();
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
        this._subscription = [];
    };
    _proto.getObserverCount = function getObserverCount() {
        return this._sinks.size;
    };
    return RelayReplaySubject;
}();
module.exports = $3e2e7d0f9444df9c$var$RelayReplaySubject;

});



parcelRegister("8PaRu", function(module, exports) {
'use strict';

var $e27SU = parcelRequire("e27SU");
var $66cb83162da92305$var$_interopRequireDefault = $e27SU.default;

var $66cb83162da92305$var$_defineProperty2 = $66cb83162da92305$var$_interopRequireDefault((parcelRequire("2JBpp")));

var $inpeC = parcelRequire("inpeC");
var $66cb83162da92305$var$observeFragment = $inpeC.observeFragment;

var $gCG1q = parcelRequire("gCG1q");
var $66cb83162da92305$var$createOperationDescriptor = $gCG1q.createOperationDescriptor;
function $66cb83162da92305$var$observeQuery(environment, gqlQuery, variables) {
    var operation = $66cb83162da92305$var$createOperationDescriptor(gqlQuery, variables);
    var rootFragmentRef = {
        __fragmentOwner: operation.request,
        __fragments: (0, $66cb83162da92305$var$_defineProperty2["default"])({}, operation.fragment.node.name, operation.request.variables),
        __id: operation.fragment.dataID
    };
    var fragmentNode = operation.request.node.fragment;
    return $66cb83162da92305$var$observeFragment(environment, fragmentNode, rootFragmentRef);
}
module.exports = {
    observeQuery: $66cb83162da92305$var$observeQuery
};

});
parcelRegister("gCG1q", function(module, exports) {
'use strict';
parcelRequire("6GnlG");

var $fST4p = parcelRequire("fST4p");

var $gZYpt = parcelRequire("gZYpt");

var $4hUjJ = parcelRequire("4hUjJ");
var $c1a0caa1b3362b36$var$hasCycle = $4hUjJ.hasCycle;

var $adnaT = parcelRequire("adnaT");
var $c1a0caa1b3362b36$var$getOperationVariables = $adnaT.getOperationVariables;

var $iUq0k = parcelRequire("iUq0k");
var $c1a0caa1b3362b36$var$createNormalizationSelector = $iUq0k.createNormalizationSelector, $c1a0caa1b3362b36$var$createReaderSelector = $iUq0k.createReaderSelector;

var $ezyIu = parcelRequire("ezyIu");
var $c1a0caa1b3362b36$var$ROOT_ID = $ezyIu.ROOT_ID;

var $jSI6G = parcelRequire("jSI6G");
function $c1a0caa1b3362b36$var$createOperationDescriptor(request, variables, cacheConfig) {
    var dataID = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : $c1a0caa1b3362b36$var$ROOT_ID;
    var operation = request.operation;
    var operationVariables = $c1a0caa1b3362b36$var$getOperationVariables(operation, request.params.providedVariables, variables);
    if ($gZYpt.ENABLE_CYLE_DETECTION_IN_VARIABLES) !!$c1a0caa1b3362b36$var$hasCycle(operationVariables) && $jSI6G(false);
    var requestDescriptor = $c1a0caa1b3362b36$var$createRequestDescriptor(request, operationVariables, cacheConfig);
    var operationDescriptor = {
        fragment: $c1a0caa1b3362b36$var$createReaderSelector(request.fragment, dataID, operationVariables, requestDescriptor),
        request: requestDescriptor,
        root: $c1a0caa1b3362b36$var$createNormalizationSelector(operation, dataID, operationVariables)
    };
    return operationDescriptor;
}
function $c1a0caa1b3362b36$var$createRequestDescriptor(request, variables, cacheConfig) {
    var requestDescriptor = {
        identifier: $fST4p(request.params, variables),
        node: request,
        variables: variables,
        cacheConfig: cacheConfig
    };
    return requestDescriptor;
}
module.exports = {
    createOperationDescriptor: $c1a0caa1b3362b36$var$createOperationDescriptor,
    createRequestDescriptor: $c1a0caa1b3362b36$var$createRequestDescriptor
};

});
parcelRegister("6GnlG", function(module, exports) {
'use strict';
function $4dd8c6e0b537a6bc$var$deepFreeze(object) {
    if (!$4dd8c6e0b537a6bc$var$shouldBeFrozen(object)) return object;
    Object.freeze(object);
    Object.getOwnPropertyNames(object).forEach(function(name) {
        var property = object[name];
        if (property && typeof property === 'object' && !Object.isFrozen(property)) $4dd8c6e0b537a6bc$var$deepFreeze(property);
    });
    return object;
}
function $4dd8c6e0b537a6bc$var$shouldBeFrozen(value) {
    return value != null && (Array.isArray(value) || typeof value === 'object' && value.constructor === Object);
}
module.exports = $4dd8c6e0b537a6bc$var$deepFreeze;

});

parcelRegister("fST4p", function(module, exports) {
'use strict';

var $4hUjJ = parcelRequire("4hUjJ");
var $b9069df3c72651b4$var$stableCopy = $4hUjJ.stableCopy;

var $jSI6G = parcelRequire("jSI6G");
function $b9069df3c72651b4$var$getRequestIdentifier(parameters, variables) {
    var requestID = parameters.cacheID != null ? parameters.cacheID : parameters.id;
    !(requestID != null) && $jSI6G(false);
    return requestID + JSON.stringify($b9069df3c72651b4$var$stableCopy(variables));
}
module.exports = $b9069df3c72651b4$var$getRequestIdentifier;

});



parcelRegister("gItWI", function(module, exports) {
"use strict";

var $dkCvo = parcelRequire("dkCvo");
var $c2b7fc0f38bbed97$require$_asyncToGenerator = $dkCvo.default;

var $inpeC = parcelRequire("inpeC");
var $c2b7fc0f38bbed97$var$observeFragment = $inpeC.observeFragment;
function $c2b7fc0f38bbed97$var$waitForFragmentData(_x, _x2, _x3) {
    return $c2b7fc0f38bbed97$var$_waitForFragmentData.apply(this, arguments);
}
function $c2b7fc0f38bbed97$var$_waitForFragmentData() {
    $c2b7fc0f38bbed97$var$_waitForFragmentData = $c2b7fc0f38bbed97$require$_asyncToGenerator(function*(environment, fragment, fragmentRef) {
        var subscription;
        try {
            var _subscription;
            var data = yield new Promise(function(resolve, reject) {
                subscription = $c2b7fc0f38bbed97$var$observeFragment(environment, fragment, fragmentRef).subscribe({
                    next: function next(val) {
                        if (val.state === 'ok') resolve(val.value);
                        else if (val.state === 'error') reject(val.error);
                    }
                });
            });
            (_subscription = subscription) === null || _subscription === void 0 || _subscription.unsubscribe();
            return data;
        } catch (e) {
            var _subscription2;
            (_subscription2 = subscription) === null || _subscription2 === void 0 || _subscription2.unsubscribe();
            throw e;
        }
    });
    return $c2b7fc0f38bbed97$var$_waitForFragmentData.apply(this, arguments);
}
module.exports = {
    waitForFragmentData: $c2b7fc0f38bbed97$var$waitForFragmentData
};

});


parcelRegister("qhT86", function(module, exports) {
'use strict';

var $9pidS = parcelRequire("9pidS");
var $04f04e0b480ab5e8$var$generateClientID = $9pidS.generateClientID;

var $ezyIu = parcelRequire("ezyIu");
var $04f04e0b480ab5e8$var$getStableStorageKey = $ezyIu.getStableStorageKey;

var $fFdd7 = parcelRequire("fFdd7");

var $3h9bc = parcelRequire("3h9bc");

var $jSI6G = parcelRequire("jSI6G");
parcelRequire("2OmBw");
var $04f04e0b480ab5e8$var$CONNECTION = 'connection';
var $04f04e0b480ab5e8$var$NEXT_EDGE_INDEX = '__connection_next_edge_index';
function $04f04e0b480ab5e8$var$update(store, payload) {
    var record = store.get(payload.dataID);
    if (!record) return;
    var _ConnectionInterface$ = $3h9bc.get(), EDGES = _ConnectionInterface$.EDGES, END_CURSOR = _ConnectionInterface$.END_CURSOR, HAS_NEXT_PAGE = _ConnectionInterface$.HAS_NEXT_PAGE, HAS_PREV_PAGE = _ConnectionInterface$.HAS_PREV_PAGE, PAGE_INFO = _ConnectionInterface$.PAGE_INFO, PAGE_INFO_TYPE = _ConnectionInterface$.PAGE_INFO_TYPE, START_CURSOR = _ConnectionInterface$.START_CURSOR;
    var serverConnection = record.getLinkedRecord(payload.fieldKey);
    var serverPageInfo = serverConnection && serverConnection.getLinkedRecord(PAGE_INFO);
    if (!serverConnection) {
        record.setValue(null, payload.handleKey, undefined, record.getErrors(payload.fieldKey));
        return;
    }
    var clientConnectionID = $04f04e0b480ab5e8$var$generateClientID(record.getDataID(), payload.handleKey);
    var clientConnectionField = record.getLinkedRecord(payload.handleKey);
    var clientConnection = clientConnectionField !== null && clientConnectionField !== void 0 ? clientConnectionField : store.get(clientConnectionID);
    var clientPageInfo = clientConnection && clientConnection.getLinkedRecord(PAGE_INFO);
    if (!clientConnection) {
        var connection = store.create(clientConnectionID, serverConnection.getType());
        connection.setValue(0, $04f04e0b480ab5e8$var$NEXT_EDGE_INDEX);
        connection.copyFieldsFrom(serverConnection);
        var serverEdges = serverConnection.getLinkedRecords(EDGES);
        if (serverEdges) {
            serverEdges = serverEdges.map(function(edge) {
                return $04f04e0b480ab5e8$var$buildConnectionEdge(store, connection, edge);
            });
            connection.setLinkedRecords(serverEdges, EDGES);
        }
        record.setLinkedRecord(connection, payload.handleKey);
        clientPageInfo = store.create($04f04e0b480ab5e8$var$generateClientID(connection.getDataID(), PAGE_INFO), PAGE_INFO_TYPE);
        clientPageInfo.setValue(false, HAS_NEXT_PAGE);
        clientPageInfo.setValue(false, HAS_PREV_PAGE);
        clientPageInfo.setValue(null, END_CURSOR);
        clientPageInfo.setValue(null, START_CURSOR);
        if (serverPageInfo) clientPageInfo.copyFieldsFrom(serverPageInfo);
        connection.setLinkedRecord(clientPageInfo, PAGE_INFO);
    } else {
        if (clientConnectionField == null) record.setLinkedRecord(clientConnection, payload.handleKey);
        var _connection = clientConnection;
        var _serverEdges = serverConnection.getLinkedRecords(EDGES);
        if (_serverEdges) _serverEdges = _serverEdges.map(function(edge) {
            return $04f04e0b480ab5e8$var$buildConnectionEdge(store, _connection, edge);
        });
        var prevEdges = _connection.getLinkedRecords(EDGES);
        var prevPageInfo = _connection.getLinkedRecord(PAGE_INFO);
        _connection.copyFieldsFrom(serverConnection);
        if (prevEdges) _connection.setLinkedRecords(prevEdges, EDGES);
        if (prevPageInfo) _connection.setLinkedRecord(prevPageInfo, PAGE_INFO);
        var nextEdges = [];
        var args = payload.args;
        if (prevEdges && _serverEdges) {
            if (args.after != null) {
                var _clientPageInfo;
                var clientEndCursor = (_clientPageInfo = clientPageInfo) === null || _clientPageInfo === void 0 ? void 0 : _clientPageInfo.getValue(END_CURSOR);
                var serverEndCursor = serverPageInfo === null || serverPageInfo === void 0 ? void 0 : serverPageInfo.getValue(END_CURSOR);
                var isAddingEdgesAfterCurrentPage = clientPageInfo && args.after === clientEndCursor;
                var isFillingOutCurrentPage = clientPageInfo && clientEndCursor === serverEndCursor;
                if (isAddingEdgesAfterCurrentPage || isFillingOutCurrentPage) {
                    var nodeIDs = new Set();
                    $04f04e0b480ab5e8$var$mergeEdges(prevEdges, nextEdges, nodeIDs);
                    $04f04e0b480ab5e8$var$mergeEdges(_serverEdges, nextEdges, nodeIDs);
                } else return;
            } else if (args.before != null) {
                if (clientPageInfo && args.before === clientPageInfo.getValue(START_CURSOR)) {
                    var _nodeIDs = new Set();
                    $04f04e0b480ab5e8$var$mergeEdges(_serverEdges, nextEdges, _nodeIDs);
                    $04f04e0b480ab5e8$var$mergeEdges(prevEdges, nextEdges, _nodeIDs);
                } else return;
            } else nextEdges = _serverEdges;
        } else if (_serverEdges) nextEdges = _serverEdges;
        else nextEdges = prevEdges;
        if (nextEdges != null && nextEdges !== prevEdges) _connection.setLinkedRecords(nextEdges, EDGES);
        if (clientPageInfo && serverPageInfo) {
            if (args.after == null && args.before == null) clientPageInfo.copyFieldsFrom(serverPageInfo);
            else if (args.before != null || args.after == null && args.last) {
                clientPageInfo.setValue(!!serverPageInfo.getValue(HAS_PREV_PAGE), HAS_PREV_PAGE);
                var startCursor = serverPageInfo.getValue(START_CURSOR);
                if (typeof startCursor === 'string') clientPageInfo.setValue(startCursor, START_CURSOR);
            } else if (args.after != null || args.before == null && args.first) {
                clientPageInfo.setValue(!!serverPageInfo.getValue(HAS_NEXT_PAGE), HAS_NEXT_PAGE);
                var endCursor = serverPageInfo.getValue(END_CURSOR);
                if (typeof endCursor === 'string') clientPageInfo.setValue(endCursor, END_CURSOR);
            }
        }
    }
}
function $04f04e0b480ab5e8$var$getConnection(record, key, filters) {
    var handleKey = $fFdd7($04f04e0b480ab5e8$var$CONNECTION, key, null);
    return record.getLinkedRecord(handleKey, filters);
}
function $04f04e0b480ab5e8$var$getConnectionID(recordID, key, filters) {
    var handleKey = $fFdd7($04f04e0b480ab5e8$var$CONNECTION, key, null);
    var storageKey = $04f04e0b480ab5e8$var$getStableStorageKey(handleKey, filters);
    return $04f04e0b480ab5e8$var$generateClientID(recordID, storageKey);
}
function $04f04e0b480ab5e8$var$insertEdgeAfter(record, newEdge, cursor) {
    var _ConnectionInterface$2 = $3h9bc.get(), CURSOR = _ConnectionInterface$2.CURSOR, EDGES = _ConnectionInterface$2.EDGES;
    var edges = record.getLinkedRecords(EDGES);
    if (!edges) {
        record.setLinkedRecords([
            newEdge
        ], EDGES);
        return;
    }
    var nextEdges;
    if (cursor == null) nextEdges = edges.concat(newEdge);
    else {
        nextEdges = [];
        var foundCursor = false;
        for(var ii = 0; ii < edges.length; ii++){
            var edge = edges[ii];
            nextEdges.push(edge);
            if (edge == null) continue;
            var edgeCursor = edge.getValue(CURSOR);
            if (cursor === edgeCursor) {
                nextEdges.push(newEdge);
                foundCursor = true;
            }
        }
        if (!foundCursor) nextEdges.push(newEdge);
    }
    record.setLinkedRecords(nextEdges, EDGES);
}
function $04f04e0b480ab5e8$var$createEdge(store, record, node, edgeType) {
    var _ConnectionInterface$3 = $3h9bc.get(), NODE = _ConnectionInterface$3.NODE;
    var edgeID = $04f04e0b480ab5e8$var$generateClientID(record.getDataID(), node.getDataID());
    var edge = store.get(edgeID);
    if (!edge) edge = store.create(edgeID, edgeType);
    edge.setLinkedRecord(node, NODE);
    if (edge.getValue('cursor') == null) edge.setValue(null, 'cursor');
    return edge;
}
function $04f04e0b480ab5e8$var$insertEdgeBefore(record, newEdge, cursor) {
    var _ConnectionInterface$4 = $3h9bc.get(), CURSOR = _ConnectionInterface$4.CURSOR, EDGES = _ConnectionInterface$4.EDGES;
    var edges = record.getLinkedRecords(EDGES);
    if (!edges) {
        record.setLinkedRecords([
            newEdge
        ], EDGES);
        return;
    }
    var nextEdges;
    if (cursor == null) nextEdges = [
        newEdge
    ].concat(edges);
    else {
        nextEdges = [];
        var foundCursor = false;
        for(var ii = 0; ii < edges.length; ii++){
            var edge = edges[ii];
            if (edge != null) {
                var edgeCursor = edge.getValue(CURSOR);
                if (cursor === edgeCursor) {
                    nextEdges.push(newEdge);
                    foundCursor = true;
                }
            }
            nextEdges.push(edge);
        }
        if (!foundCursor) nextEdges.unshift(newEdge);
    }
    record.setLinkedRecords(nextEdges, EDGES);
}
function $04f04e0b480ab5e8$var$deleteNode(record, nodeID) {
    var _ConnectionInterface$5 = $3h9bc.get(), EDGES = _ConnectionInterface$5.EDGES, NODE = _ConnectionInterface$5.NODE;
    var edges = record.getLinkedRecords(EDGES);
    if (!edges) return;
    var nextEdges;
    for(var ii = 0; ii < edges.length; ii++){
        var edge = edges[ii];
        var node = edge && edge.getLinkedRecord(NODE);
        if (node != null && node.getDataID() === nodeID) {
            if (nextEdges === undefined) nextEdges = edges.slice(0, ii);
        } else if (nextEdges !== undefined) nextEdges.push(edge);
    }
    if (nextEdges !== undefined) record.setLinkedRecords(nextEdges, EDGES);
}
function $04f04e0b480ab5e8$var$buildConnectionEdge(store, connection, edge) {
    if (edge == null) return edge;
    var _ConnectionInterface$6 = $3h9bc.get(), EDGES = _ConnectionInterface$6.EDGES;
    var edgeIndex = connection.getValue($04f04e0b480ab5e8$var$NEXT_EDGE_INDEX);
    !(typeof edgeIndex === 'number') && $jSI6G(false);
    var edgeID = $04f04e0b480ab5e8$var$generateClientID(connection.getDataID(), EDGES, edgeIndex);
    var connectionEdge = store.create(edgeID, edge.getType());
    connectionEdge.copyFieldsFrom(edge);
    if (connectionEdge.getValue('cursor') == null) connectionEdge.setValue(null, 'cursor');
    connection.setValue(edgeIndex + 1, $04f04e0b480ab5e8$var$NEXT_EDGE_INDEX);
    return connectionEdge;
}
function $04f04e0b480ab5e8$var$mergeEdges(sourceEdges, targetEdges, nodeIDs) {
    var _ConnectionInterface$7 = $3h9bc.get(), NODE = _ConnectionInterface$7.NODE;
    for(var ii = 0; ii < sourceEdges.length; ii++){
        var edge = sourceEdges[ii];
        if (!edge) continue;
        var node = edge.getLinkedRecord(NODE);
        var nodeID = node && node.getDataID();
        if (nodeID) {
            if (nodeIDs.has(nodeID)) continue;
            nodeIDs.add(nodeID);
        }
        targetEdges.push(edge);
    }
}
module.exports = {
    buildConnectionEdge: $04f04e0b480ab5e8$var$buildConnectionEdge,
    createEdge: $04f04e0b480ab5e8$var$createEdge,
    deleteNode: $04f04e0b480ab5e8$var$deleteNode,
    getConnection: $04f04e0b480ab5e8$var$getConnection,
    getConnectionID: $04f04e0b480ab5e8$var$getConnectionID,
    insertEdgeAfter: $04f04e0b480ab5e8$var$insertEdgeAfter,
    insertEdgeBefore: $04f04e0b480ab5e8$var$insertEdgeBefore,
    update: $04f04e0b480ab5e8$var$update
};

});
parcelRegister("9pidS", function(module, exports) {
'use strict';

var $gZYpt = parcelRequire("gZYpt");

var $d7PSX = parcelRequire("d7PSX");
var $6d94958ab39aea5d$var$intern = $d7PSX.intern;
var $6d94958ab39aea5d$var$PREFIX = 'client:';
function $6d94958ab39aea5d$var$generateClientID(id, storageKey, index) {
    var internedId = $gZYpt.STRING_INTERN_LEVEL <= 0 ? id : $6d94958ab39aea5d$var$intern(id, $gZYpt.MAX_DATA_ID_LENGTH);
    var key = internedId + ':' + storageKey;
    if (index != null) key += ':' + index;
    if (key.indexOf($6d94958ab39aea5d$var$PREFIX) !== 0) key = $6d94958ab39aea5d$var$PREFIX + key;
    return key;
}
function $6d94958ab39aea5d$var$isClientID(id) {
    return id.indexOf($6d94958ab39aea5d$var$PREFIX) === 0;
}
var $6d94958ab39aea5d$var$localID = 0;
function $6d94958ab39aea5d$var$generateUniqueClientID() {
    return "".concat($6d94958ab39aea5d$var$PREFIX, "local:").concat($6d94958ab39aea5d$var$localID++);
}
function $6d94958ab39aea5d$var$generateClientObjectClientID(typename, localId, index) {
    var key = "".concat($6d94958ab39aea5d$var$PREFIX).concat(typename, ":").concat(localId);
    if (index != null) key += ':' + index;
    return key;
}
module.exports = {
    generateClientID: $6d94958ab39aea5d$var$generateClientID,
    generateClientObjectClientID: $6d94958ab39aea5d$var$generateClientObjectClientID,
    generateUniqueClientID: $6d94958ab39aea5d$var$generateUniqueClientID,
    isClientID: $6d94958ab39aea5d$var$isClientID
};

});
parcelRegister("d7PSX", function(module, exports) {
'use strict';
var $98e42d3207838968$var$internTable = new Map();
var $98e42d3207838968$var$nextIndex = 1;
var $98e42d3207838968$var$digits = $98e42d3207838968$var$initDigitTable();
var $98e42d3207838968$var$INTERN_PREFIX = '\t';
var $98e42d3207838968$var$ESCAPE_PREFIX = '\v';
function $98e42d3207838968$var$initDigitTable() {
    var digits = new Set();
    for(var i = 0; i < 10; ++i)digits.add(i.toString());
    return digits;
}
function $98e42d3207838968$var$escape(str) {
    if (str[0] === $98e42d3207838968$var$INTERN_PREFIX && $98e42d3207838968$var$digits.has(str[1]) || str[0] === $98e42d3207838968$var$ESCAPE_PREFIX) return $98e42d3207838968$var$ESCAPE_PREFIX + str;
    return str;
}
function $98e42d3207838968$var$intern(str, limit) {
    if (limit == null || str.length < limit) return $98e42d3207838968$var$escape(str);
    var internedString = $98e42d3207838968$var$internTable.get(str);
    if (internedString != null) return internedString;
    internedString = $98e42d3207838968$var$INTERN_PREFIX + $98e42d3207838968$var$nextIndex++;
    $98e42d3207838968$var$internTable.set(str, internedString);
    return internedString;
}
module.exports = {
    intern: $98e42d3207838968$var$intern
};

});


parcelRegister("3h9bc", function(module, exports) {
'use strict';
var $262a148603195883$var$CONNECTION_CALLS = {
    after: true,
    before: true,
    find: true,
    first: true,
    last: true,
    surrounds: true
};
var $262a148603195883$var$config = {
    CURSOR: 'cursor',
    EDGES: 'edges',
    END_CURSOR: 'endCursor',
    HAS_NEXT_PAGE: 'hasNextPage',
    HAS_PREV_PAGE: 'hasPreviousPage',
    NODE: 'node',
    PAGE_INFO_TYPE: 'PageInfo',
    PAGE_INFO: 'pageInfo',
    START_CURSOR: 'startCursor'
};
var $262a148603195883$var$ConnectionInterface = {
    inject: function inject(newConfig) {
        $262a148603195883$var$config = newConfig;
    },
    get: function get() {
        return $262a148603195883$var$config;
    },
    isConnectionCall: function isConnectionCall(call) {
        return $262a148603195883$var$CONNECTION_CALLS.hasOwnProperty(call.name);
    }
};
module.exports = $262a148603195883$var$ConnectionInterface;

});


parcelRegister("a3rTt", function(module, exports) {
'use strict';

var $e27SU = parcelRequire("e27SU");
var $751fd24a2de225f3$var$_interopRequireDefault = $e27SU.default;

var $751fd24a2de225f3$var$_createForOfIteratorHelper2 = $751fd24a2de225f3$var$_interopRequireDefault((parcelRequire("5dSyV")));

var $qhT86 = parcelRequire("qhT86");

var $3h9bc = parcelRequire("3h9bc");

var $jSI6G = parcelRequire("jSI6G");
parcelRequire("2OmBw");
var $751fd24a2de225f3$var$DeleteRecordHandler = {
    update: function update(store, payload) {
        var record = store.get(payload.dataID);
        if (record != null) {
            var idOrIds = record.getValue(payload.fieldKey);
            if (typeof idOrIds === 'string') store["delete"](idOrIds);
            else if (Array.isArray(idOrIds)) idOrIds.forEach(function(id) {
                if (typeof id === 'string') store["delete"](id);
            });
        }
    }
};
var $751fd24a2de225f3$var$DeleteEdgeHandler = {
    update: function update(store, payload) {
        var record = store.get(payload.dataID);
        if (record == null) return;
        var connections = payload.handleArgs.connections;
        !(connections != null) && $jSI6G(false);
        var idOrIds = record.getValue(payload.fieldKey);
        var idList = Array.isArray(idOrIds) ? idOrIds : [
            idOrIds
        ];
        idList.forEach(function(id) {
            if (typeof id === 'string') {
                var _iterator = (0, $751fd24a2de225f3$var$_createForOfIteratorHelper2["default"])(connections), _step;
                try {
                    for(_iterator.s(); !(_step = _iterator.n()).done;){
                        var connectionID = _step.value;
                        var connection = store.get(connectionID);
                        if (connection == null) continue;
                        $qhT86.deleteNode(connection, id);
                    }
                } catch (err) {
                    _iterator.e(err);
                } finally{
                    _iterator.f();
                }
            }
        });
    }
};
var $751fd24a2de225f3$var$AppendEdgeHandler = {
    update: $751fd24a2de225f3$var$edgeUpdater($qhT86.insertEdgeAfter)
};
var $751fd24a2de225f3$var$PrependEdgeHandler = {
    update: $751fd24a2de225f3$var$edgeUpdater($qhT86.insertEdgeBefore)
};
var $751fd24a2de225f3$var$AppendNodeHandler = {
    update: $751fd24a2de225f3$var$nodeUpdater($qhT86.insertEdgeAfter)
};
var $751fd24a2de225f3$var$PrependNodeHandler = {
    update: $751fd24a2de225f3$var$nodeUpdater($qhT86.insertEdgeBefore)
};
function $751fd24a2de225f3$var$edgeUpdater(insertFn) {
    return function(store, payload) {
        var _serverEdges;
        var record = store.get(payload.dataID);
        if (record == null) return;
        var connections = payload.handleArgs.connections;
        !(connections != null) && $jSI6G(false);
        var singleServerEdge, serverEdges;
        try {
            singleServerEdge = record.getLinkedRecord(payload.fieldKey);
        } catch (_unused) {}
        if (!singleServerEdge) try {
            serverEdges = record.getLinkedRecords(payload.fieldKey);
        } catch (_unused2) {}
        if (singleServerEdge == null && serverEdges == null) return;
        var _ConnectionInterface$ = $3h9bc.get(), NODE = _ConnectionInterface$.NODE, EDGES = _ConnectionInterface$.EDGES;
        var serverEdgeList = (_serverEdges = serverEdges) !== null && _serverEdges !== void 0 ? _serverEdges : [
            singleServerEdge
        ];
        var _iterator2 = (0, $751fd24a2de225f3$var$_createForOfIteratorHelper2["default"])(serverEdgeList), _step2;
        try {
            var _loop = function _loop() {
                var serverEdge = _step2.value;
                if (serverEdge == null) return "continue";
                var serverNode = serverEdge.getLinkedRecord('node');
                if (!serverNode) return "continue";
                var serverNodeId = serverNode.getDataID();
                var _iterator3 = (0, $751fd24a2de225f3$var$_createForOfIteratorHelper2["default"])(connections), _step3;
                try {
                    for(_iterator3.s(); !(_step3 = _iterator3.n()).done;){
                        var connectionID = _step3.value;
                        var connection = store.get(connectionID);
                        if (connection == null) continue;
                        var nodeAlreadyExistsInConnection = (_connection$getLinked = connection.getLinkedRecords(EDGES)) === null || _connection$getLinked === void 0 ? void 0 : _connection$getLinked.some(function(edge) {
                            var _edge$getLinkedRecord;
                            return (edge === null || edge === void 0 ? void 0 : (_edge$getLinkedRecord = edge.getLinkedRecord(NODE)) === null || _edge$getLinkedRecord === void 0 ? void 0 : _edge$getLinkedRecord.getDataID()) === serverNodeId;
                        });
                        if (nodeAlreadyExistsInConnection) continue;
                        var clientEdge = $qhT86.buildConnectionEdge(store, connection, serverEdge);
                        !(clientEdge != null) && $jSI6G(false);
                        insertFn(connection, clientEdge);
                    }
                } catch (err) {
                    _iterator3.e(err);
                } finally{
                    _iterator3.f();
                }
            };
            for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                var _connection$getLinked;
                var _ret = _loop();
                if (_ret === "continue") continue;
            }
        } catch (err) {
            _iterator2.e(err);
        } finally{
            _iterator2.f();
        }
    };
}
function $751fd24a2de225f3$var$nodeUpdater(insertFn) {
    return function(store, payload) {
        var _serverNodes;
        var record = store.get(payload.dataID);
        if (record == null) return;
        var _payload$handleArgs = payload.handleArgs, connections = _payload$handleArgs.connections, edgeTypeName = _payload$handleArgs.edgeTypeName;
        !(connections != null) && $jSI6G(false);
        !(edgeTypeName != null) && $jSI6G(false);
        var singleServerNode;
        var serverNodes;
        try {
            singleServerNode = record.getLinkedRecord(payload.fieldKey);
        } catch (_unused3) {}
        if (!singleServerNode) try {
            serverNodes = record.getLinkedRecords(payload.fieldKey);
        } catch (_unused4) {}
        if (singleServerNode == null && serverNodes == null) return;
        var _ConnectionInterface$2 = $3h9bc.get(), NODE = _ConnectionInterface$2.NODE, EDGES = _ConnectionInterface$2.EDGES;
        var serverNodeList = (_serverNodes = serverNodes) !== null && _serverNodes !== void 0 ? _serverNodes : [
            singleServerNode
        ];
        var _iterator4 = (0, $751fd24a2de225f3$var$_createForOfIteratorHelper2["default"])(serverNodeList), _step4;
        try {
            var _loop2 = function _loop2() {
                var serverNode = _step4.value;
                if (serverNode == null) return "continue";
                var serverNodeId = serverNode.getDataID();
                var _iterator5 = (0, $751fd24a2de225f3$var$_createForOfIteratorHelper2["default"])(connections), _step5;
                try {
                    for(_iterator5.s(); !(_step5 = _iterator5.n()).done;){
                        var connectionID = _step5.value;
                        var connection = store.get(connectionID);
                        if (connection == null) continue;
                        var nodeAlreadyExistsInConnection = (_connection$getLinked2 = connection.getLinkedRecords(EDGES)) === null || _connection$getLinked2 === void 0 ? void 0 : _connection$getLinked2.some(function(edge) {
                            var _edge$getLinkedRecord2;
                            return (edge === null || edge === void 0 ? void 0 : (_edge$getLinkedRecord2 = edge.getLinkedRecord(NODE)) === null || _edge$getLinkedRecord2 === void 0 ? void 0 : _edge$getLinkedRecord2.getDataID()) === serverNodeId;
                        });
                        if (nodeAlreadyExistsInConnection) continue;
                        var clientEdge = $qhT86.createEdge(store, connection, serverNode, edgeTypeName);
                        !(clientEdge != null) && $jSI6G(false);
                        insertFn(connection, clientEdge);
                    }
                } catch (err) {
                    _iterator5.e(err);
                } finally{
                    _iterator5.f();
                }
            };
            for(_iterator4.s(); !(_step4 = _iterator4.n()).done;){
                var _connection$getLinked2;
                var _ret2 = _loop2();
                if (_ret2 === "continue") continue;
            }
        } catch (err) {
            _iterator4.e(err);
        } finally{
            _iterator4.f();
        }
    };
}
module.exports = {
    AppendEdgeHandler: $751fd24a2de225f3$var$AppendEdgeHandler,
    DeleteRecordHandler: $751fd24a2de225f3$var$DeleteRecordHandler,
    PrependEdgeHandler: $751fd24a2de225f3$var$PrependEdgeHandler,
    AppendNodeHandler: $751fd24a2de225f3$var$AppendNodeHandler,
    PrependNodeHandler: $751fd24a2de225f3$var$PrependNodeHandler,
    DeleteEdgeHandler: $751fd24a2de225f3$var$DeleteEdgeHandler
};

});

parcelRegister("7NbNP", function(module, exports) {
'use strict';

var $qhT86 = parcelRequire("qhT86");

var $a3rTt = parcelRequire("a3rTt");

var $jSI6G = parcelRequire("jSI6G");
function $5ac643c0ece7a995$var$RelayDefaultHandlerProvider(handle) {
    switch(handle){
        case 'connection':
            return $qhT86;
        case 'deleteRecord':
            return $a3rTt.DeleteRecordHandler;
        case 'deleteEdge':
            return $a3rTt.DeleteEdgeHandler;
        case 'appendEdge':
            return $a3rTt.AppendEdgeHandler;
        case 'prependEdge':
            return $a3rTt.PrependEdgeHandler;
        case 'appendNode':
            return $a3rTt.AppendNodeHandler;
        case 'prependNode':
            return $a3rTt.PrependNodeHandler;
    }
    $jSI6G(false);
}
module.exports = $5ac643c0ece7a995$var$RelayDefaultHandlerProvider;

});

parcelRegister("39DFs", function(module, exports) {
'use strict';

var $kLQDK = parcelRequire("kLQDK");
var $24c0fb83a4606806$var$getRequest = $kLQDK.getRequest;

var $jdpKt = parcelRequire("jdpKt");

var $gCG1q = parcelRequire("gCG1q");
var $24c0fb83a4606806$var$createOperationDescriptor = $gCG1q.createOperationDescriptor;

var $33gLb = parcelRequire("33gLb");

var $jSI6G = parcelRequire("jSI6G");
function $24c0fb83a4606806$var$applyOptimisticMutation(environment, config) {
    !$jdpKt(environment) && $jSI6G(false);
    var mutation = $24c0fb83a4606806$var$getRequest(config.mutation);
    if (mutation.params.operationKind !== 'mutation') throw new Error('commitMutation: Expected mutation operation');
    var optimisticUpdater = config.optimisticUpdater;
    var configs = config.configs, optimisticResponse = config.optimisticResponse, variables = config.variables;
    var operation = $24c0fb83a4606806$var$createOperationDescriptor(mutation, variables);
    if (configs) {
        var _RelayDeclarativeMuta = $33gLb.convert(configs, mutation, optimisticUpdater);
        optimisticUpdater = _RelayDeclarativeMuta.optimisticUpdater;
    }
    return environment.applyMutation({
        operation: operation,
        response: optimisticResponse,
        updater: optimisticUpdater
    });
}
module.exports = $24c0fb83a4606806$var$applyOptimisticMutation;

});
parcelRegister("jdpKt", function(module, exports) {
'use strict';
function $dfd334531f43d7a6$var$isRelayModernEnvironment(environment) {
    return Boolean(environment && environment['@@RelayModernEnvironment']);
}
module.exports = $dfd334531f43d7a6$var$isRelayModernEnvironment;

});

parcelRegister("33gLb", function(module, exports) {
'use strict';

var $e27SU = parcelRequire("e27SU");
var $238ea71ccb55dec6$var$_interopRequireDefault = $e27SU.default;

var $238ea71ccb55dec6$var$_createForOfIteratorHelper2 = $238ea71ccb55dec6$var$_interopRequireDefault((parcelRequire("5dSyV")));

var $qhT86 = parcelRequire("qhT86");
parcelRequire("2OmBw");
var $238ea71ccb55dec6$var$MutationTypes = Object.freeze({
    RANGE_ADD: 'RANGE_ADD',
    RANGE_DELETE: 'RANGE_DELETE',
    NODE_DELETE: 'NODE_DELETE'
});
var $238ea71ccb55dec6$var$RangeOperations = Object.freeze({
    APPEND: 'append',
    PREPEND: 'prepend'
});
function $238ea71ccb55dec6$var$convert(configs, request, optimisticUpdater, updater) {
    var configOptimisticUpdates = optimisticUpdater ? [
        optimisticUpdater
    ] : [];
    var configUpdates = updater ? [
        updater
    ] : [];
    configs.forEach(function(config) {
        switch(config.type){
            case 'NODE_DELETE':
                var nodeDeleteResult = $238ea71ccb55dec6$var$nodeDelete(config, request);
                if (nodeDeleteResult) {
                    configOptimisticUpdates.push(nodeDeleteResult);
                    configUpdates.push(nodeDeleteResult);
                }
                break;
            case 'RANGE_ADD':
                var rangeAddResult = $238ea71ccb55dec6$var$rangeAdd(config, request);
                if (rangeAddResult) {
                    configOptimisticUpdates.push(rangeAddResult);
                    configUpdates.push(rangeAddResult);
                }
                break;
            case 'RANGE_DELETE':
                var rangeDeleteResult = $238ea71ccb55dec6$var$rangeDelete(config, request);
                if (rangeDeleteResult) {
                    configOptimisticUpdates.push(rangeDeleteResult);
                    configUpdates.push(rangeDeleteResult);
                }
                break;
        }
    });
    return {
        optimisticUpdater: function optimisticUpdater(store, data) {
            configOptimisticUpdates.forEach(function(eachOptimisticUpdater) {
                eachOptimisticUpdater(store, data);
            });
        },
        updater: function updater(store, data) {
            configUpdates.forEach(function(eachUpdater) {
                eachUpdater(store, data);
            });
        }
    };
}
function $238ea71ccb55dec6$var$nodeDelete(config, request) {
    var deletedIDFieldName = config.deletedIDFieldName;
    var rootField = $238ea71ccb55dec6$var$getRootField(request);
    if (!rootField) return null;
    return function(store, data) {
        var payload = store.getRootField(rootField);
        if (!payload) return;
        var deleteID = payload.getValue(deletedIDFieldName);
        var deleteIDs = Array.isArray(deleteID) ? deleteID : [
            deleteID
        ];
        deleteIDs.forEach(function(id) {
            if (id && typeof id === 'string') store["delete"](id);
        });
    };
}
function $238ea71ccb55dec6$var$rangeAdd(config, request) {
    var parentID = config.parentID, connectionInfo = config.connectionInfo, edgeName = config.edgeName;
    if (!parentID) return null;
    var rootField = $238ea71ccb55dec6$var$getRootField(request);
    if (!connectionInfo || !rootField) return null;
    return function(store, data) {
        var parent = store.get(parentID);
        if (!parent) return;
        var payload = store.getRootField(rootField);
        if (!payload) return;
        var serverEdge = payload.getLinkedRecord(edgeName);
        var _iterator = (0, $238ea71ccb55dec6$var$_createForOfIteratorHelper2["default"])(connectionInfo), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var info = _step.value;
                if (!serverEdge) continue;
                var connection = $qhT86.getConnection(parent, info.key, info.filters);
                if (!connection) continue;
                var clientEdge = $qhT86.buildConnectionEdge(store, connection, serverEdge);
                if (!clientEdge) continue;
                switch(info.rangeBehavior){
                    case 'append':
                        $qhT86.insertEdgeAfter(connection, clientEdge);
                        break;
                    case 'prepend':
                        $qhT86.insertEdgeBefore(connection, clientEdge);
                        break;
                    default:
                        break;
                }
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
    };
}
function $238ea71ccb55dec6$var$rangeDelete(config, request) {
    var parentID = config.parentID, connectionKeys = config.connectionKeys, pathToConnection = config.pathToConnection, deletedIDFieldName = config.deletedIDFieldName;
    if (!parentID) return null;
    var rootField = $238ea71ccb55dec6$var$getRootField(request);
    if (!rootField) return null;
    return function(store, data) {
        if (!data) return;
        var deleteIDs = [];
        var deletedIDField = data[rootField];
        if (deletedIDField && Array.isArray(deletedIDFieldName)) {
            var _iterator2 = (0, $238ea71ccb55dec6$var$_createForOfIteratorHelper2["default"])(deletedIDFieldName), _step2;
            try {
                for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                    var eachField = _step2.value;
                    if (deletedIDField && typeof deletedIDField === 'object') deletedIDField = deletedIDField[eachField];
                }
            } catch (err) {
                _iterator2.e(err);
            } finally{
                _iterator2.f();
            }
            if (Array.isArray(deletedIDField)) deletedIDField.forEach(function(idObject) {
                if (idObject && idObject.id && typeof idObject === 'object' && typeof idObject.id === 'string') deleteIDs.push(idObject.id);
            });
            else if (deletedIDField && deletedIDField.id && typeof deletedIDField.id === 'string') deleteIDs.push(deletedIDField.id);
        } else if (deletedIDField && typeof deletedIDFieldName === 'string' && typeof deletedIDField === 'object') {
            deletedIDField = deletedIDField[deletedIDFieldName];
            if (typeof deletedIDField === 'string') deleteIDs.push(deletedIDField);
            else if (Array.isArray(deletedIDField)) deletedIDField.forEach(function(id) {
                if (typeof id === 'string') deleteIDs.push(id);
            });
        }
        $238ea71ccb55dec6$var$deleteNode(parentID, connectionKeys, pathToConnection, store, deleteIDs);
    };
}
function $238ea71ccb55dec6$var$deleteNode(parentID, connectionKeys, pathToConnection, store, deleteIDs) {
    var parent = store.get(parentID);
    if (!parent) return;
    if (pathToConnection.length < 2) return;
    var recordProxy = parent;
    for(var i = 1; i < pathToConnection.length - 1; i++)if (recordProxy) recordProxy = recordProxy.getLinkedRecord(pathToConnection[i]);
    if (!connectionKeys || !recordProxy) return;
    var _iterator3 = (0, $238ea71ccb55dec6$var$_createForOfIteratorHelper2["default"])(connectionKeys), _step3;
    try {
        var _loop = function _loop() {
            var key = _step3.value;
            var connection = $qhT86.getConnection(recordProxy, key.key, key.filters);
            if (connection) deleteIDs.forEach(function(deleteID) {
                $qhT86.deleteNode(connection, deleteID);
            });
        };
        for(_iterator3.s(); !(_step3 = _iterator3.n()).done;)_loop();
    } catch (err) {
        _iterator3.e(err);
    } finally{
        _iterator3.f();
    }
}
function $238ea71ccb55dec6$var$getRootField(request) {
    if (request.fragment.selections && request.fragment.selections.length > 0 && request.fragment.selections[0].kind === 'LinkedField') return request.fragment.selections[0].name;
    return null;
}
module.exports = {
    MutationTypes: $238ea71ccb55dec6$var$MutationTypes,
    RangeOperations: $238ea71ccb55dec6$var$RangeOperations,
    convert: $238ea71ccb55dec6$var$convert
};

});


parcelRegister("2vNtg", function(module, exports) {
'use strict';
function $1d44d9ea310440a8$var$commitLocalUpdate(environment, updater) {
    environment.commitUpdate(updater);
}
module.exports = $1d44d9ea310440a8$var$commitLocalUpdate;

});

parcelRegister("4S34J", function(module, exports) {
'use strict';

var $e27SU = parcelRequire("e27SU");
var $38be97412835025a$var$_interopRequireDefault = $e27SU.default;

var $38be97412835025a$var$_toConsumableArray2 = $38be97412835025a$var$_interopRequireDefault((parcelRequire("lLsx3")));

var $kLQDK = parcelRequire("kLQDK");
var $38be97412835025a$var$getRequest = $kLQDK.getRequest;

var $9pidS = parcelRequire("9pidS");
var $38be97412835025a$var$generateUniqueClientID = $9pidS.generateUniqueClientID;

var $jdpKt = parcelRequire("jdpKt");

var $gCG1q = parcelRequire("gCG1q");
var $38be97412835025a$var$createOperationDescriptor = $gCG1q.createOperationDescriptor;

var $33gLb = parcelRequire("33gLb");
parcelRequire("hschi");

var $jSI6G = parcelRequire("jSI6G");
parcelRequire("2OmBw");
function $38be97412835025a$var$commitMutation(environment, config) {
    !$jdpKt(environment) && $jSI6G(false);
    var mutation = $38be97412835025a$var$getRequest(config.mutation);
    if (mutation.params.operationKind !== 'mutation') throw new Error('commitMutation: Expected mutation operation');
    if (mutation.kind !== 'Request') throw new Error('commitMutation: Expected mutation to be of type request');
    var optimisticResponse = config.optimisticResponse, optimisticUpdater = config.optimisticUpdater, updater = config.updater;
    var configs = config.configs, cacheConfig = config.cacheConfig, onError = config.onError, onUnsubscribe = config.onUnsubscribe, variables = config.variables, uploadables = config.uploadables;
    var operation = $38be97412835025a$var$createOperationDescriptor(mutation, variables, cacheConfig, $38be97412835025a$var$generateUniqueClientID());
    if (typeof optimisticResponse === 'function') optimisticResponse = optimisticResponse();
    if (configs) {
        var _RelayDeclarativeMuta = $33gLb.convert(configs, mutation, optimisticUpdater, updater);
        optimisticUpdater = _RelayDeclarativeMuta.optimisticUpdater;
        updater = _RelayDeclarativeMuta.updater;
    }
    var errors = [];
    var subscription = environment.executeMutation({
        operation: operation,
        optimisticResponse: optimisticResponse,
        optimisticUpdater: optimisticUpdater,
        updater: updater,
        uploadables: uploadables
    }).subscribe({
        complete: function complete() {
            var onCompleted = config.onCompleted;
            if (onCompleted) {
                var snapshot = environment.lookup(operation.fragment);
                onCompleted(snapshot.data, errors.length !== 0 ? errors : null);
            }
        },
        error: onError,
        next: function next(payload) {
            var _config$onNext;
            if (Array.isArray(payload)) payload.forEach(function(item) {
                if (item.errors) errors.push.apply(errors, (0, $38be97412835025a$var$_toConsumableArray2["default"])(item.errors));
            });
            else if (payload.errors) errors.push.apply(errors, (0, $38be97412835025a$var$_toConsumableArray2["default"])(payload.errors));
            (_config$onNext = config.onNext) === null || _config$onNext === void 0 || _config$onNext.call(config);
        },
        unsubscribe: onUnsubscribe
    });
    return {
        dispose: subscription.unsubscribe
    };
}
module.exports = $38be97412835025a$var$commitMutation;

});
parcelRegister("hschi", function(module, exports) {
'use strict';

var $e27SU = parcelRequire("e27SU");
var $cb4e935dc3457efc$var$_interopRequireDefault = $e27SU.default;

var $cb4e935dc3457efc$var$_objectSpread2 = $cb4e935dc3457efc$var$_interopRequireDefault((parcelRequire("caqem")));
parcelRequire("2OmBw");
var $cb4e935dc3457efc$var$hasOwnProperty = Object.prototype.hasOwnProperty;
var $cb4e935dc3457efc$var$validateMutation = function validateMutation() {};
var $cb4e935dc3457efc$var$addFieldToDiff, $cb4e935dc3457efc$var$validateSelections, $cb4e935dc3457efc$var$validateSelection, $cb4e935dc3457efc$var$validateModuleImport, $cb4e935dc3457efc$var$validateAbstractKey, $cb4e935dc3457efc$var$validateField, $cb4e935dc3457efc$var$validateOptimisticResponse;
module.exports = $cb4e935dc3457efc$var$validateMutation;

});


parcelRegister("hM0OM", function(module, exports) {
'use strict';

var $lrIsZ = parcelRequire("lrIsZ");

var $esM7t = parcelRequire("esM7t");
var $cf078dd25267cf25$var$convertFetch = $esM7t.convertFetch;

var $jSI6G = parcelRequire("jSI6G");
function $cf078dd25267cf25$var$create(fetchFn, subscribe) {
    var observeFetch = $cf078dd25267cf25$var$convertFetch(fetchFn);
    function execute(request, variables, cacheConfig, uploadables, logRequestInfo) {
        var operationVariables = $lrIsZ(variables, request.providedVariables);
        if (request.operationKind === 'subscription') {
            !subscribe && $jSI6G(false);
            !!uploadables && $jSI6G(false);
            return subscribe(request, operationVariables, cacheConfig);
        }
        var pollInterval = cacheConfig.poll;
        if (pollInterval != null) {
            !!uploadables && $jSI6G(false);
            return observeFetch(request, operationVariables, {
                force: true
            }).poll(pollInterval);
        }
        return observeFetch(request, operationVariables, cacheConfig, uploadables, logRequestInfo);
    }
    return {
        execute: execute
    };
}
module.exports = {
    create: $cf078dd25267cf25$var$create
};

});
parcelRegister("lrIsZ", function(module, exports) {
'use strict';
parcelRequire("bke7t");
parcelRequire("2OmBw");
var $f9ce9cb8adbde98d$var$WEAKMAP_SUPPORTED = typeof WeakMap === 'function';
var $f9ce9cb8adbde98d$var$debugCache = $f9ce9cb8adbde98d$var$WEAKMAP_SUPPORTED ? new WeakMap() : new Map();
function $f9ce9cb8adbde98d$var$withProvidedVariables(userSuppliedVariables, providedVariables) {
    if (providedVariables != null) {
        var operationVariables = {};
        Object.assign(operationVariables, userSuppliedVariables);
        Object.keys(providedVariables).forEach(function(varName) {
            var providerFunction = providedVariables[varName].get;
            var providerResult = providerFunction();
            if (!$f9ce9cb8adbde98d$var$debugCache.has(providerFunction)) {
                $f9ce9cb8adbde98d$var$debugCache.set(providerFunction, providerResult);
                operationVariables[varName] = providerResult;
            } else {
                var cachedResult = $f9ce9cb8adbde98d$var$debugCache.get(providerFunction);
                operationVariables[varName] = cachedResult;
            }
        });
        return operationVariables;
    } else return userSuppliedVariables;
}
$f9ce9cb8adbde98d$var$withProvidedVariables.tests_only_resetDebugCache = undefined;
module.exports = $f9ce9cb8adbde98d$var$withProvidedVariables;

});

parcelRegister("esM7t", function(module, exports) {
'use strict';

var $5bMXV = parcelRequire("5bMXV");
function $a87901bec25bcb64$var$convertFetch(fn) {
    return function fetch(request, variables, cacheConfig, uploadables, logRequestInfo) {
        var result = fn(request, variables, cacheConfig, uploadables, logRequestInfo);
        if (result instanceof Error) return $5bMXV.create(function(sink) {
            return sink.error(result);
        });
        return $5bMXV.from(result);
    };
}
module.exports = {
    convertFetch: $a87901bec25bcb64$var$convertFetch
};

});


parcelRegister("8Y0RR", function(module, exports) {
'use strict';

var $e27SU = parcelRequire("e27SU");
var $687499a4132c0622$var$_interopRequireDefault = $e27SU.default;

var $687499a4132c0622$var$_objectSpread2 = $687499a4132c0622$var$_interopRequireDefault((parcelRequire("caqem")));

var $4hUjJ = parcelRequire("4hUjJ");
var $687499a4132c0622$var$stableCopy = $4hUjJ.stableCopy;

var $jSI6G = parcelRequire("jSI6G");
var $687499a4132c0622$var$RelayQueryResponseCache = /*#__PURE__*/ function() {
    function RelayQueryResponseCache(_ref) {
        var size = _ref.size, ttl = _ref.ttl;
        !(size > 0) && $jSI6G(false);
        !(ttl > 0) && $jSI6G(false);
        this._responses = new Map();
        this._size = size;
        this._ttl = ttl;
    }
    var _proto = RelayQueryResponseCache.prototype;
    _proto.clear = function clear() {
        this._responses.clear();
    };
    _proto.get = function get(queryID, variables) {
        var _this = this;
        var cacheKey = $687499a4132c0622$var$getCacheKey(queryID, variables);
        this._responses.forEach(function(response, key) {
            if (!$687499a4132c0622$var$isCurrent(response.fetchTime, _this._ttl)) _this._responses["delete"](key);
        });
        var response = this._responses.get(cacheKey);
        if (response == null) return null;
        if (Array.isArray(response.payload)) return response.payload.map(function(payload) {
            return (0, $687499a4132c0622$var$_objectSpread2["default"])((0, $687499a4132c0622$var$_objectSpread2["default"])({}, payload), {}, {
                extensions: (0, $687499a4132c0622$var$_objectSpread2["default"])((0, $687499a4132c0622$var$_objectSpread2["default"])({}, payload.extensions), {}, {
                    cacheTimestamp: response.fetchTime
                })
            });
        });
        return (0, $687499a4132c0622$var$_objectSpread2["default"])((0, $687499a4132c0622$var$_objectSpread2["default"])({}, response.payload), {}, {
            extensions: (0, $687499a4132c0622$var$_objectSpread2["default"])((0, $687499a4132c0622$var$_objectSpread2["default"])({}, response.payload.extensions), {}, {
                cacheTimestamp: response.fetchTime
            })
        });
    };
    _proto.set = function set(queryID, variables, payload) {
        var fetchTime = Date.now();
        var cacheKey = $687499a4132c0622$var$getCacheKey(queryID, variables);
        this._responses["delete"](cacheKey);
        this._responses.set(cacheKey, {
            fetchTime: fetchTime,
            payload: payload
        });
        if (this._responses.size > this._size) {
            var firstKey = this._responses.keys().next();
            if (!firstKey.done) this._responses["delete"](firstKey.value);
        }
    };
    return RelayQueryResponseCache;
}();
function $687499a4132c0622$var$getCacheKey(queryID, variables) {
    return JSON.stringify($687499a4132c0622$var$stableCopy({
        queryID: queryID,
        variables: variables
    }));
}
function $687499a4132c0622$var$isCurrent(fetchTime, ttl) {
    return fetchTime + ttl >= Date.now();
}
module.exports = $687499a4132c0622$var$RelayQueryResponseCache;

});

parcelRegister("749Kc", function(module, exports) {
'use strict';

var $e27SU = parcelRequire("e27SU");
var $525077205d9d5637$var$_interopRequireDefault = $e27SU.default;

var $525077205d9d5637$var$_objectSpread2 = $525077205d9d5637$var$_interopRequireDefault((parcelRequire("caqem")));

var $5bMXV = parcelRequire("5bMXV");

var $gCG1q = parcelRequire("gCG1q");
var $525077205d9d5637$var$createOperationDescriptor = $gCG1q.createOperationDescriptor;

var $ihTWZ = parcelRequire("ihTWZ");
var $525077205d9d5637$var$handlePotentialSnapshotErrors = $ihTWZ.handlePotentialSnapshotErrors;

var $3hl6N = parcelRequire("3hl6N");

var $kLQDK = parcelRequire("kLQDK");
var $525077205d9d5637$var$getRequest = $kLQDK.getRequest;

var $jSI6G = parcelRequire("jSI6G");
function $525077205d9d5637$var$fetchQuery(environment, query, variables, options) {
    var _options$fetchPolicy;
    var queryNode = $525077205d9d5637$var$getRequest(query);
    !(queryNode.params.operationKind === 'query') && $jSI6G(false);
    var networkCacheConfig = (0, $525077205d9d5637$var$_objectSpread2["default"])({
        force: true
    }, options === null || options === void 0 ? void 0 : options.networkCacheConfig);
    var operation = $525077205d9d5637$var$createOperationDescriptor(queryNode, variables, networkCacheConfig);
    var fetchPolicy = (_options$fetchPolicy = options === null || options === void 0 ? void 0 : options.fetchPolicy) !== null && _options$fetchPolicy !== void 0 ? _options$fetchPolicy : 'network-only';
    function readData(snapshot) {
        $525077205d9d5637$var$handlePotentialSnapshotErrors(environment, snapshot.fieldErrors);
        return snapshot.data;
    }
    switch(fetchPolicy){
        case 'network-only':
            return $525077205d9d5637$var$getNetworkObservable(environment, operation).map(readData);
        case 'store-or-network':
            var queryAvailability = environment.check(operation);
            var shouldFetch = queryAvailability.status !== 'available';
            var observable;
            if (!shouldFetch) observable = $5bMXV.from(environment.lookup(operation.fragment)).map(readData);
            else observable = $525077205d9d5637$var$getNetworkObservable(environment, operation).map(readData);
            environment.__log({
                name: 'fetchquery.fetch',
                operation: operation,
                fetchPolicy: fetchPolicy,
                queryAvailability: queryAvailability,
                shouldFetch: shouldFetch
            });
            return observable;
        default:
            fetchPolicy;
            throw new Error('fetchQuery: Invalid fetchPolicy ' + fetchPolicy);
    }
}
function $525077205d9d5637$var$getNetworkObservable(environment, operation) {
    return $3hl6N.fetchQuery(environment, operation).map(function() {
        return environment.lookup(operation.fragment);
    });
}
module.exports = $525077205d9d5637$var$fetchQuery;

});

parcelRegister("jywQ0", function(module, exports) {
'use strict';

var $gCG1q = parcelRequire("gCG1q");
var $e3caaa302da9c95c$var$createOperationDescriptor = $gCG1q.createOperationDescriptor;

var $kLQDK = parcelRequire("kLQDK");
var $e3caaa302da9c95c$var$getRequest = $kLQDK.getRequest;
function $e3caaa302da9c95c$var$fetchQuery_DEPRECATED(environment, taggedNode, variables, cacheConfig) {
    var query = $e3caaa302da9c95c$var$getRequest(taggedNode);
    if (query.params.operationKind !== 'query') throw new Error('fetchQuery: Expected query operation');
    var operation = $e3caaa302da9c95c$var$createOperationDescriptor(query, variables, cacheConfig);
    return environment.execute({
        operation: operation
    }).map(function() {
        return environment.lookup(operation.fragment).data;
    }).toPromise();
}
module.exports = $e3caaa302da9c95c$var$fetchQuery_DEPRECATED;

});

parcelRegister("kaSAu", function(module, exports) {
'use strict';
var $eaff15bec13fa303$var$PreloadableQueryRegistry = /*#__PURE__*/ function() {
    function PreloadableQueryRegistry() {
        this._preloadableQueries = new Map();
        this._callbacks = new Map();
    }
    var _proto = PreloadableQueryRegistry.prototype;
    _proto.set = function set(key, value) {
        this._preloadableQueries.set(key, value);
        var callbacks = this._callbacks.get(key);
        if (callbacks != null) callbacks.forEach(function(cb) {
            try {
                cb(value);
            } catch (e) {
                setTimeout(function() {
                    throw e;
                }, 0);
            }
        });
    };
    _proto.get = function get(key) {
        return this._preloadableQueries.get(key);
    };
    _proto.onLoad = function onLoad(key, callback) {
        var _this$_callbacks$get;
        var callbacks = (_this$_callbacks$get = this._callbacks.get(key)) !== null && _this$_callbacks$get !== void 0 ? _this$_callbacks$get : new Set();
        callbacks.add(callback);
        var dispose = function dispose() {
            callbacks["delete"](callback);
        };
        this._callbacks.set(key, callbacks);
        return {
            dispose: dispose
        };
    };
    _proto.clear = function clear() {
        this._preloadableQueries.clear();
    };
    return PreloadableQueryRegistry;
}();
var $eaff15bec13fa303$var$preloadableQueryRegistry = new $eaff15bec13fa303$var$PreloadableQueryRegistry();
module.exports = $eaff15bec13fa303$var$preloadableQueryRegistry;

});

parcelRegister("iqM8c", function(module, exports) {
'use strict';

var $5Ow6E = parcelRequire("5Ow6E");
parcelRequire("2OmBw");
function $03767392c75b74ef$var$createFragmentSpecResolver(context, containerName, fragments, props, rootIsQueryRenderer, callback) {
    var fragmentNames;
    return new $5Ow6E(context, fragments, props, callback, rootIsQueryRenderer);
}
module.exports = $03767392c75b74ef$var$createFragmentSpecResolver;

});
parcelRegister("5Ow6E", function(module, exports) {
'use strict';

var $e27SU = parcelRequire("e27SU");
var $43ba86e901d29f08$var$_interopRequireDefault = $e27SU.default;

var $43ba86e901d29f08$var$_objectSpread2 = $43ba86e901d29f08$var$_interopRequireDefault((parcelRequire("caqem")));

var $43ba86e901d29f08$var$_defineProperty2 = $43ba86e901d29f08$var$_interopRequireDefault((parcelRequire("2JBpp")));

var $hqyg2 = parcelRequire("hqyg2");

var $ihTWZ = parcelRequire("ihTWZ");
var $43ba86e901d29f08$var$handlePotentialSnapshotErrors = $ihTWZ.handlePotentialSnapshotErrors;

var $2YZAb = parcelRequire("2YZAb");

var $g0Xjw = parcelRequire("g0Xjw");

var $gZYpt = parcelRequire("gZYpt");

var $gCG1q = parcelRequire("gCG1q");
var $43ba86e901d29f08$var$createRequestDescriptor = $gCG1q.createRequestDescriptor;

var $iUq0k = parcelRequire("iUq0k");
var $43ba86e901d29f08$var$areEqualSelectors = $iUq0k.areEqualSelectors, $43ba86e901d29f08$var$createReaderSelector = $iUq0k.createReaderSelector, $43ba86e901d29f08$var$getSelectorsFromObject = $iUq0k.getSelectorsFromObject;

var $bke7t = parcelRequire("bke7t");

var $jSI6G = parcelRequire("jSI6G");
parcelRequire("2OmBw");
var $43ba86e901d29f08$var$RelayModernFragmentSpecResolver = /*#__PURE__*/ function() {
    function RelayModernFragmentSpecResolver(context, fragments, props, callback, rootIsQueryRenderer) {
        var _this = this;
        (0, $43ba86e901d29f08$var$_defineProperty2["default"])(this, "_onChange", function() {
            _this._stale = true;
            if (typeof _this._callback === 'function') _this._callback();
        });
        this._callback = callback;
        this._context = context;
        this._data = {};
        this._fragments = fragments;
        this._props = {};
        this._resolvers = {};
        this._stale = false;
        this._rootIsQueryRenderer = rootIsQueryRenderer;
        this.setProps(props);
    }
    var _proto = RelayModernFragmentSpecResolver.prototype;
    _proto.dispose = function dispose() {
        for(var key in this._resolvers)if (this._resolvers.hasOwnProperty(key)) $43ba86e901d29f08$var$disposeCallback(this._resolvers[key]);
    };
    _proto.resolve = function resolve() {
        if (this._stale) {
            var prevData = this._data;
            var nextData;
            for(var key in this._resolvers)if (this._resolvers.hasOwnProperty(key)) {
                var resolver = this._resolvers[key];
                var prevItem = prevData[key];
                if (resolver) {
                    var nextItem = resolver.resolve();
                    if (nextData || nextItem !== prevItem) {
                        nextData = nextData || (0, $43ba86e901d29f08$var$_objectSpread2["default"])({}, prevData);
                        nextData[key] = nextItem;
                    }
                } else {
                    var prop = this._props[key];
                    var _nextItem = prop !== undefined ? prop : null;
                    if (nextData || !$2YZAb(_nextItem, prevItem)) {
                        nextData = nextData || (0, $43ba86e901d29f08$var$_objectSpread2["default"])({}, prevData);
                        nextData[key] = _nextItem;
                    }
                }
            }
            this._data = nextData || prevData;
            this._stale = false;
        }
        return this._data;
    };
    _proto.setCallback = function setCallback(props, callback) {
        this._callback = callback;
        if ($gZYpt.ENABLE_CONTAINERS_SUBSCRIBE_ON_COMMIT === true) this.setProps(props);
    };
    _proto.setProps = function setProps(props) {
        this._props = {};
        var ownedSelectors = $43ba86e901d29f08$var$getSelectorsFromObject(this._fragments, props);
        for(var key in ownedSelectors)if (ownedSelectors.hasOwnProperty(key)) {
            var ownedSelector = ownedSelectors[key];
            var resolver = this._resolvers[key];
            if (ownedSelector == null) {
                if (resolver != null) resolver.dispose();
                resolver = null;
            } else if (ownedSelector.kind === 'PluralReaderSelector') {
                if (resolver == null) resolver = new $43ba86e901d29f08$var$SelectorListResolver(this._context.environment, this._rootIsQueryRenderer, ownedSelector, this._callback != null, this._onChange);
                else {
                    !(resolver instanceof $43ba86e901d29f08$var$SelectorListResolver) && $jSI6G(false);
                    resolver.setSelector(ownedSelector);
                }
            } else if (resolver == null) resolver = new $43ba86e901d29f08$var$SelectorResolver(this._context.environment, this._rootIsQueryRenderer, ownedSelector, this._callback != null, this._onChange);
            else {
                !(resolver instanceof $43ba86e901d29f08$var$SelectorResolver) && $jSI6G(false);
                resolver.setSelector(ownedSelector);
            }
            this._props[key] = props[key];
            this._resolvers[key] = resolver;
        }
        this._stale = true;
    };
    _proto.setVariables = function setVariables(variables, request) {
        for(var key in this._resolvers)if (this._resolvers.hasOwnProperty(key)) {
            var resolver = this._resolvers[key];
            if (resolver) resolver.setVariables(variables, request);
        }
        this._stale = true;
    };
    return RelayModernFragmentSpecResolver;
}();
var $43ba86e901d29f08$var$SelectorResolver = /*#__PURE__*/ function() {
    function SelectorResolver(environment, rootIsQueryRenderer, selector, subscribeOnConstruction, callback) {
        var _this2 = this;
        (0, $43ba86e901d29f08$var$_defineProperty2["default"])(this, "_onChange", function(snapshot) {
            _this2._data = snapshot.data;
            _this2._isMissingData = snapshot.isMissingData;
            _this2._fieldErrors = snapshot.fieldErrors;
            _this2._callback();
        });
        var _snapshot = environment.lookup(selector);
        this._callback = callback;
        this._data = _snapshot.data;
        this._isMissingData = _snapshot.isMissingData;
        this._fieldErrors = _snapshot.fieldErrors;
        this._environment = environment;
        this._rootIsQueryRenderer = rootIsQueryRenderer;
        this._selector = selector;
        if ($gZYpt.ENABLE_CONTAINERS_SUBSCRIBE_ON_COMMIT === true) {
            if (subscribeOnConstruction) this._subscription = environment.subscribe(_snapshot, this._onChange);
        } else this._subscription = environment.subscribe(_snapshot, this._onChange);
    }
    var _proto2 = SelectorResolver.prototype;
    _proto2.dispose = function dispose() {
        if (this._subscription) {
            this._subscription.dispose();
            this._subscription = null;
        }
    };
    _proto2.resolve = function resolve() {
        if (this._isMissingData === true) {
            var pendingOperationsResult = $hqyg2(this._environment, this._selector.node, this._selector.owner);
            var promise = pendingOperationsResult === null || pendingOperationsResult === void 0 ? void 0 : pendingOperationsResult.promise;
            if (promise != null) {
                if (this._rootIsQueryRenderer) ;
                else {
                    var _pendingOperationsRes;
                    var pendingOperations = (_pendingOperationsRes = pendingOperationsResult === null || pendingOperationsResult === void 0 ? void 0 : pendingOperationsResult.pendingOperations) !== null && _pendingOperationsRes !== void 0 ? _pendingOperationsRes : [];
                    this._environment.__log({
                        name: 'suspense.fragment',
                        data: this._data,
                        fragment: this._selector.node,
                        isRelayHooks: false,
                        isMissingData: this._isMissingData,
                        isPromiseCached: false,
                        pendingOperations: pendingOperations
                    });
                    throw promise;
                }
            }
        }
        $43ba86e901d29f08$var$handlePotentialSnapshotErrors(this._environment, this._fieldErrors);
        return this._data;
    };
    _proto2.setSelector = function setSelector(selector) {
        if (this._subscription != null && $43ba86e901d29f08$var$areEqualSelectors(selector, this._selector)) return;
        this.dispose();
        var snapshot = this._environment.lookup(selector);
        this._data = $g0Xjw(this._data, snapshot.data);
        this._isMissingData = snapshot.isMissingData;
        this._fieldErrors = snapshot.fieldErrors;
        this._selector = selector;
        this._subscription = this._environment.subscribe(snapshot, this._onChange);
    };
    _proto2.setVariables = function setVariables(variables, request) {
        if ($bke7t(variables, this._selector.variables)) return;
        var requestDescriptor = $43ba86e901d29f08$var$createRequestDescriptor(request, variables);
        var selector = $43ba86e901d29f08$var$createReaderSelector(this._selector.node, this._selector.dataID, variables, requestDescriptor);
        this.setSelector(selector);
    };
    return SelectorResolver;
}();
var $43ba86e901d29f08$var$SelectorListResolver = /*#__PURE__*/ function() {
    function SelectorListResolver(environment, rootIsQueryRenderer, selector, subscribeOnConstruction, callback) {
        var _this3 = this;
        (0, $43ba86e901d29f08$var$_defineProperty2["default"])(this, "_onChange", function(data) {
            _this3._stale = true;
            _this3._callback();
        });
        this._callback = callback;
        this._data = [];
        this._environment = environment;
        this._resolvers = [];
        this._stale = true;
        this._rootIsQueryRenderer = rootIsQueryRenderer;
        this._subscribeOnConstruction = subscribeOnConstruction;
        this.setSelector(selector);
    }
    var _proto3 = SelectorListResolver.prototype;
    _proto3.dispose = function dispose() {
        this._resolvers.forEach($43ba86e901d29f08$var$disposeCallback);
    };
    _proto3.resolve = function resolve() {
        if (this._stale) {
            var prevData = this._data;
            var nextData;
            for(var ii = 0; ii < this._resolvers.length; ii++){
                var prevItem = prevData[ii];
                var nextItem = this._resolvers[ii].resolve();
                if (nextData || nextItem !== prevItem) {
                    nextData = nextData || prevData.slice(0, ii);
                    nextData.push(nextItem);
                }
            }
            if (!nextData && this._resolvers.length !== prevData.length) nextData = prevData.slice(0, this._resolvers.length);
            this._data = nextData || prevData;
            this._stale = false;
        }
        return this._data;
    };
    _proto3.setSelector = function setSelector(selector) {
        var selectors = selector.selectors;
        while(this._resolvers.length > selectors.length){
            var resolver = this._resolvers.pop();
            resolver.dispose();
        }
        for(var ii = 0; ii < selectors.length; ii++)if (ii < this._resolvers.length) this._resolvers[ii].setSelector(selectors[ii]);
        else this._resolvers[ii] = new $43ba86e901d29f08$var$SelectorResolver(this._environment, this._rootIsQueryRenderer, selectors[ii], this._subscribeOnConstruction, this._onChange);
        this._stale = true;
    };
    _proto3.setVariables = function setVariables(variables, request) {
        this._resolvers.forEach(function(resolver) {
            return resolver.setVariables(variables, request);
        });
        this._stale = true;
    };
    return SelectorListResolver;
}();
function $43ba86e901d29f08$var$disposeCallback(disposable) {
    disposable && disposable.dispose();
}
module.exports = $43ba86e901d29f08$var$RelayModernFragmentSpecResolver;

});
parcelRegister("hqyg2", function(module, exports) {
'use strict';

var $3hl6N = parcelRequire("3hl6N");
var $caff703b401d7381$var$getPromiseForActiveRequest = $3hl6N.getPromiseForActiveRequest;
function $caff703b401d7381$var$getPendingOperationsForFragment(environment, fragmentNode, fragmentOwner) {
    var _pendingOperations$ma, _pendingOperations;
    var pendingOperations = [];
    var promise = $caff703b401d7381$var$getPromiseForActiveRequest(environment, fragmentOwner);
    if (promise != null) pendingOperations = [
        fragmentOwner
    ];
    else {
        var _result$pendingOperat, _result$promise;
        var operationTracker = environment.getOperationTracker();
        var result = operationTracker.getPendingOperationsAffectingOwner(fragmentOwner);
        pendingOperations = (_result$pendingOperat = result === null || result === void 0 ? void 0 : result.pendingOperations) !== null && _result$pendingOperat !== void 0 ? _result$pendingOperat : [];
        promise = (_result$promise = result === null || result === void 0 ? void 0 : result.promise) !== null && _result$promise !== void 0 ? _result$promise : null;
    }
    if (!promise) return null;
    var pendingOperationName = (_pendingOperations$ma = (_pendingOperations = pendingOperations) === null || _pendingOperations === void 0 ? void 0 : _pendingOperations.map(function(op) {
        return op.node.params.name;
    }).join(',')) !== null && _pendingOperations$ma !== void 0 ? _pendingOperations$ma : null;
    if (pendingOperationName == null || pendingOperationName.length === 0) pendingOperationName = 'Unknown pending operation';
    var fragmentName = fragmentNode.name;
    var promiseDisplayName = pendingOperationName === fragmentName ? "Relay(".concat(pendingOperationName, ")") : "Relay(".concat(pendingOperationName, ":").concat(fragmentName, ")");
    promise.displayName = promiseDisplayName;
    environment.__log({
        name: 'pendingoperation.found',
        fragment: fragmentNode,
        fragmentOwner: fragmentOwner,
        pendingOperations: pendingOperations
    });
    return {
        promise: promise,
        pendingOperations: pendingOperations
    };
}
module.exports = $caff703b401d7381$var$getPendingOperationsForFragment;

});

parcelRegister("2YZAb", function(module, exports) {
'use strict';
function $22c0f45f84f24784$var$isScalarAndEqual(valueA, valueB) {
    return valueA === valueB && (valueA === null || typeof valueA !== 'object');
}
module.exports = $22c0f45f84f24784$var$isScalarAndEqual;

});

parcelRegister("g0Xjw", function(module, exports) {
'use strict';
function $ba8aa7e75a218d9c$var$recycleNodesInto(prevData, nextData) {
    return $ba8aa7e75a218d9c$var$recycleNodesIntoImpl(prevData, nextData, true);
}
function $ba8aa7e75a218d9c$var$recycleNodesIntoImpl(prevData, nextData, canMutate) {
    if (prevData === nextData || typeof prevData !== 'object' || !prevData || prevData.constructor !== Object && !Array.isArray(prevData) || typeof nextData !== 'object' || !nextData || nextData.constructor !== Object && !Array.isArray(nextData)) return nextData;
    var canRecycle = false;
    var prevArray = Array.isArray(prevData) ? prevData : null;
    var nextArray = Array.isArray(nextData) ? nextData : null;
    if (prevArray && nextArray) {
        var canMutateNext = canMutate && !Object.isFrozen(nextArray);
        canRecycle = nextArray.reduce(function(wasEqual, nextItem, ii) {
            var prevValue = prevArray[ii];
            var nextValue = $ba8aa7e75a218d9c$var$recycleNodesIntoImpl(prevValue, nextItem, canMutateNext);
            if (nextValue !== nextArray[ii] && canMutateNext) nextArray[ii] = nextValue;
            return wasEqual && nextValue === prevArray[ii];
        }, true) && prevArray.length === nextArray.length;
    } else if (!prevArray && !nextArray) {
        var prevObject = prevData;
        var nextObject = nextData;
        var prevKeys = Object.keys(prevObject);
        var nextKeys = Object.keys(nextObject);
        var _canMutateNext = canMutate && !Object.isFrozen(nextObject);
        canRecycle = nextKeys.reduce(function(wasEqual, key) {
            var prevValue = prevObject[key];
            var nextValue = $ba8aa7e75a218d9c$var$recycleNodesIntoImpl(prevValue, nextObject[key], _canMutateNext);
            if (nextValue !== nextObject[key] && _canMutateNext) nextObject[key] = nextValue;
            return wasEqual && nextValue === prevObject[key];
        }, true) && prevKeys.length === nextKeys.length;
    }
    return canRecycle ? prevData : nextData;
}
module.exports = $ba8aa7e75a218d9c$var$recycleNodesInto;

});



parcelRegister("1ixaM", function(module, exports) {
'use strict';

var $jSI6G = parcelRequire("jSI6G");
var $0f213450b1408c7d$var$relayContext;
var $0f213450b1408c7d$var$firstReact;
function $0f213450b1408c7d$var$createRelayContext(react) {
    if (!$0f213450b1408c7d$var$relayContext) {
        $0f213450b1408c7d$var$relayContext = react.createContext(null);
        $0f213450b1408c7d$var$firstReact = react;
    }
    !(react === $0f213450b1408c7d$var$firstReact) && $jSI6G(false);
    return $0f213450b1408c7d$var$relayContext;
}
module.exports = $0f213450b1408c7d$var$createRelayContext;

});

parcelRegister("8ndPx", function(module, exports) {
'use strict';

var $jSI6G = parcelRequire("jSI6G");
var $618b33207200caaa$var$relayLoggingContext;
var $618b33207200caaa$var$firstReact;
function $618b33207200caaa$var$createRelayLoggingContext(react) {
    if (!$618b33207200caaa$var$relayLoggingContext) {
        $618b33207200caaa$var$relayLoggingContext = react.createContext(null);
        $618b33207200caaa$var$firstReact = react;
    }
    !(react === $618b33207200caaa$var$firstReact) && $jSI6G(false);
    return $618b33207200caaa$var$relayLoggingContext;
}
module.exports = $618b33207200caaa$var$createRelayLoggingContext;

});

parcelRegister("9pOE6", function(module, exports) {
'use strict';

var $fsmz0 = parcelRequire("fsmz0");
var $6dadbc1225fa1c53$var$VIEWER_ID = $fsmz0.VIEWER_ID, $6dadbc1225fa1c53$var$VIEWER_TYPE = $fsmz0.VIEWER_TYPE;
function $6dadbc1225fa1c53$var$defaultGetDataID(fieldValue, typeName) {
    if (typeName === $6dadbc1225fa1c53$var$VIEWER_TYPE) return fieldValue.id == null ? $6dadbc1225fa1c53$var$VIEWER_ID : fieldValue.id;
    return fieldValue.id;
}
module.exports = $6dadbc1225fa1c53$var$defaultGetDataID;

});
parcelRegister("fsmz0", function(module, exports) {
'use strict';

var $9pidS = parcelRequire("9pidS");
var $b40af92e936102ed$var$generateClientID = $9pidS.generateClientID;

var $ezyIu = parcelRequire("ezyIu");
var $b40af92e936102ed$var$ROOT_ID = $ezyIu.ROOT_ID;
var $b40af92e936102ed$var$VIEWER_ID = $b40af92e936102ed$var$generateClientID($b40af92e936102ed$var$ROOT_ID, 'viewer');
var $b40af92e936102ed$var$VIEWER_TYPE = 'Viewer';
module.exports = {
    VIEWER_ID: $b40af92e936102ed$var$VIEWER_ID,
    VIEWER_TYPE: $b40af92e936102ed$var$VIEWER_TYPE
};

});


parcelRegister("fYxIJ", function(module, exports) {
'use strict';
var $ba169dc978a0fc39$var$LIVE_RESOLVER_SUSPENSE_SENTINEL = Object.freeze({
    __LIVE_RESOLVER_SUSPENSE_SENTINEL: true
});
function $ba169dc978a0fc39$var$suspenseSentinel() {
    return $ba169dc978a0fc39$var$LIVE_RESOLVER_SUSPENSE_SENTINEL;
}
function $ba169dc978a0fc39$var$isSuspenseSentinel(value) {
    return value === $ba169dc978a0fc39$var$LIVE_RESOLVER_SUSPENSE_SENTINEL;
}
module.exports = {
    isSuspenseSentinel: $ba169dc978a0fc39$var$isSuspenseSentinel,
    suspenseSentinel: $ba169dc978a0fc39$var$suspenseSentinel
};

});

parcelRegister("eRaWx", function(module, exports) {
'use strict';

var $e27SU = parcelRequire("e27SU");
var $ad0e810596bfd29b$var$_interopRequireDefault = $e27SU.default;

var $ad0e810596bfd29b$var$_objectSpread2 = $ad0e810596bfd29b$var$_interopRequireDefault((parcelRequire("caqem")));

var $ad0e810596bfd29b$var$_toConsumableArray2 = $ad0e810596bfd29b$var$_interopRequireDefault((parcelRequire("lLsx3")));

var $4hUjJ = parcelRequire("4hUjJ");
var $ad0e810596bfd29b$var$stableCopy = $4hUjJ.stableCopy;

var $9pidS = parcelRequire("9pidS");
var $ad0e810596bfd29b$var$generateClientID = $9pidS.generateClientID;

var $9pOE6 = parcelRequire("9pOE6");

var $7SC8Z = parcelRequire("7SC8Z");

var $iUq0k = parcelRequire("iUq0k");
var $ad0e810596bfd29b$var$createNormalizationSelector = $iUq0k.createNormalizationSelector;

var $ezyIu = parcelRequire("ezyIu");
var $ad0e810596bfd29b$var$ROOT_ID = $ezyIu.ROOT_ID, $ad0e810596bfd29b$var$ROOT_TYPE = $ezyIu.ROOT_TYPE, $ad0e810596bfd29b$var$getStorageKey = $ezyIu.getStorageKey;
function $ad0e810596bfd29b$var$err(message) {
    var e = new Error(message);
    e.stack;
    return e;
}
function $ad0e810596bfd29b$var$stableStringify(value) {
    var _JSON$stringify;
    return (_JSON$stringify = JSON.stringify($ad0e810596bfd29b$var$stableCopy(value))) !== null && _JSON$stringify !== void 0 ? _JSON$stringify : '';
}
var $ad0e810596bfd29b$var$NormalizationEngine = /*#__PURE__*/ function() {
    function NormalizationEngine(config) {
        var _config$operationLoad, _config$getDataID, _config$treatMissingF, _ref, _config$operation$use, _config$operation$exe;
        this._normalizeResponse = config.normalizeResponse;
        this._operationLoader = (_config$operationLoad = config.operationLoader) !== null && _config$operationLoad !== void 0 ? _config$operationLoad : null;
        this._rootSelector = {
            dataID: $ad0e810596bfd29b$var$ROOT_ID,
            node: config.operation,
            variables: config.variables
        };
        this._options = {
            deferDeduplicatedFields: false,
            getDataID: (_config$getDataID = config.getDataID) !== null && _config$getDataID !== void 0 ? _config$getDataID : $9pOE6,
            log: null,
            path: [],
            treatMissingFieldsAsNull: (_config$treatMissingF = config.treatMissingFieldsAsNull) !== null && _config$treatMissingF !== void 0 ? _config$treatMissingF : false
        };
        this._useExecTimeResolvers = (_ref = (_config$operation$use = config.operation.use_exec_time_resolvers) !== null && _config$operation$use !== void 0 ? _config$operation$use : ((_config$operation$exe = config.operation.exec_time_resolvers_enabled_provider) === null || _config$operation$exe === void 0 ? void 0 : _config$operation$exe.get()) === true) !== null && _ref !== void 0 ? _ref : false;
        this._placeholders = new Map();
        this._bufferedResponses = new Map();
        this._parentRecords = new Map();
        this._serverComplete = false;
    }
    var _proto = NormalizationEngine.prototype;
    _proto.processResponse = function processResponse(response) {
        var payload = this._normalizeResponse(response, this._rootSelector, $ad0e810596bfd29b$var$ROOT_TYPE, this._options, this._useExecTimeResolvers);
        var extraPayloads = [];
        var pendingModules = [];
        if (payload.incrementalPlaceholders != null && payload.incrementalPlaceholders.length > 0) this._registerPlaceholders(payload.incrementalPlaceholders, payload.source, payload.fieldPayloads, extraPayloads, pendingModules);
        if (payload.followupPayloads != null && payload.followupPayloads.length > 0) this._processFollowups(payload.followupPayloads, extraPayloads, pendingModules);
        var primaryPayload = (0, $ad0e810596bfd29b$var$_objectSpread2["default"])((0, $ad0e810596bfd29b$var$_objectSpread2["default"])({}, payload), {}, {
            followupPayloads: null,
            incrementalPlaceholders: null,
            isFinal: this._computeIsFinal(payload.isFinal),
            isPreNormalized: true
        });
        return {
            payloads: [
                primaryPayload
            ].concat(extraPayloads),
            pendingModules: pendingModules
        };
    };
    _proto.processIncrementalResponse = function processIncrementalResponse(response) {
        var label = response.label;
        var path = response.path;
        if (label == null || path == null) throw $ad0e810596bfd29b$var$err("NormalizationEngine: Expected incremental response to have `label` and `path` properties.");
        var isDefer = label.indexOf('$defer$') !== -1;
        var pathKey = isDefer ? path.map(String).join('.') : path.slice(0, -2).map(String).join('.');
        var key = $ad0e810596bfd29b$var$makeKey(label, pathKey);
        var placeholder = this._placeholders.get(key);
        if (placeholder == null) {
            var buffer = this._bufferedResponses.get(key);
            if (buffer == null) {
                buffer = [];
                this._bufferedResponses.set(key, buffer);
            }
            buffer.push(response);
            return null;
        }
        if (placeholder.kind === 'defer') return this._processDefer(response, path, placeholder);
        else return this._processStream(response, path, placeholder);
    };
    _proto.setServerComplete = function setServerComplete() {
        this._serverComplete = true;
    };
    _proto.isFinal = function isFinal() {
        return this._serverComplete && this._bufferedResponses.size === 0 && this._placeholders.size === 0;
    };
    _proto._processDefer = function _processDefer(response, _path, placeholder) {
        var payload = this._normalizeResponse(response, placeholder.selector, placeholder.typeName, (0, $ad0e810596bfd29b$var$_objectSpread2["default"])((0, $ad0e810596bfd29b$var$_objectSpread2["default"])({}, this._options), {}, {
            deferDeduplicatedFields: true,
            path: placeholder.path
        }), this._useExecTimeResolvers);
        var extraPayloads = [];
        var pendingModules = [];
        if (payload.incrementalPlaceholders != null && payload.incrementalPlaceholders.length > 0) this._registerPlaceholders(payload.incrementalPlaceholders, payload.source, payload.fieldPayloads, extraPayloads, pendingModules);
        if (payload.followupPayloads != null && payload.followupPayloads.length > 0) this._processFollowups(payload.followupPayloads, extraPayloads, pendingModules);
        var parentID = placeholder.selector.dataID;
        var parentEntry = this._parentRecords.get(parentID);
        var fieldPayloads = payload.fieldPayloads;
        if (parentEntry != null && parentEntry.fieldPayloads.length > 0) {
            var _fieldPayloads;
            fieldPayloads = ((_fieldPayloads = fieldPayloads) !== null && _fieldPayloads !== void 0 ? _fieldPayloads : []).concat(parentEntry.fieldPayloads);
        }
        var primaryPayload = (0, $ad0e810596bfd29b$var$_objectSpread2["default"])((0, $ad0e810596bfd29b$var$_objectSpread2["default"])({}, payload), {}, {
            fieldPayloads: fieldPayloads,
            followupPayloads: null,
            incrementalPlaceholders: null,
            isFinal: this._computeIsFinal(payload.isFinal),
            isPreNormalized: true
        });
        return {
            payloads: [
                primaryPayload
            ].concat(extraPayloads),
            pendingModules: pendingModules
        };
    };
    _proto._processStream = function _processStream(response, path, placeholder) {
        var node = placeholder.node, parentID = placeholder.parentID, variables = placeholder.variables;
        var field = node.selections[0];
        if (field == null || field.kind !== 'LinkedField' || field.plural !== true) throw $ad0e810596bfd29b$var$err('NormalizationEngine: Expected @stream to be used on a plural field.');
        var _this$_normalizeStrea = this._normalizeStreamItem(response, parentID, field, variables, path, placeholder.path), fieldPayloads = _this$_normalizeStrea.fieldPayloads, itemID = _this$_normalizeStrea.itemID, itemIndex = _this$_normalizeStrea.itemIndex, prevIDs = _this$_normalizeStrea.prevIDs, relayPayload = _this$_normalizeStrea.relayPayload, storageKey = _this$_normalizeStrea.storageKey;
        var storeUpdater = function storeUpdater(store) {
            var currentParentRecord = store.get(parentID);
            if (currentParentRecord == null) return;
            var currentItems = currentParentRecord.getLinkedRecords(storageKey);
            if (currentItems == null) return;
            if (currentItems.length !== prevIDs.length || currentItems.some(function(item, i) {
                return prevIDs[i] !== (item && item.getDataID());
            })) return;
            var nextItems = (0, $ad0e810596bfd29b$var$_toConsumableArray2["default"])(currentItems);
            nextItems[itemIndex] = store.get(itemID);
            currentParentRecord.setLinkedRecords(nextItems, storageKey);
        };
        var mergedFieldPayloads = relayPayload.fieldPayloads;
        if (fieldPayloads.length > 0) {
            var _mergedFieldPayloads;
            mergedFieldPayloads = ((_mergedFieldPayloads = mergedFieldPayloads) !== null && _mergedFieldPayloads !== void 0 ? _mergedFieldPayloads : []).concat(fieldPayloads);
        }
        return {
            payloads: [
                (0, $ad0e810596bfd29b$var$_objectSpread2["default"])((0, $ad0e810596bfd29b$var$_objectSpread2["default"])({}, relayPayload), {}, {
                    fieldPayloads: mergedFieldPayloads,
                    followupPayloads: null,
                    incrementalPlaceholders: null,
                    isFinal: this._computeIsFinal(relayPayload.isFinal),
                    isPreNormalized: true,
                    storeUpdater: storeUpdater
                })
            ],
            pendingModules: []
        };
    };
    _proto._normalizeStreamItem = function _normalizeStreamItem(response, parentID, field, variables, path, normalizationPath) {
        var _field$alias, _field$concreteType, _ref2, _ref3;
        var data = response.data;
        if (typeof data !== 'object') throw $ad0e810596bfd29b$var$err("NormalizationEngine: Expected the GraphQL @stream payload `data` value to be an object.");
        var responseKey = (_field$alias = field.alias) !== null && _field$alias !== void 0 ? _field$alias : field.name;
        var storageKey = $ad0e810596bfd29b$var$getStorageKey(field, variables);
        var parentEntry = this._parentRecords.get(parentID);
        if (parentEntry == null) throw $ad0e810596bfd29b$var$err('NormalizationEngine: Expected the parent record `' + parentID + '` for @stream data to exist.');
        var fieldPayloads = parentEntry.fieldPayloads, parentRecord = parentEntry.record;
        var prevIDs = $7SC8Z.getLinkedRecordIDs(parentRecord, storageKey);
        if (prevIDs == null) throw $ad0e810596bfd29b$var$err('NormalizationEngine: Expected record `' + parentID + '` to have fetched field `' + field.name + '` with @stream.');
        var finalPathEntry = path[path.length - 1];
        var itemIndex = parseInt(finalPathEntry, 10);
        if (itemIndex !== finalPathEntry || itemIndex < 0) throw $ad0e810596bfd29b$var$err("NormalizationEngine: Expected path for @stream to end in a positive integer index, got `" + String(finalPathEntry) + '`');
        var typeName = (_field$concreteType = field.concreteType) !== null && _field$concreteType !== void 0 ? _field$concreteType : data.__typename;
        if (typeof typeName !== 'string') throw $ad0e810596bfd29b$var$err('NormalizationEngine: Expected @stream field `' + field.name + '` to have a __typename.');
        var getDataID = this._options.getDataID;
        var itemID = (_ref2 = (_ref3 = typeof getDataID === 'function' ? getDataID(data, typeName) : null) !== null && _ref3 !== void 0 ? _ref3 : prevIDs === null || prevIDs === void 0 ? void 0 : prevIDs[itemIndex]) !== null && _ref2 !== void 0 ? _ref2 : $ad0e810596bfd29b$var$generateClientID(parentID, storageKey, itemIndex);
        if (typeof itemID !== 'string') throw $ad0e810596bfd29b$var$err('NormalizationEngine: Expected id of elements of field `' + storageKey + '` to be strings.');
        var selector = $ad0e810596bfd29b$var$createNormalizationSelector(field, itemID, variables);
        var nextParentRecord = $7SC8Z.clone(parentRecord);
        var nextIDs = (0, $ad0e810596bfd29b$var$_toConsumableArray2["default"])(prevIDs);
        nextIDs[itemIndex] = itemID;
        $7SC8Z.setLinkedRecordIDs(nextParentRecord, storageKey, nextIDs);
        this._parentRecords.set(parentID, {
            fieldPayloads: fieldPayloads,
            record: nextParentRecord
        });
        var relayPayload = this._normalizeResponse(response, selector, typeName, (0, $ad0e810596bfd29b$var$_objectSpread2["default"])((0, $ad0e810596bfd29b$var$_objectSpread2["default"])({}, this._options), {}, {
            path: [].concat((0, $ad0e810596bfd29b$var$_toConsumableArray2["default"])(normalizationPath), [
                responseKey,
                String(itemIndex)
            ])
        }), this._useExecTimeResolvers);
        return {
            fieldPayloads: fieldPayloads,
            itemID: itemID,
            itemIndex: itemIndex,
            prevIDs: prevIDs,
            relayPayload: relayPayload,
            storageKey: storageKey
        };
    };
    _proto._registerPlaceholders = function _registerPlaceholders(placeholders, source, fieldPayloads, outPayloads, outPendingModules) {
        var _this = this;
        var _loop = function _loop(i) {
            var placeholder = placeholders[i];
            var label = placeholder.label, path = placeholder.path;
            var pathKey = path.map(String).join('.');
            var key = $ad0e810596bfd29b$var$makeKey(label, pathKey);
            _this._placeholders.set(key, placeholder);
            var parentID = void 0;
            if (placeholder.kind === 'stream') parentID = placeholder.parentID;
            else parentID = placeholder.selector.dataID;
            var parentRecord = source.get(parentID);
            if (parentRecord == null) throw $ad0e810596bfd29b$var$err('NormalizationEngine: Expected record `' + parentID + '` to exist.');
            var parentPayloads = (fieldPayloads !== null && fieldPayloads !== void 0 ? fieldPayloads : []).filter(function(fieldPayload) {
                var fieldID = $ad0e810596bfd29b$var$generateClientID(fieldPayload.dataID, fieldPayload.fieldKey);
                return fieldPayload.dataID === parentID || fieldID === parentID;
            });
            var previousEntry = _this._parentRecords.get(parentID);
            if (previousEntry != null) {
                var nextRecord = $7SC8Z.update(previousEntry.record, parentRecord);
                var handlePayloads = new Map();
                for(var j = 0; j < previousEntry.fieldPayloads.length; j++){
                    var p = previousEntry.fieldPayloads[j];
                    handlePayloads.set($ad0e810596bfd29b$var$stableStringify(p), p);
                }
                for(var _j = 0; _j < parentPayloads.length; _j++){
                    var _p = parentPayloads[_j];
                    handlePayloads.set($ad0e810596bfd29b$var$stableStringify(_p), _p);
                }
                _this._parentRecords.set(parentID, {
                    fieldPayloads: Array.from(handlePayloads.values()),
                    record: nextRecord
                });
            } else _this._parentRecords.set(parentID, {
                fieldPayloads: parentPayloads,
                record: parentRecord
            });
            var buffered = _this._bufferedResponses.get(key);
            if (buffered != null) {
                _this._bufferedResponses["delete"](key);
                for(var _j2 = 0; _j2 < buffered.length; _j2++){
                    var resp = buffered[_j2];
                    var result = void 0;
                    if (placeholder.kind === 'defer') result = _this._processDefer(resp, (_resp$path = resp.path) !== null && _resp$path !== void 0 ? _resp$path : [], placeholder);
                    else result = _this._processStream(resp, (_resp$path2 = resp.path) !== null && _resp$path2 !== void 0 ? _resp$path2 : [], placeholder);
                    if (result != null) {
                        outPayloads.push.apply(outPayloads, (0, $ad0e810596bfd29b$var$_toConsumableArray2["default"])(result.payloads));
                        outPendingModules.push.apply(outPendingModules, (0, $ad0e810596bfd29b$var$_toConsumableArray2["default"])(result.pendingModules));
                    }
                }
            }
        };
        for(var i = 0; i < placeholders.length; i++){
            var _resp$path;
            var _resp$path2;
            _loop(i);
        }
    };
    _proto._processFollowups = function _processFollowups(followups, outPayloads, outPendingModules) {
        for(var i = 0; i < followups.length; i++){
            var followup = followups[i];
            if (followup.kind === 'ModuleImportPayload') this._processModuleImport(followup, outPayloads, outPendingModules);
        }
    };
    _proto._processModuleImport = function _processModuleImport(followup, outPayloads, outPendingModules) {
        var _this2 = this;
        var operationLoader = this._operationLoader;
        if (operationLoader == null) return;
        var node = operationLoader.get(followup.operationReference);
        if (node != null) {
            var result = this._normalizeFollowup(followup, node);
            outPayloads.push.apply(outPayloads, (0, $ad0e810596bfd29b$var$_toConsumableArray2["default"])(result.payloads));
            outPendingModules.push.apply(outPendingModules, (0, $ad0e810596bfd29b$var$_toConsumableArray2["default"])(result.pendingModules));
            return;
        }
        var emptyResult = {
            payloads: [],
            pendingModules: []
        };
        outPendingModules.push(operationLoader.load(followup.operationReference).then(function(loadedNode) {
            return loadedNode != null ? _this2._normalizeFollowup(followup, loadedNode) : emptyResult;
        })["catch"](function(_error) {
            return emptyResult;
        }));
    };
    _proto._normalizeFollowup = function _normalizeFollowup(followup, node) {
        var operationNode = node.kind === 'SplitOperation' ? node : node.operation;
        var selector = $ad0e810596bfd29b$var$createNormalizationSelector(operationNode, followup.dataID, followup.variables);
        var payload = this._normalizeResponse({
            data: followup.data
        }, selector, followup.typeName, (0, $ad0e810596bfd29b$var$_objectSpread2["default"])((0, $ad0e810596bfd29b$var$_objectSpread2["default"])({}, this._options), {}, {
            path: followup.path
        }), this._useExecTimeResolvers);
        var extraPayloads = [];
        var pendingModules = [];
        if (payload.incrementalPlaceholders != null && payload.incrementalPlaceholders.length > 0) this._registerPlaceholders(payload.incrementalPlaceholders, payload.source, payload.fieldPayloads, extraPayloads, pendingModules);
        if (payload.followupPayloads != null && payload.followupPayloads.length > 0) this._processFollowups(payload.followupPayloads, extraPayloads, pendingModules);
        var primaryPayload = (0, $ad0e810596bfd29b$var$_objectSpread2["default"])((0, $ad0e810596bfd29b$var$_objectSpread2["default"])({}, payload), {}, {
            followupPayloads: null,
            incrementalPlaceholders: null,
            isFinal: this._computeIsFinal(payload.isFinal),
            isPreNormalized: true
        });
        return {
            payloads: [
                primaryPayload
            ].concat(extraPayloads),
            pendingModules: pendingModules
        };
    };
    _proto._computeIsFinal = function _computeIsFinal(serverIsFinal) {
        return (serverIsFinal || this._serverComplete) && this._bufferedResponses.size === 0;
    };
    return NormalizationEngine;
}();
function $ad0e810596bfd29b$var$makeKey(label, pathKey) {
    return "".concat(label, "::").concat(pathKey);
}
module.exports = $ad0e810596bfd29b$var$NormalizationEngine;

});
parcelRegister("7SC8Z", function(module, exports) {
'use strict';

var $e27SU = parcelRequire("e27SU");
var $5bcb2a214f30efb9$var$_interopRequireDefault = $e27SU.default;

var $5bcb2a214f30efb9$var$_defineProperty2 = $5bcb2a214f30efb9$var$_interopRequireDefault((parcelRequire("2JBpp")));

var $5bcb2a214f30efb9$var$_objectWithoutPropertiesLoose2 = $5bcb2a214f30efb9$var$_interopRequireDefault((parcelRequire("l9EoL")));

var $5bcb2a214f30efb9$var$_toPropertyKey2 = $5bcb2a214f30efb9$var$_interopRequireDefault((parcelRequire("g3TwN")));

var $5bcb2a214f30efb9$var$_objectSpread2 = $5bcb2a214f30efb9$var$_interopRequireDefault((parcelRequire("caqem")));

var $6GnlG = parcelRequire("6GnlG");

var $9pidS = parcelRequire("9pidS");
var $5bcb2a214f30efb9$var$generateClientObjectClientID = $9pidS.generateClientObjectClientID, $5bcb2a214f30efb9$var$isClientID = $9pidS.isClientID;

var $fYxIJ = parcelRequire("fYxIJ");
var $5bcb2a214f30efb9$var$isSuspenseSentinel = $fYxIJ.isSuspenseSentinel;

var $ezyIu = parcelRequire("ezyIu");
var $5bcb2a214f30efb9$var$ACTOR_IDENTIFIER_KEY = $ezyIu.ACTOR_IDENTIFIER_KEY, $5bcb2a214f30efb9$var$ERRORS_KEY = $ezyIu.ERRORS_KEY, $5bcb2a214f30efb9$var$ID_KEY = $ezyIu.ID_KEY, $5bcb2a214f30efb9$var$INVALIDATED_AT_KEY = $ezyIu.INVALIDATED_AT_KEY, $5bcb2a214f30efb9$var$REF_KEY = $ezyIu.REF_KEY, $5bcb2a214f30efb9$var$REFS_KEY = $ezyIu.REFS_KEY, $5bcb2a214f30efb9$var$RELAY_RESOLVER_VALUE_KEY = $ezyIu.RELAY_RESOLVER_VALUE_KEY, $5bcb2a214f30efb9$var$ROOT_ID = $ezyIu.ROOT_ID, $5bcb2a214f30efb9$var$TYPENAME_KEY = $ezyIu.TYPENAME_KEY;

var $bke7t = parcelRequire("bke7t");

var $jSI6G = parcelRequire("jSI6G");
parcelRequire("2OmBw");
function $5bcb2a214f30efb9$var$clone(record) {
    return (0, $5bcb2a214f30efb9$var$_objectSpread2["default"])({}, record);
}
function $5bcb2a214f30efb9$var$copyFields(source, sink) {
    for(var key in source){
        if (source.hasOwnProperty(key)) {
            if (key !== $5bcb2a214f30efb9$var$ID_KEY && key !== $5bcb2a214f30efb9$var$TYPENAME_KEY) sink[key] = source[key];
        }
    }
}
function $5bcb2a214f30efb9$var$create(dataID, typeName) {
    var record = {};
    record[$5bcb2a214f30efb9$var$ID_KEY] = dataID;
    record[$5bcb2a214f30efb9$var$TYPENAME_KEY] = typeName;
    return record;
}
function $5bcb2a214f30efb9$var$fromObject(json) {
    return json;
}
function $5bcb2a214f30efb9$var$getDataID(record) {
    return record[$5bcb2a214f30efb9$var$ID_KEY];
}
function $5bcb2a214f30efb9$var$getFields(record) {
    if ($5bcb2a214f30efb9$var$ERRORS_KEY in record) return Object.keys(record).filter(function(field) {
        return field !== $5bcb2a214f30efb9$var$ERRORS_KEY;
    });
    return Object.keys(record);
}
function $5bcb2a214f30efb9$var$getType(record) {
    return record[$5bcb2a214f30efb9$var$TYPENAME_KEY];
}
function $5bcb2a214f30efb9$var$getErrors(record, storageKey) {
    var _record$ERRORS_KEY;
    return (_record$ERRORS_KEY = record[$5bcb2a214f30efb9$var$ERRORS_KEY]) === null || _record$ERRORS_KEY === void 0 ? void 0 : _record$ERRORS_KEY[storageKey];
}
function $5bcb2a214f30efb9$var$getValue(record, storageKey) {
    var value = record[storageKey];
    if (value && typeof value === 'object') !(!value.hasOwnProperty($5bcb2a214f30efb9$var$REF_KEY) && !value.hasOwnProperty($5bcb2a214f30efb9$var$REFS_KEY)) && $jSI6G(false);
    return value;
}
function $5bcb2a214f30efb9$var$hasValue(record, storageKey) {
    return storageKey in record;
}
function $5bcb2a214f30efb9$var$getLinkedRecordID(record, storageKey) {
    var maybeLink = record[storageKey];
    if (maybeLink == null) return maybeLink;
    var link = maybeLink;
    !(typeof link === 'object' && link && typeof link[$5bcb2a214f30efb9$var$REF_KEY] === 'string') && $jSI6G(false);
    return link[$5bcb2a214f30efb9$var$REF_KEY];
}
function $5bcb2a214f30efb9$var$hasLinkedRecordID(record, storageKey) {
    var maybeLink = record[storageKey];
    if (maybeLink == null) return false;
    var link = maybeLink;
    return typeof link === 'object' && link && typeof link[$5bcb2a214f30efb9$var$REF_KEY] === 'string';
}
function $5bcb2a214f30efb9$var$getLinkedRecordIDs(record, storageKey) {
    var links = record[storageKey];
    if (links == null) return links;
    !(typeof links === 'object' && Array.isArray(links[$5bcb2a214f30efb9$var$REFS_KEY])) && $jSI6G(false);
    return links[$5bcb2a214f30efb9$var$REFS_KEY];
}
function $5bcb2a214f30efb9$var$hasLinkedRecordIDs(record, storageKey) {
    var links = record[storageKey];
    if (links == null) return false;
    return typeof links === 'object' && Array.isArray(links[$5bcb2a214f30efb9$var$REFS_KEY]) && links[$5bcb2a214f30efb9$var$REFS_KEY].every(function(link) {
        return typeof link === 'string';
    });
}
function $5bcb2a214f30efb9$var$getInvalidationEpoch(record) {
    if (record == null) return null;
    var invalidatedAt = record[$5bcb2a214f30efb9$var$INVALIDATED_AT_KEY];
    if (typeof invalidatedAt !== 'number') return null;
    return invalidatedAt;
}
function $5bcb2a214f30efb9$var$update(prevRecord, nextRecord) {
    var _updated2;
    var _getType, _getType2, prevID, nextID, prevType, nextType;
    var prevErrorsByKey = prevRecord[$5bcb2a214f30efb9$var$ERRORS_KEY];
    var nextErrorsByKey = nextRecord[$5bcb2a214f30efb9$var$ERRORS_KEY];
    var updated = null;
    if (prevErrorsByKey == null && nextErrorsByKey == null) {
        var _updated;
        for(var storageKey in nextRecord)if (updated || !$bke7t(prevRecord[storageKey], nextRecord[storageKey])) {
            updated = updated !== null ? updated : (0, $5bcb2a214f30efb9$var$_objectSpread2["default"])({}, prevRecord);
            updated[storageKey] = nextRecord[storageKey];
        }
        return (_updated = updated) !== null && _updated !== void 0 ? _updated : prevRecord;
    }
    for(var _storageKey2 in nextRecord){
        if (_storageKey2 === $5bcb2a214f30efb9$var$ERRORS_KEY) continue;
        var nextValue = nextRecord[_storageKey2];
        var nextErrors = nextErrorsByKey === null || nextErrorsByKey === void 0 ? void 0 : nextErrorsByKey[_storageKey2];
        if (updated == null) {
            var prevValue = prevRecord[_storageKey2];
            var prevErrors = prevErrorsByKey === null || prevErrorsByKey === void 0 ? void 0 : prevErrorsByKey[_storageKey2];
            if ($bke7t(prevValue, nextValue) && $bke7t(prevErrors, nextErrors)) continue;
            updated = (0, $5bcb2a214f30efb9$var$_objectSpread2["default"])({}, prevRecord);
            if (prevErrorsByKey != null) updated[$5bcb2a214f30efb9$var$ERRORS_KEY] = (0, $5bcb2a214f30efb9$var$_objectSpread2["default"])({}, prevErrorsByKey);
        }
        $5bcb2a214f30efb9$var$setValue(updated, _storageKey2, nextValue);
        $5bcb2a214f30efb9$var$setErrors(updated, _storageKey2, nextErrors);
    }
    return (_updated2 = updated) !== null && _updated2 !== void 0 ? _updated2 : prevRecord;
}
function $5bcb2a214f30efb9$var$merge(record1, record2) {
    var _getType3, _getType4, prevID, nextID, prevType, nextType;
    if ($5bcb2a214f30efb9$var$ERRORS_KEY in record1 || $5bcb2a214f30efb9$var$ERRORS_KEY in record2) {
        var errors1 = record1[$5bcb2a214f30efb9$var$ERRORS_KEY], fields1 = (0, $5bcb2a214f30efb9$var$_objectWithoutPropertiesLoose2["default"])(record1, [
            $5bcb2a214f30efb9$var$ERRORS_KEY
        ].map($5bcb2a214f30efb9$var$_toPropertyKey2["default"]));
        var errors2 = record2[$5bcb2a214f30efb9$var$ERRORS_KEY], fields2 = (0, $5bcb2a214f30efb9$var$_objectWithoutPropertiesLoose2["default"])(record2, [
            $5bcb2a214f30efb9$var$ERRORS_KEY
        ].map($5bcb2a214f30efb9$var$_toPropertyKey2["default"]));
        var updated = (0, $5bcb2a214f30efb9$var$_objectSpread2["default"])((0, $5bcb2a214f30efb9$var$_objectSpread2["default"])({}, fields1), fields2);
        if (errors1 == null && errors2 == null) return updated;
        var updatedErrors = {};
        for(var storageKey in errors1){
            if (fields2.hasOwnProperty(storageKey)) continue;
            updatedErrors[storageKey] = errors1[storageKey];
        }
        for(var _storageKey3 in errors2)updatedErrors[_storageKey3] = errors2[_storageKey3];
        for(var _storageKey in updatedErrors){
            updated[$5bcb2a214f30efb9$var$ERRORS_KEY] = updatedErrors;
            break;
        }
        return updated;
    } else return (0, $5bcb2a214f30efb9$var$_objectSpread2["default"])((0, $5bcb2a214f30efb9$var$_objectSpread2["default"])({}, record1), record2);
}
function $5bcb2a214f30efb9$var$freeze(record) {
    $6GnlG(record);
}
function $5bcb2a214f30efb9$var$setErrors(record, storageKey, errors) {
    var errorsByStorageKey = record[$5bcb2a214f30efb9$var$ERRORS_KEY];
    if (errors != null && errors.length > 0) {
        if (errorsByStorageKey == null) record[$5bcb2a214f30efb9$var$ERRORS_KEY] = (0, $5bcb2a214f30efb9$var$_defineProperty2["default"])({}, storageKey, errors);
        else errorsByStorageKey[storageKey] = errors;
    } else if (errorsByStorageKey != null) {
        if (delete errorsByStorageKey[storageKey]) {
            for(var otherStorageKey in errorsByStorageKey){
                if (errorsByStorageKey.hasOwnProperty(otherStorageKey)) return;
            }
            delete record[$5bcb2a214f30efb9$var$ERRORS_KEY];
        }
    }
}
function $5bcb2a214f30efb9$var$setValue(record, storageKey, value) {
    var prevID, _getType5, prevType, nextType;
    record[storageKey] = value;
}
function $5bcb2a214f30efb9$var$setLinkedRecordID(record, storageKey, linkedID) {
    var link = {};
    link[$5bcb2a214f30efb9$var$REF_KEY] = linkedID;
    record[storageKey] = link;
}
function $5bcb2a214f30efb9$var$setLinkedRecordIDs(record, storageKey, linkedIDs) {
    var links = {};
    links[$5bcb2a214f30efb9$var$REFS_KEY] = linkedIDs;
    record[storageKey] = links;
}
function $5bcb2a214f30efb9$var$setActorLinkedRecordID(record, storageKey, actorIdentifier, linkedID) {
    var link = {};
    link[$5bcb2a214f30efb9$var$REF_KEY] = linkedID;
    link[$5bcb2a214f30efb9$var$ACTOR_IDENTIFIER_KEY] = actorIdentifier;
    record[storageKey] = link;
}
function $5bcb2a214f30efb9$var$getActorLinkedRecordID(record, storageKey) {
    var link = record[storageKey];
    if (link == null) return link;
    !(typeof link === 'object' && typeof link[$5bcb2a214f30efb9$var$REF_KEY] === 'string' && link[$5bcb2a214f30efb9$var$ACTOR_IDENTIFIER_KEY] != null) && $jSI6G(false);
    return [
        link[$5bcb2a214f30efb9$var$ACTOR_IDENTIFIER_KEY],
        link[$5bcb2a214f30efb9$var$REF_KEY]
    ];
}
function $5bcb2a214f30efb9$var$getResolverLinkedRecordID(record, typeName) {
    var id = $5bcb2a214f30efb9$var$getValue(record, $5bcb2a214f30efb9$var$RELAY_RESOLVER_VALUE_KEY);
    if (id == null || $5bcb2a214f30efb9$var$isSuspenseSentinel(id)) return null;
    if (typeof id === 'object') id = id.id;
    !(typeof id === 'string') && $jSI6G(false);
    return $5bcb2a214f30efb9$var$generateClientObjectClientID(typeName, id);
}
function $5bcb2a214f30efb9$var$getResolverLinkedRecordIDs(record, typeName) {
    var resolverValue = $5bcb2a214f30efb9$var$getValue(record, $5bcb2a214f30efb9$var$RELAY_RESOLVER_VALUE_KEY);
    if (resolverValue == null || $5bcb2a214f30efb9$var$isSuspenseSentinel(resolverValue)) return null;
    !Array.isArray(resolverValue) && $jSI6G(false);
    return resolverValue.map(function(id) {
        if (id == null) return null;
        if (typeof id === 'object') id = id.id;
        !(typeof id === 'string') && $jSI6G(false);
        return $5bcb2a214f30efb9$var$generateClientObjectClientID(typeName, id);
    });
}
function $5bcb2a214f30efb9$var$hasFieldChanged(prevRecord, nextRecord, storageKey) {
    var _prevRecord$ERRORS_KE, _nextRecord$ERRORS_KE;
    if (!$bke7t(prevRecord[storageKey], nextRecord[storageKey])) return true;
    var prevErrors = (_prevRecord$ERRORS_KE = prevRecord[$5bcb2a214f30efb9$var$ERRORS_KEY]) === null || _prevRecord$ERRORS_KE === void 0 ? void 0 : _prevRecord$ERRORS_KE[storageKey];
    var nextErrors = (_nextRecord$ERRORS_KE = nextRecord[$5bcb2a214f30efb9$var$ERRORS_KEY]) === null || _nextRecord$ERRORS_KE === void 0 ? void 0 : _nextRecord$ERRORS_KE[storageKey];
    return !$bke7t(prevErrors, nextErrors);
}
function $5bcb2a214f30efb9$var$toJSON(record) {
    return record;
}
module.exports = {
    clone: $5bcb2a214f30efb9$var$clone,
    copyFields: $5bcb2a214f30efb9$var$copyFields,
    create: $5bcb2a214f30efb9$var$create,
    freeze: $5bcb2a214f30efb9$var$freeze,
    fromObject: $5bcb2a214f30efb9$var$fromObject,
    getActorLinkedRecordID: $5bcb2a214f30efb9$var$getActorLinkedRecordID,
    getDataID: $5bcb2a214f30efb9$var$getDataID,
    getErrors: $5bcb2a214f30efb9$var$getErrors,
    getFields: $5bcb2a214f30efb9$var$getFields,
    getInvalidationEpoch: $5bcb2a214f30efb9$var$getInvalidationEpoch,
    getLinkedRecordID: $5bcb2a214f30efb9$var$getLinkedRecordID,
    getLinkedRecordIDs: $5bcb2a214f30efb9$var$getLinkedRecordIDs,
    getResolverLinkedRecordID: $5bcb2a214f30efb9$var$getResolverLinkedRecordID,
    getResolverLinkedRecordIDs: $5bcb2a214f30efb9$var$getResolverLinkedRecordIDs,
    getType: $5bcb2a214f30efb9$var$getType,
    getValue: $5bcb2a214f30efb9$var$getValue,
    hasFieldChanged: $5bcb2a214f30efb9$var$hasFieldChanged,
    hasLinkedRecordID: $5bcb2a214f30efb9$var$hasLinkedRecordID,
    hasLinkedRecordIDs: $5bcb2a214f30efb9$var$hasLinkedRecordIDs,
    hasValue: $5bcb2a214f30efb9$var$hasValue,
    merge: $5bcb2a214f30efb9$var$merge,
    setActorLinkedRecordID: $5bcb2a214f30efb9$var$setActorLinkedRecordID,
    setErrors: $5bcb2a214f30efb9$var$setErrors,
    setLinkedRecordID: $5bcb2a214f30efb9$var$setLinkedRecordID,
    setLinkedRecordIDs: $5bcb2a214f30efb9$var$setLinkedRecordIDs,
    setValue: $5bcb2a214f30efb9$var$setValue,
    toJSON: $5bcb2a214f30efb9$var$toJSON,
    update: $5bcb2a214f30efb9$var$update
};

});
parcelRegister("l9EoL", function(module, exports) {
function $f669c686cad54657$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
module.exports = $f669c686cad54657$var$_objectWithoutPropertiesLoose, module.exports.__esModule = true, module.exports["default"] = module.exports;

});



parcelRegister("kyemR", function(module, exports) {
'use strict';

var $e27SU = parcelRequire("e27SU");
var $ef6220bbb64fbc67$var$_interopRequireDefault = $e27SU.default;

var $ef6220bbb64fbc67$var$_objectSpread2 = $ef6220bbb64fbc67$var$_interopRequireDefault((parcelRequire("caqem")));

var $ef6220bbb64fbc67$var$_RelayModernRecord = $ef6220bbb64fbc67$var$_interopRequireDefault((parcelRequire("7SC8Z")));

var $ef6220bbb64fbc67$var$_RelayRecordSource = $ef6220bbb64fbc67$var$_interopRequireDefault((parcelRequire("3fbkc")));

var $ef6220bbb64fbc67$var$_RelayResponseNormalizer = $ef6220bbb64fbc67$var$_interopRequireDefault((parcelRequire("4LqKJ")));
function $ef6220bbb64fbc67$var$normalizeResponse(response, selector, typeName, options, useExecTimeResolvers) {
    var _response$extensions;
    var data = response.data, errors = response.errors;
    var source = $ef6220bbb64fbc67$var$_RelayRecordSource["default"].create();
    var record = $ef6220bbb64fbc67$var$_RelayModernRecord["default"].create(selector.dataID, typeName);
    source.set(selector.dataID, record);
    var relayPayload = $ef6220bbb64fbc67$var$_RelayResponseNormalizer["default"].normalize(source, selector, data, options, errors, useExecTimeResolvers);
    return (0, $ef6220bbb64fbc67$var$_objectSpread2["default"])((0, $ef6220bbb64fbc67$var$_objectSpread2["default"])({}, relayPayload), {}, {
        isFinal: ((_response$extensions = response.extensions) === null || _response$extensions === void 0 ? void 0 : _response$extensions.is_final) === true
    });
}
module.exports = $ef6220bbb64fbc67$var$normalizeResponse;

});
parcelRegister("3fbkc", function(module, exports) {
'use strict';

var $e27SU = parcelRequire("e27SU");
var $25cb8eaebafbdea2$var$_interopRequireDefault = $e27SU.default;

var $25cb8eaebafbdea2$var$_createForOfIteratorHelper2 = $25cb8eaebafbdea2$var$_interopRequireDefault((parcelRequire("5dSyV")));

var $gZYpt = parcelRequire("gZYpt");

var $7SC8Z = parcelRequire("7SC8Z");

var $hfBP1 = parcelRequire("hfBP1");

var $ezyIu = parcelRequire("ezyIu");
var $25cb8eaebafbdea2$var$RELAY_RESOLVER_RECORD_TYPENAME = $ezyIu.RELAY_RESOLVER_RECORD_TYPENAME;
var $25cb8eaebafbdea2$var$EXISTENT = $hfBP1.EXISTENT, $25cb8eaebafbdea2$var$NONEXISTENT = $hfBP1.NONEXISTENT, $25cb8eaebafbdea2$var$UNKNOWN = $hfBP1.UNKNOWN;
var $25cb8eaebafbdea2$var$RelayRecordSource = /*#__PURE__*/ function() {
    function RelayRecordSource(records) {
        var _this = this;
        this._records = new Map();
        if (records != null) Object.keys(records).forEach(function(key) {
            var object = records[key];
            var record = $7SC8Z.fromObject(object);
            _this._records.set(key, record);
        });
    }
    RelayRecordSource.create = function create(records) {
        return new RelayRecordSource(records);
    };
    var _proto = RelayRecordSource.prototype;
    _proto.clear = function clear() {
        this._records = new Map();
    };
    _proto["delete"] = function _delete(dataID) {
        this._records.set(dataID, null);
    };
    _proto.get = function get(dataID) {
        return this._records.get(dataID);
    };
    _proto.getRecordIDs = function getRecordIDs() {
        return Array.from(this._records.keys());
    };
    _proto.getStatus = function getStatus(dataID) {
        if (!this._records.has(dataID)) return $25cb8eaebafbdea2$var$UNKNOWN;
        return this._records.get(dataID) == null ? $25cb8eaebafbdea2$var$NONEXISTENT : $25cb8eaebafbdea2$var$EXISTENT;
    };
    _proto.has = function has(dataID) {
        return this._records.has(dataID);
    };
    _proto.remove = function remove(dataID) {
        this._records["delete"](dataID);
    };
    _proto.set = function set(dataID, record) {
        this._records.set(dataID, record);
    };
    _proto.size = function size() {
        return this._records.size;
    };
    _proto.toJSON = function toJSON() {
        var obj = {};
        var _iterator = (0, $25cb8eaebafbdea2$var$_createForOfIteratorHelper2["default"])(this._records), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var _step$value = _step.value, key = _step$value[0], record = _step$value[1];
                if ($gZYpt.FILTER_OUT_RELAY_RESOLVER_RECORDS && record != null && $7SC8Z.getType(record) === $25cb8eaebafbdea2$var$RELAY_RESOLVER_RECORD_TYPENAME) continue;
                obj[key] = $7SC8Z.toJSON(record);
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
        return obj;
    };
    return RelayRecordSource;
}();
module.exports = $25cb8eaebafbdea2$var$RelayRecordSource;

});
parcelRegister("hfBP1", function(module, exports) {
'use strict';
var $c8f12d07da712475$var$RelayRecordState = {
    EXISTENT: 'EXISTENT',
    NONEXISTENT: 'NONEXISTENT',
    UNKNOWN: 'UNKNOWN'
};
module.exports = $c8f12d07da712475$var$RelayRecordState;

});


parcelRegister("4LqKJ", function(module, exports) {
'use strict';

var $e27SU = parcelRequire("e27SU");
var $37804db8ff135ea9$var$_interopRequireDefault = $e27SU.default;

var $37804db8ff135ea9$var$_createForOfIteratorHelper2 = $37804db8ff135ea9$var$_interopRequireDefault((parcelRequire("5dSyV")));

var $37804db8ff135ea9$var$_toConsumableArray2 = $37804db8ff135ea9$var$_interopRequireDefault((parcelRequire("lLsx3")));

var $52oJj = parcelRequire("52oJj");
var $37804db8ff135ea9$var$ACTOR_IDENTIFIER_FIELD_NAME = $52oJj.ACTOR_IDENTIFIER_FIELD_NAME, $37804db8ff135ea9$var$getActorIdentifierFromPayload = $52oJj.getActorIdentifierFromPayload;

var $gZYpt = parcelRequire("gZYpt");

var $9pidS = parcelRequire("9pidS");
var $37804db8ff135ea9$var$generateClientID = $9pidS.generateClientID, $37804db8ff135ea9$var$isClientID = $9pidS.isClientID;

var $adnaT = parcelRequire("adnaT");
var $37804db8ff135ea9$var$getLocalVariables = $adnaT.getLocalVariables;

var $jS24l = parcelRequire("jS24l");
var $37804db8ff135ea9$var$buildErrorTrie = $jS24l.buildErrorTrie, $37804db8ff135ea9$var$getErrorsByKey = $jS24l.getErrorsByKey, $37804db8ff135ea9$var$getNestedErrorTrieByKey = $jS24l.getNestedErrorTrieByKey;

var $7SC8Z = parcelRequire("7SC8Z");

var $iUq0k = parcelRequire("iUq0k");
var $37804db8ff135ea9$var$createNormalizationSelector = $iUq0k.createNormalizationSelector;

var $ezyIu = parcelRequire("ezyIu");
var $37804db8ff135ea9$var$ROOT_ID = $ezyIu.ROOT_ID, $37804db8ff135ea9$var$ROOT_TYPE = $ezyIu.ROOT_TYPE, $37804db8ff135ea9$var$TYPENAME_KEY = $ezyIu.TYPENAME_KEY, $37804db8ff135ea9$var$getArgumentValues = $ezyIu.getArgumentValues, $37804db8ff135ea9$var$getHandleStorageKey = $ezyIu.getHandleStorageKey, $37804db8ff135ea9$var$getModuleComponentKey = $ezyIu.getModuleComponentKey, $37804db8ff135ea9$var$getModuleOperationKey = $ezyIu.getModuleOperationKey, $37804db8ff135ea9$var$getStorageKey = $ezyIu.getStorageKey;

var $enqEM = parcelRequire("enqEM");
var $37804db8ff135ea9$var$TYPE_SCHEMA_TYPE = $enqEM.TYPE_SCHEMA_TYPE, $37804db8ff135ea9$var$generateTypeID = $enqEM.generateTypeID;
parcelRequire("bke7t");

var $jSI6G = parcelRequire("jSI6G");
parcelRequire("2OmBw");
function $37804db8ff135ea9$var$normalize(recordSource, selector, response, options, errors, useExecTimeResolvers) {
    var dataID = selector.dataID, node = selector.node, variables = selector.variables;
    var normalizer = new $37804db8ff135ea9$var$RelayResponseNormalizer(recordSource, variables, options, useExecTimeResolvers !== null && useExecTimeResolvers !== void 0 ? useExecTimeResolvers : false);
    return normalizer.normalizeResponse(node, dataID, response, errors);
}
var $37804db8ff135ea9$var$RelayResponseNormalizer = /*#__PURE__*/ function() {
    function RelayResponseNormalizer(recordSource, variables, options, useExecTimeResolvers) {
        this._actorIdentifier = options.actorIdentifier;
        this._getDataId = options.getDataID;
        this._handleFieldPayloads = [];
        this._treatMissingFieldsAsNull = options.treatMissingFieldsAsNull;
        this._deferDeduplicatedFields = options.deferDeduplicatedFields;
        this._incrementalPlaceholders = [];
        this._isClientExtension = false;
        this._isUnmatchedAbstractType = false;
        this._useExecTimeResolvers = useExecTimeResolvers;
        this._followupPayloads = [];
        this._path = options.path ? (0, $37804db8ff135ea9$var$_toConsumableArray2["default"])(options.path) : [];
        this._recordSource = recordSource;
        this._variables = variables;
        this._shouldProcessClientComponents = options.shouldProcessClientComponents;
        this._log = options.log;
        this._s2cExecutions = new Map();
    }
    var _proto = RelayResponseNormalizer.prototype;
    _proto.normalizeResponse = function normalizeResponse(node, dataID, data, errors) {
        var record = this._recordSource.get(dataID);
        !record && $jSI6G(false);
        this._assignClientAbstractTypes(node);
        this._errorTrie = $37804db8ff135ea9$var$buildErrorTrie(errors);
        this._traverseSelections(node, record, data);
        return {
            errors: errors,
            fieldPayloads: this._handleFieldPayloads,
            followupPayloads: this._followupPayloads,
            incrementalPlaceholders: this._incrementalPlaceholders,
            isFinal: false,
            s2cExecutions: this._s2cExecutions.size > 0 ? Array.from(this._s2cExecutions.entries()).map(function(_ref) {
                var recordID = _ref[0], entry = _ref[1];
                return {
                    recordID: recordID,
                    selections: entry.selections,
                    typeName: entry.typeName
                };
            }) : undefined,
            source: this._recordSource
        };
    };
    _proto._assignClientAbstractTypes = function _assignClientAbstractTypes(node) {
        var clientAbstractTypes = node.clientAbstractTypes;
        if (clientAbstractTypes != null) for(var _i = 0, _Object$keys = Object.keys(clientAbstractTypes); _i < _Object$keys.length; _i++){
            var abstractType = _Object$keys[_i];
            var _iterator = (0, $37804db8ff135ea9$var$_createForOfIteratorHelper2["default"])(clientAbstractTypes[abstractType]), _step;
            try {
                for(_iterator.s(); !(_step = _iterator.n()).done;){
                    var concreteType = _step.value;
                    var typeID = $37804db8ff135ea9$var$generateTypeID(concreteType);
                    var typeRecord = this._recordSource.get(typeID);
                    if (typeRecord == null) {
                        typeRecord = $7SC8Z.create(typeID, $37804db8ff135ea9$var$TYPE_SCHEMA_TYPE);
                        this._recordSource.set(typeID, typeRecord);
                    }
                    $7SC8Z.setValue(typeRecord, abstractType, true);
                }
            } catch (err) {
                _iterator.e(err);
            } finally{
                _iterator.f();
            }
        }
    };
    _proto._getVariableValue = function _getVariableValue(name) {
        !this._variables.hasOwnProperty(name) && $jSI6G(false);
        return this._variables[name];
    };
    _proto._getRecordType = function _getRecordType(data) {
        var typeName = data[$37804db8ff135ea9$var$TYPENAME_KEY];
        !(typeName != null) && $jSI6G(false);
        return typeName;
    };
    _proto._traverseSelections = function _traverseSelections(node, record, data) {
        var _selection$resolverIn, _selection$backingFie;
        for(var i = 0; i < node.selections.length; i++){
            var selection = node.selections[i];
            switch(selection.kind){
                case 'ScalarField':
                case 'LinkedField':
                    this._normalizeField(selection, record, data);
                    break;
                case 'Condition':
                    var conditionValue = Boolean(this._getVariableValue(selection.condition));
                    if (conditionValue === selection.passingValue) this._traverseSelections(selection, record, data);
                    break;
                case 'FragmentSpread':
                    var prevVariables = this._variables;
                    this._variables = $37804db8ff135ea9$var$getLocalVariables(this._variables, selection.fragment.argumentDefinitions, selection.args);
                    this._traverseSelections(selection.fragment, record, data);
                    this._variables = prevVariables;
                    break;
                case 'InlineFragment':
                    this._normalizeInlineFragment(selection, record, data);
                    break;
                case 'TypeDiscriminator':
                    var abstractKey = selection.abstractKey;
                    var implementsInterface = Object.prototype.hasOwnProperty.call(data, abstractKey);
                    var typeName = $7SC8Z.getType(record);
                    var typeID = $37804db8ff135ea9$var$generateTypeID(typeName);
                    var typeRecord = this._recordSource.get(typeID);
                    if (typeRecord == null) {
                        typeRecord = $7SC8Z.create(typeID, $37804db8ff135ea9$var$TYPE_SCHEMA_TYPE);
                        this._recordSource.set(typeID, typeRecord);
                    }
                    $7SC8Z.setValue(typeRecord, abstractKey, implementsInterface);
                    break;
                case 'LinkedHandle':
                case 'ScalarHandle':
                    var args = selection.args ? $37804db8ff135ea9$var$getArgumentValues(selection.args, this._variables) : {};
                    var fieldKey = $37804db8ff135ea9$var$getStorageKey(selection, this._variables);
                    var handleKey = $37804db8ff135ea9$var$getHandleStorageKey(selection, this._variables);
                    this._handleFieldPayloads.push({
                        args: args,
                        dataID: $7SC8Z.getDataID(record),
                        fieldKey: fieldKey,
                        handle: selection.handle,
                        handleArgs: selection.handleArgs ? $37804db8ff135ea9$var$getArgumentValues(selection.handleArgs, this._variables) : {},
                        handleKey: handleKey
                    });
                    break;
                case 'ModuleImport':
                    this._normalizeModuleImport(selection, record, data);
                    break;
                case 'Defer':
                    this._normalizeDefer(selection, record, data);
                    break;
                case 'Stream':
                    this._normalizeStream(selection, record, data);
                    break;
                case 'ClientExtension':
                    var isClientExtension = this._isClientExtension;
                    this._isClientExtension = true;
                    this._traverseSelections(selection, record, data);
                    this._isClientExtension = isClientExtension;
                    break;
                case 'ClientComponent':
                    if (this._shouldProcessClientComponents === false) break;
                    this._traverseSelections(selection.fragment, record, data);
                    break;
                case 'ActorChange':
                    this._normalizeActorChange(selection, record, data);
                    break;
                case 'RelayResolver':
                case 'RelayLiveResolver':
                    if (!this._useExecTimeResolvers) this._normalizeResolver(selection, record, data);
                    else if (((_selection$resolverIn = selection.resolverInfo) === null || _selection$resolverIn === void 0 ? void 0 : _selection$resolverIn.rootFragment) != null) this._collectS2CExecution(selection, record);
                    break;
                case 'ClientEdgeToClientObject':
                    if (!this._useExecTimeResolvers) this._normalizeResolver(selection.backingField, record, data);
                    else if (((_selection$backingFie = selection.backingField.resolverInfo) === null || _selection$backingFie === void 0 ? void 0 : _selection$backingFie.rootFragment) != null) this._collectS2CExecution(selection, record);
                    break;
                default:
                    selection;
                    $jSI6G(false);
            }
        }
    };
    _proto._normalizeInlineFragment = function _normalizeInlineFragment(selection, record, data) {
        var abstractKey = selection.abstractKey;
        if (abstractKey == null) {
            var typeName = $7SC8Z.getType(record);
            if (typeName === selection.type || typeName === $37804db8ff135ea9$var$ROOT_TYPE) this._traverseSelections(selection, record, data);
        } else {
            var implementsInterface = Object.prototype.hasOwnProperty.call(data, abstractKey);
            var _typeName = $7SC8Z.getType(record);
            var typeID = $37804db8ff135ea9$var$generateTypeID(_typeName);
            var typeRecord = this._recordSource.get(typeID);
            if (typeRecord == null) {
                typeRecord = $7SC8Z.create(typeID, $37804db8ff135ea9$var$TYPE_SCHEMA_TYPE);
                this._recordSource.set(typeID, typeRecord);
            }
            $7SC8Z.setValue(typeRecord, abstractKey, implementsInterface);
            if (implementsInterface) this._traverseSelections(selection, record, data);
        }
    };
    _proto._normalizeResolver = function _normalizeResolver(resolver, record, data) {
        if (resolver.fragment != null) this._normalizeInlineFragment(resolver.fragment, record, data);
    };
    _proto._collectS2CExecution = function _collectS2CExecution(selection, record) {
        var recordID = $7SC8Z.getDataID(record);
        var typeName = $7SC8Z.getType(record);
        var entry = this._s2cExecutions.get(recordID);
        if (entry == null) {
            entry = {
                selections: [],
                typeName: typeName
            };
            this._s2cExecutions.set(recordID, entry);
        }
        entry.selections.push(selection);
    };
    _proto._normalizeDefer = function _normalizeDefer(defer, record, data) {
        var isDeferred = defer["if"] === null || this._getVariableValue(defer["if"]);
        if (isDeferred === false) this._traverseSelections(defer, record, data);
        else this._incrementalPlaceholders.push({
            actorIdentifier: this._actorIdentifier,
            data: data,
            kind: 'defer',
            label: defer.label,
            path: (0, $37804db8ff135ea9$var$_toConsumableArray2["default"])(this._path),
            selector: $37804db8ff135ea9$var$createNormalizationSelector(defer, $7SC8Z.getDataID(record), this._variables),
            typeName: $7SC8Z.getType(record)
        });
    };
    _proto._normalizeStream = function _normalizeStream(stream, record, data) {
        this._traverseSelections(stream, record, data);
        var isStreamed = stream["if"] === null || this._getVariableValue(stream["if"]);
        if (isStreamed === true) this._incrementalPlaceholders.push({
            actorIdentifier: this._actorIdentifier,
            kind: 'stream',
            label: stream.label,
            node: stream,
            parentID: $7SC8Z.getDataID(record),
            path: (0, $37804db8ff135ea9$var$_toConsumableArray2["default"])(this._path),
            variables: this._variables
        });
    };
    _proto._normalizeModuleImport = function _normalizeModuleImport(moduleImport, record, data) {
        !(typeof data === 'object' && data) && $jSI6G(false);
        var typeName = $7SC8Z.getType(record);
        var componentKey = $37804db8ff135ea9$var$getModuleComponentKey(moduleImport.documentName);
        var componentReference = moduleImport.componentModuleProvider || data[componentKey];
        $7SC8Z.setValue(record, componentKey, componentReference !== null && componentReference !== void 0 ? componentReference : null);
        var operationKey = $37804db8ff135ea9$var$getModuleOperationKey(moduleImport.documentName);
        var operationReference = moduleImport.operationModuleProvider || data[operationKey];
        $7SC8Z.setValue(record, operationKey, operationReference !== null && operationReference !== void 0 ? operationReference : null);
        if (operationReference != null) this._followupPayloads.push({
            actorIdentifier: this._actorIdentifier,
            args: moduleImport.args,
            data: data,
            dataID: $7SC8Z.getDataID(record),
            kind: 'ModuleImportPayload',
            operationReference: operationReference,
            path: (0, $37804db8ff135ea9$var$_toConsumableArray2["default"])(this._path),
            typeName: typeName,
            variables: this._variables
        });
    };
    _proto._normalizeField = function _normalizeField(selection, record, data) {
        !(typeof data === 'object' && data) && $jSI6G(false);
        var responseKey = selection.alias || selection.name;
        var storageKey = $37804db8ff135ea9$var$getStorageKey(selection, this._variables);
        var fieldValue = data[responseKey];
        var isNoncompliantlyNullish = $gZYpt.ENABLE_NONCOMPLIANT_ERROR_HANDLING_ON_LISTS && Array.isArray(fieldValue) && fieldValue.length === 0;
        if (fieldValue == null || isNoncompliantlyNullish) {
            if (fieldValue === undefined) {
                var isOptionalField = this._isClientExtension || this._isUnmatchedAbstractType || this._deferDeduplicatedFields;
                if (isOptionalField) return;
                else if (!this._treatMissingFieldsAsNull) return;
            }
            if (selection.kind === 'ScalarField') this._validateConflictingFieldsWithIdenticalId(record, storageKey, null);
            if (isNoncompliantlyNullish) {
                if (selection.kind === 'LinkedField') $7SC8Z.setLinkedRecordIDs(record, storageKey, []);
                else $7SC8Z.setValue(record, storageKey, []);
            } else $7SC8Z.setValue(record, storageKey, null);
            var errorTrie = this._errorTrie;
            if (errorTrie != null) {
                var errors = $37804db8ff135ea9$var$getErrorsByKey(errorTrie, responseKey);
                if (errors != null) $7SC8Z.setErrors(record, storageKey, errors);
            }
            return;
        }
        if (selection.kind === 'ScalarField') {
            this._validateConflictingFieldsWithIdenticalId(record, storageKey, fieldValue);
            $7SC8Z.setValue(record, storageKey, fieldValue);
        } else if (selection.kind === 'LinkedField') {
            this._path.push(responseKey);
            var oldErrorTrie = this._errorTrie;
            this._errorTrie = oldErrorTrie == null ? null : $37804db8ff135ea9$var$getNestedErrorTrieByKey(oldErrorTrie, responseKey);
            if (selection.plural) this._normalizePluralLink(selection, record, storageKey, fieldValue);
            else this._normalizeLink(selection, record, storageKey, fieldValue);
            this._errorTrie = oldErrorTrie;
            this._path.pop();
        } else {
            selection;
            $jSI6G(false);
        }
    };
    _proto._normalizeActorChange = function _normalizeActorChange(selection, record, data) {
        var _field$concreteType;
        var field = selection.linkedField;
        !(typeof data === 'object' && data) && $jSI6G(false);
        var responseKey = field.alias || field.name;
        var storageKey = $37804db8ff135ea9$var$getStorageKey(field, this._variables);
        var fieldValue = data[responseKey];
        if (fieldValue == null) {
            if (fieldValue === undefined) {
                var isOptionalField = this._isClientExtension || this._isUnmatchedAbstractType;
                if (isOptionalField) return;
                else if (!this._treatMissingFieldsAsNull) return;
            }
            $7SC8Z.setValue(record, storageKey, null);
            return;
        }
        var actorIdentifier = $37804db8ff135ea9$var$getActorIdentifierFromPayload(fieldValue);
        if (actorIdentifier == null) {
            $7SC8Z.setValue(record, storageKey, null);
            return;
        }
        var typeName = (_field$concreteType = field.concreteType) !== null && _field$concreteType !== void 0 ? _field$concreteType : this._getRecordType(fieldValue);
        var nextID = this._getDataId(fieldValue, typeName) || $7SC8Z.getLinkedRecordID(record, storageKey) || $37804db8ff135ea9$var$generateClientID($7SC8Z.getDataID(record), storageKey);
        !(typeof nextID === 'string') && $jSI6G(false);
        $7SC8Z.setActorLinkedRecordID(record, storageKey, actorIdentifier, nextID);
        this._followupPayloads.push({
            actorIdentifier: actorIdentifier,
            data: fieldValue,
            dataID: nextID,
            kind: 'ActorPayload',
            node: field,
            path: [].concat((0, $37804db8ff135ea9$var$_toConsumableArray2["default"])(this._path), [
                responseKey
            ]),
            typeName: typeName,
            variables: this._variables
        });
    };
    _proto._normalizeLink = function _normalizeLink(field, record, storageKey, fieldValue) {
        var _field$concreteType2;
        !(typeof fieldValue === 'object' && fieldValue) && $jSI6G(false);
        var nextID = this._getDataId(fieldValue, (_field$concreteType2 = field.concreteType) !== null && _field$concreteType2 !== void 0 ? _field$concreteType2 : this._getRecordType(fieldValue)) || $7SC8Z.getLinkedRecordID(record, storageKey) || $37804db8ff135ea9$var$generateClientID($7SC8Z.getDataID(record), storageKey);
        !(typeof nextID === 'string') && $jSI6G(false);
        this._validateConflictingLinkedFieldsWithIdenticalId($7SC8Z.getLinkedRecordID(record, storageKey), nextID, storageKey);
        $7SC8Z.setLinkedRecordID(record, storageKey, nextID);
        var nextRecord = this._recordSource.get(nextID);
        if (!nextRecord) {
            var typeName = field.concreteType || this._getRecordType(fieldValue);
            nextRecord = $7SC8Z.create(nextID, typeName);
            this._recordSource.set(nextID, nextRecord);
        } else this._validateRecordType(nextRecord, field, fieldValue);
        this._traverseSelections(field, nextRecord, fieldValue);
    };
    _proto._normalizePluralLink = function _normalizePluralLink(field, record, storageKey, fieldValue) {
        var _this = this;
        !Array.isArray(fieldValue) && $jSI6G(false);
        var prevIDs = $7SC8Z.getLinkedRecordIDs(record, storageKey);
        var nextIDs = [];
        fieldValue.forEach(function(item, nextIndex) {
            var _field$concreteType3;
            if (item == null) {
                nextIDs.push(item);
                return;
            }
            _this._path.push(String(nextIndex));
            var oldErrorTrie = _this._errorTrie;
            _this._errorTrie = oldErrorTrie == null ? null : $37804db8ff135ea9$var$getNestedErrorTrieByKey(oldErrorTrie, nextIndex);
            !(typeof item === 'object') && $jSI6G(false);
            var nextID = _this._getDataId(item, (_field$concreteType3 = field.concreteType) !== null && _field$concreteType3 !== void 0 ? _field$concreteType3 : _this._getRecordType(item)) || prevIDs && prevIDs[nextIndex] || $37804db8ff135ea9$var$generateClientID($7SC8Z.getDataID(record), storageKey, nextIndex);
            !(typeof nextID === 'string') && $jSI6G(false);
            nextIDs.push(nextID);
            var nextRecord = _this._recordSource.get(nextID);
            if (!nextRecord) {
                var typeName = field.concreteType || _this._getRecordType(item);
                nextRecord = $7SC8Z.create(nextID, typeName);
                _this._recordSource.set(nextID, nextRecord);
            } else _this._validateRecordType(nextRecord, field, item);
            if (prevIDs) _this._validateConflictingLinkedFieldsWithIdenticalId(prevIDs[nextIndex], nextID, storageKey);
            _this._traverseSelections(field, nextRecord, item);
            _this._errorTrie = oldErrorTrie;
            _this._path.pop();
        });
        $7SC8Z.setLinkedRecordIDs(record, storageKey, nextIDs);
    };
    _proto._validateRecordType = function _validateRecordType(record, field, payload) {
        if ($gZYpt.ENABLE_STORE_ID_COLLISION_LOGGING) {
            var _field$concreteType4;
            var typeName = (_field$concreteType4 = field.concreteType) !== null && _field$concreteType4 !== void 0 ? _field$concreteType4 : this._getRecordType(payload);
            var dataID = $7SC8Z.getDataID(record);
            var expected = $37804db8ff135ea9$var$isClientID(dataID) && dataID !== $37804db8ff135ea9$var$ROOT_ID || $7SC8Z.getType(record) === typeName;
            if (!expected) {
                var logEvent = {
                    name: 'idCollision.typename',
                    new_typename: typeName,
                    previous_typename: $7SC8Z.getType(record)
                };
                if (this._log != null) this._log(logEvent);
            }
        }
        var _field$concreteType5, _typeName2, _dataID, _expected;
    };
    _proto._validateConflictingFieldsWithIdenticalId = function _validateConflictingFieldsWithIdenticalId(record, storageKey, fieldValue) {
        var previousValue, dataID, expected;
    };
    _proto._validateConflictingLinkedFieldsWithIdenticalId = function _validateConflictingLinkedFieldsWithIdenticalId(prevID, nextID, storageKey) {
        var expected;
    };
    return RelayResponseNormalizer;
}();
module.exports = {
    normalize: $37804db8ff135ea9$var$normalize
};

});
parcelRegister("52oJj", function(module, exports) {
'use strict';
var $3ab052815a155f5c$var$ACTOR_IDENTIFIER_FIELD_NAME = 'actor_key';

var $kc5hH = parcelRequire("kc5hH");
var $3ab052815a155f5c$var$getActorIdentifier = $kc5hH.getActorIdentifier;
function $3ab052815a155f5c$var$getActorIdentifierFromPayload(payload) {
    if (payload != null && typeof payload === 'object' && typeof payload[$3ab052815a155f5c$var$ACTOR_IDENTIFIER_FIELD_NAME] === 'string') return $3ab052815a155f5c$var$getActorIdentifier(payload[$3ab052815a155f5c$var$ACTOR_IDENTIFIER_FIELD_NAME]);
}
module.exports = {
    ACTOR_IDENTIFIER_FIELD_NAME: $3ab052815a155f5c$var$ACTOR_IDENTIFIER_FIELD_NAME,
    getActorIdentifierFromPayload: $3ab052815a155f5c$var$getActorIdentifierFromPayload
};

});
parcelRegister("kc5hH", function(module, exports) {
'use strict';

var $jSI6G = parcelRequire("jSI6G");
var $eb39070a66471516$var$INTERNAL_ACTOR_IDENTIFIER_DO_NOT_USE = 'INTERNAL_ACTOR_IDENTIFIER_DO_NOT_USE';
function $eb39070a66471516$var$assertInternalActorIdentifier(actorIdentifier) {
    !(actorIdentifier === $eb39070a66471516$var$INTERNAL_ACTOR_IDENTIFIER_DO_NOT_USE) && $jSI6G(false);
}
module.exports = {
    INTERNAL_ACTOR_IDENTIFIER_DO_NOT_USE: $eb39070a66471516$var$INTERNAL_ACTOR_IDENTIFIER_DO_NOT_USE,
    assertInternalActorIdentifier: $eb39070a66471516$var$assertInternalActorIdentifier,
    getActorIdentifier: function getActorIdentifier(actorID) {
        return actorID;
    },
    getDefaultActorIdentifier: function getDefaultActorIdentifier() {
        throw new Error('Not Implemented');
    }
};

});


parcelRegister("jS24l", function(module, exports) {
'use strict';

var $e27SU = parcelRequire("e27SU");
var $e774aa528375e473$var$_interopRequireDefault = $e27SU.default;

var $e774aa528375e473$var$_objectSpread2 = $e774aa528375e473$var$_interopRequireDefault((parcelRequire("caqem")));

var $e774aa528375e473$var$_objectWithoutPropertiesLoose2 = $e774aa528375e473$var$_interopRequireDefault((parcelRequire("l9EoL")));

var $e774aa528375e473$var$_createForOfIteratorHelper2 = $e774aa528375e473$var$_interopRequireDefault((parcelRequire("5dSyV")));

var $e774aa528375e473$var$_toConsumableArray2 = $e774aa528375e473$var$_interopRequireDefault((parcelRequire("lLsx3")));
var $e774aa528375e473$var$_excluded = [
    "path",
    "locations"
];
var $e774aa528375e473$var$SELF = Symbol('$SELF');
function $e774aa528375e473$var$buildErrorTrie(errors) {
    if (errors == null) return null;
    var trie = new Map();
    var _iterator = (0, $e774aa528375e473$var$_createForOfIteratorHelper2["default"])(errors), _step;
    try {
        ERRORS: for(_iterator.s(); !(_step = _iterator.n()).done;){
            var _step$value = _step.value, path = _step$value.path, _ = _step$value.locations, error = (0, $e774aa528375e473$var$_objectWithoutPropertiesLoose2["default"])(_step$value, $e774aa528375e473$var$_excluded);
            if (path == null) continue;
            var length = path.length;
            if (length === 0) continue;
            var lastIndex = length - 1;
            var currentTrie = trie;
            for(var index = 0; index < lastIndex; index++){
                var key = path[index];
                var existingValue = currentTrie.get(key);
                if (existingValue instanceof Map) {
                    currentTrie = existingValue;
                    continue;
                }
                var newValue = new Map();
                if (Array.isArray(existingValue)) newValue.set($e774aa528375e473$var$SELF, existingValue);
                currentTrie.set(key, newValue);
                currentTrie = newValue;
            }
            var lastKey = path[lastIndex];
            var container = currentTrie.get(lastKey);
            if (container instanceof Map) {
                currentTrie = container;
                container = currentTrie.get(lastKey);
                lastKey = $e774aa528375e473$var$SELF;
            }
            if (Array.isArray(container)) container.push(error);
            else currentTrie.set(lastKey, [
                error
            ]);
        }
    } catch (err) {
        _iterator.e(err);
    } finally{
        _iterator.f();
    }
    return trie;
}
function $e774aa528375e473$var$getErrorsByKey(trie, key) {
    var value = trie.get(key);
    if (value == null) return null;
    if (Array.isArray(value)) return value;
    var errors = [];
    $e774aa528375e473$var$recursivelyCopyErrorsIntoArray(value, errors);
    return errors;
}
function $e774aa528375e473$var$recursivelyCopyErrorsIntoArray(trieOrSet, errors) {
    var _iterator2 = (0, $e774aa528375e473$var$_createForOfIteratorHelper2["default"])(trieOrSet), _step2;
    try {
        for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
            var _step2$value = _step2.value, childKey = _step2$value[0], value = _step2$value[1];
            var oldLength = errors.length;
            if (Array.isArray(value)) errors.push.apply(errors, (0, $e774aa528375e473$var$_toConsumableArray2["default"])(value));
            else $e774aa528375e473$var$recursivelyCopyErrorsIntoArray(value, errors);
            if (childKey === $e774aa528375e473$var$SELF) continue;
            var newLength = errors.length;
            for(var index = oldLength; index < newLength; index++){
                var error = errors[index];
                if (error.path == null) errors[index] = (0, $e774aa528375e473$var$_objectSpread2["default"])((0, $e774aa528375e473$var$_objectSpread2["default"])({}, error), {}, {
                    path: [
                        childKey
                    ]
                });
                else error.path.unshift(childKey);
            }
        }
    } catch (err) {
        _iterator2.e(err);
    } finally{
        _iterator2.f();
    }
}
function $e774aa528375e473$var$getNestedErrorTrieByKey(trie, key) {
    var value = trie.get(key);
    if (value instanceof Map) return value;
    return null;
}
module.exports = {
    SELF: $e774aa528375e473$var$SELF,
    buildErrorTrie: $e774aa528375e473$var$buildErrorTrie,
    getErrorsByKey: $e774aa528375e473$var$getErrorsByKey,
    getNestedErrorTrieByKey: $e774aa528375e473$var$getNestedErrorTrieByKey
};

});

parcelRegister("enqEM", function(module, exports) {
'use strict';
var $a777e427df20ff5d$var$PREFIX = 'client:__type:';
var $a777e427df20ff5d$var$TYPE_SCHEMA_TYPE = '__TypeSchema';
function $a777e427df20ff5d$var$generateTypeID(typeName) {
    return $a777e427df20ff5d$var$PREFIX + typeName;
}
function $a777e427df20ff5d$var$isTypeID(id) {
    return id.indexOf($a777e427df20ff5d$var$PREFIX) === 0;
}
module.exports = {
    generateTypeID: $a777e427df20ff5d$var$generateTypeID,
    isTypeID: $a777e427df20ff5d$var$isTypeID,
    TYPE_SCHEMA_TYPE: $a777e427df20ff5d$var$TYPE_SCHEMA_TYPE
};

});



parcelRegister("1AjTQ", function(module, exports) {
'use strict';

var $kLQDK = parcelRequire("kLQDK");
var $127896e69098150f$var$getInlineDataFragment = $kLQDK.getInlineDataFragment;

var $ezyIu = parcelRequire("ezyIu");
var $127896e69098150f$var$FRAGMENTS_KEY = $ezyIu.FRAGMENTS_KEY;

var $jSI6G = parcelRequire("jSI6G");
function $127896e69098150f$var$readInlineData(fragment, fragmentRef) {
    var _fragmentRef$FRAGMENT;
    var inlineDataFragment = $127896e69098150f$var$getInlineDataFragment(fragment);
    if (fragmentRef == null) return fragmentRef;
    !(typeof fragmentRef === 'object') && $jSI6G(false);
    var inlineData = (_fragmentRef$FRAGMENT = fragmentRef[$127896e69098150f$var$FRAGMENTS_KEY]) === null || _fragmentRef$FRAGMENT === void 0 ? void 0 : _fragmentRef$FRAGMENT[inlineDataFragment.name];
    !(inlineData != null) && $jSI6G(false);
    return inlineData;
}
module.exports = $127896e69098150f$var$readInlineData;

});

parcelRegister("b5YyQ", function(module, exports) {
'use strict';

var $e27SU = parcelRequire("e27SU");
var $813f237ee3870a0c$var$_interopRequireDefault = $e27SU.default;

var $813f237ee3870a0c$var$_objectSpread2 = $813f237ee3870a0c$var$_interopRequireDefault((parcelRequire("caqem")));

var $7NbNP = parcelRequire("7NbNP");

var $kc5hH = parcelRequire("kc5hH");
var $813f237ee3870a0c$var$INTERNAL_ACTOR_IDENTIFIER_DO_NOT_USE = $kc5hH.INTERNAL_ACTOR_IDENTIFIER_DO_NOT_USE, $813f237ee3870a0c$var$assertInternalActorIdentifier = $kc5hH.assertInternalActorIdentifier;

var $5bMXV = parcelRequire("5bMXV");

var $2FtTY = parcelRequire("2FtTY");

var $fahOB = parcelRequire("fahOB");

var $i0kPp = parcelRequire("i0kPp");

var $9pOE6 = parcelRequire("9pOE6");

var $9ZDC9 = parcelRequire("9ZDC9");

var $kyemR = parcelRequire("kyemR");

var $gG6Ok = parcelRequire("gG6Ok");

var $1mBet = parcelRequire("1mBet");

var $cTg53 = parcelRequire("cTg53");

var $3fbkc = parcelRequire("3fbkc");

var $jSI6G = parcelRequire("jSI6G");
var $813f237ee3870a0c$var$RelayModernEnvironment = /*#__PURE__*/ function() {
    function RelayModernEnvironment(config) {
        var _this = this;
        var _config$store, _config$log, _config$relayFieldLog, _config$UNSTABLE_defa, _config$getDataID, _config$missingFieldH, _config$handlerProvid, _config$scheduler, _config$isServer, _config$normalizeResp, _config$operationTrac;
        this.configName = config.configName;
        this._treatMissingFieldsAsNull = config.treatMissingFieldsAsNull === true;
        this._deferDeduplicatedFields = config.deferDeduplicatedFields === true;
        var operationLoader = config.operationLoader;
        var store = (_config$store = config.store) !== null && _config$store !== void 0 ? _config$store : new $1mBet(new $3fbkc(), {
            getDataID: config.getDataID,
            log: config.log,
            operationLoader: config.operationLoader,
            shouldProcessClientComponents: config.shouldProcessClientComponents
        });
        this.__log = (_config$log = config.log) !== null && _config$log !== void 0 ? _config$log : $813f237ee3870a0c$var$emptyFunction;
        this.relayFieldLogger = (_config$relayFieldLog = config.relayFieldLogger) !== null && _config$relayFieldLog !== void 0 ? _config$relayFieldLog : $9ZDC9;
        this._defaultRenderPolicy = (_config$UNSTABLE_defa = config.UNSTABLE_defaultRenderPolicy) !== null && _config$UNSTABLE_defa !== void 0 ? _config$UNSTABLE_defa : 'partial';
        this._operationLoader = operationLoader;
        this._operationExecutions = new Map();
        this._network = $2FtTY(this, config.network);
        this._getDataID = (_config$getDataID = config.getDataID) !== null && _config$getDataID !== void 0 ? _config$getDataID : $9pOE6;
        this._missingFieldHandlers = (_config$missingFieldH = config.missingFieldHandlers) !== null && _config$missingFieldH !== void 0 ? _config$missingFieldH : [];
        this._publishQueue = new $cTg53(store, (_config$handlerProvid = config.handlerProvider) !== null && _config$handlerProvid !== void 0 ? _config$handlerProvid : $7NbNP, this._getDataID, this._missingFieldHandlers, this.__log);
        this._scheduler = (_config$scheduler = config.scheduler) !== null && _config$scheduler !== void 0 ? _config$scheduler : null;
        this._store = store;
        this.options = config.options;
        this._isServer = (_config$isServer = config.isServer) !== null && _config$isServer !== void 0 ? _config$isServer : false;
        this._normalizeResponse = (_config$normalizeResp = config.normalizeResponse) !== null && _config$normalizeResp !== void 0 ? _config$normalizeResp : $kyemR;
        this.__setNet = function(newNet) {
            return _this._network = $2FtTY(_this, newNet);
        };
        var _require2, inspect;
        this._operationTracker = (_config$operationTrac = config.operationTracker) !== null && _config$operationTrac !== void 0 ? _config$operationTrac : new $fahOB();
        this._shouldProcessClientComponents = config.shouldProcessClientComponents;
        $i0kPp(this);
    }
    var _proto = RelayModernEnvironment.prototype;
    _proto.getStore = function getStore() {
        return this._store;
    };
    _proto.getNetwork = function getNetwork() {
        return this._network;
    };
    _proto.getOperationTracker = function getOperationTracker() {
        return this._operationTracker;
    };
    _proto.getScheduler = function getScheduler() {
        return this._scheduler;
    };
    _proto.isRequestActive = function isRequestActive(requestIdentifier) {
        var activeState = this._operationExecutions.get(requestIdentifier);
        return activeState === 'active';
    };
    _proto.UNSTABLE_getDefaultRenderPolicy = function UNSTABLE_getDefaultRenderPolicy() {
        return this._defaultRenderPolicy;
    };
    _proto.applyUpdate = function applyUpdate(optimisticUpdate) {
        var _this2 = this;
        var dispose = function dispose() {
            _this2._scheduleUpdates(function() {
                _this2._publishQueue.revertUpdate(optimisticUpdate);
                _this2._publishQueue.run();
            });
        };
        this._scheduleUpdates(function() {
            _this2._publishQueue.applyUpdate(optimisticUpdate);
            _this2._publishQueue.run();
        });
        return {
            dispose: dispose
        };
    };
    _proto.revertUpdate = function revertUpdate(update) {
        var _this3 = this;
        this._scheduleUpdates(function() {
            _this3._publishQueue.revertUpdate(update);
            _this3._publishQueue.run();
        });
    };
    _proto.replaceUpdate = function replaceUpdate(update, newUpdate) {
        var _this4 = this;
        this._scheduleUpdates(function() {
            _this4._publishQueue.revertUpdate(update);
            _this4._publishQueue.applyUpdate(newUpdate);
            _this4._publishQueue.run();
        });
    };
    _proto.applyMutation = function applyMutation(optimisticConfig) {
        var subscription = this._execute({
            createSource: function createSource() {
                return $5bMXV.create(function(_sink) {});
            },
            isClientPayload: false,
            operation: optimisticConfig.operation,
            optimisticConfig: optimisticConfig,
            updater: null
        }).subscribe({});
        return {
            dispose: function dispose() {
                return subscription.unsubscribe();
            }
        };
    };
    _proto.check = function check(operation) {
        if (this._missingFieldHandlers.length === 0 && !$813f237ee3870a0c$var$operationHasClientAbstractTypes(operation)) return this._store.check(operation);
        return this._checkSelectorAndHandleMissingFields(operation, this._missingFieldHandlers);
    };
    _proto.commitPayload = function commitPayload(operation, payload) {
        this._execute({
            createSource: function createSource() {
                return $5bMXV.from({
                    data: payload
                });
            },
            isClientPayload: true,
            operation: operation,
            optimisticConfig: null,
            updater: null
        }).subscribe({});
    };
    _proto.commitUpdate = function commitUpdate(updater) {
        var _this5 = this;
        this._scheduleUpdates(function() {
            _this5._publishQueue.commitUpdate(updater);
            _this5._publishQueue.run();
        });
    };
    _proto.lookup = function lookup(readSelector) {
        return this._store.lookup(readSelector);
    };
    _proto.subscribe = function subscribe(snapshot, callback) {
        return this._store.subscribe(snapshot, callback);
    };
    _proto.retain = function retain(operation) {
        return this._store.retain(operation);
    };
    _proto.experimental_batchUpdates = function experimental_batchUpdates(callback) {
        var batchFn = this._store.experimental_batchUpdates;
        !(typeof batchFn === 'function') && $jSI6G(false);
        batchFn.call(this._store, callback);
    };
    _proto.isServer = function isServer() {
        return this._isServer;
    };
    _proto._checkSelectorAndHandleMissingFields = function _checkSelectorAndHandleMissingFields(operation, handlers) {
        var _this6 = this;
        var target = $3fbkc.create();
        var source = this._store.getSource();
        var result = this._store.check(operation, {
            defaultActorIdentifier: $813f237ee3870a0c$var$INTERNAL_ACTOR_IDENTIFIER_DO_NOT_USE,
            getSourceForActor: function getSourceForActor(actorIdentifier) {
                $813f237ee3870a0c$var$assertInternalActorIdentifier(actorIdentifier);
                return source;
            },
            getTargetForActor: function getTargetForActor(actorIdentifier) {
                $813f237ee3870a0c$var$assertInternalActorIdentifier(actorIdentifier);
                return target;
            },
            handlers: handlers
        });
        if (target.size() > 0) this._scheduleUpdates(function() {
            _this6._publishQueue.commitSource(target);
            _this6._publishQueue.run();
        });
        return result;
    };
    _proto._scheduleUpdates = function _scheduleUpdates(task) {
        var scheduler = this._scheduler;
        if (scheduler != null) scheduler.schedule(task);
        else task();
    };
    _proto.execute = function execute(_ref) {
        var _this7 = this;
        var operation = _ref.operation;
        return this._execute({
            createSource: function createSource() {
                return _this7.getNetwork().execute(operation.request.node.params, operation.request.variables, operation.request.cacheConfig || {}, null, undefined, undefined, undefined, function() {
                    return _this7.check(operation);
                });
            },
            isClientPayload: false,
            operation: operation,
            optimisticConfig: null,
            updater: null
        });
    };
    _proto.executeSubscription = function executeSubscription(_ref2) {
        var _this8 = this;
        var operation = _ref2.operation, updater = _ref2.updater;
        return this._execute({
            createSource: function createSource() {
                return _this8.getNetwork().execute(operation.request.node.params, operation.request.variables, operation.request.cacheConfig || {}, null);
            },
            isClientPayload: false,
            operation: operation,
            optimisticConfig: null,
            updater: updater
        });
    };
    _proto.executeMutation = function executeMutation(_ref3) {
        var _this9 = this;
        var operation = _ref3.operation, optimisticResponse = _ref3.optimisticResponse, optimisticUpdater = _ref3.optimisticUpdater, updater = _ref3.updater, uploadables = _ref3.uploadables;
        var optimisticConfig;
        if (optimisticResponse || optimisticUpdater) optimisticConfig = {
            operation: operation,
            response: optimisticResponse,
            updater: optimisticUpdater
        };
        return this._execute({
            createSource: function createSource() {
                return _this9.getNetwork().execute(operation.request.node.params, operation.request.variables, (0, $813f237ee3870a0c$var$_objectSpread2["default"])((0, $813f237ee3870a0c$var$_objectSpread2["default"])({}, operation.request.cacheConfig), {}, {
                    force: true
                }), uploadables);
            },
            isClientPayload: false,
            operation: operation,
            optimisticConfig: optimisticConfig,
            updater: updater
        });
    };
    _proto.executeWithSource = function executeWithSource(_ref4) {
        var operation = _ref4.operation, source = _ref4.source;
        return this._execute({
            createSource: function createSource() {
                return source;
            },
            isClientPayload: false,
            operation: operation,
            optimisticConfig: null,
            updater: null
        });
    };
    _proto.toJSON = function toJSON() {
        var _this$configName;
        return "RelayModernEnvironment(".concat((_this$configName = this.configName) !== null && _this$configName !== void 0 ? _this$configName : '', ")");
    };
    _proto._execute = function _execute(_ref5) {
        var _this0 = this;
        var createSource = _ref5.createSource, isClientPayload = _ref5.isClientPayload, operation = _ref5.operation, optimisticConfig = _ref5.optimisticConfig, updater = _ref5.updater;
        var publishQueue = this._publishQueue;
        var store = this._store;
        return $5bMXV.create(function(sink) {
            var executor = $gG6Ok.execute({
                actorIdentifier: $813f237ee3870a0c$var$INTERNAL_ACTOR_IDENTIFIER_DO_NOT_USE,
                getDataID: _this0._getDataID,
                getPublishQueue: function getPublishQueue(actorIdentifier) {
                    $813f237ee3870a0c$var$assertInternalActorIdentifier(actorIdentifier);
                    return publishQueue;
                },
                getStore: function getStore(actorIdentifier) {
                    $813f237ee3870a0c$var$assertInternalActorIdentifier(actorIdentifier);
                    return store;
                },
                isClientPayload: isClientPayload,
                log: _this0.__log,
                normalizeResponse: _this0._normalizeResponse,
                operation: operation,
                operationExecutions: _this0._operationExecutions,
                operationLoader: _this0._operationLoader,
                operationTracker: _this0._operationTracker,
                optimisticConfig: optimisticConfig,
                scheduler: _this0._scheduler,
                shouldProcessClientComponents: _this0._shouldProcessClientComponents,
                sink: sink,
                source: createSource(),
                treatMissingFieldsAsNull: _this0._treatMissingFieldsAsNull,
                deferDeduplicatedFields: _this0._deferDeduplicatedFields,
                updater: updater
            });
            return function() {
                return executor.cancel();
            };
        });
    };
    return RelayModernEnvironment;
}();
function $813f237ee3870a0c$var$operationHasClientAbstractTypes(operation) {
    return operation.root.node.kind === 'Operation' && operation.root.node.clientAbstractTypes != null;
}
$813f237ee3870a0c$var$RelayModernEnvironment.prototype['@@RelayModernEnvironment'] = true;
function $813f237ee3870a0c$var$emptyFunction() {}
module.exports = $813f237ee3870a0c$var$RelayModernEnvironment;

});
parcelRegister("2FtTY", function(module, exports) {
'use strict';

var $k96f4 = parcelRequire("k96f4");
function $1f169af8be6ce4e6$var$wrapNetworkWithLogObserver(env, network) {
    return {
        execute: function execute(params, variables, cacheConfig, uploadables, _, encryptedVariables, preprocessResponse, checkOperation) {
            var networkRequestId = $k96f4();
            var logObserver = {
                start: function start(subscription) {
                    env.__log({
                        name: 'network.start',
                        networkRequestId: networkRequestId,
                        params: params,
                        variables: variables,
                        cacheConfig: cacheConfig
                    });
                },
                next: function next(response) {
                    env.__log({
                        name: 'network.next',
                        networkRequestId: networkRequestId,
                        response: response
                    });
                },
                error: function error(_error) {
                    env.__log({
                        name: 'network.error',
                        networkRequestId: networkRequestId,
                        error: _error
                    });
                },
                complete: function complete() {
                    env.__log({
                        name: 'network.complete',
                        networkRequestId: networkRequestId
                    });
                },
                unsubscribe: function unsubscribe() {
                    env.__log({
                        name: 'network.unsubscribe',
                        networkRequestId: networkRequestId
                    });
                }
            };
            var logRequestInfo = function logRequestInfo(info) {
                env.__log({
                    name: 'network.info',
                    networkRequestId: networkRequestId,
                    info: info
                });
            };
            return network.execute(params, variables, cacheConfig, uploadables, logRequestInfo, encryptedVariables, preprocessResponse, checkOperation)["do"](logObserver);
        }
    };
}
module.exports = $1f169af8be6ce4e6$var$wrapNetworkWithLogObserver;

});
parcelRegister("k96f4", function(module, exports) {
'use strict';
var $eaa97d72cc496cea$var$id = 100000;
function $eaa97d72cc496cea$var$generateID() {
    return $eaa97d72cc496cea$var$id++;
}
module.exports = $eaa97d72cc496cea$var$generateID;

});


parcelRegister("fahOB", function(module, exports) {
'use strict';

var $e27SU = parcelRequire("e27SU");
var $b0a59be654d09e19$var$_interopRequireDefault = $e27SU.default;

var $b0a59be654d09e19$var$_createForOfIteratorHelper2 = $b0a59be654d09e19$var$_interopRequireDefault((parcelRequire("5dSyV")));

var $jSI6G = parcelRequire("jSI6G");
var $b0a59be654d09e19$var$RelayOperationTracker = /*#__PURE__*/ function() {
    function RelayOperationTracker() {
        this._ownersToPendingOperations = new Map();
        this._pendingOperationsToOwners = new Map();
        this._ownersToPendingPromise = new Map();
    }
    var _proto = RelayOperationTracker.prototype;
    _proto.update = function update(pendingOperation, affectedOwners) {
        if (affectedOwners.size === 0) return;
        var pendingOperationIdentifier = pendingOperation.identifier;
        var newlyAffectedOwnersIdentifier = new Set();
        var _iterator = (0, $b0a59be654d09e19$var$_createForOfIteratorHelper2["default"])(affectedOwners), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var owner = _step.value;
                var ownerIdentifier = owner.identifier;
                var pendingOperationsAffectingOwner = this._ownersToPendingOperations.get(ownerIdentifier);
                if (pendingOperationsAffectingOwner != null) {
                    if (!pendingOperationsAffectingOwner.has(pendingOperationIdentifier)) {
                        pendingOperationsAffectingOwner.set(pendingOperationIdentifier, pendingOperation);
                        newlyAffectedOwnersIdentifier.add(ownerIdentifier);
                    }
                } else {
                    this._ownersToPendingOperations.set(ownerIdentifier, new Map([
                        [
                            pendingOperationIdentifier,
                            pendingOperation
                        ]
                    ]));
                    newlyAffectedOwnersIdentifier.add(ownerIdentifier);
                }
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
        if (newlyAffectedOwnersIdentifier.size === 0) return;
        var ownersAffectedByPendingOperation = this._pendingOperationsToOwners.get(pendingOperationIdentifier) || new Set();
        var _iterator2 = (0, $b0a59be654d09e19$var$_createForOfIteratorHelper2["default"])(newlyAffectedOwnersIdentifier), _step2;
        try {
            for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                var _ownerIdentifier = _step2.value;
                this._resolveOwnerResolvers(_ownerIdentifier);
                ownersAffectedByPendingOperation.add(_ownerIdentifier);
            }
        } catch (err) {
            _iterator2.e(err);
        } finally{
            _iterator2.f();
        }
        this._pendingOperationsToOwners.set(pendingOperationIdentifier, ownersAffectedByPendingOperation);
    };
    _proto.complete = function complete(pendingOperation) {
        var pendingOperationIdentifier = pendingOperation.identifier;
        var affectedOwnersIdentifier = this._pendingOperationsToOwners.get(pendingOperationIdentifier);
        if (affectedOwnersIdentifier == null) return;
        var completedOwnersIdentifier = new Set();
        var updatedOwnersIdentifier = new Set();
        var _iterator3 = (0, $b0a59be654d09e19$var$_createForOfIteratorHelper2["default"])(affectedOwnersIdentifier), _step3;
        try {
            for(_iterator3.s(); !(_step3 = _iterator3.n()).done;){
                var ownerIdentifier = _step3.value;
                var pendingOperationsAffectingOwner = this._ownersToPendingOperations.get(ownerIdentifier);
                if (!pendingOperationsAffectingOwner) continue;
                pendingOperationsAffectingOwner["delete"](pendingOperationIdentifier);
                if (pendingOperationsAffectingOwner.size > 0) updatedOwnersIdentifier.add(ownerIdentifier);
                else completedOwnersIdentifier.add(ownerIdentifier);
            }
        } catch (err) {
            _iterator3.e(err);
        } finally{
            _iterator3.f();
        }
        var _iterator4 = (0, $b0a59be654d09e19$var$_createForOfIteratorHelper2["default"])(completedOwnersIdentifier), _step4;
        try {
            for(_iterator4.s(); !(_step4 = _iterator4.n()).done;){
                var _ownerIdentifier2 = _step4.value;
                this._resolveOwnerResolvers(_ownerIdentifier2);
                this._ownersToPendingOperations["delete"](_ownerIdentifier2);
            }
        } catch (err) {
            _iterator4.e(err);
        } finally{
            _iterator4.f();
        }
        var _iterator5 = (0, $b0a59be654d09e19$var$_createForOfIteratorHelper2["default"])(updatedOwnersIdentifier), _step5;
        try {
            for(_iterator5.s(); !(_step5 = _iterator5.n()).done;){
                var _ownerIdentifier3 = _step5.value;
                this._resolveOwnerResolvers(_ownerIdentifier3);
            }
        } catch (err) {
            _iterator5.e(err);
        } finally{
            _iterator5.f();
        }
        this._pendingOperationsToOwners["delete"](pendingOperationIdentifier);
    };
    _proto._resolveOwnerResolvers = function _resolveOwnerResolvers(ownerIdentifier) {
        var promiseEntry = this._ownersToPendingPromise.get(ownerIdentifier);
        if (promiseEntry != null) promiseEntry.resolve();
        this._ownersToPendingPromise["delete"](ownerIdentifier);
    };
    _proto.getPendingOperationsAffectingOwner = function getPendingOperationsAffectingOwner(owner) {
        var ownerIdentifier = owner.identifier;
        var pendingOperationsForOwner = this._ownersToPendingOperations.get(ownerIdentifier);
        if (pendingOperationsForOwner == null || pendingOperationsForOwner.size === 0) return null;
        var cachedPromiseEntry = this._ownersToPendingPromise.get(ownerIdentifier);
        if (cachedPromiseEntry != null) return {
            promise: cachedPromiseEntry.promise,
            pendingOperations: cachedPromiseEntry.pendingOperations
        };
        var resolve;
        var promise = new Promise(function(r) {
            resolve = r;
        });
        !(resolve != null) && $jSI6G(false);
        var pendingOperations = Array.from(pendingOperationsForOwner.values());
        this._ownersToPendingPromise.set(ownerIdentifier, {
            promise: promise,
            resolve: resolve,
            pendingOperations: pendingOperations
        });
        return {
            promise: promise,
            pendingOperations: pendingOperations
        };
    };
    return RelayOperationTracker;
}();
module.exports = $b0a59be654d09e19$var$RelayOperationTracker;

});

parcelRegister("i0kPp", function(module, exports) {
'use strict';
function $d1b8621dcb0e603f$var$registerEnvironmentWithDevTools(environment) {
    var _global = typeof $parcel$global !== 'undefined' ? $parcel$global : typeof window !== 'undefined' ? window : undefined;
    var devToolsHook = _global && _global.__RELAY_DEVTOOLS_HOOK__;
    if (devToolsHook) devToolsHook.registerEnvironment(environment);
}
module.exports = $d1b8621dcb0e603f$var$registerEnvironmentWithDevTools;

});

parcelRegister("9ZDC9", function(module, exports) {
'use strict';
var $74688a1e8c8f65ac$var$defaultRelayFieldLogger = function defaultRelayFieldLogger(event) {};
module.exports = $74688a1e8c8f65ac$var$defaultRelayFieldLogger;

});

parcelRegister("gG6Ok", function(module, exports) {
'use strict';

var $e27SU = parcelRequire("e27SU");
var $c245da0dab2b3bef$var$_interopRequireDefault = $e27SU.default;

var $c245da0dab2b3bef$var$_createForOfIteratorHelper2 = $c245da0dab2b3bef$var$_interopRequireDefault((parcelRequire("5dSyV")));

var $c245da0dab2b3bef$var$_toConsumableArray2 = $c245da0dab2b3bef$var$_interopRequireDefault((parcelRequire("lLsx3")));

var $5bMXV = parcelRequire("5bMXV");

var $k96f4 = parcelRequire("k96f4");

var $gJkyh = parcelRequire("gJkyh");

var $lFwfm = parcelRequire("lFwfm");

var $gZYpt = parcelRequire("gZYpt");

var $4hUjJ = parcelRequire("4hUjJ");
var $c245da0dab2b3bef$var$stableCopy = $4hUjJ.stableCopy;

var $9pi7j = parcelRequire("9pi7j");

var $9pidS = parcelRequire("9pidS");
var $c245da0dab2b3bef$var$generateClientID = $9pidS.generateClientID, $c245da0dab2b3bef$var$generateUniqueClientID = $9pidS.generateUniqueClientID;

var $adnaT = parcelRequire("adnaT");
var $c245da0dab2b3bef$var$getLocalVariables = $adnaT.getLocalVariables;

var $7SC8Z = parcelRequire("7SC8Z");

var $iUq0k = parcelRequire("iUq0k");
var $c245da0dab2b3bef$var$createNormalizationSelector = $iUq0k.createNormalizationSelector, $c245da0dab2b3bef$var$createReaderSelector = $iUq0k.createReaderSelector;

var $3fbkc = parcelRequire("3fbkc");

var $ezyIu = parcelRequire("ezyIu");
var $c245da0dab2b3bef$var$ROOT_TYPE = $ezyIu.ROOT_TYPE, $c245da0dab2b3bef$var$TYPENAME_KEY = $ezyIu.TYPENAME_KEY, $c245da0dab2b3bef$var$getStorageKey = $ezyIu.getStorageKey;

var $jSI6G = parcelRequire("jSI6G");
parcelRequire("2OmBw");
function $c245da0dab2b3bef$var$execute(config) {
    return new $c245da0dab2b3bef$var$Executor(config);
}
var $c245da0dab2b3bef$var$Executor = /*#__PURE__*/ function() {
    function Executor(_ref3) {
        var _this = this;
        var _ref, _this$_operation$requ, _this$_operation$requ2;
        var actorIdentifier = _ref3.actorIdentifier, getDataID = _ref3.getDataID, getPublishQueue = _ref3.getPublishQueue, getStore = _ref3.getStore, isClientPayload = _ref3.isClientPayload, operation = _ref3.operation, operationExecutions = _ref3.operationExecutions, operationLoader = _ref3.operationLoader, operationTracker = _ref3.operationTracker, optimisticConfig = _ref3.optimisticConfig, scheduler = _ref3.scheduler, shouldProcessClientComponents = _ref3.shouldProcessClientComponents, sink = _ref3.sink, source = _ref3.source, treatMissingFieldsAsNull = _ref3.treatMissingFieldsAsNull, deferDeduplicatedFields = _ref3.deferDeduplicatedFields, updater = _ref3.updater, log = _ref3.log, normalizeResponse = _ref3.normalizeResponse;
        this._actorIdentifier = actorIdentifier;
        this._getDataID = getDataID;
        this._treatMissingFieldsAsNull = treatMissingFieldsAsNull;
        this._deferDeduplicatedFields = deferDeduplicatedFields;
        this._incrementalPayloadsPending = false;
        this._incrementalResults = new Map();
        this._log = log;
        this._executeId = $k96f4();
        this._nextSubscriptionId = 0;
        this._operation = operation;
        this._operationExecutions = operationExecutions;
        this._operationLoader = operationLoader;
        this._operationTracker = operationTracker;
        this._operationUpdateEpochs = new Map();
        this._optimisticUpdates = null;
        this._useExecTimeResolvers = (_ref = (_this$_operation$requ = this._operation.request.node.operation.use_exec_time_resolvers) !== null && _this$_operation$requ !== void 0 ? _this$_operation$requ : ((_this$_operation$requ2 = this._operation.request.node.operation.exec_time_resolvers_enabled_provider) === null || _this$_operation$requ2 === void 0 ? void 0 : _this$_operation$requ2.get()) === true) !== null && _ref !== void 0 ? _ref : false;
        this._execTimeResolverResponseComplete = false;
        this._pendingModulePayloadsCount = 0;
        this._getPublishQueue = getPublishQueue;
        this._scheduler = scheduler;
        this._sink = sink;
        this._source = new Map();
        this._state = 'started';
        this._getStore = getStore;
        this._subscriptions = new Map();
        this._updater = updater;
        this._isClientPayload = isClientPayload === true;
        this._isSubscriptionOperation = this._operation.request.node.params.operationKind === 'subscription';
        this._shouldProcessClientComponents = shouldProcessClientComponents;
        this._retainDisposables = new Map();
        this._seenActors = new Set();
        this._completeFns = [];
        this._normalizeResponse = normalizeResponse;
        this._isClientQuery = this._operation.request.node.params.id == null && this._operation.request.node.params.text == null;
        var id = this._nextSubscriptionId++;
        if ($gZYpt.PROCESS_OPTIMISTIC_UPDATE_BEFORE_SUBSCRIPTION && optimisticConfig != null) this._processOptimisticResponse(optimisticConfig.response != null ? {
            data: optimisticConfig.response
        } : null, optimisticConfig.updater, false);
        source.subscribe({
            complete: function complete() {
                return _this._complete(id);
            },
            error: function error(_error2) {
                return _this._error(_error2);
            },
            next: function next(response) {
                try {
                    _this._next(id, response);
                } catch (error) {
                    sink.error(error);
                }
            },
            start: function start(subscription) {
                var _this$_operation$requ3;
                _this._start(id, subscription);
                _this._log({
                    cacheConfig: (_this$_operation$requ3 = _this._operation.request.cacheConfig) !== null && _this$_operation$requ3 !== void 0 ? _this$_operation$requ3 : {},
                    executeId: _this._executeId,
                    name: 'execute.start',
                    params: _this._operation.request.node.params,
                    variables: _this._operation.request.variables
                });
            },
            unsubscribe: function unsubscribe() {
                _this._log({
                    executeId: _this._executeId,
                    name: 'execute.unsubscribe'
                });
            }
        });
        if (!$gZYpt.PROCESS_OPTIMISTIC_UPDATE_BEFORE_SUBSCRIPTION && optimisticConfig != null) this._processOptimisticResponse(optimisticConfig.response != null ? {
            data: optimisticConfig.response
        } : null, optimisticConfig.updater, false);
    }
    var _proto = Executor.prototype;
    _proto.cancel = function cancel() {
        var _this2 = this;
        if (this._state === 'completed') return;
        this._state = 'completed';
        this._operationExecutions["delete"](this._operation.request.identifier);
        if (this._subscriptions.size !== 0) {
            this._subscriptions.forEach(function(sub) {
                return sub.unsubscribe();
            });
            this._subscriptions.clear();
        }
        var optimisticUpdates = this._optimisticUpdates;
        if (optimisticUpdates !== null) {
            this._optimisticUpdates = null;
            optimisticUpdates.forEach(function(update) {
                return _this2._getPublishQueueAndSaveActor().revertUpdate(update);
            });
            this._runPublishQueue();
        }
        this._incrementalResults.clear();
        if (this._asyncStoreUpdateDisposable != null) {
            this._asyncStoreUpdateDisposable.dispose();
            this._asyncStoreUpdateDisposable = null;
        }
        this._completeFns = [];
        this._completeOperationTracker();
        this._disposeRetainedData();
    };
    _proto._updateActiveState = function _updateActiveState() {
        var activeState;
        switch(this._state){
            case 'started':
                activeState = 'active';
                break;
            case 'loading_incremental':
                activeState = 'active';
                break;
            case 'completed':
                activeState = 'inactive';
                break;
            case 'loading_final':
                activeState = this._pendingModulePayloadsCount > 0 || this._useExecTimeResolvers && !this._execTimeResolverResponseComplete ? 'active' : 'inactive';
                break;
            default:
                this._state;
                $jSI6G(false);
        }
        this._operationExecutions.set(this._operation.request.identifier, activeState);
    };
    _proto._schedule = function _schedule(task, priority) {
        var _this3 = this;
        var scheduler = this._scheduler;
        if (scheduler != null) {
            var id = this._nextSubscriptionId++;
            $5bMXV.create(function(sink) {
                var cancellationToken = scheduler.schedule(function() {
                    try {
                        task();
                        sink.complete();
                    } catch (error) {
                        sink.error(error);
                    }
                }, priority);
                return function() {
                    return scheduler.cancel(cancellationToken);
                };
            }).subscribe({
                complete: function complete() {
                    return _this3._complete(id);
                },
                error: function error(_error3) {
                    return _this3._error(_error3);
                },
                start: function start(subscription) {
                    return _this3._start(id, subscription);
                }
            });
        } else task();
    };
    _proto._complete = function _complete(id) {
        this._subscriptions["delete"](id);
        if (this._subscriptions.size === 0) {
            this.cancel();
            this._sink.complete();
            this._log({
                executeId: this._executeId,
                name: 'execute.complete'
            });
        }
    };
    _proto._error = function _error(error) {
        this.cancel();
        this._sink.error(error);
        this._log({
            error: error,
            executeId: this._executeId,
            name: 'execute.error'
        });
    };
    _proto._start = function _start(id, subscription) {
        this._subscriptions.set(id, subscription);
        this._updateActiveState();
    };
    _proto._next = function _next(_id, response) {
        var _this4 = this;
        var priority = this._state === 'loading_incremental' ? 'low' : 'default';
        this._schedule(function() {
            if (!Array.isArray(response) && response.isPreNormalized === true) {
                _this4._handlePreNormalizedPayload(response);
                return;
            }
            var graphQLResponse = response;
            _this4._log({
                executeId: _this4._executeId,
                name: 'execute.next.start',
                operation: _this4._operation,
                response: graphQLResponse
            });
            _this4._handleNext(graphQLResponse);
            _this4._maybeCompleteSubscriptionOperationTracking();
            _this4._log({
                executeId: _this4._executeId,
                name: 'execute.next.end',
                operation: _this4._operation,
                response: graphQLResponse
            });
        }, priority);
    };
    _proto._handleErrorResponse = function _handleErrorResponse(responses) {
        var _this5 = this;
        var results = [];
        responses.forEach(function(response) {
            if (response.data === null && response.extensions != null && !response.hasOwnProperty('errors')) return;
            else if (response.data == null) {
                var errors = response.hasOwnProperty('errors') && response.errors != null ? response.errors : null;
                var messages = errors ? errors.map(function(_ref4) {
                    var message = _ref4.message;
                    return message;
                }).join('\n') : '(No errors)';
                var error = $lFwfm.create('RelayNetwork', 'No data returned for operation `' + _this5._operation.request.node.params.name + '`, got error(s):\n' + messages + '\n\nSee the error `source` property for more information.');
                error.source = {
                    errors: errors,
                    operation: _this5._operation.request.node,
                    variables: _this5._operation.request.variables
                };
                error.stack;
                throw error;
            } else {
                var responseWithData = response;
                results.push(responseWithData);
            }
        });
        return results;
    };
    _proto._handleOptimisticResponses = function _handleOptimisticResponses(responses) {
        var _response$extensions;
        if (responses.length > 1) {
            if (responses.some(function(responsePart) {
                var _responsePart$extensi;
                return ((_responsePart$extensi = responsePart.extensions) === null || _responsePart$extensi === void 0 ? void 0 : _responsePart$extensi.isOptimistic) === true;
            })) $jSI6G(false);
            return false;
        }
        var response = responses[0];
        var isOptimistic = ((_response$extensions = response.extensions) === null || _response$extensions === void 0 ? void 0 : _response$extensions.isOptimistic) === true;
        if (isOptimistic && this._state !== 'started') $jSI6G(false);
        if (isOptimistic) {
            this._processOptimisticResponse(response, null, this._treatMissingFieldsAsNull);
            this._sink.next(response);
            return true;
        }
        return false;
    };
    _proto._handlePreNormalizedPayload = function _handlePreNormalizedPayload(payload) {
        var _this6 = this;
        var _payload$storeUpdater;
        if (this._state === 'completed') return;
        this._seenActors.clear();
        if (this._optimisticUpdates !== null) {
            this._optimisticUpdates.forEach(function(update) {
                return _this6._getPublishQueueAndSaveActor().revertUpdate(update);
            });
            this._optimisticUpdates = null;
        }
        this._getPublishQueueAndSaveActor().commitPayload(this._operation, payload, (_payload$storeUpdater = payload.storeUpdater) !== null && _payload$storeUpdater !== void 0 ? _payload$storeUpdater : this._updater);
        if (payload.isFinal) this._state = 'loading_final';
        else if (this._state === 'started') this._state = 'loading_incremental';
        var updatedOwners = this._runPublishQueue(this._operation);
        this._updateActiveState();
        this._updateOperationTracker(updatedOwners);
    };
    _proto._handleNext = function _handleNext(response) {
        if (this._state === 'completed') return;
        this._seenActors.clear();
        var responses = Array.isArray(response) ? response : [
            response
        ];
        var responsesWithData = this._handleErrorResponse(responses);
        if (responsesWithData.length === 0) {
            var isFinal = responses.some(function(x) {
                var _x$extensions;
                return ((_x$extensions = x.extensions) === null || _x$extensions === void 0 ? void 0 : _x$extensions.is_final) === true;
            });
            if (isFinal) {
                if (this._useExecTimeResolvers && this._state !== 'loading_final' && responses.some(function(x) {
                    var _x$extensions2;
                    return ((_x$extensions2 = x.extensions) === null || _x$extensions2 === void 0 ? void 0 : _x$extensions2.is_normalized) === true;
                })) {
                    this._execTimeResolverResponseComplete = true;
                    if (!this._isClientQuery && responses.some(function(x) {
                        var _x$extensions3;
                        return ((_x$extensions3 = x.extensions) === null || _x$extensions3 === void 0 ? void 0 : _x$extensions3.is_client_only) === true;
                    })) this._isClientQuery = true;
                    if (this._isClientQuery) this._state = 'loading_final';
                    this._updateActiveState();
                } else {
                    this._state = 'loading_final';
                    this._updateActiveState();
                    this._incrementalPayloadsPending = false;
                }
            }
            this._sink.next(response);
            return;
        }
        var isOptimistic = this._handleOptimisticResponses(responsesWithData);
        if (isOptimistic) return;
        var _partitionGraphQLResp = $c245da0dab2b3bef$var$partitionGraphQLResponses(responsesWithData), nonIncrementalResponses = _partitionGraphQLResp[0], incrementalResponses = _partitionGraphQLResp[1], normalizedResponses = _partitionGraphQLResp[2];
        var hasNonIncrementalResponses = nonIncrementalResponses.length > 0;
        var hasNormalizedResponses = normalizedResponses.length > 0;
        if (hasNonIncrementalResponses) {
            if (this._isSubscriptionOperation) {
                var nextID = $c245da0dab2b3bef$var$generateUniqueClientID();
                this._operation = {
                    fragment: $c245da0dab2b3bef$var$createReaderSelector(this._operation.fragment.node, nextID, this._operation.fragment.variables, this._operation.fragment.owner),
                    request: this._operation.request,
                    root: $c245da0dab2b3bef$var$createNormalizationSelector(this._operation.root.node, nextID, this._operation.root.variables)
                };
            }
            var payloadFollowups = this._processResponses(nonIncrementalResponses);
            this._processPayloadFollowups(payloadFollowups);
        }
        if (hasNormalizedResponses) {
            var _payloadFollowups = [];
            for(var i = 0; i < normalizedResponses.length; i++){
                var _response$extensions2, _response$extensions3;
                var _response = normalizedResponses[i];
                var source = new $3fbkc(_response.data);
                var isFinal = ((_response$extensions2 = _response.extensions) === null || _response$extensions2 === void 0 ? void 0 : _response$extensions2.is_final) === true;
                if (((_response$extensions3 = _response.extensions) === null || _response$extensions3 === void 0 ? void 0 : _response$extensions3.is_client_only) === true) this._isClientQuery = true;
                var payload = {
                    errors: [],
                    fieldPayloads: [],
                    followupPayloads: [],
                    incrementalPlaceholders: [],
                    isFinal: isFinal,
                    source: source
                };
                this._getPublishQueueAndSaveActor().commitPayload(this._operation, payload, this._updater);
                _payloadFollowups.push(payload);
                this._execTimeResolverResponseComplete = isFinal;
                if (isFinal) {
                    if (this._isClientQuery) this._state = 'loading_final';
                    this._updateActiveState();
                }
            }
        }
        if (incrementalResponses.length > 0) {
            var _payloadFollowups2 = this._processIncrementalResponses(incrementalResponses);
            this._processPayloadFollowups(_payloadFollowups2);
        }
        if (this._isSubscriptionOperation) {
            if (responsesWithData[0].extensions == null) responsesWithData[0].extensions = {
                __relay_subscription_root_id: this._operation.fragment.dataID
            };
            else responsesWithData[0].extensions.__relay_subscription_root_id = this._operation.fragment.dataID;
        }
        var updatedOwners = this._runPublishQueue(hasNonIncrementalResponses || hasNormalizedResponses ? this._operation : undefined);
        if (hasNonIncrementalResponses) {
            if (this._incrementalPayloadsPending) this._retainData();
        }
        this._updateOperationTracker(updatedOwners);
        this._sink.next(response);
    };
    _proto._processOptimisticResponse = function _processOptimisticResponse(response, updater, treatMissingFieldsAsNull) {
        var _this7 = this;
        !(this._optimisticUpdates === null) && $jSI6G(false);
        if (response == null && updater == null) return;
        var optimisticUpdates = [];
        if (response) {
            var payload = this._normalizeResponse(response, this._operation.root, $c245da0dab2b3bef$var$ROOT_TYPE, {
                actorIdentifier: this._actorIdentifier,
                deferDeduplicatedFields: false,
                getDataID: this._getDataID,
                log: this._log,
                path: [],
                shouldProcessClientComponents: this._shouldProcessClientComponents,
                treatMissingFieldsAsNull: treatMissingFieldsAsNull
            }, this._useExecTimeResolvers);
            $c245da0dab2b3bef$var$validateOptimisticResponsePayload(payload);
            optimisticUpdates.push({
                operation: this._operation,
                payload: payload,
                updater: updater
            });
            this._processOptimisticFollowups(payload, optimisticUpdates);
        } else if (updater) optimisticUpdates.push({
            operation: this._operation,
            payload: {
                errors: null,
                fieldPayloads: null,
                followupPayloads: null,
                incrementalPlaceholders: null,
                isFinal: false,
                source: $3fbkc.create()
            },
            updater: updater
        });
        this._optimisticUpdates = optimisticUpdates;
        optimisticUpdates.forEach(function(update) {
            return _this7._getPublishQueueAndSaveActor().applyUpdate(update);
        });
        var updatedOwners = this._runPublishQueue();
        if ($gZYpt.ENABLE_OPERATION_TRACKER_OPTIMISTIC_UPDATES) this._updateOperationTracker(updatedOwners);
    };
    _proto._processOptimisticFollowups = function _processOptimisticFollowups(payload, optimisticUpdates) {
        if (payload.followupPayloads && payload.followupPayloads.length) {
            var followupPayloads = payload.followupPayloads;
            var _iterator = (0, $c245da0dab2b3bef$var$_createForOfIteratorHelper2["default"])(followupPayloads), _step;
            try {
                for(_iterator.s(); !(_step = _iterator.n()).done;){
                    var followupPayload = _step.value;
                    switch(followupPayload.kind){
                        case 'ModuleImportPayload':
                            var operationLoader = this._expectOperationLoader();
                            var operation = operationLoader.get(followupPayload.operationReference);
                            if (operation == null) this._processAsyncOptimisticModuleImport(followupPayload);
                            else {
                                var moduleImportOptimisticUpdates = this._processOptimisticModuleImport(operation, followupPayload);
                                optimisticUpdates.push.apply(optimisticUpdates, (0, $c245da0dab2b3bef$var$_toConsumableArray2["default"])(moduleImportOptimisticUpdates));
                            }
                            break;
                        case 'ActorPayload':
                            break;
                        default:
                            followupPayload;
                            $jSI6G(false);
                    }
                }
            } catch (err) {
                _iterator.e(err);
            } finally{
                _iterator.f();
            }
        }
    };
    _proto._normalizeFollowupPayload = function _normalizeFollowupPayload(followupPayload, normalizationNode) {
        var variables;
        if (normalizationNode.kind === 'SplitOperation' && followupPayload.kind === 'ModuleImportPayload') variables = $c245da0dab2b3bef$var$getLocalVariables(followupPayload.variables, normalizationNode.argumentDefinitions, followupPayload.args);
        else variables = followupPayload.variables;
        var selector = $c245da0dab2b3bef$var$createNormalizationSelector(normalizationNode, followupPayload.dataID, variables);
        var nextResponse = {
            data: followupPayload.data,
            extensions: this._state === 'loading_final' ? {
                is_final: true
            } : undefined
        };
        return this._normalizeResponse(nextResponse, selector, followupPayload.typeName, {
            actorIdentifier: this._actorIdentifier,
            deferDeduplicatedFields: false,
            getDataID: this._getDataID,
            log: this._log,
            path: followupPayload.path,
            shouldProcessClientComponents: this._shouldProcessClientComponents,
            treatMissingFieldsAsNull: this._treatMissingFieldsAsNull
        }, this._useExecTimeResolvers);
    };
    _proto._processOptimisticModuleImport = function _processOptimisticModuleImport(normalizationRootNode, moduleImportPayload) {
        var operation = $gJkyh(normalizationRootNode);
        var optimisticUpdates = [];
        var modulePayload = this._normalizeFollowupPayload(moduleImportPayload, operation);
        $c245da0dab2b3bef$var$validateOptimisticResponsePayload(modulePayload);
        optimisticUpdates.push({
            operation: this._operation,
            payload: modulePayload,
            updater: null
        });
        this._processOptimisticFollowups(modulePayload, optimisticUpdates);
        return optimisticUpdates;
    };
    _proto._processAsyncOptimisticModuleImport = function _processAsyncOptimisticModuleImport(moduleImportPayload) {
        var _this8 = this;
        this._expectOperationLoader().load(moduleImportPayload.operationReference).then(function(operation) {
            if (operation == null || _this8._state !== 'started') return;
            var moduleImportOptimisticUpdates = _this8._processOptimisticModuleImport(operation, moduleImportPayload);
            moduleImportOptimisticUpdates.forEach(function(update) {
                return _this8._getPublishQueueAndSaveActor().applyUpdate(update);
            });
            if (_this8._optimisticUpdates == null) ;
            else {
                var _this$_optimisticUpda;
                (_this$_optimisticUpda = _this8._optimisticUpdates).push.apply(_this$_optimisticUpda, (0, $c245da0dab2b3bef$var$_toConsumableArray2["default"])(moduleImportOptimisticUpdates));
                _this8._runPublishQueue();
            }
        });
    };
    _proto._processResponses = function _processResponses(responses) {
        var _this9 = this;
        this._log({
            name: 'execute.normalize.start',
            operation: this._operation
        });
        if (this._optimisticUpdates !== null) {
            this._optimisticUpdates.forEach(function(update) {
                _this9._getPublishQueueAndSaveActor().revertUpdate(update);
            });
            this._optimisticUpdates = null;
        }
        this._incrementalPayloadsPending = false;
        this._incrementalResults.clear();
        this._source.clear();
        return responses.map(function(payloadPart) {
            var relayPayload = _this9._normalizeResponse(payloadPart, _this9._operation.root, $c245da0dab2b3bef$var$ROOT_TYPE, {
                actorIdentifier: _this9._actorIdentifier,
                deferDeduplicatedFields: false,
                getDataID: _this9._getDataID,
                log: _this9._log,
                path: [],
                shouldProcessClientComponents: _this9._shouldProcessClientComponents,
                treatMissingFieldsAsNull: _this9._treatMissingFieldsAsNull
            }, _this9._useExecTimeResolvers);
            _this9._getPublishQueueAndSaveActor().commitPayload(_this9._operation, relayPayload, _this9._updater);
            _this9._log({
                name: 'execute.normalize.end',
                operation: _this9._operation
            });
            return relayPayload;
        });
    };
    _proto._processPayloadFollowups = function _processPayloadFollowups(payloads) {
        var _this0 = this;
        if (this._state === 'completed') return;
        payloads.forEach(function(payload) {
            var incrementalPlaceholders = payload.incrementalPlaceholders, followupPayloads = payload.followupPayloads, isFinal = payload.isFinal;
            _this0._state = isFinal ? 'loading_final' : 'loading_incremental';
            _this0._updateActiveState();
            if (isFinal) _this0._incrementalPayloadsPending = false;
            if (followupPayloads && followupPayloads.length !== 0) followupPayloads.forEach(function(followupPayload) {
                var _followupPayload$acto;
                var prevActorIdentifier = _this0._actorIdentifier;
                _this0._actorIdentifier = (_followupPayload$acto = followupPayload.actorIdentifier) !== null && _followupPayload$acto !== void 0 ? _followupPayload$acto : _this0._actorIdentifier;
                _this0._processFollowupPayload(followupPayload);
                _this0._actorIdentifier = prevActorIdentifier;
            });
            if (incrementalPlaceholders && incrementalPlaceholders.length !== 0) {
                _this0._incrementalPayloadsPending = _this0._state !== 'loading_final';
                incrementalPlaceholders.forEach(function(incrementalPlaceholder) {
                    var _incrementalPlacehold;
                    var prevActorIdentifier = _this0._actorIdentifier;
                    _this0._actorIdentifier = (_incrementalPlacehold = incrementalPlaceholder.actorIdentifier) !== null && _incrementalPlacehold !== void 0 ? _incrementalPlacehold : _this0._actorIdentifier;
                    _this0._processIncrementalPlaceholder(payload, incrementalPlaceholder);
                    _this0._actorIdentifier = prevActorIdentifier;
                });
                if (_this0._isClientPayload || _this0._state === 'loading_final') {
                    var relayPayloads = [];
                    incrementalPlaceholders.forEach(function(placeholder) {
                        if (placeholder.kind === 'defer') relayPayloads.push(_this0._processDeferResponse(placeholder.label, placeholder.path, placeholder, {
                            data: placeholder.data,
                            extensions: {
                                is_final: true
                            }
                        }));
                    });
                    if (relayPayloads.length > 0) _this0._processPayloadFollowups(relayPayloads);
                }
            }
        });
    };
    _proto._maybeCompleteSubscriptionOperationTracking = function _maybeCompleteSubscriptionOperationTracking() {
        if (!this._isSubscriptionOperation && !(this._useExecTimeResolvers && this._execTimeResolverResponseComplete && this._state === 'loading_final')) return;
        if (this._pendingModulePayloadsCount === 0 && this._incrementalPayloadsPending === false) this._completeOperationTracker();
    };
    _proto._processFollowupPayload = function _processFollowupPayload(followupPayload) {
        var _this1 = this;
        switch(followupPayload.kind){
            case 'ModuleImportPayload':
                var operationLoader = this._expectOperationLoader();
                var node = operationLoader.get(followupPayload.operationReference);
                if (node != null) this._processFollowupPayloadWithNormalizationNode(followupPayload, $gJkyh(node));
                else {
                    var id = this._nextSubscriptionId++;
                    this._pendingModulePayloadsCount++;
                    var decrementPendingCount = function decrementPendingCount() {
                        _this1._pendingModulePayloadsCount--;
                        _this1._maybeCompleteSubscriptionOperationTracking();
                    };
                    var networkObservable = $5bMXV.from(new Promise(function(resolve, reject) {
                        operationLoader.load(followupPayload.operationReference).then(resolve, reject);
                    }));
                    $5bMXV.create(function(sink) {
                        var cancellationToken;
                        var subscription = networkObservable.subscribe({
                            error: sink.error,
                            next: function next(loadedNode) {
                                if (loadedNode != null) {
                                    var publishModuleImportPayload = function publishModuleImportPayload() {
                                        try {
                                            var operation = $gJkyh(loadedNode);
                                            var batchAsyncModuleUpdatesFN = $gZYpt.BATCH_ASYNC_MODULE_UPDATES_FN;
                                            var shouldScheduleAsyncStoreUpdate = batchAsyncModuleUpdatesFN != null && _this1._pendingModulePayloadsCount > 1;
                                            var _withStartAndDuration = $9pi7j(function() {
                                                _this1._handleFollowupPayload(followupPayload, operation);
                                                if (shouldScheduleAsyncStoreUpdate) _this1._scheduleAsyncStoreUpdate(batchAsyncModuleUpdatesFN, sink.complete);
                                                else {
                                                    var updatedOwners = _this1._runPublishQueue();
                                                    _this1._updateOperationTracker(updatedOwners);
                                                }
                                            }), _ = _withStartAndDuration[0], duration = _withStartAndDuration[1];
                                            _this1._log({
                                                duration: duration,
                                                executeId: _this1._executeId,
                                                name: 'execute.async.module',
                                                operationName: operation.name
                                            });
                                            if (!shouldScheduleAsyncStoreUpdate) sink.complete();
                                        } catch (error) {
                                            sink.error(error);
                                        }
                                    };
                                    var scheduler = _this1._scheduler;
                                    if (scheduler == null) publishModuleImportPayload();
                                    else cancellationToken = scheduler.schedule(publishModuleImportPayload);
                                } else sink.complete();
                            }
                        });
                        return function() {
                            subscription.unsubscribe();
                            if (_this1._scheduler != null && cancellationToken != null) _this1._scheduler.cancel(cancellationToken);
                        };
                    }).subscribe({
                        complete: function complete() {
                            _this1._complete(id);
                            decrementPendingCount();
                        },
                        error: function error(_error4) {
                            _this1._error(_error4);
                            decrementPendingCount();
                        },
                        start: function start(subscription) {
                            return _this1._start(id, subscription);
                        }
                    });
                }
                break;
            case 'ActorPayload':
                this._processFollowupPayloadWithNormalizationNode(followupPayload, followupPayload.node);
                break;
            default:
                followupPayload;
                $jSI6G(false);
        }
    };
    _proto._processFollowupPayloadWithNormalizationNode = function _processFollowupPayloadWithNormalizationNode(followupPayload, normalizationNode) {
        this._handleFollowupPayload(followupPayload, normalizationNode);
        this._maybeCompleteSubscriptionOperationTracking();
    };
    _proto._handleFollowupPayload = function _handleFollowupPayload(followupPayload, normalizationNode) {
        var relayPayload = this._normalizeFollowupPayload(followupPayload, normalizationNode);
        this._getPublishQueueAndSaveActor().commitPayload(this._operation, relayPayload);
        this._processPayloadFollowups([
            relayPayload
        ]);
    };
    _proto._processIncrementalPlaceholder = function _processIncrementalPlaceholder(relayPayload, placeholder) {
        var _relayPayload$fieldPa;
        var label = placeholder.label, path = placeholder.path;
        var pathKey = path.map(String).join('.');
        var resultForLabel = this._incrementalResults.get(label);
        if (resultForLabel == null) {
            resultForLabel = new Map();
            this._incrementalResults.set(label, resultForLabel);
        }
        var resultForPath = resultForLabel.get(pathKey);
        var pendingResponses = resultForPath != null && resultForPath.kind === 'response' ? resultForPath.responses : null;
        resultForLabel.set(pathKey, {
            kind: 'placeholder',
            placeholder: placeholder
        });
        var parentID;
        if (placeholder.kind === 'stream') parentID = placeholder.parentID;
        else if (placeholder.kind === 'defer') parentID = placeholder.selector.dataID;
        else {
            placeholder;
            $jSI6G(false);
        }
        var parentRecord = relayPayload.source.get(parentID);
        var parentPayloads = ((_relayPayload$fieldPa = relayPayload.fieldPayloads) !== null && _relayPayload$fieldPa !== void 0 ? _relayPayload$fieldPa : []).filter(function(fieldPayload) {
            var fieldID = $c245da0dab2b3bef$var$generateClientID(fieldPayload.dataID, fieldPayload.fieldKey);
            return fieldPayload.dataID === parentID || fieldID === parentID;
        });
        !(parentRecord != null) && $jSI6G(false);
        var nextParentRecord;
        var nextParentPayloads;
        var previousParentEntry = this._source.get(parentID);
        if (previousParentEntry != null) {
            nextParentRecord = $7SC8Z.update(previousParentEntry.record, parentRecord);
            var handlePayloads = new Map();
            var dedupePayload = function dedupePayload(payload) {
                var key = $c245da0dab2b3bef$var$stableStringify(payload);
                handlePayloads.set(key, payload);
            };
            previousParentEntry.fieldPayloads.forEach(dedupePayload);
            parentPayloads.forEach(dedupePayload);
            nextParentPayloads = Array.from(handlePayloads.values());
        } else {
            nextParentRecord = parentRecord;
            nextParentPayloads = parentPayloads;
        }
        this._source.set(parentID, {
            fieldPayloads: nextParentPayloads,
            record: nextParentRecord
        });
        if (pendingResponses != null) {
            var payloadFollowups = this._processIncrementalResponses(pendingResponses);
            this._processPayloadFollowups(payloadFollowups);
        }
    };
    _proto._processIncrementalResponses = function _processIncrementalResponses(incrementalResponses) {
        var _this10 = this;
        var relayPayloads = [];
        incrementalResponses.forEach(function(incrementalResponse) {
            var label = incrementalResponse.label, path = incrementalResponse.path, response = incrementalResponse.response;
            var resultForLabel = _this10._incrementalResults.get(label);
            if (resultForLabel == null) {
                resultForLabel = new Map();
                _this10._incrementalResults.set(label, resultForLabel);
            }
            if (label.indexOf('$defer$') !== -1) {
                var pathKey = path.map(String).join('.');
                var resultForPath = resultForLabel.get(pathKey);
                if (resultForPath == null) {
                    resultForPath = {
                        kind: 'response',
                        responses: [
                            incrementalResponse
                        ]
                    };
                    resultForLabel.set(pathKey, resultForPath);
                    return;
                } else if (resultForPath.kind === 'response') {
                    resultForPath.responses.push(incrementalResponse);
                    return;
                }
                var placeholder = resultForPath.placeholder;
                !(placeholder.kind === 'defer') && $jSI6G(false);
                relayPayloads.push(_this10._processDeferResponse(label, path, placeholder, response));
            } else {
                var _pathKey = path.slice(0, -2).map(String).join('.');
                var _resultForPath = resultForLabel.get(_pathKey);
                if (_resultForPath == null) {
                    _resultForPath = {
                        kind: 'response',
                        responses: [
                            incrementalResponse
                        ]
                    };
                    resultForLabel.set(_pathKey, _resultForPath);
                    return;
                } else if (_resultForPath.kind === 'response') {
                    _resultForPath.responses.push(incrementalResponse);
                    return;
                }
                var _placeholder = _resultForPath.placeholder;
                !(_placeholder.kind === 'stream') && $jSI6G(false);
                relayPayloads.push(_this10._processStreamResponse(label, path, _placeholder, response));
            }
        });
        return relayPayloads;
    };
    _proto._processDeferResponse = function _processDeferResponse(label, path, placeholder, response) {
        var _placeholder$actorIde;
        var parentID = placeholder.selector.dataID;
        var prevActorIdentifier = this._actorIdentifier;
        this._actorIdentifier = (_placeholder$actorIde = placeholder.actorIdentifier) !== null && _placeholder$actorIde !== void 0 ? _placeholder$actorIde : this._actorIdentifier;
        var relayPayload = this._normalizeResponse(response, placeholder.selector, placeholder.typeName, {
            actorIdentifier: this._actorIdentifier,
            deferDeduplicatedFields: this._deferDeduplicatedFields,
            getDataID: this._getDataID,
            log: this._log,
            path: placeholder.path,
            shouldProcessClientComponents: this._shouldProcessClientComponents,
            treatMissingFieldsAsNull: this._treatMissingFieldsAsNull
        }, this._useExecTimeResolvers);
        this._getPublishQueueAndSaveActor().commitPayload(this._operation, relayPayload);
        var parentEntry = this._source.get(parentID);
        !(parentEntry != null) && $jSI6G(false);
        var fieldPayloads = parentEntry.fieldPayloads;
        if (fieldPayloads.length !== 0) {
            var _response$extensions4;
            var handleFieldsRelayPayload = {
                errors: null,
                fieldPayloads: fieldPayloads,
                followupPayloads: null,
                incrementalPlaceholders: null,
                isFinal: ((_response$extensions4 = response.extensions) === null || _response$extensions4 === void 0 ? void 0 : _response$extensions4.is_final) === true,
                source: $3fbkc.create()
            };
            this._getPublishQueueAndSaveActor().commitPayload(this._operation, handleFieldsRelayPayload);
        }
        this._actorIdentifier = prevActorIdentifier;
        return relayPayload;
    };
    _proto._processStreamResponse = function _processStreamResponse(label, path, placeholder, response) {
        var parentID = placeholder.parentID, node = placeholder.node, variables = placeholder.variables, actorIdentifier = placeholder.actorIdentifier;
        var prevActorIdentifier = this._actorIdentifier;
        this._actorIdentifier = actorIdentifier !== null && actorIdentifier !== void 0 ? actorIdentifier : this._actorIdentifier;
        var field = node.selections[0];
        !(field != null && field.kind === 'LinkedField' && field.plural === true) && $jSI6G(false);
        var _this$_normalizeStrea = this._normalizeStreamItem(response, parentID, field, variables, path, placeholder.path), fieldPayloads = _this$_normalizeStrea.fieldPayloads, itemID = _this$_normalizeStrea.itemID, itemIndex = _this$_normalizeStrea.itemIndex, prevIDs = _this$_normalizeStrea.prevIDs, relayPayload = _this$_normalizeStrea.relayPayload, storageKey = _this$_normalizeStrea.storageKey;
        this._getPublishQueueAndSaveActor().commitPayload(this._operation, relayPayload, function(store) {
            var currentParentRecord = store.get(parentID);
            if (currentParentRecord == null) return;
            var currentItems = currentParentRecord.getLinkedRecords(storageKey);
            if (currentItems == null) return;
            if (currentItems.length !== prevIDs.length || currentItems.some(function(currentItem, index) {
                return prevIDs[index] !== (currentItem && currentItem.getDataID());
            })) return;
            var nextItems = (0, $c245da0dab2b3bef$var$_toConsumableArray2["default"])(currentItems);
            nextItems[itemIndex] = store.get(itemID);
            currentParentRecord.setLinkedRecords(nextItems, storageKey);
        });
        if (fieldPayloads.length !== 0) {
            var handleFieldsRelayPayload = {
                errors: null,
                fieldPayloads: fieldPayloads,
                followupPayloads: null,
                incrementalPlaceholders: null,
                isFinal: false,
                source: $3fbkc.create()
            };
            this._getPublishQueueAndSaveActor().commitPayload(this._operation, handleFieldsRelayPayload);
        }
        this._actorIdentifier = prevActorIdentifier;
        return relayPayload;
    };
    _proto._normalizeStreamItem = function _normalizeStreamItem(response, parentID, field, variables, path, normalizationPath) {
        var _field$alias, _field$concreteType, _ref2, _this$_getDataID;
        var data = response.data;
        !(typeof data === 'object') && $jSI6G(false);
        var responseKey = (_field$alias = field.alias) !== null && _field$alias !== void 0 ? _field$alias : field.name;
        var storageKey = $c245da0dab2b3bef$var$getStorageKey(field, variables);
        var parentEntry = this._source.get(parentID);
        !(parentEntry != null) && $jSI6G(false);
        var parentRecord = parentEntry.record, fieldPayloads = parentEntry.fieldPayloads;
        var prevIDs = $7SC8Z.getLinkedRecordIDs(parentRecord, storageKey);
        !(prevIDs != null) && $jSI6G(false);
        var finalPathEntry = path[path.length - 1];
        var itemIndex = parseInt(finalPathEntry, 10);
        !(itemIndex === finalPathEntry && itemIndex >= 0) && $jSI6G(false);
        var typeName = (_field$concreteType = field.concreteType) !== null && _field$concreteType !== void 0 ? _field$concreteType : data[$c245da0dab2b3bef$var$TYPENAME_KEY];
        !(typeof typeName === 'string') && $jSI6G(false);
        var itemID = (_ref2 = (_this$_getDataID = this._getDataID(data, typeName)) !== null && _this$_getDataID !== void 0 ? _this$_getDataID : prevIDs === null || prevIDs === void 0 ? void 0 : prevIDs[itemIndex]) !== null && _ref2 !== void 0 ? _ref2 : $c245da0dab2b3bef$var$generateClientID(parentID, storageKey, itemIndex);
        !(typeof itemID === 'string') && $jSI6G(false);
        var selector = $c245da0dab2b3bef$var$createNormalizationSelector(field, itemID, variables);
        var nextParentRecord = $7SC8Z.clone(parentRecord);
        var nextIDs = (0, $c245da0dab2b3bef$var$_toConsumableArray2["default"])(prevIDs);
        nextIDs[itemIndex] = itemID;
        $7SC8Z.setLinkedRecordIDs(nextParentRecord, storageKey, nextIDs);
        this._source.set(parentID, {
            fieldPayloads: fieldPayloads,
            record: nextParentRecord
        });
        var relayPayload = this._normalizeResponse(response, selector, typeName, {
            actorIdentifier: this._actorIdentifier,
            deferDeduplicatedFields: false,
            getDataID: this._getDataID,
            log: this._log,
            path: [].concat((0, $c245da0dab2b3bef$var$_toConsumableArray2["default"])(normalizationPath), [
                responseKey,
                String(itemIndex)
            ]),
            shouldProcessClientComponents: this._shouldProcessClientComponents,
            treatMissingFieldsAsNull: this._treatMissingFieldsAsNull
        }, this._useExecTimeResolvers);
        return {
            fieldPayloads: fieldPayloads,
            itemID: itemID,
            itemIndex: itemIndex,
            prevIDs: prevIDs,
            relayPayload: relayPayload,
            storageKey: storageKey
        };
    };
    _proto._scheduleAsyncStoreUpdate = function _scheduleAsyncStoreUpdate(scheduleFn, completeFn) {
        var _this11 = this;
        this._completeFns.push(completeFn);
        if (this._asyncStoreUpdateDisposable != null) return;
        this._asyncStoreUpdateDisposable = scheduleFn(function() {
            _this11._asyncStoreUpdateDisposable = null;
            var updatedOwners = _this11._runPublishQueue();
            _this11._updateOperationTracker(updatedOwners);
            var _iterator2 = (0, $c245da0dab2b3bef$var$_createForOfIteratorHelper2["default"])(_this11._completeFns), _step2;
            try {
                for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                    var complete = _step2.value;
                    complete();
                }
            } catch (err) {
                _iterator2.e(err);
            } finally{
                _iterator2.f();
            }
            _this11._completeFns = [];
        });
    };
    _proto._updateOperationTracker = function _updateOperationTracker(updatedOwners) {
        if (updatedOwners != null && updatedOwners.length > 0) this._operationTracker.update(this._operation.request, new Set(updatedOwners));
    };
    _proto._completeOperationTracker = function _completeOperationTracker() {
        this._operationTracker.complete(this._operation.request);
    };
    _proto._getPublishQueueAndSaveActor = function _getPublishQueueAndSaveActor() {
        this._seenActors.add(this._actorIdentifier);
        return this._getPublishQueue(this._actorIdentifier);
    };
    _proto._getActorsToVisit = function _getActorsToVisit() {
        if (this._seenActors.size === 0) return new Set([
            this._actorIdentifier
        ]);
        else return this._seenActors;
    };
    _proto._runPublishQueue = function _runPublishQueue(operation) {
        var updatedOwners = new Set();
        var _iterator3 = (0, $c245da0dab2b3bef$var$_createForOfIteratorHelper2["default"])(this._getActorsToVisit()), _step3;
        try {
            for(_iterator3.s(); !(_step3 = _iterator3.n()).done;){
                var actorIdentifier = _step3.value;
                var owners = this._getPublishQueue(actorIdentifier).run(operation);
                owners.forEach(function(owner) {
                    return updatedOwners.add(owner);
                });
            }
        } catch (err) {
            _iterator3.e(err);
        } finally{
            _iterator3.f();
        }
        return Array.from(updatedOwners);
    };
    _proto._retainData = function _retainData() {
        var _iterator4 = (0, $c245da0dab2b3bef$var$_createForOfIteratorHelper2["default"])(this._getActorsToVisit()), _step4;
        try {
            for(_iterator4.s(); !(_step4 = _iterator4.n()).done;){
                var actorIdentifier = _step4.value;
                if (!this._retainDisposables.has(actorIdentifier)) this._retainDisposables.set(actorIdentifier, this._getStore(actorIdentifier).retain(this._operation));
            }
        } catch (err) {
            _iterator4.e(err);
        } finally{
            _iterator4.f();
        }
    };
    _proto._disposeRetainedData = function _disposeRetainedData() {
        var _iterator5 = (0, $c245da0dab2b3bef$var$_createForOfIteratorHelper2["default"])(this._retainDisposables.values()), _step5;
        try {
            for(_iterator5.s(); !(_step5 = _iterator5.n()).done;){
                var disposable = _step5.value;
                disposable.dispose();
            }
        } catch (err) {
            _iterator5.e(err);
        } finally{
            _iterator5.f();
        }
        this._retainDisposables.clear();
    };
    _proto._expectOperationLoader = function _expectOperationLoader() {
        var operationLoader = this._operationLoader;
        !operationLoader && $jSI6G(false);
        return operationLoader;
    };
    return Executor;
}();
function $c245da0dab2b3bef$var$partitionGraphQLResponses(responses) {
    var nonIncrementalResponses = [];
    var incrementalResponses = [];
    var normalizedResponses = [];
    responses.forEach(function(response) {
        var _response$extensions5;
        if (response.path != null || response.label != null) {
            var label = response.label, path = response.path;
            if (label == null || path == null) $jSI6G(false);
            incrementalResponses.push({
                label: label,
                path: path,
                response: response
            });
        } else if (((_response$extensions5 = response.extensions) === null || _response$extensions5 === void 0 ? void 0 : _response$extensions5.is_normalized) === true) normalizedResponses.push(response);
        else nonIncrementalResponses.push(response);
    });
    return [
        nonIncrementalResponses,
        incrementalResponses,
        normalizedResponses
    ];
}
function $c245da0dab2b3bef$var$stableStringify(value) {
    var _JSON$stringify;
    return (_JSON$stringify = JSON.stringify($c245da0dab2b3bef$var$stableCopy(value))) !== null && _JSON$stringify !== void 0 ? _JSON$stringify : '';
}
function $c245da0dab2b3bef$var$validateOptimisticResponsePayload(payload) {
    var incrementalPlaceholders = payload.incrementalPlaceholders;
    if (incrementalPlaceholders != null && incrementalPlaceholders.length !== 0) $jSI6G(false);
}
module.exports = {
    execute: $c245da0dab2b3bef$var$execute
};

});
parcelRegister("gJkyh", function(module, exports) {
'use strict';

var $fT3Ou = parcelRequire("fT3Ou");
var $c2e0ca82576c8dd7$var$REQUEST = $fT3Ou.REQUEST, $c2e0ca82576c8dd7$var$SPLIT_OPERATION = $fT3Ou.SPLIT_OPERATION;
function $c2e0ca82576c8dd7$var$getOperation(node) {
    switch(node.kind){
        case $c2e0ca82576c8dd7$var$REQUEST:
            return node.operation;
        case $c2e0ca82576c8dd7$var$SPLIT_OPERATION:
        default:
            return node;
    }
}
module.exports = $c2e0ca82576c8dd7$var$getOperation;

});

parcelRegister("lFwfm", function(module, exports) {
'use strict';
function $fc6670d32b01cdbc$var$createError(type, name, messageFormat) {
    var _messageParams$;
    for(var _len = arguments.length, messageParams = new Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++)messageParams[_key - 3] = arguments[_key];
    var index = 0;
    var message = messageFormat.replace(/%s/g, function() {
        return String(messageParams[index++]);
    });
    var err = new Error(message);
    var operation = (_messageParams$ = messageParams[2]) !== null && _messageParams$ !== void 0 ? _messageParams$ : null;
    var error = Object.assign(err, {
        name: name,
        messageFormat: messageFormat,
        messageParams: messageParams,
        type: type,
        operation: operation,
        taalOpcodes: [
            2,
            2
        ]
    });
    if (error.stack === undefined) try {
        throw error;
    } catch (_unused) {}
    return error;
}
module.exports = {
    create: function create(name, messageFormat) {
        for(var _len2 = arguments.length, messageParams = new Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++)messageParams[_key2 - 2] = arguments[_key2];
        return $fc6670d32b01cdbc$var$createError.apply(void 0, [
            'error',
            name,
            messageFormat
        ].concat(messageParams));
    },
    createWarning: function createWarning(name, messageFormat) {
        for(var _len3 = arguments.length, messageParams = new Array(_len3 > 2 ? _len3 - 2 : 0), _key3 = 2; _key3 < _len3; _key3++)messageParams[_key3 - 2] = arguments[_key3];
        return $fc6670d32b01cdbc$var$createError.apply(void 0, [
            'warn',
            name,
            messageFormat
        ].concat(messageParams));
    }
};

});

parcelRegister("9pi7j", function(module, exports) {
'use strict';
var $6d94807a645c4bca$var$_window, $6d94807a645c4bca$var$_window$performance;
var $6d94807a645c4bca$var$isPerformanceNowAvailable = typeof window !== 'undefined' && typeof (($6d94807a645c4bca$var$_window = window) === null || $6d94807a645c4bca$var$_window === void 0 ? void 0 : ($6d94807a645c4bca$var$_window$performance = $6d94807a645c4bca$var$_window.performance) === null || $6d94807a645c4bca$var$_window$performance === void 0 ? void 0 : $6d94807a645c4bca$var$_window$performance.now) === 'function';
function $6d94807a645c4bca$var$currentTimestamp() {
    if ($6d94807a645c4bca$var$isPerformanceNowAvailable) return window.performance.now();
    return Date.now();
}
function $6d94807a645c4bca$var$withStartAndDuration(cb) {
    var startTime = $6d94807a645c4bca$var$currentTimestamp();
    var result = cb();
    return [
        startTime,
        $6d94807a645c4bca$var$currentTimestamp() - startTime,
        result
    ];
}
module.exports = $6d94807a645c4bca$var$withStartAndDuration;

});


parcelRegister("1mBet", function(module, exports) {
'use strict';

var $e27SU = parcelRequire("e27SU");
var $0fe4ba2052f6b3ce$var$_interopRequireDefault = $e27SU.default;

var $0fe4ba2052f6b3ce$var$_createForOfIteratorHelper2 = $0fe4ba2052f6b3ce$var$_interopRequireDefault((parcelRequire("5dSyV")));

var $0fe4ba2052f6b3ce$var$_defineProperty2 = $0fe4ba2052f6b3ce$var$_interopRequireDefault((parcelRequire("2JBpp")));

var $kc5hH = parcelRequire("kc5hH");
var $0fe4ba2052f6b3ce$var$INTERNAL_ACTOR_IDENTIFIER_DO_NOT_USE = $kc5hH.INTERNAL_ACTOR_IDENTIFIER_DO_NOT_USE, $0fe4ba2052f6b3ce$var$assertInternalActorIdentifier = $kc5hH.assertInternalActorIdentifier;
parcelRequire("6GnlG");

var $gZYpt = parcelRequire("gZYpt");

var $9r1R7 = parcelRequire("9r1R7");

var $drk9z = parcelRequire("drk9z");

var $9pOE6 = parcelRequire("9pOE6");

var $izibt = parcelRequire("izibt");
var $0fe4ba2052f6b3ce$var$LiveResolverCache = $izibt.LiveResolverCache, $0fe4ba2052f6b3ce$var$RELAY_RESOLVER_LIVE_STATE_SUBSCRIPTION_KEY = $izibt.RELAY_RESOLVER_LIVE_STATE_SUBSCRIPTION_KEY, $0fe4ba2052f6b3ce$var$getUpdatedDataIDs = $izibt.getUpdatedDataIDs;

var $7SC8Z = parcelRequire("7SC8Z");

var $5QfIo = parcelRequire("5QfIo");

var $4SqFT = parcelRequire("4SqFT");

var $56FwA = parcelRequire("56FwA");

var $jaTqj = parcelRequire("jaTqj");

var $ezyIu = parcelRequire("ezyIu");

var $ezyIu = parcelRequire("ezyIu");
var $0fe4ba2052f6b3ce$var$FIELD_GRANULAR_NOTIFICATIONS_KEY = $ezyIu.FIELD_GRANULAR_NOTIFICATIONS_KEY, $0fe4ba2052f6b3ce$var$ROOT_ID = $ezyIu.ROOT_ID, $0fe4ba2052f6b3ce$var$ROOT_TYPE = $ezyIu.ROOT_TYPE, $0fe4ba2052f6b3ce$var$getFieldNotificationKey = $ezyIu.getFieldNotificationKey;

var $jSI6G = parcelRequire("jSI6G");
var $0fe4ba2052f6b3ce$var$DEFAULT_RELEASE_BUFFER_SIZE = 10;
var $0fe4ba2052f6b3ce$var$RelayModernStore = /*#__PURE__*/ function() {
    function RelayModernStore(source, options) {
        var _this = this;
        var _options$gcReleaseBuf, _options$shouldRetain, _options$gcScheduler, _options$getDataID, _options$log, _options$operationLoa, _options$shouldProces, _options$treatMissing, _options$deferDedupli;
        (0, $0fe4ba2052f6b3ce$var$_defineProperty2["default"])(this, "_gcStep", function() {
            if (_this._gcRun) {
                if (_this._gcRun.next().done) _this._gcRun = null;
                else _this._gcScheduler(_this._gcStep);
            }
        });
        var storeIDs, ii, record;
        this._currentWriteEpoch = 0;
        this._gcHoldCounter = 0;
        this._gcReleaseBufferSize = (_options$gcReleaseBuf = options === null || options === void 0 ? void 0 : options.gcReleaseBufferSize) !== null && _options$gcReleaseBuf !== void 0 ? _options$gcReleaseBuf : $0fe4ba2052f6b3ce$var$DEFAULT_RELEASE_BUFFER_SIZE;
        this._shouldRetainWithinTTL_EXPERIMENTAL = (_options$shouldRetain = options === null || options === void 0 ? void 0 : options.shouldRetainWithinTTL_EXPERIMENTAL) !== null && _options$shouldRetain !== void 0 ? _options$shouldRetain : false;
        this._gcRun = null;
        this._gcScheduler = (_options$gcScheduler = options === null || options === void 0 ? void 0 : options.gcScheduler) !== null && _options$gcScheduler !== void 0 ? _options$gcScheduler : $9r1R7;
        this._getDataID = (_options$getDataID = options === null || options === void 0 ? void 0 : options.getDataID) !== null && _options$getDataID !== void 0 ? _options$getDataID : $9pOE6;
        this._globalInvalidationEpoch = null;
        this._invalidationSubscriptions = new Set();
        this._invalidatedRecordIDs = new Set();
        this.__log = (_options$log = options === null || options === void 0 ? void 0 : options.log) !== null && _options$log !== void 0 ? _options$log : null;
        this._queryCacheExpirationTime = options === null || options === void 0 ? void 0 : options.queryCacheExpirationTime;
        this._operationLoader = (_options$operationLoa = options === null || options === void 0 ? void 0 : options.operationLoader) !== null && _options$operationLoa !== void 0 ? _options$operationLoa : null;
        this._optimisticSource = null;
        this._recordSource = source;
        this._releaseBuffer = [];
        this._roots = new Map();
        this._shouldScheduleGC = false;
        this._resolverCache = new $0fe4ba2052f6b3ce$var$LiveResolverCache(function() {
            return _this._getMutableRecordSource();
        }, this);
        this._resolverContext = options === null || options === void 0 ? void 0 : options.resolverContext;
        this._storeSubscriptions = new $jaTqj(options === null || options === void 0 ? void 0 : options.log, this._resolverCache, this._resolverContext);
        this._updatedRecordIDs = new Set();
        this._shouldProcessClientComponents = (_options$shouldProces = options === null || options === void 0 ? void 0 : options.shouldProcessClientComponents) !== null && _options$shouldProces !== void 0 ? _options$shouldProces : false;
        this._treatMissingFieldsAsNull = (_options$treatMissing = options === null || options === void 0 ? void 0 : options.treatMissingFieldsAsNull) !== null && _options$treatMissing !== void 0 ? _options$treatMissing : false;
        this._deferDeduplicatedFields = (_options$deferDedupli = options === null || options === void 0 ? void 0 : options.deferDeduplicatedFields) !== null && _options$deferDedupli !== void 0 ? _options$deferDedupli : false;
        this._actorIdentifier = options === null || options === void 0 ? void 0 : options.actorIdentifier;
        this._batch = null;
        $0fe4ba2052f6b3ce$var$initializeRecordSource(this._recordSource);
    }
    var _proto = RelayModernStore.prototype;
    _proto.getSource = function getSource() {
        var _this$_optimisticSour;
        return (_this$_optimisticSour = this._optimisticSource) !== null && _this$_optimisticSour !== void 0 ? _this$_optimisticSour : this._recordSource;
    };
    _proto.getOperationLoader = function getOperationLoader() {
        return this._operationLoader;
    };
    _proto._getMutableRecordSource = function _getMutableRecordSource() {
        var _this$_optimisticSour2;
        return (_this$_optimisticSour2 = this._optimisticSource) !== null && _this$_optimisticSour2 !== void 0 ? _this$_optimisticSour2 : this._recordSource;
    };
    _proto.getLiveResolverPromise = function getLiveResolverPromise(recordID) {
        return this._resolverCache.getLiveResolverPromise(recordID);
    };
    _proto.batchLiveStateUpdates = function batchLiveStateUpdates(callback) {
        if (this.__log != null) this.__log({
            name: 'liveresolver.batch.start'
        });
        try {
            this._resolverCache.batchLiveStateUpdates(callback);
        } finally{
            if (this.__log != null) this.__log({
                name: 'liveresolver.batch.end'
            });
        }
    };
    _proto.experimental_batchUpdates = function experimental_batchUpdates(callback) {
        if (this._batch != null) throw new Error('RelayModernStore: Cannot batch updates while already batching updates.');
        var log = this.__log;
        if (log != null) log({
            name: 'store.batch.start'
        });
        var batch = {
            sourceOperations: [],
            invalidateStore: false
        };
        this._batch = batch;
        try {
            callback();
        } finally{
            this._batch = null;
            this.notify(undefined, batch.invalidateStore);
            var _iterator = (0, $0fe4ba2052f6b3ce$var$_createForOfIteratorHelper2["default"])(batch.sourceOperations), _step;
            try {
                for(_iterator.s(); !(_step = _iterator.n()).done;){
                    var sourceOperation = _step.value;
                    this._recordSourceOperation(sourceOperation);
                }
            } catch (err) {
                _iterator.e(err);
            } finally{
                _iterator.f();
            }
            if (log != null) log({
                name: 'store.batch.complete',
                sourceOperations: batch.sourceOperations,
                invalidateStore: batch.invalidateStore
            });
        }
    };
    _proto.batchLiveStateUpdatesWithoutNotify = function batchLiveStateUpdatesWithoutNotify(callback) {
        if (this.__log != null) this.__log({
            name: 'liveresolver.batch.start'
        });
        var hasPublished = false;
        try {
            hasPublished = this._resolverCache.batchLiveStateUpdatesWithoutNotify(callback);
        } finally{
            if (this.__log != null) this.__log({
                name: 'liveresolver.batch.end'
            });
        }
        return hasPublished;
    };
    _proto.check = function check(operation, options) {
        var _ref, _operation$request$no, _operation$request$no2, _options$handlers, _options$getSourceFor, _options$getTargetFor, _options$defaultActor;
        var selector = operation.root;
        var source = this._getMutableRecordSource();
        var globalInvalidationEpoch = this._globalInvalidationEpoch;
        var useExecTimeResolvers = (_ref = (_operation$request$no = operation.request.node.operation.use_exec_time_resolvers) !== null && _operation$request$no !== void 0 ? _operation$request$no : ((_operation$request$no2 = operation.request.node.operation.exec_time_resolvers_enabled_provider) === null || _operation$request$no2 === void 0 ? void 0 : _operation$request$no2.get()) === true) !== null && _ref !== void 0 ? _ref : false;
        var rootEntry = this._roots.get(operation.request.identifier);
        var operationLastWrittenAt = rootEntry != null ? rootEntry.epoch : null;
        if (globalInvalidationEpoch != null) {
            if (operationLastWrittenAt == null || operationLastWrittenAt <= globalInvalidationEpoch) return {
                status: 'stale'
            };
        }
        var handlers = (_options$handlers = options === null || options === void 0 ? void 0 : options.handlers) !== null && _options$handlers !== void 0 ? _options$handlers : [];
        var getSourceForActor = (_options$getSourceFor = options === null || options === void 0 ? void 0 : options.getSourceForActor) !== null && _options$getSourceFor !== void 0 ? _options$getSourceFor : function(actorIdentifier) {
            $0fe4ba2052f6b3ce$var$assertInternalActorIdentifier(actorIdentifier);
            return source;
        };
        var getTargetForActor = (_options$getTargetFor = options === null || options === void 0 ? void 0 : options.getTargetForActor) !== null && _options$getTargetFor !== void 0 ? _options$getTargetFor : function(actorIdentifier) {
            $0fe4ba2052f6b3ce$var$assertInternalActorIdentifier(actorIdentifier);
            return source;
        };
        var operationAvailability = $drk9z.check(getSourceForActor, getTargetForActor, (_options$defaultActor = options === null || options === void 0 ? void 0 : options.defaultActorIdentifier) !== null && _options$defaultActor !== void 0 ? _options$defaultActor : $0fe4ba2052f6b3ce$var$INTERNAL_ACTOR_IDENTIFIER_DO_NOT_USE, selector, handlers, this._operationLoader, this._getDataID, this._shouldProcessClientComponents, this.__log, useExecTimeResolvers);
        return $0fe4ba2052f6b3ce$var$getAvailabilityStatus(operationAvailability, operationLastWrittenAt, rootEntry === null || rootEntry === void 0 ? void 0 : rootEntry.fetchTime, this._queryCacheExpirationTime);
    };
    _proto.retain = function retain(operation) {
        var _this2 = this;
        var id = operation.request.identifier;
        var disposed = false;
        var dispose = function dispose() {
            if (disposed) return;
            disposed = true;
            var rootEntry = _this2._roots.get(id);
            if (rootEntry == null) return;
            rootEntry.refCount--;
            if (rootEntry.refCount === 0) {
                var _queryCacheExpirationTime = _this2._queryCacheExpirationTime;
                var rootEntryIsStale = rootEntry.fetchTime != null && _queryCacheExpirationTime != null && rootEntry.fetchTime <= Date.now() - _queryCacheExpirationTime;
                if (rootEntryIsStale) {
                    if (!_this2._shouldRetainWithinTTL_EXPERIMENTAL) _this2._roots["delete"](id);
                    _this2.scheduleGC();
                } else {
                    _this2._releaseBuffer.push(id);
                    if (_this2._releaseBuffer.length > _this2._gcReleaseBufferSize) {
                        var _id = _this2._releaseBuffer.shift();
                        if (!_this2._shouldRetainWithinTTL_EXPERIMENTAL) _this2._roots["delete"](_id);
                        _this2.scheduleGC();
                    }
                }
            }
        };
        var rootEntry = this._roots.get(id);
        if (rootEntry != null) {
            if (rootEntry.refCount === 0) this._releaseBuffer = this._releaseBuffer.filter(function(_id) {
                return _id !== id;
            });
            rootEntry.refCount += 1;
        } else this._roots.set(id, {
            operation: operation,
            refCount: 1,
            epoch: null,
            fetchTime: null
        });
        return {
            dispose: dispose
        };
    };
    _proto.lookup = function lookup(selector) {
        var log = this.__log;
        if (log != null) log({
            name: 'store.lookup.start',
            selector: selector
        });
        var source = this.getSource();
        var snapshot = $4SqFT.read(source, selector, log, this._resolverCache, this._resolverContext);
        if (log != null) log({
            name: 'store.lookup.end',
            selector: selector
        });
        return snapshot;
    };
    _proto.notify = function notify(sourceOperation, invalidateStore) {
        var _this3 = this;
        var batch = this._batch;
        if (batch != null) {
            if (sourceOperation != null) batch.sourceOperations.push(sourceOperation);
            if (invalidateStore === true) batch.invalidateStore = true;
            return [];
        }
        var log = this.__log;
        if (log != null) log({
            name: 'store.notify.start',
            sourceOperation: sourceOperation
        });
        if (!$gZYpt.OPTIMIZE_NOTIFY) {
            this._currentWriteEpoch++;
            if (invalidateStore === true) this._globalInvalidationEpoch = this._currentWriteEpoch;
        }
        if (!$gZYpt.OPTIMIZE_NOTIFY || this._updatedRecordIDs.size > 0) this._resolverCache.invalidateDataIDs(this._updatedRecordIDs);
        var source = this.getSource();
        var updatedOwners = [];
        if (!$gZYpt.OPTIMIZE_NOTIFY || this._updatedRecordIDs.size > 0) this._storeSubscriptions.updateSubscriptions(source, this._updatedRecordIDs, updatedOwners, sourceOperation);
        else this._storeSubscriptions.updateStaleSubscriptions(source, this._updatedRecordIDs, updatedOwners, sourceOperation);
        if ($gZYpt.OPTIMIZE_NOTIFY && (this._updatedRecordIDs.size > 0 || updatedOwners.length > 0 || this._invalidatedRecordIDs.size > 0 || invalidateStore === true || this._globalInvalidationEpoch === this._currentWriteEpoch)) {
            this._currentWriteEpoch++;
            if (invalidateStore === true) this._globalInvalidationEpoch = this._currentWriteEpoch;
        }
        if (!$gZYpt.OPTIMIZE_NOTIFY || this._invalidatedRecordIDs.size > 0 || invalidateStore === true) this._invalidationSubscriptions.forEach(function(subscription) {
            _this3._updateInvalidationSubscription(subscription, invalidateStore === true);
        });
        if (sourceOperation != null) this._recordSourceOperation(sourceOperation);
        if (log != null) log({
            name: 'store.notify.complete',
            sourceOperation: sourceOperation,
            updatedRecordIDs: this._updatedRecordIDs,
            invalidatedRecordIDs: this._invalidatedRecordIDs,
            subscriptionsSize: this._storeSubscriptions.size(),
            updatedOwners: updatedOwners
        });
        this._updatedRecordIDs.clear();
        this._invalidatedRecordIDs.clear();
        return updatedOwners;
    };
    _proto._recordSourceOperation = function _recordSourceOperation(sourceOperation) {
        var id = sourceOperation.request.identifier;
        var rootEntry = this._roots.get(id);
        if (rootEntry != null) {
            rootEntry.epoch = this._currentWriteEpoch;
            rootEntry.fetchTime = Date.now();
        } else if (sourceOperation.request.node.params.operationKind === 'query' && this._gcReleaseBufferSize > 0 && this._releaseBuffer.length < this._gcReleaseBufferSize) {
            var temporaryRootEntry = {
                operation: sourceOperation,
                refCount: 0,
                epoch: this._currentWriteEpoch,
                fetchTime: Date.now()
            };
            this._releaseBuffer.push(id);
            this._roots.set(id, temporaryRootEntry);
        }
    };
    _proto.publish = function publish(source, idsMarkedForInvalidation) {
        var target = this._getMutableRecordSource();
        $0fe4ba2052f6b3ce$var$updateTargetFromSource(target, source, this._currentWriteEpoch + 1, idsMarkedForInvalidation, this._updatedRecordIDs, this._invalidatedRecordIDs);
        var log = this.__log;
        if (log != null) log({
            name: 'store.publish',
            source: source,
            optimistic: target === this._optimisticSource
        });
    };
    _proto.subscribe = function subscribe(snapshot, callback) {
        return this._storeSubscriptions.subscribe(snapshot, callback);
    };
    _proto.holdGC = function holdGC() {
        var _this4 = this;
        if (this._gcRun) {
            this._gcRun = null;
            this._shouldScheduleGC = true;
        }
        this._gcHoldCounter++;
        var dispose = function dispose() {
            if (_this4._gcHoldCounter > 0) {
                _this4._gcHoldCounter--;
                if (_this4._gcHoldCounter === 0 && _this4._shouldScheduleGC) {
                    _this4.scheduleGC();
                    _this4._shouldScheduleGC = false;
                }
            }
        };
        return {
            dispose: dispose
        };
    };
    _proto.toJSON = function toJSON() {
        return 'RelayModernStore()';
    };
    _proto.getEpoch = function getEpoch() {
        return this._currentWriteEpoch;
    };
    _proto.__getUpdatedRecordIDs = function __getUpdatedRecordIDs() {
        return this._updatedRecordIDs;
    };
    _proto.lookupInvalidationState = function lookupInvalidationState(dataIDs) {
        var _this5 = this;
        var invalidations = new Map();
        dataIDs.forEach(function(dataID) {
            var _RelayModernRecord$ge;
            var record = _this5.getSource().get(dataID);
            invalidations.set(dataID, (_RelayModernRecord$ge = $7SC8Z.getInvalidationEpoch(record)) !== null && _RelayModernRecord$ge !== void 0 ? _RelayModernRecord$ge : null);
        });
        invalidations.set('global', this._globalInvalidationEpoch);
        return {
            dataIDs: dataIDs,
            invalidations: invalidations
        };
    };
    _proto.checkInvalidationState = function checkInvalidationState(prevInvalidationState) {
        var latestInvalidationState = this.lookupInvalidationState(prevInvalidationState.dataIDs);
        var currentInvalidations = latestInvalidationState.invalidations;
        var prevInvalidations = prevInvalidationState.invalidations;
        if (currentInvalidations.get('global') !== prevInvalidations.get('global')) return true;
        var _iterator2 = (0, $0fe4ba2052f6b3ce$var$_createForOfIteratorHelper2["default"])(prevInvalidationState.dataIDs), _step2;
        try {
            for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                var dataID = _step2.value;
                if (currentInvalidations.get(dataID) !== prevInvalidations.get(dataID)) return true;
            }
        } catch (err) {
            _iterator2.e(err);
        } finally{
            _iterator2.f();
        }
        return false;
    };
    _proto.subscribeToInvalidationState = function subscribeToInvalidationState(invalidationState, callback) {
        var _this6 = this;
        var subscription = {
            callback: callback,
            invalidationState: invalidationState
        };
        var dispose = function dispose() {
            _this6._invalidationSubscriptions["delete"](subscription);
        };
        this._invalidationSubscriptions.add(subscription);
        return {
            dispose: dispose
        };
    };
    _proto._updateInvalidationSubscription = function _updateInvalidationSubscription(subscription, invalidatedStore) {
        var _this7 = this;
        var callback = subscription.callback, invalidationState = subscription.invalidationState;
        var dataIDs = invalidationState.dataIDs;
        var isSubscribedToInvalidatedIDs = invalidatedStore || dataIDs.some(function(dataID) {
            return _this7._invalidatedRecordIDs.has(dataID);
        });
        if (!isSubscribedToInvalidatedIDs) return;
        callback();
    };
    _proto.snapshot = function snapshot() {
        !(this._optimisticSource == null) && $jSI6G(false);
        var log = this.__log;
        if (log != null) log({
            name: 'store.snapshot'
        });
        this._storeSubscriptions.snapshotSubscriptions(this.getSource());
        if (this._gcRun) {
            this._gcRun = null;
            this._shouldScheduleGC = true;
        }
        this._optimisticSource = $5QfIo.create(this.getSource());
    };
    _proto.restore = function restore() {
        var optimisticSource = this._optimisticSource;
        !optimisticSource && $jSI6G(false);
        var log = this.__log;
        if (log != null) log({
            name: 'store.restore'
        });
        var optimisticIDs = $5QfIo.getOptimisticRecordIDs(optimisticSource);
        this._resolverCache.unsubscribeFromLiveResolverRecords(optimisticIDs);
        this._optimisticSource = null;
        if (this._shouldScheduleGC) this.scheduleGC();
        this._storeSubscriptions.restoreSubscriptions();
        this._resolverCache.invalidateResolverRecords(optimisticIDs);
    };
    _proto.scheduleGC = function scheduleGC() {
        if (this._gcHoldCounter > 0) {
            this._shouldScheduleGC = true;
            return;
        }
        if (this._gcRun) return;
        this._gcRun = this._collect();
        this._gcScheduler(this._gcStep);
    };
    _proto.__gc = function __gc() {
        if (this._optimisticSource != null) return;
        var gcRun = this._collect();
        while(!gcRun.next().done);
    };
    _proto._collect = function* _collect() {
        if (this._shouldRetainWithinTTL_EXPERIMENTAL && this._queryCacheExpirationTime == null) return;
        var log = this.__log;
        top: while(true){
            if (log != null) log({
                name: 'store.gc.start'
            });
            var startEpoch = this._currentWriteEpoch;
            var references = new Set();
            var _iterator3 = (0, $0fe4ba2052f6b3ce$var$_createForOfIteratorHelper2["default"])(this._roots.entries()), _step3;
            try {
                for(_iterator3.s(); !(_step3 = _iterator3.n()).done;){
                    var _ref2, _operation$request$no3, _operation$request$no4;
                    var _step3$value = _step3.value, _dataID = _step3$value[0], _step3$value$ = _step3$value[1], operation = _step3$value$.operation, refCount = _step3$value$.refCount, fetchTime = _step3$value$.fetchTime;
                    if (this._shouldRetainWithinTTL_EXPERIMENTAL) {
                        var _queryCacheExpirationTime = this._queryCacheExpirationTime;
                        !(_queryCacheExpirationTime != null) && $jSI6G(false);
                        var recordHasExpired = fetchTime == null || fetchTime <= Date.now() - _queryCacheExpirationTime;
                        var recordShouldBeCollected = recordHasExpired && refCount === 0 && !this._releaseBuffer.includes(_dataID);
                        if (recordShouldBeCollected) continue;
                    }
                    var selector = operation.root;
                    var useExecTimeResolvers = (_ref2 = (_operation$request$no3 = operation.request.node.operation.use_exec_time_resolvers) !== null && _operation$request$no3 !== void 0 ? _operation$request$no3 : ((_operation$request$no4 = operation.request.node.operation.exec_time_resolvers_enabled_provider) === null || _operation$request$no4 === void 0 ? void 0 : _operation$request$no4.get()) === true) !== null && _ref2 !== void 0 ? _ref2 : false;
                    $56FwA.mark(this._recordSource, selector, references, this._operationLoader, this._shouldProcessClientComponents, useExecTimeResolvers);
                    yield;
                    if (startEpoch !== this._currentWriteEpoch) {
                        if (log != null) log({
                            name: 'store.gc.interrupted'
                        });
                        continue top;
                    }
                }
            } catch (err) {
                _iterator3.e(err);
            } finally{
                _iterator3.f();
            }
            var storeIDs = this._recordSource.getRecordIDs();
            for(var ii = 0; ii < storeIDs.length; ii++){
                var dataID = storeIDs[ii];
                if (!references.has(dataID)) {
                    var record = this._recordSource.get(dataID);
                    if (record != null) {
                        var maybeResolverSubscription = $7SC8Z.getValue(record, $0fe4ba2052f6b3ce$var$RELAY_RESOLVER_LIVE_STATE_SUBSCRIPTION_KEY);
                        if (maybeResolverSubscription != null) maybeResolverSubscription();
                    }
                    this._recordSource.remove(dataID);
                    if (this._shouldRetainWithinTTL_EXPERIMENTAL) this._roots["delete"](dataID);
                }
            }
            if (log != null) log({
                name: 'store.gc.end',
                references: references
            });
            return;
        }
    };
    _proto.__getNormalizationOptions = function __getNormalizationOptions(path) {
        return {
            path: path,
            getDataID: this._getDataID,
            log: this.__log,
            treatMissingFieldsAsNull: this._treatMissingFieldsAsNull,
            deferDeduplicatedFields: this._deferDeduplicatedFields,
            shouldProcessClientComponents: this._shouldProcessClientComponents,
            actorIdentifier: this._actorIdentifier
        };
    };
    _proto.__notifyUpdatedSubscribers = function __notifyUpdatedSubscribers(updatedRecords) {
        var nextUpdatedRecordIDs = $0fe4ba2052f6b3ce$var$getUpdatedDataIDs(updatedRecords);
        var prevUpdatedRecordIDs = this._updatedRecordIDs;
        this._updatedRecordIDs = nextUpdatedRecordIDs;
        this.notify();
        this._updatedRecordIDs = prevUpdatedRecordIDs;
    };
    return RelayModernStore;
}();
function $0fe4ba2052f6b3ce$var$initializeRecordSource(target) {
    if (!target.has($0fe4ba2052f6b3ce$var$ROOT_ID)) {
        var rootRecord = $7SC8Z.create($0fe4ba2052f6b3ce$var$ROOT_ID, $0fe4ba2052f6b3ce$var$ROOT_TYPE);
        if ($gZYpt.ENABLE_FIELD_GRANULAR_NOTIFICATIONS) $7SC8Z.setValue(rootRecord, $0fe4ba2052f6b3ce$var$FIELD_GRANULAR_NOTIFICATIONS_KEY, true);
        target.set($0fe4ba2052f6b3ce$var$ROOT_ID, rootRecord);
    }
}
function $0fe4ba2052f6b3ce$var$updateTargetFromSource(target, source, currentWriteEpoch, idsMarkedForInvalidation, updatedRecordIDs, invalidatedRecordIDs) {
    if (idsMarkedForInvalidation) idsMarkedForInvalidation.forEach(function(dataID) {
        var targetRecord = target.get(dataID);
        var sourceRecord = source.get(dataID);
        if (sourceRecord === null) return;
        var nextRecord;
        if (targetRecord != null) nextRecord = $7SC8Z.clone(targetRecord);
        else nextRecord = sourceRecord != null ? $7SC8Z.clone(sourceRecord) : null;
        if (!nextRecord) return;
        $7SC8Z.setValue(nextRecord, $ezyIu.INVALIDATED_AT_KEY, currentWriteEpoch);
        invalidatedRecordIDs.add(dataID);
        target.set(dataID, nextRecord);
    });
    var dataIDs = source.getRecordIDs();
    for(var ii = 0; ii < dataIDs.length; ii++){
        var dataID = dataIDs[ii];
        var sourceRecord = source.get(dataID);
        var targetRecord = target.get(dataID);
        if (sourceRecord && targetRecord) {
            var nextRecord = $7SC8Z.update(targetRecord, sourceRecord);
            if (nextRecord !== targetRecord) {
                updatedRecordIDs.add(dataID);
                target.set(dataID, nextRecord);
                if ($7SC8Z.getValue(nextRecord, $0fe4ba2052f6b3ce$var$FIELD_GRANULAR_NOTIFICATIONS_KEY)) {
                    var fields = $7SC8Z.getFields(nextRecord);
                    for(var jj = 0; jj < fields.length; jj++){
                        var storageKey = fields[jj];
                        if (storageKey.startsWith('__')) continue;
                        if ($7SC8Z.hasFieldChanged(targetRecord, nextRecord, storageKey)) updatedRecordIDs.add($0fe4ba2052f6b3ce$var$getFieldNotificationKey(dataID, storageKey));
                    }
                }
            }
        } else if (sourceRecord === null) {
            target["delete"](dataID);
            if (targetRecord !== null) updatedRecordIDs.add(dataID);
        } else if (sourceRecord) {
            target.set(dataID, sourceRecord);
            updatedRecordIDs.add(dataID);
        }
    }
}
function $0fe4ba2052f6b3ce$var$getAvailabilityStatus(operationAvailability, operationLastWrittenAt, operationFetchTime, queryCacheExpirationTime) {
    var mostRecentlyInvalidatedAt = operationAvailability.mostRecentlyInvalidatedAt, status = operationAvailability.status;
    if (typeof mostRecentlyInvalidatedAt === 'number') {
        if (operationLastWrittenAt == null || mostRecentlyInvalidatedAt > operationLastWrittenAt) return {
            status: 'stale'
        };
    }
    if (status === 'missing') return {
        status: 'missing'
    };
    if (operationFetchTime != null && queryCacheExpirationTime != null) {
        var isStale = operationFetchTime <= Date.now() - queryCacheExpirationTime;
        if (isStale) return {
            status: 'stale'
        };
    }
    return {
        status: 'available',
        fetchTime: operationFetchTime !== null && operationFetchTime !== void 0 ? operationFetchTime : null
    };
}
module.exports = $0fe4ba2052f6b3ce$var$RelayModernStore;

});
parcelRegister("9r1R7", function(module, exports) {
'use strict';
var $6de8132a3a2e6eee$var$resolvedPromise = Promise.resolve();
function $6de8132a3a2e6eee$var$resolveImmediate(callback) {
    $6de8132a3a2e6eee$var$resolvedPromise.then(callback)["catch"]($6de8132a3a2e6eee$var$throwNext);
}
function $6de8132a3a2e6eee$var$throwNext(error) {
    setTimeout(function() {
        throw error;
    }, 0);
}
module.exports = $6de8132a3a2e6eee$var$resolveImmediate;

});

parcelRegister("drk9z", function(module, exports) {
'use strict';

var $e27SU = parcelRequire("e27SU");
var $9c8d6e00bf9dea80$var$_interopRequireDefault = $e27SU.default;

var $9c8d6e00bf9dea80$var$_createForOfIteratorHelper2 = $9c8d6e00bf9dea80$var$_interopRequireDefault((parcelRequire("5dSyV")));

var $7MnPa = parcelRequire("7MnPa");

var $9ZaBf = parcelRequire("9ZaBf");

var $gJkyh = parcelRequire("gJkyh");

var $9pidS = parcelRequire("9pidS");
var $9c8d6e00bf9dea80$var$isClientID = $9pidS.isClientID;

var $4dqb0 = parcelRequire("4dqb0");

var $aJaxb = parcelRequire("aJaxb");

var $adnaT = parcelRequire("adnaT");
var $9c8d6e00bf9dea80$var$getLocalVariables = $adnaT.getLocalVariables;

var $7SC8Z = parcelRequire("7SC8Z");

var $hfBP1 = parcelRequire("hfBP1");
var $9c8d6e00bf9dea80$var$EXISTENT = $hfBP1.EXISTENT, $9c8d6e00bf9dea80$var$UNKNOWN = $hfBP1.UNKNOWN;

var $ezyIu = parcelRequire("ezyIu");

var $enqEM = parcelRequire("enqEM");
var $9c8d6e00bf9dea80$var$TYPE_SCHEMA_TYPE = $enqEM.TYPE_SCHEMA_TYPE, $9c8d6e00bf9dea80$var$generateTypeID = $enqEM.generateTypeID;

var $jSI6G = parcelRequire("jSI6G");
var $9c8d6e00bf9dea80$var$getModuleOperationKey = $ezyIu.getModuleOperationKey, $9c8d6e00bf9dea80$var$getStorageKey = $ezyIu.getStorageKey, $9c8d6e00bf9dea80$var$getArgumentValues = $ezyIu.getArgumentValues;
function $9c8d6e00bf9dea80$var$check(getSourceForActor, getTargetForActor, defaultActorIdentifier, selector, handlers, operationLoader, getDataID, shouldProcessClientComponents, log, useExecTimeResolvers) {
    if (log != null) log({
        name: 'store.datachecker.start',
        selector: selector
    });
    var dataID = selector.dataID, node = selector.node, variables = selector.variables;
    var checker = new $9c8d6e00bf9dea80$var$DataChecker(getSourceForActor, getTargetForActor, defaultActorIdentifier, variables, handlers, operationLoader, getDataID, shouldProcessClientComponents, log, useExecTimeResolvers);
    var result = checker.check(node, dataID);
    if (log != null) log({
        name: 'store.datachecker.end',
        selector: selector
    });
    return result;
}
var $9c8d6e00bf9dea80$var$DataChecker = /*#__PURE__*/ function() {
    function DataChecker(getSourceForActor, getTargetForActor, defaultActorIdentifier, variables, handlers, operationLoader, getDataID, shouldProcessClientComponents, log, useExecTimeResolvers) {
        this._getSourceForActor = getSourceForActor;
        this._getTargetForActor = getTargetForActor;
        this._getDataID = getDataID;
        this._source = getSourceForActor(defaultActorIdentifier);
        this._mutatorRecordSourceProxyCache = new Map();
        var _this$_getMutatorAndR = this._getMutatorAndRecordProxyForActor(defaultActorIdentifier), mutator = _this$_getMutatorAndR[0], recordSourceProxy = _this$_getMutatorAndR[1];
        this._useExecTimeResolvers = useExecTimeResolvers !== null && useExecTimeResolvers !== void 0 ? useExecTimeResolvers : false;
        this._mostRecentlyInvalidatedAt = null;
        this._handlers = handlers;
        this._mutator = mutator;
        this._operationLoader = operationLoader !== null && operationLoader !== void 0 ? operationLoader : null;
        this._recordSourceProxy = recordSourceProxy;
        this._recordWasMissing = false;
        this._variables = variables;
        this._shouldProcessClientComponents = shouldProcessClientComponents;
        this._log = log;
    }
    var _proto = DataChecker.prototype;
    _proto._getMutatorAndRecordProxyForActor = function _getMutatorAndRecordProxyForActor(actorIdentifier) {
        var tuple = this._mutatorRecordSourceProxyCache.get(actorIdentifier);
        if (tuple == null) {
            var target = this._getTargetForActor(actorIdentifier);
            var mutator = new $7MnPa(this._getSourceForActor(actorIdentifier), target);
            var recordSourceProxy = new $9ZaBf(mutator, this._getDataID, undefined, this._handlers, this._log);
            tuple = [
                mutator,
                recordSourceProxy
            ];
            this._mutatorRecordSourceProxyCache.set(actorIdentifier, tuple);
        }
        return tuple;
    };
    _proto.check = function check(node, dataID) {
        this._assignClientAbstractTypes(node);
        this._traverse(node, dataID);
        return this._recordWasMissing === true ? {
            mostRecentlyInvalidatedAt: this._mostRecentlyInvalidatedAt,
            status: 'missing'
        } : {
            mostRecentlyInvalidatedAt: this._mostRecentlyInvalidatedAt,
            status: 'available'
        };
    };
    _proto._getVariableValue = function _getVariableValue(name) {
        !this._variables.hasOwnProperty(name) && $jSI6G(false);
        return this._variables[name];
    };
    _proto._handleMissing = function _handleMissing() {
        this._recordWasMissing = true;
    };
    _proto._handleMissingScalarField = function _handleMissingScalarField(field, dataID) {
        if (field.name === 'id' && field.alias == null && $9c8d6e00bf9dea80$var$isClientID(dataID)) return undefined;
        var args = field.args != undefined ? $9c8d6e00bf9dea80$var$getArgumentValues(field.args, this._variables) : {};
        var _iterator = (0, $9c8d6e00bf9dea80$var$_createForOfIteratorHelper2["default"])(this._handlers), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var handler = _step.value;
                if (handler.kind === 'scalar') {
                    var newValue = handler.handle(field, this._recordSourceProxy.get(dataID), args, this._recordSourceProxy);
                    if (newValue !== undefined) return newValue;
                }
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
        if (this._log != null) this._log({
            name: 'store.datachecker.missing',
            kind: 'scalar',
            dataID: dataID,
            fieldName: field.name,
            storageKey: $9c8d6e00bf9dea80$var$getStorageKey(field, this._variables)
        });
        this._handleMissing();
    };
    _proto._handleMissingLinkField = function _handleMissingLinkField(field, dataID) {
        var args = field.args != undefined ? $9c8d6e00bf9dea80$var$getArgumentValues(field.args, this._variables) : {};
        var _iterator2 = (0, $9c8d6e00bf9dea80$var$_createForOfIteratorHelper2["default"])(this._handlers), _step2;
        try {
            for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                var handler = _step2.value;
                if (handler.kind === 'linked') {
                    var newValue = handler.handle(field, this._recordSourceProxy.get(dataID), args, this._recordSourceProxy);
                    if (newValue !== undefined && (newValue === null || this._mutator.getStatus(newValue) === $9c8d6e00bf9dea80$var$EXISTENT)) return newValue;
                }
            }
        } catch (err) {
            _iterator2.e(err);
        } finally{
            _iterator2.f();
        }
        if (this._log != null) this._log({
            name: 'store.datachecker.missing',
            kind: 'linked',
            dataID: dataID,
            fieldName: field.name,
            storageKey: $9c8d6e00bf9dea80$var$getStorageKey(field, this._variables)
        });
        this._handleMissing();
    };
    _proto._handleMissingPluralLinkField = function _handleMissingPluralLinkField(field, dataID) {
        var _this = this;
        var args = field.args != undefined ? $9c8d6e00bf9dea80$var$getArgumentValues(field.args, this._variables) : {};
        var _iterator3 = (0, $9c8d6e00bf9dea80$var$_createForOfIteratorHelper2["default"])(this._handlers), _step3;
        try {
            for(_iterator3.s(); !(_step3 = _iterator3.n()).done;){
                var handler = _step3.value;
                if (handler.kind === 'pluralLinked') {
                    var newValue = handler.handle(field, this._recordSourceProxy.get(dataID), args, this._recordSourceProxy);
                    if (newValue != null) {
                        var allItemsKnown = newValue.every(function(linkedID) {
                            return linkedID != null && _this._mutator.getStatus(linkedID) === $9c8d6e00bf9dea80$var$EXISTENT;
                        });
                        if (allItemsKnown) return newValue;
                    } else if (newValue === null) return null;
                }
            }
        } catch (err) {
            _iterator3.e(err);
        } finally{
            _iterator3.f();
        }
        if (this._log != null) this._log({
            name: 'store.datachecker.missing',
            kind: 'pluralLinked',
            dataID: dataID,
            fieldName: field.name,
            storageKey: $9c8d6e00bf9dea80$var$getStorageKey(field, this._variables)
        });
        this._handleMissing();
    };
    _proto._traverse = function _traverse(node, dataID) {
        var status = this._mutator.getStatus(dataID);
        if (status === $9c8d6e00bf9dea80$var$UNKNOWN) {
            if (this._log != null) this._log({
                name: 'store.datachecker.missing',
                kind: 'unknown_record',
                dataID: dataID
            });
            this._handleMissing();
        }
        if (status === $9c8d6e00bf9dea80$var$EXISTENT) {
            var record = this._source.get(dataID);
            var invalidatedAt = $7SC8Z.getInvalidationEpoch(record);
            if (invalidatedAt != null) this._mostRecentlyInvalidatedAt = this._mostRecentlyInvalidatedAt != null ? Math.max(this._mostRecentlyInvalidatedAt, invalidatedAt) : invalidatedAt;
            this._traverseSelections(node.selections, dataID);
        }
    };
    _proto._traverseSelections = function _traverseSelections(selections, dataID) {
        var _this2 = this;
        selections.forEach(function(selection) {
            switch(selection.kind){
                case 'ScalarField':
                    _this2._checkScalar(selection, dataID);
                    break;
                case 'LinkedField':
                    if (selection.plural) _this2._checkPluralLink(selection, dataID);
                    else _this2._checkLink(selection, dataID);
                    break;
                case 'ActorChange':
                    _this2._checkActorChange(selection.linkedField, dataID);
                    break;
                case 'Condition':
                    var conditionValue = Boolean(_this2._getVariableValue(selection.condition));
                    if (conditionValue === selection.passingValue) _this2._traverseSelections(selection.selections, dataID);
                    break;
                case 'InlineFragment':
                    var _abstractKey = selection.abstractKey;
                    if (_abstractKey == null) {
                        var typeName = _this2._mutator.getType(dataID);
                        if (typeName === selection.type) _this2._traverseSelections(selection.selections, dataID);
                    } else {
                        var _recordType = _this2._mutator.getType(dataID);
                        !(_recordType != null) && $jSI6G(false);
                        var _typeID = $9c8d6e00bf9dea80$var$generateTypeID(_recordType);
                        var _implementsInterface = _this2._mutator.getValue(_typeID, _abstractKey);
                        if (_implementsInterface === true) _this2._traverseSelections(selection.selections, dataID);
                        else if (_implementsInterface == null) _this2._handleMissing();
                    }
                    break;
                case 'LinkedHandle':
                    var handleField = $4dqb0(selection, selections, _this2._variables);
                    if (handleField.plural) _this2._checkPluralLink(handleField, dataID);
                    else _this2._checkLink(handleField, dataID);
                    break;
                case 'ScalarHandle':
                    var _handleField = $aJaxb(selection, selections, _this2._variables);
                    _this2._checkScalar(_handleField, dataID);
                    break;
                case 'ModuleImport':
                    _this2._checkModuleImport(selection, dataID);
                    break;
                case 'Defer':
                case 'Stream':
                    _this2._traverseSelections(selection.selections, dataID);
                    break;
                case 'FragmentSpread':
                    var prevVariables = _this2._variables;
                    _this2._variables = $9c8d6e00bf9dea80$var$getLocalVariables(_this2._variables, selection.fragment.argumentDefinitions, selection.args);
                    _this2._traverseSelections(selection.fragment.selections, dataID);
                    _this2._variables = prevVariables;
                    break;
                case 'ClientExtension':
                    var recordWasMissing = _this2._recordWasMissing;
                    _this2._traverseSelections(selection.selections, dataID);
                    _this2._recordWasMissing = recordWasMissing;
                    break;
                case 'TypeDiscriminator':
                    var abstractKey = selection.abstractKey;
                    var recordType = _this2._mutator.getType(dataID);
                    !(recordType != null) && $jSI6G(false);
                    var typeID = $9c8d6e00bf9dea80$var$generateTypeID(recordType);
                    var implementsInterface = _this2._mutator.getValue(typeID, abstractKey);
                    if (implementsInterface == null) _this2._handleMissing();
                    break;
                case 'ClientComponent':
                    if (_this2._shouldProcessClientComponents === false) break;
                    _this2._traverseSelections(selection.fragment.selections, dataID);
                    break;
                case 'RelayResolver':
                case 'RelayLiveResolver':
                    if (!_this2._useExecTimeResolvers) _this2._checkResolver(selection, dataID);
                    break;
                case 'ClientEdgeToClientObject':
                    if (!_this2._useExecTimeResolvers) _this2._checkResolver(selection.backingField, dataID);
                    break;
                default:
                    selection;
                    $jSI6G(false);
            }
        });
    };
    _proto._checkResolver = function _checkResolver(resolver, dataID) {
        if (resolver.fragment) this._traverseSelections([
            resolver.fragment
        ], dataID);
    };
    _proto._checkModuleImport = function _checkModuleImport(moduleImport, dataID) {
        var operationLoader = this._operationLoader;
        !(operationLoader !== null) && $jSI6G(false);
        var operationKey = $9c8d6e00bf9dea80$var$getModuleOperationKey(moduleImport.documentName);
        var operationReference = this._mutator.getValue(dataID, operationKey);
        if (operationReference == null) {
            if (operationReference === undefined) this._handleMissing();
            return;
        }
        var normalizationRootNode = operationLoader.get(operationReference);
        if (normalizationRootNode != null) {
            var operation = $gJkyh(normalizationRootNode);
            var prevVariables = this._variables;
            this._variables = $9c8d6e00bf9dea80$var$getLocalVariables(this._variables, operation.argumentDefinitions, moduleImport.args);
            this._traverse(operation, dataID);
            this._variables = prevVariables;
        } else this._handleMissing();
    };
    _proto._checkScalar = function _checkScalar(field, dataID) {
        var storageKey = $9c8d6e00bf9dea80$var$getStorageKey(field, this._variables);
        var fieldValue = this._mutator.getValue(dataID, storageKey);
        if (fieldValue === undefined) {
            fieldValue = this._handleMissingScalarField(field, dataID);
            if (fieldValue !== undefined) this._mutator.setValue(dataID, storageKey, fieldValue);
        }
    };
    _proto._checkLink = function _checkLink(field, dataID) {
        var storageKey = $9c8d6e00bf9dea80$var$getStorageKey(field, this._variables);
        var linkedID = this._mutator.getLinkedRecordID(dataID, storageKey);
        if (linkedID === undefined) {
            linkedID = this._handleMissingLinkField(field, dataID);
            if (linkedID != null) this._mutator.setLinkedRecordID(dataID, storageKey, linkedID);
            else if (linkedID === null) this._mutator.setValue(dataID, storageKey, null);
        }
        if (linkedID != null) this._traverse(field, linkedID);
    };
    _proto._checkPluralLink = function _checkPluralLink(field, dataID) {
        var _this3 = this;
        var storageKey = $9c8d6e00bf9dea80$var$getStorageKey(field, this._variables);
        var linkedIDs = this._mutator.getLinkedRecordIDs(dataID, storageKey);
        if (linkedIDs === undefined) {
            linkedIDs = this._handleMissingPluralLinkField(field, dataID);
            if (linkedIDs != null) this._mutator.setLinkedRecordIDs(dataID, storageKey, linkedIDs);
            else if (linkedIDs === null) this._mutator.setValue(dataID, storageKey, null);
        }
        if (linkedIDs) linkedIDs.forEach(function(linkedID) {
            if (linkedID != null) _this3._traverse(field, linkedID);
        });
    };
    _proto._checkActorChange = function _checkActorChange(field, dataID) {
        var storageKey = $9c8d6e00bf9dea80$var$getStorageKey(field, this._variables);
        var record = this._source.get(dataID);
        var tuple = record != null ? $7SC8Z.getActorLinkedRecordID(record, storageKey) : record;
        if (tuple == null) {
            if (tuple === undefined) this._handleMissing();
        } else {
            var actorIdentifier = tuple[0], linkedID = tuple[1];
            var prevSource = this._source;
            var prevMutator = this._mutator;
            var prevRecordSourceProxy = this._recordSourceProxy;
            var _this$_getMutatorAndR2 = this._getMutatorAndRecordProxyForActor(actorIdentifier), mutator = _this$_getMutatorAndR2[0], recordSourceProxy = _this$_getMutatorAndR2[1];
            this._source = this._getSourceForActor(actorIdentifier);
            this._mutator = mutator;
            this._recordSourceProxy = recordSourceProxy;
            this._assignClientAbstractTypes(field);
            this._traverse(field, linkedID);
            this._source = prevSource;
            this._mutator = prevMutator;
            this._recordSourceProxy = prevRecordSourceProxy;
        }
    };
    _proto._assignClientAbstractTypes = function _assignClientAbstractTypes(node) {
        var clientAbstractTypes = node.clientAbstractTypes;
        if (clientAbstractTypes != null) for(var _i = 0, _Object$keys = Object.keys(clientAbstractTypes); _i < _Object$keys.length; _i++){
            var abstractType = _Object$keys[_i];
            var _iterator4 = (0, $9c8d6e00bf9dea80$var$_createForOfIteratorHelper2["default"])(clientAbstractTypes[abstractType]), _step4;
            try {
                for(_iterator4.s(); !(_step4 = _iterator4.n()).done;){
                    var concreteType = _step4.value;
                    var typeID = $9c8d6e00bf9dea80$var$generateTypeID(concreteType);
                    if (this._source.get(typeID) == null) this._mutator.create(typeID, $9c8d6e00bf9dea80$var$TYPE_SCHEMA_TYPE);
                    if (this._mutator.getValue(typeID, abstractType) == null) this._mutator.setValue(typeID, abstractType, true);
                }
            } catch (err) {
                _iterator4.e(err);
            } finally{
                _iterator4.f();
            }
        }
    };
    return DataChecker;
}();
module.exports = {
    check: $9c8d6e00bf9dea80$var$check
};

});
parcelRegister("7MnPa", function(module, exports) {
'use strict';

var $7SC8Z = parcelRequire("7SC8Z");

var $hfBP1 = parcelRequire("hfBP1");
var $5a9f7f1c32083978$var$EXISTENT = $hfBP1.EXISTENT;

var $jSI6G = parcelRequire("jSI6G");
var $5a9f7f1c32083978$var$RelayRecordSourceMutator = /*#__PURE__*/ function() {
    function RelayRecordSourceMutator(base, sink) {
        this.__sources = [
            sink,
            base
        ];
        this._base = base;
        this._sink = sink;
    }
    var _proto = RelayRecordSourceMutator.prototype;
    _proto.unstable_getRawRecordWithChanges = function unstable_getRawRecordWithChanges(dataID) {
        var baseRecord = this._base.get(dataID);
        var sinkRecord = this._sink.get(dataID);
        if (sinkRecord === undefined) {
            if (baseRecord == null) return baseRecord;
            var nextRecord = $7SC8Z.clone(baseRecord);
            return nextRecord;
        } else if (sinkRecord === null) return null;
        else if (baseRecord != null) {
            var _nextRecord = $7SC8Z.update(baseRecord, sinkRecord);
            return _nextRecord;
        } else {
            var _nextRecord2 = $7SC8Z.clone(sinkRecord);
            return _nextRecord2;
        }
    };
    _proto._getSinkRecord = function _getSinkRecord(dataID) {
        var sinkRecord = this._sink.get(dataID);
        if (!sinkRecord) {
            var baseRecord = this._base.get(dataID);
            !baseRecord && $jSI6G(false);
            sinkRecord = $7SC8Z.create(dataID, $7SC8Z.getType(baseRecord));
            this._sink.set(dataID, sinkRecord);
        }
        return sinkRecord;
    };
    _proto.copyFields = function copyFields(sourceID, sinkID) {
        var sinkSource = this._sink.get(sourceID);
        var baseSource = this._base.get(sourceID);
        !(sinkSource || baseSource) && $jSI6G(false);
        var sink = this._getSinkRecord(sinkID);
        if (baseSource) $7SC8Z.copyFields(baseSource, sink);
        if (sinkSource) $7SC8Z.copyFields(sinkSource, sink);
    };
    _proto.copyFieldsFromRecord = function copyFieldsFromRecord(record, sinkID) {
        var sink = this._getSinkRecord(sinkID);
        $7SC8Z.copyFields(record, sink);
    };
    _proto.create = function create(dataID, typeName) {
        !(this._base.getStatus(dataID) !== $5a9f7f1c32083978$var$EXISTENT && this._sink.getStatus(dataID) !== $5a9f7f1c32083978$var$EXISTENT) && $jSI6G(false);
        var record = $7SC8Z.create(dataID, typeName);
        this._sink.set(dataID, record);
    };
    _proto["delete"] = function _delete(dataID) {
        this._sink["delete"](dataID);
    };
    _proto.getStatus = function getStatus(dataID) {
        return this._sink.has(dataID) ? this._sink.getStatus(dataID) : this._base.getStatus(dataID);
    };
    _proto.getType = function getType(dataID) {
        for(var ii = 0; ii < this.__sources.length; ii++){
            var record = this.__sources[ii].get(dataID);
            if (record) return $7SC8Z.getType(record);
            else if (record === null) return null;
        }
    };
    _proto.getValue = function getValue(dataID, storageKey) {
        for(var ii = 0; ii < this.__sources.length; ii++){
            var record = this.__sources[ii].get(dataID);
            if (record) {
                var value = $7SC8Z.getValue(record, storageKey);
                if (value !== undefined) return value;
            } else if (record === null) return null;
        }
    };
    _proto.setValue = function setValue(dataID, storageKey, value) {
        var sinkRecord = this._getSinkRecord(dataID);
        $7SC8Z.setValue(sinkRecord, storageKey, value);
    };
    _proto.getErrors = function getErrors(dataID, storageKey) {
        for(var ii = 0; ii < this.__sources.length; ii++){
            var record = this.__sources[ii].get(dataID);
            if (record) {
                var value = $7SC8Z.getErrors(record, storageKey);
                if (value !== undefined) return value;
            } else if (record === null) return null;
        }
    };
    _proto.setErrors = function setErrors(dataID, storageKey, errors) {
        var sinkRecord = this._getSinkRecord(dataID);
        $7SC8Z.setErrors(sinkRecord, storageKey, errors);
    };
    _proto.getLinkedRecordID = function getLinkedRecordID(dataID, storageKey) {
        for(var ii = 0; ii < this.__sources.length; ii++){
            var record = this.__sources[ii].get(dataID);
            if (record) {
                var linkedID = $7SC8Z.getLinkedRecordID(record, storageKey);
                if (linkedID !== undefined) return linkedID;
            } else if (record === null) return null;
        }
    };
    _proto.setLinkedRecordID = function setLinkedRecordID(dataID, storageKey, linkedID) {
        var sinkRecord = this._getSinkRecord(dataID);
        $7SC8Z.setLinkedRecordID(sinkRecord, storageKey, linkedID);
    };
    _proto.getLinkedRecordIDs = function getLinkedRecordIDs(dataID, storageKey) {
        for(var ii = 0; ii < this.__sources.length; ii++){
            var record = this.__sources[ii].get(dataID);
            if (record) {
                var linkedIDs = $7SC8Z.getLinkedRecordIDs(record, storageKey);
                if (linkedIDs !== undefined) return linkedIDs;
            } else if (record === null) return null;
        }
    };
    _proto.setLinkedRecordIDs = function setLinkedRecordIDs(dataID, storageKey, linkedIDs) {
        var sinkRecord = this._getSinkRecord(dataID);
        $7SC8Z.setLinkedRecordIDs(sinkRecord, storageKey, linkedIDs);
    };
    return RelayRecordSourceMutator;
}();
module.exports = $5a9f7f1c32083978$var$RelayRecordSourceMutator;

});

parcelRegister("9ZaBf", function(module, exports) {
'use strict';

var $7SC8Z = parcelRequire("7SC8Z");

var $hfBP1 = parcelRequire("hfBP1");
var $74520876323fe14d$var$EXISTENT = $hfBP1.EXISTENT, $74520876323fe14d$var$NONEXISTENT = $hfBP1.NONEXISTENT;

var $ezyIu = parcelRequire("ezyIu");
var $74520876323fe14d$var$ROOT_ID = $ezyIu.ROOT_ID, $74520876323fe14d$var$ROOT_TYPE = $ezyIu.ROOT_TYPE;

var $4vRcT = parcelRequire("4vRcT");
var $74520876323fe14d$var$_readUpdatableFragment = $4vRcT.readUpdatableFragment;

var $fVSWx = parcelRequire("fVSWx");
var $74520876323fe14d$var$_readUpdatableQuery = $fVSWx.readUpdatableQuery;

var $5pVY2 = parcelRequire("5pVY2");

var $jSI6G = parcelRequire("jSI6G");
var $74520876323fe14d$var$RelayRecordSourceProxy = /*#__PURE__*/ function() {
    function RelayRecordSourceProxy(mutator, getDataID, handlerProvider, missingFieldHandlers, log) {
        this.__mutator = mutator;
        this._handlerProvider = handlerProvider || null;
        this._proxies = {};
        this._getDataID = getDataID;
        this._invalidatedStore = false;
        this._idsMarkedForInvalidation = new Set();
        this._missingFieldHandlers = missingFieldHandlers;
        this._log = log !== null && log !== void 0 ? log : function(LogEvent) {};
    }
    var _proto = RelayRecordSourceProxy.prototype;
    _proto.publishSource = function publishSource(source, fieldPayloads) {
        var _this = this;
        var dataIDs = source.getRecordIDs();
        dataIDs.forEach(function(dataID) {
            var status = source.getStatus(dataID);
            if (status === $74520876323fe14d$var$EXISTENT) {
                var sourceRecord = source.get(dataID);
                if (sourceRecord) {
                    if (_this.__mutator.getStatus(dataID) !== $74520876323fe14d$var$EXISTENT) _this.create(dataID, $7SC8Z.getType(sourceRecord));
                    _this.__mutator.copyFieldsFromRecord(sourceRecord, dataID);
                }
            } else if (status === $74520876323fe14d$var$NONEXISTENT) _this["delete"](dataID);
        });
        if (fieldPayloads && fieldPayloads.length) fieldPayloads.forEach(function(fieldPayload) {
            var handler = _this._handlerProvider && _this._handlerProvider(fieldPayload.handle);
            !handler && $jSI6G(false);
            handler.update(_this, fieldPayload);
        });
    };
    _proto.create = function create(dataID, typeName) {
        this.__mutator.create(dataID, typeName);
        delete this._proxies[dataID];
        var record = this.get(dataID);
        !record && $jSI6G(false);
        return record;
    };
    _proto["delete"] = function _delete(dataID) {
        !(dataID !== $74520876323fe14d$var$ROOT_ID) && $jSI6G(false);
        delete this._proxies[dataID];
        this.__mutator["delete"](dataID);
    };
    _proto.get = function get(dataID) {
        if (!this._proxies.hasOwnProperty(dataID)) {
            var status = this.__mutator.getStatus(dataID);
            if (status === $74520876323fe14d$var$EXISTENT) this._proxies[dataID] = new $5pVY2(this, this.__mutator, dataID);
            else this._proxies[dataID] = status === $74520876323fe14d$var$NONEXISTENT ? null : undefined;
        }
        return this._proxies[dataID];
    };
    _proto.getRoot = function getRoot() {
        var root = this.get($74520876323fe14d$var$ROOT_ID);
        if (!root) root = this.create($74520876323fe14d$var$ROOT_ID, $74520876323fe14d$var$ROOT_TYPE);
        !(root && root.getType() === $74520876323fe14d$var$ROOT_TYPE) && $jSI6G(false);
        return root;
    };
    _proto.invalidateStore = function invalidateStore() {
        this._invalidatedStore = true;
    };
    _proto.isStoreMarkedForInvalidation = function isStoreMarkedForInvalidation() {
        return this._invalidatedStore;
    };
    _proto.markIDForInvalidation = function markIDForInvalidation(dataID) {
        this._idsMarkedForInvalidation.add(dataID);
    };
    _proto.getIDsMarkedForInvalidation = function getIDsMarkedForInvalidation() {
        return this._idsMarkedForInvalidation;
    };
    _proto.readUpdatableQuery = function readUpdatableQuery(query, variables) {
        return $74520876323fe14d$var$_readUpdatableQuery(query, variables, this, this._missingFieldHandlers);
    };
    _proto.readUpdatableFragment = function readUpdatableFragment(fragment, fragmentReference) {
        return $74520876323fe14d$var$_readUpdatableFragment(fragment, fragmentReference, this, this._missingFieldHandlers);
    };
    return RelayRecordSourceProxy;
}();
module.exports = $74520876323fe14d$var$RelayRecordSourceProxy;

});
parcelRegister("4vRcT", function(module, exports) {
'use strict';

var $kLQDK = parcelRequire("kLQDK");
var $3493547b1bc1084e$var$getFragment = $kLQDK.getFragment;

var $iUq0k = parcelRequire("iUq0k");
var $3493547b1bc1084e$var$getVariablesFromFragment = $iUq0k.getVariablesFromFragment;

var $ezyIu = parcelRequire("ezyIu");
var $3493547b1bc1084e$var$ID_KEY = $ezyIu.ID_KEY;

var $bNKRh = parcelRequire("bNKRh");
var $3493547b1bc1084e$var$createUpdatableProxy = $bNKRh.createUpdatableProxy;

var $jSI6G = parcelRequire("jSI6G");
function $3493547b1bc1084e$var$readUpdatableFragment(fragment, fragmentReference, proxy, missingFieldHandlers) {
    var updatableFragment = $3493547b1bc1084e$var$getFragment(fragment);
    var fragmentVariables = $3493547b1bc1084e$var$getVariablesFromFragment(updatableFragment, fragmentReference);
    var id = fragmentReference[$3493547b1bc1084e$var$ID_KEY];
    var fragmentRoot = proxy.get(id);
    !(fragmentRoot != null) && $jSI6G(false);
    return {
        updatableData: $3493547b1bc1084e$var$createUpdatableProxy(fragmentRoot, fragmentVariables, updatableFragment.selections, proxy, missingFieldHandlers)
    };
}
module.exports = {
    readUpdatableFragment: $3493547b1bc1084e$var$readUpdatableFragment
};

});
parcelRegister("bNKRh", function(module, exports) {
'use strict';

var $e27SU = parcelRequire("e27SU");
var $89789e6c33329f72$var$_interopRequireDefault = $e27SU.default;

var $89789e6c33329f72$var$_createForOfIteratorHelper2 = $89789e6c33329f72$var$_interopRequireDefault((parcelRequire("5dSyV")));

var $ezyIu = parcelRequire("ezyIu");
var $89789e6c33329f72$var$getArgumentValues = $ezyIu.getArgumentValues;
var $89789e6c33329f72$var$nonUpdatableKeys = [
    'id',
    '__id',
    '__typename',
    'js'
];
function $89789e6c33329f72$var$createUpdatableProxy(updatableProxyRootRecord, variables, selections, recordSourceProxy, missingFieldHandlers) {
    var mutableUpdatableProxy = {};
    $89789e6c33329f72$var$updateProxyFromSelections(mutableUpdatableProxy, updatableProxyRootRecord, variables, selections, recordSourceProxy, missingFieldHandlers);
    return mutableUpdatableProxy;
}
function $89789e6c33329f72$var$updateProxyFromSelections(mutableUpdatableProxy, updatableProxyRootRecord, variables, selections, recordSourceProxy, missingFieldHandlers) {
    var _selection$alias3;
    var _iterator = (0, $89789e6c33329f72$var$_createForOfIteratorHelper2["default"])(selections), _step;
    try {
        var _loop = function _loop() {
            var selection = _step.value;
            switch(selection.kind){
                case 'LinkedField':
                    if (selection.plural) Object.defineProperty(mutableUpdatableProxy, (_selection$alias = selection.alias) !== null && _selection$alias !== void 0 ? _selection$alias : selection.name, {
                        get: $89789e6c33329f72$var$createGetterForPluralLinkedField(selection, variables, updatableProxyRootRecord, recordSourceProxy, missingFieldHandlers),
                        set: $89789e6c33329f72$var$createSetterForPluralLinkedField(selection, variables, updatableProxyRootRecord, recordSourceProxy)
                    });
                    else Object.defineProperty(mutableUpdatableProxy, (_selection$alias2 = selection.alias) !== null && _selection$alias2 !== void 0 ? _selection$alias2 : selection.name, {
                        get: $89789e6c33329f72$var$createGetterForSingularLinkedField(selection, variables, updatableProxyRootRecord, recordSourceProxy, missingFieldHandlers),
                        set: $89789e6c33329f72$var$createSetterForSingularLinkedField(selection, variables, updatableProxyRootRecord, recordSourceProxy)
                    });
                    break;
                case 'ScalarField':
                    var scalarFieldName = (_selection$alias3 = selection.alias) !== null && _selection$alias3 !== void 0 ? _selection$alias3 : selection.name;
                    Object.defineProperty(mutableUpdatableProxy, scalarFieldName, {
                        get: function get() {
                            var _selection$args;
                            var newVariables = $89789e6c33329f72$var$getArgumentValues((_selection$args = selection.args) !== null && _selection$args !== void 0 ? _selection$args : [], variables);
                            var value = updatableProxyRootRecord.getValue(selection.name, newVariables);
                            if (value == null) value = $89789e6c33329f72$var$getScalarUsingMissingFieldHandlers(selection, newVariables, updatableProxyRootRecord, recordSourceProxy, missingFieldHandlers);
                            return value;
                        },
                        set: $89789e6c33329f72$var$nonUpdatableKeys.includes(selection.name) ? undefined : function(newValue) {
                            var _selection$args2;
                            var newVariables = $89789e6c33329f72$var$getArgumentValues((_selection$args2 = selection.args) !== null && _selection$args2 !== void 0 ? _selection$args2 : [], variables);
                            updatableProxyRootRecord.setValue__UNSAFE(newValue, selection.name, newVariables);
                        }
                    });
                    break;
                case 'InlineFragment':
                    if (updatableProxyRootRecord.getType() === selection.type) $89789e6c33329f72$var$updateProxyFromSelections(mutableUpdatableProxy, updatableProxyRootRecord, variables, selection.selections, recordSourceProxy, missingFieldHandlers);
                    break;
                case 'ClientExtension':
                    $89789e6c33329f72$var$updateProxyFromSelections(mutableUpdatableProxy, updatableProxyRootRecord, variables, selection.selections, recordSourceProxy, missingFieldHandlers);
                    break;
                case 'FragmentSpread':
                    break;
                case 'Condition':
                case 'ActorChange':
                case 'InlineDataFragmentSpread':
                case 'AliasedInlineFragmentSpread':
                case 'ClientEdgeToClientObject':
                case 'ClientEdgeToServerObject':
                case 'Defer':
                case 'ModuleImport':
                case 'RequiredField':
                case 'CatchField':
                case 'Stream':
                case 'RelayResolver':
                case 'RelayLiveResolver':
                    throw new Error('Encountered an unexpected ReaderSelection variant in RelayRecordSourceProxy. This indicates a bug in Relay.');
                default:
                    selection.kind;
                    throw new Error('Encountered an unexpected ReaderSelection variant in RelayRecordSourceProxy. This indicates a bug in Relay.');
            }
        };
        for(_iterator.s(); !(_step = _iterator.n()).done;){
            var _selection$alias;
            var _selection$alias2;
            _loop();
        }
    } catch (err) {
        _iterator.e(err);
    } finally{
        _iterator.f();
    }
}
function $89789e6c33329f72$var$createSetterForPluralLinkedField(selection, variables, updatableProxyRootRecord, recordSourceProxy) {
    return function set(newValue) {
        var _selection$args3;
        var newVariables = $89789e6c33329f72$var$getArgumentValues((_selection$args3 = selection.args) !== null && _selection$args3 !== void 0 ? _selection$args3 : [], variables);
        if (newValue == null) throw new Error('Do not assign null to plural linked fields; assign an empty array instead.');
        else {
            var recordProxies = newValue.map(function(item) {
                if (item == null) throw new Error('When assigning an array of items, none of the items should be null or undefined.');
                var __id = item.__id;
                if (__id == null) throw new Error('The __id field must be present on each item passed to the setter. This indicates a bug in Relay.');
                var newValueRecord = recordSourceProxy.get(__id);
                if (newValueRecord == null) throw new Error("Did not find item with data id ".concat(__id, " in the store."));
                return newValueRecord;
            });
            updatableProxyRootRecord.setLinkedRecords(recordProxies, selection.name, newVariables);
        }
    };
}
function $89789e6c33329f72$var$createSetterForSingularLinkedField(selection, variables, updatableProxyRootRecord, recordSourceProxy) {
    return function set(newValue) {
        var _selection$args4;
        var newVariables = $89789e6c33329f72$var$getArgumentValues((_selection$args4 = selection.args) !== null && _selection$args4 !== void 0 ? _selection$args4 : [], variables);
        if (newValue == null) updatableProxyRootRecord.setValue(newValue, selection.name, newVariables);
        else {
            var __id = newValue.__id;
            if (__id == null) throw new Error('The __id field must be present on the argument. This indicates a bug in Relay.');
            var newValueRecord = recordSourceProxy.get(__id);
            if (newValueRecord == null) throw new Error("Did not find item with data id ".concat(__id, " in the store."));
            updatableProxyRootRecord.setLinkedRecord(newValueRecord, selection.name, newVariables);
        }
    };
}
function $89789e6c33329f72$var$createGetterForPluralLinkedField(selection, variables, updatableProxyRootRecord, recordSourceProxy, missingFieldHandlers) {
    return function() {
        var _selection$args5;
        var newVariables = $89789e6c33329f72$var$getArgumentValues((_selection$args5 = selection.args) !== null && _selection$args5 !== void 0 ? _selection$args5 : [], variables);
        var linkedRecords = updatableProxyRootRecord.getLinkedRecords(selection.name, newVariables);
        if (linkedRecords === undefined) linkedRecords = $89789e6c33329f72$var$getPluralLinkedRecordUsingMissingFieldHandlers(selection, newVariables, updatableProxyRootRecord, recordSourceProxy, missingFieldHandlers);
        if (linkedRecords != null) return linkedRecords.map(function(linkedRecord) {
            if (linkedRecord != null) {
                var updatableProxy = {};
                $89789e6c33329f72$var$updateProxyFromSelections(updatableProxy, linkedRecord, variables, selection.selections, recordSourceProxy, missingFieldHandlers);
                return updatableProxy;
            } else return linkedRecord;
        });
        else return linkedRecords;
    };
}
function $89789e6c33329f72$var$createGetterForSingularLinkedField(selection, variables, updatableProxyRootRecord, recordSourceProxy, missingFieldHandlers) {
    return function() {
        var _selection$args6;
        var newVariables = $89789e6c33329f72$var$getArgumentValues((_selection$args6 = selection.args) !== null && _selection$args6 !== void 0 ? _selection$args6 : [], variables);
        var linkedRecord = updatableProxyRootRecord.getLinkedRecord(selection.name, newVariables);
        if (linkedRecord === undefined) linkedRecord = $89789e6c33329f72$var$getLinkedRecordUsingMissingFieldHandlers(selection, newVariables, updatableProxyRootRecord, recordSourceProxy, missingFieldHandlers);
        if (linkedRecord != null) {
            var updatableProxy = {};
            $89789e6c33329f72$var$updateProxyFromSelections(updatableProxy, linkedRecord, variables, selection.selections, recordSourceProxy, missingFieldHandlers);
            return updatableProxy;
        } else return linkedRecord;
    };
}
function $89789e6c33329f72$var$getLinkedRecordUsingMissingFieldHandlers(selection, newVariables, updatableProxyRootRecord, recordSourceProxy, missingFieldHandlers) {
    var _iterator2 = (0, $89789e6c33329f72$var$_createForOfIteratorHelper2["default"])(missingFieldHandlers), _step2;
    try {
        for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
            var handler = _step2.value;
            if (handler.kind === 'linked') {
                var newId = handler.handle(selection, updatableProxyRootRecord, newVariables, recordSourceProxy);
                if (newId != null) return recordSourceProxy.get(newId);
            }
        }
    } catch (err) {
        _iterator2.e(err);
    } finally{
        _iterator2.f();
    }
}
function $89789e6c33329f72$var$getPluralLinkedRecordUsingMissingFieldHandlers(selection, newVariables, updatableProxyRootRecord, recordSourceProxy, missingFieldHandlers) {
    var _iterator3 = (0, $89789e6c33329f72$var$_createForOfIteratorHelper2["default"])(missingFieldHandlers), _step3;
    try {
        for(_iterator3.s(); !(_step3 = _iterator3.n()).done;){
            var handler = _step3.value;
            if (handler.kind === 'pluralLinked') {
                var newIds = handler.handle(selection, updatableProxyRootRecord, newVariables, recordSourceProxy);
                if (newIds != null) return newIds.map(function(newId) {
                    if (newId != null) return recordSourceProxy.get(newId);
                });
            }
        }
    } catch (err) {
        _iterator3.e(err);
    } finally{
        _iterator3.f();
    }
}
function $89789e6c33329f72$var$getScalarUsingMissingFieldHandlers(selection, newVariables, updatableProxyRootRecord, recordSourceProxy, missingFieldHandlers) {
    var _iterator4 = (0, $89789e6c33329f72$var$_createForOfIteratorHelper2["default"])(missingFieldHandlers), _step4;
    try {
        for(_iterator4.s(); !(_step4 = _iterator4.n()).done;){
            var handler = _step4.value;
            if (handler.kind === 'scalar') {
                var value = handler.handle(selection, updatableProxyRootRecord, newVariables, recordSourceProxy);
                if (value !== undefined) return value;
            }
        }
    } catch (err) {
        _iterator4.e(err);
    } finally{
        _iterator4.f();
    }
}
module.exports = {
    createUpdatableProxy: $89789e6c33329f72$var$createUpdatableProxy
};

});


parcelRegister("fVSWx", function(module, exports) {
'use strict';

var $kLQDK = parcelRequire("kLQDK");
var $b996cc755a535157$var$getUpdatableQuery = $kLQDK.getUpdatableQuery;

var $bNKRh = parcelRequire("bNKRh");
var $b996cc755a535157$var$createUpdatableProxy = $bNKRh.createUpdatableProxy;
function $b996cc755a535157$var$readUpdatableQuery(query, variables, proxy, missingFieldHandlers) {
    var updatableQuery = $b996cc755a535157$var$getUpdatableQuery(query);
    return {
        updatableData: $b996cc755a535157$var$createUpdatableProxy(proxy.getRoot(), variables, updatableQuery.fragment.selections, proxy, missingFieldHandlers)
    };
}
module.exports = {
    readUpdatableQuery: $b996cc755a535157$var$readUpdatableQuery
};

});

parcelRegister("5pVY2", function(module, exports) {
'use strict';

var $9pidS = parcelRequire("9pidS");
var $3f1c40af2fd772a3$var$generateClientID = $9pidS.generateClientID;

var $ezyIu = parcelRequire("ezyIu");
var $3f1c40af2fd772a3$var$getStableStorageKey = $ezyIu.getStableStorageKey;

var $jSI6G = parcelRequire("jSI6G");
var $3f1c40af2fd772a3$var$RelayRecordProxy = /*#__PURE__*/ function() {
    function RelayRecordProxy(source, mutator, dataID) {
        this._dataID = dataID;
        this._mutator = mutator;
        this._source = source;
    }
    var _proto = RelayRecordProxy.prototype;
    _proto.copyFieldsFrom = function copyFieldsFrom(source) {
        this._mutator.copyFields(source.getDataID(), this._dataID);
    };
    _proto.getDataID = function getDataID() {
        return this._dataID;
    };
    _proto.getType = function getType() {
        var type = this._mutator.getType(this._dataID);
        !(type != null) && $jSI6G(false);
        return type;
    };
    _proto.getValue = function getValue(name, args) {
        var storageKey = $3f1c40af2fd772a3$var$getStableStorageKey(name, args);
        return this._mutator.getValue(this._dataID, storageKey);
    };
    _proto.setValue = function setValue(value, name, args, errors) {
        !$3f1c40af2fd772a3$var$isValidLeafValue(value) && $jSI6G(false);
        return this.setValue__UNSAFE(value, name, args, errors);
    };
    _proto.getErrors = function getErrors(name, args) {
        var storageKey = $3f1c40af2fd772a3$var$getStableStorageKey(name, args);
        return this._mutator.getErrors(this._dataID, storageKey);
    };
    _proto.setValue__UNSAFE = function setValue__UNSAFE(value, name, args, errors) {
        var storageKey = $3f1c40af2fd772a3$var$getStableStorageKey(name, args);
        this._mutator.setValue(this._dataID, storageKey, value);
        if (errors != null) {
            if (errors.length === 0) this._mutator.setErrors(this._dataID, storageKey);
            else this._mutator.setErrors(this._dataID, storageKey, errors);
        }
        return this;
    };
    _proto.getLinkedRecord = function getLinkedRecord(name, args) {
        var storageKey = $3f1c40af2fd772a3$var$getStableStorageKey(name, args);
        var linkedID = this._mutator.getLinkedRecordID(this._dataID, storageKey);
        return linkedID != null ? this._source.get(linkedID) : linkedID;
    };
    _proto.setLinkedRecord = function setLinkedRecord(record, name, args) {
        !(record instanceof RelayRecordProxy) && $jSI6G(false);
        var storageKey = $3f1c40af2fd772a3$var$getStableStorageKey(name, args);
        var linkedID = record.getDataID();
        this._mutator.setLinkedRecordID(this._dataID, storageKey, linkedID);
        return this;
    };
    _proto.getOrCreateLinkedRecord = function getOrCreateLinkedRecord(name, typeName, args) {
        var linkedRecord = this.getLinkedRecord(name, args);
        if (!linkedRecord) {
            var _this$_source$get;
            var storageKey = $3f1c40af2fd772a3$var$getStableStorageKey(name, args);
            var clientID = $3f1c40af2fd772a3$var$generateClientID(this.getDataID(), storageKey);
            linkedRecord = (_this$_source$get = this._source.get(clientID)) !== null && _this$_source$get !== void 0 ? _this$_source$get : this._source.create(clientID, typeName);
            this.setLinkedRecord(linkedRecord, name, args);
        }
        return linkedRecord;
    };
    _proto.getLinkedRecords = function getLinkedRecords(name, args) {
        var _this = this;
        var storageKey = $3f1c40af2fd772a3$var$getStableStorageKey(name, args);
        var linkedIDs = this._mutator.getLinkedRecordIDs(this._dataID, storageKey);
        if (linkedIDs == null) return linkedIDs;
        return linkedIDs.map(function(linkedID) {
            return linkedID != null ? _this._source.get(linkedID) : linkedID;
        });
    };
    _proto.setLinkedRecords = function setLinkedRecords(records, name, args) {
        !Array.isArray(records) && $jSI6G(false);
        var storageKey = $3f1c40af2fd772a3$var$getStableStorageKey(name, args);
        var linkedIDs = records.map(function(record) {
            return record && record.getDataID();
        });
        this._mutator.setLinkedRecordIDs(this._dataID, storageKey, linkedIDs);
        return this;
    };
    _proto.invalidateRecord = function invalidateRecord() {
        this._source.markIDForInvalidation(this._dataID);
    };
    return RelayRecordProxy;
}();
function $3f1c40af2fd772a3$var$isValidLeafValue(value) {
    return value == null || typeof value !== 'object' || Array.isArray(value) && value.every($3f1c40af2fd772a3$var$isValidLeafValue);
}
module.exports = $3f1c40af2fd772a3$var$RelayRecordProxy;

});


parcelRegister("4dqb0", function(module, exports) {
'use strict';

var $fT3Ou = parcelRequire("fT3Ou");
var $311cae6e88fd1be0$var$LINKED_FIELD = $fT3Ou.LINKED_FIELD;

var $ezyIu = parcelRequire("ezyIu");
var $311cae6e88fd1be0$var$getHandleStorageKey = $ezyIu.getHandleStorageKey;

var $bke7t = parcelRequire("bke7t");

var $jSI6G = parcelRequire("jSI6G");
function $311cae6e88fd1be0$var$cloneRelayHandleSourceField(handleField, selections, variables) {
    var sourceField = selections.find(function(source) {
        return source.kind === $311cae6e88fd1be0$var$LINKED_FIELD && source.name === handleField.name && source.alias === handleField.alias && $bke7t(source.args, handleField.args);
    });
    !(sourceField && sourceField.kind === $311cae6e88fd1be0$var$LINKED_FIELD) && $jSI6G(false);
    var handleKey = $311cae6e88fd1be0$var$getHandleStorageKey(handleField, variables);
    return {
        kind: 'LinkedField',
        alias: sourceField.alias,
        name: handleKey,
        storageKey: handleKey,
        args: null,
        concreteType: sourceField.concreteType,
        plural: sourceField.plural,
        selections: sourceField.selections
    };
}
module.exports = $311cae6e88fd1be0$var$cloneRelayHandleSourceField;

});

parcelRegister("aJaxb", function(module, exports) {
'use strict';

var $fT3Ou = parcelRequire("fT3Ou");
var $7cf6473f7382d381$var$SCALAR_FIELD = $fT3Ou.SCALAR_FIELD;

var $ezyIu = parcelRequire("ezyIu");
var $7cf6473f7382d381$var$getHandleStorageKey = $ezyIu.getHandleStorageKey;

var $bke7t = parcelRequire("bke7t");

var $jSI6G = parcelRequire("jSI6G");
function $7cf6473f7382d381$var$cloneRelayScalarHandleSourceField(handleField, selections, variables) {
    var sourceField = selections.find(function(source) {
        return source.kind === $7cf6473f7382d381$var$SCALAR_FIELD && source.name === handleField.name && source.alias === handleField.alias && $bke7t(source.args, handleField.args);
    });
    !(sourceField && sourceField.kind === $7cf6473f7382d381$var$SCALAR_FIELD) && $jSI6G(false);
    var handleKey = $7cf6473f7382d381$var$getHandleStorageKey(handleField, variables);
    return {
        kind: 'ScalarField',
        alias: sourceField.alias,
        name: handleKey,
        storageKey: handleKey,
        args: null
    };
}
module.exports = $7cf6473f7382d381$var$cloneRelayScalarHandleSourceField;

});


parcelRegister("izibt", function(module, exports) {
'use strict';

var $e27SU = parcelRequire("e27SU");
var $d84999d98a29e3f4$var$_interopRequireDefault = $e27SU.default;

var $d84999d98a29e3f4$var$_createForOfIteratorHelper2 = $d84999d98a29e3f4$var$_interopRequireDefault((parcelRequire("5dSyV")));

var $g0Xjw = parcelRequire("g0Xjw");

var $fT3Ou = parcelRequire("fT3Ou");
var $d84999d98a29e3f4$var$RELAY_LIVE_RESOLVER = $fT3Ou.RELAY_LIVE_RESOLVER;

var $gZYpt = parcelRequire("gZYpt");

var $41tOk = parcelRequire("41tOk");

var $9pidS = parcelRequire("9pidS");
var $d84999d98a29e3f4$var$generateClientID = $9pidS.generateClientID, $d84999d98a29e3f4$var$generateClientObjectClientID = $9pidS.generateClientObjectClientID;

var $7SC8Z = parcelRequire("7SC8Z");

var $iUq0k = parcelRequire("iUq0k");
var $d84999d98a29e3f4$var$createNormalizationSelector = $iUq0k.createNormalizationSelector;

var $3fbkc = parcelRequire("3fbkc");

var $4LqKJ = parcelRequire("4LqKJ");
var $d84999d98a29e3f4$var$normalize = $4LqKJ.normalize;

var $ezyIu = parcelRequire("ezyIu");
var $d84999d98a29e3f4$var$RELAY_RESOLVER_ERROR_KEY = $ezyIu.RELAY_RESOLVER_ERROR_KEY, $d84999d98a29e3f4$var$RELAY_RESOLVER_INVALIDATION_KEY = $ezyIu.RELAY_RESOLVER_INVALIDATION_KEY, $d84999d98a29e3f4$var$RELAY_RESOLVER_OUTPUT_TYPE_RECORD_IDS = $ezyIu.RELAY_RESOLVER_OUTPUT_TYPE_RECORD_IDS, $d84999d98a29e3f4$var$RELAY_RESOLVER_RECORD_TYPENAME = $ezyIu.RELAY_RESOLVER_RECORD_TYPENAME, $d84999d98a29e3f4$var$RELAY_RESOLVER_SNAPSHOT_KEY = $ezyIu.RELAY_RESOLVER_SNAPSHOT_KEY, $d84999d98a29e3f4$var$RELAY_RESOLVER_VALUE_KEY = $ezyIu.RELAY_RESOLVER_VALUE_KEY, $d84999d98a29e3f4$var$getReadTimeResolverStorageKey = $ezyIu.getReadTimeResolverStorageKey, $d84999d98a29e3f4$var$getStorageKey = $ezyIu.getStorageKey;

var $kjwqA = parcelRequire("kjwqA");

var $lRRo1 = parcelRequire("lRRo1");

var $fYxIJ = parcelRequire("fYxIJ");
var $d84999d98a29e3f4$var$isSuspenseSentinel = $fYxIJ.isSuspenseSentinel;

var $jSI6G = parcelRequire("jSI6G");
parcelRequire("2OmBw");
var $d84999d98a29e3f4$var$RELAY_RESOLVER_LIVE_STATE_SUBSCRIPTION_KEY = '__resolverLiveStateSubscription';
var $d84999d98a29e3f4$var$RELAY_RESOLVER_LIVE_STATE_VALUE = '__resolverLiveStateValue';
var $d84999d98a29e3f4$var$RELAY_RESOLVER_LIVE_STATE_DIRTY = '__resolverLiveStateDirty';
var $d84999d98a29e3f4$var$MODEL_PROPERTY_NAME = '__relay_model_instance';
function $d84999d98a29e3f4$var$addDependencyEdge(edges, from, to) {
    var set = edges.get(from);
    if (!set) {
        set = new Set();
        edges.set(from, set);
    }
    set.add(to);
}
var $d84999d98a29e3f4$var$LiveResolverCache = /*#__PURE__*/ function() {
    function LiveResolverCache(getRecordSource, store) {
        this._resolverIDToRecordIDs = new Map();
        this._recordIDToResolverIDs = new Map();
        this._getRecordSource = getRecordSource;
        this._store = store;
        this._handlingBatch = false;
        this._liveResolverBatchRecordSource = null;
    }
    var _proto = LiveResolverCache.prototype;
    _proto.readFromCacheOrEvaluate = function readFromCacheOrEvaluate(recordID, field, variables, evaluate, getDataForResolverFragment) {
        var recordSource = this._getRecordSource();
        var record = $d84999d98a29e3f4$var$expectRecord(recordSource, recordID);
        var storageKey = $d84999d98a29e3f4$var$getReadTimeResolverStorageKey(field, variables);
        var linkedID = $7SC8Z.getLinkedRecordID(record, storageKey);
        var linkedRecord = linkedID == null ? null : recordSource.get(linkedID);
        var updatedDataIDs;
        if (linkedRecord == null || this._isInvalid(linkedRecord, getDataForResolverFragment)) {
            var _linkedID;
            if (linkedRecord != null) $d84999d98a29e3f4$var$maybeUnsubscribeFromLiveState(linkedRecord);
            linkedID = (_linkedID = linkedID) !== null && _linkedID !== void 0 ? _linkedID : $d84999d98a29e3f4$var$generateClientID(recordID, storageKey);
            linkedRecord = $7SC8Z.create(linkedID, $d84999d98a29e3f4$var$RELAY_RESOLVER_RECORD_TYPENAME);
            var evaluationResult = evaluate();
            $7SC8Z.setValue(linkedRecord, $d84999d98a29e3f4$var$RELAY_RESOLVER_SNAPSHOT_KEY, evaluationResult.snapshot);
            $7SC8Z.setValue(linkedRecord, $d84999d98a29e3f4$var$RELAY_RESOLVER_ERROR_KEY, evaluationResult.error);
            if (field.kind === $d84999d98a29e3f4$var$RELAY_LIVE_RESOLVER) {
                if (evaluationResult.resolverResult != null) {
                    !(evaluationResult.error == null) && $jSI6G(false);
                    var liveState = evaluationResult.resolverResult;
                    updatedDataIDs = this._setLiveStateValue(linkedRecord, linkedID, liveState, field, variables);
                } else var _evaluationResult$sna;
            } else updatedDataIDs = this._setResolverValue(linkedRecord, evaluationResult.resolverResult, field, variables);
            recordSource.set(linkedID, linkedRecord);
            var currentRecord = $d84999d98a29e3f4$var$expectRecord(recordSource, recordID);
            var nextRecord = $7SC8Z.clone(currentRecord);
            $7SC8Z.setLinkedRecordID(nextRecord, storageKey, linkedID);
            recordSource.set(recordID, nextRecord);
            if (field.fragment != null) {
                var _evaluationResult$sna2;
                var fragmentStorageKey = $d84999d98a29e3f4$var$getStorageKey(field.fragment, variables);
                var resolverID = $d84999d98a29e3f4$var$generateClientID(recordID, fragmentStorageKey);
                $d84999d98a29e3f4$var$addDependencyEdge(this._resolverIDToRecordIDs, resolverID, linkedID);
                $d84999d98a29e3f4$var$addDependencyEdge(this._recordIDToResolverIDs, recordID, resolverID);
                var seenRecordIds = (_evaluationResult$sna2 = evaluationResult.snapshot) === null || _evaluationResult$sna2 === void 0 ? void 0 : _evaluationResult$sna2.seenRecords;
                if (seenRecordIds != null) {
                    var _iterator = (0, $d84999d98a29e3f4$var$_createForOfIteratorHelper2["default"])(seenRecordIds), _step;
                    try {
                        for(_iterator.s(); !(_step = _iterator.n()).done;){
                            var seenRecordID = _step.value;
                            $d84999d98a29e3f4$var$addDependencyEdge(this._recordIDToResolverIDs, seenRecordID, resolverID);
                        }
                    } catch (err) {
                        _iterator.e(err);
                    } finally{
                        _iterator.f();
                    }
                }
            }
        } else if (field.kind === $d84999d98a29e3f4$var$RELAY_LIVE_RESOLVER && $7SC8Z.getValue(linkedRecord, $d84999d98a29e3f4$var$RELAY_RESOLVER_LIVE_STATE_DIRTY)) {
            var _linkedID2;
            linkedID = (_linkedID2 = linkedID) !== null && _linkedID2 !== void 0 ? _linkedID2 : $d84999d98a29e3f4$var$generateClientID(recordID, storageKey);
            linkedRecord = $7SC8Z.clone(linkedRecord);
            var _liveState = $7SC8Z.getValue(linkedRecord, $d84999d98a29e3f4$var$RELAY_RESOLVER_LIVE_STATE_VALUE);
            if (!$lRRo1(_liveState)) $jSI6G(false);
            updatedDataIDs = this._setLiveResolverValue(linkedRecord, _liveState, field, variables);
            $7SC8Z.setValue(linkedRecord, $d84999d98a29e3f4$var$RELAY_RESOLVER_LIVE_STATE_DIRTY, false);
            recordSource.set(linkedID, linkedRecord);
        }
        var answer = this._getResolverValue(linkedRecord);
        var snapshot = $7SC8Z.getValue(linkedRecord, $d84999d98a29e3f4$var$RELAY_RESOLVER_SNAPSHOT_KEY);
        var error = $7SC8Z.getValue(linkedRecord, $d84999d98a29e3f4$var$RELAY_RESOLVER_ERROR_KEY);
        var suspenseID = null;
        if ($d84999d98a29e3f4$var$isSuspenseSentinel(answer)) {
            var _linkedID3;
            suspenseID = (_linkedID3 = linkedID) !== null && _linkedID3 !== void 0 ? _linkedID3 : $d84999d98a29e3f4$var$generateClientID(recordID, storageKey);
        }
        return [
            answer,
            linkedID,
            error,
            snapshot,
            suspenseID,
            updatedDataIDs
        ];
    };
    _proto.getLiveResolverPromise = function getLiveResolverPromise(liveStateID) {
        var recordSource = this._getRecordSource();
        var liveStateRecord = recordSource.get(liveStateID);
        !(liveStateRecord != null) && $jSI6G(false);
        var liveState = $7SC8Z.getValue(liveStateRecord, $d84999d98a29e3f4$var$RELAY_RESOLVER_LIVE_STATE_VALUE);
        return new Promise(function(resolve) {
            var unsubscribe = liveState.subscribe(function() {
                unsubscribe();
                resolve();
            });
        });
    };
    _proto._setLiveStateValue = function _setLiveStateValue(linkedRecord, linkedID, liveState, field, variables) {
        var handler = this._makeLiveStateHandler(linkedID);
        var unsubscribe = liveState.subscribe(handler);
        $7SC8Z.setValue(linkedRecord, $d84999d98a29e3f4$var$RELAY_RESOLVER_LIVE_STATE_VALUE, liveState);
        var updatedDataIDs = this._setLiveResolverValue(linkedRecord, liveState, field, variables);
        $7SC8Z.setValue(linkedRecord, $d84999d98a29e3f4$var$RELAY_RESOLVER_LIVE_STATE_DIRTY, false);
        $7SC8Z.setValue(linkedRecord, $d84999d98a29e3f4$var$RELAY_RESOLVER_LIVE_STATE_SUBSCRIPTION_KEY, unsubscribe);
        return updatedDataIDs;
    };
    _proto._makeLiveStateHandler = function _makeLiveStateHandler(linkedID) {
        var _this = this;
        return function() {
            var currentSource = _this._getRecordSource();
            var currentRecord = currentSource.get(linkedID);
            if (!currentRecord) return;
            if (!$7SC8Z.hasValue(currentRecord, $d84999d98a29e3f4$var$RELAY_RESOLVER_LIVE_STATE_VALUE)) return;
            var nextRecord = $7SC8Z.clone(currentRecord);
            $7SC8Z.setValue(nextRecord, $d84999d98a29e3f4$var$RELAY_RESOLVER_LIVE_STATE_DIRTY, true);
            _this._setLiveResolverUpdate(linkedID, nextRecord);
        };
    };
    _proto._setLiveResolverUpdate = function _setLiveResolverUpdate(linkedId, record) {
        if (this._handlingBatch) {
            if (this._liveResolverBatchRecordSource == null) this._liveResolverBatchRecordSource = $3fbkc.create();
            this._liveResolverBatchRecordSource.set(linkedId, record);
        } else {
            var nextSource = $3fbkc.create();
            nextSource.set(linkedId, record);
            this._store.publish(nextSource);
            this._store.notify();
        }
    };
    _proto.batchLiveStateUpdates = function batchLiveStateUpdates(callback) {
        !!this._handlingBatch && $jSI6G(false);
        this._handlingBatch = true;
        try {
            callback();
        } finally{
            if (this._liveResolverBatchRecordSource != null) {
                this._store.publish(this._liveResolverBatchRecordSource);
                this._store.notify();
            }
            this._liveResolverBatchRecordSource = null;
            this._handlingBatch = false;
        }
    };
    _proto.batchLiveStateUpdatesWithoutNotify = function batchLiveStateUpdatesWithoutNotify(callback) {
        !!this._handlingBatch && $jSI6G(false);
        this._handlingBatch = true;
        try {
            callback();
        } finally{
            var shouldPublish = this._liveResolverBatchRecordSource != null;
            if (shouldPublish) this._store.publish(this._liveResolverBatchRecordSource);
            this._liveResolverBatchRecordSource = null;
            this._handlingBatch = false;
            return shouldPublish;
        }
    };
    _proto._setLiveResolverValue = function _setLiveResolverValue(resolverRecord, liveValue, field, variables) {
        var value = null;
        var resolverError = null;
        try {
            value = liveValue.read();
        } catch (e) {
            resolverError = e;
        }
        $7SC8Z.setValue(resolverRecord, $d84999d98a29e3f4$var$RELAY_RESOLVER_ERROR_KEY, resolverError);
        return this._setResolverValue(resolverRecord, value, field, variables);
    };
    _proto._setResolverValue = function _setResolverValue(resolverRecord, value, field, variables) {
        var normalizationInfo = field.normalizationInfo;
        var updatedDataIDs = null;
        if (value != null && normalizationInfo != null && !$d84999d98a29e3f4$var$isSuspenseSentinel(value)) {
            var resolverValue;
            var prevOutputTypeRecordIDs = $kjwqA(resolverRecord);
            var nextOutputTypeRecordIDs = new Set();
            var currentSource = this._getRecordSource();
            if (normalizationInfo.plural) {
                !Array.isArray(value) && $jSI6G(false);
                resolverValue = [];
                var nextSource = $3fbkc.create();
                for(var ii = 0; ii < value.length; ii++){
                    var currentValue = value[ii];
                    if (currentValue == null) continue;
                    !(typeof currentValue === 'object') && $jSI6G(false);
                    var typename = $d84999d98a29e3f4$var$getConcreteTypename(normalizationInfo, currentValue);
                    var outputTypeDataID = $d84999d98a29e3f4$var$generateClientObjectClientID(typename, $7SC8Z.getDataID(resolverRecord), ii);
                    var source = this._normalizeOutputTypeValue(outputTypeDataID, currentValue, variables, normalizationInfo, [
                        field.path,
                        String(ii)
                    ], typename);
                    var _iterator2 = (0, $d84999d98a29e3f4$var$_createForOfIteratorHelper2["default"])(source.getRecordIDs()), _step2;
                    try {
                        for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                            var recordID = _step2.value;
                            nextSource.set(recordID, $d84999d98a29e3f4$var$expectRecord(source, recordID));
                            nextOutputTypeRecordIDs.add(recordID);
                        }
                    } catch (err) {
                        _iterator2.e(err);
                    } finally{
                        _iterator2.f();
                    }
                    resolverValue.push(outputTypeDataID);
                }
                updatedDataIDs = $d84999d98a29e3f4$var$updateCurrentSource(currentSource, nextSource, prevOutputTypeRecordIDs);
            } else {
                !(typeof value === 'object') && $jSI6G(false);
                var _typename = $d84999d98a29e3f4$var$getConcreteTypename(normalizationInfo, value);
                var _outputTypeDataID = $d84999d98a29e3f4$var$generateClientObjectClientID(_typename, $7SC8Z.getDataID(resolverRecord));
                var _nextSource = this._normalizeOutputTypeValue(_outputTypeDataID, value, variables, normalizationInfo, [
                    field.path
                ], _typename);
                var _iterator3 = (0, $d84999d98a29e3f4$var$_createForOfIteratorHelper2["default"])(_nextSource.getRecordIDs()), _step3;
                try {
                    for(_iterator3.s(); !(_step3 = _iterator3.n()).done;){
                        var _recordID = _step3.value;
                        nextOutputTypeRecordIDs.add(_recordID);
                    }
                } catch (err) {
                    _iterator3.e(err);
                } finally{
                    _iterator3.f();
                }
                resolverValue = _outputTypeDataID;
                updatedDataIDs = $d84999d98a29e3f4$var$updateCurrentSource(currentSource, _nextSource, prevOutputTypeRecordIDs);
            }
            $7SC8Z.setValue(resolverRecord, $d84999d98a29e3f4$var$RELAY_RESOLVER_OUTPUT_TYPE_RECORD_IDS, nextOutputTypeRecordIDs);
            $41tOk(resolverValue);
            $7SC8Z.setValue(resolverRecord, $d84999d98a29e3f4$var$RELAY_RESOLVER_VALUE_KEY, resolverValue);
        } else {
            $41tOk(value);
            $7SC8Z.setValue(resolverRecord, $d84999d98a29e3f4$var$RELAY_RESOLVER_VALUE_KEY, value);
            $7SC8Z.setValue(resolverRecord, $d84999d98a29e3f4$var$RELAY_RESOLVER_OUTPUT_TYPE_RECORD_IDS, new Set());
        }
        return updatedDataIDs;
    };
    _proto.notifyUpdatedSubscribers = function notifyUpdatedSubscribers(updatedDataIDs) {
        this._store.__notifyUpdatedSubscribers(updatedDataIDs);
    };
    _proto._getResolverValue = function _getResolverValue(resolverRecord) {
        return $7SC8Z.getValue(resolverRecord, $d84999d98a29e3f4$var$RELAY_RESOLVER_VALUE_KEY);
    };
    _proto.invalidateDataIDs = function invalidateDataIDs(updatedDataIDs) {
        var recordSource = this._getRecordSource();
        var visited = new Set();
        var recordsToVisit = Array.from(updatedDataIDs);
        while(recordsToVisit.length){
            var recordID = recordsToVisit.pop();
            visited.add(recordID);
            updatedDataIDs.add(recordID);
            var fragmentSet = this._recordIDToResolverIDs.get(recordID);
            if (fragmentSet == null) continue;
            var _iterator4 = (0, $d84999d98a29e3f4$var$_createForOfIteratorHelper2["default"])(fragmentSet), _step4;
            try {
                for(_iterator4.s(); !(_step4 = _iterator4.n()).done;){
                    var fragment = _step4.value;
                    if (!visited.has(fragment)) {
                        visited.add(fragment);
                        var recordSet = this._resolverIDToRecordIDs.get(fragment);
                        if (recordSet == null) continue;
                        var _iterator5 = (0, $d84999d98a29e3f4$var$_createForOfIteratorHelper2["default"])(recordSet), _step5;
                        try {
                            for(_iterator5.s(); !(_step5 = _iterator5.n()).done;){
                                var anotherRecordID = _step5.value;
                                $d84999d98a29e3f4$var$markInvalidatedResolverRecord(anotherRecordID, recordSource);
                                if (!visited.has(anotherRecordID)) {
                                    visited.add(anotherRecordID);
                                    recordsToVisit.push(anotherRecordID);
                                }
                            }
                        } catch (err) {
                            _iterator5.e(err);
                        } finally{
                            _iterator5.f();
                        }
                    }
                }
            } catch (err) {
                _iterator4.e(err);
            } finally{
                _iterator4.f();
            }
        }
    };
    _proto._isInvalid = function _isInvalid(record, getDataForResolverFragment) {
        if (!$7SC8Z.getValue(record, $d84999d98a29e3f4$var$RELAY_RESOLVER_INVALIDATION_KEY)) return false;
        var snapshot = $7SC8Z.getValue(record, $d84999d98a29e3f4$var$RELAY_RESOLVER_SNAPSHOT_KEY);
        var originalInputs = snapshot === null || snapshot === void 0 ? void 0 : snapshot.data;
        var readerSelector = snapshot === null || snapshot === void 0 ? void 0 : snapshot.selector;
        if (originalInputs == null || readerSelector == null) return true;
        var _getDataForResolverFr = getDataForResolverFragment(readerSelector), latestValues = _getDataForResolverFr.data;
        var recycled = $g0Xjw(originalInputs, latestValues);
        if (recycled !== originalInputs) return true;
        if ($gZYpt.MARK_RESOLVER_VALUES_AS_CLEAN_AFTER_FRAGMENT_REREAD) {
            var nextRecord = $7SC8Z.clone(record);
            $7SC8Z.setValue(nextRecord, $d84999d98a29e3f4$var$RELAY_RESOLVER_INVALIDATION_KEY, false);
            var recordSource = this._getRecordSource();
            recordSource.set($7SC8Z.getDataID(record), nextRecord);
        }
        return false;
    };
    _proto._normalizeOutputTypeValue = function _normalizeOutputTypeValue(outputTypeDataID, value, variables, normalizationInfo, fieldPath, typename) {
        var source = $3fbkc.create();
        switch(normalizationInfo.kind){
            case 'OutputType':
                var record = $7SC8Z.create(outputTypeDataID, typename);
                source.set(outputTypeDataID, record);
                var selector = $d84999d98a29e3f4$var$createNormalizationSelector(normalizationInfo.normalizationNode, outputTypeDataID, variables);
                var useExecTimeResolvers = false;
                var normalizationOptions = this._store.__getNormalizationOptions(fieldPath);
                return $d84999d98a29e3f4$var$normalize(source, selector, value, normalizationOptions, undefined, useExecTimeResolvers).source;
            case 'WeakModel':
                var _record = $7SC8Z.create(outputTypeDataID, typename);
                $7SC8Z.setValue(_record, $d84999d98a29e3f4$var$MODEL_PROPERTY_NAME, value);
                source.set(outputTypeDataID, _record);
                return source;
            default:
                normalizationInfo.kind;
                $jSI6G(false);
        }
    };
    _proto.ensureClientRecord = function ensureClientRecord(id, typeName) {
        var key = $d84999d98a29e3f4$var$generateClientObjectClientID(typeName, id);
        var recordSource = this._getRecordSource();
        if (!recordSource.has(key)) {
            var newRecord = $7SC8Z.create(key, typeName);
            $7SC8Z.setValue(newRecord, 'id', id);
            recordSource.set(key, newRecord);
        }
        return key;
    };
    _proto.unsubscribeFromLiveResolverRecords = function unsubscribeFromLiveResolverRecords(invalidatedDataIDs) {
        return $d84999d98a29e3f4$var$unsubscribeFromLiveResolverRecordsImpl(this._getRecordSource(), invalidatedDataIDs);
    };
    _proto.invalidateResolverRecords = function invalidateResolverRecords(invalidatedDataIDs) {
        if (invalidatedDataIDs.size === 0) return;
        var _iterator6 = (0, $d84999d98a29e3f4$var$_createForOfIteratorHelper2["default"])(invalidatedDataIDs), _step6;
        try {
            for(_iterator6.s(); !(_step6 = _iterator6.n()).done;){
                var dataID = _step6.value;
                var record = this._getRecordSource().get(dataID);
                if (record != null && $d84999d98a29e3f4$var$isResolverRecord(record)) this._getRecordSource()["delete"](dataID);
            }
        } catch (err) {
            _iterator6.e(err);
        } finally{
            _iterator6.f();
        }
    };
    return LiveResolverCache;
}();
function $d84999d98a29e3f4$var$updateCurrentSource(currentSource, nextSource, prevOutputTypeRecordIDs) {
    var updatedDataIDs = new Set();
    if (prevOutputTypeRecordIDs != null) {
        var _iterator7 = (0, $d84999d98a29e3f4$var$_createForOfIteratorHelper2["default"])(prevOutputTypeRecordIDs), _step7;
        try {
            for(_iterator7.s(); !(_step7 = _iterator7.n()).done;){
                var recordID = _step7.value;
                if (!nextSource.has(recordID)) {
                    updatedDataIDs.add(recordID);
                    currentSource.remove(recordID);
                }
            }
        } catch (err) {
            _iterator7.e(err);
        } finally{
            _iterator7.f();
        }
    }
    var _iterator8 = (0, $d84999d98a29e3f4$var$_createForOfIteratorHelper2["default"])(nextSource.getRecordIDs()), _step8;
    try {
        for(_iterator8.s(); !(_step8 = _iterator8.n()).done;){
            var _recordID2 = _step8.value;
            var nextRecord = $d84999d98a29e3f4$var$expectRecord(nextSource, _recordID2);
            if (currentSource.has(_recordID2)) {
                var currentRecord = $d84999d98a29e3f4$var$expectRecord(currentSource, _recordID2);
                var updatedRecord = $7SC8Z.update(currentRecord, nextRecord);
                if (updatedRecord !== currentRecord) {
                    updatedDataIDs.add(_recordID2);
                    currentSource.set(_recordID2, updatedRecord);
                    $d84999d98a29e3f4$var$markInvalidatedLinkedResolverRecords(currentRecord, currentSource);
                }
            } else currentSource.set(_recordID2, nextRecord);
        }
    } catch (err) {
        _iterator8.e(err);
    } finally{
        _iterator8.f();
    }
    return updatedDataIDs;
}
function $d84999d98a29e3f4$var$getAllLinkedRecordIds(record) {
    var linkedRecordIDs = new Set();
    $7SC8Z.getFields(record).forEach(function(field) {
        if ($7SC8Z.hasLinkedRecordID(record, field)) {
            var linkedRecordID = $7SC8Z.getLinkedRecordID(record, field);
            if (linkedRecordID != null) linkedRecordIDs.add(linkedRecordID);
        } else if ($7SC8Z.hasLinkedRecordIDs(record, field)) {
            var _RelayModernRecord$ge;
            (_RelayModernRecord$ge = $7SC8Z.getLinkedRecordIDs(record, field)) === null || _RelayModernRecord$ge === void 0 || _RelayModernRecord$ge.forEach(function(linkedRecordID) {
                if (linkedRecordID != null) linkedRecordIDs.add(linkedRecordID);
            });
        }
    });
    return linkedRecordIDs;
}
function $d84999d98a29e3f4$var$markInvalidatedResolverRecord(dataID, recordSource) {
    var record = recordSource.get(dataID);
    if (!record) return;
    var nextRecord = $7SC8Z.clone(record);
    $7SC8Z.setValue(nextRecord, $d84999d98a29e3f4$var$RELAY_RESOLVER_INVALIDATION_KEY, true);
    recordSource.set(dataID, nextRecord);
}
function $d84999d98a29e3f4$var$markInvalidatedLinkedResolverRecords(record, recordSource) {
    var currentLinkedDataIDs = $d84999d98a29e3f4$var$getAllLinkedRecordIds(record);
    var _iterator9 = (0, $d84999d98a29e3f4$var$_createForOfIteratorHelper2["default"])(currentLinkedDataIDs), _step9;
    try {
        for(_iterator9.s(); !(_step9 = _iterator9.n()).done;){
            var recordID = _step9.value;
            var _record2 = recordSource.get(recordID);
            if (_record2 != null && $d84999d98a29e3f4$var$isResolverRecord(_record2)) $d84999d98a29e3f4$var$markInvalidatedResolverRecord(recordID, recordSource);
        }
    } catch (err) {
        _iterator9.e(err);
    } finally{
        _iterator9.f();
    }
}
function $d84999d98a29e3f4$var$unsubscribeFromLiveResolverRecordsImpl(recordSource, invalidatedDataIDs) {
    if (invalidatedDataIDs.size === 0) return;
    var _iterator0 = (0, $d84999d98a29e3f4$var$_createForOfIteratorHelper2["default"])(invalidatedDataIDs), _step0;
    try {
        for(_iterator0.s(); !(_step0 = _iterator0.n()).done;){
            var dataID = _step0.value;
            var record = recordSource.get(dataID);
            if (record != null && $d84999d98a29e3f4$var$isResolverRecord(record)) $d84999d98a29e3f4$var$maybeUnsubscribeFromLiveState(record);
        }
    } catch (err) {
        _iterator0.e(err);
    } finally{
        _iterator0.f();
    }
}
function $d84999d98a29e3f4$var$isResolverRecord(record) {
    return $7SC8Z.getType(record) === $d84999d98a29e3f4$var$RELAY_RESOLVER_RECORD_TYPENAME;
}
function $d84999d98a29e3f4$var$maybeUnsubscribeFromLiveState(linkedRecord) {
    var previousUnsubscribe = $7SC8Z.getValue(linkedRecord, $d84999d98a29e3f4$var$RELAY_RESOLVER_LIVE_STATE_SUBSCRIPTION_KEY);
    if (previousUnsubscribe != null) previousUnsubscribe();
}
function $d84999d98a29e3f4$var$expectRecord(source, recordID) {
    var record = source.get(recordID);
    !(record != null) && $jSI6G(false);
    return record;
}
function $d84999d98a29e3f4$var$getUpdatedDataIDs(updatedRecords) {
    return updatedRecords;
}
function $d84999d98a29e3f4$var$getConcreteTypename(normalizationInfo, currentValue) {
    var _normalizationInfo$co;
    var typename = (_normalizationInfo$co = normalizationInfo.concreteType) !== null && _normalizationInfo$co !== void 0 ? _normalizationInfo$co : currentValue.__typename;
    !(typename != null) && $jSI6G(false);
    return typename;
}
module.exports = {
    LiveResolverCache: $d84999d98a29e3f4$var$LiveResolverCache,
    RELAY_RESOLVER_LIVE_STATE_SUBSCRIPTION_KEY: $d84999d98a29e3f4$var$RELAY_RESOLVER_LIVE_STATE_SUBSCRIPTION_KEY,
    getUpdatedDataIDs: $d84999d98a29e3f4$var$getUpdatedDataIDs
};

});
parcelRegister("41tOk", function(module, exports) {
'use strict';
module.exports = function shallowFreeze(value) {
    if (typeof value === 'object' && value != null && (Array.isArray(value) || value.constructor === Object)) Object.freeze(value);
};

});

parcelRegister("kjwqA", function(module, exports) {
'use strict';

var $7SC8Z = parcelRequire("7SC8Z");

var $ezyIu = parcelRequire("ezyIu");
var $ec9ebc7c11b774eb$var$RELAY_RESOLVER_OUTPUT_TYPE_RECORD_IDS = $ezyIu.RELAY_RESOLVER_OUTPUT_TYPE_RECORD_IDS;

var $jSI6G = parcelRequire("jSI6G");
function $ec9ebc7c11b774eb$var$getOutputTypeRecordIDs(record) {
    var maybeOutputTypeRecordIDs = $7SC8Z.getValue(record, $ec9ebc7c11b774eb$var$RELAY_RESOLVER_OUTPUT_TYPE_RECORD_IDS);
    if (maybeOutputTypeRecordIDs == null) return null;
    !(maybeOutputTypeRecordIDs instanceof Set) && $jSI6G(false);
    return maybeOutputTypeRecordIDs;
}
module.exports = $ec9ebc7c11b774eb$var$getOutputTypeRecordIDs;

});

parcelRegister("lRRo1", function(module, exports) {
'use strict';
function $feb7f5ac1d1b1432$var$isLiveStateValue(v) {
    return v != null && typeof v === 'object' && typeof v.read === 'function' && typeof v.subscribe === 'function';
}
module.exports = $feb7f5ac1d1b1432$var$isLiveStateValue;

});


parcelRegister("5QfIo", function(module, exports) {
'use strict';

var $e27SU = parcelRequire("e27SU");
var $440dffc0a8f6195f$var$_interopRequireDefault = $e27SU.default;

var $440dffc0a8f6195f$var$_objectSpread2 = $440dffc0a8f6195f$var$_interopRequireDefault((parcelRequire("caqem")));

var $7SC8Z = parcelRequire("7SC8Z");

var $3fbkc = parcelRequire("3fbkc");

var $jSI6G = parcelRequire("jSI6G");
var $440dffc0a8f6195f$var$UNPUBLISH_RECORD_SENTINEL = $7SC8Z.fromObject(Object.freeze({
    __UNPUBLISH_RECORD_SENTINEL: true
}));
var $440dffc0a8f6195f$var$RelayOptimisticRecordSource = /*#__PURE__*/ function() {
    function RelayOptimisticRecordSource(base) {
        this._base = base;
        this._sink = $3fbkc.create();
    }
    var _proto = RelayOptimisticRecordSource.prototype;
    _proto.has = function has(dataID) {
        if (this._sink.has(dataID)) {
            var sinkRecord = this._sink.get(dataID);
            return sinkRecord !== $440dffc0a8f6195f$var$UNPUBLISH_RECORD_SENTINEL;
        } else return this._base.has(dataID);
    };
    _proto.get = function get(dataID) {
        if (this._sink.has(dataID)) {
            var sinkRecord = this._sink.get(dataID);
            if (sinkRecord === $440dffc0a8f6195f$var$UNPUBLISH_RECORD_SENTINEL) return undefined;
            else return sinkRecord;
        } else return this._base.get(dataID);
    };
    _proto.getStatus = function getStatus(dataID) {
        var record = this.get(dataID);
        if (record === undefined) return 'UNKNOWN';
        else if (record === null) return 'NONEXISTENT';
        else return 'EXISTENT';
    };
    _proto.clear = function clear() {
        this._base = $3fbkc.create();
        this._sink.clear();
    };
    _proto["delete"] = function _delete(dataID) {
        this._sink["delete"](dataID);
    };
    _proto.remove = function remove(dataID) {
        this._sink.set(dataID, $440dffc0a8f6195f$var$UNPUBLISH_RECORD_SENTINEL);
    };
    _proto.set = function set(dataID, record) {
        this._sink.set(dataID, record);
    };
    _proto.getRecordIDs = function getRecordIDs() {
        return Object.keys(this.toJSON());
    };
    _proto.size = function size() {
        return Object.keys(this.toJSON()).length;
    };
    _proto.toJSON = function toJSON() {
        var _this = this;
        var merged = (0, $440dffc0a8f6195f$var$_objectSpread2["default"])({}, this._base.toJSON());
        this._sink.getRecordIDs().forEach(function(dataID) {
            var record = _this.get(dataID);
            if (record === undefined) delete merged[dataID];
            else merged[dataID] = $7SC8Z.toJSON(record);
        });
        return merged;
    };
    _proto.getOptimisticRecordIDs = function getOptimisticRecordIDs() {
        return new Set(this._sink.getRecordIDs());
    };
    return RelayOptimisticRecordSource;
}();
function $440dffc0a8f6195f$var$create(base) {
    return new $440dffc0a8f6195f$var$RelayOptimisticRecordSource(base);
}
function $440dffc0a8f6195f$var$getOptimisticRecordIDs(source) {
    !(source instanceof $440dffc0a8f6195f$var$RelayOptimisticRecordSource) && $jSI6G(false);
    return source.getOptimisticRecordIDs();
}
module.exports = {
    create: $440dffc0a8f6195f$var$create,
    getOptimisticRecordIDs: $440dffc0a8f6195f$var$getOptimisticRecordIDs
};

});

parcelRegister("4SqFT", function(module, exports) {
'use strict';

var $e27SU = parcelRequire("e27SU");
var $38d0e5a20f326490$var$_interopRequireDefault = $e27SU.default;

var $38d0e5a20f326490$var$_objectSpread2 = $38d0e5a20f326490$var$_interopRequireDefault((parcelRequire("caqem")));

var $38d0e5a20f326490$var$_defineProperty2 = $38d0e5a20f326490$var$_interopRequireDefault((parcelRequire("2JBpp")));

var $38d0e5a20f326490$var$_objectWithoutPropertiesLoose2 = $38d0e5a20f326490$var$_interopRequireDefault((parcelRequire("l9EoL")));

var $38d0e5a20f326490$var$_toConsumableArray2 = $38d0e5a20f326490$var$_interopRequireDefault((parcelRequire("lLsx3")));
var $38d0e5a20f326490$var$_excluded = [
    "message"
];

var $gZYpt = parcelRequire("gZYpt");

var $fYxIJ = parcelRequire("fYxIJ");
var $38d0e5a20f326490$var$isSuspenseSentinel = $fYxIJ.isSuspenseSentinel;

var $adnaT = parcelRequire("adnaT");

var $7SC8Z = parcelRequire("7SC8Z");

var $ezyIu = parcelRequire("ezyIu");
var $38d0e5a20f326490$var$CLIENT_EDGE_TRAVERSAL_PATH = $ezyIu.CLIENT_EDGE_TRAVERSAL_PATH, $38d0e5a20f326490$var$FIELD_GRANULAR_NOTIFICATIONS_KEY = $ezyIu.FIELD_GRANULAR_NOTIFICATIONS_KEY, $38d0e5a20f326490$var$FRAGMENT_OWNER_KEY = $ezyIu.FRAGMENT_OWNER_KEY, $38d0e5a20f326490$var$FRAGMENT_PROP_NAME_KEY = $ezyIu.FRAGMENT_PROP_NAME_KEY, $38d0e5a20f326490$var$FRAGMENTS_KEY = $ezyIu.FRAGMENTS_KEY, $38d0e5a20f326490$var$ID_KEY = $ezyIu.ID_KEY, $38d0e5a20f326490$var$MODULE_COMPONENT_KEY = $ezyIu.MODULE_COMPONENT_KEY, $38d0e5a20f326490$var$ROOT_ID = $ezyIu.ROOT_ID, $38d0e5a20f326490$var$getArgumentValues = $ezyIu.getArgumentValues, $38d0e5a20f326490$var$getFieldNotificationKey = $ezyIu.getFieldNotificationKey, $38d0e5a20f326490$var$getModuleComponentKey = $ezyIu.getModuleComponentKey, $38d0e5a20f326490$var$getStorageKey = $ezyIu.getStorageKey;

var $835Zq = parcelRequire("835Zq");
var $38d0e5a20f326490$var$NoopResolverCache = $835Zq.NoopResolverCache;

var $hOB00 = parcelRequire("hOB00");
var $38d0e5a20f326490$var$RESOLVER_FRAGMENT_ERRORED_SENTINEL = $hOB00.RESOLVER_FRAGMENT_ERRORED_SENTINEL, $38d0e5a20f326490$var$withResolverContext = $hOB00.withResolverContext;

var $enqEM = parcelRequire("enqEM");
var $38d0e5a20f326490$var$generateTypeID = $enqEM.generateTypeID;

var $jSI6G = parcelRequire("jSI6G");
function $38d0e5a20f326490$var$read(recordSource, selector, log, resolverCache, resolverContext) {
    var reader = new $38d0e5a20f326490$var$RelayReader(recordSource, selector, log, resolverCache !== null && resolverCache !== void 0 ? resolverCache : new $38d0e5a20f326490$var$NoopResolverCache(), resolverContext);
    return reader.read();
}
var $38d0e5a20f326490$var$RelayReader = /*#__PURE__*/ function() {
    function RelayReader(recordSource, selector, log, resolverCache, resolverContext) {
        var _selector$clientEdgeT, _ref, _this$_owner$node$ope, _this$_owner$node$ope2;
        this._clientEdgeTraversalPath = (_selector$clientEdgeT = selector.clientEdgeTraversalPath) !== null && _selector$clientEdgeT !== void 0 && _selector$clientEdgeT.length ? (0, $38d0e5a20f326490$var$_toConsumableArray2["default"])(selector.clientEdgeTraversalPath) : [];
        this._missingClientEdges = [];
        this._missingLiveResolverFields = [];
        this._isMissingData = false;
        this._isWithinUnmatchedTypeRefinement = false;
        this._fieldErrors = null;
        this._fieldGranularNotificationDataID = null;
        this._owner = selector.owner;
        this._useExecTimeResolvers = (_ref = (_this$_owner$node$ope = this._owner.node.operation.use_exec_time_resolvers) !== null && _this$_owner$node$ope !== void 0 ? _this$_owner$node$ope : ((_this$_owner$node$ope2 = this._owner.node.operation.exec_time_resolvers_enabled_provider) === null || _this$_owner$node$ope2 === void 0 ? void 0 : _this$_owner$node$ope2.get()) === true) !== null && _ref !== void 0 ? _ref : false;
        this._recordSource = recordSource;
        this._seenRecords = new Set();
        this._selector = selector;
        this._variables = selector.variables;
        this._resolverCache = resolverCache;
        this._fragmentName = selector.node.name;
        this._updatedDataIDs = new Set();
        this._resolverContext = resolverContext;
        this._log = log;
    }
    var _proto = RelayReader.prototype;
    _proto.read = function read() {
        var _this$_selector$node$;
        var _this$_selector = this._selector, node = _this$_selector.node, dataID = _this$_selector.dataID, isWithinUnmatchedTypeRefinement = _this$_selector.isWithinUnmatchedTypeRefinement;
        var abstractKey = node.abstractKey;
        var record = this._recordSource.get(dataID);
        var isDataExpectedToBePresent = !isWithinUnmatchedTypeRefinement;
        if (isDataExpectedToBePresent && abstractKey == null && record != null) {
            if (!this._recordMatchesTypeCondition(record, node.type)) isDataExpectedToBePresent = false;
        }
        if (isDataExpectedToBePresent && abstractKey != null && record != null) {
            var implementsInterface = this._implementsInterface(record, abstractKey);
            if (implementsInterface === false) isDataExpectedToBePresent = false;
        }
        this._isWithinUnmatchedTypeRefinement = !isDataExpectedToBePresent;
        var data = this._traverse(node, dataID, null);
        var catchTo = (_this$_selector$node$ = this._selector.node.metadata) === null || _this$_selector$node$ === void 0 ? void 0 : _this$_selector$node$.catchTo;
        if (catchTo != null) data = this._catchErrors(data, catchTo, null);
        if (this._updatedDataIDs.size > 0) {
            this._resolverCache.notifyUpdatedSubscribers(this._updatedDataIDs);
            this._updatedDataIDs.clear();
        }
        if ($gZYpt.ENABLE_READER_FRAGMENTS_LOGGING) {
            var _this$_log;
            (_this$_log = this._log) === null || _this$_log === void 0 || _this$_log.call(this, {
                name: 'reader.read',
                selector: this._selector
            });
        }
        return {
            data: data,
            fieldErrors: this._fieldErrors,
            isMissingData: this._isMissingData && isDataExpectedToBePresent,
            missingClientEdges: this._missingClientEdges.length ? this._missingClientEdges : null,
            missingLiveResolverFields: this._missingLiveResolverFields,
            seenRecords: this._seenRecords,
            selector: this._selector
        };
    };
    _proto._maybeAddFieldErrors = function _maybeAddFieldErrors(record, storageKey) {
        var errors = $7SC8Z.getErrors(record, storageKey);
        if (errors == null) return;
        var owner = this._fragmentName;
        if (this._fieldErrors == null) this._fieldErrors = [];
        for(var i = 0; i < errors.length; i++){
            var _error$path, _this$_selector$node$2, _this$_selector$node$3;
            var error = errors[i];
            this._fieldErrors.push({
                error: error,
                fieldPath: ((_error$path = error.path) !== null && _error$path !== void 0 ? _error$path : []).join('.'),
                handled: false,
                kind: 'relay_field_payload.error',
                owner: owner,
                shouldThrow: (_this$_selector$node$2 = (_this$_selector$node$3 = this._selector.node.metadata) === null || _this$_selector$node$3 === void 0 ? void 0 : _this$_selector$node$3.throwOnFieldError) !== null && _this$_selector$node$2 !== void 0 ? _this$_selector$node$2 : false,
                uiContext: undefined
            });
        }
    };
    _proto._markDataAsMissing = function _markDataAsMissing(fieldName) {
        var _this$_selector$node$4, _this$_selector$node$5;
        if (this._isWithinUnmatchedTypeRefinement) return;
        if (this._fieldErrors == null) this._fieldErrors = [];
        var owner = this._fragmentName;
        this._fieldErrors.push(((_this$_selector$node$4 = (_this$_selector$node$5 = this._selector.node.metadata) === null || _this$_selector$node$5 === void 0 ? void 0 : _this$_selector$node$5.throwOnFieldError) !== null && _this$_selector$node$4 !== void 0 ? _this$_selector$node$4 : false) ? {
            fieldPath: fieldName,
            handled: false,
            kind: 'missing_expected_data.throw',
            owner: owner,
            uiContext: undefined
        } : {
            fieldPath: fieldName,
            kind: 'missing_expected_data.log',
            owner: owner,
            uiContext: undefined
        });
        this._isMissingData = true;
        if (this._clientEdgeTraversalPath.length) {
            var top = this._clientEdgeTraversalPath[this._clientEdgeTraversalPath.length - 1];
            if (top !== null) this._missingClientEdges.push({
                clientEdgeDestinationID: top.clientEdgeDestinationID,
                request: top.readerClientEdge.operation
            });
        }
    };
    _proto._traverse = function _traverse(node, dataID, prevData) {
        var record = this._recordSource.get(dataID);
        var prevFieldGranularDataID = this._fieldGranularNotificationDataID;
        if (record != null && $7SC8Z.getValue(record, $38d0e5a20f326490$var$FIELD_GRANULAR_NOTIFICATIONS_KEY)) this._fieldGranularNotificationDataID = dataID;
        else {
            this._seenRecords.add(dataID);
            this._fieldGranularNotificationDataID = null;
        }
        if (record == null) {
            if (record === undefined) this._markDataAsMissing('<record>');
            this._fieldGranularNotificationDataID = prevFieldGranularDataID;
            return record;
        }
        var data = prevData || {};
        var hadRequiredData = this._traverseSelections(node.selections, record, data);
        this._fieldGranularNotificationDataID = prevFieldGranularDataID;
        return hadRequiredData ? data : null;
    };
    _proto._getVariableValue = function _getVariableValue(name) {
        !this._variables.hasOwnProperty(name) && $jSI6G(false);
        return this._variables[name];
    };
    _proto._maybeReportUnexpectedNull = function _maybeReportUnexpectedNull(selection) {
        if (selection.action === 'NONE') return;
        var owner = this._fragmentName;
        if (this._fieldErrors == null) this._fieldErrors = [];
        var fieldName;
        if (selection.field.linkedField != null) {
            var _selection$field$link;
            fieldName = (_selection$field$link = selection.field.linkedField.alias) !== null && _selection$field$link !== void 0 ? _selection$field$link : selection.field.linkedField.name;
        } else {
            var _selection$field$alia;
            fieldName = (_selection$field$alia = selection.field.alias) !== null && _selection$field$alia !== void 0 ? _selection$field$alia : selection.field.name;
        }
        switch(selection.action){
            case 'THROW':
                this._fieldErrors.push({
                    fieldPath: fieldName,
                    handled: false,
                    kind: 'missing_required_field.throw',
                    owner: owner,
                    uiContext: undefined
                });
                return;
            case 'LOG':
                this._fieldErrors.push({
                    fieldPath: fieldName,
                    kind: 'missing_required_field.log',
                    owner: owner,
                    uiContext: undefined
                });
                return;
            default:
                selection.action;
        }
    };
    _proto._handleRequiredFieldValue = function _handleRequiredFieldValue(selection, value) {
        if (value == null) {
            this._maybeReportUnexpectedNull(selection);
            return false;
        }
        return true;
    };
    _proto._catchErrors = function _catchErrors(_value, to, previousResponseFields) {
        var value = _value;
        switch(to){
            case 'RESULT':
                value = this._asResult(_value);
                break;
            case 'NULL':
                if (this._fieldErrors != null && this._fieldErrors.length > 0) value = null;
                break;
            default:
                to;
        }
        var childrenFieldErrors = this._fieldErrors;
        this._fieldErrors = previousResponseFields;
        if (childrenFieldErrors != null) {
            if (this._fieldErrors == null) this._fieldErrors = [];
            for(var i = 0; i < childrenFieldErrors.length; i++)this._fieldErrors.push($38d0e5a20f326490$var$markFieldErrorHasHandled(childrenFieldErrors[i]));
        }
        return value;
    };
    _proto._asResult = function _asResult(value) {
        if (this._fieldErrors == null || this._fieldErrors.length === 0) return {
            ok: true,
            value: value
        };
        var errors = this._fieldErrors.map(function(error) {
            switch(error.kind){
                case 'relay_field_payload.error':
                    var _error$error = error.error, message = _error$error.message, displayError = (0, $38d0e5a20f326490$var$_objectWithoutPropertiesLoose2["default"])(_error$error, $38d0e5a20f326490$var$_excluded);
                    return displayError;
                case 'missing_expected_data.throw':
                case 'missing_expected_data.log':
                    return {
                        path: error.fieldPath.split('.')
                    };
                case 'relay_resolver.error':
                    return {
                        message: "Relay: Error in resolver for field at ".concat(error.fieldPath, " in ").concat(error.owner)
                    };
                case 'missing_required_field.throw':
                    return {
                        message: "Relay: Missing @required value at path '".concat(error.fieldPath, "' in '").concat(error.owner, "'.")
                    };
                case 'missing_required_field.log':
                    return null;
                default:
                    error.kind;
                    $jSI6G(false);
            }
        }).filter(Boolean);
        return {
            errors: errors,
            ok: false
        };
    };
    _proto._traverseSelections = function _traverseSelections(selections, record, data) {
        for(var i = 0; i < selections.length; i++){
            var selection = selections[i];
            switch(selection.kind){
                case 'RequiredField':
                    var requiredFieldValue = this._readClientSideDirectiveField(selection, record, data);
                    if (!this._handleRequiredFieldValue(selection, requiredFieldValue)) return false;
                    break;
                case 'CatchField':
                    var _selection$field$back, _selection$field, _field$alias;
                    var previousResponseFields = this._fieldErrors;
                    this._fieldErrors = null;
                    var catchFieldValue = this._readClientSideDirectiveField(selection, record, data);
                    var field = (_selection$field$back = (_selection$field = selection.field) === null || _selection$field === void 0 ? void 0 : _selection$field.backingField) !== null && _selection$field$back !== void 0 ? _selection$field$back : selection.field;
                    var fieldName = (_field$alias = field === null || field === void 0 ? void 0 : field.alias) !== null && _field$alias !== void 0 ? _field$alias : field === null || field === void 0 ? void 0 : field.name;
                    !(fieldName != null) && $jSI6G(false);
                    data[fieldName] = this._catchErrors(catchFieldValue, selection.to, previousResponseFields);
                    break;
                case 'ScalarField':
                    this._readScalar(selection, record, data);
                    break;
                case 'LinkedField':
                    if (selection.plural) this._readPluralLink(selection, record, data);
                    else this._readLink(selection, record, data);
                    break;
                case 'Condition':
                    var conditionValue = Boolean(this._getVariableValue(selection.condition));
                    if (conditionValue === selection.passingValue) {
                        var hasExpectedData = this._traverseSelections(selection.selections, record, data);
                        if (!hasExpectedData) return false;
                    }
                    break;
                case 'InlineFragment':
                    var _hasExpectedData = this._readInlineFragment(selection, record, data, false);
                    if (_hasExpectedData === false) return false;
                    break;
                case 'RelayLiveResolver':
                case 'RelayResolver':
                    if (this._useExecTimeResolvers) this._readScalar(selection, record, data);
                    else this._readResolverField(selection, record, data);
                    break;
                case 'FragmentSpread':
                    this._createFragmentPointer(selection, record, data);
                    break;
                case 'AliasedInlineFragmentSpread':
                    this._readAliasedInlineFragment(selection, record, data);
                    break;
                case 'ModuleImport':
                    this._readModuleImport(selection, record, data);
                    break;
                case 'InlineDataFragmentSpread':
                    this._createInlineDataOrResolverFragmentPointer(selection, record, data);
                    break;
                case 'Defer':
                case 'ClientExtension':
                    var isMissingData = this._isMissingData;
                    var alreadyMissingClientEdges = this._missingClientEdges.length;
                    this._clientEdgeTraversalPath.push(null);
                    var _hasExpectedData2 = this._traverseSelections(selection.selections, record, data);
                    this._isMissingData = isMissingData || this._missingClientEdges.length > alreadyMissingClientEdges || this._missingLiveResolverFields.length > 0;
                    this._clientEdgeTraversalPath.pop();
                    if (!_hasExpectedData2) return false;
                    break;
                case 'Stream':
                    var _hasExpectedData3 = this._traverseSelections(selection.selections, record, data);
                    if (!_hasExpectedData3) return false;
                    break;
                case 'ActorChange':
                    this._readActorChange(selection, record, data);
                    break;
                case 'ClientEdgeToClientObject':
                case 'ClientEdgeToServerObject':
                    if (this._useExecTimeResolvers && (selection.backingField.kind === 'RelayResolver' || selection.backingField.kind === 'RelayLiveResolver')) {
                        var linkedField = selection.linkedField;
                        if (linkedField.plural) this._readPluralLink(linkedField, record, data);
                        else this._readLink(linkedField, record, data);
                    } else this._readClientEdge(selection, record, data);
                    break;
                default:
                    selection;
                    $jSI6G(false);
            }
        }
        return true;
    };
    _proto._readClientSideDirectiveField = function _readClientSideDirectiveField(selection, record, data) {
        switch(selection.field.kind){
            case 'ScalarField':
                return this._readScalar(selection.field, record, data);
            case 'LinkedField':
                if (selection.field.plural) return this._readPluralLink(selection.field, record, data);
                else return this._readLink(selection.field, record, data);
            case 'RelayResolver':
            case 'RelayLiveResolver':
                if (this._useExecTimeResolvers) return this._readScalar(selection.field, record, data);
                else return this._readResolverField(selection.field, record, data);
            case 'ClientEdgeToClientObject':
            case 'ClientEdgeToServerObject':
                if (this._useExecTimeResolvers && (selection.field.backingField.kind === 'RelayResolver' || selection.field.backingField.kind === 'RelayLiveResolver')) {
                    var field = selection.field;
                    if (field.linkedField.plural) return this._readPluralLink(field.linkedField, record, data);
                    else return this._readLink(field.linkedField, record, data);
                } else return this._readClientEdge(selection.field, record, data);
            case 'AliasedInlineFragmentSpread':
                return this._readAliasedInlineFragment(selection.field, record, data);
            default:
                selection.field.kind;
                $jSI6G(false);
        }
    };
    _proto._readResolverField = function _readResolverField(field, record, data) {
        var _field$alias2;
        var parentRecordID = $7SC8Z.getDataID(record);
        var prevErrors = this._fieldErrors;
        this._fieldErrors = null;
        var result = this._readResolverFieldImpl(field, parentRecordID);
        var fieldName = (_field$alias2 = field.alias) !== null && _field$alias2 !== void 0 ? _field$alias2 : field.name;
        this._prependPreviousErrors(prevErrors, fieldName);
        data[fieldName] = result;
        return result;
    };
    _proto._readResolverFieldImpl = function _readResolverFieldImpl(field, parentRecordID) {
        var _this = this;
        var fragment = field.fragment;
        var snapshot;
        var getDataForResolverFragment = function getDataForResolverFragment(singularReaderSelector) {
            if (snapshot != null) return {
                data: snapshot.data,
                fieldErrors: snapshot.fieldErrors,
                isMissingData: snapshot.isMissingData
            };
            snapshot = $38d0e5a20f326490$var$read(_this._recordSource, singularReaderSelector, null, _this._resolverCache, undefined);
            return {
                data: snapshot.data,
                fieldErrors: snapshot.fieldErrors,
                isMissingData: snapshot.isMissingData
            };
        };
        var evaluate = function evaluate() {
            if (fragment != null) {
                var key = {
                    __fragmentOwner: _this._owner,
                    __fragments: (0, $38d0e5a20f326490$var$_defineProperty2["default"])({}, fragment.name, fragment.args ? $38d0e5a20f326490$var$getArgumentValues(fragment.args, _this._variables) : {}),
                    __id: parentRecordID
                };
                if (_this._clientEdgeTraversalPath.length > 0 && _this._clientEdgeTraversalPath[_this._clientEdgeTraversalPath.length - 1] !== null) key[$38d0e5a20f326490$var$CLIENT_EDGE_TRAVERSAL_PATH] = (0, $38d0e5a20f326490$var$_toConsumableArray2["default"])(_this._clientEdgeTraversalPath);
                var resolverContext = {
                    getDataForResolverFragment: getDataForResolverFragment
                };
                return $38d0e5a20f326490$var$withResolverContext(resolverContext, function() {
                    var _getResolverValue = $38d0e5a20f326490$var$getResolverValue(field, _this._variables, key, _this._resolverContext), resolverResult = _getResolverValue[0], resolverError = _getResolverValue[1];
                    return {
                        error: resolverError,
                        resolverResult: resolverResult,
                        snapshot: snapshot
                    };
                });
            } else {
                var _getResolverValue2 = $38d0e5a20f326490$var$getResolverValue(field, _this._variables, null, _this._resolverContext), resolverResult = _getResolverValue2[0], _resolverError = _getResolverValue2[1];
                return {
                    error: _resolverError,
                    resolverResult: resolverResult,
                    snapshot: undefined
                };
            }
        };
        var _this$_resolverCache$ = this._resolverCache.readFromCacheOrEvaluate(parentRecordID, field, this._variables, evaluate, getDataForResolverFragment), result = _this$_resolverCache$[0], seenRecord = _this$_resolverCache$[1], resolverError = _this$_resolverCache$[2], cachedSnapshot = _this$_resolverCache$[3], suspenseID = _this$_resolverCache$[4], updatedDataIDs = _this$_resolverCache$[5];
        this._propagateResolverMetadata(field.path, cachedSnapshot, resolverError, seenRecord, suspenseID, updatedDataIDs);
        return result;
    };
    _proto._propagateResolverMetadata = function _propagateResolverMetadata(fieldPath, cachedSnapshot, resolverError, seenRecord, suspenseID, updatedDataIDs) {
        var _this2 = this;
        if (cachedSnapshot != null) {
            if (cachedSnapshot.missingClientEdges != null) for(var i = 0; i < cachedSnapshot.missingClientEdges.length; i++){
                var missing = cachedSnapshot.missingClientEdges[i];
                this._missingClientEdges.push(missing);
            }
            if (cachedSnapshot.missingLiveResolverFields != null) {
                this._isMissingData = this._isMissingData || cachedSnapshot.missingLiveResolverFields.length > 0;
                for(var _i = 0; _i < cachedSnapshot.missingLiveResolverFields.length; _i++){
                    var missingResolverField = cachedSnapshot.missingLiveResolverFields[_i];
                    this._missingLiveResolverFields.push(missingResolverField);
                }
            }
            if (cachedSnapshot.fieldErrors != null) {
                if (this._fieldErrors == null) this._fieldErrors = [];
                for(var _i2 = 0; _i2 < cachedSnapshot.fieldErrors.length; _i2++){
                    var _this$_selector$node$6;
                    var error = cachedSnapshot.fieldErrors[_i2];
                    if (((_this$_selector$node$6 = this._selector.node.metadata) === null || _this$_selector$node$6 === void 0 ? void 0 : _this$_selector$node$6.throwOnFieldError) === true) this._fieldErrors.push(error);
                    else this._fieldErrors.push($38d0e5a20f326490$var$markFieldErrorHasHandled(error));
                }
            }
            this._isMissingData = this._isMissingData || cachedSnapshot.isMissingData;
        }
        if (resolverError) {
            var _this$_selector$node$7, _this$_selector$node$8;
            var errorEvent = {
                error: resolverError,
                fieldPath: fieldPath,
                handled: false,
                kind: 'relay_resolver.error',
                owner: this._fragmentName,
                shouldThrow: (_this$_selector$node$7 = (_this$_selector$node$8 = this._selector.node.metadata) === null || _this$_selector$node$8 === void 0 ? void 0 : _this$_selector$node$8.throwOnFieldError) !== null && _this$_selector$node$7 !== void 0 ? _this$_selector$node$7 : false,
                uiContext: undefined
            };
            if (this._fieldErrors == null) this._fieldErrors = [
                errorEvent
            ];
            else this._fieldErrors.push(errorEvent);
        }
        if (seenRecord != null) this._seenRecords.add(seenRecord);
        if (suspenseID != null) {
            this._isMissingData = true;
            this._missingLiveResolverFields.push(suspenseID);
        }
        if (updatedDataIDs != null) updatedDataIDs.forEach(function(recordID) {
            _this2._updatedDataIDs.add(recordID);
        });
    };
    _proto._readClientEdge = function _readClientEdge(field, record, data) {
        var _this3 = this;
        var _backingField$alias;
        var backingField = field.backingField;
        !(backingField.kind !== 'ClientExtension') && $jSI6G(false);
        var fieldName = (_backingField$alias = backingField.alias) !== null && _backingField$alias !== void 0 ? _backingField$alias : backingField.name;
        var backingFieldData = {};
        this._traverseSelections([
            backingField
        ], record, backingFieldData);
        var clientEdgeResolverResponse = backingFieldData[fieldName];
        if (clientEdgeResolverResponse == null || $38d0e5a20f326490$var$isSuspenseSentinel(clientEdgeResolverResponse)) {
            data[fieldName] = clientEdgeResolverResponse;
            return clientEdgeResolverResponse;
        }
        if (field.linkedField.plural) {
            !Array.isArray(clientEdgeResolverResponse) && $jSI6G(false);
            var storeIDs;
            !(field.kind === 'ClientEdgeToClientObject') && $jSI6G(false);
            if (field.backingField.normalizationInfo == null) storeIDs = clientEdgeResolverResponse.map(function(itemResponse) {
                var _field$concreteType;
                var concreteType = (_field$concreteType = field.concreteType) !== null && _field$concreteType !== void 0 ? _field$concreteType : itemResponse.__typename;
                !(typeof concreteType === 'string') && $jSI6G(false);
                var localId = $38d0e5a20f326490$var$extractIdFromResponse(itemResponse, backingField.path, _this3._owner.identifier);
                var id = _this3._resolverCache.ensureClientRecord(localId, concreteType);
                var modelResolvers = field.modelResolvers;
                if (modelResolvers != null) {
                    var modelResolver = modelResolvers[concreteType];
                    !(modelResolver !== undefined) && $jSI6G(false);
                    var model = _this3._readResolverFieldImpl(modelResolver, id);
                    return model != null ? id : null;
                }
                return id;
            });
            else storeIDs = clientEdgeResolverResponse.map(function(obj) {
                return $38d0e5a20f326490$var$extractIdFromResponse(obj, backingField.path, _this3._owner.identifier);
            });
            this._clientEdgeTraversalPath.push(null);
            var edgeValues = this._readLinkedIds(field.linkedField, storeIDs, record, data);
            this._clientEdgeTraversalPath.pop();
            data[fieldName] = edgeValues;
            return edgeValues;
        } else {
            var _field$concreteType2;
            var id = $38d0e5a20f326490$var$extractIdFromResponse(clientEdgeResolverResponse, backingField.path, this._owner.identifier);
            var storeID;
            var concreteType = (_field$concreteType2 = field.concreteType) !== null && _field$concreteType2 !== void 0 ? _field$concreteType2 : clientEdgeResolverResponse.__typename;
            var traversalPathSegment;
            if (field.kind === 'ClientEdgeToClientObject') {
                if (field.backingField.normalizationInfo == null) {
                    !(typeof concreteType === 'string') && $jSI6G(false);
                    storeID = this._resolverCache.ensureClientRecord(id, concreteType);
                    traversalPathSegment = null;
                } else {
                    storeID = id;
                    traversalPathSegment = null;
                }
            } else {
                storeID = id;
                traversalPathSegment = {
                    clientEdgeDestinationID: id,
                    readerClientEdge: field
                };
            }
            var modelResolvers = field.modelResolvers;
            if (modelResolvers != null) {
                !(typeof concreteType === 'string') && $jSI6G(false);
                var modelResolver = modelResolvers[concreteType];
                !(modelResolver !== undefined) && $jSI6G(false);
                var model = this._readResolverFieldImpl(modelResolver, storeID);
                if (model == null) {
                    data[fieldName] = null;
                    return null;
                }
            }
            this._clientEdgeTraversalPath.push(traversalPathSegment);
            var prevData = data[fieldName];
            !(prevData == null || typeof prevData === 'object') && $jSI6G(false);
            var prevErrors = this._fieldErrors;
            this._fieldErrors = null;
            var edgeValue = this._traverse(field.linkedField, storeID, prevData);
            this._prependPreviousErrors(prevErrors, fieldName);
            this._clientEdgeTraversalPath.pop();
            data[fieldName] = edgeValue;
            return edgeValue;
        }
    };
    _proto._readScalar = function _readScalar(field, record, data) {
        var _field$alias3;
        var fieldName = (_field$alias3 = field.alias) !== null && _field$alias3 !== void 0 ? _field$alias3 : field.name;
        var storageKey = $38d0e5a20f326490$var$getStorageKey(field, this._variables);
        if (this._fieldGranularNotificationDataID != null) this._seenRecords.add($38d0e5a20f326490$var$getFieldNotificationKey(this._fieldGranularNotificationDataID, storageKey));
        var value = $7SC8Z.getValue(record, storageKey);
        if (value === null || $gZYpt.ENABLE_NONCOMPLIANT_ERROR_HANDLING_ON_LISTS && Array.isArray(value) && value.length === 0) this._maybeAddFieldErrors(record, storageKey);
        else if (value === undefined) this._markDataAsMissing(fieldName);
        data[fieldName] = value;
        return value;
    };
    _proto._readLink = function _readLink(field, record, data) {
        var _field$alias4;
        var fieldName = (_field$alias4 = field.alias) !== null && _field$alias4 !== void 0 ? _field$alias4 : field.name;
        var storageKey = $38d0e5a20f326490$var$getStorageKey(field, this._variables);
        if (this._fieldGranularNotificationDataID != null) this._seenRecords.add($38d0e5a20f326490$var$getFieldNotificationKey(this._fieldGranularNotificationDataID, storageKey));
        var linkedID = $7SC8Z.getLinkedRecordID(record, storageKey);
        if (linkedID == null) {
            data[fieldName] = linkedID;
            if (linkedID === null) this._maybeAddFieldErrors(record, storageKey);
            else if (linkedID === undefined) this._markDataAsMissing(fieldName);
            return linkedID;
        }
        var prevData = data[fieldName];
        !(prevData == null || typeof prevData === 'object') && $jSI6G(false);
        var prevErrors = this._fieldErrors;
        this._fieldErrors = null;
        var value = this._traverse(field, linkedID, prevData);
        this._prependPreviousErrors(prevErrors, fieldName);
        data[fieldName] = value;
        return value;
    };
    _proto._prependPreviousErrors = function _prependPreviousErrors(prevErrors, fieldNameOrIndex) {
        if (this._fieldErrors != null) {
            for(var i = 0; i < this._fieldErrors.length; i++){
                var event = this._fieldErrors[i];
                if (event.owner === this._fragmentName && (event.kind === 'missing_expected_data.throw' || event.kind === 'missing_expected_data.log' || event.kind === 'missing_required_field.throw' || event.kind === 'missing_required_field.log')) event.fieldPath = "".concat(fieldNameOrIndex, ".").concat(event.fieldPath);
            }
            if (prevErrors != null) {
                for(var _i3 = this._fieldErrors.length - 1; _i3 >= 0; _i3--)prevErrors.push(this._fieldErrors[_i3]);
                this._fieldErrors = prevErrors;
            }
        } else this._fieldErrors = prevErrors;
    };
    _proto._readActorChange = function _readActorChange(field, record, data) {
        var _field$alias5;
        var fieldName = (_field$alias5 = field.alias) !== null && _field$alias5 !== void 0 ? _field$alias5 : field.name;
        var storageKey = $38d0e5a20f326490$var$getStorageKey(field, this._variables);
        var externalRef = $7SC8Z.getActorLinkedRecordID(record, storageKey);
        if (externalRef == null) {
            data[fieldName] = externalRef;
            if (externalRef === undefined) this._markDataAsMissing(fieldName);
            else if (externalRef === null) this._maybeAddFieldErrors(record, storageKey);
            return data[fieldName];
        }
        var actorIdentifier = externalRef[0], dataID = externalRef[1];
        var fragmentRef = {};
        this._createFragmentPointer(field.fragmentSpread, $7SC8Z.fromObject({
            __id: dataID
        }), fragmentRef);
        data[fieldName] = {
            __fragmentRef: fragmentRef,
            __viewer: actorIdentifier
        };
        return data[fieldName];
    };
    _proto._readPluralLink = function _readPluralLink(field, record, data) {
        var storageKey = $38d0e5a20f326490$var$getStorageKey(field, this._variables);
        if (this._fieldGranularNotificationDataID != null) this._seenRecords.add($38d0e5a20f326490$var$getFieldNotificationKey(this._fieldGranularNotificationDataID, storageKey));
        var linkedIDs = $7SC8Z.getLinkedRecordIDs(record, storageKey);
        if (linkedIDs === null || $gZYpt.ENABLE_NONCOMPLIANT_ERROR_HANDLING_ON_LISTS && Array.isArray(linkedIDs) && linkedIDs.length === 0) this._maybeAddFieldErrors(record, storageKey);
        return this._readLinkedIds(field, linkedIDs, record, data);
    };
    _proto._readLinkedIds = function _readLinkedIds(field, linkedIDs, record, data) {
        var _this4 = this;
        var _field$alias6;
        var fieldName = (_field$alias6 = field.alias) !== null && _field$alias6 !== void 0 ? _field$alias6 : field.name;
        if (linkedIDs == null) {
            data[fieldName] = linkedIDs;
            if (linkedIDs === undefined) this._markDataAsMissing(fieldName);
            return linkedIDs;
        }
        var prevData = data[fieldName];
        !(prevData == null || Array.isArray(prevData)) && $jSI6G(false);
        var prevErrors = this._fieldErrors;
        this._fieldErrors = null;
        var linkedArray = prevData || [];
        linkedIDs.forEach(function(linkedID, nextIndex) {
            if (linkedID == null) {
                if (linkedID === undefined) _this4._markDataAsMissing(String(nextIndex));
                linkedArray[nextIndex] = linkedID;
                return;
            }
            var prevItem = linkedArray[nextIndex];
            !(prevItem == null || typeof prevItem === 'object') && $jSI6G(false);
            var prevErrors = _this4._fieldErrors;
            _this4._fieldErrors = null;
            linkedArray[nextIndex] = _this4._traverse(field, linkedID, prevItem);
            _this4._prependPreviousErrors(prevErrors, nextIndex);
        });
        this._prependPreviousErrors(prevErrors, fieldName);
        data[fieldName] = linkedArray;
        return linkedArray;
    };
    _proto._readModuleImport = function _readModuleImport(moduleImport, record, data) {
        var componentKey = $38d0e5a20f326490$var$getModuleComponentKey(moduleImport.documentName);
        var relayStoreComponent = $7SC8Z.getValue(record, componentKey);
        var component = relayStoreComponent !== undefined ? relayStoreComponent : moduleImport.componentModuleProvider;
        if (component == null) {
            if (component === undefined) this._markDataAsMissing('<module-import>');
            return;
        }
        this._createFragmentPointer({
            args: moduleImport.args,
            kind: 'FragmentSpread',
            name: moduleImport.fragmentName
        }, record, data);
        data[$38d0e5a20f326490$var$FRAGMENT_PROP_NAME_KEY] = moduleImport.fragmentPropName;
        data[$38d0e5a20f326490$var$MODULE_COMPONENT_KEY] = component;
    };
    _proto._readAliasedInlineFragment = function _readAliasedInlineFragment(aliasedInlineFragment, record, data) {
        var prevErrors = this._fieldErrors;
        this._fieldErrors = null;
        var fieldValue = this._readInlineFragment(aliasedInlineFragment.fragment, record, {}, true);
        this._prependPreviousErrors(prevErrors, aliasedInlineFragment.name);
        if (fieldValue === false) fieldValue = null;
        data[aliasedInlineFragment.name] = fieldValue;
        return fieldValue;
    };
    _proto._readInlineFragment = function _readInlineFragment(inlineFragment, record, data, skipUnmatchedAbstractTypes) {
        if (inlineFragment.type == null) {
            var hasExpectedData = this._traverseSelections(inlineFragment.selections, record, data);
            if (hasExpectedData === false) return false;
            return data;
        }
        var abstractKey = inlineFragment.abstractKey;
        if (abstractKey == null) {
            if (!this._recordMatchesTypeCondition(record, inlineFragment.type)) return null;
            else {
                var hasExpectedData = this._traverseSelections(inlineFragment.selections, record, data);
                if (!hasExpectedData) return false;
            }
        } else {
            var implementsInterface = this._implementsInterface(record, abstractKey);
            if (implementsInterface === false && skipUnmatchedAbstractTypes) return null;
            var parentIsMissingData = this._isMissingData;
            var parentIsWithinUnmatchedTypeRefinement = this._isWithinUnmatchedTypeRefinement;
            this._isWithinUnmatchedTypeRefinement = parentIsWithinUnmatchedTypeRefinement || implementsInterface === false;
            var hasMissingData = this._traverseSelections(inlineFragment.selections, record, data);
            this._isWithinUnmatchedTypeRefinement = parentIsWithinUnmatchedTypeRefinement;
            if (implementsInterface === false) {
                this._isMissingData = parentIsMissingData;
                return null;
            } else if (implementsInterface == null) return undefined;
            else if (hasMissingData === false) return false;
        }
        return data;
    };
    _proto._recordMatchesTypeCondition = function _recordMatchesTypeCondition(record, type) {
        var typeName = $7SC8Z.getType(record);
        return typeName != null && typeName === type || $7SC8Z.getDataID(record) === $38d0e5a20f326490$var$ROOT_ID;
    };
    _proto._createFragmentPointer = function _createFragmentPointer(fragmentSpread, record, data) {
        var fragmentPointers = data[$38d0e5a20f326490$var$FRAGMENTS_KEY];
        if (fragmentPointers == null) fragmentPointers = data[$38d0e5a20f326490$var$FRAGMENTS_KEY] = {};
        !(typeof fragmentPointers === 'object' && fragmentPointers != null) && $jSI6G(false);
        if (data[$38d0e5a20f326490$var$ID_KEY] == null) data[$38d0e5a20f326490$var$ID_KEY] = $7SC8Z.getDataID(record);
        var args = $38d0e5a20f326490$var$getArgumentValues(fragmentSpread.args, this._variables, this._isWithinUnmatchedTypeRefinement);
        fragmentPointers[fragmentSpread.name] = args;
        data[$38d0e5a20f326490$var$FRAGMENT_OWNER_KEY] = this._owner;
        if (this._clientEdgeTraversalPath.length > 0 && this._clientEdgeTraversalPath[this._clientEdgeTraversalPath.length - 1] !== null) data[$38d0e5a20f326490$var$CLIENT_EDGE_TRAVERSAL_PATH] = (0, $38d0e5a20f326490$var$_toConsumableArray2["default"])(this._clientEdgeTraversalPath);
        if ($gZYpt.ENABLE_READER_FRAGMENTS_LOGGING) {
            var _this$_log2;
            (_this$_log2 = this._log) === null || _this$_log2 === void 0 || _this$_log2.call(this, {
                name: 'reader.fragmentSpread',
                fragmentName: fragmentSpread.name,
                data: data
            });
        }
    };
    _proto._createInlineDataOrResolverFragmentPointer = function _createInlineDataOrResolverFragmentPointer(fragmentSpreadOrFragment, record, data) {
        var fragmentPointers = data[$38d0e5a20f326490$var$FRAGMENTS_KEY];
        if (fragmentPointers == null) fragmentPointers = data[$38d0e5a20f326490$var$FRAGMENTS_KEY] = {};
        !(typeof fragmentPointers === 'object' && fragmentPointers != null) && $jSI6G(false);
        if (data[$38d0e5a20f326490$var$ID_KEY] == null) data[$38d0e5a20f326490$var$ID_KEY] = $7SC8Z.getDataID(record);
        var inlineData = {};
        var parentFragmentName = this._fragmentName;
        this._fragmentName = fragmentSpreadOrFragment.name;
        var parentVariables = this._variables;
        var argumentVariables = fragmentSpreadOrFragment.args ? $38d0e5a20f326490$var$getArgumentValues(fragmentSpreadOrFragment.args, this._variables) : {};
        this._variables = $adnaT.getFragmentVariables(fragmentSpreadOrFragment, this._owner.variables, argumentVariables);
        this._traverseSelections(fragmentSpreadOrFragment.selections, record, inlineData);
        this._variables = parentVariables;
        this._fragmentName = parentFragmentName;
        fragmentPointers[fragmentSpreadOrFragment.name] = inlineData;
    };
    _proto._implementsInterface = function _implementsInterface(record, abstractKey) {
        var typeName = $7SC8Z.getType(record);
        var typeRecord = this._recordSource.get($38d0e5a20f326490$var$generateTypeID(typeName));
        var implementsInterface = typeRecord != null ? $7SC8Z.getValue(typeRecord, abstractKey) : null;
        if (implementsInterface == null) this._markDataAsMissing('<abstract-type-hint>');
        return implementsInterface;
    };
    return RelayReader;
}();
function $38d0e5a20f326490$var$markFieldErrorHasHandled(event) {
    switch(event.kind){
        case 'missing_expected_data.throw':
        case 'missing_required_field.throw':
        case 'relay_field_payload.error':
        case 'relay_resolver.error':
            return (0, $38d0e5a20f326490$var$_objectSpread2["default"])((0, $38d0e5a20f326490$var$_objectSpread2["default"])({}, event), {}, {
                handled: true
            });
        case 'missing_expected_data.log':
        case 'missing_required_field.log':
            return event;
        default:
            event.kind;
            $jSI6G(false);
    }
}
function $38d0e5a20f326490$var$getResolverValue(field, variables, fragmentKey, resolverContext) {
    var resolverFunction = typeof field.resolverModule === 'function' ? field.resolverModule : field.resolverModule["default"];
    var resolverResult = null;
    var resolverError = null;
    try {
        var resolverFunctionArgs = [];
        if (field.fragment != null) resolverFunctionArgs.push(fragmentKey);
        var args = field.args ? $38d0e5a20f326490$var$getArgumentValues(field.args, variables) : undefined;
        resolverFunctionArgs.push(args);
        resolverFunctionArgs.push(resolverContext);
        resolverResult = resolverFunction.apply(null, resolverFunctionArgs);
    } catch (e) {
        resolverResult = null;
        if (e !== $38d0e5a20f326490$var$RESOLVER_FRAGMENT_ERRORED_SENTINEL) resolverError = e;
    }
    return [
        resolverResult,
        resolverError
    ];
}
function $38d0e5a20f326490$var$extractIdFromResponse(individualResponse, path, owner) {
    if (typeof individualResponse === 'string') return individualResponse;
    else if (typeof individualResponse === 'object' && individualResponse != null && typeof individualResponse.id === 'string') return individualResponse.id;
    $jSI6G(false);
}
module.exports = {
    read: $38d0e5a20f326490$var$read
};

});
parcelRegister("835Zq", function(module, exports) {
'use strict';

var $fT3Ou = parcelRequire("fT3Ou");
var $5dc33ffd441b272e$var$RELAY_LIVE_RESOLVER = $fT3Ou.RELAY_LIVE_RESOLVER;

var $jSI6G = parcelRequire("jSI6G");
var $5dc33ffd441b272e$var$NoopResolverCache = /*#__PURE__*/ function() {
    function NoopResolverCache() {}
    var _proto = NoopResolverCache.prototype;
    _proto.readFromCacheOrEvaluate = function readFromCacheOrEvaluate(recordID, field, variables, evaluate, getDataForResolverFragment) {
        !(field.kind !== $5dc33ffd441b272e$var$RELAY_LIVE_RESOLVER) && $jSI6G(false);
        var _evaluate = evaluate(), resolverResult = _evaluate.resolverResult, snapshot = _evaluate.snapshot, error = _evaluate.error;
        return [
            resolverResult,
            undefined,
            error,
            snapshot,
            undefined,
            undefined
        ];
    };
    _proto.invalidateDataIDs = function invalidateDataIDs(updatedDataIDs) {};
    _proto.ensureClientRecord = function ensureClientRecord(id, typeName) {
        $jSI6G(false);
    };
    _proto.notifyUpdatedSubscribers = function notifyUpdatedSubscribers(updatedDataIDs) {};
    return NoopResolverCache;
}();
module.exports = {
    NoopResolverCache: $5dc33ffd441b272e$var$NoopResolverCache
};

});


parcelRegister("56FwA", function(module, exports) {
'use strict';

var $e27SU = parcelRequire("e27SU");
var $3b7db934651fc21b$var$_interopRequireDefault = $e27SU.default;

var $3b7db934651fc21b$var$_createForOfIteratorHelper2 = $3b7db934651fc21b$var$_interopRequireDefault((parcelRequire("5dSyV")));

var $gJkyh = parcelRequire("gJkyh");

var $4dqb0 = parcelRequire("4dqb0");

var $kjwqA = parcelRequire("kjwqA");

var $adnaT = parcelRequire("adnaT");
var $3b7db934651fc21b$var$getLocalVariables = $adnaT.getLocalVariables;

var $7SC8Z = parcelRequire("7SC8Z");

var $ezyIu = parcelRequire("ezyIu");

var $enqEM = parcelRequire("enqEM");
var $3b7db934651fc21b$var$generateTypeID = $enqEM.generateTypeID;

var $jSI6G = parcelRequire("jSI6G");
var $3b7db934651fc21b$var$getReadTimeResolverStorageKey = $ezyIu.getReadTimeResolverStorageKey, $3b7db934651fc21b$var$getStorageKey = $ezyIu.getStorageKey, $3b7db934651fc21b$var$getModuleOperationKey = $ezyIu.getModuleOperationKey;
function $3b7db934651fc21b$var$mark(recordSource, selector, references, operationLoader, shouldProcessClientComponents, useExecTimeResolvers) {
    var dataID = selector.dataID, node = selector.node, variables = selector.variables;
    var marker = new $3b7db934651fc21b$var$RelayReferenceMarker(recordSource, variables, references, operationLoader, shouldProcessClientComponents, useExecTimeResolvers);
    marker.mark(node, dataID);
}
var $3b7db934651fc21b$var$RelayReferenceMarker = /*#__PURE__*/ function() {
    function RelayReferenceMarker(recordSource, variables, references, operationLoader, shouldProcessClientComponents, useExecTimeResolvers) {
        this._operationLoader = operationLoader !== null && operationLoader !== void 0 ? operationLoader : null;
        this._operationName = null;
        this._useExecTimeResolvers = useExecTimeResolvers !== null && useExecTimeResolvers !== void 0 ? useExecTimeResolvers : false;
        this._recordSource = recordSource;
        this._references = references;
        this._variables = variables;
        this._shouldProcessClientComponents = shouldProcessClientComponents;
    }
    var _proto = RelayReferenceMarker.prototype;
    _proto.mark = function mark(node, dataID) {
        if (node.kind === 'Operation' || node.kind === 'SplitOperation') this._operationName = node.name;
        this._traverse(node, dataID);
    };
    _proto._traverse = function _traverse(node, dataID) {
        this._references.add(dataID);
        var record = this._recordSource.get(dataID);
        if (record == null) return;
        this._traverseSelections(node.selections, record);
    };
    _proto._getVariableValue = function _getVariableValue(name) {
        !this._variables.hasOwnProperty(name) && $jSI6G(false);
        return this._variables[name];
    };
    _proto._traverseSelections = function _traverseSelections(selections, record) {
        var _this = this;
        selections.forEach(function(selection) {
            switch(selection.kind){
                case 'ActorChange':
                    _this._traverseLink(selection.linkedField, record);
                    break;
                case 'LinkedField':
                    if (selection.plural) _this._traversePluralLink(selection, record);
                    else _this._traverseLink(selection, record);
                    break;
                case 'Condition':
                    var conditionValue = Boolean(_this._getVariableValue(selection.condition));
                    if (conditionValue === selection.passingValue) _this._traverseSelections(selection.selections, record);
                    break;
                case 'InlineFragment':
                    if (selection.abstractKey == null) {
                        var typeName = $7SC8Z.getType(record);
                        if (typeName != null && typeName === selection.type || typeName === $ezyIu.ROOT_TYPE) _this._traverseSelections(selection.selections, record);
                    } else {
                        var _typeName = $7SC8Z.getType(record);
                        var typeID = $3b7db934651fc21b$var$generateTypeID(_typeName);
                        _this._references.add(typeID);
                        _this._traverseSelections(selection.selections, record);
                    }
                    break;
                case 'FragmentSpread':
                    var prevVariables = _this._variables;
                    _this._variables = $3b7db934651fc21b$var$getLocalVariables(_this._variables, selection.fragment.argumentDefinitions, selection.args);
                    _this._traverseSelections(selection.fragment.selections, record);
                    _this._variables = prevVariables;
                    break;
                case 'LinkedHandle':
                    var handleField = $4dqb0(selection, selections, _this._variables);
                    if (handleField.plural) _this._traversePluralLink(handleField, record);
                    else _this._traverseLink(handleField, record);
                    break;
                case 'Defer':
                case 'Stream':
                    _this._traverseSelections(selection.selections, record);
                    break;
                case 'ScalarField':
                case 'ScalarHandle':
                    break;
                case 'TypeDiscriminator':
                    var _typeName2 = $7SC8Z.getType(record);
                    var _typeID = $3b7db934651fc21b$var$generateTypeID(_typeName2);
                    _this._references.add(_typeID);
                    break;
                case 'ModuleImport':
                    _this._traverseModuleImport(selection, record);
                    break;
                case 'ClientExtension':
                    _this._traverseSelections(selection.selections, record);
                    break;
                case 'ClientComponent':
                    if (_this._shouldProcessClientComponents === false) break;
                    _this._traverseSelections(selection.fragment.selections, record);
                    break;
                case 'RelayResolver':
                case 'RelayLiveResolver':
                    _this._traverseResolverField(selection, record);
                    break;
                case 'ClientEdgeToClientObject':
                    _this._traverseClientEdgeToClientObject(selection, record);
                    break;
                default:
                    selection;
                    $jSI6G(false);
            }
        });
    };
    _proto._traverseClientEdgeToClientObject = function _traverseClientEdgeToClientObject(field, record) {
        if (this._useExecTimeResolvers) {
            this._traverseLink(field.linkedField, record);
            return;
        }
        var dataID = this._traverseResolverField(field.backingField, record);
        if (dataID == null) return;
        var resolverRecord = this._recordSource.get(dataID);
        if (resolverRecord == null) return;
        var linkedField = field.linkedField;
        if (field.backingField.isOutputType) {
            var outputTypeRecordIDs = $kjwqA(resolverRecord);
            if (outputTypeRecordIDs != null) {
                var _iterator = (0, $3b7db934651fc21b$var$_createForOfIteratorHelper2["default"])(outputTypeRecordIDs), _step;
                try {
                    for(_iterator.s(); !(_step = _iterator.n()).done;){
                        var _dataID = _step.value;
                        this._references.add(_dataID);
                        this._traverse(linkedField, _dataID);
                    }
                } catch (err) {
                    _iterator.e(err);
                } finally{
                    _iterator.f();
                }
            }
        } else {
            var concreteType = linkedField.concreteType;
            if (concreteType == null) return;
            if (linkedField.plural) {
                var dataIDs = $7SC8Z.getResolverLinkedRecordIDs(resolverRecord, concreteType);
                if (dataIDs != null) {
                    var _iterator2 = (0, $3b7db934651fc21b$var$_createForOfIteratorHelper2["default"])(dataIDs), _step2;
                    try {
                        for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                            var _dataID2 = _step2.value;
                            if (_dataID2 != null) this._traverse(linkedField, _dataID2);
                        }
                    } catch (err) {
                        _iterator2.e(err);
                    } finally{
                        _iterator2.f();
                    }
                }
            } else {
                var _dataID3 = $7SC8Z.getResolverLinkedRecordID(resolverRecord, concreteType);
                if (_dataID3 != null) this._traverse(linkedField, _dataID3);
            }
        }
    };
    _proto._traverseResolverField = function _traverseResolverField(field, record) {
        if (this._useExecTimeResolvers) return;
        var storageKey = $3b7db934651fc21b$var$getReadTimeResolverStorageKey(field, this._variables);
        var dataID = $7SC8Z.getLinkedRecordID(record, storageKey);
        if (dataID != null) this._references.add(dataID);
        var fragment = field.fragment;
        if (fragment != null) this._traverseSelections([
            fragment
        ], record);
        return dataID;
    };
    _proto._traverseModuleImport = function _traverseModuleImport(moduleImport, record) {
        var _this$_operationName;
        var operationLoader = this._operationLoader;
        !(operationLoader !== null) && $jSI6G(false);
        var operationKey = $3b7db934651fc21b$var$getModuleOperationKey(moduleImport.documentName);
        var operationReference = $7SC8Z.getValue(record, operationKey);
        if (operationReference == null) return;
        var normalizationRootNode = operationLoader.get(operationReference);
        if (normalizationRootNode != null) {
            var operation = $gJkyh(normalizationRootNode);
            var prevVariables = this._variables;
            this._variables = $3b7db934651fc21b$var$getLocalVariables(this._variables, operation.argumentDefinitions, moduleImport.args);
            this._traverseSelections(operation.selections, record);
            this._variables = prevVariables;
        }
    };
    _proto._traverseLink = function _traverseLink(field, record) {
        var storageKey = $3b7db934651fc21b$var$getStorageKey(field, this._variables);
        var linkedID = $7SC8Z.getLinkedRecordID(record, storageKey);
        if (linkedID == null) return;
        this._traverse(field, linkedID);
    };
    _proto._traversePluralLink = function _traversePluralLink(field, record) {
        var _this2 = this;
        var storageKey = $3b7db934651fc21b$var$getStorageKey(field, this._variables);
        var linkedIDs = $7SC8Z.getLinkedRecordIDs(record, storageKey);
        if (linkedIDs == null) return;
        linkedIDs.forEach(function(linkedID) {
            if (linkedID != null) _this2._traverse(field, linkedID);
        });
    };
    return RelayReferenceMarker;
}();
module.exports = {
    mark: $3b7db934651fc21b$var$mark
};

});

parcelRegister("jaTqj", function(module, exports) {
'use strict';
parcelRequire("6GnlG");

var $g0Xjw = parcelRequire("g0Xjw");

var $gZYpt = parcelRequire("gZYpt");

var $hwHLe = parcelRequire("hwHLe");

var $igoM9 = parcelRequire("igoM9");

var $4SqFT = parcelRequire("4SqFT");
var $df59f1716471df73$var$RelayStoreSubscriptions = /*#__PURE__*/ function() {
    function RelayStoreSubscriptions(log, resolverCache, resolverContext) {
        this._subscriptions = new Set();
        this._staleSubscriptions = new Set();
        this.__log = log;
        this._resolverCache = resolverCache;
        this._resolverContext = resolverContext;
    }
    var _proto = RelayStoreSubscriptions.prototype;
    _proto.subscribe = function subscribe(snapshot, callback) {
        var _this = this;
        var subscription = {
            backup: null,
            callback: callback,
            snapshot: snapshot,
            stale: false
        };
        var dispose = function dispose() {
            _this._subscriptions["delete"](subscription);
            if ($gZYpt.OPTIMIZE_NOTIFY && subscription.stale) _this._staleSubscriptions["delete"](subscription);
        };
        this._subscriptions.add(subscription);
        return {
            dispose: dispose
        };
    };
    _proto.snapshotSubscriptions = function snapshotSubscriptions(source) {
        var _this2 = this;
        this._subscriptions.forEach(function(subscription) {
            if (!subscription.stale) {
                subscription.backup = subscription.snapshot;
                return;
            }
            var snapshot = subscription.snapshot;
            var backup = $4SqFT.read(source, snapshot.selector, _this2.__log, _this2._resolverCache, _this2._resolverContext);
            var nextData = $g0Xjw(snapshot.data, backup.data);
            backup.data = nextData;
            subscription.backup = backup;
        });
    };
    _proto.restoreSubscriptions = function restoreSubscriptions() {
        var _this3 = this;
        this._subscriptions.forEach(function(subscription) {
            var backup = subscription.backup;
            subscription.backup = null;
            if (backup) {
                if (backup.data !== subscription.snapshot.data) {
                    subscription.stale = true;
                    if ($gZYpt.OPTIMIZE_NOTIFY) _this3._staleSubscriptions.add(subscription);
                }
                subscription.snapshot = {
                    data: subscription.snapshot.data,
                    fieldErrors: backup.fieldErrors,
                    isMissingData: backup.isMissingData,
                    missingClientEdges: backup.missingClientEdges,
                    missingLiveResolverFields: backup.missingLiveResolverFields,
                    seenRecords: backup.seenRecords,
                    selector: backup.selector
                };
            } else {
                subscription.stale = true;
                if ($gZYpt.OPTIMIZE_NOTIFY) _this3._staleSubscriptions.add(subscription);
            }
        });
    };
    _proto.updateSubscriptions = function updateSubscriptions(source, updatedRecordIDs, updatedOwners, sourceOperation) {
        var _this4 = this;
        var hasUpdatedRecords = updatedRecordIDs.size !== 0;
        this._subscriptions.forEach(function(subscription) {
            var owner = _this4._updateSubscription(source, subscription, updatedRecordIDs, hasUpdatedRecords, sourceOperation);
            if (owner != null) updatedOwners.push(owner);
        });
    };
    _proto.updateStaleSubscriptions = function updateStaleSubscriptions(source, updatedRecordIDs, updatedOwners, sourceOperation) {
        var _this5 = this;
        var hasUpdatedRecords = updatedRecordIDs.size !== 0;
        this._staleSubscriptions.forEach(function(subscription) {
            var owner = _this5._updateSubscription(source, subscription, updatedRecordIDs, hasUpdatedRecords, sourceOperation);
            if (owner != null) updatedOwners.push(owner);
        });
    };
    _proto._updateSubscription = function _updateSubscription(source, subscription, updatedRecordIDs, hasUpdatedRecords, sourceOperation) {
        var backup = subscription.backup, callback = subscription.callback, snapshot = subscription.snapshot, stale = subscription.stale;
        var hasOverlappingUpdates = hasUpdatedRecords && $hwHLe(snapshot.seenRecords, updatedRecordIDs);
        if (!stale && !hasOverlappingUpdates) return;
        var nextSnapshot = hasOverlappingUpdates || !backup ? $4SqFT.read(source, snapshot.selector, this.__log, this._resolverCache, this._resolverContext) : backup;
        var nextData = $g0Xjw(snapshot.data, nextSnapshot.data);
        nextSnapshot = {
            data: nextData,
            fieldErrors: nextSnapshot.fieldErrors,
            isMissingData: nextSnapshot.isMissingData,
            missingClientEdges: nextSnapshot.missingClientEdges,
            missingLiveResolverFields: nextSnapshot.missingLiveResolverFields,
            seenRecords: nextSnapshot.seenRecords,
            selector: nextSnapshot.selector
        };
        subscription.snapshot = nextSnapshot;
        subscription.stale = false;
        if ($gZYpt.OPTIMIZE_NOTIFY && stale) this._staleSubscriptions["delete"](subscription);
        if (nextSnapshot.data !== snapshot.data) {
            if (this.__log && $gZYpt.ENABLE_NOTIFY_SUBSCRIPTION) this.__log({
                name: 'store.notify.subscription',
                nextSnapshot: nextSnapshot,
                snapshot: snapshot,
                sourceOperation: sourceOperation
            });
            callback(nextSnapshot);
            return snapshot.selector.owner;
        }
        if ($gZYpt.ENABLE_LOOSE_SUBSCRIPTION_ATTRIBUTION && (stale || $igoM9(snapshot.seenRecords, updatedRecordIDs))) return snapshot.selector.owner;
    };
    _proto.size = function size() {
        return this._subscriptions.size;
    };
    return RelayStoreSubscriptions;
}();
module.exports = $df59f1716471df73$var$RelayStoreSubscriptions;

});
parcelRegister("hwHLe", function(module, exports) {
'use strict';
var $cc275ec97fa2c726$var$ITERATOR_KEY = Symbol.iterator;
function $cc275ec97fa2c726$var$hasOverlappingIDs(seenRecords, updatedRecordIDs) {
    var iterator = seenRecords[$cc275ec97fa2c726$var$ITERATOR_KEY]();
    var next = iterator.next();
    while(!next.done){
        var key = next.value;
        if (updatedRecordIDs.has(key)) return true;
        next = iterator.next();
    }
    return false;
}
module.exports = $cc275ec97fa2c726$var$hasOverlappingIDs;

});

parcelRegister("igoM9", function(module, exports) {
'use strict';

var $ezyIu = parcelRequire("ezyIu");
var $d4bcf089f5530cbd$var$ROOT_ID = $ezyIu.ROOT_ID;

var $fsmz0 = parcelRequire("fsmz0");
var $d4bcf089f5530cbd$var$VIEWER_ID = $fsmz0.VIEWER_ID;
var $d4bcf089f5530cbd$var$ITERATOR_KEY = Symbol.iterator;
function $d4bcf089f5530cbd$var$hasSignificantOverlappingIDs(seenRecords, updatedRecordIDs) {
    var iterator = seenRecords[$d4bcf089f5530cbd$var$ITERATOR_KEY]();
    var next = iterator.next();
    while(!next.done){
        var key = next.value;
        if (updatedRecordIDs.has(key) && key !== $d4bcf089f5530cbd$var$ROOT_ID && key !== $d4bcf089f5530cbd$var$VIEWER_ID) return true;
        next = iterator.next();
    }
    return false;
}
module.exports = $d4bcf089f5530cbd$var$hasSignificantOverlappingIDs;

});



parcelRegister("cTg53", function(module, exports) {
'use strict';
var $9627185690087895$var$_global$ErrorUtils$ap, $9627185690087895$var$_global$ErrorUtils;

var $7MnPa = parcelRequire("7MnPa");

var $9ZaBf = parcelRequire("9ZaBf");

var $6uwqh = parcelRequire("6uwqh");

var $gZYpt = parcelRequire("gZYpt");

var $4SqFT = parcelRequire("4SqFT");

var $3fbkc = parcelRequire("3fbkc");

var $jSI6G = parcelRequire("jSI6G");
parcelRequire("2OmBw");
var $9627185690087895$var$_global = typeof $parcel$global !== 'undefined' ? $parcel$global : typeof window !== 'undefined' ? window : undefined;
var $9627185690087895$var$applyWithGuard = ($9627185690087895$var$_global$ErrorUtils$ap = $9627185690087895$var$_global === null || $9627185690087895$var$_global === void 0 ? void 0 : ($9627185690087895$var$_global$ErrorUtils = $9627185690087895$var$_global.ErrorUtils) === null || $9627185690087895$var$_global$ErrorUtils === void 0 ? void 0 : $9627185690087895$var$_global$ErrorUtils.applyWithGuard) !== null && $9627185690087895$var$_global$ErrorUtils$ap !== void 0 ? $9627185690087895$var$_global$ErrorUtils$ap : function(callback, context, args, onError, name) {
    return callback.apply(context, args);
};
var $9627185690087895$var$RelayPublishQueue = /*#__PURE__*/ function() {
    function RelayPublishQueue(store, handlerProvider, getDataID, missingFieldHandlers, log) {
        this._hasStoreSnapshot = false;
        this._handlerProvider = handlerProvider || null;
        this._pendingBackupRebase = false;
        this._pendingData = new Set();
        this._pendingOptimisticUpdates = new Set();
        this._store = store;
        this._appliedOptimisticUpdates = new Set();
        this._gcHold = null;
        this._getDataID = getDataID;
        this._missingFieldHandlers = missingFieldHandlers;
        this._log = log;
    }
    var _proto = RelayPublishQueue.prototype;
    _proto.applyUpdate = function applyUpdate(updater) {
        !(!this._appliedOptimisticUpdates.has(updater) && !this._pendingOptimisticUpdates.has(updater)) && $jSI6G(false);
        this._pendingOptimisticUpdates.add(updater);
    };
    _proto.revertUpdate = function revertUpdate(updater) {
        if (this._pendingOptimisticUpdates.has(updater)) this._pendingOptimisticUpdates["delete"](updater);
        else if (this._appliedOptimisticUpdates.has(updater)) {
            this._pendingBackupRebase = true;
            this._appliedOptimisticUpdates["delete"](updater);
        }
    };
    _proto.revertAll = function revertAll() {
        this._pendingBackupRebase = true;
        this._pendingOptimisticUpdates.clear();
        this._appliedOptimisticUpdates.clear();
    };
    _proto.commitPayload = function commitPayload(operation, payload, updater) {
        this._pendingBackupRebase = true;
        this._pendingData.add({
            kind: 'payload',
            operation: operation,
            payload: payload,
            updater: updater
        });
    };
    _proto.commitUpdate = function commitUpdate(updater) {
        this._pendingBackupRebase = true;
        this._pendingData.add({
            kind: 'updater',
            updater: updater
        });
    };
    _proto.commitSource = function commitSource(source) {
        this._pendingBackupRebase = true;
        this._pendingData.add({
            kind: 'source',
            source: source
        });
    };
    _proto.run = function run(sourceOperation) {
        var runWillClearGcHold = this._appliedOptimisticUpdates === 0 && !!this._gcHold;
        var runIsANoop = !this._pendingBackupRebase && this._pendingOptimisticUpdates.size === 0 && !runWillClearGcHold;
        $gZYpt.DISALLOW_NESTED_UPDATES && !(this._isRunning !== true) && $jSI6G(false);
        this._isRunning = true;
        if (runIsANoop) {
            this._isRunning = false;
            return [];
        }
        if (this._pendingBackupRebase) {
            if (this._hasStoreSnapshot) {
                this._store.restore();
                this._hasStoreSnapshot = false;
            }
        }
        var invalidatedStore = this._commitData();
        if (this._pendingOptimisticUpdates.size || this._pendingBackupRebase && this._appliedOptimisticUpdates.size) {
            if (!this._hasStoreSnapshot) {
                this._store.snapshot();
                this._hasStoreSnapshot = true;
            }
            this._applyUpdates();
        }
        this._pendingBackupRebase = false;
        if (this._appliedOptimisticUpdates.size > 0) {
            if (!this._gcHold) this._gcHold = this._store.holdGC();
        } else if (this._gcHold) {
            this._gcHold.dispose();
            this._gcHold = null;
        }
        this._isRunning = false;
        return this._store.notify(sourceOperation, invalidatedStore);
    };
    _proto._publishSourceFromPayload = function _publishSourceFromPayload(pendingPayload) {
        var _this = this;
        var payload = pendingPayload.payload, operation = pendingPayload.operation, updater = pendingPayload.updater;
        var source = payload.source, fieldPayloads = payload.fieldPayloads;
        var mutator = new $7MnPa(this._store.getSource(), source);
        var recordSourceProxy = new $9ZaBf(mutator, this._getDataID, this._handlerProvider, this._missingFieldHandlers, this._log);
        if (fieldPayloads && fieldPayloads.length) fieldPayloads.forEach(function(fieldPayload) {
            var handler = _this._handlerProvider && _this._handlerProvider(fieldPayload.handle);
            !handler && $jSI6G(false);
            handler.update(recordSourceProxy, fieldPayload);
        });
        if (updater) {
            var selector = operation.fragment;
            !(selector != null) && $jSI6G(false);
            var recordSourceSelectorProxy = new $6uwqh(mutator, recordSourceProxy, selector, this._missingFieldHandlers);
            var selectorData = $9627185690087895$var$lookupSelector(source, selector);
            updater(recordSourceSelectorProxy, selectorData);
        }
        var idsMarkedForInvalidation = recordSourceProxy.getIDsMarkedForInvalidation();
        this._store.publish(source, idsMarkedForInvalidation);
        return recordSourceProxy.isStoreMarkedForInvalidation();
    };
    _proto._commitData = function _commitData() {
        var _this2 = this;
        if (!this._pendingData.size) return false;
        var invalidatedStore = false;
        this._pendingData.forEach(function(data) {
            if (data.kind === 'payload') {
                var payloadInvalidatedStore = _this2._publishSourceFromPayload(data);
                invalidatedStore = invalidatedStore || payloadInvalidatedStore;
            } else if (data.kind === 'source') {
                var source = data.source;
                _this2._store.publish(source);
            } else {
                var updater = data.updater;
                var sink = $3fbkc.create();
                var mutator = new $7MnPa(_this2._store.getSource(), sink);
                var recordSourceProxy = new $9ZaBf(mutator, _this2._getDataID, _this2._handlerProvider, _this2._missingFieldHandlers, _this2._log);
                $9627185690087895$var$applyWithGuard(updater, null, [
                    recordSourceProxy
                ], null, 'RelayPublishQueue:commitData');
                invalidatedStore = invalidatedStore || recordSourceProxy.isStoreMarkedForInvalidation();
                var idsMarkedForInvalidation = recordSourceProxy.getIDsMarkedForInvalidation();
                _this2._store.publish(sink, idsMarkedForInvalidation);
            }
        });
        this._pendingData.clear();
        return invalidatedStore;
    };
    _proto._applyUpdates = function _applyUpdates() {
        var _this3 = this;
        var sink = $3fbkc.create();
        var mutator = new $7MnPa(this._store.getSource(), sink);
        var recordSourceProxy = new $9ZaBf(mutator, this._getDataID, this._handlerProvider, this._missingFieldHandlers, this._log);
        var processUpdate = function processUpdate(optimisticUpdate) {
            if (optimisticUpdate.storeUpdater) {
                var storeUpdater = optimisticUpdate.storeUpdater;
                $9627185690087895$var$applyWithGuard(storeUpdater, null, [
                    recordSourceProxy
                ], null, 'RelayPublishQueue:applyUpdates');
            } else {
                var operation = optimisticUpdate.operation, payload = optimisticUpdate.payload, updater = optimisticUpdate.updater;
                var source = payload.source, fieldPayloads = payload.fieldPayloads;
                if (source) recordSourceProxy.publishSource(source, fieldPayloads);
                if (updater) {
                    var selectorData;
                    if (source) selectorData = $9627185690087895$var$lookupSelector(source, operation.fragment);
                    var recordSourceSelectorProxy = new $6uwqh(mutator, recordSourceProxy, operation.fragment, _this3._missingFieldHandlers);
                    $9627185690087895$var$applyWithGuard(updater, null, [
                        recordSourceSelectorProxy,
                        selectorData
                    ], null, 'RelayPublishQueue:applyUpdates');
                }
            }
        };
        if (this._pendingBackupRebase && this._appliedOptimisticUpdates.size) this._appliedOptimisticUpdates.forEach(processUpdate);
        if (this._pendingOptimisticUpdates.size) {
            this._pendingOptimisticUpdates.forEach(function(optimisticUpdate) {
                processUpdate(optimisticUpdate);
                _this3._appliedOptimisticUpdates.add(optimisticUpdate);
            });
            this._pendingOptimisticUpdates.clear();
        }
        this._store.publish(sink);
    };
    return RelayPublishQueue;
}();
function $9627185690087895$var$lookupSelector(source, selector) {
    var selectorData = $4SqFT.read(source, selector, null, undefined, undefined).data;
    var deepFreeze;
    return selectorData;
}
module.exports = $9627185690087895$var$RelayPublishQueue;

});
parcelRegister("6uwqh", function(module, exports) {
'use strict';

var $ezyIu = parcelRequire("ezyIu");
var $4b9eb1edb3e3fef4$var$ROOT_TYPE = $ezyIu.ROOT_TYPE, $4b9eb1edb3e3fef4$var$getStorageKey = $ezyIu.getStorageKey;

var $4vRcT = parcelRequire("4vRcT");
var $4b9eb1edb3e3fef4$var$_readUpdatableFragment = $4vRcT.readUpdatableFragment;

var $fVSWx = parcelRequire("fVSWx");
var $4b9eb1edb3e3fef4$var$_readUpdatableQuery = $fVSWx.readUpdatableQuery;

var $jSI6G = parcelRequire("jSI6G");
var $4b9eb1edb3e3fef4$var$RelayRecordSourceSelectorProxy = /*#__PURE__*/ function() {
    function RelayRecordSourceSelectorProxy(mutator, recordSource, readSelector, missingFieldHandlers) {
        this.__mutator = mutator;
        this.__recordSource = recordSource;
        this._readSelector = readSelector;
        this._missingFieldHandlers = missingFieldHandlers;
    }
    var _proto = RelayRecordSourceSelectorProxy.prototype;
    _proto.create = function create(dataID, typeName) {
        return this.__recordSource.create(dataID, typeName);
    };
    _proto["delete"] = function _delete(dataID) {
        this.__recordSource["delete"](dataID);
    };
    _proto.get = function get(dataID) {
        return this.__recordSource.get(dataID);
    };
    _proto.getRoot = function getRoot() {
        return this.__recordSource.getRoot();
    };
    _proto.getOperationRoot = function getOperationRoot() {
        var root = this.__recordSource.get(this._readSelector.dataID);
        if (!root) root = this.__recordSource.create(this._readSelector.dataID, $4b9eb1edb3e3fef4$var$ROOT_TYPE);
        return root;
    };
    _proto._getRootField = function _getRootField(selector, fieldName, plural) {
        var field = selector.node.selections.find(function(selection) {
            return selection.kind === 'LinkedField' && selection.name === fieldName || selection.kind === 'RequiredField' && selection.field.name === fieldName;
        });
        if (field && field.kind === 'RequiredField') field = field.field;
        !(field && field.kind === 'LinkedField') && $jSI6G(false);
        !(field.plural === plural) && $jSI6G(false);
        return field;
    };
    _proto.getRootField = function getRootField(fieldName) {
        var field = this._getRootField(this._readSelector, fieldName, false);
        var storageKey = $4b9eb1edb3e3fef4$var$getStorageKey(field, this._readSelector.variables);
        return this.getOperationRoot().getLinkedRecord(storageKey);
    };
    _proto.getPluralRootField = function getPluralRootField(fieldName) {
        var field = this._getRootField(this._readSelector, fieldName, true);
        var storageKey = $4b9eb1edb3e3fef4$var$getStorageKey(field, this._readSelector.variables);
        return this.getOperationRoot().getLinkedRecords(storageKey);
    };
    _proto.invalidateStore = function invalidateStore() {
        this.__recordSource.invalidateStore();
    };
    _proto.readUpdatableQuery = function readUpdatableQuery(query, variables) {
        return $4b9eb1edb3e3fef4$var$_readUpdatableQuery(query, variables, this, this._missingFieldHandlers);
    };
    _proto.readUpdatableFragment = function readUpdatableFragment(fragment, fragmentReference) {
        return $4b9eb1edb3e3fef4$var$_readUpdatableFragment(fragment, fragmentReference, this, this._missingFieldHandlers);
    };
    return RelayRecordSourceSelectorProxy;
}();
module.exports = $4b9eb1edb3e3fef4$var$RelayRecordSourceSelectorProxy;

});



parcelRegister("bFqt0", function(module, exports) {
'use strict';

var $33gLb = parcelRequire("33gLb");

var $kLQDK = parcelRequire("kLQDK");
var $87e80dd5336e6658$var$getRequest = $kLQDK.getRequest;

var $gCG1q = parcelRequire("gCG1q");
var $87e80dd5336e6658$var$createOperationDescriptor = $gCG1q.createOperationDescriptor;

var $iUq0k = parcelRequire("iUq0k");
var $87e80dd5336e6658$var$createReaderSelector = $iUq0k.createReaderSelector;
parcelRequire("2OmBw");
function $87e80dd5336e6658$var$requestSubscription(environment, config) {
    var subscription = $87e80dd5336e6658$var$getRequest(config.subscription);
    if (subscription.params.operationKind !== 'subscription') throw new Error('requestSubscription: Must use Subscription operation');
    var configs = config.configs, onCompleted = config.onCompleted, onError = config.onError, onNext = config.onNext, variables = config.variables, cacheConfig = config.cacheConfig;
    var operation = $87e80dd5336e6658$var$createOperationDescriptor(subscription, variables, cacheConfig);
    var _ref = configs ? $33gLb.convert(configs, subscription, null, config.updater) : config, updater = _ref.updater;
    var sub = environment.executeSubscription({
        operation: operation,
        updater: updater
    }).subscribe({
        complete: onCompleted,
        error: onError,
        next: function next(responses) {
            if (onNext != null) {
                var selector = operation.fragment;
                var nextID;
                if (Array.isArray(responses)) {
                    var _responses$, _responses$$extension;
                    nextID = (_responses$ = responses[0]) === null || _responses$ === void 0 ? void 0 : (_responses$$extension = _responses$.extensions) === null || _responses$$extension === void 0 ? void 0 : _responses$$extension.__relay_subscription_root_id;
                } else {
                    var _responses$extensions;
                    nextID = (_responses$extensions = responses.extensions) === null || _responses$extensions === void 0 ? void 0 : _responses$extensions.__relay_subscription_root_id;
                }
                if (typeof nextID === 'string') selector = $87e80dd5336e6658$var$createReaderSelector(selector.node, nextID, selector.variables, selector.owner);
                var data = environment.lookup(selector).data;
                onNext(data);
            }
        }
    });
    return {
        dispose: sub.unsubscribe
    };
}
module.exports = $87e80dd5336e6658$var$requestSubscription;

});

parcelRegister("ihKxl", function(module, exports) {
'use strict';

var $e27SU = parcelRequire("e27SU");
var $d4fde9c9a446618a$var$_interopRequireDefault = $e27SU.default;

var $d4fde9c9a446618a$var$_objectSpread2 = $d4fde9c9a446618a$var$_interopRequireDefault((parcelRequire("caqem")));

var $ezyIu = parcelRequire("ezyIu");
var $d4fde9c9a446618a$var$getModuleComponentKey = $ezyIu.getModuleComponentKey, $d4fde9c9a446618a$var$getModuleOperationKey = $ezyIu.getModuleOperationKey;
function $d4fde9c9a446618a$var$createPayloadFor3DField(name, operation, component, response) {
    var data = (0, $d4fde9c9a446618a$var$_objectSpread2["default"])({}, response);
    data[$d4fde9c9a446618a$var$getModuleComponentKey(name)] = component;
    data[$d4fde9c9a446618a$var$getModuleOperationKey(name)] = operation;
    return data;
}
module.exports = $d4fde9c9a446618a$var$createPayloadFor3DField;

});

parcelRegister("ishKi", function(module, exports) {
'use strict';

var $iUq0k = parcelRequire("iUq0k");
var $d6f89b714835fd38$var$getDataIDsFromFragment = $iUq0k.getDataIDsFromFragment, $d6f89b714835fd38$var$getSelector = $iUq0k.getSelector, $d6f89b714835fd38$var$getVariablesFromFragment = $iUq0k.getVariablesFromFragment;

var $dy2OZ = parcelRequire("dy2OZ");

var $gZYpt = parcelRequire("gZYpt");

var $4hUjJ = parcelRequire("4hUjJ");
var $d6f89b714835fd38$var$stableCopy = $4hUjJ.stableCopy;

var $d7PSX = parcelRequire("d7PSX");
var $d6f89b714835fd38$var$intern = $d7PSX.intern;
function $d6f89b714835fd38$var$getFragmentIdentifier(fragmentNode, fragmentRef) {
    var selector = $d6f89b714835fd38$var$getSelector(fragmentNode, fragmentRef);
    var fragmentOwnerIdentifier = selector == null ? 'null' : selector.kind === 'SingularReaderSelector' ? selector.owner.identifier : '[' + selector.selectors.map(function(sel) {
        return sel.owner.identifier;
    }).join(',') + ']';
    var fragmentVariables = $d6f89b714835fd38$var$getVariablesFromFragment(fragmentNode, fragmentRef);
    var dataIDs = $d6f89b714835fd38$var$getDataIDsFromFragment(fragmentNode, fragmentRef);
    if ($gZYpt.ENABLE_GETFRAGMENTIDENTIFIER_OPTIMIZATION) {
        var ids = typeof dataIDs === 'undefined' ? 'missing' : dataIDs == null ? 'null' : Array.isArray(dataIDs) ? '[' + dataIDs.join(',') + ']' : dataIDs;
        ids = $gZYpt.STRING_INTERN_LEVEL <= 1 ? ids : $d6f89b714835fd38$var$intern(ids, $gZYpt.MAX_DATA_ID_LENGTH);
        return fragmentOwnerIdentifier + '/' + fragmentNode.name + '/' + (fragmentVariables == null || $dy2OZ(fragmentVariables) ? '{}' : JSON.stringify($d6f89b714835fd38$var$stableCopy(fragmentVariables))) + '/' + ids;
    } else {
        var _JSON$stringify;
        var _ids = (_JSON$stringify = JSON.stringify(dataIDs)) !== null && _JSON$stringify !== void 0 ? _JSON$stringify : 'missing';
        _ids = $gZYpt.STRING_INTERN_LEVEL <= 1 ? _ids : $d6f89b714835fd38$var$intern(_ids, $gZYpt.MAX_DATA_ID_LENGTH);
        return fragmentOwnerIdentifier + '/' + fragmentNode.name + '/' + JSON.stringify($d6f89b714835fd38$var$stableCopy(fragmentVariables)) + '/' + _ids;
    }
}
module.exports = $d6f89b714835fd38$var$getFragmentIdentifier;

});
parcelRegister("dy2OZ", function(module, exports) {
'use strict';
var $9dd0a39ef3cd69d3$var$hasOwnProperty = Object.prototype.hasOwnProperty;
function $9dd0a39ef3cd69d3$var$isEmptyObject(obj) {
    for(var _key in obj){
        if ($9dd0a39ef3cd69d3$var$hasOwnProperty.call(obj, _key)) return false;
    }
    return true;
}
module.exports = $9dd0a39ef3cd69d3$var$isEmptyObject;

});


parcelRegister("bEO5H", function(module, exports) {
'use strict';

var $1zv2Y = parcelRequire("1zv2Y");

var $jSI6G = parcelRequire("jSI6G");
function $87ca49237e6395f2$var$getPaginationMetadata(fragmentNode, componentDisplayName) {
    var _fragmentNode$metadat, _fragmentNode$metadat2;
    var _getRefetchMetadata = $1zv2Y(fragmentNode, componentDisplayName), paginationRequest = _getRefetchMetadata.refetchableRequest, refetchMetadata = _getRefetchMetadata.refetchMetadata;
    var paginationMetadata = refetchMetadata.connection;
    !(paginationMetadata != null) && $jSI6G(false);
    var connectionPathInFragmentData = paginationMetadata.path;
    var connectionMetadata = ((_fragmentNode$metadat = (_fragmentNode$metadat2 = fragmentNode.metadata) === null || _fragmentNode$metadat2 === void 0 ? void 0 : _fragmentNode$metadat2.connection) !== null && _fragmentNode$metadat !== void 0 ? _fragmentNode$metadat : [])[0];
    !(connectionMetadata != null) && $jSI6G(false);
    var identifierInfo = refetchMetadata.identifierInfo;
    !((identifierInfo === null || identifierInfo === void 0 ? void 0 : identifierInfo.identifierField) == null || typeof identifierInfo.identifierField === 'string') && $jSI6G(false);
    return {
        connectionPathInFragmentData: connectionPathInFragmentData,
        identifierField: identifierInfo === null || identifierInfo === void 0 ? void 0 : identifierInfo.identifierField,
        paginationRequest: paginationRequest,
        paginationMetadata: paginationMetadata,
        stream: connectionMetadata.stream === true
    };
}
module.exports = $87ca49237e6395f2$var$getPaginationMetadata;

});
parcelRegister("1zv2Y", function(module, exports) {
'use strict';

var $jSI6G = parcelRequire("jSI6G");
function $1251249929111203$var$getRefetchMetadata(fragmentNode, componentDisplayName) {
    var _fragmentNode$metadat, _fragmentNode$metadat2;
    !(((_fragmentNode$metadat = fragmentNode.metadata) === null || _fragmentNode$metadat === void 0 ? void 0 : _fragmentNode$metadat.plural) !== true) && $jSI6G(false);
    var refetchMetadata = (_fragmentNode$metadat2 = fragmentNode.metadata) === null || _fragmentNode$metadat2 === void 0 ? void 0 : _fragmentNode$metadat2.refetch;
    !(refetchMetadata != null) && $jSI6G(false);
    var refetchableRequest = refetchMetadata.operation["default"] ? refetchMetadata.operation["default"] : refetchMetadata.operation;
    var fragmentRefPathInResponse = refetchMetadata.fragmentPathInResult;
    !(typeof refetchableRequest !== 'string') && $jSI6G(false);
    var identifierInfo = refetchMetadata.identifierInfo;
    if (identifierInfo != null) {
        !(identifierInfo.identifierField == null || typeof identifierInfo.identifierField === 'string') && $jSI6G(false);
        !(identifierInfo.identifierQueryVariableName == null || typeof identifierInfo.identifierQueryVariableName === 'string') && $jSI6G(false);
    }
    return {
        fragmentRefPathInResponse: fragmentRefPathInResponse,
        identifierInfo: identifierInfo,
        refetchableRequest: refetchableRequest,
        refetchMetadata: refetchMetadata
    };
}
module.exports = $1251249929111203$var$getRefetchMetadata;

});


parcelRegister("bA9MN", function(module, exports) {
'use strict';

var $e27SU = parcelRequire("e27SU");
var $86eaa5d3e1157653$var$_interopRequireDefault = $e27SU.default;

var $86eaa5d3e1157653$var$_defineProperty2 = $86eaa5d3e1157653$var$_interopRequireDefault((parcelRequire("2JBpp")));

var $86eaa5d3e1157653$var$_objectSpread4 = $86eaa5d3e1157653$var$_interopRequireDefault((parcelRequire("caqem")));

var $jSI6G = parcelRequire("jSI6G");
parcelRequire("2OmBw");
function $86eaa5d3e1157653$var$getPaginationVariables(direction, count, cursor, baseVariables, extraVariables, paginationMetadata) {
    var _objectSpread3;
    var backwardMetadata = paginationMetadata.backward, forwardMetadata = paginationMetadata.forward;
    if (direction === 'backward') {
        var _objectSpread2;
        !(backwardMetadata != null && backwardMetadata.count != null && backwardMetadata.cursor != null) && $jSI6G(false);
        var _paginationVariables = (0, $86eaa5d3e1157653$var$_objectSpread4["default"])((0, $86eaa5d3e1157653$var$_objectSpread4["default"])((0, $86eaa5d3e1157653$var$_objectSpread4["default"])({}, baseVariables), extraVariables), {}, (_objectSpread2 = {}, (0, $86eaa5d3e1157653$var$_defineProperty2["default"])(_objectSpread2, backwardMetadata.cursor, cursor), (0, $86eaa5d3e1157653$var$_defineProperty2["default"])(_objectSpread2, backwardMetadata.count, count), _objectSpread2));
        if (forwardMetadata && forwardMetadata.cursor) _paginationVariables[forwardMetadata.cursor] = null;
        if (forwardMetadata && forwardMetadata.count) _paginationVariables[forwardMetadata.count] = null;
        return _paginationVariables;
    }
    !(forwardMetadata != null && forwardMetadata.count != null && forwardMetadata.cursor != null) && $jSI6G(false);
    var paginationVariables = (0, $86eaa5d3e1157653$var$_objectSpread4["default"])((0, $86eaa5d3e1157653$var$_objectSpread4["default"])((0, $86eaa5d3e1157653$var$_objectSpread4["default"])({}, baseVariables), extraVariables), {}, (_objectSpread3 = {}, (0, $86eaa5d3e1157653$var$_defineProperty2["default"])(_objectSpread3, forwardMetadata.cursor, cursor), (0, $86eaa5d3e1157653$var$_defineProperty2["default"])(_objectSpread3, forwardMetadata.count, count), _objectSpread3));
    if (backwardMetadata && backwardMetadata.cursor) paginationVariables[backwardMetadata.cursor] = null;
    if (backwardMetadata && backwardMetadata.count) paginationVariables[backwardMetadata.count] = null;
    return paginationVariables;
}
module.exports = $86eaa5d3e1157653$var$getPaginationVariables;

});

parcelRegister("fTJz1", function(module, exports) {
'use strict';

var $e27SU = parcelRequire("e27SU");
var $b92f5617a3bf8c0d$var$_interopRequireDefault = $e27SU.default;

var $b92f5617a3bf8c0d$var$_createForOfIteratorHelper2 = $b92f5617a3bf8c0d$var$_interopRequireDefault((parcelRequire("5dSyV")));

var $jSI6G = parcelRequire("jSI6G");
function $b92f5617a3bf8c0d$var$getValueAtPath(data, path) {
    var result = data;
    var _iterator = (0, $b92f5617a3bf8c0d$var$_createForOfIteratorHelper2["default"])(path), _step;
    try {
        for(_iterator.s(); !(_step = _iterator.n()).done;){
            var key = _step.value;
            if (result == null) return null;
            if (typeof key === 'number') {
                !Array.isArray(result) && $jSI6G(false);
                result = result[key];
            } else {
                !(typeof result === 'object' && !Array.isArray(result)) && $jSI6G(false);
                result = result[key];
            }
        }
    } catch (err) {
        _iterator.e(err);
    } finally{
        _iterator.f();
    }
    return result;
}
module.exports = $b92f5617a3bf8c0d$var$getValueAtPath;

});

parcelRegister("3u5Sb", function(module, exports) {
'use strict';
var $2898bab019e56ed3$var$profileHandlersByName = {};
var $2898bab019e56ed3$var$defaultProfiler = {
    stop: function stop() {}
};
var $2898bab019e56ed3$var$RelayProfiler = {
    profile: function profile(name, state) {
        var handlers = $2898bab019e56ed3$var$profileHandlersByName[name];
        if (handlers && handlers.length > 0) {
            var stopHandlers = [];
            for(var ii = handlers.length - 1; ii >= 0; ii--){
                var stopHandler = handlers[ii](name, state);
                stopHandlers.unshift(stopHandler);
            }
            return {
                stop: function stop(error) {
                    stopHandlers.forEach(function(stopHandler) {
                        return stopHandler(error);
                    });
                }
            };
        }
        return $2898bab019e56ed3$var$defaultProfiler;
    },
    attachProfileHandler: function attachProfileHandler(name, handler) {
        if (!$2898bab019e56ed3$var$profileHandlersByName.hasOwnProperty(name)) $2898bab019e56ed3$var$profileHandlersByName[name] = [];
        $2898bab019e56ed3$var$profileHandlersByName[name].push(handler);
    },
    detachProfileHandler: function detachProfileHandler(name, handler) {
        if ($2898bab019e56ed3$var$profileHandlersByName.hasOwnProperty(name)) $2898bab019e56ed3$var$removeFromArray($2898bab019e56ed3$var$profileHandlersByName[name], handler);
    }
};
function $2898bab019e56ed3$var$removeFromArray(array, element) {
    var index = array.indexOf(element);
    if (index !== -1) array.splice(index, 1);
}
module.exports = $2898bab019e56ed3$var$RelayProfiler;

});




parcelRegister("aWCOu", function(module, exports) {
'use strict';

var $drPJO = parcelRequire("drPJO");
var $7f7d6db28ae39766$var$_interopRequireDefault = $drPJO.default;

var $7f7d6db28ae39766$var$_extends2 = $7f7d6db28ae39766$var$_interopRequireDefault((parcelRequire("9K8n8")));

var $7f7d6db28ae39766$var$_objectWithoutPropertiesLoose2 = $7f7d6db28ae39766$var$_interopRequireDefault((parcelRequire("gyI5Y")));

var $7f7d6db28ae39766$var$_assertThisInitialized2 = $7f7d6db28ae39766$var$_interopRequireDefault((parcelRequire("9stWB")));

var $7f7d6db28ae39766$var$_inheritsLoose2 = $7f7d6db28ae39766$var$_interopRequireDefault((parcelRequire("1tj17")));

var $7f7d6db28ae39766$var$_defineProperty2 = $7f7d6db28ae39766$var$_interopRequireDefault((parcelRequire("gPhXO")));
var $7f7d6db28ae39766$var$_excluded = [
    "componentRef",
    "__relayContext",
    "__rootIsQueryRenderer"
];

var $iVKxO = parcelRequire("iVKxO");

var $3M1UF = parcelRequire("3M1UF");
var $7f7d6db28ae39766$var$getContainerName = $3M1UF.getContainerName;

var $f8R7U = parcelRequire("f8R7U");
var $7f7d6db28ae39766$var$assertRelayContext = $f8R7U.assertRelayContext;

var $bke7t = parcelRequire("bke7t");

var $5FkrB = parcelRequire("5FkrB");

var $7eKmg = parcelRequire("7eKmg");
var $7f7d6db28ae39766$var$createFragmentSpecResolver = $7eKmg.createFragmentSpecResolver, $7f7d6db28ae39766$var$getDataIDsFromObject = $7eKmg.getDataIDsFromObject, $7f7d6db28ae39766$var$isScalarAndEqual = $7eKmg.isScalarAndEqual;
function $7f7d6db28ae39766$var$createContainerWithFragments(Component, fragments) {
    var _class;
    var containerName = $7f7d6db28ae39766$var$getContainerName(Component);
    return _class = /*#__PURE__*/ function(_React$Component) {
        (0, $7f7d6db28ae39766$var$_inheritsLoose2["default"])(_class, _React$Component);
        function _class(props) {
            var _props$__rootIsQueryR, _this;
            _this = _React$Component.call(this, props) || this;
            (0, $7f7d6db28ae39766$var$_defineProperty2["default"])((0, $7f7d6db28ae39766$var$_assertThisInitialized2["default"])(_this), "_handleFragmentDataUpdate", function() {
                var resolverFromThisUpdate = _this.state.resolver;
                _this.setState(function(updatedState) {
                    return resolverFromThisUpdate === updatedState.resolver ? {
                        data: updatedState.resolver.resolve(),
                        relayProp: $7f7d6db28ae39766$var$getRelayProp(updatedState.relayProp.environment)
                    } : null;
                });
            });
            var relayContext = $7f7d6db28ae39766$var$assertRelayContext(props.__relayContext);
            var rootIsQueryRenderer = (_props$__rootIsQueryR = props.__rootIsQueryRenderer) !== null && _props$__rootIsQueryR !== void 0 ? _props$__rootIsQueryR : false;
            var resolver = $7f7d6db28ae39766$var$createFragmentSpecResolver(relayContext, containerName, fragments, props, rootIsQueryRenderer);
            _this.state = {
                data: resolver.resolve(),
                prevProps: props,
                prevPropsContext: relayContext,
                relayProp: $7f7d6db28ae39766$var$getRelayProp(relayContext.environment),
                resolver: resolver
            };
            return _this;
        }
        _class.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, prevState) {
            var _nextProps$__rootIsQu;
            var prevProps = prevState.prevProps;
            var relayContext = $7f7d6db28ae39766$var$assertRelayContext(nextProps.__relayContext);
            var rootIsQueryRenderer = (_nextProps$__rootIsQu = nextProps.__rootIsQueryRenderer) !== null && _nextProps$__rootIsQu !== void 0 ? _nextProps$__rootIsQu : false;
            var prevIDs = $7f7d6db28ae39766$var$getDataIDsFromObject(fragments, prevProps);
            var nextIDs = $7f7d6db28ae39766$var$getDataIDsFromObject(fragments, nextProps);
            var resolver = prevState.resolver;
            if (prevState.prevPropsContext.environment !== relayContext.environment || !$bke7t(prevIDs, nextIDs)) {
                resolver = $7f7d6db28ae39766$var$createFragmentSpecResolver(relayContext, containerName, fragments, nextProps, rootIsQueryRenderer);
                return {
                    data: resolver.resolve(),
                    prevProps: nextProps,
                    prevPropsContext: relayContext,
                    relayProp: $7f7d6db28ae39766$var$getRelayProp(relayContext.environment),
                    resolver: resolver
                };
            } else {
                resolver.setProps(nextProps);
                var data = resolver.resolve();
                if (data !== prevState.data) return {
                    data: data,
                    prevProps: nextProps,
                    prevPropsContext: relayContext,
                    relayProp: $7f7d6db28ae39766$var$getRelayProp(relayContext.environment)
                };
            }
            return null;
        };
        var _proto = _class.prototype;
        _proto.componentDidMount = function componentDidMount() {
            this._subscribeToNewResolverAndRerenderIfStoreHasChanged();
        };
        _proto.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
            if (this.state.resolver !== prevState.resolver) {
                prevState.resolver.dispose();
                this._subscribeToNewResolverAndRerenderIfStoreHasChanged();
            } else this._rerenderIfStoreHasChanged();
        };
        _proto.componentWillUnmount = function componentWillUnmount() {
            this.state.resolver.dispose();
        };
        _proto.shouldComponentUpdate = function shouldComponentUpdate(nextProps, nextState) {
            if (nextState.data !== this.state.data) return true;
            var keys = Object.keys(nextProps);
            for(var ii = 0; ii < keys.length; ii++){
                var key = keys[ii];
                if (key === '__relayContext') {
                    if (nextState.prevPropsContext.environment !== this.state.prevPropsContext.environment) return true;
                } else {
                    if (!fragments.hasOwnProperty(key) && !$7f7d6db28ae39766$var$isScalarAndEqual(nextProps[key], this.props[key])) return true;
                }
            }
            return false;
        };
        _proto._rerenderIfStoreHasChanged = function _rerenderIfStoreHasChanged() {
            var _this$state = this.state, data = _this$state.data, resolver = _this$state.resolver;
            var maybeNewData = resolver.resolve();
            if (data !== maybeNewData) this.setState({
                data: maybeNewData
            });
        };
        _proto._subscribeToNewResolverAndRerenderIfStoreHasChanged = function _subscribeToNewResolverAndRerenderIfStoreHasChanged() {
            var _this$state2 = this.state, data = _this$state2.data, resolver = _this$state2.resolver;
            var maybeNewData = resolver.resolve();
            resolver.setCallback(this.props, this._handleFragmentDataUpdate);
            if (data !== maybeNewData) this.setState({
                data: maybeNewData
            });
        };
        _proto.render = function render() {
            var _this$props = this.props, componentRef = _this$props.componentRef, __relayContext = _this$props.__relayContext, __rootIsQueryRenderer = _this$props.__rootIsQueryRenderer, props = (0, $7f7d6db28ae39766$var$_objectWithoutPropertiesLoose2["default"])(_this$props, $7f7d6db28ae39766$var$_excluded);
            return /*#__PURE__*/ $5FkrB.createElement(Component, (0, $7f7d6db28ae39766$var$_extends2["default"])({}, props, this.state.data, {
                ref: componentRef,
                relay: this.state.relayProp
            }));
        };
        return _class;
    }($5FkrB.Component), (0, $7f7d6db28ae39766$var$_defineProperty2["default"])(_class, "displayName", containerName), _class;
}
function $7f7d6db28ae39766$var$getRelayProp(environment) {
    return {
        environment: environment
    };
}
function $7f7d6db28ae39766$var$createContainer(Component, fragmentSpec) {
    return $iVKxO(Component, fragmentSpec, $7f7d6db28ae39766$var$createContainerWithFragments);
}
module.exports = {
    createContainer: $7f7d6db28ae39766$var$createContainer
};

});
parcelRegister("drPJO", function(module, exports) {
function $9ca5ee0e90525def$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
module.exports = $9ca5ee0e90525def$var$_interopRequireDefault, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("9K8n8", function(module, exports) {
function $717ee7750861d780$var$_extends() {
    return module.exports = $717ee7750861d780$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $717ee7750861d780$var$_extends.apply(null, arguments);
}
module.exports = $717ee7750861d780$var$_extends, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("gyI5Y", function(module, exports) {
function $c0e206bb1051e6b2$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
module.exports = $c0e206bb1051e6b2$var$_objectWithoutPropertiesLoose, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("9stWB", function(module, exports) {
function $6e2df4dc2e2d43ba$var$_assertThisInitialized(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
}
module.exports = $6e2df4dc2e2d43ba$var$_assertThisInitialized, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("1tj17", function(module, exports) {

var $bM3dF = parcelRequire("bM3dF");
function $11274045b7e0cc2d$var$_inheritsLoose(t, o) {
    t.prototype = Object.create(o.prototype), t.prototype.constructor = t, $bM3dF(t, o);
}
module.exports = $11274045b7e0cc2d$var$_inheritsLoose, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("bM3dF", function(module, exports) {
function $8926acba680afd19$var$_setPrototypeOf(t, e) {
    return module.exports = $8926acba680afd19$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $8926acba680afd19$var$_setPrototypeOf(t, e);
}
module.exports = $8926acba680afd19$var$_setPrototypeOf, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("gPhXO", function(module, exports) {

var $azHwb = parcelRequire("azHwb");
function $c3ff57f8c5f8557e$var$_defineProperty(e, r, t) {
    return (r = $azHwb(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
module.exports = $c3ff57f8c5f8557e$var$_defineProperty, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("azHwb", function(module, exports) {

var $2etD8 = parcelRequire("2etD8");
var $7b2eee0888109d3b$var$_typeof = $2etD8.default;

var $a1ze3 = parcelRequire("a1ze3");
function $7b2eee0888109d3b$var$toPropertyKey(t) {
    var i = $a1ze3(t, "string");
    return "symbol" == $7b2eee0888109d3b$var$_typeof(i) ? i : i + "";
}
module.exports = $7b2eee0888109d3b$var$toPropertyKey, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("2etD8", function(module, exports) {
function $1a03df7fc2b040ef$var$_typeof(o) {
    "@babel/helpers - typeof";
    return module.exports = $1a03df7fc2b040ef$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $1a03df7fc2b040ef$var$_typeof(o);
}
module.exports = $1a03df7fc2b040ef$var$_typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("a1ze3", function(module, exports) {

var $2etD8 = parcelRequire("2etD8");
var $74c552790818f556$var$_typeof = $2etD8.default;
function $74c552790818f556$var$toPrimitive(t, r) {
    if ("object" != $74c552790818f556$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $74c552790818f556$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
module.exports = $74c552790818f556$var$toPrimitive, module.exports.__esModule = true, module.exports["default"] = module.exports;

});



parcelRegister("iVKxO", function(module, exports) {
'use strict';

var $drPJO = parcelRequire("drPJO");
var $dc81a7a0813ae72b$var$_interopRequireDefault = $drPJO.default;

var $dc81a7a0813ae72b$var$_extends2 = $dc81a7a0813ae72b$var$_interopRequireDefault((parcelRequire("9K8n8")));

var $12ZUK = parcelRequire("12ZUK");

var $3M1UF = parcelRequire("3M1UF");
var $dc81a7a0813ae72b$var$getComponentName = $3M1UF.getComponentName, $dc81a7a0813ae72b$var$getContainerName = $3M1UF.getContainerName;

var $8FWpR = parcelRequire("8FWpR");

var $4zxIN = parcelRequire("4zxIN");

var $jSI6G = parcelRequire("jSI6G");

var $5FkrB = parcelRequire("5FkrB");

var $7eKmg = parcelRequire("7eKmg");
var $dc81a7a0813ae72b$var$getFragment = $7eKmg.getFragment;
var $dc81a7a0813ae72b$var$useContext = $5FkrB.useContext;
function $dc81a7a0813ae72b$var$buildReactRelayContainer(ComponentClass, fragmentSpec, createContainerWithFragments) {
    var containerName = $dc81a7a0813ae72b$var$getContainerName(ComponentClass);
    $12ZUK($dc81a7a0813ae72b$var$getComponentName(ComponentClass), fragmentSpec);
    var fragments = {};
    for(var key in fragmentSpec)fragments[key] = $dc81a7a0813ae72b$var$getFragment(fragmentSpec[key]);
    var Container = createContainerWithFragments(ComponentClass, fragments);
    Container.displayName = containerName;
    function ForwardRef(props, ref) {
        var _queryRendererContext;
        var context = $dc81a7a0813ae72b$var$useContext($8FWpR);
        !(context != null) && $jSI6G(false);
        var queryRendererContext = $dc81a7a0813ae72b$var$useContext($4zxIN);
        return /*#__PURE__*/ $5FkrB.createElement(Container, (0, $dc81a7a0813ae72b$var$_extends2["default"])({}, props, {
            __relayContext: context,
            __rootIsQueryRenderer: (_queryRendererContext = queryRendererContext === null || queryRendererContext === void 0 ? void 0 : queryRendererContext.rootIsQueryRenderer) !== null && _queryRendererContext !== void 0 ? _queryRendererContext : false,
            componentRef: props.componentRef || ref
        }));
    }
    ForwardRef.displayName = containerName;
    var ForwardContainer = $5FkrB.forwardRef(ForwardRef);
    return ForwardContainer;
}
module.exports = $dc81a7a0813ae72b$var$buildReactRelayContainer;

});
parcelRegister("12ZUK", function(module, exports) {
'use strict';

var $jSI6G = parcelRequire("jSI6G");
function $0c36013859d66052$var$assertFragmentMap(componentName, fragmentSpec) {
    !(fragmentSpec && typeof fragmentSpec === 'object') && $jSI6G(false);
    for(var key in fragmentSpec)if (fragmentSpec.hasOwnProperty(key)) {
        var fragment = fragmentSpec[key];
        !(fragment && (typeof fragment === 'object' || typeof fragment === 'function')) && $jSI6G(false);
    }
}
module.exports = $0c36013859d66052$var$assertFragmentMap;

});

parcelRegister("3M1UF", function(module, exports) {
'use strict';
function $2bf756b2518e7da4$var$getComponentName(component) {
    return component.displayName || component.name || 'Component';
}
function $2bf756b2518e7da4$var$getContainerName(Component) {
    return 'Relay(' + $2bf756b2518e7da4$var$getComponentName(Component) + ')';
}
module.exports = {
    getComponentName: $2bf756b2518e7da4$var$getComponentName,
    getContainerName: $2bf756b2518e7da4$var$getContainerName
};

});

parcelRegister("4zxIN", function(module, exports) {
'use strict';

var $5FkrB = parcelRequire("5FkrB");
module.exports = $5FkrB.createContext({
    rootIsQueryRenderer: false
});

});


parcelRegister("f8R7U", function(module, exports) {
'use strict';

var $cQknW = parcelRequire("cQknW");

var $jSI6G = parcelRequire("jSI6G");
function $b060d0387a7a5320$var$assertRelayContext(relay) {
    !$b060d0387a7a5320$var$isRelayContext(relay) && $jSI6G(false);
    return relay;
}
function $b060d0387a7a5320$var$isRelayContext(context) {
    return typeof context === 'object' && context !== null && !Array.isArray(context) && $cQknW(context.environment);
}
module.exports = {
    assertRelayContext: $b060d0387a7a5320$var$assertRelayContext,
    isRelayContext: $b060d0387a7a5320$var$isRelayContext
};

});
parcelRegister("cQknW", function(module, exports) {
'use strict';
function $959a276ea00386cf$var$isRelayEnvironment(environment) {
    return typeof environment === 'object' && environment !== null && typeof environment.check === 'function' && typeof environment.lookup === 'function' && typeof environment.retain === 'function' && typeof environment.execute === 'function' && typeof environment.subscribe === 'function';
}
module.exports = $959a276ea00386cf$var$isRelayEnvironment;

});



parcelRegister("cQD5G", function(module, exports) {
'use strict';

var $8FWpR = parcelRequire("8FWpR");

var $4zxIN = parcelRequire("4zxIN");

var $bke7t = parcelRequire("bke7t");

var $5FkrB = parcelRequire("5FkrB");

var $7eKmg = parcelRequire("7eKmg");
var $95a8a9fa8f2a87cb$var$createOperationDescriptor = $7eKmg.createOperationDescriptor, $95a8a9fa8f2a87cb$var$deepFreeze = $7eKmg.deepFreeze, $95a8a9fa8f2a87cb$var$getRequest = $7eKmg.getRequest;
var $95a8a9fa8f2a87cb$var$useLayoutEffect = $5FkrB.useLayoutEffect, $95a8a9fa8f2a87cb$var$useState = $5FkrB.useState, $95a8a9fa8f2a87cb$var$useRef = $5FkrB.useRef, $95a8a9fa8f2a87cb$var$useMemo = $5FkrB.useMemo;
var $95a8a9fa8f2a87cb$var$queryRendererContext = {
    rootIsQueryRenderer: true
};
function $95a8a9fa8f2a87cb$var$useDeepCompare(value) {
    var latestValue = $5FkrB.useRef(value);
    if (!$bke7t(latestValue.current, value)) latestValue.current = value;
    return latestValue.current;
}
function $95a8a9fa8f2a87cb$var$ReactRelayLocalQueryRenderer(props) {
    var environment = props.environment, query = props.query, variables = props.variables, render = props.render;
    var latestVariables = $95a8a9fa8f2a87cb$var$useDeepCompare(variables);
    var operation = $95a8a9fa8f2a87cb$var$useMemo(function() {
        var request = $95a8a9fa8f2a87cb$var$getRequest(query);
        return $95a8a9fa8f2a87cb$var$createOperationDescriptor(request, latestVariables);
    }, [
        query,
        latestVariables
    ]);
    var relayContext = $95a8a9fa8f2a87cb$var$useMemo(function() {
        return {
            environment: environment
        };
    }, [
        environment
    ]);
    var dataRef = $95a8a9fa8f2a87cb$var$useRef(null);
    var _useState = $95a8a9fa8f2a87cb$var$useState(null), forceUpdate = _useState[1];
    var cleanupFnRef = $95a8a9fa8f2a87cb$var$useRef(null);
    var snapshot = $95a8a9fa8f2a87cb$var$useMemo(function() {
        environment.check(operation);
        var res = environment.lookup(operation.fragment);
        dataRef.current = res.data;
        var retainDisposable = environment.retain(operation);
        var subscribeDisposable = environment.subscribe(res, function(newSnapshot) {
            dataRef.current = newSnapshot.data;
            forceUpdate(dataRef.current);
        });
        var disposed = false;
        function nextCleanupFn() {
            if (!disposed) {
                disposed = true;
                cleanupFnRef.current = null;
                retainDisposable.dispose();
                subscribeDisposable.dispose();
            }
        }
        if (cleanupFnRef.current) cleanupFnRef.current();
        cleanupFnRef.current = nextCleanupFn;
        return res;
    }, [
        environment,
        operation
    ]);
    $95a8a9fa8f2a87cb$var$useLayoutEffect(function() {
        var cleanupFn = cleanupFnRef.current;
        return function() {
            cleanupFn && cleanupFn();
        };
    }, [
        snapshot
    ]);
    return /*#__PURE__*/ $5FkrB.createElement($8FWpR.Provider, {
        value: relayContext
    }, /*#__PURE__*/ $5FkrB.createElement($4zxIN.Provider, {
        value: $95a8a9fa8f2a87cb$var$queryRendererContext
    }, render({
        props: dataRef.current
    })));
}
module.exports = $95a8a9fa8f2a87cb$var$ReactRelayLocalQueryRenderer;

});

parcelRegister("lxnIq", function(module, exports) {
'use strict';

var $drPJO = parcelRequire("drPJO");
var $fadf13779037a8ae$var$_interopRequireDefault = $drPJO.default;

var $fadf13779037a8ae$var$_extends2 = $fadf13779037a8ae$var$_interopRequireDefault((parcelRequire("9K8n8")));

var $fadf13779037a8ae$var$_objectWithoutPropertiesLoose2 = $fadf13779037a8ae$var$_interopRequireDefault((parcelRequire("gyI5Y")));

var $fadf13779037a8ae$var$_assertThisInitialized2 = $fadf13779037a8ae$var$_interopRequireDefault((parcelRequire("9stWB")));

var $fadf13779037a8ae$var$_inheritsLoose2 = $fadf13779037a8ae$var$_interopRequireDefault((parcelRequire("1tj17")));

var $fadf13779037a8ae$var$_defineProperty2 = $fadf13779037a8ae$var$_interopRequireDefault((parcelRequire("gPhXO")));

var $fadf13779037a8ae$var$_objectSpread3 = $fadf13779037a8ae$var$_interopRequireDefault((parcelRequire("5OKtB")));
var $fadf13779037a8ae$var$_excluded = [
    "componentRef"
], $fadf13779037a8ae$var$_excluded2 = [
    "componentRef",
    "__relayContext",
    "__rootIsQueryRenderer"
], $fadf13779037a8ae$var$_excluded3 = [
    "componentRef",
    "__relayContext",
    "__rootIsQueryRenderer"
];

var $iVKxO = parcelRequire("iVKxO");

var $jXzWu = parcelRequire("jXzWu");

var $3M1UF = parcelRequire("3M1UF");
var $fadf13779037a8ae$var$getComponentName = $3M1UF.getComponentName, $fadf13779037a8ae$var$getContainerName = $3M1UF.getContainerName;

var $8FWpR = parcelRequire("8FWpR");

var $bDiPv = parcelRequire("bDiPv");

var $f8R7U = parcelRequire("f8R7U");
var $fadf13779037a8ae$var$assertRelayContext = $f8R7U.assertRelayContext;

var $bke7t = parcelRequire("bke7t");

var $jSI6G = parcelRequire("jSI6G");

var $5FkrB = parcelRequire("5FkrB");

var $7eKmg = parcelRequire("7eKmg");
var $fadf13779037a8ae$var$ConnectionInterface = $7eKmg.ConnectionInterface, $fadf13779037a8ae$var$Observable = $7eKmg.Observable, $fadf13779037a8ae$var$RelayFeatureFlags = $7eKmg.RelayFeatureFlags, $fadf13779037a8ae$var$createFragmentSpecResolver = $7eKmg.createFragmentSpecResolver, $fadf13779037a8ae$var$createOperationDescriptor = $7eKmg.createOperationDescriptor, $fadf13779037a8ae$var$getDataIDsFromObject = $7eKmg.getDataIDsFromObject, $fadf13779037a8ae$var$getRequest = $7eKmg.getRequest, $fadf13779037a8ae$var$getVariablesFromObject = $7eKmg.getVariablesFromObject, $fadf13779037a8ae$var$isScalarAndEqual = $7eKmg.isScalarAndEqual;
parcelRequire("2OmBw");
var $fadf13779037a8ae$var$FORWARD = 'forward';
function $fadf13779037a8ae$var$createGetConnectionFromProps(metadata) {
    var path = metadata.path;
    !path && $jSI6G(false);
    return function(props) {
        var data = props[metadata.fragmentName];
        for(var i = 0; i < path.length; i++){
            if (!data || typeof data !== 'object') return null;
            data = data[path[i]];
        }
        return data;
    };
}
function $fadf13779037a8ae$var$createGetFragmentVariables(metadata) {
    var countVariable = metadata.count;
    !countVariable && $jSI6G(false);
    return function(prevVars, totalCount) {
        return (0, $fadf13779037a8ae$var$_objectSpread3["default"])((0, $fadf13779037a8ae$var$_objectSpread3["default"])({}, prevVars), {}, (0, $fadf13779037a8ae$var$_defineProperty2["default"])({}, countVariable, totalCount));
    };
}
function $fadf13779037a8ae$var$findConnectionMetadata(fragments) {
    var foundConnectionMetadata = null;
    var isRelayModern = false;
    for(var fragmentName in fragments){
        var fragment = fragments[fragmentName];
        var connectionMetadata = fragment.metadata && fragment.metadata.connection;
        if (fragment.metadata !== undefined) isRelayModern = true;
        if (connectionMetadata) {
            !(connectionMetadata.length === 1) && $jSI6G(false);
            !!foundConnectionMetadata && $jSI6G(false);
            foundConnectionMetadata = (0, $fadf13779037a8ae$var$_objectSpread3["default"])((0, $fadf13779037a8ae$var$_objectSpread3["default"])({}, connectionMetadata[0]), {}, {
                fragmentName: fragmentName
            });
        }
    }
    !(!isRelayModern || foundConnectionMetadata !== null) && $jSI6G(false);
    return foundConnectionMetadata || {};
}
function $fadf13779037a8ae$var$toObserver(observerOrCallback) {
    return typeof observerOrCallback === 'function' ? {
        complete: observerOrCallback,
        error: observerOrCallback,
        unsubscribe: function unsubscribe(subscription) {
            typeof observerOrCallback === 'function' && observerOrCallback();
        }
    } : observerOrCallback || {};
}
function $fadf13779037a8ae$var$createContainerWithFragments(Component, fragments, connectionConfig) {
    var _class;
    var componentName = $fadf13779037a8ae$var$getComponentName(Component);
    var containerName = $fadf13779037a8ae$var$getContainerName(Component);
    var metadata = $fadf13779037a8ae$var$findConnectionMetadata(fragments);
    var getConnectionFromProps = connectionConfig.getConnectionFromProps || $fadf13779037a8ae$var$createGetConnectionFromProps(metadata);
    var direction = connectionConfig.direction || metadata.direction;
    !direction && $jSI6G(false);
    var getFragmentVariables = connectionConfig.getFragmentVariables || $fadf13779037a8ae$var$createGetFragmentVariables(metadata);
    return _class = /*#__PURE__*/ function(_React$Component) {
        (0, $fadf13779037a8ae$var$_inheritsLoose2["default"])(_class, _React$Component);
        function _class(props) {
            var _props$__rootIsQueryR, _this;
            _this = _React$Component.call(this, props) || this;
            (0, $fadf13779037a8ae$var$_defineProperty2["default"])((0, $fadf13779037a8ae$var$_assertThisInitialized2["default"])(_this), "_handleFragmentDataUpdate", function() {
                _this.setState({
                    data: _this._resolver.resolve()
                });
            });
            (0, $fadf13779037a8ae$var$_defineProperty2["default"])((0, $fadf13779037a8ae$var$_assertThisInitialized2["default"])(_this), "_hasMore", function() {
                var connectionData = _this._getConnectionData();
                return !!(connectionData && connectionData.hasMore && connectionData.cursor);
            });
            (0, $fadf13779037a8ae$var$_defineProperty2["default"])((0, $fadf13779037a8ae$var$_assertThisInitialized2["default"])(_this), "_isLoading", function() {
                return !!_this._refetchSubscription;
            });
            (0, $fadf13779037a8ae$var$_defineProperty2["default"])((0, $fadf13779037a8ae$var$_assertThisInitialized2["default"])(_this), "_refetchConnection", function(totalCount, observerOrCallback, refetchVariables) {
                if (!_this._canFetchPage('refetchConnection')) return {
                    dispose: function dispose() {}
                };
                _this._refetchVariables = refetchVariables;
                var paginatingVariables = {
                    count: totalCount,
                    cursor: null,
                    totalCount: totalCount
                };
                var fetch = _this._fetchPage(paginatingVariables, $fadf13779037a8ae$var$toObserver(observerOrCallback), {
                    force: true
                });
                return {
                    dispose: fetch.unsubscribe
                };
            });
            (0, $fadf13779037a8ae$var$_defineProperty2["default"])((0, $fadf13779037a8ae$var$_assertThisInitialized2["default"])(_this), "_loadMore", function(pageSize, observerOrCallback, options) {
                if (!_this._canFetchPage('loadMore')) return {
                    dispose: function dispose() {}
                };
                var observer = $fadf13779037a8ae$var$toObserver(observerOrCallback);
                var connectionData = _this._getConnectionData();
                if (!connectionData) {
                    $fadf13779037a8ae$var$Observable.create(function(sink) {
                        return sink.complete();
                    }).subscribe(observer);
                    return null;
                }
                var totalCount = connectionData.edgeCount + pageSize;
                if (options && options.force) return _this._refetchConnection(totalCount, observerOrCallback);
                var _ConnectionInterface$ = $fadf13779037a8ae$var$ConnectionInterface.get(), END_CURSOR = _ConnectionInterface$.END_CURSOR, START_CURSOR = _ConnectionInterface$.START_CURSOR;
                var cursor = connectionData.cursor;
                var paginatingVariables = {
                    count: pageSize,
                    cursor: cursor,
                    totalCount: totalCount
                };
                var fetch = _this._fetchPage(paginatingVariables, observer, options);
                return {
                    dispose: fetch.unsubscribe
                };
            });
            var relayContext = $fadf13779037a8ae$var$assertRelayContext(props.__relayContext);
            var rootIsQueryRenderer = (_props$__rootIsQueryR = props.__rootIsQueryRenderer) !== null && _props$__rootIsQueryR !== void 0 ? _props$__rootIsQueryR : false;
            _this._isARequestInFlight = false;
            _this._refetchSubscription = null;
            _this._refetchVariables = null;
            if ($fadf13779037a8ae$var$RelayFeatureFlags.ENABLE_CONTAINERS_SUBSCRIBE_ON_COMMIT === true) _this._resolver = $fadf13779037a8ae$var$createFragmentSpecResolver(relayContext, containerName, fragments, props, rootIsQueryRenderer);
            else _this._resolver = $fadf13779037a8ae$var$createFragmentSpecResolver(relayContext, containerName, fragments, props, rootIsQueryRenderer, _this._handleFragmentDataUpdate);
            _this.state = {
                contextForChildren: relayContext,
                data: _this._resolver.resolve(),
                prevContext: relayContext,
                relayProp: _this._buildRelayProp(relayContext),
                resolverGeneration: 0
            };
            _this._isUnmounted = false;
            _this._hasFetched = false;
            return _this;
        }
        var _proto = _class.prototype;
        _proto.componentDidMount = function componentDidMount() {
            this._isUnmounted = false;
            if ($fadf13779037a8ae$var$RelayFeatureFlags.ENABLE_CONTAINERS_SUBSCRIBE_ON_COMMIT === true) this._subscribeToNewResolverAndRerenderIfStoreHasChanged();
        };
        _proto.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
            if ($fadf13779037a8ae$var$RelayFeatureFlags.ENABLE_CONTAINERS_SUBSCRIBE_ON_COMMIT === true) {
                if (prevState.resolverGeneration !== this.state.resolverGeneration) this._subscribeToNewResolverAndRerenderIfStoreHasChanged();
                else this._rerenderIfStoreHasChanged();
            }
        };
        _proto.UNSAFE_componentWillReceiveProps = function UNSAFE_componentWillReceiveProps(nextProps) {
            var _this2 = this;
            var _nextProps$__rootIsQu;
            var relayContext = $fadf13779037a8ae$var$assertRelayContext(nextProps.__relayContext);
            var rootIsQueryRenderer = (_nextProps$__rootIsQu = nextProps.__rootIsQueryRenderer) !== null && _nextProps$__rootIsQu !== void 0 ? _nextProps$__rootIsQu : false;
            var prevIDs = $fadf13779037a8ae$var$getDataIDsFromObject(fragments, this.props);
            var nextIDs = $fadf13779037a8ae$var$getDataIDsFromObject(fragments, nextProps);
            var prevRootVariables = $jXzWu(fragments, this.props);
            var nextRootVariables = $jXzWu(fragments, nextProps);
            if (relayContext.environment !== this.state.prevContext.environment || !$bke7t(prevRootVariables, nextRootVariables) || !$bke7t(prevIDs, nextIDs)) {
                this._cleanup();
                if ($fadf13779037a8ae$var$RelayFeatureFlags.ENABLE_CONTAINERS_SUBSCRIBE_ON_COMMIT === true) this._resolver = $fadf13779037a8ae$var$createFragmentSpecResolver(relayContext, containerName, fragments, nextProps, rootIsQueryRenderer);
                else this._resolver = $fadf13779037a8ae$var$createFragmentSpecResolver(relayContext, containerName, fragments, nextProps, rootIsQueryRenderer, this._handleFragmentDataUpdate);
                this.setState(function(prevState) {
                    return {
                        contextForChildren: relayContext,
                        prevContext: relayContext,
                        relayProp: _this2._buildRelayProp(relayContext),
                        resolverGeneration: prevState.resolverGeneration + 1
                    };
                });
            } else if (!this._hasFetched) this._resolver.setProps(nextProps);
            var data = this._resolver.resolve();
            if (data !== this.state.data) this.setState({
                data: data
            });
        };
        _proto.componentWillUnmount = function componentWillUnmount() {
            this._isUnmounted = true;
            this._cleanup();
        };
        _proto.shouldComponentUpdate = function shouldComponentUpdate(nextProps, nextState) {
            if (nextState.data !== this.state.data || nextState.relayProp !== this.state.relayProp || nextState.resolverGeneration !== this.state.resolverGeneration) return true;
            var keys = Object.keys(nextProps);
            for(var ii = 0; ii < keys.length; ii++){
                var key = keys[ii];
                if (key === '__relayContext') {
                    if (nextState.prevContext.environment !== this.state.prevContext.environment) return true;
                } else {
                    if (!fragments.hasOwnProperty(key) && !$fadf13779037a8ae$var$isScalarAndEqual(nextProps[key], this.props[key])) return true;
                }
            }
            return false;
        };
        _proto._buildRelayProp = function _buildRelayProp(relayContext) {
            return {
                environment: relayContext.environment,
                hasMore: this._hasMore,
                isLoading: this._isLoading,
                loadMore: this._loadMore,
                refetchConnection: this._refetchConnection
            };
        };
        _proto._rerenderIfStoreHasChanged = function _rerenderIfStoreHasChanged() {
            var data = this.state.data;
            var maybeNewData = this._resolver.resolve();
            if (data !== maybeNewData) this.setState({
                data: maybeNewData
            });
        };
        _proto._subscribeToNewResolverAndRerenderIfStoreHasChanged = function _subscribeToNewResolverAndRerenderIfStoreHasChanged() {
            var data = this.state.data;
            var maybeNewData = this._resolver.resolve();
            this._resolver.setCallback(this.props, this._handleFragmentDataUpdate);
            if (data !== maybeNewData) this.setState({
                data: maybeNewData
            });
        };
        _proto._getConnectionData = function _getConnectionData() {
            var _this$props = this.props, _ = _this$props.componentRef, restProps = (0, $fadf13779037a8ae$var$_objectWithoutPropertiesLoose2["default"])(_this$props, $fadf13779037a8ae$var$_excluded);
            var props = (0, $fadf13779037a8ae$var$_objectSpread3["default"])((0, $fadf13779037a8ae$var$_objectSpread3["default"])({}, restProps), this.state.data);
            var connectionData = getConnectionFromProps(props);
            if (connectionData == null) return null;
            var _ConnectionInterface$2 = $fadf13779037a8ae$var$ConnectionInterface.get(), EDGES = _ConnectionInterface$2.EDGES, PAGE_INFO = _ConnectionInterface$2.PAGE_INFO, HAS_NEXT_PAGE = _ConnectionInterface$2.HAS_NEXT_PAGE, HAS_PREV_PAGE = _ConnectionInterface$2.HAS_PREV_PAGE, END_CURSOR = _ConnectionInterface$2.END_CURSOR, START_CURSOR = _ConnectionInterface$2.START_CURSOR;
            !(typeof connectionData === 'object') && $jSI6G(false);
            var edges = connectionData[EDGES];
            var pageInfo = connectionData[PAGE_INFO];
            if (edges == null || pageInfo == null) return null;
            !Array.isArray(edges) && $jSI6G(false);
            !(typeof pageInfo === 'object') && $jSI6G(false);
            var hasMore = direction === $fadf13779037a8ae$var$FORWARD ? pageInfo[HAS_NEXT_PAGE] : pageInfo[HAS_PREV_PAGE];
            var cursor = direction === $fadf13779037a8ae$var$FORWARD ? pageInfo[END_CURSOR] : pageInfo[START_CURSOR];
            if (typeof hasMore !== 'boolean' || edges.length !== 0 && typeof cursor === 'undefined') return null;
            return {
                cursor: cursor,
                edgeCount: edges.length,
                hasMore: hasMore
            };
        };
        _proto._getQueryFetcher = function _getQueryFetcher() {
            if (!this._queryFetcher) this._queryFetcher = new $bDiPv();
            return this._queryFetcher;
        };
        _proto._canFetchPage = function _canFetchPage(method) {
            if (this._isUnmounted) return false;
            return true;
        };
        _proto._fetchPage = function _fetchPage(paginatingVariables, observer, options) {
            var _this3 = this;
            var _assertRelayContext = $fadf13779037a8ae$var$assertRelayContext(this.props.__relayContext), environment = _assertRelayContext.environment;
            var _this$props2 = this.props, _ = _this$props2.componentRef, __relayContext = _this$props2.__relayContext, __rootIsQueryRenderer = _this$props2.__rootIsQueryRenderer, restProps = (0, $fadf13779037a8ae$var$_objectWithoutPropertiesLoose2["default"])(_this$props2, $fadf13779037a8ae$var$_excluded2);
            var props = (0, $fadf13779037a8ae$var$_objectSpread3["default"])((0, $fadf13779037a8ae$var$_objectSpread3["default"])({}, restProps), this.state.data);
            var fragmentVariables;
            var rootVariables = $jXzWu(fragments, restProps);
            fragmentVariables = $fadf13779037a8ae$var$getVariablesFromObject(fragments, restProps);
            fragmentVariables = (0, $fadf13779037a8ae$var$_objectSpread3["default"])((0, $fadf13779037a8ae$var$_objectSpread3["default"])((0, $fadf13779037a8ae$var$_objectSpread3["default"])({}, rootVariables), fragmentVariables), this._refetchVariables);
            var fetchVariables = connectionConfig.getVariables(props, {
                count: paginatingVariables.count,
                cursor: paginatingVariables.cursor
            }, fragmentVariables);
            !(typeof fetchVariables === 'object' && fetchVariables !== null) && $jSI6G(false);
            fetchVariables = (0, $fadf13779037a8ae$var$_objectSpread3["default"])((0, $fadf13779037a8ae$var$_objectSpread3["default"])({}, fetchVariables), this._refetchVariables);
            fragmentVariables = (0, $fadf13779037a8ae$var$_objectSpread3["default"])((0, $fadf13779037a8ae$var$_objectSpread3["default"])({}, fetchVariables), fragmentVariables);
            var cacheConfig = options ? {
                force: !!options.force
            } : undefined;
            if (cacheConfig != null && (options === null || options === void 0 ? void 0 : options.metadata) != null) cacheConfig.metadata = options === null || options === void 0 ? void 0 : options.metadata;
            var request = $fadf13779037a8ae$var$getRequest(connectionConfig.query);
            var operation = $fadf13779037a8ae$var$createOperationDescriptor(request, fetchVariables, cacheConfig);
            var refetchSubscription = null;
            if (this._refetchSubscription) this._refetchSubscription.unsubscribe();
            this._hasFetched = true;
            var onNext = function onNext(payload, complete) {
                var prevData = _this3._resolver.resolve();
                _this3._resolver.setVariables(getFragmentVariables(fragmentVariables, paginatingVariables.totalCount), operation.request.node);
                var nextData = _this3._resolver.resolve();
                if (!$bke7t(prevData, nextData)) _this3.setState({
                    contextForChildren: {
                        environment: _this3.props.__relayContext.environment
                    },
                    data: nextData
                }, complete);
                else complete();
            };
            var cleanup = function cleanup() {
                if (_this3._refetchSubscription === refetchSubscription) {
                    _this3._refetchSubscription = null;
                    _this3._isARequestInFlight = false;
                }
            };
            this._isARequestInFlight = true;
            refetchSubscription = this._getQueryFetcher().execute({
                environment: environment,
                operation: operation,
                preservePreviousReferences: true
            }).mergeMap(function(payload) {
                return $fadf13779037a8ae$var$Observable.create(function(sink) {
                    onNext(payload, function() {
                        sink.next();
                        sink.complete();
                    });
                });
            })["do"]({
                complete: cleanup,
                error: cleanup,
                unsubscribe: cleanup
            }).subscribe(observer || {});
            this._refetchSubscription = this._isARequestInFlight ? refetchSubscription : null;
            return refetchSubscription;
        };
        _proto._cleanup = function _cleanup() {
            this._resolver.dispose();
            this._refetchVariables = null;
            this._hasFetched = false;
            if (this._refetchSubscription) {
                this._refetchSubscription.unsubscribe();
                this._refetchSubscription = null;
                this._isARequestInFlight = false;
            }
            if (this._queryFetcher) this._queryFetcher.dispose();
        };
        _proto.render = function render() {
            var _this$props3 = this.props, componentRef = _this$props3.componentRef, __relayContext = _this$props3.__relayContext, __rootIsQueryRenderer = _this$props3.__rootIsQueryRenderer, props = (0, $fadf13779037a8ae$var$_objectWithoutPropertiesLoose2["default"])(_this$props3, $fadf13779037a8ae$var$_excluded3);
            return /*#__PURE__*/ $5FkrB.createElement($8FWpR.Provider, {
                value: this.state.contextForChildren
            }, /*#__PURE__*/ $5FkrB.createElement(Component, (0, $fadf13779037a8ae$var$_extends2["default"])({}, props, this.state.data, {
                ref: componentRef,
                relay: this.state.relayProp
            })));
        };
        return _class;
    }($5FkrB.Component), (0, $fadf13779037a8ae$var$_defineProperty2["default"])(_class, "displayName", containerName), _class;
}
function $fadf13779037a8ae$var$createContainer(Component, fragmentSpec, connectionConfig) {
    return $iVKxO(Component, fragmentSpec, function(ComponentClass, fragments) {
        return $fadf13779037a8ae$var$createContainerWithFragments(ComponentClass, fragments, connectionConfig);
    });
}
module.exports = {
    createContainer: $fadf13779037a8ae$var$createContainer
};

});
parcelRegister("5OKtB", function(module, exports) {

var $gPhXO = parcelRequire("gPhXO");
function $43c5ac8062ad0289$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $43c5ac8062ad0289$var$_objectSpread2(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $43c5ac8062ad0289$var$ownKeys(Object(t), !0).forEach(function(r) {
            $gPhXO(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $43c5ac8062ad0289$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
module.exports = $43c5ac8062ad0289$var$_objectSpread2, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("jXzWu", function(module, exports) {
'use strict';

var $drPJO = parcelRequire("drPJO");
var $e87f686f839311ae$var$_interopRequireDefault = $drPJO.default;

var $e87f686f839311ae$var$_objectSpread2 = $e87f686f839311ae$var$_interopRequireDefault((parcelRequire("5OKtB")));

var $7eKmg = parcelRequire("7eKmg");
var $e87f686f839311ae$var$getSelector = $7eKmg.getSelector;
function $e87f686f839311ae$var$getRootVariablesForFragments(fragments, props) {
    var rootVariables = {};
    Object.keys(fragments).forEach(function(key) {
        var _selector$selectors$, _selector$selectors$2, _selector$owner$varia;
        var fragmentNode = fragments[key];
        var fragmentRef = props[key];
        var selector = $e87f686f839311ae$var$getSelector(fragmentNode, fragmentRef);
        var fragmentOwnerVariables = selector != null && selector.kind === 'PluralReaderSelector' ? (_selector$selectors$ = (_selector$selectors$2 = selector.selectors[0]) === null || _selector$selectors$2 === void 0 ? void 0 : _selector$selectors$2.owner.variables) !== null && _selector$selectors$ !== void 0 ? _selector$selectors$ : {} : (_selector$owner$varia = selector === null || selector === void 0 ? void 0 : selector.owner.variables) !== null && _selector$owner$varia !== void 0 ? _selector$owner$varia : {};
        rootVariables = (0, $e87f686f839311ae$var$_objectSpread2["default"])((0, $e87f686f839311ae$var$_objectSpread2["default"])({}, rootVariables), fragmentOwnerVariables);
    });
    return rootVariables;
}
module.exports = $e87f686f839311ae$var$getRootVariablesForFragments;

});

parcelRegister("bDiPv", function(module, exports) {
'use strict';

var $drPJO = parcelRequire("drPJO");
var $8781f16e8e0d92be$var$_interopRequireDefault = $drPJO.default;

var $8781f16e8e0d92be$var$_defineProperty2 = $8781f16e8e0d92be$var$_interopRequireDefault((parcelRequire("gPhXO")));

var $jSI6G = parcelRequire("jSI6G");

var $7eKmg = parcelRequire("7eKmg");
var $8781f16e8e0d92be$var$fetchQuery = $7eKmg.__internal.fetchQuery, $8781f16e8e0d92be$var$createOperationDescriptor = $7eKmg.createOperationDescriptor, $8781f16e8e0d92be$var$isRelayModernEnvironment = $7eKmg.isRelayModernEnvironment;
var $8781f16e8e0d92be$var$ReactRelayQueryFetcher = /*#__PURE__*/ function() {
    function ReactRelayQueryFetcher(args) {
        (0, $8781f16e8e0d92be$var$_defineProperty2["default"])(this, "_selectionReferences", []);
        (0, $8781f16e8e0d92be$var$_defineProperty2["default"])(this, "_didFetchFinish", false);
        if (args != null) {
            this._cacheSelectionReference = args.cacheSelectionReference;
            this._selectionReferences = args.selectionReferences;
        }
    }
    var _proto = ReactRelayQueryFetcher.prototype;
    _proto.getSelectionReferences = function getSelectionReferences() {
        return {
            cacheSelectionReference: this._cacheSelectionReference,
            selectionReferences: this._selectionReferences
        };
    };
    _proto.lookupInStore = function lookupInStore(environment, operation, fetchPolicy) {
        if (fetchPolicy === 'store-and-network' || fetchPolicy === 'store-or-network') {
            if (environment.check(operation).status === 'available') {
                this._retainCachedOperation(environment, operation);
                return environment.lookup(operation.fragment);
            }
        }
        return null;
    };
    _proto.getFetchResult = function getFetchResult() {
        if (this._didFetchFinish) {
            if (this._error != null) return {
                error: this._error
            };
            else if (this._snapshot != null) return {
                snapshot: this._snapshot
            };
        } else return null;
    };
    _proto.execute = function execute(_ref) {
        var _this = this;
        var environment = _ref.environment, operation = _ref.operation, _ref$preservePrevious = _ref.preservePreviousReferences, preservePreviousReferences = _ref$preservePrevious === void 0 ? false : _ref$preservePrevious;
        var reference = environment.retain(operation);
        var error = function error() {
            _this._selectionReferences = _this._selectionReferences.concat(reference);
        };
        var complete = function complete() {
            if (!preservePreviousReferences) _this.disposeSelectionReferences();
            _this._selectionReferences = _this._selectionReferences.concat(reference);
        };
        var unsubscribe = function unsubscribe() {
            _this._selectionReferences = _this._selectionReferences.concat(reference);
        };
        if (!$8781f16e8e0d92be$var$isRelayModernEnvironment(environment)) return environment.execute({
            operation: operation
        })["do"]({
            error: error,
            complete: complete,
            unsubscribe: unsubscribe
        });
        return $8781f16e8e0d92be$var$fetchQuery(environment, operation)["do"]({
            error: error,
            complete: complete,
            unsubscribe: unsubscribe
        });
    };
    _proto.setOnDataChange = function setOnDataChange(onDataChange) {
        !this._fetchOptions && $jSI6G(false);
        if (typeof onDataChange === 'function') {
            this._fetchOptions.onDataChangeCallbacks = this._fetchOptions.onDataChangeCallbacks || [];
            this._fetchOptions.onDataChangeCallbacks.push(onDataChange);
            if (this._didFetchFinish) {
                if (this._error != null) onDataChange({
                    error: this._error
                });
                else if (this._snapshot != null) onDataChange({
                    snapshot: this._snapshot
                });
            }
        }
    };
    _proto.fetch = function fetch(fetchOptions, cacheConfigOverride) {
        var _this2 = this;
        var environment = fetchOptions.environment, operation = fetchOptions.operation, onDataChange = fetchOptions.onDataChange;
        var fetchHasReturned = false;
        var _error;
        this.disposeRequest();
        var oldOnDataChangeCallbacks = this._fetchOptions && this._fetchOptions.onDataChangeCallbacks;
        this._fetchOptions = {
            environment: environment,
            onDataChangeCallbacks: oldOnDataChangeCallbacks || [],
            operation: operation
        };
        if (onDataChange && this._fetchOptions.onDataChangeCallbacks.indexOf(onDataChange) === -1) this._fetchOptions.onDataChangeCallbacks.push(onDataChange);
        var operationOverride = cacheConfigOverride ? $8781f16e8e0d92be$var$createOperationDescriptor(operation.request.node, operation.request.variables, cacheConfigOverride) : operation;
        var request = this.execute({
            environment: environment,
            operation: operationOverride
        })["finally"](function() {
            _this2._pendingRequest = null;
        }).subscribe({
            next: function next() {
                _this2._didFetchFinish = true;
                _this2._error = null;
                _this2._onQueryDataAvailable({
                    notifyFirstResult: fetchHasReturned
                });
            },
            error: function error(err) {
                _this2._didFetchFinish = true;
                _this2._error = err;
                _this2._snapshot = null;
                var onDataChangeCallbacks = _this2._fetchOptions && _this2._fetchOptions.onDataChangeCallbacks;
                if (fetchHasReturned) {
                    if (onDataChangeCallbacks) onDataChangeCallbacks.forEach(function(onDataChange) {
                        onDataChange({
                            error: err
                        });
                    });
                } else _error = err;
            }
        });
        this._pendingRequest = {
            dispose: function dispose() {
                request.unsubscribe();
            }
        };
        fetchHasReturned = true;
        if (_error) throw _error;
        return this._snapshot;
    };
    _proto.retry = function retry(cacheConfigOverride) {
        !this._fetchOptions && $jSI6G(false);
        return this.fetch({
            environment: this._fetchOptions.environment,
            operation: this._fetchOptions.operation,
            onDataChange: null
        }, cacheConfigOverride);
    };
    _proto.dispose = function dispose() {
        this.disposeRequest();
        this.disposeSelectionReferences();
    };
    _proto.disposeRequest = function disposeRequest() {
        this._error = null;
        this._snapshot = null;
        if (this._pendingRequest) this._pendingRequest.dispose();
        if (this._rootSubscription) {
            this._rootSubscription.dispose();
            this._rootSubscription = null;
        }
    };
    _proto._retainCachedOperation = function _retainCachedOperation(environment, operation) {
        this._disposeCacheSelectionReference();
        this._cacheSelectionReference = environment.retain(operation);
    };
    _proto._disposeCacheSelectionReference = function _disposeCacheSelectionReference() {
        this._cacheSelectionReference && this._cacheSelectionReference.dispose();
        this._cacheSelectionReference = null;
    };
    _proto.disposeSelectionReferences = function disposeSelectionReferences() {
        this._disposeCacheSelectionReference();
        this._selectionReferences.forEach(function(r) {
            return r.dispose();
        });
        this._selectionReferences = [];
    };
    _proto._onQueryDataAvailable = function _onQueryDataAvailable(_ref2) {
        var _this3 = this;
        var notifyFirstResult = _ref2.notifyFirstResult;
        !this._fetchOptions && $jSI6G(false);
        var _this$_fetchOptions = this._fetchOptions, environment = _this$_fetchOptions.environment, onDataChangeCallbacks = _this$_fetchOptions.onDataChangeCallbacks, operation = _this$_fetchOptions.operation;
        if (this._snapshot) return;
        this._snapshot = environment.lookup(operation.fragment);
        this._rootSubscription = environment.subscribe(this._snapshot, function(snapshot) {
            if (_this3._fetchOptions != null) {
                var maybeNewOnDataChangeCallbacks = _this3._fetchOptions.onDataChangeCallbacks;
                if (Array.isArray(maybeNewOnDataChangeCallbacks)) maybeNewOnDataChangeCallbacks.forEach(function(onDataChange) {
                    return onDataChange({
                        snapshot: snapshot
                    });
                });
            }
        });
        if (this._snapshot && notifyFirstResult && Array.isArray(onDataChangeCallbacks)) {
            var snapshot = this._snapshot;
            onDataChangeCallbacks.forEach(function(onDataChange) {
                return onDataChange({
                    snapshot: snapshot
                });
            });
        }
    };
    return ReactRelayQueryFetcher;
}();
module.exports = $8781f16e8e0d92be$var$ReactRelayQueryFetcher;

});


parcelRegister("2gNok", function(module, exports) {
'use strict';

var $drPJO = parcelRequire("drPJO");
var $1a73637faecd6b1a$var$_interopRequireDefault = $drPJO.default;

var $1a73637faecd6b1a$var$_objectSpread2 = $1a73637faecd6b1a$var$_interopRequireDefault((parcelRequire("5OKtB")));

var $1a73637faecd6b1a$var$_assertThisInitialized2 = $1a73637faecd6b1a$var$_interopRequireDefault((parcelRequire("9stWB")));

var $1a73637faecd6b1a$var$_inheritsLoose2 = $1a73637faecd6b1a$var$_interopRequireDefault((parcelRequire("1tj17")));

var $1a73637faecd6b1a$var$_defineProperty2 = $1a73637faecd6b1a$var$_interopRequireDefault((parcelRequire("gPhXO")));

var $8FWpR = parcelRequire("8FWpR");

var $bDiPv = parcelRequire("bDiPv");

var $4zxIN = parcelRequire("4zxIN");

var $bke7t = parcelRequire("bke7t");

var $5FkrB = parcelRequire("5FkrB");

var $7eKmg = parcelRequire("7eKmg");
var $1a73637faecd6b1a$var$createOperationDescriptor = $7eKmg.createOperationDescriptor, $1a73637faecd6b1a$var$deepFreeze = $7eKmg.deepFreeze, $1a73637faecd6b1a$var$getRequest = $7eKmg.getRequest;
var $1a73637faecd6b1a$var$requestCache = {};
var $1a73637faecd6b1a$var$queryRendererContext = {
    rootIsQueryRenderer: true
};
var $1a73637faecd6b1a$var$ReactRelayQueryRenderer = /*#__PURE__*/ function(_React$Component) {
    (0, $1a73637faecd6b1a$var$_inheritsLoose2["default"])(ReactRelayQueryRenderer, _React$Component);
    function ReactRelayQueryRenderer(props) {
        var _this;
        _this = _React$Component.call(this, props) || this;
        (0, $1a73637faecd6b1a$var$_defineProperty2["default"])((0, $1a73637faecd6b1a$var$_assertThisInitialized2["default"])(_this), "_handleDataChange", function(params) {
            var error = params.error == null ? null : params.error;
            var snapshot = params.snapshot == null ? null : params.snapshot;
            _this.setState(function(prevState) {
                var prevRequestCacheKey = prevState.requestCacheKey;
                if (prevRequestCacheKey) delete $1a73637faecd6b1a$var$requestCache[prevRequestCacheKey];
                if (snapshot === prevState.snapshot && error === prevState.error) return null;
                return {
                    renderProps: $1a73637faecd6b1a$var$getRenderProps(error, snapshot, prevState.queryFetcher, prevState.retryCallbacks),
                    snapshot: snapshot,
                    requestCacheKey: null
                };
            });
        });
        var retryCallbacks = {
            handleDataChange: null,
            handleRetryAfterError: null
        };
        var queryFetcher;
        var requestCacheKey;
        if (props.query) {
            var query = props.query;
            var request = $1a73637faecd6b1a$var$getRequest(query);
            requestCacheKey = $1a73637faecd6b1a$var$getRequestCacheKey(request.params, props.variables);
            queryFetcher = $1a73637faecd6b1a$var$requestCache[requestCacheKey] ? $1a73637faecd6b1a$var$requestCache[requestCacheKey].queryFetcher : new $bDiPv();
        } else queryFetcher = new $bDiPv();
        _this._maybeHiddenOrFastRefresh = false;
        _this.state = (0, $1a73637faecd6b1a$var$_objectSpread2["default"])({
            prevPropsEnvironment: props.environment,
            prevPropsVariables: props.variables,
            prevQuery: props.query,
            queryFetcher: queryFetcher,
            retryCallbacks: retryCallbacks
        }, $1a73637faecd6b1a$var$fetchQueryAndComputeStateFromProps(props, queryFetcher, retryCallbacks, requestCacheKey));
        return _this;
    }
    ReactRelayQueryRenderer.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, prevState) {
        if (prevState.prevQuery !== nextProps.query || prevState.prevPropsEnvironment !== nextProps.environment || !$bke7t(prevState.prevPropsVariables, nextProps.variables)) return $1a73637faecd6b1a$var$resetQueryStateForUpdate(nextProps, prevState);
        return null;
    };
    var _proto = ReactRelayQueryRenderer.prototype;
    _proto.componentDidMount = function componentDidMount() {
        var _this2 = this;
        if (this._maybeHiddenOrFastRefresh === true) {
            this._maybeHiddenOrFastRefresh = false;
            this.setState(function(prevState) {
                var newState = $1a73637faecd6b1a$var$resetQueryStateForUpdate(_this2.props, prevState);
                var requestCacheKey = newState.requestCacheKey, queryFetcher = newState.queryFetcher;
                if (requestCacheKey != null && $1a73637faecd6b1a$var$requestCache[requestCacheKey] != null) queryFetcher.setOnDataChange(_this2._handleDataChange);
                return newState;
            });
            return;
        }
        var _this$state = this.state, retryCallbacks = _this$state.retryCallbacks, queryFetcher = _this$state.queryFetcher, requestCacheKey = _this$state.requestCacheKey;
        if (requestCacheKey) delete $1a73637faecd6b1a$var$requestCache[requestCacheKey];
        retryCallbacks.handleDataChange = this._handleDataChange;
        retryCallbacks.handleRetryAfterError = function(error) {
            return _this2.setState(function(prevState) {
                var prevRequestCacheKey = prevState.requestCacheKey;
                if (prevRequestCacheKey) delete $1a73637faecd6b1a$var$requestCache[prevRequestCacheKey];
                return {
                    renderProps: $1a73637faecd6b1a$var$getLoadingRenderProps(),
                    requestCacheKey: null
                };
            });
        };
        if (this.props.query) queryFetcher.setOnDataChange(this._handleDataChange);
    };
    _proto.componentDidUpdate = function componentDidUpdate(_prevProps, prevState) {
        var _this$state2 = this.state, queryFetcher = _this$state2.queryFetcher, requestCacheKey = _this$state2.requestCacheKey;
        if (requestCacheKey) {
            delete $1a73637faecd6b1a$var$requestCache[requestCacheKey];
            delete this.state.requestCacheKey;
        }
        if (this.props.query && queryFetcher !== prevState.queryFetcher) queryFetcher.setOnDataChange(this._handleDataChange);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.state.queryFetcher.dispose();
        this._maybeHiddenOrFastRefresh = true;
    };
    _proto.shouldComponentUpdate = function shouldComponentUpdate(nextProps, nextState) {
        return nextProps.render !== this.props.render || nextState.renderProps !== this.state.renderProps;
    };
    _proto.render = function render() {
        var _this$state3 = this.state, renderProps = _this$state3.renderProps, relayContext = _this$state3.relayContext;
        return /*#__PURE__*/ $5FkrB.createElement($8FWpR.Provider, {
            value: relayContext
        }, /*#__PURE__*/ $5FkrB.createElement($4zxIN.Provider, {
            value: $1a73637faecd6b1a$var$queryRendererContext
        }, this.props.render(renderProps)));
    };
    return ReactRelayQueryRenderer;
}($5FkrB.Component);
function $1a73637faecd6b1a$var$getLoadingRenderProps() {
    return {
        error: null,
        props: null,
        retry: null
    };
}
function $1a73637faecd6b1a$var$getEmptyRenderProps() {
    return {
        error: null,
        props: {},
        retry: null
    };
}
function $1a73637faecd6b1a$var$getRenderProps(error, snapshot, queryFetcher, retryCallbacks) {
    return {
        error: error ? error : null,
        props: snapshot ? snapshot.data : null,
        retry: function retry(cacheConfigOverride) {
            var syncSnapshot = queryFetcher.retry(cacheConfigOverride);
            if (syncSnapshot && typeof retryCallbacks.handleDataChange === 'function') retryCallbacks.handleDataChange({
                snapshot: syncSnapshot
            });
            else if (error && typeof retryCallbacks.handleRetryAfterError === 'function') retryCallbacks.handleRetryAfterError(error);
        }
    };
}
function $1a73637faecd6b1a$var$getRequestCacheKey(request, variables) {
    return JSON.stringify({
        id: request.cacheID ? request.cacheID : request.id,
        variables: variables
    });
}
function $1a73637faecd6b1a$var$resetQueryStateForUpdate(props, prevState) {
    var query = props.query;
    var prevSelectionReferences = prevState.queryFetcher.getSelectionReferences();
    prevState.queryFetcher.disposeRequest();
    var queryFetcher;
    if (query) {
        var request = $1a73637faecd6b1a$var$getRequest(query);
        var requestCacheKey = $1a73637faecd6b1a$var$getRequestCacheKey(request.params, props.variables);
        queryFetcher = $1a73637faecd6b1a$var$requestCache[requestCacheKey] ? $1a73637faecd6b1a$var$requestCache[requestCacheKey].queryFetcher : new $bDiPv(prevSelectionReferences);
    } else queryFetcher = new $bDiPv(prevSelectionReferences);
    return (0, $1a73637faecd6b1a$var$_objectSpread2["default"])({
        prevQuery: props.query,
        prevPropsEnvironment: props.environment,
        prevPropsVariables: props.variables,
        queryFetcher: queryFetcher
    }, $1a73637faecd6b1a$var$fetchQueryAndComputeStateFromProps(props, queryFetcher, prevState.retryCallbacks));
}
function $1a73637faecd6b1a$var$fetchQueryAndComputeStateFromProps(props, queryFetcher, retryCallbacks, requestCacheKey) {
    var environment = props.environment, query = props.query, variables = props.variables, cacheConfig = props.cacheConfig;
    var genericEnvironment = environment;
    if (query) {
        var request = $1a73637faecd6b1a$var$getRequest(query);
        var operation = $1a73637faecd6b1a$var$createOperationDescriptor(request, variables, cacheConfig);
        var relayContext = {
            environment: genericEnvironment
        };
        if (typeof requestCacheKey === 'string' && $1a73637faecd6b1a$var$requestCache[requestCacheKey]) {
            var snapshot = $1a73637faecd6b1a$var$requestCache[requestCacheKey].snapshot;
            if (snapshot) return {
                error: null,
                relayContext: relayContext,
                renderProps: $1a73637faecd6b1a$var$getRenderProps(null, snapshot, queryFetcher, retryCallbacks),
                snapshot: snapshot,
                requestCacheKey: requestCacheKey
            };
            else return {
                error: null,
                relayContext: relayContext,
                renderProps: $1a73637faecd6b1a$var$getLoadingRenderProps(),
                snapshot: null,
                requestCacheKey: requestCacheKey
            };
        }
        try {
            var storeSnapshot = queryFetcher.lookupInStore(genericEnvironment, operation, props.fetchPolicy);
            var querySnapshot = queryFetcher.fetch({
                environment: genericEnvironment,
                onDataChange: null,
                operation: operation
            });
            var _snapshot = querySnapshot || storeSnapshot;
            requestCacheKey = requestCacheKey || $1a73637faecd6b1a$var$getRequestCacheKey(request.params, props.variables);
            $1a73637faecd6b1a$var$requestCache[requestCacheKey] = {
                queryFetcher: queryFetcher,
                snapshot: _snapshot
            };
            if (!_snapshot) return {
                error: null,
                relayContext: relayContext,
                renderProps: $1a73637faecd6b1a$var$getLoadingRenderProps(),
                snapshot: null,
                requestCacheKey: requestCacheKey
            };
            return {
                error: null,
                relayContext: relayContext,
                renderProps: $1a73637faecd6b1a$var$getRenderProps(null, _snapshot, queryFetcher, retryCallbacks),
                snapshot: _snapshot,
                requestCacheKey: requestCacheKey
            };
        } catch (error) {
            return {
                error: error,
                relayContext: relayContext,
                renderProps: $1a73637faecd6b1a$var$getRenderProps(error, null, queryFetcher, retryCallbacks),
                snapshot: null,
                requestCacheKey: requestCacheKey
            };
        }
    } else {
        queryFetcher.dispose();
        var _relayContext = {
            environment: genericEnvironment
        };
        return {
            error: null,
            relayContext: _relayContext,
            renderProps: $1a73637faecd6b1a$var$getEmptyRenderProps(),
            requestCacheKey: null
        };
    }
}
module.exports = $1a73637faecd6b1a$var$ReactRelayQueryRenderer;

});

parcelRegister("gai4Q", function(module, exports) {
'use strict';

var $drPJO = parcelRequire("drPJO");
var $bc4b9a4711d6ec6a$var$_interopRequireDefault = $drPJO.default;

var $bc4b9a4711d6ec6a$var$_extends2 = $bc4b9a4711d6ec6a$var$_interopRequireDefault((parcelRequire("9K8n8")));

var $bc4b9a4711d6ec6a$var$_objectWithoutPropertiesLoose2 = $bc4b9a4711d6ec6a$var$_interopRequireDefault((parcelRequire("gyI5Y")));

var $bc4b9a4711d6ec6a$var$_objectSpread2 = $bc4b9a4711d6ec6a$var$_interopRequireDefault((parcelRequire("5OKtB")));

var $bc4b9a4711d6ec6a$var$_assertThisInitialized2 = $bc4b9a4711d6ec6a$var$_interopRequireDefault((parcelRequire("9stWB")));

var $bc4b9a4711d6ec6a$var$_inheritsLoose2 = $bc4b9a4711d6ec6a$var$_interopRequireDefault((parcelRequire("1tj17")));

var $bc4b9a4711d6ec6a$var$_defineProperty2 = $bc4b9a4711d6ec6a$var$_interopRequireDefault((parcelRequire("gPhXO")));
var $bc4b9a4711d6ec6a$var$_excluded = [
    "componentRef",
    "__relayContext",
    "__rootIsQueryRenderer"
];

var $iVKxO = parcelRequire("iVKxO");

var $jXzWu = parcelRequire("jXzWu");

var $3M1UF = parcelRequire("3M1UF");
var $bc4b9a4711d6ec6a$var$getContainerName = $3M1UF.getContainerName;

var $8FWpR = parcelRequire("8FWpR");

var $bDiPv = parcelRequire("bDiPv");

var $f8R7U = parcelRequire("f8R7U");
var $bc4b9a4711d6ec6a$var$assertRelayContext = $f8R7U.assertRelayContext;

var $bke7t = parcelRequire("bke7t");

var $5FkrB = parcelRequire("5FkrB");

var $7eKmg = parcelRequire("7eKmg");
var $bc4b9a4711d6ec6a$var$Observable = $7eKmg.Observable, $bc4b9a4711d6ec6a$var$createFragmentSpecResolver = $7eKmg.createFragmentSpecResolver, $bc4b9a4711d6ec6a$var$createOperationDescriptor = $7eKmg.createOperationDescriptor, $bc4b9a4711d6ec6a$var$getDataIDsFromObject = $7eKmg.getDataIDsFromObject, $bc4b9a4711d6ec6a$var$getRequest = $7eKmg.getRequest, $bc4b9a4711d6ec6a$var$getVariablesFromObject = $7eKmg.getVariablesFromObject, $bc4b9a4711d6ec6a$var$isScalarAndEqual = $7eKmg.isScalarAndEqual;
parcelRequire("2OmBw");
function $bc4b9a4711d6ec6a$var$createContainerWithFragments(Component, fragments, taggedNode) {
    var _class;
    var containerName = $bc4b9a4711d6ec6a$var$getContainerName(Component);
    return _class = /*#__PURE__*/ function(_React$Component) {
        (0, $bc4b9a4711d6ec6a$var$_inheritsLoose2["default"])(_class, _React$Component);
        function _class(props) {
            var _props$__rootIsQueryR, _this;
            _this = _React$Component.call(this, props) || this;
            (0, $bc4b9a4711d6ec6a$var$_defineProperty2["default"])((0, $bc4b9a4711d6ec6a$var$_assertThisInitialized2["default"])(_this), "_handleFragmentDataUpdate", function() {
                var resolverFromThisUpdate = _this.state.resolver;
                _this.setState(function(updatedState) {
                    return resolverFromThisUpdate === updatedState.resolver ? {
                        data: updatedState.resolver.resolve()
                    } : null;
                });
            });
            (0, $bc4b9a4711d6ec6a$var$_defineProperty2["default"])((0, $bc4b9a4711d6ec6a$var$_assertThisInitialized2["default"])(_this), "_refetch", function(refetchVariables, renderVariables, observerOrCallback, options) {
                if (_this._isUnmounted) return {
                    dispose: function dispose() {}
                };
                var _assertRelayContext = $bc4b9a4711d6ec6a$var$assertRelayContext(_this.props.__relayContext), environment = _assertRelayContext.environment;
                var rootVariables = $jXzWu(fragments, _this.props);
                var fetchVariables = typeof refetchVariables === 'function' ? refetchVariables(_this._getFragmentVariables()) : refetchVariables;
                fetchVariables = (0, $bc4b9a4711d6ec6a$var$_objectSpread2["default"])((0, $bc4b9a4711d6ec6a$var$_objectSpread2["default"])({}, rootVariables), fetchVariables);
                var fragmentVariables = renderVariables ? (0, $bc4b9a4711d6ec6a$var$_objectSpread2["default"])((0, $bc4b9a4711d6ec6a$var$_objectSpread2["default"])({}, fetchVariables), renderVariables) : fetchVariables;
                var cacheConfig = options ? {
                    force: !!options.force
                } : undefined;
                if (cacheConfig != null && (options === null || options === void 0 ? void 0 : options.metadata) != null) cacheConfig.metadata = options === null || options === void 0 ? void 0 : options.metadata;
                var observer = typeof observerOrCallback === 'function' ? {
                    error: observerOrCallback,
                    next: observerOrCallback
                } : observerOrCallback || {};
                var query = $bc4b9a4711d6ec6a$var$getRequest(taggedNode);
                var operation = $bc4b9a4711d6ec6a$var$createOperationDescriptor(query, fetchVariables, cacheConfig);
                _this.state.localVariables = fetchVariables;
                _this._refetchSubscription && _this._refetchSubscription.unsubscribe();
                var refetchSubscription;
                var storeSnapshot = _this._getQueryFetcher().lookupInStore(environment, operation, options === null || options === void 0 ? void 0 : options.fetchPolicy);
                if (storeSnapshot != null) {
                    _this.state.resolver.setVariables(fragmentVariables, operation.request.node);
                    _this.setState(function(latestState) {
                        return {
                            contextForChildren: {
                                environment: _this.props.__relayContext.environment
                            },
                            data: latestState.resolver.resolve()
                        };
                    }, function() {
                        observer.next && observer.next();
                        observer.complete && observer.complete();
                    });
                    return {
                        dispose: function dispose() {}
                    };
                }
                _this._getQueryFetcher().execute({
                    environment: environment,
                    operation: operation,
                    preservePreviousReferences: true
                }).mergeMap(function(response) {
                    _this.state.resolver.setVariables(fragmentVariables, operation.request.node);
                    return $bc4b9a4711d6ec6a$var$Observable.create(function(sink) {
                        return _this.setState(function(latestState) {
                            return {
                                contextForChildren: {
                                    environment: _this.props.__relayContext.environment
                                },
                                data: latestState.resolver.resolve()
                            };
                        }, function() {
                            sink.next();
                            sink.complete();
                        });
                    });
                })["finally"](function() {
                    if (_this._refetchSubscription === refetchSubscription) _this._refetchSubscription = null;
                }).subscribe((0, $bc4b9a4711d6ec6a$var$_objectSpread2["default"])((0, $bc4b9a4711d6ec6a$var$_objectSpread2["default"])({}, observer), {}, {
                    start: function start(subscription) {
                        _this._refetchSubscription = refetchSubscription = subscription;
                        observer.start && observer.start(subscription);
                    }
                }));
                return {
                    dispose: function dispose() {
                        refetchSubscription && refetchSubscription.unsubscribe();
                    }
                };
            });
            var relayContext = $bc4b9a4711d6ec6a$var$assertRelayContext(props.__relayContext);
            var rootIsQueryRenderer = (_props$__rootIsQueryR = props.__rootIsQueryRenderer) !== null && _props$__rootIsQueryR !== void 0 ? _props$__rootIsQueryR : false;
            _this._refetchSubscription = null;
            var resolver = $bc4b9a4711d6ec6a$var$createFragmentSpecResolver(relayContext, containerName, fragments, props, rootIsQueryRenderer);
            _this.state = {
                contextForChildren: relayContext,
                data: resolver.resolve(),
                localVariables: null,
                prevProps: props,
                prevPropsContext: relayContext,
                relayProp: $bc4b9a4711d6ec6a$var$getRelayProp(relayContext.environment, _this._refetch),
                resolver: resolver
            };
            _this._isUnmounted = false;
            return _this;
        }
        var _proto = _class.prototype;
        _proto.componentDidMount = function componentDidMount() {
            this._isUnmounted = false;
            this._subscribeToNewResolverAndRerenderIfStoreHasChanged();
        };
        _proto.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
            if (this.state.resolver !== prevState.resolver) {
                prevState.resolver.dispose();
                this._queryFetcher && this._queryFetcher.dispose();
                this._refetchSubscription && this._refetchSubscription.unsubscribe();
                this._subscribeToNewResolverAndRerenderIfStoreHasChanged();
            } else this._rerenderIfStoreHasChanged();
        };
        _class.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, prevState) {
            var _nextProps$__rootIsQu;
            var prevProps = prevState.prevProps;
            var relayContext = $bc4b9a4711d6ec6a$var$assertRelayContext(nextProps.__relayContext);
            var rootIsQueryRenderer = (_nextProps$__rootIsQu = nextProps.__rootIsQueryRenderer) !== null && _nextProps$__rootIsQu !== void 0 ? _nextProps$__rootIsQu : false;
            var prevIDs = $bc4b9a4711d6ec6a$var$getDataIDsFromObject(fragments, prevProps);
            var nextIDs = $bc4b9a4711d6ec6a$var$getDataIDsFromObject(fragments, nextProps);
            var prevRootVariables = $jXzWu(fragments, prevProps);
            var nextRootVariables = $jXzWu(fragments, nextProps);
            var resolver = prevState.resolver;
            if (prevState.prevPropsContext.environment !== relayContext.environment || !$bke7t(prevRootVariables, nextRootVariables) || !$bke7t(prevIDs, nextIDs)) {
                resolver = $bc4b9a4711d6ec6a$var$createFragmentSpecResolver(relayContext, containerName, fragments, nextProps, rootIsQueryRenderer);
                return {
                    contextForChildren: relayContext,
                    data: resolver.resolve(),
                    localVariables: null,
                    prevProps: nextProps,
                    prevPropsContext: relayContext,
                    relayProp: $bc4b9a4711d6ec6a$var$getRelayProp(relayContext.environment, prevState.relayProp.refetch),
                    resolver: resolver
                };
            } else if (!prevState.localVariables) resolver.setProps(nextProps);
            var data = resolver.resolve();
            if (data !== prevState.data) return {
                data: data,
                prevProps: nextProps
            };
            return null;
        };
        _proto.componentWillUnmount = function componentWillUnmount() {
            this._isUnmounted = true;
            this.state.resolver.dispose();
            this._queryFetcher && this._queryFetcher.dispose();
            this._refetchSubscription && this._refetchSubscription.unsubscribe();
        };
        _proto.shouldComponentUpdate = function shouldComponentUpdate(nextProps, nextState) {
            if (nextState.data !== this.state.data || nextState.relayProp !== this.state.relayProp) return true;
            var keys = Object.keys(nextProps);
            for(var ii = 0; ii < keys.length; ii++){
                var key = keys[ii];
                if (key === '__relayContext') {
                    if (this.state.prevPropsContext.environment !== nextState.prevPropsContext.environment) return true;
                } else {
                    if (!fragments.hasOwnProperty(key) && !$bc4b9a4711d6ec6a$var$isScalarAndEqual(nextProps[key], this.props[key])) return true;
                }
            }
            return false;
        };
        _proto._rerenderIfStoreHasChanged = function _rerenderIfStoreHasChanged() {
            var _this$state = this.state, data = _this$state.data, resolver = _this$state.resolver;
            var maybeNewData = resolver.resolve();
            if (data !== maybeNewData) this.setState({
                data: maybeNewData
            });
        };
        _proto._subscribeToNewResolverAndRerenderIfStoreHasChanged = function _subscribeToNewResolverAndRerenderIfStoreHasChanged() {
            var _this$state2 = this.state, data = _this$state2.data, resolver = _this$state2.resolver;
            var maybeNewData = resolver.resolve();
            resolver.setCallback(this.props, this._handleFragmentDataUpdate);
            if (data !== maybeNewData) this.setState({
                data: maybeNewData
            });
        };
        _proto._getFragmentVariables = function _getFragmentVariables() {
            return $bc4b9a4711d6ec6a$var$getVariablesFromObject(fragments, this.props);
        };
        _proto._getQueryFetcher = function _getQueryFetcher() {
            if (!this._queryFetcher) this._queryFetcher = new $bDiPv();
            return this._queryFetcher;
        };
        _proto.render = function render() {
            var _this$props = this.props, componentRef = _this$props.componentRef, __relayContext = _this$props.__relayContext, __rootIsQueryRenderer = _this$props.__rootIsQueryRenderer, props = (0, $bc4b9a4711d6ec6a$var$_objectWithoutPropertiesLoose2["default"])(_this$props, $bc4b9a4711d6ec6a$var$_excluded);
            var _this$state3 = this.state, relayProp = _this$state3.relayProp, contextForChildren = _this$state3.contextForChildren;
            return /*#__PURE__*/ $5FkrB.createElement($8FWpR.Provider, {
                value: contextForChildren
            }, /*#__PURE__*/ $5FkrB.createElement(Component, (0, $bc4b9a4711d6ec6a$var$_extends2["default"])({}, props, this.state.data, {
                ref: componentRef,
                relay: relayProp
            })));
        };
        return _class;
    }($5FkrB.Component), (0, $bc4b9a4711d6ec6a$var$_defineProperty2["default"])(_class, "displayName", containerName), _class;
}
function $bc4b9a4711d6ec6a$var$getRelayProp(environment, refetch) {
    return {
        environment: environment,
        refetch: refetch
    };
}
function $bc4b9a4711d6ec6a$var$createContainer(Component, fragmentSpec, taggedNode) {
    return $iVKxO(Component, fragmentSpec, function(ComponentClass, fragments) {
        return $bc4b9a4711d6ec6a$var$createContainerWithFragments(ComponentClass, fragments, taggedNode);
    });
}
module.exports = {
    createContainer: $bc4b9a4711d6ec6a$var$createContainer
};

});

parcelRegister("3ijZm", function(module, exports) {
'use strict';

var $j5zXq = parcelRequire("j5zXq");

var $23TM5 = parcelRequire("23TM5");

var $5FkrB = parcelRequire("5FkrB");

var $5FkrB = parcelRequire("5FkrB");
var $26628eddb831df04$var$useContext = $5FkrB.useContext, $26628eddb831df04$var$useEffect = $5FkrB.useEffect;
parcelRequire("2OmBw");
function $26628eddb831df04$var$EntryPointContainer(_ref) {
    var entryPointReference = _ref.entryPointReference, props = _ref.props;
    var getComponent = entryPointReference.getComponent, queries = entryPointReference.queries, entryPoints = entryPointReference.entryPoints, extraProps = entryPointReference.extraProps, rootModuleID = entryPointReference.rootModuleID;
    var Component = getComponent();
    var profilerContext = $26628eddb831df04$var$useContext($j5zXq);
    var environment = $23TM5();
    $26628eddb831df04$var$useEffect(function() {
        environment.__log({
            name: 'entrypoint.root.consume',
            profilerContext: profilerContext,
            rootModuleID: rootModuleID
        });
    }, [
        environment,
        profilerContext,
        rootModuleID
    ]);
    return /*#__PURE__*/ $5FkrB.createElement(Component, {
        entryPoints: entryPoints,
        extraProps: extraProps,
        props: props,
        queries: queries
    });
}
module.exports = $26628eddb831df04$var$EntryPointContainer;

});
parcelRegister("j5zXq", function(module, exports) {
'use strict';

var $5FkrB = parcelRequire("5FkrB");
var $de5a605979fd6a5d$var$ProfilerContext = $5FkrB.createContext({
    wrapPrepareQueryResource: function wrapPrepareQueryResource(cb) {
        return cb();
    }
});
module.exports = $de5a605979fd6a5d$var$ProfilerContext;

});

parcelRegister("23TM5", function(module, exports) {
'use strict';

var $8FWpR = parcelRequire("8FWpR");

var $jSI6G = parcelRequire("jSI6G");

var $5FkrB = parcelRequire("5FkrB");
var $18072042bff84e29$var$useContext = $5FkrB.useContext;
function $18072042bff84e29$var$useRelayEnvironment() {
    var context = $18072042bff84e29$var$useContext($8FWpR);
    !(context != null) && $jSI6G(false);
    return context.environment;
}
module.exports = $18072042bff84e29$var$useRelayEnvironment;

});


parcelRegister("b2vkf", function(module, exports) {
'use strict';

var $ejfNK = parcelRequire("ejfNK");
var $80982e324b32f70c$var$loadQuery = $ejfNK.loadQuery;
function $80982e324b32f70c$var$loadEntryPoint(environmentProvider, entryPoint, entryPointParams) {
    var loadingPromise = null;
    if (entryPoint.root.getModuleIfRequired() == null) loadingPromise = entryPoint.root.load();
    var preloadProps = entryPoint.getPreloadProps(entryPointParams);
    var queries = preloadProps.queries, entryPoints = preloadProps.entryPoints, extraProps = preloadProps.extraProps;
    var preloadedQueries = {};
    var preloadedEntryPoints = {};
    if (queries != null) {
        var queriesPropNames = Object.keys(queries);
        queriesPropNames.forEach(function(queryPropName) {
            var query = queries[queryPropName];
            if (query == null) return;
            var environmentProviderOptions = query.environmentProviderOptions, options = query.options, parameters = query.parameters, variables = query.variables;
            if ((options === null || options === void 0 ? void 0 : options.includeIf) === false) return;
            var environment = environmentProvider.getEnvironment(environmentProviderOptions);
            preloadedQueries[queryPropName] = $80982e324b32f70c$var$loadQuery(environment, parameters, variables, {
                __nameForWarning: 'loadEntryPoint',
                fetchPolicy: options === null || options === void 0 ? void 0 : options.fetchPolicy,
                networkCacheConfig: options === null || options === void 0 ? void 0 : options.networkCacheConfig
            }, environmentProviderOptions);
        });
    }
    if (entryPoints != null) {
        var entryPointPropNames = Object.keys(entryPoints);
        entryPointPropNames.forEach(function(entryPointPropName) {
            var entryPointDescription = entryPoints[entryPointPropName];
            if (entryPointDescription == null) return;
            var nestedEntryPoint = entryPointDescription.entryPoint, nestedParams = entryPointDescription.entryPointParams;
            preloadedEntryPoints[entryPointPropName] = $80982e324b32f70c$var$loadEntryPoint(environmentProvider, nestedEntryPoint, nestedParams);
        });
    }
    var isDisposed = false;
    return {
        dispose: function dispose() {
            if (isDisposed) return;
            if (preloadedQueries != null) Object.values(preloadedQueries).forEach(function(_ref) {
                var innerDispose = _ref.dispose;
                innerDispose();
            });
            if (preloadedEntryPoints != null) Object.values(preloadedEntryPoints).forEach(function(_ref2) {
                var innerDispose = _ref2.dispose;
                innerDispose();
            });
            isDisposed = true;
        },
        entryPoints: preloadedEntryPoints,
        extraProps: extraProps !== null && extraProps !== void 0 ? extraProps : null,
        getComponent: function getComponent() {
            var componentModule = entryPoint.root.getModuleIfRequired();
            if (componentModule == null) {
                var _loadingPromise;
                loadingPromise = (_loadingPromise = loadingPromise) !== null && _loadingPromise !== void 0 ? _loadingPromise : entryPoint.root.load();
                throw loadingPromise;
            }
            var component = componentModule["default"] != null ? componentModule["default"] : componentModule;
            return component;
        },
        get isDisposed () {
            return isDisposed;
        },
        queries: preloadedQueries,
        rootModuleID: entryPoint.root.getModuleId()
    };
}
module.exports = $80982e324b32f70c$var$loadEntryPoint;

});
parcelRegister("ejfNK", function(module, exports) {
'use strict';

var $drPJO = parcelRequire("drPJO");
var $a6af18e1ac94b871$var$_interopRequireDefault = $drPJO.default;

var $a6af18e1ac94b871$var$_objectSpread2 = $a6af18e1ac94b871$var$_interopRequireDefault((parcelRequire("5OKtB")));

var $jSI6G = parcelRequire("jSI6G");

var $7eKmg = parcelRequire("7eKmg");
var $a6af18e1ac94b871$var$fetchQueryDeduped = $7eKmg.__internal.fetchQueryDeduped, $a6af18e1ac94b871$var$Observable = $7eKmg.Observable, $a6af18e1ac94b871$var$PreloadableQueryRegistry = $7eKmg.PreloadableQueryRegistry, $a6af18e1ac94b871$var$ReplaySubject = $7eKmg.ReplaySubject, $a6af18e1ac94b871$var$createOperationDescriptor = $7eKmg.createOperationDescriptor, $a6af18e1ac94b871$var$getRequest = $7eKmg.getRequest, $a6af18e1ac94b871$var$getRequestIdentifier = $7eKmg.getRequestIdentifier;
var $a6af18e1ac94b871$var$fetchKey = 100001;
function $a6af18e1ac94b871$var$loadQuery(environment, preloadableRequest, variables, options, environmentProviderOptions) {
    var _options$fetchPolicy;
    $a6af18e1ac94b871$var$fetchKey++;
    var fetchPolicy = (_options$fetchPolicy = options === null || options === void 0 ? void 0 : options.fetchPolicy) !== null && _options$fetchPolicy !== void 0 ? _options$fetchPolicy : 'store-or-network';
    var networkCacheConfig = (0, $a6af18e1ac94b871$var$_objectSpread2["default"])((0, $a6af18e1ac94b871$var$_objectSpread2["default"])({}, options === null || options === void 0 ? void 0 : options.networkCacheConfig), {}, {
        force: true
    });
    var retainReference;
    var didExecuteNetworkSource = false;
    var executeWithNetworkSource = function executeWithNetworkSource(operation, networkObservable) {
        didExecuteNetworkSource = true;
        return environment.executeWithSource({
            operation: operation,
            source: networkObservable
        });
    };
    var executionSubject = new $a6af18e1ac94b871$var$ReplaySubject();
    var returnedObservable = $a6af18e1ac94b871$var$Observable.create(function(sink) {
        return executionSubject.subscribe(sink);
    });
    var unsubscribeFromNetworkRequest;
    var networkError = null;
    var didMakeNetworkRequest = false;
    var makeNetworkRequest = function makeNetworkRequest(params, checkOperation) {
        didMakeNetworkRequest = true;
        var subject = new $a6af18e1ac94b871$var$ReplaySubject();
        var identifier = 'raw-network-request-' + $a6af18e1ac94b871$var$getRequestIdentifier(params, variables);
        var observable = $a6af18e1ac94b871$var$fetchQueryDeduped(environment, identifier, function() {
            var network = environment.getNetwork();
            return network.execute(params, variables, networkCacheConfig, undefined, undefined, undefined, undefined, checkOperation);
        });
        var _observable$subscribe = observable.subscribe({
            complete: function complete() {
                subject.complete();
            },
            error: function error(err) {
                networkError = err;
                subject.error(err);
            },
            next: function next(data) {
                subject.next(data);
            }
        }), unsubscribe = _observable$subscribe.unsubscribe;
        unsubscribeFromNetworkRequest = unsubscribe;
        return $a6af18e1ac94b871$var$Observable.create(function(sink) {
            var subjectSubscription = subject.subscribe(sink);
            return function() {
                subjectSubscription.unsubscribe();
                unsubscribeFromNetworkRequest();
            };
        });
    };
    var unsubscribeFromExecution;
    var executeDeduped = function executeDeduped(operation, fetchFn) {
        didMakeNetworkRequest = true;
        var _fetchQueryDeduped$su = $a6af18e1ac94b871$var$fetchQueryDeduped(environment, operation.request.identifier, fetchFn).subscribe({
            complete: function complete() {
                executionSubject.complete();
            },
            error: function error(err) {
                executionSubject.error(err);
            },
            next: function next(data) {
                executionSubject.next(data);
            }
        });
        unsubscribeFromExecution = _fetchQueryDeduped$su.unsubscribe;
    };
    var checkAvailabilityAndExecute = function checkAvailabilityAndExecute(concreteRequest) {
        var operation = $a6af18e1ac94b871$var$createOperationDescriptor(concreteRequest, variables, networkCacheConfig);
        retainReference = environment.retain(operation);
        if (fetchPolicy === 'store-only') return;
        var shouldFetch = fetchPolicy !== 'store-or-network' || environment.check(operation).status !== 'available';
        if (shouldFetch) executeDeduped(operation, function() {
            var networkObservable = makeNetworkRequest(concreteRequest.params, function() {
                return environment.check(operation);
            });
            var executeObservable = executeWithNetworkSource(operation, networkObservable);
            return executeObservable;
        });
    };
    var params;
    var cancelOnLoadCallback;
    var queryId;
    if (preloadableRequest.kind === 'PreloadableConcreteRequest') {
        var preloadableConcreteRequest = preloadableRequest;
        params = preloadableConcreteRequest.params;
        var _params = params;
        queryId = _params.id;
        !(queryId !== null) && $jSI6G(false);
        var _module = $a6af18e1ac94b871$var$PreloadableQueryRegistry.get(queryId);
        if (_module != null) checkAvailabilityAndExecute(_module);
        else {
            var networkObservable = fetchPolicy === 'store-only' ? null : makeNetworkRequest(params);
            var _PreloadableQueryRegi = $a6af18e1ac94b871$var$PreloadableQueryRegistry.onLoad(queryId, function(preloadedModule) {
                cancelOnLoadCallback();
                var operation = $a6af18e1ac94b871$var$createOperationDescriptor(preloadedModule, variables, networkCacheConfig);
                retainReference = environment.retain(operation);
                if (networkObservable != null) executeDeduped(operation, function() {
                    return executeWithNetworkSource(operation, networkObservable);
                });
            });
            cancelOnLoadCallback = _PreloadableQueryRegi.dispose;
        }
    } else {
        var graphQlTaggedNode = preloadableRequest;
        var request = $a6af18e1ac94b871$var$getRequest(graphQlTaggedNode);
        params = request.params;
        queryId = params.cacheID != null ? params.cacheID : params.id;
        checkAvailabilityAndExecute(request);
    }
    var isDisposed = false;
    var isReleased = false;
    var isNetworkRequestCancelled = false;
    var releaseQuery = function releaseQuery() {
        if (isReleased) return;
        retainReference && retainReference.dispose();
        isReleased = true;
    };
    var cancelNetworkRequest = function cancelNetworkRequest() {
        if (isNetworkRequestCancelled) return;
        if (didExecuteNetworkSource) unsubscribeFromExecution && unsubscribeFromExecution();
        else unsubscribeFromNetworkRequest && unsubscribeFromNetworkRequest();
        cancelOnLoadCallback && cancelOnLoadCallback();
        isNetworkRequestCancelled = true;
    };
    return {
        cancelNetworkRequest: cancelNetworkRequest,
        dispose: function dispose() {
            if (isDisposed) return;
            releaseQuery();
            cancelNetworkRequest();
            isDisposed = true;
        },
        environment: environment,
        environmentProviderOptions: environmentProviderOptions,
        fetchKey: $a6af18e1ac94b871$var$fetchKey,
        fetchPolicy: fetchPolicy,
        id: queryId,
        get isDisposed () {
            return isDisposed || isReleased;
        },
        kind: 'PreloadedQuery',
        name: params.name,
        networkCacheConfig: networkCacheConfig,
        get networkError () {
            return networkError;
        },
        releaseQuery: releaseQuery,
        source: didMakeNetworkRequest ? returnedObservable : undefined,
        variables: variables
    };
}
module.exports = {
    loadQuery: $a6af18e1ac94b871$var$loadQuery
};

});


parcelRegister("3JdSd", function(module, exports) {
'use strict';

var $8FWpR = parcelRequire("8FWpR");

var $5FkrB = parcelRequire("5FkrB");
var $2b70560ca85eea5b$var$useMemo = $5FkrB.useMemo;
function $2b70560ca85eea5b$var$RelayEnvironmentProvider(props) {
    var children = props.children, environment = props.environment, getEnvironmentForActor = props.getEnvironmentForActor;
    var context = $2b70560ca85eea5b$var$useMemo(function() {
        return {
            environment: environment,
            getEnvironmentForActor: getEnvironmentForActor
        };
    }, [
        environment,
        getEnvironmentForActor
    ]);
    return /*#__PURE__*/ $5FkrB.createElement($8FWpR.Provider, {
        value: context
    }, children);
}
module.exports = $2b70560ca85eea5b$var$RelayEnvironmentProvider;

});

parcelRegister("dIqcO", function(module, exports) {
'use strict';

var $drPJO = parcelRequire("drPJO");
var $9fc3b64becebeb18$var$_interopRequireDefault = $drPJO.default;

var $9fc3b64becebeb18$var$_objectSpread2 = $9fc3b64becebeb18$var$_interopRequireDefault((parcelRequire("5OKtB")));

var $gskhu = parcelRequire("gskhu");
function $9fc3b64becebeb18$var$useClientQuery(gqlQuery, variables, options) {
    var query = gqlQuery;
    return $gskhu(query, variables, (0, $9fc3b64becebeb18$var$_objectSpread2["default"])((0, $9fc3b64becebeb18$var$_objectSpread2["default"])({}, options), {}, {
        fetchPolicy: 'store-only'
    }));
}
module.exports = $9fc3b64becebeb18$var$useClientQuery;

});
parcelRegister("gskhu", function(module, exports) {
'use strict';

var $bJ98H = parcelRequire("bJ98H");

var $96WbG = parcelRequire("96WbG");

var $23TM5 = parcelRequire("23TM5");

var $7eKmg = parcelRequire("7eKmg");
var $bfaefe45e3ee1d47$var$fetchQuery = $7eKmg.__internal.fetchQuery;
function $bfaefe45e3ee1d47$var$useLazyLoadQuery(gqlQuery, variables, options) {
    var environment = $23TM5();
    var query = $96WbG(gqlQuery, variables, options && options.networkCacheConfig ? options.networkCacheConfig : {
        force: true
    });
    var data = $bJ98H({
        componentDisplayName: 'useLazyLoadQuery()',
        fetchKey: options === null || options === void 0 ? void 0 : options.fetchKey,
        fetchObservable: $bfaefe45e3ee1d47$var$fetchQuery(environment, query),
        fetchPolicy: options === null || options === void 0 ? void 0 : options.fetchPolicy,
        query: query,
        renderPolicy: options === null || options === void 0 ? void 0 : options.UNSTABLE_renderPolicy
    });
    return data;
}
module.exports = $bfaefe45e3ee1d47$var$useLazyLoadQuery;

});
parcelRegister("bJ98H", function(module, exports) {
'use strict';

var $j5zXq = parcelRequire("j5zXq");

var $gELTa = parcelRequire("gELTa");
var $889afc90d207d99f$var$getQueryCacheIdentifier = $gELTa.getQueryCacheIdentifier, $889afc90d207d99f$var$getQueryResourceForEnvironment = $gELTa.getQueryResourceForEnvironment;

var $dxt9N = parcelRequire("dxt9N");

var $3R4z1 = parcelRequire("3R4z1");

var $23TM5 = parcelRequire("23TM5");

var $5FkrB = parcelRequire("5FkrB");
var $889afc90d207d99f$var$useContext = $5FkrB.useContext, $889afc90d207d99f$var$useEffect = $5FkrB.useEffect, $889afc90d207d99f$var$useState = $5FkrB.useState, $889afc90d207d99f$var$useRef = $5FkrB.useRef;
function $889afc90d207d99f$var$useLazyLoadQueryNode(params) {
    var _preparedQueryResult;
    var environment = $23TM5();
    var profilerContext = $889afc90d207d99f$var$useContext($j5zXq);
    var QueryResource = $889afc90d207d99f$var$getQueryResourceForEnvironment(environment);
    var _useState = $889afc90d207d99f$var$useState(0), forceUpdateKey = _useState[0], forceUpdate = _useState[1];
    var _useFetchTrackingRef = $dxt9N(), startFetch = _useFetchTrackingRef.startFetch, completeFetch = _useFetchTrackingRef.completeFetch;
    var cacheIdentifier = null;
    var preparedQueryResult = null;
    var fragmentNode;
    if (params.query != null) {
        var query = params.query, fetchObservable = params.fetchObservable, fetchPolicy = params.fetchPolicy, fetchKey = params.fetchKey, renderPolicy = params.renderPolicy;
        var cacheBreaker = "".concat(forceUpdateKey, "-").concat(fetchKey !== null && fetchKey !== void 0 ? fetchKey : '');
        var queryCacheIdentifier = $889afc90d207d99f$var$getQueryCacheIdentifier(environment, query, fetchPolicy, renderPolicy, cacheBreaker);
        cacheIdentifier = queryCacheIdentifier;
        preparedQueryResult = profilerContext.wrapPrepareQueryResource(function() {
            return QueryResource.prepareWithIdentifier(queryCacheIdentifier, query, fetchObservable, fetchPolicy, renderPolicy, {
                start: startFetch,
                complete: completeFetch,
                error: completeFetch
            }, profilerContext);
        });
        fragmentNode = preparedQueryResult.fragmentNode;
    } else fragmentNode = params.fragmentNode;
    var maybeHiddenOrFastRefresh = $889afc90d207d99f$var$useRef(false);
    $889afc90d207d99f$var$useEffect(function() {
        return function() {
            maybeHiddenOrFastRefresh.current = true;
        };
    }, []);
    $889afc90d207d99f$var$useEffect(function() {
        if (maybeHiddenOrFastRefresh.current === true) {
            maybeHiddenOrFastRefresh.current = false;
            forceUpdate(function(n) {
                return n + 1;
            });
            return;
        }
        if (preparedQueryResult == null) return;
        var disposable = QueryResource.retain(preparedQueryResult, profilerContext);
        return function() {
            disposable.dispose();
        };
    }, [
        environment,
        cacheIdentifier
    ]);
    $889afc90d207d99f$var$useEffect(function() {
        if (preparedQueryResult == null) return;
        QueryResource.releaseTemporaryRetain(preparedQueryResult);
    });
    var data = $3R4z1(fragmentNode, (_preparedQueryResult = preparedQueryResult) === null || _preparedQueryResult === void 0 ? void 0 : _preparedQueryResult.fragmentRef, params.componentDisplayName);
    return data;
}
module.exports = $889afc90d207d99f$var$useLazyLoadQueryNode;

});
parcelRegister("gELTa", function(module, exports) {
'use strict';

var $drPJO = parcelRequire("drPJO");
var $c2058782296a5f46$var$_interopRequireDefault = $drPJO.default;

var $c2058782296a5f46$var$_objectSpread2 = $c2058782296a5f46$var$_interopRequireDefault((parcelRequire("5OKtB")));

var $c2058782296a5f46$var$_defineProperty2 = $c2058782296a5f46$var$_interopRequireDefault((parcelRequire("gPhXO")));

var $llotJ = parcelRequire("llotJ");

var $3XAPK = parcelRequire("3XAPK");

var $jSI6G = parcelRequire("jSI6G");

var $7eKmg = parcelRequire("7eKmg");
var $c2058782296a5f46$var$isPromise = $7eKmg.isPromise;
parcelRequire("2OmBw");
var $c2058782296a5f46$var$CACHE_CAPACITY = 1000;
var $c2058782296a5f46$var$DEFAULT_FETCH_POLICY = 'store-or-network';
var $c2058782296a5f46$var$DEFAULT_LIVE_FETCH_POLICY = 'store-and-network';
var $c2058782296a5f46$var$WEAKMAP_SUPPORTED = typeof WeakMap === 'function';
function $c2058782296a5f46$var$operationIsLiveQuery(operation) {
    return operation.request.node.params.metadata.live !== undefined;
}
function $c2058782296a5f46$var$getQueryCacheIdentifier(environment, operation, maybeFetchPolicy, maybeRenderPolicy, cacheBreaker) {
    var fetchPolicy = maybeFetchPolicy !== null && maybeFetchPolicy !== void 0 ? maybeFetchPolicy : $c2058782296a5f46$var$operationIsLiveQuery(operation) ? $c2058782296a5f46$var$DEFAULT_LIVE_FETCH_POLICY : $c2058782296a5f46$var$DEFAULT_FETCH_POLICY;
    var renderPolicy = maybeRenderPolicy !== null && maybeRenderPolicy !== void 0 ? maybeRenderPolicy : environment.UNSTABLE_getDefaultRenderPolicy();
    var cacheIdentifier = "".concat(fetchPolicy, "-").concat(renderPolicy, "-").concat(operation.request.identifier);
    if (cacheBreaker != null) return "".concat(cacheIdentifier, "-").concat(cacheBreaker);
    return cacheIdentifier;
}
function $c2058782296a5f46$var$getQueryResult(operation, cacheIdentifier) {
    var rootFragmentRef = {
        __id: operation.fragment.dataID,
        __fragments: (0, $c2058782296a5f46$var$_defineProperty2["default"])({}, operation.fragment.node.name, operation.request.variables),
        __fragmentOwner: operation.request
    };
    return {
        cacheIdentifier: cacheIdentifier,
        fragmentNode: operation.request.node.fragment,
        fragmentRef: rootFragmentRef,
        operation: operation
    };
}
var $c2058782296a5f46$var$nextID = 200000;
function $c2058782296a5f46$var$createCacheEntry(cacheIdentifier, operation, operationAvailability, value, networkSubscription, onDispose) {
    var isLiveQuery = $c2058782296a5f46$var$operationIsLiveQuery(operation);
    var currentValue = value;
    var currentNetworkSubscription = networkSubscription;
    var suspenseResource = new $3XAPK(function(environment) {
        var retention = environment.retain(operation);
        return {
            dispose: function dispose() {
                if (isLiveQuery && currentNetworkSubscription != null) currentNetworkSubscription.unsubscribe();
                retention.dispose();
                onDispose(cacheEntry);
            }
        };
    });
    var cacheEntry = {
        cacheIdentifier: cacheIdentifier,
        id: $c2058782296a5f46$var$nextID++,
        processedPayloadsCount: 0,
        operationAvailability: operationAvailability,
        getValue: function getValue() {
            return currentValue;
        },
        setValue: function setValue(val) {
            currentValue = val;
        },
        setNetworkSubscription: function setNetworkSubscription(subscription) {
            if (isLiveQuery && currentNetworkSubscription != null) currentNetworkSubscription.unsubscribe();
            currentNetworkSubscription = subscription;
        },
        temporaryRetain: function temporaryRetain(environment) {
            return suspenseResource.temporaryRetain(environment);
        },
        permanentRetain: function permanentRetain(environment) {
            return suspenseResource.permanentRetain(environment);
        },
        releaseTemporaryRetain: function releaseTemporaryRetain() {
            suspenseResource.releaseTemporaryRetain();
        }
    };
    return cacheEntry;
}
var $c2058782296a5f46$var$QueryResourceImpl = /*#__PURE__*/ function() {
    function QueryResourceImpl(environment) {
        var _this = this;
        (0, $c2058782296a5f46$var$_defineProperty2["default"])(this, "_clearCacheEntry", function(cacheEntry) {
            _this._cache["delete"](cacheEntry.cacheIdentifier);
        });
        this._environment = environment;
        this._cache = $llotJ.create($c2058782296a5f46$var$CACHE_CAPACITY);
    }
    var _proto = QueryResourceImpl.prototype;
    _proto.prepare = function prepare(operation, fetchObservable, maybeFetchPolicy, maybeRenderPolicy, observer, cacheBreaker, profilerContext) {
        var cacheIdentifier = $c2058782296a5f46$var$getQueryCacheIdentifier(this._environment, operation, maybeFetchPolicy, maybeRenderPolicy, cacheBreaker);
        return this.prepareWithIdentifier(cacheIdentifier, operation, fetchObservable, maybeFetchPolicy, maybeRenderPolicy, observer, profilerContext);
    };
    _proto.prepareWithIdentifier = function prepareWithIdentifier(cacheIdentifier, operation, fetchObservable, maybeFetchPolicy, maybeRenderPolicy, observer, profilerContext) {
        var environment = this._environment;
        var fetchPolicy = maybeFetchPolicy !== null && maybeFetchPolicy !== void 0 ? maybeFetchPolicy : $c2058782296a5f46$var$operationIsLiveQuery(operation) ? $c2058782296a5f46$var$DEFAULT_LIVE_FETCH_POLICY : $c2058782296a5f46$var$DEFAULT_FETCH_POLICY;
        var renderPolicy = maybeRenderPolicy !== null && maybeRenderPolicy !== void 0 ? maybeRenderPolicy : environment.UNSTABLE_getDefaultRenderPolicy();
        var cacheEntry = this._cache.get(cacheIdentifier);
        var temporaryRetainDisposable = null;
        var entryWasCached = cacheEntry != null;
        if (cacheEntry == null) cacheEntry = this._fetchAndSaveQuery(cacheIdentifier, operation, fetchObservable, fetchPolicy, renderPolicy, profilerContext, (0, $c2058782296a5f46$var$_objectSpread2["default"])((0, $c2058782296a5f46$var$_objectSpread2["default"])({}, observer), {}, {
            unsubscribe: function unsubscribe(subscription) {
                if (temporaryRetainDisposable != null) temporaryRetainDisposable.dispose();
                var observerUnsubscribe = observer === null || observer === void 0 ? void 0 : observer.unsubscribe;
                observerUnsubscribe && observerUnsubscribe(subscription);
            }
        }));
        temporaryRetainDisposable = cacheEntry.temporaryRetain(environment);
        var cachedValue = cacheEntry.getValue();
        if ($c2058782296a5f46$var$isPromise(cachedValue)) {
            environment.__log({
                name: 'suspense.query',
                fetchPolicy: fetchPolicy,
                isPromiseCached: entryWasCached,
                operation: operation,
                queryAvailability: cacheEntry.operationAvailability,
                renderPolicy: renderPolicy
            });
            throw cachedValue;
        }
        if (cachedValue instanceof Error) throw cachedValue;
        return cachedValue;
    };
    _proto.retain = function retain(queryResult, profilerContext) {
        var environment = this._environment;
        var cacheIdentifier = queryResult.cacheIdentifier, operation = queryResult.operation;
        var cacheEntry = this._getOrCreateCacheEntry(cacheIdentifier, operation, null, queryResult, null);
        var disposable = cacheEntry.permanentRetain(environment);
        environment.__log({
            name: 'queryresource.retain',
            profilerContext: profilerContext,
            resourceID: cacheEntry.id
        });
        return {
            dispose: function dispose() {
                disposable.dispose();
            }
        };
    };
    _proto.releaseTemporaryRetain = function releaseTemporaryRetain(queryResult) {
        var cacheEntry = this._cache.get(queryResult.cacheIdentifier);
        if (cacheEntry != null) cacheEntry.releaseTemporaryRetain();
    };
    _proto.TESTS_ONLY__getCacheEntry = function TESTS_ONLY__getCacheEntry(operation, maybeFetchPolicy, maybeRenderPolicy, cacheBreaker) {
        var environment = this._environment;
        var cacheIdentifier = $c2058782296a5f46$var$getQueryCacheIdentifier(environment, operation, maybeFetchPolicy, maybeRenderPolicy, cacheBreaker);
        return this._cache.get(cacheIdentifier);
    };
    _proto._getOrCreateCacheEntry = function _getOrCreateCacheEntry(cacheIdentifier, operation, operationAvailability, value, networkSubscription) {
        var cacheEntry = this._cache.get(cacheIdentifier);
        if (cacheEntry == null) {
            cacheEntry = $c2058782296a5f46$var$createCacheEntry(cacheIdentifier, operation, operationAvailability, value, networkSubscription, this._clearCacheEntry);
            this._cache.set(cacheIdentifier, cacheEntry);
        }
        return cacheEntry;
    };
    _proto._fetchAndSaveQuery = function _fetchAndSaveQuery(cacheIdentifier, operation, fetchObservable, fetchPolicy, renderPolicy, profilerContext, observer) {
        var _this2 = this;
        var environment = this._environment;
        var queryAvailability = environment.check(operation);
        var queryStatus = queryAvailability.status;
        var hasFullQuery = queryStatus === 'available';
        var canPartialRender = hasFullQuery || renderPolicy === 'partial' && queryStatus !== 'stale';
        var shouldFetch;
        var shouldAllowRender;
        var resolveNetworkPromise = function resolveNetworkPromise() {};
        switch(fetchPolicy){
            case 'store-only':
                shouldFetch = false;
                shouldAllowRender = true;
                break;
            case 'store-or-network':
                shouldFetch = !hasFullQuery;
                shouldAllowRender = canPartialRender;
                break;
            case 'store-and-network':
                shouldFetch = true;
                shouldAllowRender = canPartialRender;
                break;
            case 'network-only':
            default:
                shouldFetch = true;
                shouldAllowRender = false;
                break;
        }
        if (shouldAllowRender) {
            var queryResult = $c2058782296a5f46$var$getQueryResult(operation, cacheIdentifier);
            var _cacheEntry = $c2058782296a5f46$var$createCacheEntry(cacheIdentifier, operation, queryAvailability, queryResult, null, this._clearCacheEntry);
            this._cache.set(cacheIdentifier, _cacheEntry);
        }
        if (shouldFetch) {
            var _queryResult = $c2058782296a5f46$var$getQueryResult(operation, cacheIdentifier);
            var networkSubscription;
            fetchObservable.subscribe({
                start: function start(subscription) {
                    networkSubscription = subscription;
                    var cacheEntry = _this2._cache.get(cacheIdentifier);
                    if (cacheEntry) cacheEntry.setNetworkSubscription(networkSubscription);
                    var observerStart = observer === null || observer === void 0 ? void 0 : observer.start;
                    if (observerStart) {
                        var subscriptionWithConditionalCancelation = (0, $c2058782296a5f46$var$_objectSpread2["default"])((0, $c2058782296a5f46$var$_objectSpread2["default"])({}, subscription), {}, {
                            unsubscribe: function unsubscribe() {
                                if ($c2058782296a5f46$var$operationIsLiveQuery(operation)) subscription.unsubscribe();
                            }
                        });
                        observerStart(subscriptionWithConditionalCancelation);
                    }
                },
                next: function next() {
                    var cacheEntry = _this2._getOrCreateCacheEntry(cacheIdentifier, operation, queryAvailability, _queryResult, networkSubscription);
                    cacheEntry.processedPayloadsCount += 1;
                    cacheEntry.setValue(_queryResult);
                    resolveNetworkPromise();
                    var observerNext = observer === null || observer === void 0 ? void 0 : observer.next;
                    if (observerNext != null) {
                        var snapshot = environment.lookup(operation.fragment);
                        observerNext(snapshot);
                    }
                },
                error: function error(_error) {
                    var cacheEntry = _this2._getOrCreateCacheEntry(cacheIdentifier, operation, queryAvailability, _error, networkSubscription);
                    if (cacheEntry.processedPayloadsCount === 0) cacheEntry.setValue(_error);
                    resolveNetworkPromise();
                    networkSubscription = null;
                    cacheEntry.setNetworkSubscription(null);
                    var observerError = observer === null || observer === void 0 ? void 0 : observer.error;
                    observerError && observerError(_error);
                },
                complete: function complete() {
                    resolveNetworkPromise();
                    networkSubscription = null;
                    var cacheEntry = _this2._cache.get(cacheIdentifier);
                    if (cacheEntry) cacheEntry.setNetworkSubscription(null);
                    var observerComplete = observer === null || observer === void 0 ? void 0 : observer.complete;
                    observerComplete && observerComplete();
                },
                unsubscribe: observer === null || observer === void 0 ? void 0 : observer.unsubscribe
            });
            var _cacheEntry2 = this._cache.get(cacheIdentifier);
            if (!_cacheEntry2) {
                var networkPromise = new Promise(function(resolve) {
                    resolveNetworkPromise = resolve;
                });
                networkPromise.displayName = 'Relay(' + operation.fragment.node.name + ')';
                _cacheEntry2 = $c2058782296a5f46$var$createCacheEntry(cacheIdentifier, operation, queryAvailability, networkPromise, networkSubscription, this._clearCacheEntry);
                this._cache.set(cacheIdentifier, _cacheEntry2);
            }
        } else {
            var observerComplete = observer === null || observer === void 0 ? void 0 : observer.complete;
            observerComplete && observerComplete();
        }
        var cacheEntry = this._cache.get(cacheIdentifier);
        !(cacheEntry != null) && $jSI6G(false);
        environment.__log({
            name: 'queryresource.fetch',
            resourceID: cacheEntry.id,
            operation: operation,
            profilerContext: profilerContext,
            fetchPolicy: fetchPolicy,
            renderPolicy: renderPolicy,
            queryAvailability: queryAvailability,
            shouldFetch: shouldFetch
        });
        return cacheEntry;
    };
    return QueryResourceImpl;
}();
function $c2058782296a5f46$var$createQueryResource(environment) {
    return new $c2058782296a5f46$var$QueryResourceImpl(environment);
}
var $c2058782296a5f46$var$dataResources = $c2058782296a5f46$var$WEAKMAP_SUPPORTED ? new WeakMap() : new Map();
function $c2058782296a5f46$var$getQueryResourceForEnvironment(environment) {
    var cached = $c2058782296a5f46$var$dataResources.get(environment);
    if (cached) return cached;
    var newDataResource = $c2058782296a5f46$var$createQueryResource(environment);
    $c2058782296a5f46$var$dataResources.set(environment, newDataResource);
    return newDataResource;
}
module.exports = {
    createQueryResource: $c2058782296a5f46$var$createQueryResource,
    getQueryResourceForEnvironment: $c2058782296a5f46$var$getQueryResourceForEnvironment,
    getQueryCacheIdentifier: $c2058782296a5f46$var$getQueryCacheIdentifier
};

});
parcelRegister("llotJ", function(module, exports) {
'use strict';

var $jSI6G = parcelRequire("jSI6G");
var $f89e8c0b9c333fe9$var$LRUCache = /*#__PURE__*/ function() {
    function LRUCache(capacity) {
        this._capacity = capacity;
        !(this._capacity > 0) && $jSI6G(false);
        this._map = new Map();
    }
    var _proto = LRUCache.prototype;
    _proto.set = function set(key, value) {
        this._map["delete"](key);
        this._map.set(key, value);
        if (this._map.size > this._capacity) {
            var firstKey = this._map.keys().next();
            if (!firstKey.done) this._map["delete"](firstKey.value);
        }
    };
    _proto.get = function get(key) {
        var value = this._map.get(key);
        if (value != null) {
            this._map["delete"](key);
            this._map.set(key, value);
        }
        return value;
    };
    _proto.has = function has(key) {
        return this._map.has(key);
    };
    _proto["delete"] = function _delete(key) {
        this._map["delete"](key);
    };
    _proto.size = function size() {
        return this._map.size;
    };
    _proto.capacity = function capacity() {
        return this._capacity - this._map.size;
    };
    _proto.clear = function clear() {
        this._map.clear();
    };
    return LRUCache;
}();
function $f89e8c0b9c333fe9$var$create(capacity) {
    return new $f89e8c0b9c333fe9$var$LRUCache(capacity);
}
module.exports = {
    create: $f89e8c0b9c333fe9$var$create
};

});

parcelRegister("3XAPK", function(module, exports) {
'use strict';

var $drPJO = parcelRequire("drPJO");
var $2e2374337c937d64$var$_interopRequireDefault = $drPJO.default;

var $2e2374337c937d64$var$_defineProperty2 = $2e2374337c937d64$var$_interopRequireDefault((parcelRequire("gPhXO")));
parcelRequire("2OmBw");
var $2e2374337c937d64$var$TEMPORARY_RETAIN_DURATION_MS = 300000;
var $2e2374337c937d64$var$SuspenseResource = /*#__PURE__*/ function() {
    function SuspenseResource(retain) {
        var _this = this;
        (0, $2e2374337c937d64$var$_defineProperty2["default"])(this, "_retainCount", 0);
        (0, $2e2374337c937d64$var$_defineProperty2["default"])(this, "_retainDisposable", null);
        (0, $2e2374337c937d64$var$_defineProperty2["default"])(this, "_releaseTemporaryRetain", null);
        this._retain = function(environment) {
            _this._retainCount++;
            if (_this._retainCount === 1) _this._retainDisposable = retain(environment);
            return {
                dispose: function dispose() {
                    _this._retainCount = Math.max(0, _this._retainCount - 1);
                    if (_this._retainCount === 0) {
                        if (_this._retainDisposable != null) {
                            _this._retainDisposable.dispose();
                            _this._retainDisposable = null;
                        }
                    }
                }
            };
        };
    }
    var _proto = SuspenseResource.prototype;
    _proto.temporaryRetain = function temporaryRetain(environment) {
        var _this2 = this;
        var _this$_releaseTempora;
        if (environment.isServer()) return {
            dispose: function dispose() {}
        };
        var retention = this._retain(environment);
        var releaseQueryTimeout = null;
        var releaseTemporaryRetain = function releaseTemporaryRetain() {
            clearTimeout(releaseQueryTimeout);
            releaseQueryTimeout = null;
            _this2._releaseTemporaryRetain = null;
            retention.dispose();
        };
        releaseQueryTimeout = setTimeout(releaseTemporaryRetain, $2e2374337c937d64$var$TEMPORARY_RETAIN_DURATION_MS);
        (_this$_releaseTempora = this._releaseTemporaryRetain) === null || _this$_releaseTempora === void 0 || _this$_releaseTempora.call(this);
        this._releaseTemporaryRetain = releaseTemporaryRetain;
        return {
            dispose: function dispose() {
                var _this$_releaseTempora2;
                (_this$_releaseTempora2 = _this2._releaseTemporaryRetain) === null || _this$_releaseTempora2 === void 0 || _this$_releaseTempora2.call(_this2);
            }
        };
    };
    _proto.permanentRetain = function permanentRetain(environment) {
        var disposable = this._retain(environment);
        this.releaseTemporaryRetain();
        return disposable;
    };
    _proto.releaseTemporaryRetain = function releaseTemporaryRetain() {
        var _this$_releaseTempora3;
        (_this$_releaseTempora3 = this._releaseTemporaryRetain) === null || _this$_releaseTempora3 === void 0 || _this$_releaseTempora3.call(this);
        this._releaseTemporaryRetain = null;
    };
    _proto.getRetainCount = function getRetainCount() {
        return this._retainCount;
    };
    return SuspenseResource;
}();
module.exports = $2e2374337c937d64$var$SuspenseResource;

});


parcelRegister("dxt9N", function(module, exports) {
'use strict';

var $8VZiD = parcelRequire("8VZiD");

var $5FkrB = parcelRequire("5FkrB");
var $9db4f96618015381$var$useCallback = $5FkrB.useCallback, $9db4f96618015381$var$useEffect = $5FkrB.useEffect;
function $9db4f96618015381$var$useFetchTrackingRef() {
    var subscriptionRef = $8VZiD(null);
    var isFetchingRef = $8VZiD(false);
    var disposeFetch = $9db4f96618015381$var$useCallback(function() {
        if (subscriptionRef.current != null) {
            subscriptionRef.current.unsubscribe();
            subscriptionRef.current = null;
        }
        isFetchingRef.current = false;
    }, []);
    var startFetch = $9db4f96618015381$var$useCallback(function(subscription) {
        subscriptionRef.current = subscription;
        isFetchingRef.current = true;
    }, []);
    var completeFetch = $9db4f96618015381$var$useCallback(function() {
        subscriptionRef.current = null;
        isFetchingRef.current = false;
    }, []);
    $9db4f96618015381$var$useEffect(function() {
        return disposeFetch;
    }, [
        disposeFetch
    ]);
    return {
        isFetchingRef: isFetchingRef,
        startFetch: startFetch,
        disposeFetch: disposeFetch,
        completeFetch: completeFetch
    };
}
module.exports = $9db4f96618015381$var$useFetchTrackingRef;

});
parcelRegister("8VZiD", function(module, exports) {
'use strict';

var $5FkrB = parcelRequire("5FkrB");
var $6813326639066f2b$var$useMemo = $5FkrB.useMemo;
function $6813326639066f2b$var$useUnsafeRef_DEPRECATED(init) {
    return $6813326639066f2b$var$useMemo(function() {
        return {
            current: init
        };
    }, []);
}
module.exports = $6813326639066f2b$var$useUnsafeRef_DEPRECATED;

});


parcelRegister("3R4z1", function(module, exports) {
'use strict';

var $drPJO = parcelRequire("drPJO");
var $2ce9dc9efbdbb5e0$var$_interopRequireDefault = $drPJO.default;

var $2ce9dc9efbdbb5e0$var$_useFragmentInternal_CURRENT = $2ce9dc9efbdbb5e0$var$_interopRequireDefault((parcelRequire("dKlIz")));

var $2ce9dc9efbdbb5e0$var$_useFragmentInternal_EXPERIMENTAL = $2ce9dc9efbdbb5e0$var$_interopRequireDefault((parcelRequire("juX5d")));

var $7eKmg = parcelRequire("7eKmg");
function $2ce9dc9efbdbb5e0$var$useFragmentInternal(fragmentNode, fragmentRef, hookDisplayName, queryOptions) {
    if ($7eKmg.RelayFeatureFlags.ENABLE_ACTIVITY_COMPATIBILITY) return (0, $2ce9dc9efbdbb5e0$var$_useFragmentInternal_EXPERIMENTAL["default"])(fragmentNode, fragmentRef, hookDisplayName, queryOptions);
    return (0, $2ce9dc9efbdbb5e0$var$_useFragmentInternal_CURRENT["default"])(fragmentNode, fragmentRef, hookDisplayName, queryOptions);
}
module.exports = $2ce9dc9efbdbb5e0$var$useFragmentInternal;

});
parcelRegister("dKlIz", function(module, exports) {
'use strict';

var $drPJO = parcelRequire("drPJO");
var $a0206af0a9e17a46$var$_interopRequireDefault = $drPJO.default;

var $a0206af0a9e17a46$var$_objectSpread2 = $a0206af0a9e17a46$var$_interopRequireDefault((parcelRequire("5OKtB")));

var $a0206af0a9e17a46$var$_createForOfIteratorHelper2 = $a0206af0a9e17a46$var$_interopRequireDefault((parcelRequire("jLbXI")));

var $a0206af0a9e17a46$var$_toConsumableArray2 = $a0206af0a9e17a46$var$_interopRequireDefault((parcelRequire("7gkmy")));

var $gELTa = parcelRequire("gELTa");
var $a0206af0a9e17a46$var$getQueryResourceForEnvironment = $gELTa.getQueryResourceForEnvironment;

var $23TM5 = parcelRequire("23TM5");

var $e5Ewk = parcelRequire("e5Ewk");

var $jSI6G = parcelRequire("jSI6G");

var $5FkrB = parcelRequire("5FkrB");
var $a0206af0a9e17a46$var$useDebugValue = $5FkrB.useDebugValue, $a0206af0a9e17a46$var$useEffect = $5FkrB.useEffect, $a0206af0a9e17a46$var$useMemo = $5FkrB.useMemo, $a0206af0a9e17a46$var$useRef = $5FkrB.useRef, $a0206af0a9e17a46$var$useState = $5FkrB.useState;

var $7eKmg = parcelRequire("7eKmg");
var $a0206af0a9e17a46$var$_require3$__internal = $7eKmg.__internal, $a0206af0a9e17a46$var$fetchQueryInternal = $a0206af0a9e17a46$var$_require3$__internal.fetchQuery, $a0206af0a9e17a46$var$getPromiseForActiveRequest = $a0206af0a9e17a46$var$_require3$__internal.getPromiseForActiveRequest, $a0206af0a9e17a46$var$RelayFeatureFlags = $7eKmg.RelayFeatureFlags, $a0206af0a9e17a46$var$areEqualSelectors = $7eKmg.areEqualSelectors, $a0206af0a9e17a46$var$createOperationDescriptor = $7eKmg.createOperationDescriptor, $a0206af0a9e17a46$var$getPendingOperationsForFragment = $7eKmg.getPendingOperationsForFragment, $a0206af0a9e17a46$var$getSelector = $7eKmg.getSelector, $a0206af0a9e17a46$var$getVariablesFromFragment = $7eKmg.getVariablesFromFragment, $a0206af0a9e17a46$var$handlePotentialSnapshotErrors = $7eKmg.handlePotentialSnapshotErrors, $a0206af0a9e17a46$var$recycleNodesInto = $7eKmg.recycleNodesInto;
parcelRequire("2OmBw");
function $a0206af0a9e17a46$var$isMissingData(state) {
    if (state.kind === 'bailout') return false;
    else if (state.kind === 'singular') return state.snapshot.isMissingData;
    else return state.snapshots.some(function(s) {
        return s.isMissingData;
    });
}
function $a0206af0a9e17a46$var$getMissingClientEdges(state) {
    if (state.kind === 'bailout') return null;
    else if (state.kind === 'singular') {
        var _state$snapshot$missi;
        return (_state$snapshot$missi = state.snapshot.missingClientEdges) !== null && _state$snapshot$missi !== void 0 ? _state$snapshot$missi : null;
    } else {
        var edges = null;
        var _iterator = (0, $a0206af0a9e17a46$var$_createForOfIteratorHelper2["default"])(state.snapshots), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var snapshot = _step.value;
                if (snapshot.missingClientEdges) {
                    var _edges;
                    edges = (_edges = edges) !== null && _edges !== void 0 ? _edges : [];
                    var _iterator2 = (0, $a0206af0a9e17a46$var$_createForOfIteratorHelper2["default"])(snapshot.missingClientEdges), _step2;
                    try {
                        for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                            var edge = _step2.value;
                            edges.push(edge);
                        }
                    } catch (err) {
                        _iterator2.e(err);
                    } finally{
                        _iterator2.f();
                    }
                }
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
        return edges;
    }
}
function $a0206af0a9e17a46$var$getSuspendingLiveResolver(state) {
    if (state.kind === 'bailout') return null;
    else if (state.kind === 'singular') {
        var _state$snapshot$missi2;
        return (_state$snapshot$missi2 = state.snapshot.missingLiveResolverFields) !== null && _state$snapshot$missi2 !== void 0 ? _state$snapshot$missi2 : null;
    } else {
        var missingFields = null;
        var _iterator3 = (0, $a0206af0a9e17a46$var$_createForOfIteratorHelper2["default"])(state.snapshots), _step3;
        try {
            for(_iterator3.s(); !(_step3 = _iterator3.n()).done;){
                var snapshot = _step3.value;
                if (snapshot.missingLiveResolverFields) {
                    var _missingFields;
                    missingFields = (_missingFields = missingFields) !== null && _missingFields !== void 0 ? _missingFields : [];
                    var _iterator4 = (0, $a0206af0a9e17a46$var$_createForOfIteratorHelper2["default"])(snapshot.missingLiveResolverFields), _step4;
                    try {
                        for(_iterator4.s(); !(_step4 = _iterator4.n()).done;){
                            var edge = _step4.value;
                            missingFields.push(edge);
                        }
                    } catch (err) {
                        _iterator4.e(err);
                    } finally{
                        _iterator4.f();
                    }
                }
            }
        } catch (err) {
            _iterator3.e(err);
        } finally{
            _iterator3.f();
        }
        return missingFields;
    }
}
function $a0206af0a9e17a46$var$handlePotentialSnapshotErrorsForState(environment, state, loggingContext) {
    if (state.kind === 'singular') $a0206af0a9e17a46$var$handlePotentialSnapshotErrors(environment, state.snapshot.fieldErrors, loggingContext);
    else if (state.kind === 'plural') {
        var _iterator5 = (0, $a0206af0a9e17a46$var$_createForOfIteratorHelper2["default"])(state.snapshots), _step5;
        try {
            for(_iterator5.s(); !(_step5 = _iterator5.n()).done;){
                var snapshot = _step5.value;
                $a0206af0a9e17a46$var$handlePotentialSnapshotErrors(environment, snapshot.fieldErrors, loggingContext);
            }
        } catch (err) {
            _iterator5.e(err);
        } finally{
            _iterator5.f();
        }
    }
}
function $a0206af0a9e17a46$var$handleMissedUpdates(environment, state) {
    if (state.kind === 'bailout') return null;
    var currentEpoch = environment.getStore().getEpoch();
    if (currentEpoch === state.epoch) return null;
    if (state.kind === 'singular') {
        var currentSnapshot = environment.lookup(state.snapshot.selector);
        var updatedData = $a0206af0a9e17a46$var$recycleNodesInto(state.snapshot.data, currentSnapshot.data);
        var updatedCurrentSnapshot = {
            data: updatedData,
            fieldErrors: currentSnapshot.fieldErrors,
            isMissingData: currentSnapshot.isMissingData,
            missingClientEdges: currentSnapshot.missingClientEdges,
            missingLiveResolverFields: currentSnapshot.missingLiveResolverFields,
            seenRecords: currentSnapshot.seenRecords,
            selector: currentSnapshot.selector
        };
        return [
            updatedData !== state.snapshot.data,
            {
                epoch: currentEpoch,
                kind: 'singular',
                snapshot: updatedCurrentSnapshot
            }
        ];
    } else {
        var didMissUpdates = false;
        var currentSnapshots = [];
        for(var index = 0; index < state.snapshots.length; index++){
            var snapshot = state.snapshots[index];
            var _currentSnapshot = environment.lookup(snapshot.selector);
            var _updatedData = $a0206af0a9e17a46$var$recycleNodesInto(snapshot.data, _currentSnapshot.data);
            var _updatedCurrentSnapshot = {
                data: _updatedData,
                fieldErrors: _currentSnapshot.fieldErrors,
                isMissingData: _currentSnapshot.isMissingData,
                missingClientEdges: _currentSnapshot.missingClientEdges,
                missingLiveResolverFields: _currentSnapshot.missingLiveResolverFields,
                seenRecords: _currentSnapshot.seenRecords,
                selector: _currentSnapshot.selector
            };
            if (_updatedData !== snapshot.data) didMissUpdates = true;
            currentSnapshots.push(_updatedCurrentSnapshot);
        }
        !(currentSnapshots.length === state.snapshots.length) && $jSI6G(false);
        return [
            didMissUpdates,
            {
                epoch: currentEpoch,
                kind: 'plural',
                snapshots: currentSnapshots
            }
        ];
    }
}
function $a0206af0a9e17a46$var$handleMissingClientEdge(environment, parentFragmentNode, parentFragmentRef, missingClientEdgeRequestInfo, queryOptions) {
    var originalVariables = $a0206af0a9e17a46$var$getVariablesFromFragment(parentFragmentNode, parentFragmentRef);
    var variables = (0, $a0206af0a9e17a46$var$_objectSpread2["default"])((0, $a0206af0a9e17a46$var$_objectSpread2["default"])({}, originalVariables), {}, {
        id: missingClientEdgeRequestInfo.clientEdgeDestinationID
    });
    var queryOperationDescriptor = $a0206af0a9e17a46$var$createOperationDescriptor(missingClientEdgeRequestInfo.request, variables, queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.networkCacheConfig);
    var QueryResource = $a0206af0a9e17a46$var$getQueryResourceForEnvironment(environment);
    var queryResult = QueryResource.prepare(queryOperationDescriptor, $a0206af0a9e17a46$var$fetchQueryInternal(environment, queryOperationDescriptor), queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.fetchPolicy);
    return [
        queryResult,
        $a0206af0a9e17a46$var$getPromiseForActiveRequest(environment, queryOperationDescriptor.request)
    ];
}
function $a0206af0a9e17a46$var$subscribeToSnapshot(environment, state, setState, hasPendingStateChanges) {
    if (state.kind === 'bailout') return function() {};
    else if (state.kind === 'singular') {
        var disposable = environment.subscribe(state.snapshot, function(latestSnapshot) {
            setState(function(prevState) {
                if (prevState.kind !== 'singular' || prevState.snapshot.selector !== latestSnapshot.selector) {
                    var updates = $a0206af0a9e17a46$var$handleMissedUpdates(environment, prevState);
                    if (updates != null) {
                        var dataChanged = updates[0], nextState = updates[1];
                        environment.__log({
                            hasDataChanges: dataChanged,
                            name: 'useFragment.subscription.missedUpdates'
                        });
                        hasPendingStateChanges.current = dataChanged;
                        return dataChanged ? nextState : prevState;
                    } else return prevState;
                }
                hasPendingStateChanges.current = true;
                return {
                    epoch: environment.getStore().getEpoch(),
                    kind: 'singular',
                    snapshot: latestSnapshot
                };
            });
        });
        return function() {
            disposable.dispose();
        };
    } else {
        var disposables = state.snapshots.map(function(snapshot, index) {
            return environment.subscribe(snapshot, function(latestSnapshot) {
                setState(function(prevState) {
                    var _prevState$snapshots$;
                    if (prevState.kind !== 'plural' || ((_prevState$snapshots$ = prevState.snapshots[index]) === null || _prevState$snapshots$ === void 0 ? void 0 : _prevState$snapshots$.selector) !== latestSnapshot.selector) {
                        var updates = $a0206af0a9e17a46$var$handleMissedUpdates(environment, prevState);
                        if (updates != null) {
                            var dataChanged = updates[0], nextState = updates[1];
                            environment.__log({
                                hasDataChanges: dataChanged,
                                name: 'useFragment.subscription.missedUpdates'
                            });
                            hasPendingStateChanges.current = hasPendingStateChanges.current || dataChanged;
                            return dataChanged ? nextState : prevState;
                        } else return prevState;
                    }
                    var updated = (0, $a0206af0a9e17a46$var$_toConsumableArray2["default"])(prevState.snapshots);
                    updated[index] = latestSnapshot;
                    hasPendingStateChanges.current = true;
                    return {
                        epoch: environment.getStore().getEpoch(),
                        kind: 'plural',
                        snapshots: updated
                    };
                });
            });
        });
        return function() {
            var _iterator6 = (0, $a0206af0a9e17a46$var$_createForOfIteratorHelper2["default"])(disposables), _step6;
            try {
                for(_iterator6.s(); !(_step6 = _iterator6.n()).done;){
                    var d = _step6.value;
                    d.dispose();
                }
            } catch (err) {
                _iterator6.e(err);
            } finally{
                _iterator6.f();
            }
        };
    }
}
function $a0206af0a9e17a46$var$getFragmentState(environment, fragmentSelector) {
    if (fragmentSelector == null) return {
        kind: 'bailout'
    };
    else if (fragmentSelector.kind === 'PluralReaderSelector') return {
        epoch: environment.getStore().getEpoch(),
        kind: 'plural',
        snapshots: fragmentSelector.selectors.map(function(s) {
            return environment.lookup(s);
        })
    };
    else return {
        epoch: environment.getStore().getEpoch(),
        kind: 'singular',
        snapshot: environment.lookup(fragmentSelector)
    };
}
function $a0206af0a9e17a46$var$useFragmentInternal(fragmentNode, fragmentRef, hookDisplayName, queryOptions) {
    var _fragmentNode$metadat, _fragmentNode$metadat2;
    var fragmentSelector = $a0206af0a9e17a46$var$useMemo(function() {
        return $a0206af0a9e17a46$var$getSelector(fragmentNode, fragmentRef);
    }, [
        fragmentNode,
        fragmentRef
    ]);
    var isPlural = (fragmentNode === null || fragmentNode === void 0 ? void 0 : (_fragmentNode$metadat = fragmentNode.metadata) === null || _fragmentNode$metadat === void 0 ? void 0 : _fragmentNode$metadat.plural) === true;
    if (isPlural) !(fragmentRef == null || Array.isArray(fragmentRef)) && $jSI6G(false);
    else !!Array.isArray(fragmentRef) && $jSI6G(false);
    !(fragmentRef == null || isPlural && Array.isArray(fragmentRef) && fragmentRef.length === 0 || fragmentSelector != null) && $jSI6G(false);
    var environment = $23TM5();
    var loggerContext;
    if ($a0206af0a9e17a46$var$RelayFeatureFlags.ENABLE_UI_CONTEXT_ON_RELAY_LOGGER) loggerContext = $e5Ewk();
    var _useState = $a0206af0a9e17a46$var$useState(function() {
        return $a0206af0a9e17a46$var$getFragmentState(environment, fragmentSelector);
    }), _state = _useState[0], setState = _useState[1];
    var state = _state;
    var _useState2 = $a0206af0a9e17a46$var$useState(state), _subscribedState = _useState2[0], setSubscribedState = _useState2[1];
    var subscribedState = _subscribedState;
    var _useState3 = $a0206af0a9e17a46$var$useState(fragmentSelector), previousFragmentSelector = _useState3[0], setPreviousFragmentSelector = _useState3[1];
    var _useState4 = $a0206af0a9e17a46$var$useState(environment), previousEnvironment = _useState4[0], setPreviousEnvironment = _useState4[1];
    if (!$a0206af0a9e17a46$var$areEqualSelectors(fragmentSelector, previousFragmentSelector) || environment !== previousEnvironment) {
        setPreviousFragmentSelector(fragmentSelector);
        setPreviousEnvironment(environment);
        var newState = $a0206af0a9e17a46$var$getFragmentState(environment, fragmentSelector);
        setState(newState);
        setSubscribedState(newState);
        state = newState;
        subscribedState = newState;
    }
    var committedFragmentSelectorRef = $a0206af0a9e17a46$var$useRef(false);
    $a0206af0a9e17a46$var$useEffect(function() {
        committedFragmentSelectorRef.current = fragmentSelector;
    }, [
        fragmentSelector
    ]);
    if (((_fragmentNode$metadat2 = fragmentNode.metadata) === null || _fragmentNode$metadat2 === void 0 ? void 0 : _fragmentNode$metadat2.hasClientEdges) === true || $a0206af0a9e17a46$var$RelayFeatureFlags.CHECK_ALL_FRAGMENTS_FOR_MISSING_CLIENT_EDGES) {
        var _useMemo = $a0206af0a9e17a46$var$useMemo(function() {
            var missingClientEdges = $a0206af0a9e17a46$var$getMissingClientEdges(state);
            var clientEdgeQueries;
            var activeRequestPromises = [];
            if (missingClientEdges !== null && missingClientEdges !== void 0 && missingClientEdges.length) {
                clientEdgeQueries = [];
                var _iterator7 = (0, $a0206af0a9e17a46$var$_createForOfIteratorHelper2["default"])(missingClientEdges), _step7;
                try {
                    for(_iterator7.s(); !(_step7 = _iterator7.n()).done;){
                        var edge = _step7.value;
                        var _handleMissingClientE = $a0206af0a9e17a46$var$handleMissingClientEdge(environment, fragmentNode, fragmentRef, edge, queryOptions), queryResult = _handleMissingClientE[0], requestPromise = _handleMissingClientE[1];
                        clientEdgeQueries.push(queryResult);
                        if (requestPromise != null) activeRequestPromises.push(requestPromise);
                    }
                } catch (err) {
                    _iterator7.e(err);
                } finally{
                    _iterator7.f();
                }
            }
            return [
                clientEdgeQueries,
                activeRequestPromises
            ];
        }, [
            state,
            environment,
            fragmentNode,
            fragmentRef,
            queryOptions
        ]), clientEdgeQueries = _useMemo[0], activeRequestPromises = _useMemo[1];
        if (activeRequestPromises.length) {
            !(fragmentSelector != null) && $jSI6G(false);
            var fragmentOwner = fragmentSelector.kind === 'PluralReaderSelector' ? fragmentSelector.selectors[0].owner : fragmentSelector.owner;
            environment.__log({
                name: 'suspense.client_edge',
                fragment: fragmentNode,
                fragmentOwner: fragmentOwner,
                isMount: committedFragmentSelectorRef.current === false
            });
            throw Promise.all(activeRequestPromises);
        }
        $a0206af0a9e17a46$var$useEffect(function() {
            var QueryResource = $a0206af0a9e17a46$var$getQueryResourceForEnvironment(environment);
            if (clientEdgeQueries !== null && clientEdgeQueries !== void 0 && clientEdgeQueries.length) {
                var disposables = [];
                var _iterator8 = (0, $a0206af0a9e17a46$var$_createForOfIteratorHelper2["default"])(clientEdgeQueries), _step8;
                try {
                    for(_iterator8.s(); !(_step8 = _iterator8.n()).done;){
                        var query = _step8.value;
                        disposables.push(QueryResource.retain(query));
                    }
                } catch (err) {
                    _iterator8.e(err);
                } finally{
                    _iterator8.f();
                }
                return function() {
                    for(var _i = 0, _disposables = disposables; _i < _disposables.length; _i++){
                        var disposable = _disposables[_i];
                        disposable.dispose();
                    }
                };
            }
        }, [
            environment,
            clientEdgeQueries
        ]);
    }
    if ($a0206af0a9e17a46$var$isMissingData(state)) {
        var suspendingLiveResolvers = $a0206af0a9e17a46$var$getSuspendingLiveResolver(state);
        if (suspendingLiveResolvers != null && suspendingLiveResolvers.length > 0) {
            !(fragmentSelector != null) && $jSI6G(false);
            var _fragmentOwner = fragmentSelector.kind === 'PluralReaderSelector' ? fragmentSelector.selectors[0].owner : fragmentSelector.owner;
            environment.__log({
                name: 'suspense.resolver',
                fragment: fragmentNode,
                fragmentOwner: _fragmentOwner,
                isMount: committedFragmentSelectorRef.current === false,
                suspendingLiveResolvers: suspendingLiveResolvers
            });
            throw Promise.all(suspendingLiveResolvers.map(function(liveStateID) {
                return environment.getStore().getLiveResolverPromise(liveStateID);
            }));
        }
        if ($a0206af0a9e17a46$var$RelayFeatureFlags.ENABLE_RELAY_OPERATION_TRACKER_SUSPENSE || environment !== previousEnvironment || committedFragmentSelectorRef.current === false || !$a0206af0a9e17a46$var$areEqualSelectors(committedFragmentSelectorRef.current, fragmentSelector)) {
            !(fragmentSelector != null) && $jSI6G(false);
            var _fragmentOwner2 = fragmentSelector.kind === 'PluralReaderSelector' ? fragmentSelector.selectors[0].owner : fragmentSelector.owner;
            var pendingOperationsResult = $a0206af0a9e17a46$var$getPendingOperationsForFragment(environment, fragmentNode, _fragmentOwner2);
            if (pendingOperationsResult) {
                environment.__log({
                    name: 'suspense.missing_data',
                    fragment: fragmentNode,
                    fragmentOwner: _fragmentOwner2,
                    isMount: committedFragmentSelectorRef.current === false,
                    pendingOperations: pendingOperationsResult.pendingOperations
                });
                throw pendingOperationsResult.promise;
            }
        }
    }
    $a0206af0a9e17a46$var$handlePotentialSnapshotErrorsForState(environment, state, loggerContext);
    var hasPendingStateChanges = $a0206af0a9e17a46$var$useRef(false);
    $a0206af0a9e17a46$var$useEffect(function() {
        var currentState = subscribedState;
        var updates = $a0206af0a9e17a46$var$handleMissedUpdates(environment, subscribedState);
        if (updates !== null) {
            var didMissUpdates = updates[0], updatedState = updates[1];
            if (didMissUpdates) setState(updatedState);
            currentState = updatedState;
        }
        return $a0206af0a9e17a46$var$subscribeToSnapshot(environment, currentState, setState, hasPendingStateChanges);
    }, [
        environment,
        subscribedState
    ]);
    if (hasPendingStateChanges.current) {
        var updates = $a0206af0a9e17a46$var$handleMissedUpdates(environment, state);
        if (updates != null) {
            var hasStateUpdates = updates[0], updatedState = updates[1];
            if (hasStateUpdates) {
                setState(updatedState);
                state = updatedState;
            }
        }
        hasPendingStateChanges.current = false;
    }
    var data;
    if (isPlural) {
        var fragmentRefIsNullish = fragmentRef == null;
        data = $a0206af0a9e17a46$var$useMemo(function() {
            if (state.kind === 'bailout') return fragmentRefIsNullish ? null : [];
            else {
                !(state.kind === 'plural') && $jSI6G(false);
                return state.snapshots.map(function(s) {
                    return s.data;
                });
            }
        }, [
            state,
            fragmentRefIsNullish
        ]);
    } else if (state.kind === 'bailout') data = null;
    else {
        !(state.kind === 'singular') && $jSI6G(false);
        data = state.snapshot.data;
    }
    if ($a0206af0a9e17a46$var$RelayFeatureFlags.LOG_MISSING_RECORDS_IN_PROD || false) fragmentRef != null && (data === undefined || Array.isArray(data) && data.length > 0 && data.every(function(d) {
        return d === undefined;
    }));
    return data;
}
module.exports = $a0206af0a9e17a46$var$useFragmentInternal;

});
parcelRegister("jLbXI", function(module, exports) {

var $idnG2 = parcelRequire("idnG2");
function $e62baf8b4eb6ad33$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $idnG2(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t["return"] || t["return"]();
            } finally{
                if (u) throw o;
            }
        }
    };
}
module.exports = $e62baf8b4eb6ad33$var$_createForOfIteratorHelper, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("idnG2", function(module, exports) {

var $bMIio = parcelRequire("bMIio");
function $d42bceab7603c582$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $bMIio(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $bMIio(r, a) : void 0;
    }
}
module.exports = $d42bceab7603c582$var$_unsupportedIterableToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("bMIio", function(module, exports) {
function $89468999265f7234$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
module.exports = $89468999265f7234$var$_arrayLikeToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});



parcelRegister("7gkmy", function(module, exports) {

var $3NR5b = parcelRequire("3NR5b");

var $15IhV = parcelRequire("15IhV");

var $idnG2 = parcelRequire("idnG2");

var $6Nvi8 = parcelRequire("6Nvi8");
function $5499d2abc3415820$var$_toConsumableArray(r) {
    return $3NR5b(r) || $15IhV(r) || $idnG2(r) || $6Nvi8();
}
module.exports = $5499d2abc3415820$var$_toConsumableArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("3NR5b", function(module, exports) {

var $bMIio = parcelRequire("bMIio");
function $2c4f1fc849d687f7$var$_arrayWithoutHoles(r) {
    if (Array.isArray(r)) return $bMIio(r);
}
module.exports = $2c4f1fc849d687f7$var$_arrayWithoutHoles, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("15IhV", function(module, exports) {
function $0cb89cc26963403a$var$_iterableToArray(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}
module.exports = $0cb89cc26963403a$var$_iterableToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("6Nvi8", function(module, exports) {
function $4f2f9789db0d0e47$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
module.exports = $4f2f9789db0d0e47$var$_nonIterableSpread, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("e5Ewk", function(module, exports) {
'use strict';

var $3eN5W = parcelRequire("3eN5W");

var $5FkrB = parcelRequire("5FkrB");
var $a420f6d55d086ccc$var$useContext = $5FkrB.useContext;
function $a420f6d55d086ccc$var$useRelayLoggingContext() {
    return $a420f6d55d086ccc$var$useContext($3eN5W);
}
module.exports = $a420f6d55d086ccc$var$useRelayLoggingContext;

});
parcelRegister("3eN5W", function(module, exports) {
'use strict';

var $5FkrB = parcelRequire("5FkrB");

var $7eKmg = parcelRequire("7eKmg");
var $25b8c31a5db18d18$var$createRelayLoggingContext = $7eKmg.__internal.createRelayLoggingContext;
module.exports = $25b8c31a5db18d18$var$createRelayLoggingContext($5FkrB);

});



parcelRegister("juX5d", function(module, exports) {
'use strict';

var $drPJO = parcelRequire("drPJO");
var $e31ea65cc150a6c4$var$_interopRequireDefault = $drPJO.default;

var $e31ea65cc150a6c4$var$_objectSpread2 = $e31ea65cc150a6c4$var$_interopRequireDefault((parcelRequire("5OKtB")));

var $e31ea65cc150a6c4$var$_createForOfIteratorHelper2 = $e31ea65cc150a6c4$var$_interopRequireDefault((parcelRequire("jLbXI")));

var $e31ea65cc150a6c4$var$_toConsumableArray2 = $e31ea65cc150a6c4$var$_interopRequireDefault((parcelRequire("7gkmy")));

var $gELTa = parcelRequire("gELTa");
var $e31ea65cc150a6c4$var$getQueryResourceForEnvironment = $gELTa.getQueryResourceForEnvironment;

var $23TM5 = parcelRequire("23TM5");

var $e5Ewk = parcelRequire("e5Ewk");

var $jSI6G = parcelRequire("jSI6G");

var $5FkrB = parcelRequire("5FkrB");
var $e31ea65cc150a6c4$var$useDebugValue = $5FkrB.useDebugValue, $e31ea65cc150a6c4$var$useEffect = $5FkrB.useEffect, $e31ea65cc150a6c4$var$useMemo = $5FkrB.useMemo, $e31ea65cc150a6c4$var$useRef = $5FkrB.useRef, $e31ea65cc150a6c4$var$useState = $5FkrB.useState;

var $7eKmg = parcelRequire("7eKmg");
var $e31ea65cc150a6c4$var$_require3$__internal = $7eKmg.__internal, $e31ea65cc150a6c4$var$fetchQueryInternal = $e31ea65cc150a6c4$var$_require3$__internal.fetchQuery, $e31ea65cc150a6c4$var$getPromiseForActiveRequest = $e31ea65cc150a6c4$var$_require3$__internal.getPromiseForActiveRequest, $e31ea65cc150a6c4$var$RelayFeatureFlags = $7eKmg.RelayFeatureFlags, $e31ea65cc150a6c4$var$areEqualSelectors = $7eKmg.areEqualSelectors, $e31ea65cc150a6c4$var$createOperationDescriptor = $7eKmg.createOperationDescriptor, $e31ea65cc150a6c4$var$getPendingOperationsForFragment = $7eKmg.getPendingOperationsForFragment, $e31ea65cc150a6c4$var$getSelector = $7eKmg.getSelector, $e31ea65cc150a6c4$var$getVariablesFromFragment = $7eKmg.getVariablesFromFragment, $e31ea65cc150a6c4$var$handlePotentialSnapshotErrors = $7eKmg.handlePotentialSnapshotErrors, $e31ea65cc150a6c4$var$recycleNodesInto = $7eKmg.recycleNodesInto;
parcelRequire("2OmBw");
function $e31ea65cc150a6c4$var$isMissingData(state) {
    if (state.kind === 'bailout') return false;
    else if (state.kind === 'singular') return state.snapshot.isMissingData;
    else return state.snapshots.some(function(s) {
        return s.isMissingData;
    });
}
function $e31ea65cc150a6c4$var$getMissingClientEdges(state) {
    if (state.kind === 'bailout') return null;
    else if (state.kind === 'singular') {
        var _state$snapshot$missi;
        return (_state$snapshot$missi = state.snapshot.missingClientEdges) !== null && _state$snapshot$missi !== void 0 ? _state$snapshot$missi : null;
    } else {
        var edges = null;
        var _iterator = (0, $e31ea65cc150a6c4$var$_createForOfIteratorHelper2["default"])(state.snapshots), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var snapshot = _step.value;
                if (snapshot.missingClientEdges) {
                    var _edges;
                    edges = (_edges = edges) !== null && _edges !== void 0 ? _edges : [];
                    var _iterator2 = (0, $e31ea65cc150a6c4$var$_createForOfIteratorHelper2["default"])(snapshot.missingClientEdges), _step2;
                    try {
                        for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                            var edge = _step2.value;
                            edges.push(edge);
                        }
                    } catch (err) {
                        _iterator2.e(err);
                    } finally{
                        _iterator2.f();
                    }
                }
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
        return edges;
    }
}
function $e31ea65cc150a6c4$var$getSuspendingLiveResolver(state) {
    if (state.kind === 'bailout') return null;
    else if (state.kind === 'singular') {
        var _state$snapshot$missi2;
        return (_state$snapshot$missi2 = state.snapshot.missingLiveResolverFields) !== null && _state$snapshot$missi2 !== void 0 ? _state$snapshot$missi2 : null;
    } else {
        var missingFields = null;
        var _iterator3 = (0, $e31ea65cc150a6c4$var$_createForOfIteratorHelper2["default"])(state.snapshots), _step3;
        try {
            for(_iterator3.s(); !(_step3 = _iterator3.n()).done;){
                var snapshot = _step3.value;
                if (snapshot.missingLiveResolverFields) {
                    var _missingFields;
                    missingFields = (_missingFields = missingFields) !== null && _missingFields !== void 0 ? _missingFields : [];
                    var _iterator4 = (0, $e31ea65cc150a6c4$var$_createForOfIteratorHelper2["default"])(snapshot.missingLiveResolverFields), _step4;
                    try {
                        for(_iterator4.s(); !(_step4 = _iterator4.n()).done;){
                            var edge = _step4.value;
                            missingFields.push(edge);
                        }
                    } catch (err) {
                        _iterator4.e(err);
                    } finally{
                        _iterator4.f();
                    }
                }
            }
        } catch (err) {
            _iterator3.e(err);
        } finally{
            _iterator3.f();
        }
        return missingFields;
    }
}
function $e31ea65cc150a6c4$var$handlePotentialSnapshotErrorsForState(environment, state, loggingContext) {
    if (state.kind === 'singular') $e31ea65cc150a6c4$var$handlePotentialSnapshotErrors(environment, state.snapshot.fieldErrors, loggingContext);
    else if (state.kind === 'plural') {
        var _iterator5 = (0, $e31ea65cc150a6c4$var$_createForOfIteratorHelper2["default"])(state.snapshots), _step5;
        try {
            for(_iterator5.s(); !(_step5 = _iterator5.n()).done;){
                var snapshot = _step5.value;
                $e31ea65cc150a6c4$var$handlePotentialSnapshotErrors(environment, snapshot.fieldErrors, loggingContext);
            }
        } catch (err) {
            _iterator5.e(err);
        } finally{
            _iterator5.f();
        }
    }
}
function $e31ea65cc150a6c4$var$handleMissedUpdates(environment, state) {
    if (state.kind === 'bailout') return null;
    var currentEpoch = environment.getStore().getEpoch();
    if (currentEpoch === state.epoch) return null;
    if (state.kind === 'singular') {
        var currentSnapshot = environment.lookup(state.snapshot.selector);
        var updatedData = $e31ea65cc150a6c4$var$recycleNodesInto(state.snapshot.data, currentSnapshot.data);
        var updatedCurrentSnapshot = {
            data: updatedData,
            fieldErrors: currentSnapshot.fieldErrors,
            isMissingData: currentSnapshot.isMissingData,
            missingClientEdges: currentSnapshot.missingClientEdges,
            missingLiveResolverFields: currentSnapshot.missingLiveResolverFields,
            seenRecords: currentSnapshot.seenRecords,
            selector: currentSnapshot.selector
        };
        return [
            updatedData !== state.snapshot.data,
            {
                environment: state.environment,
                epoch: currentEpoch,
                kind: 'singular',
                selector: state.selector,
                snapshot: updatedCurrentSnapshot
            }
        ];
    } else {
        var didMissUpdates = false;
        var currentSnapshots = [];
        for(var index = 0; index < state.snapshots.length; index++){
            var snapshot = state.snapshots[index];
            var _currentSnapshot = environment.lookup(snapshot.selector);
            var _updatedData = $e31ea65cc150a6c4$var$recycleNodesInto(snapshot.data, _currentSnapshot.data);
            var _updatedCurrentSnapshot = {
                data: _updatedData,
                fieldErrors: _currentSnapshot.fieldErrors,
                isMissingData: _currentSnapshot.isMissingData,
                missingClientEdges: _currentSnapshot.missingClientEdges,
                missingLiveResolverFields: _currentSnapshot.missingLiveResolverFields,
                seenRecords: _currentSnapshot.seenRecords,
                selector: _currentSnapshot.selector
            };
            if (_updatedData !== snapshot.data) didMissUpdates = true;
            currentSnapshots.push(_updatedCurrentSnapshot);
        }
        !(currentSnapshots.length === state.snapshots.length) && $jSI6G(false);
        return [
            didMissUpdates,
            {
                environment: state.environment,
                epoch: currentEpoch,
                kind: 'plural',
                selector: state.selector,
                snapshots: currentSnapshots
            }
        ];
    }
}
function $e31ea65cc150a6c4$var$handleMissingClientEdge(environment, parentFragmentNode, parentFragmentRef, missingClientEdgeRequestInfo, queryOptions) {
    var originalVariables = $e31ea65cc150a6c4$var$getVariablesFromFragment(parentFragmentNode, parentFragmentRef);
    var variables = (0, $e31ea65cc150a6c4$var$_objectSpread2["default"])((0, $e31ea65cc150a6c4$var$_objectSpread2["default"])({}, originalVariables), {}, {
        id: missingClientEdgeRequestInfo.clientEdgeDestinationID
    });
    var queryOperationDescriptor = $e31ea65cc150a6c4$var$createOperationDescriptor(missingClientEdgeRequestInfo.request, variables, queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.networkCacheConfig);
    var QueryResource = $e31ea65cc150a6c4$var$getQueryResourceForEnvironment(environment);
    var queryResult = QueryResource.prepare(queryOperationDescriptor, $e31ea65cc150a6c4$var$fetchQueryInternal(environment, queryOperationDescriptor), queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.fetchPolicy);
    var promise = $e31ea65cc150a6c4$var$getPromiseForActiveRequest(environment, queryOperationDescriptor.request);
    if (promise != null && promise.displayName == null) promise.displayName = missingClientEdgeRequestInfo.request.params.name;
    return [
        queryResult,
        promise
    ];
}
function $e31ea65cc150a6c4$var$subscribeToSnapshot(environment, state, setState) {
    if (state.kind === 'bailout') return function() {};
    else if (state.kind === 'singular') {
        var disposable = environment.subscribe(state.snapshot, function(latestSnapshot) {
            setState(function(prevState) {
                var nextState = null;
                if (prevState.kind !== 'singular' || prevState.snapshot.selector !== latestSnapshot.selector || prevState.environment !== environment) {
                    var updates = $e31ea65cc150a6c4$var$handleMissedUpdates(prevState.environment, prevState);
                    if (updates != null) {
                        var dataChanged = updates[0], updatedState = updates[1];
                        environment.__log({
                            hasDataChanges: dataChanged,
                            name: 'useFragment.subscription.missedUpdates'
                        });
                        nextState = dataChanged ? updatedState : prevState;
                    } else nextState = prevState;
                } else nextState = {
                    environment: state.environment,
                    epoch: environment.getStore().getEpoch(),
                    kind: 'singular',
                    selector: state.selector,
                    snapshot: latestSnapshot
                };
                return nextState;
            });
        });
        return function() {
            disposable.dispose();
        };
    } else {
        var disposables = state.snapshots.map(function(snapshot, index) {
            return environment.subscribe(snapshot, function(latestSnapshot) {
                setState(function(prevState) {
                    var _prevState$snapshots$;
                    var nextState = null;
                    if (prevState.kind !== 'plural' || ((_prevState$snapshots$ = prevState.snapshots[index]) === null || _prevState$snapshots$ === void 0 ? void 0 : _prevState$snapshots$.selector) !== latestSnapshot.selector || prevState.environment !== environment) {
                        var updates = $e31ea65cc150a6c4$var$handleMissedUpdates(prevState.environment, prevState);
                        if (updates != null) {
                            var dataChanged = updates[0], updatedState = updates[1];
                            environment.__log({
                                hasDataChanges: dataChanged,
                                name: 'useFragment.subscription.missedUpdates'
                            });
                            nextState = dataChanged ? updatedState : prevState;
                        } else nextState = prevState;
                    } else {
                        var updated = (0, $e31ea65cc150a6c4$var$_toConsumableArray2["default"])(prevState.snapshots);
                        updated[index] = latestSnapshot;
                        nextState = {
                            environment: state.environment,
                            epoch: environment.getStore().getEpoch(),
                            kind: 'plural',
                            selector: state.selector,
                            snapshots: updated
                        };
                    }
                    return nextState;
                });
            });
        });
        return function() {
            var _iterator6 = (0, $e31ea65cc150a6c4$var$_createForOfIteratorHelper2["default"])(disposables), _step6;
            try {
                for(_iterator6.s(); !(_step6 = _iterator6.n()).done;){
                    var d = _step6.value;
                    d.dispose();
                }
            } catch (err) {
                _iterator6.e(err);
            } finally{
                _iterator6.f();
            }
        };
    }
}
function $e31ea65cc150a6c4$var$getFragmentState(environment, fragmentSelector) {
    if (fragmentSelector == null) return {
        environment: environment,
        kind: 'bailout'
    };
    else if (fragmentSelector.kind === 'PluralReaderSelector') return {
        environment: environment,
        epoch: environment.getStore().getEpoch(),
        kind: 'plural',
        selector: fragmentSelector,
        snapshots: fragmentSelector.selectors.map(function(s) {
            return environment.lookup(s);
        })
    };
    else return {
        environment: environment,
        epoch: environment.getStore().getEpoch(),
        kind: 'singular',
        selector: fragmentSelector,
        snapshot: environment.lookup(fragmentSelector)
    };
}
function $e31ea65cc150a6c4$var$useFragmentInternal_EXPERIMENTAL(fragmentNode, fragmentRef, hookDisplayName, queryOptions) {
    var _fragmentNode$metadat, _fragmentNode$metadat2;
    var fragmentSelector = $e31ea65cc150a6c4$var$useMemo(function() {
        return $e31ea65cc150a6c4$var$getSelector(fragmentNode, fragmentRef);
    }, [
        fragmentNode,
        fragmentRef
    ]);
    var isPlural = (fragmentNode === null || fragmentNode === void 0 ? void 0 : (_fragmentNode$metadat = fragmentNode.metadata) === null || _fragmentNode$metadat === void 0 ? void 0 : _fragmentNode$metadat.plural) === true;
    if (isPlural) !(fragmentRef == null || Array.isArray(fragmentRef)) && $jSI6G(false);
    else !!Array.isArray(fragmentRef) && $jSI6G(false);
    !(fragmentRef == null || isPlural && Array.isArray(fragmentRef) && fragmentRef.length === 0 || fragmentSelector != null) && $jSI6G(false);
    var environment = $23TM5();
    var loggerContext;
    if ($e31ea65cc150a6c4$var$RelayFeatureFlags.ENABLE_UI_CONTEXT_ON_RELAY_LOGGER) loggerContext = $e5Ewk();
    var _useState = $e31ea65cc150a6c4$var$useState(function() {
        return $e31ea65cc150a6c4$var$getFragmentState(environment, fragmentSelector);
    }), _state = _useState[0], setState = _useState[1];
    var state = _state;
    var previousEnvironment = state.environment;
    if (!$e31ea65cc150a6c4$var$areEqualSelectors(fragmentSelector, state.selector) || environment !== state.environment) {
        var newState = $e31ea65cc150a6c4$var$getFragmentState(environment, fragmentSelector);
        setState(newState);
        state = newState;
    }
    var committedFragmentSelectorRef = $e31ea65cc150a6c4$var$useRef(false);
    $e31ea65cc150a6c4$var$useEffect(function() {
        committedFragmentSelectorRef.current = fragmentSelector;
    }, [
        fragmentSelector
    ]);
    if (((_fragmentNode$metadat2 = fragmentNode.metadata) === null || _fragmentNode$metadat2 === void 0 ? void 0 : _fragmentNode$metadat2.hasClientEdges) === true || $e31ea65cc150a6c4$var$RelayFeatureFlags.CHECK_ALL_FRAGMENTS_FOR_MISSING_CLIENT_EDGES) {
        var _useMemo = $e31ea65cc150a6c4$var$useMemo(function() {
            var missingClientEdges = $e31ea65cc150a6c4$var$getMissingClientEdges(state);
            var clientEdgeQueries;
            var activeRequestPromises = [];
            if (missingClientEdges !== null && missingClientEdges !== void 0 && missingClientEdges.length) {
                clientEdgeQueries = [];
                var _iterator7 = (0, $e31ea65cc150a6c4$var$_createForOfIteratorHelper2["default"])(missingClientEdges), _step7;
                try {
                    for(_iterator7.s(); !(_step7 = _iterator7.n()).done;){
                        var edge = _step7.value;
                        var _handleMissingClientE = $e31ea65cc150a6c4$var$handleMissingClientEdge(environment, fragmentNode, fragmentRef, edge, queryOptions), queryResult = _handleMissingClientE[0], requestPromise = _handleMissingClientE[1];
                        clientEdgeQueries.push(queryResult);
                        if (requestPromise != null) activeRequestPromises.push(requestPromise);
                    }
                } catch (err) {
                    _iterator7.e(err);
                } finally{
                    _iterator7.f();
                }
            }
            return [
                clientEdgeQueries,
                activeRequestPromises
            ];
        }, [
            state,
            environment,
            fragmentNode,
            fragmentRef,
            queryOptions
        ]), clientEdgeQueries = _useMemo[0], activeRequestPromises = _useMemo[1];
        if (activeRequestPromises.length) {
            !(fragmentSelector != null) && $jSI6G(false);
            var fragmentOwner = fragmentSelector.kind === 'PluralReaderSelector' ? fragmentSelector.selectors[0].owner : fragmentSelector.owner;
            environment.__log({
                name: 'suspense.client_edge',
                fragment: fragmentNode,
                fragmentOwner: fragmentOwner,
                isMount: committedFragmentSelectorRef.current === false
            });
            var allPromises = Promise.all(activeRequestPromises);
            allPromises.displayName = "RelayClientEdge(".concat(activeRequestPromises.map(function(promise) {
                return promise.displayName;
            }).join(','), ")");
            throw allPromises;
        }
        $e31ea65cc150a6c4$var$useEffect(function() {
            var QueryResource = $e31ea65cc150a6c4$var$getQueryResourceForEnvironment(environment);
            if (clientEdgeQueries !== null && clientEdgeQueries !== void 0 && clientEdgeQueries.length) {
                var disposables = [];
                var _iterator8 = (0, $e31ea65cc150a6c4$var$_createForOfIteratorHelper2["default"])(clientEdgeQueries), _step8;
                try {
                    for(_iterator8.s(); !(_step8 = _iterator8.n()).done;){
                        var query = _step8.value;
                        disposables.push(QueryResource.retain(query));
                    }
                } catch (err) {
                    _iterator8.e(err);
                } finally{
                    _iterator8.f();
                }
                return function() {
                    for(var _i = 0, _disposables = disposables; _i < _disposables.length; _i++){
                        var disposable = _disposables[_i];
                        disposable.dispose();
                    }
                };
            }
        }, [
            environment,
            clientEdgeQueries
        ]);
    }
    if ($e31ea65cc150a6c4$var$isMissingData(state)) {
        var suspendingLiveResolvers = $e31ea65cc150a6c4$var$getSuspendingLiveResolver(state);
        if (suspendingLiveResolvers != null && suspendingLiveResolvers.length > 0) {
            !(fragmentSelector != null) && $jSI6G(false);
            var _fragmentOwner = fragmentSelector.kind === 'PluralReaderSelector' ? fragmentSelector.selectors[0].owner : fragmentSelector.owner;
            environment.__log({
                name: 'suspense.resolver',
                fragment: fragmentNode,
                fragmentOwner: _fragmentOwner,
                isMount: committedFragmentSelectorRef.current === false,
                suspendingLiveResolvers: suspendingLiveResolvers
            });
            var promise = Promise.all(suspendingLiveResolvers.map(function(liveStateID) {
                return environment.getStore().getLiveResolverPromise(liveStateID);
            }));
            promise.displayName = 'RelayLiveResolver(' + fragmentNode.name + ')';
            throw promise;
        }
        if ($e31ea65cc150a6c4$var$RelayFeatureFlags.ENABLE_RELAY_OPERATION_TRACKER_SUSPENSE || environment !== previousEnvironment || committedFragmentSelectorRef.current === false || !$e31ea65cc150a6c4$var$areEqualSelectors(committedFragmentSelectorRef.current, fragmentSelector)) {
            !(fragmentSelector != null) && $jSI6G(false);
            var _fragmentOwner2 = fragmentSelector.kind === 'PluralReaderSelector' ? fragmentSelector.selectors[0].owner : fragmentSelector.owner;
            var pendingOperationsResult = $e31ea65cc150a6c4$var$getPendingOperationsForFragment(environment, fragmentNode, _fragmentOwner2);
            if (pendingOperationsResult) {
                environment.__log({
                    name: 'suspense.missing_data',
                    fragment: fragmentNode,
                    fragmentOwner: _fragmentOwner2,
                    isMount: committedFragmentSelectorRef.current === false,
                    pendingOperations: pendingOperationsResult.pendingOperations
                });
                throw pendingOperationsResult.promise;
            }
        }
    }
    $e31ea65cc150a6c4$var$handlePotentialSnapshotErrorsForState(environment, state, loggerContext);
    var storeSubscriptionRef = $e31ea65cc150a6c4$var$useRef({
        kind: 'uninitialized'
    });
    $e31ea65cc150a6c4$var$useEffect(function() {
        var storeSubscription = storeSubscriptionRef.current;
        if (storeSubscription.kind === 'initialized') {
            if (state.environment === storeSubscription.environment && state.selector === storeSubscription.selector) return;
            else {
                storeSubscription.dispose();
                storeSubscriptionRef.current = {
                    kind: 'uninitialized'
                };
            }
        }
        if (state.kind === 'bailout') return;
        var stateForSubscription = state;
        var updates = $e31ea65cc150a6c4$var$handleMissedUpdates(state.environment, state);
        if (updates !== null) {
            var didMissUpdates = updates[0], updatedState = updates[1];
            if (didMissUpdates) {
                setState(updatedState);
                storeSubscriptionRef.current = {
                    kind: 'missed-updates'
                };
                return;
            }
            stateForSubscription = updatedState;
        }
        var dispose = $e31ea65cc150a6c4$var$subscribeToSnapshot(state.environment, stateForSubscription, setState);
        storeSubscriptionRef.current = {
            dispose: dispose,
            environment: state.environment,
            kind: 'initialized',
            selector: state.selector
        };
    }, [
        state
    ]);
    $e31ea65cc150a6c4$var$useEffect(function() {
        if (storeSubscriptionRef.current.kind === 'uninitialized' && state.kind !== 'bailout') {
            var dispose = $e31ea65cc150a6c4$var$subscribeToSnapshot(state.environment, state, setState);
            storeSubscriptionRef.current = {
                dispose: dispose,
                environment: state.environment,
                kind: 'initialized',
                selector: state.selector
            };
        }
        return function() {
            if (storeSubscriptionRef.current.kind === 'initialized') storeSubscriptionRef.current.dispose();
            storeSubscriptionRef.current = {
                kind: 'uninitialized'
            };
        };
    }, []);
    var data;
    if (isPlural) {
        var fragmentRefIsNullish = fragmentRef == null;
        data = $e31ea65cc150a6c4$var$useMemo(function() {
            if (state.kind === 'bailout') return fragmentRefIsNullish ? null : [];
            else {
                !(state.kind === 'plural') && $jSI6G(false);
                return state.snapshots.map(function(s) {
                    return s.data;
                });
            }
        }, [
            state,
            fragmentRefIsNullish
        ]);
    } else if (state.kind === 'bailout') data = null;
    else {
        !(state.kind === 'singular') && $jSI6G(false);
        data = state.snapshot.data;
    }
    if ($e31ea65cc150a6c4$var$RelayFeatureFlags.LOG_MISSING_RECORDS_IN_PROD || false) fragmentRef != null && (data === undefined || Array.isArray(data) && data.length > 0 && data.every(function(d) {
        return d === undefined;
    }));
    return data;
}
module.exports = $e31ea65cc150a6c4$var$useFragmentInternal_EXPERIMENTAL;

});



parcelRegister("96WbG", function(module, exports) {
'use strict';

var $e42en = parcelRequire("e42en");

var $5FkrB = parcelRequire("5FkrB");

var $7eKmg = parcelRequire("7eKmg");
var $6a21cf6bdbd2ba17$var$createOperationDescriptor = $7eKmg.createOperationDescriptor, $6a21cf6bdbd2ba17$var$getRequest = $7eKmg.getRequest;
var $6a21cf6bdbd2ba17$var$useMemo = $5FkrB.useMemo;
function $6a21cf6bdbd2ba17$var$useMemoOperationDescriptor(gqlQuery, variables, cacheConfig) {
    var memoVariables = $e42en(variables);
    var memoCacheConfig = $e42en(cacheConfig || {});
    return $6a21cf6bdbd2ba17$var$useMemo(function() {
        return $6a21cf6bdbd2ba17$var$createOperationDescriptor($6a21cf6bdbd2ba17$var$getRequest(gqlQuery), memoVariables, memoCacheConfig);
    }, [
        gqlQuery,
        memoVariables,
        memoCacheConfig
    ]);
}
module.exports = $6a21cf6bdbd2ba17$var$useMemoOperationDescriptor;

});
parcelRegister("e42en", function(module, exports) {
'use strict';

var $bke7t = parcelRequire("bke7t");

var $5FkrB = parcelRequire("5FkrB");
var $02a4702f3132edbe$var$useState = $5FkrB.useState;
function $02a4702f3132edbe$var$useMemoVariables(variables) {
    var _useState = $02a4702f3132edbe$var$useState(variables), mirroredVariables = _useState[0], setMirroredVariables = _useState[1];
    if ($bke7t(variables, mirroredVariables)) return mirroredVariables;
    else {
        setMirroredVariables(variables);
        return variables;
    }
}
module.exports = $02a4702f3132edbe$var$useMemoVariables;

});




parcelRegister("bVIjz", function(module, exports) {
'use strict';

var $drPJO = parcelRequire("drPJO");
var $8af7648f52c42ede$var$_interopRequireDefault = $drPJO.default;

var $8af7648f52c42ede$var$_createForOfIteratorHelper2 = $8af7648f52c42ede$var$_interopRequireDefault((parcelRequire("jLbXI")));

var $b2vkf = parcelRequire("b2vkf");

var $7rvkY = parcelRequire("7rvkY");

var $5FkrB = parcelRequire("5FkrB");
var $8af7648f52c42ede$var$useCallback = $5FkrB.useCallback, $8af7648f52c42ede$var$useEffect = $5FkrB.useEffect, $8af7648f52c42ede$var$useRef = $5FkrB.useRef, $8af7648f52c42ede$var$useState = $5FkrB.useState;
var $8af7648f52c42ede$var$initialNullEntryPointReferenceState = {
    kind: 'NullEntryPointReference'
};
function $8af7648f52c42ede$var$useLoadEntryPoint(environmentProvider, entryPoint, options) {
    var _options$TEST_ONLY__i, _options$TEST_ONLY__i2, _options$TEST_ONLY__i3, _options$TEST_ONLY__i4;
    var initialEntryPointReferenceInternal = (_options$TEST_ONLY__i = options === null || options === void 0 ? void 0 : (_options$TEST_ONLY__i2 = options.TEST_ONLY__initialEntryPointData) === null || _options$TEST_ONLY__i2 === void 0 ? void 0 : _options$TEST_ONLY__i2.entryPointReference) !== null && _options$TEST_ONLY__i !== void 0 ? _options$TEST_ONLY__i : $8af7648f52c42ede$var$initialNullEntryPointReferenceState;
    var initialEntryPointParamsInternal = (_options$TEST_ONLY__i3 = options === null || options === void 0 ? void 0 : (_options$TEST_ONLY__i4 = options.TEST_ONLY__initialEntryPointData) === null || _options$TEST_ONLY__i4 === void 0 ? void 0 : _options$TEST_ONLY__i4.entryPointParams) !== null && _options$TEST_ONLY__i3 !== void 0 ? _options$TEST_ONLY__i3 : null;
    var isMountedRef = $7rvkY();
    var undisposedEntryPointReferencesRef = $8af7648f52c42ede$var$useRef(new Set([
        initialEntryPointReferenceInternal
    ]));
    var _useState = $8af7648f52c42ede$var$useState(initialEntryPointReferenceInternal), entryPointReference = _useState[0], setEntryPointReference = _useState[1];
    var _useState2 = $8af7648f52c42ede$var$useState(initialEntryPointParamsInternal), entryPointParams = _useState2[0], setEntryPointParams = _useState2[1];
    var disposeEntryPoint = $8af7648f52c42ede$var$useCallback(function() {
        if (isMountedRef.current) {
            var nullEntryPointReference = {
                kind: 'NullEntryPointReference'
            };
            undisposedEntryPointReferencesRef.current.add(nullEntryPointReference);
            setEntryPointReference(nullEntryPointReference);
        }
    }, [
        setEntryPointReference,
        isMountedRef
    ]);
    var entryPointLoaderCallback = $8af7648f52c42ede$var$useCallback(function(params) {
        if (isMountedRef.current) {
            var updatedEntryPointReference = $b2vkf(environmentProvider, entryPoint, params);
            undisposedEntryPointReferencesRef.current.add(updatedEntryPointReference);
            setEntryPointReference(updatedEntryPointReference);
            setEntryPointParams(params);
        }
    }, [
        environmentProvider,
        entryPoint,
        setEntryPointReference,
        isMountedRef
    ]);
    var maybeHiddenOrFastRefresh = $8af7648f52c42ede$var$useRef(false);
    $8af7648f52c42ede$var$useEffect(function() {
        return function() {
            maybeHiddenOrFastRefresh.current = true;
        };
    }, []);
    $8af7648f52c42ede$var$useEffect(function() {
        if (maybeHiddenOrFastRefresh.current === true) {
            maybeHiddenOrFastRefresh.current = false;
            if (entryPointReference.kind !== 'NullEntryPointReference' && entryPointParams != null) entryPointLoaderCallback(entryPointParams);
            return;
        }
        var undisposedEntryPointReferences = undisposedEntryPointReferencesRef.current;
        if (isMountedRef.current) {
            var _iterator = (0, $8af7648f52c42ede$var$_createForOfIteratorHelper2["default"])(undisposedEntryPointReferences), _step;
            try {
                for(_iterator.s(); !(_step = _iterator.n()).done;){
                    var undisposedEntryPointReference = _step.value;
                    if (undisposedEntryPointReference === entryPointReference) break;
                    undisposedEntryPointReferences["delete"](undisposedEntryPointReference);
                    if (undisposedEntryPointReference.kind !== 'NullEntryPointReference') undisposedEntryPointReference.dispose();
                }
            } catch (err) {
                _iterator.e(err);
            } finally{
                _iterator.f();
            }
        }
    }, [
        entryPointReference,
        entryPointParams,
        entryPointLoaderCallback,
        isMountedRef
    ]);
    $8af7648f52c42ede$var$useEffect(function() {
        return function disposeAllRemainingEntryPointReferences() {
            var _iterator2 = (0, $8af7648f52c42ede$var$_createForOfIteratorHelper2["default"])(undisposedEntryPointReferencesRef.current), _step2;
            try {
                for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                    var unhandledStateChange = _step2.value;
                    if (unhandledStateChange.kind !== 'NullEntryPointReference') unhandledStateChange.dispose();
                }
            } catch (err) {
                _iterator2.e(err);
            } finally{
                _iterator2.f();
            }
        };
    }, []);
    return [
        entryPointReference.kind === 'NullEntryPointReference' ? null : entryPointReference,
        entryPointLoaderCallback,
        disposeEntryPoint
    ];
}
module.exports = $8af7648f52c42ede$var$useLoadEntryPoint;

});
parcelRegister("7rvkY", function(module, exports) {
'use strict';

var $5FkrB = parcelRequire("5FkrB");
var $56b35cf37a4885f1$var$useEffect = $5FkrB.useEffect, $56b35cf37a4885f1$var$useRef = $5FkrB.useRef;
function $56b35cf37a4885f1$var$useIsMountedRef() {
    var isMountedRef = $56b35cf37a4885f1$var$useRef(true);
    $56b35cf37a4885f1$var$useEffect(function() {
        isMountedRef.current = true;
        return function() {
            isMountedRef.current = false;
        };
    }, []);
    return isMountedRef;
}
module.exports = $56b35cf37a4885f1$var$useIsMountedRef;

});


parcelRegister("lelUi", function(module, exports) {
'use strict';

var $3R4z1 = parcelRequire("3R4z1");

var $a68UM = parcelRequire("a68UM");

var $5FkrB = parcelRequire("5FkrB");
var $f74be61136cf54e1$var$useDebugValue = $5FkrB.useDebugValue;

var $7eKmg = parcelRequire("7eKmg");
var $f74be61136cf54e1$var$getFragment = $7eKmg.getFragment;
function $f74be61136cf54e1$var$useFragment(fragment, key) {
    var fragmentNode = $f74be61136cf54e1$var$getFragment(fragment);
    $a68UM(fragmentNode, 'first argument of useFragment()');
    var data = $3R4z1(fragmentNode, key, 'useFragment()');
    return data;
}
module.exports = $f74be61136cf54e1$var$useFragment;

});
parcelRegister("a68UM", function(module, exports) {
'use strict';
parcelRequire("8VZiD");
parcelRequire("2OmBw");
function $75a1613ba8eacf57$var$useStaticFragmentNodeWarning(fragmentNode, warningContext) {
    var initialPropRef;
}
module.exports = $75a1613ba8eacf57$var$useStaticFragmentNodeWarning;

});


parcelRegister("2zAPq", function(module, exports) {
'use strict';

var $drPJO = parcelRequire("drPJO");
var $1dfb6b002a19e7ff$var$_interopRequireDefault = $drPJO.default;

var $1dfb6b002a19e7ff$var$_objectSpread2 = $1dfb6b002a19e7ff$var$_interopRequireDefault((parcelRequire("5OKtB")));

var $23TM5 = parcelRequire("23TM5");

var $5FkrB = parcelRequire("5FkrB");

var $7eKmg = parcelRequire("7eKmg");
var $1dfb6b002a19e7ff$var$defaultCommitMutation = $7eKmg.commitMutation;
var $1dfb6b002a19e7ff$var$useState = $5FkrB.useState, $1dfb6b002a19e7ff$var$useEffect = $5FkrB.useEffect, $1dfb6b002a19e7ff$var$useRef = $5FkrB.useRef, $1dfb6b002a19e7ff$var$useCallback = $5FkrB.useCallback;
function $1dfb6b002a19e7ff$var$useMutation(mutation) {
    var commitMutationFn = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $1dfb6b002a19e7ff$var$defaultCommitMutation;
    var environment = $23TM5();
    var environmentRef = $1dfb6b002a19e7ff$var$useRef(environment);
    var mutationRef = $1dfb6b002a19e7ff$var$useRef(mutation);
    var inFlightMutationsRef = $1dfb6b002a19e7ff$var$useRef(new Set());
    var _useState = $1dfb6b002a19e7ff$var$useState(false), isMutationInFlight = _useState[0], setMutationInFlight = _useState[1];
    var cleanup = $1dfb6b002a19e7ff$var$useCallback(function(disposable) {
        if (environmentRef.current === environment && mutationRef.current === mutation) {
            inFlightMutationsRef.current["delete"](disposable);
            setMutationInFlight(inFlightMutationsRef.current.size > 0);
        }
    }, [
        environment,
        mutation
    ]);
    $1dfb6b002a19e7ff$var$useEffect(function() {
        if (environmentRef.current !== environment || mutationRef.current !== mutation) {
            inFlightMutationsRef.current = new Set();
            setMutationInFlight(false);
            environmentRef.current = environment;
            mutationRef.current = mutation;
        }
    }, [
        environment,
        mutation
    ]);
    var commit = $1dfb6b002a19e7ff$var$useCallback(function(config) {
        setMutationInFlight(true);
        var disposable = commitMutationFn(environment, (0, $1dfb6b002a19e7ff$var$_objectSpread2["default"])((0, $1dfb6b002a19e7ff$var$_objectSpread2["default"])({}, config), {}, {
            mutation: mutation,
            onCompleted: function onCompleted(response, errors) {
                var _config$onCompleted;
                cleanup(disposable);
                (_config$onCompleted = config.onCompleted) === null || _config$onCompleted === void 0 || _config$onCompleted.call(config, response, errors);
            },
            onError: function onError(error) {
                var _config$onError;
                cleanup(disposable);
                (_config$onError = config.onError) === null || _config$onError === void 0 || _config$onError.call(config, error);
            },
            onUnsubscribe: function onUnsubscribe() {
                var _config$onUnsubscribe;
                cleanup(disposable);
                (_config$onUnsubscribe = config.onUnsubscribe) === null || _config$onUnsubscribe === void 0 || _config$onUnsubscribe.call(config);
            },
            onNext: function onNext() {
                var _config$onNext;
                (_config$onNext = config.onNext) === null || _config$onNext === void 0 || _config$onNext.call(config);
            }
        }));
        inFlightMutationsRef.current.add(disposable);
        return disposable;
    }, [
        cleanup,
        commitMutationFn,
        environment,
        mutation
    ]);
    return [
        commit,
        isMutationInFlight
    ];
}
module.exports = $1dfb6b002a19e7ff$var$useMutation;

});

parcelRegister("ceb2r", function(module, exports) {
'use strict';

var $23TM5 = parcelRequire("23TM5");

var $5FkrB = parcelRequire("5FkrB");

var $7eKmg = parcelRequire("7eKmg");
var $8e6f5ad66819ae31$var$commitMutation = $7eKmg.commitMutation;
var $8e6f5ad66819ae31$var$useCallback = $5FkrB.useCallback;
function $8e6f5ad66819ae31$var$useMutationAction_EXPERIMENTAL(mutation) {
    var environment = $23TM5();
    var commitAction = $8e6f5ad66819ae31$var$useCallback(function(variables) {
        return new Promise(function(resolve, reject) {
            $8e6f5ad66819ae31$var$commitMutation(environment, {
                mutation: mutation,
                variables: variables,
                onCompleted: function onCompleted(response) {
                    resolve(response);
                },
                onError: function onError(error) {
                    reject(error);
                }
            });
        });
    }, [
        environment,
        mutation
    ]);
    return commitAction;
}
module.exports = $8e6f5ad66819ae31$var$useMutationAction_EXPERIMENTAL;

});

parcelRegister("cyCW8", function(module, exports) {
'use strict';

var $drPJO = parcelRequire("drPJO");
var $9246dd084ace7fbf$var$_interopRequireDefault = $drPJO.default;

var $9246dd084ace7fbf$var$_objectSpread2 = $9246dd084ace7fbf$var$_interopRequireDefault((parcelRequire("5OKtB")));

var $tXmd3 = parcelRequire("tXmd3");

var $lX5nK = parcelRequire("lX5nK");

var $23TM5 = parcelRequire("23TM5");

var $a68UM = parcelRequire("a68UM");

var $5FkrB = parcelRequire("5FkrB");
var $9246dd084ace7fbf$var$useCallback = $5FkrB.useCallback, $9246dd084ace7fbf$var$useDebugValue = $5FkrB.useDebugValue, $9246dd084ace7fbf$var$useState = $5FkrB.useState;

var $7eKmg = parcelRequire("7eKmg");
var $9246dd084ace7fbf$var$RelayFeatureFlags = $7eKmg.RelayFeatureFlags, $9246dd084ace7fbf$var$getFragment = $7eKmg.getFragment, $9246dd084ace7fbf$var$getFragmentIdentifier = $7eKmg.getFragmentIdentifier, $9246dd084ace7fbf$var$getPaginationMetadata = $7eKmg.getPaginationMetadata;
function $9246dd084ace7fbf$var$usePaginationFragment(fragmentInput, parentFragmentRef) {
    var fragmentNode = $9246dd084ace7fbf$var$getFragment(fragmentInput);
    $a68UM(fragmentNode, 'first argument of usePaginationFragment()');
    var componentDisplayName = 'usePaginationFragment()';
    var _getPaginationMetadat = $9246dd084ace7fbf$var$getPaginationMetadata(fragmentNode, componentDisplayName), connectionPathInFragmentData = _getPaginationMetadat.connectionPathInFragmentData, paginationRequest = _getPaginationMetadat.paginationRequest, paginationMetadata = _getPaginationMetadat.paginationMetadata;
    var _useRefetchableFragme = $lX5nK(fragmentNode, parentFragmentRef, componentDisplayName), fragmentData = _useRefetchableFragme.fragmentData, fragmentRef = _useRefetchableFragme.fragmentRef, refetch = _useRefetchableFragme.refetch;
    var fragmentIdentifier = $9246dd084ace7fbf$var$getFragmentIdentifier(fragmentNode, fragmentRef);
    var _useLoadMore = $9246dd084ace7fbf$var$useLoadMore({
        componentDisplayName: componentDisplayName,
        connectionPathInFragmentData: connectionPathInFragmentData,
        direction: 'backward',
        fragmentData: fragmentData,
        fragmentIdentifier: fragmentIdentifier,
        fragmentNode: fragmentNode,
        fragmentRef: fragmentRef,
        paginationMetadata: paginationMetadata,
        paginationRequest: paginationRequest
    }), loadPrevious = _useLoadMore[0], hasPrevious = _useLoadMore[1], isLoadingPrevious = _useLoadMore[2], disposeFetchPrevious = _useLoadMore[3];
    var _useLoadMore2 = $9246dd084ace7fbf$var$useLoadMore({
        componentDisplayName: componentDisplayName,
        connectionPathInFragmentData: connectionPathInFragmentData,
        direction: 'forward',
        fragmentData: fragmentData,
        fragmentIdentifier: fragmentIdentifier,
        fragmentNode: fragmentNode,
        fragmentRef: fragmentRef,
        paginationMetadata: paginationMetadata,
        paginationRequest: paginationRequest
    }), loadNext = _useLoadMore2[0], hasNext = _useLoadMore2[1], isLoadingNext = _useLoadMore2[2], disposeFetchNext = _useLoadMore2[3];
    var refetchPagination = $9246dd084ace7fbf$var$useCallback(function(variables, options) {
        disposeFetchNext();
        disposeFetchPrevious();
        return refetch(variables, (0, $9246dd084ace7fbf$var$_objectSpread2["default"])((0, $9246dd084ace7fbf$var$_objectSpread2["default"])({}, options), {}, {
            __environment: undefined
        }));
    }, [
        disposeFetchNext,
        disposeFetchPrevious,
        refetch
    ]);
    return {
        data: fragmentData,
        loadNext: loadNext,
        loadPrevious: loadPrevious,
        hasNext: hasNext,
        hasPrevious: hasPrevious,
        isLoadingNext: isLoadingNext,
        isLoadingPrevious: isLoadingPrevious,
        refetch: refetchPagination
    };
}
function $9246dd084ace7fbf$var$useLoadMore(args) {
    var environment = $23TM5();
    var _useState = $9246dd084ace7fbf$var$useState(false), isLoadingMore = _useState[0], reallySetIsLoadingMore = _useState[1];
    var setIsLoadingMore = function setIsLoadingMore(value) {
        var _environment$getSched;
        var schedule = (_environment$getSched = environment.getScheduler()) === null || _environment$getSched === void 0 ? void 0 : _environment$getSched.schedule;
        if (schedule) schedule(function() {
            reallySetIsLoadingMore(value);
        });
        else reallySetIsLoadingMore(value);
    };
    var observer = {
        start: function start() {
            return setIsLoadingMore(true);
        },
        complete: function complete() {
            return setIsLoadingMore(false);
        },
        error: function error() {
            return setIsLoadingMore(false);
        },
        unsubscribe: $9246dd084ace7fbf$var$RelayFeatureFlags.ENABLE_USE_PAGINATION_IS_LOADING_FIX ? function() {
            return setIsLoadingMore(false);
        } : undefined
    };
    var handleReset = function handleReset() {
        return setIsLoadingMore(false);
    };
    var _useLoadMoreFunction = $tXmd3((0, $9246dd084ace7fbf$var$_objectSpread2["default"])((0, $9246dd084ace7fbf$var$_objectSpread2["default"])({}, args), {}, {
        observer: observer,
        onReset: handleReset
    })), loadMore = _useLoadMoreFunction[0], hasMore = _useLoadMoreFunction[1], disposeFetch = _useLoadMoreFunction[2];
    return [
        loadMore,
        hasMore,
        isLoadingMore,
        disposeFetch
    ];
}
module.exports = $9246dd084ace7fbf$var$usePaginationFragment;

});
parcelRegister("tXmd3", function(module, exports) {
'use strict';

var $drPJO = parcelRequire("drPJO");
var $05a0c0a7a831d7aa$var$_interopRequireDefault = $drPJO.default;

var $05a0c0a7a831d7aa$var$_objectSpread2 = $05a0c0a7a831d7aa$var$_interopRequireDefault((parcelRequire("5OKtB")));

var $e356D = parcelRequire("e356D");

var $dxt9N = parcelRequire("dxt9N");

var $7rvkY = parcelRequire("7rvkY");

var $8FFuF = parcelRequire("8FFuF");

var $ap35C = parcelRequire("ap35C");

var $23TM5 = parcelRequire("23TM5");

var $jSI6G = parcelRequire("jSI6G");

var $5FkrB = parcelRequire("5FkrB");
var $05a0c0a7a831d7aa$var$useCallback = $5FkrB.useCallback, $05a0c0a7a831d7aa$var$useEffect = $5FkrB.useEffect, $05a0c0a7a831d7aa$var$useState = $5FkrB.useState;

var $7eKmg = parcelRequire("7eKmg");
var $05a0c0a7a831d7aa$var$fetchQuery = $7eKmg.__internal.fetchQuery, $05a0c0a7a831d7aa$var$RelayFeatureFlags = $7eKmg.RelayFeatureFlags, $05a0c0a7a831d7aa$var$createOperationDescriptor = $7eKmg.createOperationDescriptor, $05a0c0a7a831d7aa$var$getPaginationVariables = $7eKmg.getPaginationVariables, $05a0c0a7a831d7aa$var$getRefetchMetadata = $7eKmg.getRefetchMetadata, $05a0c0a7a831d7aa$var$getSelector = $7eKmg.getSelector;
parcelRequire("2OmBw");
function $05a0c0a7a831d7aa$var$useLoadMoreFunction(args) {
    if ($05a0c0a7a831d7aa$var$RelayFeatureFlags.ENABLE_ACTIVITY_COMPATIBILITY) return $ap35C(args);
    return $05a0c0a7a831d7aa$var$useLoadMoreFunction_CURRENT(args);
}
function $05a0c0a7a831d7aa$var$useLoadMoreFunction_CURRENT(args) {
    var direction = args.direction, fragmentNode = args.fragmentNode, fragmentRef = args.fragmentRef, fragmentIdentifier = args.fragmentIdentifier, fragmentData = args.fragmentData, connectionPathInFragmentData = args.connectionPathInFragmentData, paginationRequest = args.paginationRequest, paginationMetadata = args.paginationMetadata, componentDisplayName = args.componentDisplayName, observer = args.observer, onReset = args.onReset;
    var environment = $23TM5();
    var _useFetchTrackingRef = $dxt9N(), isFetchingRef = _useFetchTrackingRef.isFetchingRef, startFetch = _useFetchTrackingRef.startFetch, disposeFetch = _useFetchTrackingRef.disposeFetch, completeFetch = _useFetchTrackingRef.completeFetch;
    var _getRefetchMetadata = $05a0c0a7a831d7aa$var$getRefetchMetadata(fragmentNode, componentDisplayName), identifierInfo = _getRefetchMetadata.identifierInfo;
    var identifierValue = (identifierInfo === null || identifierInfo === void 0 ? void 0 : identifierInfo.identifierField) != null && fragmentData != null && typeof fragmentData === 'object' ? fragmentData[identifierInfo.identifierField] : null;
    var isMountedRef = $7rvkY();
    var _useState = $05a0c0a7a831d7aa$var$useState(environment), mirroredEnvironment = _useState[0], setMirroredEnvironment = _useState[1];
    var _useState2 = $05a0c0a7a831d7aa$var$useState(fragmentIdentifier), mirroredFragmentIdentifier = _useState2[0], setMirroredFragmentIdentifier = _useState2[1];
    var isParentQueryActive = $8FFuF(fragmentNode, fragmentRef);
    var shouldReset = environment !== mirroredEnvironment || fragmentIdentifier !== mirroredFragmentIdentifier;
    if (shouldReset) {
        disposeFetch();
        onReset();
        setMirroredEnvironment(environment);
        setMirroredFragmentIdentifier(fragmentIdentifier);
    }
    var _getConnectionState = $e356D(direction, fragmentNode, fragmentData, connectionPathInFragmentData), cursor = _getConnectionState.cursor, hasMore = _getConnectionState.hasMore;
    $05a0c0a7a831d7aa$var$useEffect(function() {
        return function() {
            disposeFetch();
        };
    }, [
        disposeFetch
    ]);
    var isRequestInvalid = fragmentData == null || isParentQueryActive;
    var loadMore = $05a0c0a7a831d7aa$var$useCallback(function(count, options) {
        var onComplete = options === null || options === void 0 ? void 0 : options.onComplete;
        if (isMountedRef.current !== true) return {
            dispose: function dispose() {}
        };
        var fragmentSelector = $05a0c0a7a831d7aa$var$getSelector(fragmentNode, fragmentRef);
        if (isFetchingRef.current === true || isRequestInvalid) {
            fragmentSelector;
            if (onComplete) onComplete(null);
            return {
                dispose: function dispose() {}
            };
        }
        !(fragmentSelector != null && fragmentSelector.kind !== 'PluralReaderSelector') && $jSI6G(false);
        var parentVariables = fragmentSelector.owner.variables;
        var fragmentVariables = fragmentSelector.variables;
        var extraVariables = options === null || options === void 0 ? void 0 : options.UNSTABLE_extraVariables;
        var baseVariables = (0, $05a0c0a7a831d7aa$var$_objectSpread2["default"])((0, $05a0c0a7a831d7aa$var$_objectSpread2["default"])({}, parentVariables), fragmentVariables);
        var paginationVariables = $05a0c0a7a831d7aa$var$getPaginationVariables(direction, count, cursor, baseVariables, (0, $05a0c0a7a831d7aa$var$_objectSpread2["default"])({}, extraVariables), paginationMetadata);
        if (identifierInfo != null) {
            typeof identifierValue;
            paginationVariables[identifierInfo.identifierQueryVariableName] = identifierValue;
        }
        var paginationQuery = $05a0c0a7a831d7aa$var$createOperationDescriptor(paginationRequest, paginationVariables, {
            force: true
        });
        $05a0c0a7a831d7aa$var$fetchQuery(environment, paginationQuery).subscribe((0, $05a0c0a7a831d7aa$var$_objectSpread2["default"])((0, $05a0c0a7a831d7aa$var$_objectSpread2["default"])({}, observer), {}, {
            start: function start(subscription) {
                startFetch(subscription);
                observer.start && observer.start(subscription);
            },
            complete: function complete() {
                completeFetch();
                observer.complete && observer.complete();
                onComplete && onComplete(null);
            },
            error: function error(_error) {
                completeFetch();
                observer.error && observer.error(_error);
                onComplete && onComplete(_error);
            }
        }));
        return {
            dispose: disposeFetch
        };
    }, [
        environment,
        identifierValue,
        direction,
        cursor,
        startFetch,
        disposeFetch,
        completeFetch,
        isFetchingRef,
        isRequestInvalid,
        fragmentNode.name,
        fragmentRef,
        componentDisplayName
    ]);
    return [
        loadMore,
        hasMore,
        disposeFetch
    ];
}
module.exports = $05a0c0a7a831d7aa$var$useLoadMoreFunction;

});
parcelRegister("e356D", function(module, exports) {
'use strict';

var $jSI6G = parcelRequire("jSI6G");

var $7eKmg = parcelRequire("7eKmg");
var $a3a54e77330559f3$var$ConnectionInterface = $7eKmg.ConnectionInterface, $a3a54e77330559f3$var$getValueAtPath = $7eKmg.getValueAtPath;
function $a3a54e77330559f3$var$getConnectionState(direction, fragmentNode, fragmentData, connectionPathInFragmentData) {
    var _pageInfo$END_CURSOR, _pageInfo$START_CURSO;
    var _ConnectionInterface$ = $a3a54e77330559f3$var$ConnectionInterface.get(), EDGES = _ConnectionInterface$.EDGES, PAGE_INFO = _ConnectionInterface$.PAGE_INFO, HAS_NEXT_PAGE = _ConnectionInterface$.HAS_NEXT_PAGE, HAS_PREV_PAGE = _ConnectionInterface$.HAS_PREV_PAGE, END_CURSOR = _ConnectionInterface$.END_CURSOR, START_CURSOR = _ConnectionInterface$.START_CURSOR;
    var connection = $a3a54e77330559f3$var$getValueAtPath(fragmentData, connectionPathInFragmentData);
    if (connection == null) return {
        cursor: null,
        hasMore: false
    };
    !(typeof connection === 'object') && $jSI6G(false);
    var edges = connection[EDGES];
    var pageInfo = connection[PAGE_INFO];
    if (edges == null || pageInfo == null) return {
        cursor: null,
        hasMore: false
    };
    !Array.isArray(edges) && $jSI6G(false);
    !(typeof pageInfo === 'object') && $jSI6G(false);
    var cursor = direction === 'forward' ? (_pageInfo$END_CURSOR = pageInfo[END_CURSOR]) !== null && _pageInfo$END_CURSOR !== void 0 ? _pageInfo$END_CURSOR : null : (_pageInfo$START_CURSO = pageInfo[START_CURSOR]) !== null && _pageInfo$START_CURSO !== void 0 ? _pageInfo$START_CURSO : null;
    !(cursor === null || typeof cursor === 'string') && $jSI6G(false);
    var hasMore;
    if (direction === 'forward') hasMore = cursor != null && pageInfo[HAS_NEXT_PAGE] === true;
    else hasMore = cursor != null && pageInfo[HAS_PREV_PAGE] === true;
    return {
        cursor: cursor,
        hasMore: hasMore
    };
}
module.exports = $a3a54e77330559f3$var$getConnectionState;

});

parcelRegister("8FFuF", function(module, exports) {
'use strict';

var $23TM5 = parcelRequire("23TM5");

var $jSI6G = parcelRequire("jSI6G");

var $5FkrB = parcelRequire("5FkrB");

var $7eKmg = parcelRequire("7eKmg");
var $650256d52f764b52$var$getObservableForActiveRequest = $7eKmg.__internal.getObservableForActiveRequest, $650256d52f764b52$var$getSelector = $7eKmg.getSelector;
var $650256d52f764b52$var$useEffect = $5FkrB.useEffect, $650256d52f764b52$var$useState = $5FkrB.useState, $650256d52f764b52$var$useMemo = $5FkrB.useMemo;
function $650256d52f764b52$var$useIsOperationNodeActive(fragmentNode, fragmentRef) {
    var environment = $23TM5();
    var observable = $650256d52f764b52$var$useMemo(function() {
        var selector = $650256d52f764b52$var$getSelector(fragmentNode, fragmentRef);
        if (selector == null) return null;
        !(selector.kind === 'SingularReaderSelector') && $jSI6G(false);
        return $650256d52f764b52$var$getObservableForActiveRequest(environment, selector.owner);
    }, [
        environment,
        fragmentNode,
        fragmentRef
    ]);
    var _useState = $650256d52f764b52$var$useState(observable != null), isActive = _useState[0], setIsActive = _useState[1];
    $650256d52f764b52$var$useEffect(function() {
        var subscription;
        setIsActive(observable != null);
        if (observable != null) {
            var onCompleteOrError = function onCompleteOrError() {
                setIsActive(false);
            };
            subscription = observable.subscribe({
                complete: onCompleteOrError,
                error: onCompleteOrError
            });
        }
        return function() {
            if (subscription) subscription.unsubscribe();
        };
    }, [
        observable
    ]);
    return isActive;
}
module.exports = $650256d52f764b52$var$useIsOperationNodeActive;

});

parcelRegister("ap35C", function(module, exports) {
'use strict';

var $drPJO = parcelRequire("drPJO");
var $792ea2b9575fffb7$var$_interopRequireDefault = $drPJO.default;

var $792ea2b9575fffb7$var$_objectSpread2 = $792ea2b9575fffb7$var$_interopRequireDefault((parcelRequire("5OKtB")));

var $e356D = parcelRequire("e356D");

var $7rvkY = parcelRequire("7rvkY");

var $8FFuF = parcelRequire("8FFuF");

var $23TM5 = parcelRequire("23TM5");

var $jSI6G = parcelRequire("jSI6G");

var $5FkrB = parcelRequire("5FkrB");
var $792ea2b9575fffb7$var$useCallback = $5FkrB.useCallback, $792ea2b9575fffb7$var$useRef = $5FkrB.useRef, $792ea2b9575fffb7$var$useState = $5FkrB.useState;

var $7eKmg = parcelRequire("7eKmg");
var $792ea2b9575fffb7$var$fetchQuery = $7eKmg.__internal.fetchQuery, $792ea2b9575fffb7$var$createOperationDescriptor = $7eKmg.createOperationDescriptor, $792ea2b9575fffb7$var$getPaginationVariables = $7eKmg.getPaginationVariables, $792ea2b9575fffb7$var$getRefetchMetadata = $7eKmg.getRefetchMetadata, $792ea2b9575fffb7$var$getSelector = $7eKmg.getSelector;
parcelRequire("2OmBw");
function $792ea2b9575fffb7$var$useLoadMoreFunction_EXPERIMENTAL(args) {
    var direction = args.direction, fragmentNode = args.fragmentNode, fragmentRef = args.fragmentRef, fragmentIdentifier = args.fragmentIdentifier, fragmentData = args.fragmentData, connectionPathInFragmentData = args.connectionPathInFragmentData, paginationRequest = args.paginationRequest, paginationMetadata = args.paginationMetadata, componentDisplayName = args.componentDisplayName, observer = args.observer, onReset = args.onReset;
    var environment = $23TM5();
    var _getRefetchMetadata = $792ea2b9575fffb7$var$getRefetchMetadata(fragmentNode, componentDisplayName), identifierInfo = _getRefetchMetadata.identifierInfo;
    var identifierValue = (identifierInfo === null || identifierInfo === void 0 ? void 0 : identifierInfo.identifierField) != null && fragmentData != null && typeof fragmentData === 'object' ? fragmentData[identifierInfo.identifierField] : null;
    var fetchStatusRef = $792ea2b9575fffb7$var$useRef({
        kind: 'none'
    });
    var _useState = $792ea2b9575fffb7$var$useState(environment), mirroredEnvironment = _useState[0], setMirroredEnvironment = _useState[1];
    var _useState2 = $792ea2b9575fffb7$var$useState(fragmentIdentifier), mirroredFragmentIdentifier = _useState2[0], setMirroredFragmentIdentifier = _useState2[1];
    var isParentQueryActive = $8FFuF(fragmentNode, fragmentRef);
    var forceDisposeFn = $792ea2b9575fffb7$var$useCallback(function() {
        if (fetchStatusRef.current.kind === 'fetching') fetchStatusRef.current.subscription.unsubscribe();
        fetchStatusRef.current = {
            kind: 'none'
        };
    }, []);
    var shouldReset = environment !== mirroredEnvironment || fragmentIdentifier !== mirroredFragmentIdentifier;
    if (shouldReset) {
        forceDisposeFn();
        onReset();
        setMirroredEnvironment(environment);
        setMirroredFragmentIdentifier(fragmentIdentifier);
    }
    var _getConnectionState = $e356D(direction, fragmentNode, fragmentData, connectionPathInFragmentData), cursor = _getConnectionState.cursor, hasMore = _getConnectionState.hasMore;
    var isRequestInvalid = fragmentData == null || isParentQueryActive;
    var isMountedRef = $7rvkY();
    var loadMore = $792ea2b9575fffb7$var$useCallback(function(count, options) {
        var onComplete = options === null || options === void 0 ? void 0 : options.onComplete;
        if (isMountedRef.current !== true) return {
            dispose: function dispose() {}
        };
        var fragmentSelector = $792ea2b9575fffb7$var$getSelector(fragmentNode, fragmentRef);
        if (fetchStatusRef.current.kind === 'fetching' || isRequestInvalid) {
            fragmentSelector;
            if (onComplete) onComplete(null);
            return {
                dispose: function dispose() {}
            };
        }
        !(fragmentSelector != null && fragmentSelector.kind !== 'PluralReaderSelector') && $jSI6G(false);
        var parentVariables = fragmentSelector.owner.variables;
        var fragmentVariables = fragmentSelector.variables;
        var extraVariables = options === null || options === void 0 ? void 0 : options.UNSTABLE_extraVariables;
        var baseVariables = (0, $792ea2b9575fffb7$var$_objectSpread2["default"])((0, $792ea2b9575fffb7$var$_objectSpread2["default"])({}, parentVariables), fragmentVariables);
        var paginationVariables = $792ea2b9575fffb7$var$getPaginationVariables(direction, count, cursor, baseVariables, (0, $792ea2b9575fffb7$var$_objectSpread2["default"])({}, extraVariables), paginationMetadata);
        if (identifierInfo != null) {
            typeof identifierValue;
            paginationVariables[identifierInfo.identifierQueryVariableName] = identifierValue;
        }
        var paginationQuery = $792ea2b9575fffb7$var$createOperationDescriptor(paginationRequest, paginationVariables, {
            force: true
        });
        $792ea2b9575fffb7$var$fetchQuery(environment, paginationQuery).subscribe((0, $792ea2b9575fffb7$var$_objectSpread2["default"])((0, $792ea2b9575fffb7$var$_objectSpread2["default"])({}, observer), {}, {
            start: function start(subscription) {
                fetchStatusRef.current = {
                    kind: 'fetching',
                    subscription: subscription
                };
                observer.start && observer.start(subscription);
            },
            complete: function complete() {
                fetchStatusRef.current = {
                    kind: 'none'
                };
                observer.complete && observer.complete();
                onComplete && onComplete(null);
            },
            error: function error(_error) {
                fetchStatusRef.current = {
                    kind: 'none'
                };
                observer.complete && observer.complete();
                onComplete && onComplete(_error);
            }
        }));
        return {
            dispose: function dispose() {}
        };
    }, [
        environment,
        identifierValue,
        direction,
        cursor,
        isRequestInvalid,
        fragmentNode.name,
        fragmentRef,
        componentDisplayName
    ]);
    return [
        loadMore,
        hasMore,
        forceDisposeFn
    ];
}
module.exports = $792ea2b9575fffb7$var$useLoadMoreFunction_EXPERIMENTAL;

});


parcelRegister("lX5nK", function(module, exports) {
'use strict';

var $drPJO = parcelRequire("drPJO");
var $ffb3486ee2b44a05$var$_interopRequireDefault = $drPJO.default;

var $ffb3486ee2b44a05$var$_objectSpread2 = $ffb3486ee2b44a05$var$_interopRequireDefault((parcelRequire("5OKtB")));

var $j5zXq = parcelRequire("j5zXq");

var $gELTa = parcelRequire("gELTa");
var $ffb3486ee2b44a05$var$getQueryResourceForEnvironment = $gELTa.getQueryResourceForEnvironment;

var $4Nq1J = parcelRequire("4Nq1J");

var $3R4z1 = parcelRequire("3R4z1");

var $7rvkY = parcelRequire("7rvkY");

var $gMQkI = parcelRequire("gMQkI");

var $23TM5 = parcelRequire("23TM5");

var $jSI6G = parcelRequire("jSI6G");

var $5FkrB = parcelRequire("5FkrB");
var $ffb3486ee2b44a05$var$useCallback = $5FkrB.useCallback, $ffb3486ee2b44a05$var$useContext = $5FkrB.useContext, $ffb3486ee2b44a05$var$useReducer = $5FkrB.useReducer;

var $7eKmg = parcelRequire("7eKmg");
var $ffb3486ee2b44a05$var$fetchQuery = $7eKmg.__internal.fetchQuery, $ffb3486ee2b44a05$var$createOperationDescriptor = $7eKmg.createOperationDescriptor, $ffb3486ee2b44a05$var$getFragmentIdentifier = $7eKmg.getFragmentIdentifier, $ffb3486ee2b44a05$var$getRefetchMetadata = $7eKmg.getRefetchMetadata, $ffb3486ee2b44a05$var$getSelector = $7eKmg.getSelector, $ffb3486ee2b44a05$var$getValueAtPath = $7eKmg.getValueAtPath;
parcelRequire("2OmBw");
function $ffb3486ee2b44a05$var$reducer(state, action) {
    switch(action.type){
        case 'refetch':
            var _action$refetchEnviro;
            return (0, $ffb3486ee2b44a05$var$_objectSpread2["default"])((0, $ffb3486ee2b44a05$var$_objectSpread2["default"])({}, state), {}, {
                fetchPolicy: action.fetchPolicy,
                mirroredEnvironment: (_action$refetchEnviro = action.refetchEnvironment) !== null && _action$refetchEnviro !== void 0 ? _action$refetchEnviro : state.mirroredEnvironment,
                onComplete: action.onComplete,
                refetchEnvironment: action.refetchEnvironment,
                refetchQuery: action.refetchQuery,
                renderPolicy: action.renderPolicy
            });
        case 'reset':
            return {
                fetchPolicy: undefined,
                mirroredEnvironment: action.environment,
                mirroredFragmentIdentifier: action.fragmentIdentifier,
                onComplete: undefined,
                refetchQuery: null,
                renderPolicy: undefined
            };
        default:
            action.type;
            throw new Error('useRefetchableFragmentNode: Unexpected action type');
    }
}
function $ffb3486ee2b44a05$var$useRefetchableFragmentInternal(fragmentNode, parentFragmentRef, componentDisplayName) {
    var parentEnvironment = $23TM5();
    var _getRefetchMetadata = $ffb3486ee2b44a05$var$getRefetchMetadata(fragmentNode, componentDisplayName), refetchableRequest = _getRefetchMetadata.refetchableRequest, fragmentRefPathInResponse = _getRefetchMetadata.fragmentRefPathInResponse, identifierInfo = _getRefetchMetadata.identifierInfo;
    var fragmentIdentifier = $ffb3486ee2b44a05$var$getFragmentIdentifier(fragmentNode, parentFragmentRef);
    var _useReducer = $ffb3486ee2b44a05$var$useReducer($ffb3486ee2b44a05$var$reducer, {
        fetchPolicy: undefined,
        mirroredEnvironment: parentEnvironment,
        mirroredFragmentIdentifier: fragmentIdentifier,
        onComplete: undefined,
        refetchEnvironment: null,
        refetchQuery: null,
        renderPolicy: undefined
    }), refetchState = _useReducer[0], dispatch = _useReducer[1];
    var fetchPolicy = refetchState.fetchPolicy, mirroredEnvironment = refetchState.mirroredEnvironment, mirroredFragmentIdentifier = refetchState.mirroredFragmentIdentifier, onComplete = refetchState.onComplete, refetchEnvironment = refetchState.refetchEnvironment, refetchQuery = refetchState.refetchQuery, renderPolicy = refetchState.renderPolicy;
    var environment = refetchEnvironment !== null && refetchEnvironment !== void 0 ? refetchEnvironment : parentEnvironment;
    var QueryResource = $ffb3486ee2b44a05$var$getQueryResourceForEnvironment(environment);
    var profilerContext = $ffb3486ee2b44a05$var$useContext($j5zXq);
    var shouldReset = environment !== mirroredEnvironment || fragmentIdentifier !== mirroredFragmentIdentifier;
    var _useQueryLoader = $gMQkI(refetchableRequest), queryRef = _useQueryLoader[0], loadQuery = _useQueryLoader[1], disposeQuery = _useQueryLoader[2];
    var fragmentRef = parentFragmentRef;
    if (shouldReset) {
        dispatch({
            environment: environment,
            fragmentIdentifier: fragmentIdentifier,
            type: 'reset'
        });
        disposeQuery();
    } else if (refetchQuery != null && queryRef != null) {
        var debugPreviousIDAndTypename;
        var handleQueryCompleted = function handleQueryCompleted(maybeError) {
            onComplete && onComplete(maybeError !== null && maybeError !== void 0 ? maybeError : null);
        };
        var fetchObservable = queryRef.source != null ? queryRef.source : $ffb3486ee2b44a05$var$fetchQuery(environment, refetchQuery);
        var queryResult = profilerContext.wrapPrepareQueryResource(function() {
            return QueryResource.prepare(refetchQuery, fetchObservable, fetchPolicy, renderPolicy, {
                complete: function complete() {
                    handleQueryCompleted();
                },
                error: handleQueryCompleted
            }, queryRef.fetchKey, profilerContext);
        });
        var queryData = $4Nq1J(environment, queryResult.fragmentNode, queryResult.fragmentRef, componentDisplayName).data;
        !(queryData != null) && $jSI6G(false);
        var refetchedFragmentRef = $ffb3486ee2b44a05$var$getValueAtPath(queryData, fragmentRefPathInResponse);
        fragmentRef = refetchedFragmentRef;
    }
    var fragmentData = $3R4z1(fragmentNode, fragmentRef, componentDisplayName);
    var refetch = $ffb3486ee2b44a05$var$useRefetchFunction(componentDisplayName, dispatch, disposeQuery, fragmentData, fragmentIdentifier, fragmentNode, fragmentRefPathInResponse, identifierInfo, loadQuery, parentFragmentRef, refetchableRequest);
    return {
        fragmentData: fragmentData,
        fragmentRef: fragmentRef,
        refetch: refetch
    };
}
function $ffb3486ee2b44a05$var$useRefetchFunction(componentDisplayName, dispatch, disposeQuery, fragmentData, fragmentIdentifier, fragmentNode, fragmentRefPathInResponse, identifierInfo, loadQuery, parentFragmentRef, refetchableRequest) {
    var isMountedRef = $7rvkY();
    var identifierValue = (identifierInfo === null || identifierInfo === void 0 ? void 0 : identifierInfo.identifierField) != null && fragmentData != null && typeof fragmentData === 'object' ? fragmentData[identifierInfo.identifierField] : null;
    return $ffb3486ee2b44a05$var$useCallback(function(providedRefetchVariables, options) {
        if (isMountedRef.current !== true) return {
            dispose: function dispose() {}
        };
        parentFragmentRef;
        var refetchEnvironment = options === null || options === void 0 ? void 0 : options.__environment;
        var fetchPolicy = options === null || options === void 0 ? void 0 : options.fetchPolicy;
        var renderPolicy = options === null || options === void 0 ? void 0 : options.UNSTABLE_renderPolicy;
        var onComplete = options === null || options === void 0 ? void 0 : options.onComplete;
        var fragmentSelector = $ffb3486ee2b44a05$var$getSelector(fragmentNode, parentFragmentRef);
        var parentVariables;
        var fragmentVariables;
        if (fragmentSelector == null) {
            parentVariables = {};
            fragmentVariables = {};
        } else if (fragmentSelector.kind === 'PluralReaderSelector') {
            var _fragmentSelector$sel, _fragmentSelector$sel2, _fragmentSelector$sel3, _fragmentSelector$sel4;
            parentVariables = (_fragmentSelector$sel = (_fragmentSelector$sel2 = fragmentSelector.selectors[0]) === null || _fragmentSelector$sel2 === void 0 ? void 0 : _fragmentSelector$sel2.owner.variables) !== null && _fragmentSelector$sel !== void 0 ? _fragmentSelector$sel : {};
            fragmentVariables = (_fragmentSelector$sel3 = (_fragmentSelector$sel4 = fragmentSelector.selectors[0]) === null || _fragmentSelector$sel4 === void 0 ? void 0 : _fragmentSelector$sel4.variables) !== null && _fragmentSelector$sel3 !== void 0 ? _fragmentSelector$sel3 : {};
        } else {
            parentVariables = fragmentSelector.owner.variables;
            fragmentVariables = fragmentSelector.variables;
        }
        var refetchVariables = (0, $ffb3486ee2b44a05$var$_objectSpread2["default"])((0, $ffb3486ee2b44a05$var$_objectSpread2["default"])((0, $ffb3486ee2b44a05$var$_objectSpread2["default"])({}, parentVariables), fragmentVariables), providedRefetchVariables);
        if (identifierInfo != null && !providedRefetchVariables.hasOwnProperty(identifierInfo.identifierQueryVariableName)) {
            typeof identifierValue;
            refetchVariables[identifierInfo.identifierQueryVariableName] = identifierValue;
        }
        var refetchQuery = $ffb3486ee2b44a05$var$createOperationDescriptor(refetchableRequest, refetchVariables, {
            force: true
        });
        loadQuery(refetchQuery.request.variables, {
            __environment: refetchEnvironment,
            __nameForWarning: 'refetch',
            fetchPolicy: fetchPolicy
        });
        dispatch({
            fetchPolicy: fetchPolicy,
            onComplete: onComplete,
            refetchEnvironment: refetchEnvironment,
            refetchQuery: refetchQuery,
            renderPolicy: renderPolicy,
            type: 'refetch'
        });
        return {
            dispose: disposeQuery
        };
    }, [
        fragmentIdentifier,
        dispatch,
        disposeQuery,
        identifierValue,
        loadQuery
    ]);
}
var $ffb3486ee2b44a05$var$debugFunctions;
module.exports = $ffb3486ee2b44a05$var$useRefetchableFragmentInternal;

});
parcelRegister("4Nq1J", function(module, exports) {
'use strict';

var $drPJO = parcelRequire("drPJO");
var $37dfed6c2741fcdd$var$_interopRequireDefault = $drPJO.default;

var $37dfed6c2741fcdd$var$_objectSpread2 = $37dfed6c2741fcdd$var$_interopRequireDefault((parcelRequire("5OKtB")));

var $37dfed6c2741fcdd$var$_createForOfIteratorHelper2 = $37dfed6c2741fcdd$var$_interopRequireDefault((parcelRequire("jLbXI")));

var $gELTa = parcelRequire("gELTa");
var $37dfed6c2741fcdd$var$getQueryResourceForEnvironment = $gELTa.getQueryResourceForEnvironment;

var $jSI6G = parcelRequire("jSI6G");

var $7eKmg = parcelRequire("7eKmg");
var $37dfed6c2741fcdd$var$fetchQueryInternal = $7eKmg.__internal.fetchQuery, $37dfed6c2741fcdd$var$RelayFeatureFlags = $7eKmg.RelayFeatureFlags, $37dfed6c2741fcdd$var$createOperationDescriptor = $7eKmg.createOperationDescriptor, $37dfed6c2741fcdd$var$getPendingOperationsForFragment = $7eKmg.getPendingOperationsForFragment, $37dfed6c2741fcdd$var$getSelector = $7eKmg.getSelector, $37dfed6c2741fcdd$var$getVariablesFromFragment = $7eKmg.getVariablesFromFragment, $37dfed6c2741fcdd$var$handlePotentialSnapshotErrors = $7eKmg.handlePotentialSnapshotErrors;
parcelRequire("2OmBw");
function $37dfed6c2741fcdd$var$isMissingData(state) {
    if (state.kind === 'bailout') return false;
    else if (state.kind === 'singular') return state.snapshot.isMissingData;
    else return state.snapshots.some(function(s) {
        return s.isMissingData;
    });
}
function $37dfed6c2741fcdd$var$getMissingClientEdges(state) {
    if (state.kind === 'bailout') return null;
    else if (state.kind === 'singular') {
        var _state$snapshot$missi;
        return (_state$snapshot$missi = state.snapshot.missingClientEdges) !== null && _state$snapshot$missi !== void 0 ? _state$snapshot$missi : null;
    } else {
        var edges = null;
        var _iterator = (0, $37dfed6c2741fcdd$var$_createForOfIteratorHelper2["default"])(state.snapshots), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var snapshot = _step.value;
                if (snapshot.missingClientEdges) {
                    var _edges;
                    edges = (_edges = edges) !== null && _edges !== void 0 ? _edges : [];
                    var _iterator2 = (0, $37dfed6c2741fcdd$var$_createForOfIteratorHelper2["default"])(snapshot.missingClientEdges), _step2;
                    try {
                        for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                            var edge = _step2.value;
                            edges.push(edge);
                        }
                    } catch (err) {
                        _iterator2.e(err);
                    } finally{
                        _iterator2.f();
                    }
                }
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
        return edges;
    }
}
function $37dfed6c2741fcdd$var$handlePotentialSnapshotErrorsForState(environment, state) {
    if (state.kind === 'singular') $37dfed6c2741fcdd$var$handlePotentialSnapshotErrors(environment, state.snapshot.fieldErrors);
    else if (state.kind === 'plural') {
        var _iterator3 = (0, $37dfed6c2741fcdd$var$_createForOfIteratorHelper2["default"])(state.snapshots), _step3;
        try {
            for(_iterator3.s(); !(_step3 = _iterator3.n()).done;){
                var snapshot = _step3.value;
                $37dfed6c2741fcdd$var$handlePotentialSnapshotErrors(environment, snapshot.fieldErrors);
            }
        } catch (err) {
            _iterator3.e(err);
        } finally{
            _iterator3.f();
        }
    }
}
function $37dfed6c2741fcdd$var$handleMissingClientEdge(environment, parentFragmentNode, parentFragmentRef, missingClientEdgeRequestInfo, queryOptions) {
    var originalVariables = $37dfed6c2741fcdd$var$getVariablesFromFragment(parentFragmentNode, parentFragmentRef);
    var variables = (0, $37dfed6c2741fcdd$var$_objectSpread2["default"])((0, $37dfed6c2741fcdd$var$_objectSpread2["default"])({}, originalVariables), {}, {
        id: missingClientEdgeRequestInfo.clientEdgeDestinationID
    });
    var queryOperationDescriptor = $37dfed6c2741fcdd$var$createOperationDescriptor(missingClientEdgeRequestInfo.request, variables, queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.networkCacheConfig);
    var QueryResource = $37dfed6c2741fcdd$var$getQueryResourceForEnvironment(environment);
    return QueryResource.prepare(queryOperationDescriptor, $37dfed6c2741fcdd$var$fetchQueryInternal(environment, queryOperationDescriptor), queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.fetchPolicy);
}
function $37dfed6c2741fcdd$var$getFragmentState(environment, fragmentSelector) {
    if (fragmentSelector == null) return {
        kind: 'bailout'
    };
    else if (fragmentSelector.kind === 'PluralReaderSelector') {
        if (fragmentSelector.selectors.length === 0) return {
            kind: 'bailout'
        };
        else return {
            epoch: environment.getStore().getEpoch(),
            kind: 'plural',
            snapshots: fragmentSelector.selectors.map(function(s) {
                return environment.lookup(s);
            })
        };
    } else return {
        epoch: environment.getStore().getEpoch(),
        kind: 'singular',
        snapshot: environment.lookup(fragmentSelector)
    };
}
function $37dfed6c2741fcdd$var$readFragmentInternal(environment, fragmentNode, fragmentRef, hookDisplayName, queryOptions, fragmentKey) {
    var _fragmentNode$metadat, _fragmentNode$metadat2;
    var fragmentSelector = $37dfed6c2741fcdd$var$getSelector(fragmentNode, fragmentRef);
    var isPlural = (fragmentNode === null || fragmentNode === void 0 ? void 0 : (_fragmentNode$metadat = fragmentNode.metadata) === null || _fragmentNode$metadat === void 0 ? void 0 : _fragmentNode$metadat.plural) === true;
    if (isPlural) !(fragmentRef == null || Array.isArray(fragmentRef)) && $jSI6G(false);
    else !!Array.isArray(fragmentRef) && $jSI6G(false);
    !(fragmentRef == null || isPlural && Array.isArray(fragmentRef) && fragmentRef.length === 0 || fragmentSelector != null) && $jSI6G(false);
    var state = $37dfed6c2741fcdd$var$getFragmentState(environment, fragmentSelector);
    var clientEdgeQueries = null;
    if (((_fragmentNode$metadat2 = fragmentNode.metadata) === null || _fragmentNode$metadat2 === void 0 ? void 0 : _fragmentNode$metadat2.hasClientEdges) === true || $37dfed6c2741fcdd$var$RelayFeatureFlags.CHECK_ALL_FRAGMENTS_FOR_MISSING_CLIENT_EDGES) {
        var missingClientEdges = $37dfed6c2741fcdd$var$getMissingClientEdges(state);
        if (missingClientEdges !== null && missingClientEdges !== void 0 && missingClientEdges.length) {
            clientEdgeQueries = [];
            var _iterator4 = (0, $37dfed6c2741fcdd$var$_createForOfIteratorHelper2["default"])(missingClientEdges), _step4;
            try {
                for(_iterator4.s(); !(_step4 = _iterator4.n()).done;){
                    var edge = _step4.value;
                    clientEdgeQueries.push($37dfed6c2741fcdd$var$handleMissingClientEdge(environment, fragmentNode, fragmentRef, edge, queryOptions));
                }
            } catch (err) {
                _iterator4.e(err);
            } finally{
                _iterator4.f();
            }
        }
    }
    if ($37dfed6c2741fcdd$var$isMissingData(state)) {
        !(fragmentSelector != null) && $jSI6G(false);
        var fragmentOwner = fragmentSelector.kind === 'PluralReaderSelector' ? fragmentSelector.selectors[0].owner : fragmentSelector.owner;
        var pendingOperationsResult = $37dfed6c2741fcdd$var$getPendingOperationsForFragment(environment, fragmentNode, fragmentOwner);
        if (pendingOperationsResult) throw pendingOperationsResult.promise;
        $37dfed6c2741fcdd$var$handlePotentialSnapshotErrorsForState(environment, state);
    }
    var data;
    if (state.kind === 'bailout') data = isPlural ? [] : null;
    else if (state.kind === 'singular') data = state.snapshot.data;
    else data = state.snapshots.map(function(s) {
        return s.data;
    });
    if ($37dfed6c2741fcdd$var$RelayFeatureFlags.LOG_MISSING_RECORDS_IN_PROD || false) fragmentRef != null && (data === undefined || Array.isArray(data) && data.length > 0 && data.every(function(d) {
        return d === undefined;
    }));
    return {
        clientEdgeQueries: clientEdgeQueries,
        data: data
    };
}
module.exports = $37dfed6c2741fcdd$var$readFragmentInternal;

});

parcelRegister("gMQkI", function(module, exports) {
'use strict';

var $drPJO = parcelRequire("drPJO");
var $c389b94f64cbe1a4$var$_interopRequireDefault = $drPJO.default;

var $c389b94f64cbe1a4$var$_createForOfIteratorHelper2 = $c389b94f64cbe1a4$var$_interopRequireDefault((parcelRequire("jLbXI")));

var $ejfNK = parcelRequire("ejfNK");
var $c389b94f64cbe1a4$var$loadQuery = $ejfNK.loadQuery;

var $7rvkY = parcelRequire("7rvkY");

var $dWYL4 = parcelRequire("dWYL4");

var $23TM5 = parcelRequire("23TM5");

var $5FkrB = parcelRequire("5FkrB");
var $c389b94f64cbe1a4$var$useCallback = $5FkrB.useCallback, $c389b94f64cbe1a4$var$useEffect = $5FkrB.useEffect, $c389b94f64cbe1a4$var$useRef = $5FkrB.useRef, $c389b94f64cbe1a4$var$useState = $5FkrB.useState;

var $7eKmg = parcelRequire("7eKmg");
var $c389b94f64cbe1a4$var$RelayFeatureFlags = $7eKmg.RelayFeatureFlags, $c389b94f64cbe1a4$var$getRequest = $7eKmg.getRequest;
var $c389b94f64cbe1a4$var$initialNullQueryReferenceState = {
    kind: 'NullQueryReference'
};
function $c389b94f64cbe1a4$var$requestIsLiveQuery(preloadableRequest) {
    if (preloadableRequest.kind === 'PreloadableConcreteRequest') return preloadableRequest.params.metadata.live !== undefined;
    var request = $c389b94f64cbe1a4$var$getRequest(preloadableRequest);
    return request.params.metadata.live !== undefined;
}
function $c389b94f64cbe1a4$var$useQueryLoader(preloadableRequest, initialQueryReference) {
    if ($c389b94f64cbe1a4$var$RelayFeatureFlags.ENABLE_ACTIVITY_COMPATIBILITY) return $dWYL4(preloadableRequest, initialQueryReference);
    return $c389b94f64cbe1a4$var$useQueryLoader_CURRENT(preloadableRequest, initialQueryReference);
}
function $c389b94f64cbe1a4$var$useQueryLoader_CURRENT(preloadableRequest, initialQueryReference) {
    var initialQueryReferenceInternal = initialQueryReference !== null && initialQueryReference !== void 0 ? initialQueryReference : $c389b94f64cbe1a4$var$initialNullQueryReferenceState;
    var environment = $23TM5();
    var isMountedRef = $7rvkY();
    var undisposedQueryReferencesRef = $c389b94f64cbe1a4$var$useRef(new Set([
        initialQueryReferenceInternal
    ]));
    var _useState = $c389b94f64cbe1a4$var$useState(function() {
        return initialQueryReferenceInternal;
    }), queryReference = _useState[0], setQueryReference = _useState[1];
    var _useState2 = $c389b94f64cbe1a4$var$useState(function() {
        return initialQueryReferenceInternal;
    }), previousInitialQueryReference = _useState2[0], setPreviousInitialQueryReference = _useState2[1];
    if (initialQueryReferenceInternal !== previousInitialQueryReference) {
        undisposedQueryReferencesRef.current.add(initialQueryReferenceInternal);
        setPreviousInitialQueryReference(initialQueryReferenceInternal);
        setQueryReference(initialQueryReferenceInternal);
    }
    var disposeQuery = $c389b94f64cbe1a4$var$useCallback(function() {
        if (isMountedRef.current) {
            undisposedQueryReferencesRef.current.add($c389b94f64cbe1a4$var$initialNullQueryReferenceState);
            setQueryReference($c389b94f64cbe1a4$var$initialNullQueryReferenceState);
        }
    }, [
        isMountedRef
    ]);
    var queryLoaderCallback = $c389b94f64cbe1a4$var$useCallback(function(variables, options) {
        var mergedOptions = options != null && options.hasOwnProperty('__environment') ? {
            __nameForWarning: options.__nameForWarning,
            fetchPolicy: options.fetchPolicy,
            networkCacheConfig: options.networkCacheConfig
        } : options;
        if (isMountedRef.current) {
            var _options$__environmen;
            var updatedQueryReference = $c389b94f64cbe1a4$var$loadQuery((_options$__environmen = options === null || options === void 0 ? void 0 : options.__environment) !== null && _options$__environmen !== void 0 ? _options$__environmen : environment, preloadableRequest, variables, mergedOptions);
            undisposedQueryReferencesRef.current.add(updatedQueryReference);
            setQueryReference(updatedQueryReference);
        }
    }, [
        environment,
        preloadableRequest,
        setQueryReference,
        isMountedRef
    ]);
    var maybeHiddenOrFastRefresh = $c389b94f64cbe1a4$var$useRef(false);
    $c389b94f64cbe1a4$var$useEffect(function() {
        return function() {
            maybeHiddenOrFastRefresh.current = true;
        };
    }, []);
    $c389b94f64cbe1a4$var$useEffect(function() {
        if (maybeHiddenOrFastRefresh.current === true) {
            maybeHiddenOrFastRefresh.current = false;
            if (queryReference.kind !== 'NullQueryReference') queryLoaderCallback(queryReference.variables, {
                fetchPolicy: queryReference.fetchPolicy,
                networkCacheConfig: queryReference.networkCacheConfig
            });
            return;
        }
        var undisposedQueryReferences = undisposedQueryReferencesRef.current;
        if (isMountedRef.current) {
            var _iterator = (0, $c389b94f64cbe1a4$var$_createForOfIteratorHelper2["default"])(undisposedQueryReferences), _step;
            try {
                for(_iterator.s(); !(_step = _iterator.n()).done;){
                    var undisposedQueryReference = _step.value;
                    if (undisposedQueryReference === queryReference) break;
                    undisposedQueryReferences["delete"](undisposedQueryReference);
                    if (undisposedQueryReference.kind !== 'NullQueryReference') {
                        if ($c389b94f64cbe1a4$var$requestIsLiveQuery(preloadableRequest)) undisposedQueryReference.dispose && undisposedQueryReference.dispose();
                        else undisposedQueryReference.releaseQuery && undisposedQueryReference.releaseQuery();
                    }
                }
            } catch (err) {
                _iterator.e(err);
            } finally{
                _iterator.f();
            }
        }
    }, [
        queryReference,
        isMountedRef,
        queryLoaderCallback,
        preloadableRequest
    ]);
    $c389b94f64cbe1a4$var$useEffect(function() {
        return function disposeAllRemainingQueryReferences() {
            var _iterator2 = (0, $c389b94f64cbe1a4$var$_createForOfIteratorHelper2["default"])(undisposedQueryReferencesRef.current), _step2;
            try {
                for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                    var undisposedQueryReference = _step2.value;
                    if (undisposedQueryReference.kind !== 'NullQueryReference') {
                        if ($c389b94f64cbe1a4$var$requestIsLiveQuery(preloadableRequest)) undisposedQueryReference.dispose && undisposedQueryReference.dispose();
                        else undisposedQueryReference.releaseQuery && undisposedQueryReference.releaseQuery();
                    }
                }
            } catch (err) {
                _iterator2.e(err);
            } finally{
                _iterator2.f();
            }
        };
    }, [
        preloadableRequest
    ]);
    return [
        queryReference.kind === 'NullQueryReference' ? null : queryReference,
        queryLoaderCallback,
        disposeQuery
    ];
}
module.exports = $c389b94f64cbe1a4$var$useQueryLoader;

});
parcelRegister("dWYL4", function(module, exports) {
'use strict';

var $drPJO = parcelRequire("drPJO");
var $a27fd2799bdaf045$var$_interopRequireDefault = $drPJO.default;

var $a27fd2799bdaf045$var$_createForOfIteratorHelper2 = $a27fd2799bdaf045$var$_interopRequireDefault((parcelRequire("jLbXI")));

var $ejfNK = parcelRequire("ejfNK");
var $a27fd2799bdaf045$var$loadQuery = $ejfNK.loadQuery;

var $7rvkY = parcelRequire("7rvkY");

var $23TM5 = parcelRequire("23TM5");

var $5FkrB = parcelRequire("5FkrB");
var $a27fd2799bdaf045$var$useCallback = $5FkrB.useCallback, $a27fd2799bdaf045$var$useEffect = $5FkrB.useEffect, $a27fd2799bdaf045$var$useInsertionEffect = $5FkrB.useInsertionEffect, $a27fd2799bdaf045$var$useRef = $5FkrB.useRef, $a27fd2799bdaf045$var$useState = $5FkrB.useState;

var $7eKmg = parcelRequire("7eKmg");
var $a27fd2799bdaf045$var$getRequest = $7eKmg.getRequest;
var $a27fd2799bdaf045$var$initialNullQueryReferenceState = {
    kind: 'NullQueryReference'
};
function $a27fd2799bdaf045$var$requestIsLiveQuery(preloadableRequest) {
    if (preloadableRequest.kind === 'PreloadableConcreteRequest') return preloadableRequest.params.metadata.live !== undefined;
    var request = $a27fd2799bdaf045$var$getRequest(preloadableRequest);
    return request.params.metadata.live !== undefined;
}
var $a27fd2799bdaf045$var$CLEANUP_TIMEOUT = 300000;
function $a27fd2799bdaf045$var$useQueryLoader_EXPERIMENTAL(preloadableRequest, initialQueryReference) {
    var initialQueryReferenceInternal = initialQueryReference !== null && initialQueryReference !== void 0 ? initialQueryReference : $a27fd2799bdaf045$var$initialNullQueryReferenceState;
    var environment = $23TM5();
    var isMountedRef = $7rvkY();
    var undisposedQueryReferencesRef = $a27fd2799bdaf045$var$useRef(null);
    if (undisposedQueryReferencesRef.current == null) undisposedQueryReferencesRef.current = new Set([
        initialQueryReferenceInternal
    ]);
    var _useState = $a27fd2799bdaf045$var$useState(function() {
        return initialQueryReferenceInternal;
    }), queryReference = _useState[0], setQueryReference = _useState[1];
    var _useState2 = $a27fd2799bdaf045$var$useState(function() {
        return initialQueryReferenceInternal;
    }), previousInitialQueryReference = _useState2[0], setPreviousInitialQueryReference = _useState2[1];
    if (initialQueryReferenceInternal !== previousInitialQueryReference) {
        var _undisposedQueryRefer;
        (_undisposedQueryRefer = undisposedQueryReferencesRef.current) === null || _undisposedQueryRefer === void 0 || _undisposedQueryRefer.add(initialQueryReferenceInternal);
        setPreviousInitialQueryReference(initialQueryReferenceInternal);
        setQueryReference(initialQueryReferenceInternal);
    }
    var disposeQuery = $a27fd2799bdaf045$var$useCallback(function() {
        if (isMountedRef.current) {
            var _undisposedQueryRefer2;
            (_undisposedQueryRefer2 = undisposedQueryReferencesRef.current) === null || _undisposedQueryRefer2 === void 0 || _undisposedQueryRefer2.add($a27fd2799bdaf045$var$initialNullQueryReferenceState);
            setQueryReference($a27fd2799bdaf045$var$initialNullQueryReferenceState);
        }
    }, [
        isMountedRef
    ]);
    var queryLoaderCallback = $a27fd2799bdaf045$var$useCallback(function(variables, options) {
        var _options$__environmen, _undisposedQueryRefer3;
        if (!isMountedRef.current) return;
        var mergedOptions = options != null && options.hasOwnProperty('__environment') ? {
            __nameForWarning: options.__nameForWarning,
            fetchPolicy: options.fetchPolicy,
            networkCacheConfig: options.networkCacheConfig
        } : options;
        var updatedQueryReference = $a27fd2799bdaf045$var$loadQuery((_options$__environmen = options === null || options === void 0 ? void 0 : options.__environment) !== null && _options$__environmen !== void 0 ? _options$__environmen : environment, preloadableRequest, variables, mergedOptions);
        (_undisposedQueryRefer3 = undisposedQueryReferencesRef.current) === null || _undisposedQueryRefer3 === void 0 || _undisposedQueryRefer3.add(updatedQueryReference);
        setQueryReference(updatedQueryReference);
    }, [
        environment,
        preloadableRequest,
        setQueryReference,
        isMountedRef
    ]);
    var disposeAllRemainingQueryReferences = $a27fd2799bdaf045$var$useCallback(function disposeAllRemainingQueryReferences(preloadableRequest, currentQueryReference) {
        var _undisposedQueryRefer4;
        var undisposedQueryReferences = (_undisposedQueryRefer4 = undisposedQueryReferencesRef.current) !== null && _undisposedQueryRefer4 !== void 0 ? _undisposedQueryRefer4 : new Set();
        var _iterator = (0, $a27fd2799bdaf045$var$_createForOfIteratorHelper2["default"])(undisposedQueryReferences), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var undisposedQueryReference = _step.value;
                if (undisposedQueryReference === currentQueryReference) continue;
                if (undisposedQueryReference.kind !== 'NullQueryReference') {
                    if ($a27fd2799bdaf045$var$requestIsLiveQuery(preloadableRequest)) undisposedQueryReference.dispose && undisposedQueryReference.dispose();
                    else undisposedQueryReference.releaseQuery && undisposedQueryReference.releaseQuery();
                }
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
    }, []);
    var cleanupTimerRef = $a27fd2799bdaf045$var$useRef(null);
    $a27fd2799bdaf045$var$useEffect(function() {
        disposeAllRemainingQueryReferences(preloadableRequest, queryReference);
        if (cleanupTimerRef.current != null) {
            clearTimeout(cleanupTimerRef.current);
            cleanupTimerRef.current = null;
        }
        return function() {
            cleanupTimerRef.current = setTimeout(function() {
                disposeAllRemainingQueryReferences(preloadableRequest, null);
            }, $a27fd2799bdaf045$var$CLEANUP_TIMEOUT);
        };
    }, [
        preloadableRequest,
        queryReference
    ]);
    $a27fd2799bdaf045$var$useInsertionEffect(function() {
        return function() {
            cleanupTimerRef.current && clearTimeout(cleanupTimerRef.current);
            cleanupTimerRef.current = null;
            disposeAllRemainingQueryReferences(preloadableRequest, null);
        };
    }, [
        preloadableRequest
    ]);
    return [
        queryReference.kind === 'NullQueryReference' ? null : queryReference,
        queryLoaderCallback,
        disposeQuery
    ];
}
module.exports = $a27fd2799bdaf045$var$useQueryLoader_EXPERIMENTAL;

});




parcelRegister("8QvNU", function(module, exports) {
'use strict';

var $drPJO = parcelRequire("drPJO");
var $670bd9aa2dfef216$var$_interopRequireDefault = $drPJO.default;

var $670bd9aa2dfef216$var$_objectSpread2 = $670bd9aa2dfef216$var$_interopRequireDefault((parcelRequire("5OKtB")));

var $lelUi = parcelRequire("lelUi");

var $tXmd3 = parcelRequire("tXmd3");

var $lX5nK = parcelRequire("lX5nK");

var $23TM5 = parcelRequire("23TM5");

var $a68UM = parcelRequire("a68UM");

var $jSI6G = parcelRequire("jSI6G");

var $5FkrB = parcelRequire("5FkrB");
var $670bd9aa2dfef216$var$useCallback = $5FkrB.useCallback, $670bd9aa2dfef216$var$useDebugValue = $5FkrB.useDebugValue, $670bd9aa2dfef216$var$useEffect = $5FkrB.useEffect, $670bd9aa2dfef216$var$useLayoutEffect = $5FkrB.useLayoutEffect, $670bd9aa2dfef216$var$useMemo = $5FkrB.useMemo, $670bd9aa2dfef216$var$useRef = $5FkrB.useRef, $670bd9aa2dfef216$var$useState = $5FkrB.useState;

var $7eKmg = parcelRequire("7eKmg");
var $670bd9aa2dfef216$var$getFragment = $7eKmg.getFragment, $670bd9aa2dfef216$var$getFragmentIdentifier = $7eKmg.getFragmentIdentifier, $670bd9aa2dfef216$var$getPaginationMetadata = $7eKmg.getPaginationMetadata;

var $7eKmg = parcelRequire("7eKmg");
var $670bd9aa2dfef216$var$ConnectionInterface = $7eKmg.ConnectionInterface, $670bd9aa2dfef216$var$RelayFeatureFlags = $7eKmg.RelayFeatureFlags, $670bd9aa2dfef216$var$getSelector = $7eKmg.getSelector, $670bd9aa2dfef216$var$getValueAtPath = $7eKmg.getValueAtPath;
function $670bd9aa2dfef216$var$usePrefetchableForwardPaginationFragment(fragmentInput, parentFragmentRef, bufferSize, initialSize, prefetchingLoadMoreOptions) {
    var _fragmentInput$metada, _fragmentInput$metada2;
    var minimalFetchSize = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 1;
    var disablePrefetching = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : false;
    var fragmentNode = $670bd9aa2dfef216$var$getFragment(fragmentInput);
    $a68UM(fragmentNode, 'first argument of usePrefetchableForwardPaginationFragment()');
    var componentDisplayName = 'usePrefetchableForwardPaginationFragment()';
    var _getPaginationMetadat = $670bd9aa2dfef216$var$getPaginationMetadata(fragmentNode, componentDisplayName), connectionPathInFragmentData = _getPaginationMetadat.connectionPathInFragmentData, paginationRequest = _getPaginationMetadat.paginationRequest, paginationMetadata = _getPaginationMetadat.paginationMetadata;
    var _useRefetchableFragme = $lX5nK(fragmentNode, parentFragmentRef, componentDisplayName), fragmentData = _useRefetchableFragme.fragmentData, fragmentRef = _useRefetchableFragme.fragmentRef, refetch = _useRefetchableFragme.refetch;
    var fragmentIdentifier = $670bd9aa2dfef216$var$getFragmentIdentifier(fragmentNode, fragmentRef);
    var edgeKeys = $670bd9aa2dfef216$var$useMemo(function() {
        var connection = $670bd9aa2dfef216$var$getValueAtPath(fragmentData, connectionPathInFragmentData);
        if (connection == null) return null;
        var _ConnectionInterface$ = $670bd9aa2dfef216$var$ConnectionInterface.get(), EDGES = _ConnectionInterface$.EDGES;
        return connection[EDGES];
    }, [
        connectionPathInFragmentData,
        fragmentData
    ]);
    var sourceSize = edgeKeys == null ? -1 : edgeKeys.length;
    var _useState = $670bd9aa2dfef216$var$useState(initialSize != null ? initialSize : sourceSize), _numInUse = _useState[0], setNumInUse = _useState[1];
    var numInUse = _numInUse;
    if (_numInUse === -1 && sourceSize !== -1) {
        numInUse = initialSize != null ? initialSize : sourceSize;
        setNumInUse(numInUse);
    }
    var environment = $23TM5();
    var _useState2 = $670bd9aa2dfef216$var$useState(false), isLoadingMore = _useState2[0], reallySetIsLoadingMore = _useState2[1];
    var _useState3 = $670bd9aa2dfef216$var$useState(false), isRefetching = _useState3[0], setIsRefetching = _useState3[1];
    var availableSizeRef = $670bd9aa2dfef216$var$useRef(0);
    var setIsLoadingMore = $670bd9aa2dfef216$var$useCallback(function(value) {
        var _environment$getSched;
        var schedule = (_environment$getSched = environment.getScheduler()) === null || _environment$getSched === void 0 ? void 0 : _environment$getSched.schedule;
        if (schedule) schedule(function() {
            reallySetIsLoadingMore(value);
        });
        else reallySetIsLoadingMore(value);
    }, [
        environment
    ]);
    var isLoadingMoreRef = $670bd9aa2dfef216$var$useRef(false);
    var observer = $670bd9aa2dfef216$var$useMemo(function() {
        function setIsLoadingFalse() {
            isLoadingMoreRef.current = false;
            setIsLoadingMore(false);
        }
        return {
            start: function start() {
                isLoadingMoreRef.current = true;
                reallySetIsLoadingMore(true);
            },
            complete: setIsLoadingFalse,
            error: setIsLoadingFalse,
            unsubscribe: $670bd9aa2dfef216$var$RelayFeatureFlags.ENABLE_USE_PAGINATION_IS_LOADING_FIX ? setIsLoadingFalse : undefined
        };
    }, [
        setIsLoadingMore
    ]);
    var handleReset = $670bd9aa2dfef216$var$useCallback(function() {
        if (!isRefetching) {
            var _environment$getSched2;
            var schedule = (_environment$getSched2 = environment.getScheduler()) === null || _environment$getSched2 === void 0 ? void 0 : _environment$getSched2.schedule;
            if (schedule) schedule(function() {
                setNumInUse(-1);
            });
            else setNumInUse(-1);
        }
        isLoadingMoreRef.current = false;
        setIsLoadingMore(false);
    }, [
        environment,
        isRefetching,
        setIsLoadingMore
    ]);
    var _useLoadMoreFunction = $tXmd3({
        componentDisplayName: componentDisplayName,
        connectionPathInFragmentData: connectionPathInFragmentData,
        direction: 'forward',
        fragmentData: fragmentData,
        fragmentIdentifier: fragmentIdentifier,
        fragmentNode: fragmentNode,
        fragmentRef: fragmentRef,
        paginationMetadata: paginationMetadata,
        paginationRequest: paginationRequest,
        observer: observer,
        onReset: handleReset
    }), loadMore = _useLoadMoreFunction[0], hasNext = _useLoadMoreFunction[1], disposeFetchNext = _useLoadMoreFunction[2];
    $670bd9aa2dfef216$var$useLayoutEffect(function() {
        availableSizeRef.current = sourceSize - numInUse;
    }, [
        numInUse,
        sourceSize
    ]);
    var prefetchingUNSTABLE_extraVariables = prefetchingLoadMoreOptions === null || prefetchingLoadMoreOptions === void 0 ? void 0 : prefetchingLoadMoreOptions.UNSTABLE_extraVariables;
    var prefetchingOnComplete = prefetchingLoadMoreOptions === null || prefetchingLoadMoreOptions === void 0 ? void 0 : prefetchingLoadMoreOptions.onComplete;
    var showMore = $670bd9aa2dfef216$var$useCallback(function(numToAdd, options) {
        if (!isLoadingMoreRef.current || availableSizeRef.current >= 0) {
            availableSizeRef.current -= numToAdd;
            setNumInUse(function(lastNumInUse) {
                return lastNumInUse + numToAdd;
            });
            if (!isLoadingMoreRef.current && availableSizeRef.current < 0) loadMore(Math.max(minimalFetchSize, Math.min(numToAdd, bufferSize - availableSizeRef.current)), options !== null && options !== void 0 ? options : {
                onComplete: prefetchingOnComplete,
                UNSTABLE_extraVariables: typeof prefetchingUNSTABLE_extraVariables === 'function' ? prefetchingUNSTABLE_extraVariables({
                    hasNext: hasNext,
                    data: fragmentData,
                    getServerEdges: function getServerEdges() {
                        var selector = $670bd9aa2dfef216$var$getSelector(edgesFragment, edgeKeys);
                        if (selector == null) return [];
                        !(selector.kind === 'PluralReaderSelector') && $jSI6G(false);
                        return selector.selectors.map(function(sel) {
                            return environment.lookup(sel).data;
                        });
                    }
                }) : prefetchingUNSTABLE_extraVariables
            });
        }
    }, [
        bufferSize,
        loadMore,
        minimalFetchSize,
        edgeKeys,
        fragmentData,
        prefetchingUNSTABLE_extraVariables,
        prefetchingOnComplete
    ]);
    var edgesFragment = (_fragmentInput$metada = fragmentInput.metadata) === null || _fragmentInput$metada === void 0 ? void 0 : (_fragmentInput$metada2 = _fragmentInput$metada.refetch) === null || _fragmentInput$metada2 === void 0 ? void 0 : _fragmentInput$metada2.edgesFragment;
    !(edgesFragment != null) && $jSI6G(false);
    $670bd9aa2dfef216$var$useEffect(function() {
        if (!isLoadingMoreRef.current && !isLoadingMore && !isRefetching && !disablePrefetching && hasNext && (sourceSize - numInUse < bufferSize || numInUse > sourceSize)) {
            var onComplete = prefetchingOnComplete;
            loadMore(Math.max(bufferSize - Math.max(sourceSize - numInUse, 0), numInUse - sourceSize, minimalFetchSize), {
                onComplete: onComplete,
                UNSTABLE_extraVariables: typeof prefetchingUNSTABLE_extraVariables === 'function' ? prefetchingUNSTABLE_extraVariables({
                    hasNext: hasNext,
                    data: fragmentData,
                    getServerEdges: function getServerEdges() {
                        var selector = $670bd9aa2dfef216$var$getSelector(edgesFragment, edgeKeys);
                        if (selector == null) return [];
                        !(selector.kind === 'PluralReaderSelector') && $jSI6G(false);
                        return selector.selectors.map(function(sel) {
                            return environment.lookup(sel).data;
                        });
                    }
                }) : prefetchingUNSTABLE_extraVariables
            });
        }
    }, [
        hasNext,
        bufferSize,
        isRefetching,
        loadMore,
        numInUse,
        prefetchingUNSTABLE_extraVariables,
        prefetchingOnComplete,
        sourceSize,
        edgeKeys,
        isLoadingMore,
        minimalFetchSize,
        environment,
        edgesFragment
    ]);
    var realNumInUse = Math.min(numInUse, sourceSize);
    var derivedEdgeKeys = $670bd9aa2dfef216$var$useMemo(function() {
        var _edgeKeys$slice;
        return (_edgeKeys$slice = edgeKeys === null || edgeKeys === void 0 ? void 0 : edgeKeys.slice(0, realNumInUse)) !== null && _edgeKeys$slice !== void 0 ? _edgeKeys$slice : [];
    }, [
        edgeKeys,
        realNumInUse
    ]);
    var edges = $lelUi(edgesFragment, derivedEdgeKeys);
    var refetchPagination = $670bd9aa2dfef216$var$useCallback(function(variables, options) {
        disposeFetchNext();
        setIsRefetching(true);
        return refetch(variables, (0, $670bd9aa2dfef216$var$_objectSpread2["default"])((0, $670bd9aa2dfef216$var$_objectSpread2["default"])({}, options), {}, {
            onComplete: function onComplete(maybeError) {
                var _environment$getSched3, _options$onComplete;
                var schedule = (_environment$getSched3 = environment.getScheduler()) === null || _environment$getSched3 === void 0 ? void 0 : _environment$getSched3.schedule;
                if (schedule) schedule(function() {
                    setIsRefetching(false);
                    setNumInUse(-1);
                });
                else {
                    setIsRefetching(false);
                    setNumInUse(-1);
                }
                options === null || options === void 0 || (_options$onComplete = options.onComplete) === null || _options$onComplete === void 0 || _options$onComplete.call(options, maybeError);
            },
            __environment: undefined
        }));
    }, [
        disposeFetchNext,
        environment,
        refetch
    ]);
    return {
        edges: edges,
        data: fragmentData,
        loadNext: showMore,
        hasNext: hasNext || sourceSize > numInUse,
        isLoadingNext: isLoadingMore && numInUse > sourceSize,
        refetch: refetchPagination
    };
}
module.exports = $670bd9aa2dfef216$var$usePrefetchableForwardPaginationFragment;

});

parcelRegister("ff9zd", function(module, exports) {
'use strict';

var $bJ98H = parcelRequire("bJ98H");

var $96WbG = parcelRequire("96WbG");

var $23TM5 = parcelRequire("23TM5");

var $jSI6G = parcelRequire("jSI6G");

var $5FkrB = parcelRequire("5FkrB");
var $b18fad860b15b23b$var$useDebugValue = $5FkrB.useDebugValue;

var $7eKmg = parcelRequire("7eKmg");
var $b18fad860b15b23b$var$_require2$__internal = $7eKmg.__internal, $b18fad860b15b23b$var$fetchQueryDeduped = $b18fad860b15b23b$var$_require2$__internal.fetchQueryDeduped, $b18fad860b15b23b$var$fetchQuery = $b18fad860b15b23b$var$_require2$__internal.fetchQuery;
parcelRequire("2OmBw");
function $b18fad860b15b23b$var$usePreloadedQuery(gqlQuery, preloadedQuery, options) {
    var environment = $23TM5();
    var operation = $96WbG(gqlQuery, preloadedQuery != null ? preloadedQuery.variables : {}, preloadedQuery != null ? preloadedQuery.networkCacheConfig : undefined);
    var useLazyLoadQueryNodeParams;
    if (preloadedQuery != null) {
        var fetchKey = preloadedQuery.fetchKey, fetchPolicy = preloadedQuery.fetchPolicy, source = preloadedQuery.source;
        if (preloadedQuery.kind === 'PreloadedQuery_DEPRECATED') {
            !(operation.request.node.params.name === preloadedQuery.name) && $jSI6G(false);
            useLazyLoadQueryNodeParams = {
                componentDisplayName: 'usePreloadedQuery()',
                fetchKey: fetchKey,
                fetchObservable: $b18fad860b15b23b$var$fetchQueryDeduped(environment, operation.request.identifier, function() {
                    if (environment === preloadedQuery.environment && source != null) return environment.executeWithSource({
                        operation: operation,
                        source: source
                    });
                    else return environment.execute({
                        operation: operation
                    });
                }),
                fetchPolicy: fetchPolicy,
                query: operation,
                renderPolicy: options === null || options === void 0 ? void 0 : options.UNSTABLE_renderPolicy
            };
        } else {
            var fallbackFetchObservable = $b18fad860b15b23b$var$fetchQuery(environment, operation);
            var fetchObservable;
            if (source != null && environment === preloadedQuery.environment) fetchObservable = source.ifEmpty(fallbackFetchObservable);
            else if (environment !== preloadedQuery.environment) fetchObservable = fallbackFetchObservable;
            else fetchObservable = fallbackFetchObservable;
            useLazyLoadQueryNodeParams = {
                componentDisplayName: 'usePreloadedQuery()',
                fetchKey: fetchKey,
                fetchObservable: fetchObservable,
                fetchPolicy: fetchPolicy,
                query: operation,
                renderPolicy: options === null || options === void 0 ? void 0 : options.UNSTABLE_renderPolicy
            };
        }
    } else useLazyLoadQueryNodeParams = {
        componentDisplayName: 'usePreloadedQuery()',
        fragmentNode: gqlQuery.fragment
    };
    var data = $bJ98H(useLazyLoadQueryNodeParams);
    return data;
}
module.exports = $b18fad860b15b23b$var$usePreloadedQuery;

});

parcelRegister("jxUnU", function(module, exports) {
'use strict';

var $lX5nK = parcelRequire("lX5nK");

var $a68UM = parcelRequire("a68UM");

var $5FkrB = parcelRequire("5FkrB");
var $e3acd62d940da7be$var$useDebugValue = $5FkrB.useDebugValue;

var $7eKmg = parcelRequire("7eKmg");
var $e3acd62d940da7be$var$getFragment = $7eKmg.getFragment;
function $e3acd62d940da7be$var$useRefetchableFragment(fragmentInput, fragmentRef) {
    var fragmentNode = $e3acd62d940da7be$var$getFragment(fragmentInput);
    $a68UM(fragmentNode, 'first argument of useRefetchableFragment()');
    var _useRefetchableFragme = $lX5nK(fragmentNode, fragmentRef, 'useRefetchableFragment()'), fragmentData = _useRefetchableFragme.fragmentData, refetch = _useRefetchableFragme.refetch;
    return [
        fragmentData,
        refetch
    ];
}
module.exports = $e3acd62d940da7be$var$useRefetchableFragment;

});

parcelRegister("lSDJw", function(module, exports) {
'use strict';

var $23TM5 = parcelRequire("23TM5");

var $5FkrB = parcelRequire("5FkrB");
var $fedd764dc0886d53$var$useEffect = $5FkrB.useEffect, $fedd764dc0886d53$var$useRef = $5FkrB.useRef;
function $fedd764dc0886d53$var$useSubscribeToInvalidationState(dataIDs, callback) {
    var environment = $23TM5();
    var disposableRef = $fedd764dc0886d53$var$useRef(null);
    var stableDataIDs = Array.from(dataIDs).sort().join('');
    $fedd764dc0886d53$var$useEffect(function() {
        var store = environment.getStore();
        var invalidationState = store.lookupInvalidationState(dataIDs);
        var disposable = store.subscribeToInvalidationState(invalidationState, callback);
        disposableRef.current = disposable;
        return function() {
            return disposable.dispose();
        };
    }, [
        stableDataIDs,
        callback,
        environment
    ]);
    return {
        dispose: function dispose() {
            if (disposableRef.current != null) disposableRef.current.dispose();
        }
    };
}
module.exports = $fedd764dc0886d53$var$useSubscribeToInvalidationState;

});

parcelRegister("5UwvI", function(module, exports) {
'use strict';

var $23TM5 = parcelRequire("23TM5");

var $5FkrB = parcelRequire("5FkrB");
var $44db66a536213dc8$var$useEffect = $5FkrB.useEffect;

var $7eKmg = parcelRequire("7eKmg");
var $44db66a536213dc8$var$requestSubscription = $7eKmg.requestSubscription;
function $44db66a536213dc8$var$useSubscription(config, requestSubscriptionFn) {
    var actualRequestSubscription = requestSubscriptionFn !== null && requestSubscriptionFn !== void 0 ? requestSubscriptionFn : $44db66a536213dc8$var$requestSubscription;
    var environment = $23TM5();
    $44db66a536213dc8$var$useEffect(function() {
        var _actualRequestSubscri = actualRequestSubscription(environment, config), dispose = _actualRequestSubscri.dispose;
        return dispose;
    }, [
        environment,
        config,
        actualRequestSubscription
    ]);
}
module.exports = $44db66a536213dc8$var$useSubscription;

});



parcelRegister("cdkZR", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => (parcelRequire("cCsHK")).default);
$parcel$export(module.exports, "Icon", () => (parcelRequire("cCsHK")).Icon);
/**
 * @deprecated Import from the generated per-export subpath instead.
 */ 
var $cCsHK = parcelRequire("cCsHK");
 /**
 * @deprecated Import from the generated per-export subpath instead.
 */ 
});
parcelRegister("cCsHK", function(module, exports) {
$parcel$export(module.exports, "Icon", () => $92ff4ccad01912e1$export$f04a61298a47a40f);
$parcel$export(module.exports, "default", () => $92ff4ccad01912e1$export$2e2bcd8739ae039);
/* icon-new.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $5FkrB = parcelRequire("5FkrB");

var $3DL6y = parcelRequire("3DL6y");
/**
 * We are hiding this props from consumers as it's reserved for use by Icon Tile.
 */ var $92ff4ccad01912e1$var$svgStyles = null;
var $92ff4ccad01912e1$var$iconStyles = null;
var $92ff4ccad01912e1$var$smallIconStyles = null;
var $92ff4ccad01912e1$var$scaleStyles = null;
/**
 * For windows high contrast mode
 */ var $92ff4ccad01912e1$var$baseHcmStyles = null;
var $92ff4ccad01912e1$var$scaleSize = null;
var $92ff4ccad01912e1$var$coreSizeMedium = {
    none: "_1bsbpxbi _4t3ipxbi",
    compact: "_1bsb1ejb _4t3i1ejb",
    spacious: "_1bsb1ejb _4t3i1ejb"
};
var $92ff4ccad01912e1$var$coreSizeSmall = {
    none: "_1bsbutpp _4t3iutpp",
    compact: "_1bsbpxbi _4t3ipxbi",
    spacious: "_1bsb1ejb _4t3i1ejb"
};
var $92ff4ccad01912e1$var$paddingMap = {
    medium: {
        none: 0,
        compact: 4,
        spacious: 4
    },
    small: {
        none: 0,
        compact: 2.66,
        spacious: 8
    }
};
var $92ff4ccad01912e1$export$f04a61298a47a40f = /*#__PURE__*/ (0, $5FkrB.memo)(function Icon(props) {
    var _ref = props, _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, testId = _ref.testId, label = _ref.label, dangerouslySetGlyph = _ref.dangerouslySetGlyph, shouldScale = _ref.shouldScale, _ref$spacing = _ref.spacing, spacing = _ref$spacing === void 0 ? 'none' : _ref$spacing, name = _ref.name;
    var dangerouslySetInnerHTML = dangerouslySetGlyph ? {
        __html: dangerouslySetGlyph
    } : undefined;
    var size = 'medium';
    if ('size' in props && props.size !== undefined) {
        if (typeof props.size === 'string') size = props.size === 'small' || props.size === 'medium' ? props.size : size;
        else if (name) {
            var newSize = props.size(name);
            size = newSize === 'small' || newSize === 'medium' ? newSize : size;
        }
    }
    var baseSize = 16;
    var viewBoxPadding = $92ff4ccad01912e1$var$paddingMap[size][spacing];
    var viewBoxSize = baseSize + 2 * viewBoxPadding;
    return /*#__PURE__*/ $5FkrB.createElement("span", {
        "data-testid": testId,
        role: label ? 'img' : undefined,
        "aria-label": label ? label : undefined,
        "aria-hidden": label ? undefined : true,
        style: {
            color: color
        },
        className: (0, $3DL6y.default)([
            "_1e0c1o8l _vchhusvi _1o9zidpf _vwz4kb7n _y4ti1igz _bozg1mb9",
            "_12va1onz _jcxd1r8n",
            shouldScale && "_1bsb1kw7 _4t3i1kw7",
            size === 'small' && "_vwz4utpp"
        ])
    }, /*#__PURE__*/ $5FkrB.createElement("svg", {
        fill: "none",
        viewBox: "".concat(0 - viewBoxPadding, " ").concat(0 - viewBoxPadding, " ").concat(viewBoxSize, " ").concat(viewBoxSize),
        role: "presentation",
        dangerouslySetInnerHTML: dangerouslySetInnerHTML,
        className: (0, $3DL6y.default)([
            "_1reo15vq _18m915vq _syaz1r31 _lcxvglyw _s7n4yfq0 _vc881r31",
            shouldScale ? "_1bsb1kw7 _4t3i1kw7" : size === 'small' ? $92ff4ccad01912e1$var$coreSizeSmall[spacing] : $92ff4ccad01912e1$var$coreSizeMedium[spacing]
        ])
    }));
});
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$92ff4ccad01912e1$export$2e2bcd8739ae039 = $92ff4ccad01912e1$export$f04a61298a47a40f;

});
parcelRegister("3DL6y", function(module, exports) {
$parcel$export(module.exports, "default", () => $2a698d9d525d1184$export$2e2bcd8739ae039);
/**
 * The length of the value hash portion of an atomic class name.
 * Atomic class names have the format: `_<group><value>`
 * where group is ATOMIC_GROUP_HASH_LENGTH chars and value is ATOMIC_VALUE_HASH_LENGTH chars.
 *
 * We extract the group key using: `className.slice(0, className.length - ATOMIC_VALUE_HASH_LENGTH)`
 *
 * We support both old-format classes (9 chars: `_` + 4 group + 4 value) and
 * new-format classes (11 chars: `_` + 6 group + 4 value) by using length-based
 * extraction rather than a hardcoded offset — old and new format group keys
 * are different lengths so they are structurally disjoint and never alias each other.
 */ const $2a698d9d525d1184$var$ATOMIC_VALUE_HASH_LENGTH = 4;
function $2a698d9d525d1184$export$2e2bcd8739ae039(classNames) {
    // Shortcut: nothing to do
    if (!classNames.length) return;
    // Shortcut: don't need to do anything if we only have a single classname
    if (classNames.length === 1 && classNames[0] && // checking to see if `classNames[0]` is a string that contains other classnames
    !classNames[0].includes(' ')) return classNames[0];
    // Using an object rather than a `Map` as it performed better in our benchmarks.
    // Would be happy to move to `Map` if it proved to be better under real conditions.
    const map = {};
    // Note: using loops to minimize iterations over the collection
    for (const value of classNames){
        // Exclude all falsy values, which leaves us with populated strings
        if (!value) continue;
        // a `value` can contain multiple classnames
        const list = value.split(' ');
        for (const className of list){
            /**
             * For atomic style classnames: the `key` is the `group`
             *
             * - Later atomic classnames with the same `group` will override earlier ones
             *   (which is what we want).
             * - Assumes atomic classnames are the only things that start with `_`
             * - Could use a regex to ensure that atomic classnames are structured how we expect,
             *   but did not add that for now as it did slow things down a bit.
             *
             * For other classnames: the `key` is the whole classname
             * - Okay to remove duplicates as doing so does not impact specificity
             *
             * */ const key = className.startsWith('_') ? className.slice(0, className.length - $2a698d9d525d1184$var$ATOMIC_VALUE_HASH_LENGTH) : className;
            map[key] = className;
        }
    }
    /**
     * We are converting the `map` into a string.
     *
     * The simple way to do this would be `Object.values(map).join(' ')`.
     * However, the approach below performs 10%-20% better in benchmarks.
     *
     * For `ax()` it feels right to squeeze as much runtime performance out as we can.
     */ let result = '';
    for(const key in map)result += map[key] + ' ';
    // If we have an empty string, then our `map` was empty.
    if (!result) return;
    // remove last " " from the result (we added " " at the end of every value)
    return result.trimEnd();
}

});



parcelRegister("jcbQ2", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => (parcelRequire("37Yt2")).default);
$parcel$export(module.exports, "Icon", () => (parcelRequire("37Yt2")).Icon);
/**
 * @deprecated Import from the generated per-export subpath instead.
 */ 
var $37Yt2 = parcelRequire("37Yt2");
 /**
 * @deprecated Import from the generated per-export subpath instead.
 */ 
});
parcelRegister("37Yt2", function(module, exports) {
$parcel$export(module.exports, "Icon", () => $2470ee1dc0edd8c8$export$f04a61298a47a40f);
$parcel$export(module.exports, "default", () => $2470ee1dc0edd8c8$export$2e2bcd8739ae039);
/* icon-new.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $5FkrB = parcelRequire("5FkrB");

var $ceTz3 = parcelRequire("ceTz3");
/**
 * We are hiding this props from consumers as it's reserved for use by Icon Tile.
 */ var $2470ee1dc0edd8c8$var$svgStyles = null;
var $2470ee1dc0edd8c8$var$iconStyles = null;
var $2470ee1dc0edd8c8$var$smallIconStyles = null;
var $2470ee1dc0edd8c8$var$scaleStyles = null;
/**
 * For windows high contrast mode
 */ var $2470ee1dc0edd8c8$var$baseHcmStyles = null;
var $2470ee1dc0edd8c8$var$scaleSize = null;
var $2470ee1dc0edd8c8$var$coreSizeMedium = {
    none: "_1bsbpxbi _4t3ipxbi",
    compact: "_1bsb1ejb _4t3i1ejb",
    spacious: "_1bsb1ejb _4t3i1ejb"
};
var $2470ee1dc0edd8c8$var$coreSizeSmall = {
    none: "_1bsbutpp _4t3iutpp",
    compact: "_1bsbpxbi _4t3ipxbi",
    spacious: "_1bsb1ejb _4t3i1ejb"
};
var $2470ee1dc0edd8c8$var$paddingMap = {
    medium: {
        none: 0,
        compact: 4,
        spacious: 4
    },
    small: {
        none: 0,
        compact: 2.66,
        spacious: 8
    }
};
var $2470ee1dc0edd8c8$export$f04a61298a47a40f = /*#__PURE__*/ (0, $5FkrB.memo)(function Icon(props) {
    var _ref = props, _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, testId = _ref.testId, label = _ref.label, dangerouslySetGlyph = _ref.dangerouslySetGlyph, shouldScale = _ref.shouldScale, _ref$spacing = _ref.spacing, spacing = _ref$spacing === void 0 ? 'none' : _ref$spacing, name = _ref.name;
    var dangerouslySetInnerHTML = dangerouslySetGlyph ? {
        __html: dangerouslySetGlyph
    } : undefined;
    var size = 'medium';
    if ('size' in props && props.size !== undefined) {
        if (typeof props.size === 'string') size = props.size === 'small' || props.size === 'medium' ? props.size : size;
        else if (name) {
            var newSize = props.size(name);
            size = newSize === 'small' || newSize === 'medium' ? newSize : size;
        }
    }
    var baseSize = 16;
    var viewBoxPadding = $2470ee1dc0edd8c8$var$paddingMap[size][spacing];
    var viewBoxSize = baseSize + 2 * viewBoxPadding;
    return /*#__PURE__*/ $5FkrB.createElement("span", {
        "data-testid": testId,
        role: label ? 'img' : undefined,
        "aria-label": label ? label : undefined,
        "aria-hidden": label ? undefined : true,
        style: {
            color: color
        },
        className: (0, $ceTz3.default)([
            "_1e0c1o8l _vchhusvi _1o9zidpf _vwz4kb7n _y4ti1igz _bozg1mb9",
            "_12va1onz _jcxd1r8n",
            shouldScale && "_1bsb1kw7 _4t3i1kw7",
            size === 'small' && "_vwz4utpp"
        ])
    }, /*#__PURE__*/ $5FkrB.createElement("svg", {
        fill: "none",
        viewBox: "".concat(0 - viewBoxPadding, " ").concat(0 - viewBoxPadding, " ").concat(viewBoxSize, " ").concat(viewBoxSize),
        role: "presentation",
        dangerouslySetInnerHTML: dangerouslySetInnerHTML,
        className: (0, $ceTz3.default)([
            "_1reo15vq _18m915vq _syaz1r31 _lcxvglyw _s7n4yfq0 _vc881r31",
            shouldScale ? "_1bsb1kw7 _4t3i1kw7" : size === 'small' ? $2470ee1dc0edd8c8$var$coreSizeSmall[spacing] : $2470ee1dc0edd8c8$var$coreSizeMedium[spacing]
        ])
    }));
});
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$2470ee1dc0edd8c8$export$2e2bcd8739ae039 = $2470ee1dc0edd8c8$export$f04a61298a47a40f;

});
parcelRegister("ceTz3", function(module, exports) {
$parcel$export(module.exports, "default", () => $8e91e4c29ef7a9af$export$2e2bcd8739ae039);
/**
 * The length of the value hash portion of an atomic class name.
 * Atomic class names have the format: `_<group><value>`
 * where group is ATOMIC_GROUP_HASH_LENGTH chars and value is ATOMIC_VALUE_HASH_LENGTH chars.
 *
 * We extract the group key using: `className.slice(0, className.length - ATOMIC_VALUE_HASH_LENGTH)`
 *
 * We support both old-format classes (9 chars: `_` + 4 group + 4 value) and
 * new-format classes (11 chars: `_` + 6 group + 4 value) by using length-based
 * extraction rather than a hardcoded offset — old and new format group keys
 * are different lengths so they are structurally disjoint and never alias each other.
 */ const $8e91e4c29ef7a9af$var$ATOMIC_VALUE_HASH_LENGTH = 4;
function $8e91e4c29ef7a9af$export$2e2bcd8739ae039(classNames) {
    // Shortcut: nothing to do
    if (!classNames.length) return;
    // Shortcut: don't need to do anything if we only have a single classname
    if (classNames.length === 1 && classNames[0] && // checking to see if `classNames[0]` is a string that contains other classnames
    !classNames[0].includes(' ')) return classNames[0];
    // Using an object rather than a `Map` as it performed better in our benchmarks.
    // Would be happy to move to `Map` if it proved to be better under real conditions.
    const map = {};
    // Note: using loops to minimize iterations over the collection
    for (const value of classNames){
        // Exclude all falsy values, which leaves us with populated strings
        if (!value) continue;
        // a `value` can contain multiple classnames
        const list = value.split(' ');
        for (const className of list){
            /**
             * For atomic style classnames: the `key` is the `group`
             *
             * - Later atomic classnames with the same `group` will override earlier ones
             *   (which is what we want).
             * - Assumes atomic classnames are the only things that start with `_`
             * - Could use a regex to ensure that atomic classnames are structured how we expect,
             *   but did not add that for now as it did slow things down a bit.
             *
             * For other classnames: the `key` is the whole classname
             * - Okay to remove duplicates as doing so does not impact specificity
             *
             * */ const key = className.startsWith('_') ? className.slice(0, className.length - $8e91e4c29ef7a9af$var$ATOMIC_VALUE_HASH_LENGTH) : className;
            map[key] = className;
        }
    }
    /**
     * We are converting the `map` into a string.
     *
     * The simple way to do this would be `Object.values(map).join(' ')`.
     * However, the approach below performs 10%-20% better in benchmarks.
     *
     * For `ax()` it feels right to squeeze as much runtime performance out as we can.
     */ let result = '';
    for(const key in map)result += map[key] + ' ';
    // If we have an empty string, then our `map` was empty.
    if (!result) return;
    // remove last " " from the result (we added " " at the end of every value)
    return result.trimEnd();
}

});



parcelRegister("4kNYI", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => (parcelRequire("ivhAr")).default);
$parcel$export(module.exports, "Icon", () => (parcelRequire("ivhAr")).Icon);
/**
 * @deprecated Import from the generated per-export subpath instead.
 */ 
var $ivhAr = parcelRequire("ivhAr");
 /**
 * @deprecated Import from the generated per-export subpath instead.
 */ 
});
parcelRegister("ivhAr", function(module, exports) {
$parcel$export(module.exports, "Icon", () => $d788c39db3f7fcff$export$f04a61298a47a40f);
$parcel$export(module.exports, "default", () => $d788c39db3f7fcff$export$2e2bcd8739ae039);
/* icon-new.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $5FkrB = parcelRequire("5FkrB");

var $3KUKI = parcelRequire("3KUKI");
/**
 * We are hiding this props from consumers as it's reserved for use by Icon Tile.
 */ var $d788c39db3f7fcff$var$svgStyles = null;
var $d788c39db3f7fcff$var$iconStyles = null;
var $d788c39db3f7fcff$var$smallIconStyles = null;
var $d788c39db3f7fcff$var$scaleStyles = null;
/**
 * For windows high contrast mode
 */ var $d788c39db3f7fcff$var$baseHcmStyles = null;
var $d788c39db3f7fcff$var$scaleSize = null;
var $d788c39db3f7fcff$var$coreSizeMedium = {
    none: "_1bsbpxbi _4t3ipxbi",
    compact: "_1bsb1ejb _4t3i1ejb",
    spacious: "_1bsb1ejb _4t3i1ejb"
};
var $d788c39db3f7fcff$var$coreSizeSmall = {
    none: "_1bsbutpp _4t3iutpp",
    compact: "_1bsbpxbi _4t3ipxbi",
    spacious: "_1bsb1ejb _4t3i1ejb"
};
var $d788c39db3f7fcff$var$paddingMap = {
    medium: {
        none: 0,
        compact: 4,
        spacious: 4
    },
    small: {
        none: 0,
        compact: 2.66,
        spacious: 8
    }
};
var $d788c39db3f7fcff$export$f04a61298a47a40f = /*#__PURE__*/ (0, $5FkrB.memo)(function Icon(props) {
    var _ref = props, _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, testId = _ref.testId, label = _ref.label, dangerouslySetGlyph = _ref.dangerouslySetGlyph, shouldScale = _ref.shouldScale, _ref$spacing = _ref.spacing, spacing = _ref$spacing === void 0 ? 'none' : _ref$spacing, name = _ref.name;
    var dangerouslySetInnerHTML = dangerouslySetGlyph ? {
        __html: dangerouslySetGlyph
    } : undefined;
    var size = 'medium';
    if ('size' in props && props.size !== undefined) {
        if (typeof props.size === 'string') size = props.size === 'small' || props.size === 'medium' ? props.size : size;
        else if (name) {
            var newSize = props.size(name);
            size = newSize === 'small' || newSize === 'medium' ? newSize : size;
        }
    }
    var baseSize = 16;
    var viewBoxPadding = $d788c39db3f7fcff$var$paddingMap[size][spacing];
    var viewBoxSize = baseSize + 2 * viewBoxPadding;
    return /*#__PURE__*/ $5FkrB.createElement("span", {
        "data-testid": testId,
        role: label ? 'img' : undefined,
        "aria-label": label ? label : undefined,
        "aria-hidden": label ? undefined : true,
        style: {
            color: color
        },
        className: (0, $3KUKI.default)([
            "_1e0c1o8l _vchhusvi _1o9zidpf _vwz4kb7n _y4ti1igz _bozg1mb9",
            "_12va1onz _jcxd1r8n",
            shouldScale && "_1bsb1kw7 _4t3i1kw7",
            size === 'small' && "_vwz4utpp"
        ])
    }, /*#__PURE__*/ $5FkrB.createElement("svg", {
        fill: "none",
        viewBox: "".concat(0 - viewBoxPadding, " ").concat(0 - viewBoxPadding, " ").concat(viewBoxSize, " ").concat(viewBoxSize),
        role: "presentation",
        dangerouslySetInnerHTML: dangerouslySetInnerHTML,
        className: (0, $3KUKI.default)([
            "_1reo15vq _18m915vq _syaz1r31 _lcxvglyw _s7n4yfq0 _vc881r31",
            shouldScale ? "_1bsb1kw7 _4t3i1kw7" : size === 'small' ? $d788c39db3f7fcff$var$coreSizeSmall[spacing] : $d788c39db3f7fcff$var$coreSizeMedium[spacing]
        ])
    }));
});
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$d788c39db3f7fcff$export$2e2bcd8739ae039 = $d788c39db3f7fcff$export$f04a61298a47a40f;

});
parcelRegister("3KUKI", function(module, exports) {
$parcel$export(module.exports, "default", () => $2bc1b0db022dd1f7$export$2e2bcd8739ae039);
/**
 * The length of the value hash portion of an atomic class name.
 * Atomic class names have the format: `_<group><value>`
 * where group is ATOMIC_GROUP_HASH_LENGTH chars and value is ATOMIC_VALUE_HASH_LENGTH chars.
 *
 * We extract the group key using: `className.slice(0, className.length - ATOMIC_VALUE_HASH_LENGTH)`
 *
 * We support both old-format classes (9 chars: `_` + 4 group + 4 value) and
 * new-format classes (11 chars: `_` + 6 group + 4 value) by using length-based
 * extraction rather than a hardcoded offset — old and new format group keys
 * are different lengths so they are structurally disjoint and never alias each other.
 */ const $2bc1b0db022dd1f7$var$ATOMIC_VALUE_HASH_LENGTH = 4;
function $2bc1b0db022dd1f7$export$2e2bcd8739ae039(classNames) {
    // Shortcut: nothing to do
    if (!classNames.length) return;
    // Shortcut: don't need to do anything if we only have a single classname
    if (classNames.length === 1 && classNames[0] && // checking to see if `classNames[0]` is a string that contains other classnames
    !classNames[0].includes(' ')) return classNames[0];
    // Using an object rather than a `Map` as it performed better in our benchmarks.
    // Would be happy to move to `Map` if it proved to be better under real conditions.
    const map = {};
    // Note: using loops to minimize iterations over the collection
    for (const value of classNames){
        // Exclude all falsy values, which leaves us with populated strings
        if (!value) continue;
        // a `value` can contain multiple classnames
        const list = value.split(' ');
        for (const className of list){
            /**
             * For atomic style classnames: the `key` is the `group`
             *
             * - Later atomic classnames with the same `group` will override earlier ones
             *   (which is what we want).
             * - Assumes atomic classnames are the only things that start with `_`
             * - Could use a regex to ensure that atomic classnames are structured how we expect,
             *   but did not add that for now as it did slow things down a bit.
             *
             * For other classnames: the `key` is the whole classname
             * - Okay to remove duplicates as doing so does not impact specificity
             *
             * */ const key = className.startsWith('_') ? className.slice(0, className.length - $2bc1b0db022dd1f7$var$ATOMIC_VALUE_HASH_LENGTH) : className;
            map[key] = className;
        }
    }
    /**
     * We are converting the `map` into a string.
     *
     * The simple way to do this would be `Object.values(map).join(' ')`.
     * However, the approach below performs 10%-20% better in benchmarks.
     *
     * For `ax()` it feels right to squeeze as much runtime performance out as we can.
     */ let result = '';
    for(const key in map)result += map[key] + ' ';
    // If we have an empty string, then our `map` was empty.
    if (!result) return;
    // remove last " " from the result (we added " " at the end of every value)
    return result.trimEnd();
}

});



parcelRegister("90MfH", function(module, exports) {
$parcel$export(module.exports, "ReactMcpContext", () => $144848332446fadd$export$717198317c60be4b);
$parcel$export(module.exports, "useMcpContext", () => $144848332446fadd$export$fd50796ca3528f33);
$parcel$export(module.exports, "McpContextProvider", () => $144848332446fadd$export$623b51d94ab5545b);

var $i3UfC = parcelRequire("i3UfC");

var $5FkrB = parcelRequire("5FkrB");

var $6hgMx = parcelRequire("6hgMx");

var $guDjK = parcelRequire("guDjK");

var $2gmBL = parcelRequire("2gmBL");

var $leM9a = parcelRequire("leM9a");

var $8LFYh = parcelRequire("8LFYh");

var $bcapr = parcelRequire("bcapr");

var $dnJFI = parcelRequire("dnJFI");

var $3jgQd = parcelRequire("3jgQd");

var $f5RPY = parcelRequire("f5RPY");

var $fLAke = parcelRequire("fLAke");

var $f54a7 = parcelRequire("f54a7");

var $ir4ge = parcelRequire("ir4ge");

var $kd2vk = parcelRequire("kd2vk");

var $3UXNA = parcelRequire("3UXNA");

var $h7OTL = parcelRequire("h7OTL");

var $Qy2AT = parcelRequire("Qy2AT");
/**
 * Sent as `selectedWorkspace` when Trello policy has to be evaluated without a
 * workspace, i.e. the member has none but requested account-level Inbox and
 * Planner scopes.
 */ const $144848332446fadd$var$ACCOUNT_LEVEL_TRELLO_POLICY_TARGET = '';
const $144848332446fadd$export$717198317c60be4b = /*#__PURE__*/ (0, $5FkrB.createContext)(null);
const $144848332446fadd$export$fd50796ca3528f33 = ()=>{
    const context = (0, $5FkrB.useContext)($144848332446fadd$export$717198317c60be4b);
    if (!context) throw new Error('useMcpContext must be used within McpContextProvider');
    return context;
};
function $144848332446fadd$var$mergeMcpPolicyIntents(intentGroups) {
    const merged = new Map();
    for (const group of intentGroups){
        const existing = merged.get(group.id);
        if (existing) {
            const existingNames = new Set(existing.toolsets.map((toolset)=>toolset.name));
            const newToolsets = group.toolsets.filter((toolset)=>{
                if (existingNames.has(toolset.name)) return false;
                existingNames.add(toolset.name);
                return true;
            });
            existing.toolsets = [
                ...existing.toolsets,
                ...newToolsets
            ].sort((0, $dnJFI.compareToolsets));
        } else merged.set(group.id, {
            ...group,
            toolsets: [
                ...group.toolsets
            ]
        });
    }
    return (0, $bcapr.MCP_INTENT_ORDER).filter((id)=>merged.has(id)).map((id)=>merged.get(id));
}
// ---------------------------------------------------------------------------
// Provider
// ---------------------------------------------------------------------------
const $144848332446fadd$var$noopLoadMore = ()=>{};
const $144848332446fadd$export$623b51d94ab5545b = ({ children: children, trelloWorkspaces: trelloWorkspaces, trelloWorkspacesLoading: trelloWorkspacesLoading = false, trelloWorkspacesHasMore: trelloWorkspacesHasMore = false, trelloWorkspacesLoadingMore: trelloWorkspacesLoadingMore = false, onLoadMoreTrelloWorkspaces: onLoadMoreTrelloWorkspaces = $144848332446fadd$var$noopLoadMore, recentTrelloWorkspaceIds: recentTrelloWorkspaceIdsOverride })=>{
    const consentContext = (0, $5FkrB.useContext)((0, $6hgMx.ReactConsentContext));
    if (!consentContext) throw new Error('McpContextProvider must be used within ConsentContextProvider');
    const { token: token } = consentContext;
    const info = (0, $6hgMx.useInfo)();
    const forgeAppName = (0, $fLAke.getForgeMcpAppName)(info);
    const analyticsClient = (0, $guDjK.useAnalytics)();
    const { selectedWorkspace: selectedWorkspace } = (0, $6hgMx.useSelectedWorkspace)();
    const jiraDeleteToolsetsEnabled = (0, $2gmBL.useFeatureGate)((0, $leM9a.OAuthConsentFeatureGate).MCP_JIRA_DELETE_TOOLSETS);
    const jiraManageToolsetsEnabled = (0, $2gmBL.useFeatureGate)((0, $leM9a.OAuthConsentFeatureGate).MCP_JIRA_MANAGE_TOOLSETS);
    const [policyState, dispatchPolicy] = (0, $5FkrB.useReducer)((0, $Qy2AT.policyReducer), {
        status: 'idle'
    });
    // Separate policy state for Trello workspace policy check
    const [trelloPolicyState, dispatchTrelloPolicy] = (0, $5FkrB.useReducer)((0, $Qy2AT.policyReducer), {
        status: 'idle'
    });
    const [selectedNames, setSelectedNames] = (0, $5FkrB.useState)(new Set());
    // Trello workspace state
    const [selectedTrelloWorkspaces, setSelectedTrelloWorkspacesState] = (0, $5FkrB.useState)([]);
    // Tracks whether we've already applied the initial workspace prefill, so a
    // user clearing their selection is not immediately overridden.
    const trelloPrefillAppliedRef = (0, $5FkrB.useRef)(false);
    const trelloWorkspaceMultiSelectionEnabled = (0, $2gmBL.useFeatureGate)((0, $leM9a.OAuthConsentFeatureGate).TRELLO_MCP_MULTI_WORKSPACE_SELECTION);
    const trelloMixedWorkspaceEnabled = (0, $2gmBL.useFeatureGate)((0, $leM9a.OAuthConsentFeatureGate).TRELLO_MCP_MIXED_WORKSPACE);
    // Bitbucket workspace selection (available list, selection state, and
    // stale-selection cleanup) lives in a dedicated hook and is folded into the
    // context value below.
    const { isBitbucketWorkspaceAccessEnabled: isBitbucketWorkspaceAccessEnabled, availableBitbucketWorkspaces: availableBitbucketWorkspaces, selectedBitbucketWorkspace: selectedBitbucketWorkspace, setSelectedBitbucketWorkspace: setSelectedBitbucketWorkspace } = (0, $f54a7.useBitbucketWorkspaces)();
    const selectFetchedToolsets = (0, $5FkrB.useCallback)((toolsetNames)=>{
        setSelectedNames((prev)=>{
            const next = new Set(prev);
            for (const name of toolsetNames)next.add(name);
            return next;
        });
    }, []);
    const bitbucketPolicyState = (0, $ir4ge.useBitbucketPolicy)({
        token: token,
        isEnabled: isBitbucketWorkspaceAccessEnabled,
        selectedBitbucketWorkspace: selectedBitbucketWorkspace,
        onToolsetsLoaded: selectFetchedToolsets
    });
    const multiWorkspaceSelectorEnabled = (0, $2gmBL.useFeatureGate)((0, $leM9a.OAuthConsentFeatureGate).MULTI_WORKSPACE_SELECTOR);
    const scopeClassification = (0, $5FkrB.useMemo)(()=>(0, $h7OTL.classifyScopesWithOverride)(token.scopes ?? [], info.hasTrelloProductAccess, trelloMixedWorkspaceEnabled), [
        token.scopes,
        info.hasTrelloProductAccess,
        trelloMixedWorkspaceEnabled
    ]);
    // Site and Bitbucket must grant within a single organization. Compared only
    // when both pickers are in play: a site-only flow has nothing to disagree
    // with, and a Trello-only flow renders no site picker — its hidden
    // auto-selected workspace is not a user choice, so it must never be reported
    // as conflicting.
    const { siteOrgId: siteOrgId, bitbucketOrgId: bitbucketOrgId, hasOrgMismatch: hasOrgMismatch, siteOrgIndex: siteOrgIndex } = (0, $kd2vk.useOrgMatch)({
        applies: isBitbucketWorkspaceAccessEnabled && scopeClassification.hasAtlassian,
        selectedWorkspace: selectedWorkspace,
        selectedBitbucketWorkspace: selectedBitbucketWorkspace
    });
    const trelloRequestedButNoAccess = (0, $5FkrB.useMemo)(()=>{
        const scopes = token.scopes ?? [];
        return (0, $h7OTL.hasTrelloScopes)(scopes) && !(0, $h7OTL.hasAtlassianScopes)(scopes) && info.hasTrelloProductAccess !== true;
    }, [
        token.scopes,
        info.hasTrelloProductAccess
    ]);
    const trelloInboxPlannerScopesRequested = (0, $5FkrB.useMemo)(()=>(0, $h7OTL.hasTrelloInboxPlannerScopes)(token.scopes ?? []), [
        token.scopes
    ]);
    const isTrelloMultiWorkspaceSelectorEnabled = multiWorkspaceSelectorEnabled && !scopeClassification.hasAtlassian;
    const isTrelloWorkspaceMultiSelectEnabled = (trelloWorkspaceMultiSelectionEnabled || multiWorkspaceSelectorEnabled) && !scopeClassification.hasAtlassian;
    const clientName = info.client?.name ?? token.clientName ?? null;
    const maxSelectableTrelloWorkspaces = (0, $5FkrB.useMemo)(()=>{
        const limit = info.maxTrelloWorkspaces;
        if (limit == null || !Number.isFinite(limit) || limit <= 0) return null;
        return Math.floor(limit);
    }, [
        info.maxTrelloWorkspaces
    ]);
    const setSelectedTrelloWorkspaces = (0, $5FkrB.useCallback)((workspaces)=>{
        setSelectedTrelloWorkspacesState(()=>(0, $3UXNA.normalizeTrelloWorkspaceSelection)(workspaces, isTrelloWorkspaceMultiSelectEnabled));
    }, [
        isTrelloWorkspaceMultiSelectEnabled
    ]);
    const user = (0, $f5RPY.useUser)();
    const accountId = user?.account_id ?? null;
    const recentTrelloWorkspaceIds = (0, $5FkrB.useMemo)(()=>{
        if (recentTrelloWorkspaceIdsOverride !== undefined) return recentTrelloWorkspaceIdsOverride;
        if (!isTrelloMultiWorkspaceSelectorEnabled) return [];
        return (0, $3jgQd.readRecentWorkspaceIds)(accountId);
    }, [
        recentTrelloWorkspaceIdsOverride,
        isTrelloMultiWorkspaceSelectorEnabled,
        accountId
    ]);
    const recordConsentedTrelloWorkspaces = (0, $5FkrB.useCallback)(()=>{
        if (!isTrelloMultiWorkspaceSelectorEnabled) return;
        (0, $3jgQd.recordConsentedWorkspaceIds)(accountId, selectedTrelloWorkspaces.map((workspace)=>workspace.id));
    }, [
        isTrelloMultiWorkspaceSelectorEnabled,
        accountId,
        selectedTrelloWorkspaces
    ]);
    // Trello workspaces: use the override prop (tests / Storybook) or fall back
    // to an empty list. In production the parent tree will wrap with a Suspense
    // boundary and call `useTrelloWorkspaces()` from `domain/getTrelloWorkspaces`
    // to populate this via the `trelloWorkspaces` prop.
    // The full list is exposed rather than one narrowed to the current
    // selection's organization. Workspaces that cannot be combined with the
    // selection are disabled by the selector, so the options keep their position
    // instead of disappearing as soon as something is picked.
    const availableTrelloWorkspaces = (0, $5FkrB.useMemo)(()=>{
        if (!scopeClassification.hasTrello) return [];
        return (0, $3UXNA.sortTrelloWorkspacesByName)(trelloWorkspaces ?? []);
    }, [
        scopeClassification.hasTrello,
        trelloWorkspaces
    ]);
    // Inbox and Planner are account level rather than workspace level, so when
    // the member belongs to no workspace at all but those scopes were requested,
    // policy is still evaluated once with an empty selectedWorkspace.
    const trelloAccountLevelPolicyOnly = availableTrelloWorkspaces.length === 0 && trelloInboxPlannerScopesRequested;
    const trelloPolicyTargets = (0, $5FkrB.useMemo)(()=>trelloAccountLevelPolicyOnly ? [
            $144848332446fadd$var$ACCOUNT_LEVEL_TRELLO_POLICY_TARGET
        ] : selectedTrelloWorkspaces.map((workspace)=>workspace.id), [
        selectedTrelloWorkspaces,
        trelloAccountLevelPolicyOnly
    ]);
    const trelloPolicyRequestKey = scopeClassification.hasTrello && trelloPolicyTargets.length > 0 ? (0, $Qy2AT.getPolicyRequestKey)(token.raw, trelloPolicyTargets) : null;
    const sitePolicyRequestKey = selectedWorkspace ? (0, $Qy2AT.getPolicyRequestKey)(token.raw, [
        selectedWorkspace
    ]) : null;
    // Effects start the next request after render. Scope stored results to the
    // current selection so a new target can never inherit the previous target's
    // toolsets or successful status during that render.
    const activeSitePolicyState = (0, $Qy2AT.getPolicyStateForRequest)(policyState, sitePolicyRequestKey);
    const activeTrelloPolicyState = (0, $Qy2AT.getPolicyStateForRequest)(trelloPolicyState, trelloPolicyRequestKey);
    const orderedPolicySources = (0, $5FkrB.useMemo)(()=>(0, $Qy2AT.getOrderedPolicySources)(scopeClassification), [
        scopeClassification
    ]);
    // Intent groups the user is allowed to see. Delete and Manage are still
    // rolling out, so each is hidden until its own gate is on.
    const isIntentGroupEnabled = (0, $5FkrB.useCallback)((intentId)=>{
        if (intentId === (0, $bcapr.MCP_INTENT).delete) return jiraDeleteToolsetsEnabled;
        if (intentId === (0, $bcapr.MCP_INTENT).manage) return jiraManageToolsetsEnabled;
        return true;
    }, [
        jiraDeleteToolsetsEnabled,
        jiraManageToolsetsEnabled
    ]);
    // Merge the site, Trello and Bitbucket policy byIntent arrays.
    // All are ordered read → write → search; merge toolsets within matching intents.
    const byIntent = (0, $5FkrB.useMemo)(()=>{
        const siteIntents = orderedPolicySources.includes('site') && activeSitePolicyState.status === 'success' ? activeSitePolicyState.byIntent : [];
        const trelloIntents = orderedPolicySources.includes('trello') && activeTrelloPolicyState.status === 'success' ? activeTrelloPolicyState.byIntent : [];
        const bitbucketIntents = orderedPolicySources.includes('bitbucket') && bitbucketPolicyState.status === 'success' ? bitbucketPolicyState.byIntent : [];
        const merged = $144848332446fadd$var$mergeMcpPolicyIntents([
            ...siteIntents,
            ...trelloIntents,
            ...bitbucketIntents
        ]).filter((group)=>isIntentGroupEnabled(group.id));
        return merged;
    }, [
        activeSitePolicyState,
        activeTrelloPolicyState,
        bitbucketPolicyState,
        isIntentGroupEnabled,
        orderedPolicySources
    ]);
    // Drop selected toolsets only when they are no longer visible in the merged
    // policy, e.g. after a workspace is unselected or a gate hides an intent.
    (0, $5FkrB.useEffect)(()=>{
        const visibleNames = (0, $dnJFI.getVisibleToolsetNames)(byIntent);
        setSelectedNames((prev)=>{
            const next = new Set([
                ...prev
            ].filter((name)=>visibleNames.has(name)));
            return next.size === prev.size ? prev : next;
        });
    }, [
        byIntent
    ]);
    const { setSelectedWorkspace: setSelectedWorkspace } = consentContext;
    // In mixed flows (both Atlassian + Trello), reset Trello workspace on site change.
    (0, $5FkrB.useEffect)(()=>{
        if (scopeClassification.hasAtlassian) setSelectedTrelloWorkspaces([]);
    }, [
        selectedWorkspace,
        scopeClassification.hasAtlassian,
        setSelectedTrelloWorkspaces
    ]);
    (0, $5FkrB.useEffect)(()=>{
        setSelectedTrelloWorkspacesState((current)=>(0, $3UXNA.normalizeTrelloWorkspaceSelection)(current, isTrelloWorkspaceMultiSelectEnabled));
    }, [
        isTrelloWorkspaceMultiSelectEnabled
    ]);
    // Prefill the Trello workspace selection once the workspaces have loaded
    // (Trello-only flow). A single workspace auto-selects; multiple workspaces
    // require user selection. Mixed flows are driven by the Atlassian SiteSelector
    // and reset Trello on site change, so we skip prefill there. The ref guard
    // ensures we only prefill on initial load and never re-apply after the user
    // clears their selection.
    (0, $5FkrB.useEffect)(()=>{
        if (!scopeClassification.hasTrello || scopeClassification.hasAtlassian) return;
        if (trelloPrefillAppliedRef.current) return;
        if (selectedTrelloWorkspaces.length > 0) {
            trelloPrefillAppliedRef.current = true;
            return;
        }
        const initialSelection = (0, $3UXNA.getInitialTrelloWorkspaceSelection)(availableTrelloWorkspaces);
        if (initialSelection.length > 0) {
            trelloPrefillAppliedRef.current = true;
            setSelectedTrelloWorkspaces(initialSelection);
        }
    }, [
        scopeClassification,
        availableTrelloWorkspaces,
        selectedTrelloWorkspaces,
        setSelectedTrelloWorkspaces
    ]);
    // In Trello-only flows the Atlassian SiteSelector is hidden, so we
    // drive the policy fetch from Trello workspace selection instead.
    // Selecting a Trello workspace auto-selects the (hidden) Atlassian workspace
    // to trigger the policy fetch; clearing it resets the policy.
    (0, $5FkrB.useEffect)(()=>{
        if (!scopeClassification.hasTrello || scopeClassification.hasAtlassian) return; // Only applies to Trello-only flows
        const firstWorkspace = token.workspaces?.[0] ?? null;
        if (selectedTrelloWorkspaces.length > 0 && !selectedWorkspace && firstWorkspace) setSelectedWorkspace?.(firstWorkspace);
        else if (selectedTrelloWorkspaces.length === 0 && selectedWorkspace) setSelectedWorkspace?.(null);
    }, [
        scopeClassification,
        selectedTrelloWorkspaces,
        selectedWorkspace,
        token.workspaces,
        setSelectedWorkspace
    ]);
    // Fetch policy whenever token or selectedWorkspace changes
    (0, $5FkrB.useEffect)(()=>{
        if (token.serviceType !== 'MCP') return;
        if (!selectedWorkspace) {
            // No workspace selected — either the user hasn't picked one yet,
            // there are none available, or the key is missing from the token.
            // Stay idle so we don't fire a policy fetch that would fail and
            // show a misleading error alongside the SiteSelector's empty-state.
            dispatchPolicy({
                type: 'RESET'
            });
            return;
        }
        const requestKey = (0, $Qy2AT.getPolicyRequestKey)(token.raw, [
            selectedWorkspace
        ]);
        const callback = token.redirectUrl?.callback ?? '';
        if (!callback) {
            dispatchPolicy({
                type: 'ERROR',
                requestKey: requestKey,
                errorMessage: null,
                errorKind: (0, $Qy2AT.MCP_POLICY_ERROR_KIND).missingRedirect
            });
            analyticsClient.pushTrackEvent({
                actionSubject: 'mcpPolicyCheck',
                action: 'failed',
                source: 'oauthConsentScreen',
                attributes: {
                    reason: (0, $Qy2AT.MCP_POLICY_ERROR_KIND).missingRedirect
                }
            });
            return;
        }
        const ac = new AbortController();
        dispatchPolicy({
            type: 'LOADING',
            requestKey: requestKey
        });
        (async ()=>{
            try {
                const result = await (0, $8LFYh.fetchWorkspacePolicyCheck)({
                    contextJwt: token.raw,
                    selectedWorkspace: selectedWorkspace
                }, ac.signal);
                if (ac.signal.aborted) return;
                if (!result.ok) {
                    const clientDisabled = (0, $8LFYh.isClientDisabledFailure)(result);
                    const errorKind = clientDisabled ? (0, $Qy2AT.MCP_POLICY_ERROR_KIND).clientDisabled : (0, $Qy2AT.MCP_POLICY_ERROR_KIND).policyFetchFailed;
                    dispatchPolicy({
                        type: 'ERROR',
                        requestKey: requestKey,
                        errorMessage: result.errorMessage,
                        errorKind: errorKind,
                        errorWorkspaceName: clientDisabled ? selectedWorkspace : null
                    });
                    analyticsClient.pushTrackEvent({
                        actionSubject: 'mcpPolicyCheck',
                        action: 'failed',
                        source: 'oauthConsentScreen',
                        attributes: {
                            reason: errorKind
                        }
                    });
                    return;
                }
                if (!result.data.redirectAllowed) {
                    dispatchPolicy({
                        type: 'ERROR',
                        requestKey: requestKey,
                        errorMessage: null,
                        errorKind: (0, $Qy2AT.MCP_POLICY_ERROR_KIND).redirectNotAllowed
                    });
                    analyticsClient.pushTrackEvent({
                        actionSubject: 'mcpPolicyCheck',
                        action: 'failed',
                        source: 'oauthConsentScreen',
                        attributes: {
                            reason: (0, $Qy2AT.MCP_POLICY_ERROR_KIND).redirectNotAllowed
                        }
                    });
                    return;
                }
                const mcpData = (0, $dnJFI.parseMcpPolicyData)(result.data);
                const newByIntent = mcpData.byIntent;
                dispatchPolicy({
                    type: 'SUCCESS',
                    requestKey: requestKey,
                    byIntent: newByIntent,
                    crossOrgScopesRemoved: mcpData.crossOrgScopesRemoved
                });
                // Pre-select toolsets
                selectFetchedToolsets((0, $dnJFI.getToolsetNames)(newByIntent));
            } catch (e) {
                if (e instanceof DOMException && e.name === 'AbortError' || ac.signal.aborted) return;
                dispatchPolicy({
                    type: 'ERROR',
                    requestKey: requestKey,
                    errorMessage: e instanceof Error ? e.message : 'Unexpected error',
                    errorKind: (0, $Qy2AT.MCP_POLICY_ERROR_KIND).unexpected
                });
            }
        })();
        return ()=>{
            ac.abort();
        };
    }, [
        token,
        selectedWorkspace,
        analyticsClient,
        selectFetchedToolsets
    ]);
    // Fetch Trello policy when one or more Trello workspaces are selected.
    // Uses the same /consent/workspace endpoint as Atlassian site policy,
    // passing the Trello workspace ARI as the selectedWorkspace parameter.
    //
    (0, $5FkrB.useEffect)(()=>{
        if (token.serviceType !== 'MCP') return;
        if (!scopeClassification.hasTrello) return;
        if (trelloPolicyRequestKey == null) {
            dispatchTrelloPolicy({
                type: 'RESET'
            });
            return;
        }
        const ac = new AbortController();
        dispatchTrelloPolicy({
            type: 'LOADING',
            requestKey: trelloPolicyRequestKey
        });
        (async ()=>{
            try {
                const results = await Promise.all(trelloPolicyTargets.map((selectedTrelloWorkspace)=>(0, $8LFYh.fetchWorkspacePolicyCheck)({
                        contextJwt: token.raw,
                        selectedWorkspace: selectedTrelloWorkspace
                    }, ac.signal)));
                if (ac.signal.aborted) return;
                const failedIndex = results.findIndex((result)=>!result.ok);
                const failedResult = failedIndex === -1 ? null : results[failedIndex];
                if (failedResult && !failedResult.ok) {
                    const clientDisabled = (0, $8LFYh.isClientDisabledFailure)(failedResult);
                    const accessRevoked = !clientDisabled && failedResult.status === 403;
                    dispatchTrelloPolicy({
                        type: 'ERROR',
                        requestKey: trelloPolicyRequestKey,
                        errorMessage: failedResult.errorMessage,
                        errorKind: clientDisabled ? (0, $Qy2AT.MCP_POLICY_ERROR_KIND).clientDisabled : accessRevoked ? (0, $Qy2AT.MCP_POLICY_ERROR_KIND).workspaceAccessRevoked : (0, $Qy2AT.MCP_POLICY_ERROR_KIND).policyFetchFailed,
                        errorWorkspaceName: clientDisabled || accessRevoked ? selectedTrelloWorkspaces[failedIndex]?.displayName ?? null : null
                    });
                    return;
                }
                const successfulResults = results.filter((result)=>result.ok);
                if (successfulResults.some((result)=>!result.data.redirectAllowed)) {
                    dispatchTrelloPolicy({
                        type: 'ERROR',
                        requestKey: trelloPolicyRequestKey,
                        errorMessage: null,
                        errorKind: (0, $Qy2AT.MCP_POLICY_ERROR_KIND).redirectNotAllowed
                    });
                    return;
                }
                const parsedPolicyData = successfulResults.map((result)=>(0, $dnJFI.parseMcpPolicyData)(result.data));
                const newByIntent = $144848332446fadd$var$mergeMcpPolicyIntents(parsedPolicyData.flatMap((data)=>data.byIntent));
                dispatchTrelloPolicy({
                    type: 'SUCCESS',
                    requestKey: trelloPolicyRequestKey,
                    byIntent: newByIntent,
                    crossOrgScopesRemoved: parsedPolicyData.some((data)=>data.crossOrgScopesRemoved)
                });
                // Pre-select Trello toolsets, adding to existing selection
                selectFetchedToolsets((0, $dnJFI.getToolsetNames)(newByIntent));
            } catch (e) {
                if (e instanceof DOMException && e.name === 'AbortError' || ac.signal.aborted) return;
                dispatchTrelloPolicy({
                    type: 'ERROR',
                    requestKey: trelloPolicyRequestKey,
                    errorMessage: e instanceof Error ? e.message : 'Unexpected error',
                    errorKind: (0, $Qy2AT.MCP_POLICY_ERROR_KIND).unexpected
                });
            }
        })();
        return ()=>{
            ac.abort();
        };
    }, [
        token,
        selectedTrelloWorkspaces,
        scopeClassification.hasTrello,
        trelloPolicyRequestKey,
        trelloPolicyTargets,
        selectFetchedToolsets
    ]);
    const toggleMcpToolset = (0, $5FkrB.useCallback)((toolsetName, selected)=>{
        setSelectedNames((prev)=>{
            const next = new Set(prev);
            if (selected) next.add(toolsetName);
            else next.delete(toolsetName);
            return next;
        });
    }, []);
    // Determine if cross-org scopes (inbox/planner) are disabled for the selected Trello workspace.
    // The policy response includes a crossOrgScopesRemoved flag when the selected workspace
    // is outside the user's managing organization.
    const inboxPlannerScopesDisabled = (0, $5FkrB.useMemo)(()=>{
        // Only relevant when Trello scopes are in play and a workspace is selected
        if (!scopeClassification.hasTrello || selectedTrelloWorkspaces.length === 0) return false;
        // Check the Trello policy response for crossOrgScopesRemoved flag
        if (activeTrelloPolicyState.status === 'success') return activeTrelloPolicyState.crossOrgScopesRemoved;
        return false;
    }, [
        scopeClassification.hasTrello,
        selectedTrelloWorkspaces,
        activeTrelloPolicyState
    ]);
    // Forge MCP permissions are intentionally read-only in the UI. Publish every
    // visible toolset as selected so the hidden resume fields submit the complete
    // grant, including toolsets that standard MCP asks users to opt into.
    const effectiveSelectedNames = (0, $5FkrB.useMemo)(()=>forgeAppName ? (0, $dnJFI.getVisibleToolsetNames)(byIntent) : selectedNames, [
        byIntent,
        forgeAppName,
        selectedNames
    ]);
    const value = (0, $5FkrB.useMemo)(()=>{
        // The three checks, keyed by source. In a Trello-only flow the hidden site
        // check does not speak for the flow; orderedSources handles that scoping.
        const policies = {
            site: activeSitePolicyState,
            trello: activeTrelloPolicyState,
            bitbucket: bitbucketPolicyState
        };
        const combinedPolicyStatus = (0, $Qy2AT.getCombinedPolicyStatus)(policies, orderedPolicySources);
        // The single failure being reported, resolved once so the kind, message and
        // source can never describe different errors.
        const errorSource = (0, $Qy2AT.getPrimaryPolicyErrorSource)(policies, orderedPolicySources);
        const errorState = errorSource ? policies[errorSource] : null;
        const errorKind = errorState?.status === 'error' ? errorState.errorKind : null;
        return {
            mcpPolicyStatus: combinedPolicyStatus,
            mcpPolicyErrorKind: errorKind,
            mcpPolicyErrorWorkspaceName: errorState?.status === 'error' ? errorState.errorWorkspaceName ?? null : null,
            policies: policies,
            hasTrelloInboxPlannerScopes: trelloInboxPlannerScopesRequested,
            mcpByIntent: byIntent,
            mcpSelectedToolsetNames: effectiveSelectedNames,
            toggleMcpToolset: toggleMcpToolset,
            scopeClassification: scopeClassification,
            trelloRequestedButNoAccess: trelloRequestedButNoAccess,
            selectedTrelloWorkspaces: selectedTrelloWorkspaces,
            setSelectedTrelloWorkspaces: setSelectedTrelloWorkspaces,
            isTrelloWorkspaceMultiSelectEnabled: isTrelloWorkspaceMultiSelectEnabled,
            isTrelloMultiWorkspaceSelectorEnabled: isTrelloMultiWorkspaceSelectorEnabled,
            maxSelectableTrelloWorkspaces: maxSelectableTrelloWorkspaces,
            clientName: clientName,
            availableTrelloWorkspaces: availableTrelloWorkspaces,
            trelloWorkspacesLoading: trelloWorkspacesLoading,
            trelloWorkspacesHasMore: trelloWorkspacesHasMore,
            trelloWorkspacesLoadingMore: trelloWorkspacesLoadingMore,
            onLoadMoreTrelloWorkspaces: onLoadMoreTrelloWorkspaces,
            inboxPlannerScopesDisabled: inboxPlannerScopesDisabled,
            isBitbucketWorkspaceAccessEnabled: isBitbucketWorkspaceAccessEnabled,
            availableBitbucketWorkspaces: availableBitbucketWorkspaces,
            selectedBitbucketWorkspace: selectedBitbucketWorkspace,
            setSelectedBitbucketWorkspace: setSelectedBitbucketWorkspace,
            siteOrgId: siteOrgId,
            siteOrgIndex: siteOrgIndex,
            bitbucketOrgId: bitbucketOrgId,
            hasOrgMismatch: hasOrgMismatch,
            recentTrelloWorkspaceIds: recentTrelloWorkspaceIds,
            recordConsentedTrelloWorkspaces: recordConsentedTrelloWorkspaces
        };
    }, [
        activeSitePolicyState,
        activeTrelloPolicyState,
        bitbucketPolicyState,
        trelloInboxPlannerScopesRequested,
        byIntent,
        effectiveSelectedNames,
        toggleMcpToolset,
        scopeClassification,
        trelloRequestedButNoAccess,
        selectedTrelloWorkspaces,
        setSelectedTrelloWorkspaces,
        isTrelloWorkspaceMultiSelectEnabled,
        isTrelloMultiWorkspaceSelectorEnabled,
        maxSelectableTrelloWorkspaces,
        clientName,
        availableTrelloWorkspaces,
        trelloWorkspacesLoading,
        trelloWorkspacesHasMore,
        trelloWorkspacesLoadingMore,
        onLoadMoreTrelloWorkspaces,
        inboxPlannerScopesDisabled,
        isBitbucketWorkspaceAccessEnabled,
        availableBitbucketWorkspaces,
        selectedBitbucketWorkspace,
        setSelectedBitbucketWorkspace,
        siteOrgId,
        siteOrgIndex,
        bitbucketOrgId,
        hasOrgMismatch,
        recentTrelloWorkspaceIds,
        recordConsentedTrelloWorkspaces,
        orderedPolicySources
    ]);
    return /*#__PURE__*/ (0, $i3UfC.jsx)($144848332446fadd$export$717198317c60be4b.Provider, {
        value: value,
        children: children
    });
};
var $144848332446fadd$export$2e2bcd8739ae039 = $144848332446fadd$export$623b51d94ab5545b;

});
parcelRegister("6hgMx", function(module, exports) {
$parcel$export(module.exports, "ReactConsentContext", () => $ca91adf2b5f5bbfd$export$683f346ec6c56a00);
$parcel$export(module.exports, "narrowConsentContentStyle", () => $ca91adf2b5f5bbfd$export$ee1802d3acc865dc);
$parcel$export(module.exports, "useToken", () => $ca91adf2b5f5bbfd$export$31dcd79391e423fe);
$parcel$export(module.exports, "useInfo", () => $ca91adf2b5f5bbfd$export$2ae76d51704c9302);
$parcel$export(module.exports, "useSelectedWorkspace", () => $ca91adf2b5f5bbfd$export$115b1e9e2e9e2d05);
$parcel$export(module.exports, "useSelectedOrg", () => $ca91adf2b5f5bbfd$export$51fa160af1ce57e5);
$parcel$export(module.exports, "default", () => $ca91adf2b5f5bbfd$export$2e2bcd8739ae039);

var $i3UfC = parcelRequire("i3UfC");

var $5FkrB = parcelRequire("5FkrB");

var $ArAzU = parcelRequire("ArAzU");

var $gDiFE = parcelRequire("gDiFE");

var $cd4Qw = parcelRequire("cd4Qw");

var $3VQxn = parcelRequire("3VQxn");

var $fLAke = parcelRequire("fLAke");

var $guDjK = parcelRequire("guDjK");

var $38t3M = parcelRequire("38t3M");
const $ca91adf2b5f5bbfd$export$683f346ec6c56a00 = /*#__PURE__*/ (0, $5FkrB.createContext)(null);
const $ca91adf2b5f5bbfd$export$ee1802d3acc865dc = (0, $gDiFE.xcss)({
    paddingTop: 'space.400',
    margin: '0 auto',
    maxWidth: '550px'
});
const $ca91adf2b5f5bbfd$export$31dcd79391e423fe = ()=>{
    const context = (0, $5FkrB.useContext)($ca91adf2b5f5bbfd$export$683f346ec6c56a00);
    if (!context) throw new Error('useToken must be used within context');
    return context.token;
};
const $ca91adf2b5f5bbfd$export$2ae76d51704c9302 = ()=>{
    const context = (0, $5FkrB.useContext)($ca91adf2b5f5bbfd$export$683f346ec6c56a00);
    if (!context) throw new Error('useInfo must be used within context');
    return context.info;
};
const $ca91adf2b5f5bbfd$export$115b1e9e2e9e2d05 = ()=>{
    const context = (0, $5FkrB.useContext)($ca91adf2b5f5bbfd$export$683f346ec6c56a00);
    if (!context) throw new Error('useSelectedWorkspace must be used within context');
    return {
        selectedWorkspace: context.selectedWorkspace ?? null,
        setSelectedWorkspace: context.setSelectedWorkspace
    };
};
const $ca91adf2b5f5bbfd$export$51fa160af1ce57e5 = ()=>{
    const context = (0, $5FkrB.useContext)($ca91adf2b5f5bbfd$export$683f346ec6c56a00);
    if (!context) throw new Error('useSelectedOrg must be used within context');
    return {
        selectedOrg: context.selectedOrg ?? null,
        setSelectedOrg: context.setSelectedOrg,
        isOrgLoading: context.isOrgLoading ?? false,
        availableOrganizations: context.info.availableOrganizations ?? [],
        orgError: context.orgError ?? null
    };
};
const $ca91adf2b5f5bbfd$export$f23d815ed4c73b08 = ({ children: children, loading: loading })=>{
    const [consentContext, setConsentContext] = (0, $5FkrB.useState)(null);
    const [selectedWorkspace, setSelectedWorkspace] = (0, $5FkrB.useState)(null);
    const [selectedOrg, setSelectedOrgState] = (0, $5FkrB.useState)(null);
    const [isOrgLoading, setIsOrgLoading] = (0, $5FkrB.useState)(false);
    const [orgError, setOrgError] = (0, $5FkrB.useState)(null);
    const [acceptDisabled, setAcceptDisabled] = (0, $5FkrB.useState)(false);
    const [selectedScopes, setSelectedScopes] = (0, $5FkrB.useState)(undefined);
    const [isLoading, setLoading] = (0, $5FkrB.useState)(true);
    const selectedOrgRequestId = (0, $5FkrB.useRef)(0);
    const { showBoundary: showBoundary } = (0, $ArAzU.useErrorBoundary)();
    const analyticsClient = (0, $guDjK.useAnalytics)();
    (0, $5FkrB.useEffect)(()=>{
        (0, $cd4Qw.getConsentContext)().then(async (token)=>{
            if ((0, $3VQxn.isError)(token)) return showBoundary(token);
            console.log('Parsed token successfully as', token);
            // Earliest point the flow is known, and deliberately ahead of the
            // /consent/info await below: the MCP screens are laid out with
            // viewport media queries, and index.html ships no viewport meta, so
            // anything that paints before this does so against the mobile
            // browser's ~980px virtual viewport.
            if (token.serviceType === 'MCP') (0, $38t3M.applyResponsiveViewport)();
            analyticsClient.setUserId(token.userId);
            analyticsClient.setCloudId(token.cloudId);
            analyticsClient.updateState({
                profile: token.profile ?? undefined,
                customer: token.customer ?? undefined,
                serviceType: token.serviceType ?? undefined
            });
            const info = await (0, $fLAke.getConsentInfo)(token);
            if ((0, $3VQxn.isError)(info)) return showBoundary(info);
            console.log('Parsed info successfully as', info);
            const effectiveToken = info.scopeThumbprint ? {
                ...token,
                scopes: info.scopeThumbprint.scopes
            } : token;
            setConsentContext({
                token: effectiveToken,
                info: info
            });
            setLoading(false);
            analyticsClient.sendConsentScreenEvent();
        }).catch(showBoundary);
    }, [
        showBoundary
    ]);
    const setSelectedOrg = (0, $5FkrB.useCallback)(async (orgId)=>{
        if (!consentContext) return;
        const requestId = selectedOrgRequestId.current + 1;
        selectedOrgRequestId.current = requestId;
        setSelectedOrgState(orgId);
        setOrgError(null);
        // Reset scope selection immediately when org changes to prevent stale scopes
        // being submitted during the async /consent/info fetch window.
        // Will be repopulated with the new org's filteredScopes once the response arrives.
        setSelectedScopes(undefined);
        // Reset site selection only when org actually changes (not when adding more sites within same org)
        setSelectedWorkspace((prev)=>{
            if (!orgId) return null;
            // Keep existing selection if same org; clear if org changed
            const prevOrg = prev ? consentContext.info.availableOrganizations?.flatMap((o)=>o.availableWorkspaces?.map((s)=>({
                        s: s,
                        orgId: o.orgId
                    })) ?? []).find((x)=>prev.split(',').includes(x.s))?.orgId : null;
            return prevOrg === orgId ? prev : null;
        });
        if (!orgId) {
            setIsOrgLoading(false);
            return;
        }
        setIsOrgLoading(true);
        try {
            const info = await (0, $fLAke.getConsentInfo)(consentContext.token, {
                selectedOrg: orgId,
                includeDisabledScopes: true
            });
            if (selectedOrgRequestId.current !== requestId) return;
            if ((0, $3VQxn.isError)(info)) {
                // TWG keeps selected-site "no scopes" policy failures inline so the
                // site selector remains visible and the user can try another site.
                if (consentContext.token.serviceType === 'TWG' && info.error === 'no-scopes') setOrgError(info);
                else showBoundary(info);
                return;
            }
            console.log('Parsed info (with org) successfully as', info);
            setConsentContext((prev)=>prev ? {
                    ...prev,
                    info: {
                        // Retain availableOrganizations from the initial load if the
                        // org-scoped response omits them (so the dropdown stays populated).
                        availableOrganizations: prev.info.availableOrganizations,
                        ...info
                    }
                } : prev);
            // Default user-selected scopes to the full allowed set for this org.
            // The user can then deselect individual scopes before accepting.
            setSelectedScopes(info.filteredScopes ?? consentContext.token.scopes ?? []);
        } catch (e) {
            if (selectedOrgRequestId.current === requestId) {
                if (consentContext.token.serviceType === 'TWG') setOrgError({
                    error: 'unexpected',
                    clientName: consentContext.token.clientName ?? undefined,
                    description: 'Unexpected error'
                });
                else showBoundary(e);
            }
        } finally{
            if (selectedOrgRequestId.current === requestId) setIsOrgLoading(false);
        }
    }, [
        consentContext,
        showBoundary
    ]);
    return /*#__PURE__*/ (0, $i3UfC.jsxs)((0, $i3UfC.Fragment), {
        children: [
            isLoading && loading,
            !isLoading && consentContext && /*#__PURE__*/ (0, $i3UfC.jsx)($ca91adf2b5f5bbfd$export$683f346ec6c56a00.Provider, {
                value: {
                    ...consentContext,
                    selectedWorkspace: selectedWorkspace,
                    setSelectedWorkspace: setSelectedWorkspace,
                    acceptDisabled: acceptDisabled,
                    setAcceptDisabled: setAcceptDisabled,
                    selectedOrg: selectedOrg,
                    setSelectedOrg: setSelectedOrg,
                    isOrgLoading: isOrgLoading,
                    orgError: orgError,
                    selectedScopes: selectedScopes,
                    setSelectedScopes: setSelectedScopes
                },
                children: children
            })
        ]
    });
};
var $ca91adf2b5f5bbfd$export$2e2bcd8739ae039 = $ca91adf2b5f5bbfd$export$f23d815ed4c73b08;

});
parcelRegister("ArAzU", function(module, exports) {
$parcel$export(module.exports, "ErrorBoundary", () => $06d8c3808eec02c5$export$e926676385687eaf);
$parcel$export(module.exports, "useErrorBoundary", () => $06d8c3808eec02c5$export$c052f6604b7d51fe);

var $5FkrB = parcelRequire("5FkrB");
'use client';
const $06d8c3808eec02c5$export$b16d9fb1a22de840 = (0, $5FkrB.createContext)(null);
const $06d8c3808eec02c5$var$initialState = {
    didCatch: false,
    error: null
};
class $06d8c3808eec02c5$export$e926676385687eaf extends (0, $5FkrB.Component) {
    constructor(props){
        super(props);
        this.resetErrorBoundary = this.resetErrorBoundary.bind(this);
        this.state = $06d8c3808eec02c5$var$initialState;
    }
    static getDerivedStateFromError(error) {
        return {
            didCatch: true,
            error: error
        };
    }
    resetErrorBoundary() {
        const { error: error } = this.state;
        if (error !== null) {
            var _this$props$onReset, _this$props;
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            (_this$props$onReset = (_this$props = this.props).onReset) === null || _this$props$onReset === void 0 || _this$props$onReset.call(_this$props, {
                args: args,
                reason: "imperative-api"
            });
            this.setState($06d8c3808eec02c5$var$initialState);
        }
    }
    componentDidCatch(error, info) {
        var _this$props$onError, _this$props2;
        (_this$props$onError = (_this$props2 = this.props).onError) === null || _this$props$onError === void 0 || _this$props$onError.call(_this$props2, error, info);
    }
    componentDidUpdate(prevProps, prevState) {
        const { didCatch: didCatch } = this.state;
        const { resetKeys: resetKeys } = this.props;
        // There's an edge case where if the thing that triggered the error happens to *also* be in the resetKeys array,
        // we'd end up resetting the error boundary immediately.
        // This would likely trigger a second error to be thrown.
        // So we make sure that we don't check the resetKeys on the first call of cDU after the error is set.
        if (didCatch && prevState.error !== null && $06d8c3808eec02c5$var$hasArrayChanged(prevProps.resetKeys, resetKeys)) {
            var _this$props$onReset2, _this$props3;
            (_this$props$onReset2 = (_this$props3 = this.props).onReset) === null || _this$props$onReset2 === void 0 || _this$props$onReset2.call(_this$props3, {
                next: resetKeys,
                prev: prevProps.resetKeys,
                reason: "keys"
            });
            this.setState($06d8c3808eec02c5$var$initialState);
        }
    }
    render() {
        const { children: children, fallbackRender: fallbackRender, FallbackComponent: FallbackComponent, fallback: fallback } = this.props;
        const { didCatch: didCatch, error: error } = this.state;
        let childToRender = children;
        if (didCatch) {
            const props = {
                error: error,
                resetErrorBoundary: this.resetErrorBoundary
            };
            if (typeof fallbackRender === "function") childToRender = fallbackRender(props);
            else if (FallbackComponent) childToRender = (0, $5FkrB.createElement)(FallbackComponent, props);
            else if (fallback !== undefined) childToRender = fallback;
            else throw error;
        }
        return (0, $5FkrB.createElement)($06d8c3808eec02c5$export$b16d9fb1a22de840.Provider, {
            value: {
                didCatch: didCatch,
                error: error,
                resetErrorBoundary: this.resetErrorBoundary
            }
        }, childToRender);
    }
}
function $06d8c3808eec02c5$var$hasArrayChanged() {
    let a = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    let b = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    return a.length !== b.length || a.some((item, index)=>!Object.is(item, b[index]));
}
function $06d8c3808eec02c5$var$assertErrorBoundaryContext(value) {
    if (value == null || typeof value.didCatch !== "boolean" || typeof value.resetErrorBoundary !== "function") throw new Error("ErrorBoundaryContext not found");
}
function $06d8c3808eec02c5$export$c052f6604b7d51fe() {
    const context = (0, $5FkrB.useContext)($06d8c3808eec02c5$export$b16d9fb1a22de840);
    $06d8c3808eec02c5$var$assertErrorBoundaryContext(context);
    const [state, setState] = (0, $5FkrB.useState)({
        error: null,
        hasError: false
    });
    const memoized = (0, $5FkrB.useMemo)(()=>({
            resetBoundary: ()=>{
                context.resetErrorBoundary();
                setState({
                    error: null,
                    hasError: false
                });
            },
            showBoundary: (error)=>setState({
                    error: error,
                    hasError: true
                })
        }), [
        context.resetErrorBoundary
    ]);
    if (state.hasError) throw state.error;
    return memoized;
}
function $06d8c3808eec02c5$export$f0c7a449e0cfaec7(component, errorBoundaryProps) {
    const Wrapped = (0, $5FkrB.forwardRef)((props, ref)=>(0, $5FkrB.createElement)($06d8c3808eec02c5$export$e926676385687eaf, errorBoundaryProps, (0, $5FkrB.createElement)(component, {
            ...props,
            ref: ref
        })));
    // Format for display in DevTools
    const name = component.displayName || component.name || "Unknown";
    Wrapped.displayName = "withErrorBoundary(".concat(name, ")");
    return Wrapped;
}

});

parcelRegister("gDiFE", function(module, exports) {
$parcel$export(module.exports, "xcss", () => $c1bec583fa49072f$export$f6c783d06584602c);

var $5olgL = parcelRequire("5olgL");

var $k0dv1 = parcelRequire("k0dv1");

var $dh9zJ = parcelRequire("dh9zJ");

var $2nBsU = parcelRequire("2nBsU");

var $cYEIA = parcelRequire("cYEIA");

var $3PTbW = parcelRequire("3PTbW");

var $3ZMUU = parcelRequire("3ZMUU");
var $c1bec583fa49072f$var$isSafeEnvToThrow = function isSafeEnvToThrow() {
    return (typeof $3ZMUU === "undefined" ? "undefined" : (0, $dh9zJ.default)($3ZMUU)) === 'object' && (0, $dh9zJ.default)($3ZMUU.env) === 'object' && false;
};
var $c1bec583fa49072f$var$reNestedSelectors = /(\.|\s|&+|\*\>|#|\[.*\])/;
var $c1bec583fa49072f$var$safeSelectors = /^@media .*$|^::?.*$|^@supports .*$/;
var $c1bec583fa49072f$var$_transformStyles = function transformStyles(styleObj) {
    if (!styleObj || (0, $dh9zJ.default)(styleObj) !== 'object') return styleObj;
    // If styles are defined as a CSSObject[], recursively call on each element until we reach CSSObject
    if (Array.isArray(styleObj)) return styleObj.map($c1bec583fa49072f$var$_transformStyles);
    // Modifies styleObj in place. Be careful.
    Object.entries(styleObj).forEach(function(_ref) {
        var _ref2 = (0, $k0dv1.default)(_ref, 2), key = _ref2[0], value = _ref2[1];
        // If key is a pseudo class or a pseudo element, then value should be an object.
        // So, call transformStyles on the value
        if ((0, $dh9zJ.default)(value) === 'object' && $c1bec583fa49072f$var$safeSelectors.test(key)) {
            styleObj[key] = $c1bec583fa49072f$var$_transformStyles(value);
            return;
        }
        if ($c1bec583fa49072f$var$isSafeEnvToThrow()) {
            // We don't support `.class`, `[data-testid]`, `> *`, `#some-id`
            if ($c1bec583fa49072f$var$reNestedSelectors.test(key)) throw new Error("Styles not supported for key '".concat(key, "'."));
        }
        // We have now dealt with all the special cases, so,
        // check whether what remains is a style property
        // that can be transformed.
        if (!(key in (0, $cYEIA.tokensMap))) return;
        var tokenValue = (0, $cYEIA.tokensMap)[key][value];
        styleObj[key] = tokenValue !== null && tokenValue !== void 0 ? tokenValue : value;
    });
    return styleObj;
};
var $c1bec583fa49072f$var$baseXcss = function baseXcss(style) {
    var transformedStyles = $c1bec583fa49072f$var$_transformStyles(style);
    return (0, $5olgL.default)({}, (0, $3PTbW.uniqueSymbol), (0, $2nBsU.css)(transformedStyles));
};
function $c1bec583fa49072f$export$f6c783d06584602c(style) {
    return $c1bec583fa49072f$var$baseXcss(style);
}

});
parcelRegister("5olgL", function(module, exports) {
$parcel$export(module.exports, "default", () => $3ecfb150439e7c4e$export$2e2bcd8739ae039);

var $7fW0j = parcelRequire("7fW0j");
function $3ecfb150439e7c4e$export$2e2bcd8739ae039(e, r, t) {
    return (r = (0, $7fW0j.default)(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}

});
parcelRegister("7fW0j", function(module, exports) {
$parcel$export(module.exports, "default", () => $5486ed81ade3d02c$export$2e2bcd8739ae039);

var $dh9zJ = parcelRequire("dh9zJ");

var $k32q6 = parcelRequire("k32q6");
function $5486ed81ade3d02c$export$2e2bcd8739ae039(t) {
    var i = (0, $k32q6.default)(t, "string");
    return "symbol" == (0, $dh9zJ.default)(i) ? i : i + "";
}

});
parcelRegister("dh9zJ", function(module, exports) {
$parcel$export(module.exports, "default", () => $9aa44a55027dece1$export$2e2bcd8739ae039);
function $9aa44a55027dece1$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $9aa44a55027dece1$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $9aa44a55027dece1$export$2e2bcd8739ae039(o);
}

});

parcelRegister("k32q6", function(module, exports) {
$parcel$export(module.exports, "default", () => $e985f704e44c4eff$export$2e2bcd8739ae039);

var $dh9zJ = parcelRequire("dh9zJ");
function $e985f704e44c4eff$export$2e2bcd8739ae039(t, r) {
    if ("object" != (0, $dh9zJ.default)(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (0, $dh9zJ.default)(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}

});



parcelRegister("k0dv1", function(module, exports) {
$parcel$export(module.exports, "default", () => $e8fe476b9951c06b$export$2e2bcd8739ae039);

var $6LxMu = parcelRequire("6LxMu");

var $lsn3u = parcelRequire("lsn3u");

var $8UkUQ = parcelRequire("8UkUQ");

var $dDpUf = parcelRequire("dDpUf");
function $e8fe476b9951c06b$export$2e2bcd8739ae039(r, e) {
    return (0, $6LxMu.default)(r) || (0, $lsn3u.default)(r, e) || (0, $8UkUQ.default)(r, e) || (0, $dDpUf.default)();
}

});
parcelRegister("6LxMu", function(module, exports) {
$parcel$export(module.exports, "default", () => $4ed15615a7227203$export$2e2bcd8739ae039);
function $4ed15615a7227203$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return r;
}

});

parcelRegister("lsn3u", function(module, exports) {
$parcel$export(module.exports, "default", () => $f9ee18c970a2007a$export$2e2bcd8739ae039);
function $f9ee18c970a2007a$export$2e2bcd8739ae039(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}

});

parcelRegister("8UkUQ", function(module, exports) {
$parcel$export(module.exports, "default", () => $67c3c72b8fc6b654$export$2e2bcd8739ae039);

var $62sEv = parcelRequire("62sEv");
function $67c3c72b8fc6b654$export$2e2bcd8739ae039(r, a) {
    if (r) {
        if ("string" == typeof r) return (0, $62sEv.default)(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? (0, $62sEv.default)(r, a) : void 0;
    }
}

});
parcelRegister("62sEv", function(module, exports) {
$parcel$export(module.exports, "default", () => $465927bec925e1e6$export$2e2bcd8739ae039);
function $465927bec925e1e6$export$2e2bcd8739ae039(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}

});


parcelRegister("dDpUf", function(module, exports) {
$parcel$export(module.exports, "default", () => $9ed3034b410f4954$export$2e2bcd8739ae039);
function $9ed3034b410f4954$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});


parcelRegister("2nBsU", function(module, exports) {
$parcel$export(module.exports, "css", () => $1bbaca91e5cf6bc9$export$dbf350e5966cf602);
$parcel$export(module.exports, "ClassNames", () => $1bbaca91e5cf6bc9$export$9b9c0f9d9f3552b8);
$parcel$export(module.exports, "jsx", () => $1bbaca91e5cf6bc9$export$c8a8987d4410bf2d);

var $cLH01 = parcelRequire("cLH01");

var $5FkrB = parcelRequire("5FkrB");

var $hXf6E = parcelRequire("hXf6E");

var $4Sr34 = parcelRequire("4Sr34");

var $ckRFu = parcelRequire("ckRFu");
parcelRequire("3GBPy");
parcelRequire("6NXXp");
parcelRequire("1QNjI");

parcelRequire("knBeW");
var $1bbaca91e5cf6bc9$export$c8a8987d4410bf2d = function jsx(type, props) {
    // eslint-disable-next-line prefer-rest-params
    var args = arguments;
    if (props == null || !(0, $cLH01.h).call(props, 'css')) return $5FkrB.createElement.apply(undefined, args);
    var argsLength = args.length;
    var createElementArgArray = new Array(argsLength);
    createElementArgArray[0] = (0, $cLH01.E);
    createElementArgArray[1] = (0, $cLH01.c)(type, props);
    for(var i = 2; i < argsLength; i++)createElementArgArray[i] = args[i];
    return $5FkrB.createElement.apply(null, createElementArgArray);
};
(function(_jsx) {
    var JSX;
    JSX || (JSX = _jsx.JSX || (_jsx.JSX = {}));
})($1bbaca91e5cf6bc9$export$c8a8987d4410bf2d || ($1bbaca91e5cf6bc9$export$c8a8987d4410bf2d = {}));
// initial render from browser, insertBefore context.sheet.tags[0] or if a style hasn't been inserted there yet, appendChild
// initial client-side render from SSR, use place of hydrating tag
var $1bbaca91e5cf6bc9$export$98f03c5d19621d70 = /* #__PURE__ */ (0, $cLH01.w)(function(props, cache) {
    var styles = props.styles;
    var serialized = (0, $ckRFu.serializeStyles)([
        styles
    ], undefined, $5FkrB.useContext((0, $cLH01.T)));
    // but it is based on a constant that will never change at runtime
    // it's effectively like having two implementations and switching them out
    // so it's not actually breaking anything
    var sheetRef = $5FkrB.useRef();
    (0, $4Sr34.useInsertionEffectWithLayoutFallback)(function() {
        var key = cache.key + "-global"; // use case of https://github.com/emotion-js/emotion/issues/2675
        var sheet = new cache.sheet.constructor({
            key: key,
            nonce: cache.sheet.nonce,
            container: cache.sheet.container,
            speedy: cache.sheet.isSpeedy
        });
        var rehydrating = false;
        var node = document.querySelector("style[data-emotion=\"" + key + " " + serialized.name + "\"]");
        if (cache.sheet.tags.length) sheet.before = cache.sheet.tags[0];
        if (node !== null) {
            rehydrating = true; // clear the hash so this node won't be recognizable as rehydratable by other <Global/>s
            node.setAttribute('data-emotion', key);
            sheet.hydrate([
                node
            ]);
        }
        sheetRef.current = [
            sheet,
            rehydrating
        ];
        return function() {
            sheet.flush();
        };
    }, [
        cache
    ]);
    (0, $4Sr34.useInsertionEffectWithLayoutFallback)(function() {
        var sheetRefCurrent = sheetRef.current;
        var sheet = sheetRefCurrent[0], rehydrating = sheetRefCurrent[1];
        if (rehydrating) {
            sheetRefCurrent[1] = false;
            return;
        }
        if (serialized.next !== undefined) // insert keyframes
        (0, $hXf6E.insertStyles)(cache, serialized.next, true);
        if (sheet.tags.length) {
            // if this doesn't exist then it will be null so the style element will be appended
            var element = sheet.tags[sheet.tags.length - 1].nextElementSibling;
            sheet.before = element;
            sheet.flush();
        }
        cache.insert("", serialized, sheet, false);
    }, [
        cache,
        serialized.name
    ]);
    return null;
});
function $1bbaca91e5cf6bc9$export$dbf350e5966cf602() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return (0, $ckRFu.serializeStyles)(args);
}
function $1bbaca91e5cf6bc9$export$d25ddfdf17c3ad3e() {
    var insertable = $1bbaca91e5cf6bc9$export$dbf350e5966cf602.apply(void 0, arguments);
    var name = "animation-" + insertable.name;
    return {
        name: name,
        styles: "@keyframes " + name + "{" + insertable.styles + "}",
        anim: 1,
        toString: function toString() {
            return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
        }
    };
}
var $1bbaca91e5cf6bc9$var$classnames = function classnames(args) {
    var len = args.length;
    var i = 0;
    var cls = '';
    for(; i < len; i++){
        var arg = args[i];
        if (arg == null) continue;
        var toAdd = void 0;
        switch(typeof arg){
            case 'boolean':
                break;
            case 'object':
                if (Array.isArray(arg)) toAdd = classnames(arg);
                else {
                    toAdd = '';
                    for(var k in arg)if (arg[k] && k) {
                        toAdd && (toAdd += ' ');
                        toAdd += k;
                    }
                }
                break;
            default:
                toAdd = arg;
        }
        if (toAdd) {
            cls && (cls += ' ');
            cls += toAdd;
        }
    }
    return cls;
};
function $1bbaca91e5cf6bc9$var$merge(registered, css, className) {
    var registeredStyles = [];
    var rawClassName = (0, $hXf6E.getRegisteredStyles)(registered, registeredStyles, className);
    if (registeredStyles.length < 2) return className;
    return rawClassName + css(registeredStyles);
}
var $1bbaca91e5cf6bc9$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serializedArr = _ref.serializedArr;
    (0, $4Sr34.useInsertionEffectAlwaysWithSyncFallback)(function() {
        for(var i = 0; i < serializedArr.length; i++)(0, $hXf6E.insertStyles)(cache, serializedArr[i], false);
    });
    return null;
};
var $1bbaca91e5cf6bc9$export$9b9c0f9d9f3552b8 = /* #__PURE__ */ (0, $cLH01.w)(function(props, cache) {
    var hasRendered = false;
    var serializedArr = [];
    var css = function css() {
        if (hasRendered && (0, $cLH01.i)) throw new Error('css can only be used during render');
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        var serialized = (0, $ckRFu.serializeStyles)(args, cache.registered);
        serializedArr.push(serialized); // registration has to happen here as the result of this might get consumed by `cx`
        (0, $hXf6E.registerStyles)(cache, serialized, false);
        return cache.key + "-" + serialized.name;
    };
    var cx = function cx() {
        if (hasRendered && (0, $cLH01.i)) throw new Error('cx can only be used during render');
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        return $1bbaca91e5cf6bc9$var$merge(cache.registered, css, $1bbaca91e5cf6bc9$var$classnames(args));
    };
    var content = {
        css: css,
        cx: cx,
        theme: $5FkrB.useContext((0, $cLH01.T))
    };
    var ele = props.children(content);
    hasRendered = true;
    return /*#__PURE__*/ $5FkrB.createElement($5FkrB.Fragment, null, /*#__PURE__*/ $5FkrB.createElement($1bbaca91e5cf6bc9$var$Insertion, {
        cache: cache,
        serializedArr: serializedArr
    }), ele);
});

});
parcelRegister("cLH01", function(module, exports) {
$parcel$export(module.exports, "i", () => $94bb3a93e1dde1bf$export$23f2a1d2818174ef);
$parcel$export(module.exports, "w", () => $94bb3a93e1dde1bf$export$efccba1c4a2ef57b);
$parcel$export(module.exports, "T", () => $94bb3a93e1dde1bf$export$971d5caa766a69d7);
$parcel$export(module.exports, "h", () => $94bb3a93e1dde1bf$export$dda1d9f60106f0e9);
$parcel$export(module.exports, "c", () => $94bb3a93e1dde1bf$export$db3b6bfb95261072);
$parcel$export(module.exports, "E", () => $94bb3a93e1dde1bf$export$a9c23c6ac3fc3eca);

var $5FkrB = parcelRequire("5FkrB");

var $3GBPy = parcelRequire("3GBPy");

var $6NXXp = parcelRequire("6NXXp");

var $1QNjI = parcelRequire("1QNjI");

var $6sA7e = parcelRequire("6sA7e");

var $hXf6E = parcelRequire("hXf6E");

var $ckRFu = parcelRequire("ckRFu");

var $4Sr34 = parcelRequire("4Sr34");
var $94bb3a93e1dde1bf$export$23f2a1d2818174ef = false;
var $94bb3a93e1dde1bf$var$EmotionCacheContext = /* #__PURE__ */ $5FkrB.createContext(// because this module is primarily intended for the browser and node
// but it's also required in react native and similar environments sometimes
// and we could have a special build just for that
// but this is much easier and the native packages
// might use a different theme context in the future anyway
typeof HTMLElement !== 'undefined' ? /* #__PURE__ */ (0, $3GBPy.default)({
    key: 'css'
}) : null);
var $94bb3a93e1dde1bf$export$e7094788287c5e9b = $94bb3a93e1dde1bf$var$EmotionCacheContext.Provider;
var $94bb3a93e1dde1bf$export$71511d61b312f219 = function useEmotionCache() {
    return (0, $5FkrB.useContext)($94bb3a93e1dde1bf$var$EmotionCacheContext);
};
var $94bb3a93e1dde1bf$export$efccba1c4a2ef57b = function withEmotionCache(func) {
    return /*#__PURE__*/ (0, $5FkrB.forwardRef)(function(props, ref) {
        // the cache will never be null in the browser
        var cache = (0, $5FkrB.useContext)($94bb3a93e1dde1bf$var$EmotionCacheContext);
        return func(props, cache, ref);
    });
};
var $94bb3a93e1dde1bf$export$971d5caa766a69d7 = /* #__PURE__ */ $5FkrB.createContext({});
var $94bb3a93e1dde1bf$export$3b14a55fb2447963 = function useTheme() {
    return $5FkrB.useContext($94bb3a93e1dde1bf$export$971d5caa766a69d7);
};
var $94bb3a93e1dde1bf$var$getTheme = function getTheme(outerTheme, theme) {
    if (typeof theme === 'function') {
        var mergedTheme = theme(outerTheme);
        return mergedTheme;
    }
    return (0, $6NXXp.default)({}, outerTheme, theme);
};
var $94bb3a93e1dde1bf$var$createCacheWithTheme = /* #__PURE__ */ (0, $1QNjI.default)(function(outerTheme) {
    return (0, $1QNjI.default)(function(theme) {
        return $94bb3a93e1dde1bf$var$getTheme(outerTheme, theme);
    });
});
var $94bb3a93e1dde1bf$export$407448d2b89b1813 = function ThemeProvider(props) {
    var theme = $5FkrB.useContext($94bb3a93e1dde1bf$export$971d5caa766a69d7);
    if (props.theme !== theme) theme = $94bb3a93e1dde1bf$var$createCacheWithTheme(theme)(props.theme);
    return /*#__PURE__*/ $5FkrB.createElement($94bb3a93e1dde1bf$export$971d5caa766a69d7.Provider, {
        value: theme
    }, props.children);
};
function $94bb3a93e1dde1bf$export$8b22cf2602fb60ce(Component) {
    var componentName = Component.displayName || Component.name || 'Component';
    var WithTheme = /*#__PURE__*/ $5FkrB.forwardRef(function render(props, ref) {
        var theme = $5FkrB.useContext($94bb3a93e1dde1bf$export$971d5caa766a69d7);
        return /*#__PURE__*/ $5FkrB.createElement(Component, (0, $6NXXp.default)({
            theme: theme,
            ref: ref
        }, props));
    });
    WithTheme.displayName = "WithTheme(" + componentName + ")";
    return (0, $6sA7e.default)(WithTheme, Component);
}
var $94bb3a93e1dde1bf$export$dda1d9f60106f0e9 = {}.hasOwnProperty;
var $94bb3a93e1dde1bf$var$typePropName = '__EMOTION_TYPE_PLEASE_DO_NOT_USE__';
var $94bb3a93e1dde1bf$export$db3b6bfb95261072 = function createEmotionProps(type, props) {
    var newProps = {};
    for(var _key in props)if ($94bb3a93e1dde1bf$export$dda1d9f60106f0e9.call(props, _key)) newProps[_key] = props[_key];
    newProps[$94bb3a93e1dde1bf$var$typePropName] = type; // Runtime labeling is an opt-in feature because:
    return newProps;
};
var $94bb3a93e1dde1bf$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serialized = _ref.serialized, isStringTag = _ref.isStringTag;
    (0, $hXf6E.registerStyles)(cache, serialized, isStringTag);
    (0, $4Sr34.useInsertionEffectAlwaysWithSyncFallback)(function() {
        return (0, $hXf6E.insertStyles)(cache, serialized, isStringTag);
    });
    return null;
};
var $94bb3a93e1dde1bf$var$Emotion = /* #__PURE__ */ $94bb3a93e1dde1bf$export$efccba1c4a2ef57b(function(props, cache, ref) {
    var cssProp = props.css; // so that using `css` from `emotion` and passing the result to the css prop works
    // not passing the registered cache to serializeStyles because it would
    // make certain babel optimisations not possible
    if (typeof cssProp === 'string' && cache.registered[cssProp] !== undefined) cssProp = cache.registered[cssProp];
    var WrappedComponent = props[$94bb3a93e1dde1bf$var$typePropName];
    var registeredStyles = [
        cssProp
    ];
    var className = '';
    if (typeof props.className === 'string') className = (0, $hXf6E.getRegisteredStyles)(cache.registered, registeredStyles, props.className);
    else if (props.className != null) className = props.className + " ";
    var serialized = (0, $ckRFu.serializeStyles)(registeredStyles, undefined, $5FkrB.useContext($94bb3a93e1dde1bf$export$971d5caa766a69d7));
    className += cache.key + "-" + serialized.name;
    var newProps = {};
    for(var _key2 in props)if ($94bb3a93e1dde1bf$export$dda1d9f60106f0e9.call(props, _key2) && _key2 !== 'css' && _key2 !== $94bb3a93e1dde1bf$var$typePropName && !$94bb3a93e1dde1bf$export$23f2a1d2818174ef) newProps[_key2] = props[_key2];
    newProps.className = className;
    if (ref) newProps.ref = ref;
    return /*#__PURE__*/ $5FkrB.createElement($5FkrB.Fragment, null, /*#__PURE__*/ $5FkrB.createElement($94bb3a93e1dde1bf$var$Insertion, {
        cache: cache,
        serialized: serialized,
        isStringTag: typeof WrappedComponent === 'string'
    }), /*#__PURE__*/ $5FkrB.createElement(WrappedComponent, newProps));
});
var $94bb3a93e1dde1bf$export$a9c23c6ac3fc3eca = $94bb3a93e1dde1bf$var$Emotion;

});
parcelRegister("3GBPy", function(module, exports) {
$parcel$export(module.exports, "default", () => $2af2a3b133a3d08e$export$2e2bcd8739ae039);

var $iSXTx = parcelRequire("iSXTx");

var $2dJYK = parcelRequire("2dJYK");
var $jTNKH = parcelRequire("jTNKH");
var $8NcZQ = parcelRequire("8NcZQ");
var $7BLx4 = parcelRequire("7BLx4");
var $aT1U2 = parcelRequire("aT1U2");
var $jQwWU = parcelRequire("jQwWU");
parcelRequire("1QNjI");
parcelRequire("7VhhO");
var $2af2a3b133a3d08e$var$identifierWithPointTracking = function identifierWithPointTracking(begin, points, index) {
    var previous = 0;
    var character = 0;
    while(true){
        previous = character;
        character = (0, $2dJYK.peek)(); // &\f
        if (previous === 38 && character === 12) points[index] = 1;
        if ((0, $2dJYK.token)(character)) break;
        (0, $2dJYK.next)();
    }
    return (0, $2dJYK.slice)(begin, (0, $2dJYK.position));
};
var $2af2a3b133a3d08e$var$toRules = function toRules(parsed, points) {
    // pretend we've started with a comma
    var index = -1;
    var character = 44;
    do switch((0, $2dJYK.token)(character)){
        case 0:
            // &\f
            if (character === 38 && (0, $2dJYK.peek)() === 12) // this is not 100% correct, we don't account for literal sequences here - like for example quoted strings
            // stylis inserts \f after & to know when & where it should replace this sequence with the context selector
            // and when it should just concatenate the outer and inner selectors
            // it's very unlikely for this sequence to actually appear in a different context, so we just leverage this fact here
            points[index] = 1;
            parsed[index] += $2af2a3b133a3d08e$var$identifierWithPointTracking((0, $2dJYK.position) - 1, points, index);
            break;
        case 2:
            parsed[index] += (0, $2dJYK.delimit)(character);
            break;
        case 4:
            // comma
            if (character === 44) {
                // colon
                parsed[++index] = (0, $2dJYK.peek)() === 58 ? '&\f' : '';
                points[index] = parsed[index].length;
                break;
            }
        // fallthrough
        default:
            parsed[index] += (0, $jTNKH.from)(character);
    }
    while (character = (0, $2dJYK.next)());
    return parsed;
};
var $2af2a3b133a3d08e$var$getRules = function getRules(value, points) {
    return (0, $2dJYK.dealloc)($2af2a3b133a3d08e$var$toRules((0, $2dJYK.alloc)(value), points));
}; // WeakSet would be more appropriate, but only WeakMap is supported in IE11
var $2af2a3b133a3d08e$var$fixedElements = /* #__PURE__ */ new WeakMap();
var $2af2a3b133a3d08e$var$compat = function compat(element) {
    if (element.type !== 'rule' || !element.parent || // positive .length indicates that this rule contains pseudo
    // negative .length indicates that this rule has been already prefixed
    element.length < 1) return;
    var value = element.value;
    var parent = element.parent;
    var isImplicitRule = element.column === parent.column && element.line === parent.line;
    while(parent.type !== 'rule'){
        parent = parent.parent;
        if (!parent) return;
    } // short-circuit for the simplest case
    if (element.props.length === 1 && value.charCodeAt(0) !== 58 && !$2af2a3b133a3d08e$var$fixedElements.get(parent)) return;
     // if this is an implicitly inserted rule (the one eagerly inserted at the each new nested level)
    // then the props has already been manipulated beforehand as they that array is shared between it and its "rule parent"
    if (isImplicitRule) return;
    $2af2a3b133a3d08e$var$fixedElements.set(element, true);
    var points = [];
    var rules = $2af2a3b133a3d08e$var$getRules(value, points);
    var parentRules = parent.props;
    for(var i = 0, k = 0; i < rules.length; i++)for(var j = 0; j < parentRules.length; j++, k++)element.props[k] = points[i] ? rules[i].replace(/&\f/g, parentRules[j]) : parentRules[j] + " " + rules[i];
};
var $2af2a3b133a3d08e$var$removeLabel = function removeLabel(element) {
    if (element.type === 'decl') {
        var value = element.value;
        if (value.charCodeAt(0) === 108 && // charcode for b
        value.charCodeAt(2) === 98) {
            // this ignores label
            element["return"] = '';
            element.value = '';
        }
    }
};
/* eslint-disable no-fallthrough */ function $2af2a3b133a3d08e$var$prefix(value, length) {
    switch((0, $jTNKH.hash)(value, length)){
        // color-adjust
        case 5103:
            return (0, $7BLx4.WEBKIT) + 'print-' + value + value;
        // animation, animation-(delay|direction|duration|fill-mode|iteration-count|name|play-state|timing-function)
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return (0, $7BLx4.WEBKIT) + value + value;
        // appearance, user-select, transform, hyphens, text-size-adjust
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return (0, $7BLx4.WEBKIT) + value + (0, $7BLx4.MOZ) + value + (0, $7BLx4.MS) + value + value;
        // flex, flex-direction
        case 6828:
        case 4268:
            return (0, $7BLx4.WEBKIT) + value + (0, $7BLx4.MS) + value + value;
        // order
        case 6165:
            return (0, $7BLx4.WEBKIT) + value + (0, $7BLx4.MS) + 'flex-' + value + value;
        // align-items
        case 5187:
            return (0, $7BLx4.WEBKIT) + value + (0, $jTNKH.replace)(value, /(\w+).+(:[^]+)/, (0, $7BLx4.WEBKIT) + 'box-$1$2' + (0, $7BLx4.MS) + 'flex-$1$2') + value;
        // align-self
        case 5443:
            return (0, $7BLx4.WEBKIT) + value + (0, $7BLx4.MS) + 'flex-item-' + (0, $jTNKH.replace)(value, /flex-|-self/, '') + value;
        // align-content
        case 4675:
            return (0, $7BLx4.WEBKIT) + value + (0, $7BLx4.MS) + 'flex-line-pack' + (0, $jTNKH.replace)(value, /align-content|flex-|-self/, '') + value;
        // flex-shrink
        case 5548:
            return (0, $7BLx4.WEBKIT) + value + (0, $7BLx4.MS) + (0, $jTNKH.replace)(value, 'shrink', 'negative') + value;
        // flex-basis
        case 5292:
            return (0, $7BLx4.WEBKIT) + value + (0, $7BLx4.MS) + (0, $jTNKH.replace)(value, 'basis', 'preferred-size') + value;
        // flex-grow
        case 6060:
            return (0, $7BLx4.WEBKIT) + 'box-' + (0, $jTNKH.replace)(value, '-grow', '') + (0, $7BLx4.WEBKIT) + value + (0, $7BLx4.MS) + (0, $jTNKH.replace)(value, 'grow', 'positive') + value;
        // transition
        case 4554:
            return (0, $7BLx4.WEBKIT) + (0, $jTNKH.replace)(value, /([^-])(transform)/g, '$1' + (0, $7BLx4.WEBKIT) + '$2') + value;
        // cursor
        case 6187:
            return (0, $jTNKH.replace)((0, $jTNKH.replace)((0, $jTNKH.replace)(value, /(zoom-|grab)/, (0, $7BLx4.WEBKIT) + '$1'), /(image-set)/, (0, $7BLx4.WEBKIT) + '$1'), value, '') + value;
        // background, background-image
        case 5495:
        case 3959:
            return (0, $jTNKH.replace)(value, /(image-set\([^]*)/, (0, $7BLx4.WEBKIT) + '$1' + '$`$1');
        // justify-content
        case 4968:
            return (0, $jTNKH.replace)((0, $jTNKH.replace)(value, /(.+:)(flex-)?(.*)/, (0, $7BLx4.WEBKIT) + 'box-pack:$3' + (0, $7BLx4.MS) + 'flex-pack:$3'), /s.+-b[^;]+/, 'justify') + (0, $7BLx4.WEBKIT) + value + value;
        // (margin|padding)-inline-(start|end)
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return (0, $jTNKH.replace)(value, /(.+)-inline(.+)/, (0, $7BLx4.WEBKIT) + '$1$2') + value;
        // (min|max)?(width|height|inline-size|block-size)
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            // stretch, max-content, min-content, fill-available
            if ((0, $jTNKH.strlen)(value) - 1 - length > 6) switch((0, $jTNKH.charat)(value, length + 1)){
                // (m)ax-content, (m)in-content
                case 109:
                    // -
                    if ((0, $jTNKH.charat)(value, length + 4) !== 45) break;
                // (f)ill-available, (f)it-content
                case 102:
                    return (0, $jTNKH.replace)(value, /(.+:)(.+)-([^]+)/, '$1' + (0, $7BLx4.WEBKIT) + '$2-$3' + '$1' + (0, $7BLx4.MOZ) + ((0, $jTNKH.charat)(value, length + 3) == 108 ? '$3' : '$2-$3')) + value;
                // (s)tretch
                case 115:
                    return ~(0, $jTNKH.indexof)(value, 'stretch') ? $2af2a3b133a3d08e$var$prefix((0, $jTNKH.replace)(value, 'stretch', 'fill-available'), length) + value : value;
            }
            break;
        // position: sticky
        case 4949:
            // (s)ticky?
            if ((0, $jTNKH.charat)(value, length + 1) !== 115) break;
        // display: (flex|inline-flex)
        case 6444:
            switch((0, $jTNKH.charat)(value, (0, $jTNKH.strlen)(value) - 3 - (~(0, $jTNKH.indexof)(value, '!important') && 10))){
                // stic(k)y
                case 107:
                    return (0, $jTNKH.replace)(value, ':', ':' + (0, $7BLx4.WEBKIT)) + value;
                // (inline-)?fl(e)x
                case 101:
                    return (0, $jTNKH.replace)(value, /(.+:)([^;!]+)(;|!.+)?/, '$1' + (0, $7BLx4.WEBKIT) + ((0, $jTNKH.charat)(value, 14) === 45 ? 'inline-' : '') + 'box$3' + '$1' + (0, $7BLx4.WEBKIT) + '$2$3' + '$1' + (0, $7BLx4.MS) + '$2box$3') + value;
            }
            break;
        // writing-mode
        case 5936:
            switch((0, $jTNKH.charat)(value, length + 11)){
                // vertical-l(r)
                case 114:
                    return (0, $7BLx4.WEBKIT) + value + (0, $7BLx4.MS) + (0, $jTNKH.replace)(value, /[svh]\w+-[tblr]{2}/, 'tb') + value;
                // vertical-r(l)
                case 108:
                    return (0, $7BLx4.WEBKIT) + value + (0, $7BLx4.MS) + (0, $jTNKH.replace)(value, /[svh]\w+-[tblr]{2}/, 'tb-rl') + value;
                // horizontal(-)tb
                case 45:
                    return (0, $7BLx4.WEBKIT) + value + (0, $7BLx4.MS) + (0, $jTNKH.replace)(value, /[svh]\w+-[tblr]{2}/, 'lr') + value;
            }
            return (0, $7BLx4.WEBKIT) + value + (0, $7BLx4.MS) + value + value;
    }
    return value;
}
var $2af2a3b133a3d08e$var$prefixer = function prefixer(element, index, children, callback) {
    if (element.length > -1) {
        if (!element["return"]) switch(element.type){
            case 0, $7BLx4.DECLARATION:
                element["return"] = $2af2a3b133a3d08e$var$prefix(element.value, element.length);
                break;
            case 0, $7BLx4.KEYFRAMES:
                return (0, $jQwWU.serialize)([
                    (0, $2dJYK.copy)(element, {
                        value: (0, $jTNKH.replace)(element.value, '@', '@' + (0, $7BLx4.WEBKIT))
                    })
                ], callback);
            case 0, $7BLx4.RULESET:
                if (element.length) return (0, $jTNKH.combine)(element.props, function(value) {
                    switch((0, $jTNKH.match)(value, /(::plac\w+|:read-\w+)/)){
                        // :read-(only|write)
                        case ':read-only':
                        case ':read-write':
                            return (0, $jQwWU.serialize)([
                                (0, $2dJYK.copy)(element, {
                                    props: [
                                        (0, $jTNKH.replace)(value, /:(read-\w+)/, ':' + (0, $7BLx4.MOZ) + '$1')
                                    ]
                                })
                            ], callback);
                        // :placeholder
                        case '::placeholder':
                            return (0, $jQwWU.serialize)([
                                (0, $2dJYK.copy)(element, {
                                    props: [
                                        (0, $jTNKH.replace)(value, /:(plac\w+)/, ':' + (0, $7BLx4.WEBKIT) + 'input-$1')
                                    ]
                                }),
                                (0, $2dJYK.copy)(element, {
                                    props: [
                                        (0, $jTNKH.replace)(value, /:(plac\w+)/, ':' + (0, $7BLx4.MOZ) + '$1')
                                    ]
                                }),
                                (0, $2dJYK.copy)(element, {
                                    props: [
                                        (0, $jTNKH.replace)(value, /:(plac\w+)/, (0, $7BLx4.MS) + 'input-$1')
                                    ]
                                })
                            ], callback);
                    }
                    return '';
                });
        }
    }
};
var $2af2a3b133a3d08e$var$defaultStylisPlugins = [
    $2af2a3b133a3d08e$var$prefixer
];
var $2af2a3b133a3d08e$export$2e2bcd8739ae039 = function createCache(options) {
    var key = options.key;
    if (key === 'css') {
        var ssrStyles = document.querySelectorAll("style[data-emotion]:not([data-s])"); // get SSRed styles out of the way of React's hydration
        // document.head is a safe place to move them to(though note document.head is not necessarily the last place they will be)
        // note this very very intentionally targets all style elements regardless of the key to ensure
        // that creating a cache works inside of render of a React component
        Array.prototype.forEach.call(ssrStyles, function(node) {
            // we want to only move elements which have a space in the data-emotion attribute value
            // because that indicates that it is an Emotion 11 server-side rendered style elements
            // while we will already ignore Emotion 11 client-side inserted styles because of the :not([data-s]) part in the selector
            // Emotion 10 client-side inserted styles did not have data-s (but importantly did not have a space in their data-emotion attributes)
            // so checking for the space ensures that loading Emotion 11 after Emotion 10 has inserted some styles
            // will not result in the Emotion 10 styles being destroyed
            var dataEmotionAttribute = node.getAttribute('data-emotion');
            if (dataEmotionAttribute.indexOf(' ') === -1) return;
            document.head.appendChild(node);
            node.setAttribute('data-s', '');
        });
    }
    var stylisPlugins = options.stylisPlugins || $2af2a3b133a3d08e$var$defaultStylisPlugins;
    var inserted = {};
    var container;
    var nodesToHydrate = [];
    container = options.container || document.head;
    Array.prototype.forEach.call(// means that the style elements we're looking at are only Emotion 11 server-rendered style elements
    document.querySelectorAll("style[data-emotion^=\"" + key + " \"]"), function(node) {
        var attrib = node.getAttribute("data-emotion").split(' ');
        for(var i = 1; i < attrib.length; i++)inserted[attrib[i]] = true;
        nodesToHydrate.push(node);
    });
    var _insert;
    var omnipresentPlugins = [
        $2af2a3b133a3d08e$var$compat,
        $2af2a3b133a3d08e$var$removeLabel
    ];
    var currentSheet;
    var finalizingPlugins = [
        (0, $jQwWU.stringify),
        (0, $aT1U2.rulesheet)(function(rule) {
            currentSheet.insert(rule);
        })
    ];
    var serializer = (0, $aT1U2.middleware)(omnipresentPlugins.concat(stylisPlugins, finalizingPlugins));
    var stylis = function stylis(styles) {
        return (0, $jQwWU.serialize)((0, $8NcZQ.compile)(styles), serializer);
    };
    _insert = function insert(selector, serialized, sheet, shouldCache) {
        currentSheet = sheet;
        stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);
        if (shouldCache) cache.inserted[serialized.name] = true;
    };
    var cache = {
        key: key,
        sheet: new (0, $iSXTx.StyleSheet)({
            key: key,
            container: container,
            nonce: options.nonce,
            speedy: options.speedy,
            prepend: options.prepend,
            insertionPoint: options.insertionPoint
        }),
        nonce: options.nonce,
        inserted: inserted,
        registered: {},
        insert: _insert
    };
    cache.sheet.hydrate(nodesToHydrate);
    return cache;
};

});
parcelRegister("iSXTx", function(module, exports) {
$parcel$export(module.exports, "StyleSheet", () => $dbfbbb00930f8e37$export$9d753cd7ae895cce);
var $dbfbbb00930f8e37$var$isDevelopment = false;
/*

Based off glamor's StyleSheet, thanks Sunil ❤️

high performance StyleSheet for css-in-js systems

- uses multiple style tags behind the scenes for millions of rules
- uses `insertRule` for appending in production for *much* faster performance

// usage

import { StyleSheet } from '@emotion/sheet'

let styleSheet = new StyleSheet({ key: '', container: document.head })

styleSheet.insert('#box { border: 1px solid red; }')
- appends a css rule into the stylesheet

styleSheet.flush()
- empties the stylesheet of all its contents

*/ function $dbfbbb00930f8e37$var$sheetForTag(tag) {
    if (tag.sheet) return tag.sheet;
     // this weirdness brought to you by firefox
    /* istanbul ignore next */ for(var i = 0; i < document.styleSheets.length; i++){
        if (document.styleSheets[i].ownerNode === tag) return document.styleSheets[i];
    } // this function should always return with a value
    // TS can't understand it though so we make it stop complaining here
    return undefined;
}
function $dbfbbb00930f8e37$var$createStyleElement(options) {
    var tag = document.createElement('style');
    tag.setAttribute('data-emotion', options.key);
    if (options.nonce !== undefined) tag.setAttribute('nonce', options.nonce);
    tag.appendChild(document.createTextNode(''));
    tag.setAttribute('data-s', '');
    return tag;
}
var $dbfbbb00930f8e37$export$9d753cd7ae895cce = /*#__PURE__*/ function() {
    // Using Node instead of HTMLElement since container may be a ShadowRoot
    function StyleSheet(options) {
        var _this = this;
        this._insertTag = function(tag) {
            var before;
            if (_this.tags.length === 0) {
                if (_this.insertionPoint) before = _this.insertionPoint.nextSibling;
                else if (_this.prepend) before = _this.container.firstChild;
                else before = _this.before;
            } else before = _this.tags[_this.tags.length - 1].nextSibling;
            _this.container.insertBefore(tag, before);
            _this.tags.push(tag);
        };
        this.isSpeedy = options.speedy === undefined ? !$dbfbbb00930f8e37$var$isDevelopment : options.speedy;
        this.tags = [];
        this.ctr = 0;
        this.nonce = options.nonce; // key is the value of the data-emotion attribute, it's used to identify different sheets
        this.key = options.key;
        this.container = options.container;
        this.prepend = options.prepend;
        this.insertionPoint = options.insertionPoint;
        this.before = null;
    }
    var _proto = StyleSheet.prototype;
    _proto.hydrate = function hydrate(nodes) {
        nodes.forEach(this._insertTag);
    };
    _proto.insert = function insert(rule) {
        // the max length is how many rules we have per style tag, it's 65000 in speedy mode
        // it's 1 in dev because we insert source maps that map a single rule to a location
        // and you can only have one source map per style tag
        if (this.ctr % (this.isSpeedy ? 65000 : 1) === 0) this._insertTag($dbfbbb00930f8e37$var$createStyleElement(this));
        var tag = this.tags[this.tags.length - 1];
        if (this.isSpeedy) {
            var sheet = $dbfbbb00930f8e37$var$sheetForTag(tag);
            try {
                // this is the ultrafast version, works across browsers
                // the big drawback is that the css won't be editable in devtools
                sheet.insertRule(rule, sheet.cssRules.length);
            } catch (e) {}
        } else tag.appendChild(document.createTextNode(rule));
        this.ctr++;
    };
    _proto.flush = function flush() {
        this.tags.forEach(function(tag) {
            var _tag$parentNode;
            return (_tag$parentNode = tag.parentNode) == null ? void 0 : _tag$parentNode.removeChild(tag);
        });
        this.tags = [];
        this.ctr = 0;
    };
    return StyleSheet;
}();

});

parcelRegister("2dJYK", function(module, exports) {
$parcel$export(module.exports, "position", () => $19e0761c4f2d2ff1$export$5880b8b5730aff45);
$parcel$export(module.exports, "node", () => $19e0761c4f2d2ff1$export$35059013cd4a06db);
$parcel$export(module.exports, "copy", () => $19e0761c4f2d2ff1$export$784d13d8ee351f07);
$parcel$export(module.exports, "char", () => $19e0761c4f2d2ff1$export$eba6f6f03b0a92e7);
$parcel$export(module.exports, "prev", () => $19e0761c4f2d2ff1$export$232faf9add678146);
$parcel$export(module.exports, "next", () => $19e0761c4f2d2ff1$export$48cfd1e771a65c4f);
$parcel$export(module.exports, "peek", () => $19e0761c4f2d2ff1$export$4d3fb11e950abb9e);
$parcel$export(module.exports, "caret", () => $19e0761c4f2d2ff1$export$e88cb2efb12ae807);
$parcel$export(module.exports, "slice", () => $19e0761c4f2d2ff1$export$58adb3bec8346d0f);
$parcel$export(module.exports, "token", () => $19e0761c4f2d2ff1$export$9e1725a4cfeada27);
$parcel$export(module.exports, "alloc", () => $19e0761c4f2d2ff1$export$2de70f21292aac9e);
$parcel$export(module.exports, "dealloc", () => $19e0761c4f2d2ff1$export$45918ac1574455b1);
$parcel$export(module.exports, "delimit", () => $19e0761c4f2d2ff1$export$410ac95b9ec204b8);
$parcel$export(module.exports, "tokenize", () => $19e0761c4f2d2ff1$export$660b2ee2d4fb4eff);
$parcel$export(module.exports, "whitespace", () => $19e0761c4f2d2ff1$export$7af1228ff777d175);
$parcel$export(module.exports, "identifier", () => $19e0761c4f2d2ff1$export$c2ab62c7bf24634);
$parcel$export(module.exports, "escaping", () => $19e0761c4f2d2ff1$export$955ba06d119e085e);
$parcel$export(module.exports, "commenter", () => $19e0761c4f2d2ff1$export$4254d4e2b3745c4c);

var $jTNKH = parcelRequire("jTNKH");
var $19e0761c4f2d2ff1$export$53f1d5ea8de3d7c = 1;
var $19e0761c4f2d2ff1$export$4e0c71f277ca26b3 = 1;
var $19e0761c4f2d2ff1$export$f24224f1c91d8156 = 0;
var $19e0761c4f2d2ff1$export$5880b8b5730aff45 = 0;
var $19e0761c4f2d2ff1$export$c0306caf338ac095 = 0;
var $19e0761c4f2d2ff1$export$30a86d91af8ff6e6 = '';
function $19e0761c4f2d2ff1$export$35059013cd4a06db(value, root, parent, type, props, children, length) {
    return {
        value: value,
        root: root,
        parent: parent,
        type: type,
        props: props,
        children: children,
        line: $19e0761c4f2d2ff1$export$53f1d5ea8de3d7c,
        column: $19e0761c4f2d2ff1$export$4e0c71f277ca26b3,
        length: length,
        return: ''
    };
}
function $19e0761c4f2d2ff1$export$784d13d8ee351f07(root, props) {
    return (0, $jTNKH.assign)($19e0761c4f2d2ff1$export$35059013cd4a06db('', null, null, '', null, null, 0), root, {
        length: -root.length
    }, props);
}
function $19e0761c4f2d2ff1$export$eba6f6f03b0a92e7() {
    return $19e0761c4f2d2ff1$export$c0306caf338ac095;
}
function $19e0761c4f2d2ff1$export$232faf9add678146() {
    $19e0761c4f2d2ff1$export$c0306caf338ac095 = $19e0761c4f2d2ff1$export$5880b8b5730aff45 > 0 ? (0, $jTNKH.charat)($19e0761c4f2d2ff1$export$30a86d91af8ff6e6, --$19e0761c4f2d2ff1$export$5880b8b5730aff45) : 0;
    if ($19e0761c4f2d2ff1$export$4e0c71f277ca26b3--, $19e0761c4f2d2ff1$export$c0306caf338ac095 === 10) $19e0761c4f2d2ff1$export$4e0c71f277ca26b3 = 1, $19e0761c4f2d2ff1$export$53f1d5ea8de3d7c--;
    return $19e0761c4f2d2ff1$export$c0306caf338ac095;
}
function $19e0761c4f2d2ff1$export$48cfd1e771a65c4f() {
    $19e0761c4f2d2ff1$export$c0306caf338ac095 = $19e0761c4f2d2ff1$export$5880b8b5730aff45 < $19e0761c4f2d2ff1$export$f24224f1c91d8156 ? (0, $jTNKH.charat)($19e0761c4f2d2ff1$export$30a86d91af8ff6e6, $19e0761c4f2d2ff1$export$5880b8b5730aff45++) : 0;
    if ($19e0761c4f2d2ff1$export$4e0c71f277ca26b3++, $19e0761c4f2d2ff1$export$c0306caf338ac095 === 10) $19e0761c4f2d2ff1$export$4e0c71f277ca26b3 = 1, $19e0761c4f2d2ff1$export$53f1d5ea8de3d7c++;
    return $19e0761c4f2d2ff1$export$c0306caf338ac095;
}
function $19e0761c4f2d2ff1$export$4d3fb11e950abb9e() {
    return (0, $jTNKH.charat)($19e0761c4f2d2ff1$export$30a86d91af8ff6e6, $19e0761c4f2d2ff1$export$5880b8b5730aff45);
}
function $19e0761c4f2d2ff1$export$e88cb2efb12ae807() {
    return $19e0761c4f2d2ff1$export$5880b8b5730aff45;
}
function $19e0761c4f2d2ff1$export$58adb3bec8346d0f(begin, end) {
    return (0, $jTNKH.substr)($19e0761c4f2d2ff1$export$30a86d91af8ff6e6, begin, end);
}
function $19e0761c4f2d2ff1$export$9e1725a4cfeada27(type) {
    switch(type){
        // \0 \t \n \r \s whitespace token
        case 0:
        case 9:
        case 10:
        case 13:
        case 32:
            return 5;
        // ! + , / > @ ~ isolate token
        case 33:
        case 43:
        case 44:
        case 47:
        case 62:
        case 64:
        case 126:
        // ; { } breakpoint token
        case 59:
        case 123:
        case 125:
            return 4;
        // : accompanied token
        case 58:
            return 3;
        // " ' ( [ opening delimit token
        case 34:
        case 39:
        case 40:
        case 91:
            return 2;
        // ) ] closing delimit token
        case 41:
        case 93:
            return 1;
    }
    return 0;
}
function $19e0761c4f2d2ff1$export$2de70f21292aac9e(value) {
    return $19e0761c4f2d2ff1$export$53f1d5ea8de3d7c = $19e0761c4f2d2ff1$export$4e0c71f277ca26b3 = 1, $19e0761c4f2d2ff1$export$f24224f1c91d8156 = (0, $jTNKH.strlen)($19e0761c4f2d2ff1$export$30a86d91af8ff6e6 = value), $19e0761c4f2d2ff1$export$5880b8b5730aff45 = 0, [];
}
function $19e0761c4f2d2ff1$export$45918ac1574455b1(value) {
    return $19e0761c4f2d2ff1$export$30a86d91af8ff6e6 = '', value;
}
function $19e0761c4f2d2ff1$export$410ac95b9ec204b8(type) {
    return (0, $jTNKH.trim)($19e0761c4f2d2ff1$export$58adb3bec8346d0f($19e0761c4f2d2ff1$export$5880b8b5730aff45 - 1, $19e0761c4f2d2ff1$export$c889f2fcc19dbf12(type === 91 ? type + 2 : type === 40 ? type + 1 : type)));
}
function $19e0761c4f2d2ff1$export$660b2ee2d4fb4eff(value) {
    return $19e0761c4f2d2ff1$export$45918ac1574455b1($19e0761c4f2d2ff1$export$5f8c09e3ae6f64e1($19e0761c4f2d2ff1$export$2de70f21292aac9e(value)));
}
function $19e0761c4f2d2ff1$export$7af1228ff777d175(type) {
    while($19e0761c4f2d2ff1$export$c0306caf338ac095 = $19e0761c4f2d2ff1$export$4d3fb11e950abb9e())if ($19e0761c4f2d2ff1$export$c0306caf338ac095 < 33) $19e0761c4f2d2ff1$export$48cfd1e771a65c4f();
    else break;
    return $19e0761c4f2d2ff1$export$9e1725a4cfeada27(type) > 2 || $19e0761c4f2d2ff1$export$9e1725a4cfeada27($19e0761c4f2d2ff1$export$c0306caf338ac095) > 3 ? '' : ' ';
}
function $19e0761c4f2d2ff1$export$5f8c09e3ae6f64e1(children) {
    while($19e0761c4f2d2ff1$export$48cfd1e771a65c4f())switch($19e0761c4f2d2ff1$export$9e1725a4cfeada27($19e0761c4f2d2ff1$export$c0306caf338ac095)){
        case 0:
            (0, $jTNKH.append)($19e0761c4f2d2ff1$export$c2ab62c7bf24634($19e0761c4f2d2ff1$export$5880b8b5730aff45 - 1), children);
            break;
        case 2:
            (0, $jTNKH.append)($19e0761c4f2d2ff1$export$410ac95b9ec204b8($19e0761c4f2d2ff1$export$c0306caf338ac095), children);
            break;
        default:
            (0, $jTNKH.append)((0, $jTNKH.from)($19e0761c4f2d2ff1$export$c0306caf338ac095), children);
    }
    return children;
}
function $19e0761c4f2d2ff1$export$955ba06d119e085e(index, count) {
    while(--count && $19e0761c4f2d2ff1$export$48cfd1e771a65c4f())// not 0-9 A-F a-f
    if ($19e0761c4f2d2ff1$export$c0306caf338ac095 < 48 || $19e0761c4f2d2ff1$export$c0306caf338ac095 > 102 || $19e0761c4f2d2ff1$export$c0306caf338ac095 > 57 && $19e0761c4f2d2ff1$export$c0306caf338ac095 < 65 || $19e0761c4f2d2ff1$export$c0306caf338ac095 > 70 && $19e0761c4f2d2ff1$export$c0306caf338ac095 < 97) break;
    return $19e0761c4f2d2ff1$export$58adb3bec8346d0f(index, $19e0761c4f2d2ff1$export$e88cb2efb12ae807() + (count < 6 && $19e0761c4f2d2ff1$export$4d3fb11e950abb9e() == 32 && $19e0761c4f2d2ff1$export$48cfd1e771a65c4f() == 32));
}
function $19e0761c4f2d2ff1$export$c889f2fcc19dbf12(type) {
    while($19e0761c4f2d2ff1$export$48cfd1e771a65c4f())switch($19e0761c4f2d2ff1$export$c0306caf338ac095){
        // ] ) " '
        case type:
            return $19e0761c4f2d2ff1$export$5880b8b5730aff45;
        // " '
        case 34:
        case 39:
            if (type !== 34 && type !== 39) $19e0761c4f2d2ff1$export$c889f2fcc19dbf12($19e0761c4f2d2ff1$export$c0306caf338ac095);
            break;
        // (
        case 40:
            if (type === 41) $19e0761c4f2d2ff1$export$c889f2fcc19dbf12(type);
            break;
        // \
        case 92:
            $19e0761c4f2d2ff1$export$48cfd1e771a65c4f();
            break;
    }
    return $19e0761c4f2d2ff1$export$5880b8b5730aff45;
}
function $19e0761c4f2d2ff1$export$4254d4e2b3745c4c(type, index) {
    while($19e0761c4f2d2ff1$export$48cfd1e771a65c4f())// //
    if (type + $19e0761c4f2d2ff1$export$c0306caf338ac095 === 57) break;
    else if (type + $19e0761c4f2d2ff1$export$c0306caf338ac095 === 84 && $19e0761c4f2d2ff1$export$4d3fb11e950abb9e() === 47) break;
    return '/*' + $19e0761c4f2d2ff1$export$58adb3bec8346d0f(index, $19e0761c4f2d2ff1$export$5880b8b5730aff45 - 1) + '*' + (0, $jTNKH.from)(type === 47 ? type : $19e0761c4f2d2ff1$export$48cfd1e771a65c4f());
}
function $19e0761c4f2d2ff1$export$c2ab62c7bf24634(index) {
    while(!$19e0761c4f2d2ff1$export$9e1725a4cfeada27($19e0761c4f2d2ff1$export$4d3fb11e950abb9e()))$19e0761c4f2d2ff1$export$48cfd1e771a65c4f();
    return $19e0761c4f2d2ff1$export$58adb3bec8346d0f(index, $19e0761c4f2d2ff1$export$5880b8b5730aff45);
}

});
parcelRegister("jTNKH", function(module, exports) {
$parcel$export(module.exports, "abs", () => $e7c9bf1da94cf2ce$export$2335f513bbd82c6d);
$parcel$export(module.exports, "from", () => $e7c9bf1da94cf2ce$export$6788812c4e6611e6);
$parcel$export(module.exports, "assign", () => $e7c9bf1da94cf2ce$export$e6e34fd1f2686227);
$parcel$export(module.exports, "hash", () => $e7c9bf1da94cf2ce$export$d6af199866bfb566);
$parcel$export(module.exports, "charat", () => $e7c9bf1da94cf2ce$export$a9db5e087081082d);
$parcel$export(module.exports, "trim", () => $e7c9bf1da94cf2ce$export$87c2784dc9fc4ab);
$parcel$export(module.exports, "match", () => $e7c9bf1da94cf2ce$export$4659b591c19bdf3d);
$parcel$export(module.exports, "replace", () => $e7c9bf1da94cf2ce$export$77ad94ebf1c2b9ed);
$parcel$export(module.exports, "indexof", () => $e7c9bf1da94cf2ce$export$f8e21b1e77979a08);
$parcel$export(module.exports, "substr", () => $e7c9bf1da94cf2ce$export$2f35ab04d2335697);
$parcel$export(module.exports, "strlen", () => $e7c9bf1da94cf2ce$export$36776f635604f274);
$parcel$export(module.exports, "sizeof", () => $e7c9bf1da94cf2ce$export$f9084667e487ed46);
$parcel$export(module.exports, "append", () => $e7c9bf1da94cf2ce$export$10d8903dec122b9d);
$parcel$export(module.exports, "combine", () => $e7c9bf1da94cf2ce$export$1be1fc439b849fdf);
/**
 * @param {number}
 * @return {number}
 */ var $e7c9bf1da94cf2ce$export$2335f513bbd82c6d = Math.abs;
var $e7c9bf1da94cf2ce$export$6788812c4e6611e6 = String.fromCharCode;
var $e7c9bf1da94cf2ce$export$e6e34fd1f2686227 = Object.assign;
function $e7c9bf1da94cf2ce$export$d6af199866bfb566(value, length) {
    return $e7c9bf1da94cf2ce$export$a9db5e087081082d(value, 0) ^ 45 ? (((length << 2 ^ $e7c9bf1da94cf2ce$export$a9db5e087081082d(value, 0)) << 2 ^ $e7c9bf1da94cf2ce$export$a9db5e087081082d(value, 1)) << 2 ^ $e7c9bf1da94cf2ce$export$a9db5e087081082d(value, 2)) << 2 ^ $e7c9bf1da94cf2ce$export$a9db5e087081082d(value, 3) : 0;
}
function $e7c9bf1da94cf2ce$export$87c2784dc9fc4ab(value) {
    return value.trim();
}
function $e7c9bf1da94cf2ce$export$4659b591c19bdf3d(value, pattern) {
    return (value = pattern.exec(value)) ? value[0] : value;
}
function $e7c9bf1da94cf2ce$export$77ad94ebf1c2b9ed(value, pattern, replacement) {
    return value.replace(pattern, replacement);
}
function $e7c9bf1da94cf2ce$export$f8e21b1e77979a08(value, search) {
    return value.indexOf(search);
}
function $e7c9bf1da94cf2ce$export$a9db5e087081082d(value, index) {
    return value.charCodeAt(index) | 0;
}
function $e7c9bf1da94cf2ce$export$2f35ab04d2335697(value, begin, end) {
    return value.slice(begin, end);
}
function $e7c9bf1da94cf2ce$export$36776f635604f274(value) {
    return value.length;
}
function $e7c9bf1da94cf2ce$export$f9084667e487ed46(value) {
    return value.length;
}
function $e7c9bf1da94cf2ce$export$10d8903dec122b9d(value, array) {
    return array.push(value), value;
}
function $e7c9bf1da94cf2ce$export$1be1fc439b849fdf(array, callback) {
    return array.map(callback).join('');
}

});


parcelRegister("8NcZQ", function(module, exports) {
$parcel$export(module.exports, "compile", () => $666cfb2ede7abf9f$export$ef7acd7185315e22);

var $7BLx4 = parcelRequire("7BLx4");

var $jTNKH = parcelRequire("jTNKH");

var $2dJYK = parcelRequire("2dJYK");
function $666cfb2ede7abf9f$export$ef7acd7185315e22(value) {
    return (0, $2dJYK.dealloc)($666cfb2ede7abf9f$export$98e6a39c04603d36('', null, null, null, [
        ''
    ], value = (0, $2dJYK.alloc)(value), 0, [
        0
    ], value));
}
function $666cfb2ede7abf9f$export$98e6a39c04603d36(value, root, parent, rule, rules, rulesets, pseudo, points, declarations) {
    var index = 0;
    var offset = 0;
    var length = pseudo;
    var atrule = 0;
    var property = 0;
    var previous = 0;
    var variable = 1;
    var scanning = 1;
    var ampersand = 1;
    var character = 0;
    var type = '';
    var props = rules;
    var children = rulesets;
    var reference = rule;
    var characters = type;
    while(scanning)switch(previous = character, character = (0, $2dJYK.next)()){
        // (
        case 40:
            if (previous != 108 && (0, $jTNKH.charat)(characters, length - 1) == 58) {
                if ((0, $jTNKH.indexof)(characters += (0, $jTNKH.replace)((0, $2dJYK.delimit)(character), '&', '&\f'), '&\f') != -1) ampersand = -1;
                break;
            }
        // " ' [
        case 34:
        case 39:
        case 91:
            characters += (0, $2dJYK.delimit)(character);
            break;
        // \t \n \r \s
        case 9:
        case 10:
        case 13:
        case 32:
            characters += (0, $2dJYK.whitespace)(previous);
            break;
        // \
        case 92:
            characters += (0, $2dJYK.escaping)((0, $2dJYK.caret)() - 1, 7);
            continue;
        // /
        case 47:
            switch((0, $2dJYK.peek)()){
                case 42:
                case 47:
                    (0, $jTNKH.append)($666cfb2ede7abf9f$export$4a34f930e789283c((0, $2dJYK.commenter)((0, $2dJYK.next)(), (0, $2dJYK.caret)()), root, parent), declarations);
                    break;
                default:
                    characters += '/';
            }
            break;
        // {
        case 123 * variable:
            points[index++] = (0, $jTNKH.strlen)(characters) * ampersand;
        // } ; \0
        case 125 * variable:
        case 59:
        case 0:
            switch(character){
                // \0 }
                case 0:
                case 125:
                    scanning = 0;
                // ;
                case 59 + offset:
                    if (ampersand == -1) characters = (0, $jTNKH.replace)(characters, /\f/g, '');
                    if (property > 0 && (0, $jTNKH.strlen)(characters) - length) (0, $jTNKH.append)(property > 32 ? $666cfb2ede7abf9f$export$f8483753829ec8f3(characters + ';', rule, parent, length - 1) : $666cfb2ede7abf9f$export$f8483753829ec8f3((0, $jTNKH.replace)(characters, ' ', '') + ';', rule, parent, length - 2), declarations);
                    break;
                // @ ;
                case 59:
                    characters += ';';
                // { rule/at-rule
                default:
                    (0, $jTNKH.append)(reference = $666cfb2ede7abf9f$export$3307ffa7023ede1e(characters, root, parent, index, offset, rules, points, type, props = [], children = [], length), rulesets);
                    if (character === 123) {
                        if (offset === 0) $666cfb2ede7abf9f$export$98e6a39c04603d36(characters, root, reference, reference, props, rulesets, length, points, children);
                        else switch(atrule === 99 && (0, $jTNKH.charat)(characters, 3) === 110 ? 100 : atrule){
                            // d l m s
                            case 100:
                            case 108:
                            case 109:
                            case 115:
                                $666cfb2ede7abf9f$export$98e6a39c04603d36(value, reference, reference, rule && (0, $jTNKH.append)($666cfb2ede7abf9f$export$3307ffa7023ede1e(value, reference, reference, 0, 0, rules, points, type, rules, props = [], length), children), rules, children, length, points, rule ? props : children);
                                break;
                            default:
                                $666cfb2ede7abf9f$export$98e6a39c04603d36(characters, reference, reference, reference, [
                                    ''
                                ], children, 0, points, children);
                        }
                    }
            }
            index = offset = property = 0, variable = ampersand = 1, type = characters = '', length = pseudo;
            break;
        // :
        case 58:
            length = 1 + (0, $jTNKH.strlen)(characters), property = previous;
        default:
            if (variable < 1) {
                if (character == 123) --variable;
                else if (character == 125 && variable++ == 0 && (0, $2dJYK.prev)() == 125) continue;
            }
            switch(characters += (0, $jTNKH.from)(character), character * variable){
                // &
                case 38:
                    ampersand = offset > 0 ? 1 : (characters += '\f', -1);
                    break;
                // ,
                case 44:
                    points[index++] = ((0, $jTNKH.strlen)(characters) - 1) * ampersand, ampersand = 1;
                    break;
                // @
                case 64:
                    // -
                    if ((0, $2dJYK.peek)() === 45) characters += (0, $2dJYK.delimit)((0, $2dJYK.next)());
                    atrule = (0, $2dJYK.peek)(), offset = length = (0, $jTNKH.strlen)(type = characters += (0, $2dJYK.identifier)((0, $2dJYK.caret)())), character++;
                    break;
                // -
                case 45:
                    if (previous === 45 && (0, $jTNKH.strlen)(characters) == 2) variable = 0;
            }
    }
    return rulesets;
}
function $666cfb2ede7abf9f$export$3307ffa7023ede1e(value, root, parent, index, offset, rules, points, type, props, children, length) {
    var post = offset - 1;
    var rule = offset === 0 ? rules : [
        ''
    ];
    var size = (0, $jTNKH.sizeof)(rule);
    for(var i = 0, j = 0, k = 0; i < index; ++i)for(var x = 0, y = (0, $jTNKH.substr)(value, post + 1, post = (0, $jTNKH.abs)(j = points[i])), z = value; x < size; ++x)if (z = (0, $jTNKH.trim)(j > 0 ? rule[x] + ' ' + y : (0, $jTNKH.replace)(y, /&\f/g, rule[x]))) props[k++] = z;
    return (0, $2dJYK.node)(value, root, parent, offset === 0 ? (0, $7BLx4.RULESET) : type, props, children, length);
}
function $666cfb2ede7abf9f$export$4a34f930e789283c(value, root, parent) {
    return (0, $2dJYK.node)(value, root, parent, (0, $7BLx4.COMMENT), (0, $jTNKH.from)((0, $2dJYK.char)()), (0, $jTNKH.substr)(value, 2, -2), 0);
}
function $666cfb2ede7abf9f$export$f8483753829ec8f3(value, root, parent, length) {
    return (0, $2dJYK.node)(value, root, parent, (0, $7BLx4.DECLARATION), (0, $jTNKH.substr)(value, 0, length), (0, $jTNKH.substr)(value, length + 1, -1), length);
}

});
parcelRegister("7BLx4", function(module, exports) {
$parcel$export(module.exports, "MS", () => $58a0dc0ebf5f92b6$export$71ad59f2e432cfe8);
$parcel$export(module.exports, "MOZ", () => $58a0dc0ebf5f92b6$export$2c0f367103c8d01c);
$parcel$export(module.exports, "WEBKIT", () => $58a0dc0ebf5f92b6$export$39dfd62a25e0fe93);
$parcel$export(module.exports, "COMMENT", () => $58a0dc0ebf5f92b6$export$a29989082612d0d9);
$parcel$export(module.exports, "RULESET", () => $58a0dc0ebf5f92b6$export$aa3a2e812ca8570d);
$parcel$export(module.exports, "DECLARATION", () => $58a0dc0ebf5f92b6$export$527d108ccf083c2b);
$parcel$export(module.exports, "IMPORT", () => $58a0dc0ebf5f92b6$export$a763edbf796b780a);
$parcel$export(module.exports, "KEYFRAMES", () => $58a0dc0ebf5f92b6$export$b44a8529a35fcb60);
$parcel$export(module.exports, "LAYER", () => $58a0dc0ebf5f92b6$export$d773506282b3cfe6);
var $58a0dc0ebf5f92b6$export$71ad59f2e432cfe8 = '-ms-';
var $58a0dc0ebf5f92b6$export$2c0f367103c8d01c = '-moz-';
var $58a0dc0ebf5f92b6$export$39dfd62a25e0fe93 = '-webkit-';
var $58a0dc0ebf5f92b6$export$a29989082612d0d9 = 'comm';
var $58a0dc0ebf5f92b6$export$aa3a2e812ca8570d = 'rule';
var $58a0dc0ebf5f92b6$export$527d108ccf083c2b = 'decl';
var $58a0dc0ebf5f92b6$export$d3d35020fa5b54f0 = '@page';
var $58a0dc0ebf5f92b6$export$500415a86c544f73 = '@media';
var $58a0dc0ebf5f92b6$export$a763edbf796b780a = '@import';
var $58a0dc0ebf5f92b6$export$2790aeb8b4e5c826 = '@charset';
var $58a0dc0ebf5f92b6$export$1cc683e23b84b133 = '@viewport';
var $58a0dc0ebf5f92b6$export$9447a5efea57e862 = '@supports';
var $58a0dc0ebf5f92b6$export$ef011b4e114b1fba = '@document';
var $58a0dc0ebf5f92b6$export$6aad947bda0f3f46 = '@namespace';
var $58a0dc0ebf5f92b6$export$b44a8529a35fcb60 = '@keyframes';
var $58a0dc0ebf5f92b6$export$2c16de31893252e6 = '@font-face';
var $58a0dc0ebf5f92b6$export$3d846dd52e150c6f = '@counter-style';
var $58a0dc0ebf5f92b6$export$22314bfbb57653fe = '@font-feature-values';
var $58a0dc0ebf5f92b6$export$d773506282b3cfe6 = '@layer';

});


parcelRegister("aT1U2", function(module, exports) {
$parcel$export(module.exports, "middleware", () => $7ed08450b4cdd883$export$5a7767152ae0305f);
$parcel$export(module.exports, "rulesheet", () => $7ed08450b4cdd883$export$38bcb760f1d4871c);

var $7BLx4 = parcelRequire("7BLx4");

var $jTNKH = parcelRequire("jTNKH");

var $2dJYK = parcelRequire("2dJYK");

var $jQwWU = parcelRequire("jQwWU");

var $dRq7U = parcelRequire("dRq7U");
function $7ed08450b4cdd883$export$5a7767152ae0305f(collection) {
    var length = (0, $jTNKH.sizeof)(collection);
    return function(element, index, children, callback) {
        var output = '';
        for(var i = 0; i < length; i++)output += collection[i](element, index, children, callback) || '';
        return output;
    };
}
function $7ed08450b4cdd883$export$38bcb760f1d4871c(callback) {
    return function(element) {
        if (!element.root) {
            if (element = element.return) callback(element);
        }
    };
}
function $7ed08450b4cdd883$export$e08c7d021b829b7a(element, index, children, callback) {
    if (element.length > -1) {
        if (!element.return) switch(element.type){
            case 0, $7BLx4.DECLARATION:
                element.return = (0, $dRq7U.prefix)(element.value, element.length, children);
                return;
            case 0, $7BLx4.KEYFRAMES:
                return (0, $jQwWU.serialize)([
                    (0, $2dJYK.copy)(element, {
                        value: (0, $jTNKH.replace)(element.value, '@', '@' + (0, $7BLx4.WEBKIT))
                    })
                ], callback);
            case 0, $7BLx4.RULESET:
                if (element.length) return (0, $jTNKH.combine)(element.props, function(value) {
                    switch((0, $jTNKH.match)(value, /(::plac\w+|:read-\w+)/)){
                        // :read-(only|write)
                        case ':read-only':
                        case ':read-write':
                            return (0, $jQwWU.serialize)([
                                (0, $2dJYK.copy)(element, {
                                    props: [
                                        (0, $jTNKH.replace)(value, /:(read-\w+)/, ':' + (0, $7BLx4.MOZ) + '$1')
                                    ]
                                })
                            ], callback);
                        // :placeholder
                        case '::placeholder':
                            return (0, $jQwWU.serialize)([
                                (0, $2dJYK.copy)(element, {
                                    props: [
                                        (0, $jTNKH.replace)(value, /:(plac\w+)/, ':' + (0, $7BLx4.WEBKIT) + 'input-$1')
                                    ]
                                }),
                                (0, $2dJYK.copy)(element, {
                                    props: [
                                        (0, $jTNKH.replace)(value, /:(plac\w+)/, ':' + (0, $7BLx4.MOZ) + '$1')
                                    ]
                                }),
                                (0, $2dJYK.copy)(element, {
                                    props: [
                                        (0, $jTNKH.replace)(value, /:(plac\w+)/, (0, $7BLx4.MS) + 'input-$1')
                                    ]
                                })
                            ], callback);
                    }
                    return '';
                });
        }
    }
}
function $7ed08450b4cdd883$export$76a88f7de6507443(element) {
    switch(element.type){
        case 0, $7BLx4.RULESET:
            element.props = element.props.map(function(value) {
                return (0, $jTNKH.combine)((0, $2dJYK.tokenize)(value), function(value, index, children) {
                    switch((0, $jTNKH.charat)(value, 0)){
                        // \f
                        case 12:
                            return (0, $jTNKH.substr)(value, 1, (0, $jTNKH.strlen)(value));
                        // \0 ( + > ~
                        case 0:
                        case 40:
                        case 43:
                        case 62:
                        case 126:
                            return value;
                        // :
                        case 58:
                            if (children[++index] === 'global') children[index] = '', children[++index] = '\f' + (0, $jTNKH.substr)(children[index], index = 1, -1);
                        // \s
                        case 32:
                            return index === 1 ? '' : value;
                        default:
                            switch(index){
                                case 0:
                                    element = value;
                                    return (0, $jTNKH.sizeof)(children) > 1 ? '' : value;
                                case index = (0, $jTNKH.sizeof)(children) - 1:
                                case 2:
                                    return index === 2 ? value + element + element : value + element;
                                default:
                                    return value;
                            }
                    }
                });
            });
    }
}

});
parcelRegister("jQwWU", function(module, exports) {
$parcel$export(module.exports, "serialize", () => $e72c6ea6dabe3eb8$export$dfdc1655ccc5b9cb);
$parcel$export(module.exports, "stringify", () => $e72c6ea6dabe3eb8$export$fac44ee5b035f737);

var $7BLx4 = parcelRequire("7BLx4");

var $jTNKH = parcelRequire("jTNKH");
function $e72c6ea6dabe3eb8$export$dfdc1655ccc5b9cb(children, callback) {
    var output = '';
    var length = (0, $jTNKH.sizeof)(children);
    for(var i = 0; i < length; i++)output += callback(children[i], i, children, callback) || '';
    return output;
}
function $e72c6ea6dabe3eb8$export$fac44ee5b035f737(element, index, children, callback) {
    switch(element.type){
        case 0, $7BLx4.LAYER:
            if (element.children.length) break;
        case 0, $7BLx4.IMPORT:
        case 0, $7BLx4.DECLARATION:
            return element.return = element.return || element.value;
        case 0, $7BLx4.COMMENT:
            return '';
        case 0, $7BLx4.KEYFRAMES:
            return element.return = element.value + '{' + $e72c6ea6dabe3eb8$export$dfdc1655ccc5b9cb(element.children, callback) + '}';
        case 0, $7BLx4.RULESET:
            element.value = element.props.join(',');
    }
    return (0, $jTNKH.strlen)(children = $e72c6ea6dabe3eb8$export$dfdc1655ccc5b9cb(element.children, callback)) ? element.return = element.value + '{' + children + '}' : '';
}

});

parcelRegister("dRq7U", function(module, exports) {
$parcel$export(module.exports, "prefix", () => $a1747dc66d5aaf6c$export$82e9f45cca5ba907);

var $7BLx4 = parcelRequire("7BLx4");

var $jTNKH = parcelRequire("jTNKH");
function $a1747dc66d5aaf6c$export$82e9f45cca5ba907(value, length, children) {
    switch((0, $jTNKH.hash)(value, length)){
        // color-adjust
        case 5103:
            return (0, $7BLx4.WEBKIT) + 'print-' + value + value;
        // animation, animation-(delay|direction|duration|fill-mode|iteration-count|name|play-state|timing-function)
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        // text-decoration, filter, clip-path, backface-visibility, column, box-decoration-break
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        // mask, mask-image, mask-(mode|clip|size), mask-(repeat|origin), mask-position, mask-composite,
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        // background-clip, columns, column-(count|fill|gap|rule|rule-color|rule-style|rule-width|span|width)
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return (0, $7BLx4.WEBKIT) + value + value;
        // tab-size
        case 4789:
            return (0, $7BLx4.MOZ) + value + value;
        // appearance, user-select, transform, hyphens, text-size-adjust
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return (0, $7BLx4.WEBKIT) + value + (0, $7BLx4.MOZ) + value + (0, $7BLx4.MS) + value + value;
        // writing-mode
        case 5936:
            switch((0, $jTNKH.charat)(value, length + 11)){
                // vertical-l(r)
                case 114:
                    return (0, $7BLx4.WEBKIT) + value + (0, $7BLx4.MS) + (0, $jTNKH.replace)(value, /[svh]\w+-[tblr]{2}/, 'tb') + value;
                // vertical-r(l)
                case 108:
                    return (0, $7BLx4.WEBKIT) + value + (0, $7BLx4.MS) + (0, $jTNKH.replace)(value, /[svh]\w+-[tblr]{2}/, 'tb-rl') + value;
                // horizontal(-)tb
                case 45:
                    return (0, $7BLx4.WEBKIT) + value + (0, $7BLx4.MS) + (0, $jTNKH.replace)(value, /[svh]\w+-[tblr]{2}/, 'lr') + value;
            }
        // flex, flex-direction, scroll-snap-type, writing-mode
        case 6828:
        case 4268:
        case 2903:
            return (0, $7BLx4.WEBKIT) + value + (0, $7BLx4.MS) + value + value;
        // order
        case 6165:
            return (0, $7BLx4.WEBKIT) + value + (0, $7BLx4.MS) + 'flex-' + value + value;
        // align-items
        case 5187:
            return (0, $7BLx4.WEBKIT) + value + (0, $jTNKH.replace)(value, /(\w+).+(:[^]+)/, (0, $7BLx4.WEBKIT) + 'box-$1$2' + (0, $7BLx4.MS) + 'flex-$1$2') + value;
        // align-self
        case 5443:
            return (0, $7BLx4.WEBKIT) + value + (0, $7BLx4.MS) + 'flex-item-' + (0, $jTNKH.replace)(value, /flex-|-self/g, '') + (!(0, $jTNKH.match)(value, /flex-|baseline/) ? (0, $7BLx4.MS) + 'grid-row-' + (0, $jTNKH.replace)(value, /flex-|-self/g, '') : '') + value;
        // align-content
        case 4675:
            return (0, $7BLx4.WEBKIT) + value + (0, $7BLx4.MS) + 'flex-line-pack' + (0, $jTNKH.replace)(value, /align-content|flex-|-self/g, '') + value;
        // flex-shrink
        case 5548:
            return (0, $7BLx4.WEBKIT) + value + (0, $7BLx4.MS) + (0, $jTNKH.replace)(value, 'shrink', 'negative') + value;
        // flex-basis
        case 5292:
            return (0, $7BLx4.WEBKIT) + value + (0, $7BLx4.MS) + (0, $jTNKH.replace)(value, 'basis', 'preferred-size') + value;
        // flex-grow
        case 6060:
            return (0, $7BLx4.WEBKIT) + 'box-' + (0, $jTNKH.replace)(value, '-grow', '') + (0, $7BLx4.WEBKIT) + value + (0, $7BLx4.MS) + (0, $jTNKH.replace)(value, 'grow', 'positive') + value;
        // transition
        case 4554:
            return (0, $7BLx4.WEBKIT) + (0, $jTNKH.replace)(value, /([^-])(transform)/g, '$1' + (0, $7BLx4.WEBKIT) + '$2') + value;
        // cursor
        case 6187:
            return (0, $jTNKH.replace)((0, $jTNKH.replace)((0, $jTNKH.replace)(value, /(zoom-|grab)/, (0, $7BLx4.WEBKIT) + '$1'), /(image-set)/, (0, $7BLx4.WEBKIT) + '$1'), value, '') + value;
        // background, background-image
        case 5495:
        case 3959:
            return (0, $jTNKH.replace)(value, /(image-set\([^]*)/, (0, $7BLx4.WEBKIT) + '$1' + '$`$1');
        // justify-content
        case 4968:
            return (0, $jTNKH.replace)((0, $jTNKH.replace)(value, /(.+:)(flex-)?(.*)/, (0, $7BLx4.WEBKIT) + 'box-pack:$3' + (0, $7BLx4.MS) + 'flex-pack:$3'), /s.+-b[^;]+/, 'justify') + (0, $7BLx4.WEBKIT) + value + value;
        // justify-self
        case 4200:
            if (!(0, $jTNKH.match)(value, /flex-|baseline/)) return (0, $7BLx4.MS) + 'grid-column-align' + (0, $jTNKH.substr)(value, length) + value;
            break;
        // grid-template-(columns|rows)
        case 2592:
        case 3360:
            return (0, $7BLx4.MS) + (0, $jTNKH.replace)(value, 'template-', '') + value;
        // grid-(row|column)-start
        case 4384:
        case 3616:
            if (children && children.some(function(element, index) {
                return length = index, (0, $jTNKH.match)(element.props, /grid-\w+-end/);
            })) return ~(0, $jTNKH.indexof)(value + (children = children[length].value), 'span') ? value : (0, $7BLx4.MS) + (0, $jTNKH.replace)(value, '-start', '') + value + (0, $7BLx4.MS) + 'grid-row-span:' + (~(0, $jTNKH.indexof)(children, 'span') ? (0, $jTNKH.match)(children, /\d+/) : +(0, $jTNKH.match)(children, /\d+/) - +(0, $jTNKH.match)(value, /\d+/)) + ';';
            return (0, $7BLx4.MS) + (0, $jTNKH.replace)(value, '-start', '') + value;
        // grid-(row|column)-end
        case 4896:
        case 4128:
            return children && children.some(function(element) {
                return (0, $jTNKH.match)(element.props, /grid-\w+-start/);
            }) ? value : (0, $7BLx4.MS) + (0, $jTNKH.replace)((0, $jTNKH.replace)(value, '-end', '-span'), 'span ', '') + value;
        // (margin|padding)-inline-(start|end)
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return (0, $jTNKH.replace)(value, /(.+)-inline(.+)/, (0, $7BLx4.WEBKIT) + '$1$2') + value;
        // (min|max)?(width|height|inline-size|block-size)
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            // stretch, max-content, min-content, fill-available
            if ((0, $jTNKH.strlen)(value) - 1 - length > 6) switch((0, $jTNKH.charat)(value, length + 1)){
                // (m)ax-content, (m)in-content
                case 109:
                    // -
                    if ((0, $jTNKH.charat)(value, length + 4) !== 45) break;
                // (f)ill-available, (f)it-content
                case 102:
                    return (0, $jTNKH.replace)(value, /(.+:)(.+)-([^]+)/, '$1' + (0, $7BLx4.WEBKIT) + '$2-$3' + '$1' + (0, $7BLx4.MOZ) + ((0, $jTNKH.charat)(value, length + 3) == 108 ? '$3' : '$2-$3')) + value;
                // (s)tretch
                case 115:
                    return ~(0, $jTNKH.indexof)(value, 'stretch') ? $a1747dc66d5aaf6c$export$82e9f45cca5ba907((0, $jTNKH.replace)(value, 'stretch', 'fill-available'), length, children) + value : value;
            }
            break;
        // grid-(column|row)
        case 5152:
        case 5920:
            return (0, $jTNKH.replace)(value, /(.+?):(\d+)(\s*\/\s*(span)?\s*(\d+))?(.*)/, function(_, a, b, c, d, e, f) {
                return (0, $7BLx4.MS) + a + ':' + b + f + (c ? (0, $7BLx4.MS) + a + '-span:' + (d ? e : +e - +b) + f : '') + value;
            });
        // position: sticky
        case 4949:
            // stick(y)?
            if ((0, $jTNKH.charat)(value, length + 6) === 121) return (0, $jTNKH.replace)(value, ':', ':' + (0, $7BLx4.WEBKIT)) + value;
            break;
        // display: (flex|inline-flex|grid|inline-grid)
        case 6444:
            switch((0, $jTNKH.charat)(value, (0, $jTNKH.charat)(value, 14) === 45 ? 18 : 11)){
                // (inline-)?fle(x)
                case 120:
                    return (0, $jTNKH.replace)(value, /(.+:)([^;\s!]+)(;|(\s+)?!.+)?/, '$1' + (0, $7BLx4.WEBKIT) + ((0, $jTNKH.charat)(value, 14) === 45 ? 'inline-' : '') + 'box$3' + '$1' + (0, $7BLx4.WEBKIT) + '$2$3' + '$1' + (0, $7BLx4.MS) + '$2box$3') + value;
                // (inline-)?gri(d)
                case 100:
                    return (0, $jTNKH.replace)(value, ':', ':' + (0, $7BLx4.MS)) + value;
            }
            break;
        // scroll-margin, scroll-margin-(top|right|bottom|left)
        case 5719:
        case 2647:
        case 2135:
        case 3927:
        case 2391:
            return (0, $jTNKH.replace)(value, 'scroll-', 'scroll-snap-') + value;
    }
    return value;
}

});


parcelRegister("1QNjI", function(module, exports) {
$parcel$export(module.exports, "default", () => $1590e71a06f1c94c$export$2e2bcd8739ae039);
var $1590e71a06f1c94c$export$2e2bcd8739ae039 = function weakMemoize(func) {
    var cache = new WeakMap();
    return function(arg) {
        if (cache.has(arg)) // Use non-null assertion because we just checked that the cache `has` it
        // This allows us to remove `undefined` from the return value
        return cache.get(arg);
        var ret = func(arg);
        cache.set(arg, ret);
        return ret;
    };
};

});

parcelRegister("7VhhO", function(module, exports) {
$parcel$export(module.exports, "default", () => $5c4b43fa4ca9ca56$export$2e2bcd8739ae039);
function $5c4b43fa4ca9ca56$export$2e2bcd8739ae039(fn) {
    var cache = Object.create(null);
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}

});


parcelRegister("6NXXp", function(module, exports) {
$parcel$export(module.exports, "default", () => $4f45d3eb7b27b09d$export$2e2bcd8739ae039);
function $4f45d3eb7b27b09d$export$2e2bcd8739ae039() {
    return $4f45d3eb7b27b09d$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $4f45d3eb7b27b09d$export$2e2bcd8739ae039.apply(null, arguments);
}

});

parcelRegister("6sA7e", function(module, exports) {
$parcel$export(module.exports, "default", () => $4b415f6a5b424019$export$2e2bcd8739ae039);

var $knBeW = parcelRequire("knBeW");
// this file isolates this package that is not tree-shakeable
// and if this module doesn't actually contain any logic of its own
// then Rollup just use 'hoist-non-react-statics' directly in other chunks
var $4b415f6a5b424019$export$2e2bcd8739ae039 = function(targetComponent, sourceComponent) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($knBeW)))(targetComponent, sourceComponent);
};

});
parcelRegister("knBeW", function(module, exports) {
'use strict';

var $lwfCu = parcelRequire("lwfCu");
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */ var $ed62d7b2a7b04291$var$REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var $ed62d7b2a7b04291$var$KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var $ed62d7b2a7b04291$var$FORWARD_REF_STATICS = {
    '$$typeof': true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};
var $ed62d7b2a7b04291$var$MEMO_STATICS = {
    '$$typeof': true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};
var $ed62d7b2a7b04291$var$TYPE_STATICS = {};
$ed62d7b2a7b04291$var$TYPE_STATICS[$lwfCu.ForwardRef] = $ed62d7b2a7b04291$var$FORWARD_REF_STATICS;
$ed62d7b2a7b04291$var$TYPE_STATICS[$lwfCu.Memo] = $ed62d7b2a7b04291$var$MEMO_STATICS;
function $ed62d7b2a7b04291$var$getStatics(component) {
    // React v16.11 and below
    if ($lwfCu.isMemo(component)) return $ed62d7b2a7b04291$var$MEMO_STATICS;
     // React v16.12 and above
    return $ed62d7b2a7b04291$var$TYPE_STATICS[component['$$typeof']] || $ed62d7b2a7b04291$var$REACT_STATICS;
}
var $ed62d7b2a7b04291$var$defineProperty = Object.defineProperty;
var $ed62d7b2a7b04291$var$getOwnPropertyNames = Object.getOwnPropertyNames;
var $ed62d7b2a7b04291$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $ed62d7b2a7b04291$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $ed62d7b2a7b04291$var$getPrototypeOf = Object.getPrototypeOf;
var $ed62d7b2a7b04291$var$objectPrototype = Object.prototype;
function $ed62d7b2a7b04291$var$hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') {
        // don't hoist over string (html) components
        if ($ed62d7b2a7b04291$var$objectPrototype) {
            var inheritedComponent = $ed62d7b2a7b04291$var$getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== $ed62d7b2a7b04291$var$objectPrototype) $ed62d7b2a7b04291$var$hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
        }
        var keys = $ed62d7b2a7b04291$var$getOwnPropertyNames(sourceComponent);
        if ($ed62d7b2a7b04291$var$getOwnPropertySymbols) keys = keys.concat($ed62d7b2a7b04291$var$getOwnPropertySymbols(sourceComponent));
        var targetStatics = $ed62d7b2a7b04291$var$getStatics(targetComponent);
        var sourceStatics = $ed62d7b2a7b04291$var$getStatics(sourceComponent);
        for(var i = 0; i < keys.length; ++i){
            var key = keys[i];
            if (!$ed62d7b2a7b04291$var$KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                var descriptor = $ed62d7b2a7b04291$var$getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    // Avoid failures from read-only properties
                    $ed62d7b2a7b04291$var$defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
    }
    return targetComponent;
}
module.exports = $ed62d7b2a7b04291$var$hoistNonReactStatics;

});
parcelRegister("lwfCu", function(module, exports) {
'use strict';

module.exports = (parcelRequire("3gsre"));

});



parcelRegister("hXf6E", function(module, exports) {
$parcel$export(module.exports, "getRegisteredStyles", () => $d123aa206da6f3da$export$95d99596f328fd52);
$parcel$export(module.exports, "registerStyles", () => $d123aa206da6f3da$export$580009a5da2a8b4b);
$parcel$export(module.exports, "insertStyles", () => $d123aa206da6f3da$export$6f077d94b33a01aa);
var $d123aa206da6f3da$var$isBrowser = true;
function $d123aa206da6f3da$export$95d99596f328fd52(registered, registeredStyles, classNames) {
    var rawClassName = '';
    classNames.split(' ').forEach(function(className) {
        if (registered[className] !== undefined) registeredStyles.push(registered[className] + ";");
        else if (className) rawClassName += className + " ";
    });
    return rawClassName;
}
var $d123aa206da6f3da$export$580009a5da2a8b4b = function registerStyles(cache, serialized, isStringTag) {
    var className = cache.key + "-" + serialized.name;
    if (// class name could be used further down
    // the tree but if it's a string tag, we know it won't
    // so we don't have to add it to registered cache.
    // this improves memory usage since we can avoid storing the whole style string
    (isStringTag === false || // we need to always store it if we're in compat mode and
    // in node since emotion-server relies on whether a style is in
    // the registered cache to know whether a style is global or not
    // also, note that this check will be dead code eliminated in the browser
    $d123aa206da6f3da$var$isBrowser === false) && cache.registered[className] === undefined) cache.registered[className] = serialized.styles;
};
var $d123aa206da6f3da$export$6f077d94b33a01aa = function insertStyles(cache, serialized, isStringTag) {
    $d123aa206da6f3da$export$580009a5da2a8b4b(cache, serialized, isStringTag);
    var className = cache.key + "-" + serialized.name;
    if (cache.inserted[serialized.name] === undefined) {
        var current = serialized;
        do {
            cache.insert(serialized === current ? "." + className : '', current, cache.sheet, true);
            current = current.next;
        }while (current !== undefined);
    }
};

});

parcelRegister("ckRFu", function(module, exports) {
$parcel$export(module.exports, "serializeStyles", () => $8fb0fbaac7a2e807$export$6321afa313b251b5);

var $1gJfi = parcelRequire("1gJfi");

var $aLo9l = parcelRequire("aLo9l");

var $7VhhO = parcelRequire("7VhhO");
var $8fb0fbaac7a2e807$var$isDevelopment = false;
var $8fb0fbaac7a2e807$var$hyphenateRegex = /[A-Z]|^ms/g;
var $8fb0fbaac7a2e807$var$animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;
var $8fb0fbaac7a2e807$var$isCustomProperty = function isCustomProperty(property) {
    return property.charCodeAt(1) === 45;
};
var $8fb0fbaac7a2e807$var$isProcessableValue = function isProcessableValue(value) {
    return value != null && typeof value !== 'boolean';
};
var $8fb0fbaac7a2e807$var$processStyleName = /* #__PURE__ */ (0, $7VhhO.default)(function(styleName) {
    return $8fb0fbaac7a2e807$var$isCustomProperty(styleName) ? styleName : styleName.replace($8fb0fbaac7a2e807$var$hyphenateRegex, '-$&').toLowerCase();
});
var $8fb0fbaac7a2e807$var$processStyleValue = function processStyleValue(key, value) {
    switch(key){
        case 'animation':
        case 'animationName':
            if (typeof value === 'string') return value.replace($8fb0fbaac7a2e807$var$animationRegex, function(match, p1, p2) {
                $8fb0fbaac7a2e807$var$cursor = {
                    name: p1,
                    styles: p2,
                    next: $8fb0fbaac7a2e807$var$cursor
                };
                return p1;
            });
    }
    if ((0, $aLo9l.default)[key] !== 1 && !$8fb0fbaac7a2e807$var$isCustomProperty(key) && typeof value === 'number' && value !== 0) return value + 'px';
    return value;
};
var $8fb0fbaac7a2e807$var$noComponentSelectorMessage = "Component selectors can only be used in conjunction with @emotion/babel-plugin, the swc Emotion plugin, or another Emotion-aware compiler transform.";
function $8fb0fbaac7a2e807$var$handleInterpolation(mergedProps, registered, interpolation) {
    if (interpolation == null) return '';
    var componentSelector = interpolation;
    if (componentSelector.__emotion_styles !== undefined) return componentSelector;
    switch(typeof interpolation){
        case 'boolean':
            return '';
        case 'object':
            var keyframes = interpolation;
            if (keyframes.anim === 1) {
                $8fb0fbaac7a2e807$var$cursor = {
                    name: keyframes.name,
                    styles: keyframes.styles,
                    next: $8fb0fbaac7a2e807$var$cursor
                };
                return keyframes.name;
            }
            var serializedStyles = interpolation;
            if (serializedStyles.styles !== undefined) {
                var next = serializedStyles.next;
                if (next !== undefined) // not the most efficient thing ever but this is a pretty rare case
                // and there will be very few iterations of this generally
                while(next !== undefined){
                    $8fb0fbaac7a2e807$var$cursor = {
                        name: next.name,
                        styles: next.styles,
                        next: $8fb0fbaac7a2e807$var$cursor
                    };
                    next = next.next;
                }
                var styles = serializedStyles.styles + ";";
                return styles;
            }
            return $8fb0fbaac7a2e807$var$createStringFromObject(mergedProps, registered, interpolation);
        case 'function':
            if (mergedProps !== undefined) {
                var previousCursor = $8fb0fbaac7a2e807$var$cursor;
                var result = interpolation(mergedProps);
                $8fb0fbaac7a2e807$var$cursor = previousCursor;
                return $8fb0fbaac7a2e807$var$handleInterpolation(mergedProps, registered, result);
            }
            break;
    } // finalize string values (regular strings and functions interpolated into css calls)
    var asString = interpolation;
    if (registered == null) return asString;
    var cached = registered[asString];
    return cached !== undefined ? cached : asString;
}
function $8fb0fbaac7a2e807$var$createStringFromObject(mergedProps, registered, obj) {
    var string = '';
    if (Array.isArray(obj)) for(var i = 0; i < obj.length; i++)string += $8fb0fbaac7a2e807$var$handleInterpolation(mergedProps, registered, obj[i]) + ";";
    else for(var key in obj){
        var value = obj[key];
        if (typeof value !== 'object') {
            var asString = value;
            if (registered != null && registered[asString] !== undefined) string += key + "{" + registered[asString] + "}";
            else if ($8fb0fbaac7a2e807$var$isProcessableValue(asString)) string += $8fb0fbaac7a2e807$var$processStyleName(key) + ":" + $8fb0fbaac7a2e807$var$processStyleValue(key, asString) + ";";
        } else {
            if (key === 'NO_COMPONENT_SELECTOR' && $8fb0fbaac7a2e807$var$isDevelopment) throw new Error($8fb0fbaac7a2e807$var$noComponentSelectorMessage);
            if (Array.isArray(value) && typeof value[0] === 'string' && (registered == null || registered[value[0]] === undefined)) {
                for(var _i = 0; _i < value.length; _i++)if ($8fb0fbaac7a2e807$var$isProcessableValue(value[_i])) string += $8fb0fbaac7a2e807$var$processStyleName(key) + ":" + $8fb0fbaac7a2e807$var$processStyleValue(key, value[_i]) + ";";
            } else {
                var interpolated = $8fb0fbaac7a2e807$var$handleInterpolation(mergedProps, registered, value);
                switch(key){
                    case 'animation':
                    case 'animationName':
                        string += $8fb0fbaac7a2e807$var$processStyleName(key) + ":" + interpolated + ";";
                        break;
                    default:
                        string += key + "{" + interpolated + "}";
                }
            }
        }
    }
    return string;
}
var $8fb0fbaac7a2e807$var$labelPattern = /label:\s*([^\s;{]+)\s*(;|$)/g; // this is the cursor for keyframes
// keyframes are stored on the SerializedStyles object as a linked list
var $8fb0fbaac7a2e807$var$cursor;
function $8fb0fbaac7a2e807$export$6321afa313b251b5(args, registered, mergedProps) {
    if (args.length === 1 && typeof args[0] === 'object' && args[0] !== null && args[0].styles !== undefined) return args[0];
    var stringMode = true;
    var styles = '';
    $8fb0fbaac7a2e807$var$cursor = undefined;
    var strings = args[0];
    if (strings == null || strings.raw === undefined) {
        stringMode = false;
        styles += $8fb0fbaac7a2e807$var$handleInterpolation(mergedProps, registered, strings);
    } else {
        var asTemplateStringsArr = strings;
        styles += asTemplateStringsArr[0];
    } // we start at 1 since we've already handled the first arg
    for(var i = 1; i < args.length; i++){
        styles += $8fb0fbaac7a2e807$var$handleInterpolation(mergedProps, registered, args[i]);
        if (stringMode) {
            var templateStringsArr = strings;
            styles += templateStringsArr[i];
        }
    } // using a global regex with .exec is stateful so lastIndex has to be reset each time
    $8fb0fbaac7a2e807$var$labelPattern.lastIndex = 0;
    var identifierName = '';
    var match; // https://esbench.com/bench/5b809c2cf2949800a0f61fb5
    while((match = $8fb0fbaac7a2e807$var$labelPattern.exec(styles)) !== null)identifierName += '-' + match[1];
    var name = (0, $1gJfi.default)(styles) + identifierName;
    return {
        name: name,
        styles: styles,
        next: $8fb0fbaac7a2e807$var$cursor
    };
}

});
parcelRegister("1gJfi", function(module, exports) {
$parcel$export(module.exports, "default", () => $0eca61e9ec9ac574$export$2e2bcd8739ae039);
/* eslint-disable */ // Inspired by https://github.com/garycourt/murmurhash-js
// Ported from https://github.com/aappleby/smhasher/blob/61a0530f28277f2e850bfc39600ce61d02b518de/src/MurmurHash2.cpp#L37-L86
function $0eca61e9ec9ac574$export$2e2bcd8739ae039(str) {
    // 'm' and 'r' are mixing constants generated offline.
    // They're not really 'magic', they just happen to work well.
    // const m = 0x5bd1e995;
    // const r = 24;
    // Initialize the hash
    var h = 0; // Mix 4 bytes at a time into the hash
    var k, i = 0, len = str.length;
    for(; len >= 4; ++i, len -= 4){
        k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
        k = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16);
        k ^= /* k >>> r: */ k >>> 24;
        h = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16) ^ /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Handle the last few bytes of the input array
    switch(len){
        case 3:
            h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
        case 2:
            h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
        case 1:
            h ^= str.charCodeAt(i) & 0xff;
            h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Do a few final mixes of the hash to ensure the last few
    // bytes are well-incorporated.
    h ^= h >>> 13;
    h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    return ((h ^ h >>> 15) >>> 0).toString(36);
}

});

parcelRegister("aLo9l", function(module, exports) {
$parcel$export(module.exports, "default", () => $7d6106d35293dee3$export$2e2bcd8739ae039);
var $7d6106d35293dee3$export$2e2bcd8739ae039 = {
    animationIterationCount: 1,
    aspectRatio: 1,
    borderImageOutset: 1,
    borderImageSlice: 1,
    borderImageWidth: 1,
    boxFlex: 1,
    boxFlexGroup: 1,
    boxOrdinalGroup: 1,
    columnCount: 1,
    columns: 1,
    flex: 1,
    flexGrow: 1,
    flexPositive: 1,
    flexShrink: 1,
    flexNegative: 1,
    flexOrder: 1,
    gridRow: 1,
    gridRowEnd: 1,
    gridRowSpan: 1,
    gridRowStart: 1,
    gridColumn: 1,
    gridColumnEnd: 1,
    gridColumnSpan: 1,
    gridColumnStart: 1,
    msGridRow: 1,
    msGridRowSpan: 1,
    msGridColumn: 1,
    msGridColumnSpan: 1,
    fontWeight: 1,
    lineHeight: 1,
    opacity: 1,
    order: 1,
    orphans: 1,
    scale: 1,
    tabSize: 1,
    widows: 1,
    zIndex: 1,
    zoom: 1,
    WebkitLineClamp: 1,
    // SVG-related properties
    fillOpacity: 1,
    floodOpacity: 1,
    stopOpacity: 1,
    strokeDasharray: 1,
    strokeDashoffset: 1,
    strokeMiterlimit: 1,
    strokeOpacity: 1,
    strokeWidth: 1
};

});


parcelRegister("4Sr34", function(module, exports) {
$parcel$export(module.exports, "useInsertionEffectAlwaysWithSyncFallback", () => $38d12fd915127030$export$db21c7ffa21794e7);
$parcel$export(module.exports, "useInsertionEffectWithLayoutFallback", () => $38d12fd915127030$export$811a713a7276cb9d);

var $5FkrB = parcelRequire("5FkrB");
var $38d12fd915127030$var$syncFallback = function syncFallback(create) {
    return create();
};
var $38d12fd915127030$var$useInsertionEffect = $5FkrB.useInsertionEffect ? $5FkrB.useInsertionEffect : false;
var $38d12fd915127030$export$db21c7ffa21794e7 = $38d12fd915127030$var$useInsertionEffect || $38d12fd915127030$var$syncFallback;
var $38d12fd915127030$export$811a713a7276cb9d = $38d12fd915127030$var$useInsertionEffect || $5FkrB.useLayoutEffect;

});



parcelRegister("cYEIA", function(module, exports) {
$parcel$export(module.exports, "tokensMap", () => $972aac682c1ca9c0$export$9a199fbafee0014e);

var $6EyqR = parcelRequire("6EyqR");

var $caG2g = parcelRequire("caG2g");

var $jPLJI = parcelRequire("jPLJI");

var $1Y8x8 = parcelRequire("1Y8x8");

var $4FBpX = parcelRequire("4FBpX");

var $9kviN = parcelRequire("9kviN");

var $48dE5 = parcelRequire("48dE5");

var $ktlcX = parcelRequire("ktlcX");

var $2myjr = parcelRequire("2myjr");

var $1JUg4 = parcelRequire("1JUg4");

var $dLDO7 = parcelRequire("dLDO7");

var $aWY4P = parcelRequire("aWY4P");

var $jEJfN = parcelRequire("jEJfN");

var $6jMrz = parcelRequire("6jMrz");
var $972aac682c1ca9c0$export$9a199fbafee0014e = {
    backgroundColor: (0, $caG2g.backgroundColorMap),
    blockSize: (0, $9kviN.dimensionMap),
    borderBlockColor: (0, $jPLJI.borderColorMap),
    borderBlockEndColor: (0, $jPLJI.borderColorMap),
    borderBlockEndWidth: (0, $4FBpX.borderWidthMap),
    borderBlockStartColor: (0, $jPLJI.borderColorMap),
    borderBlockStartWidth: (0, $4FBpX.borderWidthMap),
    borderBlockWidth: (0, $4FBpX.borderWidthMap),
    borderBottomColor: (0, $jPLJI.borderColorMap),
    borderBottomLeftRadius: (0, $1Y8x8.borderRadiusMap),
    borderBottomRightRadius: (0, $1Y8x8.borderRadiusMap),
    borderBottomWidth: (0, $4FBpX.borderWidthMap),
    borderColor: (0, $jPLJI.borderColorMap),
    borderEndEndRadius: (0, $1Y8x8.borderRadiusMap),
    borderEndStartRadius: (0, $1Y8x8.borderRadiusMap),
    borderInlineColor: (0, $jPLJI.borderColorMap),
    borderInlineEndColor: (0, $jPLJI.borderColorMap),
    borderInlineEndWidth: (0, $4FBpX.borderWidthMap),
    borderInlineStartColor: (0, $jPLJI.borderColorMap),
    borderInlineStartWidth: (0, $4FBpX.borderWidthMap),
    borderInlineWidth: (0, $4FBpX.borderWidthMap),
    borderLeftColor: (0, $jPLJI.borderColorMap),
    borderLeftWidth: (0, $4FBpX.borderWidthMap),
    borderRadius: (0, $1Y8x8.borderRadiusMap),
    borderRightColor: (0, $jPLJI.borderColorMap),
    borderRightWidth: (0, $4FBpX.borderWidthMap),
    borderStartEndRadius: (0, $1Y8x8.borderRadiusMap),
    borderStartStartRadius: (0, $1Y8x8.borderRadiusMap),
    borderTopColor: (0, $jPLJI.borderColorMap),
    borderTopLeftRadius: (0, $1Y8x8.borderRadiusMap),
    borderTopRightRadius: (0, $1Y8x8.borderRadiusMap),
    borderTopWidth: (0, $4FBpX.borderWidthMap),
    borderWidth: (0, $4FBpX.borderWidthMap),
    bottom: (0, $6EyqR.allSpaceMap),
    boxShadow: (0, $jEJfN.shadowMap),
    color: (0, $6jMrz.textColorMap),
    columnGap: (0, $aWY4P.positiveSpaceMap),
    font: (0, $48dE5.fontMap),
    fontFamily: (0, $ktlcX.fontFamilyMap),
    fontWeight: (0, $2myjr.fontWeightMap),
    gap: (0, $aWY4P.positiveSpaceMap),
    height: (0, $9kviN.dimensionMap),
    inlineSize: (0, $9kviN.dimensionMap),
    inset: (0, $6EyqR.allSpaceMap),
    insetBlock: (0, $6EyqR.allSpaceMap),
    insetBlockEnd: (0, $6EyqR.allSpaceMap),
    insetBlockStart: (0, $6EyqR.allSpaceMap),
    insetInline: (0, $6EyqR.allSpaceMap),
    insetInlineEnd: (0, $6EyqR.allSpaceMap),
    insetInlineStart: (0, $6EyqR.allSpaceMap),
    left: (0, $6EyqR.allSpaceMap),
    margin: (0, $6EyqR.allSpaceMap),
    marginBlock: (0, $6EyqR.allSpaceMap),
    marginBlockEnd: (0, $6EyqR.allSpaceMap),
    marginBlockStart: (0, $6EyqR.allSpaceMap),
    marginBottom: (0, $6EyqR.allSpaceMap),
    marginInline: (0, $6EyqR.allSpaceMap),
    marginInlineEnd: (0, $6EyqR.allSpaceMap),
    marginInlineStart: (0, $6EyqR.allSpaceMap),
    marginLeft: (0, $6EyqR.allSpaceMap),
    marginRight: (0, $6EyqR.allSpaceMap),
    marginTop: (0, $6EyqR.allSpaceMap),
    maxBlockSize: (0, $9kviN.dimensionMap),
    maxHeight: (0, $9kviN.dimensionMap),
    maxInlineSize: (0, $9kviN.dimensionMap),
    maxWidth: (0, $9kviN.dimensionMap),
    minBlockSize: (0, $9kviN.dimensionMap),
    minHeight: (0, $9kviN.dimensionMap),
    minInlineSize: (0, $9kviN.dimensionMap),
    minWidth: (0, $9kviN.dimensionMap),
    opacity: (0, $dLDO7.opacityMap),
    outlineColor: (0, $jPLJI.borderColorMap),
    outlineOffset: (0, $6EyqR.allSpaceMap),
    outlineWidth: (0, $4FBpX.borderWidthMap),
    padding: (0, $aWY4P.positiveSpaceMap),
    paddingBlock: (0, $aWY4P.positiveSpaceMap),
    paddingBlockEnd: (0, $aWY4P.positiveSpaceMap),
    paddingBlockStart: (0, $aWY4P.positiveSpaceMap),
    paddingBottom: (0, $aWY4P.positiveSpaceMap),
    paddingInline: (0, $aWY4P.positiveSpaceMap),
    paddingInlineEnd: (0, $aWY4P.positiveSpaceMap),
    paddingInlineStart: (0, $aWY4P.positiveSpaceMap),
    paddingLeft: (0, $aWY4P.positiveSpaceMap),
    paddingRight: (0, $aWY4P.positiveSpaceMap),
    paddingTop: (0, $aWY4P.positiveSpaceMap),
    right: (0, $6EyqR.allSpaceMap),
    rowGap: (0, $aWY4P.positiveSpaceMap),
    top: (0, $6EyqR.allSpaceMap),
    width: (0, $9kviN.dimensionMap),
    zIndex: (0, $1JUg4.layerMap)
};

});
parcelRegister("6EyqR", function(module, exports) {
$parcel$export(module.exports, "allSpaceMap", () => $4d8130069ac5fc0a$export$632685d741f3dbbf);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::4193602efb8ae1ec92457e1d4ae51cd6>>
 * @codegenCommand yarn workspace @atlaskit/primitives codegen-styles
 * @codegenDependency ../../../tokens/src/artifacts/tokens-raw/atlassian-spacing.tsx <<SignedSource::535518e7add48ef24f526d0904f70060>>
 */ var $4d8130069ac5fc0a$export$632685d741f3dbbf = {
    'space.0': "var(--ds-space-0, 0px)",
    'space.025': "var(--ds-space-025, 2px)",
    'space.050': "var(--ds-space-050, 4px)",
    'space.075': "var(--ds-space-075, 6px)",
    'space.100': "var(--ds-space-100, 8px)",
    'space.150': "var(--ds-space-150, 12px)",
    'space.200': "var(--ds-space-200, 16px)",
    'space.250': "var(--ds-space-250, 20px)",
    'space.300': "var(--ds-space-300, 24px)",
    'space.400': "var(--ds-space-400, 32px)",
    'space.500': "var(--ds-space-500, 40px)",
    'space.600': "var(--ds-space-600, 48px)",
    'space.800': "var(--ds-space-800, 64px)",
    'space.1000': "var(--ds-space-1000, 80px)",
    'space.negative.025': "var(--ds-space-negative-025, -2px)",
    'space.negative.050': "var(--ds-space-negative-050, -4px)",
    'space.negative.075': "var(--ds-space-negative-075, -6px)",
    'space.negative.100': "var(--ds-space-negative-100, -8px)",
    'space.negative.150': "var(--ds-space-negative-150, -12px)",
    'space.negative.200': "var(--ds-space-negative-200, -16px)",
    'space.negative.250': "var(--ds-space-negative-250, -20px)",
    'space.negative.300': "var(--ds-space-negative-300, -24px)",
    'space.negative.400': "var(--ds-space-negative-400, -32px)"
};

});

parcelRegister("caG2g", function(module, exports) {
$parcel$export(module.exports, "backgroundColorMap", () => $8dc706905367b55f$export$d1d79bf68ac056bd);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::74848f30a8ab0264055ca77ebdcac583>>
 * @codegenCommand yarn workspace @atlaskit/primitives codegen-styles
 * @codegenDependency ../../../tokens/src/artifacts/tokens-raw/atlassian-light.tsx <<SignedSource::4e25079e2363933fae45ad0f1e9c123b>>
 */ var $8dc706905367b55f$export$d1d79bf68ac056bd = {
    'color.background.accent.lime.subtlest': "var(--ds-background-accent-lime-subtlest, #EFFFD6)",
    'color.background.accent.lime.subtlest.hovered': "var(--ds-background-accent-lime-subtlest-hovered, #D3F1A7)",
    'color.background.accent.lime.subtlest.pressed': "var(--ds-background-accent-lime-subtlest-pressed, #BDE97C)",
    'color.background.accent.lime.subtler': "var(--ds-background-accent-lime-subtler, #D3F1A7)",
    'color.background.accent.lime.subtler.hovered': "var(--ds-background-accent-lime-subtler-hovered, #BDE97C)",
    'color.background.accent.lime.subtler.pressed': "var(--ds-background-accent-lime-subtler-pressed, #B3DF72)",
    'color.background.accent.lime.subtle': "var(--ds-background-accent-lime-subtle, #94C748)",
    'color.background.accent.lime.subtle.hovered': "var(--ds-background-accent-lime-subtle-hovered, #B3DF72)",
    'color.background.accent.lime.subtle.pressed': "var(--ds-background-accent-lime-subtle-pressed, #BDE97C)",
    'color.background.accent.lime.bolder': "var(--ds-background-accent-lime-bolder, #5B7F24)",
    'color.background.accent.lime.bolder.hovered': "var(--ds-background-accent-lime-bolder-hovered, #4C6B1F)",
    'color.background.accent.lime.bolder.pressed': "var(--ds-background-accent-lime-bolder-pressed, #3F5224)",
    'color.background.accent.red.subtlest': "var(--ds-background-accent-red-subtlest, #FFECEB)",
    'color.background.accent.red.subtlest.hovered': "var(--ds-background-accent-red-subtlest-hovered, #FFD5D2)",
    'color.background.accent.red.subtlest.pressed': "var(--ds-background-accent-red-subtlest-pressed, #FFB8B2)",
    'color.background.accent.red.subtler': "var(--ds-background-accent-red-subtler, #FFD5D2)",
    'color.background.accent.red.subtler.hovered': "var(--ds-background-accent-red-subtler-hovered, #FFB8B2)",
    'color.background.accent.red.subtler.pressed': "var(--ds-background-accent-red-subtler-pressed, #FD9891)",
    'color.background.accent.red.subtle': "var(--ds-background-accent-red-subtle, #F87168)",
    'color.background.accent.red.subtle.hovered': "var(--ds-background-accent-red-subtle-hovered, #FD9891)",
    'color.background.accent.red.subtle.pressed': "var(--ds-background-accent-red-subtle-pressed, #FFB8B2)",
    'color.background.accent.red.bolder': "var(--ds-background-accent-red-bolder, #C9372C)",
    'color.background.accent.red.bolder.hovered': "var(--ds-background-accent-red-bolder-hovered, #AE2E24)",
    'color.background.accent.red.bolder.pressed': "var(--ds-background-accent-red-bolder-pressed, #872821)",
    'color.background.accent.orange.subtlest': "var(--ds-background-accent-orange-subtlest, #FFF5DB)",
    'color.background.accent.orange.subtlest.hovered': "var(--ds-background-accent-orange-subtlest-hovered, #FCE4A6)",
    'color.background.accent.orange.subtlest.pressed': "var(--ds-background-accent-orange-subtlest-pressed, #FBD779)",
    'color.background.accent.orange.subtler': "var(--ds-background-accent-orange-subtler, #FCE4A6)",
    'color.background.accent.orange.subtler.hovered': "var(--ds-background-accent-orange-subtler-hovered, #FBD779)",
    'color.background.accent.orange.subtler.pressed': "var(--ds-background-accent-orange-subtler-pressed, #FBC828)",
    'color.background.accent.orange.subtle': "var(--ds-background-accent-orange-subtle, #FCA700)",
    'color.background.accent.orange.subtle.hovered': "var(--ds-background-accent-orange-subtle-hovered, #FBC828)",
    'color.background.accent.orange.subtle.pressed': "var(--ds-background-accent-orange-subtle-pressed, #FBD779)",
    'color.background.accent.orange.bolder': "var(--ds-background-accent-orange-bolder, #BD5B00)",
    'color.background.accent.orange.bolder.hovered': "var(--ds-background-accent-orange-bolder-hovered, #9E4C00)",
    'color.background.accent.orange.bolder.pressed': "var(--ds-background-accent-orange-bolder-pressed, #7A3B00)",
    'color.background.accent.yellow.subtlest': "var(--ds-background-accent-yellow-subtlest, #FEF7C8)",
    'color.background.accent.yellow.subtlest.hovered': "var(--ds-background-accent-yellow-subtlest-hovered, #F5E989)",
    'color.background.accent.yellow.subtlest.pressed': "var(--ds-background-accent-yellow-subtlest-pressed, #EFDD4E)",
    'color.background.accent.yellow.subtler': "var(--ds-background-accent-yellow-subtler, #F5E989)",
    'color.background.accent.yellow.subtler.hovered': "var(--ds-background-accent-yellow-subtler-hovered, #EFDD4E)",
    'color.background.accent.yellow.subtler.pressed': "var(--ds-background-accent-yellow-subtler-pressed, #EED12B)",
    'color.background.accent.yellow.subtle': "var(--ds-background-accent-yellow-subtle, #EED12B)",
    'color.background.accent.yellow.subtle.hovered': "var(--ds-background-accent-yellow-subtle-hovered, #DDB30E)",
    'color.background.accent.yellow.subtle.pressed': "var(--ds-background-accent-yellow-subtle-pressed, #EFDD4E)",
    'color.background.accent.yellow.bolder': "var(--ds-background-accent-yellow-bolder, #946F00)",
    'color.background.accent.yellow.bolder.hovered': "var(--ds-background-accent-yellow-bolder-hovered, #7F5F01)",
    'color.background.accent.yellow.bolder.pressed': "var(--ds-background-accent-yellow-bolder-pressed, #614A05)",
    'color.background.accent.green.subtlest': "var(--ds-background-accent-green-subtlest, #DCFFF1)",
    'color.background.accent.green.subtlest.hovered': "var(--ds-background-accent-green-subtlest-hovered, #BAF3DB)",
    'color.background.accent.green.subtlest.pressed': "var(--ds-background-accent-green-subtlest-pressed, #97EDC9)",
    'color.background.accent.green.subtler': "var(--ds-background-accent-green-subtler, #BAF3DB)",
    'color.background.accent.green.subtler.hovered': "var(--ds-background-accent-green-subtler-hovered, #97EDC9)",
    'color.background.accent.green.subtler.pressed': "var(--ds-background-accent-green-subtler-pressed, #7EE2B8)",
    'color.background.accent.green.subtle': "var(--ds-background-accent-green-subtle, #4BCE97)",
    'color.background.accent.green.subtle.hovered': "var(--ds-background-accent-green-subtle-hovered, #7EE2B8)",
    'color.background.accent.green.subtle.pressed': "var(--ds-background-accent-green-subtle-pressed, #97EDC9)",
    'color.background.accent.green.bolder': "var(--ds-background-accent-green-bolder, #1F845A)",
    'color.background.accent.green.bolder.hovered': "var(--ds-background-accent-green-bolder-hovered, #216E4E)",
    'color.background.accent.green.bolder.pressed': "var(--ds-background-accent-green-bolder-pressed, #19573D)",
    'color.background.accent.teal.subtlest': "var(--ds-background-accent-teal-subtlest, #E7F9FF)",
    'color.background.accent.teal.subtlest.hovered': "var(--ds-background-accent-teal-subtlest-hovered, #C6EDFB)",
    'color.background.accent.teal.subtlest.pressed': "var(--ds-background-accent-teal-subtlest-pressed, #B1E4F7)",
    'color.background.accent.teal.subtler': "var(--ds-background-accent-teal-subtler, #C6EDFB)",
    'color.background.accent.teal.subtler.hovered': "var(--ds-background-accent-teal-subtler-hovered, #B1E4F7)",
    'color.background.accent.teal.subtler.pressed': "var(--ds-background-accent-teal-subtler-pressed, #9DD9EE)",
    'color.background.accent.teal.subtle': "var(--ds-background-accent-teal-subtle, #6CC3E0)",
    'color.background.accent.teal.subtle.hovered': "var(--ds-background-accent-teal-subtle-hovered, #9DD9EE)",
    'color.background.accent.teal.subtle.pressed': "var(--ds-background-accent-teal-subtle-pressed, #B1E4F7)",
    'color.background.accent.teal.bolder': "var(--ds-background-accent-teal-bolder, #227D9B)",
    'color.background.accent.teal.bolder.hovered': "var(--ds-background-accent-teal-bolder-hovered, #206A83)",
    'color.background.accent.teal.bolder.pressed': "var(--ds-background-accent-teal-bolder-pressed, #1A5265)",
    'color.background.accent.blue.subtlest': "var(--ds-background-accent-blue-subtlest, #E9F2FE)",
    'color.background.accent.blue.subtlest.hovered': "var(--ds-background-accent-blue-subtlest-hovered, #CFE1FD)",
    'color.background.accent.blue.subtlest.pressed': "var(--ds-background-accent-blue-subtlest-pressed, #ADCBFB)",
    'color.background.accent.blue.subtler': "var(--ds-background-accent-blue-subtler, #CFE1FD)",
    'color.background.accent.blue.subtler.hovered': "var(--ds-background-accent-blue-subtler-hovered, #ADCBFB)",
    'color.background.accent.blue.subtler.pressed': "var(--ds-background-accent-blue-subtler-pressed, #8FB8F6)",
    'color.background.accent.blue.subtle': "var(--ds-background-accent-blue-subtle, #669DF1)",
    'color.background.accent.blue.subtle.hovered': "var(--ds-background-accent-blue-subtle-hovered, #8FB8F6)",
    'color.background.accent.blue.subtle.pressed': "var(--ds-background-accent-blue-subtle-pressed, #ADCBFB)",
    'color.background.accent.blue.bolder': "var(--ds-background-accent-blue-bolder, #1868DB)",
    'color.background.accent.blue.bolder.hovered': "var(--ds-background-accent-blue-bolder-hovered, #1558BC)",
    'color.background.accent.blue.bolder.pressed': "var(--ds-background-accent-blue-bolder-pressed, #144794)",
    'color.background.accent.purple.subtlest': "var(--ds-background-accent-purple-subtlest, #F8EEFE)",
    'color.background.accent.purple.subtlest.hovered': "var(--ds-background-accent-purple-subtlest-hovered, #EED7FC)",
    'color.background.accent.purple.subtlest.pressed': "var(--ds-background-accent-purple-subtlest-pressed, #E3BDFA)",
    'color.background.accent.purple.subtler': "var(--ds-background-accent-purple-subtler, #EED7FC)",
    'color.background.accent.purple.subtler.hovered': "var(--ds-background-accent-purple-subtler-hovered, #E3BDFA)",
    'color.background.accent.purple.subtler.pressed': "var(--ds-background-accent-purple-subtler-pressed, #D8A0F7)",
    'color.background.accent.purple.subtle': "var(--ds-background-accent-purple-subtle, #C97CF4)",
    'color.background.accent.purple.subtle.hovered': "var(--ds-background-accent-purple-subtle-hovered, #D8A0F7)",
    'color.background.accent.purple.subtle.pressed': "var(--ds-background-accent-purple-subtle-pressed, #E3BDFA)",
    'color.background.accent.purple.bolder': "var(--ds-background-accent-purple-bolder, #964AC0)",
    'color.background.accent.purple.bolder.hovered': "var(--ds-background-accent-purple-bolder-hovered, #803FA5)",
    'color.background.accent.purple.bolder.pressed': "var(--ds-background-accent-purple-bolder-pressed, #673286)",
    'color.background.accent.magenta.subtlest': "var(--ds-background-accent-magenta-subtlest, #FFECF8)",
    'color.background.accent.magenta.subtlest.hovered': "var(--ds-background-accent-magenta-subtlest-hovered, #FDD0EC)",
    'color.background.accent.magenta.subtlest.pressed': "var(--ds-background-accent-magenta-subtlest-pressed, #FCB6E1)",
    'color.background.accent.magenta.subtler': "var(--ds-background-accent-magenta-subtler, #FDD0EC)",
    'color.background.accent.magenta.subtler.hovered': "var(--ds-background-accent-magenta-subtler-hovered, #FCB6E1)",
    'color.background.accent.magenta.subtler.pressed': "var(--ds-background-accent-magenta-subtler-pressed, #F797D2)",
    'color.background.accent.magenta.subtle': "var(--ds-background-accent-magenta-subtle, #E774BB)",
    'color.background.accent.magenta.subtle.hovered': "var(--ds-background-accent-magenta-subtle-hovered, #F797D2)",
    'color.background.accent.magenta.subtle.pressed': "var(--ds-background-accent-magenta-subtle-pressed, #FCB6E1)",
    'color.background.accent.magenta.bolder': "var(--ds-background-accent-magenta-bolder, #AE4787)",
    'color.background.accent.magenta.bolder.hovered': "var(--ds-background-accent-magenta-bolder-hovered, #943D73)",
    'color.background.accent.magenta.bolder.pressed': "var(--ds-background-accent-magenta-bolder-pressed, #77325B)",
    'color.background.accent.gray.subtlest': "var(--ds-background-accent-gray-subtlest, #F0F1F2)",
    'color.background.accent.gray.subtlest.hovered': "var(--ds-background-accent-gray-subtlest-hovered, #DDDEE1)",
    'color.background.accent.gray.subtlest.pressed': "var(--ds-background-accent-gray-subtlest-pressed, #B7B9BE)",
    'color.background.accent.gray.subtler': "var(--ds-background-accent-gray-subtler, #DDDEE1)",
    'color.background.accent.gray.subtler.hovered': "var(--ds-background-accent-gray-subtler-hovered, #B7B9BE)",
    'color.background.accent.gray.subtler.pressed': "var(--ds-background-accent-gray-subtler-pressed, #8C8F97)",
    'color.background.accent.gray.subtle': "var(--ds-background-accent-gray-subtle, #8C8F97)",
    'color.background.accent.gray.subtle.hovered': "var(--ds-background-accent-gray-subtle-hovered, #B7B9BE)",
    'color.background.accent.gray.subtle.pressed': "var(--ds-background-accent-gray-subtle-pressed, #DDDEE1)",
    'color.background.accent.gray.bolder': "var(--ds-background-accent-gray-bolder, #6B6E76)",
    'color.background.accent.gray.bolder.hovered': "var(--ds-background-accent-gray-bolder-hovered, #505258)",
    'color.background.accent.gray.bolder.pressed': "var(--ds-background-accent-gray-bolder-pressed, #3B3D42)",
    'color.background.code.added.highlight': "var(--ds-background-code-added-highlight, #DCFFF1)",
    'color.background.code.added.line': "var(--ds-background-code-added-line, #BAF3DB66)",
    'color.background.code.default': "var(--ds-background-code-default, #FFFFFF)",
    'color.background.code.gutter': "var(--ds-background-code-gutter, #F0F1F2)",
    'color.background.code.highlight': "var(--ds-background-code-highlight, #F0F1F2)",
    'color.background.code.removed.highlight': "var(--ds-background-code-removed-highlight, #FFECEB)",
    'color.background.code.removed.line': "var(--ds-background-code-removed-line, #FFD5D266)",
    'color.background.disabled': "var(--ds-background-disabled, #0515240F)",
    'color.background.input': "var(--ds-background-input, #FFFFFF)",
    'color.background.input.hovered': "var(--ds-background-input-hovered, #F8F8F8)",
    'color.background.input.pressed': "var(--ds-background-input-pressed, #FFFFFF)",
    'color.background.inverse.subtle': "var(--ds-background-inverse-subtle, #00000029)",
    'color.background.inverse.subtle.hovered': "var(--ds-background-inverse-subtle-hovered, #0000003D)",
    'color.background.inverse.subtle.pressed': "var(--ds-background-inverse-subtle-pressed, #00000052)",
    'color.background.neutral': "var(--ds-background-neutral, #0515240F)",
    'color.background.neutral.hovered': "var(--ds-background-neutral-hovered, #0B120E24)",
    'color.background.neutral.pressed': "var(--ds-background-neutral-pressed, #080F214A)",
    'color.background.neutral.subtle': "var(--ds-background-neutral-subtle, #00000000)",
    'color.background.neutral.subtle.hovered': "var(--ds-background-neutral-subtle-hovered, #0515240F)",
    'color.background.neutral.subtle.pressed': "var(--ds-background-neutral-subtle-pressed, #0B120E24)",
    'color.background.neutral.bold': "var(--ds-background-neutral-bold, #292A2E)",
    'color.background.neutral.bold.hovered': "var(--ds-background-neutral-bold-hovered, #3B3D42)",
    'color.background.neutral.bold.pressed': "var(--ds-background-neutral-bold-pressed, #505258)",
    'color.background.selected': "var(--ds-background-selected, #E9F2FE)",
    'color.background.selected.hovered': "var(--ds-background-selected-hovered, #CFE1FD)",
    'color.background.selected.pressed': "var(--ds-background-selected-pressed, #8FB8F6)",
    'color.background.selected.bold': "var(--ds-background-selected-bold, #1868DB)",
    'color.background.selected.bold.hovered': "var(--ds-background-selected-bold-hovered, #1558BC)",
    'color.background.selected.bold.pressed': "var(--ds-background-selected-bold-pressed, #123263)",
    'color.background.brand.subtlest': "var(--ds-background-brand-subtlest, #E9F2FE)",
    'color.background.brand.subtlest.hovered': "var(--ds-background-brand-subtlest-hovered, #CFE1FD)",
    'color.background.brand.subtlest.pressed': "var(--ds-background-brand-subtlest-pressed, #ADCBFB)",
    'color.background.brand.bold': "var(--ds-background-brand-bold, #1868DB)",
    'color.background.brand.bold.hovered': "var(--ds-background-brand-bold-hovered, #1558BC)",
    'color.background.brand.bold.pressed': "var(--ds-background-brand-bold-pressed, #144794)",
    'color.background.brand.boldest': "var(--ds-background-brand-boldest, #1C2B42)",
    'color.background.brand.boldest.hovered': "var(--ds-background-brand-boldest-hovered, #123263)",
    'color.background.brand.boldest.pressed': "var(--ds-background-brand-boldest-pressed, #144794)",
    'color.background.danger': "var(--ds-background-danger, #FFECEB)",
    'color.background.danger.hovered': "var(--ds-background-danger-hovered, #FFD5D2)",
    'color.background.danger.pressed': "var(--ds-background-danger-pressed, #FFB8B2)",
    'color.background.danger.subtler': "var(--ds-background-danger-subtler, #FFD5D2)",
    'color.background.danger.subtler.hovered': "var(--ds-background-danger-subtler-hovered, #FFB8B2)",
    'color.background.danger.subtler.pressed': "var(--ds-background-danger-subtler-pressed, #FD9891)",
    'color.background.danger.subtle': "var(--ds-background-danger-subtle, #FD9891)",
    'color.background.danger.bold': "var(--ds-background-danger-bold, #C9372C)",
    'color.background.danger.bold.hovered': "var(--ds-background-danger-bold-hovered, #AE2E24)",
    'color.background.danger.bold.pressed': "var(--ds-background-danger-bold-pressed, #872821)",
    'color.background.warning': "var(--ds-background-warning, #FFF5DB)",
    'color.background.warning.hovered': "var(--ds-background-warning-hovered, #FCE4A6)",
    'color.background.warning.pressed': "var(--ds-background-warning-pressed, #FBD779)",
    'color.background.warning.subtler': "var(--ds-background-warning-subtler, #FCE4A6)",
    'color.background.warning.subtler.hovered': "var(--ds-background-warning-subtler-hovered, #FBD779)",
    'color.background.warning.subtler.pressed': "var(--ds-background-warning-subtler-pressed, #FBC828)",
    'color.background.warning.subtle': "var(--ds-background-warning-subtle, #FBD779)",
    'color.background.warning.bold': "var(--ds-background-warning-bold, #FBC828)",
    'color.background.warning.bold.hovered': "var(--ds-background-warning-bold-hovered, #FCA700)",
    'color.background.warning.bold.pressed': "var(--ds-background-warning-bold-pressed, #F68909)",
    'color.background.success': "var(--ds-background-success, #EFFFD6)",
    'color.background.success.hovered': "var(--ds-background-success-hovered, #D3F1A7)",
    'color.background.success.pressed': "var(--ds-background-success-pressed, #BDE97C)",
    'color.background.success.subtler': "var(--ds-background-success-subtler, #D3F1A7)",
    'color.background.success.subtler.hovered': "var(--ds-background-success-subtler-hovered, #BDE97C)",
    'color.background.success.subtler.pressed': "var(--ds-background-success-subtler-pressed, #B3DF72)",
    'color.background.success.subtle': "var(--ds-background-success-subtle, #B3DF72)",
    'color.background.success.bold': "var(--ds-background-success-bold, #5B7F24)",
    'color.background.success.bold.hovered': "var(--ds-background-success-bold-hovered, #4C6B1F)",
    'color.background.success.bold.pressed': "var(--ds-background-success-bold-pressed, #3F5224)",
    'color.background.discovery': "var(--ds-background-discovery, #F8EEFE)",
    'color.background.discovery.hovered': "var(--ds-background-discovery-hovered, #EED7FC)",
    'color.background.discovery.pressed': "var(--ds-background-discovery-pressed, #E3BDFA)",
    'color.background.discovery.subtler': "var(--ds-background-discovery-subtler, #EED7FC)",
    'color.background.discovery.subtler.hovered': "var(--ds-background-discovery-subtler-hovered, #E3BDFA)",
    'color.background.discovery.subtler.pressed': "var(--ds-background-discovery-subtler-pressed, #D8A0F7)",
    'color.background.discovery.subtle': "var(--ds-background-discovery-subtle, #D8A0F7)",
    'color.background.discovery.bold': "var(--ds-background-discovery-bold, #964AC0)",
    'color.background.discovery.bold.hovered': "var(--ds-background-discovery-bold-hovered, #803FA5)",
    'color.background.discovery.bold.pressed': "var(--ds-background-discovery-bold-pressed, #673286)",
    'color.background.information': "var(--ds-background-information, #E9F2FE)",
    'color.background.information.hovered': "var(--ds-background-information-hovered, #CFE1FD)",
    'color.background.information.pressed': "var(--ds-background-information-pressed, #ADCBFB)",
    'color.background.information.subtler': "var(--ds-background-information-subtler, #CFE1FD)",
    'color.background.information.subtler.hovered': "var(--ds-background-information-subtler-hovered, #ADCBFB)",
    'color.background.information.subtler.pressed': "var(--ds-background-information-subtler-pressed, #8FB8F6)",
    'color.background.information.subtle': "var(--ds-background-information-subtle, #8FB8F6)",
    'color.background.information.bold': "var(--ds-background-information-bold, #1868DB)",
    'color.background.information.bold.hovered': "var(--ds-background-information-bold-hovered, #1558BC)",
    'color.background.information.bold.pressed': "var(--ds-background-information-bold-pressed, #144794)",
    'color.skeleton': "var(--ds-skeleton, #0515240F)",
    'color.skeleton.subtle': "var(--ds-skeleton-subtle, #17171708)",
    'color.blanket': "var(--ds-blanket, #050C1F75)",
    'color.blanket.selected': "var(--ds-blanket-selected, #388BFF14)",
    'color.blanket.danger': "var(--ds-blanket-danger, #EF5C4814)",
    'color.rovo.background.brand.bold': "var(--ds-rovo-background-brand-bold, #000000)",
    'color.rovo.background.brand.bold.hovered': "var(--ds-rovo-background-brand-bold-hovered, #1E1F21)",
    'color.rovo.background.brand.bold.pressed': "var(--ds-rovo-background-brand-bold-pressed, #292A2E)",
    'elevation.surface': "var(--ds-surface, #FFFFFF)",
    'elevation.surface.hovered': "var(--ds-surface-hovered, #F0F1F2)",
    'elevation.surface.pressed': "var(--ds-surface-pressed, #DDDEE1)",
    'elevation.surface.container': "var(--ds-surface-container, #17171708)",
    'elevation.surface.container.hovered': "var(--ds-surface-container-hovered, #0515240F)",
    'elevation.surface.container.pressed': "var(--ds-surface-container-pressed, #0B120E24)",
    'elevation.surface.overlay': "var(--ds-surface-overlay, #FFFFFF)",
    'elevation.surface.overlay.hovered': "var(--ds-surface-overlay-hovered, #F0F1F2)",
    'elevation.surface.overlay.pressed': "var(--ds-surface-overlay-pressed, #DDDEE1)",
    'elevation.surface.raised': "var(--ds-surface-raised, #FFFFFF)",
    'elevation.surface.raised.hovered': "var(--ds-surface-raised-hovered, #F0F1F2)",
    'elevation.surface.raised.pressed': "var(--ds-surface-raised-pressed, #DDDEE1)",
    'elevation.surface.sunken': "var(--ds-surface-sunken, #F8F8F8)",
    'utility.elevation.surface.current': "var(--ds-elevation-surface-current, #FFFFFF)"
};

});

parcelRegister("jPLJI", function(module, exports) {
$parcel$export(module.exports, "borderColorMap", () => $e707cf33336581e8$export$1531ad5bb3fbedac);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c2243347101d0284063f83cb3084a0b4>>
 * @codegenCommand yarn workspace @atlaskit/primitives codegen-styles
 * @codegenDependency ../../../tokens/src/artifacts/tokens-raw/atlassian-light.tsx <<SignedSource::4e25079e2363933fae45ad0f1e9c123b>>
 */ var $e707cf33336581e8$export$1531ad5bb3fbedac = {
    'color.border': "var(--ds-border, #0B120E24)",
    'color.border.accent.lime': "var(--ds-border-accent-lime, #6A9A23)",
    'color.border.accent.lime.subtle': "var(--ds-border-accent-lime-subtle, #B3DF72)",
    'color.border.accent.red': "var(--ds-border-accent-red, #E2483D)",
    'color.border.accent.red.subtle': "var(--ds-border-accent-red-subtle, #FD9891)",
    'color.border.accent.orange': "var(--ds-border-accent-orange, #E06C00)",
    'color.border.accent.orange.subtle': "var(--ds-border-accent-orange-subtle, #FBC828)",
    'color.border.accent.yellow': "var(--ds-border-accent-yellow, #B38600)",
    'color.border.accent.yellow.subtle': "var(--ds-border-accent-yellow-subtle, #EED12B)",
    'color.border.accent.green': "var(--ds-border-accent-green, #22A06B)",
    'color.border.accent.green.subtle': "var(--ds-border-accent-green-subtle, #7EE2B8)",
    'color.border.accent.teal': "var(--ds-border-accent-teal, #2898BD)",
    'color.border.accent.teal.subtle': "var(--ds-border-accent-teal-subtle, #9DD9EE)",
    'color.border.accent.blue': "var(--ds-border-accent-blue, #357DE8)",
    'color.border.accent.blue.subtle': "var(--ds-border-accent-blue-subtle, #8FB8F6)",
    'color.border.accent.purple': "var(--ds-border-accent-purple, #AF59E1)",
    'color.border.accent.purple.subtle': "var(--ds-border-accent-purple-subtle, #D8A0F7)",
    'color.border.accent.magenta': "var(--ds-border-accent-magenta, #CD519D)",
    'color.border.accent.magenta.subtle': "var(--ds-border-accent-magenta-subtle, #F797D2)",
    'color.border.accent.gray': "var(--ds-border-accent-gray, #7D818A)",
    'color.border.accent.gray.subtle': "var(--ds-border-accent-gray-subtle, #B7B9BE)",
    'color.border.code': "var(--ds-border-code, #0B120E24)",
    'color.border.disabled': "var(--ds-border-disabled, #0515240F)",
    'color.border.focused': "var(--ds-border-focused, #4688EC)",
    'color.border.input': "var(--ds-border-input, #8C8F97)",
    'color.border.inverse': "var(--ds-border-inverse, #FFFFFF)",
    'color.border.selected': "var(--ds-border-selected, #1868DB)",
    'color.border.brand': "var(--ds-border-brand, #1868DB)",
    'color.border.danger': "var(--ds-border-danger, #E2483D)",
    'color.border.danger.subtle': "var(--ds-border-danger-subtle, #FD9891)",
    'color.border.warning': "var(--ds-border-warning, #E06C00)",
    'color.border.warning.subtle': "var(--ds-border-warning-subtle, #FBC828)",
    'color.border.success': "var(--ds-border-success, #6A9A23)",
    'color.border.success.subtle': "var(--ds-border-success-subtle, #B3DF72)",
    'color.border.discovery': "var(--ds-border-discovery, #AF59E1)",
    'color.border.discovery.subtle': "var(--ds-border-discovery-subtle, #D8A0F7)",
    'color.border.information': "var(--ds-border-information, #357DE8)",
    'color.border.information.subtle': "var(--ds-border-information-subtle, #8FB8F6)",
    'color.border.bold': "var(--ds-border-bold, #7D818A)"
};

});

parcelRegister("1Y8x8", function(module, exports) {
$parcel$export(module.exports, "borderRadiusMap", () => $16f203950a8620fa$export$3c0a6c3e64bb180d);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::75649f8b704acb878c98303f7bc82aee>>
 * @codegenCommand yarn workspace @atlaskit/primitives codegen-styles
 * @codegenDependency ../../../tokens/src/artifacts/tokens-raw/atlassian-shape.tsx <<SignedSource::8817f4073995e5dc9c2bb766316632d6>>
 */ var $16f203950a8620fa$export$3c0a6c3e64bb180d = {
    'radius.xsmall': "var(--ds-radius-xsmall, 2px)",
    'radius.small': "var(--ds-radius-small, 3px)",
    'radius.medium': "var(--ds-radius-medium, 6px)",
    'radius.large': "var(--ds-radius-large, 8px)",
    'radius.xlarge': "var(--ds-radius-xlarge, 12px)",
    'radius.xxlarge': "var(--ds-radius-xxlarge, 16px)",
    'radius.full': "var(--ds-radius-full, 9999px)",
    'radius.tile': "var(--ds-radius-tile, 25%)"
};

});

parcelRegister("4FBpX", function(module, exports) {
$parcel$export(module.exports, "borderWidthMap", () => $3668042176e82b6a$export$e1b83c5210c471b8);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2ee12747fee6f7445e430f52ee1f7b86>>
 * @codegenCommand yarn workspace @atlaskit/primitives codegen-styles
 * @codegenDependency ../../../tokens/src/artifacts/tokens-raw/atlassian-shape.tsx <<SignedSource::8817f4073995e5dc9c2bb766316632d6>>
 */ var $3668042176e82b6a$export$e1b83c5210c471b8 = {
    'border.width': "var(--ds-border-width, 1px)",
    'border.width.selected': "var(--ds-border-width-selected, 2px)",
    'border.width.focused': "var(--ds-border-width-focused, 2px)"
};

});

parcelRegister("9kviN", function(module, exports) {
$parcel$export(module.exports, "dimensionMap", () => $6cae434102897d67$export$6ccdbebca2ee545f);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::9183c00a6ce1b53a46530f6f0a7883ea>>
 * @codegenCommand yarn workspace @atlaskit/primitives codegen-styles
 * @codegenDependency ../../scripts/codegen-file-templates/dimensions.tsx <<SignedSource::cc9b3f12104c6ede803da6a42daac0b0>>
 */ var $6cae434102897d67$export$6ccdbebca2ee545f = {
    '100%': '100%',
    'size.100': '1rem',
    'size.200': '1.5rem',
    'size.300': '2rem',
    'size.400': '2.5rem',
    'size.500': '3rem',
    'size.600': '6rem',
    'size.1000': '12rem'
};

});

parcelRegister("48dE5", function(module, exports) {
$parcel$export(module.exports, "fontMap", () => $30227e8124f7c739$export$6ffa317d5e70375);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::7e931a3b15648861e85392c4c0721fbb>>
 * @codegenCommand yarn workspace @atlaskit/primitives codegen-styles
 * @codegenDependency ../../scripts/codegen-file-templates/dimensions.tsx <<SignedSource::cc9b3f12104c6ede803da6a42daac0b0>>
 * @codegenDependency ../../scripts/codegen-file-templates/layer.tsx <<SignedSource::92793ca02dbfdad66e53ffbe9f0baa0a>>
 */ var $30227e8124f7c739$export$6ffa317d5e70375 = {
    'font.body': "var(--ds-font-body, normal 400 14px/20px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.body.large': "var(--ds-font-body-large, normal 400 16px/24px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.body.small': "var(--ds-font-body-small, normal 400 12px/16px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.code': "var(--ds-font-code, normal 400 0.875em/1 \"Atlassian Mono\", ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)",
    'font.heading.large': "var(--ds-font-heading-large, normal 653 24px/28px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.heading.medium': "var(--ds-font-heading-medium, normal 653 20px/24px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.heading.small': "var(--ds-font-heading-small, normal 653 16px/20px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.heading.xlarge': "var(--ds-font-heading-xlarge, normal 653 28px/32px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.heading.xsmall': "var(--ds-font-heading-xsmall, normal 653 14px/20px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.heading.xxlarge': "var(--ds-font-heading-xxlarge, normal 653 32px/36px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.heading.xxsmall': "var(--ds-font-heading-xxsmall, normal 653 12px/16px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.metric.large': "var(--ds-font-metric-large, normal 653 28px/32px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.metric.medium': "var(--ds-font-metric-medium, normal 653 24px/28px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.metric.small': "var(--ds-font-metric-small, normal 653 16px/20px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
};

});

parcelRegister("ktlcX", function(module, exports) {
$parcel$export(module.exports, "fontFamilyMap", () => $ee76f787c5411183$export$3c7e9587132614b4);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d46fa1415e9618559c3725b5d922ea57>>
 * @codegenCommand yarn workspace @atlaskit/primitives codegen-styles
 * @codegenDependency ../../scripts/codegen-file-templates/dimensions.tsx <<SignedSource::cc9b3f12104c6ede803da6a42daac0b0>>
 * @codegenDependency ../../scripts/codegen-file-templates/layer.tsx <<SignedSource::92793ca02dbfdad66e53ffbe9f0baa0a>>
 */ var $ee76f787c5411183$export$3c7e9587132614b4 = {
    'font.family.body': "var(--ds-font-family-body, \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.family.brand.body': "var(--ds-font-family-brand-body, \"Charlie Text\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.family.brand.heading': "var(--ds-font-family-brand-heading, \"Charlie Display\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.family.code': "var(--ds-font-family-code, \"Atlassian Mono\", ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)",
    'font.family.heading': "var(--ds-font-family-heading, \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
};

});

parcelRegister("2myjr", function(module, exports) {
$parcel$export(module.exports, "fontWeightMap", () => $1b8840a190717aae$export$303e322c6b1ed114);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::45dd1de71dbd395ec11ae36c4fe5f287>>
 * @codegenCommand yarn workspace @atlaskit/primitives codegen-styles
 * @codegenDependency ../../scripts/codegen-file-templates/dimensions.tsx <<SignedSource::cc9b3f12104c6ede803da6a42daac0b0>>
 * @codegenDependency ../../scripts/codegen-file-templates/layer.tsx <<SignedSource::92793ca02dbfdad66e53ffbe9f0baa0a>>
 */ var $1b8840a190717aae$export$303e322c6b1ed114 = {
    'font.weight.bold': "var(--ds-font-weight-bold, 653)",
    'font.weight.medium': "var(--ds-font-weight-medium, 500)",
    'font.weight.regular': "var(--ds-font-weight-regular, 400)",
    'font.weight.semibold': "var(--ds-font-weight-semibold, 600)"
};

});

parcelRegister("1JUg4", function(module, exports) {
$parcel$export(module.exports, "layerMap", () => $1445a21ee4715a13$export$b5f31a7e431d2eab);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::05a468f2941874c14b7f39734d626517>>
 * @codegenCommand yarn workspace @atlaskit/primitives codegen-styles
 * @codegenDependency ../../scripts/codegen-file-templates/dimensions.tsx <<SignedSource::cc9b3f12104c6ede803da6a42daac0b0>>
 * @codegenDependency ../../scripts/codegen-file-templates/layer.tsx <<SignedSource::92793ca02dbfdad66e53ffbe9f0baa0a>>
 */ var $1445a21ee4715a13$export$b5f31a7e431d2eab = {
    '1': 1,
    card: 100,
    navigation: 200,
    dialog: 300,
    layer: 400,
    blanket: 500,
    modal: 510,
    flag: 600,
    spotlight: 700,
    tooltip: 800
};

});

parcelRegister("dLDO7", function(module, exports) {
$parcel$export(module.exports, "opacityMap", () => $a05e8b0df7ef2eeb$export$daf94a976c798b4f);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::15dcdf4fb5f4336a22fbffce70eb0f75>>
 * @codegenCommand yarn workspace @atlaskit/primitives codegen-styles
 * @codegenDependency ../../../tokens/src/artifacts/tokens-raw/atlassian-light.tsx <<SignedSource::4e25079e2363933fae45ad0f1e9c123b>>
 */ var $a05e8b0df7ef2eeb$export$daf94a976c798b4f = {
    'opacity.disabled': "var(--ds-opacity-disabled, 0.4)",
    'opacity.loading': "var(--ds-opacity-loading, 0.2)"
};

});

parcelRegister("aWY4P", function(module, exports) {
$parcel$export(module.exports, "positiveSpaceMap", () => $7f8dec2ce46e417e$export$958d0ae7f2977ae4);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::40ae4d14447bdc898f255059f8589afd>>
 * @codegenCommand yarn workspace @atlaskit/primitives codegen-styles
 * @codegenDependency ../../../tokens/src/artifacts/tokens-raw/atlassian-spacing.tsx <<SignedSource::535518e7add48ef24f526d0904f70060>>
 */ var $7f8dec2ce46e417e$export$958d0ae7f2977ae4 = {
    'space.0': "var(--ds-space-0, 0px)",
    'space.025': "var(--ds-space-025, 2px)",
    'space.050': "var(--ds-space-050, 4px)",
    'space.075': "var(--ds-space-075, 6px)",
    'space.100': "var(--ds-space-100, 8px)",
    'space.150': "var(--ds-space-150, 12px)",
    'space.200': "var(--ds-space-200, 16px)",
    'space.250': "var(--ds-space-250, 20px)",
    'space.300': "var(--ds-space-300, 24px)",
    'space.400': "var(--ds-space-400, 32px)",
    'space.500': "var(--ds-space-500, 40px)",
    'space.600': "var(--ds-space-600, 48px)",
    'space.800': "var(--ds-space-800, 64px)",
    'space.1000': "var(--ds-space-1000, 80px)"
};

});

parcelRegister("jEJfN", function(module, exports) {
$parcel$export(module.exports, "shadowMap", () => $e4f4db3638948fed$export$7aff6e7ba39bb774);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e652bb770b0f835445d139bf6da7fa80>>
 * @codegenCommand yarn workspace @atlaskit/primitives codegen-styles
 * @codegenDependency ../../../tokens/src/artifacts/tokens-raw/atlassian-light.tsx <<SignedSource::4e25079e2363933fae45ad0f1e9c123b>>
 */ var $e4f4db3638948fed$export$7aff6e7ba39bb774 = {
    'elevation.shadow.overflow': "var(--ds-shadow-overflow, 0px 0px 8px #1E1F21, 0px 0px 1px #1E1F21)",
    'elevation.shadow.overflow.perimeter': "var(--ds-shadow-overflow-perimeter, #1E1F211f)",
    'elevation.shadow.overflow.spread': "var(--ds-shadow-overflow-spread, #1E1F2129)",
    'elevation.shadow.overlay': "var(--ds-shadow-overlay, 0px 8px 12px #1E1F21, 0px 0px 1px #1E1F21)",
    'elevation.shadow.raised': "var(--ds-shadow-raised, 0px 1px 1px #1E1F21, 0px 0px 1px #1E1F21)"
};

});

parcelRegister("6jMrz", function(module, exports) {
$parcel$export(module.exports, "textColorMap", () => $499a1855aed0db86$export$8473307aa00d6ea1);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::5eb11adeb6b8651411b3d8ad1d0c981b>>
 * @codegenCommand yarn workspace @atlaskit/primitives codegen-styles
 * @codegenDependency ../../../tokens/src/artifacts/tokens-raw/atlassian-light.tsx <<SignedSource::4e25079e2363933fae45ad0f1e9c123b>>
 */ var $499a1855aed0db86$export$8473307aa00d6ea1 = {
    'color.text': "var(--ds-text, #292A2E)",
    'color.text.accent.lime': "var(--ds-text-accent-lime, #4C6B1F)",
    'color.text.accent.lime.bolder': "var(--ds-text-accent-lime-bolder, #37471F)",
    'color.text.accent.red': "var(--ds-text-accent-red, #AE2E24)",
    'color.text.accent.red.bolder': "var(--ds-text-accent-red-bolder, #5D1F1A)",
    'color.text.accent.orange': "var(--ds-text-accent-orange, #9E4C00)",
    'color.text.accent.orange.bolder': "var(--ds-text-accent-orange-bolder, #693200)",
    'color.text.accent.yellow': "var(--ds-text-accent-yellow, #7F5F01)",
    'color.text.accent.yellow.bolder': "var(--ds-text-accent-yellow-bolder, #533F04)",
    'color.text.accent.green': "var(--ds-text-accent-green, #216E4E)",
    'color.text.accent.green.bolder': "var(--ds-text-accent-green-bolder, #164B35)",
    'color.text.accent.teal': "var(--ds-text-accent-teal, #206A83)",
    'color.text.accent.teal.bolder': "var(--ds-text-accent-teal-bolder, #164555)",
    'color.text.accent.blue': "var(--ds-text-accent-blue, #1558BC)",
    'color.text.accent.blue.bolder': "var(--ds-text-accent-blue-bolder, #123263)",
    'color.text.accent.purple': "var(--ds-text-accent-purple, #803FA5)",
    'color.text.accent.purple.bolder': "var(--ds-text-accent-purple-bolder, #48245D)",
    'color.text.accent.magenta': "var(--ds-text-accent-magenta, #943D73)",
    'color.text.accent.magenta.bolder': "var(--ds-text-accent-magenta-bolder, #50253F)",
    'color.text.accent.gray': "var(--ds-text-accent-gray, #505258)",
    'color.text.accent.gray.bolder': "var(--ds-text-accent-gray-bolder, #1E1F21)",
    'color.text.code.accent.1': "var(--ds-text-code-accent-1, #943D73)",
    'color.text.code.accent.2': "var(--ds-text-code-accent-2, #1558BC)",
    'color.text.code.comments': "var(--ds-text-code-comments, #505258)",
    'color.text.code.default': "var(--ds-text-code-default, #505258)",
    'color.text.code.functions': "var(--ds-text-code-functions, #216E4E)",
    'color.text.code.gutter': "var(--ds-text-code-gutter, #6B6E76)",
    'color.text.code.keywords': "var(--ds-text-code-keywords, #AE2E24)",
    'color.text.code.numbers': "var(--ds-text-code-numbers, #7F5F01)",
    'color.text.code.operators': "var(--ds-text-code-operators, #292A2E)",
    'color.text.code.strings': "var(--ds-text-code-strings, #4C6B1F)",
    'color.text.code.tags': "var(--ds-text-code-tags, #9E4C00)",
    'color.text.disabled': "var(--ds-text-disabled, #080F214A)",
    'color.text.inverse': "var(--ds-text-inverse, #FFFFFF)",
    'color.text.selected': "var(--ds-text-selected, #1868DB)",
    'color.text.brand': "var(--ds-text-brand, #1868DB)",
    'color.text.danger': "var(--ds-text-danger, #AE2E24)",
    'color.text.danger.bolder': "var(--ds-text-danger-bolder, #5D1F1A)",
    'color.text.warning': "var(--ds-text-warning, #9E4C00)",
    'color.text.warning.inverse': "var(--ds-text-warning-inverse, #292A2E)",
    'color.text.warning.bolder': "var(--ds-text-warning-bolder, #693200)",
    'color.text.success': "var(--ds-text-success, #4C6B1F)",
    'color.text.success.bolder': "var(--ds-text-success-bolder, #37471F)",
    'color.text.discovery': "var(--ds-text-discovery, #803FA5)",
    'color.text.discovery.bolder': "var(--ds-text-discovery-bolder, #48245D)",
    'color.text.information': "var(--ds-text-information, #1558BC)",
    'color.text.information.bolder': "var(--ds-text-information-bolder, #123263)",
    'color.text.subtlest': "var(--ds-text-subtlest, #6B6E76)",
    'color.text.subtle': "var(--ds-text-subtle, #505258)",
    'color.link': "var(--ds-link, #1868DB)",
    'color.link.pressed': "var(--ds-link-pressed, #1558BC)",
    'color.link.visited': "var(--ds-link-visited, #803FA5)",
    'color.link.visited.pressed': "var(--ds-link-visited-pressed, #48245D)"
};

});


parcelRegister("3PTbW", function(module, exports) {
$parcel$export(module.exports, "uniqueSymbol", () => $2cb0f26ccdd4ec7a$export$43e479c916cb4ada);
var $2cb0f26ccdd4ec7a$export$43e479c916cb4ada = Symbol('UNSAFE_INTERNAL_styles');

});


parcelRegister("cd4Qw", function(module, exports) {
$parcel$export(module.exports, "getConsentContext", () => $c10603336f51dc41$export$114096e6f184be2d);

var $1FnhM = parcelRequire("1FnhM");
var $2dYLF = parcelRequire("2dYLF");
var $ev0NA = parcelRequire("ev0NA");
var $jAIn1 = parcelRequire("jAIn1");

var $49b5t = parcelRequire("49b5t");

var $3VQxn = parcelRequire("3VQxn");
var $c10603336f51dc41$var$CustomerName = /*#__PURE__*/ function(CustomerName) {
    CustomerName["TRELLO"] = "trello";
    CustomerName["ECOSYSTEM"] = "ecosystem";
    CustomerName["JIRA"] = "jira";
    CustomerName["CONFLUENCE"] = "confluence";
    CustomerName["AI"] = "ai";
    CustomerName["KAIZEN"] = "kaizen";
    CustomerName["PARTNERCENTRAL"] = "partnercentral";
    CustomerName["BITBUCKET"] = "bitbucket";
    CustomerName["IDENTITY"] = "identity";
    return CustomerName;
}($c10603336f51dc41$var$CustomerName || {});
var $c10603336f51dc41$var$ProfileName = /*#__PURE__*/ function(ProfileName) {
    ProfileName["APPLINKS_OAUTH_2"] = "applinksOAuth2";
    ProfileName["APPLINKS"] = "applinks";
    ProfileName["INTEGRATIONS3LO"] = "integrations3LO";
    ProfileName["POWERUPS3LO"] = "powerups3LO";
    ProfileName["DCR3P"] = "dcr3p";
    ProfileName["AI_A2ADCR3P"] = "a2adcr3p";
    ProfileName["MCP"] = "mcp";
    ProfileName["A2A_DCR3P"] = "a2adcr3p";
    ProfileName["ROVO_CLI"] = "rovoCLI";
    ProfileName["ROVO_DESKTOP"] = "rovoDesktop";
    ProfileName["TWG_CLI"] = "twgCLI";
    ProfileName["ECOSYSTEM"] = "ecosystem";
    ProfileName["DEFAULT"] = "default";
    ProfileName["DEFAULT3LO"] = "default3LO";
    ProfileName["LEGACY_OAUTH_PUBLIC"] = "legacyOAuthPublic";
    ProfileName["LEGACY_OAUTH_PRIVATE"] = "legacyOAuthPrivate";
    ProfileName["DAG_ACTIVATE"] = "dagActivate";
    return ProfileName;
}($c10603336f51dc41$var$ProfileName || {});
const $c10603336f51dc41$var$customerProfileMap = {
    ["trello"]: {
        ["integrations3LO"]: 'Trello',
        ["powerups3LO"]: 'Trello',
        ["default"]: 'Trello'
    },
    ["ecosystem"]: {
        ["ecosystem"]: 'Ecosystem',
        ["default"]: 'Ecosystem'
    },
    ["jira"]: {
        ["applinksOAuth2"]: 'Applinks',
        ["applinks"]: 'Applinks',
        ["default"]: 'Ecosystem'
    },
    ["confluence"]: {
        ["applinksOAuth2"]: 'Applinks',
        ["applinks"]: 'Applinks',
        ["default"]: 'Ecosystem'
    },
    ["ai"]: {
        ["dcr3p"]: 'MCP',
        ["mcp"]: 'MCP',
        ["a2adcr3p"]: 'A2A',
        ["rovoCLI"]: 'Rovo',
        ["rovoDesktop"]: 'Rovo',
        ["twgCLI"]: 'TWG',
        ["default"]: 'MCP'
    },
    ["kaizen"]: {
        ["dcr3p"]: 'Kaizen',
        ["default"]: 'Kaizen'
    },
    ["partnercentral"]: {
        ["default3LO"]: 'PartnerCentral',
        ["default"]: 'PartnerCentral'
    },
    ["bitbucket"]: {
        ["legacyOAuthPublic"]: 'Bitbucket',
        ["legacyOAuthPrivate"]: 'Bitbucket'
    },
    ["identity"]: {
        ["dagActivate"]: 'DAG'
    }
};
let $c10603336f51dc41$var$JWKS;
async function $c10603336f51dc41$export$114096e6f184be2d(options) {
    $c10603336f51dc41$var$JWKS = $c10603336f51dc41$var$JWKS ?? (0, $2dYLF.createRemoteJWKSet)(new URL((0, $49b5t.withForwardedEnv)(`${options?.origin ?? window.location.origin}/.well-known/jwks.json`, options?.searchParams)));
    const searchParams = new URLSearchParams(options?.searchParams ?? window.location.search);
    const contextParam = searchParams.get('context');
    if (!contextParam) return 0, $3VQxn.NoContextTokenError;
    let payload;
    try {
        payload = await $c10603336f51dc41$var$verifyConsentContextToken(contextParam, {
            issuer: options?.expectedIssuer ?? window.location.host,
            audience: options?.expectedAudience ?? window.location.host
        });
    } catch (e) {
        console.error('Failed to verify the token', e);
        if (e instanceof (0, $jAIn1).JOSEError) {
            if (e instanceof (0, $jAIn1).JWTExpired) return 0, $3VQxn.ExpiredContextTokenError;
            return 0, $3VQxn.InvalidContextToken;
        }
        console.error('Exception thrown during token verification was unexpected', e);
        throw e;
    }
    const redirectUrl = $c10603336f51dc41$var$parseRedirectURL(payload.redirect_url);
    const serviceType = $c10603336f51dc41$var$getServiceType(payload.profile, payload.customer);
    return {
        audience: payload.aud,
        profile: payload.profile || null,
        customer: payload.customer || null,
        raw: contextParam,
        issuedAt: payload.iat,
        serviceType: serviceType,
        scopes: payload.scopes && payload.scopes.length > 0 ? payload.scopes : redirectUrl?.scopes ?? [],
        userId: payload.user_id,
        clientId: payload.client?.client_id || null,
        clientName: payload.client?.name || null,
        clientLogoUrl: payload.client?.logo_uri,
        redirectUrl: redirectUrl,
        cloudId: payload.cloud_id || null,
        resources: payload.resources,
        workspaces: payload.workspaces
    };
}
const $c10603336f51dc41$var$CLOCK_TOLERANCE_SECONDS = 60;
async function $c10603336f51dc41$var$verifyConsentContextToken(token, options) {
    await (0, $1FnhM.compactVerify)(token, $c10603336f51dc41$var$JWKS);
    const payload = (0, $ev0NA.decodeJwt)(token);
    const now = Math.floor(Date.now() / 1000);
    if (payload.iss !== options.issuer) throw new (0, $jAIn1).JWTClaimValidationFailed('unexpected "iss" claim value', payload, 'iss', 'check_failed');
    const audiences = Array.isArray(payload.aud) ? payload.aud : [
        payload.aud
    ];
    if (!audiences.includes(options.audience)) throw new (0, $jAIn1).JWTClaimValidationFailed('unexpected "aud" claim value', payload, 'aud', 'check_failed');
    if (typeof payload.exp === 'number' && payload.exp <= now - $c10603336f51dc41$var$CLOCK_TOLERANCE_SECONDS) throw new (0, $jAIn1).JWTExpired('"exp" claim timestamp check failed', payload, 'exp', 'check_failed');
    return payload;
}
const $c10603336f51dc41$var$parseRedirectURL = (uri)=>{
    if (!uri) return null;
    try {
        const url = new URL('a://a' + uri);
        return {
            raw: uri,
            audience: url.searchParams.get('audience') ?? '',
            scopes: url.searchParams.get('scope')?.split(' ').filter(Boolean) ?? [],
            csrfToken: url.searchParams.get('csrf_token') ?? '',
            callback: url.searchParams.get('redirect_uri') ?? ''
        };
    } catch (e) {
        console.warn(`Could not parse redirect URI: ${uri}`);
        return null;
    }
};
function $c10603336f51dc41$var$getServiceType(profile, customerName) {
    const c = Object.values($c10603336f51dc41$var$CustomerName).includes(customerName) ? customerName : "ecosystem";
    const p = Object.values($c10603336f51dc41$var$ProfileName).includes(profile) ? profile : "default";
    // @ts-ignore
    return $c10603336f51dc41$var$customerProfileMap[c][p];
}

});
parcelRegister("1FnhM", function(module, exports) {
$parcel$export(module.exports, "compactVerify", () => $136baeded8230f7e$export$996150e72a8992e);

var $3HiUe = parcelRequire("3HiUe");

var $jAIn1 = parcelRequire("jAIn1");

var $dUFs4 = parcelRequire("dUFs4");
async function $136baeded8230f7e$export$996150e72a8992e(jws, key, options) {
    if (jws instanceof Uint8Array) jws = (0, $dUFs4.decoder).decode(jws);
    if (typeof jws !== 'string') throw new (0, $jAIn1.JWSInvalid)('Compact JWS must be a string or Uint8Array');
    const { 0: protectedHeader, 1: payload, 2: signature, length: length } = jws.split('.');
    if (length !== 3) throw new (0, $jAIn1.JWSInvalid)('Invalid Compact JWS');
    const verified = await (0, $3HiUe.flattenedVerify)({
        payload: payload,
        protected: protectedHeader,
        signature: signature
    }, key, options);
    const result = {
        payload: verified.payload,
        protectedHeader: verified.protectedHeader
    };
    if (typeof key === 'function') return {
        ...result,
        key: verified.key
    };
    return result;
}

});
parcelRegister("3HiUe", function(module, exports) {
$parcel$export(module.exports, "flattenedVerify", () => $2b140d98f878eda7$export$b2614975507c40c9);

var $adj1r = parcelRequire("adj1r");

var $hN0Ui = parcelRequire("hN0Ui");

var $jAIn1 = parcelRequire("jAIn1");

var $dUFs4 = parcelRequire("dUFs4");

var $3nDF0 = parcelRequire("3nDF0");

var $cyCSw = parcelRequire("cyCSw");

var $dqmVx = parcelRequire("dqmVx");

var $6Q0OR = parcelRequire("6Q0OR");

var $liIwC = parcelRequire("liIwC");

var $4mnjT = parcelRequire("4mnjT");

var $9pDiP = parcelRequire("9pDiP");
async function $2b140d98f878eda7$export$b2614975507c40c9(jws, key, options) {
    if (!(0, $cyCSw.default)(jws)) throw new (0, $jAIn1.JWSInvalid)('Flattened JWS must be an object');
    if (jws.protected === undefined && jws.header === undefined) throw new (0, $jAIn1.JWSInvalid)('Flattened JWS must have either of the "protected" or "header" members');
    if (jws.protected !== undefined && typeof jws.protected !== 'string') throw new (0, $jAIn1.JWSInvalid)('JWS Protected Header incorrect type');
    if (jws.payload === undefined) throw new (0, $jAIn1.JWSInvalid)('JWS Payload missing');
    if (typeof jws.signature !== 'string') throw new (0, $jAIn1.JWSInvalid)('JWS Signature missing or incorrect type');
    if (jws.header !== undefined && !(0, $cyCSw.default)(jws.header)) throw new (0, $jAIn1.JWSInvalid)('JWS Unprotected Header incorrect type');
    let parsedProt = {};
    if (jws.protected) try {
        const protectedHeader = (0, $adj1r.decode)(jws.protected);
        parsedProt = JSON.parse((0, $dUFs4.decoder).decode(protectedHeader));
    } catch  {
        throw new (0, $jAIn1.JWSInvalid)('JWS Protected Header is invalid');
    }
    if (!(0, $3nDF0.default)(parsedProt, jws.header)) throw new (0, $jAIn1.JWSInvalid)('JWS Protected and JWS Unprotected Header Parameter names must be disjoint');
    const joseHeader = {
        ...parsedProt,
        ...jws.header
    };
    const extensions = (0, $6Q0OR.default)((0, $jAIn1.JWSInvalid), new Map([
        [
            'b64',
            true
        ]
    ]), options?.crit, parsedProt, joseHeader);
    let b64 = true;
    if (extensions.has('b64')) {
        b64 = parsedProt.b64;
        if (typeof b64 !== 'boolean') throw new (0, $jAIn1.JWSInvalid)('The "b64" (base64url-encode payload) Header Parameter must be a boolean');
    }
    const { alg: alg } = joseHeader;
    if (typeof alg !== 'string' || !alg) throw new (0, $jAIn1.JWSInvalid)('JWS "alg" (Algorithm) Header Parameter missing or invalid');
    const algorithms = options && (0, $liIwC.default)('algorithms', options.algorithms);
    if (algorithms && !algorithms.has(alg)) throw new (0, $jAIn1.JOSEAlgNotAllowed)('"alg" (Algorithm) Header Parameter value not allowed');
    if (b64) {
        if (typeof jws.payload !== 'string') throw new (0, $jAIn1.JWSInvalid)('JWS Payload must be a string');
    } else if (typeof jws.payload !== 'string' && !(jws.payload instanceof Uint8Array)) throw new (0, $jAIn1.JWSInvalid)('JWS Payload must be a string or an Uint8Array instance');
    let resolvedKey = false;
    if (typeof key === 'function') {
        key = await key(parsedProt, jws);
        resolvedKey = true;
        (0, $dqmVx.checkKeyTypeWithJwk)(alg, key, 'verify');
        if ((0, $4mnjT.isJWK)(key)) key = await (0, $9pDiP.importJWK)(key, alg);
    } else (0, $dqmVx.checkKeyTypeWithJwk)(alg, key, 'verify');
    const data = (0, $dUFs4.concat)((0, $dUFs4.encoder).encode(jws.protected ?? ''), (0, $dUFs4.encoder).encode('.'), typeof jws.payload === 'string' ? (0, $dUFs4.encoder).encode(jws.payload) : jws.payload);
    let signature;
    try {
        signature = (0, $adj1r.decode)(jws.signature);
    } catch  {
        throw new (0, $jAIn1.JWSInvalid)('Failed to base64url decode the signature');
    }
    const verified = await (0, $hN0Ui.default)(alg, key, signature, data);
    if (!verified) throw new (0, $jAIn1.JWSSignatureVerificationFailed)();
    let payload;
    if (b64) try {
        payload = (0, $adj1r.decode)(jws.payload);
    } catch  {
        throw new (0, $jAIn1.JWSInvalid)('Failed to base64url decode the payload');
    }
    else if (typeof jws.payload === 'string') payload = (0, $dUFs4.encoder).encode(jws.payload);
    else payload = jws.payload;
    const result = {
        payload: payload
    };
    if (jws.protected !== undefined) result.protectedHeader = parsedProt;
    if (jws.header !== undefined) result.unprotectedHeader = jws.header;
    if (resolvedKey) return {
        ...result,
        key: key
    };
    return result;
}

});
parcelRegister("adj1r", function(module, exports) {
$parcel$export(module.exports, "encodeBase64", () => $76f9dfb074958b27$export$8fb536984ec8b4d7);
$parcel$export(module.exports, "encode", () => $76f9dfb074958b27$export$c564cdbbe6da493);
$parcel$export(module.exports, "decodeBase64", () => $76f9dfb074958b27$export$94fdf11bafc8de6b);
$parcel$export(module.exports, "decode", () => $76f9dfb074958b27$export$2f872c0f2117be69);

var $dUFs4 = parcelRequire("dUFs4");
const $76f9dfb074958b27$export$8fb536984ec8b4d7 = (input)=>{
    let unencoded = input;
    if (typeof unencoded === 'string') unencoded = (0, $dUFs4.encoder).encode(unencoded);
    const CHUNK_SIZE = 0x8000;
    const arr = [];
    for(let i = 0; i < unencoded.length; i += CHUNK_SIZE)arr.push(String.fromCharCode.apply(null, unencoded.subarray(i, i + CHUNK_SIZE)));
    return btoa(arr.join(''));
};
const $76f9dfb074958b27$export$c564cdbbe6da493 = (input)=>{
    return $76f9dfb074958b27$export$8fb536984ec8b4d7(input).replace(/=/g, '').replace(/\+/g, '-').replace(/\//g, '_');
};
const $76f9dfb074958b27$export$94fdf11bafc8de6b = (encoded)=>{
    const binary = atob(encoded);
    const bytes = new Uint8Array(binary.length);
    for(let i = 0; i < binary.length; i++)bytes[i] = binary.charCodeAt(i);
    return bytes;
};
const $76f9dfb074958b27$export$2f872c0f2117be69 = (input)=>{
    let encoded = input;
    if (encoded instanceof Uint8Array) encoded = (0, $dUFs4.decoder).decode(encoded);
    encoded = encoded.replace(/-/g, '+').replace(/_/g, '/').replace(/\s/g, '');
    try {
        return $76f9dfb074958b27$export$94fdf11bafc8de6b(encoded);
    } catch  {
        throw new TypeError('The input to be decoded is not correctly encoded.');
    }
};

});
parcelRegister("dUFs4", function(module, exports) {
$parcel$export(module.exports, "encoder", () => $a210a8c3e83e1882$export$5486af06137bf21a);
$parcel$export(module.exports, "decoder", () => $a210a8c3e83e1882$export$124c96e6ce37090b);
$parcel$export(module.exports, "concat", () => $a210a8c3e83e1882$export$ee1b3e54f0441b22);

var $2Ncms = parcelRequire("2Ncms");
const $a210a8c3e83e1882$export$5486af06137bf21a = new TextEncoder();
const $a210a8c3e83e1882$export$124c96e6ce37090b = new TextDecoder();
const $a210a8c3e83e1882$var$MAX_INT32 = 2 ** 32;
function $a210a8c3e83e1882$export$ee1b3e54f0441b22(...buffers) {
    const size = buffers.reduce((acc, { length: length })=>acc + length, 0);
    const buf = new Uint8Array(size);
    let i = 0;
    for (const buffer of buffers){
        buf.set(buffer, i);
        i += buffer.length;
    }
    return buf;
}
function $a210a8c3e83e1882$export$256d3ca12372f112(alg, p2sInput) {
    return $a210a8c3e83e1882$export$ee1b3e54f0441b22($a210a8c3e83e1882$export$5486af06137bf21a.encode(alg), new Uint8Array([
        0
    ]), p2sInput);
}
function $a210a8c3e83e1882$var$writeUInt32BE(buf, value, offset) {
    if (value < 0 || value >= $a210a8c3e83e1882$var$MAX_INT32) throw new RangeError(`value must be >= 0 and <= ${$a210a8c3e83e1882$var$MAX_INT32 - 1}. Received ${value}`);
    buf.set([
        value >>> 24,
        value >>> 16,
        value >>> 8,
        value & 0xff
    ], offset);
}
function $a210a8c3e83e1882$export$e7b531e00a18fdd7(value) {
    const high = Math.floor(value / $a210a8c3e83e1882$var$MAX_INT32);
    const low = value % $a210a8c3e83e1882$var$MAX_INT32;
    const buf = new Uint8Array(8);
    $a210a8c3e83e1882$var$writeUInt32BE(buf, high, 0);
    $a210a8c3e83e1882$var$writeUInt32BE(buf, low, 4);
    return buf;
}
function $a210a8c3e83e1882$export$74c16dba6c885532(value) {
    const buf = new Uint8Array(4);
    $a210a8c3e83e1882$var$writeUInt32BE(buf, value);
    return buf;
}
function $a210a8c3e83e1882$export$c1498c4a3718d967(input) {
    return $a210a8c3e83e1882$export$ee1b3e54f0441b22($a210a8c3e83e1882$export$74c16dba6c885532(input.length), input);
}
async function $a210a8c3e83e1882$export$67163693c21af44f(secret, bits, value) {
    const iterations = Math.ceil((bits >> 3) / 32);
    const res = new Uint8Array(iterations * 32);
    for(let iter = 0; iter < iterations; iter++){
        const buf = new Uint8Array(4 + secret.length + value.length);
        buf.set($a210a8c3e83e1882$export$74c16dba6c885532(iter + 1));
        buf.set(secret, 4);
        buf.set(value, 4 + secret.length);
        res.set(await (0, $2Ncms.default)('sha256', buf), iter * 32);
    }
    return res.slice(0, bits >> 3);
}

});
parcelRegister("2Ncms", function(module, exports) {
$parcel$export(module.exports, "default", () => $2089bf0c58214c87$export$2e2bcd8739ae039);

var $5oA8l = parcelRequire("5oA8l");
const $2089bf0c58214c87$var$digest = async (algorithm, data)=>{
    const subtleDigest = `SHA-${algorithm.slice(-3)}`;
    return new Uint8Array(await (0, $5oA8l.default).subtle.digest(subtleDigest, data));
};
var $2089bf0c58214c87$export$2e2bcd8739ae039 = $2089bf0c58214c87$var$digest;

});
parcelRegister("5oA8l", function(module, exports) {
$parcel$export(module.exports, "default", () => $3edb3909d8d1687e$export$2e2bcd8739ae039);
$parcel$export(module.exports, "isCryptoKey", () => $3edb3909d8d1687e$export$600b5603bbac4c6);
var $3edb3909d8d1687e$export$2e2bcd8739ae039 = crypto;
const $3edb3909d8d1687e$export$600b5603bbac4c6 = (key)=>key instanceof CryptoKey;

});




parcelRegister("hN0Ui", function(module, exports) {
$parcel$export(module.exports, "default", () => $cf37b767595ca111$export$2e2bcd8739ae039);

var $8lcG1 = parcelRequire("8lcG1");

var $5oA8l = parcelRequire("5oA8l");

var $aHGed = parcelRequire("aHGed");

var $4fyP2 = parcelRequire("4fyP2");
const $cf37b767595ca111$var$verify = async (alg, key, signature, data)=>{
    const cryptoKey = await (0, $4fyP2.default)(alg, key, 'verify');
    (0, $aHGed.default)(alg, cryptoKey);
    const algorithm = (0, $8lcG1.default)(alg, cryptoKey.algorithm);
    try {
        return await (0, $5oA8l.default).subtle.verify(algorithm, cryptoKey, signature, data);
    } catch  {
        return false;
    }
};
var $cf37b767595ca111$export$2e2bcd8739ae039 = $cf37b767595ca111$var$verify;

});
parcelRegister("8lcG1", function(module, exports) {
$parcel$export(module.exports, "default", () => $612a1e3788ef095b$export$2e2bcd8739ae039);

var $jAIn1 = parcelRequire("jAIn1");
function $612a1e3788ef095b$export$2e2bcd8739ae039(alg, algorithm) {
    const hash = `SHA-${alg.slice(-3)}`;
    switch(alg){
        case 'HS256':
        case 'HS384':
        case 'HS512':
            return {
                hash: hash,
                name: 'HMAC'
            };
        case 'PS256':
        case 'PS384':
        case 'PS512':
            return {
                hash: hash,
                name: 'RSA-PSS',
                saltLength: alg.slice(-3) >> 3
            };
        case 'RS256':
        case 'RS384':
        case 'RS512':
            return {
                hash: hash,
                name: 'RSASSA-PKCS1-v1_5'
            };
        case 'ES256':
        case 'ES384':
        case 'ES512':
            return {
                hash: hash,
                name: 'ECDSA',
                namedCurve: algorithm.namedCurve
            };
        case 'Ed25519':
            return {
                name: 'Ed25519'
            };
        case 'EdDSA':
            return {
                name: algorithm.name
            };
        default:
            throw new (0, $jAIn1.JOSENotSupported)(`alg ${alg} is not supported either by JOSE or your javascript runtime`);
    }
}

});
parcelRegister("jAIn1", function(module, exports) {
$parcel$export(module.exports, "JOSEError", () => $e433cc206d1ea07b$export$f754d6850d76bf87);
$parcel$export(module.exports, "JWTClaimValidationFailed", () => $e433cc206d1ea07b$export$f1e14efb908196e9);
$parcel$export(module.exports, "JWTExpired", () => $e433cc206d1ea07b$export$4b386bf852b7863d);
$parcel$export(module.exports, "JOSEAlgNotAllowed", () => $e433cc206d1ea07b$export$d51fd7fedeccc338);
$parcel$export(module.exports, "JOSENotSupported", () => $e433cc206d1ea07b$export$19ddbcbf2016ab28);
$parcel$export(module.exports, "JWEDecryptionFailed", () => $e433cc206d1ea07b$export$1a57512ad9773b2a);
$parcel$export(module.exports, "JWEInvalid", () => $e433cc206d1ea07b$export$19f281f2275f6a15);
$parcel$export(module.exports, "JWSInvalid", () => $e433cc206d1ea07b$export$e838de724af3d116);
$parcel$export(module.exports, "JWTInvalid", () => $e433cc206d1ea07b$export$936b39ada0bbfceb);
$parcel$export(module.exports, "JWKInvalid", () => $e433cc206d1ea07b$export$b3992e0f88fb07e3);
$parcel$export(module.exports, "JWKSInvalid", () => $e433cc206d1ea07b$export$9b22c2a1e2403b8e);
$parcel$export(module.exports, "JWKSNoMatchingKey", () => $e433cc206d1ea07b$export$3d5ed1a538bed04e);
$parcel$export(module.exports, "JWKSMultipleMatchingKeys", () => $e433cc206d1ea07b$export$dc036de401a5c284);
$parcel$export(module.exports, "JWKSTimeout", () => $e433cc206d1ea07b$export$3f30acebf25c04e6);
$parcel$export(module.exports, "JWSSignatureVerificationFailed", () => $e433cc206d1ea07b$export$c67a0218e7c50378);
class $e433cc206d1ea07b$export$f754d6850d76bf87 extends Error {
    constructor(message, options){
        super(message, options);
        this.code = 'ERR_JOSE_GENERIC';
        this.name = this.constructor.name;
        Error.captureStackTrace?.(this, this.constructor);
    }
}
$e433cc206d1ea07b$export$f754d6850d76bf87.code = 'ERR_JOSE_GENERIC';
class $e433cc206d1ea07b$export$f1e14efb908196e9 extends $e433cc206d1ea07b$export$f754d6850d76bf87 {
    constructor(message, payload, claim = 'unspecified', reason = 'unspecified'){
        super(message, {
            cause: {
                claim: claim,
                reason: reason,
                payload: payload
            }
        });
        this.code = 'ERR_JWT_CLAIM_VALIDATION_FAILED';
        this.claim = claim;
        this.reason = reason;
        this.payload = payload;
    }
}
$e433cc206d1ea07b$export$f1e14efb908196e9.code = 'ERR_JWT_CLAIM_VALIDATION_FAILED';
class $e433cc206d1ea07b$export$4b386bf852b7863d extends $e433cc206d1ea07b$export$f754d6850d76bf87 {
    constructor(message, payload, claim = 'unspecified', reason = 'unspecified'){
        super(message, {
            cause: {
                claim: claim,
                reason: reason,
                payload: payload
            }
        });
        this.code = 'ERR_JWT_EXPIRED';
        this.claim = claim;
        this.reason = reason;
        this.payload = payload;
    }
}
$e433cc206d1ea07b$export$4b386bf852b7863d.code = 'ERR_JWT_EXPIRED';
class $e433cc206d1ea07b$export$d51fd7fedeccc338 extends $e433cc206d1ea07b$export$f754d6850d76bf87 {
    constructor(){
        super(...arguments);
        this.code = 'ERR_JOSE_ALG_NOT_ALLOWED';
    }
}
$e433cc206d1ea07b$export$d51fd7fedeccc338.code = 'ERR_JOSE_ALG_NOT_ALLOWED';
class $e433cc206d1ea07b$export$19ddbcbf2016ab28 extends $e433cc206d1ea07b$export$f754d6850d76bf87 {
    constructor(){
        super(...arguments);
        this.code = 'ERR_JOSE_NOT_SUPPORTED';
    }
}
$e433cc206d1ea07b$export$19ddbcbf2016ab28.code = 'ERR_JOSE_NOT_SUPPORTED';
class $e433cc206d1ea07b$export$1a57512ad9773b2a extends $e433cc206d1ea07b$export$f754d6850d76bf87 {
    constructor(message = 'decryption operation failed', options){
        super(message, options);
        this.code = 'ERR_JWE_DECRYPTION_FAILED';
    }
}
$e433cc206d1ea07b$export$1a57512ad9773b2a.code = 'ERR_JWE_DECRYPTION_FAILED';
class $e433cc206d1ea07b$export$19f281f2275f6a15 extends $e433cc206d1ea07b$export$f754d6850d76bf87 {
    constructor(){
        super(...arguments);
        this.code = 'ERR_JWE_INVALID';
    }
}
$e433cc206d1ea07b$export$19f281f2275f6a15.code = 'ERR_JWE_INVALID';
class $e433cc206d1ea07b$export$e838de724af3d116 extends $e433cc206d1ea07b$export$f754d6850d76bf87 {
    constructor(){
        super(...arguments);
        this.code = 'ERR_JWS_INVALID';
    }
}
$e433cc206d1ea07b$export$e838de724af3d116.code = 'ERR_JWS_INVALID';
class $e433cc206d1ea07b$export$936b39ada0bbfceb extends $e433cc206d1ea07b$export$f754d6850d76bf87 {
    constructor(){
        super(...arguments);
        this.code = 'ERR_JWT_INVALID';
    }
}
$e433cc206d1ea07b$export$936b39ada0bbfceb.code = 'ERR_JWT_INVALID';
class $e433cc206d1ea07b$export$b3992e0f88fb07e3 extends $e433cc206d1ea07b$export$f754d6850d76bf87 {
    constructor(){
        super(...arguments);
        this.code = 'ERR_JWK_INVALID';
    }
}
$e433cc206d1ea07b$export$b3992e0f88fb07e3.code = 'ERR_JWK_INVALID';
class $e433cc206d1ea07b$export$9b22c2a1e2403b8e extends $e433cc206d1ea07b$export$f754d6850d76bf87 {
    constructor(){
        super(...arguments);
        this.code = 'ERR_JWKS_INVALID';
    }
}
$e433cc206d1ea07b$export$9b22c2a1e2403b8e.code = 'ERR_JWKS_INVALID';
class $e433cc206d1ea07b$export$3d5ed1a538bed04e extends $e433cc206d1ea07b$export$f754d6850d76bf87 {
    constructor(message = 'no applicable key found in the JSON Web Key Set', options){
        super(message, options);
        this.code = 'ERR_JWKS_NO_MATCHING_KEY';
    }
}
$e433cc206d1ea07b$export$3d5ed1a538bed04e.code = 'ERR_JWKS_NO_MATCHING_KEY';
class $e433cc206d1ea07b$export$dc036de401a5c284 extends $e433cc206d1ea07b$export$f754d6850d76bf87 {
    constructor(message = 'multiple matching keys found in the JSON Web Key Set', options){
        super(message, options);
        this.code = 'ERR_JWKS_MULTIPLE_MATCHING_KEYS';
    }
}
Symbol.asyncIterator;
$e433cc206d1ea07b$export$dc036de401a5c284.code = 'ERR_JWKS_MULTIPLE_MATCHING_KEYS';
class $e433cc206d1ea07b$export$3f30acebf25c04e6 extends $e433cc206d1ea07b$export$f754d6850d76bf87 {
    constructor(message = 'request timed out', options){
        super(message, options);
        this.code = 'ERR_JWKS_TIMEOUT';
    }
}
$e433cc206d1ea07b$export$3f30acebf25c04e6.code = 'ERR_JWKS_TIMEOUT';
class $e433cc206d1ea07b$export$c67a0218e7c50378 extends $e433cc206d1ea07b$export$f754d6850d76bf87 {
    constructor(message = 'signature verification failed', options){
        super(message, options);
        this.code = 'ERR_JWS_SIGNATURE_VERIFICATION_FAILED';
    }
}
$e433cc206d1ea07b$export$c67a0218e7c50378.code = 'ERR_JWS_SIGNATURE_VERIFICATION_FAILED';

});


parcelRegister("aHGed", function(module, exports) {
$parcel$export(module.exports, "default", () => $7caead2dedf22588$export$2e2bcd8739ae039);
var $7caead2dedf22588$export$2e2bcd8739ae039 = (alg, key)=>{
    if (alg.startsWith('RS') || alg.startsWith('PS')) {
        const { modulusLength: modulusLength } = key.algorithm;
        if (typeof modulusLength !== 'number' || modulusLength < 2048) throw new TypeError(`${alg} requires key modulusLength to be 2048 bits or larger`);
    }
};

});

parcelRegister("4fyP2", function(module, exports) {
$parcel$export(module.exports, "default", () => $3183931407bf2c2e$export$2e2bcd8739ae039);

var $5oA8l = parcelRequire("5oA8l");

var $4ABgV = parcelRequire("4ABgV");

var $8ZwVa = parcelRequire("8ZwVa");

var $iVBpG = parcelRequire("iVBpG");

var $dtSmm = parcelRequire("dtSmm");
async function $3183931407bf2c2e$export$2e2bcd8739ae039(alg, key, usage) {
    if (usage === 'sign') key = await (0, $dtSmm.default).normalizePrivateKey(key, alg);
    if (usage === 'verify') key = await (0, $dtSmm.default).normalizePublicKey(key, alg);
    if ((0, $5oA8l.isCryptoKey)(key)) {
        (0, $4ABgV.checkSigCryptoKey)(key, alg, usage);
        return key;
    }
    if (key instanceof Uint8Array) {
        if (!alg.startsWith('HS')) throw new TypeError((0, $8ZwVa.default)(key, ...(0, $iVBpG.types)));
        return (0, $5oA8l.default).subtle.importKey('raw', key, {
            hash: `SHA-${alg.slice(-3)}`,
            name: 'HMAC'
        }, false, [
            usage
        ]);
    }
    throw new TypeError((0, $8ZwVa.default)(key, ...(0, $iVBpG.types), 'Uint8Array', 'JSON Web Key'));
}

});
parcelRegister("4ABgV", function(module, exports) {
$parcel$export(module.exports, "checkSigCryptoKey", () => $35776fa6e7307e73$export$39a36029eee6729);
function $35776fa6e7307e73$var$unusable(name, prop = 'algorithm.name') {
    return new TypeError(`CryptoKey does not support this operation, its ${prop} must be ${name}`);
}
function $35776fa6e7307e73$var$isAlgorithm(algorithm, name) {
    return algorithm.name === name;
}
function $35776fa6e7307e73$var$getHashLength(hash) {
    return parseInt(hash.name.slice(4), 10);
}
function $35776fa6e7307e73$var$getNamedCurve(alg) {
    switch(alg){
        case 'ES256':
            return 'P-256';
        case 'ES384':
            return 'P-384';
        case 'ES512':
            return 'P-521';
        default:
            throw new Error('unreachable');
    }
}
function $35776fa6e7307e73$var$checkUsage(key, usages) {
    if (usages.length && !usages.some((expected)=>key.usages.includes(expected))) {
        let msg = 'CryptoKey does not support this operation, its usages must include ';
        if (usages.length > 2) {
            const last = usages.pop();
            msg += `one of ${usages.join(', ')}, or ${last}.`;
        } else if (usages.length === 2) msg += `one of ${usages[0]} or ${usages[1]}.`;
        else msg += `${usages[0]}.`;
        throw new TypeError(msg);
    }
}
function $35776fa6e7307e73$export$39a36029eee6729(key, alg, ...usages) {
    switch(alg){
        case 'HS256':
        case 'HS384':
        case 'HS512':
            {
                if (!$35776fa6e7307e73$var$isAlgorithm(key.algorithm, 'HMAC')) throw $35776fa6e7307e73$var$unusable('HMAC');
                const expected = parseInt(alg.slice(2), 10);
                const actual = $35776fa6e7307e73$var$getHashLength(key.algorithm.hash);
                if (actual !== expected) throw $35776fa6e7307e73$var$unusable(`SHA-${expected}`, 'algorithm.hash');
                break;
            }
        case 'RS256':
        case 'RS384':
        case 'RS512':
            {
                if (!$35776fa6e7307e73$var$isAlgorithm(key.algorithm, 'RSASSA-PKCS1-v1_5')) throw $35776fa6e7307e73$var$unusable('RSASSA-PKCS1-v1_5');
                const expected = parseInt(alg.slice(2), 10);
                const actual = $35776fa6e7307e73$var$getHashLength(key.algorithm.hash);
                if (actual !== expected) throw $35776fa6e7307e73$var$unusable(`SHA-${expected}`, 'algorithm.hash');
                break;
            }
        case 'PS256':
        case 'PS384':
        case 'PS512':
            {
                if (!$35776fa6e7307e73$var$isAlgorithm(key.algorithm, 'RSA-PSS')) throw $35776fa6e7307e73$var$unusable('RSA-PSS');
                const expected = parseInt(alg.slice(2), 10);
                const actual = $35776fa6e7307e73$var$getHashLength(key.algorithm.hash);
                if (actual !== expected) throw $35776fa6e7307e73$var$unusable(`SHA-${expected}`, 'algorithm.hash');
                break;
            }
        case 'EdDSA':
            if (key.algorithm.name !== 'Ed25519' && key.algorithm.name !== 'Ed448') throw $35776fa6e7307e73$var$unusable('Ed25519 or Ed448');
            break;
        case 'Ed25519':
            if (!$35776fa6e7307e73$var$isAlgorithm(key.algorithm, 'Ed25519')) throw $35776fa6e7307e73$var$unusable('Ed25519');
            break;
        case 'ES256':
        case 'ES384':
        case 'ES512':
            {
                if (!$35776fa6e7307e73$var$isAlgorithm(key.algorithm, 'ECDSA')) throw $35776fa6e7307e73$var$unusable('ECDSA');
                const expected = $35776fa6e7307e73$var$getNamedCurve(alg);
                const actual = key.algorithm.namedCurve;
                if (actual !== expected) throw $35776fa6e7307e73$var$unusable(expected, 'algorithm.namedCurve');
                break;
            }
        default:
            throw new TypeError('CryptoKey does not support this operation');
    }
    $35776fa6e7307e73$var$checkUsage(key, usages);
}
function $35776fa6e7307e73$export$41a67f89f6678b35(key, alg, ...usages) {
    switch(alg){
        case 'A128GCM':
        case 'A192GCM':
        case 'A256GCM':
            {
                if (!$35776fa6e7307e73$var$isAlgorithm(key.algorithm, 'AES-GCM')) throw $35776fa6e7307e73$var$unusable('AES-GCM');
                const expected = parseInt(alg.slice(1, 4), 10);
                const actual = key.algorithm.length;
                if (actual !== expected) throw $35776fa6e7307e73$var$unusable(expected, 'algorithm.length');
                break;
            }
        case 'A128KW':
        case 'A192KW':
        case 'A256KW':
            {
                if (!$35776fa6e7307e73$var$isAlgorithm(key.algorithm, 'AES-KW')) throw $35776fa6e7307e73$var$unusable('AES-KW');
                const expected = parseInt(alg.slice(1, 4), 10);
                const actual = key.algorithm.length;
                if (actual !== expected) throw $35776fa6e7307e73$var$unusable(expected, 'algorithm.length');
                break;
            }
        case 'ECDH':
            switch(key.algorithm.name){
                case 'ECDH':
                case 'X25519':
                case 'X448':
                    break;
                default:
                    throw $35776fa6e7307e73$var$unusable('ECDH, X25519, or X448');
            }
            break;
        case 'PBES2-HS256+A128KW':
        case 'PBES2-HS384+A192KW':
        case 'PBES2-HS512+A256KW':
            if (!$35776fa6e7307e73$var$isAlgorithm(key.algorithm, 'PBKDF2')) throw $35776fa6e7307e73$var$unusable('PBKDF2');
            break;
        case 'RSA-OAEP':
        case 'RSA-OAEP-256':
        case 'RSA-OAEP-384':
        case 'RSA-OAEP-512':
            {
                if (!$35776fa6e7307e73$var$isAlgorithm(key.algorithm, 'RSA-OAEP')) throw $35776fa6e7307e73$var$unusable('RSA-OAEP');
                const expected = parseInt(alg.slice(9), 10) || 1;
                const actual = $35776fa6e7307e73$var$getHashLength(key.algorithm.hash);
                if (actual !== expected) throw $35776fa6e7307e73$var$unusable(`SHA-${expected}`, 'algorithm.hash');
                break;
            }
        default:
            throw new TypeError('CryptoKey does not support this operation');
    }
    $35776fa6e7307e73$var$checkUsage(key, usages);
}

});

parcelRegister("8ZwVa", function(module, exports) {
$parcel$export(module.exports, "default", () => $68bd8eaaed4ea396$export$2e2bcd8739ae039);
$parcel$export(module.exports, "withAlg", () => $68bd8eaaed4ea396$export$e94f758d09bc1828);
function $68bd8eaaed4ea396$var$message(msg, actual, ...types) {
    types = types.filter(Boolean);
    if (types.length > 2) {
        const last = types.pop();
        msg += `one of type ${types.join(', ')}, or ${last}.`;
    } else if (types.length === 2) msg += `one of type ${types[0]} or ${types[1]}.`;
    else msg += `of type ${types[0]}.`;
    if (actual == null) msg += ` Received ${actual}`;
    else if (typeof actual === 'function' && actual.name) msg += ` Received function ${actual.name}`;
    else if (typeof actual === 'object' && actual != null) {
        if (actual.constructor?.name) msg += ` Received an instance of ${actual.constructor.name}`;
    }
    return msg;
}
var $68bd8eaaed4ea396$export$2e2bcd8739ae039 = (actual, ...types)=>{
    return $68bd8eaaed4ea396$var$message('Key must be ', actual, ...types);
};
function $68bd8eaaed4ea396$export$e94f758d09bc1828(alg, actual, ...types) {
    return $68bd8eaaed4ea396$var$message(`Key for the ${alg} algorithm must be `, actual, ...types);
}

});

parcelRegister("iVBpG", function(module, exports) {
$parcel$export(module.exports, "default", () => $dc7a92607da9cb91$export$2e2bcd8739ae039);
$parcel$export(module.exports, "types", () => $dc7a92607da9cb91$export$b14ad400b1d09e0f);

var $5oA8l = parcelRequire("5oA8l");
var $dc7a92607da9cb91$export$2e2bcd8739ae039 = (key)=>{
    if ((0, $5oA8l.isCryptoKey)(key)) return true;
    return key?.[Symbol.toStringTag] === 'KeyObject';
};
const $dc7a92607da9cb91$export$b14ad400b1d09e0f = [
    'CryptoKey'
];

});

parcelRegister("dtSmm", function(module, exports) {
$parcel$export(module.exports, "default", () => $9d0826772d303d10$export$2e2bcd8739ae039);

var $4mnjT = parcelRequire("4mnjT");

var $adj1r = parcelRequire("adj1r");

var $45mu8 = parcelRequire("45mu8");
const $9d0826772d303d10$var$exportKeyValue = (k)=>(0, $adj1r.decode)(k);
let $9d0826772d303d10$var$privCache;
let $9d0826772d303d10$var$pubCache;
const $9d0826772d303d10$var$isKeyObject = (key)=>{
    return key?.[Symbol.toStringTag] === 'KeyObject';
};
const $9d0826772d303d10$var$importAndCache = async (cache, key, jwk, alg, freeze = false)=>{
    let cached = cache.get(key);
    if (cached?.[alg]) return cached[alg];
    const cryptoKey = await (0, $45mu8.default)({
        ...jwk,
        alg: alg
    });
    if (freeze) Object.freeze(key);
    if (!cached) cache.set(key, {
        [alg]: cryptoKey
    });
    else cached[alg] = cryptoKey;
    return cryptoKey;
};
const $9d0826772d303d10$var$normalizePublicKey = (key, alg)=>{
    if ($9d0826772d303d10$var$isKeyObject(key)) {
        let jwk = key.export({
            format: 'jwk'
        });
        delete jwk.d;
        delete jwk.dp;
        delete jwk.dq;
        delete jwk.p;
        delete jwk.q;
        delete jwk.qi;
        if (jwk.k) return $9d0826772d303d10$var$exportKeyValue(jwk.k);
        $9d0826772d303d10$var$pubCache || ($9d0826772d303d10$var$pubCache = new WeakMap());
        return $9d0826772d303d10$var$importAndCache($9d0826772d303d10$var$pubCache, key, jwk, alg);
    }
    if ((0, $4mnjT.isJWK)(key)) {
        if (key.k) return (0, $adj1r.decode)(key.k);
        $9d0826772d303d10$var$pubCache || ($9d0826772d303d10$var$pubCache = new WeakMap());
        const cryptoKey = $9d0826772d303d10$var$importAndCache($9d0826772d303d10$var$pubCache, key, key, alg, true);
        return cryptoKey;
    }
    return key;
};
const $9d0826772d303d10$var$normalizePrivateKey = (key, alg)=>{
    if ($9d0826772d303d10$var$isKeyObject(key)) {
        let jwk = key.export({
            format: 'jwk'
        });
        if (jwk.k) return $9d0826772d303d10$var$exportKeyValue(jwk.k);
        $9d0826772d303d10$var$privCache || ($9d0826772d303d10$var$privCache = new WeakMap());
        return $9d0826772d303d10$var$importAndCache($9d0826772d303d10$var$privCache, key, jwk, alg);
    }
    if ((0, $4mnjT.isJWK)(key)) {
        if (key.k) return (0, $adj1r.decode)(key.k);
        $9d0826772d303d10$var$privCache || ($9d0826772d303d10$var$privCache = new WeakMap());
        const cryptoKey = $9d0826772d303d10$var$importAndCache($9d0826772d303d10$var$privCache, key, key, alg, true);
        return cryptoKey;
    }
    return key;
};
var $9d0826772d303d10$export$2e2bcd8739ae039 = {
    normalizePublicKey: $9d0826772d303d10$var$normalizePublicKey,
    normalizePrivateKey: $9d0826772d303d10$var$normalizePrivateKey
};

});
parcelRegister("4mnjT", function(module, exports) {
$parcel$export(module.exports, "isJWK", () => $32cb4e5ac4c7c373$export$9a44c2ef7e3b3dad);
$parcel$export(module.exports, "isPrivateJWK", () => $32cb4e5ac4c7c373$export$431699a4f17ba0e);
$parcel$export(module.exports, "isPublicJWK", () => $32cb4e5ac4c7c373$export$b786616db1cddf3);
$parcel$export(module.exports, "isSecretJWK", () => $32cb4e5ac4c7c373$export$f8ecf533504bc7ad);

var $cyCSw = parcelRequire("cyCSw");
function $32cb4e5ac4c7c373$export$9a44c2ef7e3b3dad(key) {
    return (0, $cyCSw.default)(key) && typeof key.kty === 'string';
}
function $32cb4e5ac4c7c373$export$431699a4f17ba0e(key) {
    return key.kty !== 'oct' && typeof key.d === 'string';
}
function $32cb4e5ac4c7c373$export$b786616db1cddf3(key) {
    return key.kty !== 'oct' && typeof key.d === 'undefined';
}
function $32cb4e5ac4c7c373$export$f8ecf533504bc7ad(key) {
    return $32cb4e5ac4c7c373$export$9a44c2ef7e3b3dad(key) && key.kty === 'oct' && typeof key.k === 'string';
}

});
parcelRegister("cyCSw", function(module, exports) {
$parcel$export(module.exports, "default", () => $9246d172d4950738$export$2e2bcd8739ae039);
function $9246d172d4950738$var$isObjectLike(value) {
    return typeof value === 'object' && value !== null;
}
function $9246d172d4950738$export$2e2bcd8739ae039(input) {
    if (!$9246d172d4950738$var$isObjectLike(input) || Object.prototype.toString.call(input) !== '[object Object]') return false;
    if (Object.getPrototypeOf(input) === null) return true;
    let proto = input;
    while(Object.getPrototypeOf(proto) !== null)proto = Object.getPrototypeOf(proto);
    return Object.getPrototypeOf(input) === proto;
}

});


parcelRegister("45mu8", function(module, exports) {
$parcel$export(module.exports, "default", () => $2f99121898093277$export$2e2bcd8739ae039);

var $5oA8l = parcelRequire("5oA8l");

var $jAIn1 = parcelRequire("jAIn1");
function $2f99121898093277$var$subtleMapping(jwk) {
    let algorithm;
    let keyUsages;
    switch(jwk.kty){
        case 'RSA':
            switch(jwk.alg){
                case 'PS256':
                case 'PS384':
                case 'PS512':
                    algorithm = {
                        name: 'RSA-PSS',
                        hash: `SHA-${jwk.alg.slice(-3)}`
                    };
                    keyUsages = jwk.d ? [
                        'sign'
                    ] : [
                        'verify'
                    ];
                    break;
                case 'RS256':
                case 'RS384':
                case 'RS512':
                    algorithm = {
                        name: 'RSASSA-PKCS1-v1_5',
                        hash: `SHA-${jwk.alg.slice(-3)}`
                    };
                    keyUsages = jwk.d ? [
                        'sign'
                    ] : [
                        'verify'
                    ];
                    break;
                case 'RSA-OAEP':
                case 'RSA-OAEP-256':
                case 'RSA-OAEP-384':
                case 'RSA-OAEP-512':
                    algorithm = {
                        name: 'RSA-OAEP',
                        hash: `SHA-${parseInt(jwk.alg.slice(-3), 10) || 1}`
                    };
                    keyUsages = jwk.d ? [
                        'decrypt',
                        'unwrapKey'
                    ] : [
                        'encrypt',
                        'wrapKey'
                    ];
                    break;
                default:
                    throw new (0, $jAIn1.JOSENotSupported)('Invalid or unsupported JWK "alg" (Algorithm) Parameter value');
            }
            break;
        case 'EC':
            switch(jwk.alg){
                case 'ES256':
                    algorithm = {
                        name: 'ECDSA',
                        namedCurve: 'P-256'
                    };
                    keyUsages = jwk.d ? [
                        'sign'
                    ] : [
                        'verify'
                    ];
                    break;
                case 'ES384':
                    algorithm = {
                        name: 'ECDSA',
                        namedCurve: 'P-384'
                    };
                    keyUsages = jwk.d ? [
                        'sign'
                    ] : [
                        'verify'
                    ];
                    break;
                case 'ES512':
                    algorithm = {
                        name: 'ECDSA',
                        namedCurve: 'P-521'
                    };
                    keyUsages = jwk.d ? [
                        'sign'
                    ] : [
                        'verify'
                    ];
                    break;
                case 'ECDH-ES':
                case 'ECDH-ES+A128KW':
                case 'ECDH-ES+A192KW':
                case 'ECDH-ES+A256KW':
                    algorithm = {
                        name: 'ECDH',
                        namedCurve: jwk.crv
                    };
                    keyUsages = jwk.d ? [
                        'deriveBits'
                    ] : [];
                    break;
                default:
                    throw new (0, $jAIn1.JOSENotSupported)('Invalid or unsupported JWK "alg" (Algorithm) Parameter value');
            }
            break;
        case 'OKP':
            switch(jwk.alg){
                case 'Ed25519':
                    algorithm = {
                        name: 'Ed25519'
                    };
                    keyUsages = jwk.d ? [
                        'sign'
                    ] : [
                        'verify'
                    ];
                    break;
                case 'EdDSA':
                    algorithm = {
                        name: jwk.crv
                    };
                    keyUsages = jwk.d ? [
                        'sign'
                    ] : [
                        'verify'
                    ];
                    break;
                case 'ECDH-ES':
                case 'ECDH-ES+A128KW':
                case 'ECDH-ES+A192KW':
                case 'ECDH-ES+A256KW':
                    algorithm = {
                        name: jwk.crv
                    };
                    keyUsages = jwk.d ? [
                        'deriveBits'
                    ] : [];
                    break;
                default:
                    throw new (0, $jAIn1.JOSENotSupported)('Invalid or unsupported JWK "alg" (Algorithm) Parameter value');
            }
            break;
        default:
            throw new (0, $jAIn1.JOSENotSupported)('Invalid or unsupported JWK "kty" (Key Type) Parameter value');
    }
    return {
        algorithm: algorithm,
        keyUsages: keyUsages
    };
}
const $2f99121898093277$var$parse = async (jwk)=>{
    if (!jwk.alg) throw new TypeError('"alg" argument is required when "jwk.alg" is not present');
    const { algorithm: algorithm, keyUsages: keyUsages } = $2f99121898093277$var$subtleMapping(jwk);
    const rest = [
        algorithm,
        jwk.ext ?? false,
        jwk.key_ops ?? keyUsages
    ];
    const keyData = {
        ...jwk
    };
    delete keyData.alg;
    delete keyData.use;
    return (0, $5oA8l.default).subtle.importKey('jwk', keyData, ...rest);
};
var $2f99121898093277$export$2e2bcd8739ae039 = $2f99121898093277$var$parse;

});




parcelRegister("3nDF0", function(module, exports) {
$parcel$export(module.exports, "default", () => $276248cc4b8fd1c6$export$2e2bcd8739ae039);
const $276248cc4b8fd1c6$var$isDisjoint = (...headers)=>{
    const sources = headers.filter(Boolean);
    if (sources.length === 0 || sources.length === 1) return true;
    let acc;
    for (const header of sources){
        const parameters = Object.keys(header);
        if (!acc || acc.size === 0) {
            acc = new Set(parameters);
            continue;
        }
        for (const parameter of parameters){
            if (acc.has(parameter)) return false;
            acc.add(parameter);
        }
    }
    return true;
};
var $276248cc4b8fd1c6$export$2e2bcd8739ae039 = $276248cc4b8fd1c6$var$isDisjoint;

});

parcelRegister("dqmVx", function(module, exports) {
$parcel$export(module.exports, "checkKeyTypeWithJwk", () => $9c5f7ce4526cbfc1$export$d7fd0dd52697ff18);

var $8ZwVa = parcelRequire("8ZwVa");

var $iVBpG = parcelRequire("iVBpG");

var $4mnjT = parcelRequire("4mnjT");
const $9c5f7ce4526cbfc1$var$tag = (key)=>key?.[Symbol.toStringTag];
const $9c5f7ce4526cbfc1$var$jwkMatchesOp = (alg, key, usage)=>{
    if (key.use !== undefined && key.use !== 'sig') throw new TypeError('Invalid key for this operation, when present its use must be sig');
    if (key.key_ops !== undefined && key.key_ops.includes?.(usage) !== true) throw new TypeError(`Invalid key for this operation, when present its key_ops must include ${usage}`);
    if (key.alg !== undefined && key.alg !== alg) throw new TypeError(`Invalid key for this operation, when present its alg must be ${alg}`);
    return true;
};
const $9c5f7ce4526cbfc1$var$symmetricTypeCheck = (alg, key, usage, allowJwk)=>{
    if (key instanceof Uint8Array) return;
    if (allowJwk && $4mnjT.isJWK(key)) {
        if ($4mnjT.isSecretJWK(key) && $9c5f7ce4526cbfc1$var$jwkMatchesOp(alg, key, usage)) return;
        throw new TypeError(`JSON Web Key for symmetric algorithms must have JWK "kty" (Key Type) equal to "oct" and the JWK "k" (Key Value) present`);
    }
    if (!(0, $iVBpG.default)(key)) throw new TypeError((0, $8ZwVa.withAlg)(alg, key, ...(0, $iVBpG.types), 'Uint8Array', allowJwk ? 'JSON Web Key' : null));
    if (key.type !== 'secret') throw new TypeError(`${$9c5f7ce4526cbfc1$var$tag(key)} instances for symmetric algorithms must be of type "secret"`);
};
const $9c5f7ce4526cbfc1$var$asymmetricTypeCheck = (alg, key, usage, allowJwk)=>{
    if (allowJwk && $4mnjT.isJWK(key)) switch(usage){
        case 'sign':
            if ($4mnjT.isPrivateJWK(key) && $9c5f7ce4526cbfc1$var$jwkMatchesOp(alg, key, usage)) return;
            throw new TypeError(`JSON Web Key for this operation be a private JWK`);
        case 'verify':
            if ($4mnjT.isPublicJWK(key) && $9c5f7ce4526cbfc1$var$jwkMatchesOp(alg, key, usage)) return;
            throw new TypeError(`JSON Web Key for this operation be a public JWK`);
    }
    if (!(0, $iVBpG.default)(key)) throw new TypeError((0, $8ZwVa.withAlg)(alg, key, ...(0, $iVBpG.types), allowJwk ? 'JSON Web Key' : null));
    if (key.type === 'secret') throw new TypeError(`${$9c5f7ce4526cbfc1$var$tag(key)} instances for asymmetric algorithms must not be of type "secret"`);
    if (usage === 'sign' && key.type === 'public') throw new TypeError(`${$9c5f7ce4526cbfc1$var$tag(key)} instances for asymmetric algorithm signing must be of type "private"`);
    if (usage === 'decrypt' && key.type === 'public') throw new TypeError(`${$9c5f7ce4526cbfc1$var$tag(key)} instances for asymmetric algorithm decryption must be of type "private"`);
    if (key.algorithm && usage === 'verify' && key.type === 'private') throw new TypeError(`${$9c5f7ce4526cbfc1$var$tag(key)} instances for asymmetric algorithm verifying must be of type "public"`);
    if (key.algorithm && usage === 'encrypt' && key.type === 'private') throw new TypeError(`${$9c5f7ce4526cbfc1$var$tag(key)} instances for asymmetric algorithm encryption must be of type "public"`);
};
function $9c5f7ce4526cbfc1$var$checkKeyType(allowJwk, alg, key, usage) {
    const symmetric = alg.startsWith('HS') || alg === 'dir' || alg.startsWith('PBES2') || /^A\d{3}(?:GCM)?KW$/.test(alg);
    if (symmetric) $9c5f7ce4526cbfc1$var$symmetricTypeCheck(alg, key, usage, allowJwk);
    else $9c5f7ce4526cbfc1$var$asymmetricTypeCheck(alg, key, usage, allowJwk);
}
var $9c5f7ce4526cbfc1$export$2e2bcd8739ae039 = $9c5f7ce4526cbfc1$var$checkKeyType.bind(undefined, false);
const $9c5f7ce4526cbfc1$export$d7fd0dd52697ff18 = $9c5f7ce4526cbfc1$var$checkKeyType.bind(undefined, true);

});

parcelRegister("6Q0OR", function(module, exports) {
$parcel$export(module.exports, "default", () => $4fa83c1b06d09175$export$2e2bcd8739ae039);

var $jAIn1 = parcelRequire("jAIn1");
function $4fa83c1b06d09175$var$validateCrit(Err, recognizedDefault, recognizedOption, protectedHeader, joseHeader) {
    if (joseHeader.crit !== undefined && protectedHeader?.crit === undefined) throw new Err('"crit" (Critical) Header Parameter MUST be integrity protected');
    if (!protectedHeader || protectedHeader.crit === undefined) return new Set();
    if (!Array.isArray(protectedHeader.crit) || protectedHeader.crit.length === 0 || protectedHeader.crit.some((input)=>typeof input !== 'string' || input.length === 0)) throw new Err('"crit" (Critical) Header Parameter MUST be an array of non-empty strings when present');
    let recognized;
    if (recognizedOption !== undefined) recognized = new Map([
        ...Object.entries(recognizedOption),
        ...recognizedDefault.entries()
    ]);
    else recognized = recognizedDefault;
    for (const parameter of protectedHeader.crit){
        if (!recognized.has(parameter)) throw new (0, $jAIn1.JOSENotSupported)(`Extension Header Parameter "${parameter}" is not recognized`);
        if (joseHeader[parameter] === undefined) throw new Err(`Extension Header Parameter "${parameter}" is missing`);
        if (recognized.get(parameter) && protectedHeader[parameter] === undefined) throw new Err(`Extension Header Parameter "${parameter}" MUST be integrity protected`);
    }
    return new Set(protectedHeader.crit);
}
var $4fa83c1b06d09175$export$2e2bcd8739ae039 = $4fa83c1b06d09175$var$validateCrit;

});

parcelRegister("liIwC", function(module, exports) {
$parcel$export(module.exports, "default", () => $f81dd12d26d536a9$export$2e2bcd8739ae039);
const $f81dd12d26d536a9$var$validateAlgorithms = (option, algorithms)=>{
    if (algorithms !== undefined && (!Array.isArray(algorithms) || algorithms.some((s)=>typeof s !== 'string'))) throw new TypeError(`"${option}" option must be an array of strings`);
    if (!algorithms) return undefined;
    return new Set(algorithms);
};
var $f81dd12d26d536a9$export$2e2bcd8739ae039 = $f81dd12d26d536a9$var$validateAlgorithms;

});

parcelRegister("9pDiP", function(module, exports) {
$parcel$export(module.exports, "importJWK", () => $6da4ef88fd96ea65$export$2b70d37b4d0b888b);

var $adj1r = parcelRequire("adj1r");

var $hIpF9 = parcelRequire("hIpF9");

var $45mu8 = parcelRequire("45mu8");

var $jAIn1 = parcelRequire("jAIn1");

var $cyCSw = parcelRequire("cyCSw");
async function $6da4ef88fd96ea65$export$7cdfc961c11d0266(spki, alg, options) {
    if (typeof spki !== 'string' || spki.indexOf('-----BEGIN PUBLIC KEY-----') !== 0) throw new TypeError('"spki" must be SPKI formatted string');
    return (0, $hIpF9.fromSPKI)(spki, alg, options);
}
async function $6da4ef88fd96ea65$export$948757ecbbf4a918(x509, alg, options) {
    if (typeof x509 !== 'string' || x509.indexOf('-----BEGIN CERTIFICATE-----') !== 0) throw new TypeError('"x509" must be X.509 formatted string');
    return (0, $hIpF9.fromX509)(x509, alg, options);
}
async function $6da4ef88fd96ea65$export$17f5e7f6d2848df5(pkcs8, alg, options) {
    if (typeof pkcs8 !== 'string' || pkcs8.indexOf('-----BEGIN PRIVATE KEY-----') !== 0) throw new TypeError('"pkcs8" must be PKCS#8 formatted string');
    return (0, $hIpF9.fromPKCS8)(pkcs8, alg, options);
}
async function $6da4ef88fd96ea65$export$2b70d37b4d0b888b(jwk, alg) {
    if (!(0, $cyCSw.default)(jwk)) throw new TypeError('JWK must be an object');
    alg || (alg = jwk.alg);
    switch(jwk.kty){
        case 'oct':
            if (typeof jwk.k !== 'string' || !jwk.k) throw new TypeError('missing "k" (Key Value) Parameter value');
            return (0, $adj1r.decode)(jwk.k);
        case 'RSA':
            if ('oth' in jwk && jwk.oth !== undefined) throw new (0, $jAIn1.JOSENotSupported)('RSA JWK "oth" (Other Primes Info) Parameter value is not supported');
        case 'EC':
        case 'OKP':
            return (0, $45mu8.default)({
                ...jwk,
                alg: alg
            });
        default:
            throw new (0, $jAIn1.JOSENotSupported)('Unsupported "kty" (Key Type) Parameter value');
    }
}

});
parcelRegister("hIpF9", function(module, exports) {
$parcel$export(module.exports, "fromPKCS8", () => $ce5a73cad73408c6$export$224b0a6339c7267f);
$parcel$export(module.exports, "fromSPKI", () => $ce5a73cad73408c6$export$f9a3505cdaa1fb3e);
$parcel$export(module.exports, "fromX509", () => $ce5a73cad73408c6$export$ed788b6a8533858f);

var $5oA8l = parcelRequire("5oA8l");

var $8ZwVa = parcelRequire("8ZwVa");

var $adj1r = parcelRequire("adj1r");

var $cYJV9 = parcelRequire("cYJV9");

var $jAIn1 = parcelRequire("jAIn1");

var $iVBpG = parcelRequire("iVBpG");
const $ce5a73cad73408c6$var$genericExport = async (keyType, keyFormat, key)=>{
    if (!(0, $5oA8l.isCryptoKey)(key)) throw new TypeError((0, $8ZwVa.default)(key, ...(0, $iVBpG.types)));
    if (!key.extractable) throw new TypeError('CryptoKey is not extractable');
    if (key.type !== keyType) throw new TypeError(`key is not a ${keyType} key`);
    return (0, $cYJV9.default)((0, $adj1r.encodeBase64)(new Uint8Array(await (0, $5oA8l.default).subtle.exportKey(keyFormat, key))), `${keyType.toUpperCase()} KEY`);
};
const $ce5a73cad73408c6$export$cfba7e924fe414ca = (key)=>{
    return $ce5a73cad73408c6$var$genericExport('public', 'spki', key);
};
const $ce5a73cad73408c6$export$cac76a78a90b914d = (key)=>{
    return $ce5a73cad73408c6$var$genericExport('private', 'pkcs8', key);
};
const $ce5a73cad73408c6$var$findOid = (keyData, oid, from = 0)=>{
    if (from === 0) {
        oid.unshift(oid.length);
        oid.unshift(0x06);
    }
    const i = keyData.indexOf(oid[0], from);
    if (i === -1) return false;
    const sub = keyData.subarray(i, i + oid.length);
    if (sub.length !== oid.length) return false;
    return sub.every((value, index)=>value === oid[index]) || $ce5a73cad73408c6$var$findOid(keyData, oid, i + 1);
};
const $ce5a73cad73408c6$var$getNamedCurve = (keyData)=>{
    switch(true){
        case $ce5a73cad73408c6$var$findOid(keyData, [
            0x2a,
            0x86,
            0x48,
            0xce,
            0x3d,
            0x03,
            0x01,
            0x07
        ]):
            return 'P-256';
        case $ce5a73cad73408c6$var$findOid(keyData, [
            0x2b,
            0x81,
            0x04,
            0x00,
            0x22
        ]):
            return 'P-384';
        case $ce5a73cad73408c6$var$findOid(keyData, [
            0x2b,
            0x81,
            0x04,
            0x00,
            0x23
        ]):
            return 'P-521';
        case $ce5a73cad73408c6$var$findOid(keyData, [
            0x2b,
            0x65,
            0x6e
        ]):
            return 'X25519';
        case $ce5a73cad73408c6$var$findOid(keyData, [
            0x2b,
            0x65,
            0x6f
        ]):
            return 'X448';
        case $ce5a73cad73408c6$var$findOid(keyData, [
            0x2b,
            0x65,
            0x70
        ]):
            return 'Ed25519';
        case $ce5a73cad73408c6$var$findOid(keyData, [
            0x2b,
            0x65,
            0x71
        ]):
            return 'Ed448';
        default:
            throw new (0, $jAIn1.JOSENotSupported)('Invalid or unsupported EC Key Curve or OKP Key Sub Type');
    }
};
const $ce5a73cad73408c6$var$genericImport = async (replace, keyFormat, pem, alg, options)=>{
    let algorithm;
    let keyUsages;
    const keyData = new Uint8Array(atob(pem.replace(replace, '')).split('').map((c)=>c.charCodeAt(0)));
    const isPublic = keyFormat === 'spki';
    switch(alg){
        case 'PS256':
        case 'PS384':
        case 'PS512':
            algorithm = {
                name: 'RSA-PSS',
                hash: `SHA-${alg.slice(-3)}`
            };
            keyUsages = isPublic ? [
                'verify'
            ] : [
                'sign'
            ];
            break;
        case 'RS256':
        case 'RS384':
        case 'RS512':
            algorithm = {
                name: 'RSASSA-PKCS1-v1_5',
                hash: `SHA-${alg.slice(-3)}`
            };
            keyUsages = isPublic ? [
                'verify'
            ] : [
                'sign'
            ];
            break;
        case 'RSA-OAEP':
        case 'RSA-OAEP-256':
        case 'RSA-OAEP-384':
        case 'RSA-OAEP-512':
            algorithm = {
                name: 'RSA-OAEP',
                hash: `SHA-${parseInt(alg.slice(-3), 10) || 1}`
            };
            keyUsages = isPublic ? [
                'encrypt',
                'wrapKey'
            ] : [
                'decrypt',
                'unwrapKey'
            ];
            break;
        case 'ES256':
            algorithm = {
                name: 'ECDSA',
                namedCurve: 'P-256'
            };
            keyUsages = isPublic ? [
                'verify'
            ] : [
                'sign'
            ];
            break;
        case 'ES384':
            algorithm = {
                name: 'ECDSA',
                namedCurve: 'P-384'
            };
            keyUsages = isPublic ? [
                'verify'
            ] : [
                'sign'
            ];
            break;
        case 'ES512':
            algorithm = {
                name: 'ECDSA',
                namedCurve: 'P-521'
            };
            keyUsages = isPublic ? [
                'verify'
            ] : [
                'sign'
            ];
            break;
        case 'ECDH-ES':
        case 'ECDH-ES+A128KW':
        case 'ECDH-ES+A192KW':
        case 'ECDH-ES+A256KW':
            {
                const namedCurve = $ce5a73cad73408c6$var$getNamedCurve(keyData);
                algorithm = namedCurve.startsWith('P-') ? {
                    name: 'ECDH',
                    namedCurve: namedCurve
                } : {
                    name: namedCurve
                };
                keyUsages = isPublic ? [] : [
                    'deriveBits'
                ];
                break;
            }
        case 'Ed25519':
            algorithm = {
                name: 'Ed25519'
            };
            keyUsages = isPublic ? [
                'verify'
            ] : [
                'sign'
            ];
            break;
        case 'EdDSA':
            algorithm = {
                name: $ce5a73cad73408c6$var$getNamedCurve(keyData)
            };
            keyUsages = isPublic ? [
                'verify'
            ] : [
                'sign'
            ];
            break;
        default:
            throw new (0, $jAIn1.JOSENotSupported)('Invalid or unsupported "alg" (Algorithm) value');
    }
    return (0, $5oA8l.default).subtle.importKey(keyFormat, keyData, algorithm, options?.extractable ?? false, keyUsages);
};
const $ce5a73cad73408c6$export$224b0a6339c7267f = (pem, alg, options)=>{
    return $ce5a73cad73408c6$var$genericImport(/(?:-----(?:BEGIN|END) PRIVATE KEY-----|\s)/g, 'pkcs8', pem, alg, options);
};
const $ce5a73cad73408c6$export$f9a3505cdaa1fb3e = (pem, alg, options)=>{
    return $ce5a73cad73408c6$var$genericImport(/(?:-----(?:BEGIN|END) PUBLIC KEY-----|\s)/g, 'spki', pem, alg, options);
};
function $ce5a73cad73408c6$var$getElement(seq) {
    const result = [];
    let next = 0;
    while(next < seq.length){
        const nextPart = $ce5a73cad73408c6$var$parseElement(seq.subarray(next));
        result.push(nextPart);
        next += nextPart.byteLength;
    }
    return result;
}
function $ce5a73cad73408c6$var$parseElement(bytes) {
    let position = 0;
    let tag = bytes[0] & 0x1f;
    position++;
    if (tag === 0x1f) {
        tag = 0;
        while(bytes[position] >= 0x80){
            tag = tag * 128 + bytes[position] - 0x80;
            position++;
        }
        tag = tag * 128 + bytes[position] - 0x80;
        position++;
    }
    let length = 0;
    if (bytes[position] < 0x80) {
        length = bytes[position];
        position++;
    } else if (length === 0x80) {
        length = 0;
        while(bytes[position + length] !== 0 || bytes[position + length + 1] !== 0){
            if (length > bytes.byteLength) throw new TypeError('invalid indefinite form length');
            length++;
        }
        const byteLength = position + length + 2;
        return {
            byteLength: byteLength,
            contents: bytes.subarray(position, position + length),
            raw: bytes.subarray(0, byteLength)
        };
    } else {
        const numberOfDigits = bytes[position] & 0x7f;
        position++;
        length = 0;
        for(let i = 0; i < numberOfDigits; i++){
            length = length * 256 + bytes[position];
            position++;
        }
    }
    const byteLength = position + length;
    return {
        byteLength: byteLength,
        contents: bytes.subarray(position, byteLength),
        raw: bytes.subarray(0, byteLength)
    };
}
function $ce5a73cad73408c6$var$spkiFromX509(buf) {
    const tbsCertificate = $ce5a73cad73408c6$var$getElement($ce5a73cad73408c6$var$getElement($ce5a73cad73408c6$var$parseElement(buf).contents)[0].contents);
    return (0, $adj1r.encodeBase64)(tbsCertificate[tbsCertificate[0].raw[0] === 0xa0 ? 6 : 5].raw);
}
function $ce5a73cad73408c6$var$getSPKI(x509) {
    const pem = x509.replace(/(?:-----(?:BEGIN|END) CERTIFICATE-----|\s)/g, '');
    const raw = (0, $adj1r.decodeBase64)(pem);
    return (0, $cYJV9.default)($ce5a73cad73408c6$var$spkiFromX509(raw), 'PUBLIC KEY');
}
const $ce5a73cad73408c6$export$ed788b6a8533858f = (pem, alg, options)=>{
    let spki;
    try {
        spki = $ce5a73cad73408c6$var$getSPKI(pem);
    } catch (cause) {
        throw new TypeError('Failed to parse the X.509 certificate', {
            cause: cause
        });
    }
    return $ce5a73cad73408c6$export$f9a3505cdaa1fb3e(spki, alg, options);
};

});
parcelRegister("cYJV9", function(module, exports) {
$parcel$export(module.exports, "default", () => $972eb5892c8cb69e$export$2e2bcd8739ae039);
var $972eb5892c8cb69e$export$2e2bcd8739ae039 = (b64, descriptor)=>{
    const newlined = (b64.match(/.{1,64}/g) || []).join('\n');
    return `-----BEGIN ${descriptor}-----\n${newlined}\n-----END ${descriptor}-----`;
};

});





parcelRegister("2dYLF", function(module, exports) {
$parcel$export(module.exports, "createRemoteJWKSet", () => $19ebeeea4f6d3130$export$78ce35c2df51c333);

var $d1hxa = parcelRequire("d1hxa");

var $jAIn1 = parcelRequire("jAIn1");

var $3dm10 = parcelRequire("3dm10");

var $cyCSw = parcelRequire("cyCSw");
function $19ebeeea4f6d3130$var$isCloudflareWorkers() {
    return typeof WebSocketPair !== 'undefined' || typeof navigator !== 'undefined' && navigator.userAgent === 'Cloudflare-Workers' || typeof EdgeRuntime !== 'undefined' && EdgeRuntime === 'vercel';
}
let $19ebeeea4f6d3130$var$USER_AGENT;
if (typeof navigator === 'undefined' || !navigator.userAgent?.startsWith?.('Mozilla/5.0 ')) {
    const NAME = 'jose';
    const VERSION = 'v5.10.0';
    $19ebeeea4f6d3130$var$USER_AGENT = `${NAME}/${VERSION}`;
}
const $19ebeeea4f6d3130$export$68a3c8fa6edea323 = Symbol();
function $19ebeeea4f6d3130$var$isFreshJwksCache(input, cacheMaxAge) {
    if (typeof input !== 'object' || input === null) return false;
    if (!('uat' in input) || typeof input.uat !== 'number' || Date.now() - input.uat >= cacheMaxAge) return false;
    if (!('jwks' in input) || !(0, $cyCSw.default)(input.jwks) || !Array.isArray(input.jwks.keys) || !Array.prototype.every.call(input.jwks.keys, (0, $cyCSw.default))) return false;
    return true;
}
class $19ebeeea4f6d3130$var$RemoteJWKSet {
    constructor(url, options){
        if (!(url instanceof URL)) throw new TypeError('url must be an instance of URL');
        this._url = new URL(url.href);
        this._options = {
            agent: options?.agent,
            headers: options?.headers
        };
        this._timeoutDuration = typeof options?.timeoutDuration === 'number' ? options?.timeoutDuration : 5000;
        this._cooldownDuration = typeof options?.cooldownDuration === 'number' ? options?.cooldownDuration : 30000;
        this._cacheMaxAge = typeof options?.cacheMaxAge === 'number' ? options?.cacheMaxAge : 600000;
        if (options?.[$19ebeeea4f6d3130$export$68a3c8fa6edea323] !== undefined) {
            this._cache = options?.[$19ebeeea4f6d3130$export$68a3c8fa6edea323];
            if ($19ebeeea4f6d3130$var$isFreshJwksCache(options?.[$19ebeeea4f6d3130$export$68a3c8fa6edea323], this._cacheMaxAge)) {
                this._jwksTimestamp = this._cache.uat;
                this._local = (0, $3dm10.createLocalJWKSet)(this._cache.jwks);
            }
        }
    }
    coolingDown() {
        return typeof this._jwksTimestamp === 'number' ? Date.now() < this._jwksTimestamp + this._cooldownDuration : false;
    }
    fresh() {
        return typeof this._jwksTimestamp === 'number' ? Date.now() < this._jwksTimestamp + this._cacheMaxAge : false;
    }
    async getKey(protectedHeader, token) {
        if (!this._local || !this.fresh()) await this.reload();
        try {
            return await this._local(protectedHeader, token);
        } catch (err) {
            if (err instanceof (0, $jAIn1.JWKSNoMatchingKey)) {
                if (this.coolingDown() === false) {
                    await this.reload();
                    return this._local(protectedHeader, token);
                }
            }
            throw err;
        }
    }
    async reload() {
        if (this._pendingFetch && $19ebeeea4f6d3130$var$isCloudflareWorkers()) this._pendingFetch = undefined;
        const headers = new Headers(this._options.headers);
        if ($19ebeeea4f6d3130$var$USER_AGENT && !headers.has('User-Agent')) {
            headers.set('User-Agent', $19ebeeea4f6d3130$var$USER_AGENT);
            this._options.headers = Object.fromEntries(headers.entries());
        }
        this._pendingFetch || (this._pendingFetch = (0, $d1hxa.default)(this._url, this._timeoutDuration, this._options).then((json)=>{
            this._local = (0, $3dm10.createLocalJWKSet)(json);
            if (this._cache) {
                this._cache.uat = Date.now();
                this._cache.jwks = json;
            }
            this._jwksTimestamp = Date.now();
            this._pendingFetch = undefined;
        }).catch((err)=>{
            this._pendingFetch = undefined;
            throw err;
        }));
        await this._pendingFetch;
    }
}
function $19ebeeea4f6d3130$export$78ce35c2df51c333(url, options) {
    const set = new $19ebeeea4f6d3130$var$RemoteJWKSet(url, options);
    const remoteJWKSet = async (protectedHeader, token)=>set.getKey(protectedHeader, token);
    Object.defineProperties(remoteJWKSet, {
        coolingDown: {
            get: ()=>set.coolingDown(),
            enumerable: true,
            configurable: false
        },
        fresh: {
            get: ()=>set.fresh(),
            enumerable: true,
            configurable: false
        },
        reload: {
            value: ()=>set.reload(),
            enumerable: true,
            configurable: false,
            writable: false
        },
        reloading: {
            get: ()=>!!set._pendingFetch,
            enumerable: true,
            configurable: false
        },
        jwks: {
            value: ()=>set._local?.jwks(),
            enumerable: true,
            configurable: false,
            writable: false
        }
    });
    return remoteJWKSet;
}
const $19ebeeea4f6d3130$export$3ec5a8fe10b55ead = $19ebeeea4f6d3130$export$68a3c8fa6edea323;

});
parcelRegister("d1hxa", function(module, exports) {
$parcel$export(module.exports, "default", () => $97a8f83ca96c3676$export$2e2bcd8739ae039);

var $jAIn1 = parcelRequire("jAIn1");
const $97a8f83ca96c3676$var$fetchJwks = async (url, timeout, options)=>{
    let controller;
    let id;
    let timedOut = false;
    if (typeof AbortController === 'function') {
        controller = new AbortController();
        id = setTimeout(()=>{
            timedOut = true;
            controller.abort();
        }, timeout);
    }
    const response = await fetch(url.href, {
        signal: controller ? controller.signal : undefined,
        redirect: 'manual',
        headers: options.headers
    }).catch((err)=>{
        if (timedOut) throw new (0, $jAIn1.JWKSTimeout)();
        throw err;
    });
    if (id !== undefined) clearTimeout(id);
    if (response.status !== 200) throw new (0, $jAIn1.JOSEError)('Expected 200 OK from the JSON Web Key Set HTTP response');
    try {
        return await response.json();
    } catch  {
        throw new (0, $jAIn1.JOSEError)('Failed to parse the JSON Web Key Set HTTP response as JSON');
    }
};
var $97a8f83ca96c3676$export$2e2bcd8739ae039 = $97a8f83ca96c3676$var$fetchJwks;

});

parcelRegister("3dm10", function(module, exports) {
$parcel$export(module.exports, "createLocalJWKSet", () => $2573a9bf75104689$export$4892abc640e5f80e);

var $9pDiP = parcelRequire("9pDiP");

var $jAIn1 = parcelRequire("jAIn1");

var $cyCSw = parcelRequire("cyCSw");
function $2573a9bf75104689$var$getKtyFromAlg(alg) {
    switch(typeof alg === 'string' && alg.slice(0, 2)){
        case 'RS':
        case 'PS':
            return 'RSA';
        case 'ES':
            return 'EC';
        case 'Ed':
            return 'OKP';
        default:
            throw new (0, $jAIn1.JOSENotSupported)('Unsupported "alg" value for a JSON Web Key Set');
    }
}
function $2573a9bf75104689$var$isJWKSLike(jwks) {
    return jwks && typeof jwks === 'object' && Array.isArray(jwks.keys) && jwks.keys.every($2573a9bf75104689$var$isJWKLike);
}
function $2573a9bf75104689$var$isJWKLike(key) {
    return (0, $cyCSw.default)(key);
}
function $2573a9bf75104689$var$clone(obj) {
    if (typeof structuredClone === 'function') return structuredClone(obj);
    return JSON.parse(JSON.stringify(obj));
}
class $2573a9bf75104689$var$LocalJWKSet {
    constructor(jwks){
        this._cached = new WeakMap();
        if (!$2573a9bf75104689$var$isJWKSLike(jwks)) throw new (0, $jAIn1.JWKSInvalid)('JSON Web Key Set malformed');
        this._jwks = $2573a9bf75104689$var$clone(jwks);
    }
    async getKey(protectedHeader, token) {
        const { alg: alg, kid: kid } = {
            ...protectedHeader,
            ...token?.header
        };
        const kty = $2573a9bf75104689$var$getKtyFromAlg(alg);
        const candidates = this._jwks.keys.filter((jwk)=>{
            let candidate = kty === jwk.kty;
            if (candidate && typeof kid === 'string') candidate = kid === jwk.kid;
            if (candidate && typeof jwk.alg === 'string') candidate = alg === jwk.alg;
            if (candidate && typeof jwk.use === 'string') candidate = jwk.use === 'sig';
            if (candidate && Array.isArray(jwk.key_ops)) candidate = jwk.key_ops.includes('verify');
            if (candidate) switch(alg){
                case 'ES256':
                    candidate = jwk.crv === 'P-256';
                    break;
                case 'ES256K':
                    candidate = jwk.crv === 'secp256k1';
                    break;
                case 'ES384':
                    candidate = jwk.crv === 'P-384';
                    break;
                case 'ES512':
                    candidate = jwk.crv === 'P-521';
                    break;
                case 'Ed25519':
                    candidate = jwk.crv === 'Ed25519';
                    break;
                case 'EdDSA':
                    candidate = jwk.crv === 'Ed25519' || jwk.crv === 'Ed448';
                    break;
            }
            return candidate;
        });
        const { 0: jwk, length: length } = candidates;
        if (length === 0) throw new (0, $jAIn1.JWKSNoMatchingKey)();
        if (length !== 1) {
            const error = new (0, $jAIn1.JWKSMultipleMatchingKeys)();
            const { _cached: _cached } = this;
            error[Symbol.asyncIterator] = async function*() {
                for (const jwk of candidates)try {
                    yield await $2573a9bf75104689$var$importWithAlgCache(_cached, jwk, alg);
                } catch  {}
            };
            throw error;
        }
        return $2573a9bf75104689$var$importWithAlgCache(this._cached, jwk, alg);
    }
}
async function $2573a9bf75104689$var$importWithAlgCache(cache, jwk, alg) {
    const cached = cache.get(jwk) || cache.set(jwk, {}).get(jwk);
    if (cached[alg] === undefined) {
        const key = await (0, $9pDiP.importJWK)({
            ...jwk,
            ext: true
        }, alg);
        if (key instanceof Uint8Array || key.type !== 'public') throw new (0, $jAIn1.JWKSInvalid)('JSON Web Key Set members must be public keys');
        cached[alg] = key;
    }
    return cached[alg];
}
function $2573a9bf75104689$export$4892abc640e5f80e(jwks) {
    const set = new $2573a9bf75104689$var$LocalJWKSet(jwks);
    const localJWKSet = async (protectedHeader, token)=>set.getKey(protectedHeader, token);
    Object.defineProperties(localJWKSet, {
        jwks: {
            value: ()=>$2573a9bf75104689$var$clone(set._jwks),
            enumerable: true,
            configurable: false,
            writable: false
        }
    });
    return localJWKSet;
}

});


parcelRegister("ev0NA", function(module, exports) {
$parcel$export(module.exports, "decodeJwt", () => $a8e4948c2f925d47$export$dcef71b8fb9a6794);

var $dUW7h = parcelRequire("dUW7h");

var $dUFs4 = parcelRequire("dUFs4");

var $cyCSw = parcelRequire("cyCSw");

var $jAIn1 = parcelRequire("jAIn1");
function $a8e4948c2f925d47$export$dcef71b8fb9a6794(jwt) {
    if (typeof jwt !== 'string') throw new (0, $jAIn1.JWTInvalid)('JWTs must use Compact JWS serialization, JWT must be a string');
    const { 1: payload, length: length } = jwt.split('.');
    if (length === 5) throw new (0, $jAIn1.JWTInvalid)('Only JWTs using Compact JWS serialization can be decoded');
    if (length !== 3) throw new (0, $jAIn1.JWTInvalid)('Invalid JWT');
    if (!payload) throw new (0, $jAIn1.JWTInvalid)('JWTs must contain a payload');
    let decoded;
    try {
        decoded = (0, $dUW7h.decode)(payload);
    } catch  {
        throw new (0, $jAIn1.JWTInvalid)('Failed to base64url decode the payload');
    }
    let result;
    try {
        result = JSON.parse((0, $dUFs4.decoder).decode(decoded));
    } catch  {
        throw new (0, $jAIn1.JWTInvalid)('Failed to parse the decoded payload as JSON');
    }
    if (!(0, $cyCSw.default)(result)) throw new (0, $jAIn1.JWTInvalid)('Invalid JWT Claims Set');
    return result;
}

});
parcelRegister("dUW7h", function(module, exports) {
$parcel$export(module.exports, "decode", () => $a21d960eac8f8543$export$2f872c0f2117be69);

var $adj1r = parcelRequire("adj1r");
const $a21d960eac8f8543$export$c564cdbbe6da493 = $adj1r.encode;
const $a21d960eac8f8543$export$2f872c0f2117be69 = $adj1r.decode;

});


parcelRegister("49b5t", function(module, exports) {
$parcel$export(module.exports, "withForwardedEnv", () => $245e96c394b65f44$export$4bb97362ee5103dd);
const $245e96c394b65f44$var$ENV_PARAM = 'env';
function $245e96c394b65f44$export$4f99da1c40fbc1e6(search = $245e96c394b65f44$var$getCurrentSearch()) {
    return new URLSearchParams(search).get($245e96c394b65f44$var$ENV_PARAM);
}
function $245e96c394b65f44$export$4bb97362ee5103dd(url, search = $245e96c394b65f44$var$getCurrentSearch()) {
    const env = $245e96c394b65f44$export$4f99da1c40fbc1e6(search);
    if (!env) return url;
    const [urlWithoutFragment, fragment] = url.split('#', 2);
    const [path, query] = urlWithoutFragment.split('?', 2);
    const params = new URLSearchParams(query);
    params.set($245e96c394b65f44$var$ENV_PARAM, env);
    const urlWithEnv = `${path}?${params}`;
    return fragment ? `${urlWithEnv}#${fragment}` : urlWithEnv;
}
function $245e96c394b65f44$var$getCurrentSearch() {
    return typeof window === 'undefined' ? '' : window.location.search;
}

});

parcelRegister("3VQxn", function(module, exports) {
$parcel$export(module.exports, "isError", () => $544b3084c7bc01fc$export$e6127cc7fe7395c3);
$parcel$export(module.exports, "NoContextTokenError", () => $544b3084c7bc01fc$export$ef848c410d399e50);
$parcel$export(module.exports, "InvalidContextToken", () => $544b3084c7bc01fc$export$c4d372dedadd528);
$parcel$export(module.exports, "ExpiredContextTokenError", () => $544b3084c7bc01fc$export$24be319ab5faac74);
$parcel$export(module.exports, "HttpError", () => $544b3084c7bc01fc$export$65bd6083489bd8bb);
$parcel$export(module.exports, "noAccessError", () => $544b3084c7bc01fc$export$85efa378312e74ad);

var $6bnW7 = parcelRequire("6bnW7");
function $544b3084c7bc01fc$export$e6127cc7fe7395c3(error) {
    // If error is not null/undefined, is an object, and has an "error" field string
    return error && typeof error === 'object' && typeof error.error === 'string';
}
const $544b3084c7bc01fc$var$errorMessages = (0, $6bnW7.defineMessages)({
    noContextToken: {
        id: 'error.noContextToken.description',
        defaultMessage: 'No context provided. Please try authorizing again.',
        description: 'The user does not have a context token which means they probably did not land on this site from the expected flow. The user should try going through the authorize flow again.'
    },
    invalidContextToken: {
        id: 'error.invalidContextToken.description',
        defaultMessage: 'Invalid context provided. Please try authorizing again.',
        description: 'The context used is not a valid context. The user should try going through the authorize flow again.'
    },
    expiredContextToken: {
        id: 'error.expiredContextToken.description',
        defaultMessage: 'The session has expired. Please try authorizing again.',
        description: 'The session has taken too long and so it has expired. The user should try going through the authorize flow again.'
    }
});
const $544b3084c7bc01fc$export$ef848c410d399e50 = {
    error: 'unexpected',
    description: $544b3084c7bc01fc$var$errorMessages.noContextToken
};
const $544b3084c7bc01fc$export$c4d372dedadd528 = {
    error: 'unexpected',
    description: $544b3084c7bc01fc$var$errorMessages.invalidContextToken
};
const $544b3084c7bc01fc$export$24be319ab5faac74 = {
    error: 'unexpected',
    description: $544b3084c7bc01fc$var$errorMessages.expiredContextToken
};
class $544b3084c7bc01fc$export$65bd6083489bd8bb extends Error {
    status;
    constructor(status, message, options){
        super(message, options);
        this.status = status;
    }
}
const $544b3084c7bc01fc$export$85efa378312e74ad = {
    error: 'no-access'
};

});
parcelRegister("6bnW7", function(module, exports) {
$parcel$export(module.exports, "defineMessages", () => $0129647dae5e982a$export$1adfeb024f5185b);

var $4txGJ = parcelRequire("4txGJ");




var $bgNpv = parcelRequire("bgNpv");


var $9Pk7k = parcelRequire("9Pk7k");

var $kPiFO = parcelRequire("kPiFO");

var $hrVKU = parcelRequire("hrVKU");

function $0129647dae5e982a$export$1adfeb024f5185b(msgs) {
    return msgs;
}
function $0129647dae5e982a$export$747d244ee58120dd(msg) {
    return msg;
}
var $0129647dae5e982a$export$40ae3194919d16b = (0, $4txGJ.createFormattedComponent)('formatDate');
var $0129647dae5e982a$export$5b390a54f8a846f7 = (0, $4txGJ.createFormattedComponent)('formatTime');
var $0129647dae5e982a$export$db80edc1e6b2f63d = (0, $4txGJ.createFormattedComponent)('formatNumber');
var $0129647dae5e982a$export$f52b44e459e6e71d = (0, $4txGJ.createFormattedComponent)('formatList');
var $0129647dae5e982a$export$c2336ea5aaab92fa = (0, $4txGJ.createFormattedComponent)('formatDisplayName');
var $0129647dae5e982a$export$7fdc7d2c91ce149b = (0, $4txGJ.createFormattedDateTimePartsComponent)('formatDate');
var $0129647dae5e982a$export$ec35873761676c2a = (0, $4txGJ.createFormattedDateTimePartsComponent)('formatTime');

});
parcelRegister("4txGJ", function(module, exports) {
$parcel$export(module.exports, "createFormattedDateTimePartsComponent", () => $342400a1edd754e2$export$7448277f6036d2ab);
$parcel$export(module.exports, "createFormattedComponent", () => $342400a1edd754e2$export$b37e14176d001dec);

var $kJhpj = parcelRequire("kJhpj");

var $5FkrB = parcelRequire("5FkrB");

var $hrVKU = parcelRequire("hrVKU");
var $342400a1edd754e2$var$DisplayName;
(function(DisplayName) {
    DisplayName["formatDate"] = "FormattedDate";
    DisplayName["formatTime"] = "FormattedTime";
    DisplayName["formatNumber"] = "FormattedNumber";
    DisplayName["formatList"] = "FormattedList";
    // Note that this DisplayName is the locale display name, not to be confused with
    // the name of the enum, which is for React component display name in dev tools.
    DisplayName["formatDisplayName"] = "FormattedDisplayName";
})($342400a1edd754e2$var$DisplayName || ($342400a1edd754e2$var$DisplayName = {}));
var $342400a1edd754e2$var$DisplayNameParts;
(function(DisplayNameParts) {
    DisplayNameParts["formatDate"] = "FormattedDateParts";
    DisplayNameParts["formatTime"] = "FormattedTimeParts";
    DisplayNameParts["formatNumber"] = "FormattedNumberParts";
    DisplayNameParts["formatList"] = "FormattedListParts";
})($342400a1edd754e2$var$DisplayNameParts || ($342400a1edd754e2$var$DisplayNameParts = {}));
var $342400a1edd754e2$export$54d4989ed3eea1ea = function(props) {
    var intl = (0, $hrVKU.default)();
    var value = props.value, children = props.children, formatProps = (0, $kJhpj.__rest)(props, [
        "value",
        "children"
    ]);
    return children(intl.formatNumberToParts(value, formatProps));
};
$342400a1edd754e2$export$54d4989ed3eea1ea.displayName = 'FormattedNumberParts';
var $342400a1edd754e2$export$5ac259c7da6d2188 = function(props) {
    var intl = (0, $hrVKU.default)();
    var value = props.value, children = props.children, formatProps = (0, $kJhpj.__rest)(props, [
        "value",
        "children"
    ]);
    return children(intl.formatListToParts(value, formatProps));
};
$342400a1edd754e2$export$54d4989ed3eea1ea.displayName = 'FormattedNumberParts';
function $342400a1edd754e2$export$7448277f6036d2ab(name) {
    var ComponentParts = function(props) {
        var intl = (0, $hrVKU.default)();
        var value = props.value, children = props.children, formatProps = (0, $kJhpj.__rest)(props, [
            "value",
            "children"
        ]);
        var date = typeof value === 'string' ? new Date(value || 0) : value;
        var formattedParts = name === 'formatDate' ? intl.formatDateToParts(date, formatProps) : intl.formatTimeToParts(date, formatProps);
        return children(formattedParts);
    };
    ComponentParts.displayName = $342400a1edd754e2$var$DisplayNameParts[name];
    return ComponentParts;
}
function $342400a1edd754e2$export$b37e14176d001dec(name) {
    var Component = function(props) {
        var intl = (0, $hrVKU.default)();
        var value = props.value, children = props.children, formatProps = (0, $kJhpj.__rest)(props, [
            "value",
            "children"
        ]);
        // TODO: fix TS type definition for localeMatcher upstream
        var formattedValue = intl[name](value, formatProps);
        if (typeof children === 'function') return children(formattedValue);
        var Text = intl.textComponent || $5FkrB.Fragment;
        return $5FkrB.createElement(Text, null, formattedValue);
    };
    Component.displayName = $342400a1edd754e2$var$DisplayName[name];
    return Component;
}

});
parcelRegister("kJhpj", function(module, exports) {
$parcel$export(module.exports, "__extends", () => $f1758352659798e9$export$a8ba968b8961cb8a);
$parcel$export(module.exports, "__assign", () => $f1758352659798e9$export$18ce0697a983be9b);
$parcel$export(module.exports, "__rest", () => $f1758352659798e9$export$3c9a16f847548506);
$parcel$export(module.exports, "__spreadArray", () => $f1758352659798e9$export$1216008129fb82ed);
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol, Iterator */ var $f1758352659798e9$var$extendStatics = function(d, b) {
    $f1758352659798e9$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $f1758352659798e9$var$extendStatics(d, b);
};
function $f1758352659798e9$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $f1758352659798e9$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $f1758352659798e9$export$18ce0697a983be9b = function() {
    $f1758352659798e9$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $f1758352659798e9$export$18ce0697a983be9b.apply(this, arguments);
};
function $f1758352659798e9$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $f1758352659798e9$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $f1758352659798e9$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $f1758352659798e9$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $f1758352659798e9$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $f1758352659798e9$export$6a2a36740a146cb8(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function $f1758352659798e9$export$d1a06452d3489bc7(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $f1758352659798e9$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $f1758352659798e9$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $f1758352659798e9$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $f1758352659798e9$export$45d3717a4c69092e = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $f1758352659798e9$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $f1758352659798e9$export$45d3717a4c69092e(o, m, p);
}
function $f1758352659798e9$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $f1758352659798e9$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $f1758352659798e9$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($f1758352659798e9$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $f1758352659798e9$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $f1758352659798e9$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $f1758352659798e9$export$10c90e4f7922046c(v) {
    return this instanceof $f1758352659798e9$export$10c90e4f7922046c ? (this.v = v, this) : new $f1758352659798e9$export$10c90e4f7922046c(v);
}
function $f1758352659798e9$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = Object.create((typeof AsyncIterator === "function" ? AsyncIterator : Object).prototype), verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function awaitReturn(f) {
        return function(v) {
            return Promise.resolve(v).then(f, reject);
        };
    }
    function verb(n, f) {
        if (g[n]) {
            i[n] = function(v) {
                return new Promise(function(a, b) {
                    q.push([
                        n,
                        v,
                        a,
                        b
                    ]) > 1 || resume(n, v);
                });
            };
            if (f) i[n] = f(i[n]);
        }
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $f1758352659798e9$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $f1758352659798e9$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $f1758352659798e9$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $f1758352659798e9$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $f1758352659798e9$export$19a8beecd37a4c45 === "function" ? $f1758352659798e9$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $f1758352659798e9$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $f1758352659798e9$var$__setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
var $f1758352659798e9$var$ownKeys = function(o) {
    $f1758352659798e9$var$ownKeys = Object.getOwnPropertyNames || function(o) {
        var ar = [];
        for(var k in o)if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
        return ar;
    };
    return $f1758352659798e9$var$ownKeys(o);
};
function $f1758352659798e9$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k = $f1758352659798e9$var$ownKeys(mod), i = 0; i < k.length; i++)if (k[i] !== "default") $f1758352659798e9$export$45d3717a4c69092e(result, mod, k[i]);
    }
    $f1758352659798e9$var$__setModuleDefault(result, mod);
    return result;
}
function $f1758352659798e9$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $f1758352659798e9$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $f1758352659798e9$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $f1758352659798e9$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $f1758352659798e9$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose, inner;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
            if (async) inner = dispose;
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        if (inner) dispose = function() {
            try {
                inner.call(this);
            } catch (e) {
                return Promise.reject(e);
            }
        };
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $f1758352659798e9$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $f1758352659798e9$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $f1758352659798e9$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    var r, s = 0;
    function next() {
        while(r = env.stack.pop())try {
            if (!r.async && s === 1) return s = 0, env.stack.push(r), Promise.resolve().then(next);
            if (r.dispose) {
                var result = r.dispose.call(r.value);
                if (r.async) return s |= 2, Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } else s |= 1;
        } catch (e) {
            fail(e);
        }
        if (s === 1) return env.hasError ? Promise.reject(env.error) : Promise.resolve();
        if (env.hasError) throw env.error;
    }
    return next();
}
function $f1758352659798e9$export$889dfb5d17574b0b(path, preserveJsx) {
    if (typeof path === "string" && /^\.\.?\//.test(path)) return path.replace(/\.(tsx)$|((?:\.d)?)((?:\.[^./]+?)?)\.([cm]?)ts$/i, function(m, tsx, d, ext, cm) {
        return tsx ? preserveJsx ? ".jsx" : ".js" : d && (!ext || !cm) ? m : d + ext + "." + cm.toLowerCase() + "js";
    });
    return path;
}
var $f1758352659798e9$export$2e2bcd8739ae039 = {
    __extends: $f1758352659798e9$export$a8ba968b8961cb8a,
    __assign: $f1758352659798e9$export$18ce0697a983be9b,
    __rest: $f1758352659798e9$export$3c9a16f847548506,
    __decorate: $f1758352659798e9$export$29e00dfd3077644b,
    __param: $f1758352659798e9$export$d5ad3fd78186038f,
    __esDecorate: $f1758352659798e9$export$3a84e1ae4e97e9b0,
    __runInitializers: $f1758352659798e9$export$d831c04e792af3d,
    __propKey: $f1758352659798e9$export$6a2a36740a146cb8,
    __setFunctionName: $f1758352659798e9$export$d1a06452d3489bc7,
    __metadata: $f1758352659798e9$export$f1db080c865becb9,
    __awaiter: $f1758352659798e9$export$1050f835b63b671e,
    __generator: $f1758352659798e9$export$67ebef60e6f28a6,
    __createBinding: $f1758352659798e9$export$45d3717a4c69092e,
    __exportStar: $f1758352659798e9$export$f33643c0debef087,
    __values: $f1758352659798e9$export$19a8beecd37a4c45,
    __read: $f1758352659798e9$export$8d051b38c9118094,
    __spread: $f1758352659798e9$export$afc72e2116322959,
    __spreadArrays: $f1758352659798e9$export$6388937ca91ccae8,
    __spreadArray: $f1758352659798e9$export$1216008129fb82ed,
    __await: $f1758352659798e9$export$10c90e4f7922046c,
    __asyncGenerator: $f1758352659798e9$export$e427f37a30a4de9b,
    __asyncDelegator: $f1758352659798e9$export$bbd80228419bb833,
    __asyncValues: $f1758352659798e9$export$e3b29a3d6162315f,
    __makeTemplateObject: $f1758352659798e9$export$4fb47efe1390b86f,
    __importStar: $f1758352659798e9$export$c21735bcef00d192,
    __importDefault: $f1758352659798e9$export$da59b14a69baef04,
    __classPrivateFieldGet: $f1758352659798e9$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $f1758352659798e9$export$d40a35129aaff81f,
    __classPrivateFieldIn: $f1758352659798e9$export$81fdc39f203e4e04,
    __addDisposableResource: $f1758352659798e9$export$88ac25d8e944e405,
    __disposeResources: $f1758352659798e9$export$8f076105dc360e92,
    __rewriteRelativeImportExtension: $f1758352659798e9$export$889dfb5d17574b0b
};

});

parcelRegister("hrVKU", function(module, exports) {
$parcel$export(module.exports, "default", () => $cb41c259f0d2c9ae$export$2e2bcd8739ae039);

var $5FkrB = parcelRequire("5FkrB");

var $5Kjrj = parcelRequire("5Kjrj");

var $ach6K = parcelRequire("ach6K");
function $cb41c259f0d2c9ae$export$2e2bcd8739ae039() {
    var intl = $5FkrB.useContext((0, $ach6K.Context));
    (0, $5Kjrj.invariantIntlContext)(intl);
    return intl;
}

});
parcelRegister("5Kjrj", function(module, exports) {
$parcel$export(module.exports, "invariant", () => $42f053ec1963a0e6$export$f5708dca728d7177);
$parcel$export(module.exports, "invariantIntlContext", () => $42f053ec1963a0e6$export$45c4bbf6e55bba1f);
$parcel$export(module.exports, "DEFAULT_INTL_CONFIG", () => $42f053ec1963a0e6$export$b52f8d6fc0d47415);
$parcel$export(module.exports, "toKeyedReactNodeArray", () => $42f053ec1963a0e6$export$d2fd241e0b53c057);
$parcel$export(module.exports, "assignUniqueKeysToParts", () => $42f053ec1963a0e6$export$cfec03d26465fa63);
$parcel$export(module.exports, "shallowEqual", () => $42f053ec1963a0e6$export$d36bdfa510afb180);

var $kJhpj = parcelRequire("kJhpj");

var $5FkrB = parcelRequire("5FkrB");

var $ftB2S = parcelRequire("ftB2S");
function $42f053ec1963a0e6$export$f5708dca728d7177(condition, message, Err) {
    if (Err === void 0) Err = Error;
    if (!condition) throw new Err(message);
}
function $42f053ec1963a0e6$export$45c4bbf6e55bba1f(intl) {
    $42f053ec1963a0e6$export$f5708dca728d7177(intl, "[React Intl] Could not find required `intl` object. <IntlProvider> needs to exist in the component ancestry.");
}
var $42f053ec1963a0e6$export$b52f8d6fc0d47415 = (0, $kJhpj.__assign)((0, $kJhpj.__assign)({}, (0, $ftB2S.DEFAULT_INTL_CONFIG)), {
    textComponent: $5FkrB.Fragment
});
var $42f053ec1963a0e6$var$arbitraryKeyProps = {
    key: 42
};
var $42f053ec1963a0e6$var$toArbitrarilyKeyedReactNode = function(reactNode) {
    return $5FkrB.isValidElement(reactNode) ? $5FkrB.createElement($5FkrB.Fragment, $42f053ec1963a0e6$var$arbitraryKeyProps, reactNode) : reactNode;
};
var $42f053ec1963a0e6$export$d2fd241e0b53c057 = function(children) {
    var _a;
    /**
 * Note: {@link React.Children.map} will add its own index-based prefix to
 * every key anyway, so the auto-injected one doesn't even have to be unique.
 * This basically just tells React that it's explicit/intentional.
 */ return (_a = $5FkrB.Children.map(children, $42f053ec1963a0e6$var$toArbitrarilyKeyedReactNode)) !== null && _a !== void 0 ? _a : [];
};
function $42f053ec1963a0e6$export$cfec03d26465fa63(formatXMLElementFn) {
    return function(parts) {
        // eslint-disable-next-line prefer-rest-params
        return formatXMLElementFn($5FkrB.Children.toArray(parts));
    };
}
function $42f053ec1963a0e6$export$d36bdfa510afb180(objA, objB) {
    if (objA === objB) return true;
    if (!objA || !objB) return false;
    var aKeys = Object.keys(objA);
    var bKeys = Object.keys(objB);
    var len = aKeys.length;
    if (bKeys.length !== len) return false;
    for(var i = 0; i < len; i++){
        var key = aKeys[i];
        if (objA[key] !== objB[key] || !Object.prototype.hasOwnProperty.call(objB, key)) return false;
    }
    return true;
}

});
parcelRegister("ftB2S", function(module, exports) {
$parcel$export(module.exports, "invariant", () => $b4464ce91a872efb$export$f5708dca728d7177);
$parcel$export(module.exports, "filterProps", () => $b4464ce91a872efb$export$d697c39a2985a4c);
$parcel$export(module.exports, "DEFAULT_INTL_CONFIG", () => $b4464ce91a872efb$export$b52f8d6fc0d47415);
$parcel$export(module.exports, "createIntlCache", () => $b4464ce91a872efb$export$51c4f4e973f2dc00);
$parcel$export(module.exports, "createFormatters", () => $b4464ce91a872efb$export$c3f4cd5551df13fd);
$parcel$export(module.exports, "getNamedFormat", () => $b4464ce91a872efb$export$4ee1db8ce44a209b);

var $kJhpj = parcelRequire("kJhpj");

var $pW1k6 = parcelRequire("pW1k6");
parcelRequire("kIHPs");
var $9exF4 = parcelRequire("9exF4");

var $lxO85 = parcelRequire("lxO85");
function $b4464ce91a872efb$export$f5708dca728d7177(condition, message, Err) {
    if (Err === void 0) Err = Error;
    if (!condition) throw new Err(message);
}
function $b4464ce91a872efb$export$d697c39a2985a4c(props, allowlist, defaults) {
    if (defaults === void 0) defaults = {};
    return allowlist.reduce(function(filtered, name) {
        if (name in props) filtered[name] = props[name];
        else if (name in defaults) filtered[name] = defaults[name];
        return filtered;
    }, {});
}
var $b4464ce91a872efb$var$defaultErrorHandler = function(error) {};
var $b4464ce91a872efb$var$defaultWarnHandler = function(warning) {};
var $b4464ce91a872efb$export$b52f8d6fc0d47415 = {
    formats: {},
    messages: {},
    timeZone: undefined,
    defaultLocale: 'en',
    defaultFormats: {},
    fallbackOnEmptyString: true,
    onError: $b4464ce91a872efb$var$defaultErrorHandler,
    onWarn: $b4464ce91a872efb$var$defaultWarnHandler
};
function $b4464ce91a872efb$export$51c4f4e973f2dc00() {
    return {
        dateTime: {},
        number: {},
        message: {},
        relativeTime: {},
        pluralRules: {},
        list: {},
        displayNames: {}
    };
}
function $b4464ce91a872efb$var$createFastMemoizeCache(store) {
    return {
        create: function() {
            return {
                get: function(key) {
                    return store[key];
                },
                set: function(key, value) {
                    store[key] = value;
                }
            };
        }
    };
}
function $b4464ce91a872efb$export$c3f4cd5551df13fd(cache) {
    if (cache === void 0) cache = $b4464ce91a872efb$export$51c4f4e973f2dc00();
    var RelativeTimeFormat = Intl.RelativeTimeFormat;
    var ListFormat = Intl.ListFormat;
    var DisplayNames = Intl.DisplayNames;
    var getDateTimeFormat = (0, $pW1k6.memoize)(function() {
        var _a;
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        return new ((_a = Intl.DateTimeFormat).bind.apply(_a, (0, $kJhpj.__spreadArray)([
            void 0
        ], args, false)))();
    }, {
        cache: $b4464ce91a872efb$var$createFastMemoizeCache(cache.dateTime),
        strategy: (0, $pW1k6.strategies).variadic
    });
    var getNumberFormat = (0, $pW1k6.memoize)(function() {
        var _a;
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        return new ((_a = Intl.NumberFormat).bind.apply(_a, (0, $kJhpj.__spreadArray)([
            void 0
        ], args, false)))();
    }, {
        cache: $b4464ce91a872efb$var$createFastMemoizeCache(cache.number),
        strategy: (0, $pW1k6.strategies).variadic
    });
    var getPluralRules = (0, $pW1k6.memoize)(function() {
        var _a;
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        return new ((_a = Intl.PluralRules).bind.apply(_a, (0, $kJhpj.__spreadArray)([
            void 0
        ], args, false)))();
    }, {
        cache: $b4464ce91a872efb$var$createFastMemoizeCache(cache.pluralRules),
        strategy: (0, $pW1k6.strategies).variadic
    });
    return {
        getDateTimeFormat: getDateTimeFormat,
        getNumberFormat: getNumberFormat,
        getMessageFormat: (0, $pW1k6.memoize)(function(message, locales, overrideFormats, opts) {
            return new (0, $9exF4.IntlMessageFormat)(message, locales, overrideFormats, (0, $kJhpj.__assign)({
                formatters: {
                    getNumberFormat: getNumberFormat,
                    getDateTimeFormat: getDateTimeFormat,
                    getPluralRules: getPluralRules
                }
            }, opts || {}));
        }, {
            cache: $b4464ce91a872efb$var$createFastMemoizeCache(cache.message),
            strategy: (0, $pW1k6.strategies).variadic
        }),
        getRelativeTimeFormat: (0, $pW1k6.memoize)(function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new (RelativeTimeFormat.bind.apply(RelativeTimeFormat, (0, $kJhpj.__spreadArray)([
                void 0
            ], args, false)))();
        }, {
            cache: $b4464ce91a872efb$var$createFastMemoizeCache(cache.relativeTime),
            strategy: (0, $pW1k6.strategies).variadic
        }),
        getPluralRules: getPluralRules,
        getListFormat: (0, $pW1k6.memoize)(function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new (ListFormat.bind.apply(ListFormat, (0, $kJhpj.__spreadArray)([
                void 0
            ], args, false)))();
        }, {
            cache: $b4464ce91a872efb$var$createFastMemoizeCache(cache.list),
            strategy: (0, $pW1k6.strategies).variadic
        }),
        getDisplayNames: (0, $pW1k6.memoize)(function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new (DisplayNames.bind.apply(DisplayNames, (0, $kJhpj.__spreadArray)([
                void 0
            ], args, false)))();
        }, {
            cache: $b4464ce91a872efb$var$createFastMemoizeCache(cache.displayNames),
            strategy: (0, $pW1k6.strategies).variadic
        })
    };
}
function $b4464ce91a872efb$export$4ee1db8ce44a209b(formats, type, name, onError) {
    var formatType = formats && formats[type];
    var format;
    if (formatType) format = formatType[name];
    if (format) return format;
    onError(new (0, $lxO85.UnsupportedFormatterError)("No ".concat(type, " format named: ").concat(name)));
}

});
parcelRegister("pW1k6", function(module, exports) {
$parcel$export(module.exports, "memoize", () => $04df578bb1e82bb6$export$fc10aeed3a532e2a);
$parcel$export(module.exports, "strategies", () => $04df578bb1e82bb6$export$c5491a8691a23b9e);
//
// Main
//
function $04df578bb1e82bb6$export$fc10aeed3a532e2a(fn, options) {
    var cache = options && options.cache ? options.cache : $04df578bb1e82bb6$var$cacheDefault;
    var serializer = options && options.serializer ? options.serializer : $04df578bb1e82bb6$var$serializerDefault;
    var strategy = options && options.strategy ? options.strategy : $04df578bb1e82bb6$var$strategyDefault;
    return strategy(fn, {
        cache: cache,
        serializer: serializer
    });
}
//
// Strategy
//
function $04df578bb1e82bb6$var$isPrimitive(value) {
    return value == null || typeof value === 'number' || typeof value === 'boolean'; // || typeof value === "string" 'unsafe' primitive for our needs
}
function $04df578bb1e82bb6$var$monadic(fn, cache, serializer, arg) {
    var cacheKey = $04df578bb1e82bb6$var$isPrimitive(arg) ? arg : serializer(arg);
    var computedValue = cache.get(cacheKey);
    if (typeof computedValue === 'undefined') {
        computedValue = fn.call(this, arg);
        cache.set(cacheKey, computedValue);
    }
    return computedValue;
}
function $04df578bb1e82bb6$var$variadic(fn, cache, serializer) {
    var args = Array.prototype.slice.call(arguments, 3);
    var cacheKey = serializer(args);
    var computedValue = cache.get(cacheKey);
    if (typeof computedValue === 'undefined') {
        computedValue = fn.apply(this, args);
        cache.set(cacheKey, computedValue);
    }
    return computedValue;
}
function $04df578bb1e82bb6$var$assemble(fn, context, strategy, cache, serialize) {
    return strategy.bind(context, fn, cache, serialize);
}
function $04df578bb1e82bb6$var$strategyDefault(fn, options) {
    var strategy = fn.length === 1 ? $04df578bb1e82bb6$var$monadic : $04df578bb1e82bb6$var$variadic;
    return $04df578bb1e82bb6$var$assemble(fn, this, strategy, options.cache.create(), options.serializer);
}
function $04df578bb1e82bb6$var$strategyVariadic(fn, options) {
    return $04df578bb1e82bb6$var$assemble(fn, this, $04df578bb1e82bb6$var$variadic, options.cache.create(), options.serializer);
}
function $04df578bb1e82bb6$var$strategyMonadic(fn, options) {
    return $04df578bb1e82bb6$var$assemble(fn, this, $04df578bb1e82bb6$var$monadic, options.cache.create(), options.serializer);
}
//
// Serializer
//
var $04df578bb1e82bb6$var$serializerDefault = function() {
    return JSON.stringify(arguments);
};
//
// Cache
//
var $04df578bb1e82bb6$var$ObjectWithoutPrototypeCache = /** @class */ function() {
    function ObjectWithoutPrototypeCache() {
        this.cache = Object.create(null);
    }
    ObjectWithoutPrototypeCache.prototype.get = function(key) {
        return this.cache[key];
    };
    ObjectWithoutPrototypeCache.prototype.set = function(key, value) {
        this.cache[key] = value;
    };
    return ObjectWithoutPrototypeCache;
}();
var $04df578bb1e82bb6$var$cacheDefault = {
    create: function create() {
        return new $04df578bb1e82bb6$var$ObjectWithoutPrototypeCache();
    }
};
var $04df578bb1e82bb6$export$c5491a8691a23b9e = {
    variadic: $04df578bb1e82bb6$var$strategyVariadic,
    monadic: $04df578bb1e82bb6$var$strategyMonadic
};

});

parcelRegister("kIHPs", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "ErrorCode", () => (parcelRequire("jpwqX")).ErrorCode);
$parcel$export(module.exports, "FormatError", () => (parcelRequire("jpwqX")).FormatError);
$parcel$export(module.exports, "isFormatXMLElementFn", () => (parcelRequire("b1zcR")).isFormatXMLElementFn);
$parcel$export(module.exports, "IntlMessageFormat", () => (parcelRequire("9exF4")).IntlMessageFormat);
/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/ 
var $9exF4 = parcelRequire("9exF4");
parcelRequire("jpwqX");
parcelRequire("b1zcR");
var $f159ea36570c585e$export$2e2bcd8739ae039 = (0, $9exF4.IntlMessageFormat);

});
parcelRegister("9exF4", function(module, exports) {
$parcel$export(module.exports, "IntlMessageFormat", () => $6b8f88550973e494$export$d342343268debc40);
/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/ 
var $kJhpj = parcelRequire("kJhpj");

var $pW1k6 = parcelRequire("pW1k6");

var $6dpFj = parcelRequire("6dpFj");

var $b1zcR = parcelRequire("b1zcR");
// -- MessageFormat --------------------------------------------------------
function $6b8f88550973e494$var$mergeConfig(c1, c2) {
    if (!c2) return c1;
    return (0, $kJhpj.__assign)((0, $kJhpj.__assign)((0, $kJhpj.__assign)({}, c1 || {}), c2 || {}), Object.keys(c1).reduce(function(all, k) {
        all[k] = (0, $kJhpj.__assign)((0, $kJhpj.__assign)({}, c1[k]), c2[k] || {});
        return all;
    }, {}));
}
function $6b8f88550973e494$var$mergeConfigs(defaultConfig, configs) {
    if (!configs) return defaultConfig;
    return Object.keys(defaultConfig).reduce(function(all, k) {
        all[k] = $6b8f88550973e494$var$mergeConfig(defaultConfig[k], configs[k]);
        return all;
    }, (0, $kJhpj.__assign)({}, defaultConfig));
}
function $6b8f88550973e494$var$createFastMemoizeCache(store) {
    return {
        create: function() {
            return {
                get: function(key) {
                    return store[key];
                },
                set: function(key, value) {
                    store[key] = value;
                }
            };
        }
    };
}
function $6b8f88550973e494$var$createDefaultFormatters(cache) {
    if (cache === void 0) cache = {
        number: {},
        dateTime: {},
        pluralRules: {}
    };
    return {
        getNumberFormat: (0, $pW1k6.memoize)(function() {
            var _a;
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new ((_a = Intl.NumberFormat).bind.apply(_a, (0, $kJhpj.__spreadArray)([
                void 0
            ], args, false)))();
        }, {
            cache: $6b8f88550973e494$var$createFastMemoizeCache(cache.number),
            strategy: (0, $pW1k6.strategies).variadic
        }),
        getDateTimeFormat: (0, $pW1k6.memoize)(function() {
            var _a;
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new ((_a = Intl.DateTimeFormat).bind.apply(_a, (0, $kJhpj.__spreadArray)([
                void 0
            ], args, false)))();
        }, {
            cache: $6b8f88550973e494$var$createFastMemoizeCache(cache.dateTime),
            strategy: (0, $pW1k6.strategies).variadic
        }),
        getPluralRules: (0, $pW1k6.memoize)(function() {
            var _a;
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new ((_a = Intl.PluralRules).bind.apply(_a, (0, $kJhpj.__spreadArray)([
                void 0
            ], args, false)))();
        }, {
            cache: $6b8f88550973e494$var$createFastMemoizeCache(cache.pluralRules),
            strategy: (0, $pW1k6.strategies).variadic
        })
    };
}
var $6b8f88550973e494$export$d342343268debc40 = /** @class */ function() {
    function IntlMessageFormat(message, locales, overrideFormats, opts) {
        if (locales === void 0) locales = IntlMessageFormat.defaultLocale;
        var _this = this;
        this.formatterCache = {
            number: {},
            dateTime: {},
            pluralRules: {}
        };
        this.format = function(values) {
            var parts = _this.formatToParts(values);
            // Hot path for straight simple msg translations
            if (parts.length === 1) return parts[0].value;
            var result = parts.reduce(function(all, part) {
                if (!all.length || part.type !== (0, $b1zcR.PART_TYPE).literal || typeof all[all.length - 1] !== 'string') all.push(part.value);
                else all[all.length - 1] += part.value;
                return all;
            }, []);
            if (result.length <= 1) return result[0] || '';
            return result;
        };
        this.formatToParts = function(values) {
            return (0, $b1zcR.formatToParts)(_this.ast, _this.locales, _this.formatters, _this.formats, values, undefined, _this.message);
        };
        this.resolvedOptions = function() {
            var _a;
            return {
                locale: ((_a = _this.resolvedLocale) === null || _a === void 0 ? void 0 : _a.toString()) || Intl.NumberFormat.supportedLocalesOf(_this.locales)[0]
            };
        };
        this.getAst = function() {
            return _this.ast;
        };
        // Defined first because it's used to build the format pattern.
        this.locales = locales;
        this.resolvedLocale = IntlMessageFormat.resolveLocale(locales);
        if (typeof message === 'string') {
            this.message = message;
            if (!IntlMessageFormat.__parse) throw new TypeError('IntlMessageFormat.__parse must be set to process `message` of type `string`');
            var _a = opts || {}, formatters = _a.formatters, parseOpts = (0, $kJhpj.__rest)(_a, [
                "formatters"
            ]);
            // Parse string messages into an AST.
            this.ast = IntlMessageFormat.__parse(message, (0, $kJhpj.__assign)((0, $kJhpj.__assign)({}, parseOpts), {
                locale: this.resolvedLocale
            }));
        } else this.ast = message;
        if (!Array.isArray(this.ast)) throw new TypeError('A message must be provided as a String or AST.');
        // Creates a new object with the specified `formats` merged with the default
        // formats.
        this.formats = $6b8f88550973e494$var$mergeConfigs(IntlMessageFormat.formats, overrideFormats);
        this.formatters = opts && opts.formatters || $6b8f88550973e494$var$createDefaultFormatters(this.formatterCache);
    }
    Object.defineProperty(IntlMessageFormat, "defaultLocale", {
        get: function() {
            if (!IntlMessageFormat.memoizedDefaultLocale) IntlMessageFormat.memoizedDefaultLocale = new Intl.NumberFormat().resolvedOptions().locale;
            return IntlMessageFormat.memoizedDefaultLocale;
        },
        enumerable: false,
        configurable: true
    });
    IntlMessageFormat.memoizedDefaultLocale = null;
    IntlMessageFormat.resolveLocale = function(locales) {
        if (typeof Intl.Locale === 'undefined') return;
        var supportedLocales = Intl.NumberFormat.supportedLocalesOf(locales);
        if (supportedLocales.length > 0) return new Intl.Locale(supportedLocales[0]);
        return new Intl.Locale(typeof locales === 'string' ? locales : locales[0]);
    };
    IntlMessageFormat.__parse = (0, $6dpFj.parse);
    // Default format options used as the prototype of the `formats` provided to the
    // constructor. These are used when constructing the internal Intl.NumberFormat
    // and Intl.DateTimeFormat instances.
    IntlMessageFormat.formats = {
        number: {
            integer: {
                maximumFractionDigits: 0
            },
            currency: {
                style: 'currency'
            },
            percent: {
                style: 'percent'
            }
        },
        date: {
            short: {
                month: 'numeric',
                day: 'numeric',
                year: '2-digit'
            },
            medium: {
                month: 'short',
                day: 'numeric',
                year: 'numeric'
            },
            long: {
                month: 'long',
                day: 'numeric',
                year: 'numeric'
            },
            full: {
                weekday: 'long',
                month: 'long',
                day: 'numeric',
                year: 'numeric'
            }
        },
        time: {
            short: {
                hour: 'numeric',
                minute: 'numeric'
            },
            medium: {
                hour: 'numeric',
                minute: 'numeric',
                second: 'numeric'
            },
            long: {
                hour: 'numeric',
                minute: 'numeric',
                second: 'numeric',
                timeZoneName: 'short'
            },
            full: {
                hour: 'numeric',
                minute: 'numeric',
                second: 'numeric',
                timeZoneName: 'short'
            }
        }
    };
    return IntlMessageFormat;
}();

});
parcelRegister("6dpFj", function(module, exports) {
$parcel$export(module.exports, "isArgumentElement", () => (parcelRequire("4VghZ")).isArgumentElement);
$parcel$export(module.exports, "isDateElement", () => (parcelRequire("4VghZ")).isDateElement);
$parcel$export(module.exports, "isDateTimeSkeleton", () => (parcelRequire("4VghZ")).isDateTimeSkeleton);
$parcel$export(module.exports, "isLiteralElement", () => (parcelRequire("4VghZ")).isLiteralElement);
$parcel$export(module.exports, "isNumberElement", () => (parcelRequire("4VghZ")).isNumberElement);
$parcel$export(module.exports, "isNumberSkeleton", () => (parcelRequire("4VghZ")).isNumberSkeleton);
$parcel$export(module.exports, "isPluralElement", () => (parcelRequire("4VghZ")).isPluralElement);
$parcel$export(module.exports, "isPoundElement", () => (parcelRequire("4VghZ")).isPoundElement);
$parcel$export(module.exports, "isSelectElement", () => (parcelRequire("4VghZ")).isSelectElement);
$parcel$export(module.exports, "isTagElement", () => (parcelRequire("4VghZ")).isTagElement);
$parcel$export(module.exports, "isTimeElement", () => (parcelRequire("4VghZ")).isTimeElement);
$parcel$export(module.exports, "TYPE", () => (parcelRequire("4VghZ")).TYPE);
$parcel$export(module.exports, "parse", () => $4867dd96a90c056b$export$98e6a39c04603d36);

var $kJhpj = parcelRequire("kJhpj");

var $1qhWu = parcelRequire("1qhWu");

var $5DR7r = parcelRequire("5DR7r");

var $4VghZ = parcelRequire("4VghZ");

var $fqZ2A = parcelRequire("fqZ2A");
function $4867dd96a90c056b$var$pruneLocation(els) {
    els.forEach(function(el) {
        delete el.location;
        if ((0, $4VghZ.isSelectElement)(el) || (0, $4VghZ.isPluralElement)(el)) for(var k in el.options){
            delete el.options[k].location;
            $4867dd96a90c056b$var$pruneLocation(el.options[k].value);
        }
        else if ((0, $4VghZ.isNumberElement)(el) && (0, $4VghZ.isNumberSkeleton)(el.style)) delete el.style.location;
        else if (((0, $4VghZ.isDateElement)(el) || (0, $4VghZ.isTimeElement)(el)) && (0, $4VghZ.isDateTimeSkeleton)(el.style)) delete el.style.location;
        else if ((0, $4VghZ.isTagElement)(el)) $4867dd96a90c056b$var$pruneLocation(el.children);
    });
}
function $4867dd96a90c056b$export$98e6a39c04603d36(message, opts) {
    if (opts === void 0) opts = {};
    opts = (0, $kJhpj.__assign)({
        shouldParseSkeletons: true,
        requiresOtherClause: true
    }, opts);
    var result = new (0, $5DR7r.Parser)(message, opts).parse();
    if (result.err) {
        var error = SyntaxError((0, $1qhWu.ErrorKind)[result.err.kind]);
        // @ts-expect-error Assign to error object
        error.location = result.err.location;
        // @ts-expect-error Assign to error object
        error.originalMessage = result.err.message;
        throw error;
    }
    if (!(opts === null || opts === void 0 ? void 0 : opts.captureLocation)) $4867dd96a90c056b$var$pruneLocation(result.val);
    return result.val;
}
var $4867dd96a90c056b$export$d3c1bfa0f7d806e9 = (0, $5DR7r.Parser);

});
parcelRegister("1qhWu", function(module, exports) {
$parcel$export(module.exports, "ErrorKind", () => $109623254d5d054c$export$896afd8541959ee5);
var $109623254d5d054c$export$896afd8541959ee5;
(function(ErrorKind) {
    /** Argument is unclosed (e.g. `{0`) */ ErrorKind[ErrorKind["EXPECT_ARGUMENT_CLOSING_BRACE"] = 1] = "EXPECT_ARGUMENT_CLOSING_BRACE";
    /** Argument is empty (e.g. `{}`). */ ErrorKind[ErrorKind["EMPTY_ARGUMENT"] = 2] = "EMPTY_ARGUMENT";
    /** Argument is malformed (e.g. `{foo!}``) */ ErrorKind[ErrorKind["MALFORMED_ARGUMENT"] = 3] = "MALFORMED_ARGUMENT";
    /** Expect an argument type (e.g. `{foo,}`) */ ErrorKind[ErrorKind["EXPECT_ARGUMENT_TYPE"] = 4] = "EXPECT_ARGUMENT_TYPE";
    /** Unsupported argument type (e.g. `{foo,foo}`) */ ErrorKind[ErrorKind["INVALID_ARGUMENT_TYPE"] = 5] = "INVALID_ARGUMENT_TYPE";
    /** Expect an argument style (e.g. `{foo, number, }`) */ ErrorKind[ErrorKind["EXPECT_ARGUMENT_STYLE"] = 6] = "EXPECT_ARGUMENT_STYLE";
    /** The number skeleton is invalid. */ ErrorKind[ErrorKind["INVALID_NUMBER_SKELETON"] = 7] = "INVALID_NUMBER_SKELETON";
    /** The date time skeleton is invalid. */ ErrorKind[ErrorKind["INVALID_DATE_TIME_SKELETON"] = 8] = "INVALID_DATE_TIME_SKELETON";
    /** Exepct a number skeleton following the `::` (e.g. `{foo, number, ::}`) */ ErrorKind[ErrorKind["EXPECT_NUMBER_SKELETON"] = 9] = "EXPECT_NUMBER_SKELETON";
    /** Exepct a date time skeleton following the `::` (e.g. `{foo, date, ::}`) */ ErrorKind[ErrorKind["EXPECT_DATE_TIME_SKELETON"] = 10] = "EXPECT_DATE_TIME_SKELETON";
    /** Unmatched apostrophes in the argument style (e.g. `{foo, number, 'test`) */ ErrorKind[ErrorKind["UNCLOSED_QUOTE_IN_ARGUMENT_STYLE"] = 11] = "UNCLOSED_QUOTE_IN_ARGUMENT_STYLE";
    /** Missing select argument options (e.g. `{foo, select}`) */ ErrorKind[ErrorKind["EXPECT_SELECT_ARGUMENT_OPTIONS"] = 12] = "EXPECT_SELECT_ARGUMENT_OPTIONS";
    /** Expecting an offset value in `plural` or `selectordinal` argument (e.g `{foo, plural, offset}`) */ ErrorKind[ErrorKind["EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE"] = 13] = "EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE";
    /** Offset value in `plural` or `selectordinal` is invalid (e.g. `{foo, plural, offset: x}`) */ ErrorKind[ErrorKind["INVALID_PLURAL_ARGUMENT_OFFSET_VALUE"] = 14] = "INVALID_PLURAL_ARGUMENT_OFFSET_VALUE";
    /** Expecting a selector in `select` argument (e.g `{foo, select}`) */ ErrorKind[ErrorKind["EXPECT_SELECT_ARGUMENT_SELECTOR"] = 15] = "EXPECT_SELECT_ARGUMENT_SELECTOR";
    /** Expecting a selector in `plural` or `selectordinal` argument (e.g `{foo, plural}`) */ ErrorKind[ErrorKind["EXPECT_PLURAL_ARGUMENT_SELECTOR"] = 16] = "EXPECT_PLURAL_ARGUMENT_SELECTOR";
    /** Expecting a message fragment after the `select` selector (e.g. `{foo, select, apple}`) */ ErrorKind[ErrorKind["EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT"] = 17] = "EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT";
    /**
     * Expecting a message fragment after the `plural` or `selectordinal` selector
     * (e.g. `{foo, plural, one}`)
     */ ErrorKind[ErrorKind["EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT"] = 18] = "EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT";
    /** Selector in `plural` or `selectordinal` is malformed (e.g. `{foo, plural, =x {#}}`) */ ErrorKind[ErrorKind["INVALID_PLURAL_ARGUMENT_SELECTOR"] = 19] = "INVALID_PLURAL_ARGUMENT_SELECTOR";
    /**
     * Duplicate selectors in `plural` or `selectordinal` argument.
     * (e.g. {foo, plural, one {#} one {#}})
     */ ErrorKind[ErrorKind["DUPLICATE_PLURAL_ARGUMENT_SELECTOR"] = 20] = "DUPLICATE_PLURAL_ARGUMENT_SELECTOR";
    /** Duplicate selectors in `select` argument.
     * (e.g. {foo, select, apple {apple} apple {apple}})
     */ ErrorKind[ErrorKind["DUPLICATE_SELECT_ARGUMENT_SELECTOR"] = 21] = "DUPLICATE_SELECT_ARGUMENT_SELECTOR";
    /** Plural or select argument option must have `other` clause. */ ErrorKind[ErrorKind["MISSING_OTHER_CLAUSE"] = 22] = "MISSING_OTHER_CLAUSE";
    /** The tag is malformed. (e.g. `<bold!>foo</bold!>) */ ErrorKind[ErrorKind["INVALID_TAG"] = 23] = "INVALID_TAG";
    /** The tag name is invalid. (e.g. `<123>foo</123>`) */ ErrorKind[ErrorKind["INVALID_TAG_NAME"] = 25] = "INVALID_TAG_NAME";
    /** The closing tag does not match the opening tag. (e.g. `<bold>foo</italic>`) */ ErrorKind[ErrorKind["UNMATCHED_CLOSING_TAG"] = 26] = "UNMATCHED_CLOSING_TAG";
    /** The opening tag has unmatched closing tag. (e.g. `<bold>foo`) */ ErrorKind[ErrorKind["UNCLOSED_TAG"] = 27] = "UNCLOSED_TAG";
})($109623254d5d054c$export$896afd8541959ee5 || ($109623254d5d054c$export$896afd8541959ee5 = {}));

});

parcelRegister("5DR7r", function(module, exports) {
$parcel$export(module.exports, "Parser", () => $41b9cca01985965f$export$7acfa6ed01010e37);

var $kJhpj = parcelRequire("kJhpj");

var $1qhWu = parcelRequire("1qhWu");

var $4VghZ = parcelRequire("4VghZ");

var $1tlBf = parcelRequire("1tlBf");
parcelRequire("3Uiry");
var $aYwqB = parcelRequire("aYwqB");
var $4f4OJ = parcelRequire("4f4OJ");

var $h8PxH = parcelRequire("h8PxH");
var $41b9cca01985965f$var$_a;
var $41b9cca01985965f$var$SPACE_SEPARATOR_START_REGEX = new RegExp("^".concat((0, $1tlBf.SPACE_SEPARATOR_REGEX).source, "*"));
var $41b9cca01985965f$var$SPACE_SEPARATOR_END_REGEX = new RegExp("".concat((0, $1tlBf.SPACE_SEPARATOR_REGEX).source, "*$"));
function $41b9cca01985965f$var$createLocation(start, end) {
    return {
        start: start,
        end: end
    };
}
// #region Ponyfills
// Consolidate these variables up top for easier toggling during debugging
var $41b9cca01985965f$var$hasNativeStartsWith = !!String.prototype.startsWith && '_a'.startsWith('a', 1);
var $41b9cca01985965f$var$hasNativeFromCodePoint = !!String.fromCodePoint;
var $41b9cca01985965f$var$hasNativeFromEntries = !!Object.fromEntries;
var $41b9cca01985965f$var$hasNativeCodePointAt = !!String.prototype.codePointAt;
var $41b9cca01985965f$var$hasTrimStart = !!String.prototype.trimStart;
var $41b9cca01985965f$var$hasTrimEnd = !!String.prototype.trimEnd;
var $41b9cca01985965f$var$hasNativeIsSafeInteger = !!Number.isSafeInteger;
var $41b9cca01985965f$var$isSafeInteger = $41b9cca01985965f$var$hasNativeIsSafeInteger ? Number.isSafeInteger : function(n) {
    return typeof n === 'number' && isFinite(n) && Math.floor(n) === n && Math.abs(n) <= 0x1fffffffffffff;
};
// IE11 does not support y and u.
var $41b9cca01985965f$var$REGEX_SUPPORTS_U_AND_Y = true;
try {
    var $41b9cca01985965f$var$re = $41b9cca01985965f$var$RE('([^\\p{White_Space}\\p{Pattern_Syntax}]*)', 'yu');
    /**
     * legacy Edge or Xbox One browser
     * Unicode flag support: supported
     * Pattern_Syntax support: not supported
     * See https://github.com/formatjs/formatjs/issues/2822
     */ $41b9cca01985965f$var$REGEX_SUPPORTS_U_AND_Y = (($41b9cca01985965f$var$_a = $41b9cca01985965f$var$re.exec('a')) === null || $41b9cca01985965f$var$_a === void 0 ? void 0 : $41b9cca01985965f$var$_a[0]) === 'a';
} catch (_) {
    $41b9cca01985965f$var$REGEX_SUPPORTS_U_AND_Y = false;
}
var $41b9cca01985965f$var$startsWith = $41b9cca01985965f$var$hasNativeStartsWith ? function startsWith(s, search, position) {
    return s.startsWith(search, position);
} : function startsWith(s, search, position) {
    return s.slice(position, position + search.length) === search;
};
var $41b9cca01985965f$var$fromCodePoint = $41b9cca01985965f$var$hasNativeFromCodePoint ? String.fromCodePoint : function fromCodePoint() {
    var codePoints = [];
    for(var _i = 0; _i < arguments.length; _i++)codePoints[_i] = arguments[_i];
    var elements = '';
    var length = codePoints.length;
    var i = 0;
    var code;
    while(length > i){
        code = codePoints[i++];
        if (code > 0x10ffff) throw RangeError(code + ' is not a valid code point');
        elements += code < 0x10000 ? String.fromCharCode(code) : String.fromCharCode(((code -= 0x10000) >> 10) + 0xd800, code % 0x400 + 0xdc00);
    }
    return elements;
};
var $41b9cca01985965f$var$fromEntries = // native
$41b9cca01985965f$var$hasNativeFromEntries ? Object.fromEntries : function fromEntries(entries) {
    var obj = {};
    for(var _i = 0, entries_1 = entries; _i < entries_1.length; _i++){
        var _a = entries_1[_i], k = _a[0], v = _a[1];
        obj[k] = v;
    }
    return obj;
};
var $41b9cca01985965f$var$codePointAt = $41b9cca01985965f$var$hasNativeCodePointAt ? function codePointAt(s, index) {
    return s.codePointAt(index);
} : function codePointAt(s, index) {
    var size = s.length;
    if (index < 0 || index >= size) return undefined;
    var first = s.charCodeAt(index);
    var second;
    return first < 0xd800 || first > 0xdbff || index + 1 === size || (second = s.charCodeAt(index + 1)) < 0xdc00 || second > 0xdfff ? first : (first - 0xd800 << 10) + (second - 0xdc00) + 0x10000;
};
var $41b9cca01985965f$var$trimStart = $41b9cca01985965f$var$hasTrimStart ? function trimStart(s) {
    return s.trimStart();
} : function trimStart(s) {
    return s.replace($41b9cca01985965f$var$SPACE_SEPARATOR_START_REGEX, '');
};
var $41b9cca01985965f$var$trimEnd = $41b9cca01985965f$var$hasTrimEnd ? function trimEnd(s) {
    return s.trimEnd();
} : function trimEnd(s) {
    return s.replace($41b9cca01985965f$var$SPACE_SEPARATOR_END_REGEX, '');
};
// Prevent minifier to translate new RegExp to literal form that might cause syntax error on IE11.
function $41b9cca01985965f$var$RE(s, flag) {
    return new RegExp(s, flag);
}
// #endregion
var $41b9cca01985965f$var$matchIdentifierAtIndex;
if ($41b9cca01985965f$var$REGEX_SUPPORTS_U_AND_Y) {
    // Native
    var $41b9cca01985965f$var$IDENTIFIER_PREFIX_RE_1 = $41b9cca01985965f$var$RE('([^\\p{White_Space}\\p{Pattern_Syntax}]*)', 'yu');
    $41b9cca01985965f$var$matchIdentifierAtIndex = function matchIdentifierAtIndex(s, index) {
        var _a;
        $41b9cca01985965f$var$IDENTIFIER_PREFIX_RE_1.lastIndex = index;
        var match = $41b9cca01985965f$var$IDENTIFIER_PREFIX_RE_1.exec(s);
        return (_a = match[1]) !== null && _a !== void 0 ? _a : '';
    };
} else // IE11
$41b9cca01985965f$var$matchIdentifierAtIndex = function matchIdentifierAtIndex(s, index) {
    var match = [];
    while(true){
        var c = $41b9cca01985965f$var$codePointAt(s, index);
        if (c === undefined || $41b9cca01985965f$var$_isWhiteSpace(c) || $41b9cca01985965f$var$_isPatternSyntax(c)) break;
        match.push(c);
        index += c >= 0x10000 ? 2 : 1;
    }
    return $41b9cca01985965f$var$fromCodePoint.apply(void 0, match);
};
var $41b9cca01985965f$export$7acfa6ed01010e37 = /** @class */ function() {
    function Parser(message, options) {
        if (options === void 0) options = {};
        this.message = message;
        this.position = {
            offset: 0,
            line: 1,
            column: 1
        };
        this.ignoreTag = !!options.ignoreTag;
        this.locale = options.locale;
        this.requiresOtherClause = !!options.requiresOtherClause;
        this.shouldParseSkeletons = !!options.shouldParseSkeletons;
    }
    Parser.prototype.parse = function() {
        if (this.offset() !== 0) throw Error('parser can only be used once');
        return this.parseMessage(0, '', false);
    };
    Parser.prototype.parseMessage = function(nestingLevel, parentArgType, expectingCloseTag) {
        var elements = [];
        while(!this.isEOF()){
            var char = this.char();
            if (char === 123 /* `{` */ ) {
                var result = this.parseArgument(nestingLevel, expectingCloseTag);
                if (result.err) return result;
                elements.push(result.val);
            } else if (char === 125 /* `}` */  && nestingLevel > 0) break;
            else if (char === 35 /* `#` */  && (parentArgType === 'plural' || parentArgType === 'selectordinal')) {
                var position = this.clonePosition();
                this.bump();
                elements.push({
                    type: (0, $4VghZ.TYPE).pound,
                    location: $41b9cca01985965f$var$createLocation(position, this.clonePosition())
                });
            } else if (char === 60 /* `<` */  && !this.ignoreTag && this.peek() === 47 // char code for '/'
            ) {
                if (expectingCloseTag) break;
                else return this.error((0, $1qhWu.ErrorKind).UNMATCHED_CLOSING_TAG, $41b9cca01985965f$var$createLocation(this.clonePosition(), this.clonePosition()));
            } else if (char === 60 /* `<` */  && !this.ignoreTag && $41b9cca01985965f$var$_isAlpha(this.peek() || 0)) {
                var result = this.parseTag(nestingLevel, parentArgType);
                if (result.err) return result;
                elements.push(result.val);
            } else {
                var result = this.parseLiteral(nestingLevel, parentArgType);
                if (result.err) return result;
                elements.push(result.val);
            }
        }
        return {
            val: elements,
            err: null
        };
    };
    /**
     * A tag name must start with an ASCII lower/upper case letter. The grammar is based on the
     * [custom element name][] except that a dash is NOT always mandatory and uppercase letters
     * are accepted:
     *
     * ```
     * tag ::= "<" tagName (whitespace)* "/>" | "<" tagName (whitespace)* ">" message "</" tagName (whitespace)* ">"
     * tagName ::= [a-z] (PENChar)*
     * PENChar ::=
     *     "-" | "." | [0-9] | "_" | [a-z] | [A-Z] | #xB7 | [#xC0-#xD6] | [#xD8-#xF6] | [#xF8-#x37D] |
     *     [#x37F-#x1FFF] | [#x200C-#x200D] | [#x203F-#x2040] | [#x2070-#x218F] | [#x2C00-#x2FEF] |
     *     [#x3001-#xD7FF] | [#xF900-#xFDCF] | [#xFDF0-#xFFFD] | [#x10000-#xEFFFF]
     * ```
     *
     * [custom element name]: https://html.spec.whatwg.org/multipage/custom-elements.html#valid-custom-element-name
     * NOTE: We're a bit more lax here since HTML technically does not allow uppercase HTML element but we do
     * since other tag-based engines like React allow it
     */ Parser.prototype.parseTag = function(nestingLevel, parentArgType) {
        var startPosition = this.clonePosition();
        this.bump(); // `<`
        var tagName = this.parseTagName();
        this.bumpSpace();
        if (this.bumpIf('/>')) // Self closing tag
        return {
            val: {
                type: (0, $4VghZ.TYPE).literal,
                value: "<".concat(tagName, "/>"),
                location: $41b9cca01985965f$var$createLocation(startPosition, this.clonePosition())
            },
            err: null
        };
        else if (this.bumpIf('>')) {
            var childrenResult = this.parseMessage(nestingLevel + 1, parentArgType, true);
            if (childrenResult.err) return childrenResult;
            var children = childrenResult.val;
            // Expecting a close tag
            var endTagStartPosition = this.clonePosition();
            if (this.bumpIf('</')) {
                if (this.isEOF() || !$41b9cca01985965f$var$_isAlpha(this.char())) return this.error((0, $1qhWu.ErrorKind).INVALID_TAG, $41b9cca01985965f$var$createLocation(endTagStartPosition, this.clonePosition()));
                var closingTagNameStartPosition = this.clonePosition();
                var closingTagName = this.parseTagName();
                if (tagName !== closingTagName) return this.error((0, $1qhWu.ErrorKind).UNMATCHED_CLOSING_TAG, $41b9cca01985965f$var$createLocation(closingTagNameStartPosition, this.clonePosition()));
                this.bumpSpace();
                if (!this.bumpIf('>')) return this.error((0, $1qhWu.ErrorKind).INVALID_TAG, $41b9cca01985965f$var$createLocation(endTagStartPosition, this.clonePosition()));
                return {
                    val: {
                        type: (0, $4VghZ.TYPE).tag,
                        value: tagName,
                        children: children,
                        location: $41b9cca01985965f$var$createLocation(startPosition, this.clonePosition())
                    },
                    err: null
                };
            } else return this.error((0, $1qhWu.ErrorKind).UNCLOSED_TAG, $41b9cca01985965f$var$createLocation(startPosition, this.clonePosition()));
        } else return this.error((0, $1qhWu.ErrorKind).INVALID_TAG, $41b9cca01985965f$var$createLocation(startPosition, this.clonePosition()));
    };
    /**
     * This method assumes that the caller has peeked ahead for the first tag character.
     */ Parser.prototype.parseTagName = function() {
        var startOffset = this.offset();
        this.bump(); // the first tag name character
        while(!this.isEOF() && $41b9cca01985965f$var$_isPotentialElementNameChar(this.char()))this.bump();
        return this.message.slice(startOffset, this.offset());
    };
    Parser.prototype.parseLiteral = function(nestingLevel, parentArgType) {
        var start = this.clonePosition();
        var value = '';
        while(true){
            var parseQuoteResult = this.tryParseQuote(parentArgType);
            if (parseQuoteResult) {
                value += parseQuoteResult;
                continue;
            }
            var parseUnquotedResult = this.tryParseUnquoted(nestingLevel, parentArgType);
            if (parseUnquotedResult) {
                value += parseUnquotedResult;
                continue;
            }
            var parseLeftAngleResult = this.tryParseLeftAngleBracket();
            if (parseLeftAngleResult) {
                value += parseLeftAngleResult;
                continue;
            }
            break;
        }
        var location = $41b9cca01985965f$var$createLocation(start, this.clonePosition());
        return {
            val: {
                type: (0, $4VghZ.TYPE).literal,
                value: value,
                location: location
            },
            err: null
        };
    };
    Parser.prototype.tryParseLeftAngleBracket = function() {
        if (!this.isEOF() && this.char() === 60 /* `<` */  && (this.ignoreTag || // If at the opening tag or closing tag position, bail.
        !$41b9cca01985965f$var$_isAlphaOrSlash(this.peek() || 0))) {
            this.bump(); // `<`
            return '<';
        }
        return null;
    };
    /**
     * Starting with ICU 4.8, an ASCII apostrophe only starts quoted text if it immediately precedes
     * a character that requires quoting (that is, "only where needed"), and works the same in
     * nested messages as on the top level of the pattern. The new behavior is otherwise compatible.
     */ Parser.prototype.tryParseQuote = function(parentArgType) {
        if (this.isEOF() || this.char() !== 39 /* `'` */ ) return null;
        // Parse escaped char following the apostrophe, or early return if there is no escaped char.
        // Check if is valid escaped character
        switch(this.peek()){
            case 39 /* `'` */ :
                // double quote, should return as a single quote.
                this.bump();
                this.bump();
                return "'";
            // '{', '<', '>', '}'
            case 123:
            case 60:
            case 62:
            case 125:
                break;
            case 35:
                if (parentArgType === 'plural' || parentArgType === 'selectordinal') break;
                return null;
            default:
                return null;
        }
        this.bump(); // apostrophe
        var codePoints = [
            this.char()
        ]; // escaped char
        this.bump();
        // read chars until the optional closing apostrophe is found
        while(!this.isEOF()){
            var ch = this.char();
            if (ch === 39 /* `'` */ ) {
                if (this.peek() === 39 /* `'` */ ) {
                    codePoints.push(39);
                    // Bump one more time because we need to skip 2 characters.
                    this.bump();
                } else {
                    // Optional closing apostrophe.
                    this.bump();
                    break;
                }
            } else codePoints.push(ch);
            this.bump();
        }
        return $41b9cca01985965f$var$fromCodePoint.apply(void 0, codePoints);
    };
    Parser.prototype.tryParseUnquoted = function(nestingLevel, parentArgType) {
        if (this.isEOF()) return null;
        var ch = this.char();
        if (ch === 60 /* `<` */  || ch === 123 /* `{` */  || ch === 35 /* `#` */  && (parentArgType === 'plural' || parentArgType === 'selectordinal') || ch === 125 /* `}` */  && nestingLevel > 0) return null;
        else {
            this.bump();
            return $41b9cca01985965f$var$fromCodePoint(ch);
        }
    };
    Parser.prototype.parseArgument = function(nestingLevel, expectingCloseTag) {
        var openingBracePosition = this.clonePosition();
        this.bump(); // `{`
        this.bumpSpace();
        if (this.isEOF()) return this.error((0, $1qhWu.ErrorKind).EXPECT_ARGUMENT_CLOSING_BRACE, $41b9cca01985965f$var$createLocation(openingBracePosition, this.clonePosition()));
        if (this.char() === 125 /* `}` */ ) {
            this.bump();
            return this.error((0, $1qhWu.ErrorKind).EMPTY_ARGUMENT, $41b9cca01985965f$var$createLocation(openingBracePosition, this.clonePosition()));
        }
        // argument name
        var value = this.parseIdentifierIfPossible().value;
        if (!value) return this.error((0, $1qhWu.ErrorKind).MALFORMED_ARGUMENT, $41b9cca01985965f$var$createLocation(openingBracePosition, this.clonePosition()));
        this.bumpSpace();
        if (this.isEOF()) return this.error((0, $1qhWu.ErrorKind).EXPECT_ARGUMENT_CLOSING_BRACE, $41b9cca01985965f$var$createLocation(openingBracePosition, this.clonePosition()));
        switch(this.char()){
            // Simple argument: `{name}`
            case 125 /* `}` */ :
                this.bump(); // `}`
                return {
                    val: {
                        type: (0, $4VghZ.TYPE).argument,
                        // value does not include the opening and closing braces.
                        value: value,
                        location: $41b9cca01985965f$var$createLocation(openingBracePosition, this.clonePosition())
                    },
                    err: null
                };
            // Argument with options: `{name, format, ...}`
            case 44 /* `,` */ :
                this.bump(); // `,`
                this.bumpSpace();
                if (this.isEOF()) return this.error((0, $1qhWu.ErrorKind).EXPECT_ARGUMENT_CLOSING_BRACE, $41b9cca01985965f$var$createLocation(openingBracePosition, this.clonePosition()));
                return this.parseArgumentOptions(nestingLevel, expectingCloseTag, value, openingBracePosition);
            default:
                return this.error((0, $1qhWu.ErrorKind).MALFORMED_ARGUMENT, $41b9cca01985965f$var$createLocation(openingBracePosition, this.clonePosition()));
        }
    };
    /**
     * Advance the parser until the end of the identifier, if it is currently on
     * an identifier character. Return an empty string otherwise.
     */ Parser.prototype.parseIdentifierIfPossible = function() {
        var startingPosition = this.clonePosition();
        var startOffset = this.offset();
        var value = $41b9cca01985965f$var$matchIdentifierAtIndex(this.message, startOffset);
        var endOffset = startOffset + value.length;
        this.bumpTo(endOffset);
        var endPosition = this.clonePosition();
        var location = $41b9cca01985965f$var$createLocation(startingPosition, endPosition);
        return {
            value: value,
            location: location
        };
    };
    Parser.prototype.parseArgumentOptions = function(nestingLevel, expectingCloseTag, value, openingBracePosition) {
        var _a;
        // Parse this range:
        // {name, type, style}
        //        ^---^
        var typeStartPosition = this.clonePosition();
        var argType = this.parseIdentifierIfPossible().value;
        var typeEndPosition = this.clonePosition();
        switch(argType){
            case '':
                // Expecting a style string number, date, time, plural, selectordinal, or select.
                return this.error((0, $1qhWu.ErrorKind).EXPECT_ARGUMENT_TYPE, $41b9cca01985965f$var$createLocation(typeStartPosition, typeEndPosition));
            case 'number':
            case 'date':
            case 'time':
                // Parse this range:
                // {name, number, style}
                //              ^-------^
                this.bumpSpace();
                var styleAndLocation = null;
                if (this.bumpIf(',')) {
                    this.bumpSpace();
                    var styleStartPosition = this.clonePosition();
                    var result = this.parseSimpleArgStyleIfPossible();
                    if (result.err) return result;
                    var style = $41b9cca01985965f$var$trimEnd(result.val);
                    if (style.length === 0) return this.error((0, $1qhWu.ErrorKind).EXPECT_ARGUMENT_STYLE, $41b9cca01985965f$var$createLocation(this.clonePosition(), this.clonePosition()));
                    var styleLocation = $41b9cca01985965f$var$createLocation(styleStartPosition, this.clonePosition());
                    styleAndLocation = {
                        style: style,
                        styleLocation: styleLocation
                    };
                }
                var argCloseResult = this.tryParseArgumentClose(openingBracePosition);
                if (argCloseResult.err) return argCloseResult;
                var location_1 = $41b9cca01985965f$var$createLocation(openingBracePosition, this.clonePosition());
                // Extract style or skeleton
                if (styleAndLocation && $41b9cca01985965f$var$startsWith(styleAndLocation === null || styleAndLocation === void 0 ? void 0 : styleAndLocation.style, '::', 0)) {
                    // Skeleton starts with `::`.
                    var skeleton = $41b9cca01985965f$var$trimStart(styleAndLocation.style.slice(2));
                    if (argType === 'number') {
                        var result = this.parseNumberSkeletonFromString(skeleton, styleAndLocation.styleLocation);
                        if (result.err) return result;
                        return {
                            val: {
                                type: (0, $4VghZ.TYPE).number,
                                value: value,
                                location: location_1,
                                style: result.val
                            },
                            err: null
                        };
                    } else {
                        if (skeleton.length === 0) return this.error((0, $1qhWu.ErrorKind).EXPECT_DATE_TIME_SKELETON, location_1);
                        var dateTimePattern = skeleton;
                        // Get "best match" pattern only if locale is passed, if not, let it
                        // pass as-is where `parseDateTimeSkeleton()` will throw an error
                        // for unsupported patterns.
                        if (this.locale) dateTimePattern = (0, $h8PxH.getBestPattern)(skeleton, this.locale);
                        var style = {
                            type: (0, $4VghZ.SKELETON_TYPE).dateTime,
                            pattern: dateTimePattern,
                            location: styleAndLocation.styleLocation,
                            parsedOptions: this.shouldParseSkeletons ? (0, $aYwqB.parseDateTimeSkeleton)(dateTimePattern) : {}
                        };
                        var type = argType === 'date' ? (0, $4VghZ.TYPE).date : (0, $4VghZ.TYPE).time;
                        return {
                            val: {
                                type: type,
                                value: value,
                                location: location_1,
                                style: style
                            },
                            err: null
                        };
                    }
                }
                // Regular style or no style.
                return {
                    val: {
                        type: argType === 'number' ? (0, $4VghZ.TYPE).number : argType === 'date' ? (0, $4VghZ.TYPE).date : (0, $4VghZ.TYPE).time,
                        value: value,
                        location: location_1,
                        style: (_a = styleAndLocation === null || styleAndLocation === void 0 ? void 0 : styleAndLocation.style) !== null && _a !== void 0 ? _a : null
                    },
                    err: null
                };
            case 'plural':
            case 'selectordinal':
            case 'select':
                // Parse this range:
                // {name, plural, options}
                //              ^---------^
                var typeEndPosition_1 = this.clonePosition();
                this.bumpSpace();
                if (!this.bumpIf(',')) return this.error((0, $1qhWu.ErrorKind).EXPECT_SELECT_ARGUMENT_OPTIONS, $41b9cca01985965f$var$createLocation(typeEndPosition_1, (0, $kJhpj.__assign)({}, typeEndPosition_1)));
                this.bumpSpace();
                // Parse offset:
                // {name, plural, offset:1, options}
                //                ^-----^
                //
                // or the first option:
                //
                // {name, plural, one {...} other {...}}
                //                ^--^
                var identifierAndLocation = this.parseIdentifierIfPossible();
                var pluralOffset = 0;
                if (argType !== 'select' && identifierAndLocation.value === 'offset') {
                    if (!this.bumpIf(':')) return this.error((0, $1qhWu.ErrorKind).EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE, $41b9cca01985965f$var$createLocation(this.clonePosition(), this.clonePosition()));
                    this.bumpSpace();
                    var result = this.tryParseDecimalInteger((0, $1qhWu.ErrorKind).EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE, (0, $1qhWu.ErrorKind).INVALID_PLURAL_ARGUMENT_OFFSET_VALUE);
                    if (result.err) return result;
                    // Parse another identifier for option parsing
                    this.bumpSpace();
                    identifierAndLocation = this.parseIdentifierIfPossible();
                    pluralOffset = result.val;
                }
                var optionsResult = this.tryParsePluralOrSelectOptions(nestingLevel, argType, expectingCloseTag, identifierAndLocation);
                if (optionsResult.err) return optionsResult;
                var argCloseResult = this.tryParseArgumentClose(openingBracePosition);
                if (argCloseResult.err) return argCloseResult;
                var location_2 = $41b9cca01985965f$var$createLocation(openingBracePosition, this.clonePosition());
                if (argType === 'select') return {
                    val: {
                        type: (0, $4VghZ.TYPE).select,
                        value: value,
                        options: $41b9cca01985965f$var$fromEntries(optionsResult.val),
                        location: location_2
                    },
                    err: null
                };
                else return {
                    val: {
                        type: (0, $4VghZ.TYPE).plural,
                        value: value,
                        options: $41b9cca01985965f$var$fromEntries(optionsResult.val),
                        offset: pluralOffset,
                        pluralType: argType === 'plural' ? 'cardinal' : 'ordinal',
                        location: location_2
                    },
                    err: null
                };
            default:
                return this.error((0, $1qhWu.ErrorKind).INVALID_ARGUMENT_TYPE, $41b9cca01985965f$var$createLocation(typeStartPosition, typeEndPosition));
        }
    };
    Parser.prototype.tryParseArgumentClose = function(openingBracePosition) {
        // Parse: {value, number, ::currency/GBP }
        //
        if (this.isEOF() || this.char() !== 125 /* `}` */ ) return this.error((0, $1qhWu.ErrorKind).EXPECT_ARGUMENT_CLOSING_BRACE, $41b9cca01985965f$var$createLocation(openingBracePosition, this.clonePosition()));
        this.bump(); // `}`
        return {
            val: true,
            err: null
        };
    };
    /**
     * See: https://github.com/unicode-org/icu/blob/af7ed1f6d2298013dc303628438ec4abe1f16479/icu4c/source/common/messagepattern.cpp#L659
     */ Parser.prototype.parseSimpleArgStyleIfPossible = function() {
        var nestedBraces = 0;
        var startPosition = this.clonePosition();
        while(!this.isEOF()){
            var ch = this.char();
            switch(ch){
                case 39 /* `'` */ :
                    // Treat apostrophe as quoting but include it in the style part.
                    // Find the end of the quoted literal text.
                    this.bump();
                    var apostrophePosition = this.clonePosition();
                    if (!this.bumpUntil("'")) return this.error((0, $1qhWu.ErrorKind).UNCLOSED_QUOTE_IN_ARGUMENT_STYLE, $41b9cca01985965f$var$createLocation(apostrophePosition, this.clonePosition()));
                    this.bump();
                    break;
                case 123 /* `{` */ :
                    nestedBraces += 1;
                    this.bump();
                    break;
                case 125 /* `}` */ :
                    if (nestedBraces > 0) nestedBraces -= 1;
                    else return {
                        val: this.message.slice(startPosition.offset, this.offset()),
                        err: null
                    };
                    break;
                default:
                    this.bump();
                    break;
            }
        }
        return {
            val: this.message.slice(startPosition.offset, this.offset()),
            err: null
        };
    };
    Parser.prototype.parseNumberSkeletonFromString = function(skeleton, location) {
        var tokens = [];
        try {
            tokens = (0, $4f4OJ.parseNumberSkeletonFromString)(skeleton);
        } catch (e) {
            return this.error((0, $1qhWu.ErrorKind).INVALID_NUMBER_SKELETON, location);
        }
        return {
            val: {
                type: (0, $4VghZ.SKELETON_TYPE).number,
                tokens: tokens,
                location: location,
                parsedOptions: this.shouldParseSkeletons ? (0, $4f4OJ.parseNumberSkeleton)(tokens) : {}
            },
            err: null
        };
    };
    /**
     * @param nesting_level The current nesting level of messages.
     *     This can be positive when parsing message fragment in select or plural argument options.
     * @param parent_arg_type The parent argument's type.
     * @param parsed_first_identifier If provided, this is the first identifier-like selector of
     *     the argument. It is a by-product of a previous parsing attempt.
     * @param expecting_close_tag If true, this message is directly or indirectly nested inside
     *     between a pair of opening and closing tags. The nested message will not parse beyond
     *     the closing tag boundary.
     */ Parser.prototype.tryParsePluralOrSelectOptions = function(nestingLevel, parentArgType, expectCloseTag, parsedFirstIdentifier) {
        var _a;
        var hasOtherClause = false;
        var options = [];
        var parsedSelectors = new Set();
        var selector = parsedFirstIdentifier.value, selectorLocation = parsedFirstIdentifier.location;
        // Parse:
        // one {one apple}
        // ^--^
        while(true){
            if (selector.length === 0) {
                var startPosition = this.clonePosition();
                if (parentArgType !== 'select' && this.bumpIf('=')) {
                    // Try parse `={number}` selector
                    var result = this.tryParseDecimalInteger((0, $1qhWu.ErrorKind).EXPECT_PLURAL_ARGUMENT_SELECTOR, (0, $1qhWu.ErrorKind).INVALID_PLURAL_ARGUMENT_SELECTOR);
                    if (result.err) return result;
                    selectorLocation = $41b9cca01985965f$var$createLocation(startPosition, this.clonePosition());
                    selector = this.message.slice(startPosition.offset, this.offset());
                } else break;
            }
            // Duplicate selector clauses
            if (parsedSelectors.has(selector)) return this.error(parentArgType === 'select' ? (0, $1qhWu.ErrorKind).DUPLICATE_SELECT_ARGUMENT_SELECTOR : (0, $1qhWu.ErrorKind).DUPLICATE_PLURAL_ARGUMENT_SELECTOR, selectorLocation);
            if (selector === 'other') hasOtherClause = true;
            // Parse:
            // one {one apple}
            //     ^----------^
            this.bumpSpace();
            var openingBracePosition = this.clonePosition();
            if (!this.bumpIf('{')) return this.error(parentArgType === 'select' ? (0, $1qhWu.ErrorKind).EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT : (0, $1qhWu.ErrorKind).EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT, $41b9cca01985965f$var$createLocation(this.clonePosition(), this.clonePosition()));
            var fragmentResult = this.parseMessage(nestingLevel + 1, parentArgType, expectCloseTag);
            if (fragmentResult.err) return fragmentResult;
            var argCloseResult = this.tryParseArgumentClose(openingBracePosition);
            if (argCloseResult.err) return argCloseResult;
            options.push([
                selector,
                {
                    value: fragmentResult.val,
                    location: $41b9cca01985965f$var$createLocation(openingBracePosition, this.clonePosition())
                }
            ]);
            // Keep track of the existing selectors
            parsedSelectors.add(selector);
            // Prep next selector clause.
            this.bumpSpace();
            _a = this.parseIdentifierIfPossible(), selector = _a.value, selectorLocation = _a.location;
        }
        if (options.length === 0) return this.error(parentArgType === 'select' ? (0, $1qhWu.ErrorKind).EXPECT_SELECT_ARGUMENT_SELECTOR : (0, $1qhWu.ErrorKind).EXPECT_PLURAL_ARGUMENT_SELECTOR, $41b9cca01985965f$var$createLocation(this.clonePosition(), this.clonePosition()));
        if (this.requiresOtherClause && !hasOtherClause) return this.error((0, $1qhWu.ErrorKind).MISSING_OTHER_CLAUSE, $41b9cca01985965f$var$createLocation(this.clonePosition(), this.clonePosition()));
        return {
            val: options,
            err: null
        };
    };
    Parser.prototype.tryParseDecimalInteger = function(expectNumberError, invalidNumberError) {
        var sign = 1;
        var startingPosition = this.clonePosition();
        if (this.bumpIf('+')) ;
        else if (this.bumpIf('-')) sign = -1;
        var hasDigits = false;
        var decimal = 0;
        while(!this.isEOF()){
            var ch = this.char();
            if (ch >= 48 /* `0` */  && ch <= 57 /* `9` */ ) {
                hasDigits = true;
                decimal = decimal * 10 + (ch - 48);
                this.bump();
            } else break;
        }
        var location = $41b9cca01985965f$var$createLocation(startingPosition, this.clonePosition());
        if (!hasDigits) return this.error(expectNumberError, location);
        decimal *= sign;
        if (!$41b9cca01985965f$var$isSafeInteger(decimal)) return this.error(invalidNumberError, location);
        return {
            val: decimal,
            err: null
        };
    };
    Parser.prototype.offset = function() {
        return this.position.offset;
    };
    Parser.prototype.isEOF = function() {
        return this.offset() === this.message.length;
    };
    Parser.prototype.clonePosition = function() {
        // This is much faster than `Object.assign` or spread.
        return {
            offset: this.position.offset,
            line: this.position.line,
            column: this.position.column
        };
    };
    /**
     * Return the code point at the current position of the parser.
     * Throws if the index is out of bound.
     */ Parser.prototype.char = function() {
        var offset = this.position.offset;
        if (offset >= this.message.length) throw Error('out of bound');
        var code = $41b9cca01985965f$var$codePointAt(this.message, offset);
        if (code === undefined) throw Error("Offset ".concat(offset, " is at invalid UTF-16 code unit boundary"));
        return code;
    };
    Parser.prototype.error = function(kind, location) {
        return {
            val: null,
            err: {
                kind: kind,
                message: this.message,
                location: location
            }
        };
    };
    /** Bump the parser to the next UTF-16 code unit. */ Parser.prototype.bump = function() {
        if (this.isEOF()) return;
        var code = this.char();
        if (code === 10 /* '\n' */ ) {
            this.position.line += 1;
            this.position.column = 1;
            this.position.offset += 1;
        } else {
            this.position.column += 1;
            // 0 ~ 0x10000 -> unicode BMP, otherwise skip the surrogate pair.
            this.position.offset += code < 0x10000 ? 1 : 2;
        }
    };
    /**
     * If the substring starting at the current position of the parser has
     * the given prefix, then bump the parser to the character immediately
     * following the prefix and return true. Otherwise, don't bump the parser
     * and return false.
     */ Parser.prototype.bumpIf = function(prefix) {
        if ($41b9cca01985965f$var$startsWith(this.message, prefix, this.offset())) {
            for(var i = 0; i < prefix.length; i++)this.bump();
            return true;
        }
        return false;
    };
    /**
     * Bump the parser until the pattern character is found and return `true`.
     * Otherwise bump to the end of the file and return `false`.
     */ Parser.prototype.bumpUntil = function(pattern) {
        var currentOffset = this.offset();
        var index = this.message.indexOf(pattern, currentOffset);
        if (index >= 0) {
            this.bumpTo(index);
            return true;
        } else {
            this.bumpTo(this.message.length);
            return false;
        }
    };
    /**
     * Bump the parser to the target offset.
     * If target offset is beyond the end of the input, bump the parser to the end of the input.
     */ Parser.prototype.bumpTo = function(targetOffset) {
        if (this.offset() > targetOffset) throw Error("targetOffset ".concat(targetOffset, " must be greater than or equal to the current offset ").concat(this.offset()));
        targetOffset = Math.min(targetOffset, this.message.length);
        while(true){
            var offset = this.offset();
            if (offset === targetOffset) break;
            if (offset > targetOffset) throw Error("targetOffset ".concat(targetOffset, " is at invalid UTF-16 code unit boundary"));
            this.bump();
            if (this.isEOF()) break;
        }
    };
    /** advance the parser through all whitespace to the next non-whitespace code unit. */ Parser.prototype.bumpSpace = function() {
        while(!this.isEOF() && $41b9cca01985965f$var$_isWhiteSpace(this.char()))this.bump();
    };
    /**
     * Peek at the *next* Unicode codepoint in the input without advancing the parser.
     * If the input has been exhausted, then this returns null.
     */ Parser.prototype.peek = function() {
        if (this.isEOF()) return null;
        var code = this.char();
        var offset = this.offset();
        var nextCode = this.message.charCodeAt(offset + (code >= 0x10000 ? 2 : 1));
        return nextCode !== null && nextCode !== void 0 ? nextCode : null;
    };
    return Parser;
}();
/**
 * This check if codepoint is alphabet (lower & uppercase)
 * @param codepoint
 * @returns
 */ function $41b9cca01985965f$var$_isAlpha(codepoint) {
    return codepoint >= 97 && codepoint <= 122 || codepoint >= 65 && codepoint <= 90;
}
function $41b9cca01985965f$var$_isAlphaOrSlash(codepoint) {
    return $41b9cca01985965f$var$_isAlpha(codepoint) || codepoint === 47; /* '/' */ 
}
/** See `parseTag` function docs. */ function $41b9cca01985965f$var$_isPotentialElementNameChar(c) {
    return c === 45 /* '-' */  || c === 46 /* '.' */  || c >= 48 && c <= 57 || c === 95 /* '_' */  || c >= 97 && c <= 122 || c >= 65 && c <= 90 || c == 0xb7 || c >= 0xc0 && c <= 0xd6 || c >= 0xd8 && c <= 0xf6 || c >= 0xf8 && c <= 0x37d || c >= 0x37f && c <= 0x1fff || c >= 0x200c && c <= 0x200d || c >= 0x203f && c <= 0x2040 || c >= 0x2070 && c <= 0x218f || c >= 0x2c00 && c <= 0x2fef || c >= 0x3001 && c <= 0xd7ff || c >= 0xf900 && c <= 0xfdcf || c >= 0xfdf0 && c <= 0xfffd || c >= 0x10000 && c <= 0xeffff;
}
/**
 * Code point equivalent of regex `\p{White_Space}`.
 * From: https://www.unicode.org/Public/UCD/latest/ucd/PropList.txt
 */ function $41b9cca01985965f$var$_isWhiteSpace(c) {
    return c >= 0x0009 && c <= 0x000d || c === 0x0020 || c === 0x0085 || c >= 0x200e && c <= 0x200f || c === 0x2028 || c === 0x2029;
}
/**
 * Code point equivalent of regex `\p{Pattern_Syntax}`.
 * See https://www.unicode.org/Public/UCD/latest/ucd/PropList.txt
 */ function $41b9cca01985965f$var$_isPatternSyntax(c) {
    return c >= 0x0021 && c <= 0x0023 || c === 0x0024 || c >= 0x0025 && c <= 0x0027 || c === 0x0028 || c === 0x0029 || c === 0x002a || c === 0x002b || c === 0x002c || c === 0x002d || c >= 0x002e && c <= 0x002f || c >= 0x003a && c <= 0x003b || c >= 0x003c && c <= 0x003e || c >= 0x003f && c <= 0x0040 || c === 0x005b || c === 0x005c || c === 0x005d || c === 0x005e || c === 0x0060 || c === 0x007b || c === 0x007c || c === 0x007d || c === 0x007e || c === 0x00a1 || c >= 0x00a2 && c <= 0x00a5 || c === 0x00a6 || c === 0x00a7 || c === 0x00a9 || c === 0x00ab || c === 0x00ac || c === 0x00ae || c === 0x00b0 || c === 0x00b1 || c === 0x00b6 || c === 0x00bb || c === 0x00bf || c === 0x00d7 || c === 0x00f7 || c >= 0x2010 && c <= 0x2015 || c >= 0x2016 && c <= 0x2017 || c === 0x2018 || c === 0x2019 || c === 0x201a || c >= 0x201b && c <= 0x201c || c === 0x201d || c === 0x201e || c === 0x201f || c >= 0x2020 && c <= 0x2027 || c >= 0x2030 && c <= 0x2038 || c === 0x2039 || c === 0x203a || c >= 0x203b && c <= 0x203e || c >= 0x2041 && c <= 0x2043 || c === 0x2044 || c === 0x2045 || c === 0x2046 || c >= 0x2047 && c <= 0x2051 || c === 0x2052 || c === 0x2053 || c >= 0x2055 && c <= 0x205e || c >= 0x2190 && c <= 0x2194 || c >= 0x2195 && c <= 0x2199 || c >= 0x219a && c <= 0x219b || c >= 0x219c && c <= 0x219f || c === 0x21a0 || c >= 0x21a1 && c <= 0x21a2 || c === 0x21a3 || c >= 0x21a4 && c <= 0x21a5 || c === 0x21a6 || c >= 0x21a7 && c <= 0x21ad || c === 0x21ae || c >= 0x21af && c <= 0x21cd || c >= 0x21ce && c <= 0x21cf || c >= 0x21d0 && c <= 0x21d1 || c === 0x21d2 || c === 0x21d3 || c === 0x21d4 || c >= 0x21d5 && c <= 0x21f3 || c >= 0x21f4 && c <= 0x22ff || c >= 0x2300 && c <= 0x2307 || c === 0x2308 || c === 0x2309 || c === 0x230a || c === 0x230b || c >= 0x230c && c <= 0x231f || c >= 0x2320 && c <= 0x2321 || c >= 0x2322 && c <= 0x2328 || c === 0x2329 || c === 0x232a || c >= 0x232b && c <= 0x237b || c === 0x237c || c >= 0x237d && c <= 0x239a || c >= 0x239b && c <= 0x23b3 || c >= 0x23b4 && c <= 0x23db || c >= 0x23dc && c <= 0x23e1 || c >= 0x23e2 && c <= 0x2426 || c >= 0x2427 && c <= 0x243f || c >= 0x2440 && c <= 0x244a || c >= 0x244b && c <= 0x245f || c >= 0x2500 && c <= 0x25b6 || c === 0x25b7 || c >= 0x25b8 && c <= 0x25c0 || c === 0x25c1 || c >= 0x25c2 && c <= 0x25f7 || c >= 0x25f8 && c <= 0x25ff || c >= 0x2600 && c <= 0x266e || c === 0x266f || c >= 0x2670 && c <= 0x2767 || c === 0x2768 || c === 0x2769 || c === 0x276a || c === 0x276b || c === 0x276c || c === 0x276d || c === 0x276e || c === 0x276f || c === 0x2770 || c === 0x2771 || c === 0x2772 || c === 0x2773 || c === 0x2774 || c === 0x2775 || c >= 0x2794 && c <= 0x27bf || c >= 0x27c0 && c <= 0x27c4 || c === 0x27c5 || c === 0x27c6 || c >= 0x27c7 && c <= 0x27e5 || c === 0x27e6 || c === 0x27e7 || c === 0x27e8 || c === 0x27e9 || c === 0x27ea || c === 0x27eb || c === 0x27ec || c === 0x27ed || c === 0x27ee || c === 0x27ef || c >= 0x27f0 && c <= 0x27ff || c >= 0x2800 && c <= 0x28ff || c >= 0x2900 && c <= 0x2982 || c === 0x2983 || c === 0x2984 || c === 0x2985 || c === 0x2986 || c === 0x2987 || c === 0x2988 || c === 0x2989 || c === 0x298a || c === 0x298b || c === 0x298c || c === 0x298d || c === 0x298e || c === 0x298f || c === 0x2990 || c === 0x2991 || c === 0x2992 || c === 0x2993 || c === 0x2994 || c === 0x2995 || c === 0x2996 || c === 0x2997 || c === 0x2998 || c >= 0x2999 && c <= 0x29d7 || c === 0x29d8 || c === 0x29d9 || c === 0x29da || c === 0x29db || c >= 0x29dc && c <= 0x29fb || c === 0x29fc || c === 0x29fd || c >= 0x29fe && c <= 0x2aff || c >= 0x2b00 && c <= 0x2b2f || c >= 0x2b30 && c <= 0x2b44 || c >= 0x2b45 && c <= 0x2b46 || c >= 0x2b47 && c <= 0x2b4c || c >= 0x2b4d && c <= 0x2b73 || c >= 0x2b74 && c <= 0x2b75 || c >= 0x2b76 && c <= 0x2b95 || c === 0x2b96 || c >= 0x2b97 && c <= 0x2bff || c >= 0x2e00 && c <= 0x2e01 || c === 0x2e02 || c === 0x2e03 || c === 0x2e04 || c === 0x2e05 || c >= 0x2e06 && c <= 0x2e08 || c === 0x2e09 || c === 0x2e0a || c === 0x2e0b || c === 0x2e0c || c === 0x2e0d || c >= 0x2e0e && c <= 0x2e16 || c === 0x2e17 || c >= 0x2e18 && c <= 0x2e19 || c === 0x2e1a || c === 0x2e1b || c === 0x2e1c || c === 0x2e1d || c >= 0x2e1e && c <= 0x2e1f || c === 0x2e20 || c === 0x2e21 || c === 0x2e22 || c === 0x2e23 || c === 0x2e24 || c === 0x2e25 || c === 0x2e26 || c === 0x2e27 || c === 0x2e28 || c === 0x2e29 || c >= 0x2e2a && c <= 0x2e2e || c === 0x2e2f || c >= 0x2e30 && c <= 0x2e39 || c >= 0x2e3a && c <= 0x2e3b || c >= 0x2e3c && c <= 0x2e3f || c === 0x2e40 || c === 0x2e41 || c === 0x2e42 || c >= 0x2e43 && c <= 0x2e4f || c >= 0x2e50 && c <= 0x2e51 || c === 0x2e52 || c >= 0x2e53 && c <= 0x2e7f || c >= 0x3001 && c <= 0x3003 || c === 0x3008 || c === 0x3009 || c === 0x300a || c === 0x300b || c === 0x300c || c === 0x300d || c === 0x300e || c === 0x300f || c === 0x3010 || c === 0x3011 || c >= 0x3012 && c <= 0x3013 || c === 0x3014 || c === 0x3015 || c === 0x3016 || c === 0x3017 || c === 0x3018 || c === 0x3019 || c === 0x301a || c === 0x301b || c === 0x301c || c === 0x301d || c >= 0x301e && c <= 0x301f || c === 0x3020 || c === 0x3030 || c === 0xfd3e || c === 0xfd3f || c >= 0xfe45 && c <= 0xfe46;
}

});
parcelRegister("4VghZ", function(module, exports) {
$parcel$export(module.exports, "TYPE", () => $39591ef6f138e77f$export$b87f371cbc396fcf);
$parcel$export(module.exports, "SKELETON_TYPE", () => $39591ef6f138e77f$export$906452485466fa53);
$parcel$export(module.exports, "isLiteralElement", () => $39591ef6f138e77f$export$cfa10c5697238752);
$parcel$export(module.exports, "isArgumentElement", () => $39591ef6f138e77f$export$4f55724281bdfaf9);
$parcel$export(module.exports, "isNumberElement", () => $39591ef6f138e77f$export$e11187b219e191e1);
$parcel$export(module.exports, "isDateElement", () => $39591ef6f138e77f$export$32d811605da75f40);
$parcel$export(module.exports, "isTimeElement", () => $39591ef6f138e77f$export$34ec46f596b1702f);
$parcel$export(module.exports, "isSelectElement", () => $39591ef6f138e77f$export$dcfe1c11d168b5a1);
$parcel$export(module.exports, "isPluralElement", () => $39591ef6f138e77f$export$6c796d116f0a4fbc);
$parcel$export(module.exports, "isPoundElement", () => $39591ef6f138e77f$export$c0ece297bdd0c082);
$parcel$export(module.exports, "isTagElement", () => $39591ef6f138e77f$export$5c83de34745812b);
$parcel$export(module.exports, "isNumberSkeleton", () => $39591ef6f138e77f$export$3f9a19cd4152eda3);
$parcel$export(module.exports, "isDateTimeSkeleton", () => $39591ef6f138e77f$export$7680c41f1a55f4cf);
var $39591ef6f138e77f$export$b87f371cbc396fcf;
(function(TYPE) {
    /**
     * Raw text
     */ TYPE[TYPE["literal"] = 0] = "literal";
    /**
     * Variable w/o any format, e.g `var` in `this is a {var}`
     */ TYPE[TYPE["argument"] = 1] = "argument";
    /**
     * Variable w/ number format
     */ TYPE[TYPE["number"] = 2] = "number";
    /**
     * Variable w/ date format
     */ TYPE[TYPE["date"] = 3] = "date";
    /**
     * Variable w/ time format
     */ TYPE[TYPE["time"] = 4] = "time";
    /**
     * Variable w/ select format
     */ TYPE[TYPE["select"] = 5] = "select";
    /**
     * Variable w/ plural format
     */ TYPE[TYPE["plural"] = 6] = "plural";
    /**
     * Only possible within plural argument.
     * This is the `#` symbol that will be substituted with the count.
     */ TYPE[TYPE["pound"] = 7] = "pound";
    /**
     * XML-like tag
     */ TYPE[TYPE["tag"] = 8] = "tag";
})($39591ef6f138e77f$export$b87f371cbc396fcf || ($39591ef6f138e77f$export$b87f371cbc396fcf = {}));
var $39591ef6f138e77f$export$906452485466fa53;
(function(SKELETON_TYPE) {
    SKELETON_TYPE[SKELETON_TYPE["number"] = 0] = "number";
    SKELETON_TYPE[SKELETON_TYPE["dateTime"] = 1] = "dateTime";
})($39591ef6f138e77f$export$906452485466fa53 || ($39591ef6f138e77f$export$906452485466fa53 = {}));
function $39591ef6f138e77f$export$cfa10c5697238752(el) {
    return el.type === $39591ef6f138e77f$export$b87f371cbc396fcf.literal;
}
function $39591ef6f138e77f$export$4f55724281bdfaf9(el) {
    return el.type === $39591ef6f138e77f$export$b87f371cbc396fcf.argument;
}
function $39591ef6f138e77f$export$e11187b219e191e1(el) {
    return el.type === $39591ef6f138e77f$export$b87f371cbc396fcf.number;
}
function $39591ef6f138e77f$export$32d811605da75f40(el) {
    return el.type === $39591ef6f138e77f$export$b87f371cbc396fcf.date;
}
function $39591ef6f138e77f$export$34ec46f596b1702f(el) {
    return el.type === $39591ef6f138e77f$export$b87f371cbc396fcf.time;
}
function $39591ef6f138e77f$export$dcfe1c11d168b5a1(el) {
    return el.type === $39591ef6f138e77f$export$b87f371cbc396fcf.select;
}
function $39591ef6f138e77f$export$6c796d116f0a4fbc(el) {
    return el.type === $39591ef6f138e77f$export$b87f371cbc396fcf.plural;
}
function $39591ef6f138e77f$export$c0ece297bdd0c082(el) {
    return el.type === $39591ef6f138e77f$export$b87f371cbc396fcf.pound;
}
function $39591ef6f138e77f$export$5c83de34745812b(el) {
    return el.type === $39591ef6f138e77f$export$b87f371cbc396fcf.tag;
}
function $39591ef6f138e77f$export$3f9a19cd4152eda3(el) {
    return !!(el && typeof el === 'object' && el.type === $39591ef6f138e77f$export$906452485466fa53.number);
}
function $39591ef6f138e77f$export$7680c41f1a55f4cf(el) {
    return !!(el && typeof el === 'object' && el.type === $39591ef6f138e77f$export$906452485466fa53.dateTime);
}
function $39591ef6f138e77f$export$f0ac572c1121c662(value) {
    return {
        type: $39591ef6f138e77f$export$b87f371cbc396fcf.literal,
        value: value
    };
}
function $39591ef6f138e77f$export$425e864b0ba114f1(value, style) {
    return {
        type: $39591ef6f138e77f$export$b87f371cbc396fcf.number,
        value: value,
        style: style
    };
}

});

parcelRegister("1tlBf", function(module, exports) {
$parcel$export(module.exports, "SPACE_SEPARATOR_REGEX", () => $1129411e0a357551$export$523451f94304dd6c);
// @generated from regex-gen.ts
var $1129411e0a357551$export$523451f94304dd6c = /[ \xA0\u1680\u2000-\u200A\u202F\u205F\u3000]/;
var $1129411e0a357551$export$2b8db14d8bcaece7 = /[\t-\r \x85\u200E\u200F\u2028\u2029]/;

});

parcelRegister("3Uiry", function(module, exports) {
$parcel$export(module.exports, "parseDateTimeSkeleton", () => (parcelRequire("aYwqB")).parseDateTimeSkeleton);
$parcel$export(module.exports, "parseNumberSkeleton", () => (parcelRequire("4f4OJ")).parseNumberSkeleton);
$parcel$export(module.exports, "parseNumberSkeletonFromString", () => (parcelRequire("4f4OJ")).parseNumberSkeletonFromString);
parcelRequire("aYwqB");
parcelRequire("4f4OJ");

});
parcelRegister("aYwqB", function(module, exports) {
$parcel$export(module.exports, "parseDateTimeSkeleton", () => $7fd8a98a97bb80b4$export$f7b99fb377fe69fa);
/**
 * https://unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
 * Credit: https://github.com/caridy/intl-datetimeformat-pattern/blob/master/index.js
 * with some tweaks
 */ var $7fd8a98a97bb80b4$var$DATE_TIME_REGEX = /(?:[Eec]{1,6}|G{1,5}|[Qq]{1,5}|(?:[yYur]+|U{1,5})|[ML]{1,5}|d{1,2}|D{1,3}|F{1}|[abB]{1,5}|[hkHK]{1,2}|w{1,2}|W{1}|m{1,2}|s{1,2}|[zZOvVxX]{1,4})(?=([^']*'[^']*')*[^']*$)/g;
function $7fd8a98a97bb80b4$export$f7b99fb377fe69fa(skeleton) {
    var result = {};
    skeleton.replace($7fd8a98a97bb80b4$var$DATE_TIME_REGEX, function(match) {
        var len = match.length;
        switch(match[0]){
            // Era
            case 'G':
                result.era = len === 4 ? 'long' : len === 5 ? 'narrow' : 'short';
                break;
            // Year
            case 'y':
                result.year = len === 2 ? '2-digit' : 'numeric';
                break;
            case 'Y':
            case 'u':
            case 'U':
            case 'r':
                throw new RangeError('`Y/u/U/r` (year) patterns are not supported, use `y` instead');
            // Quarter
            case 'q':
            case 'Q':
                throw new RangeError('`q/Q` (quarter) patterns are not supported');
            // Month
            case 'M':
            case 'L':
                result.month = [
                    'numeric',
                    '2-digit',
                    'short',
                    'long',
                    'narrow'
                ][len - 1];
                break;
            // Week
            case 'w':
            case 'W':
                throw new RangeError('`w/W` (week) patterns are not supported');
            case 'd':
                result.day = [
                    'numeric',
                    '2-digit'
                ][len - 1];
                break;
            case 'D':
            case 'F':
            case 'g':
                throw new RangeError('`D/F/g` (day) patterns are not supported, use `d` instead');
            // Weekday
            case 'E':
                result.weekday = len === 4 ? 'long' : len === 5 ? 'narrow' : 'short';
                break;
            case 'e':
                if (len < 4) throw new RangeError('`e..eee` (weekday) patterns are not supported');
                result.weekday = [
                    'short',
                    'long',
                    'narrow',
                    'short'
                ][len - 4];
                break;
            case 'c':
                if (len < 4) throw new RangeError('`c..ccc` (weekday) patterns are not supported');
                result.weekday = [
                    'short',
                    'long',
                    'narrow',
                    'short'
                ][len - 4];
                break;
            // Period
            case 'a':
                result.hour12 = true;
                break;
            case 'b':
            case 'B':
                throw new RangeError('`b/B` (period) patterns are not supported, use `a` instead');
            // Hour
            case 'h':
                result.hourCycle = 'h12';
                result.hour = [
                    'numeric',
                    '2-digit'
                ][len - 1];
                break;
            case 'H':
                result.hourCycle = 'h23';
                result.hour = [
                    'numeric',
                    '2-digit'
                ][len - 1];
                break;
            case 'K':
                result.hourCycle = 'h11';
                result.hour = [
                    'numeric',
                    '2-digit'
                ][len - 1];
                break;
            case 'k':
                result.hourCycle = 'h24';
                result.hour = [
                    'numeric',
                    '2-digit'
                ][len - 1];
                break;
            case 'j':
            case 'J':
            case 'C':
                throw new RangeError('`j/J/C` (hour) patterns are not supported, use `h/H/K/k` instead');
            // Minute
            case 'm':
                result.minute = [
                    'numeric',
                    '2-digit'
                ][len - 1];
                break;
            // Second
            case 's':
                result.second = [
                    'numeric',
                    '2-digit'
                ][len - 1];
                break;
            case 'S':
            case 'A':
                throw new RangeError('`S/A` (second) patterns are not supported, use `s` instead');
            // Zone
            case 'z':
                result.timeZoneName = len < 4 ? 'short' : 'long';
                break;
            case 'Z':
            case 'O':
            case 'v':
            case 'V':
            case 'X':
            case 'x':
                throw new RangeError('`Z/O/v/V/X/x` (timeZone) patterns are not supported, use `z` instead');
        }
        return '';
    });
    return result;
}

});

parcelRegister("4f4OJ", function(module, exports) {
$parcel$export(module.exports, "parseNumberSkeletonFromString", () => $316c4cc380cc14ac$export$71cee2f16fba2480);
$parcel$export(module.exports, "parseNumberSkeleton", () => $316c4cc380cc14ac$export$47c6f8480bda3e11);

var $kJhpj = parcelRequire("kJhpj");

var $cULFT = parcelRequire("cULFT");
function $316c4cc380cc14ac$export$71cee2f16fba2480(skeleton) {
    if (skeleton.length === 0) throw new Error('Number skeleton cannot be empty');
    // Parse the skeleton
    var stringTokens = skeleton.split((0, $cULFT.WHITE_SPACE_REGEX)).filter(function(x) {
        return x.length > 0;
    });
    var tokens = [];
    for(var _i = 0, stringTokens_1 = stringTokens; _i < stringTokens_1.length; _i++){
        var stringToken = stringTokens_1[_i];
        var stemAndOptions = stringToken.split('/');
        if (stemAndOptions.length === 0) throw new Error('Invalid number skeleton');
        var stem = stemAndOptions[0], options = stemAndOptions.slice(1);
        for(var _a = 0, options_1 = options; _a < options_1.length; _a++){
            var option = options_1[_a];
            if (option.length === 0) throw new Error('Invalid number skeleton');
        }
        tokens.push({
            stem: stem,
            options: options
        });
    }
    return tokens;
}
function $316c4cc380cc14ac$var$icuUnitToEcma(unit) {
    return unit.replace(/^(.*?)-/, '');
}
var $316c4cc380cc14ac$var$FRACTION_PRECISION_REGEX = /^\.(?:(0+)(\*)?|(#+)|(0+)(#+))$/g;
var $316c4cc380cc14ac$var$SIGNIFICANT_PRECISION_REGEX = /^(@+)?(\+|#+)?[rs]?$/g;
var $316c4cc380cc14ac$var$INTEGER_WIDTH_REGEX = /(\*)(0+)|(#+)(0+)|(0+)/g;
var $316c4cc380cc14ac$var$CONCISE_INTEGER_WIDTH_REGEX = /^(0+)$/;
function $316c4cc380cc14ac$var$parseSignificantPrecision(str) {
    var result = {};
    if (str[str.length - 1] === 'r') result.roundingPriority = 'morePrecision';
    else if (str[str.length - 1] === 's') result.roundingPriority = 'lessPrecision';
    str.replace($316c4cc380cc14ac$var$SIGNIFICANT_PRECISION_REGEX, function(_, g1, g2) {
        // @@@ case
        if (typeof g2 !== 'string') {
            result.minimumSignificantDigits = g1.length;
            result.maximumSignificantDigits = g1.length;
        } else if (g2 === '+') result.minimumSignificantDigits = g1.length;
        else if (g1[0] === '#') result.maximumSignificantDigits = g1.length;
        else {
            result.minimumSignificantDigits = g1.length;
            result.maximumSignificantDigits = g1.length + (typeof g2 === 'string' ? g2.length : 0);
        }
        return '';
    });
    return result;
}
function $316c4cc380cc14ac$var$parseSign(str) {
    switch(str){
        case 'sign-auto':
            return {
                signDisplay: 'auto'
            };
        case 'sign-accounting':
        case '()':
            return {
                currencySign: 'accounting'
            };
        case 'sign-always':
        case '+!':
            return {
                signDisplay: 'always'
            };
        case 'sign-accounting-always':
        case '()!':
            return {
                signDisplay: 'always',
                currencySign: 'accounting'
            };
        case 'sign-except-zero':
        case '+?':
            return {
                signDisplay: 'exceptZero'
            };
        case 'sign-accounting-except-zero':
        case '()?':
            return {
                signDisplay: 'exceptZero',
                currencySign: 'accounting'
            };
        case 'sign-never':
        case '+_':
            return {
                signDisplay: 'never'
            };
    }
}
function $316c4cc380cc14ac$var$parseConciseScientificAndEngineeringStem(stem) {
    // Engineering
    var result;
    if (stem[0] === 'E' && stem[1] === 'E') {
        result = {
            notation: 'engineering'
        };
        stem = stem.slice(2);
    } else if (stem[0] === 'E') {
        result = {
            notation: 'scientific'
        };
        stem = stem.slice(1);
    }
    if (result) {
        var signDisplay = stem.slice(0, 2);
        if (signDisplay === '+!') {
            result.signDisplay = 'always';
            stem = stem.slice(2);
        } else if (signDisplay === '+?') {
            result.signDisplay = 'exceptZero';
            stem = stem.slice(2);
        }
        if (!$316c4cc380cc14ac$var$CONCISE_INTEGER_WIDTH_REGEX.test(stem)) throw new Error('Malformed concise eng/scientific notation');
        result.minimumIntegerDigits = stem.length;
    }
    return result;
}
function $316c4cc380cc14ac$var$parseNotationOptions(opt) {
    var result = {};
    var signOpts = $316c4cc380cc14ac$var$parseSign(opt);
    if (signOpts) return signOpts;
    return result;
}
function $316c4cc380cc14ac$export$47c6f8480bda3e11(tokens) {
    var result = {};
    for(var _i = 0, tokens_1 = tokens; _i < tokens_1.length; _i++){
        var token = tokens_1[_i];
        switch(token.stem){
            case 'percent':
            case '%':
                result.style = 'percent';
                continue;
            case '%x100':
                result.style = 'percent';
                result.scale = 100;
                continue;
            case 'currency':
                result.style = 'currency';
                result.currency = token.options[0];
                continue;
            case 'group-off':
            case ',_':
                result.useGrouping = false;
                continue;
            case 'precision-integer':
            case '.':
                result.maximumFractionDigits = 0;
                continue;
            case 'measure-unit':
            case 'unit':
                result.style = 'unit';
                result.unit = $316c4cc380cc14ac$var$icuUnitToEcma(token.options[0]);
                continue;
            case 'compact-short':
            case 'K':
                result.notation = 'compact';
                result.compactDisplay = 'short';
                continue;
            case 'compact-long':
            case 'KK':
                result.notation = 'compact';
                result.compactDisplay = 'long';
                continue;
            case 'scientific':
                result = (0, $kJhpj.__assign)((0, $kJhpj.__assign)((0, $kJhpj.__assign)({}, result), {
                    notation: 'scientific'
                }), token.options.reduce(function(all, opt) {
                    return (0, $kJhpj.__assign)((0, $kJhpj.__assign)({}, all), $316c4cc380cc14ac$var$parseNotationOptions(opt));
                }, {}));
                continue;
            case 'engineering':
                result = (0, $kJhpj.__assign)((0, $kJhpj.__assign)((0, $kJhpj.__assign)({}, result), {
                    notation: 'engineering'
                }), token.options.reduce(function(all, opt) {
                    return (0, $kJhpj.__assign)((0, $kJhpj.__assign)({}, all), $316c4cc380cc14ac$var$parseNotationOptions(opt));
                }, {}));
                continue;
            case 'notation-simple':
                result.notation = 'standard';
                continue;
            // https://github.com/unicode-org/icu/blob/master/icu4c/source/i18n/unicode/unumberformatter.h
            case 'unit-width-narrow':
                result.currencyDisplay = 'narrowSymbol';
                result.unitDisplay = 'narrow';
                continue;
            case 'unit-width-short':
                result.currencyDisplay = 'code';
                result.unitDisplay = 'short';
                continue;
            case 'unit-width-full-name':
                result.currencyDisplay = 'name';
                result.unitDisplay = 'long';
                continue;
            case 'unit-width-iso-code':
                result.currencyDisplay = 'symbol';
                continue;
            case 'scale':
                result.scale = parseFloat(token.options[0]);
                continue;
            case 'rounding-mode-floor':
                result.roundingMode = 'floor';
                continue;
            case 'rounding-mode-ceiling':
                result.roundingMode = 'ceil';
                continue;
            case 'rounding-mode-down':
                result.roundingMode = 'trunc';
                continue;
            case 'rounding-mode-up':
                result.roundingMode = 'expand';
                continue;
            case 'rounding-mode-half-even':
                result.roundingMode = 'halfEven';
                continue;
            case 'rounding-mode-half-down':
                result.roundingMode = 'halfTrunc';
                continue;
            case 'rounding-mode-half-up':
                result.roundingMode = 'halfExpand';
                continue;
            // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#integer-width
            case 'integer-width':
                if (token.options.length > 1) throw new RangeError('integer-width stems only accept a single optional option');
                token.options[0].replace($316c4cc380cc14ac$var$INTEGER_WIDTH_REGEX, function(_, g1, g2, g3, g4, g5) {
                    if (g1) result.minimumIntegerDigits = g2.length;
                    else if (g3 && g4) throw new Error('We currently do not support maximum integer digits');
                    else if (g5) throw new Error('We currently do not support exact integer digits');
                    return '';
                });
                continue;
        }
        // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#integer-width
        if ($316c4cc380cc14ac$var$CONCISE_INTEGER_WIDTH_REGEX.test(token.stem)) {
            result.minimumIntegerDigits = token.stem.length;
            continue;
        }
        if ($316c4cc380cc14ac$var$FRACTION_PRECISION_REGEX.test(token.stem)) {
            // Precision
            // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#fraction-precision
            // precision-integer case
            if (token.options.length > 1) throw new RangeError('Fraction-precision stems only accept a single optional option');
            token.stem.replace($316c4cc380cc14ac$var$FRACTION_PRECISION_REGEX, function(_, g1, g2, g3, g4, g5) {
                // .000* case (before ICU67 it was .000+)
                if (g2 === '*') result.minimumFractionDigits = g1.length;
                else if (g3 && g3[0] === '#') result.maximumFractionDigits = g3.length;
                else if (g4 && g5) {
                    result.minimumFractionDigits = g4.length;
                    result.maximumFractionDigits = g4.length + g5.length;
                } else {
                    result.minimumFractionDigits = g1.length;
                    result.maximumFractionDigits = g1.length;
                }
                return '';
            });
            var opt = token.options[0];
            // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#trailing-zero-display
            if (opt === 'w') result = (0, $kJhpj.__assign)((0, $kJhpj.__assign)({}, result), {
                trailingZeroDisplay: 'stripIfInteger'
            });
            else if (opt) result = (0, $kJhpj.__assign)((0, $kJhpj.__assign)({}, result), $316c4cc380cc14ac$var$parseSignificantPrecision(opt));
            continue;
        }
        // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#significant-digits-precision
        if ($316c4cc380cc14ac$var$SIGNIFICANT_PRECISION_REGEX.test(token.stem)) {
            result = (0, $kJhpj.__assign)((0, $kJhpj.__assign)({}, result), $316c4cc380cc14ac$var$parseSignificantPrecision(token.stem));
            continue;
        }
        var signOpts = $316c4cc380cc14ac$var$parseSign(token.stem);
        if (signOpts) result = (0, $kJhpj.__assign)((0, $kJhpj.__assign)({}, result), signOpts);
        var conciseScientificAndEngineeringOpts = $316c4cc380cc14ac$var$parseConciseScientificAndEngineeringStem(token.stem);
        if (conciseScientificAndEngineeringOpts) result = (0, $kJhpj.__assign)((0, $kJhpj.__assign)({}, result), conciseScientificAndEngineeringOpts);
    }
    return result;
}

});
parcelRegister("cULFT", function(module, exports) {
$parcel$export(module.exports, "WHITE_SPACE_REGEX", () => $966fb236f7c5dc5f$export$2b8db14d8bcaece7);
// @generated from regex-gen.ts
var $966fb236f7c5dc5f$export$2b8db14d8bcaece7 = /[\t-\r \x85\u200E\u200F\u2028\u2029]/i;

});



parcelRegister("h8PxH", function(module, exports) {
$parcel$export(module.exports, "getBestPattern", () => $c7ab2a52b535161a$export$29c5368be8904d27);

var $bRAhB = parcelRequire("bRAhB");
function $c7ab2a52b535161a$export$29c5368be8904d27(skeleton, locale) {
    var skeletonCopy = '';
    for(var patternPos = 0; patternPos < skeleton.length; patternPos++){
        var patternChar = skeleton.charAt(patternPos);
        if (patternChar === 'j') {
            var extraLength = 0;
            while(patternPos + 1 < skeleton.length && skeleton.charAt(patternPos + 1) === patternChar){
                extraLength++;
                patternPos++;
            }
            var hourLen = 1 + (extraLength & 1);
            var dayPeriodLen = extraLength < 2 ? 1 : 3 + (extraLength >> 1);
            var dayPeriodChar = 'a';
            var hourChar = $c7ab2a52b535161a$var$getDefaultHourSymbolFromLocale(locale);
            if (hourChar == 'H' || hourChar == 'k') dayPeriodLen = 0;
            while(dayPeriodLen-- > 0)skeletonCopy += dayPeriodChar;
            while(hourLen-- > 0)skeletonCopy = hourChar + skeletonCopy;
        } else if (patternChar === 'J') skeletonCopy += 'H';
        else skeletonCopy += patternChar;
    }
    return skeletonCopy;
}
/**
 * Maps the [hour cycle type](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/Locale/hourCycle)
 * of the given `locale` to the corresponding time pattern.
 * @param locale
 */ function $c7ab2a52b535161a$var$getDefaultHourSymbolFromLocale(locale) {
    var hourCycle = locale.hourCycle;
    if (hourCycle === undefined && // @ts-ignore hourCycle(s) is not identified yet
    locale.hourCycles && // @ts-ignore
    locale.hourCycles.length) // @ts-ignore
    hourCycle = locale.hourCycles[0];
    if (hourCycle) switch(hourCycle){
        case 'h24':
            return 'k';
        case 'h23':
            return 'H';
        case 'h12':
            return 'h';
        case 'h11':
            return 'K';
        default:
            throw new Error('Invalid hourCycle');
    }
    // TODO: Once hourCycle is fully supported remove the following with data generation
    var languageTag = locale.language;
    var regionTag;
    if (languageTag !== 'root') regionTag = locale.maximize().region;
    var hourCycles = (0, $bRAhB.timeData)[regionTag || ''] || (0, $bRAhB.timeData)[languageTag || ''] || (0, $bRAhB.timeData)["".concat(languageTag, "-001")] || (0, $bRAhB.timeData)['001'];
    return hourCycles[0];
}

});
parcelRegister("bRAhB", function(module, exports) {
$parcel$export(module.exports, "timeData", () => $8a30c9f50c999ce6$export$a8c9209db4084317);
// @generated from time-data-gen.ts
// prettier-ignore  
var $8a30c9f50c999ce6$export$a8c9209db4084317 = {
    "001": [
        "H",
        "h"
    ],
    "419": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "AC": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "AD": [
        "H",
        "hB"
    ],
    "AE": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "AF": [
        "H",
        "hb",
        "hB",
        "h"
    ],
    "AG": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "AI": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "AL": [
        "h",
        "H",
        "hB"
    ],
    "AM": [
        "H",
        "hB"
    ],
    "AO": [
        "H",
        "hB"
    ],
    "AR": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "AS": [
        "h",
        "H"
    ],
    "AT": [
        "H",
        "hB"
    ],
    "AU": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "AW": [
        "H",
        "hB"
    ],
    "AX": [
        "H"
    ],
    "AZ": [
        "H",
        "hB",
        "h"
    ],
    "BA": [
        "H",
        "hB",
        "h"
    ],
    "BB": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "BD": [
        "h",
        "hB",
        "H"
    ],
    "BE": [
        "H",
        "hB"
    ],
    "BF": [
        "H",
        "hB"
    ],
    "BG": [
        "H",
        "hB",
        "h"
    ],
    "BH": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "BI": [
        "H",
        "h"
    ],
    "BJ": [
        "H",
        "hB"
    ],
    "BL": [
        "H",
        "hB"
    ],
    "BM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "BN": [
        "hb",
        "hB",
        "h",
        "H"
    ],
    "BO": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "BQ": [
        "H"
    ],
    "BR": [
        "H",
        "hB"
    ],
    "BS": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "BT": [
        "h",
        "H"
    ],
    "BW": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "BY": [
        "H",
        "h"
    ],
    "BZ": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "CA": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "CC": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "CD": [
        "hB",
        "H"
    ],
    "CF": [
        "H",
        "h",
        "hB"
    ],
    "CG": [
        "H",
        "hB"
    ],
    "CH": [
        "H",
        "hB",
        "h"
    ],
    "CI": [
        "H",
        "hB"
    ],
    "CK": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "CL": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "CM": [
        "H",
        "h",
        "hB"
    ],
    "CN": [
        "H",
        "hB",
        "hb",
        "h"
    ],
    "CO": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "CP": [
        "H"
    ],
    "CR": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "CU": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "CV": [
        "H",
        "hB"
    ],
    "CW": [
        "H",
        "hB"
    ],
    "CX": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "CY": [
        "h",
        "H",
        "hb",
        "hB"
    ],
    "CZ": [
        "H"
    ],
    "DE": [
        "H",
        "hB"
    ],
    "DG": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "DJ": [
        "h",
        "H"
    ],
    "DK": [
        "H"
    ],
    "DM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "DO": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "DZ": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "EA": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "EC": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "EE": [
        "H",
        "hB"
    ],
    "EG": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "EH": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "ER": [
        "h",
        "H"
    ],
    "ES": [
        "H",
        "hB",
        "h",
        "hb"
    ],
    "ET": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "FI": [
        "H"
    ],
    "FJ": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "FK": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "FM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "FO": [
        "H",
        "h"
    ],
    "FR": [
        "H",
        "hB"
    ],
    "GA": [
        "H",
        "hB"
    ],
    "GB": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "GD": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "GE": [
        "H",
        "hB",
        "h"
    ],
    "GF": [
        "H",
        "hB"
    ],
    "GG": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "GH": [
        "h",
        "H"
    ],
    "GI": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "GL": [
        "H",
        "h"
    ],
    "GM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "GN": [
        "H",
        "hB"
    ],
    "GP": [
        "H",
        "hB"
    ],
    "GQ": [
        "H",
        "hB",
        "h",
        "hb"
    ],
    "GR": [
        "h",
        "H",
        "hb",
        "hB"
    ],
    "GT": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "GU": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "GW": [
        "H",
        "hB"
    ],
    "GY": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "HK": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "HN": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "HR": [
        "H",
        "hB"
    ],
    "HU": [
        "H",
        "h"
    ],
    "IC": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "ID": [
        "H"
    ],
    "IE": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "IL": [
        "H",
        "hB"
    ],
    "IM": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "IN": [
        "h",
        "H"
    ],
    "IO": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "IQ": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "IR": [
        "hB",
        "H"
    ],
    "IS": [
        "H"
    ],
    "IT": [
        "H",
        "hB"
    ],
    "JE": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "JM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "JO": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "JP": [
        "H",
        "K",
        "h"
    ],
    "KE": [
        "hB",
        "hb",
        "H",
        "h"
    ],
    "KG": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "KH": [
        "hB",
        "h",
        "H",
        "hb"
    ],
    "KI": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "KM": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "KN": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "KP": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "KR": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "KW": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "KY": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "KZ": [
        "H",
        "hB"
    ],
    "LA": [
        "H",
        "hb",
        "hB",
        "h"
    ],
    "LB": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "LC": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "LI": [
        "H",
        "hB",
        "h"
    ],
    "LK": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "LR": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "LS": [
        "h",
        "H"
    ],
    "LT": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "LU": [
        "H",
        "h",
        "hB"
    ],
    "LV": [
        "H",
        "hB",
        "hb",
        "h"
    ],
    "LY": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "MA": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "MC": [
        "H",
        "hB"
    ],
    "MD": [
        "H",
        "hB"
    ],
    "ME": [
        "H",
        "hB",
        "h"
    ],
    "MF": [
        "H",
        "hB"
    ],
    "MG": [
        "H",
        "h"
    ],
    "MH": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "MK": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "ML": [
        "H"
    ],
    "MM": [
        "hB",
        "hb",
        "H",
        "h"
    ],
    "MN": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "MO": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "MP": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "MQ": [
        "H",
        "hB"
    ],
    "MR": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "MS": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "MT": [
        "H",
        "h"
    ],
    "MU": [
        "H",
        "h"
    ],
    "MV": [
        "H",
        "h"
    ],
    "MW": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "MX": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "MY": [
        "hb",
        "hB",
        "h",
        "H"
    ],
    "MZ": [
        "H",
        "hB"
    ],
    "NA": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "NC": [
        "H",
        "hB"
    ],
    "NE": [
        "H"
    ],
    "NF": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NG": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NI": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "NL": [
        "H",
        "hB"
    ],
    "NO": [
        "H",
        "h"
    ],
    "NP": [
        "H",
        "h",
        "hB"
    ],
    "NR": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NU": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NZ": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "OM": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "PA": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "PE": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "PF": [
        "H",
        "h",
        "hB"
    ],
    "PG": [
        "h",
        "H"
    ],
    "PH": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "PK": [
        "h",
        "hB",
        "H"
    ],
    "PL": [
        "H",
        "h"
    ],
    "PM": [
        "H",
        "hB"
    ],
    "PN": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "PR": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "PS": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "PT": [
        "H",
        "hB"
    ],
    "PW": [
        "h",
        "H"
    ],
    "PY": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "QA": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "RE": [
        "H",
        "hB"
    ],
    "RO": [
        "H",
        "hB"
    ],
    "RS": [
        "H",
        "hB",
        "h"
    ],
    "RU": [
        "H"
    ],
    "RW": [
        "H",
        "h"
    ],
    "SA": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "SB": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "SC": [
        "H",
        "h",
        "hB"
    ],
    "SD": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "SE": [
        "H"
    ],
    "SG": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "SH": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "SI": [
        "H",
        "hB"
    ],
    "SJ": [
        "H"
    ],
    "SK": [
        "H"
    ],
    "SL": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "SM": [
        "H",
        "h",
        "hB"
    ],
    "SN": [
        "H",
        "h",
        "hB"
    ],
    "SO": [
        "h",
        "H"
    ],
    "SR": [
        "H",
        "hB"
    ],
    "SS": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "ST": [
        "H",
        "hB"
    ],
    "SV": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "SX": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "SY": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "SZ": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "TA": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "TC": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "TD": [
        "h",
        "H",
        "hB"
    ],
    "TF": [
        "H",
        "h",
        "hB"
    ],
    "TG": [
        "H",
        "hB"
    ],
    "TH": [
        "H",
        "h"
    ],
    "TJ": [
        "H",
        "h"
    ],
    "TL": [
        "H",
        "hB",
        "hb",
        "h"
    ],
    "TM": [
        "H",
        "h"
    ],
    "TN": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "TO": [
        "h",
        "H"
    ],
    "TR": [
        "H",
        "hB"
    ],
    "TT": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "TW": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "TZ": [
        "hB",
        "hb",
        "H",
        "h"
    ],
    "UA": [
        "H",
        "hB",
        "h"
    ],
    "UG": [
        "hB",
        "hb",
        "H",
        "h"
    ],
    "UM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "US": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "UY": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "UZ": [
        "H",
        "hB",
        "h"
    ],
    "VA": [
        "H",
        "h",
        "hB"
    ],
    "VC": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "VE": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "VG": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "VI": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "VN": [
        "H",
        "h"
    ],
    "VU": [
        "h",
        "H"
    ],
    "WF": [
        "H",
        "hB"
    ],
    "WS": [
        "h",
        "H"
    ],
    "XK": [
        "H",
        "hB",
        "h"
    ],
    "YE": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "YT": [
        "H",
        "hB"
    ],
    "ZA": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "ZM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "ZW": [
        "H",
        "h"
    ],
    "af-ZA": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "ar-001": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "ca-ES": [
        "H",
        "h",
        "hB"
    ],
    "en-001": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "en-HK": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "en-IL": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "en-MY": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "es-BR": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-ES": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-GQ": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "fr-CA": [
        "H",
        "h",
        "hB"
    ],
    "gl-ES": [
        "H",
        "h",
        "hB"
    ],
    "gu-IN": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "hi-IN": [
        "hB",
        "h",
        "H"
    ],
    "it-CH": [
        "H",
        "h",
        "hB"
    ],
    "it-IT": [
        "H",
        "h",
        "hB"
    ],
    "kn-IN": [
        "hB",
        "h",
        "H"
    ],
    "ml-IN": [
        "hB",
        "h",
        "H"
    ],
    "mr-IN": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "pa-IN": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "ta-IN": [
        "hB",
        "h",
        "hb",
        "H"
    ],
    "te-IN": [
        "hB",
        "h",
        "H"
    ],
    "zu-ZA": [
        "H",
        "hB",
        "hb",
        "h"
    ]
};

});



parcelRegister("fqZ2A", function(module, exports) {

var $kJhpj = parcelRequire("kJhpj");

var $4VghZ = parcelRequire("4VghZ");
function $b3c8a21d9d82e32d$var$cloneDeep(obj) {
    if (Array.isArray(obj)) // @ts-expect-error meh
    return (0, $kJhpj.__spreadArray)([], obj.map($b3c8a21d9d82e32d$var$cloneDeep), true);
    if (obj !== null && typeof obj === 'object') // @ts-expect-error meh
    return Object.keys(obj).reduce(function(cloned, k) {
        // @ts-expect-error meh
        cloned[k] = $b3c8a21d9d82e32d$var$cloneDeep(obj[k]);
        return cloned;
    }, {});
    return obj;
}
function $b3c8a21d9d82e32d$var$hoistPluralOrSelectElement(ast, el, positionToInject) {
    // pull this out of the ast and move it to the top
    var cloned = $b3c8a21d9d82e32d$var$cloneDeep(el);
    var options = cloned.options;
    cloned.options = Object.keys(options).reduce(function(all, k) {
        var newValue = $b3c8a21d9d82e32d$export$be5687ba8bbdf416((0, $kJhpj.__spreadArray)((0, $kJhpj.__spreadArray)((0, $kJhpj.__spreadArray)([], ast.slice(0, positionToInject), true), options[k].value, true), ast.slice(positionToInject + 1), true));
        all[k] = {
            value: newValue
        };
        return all;
    }, {});
    return cloned;
}
function $b3c8a21d9d82e32d$var$isPluralOrSelectElement(el) {
    return (0, $4VghZ.isPluralElement)(el) || (0, $4VghZ.isSelectElement)(el);
}
function $b3c8a21d9d82e32d$var$findPluralOrSelectElement(ast) {
    return !!ast.find(function(el) {
        if ($b3c8a21d9d82e32d$var$isPluralOrSelectElement(el)) return true;
        if ((0, $4VghZ.isTagElement)(el)) return $b3c8a21d9d82e32d$var$findPluralOrSelectElement(el.children);
        return false;
    });
}
function $b3c8a21d9d82e32d$export$be5687ba8bbdf416(ast) {
    for(var i = 0; i < ast.length; i++){
        var el = ast[i];
        if ($b3c8a21d9d82e32d$var$isPluralOrSelectElement(el)) return [
            $b3c8a21d9d82e32d$var$hoistPluralOrSelectElement(ast, el, i)
        ];
        if ((0, $4VghZ.isTagElement)(el) && $b3c8a21d9d82e32d$var$findPluralOrSelectElement([
            el
        ])) throw new Error('Cannot hoist plural/select within a tag element. Please put the tag element inside each plural/select option');
    }
    return ast;
}
/**
 * Collect all variables in an AST to Record<string, TYPE>
 * @param ast AST to collect variables from
 * @param vars Record of variable name to variable type
 */ function $b3c8a21d9d82e32d$var$collectVariables(ast, vars) {
    if (vars === void 0) vars = new Map();
    ast.forEach(function(el) {
        if ((0, $4VghZ.isArgumentElement)(el) || (0, $4VghZ.isDateElement)(el) || (0, $4VghZ.isTimeElement)(el) || (0, $4VghZ.isNumberElement)(el)) {
            if (el.value in vars && vars.get(el.value) !== el.type) throw new Error("Variable ".concat(el.value, " has conflicting types"));
            vars.set(el.value, el.type);
        }
        if ((0, $4VghZ.isPluralElement)(el) || (0, $4VghZ.isSelectElement)(el)) {
            vars.set(el.value, el.type);
            Object.keys(el.options).forEach(function(k) {
                $b3c8a21d9d82e32d$var$collectVariables(el.options[k].value, vars);
            });
        }
        if ((0, $4VghZ.isTagElement)(el)) {
            vars.set(el.value, el.type);
            $b3c8a21d9d82e32d$var$collectVariables(el.children, vars);
        }
    });
}
function $b3c8a21d9d82e32d$export$1edd9c892fdd9d27(a, b) {
    var aVars = new Map();
    var bVars = new Map();
    $b3c8a21d9d82e32d$var$collectVariables(a, aVars);
    $b3c8a21d9d82e32d$var$collectVariables(b, bVars);
    if (aVars.size !== bVars.size) return {
        success: false,
        error: new Error("Different number of variables: [".concat(Array.from(aVars.keys()).join(', '), "] vs [").concat(Array.from(bVars.keys()).join(', '), "]"))
    };
    return Array.from(aVars.entries()).reduce(function(result, _a) {
        var key = _a[0], type = _a[1];
        if (!result.success) return result;
        var bType = bVars.get(key);
        if (bType == null) return {
            success: false,
            error: new Error("Missing variable ".concat(key, " in message"))
        };
        if (bType !== type) return {
            success: false,
            error: new Error("Variable ".concat(key, " has conflicting types: ").concat((0, $4VghZ.TYPE)[type], " vs ").concat((0, $4VghZ.TYPE)[bType]))
        };
        return result;
    }, {
        success: true
    });
}

});


parcelRegister("b1zcR", function(module, exports) {
$parcel$export(module.exports, "PART_TYPE", () => $806b18fc72f08d6f$export$49694c2877b44c57);
$parcel$export(module.exports, "isFormatXMLElementFn", () => $806b18fc72f08d6f$export$df0c12a2d414a163);
$parcel$export(module.exports, "formatToParts", () => $806b18fc72f08d6f$export$275d4a3bb5f66fda);
parcelRequire("6dpFj");
var $4VghZ = parcelRequire("4VghZ");

var $jpwqX = parcelRequire("jpwqX");
var $806b18fc72f08d6f$export$49694c2877b44c57;
(function(PART_TYPE) {
    PART_TYPE[PART_TYPE["literal"] = 0] = "literal";
    PART_TYPE[PART_TYPE["object"] = 1] = "object";
})($806b18fc72f08d6f$export$49694c2877b44c57 || ($806b18fc72f08d6f$export$49694c2877b44c57 = {}));
function $806b18fc72f08d6f$var$mergeLiteral(parts) {
    if (parts.length < 2) return parts;
    return parts.reduce(function(all, part) {
        var lastPart = all[all.length - 1];
        if (!lastPart || lastPart.type !== $806b18fc72f08d6f$export$49694c2877b44c57.literal || part.type !== $806b18fc72f08d6f$export$49694c2877b44c57.literal) all.push(part);
        else lastPart.value += part.value;
        return all;
    }, []);
}
function $806b18fc72f08d6f$export$df0c12a2d414a163(el) {
    return typeof el === 'function';
}
function $806b18fc72f08d6f$export$275d4a3bb5f66fda(els, locales, formatters, formats, values, currentPluralValue, // For debugging
originalMessage) {
    // Hot path for straight simple msg translations
    if (els.length === 1 && (0, $4VghZ.isLiteralElement)(els[0])) return [
        {
            type: $806b18fc72f08d6f$export$49694c2877b44c57.literal,
            value: els[0].value
        }
    ];
    var result = [];
    for(var _i = 0, els_1 = els; _i < els_1.length; _i++){
        var el = els_1[_i];
        // Exit early for string parts.
        if ((0, $4VghZ.isLiteralElement)(el)) {
            result.push({
                type: $806b18fc72f08d6f$export$49694c2877b44c57.literal,
                value: el.value
            });
            continue;
        }
        // TODO: should this part be literal type?
        // Replace `#` in plural rules with the actual numeric value.
        if ((0, $4VghZ.isPoundElement)(el)) {
            if (typeof currentPluralValue === 'number') result.push({
                type: $806b18fc72f08d6f$export$49694c2877b44c57.literal,
                value: formatters.getNumberFormat(locales).format(currentPluralValue)
            });
            continue;
        }
        var varName = el.value;
        // Enforce that all required values are provided by the caller.
        if (!(values && varName in values)) throw new (0, $jpwqX.MissingValueError)(varName, originalMessage);
        var value = values[varName];
        if ((0, $4VghZ.isArgumentElement)(el)) {
            if (!value || typeof value === 'string' || typeof value === 'number') value = typeof value === 'string' || typeof value === 'number' ? String(value) : '';
            result.push({
                type: typeof value === 'string' ? $806b18fc72f08d6f$export$49694c2877b44c57.literal : $806b18fc72f08d6f$export$49694c2877b44c57.object,
                value: value
            });
            continue;
        }
        // Recursively format plural and select parts' option — which can be a
        // nested pattern structure. The choosing of the option to use is
        // abstracted-by and delegated-to the part helper object.
        if ((0, $4VghZ.isDateElement)(el)) {
            var style = typeof el.style === 'string' ? formats.date[el.style] : (0, $4VghZ.isDateTimeSkeleton)(el.style) ? el.style.parsedOptions : undefined;
            result.push({
                type: $806b18fc72f08d6f$export$49694c2877b44c57.literal,
                value: formatters.getDateTimeFormat(locales, style).format(value)
            });
            continue;
        }
        if ((0, $4VghZ.isTimeElement)(el)) {
            var style = typeof el.style === 'string' ? formats.time[el.style] : (0, $4VghZ.isDateTimeSkeleton)(el.style) ? el.style.parsedOptions : formats.time.medium;
            result.push({
                type: $806b18fc72f08d6f$export$49694c2877b44c57.literal,
                value: formatters.getDateTimeFormat(locales, style).format(value)
            });
            continue;
        }
        if ((0, $4VghZ.isNumberElement)(el)) {
            var style = typeof el.style === 'string' ? formats.number[el.style] : (0, $4VghZ.isNumberSkeleton)(el.style) ? el.style.parsedOptions : undefined;
            if (style && style.scale) value = value * (style.scale || 1);
            result.push({
                type: $806b18fc72f08d6f$export$49694c2877b44c57.literal,
                value: formatters.getNumberFormat(locales, style).format(value)
            });
            continue;
        }
        if ((0, $4VghZ.isTagElement)(el)) {
            var children = el.children, value_1 = el.value;
            var formatFn = values[value_1];
            if (!$806b18fc72f08d6f$export$df0c12a2d414a163(formatFn)) throw new (0, $jpwqX.InvalidValueTypeError)(value_1, 'function', originalMessage);
            var parts = $806b18fc72f08d6f$export$275d4a3bb5f66fda(children, locales, formatters, formats, values, currentPluralValue);
            var chunks = formatFn(parts.map(function(p) {
                return p.value;
            }));
            if (!Array.isArray(chunks)) chunks = [
                chunks
            ];
            result.push.apply(result, chunks.map(function(c) {
                return {
                    type: typeof c === 'string' ? $806b18fc72f08d6f$export$49694c2877b44c57.literal : $806b18fc72f08d6f$export$49694c2877b44c57.object,
                    value: c
                };
            }));
        }
        if ((0, $4VghZ.isSelectElement)(el)) {
            var opt = el.options[value] || el.options.other;
            if (!opt) throw new (0, $jpwqX.InvalidValueError)(el.value, value, Object.keys(el.options), originalMessage);
            result.push.apply(result, $806b18fc72f08d6f$export$275d4a3bb5f66fda(opt.value, locales, formatters, formats, values));
            continue;
        }
        if ((0, $4VghZ.isPluralElement)(el)) {
            var opt = el.options["=".concat(value)];
            if (!opt) {
                if (!Intl.PluralRules) throw new (0, $jpwqX.FormatError)("Intl.PluralRules is not available in this environment.\nTry polyfilling it using \"@formatjs/intl-pluralrules\"\n", (0, $jpwqX.ErrorCode).MISSING_INTL_API, originalMessage);
                var rule = formatters.getPluralRules(locales, {
                    type: el.pluralType
                }).select(value - (el.offset || 0));
                opt = el.options[rule] || el.options.other;
            }
            if (!opt) throw new (0, $jpwqX.InvalidValueError)(el.value, value, Object.keys(el.options), originalMessage);
            result.push.apply(result, $806b18fc72f08d6f$export$275d4a3bb5f66fda(opt.value, locales, formatters, formats, values, value - (el.offset || 0)));
            continue;
        }
    }
    return $806b18fc72f08d6f$var$mergeLiteral(result);
}

});
parcelRegister("jpwqX", function(module, exports) {
$parcel$export(module.exports, "ErrorCode", () => $e21982ce468ea34f$export$d4e71bc0b80dc0fb);
$parcel$export(module.exports, "FormatError", () => $e21982ce468ea34f$export$7369836851cc1329);
$parcel$export(module.exports, "InvalidValueError", () => $e21982ce468ea34f$export$565c3afc07dfa382);
$parcel$export(module.exports, "InvalidValueTypeError", () => $e21982ce468ea34f$export$cbc0db47c750f7c9);
$parcel$export(module.exports, "MissingValueError", () => $e21982ce468ea34f$export$8bfc137e4d23fdf0);

var $kJhpj = parcelRequire("kJhpj");
var $e21982ce468ea34f$export$d4e71bc0b80dc0fb;
(function(ErrorCode) {
    // When we have a placeholder but no value to format
    ErrorCode["MISSING_VALUE"] = "MISSING_VALUE";
    // When value supplied is invalid
    ErrorCode["INVALID_VALUE"] = "INVALID_VALUE";
    // When we need specific Intl API but it's not available
    ErrorCode["MISSING_INTL_API"] = "MISSING_INTL_API";
})($e21982ce468ea34f$export$d4e71bc0b80dc0fb || ($e21982ce468ea34f$export$d4e71bc0b80dc0fb = {}));
var $e21982ce468ea34f$export$7369836851cc1329 = /** @class */ function(_super) {
    (0, $kJhpj.__extends)(FormatError, _super);
    function FormatError(msg, code, originalMessage) {
        var _this = _super.call(this, msg) || this;
        _this.code = code;
        _this.originalMessage = originalMessage;
        return _this;
    }
    FormatError.prototype.toString = function() {
        return "[formatjs Error: ".concat(this.code, "] ").concat(this.message);
    };
    return FormatError;
}(Error);
var $e21982ce468ea34f$export$565c3afc07dfa382 = /** @class */ function(_super) {
    (0, $kJhpj.__extends)(InvalidValueError, _super);
    function InvalidValueError(variableId, value, options, originalMessage) {
        return _super.call(this, "Invalid values for \"".concat(variableId, "\": \"").concat(value, "\". Options are \"").concat(Object.keys(options).join('", "'), "\""), $e21982ce468ea34f$export$d4e71bc0b80dc0fb.INVALID_VALUE, originalMessage) || this;
    }
    return InvalidValueError;
}($e21982ce468ea34f$export$7369836851cc1329);
var $e21982ce468ea34f$export$cbc0db47c750f7c9 = /** @class */ function(_super) {
    (0, $kJhpj.__extends)(InvalidValueTypeError, _super);
    function InvalidValueTypeError(value, type, originalMessage) {
        return _super.call(this, "Value for \"".concat(value, "\" must be of type ").concat(type), $e21982ce468ea34f$export$d4e71bc0b80dc0fb.INVALID_VALUE, originalMessage) || this;
    }
    return InvalidValueTypeError;
}($e21982ce468ea34f$export$7369836851cc1329);
var $e21982ce468ea34f$export$8bfc137e4d23fdf0 = /** @class */ function(_super) {
    (0, $kJhpj.__extends)(MissingValueError, _super);
    function MissingValueError(variableId, originalMessage) {
        return _super.call(this, "The intl string context variable \"".concat(variableId, "\" was not provided to the string \"").concat(originalMessage, "\""), $e21982ce468ea34f$export$d4e71bc0b80dc0fb.MISSING_VALUE, originalMessage) || this;
    }
    return MissingValueError;
}($e21982ce468ea34f$export$7369836851cc1329);

});




parcelRegister("lxO85", function(module, exports) {
$parcel$export(module.exports, "UnsupportedFormatterError", () => $faf390ae03ac8755$export$549f97e137a05c90);
$parcel$export(module.exports, "InvalidConfigError", () => $faf390ae03ac8755$export$3ca04dd7fb305893);
$parcel$export(module.exports, "MissingDataError", () => $faf390ae03ac8755$export$c1eaf877d81384b6);
$parcel$export(module.exports, "IntlFormatError", () => $faf390ae03ac8755$export$e3b7eee1dbc44895);
$parcel$export(module.exports, "MessageFormatError", () => $faf390ae03ac8755$export$74a601a3d3f31621);
$parcel$export(module.exports, "MissingTranslationError", () => $faf390ae03ac8755$export$2ddcb436d0aa3688);

var $kJhpj = parcelRequire("kJhpj");
var $faf390ae03ac8755$export$557d6acb76e8a244;
(function(IntlErrorCode) {
    IntlErrorCode["FORMAT_ERROR"] = "FORMAT_ERROR";
    IntlErrorCode["UNSUPPORTED_FORMATTER"] = "UNSUPPORTED_FORMATTER";
    IntlErrorCode["INVALID_CONFIG"] = "INVALID_CONFIG";
    IntlErrorCode["MISSING_DATA"] = "MISSING_DATA";
    IntlErrorCode["MISSING_TRANSLATION"] = "MISSING_TRANSLATION";
})($faf390ae03ac8755$export$557d6acb76e8a244 || ($faf390ae03ac8755$export$557d6acb76e8a244 = {}));
var $faf390ae03ac8755$export$c016d36112f6ddf8 = /** @class */ function(_super) {
    (0, $kJhpj.__extends)(IntlError, _super);
    function IntlError(code, message, exception) {
        var _this = this;
        var err = exception ? exception instanceof Error ? exception : new Error(String(exception)) : undefined;
        _this = _super.call(this, "[@formatjs/intl Error ".concat(code, "] ").concat(message, "\n").concat(err ? "\n".concat(err.message, "\n").concat(err.stack) : '')) || this;
        _this.code = code;
        // @ts-ignore just so we don't need to declare dep on @types/node
        if (typeof Error.captureStackTrace === 'function') // @ts-ignore just so we don't need to declare dep on @types/node
        Error.captureStackTrace(_this, IntlError);
        return _this;
    }
    return IntlError;
}(Error);
var $faf390ae03ac8755$export$549f97e137a05c90 = /** @class */ function(_super) {
    (0, $kJhpj.__extends)(UnsupportedFormatterError, _super);
    function UnsupportedFormatterError(message, exception) {
        return _super.call(this, $faf390ae03ac8755$export$557d6acb76e8a244.UNSUPPORTED_FORMATTER, message, exception) || this;
    }
    return UnsupportedFormatterError;
}($faf390ae03ac8755$export$c016d36112f6ddf8);
var $faf390ae03ac8755$export$3ca04dd7fb305893 = /** @class */ function(_super) {
    (0, $kJhpj.__extends)(InvalidConfigError, _super);
    function InvalidConfigError(message, exception) {
        return _super.call(this, $faf390ae03ac8755$export$557d6acb76e8a244.INVALID_CONFIG, message, exception) || this;
    }
    return InvalidConfigError;
}($faf390ae03ac8755$export$c016d36112f6ddf8);
var $faf390ae03ac8755$export$c1eaf877d81384b6 = /** @class */ function(_super) {
    (0, $kJhpj.__extends)(MissingDataError, _super);
    function MissingDataError(message, exception) {
        return _super.call(this, $faf390ae03ac8755$export$557d6acb76e8a244.MISSING_DATA, message, exception) || this;
    }
    return MissingDataError;
}($faf390ae03ac8755$export$c016d36112f6ddf8);
var $faf390ae03ac8755$export$e3b7eee1dbc44895 = /** @class */ function(_super) {
    (0, $kJhpj.__extends)(IntlFormatError, _super);
    function IntlFormatError(message, locale, exception) {
        var _this = _super.call(this, $faf390ae03ac8755$export$557d6acb76e8a244.FORMAT_ERROR, "".concat(message, "\nLocale: ").concat(locale, "\n"), exception) || this;
        _this.locale = locale;
        return _this;
    }
    return IntlFormatError;
}($faf390ae03ac8755$export$c016d36112f6ddf8);
var $faf390ae03ac8755$export$74a601a3d3f31621 = /** @class */ function(_super) {
    (0, $kJhpj.__extends)(MessageFormatError, _super);
    function MessageFormatError(message, locale, descriptor, exception) {
        var _this = _super.call(this, "".concat(message, "\nMessageID: ").concat(descriptor === null || descriptor === void 0 ? void 0 : descriptor.id, "\nDefault Message: ").concat(descriptor === null || descriptor === void 0 ? void 0 : descriptor.defaultMessage, "\nDescription: ").concat(descriptor === null || descriptor === void 0 ? void 0 : descriptor.description, "\n"), locale, exception) || this;
        _this.descriptor = descriptor;
        _this.locale = locale;
        return _this;
    }
    return MessageFormatError;
}($faf390ae03ac8755$export$e3b7eee1dbc44895);
var $faf390ae03ac8755$export$2ddcb436d0aa3688 = /** @class */ function(_super) {
    (0, $kJhpj.__extends)(MissingTranslationError, _super);
    function MissingTranslationError(descriptor, locale) {
        var _this = _super.call(this, $faf390ae03ac8755$export$557d6acb76e8a244.MISSING_TRANSLATION, "Missing message: \"".concat(descriptor.id, "\" for locale \"").concat(locale, "\", using ").concat(descriptor.defaultMessage ? "default message (".concat(typeof descriptor.defaultMessage === 'string' ? descriptor.defaultMessage : descriptor.defaultMessage.map(function(e) {
            var _a;
            return (_a = e.value) !== null && _a !== void 0 ? _a : JSON.stringify(e);
        }).join(), ")") : 'id', " as fallback.")) || this;
        _this.descriptor = descriptor;
        return _this;
    }
    return MissingTranslationError;
}($faf390ae03ac8755$export$c016d36112f6ddf8);

});



parcelRegister("ach6K", function(module, exports) {
$parcel$export(module.exports, "Provider", () => $76c84ba0e6a0ff47$export$2881499e37b75b9a);
$parcel$export(module.exports, "Context", () => $76c84ba0e6a0ff47$export$841858b892ce1f4c);

var $kJhpj = parcelRequire("kJhpj");

var $knBeW = parcelRequire("knBeW");

var $5FkrB = parcelRequire("5FkrB");

var $5Kjrj = parcelRequire("5Kjrj");
function $76c84ba0e6a0ff47$var$getDisplayName(Component) {
    return Component.displayName || Component.name || 'Component';
}
// This is primarily dealing with packaging systems where multiple copies of react-intl
// might exist
var $76c84ba0e6a0ff47$var$IntlContext = typeof window !== 'undefined' && !window.__REACT_INTL_BYPASS_GLOBAL_CONTEXT__ ? window.__REACT_INTL_CONTEXT__ || (window.__REACT_INTL_CONTEXT__ = $5FkrB.createContext(null)) : $5FkrB.createContext(null);
var $76c84ba0e6a0ff47$var$IntlConsumer = $76c84ba0e6a0ff47$var$IntlContext.Consumer, $76c84ba0e6a0ff47$var$IntlProvider = $76c84ba0e6a0ff47$var$IntlContext.Provider;
var $76c84ba0e6a0ff47$export$2881499e37b75b9a = $76c84ba0e6a0ff47$var$IntlProvider;
var $76c84ba0e6a0ff47$export$841858b892ce1f4c = $76c84ba0e6a0ff47$var$IntlContext;
function $76c84ba0e6a0ff47$export$2e2bcd8739ae039(WrappedComponent, options) {
    var _a = options || {}, _b = _a.intlPropName, intlPropName = _b === void 0 ? 'intl' : _b, _c = _a.forwardRef, forwardRef = _c === void 0 ? false : _c, _d = _a.enforceContext, enforceContext = _d === void 0 ? true : _d;
    var WithIntl = function(props) {
        return $5FkrB.createElement($76c84ba0e6a0ff47$var$IntlConsumer, null, function(intl) {
            var _a;
            if (enforceContext) (0, $5Kjrj.invariantIntlContext)(intl);
            var intlProp = (_a = {}, _a[intlPropName] = intl, _a);
            return $5FkrB.createElement(WrappedComponent, (0, $kJhpj.__assign)({}, props, intlProp, {
                ref: forwardRef ? props.forwardedRef : null
            }));
        });
    };
    WithIntl.displayName = "injectIntl(".concat($76c84ba0e6a0ff47$var$getDisplayName(WrappedComponent), ")");
    WithIntl.WrappedComponent = WrappedComponent;
    if (forwardRef) return (0, (/*@__PURE__*/$parcel$interopDefault($knBeW)))(// @ts-expect-error
    $5FkrB.forwardRef(function(props, ref) {
        return $5FkrB.createElement(WithIntl, (0, $kJhpj.__assign)({}, props, {
            forwardedRef: ref
        }));
    }), WrappedComponent);
    return (0, (/*@__PURE__*/$parcel$interopDefault($knBeW)))(WithIntl, WrappedComponent);
}

});



parcelRegister("bgNpv", function(module, exports) {
$parcel$export(module.exports, "default", () => $8347842f191e39da$export$2e2bcd8739ae039);
/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */ 
var $kJhpj = parcelRequire("kJhpj");

var $5FkrB = parcelRequire("5FkrB");

var $5Kjrj = parcelRequire("5Kjrj");

var $hrVKU = parcelRequire("hrVKU");
function $8347842f191e39da$var$areEqual(prevProps, nextProps) {
    var values = prevProps.values, otherProps = (0, $kJhpj.__rest)(prevProps, [
        "values"
    ]);
    var nextValues = nextProps.values, nextOtherProps = (0, $kJhpj.__rest)(nextProps, [
        "values"
    ]);
    return (0, $5Kjrj.shallowEqual)(nextValues, values) && (0, $5Kjrj.shallowEqual)(otherProps, nextOtherProps);
}
function $8347842f191e39da$var$FormattedMessage(props) {
    var intl = (0, $hrVKU.default)();
    var formatMessage = intl.formatMessage, _a = intl.textComponent, Text = _a === void 0 ? $5FkrB.Fragment : _a;
    var id = props.id, description = props.description, defaultMessage = props.defaultMessage, values = props.values, children = props.children, _b = props.tagName, Component = _b === void 0 ? Text : _b, ignoreTag = props.ignoreTag;
    var descriptor = {
        id: id,
        description: description,
        defaultMessage: defaultMessage
    };
    var nodes = formatMessage(descriptor, values, {
        ignoreTag: ignoreTag
    });
    if (typeof children === 'function') return children(Array.isArray(nodes) ? nodes : [
        nodes
    ]);
    if (Component) return $5FkrB.createElement(Component, null, nodes);
    return $5FkrB.createElement($5FkrB.Fragment, null, nodes);
}
$8347842f191e39da$var$FormattedMessage.displayName = 'FormattedMessage';
var $8347842f191e39da$var$MemoizedFormattedMessage = $5FkrB.memo($8347842f191e39da$var$FormattedMessage, $8347842f191e39da$var$areEqual);
$8347842f191e39da$var$MemoizedFormattedMessage.displayName = 'MemoizedFormattedMessage';
var $8347842f191e39da$export$2e2bcd8739ae039 = $8347842f191e39da$var$MemoizedFormattedMessage;

});

parcelRegister("9Pk7k", function(module, exports) {
$parcel$export(module.exports, "default", () => $72787b545755cf1e$export$2e2bcd8739ae039);
/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */ 
var $kJhpj = parcelRequire("kJhpj");

var $ftB2S = parcelRequire("ftB2S");

var $5FkrB = parcelRequire("5FkrB");

var $5Kjrj = parcelRequire("5Kjrj");

var $iQZad = parcelRequire("iQZad");

var $ach6K = parcelRequire("ach6K");
function $72787b545755cf1e$var$processIntlConfig(config) {
    return {
        locale: config.locale,
        timeZone: config.timeZone,
        fallbackOnEmptyString: config.fallbackOnEmptyString,
        formats: config.formats,
        textComponent: config.textComponent,
        messages: config.messages,
        defaultLocale: config.defaultLocale,
        defaultFormats: config.defaultFormats,
        onError: config.onError,
        onWarn: config.onWarn,
        wrapRichTextChunksInFragment: config.wrapRichTextChunksInFragment,
        defaultRichTextElements: config.defaultRichTextElements
    };
}
var $72787b545755cf1e$var$IntlProvider = /** @class */ function(_super) {
    (0, $kJhpj.__extends)(IntlProvider, _super);
    function IntlProvider() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.cache = (0, $ftB2S.createIntlCache)();
        _this.state = {
            cache: _this.cache,
            intl: (0, $iQZad.createIntl)($72787b545755cf1e$var$processIntlConfig(_this.props), _this.cache),
            prevConfig: $72787b545755cf1e$var$processIntlConfig(_this.props)
        };
        return _this;
    }
    IntlProvider.getDerivedStateFromProps = function(props, _a) {
        var prevConfig = _a.prevConfig, cache = _a.cache;
        var config = $72787b545755cf1e$var$processIntlConfig(props);
        if (!(0, $5Kjrj.shallowEqual)(prevConfig, config)) return {
            intl: (0, $iQZad.createIntl)(config, cache),
            prevConfig: config
        };
        return null;
    };
    IntlProvider.prototype.render = function() {
        (0, $5Kjrj.invariantIntlContext)(this.state.intl);
        return $5FkrB.createElement((0, $ach6K.Provider), {
            value: this.state.intl
        }, this.props.children);
    };
    IntlProvider.displayName = 'IntlProvider';
    IntlProvider.defaultProps = (0, $5Kjrj.DEFAULT_INTL_CONFIG);
    return IntlProvider;
}($5FkrB.PureComponent);
var $72787b545755cf1e$export$2e2bcd8739ae039 = $72787b545755cf1e$var$IntlProvider;

});
parcelRegister("iQZad", function(module, exports) {
$parcel$export(module.exports, "createIntl", () => $db9c872d0c1a07a2$export$7e4cbedfdd7b4c0d);
/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */ 
var $kJhpj = parcelRequire("kJhpj");

var $htSVt = parcelRequire("htSVt");
var $2k5ES = parcelRequire("2k5ES");

var $b1zcR = parcelRequire("b1zcR");

var $5Kjrj = parcelRequire("5Kjrj");
function $db9c872d0c1a07a2$var$assignUniqueKeysToFormatXMLElementFnArgument(values) {
    if (!values) return values;
    return Object.keys(values).reduce(function(acc, k) {
        var v = values[k];
        acc[k] = (0, $b1zcR.isFormatXMLElementFn)(v) ? (0, $5Kjrj.assignUniqueKeysToParts)(v) : v;
        return acc;
    }, {});
}
var $db9c872d0c1a07a2$var$formatMessage = function(config, formatters, descriptor, rawValues) {
    var rest = [];
    for(var _i = 4; _i < arguments.length; _i++)rest[_i - 4] = arguments[_i];
    var values = $db9c872d0c1a07a2$var$assignUniqueKeysToFormatXMLElementFnArgument(rawValues);
    var chunks = (0, $2k5ES.formatMessage).apply(void 0, (0, $kJhpj.__spreadArray)([
        config,
        formatters,
        descriptor,
        values
    ], rest, false));
    if (Array.isArray(chunks)) return (0, $5Kjrj.toKeyedReactNodeArray)(chunks);
    return chunks;
};
var $db9c872d0c1a07a2$export$7e4cbedfdd7b4c0d = function(_a, cache) {
    var rawDefaultRichTextElements = _a.defaultRichTextElements, config = (0, $kJhpj.__rest)(_a, [
        "defaultRichTextElements"
    ]);
    var defaultRichTextElements = $db9c872d0c1a07a2$var$assignUniqueKeysToFormatXMLElementFnArgument(rawDefaultRichTextElements);
    var coreIntl = (0, $htSVt.createIntl)((0, $kJhpj.__assign)((0, $kJhpj.__assign)((0, $kJhpj.__assign)({}, (0, $5Kjrj.DEFAULT_INTL_CONFIG)), config), {
        defaultRichTextElements: defaultRichTextElements
    }), cache);
    var resolvedConfig = {
        locale: coreIntl.locale,
        timeZone: coreIntl.timeZone,
        fallbackOnEmptyString: coreIntl.fallbackOnEmptyString,
        formats: coreIntl.formats,
        defaultLocale: coreIntl.defaultLocale,
        defaultFormats: coreIntl.defaultFormats,
        messages: coreIntl.messages,
        onError: coreIntl.onError,
        defaultRichTextElements: defaultRichTextElements
    };
    return (0, $kJhpj.__assign)((0, $kJhpj.__assign)({}, coreIntl), {
        formatMessage: $db9c872d0c1a07a2$var$formatMessage.bind(null, resolvedConfig, coreIntl.formatters),
        $t: $db9c872d0c1a07a2$var$formatMessage.bind(null, resolvedConfig, coreIntl.formatters)
    });
};

});
parcelRegister("htSVt", function(module, exports) {
$parcel$export(module.exports, "createIntl", () => $cb9fc0461b2a2e42$export$7e4cbedfdd7b4c0d);

var $kJhpj = parcelRequire("kJhpj");

var $63ABF = parcelRequire("63ABF");

var $bNLaT = parcelRequire("bNLaT");

var $lxO85 = parcelRequire("lxO85");

var $cEdDX = parcelRequire("cEdDX");

var $2k5ES = parcelRequire("2k5ES");

var $8IvbH = parcelRequire("8IvbH");

var $37L44 = parcelRequire("37L44");

var $3h18O = parcelRequire("3h18O");

var $ftB2S = parcelRequire("ftB2S");
function $cb9fc0461b2a2e42$var$messagesContainString(messages) {
    var firstMessage = messages ? messages[Object.keys(messages)[0]] : undefined;
    return typeof firstMessage === 'string';
}
function $cb9fc0461b2a2e42$var$verifyConfigMessages(config) {
    if (config.onWarn && config.defaultRichTextElements && $cb9fc0461b2a2e42$var$messagesContainString(config.messages || {})) config.onWarn("[@formatjs/intl] \"defaultRichTextElements\" was specified but \"message\" was not pre-compiled. \nPlease consider using \"@formatjs/cli\" to pre-compile your messages for performance.\nFor more details see https://formatjs.github.io/docs/getting-started/message-distribution");
}
function $cb9fc0461b2a2e42$export$7e4cbedfdd7b4c0d(config, cache) {
    var formatters = (0, $ftB2S.createFormatters)(cache);
    var resolvedConfig = (0, $kJhpj.__assign)((0, $kJhpj.__assign)({}, (0, $ftB2S.DEFAULT_INTL_CONFIG)), config);
    var locale = resolvedConfig.locale, defaultLocale = resolvedConfig.defaultLocale, onError = resolvedConfig.onError;
    if (!locale) {
        if (onError) onError(new (0, $lxO85.InvalidConfigError)("\"locale\" was not configured, using \"".concat(defaultLocale, "\" as fallback. See https://formatjs.github.io/docs/react-intl/api#intlshape for more details")));
        // Since there's no registered locale data for `locale`, this will
        // fallback to the `defaultLocale` to make sure things can render.
        // The `messages` are overridden to the `defaultProps` empty object
        // to maintain referential equality across re-renders. It's assumed
        // each <FormattedMessage> contains a `defaultMessage` prop.
        resolvedConfig.locale = resolvedConfig.defaultLocale || 'en';
    } else if (!Intl.NumberFormat.supportedLocalesOf(locale).length && onError) onError(new (0, $lxO85.MissingDataError)("Missing locale data for locale: \"".concat(locale, "\" in Intl.NumberFormat. Using default locale: \"").concat(defaultLocale, "\" as fallback. See https://formatjs.github.io/docs/react-intl#runtime-requirements for more details")));
    else if (!Intl.DateTimeFormat.supportedLocalesOf(locale).length && onError) onError(new (0, $lxO85.MissingDataError)("Missing locale data for locale: \"".concat(locale, "\" in Intl.DateTimeFormat. Using default locale: \"").concat(defaultLocale, "\" as fallback. See https://formatjs.github.io/docs/react-intl#runtime-requirements for more details")));
    $cb9fc0461b2a2e42$var$verifyConfigMessages(resolvedConfig);
    return (0, $kJhpj.__assign)((0, $kJhpj.__assign)({}, resolvedConfig), {
        formatters: formatters,
        formatNumber: (0, $8IvbH.formatNumber).bind(null, resolvedConfig, formatters.getNumberFormat),
        formatNumberToParts: (0, $8IvbH.formatNumberToParts).bind(null, resolvedConfig, formatters.getNumberFormat),
        formatRelativeTime: (0, $3h18O.formatRelativeTime).bind(null, resolvedConfig, formatters.getRelativeTimeFormat),
        formatDate: (0, $63ABF.formatDate).bind(null, resolvedConfig, formatters.getDateTimeFormat),
        formatDateToParts: (0, $63ABF.formatDateToParts).bind(null, resolvedConfig, formatters.getDateTimeFormat),
        formatTime: (0, $63ABF.formatTime).bind(null, resolvedConfig, formatters.getDateTimeFormat),
        formatDateTimeRange: (0, $63ABF.formatDateTimeRange).bind(null, resolvedConfig, formatters.getDateTimeFormat),
        formatTimeToParts: (0, $63ABF.formatTimeToParts).bind(null, resolvedConfig, formatters.getDateTimeFormat),
        formatPlural: (0, $37L44.formatPlural).bind(null, resolvedConfig, formatters.getPluralRules),
        formatMessage: (0, $2k5ES.formatMessage).bind(null, resolvedConfig, formatters),
        $t: (0, $2k5ES.formatMessage).bind(null, resolvedConfig, formatters),
        formatList: (0, $cEdDX.formatList).bind(null, resolvedConfig, formatters.getListFormat),
        formatListToParts: (0, $cEdDX.formatListToParts).bind(null, resolvedConfig, formatters.getListFormat),
        formatDisplayName: (0, $bNLaT.formatDisplayName).bind(null, resolvedConfig, formatters.getDisplayNames)
    });
}

});
parcelRegister("63ABF", function(module, exports) {
$parcel$export(module.exports, "formatDate", () => $468f6b2d6b5b6e33$export$3ae94a2503e890a1);
$parcel$export(module.exports, "formatTime", () => $468f6b2d6b5b6e33$export$3203edd9e5edd663);
$parcel$export(module.exports, "formatDateTimeRange", () => $468f6b2d6b5b6e33$export$a7fc3a91cb2ec376);
$parcel$export(module.exports, "formatDateToParts", () => $468f6b2d6b5b6e33$export$dc1f059bce486b1);
$parcel$export(module.exports, "formatTimeToParts", () => $468f6b2d6b5b6e33$export$af6e5d7a5c73edeb);

var $kJhpj = parcelRequire("kJhpj");

var $lxO85 = parcelRequire("lxO85");

var $ftB2S = parcelRequire("ftB2S");
var $468f6b2d6b5b6e33$var$DATE_TIME_FORMAT_OPTIONS = [
    'formatMatcher',
    'timeZone',
    'hour12',
    'weekday',
    'era',
    'year',
    'month',
    'day',
    'hour',
    'minute',
    'second',
    'timeZoneName',
    'hourCycle',
    'dateStyle',
    'timeStyle',
    'calendar',
    // 'dayPeriod',
    'numberingSystem',
    'fractionalSecondDigits'
];
function $468f6b2d6b5b6e33$export$a7f9565e3c81cd54(_a, type, getDateTimeFormat, options) {
    var locale = _a.locale, formats = _a.formats, onError = _a.onError, timeZone = _a.timeZone;
    if (options === void 0) options = {};
    var format = options.format;
    var defaults = (0, $kJhpj.__assign)((0, $kJhpj.__assign)({}, timeZone && {
        timeZone: timeZone
    }), format && (0, $ftB2S.getNamedFormat)(formats, type, format, onError));
    var filteredOptions = (0, $ftB2S.filterProps)(options, $468f6b2d6b5b6e33$var$DATE_TIME_FORMAT_OPTIONS, defaults);
    if (type === 'time' && !filteredOptions.hour && !filteredOptions.minute && !filteredOptions.second && !filteredOptions.timeStyle && !filteredOptions.dateStyle) // Add default formatting options if hour, minute, or second isn't defined.
    filteredOptions = (0, $kJhpj.__assign)((0, $kJhpj.__assign)({}, filteredOptions), {
        hour: 'numeric',
        minute: 'numeric'
    });
    return getDateTimeFormat(locale, filteredOptions);
}
function $468f6b2d6b5b6e33$export$3ae94a2503e890a1(config, getDateTimeFormat) {
    var _a = [];
    for(var _i = 2; _i < arguments.length; _i++)_a[_i - 2] = arguments[_i];
    var value = _a[0], _b = _a[1], options = _b === void 0 ? {} : _b;
    var date = typeof value === 'string' ? new Date(value || 0) : value;
    try {
        return $468f6b2d6b5b6e33$export$a7f9565e3c81cd54(config, 'date', getDateTimeFormat, options).format(date);
    } catch (e) {
        config.onError(new (0, $lxO85.IntlFormatError)('Error formatting date.', config.locale, e));
    }
    return String(date);
}
function $468f6b2d6b5b6e33$export$3203edd9e5edd663(config, getDateTimeFormat) {
    var _a = [];
    for(var _i = 2; _i < arguments.length; _i++)_a[_i - 2] = arguments[_i];
    var value = _a[0], _b = _a[1], options = _b === void 0 ? {} : _b;
    var date = typeof value === 'string' ? new Date(value || 0) : value;
    try {
        return $468f6b2d6b5b6e33$export$a7f9565e3c81cd54(config, 'time', getDateTimeFormat, options).format(date);
    } catch (e) {
        config.onError(new (0, $lxO85.IntlFormatError)('Error formatting time.', config.locale, e));
    }
    return String(date);
}
function $468f6b2d6b5b6e33$export$a7fc3a91cb2ec376(config, getDateTimeFormat) {
    var _a = [];
    for(var _i = 2; _i < arguments.length; _i++)_a[_i - 2] = arguments[_i];
    var from = _a[0], to = _a[1], _b = _a[2], options = _b === void 0 ? {} : _b;
    var fromDate = typeof from === 'string' ? new Date(from || 0) : from;
    var toDate = typeof to === 'string' ? new Date(to || 0) : to;
    try {
        return $468f6b2d6b5b6e33$export$a7f9565e3c81cd54(config, 'dateTimeRange', getDateTimeFormat, options).formatRange(fromDate, toDate);
    } catch (e) {
        config.onError(new (0, $lxO85.IntlFormatError)('Error formatting date time range.', config.locale, e));
    }
    return String(fromDate);
}
function $468f6b2d6b5b6e33$export$dc1f059bce486b1(config, getDateTimeFormat) {
    var _a = [];
    for(var _i = 2; _i < arguments.length; _i++)_a[_i - 2] = arguments[_i];
    var value = _a[0], _b = _a[1], options = _b === void 0 ? {} : _b;
    var date = typeof value === 'string' ? new Date(value || 0) : value;
    try {
        return $468f6b2d6b5b6e33$export$a7f9565e3c81cd54(config, 'date', getDateTimeFormat, options).formatToParts(date); // TODO: remove this when https://github.com/microsoft/TypeScript/pull/50402 is merged
    } catch (e) {
        config.onError(new (0, $lxO85.IntlFormatError)('Error formatting date.', config.locale, e));
    }
    return [];
}
function $468f6b2d6b5b6e33$export$af6e5d7a5c73edeb(config, getDateTimeFormat) {
    var _a = [];
    for(var _i = 2; _i < arguments.length; _i++)_a[_i - 2] = arguments[_i];
    var value = _a[0], _b = _a[1], options = _b === void 0 ? {} : _b;
    var date = typeof value === 'string' ? new Date(value || 0) : value;
    try {
        return $468f6b2d6b5b6e33$export$a7f9565e3c81cd54(config, 'time', getDateTimeFormat, options).formatToParts(date); // TODO: remove this when https://github.com/microsoft/TypeScript/pull/50402 is merged
    } catch (e) {
        config.onError(new (0, $lxO85.IntlFormatError)('Error formatting time.', config.locale, e));
    }
    return [];
}

});

parcelRegister("bNLaT", function(module, exports) {
$parcel$export(module.exports, "formatDisplayName", () => $8978dd3e5f4a7a94$export$62fe1a4d9e891fa2);

var $ftB2S = parcelRequire("ftB2S");

var $jpwqX = parcelRequire("jpwqX");

var $lxO85 = parcelRequire("lxO85");
var $8978dd3e5f4a7a94$var$DISPLAY_NAMES_OPTONS = [
    'style',
    'type',
    'fallback',
    'languageDisplay'
];
function $8978dd3e5f4a7a94$export$62fe1a4d9e891fa2(_a, getDisplayNames, value, options) {
    var locale = _a.locale, onError = _a.onError;
    var DisplayNames = Intl.DisplayNames;
    if (!DisplayNames) onError(new (0, $jpwqX.FormatError)("Intl.DisplayNames is not available in this environment.\nTry polyfilling it using \"@formatjs/intl-displaynames\"\n", (0, $jpwqX.ErrorCode).MISSING_INTL_API));
    var filteredOptions = (0, $ftB2S.filterProps)(options, $8978dd3e5f4a7a94$var$DISPLAY_NAMES_OPTONS);
    try {
        return getDisplayNames(locale, filteredOptions).of(value);
    } catch (e) {
        onError(new (0, $lxO85.IntlFormatError)('Error formatting display name.', locale, e));
    }
}

});

parcelRegister("cEdDX", function(module, exports) {
$parcel$export(module.exports, "formatList", () => $9353cdc81fe3f1a9$export$e8b8be48b45905bb);
$parcel$export(module.exports, "formatListToParts", () => $9353cdc81fe3f1a9$export$6f284aad1934db69);

var $kJhpj = parcelRequire("kJhpj");

var $jpwqX = parcelRequire("jpwqX");

var $lxO85 = parcelRequire("lxO85");

var $ftB2S = parcelRequire("ftB2S");
var $9353cdc81fe3f1a9$var$LIST_FORMAT_OPTIONS = [
    'type',
    'style'
];
var $9353cdc81fe3f1a9$var$now = Date.now();
function $9353cdc81fe3f1a9$var$generateToken(i) {
    return "".concat($9353cdc81fe3f1a9$var$now, "_").concat(i, "_").concat($9353cdc81fe3f1a9$var$now);
}
function $9353cdc81fe3f1a9$export$e8b8be48b45905bb(opts, getListFormat, values, options) {
    if (options === void 0) options = {};
    var results = $9353cdc81fe3f1a9$export$6f284aad1934db69(opts, getListFormat, values, options).reduce(function(all, el) {
        var val = el.value;
        if (typeof val !== 'string') all.push(val);
        else if (typeof all[all.length - 1] === 'string') all[all.length - 1] += val;
        else all.push(val);
        return all;
    }, []);
    return results.length === 1 ? results[0] : results.length === 0 ? '' : results;
}
function $9353cdc81fe3f1a9$export$6f284aad1934db69(_a, getListFormat, values, options) {
    var locale = _a.locale, onError = _a.onError;
    if (options === void 0) options = {};
    var ListFormat = Intl.ListFormat;
    if (!ListFormat) onError(new (0, $jpwqX.FormatError)("Intl.ListFormat is not available in this environment.\nTry polyfilling it using \"@formatjs/intl-listformat\"\n", (0, $jpwqX.ErrorCode).MISSING_INTL_API));
    var filteredOptions = (0, $ftB2S.filterProps)(options, $9353cdc81fe3f1a9$var$LIST_FORMAT_OPTIONS);
    try {
        var richValues_1 = {};
        var serializedValues = values.map(function(v, i) {
            if (typeof v === 'object') {
                var id = $9353cdc81fe3f1a9$var$generateToken(i);
                richValues_1[id] = v;
                return id;
            }
            return String(v);
        });
        return getListFormat(locale, filteredOptions).formatToParts(serializedValues).map(function(part) {
            return part.type === 'literal' ? part : (0, $kJhpj.__assign)((0, $kJhpj.__assign)({}, part), {
                value: richValues_1[part.value] || part.value
            });
        });
    } catch (e) {
        onError(new (0, $lxO85.IntlFormatError)('Error formatting list.', locale, e));
    }
    // @ts-ignore
    return values;
}

});

parcelRegister("2k5ES", function(module, exports) {
$parcel$export(module.exports, "formatMessage", () => $1b11d6a681c9014e$export$25868d1e8e76735f);

var $kJhpj = parcelRequire("kJhpj");
parcelRequire("6dpFj");
var $4VghZ = parcelRequire("4VghZ");
parcelRequire("kIHPs");
var $9exF4 = parcelRequire("9exF4");

var $lxO85 = parcelRequire("lxO85");

var $ftB2S = parcelRequire("ftB2S");
function $1b11d6a681c9014e$var$setTimeZoneInOptions(opts, timeZone) {
    return Object.keys(opts).reduce(function(all, k) {
        all[k] = (0, $kJhpj.__assign)({
            timeZone: timeZone
        }, opts[k]);
        return all;
    }, {});
}
function $1b11d6a681c9014e$var$deepMergeOptions(opts1, opts2) {
    var keys = Object.keys((0, $kJhpj.__assign)((0, $kJhpj.__assign)({}, opts1), opts2));
    return keys.reduce(function(all, k) {
        all[k] = (0, $kJhpj.__assign)((0, $kJhpj.__assign)({}, opts1[k] || {}), opts2[k] || {});
        return all;
    }, {});
}
function $1b11d6a681c9014e$var$deepMergeFormatsAndSetTimeZone(f1, timeZone) {
    if (!timeZone) return f1;
    var mfFormats = (0, $9exF4.IntlMessageFormat).formats;
    return (0, $kJhpj.__assign)((0, $kJhpj.__assign)((0, $kJhpj.__assign)({}, mfFormats), f1), {
        date: $1b11d6a681c9014e$var$deepMergeOptions($1b11d6a681c9014e$var$setTimeZoneInOptions(mfFormats.date, timeZone), $1b11d6a681c9014e$var$setTimeZoneInOptions(f1.date || {}, timeZone)),
        time: $1b11d6a681c9014e$var$deepMergeOptions($1b11d6a681c9014e$var$setTimeZoneInOptions(mfFormats.time, timeZone), $1b11d6a681c9014e$var$setTimeZoneInOptions(f1.time || {}, timeZone))
    });
}
var $1b11d6a681c9014e$export$25868d1e8e76735f = function(_a, state, messageDescriptor, values, opts) {
    var locale = _a.locale, formats = _a.formats, messages = _a.messages, defaultLocale = _a.defaultLocale, defaultFormats = _a.defaultFormats, fallbackOnEmptyString = _a.fallbackOnEmptyString, onError = _a.onError, timeZone = _a.timeZone, defaultRichTextElements = _a.defaultRichTextElements;
    if (messageDescriptor === void 0) messageDescriptor = {
        id: ''
    };
    var msgId = messageDescriptor.id, defaultMessage = messageDescriptor.defaultMessage;
    // `id` is a required field of a Message Descriptor.
    (0, $ftB2S.invariant)(!!msgId, "[@formatjs/intl] An `id` must be provided to format a message. You can either:\n1. Configure your build toolchain with [babel-plugin-formatjs](https://formatjs.github.io/docs/tooling/babel-plugin)\nor [@formatjs/ts-transformer](https://formatjs.github.io/docs/tooling/ts-transformer) OR\n2. Configure your `eslint` config to include [eslint-plugin-formatjs](https://formatjs.github.io/docs/tooling/linter#enforce-id)\nto autofix this issue");
    var id = String(msgId);
    var message = // In case messages is Object.create(null)
    // e.g import('foo.json') from webpack)
    // See https://github.com/formatjs/formatjs/issues/1914
    messages && Object.prototype.hasOwnProperty.call(messages, id) && messages[id];
    // IMPORTANT: Hot path if `message` is AST with a single literal node
    if (Array.isArray(message) && message.length === 1 && message[0].type === (0, $4VghZ.TYPE).literal) return message[0].value;
    // IMPORTANT: Hot path straight lookup for performance
    if (!values && message && typeof message === 'string' && !defaultRichTextElements) return message.replace(/'\{(.*?)\}'/gi, "{$1}");
    values = (0, $kJhpj.__assign)((0, $kJhpj.__assign)({}, defaultRichTextElements), values || {});
    formats = $1b11d6a681c9014e$var$deepMergeFormatsAndSetTimeZone(formats, timeZone);
    defaultFormats = $1b11d6a681c9014e$var$deepMergeFormatsAndSetTimeZone(defaultFormats, timeZone);
    if (!message) {
        if (fallbackOnEmptyString === false && message === '') return message;
        if (!defaultMessage || locale && locale.toLowerCase() !== defaultLocale.toLowerCase()) // This prevents warnings from littering the console in development
        // when no `messages` are passed into the <IntlProvider> for the
        // default locale.
        onError(new (0, $lxO85.MissingTranslationError)(messageDescriptor, locale));
        if (defaultMessage) try {
            var formatter = state.getMessageFormat(defaultMessage, defaultLocale, defaultFormats, opts);
            return formatter.format(values);
        } catch (e) {
            onError(new (0, $lxO85.MessageFormatError)("Error formatting default message for: \"".concat(id, "\", rendering default message verbatim"), locale, messageDescriptor, e));
            return typeof defaultMessage === 'string' ? defaultMessage : id;
        }
        return id;
    }
    // We have the translated message
    try {
        var formatter = state.getMessageFormat(message, locale, formats, (0, $kJhpj.__assign)({
            formatters: state
        }, opts || {}));
        return formatter.format(values);
    } catch (e) {
        onError(new (0, $lxO85.MessageFormatError)("Error formatting message: \"".concat(id, "\", using ").concat(defaultMessage ? 'default message' : 'id', " as fallback."), locale, messageDescriptor, e));
    }
    if (defaultMessage) try {
        var formatter = state.getMessageFormat(defaultMessage, defaultLocale, defaultFormats, opts);
        return formatter.format(values);
    } catch (e) {
        onError(new (0, $lxO85.MessageFormatError)("Error formatting the default message for: \"".concat(id, "\", rendering message verbatim"), locale, messageDescriptor, e));
    }
    if (typeof message === 'string') return message;
    if (typeof defaultMessage === 'string') return defaultMessage;
    return id;
};

});

parcelRegister("8IvbH", function(module, exports) {
$parcel$export(module.exports, "formatNumber", () => $658aa001f74e17e0$export$f5dd818bff069720);
$parcel$export(module.exports, "formatNumberToParts", () => $658aa001f74e17e0$export$6871080848f10b2f);

var $lxO85 = parcelRequire("lxO85");

var $ftB2S = parcelRequire("ftB2S");
var $658aa001f74e17e0$var$NUMBER_FORMAT_OPTIONS = [
    'style',
    'currency',
    'unit',
    'unitDisplay',
    'useGrouping',
    'minimumIntegerDigits',
    'minimumFractionDigits',
    'maximumFractionDigits',
    'minimumSignificantDigits',
    'maximumSignificantDigits',
    // ES2020 NumberFormat
    'compactDisplay',
    'currencyDisplay',
    'currencySign',
    'notation',
    'signDisplay',
    'unit',
    'unitDisplay',
    'numberingSystem',
    // ES2023 NumberFormat
    'trailingZeroDisplay',
    'roundingPriority',
    'roundingIncrement',
    'roundingMode'
];
function $658aa001f74e17e0$export$a7f9565e3c81cd54(_a, getNumberFormat, options) {
    var locale = _a.locale, formats = _a.formats, onError = _a.onError;
    if (options === void 0) options = {};
    var format = options.format;
    var defaults = format && (0, $ftB2S.getNamedFormat)(formats, 'number', format, onError) || {};
    var filteredOptions = (0, $ftB2S.filterProps)(options, $658aa001f74e17e0$var$NUMBER_FORMAT_OPTIONS, defaults);
    return getNumberFormat(locale, filteredOptions);
}
function $658aa001f74e17e0$export$f5dd818bff069720(config, getNumberFormat, value, options) {
    if (options === void 0) options = {};
    try {
        return $658aa001f74e17e0$export$a7f9565e3c81cd54(config, getNumberFormat, options).format(value);
    } catch (e) {
        config.onError(new (0, $lxO85.IntlFormatError)('Error formatting number.', config.locale, e));
    }
    return String(value);
}
function $658aa001f74e17e0$export$6871080848f10b2f(config, getNumberFormat, value, options) {
    if (options === void 0) options = {};
    try {
        return $658aa001f74e17e0$export$a7f9565e3c81cd54(config, getNumberFormat, options).formatToParts(value);
    } catch (e) {
        config.onError(new (0, $lxO85.IntlFormatError)('Error formatting number.', config.locale, e));
    }
    return [];
}

});

parcelRegister("37L44", function(module, exports) {
$parcel$export(module.exports, "formatPlural", () => $2466889469f751f1$export$bbbd05c900f3568d);

var $jpwqX = parcelRequire("jpwqX");

var $lxO85 = parcelRequire("lxO85");

var $ftB2S = parcelRequire("ftB2S");
var $2466889469f751f1$var$PLURAL_FORMAT_OPTIONS = [
    'type'
];
function $2466889469f751f1$export$bbbd05c900f3568d(_a, getPluralRules, value, options) {
    var locale = _a.locale, onError = _a.onError;
    if (options === void 0) options = {};
    if (!Intl.PluralRules) onError(new (0, $jpwqX.FormatError)("Intl.PluralRules is not available in this environment.\nTry polyfilling it using \"@formatjs/intl-pluralrules\"\n", (0, $jpwqX.ErrorCode).MISSING_INTL_API));
    var filteredOptions = (0, $ftB2S.filterProps)(options, $2466889469f751f1$var$PLURAL_FORMAT_OPTIONS);
    try {
        return getPluralRules(locale, filteredOptions).select(value);
    } catch (e) {
        onError(new (0, $lxO85.IntlFormatError)('Error formatting plural.', locale, e));
    }
    return 'other';
}

});

parcelRegister("3h18O", function(module, exports) {
$parcel$export(module.exports, "formatRelativeTime", () => $2623d837842f9cad$export$b4ea3b48dcf921f6);

var $ftB2S = parcelRequire("ftB2S");

var $jpwqX = parcelRequire("jpwqX");

var $lxO85 = parcelRequire("lxO85");
var $2623d837842f9cad$var$RELATIVE_TIME_FORMAT_OPTIONS = [
    'numeric',
    'style'
];
function $2623d837842f9cad$var$getFormatter(_a, getRelativeTimeFormat, options) {
    var locale = _a.locale, formats = _a.formats, onError = _a.onError;
    if (options === void 0) options = {};
    var format = options.format;
    var defaults = !!format && (0, $ftB2S.getNamedFormat)(formats, 'relative', format, onError) || {};
    var filteredOptions = (0, $ftB2S.filterProps)(options, $2623d837842f9cad$var$RELATIVE_TIME_FORMAT_OPTIONS, defaults);
    return getRelativeTimeFormat(locale, filteredOptions);
}
function $2623d837842f9cad$export$b4ea3b48dcf921f6(config, getRelativeTimeFormat, value, unit, options) {
    if (options === void 0) options = {};
    if (!unit) unit = 'second';
    var RelativeTimeFormat = Intl.RelativeTimeFormat;
    if (!RelativeTimeFormat) config.onError(new (0, $jpwqX.FormatError)("Intl.RelativeTimeFormat is not available in this environment.\nTry polyfilling it using \"@formatjs/intl-relativetimeformat\"\n", (0, $jpwqX.ErrorCode).MISSING_INTL_API));
    try {
        return $2623d837842f9cad$var$getFormatter(config, getRelativeTimeFormat, options).format(value, unit);
    } catch (e) {
        config.onError(new (0, $lxO85.IntlFormatError)('Error formatting relative time.', config.locale, e));
    }
    return String(value);
}

});




parcelRegister("kPiFO", function(module, exports) {
$parcel$export(module.exports, "default", () => $f2970e3937265c75$export$2e2bcd8739ae039);

var $kJhpj = parcelRequire("kJhpj");

var $5FkrB = parcelRequire("5FkrB");

var $5Kjrj = parcelRequire("5Kjrj");

var $hrVKU = parcelRequire("hrVKU");
var $f2970e3937265c75$var$MINUTE = 60;
var $f2970e3937265c75$var$HOUR = 3600;
var $f2970e3937265c75$var$DAY = 86400;
function $f2970e3937265c75$var$selectUnit(seconds) {
    var absValue = Math.abs(seconds);
    if (absValue < $f2970e3937265c75$var$MINUTE) return 'second';
    if (absValue < $f2970e3937265c75$var$HOUR) return 'minute';
    if (absValue < $f2970e3937265c75$var$DAY) return 'hour';
    return 'day';
}
function $f2970e3937265c75$var$getDurationInSeconds(unit) {
    switch(unit){
        case 'second':
            return 1;
        case 'minute':
            return $f2970e3937265c75$var$MINUTE;
        case 'hour':
            return $f2970e3937265c75$var$HOUR;
        default:
            return $f2970e3937265c75$var$DAY;
    }
}
function $f2970e3937265c75$var$valueToSeconds(value, unit) {
    if (!value) return 0;
    switch(unit){
        case 'second':
            return value;
        case 'minute':
            return value * $f2970e3937265c75$var$MINUTE;
        default:
            return value * $f2970e3937265c75$var$HOUR;
    }
}
var $f2970e3937265c75$var$INCREMENTABLE_UNITS = [
    'second',
    'minute',
    'hour'
];
function $f2970e3937265c75$var$canIncrement(unit) {
    if (unit === void 0) unit = 'second';
    return $f2970e3937265c75$var$INCREMENTABLE_UNITS.indexOf(unit) > -1;
}
var $f2970e3937265c75$var$SimpleFormattedRelativeTime = function(props) {
    var _a = (0, $hrVKU.default)(), formatRelativeTime = _a.formatRelativeTime, Text = _a.textComponent;
    var children = props.children, value = props.value, unit = props.unit, otherProps = (0, $kJhpj.__rest)(props, [
        "children",
        "value",
        "unit"
    ]);
    var formattedRelativeTime = formatRelativeTime(value || 0, unit, otherProps);
    if (typeof children === 'function') return children(formattedRelativeTime);
    if (Text) return $5FkrB.createElement(Text, null, formattedRelativeTime);
    return $5FkrB.createElement($5FkrB.Fragment, null, formattedRelativeTime);
};
var $f2970e3937265c75$var$FormattedRelativeTime = function(_a) {
    var _b = _a.value, value = _b === void 0 ? 0 : _b, _c = _a.unit, unit = _c === void 0 ? 'second' : _c, updateIntervalInSeconds = _a.updateIntervalInSeconds, otherProps = (0, $kJhpj.__rest)(_a, [
        "value",
        "unit",
        "updateIntervalInSeconds"
    ]);
    (0, $5Kjrj.invariant)(!updateIntervalInSeconds || !!(updateIntervalInSeconds && $f2970e3937265c75$var$canIncrement(unit)), 'Cannot schedule update with unit longer than hour');
    var _d = $5FkrB.useState(), prevUnit = _d[0], setPrevUnit = _d[1];
    var _e = $5FkrB.useState(0), prevValue = _e[0], setPrevValue = _e[1];
    var _f = $5FkrB.useState(0), currentValueInSeconds = _f[0], setCurrentValueInSeconds = _f[1];
    var updateTimer;
    if (unit !== prevUnit || value !== prevValue) {
        setPrevValue(value || 0);
        setPrevUnit(unit);
        setCurrentValueInSeconds($f2970e3937265c75$var$canIncrement(unit) ? $f2970e3937265c75$var$valueToSeconds(value, unit) : 0);
    }
    $5FkrB.useEffect(function() {
        function clearUpdateTimer() {
            clearTimeout(updateTimer);
        }
        clearUpdateTimer();
        // If there's no interval and we cannot increment this unit, do nothing
        if (!updateIntervalInSeconds || !$f2970e3937265c75$var$canIncrement(unit)) return clearUpdateTimer;
        // Figure out the next interesting time
        var nextValueInSeconds = currentValueInSeconds - updateIntervalInSeconds;
        var nextUnit = $f2970e3937265c75$var$selectUnit(nextValueInSeconds);
        // We've reached the max auto incrementable unit, don't schedule another update
        if (nextUnit === 'day') return clearUpdateTimer;
        var unitDuration = $f2970e3937265c75$var$getDurationInSeconds(nextUnit);
        var remainder = nextValueInSeconds % unitDuration;
        var prevInterestingValueInSeconds = nextValueInSeconds - remainder;
        var nextInterestingValueInSeconds = prevInterestingValueInSeconds >= currentValueInSeconds ? prevInterestingValueInSeconds - unitDuration : prevInterestingValueInSeconds;
        var delayInSeconds = Math.abs(nextInterestingValueInSeconds - currentValueInSeconds);
        if (currentValueInSeconds !== nextInterestingValueInSeconds) updateTimer = setTimeout(function() {
            return setCurrentValueInSeconds(nextInterestingValueInSeconds);
        }, delayInSeconds * 1e3);
        return clearUpdateTimer;
    }, [
        currentValueInSeconds,
        updateIntervalInSeconds,
        unit
    ]);
    var currentValue = value || 0;
    var currentUnit = unit;
    if ($f2970e3937265c75$var$canIncrement(unit) && typeof currentValueInSeconds === 'number' && updateIntervalInSeconds) {
        currentUnit = $f2970e3937265c75$var$selectUnit(currentValueInSeconds);
        var unitDuration = $f2970e3937265c75$var$getDurationInSeconds(currentUnit);
        currentValue = Math.round(currentValueInSeconds / unitDuration);
    }
    return $5FkrB.createElement($f2970e3937265c75$var$SimpleFormattedRelativeTime, (0, $kJhpj.__assign)({
        value: currentValue,
        unit: currentUnit
    }, otherProps));
};
$f2970e3937265c75$var$FormattedRelativeTime.displayName = 'FormattedRelativeTime';
var $f2970e3937265c75$export$2e2bcd8739ae039 = $f2970e3937265c75$var$FormattedRelativeTime;

});




parcelRegister("fLAke", function(module, exports) {
$parcel$export(module.exports, "getConsentInfo", () => $6b3f6e76c13fa52d$export$63817cd70bf84ca6);
$parcel$export(module.exports, "getForgeMcpAppName", () => $6b3f6e76c13fa52d$export$f0826a0e7d5403c3);
$parcel$export(module.exports, "getForgeMcpAppIcon", () => $6b3f6e76c13fa52d$export$1457679005e69ca8);

var $49b5t = parcelRequire("49b5t");

var $3VQxn = parcelRequire("3VQxn");
const $6b3f6e76c13fa52d$var$CONSENT_INFO_URL = '/consent/info';
async function $6b3f6e76c13fa52d$export$63817cd70bf84ca6(consent, options) {
    const params = {
        context: consent.raw
    };
    if (options?.selectedOrg) params.selectedOrg = options.selectedOrg;
    if (options?.includeDisabledScopes) params.includeDisabledScopes = 'true';
    const response = await fetch((0, $49b5t.withForwardedEnv)($6b3f6e76c13fa52d$var$CONSENT_INFO_URL + '?' + new URLSearchParams(params)));
    switch(response.status){
        case 200:
            console.log('Received consent info');
            return $6b3f6e76c13fa52d$var$parseSuccessBody(response);
        case 400:
        case 401:
            const error = await response.json();
            console.warn('Error verifying context', error);
            return $6b3f6e76c13fa52d$var$resolveError(response.status, consent, error);
        default:
            console.error(`Unexpected status code [${response.status}]:`, response);
            throw new (0, $3VQxn.HttpError)(response.status, `Unexpected status code [${response.status}] when calling /consent/info`);
    }
}
function $6b3f6e76c13fa52d$export$f0826a0e7d5403c3(info) {
    const appName = info?.forgeMcpConsentTarget?.appName?.trim();
    return appName || undefined;
}
function $6b3f6e76c13fa52d$export$1457679005e69ca8(info) {
    const appIcon = info?.forgeMcpConsentTarget?.appIcon?.trim();
    return appIcon || undefined;
}
async function $6b3f6e76c13fa52d$var$parseSuccessBody(response) {
    const body = await response.json();
    if (typeof body !== 'object') {
        console.error('Success body is not an object', body);
        throw Error('Unexpected body in consent info call', {
            cause: response
        });
    }
    if (body.site_name) {
        body.siteName = body.site_name;
        delete body.site_name;
    }
    if (body.has_trello_product_access != null) {
        body.hasTrelloProductAccess = body.has_trello_product_access;
        delete body.has_trello_product_access;
    }
    if (body.max_trello_workspaces != null) {
        body.maxTrelloWorkspaces = body.max_trello_workspaces;
        delete body.max_trello_workspaces;
    }
    return body;
}
function $6b3f6e76c13fa52d$var$resolveError(status, consent, errorObject) {
    switch(errorObject.error){
        case 'unauthorized_scopes':
            return {
                error: 'unauthorized-scopes',
                clientName: consent.clientName ?? '',
                products: consent.customer === 'trello' ? [
                    'Trello'
                ] : [],
                scopes: errorObject.error_description.split('+')
            };
        case 'no_scopes':
            return {
                error: 'no-scopes',
                clientName: consent.clientName ?? ''
            };
        case 'invalid_request':
        case 'unauthorized_user':
            return 0, $3VQxn.InvalidContextToken;
        default:
            throw new (0, $3VQxn.HttpError)(status, 'Unexpected error in consent info call', {
                cause: errorObject
            });
    }
}

});

parcelRegister("guDjK", function(module, exports) {
$parcel$export(module.exports, "useAnalytics", () => $5939b65e392941dc$export$e955abb82869dc84);
$parcel$export(module.exports, "default", () => $5939b65e392941dc$export$2e2bcd8739ae039);

var $i3UfC = parcelRequire("i3UfC");

var $5FkrB = parcelRequire("5FkrB");

var $5MWcp = parcelRequire("5MWcp");
const $5939b65e392941dc$export$83cd6c3eba7d8d9e = /*#__PURE__*/ (0, $5FkrB.createContext)(null);
const $5939b65e392941dc$export$e955abb82869dc84 = ()=>{
    const client = (0, $5FkrB.useContext)($5939b65e392941dc$export$83cd6c3eba7d8d9e);
    if (!client) throw new Error('useAnalytics can only be used under an AnalyticsProvider');
    return client;
};
const $5939b65e392941dc$var$AnalyticsProvider = ({ children: children, loading: loading })=>{
    const [client, setClient] = (0, $5FkrB.useState)(null);
    (0, $5FkrB.useEffect)(()=>{
        const client = new (0, $5MWcp.default)();
        setClient(client);
    }, []);
    return client ? /*#__PURE__*/ (0, $i3UfC.jsx)($5939b65e392941dc$export$83cd6c3eba7d8d9e.Provider, {
        value: client,
        children: children
    }) : loading;
};
var $5939b65e392941dc$export$2e2bcd8739ae039 = $5939b65e392941dc$var$AnalyticsProvider;

});
parcelRegister("5MWcp", function(module, exports) {
$parcel$export(module.exports, "default", () => $eabb8c2d613729e7$export$2e2bcd8739ae039);

var $62KHl = parcelRequire("62KHl");
var $dpXUu = parcelRequire("dpXUu");

var $9KGFe = parcelRequire("9KGFe");

var $1eXBn = parcelRequire("1eXBn");
function $eabb8c2d613729e7$var$getServerName() {
    return window.location.hostname;
}
const { LOCAL: $eabb8c2d613729e7$var$LOCAL, DEV: $eabb8c2d613729e7$var$DEV, STAGING: $eabb8c2d613729e7$var$STAGING, PROD: $eabb8c2d613729e7$var$PROD } = (0, $dpXUu.envType);
const $eabb8c2d613729e7$var$ENV_MAP = {
    local: $eabb8c2d613729e7$var$LOCAL,
    ddev: $eabb8c2d613729e7$var$DEV,
    stg: $eabb8c2d613729e7$var$STAGING,
    'stg-fedm': $eabb8c2d613729e7$var$STAGING,
    prod: $eabb8c2d613729e7$var$PROD,
    'prod-fedm': $eabb8c2d613729e7$var$PROD
};
const $eabb8c2d613729e7$var$analyticsConfig = (0, $9KGFe.getConfig)().analytics;
const $eabb8c2d613729e7$export$5dafcf018ef7e466 = 'identity';
const $eabb8c2d613729e7$var$SCREEN_NAME = 'oauthConsentScreen';
class $eabb8c2d613729e7$var$AnalyticsClient {
    isInitialLoad;
    state;
    analyticsWebClient;
    constructor(options = {}){
        this.state = {
            analyticsScheme: $eabb8c2d613729e7$var$analyticsConfig.scheme,
            analyticsServer: $eabb8c2d613729e7$var$analyticsConfig.server,
            server: $eabb8c2d613729e7$var$getServerName(),
            product: $eabb8c2d613729e7$export$5dafcf018ef7e466,
            isReadyToSend: false,
            pendingEventsQueue: [],
            storage_key: 'oauth.consent.analytics',
            ...options
        };
        // New GAS pipeline client. Follow this docs https://bitbucket.org/atlassian/analytics-web-client/src/master/ for more detail
        this.analyticsWebClient = new (0, $62KHl.default)({
            env: $eabb8c2d613729e7$var$ENV_MAP[(0, $1eXBn.getEnv)()],
            product: $eabb8c2d613729e7$export$5dafcf018ef7e466,
            origin: (0, $dpXUu.originType).WEB
        });
        // sending apdex events needs to know whether this is the initial load of the app or a transition.
        // Following variable helps us identify that.
        this.isInitialLoad = true;
    }
    getAnalyticsWebClient() {
        return this.analyticsWebClient;
    }
    sendTrackEvent(eventData) {
        this.analyticsWebClient.sendTrackEvent(eventData);
    }
    setUserId(userId) {
        this.analyticsWebClient.setUserInfo((0, $dpXUu.userType).ATLASSIAN_ACCOUNT, userId);
    }
    setCloudId(cloudId) {
        if (!cloudId) return this.analyticsWebClient.setTenantInfo((0, $dpXUu.tenantType).NONE);
        this.analyticsWebClient.setTenantInfo((0, $dpXUu.tenantType).CLOUD_ID, cloudId);
    }
    updateState(state) {
        this.state = {
            ...this.state,
            ...state
        };
    }
    /**
   * Checks whether the library has been initialized and decides whether the event should be sent or cached
   * @param {*} eventType Values could be 'track', 'screen', 'operation, 'ui'
   * @param {*} eventData Data of the event
   * @param {Function} cb Callback is called when the event is sent successfully.
   */ canEventBeSent(eventType, eventData, cb) {
        if (this.state.isReadyToSend) return true;
        // add to `pendingEventsQueue` in order to send the event later
        this.state.pendingEventsQueue.push({
            eventType: eventType,
            eventData: eventData,
            // `eventCallback` is called when `pendingEventsQueue` is processed and eventData is sent
            eventCallback: cb
        });
        return false;
    }
    pushTrackEvent(eventData, cb) {
        if (this.canEventBeSent('track', eventData, cb)) {
            const event = this.buildEventPayload(eventData);
            this.analyticsWebClient.sendTrackEvent(event, cb);
        }
    }
    pushUIEvent(eventData, cb) {
        if (this.canEventBeSent('ui', eventData, cb)) {
            const event = this.buildEventPayload(eventData);
            this.analyticsWebClient.sendUIEvent(event, cb);
        }
    }
    pushOperationalEvent(eventData, cb) {
        if (this.canEventBeSent('operation', eventData, cb)) {
            const event = this.buildEventPayload(eventData);
            this.analyticsWebClient.sendOperationalEvent(event, cb);
        }
    }
    pushScreenEvent(eventData, cb) {
        if (this.canEventBeSent('screen', eventData, cb)) this.analyticsWebClient.sendScreenEvent(eventData, cb);
    }
    generateAttributes() {
        return {
            customer: this.state.customer,
            profile: this.state.profile,
            serviceType: this.state.serviceType
        };
    }
    async sendConsentScreenEvent() {
        return this.analyticsWebClient.sendScreenEvent({
            name: $eabb8c2d613729e7$var$SCREEN_NAME,
            attributes: this.generateAttributes()
        });
    }
    // https://hello.atlassian.net/wiki/spaces/AAPT/pages/581609987/RFC+Analytics+-+Frontend+Errors+-+Package+Component+Failed#Specification
    async sendErrorEvent(reason) {
        return this.analyticsWebClient.sendOperationalEvent({
            action: 'failed',
            actionSubject: 'oauthConsent',
            source: $eabb8c2d613729e7$var$SCREEN_NAME,
            attributes: {
                ...this.generateAttributes(),
                failureReason: reason
            }
        });
    }
    async sendButtonClickEvent(buttonName) {
        return this.analyticsWebClient.sendUIEvent({
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: buttonName,
            attributes: this.generateAttributes(),
            source: $eabb8c2d613729e7$var$SCREEN_NAME
        });
    }
    buildEventPayload(eventData) {
        return {
            containerType: null,
            containerId: null,
            objectType: null,
            objectId: null,
            source: null,
            actionSubject: null,
            action: null,
            actionSubjectId: null,
            attributes: null,
            tags: [],
            ...eventData
        };
    }
    /**
   *  Start up E-MAU events in the new analytics pipeline (GAS v3)
   *  See: https://extranet.atlassian.com/display/BPO/DACI%3A+E-MAU+Definition
   */ async startUIViewedEvent() {
        this.analyticsWebClient.startUIViewedEvent();
        this.state.isReadyToSend = true;
        this.flushPendingEventsQueue();
    }
    /**
   * Flush all the pending events in the queue
   */ flushPendingEventsQueue() {
        this.state.pendingEventsQueue.forEach((element)=>{
            const { eventType: eventType, eventData: eventData, eventCallback: eventCallback } = element;
            switch(eventType){
                case 'track':
                    this.pushTrackEvent(eventData, eventCallback);
                    break;
                case 'ui':
                    this.pushUIEvent(eventData, eventCallback);
                    break;
                case 'screen':
                    this.pushScreenEvent(eventData, eventCallback);
                    break;
                case 'operation':
                    this.pushOperationalEvent(eventData, eventCallback);
                    break;
                default:
                    console.error('Invalid Event :', element);
                    break;
            }
        });
    }
}
var $eabb8c2d613729e7$export$2e2bcd8739ae039 = $eabb8c2d613729e7$var$AnalyticsClient;
/**
 * In order for the app to have the same analytics client instances we'll preserve them in a local const
 */ let $eabb8c2d613729e7$var$preservedAnalyticsClients;
const $eabb8c2d613729e7$export$fde53e78fd93a54d = (store)=>{
    if (!$eabb8c2d613729e7$var$preservedAnalyticsClients || !store) $eabb8c2d613729e7$var$preservedAnalyticsClients = new $eabb8c2d613729e7$var$AnalyticsClient(store);
    return $eabb8c2d613729e7$var$preservedAnalyticsClients;
};

});
parcelRegister("62KHl", function(module, exports) {
$parcel$export(module.exports, "default", () => $4667273d53967e9d$export$2e2bcd8739ae039);

var $6rvcc = parcelRequire("6rvcc");

var $eSdwu = parcelRequire("eSdwu");

var $fimjF = parcelRequire("fimjF");

var $dpXUu = parcelRequire("dpXUu");

var $nxH15 = parcelRequire("nxH15");

var $doaPm = parcelRequire("doaPm");

var $478yZ = parcelRequire("478yZ");

var $dIKYA = parcelRequire("dIKYA");

var $1dFnn = parcelRequire("1dFnn");

var $aYviu = parcelRequire("aYviu");

var $3xmDM = parcelRequire("3xmDM");

var $74pGx = parcelRequire("74pGx");

var $9hqdJ = parcelRequire("9hqdJ");

var $9Do9V = parcelRequire("9Do9V");

var $89ZKV = parcelRequire("89ZKV");

var $lsX7U = parcelRequire("lsX7U");

var $5kUYv = parcelRequire("5kUYv");

var $9raiz = parcelRequire("9raiz");

var $dyX62 = parcelRequire("dyX62");

var $eS4G8 = parcelRequire("eS4G8");

var $h5UBC = parcelRequire("h5UBC");

var $7Jko1 = parcelRequire("7Jko1");

var $ls3Em = parcelRequire("ls3Em");

var $5P1Jy = parcelRequire("5P1Jy");

var $cMwGH = parcelRequire("cMwGH");

var $j5Le2 = parcelRequire("j5Le2");

var $kxbHy = parcelRequire("kxbHy");

var $8jZU6 = parcelRequire("8jZU6");

var $4penA = parcelRequire("4penA");

var $kqsXa = parcelRequire("kqsXa");

var $1Ygrk = parcelRequire("1Ygrk");

var $1F03j = parcelRequire("1F03j");

var $c77r4 = parcelRequire("c77r4");

var $4uub9 = parcelRequire("4uub9");

var $gUTHp = parcelRequire("gUTHp");

var $gKKSu = parcelRequire("gKKSu");

var $lHJ7U = parcelRequire("lHJ7U");

var $2E7is = parcelRequire("2E7is");

var $7UqwT = parcelRequire("7UqwT");

var $hPniv = parcelRequire("hPniv");
function $4667273d53967e9d$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $4667273d53967e9d$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $4667273d53967e9d$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $6rvcc.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $4667273d53967e9d$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
const $4667273d53967e9d$var$LAST_SCREEN_EVENT_STORAGE_KEY = 'last.screen.event';
class $4667273d53967e9d$export$2e2bcd8739ae039 {
    constructor(productInfo, settings = {}){
        (0, $6rvcc.default)(this, "_useStargate", (useStargate)=>{
            if (useStargate == null) return true;
            return useStargate;
        });
        (0, $6rvcc.default)(this, "_changeInternalUserId", (userId, anonymousId)=>{
            this._eventProcessor.getUser().setUserId(userId);
            if (anonymousId && anonymousId !== this._eventProcessor.getUser().getAnonymousId()) // Setting anonymous id can take a long time. Reading is a lot faster.
            // Only update if it has changed.
            this._eventProcessor.getUser().setAnonymousId(anonymousId);
        });
        (0, $6rvcc.default)(this, "_createSubproductGetter", (subproduct)=>(0, $aYviu.default)(subproduct, 'Cannot get subproduct from the callback. Proceeding without it.'));
        (0, $6rvcc.default)(this, "_createEmbeddedProductGetter", (embeddedProduct)=>(0, $aYviu.default)(embeddedProduct, 'Cannot get embeddedProduct from the callback. Proceeding without it.'));
        (0, $6rvcc.default)(this, "_getLastScreenEvent", ()=>{
            try {
                return JSON.parse(this._safeSessionStorage.getItem($4667273d53967e9d$var$LAST_SCREEN_EVENT_STORAGE_KEY) || '');
            } catch (_unused) {
                this._safeSessionStorage.removeItem($4667273d53967e9d$var$LAST_SCREEN_EVENT_STORAGE_KEY);
                return null;
            }
        });
        (0, $6rvcc.default)(this, "_setLastScreenEvent", (event)=>{
            this._safeSessionStorage.setItem($4667273d53967e9d$var$LAST_SCREEN_EVENT_STORAGE_KEY, JSON.stringify({
                name: event.name,
                attributes: event.attributes
            }));
        });
        (0, $6rvcc.default)(this, "_shouldEventBeDelayed", (event)=>{
            // TODO: this is a temporary restriction for the purposes of the Track All Changes project
            // The delay mechanism has a chance of event loss, which we can only accept for our own data at this point.
            // Once the delay queue implementation has been improved and measured to confirm that it is reliable enough,
            // then we will be able to open it up for other products to use by removing this check.
            if (!event.tags || event.tags.indexOf('measurement') === -1) return false;
            const isEventHighPriority = event.highPriority !== false; // defaults to true if excluded
            return this._eventDelayQueue.isDelayingLowPriorityEvents() && !isEventHighPriority;
        });
        (0, $6rvcc.default)(this, "_fireEvent", (identifier, builtEvent, context, callback)=>{
            switch(builtEvent.eventType){
                case (0, $dpXUu.eventType).UI:
                case (0, $dpXUu.eventType).OPERATIONAL:
                case (0, $dpXUu.eventType).TRACK:
                    return this._eventProcessor.track(identifier, builtEvent, context, callback);
                case (0, $dpXUu.eventType).SCREEN:
                    return this._eventProcessor.page(identifier, builtEvent, context, callback);
                case (0, $dpXUu.eventType).IDENTIFY:
                    return this._eventProcessor.identify(identifier, builtEvent, context, callback);
                default:
                    throw new Error(`No handler has been defined for events of type ${builtEvent.eventType}`);
            }
        });
        (0, $6rvcc.default)(this, "_fireDelayedEvent", (identifier, builtEvent, context, userInfo)=>{
            try {
                // User information can change while the delay period is active, so we need to restore the values that
                // were active when the event was originally fired.
                this._changeInternalUserId(userInfo.userId, userInfo.anonymousId);
                builtEvent.tags = [
                    ...builtEvent.tags || [],
                    'sentWithDelay'
                ];
                // The callbacks for delayed events are fired immediately, so there is nothing to pass through for this argument.
                this._fireEvent(identifier, builtEvent, context, undefined);
            } finally{
                this._changeInternalUserId(this._userInfo.userId, this._userInfo.anonymousId);
            }
        });
        (0, $6rvcc.default)(this, "_delayEvent", (identifier, builtEvent, context, userInfo, callback)=>{
            this._eventDelayQueue.push(identifier, builtEvent, context, userInfo);
            // Fire the callback immediately, as we can consider the event successfully processed at this point
            if (callback) callback();
        });
        (0, $6rvcc.default)(this, "_processEvent", (identifier, builtEvent, context, callback)=>{
            this._testingCache.saveEvent(builtEvent);
            if (this._shouldEventBeDelayed(builtEvent)) {
                this._delayEvent(identifier, builtEvent, context, this._userInfo, callback);
                return Promise.resolve();
            } else return this._fireEvent(identifier, builtEvent, context, callback);
        });
        (0, $6rvcc.default)(this, "setEmbeddedProduct", (embeddedProduct)=>{
            this._internalProductInfo.embeddedProduct = this._createEmbeddedProductGetter(embeddedProduct);
            this.resetUIViewedTimers();
        });
        (0, $6rvcc.default)(this, "clearEmbeddedProduct", ()=>{
            this._internalProductInfo.embeddedProduct = this._createEmbeddedProductGetter(null);
        });
        (0, $6rvcc.default)(this, "setSubproduct", (subproduct)=>{
            this._internalProductInfo.subproduct = this._createSubproductGetter(subproduct);
            this.resetUIViewedTimers();
        });
        /**
      * Calling this function in the intialisation of the client in product
      * captures specified 'origin tracing' URL params and fires a single origin landed event
      * <p>
      * This function expects a mapping between the keys for any URL parameters
      *  that should be captured and removed for origin tracing
      * Multiple parameters may be captured simultaneously if multiple key: handler function pairs are provided
      * Each handler function should return an object with two items
      * a) 'originTracingAttributes' - an object that will be added to the 'origin landed' event's attributes under 'originTracing
      * b) 'taskSessionId' (optional) - an Id string that will be added to the tasksessions for any event that fires from the tab, with the key
      *    matching the URL parameter, for the purpose of attributing subsequent analytics event to the origin land.
      * </p>
      * The general use case for this feature is for allowing attributation of user behaviour to a out of product or cross product link,
      * e.g. from a share or email
      *
      * An example calling this function using an external decoding library, with taskSessionId specified to persist
      * analyticsWebClient.setOriginTracingHandlers({
           atlOrigin: encodedOrigin => {
               const { id, product } = OriginTracing.fromEncoded(encodedOrigin);
               return { originTracingAttributes: {'id': id, 'product': product}, taskSessionId: id };
           },
       });
      *
      * @param  {Object} originParamHandlerMapping a dictionary of mappings between origin url param keys and handler functions
      * @this {AnalyticsWebClient}
      */ (0, $6rvcc.default)(this, "setOriginTracingHandlers", (originParamHandlerMapping)=>{
            const capturedOriginTraces = this._originTracing.handleOriginParameters(originParamHandlerMapping, this._historyReplaceFn);
            const keys = Object.keys(capturedOriginTraces);
            keys.forEach((x)=>{
                if (typeof capturedOriginTraces[x].taskSessionId !== 'undefined') this._task.createTaskSessionWithProvidedId(x, capturedOriginTraces[x].taskSessionId);
            });
            const originAttributes = {};
            keys.forEach((x)=>{
                if (capturedOriginTraces[x].originTracingAttributes) originAttributes[x] = capturedOriginTraces[x].originTracingAttributes;
                else // eslint-disable-next-line no-console
                console.warn(`Handling method for origin parameter ${x} has not returned any attributes`);
            });
            if (keys.length > 0) return this.sendOperationalEvent({
                action: 'landed',
                actionSubject: 'origin',
                source: 'webClient',
                attributes: {
                    originTracesLanded: originAttributes
                }
            }, // eslint-disable-next-line @typescript-eslint/no-empty-function
            ()=>{});
            return Promise.resolve();
        });
        (0, $6rvcc.default)(this, "setTenantInfo", (tenantIdType, tenantId)=>{
            if (!tenantIdType) throw new Error('Missing tenantIdType');
            if (tenantIdType !== (0, $dpXUu.tenantType).NONE && !tenantId) throw new Error('Missing tenantId');
            if (!(0, $9raiz.isType)((0, $dpXUu.tenantType), tenantIdType)) throw new Error(`Invalid tenantIdType '${tenantIdType}', ` + `must be an tenantType: [${(0, $eS4G8.objectValues)((0, $dpXUu.tenantType))}]`);
            this._tenantInfo = {
                tenantIdType: tenantIdType,
                tenantId: tenantId
            };
            this._eventProcessor.refreshMetadata(this._userInfo, this._tenantInfo);
        });
        (0, $6rvcc.default)(this, "clearTenantInfo", ()=>{
            this._tenantInfo = {};
            this._eventProcessor.refreshMetadata(this._userInfo, this._tenantInfo);
        });
        (0, $6rvcc.default)(this, "setOrgInfo", (orgId)=>{
            if (!orgId) throw new Error('Missing orgId');
            this._orgInfo = {
                orgId: orgId
            };
        });
        (0, $6rvcc.default)(this, "clearOrgInfo", ()=>{
            this._orgInfo = {};
        });
        (0, $6rvcc.default)(this, "setWorkspaceInfo", (workspaceId)=>{
            if (!workspaceId) throw new Error('Missing workspaceId');
            this._workspaceInfo = {
                workspaceId: workspaceId
            };
        });
        (0, $6rvcc.default)(this, "clearWorkspaceInfo", ()=>{
            this._workspaceInfo = {};
        });
        (0, $6rvcc.default)(this, "setCollaborationContextInfo", (collaborationContextAri)=>{
            if (!collaborationContextAri) throw new Error('Missing collaborationContextAri');
            this._collaborationContextInfo = {
                collaborationContextAri: collaborationContextAri
            };
        });
        (0, $6rvcc.default)(this, "clearCollaborationContextInfo", ()=>{
            this._collaborationContextInfo = {};
        });
        (0, $6rvcc.default)(this, "setUserInfo", (userIdType, userId)=>{
            (0, $c77r4.validateIdentifyEvent)(userIdType, userId);
            this._changeInternalUserId(userId);
            this._userInfo = {
                userIdType: userIdType,
                userId: userId,
                anonymousId: this._eventProcessor.getUser().getAnonymousId()
            };
            this._eventProcessor.refreshMetadata(this._userInfo, this._tenantInfo);
        });
        (0, $6rvcc.default)(this, "clearUserInfo", ()=>{
            this._changeInternalUserId(undefined);
            this._userInfo = {
                anonymousId: this._eventProcessor.getUser().getAnonymousId()
            };
            this._eventProcessor.refreshMetadata(this._userInfo, this._tenantInfo);
        });
        (0, $6rvcc.default)(this, "setAlias", (aliasKeyType, alias)=>{
            if (!aliasKeyType) throw new Error('Missing aliasType');
            if (!(0, $9raiz.isType)((0, $dpXUu.aliasType), aliasKeyType)) throw new Error(`Invalid aliasType '${aliasKeyType}', ` + `must be an aliasType: [${(0, $eS4G8.objectValues)((0, $dpXUu.aliasType))}]`);
            this._aliases[aliasKeyType] = alias;
        });
        (0, $6rvcc.default)(this, "clearAlias", ()=>{
            this._aliases = {};
        });
        (0, $6rvcc.default)(this, "setGroup", (groupsKeyType, group)=>{
            if (!groupsKeyType) throw new Error('Missing groupType');
            if (!(0, $9raiz.isType)((0, $dpXUu.groupType), groupsKeyType)) throw new Error(`Invalid groupType '${groupsKeyType}', ` + `must be an groupType: [${(0, $eS4G8.objectValues)((0, $dpXUu.groupType))}]`);
            this._groups[groupsKeyType] = group;
        });
        (0, $6rvcc.default)(this, "clearGroup", ()=>{
            this._groups = {};
        });
        (0, $6rvcc.default)(this, "getAnonymousId", ()=>this._userInfo.anonymousId);
        (0, $6rvcc.default)(this, "getCurrentSessionId", ()=>this._sessionTracking.getCurrentSessionId());
        (0, $6rvcc.default)(this, "setUIViewedAttributes", (uiViewedAttributes)=>{
            if (!uiViewedAttributes) throw new Error('Missing uiViewedAttributes');
            if (typeof uiViewedAttributes !== 'object' || Array.isArray(uiViewedAttributes)) throw new Error('Invalid uiViewedAttributes type, should be a non array object');
            this._uiViewedAttributes = $4667273d53967e9d$var$_objectSpread({}, uiViewedAttributes);
        });
        (0, $6rvcc.default)(this, "getUIViewedAttributes", ()=>{
            return this._uiViewedAttributes;
        });
        (0, $6rvcc.default)(this, "clearUIViewedAttributes", ()=>{
            this._uiViewedAttributes = {};
        });
        (0, $6rvcc.default)(this, "appendUIViewedAttributes", (attributes)=>{
            if (!this._uiViewedAttributes) this._uiViewedAttributes = attributes;
            else this._uiViewedAttributes = $4667273d53967e9d$var$_objectSpread($4667273d53967e9d$var$_objectSpread({}, this._uiViewedAttributes), attributes);
        });
        (0, $6rvcc.default)(this, "sendIdentifyEvent", (userIdType, userId, callback)=>{
            this.setUserInfo(userIdType, userId);
            const builtEvent = {
                userIdType: userIdType,
                eventType: (0, $dpXUu.eventType).IDENTIFY
            };
            return this._processEvent(userId, builtEvent, this._context, callback);
        });
        /**
     * @deprecated
     * please use {@link sendScreenEvent instead)
     */ (0, $6rvcc.default)(this, "sendPageEvent", (name, callback)=>{
            return this.sendScreenEvent(name, callback);
        });
        /**
     * send screen event
     * @param event The event / For retrocompatibility event name is still supported here.
     * @param callback
     * @param attributes. Deprecated, will get ignored if using an event object as first param.
     */ (0, $6rvcc.default)(this, "sendScreenEvent", (event, callback, attributes)=>{
            let screenName;
            let screenAttributes;
            let screenContainers;
            let screenTags;
            if (typeof event === 'object') {
                /* This is for retrocompatibility */ screenName = event.name;
                screenAttributes = event.attributes;
                screenContainers = event.containers;
                screenTags = event.tags;
            } else {
                screenName = event;
                screenAttributes = attributes;
            }
            (0, $gKKSu.validateScreenEvent)(screenName);
            (0, $1F03j.validateContainers)(screenContainers);
            const builtEvent = (0, $1dFnn.buildScreenEvent)(this._internalProductInfo, this._tenantInfo, this._userInfo, screenAttributes, // TODO: Remove the as any and move into a place where we know event is an object
            event.nonPrivacySafeAttributes, screenTags, this._tabTracking.getCurrentTabId(), this._sessionTracking.getCurrentSessionId(), this._task.getAllTaskSessions(), this._crossProductInteractionTracking.getInteractionSession(), this._orgInfo, this._pageLoadId, this._workspaceInfo, this._collaborationContextInfo, event, screenContainers, this._aliases, this._groups);
            const builtEventWithName = $4667273d53967e9d$var$_objectSpread({
                name: screenName
            }, builtEvent);
            this._setLastScreenEvent(builtEventWithName);
            return this._processEvent(screenName, builtEventWithName, this._context, (0, $7UqwT.default)(callback, builtEventWithName));
        });
        (0, $6rvcc.default)(this, "sendTrackEvent", (event, callback)=>{
            (0, $lHJ7U.validateTrackEvent)(event);
            const builtEvent = (0, $doaPm.buildActionEvent)(this._internalProductInfo, this._tenantInfo, this._userInfo, event, (0, $dpXUu.eventType).TRACK, this._tabTracking.getCurrentTabId(), this._sessionTracking.getCurrentSessionId(), this._task.getAllTaskSessions(), this._crossProductInteractionTracking.getInteractionSession(), this._orgInfo, this._pageLoadId, this._workspaceInfo, this._collaborationContextInfo, this._aliases, this._groups);
            return this._processEvent((0, $478yZ.buildActionName)(event), builtEvent, this._context, (0, $7UqwT.default)(callback, builtEvent));
        });
        (0, $6rvcc.default)(this, "sendUIEvent", (event, callback)=>{
            (0, $2E7is.validateUIEvent)(event);
            const builtEvent = (0, $doaPm.buildActionEvent)(this._internalProductInfo, this._tenantInfo, this._userInfo, event, (0, $dpXUu.eventType).UI, this._tabTracking.getCurrentTabId(), this._sessionTracking.getCurrentSessionId(), this._task.getAllTaskSessions(), this._crossProductInteractionTracking.getInteractionSession(), this._orgInfo, this._pageLoadId, this._workspaceInfo, this._collaborationContextInfo, this._aliases, this._groups);
            return this._processEvent((0, $478yZ.buildActionName)(event), builtEvent, this._context, (0, $7UqwT.default)(callback, builtEvent));
        });
        (0, $6rvcc.default)(this, "sendOperationalEvent", (event, callback)=>{
            (0, $4uub9.validateOperationalEvent)(event);
            const builtEvent = (0, $doaPm.buildActionEvent)(this._internalProductInfo, this._tenantInfo, this._userInfo, event, (0, $dpXUu.eventType).OPERATIONAL, this._tabTracking.getCurrentTabId(), this._sessionTracking.getCurrentSessionId(), this._task.getAllTaskSessions(), this._crossProductInteractionTracking.getInteractionSession(), this._orgInfo, this._pageLoadId, this._workspaceInfo, this._collaborationContextInfo, this._aliases, this._groups);
            return this._processEvent((0, $478yZ.buildActionName)(event), builtEvent, this._context, (0, $7UqwT.default)(callback, builtEvent));
        });
        (0, $6rvcc.default)(this, "startUIViewedEvent", (callback)=>{
            this.stopUIViewedEvent();
            this._uiViewedEvent = this.createUIViewedEvent(callback);
            this._uiViewedEvent.start();
        });
        (0, $6rvcc.default)(this, "stopUIViewedEvent", ()=>{
            if (this._uiViewedEvent) {
                this._uiViewedEvent.stop();
                this._uiViewedEvent = null;
            }
        });
        (0, $6rvcc.default)(this, "resetUIViewedTimers", ()=>{
            if (this._uiViewedEvent) this._uiViewedEvent.resetTimers();
        });
        (0, $6rvcc.default)(this, "signalUserActive", ()=>{
            let uiViewedEvent = this._uiViewedEvent || this.createUIViewedEvent(null);
            uiViewedEvent.signalUserActive();
        });
        (0, $6rvcc.default)(this, "createUIViewedEvent", (callback)=>{
            return new (0, $4penA.default)(this._internalProductInfo, ()=>({
                    embeddedProduct: this._internalProductInfo.embeddedProduct(),
                    subproduct: this._internalProductInfo.subproduct(),
                    tenantIdType: this._tenantInfo.tenantIdType,
                    tenantId: this._tenantInfo.tenantId,
                    userId: this._userInfo.userId,
                    lastScreenEvent: this._getLastScreenEvent(),
                    attributes: this._uiViewedAttributes
                }), (event)=>this.sendUIEvent(event, callback));
        });
        (0, $6rvcc.default)(this, "startApdexEvent", (apdexEvent)=>{
            this._apdexEvent.start(apdexEvent);
        });
        (0, $6rvcc.default)(this, "getApdexStart", (apdexEvent)=>this._apdexEvent.getStart(apdexEvent));
        (0, $6rvcc.default)(this, "stopApdexEvent", (apdexEvent, callback)=>{
            this._apdexEvent.stop(apdexEvent, callback);
        });
        // TODO If we ever make another breaking change, merge these two optional args into an `options` object arg.
        (0, $6rvcc.default)(this, "startLowPriorityEventDelay", (timeout, callback)=>{
            this._eventDelayQueue.startLowPriorityEventDelay(timeout, callback);
        });
        (0, $6rvcc.default)(this, "stopLowPriorityEventDelay", ()=>{
            this._eventDelayQueue.stopLowPriorityEventDelay();
        });
        (0, $6rvcc.default)(this, "onEvent", (_analyticsId, analyticsData)=>{
            if (!analyticsData) throw new Error('Missing analyticsData');
            if (!analyticsData.eventType) throw new Error('Missing analyticsData.eventType');
            if (analyticsData.eventType === (0, $dpXUu.eventType).TRACK) return this.sendTrackEvent(analyticsData);
            else if (analyticsData.eventType === (0, $dpXUu.eventType).UI) return this.sendUIEvent(analyticsData);
            else if (analyticsData.eventType === (0, $dpXUu.eventType).OPERATIONAL) return this.sendOperationalEvent(analyticsData);
            else if (analyticsData.eventType === (0, $dpXUu.eventType).SCREEN) return this.sendScreenEvent(analyticsData.name, null, analyticsData.attributes);
            else if (analyticsData.eventType === (0, $dpXUu.eventType).IDENTIFY) return this.sendIdentifyEvent(analyticsData.userIdType, analyticsData.userId);
            throw new Error(`Invalid analyticsData.eventType '${analyticsData.eventType}', ` + `must be an eventType: [${(0, $eS4G8.objectValues)((0, $dpXUu.eventType))}]`);
        });
        (0, $6rvcc.default)(this, "setResponseCallback", (responseCallback)=>{
            this._eventProcessor.setResponseCallback(responseCallback);
        });
        if (!productInfo) throw new Error('Missing productInfo');
        if (!productInfo.env) throw new Error('Missing productInfo.env');
        if (!productInfo.product) throw new Error('Missing productInfo.product');
        if (!(0, $9raiz.isType)((0, $dpXUu.envType), productInfo.env)) throw new Error(`Invalid productInfo.env '${productInfo.env}', ` + `must be an envType: [${(0, $eS4G8.objectValues)((0, $dpXUu.envType))}]`);
        if (!productInfo.origin) productInfo.origin = (0, $dpXUu.originType).WEB;
        else if (!(0, $9raiz.isType)((0, $dpXUu.originType), productInfo.origin)) throw new Error(`Invalid productInfo.origin '${productInfo.origin}', ` + `must be an originType: [${(0, $eS4G8.objectValues)((0, $dpXUu.originType))}]`);
        if (!productInfo.platform) productInfo.platform = productInfo.origin === (0, $dpXUu.originType).WEB ? (0, $dpXUu.platformType).WEB : (0, $dpXUu.platformType).DESKTOP;
        else (0, $gUTHp.validatePlatform)(productInfo);
        this._logger = settings.logger || console;
        // Auto-detect Oasis perimeter (e.g. FedRAMP Moderate) when the consumer hasn't explicitly provided a perimeter.
        if (!productInfo.perimeter) try {
            if ((0, $eSdwu.isFedrampModerate)()) productInfo.perimeter = (0, $dpXUu.perimeterType).FEDRAMP_MODERATE;
        } catch (e) {
            this._logger.warn('Failed to auto-detect perimeter: %s', e instanceof Error ? e.message : String(e));
        }
        // Default to commercial perimeter if not explicitly provided and not auto-detected.
        if (!productInfo.perimeter) productInfo.perimeter = (0, $dpXUu.perimeterType).COMMERCIAL;
        if (!(0, $9raiz.isType)((0, $dpXUu.perimeterType), productInfo.perimeter)) throw new Error(`Invalid productInfo.perimeter '${productInfo.perimeter}', ` + `must be a perimeterType: [${(0, $eS4G8.objectValues)((0, $dpXUu.perimeterType))}]`);
        // Auto-detect Oasis Isolated Cloud (IC) environment when the consumer hasn't explicitly provided an `ic` value.
        if (!productInfo.ic) try {
            const icId = (0, $fimjF.isolationContextId)();
            if (icId && icId.length > 0) productInfo.ic = icId;
        } catch (e) {
            this._logger.warn('Failed to auto-detect isolation context: %s', e instanceof Error ? e.message : String(e));
        }
        this._internalProductInfo = $4667273d53967e9d$var$_objectSpread($4667273d53967e9d$var$_objectSpread({}, productInfo), {}, {
            subproduct: this._createSubproductGetter(productInfo.subproduct),
            embeddedProduct: this._createEmbeddedProductGetter(productInfo.embeddedProduct)
        });
        this._tenantInfo = {};
        this._orgInfo = {};
        this._uiViewedAttributes = {};
        if (productInfo !== null && productInfo !== void 0 && productInfo.embeddedContext) {
            this._embeddedContext = productInfo.embeddedContext;
            if ((0, $lsX7U.isFirstParty)(this._embeddedContext)) this.setUIViewedAttributes({
                embeddedType: this._embeddedContext['embeddedType'],
                embeddedFromProduct: this._embeddedContext['embeddedFromProduct'],
                embeddedFromSubproduct: this._embeddedContext['embeddedFromSubproduct'],
                embeddedFromTopLevelDomain: this._embeddedContext['embeddedFromTopLevelDomain']
            });
            if ((0, $5kUYv.isThirdParty)(this._embeddedContext)) this.setUIViewedAttributes({
                embeddedType: this._embeddedContext['embeddedType'],
                embeddedFromTopLevelDomain: this._embeddedContext['embeddedFromTopLevelDomain']
            });
        }
        this._context = (0, $dIKYA.buildContext)(this._internalProductInfo);
        this._safeSessionStorage = new (0, $cMwGH.default)();
        const _useStargate = this._useStargate(settings.useStargate);
        const apiHost = (0, $ls3Em.selectHost)({
            useStargate: _useStargate,
            env: productInfo.env,
            useLegacyUrl: settings.useLegacyUrl,
            perimeter: productInfo.perimeter,
            ic: productInfo.ic,
            envOverride: productInfo.envOverride,
            apiHost: settings.apiHost
        });
        const apiHostProtocol = settings.apiHostProtocol || 'https';
        const minRetryDelay = settings.minRetryDelay || 1000;
        const maxAttempts = settings.maxRetryAttempts !== undefined && Number.isInteger(settings.maxRetryAttempts) && settings.maxRetryAttempts >= 0 ? settings.maxRetryAttempts + 1 : undefined;
        const retryQueueOptions = {
            maxRetryDelay: 60000,
            minRetryDelay: minRetryDelay,
            backoffFactor: 2,
            flushWaitMs: settings.flushWaitInterval,
            flushBeforeUnload: settings.flushBeforeUnload,
            maxAttempts: maxAttempts,
            maxQueueSize: settings.maxQueueSize
        };
        const retryQueuePrefix = `awc-${productInfo.env}`;
        const xidPromiseGetter = ()=>(0, $hPniv.XIDPromise)(settings.xidConsent, settings.xidPromiseFn);
        const disableCookiePersistence = settings.disableCookiePersistence || false;
        const metadataClientFactory = settings.metadataClientFactory || (0, $89ZKV.MetadataClient).Factory;
        const metadataClient = metadataClientFactory(apiHostProtocol, apiHost, productInfo.product);
        this._eventProcessor = new (0, $9Do9V.default)({
            apiHost: apiHost,
            apiHostProtocol: apiHostProtocol,
            product: productInfo.product,
            retryQueuePrefix: retryQueuePrefix,
            retryQueueOptions: retryQueueOptions,
            xidPromiseGetter: xidPromiseGetter,
            logger: this._logger,
            metadataClient: metadataClient,
            disableCookiePersistence: disableCookiePersistence,
            responseCallback: (0, $dyX62.LoggingResponseCallback).getCallback(this._logger),
            env: productInfo.env,
            perimeter: productInfo.perimeter,
            enableMetadataCalls: this.metadataCallsEnabled(settings),
            enableEventCalls: this.eventCallsEnabled(settings)
        });
        this._userInfo = {
            anonymousId: this._eventProcessor.getUser().getAnonymousId(settings === null || settings === void 0 ? void 0 : settings.customAnonymousIdGenerator)
        };
        this._pageVisibility = new (0, $7Jko1.default)();
        this._tabTracking = new (0, $j5Le2.default)();
        this._sessionTracking = new (0, $5P1Jy.default)({
            sessionExpiryTime: settings.sessionExpiryTime,
            onNewSessionStarted: settings.onNewSessionStarted
        });
        this._task = new (0, $kxbHy.default)();
        this._originTracing = new (0, $h5UBC.default)();
        this._eventProcessor.setOriginTracingClient(this._originTracing);
        // Init Apdex
        this._apdexEvent = new (0, $nxH15.default)(this.sendOperationalEvent, this._pageVisibility);
        this._historyReplaceFn = typeof settings.historyReplaceFn === 'function' ? settings.historyReplaceFn : (0, $74pGx.defaultHistoryReplaceFn);
        this._eventDelayQueue = new (0, $9hqdJ.default)(this._fireDelayedEvent, settings.delayQueueCompressors || []);
        this._testingCache = new (0, $8jZU6.default)(settings.isSynthetic, settings.enableTestingCache);
        this._pageLoadId = (0, $1Ygrk.default)();
        this._workspaceInfo = {};
        this._collaborationContextInfo = {};
        this._aliases = {};
        this._groups = {};
        this._crossProductInteractionTracking = new (0, $3xmDM.default)({
            perimeter: productInfo.perimeter,
            product: productInfo.product,
            sendEventCallback: this.sendOperationalEvent,
            historyReplaceFn: this._historyReplaceFn
        });
        this._crossProductInteractionTracking.validateInteractionSession();
    }
    metadataCallsEnabled(settings) {
        if (typeof settings.disableMetadataCalls === 'boolean') return !settings.disableMetadataCalls;
        return !(0, $kqsXa.TestSupport).isGeminiVREnvironment() && !(0, $kqsXa.TestSupport).areFetchCallsDisabled();
    }
    eventCallsEnabled(settings) {
        if (typeof settings.disableEventCalls === 'boolean') return !settings.disableEventCalls;
        return !(0, $kqsXa.TestSupport).isGeminiVREnvironment() && !(0, $kqsXa.TestSupport).areFetchCallsDisabled();
    }
    setEventValidationMode(eventValidationMode) {
        this._context.context.validationMode = eventValidationMode;
    }
    /**
   * @private
   * @deprecated
   * Please avoid using internal properties. They are not part of the public
   * API and may change without notice.
   *
   * This property has been exposed for backward compatibility with existing
   * tests in external code
   */ get task() {
        return this._task;
    }
    /**
   * @private
   * @deprecated
   * Please avoid using internal properties.
   * They are not part of the public API and may change without notice.
   *
   * This property has been exposed for backward compatibility with existing
   * tests in external code
   */ get _productInfo() {
        return this._internalProductInfo;
    }
}

});
parcelRegister("6rvcc", function(module, exports) {
$parcel$export(module.exports, "default", () => $4b0d768997324831$export$2e2bcd8739ae039);

var $5Wodd = parcelRequire("5Wodd");
function $4b0d768997324831$export$2e2bcd8739ae039(e, r, t) {
    return (r = (0, $5Wodd.default)(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}

});
parcelRegister("5Wodd", function(module, exports) {
$parcel$export(module.exports, "default", () => $453526922e572780$export$2e2bcd8739ae039);

var $itFCD = parcelRequire("itFCD");

var $4WVjc = parcelRequire("4WVjc");
function $453526922e572780$export$2e2bcd8739ae039(t) {
    var i = (0, $4WVjc.default)(t, "string");
    return "symbol" == (0, $itFCD.default)(i) ? i : i + "";
}

});
parcelRegister("itFCD", function(module, exports) {
$parcel$export(module.exports, "default", () => $d73b38b58c759946$export$2e2bcd8739ae039);
function $d73b38b58c759946$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $d73b38b58c759946$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $d73b38b58c759946$export$2e2bcd8739ae039(o);
}

});

parcelRegister("4WVjc", function(module, exports) {
$parcel$export(module.exports, "default", () => $39a90884cc24e4e4$export$2e2bcd8739ae039);

var $itFCD = parcelRequire("itFCD");
function $39a90884cc24e4e4$export$2e2bcd8739ae039(t, r) {
    if ("object" != (0, $itFCD.default)(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (0, $itFCD.default)(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}

});



parcelRegister("eSdwu", function(module, exports) {
$parcel$export(module.exports, "isFedrampModerate", () => $ad409937b0dd689b$export$104cb891a6e90b3a);

var $lkh54 = parcelRequire("lkh54");

var $kN4Zn = parcelRequire("kN4Zn");
function $ad409937b0dd689b$export$104cb891a6e90b3a() {
    if (typeof document === 'undefined') {
        var _globalThis$ssrContex, _globalThis$ssrContex2;
        // @ts-ignore
        return (_globalThis$ssrContex = (_globalThis$ssrContex2 = globalThis.ssrContext) === null || _globalThis$ssrContex2 === void 0 ? void 0 : _globalThis$ssrContex2.isInFedramp) !== null && _globalThis$ssrContex !== void 0 ? _globalThis$ssrContex : false;
    }
    var atlCtxCookieValues = (0, $kN4Zn.parseAtlCtxCookies)();
    if (!atlCtxCookieValues) // If the cookies are not set, the current perimeter is non-isolated commercial
    return false;
    return atlCtxCookieValues.perimeter === (0, $lkh54.FEDRAMP_MODERATE);
}

});
parcelRegister("lkh54", function(module, exports) {
$parcel$export(module.exports, "FEDRAMP_MODERATE", () => $f868b71fb379c306$export$ce553301d55c2fd8);
$parcel$export(module.exports, "COMMERCIAL", () => $f868b71fb379c306$export$f005e2e9f707cb5f);
$parcel$export(module.exports, "ATL_CTX_PERIMETER", () => $f868b71fb379c306$export$87285944378c596);
$parcel$export(module.exports, "ATL_CTX_ISOLATION_CONTEXT_DOMAIN", () => $f868b71fb379c306$export$715603e81922c3ec);
$parcel$export(module.exports, "ATL_CTX_ISOLATION_CONTEXT_ID", () => $f868b71fb379c306$export$a0ffa0598c95dfb7);
var $f868b71fb379c306$export$ce553301d55c2fd8 = 'fedramp-moderate';
var $f868b71fb379c306$export$f005e2e9f707cb5f = 'commercial';
var $f868b71fb379c306$export$17b81a3d6c98013c = 'isolated-cloud';
var $f868b71fb379c306$export$a739cd5aac835909 = 'staging';
var $f868b71fb379c306$export$42dd0cdd351a4a9 = 'prod';
var $f868b71fb379c306$export$404582bc18fe4d9e = 'dev';
var $f868b71fb379c306$export$87285944378c596 = 'Atl-Ctx-Perimeter';
var $f868b71fb379c306$export$715603e81922c3ec = 'Atl-Ctx-Isolation-Context-Domain';
var $f868b71fb379c306$export$a0ffa0598c95dfb7 = 'Atl-Ctx-Isolation-Context-Id';
var $f868b71fb379c306$export$74814ca8786924c3 = 'Bifrost-Atl-Ctx-Cloud-Service-Provider';
var $f868b71fb379c306$export$b61e047ddcc35726 = 'GCP';
var $f868b71fb379c306$export$1baf17f3e645a2b2 = 'AWS';

});

parcelRegister("kN4Zn", function(module, exports) {
$parcel$export(module.exports, "parseAtlCtxCookies", () => $f22c40ef15d7672e$export$3fa7b7af96286cc9);

var $lkh54 = parcelRequire("lkh54");

var $lqDQf = parcelRequire("lqDQf");
function $f22c40ef15d7672e$export$3fa7b7af96286cc9() {
    var global = globalThis;
    try {
        // HOT-118791: the code below doesn't work on the server, and creates log spam in the catch block - "Cannot read properties of undefined (reading 'cookie')"
        if (typeof globalThis.document === 'undefined') return undefined;
        var cookies = global.document.cookie;
        var perimeter = (0, $lqDQf.getRawCookieValue)((0, $lkh54.ATL_CTX_PERIMETER), cookies);
        if (!perimeter) // Indicative of non-isolated commercial perimeter
        return undefined;
        var icDomain = (0, $lqDQf.getRawCookieValue)((0, $lkh54.ATL_CTX_ISOLATION_CONTEXT_DOMAIN), cookies);
        var icId = (0, $lqDQf.getRawCookieValue)((0, $lkh54.ATL_CTX_ISOLATION_CONTEXT_ID), cookies);
        // The IC Domain and IC Id cookie values are empty strings for non Isolated Cloud
        var emptyIcDomain = !icDomain || icDomain.length === 0;
        var emptyIcId = !icId || icId.length === 0;
        return {
            perimeter: perimeter,
            icDomain: emptyIcDomain ? undefined : icDomain,
            icId: emptyIcId ? undefined : icId
        };
    } catch (e) {
        console.warn('Failed to parse atl-ctx cookies:', e);
        return undefined;
    }
}

});
parcelRegister("lqDQf", function(module, exports) {
$parcel$export(module.exports, "getRawCookieValue", () => $f99aee6bb01b7c4d$export$aa09aab30a92256c);

var $8EmK8 = parcelRequire("8EmK8");
function $f99aee6bb01b7c4d$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $f99aee6bb01b7c4d$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $f99aee6bb01b7c4d$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $f99aee6bb01b7c4d$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $f99aee6bb01b7c4d$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $f99aee6bb01b7c4d$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function $f99aee6bb01b7c4d$export$aa09aab30a92256c(cookieName, cookieString) {
    if (!cookieString) return undefined;
    var cookies = cookieString.split(';');
    var _iterator = $f99aee6bb01b7c4d$var$_createForOfIteratorHelper(cookies), _step;
    try {
        for(_iterator.s(); !(_step = _iterator.n()).done;){
            var cookie = _step.value;
            var _cookie$trim$split = cookie.trim().split('='), _cookie$trim$split2 = (0, $8EmK8.default)(_cookie$trim$split, 2), name = _cookie$trim$split2[0], value = _cookie$trim$split2[1];
            if (name === cookieName) return value;
        }
    } catch (err) {
        _iterator.e(err);
    } finally{
        _iterator.f();
    }
    return undefined;
}

});
parcelRegister("8EmK8", function(module, exports) {
$parcel$export(module.exports, "default", () => $64c3b37599914551$export$2e2bcd8739ae039);

var $lUCiq = parcelRequire("lUCiq");

var $2Fe1l = parcelRequire("2Fe1l");

var $1SMa1 = parcelRequire("1SMa1");

var $bGUvW = parcelRequire("bGUvW");
function $64c3b37599914551$export$2e2bcd8739ae039(r, e) {
    return (0, $lUCiq.default)(r) || (0, $2Fe1l.default)(r, e) || (0, $1SMa1.default)(r, e) || (0, $bGUvW.default)();
}

});
parcelRegister("lUCiq", function(module, exports) {
$parcel$export(module.exports, "default", () => $ff3c88be679dabbf$export$2e2bcd8739ae039);
function $ff3c88be679dabbf$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return r;
}

});

parcelRegister("2Fe1l", function(module, exports) {
$parcel$export(module.exports, "default", () => $1f0a495124791ab2$export$2e2bcd8739ae039);
function $1f0a495124791ab2$export$2e2bcd8739ae039(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}

});

parcelRegister("1SMa1", function(module, exports) {
$parcel$export(module.exports, "default", () => $15f0314ce6d3ffc4$export$2e2bcd8739ae039);

var $5CNLq = parcelRequire("5CNLq");
function $15f0314ce6d3ffc4$export$2e2bcd8739ae039(r, a) {
    if (r) {
        if ("string" == typeof r) return (0, $5CNLq.default)(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? (0, $5CNLq.default)(r, a) : void 0;
    }
}

});
parcelRegister("5CNLq", function(module, exports) {
$parcel$export(module.exports, "default", () => $41871a72442322d1$export$2e2bcd8739ae039);
function $41871a72442322d1$export$2e2bcd8739ae039(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}

});


parcelRegister("bGUvW", function(module, exports) {
$parcel$export(module.exports, "default", () => $882f74790b233b58$export$2e2bcd8739ae039);
function $882f74790b233b58$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});





parcelRegister("fimjF", function(module, exports) {
$parcel$export(module.exports, "isolationContextId", () => $b229d8fbe13f922c$export$839b022803d38d4d);

var $kN4Zn = parcelRequire("kN4Zn");

var $b4t3v = parcelRequire("b4t3v");
function $b229d8fbe13f922c$export$839b022803d38d4d() {
    if (typeof document === 'undefined') {
        var _globalThis$ssrContex;
        // @ts-ignore
        return (0, $b4t3v.isIsolatedCloud)() ? (_globalThis$ssrContex = globalThis.ssrContext) === null || _globalThis$ssrContex === void 0 ? void 0 : _globalThis$ssrContex.icName : undefined;
    }
    var atlCtxCookieValues = (0, $kN4Zn.parseAtlCtxCookies)();
    return atlCtxCookieValues === null || atlCtxCookieValues === void 0 ? void 0 : atlCtxCookieValues.icId;
}

});
parcelRegister("b4t3v", function(module, exports) {
$parcel$export(module.exports, "isIsolatedCloud", () => $80f69b3ea8038d30$export$9186ccba8effc5de);

var $hZhqx = parcelRequire("hZhqx");

var $kN4Zn = parcelRequire("kN4Zn");
function $80f69b3ea8038d30$export$9186ccba8effc5de() {
    if (typeof document === 'undefined') {
        var _globalThis$ssrContex, _globalThis$ssrContex2;
        // @ts-ignore
        return (_globalThis$ssrContex = (_globalThis$ssrContex2 = globalThis.ssrContext) === null || _globalThis$ssrContex2 === void 0 ? void 0 : _globalThis$ssrContex2.isInIC) !== null && _globalThis$ssrContex !== void 0 ? _globalThis$ssrContex : false;
    }
    var atlCtxCookieValues = (0, $kN4Zn.parseAtlCtxCookies)();
    if (!atlCtxCookieValues) // If the cookies are not set, the current perimeter is non-isolated commercial
    return false;
    // The icDomain check is needed for when federal perimeters are eventually added to Isolated Cloud as well
    return (0, $hZhqx.ISOLATED_CLOUD_PERIMETERS).includes(atlCtxCookieValues.perimeter) && atlCtxCookieValues.icDomain !== undefined;
}

});
parcelRegister("hZhqx", function(module, exports) {
$parcel$export(module.exports, "ISOLATED_CLOUD_PERIMETERS", () => $d185a6d82daded7d$export$d8347b4aae768c2d);

var $lkh54 = parcelRequire("lkh54");
var $d185a6d82daded7d$export$d8347b4aae768c2d = [
    (0, $lkh54.COMMERCIAL)
];

});



parcelRegister("dpXUu", function(module, exports) {
$parcel$export(module.exports, "envType", () => $9c4c150c990b1f10$export$56ac8ebc9870b1b9);
$parcel$export(module.exports, "eventType", () => $9c4c150c990b1f10$export$4c045e605d532c98);
$parcel$export(module.exports, "platformType", () => $9c4c150c990b1f10$export$6b4f396210e539f3);
$parcel$export(module.exports, "originType", () => $9c4c150c990b1f10$export$f73e9fcd368bb695);
$parcel$export(module.exports, "tenantType", () => $9c4c150c990b1f10$export$496f06ac2a964da2);
$parcel$export(module.exports, "productEmbedType", () => $9c4c150c990b1f10$export$f49776dca27a2e7c);
$parcel$export(module.exports, "userType", () => $9c4c150c990b1f10$export$1827adfd178b4870);
$parcel$export(module.exports, "apdexType", () => $9c4c150c990b1f10$export$99b37380a464d794);
$parcel$export(module.exports, "desktopPlatforms", () => $9c4c150c990b1f10$export$809831be6c4c6227);
$parcel$export(module.exports, "webPlatforms", () => $9c4c150c990b1f10$export$19c579398ad213e7);
$parcel$export(module.exports, "originTracingType", () => $9c4c150c990b1f10$export$62a500c02dc63ee);
$parcel$export(module.exports, "perimeterType", () => $9c4c150c990b1f10$export$bdd41749d2096e4b);
$parcel$export(module.exports, "aliasType", () => $9c4c150c990b1f10$export$a8c99e46b781d936);
$parcel$export(module.exports, "groupType", () => $9c4c150c990b1f10$export$e73680b18d9b7c6e);
/* eslint-disable @atlaskit/volt-strict-mode/no-multiple-exports */ // These types have been converted from frozen objects to enums.
// We cannot change their name, or even capitalise them without breaking API.


let $9c4c150c990b1f10$export$56ac8ebc9870b1b9 = /*#__PURE__*/ function(envType) {
    envType["LOCAL"] = "local";
    envType["DEV"] = "dev";
    envType["STAGING"] = "staging";
    envType["PROD"] = "prod";
    return envType;
}({});
let $9c4c150c990b1f10$export$4c045e605d532c98 = /*#__PURE__*/ function(eventType) {
    eventType["TRACK"] = "track";
    eventType["UI"] = "ui";
    eventType["OPERATIONAL"] = "operational";
    eventType["SCREEN"] = "screen";
    eventType["IDENTIFY"] = "identify";
    return eventType;
}({});
let $9c4c150c990b1f10$export$6b4f396210e539f3 = /*#__PURE__*/ function(platformType) {
    platformType["MAC"] = "mac";
    platformType["LINUX"] = "linux";
    platformType["WINDOWS"] = "windows";
    /**
   *  @deprecated desktop is here for retrocompatibility, please select one of the above OS instead.
   */ platformType["DESKTOP"] = "desktop";
    platformType["WEB"] = "web";
    platformType["MOBILE_WEB"] = "mobileWeb";
    return platformType;
}({});
let $9c4c150c990b1f10$export$f73e9fcd368bb695 = /*#__PURE__*/ function(originType) {
    originType["DESKTOP"] = "desktop";
    originType["WEB"] = "web";
    return originType;
}({});
let $9c4c150c990b1f10$export$496f06ac2a964da2 = /*#__PURE__*/ function(tenantType) {
    tenantType["CLOUD_ID"] = "cloudId";
    tenantType["ORG_ID"] = "orgId";
    tenantType["OPSGENIE_CUSTOMER_ID"] = "opsgenieCustomerId";
    tenantType["HALP_TEAM_ID"] = "halpTeamId";
    tenantType["LOOM_ORG_ID"] = "loomOrgId";
    tenantType["TRANSACTION_ACCOUNT_ID"] = "transactionAccountId";
    tenantType["TRELLO_WORKSPACE_ID"] = "trelloWorkspaceId";
    tenantType["JA_WORKSPACE_ID"] = "jiraAlignWorkspaceId";
    tenantType["STUDIO_WORKSPACE_ID"] = "studioWorkspaceId";
    tenantType["NONE"] = "none";
    return tenantType;
}({});
let $9c4c150c990b1f10$export$f49776dca27a2e7c = /*#__PURE__*/ function(productEmbedType) {
    productEmbedType["FIRST_PARTY"] = "FIRST_PARTY";
    productEmbedType["THIRD_PARTY"] = "THIRD_PARTY";
    return productEmbedType;
}({});
let $9c4c150c990b1f10$export$1827adfd178b4870 = /*#__PURE__*/ function(userType) {
    userType["ATLASSIAN_ACCOUNT"] = "atlassianAccount";
    userType["HASHED_EMAIL"] = "hashedEmail";
    userType["LOOM"] = "loom";
    userType["TRELLO"] = "trello";
    userType["OPSGENIE"] = "opsgenie";
    userType["JA_USER_ID"] = "jiraAlign";
    userType["HALP"] = "halp";
    return userType;
}({});
let $9c4c150c990b1f10$export$99b37380a464d794 = /*#__PURE__*/ function(apdexType) {
    apdexType["TRANSITION"] = "transition";
    apdexType["INITIAL_LOAD"] = "initialLoad";
    return apdexType;
}({});
const $9c4c150c990b1f10$export$809831be6c4c6227 = Object.freeze([
    $9c4c150c990b1f10$export$6b4f396210e539f3.DESKTOP,
    $9c4c150c990b1f10$export$6b4f396210e539f3.MAC,
    $9c4c150c990b1f10$export$6b4f396210e539f3.LINUX,
    $9c4c150c990b1f10$export$6b4f396210e539f3.WINDOWS
]);
const $9c4c150c990b1f10$export$19c579398ad213e7 = Object.freeze([
    $9c4c150c990b1f10$export$6b4f396210e539f3.WEB,
    $9c4c150c990b1f10$export$6b4f396210e539f3.MOBILE_WEB
]);
let $9c4c150c990b1f10$export$62a500c02dc63ee = /*#__PURE__*/ function(originTracingType) {
    originTracingType["ATL_ORIGIN"] = "atlOrigin";
    return originTracingType;
}({});
let $9c4c150c990b1f10$export$bdd41749d2096e4b = /*#__PURE__*/ function(perimeterType) {
    perimeterType["C5"] = "c5";
    perimeterType["COMMERCIAL"] = "commercial";
    perimeterType["FEDRAMP_MODERATE"] = "fedramp-moderate";
    perimeterType["FEDRAMP_HIGH"] = "fedramp-high";
    return perimeterType;
}({});
let $9c4c150c990b1f10$export$a8c99e46b781d936 = /*#__PURE__*/ function(aliasType) {
    return aliasType;
}({});
let $9c4c150c990b1f10$export$e73680b18d9b7c6e = /*#__PURE__*/ function(groupType) {
    groupType["TRANSACTION_ACCOUNT_ID"] = "transactionAccountId";
    return groupType;
}({});
let $9c4c150c990b1f10$export$12b75c708da5a04b = /*#__PURE__*/ function(envOverrides) {
    return envOverrides;
}({});

});

parcelRegister("nxH15", function(module, exports) {
$parcel$export(module.exports, "default", () => $046c48c9d0dd9a40$export$2e2bcd8739ae039);

var $6rvcc = parcelRequire("6rvcc");

var $dpXUu = parcelRequire("dpXUu");

var $9raiz = parcelRequire("9raiz");

var $7Jko1 = parcelRequire("7Jko1");

var $7kC2L = parcelRequire("7kC2L");
function $046c48c9d0dd9a40$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $046c48c9d0dd9a40$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $046c48c9d0dd9a40$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $6rvcc.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $046c48c9d0dd9a40$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
class $046c48c9d0dd9a40$export$2e2bcd8739ae039 {
    constructor(onEvent, pageVisibility){
        (0, $6rvcc.default)(this, "_getEventKey", ({ task: task, taskId: taskId })=>taskId ? `${task}.${taskId}` : task);
        (0, $6rvcc.default)(this, "_getEventTimingByName", (name)=>{
            const eventTimings = this._performance.getEntriesByName(name);
            const eventTiming = eventTimings[eventTimings.length - 1];
            return eventTiming;
        });
        (0, $6rvcc.default)(this, "_getApdexFields", (event)=>{
            const apdexTimings = this._getApdexTimings(event);
            const apdexScore = this._calculateApdex({
                duration: apdexTimings.duration,
                threshold: event.threshold
            });
            return $046c48c9d0dd9a40$var$_objectSpread($046c48c9d0dd9a40$var$_objectSpread({}, apdexTimings), {}, {
                apdex: apdexScore
            });
        });
        (0, $6rvcc.default)(this, "_getApdexTimings", (event)=>{
            const eventKey = this._getEventKey(event);
            const eventStartName = `${eventKey}-start`;
            const startTime = event.startTime || this._getStartTime(event, eventStartName);
            const stopTime = event.stopTime || this._getStopTime();
            // We do some clean up of the marks and started events
            this._cleanApdexState(eventKey);
            return {
                startTime: startTime,
                stopTime: stopTime,
                duration: stopTime - startTime
            };
        });
        (0, $6rvcc.default)(this, "_getStartTime", (event, eventName)=>{
            let startTime;
            const timeOrigin = this._performance.getTimeOrigin();
            if (event.type === (0, $dpXUu.apdexType).INITIAL_LOAD) startTime = timeOrigin;
            else {
                const eventTiming = this._getEventTimingByName(eventName);
                startTime = timeOrigin + eventTiming.startTime;
            }
            return startTime;
        });
        (0, $6rvcc.default)(this, "_getStopTime", ()=>this._performance.getTimeOrigin() + this._performance.now());
        (0, $6rvcc.default)(this, "_cleanApdexState", (eventKey)=>{
            this._performance.clearMarks(`${eventKey}-start`);
            this._performance.clearMarks(`${eventKey}-stop`);
            this._startedEvents.delete(eventKey);
        });
        (0, $6rvcc.default)(this, "_getVisibilityFields", (event)=>{
            let isActiveTab;
            /**
       * For initialLoad type:
       * 1. if tab was not ever hidden (!_wasPreviouslyHidden)
       *
       * For transition type:
       * 1. active status is tracked in active events map (_isActiveEvents)
       *
       * For any type, if startTime or stopTime is specified:
       * 1. If currently active (!_isHidden)
       */ if (event.type === (0, $dpXUu.apdexType).INITIAL_LOAD) isActiveTab = !this._wasPreviouslyHidden;
            else if (event.type === (0, $dpXUu.apdexType).TRANSITION) {
                const eventKey = this._getEventKey(event);
                isActiveTab = this._isActiveEvents.get(eventKey);
            }
            if (event.startTime || event.stopTime) isActiveTab = !this._pageVisibility.getIsHidden();
            return {
                isActiveTab: isActiveTab
            };
        });
        (0, $6rvcc.default)(this, "_calculateApdex", ({ duration: duration, threshold: threshold = this._threshold })=>{
            let apdex;
            const satisfiedThreshold = threshold;
            const tolerableThreshold = threshold * 4;
            if (duration <= satisfiedThreshold) apdex = 1;
            else if (duration <= tolerableThreshold) apdex = 0.5;
            else apdex = 0;
            return apdex;
        });
        (0, $6rvcc.default)(this, "_validateStartEvent", (event)=>{
            if (!event) throw new Error('Missing "event" in Apdex start event');
            if (!event.task) throw new Error('Missing "task" in Apdex start event');
            if (typeof event.task !== 'string') throw new Error('Invalid "task" in Apdex start event');
            if (event.taskId && typeof event.taskId !== 'string') throw new Error('Invalid "taskId" in Apdex start event');
        });
        (0, $6rvcc.default)(this, "_validateStopEvent", (event)=>{
            if (!event) throw new Error('Missing "event" in Apdex stop event');
            if (!event.task) throw new Error('Missing "task" in Apdex stop event');
            if (typeof event.task !== 'string') throw new Error('Invalid "task" in Apdex stop event');
            if (event.taskId && typeof event.taskId !== 'string') throw new Error('Invalid "taskId" in Apdex stop event');
            if (!event.type) throw new Error('Missing "type" in Apdex stop event');
            if (event.type && !(0, $9raiz.isType)((0, $dpXUu.apdexType), event.type)) throw new Error('Invalid "type" in Apdex stop event');
            if (event.threshold && typeof event.threshold !== 'number') throw new Error('Invalid "threshold" in Apdex stop event');
            /*
       * For a transition, if the startTime was not specified,
       * the start event should have been present.
       */ if (!event.startTime && event.type === (0, $dpXUu.apdexType).TRANSITION) {
                const eventKey = this._getEventKey(event);
                if (!this._startedEvents.has(eventKey)) throw new Error(`Apdex event transition "${eventKey}" was not started`);
            }
            if (event.startTime && !(typeof event.startTime === 'number' && event.startTime >= 0)) throw new Error('Invalid "startTime" in Apdex stop event');
            if (event.stopTime && typeof event.stopTime !== 'number') throw new Error('Invalid "stopTime" in Apdex stop event');
            if (event.stopTime <= event.startTime) throw new Error('"stopTime" should be greater than "startTime" in Apdex stop event');
        });
        (0, $6rvcc.default)(this, "_shouldSendEvent", (event)=>{
            if (!event) return false;
            if (typeof event.apdex !== 'number') return false;
            return true;
        });
        (0, $6rvcc.default)(this, "_sendEvent", (event, callback)=>{
            if (this._shouldSendEvent(event)) this._onEvent({
                source: 'ui',
                action: 'readyForUser',
                actionSubject: 'ui',
                attributes: $046c48c9d0dd9a40$var$_objectSpread($046c48c9d0dd9a40$var$_objectSpread({}, event.additionalAttributes), {}, {
                    task: event.task,
                    taskId: event.taskId,
                    type: event.type,
                    threshold: event.threshold || this._threshold,
                    apdex: event.apdex,
                    startTime: event.startTime,
                    stopTime: event.stopTime,
                    duration: event.duration,
                    isActiveTab: event.isActiveTab
                })
            }, callback);
        });
        if (!onEvent) throw new Error('Missing onEvent callback');
        if (typeof onEvent !== 'function') throw new Error('Invalid onEvent, must be function');
        if (!(pageVisibility instanceof (0, $7Jko1.default))) throw new Error('Invalid pageVisibility, must be PageVisibility class');
        this._startedEvents = new Map();
        this._performance = new (0, $7kC2L.default)();
        this._onEvent = onEvent;
        this._threshold = 1000;
        this._wasPreviouslyHidden = pageVisibility.getIsHidden();
        this._isActiveEvents = new Map();
        this._pageVisibility = pageVisibility;
        this._pageVisibility.addCallback('apdexEvent', (isHidden)=>{
            this.onVisibilityChange(!isHidden);
        });
    }
    start(event) {
        this._validateStartEvent(event);
        if (!this._performance.isAvailable()) return;
        const eventKey = this._getEventKey(event);
        const eventStartName = `${eventKey}-start`;
        this._startedEvents.set(eventKey, true);
        this._isActiveEvents.set(eventKey, !this._pageVisibility.getIsHidden());
        this._performance.clearMarks(eventStartName);
        this._performance.mark(eventStartName);
    }
    getStart(event) {
        this._validateStartEvent(event);
        if (!this._performance.isAvailable()) return undefined;
        const eventKey = this._getEventKey(event);
        const eventStartName = `${eventKey}-start`;
        return this._getEventTimingByName(eventStartName);
    }
    stop(event, callback) {
        this._validateStopEvent(event);
        if (!this._performance.isAvailable()) return;
        const apdexFields = this._getApdexFields(event);
        const visibilityFields = this._getVisibilityFields(event);
        this._sendEvent($046c48c9d0dd9a40$var$_objectSpread($046c48c9d0dd9a40$var$_objectSpread($046c48c9d0dd9a40$var$_objectSpread({}, event), apdexFields), visibilityFields), callback);
    }
    onVisibilityChange(isActive) {
        if (!isActive) {
            this._wasPreviouslyHidden = true;
            Array.from(this._isActiveEvents.keys()).forEach((key)=>this._isActiveEvents.set(key, false));
        }
    }
}

});
parcelRegister("9raiz", function(module, exports) {
$parcel$export(module.exports, "isType", () => $6dee9fba7ded93f5$export$26b9f946b448f23e);
function $6dee9fba7ded93f5$export$26b9f946b448f23e(type, value) {
    return Object.values(type).indexOf(value) > -1;
}

});

parcelRegister("7Jko1", function(module, exports) {
$parcel$export(module.exports, "default", () => $5a0c8cae642f3b67$export$2e2bcd8739ae039);

var $6rvcc = parcelRequire("6rvcc");
class $5a0c8cae642f3b67$export$2e2bcd8739ae039 {
    constructor(){
        (0, $6rvcc.default)(this, "_bindEventListeners", ()=>{
            document.addEventListener(this._visibilityChange, this._handleVisibilityChange, false);
        });
        (0, $6rvcc.default)(this, "_handleVisibilityChange", ()=>{
            const isHidden = document[this._hidden];
            this._isHidden = isHidden;
            this._callbacks.forEach((callbackFn)=>callbackFn(isHidden));
        });
        this._isHidden = false;
        this._callbacks = new Map();
        this._hidden = undefined;
        this._visibilityChange = undefined;
        if (typeof document !== 'undefined') {
            if (typeof document.hidden !== 'undefined') {
                // Opera 12.10 and Firefox 18 and later support
                this._isHidden = document.hidden;
                this._hidden = 'hidden';
                this._visibilityChange = 'visibilitychange';
            } else if (typeof document.msHidden !== 'undefined') {
                this._isHidden = document.msHidden;
                this._hidden = 'msHidden';
                this._visibilityChange = 'msvisibilitychange';
            } else if (typeof document.webkitHidden !== 'undefined') {
                this._isHidden = document.webkitHidden;
                this._hidden = 'webkitHidden';
                this._visibilityChange = 'webkitvisibilitychange';
            }
            if (typeof document.addEventListener !== 'undefined' && this._hidden !== undefined) this._bindEventListeners();
        }
    }
    addCallback(name, fn) {
        if (typeof name !== 'string') throw new Error('Invalid name, must be string');
        if (typeof fn !== 'function') throw new Error('Invalid callback, must be function');
        this._callbacks.set(name, fn);
    }
    removeCallback(name) {
        if (this._callbacks.has(name)) this._callbacks.delete(name);
    }
    getIsHidden() {
        return this._isHidden;
    }
}

});

parcelRegister("7kC2L", function(module, exports) {
$parcel$export(module.exports, "default", () => $5567e94e2046948c$export$2e2bcd8739ae039);
class $5567e94e2046948c$export$2e2bcd8739ae039 {
    constructor(){
        this._performance = window.performance;
    }
    clearMarks(...args) {
        if (!this._performance || !this._performance.clearMarks) return;
        this._performance.clearMarks(...args);
    }
    mark(...args) {
        if (!this._performance || !this._performance.mark) return;
        this._performance.mark(...args);
    }
    getEntriesByName(...args) {
        if (!this._performance || !this._performance.getEntriesByName) return [];
        return this._performance.getEntriesByName(...args);
    }
    getTimeOrigin() {
        if (!this._performance || !this._performance.timeOrigin && !this._performance.timing) return 0;
        return this._performance.timeOrigin || this._performance.timing.navigationStart;
    }
    now() {
        if (!this._performance || !this._performance.now) return Date.now ? Date.now() : +new Date();
        return this._performance.now();
    }
    isAvailable() {
        return !!this._performance && !!this._performance.clearMarks && !!this._performance.mark && !!this._performance.getEntriesByName && !!this._performance.timing;
    }
}

});


parcelRegister("doaPm", function(module, exports) {
$parcel$export(module.exports, "buildActionEvent", () => $9bf5ea544d445952$export$7bf451af4a8e3dd9);

var $6rvcc = parcelRequire("6rvcc");

var $3Bvfg = parcelRequire("3Bvfg");

var $i5njK = parcelRequire("i5njK");

var $16Pbp = parcelRequire("16Pbp");

var $34zyg = parcelRequire("34zyg");

var $bYscG = parcelRequire("bYscG");

var $lReO1 = parcelRequire("lReO1");

var $fea3y = parcelRequire("fea3y");

var $bCSvc = parcelRequire("bCSvc");

var $10rPP = parcelRequire("10rPP");

var $cu68C = parcelRequire("cu68C");

var $fcerX = parcelRequire("fcerX");
function $9bf5ea544d445952$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $9bf5ea544d445952$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $9bf5ea544d445952$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $6rvcc.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $9bf5ea544d445952$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $9bf5ea544d445952$export$7bf451af4a8e3dd9(productInfo, tenantInfo, userInfo, event, actionEventType, tabId, sessionId, taskSessions, interactionSession, orgInfo, pageLoadId, workspaceInfo, collaborationContextInfo, aliases, groups) {
    const productFields = (0, $fea3y.buildProductFields)(productInfo, (0, $fcerX.extractProductOverrides)(event));
    const tenantFields = (0, $bCSvc.buildTenantFields)(tenantInfo);
    const orgFields = (0, $lReO1.buildOrgFields)(orgInfo);
    const workspaceFields = (0, $cu68C.buildWorkspaceFields)(workspaceInfo);
    const collaborationContextFields = (0, $16Pbp.buildCollaborationContextFields)(collaborationContextInfo);
    const userFields = (0, $10rPP.buildUserFields)(userInfo);
    const actionFields = (0, $3Bvfg.buildActionFields)(event, actionEventType);
    return $9bf5ea544d445952$var$_objectSpread($9bf5ea544d445952$var$_objectSpread($9bf5ea544d445952$var$_objectSpread($9bf5ea544d445952$var$_objectSpread($9bf5ea544d445952$var$_objectSpread($9bf5ea544d445952$var$_objectSpread($9bf5ea544d445952$var$_objectSpread($9bf5ea544d445952$var$_objectSpread($9bf5ea544d445952$var$_objectSpread($9bf5ea544d445952$var$_objectSpread({}, productFields), tenantFields), orgFields), userFields), actionFields), (0, $34zyg.buildEventOverrides)(event)), {}, {
        tabId: tabId,
        sessionId: sessionId,
        taskSessions: taskSessions,
        interactionSession: interactionSession,
        pageLoadId: pageLoadId
    }, workspaceFields), collaborationContextFields), (0, $i5njK.buildAliases)(aliases)), (0, $bYscG.buildGroups)(groups));
}

});
parcelRegister("3Bvfg", function(module, exports) {
$parcel$export(module.exports, "buildActionFields", () => $29fd106b1c4d9134$export$655ecf7241feac42);

var $6rvcc = parcelRequire("6rvcc");

var $gLNNb = parcelRequire("gLNNb");
function $29fd106b1c4d9134$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $29fd106b1c4d9134$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $29fd106b1c4d9134$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $6rvcc.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $29fd106b1c4d9134$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $29fd106b1c4d9134$export$655ecf7241feac42(event, actionEventType) {
    return $29fd106b1c4d9134$var$_objectSpread({
        containerType: event.containerType,
        containerId: event.containerId,
        source: event.source,
        objectType: event.objectType,
        objectId: event.objectId,
        actionSubject: event.actionSubject,
        action: event.action,
        actionSubjectId: event.actionSubjectId,
        attributes: event.attributes,
        nonPrivacySafeAttributes: event.nonPrivacySafeAttributes,
        tags: event.tags,
        highPriority: event.highPriority,
        eventType: actionEventType
    }, (0, $gLNNb.buildContainersWithName)(event.containers));
}

});
parcelRegister("gLNNb", function(module, exports) {
$parcel$export(module.exports, "buildContainersWithName", () => $c357a8d34df33912$export$f045f238d77c002a);

var $9ThfS = parcelRequire("9ThfS");

var $c6Zqk = parcelRequire("c6Zqk");

var $fF75j = parcelRequire("fF75j");
function $c357a8d34df33912$export$f045f238d77c002a(containers) {
    if ((0, $fF75j.isNotEmptyObject)(containers)) {
        const validContainers = (0, $c6Zqk.filterAndBuildContainers)(containers);
        return (0, $9ThfS.buildAttributesWithName)('containers', validContainers);
    }
    return undefined;
}

});
parcelRegister("9ThfS", function(module, exports) {
$parcel$export(module.exports, "buildAttributesWithName", () => $7336a2a017c8348e$export$55b70947967d0b50);

var $fF75j = parcelRequire("fF75j");
function $7336a2a017c8348e$export$55b70947967d0b50(name, attrObject) {
    return (0, $fF75j.isNotEmptyObject)(attrObject) ? {
        [name]: attrObject
    } : undefined;
}

});
parcelRegister("fF75j", function(module, exports) {
$parcel$export(module.exports, "isNotEmptyObject", () => $b6702e3d22f9f4a3$export$e0287cc73292b477);

var $8OhNE = parcelRequire("8OhNE");
function $b6702e3d22f9f4a3$export$e0287cc73292b477(obj) {
    return (0, $8OhNE.isPlainObject)(obj) && Object.keys(obj).length > 0;
}

});
parcelRegister("8OhNE", function(module, exports) {
$parcel$export(module.exports, "isPlainObject", () => $66a0cce84268e928$export$53b83ca8eaab0383);
// Modified from https://github.com/jonschlinkert/is-plain-object/blob/master/index.js
function $66a0cce84268e928$var$isObject(val) {
    return val !== null && typeof val === 'object' && Array.isArray(val) === false;
}
function $66a0cce84268e928$var$isObjectObject(o) {
    return $66a0cce84268e928$var$isObject(o) === true && Object.prototype.toString.call(o) === '[object Object]';
}
function $66a0cce84268e928$export$53b83ca8eaab0383(o) {
    if ($66a0cce84268e928$var$isObjectObject(o) === false) return false;
    // If has modified constructor
    const ctor = o.constructor;
    if (typeof ctor !== 'function') return false;
    // If has modified prototype
    const prot = ctor.prototype;
    if ($66a0cce84268e928$var$isObjectObject(prot) === false) return false;
    // If constructor does not have an Object-specific method
    if (!('isPrototypeOf' in prot)) return false;
    // Most likely a plain Object
    return true;
}

});



parcelRegister("c6Zqk", function(module, exports) {
$parcel$export(module.exports, "filterAndBuildContainers", () => $8d15b10e48711977$export$3f5115a568819c1a);
function $8d15b10e48711977$export$3f5115a568819c1a(containers) {
    const validContainers = {};
    Object.keys(containers).forEach((key)=>{
        const value = containers[key];
        validContainers[key] = {
            id: value.id,
            type: value.type
        };
    });
    return validContainers;
}

});



parcelRegister("i5njK", function(module, exports) {
$parcel$export(module.exports, "buildAliases", () => $d2aac801566a776e$export$2c4ef8ee173bbcaa);

var $fF75j = parcelRequire("fF75j");
function $d2aac801566a776e$export$2c4ef8ee173bbcaa(aliases) {
    if ((0, $fF75j.isNotEmptyObject)(aliases)) return {
        aliases: aliases
    };
    return undefined;
}

});

parcelRegister("16Pbp", function(module, exports) {
$parcel$export(module.exports, "buildCollaborationContextFields", () => $0cee0de0c0689d82$export$d138783ff9effae1);
function $0cee0de0c0689d82$export$d138783ff9effae1(collaborationContextInfo) {
    return {
        collaborationContextAri: collaborationContextInfo.collaborationContextAri
    };
}

});

parcelRegister("34zyg", function(module, exports) {
$parcel$export(module.exports, "buildEventOverrides", () => $23cd529cd6044111$export$469803cc371327c2);
function $23cd529cd6044111$export$469803cc371327c2(event) {
    let result = {};
    if (event.anonymousId) result.anonymousId = event.anonymousId;
    if (event.excludedProperties) result.excludedProperties = event.excludedProperties;
    if (event.userConsents) result.userConsents = event.userConsents;
    return result;
}

});

parcelRegister("bYscG", function(module, exports) {
$parcel$export(module.exports, "buildGroups", () => $8b7b2cf5859cbfb1$export$680f59e10d3eb269);

var $fF75j = parcelRequire("fF75j");
function $8b7b2cf5859cbfb1$export$680f59e10d3eb269(groups) {
    if ((0, $fF75j.isNotEmptyObject)(groups)) return {
        groups: groups
    };
    return undefined;
}

});

parcelRegister("lReO1", function(module, exports) {
$parcel$export(module.exports, "buildOrgFields", () => $fe9a0859b48fd736$export$19ccbe55c9aa75d5);
function $fe9a0859b48fd736$export$19ccbe55c9aa75d5(orgInfo) {
    return {
        orgId: orgInfo.orgId
    };
}

});

parcelRegister("fea3y", function(module, exports) {
$parcel$export(module.exports, "buildProductFields", () => $b15ff6cf1be335fd$export$bd1896e45d2ef8e8);

var $36pRP = parcelRequire("36pRP");
function $b15ff6cf1be335fd$export$bd1896e45d2ef8e8(productInfo, productOverrides) {
    const overrides = productOverrides || {};
    const env = (0, $36pRP.getProductField)(productInfo.env, overrides.env);
    const product = (0, $36pRP.getProductField)(productInfo.product, overrides.product);
    const subproduct = (0, $36pRP.getProductField)(productInfo.subproduct(), overrides.subproduct);
    const version = (0, $36pRP.getProductField)(productInfo.version, overrides.version);
    const origin = (0, $36pRP.getProductField)(productInfo.origin, overrides.origin);
    const platform = (0, $36pRP.getProductField)(productInfo.platform, overrides.platform);
    const ic = productInfo.ic; // ic should not be overriden once set
    const cdp = productInfo.cdp;
    const csp = productInfo.csp;
    return {
        env: env,
        product: product,
        subproduct: subproduct,
        version: version,
        origin: origin,
        platform: platform,
        ic: ic,
        cdp: cdp,
        csp: csp
    };
}

});
parcelRegister("36pRP", function(module, exports) {
$parcel$export(module.exports, "getProductField", () => $2425ff53b9f84897$export$690c718dc8037b2e);
function $2425ff53b9f84897$export$690c718dc8037b2e(field, override) {
    return override === undefined ? field : override;
}

});


parcelRegister("bCSvc", function(module, exports) {
$parcel$export(module.exports, "buildTenantFields", () => $876d8558daa280db$export$ab02ab56ae59d840);
function $876d8558daa280db$export$ab02ab56ae59d840(tenantInfo) {
    return {
        tenantIdType: tenantInfo.tenantIdType,
        tenantId: tenantInfo.tenantId
    };
}

});

parcelRegister("10rPP", function(module, exports) {
$parcel$export(module.exports, "buildUserFields", () => $0bbb61f8fe744228$export$4557a3fdd8921d68);
function $0bbb61f8fe744228$export$4557a3fdd8921d68(userInfo) {
    return {
        userIdType: userInfo.userIdType
    };
}

});

parcelRegister("cu68C", function(module, exports) {
$parcel$export(module.exports, "buildWorkspaceFields", () => $916d0c3cd820eaae$export$73c41604cd4b31da);
function $916d0c3cd820eaae$export$73c41604cd4b31da(workspaceInfo) {
    return {
        workspaceId: workspaceInfo.workspaceId
    };
}

});

parcelRegister("fcerX", function(module, exports) {
$parcel$export(module.exports, "extractProductOverrides", () => $b1032f70589e833f$export$e3d99b4bfec06f6e);
// eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
function $b1032f70589e833f$export$e3d99b4bfec06f6e(event) {
    const { env: env, product: product, subproduct: subproduct, version: version, origin: origin, platform: platform } = event;
    return {
        env: env,
        product: product,
        subproduct: subproduct,
        version: version,
        origin: origin,
        platform: platform
    };
}

});


parcelRegister("478yZ", function(module, exports) {
$parcel$export(module.exports, "buildActionName", () => $2fee755b81092588$export$9c5623a792efc9b0);
// eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
function $2fee755b81092588$export$9c5623a792efc9b0(event) {
    return `${event.actionSubject} ${event.action}`;
}

});

parcelRegister("dIKYA", function(module, exports) {
$parcel$export(module.exports, "buildContext", () => $9fd3d2eab8b5dac2$export$3a7fe28f9bf4f3d9);

var $cjBLF = parcelRequire("cjBLF");
const $9fd3d2eab8b5dac2$var$libraryVersion = "5.29.1";
function $9fd3d2eab8b5dac2$var$getDefaultValidationMode(productInfo) {
    const environment = productInfo.env;
    if (environment === undefined) return (0, $cjBLF.validationMode).QUIET;
    if (environment.includes('prod')) return (0, $cjBLF.validationMode).QUIET;
    return (0, $cjBLF.validationMode).COMPLETE;
}
function $9fd3d2eab8b5dac2$export$3a7fe28f9bf4f3d9(productInfo) {
    const screen = window.screen || {};
    return {
        context: {
            locale: productInfo.locale,
            screen: {
                width: screen.width,
                height: screen.height,
                density: window.devicePixelRatio
            },
            library: {
                name: 'analytics.js',
                version: $9fd3d2eab8b5dac2$var$libraryVersion
            },
            validationMode: $9fd3d2eab8b5dac2$var$getDefaultValidationMode(productInfo)
        }
    };
}

});
parcelRegister("cjBLF", function(module, exports) {
$parcel$export(module.exports, "validationMode", () => $8f748e4bbc815a77$export$fbd92247fb4d6159);
// eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
let $8f748e4bbc815a77$export$fbd92247fb4d6159 = /*#__PURE__*/ function(validationMode) {
    validationMode["QUIET"] = "quiet";
    validationMode["STANDARD"] = "standard";
    validationMode["COMPLETE"] = "complete";
    return validationMode;
}({});

});


parcelRegister("1dFnn", function(module, exports) {
$parcel$export(module.exports, "buildScreenEvent", () => $0e3719bfd1028ce1$export$c7d9a5f56acc4b19);

var $6rvcc = parcelRequire("6rvcc");

var $dpXUu = parcelRequire("dpXUu");

var $i5njK = parcelRequire("i5njK");

var $9ThfS = parcelRequire("9ThfS");

var $16Pbp = parcelRequire("16Pbp");

var $gLNNb = parcelRequire("gLNNb");

var $34zyg = parcelRequire("34zyg");

var $bYscG = parcelRequire("bYscG");

var $lReO1 = parcelRequire("lReO1");

var $fea3y = parcelRequire("fea3y");

var $bCSvc = parcelRequire("bCSvc");

var $10rPP = parcelRequire("10rPP");

var $cu68C = parcelRequire("cu68C");
function $0e3719bfd1028ce1$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $0e3719bfd1028ce1$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $0e3719bfd1028ce1$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $6rvcc.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $0e3719bfd1028ce1$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $0e3719bfd1028ce1$var$buildAttributes(attributes) {
    return (0, $9ThfS.buildAttributesWithName)('attributes', attributes);
}
function $0e3719bfd1028ce1$var$buildNonPrivacySafeAttributes(nonPrivacySafeAttributes) {
    return (0, $9ThfS.buildAttributesWithName)('nonPrivacySafeAttributes', nonPrivacySafeAttributes);
}
function $0e3719bfd1028ce1$export$c7d9a5f56acc4b19(productInfo, tenantInfo, userInfo, attributes, nonPrivacySafeAttributes, tags, tabId, sessionId, taskSessions, interactionSession, orgInfo, pageLoadId, workspaceInfo, collaborationContextInfo, event, containers, aliases, groups) {
    const productFields = (0, $fea3y.buildProductFields)(productInfo);
    const tenantFields = (0, $bCSvc.buildTenantFields)(tenantInfo);
    const userFields = (0, $10rPP.buildUserFields)(userInfo);
    const orgFields = (0, $lReO1.buildOrgFields)(orgInfo);
    const workspaceFields = (0, $cu68C.buildWorkspaceFields)(workspaceInfo);
    const collaborationContextFields = (0, $16Pbp.buildCollaborationContextFields)(collaborationContextInfo);
    const overrides = {
        title: '',
        path: '',
        url: '',
        referrer: '',
        search: '',
        eventType: (0, $dpXUu.eventType).SCREEN
    };
    return $0e3719bfd1028ce1$var$_objectSpread($0e3719bfd1028ce1$var$_objectSpread($0e3719bfd1028ce1$var$_objectSpread($0e3719bfd1028ce1$var$_objectSpread($0e3719bfd1028ce1$var$_objectSpread($0e3719bfd1028ce1$var$_objectSpread($0e3719bfd1028ce1$var$_objectSpread($0e3719bfd1028ce1$var$_objectSpread($0e3719bfd1028ce1$var$_objectSpread($0e3719bfd1028ce1$var$_objectSpread($0e3719bfd1028ce1$var$_objectSpread($0e3719bfd1028ce1$var$_objectSpread($0e3719bfd1028ce1$var$_objectSpread({}, productFields), tenantFields), userFields), orgFields), overrides), $0e3719bfd1028ce1$var$buildAttributes(attributes)), $0e3719bfd1028ce1$var$buildNonPrivacySafeAttributes(nonPrivacySafeAttributes)), (0, $gLNNb.buildContainersWithName)(containers)), (0, $34zyg.buildEventOverrides)(event)), {}, {
        tags: tags,
        tabId: tabId,
        sessionId: sessionId,
        taskSessions: taskSessions,
        interactionSession: interactionSession,
        pageLoadId: pageLoadId
    }, workspaceFields), collaborationContextFields), (0, $i5njK.buildAliases)(aliases)), (0, $bYscG.buildGroups)(groups));
}

});

parcelRegister("aYviu", function(module, exports) {
$parcel$export(module.exports, "default", () => $7fd7c8f1cf1381dd$export$2e2bcd8739ae039);
/**
 * Wraps {possibleFn} into a error-safe function and handles cases where {possibleFn}
 * is a function or object
 *
 * @param possibleFn - function that returns and object or the object itself
 * @param errorMessage - error message to log if {possibleFn} is a function and
 *                        throws an error when called
 * @returns {Function}
 */ const $7fd7c8f1cf1381dd$var$isFunction = (possibleFn)=>typeof possibleFn === 'function';
var $7fd7c8f1cf1381dd$export$2e2bcd8739ae039 = (possibleFn, errorMessage)=>{
    return ()=>{
        if ($7fd7c8f1cf1381dd$var$isFunction(possibleFn)) try {
            return possibleFn();
        } catch (e) {
            // eslint-disable-next-line no-console
            console.error(`${errorMessage} - ${e instanceof Error ? e.message : String(e)}`);
            return undefined;
        }
        return possibleFn;
    };
};

});

parcelRegister("3xmDM", function(module, exports) {
$parcel$export(module.exports, "default", () => $293604237edd7ee5$export$2e2bcd8739ae039);

var $6rvcc = parcelRequire("6rvcc");

var $5qIxc = parcelRequire("5qIxc");
var $hiAXT = parcelRequire("hiAXT");
var $aWPob = parcelRequire("aWPob");

var $dpXUu = parcelRequire("dpXUu");

var $2UUeH = parcelRequire("2UUeH");
const $293604237edd7ee5$var$isCrossProductInteractionAttribute = (_, paramName)=>{
    return paramName === (0, $hiAXT.URL_QUERY_PARAM_INTERACTION_SESSION);
};
class $293604237edd7ee5$export$2e2bcd8739ae039 {
    constructor(options){
        (0, $6rvcc.default)(this, "validProduct", false);
        this.isEnabled = options.perimeter !== (0, $dpXUu.perimeterType).FEDRAMP_MODERATE;
        this.urlValidation = {
            result: true,
            url: ''
        };
        this.sendEventCallback = options.sendEventCallback;
        if (this.isEnabled) {
            let bridge;
            let interactionSessionId;
            let interactionSource;
            let interactionSessionOptions;
            this.urlValidation.url = window.location.href;
            // Validate product
            //
            // Various UI components in the page might initialize their own AWC instances but some of those
            // instances might be associated with subordinate products that are of no interest to XPC tracking. We
            // want to avoid XPC meta analytics being fired against uninteresting products.
            //
            // Some products (e.g. Confluence) also have custom URL replace functions passed into AWC settings,
            // and we need to use those to ensure our query parameter is correctly processed.
            //
            // TODO - this is currently the best way we can try and guarantee that the most relevant product's AWC
            // is passing in the options. Down the line we ideally want the relevant products themselves to opt-in
            // to initialising cross product tracking via a flag in their AWC init options.
            this.validProduct = (0, $aWPob.validProducts).includes(options.product);
            if (this.validProduct) {
                // Only parse URL parameters if we are in a valid product
                const crossProductUrlPramater = (0, $2UUeH.default)($293604237edd7ee5$var$isCrossProductInteractionAttribute, options.historyReplaceFn);
                const interactionSessionBlob = (0, $hiAXT.URL_QUERY_PARAM_INTERACTION_SESSION) in crossProductUrlPramater ? crossProductUrlPramater[0, $hiAXT.URL_QUERY_PARAM_INTERACTION_SESSION] : null;
                if (interactionSessionBlob) try {
                    const interactionSession = JSON.parse(atob(interactionSessionBlob));
                    if (interactionSession.bridge && interactionSession.id && interactionSession.source) {
                        // All 3 fields must be present from a valid query param
                        bridge = interactionSession.bridge;
                        interactionSessionId = interactionSession.id;
                        interactionSource = interactionSession.source;
                    } else this.urlValidation.result = false;
                } catch (_unused) {
                    // Gracefully fail through if parameter has been corrupted
                    this.urlValidation.result = false;
                }
                interactionSessionOptions = {
                    analyticsEventCallback: this.sendEventCallback,
                    persistedSessionId: interactionSessionId
                };
            }
            // Initialise interaction session client with parsed values if they exist
            this.analyticsCrossProductInteractionClient = new (0, $5qIxc.default)(interactionSessionOptions, bridge, interactionSource);
        }
    }
    getInteractionSession() {
        if (this.isEnabled && this.analyticsCrossProductInteractionClient) return {
            bridge: this.analyticsCrossProductInteractionClient.getBridge(),
            id: this.analyticsCrossProductInteractionClient.getCurrentInteractionSessionId(),
            prevId: this.analyticsCrossProductInteractionClient.getPreviousInteractionSessionId(),
            source: this.analyticsCrossProductInteractionClient.getInteractionSource()
        };
        else return {
            bridge: null,
            id: null,
            prevId: null,
            source: null
        };
    }
    /**
   * Validates the cross product interaction session parameters parsed from the URL (if present)
   * If the Base64-encoded URL does not decode into a valid JSON object
   *
   * This method must be called out of the constructor, as the sendEventCallback we expect here
   * depends on crossProductInteractionTracking.getInteractionSession() so the class must be initialised
   */ validateInteractionSession() {
        if (!this.urlValidation.result) this.sendEventCallback({
            action: 'corrupted',
            actionSubject: 'interactionSession',
            attributes: {
                url: this.urlValidation.url
            },
            source: 'interactionComponent',
            tags: [
                'navigationExperiences'
            ] // InteractionSession events will be registered under this platform product
        });
    }
}

});
parcelRegister("5qIxc", function(module, exports) {
$parcel$export(module.exports, "default", () => $3f41ed13c410b797$export$2e2bcd8739ae039);

var $dhZ1B = parcelRequire("dhZ1B");

var $7FJTB = parcelRequire("7FJTB");

var $aZa8T = parcelRequire("aZa8T");

var $iyMnq = parcelRequire("iyMnq");

var $eSdwu = parcelRequire("eSdwu");

var $jMcNI = parcelRequire("jMcNI");

var $gwTbL = parcelRequire("gwTbL");

var $iukH2 = parcelRequire("iukH2");
var $3f41ed13c410b797$export$b9dd752fb13352ce = 'interactionSession.source';
var $3f41ed13c410b797$export$e04e3c50573f9af7 = 'interactionSession.bridge';
/**
 * AnalyticsCrossProductInteractionClient is a wrapper for the InteractionSessionTracking class.
 * It is designed to be used internally within the Atlassian Analytics Pipeline as well as useCrossProductUrlWrapper hook.
 * It is not intended to be used directly by end-users.
 *
 * This will create an instance of the interaction session tracker on the window object, which can be shared across different parts of a document.
 * If the internal client already exists, it will use the existing instance. Creating the client in a singleton manner like this enables us
 * to debounce updates to Session Storage, which is important when a large number of links using our hook are rendered on a page.
 *
 * The other interaction session parameters are written directly to session storage as they are predominantly read-only,
 * with the only update being the initialisation of the client
 */ var $3f41ed13c410b797$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $dhZ1B.default)(function AnalyticsCrossProductInteractionClient(interactionSessionOptions, bridge, interactionSource) {
    var _this = this;
    (0, $7FJTB.default)(this, AnalyticsCrossProductInteractionClient);
    (0, $aZa8T.default)(this, "getCurrentInteractionSessionId", function() {
        return _this.isEnabled && _this.interactionSessionTracking ? _this.interactionSessionTracking.getCurrentInteractionSessionId() : null;
    });
    (0, $aZa8T.default)(this, "getPreviousInteractionSessionId", function() {
        return _this.isEnabled && _this.interactionSessionTracking ? _this.interactionSessionTracking.getPreviousInteractionSessionId() : null;
    });
    (0, $aZa8T.default)(this, "getBridge", function() {
        return _this.isEnabled && _this.safeSessionStorage ? _this.safeSessionStorage.getItem($3f41ed13c410b797$export$e04e3c50573f9af7) : null;
    });
    (0, $aZa8T.default)(this, "getInteractionSource", function() {
        return _this.isEnabled && _this.safeSessionStorage ? _this.safeSessionStorage.getItem($3f41ed13c410b797$export$b9dd752fb13352ce) : null;
    });
    var shouldDisable = (0, $jMcNI.fg)('use_frontend_feature_encoding_sdk_platform') ? !(0, $iyMnq.isFeatureEnabled)('atlassian-analytics', 'atlassian-analytics-cross-product-interaction-client') : (0, $eSdwu.isFedrampModerate)();
    this.isEnabled = !shouldDisable;
    if (this.isEnabled) {
        // Get singleton interaction session tracking instance
        this.interactionSessionTracking = (0, $gwTbL.default).getInstance();
        var isValidPersistedId = false;
        if (this.interactionSessionTracking) {
            if (interactionSessionOptions) {
                this.interactionSessionTracking.setAnalyticsCallback(interactionSessionOptions.analyticsEventCallback);
                isValidPersistedId = this.interactionSessionTracking.setInteractionSessionId(interactionSessionOptions.persistedSessionId);
            }
        }
        this.safeSessionStorage = new (0, $iukH2.default)();
        // Store other interaction session parameters directly in session storage if ID has been validated
        if (isValidPersistedId) {
            bridge && this.safeSessionStorage.setItem($3f41ed13c410b797$export$e04e3c50573f9af7, bridge);
            interactionSource && this.safeSessionStorage.setItem($3f41ed13c410b797$export$b9dd752fb13352ce, interactionSource);
        }
    }
});

});
parcelRegister("dhZ1B", function(module, exports) {
$parcel$export(module.exports, "default", () => $9acc3327160de3a0$export$2e2bcd8739ae039);

var $5ddcy = parcelRequire("5ddcy");
function $9acc3327160de3a0$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, (0, $5ddcy.default)(o.key), o);
    }
}
function $9acc3327160de3a0$export$2e2bcd8739ae039(e, r, t) {
    return r && $9acc3327160de3a0$var$_defineProperties(e.prototype, r), t && $9acc3327160de3a0$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}

});
parcelRegister("5ddcy", function(module, exports) {
$parcel$export(module.exports, "default", () => $3cb8683129d20100$export$2e2bcd8739ae039);

var $86KR1 = parcelRequire("86KR1");

var $jRHWG = parcelRequire("jRHWG");
function $3cb8683129d20100$export$2e2bcd8739ae039(t) {
    var i = (0, $jRHWG.default)(t, "string");
    return "symbol" == (0, $86KR1.default)(i) ? i : i + "";
}

});
parcelRegister("86KR1", function(module, exports) {
$parcel$export(module.exports, "default", () => $5e733a8911bf36cf$export$2e2bcd8739ae039);
function $5e733a8911bf36cf$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $5e733a8911bf36cf$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $5e733a8911bf36cf$export$2e2bcd8739ae039(o);
}

});

parcelRegister("jRHWG", function(module, exports) {
$parcel$export(module.exports, "default", () => $e7650e36c3071989$export$2e2bcd8739ae039);

var $86KR1 = parcelRequire("86KR1");
function $e7650e36c3071989$export$2e2bcd8739ae039(t, r) {
    if ("object" != (0, $86KR1.default)(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (0, $86KR1.default)(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}

});



parcelRegister("7FJTB", function(module, exports) {
$parcel$export(module.exports, "default", () => $595ff6b19e2d9f45$export$2e2bcd8739ae039);
function $595ff6b19e2d9f45$export$2e2bcd8739ae039(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}

});

parcelRegister("aZa8T", function(module, exports) {
$parcel$export(module.exports, "default", () => $7ff777f184ff2335$export$2e2bcd8739ae039);

var $5ddcy = parcelRequire("5ddcy");
function $7ff777f184ff2335$export$2e2bcd8739ae039(e, r, t) {
    return (r = (0, $5ddcy.default)(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}

});

parcelRegister("iyMnq", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isFeatureEnabled = module.exports.isEnvironmentBlockEnabled = void 0;

var $cRnTy = parcelRequire("cRnTy");
Object.defineProperty(module.exports, "isEnvironmentBlockEnabled", {
    enumerable: true,
    get: function() {
        return $cRnTy.isEnvironmentBlockEnabled;
    }
});
Object.defineProperty(module.exports, "isFeatureEnabled", {
    enumerable: true,
    get: function() {
        return $cRnTy.isFeatureEnabled;
    }
});

});
parcelRegister("cRnTy", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.clearAuditState = module.exports.configureAuditState = module.exports.shouldEnableForAudit = module.exports.isFeatureEnabled = module.exports.isEnvironmentBlockEnabled = void 0;

var $4IiYp = parcelRequire("4IiYp");

var $5usR7 = parcelRequire("5usR7");

var $f7GDf = parcelRequire("f7GDf");

var $4WG8s = parcelRequire("4WG8s");
const $95ccf857b0bcb579$var$AEM_AUDIT_LOCAL_STORAGE_PREFIX = "aem-audit";
function $95ccf857b0bcb579$var$isEnvironmentBlockEnabled(environmentBlockName) {
    const boundaryKey = $95ccf857b0bcb579$var$getBoundaryKey();
    return (0, $5usR7.isEnvironmentBlockEnabledForBoundary)(environmentBlockName, boundaryKey);
}
module.exports.isEnvironmentBlockEnabled = $95ccf857b0bcb579$var$isEnvironmentBlockEnabled;
function $95ccf857b0bcb579$var$isFeatureEnabled(environmentBlockName, featureName, offeringPredicates) {
    const override = (0, $f7GDf.getFeatureOverride)(environmentBlockName, featureName);
    if (override !== null) return override;
    const boundaryKey = $95ccf857b0bcb579$var$getBoundaryKey();
    const aemResult = (0, $5usR7.isFeatureEnabledForBoundary)(environmentBlockName, featureName, boundaryKey);
    if (!aemResult) {
        if ((0, $4WG8s.isSSR)()) return false; // SSR: fallback to standard AEM resolution
        const metadata = (0, $5usR7.getFeatureAvailabilityMetadataForBoundary)(environmentBlockName, featureName, boundaryKey);
        if (metadata && metadata.auditPhase) return $95ccf857b0bcb579$var$shouldEnableForAudit(metadata.auditPhase, environmentBlockName, featureName);
        return false; // fallback to default behavior when not in audit state
    }
    const predicate = offeringPredicates ? offeringPredicates[boundaryKey] : undefined;
    return predicate ? predicate() : true;
}
module.exports.isFeatureEnabled = $95ccf857b0bcb579$var$isFeatureEnabled;
/**
 * Determines whether a feature that is not enabled via standard AEM resolution
 * should be enabled due to an active audit phase.
 *
 * This function should only be called for excluded features in browser contexts that have an active
 * audit phase. It applies the following rules:
 *
 * | Phase            | Environment | localStorage key set? | Result  |
 * | ---------------- | ----------- | --------------------- | ------- |
 * | internal-audit   | non-prod    | any                   | true    |
 * | internal-audit   | prod        | any                   | false   |
 * | external-audit   | non-prod    | any                   | true    |
 * | external-audit   | prod        | yes ("true")          | true    |
 * | external-audit   | prod        | no                    | false   |
 *
 * In SSR contexts (no window/localStorage), this falls back to false
 * for any case that would require a localStorage check.
 */ function $95ccf857b0bcb579$var$shouldEnableForAudit(auditPhase, environmentBlockName, featureName) {
    const envType = (0, $4WG8s.getEnvironmentType)();
    if (envType === "non-prod") return true;
    if (auditPhase === $5usR7.UnderAuditPhase.EXTERNAL_AUDIT && !(0, $4WG8s.isSSR)() && localStorage.getItem(`${$95ccf857b0bcb579$var$AEM_AUDIT_LOCAL_STORAGE_PREFIX}::${environmentBlockName}::${featureName}`) === "true") return true;
    return false;
}
module.exports.shouldEnableForAudit = $95ccf857b0bcb579$var$shouldEnableForAudit;
function $95ccf857b0bcb579$var$getBoundaryKey() {
    if ((0, $4IiYp.isFedrampModerate)()) return $5usR7.FED_MOD_KEY;
    if ((0, $4IiYp.isIsolatedCloud)()) return $5usR7.ISOLATED_CLOUD_COMMERCIAL_KEY;
    return $5usR7.COMMERCIAL_KEY;
}
function $95ccf857b0bcb579$var$configureAuditState(environmentBlockName, featureName, value) {
    localStorage.setItem(`${$95ccf857b0bcb579$var$AEM_AUDIT_LOCAL_STORAGE_PREFIX}::${environmentBlockName}::${featureName}`, value);
}
module.exports.configureAuditState = $95ccf857b0bcb579$var$configureAuditState;
function $95ccf857b0bcb579$var$clearAuditState(environmentBlockName, featureName) {
    localStorage.removeItem(`${$95ccf857b0bcb579$var$AEM_AUDIT_LOCAL_STORAGE_PREFIX}::${environmentBlockName}::${featureName}`);
}
module.exports.clearAuditState = $95ccf857b0bcb579$var$clearAuditState;
// Register global API on window for browser dev tools usage
if (typeof window !== "undefined") window.__AEM_FEATURE_JS__ = {
    checkFeature: $95ccf857b0bcb579$var$isFeatureEnabled,
    overrideFeature: $f7GDf.overrideFeature,
    clearFeatureOverride: $f7GDf.clearFeatureOverride,
    clearAllOverrides: $f7GDf.clearAllOverrides,
    configureAuditState: $95ccf857b0bcb579$var$configureAuditState,
    clearAuditState: $95ccf857b0bcb579$var$clearAuditState
};

});
parcelRegister("4IiYp", function(module, exports) {
$parcel$export(module.exports, "isIsolatedCloud", () => $36e9fd2f62a1f8d7$export$9186ccba8effc5de);
$parcel$export(module.exports, "isFedrampModerate", () => $36e9fd2f62a1f8d7$export$104cb891a6e90b3a);

var $gDKIc = parcelRequire("gDKIc");

var $3SaBA = parcelRequire("3SaBA");
function $36e9fd2f62a1f8d7$export$9186ccba8effc5de() {
    var atlCtxCookieValues = (0, $3SaBA.parseAtlCtxCookies)();
    if (!atlCtxCookieValues) // If the cookies are not set, the current perimeter is non-isolated commercial
    return false;
    // The icDomain check is needed for when federal perimeters are eventually added to Isolated Cloud as well
    return (0, $gDKIc.ISOLATED_CLOUD_PERIMETERS).includes(atlCtxCookieValues.perimeter) && atlCtxCookieValues.icDomain !== undefined;
}
function $36e9fd2f62a1f8d7$export$104cb891a6e90b3a() {
    var atlCtxCookieValues = (0, $3SaBA.parseAtlCtxCookies)();
    if (!atlCtxCookieValues) // If the cookies are not set, the current perimeter is non-isolated commercial
    return false;
    return atlCtxCookieValues.perimeter === (0, $gDKIc.FEDRAMP_MODERATE);
}
function $36e9fd2f62a1f8d7$export$80638ee198476daf() {
    var atlCtxCookieValues = (0, $3SaBA.parseAtlCtxCookies)();
    return atlCtxCookieValues === null || atlCtxCookieValues === void 0 ? void 0 : atlCtxCookieValues.icDomain;
}
function $36e9fd2f62a1f8d7$export$839b022803d38d4d() {
    var atlCtxCookieValues = (0, $3SaBA.parseAtlCtxCookies)();
    return atlCtxCookieValues === null || atlCtxCookieValues === void 0 ? void 0 : atlCtxCookieValues.icId;
}

});
parcelRegister("gDKIc", function(module, exports) {
$parcel$export(module.exports, "FEDRAMP_MODERATE", () => $c1d485e2a5aca663$export$ce553301d55c2fd8);
$parcel$export(module.exports, "ISOLATED_CLOUD_PERIMETERS", () => $c1d485e2a5aca663$export$d8347b4aae768c2d);
$parcel$export(module.exports, "ATL_CTX_PERIMETER", () => $c1d485e2a5aca663$export$87285944378c596);
$parcel$export(module.exports, "ATL_CTX_ISOLATION_CONTEXT_DOMAIN", () => $c1d485e2a5aca663$export$715603e81922c3ec);
$parcel$export(module.exports, "ATL_CTX_ISOLATION_CONTEXT_ID", () => $c1d485e2a5aca663$export$a0ffa0598c95dfb7);
var $c1d485e2a5aca663$export$ce553301d55c2fd8 = 'fedramp-moderate';
var $c1d485e2a5aca663$export$f005e2e9f707cb5f = 'commercial';
var $c1d485e2a5aca663$export$a739cd5aac835909 = 'staging';
var $c1d485e2a5aca663$export$42dd0cdd351a4a9 = 'prod';
var $c1d485e2a5aca663$export$404582bc18fe4d9e = 'dev';
var $c1d485e2a5aca663$export$d8347b4aae768c2d = [
    $c1d485e2a5aca663$export$f005e2e9f707cb5f
];
var $c1d485e2a5aca663$export$b1b1ccc8f3e7f954 = [
    $c1d485e2a5aca663$export$f005e2e9f707cb5f,
    $c1d485e2a5aca663$export$ce553301d55c2fd8
];
var $c1d485e2a5aca663$export$87285944378c596 = 'Atl-Ctx-Perimeter';
var $c1d485e2a5aca663$export$715603e81922c3ec = 'Atl-Ctx-Isolation-Context-Domain';
var $c1d485e2a5aca663$export$a0ffa0598c95dfb7 = 'Atl-Ctx-Isolation-Context-Id';

});

parcelRegister("3SaBA", function(module, exports) {
$parcel$export(module.exports, "parseAtlCtxCookies", () => $2d1ea43de658d657$export$3fa7b7af96286cc9);

var $jXXRn = parcelRequire("jXXRn");

var $gDKIc = parcelRequire("gDKIc");
function $2d1ea43de658d657$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $2d1ea43de658d657$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $2d1ea43de658d657$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $2d1ea43de658d657$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $2d1ea43de658d657$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $2d1ea43de658d657$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
/**
 * Internal helper function used to parse cookie values and extract value of provided cookie name
 * @param {AtlCtxCookieName} cookieName - The name of the cookie to extract
 * @param {string} cookieString - The full cookie string
 * @returns {string | undefined} - The cookie value if present, undefined otherwise
 */ function $2d1ea43de658d657$var$getRawCookieValue(cookieName, cookieString) {
    if (!cookieString) return undefined;
    var cookies = cookieString.split(';');
    var _iterator = $2d1ea43de658d657$var$_createForOfIteratorHelper(cookies), _step;
    try {
        for(_iterator.s(); !(_step = _iterator.n()).done;){
            var cookie = _step.value;
            var _cookie$trim$split = cookie.trim().split('='), _cookie$trim$split2 = (0, $jXXRn.default)(_cookie$trim$split, 2), name = _cookie$trim$split2[0], value = _cookie$trim$split2[1];
            if (name === cookieName) return value;
        }
    } catch (err) {
        _iterator.e(err);
    } finally{
        _iterator.f();
    }
    return undefined;
}
function $2d1ea43de658d657$export$3fa7b7af96286cc9() {
    var global = globalThis;
    try {
        // HOT-118791: the code below doesn't work on the server, and creates log spam in the catch block - "Cannot read properties of undefined (reading 'cookie')"
        if (typeof globalThis.document === 'undefined') return undefined;
        var cookies = global.document.cookie;
        var perimeter = $2d1ea43de658d657$var$getRawCookieValue((0, $gDKIc.ATL_CTX_PERIMETER), cookies);
        if (!perimeter) // Indicative of non-isolated commercial perimeter
        return undefined;
        var icDomain = $2d1ea43de658d657$var$getRawCookieValue((0, $gDKIc.ATL_CTX_ISOLATION_CONTEXT_DOMAIN), cookies);
        var icId = $2d1ea43de658d657$var$getRawCookieValue((0, $gDKIc.ATL_CTX_ISOLATION_CONTEXT_ID), cookies);
        // The IC Domain and IC Id cookie values are empty strings for non Isolated Cloud
        var emptyIcDomain = !icDomain || icDomain.length === 0;
        var emptyIcId = !icId || icId.length === 0;
        return {
            perimeter: perimeter,
            icDomain: emptyIcDomain ? undefined : icDomain,
            icId: emptyIcId ? undefined : icId
        };
    } catch (e) {
        console.warn('Failed to parse atl-ctx cookies:', e);
        return undefined;
    }
}

});
parcelRegister("jXXRn", function(module, exports) {
$parcel$export(module.exports, "default", () => $e891f5ee3e402fb8$export$2e2bcd8739ae039);

var $gG5Sq = parcelRequire("gG5Sq");

var $8IMJj = parcelRequire("8IMJj");

var $iXLzk = parcelRequire("iXLzk");

var $5HiqP = parcelRequire("5HiqP");
function $e891f5ee3e402fb8$export$2e2bcd8739ae039(r, e) {
    return (0, $gG5Sq.default)(r) || (0, $8IMJj.default)(r, e) || (0, $iXLzk.default)(r, e) || (0, $5HiqP.default)();
}

});
parcelRegister("gG5Sq", function(module, exports) {
$parcel$export(module.exports, "default", () => $c245209993f05fcc$export$2e2bcd8739ae039);
function $c245209993f05fcc$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return r;
}

});

parcelRegister("8IMJj", function(module, exports) {
$parcel$export(module.exports, "default", () => $65983b88c7dd0795$export$2e2bcd8739ae039);
function $65983b88c7dd0795$export$2e2bcd8739ae039(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}

});

parcelRegister("iXLzk", function(module, exports) {
$parcel$export(module.exports, "default", () => $dce2a2d698b0b7c3$export$2e2bcd8739ae039);

var $7grpc = parcelRequire("7grpc");
function $dce2a2d698b0b7c3$export$2e2bcd8739ae039(r, a) {
    if (r) {
        if ("string" == typeof r) return (0, $7grpc.default)(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? (0, $7grpc.default)(r, a) : void 0;
    }
}

});
parcelRegister("7grpc", function(module, exports) {
$parcel$export(module.exports, "default", () => $549f492fb68f28ce$export$2e2bcd8739ae039);
function $549f492fb68f28ce$export$2e2bcd8739ae039(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}

});


parcelRegister("5HiqP", function(module, exports) {
$parcel$export(module.exports, "default", () => $425f44091c1ba347$export$2e2bcd8739ae039);
function $425f44091c1ba347$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});




parcelRegister("5usR7", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ISOLATED_CLOUD_COMMERCIAL_KEY = module.exports.FED_MOD_KEY = module.exports.COMMERCIAL_KEY = module.exports.UnderAuditPhase = module.exports.BOUNDARY_KEYS_LIST = module.exports.getFeatureAvailabilityMetadataForBoundary = module.exports.isFeatureEnabledForBoundary = module.exports.isEnvironmentBlockEnabledForBoundary = void 0;

var $ePlFc = parcelRequire("ePlFc");
Object.defineProperty(module.exports, "isEnvironmentBlockEnabledForBoundary", {
    enumerable: true,
    get: function() {
        return $ePlFc.isEnvironmentBlockEnabledForBoundary;
    }
});

var $ePlFc = parcelRequire("ePlFc");
Object.defineProperty(module.exports, "isFeatureEnabledForBoundary", {
    enumerable: true,
    get: function() {
        return $ePlFc.isFeatureEnabledForBoundary;
    }
});

var $ePlFc = parcelRequire("ePlFc");
Object.defineProperty(module.exports, "getFeatureAvailabilityMetadataForBoundary", {
    enumerable: true,
    get: function() {
        return $ePlFc.getFeatureAvailabilityMetadataForBoundary;
    }
});

var $fM9g9 = parcelRequire("fM9g9");
Object.defineProperty(module.exports, "BOUNDARY_KEYS_LIST", {
    enumerable: true,
    get: function() {
        return $fM9g9.BOUNDARY_KEYS_LIST;
    }
});
Object.defineProperty(module.exports, "UnderAuditPhase", {
    enumerable: true,
    get: function() {
        return $fM9g9.UnderAuditPhase;
    }
});
Object.defineProperty(module.exports, "COMMERCIAL_KEY", {
    enumerable: true,
    get: function() {
        return $fM9g9.COMMERCIAL_KEY;
    }
});
Object.defineProperty(module.exports, "FED_MOD_KEY", {
    enumerable: true,
    get: function() {
        return $fM9g9.FED_MOD_KEY;
    }
});
Object.defineProperty(module.exports, "ISOLATED_CLOUD_COMMERCIAL_KEY", {
    enumerable: true,
    get: function() {
        return $fM9g9.ISOLATED_CLOUD_COMMERCIAL_KEY;
    }
});

});
parcelRegister("ePlFc", function(module, exports) {
"use strict";
var $acb6a20cd20feb92$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getFeatureAvailabilityMetadataForBoundary = module.exports.isFeatureEnabledForBoundary = module.exports.isEnvironmentBlockEnabledForBoundary = void 0;

const $acb6a20cd20feb92$var$sdk_data_json_1 = $acb6a20cd20feb92$var$__importDefault((parcelRequire("2X8pS")));
const $acb6a20cd20feb92$var$aemEnvironmentBlockData = $acb6a20cd20feb92$var$sdk_data_json_1.default;
// Build reverse map: offeringId -> offeringShortKeyId, derived from compositionKeyMap (offeringShortKeyId -> offeringId)
const $acb6a20cd20feb92$var$offeringToOfferingShortKeyId = Object.fromEntries(Object.entries($acb6a20cd20feb92$var$aemEnvironmentBlockData.compositionKeyMap).map(([offeringShortKeyId, offeringId])=>[
        offeringId,
        offeringShortKeyId
    ]));
/**
 * Translates a full offering ID (BoundaryKey) to its short SDK key name.
 * Falls back to the original key if no mapping exists.
 */ function $acb6a20cd20feb92$var$toofferingShortKeyId(boundaryKey) {
    const mapped = $acb6a20cd20feb92$var$offeringToOfferingShortKeyId[boundaryKey];
    return mapped !== undefined && mapped !== null ? mapped : boundaryKey;
}
/**
 *
 * @param environmentBlockName Name of environment block as encoded in AEM
 * @param boundaryKey The boundary to evaluate for.
 *
 * @returns if the environment block is available in the current cloud environment
 */ function $acb6a20cd20feb92$var$isEnvironmentBlockEnabledForBoundary(environmentBlockName, boundaryKey) {
    return $acb6a20cd20feb92$var$environmentBlockInBoundary(environmentBlockName, boundaryKey);
}
module.exports.isEnvironmentBlockEnabledForBoundary = $acb6a20cd20feb92$var$isEnvironmentBlockEnabledForBoundary;
/**
 *
 * @param environmentBlockName Name of environment block as encoded in AEM (the environment block that the feature belongs to)
 * @param featureName Name of feature as encoded in AEM
 * @param boundaryKey The boundary to evaluate for
 *
 * @returns if the feature is available in the current cloud environment
 */ function $acb6a20cd20feb92$var$isFeatureEnabledForBoundary(environmentBlockName, featureName, boundaryKey) {
    if ($acb6a20cd20feb92$var$environmentBlockInBoundary(environmentBlockName, boundaryKey)) {
        const environmentBlockData = $acb6a20cd20feb92$var$aemEnvironmentBlockData.environmentBlocks[environmentBlockName];
        const feature = environmentBlockData.features[featureName];
        if (!feature) return false;
        return feature.compositions[$acb6a20cd20feb92$var$toofferingShortKeyId(boundaryKey)] === true;
    }
    return false;
}
module.exports.isFeatureEnabledForBoundary = $acb6a20cd20feb92$var$isFeatureEnabledForBoundary;
/**
 *
 * @param environmentBlockName Name of environment block as encoded in AEM (the environment block that the feature belongs to)
 * @param featureName Name of feature as encoded in AEM
 * @param boundaryKey The boundary to evaluate for
 *
 * @returns the availability metadata for the feature in the given boundary, or undefined if none
 */ function $acb6a20cd20feb92$var$getFeatureAvailabilityMetadataForBoundary(environmentBlockName, featureName, boundaryKey) {
    const block = $acb6a20cd20feb92$var$aemEnvironmentBlockData.environmentBlocks[environmentBlockName];
    if (!block) return undefined;
    const feature = block.features[featureName];
    if (!feature) return undefined;
    return feature.availabilityMetadata && feature.availabilityMetadata[$acb6a20cd20feb92$var$toofferingShortKeyId(boundaryKey)];
}
module.exports.getFeatureAvailabilityMetadataForBoundary = $acb6a20cd20feb92$var$getFeatureAvailabilityMetadataForBoundary;
function $acb6a20cd20feb92$var$environmentBlockInBoundary(environmentBlockName, boundaryKey) {
    const block = $acb6a20cd20feb92$var$aemEnvironmentBlockData.environmentBlocks[environmentBlockName];
    if (!block) return false;
    return block.compositions[$acb6a20cd20feb92$var$toofferingShortKeyId(boundaryKey)] === true;
}

});

parcelRegister("fM9g9", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.UnderAuditPhase = module.exports.BOUNDARY_KEYS_LIST = module.exports.ISOLATED_CLOUD_COMMERCIAL_KEY = module.exports.FED_MOD_KEY = module.exports.COMMERCIAL_KEY = void 0;
// Each BoundaryKey is a key in the sdk data
module.exports.COMMERCIAL_KEY = "commercial-cloud";
module.exports.FED_MOD_KEY = "fedramp-moderate";
module.exports.ISOLATED_CLOUD_COMMERCIAL_KEY = "isolated-cloud-commercial";
module.exports.BOUNDARY_KEYS_LIST = [
    module.exports.COMMERCIAL_KEY,
    module.exports.FED_MOD_KEY,
    module.exports.ISOLATED_CLOUD_COMMERCIAL_KEY
];
var $b7c28576a691a936$var$UnderAuditPhase;
(function(UnderAuditPhase) {
    UnderAuditPhase["INTERNAL_AUDIT"] = "internal-audit";
    UnderAuditPhase["EXTERNAL_AUDIT"] = "external-audit";
})($b7c28576a691a936$var$UnderAuditPhase || (module.exports.UnderAuditPhase = $b7c28576a691a936$var$UnderAuditPhase = {}));

});


parcelRegister("f7GDf", function(module, exports) {
"use strict";
/**
 * Manages feature overrides stored in browser localStorage.
 * No-ops when not in a browser context.
 *
 * localStorage key: "AEM_FEATURE_OVERRIDES"
 * localStorage value: JSON-encoded string mapping "{environmentBlockName}::{featureName}" to boolean
 *
 * Example:
 *   "AEM_FEATURE_OVERRIDES": "{\"confluence::my_feature\":true,\"jira::other_feature\":false}"
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.clearAllOverrides = module.exports.clearFeatureOverride = module.exports.overrideFeature = module.exports.getFeatureOverride = module.exports.STORAGE_KEY = void 0;
module.exports.STORAGE_KEY = "AEM_FEATURE_OVERRIDES";
function $b028944b6dce7676$var$buildKey(environmentBlockName, featureName) {
    return `${environmentBlockName}::${featureName}`;
}
function $b028944b6dce7676$var$isBrowserEnvironment() {
    return typeof window !== "undefined" && typeof window.localStorage !== "undefined";
}
function $b028944b6dce7676$var$getOverridesMap() {
    const featureOverrideValue = window.localStorage.getItem(module.exports.STORAGE_KEY);
    if (featureOverrideValue) try {
        return JSON.parse(featureOverrideValue);
    } catch (e) {
        console.warn("Failed to parse AEM_FEATURE_OVERRIDES from localStorage", e);
    }
    return {};
}
function $b028944b6dce7676$var$setOverridesMap(map) {
    window.localStorage.setItem(module.exports.STORAGE_KEY, JSON.stringify(map));
}
/**
 * Returns the override value for a feature if one exists, or null if no override is set.
 * Returns null in non-browser environments.
 */ function $b028944b6dce7676$var$getFeatureOverride(environmentBlockName, featureName) {
    if (!$b028944b6dce7676$var$isBrowserEnvironment()) return null;
    const map = $b028944b6dce7676$var$getOverridesMap();
    const key = $b028944b6dce7676$var$buildKey(environmentBlockName, featureName);
    if (key in map) return map[key];
    return null;
}
module.exports.getFeatureOverride = $b028944b6dce7676$var$getFeatureOverride;
/**
 * Sets a feature override in localStorage.
 */ function $b028944b6dce7676$var$overrideFeature(environmentBlockName, featureName, value) {
    if (!$b028944b6dce7676$var$isBrowserEnvironment()) return;
    const map = $b028944b6dce7676$var$getOverridesMap();
    map[$b028944b6dce7676$var$buildKey(environmentBlockName, featureName)] = value;
    $b028944b6dce7676$var$setOverridesMap(map);
}
module.exports.overrideFeature = $b028944b6dce7676$var$overrideFeature;
/**
 * Removes a single feature override from localStorage. Removes the key entirely if no overrides are left.
 */ function $b028944b6dce7676$var$clearFeatureOverride(environmentBlockName, featureName) {
    if (!$b028944b6dce7676$var$isBrowserEnvironment()) return;
    const map = $b028944b6dce7676$var$getOverridesMap();
    delete map[$b028944b6dce7676$var$buildKey(environmentBlockName, featureName)];
    if (Object.keys(map).length === 0) window.localStorage.removeItem(module.exports.STORAGE_KEY);
    else $b028944b6dce7676$var$setOverridesMap(map);
}
module.exports.clearFeatureOverride = $b028944b6dce7676$var$clearFeatureOverride;
/**
 * Clears all feature overrides from localStorage.
 */ function $b028944b6dce7676$var$clearAllOverrides() {
    if (!$b028944b6dce7676$var$isBrowserEnvironment()) return;
    window.localStorage.removeItem(module.exports.STORAGE_KEY);
}
module.exports.clearAllOverrides = $b028944b6dce7676$var$clearAllOverrides;

});

parcelRegister("4WG8s", function(module, exports) {

var $3ZMUU = parcelRequire("3ZMUU");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getEnvironmentType = module.exports.isSSR = void 0;
/** Returns true when running in a server-side rendering context (no browser window). */ function $399d43667833604d$var$isSSR() {
    return typeof window === "undefined" || typeof document === "undefined" || Boolean(typeof $3ZMUU !== "undefined" && $3ZMUU && $3ZMUU.env && undefined); // see https://bitbucket.org/atlassian/atlassian-frontend-monorepo/src/7377575ff0ec8a6f78257788b224e37c2bae8f66/platform/packages/editor/editor-common/src/core-utils/is-ssr.ts#lines-6
}
module.exports.isSSR = $399d43667833604d$var$isSSR;
/**
 * Returns the current environment type.
 * Defaults to "prod" in unknown cases.
 *
 * In SSR contexts, reads from globalThis.ssrContext.environmentType.
 * In browser contexts, infers from window.location.hostname.
 */ function $399d43667833604d$var$getEnvironmentType() {
    // 1. SSR: Use ssrContext if available
    if (typeof window === "undefined") {
        // @ts-expect-error — ssrContext in globalThis type
        const ssrContext = globalThis.ssrContext;
        if (ssrContext && ssrContext.environmentType) {
            const type = ssrContext.environmentType;
            if (type === "dev") return "non-prod";
            if (type === "staging") return "non-prod";
            if (type === "prod") return "prod";
        }
        return "prod";
    }
    // 2. Browser: Use hostname-based detection with all patterns
    const host = window.location.hostname.toLowerCase();
    if (!host) // default to prod if no location available
    return "prod";
    // Exact matches
    if (host === "localhost" || host === "127.0.0.1") return "non-prod";
    // Staging patterns
    if (host.endsWith(".jira-dev.com") || host.includes(".stg.") || host.includes(".staging.")) return "non-prod";
    // Development patterns
    if (host.includes(".dev.") || host.includes(".ddev.")) return "non-prod";
    if (host.endsWith(".atlassian.net") || host.endsWith(".atlassian-us-gov-mod.com") || host.endsWith(".atlassian.com")) return "prod";
    return "prod";
}
module.exports.getEnvironmentType = $399d43667833604d$var$getEnvironmentType;

});



parcelRegister("jMcNI", function(module, exports) {
$parcel$export(module.exports, "fg", () => $e65c6dfcae763a0c$export$b40ec24ac8275656);

var $gZ2xF = parcelRequire("gZ2xF");
function $e65c6dfcae763a0c$export$b40ec24ac8275656(name) {
    return (0, $gZ2xF.resolveBooleanFlag)(name);
}

});
parcelRegister("gZ2xF", function(module, exports) {
$parcel$export(module.exports, "resolveBooleanFlag", () => $c5d450a0c9a1f9ea$export$6333b6aff9fc6275);

var $9Ts6Q = parcelRequire("9Ts6Q");

var $aIvC6 = parcelRequire("aIvC6");

var $kt9Mb = parcelRequire("kt9Mb");

var $lBR9z = parcelRequire("lBR9z");

var $e5PzA = parcelRequire("e5PzA");

var $cPqAx = parcelRequire("cPqAx");
var $c5d450a0c9a1f9ea$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE = (0, $kt9Mb.ENV_ENABLE_PLATFORM_FF) || (0, $lBR9z.ENV_STORYBOOK_ENABLE_PLATFORM_FF);
function $c5d450a0c9a1f9ea$export$6333b6aff9fc6275(flagKey) {
    if ($c5d450a0c9a1f9ea$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE) {
        (0, $aIvC6.debug)('[%s]: The feature flags were enabled while running tests. The flag "%s" will be always enabled.', (0, $cPqAx.pkgName), flagKey);
        return true;
    }
    try {
        var _globalVar$PFF_GLOBAL, _globalVar$PFF_GLOBAL2, _globalVar$PFF_GLOBAL3;
        // booleanResolver will be empty for products like Trello, Elevate, Recruit etc.
        // Currently only Confluence, Jira and Bitbucket has set it.
        if (((_globalVar$PFF_GLOBAL = (0, $e5PzA.globalVar)[0, $cPqAx.PFF_GLOBAL_KEY]) === null || _globalVar$PFF_GLOBAL === void 0 ? void 0 : _globalVar$PFF_GLOBAL.booleanResolver) === undefined || ((_globalVar$PFF_GLOBAL2 = (0, $e5PzA.globalVar)[0, $cPqAx.PFF_GLOBAL_KEY]) === null || _globalVar$PFF_GLOBAL2 === void 0 ? void 0 : _globalVar$PFF_GLOBAL2.booleanResolver) === null) // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
        return (0, $9Ts6Q.default).checkGate(flagKey);
        var result = (_globalVar$PFF_GLOBAL3 = (0, $e5PzA.globalVar)[0, $cPqAx.PFF_GLOBAL_KEY]) === null || _globalVar$PFF_GLOBAL3 === void 0 ? void 0 : _globalVar$PFF_GLOBAL3.booleanResolver(flagKey);
        if (typeof result !== 'boolean') {
            // eslint-disable-next-line no-console
            console.warn("".concat(flagKey, " resolved to a non-boolean value, returning false for safety"));
            return false;
        }
        return result;
    } catch (e) {
        return false;
    }
}

});
parcelRegister("9Ts6Q", function(module, exports) {
$parcel$export(module.exports, "default", () => $733f0e0be6245765$export$2e2bcd8739ae039);

var $7FJTB = parcelRequire("7FJTB");

var $dhZ1B = parcelRequire("dhZ1B");

var $aZa8T = parcelRequire("aZa8T");

var $3NnAq = parcelRequire("3NnAq");

var $1ZXvG = parcelRequire("1ZXvG");



var $733f0e0be6245765$var$_FeatureGates;
/**
 * Access the FeatureGates object via the default export.
 * ```ts
 * import FeatureGates from '@atlaskit/feature-gate-js-client';
 * ```
 */ var $733f0e0be6245765$var$FeatureGates = /*#__PURE__*/ function() {
    function FeatureGates() {
        (0, $7FJTB.default)(this, FeatureGates);
    }
    return (0, $dhZ1B.default)(FeatureGates, null, [
        {
            key: "isGateExists",
            value: function isGateExists(gateName) {
                return this.client.isGateExist(gateName);
            }
        },
        {
            key: "isExperimentExists",
            value: function isExperimentExists(experimentName) {
                return this.client.isExperimentExist(experimentName);
            }
        }
    ]);
}();
$733f0e0be6245765$var$_FeatureGates = $733f0e0be6245765$var$FeatureGates;
(0, $aZa8T.default)($733f0e0be6245765$var$FeatureGates, "client", new (0, $3NnAq.Client)());
(0, $aZa8T.default)($733f0e0be6245765$var$FeatureGates, "hasCheckGateErrorOccurred", false);
(0, $aZa8T.default)($733f0e0be6245765$var$FeatureGates, "hasGetExperimentValueErrorOccurred", false);
(0, $aZa8T.default)($733f0e0be6245765$var$FeatureGates, "checkGate", function(gateName, options) {
    try {
        // Check if the CRITERION override mechanism is available
        if (typeof window !== 'undefined' && window.__CRITERION__ && typeof window.__CRITERION__.getFeatureFlagOverride === 'function') {
            // Attempt to retrieve an override value for the feature gate
            var overrideValue = window.__CRITERION__.getFeatureFlagOverride(gateName);
            // If an override value is found, return it immediately
            if (overrideValue !== undefined) return overrideValue;
        }
    } catch (error) {
        // Log the first occurrence of the error
        if (!$733f0e0be6245765$var$_FeatureGates.hasCheckGateErrorOccurred) {
            // eslint-disable-next-line no-console
            console.warn({
                msg: 'An error has occurred checking the feature gate from criterion override. Only the first occurrence of this error is logged.',
                gateName: gateName,
                error: error
            });
            $733f0e0be6245765$var$_FeatureGates.hasCheckGateErrorOccurred = true;
        }
    }
    // Proceed with the main logic if no override is found
    return $733f0e0be6245765$var$_FeatureGates.client.checkGate(gateName, options);
});
(0, $aZa8T.default)($733f0e0be6245765$var$FeatureGates, "getExperimentValue", function(experimentName, parameterName, defaultValue, options) {
    try {
        // Check if the CRITERION override mechanism is available
        if (typeof window !== 'undefined' && window.__CRITERION__ && typeof window.__CRITERION__.getExperimentValueOverride === 'function') {
            var overrideValue = window.__CRITERION__.getExperimentValueOverride(experimentName, parameterName);
            if (overrideValue !== undefined && overrideValue !== null) return overrideValue;
        }
    } catch (error) {
        // Log the first occurrence of the error
        if (!$733f0e0be6245765$var$_FeatureGates.hasGetExperimentValueErrorOccurred) {
            // eslint-disable-next-line no-console
            console.warn({
                msg: 'An error has occurred getting the experiment value from criterion override. Only the first occurrence of this error is logged.',
                experimentName: experimentName,
                defaultValue: defaultValue,
                options: options,
                error: error
            });
            $733f0e0be6245765$var$_FeatureGates.hasGetExperimentValueErrorOccurred = true;
        }
        return defaultValue;
    }
    // Proceed with the main logic if no override is found
    return $733f0e0be6245765$var$_FeatureGates.client.getExperimentValue(experimentName, parameterName, defaultValue, options);
});
(0, $aZa8T.default)($733f0e0be6245765$var$FeatureGates, "initializeCalled", $733f0e0be6245765$var$_FeatureGates.client.initializeCalled.bind($733f0e0be6245765$var$_FeatureGates.client));
(0, $aZa8T.default)($733f0e0be6245765$var$FeatureGates, "initializeCompleted", $733f0e0be6245765$var$_FeatureGates.client.initializeCompleted.bind($733f0e0be6245765$var$_FeatureGates.client));
(0, $aZa8T.default)($733f0e0be6245765$var$FeatureGates, "waitUntilInitializeCompleted", $733f0e0be6245765$var$_FeatureGates.client.waitUntilInitializeCompleted.bind($733f0e0be6245765$var$_FeatureGates.client));
(0, $aZa8T.default)($733f0e0be6245765$var$FeatureGates, "initialize", $733f0e0be6245765$var$_FeatureGates.client.initialize.bind($733f0e0be6245765$var$_FeatureGates.client));
(0, $aZa8T.default)($733f0e0be6245765$var$FeatureGates, "initializeWithProvider", $733f0e0be6245765$var$_FeatureGates.client.initializeWithProvider.bind($733f0e0be6245765$var$_FeatureGates.client));
(0, $aZa8T.default)($733f0e0be6245765$var$FeatureGates, "initializeFromValues", $733f0e0be6245765$var$_FeatureGates.client.initializeFromValues.bind($733f0e0be6245765$var$_FeatureGates.client));
(0, $aZa8T.default)($733f0e0be6245765$var$FeatureGates, "manuallyLogGateExposure", $733f0e0be6245765$var$_FeatureGates.client.manuallyLogGateExposure.bind($733f0e0be6245765$var$_FeatureGates.client));
(0, $aZa8T.default)($733f0e0be6245765$var$FeatureGates, "getExperiment", $733f0e0be6245765$var$_FeatureGates.client.getExperiment.bind($733f0e0be6245765$var$_FeatureGates.client));
(0, $aZa8T.default)($733f0e0be6245765$var$FeatureGates, "manuallyLogExperimentExposure", $733f0e0be6245765$var$_FeatureGates.client.manuallyLogExperimentExposure.bind($733f0e0be6245765$var$_FeatureGates.client));
(0, $aZa8T.default)($733f0e0be6245765$var$FeatureGates, "manuallyLogLayerExposure", $733f0e0be6245765$var$_FeatureGates.client.manuallyLogLayerExposure.bind($733f0e0be6245765$var$_FeatureGates.client));
(0, $aZa8T.default)($733f0e0be6245765$var$FeatureGates, "shutdownStatsig", $733f0e0be6245765$var$_FeatureGates.client.shutdownStatsig.bind($733f0e0be6245765$var$_FeatureGates.client));
(0, $aZa8T.default)($733f0e0be6245765$var$FeatureGates, "overrideGate", $733f0e0be6245765$var$_FeatureGates.client.overrideGate.bind($733f0e0be6245765$var$_FeatureGates.client));
(0, $aZa8T.default)($733f0e0be6245765$var$FeatureGates, "clearGateOverride", $733f0e0be6245765$var$_FeatureGates.client.clearGateOverride.bind($733f0e0be6245765$var$_FeatureGates.client));
(0, $aZa8T.default)($733f0e0be6245765$var$FeatureGates, "overrideConfig", $733f0e0be6245765$var$_FeatureGates.client.overrideConfig.bind($733f0e0be6245765$var$_FeatureGates.client));
(0, $aZa8T.default)($733f0e0be6245765$var$FeatureGates, "clearConfigOverride", $733f0e0be6245765$var$_FeatureGates.client.clearConfigOverride.bind($733f0e0be6245765$var$_FeatureGates.client));
(0, $aZa8T.default)($733f0e0be6245765$var$FeatureGates, "setOverrides", $733f0e0be6245765$var$_FeatureGates.client.setOverrides.bind($733f0e0be6245765$var$_FeatureGates.client));
(0, $aZa8T.default)($733f0e0be6245765$var$FeatureGates, "getOverrides", $733f0e0be6245765$var$_FeatureGates.client.getOverrides.bind($733f0e0be6245765$var$_FeatureGates.client));
(0, $aZa8T.default)($733f0e0be6245765$var$FeatureGates, "clearAllOverrides", $733f0e0be6245765$var$_FeatureGates.client.clearAllOverrides.bind($733f0e0be6245765$var$_FeatureGates.client));
(0, $aZa8T.default)($733f0e0be6245765$var$FeatureGates, "isCurrentUser", $733f0e0be6245765$var$_FeatureGates.client.isCurrentUser.bind($733f0e0be6245765$var$_FeatureGates.client));
(0, $aZa8T.default)($733f0e0be6245765$var$FeatureGates, "onGateUpdated", $733f0e0be6245765$var$_FeatureGates.client.onGateUpdated.bind($733f0e0be6245765$var$_FeatureGates.client));
(0, $aZa8T.default)($733f0e0be6245765$var$FeatureGates, "onExperimentValueUpdated", $733f0e0be6245765$var$_FeatureGates.client.onExperimentValueUpdated.bind($733f0e0be6245765$var$_FeatureGates.client));
(0, $aZa8T.default)($733f0e0be6245765$var$FeatureGates, "onAnyUpdated", $733f0e0be6245765$var$_FeatureGates.client.onAnyUpdated.bind($733f0e0be6245765$var$_FeatureGates.client));
(0, $aZa8T.default)($733f0e0be6245765$var$FeatureGates, "updateUser", $733f0e0be6245765$var$_FeatureGates.client.updateUser.bind($733f0e0be6245765$var$_FeatureGates.client));
(0, $aZa8T.default)($733f0e0be6245765$var$FeatureGates, "updateUserWithProvider", $733f0e0be6245765$var$_FeatureGates.client.updateUserWithProvider.bind($733f0e0be6245765$var$_FeatureGates.client));
(0, $aZa8T.default)($733f0e0be6245765$var$FeatureGates, "updateUserWithValues", $733f0e0be6245765$var$_FeatureGates.client.updateUserWithValues.bind($733f0e0be6245765$var$_FeatureGates.client));
(0, $aZa8T.default)($733f0e0be6245765$var$FeatureGates, "getPackageVersion", $733f0e0be6245765$var$_FeatureGates.client.getPackageVersion.bind($733f0e0be6245765$var$_FeatureGates.client));
(0, $aZa8T.default)($733f0e0be6245765$var$FeatureGates, "getTargetApp", $733f0e0be6245765$var$_FeatureGates.client.getTargetApp.bind($733f0e0be6245765$var$_FeatureGates.client));
(0, $aZa8T.default)($733f0e0be6245765$var$FeatureGates, "getLayer", $733f0e0be6245765$var$_FeatureGates.client.getLayer.bind($733f0e0be6245765$var$_FeatureGates.client));
(0, $aZa8T.default)($733f0e0be6245765$var$FeatureGates, "getLayerValue", $733f0e0be6245765$var$_FeatureGates.client.getLayerValue.bind($733f0e0be6245765$var$_FeatureGates.client));
var $733f0e0be6245765$var$boundFGJS = $733f0e0be6245765$var$FeatureGates;
// This makes it possible to get a reference to the FeatureGates client at runtime.
// This is important for overriding values in Cypress tests, as there needs to be a
// way to get the exact instance for a window in order to mock some of its methods.
if (typeof window !== 'undefined') {
    if (window.__FEATUREGATES_JS__ === undefined) window.__FEATUREGATES_JS__ = $733f0e0be6245765$var$FeatureGates;
    else {
        var $733f0e0be6245765$var$_boundFGJS, $733f0e0be6245765$var$_boundFGJS$getPackage;
        $733f0e0be6245765$var$boundFGJS = window.__FEATUREGATES_JS__;
        var $733f0e0be6245765$var$boundVersion = (($733f0e0be6245765$var$_boundFGJS = $733f0e0be6245765$var$boundFGJS) === null || $733f0e0be6245765$var$_boundFGJS === void 0 || ($733f0e0be6245765$var$_boundFGJS$getPackage = $733f0e0be6245765$var$_boundFGJS.getPackageVersion) === null || $733f0e0be6245765$var$_boundFGJS$getPackage === void 0 ? void 0 : $733f0e0be6245765$var$_boundFGJS$getPackage.call($733f0e0be6245765$var$_boundFGJS)) || '4.10.0 or earlier';
        if ($733f0e0be6245765$var$boundVersion !== (0, $1ZXvG.CLIENT_VERSION)) {
            var $733f0e0be6245765$var$message = "Multiple versions of FeatureGateClients found on the current page.\n      The currently bound version is ".concat($733f0e0be6245765$var$boundVersion, " when module version ").concat((0, $1ZXvG.CLIENT_VERSION), " was loading.");
            // eslint-disable-next-line no-console
            console.warn($733f0e0be6245765$var$message);
        }
    }
}
var /**
 * @property {FeatureGates} FeatureGate default export
 */ $733f0e0be6245765$export$2e2bcd8739ae039 = $733f0e0be6245765$var$boundFGJS;

});
parcelRegister("3NnAq", function(module, exports) {
$parcel$export(module.exports, "Client", () => $2c383e7b52cee7b5$export$1f2bb630327ac4b6);

var $5jEYh = parcelRequire("5jEYh");

var $9xnax = parcelRequire("9xnax");

var $8V41E = parcelRequire("8V41E");

var $7FJTB = parcelRequire("7FJTB");

var $dhZ1B = parcelRequire("dhZ1B");

var $aZa8T = parcelRequire("aZa8T");

var $krGuf = parcelRequire("krGuf");

var $iFR7a = parcelRequire("iFR7a");

var $f3n4h = parcelRequire("f3n4h");

var $6c0Ti = parcelRequire("6c0Ti");

var $eFXVC = parcelRequire("eFXVC");

var $1E5FR = parcelRequire("1E5FR");

var $dSUrF = parcelRequire("dSUrF");

var $lEXVk = parcelRequire("lEXVk");

var $imHDk = parcelRequire("imHDk");

var $hyhGn = parcelRequire("hyhGn");

var $cu29X = parcelRequire("cu29X");

var $1ZXvG = parcelRequire("1ZXvG");
var $2c383e7b52cee7b5$var$_excluded = [
    "sdkKey",
    "environment",
    "updateUserCompletionCallback",
    "perimeter"
];
function $2c383e7b52cee7b5$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $2c383e7b52cee7b5$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $2c383e7b52cee7b5$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $aZa8T.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $2c383e7b52cee7b5$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $2c383e7b52cee7b5$var$DEFAULT_CLIENT_KEY = 'client-default-key';
// default event logging api is Atlassian proxy rather than Statsig's domain, to avoid ad blockers
var $2c383e7b52cee7b5$var$DEFAULT_EVENT_LOGGING_API = 'https://xp.atlassian.com/v1/rgstr';
var $2c383e7b52cee7b5$export$1f2bb630327ac4b6 = /*#__PURE__*/ function() {
    function Client() {
        var _this = this;
        var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, _ref$localStorageKey = _ref.localStorageKey, localStorageKey = _ref$localStorageKey === void 0 ? (0, $imHDk.LOCAL_STORAGE_KEY) : _ref$localStorageKey, overrideAdapter = _ref.overrideAdapter;
        (0, $7FJTB.default)(this, Client);
        (0, $aZa8T.default)(this, "initPromise", null);
        /** True if an initialize method was called and completed successfully. */ (0, $aZa8T.default)(this, "initCompleted", false);
        /**
     * True if an initialize method was called and completed, meaning the client is now usable.
     * However if there was an error during initialization it may have initialized with default
     * values. Use {@link initCompleted} to check for this.
     */ (0, $aZa8T.default)(this, "initWithDefaults", false);
        (0, $aZa8T.default)(this, "hasCheckGateErrorOccurred", false);
        (0, $aZa8T.default)(this, "hasGetExperimentErrorOccurred", false);
        (0, $aZa8T.default)(this, "hasGetExperimentValueErrorOccurred", false);
        (0, $aZa8T.default)(this, "hasGetLayerErrorOccurred", false);
        (0, $aZa8T.default)(this, "hasGetLayerValueErrorOccurred", false);
        (0, $aZa8T.default)(this, "subscriptions", new (0, $f3n4h.default)());
        (0, $aZa8T.default)(this, "dataAdapter", new (0, $lEXVk.NoFetchDataAdapter)());
        /**
     * Call this if modifying the values being served by the Statsig library since it has its own
     * memoization cache which will not be updated if the values are changed outside of the library.
     */ (0, $aZa8T.default)(this, "statsigValuesUpdated", function() {
            if (_this.user) // Trigger a reset of the memoize cache
            _this.statsigClient.updateUserSync(_this.user, {
                disableBackgroundCacheRefresh: true
            });
            _this.subscriptions.anyUpdated();
        });
        this.overrideAdapter = overrideAdapter || new (0, $imHDk.PersistentOverrideAdapter)(localStorageKey);
    }
    /**
   * @description
   * This method initializes the client using a network call to fetch the bootstrap values.
   * If the client is inialized with an `analyticsWebClient`, it will send an operational event
   * to GASv3 with the following attributes:
   * - targetApp: the target app of the client
   * - clientVersion: the version of the client
   * - success: whether the initialization was successful
   * - startTime: the time when the initialization started
   * - totalTime: the total time it took to initialize the client
   * - apiKey: the api key used to initialize the client
   * @param clientOptions {ClientOptions}
   * @param identifiers {Identifiers}
   * @param customAttributes {CustomAttributes}
   * @returns {Promise<void>}
   */ return (0, $dhZ1B.default)(Client, [
        {
            key: "initialize",
            value: function() {
                var _initialize = (0, $8V41E.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($krGuf))).mark(function _callee(clientOptions, identifiers, customAttributes) {
                    var _this2 = this;
                    var clientOptionsWithDefaults, startTime;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($krGuf))).wrap(function(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                clientOptionsWithDefaults = (0, $cu29X.getOptionsWithDefaults)(clientOptions);
                                if (!this.initPromise) {
                                    _context.next = 1;
                                    break;
                                }
                                if (!(0, $cu29X.shallowEquals)(clientOptionsWithDefaults, this.initOptions)) // eslint-disable-next-line no-console
                                console.warn('Feature Gates client already initialized with different options. New options were not applied.');
                                return _context.abrupt("return", this.initPromise);
                            case 1:
                                startTime = performance.now();
                                this.initOptions = clientOptionsWithDefaults;
                                this.initPromise = this.init(clientOptionsWithDefaults, identifiers, customAttributes).then(function() {
                                    _this2.initCompleted = true;
                                    _this2.initWithDefaults = true;
                                }).finally(function() {
                                    var endTime = performance.now();
                                    var totalTime = endTime - startTime;
                                    _this2.fireClientEvent(startTime, totalTime, 'initialize', _this2.initCompleted, clientOptionsWithDefaults.apiKey);
                                });
                                return _context.abrupt("return", this.initPromise);
                            case 2:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee, this);
                }));
                function initialize(_x, _x2, _x3) {
                    return _initialize.apply(this, arguments);
                }
                return initialize;
            }()
        },
        {
            key: "initializeWithProvider",
            value: function() {
                var _initializeWithProvider = (0, $8V41E.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($krGuf))).mark(function _callee2(clientOptions, provider, identifiers, customAttributes) {
                    var _this3 = this;
                    var clientOptionsWithDefaults, startTime;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($krGuf))).wrap(function(_context2) {
                        while(true)switch(_context2.prev = _context2.next){
                            case 0:
                                clientOptionsWithDefaults = (0, $cu29X.getOptionsWithDefaults)(clientOptions);
                                if (!this.initPromise) {
                                    _context2.next = 1;
                                    break;
                                }
                                if (!(0, $cu29X.shallowEquals)(clientOptionsWithDefaults, this.initOptions)) // eslint-disable-next-line no-console
                                console.warn('Feature Gates client already initialized with different options. New options were not applied.');
                                return _context2.abrupt("return", this.initPromise);
                            case 1:
                                startTime = performance.now();
                                this.initOptions = clientOptionsWithDefaults;
                                this.provider = provider;
                                this.provider.setClientVersion((0, $1ZXvG.CLIENT_VERSION));
                                if (this.provider.setApplyUpdateCallback) this.provider.setApplyUpdateCallback(this.applyUpdateCallback.bind(this));
                                this.initPromise = this.initWithProvider(clientOptionsWithDefaults, provider, identifiers, customAttributes).then(function() {
                                    _this3.initCompleted = true;
                                    _this3.initWithDefaults = true;
                                }).finally(function() {
                                    var endTime = performance.now();
                                    var totalTime = endTime - startTime;
                                    _this3.fireClientEvent(startTime, totalTime, 'initializeWithProvider', _this3.initCompleted, provider.getApiKey ? provider.getApiKey() : undefined);
                                });
                                return _context2.abrupt("return", this.initPromise);
                            case 2:
                            case "end":
                                return _context2.stop();
                        }
                    }, _callee2, this);
                }));
                function initializeWithProvider(_x4, _x5, _x6, _x7) {
                    return _initializeWithProvider.apply(this, arguments);
                }
                return initializeWithProvider;
            }()
        },
        {
            key: "applyUpdateCallback",
            value: function applyUpdateCallback(experimentsResult) {
                try {
                    if (this.initCompleted || this.initWithDefaults) {
                        this.assertInitialized(this.statsigClient);
                        this.dataAdapter.setBootstrapData(experimentsResult.experimentValues);
                        this.dataAdapter.setData(JSON.stringify(experimentsResult.experimentValues));
                        this.statsigValuesUpdated();
                    }
                } catch (error) {
                    // eslint-disable-next-line no-console
                    console.warn('Error when attempting to apply update', error);
                }
            }
        },
        {
            key: "fireClientEvent",
            value: function fireClientEvent(startTime, totalTime, action, success) {
                var _analyticsWebClient, _this4 = this;
                var apiKey = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;
                (_analyticsWebClient = this.initOptions.analyticsWebClient) === null || _analyticsWebClient === void 0 || _analyticsWebClient.then(function(analyticsWebClient) {
                    var attributes = $2c383e7b52cee7b5$var$_objectSpread({
                        targetApp: _this4.initOptions.targetApp,
                        clientVersion: (0, $1ZXvG.CLIENT_VERSION),
                        success: success,
                        startTime: startTime,
                        totalTime: totalTime
                    }, apiKey && {
                        apiKey: apiKey
                    });
                    analyticsWebClient.sendOperationalEvent({
                        action: action,
                        actionSubject: 'featureGatesClient',
                        attributes: attributes,
                        tags: [
                            'measurement'
                        ],
                        source: '@atlaskit/feature-gate-js-client'
                    });
                }).catch(function(err) {
                    if (_this4.initOptions.environment !== (0, $hyhGn.FeatureGateEnvironment).Production) // eslint-disable-next-line no-console
                    console.error('Analytics web client promise did not resolve', err);
                });
            }
        },
        {
            key: "initializeFromValues",
            value: function() {
                var _initializeFromValues = (0, $8V41E.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($krGuf))).mark(function _callee3(clientOptions, identifiers, customAttributes) {
                    var _this5 = this;
                    var initializeValues, clientOptionsWithDefaults, startTime, _args3 = arguments;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($krGuf))).wrap(function(_context3) {
                        while(true)switch(_context3.prev = _context3.next){
                            case 0:
                                initializeValues = _args3.length > 3 && _args3[3] !== undefined ? _args3[3] : {};
                                clientOptionsWithDefaults = (0, $cu29X.getOptionsWithDefaults)(clientOptions);
                                if (!this.initPromise) {
                                    _context3.next = 1;
                                    break;
                                }
                                if (!(0, $cu29X.shallowEquals)(clientOptionsWithDefaults, this.initOptions)) // eslint-disable-next-line no-console
                                console.warn('Feature Gates client already initialized with different options. New options were not applied.');
                                return _context3.abrupt("return", this.initPromise);
                            case 1:
                                // This makes sure the new Statsig client behaves like the old when bootstrap data is
                                // passed, and `has_updates` isn't specified (which happens a lot in product integration tests).
                                if (!Object.prototype.hasOwnProperty.call(initializeValues, 'has_updates')) initializeValues['has_updates'] = true;
                                startTime = performance.now();
                                this.initOptions = clientOptionsWithDefaults;
                                this.initPromise = this.initFromValues(clientOptionsWithDefaults, identifiers, customAttributes, initializeValues).then(function() {
                                    _this5.initCompleted = true;
                                    _this5.initWithDefaults = true;
                                }).finally(function() {
                                    var endTime = performance.now();
                                    var totalTime = endTime - startTime;
                                    _this5.fireClientEvent(startTime, totalTime, 'initializeFromValues', _this5.initCompleted);
                                });
                                return _context3.abrupt("return", this.initPromise);
                            case 2:
                            case "end":
                                return _context3.stop();
                        }
                    }, _callee3, this);
                }));
                function initializeFromValues(_x8, _x9, _x0) {
                    return _initializeFromValues.apply(this, arguments);
                }
                return initializeFromValues;
            }()
        },
        {
            key: "assertInitialized",
            value: function assertInitialized(statsigClient) {
                if (!statsigClient) throw new Error('Client must be initialized before using this method');
            }
        },
        {
            key: "updateUser",
            value: function() {
                var _updateUser = (0, $8V41E.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($krGuf))).mark(function _callee4(fetchOptions, identifiers, customAttributes) {
                    var fetchOptionsWithDefaults, initializeValuesProducer;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($krGuf))).wrap(function(_context4) {
                        while(true)switch(_context4.prev = _context4.next){
                            case 0:
                                this.assertInitialized(this.statsigClient);
                                fetchOptionsWithDefaults = (0, $cu29X.getOptionsWithDefaults)(fetchOptions);
                                initializeValuesProducer = function initializeValuesProducer() {
                                    return (0, $dSUrF.default).fetchExperimentValues(fetchOptionsWithDefaults, identifiers, customAttributes).then(function(_ref2) {
                                        var experimentValues = _ref2.experimentValues, customAttributes = _ref2.customAttributes;
                                        return {
                                            experimentValues: experimentValues,
                                            customAttributesFromFetch: customAttributes
                                        };
                                    });
                                };
                                _context4.next = 1;
                                return this.updateUserUsingInitializeValuesProducer(initializeValuesProducer, identifiers, customAttributes);
                            case 1:
                            case "end":
                                return _context4.stop();
                        }
                    }, _callee4, this);
                }));
                function updateUser(_x1, _x10, _x11) {
                    return _updateUser.apply(this, arguments);
                }
                return updateUser;
            }()
        },
        {
            key: "updateUserWithProvider",
            value: function() {
                var _updateUserWithProvider = (0, $8V41E.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($krGuf))).mark(function _callee5(identifiers, customAttributes) {
                    var _this6 = this;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($krGuf))).wrap(function(_context5) {
                        while(true)switch(_context5.prev = _context5.next){
                            case 0:
                                this.assertInitialized(this.statsigClient);
                                if (this.provider) {
                                    _context5.next = 1;
                                    break;
                                }
                                throw new Error('Cannot update user using provider as the client was not initialised with a provider');
                            case 1:
                                _context5.next = 2;
                                return this.provider.setProfile(this.initOptions, identifiers, customAttributes);
                            case 2:
                                _context5.next = 3;
                                return this.updateUserUsingInitializeValuesProducer(function() {
                                    return _this6.provider.getExperimentValues();
                                }, identifiers, customAttributes);
                            case 3:
                            case "end":
                                return _context5.stop();
                        }
                    }, _callee5, this);
                }));
                function updateUserWithProvider(_x12, _x13) {
                    return _updateUserWithProvider.apply(this, arguments);
                }
                return updateUserWithProvider;
            }()
        },
        {
            key: "updateUserWithValues",
            value: function() {
                var _updateUserWithValues = (0, $8V41E.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($krGuf))).mark(function _callee6(identifiers, customAttributes) {
                    var initializeValues, initializeValuesProducer, _args6 = arguments;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($krGuf))).wrap(function(_context6) {
                        while(true)switch(_context6.prev = _context6.next){
                            case 0:
                                initializeValues = _args6.length > 2 && _args6[2] !== undefined ? _args6[2] : {};
                                this.assertInitialized(this.statsigClient);
                                initializeValuesProducer = function initializeValuesProducer() {
                                    return Promise.resolve({
                                        experimentValues: initializeValues,
                                        customAttributesFromFetch: customAttributes
                                    });
                                };
                                _context6.next = 1;
                                return this.updateUserUsingInitializeValuesProducer(initializeValuesProducer, identifiers, customAttributes);
                            case 1:
                            case "end":
                                return _context6.stop();
                        }
                    }, _callee6, this);
                }));
                function updateUserWithValues(_x14, _x15) {
                    return _updateUserWithValues.apply(this, arguments);
                }
                return updateUserWithValues;
            }()
        },
        {
            key: "initializeCalled",
            value: function initializeCalled() {
                return this.initPromise != null;
            }
        },
        {
            key: "initializeCompleted",
            value: function initializeCompleted() {
                return this.initCompleted;
            }
        },
        {
            key: "waitUntilInitializeCompleted",
            value: function() {
                var _waitUntilInitializeCompleted = (0, $8V41E.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($krGuf))).mark(function _callee7() {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($krGuf))).wrap(function(_context7) {
                        while(true)switch(_context7.prev = _context7.next){
                            case 0:
                                if (this.initPromise) {
                                    _context7.next = 1;
                                    break;
                                }
                                throw new Error('The client must be initialized before you can wait until initialized.');
                            case 1:
                                if (!this.initCompleted) {
                                    _context7.next = 2;
                                    break;
                                }
                                return _context7.abrupt("return");
                            case 2:
                                _context7.next = 3;
                                return this.initPromise;
                            case 3:
                            case "end":
                                return _context7.stop();
                        }
                    }, _callee7, this);
                }));
                function waitUntilInitializeCompleted() {
                    return _waitUntilInitializeCompleted.apply(this, arguments);
                }
                return waitUntilInitializeCompleted;
            }()
        },
        {
            key: "checkGate",
            value: function checkGate(gateName) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                try {
                    this.assertInitialized(this.statsigClient);
                    var _options$fireGateExpo = options.fireGateExposure, fireGateExposure = _options$fireGateExpo === void 0 ? true : _options$fireGateExpo;
                    return this.statsigClient.checkGate(gateName, {
                        disableExposureLog: !fireGateExposure
                    });
                } catch (error) {
                    // Log the first occurrence of the error
                    if (!this.hasCheckGateErrorOccurred) {
                        // eslint-disable-next-line no-console
                        console.warn({
                            msg: 'An error has occurred checking the feature gate. Only the first occurrence of this error is logged.',
                            gateName: gateName,
                            error: error
                        });
                        this.hasCheckGateErrorOccurred = true;
                    }
                    return false;
                }
            }
        },
        {
            key: "isGateExist",
            value: function isGateExist(gateName) {
                try {
                    this.assertInitialized(this.statsigClient);
                    var gate = this.statsigClient.getFeatureGate(gateName, {
                        disableExposureLog: true
                    });
                    return !gate.details.reason.includes('Unrecognized');
                } catch (error) {
                    // eslint-disable-next-line no-console
                    console.error("Error occurred when trying to check FeatureGate: ".concat(error));
                    // in case of error report true to avoid false positives.
                    return true;
                }
            }
        },
        {
            key: "isExperimentExist",
            value: function isExperimentExist(experimentName) {
                try {
                    this.assertInitialized(this.statsigClient);
                    var config = this.statsigClient.getExperiment(experimentName, {
                        disableExposureLog: true
                    });
                    return !config.details.reason.includes('Unrecognized');
                } catch (error) {
                    // eslint-disable-next-line no-console
                    console.error("Error occurred when trying to check Experiment: ".concat(error));
                    // in case of error report true to avoid false positives.
                    return true;
                }
            }
        },
        {
            key: "manuallyLogGateExposure",
            value: function manuallyLogGateExposure(gateName) {
                this.assertInitialized(this.statsigClient);
                // This is the approach recommended in the docs
                // https://docs.statsig.com/client/javascript-sdk/#manual-exposures-
                this.statsigClient.checkGate(gateName);
            }
        },
        {
            key: "getExperiment",
            value: function getExperiment(experimentName) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                try {
                    this.assertInitialized(this.statsigClient);
                    var _options$fireExperime = options.fireExperimentExposure, fireExperimentExposure = _options$fireExperime === void 0 ? true : _options$fireExperime;
                    return (0, $6c0Ti.DynamicConfig).fromExperiment(this.statsigClient.getExperiment(experimentName, {
                        disableExposureLog: !fireExperimentExposure
                    }));
                } catch (error) {
                    // Log the first occurrence of the error
                    if (!this.hasGetExperimentErrorOccurred) {
                        // eslint-disable-next-line no-console
                        console.warn({
                            msg: 'An error has occurred getting the experiment. Only the first occurrence of this error is logged.',
                            experimentName: experimentName,
                            error: error
                        });
                        this.hasGetExperimentErrorOccurred = true;
                    }
                    // Return a default value
                    return new (0, $6c0Ti.DynamicConfig)(experimentName, {}, '', {
                        time: Date.now(),
                        reason: (0, $1E5FR.EvaluationReason).Error
                    });
                }
            }
        },
        {
            key: "getExperimentValue",
            value: function getExperimentValue(experimentName, parameterName, defaultValue) {
                var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var experiment = this.getExperiment(experimentName, options);
                try {
                    var typeGuard = options.typeGuard;
                    return experiment.get(parameterName, defaultValue, typeGuard);
                } catch (error) {
                    // Log the first occurrence of the error
                    if (!this.hasGetExperimentValueErrorOccurred) {
                        // eslint-disable-next-line no-console
                        console.warn({
                            msg: 'An error has occurred getting the experiment value. Only the first occurrence of this error is logged.',
                            experimentName: experimentName,
                            defaultValue: defaultValue,
                            options: options,
                            error: error
                        });
                        this.hasGetExperimentValueErrorOccurred = true;
                    }
                    return defaultValue;
                }
            }
        },
        {
            key: "manuallyLogExperimentExposure",
            value: function manuallyLogExperimentExposure(experimentName) {
                this.assertInitialized(this.statsigClient);
                // This is the approach recommended in the docs
                // https://docs.statsig.com/client/javascript-sdk/#manual-exposures-
                this.statsigClient.getExperiment(experimentName);
            }
        },
        {
            key: "manuallyLogLayerExposure",
            value: function manuallyLogLayerExposure(layerName, parameterName) {
                var _this$statsigClient$g;
                this.assertInitialized(this.statsigClient);
                // This is the approach recommended in the docs
                // https://docs.statsig.com/client/javascript-sdk/#manual-exposures-
                (_this$statsigClient$g = this.statsigClient.getLayer(layerName)) === null || _this$statsigClient$g === void 0 || _this$statsigClient$g.get(parameterName);
            }
        },
        {
            key: "shutdownStatsig",
            value: function shutdownStatsig() {
                this.assertInitialized(this.statsigClient);
                this.statsigClient.shutdown();
            }
        },
        {
            key: "overrideGate",
            value: function overrideGate(gateName, value) {
                this.overrideAdapter.overrideGate(gateName, value);
                // Trigger a reset of the memoized gate value
                if (this.user) {
                    var _this$statsigClient;
                    (_this$statsigClient = this.statsigClient) === null || _this$statsigClient === void 0 || _this$statsigClient.updateUserSync(this.user, {
                        disableBackgroundCacheRefresh: true
                    });
                }
                this.statsigValuesUpdated();
            }
        },
        {
            key: "clearGateOverride",
            value: function clearGateOverride(gateName) {
                this.overrideAdapter.removeGateOverride(gateName);
                this.statsigValuesUpdated();
            }
        },
        {
            key: "overrideConfig",
            value: function overrideConfig(experimentName, values) {
                this.overrideAdapter.overrideDynamicConfig(experimentName, values);
                this.statsigValuesUpdated();
            }
        },
        {
            key: "clearConfigOverride",
            value: function clearConfigOverride(experimentName) {
                this.overrideAdapter.removeDynamicConfigOverride(experimentName);
                this.statsigValuesUpdated();
            }
        },
        {
            key: "setOverrides",
            value: function setOverrides(overrides) {
                this.overrideAdapter.setOverrides(overrides);
                this.statsigValuesUpdated();
            }
        },
        {
            key: "getOverrides",
            value: function getOverrides() {
                return this.overrideAdapter.getOverrides();
            }
        },
        {
            key: "clearAllOverrides",
            value: function clearAllOverrides() {
                this.overrideAdapter.removeAllOverrides();
                this.statsigValuesUpdated();
            }
        },
        {
            key: "isCurrentUser",
            value: function isCurrentUser(identifiers, customAttributes) {
                return (0, $cu29X.shallowEquals)(this.currentIdentifiers, identifiers) && (0, $cu29X.shallowEquals)(this.currentAttributes, customAttributes);
            }
        },
        {
            key: "onGateUpdated",
            value: function onGateUpdated(gateName, callback) {
                var _this7 = this;
                var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                var wrapCallback = function wrapCallback(value) {
                    var _options$fireGateExpo2 = options.fireGateExposure, fireGateExposure = _options$fireGateExpo2 === void 0 ? true : _options$fireGateExpo2;
                    if (fireGateExposure) _this7.manuallyLogGateExposure(gateName);
                    try {
                        callback(value);
                    } catch (error) {
                        // eslint-disable-next-line no-console
                        console.warn("Error calling callback for gate ".concat(gateName, " with value ").concat(value), error);
                    }
                };
                return this.subscriptions.onGateUpdated(gateName, wrapCallback, this.checkGate.bind(this), options);
            }
        },
        {
            key: "onExperimentValueUpdated",
            value: function onExperimentValueUpdated(experimentName, parameterName, defaultValue, callback) {
                var _this8 = this;
                var options = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
                var wrapCallback = function wrapCallback(value) {
                    var _options$fireExperime2 = options.fireExperimentExposure, fireExperimentExposure = _options$fireExperime2 === void 0 ? true : _options$fireExperime2;
                    if (fireExperimentExposure) _this8.manuallyLogExperimentExposure(experimentName);
                    try {
                        callback(value);
                    } catch (error) {
                        // eslint-disable-next-line no-console
                        console.warn("Error calling callback for experiment ".concat(experimentName, " with value ").concat(value), error);
                    }
                };
                return this.subscriptions.onExperimentValueUpdated(experimentName, parameterName, defaultValue, wrapCallback, this.getExperimentValue.bind(this), options);
            }
        },
        {
            key: "onAnyUpdated",
            value: function onAnyUpdated(callback) {
                return this.subscriptions.onAnyUpdated(callback);
            }
        },
        {
            key: "init",
            value: function() {
                var _init = (0, $8V41E.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($krGuf))).mark(function _callee8(clientOptions, identifiers, customAttributes) {
                    var fromValuesClientOptions, experimentValues, customAttributesFromResult, clientSdkKeyPromise, experimentValuesPromise, _yield$Promise$all, _yield$Promise$all2, experimentValuesResult, _t;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($krGuf))).wrap(function(_context8) {
                        while(true)switch(_context8.prev = _context8.next){
                            case 0:
                                fromValuesClientOptions = $2c383e7b52cee7b5$var$_objectSpread({}, clientOptions);
                                if (!clientOptions.localMode) {
                                    _context8.next = 2;
                                    break;
                                }
                                _context8.next = 1;
                                return this.initFromValues(fromValuesClientOptions, identifiers, customAttributes);
                            case 1:
                                return _context8.abrupt("return");
                            case 2:
                                _context8.prev = 2;
                                // If client sdk key fetch fails, an error would be thrown and handled instead of waiting for
                                // the experiment values request to be settled, and it will fall back to use default values.
                                clientSdkKeyPromise = (0, $dSUrF.default).fetchClientSdk(clientOptions).then(function(value) {
                                    return fromValuesClientOptions.sdkKey = value.clientSdkKey;
                                });
                                experimentValuesPromise = (0, $dSUrF.default).fetchExperimentValues(clientOptions, identifiers, customAttributes); // Only wait for the experiment values request to finish and try to initialise the client
                                // with experiment values if both requests are successful. Else an error would be thrown and
                                // handled by the catch
                                _context8.next = 3;
                                return Promise.all([
                                    clientSdkKeyPromise,
                                    experimentValuesPromise
                                ]);
                            case 3:
                                _yield$Promise$all = _context8.sent;
                                _yield$Promise$all2 = (0, $9xnax.default)(_yield$Promise$all, 2);
                                experimentValuesResult = _yield$Promise$all2[1];
                                experimentValues = experimentValuesResult.experimentValues;
                                customAttributesFromResult = experimentValuesResult.customAttributes;
                                _context8.next = 6;
                                break;
                            case 4:
                                _context8.prev = 4;
                                _t = _context8["catch"](2);
                                if (_t instanceof Error) // eslint-disable-next-line no-console
                                console.error("Error occurred when trying to fetch the Feature Gates client values, error: ".concat(_t === null || _t === void 0 ? void 0 : _t.message));
                                // eslint-disable-next-line no-console
                                console.warn("Initialising Statsig client without values");
                                _context8.next = 5;
                                return this.initFromValues(fromValuesClientOptions, identifiers, customAttributes);
                            case 5:
                                throw _t;
                            case 6:
                                return _context8.abrupt("return", this.initFromValues(fromValuesClientOptions, identifiers, customAttributesFromResult, experimentValues));
                            case 7:
                            case "end":
                                return _context8.stop();
                        }
                    }, _callee8, this, [
                        [
                            2,
                            4
                        ]
                    ]);
                }));
                function init(_x16, _x17, _x18) {
                    return _init.apply(this, arguments);
                }
                return init;
            }()
        },
        {
            key: "initWithProvider",
            value: function() {
                var _initWithProvider = (0, $8V41E.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($krGuf))).mark(function _callee9(baseClientOptions, provider, identifiers, customAttributes) {
                    var fromValuesClientOptions, experimentValues, customAttributesFromResult, clientSdkKeyPromise, experimentValuesPromise, _yield$Promise$all3, _yield$Promise$all4, experimentValuesResult, _t2;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($krGuf))).wrap(function(_context9) {
                        while(true)switch(_context9.prev = _context9.next){
                            case 0:
                                fromValuesClientOptions = $2c383e7b52cee7b5$var$_objectSpread($2c383e7b52cee7b5$var$_objectSpread({}, baseClientOptions), {}, {
                                    disableCurrentPageLogging: true
                                });
                                _context9.prev = 1;
                                _context9.next = 2;
                                return provider.setProfile(baseClientOptions, identifiers, customAttributes);
                            case 2:
                                // If client sdk key fetch fails, an error would be thrown and handled instead of waiting for
                                // the experiment values request to be settled, and it will fall back to use default values.
                                clientSdkKeyPromise = provider.getClientSdkKey().then(function(value) {
                                    return fromValuesClientOptions.sdkKey = value;
                                });
                                experimentValuesPromise = provider.getExperimentValues(); // Only wait for the experiment values request to finish and try to initialise the client
                                // with experiment values if both requests are successful. Else an error would be thrown and
                                // handled by the catch
                                _context9.next = 3;
                                return Promise.all([
                                    clientSdkKeyPromise,
                                    experimentValuesPromise
                                ]);
                            case 3:
                                _yield$Promise$all3 = _context9.sent;
                                _yield$Promise$all4 = (0, $9xnax.default)(_yield$Promise$all3, 2);
                                experimentValuesResult = _yield$Promise$all4[1];
                                experimentValues = experimentValuesResult.experimentValues;
                                customAttributesFromResult = experimentValuesResult.customAttributesFromFetch;
                                _context9.next = 6;
                                break;
                            case 4:
                                _context9.prev = 4;
                                _t2 = _context9["catch"](1);
                                if (_t2 instanceof Error) // eslint-disable-next-line no-console
                                console.error("Error occurred when trying to fetch the Feature Gates client values, error: ".concat(_t2 === null || _t2 === void 0 ? void 0 : _t2.message));
                                // eslint-disable-next-line no-console
                                console.warn("Initialising Statsig client without values");
                                _context9.next = 5;
                                return this.initFromValues(fromValuesClientOptions, identifiers, customAttributes);
                            case 5:
                                throw _t2;
                            case 6:
                                return _context9.abrupt("return", this.initFromValues(fromValuesClientOptions, identifiers, customAttributesFromResult, experimentValues));
                            case 7:
                            case "end":
                                return _context9.stop();
                        }
                    }, _callee9, this, [
                        [
                            1,
                            4
                        ]
                    ]);
                }));
                function initWithProvider(_x19, _x20, _x21, _x22) {
                    return _initWithProvider.apply(this, arguments);
                }
                return initWithProvider;
            }()
        },
        {
            key: "initFromValues",
            value: function() {
                var _initFromValues = (0, $8V41E.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($krGuf))).mark(function _callee0(clientOptions, identifiers, customAttributes) {
                    var _newClientOptions$net;
                    var initializeValues, newClientOptions, sdkKey, environment, _updateUserCompletionCallback, _perimeter, restClientOptions, frontendUser, statsigOptions, _args0 = arguments, _t3;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($krGuf))).wrap(function(_context0) {
                        while(true)switch(_context0.prev = _context0.next){
                            case 0:
                                initializeValues = _args0.length > 3 && _args0[3] !== undefined ? _args0[3] : {};
                                this.overrideAdapter.initFromStoredOverrides();
                                this.currentIdentifiers = identifiers;
                                this.currentAttributes = customAttributes;
                                newClientOptions = (0, $cu29X.migrateInitializationOptions)(clientOptions);
                                if (!newClientOptions.sdkKey) newClientOptions.sdkKey = $2c383e7b52cee7b5$var$DEFAULT_CLIENT_KEY;
                                if (!((_newClientOptions$net = newClientOptions.networkConfig) !== null && _newClientOptions$net !== void 0 && _newClientOptions$net.logEventUrl)) newClientOptions.networkConfig = $2c383e7b52cee7b5$var$_objectSpread($2c383e7b52cee7b5$var$_objectSpread({}, newClientOptions.networkConfig), {}, {
                                    logEventUrl: $2c383e7b52cee7b5$var$DEFAULT_EVENT_LOGGING_API
                                });
                                if (newClientOptions.perimeter === (0, $hyhGn.PerimeterType).FEDRAMP_MODERATE) // disable all logging in FedRAMP to prevent egress of sensitive data
                                newClientOptions.disableLogging = true;
                                sdkKey = newClientOptions.sdkKey, environment = newClientOptions.environment, _updateUserCompletionCallback = newClientOptions.updateUserCompletionCallback, _perimeter = newClientOptions.perimeter, restClientOptions = (0, $5jEYh.default)(newClientOptions, $2c383e7b52cee7b5$var$_excluded);
                                frontendUser = (0, $cu29X.toStatsigUser)(identifiers, customAttributes);
                                this.user = (0, $cu29X.deepAssign)({}, initializeValues.user, frontendUser);
                                statsigOptions = $2c383e7b52cee7b5$var$_objectSpread($2c383e7b52cee7b5$var$_objectSpread({}, restClientOptions), {}, {
                                    environment: {
                                        tier: environment
                                    },
                                    includeCurrentPageUrlWithEvents: false,
                                    dataAdapter: this.dataAdapter,
                                    overrideAdapter: this.overrideAdapter,
                                    logEventCompressionMode: (0, $iFR7a.LogEventCompressionMode).Forced
                                }); // Statsig validates the provided stableId against their own cookie, so we either need
                                // to update the cookie to match, or disable the validation completely.
                                if (identifiers.stableId) (0, $iFR7a.StableID).setOverride(identifiers.stableId, sdkKey);
                                else statsigOptions.disableStableID = true;
                                _context0.prev = 1;
                                this.statsigClient = new (0, $iFR7a.StatsigClient)(sdkKey, this.user, statsigOptions);
                                this.dataAdapter.setBootstrapData(initializeValues);
                                _context0.next = 2;
                                return this.statsigClient.initializeAsync();
                            case 2:
                                _context0.next = 5;
                                break;
                            case 3:
                                _context0.prev = 3;
                                _t3 = _context0["catch"](1);
                                if (_t3 instanceof Error) // eslint-disable-next-line no-console
                                console.error("Error occurred when trying to initialise the Statsig client, error: ".concat(_t3 === null || _t3 === void 0 ? void 0 : _t3.message));
                                // eslint-disable-next-line no-console
                                console.warn("Initialising Statsig client with default sdk key and without values");
                                this.statsigClient = new (0, $iFR7a.StatsigClient)($2c383e7b52cee7b5$var$DEFAULT_CLIENT_KEY, this.user, statsigOptions);
                                this.dataAdapter.setBootstrapData();
                                _context0.next = 4;
                                return this.statsigClient.initializeAsync();
                            case 4:
                                this.initWithDefaults = true;
                                throw _t3;
                            case 5:
                            case "end":
                                return _context0.stop();
                        }
                    }, _callee0, this, [
                        [
                            1,
                            3
                        ]
                    ]);
                }));
                function initFromValues(_x23, _x24, _x25) {
                    return _initFromValues.apply(this, arguments);
                }
                return initFromValues;
            }()
        },
        {
            key: "updateUserUsingInitializeValuesProducer",
            value: function() {
                var _updateUserUsingInitializeValuesProducer = (0, $8V41E.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($krGuf))).mark(function _callee10(getInitializeValues, identifiers, customAttributes) {
                    var _this9 = this;
                    var originalInitPromise, initializeValuesPromise, updateUserPromise, _t4;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($krGuf))).wrap(function(_context10) {
                        while(true)switch(_context10.prev = _context10.next){
                            case 0:
                                this.assertInitialized(this.statsigClient);
                                if (this.initPromise) {
                                    _context10.next = 1;
                                    break;
                                }
                                throw new Error('The client must be initialized before you can update the user.');
                            case 1:
                                if (!this.isCurrentUser(identifiers, customAttributes)) {
                                    _context10.next = 2;
                                    break;
                                }
                                return _context10.abrupt("return", this.initPromise);
                            case 2:
                                // Wait for the current initialize/update to finish
                                originalInitPromise = this.initPromise;
                                _context10.prev = 3;
                                _context10.next = 4;
                                return this.initPromise;
                            case 4:
                                _context10.next = 6;
                                break;
                            case 5:
                                _context10.prev = 5;
                                _t4 = _context10["catch"](3);
                            case 6:
                                initializeValuesPromise = getInitializeValues();
                                updateUserPromise = this.updateStatsigClientUser(initializeValuesPromise, identifiers, customAttributes); // We replace the init promise here since we are essentially re-initializing the client at this
                                // point. Any subsequent calls to await client.initialize() or client.updateUser()
                                // will now also await this user update.
                                this.initPromise = updateUserPromise.catch(/*#__PURE__*/ (0, $8V41E.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($krGuf))).mark(function _callee1() {
                                    return (0, (/*@__PURE__*/$parcel$interopDefault($krGuf))).wrap(function(_context1) {
                                        while(true)switch(_context1.prev = _context1.next){
                                            case 0:
                                                // If the update failed then it changed nothing, so revert back to the original promise.
                                                _this9.initPromise = originalInitPromise;
                                                // Set the user profile again to revert back to the current user
                                                if (!_this9.provider) {
                                                    _context1.next = 1;
                                                    break;
                                                }
                                                _context1.next = 1;
                                                return _this9.provider.setProfile(_this9.initOptions, _this9.currentIdentifiers, _this9.currentAttributes);
                                            case 1:
                                            case "end":
                                                return _context1.stop();
                                        }
                                    }, _callee1);
                                })));
                                return _context10.abrupt("return", updateUserPromise);
                            case 7:
                            case "end":
                                return _context10.stop();
                        }
                    }, _callee10, this, [
                        [
                            3,
                            5
                        ]
                    ]);
                }));
                function updateUserUsingInitializeValuesProducer(_x26, _x27, _x28) {
                    return _updateUserUsingInitializeValuesProducer.apply(this, arguments);
                }
                return updateUserUsingInitializeValuesProducer;
            }()
        },
        {
            key: "updateStatsigClientUser",
            value: function() {
                var _updateStatsigClientUser = (0, $8V41E.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($krGuf))).mark(function _callee11(initializeValuesPromise, identifiers, customAttributes) {
                    var _this$initOptions, _this$initOptions$upd;
                    var initializeValues, user, frontendUser, _updateUserCompletion, _ref4, errMsg, success, errorMessage, _t5, _t6;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($krGuf))).wrap(function(_context11) {
                        while(true)switch(_context11.prev = _context11.next){
                            case 0:
                                this.assertInitialized(this.statsigClient);
                                _context11.prev = 1;
                                _context11.next = 2;
                                return initializeValuesPromise;
                            case 2:
                                initializeValues = _context11.sent;
                                frontendUser = (0, $cu29X.toStatsigUser)(identifiers, initializeValues.customAttributesFromFetch);
                                user = (0, $cu29X.deepAssign)({}, initializeValues.experimentValues.user, frontendUser);
                                _context11.next = 4;
                                break;
                            case 3:
                                _context11.prev = 3;
                                _t5 = _context11["catch"](1);
                                // Make sure the updateUserCompletionCallback is called for any errors in our custom code.
                                // This is not necessary for the updateUserWithValues call, because the Statsig client will
                                // already invoke the callback itself.
                                errMsg = _t5 instanceof Error ? _t5.message : JSON.stringify(_t5);
                                (_updateUserCompletion = (_ref4 = this.initOptions).updateUserCompletionCallback) === null || _updateUserCompletion === void 0 || _updateUserCompletion.call(_ref4, false, errMsg);
                                throw _t5;
                            case 4:
                                success = true;
                                errorMessage = null;
                                _context11.prev = 5;
                                this.dataAdapter.setBootstrapData(initializeValues.experimentValues);
                                this.user = user;
                                if (!this.user) {
                                    _context11.next = 6;
                                    break;
                                }
                                _context11.next = 6;
                                return this.statsigClient.updateUserAsync(this.user);
                            case 6:
                                _context11.next = 8;
                                break;
                            case 7:
                                _context11.prev = 7;
                                _t6 = _context11["catch"](5);
                                success = false;
                                errorMessage = String(_t6);
                            case 8:
                                (_this$initOptions = this.initOptions) === null || _this$initOptions === void 0 || (_this$initOptions$upd = _this$initOptions.updateUserCompletionCallback) === null || _this$initOptions$upd === void 0 || _this$initOptions$upd.call(_this$initOptions, success, errorMessage);
                                if (!success) {
                                    _context11.next = 9;
                                    break;
                                }
                                this.currentIdentifiers = identifiers;
                                this.currentAttributes = customAttributes;
                                this.subscriptions.anyUpdated();
                                _context11.next = 10;
                                break;
                            case 9:
                                throw new Error('Failed to update user. An unexpected error occured.');
                            case 10:
                            case "end":
                                return _context11.stop();
                        }
                    }, _callee11, this, [
                        [
                            1,
                            3
                        ],
                        [
                            5,
                            7
                        ]
                    ]);
                }));
                function updateStatsigClientUser(_x29, _x30, _x31) {
                    return _updateStatsigClientUser.apply(this, arguments);
                }
                return updateStatsigClientUser;
            }()
        },
        {
            key: "getPackageVersion",
            value: /**
     * @returns string version of the current package in semver style.
     */ function getPackageVersion() {
                return 0, $1ZXvG.CLIENT_VERSION;
            }
        },
        {
            key: "getTargetApp",
            value: function getTargetApp() {
                var _this$initOptions2;
                return (_this$initOptions2 = this.initOptions) === null || _this$initOptions2 === void 0 ? void 0 : _this$initOptions2.targetApp;
            }
        },
        {
            key: "getLayer",
            value: function getLayer(/** The name of the layer */ layerName) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                try {
                    this.assertInitialized(this.statsigClient);
                    var _options$fireLayerExp = options.fireLayerExposure, fireLayerExposure = _options$fireLayerExp === void 0 ? true : _options$fireLayerExp;
                    return (0, $eFXVC.Layer).fromLayer(this.statsigClient.getLayer(layerName, {
                        disableExposureLog: !fireLayerExposure
                    }));
                } catch (error) {
                    // Log the first occurrence of the error
                    if (!this.hasGetLayerErrorOccurred) {
                        // eslint-disable-next-line no-console
                        console.warn({
                            msg: 'An error has occurred getting the layer. Only the first occurrence of this error is logged.',
                            layerName: layerName,
                            error: error
                        });
                        this.hasGetLayerErrorOccurred = true;
                    }
                    // Return a default value
                    return (0, $eFXVC.Layer).fromLayer((0, $iFR7a._makeLayer)(layerName, {
                        reason: 'Error'
                    }, null));
                }
            }
        },
        {
            key: "getLayerValue",
            value: function getLayerValue(layerName, parameterName, defaultValue) {
                var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var layer = this.getLayer(layerName, options);
                try {
                    var typeGuard = options.typeGuard;
                    return layer.get(parameterName, defaultValue, typeGuard);
                } catch (error) {
                    // Log the first occurrence of the error
                    if (!this.hasGetLayerValueErrorOccurred) {
                        // eslint-disable-next-line no-console
                        console.warn({
                            msg: 'An error has occurred getting the layer value. Only the first occurrence of this error is logged.',
                            layerName: layerName,
                            defaultValue: defaultValue,
                            options: options,
                            error: error
                        });
                        this.hasGetLayerValueErrorOccurred = true;
                    }
                    return defaultValue;
                }
            }
        }
    ]);
}();

});
parcelRegister("5jEYh", function(module, exports) {
$parcel$export(module.exports, "default", () => $3dee82265f6a8393$export$2e2bcd8739ae039);

var $8Uzd8 = parcelRequire("8Uzd8");
function $3dee82265f6a8393$export$2e2bcd8739ae039(e, t) {
    if (null == e) return {};
    var o, r, i = (0, $8Uzd8.default)(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}

});
parcelRegister("8Uzd8", function(module, exports) {
$parcel$export(module.exports, "default", () => $67ceddda09dcbf99$export$2e2bcd8739ae039);
function $67ceddda09dcbf99$export$2e2bcd8739ae039(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}

});


parcelRegister("9xnax", function(module, exports) {
$parcel$export(module.exports, "default", () => $6f192afed51e6a81$export$2e2bcd8739ae039);

var $gULzd = parcelRequire("gULzd");

var $4TKt4 = parcelRequire("4TKt4");

var $c6wee = parcelRequire("c6wee");

var $gfaKw = parcelRequire("gfaKw");
function $6f192afed51e6a81$export$2e2bcd8739ae039(r, e) {
    return (0, $gULzd.default)(r) || (0, $4TKt4.default)(r, e) || (0, $c6wee.default)(r, e) || (0, $gfaKw.default)();
}

});
parcelRegister("gULzd", function(module, exports) {
$parcel$export(module.exports, "default", () => $c506c61f3e1d8ca9$export$2e2bcd8739ae039);
function $c506c61f3e1d8ca9$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return r;
}

});

parcelRegister("4TKt4", function(module, exports) {
$parcel$export(module.exports, "default", () => $3910580da8b28310$export$2e2bcd8739ae039);
function $3910580da8b28310$export$2e2bcd8739ae039(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}

});

parcelRegister("c6wee", function(module, exports) {
$parcel$export(module.exports, "default", () => $8cff0b7fb3604f4b$export$2e2bcd8739ae039);

var $aWzVQ = parcelRequire("aWzVQ");
function $8cff0b7fb3604f4b$export$2e2bcd8739ae039(r, a) {
    if (r) {
        if ("string" == typeof r) return (0, $aWzVQ.default)(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? (0, $aWzVQ.default)(r, a) : void 0;
    }
}

});
parcelRegister("aWzVQ", function(module, exports) {
$parcel$export(module.exports, "default", () => $7f7b318207c57f40$export$2e2bcd8739ae039);
function $7f7b318207c57f40$export$2e2bcd8739ae039(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}

});


parcelRegister("gfaKw", function(module, exports) {
$parcel$export(module.exports, "default", () => $bd3662aa5e8ba52a$export$2e2bcd8739ae039);
function $bd3662aa5e8ba52a$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});


parcelRegister("8V41E", function(module, exports) {
$parcel$export(module.exports, "default", () => $67e6c506061ad6f7$export$2e2bcd8739ae039);
function $67e6c506061ad6f7$var$asyncGeneratorStep(n, t, e, r, o, a, c) {
    try {
        var i = n[a](c), u = i.value;
    } catch (n) {
        return void e(n);
    }
    i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function $67e6c506061ad6f7$export$2e2bcd8739ae039(n) {
    return function() {
        var t = this, e = arguments;
        return new Promise(function(r, o) {
            var a = n.apply(t, e);
            function _next(n) {
                $67e6c506061ad6f7$var$asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
            }
            function _throw(n) {
                $67e6c506061ad6f7$var$asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
            }
            _next(void 0);
        });
    };
}

});

parcelRegister("krGuf", function(module, exports) {
// TODO(Babel 8): Remove this file.

var $ee274949368961be$var$runtime = (parcelRequire("hFJK0"))();
module.exports = $ee274949368961be$var$runtime;
// Copied from https://github.com/facebook/regenerator/blob/main/packages/runtime/runtime.js#L736=
try {
    regeneratorRuntime = $ee274949368961be$var$runtime;
} catch (accidentalStrictMode) {
    if (typeof globalThis === "object") globalThis.regeneratorRuntime = $ee274949368961be$var$runtime;
    else Function("r", "regeneratorRuntime = r")($ee274949368961be$var$runtime);
}

});

parcelRegister("f3n4h", function(module, exports) {
$parcel$export(module.exports, "default", () => $af5907ad73894548$export$2e2bcd8739ae039);

var $7FJTB = parcelRequire("7FJTB");

var $dhZ1B = parcelRequire("dhZ1B");

var $aZa8T = parcelRequire("aZa8T");

var $hLfKH = parcelRequire("hLfKH");
function $af5907ad73894548$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $af5907ad73894548$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $af5907ad73894548$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $aZa8T.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $af5907ad73894548$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $af5907ad73894548$export$a66cbd9b2289cd78 = '@all-features';
var $af5907ad73894548$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function Subscriptions() {
        (0, $7FJTB.default)(this, Subscriptions);
        (0, $aZa8T.default)(this, "eventToValue", new Map());
        this.emitter = new (0, (/*@__PURE__*/$parcel$interopDefault($hLfKH)))();
    }
    return (0, $dhZ1B.default)(Subscriptions, [
        {
            key: "onGateUpdated",
            value: function onGateUpdated(gateName, callback, checkGate, options) {
                var _this = this;
                var value = checkGate(gateName, $af5907ad73894548$var$_objectSpread($af5907ad73894548$var$_objectSpread({}, options), {}, {
                    fireGateExposure: false
                }));
                if (this.eventToValue.get(callback) === undefined) this.eventToValue.set(callback, value);
                var wrapCallback = function wrapCallback() {
                    var value = checkGate(gateName, $af5907ad73894548$var$_objectSpread($af5907ad73894548$var$_objectSpread({}, options), {}, {
                        fireGateExposure: false
                    }));
                    var existingValue = _this.eventToValue.get(callback);
                    if (existingValue !== value) {
                        _this.eventToValue.set(callback, value);
                        callback(value);
                    }
                };
                this.emitter.on(gateName, wrapCallback);
                return function() {
                    _this.emitter.off(gateName, wrapCallback);
                };
            }
        },
        {
            key: "onExperimentValueUpdated",
            value: function onExperimentValueUpdated(experimentName, parameterName, defaultValue, callback, getExperimentValue, options) {
                var _this2 = this;
                var experimentEventName = "".concat(experimentName, ".").concat(parameterName);
                var value = getExperimentValue(experimentName, parameterName, defaultValue, $af5907ad73894548$var$_objectSpread($af5907ad73894548$var$_objectSpread({}, options), {}, {
                    fireExperimentExposure: false
                }));
                if (this.eventToValue.get(callback) === undefined) this.eventToValue.set(callback, value);
                var wrapCallback = function wrapCallback() {
                    var value = getExperimentValue(experimentName, parameterName, defaultValue, $af5907ad73894548$var$_objectSpread($af5907ad73894548$var$_objectSpread({}, options), {}, {
                        fireExperimentExposure: false
                    }));
                    var existingValue = _this2.eventToValue.get(callback);
                    if (existingValue !== value) {
                        _this2.eventToValue.set(callback, value);
                        callback(value);
                    }
                };
                this.emitter.on(experimentEventName, wrapCallback);
                return function() {
                    _this2.emitter.off(experimentEventName, wrapCallback);
                };
            }
        },
        {
            key: "onAnyUpdated",
            value: function onAnyUpdated(callback) {
                var _this3 = this;
                this.emitter.on($af5907ad73894548$export$a66cbd9b2289cd78, callback);
                return function() {
                    _this3.emitter.off($af5907ad73894548$export$a66cbd9b2289cd78, callback);
                };
            }
        },
        {
            key: "anyUpdated",
            value: function anyUpdated() {
                var _this4 = this;
                this.emitter.emit($af5907ad73894548$export$a66cbd9b2289cd78);
                this.emitter.eventNames().filter(function(name) {
                    return name !== $af5907ad73894548$export$a66cbd9b2289cd78;
                }).forEach(function(event) {
                    _this4.emitter.emit(event);
                });
            }
        }
    ]);
}();

});

parcelRegister("6c0Ti", function(module, exports) {
$parcel$export(module.exports, "DynamicConfig", () => $48248dfeb75baa43$export$6dc24881a3d96325);

var $86KR1 = parcelRequire("86KR1");

var $7FJTB = parcelRequire("7FJTB");

var $dhZ1B = parcelRequire("dhZ1B");

var $cu29X = parcelRequire("cu29X");
var $48248dfeb75baa43$export$6dc24881a3d96325 = /*#__PURE__*/ function() {
    function DynamicConfig(configName, configValue, ruleID, evaluationDetails) {
        var secondaryExposures = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : [];
        var allocatedExperimentName = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : '';
        var onDefaultValueFallback = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : null;
        (0, $7FJTB.default)(this, DynamicConfig);
        this.value = configValue;
        this._name = configName;
        this._ruleID = ruleID;
        this._secondaryExposures = secondaryExposures;
        this._allocatedExperimentName = allocatedExperimentName;
        this._evaluationDetails = evaluationDetails;
        this._onDefaultValueFallback = onDefaultValueFallback;
    }
    return (0, $dhZ1B.default)(DynamicConfig, [
        {
            key: "get",
            value: function get(key, defaultValue, typeGuard) {
                var _this$_onDefaultValue2;
                var val = this.getValue(key, defaultValue);
                if (val == null) return defaultValue;
                var expectedType = Array.isArray(defaultValue) ? 'array' : (0, $86KR1.default)(defaultValue);
                var actualType = Array.isArray(val) ? 'array' : (0, $86KR1.default)(val);
                if (typeGuard) {
                    var _this$_onDefaultValue;
                    if (typeGuard(val)) {
                        this.fireExposure(key);
                        return val;
                    }
                    (_this$_onDefaultValue = this._onDefaultValueFallback) === null || _this$_onDefaultValue === void 0 || _this$_onDefaultValue.call(this, this, key, expectedType, actualType);
                    return defaultValue;
                }
                if (defaultValue == null || expectedType === actualType) {
                    this.fireExposure(key);
                    return val;
                }
                (_this$_onDefaultValue2 = this._onDefaultValueFallback) === null || _this$_onDefaultValue2 === void 0 || _this$_onDefaultValue2.call(this, this, key, expectedType, actualType);
                return defaultValue;
            }
        },
        {
            key: "getValue",
            value: function getValue(key, defaultValue) {
                if (key == null) return this.value;
                if (defaultValue == null) defaultValue = null;
                if (this.value[key] == null) return defaultValue;
                this.fireExposure(key);
                return this.value[key];
            }
        },
        {
            key: "fireExposure",
            value: function fireExposure(key) {
                // Call the wrapped experiment's get method to fire exposure
                if (this.experiment) this.experiment.get(key);
            }
        }
    ], [
        {
            key: "fromExperiment",
            value: function fromExperiment(experiment) {
                var _experiment$__evaluat, _experiment$__evaluat2, _experiment$groupName;
                var config = new DynamicConfig(experiment.name, experiment.value, experiment.ruleID, (0, $cu29X.migrateEvaluationDetails)(experiment.details), (0, $cu29X.migrateSecondaryExposures)((_experiment$__evaluat = (_experiment$__evaluat2 = experiment.__evaluation) === null || _experiment$__evaluat2 === void 0 ? void 0 : _experiment$__evaluat2.secondary_exposures) !== null && _experiment$__evaluat !== void 0 ? _experiment$__evaluat : []), (_experiment$groupName = experiment.groupName) !== null && _experiment$groupName !== void 0 ? _experiment$groupName : undefined);
                config.experiment = experiment;
                return config;
            }
        }
    ]);
}();

});
parcelRegister("cu29X", function(module, exports) {
$parcel$export(module.exports, "getOptionsWithDefaults", () => $9169f63c9da13a43$export$d119b37e5f788b43);
$parcel$export(module.exports, "shallowEquals", () => $9169f63c9da13a43$export$fa1c2bbf4100b8bc);
$parcel$export(module.exports, "toStatsigUser", () => $9169f63c9da13a43$export$3dad1db244472f32);
$parcel$export(module.exports, "deepAssign", () => $9169f63c9da13a43$export$1148cb79ceecd5fa);
$parcel$export(module.exports, "migrateInitializationOptions", () => $9169f63c9da13a43$export$202946b690d26d22);
$parcel$export(module.exports, "migrateEvaluationDetails", () => $9169f63c9da13a43$export$18ad168d3dbac899);
$parcel$export(module.exports, "migrateSecondaryExposures", () => $9169f63c9da13a43$export$55fd683752d01e67);

var $86KR1 = parcelRequire("86KR1");

var $2ypGG = parcelRequire("2ypGG");

var $5jEYh = parcelRequire("5jEYh");

var $9xnax = parcelRequire("9xnax");

var $aZa8T = parcelRequire("aZa8T");

var $ilFNZ = parcelRequire("ilFNZ");

var $1E5FR = parcelRequire("1E5FR");

var $hyhGn = parcelRequire("hyhGn");
var $9169f63c9da13a43$var$_excluded = [
    "stableId"
], $9169f63c9da13a43$var$_excluded2 = [
    "api",
    "disableCurrentPageLogging",
    "loggingIntervalMillis",
    "loggingBufferMaxSize",
    "localMode",
    "eventLoggingApi",
    "eventLoggingApiForRetries",
    "disableLocalStorage",
    "ignoreWindowUndefined",
    "disableAllLogging",
    "initTimeoutMs",
    "disableNetworkKeepalive",
    "overrideStableID",
    "disableErrorLogging",
    "disableAutoMetricsLogging"
];
function $9169f63c9da13a43$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $9169f63c9da13a43$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $9169f63c9da13a43$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $aZa8T.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $9169f63c9da13a43$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $9169f63c9da13a43$export$d119b37e5f788b43 = function getOptionsWithDefaults(options) {
    return $9169f63c9da13a43$var$_objectSpread({
        /**
     * If more federal PerimeterTypes are added in the future, this should be updated so
     * that isFedRamp() === true always returns the strictest perimeter.
     */ perimeter: (0, $ilFNZ.isFedRamp)() ? (0, $hyhGn.PerimeterType).FEDRAMP_MODERATE : (0, $hyhGn.PerimeterType).COMMERCIAL
    }, options);
};
var $9169f63c9da13a43$export$fa1c2bbf4100b8bc = function shallowEquals(objectA, objectB) {
    if (!objectA && !objectB) return true;
    if (!objectA || !objectB) return false;
    var aEntries = Object.entries(objectA);
    var bEntries = Object.entries(objectB);
    if (aEntries.length !== bEntries.length) return false;
    var ascendingKeyOrder = function ascendingKeyOrder(_ref, _ref2) {
        var _ref3 = (0, $9xnax.default)(_ref, 1), key1 = _ref3[0];
        var _ref4 = (0, $9xnax.default)(_ref2, 1), key2 = _ref4[0];
        return key1.localeCompare(key2);
    };
    aEntries.sort(ascendingKeyOrder);
    bEntries.sort(ascendingKeyOrder);
    for(var i = 0; i < aEntries.length; i++){
        var _aEntries$i = (0, $9xnax.default)(aEntries[i], 2), aValue = _aEntries$i[1];
        var _bEntries$i = (0, $9xnax.default)(bEntries[i], 2), bValue = _bEntries$i[1];
        if (aValue !== bValue) return false;
    }
    return true;
};
var $9169f63c9da13a43$export$3dad1db244472f32 = function toStatsigUser(identifiers, customAttributes) {
    // Re-map `stableId` to `stableID` to match Statsig's native type.
    var stableId = identifiers.stableId, otherIdentifiers = (0, $5jEYh.default)(identifiers, $9169f63c9da13a43$var$_excluded);
    var user = {
        customIDs: $9169f63c9da13a43$var$_objectSpread($9169f63c9da13a43$var$_objectSpread({}, otherIdentifiers), stableId !== undefined ? {
            stableID: stableId
        } : {}),
        custom: customAttributes
    };
    if (identifiers.atlassianAccountId) user.userID = identifiers.atlassianAccountId;
    return user;
};
function $9169f63c9da13a43$export$1148cb79ceecd5fa(target) {
    for(var _len = arguments.length, sources = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)sources[_key - 1] = arguments[_key];
    if (!sources.length) return target;
    var source = sources.shift();
    if (source === undefined || source === null) return $9169f63c9da13a43$export$1148cb79ceecd5fa.apply(void 0, [
        target
    ].concat((0, $2ypGG.default)(sources)));
    for(var _i = 0, _Object$entries = Object.entries(source); _i < _Object$entries.length; _i++){
        var _Object$entries$_i = (0, $9xnax.default)(_Object$entries[_i], 2), key = _Object$entries$_i[0], src = _Object$entries$_i[1];
        var dst = target[key];
        var srcIsObj = src && (0, $86KR1.default)(src) === 'object' && !Array.isArray(src);
        var dstIsObj = dst && (0, $86KR1.default)(dst) === 'object' && !Array.isArray(dst);
        if (srcIsObj && dstIsObj) target[key] = $9169f63c9da13a43$export$1148cb79ceecd5fa(dst, src);
        else target[key] = src;
    }
    return $9169f63c9da13a43$export$1148cb79ceecd5fa.apply(void 0, [
        target
    ].concat((0, $2ypGG.default)(sources)));
}
var $9169f63c9da13a43$export$202946b690d26d22 = function migrateInitializationOptions(options) {
    var api = options.api, disableCurrentPageLogging = options.disableCurrentPageLogging, loggingIntervalMillis = options.loggingIntervalMillis, loggingBufferMaxSize = options.loggingBufferMaxSize, localMode = options.localMode, eventLoggingApi = options.eventLoggingApi, eventLoggingApiForRetries = options.eventLoggingApiForRetries, disableLocalStorage = options.disableLocalStorage, ignoreWindowUndefined = options.ignoreWindowUndefined, disableAllLogging = options.disableAllLogging, _initTimeoutMs = options.initTimeoutMs, _disableNetworkKeepalive = options.disableNetworkKeepalive, _overrideStableID = options.overrideStableID, _disableErrorLogging = options.disableErrorLogging, _disableAutoMetricsLogging = options.disableAutoMetricsLogging, rest = (0, $5jEYh.default)(options, $9169f63c9da13a43$var$_excluded2);
    return $9169f63c9da13a43$var$_objectSpread($9169f63c9da13a43$var$_objectSpread({}, rest), {}, {
        networkConfig: {
            api: api,
            logEventUrl: eventLoggingApi ? eventLoggingApi + 'rgstr' : undefined,
            logEventFallbackUrls: eventLoggingApiForRetries ? [
                eventLoggingApiForRetries
            ] : undefined,
            preventAllNetworkTraffic: localMode || !ignoreWindowUndefined && typeof window === 'undefined'
        },
        includeCurrentPageUrlWithEvents: !disableCurrentPageLogging,
        loggingIntervalMs: loggingIntervalMillis,
        loggingBufferMaxSize: loggingBufferMaxSize,
        disableStorage: disableLocalStorage === undefined ? localMode : disableLocalStorage,
        disableLogging: disableAllLogging === undefined ? localMode : disableAllLogging
    });
};
var $9169f63c9da13a43$var$evaluationReasonMappings = Object.entries((0, $1E5FR.EvaluationReason)).map(function(_ref5) {
    var _ref6 = (0, $9xnax.default)(_ref5, 2), key = _ref6[0], value = _ref6[1];
    return [
        key.toLowerCase(),
        value
    ];
});
var $9169f63c9da13a43$export$18ad168d3dbac899 = function migrateEvaluationDetails(details) {
    var _evaluationReasonMapp, _evaluationReasonMapp2, _details$receivedAt;
    var reasonLower = details.reason.toLowerCase();
    return {
        reason: (_evaluationReasonMapp = (_evaluationReasonMapp2 = $9169f63c9da13a43$var$evaluationReasonMappings.find(function(_ref7) {
            var _ref8 = (0, $9xnax.default)(_ref7, 1), key = _ref8[0];
            return reasonLower.includes(key);
        })) === null || _evaluationReasonMapp2 === void 0 ? void 0 : _evaluationReasonMapp2[1]) !== null && _evaluationReasonMapp !== void 0 ? _evaluationReasonMapp : (0, $1E5FR.EvaluationReason).Unknown,
        time: (_details$receivedAt = details.receivedAt) !== null && _details$receivedAt !== void 0 ? _details$receivedAt : Date.now()
    };
};
var $9169f63c9da13a43$export$55fd683752d01e67 = function migrateSecondaryExposures(secondaryExposures) {
    return secondaryExposures.map(function(exposure) {
        if (typeof exposure === 'string') // This should ideally have gateValue and ruleID fields too, but it's not possible for us
        // to determine the correct values for these.
        return {
            gate: exposure
        };
        return exposure;
    });
};

});
parcelRegister("2ypGG", function(module, exports) {
$parcel$export(module.exports, "default", () => $1dc2aeb9d9606c67$export$2e2bcd8739ae039);

var $25Nrq = parcelRequire("25Nrq");

var $6OJUg = parcelRequire("6OJUg");

var $c6wee = parcelRequire("c6wee");

var $d4oex = parcelRequire("d4oex");
function $1dc2aeb9d9606c67$export$2e2bcd8739ae039(r) {
    return (0, $25Nrq.default)(r) || (0, $6OJUg.default)(r) || (0, $c6wee.default)(r) || (0, $d4oex.default)();
}

});
parcelRegister("25Nrq", function(module, exports) {
$parcel$export(module.exports, "default", () => $1862667271b8eb12$export$2e2bcd8739ae039);

var $aWzVQ = parcelRequire("aWzVQ");
function $1862667271b8eb12$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return (0, $aWzVQ.default)(r);
}

});

parcelRegister("6OJUg", function(module, exports) {
$parcel$export(module.exports, "default", () => $4f6b05ab261af41b$export$2e2bcd8739ae039);
function $4f6b05ab261af41b$export$2e2bcd8739ae039(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}

});

parcelRegister("d4oex", function(module, exports) {
$parcel$export(module.exports, "default", () => $983e725986da7066$export$2e2bcd8739ae039);
function $983e725986da7066$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});


parcelRegister("ilFNZ", function(module, exports) {
$parcel$export(module.exports, "isFedRamp", () => $d5ba9dcfc96c52dc$export$64d6499adf9b2e51);

var $kQa3X = parcelRequire("kQa3X");
function $d5ba9dcfc96c52dc$export$64d6499adf9b2e51() {
    var _global$location;
    var global = globalThis;
    // MICROS_PERIMETER is already used by few products, so we need to keep it for backward compatibility
    var env = global.MICROS_PERIMETER || global.UNSAFE_ATL_CONTEXT_BOUNDARY;
    if (env) return env === (0, $kQa3X.FEDRAMP_MODERATE);
    var matches = (_global$location = global.location) === null || _global$location === void 0 || (_global$location = _global$location.hostname) === null || _global$location === void 0 ? void 0 : _global$location.match(/atlassian-us-gov-mod\.(com|net)|atlassian-us-gov\.(com|net)|atlassian-fex\.(com|net)|atlassian-stg-fedm\.(com|net)/);
    return matches ? matches.length > 0 : false;
}

});
parcelRegister("kQa3X", function(module, exports) {
$parcel$export(module.exports, "FEDRAMP_MODERATE", () => $f2c0783aa9abef56$export$ce553301d55c2fd8);
var $f2c0783aa9abef56$export$ce553301d55c2fd8 = 'fedramp-moderate';
var $f2c0783aa9abef56$export$f005e2e9f707cb5f = 'commercial';
var $f2c0783aa9abef56$export$bd6b5a7802d76127 = 'fedramp-fedex';
var $f2c0783aa9abef56$export$a739cd5aac835909 = 'stg';
var $f2c0783aa9abef56$export$42dd0cdd351a4a9 = 'prod';
var $f2c0783aa9abef56$export$404582bc18fe4d9e = 'dev';

});


parcelRegister("1E5FR", function(module, exports) {
$parcel$export(module.exports, "EvaluationReason", () => $132deda36a5182c5$export$c62558b199e46828);
// Reference: https://github.com/statsig-io/js-lite/blob/main/src/StatsigStore.ts
var $132deda36a5182c5$export$c62558b199e46828 = {
    // Order is important since the logic for migrating from a new client reason to an old one
    // returns the first which is a substring of the new client reason
    Error: 'Error',
    LocalOverride: 'LocalOverride',
    Unrecognized: 'Unrecognized',
    Uninitialized: 'Uninitialized',
    NetworkNotModified: 'NetworkNotModified',
    Network: 'Network',
    InvalidBootstrap: 'InvalidBootstrap',
    Bootstrap: 'Bootstrap',
    Cache: 'Cache',
    // For when we could not migrate the reason from the new client
    Unknown: 'Unknown'
}; // Reference: https://github.com/statsig-io/js-lite/blob/main/src/StatsigSDKOptions.ts

});

parcelRegister("hyhGn", function(module, exports) {
$parcel$export(module.exports, "FeatureGateEnvironment", () => $cc7354002ee6aca5$export$479e7351a733299);
$parcel$export(module.exports, "PerimeterType", () => $cc7354002ee6aca5$export$c42b7bbc5e7ba555);
/**
 * The identifiers for the user. Options are restricted to the set that is currently supported.
 */ /**
 * Base client options. Does not include any options specific to providers
 * @interface BaseClientOptions
 * @property {FeatureGateEnvironment} environment - The environment for the client.
 * @property {string} targetApp - The target app for the client.
 * @property {AnalyticsWebClient} analyticsWebClient - The analytics web client.
 * @property {PerimeterType} perimeter - The perimeter for the client.
 */ /**
 * The options for the client.
 * @interface ClientOptions
 * @extends {BaseClientOptions}
 * @property {string} apiKey - The API key for the client.
 * @property {fetchTimeoutMs} fetchTimeoutMs - The timeout for the fetch request in milliseconds. Defaults to 5000.
 * @property {boolean} useGatewayURL - Whether to use the gateway URL. Defaults to false.
 */ /**
 * The custom attributes for the user.
 */ var $cc7354002ee6aca5$export$479e7351a733299 = {
    Development: 'development',
    Staging: 'staging',
    Production: 'production'
};
var $cc7354002ee6aca5$export$c42b7bbc5e7ba555 = {
    COMMERCIAL: 'commercial',
    FEDRAMP_MODERATE: 'fedramp-moderate'
};
var $cc7354002ee6aca5$export$42f4885608027d0c = 'non_boolean'; // Type magic to get the JSDoc comments from the Client class methods to appear on the static
 // methods in FeatureGates where the property name and function type are identical

});



parcelRegister("eFXVC", function(module, exports) {
$parcel$export(module.exports, "Layer", () => $aaf3618a6ed8a1ec$export$936d0764594b6eb3);

var $86KR1 = parcelRequire("86KR1");

var $7FJTB = parcelRequire("7FJTB");

var $dhZ1B = parcelRequire("dhZ1B");

var $cu29X = parcelRequire("cu29X");
var $aaf3618a6ed8a1ec$export$936d0764594b6eb3 = /*#__PURE__*/ function() {
    function Layer(name, layerValue, ruleID, evaluationDetails) {
        var logParameterFunction = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;
        var secondaryExposures = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : [];
        var undelegatedSecondaryExposures = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : [];
        var allocatedExperimentName = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : '';
        var explicitParameters = arguments.length > 8 && arguments[8] !== undefined ? arguments[8] : [];
        (0, $7FJTB.default)(this, Layer);
        this._logParameterFunction = logParameterFunction;
        this._name = name;
        this._value = JSON.parse(JSON.stringify(layerValue !== null && layerValue !== void 0 ? layerValue : {}));
        this._ruleID = ruleID !== null && ruleID !== void 0 ? ruleID : '';
        this._evaluationDetails = evaluationDetails;
        this._secondaryExposures = secondaryExposures;
        this._undelegatedSecondaryExposures = undelegatedSecondaryExposures;
        this._allocatedExperimentName = allocatedExperimentName;
        this._explicitParameters = explicitParameters;
    }
    return (0, $dhZ1B.default)(Layer, [
        {
            key: "get",
            value: function get(key, defaultValue, typeGuard) {
                var _this = this;
                var val = this._value[key];
                if (val == null) return defaultValue;
                var logAndReturn = function logAndReturn() {
                    _this._logLayerParameterExposure(key);
                    return val;
                };
                if (typeGuard) return typeGuard(val) ? logAndReturn() : defaultValue;
                if (defaultValue == null) return logAndReturn();
                if ((0, $86KR1.default)(val) === (0, $86KR1.default)(defaultValue) && Array.isArray(defaultValue) === Array.isArray(val)) return logAndReturn();
                return defaultValue;
            }
        },
        {
            key: "getValue",
            value: function getValue(key, defaultValue) {
                // eslint-disable-next-line eqeqeq
                if (defaultValue == undefined) defaultValue = null;
                var val = this._value[key];
                if (val != null) this._logLayerParameterExposure(key);
                return val !== null && val !== void 0 ? val : defaultValue;
            }
        },
        {
            key: "_logLayerParameterExposure",
            value: function _logLayerParameterExposure(parameterName) {
                var _this$_logParameterFu;
                (_this$_logParameterFu = this._logParameterFunction) === null || _this$_logParameterFu === void 0 || _this$_logParameterFu.call(this, this, parameterName);
            }
        }
    ], [
        {
            key: "fromLayer",
            value: function fromLayer(layer) {
                var _layer$__evaluation$s, _layer$__evaluation, _layer$__evaluation$u, _layer$__evaluation2, _layer$__evaluation3, _layer$__evaluation4;
                var value = new Layer(layer.name, layer.__value, layer.ruleID, (0, $cu29X.migrateEvaluationDetails)(layer.details), function(_layer, parameterName) {
                    return layer.get(parameterName);
                }, (0, $cu29X.migrateSecondaryExposures)((_layer$__evaluation$s = (_layer$__evaluation = layer.__evaluation) === null || _layer$__evaluation === void 0 ? void 0 : _layer$__evaluation.secondary_exposures) !== null && _layer$__evaluation$s !== void 0 ? _layer$__evaluation$s : []), (0, $cu29X.migrateSecondaryExposures)((_layer$__evaluation$u = (_layer$__evaluation2 = layer.__evaluation) === null || _layer$__evaluation2 === void 0 ? void 0 : _layer$__evaluation2.undelegated_secondary_exposures) !== null && _layer$__evaluation$u !== void 0 ? _layer$__evaluation$u : []), (_layer$__evaluation3 = layer.__evaluation) === null || _layer$__evaluation3 === void 0 ? void 0 : _layer$__evaluation3.allocated_experiment_name, (_layer$__evaluation4 = layer.__evaluation) === null || _layer$__evaluation4 === void 0 ? void 0 : _layer$__evaluation4.explicit_parameters);
                return value;
            }
        }
    ]);
}();

});

parcelRegister("dSUrF", function(module, exports) {
$parcel$export(module.exports, "default", () => $a1bc1a5bf5627dce$export$2e2bcd8739ae039);

var $aZa8T = parcelRequire("aZa8T");

var $8V41E = parcelRequire("8V41E");

var $7FJTB = parcelRequire("7FJTB");

var $dhZ1B = parcelRequire("dhZ1B");

var $krGuf = parcelRequire("krGuf");

var $hyhGn = parcelRequire("hyhGn");

var $1ZXvG = parcelRequire("1ZXvG");

var $eosR3 = parcelRequire("eosR3");
function $a1bc1a5bf5627dce$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $a1bc1a5bf5627dce$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $a1bc1a5bf5627dce$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $aZa8T.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $a1bc1a5bf5627dce$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $a1bc1a5bf5627dce$var$DEFAULT_REQUEST_TIMEOUT_MS = 5000;
var $a1bc1a5bf5627dce$export$250a58ecde616daa = 'https://api.atlassian.com/flags';
var $a1bc1a5bf5627dce$export$942ba04389b0d5a2 = 'https://api.stg.atlassian.com/flags';
var $a1bc1a5bf5627dce$export$f058dbf75c3bc647 = 'https://api.dev.atlassian.com/flags';
var $a1bc1a5bf5627dce$export$1a401a0da8da3565 = 'https://api.stg.atlassian-us-gov-mod.com/flags';
var $a1bc1a5bf5627dce$export$18c93900db9358a4 = 'https://api.atlassian-us-gov-mod.com/flags';
var $a1bc1a5bf5627dce$export$4e8a0415edbfa1f7 = 'https://atlassian-statsig-proxy-archetype.atl-paas.%s.atl-ic.net';
var $a1bc1a5bf5627dce$export$cb3cd156f70d7e94 = 'oasis-stg.com/flags';
var $a1bc1a5bf5627dce$export$921fbc6cdfd4eee0 = 'atlassian-isolated.net/flags';
var $a1bc1a5bf5627dce$export$450bd8fb2a6d7ace = '/gateway/api/flags';
var $a1bc1a5bf5627dce$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function Fetcher() {
        (0, $7FJTB.default)(this, Fetcher);
    }
    return (0, $dhZ1B.default)(Fetcher, null, [
        {
            key: "fetchClientSdk",
            value: function() {
                var _fetchClientSdk = (0, $8V41E.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($krGuf))).mark(function _callee(fetcherOptions) {
                    var targetApp, url, _t;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($krGuf))).wrap(function(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                targetApp = fetcherOptions.targetApp;
                                url = "/api/v2/frontend/clientSdkKey/".concat(targetApp);
                                _context.prev = 1;
                                _context.next = 2;
                                return this.fetchRequest(url, 'GET', fetcherOptions);
                            case 2:
                                return _context.abrupt("return", _context.sent);
                            case 3:
                                _context.prev = 3;
                                _t = _context["catch"](1);
                                if (!(_t instanceof Error)) {
                                    _context.next = 4;
                                    break;
                                }
                                throw _t;
                            case 4:
                                throw Error('Failed to retrieve client sdk key');
                            case 5:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee, this, [
                        [
                            1,
                            3
                        ]
                    ]);
                }));
                function fetchClientSdk(_x) {
                    return _fetchClientSdk.apply(this, arguments);
                }
                return fetchClientSdk;
            }()
        },
        {
            key: "fetchExperimentValues",
            value: function() {
                var _fetchExperimentValues = (0, $8V41E.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($krGuf))).mark(function _callee2(fetcherOptions, identifiers, customAttributes) {
                    var requestBody, _t2;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($krGuf))).wrap(function(_context2) {
                        while(true)switch(_context2.prev = _context2.next){
                            case 0:
                                requestBody = {
                                    identifiers: identifiers,
                                    customAttributes: customAttributes,
                                    targetApp: fetcherOptions.targetApp
                                };
                                _context2.prev = 1;
                                _context2.next = 2;
                                return this.fetchRequest('/api/v2/frontend/experimentValues', 'POST', fetcherOptions, requestBody);
                            case 2:
                                return _context2.abrupt("return", _context2.sent);
                            case 3:
                                _context2.prev = 3;
                                _t2 = _context2["catch"](1);
                                if (!(_t2 instanceof Error)) {
                                    _context2.next = 4;
                                    break;
                                }
                                throw _t2;
                            case 4:
                                throw Error('Failed to retrieve experiment values');
                            case 5:
                            case "end":
                                return _context2.stop();
                        }
                    }, _callee2, this, [
                        [
                            1,
                            3
                        ]
                    ]);
                }));
                function fetchExperimentValues(_x2, _x3, _x4) {
                    return _fetchExperimentValues.apply(this, arguments);
                }
                return fetchExperimentValues;
            }()
        },
        {
            key: "handleResponseError",
            value: function() {
                var _handleResponseError = (0, $8V41E.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($krGuf))).mark(function _callee3(response) {
                    var body;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($krGuf))).wrap(function(_context3) {
                        while(true)switch(_context3.prev = _context3.next){
                            case 0:
                                if (response.ok) {
                                    _context3.next = 2;
                                    break;
                                }
                                _context3.next = 1;
                                return response.text();
                            case 1:
                                body = _context3.sent;
                                throw new (0, $eosR3.ResponseError)("Non 2xx response status received, status: ".concat(response.status, ", body: ").concat(JSON.stringify(body)));
                            case 2:
                                if (!(response.status === 204)) {
                                    _context3.next = 3;
                                    break;
                                }
                                throw new (0, $eosR3.ResponseError)('Unexpected 204 response');
                            case 3:
                            case "end":
                                return _context3.stop();
                        }
                    }, _callee3);
                }));
                function handleResponseError(_x5) {
                    return _handleResponseError.apply(this, arguments);
                }
                return handleResponseError;
            }()
        },
        {
            key: "extractResponseBody",
            value: function() {
                var _extractResponseBody = (0, $8V41E.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($krGuf))).mark(function _callee4(response) {
                    var value;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($krGuf))).wrap(function(_context4) {
                        while(true)switch(_context4.prev = _context4.next){
                            case 0:
                                _context4.next = 1;
                                return response.text();
                            case 1:
                                value = _context4.sent;
                                return _context4.abrupt("return", JSON.parse(value));
                            case 2:
                            case "end":
                                return _context4.stop();
                        }
                    }, _callee4);
                }));
                function extractResponseBody(_x6) {
                    return _extractResponseBody.apply(this, arguments);
                }
                return extractResponseBody;
            }()
        },
        {
            key: "getBaseUrl",
            value: function getBaseUrl(serviceEnv) {
                var useGatewayUrl = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
                var perimeter = arguments.length > 2 ? arguments[2] : undefined;
                var isolationContextId = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
                if (useGatewayUrl) return $a1bc1a5bf5627dce$export$450bd8fb2a6d7ace;
                if (perimeter === (0, $hyhGn.PerimeterType).FEDRAMP_MODERATE) switch(serviceEnv){
                    case (0, $hyhGn.FeatureGateEnvironment).Production:
                        return $a1bc1a5bf5627dce$export$18c93900db9358a4;
                    case (0, $hyhGn.FeatureGateEnvironment).Staging:
                        return $a1bc1a5bf5627dce$export$1a401a0da8da3565;
                    default:
                        throw new Error("Invalid environment \"".concat(serviceEnv, "\" for \"").concat(perimeter, "\" perimeter"));
                }
                else if (perimeter === (0, $hyhGn.PerimeterType).COMMERCIAL) switch(serviceEnv){
                    case (0, $hyhGn.FeatureGateEnvironment).Development:
                        return $a1bc1a5bf5627dce$export$f058dbf75c3bc647;
                    case (0, $hyhGn.FeatureGateEnvironment).Staging:
                        var apiUrl = this.getApiUrl(isolationContextId);
                        if (apiUrl !== null) return apiUrl;
                        return $a1bc1a5bf5627dce$export$942ba04389b0d5a2;
                    default:
                        var prodApiUrl = this.getApiUrl(isolationContextId);
                        if (prodApiUrl !== null) return prodApiUrl;
                        return $a1bc1a5bf5627dce$export$250a58ecde616daa;
                }
                else throw new Error("Invalid perimeter \"".concat(perimeter, "\""));
            }
        },
        {
            key: "fetchRequest",
            value: function() {
                var _fetchRequest = (0, $8V41E.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($krGuf))).mark(function _callee5(path, method, fetcherOptions, body) {
                    var baseUrl, fetchTimeout, abortSignal, abortController, response;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($krGuf))).wrap(function(_context5) {
                        while(true)switch(_context5.prev = _context5.next){
                            case 0:
                                baseUrl = Fetcher.getBaseUrl(fetcherOptions.environment, fetcherOptions.useGatewayURL, fetcherOptions.perimeter, fetcherOptions.isolationContextId);
                                fetchTimeout = fetcherOptions.fetchTimeoutMs || $a1bc1a5bf5627dce$var$DEFAULT_REQUEST_TIMEOUT_MS;
                                if (AbortSignal.timeout) abortSignal = AbortSignal.timeout(fetchTimeout);
                                else if (AbortController) {
                                    abortController = new AbortController();
                                    abortSignal = abortController.signal;
                                    setTimeout(function() {
                                        return abortController.abort();
                                    }, fetchTimeout);
                                }
                                _context5.next = 1;
                                return fetch("".concat(baseUrl).concat(path), $a1bc1a5bf5627dce$var$_objectSpread({
                                    method: method,
                                    headers: {
                                        'Content-Type': 'application/json',
                                        'X-Client-Name': 'feature-gate-js-client',
                                        'X-Client-Version': (0, $1ZXvG.CLIENT_VERSION),
                                        'X-API-KEY': fetcherOptions.apiKey
                                    },
                                    signal: abortSignal
                                }, body && {
                                    body: JSON.stringify(body)
                                }));
                            case 1:
                                response = _context5.sent;
                                _context5.next = 2;
                                return this.handleResponseError(response);
                            case 2:
                                _context5.next = 3;
                                return this.extractResponseBody(response);
                            case 3:
                                return _context5.abrupt("return", _context5.sent);
                            case 4:
                            case "end":
                                return _context5.stop();
                        }
                    }, _callee5, this);
                }));
                function fetchRequest(_x7, _x8, _x9, _x0) {
                    return _fetchRequest.apply(this, arguments);
                }
                return fetchRequest;
            }()
        },
        {
            key: "getApiUrl",
            value: function getApiUrl(isolationContextId) {
                var window1 = this.getWindowLocation();
                if (window1 === undefined) {
                    //this is needed when this SDK is used for SSR or plugin use cases where secret keys not available to use backend SDKs
                    if (!isolationContextId) return null;
                    return $a1bc1a5bf5627dce$export$4e8a0415edbfa1f7.replace('%s', isolationContextId);
                }
                var protocol = window1.protocol, hostname = window1.hostname;
                // Match last subdomain fragment before oasis-stg.com
                var oasisMatch = hostname.match(/([^.]+)\.oasis-stg\.com$/);
                if (oasisMatch) return "".concat(protocol, "//api.").concat(oasisMatch[1], ".").concat($a1bc1a5bf5627dce$export$cb3cd156f70d7e94);
                // Match last subdomain fragment before atlassian-isolated.net
                var isolatedMatch = hostname.match(/([^.]+)\.atlassian-isolated\.net$/);
                if (isolatedMatch) return "".concat(protocol, "//api.").concat(isolatedMatch[1], ".").concat($a1bc1a5bf5627dce$export$921fbc6cdfd4eee0);
                return null;
            }
        },
        {
            key: "getWindowLocation",
            value: function getWindowLocation() {
                if (typeof window !== 'undefined' && window.location) return window.location;
                return undefined;
            }
        }
    ]);
}();

});
parcelRegister("1ZXvG", function(module, exports) {
$parcel$export(module.exports, "CLIENT_VERSION", () => $1749a66aa1ca4cfa$export$a59f8d67326bd1cb);
/// <reference types="node" />
var $1749a66aa1ca4cfa$export$a59f8d67326bd1cb = "5.8.0";

});

parcelRegister("eosR3", function(module, exports) {
$parcel$export(module.exports, "ResponseError", () => $a7a9b084f557d276$export$286baf652d0b1206);

var $dhZ1B = parcelRequire("dhZ1B");

var $7FJTB = parcelRequire("7FJTB");

var $4MOeb = parcelRequire("4MOeb");

var $aawNP = parcelRequire("aawNP");

var $jTzgi = parcelRequire("jTzgi");

var $j4tjv = parcelRequire("j4tjv");
function $a7a9b084f557d276$var$_callSuper(t, o, e) {
    return o = (0, $aawNP.default)(o), (0, $4MOeb.default)(t, $a7a9b084f557d276$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, $aawNP.default)(t).constructor) : o.apply(t, e));
}
function $a7a9b084f557d276$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($a7a9b084f557d276$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $a7a9b084f557d276$export$286baf652d0b1206 = /*#__PURE__*/ function(_Error) {
    function ResponseError(message) {
        (0, $7FJTB.default)(this, ResponseError);
        return $a7a9b084f557d276$var$_callSuper(this, ResponseError, [
            message
        ]);
    }
    (0, $jTzgi.default)(ResponseError, _Error);
    return (0, $dhZ1B.default)(ResponseError);
}(/*#__PURE__*/ (0, $j4tjv.default)(Error));

});
parcelRegister("4MOeb", function(module, exports) {
$parcel$export(module.exports, "default", () => $37c29b53b51a9d76$export$2e2bcd8739ae039);

var $86KR1 = parcelRequire("86KR1");

var $RLquA = parcelRequire("RLquA");
function $37c29b53b51a9d76$export$2e2bcd8739ae039(t, e) {
    if (e && ("object" == (0, $86KR1.default)(e) || "function" == typeof e)) return e;
    if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
    return (0, $RLquA.default)(t);
}

});
parcelRegister("RLquA", function(module, exports) {
$parcel$export(module.exports, "default", () => $0a19bd39fdbc9944$export$2e2bcd8739ae039);
function $0a19bd39fdbc9944$export$2e2bcd8739ae039(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
}

});


parcelRegister("aawNP", function(module, exports) {
$parcel$export(module.exports, "default", () => $76744881e23437bb$export$2e2bcd8739ae039);
function $76744881e23437bb$export$2e2bcd8739ae039(t) {
    return $76744881e23437bb$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
        return t.__proto__ || Object.getPrototypeOf(t);
    }, $76744881e23437bb$export$2e2bcd8739ae039(t);
}

});

parcelRegister("jTzgi", function(module, exports) {
$parcel$export(module.exports, "default", () => $e7be81a542015542$export$2e2bcd8739ae039);

var $bCN8q = parcelRequire("bCN8q");
function $e7be81a542015542$export$2e2bcd8739ae039(t, e) {
    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
    t.prototype = Object.create(e && e.prototype, {
        constructor: {
            value: t,
            writable: !0,
            configurable: !0
        }
    }), Object.defineProperty(t, "prototype", {
        writable: !1
    }), e && (0, $bCN8q.default)(t, e);
}

});
parcelRegister("bCN8q", function(module, exports) {
$parcel$export(module.exports, "default", () => $87695b7a9946ac50$export$2e2bcd8739ae039);
function $87695b7a9946ac50$export$2e2bcd8739ae039(t, e) {
    return $87695b7a9946ac50$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, $87695b7a9946ac50$export$2e2bcd8739ae039(t, e);
}

});


parcelRegister("j4tjv", function(module, exports) {
$parcel$export(module.exports, "default", () => $de25211c14e68ec7$export$2e2bcd8739ae039);

var $aawNP = parcelRequire("aawNP");

var $bCN8q = parcelRequire("bCN8q");

var $ls9LV = parcelRequire("ls9LV");

var $fv5xe = parcelRequire("fv5xe");
function $de25211c14e68ec7$export$2e2bcd8739ae039(t) {
    var r = "function" == typeof Map ? new Map() : void 0;
    return $de25211c14e68ec7$export$2e2bcd8739ae039 = function _wrapNativeSuper(t) {
        if (null === t || !(0, $ls9LV.default)(t)) return t;
        if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function");
        if (void 0 !== r) {
            if (r.has(t)) return r.get(t);
            r.set(t, Wrapper);
        }
        function Wrapper() {
            return (0, $fv5xe.default)(t, arguments, (0, $aawNP.default)(this).constructor);
        }
        return Wrapper.prototype = Object.create(t.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: !1,
                writable: !0,
                configurable: !0
            }
        }), (0, $bCN8q.default)(Wrapper, t);
    }, $de25211c14e68ec7$export$2e2bcd8739ae039(t);
}

});
parcelRegister("ls9LV", function(module, exports) {
$parcel$export(module.exports, "default", () => $f9e3cb06225fdde0$export$2e2bcd8739ae039);
function $f9e3cb06225fdde0$export$2e2bcd8739ae039(t) {
    try {
        return -1 !== Function.toString.call(t).indexOf("[native code]");
    } catch (n) {
        return "function" == typeof t;
    }
}

});

parcelRegister("fv5xe", function(module, exports) {
$parcel$export(module.exports, "default", () => $b48e0b625c0c5f99$export$2e2bcd8739ae039);

var $ihiNI = parcelRequire("ihiNI");

var $bCN8q = parcelRequire("bCN8q");
function $b48e0b625c0c5f99$export$2e2bcd8739ae039(t, e, r) {
    if ((0, $ihiNI.default)()) return Reflect.construct.apply(null, arguments);
    var o = [
        null
    ];
    o.push.apply(o, e);
    var p = new (t.bind.apply(t, o))();
    return r && (0, $bCN8q.default)(p, r.prototype), p;
}

});
parcelRegister("ihiNI", function(module, exports) {
$parcel$export(module.exports, "default", () => $d4e865ffeeaf46b3$export$2e2bcd8739ae039);
function $d4e865ffeeaf46b3$export$2e2bcd8739ae039() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($d4e865ffeeaf46b3$export$2e2bcd8739ae039 = function _isNativeReflectConstruct() {
        return !!t;
    })();
}

});





parcelRegister("lEXVk", function(module, exports) {
$parcel$export(module.exports, "NoFetchDataAdapter", () => $fc4bd103a9c0542c$export$55fffef3474104af);

var $8V41E = parcelRequire("8V41E");

var $7FJTB = parcelRequire("7FJTB");

var $dhZ1B = parcelRequire("dhZ1B");

var $4MOeb = parcelRequire("4MOeb");

var $aawNP = parcelRequire("aawNP");

var $e0E0o = parcelRequire("e0E0o");

var $jTzgi = parcelRequire("jTzgi");

var $aZa8T = parcelRequire("aZa8T");

var $krGuf = parcelRequire("krGuf");

var $iFR7a = parcelRequire("iFR7a");
function $fc4bd103a9c0542c$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $fc4bd103a9c0542c$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $fc4bd103a9c0542c$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $aZa8T.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $fc4bd103a9c0542c$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $fc4bd103a9c0542c$var$_callSuper(t, o, e) {
    return o = (0, $aawNP.default)(o), (0, $4MOeb.default)(t, $fc4bd103a9c0542c$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, $aawNP.default)(t).constructor) : o.apply(t, e));
}
function $fc4bd103a9c0542c$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($fc4bd103a9c0542c$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $fc4bd103a9c0542c$var$_superPropGet(t, o, e, r) {
    var p = (0, $e0E0o.default)((0, $aawNP.default)(1 & r ? t.prototype : t), o, e);
    return 2 & r && "function" == typeof p ? function(t) {
        return p.apply(e, t);
    } : p;
}
var $fc4bd103a9c0542c$export$55fffef3474104af = /*#__PURE__*/ function(_DataAdapterCore) {
    function NoFetchDataAdapter() {
        var _this;
        (0, $7FJTB.default)(this, NoFetchDataAdapter);
        _this = $fc4bd103a9c0542c$var$_callSuper(this, NoFetchDataAdapter, [
            'NoFetchDataAdapter',
            'nofetch'
        ]);
        (0, $aZa8T.default)(_this, "bootstrapResult", null);
        return _this;
    }
    /**
   * Make sure to call this **before** calling `initializeAsync` or `updateUserAsync` but
   * after the Statsig client has been created!
   */ (0, $jTzgi.default)(NoFetchDataAdapter, _DataAdapterCore);
    return (0, $dhZ1B.default)(NoFetchDataAdapter, [
        {
            key: "setBootstrapData",
            value: function setBootstrapData(data) {
                this.bootstrapResult = data ? {
                    source: 'Bootstrap',
                    data: JSON.stringify(data),
                    receivedAt: Date.now(),
                    stableID: (0, $iFR7a.StableID).get(this._getSdkKey()),
                    fullUserHash: null
                } : null;
            }
        },
        {
            key: "prefetchData",
            value: function() {
                var _prefetchData = (0, $8V41E.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($krGuf))).mark(function _callee(_user, _options) {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($krGuf))).wrap(function(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee);
                }));
                function prefetchData(_x, _x2) {
                    return _prefetchData.apply(this, arguments);
                }
                return prefetchData;
            }()
        },
        {
            key: "getDataAsync",
            value: function() {
                var _getDataAsync = (0, $8V41E.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($krGuf))).mark(function _callee2(_current, user, _options) {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($krGuf))).wrap(function(_context2) {
                        while(true)switch(_context2.prev = _context2.next){
                            case 0:
                                return _context2.abrupt("return", this.bootstrapResult && $fc4bd103a9c0542c$var$_objectSpread($fc4bd103a9c0542c$var$_objectSpread({}, this.bootstrapResult), {}, {
                                    fullUserHash: (0, $iFR7a._getFullUserHash)(user)
                                }));
                            case 1:
                            case "end":
                                return _context2.stop();
                        }
                    }, _callee2, this);
                }));
                function getDataAsync(_x3, _x4, _x5) {
                    return _getDataAsync.apply(this, arguments);
                }
                return getDataAsync;
            }()
        },
        {
            key: "getDataSync",
            value: function getDataSync(user) {
                return this.bootstrapResult && $fc4bd103a9c0542c$var$_objectSpread($fc4bd103a9c0542c$var$_objectSpread({}, this.bootstrapResult), {}, {
                    fullUserHash: (0, $iFR7a._getFullUserHash)(user)
                });
            }
        },
        {
            key: "_fetchFromNetwork",
            value: function() {
                var _fetchFromNetwork2 = (0, $8V41E.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($krGuf))).mark(function _callee3(_current, _user, _options) {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($krGuf))).wrap(function(_context3) {
                        while(true)switch(_context3.prev = _context3.next){
                            case 0:
                                return _context3.abrupt("return", null);
                            case 1:
                            case "end":
                                return _context3.stop();
                        }
                    }, _callee3);
                }));
                function _fetchFromNetwork(_x6, _x7, _x8) {
                    return _fetchFromNetwork2.apply(this, arguments);
                }
                return _fetchFromNetwork;
            }()
        },
        {
            key: "_getCacheKey",
            value: function _getCacheKey(user) {
                // Same logic as default data adapter
                // https://github.com/statsig-io/js-client-monorepo/blob/main/packages/js-client/src/StatsigEvaluationsDataAdapter.ts
                var key = (0, $iFR7a._getStorageKey)(this._getSdkKey(), user);
                return "".concat((0, $iFR7a.DataAdapterCachePrefix), ".").concat(this._cacheSuffix, ".").concat(key);
            }
        },
        {
            key: "_isCachedResultValidFor204",
            value: function _isCachedResultValidFor204(_result, _user) {
                return false;
            }
        },
        {
            key: "setDataLegacy",
            value: function setDataLegacy(data, user) {
                $fc4bd103a9c0542c$var$_superPropGet(NoFetchDataAdapter, "setData", this, 3)([
                    data,
                    user
                ]);
            }
        },
        {
            key: "toJSON",
            value: function toJSON() {
                var result = $fc4bd103a9c0542c$var$_objectSpread({}, this);
                delete result._options;
                delete result._inMemoryCache;
                delete result.bootstrapResult;
                return result;
            }
        }
    ]);
}((0, $iFR7a.DataAdapterCore));

});
parcelRegister("e0E0o", function(module, exports) {
$parcel$export(module.exports, "default", () => $a33018fe656b0e1f$export$2e2bcd8739ae039);

var $311mr = parcelRequire("311mr");
function $a33018fe656b0e1f$export$2e2bcd8739ae039() {
    return $a33018fe656b0e1f$export$2e2bcd8739ae039 = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function(e, t, r) {
        var p = (0, $311mr.default)(e, t);
        if (p) {
            var n = Object.getOwnPropertyDescriptor(p, t);
            return n.get ? n.get.call(arguments.length < 3 ? e : r) : n.value;
        }
    }, $a33018fe656b0e1f$export$2e2bcd8739ae039.apply(null, arguments);
}

});
parcelRegister("311mr", function(module, exports) {
$parcel$export(module.exports, "default", () => $2322855c13ed5cf9$export$2e2bcd8739ae039);

var $aawNP = parcelRequire("aawNP");
function $2322855c13ed5cf9$export$2e2bcd8739ae039(t, o) {
    for(; !({}).hasOwnProperty.call(t, o) && null !== (t = (0, $aawNP.default)(t)););
    return t;
}

});



parcelRegister("imHDk", function(module, exports) {
$parcel$export(module.exports, "LOCAL_STORAGE_KEY", () => $d5ec20c2e57ca15d$export$d8474cff104280f3);
$parcel$export(module.exports, "PersistentOverrideAdapter", () => $d5ec20c2e57ca15d$export$bcb28fbac1def494);

var $aZa8T = parcelRequire("aZa8T");

var $9xnax = parcelRequire("9xnax");

var $7FJTB = parcelRequire("7FJTB");

var $dhZ1B = parcelRequire("dhZ1B");

var $dtn6l = parcelRequire("dtn6l");
function $d5ec20c2e57ca15d$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $d5ec20c2e57ca15d$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $d5ec20c2e57ca15d$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $aZa8T.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $d5ec20c2e57ca15d$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $d5ec20c2e57ca15d$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $d5ec20c2e57ca15d$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $d5ec20c2e57ca15d$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $d5ec20c2e57ca15d$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $d5ec20c2e57ca15d$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $d5ec20c2e57ca15d$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
var $d5ec20c2e57ca15d$var$LOCAL_OVERRIDE_REASON = 'LocalOverride:Recognized';
var $d5ec20c2e57ca15d$export$d8474cff104280f3 = 'STATSIG_OVERRIDES';
var $d5ec20c2e57ca15d$var$LEGACY_LOCAL_STORAGE_KEY = 'STATSIG_JS_LITE_LOCAL_OVERRIDES';
var $d5ec20c2e57ca15d$var$makeEmptyStore = function makeEmptyStore() {
    return {
        gates: {},
        configs: {},
        layers: {}
    };
};
var $d5ec20c2e57ca15d$var$djb2MapKey = function djb2MapKey(hash, kind) {
    return kind + ':' + hash;
};
var $d5ec20c2e57ca15d$export$bcb28fbac1def494 = /*#__PURE__*/ function() {
    function PersistentOverrideAdapter(localStorageKey) {
        (0, $7FJTB.default)(this, PersistentOverrideAdapter);
        this._overrides = $d5ec20c2e57ca15d$var$makeEmptyStore();
        this._djb2Map = new Map();
        this._localStorageKey = localStorageKey;
    }
    return (0, $dhZ1B.default)(PersistentOverrideAdapter, [
        {
            key: "parseStoredOverrides",
            value: function parseStoredOverrides(localStorageKey) {
                try {
                    var json = window.localStorage.getItem(localStorageKey);
                    if (!json) return $d5ec20c2e57ca15d$var$makeEmptyStore();
                    return JSON.parse(json);
                } catch (_unused) {
                    return $d5ec20c2e57ca15d$var$makeEmptyStore();
                }
            }
        },
        {
            key: "mergeOverrides",
            value: function mergeOverrides() {
                var merged = $d5ec20c2e57ca15d$var$makeEmptyStore();
                for(var _len = arguments.length, allOverrides = new Array(_len), _key = 0; _key < _len; _key++)allOverrides[_key] = arguments[_key];
                for(var _i = 0, _allOverrides = allOverrides; _i < _allOverrides.length; _i++){
                    var overrides = _allOverrides[_i];
                    for(var _i2 = 0, _Object$entries = Object.entries((_overrides$gates = overrides.gates) !== null && _overrides$gates !== void 0 ? _overrides$gates : {}); _i2 < _Object$entries.length; _i2++){
                        var _overrides$gates;
                        var _Object$entries$_i = (0, $9xnax.default)(_Object$entries[_i2], 2), name = _Object$entries$_i[0], value = _Object$entries$_i[1];
                        merged.gates[name] = value;
                    }
                    for(var _i3 = 0, _Object$entries2 = Object.entries((_overrides$configs = overrides.configs) !== null && _overrides$configs !== void 0 ? _overrides$configs : {}); _i3 < _Object$entries2.length; _i3++){
                        var _overrides$configs;
                        var _Object$entries2$_i = (0, $9xnax.default)(_Object$entries2[_i3], 2), _name = _Object$entries2$_i[0], _value = _Object$entries2$_i[1];
                        merged.configs[_name] = _value;
                    }
                    for(var _i4 = 0, _Object$entries3 = Object.entries((_overrides$layers = overrides.layers) !== null && _overrides$layers !== void 0 ? _overrides$layers : {}); _i4 < _Object$entries3.length; _i4++){
                        var _overrides$layers;
                        var _Object$entries3$_i = (0, $9xnax.default)(_Object$entries3[_i4], 2), _name2 = _Object$entries3$_i[0], _value2 = _Object$entries3$_i[1];
                        merged.layers[_name2] = _value2;
                    }
                }
                return merged;
            }
        },
        {
            key: "initFromStoredOverrides",
            value: function initFromStoredOverrides() {
                var storedOverrides = this.mergeOverrides(this._overrides, this.parseStoredOverrides($d5ec20c2e57ca15d$var$LEGACY_LOCAL_STORAGE_KEY), this.parseStoredOverrides(this._localStorageKey));
                // Clear data from legacy local storage key now we've read from it.
                // This prevents things being stuck in there that are always read but never written to.
                try {
                    window.localStorage.removeItem($d5ec20c2e57ca15d$var$LEGACY_LOCAL_STORAGE_KEY);
                } catch (_unused2) {
                // ignored - window is not defined in non-browser environments, and we don't save things there
                // (things like SSR, etc)
                }
                // In version 4.24.0 we introduced hashes in this override adapter, but had a bug which would cause
                // multiple hashes to continue being created. This code here removes these hashes since we've moved
                // to using a more reliable and easier to maintain map in `_djb2Map`.
                for(var _i5 = 0, _Object$values = Object.values(storedOverrides); _i5 < _Object$values.length; _i5++){
                    var container = _Object$values[_i5];
                    var allKeys = new Set(Object.keys(container));
                    var _iterator = $d5ec20c2e57ca15d$var$_createForOfIteratorHelper(allKeys), _step;
                    try {
                        for(_iterator.s(); !(_step = _iterator.n()).done;){
                            var name = _step.value;
                            var hash = (0, $dtn6l._DJB2)(name);
                            if (allKeys.has(hash)) delete container[hash];
                        }
                    } catch (err) {
                        _iterator.e(err);
                    } finally{
                        _iterator.f();
                    }
                }
                this.applyOverrides(storedOverrides);
            }
        },
        {
            key: "saveOverrides",
            value: function saveOverrides() {
                try {
                    window.localStorage.setItem(this._localStorageKey, JSON.stringify(this._overrides));
                } catch (_unused3) {
                // ignored - window is not defined in non-browser environments, and we don't save things there
                // (things like SSR, etc)
                }
            }
        },
        {
            key: "getOverrides",
            value: function getOverrides() {
                return this.mergeOverrides(this._overrides);
            }
        },
        {
            key: "applyOverrides",
            value: function applyOverrides(overrides) {
                var newOverrides = $d5ec20c2e57ca15d$var$_objectSpread($d5ec20c2e57ca15d$var$_objectSpread({}, $d5ec20c2e57ca15d$var$makeEmptyStore()), overrides);
                this._djb2Map.clear();
                for(var _i6 = 0, _Object$entries4 = Object.entries(newOverrides); _i6 < _Object$entries4.length; _i6++){
                    var _Object$entries4$_i = (0, $9xnax.default)(_Object$entries4[_i6], 2), containerName = _Object$entries4$_i[0], container = _Object$entries4$_i[1];
                    for(var _i7 = 0, _Object$entries5 = Object.entries(container); _i7 < _Object$entries5.length; _i7++){
                        var _Object$entries5$_i = (0, $9xnax.default)(_Object$entries5[_i7], 2), name = _Object$entries5$_i[0], value = _Object$entries5$_i[1];
                        this._djb2Map.set($d5ec20c2e57ca15d$var$djb2MapKey((0, $dtn6l._DJB2)(name), containerName), value);
                    }
                }
                this._overrides = newOverrides;
            }
        },
        {
            key: "setOverrides",
            value: function setOverrides(overrides) {
                this.applyOverrides(overrides);
                this.saveOverrides();
            }
        },
        {
            key: "overrideGate",
            value: function overrideGate(name, value) {
                this._overrides.gates[name] = value;
                this._djb2Map.set($d5ec20c2e57ca15d$var$djb2MapKey((0, $dtn6l._DJB2)(name), 'gates'), value);
                this.saveOverrides();
            }
        },
        {
            key: "removeGateOverride",
            value: function removeGateOverride(name) {
                delete this._overrides.gates[name];
                this._djb2Map.delete($d5ec20c2e57ca15d$var$djb2MapKey((0, $dtn6l._DJB2)(name), 'gates'));
                this.saveOverrides();
            }
        },
        {
            key: "getGateOverride",
            value: function getGateOverride(current, _user) {
                var _this$_overrides$gate;
                var overridden = (_this$_overrides$gate = this._overrides.gates[current.name]) !== null && _this$_overrides$gate !== void 0 ? _this$_overrides$gate : this._djb2Map.get($d5ec20c2e57ca15d$var$djb2MapKey(current.name, 'gates'));
                if (overridden == null) return null;
                return $d5ec20c2e57ca15d$var$_objectSpread($d5ec20c2e57ca15d$var$_objectSpread({}, current), {}, {
                    value: overridden,
                    details: $d5ec20c2e57ca15d$var$_objectSpread($d5ec20c2e57ca15d$var$_objectSpread({}, current.details), {}, {
                        reason: $d5ec20c2e57ca15d$var$LOCAL_OVERRIDE_REASON
                    })
                });
            }
        },
        {
            key: "overrideDynamicConfig",
            value: function overrideDynamicConfig(name, value) {
                this._overrides.configs[name] = value;
                this._djb2Map.set($d5ec20c2e57ca15d$var$djb2MapKey((0, $dtn6l._DJB2)(name), 'configs'), value);
                this.saveOverrides();
            }
        },
        {
            key: "removeDynamicConfigOverride",
            value: function removeDynamicConfigOverride(name) {
                delete this._overrides.configs[name];
                this._djb2Map.delete($d5ec20c2e57ca15d$var$djb2MapKey((0, $dtn6l._DJB2)(name), 'configs'));
                this.saveOverrides();
            }
        },
        {
            key: "getDynamicConfigOverride",
            value: function getDynamicConfigOverride(current, _user) {
                return this._getConfigOverride(current, this._overrides.configs);
            }
        },
        {
            key: "overrideExperiment",
            value: function overrideExperiment(name, value) {
                this._overrides.configs[name] = value;
                this._djb2Map.set($d5ec20c2e57ca15d$var$djb2MapKey((0, $dtn6l._DJB2)(name), 'configs'), value);
                this.saveOverrides();
            }
        },
        {
            key: "removeExperimentOverride",
            value: function removeExperimentOverride(name) {
                delete this._overrides.configs[name];
                this._djb2Map.delete($d5ec20c2e57ca15d$var$djb2MapKey((0, $dtn6l._DJB2)(name), 'configs'));
                this.saveOverrides();
            }
        },
        {
            key: "getExperimentOverride",
            value: function getExperimentOverride(current, _user) {
                return this._getConfigOverride(current, this._overrides.configs);
            }
        },
        {
            key: "overrideLayer",
            value: function overrideLayer(name, value) {
                this._overrides.layers[name] = value;
                this._djb2Map.set($d5ec20c2e57ca15d$var$djb2MapKey((0, $dtn6l._DJB2)(name), 'layers'), value);
                this.saveOverrides();
            }
        },
        {
            key: "removeLayerOverride",
            value: function removeLayerOverride(name) {
                delete this._overrides.layers[name];
                this._djb2Map.delete($d5ec20c2e57ca15d$var$djb2MapKey((0, $dtn6l._DJB2)(name), 'layers'));
                this.saveOverrides();
            }
        },
        {
            key: "removeAllOverrides",
            value: function removeAllOverrides() {
                this._overrides = $d5ec20c2e57ca15d$var$makeEmptyStore();
                try {
                    window.localStorage.removeItem(this._localStorageKey);
                } catch (_unused4) {
                // ignored - window is not defined in non-browser environments, and we don't save things there
                // (things like SSR, etc)
                }
            }
        },
        {
            key: "getLayerOverride",
            value: function getLayerOverride(current, _user) {
                var _this$_overrides$laye;
                var overridden = (_this$_overrides$laye = this._overrides.layers[current.name]) !== null && _this$_overrides$laye !== void 0 ? _this$_overrides$laye : this._djb2Map.get($d5ec20c2e57ca15d$var$djb2MapKey(current.name, 'layers'));
                if (overridden == null) return null;
                return $d5ec20c2e57ca15d$var$_objectSpread($d5ec20c2e57ca15d$var$_objectSpread({}, current), {}, {
                    __value: overridden,
                    get: (0, $dtn6l._makeTypedGet)(current.name, overridden),
                    details: $d5ec20c2e57ca15d$var$_objectSpread($d5ec20c2e57ca15d$var$_objectSpread({}, current.details), {}, {
                        reason: $d5ec20c2e57ca15d$var$LOCAL_OVERRIDE_REASON
                    })
                });
            }
        },
        {
            key: "_getConfigOverride",
            value: function _getConfigOverride(current, lookup) {
                var _lookup$current$name;
                var overridden = (_lookup$current$name = lookup[current.name]) !== null && _lookup$current$name !== void 0 ? _lookup$current$name : this._djb2Map.get($d5ec20c2e57ca15d$var$djb2MapKey(current.name, 'configs'));
                if (overridden == null) return null;
                return $d5ec20c2e57ca15d$var$_objectSpread($d5ec20c2e57ca15d$var$_objectSpread({}, current), {}, {
                    value: overridden,
                    get: (0, $dtn6l._makeTypedGet)(current.name, overridden),
                    details: $d5ec20c2e57ca15d$var$_objectSpread($d5ec20c2e57ca15d$var$_objectSpread({}, current.details), {}, {
                        reason: $d5ec20c2e57ca15d$var$LOCAL_OVERRIDE_REASON
                    })
                });
            }
        }
    ]);
}();

});



parcelRegister("aIvC6", function(module, exports) {
$parcel$export(module.exports, "debug", () => $7cd689410fe3de21$export$1c9f709888824e05);
var $7cd689410fe3de21$var$_process, $7cd689410fe3de21$var$_process2;
// We can't rely on NODE_ENV === 'test' if its value is already configured by the consumer to some other value, so better to use JEST_WORKER_ID
// https://jestjs.io/docs/environment-variables#jest_worker_id
var $7cd689410fe3de21$var$TESTS_MODE = (globalThis === null || globalThis === void 0 || ($7cd689410fe3de21$var$_process = globalThis.process) === null || $7cd689410fe3de21$var$_process === void 0 || ($7cd689410fe3de21$var$_process = $7cd689410fe3de21$var$_process.env) === null || $7cd689410fe3de21$var$_process === void 0 ? void 0 : $7cd689410fe3de21$var$_process.JEST_WORKER_ID) !== undefined;
var $7cd689410fe3de21$var$DEBUG_MODE = !$7cd689410fe3de21$var$TESTS_MODE && (globalThis === null || globalThis === void 0 || ($7cd689410fe3de21$var$_process2 = globalThis.process) === null || $7cd689410fe3de21$var$_process2 === void 0 || ($7cd689410fe3de21$var$_process2 = $7cd689410fe3de21$var$_process2.env) === null || $7cd689410fe3de21$var$_process2 === void 0 ? void 0 : $7cd689410fe3de21$var$_process2.NODE_ENV) !== 'production';
var $7cd689410fe3de21$export$1c9f709888824e05 = function debug() {
    var _console;
    if (!$7cd689410fe3de21$var$DEBUG_MODE) return;
    // eslint-disable-next-line no-console
    (_console = console).debug.apply(_console, arguments);
};

});

parcelRegister("kt9Mb", function(module, exports) {
$parcel$export(module.exports, "ENV_ENABLE_PLATFORM_FF", () => $ee6e1971d7677b65$export$b574c24e1e6490f5);

var $cPqAx = parcelRequire("cPqAx");
var $ee6e1971d7677b65$export$b574c24e1e6490f5 = (0, $cPqAx.hasProcessEnv) ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;

});
parcelRegister("cPqAx", function(module, exports) {
$parcel$export(module.exports, "PFF_GLOBAL_KEY", () => $956edf5980adeac0$export$7e41b1b2bdee3f98);
$parcel$export(module.exports, "pkgName", () => $956edf5980adeac0$export$407f05df8e3ce9f3);
$parcel$export(module.exports, "hasProcessEnv", () => $956edf5980adeac0$export$75f4a1454eff2805);

var $3ZMUU = parcelRequire("3ZMUU");
var $956edf5980adeac0$export$7e41b1b2bdee3f98 = '__PLATFORM_FEATURE_FLAGS__';
var $956edf5980adeac0$export$407f05df8e3ce9f3 = '@atlaskit/platform-feature-flags';
var $956edf5980adeac0$export$75f4a1454eff2805 = typeof $3ZMUU !== 'undefined' && typeof $3ZMUU.env !== 'undefined';

});


parcelRegister("lBR9z", function(module, exports) {
$parcel$export(module.exports, "ENV_STORYBOOK_ENABLE_PLATFORM_FF", () => $fbb648d8bfe745af$export$92f8b531feaeb23d);

var $cPqAx = parcelRequire("cPqAx");
var $fbb648d8bfe745af$export$92f8b531feaeb23d = (0, $cPqAx.hasProcessEnv) ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;

});

parcelRegister("e5PzA", function(module, exports) {
$parcel$export(module.exports, "globalVar", () => $a429899fbc60ee97$export$54ea85357b4e0159);

var $cPqAx = parcelRequire("cPqAx");
var $a429899fbc60ee97$var$DEFAULT_PFF_GLOBAL = {
    booleanResolver: undefined
};
var $a429899fbc60ee97$export$54ea85357b4e0159 = typeof window !== 'undefined' ? window : globalThis;
$a429899fbc60ee97$export$54ea85357b4e0159[0, $cPqAx.PFF_GLOBAL_KEY] = $a429899fbc60ee97$export$54ea85357b4e0159[0, $cPqAx.PFF_GLOBAL_KEY] || $a429899fbc60ee97$var$DEFAULT_PFF_GLOBAL;

});



parcelRegister("gwTbL", function(module, exports) {
$parcel$export(module.exports, "default", () => $c08a71d1bea39f71$export$2e2bcd8739ae039);

var $7FJTB = parcelRequire("7FJTB");

var $dhZ1B = parcelRequire("dhZ1B");

var $iMVPw = parcelRequire("iMVPw");
var $c08a71d1bea39f71$export$7bc189309d2ad463 = 'analyticsInteractionSesssionTrackingClient';
var $c08a71d1bea39f71$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function GlobalInteractionSessionTracking() {
        (0, $7FJTB.default)(this, GlobalInteractionSessionTracking);
    }
    return (0, $dhZ1B.default)(GlobalInteractionSessionTracking, null, [
        {
            key: "getInstance",
            value: function getInstance() {
                var interactionSessionTracking;
                try {
                    // Check if InteractionSessionTracking in global window object
                    if ($c08a71d1bea39f71$export$7bc189309d2ad463 in window) interactionSessionTracking = window[$c08a71d1bea39f71$export$7bc189309d2ad463];
                    else {
                        // Initialise InteractionSessionTracking on global window object
                        window[$c08a71d1bea39f71$export$7bc189309d2ad463] = new (0, $iMVPw.default)();
                        interactionSessionTracking = window[$c08a71d1bea39f71$export$7bc189309d2ad463];
                    }
                } catch (error) {
                // Silently swallow exception
                }
                return interactionSessionTracking;
            }
        }
    ]);
}();

});
parcelRegister("iMVPw", function(module, exports) {
$parcel$export(module.exports, "default", () => $dad991887cadc559$export$2e2bcd8739ae039);

var $7FJTB = parcelRequire("7FJTB");

var $dhZ1B = parcelRequire("dhZ1B");

var $aZa8T = parcelRequire("aZa8T");

var $iukH2 = parcelRequire("iukH2");
var $dad991887cadc559$var$INTERACTION_SESSION_ID_STORAGE_KEY = 'interactionSession.id';
var $dad991887cadc559$var$INTERACTION_SESSION_ID_PREV_STORAGE_KEY = 'interactionSession.id.prev';
var $dad991887cadc559$var$INTERACTION_SESSION_EXPIRY_STORAGE_KEY = 'interactionSession.expiry';
var $dad991887cadc559$export$285f6bddd927a06d = 1800000; // 30 minutes
var $dad991887cadc559$export$d050a4cab1b9f734 = 86400000; // 24 hours
var $dad991887cadc559$export$a92e915d70316eb2 = 5000; // 5 seconds
var $dad991887cadc559$export$de43760b2dc10c19 = 0.9; // 90% of expiry
var $dad991887cadc559$var$INTEGER_REGEX = /^\d+$/;
var $dad991887cadc559$export$5d4c4eab0863aae3 = 'interactionSessionIdUpdated';
/**
 * This class is essentially a wrapper around SessionStorage that introduces some failsafes (such as switching to InMemoryStorage if SessionStorage is not available)
 * and providing resilient methods for accessing and updating the interaction session ID.
 * This class can be initialised anywhere within a document, and `getCurrentInteractionSessionId` will always return the latest interaction session ID.
 *
 * The `setAnalyticsCallback` method must be called with a valid analytics event callback function provided by an Analytics Web Client before any other methods are used.
 * This is to ensure that any generated or renewed session IDs can be reported via an analytics event.
 *
 * The `setInteractionSessionId` method will write the SessionStorage with the persisted session ID, and is only intended to be used by the Analytics Web Client
 */ var $dad991887cadc559$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    // This callback function will be called whenever a new session ID is generated
    // It expects a function that sends an operational analytics event, with
    // the first parameter being set to the action ('started' or 'renewed'), and the second parameter being
    // an InteractionSession object containing the new session ID and previous session ID.
    function InteractionSessionTracking() {
        var _this = this;
        (0, $7FJTB.default)(this, InteractionSessionTracking);
        (0, $aZa8T.default)(this, "analyticsReady", false);
        (0, $aZa8T.default)(this, "generateNewSessionId", function() {
            if (!_this.analyticsReady) return null;
            var currentSessionId = _this.safeSessionStorage.getItem($dad991887cadc559$var$INTERACTION_SESSION_ID_STORAGE_KEY);
            var newSessionId = Date.now().toString();
            _this.safeSessionStorage.setItem($dad991887cadc559$var$INTERACTION_SESSION_ID_STORAGE_KEY, newSessionId);
            var _this$getCurrentSessi = _this.getCurrentSessionParams(), isValidSession = _this$getCurrentSessi.isValidSession;
            if (!isValidSession) // If session is not valid at this point, something has gone wrong with Session Storage access
            // Calling sendInteractionSessionEvent now would result in an infinite loop, so we terminate
            return null;
            if (currentSessionId) {
                // Store a copy of the current session ID so we can link sessions if needed
                _this.safeSessionStorage.setItem($dad991887cadc559$var$INTERACTION_SESSION_ID_PREV_STORAGE_KEY, currentSessionId);
                _this.sendInteractionSessionEvent('renewed');
            } else _this.sendInteractionSessionEvent('started');
            // Event listener is in useCrossProductUrl.tsx to update URL query params
            document.dispatchEvent(new Event($dad991887cadc559$export$5d4c4eab0863aae3));
            return newSessionId;
        });
        (0, $aZa8T.default)(this, "updateSessionExpiry", function() {
            var expiry = Date.now() + _this.sessionExpiryTime;
            _this.safeSessionStorage.setItem($dad991887cadc559$var$INTERACTION_SESSION_EXPIRY_STORAGE_KEY, expiry.toString());
            return expiry;
        });
        (0, $aZa8T.default)(this, "debouncedUpdateSessionExpiry", function(currentExpiry) {
            var updateSessionExpiry = _this.updateSessionExpiry;
            // If the current expiry is out of date by more than 10% of the expiry, update immediately
            if (currentExpiry < Date.now() + _this.sessionExpiryDebounceThresholdPercentage * _this.sessionExpiryTime) updateSessionExpiry();
            else {
                if (_this.sessionExpiryDebounceTimer) clearTimeout(_this.sessionExpiryDebounceTimer);
                // @ts-ignore Something wrong with our types... this is legit
                _this.sessionExpiryDebounceTimer = setTimeout(function() {
                    updateSessionExpiry();
                }, _this.sessionExpiryDebounce);
            }
        });
        this.sessionExpiryTime = $dad991887cadc559$export$285f6bddd927a06d;
        this.sessionExpiryDebounce = $dad991887cadc559$export$a92e915d70316eb2;
        this.sessionExpiryDebounceThresholdPercentage = $dad991887cadc559$export$de43760b2dc10c19;
        this.safeSessionStorage = new (0, $iukH2.default)();
    }
    return (0, $dhZ1B.default)(InteractionSessionTracking, [
        {
            key: "getCurrentInteractionSessionId",
            value: function getCurrentInteractionSessionId() {
                try {
                    var _this$getCurrentSessi2 = this.getCurrentSessionParams(), isValidSession = _this$getCurrentSessi2.isValidSession, sessionExpiry = _this$getCurrentSessi2.sessionExpiry, sessionId = _this$getCurrentSessi2.sessionId;
                    // If we have an existing valid session we can return the sessionId straight away
                    if (isValidSession) {
                        this.debouncedUpdateSessionExpiry(sessionExpiry);
                        return sessionId;
                    }
                    // To generate a new session ID we must ensure analytics is ready
                    if (this.analyticsReady) {
                        // Session expiry update must occur before generateNewSessionId. Otherwise we were running
                        // into issues of calls attempting to read the session ID before a valid expiry had been set
                        this.debouncedUpdateSessionExpiry(sessionExpiry);
                        return this.generateNewSessionId();
                    }
                } catch (err) {
                // Silently swallow exception
                }
                return null;
            }
        },
        {
            key: "getPreviousInteractionSessionId",
            value: function getPreviousInteractionSessionId() {
                return this.safeSessionStorage.getItem($dad991887cadc559$var$INTERACTION_SESSION_ID_PREV_STORAGE_KEY);
            }
        },
        {
            key: "setInteractionSessionId",
            value: function setInteractionSessionId(persistedSessionId) {
                if (this.validateSessionId(persistedSessionId)) {
                    var currentSessionId = this.safeSessionStorage.getItem($dad991887cadc559$var$INTERACTION_SESSION_ID_STORAGE_KEY);
                    // If we are already on the required session ID, just return true and make no changes
                    // This can happen if the persisted session ID in options is the same as the current session ID
                    // We noticed this happening in some cases where Confluence's own URL redirect logic was causing
                    // race conditions with our URL stripping, resulting in the same query parameter being processed multiple times
                    if (currentSessionId === persistedSessionId) return false;
                    // Session expiry update must occur before we fire off the dispatchEvent. Otherwise we were running
                    // into issues of the event consumer attempting to read the session ID before a valid expiry had been set
                    this.debouncedUpdateSessionExpiry(0);
                    this.safeSessionStorage.setItem($dad991887cadc559$var$INTERACTION_SESSION_ID_STORAGE_KEY, persistedSessionId);
                    this.safeSessionStorage.removeItem($dad991887cadc559$var$INTERACTION_SESSION_ID_PREV_STORAGE_KEY);
                    document.dispatchEvent(new Event($dad991887cadc559$export$5d4c4eab0863aae3));
                    return true;
                }
                return false;
            }
        },
        {
            key: "setAnalyticsCallback",
            value: function setAnalyticsCallback(sendEventCallback) {
                if (this.analyticsReady) // If we already have a valid callback, don't over-write it
                return;
                if (sendEventCallback && typeof sendEventCallback === 'function') {
                    this.sendEventCallback = sendEventCallback;
                    this.analyticsReady = true;
                } else this.analyticsReady = false;
            }
        },
        {
            key: "validateSessionId",
            value: function validateSessionId(sessionId) {
                // Check if persisted session ID can parse as valid Unix timestamp
                if (sessionId && $dad991887cadc559$var$INTEGER_REGEX.test(sessionId)) {
                    var sessionAge = Date.now() - parseInt(sessionId, 10);
                    // Validate that timestamp is not a future time, and is also within the TTL
                    if (sessionAge >= 0 && sessionAge <= $dad991887cadc559$export$d050a4cab1b9f734) return true;
                }
                return false;
            }
        },
        {
            key: "getCurrentSessionParams",
            value: function getCurrentSessionParams() {
                var sessionId = this.safeSessionStorage.getItem($dad991887cadc559$var$INTERACTION_SESSION_ID_STORAGE_KEY);
                var sessionExpiry = parseInt(this.safeSessionStorage.getItem($dad991887cadc559$var$INTERACTION_SESSION_EXPIRY_STORAGE_KEY) || '0', 10) || 0;
                if (sessionId && !Number.isNaN(sessionExpiry) && sessionExpiry > Date.now()) return {
                    isValidSession: true,
                    sessionExpiry: sessionExpiry,
                    sessionId: sessionId
                };
                return {
                    isValidSession: false,
                    sessionExpiry: sessionExpiry,
                    sessionId: sessionId
                };
            }
        },
        {
            key: "sendInteractionSessionEvent",
            value: function sendInteractionSessionEvent(action) {
                this.sendEventCallback && this.sendEventCallback({
                    action: action,
                    actionSubject: 'interactionSession',
                    source: 'interactionComponent',
                    tags: [
                        'navigationExperiences'
                    ] // InteractionSession events will be registered under this platform product
                });
            }
        }
    ]);
}();

});
parcelRegister("iukH2", function(module, exports) {
$parcel$export(module.exports, "default", () => $d75b148bb05fa448$export$2e2bcd8739ae039);

var $dhZ1B = parcelRequire("dhZ1B");

var $7FJTB = parcelRequire("7FJTB");

var $4MOeb = parcelRequire("4MOeb");

var $aawNP = parcelRequire("aawNP");

var $jTzgi = parcelRequire("jTzgi");

var $1gLwd = parcelRequire("1gLwd");

var $3KMgh = parcelRequire("3KMgh");
function $d75b148bb05fa448$var$_callSuper(t, o, e) {
    return o = (0, $aawNP.default)(o), (0, $4MOeb.default)(t, $d75b148bb05fa448$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, $aawNP.default)(t).constructor) : o.apply(t, e));
}
function $d75b148bb05fa448$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($d75b148bb05fa448$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
// eslint-disable-next-line import/no-anonymous-default-export
var $d75b148bb05fa448$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_SafeStorage) {
    function _default(options) {
        (0, $7FJTB.default)(this, _default);
        var storageToUse;
        try {
            // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
            storageToUse = window.sessionStorage || (0, $1gLwd.default);
        } catch (err) {
            storageToUse = (0, $1gLwd.default);
        }
        return $d75b148bb05fa448$var$_callSuper(this, _default, [
            storageToUse,
            options
        ]);
    }
    (0, $jTzgi.default)(_default, _SafeStorage);
    return (0, $dhZ1B.default)(_default);
}((0, $3KMgh.default));

});
parcelRegister("1gLwd", function(module, exports) {
$parcel$export(module.exports, "default", () => $0ecc2545dba4bca4$export$2e2bcd8739ae039);

var $3erKm = parcelRequire("3erKm");
// eslint-disable-next-line import/no-anonymous-default-export
var $0ecc2545dba4bca4$var$inmemorystorage = new (0, $3erKm.InMemoryStore)();
var $0ecc2545dba4bca4$export$2e2bcd8739ae039 = $0ecc2545dba4bca4$var$inmemorystorage;

});
parcelRegister("3erKm", function(module, exports) {
$parcel$export(module.exports, "InMemoryStore", () => $25a833d2391d5233$export$90e3e001bcac59c7);

var $dhZ1B = parcelRequire("dhZ1B");

var $7FJTB = parcelRequire("7FJTB");

var $aZa8T = parcelRequire("aZa8T");
var $25a833d2391d5233$export$90e3e001bcac59c7 = /*#__PURE__*/ (0, $dhZ1B.default)(function InMemoryStore() {
    var _this = this;
    (0, $7FJTB.default)(this, InMemoryStore);
    (0, $aZa8T.default)(this, "data", {});
    (0, $aZa8T.default)(this, "length", 0);
    (0, $aZa8T.default)(this, "setItem", function(key, value) {
        _this.data[key] = value;
        _this.length = Object.keys(_this.data).length;
        return value;
    });
    (0, $aZa8T.default)(this, "getItem", function(key) {
        if (key in _this.data) return _this.data[key];
        return null;
    });
    (0, $aZa8T.default)(this, "removeItem", function(key) {
        if (key in _this.data) delete _this.data[key];
        _this.length = Object.keys(_this.data).length;
        return null;
    });
    (0, $aZa8T.default)(this, "clear", function() {
        _this.data = {};
        _this.length = 0;
    });
    (0, $aZa8T.default)(this, "key", function(index) {
        return Object.keys(_this.data)[index];
    });
});

});


parcelRegister("3KMgh", function(module, exports) {
$parcel$export(module.exports, "default", () => $2bbb1abbaa4b4747$export$2e2bcd8739ae039);

var $dhZ1B = parcelRequire("dhZ1B");

var $7FJTB = parcelRequire("7FJTB");

var $aZa8T = parcelRequire("aZa8T");

var $hqF8O = parcelRequire("hqF8O");

var $1gLwd = parcelRequire("1gLwd");

var $ekrwR = parcelRequire("ekrwR");
var $2bbb1abbaa4b4747$export$41c06fdd37b7e9a5 = 'awc';
var $2bbb1abbaa4b4747$export$770aa8bc07b3de03 = 'awcInMemoryStorageFallback';
var $2bbb1abbaa4b4747$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $dhZ1B.default)(function SafeStorage(storageToUse) {
    var _this = this;
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    (0, $7FJTB.default)(this, SafeStorage);
    (0, $aZa8T.default)(this, "getStore", function() {
        return _this.store;
    });
    (0, $aZa8T.default)(this, "getItem", function(key) {
        return _this.store.getItem(_this.createKey(key));
    });
    (0, $aZa8T.default)(this, "removeItem", function(key) {
        return _this.store.removeItem(_this.createKey(key));
    });
    (0, $aZa8T.default)(this, "setItem", function(key, value) {
        try {
            _this.store.setItem(_this.createKey(key), value);
        } catch (err) {
            // Theoretically should only be QuotaExceededError, but keeping 'err' generic
            // https://developer.mozilla.org/en-US/docs/Web/API/Storage/setItem
            _this.swapToInMemory();
            _this.store.setItem(_this.createKey(key), value);
        }
    });
    (0, $aZa8T.default)(this, "swapToInMemory", function() {
        if (_this.store === (0, $1gLwd.default) || typeof window === 'undefined') return;
        var keys = Object.keys(_this.store || {});
        var inMemoryStorage;
        if ((0, $ekrwR.isSupported)(window[$2bbb1abbaa4b4747$export$770aa8bc07b3de03])) inMemoryStorage = window[$2bbb1abbaa4b4747$export$770aa8bc07b3de03];
        else {
            inMemoryStorage = (0, $1gLwd.default);
            if (!window[$2bbb1abbaa4b4747$export$770aa8bc07b3de03]) // If not already attached to window then attach our instance of InMemoryStorage
            // We need to do this because if there are multiple instances of Analytics Client in multiple scopes,
            // there is no way to guarantee the throttling behaviour of the UI viewed event across those instances without a global singleton
            window[$2bbb1abbaa4b4747$export$770aa8bc07b3de03] = (0, $1gLwd.default);
        }
        keys.forEach(function(key) {
            if (key.indexOf(_this.getPrefix()) === 0) {
                var value = _this.store.getItem(key);
                if (value) inMemoryStorage.setItem(key, value);
            }
        });
        _this.store = inMemoryStorage;
    });
    (0, $aZa8T.default)(this, "clear", function() {
        return _this.store.clear();
    });
    (0, $aZa8T.default)(this, "key", function(index) {
        return _this.store.key(index);
    });
    (0, $aZa8T.default)(this, "getPrefix", function() {
        return _this.prefix;
    });
    (0, $aZa8T.default)(this, "createKey", function(key) {
        if (_this.prefix) return "".concat(_this.getPrefix(), ".").concat(key);
        return key;
    });
    this.options = options;
    var prefixes = [];
    if (options.useStoragePrefix === undefined || options.useStoragePrefix) prefixes.push($2bbb1abbaa4b4747$export$41c06fdd37b7e9a5);
    if (options.envPrefix && options.envPrefix !== (0, $hqF8O.envType).PROD) prefixes.push(options.envPrefix);
    this.prefix = prefixes.join('-');
    if ((0, $ekrwR.isSupported)(storageToUse)) this.store = storageToUse;
    else this.swapToInMemory();
});

});
parcelRegister("hqF8O", function(module, exports) {
$parcel$export(module.exports, "envType", () => $cb04c7282236de98$export$56ac8ebc9870b1b9);
/*
 * Code heavily influenced by Segment's Store https://github.com/segmentio/localstorage-retry/blob/master/lib/store.js
 * and Engine https://github.com/segmentio/localstorage-retry/blob/master/lib/engine.js
 * But is not used because it's not public API and is too restrictive in the way it sets keys and does JSON parsing and stringify
 */ // This type has been converted from frozen objects to enums.
// We cannot change their name, or even capitalise them without breaking API.
var $cb04c7282236de98$export$56ac8ebc9870b1b9 = /*#__PURE__*/ function(envType) {
    envType["DEV"] = "dev";
    envType["LOCAL"] = "local";
    envType["PROD"] = "prod";
    envType["STAGING"] = "staging";
    return envType;
}({});

});

parcelRegister("ekrwR", function(module, exports) {
$parcel$export(module.exports, "isSupported", () => $a6e849a1caf58321$export$48c17662a6902497);
/*
 * Code heavily influenced by Segment's Store https://github.com/segmentio/localstorage-retry/blob/master/lib/store.js
 * and Engine https://github.com/segmentio/localstorage-retry/blob/master/lib/engine.js
 * But is not used because it's not public API and is too restrictive in the way it sets keys and does JSON parsing and stringify
 */ function $a6e849a1caf58321$export$48c17662a6902497(store) {
    var TEST_VALUE = 'test_value';
    if (!store) return false;
    try {
        var key = 'awc.storage.support';
        store.setItem(key, TEST_VALUE);
        var value = store.getItem(key);
        store.removeItem(key);
        // handle localStorage silently failing
        return value === TEST_VALUE;
    } catch (e) {
        // Can throw if localStorage is disabled
        return false;
    }
}

});






parcelRegister("hiAXT", function(module, exports) {
$parcel$export(module.exports, "URL_QUERY_PARAM_INTERACTION_SESSION", () => $c980ca96fe3c1be9$export$81d16f1428ce0486);
var $c980ca96fe3c1be9$export$81d16f1428ce0486 = 'xpis';
var $c980ca96fe3c1be9$export$2e3999ec51334ffe = function generateUrlWithParams(url, bridge, interactionSessionId, product, subProduct) {
    var interactionSource = subProduct ? "".concat(product, "-").concat(subProduct) : product;
    var interactionSession = {
        bridge: bridge,
        id: interactionSessionId,
        source: interactionSource
    };
    var paramValueEncoded = btoa(JSON.stringify(interactionSession));
    var partialUrl = false;
    var urlObj;
    // If relative URL provided, add localhost as placeholder base, to be stripped later
    try {
        urlObj = new URL(url);
    } catch (_unused) {
        urlObj = new URL(url, 'http://localhost/');
        partialUrl = true;
    }
    urlObj.searchParams.set($c980ca96fe3c1be9$export$81d16f1428ce0486, paramValueEncoded);
    if (partialUrl) return urlObj.pathname + urlObj.search;
    else return urlObj.toString();
};

});

parcelRegister("aWPob", function(module, exports) {
$parcel$export(module.exports, "validProducts", () => $7f872ef078f1fd45$export$b1e8b4360a046e61);
// Add products that will participate in cross-product interaction tracking here
// TODO: Down the line this should ideally be synced with ECS product list but that
// will take significant engineering effort
var $7f872ef078f1fd45$export$b1e8b4360a046e61 = [
    'jira',
    'confluence',
    'townsquare',
    'loom',
    'atlassianStudio',
    'bitbucket',
    'admin',
    'mercury',
    'trello',
    'analyticsVisualizationPlatform'
];

});

parcelRegister("2UUeH", function(module, exports) {
$parcel$export(module.exports, "default", () => $21fc6f103b6afda8$export$2e2bcd8739ae039);

var $3hnNg = parcelRequire("3hnNg");

var $74pGx = parcelRequire("74pGx");

var $8ZtlX = parcelRequire("8ZtlX");
const $21fc6f103b6afda8$var$urlParamExtractor = (isCaptureParam, historyReplaceFn = (0, $74pGx.defaultHistoryReplaceFn))=>{
    // Extract target parameters and values from URL if present
    const originalUrl = window.location.href;
    const fragmentHash = window.location.hash;
    const removedFragmentURL = fragmentHash !== '' ? originalUrl.replace(fragmentHash, '') : originalUrl;
    const { url: url, query: query } = (0, $3hnNg.parseUrl)(removedFragmentURL);
    const captureParams = (0, $8ZtlX.pickBy)(query, isCaptureParam);
    // Do not modify URL if no matches
    if (Object.keys(captureParams).length > 0) {
        const queryWithoutCaptureParams = (0, $8ZtlX.omitBy)(query, isCaptureParam);
        // Replace the URL minus captured parameters
        if (Object.keys(queryWithoutCaptureParams).length > 0) {
            const newUrl = `${url}?${(0, $3hnNg.stringify)(queryWithoutCaptureParams)}${fragmentHash}`;
            historyReplaceFn(newUrl);
        } else historyReplaceFn(`${url}${fragmentHash}`);
    }
    return captureParams;
};
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$21fc6f103b6afda8$export$2e2bcd8739ae039 = $21fc6f103b6afda8$var$urlParamExtractor;

});
parcelRegister("3hnNg", function(module, exports) {
$parcel$export(module.exports, "extract", () => $26356a878988d07a$export$f9380c9a627682d3, (v) => $26356a878988d07a$export$f9380c9a627682d3 = v);
$parcel$export(module.exports, "parse", () => $26356a878988d07a$export$98e6a39c04603d36, (v) => $26356a878988d07a$export$98e6a39c04603d36 = v);
$parcel$export(module.exports, "stringify", () => $26356a878988d07a$export$fac44ee5b035f737, (v) => $26356a878988d07a$export$fac44ee5b035f737 = v);
$parcel$export(module.exports, "parseUrl", () => $26356a878988d07a$export$7a5253c0f62e0150, (v) => $26356a878988d07a$export$7a5253c0f62e0150 = v);
$parcel$export(module.exports, "stringifyUrl", () => $26356a878988d07a$export$a8c1621ea79325d3, (v) => $26356a878988d07a$export$a8c1621ea79325d3 = v);
$parcel$export(module.exports, "pick", () => $26356a878988d07a$export$357523c63a2253b9, (v) => $26356a878988d07a$export$357523c63a2253b9 = v);
var $26356a878988d07a$export$f9380c9a627682d3;
var $26356a878988d07a$export$98e6a39c04603d36;
var $26356a878988d07a$export$fac44ee5b035f737;
var $26356a878988d07a$export$7a5253c0f62e0150;
var $26356a878988d07a$export$a8c1621ea79325d3;
var $26356a878988d07a$export$357523c63a2253b9;
var $26356a878988d07a$export$44c361b8ec72ef7f;
'use strict';

var $6XEYK = parcelRequire("6XEYK");

var $9YPP7 = parcelRequire("9YPP7");

var $l4Qn0 = parcelRequire("l4Qn0");

var $9PyLY = parcelRequire("9PyLY");
const $26356a878988d07a$var$isNullOrUndefined = (value)=>value === null || value === undefined;
const $26356a878988d07a$var$encodeFragmentIdentifier = Symbol('encodeFragmentIdentifier');
function $26356a878988d07a$var$encoderForArrayFormat(options) {
    switch(options.arrayFormat){
        case 'index':
            return (key)=>(result, value)=>{
                    const index = result.length;
                    if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === '') return result;
                    if (value === null) return [
                        ...result,
                        [
                            $26356a878988d07a$var$encode(key, options),
                            '[',
                            index,
                            ']'
                        ].join('')
                    ];
                    return [
                        ...result,
                        [
                            $26356a878988d07a$var$encode(key, options),
                            '[',
                            $26356a878988d07a$var$encode(index, options),
                            ']=',
                            $26356a878988d07a$var$encode(value, options)
                        ].join('')
                    ];
                };
        case 'bracket':
            return (key)=>(result, value)=>{
                    if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === '') return result;
                    if (value === null) return [
                        ...result,
                        [
                            $26356a878988d07a$var$encode(key, options),
                            '[]'
                        ].join('')
                    ];
                    return [
                        ...result,
                        [
                            $26356a878988d07a$var$encode(key, options),
                            '[]=',
                            $26356a878988d07a$var$encode(value, options)
                        ].join('')
                    ];
                };
        case 'colon-list-separator':
            return (key)=>(result, value)=>{
                    if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === '') return result;
                    if (value === null) return [
                        ...result,
                        [
                            $26356a878988d07a$var$encode(key, options),
                            ':list='
                        ].join('')
                    ];
                    return [
                        ...result,
                        [
                            $26356a878988d07a$var$encode(key, options),
                            ':list=',
                            $26356a878988d07a$var$encode(value, options)
                        ].join('')
                    ];
                };
        case 'comma':
        case 'separator':
        case 'bracket-separator':
            {
                const keyValueSep = options.arrayFormat === 'bracket-separator' ? '[]=' : '=';
                return (key)=>(result, value)=>{
                        if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === '') return result;
                        // Translate null to an empty string so that it doesn't serialize as 'null'
                        value = value === null ? '' : value;
                        if (result.length === 0) return [
                            [
                                $26356a878988d07a$var$encode(key, options),
                                keyValueSep,
                                $26356a878988d07a$var$encode(value, options)
                            ].join('')
                        ];
                        return [
                            [
                                result,
                                $26356a878988d07a$var$encode(value, options)
                            ].join(options.arrayFormatSeparator)
                        ];
                    };
            }
        default:
            return (key)=>(result, value)=>{
                    if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === '') return result;
                    if (value === null) return [
                        ...result,
                        $26356a878988d07a$var$encode(key, options)
                    ];
                    return [
                        ...result,
                        [
                            $26356a878988d07a$var$encode(key, options),
                            '=',
                            $26356a878988d07a$var$encode(value, options)
                        ].join('')
                    ];
                };
    }
}
function $26356a878988d07a$var$parserForArrayFormat(options) {
    let result;
    switch(options.arrayFormat){
        case 'index':
            return (key, value, accumulator)=>{
                result = /\[(\d*)\]$/.exec(key);
                key = key.replace(/\[\d*\]$/, '');
                if (!result) {
                    accumulator[key] = value;
                    return;
                }
                if (accumulator[key] === undefined) accumulator[key] = {};
                accumulator[key][result[1]] = value;
            };
        case 'bracket':
            return (key, value, accumulator)=>{
                result = /(\[\])$/.exec(key);
                key = key.replace(/\[\]$/, '');
                if (!result) {
                    accumulator[key] = value;
                    return;
                }
                if (accumulator[key] === undefined) {
                    accumulator[key] = [
                        value
                    ];
                    return;
                }
                accumulator[key] = [].concat(accumulator[key], value);
            };
        case 'colon-list-separator':
            return (key, value, accumulator)=>{
                result = /(:list)$/.exec(key);
                key = key.replace(/:list$/, '');
                if (!result) {
                    accumulator[key] = value;
                    return;
                }
                if (accumulator[key] === undefined) {
                    accumulator[key] = [
                        value
                    ];
                    return;
                }
                accumulator[key] = [].concat(accumulator[key], value);
            };
        case 'comma':
        case 'separator':
            return (key, value, accumulator)=>{
                const isArray = typeof value === 'string' && value.includes(options.arrayFormatSeparator);
                const isEncodedArray = typeof value === 'string' && !isArray && $26356a878988d07a$var$decode(value, options).includes(options.arrayFormatSeparator);
                value = isEncodedArray ? $26356a878988d07a$var$decode(value, options) : value;
                const newValue = isArray || isEncodedArray ? value.split(options.arrayFormatSeparator).map((item)=>$26356a878988d07a$var$decode(item, options)) : value === null ? value : $26356a878988d07a$var$decode(value, options);
                accumulator[key] = newValue;
            };
        case 'bracket-separator':
            return (key, value, accumulator)=>{
                const isArray = /(\[\])$/.test(key);
                key = key.replace(/\[\]$/, '');
                if (!isArray) {
                    accumulator[key] = value ? $26356a878988d07a$var$decode(value, options) : value;
                    return;
                }
                const arrayValue = value === null ? [] : value.split(options.arrayFormatSeparator).map((item)=>$26356a878988d07a$var$decode(item, options));
                if (accumulator[key] === undefined) {
                    accumulator[key] = arrayValue;
                    return;
                }
                accumulator[key] = [].concat(accumulator[key], arrayValue);
            };
        default:
            return (key, value, accumulator)=>{
                if (accumulator[key] === undefined) {
                    accumulator[key] = value;
                    return;
                }
                accumulator[key] = [].concat(accumulator[key], value);
            };
    }
}
function $26356a878988d07a$var$validateArrayFormatSeparator(value) {
    if (typeof value !== 'string' || value.length !== 1) throw new TypeError('arrayFormatSeparator must be single character string');
}
function $26356a878988d07a$var$encode(value, options) {
    if (options.encode) return options.strict ? $6XEYK(value) : encodeURIComponent(value);
    return value;
}
function $26356a878988d07a$var$decode(value, options) {
    if (options.decode) return $9YPP7(value);
    return value;
}
function $26356a878988d07a$var$keysSorter(input) {
    if (Array.isArray(input)) return input.sort();
    if (typeof input === 'object') return $26356a878988d07a$var$keysSorter(Object.keys(input)).sort((a, b)=>Number(a) - Number(b)).map((key)=>input[key]);
    return input;
}
function $26356a878988d07a$var$removeHash(input) {
    const hashStart = input.indexOf('#');
    if (hashStart !== -1) input = input.slice(0, hashStart);
    return input;
}
function $26356a878988d07a$var$getHash(url) {
    let hash = '';
    const hashStart = url.indexOf('#');
    if (hashStart !== -1) hash = url.slice(hashStart);
    return hash;
}
function $26356a878988d07a$var$extract(input) {
    input = $26356a878988d07a$var$removeHash(input);
    const queryStart = input.indexOf('?');
    if (queryStart === -1) return '';
    return input.slice(queryStart + 1);
}
function $26356a878988d07a$var$parseValue(value, options) {
    if (options.parseNumbers && !Number.isNaN(Number(value)) && typeof value === 'string' && value.trim() !== '') value = Number(value);
    else if (options.parseBooleans && value !== null && (value.toLowerCase() === 'true' || value.toLowerCase() === 'false')) value = value.toLowerCase() === 'true';
    return value;
}
function $26356a878988d07a$var$parse(query, options) {
    options = Object.assign({
        decode: true,
        sort: true,
        arrayFormat: 'none',
        arrayFormatSeparator: ',',
        parseNumbers: false,
        parseBooleans: false
    }, options);
    $26356a878988d07a$var$validateArrayFormatSeparator(options.arrayFormatSeparator);
    const formatter = $26356a878988d07a$var$parserForArrayFormat(options);
    // Create an object with no prototype
    const ret = Object.create(null);
    if (typeof query !== 'string') return ret;
    query = query.trim().replace(/^[?#&]/, '');
    if (!query) return ret;
    for (const param of query.split('&')){
        if (param === '') continue;
        let [key, value] = $l4Qn0(options.decode ? param.replace(/\+/g, ' ') : param, '=');
        // Missing `=` should be `null`:
        // http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
        value = value === undefined ? null : [
            'comma',
            'separator',
            'bracket-separator'
        ].includes(options.arrayFormat) ? value : $26356a878988d07a$var$decode(value, options);
        formatter($26356a878988d07a$var$decode(key, options), value, ret);
    }
    for (const key of Object.keys(ret)){
        const value = ret[key];
        if (typeof value === 'object' && value !== null) for (const k of Object.keys(value))value[k] = $26356a878988d07a$var$parseValue(value[k], options);
        else ret[key] = $26356a878988d07a$var$parseValue(value, options);
    }
    if (options.sort === false) return ret;
    return (options.sort === true ? Object.keys(ret).sort() : Object.keys(ret).sort(options.sort)).reduce((result, key)=>{
        const value = ret[key];
        if (Boolean(value) && typeof value === 'object' && !Array.isArray(value)) // Sort object keys, not values
        result[key] = $26356a878988d07a$var$keysSorter(value);
        else result[key] = value;
        return result;
    }, Object.create(null));
}
$26356a878988d07a$export$f9380c9a627682d3 = $26356a878988d07a$var$extract;
$26356a878988d07a$export$98e6a39c04603d36 = $26356a878988d07a$var$parse;
$26356a878988d07a$export$fac44ee5b035f737 = (object, options)=>{
    if (!object) return '';
    options = Object.assign({
        encode: true,
        strict: true,
        arrayFormat: 'none',
        arrayFormatSeparator: ','
    }, options);
    $26356a878988d07a$var$validateArrayFormatSeparator(options.arrayFormatSeparator);
    const shouldFilter = (key)=>options.skipNull && $26356a878988d07a$var$isNullOrUndefined(object[key]) || options.skipEmptyString && object[key] === '';
    const formatter = $26356a878988d07a$var$encoderForArrayFormat(options);
    const objectCopy = {};
    for (const key of Object.keys(object))if (!shouldFilter(key)) objectCopy[key] = object[key];
    const keys = Object.keys(objectCopy);
    if (options.sort !== false) keys.sort(options.sort);
    return keys.map((key)=>{
        const value = object[key];
        if (value === undefined) return '';
        if (value === null) return $26356a878988d07a$var$encode(key, options);
        if (Array.isArray(value)) {
            if (value.length === 0 && options.arrayFormat === 'bracket-separator') return $26356a878988d07a$var$encode(key, options) + '[]';
            return value.reduce(formatter(key), []).join('&');
        }
        return $26356a878988d07a$var$encode(key, options) + '=' + $26356a878988d07a$var$encode(value, options);
    }).filter((x)=>x.length > 0).join('&');
};
$26356a878988d07a$export$7a5253c0f62e0150 = (url, options)=>{
    options = Object.assign({
        decode: true
    }, options);
    const [url_, hash] = $l4Qn0(url, '#');
    return Object.assign({
        url: url_.split('?')[0] || '',
        query: $26356a878988d07a$var$parse($26356a878988d07a$var$extract(url), options)
    }, options && options.parseFragmentIdentifier && hash ? {
        fragmentIdentifier: $26356a878988d07a$var$decode(hash, options)
    } : {});
};
$26356a878988d07a$export$a8c1621ea79325d3 = (object, options)=>{
    options = Object.assign({
        encode: true,
        strict: true,
        [$26356a878988d07a$var$encodeFragmentIdentifier]: true
    }, options);
    const url = $26356a878988d07a$var$removeHash(object.url).split('?')[0] || '';
    const queryFromUrl = $26356a878988d07a$export$f9380c9a627682d3(object.url);
    const parsedQueryFromUrl = $26356a878988d07a$export$98e6a39c04603d36(queryFromUrl, {
        sort: false
    });
    const query = Object.assign(parsedQueryFromUrl, object.query);
    let queryString = $26356a878988d07a$export$fac44ee5b035f737(query, options);
    if (queryString) queryString = `?${queryString}`;
    let hash = $26356a878988d07a$var$getHash(object.url);
    if (object.fragmentIdentifier) hash = `#${options[$26356a878988d07a$var$encodeFragmentIdentifier] ? $26356a878988d07a$var$encode(object.fragmentIdentifier, options) : object.fragmentIdentifier}`;
    return `${url}${queryString}${hash}`;
};
$26356a878988d07a$export$357523c63a2253b9 = (input, filter, options)=>{
    options = Object.assign({
        parseFragmentIdentifier: true,
        [$26356a878988d07a$var$encodeFragmentIdentifier]: false
    }, options);
    const { url: url, query: query, fragmentIdentifier: fragmentIdentifier } = $26356a878988d07a$export$7a5253c0f62e0150(input, options);
    return $26356a878988d07a$export$a8c1621ea79325d3({
        url: url,
        query: $9PyLY(query, filter),
        fragmentIdentifier: fragmentIdentifier
    }, options);
};
$26356a878988d07a$export$44c361b8ec72ef7f = (input, filter, options)=>{
    const exclusionFilter = Array.isArray(filter) ? (key)=>!filter.includes(key) : (key, value)=>!filter(key, value);
    return $26356a878988d07a$export$357523c63a2253b9(input, exclusionFilter, options);
};

});
parcelRegister("6XEYK", function(module, exports) {
'use strict';
module.exports = (str)=>encodeURIComponent(str).replace(/[!'()*]/g, (x)=>`%${x.charCodeAt(0).toString(16).toUpperCase()}`);

});

parcelRegister("9YPP7", function(module, exports) {
'use strict';
var $7441eabb5801ca04$var$token = '%[a-f0-9]{2}';
var $7441eabb5801ca04$var$singleMatcher = new RegExp('(' + $7441eabb5801ca04$var$token + ')|([^%]+?)', 'gi');
var $7441eabb5801ca04$var$multiMatcher = new RegExp('(' + $7441eabb5801ca04$var$token + ')+', 'gi');
function $7441eabb5801ca04$var$decodeComponents(components, split) {
    try {
        // Try to decode the entire string first
        return [
            decodeURIComponent(components.join(''))
        ];
    } catch (err) {
    // Do nothing
    }
    if (components.length === 1) return components;
    split = split || 1;
    // Split the array in 2 parts
    var left = components.slice(0, split);
    var right = components.slice(split);
    return Array.prototype.concat.call([], $7441eabb5801ca04$var$decodeComponents(left), $7441eabb5801ca04$var$decodeComponents(right));
}
function $7441eabb5801ca04$var$decode(input) {
    try {
        return decodeURIComponent(input);
    } catch (err) {
        var tokens = input.match($7441eabb5801ca04$var$singleMatcher) || [];
        for(var i = 1; i < tokens.length; i++){
            input = $7441eabb5801ca04$var$decodeComponents(tokens, i).join('');
            tokens = input.match($7441eabb5801ca04$var$singleMatcher) || [];
        }
        return input;
    }
}
function $7441eabb5801ca04$var$customDecodeURIComponent(input) {
    // Keep track of all the replacements and prefill the map with the `BOM`
    var replaceMap = {
        '%FE%FF': '\uFFFD\uFFFD',
        '%FF%FE': '\uFFFD\uFFFD'
    };
    var match = $7441eabb5801ca04$var$multiMatcher.exec(input);
    while(match){
        try {
            // Decode as big chunks as possible
            replaceMap[match[0]] = decodeURIComponent(match[0]);
        } catch (err) {
            var result = $7441eabb5801ca04$var$decode(match[0]);
            if (result !== match[0]) replaceMap[match[0]] = result;
        }
        match = $7441eabb5801ca04$var$multiMatcher.exec(input);
    }
    // Add `%C2` at the end of the map to make sure it does not replace the combinator before everything else
    replaceMap['%C2'] = '\uFFFD';
    var entries = Object.keys(replaceMap);
    for(var i = 0; i < entries.length; i++){
        // Replace all decoded components
        var key = entries[i];
        input = input.replace(new RegExp(key, 'g'), replaceMap[key]);
    }
    return input;
}
module.exports = function(encodedURI) {
    if (typeof encodedURI !== 'string') throw new TypeError('Expected `encodedURI` to be of type `string`, got `' + typeof encodedURI + '`');
    try {
        encodedURI = encodedURI.replace(/\+/g, ' ');
        // Try the built in decoder first
        return decodeURIComponent(encodedURI);
    } catch (err) {
        // Fallback to a more advanced decoder
        return $7441eabb5801ca04$var$customDecodeURIComponent(encodedURI);
    }
};

});

parcelRegister("l4Qn0", function(module, exports) {
'use strict';
module.exports = (string, separator)=>{
    if (!(typeof string === 'string' && typeof separator === 'string')) throw new TypeError('Expected the arguments to be of type `string`');
    if (separator === '') return [
        string
    ];
    const separatorIndex = string.indexOf(separator);
    if (separatorIndex === -1) return [
        string
    ];
    return [
        string.slice(0, separatorIndex),
        string.slice(separatorIndex + separator.length)
    ];
};

});

parcelRegister("9PyLY", function(module, exports) {
'use strict';
module.exports = function(obj, predicate) {
    var ret = {};
    var keys = Object.keys(obj);
    var isArr = Array.isArray(predicate);
    for(var i = 0; i < keys.length; i++){
        var key = keys[i];
        var val = obj[key];
        if (isArr ? predicate.indexOf(key) !== -1 : predicate(key, val, obj)) ret[key] = val;
    }
    return ret;
};

});


parcelRegister("74pGx", function(module, exports) {
$parcel$export(module.exports, "defaultHistoryReplaceFn", () => $525cd4a927009906$export$600dd5bf1b049f11);
const $525cd4a927009906$export$600dd5bf1b049f11 = (newUrl)=>window.history.replaceState({}, '', newUrl);

});

parcelRegister("8ZtlX", function(module, exports) {
$parcel$export(module.exports, "mapKeys", () => $68baca26a6bab057$export$781522908e4e76a1);
$parcel$export(module.exports, "pick", () => $68baca26a6bab057$export$357523c63a2253b9);
$parcel$export(module.exports, "omitBy", () => $68baca26a6bab057$export$d7a617dda645b4e3);
$parcel$export(module.exports, "pickBy", () => $68baca26a6bab057$export$b460b275d6c6aa0);
$parcel$export(module.exports, "omit", () => $68baca26a6bab057$export$30a06c8d3562193f);
$parcel$export(module.exports, "equals", () => $68baca26a6bab057$export$e9bab7fafb253603);
$parcel$export(module.exports, "partition", () => $68baca26a6bab057$export$b29f828819edca8d);
/* eslint-disable no-return-assign, no-sequences */ // https://www.30secondsofcode.org/js/s/map-keys
const $68baca26a6bab057$export$781522908e4e76a1 = (obj, fn)=>Object.keys(obj).reduce((acc, k)=>{
        const key = fn(obj[k], k, obj);
        acc[key] = obj[k];
        return acc;
    }, {});
// https://www.30secondsofcode.org/js/s/pick
const $68baca26a6bab057$export$357523c63a2253b9 = (obj, arr)=>arr.reduce((acc, curr)=>(curr in obj && (acc[curr] = obj[curr]), acc), {});
// https://www.30secondsofcode.org/js/s/omit-by
const $68baca26a6bab057$export$d7a617dda645b4e3 = (obj, fn)=>Object.keys(obj).filter((k)=>!fn(obj[k], k)).reduce((acc, key)=>(acc[key] = obj[key], acc), {});
// https://www.30secondsofcode.org/js/s/pick-by
const $68baca26a6bab057$export$b460b275d6c6aa0 = (obj, fn)=>Object.keys(obj).filter((k)=>fn(obj[k], k)).reduce((acc, key)=>(acc[key] = obj[key], acc), {});
// https://www.30secondsofcode.org/js/s/omit
const $68baca26a6bab057$export$30a06c8d3562193f = (obj, arr)=>Object.keys(obj).filter((k)=>arr.indexOf(k) < 0).reduce((acc, key)=>(acc[key] = obj[key], acc), {});
// https://www.30secondsofcode.org/js/s/equals
const $68baca26a6bab057$export$e9bab7fafb253603 = (a, b)=>{
    if (a === b) return true;
    if (a instanceof Date && b instanceof Date) return a.getTime() === b.getTime();
    if (!a || !b || typeof a !== 'object' && typeof b !== 'object') return a === b;
    if (a.prototype !== b.prototype) return false;
    const keys = Object.keys(a);
    if (keys.length !== Object.keys(b).length) return false;
    return keys.every((k)=>$68baca26a6bab057$export$e9bab7fafb253603(a[k], b[k]));
};
// https://www.30secondsofcode.org/js/s/partition
const $68baca26a6bab057$export$b29f828819edca8d = (arr, fn)=>arr.reduce(// eslint-disable-next-line no-shadow
    (acc, val, i, arr)=>{
        acc[fn(val, i, arr) ? 0 : 1].push(val);
        return acc;
    }, [
        [],
        []
    ]);

});



parcelRegister("9hqdJ", function(module, exports) {
$parcel$export(module.exports, "default", () => $6c1a0a725e9fc5bf$export$2e2bcd8739ae039);

var $6rvcc = parcelRequire("6rvcc");

var $7Io7X = parcelRequire("7Io7X");

var $9BGWy = parcelRequire("9BGWy");

var $b4U7t = parcelRequire("b4U7t");
class $6c1a0a725e9fc5bf$export$2e2bcd8739ae039 {
    constructor(fireDelayedEvent, compressors){
        (0, $6rvcc.default)(this, "push", (identifier, builtEvent, context, userInfo)=>{
            this.delayQueue.push(identifier, builtEvent, context, userInfo);
        });
        (0, $6rvcc.default)(this, "startLowPriorityEventDelay", (timeout = (0, $7Io7X.DEFAULT_DELAY_TIMEOUT), callback)=>{
            if (Number.isNaN(timeout) || timeout <= 0) throw new Error(`Invalid timeout period: ${timeout}, must be a number greater than 0`);
            if (this.delayTimeout) clearTimeout(this.delayTimeout);
            const delayTimeoutPeriod = timeout ? Math.min(timeout, (0, $7Io7X.MAX_DELAY_TIMEOUT)) : (0, $7Io7X.MAX_DELAY_TIMEOUT);
            this.delayCallback = callback;
            this.delayTimeout = setTimeout(()=>this.stopLowPriorityEventDelay((0, $b4U7t.StopLowPriorityEventDelayReason).TIMEOUT), delayTimeoutPeriod);
            // If the queue is still flushing from a previous delay period, then we should cancel that flush
            // to stop it from negatively impacting the performance of the new critical section
            this.delayQueue.cancelFlush();
            this.isDelaying = true;
        });
        (0, $6rvcc.default)(this, "stopLowPriorityEventDelay", (reason = (0, $b4U7t.StopLowPriorityEventDelayReason).MANUAL)=>{
            var _this$delayCallback;
            if (this.delayTimeout) {
                clearTimeout(this.delayTimeout);
                this.delayTimeout = undefined;
            }
            this.delayQueue.startFlush();
            this.isDelaying = false;
            (_this$delayCallback = this.delayCallback) === null || _this$delayCallback === void 0 || _this$delayCallback.call(this, reason);
            this.delayCallback = undefined;
        });
        (0, $6rvcc.default)(this, "isDelayingLowPriorityEvents", ()=>this.isDelaying);
        this.isDelaying = false;
        this.delayQueue = new (0, $9BGWy.default)(fireDelayedEvent, compressors);
    }
}

});
parcelRegister("7Io7X", function(module, exports) {
$parcel$export(module.exports, "DEFAULT_DELAY_TIMEOUT", () => $59df5babe6000c50$export$cf090d5281b5ae06);
$parcel$export(module.exports, "MAX_DELAY_TIMEOUT", () => $59df5babe6000c50$export$8575e30be0feb909);
const $59df5babe6000c50$export$cf090d5281b5ae06 = 10000;
const $59df5babe6000c50$export$8575e30be0feb909 = 30000;

});

parcelRegister("9BGWy", function(module, exports) {
$parcel$export(module.exports, "default", () => $6fe8e1689316f53e$export$2e2bcd8739ae039);

var $6rvcc = parcelRequire("6rvcc");

var $478yZ = parcelRequire("478yZ");

var $8ZtlX = parcelRequire("8ZtlX");

var $7VElg = parcelRequire("7VElg");
// We want to throttle the flush rate so that we don't have a huge upfront performance hit from starting the flush,
// and so that the underlying Segment client has some time to process some events in its queue before more are added.
const $6fe8e1689316f53e$var$FLUSH_BATCH_SIZE = 7; // aligns with the default batch size of Segment's BatchableQueue
const $6fe8e1689316f53e$var$FLUSH_BATCH_BACKOFF_PERIOD = 100;
class $6fe8e1689316f53e$export$2e2bcd8739ae039 {
    constructor(processFn, compressionRules){
        (0, $6rvcc.default)(this, "push", (identifier, builtEvent, context, userInfo)=>{
            this.eventArgs.push({
                identifier: identifier,
                builtEvent: builtEvent,
                context: context,
                userInfo: userInfo
            });
        });
        (0, $6rvcc.default)(this, "size", ()=>this.eventArgs.length);
        (0, $6rvcc.default)(this, "startFlush", ()=>{
            try {
                this.eventArgs = this.compressEventArgs(this.eventArgs);
            } catch (e) {
                // eslint-disable-next-line no-console
                console.warn('Failed to perform compression on the delayed analytics events. ' + `Error: ${e.message}. Sending ${this.eventArgs.length} uncompressed events instead`);
            }
            this.flushNextBatch();
        });
        (0, $6rvcc.default)(this, "cancelFlush", ()=>{
            if (this.flushBatchTimeout) {
                clearTimeout(this.flushBatchTimeout);
                this.flushBatchTimeout = null;
            }
        });
        (0, $6rvcc.default)(this, "flushNextBatch", ()=>{
            const batch = this.eventArgs.splice(0, $6fe8e1689316f53e$var$FLUSH_BATCH_SIZE);
            batch.forEach((item)=>this.processFn(item.identifier, item.builtEvent, item.context, item.userInfo));
            if (this.eventArgs.length > 0) this.flushBatchTimeout = setTimeout(()=>this.flushNextBatch(), $6fe8e1689316f53e$var$FLUSH_BATCH_BACKOFF_PERIOD);
            else this.flushBatchTimeout = null;
        });
        (0, $6rvcc.default)(this, "compressEventArgs", (eventArgs)=>{
            const [compressibleEventArgs, incompressibleEventArgs] = (0, $8ZtlX.partition)(eventArgs, (args)=>this.compressor.canCompress(args.builtEvent));
            // Events can only be compressed together if they share the same context and user info, since these are top-level
            // fields that need to exist on the fired event and can only be set to a single value.
            // We can achieve this by grouping our events by context prior to passing them to the compressor.
            const contextGroups = compressibleEventArgs.reduce((groups, args)=>{
                const matchingGroup = groups.find((group)=>(0, $8ZtlX.equals)(group.userInfo, args.userInfo) && (0, $8ZtlX.equals)(group.context, args.context));
                if (matchingGroup) matchingGroup.eventArgs.push(args);
                else groups.push({
                    userInfo: args.userInfo,
                    context: args.context,
                    eventArgs: [
                        args
                    ]
                });
                return groups;
            }, []);
            // Run the compressor on each group
            const allCompressedEventArgs = contextGroups.reduce((acc, group)=>{
                try {
                    const events = group.eventArgs.map((args)=>args.builtEvent);
                    const compressedEvents = this.compressor.compress(events);
                    const compressedEventArgs = compressedEvents.map((compressedEvent)=>({
                            identifier: (0, $478yZ.buildActionName)(compressedEvent),
                            builtEvent: compressedEvent,
                            userInfo: group.userInfo,
                            context: group.context
                        }));
                    return acc.concat(compressedEventArgs);
                } catch (e) {
                    // If anything goes wrong while compressing this group, then just fall back on the
                    // uncompressed events instead. The event compressor already handles errors with invalid
                    // generator functions or results, but this is an extra layer of defense to prevent data
                    // loss in the event of an unexpected error.
                    // eslint-disable-next-line no-console
                    console.warn('Failed to compress some analytics events. ' + `Error: ${e.message}. Sending ${group.eventArgs.length} uncompressed events instead`);
                    return group.eventArgs;
                }
            }, []);
            incompressibleEventArgs.forEach((args)=>allCompressedEventArgs.push(args));
            return allCompressedEventArgs;
        });
        this.processFn = processFn;
        this.flushBatchTimeout = null;
        this.eventArgs = [];
        this.compressor = new (0, $7VElg.default)(compressionRules);
    }
}

});
parcelRegister("7VElg", function(module, exports) {
$parcel$export(module.exports, "default", () => $5c5d265bae4f52f8$export$2e2bcd8739ae039);

var $6rvcc = parcelRequire("6rvcc");

var $3Bvfg = parcelRequire("3Bvfg");

var $8ZtlX = parcelRequire("8ZtlX");

var $aFMrF = parcelRequire("aFMrF");
function $5c5d265bae4f52f8$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $5c5d265bae4f52f8$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $5c5d265bae4f52f8$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $6rvcc.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $5c5d265bae4f52f8$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
class $5c5d265bae4f52f8$export$2e2bcd8739ae039 {
    constructor(compressionRules = []){
        (0, $6rvcc.default)(this, "canCompress", (event)=>this.compressionRules.some((compressionRule)=>compressionRule.canCompress(event)));
        (0, $6rvcc.default)(this, "compress", (events)=>{
            const groups = this.createGroups(events);
            return groups.reduce((allCompressedEvents, group)=>{
                const groupCompressedEvents = this.compressGroup(group);
                return allCompressedEvents.concat(groupCompressedEvents);
            }, []);
        });
        (0, $6rvcc.default)(this, "createGroups", (events)=>// Group events based on contextual fields. These fields are anything that is added by the client itself,
            // rather than passed in by the caller (eg. product, org. and tenant info)
            events.reduce((groups, event)=>{
                const matchingCompressor = this.compressionRules.find((compressor)=>compressor.canCompress(event));
                let contextFields;
                if (matchingCompressor) {
                    const actionFields = (0, $3Bvfg.buildActionFields)(event, event.eventType);
                    contextFields = (0, $8ZtlX.omit)(event, Object.keys(actionFields));
                }
                const matchingGroup = groups.find((group)=>matchingCompressor === group.compressor && (0, $8ZtlX.equals)(contextFields, group.contextFields));
                if (matchingGroup) matchingGroup.events.push(event);
                else groups.push({
                    contextFields: contextFields,
                    compressor: matchingCompressor,
                    events: [
                        event
                    ]
                });
                return groups;
            }, []));
        (0, $6rvcc.default)(this, "compressGroup", (group)=>{
            // If this group doesn't have any compressor, then the event args are already in their final format
            if (!group.compressor) return group.events;
            try {
                // Run the compressor on the group to generate some new events.
                // The compression function is only expected to return the action fields for each
                // event that it generates, since all other fields are generated by the client.
                const compressedEventActionFields = group.compressor.compress(group.events);
                // Add the context fields to each of the resulting events to inflate them into a full action event
                return compressedEventActionFields.map((actionFields)=>$5c5d265bae4f52f8$var$_objectSpread($5c5d265bae4f52f8$var$_objectSpread({}, actionFields), group.contextFields));
            } catch (e) {
                // If we fail to compress the events, then just fall back the uncompressed events
                // so that no data is lost. This can happen if the compression function throws an error
                // or returns some invalid event payloads.
                // eslint-disable-next-line no-console
                // console.warn(
                // 	'Failed to compress some analytics events. ' +
                // 		`Error: ${(e as Error).message}. Sending ${
                // 			group.events.length
                // 		} uncompressed events instead`,
                // );
                return group.events;
            }
        });
        if (!Array.isArray(compressionRules)) throw new Error('Event compressors must be constructed with an array of CompressionRules');
        if (!compressionRules.every((rule)=>rule instanceof (0, $aFMrF.CompressionRule))) throw new Error('Event compressors can only be constructed with instances of CompressionRule');
        this.compressionRules = compressionRules;
    }
}

});
parcelRegister("aFMrF", function(module, exports) {
$parcel$export(module.exports, "CompressionRule", () => $7c534fef00d87d47$export$89b3253ddfd2e6e8);

var $6rvcc = parcelRequire("6rvcc");

var $2vM2B = parcelRequire("2vM2B");

var $8ZtlX = parcelRequire("8ZtlX");

var $kCOHZ = parcelRequire("kCOHZ");

var $l6Ufe = parcelRequire("l6Ufe");
class $7c534fef00d87d47$export$89b3253ddfd2e6e8 {
    /**
   * @callback EventPredicate
   * @param {object} event An analytics event
   * @returns {boolean} A flag indicating whether or not the event matches the conditions
   */ /**
   * @callback CompressionFunction
   * @param {Array.<Object>} events A collection of analytics events that match the predicate of this compression rule
   * @returns {Array.<Object>} compressedEvents The compressed analytics events to fire
   */ /**
   * This constructor defines a new rule for compressing analytics events.
   * @param {EventPredicate} predicate
   * @param {CompressionFunction} compressFn
   */ constructor(predicate, compressFn){
        /**
     * This function returns a flag indicating whether or not this instance is capable of compressing the given event.
     * @param event
     * @returns {boolean}
     */ (0, $6rvcc.default)(this, "canCompress", (event)=>{
            try {
                return event && (0, $2vM2B.isActionEventType)(event.eventType) && this.predicate(event);
            } catch (e) {
                return false;
            }
        });
        /**
     * This function compresses as many events in the given collection as possible.<p>
     * Any events in the given collection that do not match the conditions of {@link canCompress} will be left uncompressed and
     * appended to the end of the resulting array.
     *
     * @param events A collection of analytic events to compress
     * @returns {Array.<Object>} The action fields for the resulting compressed events
     */ (0, $6rvcc.default)(this, "compress", (events)=>{
            const [compatibleEvents, incompatibleEvents] = (0, $8ZtlX.partition)(events, (event)=>this.canCompress(event));
            const compressedEvents = this.compressFn(compatibleEvents);
            if (!compressedEvents) throw new Error('No events were returned from the compression function');
            compressedEvents.forEach((event)=>{
                (0, $l6Ufe.validateActionEventType)(event.eventType);
                (0, $kCOHZ.validateActionEvent)(event);
            });
            return compressedEvents.concat(incompatibleEvents);
        });
        if (typeof predicate !== 'function') throw new Error('Invalid predicate, must be a function that accepts an event and returns a boolean');
        if (typeof compressFn !== 'function') throw new Error('Invalid compressFn, must be a function that both accepts and returns an array of events');
        this.predicate = predicate;
        this.compressFn = compressFn;
    }
}

});
parcelRegister("2vM2B", function(module, exports) {
$parcel$export(module.exports, "isActionEventType", () => $1d43bdf01dd62daa$export$d19cebda16f7579a);
/* eslint-disable @atlaskit/volt-strict-mode/no-multiple-exports */ 
var $dpXUu = parcelRequire("dpXUu");
function $1d43bdf01dd62daa$export$d19cebda16f7579a(type) {
    switch(type){
        case (0, $dpXUu.eventType).OPERATIONAL:
        case (0, $dpXUu.eventType).TRACK:
        case (0, $dpXUu.eventType).UI:
            return true;
        default:
            return false;
    }
}

});

parcelRegister("kCOHZ", function(module, exports) {
$parcel$export(module.exports, "validateActionEvent", () => $f03eb0e423f5e21d$export$e0c121325c66ed4c);
/* eslint-disable @atlaskit/volt-strict-mode/no-multiple-exports */ 
var $1F03j = parcelRequire("1F03j");
function $f03eb0e423f5e21d$export$e0c121325c66ed4c(event) {
    if (!event) throw new Error('Missing event');
    if (!event.source) throw new Error('Missing event.source');
    if (!event.actionSubject) throw new Error('Missing event.actionSubject');
    if (!event.action) throw new Error('Missing event.action');
    (0, $1F03j.validateContainers)(event.containers);
}

});
parcelRegister("1F03j", function(module, exports) {
$parcel$export(module.exports, "validateContainers", () => $1359a92b5a227f93$export$e63ea5d8477971d3);
/* eslint-disable @atlaskit/volt-strict-mode/no-multiple-exports */ 
var $3aElN = parcelRequire("3aElN");
function $1359a92b5a227f93$export$e63ea5d8477971d3(containers) {
    if (!containers) return;
    if (containers && containers.constructor !== Object) throw new Error('properties.containers must be an Object');
    Object.values(containers).forEach((container)=>(0, $3aElN.validateContainersObject)(container));
}

});
parcelRegister("3aElN", function(module, exports) {
$parcel$export(module.exports, "validateContainersObject", () => $24f19b0fc028052f$export$df8ff30e3c960006);
/* eslint-disable @atlaskit/volt-strict-mode/no-multiple-exports */ 
var $8OhNE = parcelRequire("8OhNE");
function $24f19b0fc028052f$export$df8ff30e3c960006(container) {
    if (!(0, $8OhNE.isPlainObject)(container)) throw new Error('properties.containers must be an Object');
    if (!('id' in container)) throw new Error("properties.containers is missing field 'id'");
    if (typeof container.id !== 'string') throw new Error('properties.containers.id must be of type String');
    if ('type' in container && typeof container.type !== 'string') throw new Error('properties.containers.type must be of type String');
}

});



parcelRegister("l6Ufe", function(module, exports) {
$parcel$export(module.exports, "validateActionEventType", () => $f5e5c98807f45d8d$export$4a8d7476662aebcc);
/* eslint-disable @atlaskit/volt-strict-mode/no-multiple-exports */ 
var $dpXUu = parcelRequire("dpXUu");

var $2vM2B = parcelRequire("2vM2B");
const $f5e5c98807f45d8d$var$actionEventTypes = Object.freeze([
    (0, $dpXUu.eventType).OPERATIONAL,
    (0, $dpXUu.eventType).TRACK,
    (0, $dpXUu.eventType).UI
]);
function $f5e5c98807f45d8d$export$4a8d7476662aebcc(type) {
    if (!(0, $2vM2B.isActionEventType)(type)) throw new Error(`Invalid action event type: ${type}, must be one of: [${$f5e5c98807f45d8d$var$actionEventTypes}]`);
    return true;
}

});




parcelRegister("b4U7t", function(module, exports) {
$parcel$export(module.exports, "StopLowPriorityEventDelayReason", () => $810b9993bdaf216c$export$fa6e3729c21cb8f);
let $810b9993bdaf216c$export$fa6e3729c21cb8f = /*#__PURE__*/ function(StopLowPriorityEventDelayReason) {
    StopLowPriorityEventDelayReason["TIMEOUT"] = "timeout";
    StopLowPriorityEventDelayReason["MANUAL"] = "manual";
    return StopLowPriorityEventDelayReason;
}({});

});


parcelRegister("9Do9V", function(module, exports) {
$parcel$export(module.exports, "default", () => $703a7f160fd6ee7a$export$2e2bcd8739ae039);

var $6rvcc = parcelRequire("6rvcc");

var $cmI9b = parcelRequire("cmI9b");

var $f4MJF = parcelRequire("f4MJF");

var $1Ygrk = parcelRequire("1Ygrk");

var $acFLR = parcelRequire("acFLR");

var $cHKVx = parcelRequire("cHKVx");

var $o1t1Z = parcelRequire("o1t1Z");

var $bJ6Ic = parcelRequire("bJ6Ic");

var $9vzfq = parcelRequire("9vzfq");

var $c8Y37 = parcelRequire("c8Y37");

var $HBXCt = parcelRequire("HBXCt");

var $hL0G3 = parcelRequire("hL0G3");

var $3I9pn = parcelRequire("3I9pn");

var $zYlx7 = parcelRequire("zYlx7");

var $amec4 = parcelRequire("amec4");

var $5pjnf = parcelRequire("5pjnf");

var $lhwNW = parcelRequire("lhwNW");
function $703a7f160fd6ee7a$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $703a7f160fd6ee7a$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $703a7f160fd6ee7a$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $6rvcc.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $703a7f160fd6ee7a$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
class $703a7f160fd6ee7a$var$AnalyticsAPIResponse {
    constructor(success, validationErrors, message, code, validationReports){
        this.success = success;
        this.validationErrors = validationErrors;
        this.message = message;
        this.code = code;
        this.validationReports = validationReports;
    }
    isSuccess() {
        return this.success;
    }
    getValidationErrors() {
        return this.validationErrors;
    }
    getMessage() {
        return this.message;
    }
    getCode() {
        return this.code;
    }
    getValidationReports() {
        return this.validationReports === undefined ? null : this.validationReports;
    }
}
class $703a7f160fd6ee7a$var$Message {
    constructor(error){
        this.error = error;
    }
}
class $703a7f160fd6ee7a$var$EventValidationReport {
    constructor(messageId, results){
        this.messageId = messageId;
        this.results = results;
    }
    getMessageId() {
        return this.messageId;
    }
    getResults() {
        return this.results;
    }
}
class $703a7f160fd6ee7a$export$2e2bcd8739ae039 {
    constructor(options){
        var _this$options;
        (0, $6rvcc.default)(this, "originTracingClient", null);
        // Using anonymous function so it can have the BatchFlushCallback type associated with it
        // And to allow it to not need bind when passing through to ResilieceQueue.
        (0, $6rvcc.default)(this, "sendEvents", async (items, callback)=>{
            var _this$lastSendEventsE, _this$metadataClient;
            if (this.options.enableEventCalls === false) return;
            const httpRetryCount = this.resilienceQueue.getGlobalRetryCount();
            const metricsPayload = this.metrics.getMetricsPayload();
            const eventsWithXID = await this.attachXIDs(items);
            // Calculating sentAt after the XID generation as this may take some time.
            const sentAt = new Date().toISOString();
            const metadataInfo = await this.metadataClient.getMetadataAsync();
            const [eventUrl, isFallbackUrl] = this.getEventUrl(metadataInfo);
            const metadata = $703a7f160fd6ee7a$var$_objectSpread($703a7f160fd6ee7a$var$_objectSpread({}, metricsPayload), {}, {
                httpRetryCount: httpRetryCount,
                lastSendEventsErrorReason: ((_this$lastSendEventsE = this.lastSendEventsError) === null || _this$lastSendEventsE === void 0 ? void 0 : _this$lastSendEventsE.message) || null,
                // Temporary back-compat
                lastSendEventsError: this.lastSendEventsError,
                lastUrlFallbackError: this.lastUrlFallbackError,
                isUsingFallbackUrl: isFallbackUrl,
                props: (metadataInfo === null || metadataInfo === void 0 ? void 0 : metadataInfo.props) || null,
                metadataClientMetrics: ((_this$metadataClient = this.metadataClient) === null || _this$metadataClient === void 0 ? void 0 : _this$metadataClient.metrics) || null
            });
            // Remove default values from metadata to save space
            this.cleanLibraryMetadata(metadata);
            const unpackagedEvents = eventsWithXID.map((item)=>{
                this.applyExclusions(item);
                item.msg.sentAt = sentAt;
                return item.msg;
            });
            const batchBody = {
                batch: unpackagedEvents,
                sentAt: sentAt,
                metadata: metadata
            };
            try {
                var _this$originTracingCl;
                const response = await (0, $amec4.sendEvents)({
                    url: eventUrl,
                    batch: batchBody,
                    timeout: this.options.requestTimeout
                });
                this.lastSendEventsError = null;
                this.lastUrlFallbackError = null;
                this.metrics.subtractFromMetrics(metricsPayload);
                callback(null, response);
                (_this$originTracingCl = this.originTracingClient) === null || _this$originTracingCl === void 0 || _this$originTracingCl.cleanupOriginParameters(items);
                await this.invokeLocalResponseCallbackAsync(items, response, null);
            } catch (error) {
                // If there's an error, other than one which indicates a temporary problem with the service,
                // we'll stop using the URL from the metadata and fall back to the default URL. After a time
                // we'll fall forward again in case the problem has been resolved.
                if (error instanceof (0, $c8Y37.FetchError) && [
                    429,
                    503
                ].includes(error.statusCode)) // Ignore 429 and 503 errors since they're considered to indicate a temporary
                // issue with the service, rather than a network failure due to blocked requests.
                this.lastSendEventsError = new (0, $hL0G3.LastError)('ServerBusyError', error);
                else {
                    const errorName = error instanceof Error && (0, $5pjnf.ALLOW_LISTED_FETCH_ERROR_NAMES).includes(error.name) ? error.name : 'Unknown';
                    this.lastSendEventsError = new (0, $hL0G3.LastError)(errorName, error);
                    // Handle falling back to the default URL if we're using the metadata URL.
                    this.useUrlFromMetadata = false;
                    // If we're now using the fallback URL, and the last attempt wasn't,
                    // we'll record this as the error that triggered the fallback.
                    const [_, willUseFallbackUrl] = this.getEventUrl(metadataInfo);
                    if (willUseFallbackUrl && willUseFallbackUrl !== isFallbackUrl) this.lastUrlFallbackError = this.lastSendEventsError;
                }
                callback(error, null);
                await this.invokeLocalResponseCallbackAsync(items, null, error);
            }
        });
        this.options = $703a7f160fd6ee7a$var$_objectSpread($703a7f160fd6ee7a$var$_objectSpread({}, options), {}, {
            requestTimeout: options.requestTimeout || (0, $bJ6Ic.DEFAULT_REQUEST_TIMEOUT),
            retryQueueOptions: options.retryQueueOptions || {},
            logger: options.logger || console,
            disableCookiePersistence: options.disableCookiePersistence || false,
            env: options.env,
            perimeter: options.perimeter || '',
            enableMetadataCalls: typeof options.enableMetadataCalls === 'boolean' ? options.enableMetadataCalls : true,
            enableEventCalls: typeof options.enableEventCalls === 'boolean' ? options.enableEventCalls : true
        });
        this.user = new (0, $lhwNW.default)((_this$options = this.options) === null || _this$options === void 0 ? void 0 : _this$options.disableCookiePersistence);
        this.xidPromiseCallback = options.xidPromiseGetter();
        this.gasv3BatchUrl = `${options.apiHostProtocol}://${options.apiHost}/batch`;
        this.metrics = (0, $f4MJF.default)();
        this.responseCallback = options.responseCallback;
        this.resilienceQueue = (0, $cmI9b.default)(options.retryQueuePrefix, options.product, this.options.retryQueueOptions, this.options.logger);
        this.metadataClient = options.metadataClient;
        this.useUrlFromMetadata = true;
        this.lastSendEventsError = null;
        this.lastUrlFallbackError = null;
        setInterval(()=>{
            this.useUrlFromMetadata = true;
        }, 600000);
        this.resilienceQueue.start(this.sendEvents);
    }
    getUser() {
        return this.user;
    }
    async track(eventName, builtEvent, context, callback) {
        const baseEvent = this.buildBaseEvent(context, (0, $5pjnf.SegmentEventTypes).TRACK, builtEvent);
        const eventWithoutMessageId = $703a7f160fd6ee7a$var$_objectSpread($703a7f160fd6ee7a$var$_objectSpread({}, baseEvent), {}, {
            type: (0, $5pjnf.SegmentEventTypes).TRACK,
            properties: (0, $zYlx7.prepareEventProperties)(builtEvent),
            event: eventName
        });
        const event = $703a7f160fd6ee7a$var$_objectSpread($703a7f160fd6ee7a$var$_objectSpread({}, eventWithoutMessageId), {}, {
            messageId: this.createMessageId()
        });
        const packagedEvent = this.packageEvent(event);
        await this.enqueueEvent(packagedEvent);
        if (callback) callback();
    }
    async page(eventName, builtEvent, context, callback) {
        const baseEvent = this.buildBaseEvent(context, (0, $5pjnf.SegmentEventTypes).PAGE, builtEvent);
        const eventWithoutMessageId = $703a7f160fd6ee7a$var$_objectSpread($703a7f160fd6ee7a$var$_objectSpread({}, baseEvent), {}, {
            type: (0, $5pjnf.SegmentEventTypes).PAGE,
            properties: (0, $zYlx7.prepareEventProperties)(builtEvent),
            name: eventName
        });
        const event = $703a7f160fd6ee7a$var$_objectSpread($703a7f160fd6ee7a$var$_objectSpread({}, eventWithoutMessageId), {}, {
            messageId: this.createMessageId()
        });
        const packagedEvent = this.packageEvent(event);
        await this.enqueueEvent(packagedEvent);
        if (callback) callback();
    }
    // Segment uses the identifier to update user id which we have already done in the analyticsWebClient.ts
    async identify(_identifier, builtEvent, context, callback) {
        const baseEvent = this.buildBaseEvent(context, (0, $5pjnf.SegmentEventTypes).IDENTIFY, builtEvent);
        const eventWithoutMessageId = $703a7f160fd6ee7a$var$_objectSpread($703a7f160fd6ee7a$var$_objectSpread({}, baseEvent), {}, {
            type: (0, $5pjnf.SegmentEventTypes).IDENTIFY,
            traits: (0, $zYlx7.prepareEventProperties)(builtEvent)
        });
        const event = $703a7f160fd6ee7a$var$_objectSpread($703a7f160fd6ee7a$var$_objectSpread({}, eventWithoutMessageId), {}, {
            messageId: this.createMessageId()
        });
        const packagedEvent = this.packageEvent(event);
        await this.enqueueEvent(packagedEvent);
        if (callback) callback();
    }
    async enqueueEvent(packagedEvent) {
        if (this.options.enableMetadataCalls) this.metadataClient.start(false); // Start the metadata client if needed
        await this.resilienceQueue.addItem(packagedEvent);
    }
    buildBaseEvent(context, type, overrides) {
        const clonedContext = (0, $3I9pn.prepareEventContext)(context);
        const segmentContext = (0, $o1t1Z.buildContext)(clonedContext, overrides);
        return {
            context: segmentContext,
            timestamp: new Date().toISOString(),
            type: type,
            userId: this.user.getUserId(),
            anonymousId: overrides.anonymousId || this.user.getAnonymousId()
        };
    }
    createMessageId() {
        return `ajs-${(0, $1Ygrk.default)()}`;
    }
    packageEvent(event) {
        const { apiHost: apiHost, apiHostProtocol: apiHostProtocol } = this.options;
        return {
            headers: {
                'Content-Type': 'text/plain'
            },
            msg: event,
            url: `${apiHostProtocol}://${apiHost}/${event.type.charAt(0)}`
        };
    }
    applyExclusions(item) {
        var _msg$context;
        const msg = item.msg;
        const properties = msg.properties;
        const traits = msg.traits;
        const excluded = (_msg$context = msg.context) === null || _msg$context === void 0 ? void 0 : _msg$context.excludedProperties;
        if (!excluded) return;
        if (excluded.anonymousId === true) msg.anonymousId = undefined;
        if (excluded.interactionSession === true) {
            if (properties) properties.interactionSession = undefined;
        }
        if (excluded.sessionId === true) {
            if (properties) properties.sessionId = undefined;
        }
        if (excluded.pageLoadId === true) {
            if (properties) properties.pageLoadId = undefined;
        }
        if (excluded.tabId === true) {
            if (properties) properties.tabId = undefined;
        }
        if (excluded.taskSessions === true) {
            if (properties) properties.taskSessions = undefined;
        }
        if (excluded.userId === true) {
            msg.userId = undefined;
            if (properties) properties.userIdType = undefined;
        }
        if (excluded.xid === true) {
            if (properties) properties.xid = undefined;
            if (traits) traits.xid = undefined;
        }
    }
    getEventUrl(metadataInfo) {
        const preferredBatchUrl = metadataInfo !== null && metadataInfo !== void 0 && metadataInfo.url ? metadataInfo.url : this.gasv3BatchUrl;
        const finalBatchUrl = this.useUrlFromMetadata ? preferredBatchUrl : this.gasv3BatchUrl;
        const isFallbackUrl = preferredBatchUrl === this.gasv3BatchUrl ? null : finalBatchUrl !== preferredBatchUrl;
        return [
            finalBatchUrl,
            isFallbackUrl
        ];
    }
    cleanLibraryMetadata(obj) {
        // skip if the parameter is not an object
        if (obj === null || typeof obj !== 'object') return;
        for(const key in obj){
            // Skip cleaning up props object and its keys
            // to avoid having to check the existence of the fields in props object
            // and manipulate them to calculate metadata signature in analytics service
            if (key === 'props') continue;
            let value = obj[key];
            // Remove null or undefined values
            if (value === null || value === undefined) delete obj[key];
            else if (typeof value === 'number' && value === 0) delete obj[key];
            else if (Array.isArray(value)) {
                if (value.length === 0) delete obj[key];
                else value.forEach((item)=>{
                    this.cleanLibraryMetadata(item);
                });
            } else if (typeof value === 'object') this.cleanLibraryMetadata(obj[key]);
        }
    }
    async invokeLocalResponseCallbackAsync(items, response, error) {
        const localResponseCallback = this.responseCallback;
        if (localResponseCallback) {
            // If we have a response, we'll parse it and create an AnalyticsAPIResponse from it.
            let analyticsAPIResponse = null;
            if (response) {
                var _responseObject$messa;
                let responseObject;
                try {
                    responseObject = await response.clone().json();
                } catch (_unused) {
                // Ignore errors parsing the response, we can't do anything about them
                }
                // Ensure we've got a valid object to work with, filling in any missing
                // properties as best we can.
                responseObject = responseObject || {};
                responseObject.code = Number.parseInt(responseObject.code) > 0 ? Number.parseInt(responseObject.code) : response.status;
                responseObject.success = responseObject.success || responseObject.code >= 200 && responseObject.code <= 299;
                analyticsAPIResponse = new $703a7f160fd6ee7a$var$AnalyticsAPIResponse(responseObject.success, responseObject.validationErrors || new Map(), new $703a7f160fd6ee7a$var$Message(((_responseObject$messa = responseObject.message) === null || _responseObject$messa === void 0 ? void 0 : _responseObject$messa.error) || ''), responseObject.code, responseObject.validationReports || null);
            }
            // If we have an error, but it's not an instance of Error (e.g. it's a string), we'll convert it to an Error object.
            if (error && !(error instanceof Error)) error = new Error(String(error));
            const analyticsResponse = $703a7f160fd6ee7a$var$BatchInterceptor.toAnalyticsResponse(items || [], error || null, // In case 'error' were to be undefined we'll convert it to null.
            analyticsAPIResponse);
            localResponseCallback(analyticsResponse);
        }
    }
    async attachXIDs(items) {
        if (this.xidPromiseCallback) return (0, $acFLR.attachXidToMultipleEvents)(items, this.xidPromiseCallback);
        return Promise.resolve(items);
    }
    /** @internal Used by AnalyticsWebClient to wire up origin tracing cleanup. */ setOriginTracingClient(client) {
        this.originTracingClient = client;
    }
    setResponseCallback(responseCallback) {
        this.responseCallback = responseCallback;
    }
    refreshMetadata(userInfo, tenantInfo) {
        this.metadataClient.userInfo = userInfo;
        this.metadataClient.tenantInfo = tenantInfo;
    }
}
class $703a7f160fd6ee7a$var$BatchInterceptor {
    static toAnalyticsResponse(items, error, analyticsAPIResponse) {
        const eventResponseList = [];
        if (analyticsAPIResponse !== null) {
            const [statusCode, success] = [
                analyticsAPIResponse.code,
                analyticsAPIResponse.success
            ];
            if (statusCode >= 200 && statusCode <= 299) {
                var _analyticsAPIResponse;
                (_analyticsAPIResponse = analyticsAPIResponse.validationReports) === null || _analyticsAPIResponse === void 0 || _analyticsAPIResponse.forEach((report)=>{
                    const matchedEvent = items.find((item)=>item.msg.messageId === report.messageId);
                    if (matchedEvent) eventResponseList.push(new (0, $9vzfq.EventResponse)(matchedEvent.msg.messageId, report.results, matchedEvent.msg));
                });
                return new (0, $cHKVx.AnalyticsResponse)(success, statusCode, (0, $HBXCt.HTTP_STATUS_CODE_MAP).get(statusCode), eventResponseList);
            } else if (statusCode >= 400 && statusCode <= 499) {
                var _analyticsAPIResponse2;
                // not exluding "HTTP 429 Too Many Requests error" as it is thrown as an error and handled below
                const errorMessage = ((_analyticsAPIResponse2 = analyticsAPIResponse.message) === null || _analyticsAPIResponse2 === void 0 ? void 0 : _analyticsAPIResponse2.error) !== null ? analyticsAPIResponse.message.error : (0, $HBXCt.HTTP_STATUS_CODE_MAP).has(statusCode) ? (0, $HBXCt.HTTP_STATUS_CODE_MAP).get(statusCode) : (0, $HBXCt.HTTP_STATUS_CODE_MAP).get(-1);
                items.forEach((item)=>{
                    eventResponseList.push(new (0, $9vzfq.EventResponse)(item.msg.messageId, [], item.msg));
                });
                return new (0, $cHKVx.AnalyticsResponse)(success, statusCode, errorMessage, eventResponseList);
            }
        } else if (error !== null && error !== void 0 && error.message) {
            const match = error.message.match($703a7f160fd6ee7a$var$BatchInterceptor.http_error_regex);
            if (match) {
                items.forEach((item)=>{
                    eventResponseList.push(new (0, $9vzfq.EventResponse)(item.msg.messageId, [], item.msg));
                });
                return new (0, $cHKVx.AnalyticsResponse)(false, Number(match[1]), match[2], eventResponseList);
            }
        }
        items.forEach((item)=>{
            eventResponseList.push(new (0, $9vzfq.EventResponse)(item.msg.messageId, [], item.msg));
        });
        return new (0, $cHKVx.AnalyticsResponse)(false, -1, (0, $HBXCt.HTTP_STATUS_CODE_MAP).get(-1), eventResponseList);
    }
}
(0, $6rvcc.default)($703a7f160fd6ee7a$var$BatchInterceptor, "http_error_regex", /HTTP Error\s([0-9]{3})\s\((.+)\)/);

});
parcelRegister("cmI9b", function(module, exports) {
$parcel$export(module.exports, "default", () => $9009c8d029fe1a5f$export$2e2bcd8739ae039);
/* eslint-disable @repo/internal/deprecations/deprecation-ticket-required -- VOLTC-139 tracks removal of these deprecated re-export shims. */ 
var $3zQGx = parcelRequire("3zQGx");

var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$9009c8d029fe1a5f$export$2e2bcd8739ae039 = (retryQueuePrefix, product, options, logger)=>{
    return new (0, $3zQGx.default)(retryQueuePrefix, product, options || {}, logger);
};

});
parcelRegister("3zQGx", function(module, exports) {
$parcel$export(module.exports, "DEFAULT_POLLING_OPTIONS", () => $29ad82233d2d80ba$export$d219df4fe04c04a7);
$parcel$export(module.exports, "default", () => $29ad82233d2d80ba$export$2e2bcd8739ae039);

var $6rvcc = parcelRequire("6rvcc");

var $g0txv = parcelRequire("g0txv");

var $b6FTZ = parcelRequire("b6FTZ");

var $aB9ZI = parcelRequire("aB9ZI");

var $4r6Zx = parcelRequire("4r6Zx");

var $ldMum = parcelRequire("ldMum");

var $f4MJF = parcelRequire("f4MJF");

var $2SiT1 = parcelRequire("2SiT1");

var $cx5q7 = parcelRequire("cx5q7");

var $3efd3 = parcelRequire("3efd3");

var $9GE8Y = parcelRequire("9GE8Y");
function $29ad82233d2d80ba$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $29ad82233d2d80ba$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $29ad82233d2d80ba$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $6rvcc.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $29ad82233d2d80ba$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
const $29ad82233d2d80ba$var$ONE_MINUTE = 60000;
const $29ad82233d2d80ba$var$LONG_POLLING_OPTIONS = {
    backoffFactor: 0,
    backoffJitterPercentage: 0,
    flushWaitMs: $29ad82233d2d80ba$var$ONE_MINUTE,
    minRetryDelay: $29ad82233d2d80ba$var$ONE_MINUTE,
    maxRetryDelay: $29ad82233d2d80ba$var$ONE_MINUTE
};
const $29ad82233d2d80ba$export$d219df4fe04c04a7 = {
    backoffFactor: 2,
    backoffJitterPercentage: 0.2,
    batchFlushSize: 7,
    flushBeforeUnload: false,
    flushWaitMs: 500,
    maxAttempts: 10,
    // The maximum number of events that can be stored in the resilience queue (IndexedDB/memory).
    // This limit is per product and is enforced by the EventCountGuard in the resilience layer.
    maxQueueSize: 8000,
    maxRetryDelay: 30000,
    minRetryDelay: 1000
};
class $29ad82233d2d80ba$export$2e2bcd8739ae039 {
    constructor(queuePrefix, product, options, logger){
        this.queuePrefix = queuePrefix;
        // Avoiding using options in ResilienceDB at this stage as
        // the options are optimised for the PushBatchableQueue
        this.resilience = new (0, $aB9ZI.default)(product, {
            logger: logger,
            maxAttempts: options === null || options === void 0 ? void 0 : options.maxAttempts,
            maxEventLimit: (options === null || options === void 0 ? void 0 : options.maxQueueSize) || $29ad82233d2d80ba$export$d219df4fe04c04a7.maxQueueSize
        });
        this.options = this.buildOptions(options);
        this.scheduler = new (0, $cx5q7.default)($29ad82233d2d80ba$var$_objectSpread($29ad82233d2d80ba$var$_objectSpread({}, this.options), {}, {
            waitInterval: options !== null && options !== void 0 && options.flushBeforeUnload ? 0 : this.options.flushWaitMs
        }), this.scheduleCallback.bind(this));
        this.longPollingScheduler = new (0, $cx5q7.default)($29ad82233d2d80ba$var$_objectSpread($29ad82233d2d80ba$var$_objectSpread({}, $29ad82233d2d80ba$var$LONG_POLLING_OPTIONS), {}, {
            waitInterval: $29ad82233d2d80ba$var$LONG_POLLING_OPTIONS.flushWaitMs
        }), this.scheduleLongCallBack.bind(this));
        this.metricsCollector = (0, $f4MJF.default)();
        this.networkStatus = new (0, $2SiT1.default)((status)=>{
            if (status === (0, $9GE8Y.NetworkStatusEnum).OFFLINE) this.scheduler.stop();
            else this.checkEventCountAndReschedule();
        });
    }
    start(flushCallback) {
        this.batchFlushCallback = flushCallback;
        this.longPollingScheduler.schedule();
    }
    stop() {
        this.scheduler.stop();
        this.longPollingScheduler.stop();
    }
    async addItem(item) {
        // Since Jira and Confluence use `.toJSON` on objects that should be strings
        // And expect us to use `JSON.stringify` on these objects,
        // And indexeddb strips these functions from the objects when adding them to the DB,
        // We must run this silly stringify and parse before passing the event to the resilience meechanism.
        // Planning on removing this in v4
        const jsonStringifiedAndParsedItem = JSON.parse(JSON.stringify(item));
        const { numberOfEvictedItems: numberOfEvictedItems } = await this.resilience.addItem(jsonStringifiedAndParsedItem, {}, (0, $4r6Zx.GuardPolicy).EVICT);
        this.scheduler.schedule();
        this.metricsCollector.addToEventCount();
        if (numberOfEvictedItems > 0) this.metricsCollector.addToItemsDiscardedByOverflowCounter(numberOfEvictedItems);
    }
    getGlobalRetryCount() {
        return this.scheduler.getFailureCount();
    }
    async scheduleCallback(done) {
        // Even though we stopped the scheduler, it can be restarted with a call to schedule.
        // This could be triggered by a new event or the longPollingScheduler
        if (this.networkStatus.getNetworkStatus() === (0, $9GE8Y.NetworkStatusEnum).OFFLINE) {
            done((0, $3efd3.DoneState).NOOP);
            return;
        }
        try {
            const result = await this.resilience.processItems(this.flush.bind(this), this.options.batchFlushSize);
            done(result);
        } catch (error) {
            if (error.name === (0, $ldMum.CallbackProcessingErrorName)) {
                done((0, $3efd3.DoneState).ERROR);
                return;
            }
        // TODO we can probably log here but throwing is useless as it will just be shallowed by the Scheduler
        // In theory something else should catch all other errors from indexeddb and this should never happen.
        } finally{
            await this.checkEventCountAndReschedule();
        }
    }
    async checkEventCountAndReschedule() {
        const eventWaitingCount = await this.resilience.getItemCount();
        if (eventWaitingCount > 0) this.scheduler.schedule({
            immediate: eventWaitingCount >= this.options.batchFlushSize
        });
    }
    async scheduleLongCallBack(done) {
        // Eventually we will want to send data about how many queues were purged
        const numberOfQueuesPurged = (0, $g0txv.default)(this.queuePrefix);
        this.metricsCollector.addToPurgedQueuesMetrics(numberOfQueuesPurged);
        // Eventually we will want to send data about how attempted reclaims and actual reclaims were made
        const reclaimMetrics = await (0, $b6FTZ.default)(this.queuePrefix, async (localStorageItems)=>{
            const itemsToAdd = localStorageItems.map((localStorageItem)=>({
                    item: localStorageItem.item,
                    retryAttempts: localStorageItem.attemptNumber,
                    id: localStorageItem.id
                }));
            const { items: addedEvents } = await this.resilience.bulkAddItem(itemsToAdd, (0, $4r6Zx.GuardPolicy).IGNORE);
            if (addedEvents.length === itemsToAdd.length) return {
                status: 'successful'
            };
            else return {
                status: 'partial',
                acceptedItemIds: addedEvents.map((event)=>event.id)
            };
        });
        this.metricsCollector.addToReclaimMetrics(reclaimMetrics);
        // We dont want to flush events from here as there maybe issues with analytics-service
        // Scheduler has all the context and can schedule the next batch accordingly
        await this.checkEventCountAndReschedule();
        done((0, $3efd3.DoneState).SUCCESS);
        this.longPollingScheduler.schedule();
    }
    flush(wrappedItems, otherMetadata) {
        this.metricsCollector.setResilienceMechanism(this.resilience.storeType());
        const { batchFlushCallback: batchFlushCallback } = this;
        if (!batchFlushCallback) throw new Error('batchFlushCallback has not been set. Call PullBatchableQueue#start first.');
        return new Promise((resolve, reject)=>{
            if (wrappedItems.length <= 0) {
                resolve((0, $3efd3.DoneState).NOOP);
                return;
            }
            const items = wrappedItems.map((wrappedItem)=>{
                const item = wrappedItem.item;
                if (wrappedItem.retryAttempts > 0 && item.msg) {
                    if (!item.msg._metadata) item.msg._metadata = {};
                    item.msg._metadata.failedAttempts = wrappedItem.retryAttempts;
                }
                return item;
            });
            batchFlushCallback(items, (error)=>{
                if (error) {
                    if (otherMetadata.numberOfDeletedItems > 0) this.metricsCollector.addToItemsDiscardedByRetryCounter(otherMetadata.numberOfDeletedItems);
                    reject(error);
                } else resolve((0, $3efd3.DoneState).SUCCESS);
            });
        });
    }
    buildOptions(options) {
        return {
            backoffFactor: (options === null || options === void 0 ? void 0 : options.backoffFactor) || $29ad82233d2d80ba$export$d219df4fe04c04a7.backoffFactor,
            backoffJitterPercentage: (options === null || options === void 0 ? void 0 : options.backoffJitterPercentage) !== undefined ? options.backoffJitterPercentage : $29ad82233d2d80ba$export$d219df4fe04c04a7.backoffJitterPercentage,
            batchFlushSize: (options === null || options === void 0 ? void 0 : options.batchFlushSize) || $29ad82233d2d80ba$export$d219df4fe04c04a7.batchFlushSize,
            flushBeforeUnload: (options === null || options === void 0 ? void 0 : options.flushBeforeUnload) || $29ad82233d2d80ba$export$d219df4fe04c04a7.flushBeforeUnload,
            flushWaitMs: (options === null || options === void 0 ? void 0 : options.flushWaitMs) || $29ad82233d2d80ba$export$d219df4fe04c04a7.flushWaitMs,
            maxQueueSize: (options === null || options === void 0 ? void 0 : options.maxQueueSize) || $29ad82233d2d80ba$export$d219df4fe04c04a7.maxQueueSize,
            maxAttempts: (options === null || options === void 0 ? void 0 : options.maxAttempts) || $29ad82233d2d80ba$export$d219df4fe04c04a7.maxAttempts,
            maxRetryDelay: (options === null || options === void 0 ? void 0 : options.maxRetryDelay) || $29ad82233d2d80ba$export$d219df4fe04c04a7.maxRetryDelay,
            minRetryDelay: (options === null || options === void 0 ? void 0 : options.minRetryDelay) || $29ad82233d2d80ba$export$d219df4fe04c04a7.minRetryDelay
        };
    }
}

});
parcelRegister("g0txv", function(module, exports) {
$parcel$export(module.exports, "default", () => $ba738f5e1bb5880f$export$2e2bcd8739ae039);

var $4uOvq = parcelRequire("4uOvq");

var $2uDuF = parcelRequire("2uDuF");
// For more details on this funciton, see https://hello.atlassian.net/wiki/spaces/MEASURE/pages/585086028/Investigation+Local+storage+full
// TL;DR
// If a queue looses its `ack` key in localstorage, it will never get claimed.
// There is a small chance that this can happen.
// This function is to run through queues and clean any that have been orphaned.
// Keys stolen from https://github.com/segmentio/localstorage-retry/blob/master/lib/index.js#L55
const $ba738f5e1bb5880f$var$validSuffixs = Object.values((0, $4uOvq.LocalStorageKeySuffix));
var $ba738f5e1bb5880f$export$2e2bcd8739ae039 = (prefix)=>{
    if (typeof prefix !== 'string' || prefix.length === 0) // We do not want to start deleting everything in localstorage
    return 0;
    try {
        // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
        const queueStates = Object.keys(localStorage).filter((key)=>key && key.startsWith(`${prefix}.`) || false).map((key)=>key.split('.')).filter((splitKeys)=>splitKeys.length === 3 && $ba738f5e1bb5880f$var$validSuffixs.includes(splitKeys[2])).reduce((accumulator, currentKeys)=>{
            const [, id, suffix] = currentKeys;
            if (accumulator[id] === undefined) accumulator[id] = {};
            accumulator[id][suffix] = true;
            return accumulator;
        }, {});
        const queuesToPurge = Object.keys(queueStates).filter((id)=>queueStates[id][(0, $4uOvq.LocalStorageKeySuffix).ACK] !== true);
        queuesToPurge.forEach((id)=>{
            const { queue: queue, inProgress: inProgress, reclaimStart: reclaimStart, reclaimEnd: reclaimEnd } = (0, $2uDuF.createLocalStorageKeys)(prefix, id);
            // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
            localStorage.removeItem(inProgress);
            // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
            localStorage.removeItem(queue);
            // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
            localStorage.removeItem(reclaimStart);
            // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
            localStorage.removeItem(reclaimEnd);
        });
        return queuesToPurge.length;
    } catch (_error) {
    // Ignore errors from localStorage.
    }
    return 0;
};

});
parcelRegister("4uOvq", function(module, exports) {
$parcel$export(module.exports, "LocalStorageKeySuffix", () => $34612426f666b75f$export$ecfa71cbc9b28241);
$parcel$export(module.exports, "Timers", () => $34612426f666b75f$export$8bb2c1fb2b1765a9);
let $34612426f666b75f$export$ecfa71cbc9b28241 = /*#__PURE__*/ function(LocalStorageKeySuffix) {
    LocalStorageKeySuffix["IN_PROGRESS"] = "inProgress";
    LocalStorageKeySuffix["QUEUE"] = "queue";
    LocalStorageKeySuffix["RECLAIM_START"] = "reclaimStart";
    LocalStorageKeySuffix["RECLAIM_END"] = "reclaimEnd";
    LocalStorageKeySuffix["ACK"] = "ack";
    return LocalStorageKeySuffix;
}({});
let $34612426f666b75f$export$8bb2c1fb2b1765a9 = /*#__PURE__*/ function(Timers) {
    Timers[Timers["RECLAIM_TIMEOUT"] = 10000] = "RECLAIM_TIMEOUT";
    Timers[Timers["RECLAIM_WAIT"] = 500] = "RECLAIM_WAIT";
    Timers[Timers["RECLAIM_WAIT_THRESHOLD"] = 2000] = "RECLAIM_WAIT_THRESHOLD";
    return Timers;
}({});

});

parcelRegister("2uDuF", function(module, exports) {
$parcel$export(module.exports, "createLocalStorageKeys", () => $1d0d04b78b826b82$export$8433d54f767cbec5);

var $4uOvq = parcelRequire("4uOvq");
const $1d0d04b78b826b82$export$8433d54f767cbec5 = (queuePrefix, queueId)=>({
        [(0, $4uOvq.LocalStorageKeySuffix).ACK]: `${queuePrefix}.${queueId}.${(0, $4uOvq.LocalStorageKeySuffix).ACK}`,
        [(0, $4uOvq.LocalStorageKeySuffix).QUEUE]: `${queuePrefix}.${queueId}.${(0, $4uOvq.LocalStorageKeySuffix).QUEUE}`,
        [(0, $4uOvq.LocalStorageKeySuffix).IN_PROGRESS]: `${queuePrefix}.${queueId}.${(0, $4uOvq.LocalStorageKeySuffix).IN_PROGRESS}`,
        [(0, $4uOvq.LocalStorageKeySuffix).RECLAIM_START]: `${queuePrefix}.${queueId}.${(0, $4uOvq.LocalStorageKeySuffix).RECLAIM_START}`,
        [(0, $4uOvq.LocalStorageKeySuffix).RECLAIM_END]: `${queuePrefix}.${queueId}.${(0, $4uOvq.LocalStorageKeySuffix).RECLAIM_END}`
    });

});


parcelRegister("b6FTZ", function(module, exports) {
$parcel$export(module.exports, "default", () => $021634adde976b1b$export$2e2bcd8739ae039);

var $6rvcc = parcelRequire("6rvcc");

var $1Ygrk = parcelRequire("1Ygrk");

var $4uOvq = parcelRequire("4uOvq");

var $2uDuF = parcelRequire("2uDuF");
function $021634adde976b1b$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $021634adde976b1b$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $021634adde976b1b$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $6rvcc.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $021634adde976b1b$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
// Code we need to mimic:
// https://github.com/segmentio/localstorage-retry/blob/master/lib/index.js#L262-L357
// Note we do not want to run this library due to the performance, duplication and memory leak issues.
const $021634adde976b1b$var$promisedSetTimeout = (msToWait)=>new Promise((resolve)=>{
        setTimeout(resolve, msToWait);
    });
const $021634adde976b1b$var$findOtherQueues = (queuePrefix)=>{
    try {
        // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
        return Object.keys(localStorage).filter((key)=>key.startsWith(queuePrefix)).map((key)=>key.split('.')).filter((split)=>{
            if (split.length === 3 && split[0] === queuePrefix && split[2] === (0, $4uOvq.LocalStorageKeySuffix).ACK) try {
                // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
                const ackTimestamp = localStorage.getItem(split.join('.'));
                if (ackTimestamp) {
                    const ackTimestampNumber = parseInt(ackTimestamp);
                    return (0, $4uOvq.Timers).RECLAIM_TIMEOUT + ackTimestampNumber < Date.now();
                }
            } catch (_unused) {
            // ignore and drop value
            }
            return false;
        }).map((split)=>split[1]);
    } catch (_unused2) {
    // Ignore errors from accessing localStorage.
    }
    return [];
};
const $021634adde976b1b$var$tryReclaim = async (options, callback)=>{
    const { ack: ack, reclaimStart: reclaimStart, reclaimEnd: reclaimEnd } = options.storageKeys;
    const start = Date.now();
    // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
    localStorage.setItem(reclaimStart, options.reclaimProcessId);
    // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
    localStorage.setItem(ack, start.toString());
    await $021634adde976b1b$var$promisedSetTimeout((0, $4uOvq.Timers).RECLAIM_WAIT);
    if (// Prevent duplicates when extracting events from localstorage due to CPU / Memory pressure on client
    Date.now() > start + (0, $4uOvq.Timers).RECLAIM_WAIT_THRESHOLD || // Either the parent has caught up and removed our claim, or someone else started a claim instead
    // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
    localStorage.getItem(reclaimStart) !== options.reclaimProcessId) throw new Error('Took to long to callback, reclaim abandonded. After reclaimStart.');
    // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
    localStorage.setItem(reclaimEnd, options.reclaimProcessId);
    await $021634adde976b1b$var$promisedSetTimeout((0, $4uOvq.Timers).RECLAIM_WAIT);
    if (// Prevent duplicates when extracting events from localstorage due to CPU / Memory pressure on client
    Date.now() > start + (0, $4uOvq.Timers).RECLAIM_WAIT_THRESHOLD || // Either the parent has caught up and removed our claim, or someone else started a claim instead
    // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
    localStorage.getItem(reclaimStart) !== options.reclaimProcessId || // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
    localStorage.getItem(reclaimEnd) !== options.reclaimProcessId) throw new Error('Took to long to callback, reclaim abandonded. After reclaimEnd.');
    return $021634adde976b1b$var$reclaim(options, callback);
};
const $021634adde976b1b$var$reclaim = async (options, callback)=>{
    const { queue: queue, inProgress: inProgress } = options.storageKeys;
    // Queue is an array of events while inProgress is an object with a uuid for key
    // Either of these queues may legitimately be missing.
    // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
    const eventsInQueue = JSON.parse(localStorage.getItem(queue) || '[]');
    const eventsInProgress = JSON.parse(// eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
    localStorage.getItem(inProgress) || '{}');
    const arrayOfEventsInProgress = Object.entries(eventsInProgress).map(([key, item])=>{
        const itemWithId = $021634adde976b1b$var$_objectSpread($021634adde976b1b$var$_objectSpread({}, item), {}, {
            // LocalStorage-retry would add the attemptCounter after failure, rather than
            // as it was being processed
            attemptNumber: item.attemptNumber + 1,
            id: key
        });
        return itemWithId;
    });
    const eventsToProcess = [
        ...eventsInQueue,
        ...arrayOfEventsInProgress
    ];
    if (eventsToProcess.length > 0) {
        const result = await callback(eventsToProcess);
        if (result.status === 'successful') $021634adde976b1b$var$clearLocalStorageKeys(options.storageKeys);
        else if (result.status === 'partial') {
            // Dont delete all events if we are only able to take some of them.
            const leftover = eventsToProcess.filter((event)=>!result.acceptedItemIds.includes(event.id));
            // This way around, we can almost ensure that we wont hit memory quota exceeded errors.
            // However, there is a very small chance that we may lose events if the process exits between these two commands.
            // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
            localStorage.removeItem(inProgress);
            // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
            localStorage.setItem(queue, JSON.stringify(leftover));
            return {
                fullReclaim: false
            };
        }
    } else $021634adde976b1b$var$clearLocalStorageKeys(options.storageKeys);
    return {
        fullReclaim: true
    };
};
// Exterminate
const $021634adde976b1b$var$clearLocalStorageKeys = (keys)=>{
    // Always good to do queue and inprogress first to reduce duplications
    // and to free up more space in localstorage
    // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
    localStorage.removeItem(keys.queue);
    // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
    localStorage.removeItem(keys.inProgress);
    // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
    localStorage.removeItem(keys.reclaimEnd);
    // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
    localStorage.removeItem(keys.reclaimStart);
    // This has to be last or we risk leaving things in localStorage that have to be purged
    // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
    localStorage.removeItem(keys.ack);
};
var $021634adde976b1b$export$2e2bcd8739ae039 = async (queuePrefix, callback)=>{
    if (typeof queuePrefix !== 'string' || queuePrefix.length === 0) // We do not want to start deleting everything in localstorage
    return {
        fullReclaims: 0,
        partialReclaims: 0,
        failedReclaims: 0
    };
    const reclaimProcessId = (0, $1Ygrk.default)();
    const queuesToReclaim = $021634adde976b1b$var$findOtherQueues(queuePrefix);
    const claims = queuesToReclaim.map((id)=>$021634adde976b1b$var$tryReclaim({
            queuePrefix: queuePrefix,
            reclaimProcessId: reclaimProcessId,
            storageKeys: (0, $2uDuF.createLocalStorageKeys)(queuePrefix, id)
        }, callback));
    const settledClaims = await Promise.allSettled(claims);
    const failedReclaims = settledClaims.filter((claim)=>claim.status === 'rejected');
    const successfulClaims = settledClaims.filter((settledValue)=>settledValue.status === 'fulfilled').map((result)=>result.value);
    const fullReclaims = successfulClaims.filter((claim)=>claim.fullReclaim);
    const partialReclaims = successfulClaims.filter((claim)=>!claim.fullReclaim);
    return {
        failedReclaims: failedReclaims.length,
        partialReclaims: partialReclaims.length,
        fullReclaims: fullReclaims.length
    };
};

});
parcelRegister("1Ygrk", function(module, exports) {
$parcel$export(module.exports, "default", () => $16f8259e8856e670$export$2e2bcd8739ae039);
// UUID v4 generator with fallback for non-secure contexts
function $16f8259e8856e670$export$2e2bcd8739ae039() {
    const g = globalThis;
    try {
        if (g.crypto && typeof g.crypto.randomUUID === 'function') return g.crypto.randomUUID();
    } catch (_unused) {
    // ignore and fallback
    }
    // Fallback to Math.random-based v4 UUID
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c)=>{
        const r = Math.floor(Math.random() * 16);
        const v = c === 'x' ? r : r & 0x3 | 0x8; // x => random hex digit; y => set RFC 4122 variant bits (10xx), yielding 8, 9, a, or b
        return v.toString(16);
    });
}

});


parcelRegister("aB9ZI", function(module, exports) {
$parcel$export(module.exports, "default", () => $7b751cc60eb1a247$export$2e2bcd8739ae039);

var $dwiKG = parcelRequire("dwiKG");
var $7b751cc60eb1a247$export$2e2bcd8739ae039 = (0, $dwiKG.default);

});
parcelRegister("dwiKG", function(module, exports) {
$parcel$export(module.exports, "default", () => $9d7ccf4aa6931707$export$2e2bcd8739ae039);

var $4r6Zx = parcelRequire("4r6Zx");

var $9hTgF = parcelRequire("9hTgF");

var $5ZJYG = parcelRequire("5ZJYG");

var $B6WLz = parcelRequire("B6WLz");

var $hxjSL = parcelRequire("hxjSL");

var $1YukK = parcelRequire("1YukK");
class $9d7ccf4aa6931707$export$2e2bcd8739ae039 {
    constructor(namespace, options = {}){
        this.namespace = namespace;
        this.options = (0, $9hTgF.createOptionsWithDefaults)(options);
        if (!namespace || namespace.length === 0 || typeof namespace !== 'string') throw new Error('Invalid namespace provided');
        this.resilience = this.getResilienceMechanism(namespace, options);
    }
    getResilienceMechanism(namespace, options) {
        if (!options.useMemory) try {
            return new (0, $hxjSL.default)(namespace, options);
        } catch (error) {
            if (!(error instanceof (0, $5ZJYG.default))) {
                var _options$logger;
                (_options$logger = options.logger) === null || _options$logger === void 0 || _options$logger.warn('Attempted to create IndexedDbResilience but failed. Using memory instead.');
            }
        }
        return new (0, $1YukK.default)(this.namespace, options);
    }
    addItem(item, options, policy = (0, $4r6Zx.GuardPolicy).ABANDON) {
        return this.runOrFailOver(()=>this.resilience.addItem(item, options, policy));
    }
    bulkAddItem(itemOptions, policy = (0, $4r6Zx.GuardPolicy).ABANDON) {
        return this.runOrFailOver(()=>this.resilience.bulkAddItem(itemOptions, policy));
    }
    getItems(count) {
        return this.runOrFailOver(()=>this.resilience.getItems(count));
    }
    deleteItems(itemIds) {
        return this.runOrFailOver(()=>this.resilience.deleteItems(itemIds));
    }
    getItemCount() {
        return this.runOrFailOver(()=>this.resilience.getItemCount());
    }
    processItems(processFn, count) {
        return this.runOrFailOver(()=>this.resilience.processItems(processFn, count));
    }
    storeType() {
        return this.resilience.storeType();
    }
    async runOrFailOver(runnable) {
        try {
            return await runnable();
        } catch (error) {
            if ((0, $B6WLz.shouldIgnoreResilienceDbError)(error)) throw error;
            else if (this.resilience.storeType() === (0, $4r6Zx.StoreType).INDEXEDDB) await this.failOver();
            return runnable();
        }
    }
    async failOver() {
        // Attempt to get any events we can and put them into memory
        const oldResilience = this.resilience;
        const newResilience = new (0, $1YukK.default)(this.namespace, this.options);
        this.resilience = newResilience;
        try {
            const { items: items } = await oldResilience.getItems(this.options.maxEventLimit);
            if (items.length > 0) {
                const bulkAddItemsResponse = await newResilience.bulkAddItemWrapperType(items, (0, $4r6Zx.GuardPolicy).IGNORE);
                const addedItemIds = bulkAddItemsResponse.items.map((item)=>item.id);
                await oldResilience.deleteItems(addedItemIds);
            }
        } catch (error) {
            this.options.logger.warn('Unexpected error from ResilienceDb, switching to MemoryDb');
        // Dont need to catch. We are just getting events if we can
        }
    }
}

});
parcelRegister("4r6Zx", function(module, exports) {
$parcel$export(module.exports, "NAMESPACE_AND_TIME_ADDED_INDEX", () => $33af1b6df02acb6a$export$d21fbb25eb37b5bf);
$parcel$export(module.exports, "RESILIENCE_DB_NAME", () => $33af1b6df02acb6a$export$8cad224051643259);
$parcel$export(module.exports, "RESILIENCE_STORE_NAME", () => $33af1b6df02acb6a$export$3d8420be07b276ab);
$parcel$export(module.exports, "TIME_TO_PROCESS_AFTER_INDEX", () => $33af1b6df02acb6a$export$a512a65455fce2a6);
$parcel$export(module.exports, "TIME_ADDED_INDEX", () => $33af1b6df02acb6a$export$89d9c1ff8ac91862);
$parcel$export(module.exports, "RETRY_INDEX", () => $33af1b6df02acb6a$export$a37d385bcd713809);
$parcel$export(module.exports, "INDEXEDDB_TIMEOUT", () => $33af1b6df02acb6a$export$6d8635fed0e4b14d);
$parcel$export(module.exports, "StoreType", () => $33af1b6df02acb6a$export$39337ab5872e9457);
$parcel$export(module.exports, "GuardPolicy", () => $33af1b6df02acb6a$export$7710d69e6f450f20);
const $33af1b6df02acb6a$export$d21fbb25eb37b5bf = 'namespace-timeAdded';
const $33af1b6df02acb6a$export$8cad224051643259 = 'analytics-web-client';
const $33af1b6df02acb6a$export$3d8420be07b276ab = 'analytics-resilience';
const $33af1b6df02acb6a$export$a512a65455fce2a6 = 'timeToBeProcessedAfter';
const $33af1b6df02acb6a$export$89d9c1ff8ac91862 = 'timeAdded';
const $33af1b6df02acb6a$export$a37d385bcd713809 = 'retryAttempts';
const $33af1b6df02acb6a$export$6d8635fed0e4b14d = 15000;
let $33af1b6df02acb6a$export$39337ab5872e9457 = /*#__PURE__*/ function(StoreType) {
    StoreType["INDEXEDDB"] = "indexeddb";
    StoreType["MEMORY"] = "memory";
    return StoreType;
}({});
let $33af1b6df02acb6a$export$7710d69e6f450f20 = /*#__PURE__*/ function(GuardPolicy) {
    // Adds as many items as possible and IGONRES the rest.
    // Only to be used with BulkAdd
    GuardPolicy["IGNORE"] = "ignore";
    // ABANDON the request if not all items can be added.
    GuardPolicy["ABANDON"] = "abandon";
    // EVICT old items to make room for new items if space is tight.
    GuardPolicy["EVICT"] = "evict";
    return GuardPolicy;
}({});

});

parcelRegister("9hTgF", function(module, exports) {
$parcel$export(module.exports, "createOptionsWithDefaults", () => $6c30929ffd0630e9$export$ddc6718318090f71);

var $2qzvd = parcelRequire("2qzvd");
const $6c30929ffd0630e9$export$ddc6718318090f71 = (options)=>({
        logger: options.logger || console,
        useMemory: options.useMemory || false,
        maxAttempts: options.maxAttempts || (0, $2qzvd.MAX_ATTEMPTS),
        // This is so that we can customise `maxEventLimit`, primarily for testing.
        maxEventLimit: options.maxEventLimit || (0, $2qzvd.EVENT_COUNT_LIMIT)
    });

});
parcelRegister("2qzvd", function(module, exports) {
$parcel$export(module.exports, "GET_ITEM_COUNT", () => $1c498c884937cf8b$export$b6df3d334cec060f);
$parcel$export(module.exports, "VISIBILITY_TIMEOUT", () => $1c498c884937cf8b$export$14ef152a03a4b6ee);
$parcel$export(module.exports, "MAX_ATTEMPTS", () => $1c498c884937cf8b$export$da9ab7b2fd5998e8);
$parcel$export(module.exports, "EVENT_COUNT_LIMIT", () => $1c498c884937cf8b$export$1188664dfff364c8);
const $1c498c884937cf8b$export$b6df3d334cec060f = 7;
const $1c498c884937cf8b$export$14ef152a03a4b6ee = 60000;
const $1c498c884937cf8b$export$da9ab7b2fd5998e8 = 10;
const $1c498c884937cf8b$export$1188664dfff364c8 = 8000;

});


parcelRegister("5ZJYG", function(module, exports) {
$parcel$export(module.exports, "default", () => $45d6507642197b13$export$2e2bcd8739ae039);
const $45d6507642197b13$export$fc14cf6dcea0f8ed = 'NoIndexedDbError';
class $45d6507642197b13$export$2e2bcd8739ae039 extends Error {
    constructor(){
        super('window.indexeddb is undefined.');
        // Must reset the prototypes after calling super of builtin classes
        // https://github.com/Microsoft/TypeScript/wiki/Breaking-Changes#extending-built-ins-like-error-array-and-map-may-no-longer-work
        Object.setPrototypeOf(this, $45d6507642197b13$export$2e2bcd8739ae039.prototype);
        this.name = $45d6507642197b13$export$fc14cf6dcea0f8ed;
    }
}

});

parcelRegister("B6WLz", function(module, exports) {
$parcel$export(module.exports, "shouldIgnoreResilienceDbError", () => $06f8d85073d84c3b$export$74101021e0969375);

var $i6hRu = parcelRequire("i6hRu");

var $ldMum = parcelRequire("ldMum");

var $hZkpD = parcelRequire("hZkpD");
const $06f8d85073d84c3b$export$74101021e0969375 = (error)=>{
    if (error && typeof error === 'object' && 'name' in error) {
        const errorWithName = error;
        return typeof errorWithName.name === 'string' && (errorWithName.name === (0, $i6hRu.AbandonWriteErrorName) || errorWithName.name === (0, $ldMum.CallbackProcessingErrorName) || errorWithName.name === (0, $hZkpD.InvalidPolicyErrorName));
    }
    return false;
};

});
parcelRegister("i6hRu", function(module, exports) {
$parcel$export(module.exports, "AbandonWriteErrorName", () => $d2d6a47f21b9612f$export$ba95206613c96b28);
$parcel$export(module.exports, "default", () => $d2d6a47f21b9612f$export$2e2bcd8739ae039);
const $d2d6a47f21b9612f$export$ba95206613c96b28 = 'AbandonWriteError';
class $d2d6a47f21b9612f$export$2e2bcd8739ae039 extends Error {
    constructor(source){
        super(`Event Limit reached. Abandoning write to: ${source}`);
        // Must reset the prototypes after calling super of builtin classes
        // https://github.com/Microsoft/TypeScript/wiki/Breaking-Changes#extending-built-ins-like-error-array-and-map-may-no-longer-work
        Object.setPrototypeOf(this, $d2d6a47f21b9612f$export$2e2bcd8739ae039.prototype);
        this.name = $d2d6a47f21b9612f$export$ba95206613c96b28;
    }
}

});

parcelRegister("ldMum", function(module, exports) {
$parcel$export(module.exports, "CallbackProcessingErrorName", () => $f7306cb8422ee85a$export$a409c8de90e11e14);
$parcel$export(module.exports, "default", () => $f7306cb8422ee85a$export$2e2bcd8739ae039);
const $f7306cb8422ee85a$export$a409c8de90e11e14 = 'CallbackProcessingError';
class $f7306cb8422ee85a$export$2e2bcd8739ae039 extends Error {
    constructor(error){
        const messageFromError = error && typeof error === 'object' && 'toString' in error && typeof error.toString === 'function' && error.toString();
        const messageFromString = typeof error === 'string' && error;
        const message = messageFromError || messageFromString || 'Argument passed to CallbackProcessingError was not an Error or string.';
        super(`Error thrown while processing events in callback: ${message}`);
        // Must reset the prototypes after calling super of builtin classes
        // https://github.com/Microsoft/TypeScript/wiki/Breaking-Changes#extending-built-ins-like-error-array-and-map-may-no-longer-work
        Object.setPrototypeOf(this, $f7306cb8422ee85a$export$2e2bcd8739ae039.prototype);
        this.name = $f7306cb8422ee85a$export$a409c8de90e11e14;
    }
}

});

parcelRegister("hZkpD", function(module, exports) {
$parcel$export(module.exports, "InvalidPolicyErrorName", () => $d187f7a92ea73b17$export$7e7aee9a953465ec);
$parcel$export(module.exports, "default", () => $d187f7a92ea73b17$export$2e2bcd8739ae039);
const $d187f7a92ea73b17$export$7e7aee9a953465ec = 'InvalidPolicyError';
class $d187f7a92ea73b17$export$2e2bcd8739ae039 extends Error {
    constructor(policy, method){
        super(`Method '${method}' cannot be called with policy '${policy}'.`);
        this.name = $d187f7a92ea73b17$export$7e7aee9a953465ec;
    }
}

});


parcelRegister("hxjSL", function(module, exports) {
$parcel$export(module.exports, "default", () => $cc44f0f2693c9e2c$export$2e2bcd8739ae039);

var $kEBxa = parcelRequire("kEBxa");

var $6rvcc = parcelRequire("6rvcc");

var $gyG3B = parcelRequire("gyG3B");

var $4r6Zx = parcelRequire("4r6Zx");

var $lG9Bp = parcelRequire("lG9Bp");

var $9hTgF = parcelRequire("9hTgF");

var $2qzvd = parcelRequire("2qzvd");

var $ldMum = parcelRequire("ldMum");

var $hZkpD = parcelRequire("hZkpD");

var $5ZJYG = parcelRequire("5ZJYG");

var $B6WLz = parcelRequire("B6WLz");

var $Np7tU = parcelRequire("Np7tU");

var $8c4CO = parcelRequire("8c4CO");

var $cxfqV = parcelRequire("cxfqV");
const $cc44f0f2693c9e2c$var$_excluded = [
    "item"
], $cc44f0f2693c9e2c$var$_excluded2 = [
    "items"
];
function $cc44f0f2693c9e2c$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $cc44f0f2693c9e2c$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $cc44f0f2693c9e2c$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $6rvcc.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $cc44f0f2693c9e2c$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
class $cc44f0f2693c9e2c$export$2e2bcd8739ae039 {
    constructor(_namespace, _options = {}){
        (0, $6rvcc.default)(this, "startDB", async ()=>{
            return new Promise(async (resolve, reject)=>{
                if (typeof window !== 'undefined') {
                    const dbTimeout = window.setTimeout(()=>{
                        this.logger.warn('IndexedDB timed out.');
                        reject(new (0, $5ZJYG.default)());
                    }, (0, $4r6Zx.INDEXEDDB_TIMEOUT));
                    /*
           * The database version number can never change.
           * An upgrade transaction is limited to only one connection to the database.
           * Once this is done, we cannot open any connections with older versions of the schema.
           * https://www.w3.org/TR/IndexedDB/#upgrade-transaction-construct
           *
           * Due to the nature of how AWC is used (multiple tabs that are very long lived),
           * we will not be able to run version upgrades via indexeddb.
           *
           * This does not mean we cant change what is stored in the tables,
           * this limitation just prevents us from:
           *   - Creating new ObjectStores in this database connection, and
           *   - Creating new indexes on our ObjectStores
           *
           * Any upgrades we wish to run in the future will have to create a new database,
           * and migrate all the data from older databases.
           *
           * This also means any migrations we make will have to be supported until we have evidence
           * that no events are coming from old versions of the database.
           * This may take a long time.
           */ const request = window.indexedDB.open((0, $4r6Zx.RESILIENCE_DB_NAME), 1);
                    request.onupgradeneeded = (event)=>{
                        if (event.oldVersion !== 0) throw new Error('We cannot upgrade the database. Do not do this.');
                        const db = request.result;
                        const store = db.createObjectStore((0, $4r6Zx.RESILIENCE_STORE_NAME), {
                            keyPath: 'id'
                        });
                        store.createIndex((0, $4r6Zx.TIME_TO_PROCESS_AFTER_INDEX), (0, $4r6Zx.TIME_TO_PROCESS_AFTER_INDEX), {
                            unique: false
                        });
                        store.createIndex((0, $4r6Zx.RETRY_INDEX), (0, $4r6Zx.RETRY_INDEX), {
                            unique: false
                        });
                        store.createIndex((0, $4r6Zx.TIME_ADDED_INDEX), (0, $4r6Zx.TIME_ADDED_INDEX), {
                            unique: false
                        });
                        // Compound key index of product - timeAdded.
                        store.createIndex((0, $4r6Zx.NAMESPACE_AND_TIME_ADDED_INDEX), [
                            'namespace',
                            'timeAdded'
                        ], {
                            unique: false
                        });
                    };
                    request.onerror = function() {
                        reject(new (0, $5ZJYG.default)());
                    };
                    try {
                        await (0, $cxfqV.requestToPromise)(request);
                        return resolve(request.result);
                    } catch (error) {
                        this.logger.warn('IndexedDB failed to initialise.', error);
                        reject(new (0, $5ZJYG.default)());
                    } finally{
                        window.clearTimeout(dbTimeout);
                    }
                } else {
                    this.logger.warn("IndexedDB failed to initialise. No 'window' object.");
                    reject(new (0, $5ZJYG.default)());
                }
            });
        });
        (0, $6rvcc.default)(this, "addItem", async (item, options = {}, policy = (0, $4r6Zx.GuardPolicy).ABANDON)=>{
            const { logger: logger, namespace: namespace } = this;
            const value = (0, $lG9Bp.convertToItemWrapper)(item, namespace, options);
            const { objectStore: objectStore } = await this.getObjectStoreAndTransaction('readwrite');
            if (policy === (0, $4r6Zx.GuardPolicy).IGNORE) throw new (0, $hZkpD.default)(policy, 'IndexedDbConnector#addItem');
            try {
                if (!value.namespace || value.namespace.length === 0 || typeof value.namespace !== 'string') throw new Error('Namespace not specified');
                // Making space for 1 event, if required.
                const bulkAddResult = await this.globalEventLimitGuard.insertItems(objectStore, [
                    value
                ], policy);
                if (bulkAddResult.items.length === 1) return {
                    item: bulkAddResult.items[0],
                    numberOfEvictedItems: bulkAddResult.numberOfEvictedItems
                };
                // Should never happen as the Policy and EventCountGuard should cause another pathway
                throw new Error(`Incorrect number of items added. Expected: 1, got: ${bulkAddResult.items.length}`);
            } catch (error) {
                if ((0, $B6WLz.shouldIgnoreResilienceDbError)(error)) throw error;
                logger.log('Failed to add item to table', error);
                throw new Error('Request to add item to table failed');
            }
        });
        (0, $6rvcc.default)(this, "bulkAddItem", async (itemOptions, policy = (0, $4r6Zx.GuardPolicy).ABANDON)=>{
            const { logger: logger, namespace: namespace } = this;
            const items = itemOptions.map((_ref)=>{
                let { item: item } = _ref, options = (0, $kEBxa.default)(_ref, $cc44f0f2693c9e2c$var$_excluded);
                return (0, $lG9Bp.convertToItemWrapper)(item, namespace, options);
            });
            const { objectStore: objectStore } = await this.getObjectStoreAndTransaction('readwrite');
            try {
                return await this.globalEventLimitGuard.insertItems(objectStore, items, policy);
            } catch (error) {
                if ((0, $B6WLz.shouldIgnoreResilienceDbError)(error)) throw error;
                logger.log('Failed to add item to table', error);
                throw new Error('Request to add item to table failed');
            }
        });
        (0, $6rvcc.default)(this, "getItems", async (count = (0, $2qzvd.GET_ITEM_COUNT))=>{
            const fixedCount = count > 0 ? count : (0, $2qzvd.GET_ITEM_COUNT);
            const { logger: logger } = this;
            const maxAttempts = this.options.maxAttempts;
            const { transaction: transaction, objectStore: objectStore } = await this.getObjectStoreAndTransaction('readwrite');
            const timeIndex = objectStore.index((0, $4r6Zx.TIME_TO_PROCESS_AFTER_INDEX));
            const upperBoundOpenKeyRange = IDBKeyRange.upperBound(Date.now());
            const request = timeIndex.openCursor(upperBoundOpenKeyRange);
            const getResult = await new Promise(async (resolve, reject)=>{
                const items = [];
                let numberOfDeletedItems = 0;
                request.onerror = (error)=>{
                    logger.error('Failed to open cursor:', error);
                    reject('Failed to open cursor');
                };
                // Requests for Cursors call onsuccess multiple times and cannot be converted to promises
                request.onsuccess = (event)=>{
                    const cursor = event.target.result;
                    if (cursor) {
                        // Prevent mutation of the value we are returning
                        const value = $cc44f0f2693c9e2c$var$_objectSpread({}, cursor.value);
                        items.push(value);
                        // Mutations seem to be required for testing indexeddb library
                        const updatedValue = cursor.value;
                        updatedValue.retryAttempts += 1;
                        updatedValue.timeToBeProcessedAfter = Date.now() + (0, $2qzvd.VISIBILITY_TIMEOUT);
                        if (updatedValue.retryAttempts >= maxAttempts) {
                            ++numberOfDeletedItems;
                            const request = cursor.delete();
                            (0, $8c4CO.monitorErrorsOnRequest)(request, logger);
                        } else {
                            const request = cursor.update(updatedValue);
                            (0, $8c4CO.monitorErrorsOnRequest)(request, logger);
                        }
                        if (items.length < fixedCount) cursor.continue();
                        else resolve({
                            items: items,
                            numberOfDeletedItems: numberOfDeletedItems
                        });
                    } else resolve({
                        items: items,
                        numberOfDeletedItems: numberOfDeletedItems
                    });
                };
            });
            await (0, $gyG3B.commitTransaction)(transaction, this.logger);
            return getResult;
        });
        (0, $6rvcc.default)(this, "deleteItems", async (itemIds)=>{
            const { transaction: transaction, objectStore: objectStore } = await this.getObjectStoreAndTransaction('readwrite');
            try {
                const deletePromises = itemIds.map((id)=>this.deleteItem(objectStore, id));
                await (0, $gyG3B.commitTransaction)(transaction, this.logger);
                await Promise.all(deletePromises);
            } catch (error) {
                this.logger.warn('Failed to delete items from indexeddb.', error);
                throw error;
            }
        });
        (0, $6rvcc.default)(this, "getItemCount", async ()=>{
            const { transaction: transaction, objectStore: objectStore } = await this.getObjectStoreAndTransaction('readonly');
            const timeIndex = objectStore.index((0, $4r6Zx.TIME_TO_PROCESS_AFTER_INDEX));
            const upperBoundOpenKeyRange = IDBKeyRange.upperBound(Date.now());
            const request = timeIndex.count(upperBoundOpenKeyRange);
            const event = await (0, $cxfqV.requestToPromise)(request);
            await (0, $gyG3B.commitTransaction)(transaction, this.logger);
            return event.target.result;
        });
        (0, $6rvcc.default)(this, "processItems", async (processFn, count = (0, $2qzvd.GET_ITEM_COUNT))=>{
            const _await$this$getItems = await this.getItems(count), { items: items } = _await$this$getItems, partialResult = (0, $kEBxa.default)(_await$this$getItems, $cc44f0f2693c9e2c$var$_excluded2);
            try {
                const result = await processFn(items, partialResult);
                const itemIds = items.map((item)=>item.id);
                // We should not await this delete as a rejected promise would get caught by the catch statement
                await this.deleteItems(itemIds);
                return result;
            } catch (error) {
                // Eventually we will need a intermediate class to catch all errors but we should ignore this error
                // This allows libraries beneath to distinguish between a success or failure in processing to update schedulers or anything else
                // To provide back off or any other mechanism to allow what ever is cauing the errors to recover
                throw new (0, $ldMum.default)(error);
            }
        });
        (0, $6rvcc.default)(this, "deleteItem", async (objectStore, id)=>{
            const { logger: logger } = this;
            try {
                await (0, $cxfqV.requestToPromise)(objectStore.delete(id));
            } catch (error) {
                logger.error('Failed to delete item:', id, error);
                throw error;
            }
        });
        (0, $6rvcc.default)(this, "getObjectStoreAndTransaction", async (mode)=>{
            const transaction = (await this.db).transaction((0, $4r6Zx.RESILIENCE_STORE_NAME), mode);
            const objectStore = transaction.objectStore((0, $4r6Zx.RESILIENCE_STORE_NAME));
            return {
                transaction: transaction,
                objectStore: objectStore
            };
        });
        this.options = (0, $9hTgF.createOptionsWithDefaults)(_options);
        this.namespace = _namespace;
        this.logger = this.options.logger;
        if (!window.indexedDB) throw new (0, $5ZJYG.default)();
        this.db = this.startDB();
        // We just swallow any errors as we know that these are intermittent errors
        // when switching from indexeddb -> localStorage
        this.db.catch(()=>{});
        /**
     *
     * This class will enforce the number of analytics events we can store in our IndexedDB object store
     * if asked before adding items to the object store.
     */ this.globalEventLimitGuard = new (0, $Np7tU.default)(this.options.maxEventLimit, this.namespace, this.logger, this.deleteItem);
    }
    storeType() {
        return (0, $4r6Zx.StoreType).INDEXEDDB;
    }
}

});
parcelRegister("kEBxa", function(module, exports) {
$parcel$export(module.exports, "default", () => $f094a888e52110d2$export$2e2bcd8739ae039);

var $bnq8R = parcelRequire("bnq8R");
function $f094a888e52110d2$export$2e2bcd8739ae039(e, t) {
    if (null == e) return {};
    var o, r, i = (0, $bnq8R.default)(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}

});
parcelRegister("bnq8R", function(module, exports) {
$parcel$export(module.exports, "default", () => $84861ef15722fb5f$export$2e2bcd8739ae039);
function $84861ef15722fb5f$export$2e2bcd8739ae039(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}

});


parcelRegister("gyG3B", function(module, exports) {
$parcel$export(module.exports, "commitTransaction", () => $c0e0720223c37df2$export$feab8418f018df89);

var $9gUwK = parcelRequire("9gUwK");
const $c0e0720223c37df2$export$feab8418f018df89 = (transaction, logger)=>{
    try {
        if (typeof transaction.commit === 'function') transaction.commit();
    } catch (error) {
        logger.error('Failed to force commit transaction:', error);
        throw error;
    }
    return (0, $9gUwK.transactionToPromise)(transaction);
};

});
parcelRegister("9gUwK", function(module, exports) {
$parcel$export(module.exports, "transactionToPromise", () => $6c0174cc05898746$export$2a5213bce1720b42);
// eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
const $6c0174cc05898746$export$2a5213bce1720b42 = (transaction)=>{
    return new Promise((resolve, reject)=>{
        // We will have to see how much cost there is to waiting for the transaction to complete in the real world.
        // In theory in some cases we could return as soon as the request is complete and
        // just monitor errors on transactions with the logger.
        // This maybe more of an issue in Safari and other older browsers where commit isnt available
        // and we would have to wait for the transaction to complete itself.
        transaction.oncomplete = ()=>{
            resolve();
        };
        transaction.onerror = (event)=>{
            reject(event);
        };
        transaction.onabort = (event)=>{
            reject(event);
        };
    });
};

});


parcelRegister("lG9Bp", function(module, exports) {
$parcel$export(module.exports, "convertToItemWrapper", () => $fc84f8080a8d29e1$export$aec476f33d77be11);

var $1Ygrk = parcelRequire("1Ygrk");
const $fc84f8080a8d29e1$export$aec476f33d77be11 = (item, namespace, { id: id, retryAttempts: retryAttempts, timeToProcessOffset: timeToProcessOffset })=>({
        item: item,
        id: id || (0, $1Ygrk.default)(),
        retryAttempts: retryAttempts || 0,
        timeToBeProcessedAfter: Date.now() + (timeToProcessOffset || 0),
        namespace: namespace,
        timeAdded: Date.now()
    });

});

parcelRegister("Np7tU", function(module, exports) {
$parcel$export(module.exports, "default", () => $09480ff5e266e6b6$export$2e2bcd8739ae039);

var $6rvcc = parcelRequire("6rvcc");

var $gyG3B = parcelRequire("gyG3B");

var $4r6Zx = parcelRequire("4r6Zx");

var $i6hRu = parcelRequire("i6hRu");

var $cxfqV = parcelRequire("cxfqV");
class $09480ff5e266e6b6$export$2e2bcd8739ae039 {
    constructor(eventLimit, namespace, logger, deleteItemHandler){
        /**
     * This query fetches the oldest events currently stored in AWC IndexedDb object store
     * and deletes them sequentially
     */ (0, $6rvcc.default)(this, "deleteOldestNEvents", async (objectStore, count)=>{
            var _target;
            const productTimeAddedIndex = objectStore.index((0, $4r6Zx.NAMESPACE_AND_TIME_ADDED_INDEX));
            const keyRangeValues = IDBKeyRange.bound([
                this.namespace,
                0
            ], [
                this.namespace,
                Date.now()
            ]);
            const getAllRequest = productTimeAddedIndex.getAllKeys(keyRangeValues, count);
            const event = await (0, $cxfqV.requestToPromise)(getAllRequest);
            const result = event === null || event === void 0 || (_target = event.target) === null || _target === void 0 ? void 0 : _target.result;
            // Adding extra safety
            if (result && Array.isArray(result) && result.length > 0) try {
                const deletePromises = result.map((item)=>this.deleteItemHandler(objectStore, item));
                await Promise.all(deletePromises);
            } catch (error) {
                this.logger.warn('Failed to delete items from indexeddb.', error);
                throw error;
            }
        });
        if (eventLimit > 0) this.eventLimit = eventLimit;
        else throw Error('Event Limit has to be set higher than 1');
        this.namespace = namespace;
        this.logger = logger;
        this.deleteItemHandler = deleteItemHandler;
    }
    /**
   * This function checks the number of events currently in AWC IndexedDB object store and if necessary,
   * will evict the oldest events in favour of the events we want to add.
   *
   * The indexed is treated as effectively: partitioned by product and sorted by timeAdded.
   *
   * This function can be re-used when the bulk add functionality is added in IndexedDbConnector.
   *
   * @param countOfEventsToAdd - The number of events we are proposing to add.
   */ async insertItems(objectStore, items, policy = (0, $4r6Zx.GuardPolicy).ABANDON) {
        const itemsToAdd = [
            ...items
        ];
        let numberOfEvictedItems = 0;
        switch(policy){
            case (0, $4r6Zx.GuardPolicy).ABANDON:
                await this.throwIfNotEnoughSpace(objectStore, items.length);
                break;
            case (0, $4r6Zx.GuardPolicy).EVICT:
                numberOfEvictedItems = await this.evictIfNotEnoughSpace(objectStore, items.length);
                break;
            case (0, $4r6Zx.GuardPolicy).IGNORE:
                // Removed items from `itemsToAdd` if there is insufficient space
                await this.calculateHowManyEventsWeCanAdd(objectStore, itemsToAdd);
                break;
        }
        const promises = itemsToAdd.map((item)=>(0, $cxfqV.requestToPromise)(objectStore.add(item)));
        await Promise.all(promises);
        await (0, $gyG3B.commitTransaction)(objectStore.transaction, this.logger);
        return {
            items: itemsToAdd,
            numberOfEvictedItems: numberOfEvictedItems
        };
    }
    async throwIfNotEnoughSpace(objectStore, requiredSpace) {
        const freeSpace = await this.calculateFreeSpace(objectStore);
        if (freeSpace < requiredSpace) throw new (0, $i6hRu.default)(`Not enough space in IndexedDb. Needed ${requiredSpace} but only had ${freeSpace}`);
    }
    async evictIfNotEnoughSpace(objectStore, requiredSpace) {
        const freeSpace = await this.calculateFreeSpace(objectStore);
        if (freeSpace < requiredSpace) {
            const extraSpace = requiredSpace - freeSpace;
            await this.deleteOldestNEvents(objectStore, extraSpace);
            return extraSpace;
        }
        return 0;
    }
    async calculateHowManyEventsWeCanAdd(objectStore, items) {
        const freeSpace = await this.calculateFreeSpace(objectStore);
        if (freeSpace < items.length) {
            const numberOfItemsToRemove = items.length - freeSpace;
            const start = items.length - numberOfItemsToRemove;
            items.splice(start, numberOfItemsToRemove);
        }
    }
    async calculateFreeSpace(objectStore) {
        const numberOfEventsInDb = await this.getCountofEventsInObjectStore(objectStore);
        return this.eventLimit - numberOfEventsInDb;
    }
    /**
   * This query returns the count of items held in AWC IndexedDB object store per product.
   */ async getCountofEventsInObjectStore(objectStore) {
        const productTimeAddedIndex = objectStore.index((0, $4r6Zx.NAMESPACE_AND_TIME_ADDED_INDEX));
        const keyRangeValues = IDBKeyRange.bound([
            this.namespace,
            0
        ], [
            this.namespace,
            Date.now()
        ]);
        const request = productTimeAddedIndex.count(keyRangeValues);
        const event = await (0, $cxfqV.requestToPromise)(request);
        return event.target.result;
    }
}

});
parcelRegister("cxfqV", function(module, exports) {
$parcel$export(module.exports, "requestToPromise", () => $920489cfec389054$export$85ceed0783e42041);
// Not to be used on cursors or other requests that may call onsuccess multiple times.
// eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
const $920489cfec389054$export$85ceed0783e42041 = (request)=>{
    return new Promise((resolve, reject)=>{
        request.onsuccess = (event)=>{
            resolve(event);
        };
        request.onerror = (event)=>{
            reject(event);
        };
    });
};

});


parcelRegister("8c4CO", function(module, exports) {
$parcel$export(module.exports, "monitorErrorsOnRequest", () => $5f730822a9ef2e6f$export$342d941b6f724995);
// For requests that are not mission critical
// eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
const $5f730822a9ef2e6f$export$342d941b6f724995 = (request, logger)=>{
    request.onerror = (event)=>{
        logger.warn('Error thrown from request:', event);
    };
};

});


parcelRegister("1YukK", function(module, exports) {
$parcel$export(module.exports, "default", () => $1702ecaf3ddce481$export$2e2bcd8739ae039);

var $6rvcc = parcelRequire("6rvcc");

var $kEBxa = parcelRequire("kEBxa");

var $4r6Zx = parcelRequire("4r6Zx");

var $lG9Bp = parcelRequire("lG9Bp");

var $9hTgF = parcelRequire("9hTgF");

var $2qzvd = parcelRequire("2qzvd");

var $ldMum = parcelRequire("ldMum");

var $hZkpD = parcelRequire("hZkpD");

var $e7ngm = parcelRequire("e7ngm");
const $1702ecaf3ddce481$var$_excluded = [
    "item"
], $1702ecaf3ddce481$var$_excluded2 = [
    "items"
];
function $1702ecaf3ddce481$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $1702ecaf3ddce481$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $1702ecaf3ddce481$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $6rvcc.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $1702ecaf3ddce481$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
class $1702ecaf3ddce481$export$2e2bcd8739ae039 {
    constructor(namespace, options = {}){
        this.namespace = namespace;
        this.memoryStore = [];
        this.options = (0, $9hTgF.createOptionsWithDefaults)(options);
        /**
     * This class will enforce the number of analytics events we can store in our MemoryDb
     */ this.globalEventLimitGuard = new (0, $e7ngm.default)(this.options.maxEventLimit, {
            addItems: this.addItems.bind(this),
            getItemCount: this.getItemCount.bind(this),
            evictEventsIfNeeded: this.evictEventsIfNeeded.bind(this)
        });
    }
    /**
   * This method is used mainly to write new events to MemoryDB and uses the MEMORY_DB_GUARD_POLICY.EVICT_OLDEST_IF_LIMIT_EXECEEDED policy
   * to removes oldest events when limit is reached.
   */ async addItem(item, options = {}, policy = (0, $4r6Zx.GuardPolicy).ABANDON) {
        if (policy === (0, $4r6Zx.GuardPolicy).IGNORE) throw new (0, $hZkpD.default)(policy, 'IndexedDbConnector#addItem');
        const storedValue = (0, $lG9Bp.convertToItemWrapper)(item, this.namespace, options);
        // Delegated responsiblity to event limit guard to insert to memory stored
        const bulkAddItemsResult = await this.globalEventLimitGuard.insertItemsToMemoryStore([
            storedValue
        ], policy);
        return Promise.resolve({
            item: bulkAddItemsResult.items[0],
            numberOfEvictedItems: bulkAddItemsResult.numberOfEvictedItems
        });
    }
    bulkAddItem(itemOptions, policy = (0, $4r6Zx.GuardPolicy).ABANDON) {
        const items = itemOptions.map((_ref)=>{
            let { item: item } = _ref, addOptions = (0, $kEBxa.default)(_ref, $1702ecaf3ddce481$var$_excluded);
            return (0, $lG9Bp.convertToItemWrapper)(item, this.namespace, addOptions);
        });
        return this.bulkAddItemWrapperType(items, policy);
    }
    /**
   * This method is used mainly to write events to MemoryDB when unknown errors are thrown from IndexedDB.
   */ bulkAddItemWrapperType(items, policy = (0, $4r6Zx.GuardPolicy).ABANDON) {
        return Promise.resolve(this.globalEventLimitGuard.insertItemsToMemoryStore(items, policy));
    }
    getItems(count = (0, $2qzvd.GET_ITEM_COUNT)) {
        return Promise.resolve(this.synchronousGetItems(count));
    }
    synchronousGetItems(count = (0, $2qzvd.GET_ITEM_COUNT)) {
        const fixedCount = count > 0 ? count : (0, $2qzvd.GET_ITEM_COUNT);
        const now = Date.now();
        const wrappedItems = [];
        const itemsToRemove = [];
        for (let wrappedItem of this.memoryStore){
            if (wrappedItem.timeToBeProcessedAfter <= now) {
                wrappedItems.push($1702ecaf3ddce481$var$_objectSpread({}, wrappedItem));
                // Mutates the item in the memoryStore array, but not whats inside of wrappedItems
                wrappedItem.timeToBeProcessedAfter += (0, $2qzvd.VISIBILITY_TIMEOUT);
                wrappedItem.retryAttempts += 1;
                if (wrappedItem.retryAttempts >= this.options.maxAttempts) itemsToRemove.push(wrappedItem);
            }
            if (wrappedItems.length >= fixedCount) break;
        }
        itemsToRemove.forEach((item)=>{
            const index = this.memoryStore.indexOf(item);
            this.memoryStore.splice(index, 1);
        });
        return {
            items: wrappedItems,
            numberOfDeletedItems: itemsToRemove.length
        };
    }
    deleteItems(itemIds) {
        this.memoryStore = this.memoryStore.filter((item)=>!itemIds.includes(item.id));
        return Promise.resolve(void 0);
    }
    getItemCount() {
        const now = Date.now();
        const count = this.memoryStore.filter((item)=>item.timeToBeProcessedAfter <= now).length;
        return Promise.resolve(count);
    }
    async processItems(processFn, count) {
        const _this$synchronousGetI = this.synchronousGetItems(count), { items: items } = _this$synchronousGetI, partialGetResult = (0, $kEBxa.default)(_this$synchronousGetI, $1702ecaf3ddce481$var$_excluded2);
        const itemIds = items.map((i)=>i.id);
        try {
            const result = await processFn(items, partialGetResult);
            await this.deleteItems(itemIds);
            return result;
        } catch (error) {
            throw new (0, $ldMum.default)(error);
        }
    }
    storeType() {
        return (0, $4r6Zx.StoreType).MEMORY;
    }
    /**
   * This function is adding items to the tail of the memoryStore and as it adds new items it keeps the
   * memory store sorted by timeAdded property. This makes evictions easier and adding elements to
   * memoryStore much faster.
   *
   * @param itemsToAdd
   */ addItems(itemsToAdd) {
        this.memoryStore.push(...itemsToAdd);
        // Sorting everytime, intentionally.
        this.memoryStore.sort(function(a, b) {
            return a.timeAdded - b.timeAdded;
        });
    }
    /**
   * This function checks the number of events currently in AWC MemoryDb and if necessary,
   * will evict the oldest events in favour of the events we want to add.
   *
   * @param countOfEventsToAdd - The number of events we are proposing to add.
   */ evictEventsIfNeeded(eventLimit) {
        const numberOfEventsInDb = this.memoryStore.length;
        // The number of analytics events currently in MemoryDb and
        // the Z events we are proposing to add will exceed our event count limit.
        if (numberOfEventsInDb > eventLimit) {
            const m = numberOfEventsInDb - eventLimit;
            // Removing oldest M events
            this.memoryStore.splice(0, m);
            return m;
        }
        return 0;
    }
}

});
parcelRegister("e7ngm", function(module, exports) {
$parcel$export(module.exports, "default", () => $a473c3a6a30f3441$export$2e2bcd8739ae039);

var $6rvcc = parcelRequire("6rvcc");

var $4r6Zx = parcelRequire("4r6Zx");

var $i6hRu = parcelRequire("i6hRu");
class $a473c3a6a30f3441$export$2e2bcd8739ae039 {
    constructor(eventLimit, memoryItemHandlers){
        /**
     * Unlike IndexedDb, we cannot take advantage of any index. So we are,
     * treating the memory store as a sorted set when adding items.
     */ (0, $6rvcc.default)(this, "insertItemsToMemoryStore", (itemsToAdd, policy)=>{
            switch(policy){
                case (0, $4r6Zx.GuardPolicy).ABANDON:
                    return this.handleAbandonIfLimitWillExceedPolicy(itemsToAdd);
                case (0, $4r6Zx.GuardPolicy).EVICT:
                    return Promise.resolve(this.handleEvictOldestIfLimitExceededPolicy(itemsToAdd));
                case (0, $4r6Zx.GuardPolicy).IGNORE:
                    return this.handleAddAsManyAsPossible(itemsToAdd);
            }
        });
        if (eventLimit > 0) this.eventLimit = eventLimit;
        else throw Error('Event Limit has to be set higher than 1');
        this.memoryItemHandlers = memoryItemHandlers;
    }
    async handleAbandonIfLimitWillExceedPolicy(itemsToAdd) {
        const itemCount = await this.memoryItemHandlers.getItemCount();
        if (itemCount + itemsToAdd.length > this.eventLimit) throw new (0, $i6hRu.default)((0, $4r6Zx.StoreType).MEMORY);
        this.memoryItemHandlers.addItems(itemsToAdd);
        return {
            items: itemsToAdd,
            numberOfEvictedItems: 0
        };
    }
    handleEvictOldestIfLimitExceededPolicy(itemsToAdd) {
        this.memoryItemHandlers.addItems(itemsToAdd);
        const numberOfEvictedItems = this.memoryItemHandlers.evictEventsIfNeeded(this.eventLimit);
        return {
            items: itemsToAdd,
            numberOfEvictedItems: numberOfEvictedItems
        };
    }
    async handleAddAsManyAsPossible(itemsToAdd) {
        const freeSpace = this.eventLimit - await this.memoryItemHandlers.getItemCount();
        const partialEventsToAdd = freeSpace > itemsToAdd.length ? itemsToAdd : itemsToAdd.slice(0, freeSpace);
        this.memoryItemHandlers.addItems(partialEventsToAdd);
        return {
            items: partialEventsToAdd,
            numberOfEvictedItems: 0
        };
    }
}

});




parcelRegister("f4MJF", function(module, exports) {
$parcel$export(module.exports, "default", () => $02d51d0ac0f3eacd$export$2e2bcd8739ae039);

var $50YPo = parcelRequire("50YPo");
let $02d51d0ac0f3eacd$var$cachedMetricsClient = null;
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$02d51d0ac0f3eacd$export$2e2bcd8739ae039 = ()=>{
    if (!$02d51d0ac0f3eacd$var$cachedMetricsClient) $02d51d0ac0f3eacd$var$cachedMetricsClient = new (0, $50YPo.MetricsCollector)();
    return $02d51d0ac0f3eacd$var$cachedMetricsClient;
};

});
parcelRegister("50YPo", function(module, exports) {
$parcel$export(module.exports, "MetricsCollector", () => $3a6c22fbb2e9498b$export$4b62ee5120ab50a8);

var $6rvcc = parcelRequire("6rvcc");

var $9GE8Y = parcelRequire("9GE8Y");
class $3a6c22fbb2e9498b$export$4b62ee5120ab50a8 {
    constructor(){
        // Number of events discarded due to exceeding retry limits.
        (0, $6rvcc.default)(this, "itemsDiscardedByRetry", 0);
        // Number of events created by the product in current tab.
        (0, $6rvcc.default)(this, "eventCount", 0);
        // Number of events discarded due to reaching queue max size.
        (0, $6rvcc.default)(this, "itemsDiscardedByOverflow", 0);
        // Will be used in the future when we get more resilience mechanisms
        (0, $6rvcc.default)(this, "resilienceMechanism", (0, $9GE8Y.ResilienceMechanism).INDEXEDDB);
        /* --- LocalStorage specific metrics --- */ // Emitted by purgeOrphanedQueues to tell us how many queues we have had to clean up due to
        // https://github.com/segmentio/localstorage-retry/pull/17
        (0, $6rvcc.default)(this, "localstorageNumberOfQueuesPurged", 0);
        // Emitted by reclaimEvents to tell us how many queues were seen in the process of reclaim.
        // We will only emit metrics for queues that are not currently being maintained (i.e. `ack` is not being updated).
        // Queue was found, all events removed and put into resilienceDb.
        (0, $6rvcc.default)(this, "localstorageNumberOfFullReclaims", 0);
        // Queue was found but not all events were able to be put into resilienceDb.
        (0, $6rvcc.default)(this, "localstorageNumberOfPartialReclaims", 0);
        // Reclaim failed for a queue and reclaim was abandonded.
        (0, $6rvcc.default)(this, "localstorageNumberOfFailedReclaims", 0);
    }
    addToItemsDiscardedByRetryCounter(numberOfDeletedEvents = 1) {
        this.itemsDiscardedByRetry += numberOfDeletedEvents;
    }
    addToEventCount() {
        this.eventCount++;
    }
    addToItemsDiscardedByOverflowCounter(numberOfDeletedEvents = 1) {
        this.itemsDiscardedByOverflow += numberOfDeletedEvents;
    }
    setResilienceMechanism(mechanism) {
        this.resilienceMechanism = mechanism;
    }
    /* <Localstorage specific> */ addToReclaimMetrics(reclaimMetrics) {
        this.localstorageNumberOfFullReclaims += reclaimMetrics.fullReclaims;
        this.localstorageNumberOfPartialReclaims += reclaimMetrics.partialReclaims;
        this.localstorageNumberOfFailedReclaims += reclaimMetrics.failedReclaims;
    }
    addToPurgedQueuesMetrics(numberOfQueuesPurged) {
        this.localstorageNumberOfQueuesPurged += numberOfQueuesPurged;
    }
    /* </Localstorage specific> */ subtractFromMetrics(sentMetrics) {
        this.itemsDiscardedByRetry = this.subtractFromCount(this.itemsDiscardedByRetry, sentMetrics.itemsDiscardedByRetry);
        this.eventCount = this.subtractFromCount(this.eventCount, sentMetrics.eventCount);
        this.itemsDiscardedByOverflow = this.subtractFromCount(this.itemsDiscardedByOverflow, sentMetrics.itemsDiscardedByOverflow);
        // Localstorage specific
        this.localstorageNumberOfFullReclaims = this.subtractFromCount(this.localstorageNumberOfFullReclaims, sentMetrics.fullReclaims);
        this.localstorageNumberOfPartialReclaims = this.subtractFromCount(this.localstorageNumberOfPartialReclaims, sentMetrics.partialReclaims);
        this.localstorageNumberOfFailedReclaims = this.subtractFromCount(this.localstorageNumberOfFailedReclaims, sentMetrics.failedReclaims);
        this.localstorageNumberOfQueuesPurged = this.subtractFromCount(this.localstorageNumberOfQueuesPurged, sentMetrics.localstorageQueuesPurged);
    }
    subtractFromCount(count, subtract) {
        return Math.max(count - (subtract || 0), 0);
    }
    getMetricsPayload() {
        return {
            itemsDiscardedByRetry: this.itemsDiscardedByRetry,
            eventCount: this.eventCount,
            itemsDiscardedByOverflow: this.itemsDiscardedByOverflow,
            resilienceMechanism: this.resilienceMechanism,
            // Localstorage specific
            localstorageQueuesPurged: this.localstorageNumberOfQueuesPurged,
            fullReclaims: this.localstorageNumberOfFullReclaims,
            partialReclaims: this.localstorageNumberOfPartialReclaims,
            failedReclaims: this.localstorageNumberOfFailedReclaims
        };
    }
}

});
parcelRegister("9GE8Y", function(module, exports) {
$parcel$export(module.exports, "ResilienceMechanism", () => $70d72d06700e4121$export$c75161629e3ec34e);
$parcel$export(module.exports, "NetworkStatusEnum", () => $70d72d06700e4121$export$ee138fa712d11b84);
let $70d72d06700e4121$export$c75161629e3ec34e = /*#__PURE__*/ function(ResilienceMechanism) {
    ResilienceMechanism["INDEXEDDB"] = "indexeddb";
    ResilienceMechanism["MEMORY"] = "memory";
    return ResilienceMechanism;
}({});
let $70d72d06700e4121$export$ee138fa712d11b84 = /*#__PURE__*/ function(NetworkStatusEnum) {
    NetworkStatusEnum[NetworkStatusEnum["ONLINE"] = 0] = "ONLINE";
    NetworkStatusEnum[NetworkStatusEnum["OFFLINE"] = 1] = "OFFLINE";
    return NetworkStatusEnum;
}({});

});



parcelRegister("2SiT1", function(module, exports) {
$parcel$export(module.exports, "default", () => $217f46601d89c1b6$export$2e2bcd8739ae039);

var $9GE8Y = parcelRequire("9GE8Y");
class $217f46601d89c1b6$export$2e2bcd8739ae039 {
    constructor(networkChangeCallback){
        this._networkChangeCallback = networkChangeCallback;
        if (typeof window !== 'undefined') {
            window.addEventListener('offline', ()=>this._networkChangeCallback((0, $9GE8Y.NetworkStatusEnum).OFFLINE));
            window.addEventListener('online', ()=>this._networkChangeCallback((0, $9GE8Y.NetworkStatusEnum).ONLINE));
        }
    }
    removeListeners() {
        if (typeof window !== 'undefined') {
            window.addEventListener('offline', ()=>this._networkChangeCallback((0, $9GE8Y.NetworkStatusEnum).OFFLINE));
            window.addEventListener('online', ()=>this._networkChangeCallback((0, $9GE8Y.NetworkStatusEnum).ONLINE));
        }
    }
    getNetworkStatus() {
        if (window.navigator.onLine) return (0, $9GE8Y.NetworkStatusEnum).ONLINE;
        return (0, $9GE8Y.NetworkStatusEnum).OFFLINE;
    }
}

});

parcelRegister("cx5q7", function(module, exports) {
$parcel$export(module.exports, "default", () => $91fcc5723998e290$export$2e2bcd8739ae039);

var $6rvcc = parcelRequire("6rvcc");

var $8Gucb = parcelRequire("8Gucb");

var $3efd3 = parcelRequire("3efd3");
const $91fcc5723998e290$var$SCHEDULER_OPTIONS_DEFAULT = {
    minRetryDelay: 1000,
    maxRetryDelay: 30000,
    backoffFactor: 2,
    backoffJitterPercentage: 0,
    waitInterval: 500,
    callbackTimeoutPeriod: 5000
};
let $91fcc5723998e290$export$8bb92baee001fc60 = /*#__PURE__*/ function(QueuedScheduleTypes) {
    QueuedScheduleTypes[QueuedScheduleTypes["NONE"] = 0] = "NONE";
    QueuedScheduleTypes[QueuedScheduleTypes["IMMEDIATE"] = 1] = "IMMEDIATE";
    QueuedScheduleTypes[QueuedScheduleTypes["WAIT"] = 2] = "WAIT";
    return QueuedScheduleTypes;
}({});
class $91fcc5723998e290$export$2e2bcd8739ae039 {
    constructor(retryOptions, callback){
        (0, $6rvcc.default)(this, "schedule", ({ immediate: immediate } = {})=>{
            if (typeof window === 'undefined') return;
            if (this.operationInFlight) {
                if (immediate) this.queuedSchedule = $91fcc5723998e290$export$8bb92baee001fc60.IMMEDIATE;
                else if (this.queuedSchedule !== $91fcc5723998e290$export$8bb92baee001fc60.IMMEDIATE) this.queuedSchedule = $91fcc5723998e290$export$8bb92baee001fc60.WAIT;
            // Only run immediately if we have no failures
            } else if ((immediate || this.options.waitInterval <= 0) && this.failureCount === 0) {
                this.clearTimeout();
                this.run();
            // Calculate backoff for normal or failure scenario
            } else if (this.scheduledTimeout === null) this.scheduledTimeout = window.setTimeout(this.run, this.calculateBackoff());
        });
        (0, $6rvcc.default)(this, "stop", ()=>{
            this.clearTimeout();
            this.queuedSchedule = $91fcc5723998e290$export$8bb92baee001fc60.NONE;
        });
        (0, $6rvcc.default)(this, "getFailureCount", ()=>this.failureCount);
        (0, $6rvcc.default)(this, "getCallbackStatus", ()=>{
            return this.callbackTimer.getCallbackStatus();
        });
        (0, $6rvcc.default)(this, "clearTimeout", ()=>{
            if (typeof window !== 'undefined' && this.scheduledTimeout !== null) {
                window.clearTimeout(this.scheduledTimeout);
                this.scheduledTimeout = null;
            }
        });
        (0, $6rvcc.default)(this, "run", ()=>{
            this.operationInFlight = true;
            this.clearTimeout();
            try {
                this.callbackTimer.executeCallbackWithTimeout(// callback to execute
                this.callback, // when callback completes, call this function
                this.done, // on timeout, do this instead
                ()=>this.done((0, $3efd3.DoneState).ERROR));
            } catch (err) {
                this.done(err);
            }
        });
        (0, $6rvcc.default)(this, "done", (state)=>{
            this.operationInFlight = false;
            if (state === (0, $3efd3.DoneState).ERROR || this.callbackTimer.getCallbackStatus() === (0, $8Gucb.CallbackStatus).TIMED_OUT) {
                this.failureCount++;
                this.clearTimeout();
            } else if (state === (0, $3efd3.DoneState).SUCCESS) this.failureCount = 0;
            this.processQueuedSchedule();
        });
        (0, $6rvcc.default)(this, "processQueuedSchedule", ()=>{
            if (this.queuedSchedule !== $91fcc5723998e290$export$8bb92baee001fc60.NONE) {
                const immediate = this.queuedSchedule === $91fcc5723998e290$export$8bb92baee001fc60.IMMEDIATE;
                this.queuedSchedule = $91fcc5723998e290$export$8bb92baee001fc60.NONE;
                this.schedule({
                    immediate: immediate
                });
            } else if (this.failureCount > 0) // This will schedule tasks when this._done was called with a truthy value
            // For example, when this.callback(this._done) was not called within
            // this.callbackTimeoutPeriod
            this.schedule();
        });
        (0, $6rvcc.default)(this, "calculateBackoff", ()=>{
            const { minRetryDelay: minRetryDelay, maxRetryDelay: maxRetryDelay, backoffFactor: backoffFactor, backoffJitterPercentage: backoffJitterPercentage, waitInterval: waitInterval } = this.options;
            // Helper for deviation based on a single random sample
            const jitter = (base, symmetric)=>{
                if (!backoffJitterPercentage || base <= 0) return 0;
                const r = (Math.random() - 0.5) * 2;
                const frac = symmetric ? r : Math.abs(r);
                return Math.floor(frac * backoffJitterPercentage * base);
            };
            // No failures: wait interval with positive-only jitter
            if (this.failureCount === 0) return waitInterval + jitter(waitInterval, false);
            // Failures: exponential backoff with symmetric jitter
            const base = Math.min(minRetryDelay * backoffFactor ** this.failureCount, maxRetryDelay);
            const withJitter = base + jitter(base, true);
            return Math.max(minRetryDelay, Math.min(withJitter, maxRetryDelay));
        });
        this.options = {
            minRetryDelay: retryOptions.minRetryDelay || $91fcc5723998e290$var$SCHEDULER_OPTIONS_DEFAULT.minRetryDelay,
            maxRetryDelay: retryOptions.maxRetryDelay || $91fcc5723998e290$var$SCHEDULER_OPTIONS_DEFAULT.maxRetryDelay,
            backoffFactor: retryOptions.backoffFactor || $91fcc5723998e290$var$SCHEDULER_OPTIONS_DEFAULT.backoffFactor,
            backoffJitterPercentage: retryOptions.backoffJitterPercentage || $91fcc5723998e290$var$SCHEDULER_OPTIONS_DEFAULT.backoffJitterPercentage,
            waitInterval: retryOptions.waitInterval !== undefined ? retryOptions.waitInterval : $91fcc5723998e290$var$SCHEDULER_OPTIONS_DEFAULT.waitInterval,
            callbackTimeoutPeriod: retryOptions.callbackTimeoutPeriod || $91fcc5723998e290$var$SCHEDULER_OPTIONS_DEFAULT.callbackTimeoutPeriod
        };
        this.scheduledTimeout = null;
        this.failureCount = 0;
        this.callback = callback;
        this.operationInFlight = false;
        this.queuedSchedule = $91fcc5723998e290$export$8bb92baee001fc60.NONE;
        this.callbackTimer = new (0, $8Gucb.CallbackWithTimeout)(this.options.callbackTimeoutPeriod);
    }
}

});
parcelRegister("8Gucb", function(module, exports) {
$parcel$export(module.exports, "CallbackStatus", () => $6529ab323cc35eef$export$ef3353088fca369c);
$parcel$export(module.exports, "CallbackWithTimeout", () => $6529ab323cc35eef$export$590a718599f8f8b3);

var $6rvcc = parcelRequire("6rvcc");
let $6529ab323cc35eef$export$ef3353088fca369c = /*#__PURE__*/ function(CallbackStatus) {
    CallbackStatus["IDLE"] = "idle";
    CallbackStatus["RUNNING"] = "running";
    CallbackStatus["COMPLETED"] = "completed";
    CallbackStatus["TIMED_OUT"] = "timedOut";
    return CallbackStatus;
}({});
let $6529ab323cc35eef$export$def7d978353eaa0 = /*#__PURE__*/ function(CallbackEvent) {
    CallbackEvent["EXECUTE"] = "execute";
    CallbackEvent["COMPLETE"] = "complete";
    CallbackEvent["TIMEOUT"] = "timeout";
    return CallbackEvent;
}({});
class $6529ab323cc35eef$export$590a718599f8f8b3 {
    constructor(timeoutPeriod){
        // Milliseconds to wait
        // Tracks the settimeout; so that we can clear the timeout
        (0, $6rvcc.default)(this, "timeoutHandle", undefined);
        (0, $6rvcc.default)(this, "callbackStatus", $6529ab323cc35eef$export$ef3353088fca369c.IDLE);
        if (timeoutPeriod > 0) {
            this.timeoutPeriod = timeoutPeriod;
            return;
        }
        throw new Error('CallbackWithTimeout requires timeout period higher than 0');
    }
    // This is a state machine to control the flow of execution.
    // IDLE -> RUNNING -> COMPLETED
    // IDLE -> RUNNING -> TIMEDOUT
    transitionCallbackStatus(currentStatus, event) {
        switch(currentStatus){
            case $6529ab323cc35eef$export$ef3353088fca369c.IDLE:
            case $6529ab323cc35eef$export$ef3353088fca369c.TIMED_OUT:
            case $6529ab323cc35eef$export$ef3353088fca369c.COMPLETED:
                if (event === $6529ab323cc35eef$export$def7d978353eaa0.EXECUTE) this.callbackStatus = $6529ab323cc35eef$export$ef3353088fca369c.RUNNING;
                break;
            case $6529ab323cc35eef$export$ef3353088fca369c.RUNNING:
                switch(event){
                    case $6529ab323cc35eef$export$def7d978353eaa0.COMPLETE:
                        this.callbackStatus = $6529ab323cc35eef$export$ef3353088fca369c.COMPLETED;
                        break;
                    case $6529ab323cc35eef$export$def7d978353eaa0.TIMEOUT:
                        this.callbackStatus = $6529ab323cc35eef$export$ef3353088fca369c.TIMED_OUT;
                        break;
                }
                break;
            default:
                this.callbackStatus = currentStatus;
        }
    }
    // Start a timeout. If this.callback(this._done) does not finish
    // by this.options.callbackTimeoutPeriod time period,
    // we will call done with a true value.
    executeCallbackWithTimeout(callback, onDone, onTimeout) {
        if (typeof window === 'undefined') return;
        this.transitionCallbackStatus(this.callbackStatus, $6529ab323cc35eef$export$def7d978353eaa0.EXECUTE);
        // Setting timeout
        this.timeoutHandle = window.setTimeout(()=>{
            this.transitionCallbackStatus(this.callbackStatus, $6529ab323cc35eef$export$def7d978353eaa0.TIMEOUT);
            onTimeout();
        }, this.timeoutPeriod);
        // Executing callback
        callback((state)=>{
            this.cancelTimeout();
            if (this.getCallbackStatus() !== $6529ab323cc35eef$export$ef3353088fca369c.TIMED_OUT) {
                this.transitionCallbackStatus(this.callbackStatus, $6529ab323cc35eef$export$def7d978353eaa0.COMPLETE);
                onDone(state);
            }
        });
    }
    getCallbackStatus() {
        return this.callbackStatus;
    }
    // This allows us to cancel the timeout function, for example, if the callback finishes before the timeout period
    // or, if the user wants to manually cancel the timeout
    cancelTimeout() {
        if (typeof window !== 'undefined' && this.timeoutPeriod > 0 && this.timeoutHandle) {
            window.clearTimeout(this.timeoutHandle);
            this.timeoutHandle = undefined;
        }
    }
}

});

parcelRegister("3efd3", function(module, exports) {
$parcel$export(module.exports, "DoneState", () => $259e7a33bf7a29f3$export$f93c40fda808dd0c);
// Clients can optionally provide the callbackTimeoutPeriod parameter
let $259e7a33bf7a29f3$export$f93c40fda808dd0c = /*#__PURE__*/ function(DoneState) {
    DoneState[DoneState["NOOP"] = 0] = "NOOP";
    DoneState[DoneState["SUCCESS"] = 1] = "SUCCESS";
    DoneState[DoneState["ERROR"] = 2] = "ERROR";
    return DoneState;
}({});

});




parcelRegister("acFLR", function(module, exports) {
$parcel$export(module.exports, "attachXidToMultipleEvents", () => $76db6d310b8b4afb$export$c21270cab66ab290);

var $vZHup = parcelRequire("vZHup");
async function $76db6d310b8b4afb$export$c21270cab66ab290(items, xidItemPromiseCallback) {
    try {
        const xidCallback = await xidItemPromiseCallback;
        return items.map((item)=>(0, $vZHup.attachXidToSingleEvent)(item, xidCallback));
    } catch (error) {
        return items;
    }
}

});
parcelRegister("vZHup", function(module, exports) {
$parcel$export(module.exports, "attachXidToSingleEvent", () => $0602c1c9bcdffe46$export$c9c3aaf655d6f275);

var $6rvcc = parcelRequire("6rvcc");

var $5pjnf = parcelRequire("5pjnf");
function $0602c1c9bcdffe46$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $0602c1c9bcdffe46$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $0602c1c9bcdffe46$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $6rvcc.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $0602c1c9bcdffe46$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $0602c1c9bcdffe46$export$c9c3aaf655d6f275(item, xidCallback) {
    if (!(xidCallback && xidCallback instanceof Function)) return item;
    if (item.msg.type === (0, $5pjnf.SegmentEventTypes).PAGE || item.msg.type === (0, $5pjnf.SegmentEventTypes).TRACK) {
        const xid = xidCallback();
        if (xid && Array.isArray(xid)) item.msg.properties = $0602c1c9bcdffe46$var$_objectSpread($0602c1c9bcdffe46$var$_objectSpread({}, item.msg.properties), {}, {
            xid: xid
        });
    } else if (item.msg.traits && item.msg.type === (0, $5pjnf.SegmentEventTypes).IDENTIFY) {
        const xid = xidCallback();
        if (xid && Array.isArray(xid)) item.msg.traits = $0602c1c9bcdffe46$var$_objectSpread($0602c1c9bcdffe46$var$_objectSpread({}, item.msg.traits), {}, {
            xid: xid
        });
    }
    return item;
}

});
parcelRegister("5pjnf", function(module, exports) {
$parcel$export(module.exports, "SegmentEventTypes", () => $3efe50d51d84d6fc$export$ddf929981dc6feb3);
$parcel$export(module.exports, "ALLOW_LISTED_FETCH_ERROR_NAMES", () => $3efe50d51d84d6fc$export$96f086dcf574a9e2);
// Segment event types copied from our backend
// https://bitbucket.org/atlassian/analytics-service/src/master/api/src/main/java/com/atlassian/dataservices/analytics/service/api/segment/
// eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
let $3efe50d51d84d6fc$export$ddf929981dc6feb3 = /*#__PURE__*/ function(SegmentEventTypes) {
    SegmentEventTypes["IDENTIFY"] = "identify";
    SegmentEventTypes["PAGE"] = "page";
    // Dont need Screen as page and screen are the same and we only use page
    SegmentEventTypes["TRACK"] = "track";
    return SegmentEventTypes;
}({});
let $3efe50d51d84d6fc$export$8d8db47b9b0efb63 = /*#__PURE__*/ function(CrossDomainIdentifierType) {
    CrossDomainIdentifierType["XC"] = "xc";
    CrossDomainIdentifierType["UID"] = "uid";
    return CrossDomainIdentifierType;
}({});
let $3efe50d51d84d6fc$export$2140495465f9e528 = /*#__PURE__*/ function(CrossDomainIdentifierState) {
    CrossDomainIdentifierState["NEW"] = "NEW";
    CrossDomainIdentifierState["CHANGED"] = "CHANGED";
    CrossDomainIdentifierState["EXISTING"] = "EXISTING";
    CrossDomainIdentifierState["TIMEOUT"] = "TIMEOUT";
    CrossDomainIdentifierState["ERROR"] = "ERROR";
    CrossDomainIdentifierState["UNAVAILABLE"] = "UNAVAILABLE";
    CrossDomainIdentifierState["MALFORMED"] = "MALFORMED";
    CrossDomainIdentifierState["UNKNOWN"] = "UNKNOWN";
    return CrossDomainIdentifierState;
}({});
const $3efe50d51d84d6fc$export$96f086dcf574a9e2 = [
    'FetchError',
    'AbortError',
    'TypeError'
];

});



parcelRegister("cHKVx", function(module, exports) {
$parcel$export(module.exports, "AnalyticsResponse", () => $93fde6e60f95bd45$export$133650fcdde1b226);
class $93fde6e60f95bd45$export$133650fcdde1b226 {
    constructor(success, statusCode, message, eventResponseList){
        this.success = success;
        this.statusCode = statusCode;
        this.message = message;
        this.eventResponseList = eventResponseList;
    }
    isSuccess() {
        return this.success;
    }
    getStatusCode() {
        return this.statusCode;
    }
    getMessage() {
        return this.message;
    }
    getEventResponseList() {
        return this.eventResponseList;
    }
}

});

parcelRegister("o1t1Z", function(module, exports) {
$parcel$export(module.exports, "buildContext", () => $0483615eaa710c8d$export$3a7fe28f9bf4f3d9);

var $6rvcc = parcelRequire("6rvcc");

var $4ZNSA = parcelRequire("4ZNSA");
function $0483615eaa710c8d$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $0483615eaa710c8d$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $0483615eaa710c8d$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $6rvcc.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $0483615eaa710c8d$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
// Shallow removal of all falsey properties from an object, returning a new object.
const $0483615eaa710c8d$var$removeFalseyProperties = (obj)=>{
    const result = {};
    for(const key in obj){
        if (Object.prototype.hasOwnProperty.call(obj, key)) // If the value is not strictly true, map it to undefined
        {
            if (obj[key]) result[key] = obj[key];
        }
    }
    return result;
};
const $0483615eaa710c8d$export$3a7fe28f9bf4f3d9 = (context, overrides)=>{
    const result = $0483615eaa710c8d$var$_objectSpread($0483615eaa710c8d$var$_objectSpread({}, context.context), {}, {
        userAgent: navigator.userAgent
    });
    // use nestedRemoveUndefinedValues to strip undefined properties before
    // spreading the override object since we want properties that explicitly
    // set to 'undefined' to not overwrite any values, just like properties
    // that are 'undefined' because they're not set at all will.
    if (overrides !== null && overrides !== void 0 && overrides.excludedProperties) result.excludedProperties = $0483615eaa710c8d$var$_objectSpread($0483615eaa710c8d$var$_objectSpread({}, result.excludedProperties), (0, $4ZNSA.nestedRemoveUndefinedValues)(overrides.excludedProperties, '$.excludedProperties'));
    if (overrides !== null && overrides !== void 0 && overrides.userConsents) result.userConsents = $0483615eaa710c8d$var$_objectSpread($0483615eaa710c8d$var$_objectSpread({}, result.userConsents), (0, $4ZNSA.nestedRemoveUndefinedValues)(overrides.userConsents, '$.userConsents'));
    // Remove any falsey properties since we only want to have exclusions
    // that were explicitly declared as excluded.
    if (result.excludedProperties) result.excludedProperties = $0483615eaa710c8d$var$removeFalseyProperties(result.excludedProperties);
    return result;
};

});
parcelRegister("4ZNSA", function(module, exports) {
$parcel$export(module.exports, "nestedRemoveUndefinedValues", () => $3a338cf2d1e795da$export$2250ccecd1e040fd);
// @ts-ignore
// This function will essentially deepClone as well
const $3a338cf2d1e795da$export$2250ccecd1e040fd = (obj, path)=>{
    const recursionDepthLimit = 512;
    const nestedRemoveUndefinedValuesImpl = (source, processedReferences, path, depth)=>{
        if (source === null || typeof source !== 'object') return source;
        // If the level of nesting is egregiously excessive we'll stop processing any further to
        // avoid crashing due to stack exhaustion, instead we return a note object.
        if (depth > recursionDepthLimit) return {
            _depthLimitExceeded: true,
            message: `Object nesting depth limit exceeded at path '${path}' with depth '${depth}'`
        };
        // If this object has already been seen then processing it would create a circular reference,
        // instead we return a note object.
        if (processedReferences.has(source)) {
            const originalPath = processedReferences.get(source);
            return {
                _circularReference: true,
                message: `Circular reference to object at original path '${originalPath}' detected at path '${path}'`,
                originalPath: originalPath
            };
        }
        processedReferences.set(source, path);
        const clone = {};
        Object.keys(source).forEach((key)=>{
            const value = source[key];
            if (value !== undefined) {
                if (Array.isArray(value)) {
                    const newArray = [];
                    value.forEach((v, i)=>{
                        const newValue = nestedRemoveUndefinedValuesImpl(v, processedReferences, `${path}.${key}[${i}]`, depth + 1);
                        if (newValue !== undefined) newArray.push(newValue);
                    });
                    clone[key] = newArray;
                } else {
                    const newValue = nestedRemoveUndefinedValuesImpl(value, processedReferences, `${path}.${key}`, depth + 1);
                    if (newValue !== undefined) clone[key] = newValue;
                }
            }
        });
        processedReferences.delete(source);
        return clone;
    };
    return nestedRemoveUndefinedValuesImpl(obj, new Map(), path, 0);
};

});


parcelRegister("bJ6Ic", function(module, exports) {
$parcel$export(module.exports, "DEFAULT_REQUEST_TIMEOUT", () => $88991a89387117c8$export$9175ce0e1c95daf2);
$parcel$export(module.exports, "DEFAULT_METADATA_REQUEST_TIMEOUT", () => $88991a89387117c8$export$8fddcd1eff390364);
$parcel$export(module.exports, "DEFAULT_METADATA_REFRESH_INTERVAL", () => $88991a89387117c8$export$92ed669a3d41dad3);
$parcel$export(module.exports, "DEFAULT_METADATA_MIN_RETRY_DELAY", () => $88991a89387117c8$export$6649d5c857717efe);
$parcel$export(module.exports, "DEFAULT_METADATA_MAX_RETRY_DELAY", () => $88991a89387117c8$export$33e7628d3b2c0e2);
$parcel$export(module.exports, "DEFAULT_METADATA_PROPERTY_CHANGE_REFRESH_INTERVAL", () => $88991a89387117c8$export$6f1c008dd0c3b67e);
const $88991a89387117c8$export$9175ce0e1c95daf2 = 10000; // 10 seconds
const $88991a89387117c8$export$8fddcd1eff390364 = 60000; // 60 seconds
const $88991a89387117c8$export$92ed669a3d41dad3 = 600000; // 10 minutes
const $88991a89387117c8$export$6649d5c857717efe = 5000; // 5 seconds
const $88991a89387117c8$export$33e7628d3b2c0e2 = 3600000; // 60 minutes
const $88991a89387117c8$export$6f1c008dd0c3b67e = 10; // 10 milliseconds

});

parcelRegister("9vzfq", function(module, exports) {
$parcel$export(module.exports, "EventResponse", () => $6ec259c712435776$export$51e0b986fdbf3840);
class $6ec259c712435776$export$51e0b986fdbf3840 {
    constructor(messageId, results, segmentEvent){
        this.messageId = messageId;
        this.results = results;
        this.segmentEvent = segmentEvent;
    }
    getMessageId() {
        return this.messageId;
    }
    getResults() {
        return this.results;
    }
    getSegmentEvent() {
        return this.segmentEvent;
    }
}

});

parcelRegister("c8Y37", function(module, exports) {
$parcel$export(module.exports, "FetchError", () => $8d74cff4d55c4f44$export$26e841bcf1aeb894);
// eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
class $8d74cff4d55c4f44$export$26e841bcf1aeb894 extends Error {
    constructor(message, statusCode, statusText){
        super(message);
        this.statusCode = statusCode;
        this.statusText = statusText;
    }
}

});

parcelRegister("HBXCt", function(module, exports) {
$parcel$export(module.exports, "HTTP_STATUS_CODE_MAP", () => $08317673ed014342$export$ba118f9de1e5ac63);
const $08317673ed014342$export$ba118f9de1e5ac63 = new Map([
    [
        200,
        'OK'
    ],
    [
        400,
        'Bad Request'
    ],
    [
        401,
        'Unauthorized'
    ],
    [
        402,
        'Payment Required'
    ],
    [
        403,
        'Forbidden'
    ],
    [
        404,
        'Not Found'
    ],
    [
        405,
        'Method Not Allowed'
    ],
    [
        406,
        'Not Acceptable'
    ],
    [
        407,
        'Proxy Authentication Required'
    ],
    [
        408,
        'Request Timeout'
    ],
    [
        409,
        'Conflict'
    ],
    [
        410,
        'Gone'
    ],
    [
        411,
        'Length Required'
    ],
    [
        412,
        'Precondition Failed'
    ],
    [
        413,
        'Payload Too Large'
    ],
    [
        414,
        'URI Too Long'
    ],
    [
        415,
        'Unsupported Media Type'
    ],
    [
        416,
        'Requested range not satisfiable'
    ],
    [
        417,
        'Expectation Failed'
    ],
    [
        418,
        "I'm a teapot"
    ],
    [
        422,
        'Unprocessable Entity'
    ],
    [
        423,
        'Locked'
    ],
    [
        424,
        'Failed Dependency'
    ],
    [
        425,
        'Too Early'
    ],
    [
        426,
        'Upgrade Required'
    ],
    [
        428,
        'Precondition Required'
    ],
    [
        429,
        'Too Many Requests'
    ],
    [
        431,
        'Request Header Fields Too Large'
    ],
    [
        451,
        'Unavailable For Legal Reasons'
    ],
    [
        500,
        'Internal Server Error'
    ],
    [
        501,
        'Not Implemented'
    ],
    [
        502,
        'Bad Gateway'
    ],
    [
        503,
        'Service Unavailable'
    ],
    [
        504,
        'Gateway Timeout'
    ],
    [
        505,
        'HTTP Version not supported'
    ],
    [
        506,
        'Variant Also Negotiates'
    ],
    [
        507,
        'Insufficient Storage'
    ],
    [
        508,
        'Loop Detected'
    ],
    [
        509,
        'Bandwidth Limit Exceeded'
    ],
    [
        510,
        'Not Extended'
    ],
    [
        511,
        'Network Authentication Required'
    ],
    [
        -1,
        'Unknown Status'
    ]
]);

});

parcelRegister("hL0G3", function(module, exports) {
$parcel$export(module.exports, "LastError", () => $ced759ee3c9667b9$export$a63e16b3351b8c36);

var $c8Y37 = parcelRequire("c8Y37");
class $ced759ee3c9667b9$export$a63e16b3351b8c36 {
    constructor(reason, error){
        this.reason = reason;
        this.message = error instanceof Error ? error.message : null;
        this.statusCode = error instanceof (0, $c8Y37.FetchError) ? error.statusCode : null;
    }
}

});

parcelRegister("3I9pn", function(module, exports) {
$parcel$export(module.exports, "prepareEventContext", () => $2b3cc7703d365242$export$6b26e26d40264200);
// @ts-ignore

var $dMCb6 = parcelRequire("dMCb6");

var $4ZNSA = parcelRequire("4ZNSA");
const $2b3cc7703d365242$export$6b26e26d40264200 = (context)=>{
    const propertiesWithoutUndefined = (0, $4ZNSA.nestedRemoveUndefinedValues)(context, '$.context');
    return (0, (/*@__PURE__*/$parcel$interopDefault($dMCb6)))(propertiesWithoutUndefined);
};

});
parcelRegister("dMCb6", function(module, exports) {
'use strict';

var $6so8c = parcelRequire("6so8c");
/**
 * Expose `traverse`.
 */ module.exports = $a08d5f71a1a1eb97$var$traverse;
/**
 * Recursively traverse an object or array, and convert
 * all ISO date strings parse into Date objects.
 *
 * @param {Object} input - object, array, or string to convert
 * @param {Boolean} strict - only convert strings with year, month, and date
 * @return {Object}
 */ function $a08d5f71a1a1eb97$var$traverse(input, strict) {
    if (strict === undefined) strict = true;
    if (input && typeof input === 'object') return $a08d5f71a1a1eb97$var$traverseObject(input, strict);
    else if (Array.isArray(input)) return $a08d5f71a1a1eb97$var$traverseArray(input, strict);
    else if ($6so8c.is(input, strict)) return $6so8c.parse(input);
    return input;
}
/**
 * Object traverser helper function.
 *
 * @param {Object} obj - object to traverse
 * @param {Boolean} strict - only convert strings with year, month, and date
 * @return {Object}
 */ function $a08d5f71a1a1eb97$var$traverseObject(obj, strict) {
    Object.keys(obj).forEach(function(key) {
        obj[key] = $a08d5f71a1a1eb97$var$traverse(obj[key], strict);
    });
    return obj;
}
/**
 * Array traverser helper function
 *
 * @param {Array} arr - array to traverse
 * @param {Boolean} strict - only convert strings with year, month, and date
 * @return {Array}
 */ function $a08d5f71a1a1eb97$var$traverseArray(arr, strict) {
    arr.forEach(function(value, index) {
        arr[index] = $a08d5f71a1a1eb97$var$traverse(value, strict);
    });
    return arr;
}

});
parcelRegister("6so8c", function(module, exports) {
$parcel$export(module.exports, "parse", () => $4b381390c1569522$export$98e6a39c04603d36, (v) => $4b381390c1569522$export$98e6a39c04603d36 = v);
$parcel$export(module.exports, "is", () => $4b381390c1569522$export$226b3eccf92c9ed9, (v) => $4b381390c1569522$export$226b3eccf92c9ed9 = v);
/**
 * Convert an ISO date string to a date. Fallback to native `Date.parse`.
 *
 * https://github.com/csnover/js-iso8601/blob/lax/iso8601.js
 *
 * @param {String} iso
 * @return {Date}
 */ var $4b381390c1569522$export$98e6a39c04603d36;
/**
 * Checks whether a `string` is an ISO date string. `strict` mode requires that
 * the date string at least have a year, month and date.
 *
 * @param {String} string
 * @param {Boolean} strict
 * @return {Boolean}
 */ var $4b381390c1569522$export$226b3eccf92c9ed9;
'use strict';
/**
 * Matcher, slightly modified from:
 *
 * https://github.com/csnover/js-iso8601/blob/lax/iso8601.js
 */ var $4b381390c1569522$var$matcher = /^(\d{4})(?:-?(\d{2})(?:-?(\d{2}))?)?(?:([ T])(\d{2}):?(\d{2})(?::?(\d{2})(?:[,\.](\d{1,}))?)?(?:(Z)|([+\-])(\d{2})(?::?(\d{2}))?)?)?$/;
$4b381390c1569522$export$98e6a39c04603d36 = function(iso) {
    var numericKeys = [
        1,
        5,
        6,
        7,
        11,
        12
    ];
    var arr = $4b381390c1569522$var$matcher.exec(iso);
    var offset = 0;
    // fallback to native parsing
    if (!arr) return new Date(iso);
    /* eslint-disable no-cond-assign */ // remove undefined values
    for(var i = 0, val; val = numericKeys[i]; i++)arr[val] = parseInt(arr[val], 10) || 0;
    /* eslint-enable no-cond-assign */ // allow undefined days and months
    arr[2] = parseInt(arr[2], 10) || 1;
    arr[3] = parseInt(arr[3], 10) || 1;
    // month is 0-11
    arr[2]--;
    // allow abitrary sub-second precision
    arr[8] = arr[8] ? (arr[8] + '00').substring(0, 3) : 0;
    // apply timezone if one exists
    if (arr[4] === ' ') offset = new Date().getTimezoneOffset();
    else if (arr[9] !== 'Z' && arr[10]) {
        offset = arr[11] * 60 + arr[12];
        if (arr[10] === '+') offset = 0 - offset;
    }
    var millis = Date.UTC(arr[1], arr[2], arr[3], arr[5], arr[6] + offset, arr[7], arr[8]);
    return new Date(millis);
};
$4b381390c1569522$export$226b3eccf92c9ed9 = function(string, strict) {
    if (typeof string !== 'string') return false;
    if (strict && /^\d{4}-\d{2}-\d{2}/.test(string) === false) return false;
    return $4b381390c1569522$var$matcher.test(string);
};

});



parcelRegister("zYlx7", function(module, exports) {
$parcel$export(module.exports, "prepareEventProperties", () => $06c21484e05d2894$export$44d22e5fb02cc68e);
// @ts-ignore

var $dMCb6 = parcelRequire("dMCb6");

var $4ZNSA = parcelRequire("4ZNSA");
const $06c21484e05d2894$export$44d22e5fb02cc68e = (properties)=>{
    const propertiesWithoutUndefined = (0, $4ZNSA.nestedRemoveUndefinedValues)(properties, '$.properties');
    // Remove any override properties that shouldn't be included in the event body
    delete propertiesWithoutUndefined.excludedProperties;
    delete propertiesWithoutUndefined.userConsents;
    return (0, (/*@__PURE__*/$parcel$interopDefault($dMCb6)))(propertiesWithoutUndefined);
};

});

parcelRegister("amec4", function(module, exports) {
$parcel$export(module.exports, "sendEvents", () => $78a6f802f57c0600$export$8e8f0180c1b41fad);

var $6rvcc = parcelRequire("6rvcc");

var $cvlyC = parcelRequire("cvlyC");

var $c8Y37 = parcelRequire("c8Y37");
function $78a6f802f57c0600$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $78a6f802f57c0600$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $78a6f802f57c0600$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $6rvcc.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $78a6f802f57c0600$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
const $78a6f802f57c0600$export$8e8f0180c1b41fad = async (options)=>{
    var _createOrGetAbortCont;
    const signal = (_createOrGetAbortCont = $78a6f802f57c0600$var$createOrGetAbortController(options)) === null || _createOrGetAbortCont === void 0 ? void 0 : _createOrGetAbortCont.signal;
    const corsOptions = $78a6f802f57c0600$var$getCorsForUrl(options.url);
    const response = await fetch(options.url, $78a6f802f57c0600$var$_objectSpread({
        method: 'POST',
        // Content-type has to be text/plain in order to prevent unnecessary `OPTIONS` requests.
        headers: {
            'Content-Type': 'text/plain'
        },
        body: JSON.stringify(options.batch),
        signal: signal
    }, corsOptions));
    if (response.status !== 200) throw new (0, $c8Y37.FetchError)(`HTTP Error ${response.status} (${response.statusText})`, response.status, response.statusText);
    try {
        let responseBody = await response.clone().json();
        if (responseBody.success === true) return response;
    } catch (_unused) {}
    throw new (0, $c8Y37.FetchError)('Invalid HTTP Response (Invalid response body)', 200, 'Invalid response body');
};
const $78a6f802f57c0600$var$createOrGetAbortController = (options)=>{
    if (options.abortController) return options.abortController;
    else if (options.timeout) {
        const abortController = new AbortController();
        // After a fetch has completed, calling abort is ignored.
        setTimeout(()=>{
            abortController.abort();
        }, options.timeout);
        return abortController;
    }
    return undefined;
};
// To ensure we always have cookies, we should check if the origins match.
// If they dont, we need to set mode to `cors` and credentials to `include`.
const $78a6f802f57c0600$var$getCorsForUrl = (0, $cvlyC.default)((url)=>{
    const origin = new URL(url).origin;
    if (origin === location.origin) return {};
    else return {
        mode: 'cors',
        credentials: 'include'
    };
});

});
parcelRegister("cvlyC", function(module, exports) {
$parcel$export(module.exports, "default", () => $91a91a1bf1b7e1c6$export$2e2bcd8739ae039);
var $91a91a1bf1b7e1c6$var$safeIsNaN = Number.isNaN || function ponyfill(value) {
    return typeof value === 'number' && value !== value;
};
function $91a91a1bf1b7e1c6$var$isEqual(first, second) {
    if (first === second) return true;
    if ($91a91a1bf1b7e1c6$var$safeIsNaN(first) && $91a91a1bf1b7e1c6$var$safeIsNaN(second)) return true;
    return false;
}
function $91a91a1bf1b7e1c6$var$areInputsEqual(newInputs, lastInputs) {
    if (newInputs.length !== lastInputs.length) return false;
    for(var i = 0; i < newInputs.length; i++){
        if (!$91a91a1bf1b7e1c6$var$isEqual(newInputs[i], lastInputs[i])) return false;
    }
    return true;
}
function $91a91a1bf1b7e1c6$export$2e2bcd8739ae039(resultFn, isEqual) {
    if (isEqual === void 0) isEqual = $91a91a1bf1b7e1c6$var$areInputsEqual;
    var cache = null;
    function memoized() {
        var newArgs = [];
        for(var _i = 0; _i < arguments.length; _i++)newArgs[_i] = arguments[_i];
        if (cache && cache.lastThis === this && isEqual(newArgs, cache.lastArgs)) return cache.lastResult;
        var lastResult = resultFn.apply(this, newArgs);
        cache = {
            lastResult: lastResult,
            lastArgs: newArgs,
            lastThis: this
        };
        return lastResult;
    }
    memoized.clear = function clear() {
        cache = null;
    };
    return memoized;
}

});


parcelRegister("lhwNW", function(module, exports) {
$parcel$export(module.exports, "default", () => $f7e4a1cbd6920661$export$2e2bcd8739ae039);

var $eWmwA = parcelRequire("eWmwA");

var $hel6R = parcelRequire("hel6R");

var $kN8x2 = parcelRequire("kN8x2");

var $jc2hJ = parcelRequire("jc2hJ");

var $1Ygrk = parcelRequire("1Ygrk");
// Cookie is stale, if anonymousId was generated 7 days ago.
const $f7e4a1cbd6920661$var$ANONYMOUS_ID_COOKIE_STALE_DAYS = 7;
const $f7e4a1cbd6920661$var$SAFE = 'SAFE';
const $f7e4a1cbd6920661$var$UNSAFE = 'UNSAFE';
const $f7e4a1cbd6920661$var$NOT_FOUND = 'NOT_FOUND';
const $f7e4a1cbd6920661$var$COOKIE = 'COOKIE';
const $f7e4a1cbd6920661$var$LOCAL_STORAGE = 'LOCAL_STORAGE';
class $f7e4a1cbd6920661$export$2e2bcd8739ae039 {
    constructor(disableCookiePersistence){
        this.store = new (0, $jc2hJ.default)({
            useStoragePrefix: false
        });
        this.cookie = new (0, $kN8x2.default)(disableCookiePersistence);
    }
    getUserId() {
        return this.userId || null;
    }
    setUserId(userId) {
        this.userId = userId;
    }
    getAnonymousId(customAnonymousIdGenerator) {
        /**
     * Prefer localStorage as there cant be duplicate keys, and its faster. Also update cookie, if stale.
     * If not set in localStorage, check cookies. Also set localStorage for future attempts.
     * If not in cookies, generate a new one. Set both cookie and localStorage keys.
     */ return this.getAnonymousIdFromLocalStorageAndUpdateCookieIfStale() || this.getAnonymousIdFromCookieAndUpdateLocalStorage() || this.generateNewAnonymousId(customAnonymousIdGenerator);
    }
    setAnonymousId(anonymousId) {
        const stringifyAnonymosId = JSON.stringify(anonymousId);
        this.cookie.set((0, $hel6R.AWCCookiesKeys).AJS_ANONYMOUS_ID, stringifyAnonymosId);
        this.lastAnonymousIdCookieUpdate = Date.now();
        return this.store.setItem((0, $hel6R.AllAnalyticsCookies).AJS_ANONYMOUS_ID.getKey(), stringifyAnonymosId);
    }
    getAnonymousIdFromStorage(source) {
        const rawStorageAnonidValue = source === $f7e4a1cbd6920661$var$LOCAL_STORAGE ? this.store.getItem((0, $hel6R.AllAnalyticsCookies).AJS_ANONYMOUS_ID.getKey()) : this.cookie.get((0, $hel6R.AWCCookiesKeys).AJS_ANONYMOUS_ID);
        if (rawStorageAnonidValue) {
            const unsafeValue = {
                type: $f7e4a1cbd6920661$var$UNSAFE,
                anonymousId: rawStorageAnonidValue
            };
            try {
                const parsedAnonId = JSON.parse(rawStorageAnonidValue);
                if (parsedAnonId && typeof parsedAnonId === 'string') return {
                    type: $f7e4a1cbd6920661$var$SAFE,
                    anonymousId: parsedAnonId
                };
                return unsafeValue;
            } catch (_unused) {
                /*
         * Segments new Analytics-next client will store strings as strings without stringifing.
         * The legacy Segment client and AWC always stringify and parse cookies and values.
         * If the new Segment analytics-client stores a cookie and local storage value first, it will
         * breaking old clients.
         *
         * Additionally, JSON.parse can cause exceptions to be thrown in some browsers; see AAP-324.
         *
         * Intentionally swalling errors here and returning the original value found in storage to avoid ping-pong.
         */ return unsafeValue;
            }
        }
        return {
            type: $f7e4a1cbd6920661$var$NOT_FOUND
        };
    }
    getAnonymousIdFromLocalStorageAndUpdateCookieIfStale() {
        const localStorageValue = this.getAnonymousIdFromStorage($f7e4a1cbd6920661$var$LOCAL_STORAGE);
        let shouldUpdateCookie = false;
        if (!this.lastAnonymousIdCookieUpdate || (0, $eWmwA.default)(new Date(), new Date(this.lastAnonymousIdCookieUpdate)) >= $f7e4a1cbd6920661$var$ANONYMOUS_ID_COOKIE_STALE_DAYS) shouldUpdateCookie = true;
        switch(localStorageValue.type){
            case $f7e4a1cbd6920661$var$SAFE:
                if (shouldUpdateCookie) this.setAnonymousId(localStorageValue.anonymousId);
                return localStorageValue.anonymousId;
            case $f7e4a1cbd6920661$var$UNSAFE:
                return localStorageValue.anonymousId;
            case $f7e4a1cbd6920661$var$NOT_FOUND:
            default:
                return null;
        }
    }
    getAnonymousIdFromCookieAndUpdateLocalStorage() {
        const cookieValue = this.getAnonymousIdFromStorage($f7e4a1cbd6920661$var$COOKIE);
        switch(cookieValue.type){
            case $f7e4a1cbd6920661$var$SAFE:
            case $f7e4a1cbd6920661$var$UNSAFE:
                this.store.setItem((0, $hel6R.AllAnalyticsCookies).AJS_ANONYMOUS_ID.getKey(), JSON.stringify(cookieValue.anonymousId));
                return cookieValue.anonymousId;
            case $f7e4a1cbd6920661$var$NOT_FOUND:
            default:
                return null;
        }
    }
    generateNewAnonymousId(customAnonymousIdGenerator) {
        const generator = typeof customAnonymousIdGenerator === 'function' ? customAnonymousIdGenerator : ()=>{
            return (0, $1Ygrk.default)();
        };
        const newAnonId = generator();
        this.setAnonymousId(newAnonId);
        return newAnonId;
    }
}

});
parcelRegister("eWmwA", function(module, exports) {
$parcel$export(module.exports, "default", () => $ae07f466ece1f6b1$export$2e2bcd8739ae039);

var $k0voR = parcelRequire("k0voR");

var $6XY0b = parcelRequire("6XY0b");

var $aCKXn = parcelRequire("aCKXn");
// for accurate equality comparisons of UTC timestamps that end up
// having the same representation in local time, e.g. one hour before
// DST ends vs. the instant that DST ends.
function $ae07f466ece1f6b1$var$compareLocalAsc(dateLeft, dateRight) {
    var diff = dateLeft.getFullYear() - dateRight.getFullYear() || dateLeft.getMonth() - dateRight.getMonth() || dateLeft.getDate() - dateRight.getDate() || dateLeft.getHours() - dateRight.getHours() || dateLeft.getMinutes() - dateRight.getMinutes() || dateLeft.getSeconds() - dateRight.getSeconds() || dateLeft.getMilliseconds() - dateRight.getMilliseconds();
    if (diff < 0) return -1;
    else if (diff > 0) return 1;
    else return diff;
}
function $ae07f466ece1f6b1$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $aCKXn.default)(2, arguments);
    var dateLeft = (0, $k0voR.default)(dirtyDateLeft);
    var dateRight = (0, $k0voR.default)(dirtyDateRight);
    var sign = $ae07f466ece1f6b1$var$compareLocalAsc(dateLeft, dateRight);
    var difference = Math.abs((0, $6XY0b.default)(dateLeft, dateRight));
    dateLeft.setDate(dateLeft.getDate() - sign * difference);
    // Math.abs(diff in full days - diff in calendar days) === 1 if last calendar day is not full
    // If so, result must be decreased by 1 in absolute value
    var isLastDayNotFull = Number($ae07f466ece1f6b1$var$compareLocalAsc(dateLeft, dateRight) === -sign);
    var result = sign * (difference - isLastDayNotFull);
    // Prevent negative zero
    return result === 0 ? 0 : result;
}

});
parcelRegister("k0voR", function(module, exports) {
$parcel$export(module.exports, "default", () => $e90c2a187f20b2a5$export$2e2bcd8739ae039);

var $iCnSD = parcelRequire("iCnSD");

var $aCKXn = parcelRequire("aCKXn");
function $e90c2a187f20b2a5$export$2e2bcd8739ae039(argument) {
    (0, $aCKXn.default)(1, arguments);
    var argStr = Object.prototype.toString.call(argument);
    // Clone the date
    if (argument instanceof Date || (0, $iCnSD.default)(argument) === 'object' && argStr === '[object Date]') // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new Date(argument.getTime());
    else if (typeof argument === 'number' || argStr === '[object Number]') return new Date(argument);
    else {
        if ((typeof argument === 'string' || argStr === '[object String]') && typeof console !== 'undefined') {
            // eslint-disable-next-line no-console
            console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#string-arguments");
            // eslint-disable-next-line no-console
            console.warn(new Error().stack);
        }
        return new Date(NaN);
    }
}

});
parcelRegister("iCnSD", function(module, exports) {
$parcel$export(module.exports, "default", () => $d8de4cbdb597287c$export$2e2bcd8739ae039);
function $d8de4cbdb597287c$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $d8de4cbdb597287c$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $d8de4cbdb597287c$export$2e2bcd8739ae039(o);
}

});

parcelRegister("aCKXn", function(module, exports) {
$parcel$export(module.exports, "default", () => $7bc1e09ac693047d$export$2e2bcd8739ae039);
function $7bc1e09ac693047d$export$2e2bcd8739ae039(required, args) {
    if (args.length < required) throw new TypeError(required + ' argument' + (required > 1 ? 's' : '') + ' required, but only ' + args.length + ' present');
}

});


parcelRegister("6XY0b", function(module, exports) {
$parcel$export(module.exports, "default", () => $5126cbe4c03a9703$export$2e2bcd8739ae039);

var $9jQRB = parcelRequire("9jQRB");

var $dQr7B = parcelRequire("dQr7B");

var $aCKXn = parcelRequire("aCKXn");
var $5126cbe4c03a9703$var$MILLISECONDS_IN_DAY = 86400000;
function $5126cbe4c03a9703$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $aCKXn.default)(2, arguments);
    var startOfDayLeft = (0, $dQr7B.default)(dirtyDateLeft);
    var startOfDayRight = (0, $dQr7B.default)(dirtyDateRight);
    var timestampLeft = startOfDayLeft.getTime() - (0, $9jQRB.default)(startOfDayLeft);
    var timestampRight = startOfDayRight.getTime() - (0, $9jQRB.default)(startOfDayRight);
    // Round the number of days to the nearest integer
    // because the number of milliseconds in a day is not constant
    // (e.g. it's different in the day of the daylight saving time clock shift)
    return Math.round((timestampLeft - timestampRight) / $5126cbe4c03a9703$var$MILLISECONDS_IN_DAY);
}

});
parcelRegister("9jQRB", function(module, exports) {
$parcel$export(module.exports, "default", () => $6c8ee502bc30586d$export$2e2bcd8739ae039);
/**
 * Google Chrome as of 67.0.3396.87 introduced timezones with offset that includes seconds.
 * They usually appear for dates that denote time before the timezones were introduced
 * (e.g. for 'Europe/Prague' timezone the offset is GMT+00:57:44 before 1 October 1891
 * and GMT+01:00:00 after that date)
 *
 * Date#getTimezoneOffset returns the offset in minutes and would return 57 for the example above,
 * which would lead to incorrect calculations.
 *
 * This function returns the timezone offset in milliseconds that takes seconds in account.
 */ function $6c8ee502bc30586d$export$2e2bcd8739ae039(date) {
    var utcDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds()));
    utcDate.setUTCFullYear(date.getFullYear());
    return date.getTime() - utcDate.getTime();
}

});

parcelRegister("dQr7B", function(module, exports) {
$parcel$export(module.exports, "default", () => $a1452b7a9be621b1$export$2e2bcd8739ae039);

var $k0voR = parcelRequire("k0voR");

var $aCKXn = parcelRequire("aCKXn");
function $a1452b7a9be621b1$export$2e2bcd8739ae039(dirtyDate) {
    (0, $aCKXn.default)(1, arguments);
    var date = (0, $k0voR.default)(dirtyDate);
    date.setHours(0, 0, 0, 0);
    return date;
}

});



parcelRegister("hel6R", function(module, exports) {
$parcel$export(module.exports, "AWCCookiesKeys", () => $c8b41e64c5f9315f$export$202d555a5dbfd90c);
$parcel$export(module.exports, "AllAnalyticsCookies", () => $c8b41e64c5f9315f$export$d4cb17942ea57c95);
let $c8b41e64c5f9315f$export$202d555a5dbfd90c = /*#__PURE__*/ function(AWCCookiesKeys) {
    AWCCookiesKeys["AWC_TLD_TEST"] = "AWC_TLD_TEST";
    AWCCookiesKeys["AWC_ANALYTICS_DEBUG"] = "AWC_ANALYTICS_DEBUG";
    AWCCookiesKeys["AJS_ANONYMOUS_ID"] = "AJS_ANONYMOUS_ID";
    return AWCCookiesKeys;
}({});
class $c8b41e64c5f9315f$var$CookieSchema {
    constructor(key, options){
        this.key = key;
        this.options = options;
    }
    getAttributes() {
        return this.options;
    }
    getKey() {
        return this.key;
    }
}
const $c8b41e64c5f9315f$var$isSecure = ()=>{
    try {
        return globalThis && globalThis.location && globalThis.location.protocol === 'https:';
    } catch (err) {
        return false;
    }
};
const $c8b41e64c5f9315f$export$d4cb17942ea57c95 = {
    [$c8b41e64c5f9315f$export$202d555a5dbfd90c.AWC_TLD_TEST]: new $c8b41e64c5f9315f$var$CookieSchema('__awc_tld_test__', {
        expires: 365,
        secure: $c8b41e64c5f9315f$var$isSecure(),
        path: '/'
    }),
    [$c8b41e64c5f9315f$export$202d555a5dbfd90c.AWC_ANALYTICS_DEBUG]: new $c8b41e64c5f9315f$var$CookieSchema('atlassian_analytics_debug', {
        expires: 365,
        secure: $c8b41e64c5f9315f$var$isSecure(),
        path: '/'
    }),
    [$c8b41e64c5f9315f$export$202d555a5dbfd90c.AJS_ANONYMOUS_ID]: new $c8b41e64c5f9315f$var$CookieSchema('ajs_anonymous_id', {
        expires: 365,
        secure: $c8b41e64c5f9315f$var$isSecure(),
        path: '/'
    })
};

});

parcelRegister("kN8x2", function(module, exports) {
$parcel$export(module.exports, "default", () => $f22f007bc4ca3f5c$export$2e2bcd8739ae039);

var $6rvcc = parcelRequire("6rvcc");

var $7frtV = parcelRequire("7frtV");

var $hel6R = parcelRequire("hel6R");

var $dd4rW = parcelRequire("dd4rW");

var $k6Fyl = parcelRequire("k6Fyl");
function $f22f007bc4ca3f5c$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $f22f007bc4ca3f5c$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $f22f007bc4ca3f5c$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $6rvcc.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $f22f007bc4ca3f5c$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
class $f22f007bc4ca3f5c$export$2e2bcd8739ae039 {
    constructor(disableCookiePersistence){
        this.cookieLike = (0, $k6Fyl.canUseCookie)(disableCookiePersistence) ? (0, $7frtV.default) : new (0, $dd4rW.default)();
    }
    set(name, value, options) {
        // no-op
        if (!(0, $hel6R.AllAnalyticsCookies)[name]) {
            // eslint-disable-next-line no-console
            console.warn(`Unknown cookie key ${name} provided, not set.`);
            return;
        }
        return this.cookieLike.set((0, $hel6R.AllAnalyticsCookies)[name].getKey(), value, $f22f007bc4ca3f5c$var$_objectSpread($f22f007bc4ca3f5c$var$_objectSpread({}, (0, $hel6R.AllAnalyticsCookies)[name].getAttributes()), {}, {
            // Function is memoized so we only calculate this once per page load
            domain: (0, $k6Fyl.getTld)()
        }, options));
    }
    get(name) {
        if (!(0, $hel6R.AllAnalyticsCookies)[name]) {
            // eslint-disable-next-line no-console
            console.warn(`Unknown cookie key ${name} provided, not fetched.`);
            return;
        }
        return this.cookieLike.get((0, $hel6R.AllAnalyticsCookies)[name].getKey());
    }
    remove(name, options) {
        if (!(0, $hel6R.AllAnalyticsCookies)[name]) {
            // eslint-disable-next-line no-console
            console.warn(`Unknown cookie key ${name} provided, not removed.`);
            return;
        }
        this.cookieLike.remove((0, $hel6R.AllAnalyticsCookies)[name].getKey(), $f22f007bc4ca3f5c$var$_objectSpread({}, options));
    }
}

});
parcelRegister("7frtV", function(module, exports) {
$parcel$export(module.exports, "default", () => $546f4065ab6d5808$export$2e2bcd8739ae039);
/*! js-cookie v3.0.8 | MIT */ function $546f4065ab6d5808$var$assign(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source){
            if (key === '__proto__') continue;
            target[key] = source[key];
        }
    }
    return target;
}
var $546f4065ab6d5808$var$defaultConverter = {
    read: function(value) {
        if (value[0] === '"') value = value.slice(1, -1);
        return value.replace(/(%[\dA-F]{2})+/gi, decodeURIComponent);
    },
    write: function(value) {
        return encodeURIComponent(value).replace(/%(2[346BF]|3[AC-F]|40|5[BDE]|60|7[BCD])/g, decodeURIComponent);
    }
};
function $546f4065ab6d5808$var$init(converter, defaultAttributes) {
    function set(name, value, attributes) {
        if (typeof document === 'undefined') return;
        attributes = $546f4065ab6d5808$var$assign({}, defaultAttributes, attributes);
        if (typeof attributes.expires === 'number') attributes.expires = new Date(Date.now() + attributes.expires * 864e5);
        if (attributes.expires) attributes.expires = attributes.expires.toUTCString();
        name = encodeURIComponent(name).replace(/%(2[346B]|5E|60|7C)/g, decodeURIComponent).replace(/[()]/g, escape);
        var stringifiedAttributes = '';
        for(var attributeName in attributes){
            if (!attributes[attributeName]) continue;
            stringifiedAttributes += '; ' + attributeName;
            if (attributes[attributeName] === true) continue;
            // Considers RFC 6265 section 5.2:
            // ...
            // 3.  If the remaining unparsed-attributes contains a %x3B (";")
            //     character:
            // Consume the characters of the unparsed-attributes up to,
            // not including, the first %x3B (";") character.
            // ...
            stringifiedAttributes += '=' + attributes[attributeName].split(';')[0];
        }
        return document.cookie = name + '=' + converter.write(value, name) + stringifiedAttributes;
    }
    function get(name) {
        if (typeof document === 'undefined' || arguments.length && !name) return;
        // To prevent the for loop in the first place assign an empty array
        // in case there are no cookies at all.
        var cookies = document.cookie ? document.cookie.split('; ') : [];
        var jar = {};
        for(var i = 0; i < cookies.length; i++){
            var parts = cookies[i].split('=');
            var value = parts.slice(1).join('=');
            try {
                var found = decodeURIComponent(parts[0]);
                if (!(found in jar)) jar[found] = converter.read(value, found);
                if (name === found) break;
            } catch (_e) {
            // Do nothing...
            }
        }
        return name ? jar[name] : jar;
    }
    return Object.create({
        set: set,
        get: get,
        remove: function(name, attributes) {
            set(name, '', $546f4065ab6d5808$var$assign({}, attributes, {
                expires: -1
            }));
        },
        withAttributes: function(attributes) {
            return $546f4065ab6d5808$var$init(this.converter, $546f4065ab6d5808$var$assign({}, this.attributes, attributes));
        },
        withConverter: function(converter) {
            return $546f4065ab6d5808$var$init($546f4065ab6d5808$var$assign({}, this.converter, converter), this.attributes);
        }
    }, {
        attributes: {
            value: Object.freeze(defaultAttributes)
        },
        converter: {
            value: Object.freeze(converter)
        }
    });
}
var $546f4065ab6d5808$export$2e2bcd8739ae039 = $546f4065ab6d5808$var$init($546f4065ab6d5808$var$defaultConverter, {
    path: '/'
});

});

parcelRegister("dd4rW", function(module, exports) {
$parcel$export(module.exports, "default", () => $99dff0dfd76e6218$export$2e2bcd8739ae039);

var $jc2hJ = parcelRequire("jc2hJ");
class $99dff0dfd76e6218$export$2e2bcd8739ae039 {
    constructor(){
        this.safeStorage = new (0, $jc2hJ.default)({
            useStoragePrefix: false
        });
    }
    set(name, value) {
        this.safeStorage.setItem(name, value);
        return value;
    }
    get(name) {
        const value = this.safeStorage.getItem(name);
        return value || undefined;
    }
    remove(name) {
        this.safeStorage.removeItem(name);
    }
}

});
parcelRegister("jc2hJ", function(module, exports) {
$parcel$export(module.exports, "default", () => $df90e90c3af4c162$export$2e2bcd8739ae039);

var $eXTjr = parcelRequire("eXTjr");

var $5eu7g = parcelRequire("5eu7g");
class $df90e90c3af4c162$export$2e2bcd8739ae039 extends (0, $5eu7g.default) {
    constructor(options){
        let storageToUse;
        try {
            // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
            storageToUse = globalThis.localStorage || (0, $eXTjr.default);
        } catch (err) {
            storageToUse = (0, $eXTjr.default);
        }
        super(storageToUse, options);
    }
}

});
parcelRegister("eXTjr", function(module, exports) {
$parcel$export(module.exports, "default", () => $ae517b47e306f68f$export$2e2bcd8739ae039);

var $fGVRK = parcelRequire("fGVRK");
// eslint-disable-next-line import/no-anonymous-default-export
const $ae517b47e306f68f$var$inmemorystorage = new (0, $fGVRK.InMemoryStore)();
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$ae517b47e306f68f$export$2e2bcd8739ae039 = $ae517b47e306f68f$var$inmemorystorage;

});
parcelRegister("fGVRK", function(module, exports) {
$parcel$export(module.exports, "InMemoryStore", () => $b6c7aa36770a96ec$export$90e3e001bcac59c7);

var $6rvcc = parcelRequire("6rvcc");
class $b6c7aa36770a96ec$export$90e3e001bcac59c7 {
    constructor(){
        (0, $6rvcc.default)(this, "_data", {});
        (0, $6rvcc.default)(this, "length", 0);
        (0, $6rvcc.default)(this, "setItem", (key, value)=>{
            this._data[key] = value;
            this.length = Object.keys(this._data).length;
            return value;
        });
        (0, $6rvcc.default)(this, "getItem", (key)=>{
            if (key in this._data) return this._data[key];
            return null;
        });
        (0, $6rvcc.default)(this, "removeItem", (key)=>{
            if (key in this._data) delete this._data[key];
            this.length = Object.keys(this._data).length;
            return null;
        });
        (0, $6rvcc.default)(this, "clear", ()=>{
            this._data = {};
            this.length = 0;
        });
        (0, $6rvcc.default)(this, "key", (index)=>Object.keys(this._data)[index]);
    }
}

});


parcelRegister("5eu7g", function(module, exports) {
$parcel$export(module.exports, "default", () => $3cf59f0615ba9877$export$2e2bcd8739ae039);

var $6rvcc = parcelRequire("6rvcc");

var $dpXUu = parcelRequire("dpXUu");

var $eXTjr = parcelRequire("eXTjr");

var $kxxHr = parcelRequire("kxxHr");
const $3cf59f0615ba9877$export$41c06fdd37b7e9a5 = 'awc';
const $3cf59f0615ba9877$export$770aa8bc07b3de03 = 'awcInMemoryStorageFallback';
class $3cf59f0615ba9877$export$2e2bcd8739ae039 {
    constructor(storageToUse, options = {}){
        (0, $6rvcc.default)(this, "getStore", ()=>this._store);
        (0, $6rvcc.default)(this, "getItem", (key)=>this._store.getItem(this.createKey(key)));
        (0, $6rvcc.default)(this, "removeItem", (key)=>this._store.removeItem(this.createKey(key)));
        (0, $6rvcc.default)(this, "setItem", (key, value)=>{
            try {
                this._store.setItem(this.createKey(key), value);
            } catch (err) {
                // Theoretically should only be QuotaExceededError, but keeping 'err' generic
                // https://developer.mozilla.org/en-US/docs/Web/API/Storage/setItem
                this.swapToInMemory();
                this._store.setItem(this.createKey(key), value);
            }
        });
        (0, $6rvcc.default)(this, "swapToInMemory", ()=>{
            if (this._store === (0, $eXTjr.default) || typeof globalThis === 'undefined') return;
            const keys = Object.keys(this._store || {});
            let inMemoryStorage;
            if ((0, $kxxHr.isSupported)(globalThis[$3cf59f0615ba9877$export$770aa8bc07b3de03])) inMemoryStorage = globalThis[$3cf59f0615ba9877$export$770aa8bc07b3de03];
            else {
                inMemoryStorage = (0, $eXTjr.default);
                if (!globalThis[$3cf59f0615ba9877$export$770aa8bc07b3de03]) // If not already attached to globalThis then attach our instance of InMemoryStorage
                // We need to do this because if there are multiple instances of Analytics Client in multiple scopes,
                // there is no way to guarantee the throttling behaviour of the UI viewed event across those instances without a global singleton
                globalThis[$3cf59f0615ba9877$export$770aa8bc07b3de03] = (0, $eXTjr.default);
            }
            keys.forEach((key)=>{
                if (key.indexOf(this.getPrefix()) === 0) {
                    const value = this._store.getItem(key);
                    if (value) inMemoryStorage.setItem(key, value);
                }
            });
            this._store = inMemoryStorage;
        });
        (0, $6rvcc.default)(this, "clear", ()=>this._store.clear());
        (0, $6rvcc.default)(this, "key", (index)=>this._store.key(index));
        (0, $6rvcc.default)(this, "getPrefix", ()=>this._prefix);
        (0, $6rvcc.default)(this, "createKey", (key)=>{
            if (this._prefix) return `${this.getPrefix()}.${key}`;
            return key;
        });
        this.options = options;
        const prefixes = [];
        if (options.useStoragePrefix === undefined || options.useStoragePrefix) prefixes.push($3cf59f0615ba9877$export$41c06fdd37b7e9a5);
        if (options.envPrefix && options.envPrefix !== (0, $dpXUu.envType).PROD) prefixes.push(options.envPrefix);
        this._prefix = prefixes.join('-');
        if ((0, $kxxHr.isSupported)(storageToUse)) this._store = storageToUse;
        else this.swapToInMemory();
    }
}

});
parcelRegister("kxxHr", function(module, exports) {
$parcel$export(module.exports, "isSupported", () => $ef4107c8056f0789$export$48c17662a6902497);
/*
 * Code heavily influenced by Segment's Store https://github.com/segmentio/localstorage-retry/blob/master/lib/store.js
 * and Engine https://github.com/segmentio/localstorage-retry/blob/master/lib/engine.js
 * But is not used because it's not public API and is too restrictive in the way it sets keys and does JSON parsing and stringify
 */ // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
function $ef4107c8056f0789$export$48c17662a6902497(store) {
    const TEST_VALUE = 'test_value';
    if (!store) return false;
    try {
        const key = 'awc.storage.support';
        store.setItem(key, TEST_VALUE);
        const value = store.getItem(key);
        store.removeItem(key);
        // handle localStorage silently failing
        return value === TEST_VALUE;
    } catch (e) {
        // Can throw if localStorage is disabled
        return false;
    }
}

});




parcelRegister("k6Fyl", function(module, exports) {
$parcel$export(module.exports, "canUseCookie", () => $ea3499c14649495b$export$a9330601ee8f4d95);
$parcel$export(module.exports, "getTld", () => $ea3499c14649495b$export$de6821eed3d5f32d);

var $7frtV = parcelRequire("7frtV");

var $cvlyC = parcelRequire("cvlyC");

var $hel6R = parcelRequire("hel6R");
const $ea3499c14649495b$export$a9330601ee8f4d95 = (disableCookiePersistence = false)=>{
    if (disableCookiePersistence) return false;
    return !(location.protocol === 'file:' || location.protocol === 'chrome-extension:');
};
const $ea3499c14649495b$export$eb80e1beaa8dacf8 = (0, $hel6R.AllAnalyticsCookies).AWC_TLD_TEST.getKey();
const $ea3499c14649495b$export$19164982d36535d8 = 'tld_test';
const $ea3499c14649495b$export$de6821eed3d5f32d = (0, $cvlyC.default)(()=>{
    if (typeof location === 'undefined') return '';
    const { hostname: hostname } = location;
    const splitHostname = hostname.split('.');
    for(let i = 1; i <= splitHostname.length; i++){
        const domainParts = splitHostname.slice(i * -1);
        const domain = `.${domainParts.join('.')}`;
        (0, $7frtV.default).set($ea3499c14649495b$export$eb80e1beaa8dacf8, $ea3499c14649495b$export$19164982d36535d8, {
            domain: domain
        });
        if ((0, $7frtV.default).get($ea3499c14649495b$export$eb80e1beaa8dacf8) === $ea3499c14649495b$export$19164982d36535d8) {
            (0, $7frtV.default).remove($ea3499c14649495b$export$eb80e1beaa8dacf8, {
                domain: domain
            });
            return domain;
        }
    }
    return hostname;
});

});




parcelRegister("89ZKV", function(module, exports) {
$parcel$export(module.exports, "MetadataClient", () => $5f0f1169c182c3a3$export$1ac223ae496131c9);

var $6rvcc = parcelRequire("6rvcc");

var $gE0et = parcelRequire("gE0et");

var $2SiT1 = parcelRequire("2SiT1");

var $3zQGx = parcelRequire("3zQGx");

var $cx5q7 = parcelRequire("cx5q7");

var $3efd3 = parcelRequire("3efd3");

var $9GE8Y = parcelRequire("9GE8Y");

var $kqsXa = parcelRequire("kqsXa");

var $bJ6Ic = parcelRequire("bJ6Ic");

var $c8Y37 = parcelRequire("c8Y37");

var $3LjAy = parcelRequire("3LjAy");

var $4ra9w = parcelRequire("4ra9w");

var $5pjnf = parcelRequire("5pjnf");
var $5f0f1169c182c3a3$var$_MetadataClient;
function $5f0f1169c182c3a3$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $5f0f1169c182c3a3$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $5f0f1169c182c3a3$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $6rvcc.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $5f0f1169c182c3a3$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
class $5f0f1169c182c3a3$export$1ac223ae496131c9 {
    constructor(apiHostProtocol, apiHost, product){
        this._userInfo = {
            anonymousId: ''
        };
        this._tenantInfo = {};
        this._url = `${apiHostProtocol}://${apiHost}/metadata`;
        this._product = product;
        this._metadataInfo = null;
        this._requestStatus = 'PENDING';
        this._lastFetchRequestCount = 0;
        this._lastErrorReason = null;
        this._fetchAbortController = null;
        this._hasBeenStopped = false;
        this._isEnabled = false;
        this._propertyChangeRefreshTimeout = null;
        const isStargateProxy = (0, $gE0et.isStargateProxyPath)({
            apiHost: apiHost
        });
        this._metadataHost = isStargateProxy ? 'PRODUCT_HOST' : apiHost;
        this._options = this.buildOptions({
            backoffFactor: 2,
            backoffJitterPercentage: 0.8,
            flushBeforeUnload: false,
            flushWaitMs: 500,
            maxAttempts: 10,
            minRetryDelay: (0, $bJ6Ic.DEFAULT_METADATA_MIN_RETRY_DELAY),
            maxRetryDelay: (0, $bJ6Ic.DEFAULT_METADATA_MAX_RETRY_DELAY)
        });
        this._scheduler = new (0, $cx5q7.default)($5f0f1169c182c3a3$var$_objectSpread($5f0f1169c182c3a3$var$_objectSpread({}, this._options), {}, {
            waitInterval: (0, $bJ6Ic.DEFAULT_METADATA_REFRESH_INTERVAL)
        }), this.scheduleCallback.bind(this));
        this._networkStatus = null;
    }
    /**
   * Starts the metadata client. This will start the scheduler and begin
   * fetching metadata.
   *
   * @param allowRestart - If false, the client will not be restarted if it has already been stopped
   *						 by a call to stop().
   */ start(allowRestart) {
        if (this._isEnabled || this._hasBeenStopped && !allowRestart) return;
        this._isEnabled = true;
        this.startNetworkStatusMonitor();
        setTimeout(()=>{
            this._scheduler.schedule({
                immediate: true
            });
        }, $5f0f1169c182c3a3$export$1ac223ae496131c9.INITIAL_REFRESH_DELAY);
    }
    stop() {
        var _this$_fetchAbortCont;
        if (!this._isEnabled) return;
        this._hasBeenStopped = true;
        this._isEnabled = false;
        this.stopNetworkStatusMonitor();
        this._scheduler.stop();
        (_this$_fetchAbortCont = this._fetchAbortController) === null || _this$_fetchAbortCont === void 0 || _this$_fetchAbortCont.abort();
        this.resetPropertyChangeRefresh();
    }
    startNetworkStatusMonitor() {
        if (this._networkStatus) return;
        this._networkStatus = new (0, $2SiT1.default)((status)=>{
            if (status === (0, $9GE8Y.NetworkStatusEnum).OFFLINE) this._scheduler.stop();
            else if (this._isEnabled) this._scheduler.schedule({
                immediate: this._metadataInfo === null
            });
        });
    }
    stopNetworkStatusMonitor() {
        if (this._networkStatus) {
            this._networkStatus.removeListeners();
            this._networkStatus = null;
        }
    }
    async refreshMetadataAsync() {
        var _this$_fetchAbortCont2;
        if ((0, $kqsXa.TestSupport).areFetchCallsDisabled() || !this._isEnabled) return Promise.resolve();
        (_this$_fetchAbortCont2 = this._fetchAbortController) === null || _this$_fetchAbortCont2 === void 0 || _this$_fetchAbortCont2.abort();
        this._fetchAbortController = new AbortController();
        const fetchAbortSignal = this._fetchAbortController.signal;
        this._lastFetchRequestCount = this._scheduler.getFailureCount();
        await (0, $3LjAy.fetchMetadata)(this._url, {
            product: this._product,
            userInfo: this._userInfo,
            tenantInfo: this._tenantInfo
        }, (0, $bJ6Ic.DEFAULT_METADATA_REQUEST_TIMEOUT), fetchAbortSignal).then(async (response)=>{
            const metadata = await response.json();
            this._metadataInfo = (0, $4ra9w.MetadataResponse).fromJson(metadata);
            this._lastFetchRequestCount++;
            this._requestStatus = 'FETCHED';
            this._lastErrorReason = null;
        }).catch((error)=>{
            if (fetchAbortSignal.aborted) // This request was aborted, so we don't need to handle it.
            return;
            this._requestStatus = 'FAILED';
            if (error instanceof (0, $c8Y37.FetchError) && [
                429,
                503
            ].includes(error.statusCode)) this._lastErrorReason = 'ServerBusyError';
            else this._lastErrorReason = error instanceof Error && (0, $5pjnf.ALLOW_LISTED_FETCH_ERROR_NAMES).includes(error.name) ? error.name : 'Unknown';
            throw error;
        });
    }
    getMetadataAsync() {
        return Promise.resolve(this._metadataInfo);
    }
    get status() {
        return this._requestStatus;
    }
    get lastErrorReason() {
        return this._lastErrorReason;
    }
    get lastFetchRequestCount() {
        return this._lastFetchRequestCount;
    }
    get userInfo() {
        return this._userInfo;
    }
    set userInfo(userInfo) {
        var _this$_userInfo, _this$_userInfo2;
        if (((_this$_userInfo = this._userInfo) === null || _this$_userInfo === void 0 ? void 0 : _this$_userInfo.userId) === (userInfo === null || userInfo === void 0 ? void 0 : userInfo.userId) && ((_this$_userInfo2 = this._userInfo) === null || _this$_userInfo2 === void 0 ? void 0 : _this$_userInfo2.userIdType) === (userInfo === null || userInfo === void 0 ? void 0 : userInfo.userIdType)) return;
        this._userInfo = userInfo;
        this.schedulePropertyChangeRefresh();
    }
    get tenantInfo() {
        return this._tenantInfo;
    }
    set tenantInfo(tenantInfo) {
        var _this$_tenantInfo, _this$_tenantInfo2;
        if (((_this$_tenantInfo = this._tenantInfo) === null || _this$_tenantInfo === void 0 ? void 0 : _this$_tenantInfo.tenantId) === (tenantInfo === null || tenantInfo === void 0 ? void 0 : tenantInfo.tenantId) && ((_this$_tenantInfo2 = this._tenantInfo) === null || _this$_tenantInfo2 === void 0 ? void 0 : _this$_tenantInfo2.tenantIdType) === (tenantInfo === null || tenantInfo === void 0 ? void 0 : tenantInfo.tenantIdType)) return;
        this._tenantInfo = tenantInfo;
        this.schedulePropertyChangeRefresh();
    }
    get metrics() {
        return {
            host: this._metadataHost,
            status: this.status,
            lastErrorReason: this.lastErrorReason,
            lastRefreshRequestCount: this.lastFetchRequestCount
        };
    }
    async scheduleCallback(done) {
        var _this$_networkStatus;
        if (((_this$_networkStatus = this._networkStatus) === null || _this$_networkStatus === void 0 ? void 0 : _this$_networkStatus.getNetworkStatus()) === (0, $9GE8Y.NetworkStatusEnum).OFFLINE) {
            done((0, $3efd3.DoneState).NOOP);
            return;
        }
        try {
            await this.refreshMetadataAsync();
            done((0, $3efd3.DoneState).SUCCESS);
            this._scheduler.schedule();
        } catch (_unused) {
            done((0, $3efd3.DoneState).ERROR);
        }
    }
    /**
   * Schedules a refresh of the metadata when the user or tenant info changes. There is
   * a short delay to allow for multiple changes to be batched together, such as when the
   * callers sets the user info and tenant info in quick succession.
   */ schedulePropertyChangeRefresh() {
        if (!this._isEnabled) return;
        this.resetPropertyChangeRefresh();
        this._propertyChangeRefreshTimeout = setTimeout(()=>{
            this.resetPropertyChangeRefresh();
            this._scheduler.schedule({
                immediate: true
            });
        }, (0, $bJ6Ic.DEFAULT_METADATA_PROPERTY_CHANGE_REFRESH_INTERVAL));
    }
    resetPropertyChangeRefresh() {
        if (this._propertyChangeRefreshTimeout) {
            clearTimeout(this._propertyChangeRefreshTimeout);
            this._propertyChangeRefreshTimeout = null;
        }
    }
    buildOptions(options) {
        return {
            backoffFactor: (options === null || options === void 0 ? void 0 : options.backoffFactor) || (0, $3zQGx.DEFAULT_POLLING_OPTIONS).backoffFactor,
            backoffJitterPercentage: (options === null || options === void 0 ? void 0 : options.backoffJitterPercentage) !== undefined ? options.backoffJitterPercentage : (0, $3zQGx.DEFAULT_POLLING_OPTIONS).backoffJitterPercentage,
            maxRetryDelay: (options === null || options === void 0 ? void 0 : options.maxRetryDelay) || (0, $3zQGx.DEFAULT_POLLING_OPTIONS).maxRetryDelay,
            minRetryDelay: (options === null || options === void 0 ? void 0 : options.minRetryDelay) || (0, $3zQGx.DEFAULT_POLLING_OPTIONS).minRetryDelay
        };
    }
}
$5f0f1169c182c3a3$var$_MetadataClient = $5f0f1169c182c3a3$export$1ac223ae496131c9;
(0, $6rvcc.default)($5f0f1169c182c3a3$export$1ac223ae496131c9, "INITIAL_REFRESH_DELAY", 1);
(0, $6rvcc.default)($5f0f1169c182c3a3$export$1ac223ae496131c9, "Factory", (apiHostProtocol, apiHost, product)=>{
    return new $5f0f1169c182c3a3$var$_MetadataClient(apiHostProtocol, apiHost, product);
});

});
parcelRegister("gE0et", function(module, exports) {
$parcel$export(module.exports, "isStargateProxyPath", () => $c1e08fe93559206d$export$83a9dd8d74be72c);

var $ls3Em = parcelRequire("ls3Em");
function $c1e08fe93559206d$export$83a9dd8d74be72c({ apiHost: apiHost }) {
    return apiHost === (0, $ls3Em.stargateProxyUrl)();
}

});
parcelRegister("ls3Em", function(module, exports) {
$parcel$export(module.exports, "stargateProxyUrl", () => $f9df0b541c3a14c4$export$78e02cfb66671ad0);
$parcel$export(module.exports, "selectHost", () => $f9df0b541c3a14c4$export$18c0b81944902eae);

var $dpXUu = parcelRequire("dpXUu");

const $f9df0b541c3a14c4$var$PROD_HOST = 'as.atlassian.com/api/v1';
const $f9df0b541c3a14c4$var$STARGATE_PROD_HOST = 'api-private.atlassian.com/gasv3/api/v1';
const $f9df0b541c3a14c4$var$STAGING_HOST = 'as.staging.atl-paas.net/api/v1';
const $f9df0b541c3a14c4$var$STARGATE_STAGING_HOST = 'api-private.stg.atlassian.com/gasv3/api/v1';
const $f9df0b541c3a14c4$var$FEDRAMP_STAGING_HOST = 'as.staging.atl-paas-us-gov-mod.net/api/v1';
const $f9df0b541c3a14c4$var$FEDRAMP_PROD_HOST = 'as.atlassian-us-gov-mod.com/api/v1';
const $f9df0b541c3a14c4$var$STARGATE_FEDRAMP_STAGING_HOST = 'api.stg.atlassian-us-gov-mod.com/gasv3/api/v1';
const $f9df0b541c3a14c4$var$STARGATE_FEDRAMP_PROD_HOST = 'api.atlassian-us-gov-mod.com/gasv3/api/v1';
const $f9df0b541c3a14c4$export$5df9262e102d0c32 = '/gateway/api/gasv3/api/v1';
/**
* Returns the full Stargate proxy URL (host + proxy path) for the current host.
*
* This is the default endpoint for Commercial, FedRAMP Moderate (with Stargate),
* and Oasis IC environments. Using the first-party proxy works around browser
* restrictions with third-party cookies.
*
* In non-browser environments (e.g. SSR) where `window` is not defined, the host
* portion is omitted and the function returns only `STARGATE_PROXY_PATH`
* (i.e. `/gateway/api/gasv3/api/v1`).
*/ function $f9df0b541c3a14c4$export$78e02cfb66671ad0() {
    return (typeof window !== 'undefined' ? window.location.host : '') + $f9df0b541c3a14c4$export$5df9262e102d0c32;
}
const $f9df0b541c3a14c4$var$handleFedRampModerate = ({ useStargate: useStargate, env: env, useLegacyUrl: useLegacyUrl, envOverride: envOverride })=>{
    if (env === (0, $dpXUu.envType).LOCAL || env === (0, $dpXUu.envType).DEV) throw Error('No LOCAL or DEV environments for FedRAMP.');
    if (env === (0, $dpXUu.envType).PROD && envOverride) throw Error('Cannot override to FedRAMP Sandbox for Prod.');
    if (!useStargate) return env === (0, $dpXUu.envType).PROD ? $f9df0b541c3a14c4$var$FEDRAMP_PROD_HOST : $f9df0b541c3a14c4$var$FEDRAMP_STAGING_HOST;
    if (useLegacyUrl) return env === (0, $dpXUu.envType).PROD ? $f9df0b541c3a14c4$var$STARGATE_FEDRAMP_PROD_HOST : $f9df0b541c3a14c4$var$STARGATE_FEDRAMP_STAGING_HOST;
    return $f9df0b541c3a14c4$export$78e02cfb66671ad0();
};
const $f9df0b541c3a14c4$var$handleCommercial = ({ useStargate: useStargate, env: env, useLegacyUrl: useLegacyUrl })=>{
    if (!useStargate) return env === (0, $dpXUu.envType).PROD ? $f9df0b541c3a14c4$var$PROD_HOST : $f9df0b541c3a14c4$var$STAGING_HOST;
    if (useLegacyUrl) return env === (0, $dpXUu.envType).PROD ? $f9df0b541c3a14c4$var$STARGATE_PROD_HOST : $f9df0b541c3a14c4$var$STARGATE_STAGING_HOST;
    return $f9df0b541c3a14c4$export$78e02cfb66671ad0();
};
function $f9df0b541c3a14c4$export$18c0b81944902eae({ useStargate: useStargate, env: env, useLegacyUrl: useLegacyUrl, perimeter: perimeter, ic: ic, envOverride: envOverride, apiHost: apiHost }) {
    // If the caller has explicitly set an apiHost, use it as the endpoint.
    if (apiHost) return apiHost;
    // When running inside an IC, events are routed through the Stargate proxy.
    if (ic) {
        if (useLegacyUrl) throw Error('IC is set but useLegacyUrl is true. Legacy URLs are not supported in IC environments.');
        return $f9df0b541c3a14c4$export$78e02cfb66671ad0();
    }
    if (perimeter === (0, $dpXUu.perimeterType).FEDRAMP_MODERATE) return $f9df0b541c3a14c4$var$handleFedRampModerate({
        useStargate: useStargate,
        env: env,
        useLegacyUrl: useLegacyUrl,
        envOverride: envOverride
    });
    return $f9df0b541c3a14c4$var$handleCommercial({
        useStargate: useStargate,
        env: env,
        useLegacyUrl: useLegacyUrl
    });
}

});


parcelRegister("kqsXa", function(module, exports) {
$parcel$export(module.exports, "TestSupport", () => $edecb1e04eb94083$export$44b578549c42d779);

var $6rvcc = parcelRequire("6rvcc");
class $edecb1e04eb94083$export$44b578549c42d779 {
    static isGeminiVREnvironment() {
        try {
            for(const k in globalThis){
                if (k.startsWith('__gemini_') && k.endsWith('__')) return true;
            }
        } catch (e) {
        // ignore
        }
        return false;
    }
    static areMetadataCallsDisabled() {
        return this.areFetchCallsDisabled() || this.getGlobalBooleanProperty($edecb1e04eb94083$export$44b578549c42d779.DISABLE_METADATA_CALLS_PROPERTY);
    }
    static areEventCallsDisabled() {
        return this.areFetchCallsDisabled() || this.getGlobalBooleanProperty($edecb1e04eb94083$export$44b578549c42d779.DISABLE_EVENT_CALLS_PROPERTY);
    }
    static areFetchCallsDisabled() {
        return this.getGlobalBooleanProperty($edecb1e04eb94083$export$44b578549c42d779.DISABLE_FETCH_CALLS_PROPERTY);
    }
    static getSyntheticFlagOverride() {
        return this.getGlobalTriStateProperty($edecb1e04eb94083$export$44b578549c42d779.SYNTHETIC_FLAG_OVERRIDE_PROPERTY);
    }
    static getGlobalBooleanProperty(propertyName) {
        if (globalThis && globalThis.hasOwnProperty(propertyName)) return globalThis[propertyName] === true;
        return false;
    }
    static getGlobalTriStateProperty(propertyName) {
        if (globalThis && globalThis.hasOwnProperty(propertyName)) {
            const value = globalThis[propertyName];
            if (typeof value === 'boolean') return value;
        }
        return undefined;
    }
}
(0, $6rvcc.default)($edecb1e04eb94083$export$44b578549c42d779, "DISABLE_METADATA_CALLS_PROPERTY", '__awc_disable_metadata_calls__');
(0, $6rvcc.default)($edecb1e04eb94083$export$44b578549c42d779, "DISABLE_EVENT_CALLS_PROPERTY", '__awc_disable_event_calls__');
(0, $6rvcc.default)($edecb1e04eb94083$export$44b578549c42d779, "DISABLE_FETCH_CALLS_PROPERTY", '__awc_disable_fetch_calls__');
(0, $6rvcc.default)($edecb1e04eb94083$export$44b578549c42d779, "SYNTHETIC_FLAG_OVERRIDE_PROPERTY", '__awc_synthetic_flag_override__');

});

parcelRegister("3LjAy", function(module, exports) {
$parcel$export(module.exports, "fetchMetadata", () => $2bd4f4c8b23cd51e$export$55b0d0261469055);

var $6rvcc = parcelRequire("6rvcc");

var $cvlyC = parcelRequire("cvlyC");

var $c8Y37 = parcelRequire("c8Y37");
function $2bd4f4c8b23cd51e$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $2bd4f4c8b23cd51e$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $2bd4f4c8b23cd51e$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $6rvcc.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $2bd4f4c8b23cd51e$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
const $2bd4f4c8b23cd51e$export$55b0d0261469055 = async (url, params, timeout, signal)=>{
    var _params$userInfo, _params$userInfo2, _params$tenantInfo, _params$tenantInfo2;
    const requestAbortController = $2bd4f4c8b23cd51e$var$createRequestAbortController(timeout, signal);
    const corsOptions = $2bd4f4c8b23cd51e$var$getCorsForUrl(url);
    const metadataUrl = url + '?' + new URLSearchParams({
        product: `${params.product}`,
        userId: `${((_params$userInfo = params.userInfo) === null || _params$userInfo === void 0 ? void 0 : _params$userInfo.userId) || ''}`,
        userIdType: `${((_params$userInfo2 = params.userInfo) === null || _params$userInfo2 === void 0 ? void 0 : _params$userInfo2.userIdType) || ''}`,
        tenantId: `${((_params$tenantInfo = params.tenantInfo) === null || _params$tenantInfo === void 0 ? void 0 : _params$tenantInfo.tenantId) || ''}`,
        tenantIdType: `${((_params$tenantInfo2 = params.tenantInfo) === null || _params$tenantInfo2 === void 0 ? void 0 : _params$tenantInfo2.tenantIdType) || ''}`
    }).toString();
    const response = await fetch(metadataUrl, $2bd4f4c8b23cd51e$var$_objectSpread({
        method: 'GET',
        signal: requestAbortController.signal
    }, corsOptions));
    // Response must be a 200 (we expect a JSON response, so 204 is not valid for instance)
    if (response.status !== 200) throw new (0, $c8Y37.FetchError)(`Metadata: HTTP Error ${response.status} (${response.statusText})`, response.status, response.statusText);
    return response;
};
const $2bd4f4c8b23cd51e$var$createRequestAbortController = (timeout, signal)=>{
    const abortController = new AbortController();
    setTimeout(()=>{
        abortController.abort();
    }, timeout || 30000);
    signal === null || signal === void 0 || signal.addEventListener('abort', ()=>{
        abortController.abort();
    });
    return abortController;
};
// To ensure we always have cookies, we should check if the origins match.
// If they dont, we need to set mode to `cors` and credentials to `include`.
const $2bd4f4c8b23cd51e$var$getCorsForUrl = (0, $cvlyC.default)((url)=>{
    const origin = new URL(url).origin;
    if (origin === location.origin) return {};
    else return {
        mode: 'cors',
        credentials: 'include'
    };
});

});

parcelRegister("4ra9w", function(module, exports) {
$parcel$export(module.exports, "MetadataResponse", () => $33b18f215ea84257$export$4b1a5e5486cc0d80);
// eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
class $33b18f215ea84257$export$4b1a5e5486cc0d80 {
    constructor(props, url){
        this.props = props;
        this.url = url;
    }
    static fromJson(json) {
        let isString = (value)=>typeof value === 'string' || value instanceof String;
        const url = isString(json === null || json === void 0 ? void 0 : json.url) ? json.url.trim() : '';
        return new $33b18f215ea84257$export$4b1a5e5486cc0d80((json === null || json === void 0 ? void 0 : json.props) || null, url.startsWith('http') ? url : null);
    }
}

});


parcelRegister("lsX7U", function(module, exports) {
$parcel$export(module.exports, "isFirstParty", () => $fa0a13d0aa14ff8d$export$f56713ced121eb91);

var $dpXUu = parcelRequire("dpXUu");
const $fa0a13d0aa14ff8d$export$f56713ced121eb91 = (input)=>{
    return input.embeddedType === (0, $dpXUu.productEmbedType).FIRST_PARTY && input.embeddedFromProduct !== undefined;
};

});

parcelRegister("5kUYv", function(module, exports) {
$parcel$export(module.exports, "isThirdParty", () => $3e2b040d881a7205$export$ab34f90cc32c8960);

var $dpXUu = parcelRequire("dpXUu");
const $3e2b040d881a7205$export$ab34f90cc32c8960 = (input)=>{
    return input.embeddedType === (0, $dpXUu.productEmbedType).THIRD_PARTY && input.embeddedFromTopLevelDomain !== undefined;
};

});

parcelRegister("dyX62", function(module, exports) {
$parcel$export(module.exports, "LoggingResponseCallback", () => $9dfc4aa78eb337fc$export$48361b6ed38f1b0);
class $9dfc4aa78eb337fc$export$48361b6ed38f1b0 {
    static getCallback(logger) {
        logger = logger || console;
        return (response)=>{
            $9dfc4aa78eb337fc$export$48361b6ed38f1b0.callback(response, logger);
        };
    }
    static callback(response, logger) {
        const statusCode = response.getStatusCode();
        if (statusCode >= 200 && statusCode <= 299) response.getEventResponseList().forEach((eventResponse)=>{
            logger.warn('Validation report for event with message ID %s:\n', eventResponse.getMessageId(), eventResponse);
        });
        else if (statusCode === 400 || statusCode === 404) {
            logger.warn('GASv3 submission failed with HTTP Status Code %d: %s', response.getStatusCode(), response.getMessage());
            response.getEventResponseList().forEach((eventResponse)=>{
                logger.warn('Event with message ID %s:\n', eventResponse.getMessageId(), eventResponse);
            });
        } else {
            logger.log('GASv3 submission failed with HTTP Status Code %d: %s', response.getStatusCode(), response.getMessage());
            response.eventResponseList.forEach((eventResponse)=>{
                logger.debug('Event with message ID %s:\n', eventResponse.getMessageId(), eventResponse);
            });
        }
    }
}

});

parcelRegister("eS4G8", function(module, exports) {
$parcel$export(module.exports, "objectValues", () => $ad39bce6d9283b30$export$ad1854f4a08c15f8);
function $ad39bce6d9283b30$export$ad1854f4a08c15f8(object) {
    return Object.values(object);
}

});

parcelRegister("h5UBC", function(module, exports) {
$parcel$export(module.exports, "default", () => $c71ed008013c1ce7$export$2e2bcd8739ae039);

var $6rvcc = parcelRequire("6rvcc");

var $dpXUu = parcelRequire("dpXUu");

var $2UUeH = parcelRequire("2UUeH");
class $c71ed008013c1ce7$export$2e2bcd8739ae039 {
    constructor(){
        (0, $6rvcc.default)(this, "pendingCleanup", null);
        (0, $6rvcc.default)(this, "handleOriginParameters", (originParamHandlerMapping, historyReplaceFn)=>{
            // Collect all the parameter labels to be handled
            const originParamLabelList = Object.keys(originParamHandlerMapping);
            if (!(originParamLabelList.length > 0)) throw new Error('Empty parameter mapping provided');
            // Check if the parameter labels are valid. If any invalid labels are found throw an exception.
            const invalidParams = originParamLabelList.filter((x)=>Object.values((0, $dpXUu.originTracingType)).indexOf(x) < 0);
            if (invalidParams.length > 0) throw new Error(`Invalid Origin Tracing Parameter(s) supplied: ${invalidParams.join()}!`);
            const isCaptureParam = (_, key)=>originParamLabelList.indexOf(key) >= 0;
            // Capture params WITHOUT removing from URL (explicit no-op required because
            // urlParamExtractor defaults to calling history.replaceState if omitted)
            const paramExtractorReplace = ()=>{};
            const capturedURLParams = (0, $2UUeH.default)(isCaptureParam, paramExtractorReplace);
            // Apply provided handler function to extract origin trace ID from each URL parameter
            const applyHandlerFunction = (key)=>{
                const x = originParamHandlerMapping[key](capturedURLParams[key]);
                return {
                    [key]: x
                };
            };
            const capturedOriginTraces = Object.keys(capturedURLParams).map(applyHandlerFunction).reduce((accumulator, currentValue)=>Object.assign(accumulator, currentValue), {});
            if (Object.keys(capturedOriginTraces).length > 0) this.pendingCleanup = ()=>{
                (0, $2UUeH.default)(isCaptureParam, historyReplaceFn);
            };
            return capturedOriginTraces;
        });
        this._originStore = {};
    }
    /** Executes and clears any pending origin param cleanup. No-op if nothing is pending. */ _cleanupOriginParams() {
        if (this.pendingCleanup) {
            const cleanup = this.pendingCleanup;
            this.pendingCleanup = null;
            cleanup();
        }
    }
    /**
   * Designed to be invoked after a successful flush with the batch of flushed events.
   */ cleanupOriginParameters(events) {
        try {
            if (this.pendingCleanup) {
                const hasOriginLanded = events.some((item)=>'event' in item.msg && item.msg.event === $c71ed008013c1ce7$export$2e2bcd8739ae039.messageEvent);
                if (hasOriginLanded) this._cleanupOriginParams();
            }
        } catch (_unused) {
        // Silently ignore cleanup errors to avoid disrupting the flush cycle
        }
    }
}
(0, $6rvcc.default)($c71ed008013c1ce7$export$2e2bcd8739ae039, "messageEvent", 'origin landed');

});

parcelRegister("5P1Jy", function(module, exports) {
$parcel$export(module.exports, "default", () => $43d30f76663fb1b4$export$2e2bcd8739ae039);

var $6rvcc = parcelRequire("6rvcc");

var $kkWUi = parcelRequire("kkWUi");

var $7Nwkx = parcelRequire("7Nwkx");

var $jc2hJ = parcelRequire("jc2hJ");
// WARNING: The value of SESSION_ID_STORAGE_KEY is relied upon by other Platform packages
// (eg. search-page, product-search-dialog). If you need to change this key, you MUST
// notify the dependant Platform teams and update all dependent packages accordingly.
const $43d30f76663fb1b4$var$SESSION_ID_STORAGE_KEY = 'session.id';
const $43d30f76663fb1b4$var$SESSION_EXPIRY_STORAGE_KEY = 'session.expiry';
const $43d30f76663fb1b4$var$ONLY_NUMBERS_REGEX = /^\d+$/;
const $43d30f76663fb1b4$export$285f6bddd927a06d = 1800000;
const $43d30f76663fb1b4$export$a92e915d70316eb2 = 5000;
const $43d30f76663fb1b4$export$de43760b2dc10c19 = 0.9;
class $43d30f76663fb1b4$export$2e2bcd8739ae039 {
    constructor(options = {}){
        (0, $6rvcc.default)(this, "_generateNewSessionId", ()=>{
            const newSessionId = Date.now().toString();
            this._safeLocalStorage.setItem($43d30f76663fb1b4$var$SESSION_ID_STORAGE_KEY, newSessionId);
            if ((0, $kkWUi.fg)('awc_session_id_early_exit')) {
                // If session is not valid at this point, something has gone wrong with Local Storage access
                // Calling the callback may result in possible recursion errors (see HOT-304742). Feature
                // gating roll-out of this early exit condition
                const { isValidSession: isValidSession } = this._getCurrentSessionParams();
                if (!isValidSession) return '';
            }
            // COMMENTS-123 - When a new session starts, call the callback if it is given
            this._onNewSessionStarted && this._onNewSessionStarted();
            return newSessionId;
        });
        (0, $6rvcc.default)(this, "_updateSessionExpiry", ()=>{
            const expiry = Date.now() + this._sessionExpiryTime;
            this._safeLocalStorage.setItem($43d30f76663fb1b4$var$SESSION_EXPIRY_STORAGE_KEY, expiry.toString());
            return expiry;
        });
        (0, $6rvcc.default)(this, "_debouncedUpdateSessionExpiry", (currentExpiry)=>{
            const { _updateSessionExpiry: _updateSessionExpiry } = this;
            // If the current expiry is out of date by more than 10% of the expiry, update immediately
            if (currentExpiry < Date.now() + this._sessionExpiryDebounceThresholdPercentage * this._sessionExpiryTime) _updateSessionExpiry();
            else {
                if (this._sessionExpiryDebounceTimer) clearTimeout(this._sessionExpiryDebounceTimer);
                // @ts-ignore Something wrong with our types... this is legit
                this._sessionExpiryDebounceTimer = setTimeout(()=>{
                    _updateSessionExpiry();
                }, this._sessionExpiryDebounce);
            }
        });
        this._sessionExpiryTime = options.sessionExpiryTime || $43d30f76663fb1b4$export$285f6bddd927a06d;
        this._sessionExpiryDebounce = options.sessionExpiryDebounce || $43d30f76663fb1b4$export$a92e915d70316eb2;
        this._sessionExpiryDebounceThresholdPercentage = options.sessionExpiryDebounceThresholdPercentage || $43d30f76663fb1b4$export$de43760b2dc10c19;
        this._onNewSessionStarted = options.onNewSessionStarted ? options.onNewSessionStarted : (0, $7Nwkx.NOOP);
        this._safeLocalStorage = new (0, $jc2hJ.default)();
    }
    /*
   * This function retrieves the current session ID and expiry from SessionStorage
   * It runs the necessary checks to ensure the session ID is valid and within expiry
   *
   * It returns the values along with a `validSession` boolean
   */ _getCurrentSessionParams() {
        const sessionId = this._safeLocalStorage.getItem($43d30f76663fb1b4$var$SESSION_ID_STORAGE_KEY);
        const sessionExpiry = parseInt(this._safeLocalStorage.getItem($43d30f76663fb1b4$var$SESSION_EXPIRY_STORAGE_KEY) || '0', 10) || 0;
        // REGEX test: Old versions of sessionId were UUIDs which caused issues for Amplitude which only accepts
        // integers for this field. In these scenarios we want to regenerate the sessionId as an integer
        if (sessionId && !Number.isNaN(sessionExpiry) && $43d30f76663fb1b4$var$ONLY_NUMBERS_REGEX.test(sessionId) && sessionExpiry > Date.now()) return {
            isValidSession: true,
            sessionExpiry: sessionExpiry,
            sessionId: sessionId
        };
        return {
            isValidSession: false,
            sessionExpiry: sessionExpiry,
            sessionId: sessionId
        };
    }
    /*
   * Session ID SHOULD always be a timestamp, however due to new Browser Storage Controls key classifications, it is
   * technically possible that writing Session ID to local storage is intercepted by BSC, in which case we can potentially
   * read a null value from storage, in which case we will return empty String
   */ getCurrentSessionId() {
        const { isValidSession: isValidSession, sessionExpiry: sessionExpiry, sessionId: sessionId } = this._getCurrentSessionParams();
        this._debouncedUpdateSessionExpiry(sessionExpiry);
        // If we have an existing valid session we can return the sessionId straight away
        if (isValidSession) return sessionId;
        else return this._generateNewSessionId();
    }
}

});
parcelRegister("kkWUi", function(module, exports) {
$parcel$export(module.exports, "fg", () => $ece35e9ec035cb1d$export$b40ec24ac8275656);

var $7z5bG = parcelRequire("7z5bG");
function $ece35e9ec035cb1d$export$b40ec24ac8275656(name) {
    return (0, $7z5bG.resolveBooleanFlag)(name);
}

});
parcelRegister("7z5bG", function(module, exports) {
$parcel$export(module.exports, "resolveBooleanFlag", () => $581fd364ddbf244d$export$6333b6aff9fc6275);

var $iQSpK = parcelRequire("iQSpK");

var $bzNvu = parcelRequire("bzNvu");

var $1gj4Y = parcelRequire("1gj4Y");

var $cThjD = parcelRequire("cThjD");

var $9oJez = parcelRequire("9oJez");

var $7a4c1 = parcelRequire("7a4c1");
var $581fd364ddbf244d$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE = (0, $1gj4Y.ENV_ENABLE_PLATFORM_FF) || (0, $cThjD.ENV_STORYBOOK_ENABLE_PLATFORM_FF);
function $581fd364ddbf244d$export$6333b6aff9fc6275(flagKey) {
    if ($581fd364ddbf244d$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE) {
        (0, $bzNvu.debug)('[%s]: The feature flags were enabled while running tests. The flag "%s" will be always enabled.', (0, $7a4c1.pkgName), flagKey);
        return true;
    }
    try {
        var _globalVar$PFF_GLOBAL, _globalVar$PFF_GLOBAL2, _globalVar$PFF_GLOBAL3;
        // booleanResolver will be empty for products like Trello, Elevate, Recruit etc.
        // Currently only Confluence, Jira and Bitbucket has set it.
        if (((_globalVar$PFF_GLOBAL = (0, $9oJez.globalVar)[0, $7a4c1.PFF_GLOBAL_KEY]) === null || _globalVar$PFF_GLOBAL === void 0 ? void 0 : _globalVar$PFF_GLOBAL.booleanResolver) === undefined || ((_globalVar$PFF_GLOBAL2 = (0, $9oJez.globalVar)[0, $7a4c1.PFF_GLOBAL_KEY]) === null || _globalVar$PFF_GLOBAL2 === void 0 ? void 0 : _globalVar$PFF_GLOBAL2.booleanResolver) === null) // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
        return (0, $iQSpK.default).checkGate(flagKey);
        var result = (_globalVar$PFF_GLOBAL3 = (0, $9oJez.globalVar)[0, $7a4c1.PFF_GLOBAL_KEY]) === null || _globalVar$PFF_GLOBAL3 === void 0 ? void 0 : _globalVar$PFF_GLOBAL3.booleanResolver(flagKey);
        if (typeof result !== 'boolean') {
            // eslint-disable-next-line no-console
            console.warn("".concat(flagKey, " resolved to a non-boolean value, returning false for safety"));
            return false;
        }
        return result;
    } catch (e) {
        return false;
    }
}

});
parcelRegister("iQSpK", function(module, exports) {
$parcel$export(module.exports, "default", () => $db974addfd277930$export$2e2bcd8739ae039);

var $ja5yh = parcelRequire("ja5yh");

var $4gOTZ = parcelRequire("4gOTZ");

var $6rvcc = parcelRequire("6rvcc");

var $1MqIG = parcelRequire("1MqIG");

var $l7Wmf = parcelRequire("l7Wmf");



var $db974addfd277930$var$_FeatureGates;
/**
 * Access the FeatureGates object via the default export.
 * ```ts
 * import FeatureGates from '@atlaskit/feature-gate-js-client';
 * ```
 */ var $db974addfd277930$var$FeatureGates = /*#__PURE__*/ function() {
    function FeatureGates() {
        (0, $ja5yh.default)(this, FeatureGates);
    }
    return (0, $4gOTZ.default)(FeatureGates, null, [
        {
            key: "isGateExists",
            value: function isGateExists(gateName) {
                return this.client.isGateExist(gateName);
            }
        },
        {
            key: "isExperimentExists",
            value: function isExperimentExists(experimentName) {
                return this.client.isExperimentExist(experimentName);
            }
        }
    ]);
}();
$db974addfd277930$var$_FeatureGates = $db974addfd277930$var$FeatureGates;
(0, $6rvcc.default)($db974addfd277930$var$FeatureGates, "client", new (0, $1MqIG.Client)());
(0, $6rvcc.default)($db974addfd277930$var$FeatureGates, "hasCheckGateErrorOccurred", false);
(0, $6rvcc.default)($db974addfd277930$var$FeatureGates, "hasGetExperimentValueErrorOccurred", false);
(0, $6rvcc.default)($db974addfd277930$var$FeatureGates, "checkGate", function(gateName, options) {
    try {
        // Check if the CRITERION override mechanism is available
        if (typeof window !== 'undefined' && window.__CRITERION__ && typeof window.__CRITERION__.getFeatureFlagOverride === 'function') {
            // Attempt to retrieve an override value for the feature gate
            var overrideValue = window.__CRITERION__.getFeatureFlagOverride(gateName);
            // If an override value is found, return it immediately
            if (overrideValue !== undefined) return overrideValue;
        }
    } catch (error) {
        // Log the first occurrence of the error
        if (!$db974addfd277930$var$_FeatureGates.hasCheckGateErrorOccurred) {
            // eslint-disable-next-line no-console
            console.warn({
                msg: 'An error has occurred checking the feature gate from criterion override. Only the first occurrence of this error is logged.',
                gateName: gateName,
                error: error
            });
            $db974addfd277930$var$_FeatureGates.hasCheckGateErrorOccurred = true;
        }
    }
    // Proceed with the main logic if no override is found
    return $db974addfd277930$var$_FeatureGates.client.checkGate(gateName, options);
});
(0, $6rvcc.default)($db974addfd277930$var$FeatureGates, "getExperimentValue", function(experimentName, parameterName, defaultValue, options) {
    try {
        // Check if the CRITERION override mechanism is available
        if (typeof window !== 'undefined' && window.__CRITERION__ && typeof window.__CRITERION__.getExperimentValueOverride === 'function') {
            var overrideValue = window.__CRITERION__.getExperimentValueOverride(experimentName, parameterName);
            if (overrideValue !== undefined && overrideValue !== null) return overrideValue;
        }
    } catch (error) {
        // Log the first occurrence of the error
        if (!$db974addfd277930$var$_FeatureGates.hasGetExperimentValueErrorOccurred) {
            // eslint-disable-next-line no-console
            console.warn({
                msg: 'An error has occurred getting the experiment value from criterion override. Only the first occurrence of this error is logged.',
                experimentName: experimentName,
                defaultValue: defaultValue,
                options: options,
                error: error
            });
            $db974addfd277930$var$_FeatureGates.hasGetExperimentValueErrorOccurred = true;
        }
        return defaultValue;
    }
    // Proceed with the main logic if no override is found
    return $db974addfd277930$var$_FeatureGates.client.getExperimentValue(experimentName, parameterName, defaultValue, options);
});
(0, $6rvcc.default)($db974addfd277930$var$FeatureGates, "initializeCalled", $db974addfd277930$var$_FeatureGates.client.initializeCalled.bind($db974addfd277930$var$_FeatureGates.client));
(0, $6rvcc.default)($db974addfd277930$var$FeatureGates, "initializeCompleted", $db974addfd277930$var$_FeatureGates.client.initializeCompleted.bind($db974addfd277930$var$_FeatureGates.client));
(0, $6rvcc.default)($db974addfd277930$var$FeatureGates, "waitUntilInitializeCompleted", $db974addfd277930$var$_FeatureGates.client.waitUntilInitializeCompleted.bind($db974addfd277930$var$_FeatureGates.client));
(0, $6rvcc.default)($db974addfd277930$var$FeatureGates, "initialize", $db974addfd277930$var$_FeatureGates.client.initialize.bind($db974addfd277930$var$_FeatureGates.client));
(0, $6rvcc.default)($db974addfd277930$var$FeatureGates, "initializeWithProvider", $db974addfd277930$var$_FeatureGates.client.initializeWithProvider.bind($db974addfd277930$var$_FeatureGates.client));
(0, $6rvcc.default)($db974addfd277930$var$FeatureGates, "initializeFromValues", $db974addfd277930$var$_FeatureGates.client.initializeFromValues.bind($db974addfd277930$var$_FeatureGates.client));
(0, $6rvcc.default)($db974addfd277930$var$FeatureGates, "manuallyLogGateExposure", $db974addfd277930$var$_FeatureGates.client.manuallyLogGateExposure.bind($db974addfd277930$var$_FeatureGates.client));
(0, $6rvcc.default)($db974addfd277930$var$FeatureGates, "getExperiment", $db974addfd277930$var$_FeatureGates.client.getExperiment.bind($db974addfd277930$var$_FeatureGates.client));
(0, $6rvcc.default)($db974addfd277930$var$FeatureGates, "manuallyLogExperimentExposure", $db974addfd277930$var$_FeatureGates.client.manuallyLogExperimentExposure.bind($db974addfd277930$var$_FeatureGates.client));
(0, $6rvcc.default)($db974addfd277930$var$FeatureGates, "manuallyLogLayerExposure", $db974addfd277930$var$_FeatureGates.client.manuallyLogLayerExposure.bind($db974addfd277930$var$_FeatureGates.client));
(0, $6rvcc.default)($db974addfd277930$var$FeatureGates, "shutdownStatsig", $db974addfd277930$var$_FeatureGates.client.shutdownStatsig.bind($db974addfd277930$var$_FeatureGates.client));
(0, $6rvcc.default)($db974addfd277930$var$FeatureGates, "overrideGate", $db974addfd277930$var$_FeatureGates.client.overrideGate.bind($db974addfd277930$var$_FeatureGates.client));
(0, $6rvcc.default)($db974addfd277930$var$FeatureGates, "clearGateOverride", $db974addfd277930$var$_FeatureGates.client.clearGateOverride.bind($db974addfd277930$var$_FeatureGates.client));
(0, $6rvcc.default)($db974addfd277930$var$FeatureGates, "overrideConfig", $db974addfd277930$var$_FeatureGates.client.overrideConfig.bind($db974addfd277930$var$_FeatureGates.client));
(0, $6rvcc.default)($db974addfd277930$var$FeatureGates, "clearConfigOverride", $db974addfd277930$var$_FeatureGates.client.clearConfigOverride.bind($db974addfd277930$var$_FeatureGates.client));
(0, $6rvcc.default)($db974addfd277930$var$FeatureGates, "setOverrides", $db974addfd277930$var$_FeatureGates.client.setOverrides.bind($db974addfd277930$var$_FeatureGates.client));
(0, $6rvcc.default)($db974addfd277930$var$FeatureGates, "getOverrides", $db974addfd277930$var$_FeatureGates.client.getOverrides.bind($db974addfd277930$var$_FeatureGates.client));
(0, $6rvcc.default)($db974addfd277930$var$FeatureGates, "clearAllOverrides", $db974addfd277930$var$_FeatureGates.client.clearAllOverrides.bind($db974addfd277930$var$_FeatureGates.client));
(0, $6rvcc.default)($db974addfd277930$var$FeatureGates, "isCurrentUser", $db974addfd277930$var$_FeatureGates.client.isCurrentUser.bind($db974addfd277930$var$_FeatureGates.client));
(0, $6rvcc.default)($db974addfd277930$var$FeatureGates, "onGateUpdated", $db974addfd277930$var$_FeatureGates.client.onGateUpdated.bind($db974addfd277930$var$_FeatureGates.client));
(0, $6rvcc.default)($db974addfd277930$var$FeatureGates, "onExperimentValueUpdated", $db974addfd277930$var$_FeatureGates.client.onExperimentValueUpdated.bind($db974addfd277930$var$_FeatureGates.client));
(0, $6rvcc.default)($db974addfd277930$var$FeatureGates, "onAnyUpdated", $db974addfd277930$var$_FeatureGates.client.onAnyUpdated.bind($db974addfd277930$var$_FeatureGates.client));
(0, $6rvcc.default)($db974addfd277930$var$FeatureGates, "updateUser", $db974addfd277930$var$_FeatureGates.client.updateUser.bind($db974addfd277930$var$_FeatureGates.client));
(0, $6rvcc.default)($db974addfd277930$var$FeatureGates, "updateUserWithProvider", $db974addfd277930$var$_FeatureGates.client.updateUserWithProvider.bind($db974addfd277930$var$_FeatureGates.client));
(0, $6rvcc.default)($db974addfd277930$var$FeatureGates, "updateUserWithValues", $db974addfd277930$var$_FeatureGates.client.updateUserWithValues.bind($db974addfd277930$var$_FeatureGates.client));
(0, $6rvcc.default)($db974addfd277930$var$FeatureGates, "getPackageVersion", $db974addfd277930$var$_FeatureGates.client.getPackageVersion.bind($db974addfd277930$var$_FeatureGates.client));
(0, $6rvcc.default)($db974addfd277930$var$FeatureGates, "getTargetApp", $db974addfd277930$var$_FeatureGates.client.getTargetApp.bind($db974addfd277930$var$_FeatureGates.client));
(0, $6rvcc.default)($db974addfd277930$var$FeatureGates, "getLayer", $db974addfd277930$var$_FeatureGates.client.getLayer.bind($db974addfd277930$var$_FeatureGates.client));
(0, $6rvcc.default)($db974addfd277930$var$FeatureGates, "getLayerValue", $db974addfd277930$var$_FeatureGates.client.getLayerValue.bind($db974addfd277930$var$_FeatureGates.client));
var $db974addfd277930$var$boundFGJS = $db974addfd277930$var$FeatureGates;
// This makes it possible to get a reference to the FeatureGates client at runtime.
// This is important for overriding values in Cypress tests, as there needs to be a
// way to get the exact instance for a window in order to mock some of its methods.
if (typeof window !== 'undefined') {
    if (window.__FEATUREGATES_JS__ === undefined) window.__FEATUREGATES_JS__ = $db974addfd277930$var$FeatureGates;
    else {
        var $db974addfd277930$var$_boundFGJS, $db974addfd277930$var$_boundFGJS$getPackage;
        $db974addfd277930$var$boundFGJS = window.__FEATUREGATES_JS__;
        var $db974addfd277930$var$boundVersion = (($db974addfd277930$var$_boundFGJS = $db974addfd277930$var$boundFGJS) === null || $db974addfd277930$var$_boundFGJS === void 0 || ($db974addfd277930$var$_boundFGJS$getPackage = $db974addfd277930$var$_boundFGJS.getPackageVersion) === null || $db974addfd277930$var$_boundFGJS$getPackage === void 0 ? void 0 : $db974addfd277930$var$_boundFGJS$getPackage.call($db974addfd277930$var$_boundFGJS)) || '4.10.0 or earlier';
        if ($db974addfd277930$var$boundVersion !== (0, $l7Wmf.CLIENT_VERSION)) {
            var $db974addfd277930$var$message = "Multiple versions of FeatureGateClients found on the current page.\n      The currently bound version is ".concat($db974addfd277930$var$boundVersion, " when module version ").concat((0, $l7Wmf.CLIENT_VERSION), " was loading.");
            // eslint-disable-next-line no-console
            console.warn($db974addfd277930$var$message);
        }
    }
}
var /**
 * @property {FeatureGates} FeatureGate default export
 */ $db974addfd277930$export$2e2bcd8739ae039 = $db974addfd277930$var$boundFGJS;

});
parcelRegister("ja5yh", function(module, exports) {
$parcel$export(module.exports, "default", () => $df334202439e3285$export$2e2bcd8739ae039);
function $df334202439e3285$export$2e2bcd8739ae039(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}

});

parcelRegister("4gOTZ", function(module, exports) {
$parcel$export(module.exports, "default", () => $31c024221b1475c1$export$2e2bcd8739ae039);

var $5Wodd = parcelRequire("5Wodd");
function $31c024221b1475c1$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, (0, $5Wodd.default)(o.key), o);
    }
}
function $31c024221b1475c1$export$2e2bcd8739ae039(e, r, t) {
    return r && $31c024221b1475c1$var$_defineProperties(e.prototype, r), t && $31c024221b1475c1$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}

});

parcelRegister("1MqIG", function(module, exports) {
$parcel$export(module.exports, "Client", () => $14bf0018cb51ec18$export$1f2bb630327ac4b6);

var $kEBxa = parcelRequire("kEBxa");

var $6mpGR = parcelRequire("6mpGR");

var $dLmLT = parcelRequire("dLmLT");

var $ja5yh = parcelRequire("ja5yh");

var $4gOTZ = parcelRequire("4gOTZ");

var $6rvcc = parcelRequire("6rvcc");

var $dL89k = parcelRequire("dL89k");

var $iFR7a = parcelRequire("iFR7a");

var $5giQQ = parcelRequire("5giQQ");

var $9qaud = parcelRequire("9qaud");

var $I2vtT = parcelRequire("I2vtT");

var $lTwRL = parcelRequire("lTwRL");

var $88RZX = parcelRequire("88RZX");

var $Obu4B = parcelRequire("Obu4B");

var $l8qYn = parcelRequire("l8qYn");

var $kXewy = parcelRequire("kXewy");

var $lhvkE = parcelRequire("lhvkE");

var $l7Wmf = parcelRequire("l7Wmf");
var $14bf0018cb51ec18$var$_excluded = [
    "sdkKey",
    "environment",
    "updateUserCompletionCallback",
    "perimeter"
];
function $14bf0018cb51ec18$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $14bf0018cb51ec18$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $14bf0018cb51ec18$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $6rvcc.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $14bf0018cb51ec18$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $14bf0018cb51ec18$var$DEFAULT_CLIENT_KEY = 'client-default-key';
// default event logging api is Atlassian proxy rather than Statsig's domain, to avoid ad blockers
var $14bf0018cb51ec18$var$DEFAULT_EVENT_LOGGING_API = 'https://xp.atlassian.com/v1/rgstr';
var $14bf0018cb51ec18$export$1f2bb630327ac4b6 = /*#__PURE__*/ function() {
    function Client() {
        var _this = this;
        var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, _ref$localStorageKey = _ref.localStorageKey, localStorageKey = _ref$localStorageKey === void 0 ? (0, $l8qYn.LOCAL_STORAGE_KEY) : _ref$localStorageKey, overrideAdapter = _ref.overrideAdapter;
        (0, $ja5yh.default)(this, Client);
        (0, $6rvcc.default)(this, "initPromise", null);
        /** True if an initialize method was called and completed successfully. */ (0, $6rvcc.default)(this, "initCompleted", false);
        /**
     * True if an initialize method was called and completed, meaning the client is now usable.
     * However if there was an error during initialization it may have initialized with default
     * values. Use {@link initCompleted} to check for this.
     */ (0, $6rvcc.default)(this, "initWithDefaults", false);
        (0, $6rvcc.default)(this, "hasCheckGateErrorOccurred", false);
        (0, $6rvcc.default)(this, "hasGetExperimentErrorOccurred", false);
        (0, $6rvcc.default)(this, "hasGetExperimentValueErrorOccurred", false);
        (0, $6rvcc.default)(this, "hasGetLayerErrorOccurred", false);
        (0, $6rvcc.default)(this, "hasGetLayerValueErrorOccurred", false);
        (0, $6rvcc.default)(this, "subscriptions", new (0, $5giQQ.default)());
        (0, $6rvcc.default)(this, "dataAdapter", new (0, $Obu4B.NoFetchDataAdapter)());
        /**
     * Call this if modifying the values being served by the Statsig library since it has its own
     * memoization cache which will not be updated if the values are changed outside of the library.
     */ (0, $6rvcc.default)(this, "statsigValuesUpdated", function() {
            if (_this.user) // Trigger a reset of the memoize cache
            _this.statsigClient.updateUserSync(_this.user, {
                disableBackgroundCacheRefresh: true
            });
            _this.subscriptions.anyUpdated();
        });
        this.overrideAdapter = overrideAdapter || new (0, $l8qYn.PersistentOverrideAdapter)(localStorageKey);
    }
    /**
   * @description
   * This method initializes the client using a network call to fetch the bootstrap values.
   * If the client is inialized with an `analyticsWebClient`, it will send an operational event
   * to GASv3 with the following attributes:
   * - targetApp: the target app of the client
   * - clientVersion: the version of the client
   * - success: whether the initialization was successful
   * - startTime: the time when the initialization started
   * - totalTime: the total time it took to initialize the client
   * - apiKey: the api key used to initialize the client
   * @param clientOptions {ClientOptions}
   * @param identifiers {Identifiers}
   * @param customAttributes {CustomAttributes}
   * @returns {Promise<void>}
   */ return (0, $4gOTZ.default)(Client, [
        {
            key: "initialize",
            value: function() {
                var _initialize = (0, $dLmLT.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dL89k))).mark(function _callee(clientOptions, identifiers, customAttributes) {
                    var _this2 = this;
                    var clientOptionsWithDefaults, startTime;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($dL89k))).wrap(function(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                clientOptionsWithDefaults = (0, $lhvkE.getOptionsWithDefaults)(clientOptions);
                                if (!this.initPromise) {
                                    _context.next = 1;
                                    break;
                                }
                                if (!(0, $lhvkE.shallowEquals)(clientOptionsWithDefaults, this.initOptions)) // eslint-disable-next-line no-console
                                console.warn('Feature Gates client already initialized with different options. New options were not applied.');
                                return _context.abrupt("return", this.initPromise);
                            case 1:
                                startTime = performance.now();
                                this.initOptions = clientOptionsWithDefaults;
                                this.initPromise = this.init(clientOptionsWithDefaults, identifiers, customAttributes).then(function() {
                                    _this2.initCompleted = true;
                                    _this2.initWithDefaults = true;
                                }).finally(function() {
                                    var endTime = performance.now();
                                    var totalTime = endTime - startTime;
                                    _this2.fireClientEvent(startTime, totalTime, 'initialize', _this2.initCompleted, clientOptionsWithDefaults.apiKey);
                                });
                                return _context.abrupt("return", this.initPromise);
                            case 2:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee, this);
                }));
                function initialize(_x, _x2, _x3) {
                    return _initialize.apply(this, arguments);
                }
                return initialize;
            }()
        },
        {
            key: "initializeWithProvider",
            value: function() {
                var _initializeWithProvider = (0, $dLmLT.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dL89k))).mark(function _callee2(clientOptions, provider, identifiers, customAttributes) {
                    var _this3 = this;
                    var clientOptionsWithDefaults, startTime;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($dL89k))).wrap(function(_context2) {
                        while(true)switch(_context2.prev = _context2.next){
                            case 0:
                                clientOptionsWithDefaults = (0, $lhvkE.getOptionsWithDefaults)(clientOptions);
                                if (!this.initPromise) {
                                    _context2.next = 1;
                                    break;
                                }
                                if (!(0, $lhvkE.shallowEquals)(clientOptionsWithDefaults, this.initOptions)) // eslint-disable-next-line no-console
                                console.warn('Feature Gates client already initialized with different options. New options were not applied.');
                                return _context2.abrupt("return", this.initPromise);
                            case 1:
                                startTime = performance.now();
                                this.initOptions = clientOptionsWithDefaults;
                                this.provider = provider;
                                this.provider.setClientVersion((0, $l7Wmf.CLIENT_VERSION));
                                if (this.provider.setApplyUpdateCallback) this.provider.setApplyUpdateCallback(this.applyUpdateCallback.bind(this));
                                this.initPromise = this.initWithProvider(clientOptionsWithDefaults, provider, identifiers, customAttributes).then(function() {
                                    _this3.initCompleted = true;
                                    _this3.initWithDefaults = true;
                                }).finally(function() {
                                    var endTime = performance.now();
                                    var totalTime = endTime - startTime;
                                    _this3.fireClientEvent(startTime, totalTime, 'initializeWithProvider', _this3.initCompleted, provider.getApiKey ? provider.getApiKey() : undefined);
                                });
                                return _context2.abrupt("return", this.initPromise);
                            case 2:
                            case "end":
                                return _context2.stop();
                        }
                    }, _callee2, this);
                }));
                function initializeWithProvider(_x4, _x5, _x6, _x7) {
                    return _initializeWithProvider.apply(this, arguments);
                }
                return initializeWithProvider;
            }()
        },
        {
            key: "applyUpdateCallback",
            value: function applyUpdateCallback(experimentsResult) {
                try {
                    if (this.initCompleted || this.initWithDefaults) {
                        this.assertInitialized(this.statsigClient);
                        this.dataAdapter.setBootstrapData(experimentsResult.experimentValues);
                        this.dataAdapter.setData(JSON.stringify(experimentsResult.experimentValues));
                        this.statsigValuesUpdated();
                    }
                } catch (error) {
                    // eslint-disable-next-line no-console
                    console.warn('Error when attempting to apply update', error);
                }
            }
        },
        {
            key: "fireClientEvent",
            value: function fireClientEvent(startTime, totalTime, action, success) {
                var _analyticsWebClient, _this4 = this;
                var apiKey = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;
                (_analyticsWebClient = this.initOptions.analyticsWebClient) === null || _analyticsWebClient === void 0 || _analyticsWebClient.then(function(analyticsWebClient) {
                    var attributes = $14bf0018cb51ec18$var$_objectSpread({
                        targetApp: _this4.initOptions.targetApp,
                        clientVersion: (0, $l7Wmf.CLIENT_VERSION),
                        success: success,
                        startTime: startTime,
                        totalTime: totalTime
                    }, apiKey && {
                        apiKey: apiKey
                    });
                    analyticsWebClient.sendOperationalEvent({
                        action: action,
                        actionSubject: 'featureGatesClient',
                        attributes: attributes,
                        tags: [
                            'measurement'
                        ],
                        source: '@atlaskit/feature-gate-js-client'
                    });
                }).catch(function(err) {
                    if (_this4.initOptions.environment !== (0, $kXewy.FeatureGateEnvironment).Production) // eslint-disable-next-line no-console
                    console.error('Analytics web client promise did not resolve', err);
                });
            }
        },
        {
            key: "initializeFromValues",
            value: function() {
                var _initializeFromValues = (0, $dLmLT.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dL89k))).mark(function _callee3(clientOptions, identifiers, customAttributes) {
                    var _this5 = this;
                    var initializeValues, clientOptionsWithDefaults, startTime, _args3 = arguments;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($dL89k))).wrap(function(_context3) {
                        while(true)switch(_context3.prev = _context3.next){
                            case 0:
                                initializeValues = _args3.length > 3 && _args3[3] !== undefined ? _args3[3] : {};
                                clientOptionsWithDefaults = (0, $lhvkE.getOptionsWithDefaults)(clientOptions);
                                if (!this.initPromise) {
                                    _context3.next = 1;
                                    break;
                                }
                                if (!(0, $lhvkE.shallowEquals)(clientOptionsWithDefaults, this.initOptions)) // eslint-disable-next-line no-console
                                console.warn('Feature Gates client already initialized with different options. New options were not applied.');
                                return _context3.abrupt("return", this.initPromise);
                            case 1:
                                // This makes sure the new Statsig client behaves like the old when bootstrap data is
                                // passed, and `has_updates` isn't specified (which happens a lot in product integration tests).
                                if (!Object.prototype.hasOwnProperty.call(initializeValues, 'has_updates')) initializeValues['has_updates'] = true;
                                startTime = performance.now();
                                this.initOptions = clientOptionsWithDefaults;
                                this.initPromise = this.initFromValues(clientOptionsWithDefaults, identifiers, customAttributes, initializeValues).then(function() {
                                    _this5.initCompleted = true;
                                    _this5.initWithDefaults = true;
                                }).finally(function() {
                                    var endTime = performance.now();
                                    var totalTime = endTime - startTime;
                                    _this5.fireClientEvent(startTime, totalTime, 'initializeFromValues', _this5.initCompleted);
                                });
                                return _context3.abrupt("return", this.initPromise);
                            case 2:
                            case "end":
                                return _context3.stop();
                        }
                    }, _callee3, this);
                }));
                function initializeFromValues(_x8, _x9, _x0) {
                    return _initializeFromValues.apply(this, arguments);
                }
                return initializeFromValues;
            }()
        },
        {
            key: "assertInitialized",
            value: function assertInitialized(statsigClient) {
                if (!statsigClient) throw new Error('Client must be initialized before using this method');
            }
        },
        {
            key: "updateUser",
            value: function() {
                var _updateUser = (0, $dLmLT.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dL89k))).mark(function _callee4(fetchOptions, identifiers, customAttributes) {
                    var fetchOptionsWithDefaults, initializeValuesProducer;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($dL89k))).wrap(function(_context4) {
                        while(true)switch(_context4.prev = _context4.next){
                            case 0:
                                this.assertInitialized(this.statsigClient);
                                fetchOptionsWithDefaults = (0, $lhvkE.getOptionsWithDefaults)(fetchOptions);
                                initializeValuesProducer = function initializeValuesProducer() {
                                    return (0, $88RZX.default).fetchExperimentValues(fetchOptionsWithDefaults, identifiers, customAttributes).then(function(_ref2) {
                                        var experimentValues = _ref2.experimentValues, customAttributes = _ref2.customAttributes;
                                        return {
                                            experimentValues: experimentValues,
                                            customAttributesFromFetch: customAttributes
                                        };
                                    });
                                };
                                _context4.next = 1;
                                return this.updateUserUsingInitializeValuesProducer(initializeValuesProducer, identifiers, customAttributes);
                            case 1:
                            case "end":
                                return _context4.stop();
                        }
                    }, _callee4, this);
                }));
                function updateUser(_x1, _x10, _x11) {
                    return _updateUser.apply(this, arguments);
                }
                return updateUser;
            }()
        },
        {
            key: "updateUserWithProvider",
            value: function() {
                var _updateUserWithProvider = (0, $dLmLT.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dL89k))).mark(function _callee5(identifiers, customAttributes) {
                    var _this6 = this;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($dL89k))).wrap(function(_context5) {
                        while(true)switch(_context5.prev = _context5.next){
                            case 0:
                                this.assertInitialized(this.statsigClient);
                                if (this.provider) {
                                    _context5.next = 1;
                                    break;
                                }
                                throw new Error('Cannot update user using provider as the client was not initialised with a provider');
                            case 1:
                                _context5.next = 2;
                                return this.provider.setProfile(this.initOptions, identifiers, customAttributes);
                            case 2:
                                _context5.next = 3;
                                return this.updateUserUsingInitializeValuesProducer(function() {
                                    return _this6.provider.getExperimentValues();
                                }, identifiers, customAttributes);
                            case 3:
                            case "end":
                                return _context5.stop();
                        }
                    }, _callee5, this);
                }));
                function updateUserWithProvider(_x12, _x13) {
                    return _updateUserWithProvider.apply(this, arguments);
                }
                return updateUserWithProvider;
            }()
        },
        {
            key: "updateUserWithValues",
            value: function() {
                var _updateUserWithValues = (0, $dLmLT.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dL89k))).mark(function _callee6(identifiers, customAttributes) {
                    var initializeValues, initializeValuesProducer, _args6 = arguments;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($dL89k))).wrap(function(_context6) {
                        while(true)switch(_context6.prev = _context6.next){
                            case 0:
                                initializeValues = _args6.length > 2 && _args6[2] !== undefined ? _args6[2] : {};
                                this.assertInitialized(this.statsigClient);
                                initializeValuesProducer = function initializeValuesProducer() {
                                    return Promise.resolve({
                                        experimentValues: initializeValues,
                                        customAttributesFromFetch: customAttributes
                                    });
                                };
                                _context6.next = 1;
                                return this.updateUserUsingInitializeValuesProducer(initializeValuesProducer, identifiers, customAttributes);
                            case 1:
                            case "end":
                                return _context6.stop();
                        }
                    }, _callee6, this);
                }));
                function updateUserWithValues(_x14, _x15) {
                    return _updateUserWithValues.apply(this, arguments);
                }
                return updateUserWithValues;
            }()
        },
        {
            key: "initializeCalled",
            value: function initializeCalled() {
                return this.initPromise != null;
            }
        },
        {
            key: "initializeCompleted",
            value: function initializeCompleted() {
                return this.initCompleted;
            }
        },
        {
            key: "waitUntilInitializeCompleted",
            value: function() {
                var _waitUntilInitializeCompleted = (0, $dLmLT.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dL89k))).mark(function _callee7() {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($dL89k))).wrap(function(_context7) {
                        while(true)switch(_context7.prev = _context7.next){
                            case 0:
                                if (this.initPromise) {
                                    _context7.next = 1;
                                    break;
                                }
                                throw new Error('The client must be initialized before you can wait until initialized.');
                            case 1:
                                if (!this.initCompleted) {
                                    _context7.next = 2;
                                    break;
                                }
                                return _context7.abrupt("return");
                            case 2:
                                _context7.next = 3;
                                return this.initPromise;
                            case 3:
                            case "end":
                                return _context7.stop();
                        }
                    }, _callee7, this);
                }));
                function waitUntilInitializeCompleted() {
                    return _waitUntilInitializeCompleted.apply(this, arguments);
                }
                return waitUntilInitializeCompleted;
            }()
        },
        {
            key: "checkGate",
            value: function checkGate(gateName) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                try {
                    this.assertInitialized(this.statsigClient);
                    var _options$fireGateExpo = options.fireGateExposure, fireGateExposure = _options$fireGateExpo === void 0 ? true : _options$fireGateExpo;
                    return this.statsigClient.checkGate(gateName, {
                        disableExposureLog: !fireGateExposure
                    });
                } catch (error) {
                    // Log the first occurrence of the error
                    if (!this.hasCheckGateErrorOccurred) {
                        // eslint-disable-next-line no-console
                        console.warn({
                            msg: 'An error has occurred checking the feature gate. Only the first occurrence of this error is logged.',
                            gateName: gateName,
                            error: error
                        });
                        this.hasCheckGateErrorOccurred = true;
                    }
                    return false;
                }
            }
        },
        {
            key: "isGateExist",
            value: function isGateExist(gateName) {
                try {
                    this.assertInitialized(this.statsigClient);
                    var gate = this.statsigClient.getFeatureGate(gateName, {
                        disableExposureLog: true
                    });
                    return !gate.details.reason.includes('Unrecognized');
                } catch (error) {
                    // eslint-disable-next-line no-console
                    console.error("Error occurred when trying to check FeatureGate: ".concat(error));
                    // in case of error report true to avoid false positives.
                    return true;
                }
            }
        },
        {
            key: "isExperimentExist",
            value: function isExperimentExist(experimentName) {
                try {
                    this.assertInitialized(this.statsigClient);
                    var config = this.statsigClient.getExperiment(experimentName, {
                        disableExposureLog: true
                    });
                    return !config.details.reason.includes('Unrecognized');
                } catch (error) {
                    // eslint-disable-next-line no-console
                    console.error("Error occurred when trying to check Experiment: ".concat(error));
                    // in case of error report true to avoid false positives.
                    return true;
                }
            }
        },
        {
            key: "manuallyLogGateExposure",
            value: function manuallyLogGateExposure(gateName) {
                this.assertInitialized(this.statsigClient);
                // This is the approach recommended in the docs
                // https://docs.statsig.com/client/javascript-sdk/#manual-exposures-
                this.statsigClient.checkGate(gateName);
            }
        },
        {
            key: "getExperiment",
            value: function getExperiment(experimentName) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                try {
                    this.assertInitialized(this.statsigClient);
                    var _options$fireExperime = options.fireExperimentExposure, fireExperimentExposure = _options$fireExperime === void 0 ? true : _options$fireExperime;
                    return (0, $9qaud.DynamicConfig).fromExperiment(this.statsigClient.getExperiment(experimentName, {
                        disableExposureLog: !fireExperimentExposure
                    }));
                } catch (error) {
                    // Log the first occurrence of the error
                    if (!this.hasGetExperimentErrorOccurred) {
                        // eslint-disable-next-line no-console
                        console.warn({
                            msg: 'An error has occurred getting the experiment. Only the first occurrence of this error is logged.',
                            experimentName: experimentName,
                            error: error
                        });
                        this.hasGetExperimentErrorOccurred = true;
                    }
                    // Return a default value
                    return new (0, $9qaud.DynamicConfig)(experimentName, {}, '', {
                        time: Date.now(),
                        reason: (0, $lTwRL.EvaluationReason).Error
                    });
                }
            }
        },
        {
            key: "getExperimentValue",
            value: function getExperimentValue(experimentName, parameterName, defaultValue) {
                var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var experiment = this.getExperiment(experimentName, options);
                try {
                    var typeGuard = options.typeGuard;
                    return experiment.get(parameterName, defaultValue, typeGuard);
                } catch (error) {
                    // Log the first occurrence of the error
                    if (!this.hasGetExperimentValueErrorOccurred) {
                        // eslint-disable-next-line no-console
                        console.warn({
                            msg: 'An error has occurred getting the experiment value. Only the first occurrence of this error is logged.',
                            experimentName: experimentName,
                            defaultValue: defaultValue,
                            options: options,
                            error: error
                        });
                        this.hasGetExperimentValueErrorOccurred = true;
                    }
                    return defaultValue;
                }
            }
        },
        {
            key: "manuallyLogExperimentExposure",
            value: function manuallyLogExperimentExposure(experimentName) {
                this.assertInitialized(this.statsigClient);
                // This is the approach recommended in the docs
                // https://docs.statsig.com/client/javascript-sdk/#manual-exposures-
                this.statsigClient.getExperiment(experimentName);
            }
        },
        {
            key: "manuallyLogLayerExposure",
            value: function manuallyLogLayerExposure(layerName, parameterName) {
                var _this$statsigClient$g;
                this.assertInitialized(this.statsigClient);
                // This is the approach recommended in the docs
                // https://docs.statsig.com/client/javascript-sdk/#manual-exposures-
                (_this$statsigClient$g = this.statsigClient.getLayer(layerName)) === null || _this$statsigClient$g === void 0 || _this$statsigClient$g.get(parameterName);
            }
        },
        {
            key: "shutdownStatsig",
            value: function shutdownStatsig() {
                this.assertInitialized(this.statsigClient);
                this.statsigClient.shutdown();
            }
        },
        {
            key: "overrideGate",
            value: function overrideGate(gateName, value) {
                this.overrideAdapter.overrideGate(gateName, value);
                // Trigger a reset of the memoized gate value
                if (this.user) {
                    var _this$statsigClient;
                    (_this$statsigClient = this.statsigClient) === null || _this$statsigClient === void 0 || _this$statsigClient.updateUserSync(this.user, {
                        disableBackgroundCacheRefresh: true
                    });
                }
                this.statsigValuesUpdated();
            }
        },
        {
            key: "clearGateOverride",
            value: function clearGateOverride(gateName) {
                this.overrideAdapter.removeGateOverride(gateName);
                this.statsigValuesUpdated();
            }
        },
        {
            key: "overrideConfig",
            value: function overrideConfig(experimentName, values) {
                this.overrideAdapter.overrideDynamicConfig(experimentName, values);
                this.statsigValuesUpdated();
            }
        },
        {
            key: "clearConfigOverride",
            value: function clearConfigOverride(experimentName) {
                this.overrideAdapter.removeDynamicConfigOverride(experimentName);
                this.statsigValuesUpdated();
            }
        },
        {
            key: "setOverrides",
            value: function setOverrides(overrides) {
                this.overrideAdapter.setOverrides(overrides);
                this.statsigValuesUpdated();
            }
        },
        {
            key: "getOverrides",
            value: function getOverrides() {
                return this.overrideAdapter.getOverrides();
            }
        },
        {
            key: "clearAllOverrides",
            value: function clearAllOverrides() {
                this.overrideAdapter.removeAllOverrides();
                this.statsigValuesUpdated();
            }
        },
        {
            key: "isCurrentUser",
            value: function isCurrentUser(identifiers, customAttributes) {
                return (0, $lhvkE.shallowEquals)(this.currentIdentifiers, identifiers) && (0, $lhvkE.shallowEquals)(this.currentAttributes, customAttributes);
            }
        },
        {
            key: "onGateUpdated",
            value: function onGateUpdated(gateName, callback) {
                var _this7 = this;
                var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                var wrapCallback = function wrapCallback(value) {
                    var _options$fireGateExpo2 = options.fireGateExposure, fireGateExposure = _options$fireGateExpo2 === void 0 ? true : _options$fireGateExpo2;
                    if (fireGateExposure) _this7.manuallyLogGateExposure(gateName);
                    try {
                        callback(value);
                    } catch (error) {
                        // eslint-disable-next-line no-console
                        console.warn("Error calling callback for gate ".concat(gateName, " with value ").concat(value), error);
                    }
                };
                return this.subscriptions.onGateUpdated(gateName, wrapCallback, this.checkGate.bind(this), options);
            }
        },
        {
            key: "onExperimentValueUpdated",
            value: function onExperimentValueUpdated(experimentName, parameterName, defaultValue, callback) {
                var _this8 = this;
                var options = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
                var wrapCallback = function wrapCallback(value) {
                    var _options$fireExperime2 = options.fireExperimentExposure, fireExperimentExposure = _options$fireExperime2 === void 0 ? true : _options$fireExperime2;
                    if (fireExperimentExposure) _this8.manuallyLogExperimentExposure(experimentName);
                    try {
                        callback(value);
                    } catch (error) {
                        // eslint-disable-next-line no-console
                        console.warn("Error calling callback for experiment ".concat(experimentName, " with value ").concat(value), error);
                    }
                };
                return this.subscriptions.onExperimentValueUpdated(experimentName, parameterName, defaultValue, wrapCallback, this.getExperimentValue.bind(this), options);
            }
        },
        {
            key: "onAnyUpdated",
            value: function onAnyUpdated(callback) {
                return this.subscriptions.onAnyUpdated(callback);
            }
        },
        {
            key: "init",
            value: function() {
                var _init = (0, $dLmLT.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dL89k))).mark(function _callee8(clientOptions, identifiers, customAttributes) {
                    var fromValuesClientOptions, experimentValues, customAttributesFromResult, clientSdkKeyPromise, experimentValuesPromise, _yield$Promise$all, _yield$Promise$all2, experimentValuesResult, _t;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($dL89k))).wrap(function(_context8) {
                        while(true)switch(_context8.prev = _context8.next){
                            case 0:
                                fromValuesClientOptions = $14bf0018cb51ec18$var$_objectSpread({}, clientOptions);
                                if (!clientOptions.localMode) {
                                    _context8.next = 2;
                                    break;
                                }
                                _context8.next = 1;
                                return this.initFromValues(fromValuesClientOptions, identifiers, customAttributes);
                            case 1:
                                return _context8.abrupt("return");
                            case 2:
                                _context8.prev = 2;
                                // If client sdk key fetch fails, an error would be thrown and handled instead of waiting for
                                // the experiment values request to be settled, and it will fall back to use default values.
                                clientSdkKeyPromise = (0, $88RZX.default).fetchClientSdk(clientOptions).then(function(value) {
                                    return fromValuesClientOptions.sdkKey = value.clientSdkKey;
                                });
                                experimentValuesPromise = (0, $88RZX.default).fetchExperimentValues(clientOptions, identifiers, customAttributes); // Only wait for the experiment values request to finish and try to initialise the client
                                // with experiment values if both requests are successful. Else an error would be thrown and
                                // handled by the catch
                                _context8.next = 3;
                                return Promise.all([
                                    clientSdkKeyPromise,
                                    experimentValuesPromise
                                ]);
                            case 3:
                                _yield$Promise$all = _context8.sent;
                                _yield$Promise$all2 = (0, $6mpGR.default)(_yield$Promise$all, 2);
                                experimentValuesResult = _yield$Promise$all2[1];
                                experimentValues = experimentValuesResult.experimentValues;
                                customAttributesFromResult = experimentValuesResult.customAttributes;
                                _context8.next = 6;
                                break;
                            case 4:
                                _context8.prev = 4;
                                _t = _context8["catch"](2);
                                if (_t instanceof Error) // eslint-disable-next-line no-console
                                console.error("Error occurred when trying to fetch the Feature Gates client values, error: ".concat(_t === null || _t === void 0 ? void 0 : _t.message));
                                // eslint-disable-next-line no-console
                                console.warn("Initialising Statsig client without values");
                                _context8.next = 5;
                                return this.initFromValues(fromValuesClientOptions, identifiers, customAttributes);
                            case 5:
                                throw _t;
                            case 6:
                                return _context8.abrupt("return", this.initFromValues(fromValuesClientOptions, identifiers, customAttributesFromResult, experimentValues));
                            case 7:
                            case "end":
                                return _context8.stop();
                        }
                    }, _callee8, this, [
                        [
                            2,
                            4
                        ]
                    ]);
                }));
                function init(_x16, _x17, _x18) {
                    return _init.apply(this, arguments);
                }
                return init;
            }()
        },
        {
            key: "initWithProvider",
            value: function() {
                var _initWithProvider = (0, $dLmLT.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dL89k))).mark(function _callee9(baseClientOptions, provider, identifiers, customAttributes) {
                    var fromValuesClientOptions, experimentValues, customAttributesFromResult, clientSdkKeyPromise, experimentValuesPromise, _yield$Promise$all3, _yield$Promise$all4, experimentValuesResult, _t2;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($dL89k))).wrap(function(_context9) {
                        while(true)switch(_context9.prev = _context9.next){
                            case 0:
                                fromValuesClientOptions = $14bf0018cb51ec18$var$_objectSpread($14bf0018cb51ec18$var$_objectSpread({}, baseClientOptions), {}, {
                                    disableCurrentPageLogging: true
                                });
                                _context9.prev = 1;
                                _context9.next = 2;
                                return provider.setProfile(baseClientOptions, identifiers, customAttributes);
                            case 2:
                                // If client sdk key fetch fails, an error would be thrown and handled instead of waiting for
                                // the experiment values request to be settled, and it will fall back to use default values.
                                clientSdkKeyPromise = provider.getClientSdkKey().then(function(value) {
                                    return fromValuesClientOptions.sdkKey = value;
                                });
                                experimentValuesPromise = provider.getExperimentValues(); // Only wait for the experiment values request to finish and try to initialise the client
                                // with experiment values if both requests are successful. Else an error would be thrown and
                                // handled by the catch
                                _context9.next = 3;
                                return Promise.all([
                                    clientSdkKeyPromise,
                                    experimentValuesPromise
                                ]);
                            case 3:
                                _yield$Promise$all3 = _context9.sent;
                                _yield$Promise$all4 = (0, $6mpGR.default)(_yield$Promise$all3, 2);
                                experimentValuesResult = _yield$Promise$all4[1];
                                experimentValues = experimentValuesResult.experimentValues;
                                customAttributesFromResult = experimentValuesResult.customAttributesFromFetch;
                                _context9.next = 6;
                                break;
                            case 4:
                                _context9.prev = 4;
                                _t2 = _context9["catch"](1);
                                if (_t2 instanceof Error) // eslint-disable-next-line no-console
                                console.error("Error occurred when trying to fetch the Feature Gates client values, error: ".concat(_t2 === null || _t2 === void 0 ? void 0 : _t2.message));
                                // eslint-disable-next-line no-console
                                console.warn("Initialising Statsig client without values");
                                _context9.next = 5;
                                return this.initFromValues(fromValuesClientOptions, identifiers, customAttributes);
                            case 5:
                                throw _t2;
                            case 6:
                                return _context9.abrupt("return", this.initFromValues(fromValuesClientOptions, identifiers, customAttributesFromResult, experimentValues));
                            case 7:
                            case "end":
                                return _context9.stop();
                        }
                    }, _callee9, this, [
                        [
                            1,
                            4
                        ]
                    ]);
                }));
                function initWithProvider(_x19, _x20, _x21, _x22) {
                    return _initWithProvider.apply(this, arguments);
                }
                return initWithProvider;
            }()
        },
        {
            key: "initFromValues",
            value: function() {
                var _initFromValues = (0, $dLmLT.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dL89k))).mark(function _callee0(clientOptions, identifiers, customAttributes) {
                    var _newClientOptions$net;
                    var initializeValues, newClientOptions, sdkKey, environment, _updateUserCompletionCallback, _perimeter, restClientOptions, frontendUser, statsigOptions, _args0 = arguments, _t3;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($dL89k))).wrap(function(_context0) {
                        while(true)switch(_context0.prev = _context0.next){
                            case 0:
                                initializeValues = _args0.length > 3 && _args0[3] !== undefined ? _args0[3] : {};
                                this.overrideAdapter.initFromStoredOverrides();
                                this.currentIdentifiers = identifiers;
                                this.currentAttributes = customAttributes;
                                newClientOptions = (0, $lhvkE.migrateInitializationOptions)(clientOptions);
                                if (!newClientOptions.sdkKey) newClientOptions.sdkKey = $14bf0018cb51ec18$var$DEFAULT_CLIENT_KEY;
                                if (!((_newClientOptions$net = newClientOptions.networkConfig) !== null && _newClientOptions$net !== void 0 && _newClientOptions$net.logEventUrl)) newClientOptions.networkConfig = $14bf0018cb51ec18$var$_objectSpread($14bf0018cb51ec18$var$_objectSpread({}, newClientOptions.networkConfig), {}, {
                                    logEventUrl: $14bf0018cb51ec18$var$DEFAULT_EVENT_LOGGING_API
                                });
                                if (newClientOptions.perimeter === (0, $kXewy.PerimeterType).FEDRAMP_MODERATE) // disable all logging in FedRAMP to prevent egress of sensitive data
                                newClientOptions.disableLogging = true;
                                sdkKey = newClientOptions.sdkKey, environment = newClientOptions.environment, _updateUserCompletionCallback = newClientOptions.updateUserCompletionCallback, _perimeter = newClientOptions.perimeter, restClientOptions = (0, $kEBxa.default)(newClientOptions, $14bf0018cb51ec18$var$_excluded);
                                frontendUser = (0, $lhvkE.toStatsigUser)(identifiers, customAttributes);
                                this.user = (0, $lhvkE.deepAssign)({}, initializeValues.user, frontendUser);
                                statsigOptions = $14bf0018cb51ec18$var$_objectSpread($14bf0018cb51ec18$var$_objectSpread({}, restClientOptions), {}, {
                                    environment: {
                                        tier: environment
                                    },
                                    includeCurrentPageUrlWithEvents: false,
                                    dataAdapter: this.dataAdapter,
                                    overrideAdapter: this.overrideAdapter,
                                    logEventCompressionMode: (0, $iFR7a.LogEventCompressionMode).Forced
                                }); // Statsig validates the provided stableId against their own cookie, so we either need
                                // to update the cookie to match, or disable the validation completely.
                                if (identifiers.stableId) (0, $iFR7a.StableID).setOverride(identifiers.stableId, sdkKey);
                                else statsigOptions.disableStableID = true;
                                _context0.prev = 1;
                                this.statsigClient = new (0, $iFR7a.StatsigClient)(sdkKey, this.user, statsigOptions);
                                this.dataAdapter.setBootstrapData(initializeValues);
                                _context0.next = 2;
                                return this.statsigClient.initializeAsync();
                            case 2:
                                _context0.next = 5;
                                break;
                            case 3:
                                _context0.prev = 3;
                                _t3 = _context0["catch"](1);
                                if (_t3 instanceof Error) // eslint-disable-next-line no-console
                                console.error("Error occurred when trying to initialise the Statsig client, error: ".concat(_t3 === null || _t3 === void 0 ? void 0 : _t3.message));
                                // eslint-disable-next-line no-console
                                console.warn("Initialising Statsig client with default sdk key and without values");
                                this.statsigClient = new (0, $iFR7a.StatsigClient)($14bf0018cb51ec18$var$DEFAULT_CLIENT_KEY, this.user, statsigOptions);
                                this.dataAdapter.setBootstrapData();
                                _context0.next = 4;
                                return this.statsigClient.initializeAsync();
                            case 4:
                                this.initWithDefaults = true;
                                throw _t3;
                            case 5:
                            case "end":
                                return _context0.stop();
                        }
                    }, _callee0, this, [
                        [
                            1,
                            3
                        ]
                    ]);
                }));
                function initFromValues(_x23, _x24, _x25) {
                    return _initFromValues.apply(this, arguments);
                }
                return initFromValues;
            }()
        },
        {
            key: "updateUserUsingInitializeValuesProducer",
            value: function() {
                var _updateUserUsingInitializeValuesProducer = (0, $dLmLT.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dL89k))).mark(function _callee10(getInitializeValues, identifiers, customAttributes) {
                    var _this9 = this;
                    var originalInitPromise, initializeValuesPromise, updateUserPromise, _t4;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($dL89k))).wrap(function(_context10) {
                        while(true)switch(_context10.prev = _context10.next){
                            case 0:
                                this.assertInitialized(this.statsigClient);
                                if (this.initPromise) {
                                    _context10.next = 1;
                                    break;
                                }
                                throw new Error('The client must be initialized before you can update the user.');
                            case 1:
                                if (!this.isCurrentUser(identifiers, customAttributes)) {
                                    _context10.next = 2;
                                    break;
                                }
                                return _context10.abrupt("return", this.initPromise);
                            case 2:
                                // Wait for the current initialize/update to finish
                                originalInitPromise = this.initPromise;
                                _context10.prev = 3;
                                _context10.next = 4;
                                return this.initPromise;
                            case 4:
                                _context10.next = 6;
                                break;
                            case 5:
                                _context10.prev = 5;
                                _t4 = _context10["catch"](3);
                            case 6:
                                initializeValuesPromise = getInitializeValues();
                                updateUserPromise = this.updateStatsigClientUser(initializeValuesPromise, identifiers, customAttributes); // We replace the init promise here since we are essentially re-initializing the client at this
                                // point. Any subsequent calls to await client.initialize() or client.updateUser()
                                // will now also await this user update.
                                this.initPromise = updateUserPromise.catch(/*#__PURE__*/ (0, $dLmLT.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dL89k))).mark(function _callee1() {
                                    return (0, (/*@__PURE__*/$parcel$interopDefault($dL89k))).wrap(function(_context1) {
                                        while(true)switch(_context1.prev = _context1.next){
                                            case 0:
                                                // If the update failed then it changed nothing, so revert back to the original promise.
                                                _this9.initPromise = originalInitPromise;
                                                // Set the user profile again to revert back to the current user
                                                if (!_this9.provider) {
                                                    _context1.next = 1;
                                                    break;
                                                }
                                                _context1.next = 1;
                                                return _this9.provider.setProfile(_this9.initOptions, _this9.currentIdentifiers, _this9.currentAttributes);
                                            case 1:
                                            case "end":
                                                return _context1.stop();
                                        }
                                    }, _callee1);
                                })));
                                return _context10.abrupt("return", updateUserPromise);
                            case 7:
                            case "end":
                                return _context10.stop();
                        }
                    }, _callee10, this, [
                        [
                            3,
                            5
                        ]
                    ]);
                }));
                function updateUserUsingInitializeValuesProducer(_x26, _x27, _x28) {
                    return _updateUserUsingInitializeValuesProducer.apply(this, arguments);
                }
                return updateUserUsingInitializeValuesProducer;
            }()
        },
        {
            key: "updateStatsigClientUser",
            value: function() {
                var _updateStatsigClientUser = (0, $dLmLT.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dL89k))).mark(function _callee11(initializeValuesPromise, identifiers, customAttributes) {
                    var _this$initOptions, _this$initOptions$upd;
                    var initializeValues, user, frontendUser, _updateUserCompletion, _ref4, errMsg, success, errorMessage, _t5, _t6;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($dL89k))).wrap(function(_context11) {
                        while(true)switch(_context11.prev = _context11.next){
                            case 0:
                                this.assertInitialized(this.statsigClient);
                                _context11.prev = 1;
                                _context11.next = 2;
                                return initializeValuesPromise;
                            case 2:
                                initializeValues = _context11.sent;
                                frontendUser = (0, $lhvkE.toStatsigUser)(identifiers, initializeValues.customAttributesFromFetch);
                                user = (0, $lhvkE.deepAssign)({}, initializeValues.experimentValues.user, frontendUser);
                                _context11.next = 4;
                                break;
                            case 3:
                                _context11.prev = 3;
                                _t5 = _context11["catch"](1);
                                // Make sure the updateUserCompletionCallback is called for any errors in our custom code.
                                // This is not necessary for the updateUserWithValues call, because the Statsig client will
                                // already invoke the callback itself.
                                errMsg = _t5 instanceof Error ? _t5.message : JSON.stringify(_t5);
                                (_updateUserCompletion = (_ref4 = this.initOptions).updateUserCompletionCallback) === null || _updateUserCompletion === void 0 || _updateUserCompletion.call(_ref4, false, errMsg);
                                throw _t5;
                            case 4:
                                success = true;
                                errorMessage = null;
                                _context11.prev = 5;
                                this.dataAdapter.setBootstrapData(initializeValues.experimentValues);
                                this.user = user;
                                if (!this.user) {
                                    _context11.next = 6;
                                    break;
                                }
                                _context11.next = 6;
                                return this.statsigClient.updateUserAsync(this.user);
                            case 6:
                                _context11.next = 8;
                                break;
                            case 7:
                                _context11.prev = 7;
                                _t6 = _context11["catch"](5);
                                success = false;
                                errorMessage = String(_t6);
                            case 8:
                                (_this$initOptions = this.initOptions) === null || _this$initOptions === void 0 || (_this$initOptions$upd = _this$initOptions.updateUserCompletionCallback) === null || _this$initOptions$upd === void 0 || _this$initOptions$upd.call(_this$initOptions, success, errorMessage);
                                if (!success) {
                                    _context11.next = 9;
                                    break;
                                }
                                this.currentIdentifiers = identifiers;
                                this.currentAttributes = customAttributes;
                                this.subscriptions.anyUpdated();
                                _context11.next = 10;
                                break;
                            case 9:
                                throw new Error('Failed to update user. An unexpected error occured.');
                            case 10:
                            case "end":
                                return _context11.stop();
                        }
                    }, _callee11, this, [
                        [
                            1,
                            3
                        ],
                        [
                            5,
                            7
                        ]
                    ]);
                }));
                function updateStatsigClientUser(_x29, _x30, _x31) {
                    return _updateStatsigClientUser.apply(this, arguments);
                }
                return updateStatsigClientUser;
            }()
        },
        {
            key: "getPackageVersion",
            value: /**
     * @returns string version of the current package in semver style.
     */ function getPackageVersion() {
                return 0, $l7Wmf.CLIENT_VERSION;
            }
        },
        {
            key: "getTargetApp",
            value: function getTargetApp() {
                var _this$initOptions2;
                return (_this$initOptions2 = this.initOptions) === null || _this$initOptions2 === void 0 ? void 0 : _this$initOptions2.targetApp;
            }
        },
        {
            key: "getLayer",
            value: function getLayer(/** The name of the layer */ layerName) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                try {
                    this.assertInitialized(this.statsigClient);
                    var _options$fireLayerExp = options.fireLayerExposure, fireLayerExposure = _options$fireLayerExp === void 0 ? true : _options$fireLayerExp;
                    return (0, $I2vtT.Layer).fromLayer(this.statsigClient.getLayer(layerName, {
                        disableExposureLog: !fireLayerExposure
                    }));
                } catch (error) {
                    // Log the first occurrence of the error
                    if (!this.hasGetLayerErrorOccurred) {
                        // eslint-disable-next-line no-console
                        console.warn({
                            msg: 'An error has occurred getting the layer. Only the first occurrence of this error is logged.',
                            layerName: layerName,
                            error: error
                        });
                        this.hasGetLayerErrorOccurred = true;
                    }
                    // Return a default value
                    return (0, $I2vtT.Layer).fromLayer((0, $iFR7a._makeLayer)(layerName, {
                        reason: 'Error'
                    }, null));
                }
            }
        },
        {
            key: "getLayerValue",
            value: function getLayerValue(layerName, parameterName, defaultValue) {
                var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var layer = this.getLayer(layerName, options);
                try {
                    var typeGuard = options.typeGuard;
                    return layer.get(parameterName, defaultValue, typeGuard);
                } catch (error) {
                    // Log the first occurrence of the error
                    if (!this.hasGetLayerValueErrorOccurred) {
                        // eslint-disable-next-line no-console
                        console.warn({
                            msg: 'An error has occurred getting the layer value. Only the first occurrence of this error is logged.',
                            layerName: layerName,
                            defaultValue: defaultValue,
                            options: options,
                            error: error
                        });
                        this.hasGetLayerValueErrorOccurred = true;
                    }
                    return defaultValue;
                }
            }
        }
    ]);
}();

});
parcelRegister("6mpGR", function(module, exports) {
$parcel$export(module.exports, "default", () => $4a18b9b099e7037a$export$2e2bcd8739ae039);

var $cd4YF = parcelRequire("cd4YF");

var $2juMU = parcelRequire("2juMU");

var $d7D8H = parcelRequire("d7D8H");

var $7IXOF = parcelRequire("7IXOF");
function $4a18b9b099e7037a$export$2e2bcd8739ae039(r, e) {
    return (0, $cd4YF.default)(r) || (0, $2juMU.default)(r, e) || (0, $d7D8H.default)(r, e) || (0, $7IXOF.default)();
}

});
parcelRegister("cd4YF", function(module, exports) {
$parcel$export(module.exports, "default", () => $8e3a8f57950a16a3$export$2e2bcd8739ae039);
function $8e3a8f57950a16a3$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return r;
}

});

parcelRegister("2juMU", function(module, exports) {
$parcel$export(module.exports, "default", () => $1af53cf3adee9153$export$2e2bcd8739ae039);
function $1af53cf3adee9153$export$2e2bcd8739ae039(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}

});

parcelRegister("d7D8H", function(module, exports) {
$parcel$export(module.exports, "default", () => $98da4a0e03586041$export$2e2bcd8739ae039);

var $gRW5H = parcelRequire("gRW5H");
function $98da4a0e03586041$export$2e2bcd8739ae039(r, a) {
    if (r) {
        if ("string" == typeof r) return (0, $gRW5H.default)(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? (0, $gRW5H.default)(r, a) : void 0;
    }
}

});
parcelRegister("gRW5H", function(module, exports) {
$parcel$export(module.exports, "default", () => $c47ea8339d0e89fc$export$2e2bcd8739ae039);
function $c47ea8339d0e89fc$export$2e2bcd8739ae039(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}

});


parcelRegister("7IXOF", function(module, exports) {
$parcel$export(module.exports, "default", () => $59fb0ab50e45024c$export$2e2bcd8739ae039);
function $59fb0ab50e45024c$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});


parcelRegister("dLmLT", function(module, exports) {
$parcel$export(module.exports, "default", () => $a051541966d20e3a$export$2e2bcd8739ae039);
function $a051541966d20e3a$var$asyncGeneratorStep(n, t, e, r, o, a, c) {
    try {
        var i = n[a](c), u = i.value;
    } catch (n) {
        return void e(n);
    }
    i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function $a051541966d20e3a$export$2e2bcd8739ae039(n) {
    return function() {
        var t = this, e = arguments;
        return new Promise(function(r, o) {
            var a = n.apply(t, e);
            function _next(n) {
                $a051541966d20e3a$var$asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
            }
            function _throw(n) {
                $a051541966d20e3a$var$asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
            }
            _next(void 0);
        });
    };
}

});

parcelRegister("dL89k", function(module, exports) {
// TODO(Babel 8): Remove this file.

var $a045fc786cedb54d$var$runtime = (parcelRequire("hY3Wi"))();
module.exports = $a045fc786cedb54d$var$runtime;
// Copied from https://github.com/facebook/regenerator/blob/main/packages/runtime/runtime.js#L736=
try {
    regeneratorRuntime = $a045fc786cedb54d$var$runtime;
} catch (accidentalStrictMode) {
    if (typeof globalThis === "object") globalThis.regeneratorRuntime = $a045fc786cedb54d$var$runtime;
    else Function("r", "regeneratorRuntime = r")($a045fc786cedb54d$var$runtime);
}

});

parcelRegister("5giQQ", function(module, exports) {
$parcel$export(module.exports, "default", () => $3d4d11dd06795dd0$export$2e2bcd8739ae039);

var $ja5yh = parcelRequire("ja5yh");

var $4gOTZ = parcelRequire("4gOTZ");

var $6rvcc = parcelRequire("6rvcc");

var $hLfKH = parcelRequire("hLfKH");
function $3d4d11dd06795dd0$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $3d4d11dd06795dd0$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $3d4d11dd06795dd0$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $6rvcc.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $3d4d11dd06795dd0$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $3d4d11dd06795dd0$export$a66cbd9b2289cd78 = '@all-features';
var $3d4d11dd06795dd0$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function Subscriptions() {
        (0, $ja5yh.default)(this, Subscriptions);
        (0, $6rvcc.default)(this, "eventToValue", new Map());
        this.emitter = new (0, (/*@__PURE__*/$parcel$interopDefault($hLfKH)))();
    }
    return (0, $4gOTZ.default)(Subscriptions, [
        {
            key: "onGateUpdated",
            value: function onGateUpdated(gateName, callback, checkGate, options) {
                var _this = this;
                var value = checkGate(gateName, $3d4d11dd06795dd0$var$_objectSpread($3d4d11dd06795dd0$var$_objectSpread({}, options), {}, {
                    fireGateExposure: false
                }));
                if (this.eventToValue.get(callback) === undefined) this.eventToValue.set(callback, value);
                var wrapCallback = function wrapCallback() {
                    var value = checkGate(gateName, $3d4d11dd06795dd0$var$_objectSpread($3d4d11dd06795dd0$var$_objectSpread({}, options), {}, {
                        fireGateExposure: false
                    }));
                    var existingValue = _this.eventToValue.get(callback);
                    if (existingValue !== value) {
                        _this.eventToValue.set(callback, value);
                        callback(value);
                    }
                };
                this.emitter.on(gateName, wrapCallback);
                return function() {
                    _this.emitter.off(gateName, wrapCallback);
                };
            }
        },
        {
            key: "onExperimentValueUpdated",
            value: function onExperimentValueUpdated(experimentName, parameterName, defaultValue, callback, getExperimentValue, options) {
                var _this2 = this;
                var experimentEventName = "".concat(experimentName, ".").concat(parameterName);
                var value = getExperimentValue(experimentName, parameterName, defaultValue, $3d4d11dd06795dd0$var$_objectSpread($3d4d11dd06795dd0$var$_objectSpread({}, options), {}, {
                    fireExperimentExposure: false
                }));
                if (this.eventToValue.get(callback) === undefined) this.eventToValue.set(callback, value);
                var wrapCallback = function wrapCallback() {
                    var value = getExperimentValue(experimentName, parameterName, defaultValue, $3d4d11dd06795dd0$var$_objectSpread($3d4d11dd06795dd0$var$_objectSpread({}, options), {}, {
                        fireExperimentExposure: false
                    }));
                    var existingValue = _this2.eventToValue.get(callback);
                    if (existingValue !== value) {
                        _this2.eventToValue.set(callback, value);
                        callback(value);
                    }
                };
                this.emitter.on(experimentEventName, wrapCallback);
                return function() {
                    _this2.emitter.off(experimentEventName, wrapCallback);
                };
            }
        },
        {
            key: "onAnyUpdated",
            value: function onAnyUpdated(callback) {
                var _this3 = this;
                this.emitter.on($3d4d11dd06795dd0$export$a66cbd9b2289cd78, callback);
                return function() {
                    _this3.emitter.off($3d4d11dd06795dd0$export$a66cbd9b2289cd78, callback);
                };
            }
        },
        {
            key: "anyUpdated",
            value: function anyUpdated() {
                var _this4 = this;
                this.emitter.emit($3d4d11dd06795dd0$export$a66cbd9b2289cd78);
                this.emitter.eventNames().filter(function(name) {
                    return name !== $3d4d11dd06795dd0$export$a66cbd9b2289cd78;
                }).forEach(function(event) {
                    _this4.emitter.emit(event);
                });
            }
        }
    ]);
}();

});

parcelRegister("9qaud", function(module, exports) {
$parcel$export(module.exports, "DynamicConfig", () => $6dbead1e39f1a93d$export$6dc24881a3d96325);

var $itFCD = parcelRequire("itFCD");

var $ja5yh = parcelRequire("ja5yh");

var $4gOTZ = parcelRequire("4gOTZ");

var $lhvkE = parcelRequire("lhvkE");
var $6dbead1e39f1a93d$export$6dc24881a3d96325 = /*#__PURE__*/ function() {
    function DynamicConfig(configName, configValue, ruleID, evaluationDetails) {
        var secondaryExposures = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : [];
        var allocatedExperimentName = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : '';
        var onDefaultValueFallback = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : null;
        (0, $ja5yh.default)(this, DynamicConfig);
        this.value = configValue;
        this._name = configName;
        this._ruleID = ruleID;
        this._secondaryExposures = secondaryExposures;
        this._allocatedExperimentName = allocatedExperimentName;
        this._evaluationDetails = evaluationDetails;
        this._onDefaultValueFallback = onDefaultValueFallback;
    }
    return (0, $4gOTZ.default)(DynamicConfig, [
        {
            key: "get",
            value: function get(key, defaultValue, typeGuard) {
                var _this$_onDefaultValue2;
                var val = this.getValue(key, defaultValue);
                if (val == null) return defaultValue;
                var expectedType = Array.isArray(defaultValue) ? 'array' : (0, $itFCD.default)(defaultValue);
                var actualType = Array.isArray(val) ? 'array' : (0, $itFCD.default)(val);
                if (typeGuard) {
                    var _this$_onDefaultValue;
                    if (typeGuard(val)) {
                        this.fireExposure(key);
                        return val;
                    }
                    (_this$_onDefaultValue = this._onDefaultValueFallback) === null || _this$_onDefaultValue === void 0 || _this$_onDefaultValue.call(this, this, key, expectedType, actualType);
                    return defaultValue;
                }
                if (defaultValue == null || expectedType === actualType) {
                    this.fireExposure(key);
                    return val;
                }
                (_this$_onDefaultValue2 = this._onDefaultValueFallback) === null || _this$_onDefaultValue2 === void 0 || _this$_onDefaultValue2.call(this, this, key, expectedType, actualType);
                return defaultValue;
            }
        },
        {
            key: "getValue",
            value: function getValue(key, defaultValue) {
                if (key == null) return this.value;
                if (defaultValue == null) defaultValue = null;
                if (this.value[key] == null) return defaultValue;
                this.fireExposure(key);
                return this.value[key];
            }
        },
        {
            key: "fireExposure",
            value: function fireExposure(key) {
                // Call the wrapped experiment's get method to fire exposure
                if (this.experiment) this.experiment.get(key);
            }
        }
    ], [
        {
            key: "fromExperiment",
            value: function fromExperiment(experiment) {
                var _experiment$__evaluat, _experiment$__evaluat2, _experiment$groupName;
                var config = new DynamicConfig(experiment.name, experiment.value, experiment.ruleID, (0, $lhvkE.migrateEvaluationDetails)(experiment.details), (0, $lhvkE.migrateSecondaryExposures)((_experiment$__evaluat = (_experiment$__evaluat2 = experiment.__evaluation) === null || _experiment$__evaluat2 === void 0 ? void 0 : _experiment$__evaluat2.secondary_exposures) !== null && _experiment$__evaluat !== void 0 ? _experiment$__evaluat : []), (_experiment$groupName = experiment.groupName) !== null && _experiment$groupName !== void 0 ? _experiment$groupName : undefined);
                config.experiment = experiment;
                return config;
            }
        }
    ]);
}();

});
parcelRegister("lhvkE", function(module, exports) {
$parcel$export(module.exports, "getOptionsWithDefaults", () => $f7e37d6a1e1b71b5$export$d119b37e5f788b43);
$parcel$export(module.exports, "shallowEquals", () => $f7e37d6a1e1b71b5$export$fa1c2bbf4100b8bc);
$parcel$export(module.exports, "toStatsigUser", () => $f7e37d6a1e1b71b5$export$3dad1db244472f32);
$parcel$export(module.exports, "deepAssign", () => $f7e37d6a1e1b71b5$export$1148cb79ceecd5fa);
$parcel$export(module.exports, "migrateInitializationOptions", () => $f7e37d6a1e1b71b5$export$202946b690d26d22);
$parcel$export(module.exports, "migrateEvaluationDetails", () => $f7e37d6a1e1b71b5$export$18ad168d3dbac899);
$parcel$export(module.exports, "migrateSecondaryExposures", () => $f7e37d6a1e1b71b5$export$55fd683752d01e67);

var $itFCD = parcelRequire("itFCD");

var $lp9qg = parcelRequire("lp9qg");

var $kEBxa = parcelRequire("kEBxa");

var $6mpGR = parcelRequire("6mpGR");

var $6rvcc = parcelRequire("6rvcc");

var $6neHm = parcelRequire("6neHm");

var $lTwRL = parcelRequire("lTwRL");

var $kXewy = parcelRequire("kXewy");
var $f7e37d6a1e1b71b5$var$_excluded = [
    "stableId"
], $f7e37d6a1e1b71b5$var$_excluded2 = [
    "api",
    "disableCurrentPageLogging",
    "loggingIntervalMillis",
    "loggingBufferMaxSize",
    "localMode",
    "eventLoggingApi",
    "eventLoggingApiForRetries",
    "disableLocalStorage",
    "ignoreWindowUndefined",
    "disableAllLogging",
    "initTimeoutMs",
    "disableNetworkKeepalive",
    "overrideStableID",
    "disableErrorLogging",
    "disableAutoMetricsLogging"
];
function $f7e37d6a1e1b71b5$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $f7e37d6a1e1b71b5$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $f7e37d6a1e1b71b5$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $6rvcc.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $f7e37d6a1e1b71b5$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $f7e37d6a1e1b71b5$export$d119b37e5f788b43 = function getOptionsWithDefaults(options) {
    return $f7e37d6a1e1b71b5$var$_objectSpread({
        /**
     * If more federal PerimeterTypes are added in the future, this should be updated so
     * that isFedRamp() === true always returns the strictest perimeter.
     */ perimeter: (0, $6neHm.isFedRamp)() ? (0, $kXewy.PerimeterType).FEDRAMP_MODERATE : (0, $kXewy.PerimeterType).COMMERCIAL
    }, options);
};
var $f7e37d6a1e1b71b5$export$fa1c2bbf4100b8bc = function shallowEquals(objectA, objectB) {
    if (!objectA && !objectB) return true;
    if (!objectA || !objectB) return false;
    var aEntries = Object.entries(objectA);
    var bEntries = Object.entries(objectB);
    if (aEntries.length !== bEntries.length) return false;
    var ascendingKeyOrder = function ascendingKeyOrder(_ref, _ref2) {
        var _ref3 = (0, $6mpGR.default)(_ref, 1), key1 = _ref3[0];
        var _ref4 = (0, $6mpGR.default)(_ref2, 1), key2 = _ref4[0];
        return key1.localeCompare(key2);
    };
    aEntries.sort(ascendingKeyOrder);
    bEntries.sort(ascendingKeyOrder);
    for(var i = 0; i < aEntries.length; i++){
        var _aEntries$i = (0, $6mpGR.default)(aEntries[i], 2), aValue = _aEntries$i[1];
        var _bEntries$i = (0, $6mpGR.default)(bEntries[i], 2), bValue = _bEntries$i[1];
        if (aValue !== bValue) return false;
    }
    return true;
};
var $f7e37d6a1e1b71b5$export$3dad1db244472f32 = function toStatsigUser(identifiers, customAttributes) {
    // Re-map `stableId` to `stableID` to match Statsig's native type.
    var stableId = identifiers.stableId, otherIdentifiers = (0, $kEBxa.default)(identifiers, $f7e37d6a1e1b71b5$var$_excluded);
    var user = {
        customIDs: $f7e37d6a1e1b71b5$var$_objectSpread($f7e37d6a1e1b71b5$var$_objectSpread({}, otherIdentifiers), stableId !== undefined ? {
            stableID: stableId
        } : {}),
        custom: customAttributes
    };
    if (identifiers.atlassianAccountId) user.userID = identifiers.atlassianAccountId;
    return user;
};
function $f7e37d6a1e1b71b5$export$1148cb79ceecd5fa(target) {
    for(var _len = arguments.length, sources = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)sources[_key - 1] = arguments[_key];
    if (!sources.length) return target;
    var source = sources.shift();
    if (source === undefined || source === null) return $f7e37d6a1e1b71b5$export$1148cb79ceecd5fa.apply(void 0, [
        target
    ].concat((0, $lp9qg.default)(sources)));
    for(var _i = 0, _Object$entries = Object.entries(source); _i < _Object$entries.length; _i++){
        var _Object$entries$_i = (0, $6mpGR.default)(_Object$entries[_i], 2), key = _Object$entries$_i[0], src = _Object$entries$_i[1];
        var dst = target[key];
        var srcIsObj = src && (0, $itFCD.default)(src) === 'object' && !Array.isArray(src);
        var dstIsObj = dst && (0, $itFCD.default)(dst) === 'object' && !Array.isArray(dst);
        if (srcIsObj && dstIsObj) target[key] = $f7e37d6a1e1b71b5$export$1148cb79ceecd5fa(dst, src);
        else target[key] = src;
    }
    return $f7e37d6a1e1b71b5$export$1148cb79ceecd5fa.apply(void 0, [
        target
    ].concat((0, $lp9qg.default)(sources)));
}
var $f7e37d6a1e1b71b5$export$202946b690d26d22 = function migrateInitializationOptions(options) {
    var api = options.api, disableCurrentPageLogging = options.disableCurrentPageLogging, loggingIntervalMillis = options.loggingIntervalMillis, loggingBufferMaxSize = options.loggingBufferMaxSize, localMode = options.localMode, eventLoggingApi = options.eventLoggingApi, eventLoggingApiForRetries = options.eventLoggingApiForRetries, disableLocalStorage = options.disableLocalStorage, ignoreWindowUndefined = options.ignoreWindowUndefined, disableAllLogging = options.disableAllLogging, _initTimeoutMs = options.initTimeoutMs, _disableNetworkKeepalive = options.disableNetworkKeepalive, _overrideStableID = options.overrideStableID, _disableErrorLogging = options.disableErrorLogging, _disableAutoMetricsLogging = options.disableAutoMetricsLogging, rest = (0, $kEBxa.default)(options, $f7e37d6a1e1b71b5$var$_excluded2);
    return $f7e37d6a1e1b71b5$var$_objectSpread($f7e37d6a1e1b71b5$var$_objectSpread({}, rest), {}, {
        networkConfig: {
            api: api,
            logEventUrl: eventLoggingApi ? eventLoggingApi + 'rgstr' : undefined,
            logEventFallbackUrls: eventLoggingApiForRetries ? [
                eventLoggingApiForRetries
            ] : undefined,
            preventAllNetworkTraffic: localMode || !ignoreWindowUndefined && typeof window === 'undefined'
        },
        includeCurrentPageUrlWithEvents: !disableCurrentPageLogging,
        loggingIntervalMs: loggingIntervalMillis,
        loggingBufferMaxSize: loggingBufferMaxSize,
        disableStorage: disableLocalStorage === undefined ? localMode : disableLocalStorage,
        disableLogging: disableAllLogging === undefined ? localMode : disableAllLogging
    });
};
var $f7e37d6a1e1b71b5$var$evaluationReasonMappings = Object.entries((0, $lTwRL.EvaluationReason)).map(function(_ref5) {
    var _ref6 = (0, $6mpGR.default)(_ref5, 2), key = _ref6[0], value = _ref6[1];
    return [
        key.toLowerCase(),
        value
    ];
});
var $f7e37d6a1e1b71b5$export$18ad168d3dbac899 = function migrateEvaluationDetails(details) {
    var _evaluationReasonMapp, _evaluationReasonMapp2, _details$receivedAt;
    var reasonLower = details.reason.toLowerCase();
    return {
        reason: (_evaluationReasonMapp = (_evaluationReasonMapp2 = $f7e37d6a1e1b71b5$var$evaluationReasonMappings.find(function(_ref7) {
            var _ref8 = (0, $6mpGR.default)(_ref7, 1), key = _ref8[0];
            return reasonLower.includes(key);
        })) === null || _evaluationReasonMapp2 === void 0 ? void 0 : _evaluationReasonMapp2[1]) !== null && _evaluationReasonMapp !== void 0 ? _evaluationReasonMapp : (0, $lTwRL.EvaluationReason).Unknown,
        time: (_details$receivedAt = details.receivedAt) !== null && _details$receivedAt !== void 0 ? _details$receivedAt : Date.now()
    };
};
var $f7e37d6a1e1b71b5$export$55fd683752d01e67 = function migrateSecondaryExposures(secondaryExposures) {
    return secondaryExposures.map(function(exposure) {
        if (typeof exposure === 'string') // This should ideally have gateValue and ruleID fields too, but it's not possible for us
        // to determine the correct values for these.
        return {
            gate: exposure
        };
        return exposure;
    });
};

});
parcelRegister("lp9qg", function(module, exports) {
$parcel$export(module.exports, "default", () => $f9533de737acad1f$export$2e2bcd8739ae039);

var $lVsf4 = parcelRequire("lVsf4");

var $keWez = parcelRequire("keWez");

var $d7D8H = parcelRequire("d7D8H");

var $2ORGh = parcelRequire("2ORGh");
function $f9533de737acad1f$export$2e2bcd8739ae039(r) {
    return (0, $lVsf4.default)(r) || (0, $keWez.default)(r) || (0, $d7D8H.default)(r) || (0, $2ORGh.default)();
}

});
parcelRegister("lVsf4", function(module, exports) {
$parcel$export(module.exports, "default", () => $ff64d423391a49bc$export$2e2bcd8739ae039);

var $gRW5H = parcelRequire("gRW5H");
function $ff64d423391a49bc$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return (0, $gRW5H.default)(r);
}

});

parcelRegister("keWez", function(module, exports) {
$parcel$export(module.exports, "default", () => $ebc24984e9960cfa$export$2e2bcd8739ae039);
function $ebc24984e9960cfa$export$2e2bcd8739ae039(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}

});

parcelRegister("2ORGh", function(module, exports) {
$parcel$export(module.exports, "default", () => $20d9e43395076adf$export$2e2bcd8739ae039);
function $20d9e43395076adf$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});


parcelRegister("6neHm", function(module, exports) {
$parcel$export(module.exports, "isFedRamp", () => $4a404ad4f3617d62$export$64d6499adf9b2e51);

var $lVXd4 = parcelRequire("lVXd4");
function $4a404ad4f3617d62$export$64d6499adf9b2e51() {
    var _global$location;
    var global = globalThis;
    // MICROS_PERIMETER is already used by few products, so we need to keep it for backward compatibility
    var env = global.MICROS_PERIMETER || global.UNSAFE_ATL_CONTEXT_BOUNDARY;
    if (env) return env === (0, $lVXd4.FEDRAMP_MODERATE);
    var matches = (_global$location = global.location) === null || _global$location === void 0 || (_global$location = _global$location.hostname) === null || _global$location === void 0 ? void 0 : _global$location.match(/atlassian-us-gov-mod\.(com|net)|atlassian-us-gov\.(com|net)|atlassian-fex\.(com|net)|atlassian-stg-fedm\.(com|net)/);
    return matches ? matches.length > 0 : false;
}

});
parcelRegister("lVXd4", function(module, exports) {
$parcel$export(module.exports, "FEDRAMP_MODERATE", () => $ff7cd9b475d1865a$export$ce553301d55c2fd8);
var $ff7cd9b475d1865a$export$ce553301d55c2fd8 = 'fedramp-moderate';
var $ff7cd9b475d1865a$export$f005e2e9f707cb5f = 'commercial';
var $ff7cd9b475d1865a$export$bd6b5a7802d76127 = 'fedramp-fedex';
var $ff7cd9b475d1865a$export$a739cd5aac835909 = 'stg';
var $ff7cd9b475d1865a$export$42dd0cdd351a4a9 = 'prod';
var $ff7cd9b475d1865a$export$404582bc18fe4d9e = 'dev';

});


parcelRegister("lTwRL", function(module, exports) {
$parcel$export(module.exports, "EvaluationReason", () => $ff083a9296dc486c$export$c62558b199e46828);
// Reference: https://github.com/statsig-io/js-lite/blob/main/src/StatsigStore.ts
var $ff083a9296dc486c$export$c62558b199e46828 = {
    // Order is important since the logic for migrating from a new client reason to an old one
    // returns the first which is a substring of the new client reason
    Error: 'Error',
    LocalOverride: 'LocalOverride',
    Unrecognized: 'Unrecognized',
    Uninitialized: 'Uninitialized',
    NetworkNotModified: 'NetworkNotModified',
    Network: 'Network',
    InvalidBootstrap: 'InvalidBootstrap',
    Bootstrap: 'Bootstrap',
    Cache: 'Cache',
    // For when we could not migrate the reason from the new client
    Unknown: 'Unknown'
}; // Reference: https://github.com/statsig-io/js-lite/blob/main/src/StatsigSDKOptions.ts

});

parcelRegister("kXewy", function(module, exports) {
$parcel$export(module.exports, "FeatureGateEnvironment", () => $f414957ec4356a3c$export$479e7351a733299);
$parcel$export(module.exports, "PerimeterType", () => $f414957ec4356a3c$export$c42b7bbc5e7ba555);
/**
 * The identifiers for the user. Options are restricted to the set that is currently supported.
 */ /**
 * Base client options. Does not include any options specific to providers
 * @interface BaseClientOptions
 * @property {FeatureGateEnvironment} environment - The environment for the client.
 * @property {string} targetApp - The target app for the client.
 * @property {AnalyticsWebClient} analyticsWebClient - The analytics web client.
 * @property {PerimeterType} perimeter - The perimeter for the client.
 */ /**
 * The options for the client.
 * @interface ClientOptions
 * @extends {BaseClientOptions}
 * @property {string} apiKey - The API key for the client.
 * @property {fetchTimeoutMs} fetchTimeoutMs - The timeout for the fetch request in milliseconds. Defaults to 5000.
 * @property {boolean} useGatewayURL - Whether to use the gateway URL. Defaults to false.
 */ /**
 * The custom attributes for the user.
 */ var $f414957ec4356a3c$export$479e7351a733299 = {
    Development: 'development',
    Staging: 'staging',
    Production: 'production'
};
var $f414957ec4356a3c$export$c42b7bbc5e7ba555 = {
    COMMERCIAL: 'commercial',
    FEDRAMP_MODERATE: 'fedramp-moderate'
};
var $f414957ec4356a3c$export$42f4885608027d0c = 'non_boolean'; // Type magic to get the JSDoc comments from the Client class methods to appear on the static
 // methods in FeatureGates where the property name and function type are identical

});



parcelRegister("I2vtT", function(module, exports) {
$parcel$export(module.exports, "Layer", () => $08460df73cdd027e$export$936d0764594b6eb3);

var $itFCD = parcelRequire("itFCD");

var $ja5yh = parcelRequire("ja5yh");

var $4gOTZ = parcelRequire("4gOTZ");

var $lhvkE = parcelRequire("lhvkE");
var $08460df73cdd027e$export$936d0764594b6eb3 = /*#__PURE__*/ function() {
    function Layer(name, layerValue, ruleID, evaluationDetails) {
        var logParameterFunction = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;
        var secondaryExposures = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : [];
        var undelegatedSecondaryExposures = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : [];
        var allocatedExperimentName = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : '';
        var explicitParameters = arguments.length > 8 && arguments[8] !== undefined ? arguments[8] : [];
        (0, $ja5yh.default)(this, Layer);
        this._logParameterFunction = logParameterFunction;
        this._name = name;
        this._value = JSON.parse(JSON.stringify(layerValue !== null && layerValue !== void 0 ? layerValue : {}));
        this._ruleID = ruleID !== null && ruleID !== void 0 ? ruleID : '';
        this._evaluationDetails = evaluationDetails;
        this._secondaryExposures = secondaryExposures;
        this._undelegatedSecondaryExposures = undelegatedSecondaryExposures;
        this._allocatedExperimentName = allocatedExperimentName;
        this._explicitParameters = explicitParameters;
    }
    return (0, $4gOTZ.default)(Layer, [
        {
            key: "get",
            value: function get(key, defaultValue, typeGuard) {
                var _this = this;
                var val = this._value[key];
                if (val == null) return defaultValue;
                var logAndReturn = function logAndReturn() {
                    _this._logLayerParameterExposure(key);
                    return val;
                };
                if (typeGuard) return typeGuard(val) ? logAndReturn() : defaultValue;
                if (defaultValue == null) return logAndReturn();
                if ((0, $itFCD.default)(val) === (0, $itFCD.default)(defaultValue) && Array.isArray(defaultValue) === Array.isArray(val)) return logAndReturn();
                return defaultValue;
            }
        },
        {
            key: "getValue",
            value: function getValue(key, defaultValue) {
                // eslint-disable-next-line eqeqeq
                if (defaultValue == undefined) defaultValue = null;
                var val = this._value[key];
                if (val != null) this._logLayerParameterExposure(key);
                return val !== null && val !== void 0 ? val : defaultValue;
            }
        },
        {
            key: "_logLayerParameterExposure",
            value: function _logLayerParameterExposure(parameterName) {
                var _this$_logParameterFu;
                (_this$_logParameterFu = this._logParameterFunction) === null || _this$_logParameterFu === void 0 || _this$_logParameterFu.call(this, this, parameterName);
            }
        }
    ], [
        {
            key: "fromLayer",
            value: function fromLayer(layer) {
                var _layer$__evaluation$s, _layer$__evaluation, _layer$__evaluation$u, _layer$__evaluation2, _layer$__evaluation3, _layer$__evaluation4;
                var value = new Layer(layer.name, layer.__value, layer.ruleID, (0, $lhvkE.migrateEvaluationDetails)(layer.details), function(_layer, parameterName) {
                    return layer.get(parameterName);
                }, (0, $lhvkE.migrateSecondaryExposures)((_layer$__evaluation$s = (_layer$__evaluation = layer.__evaluation) === null || _layer$__evaluation === void 0 ? void 0 : _layer$__evaluation.secondary_exposures) !== null && _layer$__evaluation$s !== void 0 ? _layer$__evaluation$s : []), (0, $lhvkE.migrateSecondaryExposures)((_layer$__evaluation$u = (_layer$__evaluation2 = layer.__evaluation) === null || _layer$__evaluation2 === void 0 ? void 0 : _layer$__evaluation2.undelegated_secondary_exposures) !== null && _layer$__evaluation$u !== void 0 ? _layer$__evaluation$u : []), (_layer$__evaluation3 = layer.__evaluation) === null || _layer$__evaluation3 === void 0 ? void 0 : _layer$__evaluation3.allocated_experiment_name, (_layer$__evaluation4 = layer.__evaluation) === null || _layer$__evaluation4 === void 0 ? void 0 : _layer$__evaluation4.explicit_parameters);
                return value;
            }
        }
    ]);
}();

});

parcelRegister("88RZX", function(module, exports) {
$parcel$export(module.exports, "default", () => $5ed8f4fff388c261$export$2e2bcd8739ae039);

var $6rvcc = parcelRequire("6rvcc");

var $dLmLT = parcelRequire("dLmLT");

var $ja5yh = parcelRequire("ja5yh");

var $4gOTZ = parcelRequire("4gOTZ");

var $dL89k = parcelRequire("dL89k");

var $kXewy = parcelRequire("kXewy");

var $l7Wmf = parcelRequire("l7Wmf");

var $faq4E = parcelRequire("faq4E");
function $5ed8f4fff388c261$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $5ed8f4fff388c261$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $5ed8f4fff388c261$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $6rvcc.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $5ed8f4fff388c261$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $5ed8f4fff388c261$var$DEFAULT_REQUEST_TIMEOUT_MS = 5000;
var $5ed8f4fff388c261$export$250a58ecde616daa = 'https://api.atlassian.com/flags';
var $5ed8f4fff388c261$export$942ba04389b0d5a2 = 'https://api.stg.atlassian.com/flags';
var $5ed8f4fff388c261$export$f058dbf75c3bc647 = 'https://api.dev.atlassian.com/flags';
var $5ed8f4fff388c261$export$1a401a0da8da3565 = 'https://api.stg.atlassian-us-gov-mod.com/flags';
var $5ed8f4fff388c261$export$18c93900db9358a4 = 'https://api.atlassian-us-gov-mod.com/flags';
var $5ed8f4fff388c261$export$4e8a0415edbfa1f7 = 'https://atlassian-statsig-proxy-archetype.atl-paas.%s.atl-ic.net';
var $5ed8f4fff388c261$export$cb3cd156f70d7e94 = 'oasis-stg.com/flags';
var $5ed8f4fff388c261$export$921fbc6cdfd4eee0 = 'atlassian-isolated.net/flags';
var $5ed8f4fff388c261$export$450bd8fb2a6d7ace = '/gateway/api/flags';
var $5ed8f4fff388c261$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function Fetcher() {
        (0, $ja5yh.default)(this, Fetcher);
    }
    return (0, $4gOTZ.default)(Fetcher, null, [
        {
            key: "fetchClientSdk",
            value: function() {
                var _fetchClientSdk = (0, $dLmLT.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dL89k))).mark(function _callee(fetcherOptions) {
                    var targetApp, url, _t;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($dL89k))).wrap(function(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                targetApp = fetcherOptions.targetApp;
                                url = "/api/v2/frontend/clientSdkKey/".concat(targetApp);
                                _context.prev = 1;
                                _context.next = 2;
                                return this.fetchRequest(url, 'GET', fetcherOptions);
                            case 2:
                                return _context.abrupt("return", _context.sent);
                            case 3:
                                _context.prev = 3;
                                _t = _context["catch"](1);
                                if (!(_t instanceof Error)) {
                                    _context.next = 4;
                                    break;
                                }
                                throw _t;
                            case 4:
                                throw Error('Failed to retrieve client sdk key');
                            case 5:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee, this, [
                        [
                            1,
                            3
                        ]
                    ]);
                }));
                function fetchClientSdk(_x) {
                    return _fetchClientSdk.apply(this, arguments);
                }
                return fetchClientSdk;
            }()
        },
        {
            key: "fetchExperimentValues",
            value: function() {
                var _fetchExperimentValues = (0, $dLmLT.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dL89k))).mark(function _callee2(fetcherOptions, identifiers, customAttributes) {
                    var requestBody, _t2;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($dL89k))).wrap(function(_context2) {
                        while(true)switch(_context2.prev = _context2.next){
                            case 0:
                                requestBody = {
                                    identifiers: identifiers,
                                    customAttributes: customAttributes,
                                    targetApp: fetcherOptions.targetApp
                                };
                                _context2.prev = 1;
                                _context2.next = 2;
                                return this.fetchRequest('/api/v2/frontend/experimentValues', 'POST', fetcherOptions, requestBody);
                            case 2:
                                return _context2.abrupt("return", _context2.sent);
                            case 3:
                                _context2.prev = 3;
                                _t2 = _context2["catch"](1);
                                if (!(_t2 instanceof Error)) {
                                    _context2.next = 4;
                                    break;
                                }
                                throw _t2;
                            case 4:
                                throw Error('Failed to retrieve experiment values');
                            case 5:
                            case "end":
                                return _context2.stop();
                        }
                    }, _callee2, this, [
                        [
                            1,
                            3
                        ]
                    ]);
                }));
                function fetchExperimentValues(_x2, _x3, _x4) {
                    return _fetchExperimentValues.apply(this, arguments);
                }
                return fetchExperimentValues;
            }()
        },
        {
            key: "handleResponseError",
            value: function() {
                var _handleResponseError = (0, $dLmLT.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dL89k))).mark(function _callee3(response) {
                    var body;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($dL89k))).wrap(function(_context3) {
                        while(true)switch(_context3.prev = _context3.next){
                            case 0:
                                if (response.ok) {
                                    _context3.next = 2;
                                    break;
                                }
                                _context3.next = 1;
                                return response.text();
                            case 1:
                                body = _context3.sent;
                                throw new (0, $faq4E.ResponseError)("Non 2xx response status received, status: ".concat(response.status, ", body: ").concat(JSON.stringify(body)));
                            case 2:
                                if (!(response.status === 204)) {
                                    _context3.next = 3;
                                    break;
                                }
                                throw new (0, $faq4E.ResponseError)('Unexpected 204 response');
                            case 3:
                            case "end":
                                return _context3.stop();
                        }
                    }, _callee3);
                }));
                function handleResponseError(_x5) {
                    return _handleResponseError.apply(this, arguments);
                }
                return handleResponseError;
            }()
        },
        {
            key: "extractResponseBody",
            value: function() {
                var _extractResponseBody = (0, $dLmLT.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dL89k))).mark(function _callee4(response) {
                    var value;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($dL89k))).wrap(function(_context4) {
                        while(true)switch(_context4.prev = _context4.next){
                            case 0:
                                _context4.next = 1;
                                return response.text();
                            case 1:
                                value = _context4.sent;
                                return _context4.abrupt("return", JSON.parse(value));
                            case 2:
                            case "end":
                                return _context4.stop();
                        }
                    }, _callee4);
                }));
                function extractResponseBody(_x6) {
                    return _extractResponseBody.apply(this, arguments);
                }
                return extractResponseBody;
            }()
        },
        {
            key: "getBaseUrl",
            value: function getBaseUrl(serviceEnv) {
                var useGatewayUrl = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
                var perimeter = arguments.length > 2 ? arguments[2] : undefined;
                var isolationContextId = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
                if (useGatewayUrl) return $5ed8f4fff388c261$export$450bd8fb2a6d7ace;
                if (perimeter === (0, $kXewy.PerimeterType).FEDRAMP_MODERATE) switch(serviceEnv){
                    case (0, $kXewy.FeatureGateEnvironment).Production:
                        return $5ed8f4fff388c261$export$18c93900db9358a4;
                    case (0, $kXewy.FeatureGateEnvironment).Staging:
                        return $5ed8f4fff388c261$export$1a401a0da8da3565;
                    default:
                        throw new Error("Invalid environment \"".concat(serviceEnv, "\" for \"").concat(perimeter, "\" perimeter"));
                }
                else if (perimeter === (0, $kXewy.PerimeterType).COMMERCIAL) switch(serviceEnv){
                    case (0, $kXewy.FeatureGateEnvironment).Development:
                        return $5ed8f4fff388c261$export$f058dbf75c3bc647;
                    case (0, $kXewy.FeatureGateEnvironment).Staging:
                        var apiUrl = this.getApiUrl(isolationContextId);
                        if (apiUrl !== null) return apiUrl;
                        return $5ed8f4fff388c261$export$942ba04389b0d5a2;
                    default:
                        var prodApiUrl = this.getApiUrl(isolationContextId);
                        if (prodApiUrl !== null) return prodApiUrl;
                        return $5ed8f4fff388c261$export$250a58ecde616daa;
                }
                else throw new Error("Invalid perimeter \"".concat(perimeter, "\""));
            }
        },
        {
            key: "fetchRequest",
            value: function() {
                var _fetchRequest = (0, $dLmLT.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dL89k))).mark(function _callee5(path, method, fetcherOptions, body) {
                    var baseUrl, fetchTimeout, abortSignal, abortController, response;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($dL89k))).wrap(function(_context5) {
                        while(true)switch(_context5.prev = _context5.next){
                            case 0:
                                baseUrl = Fetcher.getBaseUrl(fetcherOptions.environment, fetcherOptions.useGatewayURL, fetcherOptions.perimeter, fetcherOptions.isolationContextId);
                                fetchTimeout = fetcherOptions.fetchTimeoutMs || $5ed8f4fff388c261$var$DEFAULT_REQUEST_TIMEOUT_MS;
                                if (AbortSignal.timeout) abortSignal = AbortSignal.timeout(fetchTimeout);
                                else if (AbortController) {
                                    abortController = new AbortController();
                                    abortSignal = abortController.signal;
                                    setTimeout(function() {
                                        return abortController.abort();
                                    }, fetchTimeout);
                                }
                                _context5.next = 1;
                                return fetch("".concat(baseUrl).concat(path), $5ed8f4fff388c261$var$_objectSpread({
                                    method: method,
                                    headers: {
                                        'Content-Type': 'application/json',
                                        'X-Client-Name': 'feature-gate-js-client',
                                        'X-Client-Version': (0, $l7Wmf.CLIENT_VERSION),
                                        'X-API-KEY': fetcherOptions.apiKey
                                    },
                                    signal: abortSignal
                                }, body && {
                                    body: JSON.stringify(body)
                                }));
                            case 1:
                                response = _context5.sent;
                                _context5.next = 2;
                                return this.handleResponseError(response);
                            case 2:
                                _context5.next = 3;
                                return this.extractResponseBody(response);
                            case 3:
                                return _context5.abrupt("return", _context5.sent);
                            case 4:
                            case "end":
                                return _context5.stop();
                        }
                    }, _callee5, this);
                }));
                function fetchRequest(_x7, _x8, _x9, _x0) {
                    return _fetchRequest.apply(this, arguments);
                }
                return fetchRequest;
            }()
        },
        {
            key: "getApiUrl",
            value: function getApiUrl(isolationContextId) {
                var window1 = this.getWindowLocation();
                if (window1 === undefined) {
                    //this is needed when this SDK is used for SSR or plugin use cases where secret keys not available to use backend SDKs
                    if (!isolationContextId) return null;
                    return $5ed8f4fff388c261$export$4e8a0415edbfa1f7.replace('%s', isolationContextId);
                }
                var protocol = window1.protocol, hostname = window1.hostname;
                // Match last subdomain fragment before oasis-stg.com
                var oasisMatch = hostname.match(/([^.]+)\.oasis-stg\.com$/);
                if (oasisMatch) return "".concat(protocol, "//api.").concat(oasisMatch[1], ".").concat($5ed8f4fff388c261$export$cb3cd156f70d7e94);
                // Match last subdomain fragment before atlassian-isolated.net
                var isolatedMatch = hostname.match(/([^.]+)\.atlassian-isolated\.net$/);
                if (isolatedMatch) return "".concat(protocol, "//api.").concat(isolatedMatch[1], ".").concat($5ed8f4fff388c261$export$921fbc6cdfd4eee0);
                return null;
            }
        },
        {
            key: "getWindowLocation",
            value: function getWindowLocation() {
                if (typeof window !== 'undefined' && window.location) return window.location;
                return undefined;
            }
        }
    ]);
}();

});
parcelRegister("l7Wmf", function(module, exports) {
$parcel$export(module.exports, "CLIENT_VERSION", () => $f6178518918adac1$export$a59f8d67326bd1cb);
/// <reference types="node" />
var $f6178518918adac1$export$a59f8d67326bd1cb = "5.8.0";

});

parcelRegister("faq4E", function(module, exports) {
$parcel$export(module.exports, "ResponseError", () => $b0ac03f6c393b27c$export$286baf652d0b1206);

var $4gOTZ = parcelRequire("4gOTZ");

var $ja5yh = parcelRequire("ja5yh");

var $1kOKH = parcelRequire("1kOKH");

var $5dlJq = parcelRequire("5dlJq");

var $gBaoS = parcelRequire("gBaoS");

var $hh1IO = parcelRequire("hh1IO");
function $b0ac03f6c393b27c$var$_callSuper(t, o, e) {
    return o = (0, $5dlJq.default)(o), (0, $1kOKH.default)(t, $b0ac03f6c393b27c$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, $5dlJq.default)(t).constructor) : o.apply(t, e));
}
function $b0ac03f6c393b27c$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($b0ac03f6c393b27c$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $b0ac03f6c393b27c$export$286baf652d0b1206 = /*#__PURE__*/ function(_Error) {
    function ResponseError(message) {
        (0, $ja5yh.default)(this, ResponseError);
        return $b0ac03f6c393b27c$var$_callSuper(this, ResponseError, [
            message
        ]);
    }
    (0, $gBaoS.default)(ResponseError, _Error);
    return (0, $4gOTZ.default)(ResponseError);
}(/*#__PURE__*/ (0, $hh1IO.default)(Error));

});
parcelRegister("1kOKH", function(module, exports) {
$parcel$export(module.exports, "default", () => $0f8f070bd95116c3$export$2e2bcd8739ae039);

var $itFCD = parcelRequire("itFCD");

var $akl3K = parcelRequire("akl3K");
function $0f8f070bd95116c3$export$2e2bcd8739ae039(t, e) {
    if (e && ("object" == (0, $itFCD.default)(e) || "function" == typeof e)) return e;
    if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
    return (0, $akl3K.default)(t);
}

});
parcelRegister("akl3K", function(module, exports) {
$parcel$export(module.exports, "default", () => $784c1b9d3aa9be81$export$2e2bcd8739ae039);
function $784c1b9d3aa9be81$export$2e2bcd8739ae039(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
}

});


parcelRegister("5dlJq", function(module, exports) {
$parcel$export(module.exports, "default", () => $3cbf06176c324783$export$2e2bcd8739ae039);
function $3cbf06176c324783$export$2e2bcd8739ae039(t) {
    return $3cbf06176c324783$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
        return t.__proto__ || Object.getPrototypeOf(t);
    }, $3cbf06176c324783$export$2e2bcd8739ae039(t);
}

});

parcelRegister("gBaoS", function(module, exports) {
$parcel$export(module.exports, "default", () => $c1582b5578e8f64d$export$2e2bcd8739ae039);

var $iwHv4 = parcelRequire("iwHv4");
function $c1582b5578e8f64d$export$2e2bcd8739ae039(t, e) {
    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
    t.prototype = Object.create(e && e.prototype, {
        constructor: {
            value: t,
            writable: !0,
            configurable: !0
        }
    }), Object.defineProperty(t, "prototype", {
        writable: !1
    }), e && (0, $iwHv4.default)(t, e);
}

});
parcelRegister("iwHv4", function(module, exports) {
$parcel$export(module.exports, "default", () => $d7ccf559ebba3b30$export$2e2bcd8739ae039);
function $d7ccf559ebba3b30$export$2e2bcd8739ae039(t, e) {
    return $d7ccf559ebba3b30$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, $d7ccf559ebba3b30$export$2e2bcd8739ae039(t, e);
}

});


parcelRegister("hh1IO", function(module, exports) {
$parcel$export(module.exports, "default", () => $c9355c198f31bd3c$export$2e2bcd8739ae039);

var $5dlJq = parcelRequire("5dlJq");

var $iwHv4 = parcelRequire("iwHv4");

var $kgk56 = parcelRequire("kgk56");

var $lyCcN = parcelRequire("lyCcN");
function $c9355c198f31bd3c$export$2e2bcd8739ae039(t) {
    var r = "function" == typeof Map ? new Map() : void 0;
    return $c9355c198f31bd3c$export$2e2bcd8739ae039 = function _wrapNativeSuper(t) {
        if (null === t || !(0, $kgk56.default)(t)) return t;
        if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function");
        if (void 0 !== r) {
            if (r.has(t)) return r.get(t);
            r.set(t, Wrapper);
        }
        function Wrapper() {
            return (0, $lyCcN.default)(t, arguments, (0, $5dlJq.default)(this).constructor);
        }
        return Wrapper.prototype = Object.create(t.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: !1,
                writable: !0,
                configurable: !0
            }
        }), (0, $iwHv4.default)(Wrapper, t);
    }, $c9355c198f31bd3c$export$2e2bcd8739ae039(t);
}

});
parcelRegister("kgk56", function(module, exports) {
$parcel$export(module.exports, "default", () => $ec04e1048269ac93$export$2e2bcd8739ae039);
function $ec04e1048269ac93$export$2e2bcd8739ae039(t) {
    try {
        return -1 !== Function.toString.call(t).indexOf("[native code]");
    } catch (n) {
        return "function" == typeof t;
    }
}

});

parcelRegister("lyCcN", function(module, exports) {
$parcel$export(module.exports, "default", () => $fb1a68b9fb0306e5$export$2e2bcd8739ae039);

var $lhcmI = parcelRequire("lhcmI");

var $iwHv4 = parcelRequire("iwHv4");
function $fb1a68b9fb0306e5$export$2e2bcd8739ae039(t, e, r) {
    if ((0, $lhcmI.default)()) return Reflect.construct.apply(null, arguments);
    var o = [
        null
    ];
    o.push.apply(o, e);
    var p = new (t.bind.apply(t, o))();
    return r && (0, $iwHv4.default)(p, r.prototype), p;
}

});
parcelRegister("lhcmI", function(module, exports) {
$parcel$export(module.exports, "default", () => $f7d4c700316897b7$export$2e2bcd8739ae039);
function $f7d4c700316897b7$export$2e2bcd8739ae039() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($f7d4c700316897b7$export$2e2bcd8739ae039 = function _isNativeReflectConstruct() {
        return !!t;
    })();
}

});





parcelRegister("Obu4B", function(module, exports) {
$parcel$export(module.exports, "NoFetchDataAdapter", () => $096d941ecf1b8e11$export$55fffef3474104af);

var $dLmLT = parcelRequire("dLmLT");

var $ja5yh = parcelRequire("ja5yh");

var $4gOTZ = parcelRequire("4gOTZ");

var $1kOKH = parcelRequire("1kOKH");

var $5dlJq = parcelRequire("5dlJq");

var $7wexr = parcelRequire("7wexr");

var $gBaoS = parcelRequire("gBaoS");

var $6rvcc = parcelRequire("6rvcc");

var $dL89k = parcelRequire("dL89k");

var $iFR7a = parcelRequire("iFR7a");
function $096d941ecf1b8e11$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $096d941ecf1b8e11$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $096d941ecf1b8e11$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $6rvcc.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $096d941ecf1b8e11$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $096d941ecf1b8e11$var$_callSuper(t, o, e) {
    return o = (0, $5dlJq.default)(o), (0, $1kOKH.default)(t, $096d941ecf1b8e11$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, $5dlJq.default)(t).constructor) : o.apply(t, e));
}
function $096d941ecf1b8e11$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($096d941ecf1b8e11$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $096d941ecf1b8e11$var$_superPropGet(t, o, e, r) {
    var p = (0, $7wexr.default)((0, $5dlJq.default)(1 & r ? t.prototype : t), o, e);
    return 2 & r && "function" == typeof p ? function(t) {
        return p.apply(e, t);
    } : p;
}
var $096d941ecf1b8e11$export$55fffef3474104af = /*#__PURE__*/ function(_DataAdapterCore) {
    function NoFetchDataAdapter() {
        var _this;
        (0, $ja5yh.default)(this, NoFetchDataAdapter);
        _this = $096d941ecf1b8e11$var$_callSuper(this, NoFetchDataAdapter, [
            'NoFetchDataAdapter',
            'nofetch'
        ]);
        (0, $6rvcc.default)(_this, "bootstrapResult", null);
        return _this;
    }
    /**
   * Make sure to call this **before** calling `initializeAsync` or `updateUserAsync` but
   * after the Statsig client has been created!
   */ (0, $gBaoS.default)(NoFetchDataAdapter, _DataAdapterCore);
    return (0, $4gOTZ.default)(NoFetchDataAdapter, [
        {
            key: "setBootstrapData",
            value: function setBootstrapData(data) {
                this.bootstrapResult = data ? {
                    source: 'Bootstrap',
                    data: JSON.stringify(data),
                    receivedAt: Date.now(),
                    stableID: (0, $iFR7a.StableID).get(this._getSdkKey()),
                    fullUserHash: null
                } : null;
            }
        },
        {
            key: "prefetchData",
            value: function() {
                var _prefetchData = (0, $dLmLT.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dL89k))).mark(function _callee(_user, _options) {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($dL89k))).wrap(function(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee);
                }));
                function prefetchData(_x, _x2) {
                    return _prefetchData.apply(this, arguments);
                }
                return prefetchData;
            }()
        },
        {
            key: "getDataAsync",
            value: function() {
                var _getDataAsync = (0, $dLmLT.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dL89k))).mark(function _callee2(_current, user, _options) {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($dL89k))).wrap(function(_context2) {
                        while(true)switch(_context2.prev = _context2.next){
                            case 0:
                                return _context2.abrupt("return", this.bootstrapResult && $096d941ecf1b8e11$var$_objectSpread($096d941ecf1b8e11$var$_objectSpread({}, this.bootstrapResult), {}, {
                                    fullUserHash: (0, $iFR7a._getFullUserHash)(user)
                                }));
                            case 1:
                            case "end":
                                return _context2.stop();
                        }
                    }, _callee2, this);
                }));
                function getDataAsync(_x3, _x4, _x5) {
                    return _getDataAsync.apply(this, arguments);
                }
                return getDataAsync;
            }()
        },
        {
            key: "getDataSync",
            value: function getDataSync(user) {
                return this.bootstrapResult && $096d941ecf1b8e11$var$_objectSpread($096d941ecf1b8e11$var$_objectSpread({}, this.bootstrapResult), {}, {
                    fullUserHash: (0, $iFR7a._getFullUserHash)(user)
                });
            }
        },
        {
            key: "_fetchFromNetwork",
            value: function() {
                var _fetchFromNetwork2 = (0, $dLmLT.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dL89k))).mark(function _callee3(_current, _user, _options) {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($dL89k))).wrap(function(_context3) {
                        while(true)switch(_context3.prev = _context3.next){
                            case 0:
                                return _context3.abrupt("return", null);
                            case 1:
                            case "end":
                                return _context3.stop();
                        }
                    }, _callee3);
                }));
                function _fetchFromNetwork(_x6, _x7, _x8) {
                    return _fetchFromNetwork2.apply(this, arguments);
                }
                return _fetchFromNetwork;
            }()
        },
        {
            key: "_getCacheKey",
            value: function _getCacheKey(user) {
                // Same logic as default data adapter
                // https://github.com/statsig-io/js-client-monorepo/blob/main/packages/js-client/src/StatsigEvaluationsDataAdapter.ts
                var key = (0, $iFR7a._getStorageKey)(this._getSdkKey(), user);
                return "".concat((0, $iFR7a.DataAdapterCachePrefix), ".").concat(this._cacheSuffix, ".").concat(key);
            }
        },
        {
            key: "_isCachedResultValidFor204",
            value: function _isCachedResultValidFor204(_result, _user) {
                return false;
            }
        },
        {
            key: "setDataLegacy",
            value: function setDataLegacy(data, user) {
                $096d941ecf1b8e11$var$_superPropGet(NoFetchDataAdapter, "setData", this, 3)([
                    data,
                    user
                ]);
            }
        },
        {
            key: "toJSON",
            value: function toJSON() {
                var result = $096d941ecf1b8e11$var$_objectSpread({}, this);
                delete result._options;
                delete result._inMemoryCache;
                delete result.bootstrapResult;
                return result;
            }
        }
    ]);
}((0, $iFR7a.DataAdapterCore));

});
parcelRegister("7wexr", function(module, exports) {
$parcel$export(module.exports, "default", () => $5796cc8eb3a82184$export$2e2bcd8739ae039);

var $6MNuk = parcelRequire("6MNuk");
function $5796cc8eb3a82184$export$2e2bcd8739ae039() {
    return $5796cc8eb3a82184$export$2e2bcd8739ae039 = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function(e, t, r) {
        var p = (0, $6MNuk.default)(e, t);
        if (p) {
            var n = Object.getOwnPropertyDescriptor(p, t);
            return n.get ? n.get.call(arguments.length < 3 ? e : r) : n.value;
        }
    }, $5796cc8eb3a82184$export$2e2bcd8739ae039.apply(null, arguments);
}

});
parcelRegister("6MNuk", function(module, exports) {
$parcel$export(module.exports, "default", () => $4f0d9d15c66bfdb0$export$2e2bcd8739ae039);

var $5dlJq = parcelRequire("5dlJq");
function $4f0d9d15c66bfdb0$export$2e2bcd8739ae039(t, o) {
    for(; !({}).hasOwnProperty.call(t, o) && null !== (t = (0, $5dlJq.default)(t)););
    return t;
}

});



parcelRegister("l8qYn", function(module, exports) {
$parcel$export(module.exports, "LOCAL_STORAGE_KEY", () => $f62f449075088262$export$d8474cff104280f3);
$parcel$export(module.exports, "PersistentOverrideAdapter", () => $f62f449075088262$export$bcb28fbac1def494);

var $6rvcc = parcelRequire("6rvcc");

var $6mpGR = parcelRequire("6mpGR");

var $ja5yh = parcelRequire("ja5yh");

var $4gOTZ = parcelRequire("4gOTZ");

var $dtn6l = parcelRequire("dtn6l");
function $f62f449075088262$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $f62f449075088262$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $f62f449075088262$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $6rvcc.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $f62f449075088262$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $f62f449075088262$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $f62f449075088262$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $f62f449075088262$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $f62f449075088262$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $f62f449075088262$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $f62f449075088262$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
var $f62f449075088262$var$LOCAL_OVERRIDE_REASON = 'LocalOverride:Recognized';
var $f62f449075088262$export$d8474cff104280f3 = 'STATSIG_OVERRIDES';
var $f62f449075088262$var$LEGACY_LOCAL_STORAGE_KEY = 'STATSIG_JS_LITE_LOCAL_OVERRIDES';
var $f62f449075088262$var$makeEmptyStore = function makeEmptyStore() {
    return {
        gates: {},
        configs: {},
        layers: {}
    };
};
var $f62f449075088262$var$djb2MapKey = function djb2MapKey(hash, kind) {
    return kind + ':' + hash;
};
var $f62f449075088262$export$bcb28fbac1def494 = /*#__PURE__*/ function() {
    function PersistentOverrideAdapter(localStorageKey) {
        (0, $ja5yh.default)(this, PersistentOverrideAdapter);
        this._overrides = $f62f449075088262$var$makeEmptyStore();
        this._djb2Map = new Map();
        this._localStorageKey = localStorageKey;
    }
    return (0, $4gOTZ.default)(PersistentOverrideAdapter, [
        {
            key: "parseStoredOverrides",
            value: function parseStoredOverrides(localStorageKey) {
                try {
                    var json = window.localStorage.getItem(localStorageKey);
                    if (!json) return $f62f449075088262$var$makeEmptyStore();
                    return JSON.parse(json);
                } catch (_unused) {
                    return $f62f449075088262$var$makeEmptyStore();
                }
            }
        },
        {
            key: "mergeOverrides",
            value: function mergeOverrides() {
                var merged = $f62f449075088262$var$makeEmptyStore();
                for(var _len = arguments.length, allOverrides = new Array(_len), _key = 0; _key < _len; _key++)allOverrides[_key] = arguments[_key];
                for(var _i = 0, _allOverrides = allOverrides; _i < _allOverrides.length; _i++){
                    var overrides = _allOverrides[_i];
                    for(var _i2 = 0, _Object$entries = Object.entries((_overrides$gates = overrides.gates) !== null && _overrides$gates !== void 0 ? _overrides$gates : {}); _i2 < _Object$entries.length; _i2++){
                        var _overrides$gates;
                        var _Object$entries$_i = (0, $6mpGR.default)(_Object$entries[_i2], 2), name = _Object$entries$_i[0], value = _Object$entries$_i[1];
                        merged.gates[name] = value;
                    }
                    for(var _i3 = 0, _Object$entries2 = Object.entries((_overrides$configs = overrides.configs) !== null && _overrides$configs !== void 0 ? _overrides$configs : {}); _i3 < _Object$entries2.length; _i3++){
                        var _overrides$configs;
                        var _Object$entries2$_i = (0, $6mpGR.default)(_Object$entries2[_i3], 2), _name = _Object$entries2$_i[0], _value = _Object$entries2$_i[1];
                        merged.configs[_name] = _value;
                    }
                    for(var _i4 = 0, _Object$entries3 = Object.entries((_overrides$layers = overrides.layers) !== null && _overrides$layers !== void 0 ? _overrides$layers : {}); _i4 < _Object$entries3.length; _i4++){
                        var _overrides$layers;
                        var _Object$entries3$_i = (0, $6mpGR.default)(_Object$entries3[_i4], 2), _name2 = _Object$entries3$_i[0], _value2 = _Object$entries3$_i[1];
                        merged.layers[_name2] = _value2;
                    }
                }
                return merged;
            }
        },
        {
            key: "initFromStoredOverrides",
            value: function initFromStoredOverrides() {
                var storedOverrides = this.mergeOverrides(this._overrides, this.parseStoredOverrides($f62f449075088262$var$LEGACY_LOCAL_STORAGE_KEY), this.parseStoredOverrides(this._localStorageKey));
                // Clear data from legacy local storage key now we've read from it.
                // This prevents things being stuck in there that are always read but never written to.
                try {
                    window.localStorage.removeItem($f62f449075088262$var$LEGACY_LOCAL_STORAGE_KEY);
                } catch (_unused2) {
                // ignored - window is not defined in non-browser environments, and we don't save things there
                // (things like SSR, etc)
                }
                // In version 4.24.0 we introduced hashes in this override adapter, but had a bug which would cause
                // multiple hashes to continue being created. This code here removes these hashes since we've moved
                // to using a more reliable and easier to maintain map in `_djb2Map`.
                for(var _i5 = 0, _Object$values = Object.values(storedOverrides); _i5 < _Object$values.length; _i5++){
                    var container = _Object$values[_i5];
                    var allKeys = new Set(Object.keys(container));
                    var _iterator = $f62f449075088262$var$_createForOfIteratorHelper(allKeys), _step;
                    try {
                        for(_iterator.s(); !(_step = _iterator.n()).done;){
                            var name = _step.value;
                            var hash = (0, $dtn6l._DJB2)(name);
                            if (allKeys.has(hash)) delete container[hash];
                        }
                    } catch (err) {
                        _iterator.e(err);
                    } finally{
                        _iterator.f();
                    }
                }
                this.applyOverrides(storedOverrides);
            }
        },
        {
            key: "saveOverrides",
            value: function saveOverrides() {
                try {
                    window.localStorage.setItem(this._localStorageKey, JSON.stringify(this._overrides));
                } catch (_unused3) {
                // ignored - window is not defined in non-browser environments, and we don't save things there
                // (things like SSR, etc)
                }
            }
        },
        {
            key: "getOverrides",
            value: function getOverrides() {
                return this.mergeOverrides(this._overrides);
            }
        },
        {
            key: "applyOverrides",
            value: function applyOverrides(overrides) {
                var newOverrides = $f62f449075088262$var$_objectSpread($f62f449075088262$var$_objectSpread({}, $f62f449075088262$var$makeEmptyStore()), overrides);
                this._djb2Map.clear();
                for(var _i6 = 0, _Object$entries4 = Object.entries(newOverrides); _i6 < _Object$entries4.length; _i6++){
                    var _Object$entries4$_i = (0, $6mpGR.default)(_Object$entries4[_i6], 2), containerName = _Object$entries4$_i[0], container = _Object$entries4$_i[1];
                    for(var _i7 = 0, _Object$entries5 = Object.entries(container); _i7 < _Object$entries5.length; _i7++){
                        var _Object$entries5$_i = (0, $6mpGR.default)(_Object$entries5[_i7], 2), name = _Object$entries5$_i[0], value = _Object$entries5$_i[1];
                        this._djb2Map.set($f62f449075088262$var$djb2MapKey((0, $dtn6l._DJB2)(name), containerName), value);
                    }
                }
                this._overrides = newOverrides;
            }
        },
        {
            key: "setOverrides",
            value: function setOverrides(overrides) {
                this.applyOverrides(overrides);
                this.saveOverrides();
            }
        },
        {
            key: "overrideGate",
            value: function overrideGate(name, value) {
                this._overrides.gates[name] = value;
                this._djb2Map.set($f62f449075088262$var$djb2MapKey((0, $dtn6l._DJB2)(name), 'gates'), value);
                this.saveOverrides();
            }
        },
        {
            key: "removeGateOverride",
            value: function removeGateOverride(name) {
                delete this._overrides.gates[name];
                this._djb2Map.delete($f62f449075088262$var$djb2MapKey((0, $dtn6l._DJB2)(name), 'gates'));
                this.saveOverrides();
            }
        },
        {
            key: "getGateOverride",
            value: function getGateOverride(current, _user) {
                var _this$_overrides$gate;
                var overridden = (_this$_overrides$gate = this._overrides.gates[current.name]) !== null && _this$_overrides$gate !== void 0 ? _this$_overrides$gate : this._djb2Map.get($f62f449075088262$var$djb2MapKey(current.name, 'gates'));
                if (overridden == null) return null;
                return $f62f449075088262$var$_objectSpread($f62f449075088262$var$_objectSpread({}, current), {}, {
                    value: overridden,
                    details: $f62f449075088262$var$_objectSpread($f62f449075088262$var$_objectSpread({}, current.details), {}, {
                        reason: $f62f449075088262$var$LOCAL_OVERRIDE_REASON
                    })
                });
            }
        },
        {
            key: "overrideDynamicConfig",
            value: function overrideDynamicConfig(name, value) {
                this._overrides.configs[name] = value;
                this._djb2Map.set($f62f449075088262$var$djb2MapKey((0, $dtn6l._DJB2)(name), 'configs'), value);
                this.saveOverrides();
            }
        },
        {
            key: "removeDynamicConfigOverride",
            value: function removeDynamicConfigOverride(name) {
                delete this._overrides.configs[name];
                this._djb2Map.delete($f62f449075088262$var$djb2MapKey((0, $dtn6l._DJB2)(name), 'configs'));
                this.saveOverrides();
            }
        },
        {
            key: "getDynamicConfigOverride",
            value: function getDynamicConfigOverride(current, _user) {
                return this._getConfigOverride(current, this._overrides.configs);
            }
        },
        {
            key: "overrideExperiment",
            value: function overrideExperiment(name, value) {
                this._overrides.configs[name] = value;
                this._djb2Map.set($f62f449075088262$var$djb2MapKey((0, $dtn6l._DJB2)(name), 'configs'), value);
                this.saveOverrides();
            }
        },
        {
            key: "removeExperimentOverride",
            value: function removeExperimentOverride(name) {
                delete this._overrides.configs[name];
                this._djb2Map.delete($f62f449075088262$var$djb2MapKey((0, $dtn6l._DJB2)(name), 'configs'));
                this.saveOverrides();
            }
        },
        {
            key: "getExperimentOverride",
            value: function getExperimentOverride(current, _user) {
                return this._getConfigOverride(current, this._overrides.configs);
            }
        },
        {
            key: "overrideLayer",
            value: function overrideLayer(name, value) {
                this._overrides.layers[name] = value;
                this._djb2Map.set($f62f449075088262$var$djb2MapKey((0, $dtn6l._DJB2)(name), 'layers'), value);
                this.saveOverrides();
            }
        },
        {
            key: "removeLayerOverride",
            value: function removeLayerOverride(name) {
                delete this._overrides.layers[name];
                this._djb2Map.delete($f62f449075088262$var$djb2MapKey((0, $dtn6l._DJB2)(name), 'layers'));
                this.saveOverrides();
            }
        },
        {
            key: "removeAllOverrides",
            value: function removeAllOverrides() {
                this._overrides = $f62f449075088262$var$makeEmptyStore();
                try {
                    window.localStorage.removeItem(this._localStorageKey);
                } catch (_unused4) {
                // ignored - window is not defined in non-browser environments, and we don't save things there
                // (things like SSR, etc)
                }
            }
        },
        {
            key: "getLayerOverride",
            value: function getLayerOverride(current, _user) {
                var _this$_overrides$laye;
                var overridden = (_this$_overrides$laye = this._overrides.layers[current.name]) !== null && _this$_overrides$laye !== void 0 ? _this$_overrides$laye : this._djb2Map.get($f62f449075088262$var$djb2MapKey(current.name, 'layers'));
                if (overridden == null) return null;
                return $f62f449075088262$var$_objectSpread($f62f449075088262$var$_objectSpread({}, current), {}, {
                    __value: overridden,
                    get: (0, $dtn6l._makeTypedGet)(current.name, overridden),
                    details: $f62f449075088262$var$_objectSpread($f62f449075088262$var$_objectSpread({}, current.details), {}, {
                        reason: $f62f449075088262$var$LOCAL_OVERRIDE_REASON
                    })
                });
            }
        },
        {
            key: "_getConfigOverride",
            value: function _getConfigOverride(current, lookup) {
                var _lookup$current$name;
                var overridden = (_lookup$current$name = lookup[current.name]) !== null && _lookup$current$name !== void 0 ? _lookup$current$name : this._djb2Map.get($f62f449075088262$var$djb2MapKey(current.name, 'configs'));
                if (overridden == null) return null;
                return $f62f449075088262$var$_objectSpread($f62f449075088262$var$_objectSpread({}, current), {}, {
                    value: overridden,
                    get: (0, $dtn6l._makeTypedGet)(current.name, overridden),
                    details: $f62f449075088262$var$_objectSpread($f62f449075088262$var$_objectSpread({}, current.details), {}, {
                        reason: $f62f449075088262$var$LOCAL_OVERRIDE_REASON
                    })
                });
            }
        }
    ]);
}();

});



parcelRegister("bzNvu", function(module, exports) {
$parcel$export(module.exports, "debug", () => $86d95d9dc2aab466$export$1c9f709888824e05);
var $86d95d9dc2aab466$var$_process, $86d95d9dc2aab466$var$_process2;
// We can't rely on NODE_ENV === 'test' if its value is already configured by the consumer to some other value, so better to use JEST_WORKER_ID
// https://jestjs.io/docs/environment-variables#jest_worker_id
var $86d95d9dc2aab466$var$TESTS_MODE = (globalThis === null || globalThis === void 0 || ($86d95d9dc2aab466$var$_process = globalThis.process) === null || $86d95d9dc2aab466$var$_process === void 0 || ($86d95d9dc2aab466$var$_process = $86d95d9dc2aab466$var$_process.env) === null || $86d95d9dc2aab466$var$_process === void 0 ? void 0 : $86d95d9dc2aab466$var$_process.JEST_WORKER_ID) !== undefined;
var $86d95d9dc2aab466$var$DEBUG_MODE = !$86d95d9dc2aab466$var$TESTS_MODE && (globalThis === null || globalThis === void 0 || ($86d95d9dc2aab466$var$_process2 = globalThis.process) === null || $86d95d9dc2aab466$var$_process2 === void 0 || ($86d95d9dc2aab466$var$_process2 = $86d95d9dc2aab466$var$_process2.env) === null || $86d95d9dc2aab466$var$_process2 === void 0 ? void 0 : $86d95d9dc2aab466$var$_process2.NODE_ENV) !== 'production';
var $86d95d9dc2aab466$export$1c9f709888824e05 = function debug() {
    var _console;
    if (!$86d95d9dc2aab466$var$DEBUG_MODE) return;
    // eslint-disable-next-line no-console
    (_console = console).debug.apply(_console, arguments);
};

});

parcelRegister("1gj4Y", function(module, exports) {
$parcel$export(module.exports, "ENV_ENABLE_PLATFORM_FF", () => $0eb615cb42faa2af$export$b574c24e1e6490f5);

var $7a4c1 = parcelRequire("7a4c1");
var $0eb615cb42faa2af$export$b574c24e1e6490f5 = (0, $7a4c1.hasProcessEnv) ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;

});
parcelRegister("7a4c1", function(module, exports) {
$parcel$export(module.exports, "PFF_GLOBAL_KEY", () => $536cb831d430f02c$export$7e41b1b2bdee3f98);
$parcel$export(module.exports, "pkgName", () => $536cb831d430f02c$export$407f05df8e3ce9f3);
$parcel$export(module.exports, "hasProcessEnv", () => $536cb831d430f02c$export$75f4a1454eff2805);

var $3ZMUU = parcelRequire("3ZMUU");
var $536cb831d430f02c$export$7e41b1b2bdee3f98 = '__PLATFORM_FEATURE_FLAGS__';
var $536cb831d430f02c$export$407f05df8e3ce9f3 = '@atlaskit/platform-feature-flags';
var $536cb831d430f02c$export$75f4a1454eff2805 = typeof $3ZMUU !== 'undefined' && typeof $3ZMUU.env !== 'undefined';

});


parcelRegister("cThjD", function(module, exports) {
$parcel$export(module.exports, "ENV_STORYBOOK_ENABLE_PLATFORM_FF", () => $96280da061cae4ae$export$92f8b531feaeb23d);

var $7a4c1 = parcelRequire("7a4c1");
var $96280da061cae4ae$export$92f8b531feaeb23d = (0, $7a4c1.hasProcessEnv) ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;

});

parcelRegister("9oJez", function(module, exports) {
$parcel$export(module.exports, "globalVar", () => $6d79717bae38a044$export$54ea85357b4e0159);

var $7a4c1 = parcelRequire("7a4c1");
var $6d79717bae38a044$var$DEFAULT_PFF_GLOBAL = {
    booleanResolver: undefined
};
var $6d79717bae38a044$export$54ea85357b4e0159 = typeof window !== 'undefined' ? window : globalThis;
$6d79717bae38a044$export$54ea85357b4e0159[0, $7a4c1.PFF_GLOBAL_KEY] = $6d79717bae38a044$export$54ea85357b4e0159[0, $7a4c1.PFF_GLOBAL_KEY] || $6d79717bae38a044$var$DEFAULT_PFF_GLOBAL;

});



parcelRegister("7Nwkx", function(module, exports) {
$parcel$export(module.exports, "NOOP", () => $5ad6301d2094590b$export$5702a91a6f42969f);
// 90% of expiry
// eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
const $5ad6301d2094590b$export$5702a91a6f42969f = ()=>{};

});


parcelRegister("cMwGH", function(module, exports) {
$parcel$export(module.exports, "default", () => $94e352d257707d44$export$2e2bcd8739ae039);

var $eXTjr = parcelRequire("eXTjr");

var $5eu7g = parcelRequire("5eu7g");
class $94e352d257707d44$export$2e2bcd8739ae039 extends (0, $5eu7g.default) {
    constructor(options){
        let storageToUse;
        try {
            // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
            storageToUse = globalThis.sessionStorage || (0, $eXTjr.default);
        } catch (err) {
            storageToUse = (0, $eXTjr.default);
        }
        super(storageToUse, options);
    }
}

});

parcelRegister("j5Le2", function(module, exports) {
$parcel$export(module.exports, "default", () => $de631ded0d60c70b$export$2e2bcd8739ae039);

var $6rvcc = parcelRequire("6rvcc");

var $cMwGH = parcelRequire("cMwGH");

var $1Ygrk = parcelRequire("1Ygrk");
const $de631ded0d60c70b$var$STORAGE_KEY = 'tab.id';
class $de631ded0d60c70b$export$2e2bcd8739ae039 {
    constructor(){
        (0, $6rvcc.default)(this, "_generateNewTabId", ()=>{
            const newTabId = (0, $1Ygrk.default)();
            this._safeSessionStorage.setItem($de631ded0d60c70b$var$STORAGE_KEY, newTabId);
            return newTabId;
        });
        this._safeSessionStorage = new (0, $cMwGH.default)();
    }
    getCurrentTabId() {
        let tabId = this._safeSessionStorage.getItem($de631ded0d60c70b$var$STORAGE_KEY);
        if (!tabId) tabId = this._generateNewTabId();
        return tabId;
    }
}

});

parcelRegister("kxbHy", function(module, exports) {
$parcel$export(module.exports, "default", () => $ef2ff75caf77a3e2$export$2e2bcd8739ae039);

var $6rvcc = parcelRequire("6rvcc");

var $3hnNg = parcelRequire("3hnNg");

var $dpXUu = parcelRequire("dpXUu");

var $8ZtlX = parcelRequire("8ZtlX");

var $cMwGH = parcelRequire("cMwGH");

var $2UUeH = parcelRequire("2UUeH");

var $1Ygrk = parcelRequire("1Ygrk");
function $ef2ff75caf77a3e2$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $ef2ff75caf77a3e2$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $ef2ff75caf77a3e2$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $6rvcc.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $ef2ff75caf77a3e2$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
const $ef2ff75caf77a3e2$var$STORAGE_KEY = 'taskSessions';
const $ef2ff75caf77a3e2$var$INIT_KEY = 'taskSessionsInit';
const $ef2ff75caf77a3e2$var$AWC_PARAM_PREFIX = 'awc.';
const $ef2ff75caf77a3e2$var$TASK_SESSION_RELOAD_TIME = 3000;
class $ef2ff75caf77a3e2$export$2e2bcd8739ae039 {
    constructor(){
        (0, $6rvcc.default)(this, "_taskSessionsNotRecentlyInitialised", (currentTimestamp)=>this._safeSessionStorage.getItem($ef2ff75caf77a3e2$var$STORAGE_KEY) === null || this._safeSessionStorage.getItem($ef2ff75caf77a3e2$var$INIT_KEY) === null || parseInt(this._safeSessionStorage.getItem($ef2ff75caf77a3e2$var$INIT_KEY) || '0', 10) < currentTimestamp - $ef2ff75caf77a3e2$var$TASK_SESSION_RELOAD_TIME);
        (0, $6rvcc.default)(this, "_removeTaskSessionPrefix", (_, taskSessionName)=>taskSessionName.split($ef2ff75caf77a3e2$var$AWC_PARAM_PREFIX)[1]);
        (0, $6rvcc.default)(this, "_isTaskSessionQueryParam", (_, taskSessionName)=>taskSessionName.startsWith($ef2ff75caf77a3e2$var$AWC_PARAM_PREFIX));
        (0, $6rvcc.default)(this, "getAllTaskSessions", ()=>{
            try {
                return JSON.parse(this._safeSessionStorage.getItem($ef2ff75caf77a3e2$var$STORAGE_KEY) || '');
            } catch (_unused) {
                return {};
            }
        });
        (0, $6rvcc.default)(this, "_writeToSessionStorage", (taskSessions)=>{
            try {
                this._safeSessionStorage.setItem($ef2ff75caf77a3e2$var$STORAGE_KEY, JSON.stringify(taskSessions));
            // eslint-disable-next-line no-empty
            } catch (_unused2) {}
        });
        (0, $6rvcc.default)(this, "_appendTaskSessions", (newTaskSessions)=>{
            const currentState = this.getAllTaskSessions();
            const newState = currentState === null ? newTaskSessions : Object.assign(currentState, newTaskSessions);
            this._writeToSessionStorage(newState);
        });
        (0, $6rvcc.default)(this, "_safelyRemoveKey", (currentState, taskSessionName)=>{
            if (currentState === null) return {};
            delete currentState[taskSessionName];
            return currentState;
        });
        (0, $6rvcc.default)(this, "createTaskSession", (taskSessionName)=>{
            const taskSessionId = (0, $1Ygrk.default)();
            const newTaskSessions = {};
            newTaskSessions[taskSessionName] = taskSessionId;
            this._appendTaskSessions(newTaskSessions);
            return taskSessionId;
        });
        (0, $6rvcc.default)(this, "createTaskSessionWithProvidedId", (taskSessionName, taskSessionId)=>{
            if (typeof taskSessionId !== 'string') throw new TypeError('invalid taskSessionId, must be string');
            const newTaskSessions = {};
            newTaskSessions[taskSessionName] = taskSessionId;
            this._appendTaskSessions(newTaskSessions);
        });
        (0, $6rvcc.default)(this, "completeTaskSession", (taskSessionName)=>{
            const currentState = this.getAllTaskSessions();
            const updatedState = this._safelyRemoveKey(currentState, taskSessionName);
            this._writeToSessionStorage(updatedState);
        });
        (0, $6rvcc.default)(this, "formatTaskSessionQueryString", ({ uri: uri, includedTaskSessions: includedTaskSessions })=>{
            const { url: url, query: query } = (0, $3hnNg.parseUrl)(uri);
            const currentState = this.getAllTaskSessions();
            // Use specified task sessions, otherwise all tasksessions excluding originTracing sessions
            const filteredTaskSessions = includedTaskSessions ? (0, $8ZtlX.pick)(currentState, includedTaskSessions) : (0, $8ZtlX.omit)(currentState, Object.values((0, $dpXUu.originTracingType)));
            if (Object.keys(filteredTaskSessions).length === 0) return uri;
            const queryWithTaskSessions = $ef2ff75caf77a3e2$var$_objectSpread($ef2ff75caf77a3e2$var$_objectSpread({}, (0, $8ZtlX.mapKeys)(filteredTaskSessions, (_, taskSessionName)=>$ef2ff75caf77a3e2$var$AWC_PARAM_PREFIX + taskSessionName)), query);
            return `${url}?${(0, $3hnNg.stringify)(queryWithTaskSessions)}`;
        });
        (0, $6rvcc.default)(this, "stripQueryParameters", ()=>{
            const extractedTaskSessions = (0, $8ZtlX.mapKeys)((0, $2UUeH.default)(this._isTaskSessionQueryParam), this._removeTaskSessionPrefix);
            this._appendTaskSessions(extractedTaskSessions);
        });
        const _currentTimestamp = Date.now();
        this._safeSessionStorage = new (0, $cMwGH.default)();
        // Wrapping all sessionStorage calls in try catch to stop any error propogation, taskSessions should gracefully fail.
        try {
            if (this._taskSessionsNotRecentlyInitialised(_currentTimestamp)) {
                this._writeToSessionStorage({});
                this._safeSessionStorage.setItem($ef2ff75caf77a3e2$var$INIT_KEY, _currentTimestamp.toString());
            }
        // eslint-disable-next-line no-empty
        } catch (_unused3) {}
    }
}

});

parcelRegister("8jZU6", function(module, exports) {
$parcel$export(module.exports, "default", () => $60f01de259a84dee$export$2e2bcd8739ae039);

var $7frtV = parcelRequire("7frtV");

var $hel6R = parcelRequire("hel6R");

var $kqsXa = parcelRequire("kqsXa");
const $60f01de259a84dee$var$MAX_CACHE_SIZE = 100;
const $60f01de259a84dee$var$COOKIE_NAME = (0, $hel6R.AllAnalyticsCookies).AWC_ANALYTICS_DEBUG.getKey();
const $60f01de259a84dee$var$DEBUG_TAG = 'synthetic';
class $60f01de259a84dee$var$TestingCache {
    constructor(syntheticFlagOverride, enableTestingCache){
        this._syntheticFlagOverride = typeof syntheticFlagOverride === 'boolean' ? syntheticFlagOverride : undefined;
        this._enableTestingCache = typeof enableTestingCache === 'boolean' ? enableTestingCache : undefined;
        this._isDebugCookieEnabled = $60f01de259a84dee$var$TestingCache.getDebugCookie();
        this.bind();
    }
    saveEvent(event) {
        try {
            if (!event) return;
            this.bind();
            this.addSyntheticTag(event);
            this.cache(event);
        } catch (_unused) {
        // Ignore errors from testing cache.
        }
    }
    bind() {
        if (!this.shouldCacheEvent() || typeof window === 'undefined' || window.testAnalytics) return;
        window.testAnalytics = {
            eventCache: [],
            events: ()=>window.testAnalytics.eventCache,
            clear: ()=>{
                window.testAnalytics.eventCache = [];
                try {
                    localStorage.removeItem('awc.ui.viewed.last.sent');
                    localStorage.removeItem('awc-staging.ui.viewed.last.sent');
                    localStorage.removeItem('awc-dev.ui.viewed.last.sent');
                    localStorage.removeItem('awc-local.ui.viewed.last.sent');
                } catch (_unused2) {
                // Ignore errors from localStorage.
                }
            }
        };
    }
    cache(event) {
        if (!this.shouldCacheEvent() || typeof window === 'undefined' || !window.testAnalytics) return;
        if (window.testAnalytics.eventCache.length >= $60f01de259a84dee$var$MAX_CACHE_SIZE) window.testAnalytics.eventCache = window.testAnalytics.eventCache.slice(1, window.testAnalytics.eventCache.length);
        window.testAnalytics.eventCache.push(event);
    }
    addSyntheticTag(event) {
        if (!this.shouldSetSyntheticFlag()) return;
        if (event.tags instanceof Array) {
            if (!event.tags.includes($60f01de259a84dee$var$DEBUG_TAG)) event.tags.push($60f01de259a84dee$var$DEBUG_TAG);
        } else event.tags = [
            $60f01de259a84dee$var$DEBUG_TAG
        ];
    }
    shouldCacheEvent() {
        return this._enableTestingCache ? this._enableTestingCache : this._isDebugCookieEnabled;
    }
    shouldSetSyntheticFlag() {
        if (this._syntheticFlagOverride !== undefined) return this._syntheticFlagOverride;
        const globalSyntheticOverride = (0, $kqsXa.TestSupport).getSyntheticFlagOverride();
        if (globalSyntheticOverride !== undefined) return globalSyntheticOverride;
        return this.shouldCacheEvent();
    }
    static getDebugCookie() {
        try {
            return JSON.parse((0, $7frtV.default).get($60f01de259a84dee$var$COOKIE_NAME) || 'false') === true;
        } catch (_unused3) {
            (0, $7frtV.default).remove($60f01de259a84dee$var$COOKIE_NAME);
        }
        return false;
    }
}
var $60f01de259a84dee$export$2e2bcd8739ae039 = $60f01de259a84dee$var$TestingCache;

});

parcelRegister("4penA", function(module, exports) {
$parcel$export(module.exports, "default", () => $3354a6ae24846e2f$export$2e2bcd8739ae039);

var $kEBxa = parcelRequire("kEBxa");

var $6rvcc = parcelRequire("6rvcc");

var $dpXUu = parcelRequire("dpXUu");

var $daYpa = parcelRequire("daYpa");

var $jc2hJ = parcelRequire("jc2hJ");
const $3354a6ae24846e2f$var$_excluded = [
    "embeddedProduct"
];
function $3354a6ae24846e2f$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $3354a6ae24846e2f$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $3354a6ae24846e2f$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $6rvcc.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $3354a6ae24846e2f$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
const $3354a6ae24846e2f$var$DEFAULT_DELAY = 2000; // 2 seconds
const $3354a6ae24846e2f$var$DEFAULT_THROTTLE = 3600000; // 1 hour
const $3354a6ae24846e2f$var$DEFAULT_STORAGE_KEY = 'ui.viewed.last.sent';
const $3354a6ae24846e2f$var$DEFAULT_MALFORMED_UIVIEWED_EVENT = 'malformed.uiviewed.last.sent';
var $3354a6ae24846e2f$var$SendEventDecision = /*#__PURE__*/ function(SendEventDecision) {
    SendEventDecision[SendEventDecision["FocusLost"] = 0] = "FocusLost";
    SendEventDecision[SendEventDecision["UserOrTenantIncomplete"] = 1] = "UserOrTenantIncomplete";
    SendEventDecision[SendEventDecision["MalformedUiViewedRateLimited"] = 2] = "MalformedUiViewedRateLimited";
    SendEventDecision[SendEventDecision["EligibleToSend"] = 3] = "EligibleToSend";
    SendEventDecision[SendEventDecision["UiViewedRateLimited"] = 4] = "UiViewedRateLimited";
    return SendEventDecision;
}($3354a6ae24846e2f$var$SendEventDecision || {});
class $3354a6ae24846e2f$export$2e2bcd8739ae039 {
    constructor(productInfo, getContext, onEvent, settings = {}){
        (0, $6rvcc.default)(this, "start", ()=>{
            this._startInterval();
            this._bindEventListeners();
        });
        (0, $6rvcc.default)(this, "stop", ()=>{
            this._stopInterval();
            this._unbindEventListeners();
        });
        (0, $6rvcc.default)(this, "resetTimers", ()=>{
            if (this._intervalId) {
                this.stop();
                this.start();
            }
        });
        (0, $6rvcc.default)(this, "signalUserActive", ()=>{
            this._sendUserActiveEvents();
        });
        (0, $6rvcc.default)(this, "_bindEventListeners", ()=>{
            if (typeof window !== 'undefined') {
                window.addEventListener('focus', this._focusListener);
                window.addEventListener('blur', this._blurListener);
            }
        });
        (0, $6rvcc.default)(this, "_unbindEventListeners", ()=>{
            if (typeof window !== 'undefined') {
                window.removeEventListener('focus', this._focusListener);
                window.removeEventListener('blur', this._blurListener);
            }
        });
        (0, $6rvcc.default)(this, "_startInterval", ()=>{
            clearInterval(this._intervalId);
            this._intervalId = setInterval(this._handleDwellTimerTriggered, this._delay);
        });
        (0, $6rvcc.default)(this, "_stopInterval", ()=>{
            if (this._intervalId) {
                clearInterval(this._intervalId);
                this._intervalId = null;
            }
        });
        (0, $6rvcc.default)(this, "_getProductKey", (product, subproduct)=>{
            let productKey = product;
            if (subproduct) productKey += `-${subproduct}`;
            return productKey;
        });
        (0, $6rvcc.default)(this, "_getLastSentTimestamp", (productKey, tenantId, userId)=>{
            const json = this._parseLocalStorageData(this._storageKey) || {};
            const u = json[userId] || {};
            const t = u[tenantId] || {};
            const p = t[productKey] || null;
            return p;
        });
        (0, $6rvcc.default)(this, "_parseLocalStorageData", (key)=>{
            const data = this._safeLocalStorage.getItem(key);
            try {
                return JSON.parse(data || '');
            } catch (_unused) {
                this._safeLocalStorage.removeItem(key);
                return null;
            }
        });
        (0, $6rvcc.default)(this, "_getMalformedLastSentTimestamp", (productKey, tenantId, userId)=>{
            const json = this._parseLocalStorageData(this._malformedEventStorageKey) || {};
            const finalUserId = userId || 'NOT_SET';
            const finalTenantId = tenantId || 'NOT_SET';
            const u = json[finalUserId] || {};
            const t = u[finalTenantId] || {};
            const p = t[productKey] || null;
            return p;
        });
        (0, $6rvcc.default)(this, "_setLastSentTimestamp", (productKey, tenantId, userId)=>{
            const json = this._parseLocalStorageData(this._storageKey) || {};
            const u = json[userId] || {};
            const t = u[tenantId] || {};
            t[productKey] = Date.now();
            u[tenantId] = t;
            json[userId] = u;
            this._safeLocalStorage.setItem(this._storageKey, JSON.stringify(json));
        });
        (0, $6rvcc.default)(this, "_setMalformedLastSentTimestamp", (productKey, tenantId, userId)=>{
            const json = this._parseLocalStorageData(this._malformedEventStorageKey) || {};
            const finalUserId = userId || 'NOT_SET';
            const finalTenantId = tenantId || 'NOT_SET';
            const u = json[finalUserId] || {};
            const t = u[finalTenantId] || {};
            t[productKey] = Date.now();
            u[finalTenantId] = t;
            json[finalUserId] = u;
            this._safeLocalStorage.setItem(this._malformedEventStorageKey, JSON.stringify(json));
        });
        (0, $6rvcc.default)(this, "_handleDwellTimerTriggered", ()=>{
            const document = (0, $daYpa.getDocument)();
            if (document && !document.hasFocus()) return;
            this._sendUserActiveEvents();
        });
        (0, $6rvcc.default)(this, "_sendUserActiveEvents", ()=>{
            const _this$_getContext = this._getContext(), { embeddedProduct: embeddedProduct } = _this$_getContext, context = (0, $kEBxa.default)(_this$_getContext, $3354a6ae24846e2f$var$_excluded);
            this._sendEvent(this._product, context, false);
            if (embeddedProduct) this._sendEvent(embeddedProduct, context, true);
        });
        (0, $6rvcc.default)(this, "_sendEvent", (product, context, isEmbeddedProduct)=>{
            const { subproduct: subproduct, tenantIdType: tenantIdType, tenantId: tenantId, userId: userId, lastScreenEvent: lastScreenEvent, attributes: attributes } = context;
            const productKey = this._getProductKey(product, subproduct);
            const sendEventDecision = this._shouldSendEvent(productKey, tenantIdType, tenantId, userId);
            switch(sendEventDecision){
                case $3354a6ae24846e2f$var$SendEventDecision.EligibleToSend:
                    this._setLastSentTimestamp(productKey, tenantId, userId);
                    this._onEvent(this._createEvent(product, subproduct, isEmbeddedProduct, lastScreenEvent, attributes, 'ui', 'viewed'));
                    break;
                case $3354a6ae24846e2f$var$SendEventDecision.UserOrTenantIncomplete:
                    this._setMalformedLastSentTimestamp(productKey, tenantId, userId);
                    this._onEvent(this._createEvent(product, subproduct, isEmbeddedProduct, lastScreenEvent, attributes, 'malformed', 'uiviewed'));
                    break;
                default:
                    break;
            }
        });
        (0, $6rvcc.default)(this, "_shouldSendEvent", (productKey, tenantIdType, tenantId, userId)=>{
            // TENANT OR USER ID NOT SET
            if (tenantIdType !== (0, $dpXUu.tenantType).NONE && !tenantId || !userId) {
                const sinceLastSent = Date.now() - this._getMalformedLastSentTimestamp(productKey, tenantId, userId);
                if (sinceLastSent === null || sinceLastSent > this._throttle) return $3354a6ae24846e2f$var$SendEventDecision.UserOrTenantIncomplete;
                return $3354a6ae24846e2f$var$SendEventDecision.MalformedUiViewedRateLimited;
            }
            const sinceLastSent = Date.now() - this._getLastSentTimestamp(productKey, tenantId, userId);
            if (sinceLastSent === null || sinceLastSent > this._throttle) return $3354a6ae24846e2f$var$SendEventDecision.EligibleToSend;
            return $3354a6ae24846e2f$var$SendEventDecision.UiViewedRateLimited;
        });
        (0, $6rvcc.default)(this, "_createEvent", (product, subproduct, isEmbeddedProduct, lastScreenEvent, extraAttributes, actionSubject, action)=>{
            const event = {
                product: product,
                source: 'ui',
                action: action,
                actionSubject: actionSubject,
                attributes: extraAttributes
            };
            if (isEmbeddedProduct) {
                // Clear the subproduct and version as they don't relate to the embedded product
                event.subproduct = null;
                event.version = null;
                event.attributes = $3354a6ae24846e2f$var$_objectSpread($3354a6ae24846e2f$var$_objectSpread({}, event.attributes), {}, {
                    embeddedInEnv: this._productInfo.env,
                    embeddedInProduct: this._productInfo.product,
                    embeddedInSubproduct: subproduct,
                    embeddedInVersion: this._productInfo.version,
                    embeddedInOrigin: this._productInfo.origin,
                    embeddedInPlatform: this._productInfo.platform
                });
            }
            if (lastScreenEvent) event.attributes = $3354a6ae24846e2f$var$_objectSpread($3354a6ae24846e2f$var$_objectSpread({}, event.attributes), {}, {
                lastScreenEvent: {
                    name: lastScreenEvent.name,
                    attributes: lastScreenEvent.attributes
                }
            });
            return event;
        });
        if (!productInfo) throw new Error('Missing productInfo');
        if (!productInfo.product) throw new Error('Missing productInfo.product');
        if (!getContext) throw new Error('Missing getContext callback');
        if (typeof getContext !== 'function') throw new Error('Invalid getContext, must be function');
        if (!onEvent) throw new Error('Missing onEvent callback');
        if (typeof onEvent !== 'function') throw new Error('Invalid onEvent, must be function');
        this._productInfo = productInfo;
        this._product = productInfo.product;
        this._getContext = getContext;
        this._onEvent = onEvent;
        this._delay = settings.delay || $3354a6ae24846e2f$var$DEFAULT_DELAY;
        this._throttle = settings.throttle || $3354a6ae24846e2f$var$DEFAULT_THROTTLE;
        this._storageKey = settings.storageKey || $3354a6ae24846e2f$var$DEFAULT_STORAGE_KEY;
        this._malformedEventStorageKey = settings.malformedStorageKey || $3354a6ae24846e2f$var$DEFAULT_MALFORMED_UIVIEWED_EVENT;
        this._safeLocalStorage = new (0, $jc2hJ.default)({
            envPrefix: this._productInfo.env
        });
        this._focusListener = ()=>{
            this._startInterval();
        };
        this._blurListener = ()=>{
            this._stopInterval();
        };
    }
}

});
parcelRegister("daYpa", function(module, exports) {
$parcel$export(module.exports, "getDocument", () => $997b10b79fa3f8dc$export$f65ca476c09acec0);
const $997b10b79fa3f8dc$export$f65ca476c09acec0 = ()=>{
    if (typeof document !== 'undefined') return document;
    return null;
};

});


parcelRegister("c77r4", function(module, exports) {
$parcel$export(module.exports, "validateIdentifyEvent", () => $8d1be80e306e78b1$export$c16a4e16aa4026c0);
/* eslint-disable @atlaskit/volt-strict-mode/no-multiple-exports */ 
var $dpXUu = parcelRequire("dpXUu");

var $9raiz = parcelRequire("9raiz");

var $eS4G8 = parcelRequire("eS4G8");
function $8d1be80e306e78b1$export$c16a4e16aa4026c0(userIdType, userId) {
    if (!userIdType) throw new Error('Missing userIdType');
    if (!userId) throw new Error('Missing userId');
    if (!(0, $9raiz.isType)((0, $dpXUu.userType), userIdType)) throw new Error(`Invalid userIdType '${userIdType}', ` + `must be an userType: [${(0, $eS4G8.objectValues)((0, $dpXUu.userType))}]`);
}

});

parcelRegister("4uub9", function(module, exports) {
$parcel$export(module.exports, "validateOperationalEvent", () => $34515fab26bd9a15$export$1e561554275607ef);
/* eslint-disable @atlaskit/volt-strict-mode/no-multiple-exports */ 
var $kCOHZ = parcelRequire("kCOHZ");
function $34515fab26bd9a15$export$1e561554275607ef(event) {
    (0, $kCOHZ.validateActionEvent)(event);
}

});

parcelRegister("gUTHp", function(module, exports) {
$parcel$export(module.exports, "validatePlatform", () => $c50d1502f8d3d175$export$801b46c35394d316);
/* eslint-disable @atlaskit/volt-strict-mode/no-multiple-exports */ 
var $dpXUu = parcelRequire("dpXUu");

var $9raiz = parcelRequire("9raiz");

var $eS4G8 = parcelRequire("eS4G8");
function $c50d1502f8d3d175$export$801b46c35394d316(productInfo) {
    if (!(0, $9raiz.isType)((0, $dpXUu.platformType), productInfo.platform)) throw new Error(`Invalid productInfo.platform '${productInfo.platform}', ` + `must be a platformType: [${(0, $eS4G8.objectValues)((0, $dpXUu.platformType))}]`);
    if (productInfo.origin === (0, $dpXUu.originType).DESKTOP && !(0, $9raiz.isType)((0, $dpXUu.desktopPlatforms), productInfo.platform)) throw new Error(`Invalid productInfo.platform '${productInfo.platform}', ` + 'must be one of [mac, linux, windows]');
    if (productInfo.origin === (0, $dpXUu.originType).WEB && !(0, $9raiz.isType)((0, $dpXUu.webPlatforms), productInfo.platform)) throw new Error(`Invalid productInfo.platform '${productInfo.platform}', must be one of [web, mobileWeb]`);
}

});

parcelRegister("gKKSu", function(module, exports) {
$parcel$export(module.exports, "validateScreenEvent", () => $c3254e2a0fc6d4e4$export$dc993432a592dc27);
/* eslint-disable @atlaskit/volt-strict-mode/no-multiple-exports */ function $c3254e2a0fc6d4e4$export$dc993432a592dc27(name) {
    if (!name) throw new Error('Missing name');
}

});

parcelRegister("lHJ7U", function(module, exports) {
$parcel$export(module.exports, "validateTrackEvent", () => $fcd09e4ca0ff1670$export$8c014fd74b0c8b99);
/* eslint-disable @atlaskit/volt-strict-mode/no-multiple-exports */ 
var $kCOHZ = parcelRequire("kCOHZ");
function $fcd09e4ca0ff1670$export$8c014fd74b0c8b99(event) {
    (0, $kCOHZ.validateActionEvent)(event);
}

});

parcelRegister("2E7is", function(module, exports) {
$parcel$export(module.exports, "validateUIEvent", () => $1ed4fa2aafa80baa$export$e5bac0930c812e90);
/* eslint-disable @atlaskit/volt-strict-mode/no-multiple-exports */ 
var $kCOHZ = parcelRequire("kCOHZ");
function $1ed4fa2aafa80baa$export$e5bac0930c812e90(event) {
    (0, $kCOHZ.validateActionEvent)(event);
}

});

parcelRegister("7UqwT", function(module, exports) {
$parcel$export(module.exports, "default", () => $5c22578f1038a2ab$export$2e2bcd8739ae039);
function $5c22578f1038a2ab$export$2e2bcd8739ae039(callback, event) {
    if (!callback || typeof callback !== 'function') return null;
    return ()=>{
        callback(event);
    };
}

});

parcelRegister("hPniv", function(module, exports) {
$parcel$export(module.exports, "XIDPromise", () => $cfa945807de0debd$export$fbe53bbbe682bcdd);

var $Lo77l = parcelRequire("Lo77l");
const $cfa945807de0debd$export$fbe53bbbe682bcdd = (xidConsent, xidPromiseFn)=>{
    if (xidConsent && xidPromiseFn && typeof xidPromiseFn === 'function') {
        const timeoutPromise = ()=>{
            return new Promise((resolve)=>{
                setTimeout(()=>resolve(()=>(0, $Lo77l.createTimeoutXid)()), (0, $Lo77l.XID_TIMEOUT));
            });
        };
        const xidPromise = ()=>{
            return xidPromiseFn().catch(()=>()=>(0, $Lo77l.createUnknownXid)());
        };
        return Promise.race([
            xidPromise(),
            timeoutPromise()
        ]);
    }
    return undefined;
};

});
parcelRegister("Lo77l", function(module, exports) {
$parcel$export(module.exports, "XID_TIMEOUT", () => $08e71866145a7f5d$export$545bcbd53afabfa3);
$parcel$export(module.exports, "createTimeoutXid", () => $08e71866145a7f5d$export$af4087e36d63846);
$parcel$export(module.exports, "createUnknownXid", () => $08e71866145a7f5d$export$fa341d0c750d705b);

var $3Mpn1 = parcelRequire("3Mpn1");
const $08e71866145a7f5d$export$545bcbd53afabfa3 = 5000;
const $08e71866145a7f5d$export$af4087e36d63846 = ()=>[
        {
            type: (0, $3Mpn1.XIDItemType).XC,
            state: 'TIMEOUT'
        },
        {
            type: (0, $3Mpn1.XIDItemType).UID,
            state: 'TIMEOUT'
        }
    ];
const $08e71866145a7f5d$export$fa341d0c750d705b = ()=>[
        {
            type: (0, $3Mpn1.XIDItemType).XC,
            state: 'UNKNOWN'
        },
        {
            type: (0, $3Mpn1.XIDItemType).UID,
            state: 'UNKNOWN'
        }
    ];

});
parcelRegister("3Mpn1", function(module, exports) {
$parcel$export(module.exports, "XIDItemType", () => $2c0988cb35351eed$export$92ca0438bcb0d396);
let $2c0988cb35351eed$export$92ca0438bcb0d396 = /*#__PURE__*/ function(XIDItemType) {
    XIDItemType["XC"] = "xc";
    XIDItemType["UID"] = "uid";
    return XIDItemType;
}({});
let $2c0988cb35351eed$export$c9079017d1f5aab9 = /*#__PURE__*/ function(XIDState) {
    XIDState["NEW"] = "NEW";
    XIDState["CHANGED"] = "CHANGED";
    XIDState["EXISTING"] = "EXISTING";
    XIDState["TIMEOUT"] = "TIMEOUT";
    XIDState["ERROR"] = "ERROR";
    XIDState["UNAVAILABLE"] = "UNAVAILABLE";
    XIDState["MALFORMED"] = "MALFORMED";
    XIDState["UNKNOWN"] = "UNKNOWN";
    return XIDState;
}({});

});




parcelRegister("9KGFe", function(module, exports) {
$parcel$export(module.exports, "getConfig", () => $368a783e6606530d$export$44487a86467333c3);

var $hiARP = parcelRequire("hiARP");

var $1eXBn = parcelRequire("1eXBn");
// default configs is also config for production env
const $368a783e6606530d$var$defaultConfig = {
    analytics: {
        scheme: 'https',
        server: 'analytics.atlassian.com'
    },
    identity: {
        baseUrl: 'https://id.atlassian.com'
    },
    statsigApiKey: '503c2782-4db6-45dc-a57b-0f9b4e3a8636',
    featureGateEnvironment: (0, $hiARP.FeatureGateEnvironment).Production,
    featureGatePerimeter: (0, $hiARP.PerimeterType).COMMERCIAL,
    consent: {
        privacyPolicyUrl: 'https://www.atlassian.com/legal/privacy-policy#what-this-policy-covers',
        termsOfUseUrl: 'https://www.atlassian.com/legal/atlassian-customer-agreement#intro'
    },
    support: {
        contactSupportUrl: 'http://support.atlassian.com/'
    },
    trello: {
        webHost: 'trello.com'
    },
    a2a: {
        docUrl: 'https://support.atlassian.com/security-and-access-policies/docs/understand-atlassian-rovo-mcp-server/'
    },
    twg: {
        permissionsManagementDocUrl: 'https://developer.atlassian.com/cloud/twg-cli/'
    },
    mcpPolicy: {
        apiBaseUrl: '',
        showSseDeprecationBanner: false,
        allowlistGuideUrl: 'https://support.atlassian.com/security-and-access-policies/docs/control-atlassian-rovo-mcp-server-settings/',
        rovoDocUrl: 'https://support.atlassian.com/security-and-access-policies/docs/understand-atlassian-rovo-mcp-server/',
        developerDocUrl: 'https://support.atlassian.com/atlassian-rovo-mcp-server/docs/getting-started-with-the-atlassian-remote-mcp-server/',
        sseMigrationGuideUrl: 'https://support.atlassian.com/security-and-access-policies/docs/control-atlassian-rovo-mcp-server-settings/',
        permissionsManagementDocUrl: 'https://support.atlassian.com/security-and-access-policies/docs/control-atlassian-rovo-mcp-server-settings/',
        deprecatedSseEndpoint: 'https://mcp.atlassian.com/v1/sse'
    }
};
const $368a783e6606530d$var$stagingOverrides = {
    statsigApiKey: '9f0ef96e-59da-4618-9844-397dc60d1b0d',
    featureGateEnvironment: (0, $hiARP.FeatureGateEnvironment).Staging,
    identity: {
        baseUrl: 'https://id.stg.internal.atlassian.com'
    },
    trello: {
        webHost: 'trellis.coffee'
    }
};
const $368a783e6606530d$var$localAndTestOverrides = {
    statsigApiKey: '1565260a-fa4c-4df1-a23d-87427576e44e',
    featureGateEnvironment: (0, $hiARP.FeatureGateEnvironment).Development,
    identity: {
        baseUrl: 'https://id-domain.dev.internal.atlassian.com'
    }
};
const $368a783e6606530d$var$environmentOverrides = {
    local: {
        ...$368a783e6606530d$var$localAndTestOverrides,
        analytics: {
            scheme: 'http',
            server: `${window.location.hostname}:3000`
        }
    },
    ddev: {
        ...$368a783e6606530d$var$stagingOverrides,
        ...$368a783e6606530d$var$localAndTestOverrides
    },
    stg: $368a783e6606530d$var$stagingOverrides,
    'stg-fedm': {
        ...$368a783e6606530d$var$stagingOverrides,
        featureGatePerimeter: (0, $hiARP.PerimeterType).FEDRAMP_MODERATE,
        identity: {
            baseUrl: 'https://id.stg.atlassian-us-gov-mod.com'
        }
    },
    'prod-fedm': {
        featureGatePerimeter: (0, $hiARP.PerimeterType).FEDRAMP_MODERATE,
        identity: {
            baseUrl: 'https://id.atlassian-us-gov-mod.com'
        }
    }
};
const $368a783e6606530d$var$cachedConfig = {};
function $368a783e6606530d$export$44487a86467333c3() {
    const env = (0, $1eXBn.getEnv)();
    if (!$368a783e6606530d$var$cachedConfig[env]) $368a783e6606530d$var$cachedConfig[env] = {
        ...$368a783e6606530d$var$defaultConfig,
        ...$368a783e6606530d$var$environmentOverrides[env]
    };
    return $368a783e6606530d$var$cachedConfig[env];
}

});
parcelRegister("1eXBn", function(module, exports) {
$parcel$export(module.exports, "getEnv", () => $9e6536462cd60635$export$4bd44a2aa29d3d6e);
const $9e6536462cd60635$var$envHostNameMapping = {
    localhost: 'local',
    'auth.dev.atlassian.com': 'ddev',
    'auth.stg.atlassian.com': 'stg',
    'auth.atlassian.com': 'prod',
    'auth.stg.atlassian-us-gov-mod.com': 'stg-fedm',
    'auth.atlassian-us-gov-mod.com': 'prod-fedm'
};
function $9e6536462cd60635$export$4bd44a2aa29d3d6e() {
    return $9e6536462cd60635$var$envHostNameMapping[window.location.hostname] ?? 'local';
}
const $9e6536462cd60635$var$perimeters = {
    local: 'commercial',
    ddev: 'commercial',
    stg: 'commercial',
    'stg-fedm': 'fedramp-moderate',
    prod: 'commercial',
    'prod-fedm': 'fedramp-moderate'
};
const $9e6536462cd60635$export$84a0517db04c70cb = $9e6536462cd60635$var$perimeters[$9e6536462cd60635$export$4bd44a2aa29d3d6e()];
const $9e6536462cd60635$export$64d6499adf9b2e51 = ()=>'fedramp-moderate' === $9e6536462cd60635$export$84a0517db04c70cb;

});




parcelRegister("38t3M", function(module, exports) {
$parcel$export(module.exports, "applyResponsiveViewport", () => $81a9fa5c3f601166$export$fa5d5004982de478);
const $81a9fa5c3f601166$var$RESPONSIVE_VIEWPORT = 'width=device-width, initial-scale=1';
const $81a9fa5c3f601166$export$fa5d5004982de478 = ()=>{
    // A tag already in the document means the page has stated its own intent
    // (`index.html` one day, or the Storybook preview iframe today, which is why
    // this bug never showed up in stories). Don't fight it.
    if (document.querySelector('meta[name="viewport"]')) return;
    const meta = document.createElement('meta');
    meta.name = 'viewport';
    meta.content = $81a9fa5c3f601166$var$RESPONSIVE_VIEWPORT;
    document.head.appendChild(meta);
};

});


parcelRegister("2gmBL", function(module, exports) {
"use strict";
var $1a5e9ce6b94f06da$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $1a5e9ce6b94f06da$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $1a5e9ce6b94f06da$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$1a5e9ce6b94f06da$var$__exportStar((parcelRequire("c4Up0")), module.exports);

$1a5e9ce6b94f06da$var$__exportStar((parcelRequire("fb6VX")), module.exports);

$1a5e9ce6b94f06da$var$__exportStar((parcelRequire("jlxKU")), module.exports);

$1a5e9ce6b94f06da$var$__exportStar((parcelRequire("glblS")), module.exports);

$1a5e9ce6b94f06da$var$__exportStar((parcelRequire("hn1YZ")), module.exports);

});

parcelRegister("leM9a", function(module, exports) {
$parcel$export(module.exports, "OAuthConsentFeatureGate", () => $e414e1fe3210f762$export$ba498951ac9aeac6);
/**
 * Enum of all feature gate keys used in oauth-consent.
 *
 * Each entry should include a comment linking to the Switcheroo gate URL.
 * Example:
 *   // https://switcheroo.atlassian.com/ui/gates/<gate-id>/key/<gate-key>
 *   MY_FEATURE = 'oauth-consent-my-feature',
 */ var $e414e1fe3210f762$export$ba498951ac9aeac6 = /*#__PURE__*/ function(OAuthConsentFeatureGate) {
    // Limits Rovo consent to one selected site; disabled preserves multi-site selection.
    // https://switcheroo.atlassian.com/ui/gates/26308305-524d-4fc6-8a96-90c232718d8f/key/oauth-consent_rovo-single-site
    OAuthConsentFeatureGate["ROVO_SINGLE_SITE"] = "oauth-consent_rovo-single-site";
    // Gates Trello consent screen access to app authors/collaborators (Horsefly program).
    // https://switcheroo.atlassian.com/ui/gates/7d71dd9e-26b8-4587-b202-8ef2814277a1/key/oauth-consent_trello-contributor-gate
    OAuthConsentFeatureGate["TRELLO_CONTRIBUTOR_GATE"] = "oauth-consent_trello-contributor-gate";
    // Internal bypass for site selector when /consent/info returns no workspaces (e.g. timeout).
    // NOT intended for production use — shown only to internal users via this gate.
    OAuthConsentFeatureGate["SITE_SELECTOR_BYPASS"] = "oauth-consent_site-selector-bypass";
    // Sorts the workspace list in MCP-style site selectors.
    OAuthConsentFeatureGate["MCP_SORT_WORKSPACES"] = "oauth-consent_mcp-sorted-workspaces";
    // Enables selecting more than one Trello workspace on the MCP consent screen.
    OAuthConsentFeatureGate["TRELLO_MCP_MULTI_WORKSPACE_SELECTION"] = "oauth-consent_trello-mcp-multi-workspace";
    // Enables the Trello workspace selector alongside the Atlassian site selector
    // in mixed-scope MCP consent flows. When disabled, the Trello workspace
    // selector is hidden even if hasTrelloProductAccess is true and Trello scopes
    // are present.
    OAuthConsentFeatureGate["TRELLO_MCP_MIXED_WORKSPACE"] = "oauth-consent_trello-mcp-mixed-workspace";
    // Enables the reworked Trello multi-workspace selector on the MCP consent
    // screen, and the multi-workspace data and selection rules behind it.
    OAuthConsentFeatureGate["MULTI_WORKSPACE_SELECTOR"] = "oauth-consent_multi-workspace-selector";
    // Shows the Jira "Delete" intent group on the MCP permissions list. Owned by
    // the MCP service, so the key does not follow the oauth-consent_ convention.
    OAuthConsentFeatureGate["MCP_JIRA_DELETE_TOOLSETS"] = "atlassian_mcp_jira_delete_toolsets";
    // Shows the Jira "Manage" intent group on the MCP permissions list. Owned by
    // the MCP service, so the key does not follow the oauth-consent_ convention.
    OAuthConsentFeatureGate["MCP_JIRA_MANAGE_TOOLSETS"] = "atlassian_mcp_jira_admin_toolsets";
    // Redirects the consent tab to the dagterminal success screen after Accept
    // when the OAuth callback uses the rovo:// custom scheme. The system browser
    // hands the rovo:// URI off to the OS to launch the native app, but the tab
    // itself has nowhere to navigate and would otherwise remain on the stale
    // consent screen.
    // https://switcheroo.atlassian.com/ui/gates/<id>/key/oauth-consent_rovo-success-redirect
    OAuthConsentFeatureGate["ROVO_SUCCESS_REDIRECT"] = "oauth-consent_rovo-success-redirect";
    return OAuthConsentFeatureGate;
}({});

});

parcelRegister("8LFYh", function(module, exports) {
$parcel$export(module.exports, "isClientDisabledFailure", () => $e0e4696779f08f7d$export$5d0f60195fc103ba);
$parcel$export(module.exports, "fetchWorkspacePolicyCheck", () => $e0e4696779f08f7d$export$77bc2ba0a2a5eb6e);

var $9KGFe = parcelRequire("9KGFe");

var $49b5t = parcelRequire("49b5t");
const $e0e4696779f08f7d$export$a27bd8a204a77706 = '/consent/workspace';
const $e0e4696779f08f7d$export$7b5a63dd32024b76 = 'client_disabled';
function $e0e4696779f08f7d$export$5d0f60195fc103ba(result) {
    return !result.ok && result.status === 403 && result.errorCode === $e0e4696779f08f7d$export$7b5a63dd32024b76;
}
// ---------------------------------------------------------------------------
// URL builders
// ---------------------------------------------------------------------------
function $e0e4696779f08f7d$var$buildWorkspacePolicyUrl(baseUrl, params) {
    const root = $e0e4696779f08f7d$var$apiBaseUrlRoot(baseUrl);
    const url = new URL($e0e4696779f08f7d$export$a27bd8a204a77706, root.endsWith('/') ? root : `${root}/`);
    url.searchParams.set('context', params.contextJwt);
    url.searchParams.set('selectedWorkspace', params.selectedWorkspace);
    return (0, $49b5t.withForwardedEnv)(url.toString());
}
function $e0e4696779f08f7d$var$apiBaseUrlRoot(baseUrl) {
    return baseUrl.trim() || window.location.origin;
}
// ---------------------------------------------------------------------------
// Error body parsing
// ---------------------------------------------------------------------------
/**
 * Reads oauth-server's `{ error, error_description }` body off a non-2xx
 * response, as /consent/info does. Tolerates empty or non-JSON bodies.
 */ async function $e0e4696779f08f7d$var$parseErrorBody(res) {
    let body;
    try {
        body = await res.json();
    } catch  {
        return {};
    }
    if (!body || typeof body !== 'object') return {};
    const o = body;
    return {
        errorCode: typeof o.error === 'string' ? o.error : undefined,
        errorDescription: typeof o.error_description === 'string' ? o.error_description : undefined
    };
}
// ---------------------------------------------------------------------------
// Domain parsing (shared)
// ---------------------------------------------------------------------------
function $e0e4696779f08f7d$var$parseDomain(rawDomain) {
    const o = rawDomain && typeof rawDomain === 'object' ? rawDomain : {};
    return {
        // Fail-closed: if the domain field is missing or malformed, default to
        // blocked so a corrupted API response never silently permits a redirect.
        allowed: typeof o.allowed === 'boolean' ? o.allowed : false,
        error: typeof o.error === 'boolean' ? o.error : false
    };
}
async function $e0e4696779f08f7d$export$77bc2ba0a2a5eb6e(params, signal) {
    const policyUrl = $e0e4696779f08f7d$var$buildWorkspacePolicyUrl((0, $9KGFe.getConfig)().mcpPolicy.apiBaseUrl, params);
    let res;
    try {
        res = await fetch(policyUrl, {
            method: 'GET',
            credentials: 'include',
            signal: signal
        });
    } catch (e) {
        if (signal?.aborted || e instanceof DOMException && e.name === 'AbortError') throw e;
        const msg = e instanceof Error ? e.message : 'Network error';
        return {
            ok: false,
            errorMessage: msg
        };
    }
    if (!res.ok) {
        const errorBody = await $e0e4696779f08f7d$var$parseErrorBody(res);
        return {
            ok: false,
            errorMessage: `Workspace policy check failed (${res.status})`,
            status: res.status,
            ...errorBody
        };
    }
    let body;
    try {
        body = await res.json();
    } catch  {
        return {
            ok: false,
            errorMessage: 'Invalid workspace policy response'
        };
    }
    if (!body || typeof body !== 'object') return {
        ok: false,
        errorMessage: 'Invalid policy response'
    };
    const o = body;
    if (o.success === false) return {
        ok: false,
        errorMessage: 'Policy check unsuccessful'
    };
    const domain = $e0e4696779f08f7d$var$parseDomain(o.domain);
    // a2aEnabled sits at the same level as domain in the API response.
    // Fail-closed: default to true so non-A2A flows are unaffected.
    const a2aEnabled = typeof o.a2aEnabled === 'boolean' ? o.a2aEnabled : true;
    const data = {
        domain: domain,
        redirectAllowed: domain.allowed && !domain.error,
        a2aEnabled: a2aEnabled,
        rawBody: o
    };
    return {
        ok: true,
        data: data
    };
}

});

parcelRegister("bcapr", function(module, exports) {
$parcel$export(module.exports, "MCP_INTENT", () => $75ad36b000146cee$export$e08cbc28ab95ef10);
$parcel$export(module.exports, "MCP_INTENT_ORDER", () => $75ad36b000146cee$export$bd493ae49ab38936);
$parcel$export(module.exports, "isIrreversibleIntent", () => $75ad36b000146cee$export$458d508c493bbc79);
$parcel$export(module.exports, "showsIrreversibleResultsBadge", () => $75ad36b000146cee$export$7f5060046dc11cdc);
/**
 * Intent ids used by the MCP policy API (`byIntent[].id`).
 */ const $75ad36b000146cee$export$e08cbc28ab95ef10 = {
    read: 'read',
    write: 'write',
    search: 'search',
    delete: 'delete',
    manage: 'manage'
};
const $75ad36b000146cee$export$bd493ae49ab38936 = [
    $75ad36b000146cee$export$e08cbc28ab95ef10.read,
    $75ad36b000146cee$export$e08cbc28ab95ef10.write,
    $75ad36b000146cee$export$e08cbc28ab95ef10.search,
    $75ad36b000146cee$export$e08cbc28ab95ef10.delete,
    $75ad36b000146cee$export$e08cbc28ab95ef10.manage
];
/**
 * Intents that start unchecked and require a deliberate opt-in (delete /
 * manage). Used for default selection, read-only visibility, and the warning
 * flag — not for the "Irreversible results" lozenge.
 */ const $75ad36b000146cee$var$OPT_IN_INTENT_IDS = new Set([
    $75ad36b000146cee$export$e08cbc28ab95ef10.delete,
    $75ad36b000146cee$export$e08cbc28ab95ef10.manage
]);
// TODO: Replace this UI-owned mapping with backend-provided irreversible metadata.
/** Intents that show the "Irreversible results" lozenge (delete only). */ const $75ad36b000146cee$var$IRREVERSIBLE_BADGE_INTENT_IDS = new Set([
    $75ad36b000146cee$export$e08cbc28ab95ef10.delete
]);
function $75ad36b000146cee$export$458d508c493bbc79(intentId) {
    return $75ad36b000146cee$var$OPT_IN_INTENT_IDS.has(intentId);
}
function $75ad36b000146cee$export$7f5060046dc11cdc(intentId) {
    return $75ad36b000146cee$var$IRREVERSIBLE_BADGE_INTENT_IDS.has(intentId);
}

});

parcelRegister("dnJFI", function(module, exports) {
$parcel$export(module.exports, "parseMcpPolicyData", () => $9b8c70b144480b63$export$9788702d95e19453);
$parcel$export(module.exports, "compareToolsets", () => $9b8c70b144480b63$export$8f4bd6cceab8f82e);
$parcel$export(module.exports, "getToolsetNames", () => $9b8c70b144480b63$export$8ed7f63f7bededb8);
$parcel$export(module.exports, "getVisibleToolsetNames", () => $9b8c70b144480b63$export$abe95a2ef2a3fcfd);

var $bcapr = parcelRequire("bcapr");
const $9b8c70b144480b63$var$collator = new Intl.Collator(undefined, {
    sensitivity: 'base'
});
/** Parse a raw toolset array from the API (byIntent.toolsets). */ function $9b8c70b144480b63$var$parseRawToolsetArray(items) {
    if (!Array.isArray(items)) return [];
    const result = [];
    for (const item of items){
        if (!item || typeof item !== 'object') continue;
        const o = item;
        const name = typeof o.name === 'string' ? o.name.trim() : '';
        const product = typeof o.product === 'string' ? o.product.trim() : '';
        const intent = typeof o.intent === 'string' ? o.intent.trim() : '';
        const description = typeof o.description === 'string' ? o.description : '';
        const scopes = Array.isArray(o.scopes) ? o.scopes.filter((s)=>typeof s === 'string').sort($9b8c70b144480b63$var$collator.compare) : [];
        const container = o.container === 'organization' || o.container === 'site' || o.container === 'unit' ? o.container : undefined;
        if (name) result.push({
            name: name,
            product: product,
            intent: intent,
            scopes: scopes,
            description: description,
            ...container ? {
                container: container
            } : {}
        });
    }
    result.sort((a, b)=>$9b8c70b144480b63$var$collator.compare(a.name, b.name));
    return result;
}
/** Parse byIntent from the ordered-array format. */ function $9b8c70b144480b63$var$parseByIntent(byIntent) {
    if (!Array.isArray(byIntent)) return [];
    const result = [];
    for (const item of byIntent){
        if (!item || typeof item !== 'object' || Array.isArray(item)) continue;
        const o = item;
        const id = typeof o.id === 'string' ? o.id.trim() : '';
        const label = typeof o.label === 'string' ? o.label : '';
        const description = typeof o.description === 'string' ? o.description : '';
        const toolsets = $9b8c70b144480b63$var$parseRawToolsetArray(o.toolsets);
        if (id) result.push({
            id: id,
            label: label,
            description: description,
            toolsets: toolsets
        });
    }
    // TODO: Move intent display ordering into the backend policy response.
    // Irreversible groups (delete / manage) always sit below the rest so the
    // destructive options are never the first thing offered.
    result.sort((a, b)=>Number((0, $bcapr.isIrreversibleIntent)(a.id)) - Number((0, $bcapr.isIrreversibleIntent)(b.id)) || $9b8c70b144480b63$var$collator.compare(a.label, b.label));
    return result;
}
function $9b8c70b144480b63$export$9788702d95e19453(sharedData) {
    const toolsets = sharedData.rawBody.toolsets;
    const byIntent = $9b8c70b144480b63$var$parseByIntent(toolsets?.byIntent);
    const crossOrgScopesRemoved = typeof sharedData.rawBody.crossOrgScopesRemoved === 'boolean' ? sharedData.rawBody.crossOrgScopesRemoved : false;
    return {
        domain: sharedData.domain,
        byIntent: byIntent,
        redirectAllowed: sharedData.redirectAllowed,
        crossOrgScopesRemoved: crossOrgScopesRemoved
    };
}
function $9b8c70b144480b63$export$8f4bd6cceab8f82e(a, b) {
    return $9b8c70b144480b63$var$collator.compare(a.name, b.name);
}
function $9b8c70b144480b63$export$8ed7f63f7bededb8(intentGroups) {
    return new Set(intentGroups// TODO: Use backend-provided default selection metadata when available.
    // Pre-select every toolset except the irreversible groups, which the
    // user has to opt into.
    .filter((g)=>!(0, $bcapr.isIrreversibleIntent)(g.id)).flatMap((group)=>group.toolsets.map((t)=>t.name)));
}
function $9b8c70b144480b63$export$abe95a2ef2a3fcfd(intentGroups) {
    return new Set(intentGroups.flatMap((group)=>group.toolsets.map((t)=>t.name)));
}

});

parcelRegister("3jgQd", function(module, exports) {
$parcel$export(module.exports, "readRecentWorkspaceIds", () => $483cdda3203a3e80$export$b1dd5413a0291c61);
$parcel$export(module.exports, "recordConsentedWorkspaceIds", () => $483cdda3203a3e80$export$6753aff617c48d51);
/**
 * Client-side record of the Trello workspaces a user has previously consented
 * with, used to populate the "Recently used" group in the workspace selector.
 *
 * There is no backend source for this: the consent screen is served from a
 * stable first-party origin, so localStorage persists across consent visits for
 * every client app. Two constraints follow from how the screen works:
 *
 * - Entries are keyed by account id. The origin is shared by every Atlassian
 *   account used in the browser, so an unkeyed record would leak one user's
 *   workspaces to another.
 * - Only workspace ids are stored, never display names, so nothing
 *   human-readable is written to disk. Ids that no longer resolve against the
 *   available workspaces are dropped at render time by the selector.
 *
 * Every entry point is total: storage being unavailable (private browsing,
 * quota exhaustion, blocked cookies) degrades to "no recents" and must never
 * interrupt consent.
 */ const $483cdda3203a3e80$var$STORAGE_KEY_PREFIX = 'oauth-consent.recent-trello-workspaces';
const $483cdda3203a3e80$export$cb07ea20dff610a = 5;
const $483cdda3203a3e80$var$storageKeyFor = (accountId)=>`${$483cdda3203a3e80$var$STORAGE_KEY_PREFIX}.${accountId}`;
const $483cdda3203a3e80$var$getLocalStorage = ()=>{
    try {
        return window.localStorage ?? null;
    } catch  {
        return null;
    }
};
const $483cdda3203a3e80$var$isNonEmptyString = (value)=>'string' === typeof value && value.length > 0;
const $483cdda3203a3e80$var$dedupe = (ids)=>[
        ...new Set(ids)
    ];
const $483cdda3203a3e80$export$b1dd5413a0291c61 = (accountId)=>{
    if (!$483cdda3203a3e80$var$isNonEmptyString(accountId)) return [];
    const storage = $483cdda3203a3e80$var$getLocalStorage();
    if (!storage) return [];
    try {
        const raw = storage.getItem($483cdda3203a3e80$var$storageKeyFor(accountId));
        if (!raw) return [];
        const parsed = JSON.parse(raw);
        if (!Array.isArray(parsed)) return [];
        return $483cdda3203a3e80$var$dedupe(parsed.filter($483cdda3203a3e80$var$isNonEmptyString)).slice(0, $483cdda3203a3e80$export$cb07ea20dff610a);
    } catch  {
        return [];
    }
};
const $483cdda3203a3e80$export$b1778f2df4a19de8 = (accountId)=>{
    if (!$483cdda3203a3e80$var$isNonEmptyString(accountId)) return;
    try {
        $483cdda3203a3e80$var$getLocalStorage()?.removeItem($483cdda3203a3e80$var$storageKeyFor(accountId));
    } catch  {
    // Nothing to do — the record is best-effort in both directions.
    }
};
const $483cdda3203a3e80$export$6753aff617c48d51 = (accountId, workspaceIds)=>{
    if (!$483cdda3203a3e80$var$isNonEmptyString(accountId)) return;
    const consented = workspaceIds.filter($483cdda3203a3e80$var$isNonEmptyString);
    if (0 === consented.length) return;
    const storage = $483cdda3203a3e80$var$getLocalStorage();
    if (!storage) return;
    const merged = $483cdda3203a3e80$var$dedupe([
        ...consented,
        ...$483cdda3203a3e80$export$b1dd5413a0291c61(accountId)
    ]).slice(0, $483cdda3203a3e80$export$cb07ea20dff610a);
    try {
        storage.setItem($483cdda3203a3e80$var$storageKeyFor(accountId), JSON.stringify(merged));
    } catch  {
    // Storage unavailable or full — recents are best-effort, never block consent.
    }
};

});

parcelRegister("f5RPY", function(module, exports) {
$parcel$export(module.exports, "AccountClientProvider", () => $116413ebc503adf0$export$9c573e05c0f57a89);
$parcel$export(module.exports, "useUser", () => $116413ebc503adf0$export$23bbbc4533528f03);
$parcel$export(module.exports, "useSwitchAccountLink", () => $116413ebc503adf0$export$dce6af3168fb6ced);

var $i3UfC = parcelRequire("i3UfC");

var $5FkrB = parcelRequire("5FkrB");

var $ebbcy = parcelRequire("ebbcy");

var $6hgMx = parcelRequire("6hgMx");
const $116413ebc503adf0$var$fedrampSuffix = '-fedm';
const $116413ebc503adf0$var$rawEnv = "prod" ?? 'dev';
const $116413ebc503adf0$var$isFedramp = $116413ebc503adf0$var$rawEnv.endsWith($116413ebc503adf0$var$fedrampSuffix);
// If the env ends with "-fedm" then strip the suffix
const $116413ebc503adf0$var$envType = $116413ebc503adf0$var$isFedramp ? $116413ebc503adf0$var$rawEnv.substring(0, $116413ebc503adf0$var$rawEnv.length - $116413ebc503adf0$var$fedrampSuffix.length) : $116413ebc503adf0$var$rawEnv;
const $116413ebc503adf0$var$AccountClientContext = /*#__PURE__*/ (0, $5FkrB.createContext)(null);
function $116413ebc503adf0$export$9c573e05c0f57a89({ children: children, accountClient: accountClient }) {
    const defaultClient = (0, $5FkrB.useMemo)(()=>accountClient ?? new (0, $ebbcy.DefaultAccountClient)({
            identityEnvironment: $116413ebc503adf0$var$envType,
            defaultContinueUrl: window.location.href,
            perimeter: $116413ebc503adf0$var$isFedramp ? 'fedramp-moderate' : 'commercial'
        }), // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
    return /*#__PURE__*/ (0, $i3UfC.jsx)($116413ebc503adf0$var$AccountClientContext.Provider, {
        value: defaultClient,
        children: children
    });
}
const $116413ebc503adf0$export$46db560d0f65f4ac = ()=>{
    const client = (0, $5FkrB.useContext)($116413ebc503adf0$var$AccountClientContext);
    if (!client) throw new Error('useAccountClient must be used within AccountClientProvider');
    return client;
};
function $116413ebc503adf0$export$23bbbc4533528f03() {
    const client = $116413ebc503adf0$export$46db560d0f65f4ac();
    const [user, setUser] = (0, $5FkrB.useState)(client.currentUser);
    (0, $5FkrB.useLayoutEffect)(()=>client.addUserListener(setUser), []);
    user;
    return user;
}
function $116413ebc503adf0$export$dce6af3168fb6ced(prependIdDomainUrl) {
    const client = $116413ebc503adf0$export$46db560d0f65f4ac();
    const { audience: audience, redirectUrl: redirectUrl } = (0, $6hgMx.useToken)();
    const continueUrl = `https://${audience}${redirectUrl?.raw}`;
    if (prependIdDomainUrl ?? true) return client.getSwitchAccountLink({
        continueUrl: continueUrl
    });
    return continueUrl;
}

});
parcelRegister("ebbcy", function(module, exports) {
$parcel$export(module.exports, "DefaultAccountClient", () => $a52ac82903de8d62$export$1582a199dfd557d7);

var $47DfN = parcelRequire("47DfN");

var $br94z = parcelRequire("br94z");

var $4xzmZ = parcelRequire("4xzmZ");

var $v99KJ = parcelRequire("v99KJ");

var $7ekWx = parcelRequire("7ekWx");

var $9uJkO = parcelRequire("9uJkO");

var $lBLAm = parcelRequire("lBLAm");

var $vq8Ju = parcelRequire("vq8Ju");

var $if8j9 = parcelRequire("if8j9");

var $Ck9cD = parcelRequire("Ck9cD");
function $a52ac82903de8d62$var$_callSuper(t, o, e) {
    return o = (0, $7ekWx.default)(o), (0, $v99KJ.default)(t, $a52ac82903de8d62$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, $7ekWx.default)(t).constructor) : o.apply(t, e));
}
function $a52ac82903de8d62$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($a52ac82903de8d62$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $a52ac82903de8d62$var$retryOptions = {
    minTimeout: 1000,
    retries: 4,
    factor: 2
};
/**
 * The retry npm package has become incompatible due to Parcel 2 scope-hoisting and retry not correctly exporting.
 *
 * Since the maintainer of the retry package seems to have abandoned the project, moving toward an internal
 * retry library.
 *
 * The following recreates the previous settings for retry; see for formula https://www.npmjs.com/package/retry
 */ var $a52ac82903de8d62$var$intervalsMS = new Array($a52ac82903de8d62$var$retryOptions.retries).fill(0).map(function(_, attempt) {
    return Math.max(1, $a52ac82903de8d62$var$retryOptions.minTimeout) * Math.pow($a52ac82903de8d62$var$retryOptions.factor, attempt);
}, Infinity);
var $a52ac82903de8d62$export$1582a199dfd557d7 = /*#__PURE__*/ function(_AbstractAccountClien) {
    /** @override */ function DefaultAccountClient(config) {
        var _this;
        (0, $br94z.default)(this, DefaultAccountClient);
        _this = $a52ac82903de8d62$var$_callSuper(this, DefaultAccountClient, [
            config
        ]);
        (0, $lBLAm.default)(_this, "_listeners", []);
        _this._load();
        return _this;
    }
    /** @override */ (0, $9uJkO.default)(DefaultAccountClient, _AbstractAccountClien);
    return (0, $4xzmZ.default)(DefaultAccountClient, [
        {
            key: "addUserListener",
            value: function addUserListener(callback) {
                var _this2 = this;
                this._listeners.push(callback);
                return function() {
                    _this2._listeners = _this2._listeners.filter(function(listener) {
                        return listener !== callback;
                    });
                };
            }
        },
        {
            key: "_load",
            value: function _load() {
                var _this3 = this;
                (0, $if8j9.retryOnException)(/*#__PURE__*/ (0, $47DfN.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($vq8Ju))).mark(function _callee() {
                    var response, user;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($vq8Ju))).wrap(function(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                _context.next = 1;
                                return fetch('/gateway/api/me');
                            case 1:
                                response = _context.sent;
                                if (!(response.status === 200)) {
                                    _context.next = 3;
                                    break;
                                }
                                _context.next = 2;
                                return response.json();
                            case 2:
                                user = _context.sent;
                                return _context.abrupt("return", user);
                            case 3:
                                if (!(response.status === 401)) {
                                    _context.next = 4;
                                    break;
                                }
                                return _context.abrupt("return", null);
                            case 4:
                                throw Object.assign(new Error("Unexpected response from /gateway/api/me: ".concat(response.status)), {
                                    response: response
                                });
                            case 5:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee);
                })), {
                    intervalsMS: $a52ac82903de8d62$var$intervalsMS
                }).then(function(user) {
                    _this3.currentUser = user;
                    _this3._listeners.forEach(function(listener) {
                        return listener(user);
                    });
                }, function(error) {
                    _this3.currentUser = null;
                    _this3._listeners.forEach(function(listener) {
                        return listener(null, error);
                    });
                });
            }
        }
    ]);
}((0, $Ck9cD.AbstractAccountClient));

});
parcelRegister("47DfN", function(module, exports) {
$parcel$export(module.exports, "default", () => $300643d5951a2001$export$2e2bcd8739ae039);
function $300643d5951a2001$var$asyncGeneratorStep(n, t, e, r, o, a, c) {
    try {
        var i = n[a](c), u = i.value;
    } catch (n) {
        return void e(n);
    }
    i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function $300643d5951a2001$export$2e2bcd8739ae039(n) {
    return function() {
        var t = this, e = arguments;
        return new Promise(function(r, o) {
            var a = n.apply(t, e);
            function _next(n) {
                $300643d5951a2001$var$asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
            }
            function _throw(n) {
                $300643d5951a2001$var$asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
            }
            _next(void 0);
        });
    };
}

});

parcelRegister("br94z", function(module, exports) {
$parcel$export(module.exports, "default", () => $853940ffca844e3b$export$2e2bcd8739ae039);
function $853940ffca844e3b$export$2e2bcd8739ae039(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}

});

parcelRegister("4xzmZ", function(module, exports) {
$parcel$export(module.exports, "default", () => $34e5ae36691f954c$export$2e2bcd8739ae039);

var $dUoTc = parcelRequire("dUoTc");
function $34e5ae36691f954c$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, (0, $dUoTc.default)(o.key), o);
    }
}
function $34e5ae36691f954c$export$2e2bcd8739ae039(e, r, t) {
    return r && $34e5ae36691f954c$var$_defineProperties(e.prototype, r), t && $34e5ae36691f954c$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}

});
parcelRegister("dUoTc", function(module, exports) {
$parcel$export(module.exports, "default", () => $a203cfcd36add72e$export$2e2bcd8739ae039);

var $37oBo = parcelRequire("37oBo");

var $eQ5yU = parcelRequire("eQ5yU");
function $a203cfcd36add72e$export$2e2bcd8739ae039(t) {
    var i = (0, $eQ5yU.default)(t, "string");
    return "symbol" == (0, $37oBo.default)(i) ? i : i + "";
}

});
parcelRegister("37oBo", function(module, exports) {
$parcel$export(module.exports, "default", () => $24551bfda634c0f5$export$2e2bcd8739ae039);
function $24551bfda634c0f5$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $24551bfda634c0f5$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $24551bfda634c0f5$export$2e2bcd8739ae039(o);
}

});

parcelRegister("eQ5yU", function(module, exports) {
$parcel$export(module.exports, "default", () => $acda3c80efe86edb$export$2e2bcd8739ae039);

var $37oBo = parcelRequire("37oBo");
function $acda3c80efe86edb$export$2e2bcd8739ae039(t, r) {
    if ("object" != (0, $37oBo.default)(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (0, $37oBo.default)(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}

});



parcelRegister("v99KJ", function(module, exports) {
$parcel$export(module.exports, "default", () => $05d9ff9d9d591e17$export$2e2bcd8739ae039);

var $37oBo = parcelRequire("37oBo");

var $gODJ8 = parcelRequire("gODJ8");
function $05d9ff9d9d591e17$export$2e2bcd8739ae039(t, e) {
    if (e && ("object" == (0, $37oBo.default)(e) || "function" == typeof e)) return e;
    if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
    return (0, $gODJ8.default)(t);
}

});
parcelRegister("gODJ8", function(module, exports) {
$parcel$export(module.exports, "default", () => $c3e021c885f8b61d$export$2e2bcd8739ae039);
function $c3e021c885f8b61d$export$2e2bcd8739ae039(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
}

});


parcelRegister("7ekWx", function(module, exports) {
$parcel$export(module.exports, "default", () => $543a1614f343611c$export$2e2bcd8739ae039);
function $543a1614f343611c$export$2e2bcd8739ae039(t) {
    return $543a1614f343611c$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
        return t.__proto__ || Object.getPrototypeOf(t);
    }, $543a1614f343611c$export$2e2bcd8739ae039(t);
}

});

parcelRegister("9uJkO", function(module, exports) {
$parcel$export(module.exports, "default", () => $6e9a14e5d204592e$export$2e2bcd8739ae039);

var $eOIKd = parcelRequire("eOIKd");
function $6e9a14e5d204592e$export$2e2bcd8739ae039(t, e) {
    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
    t.prototype = Object.create(e && e.prototype, {
        constructor: {
            value: t,
            writable: !0,
            configurable: !0
        }
    }), Object.defineProperty(t, "prototype", {
        writable: !1
    }), e && (0, $eOIKd.default)(t, e);
}

});
parcelRegister("eOIKd", function(module, exports) {
$parcel$export(module.exports, "default", () => $ac987182995d3ee6$export$2e2bcd8739ae039);
function $ac987182995d3ee6$export$2e2bcd8739ae039(t, e) {
    return $ac987182995d3ee6$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, $ac987182995d3ee6$export$2e2bcd8739ae039(t, e);
}

});


parcelRegister("lBLAm", function(module, exports) {
$parcel$export(module.exports, "default", () => $fbb1f72c8b5dc7f4$export$2e2bcd8739ae039);

var $dUoTc = parcelRequire("dUoTc");
function $fbb1f72c8b5dc7f4$export$2e2bcd8739ae039(e, r, t) {
    return (r = (0, $dUoTc.default)(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}

});

parcelRegister("vq8Ju", function(module, exports) {
// TODO(Babel 8): Remove this file.

var $05e72c31cfb7a198$var$runtime = (parcelRequire("hiOMe"))();
module.exports = $05e72c31cfb7a198$var$runtime;
// Copied from https://github.com/facebook/regenerator/blob/main/packages/runtime/runtime.js#L736=
try {
    regeneratorRuntime = $05e72c31cfb7a198$var$runtime;
} catch (accidentalStrictMode) {
    if (typeof globalThis === "object") globalThis.regeneratorRuntime = $05e72c31cfb7a198$var$runtime;
    else Function("r", "regeneratorRuntime = r")($05e72c31cfb7a198$var$runtime);
}

});

parcelRegister("if8j9", function(module, exports) {
$parcel$export(module.exports, "retryOnException", () => $d4801276263466a1$export$1d94629c94e7a17f);

var $lzihu = parcelRequire("lzihu");

var $7bQhm = parcelRequire("7bQhm");

var $1tkiV = parcelRequire("1tkiV");

var $2CZjQ = parcelRequire("2CZjQ");

var $d912J = parcelRequire("d912J");

var $glLdS = parcelRequire("glLdS");
var $d4801276263466a1$export$5c069c93d2b7493f = function wait(ms) {
    return new Promise(function(resolve) {
        setTimeout(resolve, ms);
    });
};
var $d4801276263466a1$var$NO_CALLS_ERROR = 'No calls made';
var $d4801276263466a1$export$1d94629c94e7a17f = /*#__PURE__*/ function() {
    var _ref2 = (0, $7bQhm.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1tkiV))).mark(function _callee(invokeOperation, _ref) {
        var _ref$intervalsMS, intervalsMS, _ref$retryOn, retryOn, captureException, onRetry, intervals, nextMSInterval, error, _t;
        return (0, (/*@__PURE__*/$parcel$interopDefault($1tkiV))).wrap(function(_context) {
            while(true)switch(_context.prev = _context.next){
                case 0:
                    _ref$intervalsMS = _ref.intervalsMS, intervalsMS = _ref$intervalsMS === void 0 ? (0, $d912J.NO_RETRIES) : _ref$intervalsMS, _ref$retryOn = _ref.retryOn, retryOn = _ref$retryOn === void 0 ? [
                        (0, $glLdS.default)
                    ] : _ref$retryOn, captureException = _ref.captureException, onRetry = _ref.onRetry;
                    intervals = (0, $lzihu.default)(intervalsMS);
                    nextMSInterval = 0;
                    error = new Error($d4801276263466a1$var$NO_CALLS_ERROR);
                case 1:
                    if (!(nextMSInterval !== undefined)) {
                        _context.next = 6;
                        break;
                    }
                    _context.prev = 2;
                    if (!(nextMSInterval > 0)) {
                        _context.next = 3;
                        break;
                    }
                    _context.next = 3;
                    return $d4801276263466a1$export$5c069c93d2b7493f(nextMSInterval);
                case 3:
                    if (onRetry && error.message !== $d4801276263466a1$var$NO_CALLS_ERROR) onRetry(error);
                    _context.next = 4;
                    return invokeOperation();
                case 4:
                    return _context.abrupt("return", _context.sent);
                case 5:
                    _context.prev = 5;
                    _t = _context["catch"](2);
                    error = (0, $2CZjQ.default)(_t);
                    if (captureException) captureException(error);
                    // Retry ONLY when the error is an instance of one of the provided `retryOn` errors, or passes the `retryOn` test.
                    // You need to ensure you are throwing one of the `retryOn` errors if that is the method you are using.
                    if (typeof retryOn === 'function' ? retryOn(error) : retryOn.some(function(err) {
                        return error instanceof err;
                    })) nextMSInterval = intervals.shift();
                    else nextMSInterval = undefined;
                    _context.next = 1;
                    break;
                case 6:
                    throw error;
                case 7:
                case "end":
                    return _context.stop();
            }
        }, _callee, null, [
            [
                2,
                5
            ]
        ]);
    }));
    return function retryOnException(_x, _x2) {
        return _ref2.apply(this, arguments);
    };
}();

});
parcelRegister("lzihu", function(module, exports) {
$parcel$export(module.exports, "default", () => $fb3b0c1e54e17dec$export$2e2bcd8739ae039);

var $ktiSN = parcelRequire("ktiSN");

var $9HGfR = parcelRequire("9HGfR");

var $4L7XY = parcelRequire("4L7XY");

var $aCA4G = parcelRequire("aCA4G");
function $fb3b0c1e54e17dec$export$2e2bcd8739ae039(r) {
    return (0, $ktiSN.default)(r) || (0, $9HGfR.default)(r) || (0, $4L7XY.default)(r) || (0, $aCA4G.default)();
}

});
parcelRegister("ktiSN", function(module, exports) {
$parcel$export(module.exports, "default", () => $ee7529cc411df034$export$2e2bcd8739ae039);

var $2iiDz = parcelRequire("2iiDz");
function $ee7529cc411df034$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return (0, $2iiDz.default)(r);
}

});
parcelRegister("2iiDz", function(module, exports) {
$parcel$export(module.exports, "default", () => $1abbb830d0ffaa12$export$2e2bcd8739ae039);
function $1abbb830d0ffaa12$export$2e2bcd8739ae039(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}

});


parcelRegister("9HGfR", function(module, exports) {
$parcel$export(module.exports, "default", () => $7108e820c10da899$export$2e2bcd8739ae039);
function $7108e820c10da899$export$2e2bcd8739ae039(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}

});

parcelRegister("4L7XY", function(module, exports) {
$parcel$export(module.exports, "default", () => $3771bb247a9ac0b9$export$2e2bcd8739ae039);

var $2iiDz = parcelRequire("2iiDz");
function $3771bb247a9ac0b9$export$2e2bcd8739ae039(r, a) {
    if (r) {
        if ("string" == typeof r) return (0, $2iiDz.default)(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? (0, $2iiDz.default)(r, a) : void 0;
    }
}

});

parcelRegister("aCA4G", function(module, exports) {
$parcel$export(module.exports, "default", () => $7bb96fa085c3d7ac$export$2e2bcd8739ae039);
function $7bb96fa085c3d7ac$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});


parcelRegister("7bQhm", function(module, exports) {
$parcel$export(module.exports, "default", () => $53c21d0091803c4c$export$2e2bcd8739ae039);
function $53c21d0091803c4c$var$asyncGeneratorStep(n, t, e, r, o, a, c) {
    try {
        var i = n[a](c), u = i.value;
    } catch (n) {
        return void e(n);
    }
    i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function $53c21d0091803c4c$export$2e2bcd8739ae039(n) {
    return function() {
        var t = this, e = arguments;
        return new Promise(function(r, o) {
            var a = n.apply(t, e);
            function _next(n) {
                $53c21d0091803c4c$var$asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
            }
            function _throw(n) {
                $53c21d0091803c4c$var$asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
            }
            _next(void 0);
        });
    };
}

});

parcelRegister("1tkiV", function(module, exports) {
// TODO(Babel 8): Remove this file.

var $11283fdfea2c36ad$var$runtime = (parcelRequire("hd2Rf"))();
module.exports = $11283fdfea2c36ad$var$runtime;
// Copied from https://github.com/facebook/regenerator/blob/main/packages/runtime/runtime.js#L736=
try {
    regeneratorRuntime = $11283fdfea2c36ad$var$runtime;
} catch (accidentalStrictMode) {
    if (typeof globalThis === "object") globalThis.regeneratorRuntime = $11283fdfea2c36ad$var$runtime;
    else Function("r", "regeneratorRuntime = r")($11283fdfea2c36ad$var$runtime);
}

});

parcelRegister("2CZjQ", function(module, exports) {
$parcel$export(module.exports, "default", () => $1e9eb2122c30125c$export$2e2bcd8739ae039);

var $jCdDl = parcelRequire("jCdDl");
var $1e9eb2122c30125c$var$convertToError = function convertToError(e) {
    var error;
    if (e instanceof Error) error = e;
    else if (typeof e === 'string') error = new Error(e);
    else if ((0, $jCdDl.default)(e) === 'object') try {
        error = new Error('Object error instance thrown for operation: ' + JSON.stringify(e));
    } catch (jsonError) {
        error = new Error('Object serialisation error thrown during operation: ' + String(e));
    }
    else error = new Error('No error instance thrown for operation: ' + String(e));
    return error;
};
var $1e9eb2122c30125c$export$2e2bcd8739ae039 = $1e9eb2122c30125c$var$convertToError;

});
parcelRegister("jCdDl", function(module, exports) {
$parcel$export(module.exports, "default", () => $e47c244c78f740f5$export$2e2bcd8739ae039);
function $e47c244c78f740f5$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $e47c244c78f740f5$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $e47c244c78f740f5$export$2e2bcd8739ae039(o);
}

});


parcelRegister("d912J", function(module, exports) {
$parcel$export(module.exports, "NO_RETRIES", () => $991cecc2dbab0cce$export$a0a1c8f90becc136);
var $991cecc2dbab0cce$export$a0a1c8f90becc136 = [];
var $991cecc2dbab0cce$export$972171517b12aa4 = [
    0,
    0
];
var $991cecc2dbab0cce$export$746d2203ed8cdc40 = [
    0,
    50,
    100
];
var $991cecc2dbab0cce$export$f6858378b665f957 = [
    100,
    500,
    1000
];

});

parcelRegister("glLdS", function(module, exports) {
$parcel$export(module.exports, "default", () => $be733cf6ad53c8ee$export$2e2bcd8739ae039);

var $lgMVF = parcelRequire("lgMVF");

var $a1lar = parcelRequire("a1lar");

var $Bizn4 = parcelRequire("Bizn4");

var $2c72B = parcelRequire("2c72B");

var $6ZnJZ = parcelRequire("6ZnJZ");

var $hqk5A = parcelRequire("hqk5A");
function $be733cf6ad53c8ee$var$_callSuper(t, o, e) {
    return o = (0, $2c72B.default)(o), (0, $Bizn4.default)(t, $be733cf6ad53c8ee$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, $2c72B.default)(t).constructor) : o.apply(t, e));
}
function $be733cf6ad53c8ee$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($be733cf6ad53c8ee$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $be733cf6ad53c8ee$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_Error) {
    function FailedFetchError(_ref) {
        var _this;
        var error = _ref.error, path = _ref.path, method = _ref.method;
        (0, $a1lar.default)(this, FailedFetchError);
        _this = $be733cf6ad53c8ee$var$_callSuper(this, FailedFetchError);
        _this.name = 'FailedFetchError';
        _this.message = error.message || 'Unknown fetch error';
        _this.stack = error.stack;
        _this.originalName = error.name;
        _this.method = method;
        var p = path.split('?')[0];
        _this.path = /^[/-a-z]+$/i.test(p) ? p : '';
        return _this;
    }
    (0, $6ZnJZ.default)(FailedFetchError, _Error);
    return (0, $lgMVF.default)(FailedFetchError);
}(/*#__PURE__*/ (0, $hqk5A.default)(Error));

});
parcelRegister("lgMVF", function(module, exports) {
$parcel$export(module.exports, "default", () => $f7c10be6fb7128a1$export$2e2bcd8739ae039);

var $eStyP = parcelRequire("eStyP");
function $f7c10be6fb7128a1$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, (0, $eStyP.default)(o.key), o);
    }
}
function $f7c10be6fb7128a1$export$2e2bcd8739ae039(e, r, t) {
    return r && $f7c10be6fb7128a1$var$_defineProperties(e.prototype, r), t && $f7c10be6fb7128a1$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}

});
parcelRegister("eStyP", function(module, exports) {
$parcel$export(module.exports, "default", () => $ad4d09fe77089878$export$2e2bcd8739ae039);

var $jCdDl = parcelRequire("jCdDl");

var $8hzz6 = parcelRequire("8hzz6");
function $ad4d09fe77089878$export$2e2bcd8739ae039(t) {
    var i = (0, $8hzz6.default)(t, "string");
    return "symbol" == (0, $jCdDl.default)(i) ? i : i + "";
}

});
parcelRegister("8hzz6", function(module, exports) {
$parcel$export(module.exports, "default", () => $607b7fc6db013df5$export$2e2bcd8739ae039);

var $jCdDl = parcelRequire("jCdDl");
function $607b7fc6db013df5$export$2e2bcd8739ae039(t, r) {
    if ("object" != (0, $jCdDl.default)(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (0, $jCdDl.default)(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}

});



parcelRegister("a1lar", function(module, exports) {
$parcel$export(module.exports, "default", () => $74ba6acd5ed871a4$export$2e2bcd8739ae039);
function $74ba6acd5ed871a4$export$2e2bcd8739ae039(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}

});

parcelRegister("Bizn4", function(module, exports) {
$parcel$export(module.exports, "default", () => $0701dc55116aad2d$export$2e2bcd8739ae039);

var $jCdDl = parcelRequire("jCdDl");

var $bCPYG = parcelRequire("bCPYG");
function $0701dc55116aad2d$export$2e2bcd8739ae039(t, e) {
    if (e && ("object" == (0, $jCdDl.default)(e) || "function" == typeof e)) return e;
    if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
    return (0, $bCPYG.default)(t);
}

});
parcelRegister("bCPYG", function(module, exports) {
$parcel$export(module.exports, "default", () => $876b9005e60b9911$export$2e2bcd8739ae039);
function $876b9005e60b9911$export$2e2bcd8739ae039(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
}

});


parcelRegister("2c72B", function(module, exports) {
$parcel$export(module.exports, "default", () => $199229efde23557f$export$2e2bcd8739ae039);
function $199229efde23557f$export$2e2bcd8739ae039(t) {
    return $199229efde23557f$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
        return t.__proto__ || Object.getPrototypeOf(t);
    }, $199229efde23557f$export$2e2bcd8739ae039(t);
}

});

parcelRegister("6ZnJZ", function(module, exports) {
$parcel$export(module.exports, "default", () => $516adb02dfe1fe2c$export$2e2bcd8739ae039);

var $4Ktce = parcelRequire("4Ktce");
function $516adb02dfe1fe2c$export$2e2bcd8739ae039(t, e) {
    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
    t.prototype = Object.create(e && e.prototype, {
        constructor: {
            value: t,
            writable: !0,
            configurable: !0
        }
    }), Object.defineProperty(t, "prototype", {
        writable: !1
    }), e && (0, $4Ktce.default)(t, e);
}

});
parcelRegister("4Ktce", function(module, exports) {
$parcel$export(module.exports, "default", () => $37521b0ffbf46730$export$2e2bcd8739ae039);
function $37521b0ffbf46730$export$2e2bcd8739ae039(t, e) {
    return $37521b0ffbf46730$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, $37521b0ffbf46730$export$2e2bcd8739ae039(t, e);
}

});


parcelRegister("hqk5A", function(module, exports) {
$parcel$export(module.exports, "default", () => $caf472a4ba968cf9$export$2e2bcd8739ae039);

var $2c72B = parcelRequire("2c72B");

var $4Ktce = parcelRequire("4Ktce");

var $fXKaq = parcelRequire("fXKaq");

var $ddR9D = parcelRequire("ddR9D");
function $caf472a4ba968cf9$export$2e2bcd8739ae039(t) {
    var r = "function" == typeof Map ? new Map() : void 0;
    return $caf472a4ba968cf9$export$2e2bcd8739ae039 = function _wrapNativeSuper(t) {
        if (null === t || !(0, $fXKaq.default)(t)) return t;
        if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function");
        if (void 0 !== r) {
            if (r.has(t)) return r.get(t);
            r.set(t, Wrapper);
        }
        function Wrapper() {
            return (0, $ddR9D.default)(t, arguments, (0, $2c72B.default)(this).constructor);
        }
        return Wrapper.prototype = Object.create(t.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: !1,
                writable: !0,
                configurable: !0
            }
        }), (0, $4Ktce.default)(Wrapper, t);
    }, $caf472a4ba968cf9$export$2e2bcd8739ae039(t);
}

});
parcelRegister("fXKaq", function(module, exports) {
$parcel$export(module.exports, "default", () => $b9f02d8f9693f6e5$export$2e2bcd8739ae039);
function $b9f02d8f9693f6e5$export$2e2bcd8739ae039(t) {
    try {
        return -1 !== Function.toString.call(t).indexOf("[native code]");
    } catch (n) {
        return "function" == typeof t;
    }
}

});

parcelRegister("ddR9D", function(module, exports) {
$parcel$export(module.exports, "default", () => $9a05b8a0c718a657$export$2e2bcd8739ae039);

var $ha4B8 = parcelRequire("ha4B8");

var $4Ktce = parcelRequire("4Ktce");
function $9a05b8a0c718a657$export$2e2bcd8739ae039(t, e, r) {
    if ((0, $ha4B8.default)()) return Reflect.construct.apply(null, arguments);
    var o = [
        null
    ];
    o.push.apply(o, e);
    var p = new (t.bind.apply(t, o))();
    return r && (0, $4Ktce.default)(p, r.prototype), p;
}

});
parcelRegister("ha4B8", function(module, exports) {
$parcel$export(module.exports, "default", () => $c7e6efe88a809f95$export$2e2bcd8739ae039);
function $c7e6efe88a809f95$export$2e2bcd8739ae039() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($c7e6efe88a809f95$export$2e2bcd8739ae039 = function _isNativeReflectConstruct() {
        return !!t;
    })();
}

});





parcelRegister("Ck9cD", function(module, exports) {
$parcel$export(module.exports, "AbstractAccountClient", () => $07332d95adb00e35$export$b8a928589413ca97);

var $br94z = parcelRequire("br94z");

var $4xzmZ = parcelRequire("4xzmZ");

var $diyh3 = parcelRequire("diyh3");
var $07332d95adb00e35$export$b8a928589413ca97 = /*#__PURE__*/ function() {
    /** @override */ function AbstractAccountClient(config) {
        (0, $br94z.default)(this, AbstractAccountClient);
        this._config = (0, $diyh3.resolveConfig)(config);
    }
    /** @override */ return (0, $4xzmZ.default)(AbstractAccountClient, [
        {
            key: "getManageProfileLink",
            value: /** @override */ function getManageProfileLink(user) {
                return this.getSessionSyncLink("".concat(this._config.identityEnvironment.baseUrl, "/manage-profile"), user);
            }
        },
        {
            key: "getSessionSyncLink",
            value: function getSessionSyncLink(destination, user) {
                if (user) {
                    var url = this._createLink({
                        continueUrl: destination,
                        loginHint: {
                            type: 'email-address',
                            email: user.email
                        }
                    });
                    url.pathname = '/login';
                    url.searchParams.append('prompt', 'none');
                    return url.toString();
                } else return destination;
            }
        },
        {
            key: "getLoginLink",
            value: function getLoginLink() {
                var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, _ref$continueUrl = _ref.continueUrl, continueUrl = _ref$continueUrl === void 0 ? this._config.defaultContinueUrl : _ref$continueUrl;
                var url = this._createLink({
                    continueUrl: continueUrl
                });
                url.pathname = '/login';
                return url.toString();
            }
        },
        {
            key: "getSwitchAccountLink",
            value: function getSwitchAccountLink() {
                var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, _ref2$continueUrl = _ref2.continueUrl, continueUrl = _ref2$continueUrl === void 0 ? this._config.defaultContinueUrl : _ref2$continueUrl, loginHint = _ref2.loginHint;
                var url = this._createLink({
                    continueUrl: continueUrl,
                    loginHint: loginHint
                });
                url.pathname = '/login';
                url.searchParams.append('prompt', 'select_account');
                return url.toString();
            }
        },
        {
            key: "getLogoutLink",
            value: function getLogoutLink() {
                var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, _ref3$continueUrl = _ref3.continueUrl, continueUrl = _ref3$continueUrl === void 0 ? this._config.defaultLogoutContinueUrl : _ref3$continueUrl;
                var url = this._createLink({
                    continueUrl: continueUrl
                });
                url.pathname = '/logout';
                url.searchParams.append('prompt', 'none');
                return url.toString();
            }
        },
        {
            key: "_createLink",
            value: function _createLink(_ref4) {
                var continueUrl = _ref4.continueUrl, loginHint = _ref4.loginHint;
                var url = new URL(this._config.identityEnvironment.baseUrl);
                if (this._config.application) url.searchParams.append('application', this._config.application);
                url.searchParams.append('continue', continueUrl);
                if (loginHint) url.searchParams.append('login_hint', loginHint.type === 'not-email-address' ? "not:".concat(loginHint.email) : loginHint.email);
                return url;
            }
        }
    ]);
}();

});
parcelRegister("diyh3", function(module, exports) {
$parcel$export(module.exports, "resolveConfig", () => $9ae78aed5f5c9a08$export$7eca4ea16d4c8343);

var $lBLAm = parcelRequire("lBLAm");
function $9ae78aed5f5c9a08$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $9ae78aed5f5c9a08$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $9ae78aed5f5c9a08$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $lBLAm.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $9ae78aed5f5c9a08$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $9ae78aed5f5c9a08$export$7eca4ea16d4c8343(config) {
    var identityEnvironment = config.identityEnvironment, _config$perimeter = config.perimeter, perimeter = _config$perimeter === void 0 ? 'commercial' : _config$perimeter;
    var environment = typeof identityEnvironment === 'string' ? $9ae78aed5f5c9a08$var$environments[perimeter][identityEnvironment] : $9ae78aed5f5c9a08$var$_objectSpread({}, identityEnvironment); // copy to prevent modification;
    if (!environment) throw new Error("No such IdentityEnvironment '".concat(identityEnvironment, "' in Perimeter '").concat(perimeter, "'"));
    return $9ae78aed5f5c9a08$var$_objectSpread($9ae78aed5f5c9a08$var$_objectSpread({}, config), {}, {
        identityEnvironment: environment,
        perimeter: perimeter,
        defaultLogoutContinueUrl: config.defaultLogoutContinueUrl || config.defaultContinueUrl
    });
}
var $9ae78aed5f5c9a08$var$environments = {
    commercial: {
        dev: {
            baseUrl: 'https://id-domain.dev.internal.atlassian.com'
        },
        stg: {
            baseUrl: 'https://id.stg.internal.atlassian.com'
        },
        prod: {
            baseUrl: 'https://id.atlassian.com'
        }
    },
    'fedramp-moderate': {
        stg: {
            baseUrl: 'https://id.stg.atlassian-us-gov-mod.com'
        },
        prod: {
            baseUrl: 'https://id.atlassian-us-gov-mod.com'
        }
    }
};

});




parcelRegister("f54a7", function(module, exports) {
$parcel$export(module.exports, "useBitbucketWorkspaces", () => $8132d361137eda3d$export$8bf857d5a9c0ddbd);

var $5FkrB = parcelRequire("5FkrB");

var $6hgMx = parcelRequire("6hgMx");
function $8132d361137eda3d$export$8bf857d5a9c0ddbd() {
    const info = (0, $6hgMx.useInfo)();
    const availableBitbucketWorkspaces = (0, $5FkrB.useMemo)(()=>info.availableBitbucketWorkspaces ?? [], [
        info.availableBitbucketWorkspaces
    ]);
    // An empty list means there is nothing to grant, so Bitbucket sits this
    // consent out entirely: no selector, no policy check, no submitted param.
    const isBitbucketWorkspaceAccessEnabled = availableBitbucketWorkspaces.length > 0;
    const [selectedBitbucketWorkspace, setSelectedBitbucketWorkspace] = (0, $5FkrB.useState)(null);
    // Drop the selection if it is no longer among the available workspaces
    // (e.g. /consent/info changed).
    (0, $5FkrB.useEffect)(()=>{
        setSelectedBitbucketWorkspace((current)=>current && !availableBitbucketWorkspaces.some((ws)=>ws.ari === current.ari) ? null : current);
    }, [
        availableBitbucketWorkspaces
    ]);
    return {
        isBitbucketWorkspaceAccessEnabled: isBitbucketWorkspaceAccessEnabled,
        availableBitbucketWorkspaces: availableBitbucketWorkspaces,
        selectedBitbucketWorkspace: selectedBitbucketWorkspace,
        setSelectedBitbucketWorkspace: setSelectedBitbucketWorkspace
    };
}

});

parcelRegister("ir4ge", function(module, exports) {
$parcel$export(module.exports, "useBitbucketPolicy", () => $c124fbdc31d63044$export$54c646985c2e4e2f);

var $5FkrB = parcelRequire("5FkrB");

var $8LFYh = parcelRequire("8LFYh");

var $guDjK = parcelRequire("guDjK");

var $dnJFI = parcelRequire("dnJFI");

var $Qy2AT = parcelRequire("Qy2AT");
function $c124fbdc31d63044$export$54c646985c2e4e2f({ token: token, isEnabled: isEnabled, selectedBitbucketWorkspace: selectedBitbucketWorkspace, onToolsetsLoaded: onToolsetsLoaded }) {
    const analyticsClient = (0, $guDjK.useAnalytics)();
    const [policyState, dispatch] = (0, $5FkrB.useReducer)((0, $Qy2AT.policyReducer), {
        status: 'idle'
    });
    (0, $5FkrB.useEffect)(()=>{
        if (token.serviceType !== 'MCP') return;
        if (!isEnabled || !selectedBitbucketWorkspace) {
            dispatch({
                type: 'RESET'
            });
            return;
        }
        const requestKey = (0, $Qy2AT.getPolicyRequestKey)(token.raw, [
            selectedBitbucketWorkspace.ari
        ]);
        const ac = new AbortController();
        dispatch({
            type: 'LOADING',
            requestKey: requestKey
        });
        (async ()=>{
            try {
                const result = await (0, $8LFYh.fetchWorkspacePolicyCheck)({
                    contextJwt: token.raw,
                    selectedWorkspace: selectedBitbucketWorkspace.ari
                }, ac.signal);
                if (ac.signal.aborted) return;
                if (!result.ok) {
                    // 403 client_disabled: an admin disabled the app (or its system
                    // account) for the org that owns this workspace.
                    const clientDisabled = (0, $8LFYh.isClientDisabledFailure)(result);
                    const errorKind = clientDisabled ? (0, $Qy2AT.MCP_POLICY_ERROR_KIND).clientDisabled : (0, $Qy2AT.MCP_POLICY_ERROR_KIND).policyFetchFailed;
                    dispatch({
                        type: 'ERROR',
                        requestKey: requestKey,
                        errorMessage: result.errorMessage,
                        errorKind: errorKind,
                        errorWorkspaceName: clientDisabled ? selectedBitbucketWorkspace.name : null
                    });
                    analyticsClient.pushTrackEvent({
                        actionSubject: 'mcpPolicyCheck',
                        action: 'failed',
                        source: 'oauthConsentScreen',
                        attributes: {
                            reason: errorKind
                        }
                    });
                    return;
                }
                if (!result.data.redirectAllowed) {
                    dispatch({
                        type: 'ERROR',
                        requestKey: requestKey,
                        errorMessage: null,
                        errorKind: (0, $Qy2AT.MCP_POLICY_ERROR_KIND).redirectNotAllowed
                    });
                    analyticsClient.pushTrackEvent({
                        actionSubject: 'mcpPolicyCheck',
                        action: 'failed',
                        source: 'oauthConsentScreen',
                        attributes: {
                            reason: (0, $Qy2AT.MCP_POLICY_ERROR_KIND).redirectNotAllowed
                        }
                    });
                    return;
                }
                const byIntent = (0, $dnJFI.parseMcpPolicyData)(result.data).byIntent;
                dispatch({
                    type: 'SUCCESS',
                    requestKey: requestKey,
                    byIntent: byIntent,
                    // Cross-org scope removal is a Trello-only concept.
                    crossOrgScopesRemoved: false
                });
                onToolsetsLoaded((0, $dnJFI.getToolsetNames)(byIntent));
            } catch (e) {
                if (e instanceof DOMException && e.name === 'AbortError' || ac.signal.aborted) return;
                dispatch({
                    type: 'ERROR',
                    requestKey: requestKey,
                    errorMessage: e instanceof Error ? e.message : 'Unexpected error',
                    errorKind: (0, $Qy2AT.MCP_POLICY_ERROR_KIND).unexpected
                });
            }
        })();
        return ()=>{
            ac.abort();
        };
    }, [
        token,
        isEnabled,
        selectedBitbucketWorkspace,
        analyticsClient,
        onToolsetsLoaded
    ]);
    return (0, $Qy2AT.getPolicyStateForRequest)(policyState, isEnabled && selectedBitbucketWorkspace ? (0, $Qy2AT.getPolicyRequestKey)(token.raw, [
        selectedBitbucketWorkspace.ari
    ]) : null);
}

});
parcelRegister("Qy2AT", function(module, exports) {
$parcel$export(module.exports, "MCP_POLICY_STATUS", () => $f64efb567fb08745$export$5f31aad5101b7e6d);
$parcel$export(module.exports, "MCP_POLICY_ERROR_KIND", () => $f64efb567fb08745$export$a41eba310d15cf20);
$parcel$export(module.exports, "getOrderedPolicySources", () => $f64efb567fb08745$export$e55b1b64e767524f);
$parcel$export(module.exports, "getCombinedPolicyStatus", () => $f64efb567fb08745$export$97ad3dbedfcf5de6);
$parcel$export(module.exports, "getPrimaryPolicyErrorSource", () => $f64efb567fb08745$export$7873fda14ed09174);
$parcel$export(module.exports, "grantedNoPermissions", () => $f64efb567fb08745$export$d3810366ea691c97);
$parcel$export(module.exports, "needsNoPermissionsEmptyState", () => $f64efb567fb08745$export$43c6599937a0d43d);
$parcel$export(module.exports, "hasFailedPolicyCheck", () => $f64efb567fb08745$export$59f1b5e799529298);
$parcel$export(module.exports, "getPolicyRequestKey", () => $f64efb567fb08745$export$bac601396c24e95c);
$parcel$export(module.exports, "getPolicyStateForRequest", () => $f64efb567fb08745$export$79be151ce6ce4d86);
$parcel$export(module.exports, "policyReducer", () => $f64efb567fb08745$export$beeac609885a0576);
const $f64efb567fb08745$export$5f31aad5101b7e6d = {
    idle: 'idle',
    loading: 'loading',
    success: 'success',
    error: 'error'
};
const $f64efb567fb08745$export$a41eba310d15cf20 = {
    policyFetchFailed: 'policyFetchFailed',
    redirectNotAllowed: 'redirectNotAllowed',
    missingRedirect: 'missingRedirect',
    workspaceAccessRevoked: 'workspaceAccessRevoked',
    clientDisabled: 'clientDisabled',
    unexpected: 'unexpected'
};
const $f64efb567fb08745$export$1bf866b2fc812683 = {
    site: {
        status: 'idle'
    },
    trello: {
        status: 'idle'
    },
    bitbucket: {
        status: 'idle'
    }
};
function $f64efb567fb08745$export$e55b1b64e767524f(scopeClassification) {
    return scopeClassification.hasTrello && !scopeClassification.hasAtlassian ? [
        'trello'
    ] : [
        'site',
        'trello',
        'bitbucket'
    ];
}
function $f64efb567fb08745$export$97ad3dbedfcf5de6(policies, orderedSources) {
    const statuses = orderedSources.map((source)=>policies[source].status);
    if (statuses.includes('loading')) return 'loading';
    if (statuses.includes('error')) return 'error';
    if (statuses.includes('success')) return 'success';
    return 'idle';
}
function $f64efb567fb08745$export$7873fda14ed09174(policies, orderedSources) {
    return orderedSources.find((source)=>policies[source].status === 'error') ?? null;
}
function $f64efb567fb08745$export$d3810366ea691c97(policy) {
    return policy.status === 'success' && policy.byIntent.length === 0;
}
function $f64efb567fb08745$export$43c6599937a0d43d(policies) {
    return $f64efb567fb08745$export$d3810366ea691c97(policies.trello);
}
function $f64efb567fb08745$export$59f1b5e799529298(policies, orderedSources) {
    return orderedSources.some((source)=>policies[source].status === 'error');
}
function $f64efb567fb08745$export$bac601396c24e95c(contextJwt, targets) {
    return JSON.stringify([
        contextJwt,
        targets
    ]);
}
function $f64efb567fb08745$export$79be151ce6ce4d86(policy, requestKey) {
    if (requestKey == null) return {
        status: 'idle'
    };
    if (policy.status === 'idle') return policy;
    return policy.requestKey == null || policy.requestKey === requestKey ? policy : {
        status: 'idle'
    };
}
function $f64efb567fb08745$export$beeac609885a0576(_, action) {
    switch(action.type){
        case 'RESET':
            return {
                status: 'idle'
            };
        case 'LOADING':
            return {
                status: 'loading',
                requestKey: action.requestKey
            };
        case 'SUCCESS':
            return {
                status: 'success',
                requestKey: action.requestKey,
                byIntent: action.byIntent,
                crossOrgScopesRemoved: action.crossOrgScopesRemoved
            };
        case 'ERROR':
            return {
                status: 'error',
                requestKey: action.requestKey,
                errorMessage: action.errorMessage,
                errorKind: action.errorKind,
                errorWorkspaceName: action.errorWorkspaceName ?? null
            };
    }
}

});


parcelRegister("kd2vk", function(module, exports) {
$parcel$export(module.exports, "useOrgMatch", () => $77c4e69e841b6b86$export$776d66468d69b77e);

var $5FkrB = parcelRequire("5FkrB");

var $6hgMx = parcelRequire("6hgMx");

var $gUxXX = parcelRequire("gUxXX");
function $77c4e69e841b6b86$export$776d66468d69b77e({ applies: applies, selectedWorkspace: selectedWorkspace, selectedBitbucketWorkspace: selectedBitbucketWorkspace }) {
    const info = (0, $6hgMx.useInfo)();
    const siteOrgIndex = (0, $5FkrB.useMemo)(()=>(0, $gUxXX.buildSiteOrgIndex)(info), [
        info.availableOrganizations
    ]);
    return (0, $5FkrB.useMemo)(()=>{
        if (!applies) return {
            siteOrgId: null,
            bitbucketOrgId: null,
            hasOrgMismatch: false,
            siteOrgIndex: siteOrgIndex
        };
        const siteOrgId = (0, $gUxXX.resolveSiteOrgId)(siteOrgIndex, selectedWorkspace);
        const bitbucketOrgId = selectedBitbucketWorkspace?.orgId ?? null;
        return {
            siteOrgId: siteOrgId,
            bitbucketOrgId: bitbucketOrgId,
            hasOrgMismatch: (0, $gUxXX.isOrgMismatch)(siteOrgId, bitbucketOrgId),
            siteOrgIndex: siteOrgIndex
        };
    }, [
        applies,
        siteOrgIndex,
        selectedWorkspace,
        selectedBitbucketWorkspace
    ]);
}

});
parcelRegister("gUxXX", function(module, exports) {
$parcel$export(module.exports, "buildSiteOrgIndex", () => $88216c0be75d3bd5$export$b391904d433371b7);
$parcel$export(module.exports, "resolveSiteOrgId", () => $88216c0be75d3bd5$export$b27d0e5b1b370893);
$parcel$export(module.exports, "isOrgMismatch", () => $88216c0be75d3bd5$export$faca11d435682c11);
$parcel$export(module.exports, "getOrgOptionState", () => $88216c0be75d3bd5$export$9e681d6b92e2281b);
/**
 * Compare site URLs on their bare host.
 *
 * `availableWorkspaces` and `availableSites[].url` are bare hosts, while
 * `units[].workspaces[].workspaceUrl` carries a scheme, so the two sources only
 * line up once the scheme and any trailing slash are stripped.
 */ function $88216c0be75d3bd5$var$normalizeSiteUrl(rawUrl) {
    const url = rawUrl?.trim().replace(/^https?:\/\//i, '').replace(/\/+$/, '');
    return url ? url.toLowerCase() : null;
}
function $88216c0be75d3bd5$export$b391904d433371b7(info) {
    const index = new Map();
    const claim = (rawUrl, orgId)=>{
        const url = $88216c0be75d3bd5$var$normalizeSiteUrl(rawUrl);
        if (url && !index.has(url)) index.set(url, orgId);
    };
    for (const org of info.availableOrganizations ?? []){
        if (!org?.orgId) continue;
        for (const workspace of org.availableWorkspaces ?? [])claim(workspace, org.orgId);
    }
    for (const org of info.availableOrganizations ?? []){
        if (!org?.orgId) continue;
        for (const unit of org.units ?? [])for (const workspace of unit.workspaces ?? []){
            claim(workspace.workspaceUrl, org.orgId);
            claim(workspace.cloudUrl, org.orgId);
        }
    }
    return index;
}
function $88216c0be75d3bd5$export$b27d0e5b1b370893(index, siteUrl) {
    const url = $88216c0be75d3bd5$var$normalizeSiteUrl(siteUrl);
    return url && index.get(url) || null;
}
function $88216c0be75d3bd5$export$faca11d435682c11(siteOrgId, bitbucketOrgId) {
    return siteOrgId != null && bitbucketOrgId != null && siteOrgId !== bitbucketOrgId;
}
function $88216c0be75d3bd5$export$9e681d6b92e2281b({ items: items, otherOrgId: otherOrgId, getOrgId: getOrgId, canShowHelp: canShowHelp }) {
    if (!otherOrgId) return {
        helpKind: 'none'
    };
    const isItemDisabled = (item)=>$88216c0be75d3bd5$export$faca11d435682c11(getOrgId(item), otherOrgId);
    const disabledCount = items.filter(isItemDisabled).length;
    return {
        isItemDisabled: isItemDisabled,
        helpKind: !canShowHelp || disabledCount === 0 ? 'none' : disabledCount === items.length ? 'empty' : 'constraint'
    };
}

});


parcelRegister("3UXNA", function(module, exports) {
$parcel$export(module.exports, "normalizeTrelloWorkspaceSelection", () => $571d8f677a82807b$export$3d3928cf3d28cc4a);
$parcel$export(module.exports, "getInitialTrelloWorkspaceSelection", () => $571d8f677a82807b$export$24d3e2273077099b);
$parcel$export(module.exports, "isTrelloWorkspaceSelectable", () => $571d8f677a82807b$export$4945e7383169dea7);
$parcel$export(module.exports, "hasEnterpriseTrelloWorkspace", () => $571d8f677a82807b$export$49ec9a1ac748fea4);
$parcel$export(module.exports, "compareTrelloWorkspacesByName", () => $571d8f677a82807b$export$b1939a54b40bf4ad);
$parcel$export(module.exports, "sortTrelloWorkspacesByName", () => $571d8f677a82807b$export$4f529acce1cd9982);
$parcel$export(module.exports, "compareTrelloWorkspacesByEnterpriseThenName", () => $571d8f677a82807b$export$86cbbb7a75583e19);
function $571d8f677a82807b$var$getSelectedOrganizationId(workspaces) {
    return workspaces[0]?.atlassianOrganizationId ?? null;
}
function $571d8f677a82807b$var$keepSameOrganizationAsFirst(workspaces) {
    const selectedOrganizationId = $571d8f677a82807b$var$getSelectedOrganizationId(workspaces);
    return workspaces.filter((workspace)=>(workspace.atlassianOrganizationId ?? null) === selectedOrganizationId);
}
function $571d8f677a82807b$export$3d3928cf3d28cc4a(workspaces, isMultiSelectEnabled) {
    if (workspaces.length <= 1) return workspaces;
    return isMultiSelectEnabled ? $571d8f677a82807b$var$keepSameOrganizationAsFirst(workspaces) : workspaces.slice(0, 1);
}
function $571d8f677a82807b$export$24d3e2273077099b(workspaces) {
    if (workspaces.length === 1) return [
        workspaces[0]
    ];
    return [];
}
function $571d8f677a82807b$export$4945e7383169dea7({ workspace: workspace, selectedWorkspaces: selectedWorkspaces, isMultiSelectEnabled: isMultiSelectEnabled }) {
    if (!isMultiSelectEnabled || selectedWorkspaces.length === 0) return true;
    return (workspace.atlassianOrganizationId ?? null) === $571d8f677a82807b$var$getSelectedOrganizationId([
        ...selectedWorkspaces
    ]);
}
function $571d8f677a82807b$export$49ec9a1ac748fea4(workspaces) {
    return workspaces.some((workspace)=>workspace.atlassianOrganizationId != null);
}
function $571d8f677a82807b$export$b1939a54b40bf4ad(a, b) {
    return a.displayName.localeCompare(b.displayName, undefined, {
        sensitivity: 'base',
        numeric: true
    });
}
function $571d8f677a82807b$export$4f529acce1cd9982(workspaces) {
    return [
        ...workspaces
    ].sort($571d8f677a82807b$export$b1939a54b40bf4ad);
}
function $571d8f677a82807b$export$86cbbb7a75583e19(a, b) {
    const aIsEnterprise = a.atlassianOrganizationId != null;
    const bIsEnterprise = b.atlassianOrganizationId != null;
    if (aIsEnterprise !== bIsEnterprise) return aIsEnterprise ? -1 : 1;
    return $571d8f677a82807b$export$b1939a54b40bf4ad(a, b);
}

});

parcelRegister("h7OTL", function(module, exports) {
$parcel$export(module.exports, "hasTrelloScopes", () => $71d207db12226960$export$b70a68eb0c1c5e6f);
$parcel$export(module.exports, "hasTrelloInboxPlannerScopes", () => $71d207db12226960$export$260d2ee378d8bacb);
$parcel$export(module.exports, "hasAtlassianScopes", () => $71d207db12226960$export$66d222645b5c4ee2);
$parcel$export(module.exports, "classifyScopes", () => $71d207db12226960$export$4e8bc09fb98cbe1);
$parcel$export(module.exports, "classifyScopesWithOverride", () => $71d207db12226960$export$744627ce59d214d6);
/**
 * Trello scope detection utilities for MCP consent.
 *
 * Trello scopes follow the pattern `action:resource:trello` (e.g. `read:board:trello`).
 *
 * When the consent token contains Trello scopes, the MCP consent screen shows a
 * Trello workspace selector alongside (or instead of) the Atlassian site selector.
 */ 
var $g1jVQ = parcelRequire("g1jVQ");
function $71d207db12226960$export$d470da48cb37e159(scope) {
    return scope.endsWith(':trello');
}
function $71d207db12226960$export$b70a68eb0c1c5e6f(scopes) {
    return scopes.some($71d207db12226960$export$d470da48cb37e159);
}
const $71d207db12226960$export$440003ea53e32e31 = new Set([
    ...(0, $g1jVQ.MCP_DEFAULT_SCOPES),
    // OIDC scopes — see src/definitions/oidc.ts
    'openid',
    'profile',
    'email'
]);
/** Returns true if any scope in the list is a non-Trello (Atlassian) scope. */ const $71d207db12226960$var$INBOX_PLANNER_SCOPE_PATTERN = /^(read|write):member\.(inbox|planner):trello$/;
function $71d207db12226960$export$260d2ee378d8bacb(scopes) {
    return scopes.some((scope)=>$71d207db12226960$var$INBOX_PLANNER_SCOPE_PATTERN.test(scope));
}
function $71d207db12226960$export$66d222645b5c4ee2(scopes) {
    return scopes.some((s)=>!$71d207db12226960$export$d470da48cb37e159(s) && !$71d207db12226960$export$440003ea53e32e31.has(s));
}
function $71d207db12226960$export$4e8bc09fb98cbe1(scopes) {
    return {
        hasTrello: $71d207db12226960$export$b70a68eb0c1c5e6f(scopes),
        hasAtlassian: $71d207db12226960$export$66d222645b5c4ee2(scopes)
    };
}
function $71d207db12226960$export$744627ce59d214d6(scopes, hasTrelloProductAccess, mixedWorkspaceGateEnabled = false) {
    const hasAtlassian = $71d207db12226960$export$66d222645b5c4ee2(scopes);
    const hasTrello = hasTrelloProductAccess === true && $71d207db12226960$export$b70a68eb0c1c5e6f(scopes);
    return {
        hasTrello: hasTrello && (mixedWorkspaceGateEnabled || !hasAtlassian),
        hasAtlassian: hasAtlassian
    };
}

});
parcelRegister("g1jVQ", function(module, exports) {
$parcel$export(module.exports, "MCP_DEFAULT_SCOPES", () => $a04d666ed4396857$export$a16a5f0e811df4b5);
$parcel$export(module.exports, "buildMcpSelectedScopesForPost", () => $a04d666ed4396857$export$22bfc659949ada7e);
const $a04d666ed4396857$export$a16a5f0e811df4b5 = [
    'read:me',
    'read:account',
    'offline_access'
];
const $a04d666ed4396857$export$43d04d0019961196 = [
    'openid',
    'email',
    'profile'
];
function $a04d666ed4396857$export$cf2163a0b26c9013(toolsetNames, toolsets) {
    const byName = new Map(toolsets.map((t)=>[
            t.name,
            t
        ]));
    const out = new Set();
    for (const name of toolsetNames){
        const def = byName.get(name);
        if (!def) continue;
        for (const s of def.scopes)out.add(s);
    }
    return [
        ...out
    ].sort();
}
function $a04d666ed4396857$export$22bfc659949ada7e(selectedNames, toolsets, requestedScopes = []) {
    const requested = new Set(requestedScopes);
    return [
        ...new Set([
            ...$a04d666ed4396857$export$a16a5f0e811df4b5,
            ...$a04d666ed4396857$export$cf2163a0b26c9013(selectedNames, toolsets),
            ...$a04d666ed4396857$export$43d04d0019961196.filter((s)=>requested.has(s))
        ])
    ];
}

});



parcelRegister("3RbwF", function(module, exports) {
$parcel$export(module.exports, "TRELLO_WORKSPACE_PAGE_SIZE", () => $92c7b433464b1c55$export$d4aa8849edd5eca6);
$parcel$export(module.exports, "getTrelloWorkspaceUrl", () => $92c7b433464b1c55$export$546716a183fc98cb);
/**
 * Trello-specific types for MCP consent.
 *
 * These types are used by the TrelloWorkspaceSelector and McpContextProvider
 * to manage Trello workspace selection in the MCP consent flow.
 */ 
var $9KGFe = parcelRequire("9KGFe");
const $92c7b433464b1c55$export$d4aa8849edd5eca6 = 20;
function $92c7b433464b1c55$export$546716a183fc98cb(workspace) {
    const { shortName: shortName } = workspace;
    if (!shortName) return null;
    return /[./]/.test(shortName) ? shortName : `${(0, $9KGFe.getConfig)().trello.webHost}/w/${shortName}`;
}

});

parcelRegister("kHgfX", function(module, exports) {

var $iKwew = parcelRequire("iKwew");
module.exports = $iKwew("aOd6i").then(()=>parcelRequire('hzInV'));

});

parcelRegister("lRhHj", function(module, exports) {

var $iKwew = parcelRequire("iKwew");
module.exports = $iKwew("i4HqB").then(()=>parcelRequire('eWS7H'));

});

parcelRegister("bvGJV", function(module, exports) {

var $iKwew = parcelRequire("iKwew");
module.exports = $iKwew("cYmof").then(()=>parcelRequire('6wNun'));

});

parcelRegister("jae7A", function(module, exports) {

var $iKwew = parcelRequire("iKwew");
module.exports = $iKwew("jzN43").then(()=>parcelRequire('gmnhf'));

});

parcelRegister("hoPPq", function(module, exports) {

var $iKwew = parcelRequire("iKwew");
module.exports = $iKwew("gQq0x").then(()=>parcelRequire('eekDu'));

});

parcelRegister("dQrN2", function(module, exports) {

var $iKwew = parcelRequire("iKwew");
module.exports = $iKwew("1pi3D").then(()=>parcelRequire('h242j'));

});

parcelRegister("8aMe7", function(module, exports) {

var $iKwew = parcelRequire("iKwew");
module.exports = $iKwew("83m4H").then(()=>parcelRequire('7Fnwf'));

});

parcelRegister("dQ0Ca", function(module, exports) {

var $iKwew = parcelRequire("iKwew");
module.exports = $iKwew("6AIx5").then(()=>parcelRequire('gq1st'));

});

parcelRegister("90MIr", function(module, exports) {

var $iKwew = parcelRequire("iKwew");
module.exports = $iKwew("cDN2P").then(()=>parcelRequire('2ruGH'));

});

parcelRegister("8WJXk", function(module, exports) {

var $iKwew = parcelRequire("iKwew");
module.exports = $iKwew("66jmJ").then(()=>parcelRequire('gPSKR'));

});

parcelRegister("d9nPO", function(module, exports) {

var $iKwew = parcelRequire("iKwew");
module.exports = $iKwew("g7enF").then(()=>parcelRequire('gMDOB'));

});

parcelRegister("jj0xI", function(module, exports) {

var $iKwew = parcelRequire("iKwew");
module.exports = $iKwew("dszjR").then(()=>parcelRequire('fLdKB'));

});

parcelRegister("324GR", function(module, exports) {

var $iKwew = parcelRequire("iKwew");
module.exports = $iKwew("cGqK9").then(()=>parcelRequire('kX9y9'));

});

parcelRegister("71S74", function(module, exports) {

var $iKwew = parcelRequire("iKwew");
module.exports = $iKwew("jHQHx").then(()=>parcelRequire('81XEK'));

});

parcelRegister("jlXqg", function(module, exports) {

var $iKwew = parcelRequire("iKwew");
module.exports = $iKwew("frRxL").then(()=>parcelRequire('kw5pm'));

});

parcelRegister("4e5mi", function(module, exports) {

var $iKwew = parcelRequire("iKwew");
module.exports = $iKwew("ijrSd").then(()=>parcelRequire('bV7EH'));

});

parcelRegister("e4wiJ", function(module, exports) {

var $iKwew = parcelRequire("iKwew");
module.exports = $iKwew("kmWEf").then(()=>parcelRequire('6M0La'));

});

parcelRegister("ieemf", function(module, exports) {

var $iKwew = parcelRequire("iKwew");
module.exports = $iKwew("kfWTX").then(()=>parcelRequire('3bkWK'));

});

parcelRegister("7xzx8", function(module, exports) {

var $iKwew = parcelRequire("iKwew");
module.exports = $iKwew("gFhZP").then(()=>parcelRequire('97vx4'));

});

parcelRegister("6n0r0", function(module, exports) {

var $iKwew = parcelRequire("iKwew");
module.exports = $iKwew("7Czaw").then(()=>parcelRequire('lrLg4'));

});

parcelRegister("9nX3d", function(module, exports) {

var $iKwew = parcelRequire("iKwew");
module.exports = $iKwew("3KQ8R").then(()=>parcelRequire('hNBdE'));

});

parcelRegister("7Viz1", function(module, exports) {

var $iKwew = parcelRequire("iKwew");
module.exports = $iKwew("be4ZE").then(()=>parcelRequire('lXRD6'));

});

parcelRegister("AOvE8", function(module, exports) {

var $iKwew = parcelRequire("iKwew");
module.exports = $iKwew("fy5ri").then(()=>parcelRequire('bweKn'));

});

parcelRegister("3rjyv", function(module, exports) {

var $iKwew = parcelRequire("iKwew");
module.exports = $iKwew("i8bB7").then(()=>parcelRequire('kk8Qh'));

});

parcelRegister("jBcYC", function(module, exports) {

var $iKwew = parcelRequire("iKwew");
module.exports = $iKwew("5DIKG").then(()=>parcelRequire('2yZ4r'));

});

parcelRegister("dtahh", function(module, exports) {

var $kNQwB = parcelRequire("kNQwB");
var $9ce5f4b98e25635a$var$_typeof = $kNQwB.default;
function $9ce5f4b98e25635a$var$_regeneratorRuntime() {
    "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ 
    module.exports = $9ce5f4b98e25635a$var$_regeneratorRuntime = function _regeneratorRuntime() {
        return e;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports;
    var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function(t, e, r) {
        t[e] = r.value;
    }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag";
    function define(t, e, r) {
        return Object.defineProperty(t, e, {
            value: r,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }), t[e];
    }
    try {
        define({}, "");
    } catch (t) {
        define = function define(t, e, r) {
            return t[e] = r;
        };
    }
    function wrap(t, e, r, n) {
        var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []);
        return o(a, "_invoke", {
            value: makeInvokeMethod(t, r, c)
        }), a;
    }
    function tryCatch(t, e, r) {
        try {
            return {
                type: "normal",
                arg: t.call(e, r)
            };
        } catch (t) {
            return {
                type: "throw",
                arg: t
            };
        }
    }
    e.wrap = wrap;
    var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {};
    function Generator() {}
    function GeneratorFunction() {}
    function GeneratorFunctionPrototype() {}
    var p = {};
    define(p, a, function() {
        return this;
    });
    var d = Object.getPrototypeOf, v = d && d(d(values([])));
    v && v !== r && n.call(v, a) && (p = v);
    var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p);
    function defineIteratorMethods(t) {
        [
            "next",
            "throw",
            "return"
        ].forEach(function(e) {
            define(t, e, function(t) {
                return this._invoke(e, t);
            });
        });
    }
    function AsyncIterator(t, e) {
        function invoke(r, o, i, a) {
            var c = tryCatch(t[r], t, o);
            if ("throw" !== c.type) {
                var u = c.arg, h = u.value;
                return h && "object" == $9ce5f4b98e25635a$var$_typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function(t) {
                    invoke("next", t, i, a);
                }, function(t) {
                    invoke("throw", t, i, a);
                }) : e.resolve(h).then(function(t) {
                    u.value = t, i(u);
                }, function(t) {
                    return invoke("throw", t, i, a);
                });
            }
            a(c.arg);
        }
        var r;
        o(this, "_invoke", {
            value: function value(t, n) {
                function callInvokeWithMethodAndArg() {
                    return new e(function(e, r) {
                        invoke(t, n, e, r);
                    });
                }
                return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
            }
        });
    }
    function makeInvokeMethod(e, r, n) {
        var o = h;
        return function(i, a) {
            if (o === f) throw Error("Generator is already running");
            if (o === s) {
                if ("throw" === i) throw a;
                return {
                    value: t,
                    done: !0
                };
            }
            for(n.method = i, n.arg = a;;){
                var c = n.delegate;
                if (c) {
                    var u = maybeInvokeDelegate(c, n);
                    if (u) {
                        if (u === y) continue;
                        return u;
                    }
                }
                if ("next" === n.method) n.sent = n._sent = n.arg;
                else if ("throw" === n.method) {
                    if (o === h) throw o = s, n.arg;
                    n.dispatchException(n.arg);
                } else "return" === n.method && n.abrupt("return", n.arg);
                o = f;
                var p = tryCatch(e, r, n);
                if ("normal" === p.type) {
                    if (o = n.done ? s : l, p.arg === y) continue;
                    return {
                        value: p.arg,
                        done: n.done
                    };
                }
                "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg);
            }
        };
    }
    function maybeInvokeDelegate(e, r) {
        var n = r.method, o = e.iterator[n];
        if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y;
        var i = tryCatch(o, e.iterator, r.arg);
        if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y;
        var a = i.arg;
        return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y);
    }
    function pushTryEntry(t) {
        var e = {
            tryLoc: t[0]
        };
        1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e);
    }
    function resetTryEntry(t) {
        var e = t.completion || {};
        e.type = "normal", delete e.arg, t.completion = e;
    }
    function Context(t) {
        this.tryEntries = [
            {
                tryLoc: "root"
            }
        ], t.forEach(pushTryEntry, this), this.reset(!0);
    }
    function values(e) {
        if (e || "" === e) {
            var r = e[a];
            if (r) return r.call(e);
            if ("function" == typeof e.next) return e;
            if (!isNaN(e.length)) {
                var o = -1, i = function next() {
                    for(; ++o < e.length;)if (n.call(e, o)) return next.value = e[o], next.done = !1, next;
                    return next.value = t, next.done = !0, next;
                };
                return i.next = i;
            }
        }
        throw new TypeError($9ce5f4b98e25635a$var$_typeof(e) + " is not iterable");
    }
    return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", {
        value: GeneratorFunctionPrototype,
        configurable: !0
    }), o(GeneratorFunctionPrototype, "constructor", {
        value: GeneratorFunction,
        configurable: !0
    }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function(t) {
        var e = "function" == typeof t && t.constructor;
        return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name));
    }, e.mark = function(t) {
        return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t;
    }, e.awrap = function(t) {
        return {
            __await: t
        };
    }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function() {
        return this;
    }), e.AsyncIterator = AsyncIterator, e.async = function(t, r, n, o, i) {
        void 0 === i && (i = Promise);
        var a = new AsyncIterator(wrap(t, r, n, o), i);
        return e.isGeneratorFunction(r) ? a : a.next().then(function(t) {
            return t.done ? t.value : a.next();
        });
    }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function() {
        return this;
    }), define(g, "toString", function() {
        return "[object Generator]";
    }), e.keys = function(t) {
        var e = Object(t), r = [];
        for(var n in e)r.push(n);
        return r.reverse(), function next() {
            for(; r.length;){
                var t = r.pop();
                if (t in e) return next.value = t, next.done = !1, next;
            }
            return next.done = !0, next;
        };
    }, e.values = values, Context.prototype = {
        constructor: Context,
        reset: function reset(e) {
            if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for(var r in this)"t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t);
        },
        stop: function stop() {
            this.done = !0;
            var t = this.tryEntries[0].completion;
            if ("throw" === t.type) throw t.arg;
            return this.rval;
        },
        dispatchException: function dispatchException(e) {
            if (this.done) throw e;
            var r = this;
            function handle(n, o) {
                return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o;
            }
            for(var o = this.tryEntries.length - 1; o >= 0; --o){
                var i = this.tryEntries[o], a = i.completion;
                if ("root" === i.tryLoc) return handle("end");
                if (i.tryLoc <= this.prev) {
                    var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc");
                    if (c && u) {
                        if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
                        if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
                    } else if (c) {
                        if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
                    } else {
                        if (!u) throw Error("try statement without catch or finally");
                        if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
                    }
                }
            }
        },
        abrupt: function abrupt(t, e) {
            for(var r = this.tryEntries.length - 1; r >= 0; --r){
                var o = this.tryEntries[r];
                if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
                    var i = o;
                    break;
                }
            }
            i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null);
            var a = i ? i.completion : {};
            return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a);
        },
        complete: function complete(t, e) {
            if ("throw" === t.type) throw t.arg;
            return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y;
        },
        finish: function finish(t) {
            for(var e = this.tryEntries.length - 1; e >= 0; --e){
                var r = this.tryEntries[e];
                if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y;
            }
        },
        "catch": function _catch(t) {
            for(var e = this.tryEntries.length - 1; e >= 0; --e){
                var r = this.tryEntries[e];
                if (r.tryLoc === t) {
                    var n = r.completion;
                    if ("throw" === n.type) {
                        var o = n.arg;
                        resetTryEntry(r);
                    }
                    return o;
                }
            }
            throw Error("illegal catch attempt");
        },
        delegateYield: function delegateYield(e, r, n) {
            return this.delegate = {
                iterator: values(e),
                resultName: r,
                nextLoc: n
            }, "next" === this.method && (this.arg = t), y;
        }
    }, e;
}
module.exports = $9ce5f4b98e25635a$var$_regeneratorRuntime, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("kNQwB", function(module, exports) {
function $f25120975d7d44cb$var$_typeof(o) {
    "@babel/helpers - typeof";
    return module.exports = $f25120975d7d44cb$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $f25120975d7d44cb$var$_typeof(o);
}
module.exports = $f25120975d7d44cb$var$_typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("f3AnC", function(module, exports) {

var $8lNtc = parcelRequire("8lNtc");
var $af635b22d79fa650$var$_typeof = $8lNtc.default;
function $af635b22d79fa650$var$_regeneratorRuntime() {
    "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ 
    module.exports = $af635b22d79fa650$var$_regeneratorRuntime = function _regeneratorRuntime() {
        return e;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports;
    var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function(t, e, r) {
        t[e] = r.value;
    }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag";
    function define(t, e, r) {
        return Object.defineProperty(t, e, {
            value: r,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }), t[e];
    }
    try {
        define({}, "");
    } catch (t) {
        define = function define(t, e, r) {
            return t[e] = r;
        };
    }
    function wrap(t, e, r, n) {
        var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []);
        return o(a, "_invoke", {
            value: makeInvokeMethod(t, r, c)
        }), a;
    }
    function tryCatch(t, e, r) {
        try {
            return {
                type: "normal",
                arg: t.call(e, r)
            };
        } catch (t) {
            return {
                type: "throw",
                arg: t
            };
        }
    }
    e.wrap = wrap;
    var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {};
    function Generator() {}
    function GeneratorFunction() {}
    function GeneratorFunctionPrototype() {}
    var p = {};
    define(p, a, function() {
        return this;
    });
    var d = Object.getPrototypeOf, v = d && d(d(values([])));
    v && v !== r && n.call(v, a) && (p = v);
    var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p);
    function defineIteratorMethods(t) {
        [
            "next",
            "throw",
            "return"
        ].forEach(function(e) {
            define(t, e, function(t) {
                return this._invoke(e, t);
            });
        });
    }
    function AsyncIterator(t, e) {
        function invoke(r, o, i, a) {
            var c = tryCatch(t[r], t, o);
            if ("throw" !== c.type) {
                var u = c.arg, h = u.value;
                return h && "object" == $af635b22d79fa650$var$_typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function(t) {
                    invoke("next", t, i, a);
                }, function(t) {
                    invoke("throw", t, i, a);
                }) : e.resolve(h).then(function(t) {
                    u.value = t, i(u);
                }, function(t) {
                    return invoke("throw", t, i, a);
                });
            }
            a(c.arg);
        }
        var r;
        o(this, "_invoke", {
            value: function value(t, n) {
                function callInvokeWithMethodAndArg() {
                    return new e(function(e, r) {
                        invoke(t, n, e, r);
                    });
                }
                return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
            }
        });
    }
    function makeInvokeMethod(e, r, n) {
        var o = h;
        return function(i, a) {
            if (o === f) throw Error("Generator is already running");
            if (o === s) {
                if ("throw" === i) throw a;
                return {
                    value: t,
                    done: !0
                };
            }
            for(n.method = i, n.arg = a;;){
                var c = n.delegate;
                if (c) {
                    var u = maybeInvokeDelegate(c, n);
                    if (u) {
                        if (u === y) continue;
                        return u;
                    }
                }
                if ("next" === n.method) n.sent = n._sent = n.arg;
                else if ("throw" === n.method) {
                    if (o === h) throw o = s, n.arg;
                    n.dispatchException(n.arg);
                } else "return" === n.method && n.abrupt("return", n.arg);
                o = f;
                var p = tryCatch(e, r, n);
                if ("normal" === p.type) {
                    if (o = n.done ? s : l, p.arg === y) continue;
                    return {
                        value: p.arg,
                        done: n.done
                    };
                }
                "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg);
            }
        };
    }
    function maybeInvokeDelegate(e, r) {
        var n = r.method, o = e.iterator[n];
        if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y;
        var i = tryCatch(o, e.iterator, r.arg);
        if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y;
        var a = i.arg;
        return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y);
    }
    function pushTryEntry(t) {
        var e = {
            tryLoc: t[0]
        };
        1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e);
    }
    function resetTryEntry(t) {
        var e = t.completion || {};
        e.type = "normal", delete e.arg, t.completion = e;
    }
    function Context(t) {
        this.tryEntries = [
            {
                tryLoc: "root"
            }
        ], t.forEach(pushTryEntry, this), this.reset(!0);
    }
    function values(e) {
        if (e || "" === e) {
            var r = e[a];
            if (r) return r.call(e);
            if ("function" == typeof e.next) return e;
            if (!isNaN(e.length)) {
                var o = -1, i = function next() {
                    for(; ++o < e.length;)if (n.call(e, o)) return next.value = e[o], next.done = !1, next;
                    return next.value = t, next.done = !0, next;
                };
                return i.next = i;
            }
        }
        throw new TypeError($af635b22d79fa650$var$_typeof(e) + " is not iterable");
    }
    return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", {
        value: GeneratorFunctionPrototype,
        configurable: !0
    }), o(GeneratorFunctionPrototype, "constructor", {
        value: GeneratorFunction,
        configurable: !0
    }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function(t) {
        var e = "function" == typeof t && t.constructor;
        return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name));
    }, e.mark = function(t) {
        return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t;
    }, e.awrap = function(t) {
        return {
            __await: t
        };
    }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function() {
        return this;
    }), e.AsyncIterator = AsyncIterator, e.async = function(t, r, n, o, i) {
        void 0 === i && (i = Promise);
        var a = new AsyncIterator(wrap(t, r, n, o), i);
        return e.isGeneratorFunction(r) ? a : a.next().then(function(t) {
            return t.done ? t.value : a.next();
        });
    }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function() {
        return this;
    }), define(g, "toString", function() {
        return "[object Generator]";
    }), e.keys = function(t) {
        var e = Object(t), r = [];
        for(var n in e)r.push(n);
        return r.reverse(), function next() {
            for(; r.length;){
                var t = r.pop();
                if (t in e) return next.value = t, next.done = !1, next;
            }
            return next.done = !0, next;
        };
    }, e.values = values, Context.prototype = {
        constructor: Context,
        reset: function reset(e) {
            if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for(var r in this)"t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t);
        },
        stop: function stop() {
            this.done = !0;
            var t = this.tryEntries[0].completion;
            if ("throw" === t.type) throw t.arg;
            return this.rval;
        },
        dispatchException: function dispatchException(e) {
            if (this.done) throw e;
            var r = this;
            function handle(n, o) {
                return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o;
            }
            for(var o = this.tryEntries.length - 1; o >= 0; --o){
                var i = this.tryEntries[o], a = i.completion;
                if ("root" === i.tryLoc) return handle("end");
                if (i.tryLoc <= this.prev) {
                    var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc");
                    if (c && u) {
                        if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
                        if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
                    } else if (c) {
                        if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
                    } else {
                        if (!u) throw Error("try statement without catch or finally");
                        if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
                    }
                }
            }
        },
        abrupt: function abrupt(t, e) {
            for(var r = this.tryEntries.length - 1; r >= 0; --r){
                var o = this.tryEntries[r];
                if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
                    var i = o;
                    break;
                }
            }
            i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null);
            var a = i ? i.completion : {};
            return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a);
        },
        complete: function complete(t, e) {
            if ("throw" === t.type) throw t.arg;
            return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y;
        },
        finish: function finish(t) {
            for(var e = this.tryEntries.length - 1; e >= 0; --e){
                var r = this.tryEntries[e];
                if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y;
            }
        },
        "catch": function _catch(t) {
            for(var e = this.tryEntries.length - 1; e >= 0; --e){
                var r = this.tryEntries[e];
                if (r.tryLoc === t) {
                    var n = r.completion;
                    if ("throw" === n.type) {
                        var o = n.arg;
                        resetTryEntry(r);
                    }
                    return o;
                }
            }
            throw Error("illegal catch attempt");
        },
        delegateYield: function delegateYield(e, r, n) {
            return this.delegate = {
                iterator: values(e),
                resultName: r,
                nextLoc: n
            }, "next" === this.method && (this.arg = t), y;
        }
    }, e;
}
module.exports = $af635b22d79fa650$var$_regeneratorRuntime, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("8lNtc", function(module, exports) {
function $0191a7e168e265f8$var$_typeof(o) {
    "@babel/helpers - typeof";
    return module.exports = $0191a7e168e265f8$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $0191a7e168e265f8$var$_typeof(o);
}
module.exports = $0191a7e168e265f8$var$_typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;

});



var $i3UfC = parcelRequire("i3UfC");
var $7d59b24134129acf$exports = {};
'use strict';
function $7d59b24134129acf$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($7d59b24134129acf$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$7d59b24134129acf$var$checkDCE();

$7d59b24134129acf$exports = (parcelRequire("hLm8s"));




var $i3UfC = parcelRequire("i3UfC");

var $5FkrB = parcelRequire("5FkrB");
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled, @typescript-eslint/consistent-type-imports

var $2nBsU = parcelRequire("2nBsU");
// dimension vars
var $efd2be1bf5c3a2eb$export$cbfb0f5b2869b17b = 'leftPanelWidth';
var $efd2be1bf5c3a2eb$export$a30f2e00489a8957 = 'leftSidebarWidth';
var $efd2be1bf5c3a2eb$export$c103b605cd368aed = 'rightSidebarWidth';
var $efd2be1bf5c3a2eb$export$fa34f417972d6341 = 'rightPanelWidth';
var $efd2be1bf5c3a2eb$export$3a6a779d9181047c = 'topNavigationHeight';
var $efd2be1bf5c3a2eb$export$bcd94a6a792e7f96 = 'bannerHeight';
var $efd2be1bf5c3a2eb$export$b6744d31294864fd = 'leftSidebarFlyoutWidth';
var $efd2be1bf5c3a2eb$export$344062f7cfc9528e = 'left-panel';
var $efd2be1bf5c3a2eb$export$c7139cc2d6110b5f = 'right-panel';
var $efd2be1bf5c3a2eb$export$238d30785c4bca84 = 'banner';
var $efd2be1bf5c3a2eb$export$bec6dca2e63de4ae = 'top-navigation';
var $efd2be1bf5c3a2eb$export$d1213e82613ff4df = 'content';
var $efd2be1bf5c3a2eb$export$be83e7118304b28e = 56;
var $efd2be1bf5c3a2eb$export$4a98ee0bd1ae362 = 56;
var $efd2be1bf5c3a2eb$export$539e68c09584883a = 240;
var $efd2be1bf5c3a2eb$export$b92df8810d2fcd01 = 280;
var $efd2be1bf5c3a2eb$export$c3e41153b9288bcf = 368;
var $efd2be1bf5c3a2eb$export$c4d6152f86ea28f6 = 368;
var $efd2be1bf5c3a2eb$export$46acf8758e9e2636 = 20;
var $efd2be1bf5c3a2eb$export$70740f5ad8360a78 = 16;
var $efd2be1bf5c3a2eb$export$991d5285ad765a3d = 240;
var $efd2be1bf5c3a2eb$export$6949d4f32b161684 = 200;
var $efd2be1bf5c3a2eb$export$d6e7e8af042815bb = 350;
var $efd2be1bf5c3a2eb$export$3749e1104328fde4 = 300;
var $efd2be1bf5c3a2eb$export$1074d925b0b82be5 = 200;
var $efd2be1bf5c3a2eb$export$451e84a45a9e4a75 = 'DS_PAGE_LAYOUT_UI_STATE';
var $efd2be1bf5c3a2eb$export$802bb2c050f3db5c = 'data-is-sidebar-dragging';
var $efd2be1bf5c3a2eb$export$5e5e1875c3fd8f4f = 'data-is-sidebar-collapsing';
var $efd2be1bf5c3a2eb$export$70c702a8c5895f03 = 'data-grab-area-line';
var $efd2be1bf5c3a2eb$export$48a43f91e4becf4e = 'data-grab-area';
var $efd2be1bf5c3a2eb$export$dac2fb31a9f6844d = 'data-resize-button';
var $efd2be1bf5c3a2eb$export$9ecd22db14e6c70e = 'data-resize-control';
var $efd2be1bf5c3a2eb$export$5253dd9707b8c3ba = 'data-ds--page-layout--slot';
var $efd2be1bf5c3a2eb$export$206a08f7f8beb554 = 'Skip to:';
var $efd2be1bf5c3a2eb$export$659ee746b31b360d = 'data-layout-container';
var $efd2be1bf5c3a2eb$export$f963aecf2d4465bd = "var(--".concat($efd2be1bf5c3a2eb$export$cbfb0f5b2869b17b, ", 0px)");
var $efd2be1bf5c3a2eb$export$750459958906793 = "var(--".concat($efd2be1bf5c3a2eb$export$fa34f417972d6341, ", 0px)");
var $efd2be1bf5c3a2eb$export$f897e1ed9f8ed251 = "var(--".concat($efd2be1bf5c3a2eb$export$a30f2e00489a8957, ", 0px)");
var $efd2be1bf5c3a2eb$export$b44ab66843c05a69 = "var(--".concat($efd2be1bf5c3a2eb$export$c103b605cd368aed, ", 0px)");
var $efd2be1bf5c3a2eb$export$aeff86a16f13529 = "var(--".concat($efd2be1bf5c3a2eb$export$3a6a779d9181047c, ", 0px)");
var $efd2be1bf5c3a2eb$export$ed7cc0d417ee89e = "var(--".concat($efd2be1bf5c3a2eb$export$bcd94a6a792e7f96, ", 0px)");
var $efd2be1bf5c3a2eb$export$d2fa14f05b61e66 = "var(--".concat($efd2be1bf5c3a2eb$export$b6744d31294864fd, ", ").concat($efd2be1bf5c3a2eb$export$991d5285ad765a3d, "px)");


var $0b354a69a2959049$var$contentStyles = (0, $2nBsU.css)({
    display: 'flex',
    height: '100%',
    position: 'relative',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    gridArea: (0, $efd2be1bf5c3a2eb$export$d1213e82613ff4df)
});
/**
 * __Content__
 *
 * Provides a slot for your application content within the PageLayout.
 *
 * - [Examples](https://atlassian.design/components/page-layout/examples)
 * - [Code](https://atlassian.design/components/page-layout/code)
 *
 * @deprecated `@atlaskit/page-layout` is deprecated. Use `@atlaskit/navigation-system` instead.
 */ var $0b354a69a2959049$var$Content = function Content(props) {
    var children = props.children, testId = props.testId;
    return (0, $2nBsU.jsx)("div", {
        "data-testid": testId,
        css: $0b354a69a2959049$var$contentStyles
    }, children);
};
var $0b354a69a2959049$export$2e2bcd8739ae039 = $0b354a69a2959049$var$Content;

function $b65104b70faead20$export$2e2bcd8739ae039() {
    return $b65104b70faead20$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $b65104b70faead20$export$2e2bcd8739ae039.apply(null, arguments);
}


function $ec3f76b68921e912$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $ec3f76b68921e912$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $ec3f76b68921e912$export$2e2bcd8739ae039(o);
}



function $872da6118c324a77$export$2e2bcd8739ae039(t, r) {
    if ("object" != (0, $ec3f76b68921e912$export$2e2bcd8739ae039)(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (0, $ec3f76b68921e912$export$2e2bcd8739ae039)(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}


function $5034698ee3fdca70$export$2e2bcd8739ae039(t) {
    var i = (0, $872da6118c324a77$export$2e2bcd8739ae039)(t, "string");
    return "symbol" == (0, $ec3f76b68921e912$export$2e2bcd8739ae039)(i) ? i : i + "";
}


function $75c03925a1a6ef46$export$2e2bcd8739ae039(e, r, t) {
    return (r = (0, $5034698ee3fdca70$export$2e2bcd8739ae039)(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}



var $5FkrB = parcelRequire("5FkrB");

var $2nBsU = parcelRequire("2nBsU");

var $86b286ad5c089076$export$987d49ffe1b0900f = {
    above: {
        xxs: '@media all',
        xs: '@media (min-width: 30rem)',
        sm: '@media (min-width: 48rem)',
        md: '@media (min-width: 64rem)',
        lg: '@media (min-width: 90rem)',
        xl: '@media (min-width: 110.5rem)'
    },
    only: {
        xxs: '@media (min-width: 0rem) and (max-width: 29.99rem)',
        xs: '@media (min-width: 30rem) and (max-width: 47.99rem)',
        sm: '@media (min-width: 48rem) and (max-width: 63.99rem)',
        md: '@media (min-width: 64rem) and (max-width: 89.99rem)',
        lg: '@media (min-width: 90rem) and (max-width: 110.49rem)',
        xl: '@media (min-width: 110.5rem)'
    },
    below: {
        xs: '@media not all and (min-width: 30rem)',
        sm: '@media not all and (min-width: 48rem)',
        md: '@media not all and (min-width: 64rem)',
        lg: '@media not all and (min-width: 90rem)',
        xl: '@media not all and (min-width: 110.5rem)'
    }
};


var $92693c60dc1696c3$export$c881183ca713c214 = (0, $86b286ad5c089076$export$987d49ffe1b0900f);



function $e793b4d232f50a31$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return r;
}


function $bd49773988e56201$export$2e2bcd8739ae039(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}


function $d6f13e99a310feb2$export$2e2bcd8739ae039(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}


function $507c36b7d60c8fd6$export$2e2bcd8739ae039(r, a) {
    if (r) {
        if ("string" == typeof r) return (0, $d6f13e99a310feb2$export$2e2bcd8739ae039)(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? (0, $d6f13e99a310feb2$export$2e2bcd8739ae039)(r, a) : void 0;
    }
}


function $9af7c144bdb0838b$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}


function $f0700d30f2885170$export$2e2bcd8739ae039(r, e) {
    return (0, $e793b4d232f50a31$export$2e2bcd8739ae039)(r) || (0, $bd49773988e56201$export$2e2bcd8739ae039)(r, e) || (0, $507c36b7d60c8fd6$export$2e2bcd8739ae039)(r, e) || (0, $9af7c144bdb0838b$export$2e2bcd8739ae039)();
}



var $5FkrB = parcelRequire("5FkrB");
var $5b617c1f48263075$exports = {};
"use strict";
Object.defineProperty($5b617c1f48263075$exports, "__esModule", {
    value: true
});
$5b617c1f48263075$exports.bindAll = $5b617c1f48263075$exports.bind = void 0;
var $bae1c2098f2dd253$exports = {};
"use strict";
Object.defineProperty($bae1c2098f2dd253$exports, "__esModule", {
    value: true
});
$bae1c2098f2dd253$exports.bind = void 0;
function $bae1c2098f2dd253$var$bind(target, _a) {
    var type = _a.type, listener = _a.listener, options = _a.options;
    target.addEventListener(type, listener, options);
    return function unbind() {
        target.removeEventListener(type, listener, options);
    };
}
$bae1c2098f2dd253$exports.bind = $bae1c2098f2dd253$var$bind;


Object.defineProperty($5b617c1f48263075$exports, "bind", {
    enumerable: true,
    get: function() {
        return $bae1c2098f2dd253$exports.bind;
    }
});
var $f6f23e2d6cc820f3$exports = {};
"use strict";
var $f6f23e2d6cc820f3$var$__assign = $f6f23e2d6cc820f3$exports && $f6f23e2d6cc820f3$exports.__assign || function() {
    $f6f23e2d6cc820f3$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $f6f23e2d6cc820f3$var$__assign.apply(this, arguments);
};
Object.defineProperty($f6f23e2d6cc820f3$exports, "__esModule", {
    value: true
});
$f6f23e2d6cc820f3$exports.bindAll = void 0;

function $f6f23e2d6cc820f3$var$toOptions(value) {
    if (typeof value === 'undefined') return undefined;
    if (typeof value === 'boolean') return {
        capture: value
    };
    return value;
}
function $f6f23e2d6cc820f3$var$getBinding(original, sharedOptions) {
    if (sharedOptions == null) return original;
    var binding = $f6f23e2d6cc820f3$var$__assign($f6f23e2d6cc820f3$var$__assign({}, original), {
        options: $f6f23e2d6cc820f3$var$__assign($f6f23e2d6cc820f3$var$__assign({}, $f6f23e2d6cc820f3$var$toOptions(sharedOptions)), $f6f23e2d6cc820f3$var$toOptions(original.options))
    });
    return binding;
}
function $f6f23e2d6cc820f3$var$bindAll(target, bindings, sharedOptions) {
    var unbinds = bindings.map(function(original) {
        var binding = $f6f23e2d6cc820f3$var$getBinding(original, sharedOptions);
        return (0, $bae1c2098f2dd253$exports.bind)(target, binding);
    });
    return function unbindAll() {
        unbinds.forEach(function(unbind) {
            return unbind();
        });
    };
}
$f6f23e2d6cc820f3$exports.bindAll = $f6f23e2d6cc820f3$var$bindAll;


Object.defineProperty($5b617c1f48263075$exports, "bindAll", {
    enumerable: true,
    get: function() {
        return $f6f23e2d6cc820f3$exports.bindAll;
    }
});


/**
 * An empty function which does nothing.
 */ function $adcefb868cf2fc9d$export$2e2bcd8739ae039() {}


var $bea6fcbdfeebb196$export$c5406bd59b374abd = function isMatchMediaAvailable() {
    return typeof window !== 'undefined' && 'matchMedia' in window;
};


var $c13dcba1845ee9f2$export$b7baf7667a68d87c = function isReducedMotion() {
    if (!(0, $bea6fcbdfeebb196$export$c5406bd59b374abd)()) return false;
    var _window$matchMedia = window.matchMedia('(prefers-reduced-motion: reduce)'), matches = _window$matchMedia.matches;
    return matches;
};



var $5FkrB = parcelRequire("5FkrB");


var $5FkrB = parcelRequire("5FkrB");
var $3948504cb3fd4772$export$e5c5a5f917a5871c = typeof window === 'undefined' ? (0, $5FkrB.useEffect) : (0, $5FkrB.useLayoutEffect);



var $965bfce17c5c9621$var$_window, $965bfce17c5c9621$var$_window$matchMedia, $965bfce17c5c9621$var$_window2, $965bfce17c5c9621$var$_window2$matchMedia, $965bfce17c5c9621$var$_window3, $965bfce17c5c9621$var$_window3$matchMedia, $965bfce17c5c9621$var$_window4, $965bfce17c5c9621$var$_window4$matchMedia, $965bfce17c5c9621$var$_window5, $965bfce17c5c9621$var$_window5$matchMedia, $965bfce17c5c9621$var$_window6, $965bfce17c5c9621$var$_window6$matchMedia, $965bfce17c5c9621$var$_window7, $965bfce17c5c9621$var$_window7$matchMedia, $965bfce17c5c9621$var$_window8, $965bfce17c5c9621$var$_window8$matchMedia, $965bfce17c5c9621$var$_window9, $965bfce17c5c9621$var$_window9$matchMedia, $965bfce17c5c9621$var$_window0, $965bfce17c5c9621$var$_window0$matchMedia, $965bfce17c5c9621$var$_window1, $965bfce17c5c9621$var$_window1$matchMedia;
var $965bfce17c5c9621$var$queries = {
    'above.xxs': typeof window === 'undefined' ? undefined : ($965bfce17c5c9621$var$_window = window) === null || $965bfce17c5c9621$var$_window === void 0 || ($965bfce17c5c9621$var$_window$matchMedia = $965bfce17c5c9621$var$_window.matchMedia) === null || $965bfce17c5c9621$var$_window$matchMedia === void 0 ? void 0 : $965bfce17c5c9621$var$_window$matchMedia.call($965bfce17c5c9621$var$_window, (0, $92693c60dc1696c3$export$c881183ca713c214).above.xxs.replace('@media ', '').trim()),
    'above.xs': typeof window === 'undefined' ? undefined : ($965bfce17c5c9621$var$_window2 = window) === null || $965bfce17c5c9621$var$_window2 === void 0 || ($965bfce17c5c9621$var$_window2$matchMedia = $965bfce17c5c9621$var$_window2.matchMedia) === null || $965bfce17c5c9621$var$_window2$matchMedia === void 0 ? void 0 : $965bfce17c5c9621$var$_window2$matchMedia.call($965bfce17c5c9621$var$_window2, (0, $92693c60dc1696c3$export$c881183ca713c214).above.xs.replace('@media ', '').trim()),
    'above.sm': typeof window === 'undefined' ? undefined : ($965bfce17c5c9621$var$_window3 = window) === null || $965bfce17c5c9621$var$_window3 === void 0 || ($965bfce17c5c9621$var$_window3$matchMedia = $965bfce17c5c9621$var$_window3.matchMedia) === null || $965bfce17c5c9621$var$_window3$matchMedia === void 0 ? void 0 : $965bfce17c5c9621$var$_window3$matchMedia.call($965bfce17c5c9621$var$_window3, (0, $92693c60dc1696c3$export$c881183ca713c214).above.sm.replace('@media ', '').trim()),
    'above.md': typeof window === 'undefined' ? undefined : ($965bfce17c5c9621$var$_window4 = window) === null || $965bfce17c5c9621$var$_window4 === void 0 || ($965bfce17c5c9621$var$_window4$matchMedia = $965bfce17c5c9621$var$_window4.matchMedia) === null || $965bfce17c5c9621$var$_window4$matchMedia === void 0 ? void 0 : $965bfce17c5c9621$var$_window4$matchMedia.call($965bfce17c5c9621$var$_window4, (0, $92693c60dc1696c3$export$c881183ca713c214).above.md.replace('@media ', '').trim()),
    'above.lg': typeof window === 'undefined' ? undefined : ($965bfce17c5c9621$var$_window5 = window) === null || $965bfce17c5c9621$var$_window5 === void 0 || ($965bfce17c5c9621$var$_window5$matchMedia = $965bfce17c5c9621$var$_window5.matchMedia) === null || $965bfce17c5c9621$var$_window5$matchMedia === void 0 ? void 0 : $965bfce17c5c9621$var$_window5$matchMedia.call($965bfce17c5c9621$var$_window5, (0, $92693c60dc1696c3$export$c881183ca713c214).above.lg.replace('@media ', '').trim()),
    'above.xl': typeof window === 'undefined' ? undefined : ($965bfce17c5c9621$var$_window6 = window) === null || $965bfce17c5c9621$var$_window6 === void 0 || ($965bfce17c5c9621$var$_window6$matchMedia = $965bfce17c5c9621$var$_window6.matchMedia) === null || $965bfce17c5c9621$var$_window6$matchMedia === void 0 ? void 0 : $965bfce17c5c9621$var$_window6$matchMedia.call($965bfce17c5c9621$var$_window6, (0, $92693c60dc1696c3$export$c881183ca713c214).above.xl.replace('@media ', '').trim()),
    'below.xs': typeof window === 'undefined' ? undefined : ($965bfce17c5c9621$var$_window7 = window) === null || $965bfce17c5c9621$var$_window7 === void 0 || ($965bfce17c5c9621$var$_window7$matchMedia = $965bfce17c5c9621$var$_window7.matchMedia) === null || $965bfce17c5c9621$var$_window7$matchMedia === void 0 ? void 0 : $965bfce17c5c9621$var$_window7$matchMedia.call($965bfce17c5c9621$var$_window7, (0, $92693c60dc1696c3$export$c881183ca713c214).below.xs.replace('@media ', '').trim()),
    'below.sm': typeof window === 'undefined' ? undefined : ($965bfce17c5c9621$var$_window8 = window) === null || $965bfce17c5c9621$var$_window8 === void 0 || ($965bfce17c5c9621$var$_window8$matchMedia = $965bfce17c5c9621$var$_window8.matchMedia) === null || $965bfce17c5c9621$var$_window8$matchMedia === void 0 ? void 0 : $965bfce17c5c9621$var$_window8$matchMedia.call($965bfce17c5c9621$var$_window8, (0, $92693c60dc1696c3$export$c881183ca713c214).below.sm.replace('@media ', '').trim()),
    'below.md': typeof window === 'undefined' ? undefined : ($965bfce17c5c9621$var$_window9 = window) === null || $965bfce17c5c9621$var$_window9 === void 0 || ($965bfce17c5c9621$var$_window9$matchMedia = $965bfce17c5c9621$var$_window9.matchMedia) === null || $965bfce17c5c9621$var$_window9$matchMedia === void 0 ? void 0 : $965bfce17c5c9621$var$_window9$matchMedia.call($965bfce17c5c9621$var$_window9, (0, $92693c60dc1696c3$export$c881183ca713c214).below.md.replace('@media ', '').trim()),
    'below.lg': typeof window === 'undefined' ? undefined : ($965bfce17c5c9621$var$_window0 = window) === null || $965bfce17c5c9621$var$_window0 === void 0 || ($965bfce17c5c9621$var$_window0$matchMedia = $965bfce17c5c9621$var$_window0.matchMedia) === null || $965bfce17c5c9621$var$_window0$matchMedia === void 0 ? void 0 : $965bfce17c5c9621$var$_window0$matchMedia.call($965bfce17c5c9621$var$_window0, (0, $92693c60dc1696c3$export$c881183ca713c214).below.lg.replace('@media ', '').trim()),
    'below.xl': typeof window === 'undefined' ? undefined : ($965bfce17c5c9621$var$_window1 = window) === null || $965bfce17c5c9621$var$_window1 === void 0 || ($965bfce17c5c9621$var$_window1$matchMedia = $965bfce17c5c9621$var$_window1.matchMedia) === null || $965bfce17c5c9621$var$_window1$matchMedia === void 0 ? void 0 : $965bfce17c5c9621$var$_window1$matchMedia.call($965bfce17c5c9621$var$_window1, (0, $92693c60dc1696c3$export$c881183ca713c214).below.xl.replace('@media ', '').trim())
};
var $965bfce17c5c9621$export$49e55ae2c03d6045 = function UNSAFE_useMediaQuery(queryString, listener) {
    var listenerRef = (0, $5FkrB.useRef)(listener);
    (0, $5FkrB.useEffect)(function() {
        // Bind the listener if changed so it's called on the next change event; no guarantee on timing.
        listenerRef.current = listener;
    }, [
        listener
    ]);
    /**
   * We explicitly only react to boolean changes for binding our listener
   * Changes to the functional reference are ignored.
   */ var hasListener = !!listener;
    /**
   * The `matchMedia(…)` return value for our breakpoint query.
   */ var mq = $965bfce17c5c9621$var$queries[queryString];
    (0, $3948504cb3fd4772$export$e5c5a5f917a5871c)(function() {
        listenerRef.current = listener; // Bind the listener now in case the `useEffect` hasn't fired above yet
        if (!mq || !hasListener || !listenerRef.current) return;
        return (0, $5b617c1f48263075$exports.bind)(mq, {
            type: 'change',
            listener: function listener(event) {
                // We explicitly call the current version of the function
                return listenerRef.current(event);
            }
        });
    }, // eslint-disable-next-line react-hooks/exhaustive-deps -- explicitly do not trigger the effect on `listener` reference change, only on a boolean representation of it.
    [
        mq,
        hasListener
    ]);
    return mq || null;
};




var $c94ee15af6e9a3e2$export$218ece2c32b7db0e = function getPageLayoutSlotCSSSelector(slotName) {
    return "[".concat((0, $efd2be1bf5c3a2eb$export$5253dd9707b8c3ba), "='").concat(slotName, "']");
};



var $5FkrB = parcelRequire("5FkrB");

var $198526dc4eb950df$var$leftSidebarState = {
    isFlyoutOpen: false,
    isResizing: false,
    isLeftSidebarCollapsed: false,
    leftSidebarWidth: 0,
    lastLeftSidebarWidth: 0,
    flyoutLockCount: 0,
    isFixed: true,
    hasInit: false
};
var $198526dc4eb950df$export$aa5a712eea4c2ae8 = /*#__PURE__*/ (0, $5FkrB.createContext)({
    isLeftSidebarCollapsed: false,
    expandLeftSidebar: (0, $adcefb868cf2fc9d$export$2e2bcd8739ae039),
    collapseLeftSidebar: (0, $adcefb868cf2fc9d$export$2e2bcd8739ae039),
    leftSidebarState: $198526dc4eb950df$var$leftSidebarState,
    setLeftSidebarState: (0, $adcefb868cf2fc9d$export$2e2bcd8739ae039),
    toggleLeftSidebar: (0, $adcefb868cf2fc9d$export$2e2bcd8739ae039)
});


var $4bf072c5e52065f0$var$handleDataAttributesAndCb = function handleDataAttributesAndCb() {
    var callback = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, $adcefb868cf2fc9d$export$2e2bcd8739ae039);
    var leftSidebarState = arguments.length > 1 ? arguments[1] : undefined;
    document.documentElement.removeAttribute((0, $efd2be1bf5c3a2eb$export$5e5e1875c3fd8f4f));
    callback(leftSidebarState);
};
var $4bf072c5e52065f0$var$leftSidebarSelector = (0, $c94ee15af6e9a3e2$export$218ece2c32b7db0e)('left-sidebar');
var $4bf072c5e52065f0$export$850bd1bba41f1448 = function SidebarResizeController(_ref) {
    var children = _ref.children, onExpand = _ref.onLeftSidebarExpand, onCollapse = _ref.onLeftSidebarCollapse;
    var _useState = (0, $5FkrB.useState)({
        isFlyoutOpen: false,
        isResizing: false,
        isLeftSidebarCollapsed: false,
        leftSidebarWidth: 0,
        lastLeftSidebarWidth: 0,
        flyoutLockCount: 0,
        isFixed: true,
        hasInit: false
    }), _useState2 = (0, $f0700d30f2885170$export$2e2bcd8739ae039)(_useState, 2), leftSidebarState = _useState2[0], setLeftSidebarState = _useState2[1];
    var leftSidebarWidth = leftSidebarState.leftSidebarWidth, lastLeftSidebarWidth = leftSidebarState.lastLeftSidebarWidth, isResizing = leftSidebarState.isResizing, flyoutLockCount = leftSidebarState.flyoutLockCount, isFixed = leftSidebarState.isFixed, isLeftSidebarCollapsed = leftSidebarState.isLeftSidebarCollapsed, isFlyoutOpen = leftSidebarState.isFlyoutOpen, hasInit = leftSidebarState.hasInit;
    // We put the latest callbacks into a ref so we can always have the latest
    // functions in our transitionend listeners
    var stableRef = (0, $5FkrB.useRef)({
        onExpand: onExpand,
        onCollapse: onCollapse
    });
    (0, $5FkrB.useEffect)(function() {
        stableRef.current = {
            onExpand: onExpand,
            onCollapse: onCollapse
        };
    }, [
        onExpand,
        onCollapse
    ]);
    var transition = (0, $5FkrB.useRef)(null);
    var mobileMediaQuery = (0, $965bfce17c5c9621$export$49e55ae2c03d6045)('below.sm');
    var isOpen = mobileMediaQuery !== null && mobileMediaQuery !== void 0 && mobileMediaQuery.matches ? isFlyoutOpen : !isLeftSidebarCollapsed;
    var expandLeftSidebar = (0, $5FkrB.useCallback)(function() {
        var _transition$current2, _transition$current3;
        if (isOpen) return;
        // If the user is at a mobile viewport when this runs, we handle it differently
        // We don't expand at mobile widths; instead we use a flyout which is treated the same otherwise
        if (mobileMediaQuery !== null && mobileMediaQuery !== void 0 && mobileMediaQuery.matches) {
            var _transition$current;
            var flyoutOpenSidebarState = {
                isResizing: false,
                isLeftSidebarCollapsed: true,
                leftSidebarWidth: (0, $efd2be1bf5c3a2eb$export$46acf8758e9e2636),
                lastLeftSidebarWidth: leftSidebarWidth,
                isFlyoutOpen: true,
                flyoutLockCount: 0,
                isFixed: isFixed,
                hasInit: hasInit
            };
            setLeftSidebarState(flyoutOpenSidebarState);
            // Flush the desktop transitions, cleanup, and call the `onExpand` still
            (_transition$current = transition.current) === null || _transition$current === void 0 || _transition$current.complete();
            $4bf072c5e52065f0$var$handleDataAttributesAndCb(stableRef.current.onExpand, flyoutOpenSidebarState);
            return;
        }
        if (isResizing || !isLeftSidebarCollapsed || // already expanding
        ((_transition$current2 = transition.current) === null || _transition$current2 === void 0 ? void 0 : _transition$current2.action) === 'expand') return;
        // flush existing transition
        (_transition$current3 = transition.current) === null || _transition$current3 === void 0 || _transition$current3.complete();
        var width = Math.max(lastLeftSidebarWidth, (0, $efd2be1bf5c3a2eb$export$539e68c09584883a));
        var updatedLeftSidebarState = {
            isLeftSidebarCollapsed: false,
            isFlyoutOpen: false,
            leftSidebarWidth: width,
            lastLeftSidebarWidth: lastLeftSidebarWidth,
            isResizing: isResizing,
            flyoutLockCount: flyoutLockCount,
            isFixed: isFixed,
            hasInit: hasInit
        };
        setLeftSidebarState(updatedLeftSidebarState);
        function finish() {
            $4bf072c5e52065f0$var$handleDataAttributesAndCb(stableRef.current.onExpand, updatedLeftSidebarState);
        }
        var sidebar = document.querySelector($4bf072c5e52065f0$var$leftSidebarSelector);
        // onTransitionEnd isn't triggered when a user prefers reduced motion
        if ((0, $c13dcba1845ee9f2$export$b7baf7667a68d87c)() || !sidebar) {
            finish();
            return;
        }
        var unbindEvent = (0, $5b617c1f48263075$exports.bind)(sidebar, {
            type: 'transitionend',
            listener: function listener(event) {
                if (event.target === sidebar && event.propertyName === 'width') {
                    var _transition$current4;
                    (_transition$current4 = transition.current) === null || _transition$current4 === void 0 || _transition$current4.complete();
                }
            }
        });
        var value = {
            action: 'expand',
            complete: function complete() {
                value.abort();
                finish();
            },
            abort: function abort() {
                unbindEvent();
                transition.current = null;
            }
        };
        transition.current = value;
    }, [
        isOpen,
        mobileMediaQuery,
        isResizing,
        isLeftSidebarCollapsed,
        lastLeftSidebarWidth,
        flyoutLockCount,
        isFixed,
        leftSidebarWidth,
        hasInit
    ]);
    var collapseLeftSidebar = (0, $5FkrB.useCallback)(function(_event, collapseWithoutTransition) {
        var _transition$current6, _transition$current7;
        if (!isOpen) return;
        // If the user is at a mobile viewport when this runs, we handle it differently
        // We don't collapse at mobile widths; instead we close the flyout.
        if (mobileMediaQuery !== null && mobileMediaQuery !== void 0 && mobileMediaQuery.matches) {
            var _transition$current5;
            var flyoutCloseSidebarState = {
                isResizing: false,
                isLeftSidebarCollapsed: true,
                leftSidebarWidth: (0, $efd2be1bf5c3a2eb$export$46acf8758e9e2636),
                lastLeftSidebarWidth: lastLeftSidebarWidth,
                isFlyoutOpen: false,
                flyoutLockCount: 0,
                isFixed: isFixed,
                hasInit: hasInit
            };
            setLeftSidebarState(flyoutCloseSidebarState);
            // Flush the desktop transitions, cleanup, and call the `onCollapse` still
            (_transition$current5 = transition.current) === null || _transition$current5 === void 0 || _transition$current5.complete();
            $4bf072c5e52065f0$var$handleDataAttributesAndCb(stableRef.current.onCollapse, flyoutCloseSidebarState);
            return;
        }
        if (isResizing || isLeftSidebarCollapsed || // already collapsing
        ((_transition$current6 = transition.current) === null || _transition$current6 === void 0 ? void 0 : _transition$current6.action) === 'collapse') return;
        // flush existing transition
        (_transition$current7 = transition.current) === null || _transition$current7 === void 0 || _transition$current7.complete();
        // data-attribute is used as a CSS selector to sync the hiding/showing
        // of the nav contents with expand/collapse animation
        document.documentElement.setAttribute((0, $efd2be1bf5c3a2eb$export$5e5e1875c3fd8f4f), 'true');
        var updatedLeftSidebarState = {
            isLeftSidebarCollapsed: true,
            isFlyoutOpen: false,
            leftSidebarWidth: (0, $efd2be1bf5c3a2eb$export$46acf8758e9e2636),
            lastLeftSidebarWidth: leftSidebarWidth,
            isResizing: isResizing,
            flyoutLockCount: flyoutLockCount,
            isFixed: isFixed,
            hasInit: hasInit
        };
        setLeftSidebarState(updatedLeftSidebarState);
        function finish() {
            $4bf072c5e52065f0$var$handleDataAttributesAndCb(stableRef.current.onCollapse, updatedLeftSidebarState);
        }
        var sidebar = document.querySelector($4bf072c5e52065f0$var$leftSidebarSelector);
        // onTransitionEnd isn't triggered when a user prefers reduced motion
        if (collapseWithoutTransition || (0, $c13dcba1845ee9f2$export$b7baf7667a68d87c)() || !sidebar) {
            finish();
            return;
        }
        var unbindEvent = (0, $5b617c1f48263075$exports.bind)(sidebar, {
            type: 'transitionend',
            listener: function listener(event) {
                if (sidebar === event.target && event.propertyName === 'width') {
                    var _transition$current8;
                    (_transition$current8 = transition.current) === null || _transition$current8 === void 0 || _transition$current8.complete();
                }
            }
        });
        var value = {
            action: 'collapse',
            complete: function complete() {
                value.abort();
                finish();
            },
            abort: function abort() {
                unbindEvent();
                transition.current = null;
            }
        };
        transition.current = value;
    }, [
        isOpen,
        mobileMediaQuery,
        isResizing,
        isLeftSidebarCollapsed,
        leftSidebarWidth,
        flyoutLockCount,
        isFixed,
        lastLeftSidebarWidth,
        hasInit
    ]);
    /**
   * Conditionally toggle the expanding or collapsing the sidebars.
   * This supports our mobile flyout mode as well.
   */ var toggleLeftSidebar = (0, $5FkrB.useCallback)(function(event, collapseWithoutTransition) {
        if (isOpen) collapseLeftSidebar(event, collapseWithoutTransition);
        else expandLeftSidebar();
    }, [
        isOpen,
        expandLeftSidebar,
        collapseLeftSidebar
    ]);
    // Make sure we finish any lingering transitions when unmounting
    (0, $5FkrB.useEffect)(function mount() {
        return function unmount() {
            var _transition$current9;
            (_transition$current9 = transition.current) === null || _transition$current9 === void 0 || _transition$current9.abort();
        };
    }, []);
    var context = (0, $5FkrB.useMemo)(function() {
        return {
            isLeftSidebarCollapsed: !isOpen,
            // Technically this isn't quite true, but with mobile it's a bit safer if apps are using this to roll their own collapse/expand
            expandLeftSidebar: expandLeftSidebar,
            collapseLeftSidebar: collapseLeftSidebar,
            leftSidebarState: leftSidebarState,
            setLeftSidebarState: setLeftSidebarState,
            toggleLeftSidebar: toggleLeftSidebar
        };
    }, [
        isOpen,
        expandLeftSidebar,
        collapseLeftSidebar,
        leftSidebarState,
        toggleLeftSidebar
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $198526dc4eb950df$export$aa5a712eea4c2ae8).Provider, {
        value: context
    }, children);
};


function $72d075989400000a$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return (0, $d6f13e99a310feb2$export$2e2bcd8739ae039)(r);
}


function $ca5f3eb690420c92$export$2e2bcd8739ae039(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}



function $43fd7c1d91ecc5f2$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}


function $5c28c49a950f777f$export$2e2bcd8739ae039(r) {
    return (0, $72d075989400000a$export$2e2bcd8739ae039)(r) || (0, $ca5f3eb690420c92$export$2e2bcd8739ae039)(r) || (0, $507c36b7d60c8fd6$export$2e2bcd8739ae039)(r) || (0, $43fd7c1d91ecc5f2$export$2e2bcd8739ae039)();
}




var $5FkrB = parcelRequire("5FkrB");


var $5FkrB = parcelRequire("5FkrB");

var $d3031762c57f63c1$export$4c5cc3b14c7678a = /*#__PURE__*/ (0, $5FkrB.createContext)({
    skipLinksData: [],
    registerSkipLink: (0, $adcefb868cf2fc9d$export$2e2bcd8739ae039),
    unregisterSkipLink: (0, $adcefb868cf2fc9d$export$2e2bcd8739ae039)
});


var $dfad1c2e53161c67$var$byDOMOrder = function byDOMOrder(a, b) {
    var _a$listIndex, _b$listIndex;
    var elems = Array.from(document.querySelectorAll("[".concat((0, $efd2be1bf5c3a2eb$export$5253dd9707b8c3ba), "]")));
    var elemA = document.getElementById(a.id);
    var elemB = document.getElementById(b.id);
    var indexA = (_a$listIndex = a.listIndex) !== null && _a$listIndex !== void 0 ? _a$listIndex : elems.indexOf(elemA);
    var indexB = (_b$listIndex = b.listIndex) !== null && _b$listIndex !== void 0 ? _b$listIndex : elems.indexOf(elemB);
    /**
   * If they are tied it is because one (or both) is
   * a custom skiplink with a set index.
   *
   * Give the custom skiplink priority.
   */ if (indexA === indexB) {
        if (a.listIndex !== undefined) return -1;
        else return 1;
    }
    return indexA - indexB;
};
var $dfad1c2e53161c67$export$da7be99d6a868f3d = function SkipLinksController(_ref) {
    var children = _ref.children;
    var _useState = (0, $5FkrB.useState)([]), _useState2 = (0, $f0700d30f2885170$export$2e2bcd8739ae039)(_useState, 2), links = _useState2[0], setLinks = _useState2[1];
    var registerSkipLink = (0, $5FkrB.useRef)(function(skipLinkData) {
        // Don't add duplicate SkipLinks
        setLinks(function(oldLinks) {
            if (oldLinks.some(function(_ref2) {
                var id = _ref2.id;
                return id === skipLinkData.id;
            })) return oldLinks;
            return [].concat((0, $5c28c49a950f777f$export$2e2bcd8739ae039)(oldLinks), [
                skipLinkData
            ]).sort($dfad1c2e53161c67$var$byDOMOrder);
        });
    });
    var unregisterSkipLink = (0, $5FkrB.useRef)(function(id) {
        setLinks(function(links) {
            return links.filter(function(link) {
                return link.id !== id;
            });
        });
    });
    var context = {
        registerSkipLink: registerSkipLink.current,
        skipLinksData: links,
        unregisterSkipLink: unregisterSkipLink.current
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $d3031762c57f63c1$export$4c5cc3b14c7678a).Provider, {
        value: context
    }, children);
};





var $2nBsU = parcelRequire("2nBsU");
var $6a30af0ce01ddfc7$export$c07234257a03d5e9 = 'cubic-bezier(0.15,1,0.3,1)';
var $6a30af0ce01ddfc7$export$57636bb43b1ccbb0 = 'cubic-bezier(0.2,0,0,1)';
var $6a30af0ce01ddfc7$export$929e5a82286172a6 = 'cubic-bezier(0.8,0,0,0.8)';
var $6a30af0ce01ddfc7$export$fc825baa2ef870d0 = 'cubic-bezier(0.4,0,0,1)';
var $6a30af0ce01ddfc7$export$816ee5d79b5bd9a5 = 'cubic-bezier(0.6,0,0,1)';
var $6a30af0ce01ddfc7$export$53ce3390a1a8f2a2 = 'cubic-bezier(0.8,0,0,1)';
var $6a30af0ce01ddfc7$export$45db2fc2f15997e7 = 'cubic-bezier(0,0,1,1)';


/**
 * Use for any CSS based motion (animation or transition).
 * Always put at the end of your declaration for correct use of the cascade.
 * Reduced motion preference is generally set through OS preferences/settings.
 *
 * @deprecated This is not fully compatible with Compiled CSS and will be removed in the future.
 * You should hardcode the `prefers-reduced-motion` media query in your file instead.
 */ var $e87c51df84cda687$export$f0f789643ba5a83c = {
    '@media (prefers-reduced-motion: reduce)': {
        animation: 'none',
        transition: 'none'
    }
};


var $c388794be4d106d9$export$ff7706047246b98b = function prefersReducedMotion() {
    return 0, $e87c51df84cda687$export$f0f789643ba5a83c;
};




var $5FkrB = parcelRequire("5FkrB");

var $a56aa16f16be206c$export$c9d9cb2ee9590f87 = function useSkipLinks() {
    return (0, $5FkrB.useContext)((0, $d3031762c57f63c1$export$4c5cc3b14c7678a));
};


/* eslint-disable @repo/internal/dom-events/no-unsafe-event-listeners */ /**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled

var $2nBsU = parcelRequire("2nBsU");
/* index.tsx generated by @compiled/babel-plugin v2.0.0 */ function $a22d338ce3923cba$export$2e2bcd8739ae039() {
    return $a22d338ce3923cba$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $a22d338ce3923cba$export$2e2bcd8739ae039.apply(null, arguments);
}


function $a8e16d9d59e56690$export$2e2bcd8739ae039(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}


function $e1dadfc9c3d2f1bd$export$2e2bcd8739ae039(e, t) {
    if (null == e) return {};
    var o, r, i = (0, $a8e16d9d59e56690$export$2e2bcd8739ae039)(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}



var $5FkrB = parcelRequire("5FkrB");
/**
 * The length of the value hash portion of an atomic class name.
 * Atomic class names have the format: `_<group><value>`
 * where group is ATOMIC_GROUP_HASH_LENGTH chars and value is ATOMIC_VALUE_HASH_LENGTH chars.
 *
 * We extract the group key using: `className.slice(0, className.length - ATOMIC_VALUE_HASH_LENGTH)`
 *
 * We support both old-format classes (9 chars: `_` + 4 group + 4 value) and
 * new-format classes (11 chars: `_` + 6 group + 4 value) by using length-based
 * extraction rather than a hardcoded offset — old and new format group keys
 * are different lengths so they are structurally disjoint and never alias each other.
 */ const $2efec74f5f421835$var$ATOMIC_VALUE_HASH_LENGTH = 4;
function $2efec74f5f421835$export$2e2bcd8739ae039(classNames) {
    // Shortcut: nothing to do
    if (!classNames.length) return;
    // Shortcut: don't need to do anything if we only have a single classname
    if (classNames.length === 1 && classNames[0] && // checking to see if `classNames[0]` is a string that contains other classnames
    !classNames[0].includes(' ')) return classNames[0];
    // Using an object rather than a `Map` as it performed better in our benchmarks.
    // Would be happy to move to `Map` if it proved to be better under real conditions.
    const map = {};
    // Note: using loops to minimize iterations over the collection
    for (const value of classNames){
        // Exclude all falsy values, which leaves us with populated strings
        if (!value) continue;
        // a `value` can contain multiple classnames
        const list = value.split(' ');
        for (const className of list){
            /**
             * For atomic style classnames: the `key` is the `group`
             *
             * - Later atomic classnames with the same `group` will override earlier ones
             *   (which is what we want).
             * - Assumes atomic classnames are the only things that start with `_`
             * - Could use a regex to ensure that atomic classnames are structured how we expect,
             *   but did not add that for now as it did slow things down a bit.
             *
             * For other classnames: the `key` is the whole classname
             * - Okay to remove duplicates as doing so does not impact specificity
             *
             * */ const key = className.startsWith('_') ? className.slice(0, className.length - $2efec74f5f421835$var$ATOMIC_VALUE_HASH_LENGTH) : className;
            map[key] = className;
        }
    }
    /**
     * We are converting the `map` into a string.
     *
     * The simple way to do this would be `Object.values(map).join(' ')`.
     * However, the approach below performs 10%-20% better in benchmarks.
     *
     * For `ax()` it feels right to squeeze as much runtime performance out as we can.
     */ let result = '';
    for(const key in map)result += map[key] + ' ';
    // If we have an empty string, then our `map` was empty.
    if (!result) return;
    // remove last " " from the result (we added " " at the end of every value)
    return result.trimEnd();
}


/* index.tsx generated by @compiled/babel-plugin v0.39.1 */ parcelRequire("5FkrB");

const $aaa2c05dcf489bc4$export$6c9a87045746941d = ()=>{
    return new Error(`
 \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2557}   \u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2557}     \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}
\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}
\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}   \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}  \u{2588}\u{2588}\u{2551}  \u{2588}\u{2588}\u{2551}
\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}   \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}\u{255A}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{255D} \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{255D}  \u{2588}\u{2588}\u{2551}  \u{2588}\u{2588}\u{2551}
\u{255A}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{255A}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551} \u{255A}\u{2550}\u{255D} \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}
 \u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D} \u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D} \u{255A}\u{2550}\u{255D}     \u{255A}\u{2550}\u{255D}\u{255A}\u{2550}\u{255D}     \u{255A}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}

  @compiled/react

  Code was executed when it shouldn't have. This could have happened because:

  1. You haven't configured a transformer yet. Visit https://compiledcssinjs.com/docs/installation and follow the instructions.
  2. You have duplicate versions of React and hooks are blowing up. You need to de-duplicate your dependencies.

  Good luck!
`);
};
const $aaa2c05dcf489bc4$export$c4df1cb0c2b4d77c = ()=>{
    return new Error(`
 \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2557}   \u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2557}     \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}
\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}
\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}   \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}  \u{2588}\u{2588}\u{2551}  \u{2588}\u{2588}\u{2551}
\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}   \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}\u{255A}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{255D} \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{255D}  \u{2588}\u{2588}\u{2551}  \u{2588}\u{2588}\u{2551}
\u{255A}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{255A}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551} \u{255A}\u{2550}\u{255D} \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}
 \u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D} \u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D} \u{255A}\u{2550}\u{255D}     \u{255A}\u{2550}\u{255D}\u{255A}\u{2550}\u{255D}     \u{255A}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}

  @compiled/react

  Code was executed when it shouldn't have. To resolve make sure to:

  1. Set up Compiled.
  2. Configure importSources in your Compiled config to point to the module that exports the output of createStrictAPI().

  For more information visit https://compiledcssinjs.com/docs/installation and follow the instructions.
`);
};


/**
 * This length includes the underscore,
 * e.g. `"_1s4A"` would be a valid atomic group hash.
 */ const $95ebcaa1ad855955$var$ATOMIC_GROUP_LENGTH = 5;
function $95ebcaa1ad855955$export$2e2bcd8739ae039(classNames) {
    // Shortcut: nothing to do
    if (!classNames.length) return;
    // Shortcut: don't need to do anything if we only have a single classname
    if (classNames.length === 1 && classNames[0] && // checking to see if `classNames[0]` is a string that contains other classnames
    !classNames[0].includes(' ')) return classNames[0];
    // Using an object rather than a `Map` as it performed better in our benchmarks.
    // Would be happy to move to `Map` if it proved to be better under real conditions.
    const map = {};
    // Note: using loops to minimize iterations over the collection
    for (const value of classNames){
        // Exclude all falsy values, which leaves us with populated strings
        if (!value) continue;
        // a `value` can contain multiple classnames
        const list = value.split(' ');
        for (const className of list){
            /**
             * For atomic style classnames: the `key` is the `group`
             *
             * - Later atomic classnames with the same `group` will override earlier ones
             *   (which is what we want).
             * - Assumes atomic classnames are the only things that start with `_`
             * - Could use a regex to ensure that atomic classnames are structured how we expect,
             *   but did not add that for now as it did slow things down a bit.
             *
             * For other classnames: the `key` is the whole classname
             * - Okay to remove duplicates as doing so does not impact specificity
             *
             * */ const key = className.startsWith('_') ? className.slice(0, $95ebcaa1ad855955$var$ATOMIC_GROUP_LENGTH) : className;
            map[key] = className;
        }
    }
    /**
     * We are converting the `map` into a string.
     *
     * The simple way to do this would be `Object.values(map).join(' ')`.
     * However, the approach below performs 10%-20% better in benchmarks.
     *
     * For `ax()` it feels right to squeeze as much runtime performance out as we can.
     */ let result = '';
    for(const key in map)result += map[key] + ' ';
    // If we have an empty string, then our `map` was empty.
    if (!result) return;
    // remove last " " from the result (we added " " at the end of every value)
    return result.trimEnd();
}


const $614e47490aaac3b5$export$a274e22fb40f762e = (...styles)=>{
    // At runtime TStyles is resolved down to strings, but not at compile time.
    // We circumvent the type system here because of that.
    const actualStyles = styles;
    // The output should be a union type of passed in styles. This ensures the call
    // site of xcss prop can raise violations when disallowed styles have been passed.
    return (0, $95ebcaa1ad855955$export$2e2bcd8739ae039)(actualStyles);
};


function $df5b8ea5de95f793$export$39716b4af53f4ad() {
    return {
        css () {
            throw (0, $aaa2c05dcf489bc4$export$c4df1cb0c2b4d77c)();
        },
        cssMap () {
            throw (0, $aaa2c05dcf489bc4$export$c4df1cb0c2b4d77c)();
        },
        cx: $614e47490aaac3b5$export$a274e22fb40f762e,
        XCSSProp () {
            throw (0, $aaa2c05dcf489bc4$export$c4df1cb0c2b4d77c)();
        }
    };
}


var $f5394890a4af8edf$var$strictApi = (0, $df5b8ea5de95f793$export$39716b4af53f4ad)();
var $f5394890a4af8edf$export$dbf350e5966cf602 = $f5394890a4af8edf$var$strictApi.css;
var $f5394890a4af8edf$export$eb1ecd84a24ee424 = $f5394890a4af8edf$var$strictApi.cssMap;
$f5394890a4af8edf$var$strictApi.cssMap;
var $f5394890a4af8edf$export$a274e22fb40f762e = $f5394890a4af8edf$var$strictApi.cx;
var $f5394890a4af8edf$var$XCSSProp = $f5394890a4af8edf$var$strictApi.XCSSProp; // This is to mitigate local TS error TS2315: Type 'StrictXCSSProp' is not generic.
 // Currently for some reason tsc is generating malformed .d.ts in local dev environment, below change fixes it
 /**
 * ## StrictXCSSProp
 *
 * Declare styles your component takes with all other styles marked as violations
 * by the TypeScript compiler. There are two primary use cases for xcss prop:
 *
 * - safe style overrides
 * - inverting style declarations
 *
 * Interverting style declarations is interesting for platform teams as
 * it means apps only pay for styles they use as they're now the ones who declare
 * the styles!
 *
 * The {@link StrictXCSSProp} type has generics two of which must be defined — use to explicitly
 * set what you want to maintain as API. Use {@link XCSSAllProperties} and {@link XCSSAllPseudos}
 * to enable all properties and pseudos.
 *
 * The third generic is used to declare what properties and pseudos should be required.
 *
 * ```tsx
 * interface MyComponentProps {
 *   // Color is accepted, all other properties / pseudos are considered violations.
 *   xcss?: StrictXCSSProp<'color', never>;
 *
 *   // Only background color and hover pseudo are accepted.
 *   xcss?: StrictXCSSProp<'backgroundColor', '&:hover'>;
 *
 *   // All properties are accepted, all pseudos are considered violations.
 *   xcss?: StrictXCSSProp<XCSSAllProperties, never>;
 *
 *   // All properties are accepted, only the hover pseudo is accepted.
 *   xcss?: StrictXCSSProp<XCSSAllProperties, '&:hover'>;
 *
 *   // The xcss prop is required as well as the color property. No pseudos are required.
 *   xcss: StrictXCSSProp<
 *     XCSSAllProperties,
 *     '&:hover',
 *     { requiredProperties: 'color', requiredPseudos: never }
 *   >;
 * }
 *
 * function MyComponent({ xcss }: MyComponentProps) {
 *   return <div css={{ color: 'var(--ds-text-danger)' }} className={xcss} />
 * }
 * ```
 *
 * The xcss prop works with static inline objects and the [cssMap](https://compiledcssinjs.com/docs/api-cssmap) API.
 *
 * ```jsx
 * // Declared as an inline object
 * <Component xcss={{ color: 'var(--ds-text)' }} />
 *
 * // Declared with the cssMap API
 * const styles = cssMap({ text: { color: 'var(--ds-text)' } });
 * <Component xcss={styles.text} />
 * ```
 *
 * To concatenate and conditonally apply styles use the {@link cssMap} and {@link cx} functions.
 */ 


function $b415120f8e0f227f$export$2e2bcd8739ae039(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}


function $0b394150901e1111$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $0b394150901e1111$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $0b394150901e1111$export$2e2bcd8739ae039(o);
}



function $33132a91f542bf9d$export$2e2bcd8739ae039(t, r) {
    if ("object" != (0, $0b394150901e1111$export$2e2bcd8739ae039)(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (0, $0b394150901e1111$export$2e2bcd8739ae039)(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}


function $7e8776bcbaade50b$export$2e2bcd8739ae039(t) {
    var i = (0, $33132a91f542bf9d$export$2e2bcd8739ae039)(t, "string");
    return "symbol" == (0, $0b394150901e1111$export$2e2bcd8739ae039)(i) ? i : i + "";
}


function $8be4ca258be1ae94$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, (0, $7e8776bcbaade50b$export$2e2bcd8739ae039)(o.key), o);
    }
}
function $8be4ca258be1ae94$export$2e2bcd8739ae039(e, r, t) {
    return r && $8be4ca258be1ae94$var$_defineProperties(e.prototype, r), t && $8be4ca258be1ae94$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}



function $36e8c6a8ae2e8480$export$2e2bcd8739ae039(e, r, t) {
    return (r = (0, $7e8776bcbaade50b$export$2e2bcd8739ae039)(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}



function $5c763fe075a51b04$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return r;
}


function $7ce3dac241cc8e25$export$2e2bcd8739ae039(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}


function $eb4764551033db71$export$2e2bcd8739ae039(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}


function $9f8ed0ce02ebf653$export$2e2bcd8739ae039(r, a) {
    if (r) {
        if ("string" == typeof r) return (0, $eb4764551033db71$export$2e2bcd8739ae039)(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? (0, $eb4764551033db71$export$2e2bcd8739ae039)(r, a) : void 0;
    }
}


function $e67f857a7f1385b1$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}


function $5e90782b0facda0b$export$2e2bcd8739ae039(r, e) {
    return (0, $5c763fe075a51b04$export$2e2bcd8739ae039)(r) || (0, $7ce3dac241cc8e25$export$2e2bcd8739ae039)(r, e) || (0, $9f8ed0ce02ebf653$export$2e2bcd8739ae039)(r, e) || (0, $e67f857a7f1385b1$export$2e2bcd8739ae039)();
}


function $a6260dcf494016d1$var$asyncGeneratorStep(n, t, e, r, o, a, c) {
    try {
        var i = n[a](c), u = i.value;
    } catch (n) {
        return void e(n);
    }
    i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function $a6260dcf494016d1$export$2e2bcd8739ae039(n) {
    return function() {
        var t = this, e = arguments;
        return new Promise(function(r, o) {
            var a = n.apply(t, e);
            function _next(n) {
                $a6260dcf494016d1$var$asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
            }
            function _throw(n) {
                $a6260dcf494016d1$var$asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
            }
            _next(void 0);
        });
    };
}





var $249ba1682cdbc1d3$exports = {};
// TODO(Babel 8): Remove this file.

var $249ba1682cdbc1d3$var$runtime = (parcelRequire("iw5eO"))();
$249ba1682cdbc1d3$exports = $249ba1682cdbc1d3$var$runtime;
// Copied from https://github.com/facebook/regenerator/blob/main/packages/runtime/runtime.js#L736=
try {
    regeneratorRuntime = $249ba1682cdbc1d3$var$runtime;
} catch (accidentalStrictMode) {
    if (typeof globalThis === "object") globalThis.regeneratorRuntime = $249ba1682cdbc1d3$var$runtime;
    else Function("r", "regeneratorRuntime = r")($249ba1682cdbc1d3$var$runtime);
}



var $iFR7a = parcelRequire("iFR7a");




var $hLfKH = parcelRequire("hLfKH");
function $d26325b71343c3d7$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $d26325b71343c3d7$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $d26325b71343c3d7$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $36e8c6a8ae2e8480$export$2e2bcd8739ae039)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $d26325b71343c3d7$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $d26325b71343c3d7$export$a66cbd9b2289cd78 = '@all-features';
var $d26325b71343c3d7$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function Subscriptions() {
        (0, $b415120f8e0f227f$export$2e2bcd8739ae039)(this, Subscriptions);
        (0, $36e8c6a8ae2e8480$export$2e2bcd8739ae039)(this, "eventToValue", new Map());
        this.emitter = new (0, (/*@__PURE__*/$parcel$interopDefault($hLfKH)))();
    }
    return (0, $8be4ca258be1ae94$export$2e2bcd8739ae039)(Subscriptions, [
        {
            key: "onGateUpdated",
            value: function onGateUpdated(gateName, callback, checkGate, options) {
                var _this = this;
                var value = checkGate(gateName, $d26325b71343c3d7$var$_objectSpread($d26325b71343c3d7$var$_objectSpread({}, options), {}, {
                    fireGateExposure: false
                }));
                if (this.eventToValue.get(callback) === undefined) this.eventToValue.set(callback, value);
                var wrapCallback = function wrapCallback() {
                    var value = checkGate(gateName, $d26325b71343c3d7$var$_objectSpread($d26325b71343c3d7$var$_objectSpread({}, options), {}, {
                        fireGateExposure: false
                    }));
                    var existingValue = _this.eventToValue.get(callback);
                    if (existingValue !== value) {
                        _this.eventToValue.set(callback, value);
                        callback(value);
                    }
                };
                this.emitter.on(gateName, wrapCallback);
                return function() {
                    _this.emitter.off(gateName, wrapCallback);
                };
            }
        },
        {
            key: "onExperimentValueUpdated",
            value: function onExperimentValueUpdated(experimentName, parameterName, defaultValue, callback, getExperimentValue, options) {
                var _this2 = this;
                var experimentEventName = "".concat(experimentName, ".").concat(parameterName);
                var value = getExperimentValue(experimentName, parameterName, defaultValue, $d26325b71343c3d7$var$_objectSpread($d26325b71343c3d7$var$_objectSpread({}, options), {}, {
                    fireExperimentExposure: false
                }));
                if (this.eventToValue.get(callback) === undefined) this.eventToValue.set(callback, value);
                var wrapCallback = function wrapCallback() {
                    var value = getExperimentValue(experimentName, parameterName, defaultValue, $d26325b71343c3d7$var$_objectSpread($d26325b71343c3d7$var$_objectSpread({}, options), {}, {
                        fireExperimentExposure: false
                    }));
                    var existingValue = _this2.eventToValue.get(callback);
                    if (existingValue !== value) {
                        _this2.eventToValue.set(callback, value);
                        callback(value);
                    }
                };
                this.emitter.on(experimentEventName, wrapCallback);
                return function() {
                    _this2.emitter.off(experimentEventName, wrapCallback);
                };
            }
        },
        {
            key: "onAnyUpdated",
            value: function onAnyUpdated(callback) {
                var _this3 = this;
                this.emitter.on($d26325b71343c3d7$export$a66cbd9b2289cd78, callback);
                return function() {
                    _this3.emitter.off($d26325b71343c3d7$export$a66cbd9b2289cd78, callback);
                };
            }
        },
        {
            key: "anyUpdated",
            value: function anyUpdated() {
                var _this4 = this;
                this.emitter.emit($d26325b71343c3d7$export$a66cbd9b2289cd78);
                this.emitter.eventNames().filter(function(name) {
                    return name !== $d26325b71343c3d7$export$a66cbd9b2289cd78;
                }).forEach(function(event) {
                    _this4.emitter.emit(event);
                });
            }
        }
    ]);
}();







function $8a559282e6e43c61$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return (0, $eb4764551033db71$export$2e2bcd8739ae039)(r);
}


function $b7880359a29a9009$export$2e2bcd8739ae039(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}



function $8d62b7d74f8692ff$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}


function $26ce087261062f24$export$2e2bcd8739ae039(r) {
    return (0, $8a559282e6e43c61$export$2e2bcd8739ae039)(r) || (0, $b7880359a29a9009$export$2e2bcd8739ae039)(r) || (0, $9f8ed0ce02ebf653$export$2e2bcd8739ae039)(r) || (0, $8d62b7d74f8692ff$export$2e2bcd8739ae039)();
}





var $54423b3a6044750d$export$ce553301d55c2fd8 = 'fedramp-moderate';
var $54423b3a6044750d$export$f005e2e9f707cb5f = 'commercial';
var $54423b3a6044750d$export$bd6b5a7802d76127 = 'fedramp-fedex';
var $54423b3a6044750d$export$a739cd5aac835909 = 'stg';
var $54423b3a6044750d$export$42dd0cdd351a4a9 = 'prod';
var $54423b3a6044750d$export$404582bc18fe4d9e = 'dev';


function $0717fe457bff801a$export$64d6499adf9b2e51() {
    var _global$location;
    var global = globalThis;
    // MICROS_PERIMETER is already used by few products, so we need to keep it for backward compatibility
    var env = global.MICROS_PERIMETER || global.UNSAFE_ATL_CONTEXT_BOUNDARY;
    if (env) return env === (0, $54423b3a6044750d$export$ce553301d55c2fd8);
    var matches = (_global$location = global.location) === null || _global$location === void 0 || (_global$location = _global$location.hostname) === null || _global$location === void 0 ? void 0 : _global$location.match(/atlassian-us-gov-mod\.(com|net)|atlassian-us-gov\.(com|net)|atlassian-fex\.(com|net)|atlassian-stg-fedm\.(com|net)/);
    return matches ? matches.length > 0 : false;
}


// Reference: https://github.com/statsig-io/js-lite/blob/main/src/StatsigStore.ts
var $bb4ffb7b92792fed$export$c62558b199e46828 = {
    // Order is important since the logic for migrating from a new client reason to an old one
    // returns the first which is a substring of the new client reason
    Error: 'Error',
    LocalOverride: 'LocalOverride',
    Unrecognized: 'Unrecognized',
    Uninitialized: 'Uninitialized',
    NetworkNotModified: 'NetworkNotModified',
    Network: 'Network',
    InvalidBootstrap: 'InvalidBootstrap',
    Bootstrap: 'Bootstrap',
    Cache: 'Cache',
    // For when we could not migrate the reason from the new client
    Unknown: 'Unknown'
}; // Reference: https://github.com/statsig-io/js-lite/blob/main/src/StatsigSDKOptions.ts


/**
 * The identifiers for the user. Options are restricted to the set that is currently supported.
 */ /**
 * Base client options. Does not include any options specific to providers
 * @interface BaseClientOptions
 * @property {FeatureGateEnvironment} environment - The environment for the client.
 * @property {string} targetApp - The target app for the client.
 * @property {AnalyticsWebClient} analyticsWebClient - The analytics web client.
 * @property {PerimeterType} perimeter - The perimeter for the client.
 */ /**
 * The options for the client.
 * @interface ClientOptions
 * @extends {BaseClientOptions}
 * @property {string} apiKey - The API key for the client.
 * @property {fetchTimeoutMs} fetchTimeoutMs - The timeout for the fetch request in milliseconds. Defaults to 5000.
 * @property {boolean} useGatewayURL - Whether to use the gateway URL. Defaults to false.
 */ /**
 * The custom attributes for the user.
 */ var $516b4b3ae2a8b767$export$479e7351a733299 = {
    Development: 'development',
    Staging: 'staging',
    Production: 'production'
};
var $516b4b3ae2a8b767$export$c42b7bbc5e7ba555 = {
    COMMERCIAL: 'commercial',
    FEDRAMP_MODERATE: 'fedramp-moderate'
};
var $516b4b3ae2a8b767$export$42f4885608027d0c = 'non_boolean'; // Type magic to get the JSDoc comments from the Client class methods to appear on the static
 // methods in FeatureGates where the property name and function type are identical


var $d925d48c155338e5$var$_excluded = [
    "stableId"
], $d925d48c155338e5$var$_excluded2 = [
    "api",
    "disableCurrentPageLogging",
    "loggingIntervalMillis",
    "loggingBufferMaxSize",
    "localMode",
    "eventLoggingApi",
    "eventLoggingApiForRetries",
    "disableLocalStorage",
    "ignoreWindowUndefined",
    "disableAllLogging",
    "initTimeoutMs",
    "disableNetworkKeepalive",
    "overrideStableID",
    "disableErrorLogging",
    "disableAutoMetricsLogging"
];
function $d925d48c155338e5$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $d925d48c155338e5$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $d925d48c155338e5$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $36e8c6a8ae2e8480$export$2e2bcd8739ae039)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $d925d48c155338e5$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $d925d48c155338e5$export$d119b37e5f788b43 = function getOptionsWithDefaults(options) {
    return $d925d48c155338e5$var$_objectSpread({
        /**
     * If more federal PerimeterTypes are added in the future, this should be updated so
     * that isFedRamp() === true always returns the strictest perimeter.
     */ perimeter: (0, $0717fe457bff801a$export$64d6499adf9b2e51)() ? (0, $516b4b3ae2a8b767$export$c42b7bbc5e7ba555).FEDRAMP_MODERATE : (0, $516b4b3ae2a8b767$export$c42b7bbc5e7ba555).COMMERCIAL
    }, options);
};
var $d925d48c155338e5$export$fa1c2bbf4100b8bc = function shallowEquals(objectA, objectB) {
    if (!objectA && !objectB) return true;
    if (!objectA || !objectB) return false;
    var aEntries = Object.entries(objectA);
    var bEntries = Object.entries(objectB);
    if (aEntries.length !== bEntries.length) return false;
    var ascendingKeyOrder = function ascendingKeyOrder(_ref, _ref2) {
        var _ref3 = (0, $5e90782b0facda0b$export$2e2bcd8739ae039)(_ref, 1), key1 = _ref3[0];
        var _ref4 = (0, $5e90782b0facda0b$export$2e2bcd8739ae039)(_ref2, 1), key2 = _ref4[0];
        return key1.localeCompare(key2);
    };
    aEntries.sort(ascendingKeyOrder);
    bEntries.sort(ascendingKeyOrder);
    for(var i = 0; i < aEntries.length; i++){
        var _aEntries$i = (0, $5e90782b0facda0b$export$2e2bcd8739ae039)(aEntries[i], 2), aValue = _aEntries$i[1];
        var _bEntries$i = (0, $5e90782b0facda0b$export$2e2bcd8739ae039)(bEntries[i], 2), bValue = _bEntries$i[1];
        if (aValue !== bValue) return false;
    }
    return true;
};
var $d925d48c155338e5$export$3dad1db244472f32 = function toStatsigUser(identifiers, customAttributes) {
    // Re-map `stableId` to `stableID` to match Statsig's native type.
    var stableId = identifiers.stableId, otherIdentifiers = (0, $e1dadfc9c3d2f1bd$export$2e2bcd8739ae039)(identifiers, $d925d48c155338e5$var$_excluded);
    var user = {
        customIDs: $d925d48c155338e5$var$_objectSpread($d925d48c155338e5$var$_objectSpread({}, otherIdentifiers), stableId !== undefined ? {
            stableID: stableId
        } : {}),
        custom: customAttributes
    };
    if (identifiers.atlassianAccountId) user.userID = identifiers.atlassianAccountId;
    return user;
};
function $d925d48c155338e5$export$1148cb79ceecd5fa(target) {
    for(var _len = arguments.length, sources = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)sources[_key - 1] = arguments[_key];
    if (!sources.length) return target;
    var source = sources.shift();
    if (source === undefined || source === null) return $d925d48c155338e5$export$1148cb79ceecd5fa.apply(void 0, [
        target
    ].concat((0, $26ce087261062f24$export$2e2bcd8739ae039)(sources)));
    for(var _i = 0, _Object$entries = Object.entries(source); _i < _Object$entries.length; _i++){
        var _Object$entries$_i = (0, $5e90782b0facda0b$export$2e2bcd8739ae039)(_Object$entries[_i], 2), key = _Object$entries$_i[0], src = _Object$entries$_i[1];
        var dst = target[key];
        var srcIsObj = src && (0, $0b394150901e1111$export$2e2bcd8739ae039)(src) === 'object' && !Array.isArray(src);
        var dstIsObj = dst && (0, $0b394150901e1111$export$2e2bcd8739ae039)(dst) === 'object' && !Array.isArray(dst);
        if (srcIsObj && dstIsObj) target[key] = $d925d48c155338e5$export$1148cb79ceecd5fa(dst, src);
        else target[key] = src;
    }
    return $d925d48c155338e5$export$1148cb79ceecd5fa.apply(void 0, [
        target
    ].concat((0, $26ce087261062f24$export$2e2bcd8739ae039)(sources)));
}
var $d925d48c155338e5$export$202946b690d26d22 = function migrateInitializationOptions(options) {
    var api = options.api, disableCurrentPageLogging = options.disableCurrentPageLogging, loggingIntervalMillis = options.loggingIntervalMillis, loggingBufferMaxSize = options.loggingBufferMaxSize, localMode = options.localMode, eventLoggingApi = options.eventLoggingApi, eventLoggingApiForRetries = options.eventLoggingApiForRetries, disableLocalStorage = options.disableLocalStorage, ignoreWindowUndefined = options.ignoreWindowUndefined, disableAllLogging = options.disableAllLogging, _initTimeoutMs = options.initTimeoutMs, _disableNetworkKeepalive = options.disableNetworkKeepalive, _overrideStableID = options.overrideStableID, _disableErrorLogging = options.disableErrorLogging, _disableAutoMetricsLogging = options.disableAutoMetricsLogging, rest = (0, $e1dadfc9c3d2f1bd$export$2e2bcd8739ae039)(options, $d925d48c155338e5$var$_excluded2);
    return $d925d48c155338e5$var$_objectSpread($d925d48c155338e5$var$_objectSpread({}, rest), {}, {
        networkConfig: {
            api: api,
            logEventUrl: eventLoggingApi ? eventLoggingApi + 'rgstr' : undefined,
            logEventFallbackUrls: eventLoggingApiForRetries ? [
                eventLoggingApiForRetries
            ] : undefined,
            preventAllNetworkTraffic: localMode || !ignoreWindowUndefined && typeof window === 'undefined'
        },
        includeCurrentPageUrlWithEvents: !disableCurrentPageLogging,
        loggingIntervalMs: loggingIntervalMillis,
        loggingBufferMaxSize: loggingBufferMaxSize,
        disableStorage: disableLocalStorage === undefined ? localMode : disableLocalStorage,
        disableLogging: disableAllLogging === undefined ? localMode : disableAllLogging
    });
};
var $d925d48c155338e5$var$evaluationReasonMappings = Object.entries((0, $bb4ffb7b92792fed$export$c62558b199e46828)).map(function(_ref5) {
    var _ref6 = (0, $5e90782b0facda0b$export$2e2bcd8739ae039)(_ref5, 2), key = _ref6[0], value = _ref6[1];
    return [
        key.toLowerCase(),
        value
    ];
});
var $d925d48c155338e5$export$18ad168d3dbac899 = function migrateEvaluationDetails(details) {
    var _evaluationReasonMapp, _evaluationReasonMapp2, _details$receivedAt;
    var reasonLower = details.reason.toLowerCase();
    return {
        reason: (_evaluationReasonMapp = (_evaluationReasonMapp2 = $d925d48c155338e5$var$evaluationReasonMappings.find(function(_ref7) {
            var _ref8 = (0, $5e90782b0facda0b$export$2e2bcd8739ae039)(_ref7, 1), key = _ref8[0];
            return reasonLower.includes(key);
        })) === null || _evaluationReasonMapp2 === void 0 ? void 0 : _evaluationReasonMapp2[1]) !== null && _evaluationReasonMapp !== void 0 ? _evaluationReasonMapp : (0, $bb4ffb7b92792fed$export$c62558b199e46828).Unknown,
        time: (_details$receivedAt = details.receivedAt) !== null && _details$receivedAt !== void 0 ? _details$receivedAt : Date.now()
    };
};
var $d925d48c155338e5$export$55fd683752d01e67 = function migrateSecondaryExposures(secondaryExposures) {
    return secondaryExposures.map(function(exposure) {
        if (typeof exposure === 'string') // This should ideally have gateValue and ruleID fields too, but it's not possible for us
        // to determine the correct values for these.
        return {
            gate: exposure
        };
        return exposure;
    });
};


var $e5f5c96a9cfad9f4$export$6dc24881a3d96325 = /*#__PURE__*/ function() {
    function DynamicConfig(configName, configValue, ruleID, evaluationDetails) {
        var secondaryExposures = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : [];
        var allocatedExperimentName = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : '';
        var onDefaultValueFallback = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : null;
        (0, $b415120f8e0f227f$export$2e2bcd8739ae039)(this, DynamicConfig);
        this.value = configValue;
        this._name = configName;
        this._ruleID = ruleID;
        this._secondaryExposures = secondaryExposures;
        this._allocatedExperimentName = allocatedExperimentName;
        this._evaluationDetails = evaluationDetails;
        this._onDefaultValueFallback = onDefaultValueFallback;
    }
    return (0, $8be4ca258be1ae94$export$2e2bcd8739ae039)(DynamicConfig, [
        {
            key: "get",
            value: function get(key, defaultValue, typeGuard) {
                var _this$_onDefaultValue2;
                var val = this.getValue(key, defaultValue);
                if (val == null) return defaultValue;
                var expectedType = Array.isArray(defaultValue) ? 'array' : (0, $0b394150901e1111$export$2e2bcd8739ae039)(defaultValue);
                var actualType = Array.isArray(val) ? 'array' : (0, $0b394150901e1111$export$2e2bcd8739ae039)(val);
                if (typeGuard) {
                    var _this$_onDefaultValue;
                    if (typeGuard(val)) {
                        this.fireExposure(key);
                        return val;
                    }
                    (_this$_onDefaultValue = this._onDefaultValueFallback) === null || _this$_onDefaultValue === void 0 || _this$_onDefaultValue.call(this, this, key, expectedType, actualType);
                    return defaultValue;
                }
                if (defaultValue == null || expectedType === actualType) {
                    this.fireExposure(key);
                    return val;
                }
                (_this$_onDefaultValue2 = this._onDefaultValueFallback) === null || _this$_onDefaultValue2 === void 0 || _this$_onDefaultValue2.call(this, this, key, expectedType, actualType);
                return defaultValue;
            }
        },
        {
            key: "getValue",
            value: function getValue(key, defaultValue) {
                if (key == null) return this.value;
                if (defaultValue == null) defaultValue = null;
                if (this.value[key] == null) return defaultValue;
                this.fireExposure(key);
                return this.value[key];
            }
        },
        {
            key: "fireExposure",
            value: function fireExposure(key) {
                // Call the wrapped experiment's get method to fire exposure
                if (this.experiment) this.experiment.get(key);
            }
        }
    ], [
        {
            key: "fromExperiment",
            value: function fromExperiment(experiment) {
                var _experiment$__evaluat, _experiment$__evaluat2, _experiment$groupName;
                var config = new DynamicConfig(experiment.name, experiment.value, experiment.ruleID, (0, $d925d48c155338e5$export$18ad168d3dbac899)(experiment.details), (0, $d925d48c155338e5$export$55fd683752d01e67)((_experiment$__evaluat = (_experiment$__evaluat2 = experiment.__evaluation) === null || _experiment$__evaluat2 === void 0 ? void 0 : _experiment$__evaluat2.secondary_exposures) !== null && _experiment$__evaluat !== void 0 ? _experiment$__evaluat : []), (_experiment$groupName = experiment.groupName) !== null && _experiment$groupName !== void 0 ? _experiment$groupName : undefined);
                config.experiment = experiment;
                return config;
            }
        }
    ]);
}();






var $cd7bdea79e6bbef8$export$936d0764594b6eb3 = /*#__PURE__*/ function() {
    function Layer(name, layerValue, ruleID, evaluationDetails) {
        var logParameterFunction = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;
        var secondaryExposures = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : [];
        var undelegatedSecondaryExposures = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : [];
        var allocatedExperimentName = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : '';
        var explicitParameters = arguments.length > 8 && arguments[8] !== undefined ? arguments[8] : [];
        (0, $b415120f8e0f227f$export$2e2bcd8739ae039)(this, Layer);
        this._logParameterFunction = logParameterFunction;
        this._name = name;
        this._value = JSON.parse(JSON.stringify(layerValue !== null && layerValue !== void 0 ? layerValue : {}));
        this._ruleID = ruleID !== null && ruleID !== void 0 ? ruleID : '';
        this._evaluationDetails = evaluationDetails;
        this._secondaryExposures = secondaryExposures;
        this._undelegatedSecondaryExposures = undelegatedSecondaryExposures;
        this._allocatedExperimentName = allocatedExperimentName;
        this._explicitParameters = explicitParameters;
    }
    return (0, $8be4ca258be1ae94$export$2e2bcd8739ae039)(Layer, [
        {
            key: "get",
            value: function get(key, defaultValue, typeGuard) {
                var _this = this;
                var val = this._value[key];
                if (val == null) return defaultValue;
                var logAndReturn = function logAndReturn() {
                    _this._logLayerParameterExposure(key);
                    return val;
                };
                if (typeGuard) return typeGuard(val) ? logAndReturn() : defaultValue;
                if (defaultValue == null) return logAndReturn();
                if ((0, $0b394150901e1111$export$2e2bcd8739ae039)(val) === (0, $0b394150901e1111$export$2e2bcd8739ae039)(defaultValue) && Array.isArray(defaultValue) === Array.isArray(val)) return logAndReturn();
                return defaultValue;
            }
        },
        {
            key: "getValue",
            value: function getValue(key, defaultValue) {
                // eslint-disable-next-line eqeqeq
                if (defaultValue == undefined) defaultValue = null;
                var val = this._value[key];
                if (val != null) this._logLayerParameterExposure(key);
                return val !== null && val !== void 0 ? val : defaultValue;
            }
        },
        {
            key: "_logLayerParameterExposure",
            value: function _logLayerParameterExposure(parameterName) {
                var _this$_logParameterFu;
                (_this$_logParameterFu = this._logParameterFunction) === null || _this$_logParameterFu === void 0 || _this$_logParameterFu.call(this, this, parameterName);
            }
        }
    ], [
        {
            key: "fromLayer",
            value: function fromLayer(layer) {
                var _layer$__evaluation$s, _layer$__evaluation, _layer$__evaluation$u, _layer$__evaluation2, _layer$__evaluation3, _layer$__evaluation4;
                var value = new Layer(layer.name, layer.__value, layer.ruleID, (0, $d925d48c155338e5$export$18ad168d3dbac899)(layer.details), function(_layer, parameterName) {
                    return layer.get(parameterName);
                }, (0, $d925d48c155338e5$export$55fd683752d01e67)((_layer$__evaluation$s = (_layer$__evaluation = layer.__evaluation) === null || _layer$__evaluation === void 0 ? void 0 : _layer$__evaluation.secondary_exposures) !== null && _layer$__evaluation$s !== void 0 ? _layer$__evaluation$s : []), (0, $d925d48c155338e5$export$55fd683752d01e67)((_layer$__evaluation$u = (_layer$__evaluation2 = layer.__evaluation) === null || _layer$__evaluation2 === void 0 ? void 0 : _layer$__evaluation2.undelegated_secondary_exposures) !== null && _layer$__evaluation$u !== void 0 ? _layer$__evaluation$u : []), (_layer$__evaluation3 = layer.__evaluation) === null || _layer$__evaluation3 === void 0 ? void 0 : _layer$__evaluation3.allocated_experiment_name, (_layer$__evaluation4 = layer.__evaluation) === null || _layer$__evaluation4 === void 0 ? void 0 : _layer$__evaluation4.explicit_parameters);
                return value;
            }
        }
    ]);
}();









/// <reference types="node" />
var $486412f8149dc8bc$export$a59f8d67326bd1cb = "5.8.0";





function $d3e47ea3e6a73101$export$2e2bcd8739ae039(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
}


function $ff8735ca66b4325e$export$2e2bcd8739ae039(t, e) {
    if (e && ("object" == (0, $0b394150901e1111$export$2e2bcd8739ae039)(e) || "function" == typeof e)) return e;
    if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
    return (0, $d3e47ea3e6a73101$export$2e2bcd8739ae039)(t);
}


function $a5ff528a183eafe8$export$2e2bcd8739ae039(t) {
    return $a5ff528a183eafe8$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
        return t.__proto__ || Object.getPrototypeOf(t);
    }, $a5ff528a183eafe8$export$2e2bcd8739ae039(t);
}


function $f2c5ad39f6fc4128$export$2e2bcd8739ae039(t, e) {
    return $f2c5ad39f6fc4128$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, $f2c5ad39f6fc4128$export$2e2bcd8739ae039(t, e);
}


function $d38571b416fa0640$export$2e2bcd8739ae039(t, e) {
    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
    t.prototype = Object.create(e && e.prototype, {
        constructor: {
            value: t,
            writable: !0,
            configurable: !0
        }
    }), Object.defineProperty(t, "prototype", {
        writable: !1
    }), e && (0, $f2c5ad39f6fc4128$export$2e2bcd8739ae039)(t, e);
}




function $405138909c3e41cc$export$2e2bcd8739ae039(t) {
    try {
        return -1 !== Function.toString.call(t).indexOf("[native code]");
    } catch (n) {
        return "function" == typeof t;
    }
}


function $1b4b9aefb6cb582e$export$2e2bcd8739ae039() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($1b4b9aefb6cb582e$export$2e2bcd8739ae039 = function _isNativeReflectConstruct() {
        return !!t;
    })();
}



function $493118e782ed1f14$export$2e2bcd8739ae039(t, e, r) {
    if ((0, $1b4b9aefb6cb582e$export$2e2bcd8739ae039)()) return Reflect.construct.apply(null, arguments);
    var o = [
        null
    ];
    o.push.apply(o, e);
    var p = new (t.bind.apply(t, o))();
    return r && (0, $f2c5ad39f6fc4128$export$2e2bcd8739ae039)(p, r.prototype), p;
}


function $95e74c06f4994595$export$2e2bcd8739ae039(t) {
    var r = "function" == typeof Map ? new Map() : void 0;
    return $95e74c06f4994595$export$2e2bcd8739ae039 = function _wrapNativeSuper(t) {
        if (null === t || !(0, $405138909c3e41cc$export$2e2bcd8739ae039)(t)) return t;
        if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function");
        if (void 0 !== r) {
            if (r.has(t)) return r.get(t);
            r.set(t, Wrapper);
        }
        function Wrapper() {
            return (0, $493118e782ed1f14$export$2e2bcd8739ae039)(t, arguments, (0, $a5ff528a183eafe8$export$2e2bcd8739ae039)(this).constructor);
        }
        return Wrapper.prototype = Object.create(t.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: !1,
                writable: !0,
                configurable: !0
            }
        }), (0, $f2c5ad39f6fc4128$export$2e2bcd8739ae039)(Wrapper, t);
    }, $95e74c06f4994595$export$2e2bcd8739ae039(t);
}


function $2abb48cdf872e6e5$var$_callSuper(t, o, e) {
    return o = (0, $a5ff528a183eafe8$export$2e2bcd8739ae039)(o), (0, $ff8735ca66b4325e$export$2e2bcd8739ae039)(t, $2abb48cdf872e6e5$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, $a5ff528a183eafe8$export$2e2bcd8739ae039)(t).constructor) : o.apply(t, e));
}
function $2abb48cdf872e6e5$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($2abb48cdf872e6e5$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $2abb48cdf872e6e5$export$286baf652d0b1206 = /*#__PURE__*/ function(_Error) {
    function ResponseError(message) {
        (0, $b415120f8e0f227f$export$2e2bcd8739ae039)(this, ResponseError);
        return $2abb48cdf872e6e5$var$_callSuper(this, ResponseError, [
            message
        ]);
    }
    (0, $d38571b416fa0640$export$2e2bcd8739ae039)(ResponseError, _Error);
    return (0, $8be4ca258be1ae94$export$2e2bcd8739ae039)(ResponseError);
}(/*#__PURE__*/ (0, $95e74c06f4994595$export$2e2bcd8739ae039)(Error));


function $0f34ebd4941c4ffb$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $0f34ebd4941c4ffb$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $0f34ebd4941c4ffb$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $36e8c6a8ae2e8480$export$2e2bcd8739ae039)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $0f34ebd4941c4ffb$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $0f34ebd4941c4ffb$var$DEFAULT_REQUEST_TIMEOUT_MS = 5000;
var $0f34ebd4941c4ffb$export$250a58ecde616daa = 'https://api.atlassian.com/flags';
var $0f34ebd4941c4ffb$export$942ba04389b0d5a2 = 'https://api.stg.atlassian.com/flags';
var $0f34ebd4941c4ffb$export$f058dbf75c3bc647 = 'https://api.dev.atlassian.com/flags';
var $0f34ebd4941c4ffb$export$1a401a0da8da3565 = 'https://api.stg.atlassian-us-gov-mod.com/flags';
var $0f34ebd4941c4ffb$export$18c93900db9358a4 = 'https://api.atlassian-us-gov-mod.com/flags';
var $0f34ebd4941c4ffb$export$4e8a0415edbfa1f7 = 'https://atlassian-statsig-proxy-archetype.atl-paas.%s.atl-ic.net';
var $0f34ebd4941c4ffb$export$cb3cd156f70d7e94 = 'oasis-stg.com/flags';
var $0f34ebd4941c4ffb$export$921fbc6cdfd4eee0 = 'atlassian-isolated.net/flags';
var $0f34ebd4941c4ffb$export$450bd8fb2a6d7ace = '/gateway/api/flags';
var $0f34ebd4941c4ffb$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function Fetcher() {
        (0, $b415120f8e0f227f$export$2e2bcd8739ae039)(this, Fetcher);
    }
    return (0, $8be4ca258be1ae94$export$2e2bcd8739ae039)(Fetcher, null, [
        {
            key: "fetchClientSdk",
            value: function() {
                var _fetchClientSdk = (0, $a6260dcf494016d1$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($249ba1682cdbc1d3$exports))).mark(function _callee(fetcherOptions) {
                    var targetApp, url, _t;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($249ba1682cdbc1d3$exports))).wrap(function(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                targetApp = fetcherOptions.targetApp;
                                url = "/api/v2/frontend/clientSdkKey/".concat(targetApp);
                                _context.prev = 1;
                                _context.next = 2;
                                return this.fetchRequest(url, 'GET', fetcherOptions);
                            case 2:
                                return _context.abrupt("return", _context.sent);
                            case 3:
                                _context.prev = 3;
                                _t = _context["catch"](1);
                                if (!(_t instanceof Error)) {
                                    _context.next = 4;
                                    break;
                                }
                                throw _t;
                            case 4:
                                throw Error('Failed to retrieve client sdk key');
                            case 5:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee, this, [
                        [
                            1,
                            3
                        ]
                    ]);
                }));
                function fetchClientSdk(_x) {
                    return _fetchClientSdk.apply(this, arguments);
                }
                return fetchClientSdk;
            }()
        },
        {
            key: "fetchExperimentValues",
            value: function() {
                var _fetchExperimentValues = (0, $a6260dcf494016d1$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($249ba1682cdbc1d3$exports))).mark(function _callee2(fetcherOptions, identifiers, customAttributes) {
                    var requestBody, _t2;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($249ba1682cdbc1d3$exports))).wrap(function(_context2) {
                        while(true)switch(_context2.prev = _context2.next){
                            case 0:
                                requestBody = {
                                    identifiers: identifiers,
                                    customAttributes: customAttributes,
                                    targetApp: fetcherOptions.targetApp
                                };
                                _context2.prev = 1;
                                _context2.next = 2;
                                return this.fetchRequest('/api/v2/frontend/experimentValues', 'POST', fetcherOptions, requestBody);
                            case 2:
                                return _context2.abrupt("return", _context2.sent);
                            case 3:
                                _context2.prev = 3;
                                _t2 = _context2["catch"](1);
                                if (!(_t2 instanceof Error)) {
                                    _context2.next = 4;
                                    break;
                                }
                                throw _t2;
                            case 4:
                                throw Error('Failed to retrieve experiment values');
                            case 5:
                            case "end":
                                return _context2.stop();
                        }
                    }, _callee2, this, [
                        [
                            1,
                            3
                        ]
                    ]);
                }));
                function fetchExperimentValues(_x2, _x3, _x4) {
                    return _fetchExperimentValues.apply(this, arguments);
                }
                return fetchExperimentValues;
            }()
        },
        {
            key: "handleResponseError",
            value: function() {
                var _handleResponseError = (0, $a6260dcf494016d1$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($249ba1682cdbc1d3$exports))).mark(function _callee3(response) {
                    var body;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($249ba1682cdbc1d3$exports))).wrap(function(_context3) {
                        while(true)switch(_context3.prev = _context3.next){
                            case 0:
                                if (response.ok) {
                                    _context3.next = 2;
                                    break;
                                }
                                _context3.next = 1;
                                return response.text();
                            case 1:
                                body = _context3.sent;
                                throw new (0, $2abb48cdf872e6e5$export$286baf652d0b1206)("Non 2xx response status received, status: ".concat(response.status, ", body: ").concat(JSON.stringify(body)));
                            case 2:
                                if (!(response.status === 204)) {
                                    _context3.next = 3;
                                    break;
                                }
                                throw new (0, $2abb48cdf872e6e5$export$286baf652d0b1206)('Unexpected 204 response');
                            case 3:
                            case "end":
                                return _context3.stop();
                        }
                    }, _callee3);
                }));
                function handleResponseError(_x5) {
                    return _handleResponseError.apply(this, arguments);
                }
                return handleResponseError;
            }()
        },
        {
            key: "extractResponseBody",
            value: function() {
                var _extractResponseBody = (0, $a6260dcf494016d1$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($249ba1682cdbc1d3$exports))).mark(function _callee4(response) {
                    var value;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($249ba1682cdbc1d3$exports))).wrap(function(_context4) {
                        while(true)switch(_context4.prev = _context4.next){
                            case 0:
                                _context4.next = 1;
                                return response.text();
                            case 1:
                                value = _context4.sent;
                                return _context4.abrupt("return", JSON.parse(value));
                            case 2:
                            case "end":
                                return _context4.stop();
                        }
                    }, _callee4);
                }));
                function extractResponseBody(_x6) {
                    return _extractResponseBody.apply(this, arguments);
                }
                return extractResponseBody;
            }()
        },
        {
            key: "getBaseUrl",
            value: function getBaseUrl(serviceEnv) {
                var useGatewayUrl = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
                var perimeter = arguments.length > 2 ? arguments[2] : undefined;
                var isolationContextId = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
                if (useGatewayUrl) return $0f34ebd4941c4ffb$export$450bd8fb2a6d7ace;
                if (perimeter === (0, $516b4b3ae2a8b767$export$c42b7bbc5e7ba555).FEDRAMP_MODERATE) switch(serviceEnv){
                    case (0, $516b4b3ae2a8b767$export$479e7351a733299).Production:
                        return $0f34ebd4941c4ffb$export$18c93900db9358a4;
                    case (0, $516b4b3ae2a8b767$export$479e7351a733299).Staging:
                        return $0f34ebd4941c4ffb$export$1a401a0da8da3565;
                    default:
                        throw new Error("Invalid environment \"".concat(serviceEnv, "\" for \"").concat(perimeter, "\" perimeter"));
                }
                else if (perimeter === (0, $516b4b3ae2a8b767$export$c42b7bbc5e7ba555).COMMERCIAL) switch(serviceEnv){
                    case (0, $516b4b3ae2a8b767$export$479e7351a733299).Development:
                        return $0f34ebd4941c4ffb$export$f058dbf75c3bc647;
                    case (0, $516b4b3ae2a8b767$export$479e7351a733299).Staging:
                        var apiUrl = this.getApiUrl(isolationContextId);
                        if (apiUrl !== null) return apiUrl;
                        return $0f34ebd4941c4ffb$export$942ba04389b0d5a2;
                    default:
                        var prodApiUrl = this.getApiUrl(isolationContextId);
                        if (prodApiUrl !== null) return prodApiUrl;
                        return $0f34ebd4941c4ffb$export$250a58ecde616daa;
                }
                else throw new Error("Invalid perimeter \"".concat(perimeter, "\""));
            }
        },
        {
            key: "fetchRequest",
            value: function() {
                var _fetchRequest = (0, $a6260dcf494016d1$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($249ba1682cdbc1d3$exports))).mark(function _callee5(path, method, fetcherOptions, body) {
                    var baseUrl, fetchTimeout, abortSignal, abortController, response;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($249ba1682cdbc1d3$exports))).wrap(function(_context5) {
                        while(true)switch(_context5.prev = _context5.next){
                            case 0:
                                baseUrl = Fetcher.getBaseUrl(fetcherOptions.environment, fetcherOptions.useGatewayURL, fetcherOptions.perimeter, fetcherOptions.isolationContextId);
                                fetchTimeout = fetcherOptions.fetchTimeoutMs || $0f34ebd4941c4ffb$var$DEFAULT_REQUEST_TIMEOUT_MS;
                                if (AbortSignal.timeout) abortSignal = AbortSignal.timeout(fetchTimeout);
                                else if (AbortController) {
                                    abortController = new AbortController();
                                    abortSignal = abortController.signal;
                                    setTimeout(function() {
                                        return abortController.abort();
                                    }, fetchTimeout);
                                }
                                _context5.next = 1;
                                return fetch("".concat(baseUrl).concat(path), $0f34ebd4941c4ffb$var$_objectSpread({
                                    method: method,
                                    headers: {
                                        'Content-Type': 'application/json',
                                        'X-Client-Name': 'feature-gate-js-client',
                                        'X-Client-Version': (0, $486412f8149dc8bc$export$a59f8d67326bd1cb),
                                        'X-API-KEY': fetcherOptions.apiKey
                                    },
                                    signal: abortSignal
                                }, body && {
                                    body: JSON.stringify(body)
                                }));
                            case 1:
                                response = _context5.sent;
                                _context5.next = 2;
                                return this.handleResponseError(response);
                            case 2:
                                _context5.next = 3;
                                return this.extractResponseBody(response);
                            case 3:
                                return _context5.abrupt("return", _context5.sent);
                            case 4:
                            case "end":
                                return _context5.stop();
                        }
                    }, _callee5, this);
                }));
                function fetchRequest(_x7, _x8, _x9, _x0) {
                    return _fetchRequest.apply(this, arguments);
                }
                return fetchRequest;
            }()
        },
        {
            key: "getApiUrl",
            value: function getApiUrl(isolationContextId) {
                var window1 = this.getWindowLocation();
                if (window1 === undefined) {
                    //this is needed when this SDK is used for SSR or plugin use cases where secret keys not available to use backend SDKs
                    if (!isolationContextId) return null;
                    return $0f34ebd4941c4ffb$export$4e8a0415edbfa1f7.replace('%s', isolationContextId);
                }
                var protocol = window1.protocol, hostname = window1.hostname;
                // Match last subdomain fragment before oasis-stg.com
                var oasisMatch = hostname.match(/([^.]+)\.oasis-stg\.com$/);
                if (oasisMatch) return "".concat(protocol, "//api.").concat(oasisMatch[1], ".").concat($0f34ebd4941c4ffb$export$cb3cd156f70d7e94);
                // Match last subdomain fragment before atlassian-isolated.net
                var isolatedMatch = hostname.match(/([^.]+)\.atlassian-isolated\.net$/);
                if (isolatedMatch) return "".concat(protocol, "//api.").concat(isolatedMatch[1], ".").concat($0f34ebd4941c4ffb$export$921fbc6cdfd4eee0);
                return null;
            }
        },
        {
            key: "getWindowLocation",
            value: function getWindowLocation() {
                if (typeof window !== 'undefined' && window.location) return window.location;
                return undefined;
            }
        }
    ]);
}();








function $52713198df29157e$export$2e2bcd8739ae039(t, o) {
    for(; !({}).hasOwnProperty.call(t, o) && null !== (t = (0, $a5ff528a183eafe8$export$2e2bcd8739ae039)(t)););
    return t;
}


function $1bb15625cf4ef546$export$2e2bcd8739ae039() {
    return $1bb15625cf4ef546$export$2e2bcd8739ae039 = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function(e, t, r) {
        var p = (0, $52713198df29157e$export$2e2bcd8739ae039)(e, t);
        if (p) {
            var n = Object.getOwnPropertyDescriptor(p, t);
            return n.get ? n.get.call(arguments.length < 3 ? e : r) : n.value;
        }
    }, $1bb15625cf4ef546$export$2e2bcd8739ae039.apply(null, arguments);
}






var $iFR7a = parcelRequire("iFR7a");
function $b24077ba3afb3dce$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $b24077ba3afb3dce$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $b24077ba3afb3dce$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $36e8c6a8ae2e8480$export$2e2bcd8739ae039)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $b24077ba3afb3dce$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $b24077ba3afb3dce$var$_callSuper(t, o, e) {
    return o = (0, $a5ff528a183eafe8$export$2e2bcd8739ae039)(o), (0, $ff8735ca66b4325e$export$2e2bcd8739ae039)(t, $b24077ba3afb3dce$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, $a5ff528a183eafe8$export$2e2bcd8739ae039)(t).constructor) : o.apply(t, e));
}
function $b24077ba3afb3dce$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($b24077ba3afb3dce$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $b24077ba3afb3dce$var$_superPropGet(t, o, e, r) {
    var p = (0, $1bb15625cf4ef546$export$2e2bcd8739ae039)((0, $a5ff528a183eafe8$export$2e2bcd8739ae039)(1 & r ? t.prototype : t), o, e);
    return 2 & r && "function" == typeof p ? function(t) {
        return p.apply(e, t);
    } : p;
}
var $b24077ba3afb3dce$export$55fffef3474104af = /*#__PURE__*/ function(_DataAdapterCore) {
    function NoFetchDataAdapter() {
        var _this;
        (0, $b415120f8e0f227f$export$2e2bcd8739ae039)(this, NoFetchDataAdapter);
        _this = $b24077ba3afb3dce$var$_callSuper(this, NoFetchDataAdapter, [
            'NoFetchDataAdapter',
            'nofetch'
        ]);
        (0, $36e8c6a8ae2e8480$export$2e2bcd8739ae039)(_this, "bootstrapResult", null);
        return _this;
    }
    /**
   * Make sure to call this **before** calling `initializeAsync` or `updateUserAsync` but
   * after the Statsig client has been created!
   */ (0, $d38571b416fa0640$export$2e2bcd8739ae039)(NoFetchDataAdapter, _DataAdapterCore);
    return (0, $8be4ca258be1ae94$export$2e2bcd8739ae039)(NoFetchDataAdapter, [
        {
            key: "setBootstrapData",
            value: function setBootstrapData(data) {
                this.bootstrapResult = data ? {
                    source: 'Bootstrap',
                    data: JSON.stringify(data),
                    receivedAt: Date.now(),
                    stableID: (0, $iFR7a.StableID).get(this._getSdkKey()),
                    fullUserHash: null
                } : null;
            }
        },
        {
            key: "prefetchData",
            value: function() {
                var _prefetchData = (0, $a6260dcf494016d1$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($249ba1682cdbc1d3$exports))).mark(function _callee(_user, _options) {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($249ba1682cdbc1d3$exports))).wrap(function(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee);
                }));
                function prefetchData(_x, _x2) {
                    return _prefetchData.apply(this, arguments);
                }
                return prefetchData;
            }()
        },
        {
            key: "getDataAsync",
            value: function() {
                var _getDataAsync = (0, $a6260dcf494016d1$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($249ba1682cdbc1d3$exports))).mark(function _callee2(_current, user, _options) {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($249ba1682cdbc1d3$exports))).wrap(function(_context2) {
                        while(true)switch(_context2.prev = _context2.next){
                            case 0:
                                return _context2.abrupt("return", this.bootstrapResult && $b24077ba3afb3dce$var$_objectSpread($b24077ba3afb3dce$var$_objectSpread({}, this.bootstrapResult), {}, {
                                    fullUserHash: (0, $iFR7a._getFullUserHash)(user)
                                }));
                            case 1:
                            case "end":
                                return _context2.stop();
                        }
                    }, _callee2, this);
                }));
                function getDataAsync(_x3, _x4, _x5) {
                    return _getDataAsync.apply(this, arguments);
                }
                return getDataAsync;
            }()
        },
        {
            key: "getDataSync",
            value: function getDataSync(user) {
                return this.bootstrapResult && $b24077ba3afb3dce$var$_objectSpread($b24077ba3afb3dce$var$_objectSpread({}, this.bootstrapResult), {}, {
                    fullUserHash: (0, $iFR7a._getFullUserHash)(user)
                });
            }
        },
        {
            key: "_fetchFromNetwork",
            value: function() {
                var _fetchFromNetwork2 = (0, $a6260dcf494016d1$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($249ba1682cdbc1d3$exports))).mark(function _callee3(_current, _user, _options) {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($249ba1682cdbc1d3$exports))).wrap(function(_context3) {
                        while(true)switch(_context3.prev = _context3.next){
                            case 0:
                                return _context3.abrupt("return", null);
                            case 1:
                            case "end":
                                return _context3.stop();
                        }
                    }, _callee3);
                }));
                function _fetchFromNetwork(_x6, _x7, _x8) {
                    return _fetchFromNetwork2.apply(this, arguments);
                }
                return _fetchFromNetwork;
            }()
        },
        {
            key: "_getCacheKey",
            value: function _getCacheKey(user) {
                // Same logic as default data adapter
                // https://github.com/statsig-io/js-client-monorepo/blob/main/packages/js-client/src/StatsigEvaluationsDataAdapter.ts
                var key = (0, $iFR7a._getStorageKey)(this._getSdkKey(), user);
                return "".concat((0, $iFR7a.DataAdapterCachePrefix), ".").concat(this._cacheSuffix, ".").concat(key);
            }
        },
        {
            key: "_isCachedResultValidFor204",
            value: function _isCachedResultValidFor204(_result, _user) {
                return false;
            }
        },
        {
            key: "setDataLegacy",
            value: function setDataLegacy(data, user) {
                $b24077ba3afb3dce$var$_superPropGet(NoFetchDataAdapter, "setData", this, 3)([
                    data,
                    user
                ]);
            }
        },
        {
            key: "toJSON",
            value: function toJSON() {
                var result = $b24077ba3afb3dce$var$_objectSpread({}, this);
                delete result._options;
                delete result._inMemoryCache;
                delete result.bootstrapResult;
                return result;
            }
        }
    ]);
}((0, $iFR7a.DataAdapterCore));







var $dtn6l = parcelRequire("dtn6l");
function $6da336d0c6496190$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $6da336d0c6496190$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $6da336d0c6496190$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $36e8c6a8ae2e8480$export$2e2bcd8739ae039)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $6da336d0c6496190$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $6da336d0c6496190$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $6da336d0c6496190$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $6da336d0c6496190$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $6da336d0c6496190$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $6da336d0c6496190$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $6da336d0c6496190$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
var $6da336d0c6496190$var$LOCAL_OVERRIDE_REASON = 'LocalOverride:Recognized';
var $6da336d0c6496190$export$d8474cff104280f3 = 'STATSIG_OVERRIDES';
var $6da336d0c6496190$var$LEGACY_LOCAL_STORAGE_KEY = 'STATSIG_JS_LITE_LOCAL_OVERRIDES';
var $6da336d0c6496190$var$makeEmptyStore = function makeEmptyStore() {
    return {
        gates: {},
        configs: {},
        layers: {}
    };
};
var $6da336d0c6496190$var$djb2MapKey = function djb2MapKey(hash, kind) {
    return kind + ':' + hash;
};
var $6da336d0c6496190$export$bcb28fbac1def494 = /*#__PURE__*/ function() {
    function PersistentOverrideAdapter(localStorageKey) {
        (0, $b415120f8e0f227f$export$2e2bcd8739ae039)(this, PersistentOverrideAdapter);
        this._overrides = $6da336d0c6496190$var$makeEmptyStore();
        this._djb2Map = new Map();
        this._localStorageKey = localStorageKey;
    }
    return (0, $8be4ca258be1ae94$export$2e2bcd8739ae039)(PersistentOverrideAdapter, [
        {
            key: "parseStoredOverrides",
            value: function parseStoredOverrides(localStorageKey) {
                try {
                    var json = window.localStorage.getItem(localStorageKey);
                    if (!json) return $6da336d0c6496190$var$makeEmptyStore();
                    return JSON.parse(json);
                } catch (_unused) {
                    return $6da336d0c6496190$var$makeEmptyStore();
                }
            }
        },
        {
            key: "mergeOverrides",
            value: function mergeOverrides() {
                var merged = $6da336d0c6496190$var$makeEmptyStore();
                for(var _len = arguments.length, allOverrides = new Array(_len), _key = 0; _key < _len; _key++)allOverrides[_key] = arguments[_key];
                for(var _i = 0, _allOverrides = allOverrides; _i < _allOverrides.length; _i++){
                    var overrides = _allOverrides[_i];
                    for(var _i2 = 0, _Object$entries = Object.entries((_overrides$gates = overrides.gates) !== null && _overrides$gates !== void 0 ? _overrides$gates : {}); _i2 < _Object$entries.length; _i2++){
                        var _overrides$gates;
                        var _Object$entries$_i = (0, $5e90782b0facda0b$export$2e2bcd8739ae039)(_Object$entries[_i2], 2), name = _Object$entries$_i[0], value = _Object$entries$_i[1];
                        merged.gates[name] = value;
                    }
                    for(var _i3 = 0, _Object$entries2 = Object.entries((_overrides$configs = overrides.configs) !== null && _overrides$configs !== void 0 ? _overrides$configs : {}); _i3 < _Object$entries2.length; _i3++){
                        var _overrides$configs;
                        var _Object$entries2$_i = (0, $5e90782b0facda0b$export$2e2bcd8739ae039)(_Object$entries2[_i3], 2), _name = _Object$entries2$_i[0], _value = _Object$entries2$_i[1];
                        merged.configs[_name] = _value;
                    }
                    for(var _i4 = 0, _Object$entries3 = Object.entries((_overrides$layers = overrides.layers) !== null && _overrides$layers !== void 0 ? _overrides$layers : {}); _i4 < _Object$entries3.length; _i4++){
                        var _overrides$layers;
                        var _Object$entries3$_i = (0, $5e90782b0facda0b$export$2e2bcd8739ae039)(_Object$entries3[_i4], 2), _name2 = _Object$entries3$_i[0], _value2 = _Object$entries3$_i[1];
                        merged.layers[_name2] = _value2;
                    }
                }
                return merged;
            }
        },
        {
            key: "initFromStoredOverrides",
            value: function initFromStoredOverrides() {
                var storedOverrides = this.mergeOverrides(this._overrides, this.parseStoredOverrides($6da336d0c6496190$var$LEGACY_LOCAL_STORAGE_KEY), this.parseStoredOverrides(this._localStorageKey));
                // Clear data from legacy local storage key now we've read from it.
                // This prevents things being stuck in there that are always read but never written to.
                try {
                    window.localStorage.removeItem($6da336d0c6496190$var$LEGACY_LOCAL_STORAGE_KEY);
                } catch (_unused2) {
                // ignored - window is not defined in non-browser environments, and we don't save things there
                // (things like SSR, etc)
                }
                // In version 4.24.0 we introduced hashes in this override adapter, but had a bug which would cause
                // multiple hashes to continue being created. This code here removes these hashes since we've moved
                // to using a more reliable and easier to maintain map in `_djb2Map`.
                for(var _i5 = 0, _Object$values = Object.values(storedOverrides); _i5 < _Object$values.length; _i5++){
                    var container = _Object$values[_i5];
                    var allKeys = new Set(Object.keys(container));
                    var _iterator = $6da336d0c6496190$var$_createForOfIteratorHelper(allKeys), _step;
                    try {
                        for(_iterator.s(); !(_step = _iterator.n()).done;){
                            var name = _step.value;
                            var hash = (0, $dtn6l._DJB2)(name);
                            if (allKeys.has(hash)) delete container[hash];
                        }
                    } catch (err) {
                        _iterator.e(err);
                    } finally{
                        _iterator.f();
                    }
                }
                this.applyOverrides(storedOverrides);
            }
        },
        {
            key: "saveOverrides",
            value: function saveOverrides() {
                try {
                    window.localStorage.setItem(this._localStorageKey, JSON.stringify(this._overrides));
                } catch (_unused3) {
                // ignored - window is not defined in non-browser environments, and we don't save things there
                // (things like SSR, etc)
                }
            }
        },
        {
            key: "getOverrides",
            value: function getOverrides() {
                return this.mergeOverrides(this._overrides);
            }
        },
        {
            key: "applyOverrides",
            value: function applyOverrides(overrides) {
                var newOverrides = $6da336d0c6496190$var$_objectSpread($6da336d0c6496190$var$_objectSpread({}, $6da336d0c6496190$var$makeEmptyStore()), overrides);
                this._djb2Map.clear();
                for(var _i6 = 0, _Object$entries4 = Object.entries(newOverrides); _i6 < _Object$entries4.length; _i6++){
                    var _Object$entries4$_i = (0, $5e90782b0facda0b$export$2e2bcd8739ae039)(_Object$entries4[_i6], 2), containerName = _Object$entries4$_i[0], container = _Object$entries4$_i[1];
                    for(var _i7 = 0, _Object$entries5 = Object.entries(container); _i7 < _Object$entries5.length; _i7++){
                        var _Object$entries5$_i = (0, $5e90782b0facda0b$export$2e2bcd8739ae039)(_Object$entries5[_i7], 2), name = _Object$entries5$_i[0], value = _Object$entries5$_i[1];
                        this._djb2Map.set($6da336d0c6496190$var$djb2MapKey((0, $dtn6l._DJB2)(name), containerName), value);
                    }
                }
                this._overrides = newOverrides;
            }
        },
        {
            key: "setOverrides",
            value: function setOverrides(overrides) {
                this.applyOverrides(overrides);
                this.saveOverrides();
            }
        },
        {
            key: "overrideGate",
            value: function overrideGate(name, value) {
                this._overrides.gates[name] = value;
                this._djb2Map.set($6da336d0c6496190$var$djb2MapKey((0, $dtn6l._DJB2)(name), 'gates'), value);
                this.saveOverrides();
            }
        },
        {
            key: "removeGateOverride",
            value: function removeGateOverride(name) {
                delete this._overrides.gates[name];
                this._djb2Map.delete($6da336d0c6496190$var$djb2MapKey((0, $dtn6l._DJB2)(name), 'gates'));
                this.saveOverrides();
            }
        },
        {
            key: "getGateOverride",
            value: function getGateOverride(current, _user) {
                var _this$_overrides$gate;
                var overridden = (_this$_overrides$gate = this._overrides.gates[current.name]) !== null && _this$_overrides$gate !== void 0 ? _this$_overrides$gate : this._djb2Map.get($6da336d0c6496190$var$djb2MapKey(current.name, 'gates'));
                if (overridden == null) return null;
                return $6da336d0c6496190$var$_objectSpread($6da336d0c6496190$var$_objectSpread({}, current), {}, {
                    value: overridden,
                    details: $6da336d0c6496190$var$_objectSpread($6da336d0c6496190$var$_objectSpread({}, current.details), {}, {
                        reason: $6da336d0c6496190$var$LOCAL_OVERRIDE_REASON
                    })
                });
            }
        },
        {
            key: "overrideDynamicConfig",
            value: function overrideDynamicConfig(name, value) {
                this._overrides.configs[name] = value;
                this._djb2Map.set($6da336d0c6496190$var$djb2MapKey((0, $dtn6l._DJB2)(name), 'configs'), value);
                this.saveOverrides();
            }
        },
        {
            key: "removeDynamicConfigOverride",
            value: function removeDynamicConfigOverride(name) {
                delete this._overrides.configs[name];
                this._djb2Map.delete($6da336d0c6496190$var$djb2MapKey((0, $dtn6l._DJB2)(name), 'configs'));
                this.saveOverrides();
            }
        },
        {
            key: "getDynamicConfigOverride",
            value: function getDynamicConfigOverride(current, _user) {
                return this._getConfigOverride(current, this._overrides.configs);
            }
        },
        {
            key: "overrideExperiment",
            value: function overrideExperiment(name, value) {
                this._overrides.configs[name] = value;
                this._djb2Map.set($6da336d0c6496190$var$djb2MapKey((0, $dtn6l._DJB2)(name), 'configs'), value);
                this.saveOverrides();
            }
        },
        {
            key: "removeExperimentOverride",
            value: function removeExperimentOverride(name) {
                delete this._overrides.configs[name];
                this._djb2Map.delete($6da336d0c6496190$var$djb2MapKey((0, $dtn6l._DJB2)(name), 'configs'));
                this.saveOverrides();
            }
        },
        {
            key: "getExperimentOverride",
            value: function getExperimentOverride(current, _user) {
                return this._getConfigOverride(current, this._overrides.configs);
            }
        },
        {
            key: "overrideLayer",
            value: function overrideLayer(name, value) {
                this._overrides.layers[name] = value;
                this._djb2Map.set($6da336d0c6496190$var$djb2MapKey((0, $dtn6l._DJB2)(name), 'layers'), value);
                this.saveOverrides();
            }
        },
        {
            key: "removeLayerOverride",
            value: function removeLayerOverride(name) {
                delete this._overrides.layers[name];
                this._djb2Map.delete($6da336d0c6496190$var$djb2MapKey((0, $dtn6l._DJB2)(name), 'layers'));
                this.saveOverrides();
            }
        },
        {
            key: "removeAllOverrides",
            value: function removeAllOverrides() {
                this._overrides = $6da336d0c6496190$var$makeEmptyStore();
                try {
                    window.localStorage.removeItem(this._localStorageKey);
                } catch (_unused4) {
                // ignored - window is not defined in non-browser environments, and we don't save things there
                // (things like SSR, etc)
                }
            }
        },
        {
            key: "getLayerOverride",
            value: function getLayerOverride(current, _user) {
                var _this$_overrides$laye;
                var overridden = (_this$_overrides$laye = this._overrides.layers[current.name]) !== null && _this$_overrides$laye !== void 0 ? _this$_overrides$laye : this._djb2Map.get($6da336d0c6496190$var$djb2MapKey(current.name, 'layers'));
                if (overridden == null) return null;
                return $6da336d0c6496190$var$_objectSpread($6da336d0c6496190$var$_objectSpread({}, current), {}, {
                    __value: overridden,
                    get: (0, $dtn6l._makeTypedGet)(current.name, overridden),
                    details: $6da336d0c6496190$var$_objectSpread($6da336d0c6496190$var$_objectSpread({}, current.details), {}, {
                        reason: $6da336d0c6496190$var$LOCAL_OVERRIDE_REASON
                    })
                });
            }
        },
        {
            key: "_getConfigOverride",
            value: function _getConfigOverride(current, lookup) {
                var _lookup$current$name;
                var overridden = (_lookup$current$name = lookup[current.name]) !== null && _lookup$current$name !== void 0 ? _lookup$current$name : this._djb2Map.get($6da336d0c6496190$var$djb2MapKey(current.name, 'configs'));
                if (overridden == null) return null;
                return $6da336d0c6496190$var$_objectSpread($6da336d0c6496190$var$_objectSpread({}, current), {}, {
                    value: overridden,
                    get: (0, $dtn6l._makeTypedGet)(current.name, overridden),
                    details: $6da336d0c6496190$var$_objectSpread($6da336d0c6496190$var$_objectSpread({}, current.details), {}, {
                        reason: $6da336d0c6496190$var$LOCAL_OVERRIDE_REASON
                    })
                });
            }
        }
    ]);
}();





var $89a87ba076562c21$var$_excluded = [
    "sdkKey",
    "environment",
    "updateUserCompletionCallback",
    "perimeter"
];
function $89a87ba076562c21$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $89a87ba076562c21$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $89a87ba076562c21$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $36e8c6a8ae2e8480$export$2e2bcd8739ae039)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $89a87ba076562c21$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $89a87ba076562c21$var$DEFAULT_CLIENT_KEY = 'client-default-key';
// default event logging api is Atlassian proxy rather than Statsig's domain, to avoid ad blockers
var $89a87ba076562c21$var$DEFAULT_EVENT_LOGGING_API = 'https://xp.atlassian.com/v1/rgstr';
var $89a87ba076562c21$export$1f2bb630327ac4b6 = /*#__PURE__*/ function() {
    function Client() {
        var _this = this;
        var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, _ref$localStorageKey = _ref.localStorageKey, localStorageKey = _ref$localStorageKey === void 0 ? (0, $6da336d0c6496190$export$d8474cff104280f3) : _ref$localStorageKey, overrideAdapter = _ref.overrideAdapter;
        (0, $b415120f8e0f227f$export$2e2bcd8739ae039)(this, Client);
        (0, $36e8c6a8ae2e8480$export$2e2bcd8739ae039)(this, "initPromise", null);
        /** True if an initialize method was called and completed successfully. */ (0, $36e8c6a8ae2e8480$export$2e2bcd8739ae039)(this, "initCompleted", false);
        /**
     * True if an initialize method was called and completed, meaning the client is now usable.
     * However if there was an error during initialization it may have initialized with default
     * values. Use {@link initCompleted} to check for this.
     */ (0, $36e8c6a8ae2e8480$export$2e2bcd8739ae039)(this, "initWithDefaults", false);
        (0, $36e8c6a8ae2e8480$export$2e2bcd8739ae039)(this, "hasCheckGateErrorOccurred", false);
        (0, $36e8c6a8ae2e8480$export$2e2bcd8739ae039)(this, "hasGetExperimentErrorOccurred", false);
        (0, $36e8c6a8ae2e8480$export$2e2bcd8739ae039)(this, "hasGetExperimentValueErrorOccurred", false);
        (0, $36e8c6a8ae2e8480$export$2e2bcd8739ae039)(this, "hasGetLayerErrorOccurred", false);
        (0, $36e8c6a8ae2e8480$export$2e2bcd8739ae039)(this, "hasGetLayerValueErrorOccurred", false);
        (0, $36e8c6a8ae2e8480$export$2e2bcd8739ae039)(this, "subscriptions", new (0, $d26325b71343c3d7$export$2e2bcd8739ae039)());
        (0, $36e8c6a8ae2e8480$export$2e2bcd8739ae039)(this, "dataAdapter", new (0, $b24077ba3afb3dce$export$55fffef3474104af)());
        /**
     * Call this if modifying the values being served by the Statsig library since it has its own
     * memoization cache which will not be updated if the values are changed outside of the library.
     */ (0, $36e8c6a8ae2e8480$export$2e2bcd8739ae039)(this, "statsigValuesUpdated", function() {
            if (_this.user) // Trigger a reset of the memoize cache
            _this.statsigClient.updateUserSync(_this.user, {
                disableBackgroundCacheRefresh: true
            });
            _this.subscriptions.anyUpdated();
        });
        this.overrideAdapter = overrideAdapter || new (0, $6da336d0c6496190$export$bcb28fbac1def494)(localStorageKey);
    }
    /**
   * @description
   * This method initializes the client using a network call to fetch the bootstrap values.
   * If the client is inialized with an `analyticsWebClient`, it will send an operational event
   * to GASv3 with the following attributes:
   * - targetApp: the target app of the client
   * - clientVersion: the version of the client
   * - success: whether the initialization was successful
   * - startTime: the time when the initialization started
   * - totalTime: the total time it took to initialize the client
   * - apiKey: the api key used to initialize the client
   * @param clientOptions {ClientOptions}
   * @param identifiers {Identifiers}
   * @param customAttributes {CustomAttributes}
   * @returns {Promise<void>}
   */ return (0, $8be4ca258be1ae94$export$2e2bcd8739ae039)(Client, [
        {
            key: "initialize",
            value: function() {
                var _initialize = (0, $a6260dcf494016d1$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($249ba1682cdbc1d3$exports))).mark(function _callee(clientOptions, identifiers, customAttributes) {
                    var _this2 = this;
                    var clientOptionsWithDefaults, startTime;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($249ba1682cdbc1d3$exports))).wrap(function(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                clientOptionsWithDefaults = (0, $d925d48c155338e5$export$d119b37e5f788b43)(clientOptions);
                                if (!this.initPromise) {
                                    _context.next = 1;
                                    break;
                                }
                                if (!(0, $d925d48c155338e5$export$fa1c2bbf4100b8bc)(clientOptionsWithDefaults, this.initOptions)) // eslint-disable-next-line no-console
                                console.warn('Feature Gates client already initialized with different options. New options were not applied.');
                                return _context.abrupt("return", this.initPromise);
                            case 1:
                                startTime = performance.now();
                                this.initOptions = clientOptionsWithDefaults;
                                this.initPromise = this.init(clientOptionsWithDefaults, identifiers, customAttributes).then(function() {
                                    _this2.initCompleted = true;
                                    _this2.initWithDefaults = true;
                                }).finally(function() {
                                    var endTime = performance.now();
                                    var totalTime = endTime - startTime;
                                    _this2.fireClientEvent(startTime, totalTime, 'initialize', _this2.initCompleted, clientOptionsWithDefaults.apiKey);
                                });
                                return _context.abrupt("return", this.initPromise);
                            case 2:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee, this);
                }));
                function initialize(_x, _x2, _x3) {
                    return _initialize.apply(this, arguments);
                }
                return initialize;
            }()
        },
        {
            key: "initializeWithProvider",
            value: function() {
                var _initializeWithProvider = (0, $a6260dcf494016d1$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($249ba1682cdbc1d3$exports))).mark(function _callee2(clientOptions, provider, identifiers, customAttributes) {
                    var _this3 = this;
                    var clientOptionsWithDefaults, startTime;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($249ba1682cdbc1d3$exports))).wrap(function(_context2) {
                        while(true)switch(_context2.prev = _context2.next){
                            case 0:
                                clientOptionsWithDefaults = (0, $d925d48c155338e5$export$d119b37e5f788b43)(clientOptions);
                                if (!this.initPromise) {
                                    _context2.next = 1;
                                    break;
                                }
                                if (!(0, $d925d48c155338e5$export$fa1c2bbf4100b8bc)(clientOptionsWithDefaults, this.initOptions)) // eslint-disable-next-line no-console
                                console.warn('Feature Gates client already initialized with different options. New options were not applied.');
                                return _context2.abrupt("return", this.initPromise);
                            case 1:
                                startTime = performance.now();
                                this.initOptions = clientOptionsWithDefaults;
                                this.provider = provider;
                                this.provider.setClientVersion((0, $486412f8149dc8bc$export$a59f8d67326bd1cb));
                                if (this.provider.setApplyUpdateCallback) this.provider.setApplyUpdateCallback(this.applyUpdateCallback.bind(this));
                                this.initPromise = this.initWithProvider(clientOptionsWithDefaults, provider, identifiers, customAttributes).then(function() {
                                    _this3.initCompleted = true;
                                    _this3.initWithDefaults = true;
                                }).finally(function() {
                                    var endTime = performance.now();
                                    var totalTime = endTime - startTime;
                                    _this3.fireClientEvent(startTime, totalTime, 'initializeWithProvider', _this3.initCompleted, provider.getApiKey ? provider.getApiKey() : undefined);
                                });
                                return _context2.abrupt("return", this.initPromise);
                            case 2:
                            case "end":
                                return _context2.stop();
                        }
                    }, _callee2, this);
                }));
                function initializeWithProvider(_x4, _x5, _x6, _x7) {
                    return _initializeWithProvider.apply(this, arguments);
                }
                return initializeWithProvider;
            }()
        },
        {
            key: "applyUpdateCallback",
            value: function applyUpdateCallback(experimentsResult) {
                try {
                    if (this.initCompleted || this.initWithDefaults) {
                        this.assertInitialized(this.statsigClient);
                        this.dataAdapter.setBootstrapData(experimentsResult.experimentValues);
                        this.dataAdapter.setData(JSON.stringify(experimentsResult.experimentValues));
                        this.statsigValuesUpdated();
                    }
                } catch (error) {
                    // eslint-disable-next-line no-console
                    console.warn('Error when attempting to apply update', error);
                }
            }
        },
        {
            key: "fireClientEvent",
            value: function fireClientEvent(startTime, totalTime, action, success) {
                var _analyticsWebClient, _this4 = this;
                var apiKey = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;
                (_analyticsWebClient = this.initOptions.analyticsWebClient) === null || _analyticsWebClient === void 0 || _analyticsWebClient.then(function(analyticsWebClient) {
                    var attributes = $89a87ba076562c21$var$_objectSpread({
                        targetApp: _this4.initOptions.targetApp,
                        clientVersion: (0, $486412f8149dc8bc$export$a59f8d67326bd1cb),
                        success: success,
                        startTime: startTime,
                        totalTime: totalTime
                    }, apiKey && {
                        apiKey: apiKey
                    });
                    analyticsWebClient.sendOperationalEvent({
                        action: action,
                        actionSubject: 'featureGatesClient',
                        attributes: attributes,
                        tags: [
                            'measurement'
                        ],
                        source: '@atlaskit/feature-gate-js-client'
                    });
                }).catch(function(err) {
                    if (_this4.initOptions.environment !== (0, $516b4b3ae2a8b767$export$479e7351a733299).Production) // eslint-disable-next-line no-console
                    console.error('Analytics web client promise did not resolve', err);
                });
            }
        },
        {
            key: "initializeFromValues",
            value: function() {
                var _initializeFromValues = (0, $a6260dcf494016d1$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($249ba1682cdbc1d3$exports))).mark(function _callee3(clientOptions, identifiers, customAttributes) {
                    var _this5 = this;
                    var initializeValues, clientOptionsWithDefaults, startTime, _args3 = arguments;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($249ba1682cdbc1d3$exports))).wrap(function(_context3) {
                        while(true)switch(_context3.prev = _context3.next){
                            case 0:
                                initializeValues = _args3.length > 3 && _args3[3] !== undefined ? _args3[3] : {};
                                clientOptionsWithDefaults = (0, $d925d48c155338e5$export$d119b37e5f788b43)(clientOptions);
                                if (!this.initPromise) {
                                    _context3.next = 1;
                                    break;
                                }
                                if (!(0, $d925d48c155338e5$export$fa1c2bbf4100b8bc)(clientOptionsWithDefaults, this.initOptions)) // eslint-disable-next-line no-console
                                console.warn('Feature Gates client already initialized with different options. New options were not applied.');
                                return _context3.abrupt("return", this.initPromise);
                            case 1:
                                // This makes sure the new Statsig client behaves like the old when bootstrap data is
                                // passed, and `has_updates` isn't specified (which happens a lot in product integration tests).
                                if (!Object.prototype.hasOwnProperty.call(initializeValues, 'has_updates')) initializeValues['has_updates'] = true;
                                startTime = performance.now();
                                this.initOptions = clientOptionsWithDefaults;
                                this.initPromise = this.initFromValues(clientOptionsWithDefaults, identifiers, customAttributes, initializeValues).then(function() {
                                    _this5.initCompleted = true;
                                    _this5.initWithDefaults = true;
                                }).finally(function() {
                                    var endTime = performance.now();
                                    var totalTime = endTime - startTime;
                                    _this5.fireClientEvent(startTime, totalTime, 'initializeFromValues', _this5.initCompleted);
                                });
                                return _context3.abrupt("return", this.initPromise);
                            case 2:
                            case "end":
                                return _context3.stop();
                        }
                    }, _callee3, this);
                }));
                function initializeFromValues(_x8, _x9, _x0) {
                    return _initializeFromValues.apply(this, arguments);
                }
                return initializeFromValues;
            }()
        },
        {
            key: "assertInitialized",
            value: function assertInitialized(statsigClient) {
                if (!statsigClient) throw new Error('Client must be initialized before using this method');
            }
        },
        {
            key: "updateUser",
            value: function() {
                var _updateUser = (0, $a6260dcf494016d1$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($249ba1682cdbc1d3$exports))).mark(function _callee4(fetchOptions, identifiers, customAttributes) {
                    var fetchOptionsWithDefaults, initializeValuesProducer;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($249ba1682cdbc1d3$exports))).wrap(function(_context4) {
                        while(true)switch(_context4.prev = _context4.next){
                            case 0:
                                this.assertInitialized(this.statsigClient);
                                fetchOptionsWithDefaults = (0, $d925d48c155338e5$export$d119b37e5f788b43)(fetchOptions);
                                initializeValuesProducer = function initializeValuesProducer() {
                                    return (0, $0f34ebd4941c4ffb$export$2e2bcd8739ae039).fetchExperimentValues(fetchOptionsWithDefaults, identifiers, customAttributes).then(function(_ref2) {
                                        var experimentValues = _ref2.experimentValues, customAttributes = _ref2.customAttributes;
                                        return {
                                            experimentValues: experimentValues,
                                            customAttributesFromFetch: customAttributes
                                        };
                                    });
                                };
                                _context4.next = 1;
                                return this.updateUserUsingInitializeValuesProducer(initializeValuesProducer, identifiers, customAttributes);
                            case 1:
                            case "end":
                                return _context4.stop();
                        }
                    }, _callee4, this);
                }));
                function updateUser(_x1, _x10, _x11) {
                    return _updateUser.apply(this, arguments);
                }
                return updateUser;
            }()
        },
        {
            key: "updateUserWithProvider",
            value: function() {
                var _updateUserWithProvider = (0, $a6260dcf494016d1$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($249ba1682cdbc1d3$exports))).mark(function _callee5(identifiers, customAttributes) {
                    var _this6 = this;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($249ba1682cdbc1d3$exports))).wrap(function(_context5) {
                        while(true)switch(_context5.prev = _context5.next){
                            case 0:
                                this.assertInitialized(this.statsigClient);
                                if (this.provider) {
                                    _context5.next = 1;
                                    break;
                                }
                                throw new Error('Cannot update user using provider as the client was not initialised with a provider');
                            case 1:
                                _context5.next = 2;
                                return this.provider.setProfile(this.initOptions, identifiers, customAttributes);
                            case 2:
                                _context5.next = 3;
                                return this.updateUserUsingInitializeValuesProducer(function() {
                                    return _this6.provider.getExperimentValues();
                                }, identifiers, customAttributes);
                            case 3:
                            case "end":
                                return _context5.stop();
                        }
                    }, _callee5, this);
                }));
                function updateUserWithProvider(_x12, _x13) {
                    return _updateUserWithProvider.apply(this, arguments);
                }
                return updateUserWithProvider;
            }()
        },
        {
            key: "updateUserWithValues",
            value: function() {
                var _updateUserWithValues = (0, $a6260dcf494016d1$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($249ba1682cdbc1d3$exports))).mark(function _callee6(identifiers, customAttributes) {
                    var initializeValues, initializeValuesProducer, _args6 = arguments;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($249ba1682cdbc1d3$exports))).wrap(function(_context6) {
                        while(true)switch(_context6.prev = _context6.next){
                            case 0:
                                initializeValues = _args6.length > 2 && _args6[2] !== undefined ? _args6[2] : {};
                                this.assertInitialized(this.statsigClient);
                                initializeValuesProducer = function initializeValuesProducer() {
                                    return Promise.resolve({
                                        experimentValues: initializeValues,
                                        customAttributesFromFetch: customAttributes
                                    });
                                };
                                _context6.next = 1;
                                return this.updateUserUsingInitializeValuesProducer(initializeValuesProducer, identifiers, customAttributes);
                            case 1:
                            case "end":
                                return _context6.stop();
                        }
                    }, _callee6, this);
                }));
                function updateUserWithValues(_x14, _x15) {
                    return _updateUserWithValues.apply(this, arguments);
                }
                return updateUserWithValues;
            }()
        },
        {
            key: "initializeCalled",
            value: function initializeCalled() {
                return this.initPromise != null;
            }
        },
        {
            key: "initializeCompleted",
            value: function initializeCompleted() {
                return this.initCompleted;
            }
        },
        {
            key: "waitUntilInitializeCompleted",
            value: function() {
                var _waitUntilInitializeCompleted = (0, $a6260dcf494016d1$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($249ba1682cdbc1d3$exports))).mark(function _callee7() {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($249ba1682cdbc1d3$exports))).wrap(function(_context7) {
                        while(true)switch(_context7.prev = _context7.next){
                            case 0:
                                if (this.initPromise) {
                                    _context7.next = 1;
                                    break;
                                }
                                throw new Error('The client must be initialized before you can wait until initialized.');
                            case 1:
                                if (!this.initCompleted) {
                                    _context7.next = 2;
                                    break;
                                }
                                return _context7.abrupt("return");
                            case 2:
                                _context7.next = 3;
                                return this.initPromise;
                            case 3:
                            case "end":
                                return _context7.stop();
                        }
                    }, _callee7, this);
                }));
                function waitUntilInitializeCompleted() {
                    return _waitUntilInitializeCompleted.apply(this, arguments);
                }
                return waitUntilInitializeCompleted;
            }()
        },
        {
            key: "checkGate",
            value: function checkGate(gateName) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                try {
                    this.assertInitialized(this.statsigClient);
                    var _options$fireGateExpo = options.fireGateExposure, fireGateExposure = _options$fireGateExpo === void 0 ? true : _options$fireGateExpo;
                    return this.statsigClient.checkGate(gateName, {
                        disableExposureLog: !fireGateExposure
                    });
                } catch (error) {
                    // Log the first occurrence of the error
                    if (!this.hasCheckGateErrorOccurred) {
                        // eslint-disable-next-line no-console
                        console.warn({
                            msg: 'An error has occurred checking the feature gate. Only the first occurrence of this error is logged.',
                            gateName: gateName,
                            error: error
                        });
                        this.hasCheckGateErrorOccurred = true;
                    }
                    return false;
                }
            }
        },
        {
            key: "isGateExist",
            value: function isGateExist(gateName) {
                try {
                    this.assertInitialized(this.statsigClient);
                    var gate = this.statsigClient.getFeatureGate(gateName, {
                        disableExposureLog: true
                    });
                    return !gate.details.reason.includes('Unrecognized');
                } catch (error) {
                    // eslint-disable-next-line no-console
                    console.error("Error occurred when trying to check FeatureGate: ".concat(error));
                    // in case of error report true to avoid false positives.
                    return true;
                }
            }
        },
        {
            key: "isExperimentExist",
            value: function isExperimentExist(experimentName) {
                try {
                    this.assertInitialized(this.statsigClient);
                    var config = this.statsigClient.getExperiment(experimentName, {
                        disableExposureLog: true
                    });
                    return !config.details.reason.includes('Unrecognized');
                } catch (error) {
                    // eslint-disable-next-line no-console
                    console.error("Error occurred when trying to check Experiment: ".concat(error));
                    // in case of error report true to avoid false positives.
                    return true;
                }
            }
        },
        {
            key: "manuallyLogGateExposure",
            value: function manuallyLogGateExposure(gateName) {
                this.assertInitialized(this.statsigClient);
                // This is the approach recommended in the docs
                // https://docs.statsig.com/client/javascript-sdk/#manual-exposures-
                this.statsigClient.checkGate(gateName);
            }
        },
        {
            key: "getExperiment",
            value: function getExperiment(experimentName) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                try {
                    this.assertInitialized(this.statsigClient);
                    var _options$fireExperime = options.fireExperimentExposure, fireExperimentExposure = _options$fireExperime === void 0 ? true : _options$fireExperime;
                    return (0, $e5f5c96a9cfad9f4$export$6dc24881a3d96325).fromExperiment(this.statsigClient.getExperiment(experimentName, {
                        disableExposureLog: !fireExperimentExposure
                    }));
                } catch (error) {
                    // Log the first occurrence of the error
                    if (!this.hasGetExperimentErrorOccurred) {
                        // eslint-disable-next-line no-console
                        console.warn({
                            msg: 'An error has occurred getting the experiment. Only the first occurrence of this error is logged.',
                            experimentName: experimentName,
                            error: error
                        });
                        this.hasGetExperimentErrorOccurred = true;
                    }
                    // Return a default value
                    return new (0, $e5f5c96a9cfad9f4$export$6dc24881a3d96325)(experimentName, {}, '', {
                        time: Date.now(),
                        reason: (0, $bb4ffb7b92792fed$export$c62558b199e46828).Error
                    });
                }
            }
        },
        {
            key: "getExperimentValue",
            value: function getExperimentValue(experimentName, parameterName, defaultValue) {
                var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var experiment = this.getExperiment(experimentName, options);
                try {
                    var typeGuard = options.typeGuard;
                    return experiment.get(parameterName, defaultValue, typeGuard);
                } catch (error) {
                    // Log the first occurrence of the error
                    if (!this.hasGetExperimentValueErrorOccurred) {
                        // eslint-disable-next-line no-console
                        console.warn({
                            msg: 'An error has occurred getting the experiment value. Only the first occurrence of this error is logged.',
                            experimentName: experimentName,
                            defaultValue: defaultValue,
                            options: options,
                            error: error
                        });
                        this.hasGetExperimentValueErrorOccurred = true;
                    }
                    return defaultValue;
                }
            }
        },
        {
            key: "manuallyLogExperimentExposure",
            value: function manuallyLogExperimentExposure(experimentName) {
                this.assertInitialized(this.statsigClient);
                // This is the approach recommended in the docs
                // https://docs.statsig.com/client/javascript-sdk/#manual-exposures-
                this.statsigClient.getExperiment(experimentName);
            }
        },
        {
            key: "manuallyLogLayerExposure",
            value: function manuallyLogLayerExposure(layerName, parameterName) {
                var _this$statsigClient$g;
                this.assertInitialized(this.statsigClient);
                // This is the approach recommended in the docs
                // https://docs.statsig.com/client/javascript-sdk/#manual-exposures-
                (_this$statsigClient$g = this.statsigClient.getLayer(layerName)) === null || _this$statsigClient$g === void 0 || _this$statsigClient$g.get(parameterName);
            }
        },
        {
            key: "shutdownStatsig",
            value: function shutdownStatsig() {
                this.assertInitialized(this.statsigClient);
                this.statsigClient.shutdown();
            }
        },
        {
            key: "overrideGate",
            value: function overrideGate(gateName, value) {
                this.overrideAdapter.overrideGate(gateName, value);
                // Trigger a reset of the memoized gate value
                if (this.user) {
                    var _this$statsigClient;
                    (_this$statsigClient = this.statsigClient) === null || _this$statsigClient === void 0 || _this$statsigClient.updateUserSync(this.user, {
                        disableBackgroundCacheRefresh: true
                    });
                }
                this.statsigValuesUpdated();
            }
        },
        {
            key: "clearGateOverride",
            value: function clearGateOverride(gateName) {
                this.overrideAdapter.removeGateOverride(gateName);
                this.statsigValuesUpdated();
            }
        },
        {
            key: "overrideConfig",
            value: function overrideConfig(experimentName, values) {
                this.overrideAdapter.overrideDynamicConfig(experimentName, values);
                this.statsigValuesUpdated();
            }
        },
        {
            key: "clearConfigOverride",
            value: function clearConfigOverride(experimentName) {
                this.overrideAdapter.removeDynamicConfigOverride(experimentName);
                this.statsigValuesUpdated();
            }
        },
        {
            key: "setOverrides",
            value: function setOverrides(overrides) {
                this.overrideAdapter.setOverrides(overrides);
                this.statsigValuesUpdated();
            }
        },
        {
            key: "getOverrides",
            value: function getOverrides() {
                return this.overrideAdapter.getOverrides();
            }
        },
        {
            key: "clearAllOverrides",
            value: function clearAllOverrides() {
                this.overrideAdapter.removeAllOverrides();
                this.statsigValuesUpdated();
            }
        },
        {
            key: "isCurrentUser",
            value: function isCurrentUser(identifiers, customAttributes) {
                return (0, $d925d48c155338e5$export$fa1c2bbf4100b8bc)(this.currentIdentifiers, identifiers) && (0, $d925d48c155338e5$export$fa1c2bbf4100b8bc)(this.currentAttributes, customAttributes);
            }
        },
        {
            key: "onGateUpdated",
            value: function onGateUpdated(gateName, callback) {
                var _this7 = this;
                var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                var wrapCallback = function wrapCallback(value) {
                    var _options$fireGateExpo2 = options.fireGateExposure, fireGateExposure = _options$fireGateExpo2 === void 0 ? true : _options$fireGateExpo2;
                    if (fireGateExposure) _this7.manuallyLogGateExposure(gateName);
                    try {
                        callback(value);
                    } catch (error) {
                        // eslint-disable-next-line no-console
                        console.warn("Error calling callback for gate ".concat(gateName, " with value ").concat(value), error);
                    }
                };
                return this.subscriptions.onGateUpdated(gateName, wrapCallback, this.checkGate.bind(this), options);
            }
        },
        {
            key: "onExperimentValueUpdated",
            value: function onExperimentValueUpdated(experimentName, parameterName, defaultValue, callback) {
                var _this8 = this;
                var options = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
                var wrapCallback = function wrapCallback(value) {
                    var _options$fireExperime2 = options.fireExperimentExposure, fireExperimentExposure = _options$fireExperime2 === void 0 ? true : _options$fireExperime2;
                    if (fireExperimentExposure) _this8.manuallyLogExperimentExposure(experimentName);
                    try {
                        callback(value);
                    } catch (error) {
                        // eslint-disable-next-line no-console
                        console.warn("Error calling callback for experiment ".concat(experimentName, " with value ").concat(value), error);
                    }
                };
                return this.subscriptions.onExperimentValueUpdated(experimentName, parameterName, defaultValue, wrapCallback, this.getExperimentValue.bind(this), options);
            }
        },
        {
            key: "onAnyUpdated",
            value: function onAnyUpdated(callback) {
                return this.subscriptions.onAnyUpdated(callback);
            }
        },
        {
            key: "init",
            value: function() {
                var _init = (0, $a6260dcf494016d1$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($249ba1682cdbc1d3$exports))).mark(function _callee8(clientOptions, identifiers, customAttributes) {
                    var fromValuesClientOptions, experimentValues, customAttributesFromResult, clientSdkKeyPromise, experimentValuesPromise, _yield$Promise$all, _yield$Promise$all2, experimentValuesResult, _t;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($249ba1682cdbc1d3$exports))).wrap(function(_context8) {
                        while(true)switch(_context8.prev = _context8.next){
                            case 0:
                                fromValuesClientOptions = $89a87ba076562c21$var$_objectSpread({}, clientOptions);
                                if (!clientOptions.localMode) {
                                    _context8.next = 2;
                                    break;
                                }
                                _context8.next = 1;
                                return this.initFromValues(fromValuesClientOptions, identifiers, customAttributes);
                            case 1:
                                return _context8.abrupt("return");
                            case 2:
                                _context8.prev = 2;
                                // If client sdk key fetch fails, an error would be thrown and handled instead of waiting for
                                // the experiment values request to be settled, and it will fall back to use default values.
                                clientSdkKeyPromise = (0, $0f34ebd4941c4ffb$export$2e2bcd8739ae039).fetchClientSdk(clientOptions).then(function(value) {
                                    return fromValuesClientOptions.sdkKey = value.clientSdkKey;
                                });
                                experimentValuesPromise = (0, $0f34ebd4941c4ffb$export$2e2bcd8739ae039).fetchExperimentValues(clientOptions, identifiers, customAttributes); // Only wait for the experiment values request to finish and try to initialise the client
                                // with experiment values if both requests are successful. Else an error would be thrown and
                                // handled by the catch
                                _context8.next = 3;
                                return Promise.all([
                                    clientSdkKeyPromise,
                                    experimentValuesPromise
                                ]);
                            case 3:
                                _yield$Promise$all = _context8.sent;
                                _yield$Promise$all2 = (0, $5e90782b0facda0b$export$2e2bcd8739ae039)(_yield$Promise$all, 2);
                                experimentValuesResult = _yield$Promise$all2[1];
                                experimentValues = experimentValuesResult.experimentValues;
                                customAttributesFromResult = experimentValuesResult.customAttributes;
                                _context8.next = 6;
                                break;
                            case 4:
                                _context8.prev = 4;
                                _t = _context8["catch"](2);
                                if (_t instanceof Error) // eslint-disable-next-line no-console
                                console.error("Error occurred when trying to fetch the Feature Gates client values, error: ".concat(_t === null || _t === void 0 ? void 0 : _t.message));
                                // eslint-disable-next-line no-console
                                console.warn("Initialising Statsig client without values");
                                _context8.next = 5;
                                return this.initFromValues(fromValuesClientOptions, identifiers, customAttributes);
                            case 5:
                                throw _t;
                            case 6:
                                return _context8.abrupt("return", this.initFromValues(fromValuesClientOptions, identifiers, customAttributesFromResult, experimentValues));
                            case 7:
                            case "end":
                                return _context8.stop();
                        }
                    }, _callee8, this, [
                        [
                            2,
                            4
                        ]
                    ]);
                }));
                function init(_x16, _x17, _x18) {
                    return _init.apply(this, arguments);
                }
                return init;
            }()
        },
        {
            key: "initWithProvider",
            value: function() {
                var _initWithProvider = (0, $a6260dcf494016d1$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($249ba1682cdbc1d3$exports))).mark(function _callee9(baseClientOptions, provider, identifiers, customAttributes) {
                    var fromValuesClientOptions, experimentValues, customAttributesFromResult, clientSdkKeyPromise, experimentValuesPromise, _yield$Promise$all3, _yield$Promise$all4, experimentValuesResult, _t2;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($249ba1682cdbc1d3$exports))).wrap(function(_context9) {
                        while(true)switch(_context9.prev = _context9.next){
                            case 0:
                                fromValuesClientOptions = $89a87ba076562c21$var$_objectSpread($89a87ba076562c21$var$_objectSpread({}, baseClientOptions), {}, {
                                    disableCurrentPageLogging: true
                                });
                                _context9.prev = 1;
                                _context9.next = 2;
                                return provider.setProfile(baseClientOptions, identifiers, customAttributes);
                            case 2:
                                // If client sdk key fetch fails, an error would be thrown and handled instead of waiting for
                                // the experiment values request to be settled, and it will fall back to use default values.
                                clientSdkKeyPromise = provider.getClientSdkKey().then(function(value) {
                                    return fromValuesClientOptions.sdkKey = value;
                                });
                                experimentValuesPromise = provider.getExperimentValues(); // Only wait for the experiment values request to finish and try to initialise the client
                                // with experiment values if both requests are successful. Else an error would be thrown and
                                // handled by the catch
                                _context9.next = 3;
                                return Promise.all([
                                    clientSdkKeyPromise,
                                    experimentValuesPromise
                                ]);
                            case 3:
                                _yield$Promise$all3 = _context9.sent;
                                _yield$Promise$all4 = (0, $5e90782b0facda0b$export$2e2bcd8739ae039)(_yield$Promise$all3, 2);
                                experimentValuesResult = _yield$Promise$all4[1];
                                experimentValues = experimentValuesResult.experimentValues;
                                customAttributesFromResult = experimentValuesResult.customAttributesFromFetch;
                                _context9.next = 6;
                                break;
                            case 4:
                                _context9.prev = 4;
                                _t2 = _context9["catch"](1);
                                if (_t2 instanceof Error) // eslint-disable-next-line no-console
                                console.error("Error occurred when trying to fetch the Feature Gates client values, error: ".concat(_t2 === null || _t2 === void 0 ? void 0 : _t2.message));
                                // eslint-disable-next-line no-console
                                console.warn("Initialising Statsig client without values");
                                _context9.next = 5;
                                return this.initFromValues(fromValuesClientOptions, identifiers, customAttributes);
                            case 5:
                                throw _t2;
                            case 6:
                                return _context9.abrupt("return", this.initFromValues(fromValuesClientOptions, identifiers, customAttributesFromResult, experimentValues));
                            case 7:
                            case "end":
                                return _context9.stop();
                        }
                    }, _callee9, this, [
                        [
                            1,
                            4
                        ]
                    ]);
                }));
                function initWithProvider(_x19, _x20, _x21, _x22) {
                    return _initWithProvider.apply(this, arguments);
                }
                return initWithProvider;
            }()
        },
        {
            key: "initFromValues",
            value: function() {
                var _initFromValues = (0, $a6260dcf494016d1$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($249ba1682cdbc1d3$exports))).mark(function _callee0(clientOptions, identifiers, customAttributes) {
                    var _newClientOptions$net;
                    var initializeValues, newClientOptions, sdkKey, environment, _updateUserCompletionCallback, _perimeter, restClientOptions, frontendUser, statsigOptions, _args0 = arguments, _t3;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($249ba1682cdbc1d3$exports))).wrap(function(_context0) {
                        while(true)switch(_context0.prev = _context0.next){
                            case 0:
                                initializeValues = _args0.length > 3 && _args0[3] !== undefined ? _args0[3] : {};
                                this.overrideAdapter.initFromStoredOverrides();
                                this.currentIdentifiers = identifiers;
                                this.currentAttributes = customAttributes;
                                newClientOptions = (0, $d925d48c155338e5$export$202946b690d26d22)(clientOptions);
                                if (!newClientOptions.sdkKey) newClientOptions.sdkKey = $89a87ba076562c21$var$DEFAULT_CLIENT_KEY;
                                if (!((_newClientOptions$net = newClientOptions.networkConfig) !== null && _newClientOptions$net !== void 0 && _newClientOptions$net.logEventUrl)) newClientOptions.networkConfig = $89a87ba076562c21$var$_objectSpread($89a87ba076562c21$var$_objectSpread({}, newClientOptions.networkConfig), {}, {
                                    logEventUrl: $89a87ba076562c21$var$DEFAULT_EVENT_LOGGING_API
                                });
                                if (newClientOptions.perimeter === (0, $516b4b3ae2a8b767$export$c42b7bbc5e7ba555).FEDRAMP_MODERATE) // disable all logging in FedRAMP to prevent egress of sensitive data
                                newClientOptions.disableLogging = true;
                                sdkKey = newClientOptions.sdkKey, environment = newClientOptions.environment, _updateUserCompletionCallback = newClientOptions.updateUserCompletionCallback, _perimeter = newClientOptions.perimeter, restClientOptions = (0, $e1dadfc9c3d2f1bd$export$2e2bcd8739ae039)(newClientOptions, $89a87ba076562c21$var$_excluded);
                                frontendUser = (0, $d925d48c155338e5$export$3dad1db244472f32)(identifiers, customAttributes);
                                this.user = (0, $d925d48c155338e5$export$1148cb79ceecd5fa)({}, initializeValues.user, frontendUser);
                                statsigOptions = $89a87ba076562c21$var$_objectSpread($89a87ba076562c21$var$_objectSpread({}, restClientOptions), {}, {
                                    environment: {
                                        tier: environment
                                    },
                                    includeCurrentPageUrlWithEvents: false,
                                    dataAdapter: this.dataAdapter,
                                    overrideAdapter: this.overrideAdapter,
                                    logEventCompressionMode: (0, $iFR7a.LogEventCompressionMode).Forced
                                }); // Statsig validates the provided stableId against their own cookie, so we either need
                                // to update the cookie to match, or disable the validation completely.
                                if (identifiers.stableId) (0, $iFR7a.StableID).setOverride(identifiers.stableId, sdkKey);
                                else statsigOptions.disableStableID = true;
                                _context0.prev = 1;
                                this.statsigClient = new (0, $iFR7a.StatsigClient)(sdkKey, this.user, statsigOptions);
                                this.dataAdapter.setBootstrapData(initializeValues);
                                _context0.next = 2;
                                return this.statsigClient.initializeAsync();
                            case 2:
                                _context0.next = 5;
                                break;
                            case 3:
                                _context0.prev = 3;
                                _t3 = _context0["catch"](1);
                                if (_t3 instanceof Error) // eslint-disable-next-line no-console
                                console.error("Error occurred when trying to initialise the Statsig client, error: ".concat(_t3 === null || _t3 === void 0 ? void 0 : _t3.message));
                                // eslint-disable-next-line no-console
                                console.warn("Initialising Statsig client with default sdk key and without values");
                                this.statsigClient = new (0, $iFR7a.StatsigClient)($89a87ba076562c21$var$DEFAULT_CLIENT_KEY, this.user, statsigOptions);
                                this.dataAdapter.setBootstrapData();
                                _context0.next = 4;
                                return this.statsigClient.initializeAsync();
                            case 4:
                                this.initWithDefaults = true;
                                throw _t3;
                            case 5:
                            case "end":
                                return _context0.stop();
                        }
                    }, _callee0, this, [
                        [
                            1,
                            3
                        ]
                    ]);
                }));
                function initFromValues(_x23, _x24, _x25) {
                    return _initFromValues.apply(this, arguments);
                }
                return initFromValues;
            }()
        },
        {
            key: "updateUserUsingInitializeValuesProducer",
            value: function() {
                var _updateUserUsingInitializeValuesProducer = (0, $a6260dcf494016d1$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($249ba1682cdbc1d3$exports))).mark(function _callee10(getInitializeValues, identifiers, customAttributes) {
                    var _this9 = this;
                    var originalInitPromise, initializeValuesPromise, updateUserPromise, _t4;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($249ba1682cdbc1d3$exports))).wrap(function(_context10) {
                        while(true)switch(_context10.prev = _context10.next){
                            case 0:
                                this.assertInitialized(this.statsigClient);
                                if (this.initPromise) {
                                    _context10.next = 1;
                                    break;
                                }
                                throw new Error('The client must be initialized before you can update the user.');
                            case 1:
                                if (!this.isCurrentUser(identifiers, customAttributes)) {
                                    _context10.next = 2;
                                    break;
                                }
                                return _context10.abrupt("return", this.initPromise);
                            case 2:
                                // Wait for the current initialize/update to finish
                                originalInitPromise = this.initPromise;
                                _context10.prev = 3;
                                _context10.next = 4;
                                return this.initPromise;
                            case 4:
                                _context10.next = 6;
                                break;
                            case 5:
                                _context10.prev = 5;
                                _t4 = _context10["catch"](3);
                            case 6:
                                initializeValuesPromise = getInitializeValues();
                                updateUserPromise = this.updateStatsigClientUser(initializeValuesPromise, identifiers, customAttributes); // We replace the init promise here since we are essentially re-initializing the client at this
                                // point. Any subsequent calls to await client.initialize() or client.updateUser()
                                // will now also await this user update.
                                this.initPromise = updateUserPromise.catch(/*#__PURE__*/ (0, $a6260dcf494016d1$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($249ba1682cdbc1d3$exports))).mark(function _callee1() {
                                    return (0, (/*@__PURE__*/$parcel$interopDefault($249ba1682cdbc1d3$exports))).wrap(function(_context1) {
                                        while(true)switch(_context1.prev = _context1.next){
                                            case 0:
                                                // If the update failed then it changed nothing, so revert back to the original promise.
                                                _this9.initPromise = originalInitPromise;
                                                // Set the user profile again to revert back to the current user
                                                if (!_this9.provider) {
                                                    _context1.next = 1;
                                                    break;
                                                }
                                                _context1.next = 1;
                                                return _this9.provider.setProfile(_this9.initOptions, _this9.currentIdentifiers, _this9.currentAttributes);
                                            case 1:
                                            case "end":
                                                return _context1.stop();
                                        }
                                    }, _callee1);
                                })));
                                return _context10.abrupt("return", updateUserPromise);
                            case 7:
                            case "end":
                                return _context10.stop();
                        }
                    }, _callee10, this, [
                        [
                            3,
                            5
                        ]
                    ]);
                }));
                function updateUserUsingInitializeValuesProducer(_x26, _x27, _x28) {
                    return _updateUserUsingInitializeValuesProducer.apply(this, arguments);
                }
                return updateUserUsingInitializeValuesProducer;
            }()
        },
        {
            key: "updateStatsigClientUser",
            value: function() {
                var _updateStatsigClientUser = (0, $a6260dcf494016d1$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($249ba1682cdbc1d3$exports))).mark(function _callee11(initializeValuesPromise, identifiers, customAttributes) {
                    var _this$initOptions, _this$initOptions$upd;
                    var initializeValues, user, frontendUser, _updateUserCompletion, _ref4, errMsg, success, errorMessage, _t5, _t6;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($249ba1682cdbc1d3$exports))).wrap(function(_context11) {
                        while(true)switch(_context11.prev = _context11.next){
                            case 0:
                                this.assertInitialized(this.statsigClient);
                                _context11.prev = 1;
                                _context11.next = 2;
                                return initializeValuesPromise;
                            case 2:
                                initializeValues = _context11.sent;
                                frontendUser = (0, $d925d48c155338e5$export$3dad1db244472f32)(identifiers, initializeValues.customAttributesFromFetch);
                                user = (0, $d925d48c155338e5$export$1148cb79ceecd5fa)({}, initializeValues.experimentValues.user, frontendUser);
                                _context11.next = 4;
                                break;
                            case 3:
                                _context11.prev = 3;
                                _t5 = _context11["catch"](1);
                                // Make sure the updateUserCompletionCallback is called for any errors in our custom code.
                                // This is not necessary for the updateUserWithValues call, because the Statsig client will
                                // already invoke the callback itself.
                                errMsg = _t5 instanceof Error ? _t5.message : JSON.stringify(_t5);
                                (_updateUserCompletion = (_ref4 = this.initOptions).updateUserCompletionCallback) === null || _updateUserCompletion === void 0 || _updateUserCompletion.call(_ref4, false, errMsg);
                                throw _t5;
                            case 4:
                                success = true;
                                errorMessage = null;
                                _context11.prev = 5;
                                this.dataAdapter.setBootstrapData(initializeValues.experimentValues);
                                this.user = user;
                                if (!this.user) {
                                    _context11.next = 6;
                                    break;
                                }
                                _context11.next = 6;
                                return this.statsigClient.updateUserAsync(this.user);
                            case 6:
                                _context11.next = 8;
                                break;
                            case 7:
                                _context11.prev = 7;
                                _t6 = _context11["catch"](5);
                                success = false;
                                errorMessage = String(_t6);
                            case 8:
                                (_this$initOptions = this.initOptions) === null || _this$initOptions === void 0 || (_this$initOptions$upd = _this$initOptions.updateUserCompletionCallback) === null || _this$initOptions$upd === void 0 || _this$initOptions$upd.call(_this$initOptions, success, errorMessage);
                                if (!success) {
                                    _context11.next = 9;
                                    break;
                                }
                                this.currentIdentifiers = identifiers;
                                this.currentAttributes = customAttributes;
                                this.subscriptions.anyUpdated();
                                _context11.next = 10;
                                break;
                            case 9:
                                throw new Error('Failed to update user. An unexpected error occured.');
                            case 10:
                            case "end":
                                return _context11.stop();
                        }
                    }, _callee11, this, [
                        [
                            1,
                            3
                        ],
                        [
                            5,
                            7
                        ]
                    ]);
                }));
                function updateStatsigClientUser(_x29, _x30, _x31) {
                    return _updateStatsigClientUser.apply(this, arguments);
                }
                return updateStatsigClientUser;
            }()
        },
        {
            key: "getPackageVersion",
            value: /**
     * @returns string version of the current package in semver style.
     */ function getPackageVersion() {
                return 0, $486412f8149dc8bc$export$a59f8d67326bd1cb;
            }
        },
        {
            key: "getTargetApp",
            value: function getTargetApp() {
                var _this$initOptions2;
                return (_this$initOptions2 = this.initOptions) === null || _this$initOptions2 === void 0 ? void 0 : _this$initOptions2.targetApp;
            }
        },
        {
            key: "getLayer",
            value: function getLayer(/** The name of the layer */ layerName) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                try {
                    this.assertInitialized(this.statsigClient);
                    var _options$fireLayerExp = options.fireLayerExposure, fireLayerExposure = _options$fireLayerExp === void 0 ? true : _options$fireLayerExp;
                    return (0, $cd7bdea79e6bbef8$export$936d0764594b6eb3).fromLayer(this.statsigClient.getLayer(layerName, {
                        disableExposureLog: !fireLayerExposure
                    }));
                } catch (error) {
                    // Log the first occurrence of the error
                    if (!this.hasGetLayerErrorOccurred) {
                        // eslint-disable-next-line no-console
                        console.warn({
                            msg: 'An error has occurred getting the layer. Only the first occurrence of this error is logged.',
                            layerName: layerName,
                            error: error
                        });
                        this.hasGetLayerErrorOccurred = true;
                    }
                    // Return a default value
                    return (0, $cd7bdea79e6bbef8$export$936d0764594b6eb3).fromLayer((0, $iFR7a._makeLayer)(layerName, {
                        reason: 'Error'
                    }, null));
                }
            }
        },
        {
            key: "getLayerValue",
            value: function getLayerValue(layerName, parameterName, defaultValue) {
                var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var layer = this.getLayer(layerName, options);
                try {
                    var typeGuard = options.typeGuard;
                    return layer.get(parameterName, defaultValue, typeGuard);
                } catch (error) {
                    // Log the first occurrence of the error
                    if (!this.hasGetLayerValueErrorOccurred) {
                        // eslint-disable-next-line no-console
                        console.warn({
                            msg: 'An error has occurred getting the layer value. Only the first occurrence of this error is logged.',
                            layerName: layerName,
                            defaultValue: defaultValue,
                            options: options,
                            error: error
                        });
                        this.hasGetLayerValueErrorOccurred = true;
                    }
                    return defaultValue;
                }
            }
        }
    ]);
}();






var $64018b7e2de5e8ce$var$_FeatureGates;
/**
 * Access the FeatureGates object via the default export.
 * ```ts
 * import FeatureGates from '@atlaskit/feature-gate-js-client';
 * ```
 */ var $64018b7e2de5e8ce$var$FeatureGates = /*#__PURE__*/ function() {
    function FeatureGates() {
        (0, $b415120f8e0f227f$export$2e2bcd8739ae039)(this, FeatureGates);
    }
    return (0, $8be4ca258be1ae94$export$2e2bcd8739ae039)(FeatureGates, null, [
        {
            key: "isGateExists",
            value: function isGateExists(gateName) {
                return this.client.isGateExist(gateName);
            }
        },
        {
            key: "isExperimentExists",
            value: function isExperimentExists(experimentName) {
                return this.client.isExperimentExist(experimentName);
            }
        }
    ]);
}();
$64018b7e2de5e8ce$var$_FeatureGates = $64018b7e2de5e8ce$var$FeatureGates;
(0, $36e8c6a8ae2e8480$export$2e2bcd8739ae039)($64018b7e2de5e8ce$var$FeatureGates, "client", new (0, $89a87ba076562c21$export$1f2bb630327ac4b6)());
(0, $36e8c6a8ae2e8480$export$2e2bcd8739ae039)($64018b7e2de5e8ce$var$FeatureGates, "hasCheckGateErrorOccurred", false);
(0, $36e8c6a8ae2e8480$export$2e2bcd8739ae039)($64018b7e2de5e8ce$var$FeatureGates, "hasGetExperimentValueErrorOccurred", false);
(0, $36e8c6a8ae2e8480$export$2e2bcd8739ae039)($64018b7e2de5e8ce$var$FeatureGates, "checkGate", function(gateName, options) {
    try {
        // Check if the CRITERION override mechanism is available
        if (typeof window !== 'undefined' && window.__CRITERION__ && typeof window.__CRITERION__.getFeatureFlagOverride === 'function') {
            // Attempt to retrieve an override value for the feature gate
            var overrideValue = window.__CRITERION__.getFeatureFlagOverride(gateName);
            // If an override value is found, return it immediately
            if (overrideValue !== undefined) return overrideValue;
        }
    } catch (error) {
        // Log the first occurrence of the error
        if (!$64018b7e2de5e8ce$var$_FeatureGates.hasCheckGateErrorOccurred) {
            // eslint-disable-next-line no-console
            console.warn({
                msg: 'An error has occurred checking the feature gate from criterion override. Only the first occurrence of this error is logged.',
                gateName: gateName,
                error: error
            });
            $64018b7e2de5e8ce$var$_FeatureGates.hasCheckGateErrorOccurred = true;
        }
    }
    // Proceed with the main logic if no override is found
    return $64018b7e2de5e8ce$var$_FeatureGates.client.checkGate(gateName, options);
});
(0, $36e8c6a8ae2e8480$export$2e2bcd8739ae039)($64018b7e2de5e8ce$var$FeatureGates, "getExperimentValue", function(experimentName, parameterName, defaultValue, options) {
    try {
        // Check if the CRITERION override mechanism is available
        if (typeof window !== 'undefined' && window.__CRITERION__ && typeof window.__CRITERION__.getExperimentValueOverride === 'function') {
            var overrideValue = window.__CRITERION__.getExperimentValueOverride(experimentName, parameterName);
            if (overrideValue !== undefined && overrideValue !== null) return overrideValue;
        }
    } catch (error) {
        // Log the first occurrence of the error
        if (!$64018b7e2de5e8ce$var$_FeatureGates.hasGetExperimentValueErrorOccurred) {
            // eslint-disable-next-line no-console
            console.warn({
                msg: 'An error has occurred getting the experiment value from criterion override. Only the first occurrence of this error is logged.',
                experimentName: experimentName,
                defaultValue: defaultValue,
                options: options,
                error: error
            });
            $64018b7e2de5e8ce$var$_FeatureGates.hasGetExperimentValueErrorOccurred = true;
        }
        return defaultValue;
    }
    // Proceed with the main logic if no override is found
    return $64018b7e2de5e8ce$var$_FeatureGates.client.getExperimentValue(experimentName, parameterName, defaultValue, options);
});
(0, $36e8c6a8ae2e8480$export$2e2bcd8739ae039)($64018b7e2de5e8ce$var$FeatureGates, "initializeCalled", $64018b7e2de5e8ce$var$_FeatureGates.client.initializeCalled.bind($64018b7e2de5e8ce$var$_FeatureGates.client));
(0, $36e8c6a8ae2e8480$export$2e2bcd8739ae039)($64018b7e2de5e8ce$var$FeatureGates, "initializeCompleted", $64018b7e2de5e8ce$var$_FeatureGates.client.initializeCompleted.bind($64018b7e2de5e8ce$var$_FeatureGates.client));
(0, $36e8c6a8ae2e8480$export$2e2bcd8739ae039)($64018b7e2de5e8ce$var$FeatureGates, "waitUntilInitializeCompleted", $64018b7e2de5e8ce$var$_FeatureGates.client.waitUntilInitializeCompleted.bind($64018b7e2de5e8ce$var$_FeatureGates.client));
(0, $36e8c6a8ae2e8480$export$2e2bcd8739ae039)($64018b7e2de5e8ce$var$FeatureGates, "initialize", $64018b7e2de5e8ce$var$_FeatureGates.client.initialize.bind($64018b7e2de5e8ce$var$_FeatureGates.client));
(0, $36e8c6a8ae2e8480$export$2e2bcd8739ae039)($64018b7e2de5e8ce$var$FeatureGates, "initializeWithProvider", $64018b7e2de5e8ce$var$_FeatureGates.client.initializeWithProvider.bind($64018b7e2de5e8ce$var$_FeatureGates.client));
(0, $36e8c6a8ae2e8480$export$2e2bcd8739ae039)($64018b7e2de5e8ce$var$FeatureGates, "initializeFromValues", $64018b7e2de5e8ce$var$_FeatureGates.client.initializeFromValues.bind($64018b7e2de5e8ce$var$_FeatureGates.client));
(0, $36e8c6a8ae2e8480$export$2e2bcd8739ae039)($64018b7e2de5e8ce$var$FeatureGates, "manuallyLogGateExposure", $64018b7e2de5e8ce$var$_FeatureGates.client.manuallyLogGateExposure.bind($64018b7e2de5e8ce$var$_FeatureGates.client));
(0, $36e8c6a8ae2e8480$export$2e2bcd8739ae039)($64018b7e2de5e8ce$var$FeatureGates, "getExperiment", $64018b7e2de5e8ce$var$_FeatureGates.client.getExperiment.bind($64018b7e2de5e8ce$var$_FeatureGates.client));
(0, $36e8c6a8ae2e8480$export$2e2bcd8739ae039)($64018b7e2de5e8ce$var$FeatureGates, "manuallyLogExperimentExposure", $64018b7e2de5e8ce$var$_FeatureGates.client.manuallyLogExperimentExposure.bind($64018b7e2de5e8ce$var$_FeatureGates.client));
(0, $36e8c6a8ae2e8480$export$2e2bcd8739ae039)($64018b7e2de5e8ce$var$FeatureGates, "manuallyLogLayerExposure", $64018b7e2de5e8ce$var$_FeatureGates.client.manuallyLogLayerExposure.bind($64018b7e2de5e8ce$var$_FeatureGates.client));
(0, $36e8c6a8ae2e8480$export$2e2bcd8739ae039)($64018b7e2de5e8ce$var$FeatureGates, "shutdownStatsig", $64018b7e2de5e8ce$var$_FeatureGates.client.shutdownStatsig.bind($64018b7e2de5e8ce$var$_FeatureGates.client));
(0, $36e8c6a8ae2e8480$export$2e2bcd8739ae039)($64018b7e2de5e8ce$var$FeatureGates, "overrideGate", $64018b7e2de5e8ce$var$_FeatureGates.client.overrideGate.bind($64018b7e2de5e8ce$var$_FeatureGates.client));
(0, $36e8c6a8ae2e8480$export$2e2bcd8739ae039)($64018b7e2de5e8ce$var$FeatureGates, "clearGateOverride", $64018b7e2de5e8ce$var$_FeatureGates.client.clearGateOverride.bind($64018b7e2de5e8ce$var$_FeatureGates.client));
(0, $36e8c6a8ae2e8480$export$2e2bcd8739ae039)($64018b7e2de5e8ce$var$FeatureGates, "overrideConfig", $64018b7e2de5e8ce$var$_FeatureGates.client.overrideConfig.bind($64018b7e2de5e8ce$var$_FeatureGates.client));
(0, $36e8c6a8ae2e8480$export$2e2bcd8739ae039)($64018b7e2de5e8ce$var$FeatureGates, "clearConfigOverride", $64018b7e2de5e8ce$var$_FeatureGates.client.clearConfigOverride.bind($64018b7e2de5e8ce$var$_FeatureGates.client));
(0, $36e8c6a8ae2e8480$export$2e2bcd8739ae039)($64018b7e2de5e8ce$var$FeatureGates, "setOverrides", $64018b7e2de5e8ce$var$_FeatureGates.client.setOverrides.bind($64018b7e2de5e8ce$var$_FeatureGates.client));
(0, $36e8c6a8ae2e8480$export$2e2bcd8739ae039)($64018b7e2de5e8ce$var$FeatureGates, "getOverrides", $64018b7e2de5e8ce$var$_FeatureGates.client.getOverrides.bind($64018b7e2de5e8ce$var$_FeatureGates.client));
(0, $36e8c6a8ae2e8480$export$2e2bcd8739ae039)($64018b7e2de5e8ce$var$FeatureGates, "clearAllOverrides", $64018b7e2de5e8ce$var$_FeatureGates.client.clearAllOverrides.bind($64018b7e2de5e8ce$var$_FeatureGates.client));
(0, $36e8c6a8ae2e8480$export$2e2bcd8739ae039)($64018b7e2de5e8ce$var$FeatureGates, "isCurrentUser", $64018b7e2de5e8ce$var$_FeatureGates.client.isCurrentUser.bind($64018b7e2de5e8ce$var$_FeatureGates.client));
(0, $36e8c6a8ae2e8480$export$2e2bcd8739ae039)($64018b7e2de5e8ce$var$FeatureGates, "onGateUpdated", $64018b7e2de5e8ce$var$_FeatureGates.client.onGateUpdated.bind($64018b7e2de5e8ce$var$_FeatureGates.client));
(0, $36e8c6a8ae2e8480$export$2e2bcd8739ae039)($64018b7e2de5e8ce$var$FeatureGates, "onExperimentValueUpdated", $64018b7e2de5e8ce$var$_FeatureGates.client.onExperimentValueUpdated.bind($64018b7e2de5e8ce$var$_FeatureGates.client));
(0, $36e8c6a8ae2e8480$export$2e2bcd8739ae039)($64018b7e2de5e8ce$var$FeatureGates, "onAnyUpdated", $64018b7e2de5e8ce$var$_FeatureGates.client.onAnyUpdated.bind($64018b7e2de5e8ce$var$_FeatureGates.client));
(0, $36e8c6a8ae2e8480$export$2e2bcd8739ae039)($64018b7e2de5e8ce$var$FeatureGates, "updateUser", $64018b7e2de5e8ce$var$_FeatureGates.client.updateUser.bind($64018b7e2de5e8ce$var$_FeatureGates.client));
(0, $36e8c6a8ae2e8480$export$2e2bcd8739ae039)($64018b7e2de5e8ce$var$FeatureGates, "updateUserWithProvider", $64018b7e2de5e8ce$var$_FeatureGates.client.updateUserWithProvider.bind($64018b7e2de5e8ce$var$_FeatureGates.client));
(0, $36e8c6a8ae2e8480$export$2e2bcd8739ae039)($64018b7e2de5e8ce$var$FeatureGates, "updateUserWithValues", $64018b7e2de5e8ce$var$_FeatureGates.client.updateUserWithValues.bind($64018b7e2de5e8ce$var$_FeatureGates.client));
(0, $36e8c6a8ae2e8480$export$2e2bcd8739ae039)($64018b7e2de5e8ce$var$FeatureGates, "getPackageVersion", $64018b7e2de5e8ce$var$_FeatureGates.client.getPackageVersion.bind($64018b7e2de5e8ce$var$_FeatureGates.client));
(0, $36e8c6a8ae2e8480$export$2e2bcd8739ae039)($64018b7e2de5e8ce$var$FeatureGates, "getTargetApp", $64018b7e2de5e8ce$var$_FeatureGates.client.getTargetApp.bind($64018b7e2de5e8ce$var$_FeatureGates.client));
(0, $36e8c6a8ae2e8480$export$2e2bcd8739ae039)($64018b7e2de5e8ce$var$FeatureGates, "getLayer", $64018b7e2de5e8ce$var$_FeatureGates.client.getLayer.bind($64018b7e2de5e8ce$var$_FeatureGates.client));
(0, $36e8c6a8ae2e8480$export$2e2bcd8739ae039)($64018b7e2de5e8ce$var$FeatureGates, "getLayerValue", $64018b7e2de5e8ce$var$_FeatureGates.client.getLayerValue.bind($64018b7e2de5e8ce$var$_FeatureGates.client));
var $64018b7e2de5e8ce$var$boundFGJS = $64018b7e2de5e8ce$var$FeatureGates;
// This makes it possible to get a reference to the FeatureGates client at runtime.
// This is important for overriding values in Cypress tests, as there needs to be a
// way to get the exact instance for a window in order to mock some of its methods.
if (typeof window !== 'undefined') {
    if (window.__FEATUREGATES_JS__ === undefined) window.__FEATUREGATES_JS__ = $64018b7e2de5e8ce$var$FeatureGates;
    else {
        var $64018b7e2de5e8ce$var$_boundFGJS, $64018b7e2de5e8ce$var$_boundFGJS$getPackage;
        $64018b7e2de5e8ce$var$boundFGJS = window.__FEATUREGATES_JS__;
        var $64018b7e2de5e8ce$var$boundVersion = (($64018b7e2de5e8ce$var$_boundFGJS = $64018b7e2de5e8ce$var$boundFGJS) === null || $64018b7e2de5e8ce$var$_boundFGJS === void 0 || ($64018b7e2de5e8ce$var$_boundFGJS$getPackage = $64018b7e2de5e8ce$var$_boundFGJS.getPackageVersion) === null || $64018b7e2de5e8ce$var$_boundFGJS$getPackage === void 0 ? void 0 : $64018b7e2de5e8ce$var$_boundFGJS$getPackage.call($64018b7e2de5e8ce$var$_boundFGJS)) || '4.10.0 or earlier';
        if ($64018b7e2de5e8ce$var$boundVersion !== (0, $486412f8149dc8bc$export$a59f8d67326bd1cb)) {
            var $64018b7e2de5e8ce$var$message = "Multiple versions of FeatureGateClients found on the current page.\n      The currently bound version is ".concat($64018b7e2de5e8ce$var$boundVersion, " when module version ").concat((0, $486412f8149dc8bc$export$a59f8d67326bd1cb), " was loading.");
            // eslint-disable-next-line no-console
            console.warn($64018b7e2de5e8ce$var$message);
        }
    }
}
var /**
 * @property {FeatureGates} FeatureGate default export
 */ $64018b7e2de5e8ce$export$2e2bcd8739ae039 = $64018b7e2de5e8ce$var$boundFGJS;


var $0451700bcb4c47f9$var$_process, $0451700bcb4c47f9$var$_process2;
// We can't rely on NODE_ENV === 'test' if its value is already configured by the consumer to some other value, so better to use JEST_WORKER_ID
// https://jestjs.io/docs/environment-variables#jest_worker_id
var $0451700bcb4c47f9$var$TESTS_MODE = (globalThis === null || globalThis === void 0 || ($0451700bcb4c47f9$var$_process = globalThis.process) === null || $0451700bcb4c47f9$var$_process === void 0 || ($0451700bcb4c47f9$var$_process = $0451700bcb4c47f9$var$_process.env) === null || $0451700bcb4c47f9$var$_process === void 0 ? void 0 : $0451700bcb4c47f9$var$_process.JEST_WORKER_ID) !== undefined;
var $0451700bcb4c47f9$var$DEBUG_MODE = !$0451700bcb4c47f9$var$TESTS_MODE && (globalThis === null || globalThis === void 0 || ($0451700bcb4c47f9$var$_process2 = globalThis.process) === null || $0451700bcb4c47f9$var$_process2 === void 0 || ($0451700bcb4c47f9$var$_process2 = $0451700bcb4c47f9$var$_process2.env) === null || $0451700bcb4c47f9$var$_process2 === void 0 ? void 0 : $0451700bcb4c47f9$var$_process2.NODE_ENV) !== 'production';
var $0451700bcb4c47f9$export$1c9f709888824e05 = function debug() {
    var _console;
    if (!$0451700bcb4c47f9$var$DEBUG_MODE) return;
    // eslint-disable-next-line no-console
    (_console = console).debug.apply(_console, arguments);
};



var $3ZMUU = parcelRequire("3ZMUU");
var $6f36a53848257378$export$7e41b1b2bdee3f98 = '__PLATFORM_FEATURE_FLAGS__';
var $6f36a53848257378$export$407f05df8e3ce9f3 = '@atlaskit/platform-feature-flags';
var $6f36a53848257378$export$75f4a1454eff2805 = typeof $3ZMUU !== 'undefined' && typeof $3ZMUU.env !== 'undefined';


var $6759630a3a4920ab$export$b574c24e1e6490f5 = (0, $6f36a53848257378$export$75f4a1454eff2805) ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;



var $c6ffd79ba6b499ec$export$92f8b531feaeb23d = (0, $6f36a53848257378$export$75f4a1454eff2805) ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;



var $24ed348a6393ea4b$var$DEFAULT_PFF_GLOBAL = {
    booleanResolver: undefined
};
var $24ed348a6393ea4b$export$54ea85357b4e0159 = typeof window !== 'undefined' ? window : globalThis;
$24ed348a6393ea4b$export$54ea85357b4e0159[0, $6f36a53848257378$export$7e41b1b2bdee3f98] = $24ed348a6393ea4b$export$54ea85357b4e0159[0, $6f36a53848257378$export$7e41b1b2bdee3f98] || $24ed348a6393ea4b$var$DEFAULT_PFF_GLOBAL;



var $0bd199ce718b2fb2$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE = (0, $6759630a3a4920ab$export$b574c24e1e6490f5) || (0, $c6ffd79ba6b499ec$export$92f8b531feaeb23d);
function $0bd199ce718b2fb2$export$6333b6aff9fc6275(flagKey) {
    if ($0bd199ce718b2fb2$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE) {
        (0, $0451700bcb4c47f9$export$1c9f709888824e05)('[%s]: The feature flags were enabled while running tests. The flag "%s" will be always enabled.', (0, $6f36a53848257378$export$407f05df8e3ce9f3), flagKey);
        return true;
    }
    try {
        var _globalVar$PFF_GLOBAL, _globalVar$PFF_GLOBAL2, _globalVar$PFF_GLOBAL3;
        // booleanResolver will be empty for products like Trello, Elevate, Recruit etc.
        // Currently only Confluence, Jira and Bitbucket has set it.
        if (((_globalVar$PFF_GLOBAL = (0, $24ed348a6393ea4b$export$54ea85357b4e0159)[0, $6f36a53848257378$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL === void 0 ? void 0 : _globalVar$PFF_GLOBAL.booleanResolver) === undefined || ((_globalVar$PFF_GLOBAL2 = (0, $24ed348a6393ea4b$export$54ea85357b4e0159)[0, $6f36a53848257378$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL2 === void 0 ? void 0 : _globalVar$PFF_GLOBAL2.booleanResolver) === null) // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
        return (0, $64018b7e2de5e8ce$export$2e2bcd8739ae039).checkGate(flagKey);
        var result = (_globalVar$PFF_GLOBAL3 = (0, $24ed348a6393ea4b$export$54ea85357b4e0159)[0, $6f36a53848257378$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL3 === void 0 ? void 0 : _globalVar$PFF_GLOBAL3.booleanResolver(flagKey);
        if (typeof result !== 'boolean') {
            // eslint-disable-next-line no-console
            console.warn("".concat(flagKey, " resolved to a non-boolean value, returning false for safety"));
            return false;
        }
        return result;
    } catch (e) {
        return false;
    }
}


function $b4741ae2f346a6af$export$b40ec24ac8275656(name) {
    return (0, $0bd199ce718b2fb2$export$6333b6aff9fc6275)(name);
}


/* anchor.tsx generated by @compiled/babel-plugin v2.0.0 */ 



var $5FkrB = parcelRequire("5FkrB");


const $adc17885230aed9b$export$a274e22fb40f762e = (...styles)=>{
    // At runtime TStyles is resolved down to strings, but not at compile time.
    // We circumvent the type system here because of that.
    const actualStyles = styles;
    // The output should be a union type of passed in styles. This ensures the call
    // site of xcss prop can raise violations when disallowed styles have been passed.
    return (0, $2efec74f5f421835$export$2e2bcd8739ae039)(actualStyles);
};


var $fff3f31fc3bd4f88$var$isProduction = true;
var $fff3f31fc3bd4f88$var$prefix = 'Invariant failed';
function $fff3f31fc3bd4f88$export$2e2bcd8739ae039(condition, message) {
    if (condition) return;
    if ($fff3f31fc3bd4f88$var$isProduction) throw new Error($fff3f31fc3bd4f88$var$prefix);
    var provided = typeof message === 'function' ? message() : message;
    var value = provided ? "".concat($fff3f31fc3bd4f88$var$prefix, ": ").concat(provided) : $fff3f31fc3bd4f88$var$prefix;
    throw new Error(value);
}




var $5FkrB = parcelRequire("5FkrB");

var $5FkrB = parcelRequire("5FkrB");
function $a060da77483cc5d3$var$areInputsEqual(newInputs, lastInputs) {
    if (newInputs.length !== lastInputs.length) return false;
    for(var i = 0; i < newInputs.length; i++){
        if (newInputs[i] !== lastInputs[i]) return false;
    }
    return true;
}
function $a060da77483cc5d3$export$b6feb8998cd9b342(getResult, inputs) {
    var initial = (0, $5FkrB.useState)(function() {
        return {
            inputs: inputs,
            result: getResult()
        };
    })[0];
    var isFirstRun = (0, $5FkrB.useRef)(true);
    var committed = (0, $5FkrB.useRef)(initial);
    var useCache = isFirstRun.current || Boolean(inputs && committed.current.inputs && $a060da77483cc5d3$var$areInputsEqual(inputs, committed.current.inputs));
    var cache = useCache ? committed.current : {
        inputs: inputs,
        result: getResult()
    };
    (0, $5FkrB.useEffect)(function() {
        isFirstRun.current = false;
        committed.current = cache;
    }, [
        cache
    ]);
    return cache.result;
}
function $a060da77483cc5d3$export$33752cf3ee811995(callback, inputs) {
    return $a060da77483cc5d3$export$b6feb8998cd9b342(function() {
        return callback;
    }, inputs);
}
var $a060da77483cc5d3$export$1538c33de8887b59 = $a060da77483cc5d3$export$b6feb8998cd9b342;
var $a060da77483cc5d3$export$35808ee640e87ca7 = $a060da77483cc5d3$export$33752cf3ee811995;











var $9b55b89d220bd473$var$_process, $9b55b89d220bd473$var$_process2;
// We can't rely on NODE_ENV === 'test' if its value is already configured by the consumer to some other value, so better to use JEST_WORKER_ID
// https://jestjs.io/docs/environment-variables#jest_worker_id
var $9b55b89d220bd473$var$TESTS_MODE = (globalThis === null || globalThis === void 0 || ($9b55b89d220bd473$var$_process = globalThis.process) === null || $9b55b89d220bd473$var$_process === void 0 || ($9b55b89d220bd473$var$_process = $9b55b89d220bd473$var$_process.env) === null || $9b55b89d220bd473$var$_process === void 0 ? void 0 : $9b55b89d220bd473$var$_process.JEST_WORKER_ID) !== undefined;
var $9b55b89d220bd473$var$DEBUG_MODE = !$9b55b89d220bd473$var$TESTS_MODE && (globalThis === null || globalThis === void 0 || ($9b55b89d220bd473$var$_process2 = globalThis.process) === null || $9b55b89d220bd473$var$_process2 === void 0 || ($9b55b89d220bd473$var$_process2 = $9b55b89d220bd473$var$_process2.env) === null || $9b55b89d220bd473$var$_process2 === void 0 ? void 0 : $9b55b89d220bd473$var$_process2.NODE_ENV) !== 'production';
var $9b55b89d220bd473$export$1c9f709888824e05 = function debug() {
    var _console;
    if (!$9b55b89d220bd473$var$DEBUG_MODE) return;
    // eslint-disable-next-line no-console
    (_console = console).debug.apply(_console, arguments);
};



var $3ZMUU = parcelRequire("3ZMUU");
var $6cea8d6c8421ffc9$var$pkgName = '@atlaskit/platform-feature-flags';
var $6cea8d6c8421ffc9$export$7e41b1b2bdee3f98 = '__PLATFORM_FEATURE_FLAGS__';
var $6cea8d6c8421ffc9$var$hasProcessEnv = typeof $3ZMUU !== 'undefined' && typeof $3ZMUU.env !== 'undefined';
// FF global overrides can be configured by test runners or Storybook
var $6cea8d6c8421ffc9$var$ENV_ENABLE_PLATFORM_FF = $6cea8d6c8421ffc9$var$hasProcessEnv ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;
// STORYBOOK_ENABLE_PLATFORM_FF is included as storybook only allows env vars prefixed with STORYBOOK
// https://github.com/storybookjs/storybook/issues/12270
var $6cea8d6c8421ffc9$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF = $6cea8d6c8421ffc9$var$hasProcessEnv ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;
var $6cea8d6c8421ffc9$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE = $6cea8d6c8421ffc9$var$ENV_ENABLE_PLATFORM_FF || $6cea8d6c8421ffc9$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF;
var $6cea8d6c8421ffc9$var$DEFAULT_PFF_GLOBAL = {
    booleanResolver: undefined
};
var $6cea8d6c8421ffc9$var$globalVar = typeof window !== 'undefined' ? window : globalThis;
$6cea8d6c8421ffc9$var$globalVar[$6cea8d6c8421ffc9$export$7e41b1b2bdee3f98] = $6cea8d6c8421ffc9$var$globalVar[$6cea8d6c8421ffc9$export$7e41b1b2bdee3f98] || $6cea8d6c8421ffc9$var$DEFAULT_PFF_GLOBAL;
function $6cea8d6c8421ffc9$export$f2b591175b3e424c(resolver) {
    $6cea8d6c8421ffc9$var$globalVar[$6cea8d6c8421ffc9$export$7e41b1b2bdee3f98].booleanResolver = resolver;
}
function $6cea8d6c8421ffc9$export$6333b6aff9fc6275(flagKey) {
    if ($6cea8d6c8421ffc9$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE) {
        (0, $9b55b89d220bd473$export$1c9f709888824e05)('[%s]: The feature flags were enabled while running tests. The flag "%s" will be always enabled.', $6cea8d6c8421ffc9$var$pkgName, flagKey);
        return true;
    }
    try {
        var _globalVar$PFF_GLOBAL, _globalVar$PFF_GLOBAL2, _globalVar$PFF_GLOBAL3;
        // booleanResolver will be empty for products like Trello, Elevate, Recruit etc.
        // Currently only Confluence, Jira and Bitbucket has set it.
        if (((_globalVar$PFF_GLOBAL = $6cea8d6c8421ffc9$var$globalVar[$6cea8d6c8421ffc9$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL === void 0 ? void 0 : _globalVar$PFF_GLOBAL.booleanResolver) === undefined || ((_globalVar$PFF_GLOBAL2 = $6cea8d6c8421ffc9$var$globalVar[$6cea8d6c8421ffc9$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL2 === void 0 ? void 0 : _globalVar$PFF_GLOBAL2.booleanResolver) === null) // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
        return (0, $64018b7e2de5e8ce$export$2e2bcd8739ae039).checkGate(flagKey);
        var result = (_globalVar$PFF_GLOBAL3 = $6cea8d6c8421ffc9$var$globalVar[$6cea8d6c8421ffc9$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL3 === void 0 ? void 0 : _globalVar$PFF_GLOBAL3.booleanResolver(flagKey);
        if (typeof result !== 'boolean') {
            // eslint-disable-next-line no-console
            console.warn("".concat(flagKey, " resolved to a non-boolean value, returning false for safety"));
            return false;
        }
        return result;
    } catch (e) {
        return false;
    }
}


function $c45234f6ee9ee85d$export$ba05d765b8392e5e(flagResolver) {
    (0, $6cea8d6c8421ffc9$export$f2b591175b3e424c)(flagResolver);
}
function $c45234f6ee9ee85d$export$470e5c2be1411c89(name) {
    return (0, $6cea8d6c8421ffc9$export$6333b6aff9fc6275)(name);
}
function $c45234f6ee9ee85d$export$b40ec24ac8275656(name) {
    return (0, $6cea8d6c8421ffc9$export$6333b6aff9fc6275)(name);
}






function $427d60da9e7e5d8e$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $427d60da9e7e5d8e$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $427d60da9e7e5d8e$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $36e8c6a8ae2e8480$export$2e2bcd8739ae039)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $427d60da9e7e5d8e$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $427d60da9e7e5d8e$export$ad4be5c2ec28cecf = function isAnalyticsEvent(obj) {
    var _obj$constructor;
    return obj instanceof $427d60da9e7e5d8e$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 || (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === 'AnalyticsEvent';
};
// eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
var $427d60da9e7e5d8e$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function AnalyticsEvent(props) {
        var _this = this;
        (0, $b415120f8e0f227f$export$2e2bcd8739ae039)(this, AnalyticsEvent);
        (0, $36e8c6a8ae2e8480$export$2e2bcd8739ae039)(this, "_isAnalyticsEvent", true);
        (0, $36e8c6a8ae2e8480$export$2e2bcd8739ae039)(this, "clone", function() {
            // just a shallow clone, don't change sub refs unless you want to
            // affect the original's too
            var payload = $427d60da9e7e5d8e$var$_objectSpread({}, _this.payload);
            return new AnalyticsEvent({
                payload: payload
            });
        });
        this.payload = props.payload;
    }
    return (0, $8be4ca258be1ae94$export$2e2bcd8739ae039)(AnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (typeof updater === 'function') this.payload = updater(this.payload);
                if ((0, $0b394150901e1111$export$2e2bcd8739ae039)(updater) === 'object') this.payload = $427d60da9e7e5d8e$var$_objectSpread($427d60da9e7e5d8e$var$_objectSpread({}, this.payload), updater);
                return this;
            }
        }
    ]);
}();


function $1a7fd2698bd070cf$var$_callSuper(t, o, e) {
    return o = (0, $a5ff528a183eafe8$export$2e2bcd8739ae039)(o), (0, $ff8735ca66b4325e$export$2e2bcd8739ae039)(t, $1a7fd2698bd070cf$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, $a5ff528a183eafe8$export$2e2bcd8739ae039)(t).constructor) : o.apply(t, e));
}
function $1a7fd2698bd070cf$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($1a7fd2698bd070cf$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $1a7fd2698bd070cf$var$_superPropGet(t, o, e, r) {
    var p = (0, $1bb15625cf4ef546$export$2e2bcd8739ae039)((0, $a5ff528a183eafe8$export$2e2bcd8739ae039)(1 & r ? t.prototype : t), o, e);
    return 2 & r && "function" == typeof p ? function(t) {
        return p.apply(e, t);
    } : p;
}
function $1a7fd2698bd070cf$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $1a7fd2698bd070cf$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $1a7fd2698bd070cf$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $36e8c6a8ae2e8480$export$2e2bcd8739ae039)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $1a7fd2698bd070cf$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $1a7fd2698bd070cf$export$35f8383928ba8d7 = function isUIAnalyticsEvent(obj) {
    var _obj$constructor;
    return obj instanceof $1a7fd2698bd070cf$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isUIAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 || (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === 'UIAnalyticsEvent';
};
/**
 * Produces a deep clone of an event payload.
 *
 * The historic implementation relied on `JSON.parse(JSON.stringify(...))`, a
 * "hacky" deep clone that does not support functions, regexs, Maps, Sets, etc.
 * Crucially, `JSON.stringify` also throws `TypeError: Converting circular
 * structure to JSON` when the payload contains a value with circular
 * references — e.g. a live DOM node carrying React fiber back-references
 * (`__reactFiber$...`). When that throw happens during a React render/commit it
 * escapes into product UI and trips an error boundary (HOT-127428).
 *
 * Analytics must never crash product UI (the same contract `fire` upholds), so
 * behind the `platform-analytics-next-safe-clone` gate we wrap the
 * serialization in a try/catch and fall back to a shallow clone — matching the
 * base `AnalyticsEvent.clone` behaviour — if the deep clone fails.
 *
 * NOTE: this is intentionally a module-scoped function rather than a class
 * member so it does not change the structural type of `UIAnalyticsEvent`, which
 * is hand-mocked across the monorepo.
 */ var $1a7fd2698bd070cf$var$clonePayload = function clonePayload(payload) {
    if ((0, $c45234f6ee9ee85d$export$b40ec24ac8275656)('platform-analytics-next-safe-clone')) try {
        return JSON.parse(JSON.stringify(payload));
    } catch (e) {
        // Shallow clone keeps the event usable without crashing the UI.
        return $1a7fd2698bd070cf$var$_objectSpread({}, payload);
    }
    /**
   * A hacky "deep clone" of the object. This is limited in that it wont
   * support functions, regexs, Maps, Sets, etc, but none of those need to
   * be represented in our payload.
   */ return JSON.parse(JSON.stringify(payload));
};
// eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
var $1a7fd2698bd070cf$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_AnalyticsEvent) {
    function UIAnalyticsEvent(props) {
        var _this;
        (0, $b415120f8e0f227f$export$2e2bcd8739ae039)(this, UIAnalyticsEvent);
        _this = $1a7fd2698bd070cf$var$_callSuper(this, UIAnalyticsEvent, [
            props
        ]);
        (0, $36e8c6a8ae2e8480$export$2e2bcd8739ae039)(_this, "_isUIAnalyticsEvent", true);
        (0, $36e8c6a8ae2e8480$export$2e2bcd8739ae039)(_this, "clone", function() {
            if (_this.hasFired) return null;
            var context = (0, $26ce087261062f24$export$2e2bcd8739ae039)(_this.context);
            var handlers = (0, $26ce087261062f24$export$2e2bcd8739ae039)(_this.handlers);
            var payload = $1a7fd2698bd070cf$var$clonePayload(_this.payload);
            return new UIAnalyticsEvent({
                context: context,
                handlers: handlers,
                payload: payload
            });
        });
        (0, $36e8c6a8ae2e8480$export$2e2bcd8739ae039)(_this, "fire", function(channel) {
            if (_this.hasFired) return;
            _this.handlers.forEach(function(handler) {
                try {
                    handler(_this, channel);
                } catch (e) {}
            });
            _this.hasFired = true;
        });
        _this.context = props.context || [];
        _this.handlers = props.handlers || [];
        _this.hasFired = false;
        return _this;
    }
    (0, $d38571b416fa0640$export$2e2bcd8739ae039)(UIAnalyticsEvent, _AnalyticsEvent);
    return (0, $8be4ca258be1ae94$export$2e2bcd8739ae039)(UIAnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (this.hasFired) return this;
                return $1a7fd2698bd070cf$var$_superPropGet(UIAnalyticsEvent, "update", this, 3)([
                    updater
                ]);
            }
        }
    ]);
}((0, $427d60da9e7e5d8e$export$2e2bcd8739ae039));



var $5FkrB = parcelRequire("5FkrB");

var $5FkrB = parcelRequire("5FkrB");
var $2fdf6e45620f1c96$var$AnalyticsNextContext = (0, $5FkrB.createContext)({
    getAtlaskitAnalyticsContext: function() {
        return [];
    },
    getAtlaskitAnalyticsEventHandlers: function() {
        return [];
    }
});
var $2fdf6e45620f1c96$export$2e2bcd8739ae039 = $2fdf6e45620f1c96$var$AnalyticsNextContext;


var $d82667e77467cbe0$export$2e2bcd8739ae039 = (0, $2fdf6e45620f1c96$export$2e2bcd8739ae039);


var $9932a820a8e26dfa$export$d1f587f82ad51c4 = function useAnalyticsContext() {
    return (0, $5FkrB.useContext)((0, $d82667e77467cbe0$export$2e2bcd8739ae039));
};


function $b22f7131922934a4$export$5bf35293e545f20c() {
    var analyticsContext = (0, $9932a820a8e26dfa$export$d1f587f82ad51c4)();
    var createAnalyticsEvent = (0, $a060da77483cc5d3$export$33752cf3ee811995)(function(payload) {
        return new (0, $1a7fd2698bd070cf$export$2e2bcd8739ae039)({
            context: analyticsContext.getAtlaskitAnalyticsContext(),
            handlers: analyticsContext.getAtlaskitAnalyticsEventHandlers(),
            payload: payload
        });
    }, [
        analyticsContext
    ]);
    return {
        createAnalyticsEvent: createAnalyticsEvent
    };
}



var $5FkrB = parcelRequire("5FkrB");
var $208d62e16eee951c$export$1d27a74659855e44 = function useTrackedRef(value) {
    var ref = (0, $5FkrB.useRef)(value);
    ref.current = value;
    return ref;
};


function $73e78cee963588e3$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $73e78cee963588e3$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $73e78cee963588e3$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $36e8c6a8ae2e8480$export$2e2bcd8739ae039)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $73e78cee963588e3$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $73e78cee963588e3$export$a4687b0234b40e28(_ref) {
    var fn = _ref.fn, action = _ref.action, componentName = _ref.componentName, actionSubject = _ref.actionSubject, packageName = _ref.packageName, packageVersion = _ref.packageVersion, analyticsData = _ref.analyticsData;
    var _useAnalyticsEvents = (0, $b22f7131922934a4$export$5bf35293e545f20c)(), createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
    // We put analyticsData and fn in a ref so that we don't need to break
    // memoization.
    // Generally these could be defined by consumers inline
    // and so we do this to avoid breaking memoization of useCallback
    var dataRef = (0, $208d62e16eee951c$export$1d27a74659855e44)(analyticsData);
    var fnRef = (0, $208d62e16eee951c$export$1d27a74659855e44)(fn);
    var handler = (0, $5FkrB.useCallback)(function(value) {
        var analyticsEvent = createAnalyticsEvent({
            action: action,
            actionSubject: actionSubject || componentName,
            attributes: {
                componentName: componentName,
                packageName: packageName,
                packageVersion: packageVersion
            }
        });
        // To avoid wrapping this component in AnalyticsContext we manually
        // push the parent context's meta data into the context.
        // Note: this new 'context'
        var context = $73e78cee963588e3$var$_objectSpread({
            componentName: componentName,
            packageName: packageName,
            packageVersion: packageVersion
        }, dataRef.current);
        analyticsEvent.context.push(context);
        // fire an event on the atlaskit channel
        var clone = analyticsEvent.clone();
        if (clone) clone.fire('atlaskit');
        fnRef.current(value, analyticsEvent);
    }, [
        // These are strings and won't change
        action,
        componentName,
        actionSubject,
        packageName,
        packageVersion,
        // This function is memoized in the context
        createAnalyticsEvent,
        // these are a stable ref because of the useTrackedRef hook
        dataRef,
        fnRef
    ]);
    return handler;
}



var $5FkrB = parcelRequire("5FkrB");

var $5FkrB = parcelRequire("5FkrB");
var $7330b8b30881a453$export$2931e0ee690eee88 = /*#__PURE__*/ (0, $5FkrB.createContext)({});
/**
 * __RouterLinkProvider__
 *
 * Provides a configured router link component for use
 * within Design System components.
 */ var $7330b8b30881a453$var$RouterLinkProvider = function RouterLinkProvider(_ref) {
    var routerLinkComponent = _ref.routerLinkComponent, children = _ref.children;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement($7330b8b30881a453$export$2931e0ee690eee88.Provider, {
        value: {
            routerLinkComponent: routerLinkComponent
        }
    }, children);
};
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$7330b8b30881a453$export$2e2bcd8739ae039 = $7330b8b30881a453$var$RouterLinkProvider;


var $bfb7249c3c1ef356$export$6d558eab13290f59 = function useRouterLink() {
    var _useContext = (0, $5FkrB.useContext)((0, $7330b8b30881a453$export$2931e0ee690eee88)), routerLinkComponent = _useContext.routerLinkComponent;
    if (routerLinkComponent) return routerLinkComponent;
    return;
};




var $5FkrB = parcelRequire("5FkrB");
function $c797bf80d6171378$export$f680877a34711e37() {
    // React uses `:` or `«»` in selectors which breaks `document.querySelector(…)`.
    // Replace with `_` to match future React 19 functionality.
    return (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).useId().replace(/[:«»]/g, '_');
}



var $5FkrB = parcelRequire("5FkrB");
var $a81fd7e45a8c2ef5$var$interactionContext = /*#__PURE__*/ (0, $5FkrB.createContext)(null);
var $a81fd7e45a8c2ef5$export$2e2bcd8739ae039 = $a81fd7e45a8c2ef5$var$interactionContext;


/* visually-hidden.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $5FkrB = parcelRequire("5FkrB");

var $18eafb5d6736b659$var$visuallyHiddenStyles = null;
/**
 * __Visually hidden__
 *
 * A composable element to apply a visually hidden effect to children.
 * Useful for accessibility compliance.
 *
 * @example
 * ```jsx
 * import VisuallyHidden from '@atlaskit/visually-hidden';
 *
 * export default () => (
 *   <div style={{ border: '1px solid black' }}>
 *      There is text hidden between the brackets [
 *      <VisuallyHidden>Can't see me!</VisuallyHidden>]
 *   </div>
 * );
 * ```
 */ var $18eafb5d6736b659$var$VisuallyHidden = function VisuallyHidden(_ref) {
    var children = _ref.children, testId = _ref.testId, role = _ref.role, id = _ref.id;
    return /*#__PURE__*/ $5FkrB.createElement("span", {
        id: id,
        "data-testid": testId,
        role: role,
        className: (0, $2efec74f5f421835$export$2e2bcd8739ae039)([
            "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19itidpf _1reo15vq _18m915vq _1bsbt94y _4t3it94y _kqswstnw _ogto7mnp _uiztglyw _o5721q9c"
        ])
    }, children);
};
$18eafb5d6736b659$var$VisuallyHidden.displayName = 'VisuallyHidden';
var $18eafb5d6736b659$export$2e2bcd8739ae039 = $18eafb5d6736b659$var$VisuallyHidden;


/* focusable.tsx generated by @compiled/babel-plugin v2.0.0 */ 


var $5FkrB = parcelRequire("5FkrB");

var $0892b67300d3cad3$var$_excluded = [
    "as",
    "children",
    "isInset",
    "testId",
    "style",
    "xcss"
], $0892b67300d3cad3$var$_excluded2 = [
    "className"
];
var $0892b67300d3cad3$var$focusRingStyles = null;
var $0892b67300d3cad3$var$insetFocusRingStyles = null;
var $0892b67300d3cad3$export$35a3bebf7ef2d934 = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? 'button' : _ref$as, children = _ref.children, isInset = _ref.isInset, testId = _ref.testId, style = _ref.style, xcss = _ref.xcss, htmlAttributes = (0, $e1dadfc9c3d2f1bd$export$2e2bcd8739ae039)(_ref, $0892b67300d3cad3$var$_excluded);
    // This is to remove className from safeHtmlAttributes
    // @ts-ignore -- not using expect since it causes issues with help-center local consumption - className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    var _spreadClass = htmlAttributes.className, safeHtmlAttributes = (0, $e1dadfc9c3d2f1bd$export$2e2bcd8739ae039)(htmlAttributes, $0892b67300d3cad3$var$_excluded2);
    return /*#__PURE__*/ $5FkrB.createElement(Component, (0, $a22d338ce3923cba$export$2e2bcd8739ae039)({}, safeHtmlAttributes, {
        // @ts-ignore Expression produces a union type that is too complex to represent. We may be able to narrow the type here but unsure.
        ref: ref,
        className: (0, $2efec74f5f421835$export$2e2bcd8739ae039)([
            "_ymio1r31 _ypr0glyw _zcxs1o36 _mizu194a _1ah3dkaa _ra3xnqa1 _128mdkaa _1cvmnqa1 _4davt94y",
            isInset && "_1ah31gjf _2mwq1gjf",
            xcss
        ]),
        style: style,
        "data-testid": testId
    }), children);
});


var $8ad8e55618b90d53$var$_excluded = [
    "href",
    "children",
    "onClick",
    "interactionName",
    "componentName",
    "analyticsContext",
    "aria-label",
    "aria-labelledby",
    "style",
    "target",
    "testId",
    "xcss",
    "newWindowLabel"
], $8ad8e55618b90d53$var$_excluded2 = [
    "className"
];
var $8ad8e55618b90d53$var$styles = {
    root: "_4bfu1r31 _1hms8stv _ajmmnqa1 _vchhusvi",
    position: "_kqswh2mm"
};
var $8ad8e55618b90d53$var$IS_EXTERNAL_LINK_REGEX = /^(?:(http|https):\/\/)/;
var $8ad8e55618b90d53$var$IS_NON_HTTP_BASED = /^(((mailto|tel|sms|blob):)|(#))/;
/**
 * __Anchor__
 *
 * A primitive for building custom anchor links.
 *
 * - [Examples](https://atlassian.design/components/primitives/anchor/examples)
 * - [Code](https://atlassian.design/components/primitives/anchor/code)
 * - [Usage](https://atlassian.design/components/primitives/anchor/usage)
 */ var $8ad8e55618b90d53$var$AnchorNoRef = function AnchorNoRef(_ref, ref) {
    var href = _ref.href, children = _ref.children, _ref$onClick = _ref.onClick, providedOnClick = _ref$onClick === void 0 ? (0, $adcefb868cf2fc9d$export$2e2bcd8739ae039) : _ref$onClick, interactionName = _ref.interactionName, componentName = _ref.componentName, analyticsContext = _ref.analyticsContext, ariaLabel = _ref['aria-label'], ariaLabelledBy = _ref['aria-labelledby'], style = _ref.style, target = _ref.target, testId = _ref.testId, xcss = _ref.xcss, _ref$newWindowLabel = _ref.newWindowLabel, newWindowLabel = _ref$newWindowLabel === void 0 ? '(opens new window)' : _ref$newWindowLabel, htmlAttributes = (0, $e1dadfc9c3d2f1bd$export$2e2bcd8739ae039)(_ref, $8ad8e55618b90d53$var$_excluded);
    var interactionContext = (0, $5FkrB.useContext)((0, $a81fd7e45a8c2ef5$export$2e2bcd8739ae039));
    var handleClick = (0, $5FkrB.useCallback)(function(e, analyticsEvent) {
        interactionContext && interactionContext.tracePress(interactionName, e.timeStamp);
        providedOnClick(e, analyticsEvent);
    }, [
        providedOnClick,
        interactionContext,
        interactionName
    ]);
    var opensNewWindowLabelId = (0, $c797bf80d6171378$export$f680877a34711e37)();
    var onClick = (0, $73e78cee963588e3$export$a4687b0234b40e28)({
        fn: handleClick,
        action: 'clicked',
        componentName: componentName || 'Anchor',
        packageName: "@atlaskit/primitives",
        packageVersion: "22.3.0",
        analyticsData: analyticsContext,
        actionSubject: 'link'
    });
    // This is to remove className from safeHtmlAttributes
    // @ts-expect-error className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    var _spreadClass = htmlAttributes.className, safeHtmlAttributes = (0, $e1dadfc9c3d2f1bd$export$2e2bcd8739ae039)(htmlAttributes, $8ad8e55618b90d53$var$_excluded2);
    var RouterLink = (0, $bfb7249c3c1ef356$export$6d558eab13290f59)();
    var isExternal = typeof href === 'string' && $8ad8e55618b90d53$var$IS_EXTERNAL_LINK_REGEX.test(href);
    var isNonHttpBased = typeof href === 'string' && $8ad8e55618b90d53$var$IS_NON_HTTP_BASED.test(href);
    /**
   * Renders a router link if:
   *
   * - a link component is set in the app provider
   * - it's not an external link (starting with `http://` or `https://`)
   * - it's not a non-HTTP-based link (e.g. emails, phone numbers, hash links etc.).
   */ var isRouterLink = RouterLink && !isExternal && !isNonHttpBased;
    var hrefObjectUsedWithoutRouterLink = RouterLink === undefined && (0, $0b394150901e1111$export$2e2bcd8739ae039)(href) === 'object';
    (0, $fff3f31fc3bd4f88$export$2e2bcd8739ae039)(!hrefObjectUsedWithoutRouterLink, "@atlaskit/primitives: Anchor primitive cannot pass an object to 'href' unless a router link is configured in the AppProvider");
    var Component = isRouterLink ? RouterLink : 'a';
    return /*#__PURE__*/ $5FkrB.createElement((0, $0892b67300d3cad3$export$35a3bebf7ef2d934), (0, $a22d338ce3923cba$export$2e2bcd8739ae039)({
        as: Component,
        className: xcss,
        style: style,
        ref: ref
    }, safeHtmlAttributes, {
        href: !isRouterLink && typeof href !== 'string' ? undefined : href,
        target: target,
        onClick: onClick,
        "aria-label": ariaLabel && target === '_blank' && !ariaLabelledBy ? "".concat(ariaLabel, " , ").concat(newWindowLabel) : ariaLabel,
        "aria-labelledby": ariaLabelledBy && target === '_blank' ? "".concat(ariaLabelledBy, " ").concat(opensNewWindowLabelId) : ariaLabelledBy,
        xcss: (0, $adc17885230aed9b$export$a274e22fb40f762e)($8ad8e55618b90d53$var$styles.root, $8ad8e55618b90d53$var$styles.position, xcss),
        testId: testId,
        "data-is-router-link": testId ? isRouterLink ? 'true' : 'false' : undefined
    }), children, target === '_blank' && (children && !ariaLabel && !ariaLabelledBy || ariaLabelledBy) && /*#__PURE__*/ $5FkrB.createElement((0, $18eafb5d6736b659$export$2e2bcd8739ae039), {
        id: opensNewWindowLabelId
    }, ", ".concat(newWindowLabel)));
};
var $8ad8e55618b90d53$export$b688253958b8dfe7 = /*#__PURE__*/ (0, $5FkrB.forwardRef)($8ad8e55618b90d53$var$AnchorNoRef);

/* box.tsx generated by @compiled/babel-plugin v2.0.0 */ 


var $5FkrB = parcelRequire("5FkrB");


var $5FkrB = parcelRequire("5FkrB");
var $5b9f730e423c70ca$export$1ca2a26fecb070ae = /*#__PURE__*/ (0, $5FkrB.createContext)('elevation.surface');


var $486e85222e48a5c3$var$_excluded = [
    "as",
    "children",
    "backgroundColor",
    "padding",
    "paddingBlock",
    "paddingBlockStart",
    "paddingBlockEnd",
    "paddingInline",
    "paddingInlineStart",
    "paddingInlineEnd",
    "style",
    "testId",
    "xcss"
], $486e85222e48a5c3$var$_excluded2 = [
    "className"
];
// Can either Exclude or Extract - here we're excluding all SVG-related elements, <button> elements (handled by Pressable), and <a> elements (handled by Anchor)
// Basically just ElementType but without ComponentType, it makes sense to keep the "Type" suffix
// eslint-disable-next-line @repo/internal/react/consistent-types-definitions
var $486e85222e48a5c3$var$baseStyles = null;
var $486e85222e48a5c3$var$backgroundColorMap = {
    'color.background.accent.lime.subtlest': "_bfhkm890",
    'color.background.accent.lime.subtlest.hovered': "_bfhkd4y8",
    'color.background.accent.lime.subtlest.pressed': "_bfhkkuup",
    'color.background.accent.lime.subtler': "_bfhkz2ec",
    'color.background.accent.lime.subtler.hovered': "_bfhk1gf0",
    'color.background.accent.lime.subtler.pressed': "_bfhk2kxc",
    'color.background.accent.lime.subtle': "_bfhkbq5w",
    'color.background.accent.lime.subtle.hovered': "_bfhkfoww",
    'color.background.accent.lime.subtle.pressed': "_bfhk1jbd",
    'color.background.accent.lime.bolder': "_bfhktde4",
    'color.background.accent.lime.bolder.hovered': "_bfhknzpa",
    'color.background.accent.lime.bolder.pressed': "_bfhkh0j0",
    'color.background.accent.red.subtlest': "_bfhk1vk5",
    'color.background.accent.red.subtlest.hovered': "_bfhk1i6i",
    'color.background.accent.red.subtlest.pressed': "_bfhknbir",
    'color.background.accent.red.subtler': "_bfhk1rtt",
    'color.background.accent.red.subtler.hovered': "_bfhkaffd",
    'color.background.accent.red.subtler.pressed': "_bfhk1j5a",
    'color.background.accent.red.subtle': "_bfhkkrt9",
    'color.background.accent.red.subtle.hovered': "_bfhk1sou",
    'color.background.accent.red.subtle.pressed': "_bfhk1fnn",
    'color.background.accent.red.bolder': "_bfhkuibq",
    'color.background.accent.red.bolder.hovered': "_bfhk100f",
    'color.background.accent.red.bolder.pressed': "_bfhk1cl6",
    'color.background.accent.orange.subtlest': "_bfhkf5uh",
    'color.background.accent.orange.subtlest.hovered': "_bfhk19yr",
    'color.background.accent.orange.subtlest.pressed': "_bfhkf90x",
    'color.background.accent.orange.subtler': "_bfhk165s",
    'color.background.accent.orange.subtler.hovered': "_bfhk1ei0",
    'color.background.accent.orange.subtler.pressed': "_bfhkdpo3",
    'color.background.accent.orange.subtle': "_bfhk1kkj",
    'color.background.accent.orange.subtle.hovered': "_bfhk9mfs",
    'color.background.accent.orange.subtle.pressed': "_bfhkaxpp",
    'color.background.accent.orange.bolder': "_bfhk1qg1",
    'color.background.accent.orange.bolder.hovered': "_bfhk12qo",
    'color.background.accent.orange.bolder.pressed': "_bfhk1fyq",
    'color.background.accent.yellow.subtlest': "_bfhkibhp",
    'color.background.accent.yellow.subtlest.hovered': "_bfhkaetg",
    'color.background.accent.yellow.subtlest.pressed': "_bfhk1o1l",
    'color.background.accent.yellow.subtler': "_bfhk1773",
    'color.background.accent.yellow.subtler.hovered': "_bfhk1uw7",
    'color.background.accent.yellow.subtler.pressed': "_bfhk1r9w",
    'color.background.accent.yellow.subtle': "_bfhk8y3s",
    'color.background.accent.yellow.subtle.hovered': "_bfhk819w",
    'color.background.accent.yellow.subtle.pressed': "_bfhk1jx0",
    'color.background.accent.yellow.bolder': "_bfhk1vop",
    'color.background.accent.yellow.bolder.hovered': "_bfhkkjqf",
    'color.background.accent.yellow.bolder.pressed': "_bfhk1okt",
    'color.background.accent.green.subtlest': "_bfhkn729",
    'color.background.accent.green.subtlest.hovered': "_bfhk3utz",
    'color.background.accent.green.subtlest.pressed': "_bfhkyfny",
    'color.background.accent.green.subtler': "_bfhk1wnw",
    'color.background.accent.green.subtler.hovered': "_bfhk1e2h",
    'color.background.accent.green.subtler.pressed': "_bfhkybhx",
    'color.background.accent.green.subtle': "_bfhk1rsu",
    'color.background.accent.green.subtle.hovered': "_bfhk12e3",
    'color.background.accent.green.subtle.pressed': "_bfhk1g86",
    'color.background.accent.green.bolder': "_bfhk1e5c",
    'color.background.accent.green.bolder.hovered': "_bfhka5yi",
    'color.background.accent.green.bolder.pressed': "_bfhk1j68",
    'color.background.accent.teal.subtlest': "_bfhk7xuz",
    'color.background.accent.teal.subtlest.hovered': "_bfhk108c",
    'color.background.accent.teal.subtlest.pressed': "_bfhk1cxp",
    'color.background.accent.teal.subtler': "_bfhk1a17",
    'color.background.accent.teal.subtler.hovered': "_bfhkkwwr",
    'color.background.accent.teal.subtler.pressed': "_bfhk1jb0",
    'color.background.accent.teal.subtle': "_bfhktdv8",
    'color.background.accent.teal.subtle.hovered': "_bfhkzh8h",
    'color.background.accent.teal.subtle.pressed': "_bfhk16zl",
    'color.background.accent.teal.bolder': "_bfhk2c8p",
    'color.background.accent.teal.bolder.hovered': "_bfhkl3ve",
    'color.background.accent.teal.bolder.pressed': "_bfhktor0",
    'color.background.accent.blue.subtlest': "_bfhk1s93",
    'color.background.accent.blue.subtlest.hovered': "_bfhkdaj9",
    'color.background.accent.blue.subtlest.pressed': "_bfhkxm0g",
    'color.background.accent.blue.subtler': "_bfhk1dy8",
    'color.background.accent.blue.subtler.hovered': "_bfhk815t",
    'color.background.accent.blue.subtler.pressed': "_bfhkrwxf",
    'color.background.accent.blue.subtle': "_bfhk115i",
    'color.background.accent.blue.subtle.hovered': "_bfhk9pr4",
    'color.background.accent.blue.subtle.pressed': "_bfhknpx7",
    'color.background.accent.blue.bolder': "_bfhk16e3",
    'color.background.accent.blue.bolder.hovered': "_bfhk1vbm",
    'color.background.accent.blue.bolder.pressed': "_bfhk1xwi",
    'color.background.accent.purple.subtlest': "_bfhkp2ly",
    'color.background.accent.purple.subtlest.hovered': "_bfhkkca2",
    'color.background.accent.purple.subtlest.pressed': "_bfhk1jbm",
    'color.background.accent.purple.subtler': "_bfhk1nm4",
    'color.background.accent.purple.subtler.hovered': "_bfhkattl",
    'color.background.accent.purple.subtler.pressed': "_bfhk3nfk",
    'color.background.accent.purple.subtle': "_bfhk18ah",
    'color.background.accent.purple.subtle.hovered': "_bfhk8bp1",
    'color.background.accent.purple.subtle.pressed': "_bfhk1cd2",
    'color.background.accent.purple.bolder': "_bfhkya33",
    'color.background.accent.purple.bolder.hovered': "_bfhk1af5",
    'color.background.accent.purple.bolder.pressed': "_bfhk6cze",
    'color.background.accent.magenta.subtlest': "_bfhk8tvm",
    'color.background.accent.magenta.subtlest.hovered': "_bfhkr3zd",
    'color.background.accent.magenta.subtlest.pressed': "_bfhk1ckf",
    'color.background.accent.magenta.subtler': "_bfhkv9ra",
    'color.background.accent.magenta.subtler.hovered': "_bfhk1axx",
    'color.background.accent.magenta.subtler.pressed': "_bfhk42ri",
    'color.background.accent.magenta.subtle': "_bfhk1mi6",
    'color.background.accent.magenta.subtle.hovered': "_bfhkrwyz",
    'color.background.accent.magenta.subtle.pressed': "_bfhk6c15",
    'color.background.accent.magenta.bolder': "_bfhkc3uk",
    'color.background.accent.magenta.bolder.hovered': "_bfhk1ok8",
    'color.background.accent.magenta.bolder.pressed': "_bfhkeawv",
    'color.background.accent.gray.subtlest': "_bfhkysee",
    'color.background.accent.gray.subtlest.hovered': "_bfhkwejn",
    'color.background.accent.gray.subtlest.pressed': "_bfhk18ut",
    'color.background.accent.gray.subtler': "_bfhk7qp0",
    'color.background.accent.gray.subtler.hovered': "_bfhk10ef",
    'color.background.accent.gray.subtler.pressed': "_bfhk1rk9",
    'color.background.accent.gray.subtle': "_bfhk18j9",
    'color.background.accent.gray.subtle.hovered': "_bfhk1nv3",
    'color.background.accent.gray.subtle.pressed': "_bfhkq9tj",
    'color.background.accent.gray.bolder': "_bfhk1i45",
    'color.background.accent.gray.bolder.hovered': "_bfhkbyip",
    'color.background.accent.gray.bolder.pressed': "_bfhk1van",
    'color.background.disabled': "_bfhk187o",
    'color.background.input': "_bfhk1j9a",
    'color.background.input.hovered': "_bfhkl4ek",
    'color.background.input.pressed': "_bfhkr01l",
    'color.background.inverse.subtle': "_bfhk1vck",
    'color.background.inverse.subtle.hovered': "_bfhkmpja",
    'color.background.inverse.subtle.pressed': "_bfhk1gii",
    'color.background.neutral': "_bfhki8nm",
    'color.background.neutral.hovered': "_bfhkplhp",
    'color.background.neutral.pressed': "_bfhk1gdz",
    'color.background.neutral.subtle': "_bfhksm61",
    'color.background.neutral.subtle.hovered': "_bfhk1dpa",
    'color.background.neutral.subtle.pressed': "_bfhkfcek",
    'color.background.neutral.bold': "_bfhk1aqn",
    'color.background.neutral.bold.hovered': "_bfhk1ibz",
    'color.background.neutral.bold.pressed': "_bfhkof27",
    'color.background.selected': "_bfhk15s3",
    'color.background.selected.hovered': "_bfhkufnl",
    'color.background.selected.pressed': "_bfhknozp",
    'color.background.selected.bold': "_bfhkjmqp",
    'color.background.selected.bold.hovered': "_bfhk1q28",
    'color.background.selected.bold.pressed': "_bfhk12kk",
    'color.background.brand.subtlest': "_bfhk1gmr",
    'color.background.brand.subtlest.hovered': "_bfhk3v15",
    'color.background.brand.subtlest.pressed': "_bfhku02c",
    'color.background.brand.bold': "_bfhk1856",
    'color.background.brand.bold.hovered': "_bfhkhf2y",
    'color.background.brand.bold.pressed': "_bfhkg6ey",
    'color.background.brand.boldest': "_bfhk1o4i",
    'color.background.brand.boldest.hovered': "_bfhklefx",
    'color.background.brand.boldest.pressed': "_bfhk16k6",
    'color.background.danger': "_bfhk1gly",
    'color.background.danger.hovered': "_bfhk1yvi",
    'color.background.danger.pressed': "_bfhk1r4b",
    'color.background.danger.bold': "_bfhkybec",
    'color.background.danger.bold.hovered': "_bfhks9hg",
    'color.background.danger.bold.pressed': "_bfhk13a9",
    'color.background.warning': "_bfhk1917",
    'color.background.warning.hovered': "_bfhk19zu",
    'color.background.warning.pressed': "_bfhkzr32",
    'color.background.warning.bold': "_bfhk1kmu",
    'color.background.warning.bold.hovered': "_bfhk1spp",
    'color.background.warning.bold.pressed': "_bfhk4m4m",
    'color.background.success': "_bfhk1y9u",
    'color.background.success.hovered': "_bfhk1vfx",
    'color.background.success.pressed': "_bfhk1wl5",
    'color.background.success.bold': "_bfhkkcmj",
    'color.background.success.bold.hovered': "_bfhky7x8",
    'color.background.success.bold.pressed': "_bfhkwcbh",
    'color.background.discovery': "_bfhk6vm6",
    'color.background.discovery.hovered': "_bfhk12eq",
    'color.background.discovery.pressed': "_bfhk18vq",
    'color.background.discovery.bold': "_bfhku5tj",
    'color.background.discovery.bold.hovered': "_bfhkfqeg",
    'color.background.discovery.bold.pressed': "_bfhk1f1m",
    'color.background.information': "_bfhk19ip",
    'color.background.information.hovered': "_bfhk86z5",
    'color.background.information.pressed': "_bfhk1c1j",
    'color.background.information.bold': "_bfhkx4w0",
    'color.background.information.bold.hovered': "_bfhkq2ii",
    'color.background.information.bold.pressed': "_bfhkf89v",
    'color.blanket': "_bfhk1i5c",
    'color.blanket.selected': "_bfhk7wq0",
    'color.blanket.danger': "_bfhkrprw",
    'color.skeleton': "_bfhkizff",
    'color.skeleton.subtle': "_bfhkvkf5",
    'elevation.surface': "_bfhkvuon",
    'elevation.surface.hovered': "_bfhk19i6",
    'elevation.surface.pressed': "_bfhk13ro",
    'elevation.surface.overlay': "_bfhk1bhr",
    'elevation.surface.overlay.hovered': "_bfhk6o2t",
    'elevation.surface.overlay.pressed': "_bfhkm8nx",
    'elevation.surface.raised': "_bfhkhp5a",
    'elevation.surface.raised.hovered': "_bfhk116u",
    'elevation.surface.raised.pressed': "_bfhk14aj",
    'elevation.surface.sunken': "_bfhkhfxm",
    'utility.elevation.surface.current': "_bfhkchd4"
};
var $486e85222e48a5c3$var$CURRENT_SURFACE_CSS_VAR = "--ds-elevation-surface-current";
var $486e85222e48a5c3$var$setSurfaceTokenMap = {
    'elevation.surface': "_1q1lvuon",
    'elevation.surface.hovered': "_1q1l19i6",
    'elevation.surface.pressed': "_1q1l13ro",
    'elevation.surface.overlay': "_1q1l1bhr",
    'elevation.surface.overlay.hovered': "_1q1l6o2t",
    'elevation.surface.overlay.pressed': "_1q1lm8nx",
    'elevation.surface.raised': "_1q1lhp5a",
    'elevation.surface.raised.hovered': "_1q1l116u",
    'elevation.surface.raised.pressed': "_1q1l14aj",
    'elevation.surface.sunken': "_1q1lhfxm"
};
var $486e85222e48a5c3$var$paddingBlockStartMap = {
    'space.0': "_1q51ze3t",
    'space.025': "_1q51v77o",
    'space.050': "_1q511b66",
    'space.075': "_1q5112x7",
    'space.100': "_1q51u2gc",
    'space.150': "_1q51utpp",
    'space.200': "_1q51pxbi",
    'space.250': "_1q51v47k",
    'space.300': "_1q511ejb",
    'space.400': "_1q51xy5q",
    'space.500': "_1q511jfw",
    'space.600': "_1q51oahv",
    'space.800': "_1q51xncg",
    'space.1000': "_1q511epz"
};
var $486e85222e48a5c3$var$paddingBlockEndMap = {
    'space.0': "_85i5ze3t",
    'space.025': "_85i5v77o",
    'space.050': "_85i51b66",
    'space.075': "_85i512x7",
    'space.100': "_85i5u2gc",
    'space.150': "_85i5utpp",
    'space.200': "_85i5pxbi",
    'space.250': "_85i5v47k",
    'space.300': "_85i51ejb",
    'space.400': "_85i5xy5q",
    'space.500': "_85i51jfw",
    'space.600': "_85i5oahv",
    'space.800': "_85i5xncg",
    'space.1000': "_85i51epz"
};
var $486e85222e48a5c3$var$paddingInlineStartMap = {
    'space.0': "_bozgze3t",
    'space.025': "_bozgv77o",
    'space.050': "_bozg1b66",
    'space.075': "_bozg12x7",
    'space.100': "_bozgu2gc",
    'space.150': "_bozgutpp",
    'space.200': "_bozgpxbi",
    'space.250': "_bozgv47k",
    'space.300': "_bozg1ejb",
    'space.400': "_bozgxy5q",
    'space.500': "_bozg1jfw",
    'space.600': "_bozgoahv",
    'space.800': "_bozgxncg",
    'space.1000': "_bozg1epz"
};
var $486e85222e48a5c3$var$paddingInlineEndMap = {
    'space.0': "_y4tize3t",
    'space.025': "_y4tiv77o",
    'space.050': "_y4ti1b66",
    'space.075': "_y4ti12x7",
    'space.100': "_y4tiu2gc",
    'space.150': "_y4tiutpp",
    'space.200': "_y4tipxbi",
    'space.250': "_y4tiv47k",
    'space.300': "_y4ti1ejb",
    'space.400': "_y4tixy5q",
    'space.500': "_y4ti1jfw",
    'space.600': "_y4tioahv",
    'space.800': "_y4tixncg",
    'space.1000': "_y4ti1epz"
};
var $486e85222e48a5c3$export$e71c4d32a2263218 = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? 'div' : _ref$as, children = _ref.children, backgroundColor = _ref.backgroundColor, padding = _ref.padding, _ref$paddingBlock = _ref.paddingBlock, paddingBlock = _ref$paddingBlock === void 0 ? padding : _ref$paddingBlock, _ref$paddingBlockStar = _ref.paddingBlockStart, paddingBlockStart = _ref$paddingBlockStar === void 0 ? paddingBlock : _ref$paddingBlockStar, _ref$paddingBlockEnd = _ref.paddingBlockEnd, paddingBlockEnd = _ref$paddingBlockEnd === void 0 ? paddingBlock : _ref$paddingBlockEnd, _ref$paddingInline = _ref.paddingInline, paddingInline = _ref$paddingInline === void 0 ? padding : _ref$paddingInline, _ref$paddingInlineSta = _ref.paddingInlineStart, paddingInlineStart = _ref$paddingInlineSta === void 0 ? paddingInline : _ref$paddingInlineSta, _ref$paddingInlineEnd = _ref.paddingInlineEnd, paddingInlineEnd = _ref$paddingInlineEnd === void 0 ? paddingInline : _ref$paddingInlineEnd, style = _ref.style, testId = _ref.testId, xcss = _ref.xcss, htmlAttributes = (0, $e1dadfc9c3d2f1bd$export$2e2bcd8739ae039)(_ref, $486e85222e48a5c3$var$_excluded);
    // This is to remove className from safeHtmlAttributes
    // @ts-ignore -- not using expect since it causes issues with help-center local consumption - className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    var _spreadClass = htmlAttributes.className, safeHtmlAttributes = (0, $e1dadfc9c3d2f1bd$export$2e2bcd8739ae039)(htmlAttributes, $486e85222e48a5c3$var$_excluded2);
    var node = /*#__PURE__*/ $5FkrB.createElement(Component, (0, $a22d338ce3923cba$export$2e2bcd8739ae039)({
        style: style,
        ref: ref,
        className: (0, $2efec74f5f421835$export$2e2bcd8739ae039)([
            "_19itglyw _vchhusvi _r06hglyw",
            backgroundColor && $486e85222e48a5c3$var$backgroundColorMap[backgroundColor],
            backgroundColor && $486e85222e48a5c3$var$isSurfaceToken(backgroundColor) && $486e85222e48a5c3$var$setSurfaceTokenMap[backgroundColor],
            paddingBlockStart && $486e85222e48a5c3$var$paddingBlockStartMap[paddingBlockStart],
            paddingBlockEnd && $486e85222e48a5c3$var$paddingBlockEndMap[paddingBlockEnd],
            paddingInlineStart && $486e85222e48a5c3$var$paddingInlineStartMap[paddingInlineStart],
            paddingInlineEnd && $486e85222e48a5c3$var$paddingInlineEndMap[paddingInlineEnd],
            xcss
        ])
    }, safeHtmlAttributes, {
        "data-testid": testId
    }), children);
    if (backgroundColor) return /*#__PURE__*/ $5FkrB.createElement((0, $5b9f730e423c70ca$export$1ca2a26fecb070ae).Provider, {
        value: backgroundColor
    }, node);
    return node;
});
function $486e85222e48a5c3$var$isSurfaceToken(backgroundColor) {
    return backgroundColor in $486e85222e48a5c3$var$setSurfaceTokenMap;
}


var $64e95b69a05329e9$var$_excluded = [
    "children",
    "testId",
    "appearance",
    "newWindowLabel",
    "target",
    "className",
    "style"
];
var $64e95b69a05329e9$var$styles = {
    base: "_ect4ttxp",
    baseT26Shape: "_2rkolb4i",
    visitedLink: "_10531ra0 _1ien1ra0 _n0fx1ra0 _1vhv17z1",
    defaultAppearance: "_4bfu1r31 _1hms8stv _ajmmnqa1 _syaz13af _1a3b1r31 _4fpr8stv _5goinqa1 _f8pj13af _9oik1r31 _1bnxglyw _jf4cnqa1 _30l313af _1nrm1r31 _c2waglyw _1iohnqa1 _9h8h12zz",
    defaultAppearanceMotion: "_4bfu1r31 _1hms8stv _ajmmnqa1 _v564hxmd _syaz13af _1a3b1r31 _4fpr8stv _5goinqa1 _f8pj13af _9oik1j28 _1bnx8stv _jf4cnqa1 _o7kshxmd _30l313af _1nrm1j28 _c2wa8stv _1iohnqa1 _1ggl87vo _9h8h12zz",
    subtleAppearance: "_4bfu1r31 _1hmsglyw _ajmmnqa1 _syazazsu _1a3b1r31 _4fprglyw _5goinqa1 _f8pjazsu _9oik1r31 _1bnx8stv _jf4cnqa1 _30l3azsu _1nrm1r31 _c2wa8stv _1iohnqa1 _9h8hi7uo",
    subtleAppearanceMotion: "_4bfu1j28 _1hms8stv _ajmmnqa1 _v564hxmd _syazazsu _1a3b1j28 _4fpr8stv _5goinqa1 _f8pjazsu _9oik1r31 _1bnx8stv _jf4cnqa1 _o7kshxmd _30l3azsu _1nrm1r31 _c2wa8stv _1iohnqa1 _1ggl87vo _9h8hi7uo",
    inverseAppearance: "_4bfu1r31 _1hms8stv _ajmmnqa1 _syaz15cr _105315cr _1a3b1r31 _4fpr8stv _5goinqa1 _f8pj15cr _9oik1r31 _1bnxglyw _jf4cnqa1 _30l315cr _1nrm1r31 _c2waglyw _1iohnqa1 _9h8h15cr",
    inverseAppearanceMotion: "_4bfu1r31 _1hms8stv _ajmmnqa1 _v564hxmd _syaz15cr _105315cr _1a3b1r31 _4fpr8stv _5goinqa1 _f8pj15cr _9oik1j28 _1bnx8stv _jf4cnqa1 _o7kshxmd _30l315cr _1nrm1j28 _c2wa8stv _1iohnqa1 _1ggl87vo _9h8h15cr",
    iconWrapper: "_1e0c1nu9 _o5721q9c _s7n41q9y _kqswh2mm _152ttb3r"
};
var $64e95b69a05329e9$var$iconStyles = null;
var $64e95b69a05329e9$var$LinkWithoutRef = function LinkWithoutRef(_ref, ref) {
    var children = _ref.children, testId = _ref.testId, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'default' : _ref$appearance, newWindowLabel = _ref.newWindowLabel, target = _ref.target, _preventedClassName = _ref.className, _preventedStyle = _ref.style, htmlAttributes = (0, $e1dadfc9c3d2f1bd$export$2e2bcd8739ae039)(_ref, $64e95b69a05329e9$var$_excluded);
    return /*#__PURE__*/ $5FkrB.createElement((0, $8ad8e55618b90d53$export$b688253958b8dfe7), (0, $a22d338ce3923cba$export$2e2bcd8739ae039)({}, htmlAttributes, {
        target: target,
        ref: ref,
        xcss: (0, $f5394890a4af8edf$export$a274e22fb40f762e)($64e95b69a05329e9$var$styles.base, (0, $b4741ae2f346a6af$export$b40ec24ac8275656)('platform-dst-shape-theme-default') && $64e95b69a05329e9$var$styles.baseT26Shape, appearance === 'default' && ((0, $b4741ae2f346a6af$export$b40ec24ac8275656)('platform-dst-motion-uplift-list-item') ? $64e95b69a05329e9$var$styles.defaultAppearanceMotion : $64e95b69a05329e9$var$styles.defaultAppearance), appearance === 'subtle' && ((0, $b4741ae2f346a6af$export$b40ec24ac8275656)('platform-dst-motion-uplift-list-item') ? $64e95b69a05329e9$var$styles.subtleAppearanceMotion : $64e95b69a05329e9$var$styles.subtleAppearance), appearance === 'inverse' && ((0, $b4741ae2f346a6af$export$b40ec24ac8275656)('platform-dst-motion-uplift-list-item') ? $64e95b69a05329e9$var$styles.inverseAppearanceMotion : $64e95b69a05329e9$var$styles.inverseAppearance), // Visited styles are not supported for inverse links due to contrast issues
        appearance !== 'inverse' && $64e95b69a05329e9$var$styles.visitedLink),
        testId: testId,
        componentName: "Link",
        newWindowLabel: newWindowLabel
    }), children, target === '_blank' && /*#__PURE__*/ $5FkrB.createElement((0, $486e85222e48a5c3$export$e71c4d32a2263218), {
        as: "span",
        xcss: $64e95b69a05329e9$var$styles.iconWrapper,
        testId: testId && "".concat(testId, "__icon")
    }, "\uFEFF", /*#__PURE__*/ $5FkrB.createElement("svg", {
        width: "12",
        height: "12",
        viewBox: "0 0 12 12",
        fill: "none",
        className: (0, $2efec74f5f421835$export$2e2bcd8739ae039)([
            "_1bsbgm0b _4t3igm0b _ahbqzjw7"
        ])
    }, /*#__PURE__*/ $5FkrB.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M0 1.82609C0 0.817938 0.817938 0 1.82609 0H3.91304V1.04348H1.82609C1.39424 1.04348 1.04348 1.39424 1.04348 1.82609V10.1739C1.04348 10.6058 1.39424 10.9565 1.82609 10.9565H10.1739C10.6058 10.9565 10.9565 10.6058 10.9565 10.1739V8.08696H12V10.1739C12 11.1821 11.1821 12 10.1739 12H1.82609C0.817938 12 0 11.1821 0 10.1739V1.82609ZM7.04348 0H12V4.95652H10.9565V1.78133L6.36893 6.36893L5.63107 5.63107L10.2187 1.04348H7.04348V0Z",
        fill: "currentColor"
    }))));
};
// Workarounds to support generic types with forwardRef
/**
 * __Link__
 *
 * A link is an inline text element that navigates to a new location when clicked.
 *
 * - [Examples](https://atlassian.design/components/primitives/link/examples)
 * - [Code](https://atlassian.design/components/primitives/link/code)
 * - [Usage](https://atlassian.design/components/primitives/link/usage)
 */ var $64e95b69a05329e9$var$Link = /*#__PURE__*/ (0, $5FkrB.forwardRef)($64e95b69a05329e9$var$LinkWithoutRef);
var $64e95b69a05329e9$export$2e2bcd8739ae039 = $64e95b69a05329e9$var$Link;


var $b100bedb1ab111a8$var$skipLinkListItemStyles = (0, $2nBsU.css)({
    marginBlockStart: 0
});
var $b100bedb1ab111a8$var$focusTargetRef = function focusTargetRef(href) {
    return function(event) {
        event.preventDefault();
        var targetRef = document.querySelector(href);
        // eslint-disable-next-line @atlaskit/platform/no-direct-document-usage
        // @ts-ignore
        var key = event.which || event.keycode;
        // if it is a keypress and the key is not
        // space or enter, just ignore it.
        if (key && key !== 13 && key !== 32) return;
        if (targetRef) {
            targetRef.setAttribute('tabindex', '-1');
            // @ts-ignore
            targetRef.addEventListener('blur', handleBlur);
            // @ts-ignore
            targetRef.focus();
            document.activeElement && document.activeElement.scrollIntoView({
                // eslint-disable-next-line @atlaskit/platform/no-direct-document-usage
                behavior: 'smooth'
            });
            window.scrollTo(0, 0);
        }
        return false;
    };
};
var $b100bedb1ab111a8$export$ef95c37428582a65 = function SkipLink(_ref) {
    var href = _ref.href, children = _ref.children, isFocusable = _ref.isFocusable;
    return (0, $2nBsU.jsx)("li", {
        css: $b100bedb1ab111a8$var$skipLinkListItemStyles
    }, (0, $2nBsU.jsx)((0, $64e95b69a05329e9$export$2e2bcd8739ae039), {
        tabIndex: isFocusable ? 0 : -1,
        href: href,
        onClick: $b100bedb1ab111a8$var$focusTargetRef(href)
    }, children));
};


function $9e448eccb1d940c3$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $9e448eccb1d940c3$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $9e448eccb1d940c3$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $75c03925a1a6ef46$export$2e2bcd8739ae039)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $9e448eccb1d940c3$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
var $9e448eccb1d940c3$var$prefersReducedMotionStyles = (0, $2nBsU.css)((0, $c388794be4d106d9$export$ff7706047246b98b)());
var $9e448eccb1d940c3$var$skipLinkStyles = (0, $2nBsU.css)({
    margin: "var(--ds-space-250, 20px)",
    padding: '0.8rem 1rem',
    position: 'fixed',
    zIndex: -1,
    backgroundColor: "var(--ds-surface-overlay, #FFFFFF)",
    border: 'none',
    borderRadius: "var(--ds-radius-small, 3px)",
    boxShadow: "var(--ds-shadow-overlay, 0px 8px 12px #1E1F2126, 0px 0px 1px #1E1F214f)",
    insetInlineStart: -999999,
    opacity: 0,
    transform: 'translateY(-50%)',
    transition: "transform 0.3s ".concat((0, $6a30af0ce01ddfc7$export$57636bb43b1ccbb0)),
    '&:focus-within': {
        zIndex: 2147483640,
        insetInlineStart: 0,
        opacity: 1,
        transform: 'translateY(0%)'
    }
});
var $9e448eccb1d940c3$var$skipLinkHeadingStyles = (0, $2nBsU.css)({
    fontWeight: "var(--ds-font-weight-semibold, 600)"
});
var $9e448eccb1d940c3$var$skipLinkListStyles = (0, $2nBsU.css)({
    listStylePosition: 'outside',
    listStyleType: 'none',
    marginBlockStart: "var(--ds-space-050, 4px)",
    paddingInlineStart: 0
});
var $9e448eccb1d940c3$var$_assignIndex = function assignIndex(num, arr) {
    if (!arr.includes(num)) return num;
    return $9e448eccb1d940c3$var$_assignIndex(num + 1, arr);
};
var $9e448eccb1d940c3$export$4241a460557ba901 = function SkipLinkWrapper(_ref) {
    var skipLinksLabel = _ref.skipLinksLabel;
    var _useSkipLinks = (0, $a56aa16f16be206c$export$c9d9cb2ee9590f87)(), skipLinksData = _useSkipLinks.skipLinksData;
    if (skipLinksData.length === 0) return null;
    var sortSkipLinks = function sortSkipLinks(arr) {
        var customLinks = arr.filter(function(link) {
            return Number.isInteger(link.listIndex);
        });
        if (customLinks.length === 0) return arr;
        var usedIndexes = customLinks.map(function(a) {
            return a.listIndex;
        });
        var regularLinksWithIdx = arr.filter(function(link) {
            return link.listIndex === undefined;
        }).map(function(link, idx) {
            var listIndex = $9e448eccb1d940c3$var$_assignIndex(idx, usedIndexes);
            usedIndexes.push(listIndex);
            return $9e448eccb1d940c3$var$_objectSpread($9e448eccb1d940c3$var$_objectSpread({}, link), {}, {
                listIndex: listIndex
            });
        });
        return [].concat((0, $5c28c49a950f777f$export$2e2bcd8739ae039)(customLinks), (0, $5c28c49a950f777f$export$2e2bcd8739ae039)(regularLinksWithIdx)).sort(function(a, b) {
            return a.listIndex - b.listIndex;
        });
    };
    var escapeHandler = function escapeHandler(event) {
        if (event.keyCode === 27) {
            var container = document.querySelector("[".concat((0, $efd2be1bf5c3a2eb$export$659ee746b31b360d), "=\"true\"]") // eslint-disable-next-line @atlaskit/platform/no-direct-document-usage
            );
            if (container !== null) container.focus();
        }
    };
    var attachEscHandler = function attachEscHandler() {
        return window.addEventListener('keydown', escapeHandler, false);
    };
    var removeEscHandler = function removeEscHandler() {
        return window.removeEventListener('keydown', escapeHandler, false);
    };
    var emptyLabelOverride = !!(skipLinksLabel !== null && skipLinksLabel !== void 0 && skipLinksLabel.match(/^\s+$/));
    var label = skipLinksLabel || (0, $efd2be1bf5c3a2eb$export$206a08f7f8beb554);
    return (0, $2nBsU.jsx)("div", {
        onFocus: attachEscHandler,
        onBlur: removeEscHandler,
        css: [
            $9e448eccb1d940c3$var$skipLinkStyles,
            $9e448eccb1d940c3$var$prefersReducedMotionStyles
        ],
        "data-skip-link-wrapper": true
    }, emptyLabelOverride ? null : (0, $2nBsU.jsx)("p", {
        css: $9e448eccb1d940c3$var$skipLinkHeadingStyles
    }, label), (0, $2nBsU.jsx)("ol", {
        css: $9e448eccb1d940c3$var$skipLinkListStyles
    }, sortSkipLinks(skipLinksData).map(function(_ref2) {
        var id = _ref2.id, skipLinkTitle = _ref2.skipLinkTitle;
        return (0, $2nBsU.jsx)((0, $b100bedb1ab111a8$export$ef95c37428582a65), {
            key: id,
            href: "#".concat(id),
            isFocusable: true
        }, skipLinkTitle);
    })));
};



var $3ZMUU = parcelRequire("3ZMUU");
var $b550a1f730f79a9b$var$pageLayoutSelector = (0, $75c03925a1a6ef46$export$2e2bcd8739ae039)({}, (0, $efd2be1bf5c3a2eb$export$659ee746b31b360d), true);
var $b550a1f730f79a9b$var$gridTemplateAreasMobile = "\n".concat("\n  \"", (0, $efd2be1bf5c3a2eb$export$344062f7cfc9528e), " ").concat((0, $efd2be1bf5c3a2eb$export$238d30785c4bca84), "\"\n  ", "\n  \"").concat((0, $efd2be1bf5c3a2eb$export$344062f7cfc9528e), " ").concat((0, $efd2be1bf5c3a2eb$export$bec6dca2e63de4ae), "\"\n  ", "\n  \"").concat((0, $efd2be1bf5c3a2eb$export$344062f7cfc9528e), " ").concat((0, $efd2be1bf5c3a2eb$export$d1213e82613ff4df), "\"\n ");
var $b550a1f730f79a9b$var$gridTemplateAreas = "\n".concat("\n  \"", (0, $efd2be1bf5c3a2eb$export$344062f7cfc9528e), " ").concat((0, $efd2be1bf5c3a2eb$export$238d30785c4bca84), " ").concat((0, $efd2be1bf5c3a2eb$export$c7139cc2d6110b5f), "\"\n  ", "\n  \"").concat((0, $efd2be1bf5c3a2eb$export$344062f7cfc9528e), " ").concat((0, $efd2be1bf5c3a2eb$export$bec6dca2e63de4ae), " ").concat((0, $efd2be1bf5c3a2eb$export$c7139cc2d6110b5f), "\"\n", "\n  \"").concat((0, $efd2be1bf5c3a2eb$export$344062f7cfc9528e), " ").concat((0, $efd2be1bf5c3a2eb$export$d1213e82613ff4df), " ").concat((0, $efd2be1bf5c3a2eb$export$c7139cc2d6110b5f), "\"\n ");
var $b550a1f730f79a9b$var$gridStyles = (0, $2nBsU.css)({
    display: 'grid',
    height: '100%',
    gridTemplateAreas: $b550a1f730f79a9b$var$gridTemplateAreas,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    gridTemplateColumns: "".concat((0, $efd2be1bf5c3a2eb$export$f963aecf2d4465bd), " minmax(0, 1fr) ").concat((0, $efd2be1bf5c3a2eb$export$750459958906793)),
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    gridTemplateRows: "".concat((0, $efd2be1bf5c3a2eb$export$ed7cc0d417ee89e), " ").concat((0, $efd2be1bf5c3a2eb$export$aeff86a16f13529), " auto"),
    outline: 'none'
});
var $b550a1f730f79a9b$var$gridStylesMobileStyles = (0, $2nBsU.css)((0, $75c03925a1a6ef46$export$2e2bcd8739ae039)({}, (0, $92693c60dc1696c3$export$c881183ca713c214).below.sm, {
    gridTemplateAreas: $b550a1f730f79a9b$var$gridTemplateAreasMobile,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    gridTemplateColumns: "".concat((0, $efd2be1bf5c3a2eb$export$f963aecf2d4465bd), " minmax(0, 1fr)")
}));
/**
 * __Page layout__
 *
 * A collection of components which let you compose an application's page layout.
 *
 * - [Examples](https://atlassian.design/components/page-layout/examples)
 * - [Code](https://atlassian.design/components/page-layout/code)
 *
 * @deprecated `@atlaskit/page-layout` is deprecated. Use `@atlaskit/navigation-system` instead.
 */ var $b550a1f730f79a9b$var$PageLayout = function PageLayout(_ref) {
    var _ref$skipLinksLabel = _ref.skipLinksLabel, skipLinksLabel = _ref$skipLinksLabel === void 0 ? (0, $efd2be1bf5c3a2eb$export$206a08f7f8beb554) : _ref$skipLinksLabel, children = _ref.children, testId = _ref.testId, onLeftSidebarExpand = _ref.onLeftSidebarExpand, onLeftSidebarCollapse = _ref.onLeftSidebarCollapse;
    typeof $3ZMUU;
    return (0, $2nBsU.jsx)((0, $5FkrB.Fragment), null, (0, $2nBsU.jsx)((0, $dfad1c2e53161c67$export$da7be99d6a868f3d), null, (0, $2nBsU.jsx)((0, $9e448eccb1d940c3$export$4241a460557ba901), {
        skipLinksLabel: skipLinksLabel
    }), (0, $2nBsU.jsx)("div", (0, $b65104b70faead20$export$2e2bcd8739ae039)({}, $b550a1f730f79a9b$var$pageLayoutSelector, {
        "data-testid": testId,
        css: [
            $b550a1f730f79a9b$var$gridStyles,
            $b550a1f730f79a9b$var$gridStylesMobileStyles
        ],
        tabIndex: -1,
        "data-vc": "page-layout"
    }), (0, $2nBsU.jsx)((0, $4bf072c5e52065f0$export$850bd1bba41f1448), {
        onLeftSidebarCollapse: onLeftSidebarCollapse,
        onLeftSidebarExpand: onLeftSidebarExpand
    }, children))));
};
var $b550a1f730f79a9b$export$2e2bcd8739ae039 = $b550a1f730f79a9b$var$PageLayout;



var $lMtwZ = parcelRequire("lMtwZ");
function $88a75703cd62f79d$var$asyncGeneratorStep(n, t, e, r, o, a, c) {
    try {
        var i = n[a](c), u = i.value;
    } catch (n) {
        return void e(n);
    }
    i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function $88a75703cd62f79d$export$2e2bcd8739ae039(n) {
    return function() {
        var t = this, e = arguments;
        return new Promise(function(r, o) {
            var a = n.apply(t, e);
            function _next(n) {
                $88a75703cd62f79d$var$asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
            }
            function _throw(n) {
                $88a75703cd62f79d$var$asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
            }
            _next(void 0);
        });
    };
}


var $f410d35d96337f35$exports = {};
// TODO(Babel 8): Remove this file.

var $f410d35d96337f35$var$runtime = (parcelRequire("9KzpK"))();
$f410d35d96337f35$exports = $f410d35d96337f35$var$runtime;
// Copied from https://github.com/facebook/regenerator/blob/main/packages/runtime/runtime.js#L736=
try {
    regeneratorRuntime = $f410d35d96337f35$var$runtime;
} catch (accidentalStrictMode) {
    if (typeof globalThis === "object") globalThis.regeneratorRuntime = $f410d35d96337f35$var$runtime;
    else Function("r", "regeneratorRuntime = r")($f410d35d96337f35$var$runtime);
}



var $50U6m = parcelRequire("50U6m");

var $lMtwZ = parcelRequire("lMtwZ");

var $9AP5g = parcelRequire("9AP5g");
/**
 * Theme modes: The general purpose of a theme.
 * This attr is used to apply the appropriate system-preference option
 * It may also be used as a selector for mode-specific overrides such as light/dark images.
 * The idea is there may exist many color themes, but every theme must either fit into light or dark.
 */ var $827de745ceff3d4d$export$83993de8eb66733 = [
    'light',
    'dark',
    'auto'
];


var $5ed4064b4ac2aa3f$export$fcfb1976c88f9f75 = function isThemeColorMode(colorMode) {
    return (0, $827de745ceff3d4d$export$83993de8eb66733).find(function(mode) {
        return mode === colorMode;
    }) !== undefined;
};



var $jAELq = parcelRequire("jAELq");
var $b22e0f4bd02ee9bc$export$4a14e169b1de4ee7 = function isColorMode(modeId) {
    return [
        'light',
        'dark',
        'auto'
    ].includes(modeId);
};


/**
 * Theme ids: The value that will be mounted to the DOM as a data attr
 * For example: `data-theme="light:light dark:dark spacing:spacing"
 *
 * These ids must be kebab case
 */ var $f5cca04043e97ccd$export$7d43e72a58e3283f = [
    'light-increased-contrast',
    'light',
    'light-future',
    'dark',
    'dark-future',
    'dark-increased-contrast',
    'spacing',
    'shape',
    'typography',
    'motion'
];


var $cfe97e314278c305$export$ea35b8958c39dd07 = function isThemeIds(themeId) {
    return (0, $f5cca04043e97ccd$export$7d43e72a58e3283f).find(function(id) {
        return id === themeId;
    }) !== undefined;
};


var $0c5f0bb7a775b02f$var$themeKinds = [
    'light',
    'dark',
    'spacing',
    'typography',
    'shape',
    'motion'
];
var $0c5f0bb7a775b02f$export$958fa026be3a263e = function isThemeKind(themeKind) {
    return $0c5f0bb7a775b02f$var$themeKinds.find(function(kind) {
        return kind === themeKind;
    }) !== undefined;
};


var $ec6249de1b2286f1$var$customThemeOptions = 'UNSAFE_themeOptions';
var $ec6249de1b2286f1$export$f19b488f7c0547ee = function themeStringToObject(themeState) {
    return themeState.split(' ').map(function(theme) {
        return theme.split(/:([^]*)/);
    }).reduce(function(themeObject, _ref) {
        var _ref2 = (0, $jAELq.default)(_ref, 2), kind = _ref2[0], id = _ref2[1];
        if (kind === 'colorMode' && (0, $b22e0f4bd02ee9bc$export$4a14e169b1de4ee7)(id)) themeObject[kind] = id;
        if ((0, $0c5f0bb7a775b02f$export$958fa026be3a263e)(kind) && (0, $cfe97e314278c305$export$ea35b8958c39dd07)(id)) // @ts-expect-error FIXME - this is a valid ts error
        themeObject[kind] = id;
        if (kind === $ec6249de1b2286f1$var$customThemeOptions) try {
            themeObject[$ec6249de1b2286f1$var$customThemeOptions] = JSON.parse(id);
        } catch (_unused) {
            new Error('Invalid custom theme string');
        }
        return themeObject;
    }, {});
};


function $9f556f5b50981903$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $9f556f5b50981903$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $9f556f5b50981903$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $lMtwZ.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $9f556f5b50981903$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $9f556f5b50981903$export$813ecdf77207a053 = function getGlobalTheme() {
    if (typeof document === 'undefined') return {};
    var element = document.documentElement;
    var colorMode = element.getAttribute((0, $9AP5g.COLOR_MODE_ATTRIBUTE)) || '';
    var theme = element.getAttribute((0, $9AP5g.THEME_DATA_ATTRIBUTE)) || '';
    return $9f556f5b50981903$var$_objectSpread($9f556f5b50981903$var$_objectSpread({}, (0, $ec6249de1b2286f1$export$f19b488f7c0547ee)(theme)), (0, $5ed4064b4ac2aa3f$export$fcfb1976c88f9f75)(colorMode) && {
        colorMode: colorMode
    });
};



var $6lN5g = parcelRequire("6lN5g");

var $jAELq = parcelRequire("jAELq");

var $50U6m = parcelRequire("50U6m");

var $lMtwZ = parcelRequire("lMtwZ");

var $50U6m = parcelRequire("50U6m");

var $9AP5g = parcelRequire("9AP5g");

var $6lN5g = parcelRequire("6lN5g");

var $kZkio = parcelRequire("kZkio");

var $jAELq = parcelRequire("jAELq");



var $a4582ab93641fdfd$var$customThemeOptions = 'UNSAFE_themeOptions';
var $a4582ab93641fdfd$export$62c37ab81302621a = function themeObjectToString(themeState) {
    return Object.entries(themeState).reduce(function(themeString, _ref) {
        var _ref2 = (0, $jAELq.default)(_ref, 2), kind = _ref2[0], id = _ref2[1];
        if (// colorMode theme state
        kind === 'colorMode' && typeof id === 'string' && (0, $b22e0f4bd02ee9bc$export$4a14e169b1de4ee7)(id) || // custom theme state
        kind === $a4582ab93641fdfd$var$customThemeOptions && (0, $kZkio.default)(id) === 'object' || // other theme states
        (0, $0c5f0bb7a775b02f$export$958fa026be3a263e)(kind) && typeof id === 'string' && (0, $cfe97e314278c305$export$ea35b8958c39dd07)(id)) return themeString + "".concat(themeString ? ' ' : '') + "".concat(kind, ":").concat((0, $kZkio.default)(id) === 'object' ? JSON.stringify(id) : id);
        return themeString;
    }, '');
};



var $3ENxc = parcelRequire("3ENxc");
var $4834b5af4fbc0ef8$export$53031ac1ecb71f44 = function isValidBrandHex(hex) {
    return /^#[0-9A-F]{6}$/i.test(hex);
};


function $ec4eb29d91d718cb$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $ec4eb29d91d718cb$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $ec4eb29d91d718cb$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $lMtwZ.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $ec4eb29d91d718cb$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $ec4eb29d91d718cb$var$defaultColorMode = 'light';
var $ec4eb29d91d718cb$var$defaultContrastMode = 'no-preference';
var $ec4eb29d91d718cb$export$e1f80cb7a749802f = function getThemeHtmlAttrs() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, _ref$colorMode = _ref.colorMode, colorMode = _ref$colorMode === void 0 ? (0, $6lN5g.themeStateDefaults)['colorMode'] : _ref$colorMode, _ref$dark = _ref.dark, dark = _ref$dark === void 0 ? (0, $6lN5g.themeStateDefaults)['dark'] : _ref$dark, _ref$light = _ref.light, light = _ref$light === void 0 ? (0, $6lN5g.themeStateDefaults)['light'] : _ref$light, _ref$contrastMode = _ref.contrastMode, contrastMode = _ref$contrastMode === void 0 ? (0, $6lN5g.themeStateDefaults)['contrastMode'] : _ref$contrastMode, _ref$motion = _ref.motion, motion = _ref$motion === void 0 ? (0, $6lN5g.themeStateDefaults)['motion']() : _ref$motion, _ref$shape = _ref.shape, shape = _ref$shape === void 0 ? (0, $6lN5g.themeStateDefaults)['shape']() : _ref$shape, _ref$spacing = _ref.spacing, spacing = _ref$spacing === void 0 ? (0, $6lN5g.themeStateDefaults)['spacing'] : _ref$spacing, _ref$typography = _ref.typography, typography = _ref$typography === void 0 ? (0, $6lN5g.themeStateDefaults)['typography'] : _ref$typography, _ref$UNSAFE_themeOpti = _ref.UNSAFE_themeOptions, UNSAFE_themeOptions = _ref$UNSAFE_themeOpti === void 0 ? (0, $6lN5g.themeStateDefaults)['UNSAFE_themeOptions'] : _ref$UNSAFE_themeOpti;
    var themeAttribute = (0, $a4582ab93641fdfd$export$62c37ab81302621a)({
        dark: dark,
        light: light,
        motion: motion,
        shape: shape,
        spacing: spacing,
        typography: typography
    });
    var result = (0, $lMtwZ.default)((0, $lMtwZ.default)({}, (0, $9AP5g.THEME_DATA_ATTRIBUTE), themeAttribute), (0, $9AP5g.COLOR_MODE_ATTRIBUTE), colorMode === 'auto' ? $ec4eb29d91d718cb$var$defaultColorMode : colorMode);
    if ((0, $50U6m.fg)('platform_increased-contrast-themes')) result = $ec4eb29d91d718cb$var$_objectSpread($ec4eb29d91d718cb$var$_objectSpread({}, result), {}, (0, $lMtwZ.default)({}, (0, $9AP5g.CONTRAST_MODE_ATTRIBUTE), contrastMode === 'auto' ? $ec4eb29d91d718cb$var$defaultContrastMode : contrastMode));
    if (UNSAFE_themeOptions && (0, $4834b5af4fbc0ef8$export$53031ac1ecb71f44)(UNSAFE_themeOptions.brandColor)) {
        var optionString = JSON.stringify(UNSAFE_themeOptions);
        var uniqueId = (0, $3ENxc.hash)(optionString);
        result[0, $9AP5g.CUSTOM_THEME_ATTRIBUTE] = uniqueId;
    }
    return result;
};
var $ec4eb29d91d718cb$export$2e2bcd8739ae039 = $ec4eb29d91d718cb$export$e1f80cb7a749802f;



var $eoPms = parcelRequire("eoPms");

var $eyhZN = parcelRequire("eyhZN");

var $lMtwZ = parcelRequire("lMtwZ");


var $9AP5g = parcelRequire("9AP5g");



var $9AP5g = parcelRequire("9AP5g");


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 *
 * This file contains a dynamic import for each theme this package exports.
 * Themes are loaded asynchronously at runtime to minimise the amount of CSS we send to the client.
 * This allows users to compose their themes and only use the tokens that are requested.
 * When a new theme is created, the import should automatically be added to the map
 *
 * @codegen <<SignedSource::3d041793de6aed48f20cb5e398199413>>
 * @codegenCommand yarn build tokens
 */ 














var $16ea0866e540b1ea$export$3a171c49f8c16356 = {
    'light': function light() {
        return (parcelRequire("bDSDt"));
    },
    'light-future': function lightFuture() {
        return (parcelRequire("8SV4m"));
    },
    'light-finesse': function lightFinesse() {
        return (parcelRequire("3sbKi"));
    },
    'light-increased-contrast-finesse': function lightIncreasedContrastFinesse() {
        return (parcelRequire("clWHD"));
    },
    'light-increased-contrast': function lightIncreasedContrast() {
        return (parcelRequire("10OzB"));
    },
    'dark': function dark() {
        return (parcelRequire("8Ul61"));
    },
    'dark-future': function darkFuture() {
        return (parcelRequire("fUMDb"));
    },
    'dark-finesse': function darkFinesse() {
        return (parcelRequire("fONlQ"));
    },
    'dark-increased-contrast-finesse': function darkIncreasedContrastFinesse() {
        return (parcelRequire("89bQV"));
    },
    'dark-increased-contrast': function darkIncreasedContrast() {
        return (parcelRequire("5r8Y4"));
    },
    'spacing': function spacing() {
        return (parcelRequire("9aLgs"));
    },
    'typography': function typography() {
        return (parcelRequire("b3HFs"));
    },
    'typography-finesse': function typographyFinesse() {
        return (parcelRequire("1VnnL"));
    },
    'shape': function shape() {
        return (parcelRequire("2BLfh"));
    },
    'motion': function motion() {
        return (parcelRequire("j7Ivm"));
    }
};
var $16ea0866e540b1ea$export$2e2bcd8739ae039 = $16ea0866e540b1ea$export$3a171c49f8c16356;


var $dec12687bb640dba$export$8a48286ed7df6720 = /*#__PURE__*/ function() {
    var _ref = (0, $88a75703cd62f79d$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($f410d35d96337f35$exports))).mark(function _callee(themeId) {
        var _yield$themeImportMap, themeCss;
        return (0, (/*@__PURE__*/$parcel$interopDefault($f410d35d96337f35$exports))).wrap(function(_context) {
            while(true)switch(_context.prev = _context.next){
                case 0:
                    _context.next = 1;
                    return (0, $16ea0866e540b1ea$export$2e2bcd8739ae039)[themeId]();
                case 1:
                    _yield$themeImportMap = _context.sent;
                    themeCss = _yield$themeImportMap.default;
                    return _context.abrupt("return", themeCss);
                case 2:
                case "end":
                    return _context.stop();
            }
        }, _callee);
    }));
    return function loadThemeCss(_x) {
        return _ref.apply(this, arguments);
    };
}();


var $e00715b6e459a098$export$26cd7ae85c7144e5 = /*#__PURE__*/ function() {
    var _ref = (0, $88a75703cd62f79d$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($f410d35d96337f35$exports))).mark(function _callee(themeId, preloadedThemeCss) {
        var themeCss, style, _t;
        return (0, (/*@__PURE__*/$parcel$interopDefault($f410d35d96337f35$exports))).wrap(function(_context) {
            while(true)switch(_context.prev = _context.next){
                case 0:
                    if (!document.head.querySelector("style[".concat((0, $9AP5g.THEME_DATA_ATTRIBUTE), "=\"").concat(themeId, "\"]:not([").concat((0, $9AP5g.CUSTOM_THEME_ATTRIBUTE), "])"))) {
                        _context.next = 1;
                        break;
                    }
                    return _context.abrupt("return");
                case 1:
                    if (themeId) {
                        _context.next = 2;
                        break;
                    }
                    return _context.abrupt("return");
                case 2:
                    if (!(preloadedThemeCss !== null && preloadedThemeCss !== void 0)) {
                        _context.next = 3;
                        break;
                    }
                    _t = preloadedThemeCss;
                    _context.next = 5;
                    break;
                case 3:
                    _context.next = 4;
                    return (0, $dec12687bb640dba$export$8a48286ed7df6720)(themeId);
                case 4:
                    _t = _context.sent;
                case 5:
                    themeCss = _t;
                    style = document.createElement('style');
                    style.textContent = themeCss;
                    style.dataset.theme = themeId;
                    document.head.appendChild(style);
                case 6:
                case "end":
                    return _context.stop();
            }
        }, _callee);
    }));
    return function loadAndAppendThemeCss(_x, _x2) {
        return _ref.apply(this, arguments);
    };
}();
var $e00715b6e459a098$export$bb1e815119d30f8b = '(prefers-color-scheme: dark)';
var $e00715b6e459a098$export$8662df6937d86fcb = '(prefers-contrast: more)';


var $983d5a90f967f7fe$var$isMatchMediaAvailable = typeof window !== 'undefined' && 'matchMedia' in window;
/**
 * Updates the current theme when the system theme changes. Should be bound
 * to an event listener listening on the '(prefers-color-scheme: dark)' query
 * @param e The event representing a change in system theme.
 */ function $983d5a90f967f7fe$var$checkNativeListener(e) {
    var element = document.documentElement;
    element.setAttribute((0, $9AP5g.COLOR_MODE_ATTRIBUTE), e.matches ? 'dark' : 'light');
}
var $983d5a90f967f7fe$var$darkModeMql = $983d5a90f967f7fe$var$isMatchMediaAvailable && window.matchMedia((0, $e00715b6e459a098$export$bb1e815119d30f8b));
var $983d5a90f967f7fe$var$ColorModeObserver = /*#__PURE__*/ function() {
    function ColorModeObserver() {
        (0, $eoPms.default)(this, ColorModeObserver);
        (0, $lMtwZ.default)(this, "unbindThemeChangeListener", null);
    }
    return (0, $eyhZN.default)(ColorModeObserver, [
        {
            key: "getColorMode",
            value: function getColorMode() {
                if (!$983d5a90f967f7fe$var$darkModeMql) return 'light';
                return $983d5a90f967f7fe$var$darkModeMql !== null && $983d5a90f967f7fe$var$darkModeMql !== void 0 && $983d5a90f967f7fe$var$darkModeMql.matches ? 'dark' : 'light';
            }
        },
        {
            key: "bind",
            value: function bind() {
                if ($983d5a90f967f7fe$var$darkModeMql && this.unbindThemeChangeListener === null) this.unbindThemeChangeListener = (0, $5b617c1f48263075$exports.bind)($983d5a90f967f7fe$var$darkModeMql, {
                    type: 'change',
                    listener: $983d5a90f967f7fe$var$checkNativeListener
                });
            }
        },
        {
            key: "unbind",
            value: function unbind() {
                if (this.unbindThemeChangeListener) {
                    this.unbindThemeChangeListener();
                    this.unbindThemeChangeListener = null;
                }
            }
        }
    ]);
}();
/**
 * A singleton color mode observer - binds "auto" switching logic to a single `mediaQueryList` listener
 * that can be unbound by any consumer when no longer needed.
 */ var $983d5a90f967f7fe$var$SingletonColorModeObserver = new $983d5a90f967f7fe$var$ColorModeObserver();
var $983d5a90f967f7fe$export$2e2bcd8739ae039 = $983d5a90f967f7fe$var$SingletonColorModeObserver;



var $eoPms = parcelRequire("eoPms");

var $eyhZN = parcelRequire("eyhZN");

var $lMtwZ = parcelRequire("lMtwZ");


var $9AP5g = parcelRequire("9AP5g");

var $fd913e28a40792b4$var$isMatchMediaAvailable = typeof window !== 'undefined' && 'matchMedia' in window;
/**
 * Updates the current theme when the system contrast preference changes. Should be bound
 * to an event listener listening on the '(prefers-contrast: more)' query
 * @param e The event representing a change in system theme.
 */ function $fd913e28a40792b4$var$checkNativeListener(e) {
    var element = document.documentElement;
    element.setAttribute((0, $9AP5g.CONTRAST_MODE_ATTRIBUTE), e.matches ? 'more' : 'no-preference');
}
var $fd913e28a40792b4$var$contrastModeMql = $fd913e28a40792b4$var$isMatchMediaAvailable && window.matchMedia((0, $e00715b6e459a098$export$8662df6937d86fcb));
var $fd913e28a40792b4$var$ContrastModeObserver = /*#__PURE__*/ function() {
    function ContrastModeObserver() {
        (0, $eoPms.default)(this, ContrastModeObserver);
        (0, $lMtwZ.default)(this, "unbindContrastChangeListener", null);
    }
    return (0, $eyhZN.default)(ContrastModeObserver, [
        {
            key: "getContrastMode",
            value: function getContrastMode() {
                if (!$fd913e28a40792b4$var$contrastModeMql) return 'no-preference';
                return $fd913e28a40792b4$var$contrastModeMql !== null && $fd913e28a40792b4$var$contrastModeMql !== void 0 && $fd913e28a40792b4$var$contrastModeMql.matches ? 'more' : 'no-preference';
            }
        },
        {
            key: "bind",
            value: function bind() {
                if ($fd913e28a40792b4$var$contrastModeMql && this.unbindContrastChangeListener === null) this.unbindContrastChangeListener = (0, $5b617c1f48263075$exports.bind)($fd913e28a40792b4$var$contrastModeMql, {
                    type: 'change',
                    listener: $fd913e28a40792b4$var$checkNativeListener
                });
            }
        },
        {
            key: "unbind",
            value: function unbind() {
                if (this.unbindContrastChangeListener) {
                    this.unbindContrastChangeListener();
                    this.unbindContrastChangeListener = null;
                }
            }
        }
    ]);
}();
/**
 * A singleton contrast mode observer - binds "auto" switching logic to a single `mediaQueryList` listener
 * that can be unbound by any consumer when no longer needed.
 */ var $fd913e28a40792b4$var$SingletonContrastModeObserver = new $fd913e28a40792b4$var$ContrastModeObserver();
var $fd913e28a40792b4$export$2e2bcd8739ae039 = $fd913e28a40792b4$var$SingletonContrastModeObserver;


function $7ffc6e39b7f2dd73$export$2e2bcd8739ae039(themeState) {
    if (themeState.colorMode === 'auto') {
        // Set colorMode based on the user preference
        themeState.colorMode = (0, $983d5a90f967f7fe$export$2e2bcd8739ae039).getColorMode();
        // Bind a listener (if one doesn't already exist) to keep colorMode updated
        (0, $983d5a90f967f7fe$export$2e2bcd8739ae039).bind();
    } else (0, $983d5a90f967f7fe$export$2e2bcd8739ae039).unbind();
    if ((0, $50U6m.fg)('platform_increased-contrast-themes')) {
        if (themeState.contrastMode === 'auto') {
            // Set contrastMode based on the user preference
            themeState.contrastMode = (0, $fd913e28a40792b4$export$2e2bcd8739ae039).getContrastMode();
            // Bind a listener (if one doesn't already exist) to keep contrastMode updated
            (0, $fd913e28a40792b4$export$2e2bcd8739ae039).bind();
        } else (0, $fd913e28a40792b4$export$2e2bcd8739ae039).unbind();
    }
    var themeAttributes = (0, $ec4eb29d91d718cb$export$2e2bcd8739ae039)(themeState);
    Object.entries(themeAttributes).forEach(function(_ref) {
        var _ref2 = (0, $jAELq.default)(_ref, 2), key = _ref2[0], value = _ref2[1];
        document.documentElement.setAttribute(key, value);
    });
    return function() {
        (0, $983d5a90f967f7fe$export$2e2bcd8739ae039).unbind();
        if ((0, $50U6m.fg)('platform_increased-contrast-themes')) (0, $fd913e28a40792b4$export$2e2bcd8739ae039).unbind();
    };
}



var $9AP5g = parcelRequire("9AP5g");

var $3ENxc = parcelRequire("3ENxc");
function $0aafbc0c1e392f5b$export$bd1ac9300b0e885a(UNSAFE_themeOptions, mode) {
    var optionString = JSON.stringify(UNSAFE_themeOptions);
    var uniqueId = (0, $3ENxc.hash)(optionString);
    var attrOfMissingCustomStyles = [];
    (mode === 'auto' ? [
        'light',
        'dark'
    ] : [
        mode
    ]).forEach(function(themeId) {
        var element = document.head.querySelector("style[".concat((0, $9AP5g.CUSTOM_THEME_ATTRIBUTE), "=\"").concat(uniqueId, "\"][").concat((0, $9AP5g.THEME_DATA_ATTRIBUTE), "=\"").concat(themeId, "\"]"));
        if (element) // Append the existing custom styles to take precedence over others
        document.head.appendChild(element);
        else attrOfMissingCustomStyles.push(themeId);
    });
    return attrOfMissingCustomStyles;
}



var $7tyYU = parcelRequire("7tyYU");

var $50U6m = parcelRequire("50U6m");

var $jAELq = parcelRequire("jAELq");

var $7tyYU = parcelRequire("7tyYU");



var $6lN5g = parcelRequire("6lN5g");
/**
 * Themes: The internal identifier of a theme.
 * These ids are what the actual theme files/folders are called.
 * style-dictionary will attempt to locate these in the file-system.
 */ /**
 * ThemeOverrides: The internal identifier of a theme override. Which are themes that contain
 * a subset of tokens intended to override an existing theme. These ids are what the actual
 * theme files/folders are called. style-dictionary will attempt to locate these in the file-system.
 * Theme overrides are temporary and there may not be any defined at times.
 */ // Retain Themes in this public type for backwards compatibility.
// platform-dst-tokens-finesse cleanup: Revisit when the temporary override themes are removed.
/**
 * Theme kinds: The type of theme.
 * Some themes are entirely focused on Color, whilst others are purely focused on spacing.
 * In the future other types may be introduced such as typography.
 */ /**
 * Contrast preferences: The system contrast preference
 */ var $0939e582e4241e27$var$themeContrastModes = [
    'more',
    'no-preference',
    'auto'
];
var $0939e582e4241e27$export$ba8a43b83ecc69f8 = [
    'light-finesse',
    'light-increased-contrast-finesse',
    'dark-finesse',
    'dark-increased-contrast-finesse',
    'typography-finesse'
];
var $0939e582e4241e27$export$92ba366331403db2 = [].concat((0, $7tyYU.default)((0, $f5cca04043e97ccd$export$7d43e72a58e3283f)), $0939e582e4241e27$export$ba8a43b83ecc69f8);
var $0939e582e4241e27$export$9d64ff89b6869900 = {
    'atlassian-light': {
        id: 'light',
        displayName: 'Light Theme',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'light'
        }
    },
    'atlassian-light-future': {
        id: 'light-future',
        displayName: 'Future Light Theme',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'light'
        },
        override: 'light'
    },
    'atlassian-light-finesse': {
        id: 'light-finesse',
        displayName: 'FY27 Finesse Light Theme Override',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'light'
        },
        override: 'light'
    },
    'atlassian-light-increased-contrast-finesse': {
        id: 'light-increased-contrast-finesse',
        displayName: 'FY27 Finesse Light Theme (increased contrast) Override',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'light'
        },
        override: 'light-increased-contrast'
    },
    'atlassian-light-increased-contrast': {
        id: 'light-increased-contrast',
        displayName: 'Light Theme (increased contrast)',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'light'
        },
        extends: 'light',
        increasesContrastFor: 'light'
    },
    'atlassian-dark': {
        id: 'dark',
        displayName: 'Dark Theme',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'dark'
        }
    },
    'atlassian-dark-future': {
        id: 'dark-future',
        displayName: 'Future Dark Theme',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'dark'
        },
        override: 'light'
    },
    'atlassian-dark-finesse': {
        id: 'dark-finesse',
        displayName: 'FY27 Finesse Dark Theme Override',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'dark'
        },
        override: 'dark'
    },
    'atlassian-dark-increased-contrast-finesse': {
        id: 'dark-increased-contrast-finesse',
        displayName: 'FY27 Finesse Dark Theme (increased contrast) Override',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'dark'
        },
        override: 'dark-increased-contrast'
    },
    'atlassian-dark-increased-contrast': {
        id: 'dark-increased-contrast',
        displayName: 'Dark Theme (increased contrast)',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'dark'
        },
        extends: 'dark',
        increasesContrastFor: 'dark'
    },
    'atlassian-spacing': {
        id: 'spacing',
        displayName: 'Atlassian Spacing',
        palette: 'spacingScale',
        attributes: {
            type: 'spacing'
        }
    },
    'atlassian-typography': {
        id: 'typography',
        displayName: 'Atlassian Typography',
        palette: 'typographyPalette',
        attributes: {
            type: 'typography'
        }
    },
    'atlassian-typography-finesse': {
        id: 'typography-finesse',
        displayName: 'FY27 Finesse Typography Override',
        palette: 'typographyPalette',
        attributes: {
            type: 'typography'
        },
        override: 'typography'
    },
    'atlassian-shape': {
        id: 'shape',
        displayName: 'Shape',
        palette: 'shapePalette',
        attributes: {
            type: 'shape'
        }
    },
    'atlassian-motion': {
        id: 'motion',
        displayName: 'Motion',
        palette: 'motionPalette',
        attributes: {
            type: 'motion'
        }
    }
};
var /**
 * Represents theme state once mounted to the page
 * (the page doesn't have an "auto" color mode, it's either light or dark)
 */ // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$0939e582e4241e27$export$2e2bcd8739ae039 = $0939e582e4241e27$export$9d64ff89b6869900;


function $a673407db681c464$export$2e2bcd8739ae039(themeId) {
    var _Object$entries$find;
    return (_Object$entries$find = Object.entries((0, $0939e582e4241e27$export$2e2bcd8739ae039)).find(function(_ref) {
        var _ref2 = (0, $jAELq.default)(_ref, 2), increasesContrastFor = _ref2[1].increasesContrastFor;
        return increasesContrastFor === themeId;
    })) === null || _Object$entries$find === void 0 ? void 0 : _Object$entries$find[1].id;
}


var $ed9aa88ca40ae06d$var$finesseOverrides = {
    light: 'light-finesse',
    'light-increased-contrast': 'light-increased-contrast-finesse',
    dark: 'dark-finesse',
    'dark-increased-contrast': 'dark-increased-contrast-finesse',
    typography: 'typography-finesse'
};
var $ed9aa88ca40ae06d$export$5d76d7014f4a5d08 = function getThemeOverridePreferences(themeState) {
    if (!(0, $50U6m.fg)('platform-dst-tokens-finesse')) return [];
    var colorMode = themeState.colorMode, contrastMode = themeState.contrastMode, dark = themeState.dark, light = themeState.light, typography = themeState.typography;
    var selectedThemes = [].concat((0, $7tyYU.default)(colorMode === 'auto' ? [
        light,
        dark
    ] : [
        themeState[colorMode]
    ]), [
        typography
    ]);
    if (contrastMode !== 'no-preference' && (0, $50U6m.fg)('platform_increased-contrast-themes')) selectedThemes.forEach(function(themeId) {
        var increasedContrastTheme = (0, $a673407db681c464$export$2e2bcd8739ae039)(themeId);
        if (increasedContrastTheme) selectedThemes.push(increasedContrastTheme);
    });
    var themeOverridePreferences = selectedThemes.map(function(themeId) {
        return $ed9aa88ca40ae06d$var$finesseOverrides[themeId];
    }).filter(function(themeId) {
        return themeId !== undefined;
    });
    return (0, $7tyYU.default)(new Set(themeOverridePreferences));
};



var $7tyYU = parcelRequire("7tyYU");

var $50U6m = parcelRequire("50U6m");

var $2a0bd88b2a46cb27$export$dd6aeb7c823fc03d = function getThemePreferences(themeState) {
    var colorMode = themeState.colorMode, contrastMode = themeState.contrastMode, dark = themeState.dark, light = themeState.light, shape = themeState.shape, spacing = themeState.spacing, typography = themeState.typography, motion = themeState.motion;
    var autoColorModeThemes = [
        light,
        dark
    ];
    var themePreferences = [];
    if (colorMode === 'auto') {
        if (contrastMode !== 'no-preference' && (0, $50U6m.fg)('platform_increased-contrast-themes')) autoColorModeThemes.forEach(function(normalTheme) {
            var increasedContrastTheme = (0, $a673407db681c464$export$2e2bcd8739ae039)(normalTheme);
            if (increasedContrastTheme) autoColorModeThemes.push(increasedContrastTheme);
        });
        themePreferences.push.apply(themePreferences, autoColorModeThemes);
    } else {
        themePreferences.push(themeState[colorMode]);
        if (contrastMode !== 'no-preference' && (0, $50U6m.fg)('platform_increased-contrast-themes')) {
            var increasedContrastTheme = (0, $a673407db681c464$export$2e2bcd8739ae039)(themeState[colorMode]);
            if (increasedContrastTheme) themePreferences.push(increasedContrastTheme);
        }
    }
    [
        shape,
        spacing,
        typography,
        motion
    ].forEach(function(themeId) {
        if (themeId) themePreferences.push(themeId);
    });
    return (0, $7tyYU.default)(new Set(themePreferences));
};





function $9a4b3b2d125ade05$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $9a4b3b2d125ade05$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $9a4b3b2d125ade05$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $9a4b3b2d125ade05$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $9a4b3b2d125ade05$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $9a4b3b2d125ade05$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function $9a4b3b2d125ade05$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $9a4b3b2d125ade05$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $9a4b3b2d125ade05$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $lMtwZ.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $9a4b3b2d125ade05$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}

/**
 * Sets the theme globally at runtime. This updates the `data-theme` and `data-color-mode` attributes on your page's <html> tag.
 *
 * @param {Object<string, string>} themeState The themes and color mode that should be applied.
 * @param {string} themeState.colorMode Determines which color theme is applied. If set to `auto`, the theme applied will be determined by the OS setting.
 * @param {string} themeState.contrastMode The contrast mode theme to be applied. If set to `auto`, the theme applied will be determined by the OS setting.set to `auto`, the theme applied will be determined by the OS setting.
 * @param {string} themeState.dark The color theme to be applied when the color mode resolves to 'dark'.
 * @param {string} themeState.light The color theme to be applied when the color mode resolves to 'light'.
 * @param {string} themeState.motion The motion theme to be applied.
 * @param {string} themeState.shape The shape theme to be applied.
 * @param {string} themeState.spacing The spacing theme to be applied.
 * @param {string} themeState.typography The typography theme to be applied.
 * @param {Object} themeState.UNSAFE_themeOptions The custom branding options to be used for custom theme generation
 * @param {function} themeLoader Callback function used to override the default theme loading functionality.
 *
 * @returns A Promise of an unbind function, that can be used to stop listening for changes to system theme.
 *
 * @example
 * ```
 * setGlobalTheme({colorMode: 'auto', light: 'light', dark: 'dark', spacing: 'spacing'});
 * ```
 */ var $9a4b3b2d125ade05$export$fd7e0dd2b74807f7 = /*#__PURE__*/ function() {
    var _ref = (0, $88a75703cd62f79d$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($f410d35d96337f35$exports))).mark(function _callee3() {
        var nextThemeState, themeLoader, _ref2, _ref2$colorMode, colorMode, _ref2$contrastMode, contrastMode, _ref2$dark, dark, _ref2$light, light, _ref2$shape, shape, _ref2$spacing, spacing, _ref2$typography, typography, _ref2$motion, motion, _ref2$UNSAFE_themeOpt, UNSAFE_themeOptions, themeState, themePreferences, loadingStrategy, loadingTasks, themeOverridePreferences, overrideThemeCssLoadingTasks, mode, attrOfMissingCustomStyles, _iterator, _step, themeId, overrideThemeCss, autoUnbind, _args3 = arguments, _t;
        return (0, (/*@__PURE__*/$parcel$interopDefault($f410d35d96337f35$exports))).wrap(function(_context3) {
            while(true)switch(_context3.prev = _context3.next){
                case 0:
                    nextThemeState = _args3.length > 0 && _args3[0] !== undefined ? _args3[0] : {};
                    themeLoader = _args3.length > 1 ? _args3[1] : undefined;
                    _ref2 = typeof nextThemeState === 'function' ? nextThemeState($9a4b3b2d125ade05$var$_objectSpread($9a4b3b2d125ade05$var$_objectSpread({}, (0, $6lN5g.themeStateDefaults)), {}, {
                        typography: (0, $6lN5g.themeStateDefaults)['typography'],
                        shape: (0, $6lN5g.themeStateDefaults)['shape'](),
                        motion: (0, $6lN5g.themeStateDefaults)['motion']()
                    }, (0, $9f556f5b50981903$export$813ecdf77207a053)())) : nextThemeState, _ref2$colorMode = _ref2.colorMode, colorMode = _ref2$colorMode === void 0 ? (0, $6lN5g.themeStateDefaults)['colorMode'] : _ref2$colorMode, _ref2$contrastMode = _ref2.contrastMode, contrastMode = _ref2$contrastMode === void 0 ? (0, $6lN5g.themeStateDefaults)['contrastMode'] : _ref2$contrastMode, _ref2$dark = _ref2.dark, dark = _ref2$dark === void 0 ? (0, $6lN5g.themeStateDefaults)['dark'] : _ref2$dark, _ref2$light = _ref2.light, light = _ref2$light === void 0 ? (0, $6lN5g.themeStateDefaults)['light'] : _ref2$light, _ref2$shape = _ref2.shape, shape = _ref2$shape === void 0 ? (0, $6lN5g.themeStateDefaults)['shape']() : _ref2$shape, _ref2$spacing = _ref2.spacing, spacing = _ref2$spacing === void 0 ? (0, $6lN5g.themeStateDefaults)['spacing'] : _ref2$spacing, _ref2$typography = _ref2.typography, typography = _ref2$typography === void 0 ? (0, $6lN5g.themeStateDefaults)['typography'] : _ref2$typography, _ref2$motion = _ref2.motion, motion = _ref2$motion === void 0 ? (0, $6lN5g.themeStateDefaults)['motion']() : _ref2$motion, _ref2$UNSAFE_themeOpt = _ref2.UNSAFE_themeOptions, UNSAFE_themeOptions = _ref2$UNSAFE_themeOpt === void 0 ? (0, $6lN5g.themeStateDefaults)['UNSAFE_themeOptions'] : _ref2$UNSAFE_themeOpt; // CLEANUP: Remove. This blocks application of increased contrast themes
                    // without the feature flag enabled.
                    if (!(0, $50U6m.fg)('platform_increased-contrast-themes')) {
                        if (light === 'light-increased-contrast') light = 'light';
                        if (dark === 'dark-increased-contrast') dark = 'dark';
                    }
                    themeState = {
                        colorMode: colorMode,
                        contrastMode: contrastMode,
                        dark: dark,
                        light: light,
                        shape: shape,
                        spacing: spacing,
                        typography: typography,
                        motion: motion,
                        UNSAFE_themeOptions: themeLoader ? undefined : UNSAFE_themeOptions
                    }; // Determine what to load and loading strategy
                    themePreferences = (0, $2a0bd88b2a46cb27$export$dd6aeb7c823fc03d)(themeState);
                    loadingStrategy = themeLoader ? themeLoader : (0, $e00715b6e459a098$export$26cd7ae85c7144e5); // Load standard themes
                    loadingTasks = themePreferences.map(/*#__PURE__*/ function() {
                        var _ref3 = (0, $88a75703cd62f79d$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($f410d35d96337f35$exports))).mark(function _callee(themeId) {
                            return (0, (/*@__PURE__*/$parcel$interopDefault($f410d35d96337f35$exports))).wrap(function(_context) {
                                while(true)switch(_context.prev = _context.next){
                                    case 0:
                                        _context.next = 1;
                                        return loadingStrategy(themeId);
                                    case 1:
                                        return _context.abrupt("return", _context.sent);
                                    case 2:
                                    case "end":
                                        return _context.stop();
                                }
                            }, _callee);
                        }));
                        return function(_x) {
                            return _ref3.apply(this, arguments);
                        };
                    }());
                    themeOverridePreferences = (0, $ed9aa88ca40ae06d$export$5d76d7014f4a5d08)(themeState); // Start loading override CSS before the first await. It is appended only after the standard
                    // themes have loaded so that the override cascade order remains deterministic.
                    overrideThemeCssLoadingTasks = themeLoader ? [] : themeOverridePreferences.map(function(themeId) {
                        return (0, $dec12687bb640dba$export$8a48286ed7df6720)(themeId);
                    }); // Load custom themes if needed
                    if (!themeLoader && UNSAFE_themeOptions && (0, $4834b5af4fbc0ef8$export$53031ac1ecb71f44)(UNSAFE_themeOptions === null || UNSAFE_themeOptions === void 0 ? void 0 : UNSAFE_themeOptions.brandColor)) {
                        mode = colorMode || (0, $6lN5g.themeStateDefaults)['colorMode'];
                        attrOfMissingCustomStyles = (0, $0aafbc0c1e392f5b$export$bd1ac9300b0e885a)(UNSAFE_themeOptions, mode);
                        if (attrOfMissingCustomStyles.length > 0) // Load custom theme styles
                        loadingTasks.push((0, $88a75703cd62f79d$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($f410d35d96337f35$exports))).mark(function _callee2() {
                            var _yield$import, loadAndAppendCustomThemeCss;
                            return (0, (/*@__PURE__*/$parcel$interopDefault($f410d35d96337f35$exports))).wrap(function(_context2) {
                                while(true)switch(_context2.prev = _context2.next){
                                    case 0:
                                        _context2.next = 1;
                                        return (parcelRequire("6OciX"));
                                    case 1:
                                        _yield$import = _context2.sent;
                                        loadAndAppendCustomThemeCss = _yield$import.loadAndAppendCustomThemeCss;
                                        loadAndAppendCustomThemeCss({
                                            colorMode: attrOfMissingCustomStyles.length === 2 ? 'auto' : // only load the missing custom theme styles
                                            attrOfMissingCustomStyles[0],
                                            UNSAFE_themeOptions: UNSAFE_themeOptions
                                        });
                                    case 2:
                                    case "end":
                                        return _context2.stop();
                                }
                            }, _callee2);
                        }))());
                    }
                    _context3.next = 1;
                    return Promise.all(loadingTasks);
                case 1:
                    if (!themeLoader) {
                        _context3.next = 9;
                        break;
                    }
                    _iterator = $9a4b3b2d125ade05$var$_createForOfIteratorHelper(themeOverridePreferences);
                    _context3.prev = 2;
                    _iterator.s();
                case 3:
                    if ((_step = _iterator.n()).done) {
                        _context3.next = 5;
                        break;
                    }
                    themeId = _step.value;
                    _context3.next = 4;
                    return loadingStrategy(themeId);
                case 4:
                    _context3.next = 3;
                    break;
                case 5:
                    _context3.next = 7;
                    break;
                case 6:
                    _context3.prev = 6;
                    _t = _context3["catch"](2);
                    _iterator.e(_t);
                case 7:
                    _context3.prev = 7;
                    _iterator.f();
                    return _context3.finish(7);
                case 8:
                    _context3.next = 11;
                    break;
                case 9:
                    _context3.next = 10;
                    return Promise.all(overrideThemeCssLoadingTasks);
                case 10:
                    overrideThemeCss = _context3.sent;
                    _context3.next = 11;
                    return Promise.all(themeOverridePreferences.map(function(themeId, index) {
                        return (0, $e00715b6e459a098$export$26cd7ae85c7144e5)(themeId, overrideThemeCss[index]);
                    }));
                case 11:
                    autoUnbind = (0, $7ffc6e39b7f2dd73$export$2e2bcd8739ae039)(themeState);
                    return _context3.abrupt("return", autoUnbind);
                case 12:
                case "end":
                    return _context3.stop();
            }
        }, _callee3, null, [
            [
                2,
                6,
                7,
                8
            ]
        ]);
    }));
    return function setGlobalTheme() {
        return _ref.apply(this, arguments);
    };
}();



var $i3UfC = parcelRequire("i3UfC");



var $5FkrB = parcelRequire("5FkrB");

var $2nBsU = parcelRequire("2nBsU");



var $0134283b3375b86b$export$e895e3e8b708ae2a = function getPageLayoutSlotSelector(slotName) {
    return (0, $75c03925a1a6ef46$export$2e2bcd8739ae039)({}, (0, $efd2be1bf5c3a2eb$export$5253dd9707b8c3ba), slotName);
};



// Reliably test against conditions like
// localStorage being full or private mode in Safari being a .
// https://gist.github.com/paulirish/5558557
var $2c0492804ed7b798$var$isLocalStorageSupported = function isLocalStorageSupported() {
    try {
        // use an random key to test
        // eslint-disable-next-line @repo/internal/react/disallow-unstable-values
        var testKey = "__test_".concat(Date.now(), "__");
        // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
        localStorage.setItem(testKey, testKey);
        // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
        localStorage.removeItem(testKey);
        return true;
    } catch (_unused) {
        return false;
    }
};
var $2c0492804ed7b798$var$safeLocalStorage = function safeLocalStorage() {
    if ($2c0492804ed7b798$var$isLocalStorageSupported()) // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
    return localStorage;
    // Returning a mock object here in the case that this is run in SSR mode
    if (typeof window === 'undefined') return {
        getItem: function getItem(_key) {
            return null;
        },
        setItem: function setItem(_key, _value) {
            return null;
        },
        removeItem: function removeItem(_key) {
            return null;
        },
        clear: function clear() {
            return null;
        },
        key: function key(_index) {
            return null;
        },
        get length () {
            return 0;
        }
    };
    if (window.__localStorageFallback && Object.keys(window.__localStorageFallback).length !== 0) return window.__localStorageFallback;
    var storageAPI = {
        getItem: function getItem(key) {
            if (window.__localStorageFallback.hasOwnProperty(key)) return window.__localStorageFallback[key];
            return null;
        },
        setItem: function setItem(key, value) {
            window.__localStorageFallback[key] = String(value);
        },
        removeItem: function removeItem(key) {
            delete window.__localStorageFallback[key];
        },
        clear: function clear() {
            for(var key in window.__localStorageFallback)if (window.__localStorageFallback.hasOwnProperty(key)) delete window.__localStorageFallback[key];
        },
        get length () {
            if (!window.__localStorageFallback) return 0;
            return Object.keys(window.__localStorageFallback).length;
        }
    };
    window.__localStorageFallback = Object.create(storageAPI);
    return window.__localStorageFallback;
};
var $2c0492804ed7b798$export$2e2bcd8739ae039 = $2c0492804ed7b798$var$safeLocalStorage;


var $7899bd7c8fbacce0$export$d95e99d8116d17dc = function getGridStateFromStorage(key) {
    var storageValue = JSON.parse((0, $2c0492804ed7b798$export$2e2bcd8739ae039)().getItem((0, $efd2be1bf5c3a2eb$export$451e84a45a9e4a75)) || '{}');
    return storageValue[key];
};


var $80253a9c765605be$export$74732e47915c7839 = function resolveDimension(key) {
    var dimension = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    var shouldPersist = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    if (shouldPersist) {
        var cachedGridState = (0, $7899bd7c8fbacce0$export$d95e99d8116d17dc)('gridState');
        return cachedGridState && Object.keys(cachedGridState).length > 0 && cachedGridState[key] ? cachedGridState[key] : dimension;
    }
    return dimension;
};








function $5fe25f3a7d94fe4c$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $5fe25f3a7d94fe4c$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $5fe25f3a7d94fe4c$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $75c03925a1a6ef46$export$2e2bcd8739ae039)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $5fe25f3a7d94fe4c$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $5fe25f3a7d94fe4c$export$f8355a2df0f4a946 = function mergeGridStateIntoStorage(key, value) {
    var storageValue = JSON.parse((0, $2c0492804ed7b798$export$2e2bcd8739ae039)().getItem((0, $efd2be1bf5c3a2eb$export$451e84a45a9e4a75)) || '{}');
    if (value !== null && (0, $ec3f76b68921e912$export$2e2bcd8739ae039)(value) === 'object') storageValue[key] = $5fe25f3a7d94fe4c$var$_objectSpread($5fe25f3a7d94fe4c$var$_objectSpread({}, storageValue[key]), value);
    else storageValue[key] = value;
    (0, $2c0492804ed7b798$export$2e2bcd8739ae039)().setItem((0, $efd2be1bf5c3a2eb$export$451e84a45a9e4a75), JSON.stringify(storageValue));
};




var $860d8a4cb1fd22bc$export$17e3760e0b35f1cd = function removeFromGridStateInStorage(key, secondKey) {
    var storageValue = JSON.parse((0, $2c0492804ed7b798$export$2e2bcd8739ae039)().getItem((0, $efd2be1bf5c3a2eb$export$451e84a45a9e4a75)) || '{}');
    if (secondKey && storageValue[key]) delete storageValue[key][secondKey];
    else delete storageValue[key];
    (0, $2c0492804ed7b798$export$2e2bcd8739ae039)().setItem((0, $efd2be1bf5c3a2eb$export$451e84a45a9e4a75), JSON.stringify(storageValue));
};


var $4c3ca5af83e051b7$var$publishGridState = function publishGridState(gridState) {
    Object.entries(gridState).forEach(function(_ref) {
        var _ref2 = (0, $f0700d30f2885170$export$2e2bcd8739ae039)(_ref, 2), slotName = _ref2[0], value = _ref2[1];
        if (!value) {
            document.documentElement.style.removeProperty("--".concat(slotName));
            (0, $860d8a4cb1fd22bc$export$17e3760e0b35f1cd)('gridState', slotName);
            return;
        }
        //Update the css variable
        document.documentElement.style.setProperty("--".concat(slotName), "".concat(value, "px"));
        // also update state in local storage so that
        // it persists across page refresh, across tabs etc
        (0, $5fe25f3a7d94fe4c$export$f8355a2df0f4a946)('gridState', (0, $75c03925a1a6ef46$export$2e2bcd8739ae039)({}, slotName, value));
    });
};
var $4c3ca5af83e051b7$export$2e2bcd8739ae039 = $4c3ca5af83e051b7$var$publishGridState;


var $5FkrB = parcelRequire("5FkrB");

var $d3394030a5bc27ce$export$89d9323301efc7d6 = function useSkipLink(id, skipLinkTitle) {
    var _useSkipLinks = (0, $a56aa16f16be206c$export$c9d9cb2ee9590f87)(), registerSkipLink = _useSkipLinks.registerSkipLink, unregisterSkipLink = _useSkipLinks.unregisterSkipLink;
    (0, $5FkrB.useEffect)(function() {
        if (id && skipLinkTitle) registerSkipLink({
            id: id,
            skipLinkTitle: skipLinkTitle
        });
        return function() {
            unregisterSkipLink(id);
        };
    }, [
        id,
        skipLinkTitle,
        registerSkipLink,
        unregisterSkipLink
    ]);
};


/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled, @typescript-eslint/consistent-type-imports

var $2nBsU = parcelRequire("2nBsU");
var $d01cbf9d38a43f2f$var$focusStyles = (0, $2nBsU.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    ':focus': {
        outline: 'none',
        // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '> div': {
            boxShadow: "0px 0px 0px 2px inset ".concat("var(--ds-border-focused, #4688EC)"),
            outline: 'none'
        }
    }
});
/**
 * Sidebars have an outer and inner component,
 * so the nested selector needs to target an extra level deeper.
 */ var $d01cbf9d38a43f2f$var$sidebarFocusStyles = (0, $2nBsU.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    ':focus': {
        outline: 'none',
        // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '> div > div': {
            boxShadow: "0px 0px 0px 2px inset ".concat("var(--ds-border-focused, #4688EC)"),
            outline: 'none'
        }
    }
});
/**
 * We don't use `@atlaskit/focus-ring` here,
 * because we need inset focus styles and:
 *
 * 1. If we set them directly to the layout element,
 *    then any child element's background will cover the shadow.
 * 2. We cannot wrap `children` in `FocusRing`,
 *    because there's no guarantee the passed child takes `className`.
 */ var $d01cbf9d38a43f2f$var$SlotFocusRing = function SlotFocusRing(_ref) {
    var children = _ref.children, _ref$isSidebar = _ref.isSidebar, isSidebar = _ref$isSidebar === void 0 ? false : _ref$isSidebar;
    return (0, $2nBsU.jsx)((0, $2nBsU.ClassNames), null, function(_ref2) {
        var css = _ref2.css;
        return children({
            className: isSidebar ? css($d01cbf9d38a43f2f$var$sidebarFocusStyles) : css($d01cbf9d38a43f2f$var$focusStyles)
        });
    });
};
var $d01cbf9d38a43f2f$export$2e2bcd8739ae039 = $d01cbf9d38a43f2f$var$SlotFocusRing;



var $5FkrB = parcelRequire("5FkrB");

/**
 * Hoists slot dimension styles to the root element.
 */ var $9f2fa52b548fb20d$var$SlotDimensions = function SlotDimensions(_ref) {
    var variableName = _ref.variableName, value = _ref.value, mobileValue = _ref.mobileValue;
    /**
   * Note don't put multiple variables in multiple lines. eg
   * <style>
   *   {css1}
   *   {css2}
   * </style>
   *
   * React will insert an empty HTML comment in between the text in SSR.
   * This is not a valid tag and will break the page.
   * <style>foo<!-- -->bar</style>
   */ var style = ":root{--".concat(variableName, ":").concat(value, "px;}");
    if (mobileValue) style += " ".concat((0, $92693c60dc1696c3$export$c881183ca713c214).below.sm, " { :root{--").concat(variableName, ":").concat(mobileValue, "px;} }");
    return(/*#__PURE__*/ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-global-styles -- Ignored via go/DSP-18766
    (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("style", null, style));
};
var $9f2fa52b548fb20d$export$2e2bcd8739ae039 = $9f2fa52b548fb20d$var$SlotDimensions;


var $1a90644fef3a8d91$var$topNavigationStyles = (0, $2nBsU.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    height: (0, $efd2be1bf5c3a2eb$export$aeff86a16f13529),
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    gridArea: (0, $efd2be1bf5c3a2eb$export$bec6dca2e63de4ae)
});
var $1a90644fef3a8d91$var$fixedStyles = (0, $2nBsU.css)({
    position: 'fixed',
    zIndex: 2,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    insetBlockStart: (0, $efd2be1bf5c3a2eb$export$ed7cc0d417ee89e),
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    insetInlineEnd: (0, $efd2be1bf5c3a2eb$export$750459958906793),
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    insetInlineStart: (0, $efd2be1bf5c3a2eb$export$f963aecf2d4465bd)
});
/**
 * __Top navigation__
 *
 * Provides a slot for top navigation within the PageLayout.
 *
 * - [Examples](https://atlassian.design/components/page-layout/examples)
 * - [Code](https://atlassian.design/components/page-layout/code)
 *
 * @deprecated `@atlaskit/page-layout` is deprecated. Use `@atlaskit/navigation-system` instead.
 */ var $1a90644fef3a8d91$var$TopNavigation = function TopNavigation(props) {
    var children = props.children, _props$height = props.height, height = _props$height === void 0 ? (0, $efd2be1bf5c3a2eb$export$4a98ee0bd1ae362) : _props$height, _props$isFixed = props.isFixed, isFixed = _props$isFixed === void 0 ? true : _props$isFixed, shouldPersistHeight = props.shouldPersistHeight, testId = props.testId, id = props.id, skipLinkTitle = props.skipLinkTitle;
    var topNavigationHeight = (0, $80253a9c765605be$export$74732e47915c7839)((0, $efd2be1bf5c3a2eb$export$3a6a779d9181047c), height, shouldPersistHeight);
    (0, $5FkrB.useEffect)(function() {
        (0, $4c3ca5af83e051b7$export$2e2bcd8739ae039)((0, $75c03925a1a6ef46$export$2e2bcd8739ae039)({}, (0, $efd2be1bf5c3a2eb$export$3a6a779d9181047c), topNavigationHeight));
        return function() {
            (0, $4c3ca5af83e051b7$export$2e2bcd8739ae039)((0, $75c03925a1a6ef46$export$2e2bcd8739ae039)({}, (0, $efd2be1bf5c3a2eb$export$3a6a779d9181047c), 0));
        };
    }, [
        topNavigationHeight
    ]);
    (0, $d3394030a5bc27ce$export$89d9323301efc7d6)(id, skipLinkTitle);
    return (0, $2nBsU.jsx)((0, $d01cbf9d38a43f2f$export$2e2bcd8739ae039), null, function(_ref) {
        var className = _ref.className;
        return (0, $2nBsU.jsx)("div", (0, $b65104b70faead20$export$2e2bcd8739ae039)({
            css: [
                $1a90644fef3a8d91$var$topNavigationStyles,
                isFixed && $1a90644fef3a8d91$var$fixedStyles
            ],
            className: className,
            "data-testid": testId,
            id: id
        }, (0, $0134283b3375b86b$export$e895e3e8b708ae2a)('top-navigation')), (0, $2nBsU.jsx)((0, $9f2fa52b548fb20d$export$2e2bcd8739ae039), {
            variableName: (0, $efd2be1bf5c3a2eb$export$3a6a779d9181047c),
            value: topNavigationHeight
        }), children);
    });
};
var $1a90644fef3a8d91$export$2e2bcd8739ae039 = $1a90644fef3a8d91$var$TopNavigation;



var $i3UfC = parcelRequire("i3UfC");
function $d029a6002153f8f3$export$2e2bcd8739ae039() {
    return $d029a6002153f8f3$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $d029a6002153f8f3$export$2e2bcd8739ae039.apply(null, arguments);
}


parcelRequire("5FkrB");

var $2nBsU = parcelRequire("2nBsU");
function $2dbd29ae0aefa014$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $2dbd29ae0aefa014$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $2dbd29ae0aefa014$export$2e2bcd8739ae039(o);
}



function $daed41fbf1a4634a$export$2e2bcd8739ae039(t, r) {
    if ("object" != (0, $2dbd29ae0aefa014$export$2e2bcd8739ae039)(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (0, $2dbd29ae0aefa014$export$2e2bcd8739ae039)(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}


function $6c5620311db629d8$export$2e2bcd8739ae039(t) {
    var i = (0, $daed41fbf1a4634a$export$2e2bcd8739ae039)(t, "string");
    return "symbol" == (0, $2dbd29ae0aefa014$export$2e2bcd8739ae039)(i) ? i : i + "";
}


function $13b2f21c431db546$export$2e2bcd8739ae039(e, r, t) {
    return (r = (0, $6c5620311db629d8$export$2e2bcd8739ae039)(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}



var $5FkrB = parcelRequire("5FkrB");
function $1e78769d80239f1e$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return r;
}


function $86e4028a2e2096d4$export$2e2bcd8739ae039(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}


function $84c5804da659d6b9$export$2e2bcd8739ae039(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}


function $22fc970bc97b2f71$export$2e2bcd8739ae039(r, a) {
    if (r) {
        if ("string" == typeof r) return (0, $84c5804da659d6b9$export$2e2bcd8739ae039)(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? (0, $84c5804da659d6b9$export$2e2bcd8739ae039)(r, a) : void 0;
    }
}


function $95f463313300caa4$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}


function $6daab6664c1eb2d5$export$2e2bcd8739ae039(r, e) {
    return (0, $1e78769d80239f1e$export$2e2bcd8739ae039)(r) || (0, $86e4028a2e2096d4$export$2e2bcd8739ae039)(r, e) || (0, $22fc970bc97b2f71$export$2e2bcd8739ae039)(r, e) || (0, $95f463313300caa4$export$2e2bcd8739ae039)();
}



var $5FkrB = parcelRequire("5FkrB");

var $50U6m = parcelRequire("50U6m");

var $3ZMUU = parcelRequire("3ZMUU");
var $0eb3be8b64b15357$var$_process$env;
/// <reference types="node" />
var $0eb3be8b64b15357$var$_default_1 = typeof $3ZMUU !== 'undefined' && $3ZMUU !== null && (($0eb3be8b64b15357$var$_process$env = {}, $0eb3be8b64b15357$var$_process$env === void 0) ? void 0 : $0eb3be8b64b15357$var$_process$env['ANALYTICS_NEXT_MODERN_CONTEXT']);
var $0eb3be8b64b15357$export$2e2bcd8739ae039 = $0eb3be8b64b15357$var$_default_1;



function $6737a70a08aa14e5$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return (0, $84c5804da659d6b9$export$2e2bcd8739ae039)(r);
}


function $aaeca58f83b67358$export$2e2bcd8739ae039(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}



function $0d12cbe7deba19cd$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}


function $020c6c091d5e971b$export$2e2bcd8739ae039(r) {
    return (0, $6737a70a08aa14e5$export$2e2bcd8739ae039)(r) || (0, $aaeca58f83b67358$export$2e2bcd8739ae039)(r) || (0, $22fc970bc97b2f71$export$2e2bcd8739ae039)(r) || (0, $0d12cbe7deba19cd$export$2e2bcd8739ae039)();
}


function $3ff823f0da4a20b9$export$2e2bcd8739ae039(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}


function $da06783b19ad120c$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $da06783b19ad120c$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $da06783b19ad120c$export$2e2bcd8739ae039(o);
}



function $6f3ce1e8fee89188$export$2e2bcd8739ae039(t, r) {
    if ("object" != (0, $da06783b19ad120c$export$2e2bcd8739ae039)(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (0, $da06783b19ad120c$export$2e2bcd8739ae039)(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}


function $39705e5882cacb4c$export$2e2bcd8739ae039(t) {
    var i = (0, $6f3ce1e8fee89188$export$2e2bcd8739ae039)(t, "string");
    return "symbol" == (0, $da06783b19ad120c$export$2e2bcd8739ae039)(i) ? i : i + "";
}


function $5c543da7f3d6df1a$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, (0, $39705e5882cacb4c$export$2e2bcd8739ae039)(o.key), o);
    }
}
function $5c543da7f3d6df1a$export$2e2bcd8739ae039(e, r, t) {
    return r && $5c543da7f3d6df1a$var$_defineProperties(e.prototype, r), t && $5c543da7f3d6df1a$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}



function $ad0c640a1c3a3ecb$export$2e2bcd8739ae039(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
}


function $8cacf05721e5c3d7$export$2e2bcd8739ae039(t, e) {
    if (e && ("object" == (0, $da06783b19ad120c$export$2e2bcd8739ae039)(e) || "function" == typeof e)) return e;
    if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
    return (0, $ad0c640a1c3a3ecb$export$2e2bcd8739ae039)(t);
}


function $c6c7ad7ba578ca39$export$2e2bcd8739ae039(t) {
    return $c6c7ad7ba578ca39$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
        return t.__proto__ || Object.getPrototypeOf(t);
    }, $c6c7ad7ba578ca39$export$2e2bcd8739ae039(t);
}


function $ac426a5cca6bf306$export$2e2bcd8739ae039(t, e) {
    return $ac426a5cca6bf306$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, $ac426a5cca6bf306$export$2e2bcd8739ae039(t, e);
}


function $0eea87f8e9485d77$export$2e2bcd8739ae039(t, e) {
    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
    t.prototype = Object.create(e && e.prototype, {
        constructor: {
            value: t,
            writable: !0,
            configurable: !0
        }
    }), Object.defineProperty(t, "prototype", {
        writable: !1
    }), e && (0, $ac426a5cca6bf306$export$2e2bcd8739ae039)(t, e);
}



function $0b2d8b20b765b25f$export$2e2bcd8739ae039(e, r, t) {
    return (r = (0, $39705e5882cacb4c$export$2e2bcd8739ae039)(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}



var $5FkrB = parcelRequire("5FkrB");
var $7c1267c58618c0a0$exports = {};
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $7c1267c58618c0a0$var$ReactIs, $7c1267c58618c0a0$var$throwOnDirectAccess;

// By explicitly using `prop-types` you are opting into new production behavior.
// http://fb.me/prop-types-in-prod
$7c1267c58618c0a0$exports = (parcelRequire("4Jvr6"))();



function $b4492ce4107f08c4$var$_callSuper(t, o, e) {
    return o = (0, $c6c7ad7ba578ca39$export$2e2bcd8739ae039)(o), (0, $8cacf05721e5c3d7$export$2e2bcd8739ae039)(t, $b4492ce4107f08c4$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, $c6c7ad7ba578ca39$export$2e2bcd8739ae039)(t).constructor) : o.apply(t, e));
}
function $b4492ce4107f08c4$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($b4492ce4107f08c4$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $b4492ce4107f08c4$var$ContextTypes = {
    getAtlaskitAnalyticsContext: (0, (/*@__PURE__*/$parcel$interopDefault($7c1267c58618c0a0$exports))).func,
    getAtlaskitAnalyticsEventHandlers: (0, (/*@__PURE__*/$parcel$interopDefault($7c1267c58618c0a0$exports))).func
};
var $b4492ce4107f08c4$var$noop = function noop() {
    return [];
};
// eslint-disable-next-line @repo/internal/react/no-class-components
var $b4492ce4107f08c4$var$AnalyticsContext = /*#__PURE__*/ function(_Component) {
    function AnalyticsContext(props) {
        var _this;
        (0, $3ff823f0da4a20b9$export$2e2bcd8739ae039)(this, AnalyticsContext);
        _this = $b4492ce4107f08c4$var$_callSuper(this, AnalyticsContext, [
            props
        ]);
        (0, $0b2d8b20b765b25f$export$2e2bcd8739ae039)(_this, "getChildContext", function() {
            return {
                getAtlaskitAnalyticsContext: _this.getAnalyticsContext
            };
        });
        (0, $0b2d8b20b765b25f$export$2e2bcd8739ae039)(_this, "getAnalyticsContext", function() {
            var data = _this.props.data;
            var _this$context$getAtla = _this.context.getAtlaskitAnalyticsContext, getAtlaskitAnalyticsContext = _this$context$getAtla === void 0 ? $b4492ce4107f08c4$var$noop : _this$context$getAtla;
            return [].concat((0, $020c6c091d5e971b$export$2e2bcd8739ae039)(getAtlaskitAnalyticsContext()), [
                data
            ]);
        });
        (0, $0b2d8b20b765b25f$export$2e2bcd8739ae039)(_this, "getAnalyticsEventHandlers", function() {
            var _this$context$getAtla2 = _this.context.getAtlaskitAnalyticsEventHandlers, getAtlaskitAnalyticsEventHandlers = _this$context$getAtla2 === void 0 ? $b4492ce4107f08c4$var$noop : _this$context$getAtla2;
            return getAtlaskitAnalyticsEventHandlers();
        });
        _this.contextValue = {
            getAtlaskitAnalyticsContext: _this.getAnalyticsContext,
            getAtlaskitAnalyticsEventHandlers: _this.getAnalyticsEventHandlers
        };
        return _this;
    }
    (0, $0eea87f8e9485d77$export$2e2bcd8739ae039)(AnalyticsContext, _Component);
    return (0, $5c543da7f3d6df1a$export$2e2bcd8739ae039)(AnalyticsContext, [
        {
            key: "render",
            value: function render() {
                var children = this.props.children;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $d82667e77467cbe0$export$2e2bcd8739ae039).Provider, {
                    value: this.contextValue
                }, children);
            }
        }
    ]);
}((0, $5FkrB.Component));
(0, $0b2d8b20b765b25f$export$2e2bcd8739ae039)($b4492ce4107f08c4$var$AnalyticsContext, "contextTypes", $b4492ce4107f08c4$var$ContextTypes);
(0, $0b2d8b20b765b25f$export$2e2bcd8739ae039)($b4492ce4107f08c4$var$AnalyticsContext, "childContextTypes", $b4492ce4107f08c4$var$ContextTypes);
var $b4492ce4107f08c4$export$2e2bcd8739ae039 = $b4492ce4107f08c4$var$AnalyticsContext;




var $5FkrB = parcelRequire("5FkrB");


var $5FkrB = parcelRequire("5FkrB");

var $3a4497eea280292e$export$d1f587f82ad51c4 = function useAnalyticsContext() {
    return (0, $5FkrB.useContext)((0, $d82667e77467cbe0$export$2e2bcd8739ae039));
};



var $5FkrB = parcelRequire("5FkrB");
var $90d091140a6cc984$export$1d27a74659855e44 = function useTrackedRef(value) {
    var ref = (0, $5FkrB.useRef)(value);
    ref.current = value;
    return ref;
};


var $97ca9e2bedb57888$var$AnalyticsContext = function AnalyticsContext(_ref) {
    var data = _ref.data, children = _ref.children;
    var dataRef = (0, $90d091140a6cc984$export$1d27a74659855e44)(data);
    var _useAnalyticsContext = (0, $3a4497eea280292e$export$d1f587f82ad51c4)(), getAtlaskitAnalyticsEventHandlers = _useAnalyticsContext.getAtlaskitAnalyticsEventHandlers, getOriginalAnalyticsContext = _useAnalyticsContext.getAtlaskitAnalyticsContext;
    var getAtlaskitAnalyticsContext = (0, $5FkrB.useCallback)(function() {
        return [].concat((0, $020c6c091d5e971b$export$2e2bcd8739ae039)(getOriginalAnalyticsContext()), [
            dataRef.current
        ]);
    }, [
        getOriginalAnalyticsContext,
        dataRef
    ]);
    var value = (0, $5FkrB.useMemo)(function() {
        return {
            getAtlaskitAnalyticsContext: getAtlaskitAnalyticsContext,
            getAtlaskitAnalyticsEventHandlers: getAtlaskitAnalyticsEventHandlers
        };
    }, [
        getAtlaskitAnalyticsContext,
        getAtlaskitAnalyticsEventHandlers
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $d82667e77467cbe0$export$2e2bcd8739ae039).Provider, {
        value: value
    }, children);
};
var $97ca9e2bedb57888$export$2e2bcd8739ae039 = $97ca9e2bedb57888$var$AnalyticsContext;


var $f6709ac4711d5a89$var$AnalyticsContext = function AnalyticsContext(props) {
    // Resolved once at mount, never re-read: Modern and Legacy are different component types, so
    // switching on a later render would unmount the whole subtree beneath this provider.
    var _React$useState = (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).useState(function() {
        return (0, $0eb3be8b64b15357$export$2e2bcd8739ae039) || (0, $50U6m.fg)('analytics-next-use-legacy-context') === false || (0, $50U6m.fg)('adminhub-analytics-next-use-modern-context');
    }), _React$useState2 = (0, $6daab6664c1eb2d5$export$2e2bcd8739ae039)(_React$useState, 1), isModernContext = _React$useState2[0];
    return isModernContext ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $97ca9e2bedb57888$export$2e2bcd8739ae039), props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $b4492ce4107f08c4$export$2e2bcd8739ae039), props);
};
var $f6709ac4711d5a89$export$2e2bcd8739ae039 = $f6709ac4711d5a89$var$AnalyticsContext;


var $c122abe76d5b40d8$var$createNamespaceContext = function createNamespaceContext(namespace) {
    var displayName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'NamespacedContext';
    var Component = function Component(props) {
        var newData = (0, $13b2f21c431db546$export$2e2bcd8739ae039)({}, namespace, props.data);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $f6709ac4711d5a89$export$2e2bcd8739ae039), {
            data: newData
        }, (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).Children.only(props.children));
    };
    Component.displayName = displayName;
    return Component;
};
var $c122abe76d5b40d8$export$2e2bcd8739ae039 = $c122abe76d5b40d8$var$createNamespaceContext;


var $fb54a115516e258d$export$1fd3aad76a7c6788 = 'navigationCtx';
var $fb54a115516e258d$export$d0a82da1a0b94929 = (0, $c122abe76d5b40d8$export$2e2bcd8739ae039)($fb54a115516e258d$export$1fd3aad76a7c6788, 'NavigationAnalyticsContext');



/**
 * @deprecated `@atlaskit/atlassian-navigation` is deprecated. Use `@atlaskit/navigation-system` instead.
 */ var $9e0b6f96d7dc4701$export$30fa7cc5f2690a43 = 56;
var $9e0b6f96d7dc4701$export$4033a111ca79977d = 1280;
var $9e0b6f96d7dc4701$export$24ec62cee78b7042 = 1130;
var $9e0b6f96d7dc4701$export$d8bde68ac946124f = '--ds--ans--fbc';
var $9e0b6f96d7dc4701$export$73e44f54603a0964 = '--ds--ans--hbgc';
var $9e0b6f96d7dc4701$export$13f8aa8f663f4c99 = '--ds--ans--bgc';
var $9e0b6f96d7dc4701$export$d81606c1fc5119bc = '--ds--ans--c';
var $9e0b6f96d7dc4701$export$65f656ad520ea71 = '--ds--ans--bc';


var $ffde35be8257144f$var$defaultTheme = {
    mode: {
        create: {
            active: {
                color: "var(--ds-text-inverse, #FFFFFF)",
                backgroundColor: "var(--ds-background-brand-bold-pressed, #144794)",
                boxShadow: ''
            },
            default: {
                color: "var(--ds-text-inverse, #FFFFFF)",
                backgroundColor: "var(--ds-background-brand-bold, #1868DB)",
                boxShadow: ''
            },
            focus: {
                color: "var(--ds-text-inverse, #FFFFFF)",
                backgroundColor: '',
                boxShadow: ''
            },
            hover: {
                color: "var(--ds-text-inverse, #FFFFFF)",
                backgroundColor: "var(--ds-background-brand-bold-hovered, #1558BC)",
                boxShadow: ''
            },
            selected: {
                color: '',
                backgroundColor: '',
                boxShadow: ''
            }
        },
        iconButton: {
            active: {
                color: "var(--ds-text-subtle, #505258)",
                backgroundColor: "var(--ds-background-neutral-subtle-pressed, #0B120E24)",
                boxShadow: ''
            },
            default: {
                color: "var(--ds-text-subtle, #505258)",
                backgroundColor: 'transparent',
                boxShadow: ''
            },
            focus: {
                color: "var(--ds-text-subtle, #505258)",
                backgroundColor: '',
                boxShadow: ''
            },
            hover: {
                color: "var(--ds-text-subtle, #505258)",
                backgroundColor: "var(--ds-background-neutral-subtle-hovered, #0515240F)",
                boxShadow: ''
            },
            selected: {
                color: "var(--ds-text-selected, #1868DB)",
                backgroundColor: "var(--ds-background-selected, #E9F2FE)",
                boxShadow: ''
            },
            selectedHover: {
                color: "var(--ds-text-selected, #1868DB)",
                backgroundColor: "var(--ds-background-selected-hovered, #CFE1FD)",
                boxShadow: ''
            }
        },
        navigation: {
            backgroundColor: "var(--ds-surface, #FFFFFF)",
            color: "var(--ds-text-subtlest, #6B6E76)"
        },
        productHome: {
            backgroundColor: "var(--ds-text-brand, #1868DB)",
            color: "var(--ds-text, #292A2E)",
            borderRight: "var(--ds-border-width, 1px)".concat(" solid ", "var(--ds-border, #0B120E24)"),
            // TODO: replace with token after brand refresh
            iconColor: '#357DE8',
            textColor: "var(--ds-text, #292A2E)"
        },
        primaryButton: {
            active: {
                color: "var(--ds-text-subtle, #505258)",
                backgroundColor: "var(--ds-background-neutral-subtle-pressed, #0B120E24)",
                boxShadow: ''
            },
            default: {
                color: "var(--ds-text-subtle, #505258)",
                backgroundColor: 'transparent',
                boxShadow: ''
            },
            focus: {
                color: "var(--ds-text-subtle, #505258)",
                backgroundColor: '',
                boxShadow: ''
            },
            hover: {
                color: "var(--ds-text-subtle, #505258)",
                backgroundColor: "var(--ds-background-neutral-subtle-hovered, #0515240F)",
                boxShadow: ''
            },
            selected: {
                color: "var(--ds-text-selected, #1868DB)",
                backgroundColor: "var(--ds-background-selected, #E9F2FE)",
                boxShadow: '',
                borderColor: "var(--ds-border-selected, #1868DB)"
            },
            selectedHover: {
                color: "var(--ds-text-selected, #1868DB)",
                backgroundColor: "var(--ds-background-selected-hovered, #CFE1FD)",
                boxShadow: '',
                borderColor: "var(--ds-border-selected, #1868DB)"
            }
        },
        search: {
            default: {
                backgroundColor: "var(--ds-background-input, #FFFFFF)",
                color: "var(--ds-text-subtlest, #6B6E76)",
                borderColor: "var(--ds-border-input, #8C8F97)"
            },
            focus: {
                borderColor: "var(--ds-border-focused, #4688EC)"
            },
            hover: {
                backgroundColor: "var(--ds-background-input-hovered, #F8F8F8)"
            }
        },
        skeleton: {
            backgroundColor: "var(--ds-background-neutral, #0515240F)",
            opacity: 1
        }
    }
};
// Create deep copy of defaultTheme
var $ffde35be8257144f$var$defaultThemeCopy = JSON.parse(JSON.stringify($ffde35be8257144f$var$defaultTheme));
// Update iconColor and textColor in defaultThemeBrandRefresh
$ffde35be8257144f$var$defaultThemeCopy.mode.productHome.iconColor = undefined;
$ffde35be8257144f$var$defaultThemeCopy.mode.productHome.textColor = undefined;
var $ffde35be8257144f$export$2491e13b198e597d = 'atlassian';
var $ffde35be8257144f$export$2e2bcd8739ae039 = $ffde35be8257144f$var$defaultTheme;


function $8f3fa2d1e0e4cb52$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $8f3fa2d1e0e4cb52$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $8f3fa2d1e0e4cb52$export$2e2bcd8739ae039(o);
}



function $64c8a0efd3178e60$export$2e2bcd8739ae039(t, r) {
    if ("object" != (0, $8f3fa2d1e0e4cb52$export$2e2bcd8739ae039)(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (0, $8f3fa2d1e0e4cb52$export$2e2bcd8739ae039)(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}


function $b68ceb27a5284ac7$export$2e2bcd8739ae039(t) {
    var i = (0, $64c8a0efd3178e60$export$2e2bcd8739ae039)(t, "string");
    return "symbol" == (0, $8f3fa2d1e0e4cb52$export$2e2bcd8739ae039)(i) ? i : i + "";
}


function $d93598d00ce909df$export$2e2bcd8739ae039(e, r, t) {
    return (r = (0, $b68ceb27a5284ac7$export$2e2bcd8739ae039)(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}




var $1ed4db7869293530$var$defaultThemeCopy = JSON.parse(JSON.stringify((0, $ffde35be8257144f$export$2e2bcd8739ae039)));
var $1ed4db7869293530$export$77823bc9863eaa03 = $1ed4db7869293530$var$defaultThemeCopy;


function $9de014d0ca2dbeda$var$fromHex(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    n = n.replace("#", "").match(/.{2}/g);
    for(var a = 0; a < n.length; a++)n[a] = parseInt(n[a], 16);
    switch(e){
        case "rgb":
            return {
                r: n[0],
                g: n[1],
                b: n[2]
            };
        default:
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, {
                r: n[0],
                g: n[1],
                b: n[2]
            });
    }
}
function $9de014d0ca2dbeda$var$fromRgb(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    switch(e){
        case "hex":
            return 1 == (g = Math.round(n.r).toString(16)).length && (g = "0" + g), 1 == (y = Math.round(n.g).toString(16)).length && (y = "0" + y), 1 == (_ = Math.round(n.b).toString(16)).length && (_ = "0" + _), "#" + g + y + _;
        case "cssrgb":
            return "rgb(" + Math.round(n.r) + "," + Math.round(n.g) + "," + Math.round(n.b) + ")";
        case "hsl":
            var a = [
                g = n.r / 255,
                y = n.g / 255,
                _ = n.b / 255
            ].sort(), i = (a[0] + a[2]) / 2 * 100;
            return a[0] == a[2] ? (b = 0, d = 0) : (b = i >= 50 ? (a[2] - a[0]) / (2 - a[2] - a[0]) * 100 : (a[2] - a[0]) / (a[2] + a[0]) * 100, (d = a[2] == g ? (y - _) / (a[2] - a[0]) * 60 : a[2] == y ? 60 * (2 + (_ - g) / (a[2] - a[0])) : 60 * (4 + (g - y) / (a[2] - a[0]))) < 0 ? d += 360 : d > 360 && (d %= 360)), {
                h: d,
                s: b,
                l: i
            };
        case "csshsl":
            var c = o.convert({
                conversions: t,
                helpers: s
            }, "hsl", n);
            return "hsl(" + Math.round(c.h) + "," + Math.round(c.s) + "%," + Math.round(c.l) + "%)";
        case "cmyk":
            var u = n.r / 255, l = n.g / 255, h = n.b / 255, v = 1 - Math.max(u, l, h);
            if (1 != v) var p = (1 - u - v) / (1 - v), f = (1 - l - v) / (1 - v), m = (1 - h - v) / (1 - v);
            else var p = 0, f = 0, m = 0;
            return {
                c: p,
                m: f,
                y: m,
                k: v
            };
        case "hsv":
            var d, b, g = n.r / 255, y = n.g / 255, _ = n.b / 255, M = Math.min(g, y, _), Y = Math.max(g, y, _), L = Y - M, X = Y;
            if (0 == L) d = 0, b = 0;
            else {
                b = L / Y;
                var Z = ((Y - g) / 6 + L / 2) / L, R = ((Y - y) / 6 + L / 2) / L, w = ((Y - _) / 6 + L / 2) / L;
                g == Y ? d = w - R : y == Y ? d = 1 / 3 + Z - w : _ == Y && (d = 2 / 3 + R - Z), d < 0 && (d += 1), d > 1 && (d -= 1);
            }
            return {
                h: 360 * d,
                s: 100 * b,
                v: 100 * X
            };
        case "yiq":
            var m = n.r / 255 * .299 + n.g / 255 * .587 + n.b / 255 * .114, C = n.r / 255 * .596 + n.g / 255 * -0.274 + n.b / 255 * -0.322, x = n.r / 255 * .211 + n.g / 255 * -0.523 + n.b / 255 * .312;
            return C = s.bounded(C, [
                -0.5957,
                .5957
            ]), x = s.bounded(x, [
                -0.5226,
                .5226
            ]), {
                y: m,
                i: C,
                q: x
            };
        case "XYZ":
            var A = [
                n.r,
                n.g,
                n.b
            ].map(function(r) {
                return r / 255;
            }).map(function(r) {
                return r <= .04045 ? r / 12.92 : Math.pow((r + .055) / 1.055, 2.4);
            }), S = s.getTransform("SRGB_XYZ").map(function(r) {
                return A.reduce(function(e, n, t) {
                    return r[t] * n + e;
                }, 0);
            }).map(function(r) {
                return 100 * r;
            }), O = $9de014d0ca2dbeda$var$slicedToArray(S, 3);
            return {
                X: O[0],
                Y: O[1],
                Z: O[2]
            };
        case "lms":
        case "cielab":
        case "cieluv":
        case "xyY":
            var I = o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "XYZ", n);
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, I);
        case "cielch":
            var j = o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "cieluv", n);
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, j);
        case "hsluv":
            var D = o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "cielch", n);
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, D);
    }
}
function $9de014d0ca2dbeda$var$fromCssRgb(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    n = n.replace(/((rgb\(|\))|[\s]*)/g, "").split(",");
    for(var a = 0; a < n.length; a++)n[a] = parseInt(n[a]);
    switch(e){
        case "rgb":
            return {
                r: n[0],
                g: n[1],
                b: n[2]
            };
        default:
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, {
                r: n[0],
                g: n[1],
                b: n[2]
            });
    }
}
function $9de014d0ca2dbeda$var$fromHsl(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    switch(e){
        case "rgb":
            if (0 == n.s) {
                var a = n.l / 100 * 255;
                return {
                    r: a,
                    g: a,
                    b: a
                };
            }
            var i, c, u;
            i = n.l >= 50 ? n.l / 100 + n.s / 100 - n.l / 100 * (n.s / 100) : n.l / 100 * (1 + n.s / 100), c = n.l / 100 * 2 - i;
            var l, h, v, p = ((u = n.h / 360) + .333) % 1, f = u, m = s.negMod(u - .333, 1);
            return l = 6 * p < 1 ? c + 6 * (i - c) * p : 2 * p < 1 ? i : 3 * p < 2 ? c + 6 * (.666 - p) * (i - c) : c, h = 6 * f < 1 ? c + 6 * (i - c) * f : 2 * f < 1 ? i : 3 * f < 2 ? c + 6 * (.666 - f) * (i - c) : c, v = 6 * m < 1 ? c + 6 * (i - c) * m : 2 * m < 1 ? i : 3 * m < 2 ? c + 6 * (.666 - m) * (i - c) : c, l < 0 && (l = 0), h < 0 && (h = 0), v < 0 && (v = 0), {
                r: 255 * l,
                g: 255 * h,
                b: 255 * v
            };
        case "csshsl":
            return "hsl(" + Math.round(n.h) + "," + Math.round(n.s) + "%," + Math.round(n.l) + "%)";
        case "hsv":
            n.s = n.s / 100, n.l = n.l / 100;
            var d = n.s * (n.l < .5 ? n.l : 1 - n.l);
            return {
                h: n.h,
                s: 100 * (2 * d / (n.l + d)),
                v: 100 * (n.l + d)
            };
        default:
            var b = o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "rgb", n);
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, b);
    }
}
function $9de014d0ca2dbeda$var$fromCssHsl(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    n = n.replace(/(hsl\(|\)|%|[\s]*)/g, "").split(",");
    for(var a = 0; a < n.length; a++)n[a] = parseInt(n[a]);
    switch(e){
        case "hsl":
            return {
                h: n[0],
                s: n[1],
                l: n[2]
            };
        default:
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, {
                h: n[0],
                s: n[1],
                l: n[2]
            });
    }
}
function $9de014d0ca2dbeda$var$fromHsv(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    switch(e){
        case "rgb":
            var a, i, c;
            n.h = n.h / 360, n.s = n.s / 100, n.v = n.v / 100;
            var u = 6 * n.h;
            6 == u && (u = 0);
            var l, h, v, p = Math.round(u), f = n.v * (1 - n.s), m = n.v * (1 - n.s * (u - p)), d = n.v * (1 - n.s * (1 - (u - p)));
            return 0 == p ? (l = n.v, h = d, v = f) : 1 == p ? (l = m, h = n.v, v = f) : 2 == p ? (l = f, h = n.v, v = d) : 3 == p ? (l = f, h = m, v = n.v) : 4 == p ? (l = d, h = f, v = n.v) : (l = n.v, h = f, v = m), a = 255 * l, i = 255 * h, c = 255 * v, {
                r: a,
                g: i,
                b: c
            };
        case "hsl":
            n.h = n.h / 360, n.s = n.s / 100, n.v = n.v / 100;
            return {
                h: 360 * n.h,
                s: 100 * ((2 - n.s) * n.v < 1 ? n.s * n.v / ((2 - n.s) * n.v) : n.s * n.v / (2 - (2 - n.s) * n.v)),
                l: 100 * ((2 - n.s) * n.v / 2)
            };
        default:
            var b = o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "rgb", n);
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, b);
    }
}
function $9de014d0ca2dbeda$var$fromCmyk(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    switch(e){
        case "rgb":
            return {
                r: a = 255 * (1 - n.c) * (1 - n.k),
                g: i = 255 * (1 - n.m) * (1 - n.k),
                b: c = 255 * (1 - n.y) * (1 - n.k)
            };
        case "cssrgb":
            var a = 255 * (1 - n.c) * (1 - n.k), i = 255 * (1 - n.m) * (1 - n.k), c = 255 * (1 - n.y) * (1 - n.k);
            return "rgb(" + Math.round(a) + "," + Math.round(i) + "," + Math.round(c) + ")";
        default:
            var u = o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "rgb", n);
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, u);
    }
}
function $9de014d0ca2dbeda$var$fromYiq(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    switch(n.i = s.bounded(n.i, [
        -0.5957,
        .5957
    ]), n.q = s.bounded(n.q, [
        -0.5226,
        .5226
    ]), e){
        case "rgb":
            var a = 255 * (n.y + .956 * n.i + .621 * n.q), i = 255 * (n.y + -0.272 * n.i + -0.647 * n.q), c = 255 * (n.y + -1.106 * n.i + -1.703 * n.q);
            return a = s.bounded(a, [
                0,
                255
            ]), i = s.bounded(i, [
                0,
                255
            ]), c = s.bounded(c, [
                0,
                255
            ]), {
                r: a,
                g: i,
                b: c
            };
        default:
            var u = o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "rgb", n);
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, u);
    }
}
function $9de014d0ca2dbeda$var$fromXYZ(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers, a = s.getIlluminant("D65");
    switch(e){
        case "rgb":
            var i = [
                n.X,
                n.Y,
                n.Z
            ].map(function(r) {
                return r / 100;
            }), c = s.getTransform("INVERSE_SRGB_XYZ").map(function(r) {
                return i.reduce(function(e, n, t) {
                    return r[t] * n + e;
                }, 0);
            }).map(function(r) {
                return r <= .0031308 ? 12.92 * r : 1.055 * Math.pow(r, 1 / 2.4) - .055;
            }).map(function(r) {
                return 255 * r;
            }), u = $9de014d0ca2dbeda$var$slicedToArray(c, 3), l = u[0], h = u[1], v = u[2];
            return s.boundedRgb({
                r: l,
                g: h,
                b: v
            });
        case "lms":
            var p = [
                n.X,
                n.Y,
                n.Z
            ].map(function(r) {
                return r / 100;
            }), f = s.getTransform("BRADFORD").map(function(r) {
                return p.reduce(function(e, n, t) {
                    return r[t] * n + e;
                }, 0);
            });
            return {
                rho: f[0],
                gamma: f[1],
                beta: f[2]
            };
        case "cielab":
            var m = n.X / a.X, d = n.Y / a.Y, b = n.Z / a.Z, g = function(r) {
                return r > .008856 ? s.cbrt(r) : (903.3 * r + 16) / 116;
            }, y = g(m), _ = g(d);
            return {
                L: 116 * _ - 16,
                a: 500 * (y - _),
                b: 200 * (_ - g(b))
            };
        case "cieluv":
            var M = n.Y / a.Y, Y = M > .008856 ? 116 * s.cbrt(M) - 16 : 903.3 * M, L = function(r) {
                return 4 * r.X / (r.X + 15 * r.Y + 3 * r.Z);
            }, X = function(r) {
                return 9 * r.Y / (r.X + 15 * r.Y + 3 * r.Z);
            };
            return {
                L: Y,
                u: 13 * Y * (L(n) - L(a)),
                v: 13 * Y * (X(n) - X(a))
            };
        case "xyY":
            return {
                x: n.X / (n.X + n.Y + n.Z),
                y: n.Y / (n.X + n.Y + n.Z),
                Y: n.Y
            };
        default:
            var Z = s.boundedRgb(o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "rgb", n));
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, Z);
    }
}
function $9de014d0ca2dbeda$var$fromxyY(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    switch(e){
        case "XYZ":
            var a = n.Y / n.y * n.x, i = n.Y / n.y * (1 - n.x - n.y);
            return {
                X: a,
                Y: n.Y,
                Z: i
            };
        default:
            var c = o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "XYZ", n);
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, c);
    }
}
function $9de014d0ca2dbeda$var$fromLms(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    switch(e){
        case "XYZ":
            var a = [
                n.rho,
                n.gamma,
                n.beta
            ], i = s.getTransform("INVERSE_BRADFORD").map(function(r) {
                return a.reduce(function(e, n, t) {
                    return r[t] * n + e;
                }, 0);
            });
            return {
                X: 100 * i[0],
                Y: 100 * i[1],
                Z: 100 * i[2]
            };
        default:
            var c = o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "XYZ", n);
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, c);
    }
}
function $9de014d0ca2dbeda$var$fromCieLab(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    switch(e){
        case "XYZ":
            var a = s.getIlluminant("D65"), i = (n.L + 16) / 116, c = n.a / 500 + i, u = i - n.b / 200, l = function(r) {
                return Math.pow(r, 3) > .008856 ? Math.pow(r, 3) : (116 * r - 16) / 903.3;
            }, h = l(c), v = l(u), p = n.L > 903.3 * .008856 ? Math.pow(i, 3) : n.L / 903.3;
            return {
                X: h * a.X,
                Y: p * a.Y,
                Z: v * a.Z
            };
        default:
            var f = o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "XYZ", n);
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, f);
    }
}
function $9de014d0ca2dbeda$var$fromCieLuv(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    switch(e){
        case "XYZ":
            var a = s.getIlluminant("D65"), i = function(r) {
                return 4 * r.X / (r.X + 15 * r.Y + 3 * r.Z);
            }(a), c = function(r) {
                return 9 * r.Y / (r.X + 15 * r.Y + 3 * r.Z);
            }(a), u = 1 / 3 * (52 * n.L / (n.u + 13 * n.L * i) - 1), l = n.L > 903.3 * .008856 ? Math.pow((n.L + 16) / 116, 3) : n.L / 903.3, h = -5 * l, v = (l * (39 * n.L / (n.v + 13 * n.L * c) - 5) - h) / (u - -1 / 3);
            return {
                X: 100 * v,
                Y: 100 * l,
                Z: 100 * (v * u + h)
            };
        case "cielch":
            var p = Math.sqrt(Math.pow(n.u, 2) + Math.pow(n.v, 2)), f = Math.atan2(n.v, n.u);
            return f < 0 && (f += 2 * Math.PI), f = s.toDeg(f), {
                L: n.L,
                C: p,
                h: f
            };
        default:
            var m = o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "XYZ", n);
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, m);
    }
}
function $9de014d0ca2dbeda$var$fromCieLch(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    switch(e){
        case "cieluv":
            var a = s.toRad(n.h), i = n.C * Math.cos(a), c = n.C * Math.sin(a);
            return {
                L: n.L,
                u: i,
                v: c
            };
        case "hsluv":
            if (n.L > 99.9999999) return {
                hu: n.h,
                s: 0,
                l: 100
            };
            if (n.L < 1e-8) return {
                hu: n.h,
                s: 0,
                l: 0
            };
            for(var u = (n.L + 16) / 1560896, l = u > .008856 ? u : n.L / 903.3, h = s.getTransform("INVERSE_SRGB_XYZ"), v = [], p = 0; p < 3; p++)for(var f = h[p][0], m = h[p][1], d = h[p][2], b = 0; b < 2; b++){
                var g = (284517 * f - 94839 * d) * l, y = (838422 * d + 769860 * m + 731718 * f) * n.L * l - 769860 * b * n.L, _ = (632260 * d - 126452 * m) * l + 126452 * b;
                v.push({
                    m: g / _,
                    b: y / _
                });
            }
            var M = Number.MAX_VALUE, Y = s.toRad(n.h);
            v.forEach(function(r) {
                var e = r.b / (Math.sin(Y) - r.m * Math.cos(Y));
                e >= 0 && (M = Math.min(M, e));
            });
            var L = M;
            return {
                hu: n.h,
                s: n.C / L * 100,
                l: n.L
            };
        default:
            var X = o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "cieluv", n);
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, X);
    }
}
function $9de014d0ca2dbeda$var$fromCieLch$1(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    switch(e){
        case "cielch":
            if (n.L > 99.9999999) return {
                L: 100,
                C: 0,
                h: n.hu
            };
            if (n.L < 1e-8) return {
                L: 0,
                C: 0,
                h: n.hu
            };
            for(var a = (n.l + 16) / 1560896, i = a > .008856 ? a : n.l / 903.3, c = s.getTransform("INVERSE_SRGB_XYZ"), u = [], l = 0; l < 3; l++)for(var h = c[l][0], v = c[l][1], p = c[l][2], f = 0; f < 2; f++){
                var m = (284517 * h - 94839 * p) * i, d = (838422 * p + 769860 * v + 731718 * h) * n.l * i - 769860 * f * n.l, b = (632260 * p - 126452 * v) * i + 126452 * f;
                u.push({
                    m: m / b,
                    b: d / b
                });
            }
            var g = Number.MAX_VALUE, y = s.toRad(n.hu);
            u.forEach(function(r) {
                var e = r.b / (Math.sin(y) - r.m * Math.cos(y));
                e >= 0 && (g = Math.min(g, e));
            });
            var _ = g;
            return {
                L: n.l,
                C: _ / 100 * n.s,
                h: n.hu
            };
        default:
            var M = o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "cielch", n);
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, M);
    }
}
function $9de014d0ca2dbeda$var$contains(r, e) {
    return Object.keys(r).every(function(r) {
        return -1 !== e.indexOf(r);
    });
}
function $9de014d0ca2dbeda$var$adapt(r, e, n, t) {
    var o = r.operations.convert(r, "XYZ", e), s = r.operations.convert(r, "lms", n);
    if (t) a = r.operations.convert(r, "lms", t);
    else var a = r.operations.convert(r, "lms", r.helpers.getIlluminant("D65"));
    var i = r.helpers.getTransform("BRADFORD"), c = r.helpers.getTransform("INVERSE_BRADFORD"), u = [
        [
            s.rho / a.rho,
            0,
            0
        ],
        [
            0,
            s.gamma / a.gamma,
            0
        ],
        [
            0,
            0,
            s.beta / a.beta
        ]
    ], l = r.helpers.matrixMultiply(c, u), h = r.helpers.matrixMultiply(l, i), v = [
        [
            o.X
        ],
        [
            o.Y
        ],
        [
            o.Z
        ]
    ], p = r.helpers.matrixMultiply(h, v), f = {
        X: p[0][0],
        Y: p[1][0],
        Z: p[2][0]
    };
    return r.helpers.ready(r, f);
}
function $9de014d0ca2dbeda$var$adjacent(r, e, n, t) {
    for(var o = r.operations.convert(r, "hsl", t), s = [
        {
            h: o.h,
            s: o.s,
            l: o.l
        }
    ], a = 0; a < n - 1; a++)o.h = r.helpers.negMod(o.h + e, 360), s.push({
        h: o.h,
        s: o.s,
        l: o.l
    });
    return r.helpers.ready(r, s);
}
function $9de014d0ca2dbeda$var$brightness(r, e, n) {
    var t = r.operations.convert(r, "hsl", n);
    return t.l += e, t.l < 0 ? t.l = 0 : t.l > 100 && (t.l = 100), r.helpers.ready(r, t);
}
function $9de014d0ca2dbeda$var$complementary(r, e) {
    var n = r.operations.convert(r, "hsl", e);
    return n.h = (n.h + 180) % 360, r.helpers.ready(r, n);
}
function $9de014d0ca2dbeda$var$contrast(r, e, n) {
    var t = r.operations.convert(r, "rgb", n);
    return t.r = 255 * ((t.r / 255 - .5) * e + .5), t.r < 0 ? t.r = 0 : t.r > 255 && (t.r = 255), t.g = 255 * ((t.g / 255 - .5) * e + .5), t.g < 0 ? t.g = 0 : t.g > 255 && (t.g = 255), t.b = 255 * ((t.b / 255 - .5) * e + .5), t.b < 0 ? t.b = 0 : t.b > 255 && (t.b = 255), r.helpers.ready(r, t);
}
function $9de014d0ca2dbeda$var$contrastRatio(r, e) {
    var n = r.operations.convert(r, "rgb", e);
    return n = (299 * n.r + 587 * n.g + 114 * n.b) / 1e3 >= 128 ? {
        r: 0,
        g: 0,
        b: 0
    } : {
        r: 255,
        g: 255,
        b: 255
    }, r.helpers.ready(r, n);
}
function $9de014d0ca2dbeda$var$convert(r, e, n) {
    if (Object.keys(r.conversions).indexOf(e) > -1) {
        n.colour ? n = n.colour : n.colours && (n = n.colours);
        var t = r.helpers.determineMode(n);
        return t != e ? r.conversions[t].convert(r, e, n) : n;
    }
    return r.helpers.ready(r, e);
}
function $9de014d0ca2dbeda$var$difference(r, e, n, t, o) {
    t = t || 1, o = o || 1;
    var s = r.operations.convert(r, "cielab", e), a = r.operations.convert(r, "cielab", n), i = Math.sqrt(Math.pow(s.a, 2) + Math.pow(s.b, 2)), c = i - Math.sqrt(Math.pow(a.a, 2) + Math.pow(a.b, 2)), u = s.L - a.L, l = s.a - a.a, h = s.b - a.b, v = Math.sqrt(Math.pow(l, 2) + Math.pow(h, 2) - Math.pow(c, 2)), p = s.L < 16 ? .511 : .040975 * s.L / (1.01765 * s.L), f = .0638 * i / (1.0131 * i), m = Math.atan2(s.b, s.a), d = m >= 0 ? m : m + 360, b = 164 <= d && d <= 345 ? .56 + Math.abs(.2 * Math.cos(r.helpers.toRad(d + 168))) : .36 + Math.abs(.4 * Math.cos(r.helpers.toRad(d + 35))), g = Math.pow(i, 4) / (Math.pow(i, 4) + 1900), y = f * (g * b + 1 - g), _ = Math.pow(u / (t * p), 2);
    return Math.sqrt(_ + _ + _);
}
function $9de014d0ca2dbeda$var$fade(r, e, n, t) {
    var o = r.operations.convert(r, "rgb", n), s = r.operations.convert(r, "rgb", t), a = [
        o
    ];
    e -= 1;
    for(var i = (s.r - o.r) / e, c = (s.g - o.g) / e, u = (s.b - o.b) / e, l = {
        r: o.r,
        g: o.g,
        b: o.b
    }, h = 0; h < e - 1; h++)l.r = r.helpers.slopeMod(l.r + i, 255), l.g = r.helpers.slopeMod(l.g + c, 255), l.b = r.helpers.slopeMod(l.b + u, 255), a.push({
        r: l.r,
        g: l.g,
        b: l.b
    });
    return a.push(s), r.helpers.ready(r, a);
}
function $9de014d0ca2dbeda$var$greyscale(r, e) {
    var n = r.operations.convert(r, "rgb", e), t = (n.r + n.g + n.b) / 3;
    return n = {
        r: t,
        g: t,
        b: t
    }, r.helpers.ready(r, n);
}
function $9de014d0ca2dbeda$var$hue(r, e, n) {
    var t = r.operations.convert(r, "hsl", n);
    return t.h = r.helpers.negMod(t.h + e, 360), r.helpers.ready(r, t);
}
function $9de014d0ca2dbeda$var$invert(r, e) {
    var n = r.operations.convert(r, "rgb", e);
    return n.r = r.helpers.negMod(255 - n.r, 255), n.g = r.helpers.negMod(255 - n.g, 255), n.b = r.helpers.negMod(255 - n.b, 255), r.helpers.ready(r, n);
}
function $9de014d0ca2dbeda$var$invertLightness(r, e) {
    var n = r.operations.convert(r, "hsl", e);
    return n.l = 100 - n.l, r.helpers.ready(r, n);
}
function $9de014d0ca2dbeda$var$mid(r, e, n) {
    var t = r.operations.convert(r, "hsl", e), o = r.operations.convert(r, "hsl", n), s = {
        h: (t.h + o.h) / 2,
        s: (t.s + o.s) / 2,
        l: (t.l + o.l) / 2
    };
    return r.helpers.ready(r, s);
}
function $9de014d0ca2dbeda$var$multiply(r, e, n) {
    var t = r.operations.convert(r, "hsl", e), o = r.operations.convert(r, "hsl", n), s = {
        h: t.h,
        s: t.s,
        l: t.l / 100 * (o.l / 100) * 100
    };
    return s.l = s.l > 100 ? 100 : s.l, s.l = s.l < 0 ? 0 : s.l, r.helpers.ready(r, s);
}
function $9de014d0ca2dbeda$var$saturation(r, e, n) {
    var t = r.operations.convert(r, "hsl", n);
    return t.s += e, t.s < 0 ? t.s = 0 : t.s > 100 && (t.s = 100), r.helpers.ready(r, t);
}
function $9de014d0ca2dbeda$var$sepia(r, e) {
    var n = r.operations.convert(r, "rgb", e), t = {};
    return t.r = .393 * n.r + .769 * n.g + .189 * n.b, t.g = .349 * n.r + .686 * n.g + .168 * n.b, t.b = .272 * n.r + .534 * n.g + .131 * n.b, r.helpers.ready(r, t);
}
function $9de014d0ca2dbeda$var$shade(r, e, n) {
    var t = r.operations.convert(r, "hsv", n);
    return t.v += e, t.v < 0 ? t.v = 0 : t.v > 100 && (t.v = 100), r.helpers.ready(r, t);
}
function $9de014d0ca2dbeda$var$temperature(r, e) {
    var n = r.operations.convert(r, "xyY", e), t = (n.x - .332) / (n.y - .1858);
    return -449 * Math.pow(t, 3) + 3525 * Math.pow(t, 2) - 6823.3 * t + 5520.33;
}
function $9de014d0ca2dbeda$var$tetrad(r, e) {
    for(var n = r.operations.convert(r, "hsl", e), t = [
        {
            h: n.h,
            s: n.s,
            l: n.l
        }
    ], o = 0; o < 3; o++)n.h = (n.h + 90) % 360, t.push({
        h: n.h,
        s: n.s,
        l: n.l
    });
    return r.helpers.ready(r, t);
}
function $9de014d0ca2dbeda$var$triad(r, e) {
    for(var n = r.operations.convert(r, "hsl", e), t = [
        {
            h: n.h,
            s: n.s,
            l: n.l
        }
    ], o = 0; o < 2; o++)n.h = (n.h + 120) % 360, t.push({
        h: n.h,
        s: n.s,
        l: n.l
    });
    return r.helpers.ready(r, t);
}
var $9de014d0ca2dbeda$var$fromHex_1 = $9de014d0ca2dbeda$var$fromHex, $9de014d0ca2dbeda$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(r) {
    return typeof r;
} : function(r) {
    return r && "function" == typeof Symbol && r.constructor === Symbol && r !== Symbol.prototype ? "symbol" : typeof r;
}, $9de014d0ca2dbeda$var$slicedToArray = function() {
    function r(r, e) {
        var n = [], t = !0, o = !1, s = void 0;
        try {
            for(var a, i = r[Symbol.iterator](); !(t = (a = i.next()).done) && (n.push(a.value), !e || n.length !== e); t = !0);
        } catch (r) {
            o = !0, s = r;
        } finally{
            try {
                !t && i.return && i.return();
            } finally{
                if (o) throw s;
            }
        }
        return n;
    }
    return function(e, n) {
        if (Array.isArray(e)) return e;
        if (Symbol.iterator in Object(e)) return r(e, n);
        throw new TypeError("Invalid attempt to destructure non-iterable instance");
    };
}(), $9de014d0ca2dbeda$var$toConsumableArray = function(r) {
    if (Array.isArray(r)) {
        for(var e = 0, n = Array(r.length); e < r.length; e++)n[e] = r[e];
        return n;
    }
    return Array.from(r);
}, $9de014d0ca2dbeda$var$fromRgb_1 = $9de014d0ca2dbeda$var$fromRgb, $9de014d0ca2dbeda$var$fromCssRgb_1 = $9de014d0ca2dbeda$var$fromCssRgb, $9de014d0ca2dbeda$var$fromHsl_1 = $9de014d0ca2dbeda$var$fromHsl, $9de014d0ca2dbeda$var$fromCssHsl_1 = $9de014d0ca2dbeda$var$fromCssHsl, $9de014d0ca2dbeda$var$fromHsv_1 = $9de014d0ca2dbeda$var$fromHsv, $9de014d0ca2dbeda$var$fromCmyk_1 = $9de014d0ca2dbeda$var$fromCmyk, $9de014d0ca2dbeda$var$fromYiq_1 = $9de014d0ca2dbeda$var$fromYiq, $9de014d0ca2dbeda$var$fromXYZ_1 = $9de014d0ca2dbeda$var$fromXYZ, $9de014d0ca2dbeda$var$fromxyY_1 = $9de014d0ca2dbeda$var$fromxyY, $9de014d0ca2dbeda$var$fromLms_1 = $9de014d0ca2dbeda$var$fromLms, $9de014d0ca2dbeda$var$fromCieLab_1 = $9de014d0ca2dbeda$var$fromCieLab, $9de014d0ca2dbeda$var$fromCieLuv_1 = $9de014d0ca2dbeda$var$fromCieLuv, $9de014d0ca2dbeda$var$fromCieLch_1 = $9de014d0ca2dbeda$var$fromCieLch, $9de014d0ca2dbeda$var$fromHsluv = $9de014d0ca2dbeda$var$fromCieLch$1, $9de014d0ca2dbeda$var$index = {
    hex: {
        test: function(r) {
            return "string" == typeof r && "#" === r.slice(0, 1);
        },
        convert: $9de014d0ca2dbeda$var$fromHex_1
    },
    rgb: {
        test: function(r) {
            return $9de014d0ca2dbeda$var$contains(r, [
                "r",
                "g",
                "b"
            ]);
        },
        convert: $9de014d0ca2dbeda$var$fromRgb_1
    },
    cssrgb: {
        test: function(r) {
            return "string" == typeof r && "rgb(" === r.slice(0, 4);
        },
        convert: $9de014d0ca2dbeda$var$fromCssRgb_1
    },
    hsl: {
        test: function(r) {
            return $9de014d0ca2dbeda$var$contains(r, [
                "h",
                "s",
                "l"
            ]);
        },
        convert: $9de014d0ca2dbeda$var$fromHsl_1
    },
    csshsl: {
        test: function(r) {
            return "string" == typeof r && "hsl(" === r.slice(0, 4);
        },
        convert: $9de014d0ca2dbeda$var$fromCssHsl_1
    },
    hsv: {
        test: function(r) {
            return $9de014d0ca2dbeda$var$contains(r, [
                "h",
                "s",
                "v"
            ]);
        },
        convert: $9de014d0ca2dbeda$var$fromHsv_1
    },
    cmyk: {
        test: function(r) {
            return $9de014d0ca2dbeda$var$contains(r, [
                "c",
                "m",
                "y",
                "k"
            ]);
        },
        convert: $9de014d0ca2dbeda$var$fromCmyk_1
    },
    yiq: {
        test: function(r) {
            return $9de014d0ca2dbeda$var$contains(r, [
                "y",
                "i",
                "q"
            ]);
        },
        convert: $9de014d0ca2dbeda$var$fromYiq_1
    },
    XYZ: {
        test: function(r) {
            return $9de014d0ca2dbeda$var$contains(r, [
                "X",
                "Y",
                "Z"
            ]);
        },
        convert: $9de014d0ca2dbeda$var$fromXYZ_1
    },
    xyY: {
        test: function(r) {
            return $9de014d0ca2dbeda$var$contains(r, [
                "x",
                "y",
                "Y"
            ]);
        },
        convert: $9de014d0ca2dbeda$var$fromxyY_1
    },
    lms: {
        test: function(r) {
            return $9de014d0ca2dbeda$var$contains(r, [
                "rho",
                "gamma",
                "beta"
            ]);
        },
        convert: $9de014d0ca2dbeda$var$fromLms_1
    },
    cielab: {
        test: function(r) {
            return $9de014d0ca2dbeda$var$contains(r, [
                "L",
                "a",
                "b"
            ]);
        },
        convert: $9de014d0ca2dbeda$var$fromCieLab_1
    },
    cieluv: {
        test: function(r) {
            return $9de014d0ca2dbeda$var$contains(r, [
                "L",
                "u",
                "v"
            ]);
        },
        convert: $9de014d0ca2dbeda$var$fromCieLuv_1
    },
    cielch: {
        test: function(r) {
            return $9de014d0ca2dbeda$var$contains(r, [
                "L",
                "C",
                "h"
            ]);
        },
        convert: $9de014d0ca2dbeda$var$fromCieLch_1
    },
    hsluv: {
        test: function(r) {
            return $9de014d0ca2dbeda$var$contains(r, [
                "hu",
                "s",
                "l"
            ]);
        },
        convert: $9de014d0ca2dbeda$var$fromHsluv
    }
}, $9de014d0ca2dbeda$var$adapt_1 = $9de014d0ca2dbeda$var$adapt, $9de014d0ca2dbeda$var$adjacent_1 = $9de014d0ca2dbeda$var$adjacent, $9de014d0ca2dbeda$var$brightness_1 = $9de014d0ca2dbeda$var$brightness, $9de014d0ca2dbeda$var$complementary_1 = $9de014d0ca2dbeda$var$complementary, $9de014d0ca2dbeda$var$contrast_1 = $9de014d0ca2dbeda$var$contrast, $9de014d0ca2dbeda$var$contrastRatio_1 = $9de014d0ca2dbeda$var$contrastRatio, $9de014d0ca2dbeda$var$convert_1 = $9de014d0ca2dbeda$var$convert, $9de014d0ca2dbeda$var$difference_1 = $9de014d0ca2dbeda$var$difference, $9de014d0ca2dbeda$var$fade_1 = $9de014d0ca2dbeda$var$fade, $9de014d0ca2dbeda$var$greyscale_1 = $9de014d0ca2dbeda$var$greyscale, $9de014d0ca2dbeda$var$hue_1 = $9de014d0ca2dbeda$var$hue, $9de014d0ca2dbeda$var$invert_1 = $9de014d0ca2dbeda$var$invert, $9de014d0ca2dbeda$var$invertLightness_1 = $9de014d0ca2dbeda$var$invertLightness, $9de014d0ca2dbeda$var$mid_1 = $9de014d0ca2dbeda$var$mid, $9de014d0ca2dbeda$var$multiply_1 = $9de014d0ca2dbeda$var$multiply, $9de014d0ca2dbeda$var$saturation_1 = $9de014d0ca2dbeda$var$saturation, $9de014d0ca2dbeda$var$sepia_1 = $9de014d0ca2dbeda$var$sepia, $9de014d0ca2dbeda$var$shade_1 = $9de014d0ca2dbeda$var$shade, $9de014d0ca2dbeda$var$temperature_1 = $9de014d0ca2dbeda$var$temperature, $9de014d0ca2dbeda$var$tetrad_1 = $9de014d0ca2dbeda$var$tetrad, $9de014d0ca2dbeda$var$triad_1 = $9de014d0ca2dbeda$var$triad, $9de014d0ca2dbeda$var$index$2 = {
    adapt: $9de014d0ca2dbeda$var$adapt_1,
    adjacent: $9de014d0ca2dbeda$var$adjacent_1,
    brightness: $9de014d0ca2dbeda$var$brightness_1,
    complementary: $9de014d0ca2dbeda$var$complementary_1,
    contrast: $9de014d0ca2dbeda$var$contrast_1,
    contrastRatio: $9de014d0ca2dbeda$var$contrastRatio_1,
    convert: $9de014d0ca2dbeda$var$convert_1,
    difference: $9de014d0ca2dbeda$var$difference_1,
    fade: $9de014d0ca2dbeda$var$fade_1,
    greyscale: $9de014d0ca2dbeda$var$greyscale_1,
    hue: $9de014d0ca2dbeda$var$hue_1,
    invert: $9de014d0ca2dbeda$var$invert_1,
    invertLightness: $9de014d0ca2dbeda$var$invertLightness_1,
    mid: $9de014d0ca2dbeda$var$mid_1,
    multiply: $9de014d0ca2dbeda$var$multiply_1,
    saturation: $9de014d0ca2dbeda$var$saturation_1,
    sepia: $9de014d0ca2dbeda$var$sepia_1,
    shade: $9de014d0ca2dbeda$var$shade_1,
    temperature: $9de014d0ca2dbeda$var$temperature_1,
    tetrad: $9de014d0ca2dbeda$var$tetrad_1,
    triad: $9de014d0ca2dbeda$var$triad_1
}, $9de014d0ca2dbeda$var$constants = {
    ILLUMINANTS: {
        A: {
            X: 1.0985 * 100,
            Y: 100,
            Z: 35.585
        },
        B: {
            X: 99.072,
            Y: 100,
            Z: 85.223
        },
        C: {
            X: 98.074,
            Y: 100,
            Z: 118.232
        },
        D50: {
            X: 96.422,
            Y: 100,
            Z: 82.521
        },
        D55: {
            X: 95.682,
            Y: 100,
            Z: 92.149
        },
        D65: {
            X: 95.047,
            Y: 100,
            Z: 108.883
        },
        D75: {
            X: 94.972,
            Y: 100,
            Z: 122.638
        },
        E: {
            X: 100,
            Y: 100,
            Z: 100
        },
        F2: {
            X: .99186 * 100,
            Y: 100,
            Z: 67.393
        },
        F7: {
            X: 95.041,
            Y: 100,
            Z: 108.747
        },
        F11: {
            X: 1.00962 * 100,
            Y: 100,
            Z: 64.35
        }
    },
    TRANSFORMS: {
        BRADFORD: [
            [
                .8951,
                .2664,
                -0.1614
            ],
            [
                -0.7502,
                1.7135,
                .0367
            ],
            [
                .0389,
                -0.0685,
                1.0296
            ]
        ],
        INVERSE_BRADFORD: [
            [
                .9869929,
                -0.1470543,
                .1599627
            ],
            [
                .4323053,
                .5183603,
                .0492912
            ],
            [
                -0.0085287,
                .0400428,
                .9684867
            ]
        ],
        SRGB_XYZ: [
            [
                .4124,
                .3576,
                .1805
            ],
            [
                .2126,
                .7152,
                .0722
            ],
            [
                .0193,
                .1192,
                .9505
            ]
        ],
        INVERSE_SRGB_XYZ: [
            [
                3.2406,
                -1.5372,
                -0.4986
            ],
            [
                -0.9689,
                1.8758,
                .0415
            ],
            [
                .0557,
                -0.204,
                1.057
            ]
        ]
    }
}, $9de014d0ca2dbeda$var$api = function(r, e, n) {
    var t = Object.keys(r.operations).reduce(function(e, t) {
        var o = r.operations[t];
        return e[t] = function() {
            for(var e = arguments.length, t = Array(e), s = 0; s < e; s++)t[s] = arguments[s];
            var a = t.slice(0).map(function(r) {
                return "object" === (void 0 === r ? "undefined" : $9de014d0ca2dbeda$var$_typeof(r)) ? Object.assign({}, r) : r;
            });
            if (n && n.colours) return function e(n) {
                var t = n.map(function(n) {
                    if (Array.isArray(n)) {
                        var t = e(n);
                        return t.colours || t.colour;
                    }
                    var s = o.apply(void 0, [
                        r
                    ].concat($9de014d0ca2dbeda$var$toConsumableArray(a), [
                        n
                    ]));
                    return "object" === (void 0 === s ? "undefined" : $9de014d0ca2dbeda$var$_typeof(s)) ? s.colours || s.colour : s;
                });
                return "number" != typeof t[0] ? r.helpers.ready(r, t) : t;
            }(n.colours);
            return o.apply(void 0, [
                r
            ].concat($9de014d0ca2dbeda$var$toConsumableArray(a), [
                n ? n.colour : void 0
            ]));
        }, e;
    }, {});
    return n || (t = Object.assign(t, e)), t;
}, $9de014d0ca2dbeda$var$api_1 = $9de014d0ca2dbeda$var$api, $9de014d0ca2dbeda$var$helpers = {
    getIlluminant: function(r) {
        return $9de014d0ca2dbeda$var$constants.ILLUMINANTS[r];
    },
    getTransform: function(r) {
        return $9de014d0ca2dbeda$var$constants.TRANSFORMS[r];
    },
    matrixMultiply: function(r, e) {
        for(var n = [], t = 0; t < r.length; t++){
            n[t] = [];
            for(var o = 0; o < e[0].length; o++){
                for(var s = 0, a = 0; a < r[0].length; a++)s += r[t][a] * e[a][o];
                n[t][o] = s;
            }
        }
        return n;
    },
    cbrt: function(r) {
        if (Math.cbrt) return Math.cbrt(r);
        var e = Math.pow(Math.abs(r), 1 / 3);
        return r < 0 ? -e : e;
    },
    toRad: function(r) {
        return r * (Math.PI / 180);
    },
    toDeg: function(r) {
        return r * (180 / Math.PI);
    },
    negMod: function(r, e) {
        return (r % e + e) % e;
    },
    slopeMod: function(r) {
        function e(e, n) {
            return r.apply(this, arguments);
        }
        return e.toString = function() {
            return r.toString();
        }, e;
    }(function(r, e) {
        return r > 2 * e ? slopeMod(r - 2 * e, e) : r > e ? 2 * e - r : r < 0 ? slopeMod(r + 2 * e, e) : r;
    }),
    bounded: function(r, e) {
        return r < e[0] ? r = e[0] : r > e[1] && (r = e[1]), r;
    },
    boundedRgb: function(r) {
        var e = this, n = function(r) {
            return e.bounded(r, [
                0,
                255
            ]);
        };
        return {
            r: n(r.r),
            g: n(r.g),
            b: n(r.b)
        };
    },
    determineMode: function(r) {
        for(var e in $9de014d0ca2dbeda$var$index)if ($9de014d0ca2dbeda$var$index.hasOwnProperty(e) && $9de014d0ca2dbeda$var$index[e].test(r)) return e;
        return null;
    },
    ready: function(r, e) {
        var n = r.conversions, t = r.operations, o = r.helpers, s = {};
        switch(Object.prototype.toString.call(e)){
            case "[object Object]":
            case "[object String]":
                s.colour = e;
                for(var a in n)n.hasOwnProperty(a) && function(r) {
                    Object.defineProperty(s, r, {
                        get: function() {
                            o.determineMode(e);
                            return t.convert({
                                conversions: n,
                                operations: t,
                                helpers: o
                            }, r, e);
                        },
                        enumerable: !0
                    });
                }(a);
                return s = Object.assign(s, $9de014d0ca2dbeda$var$api_1({
                    conversions: n,
                    operations: t,
                    helpers: o
                }, $9de014d0ca2dbeda$var$constants, s));
            case "[object Array]":
                s.colours = e;
                for(var i in n)n.hasOwnProperty(i) && function(r) {
                    Object.defineProperty(s, r, {
                        get: function() {
                            return function e(s) {
                                return s.map(function(s) {
                                    return Array.isArray(s) ? e(s) : t.convert({
                                        conversions: n,
                                        operations: t,
                                        helpers: o
                                    }, r, s);
                                });
                            }(e);
                        },
                        enumerable: !0
                    });
                }(i);
                return s = Object.assign(s, $9de014d0ca2dbeda$var$api_1({
                    conversions: n,
                    operations: t,
                    helpers: o
                }, $9de014d0ca2dbeda$var$constants, s));
            default:
                return null;
        }
    }
}, $9de014d0ca2dbeda$var$helpers_1 = $9de014d0ca2dbeda$var$helpers, $9de014d0ca2dbeda$var$dependencies = {
    conversions: $9de014d0ca2dbeda$var$index,
    operations: $9de014d0ca2dbeda$var$index$2,
    helpers: $9de014d0ca2dbeda$var$helpers_1
}, $9de014d0ca2dbeda$var$entry = $9de014d0ca2dbeda$var$api_1($9de014d0ca2dbeda$var$dependencies, $9de014d0ca2dbeda$var$constants);
var $9de014d0ca2dbeda$export$2e2bcd8739ae039 = $9de014d0ca2dbeda$var$entry;


function $dee5afe6657ddc59$export$2e2bcd8739ae039(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}


function $7f4468c532e18ee3$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return (0, $dee5afe6657ddc59$export$2e2bcd8739ae039)(r);
}


function $fd02ec816f6f909e$export$2e2bcd8739ae039(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}



function $2e684a693b53c115$export$2e2bcd8739ae039(r, a) {
    if (r) {
        if ("string" == typeof r) return (0, $dee5afe6657ddc59$export$2e2bcd8739ae039)(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? (0, $dee5afe6657ddc59$export$2e2bcd8739ae039)(r, a) : void 0;
    }
}


function $6c314cee797deebd$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}


function $dd0bb0a33f0319e0$export$2e2bcd8739ae039(r) {
    return (0, $7f4468c532e18ee3$export$2e2bcd8739ae039)(r) || (0, $fd02ec816f6f909e$export$2e2bcd8739ae039)(r) || (0, $2e684a693b53c115$export$2e2bcd8739ae039)(r) || (0, $6c314cee797deebd$export$2e2bcd8739ae039)();
}


var $6a977020bdd38fa5$var$hex = '[a-z0-9]';
var $6a977020bdd38fa5$var$shortHandHexColorPattern = new RegExp("#(".concat($6a977020bdd38fa5$var$hex, ")(").concat($6a977020bdd38fa5$var$hex, ")(").concat($6a977020bdd38fa5$var$hex, ")"), 'i');
var $6a977020bdd38fa5$var$repeat = function repeat(str, times) {
    return (0, $dd0bb0a33f0319e0$export$2e2bcd8739ae039)(Array(times)).map(function() {
        return str;
    }).join('');
};
var $6a977020bdd38fa5$var$isShortHexColor = function isShortHexColor(color) {
    return color && color.length === 4;
};
var $6a977020bdd38fa5$var$completeHexColor = function completeHexColor(colors) {
    var hex = colors.map(function(color) {
        return $6a977020bdd38fa5$var$repeat(color, 2);
    }).join('');
    return "#".concat(hex);
};
var $6a977020bdd38fa5$var$completeTriplet = function completeTriplet(colors) {
    return "#".concat($6a977020bdd38fa5$var$repeat(colors[1], 6));
};
var $6a977020bdd38fa5$var$isTriplet = function isTriplet(colors) {
    return colors[0] === colors[1] && colors[1] === colors[2];
};
var $6a977020bdd38fa5$export$db8d2130677f868c = function convertHexShorthand(color) {
    if ($6a977020bdd38fa5$var$isShortHexColor(color)) {
        // when color = '#ccc', matches is structured as ['#ccc', 'c', 'c', 'c', ...]
        var matches = color.match($6a977020bdd38fa5$var$shortHandHexColorPattern);
        if (matches) {
            var colors = matches.slice(1, 4);
            if ($6a977020bdd38fa5$var$isTriplet(colors)) return $6a977020bdd38fa5$var$completeTriplet(colors);
            else return $6a977020bdd38fa5$var$completeHexColor(colors);
        }
    }
    // return the color as is when it's not hex color shorthand
    return color;
};


var $a6e8df1eeab168d6$export$10a10e7cd1193377 = function generateTextColor(color) {
    var converted = (0, $6a977020bdd38fa5$export$db8d2130677f868c)(color);
    return (0, $9de014d0ca2dbeda$export$2e2bcd8739ae039).contrastRatio(converted).hex;
};


var $8c247cd04a65f7fe$export$bba5a971afe05444 = function getBoxShadow(color) {
    return "0 0 0 2px ".concat(color);
};





function $fad81d3f888775e2$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $fad81d3f888775e2$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $fad81d3f888775e2$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $d93598d00ce909df$export$2e2bcd8739ae039)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $fad81d3f888775e2$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $fad81d3f888775e2$export$7229be6d7219ee6a = function hexToRGBA(hex) {
    var opacity = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
    var rgba = $fad81d3f888775e2$var$_objectSpread($fad81d3f888775e2$var$_objectSpread({}, (0, $9de014d0ca2dbeda$export$2e2bcd8739ae039).convert(hex).rgb), {}, {
        a: opacity
    });
    return "rgba(".concat(Object.values(rgba).join(', '), ")");
};


var $7371a882583163ce$export$77a1051494882576 = function getContrastColor(contrastValue, opacityValue, color) {
    return (0, $fad81d3f888775e2$export$7229be6d7219ee6a)((0, $9de014d0ca2dbeda$export$2e2bcd8739ae039).contrast(contrastValue, color).hex, opacityValue);
};



function $80737e0d5599a7a8$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $80737e0d5599a7a8$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $80737e0d5599a7a8$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $d93598d00ce909df$export$2e2bcd8739ae039)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $80737e0d5599a7a8$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $80737e0d5599a7a8$var$generateOpacityValue = function generateOpacityValue(color) {
    return color === '#000000' ? 0.3 : 0.6;
};
// eslint-disable-next-line @repo/internal/react/consistent-types-definitions
var $80737e0d5599a7a8$var$generateButtonCSSStates = function generateButtonCSSStates(colors, buttonType) {
    var backgroundColor = colors.backgroundColor, color = colors.color, highlightColor = colors.highlightColor;
    // Add less opacity for white text so it is still legible.
    var opacityValue = $80737e0d5599a7a8$var$generateOpacityValue(color);
    var isCreateButton = buttonType === 'create';
    return {
        active: {
            backgroundColor: isCreateButton ? (0, $fad81d3f888775e2$export$7229be6d7219ee6a)(backgroundColor, 0.65) : (0, $7371a882583163ce$export$77a1051494882576)(0.3, opacityValue, backgroundColor),
            boxShadow: (0, $8c247cd04a65f7fe$export$bba5a971afe05444)('transparent'),
            color: color
        },
        default: {
            backgroundColor: backgroundColor,
            boxShadow: (0, $8c247cd04a65f7fe$export$bba5a971afe05444)('transparent'),
            color: color
        },
        focus: {
            boxShadow: 'none',
            color: color,
            backgroundColor: backgroundColor
        },
        hover: {
            backgroundColor: isCreateButton ? (0, $fad81d3f888775e2$export$7229be6d7219ee6a)(backgroundColor, 0.8) : (0, $7371a882583163ce$export$77a1051494882576)(0.1, opacityValue, backgroundColor),
            boxShadow: (0, $8c247cd04a65f7fe$export$bba5a971afe05444)('transparent'),
            color: color
        },
        selected: {
            color: color,
            backgroundColor: (0, $7371a882583163ce$export$77a1051494882576)(0.3, opacityValue, backgroundColor),
            borderColor: highlightColor,
            boxShadow: (0, $8c247cd04a65f7fe$export$bba5a971afe05444)('transparent')
        },
        selectedHover: {
            color: color,
            backgroundColor: (0, $7371a882583163ce$export$77a1051494882576)(0.3, opacityValue, backgroundColor),
            borderColor: highlightColor,
            boxShadow: (0, $8c247cd04a65f7fe$export$bba5a971afe05444)('transparent')
        }
    };
};
var $80737e0d5599a7a8$var$generateCreateButtonColors = function generateCreateButtonColors(_themeBackground, themeHighlight) {
    return {
        backgroundColor: themeHighlight,
        color: (0, $a6e8df1eeab168d6$export$10a10e7cd1193377)(themeHighlight),
        highlightColor: themeHighlight
    };
};
var $80737e0d5599a7a8$export$2e4ecffaca289a18 = function generateTheme(themeColors) {
    var backgroundColor = themeColors.backgroundColor, highlightColor = themeColors.highlightColor, name = themeColors.name;
    var color = (0, $a6e8df1eeab168d6$export$10a10e7cd1193377)(backgroundColor);
    var colors = $80737e0d5599a7a8$var$_objectSpread($80737e0d5599a7a8$var$_objectSpread({}, themeColors), {}, {
        color: color
    });
    if (name === (0, $ffde35be8257144f$export$2491e13b198e597d)) return 0, $1ed4db7869293530$export$77823bc9863eaa03;
    return {
        mode: {
            create: $80737e0d5599a7a8$var$generateButtonCSSStates($80737e0d5599a7a8$var$generateCreateButtonColors(backgroundColor, highlightColor), 'create'),
            iconButton: $80737e0d5599a7a8$var$generateButtonCSSStates(colors, 'iconButton'),
            primaryButton: $80737e0d5599a7a8$var$generateButtonCSSStates(colors, 'primaryButton'),
            navigation: {
                backgroundColor: backgroundColor,
                color: color
            },
            productHome: {
                color: color,
                iconColor: color,
                textColor: color,
                backgroundColor: highlightColor,
                borderRight: "var(--ds-border-width, 1px)".concat(" solid ", (0, $fad81d3f888775e2$export$7229be6d7219ee6a)(color, 0.5))
            },
            search: {
                default: {
                    backgroundColor: backgroundColor,
                    color: color,
                    borderColor: (0, $fad81d3f888775e2$export$7229be6d7219ee6a)(color, 0.5)
                },
                focus: {
                    borderColor: (0, $fad81d3f888775e2$export$7229be6d7219ee6a)(highlightColor, 0.8),
                    boxShadow: (0, $8c247cd04a65f7fe$export$bba5a971afe05444)((0, $fad81d3f888775e2$export$7229be6d7219ee6a)(highlightColor, 0.5))
                },
                hover: {
                    backgroundColor: (0, $7371a882583163ce$export$77a1051494882576)(0.1, $80737e0d5599a7a8$var$generateOpacityValue(color), backgroundColor),
                    color: color
                }
            },
            skeleton: {
                backgroundColor: color,
                opacity: 0.08
            }
        }
    };
};


var $f3ab24b4d1e497c1$export$eeee8619e1b91cb0 = (0, $80737e0d5599a7a8$export$2e4ecffaca289a18)({
    name: (0, $ffde35be8257144f$export$2491e13b198e597d),
    backgroundColor: '#FFFFFF',
    highlightColor: '#0052CC'
});


var $4692d5c70ecef3eb$export$164de7ab8df77ef0 = (0, $f3ab24b4d1e497c1$export$eeee8619e1b91cb0);


var $5FkrB = parcelRequire("5FkrB");

var $dcab9c7966c8b191$export$2c657da244d00bd6 = /*#__PURE__*/ (0, $5FkrB.createContext)((0, $4692d5c70ecef3eb$export$164de7ab8df77ef0));


var $0cbbe03340c55ac9$export$d8964aec282183a3 = (0, $dcab9c7966c8b191$export$2c657da244d00bd6).Provider;



function $8ba683f37517a100$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return r;
}


function $32c660371a132632$export$2e2bcd8739ae039(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}



function $abc8f1ceefe7f4b4$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}


function $8ddf8a10eebb4436$export$2e2bcd8739ae039(r, e) {
    return (0, $8ba683f37517a100$export$2e2bcd8739ae039)(r) || (0, $32c660371a132632$export$2e2bcd8739ae039)(r, e) || (0, $2e684a693b53c115$export$2e2bcd8739ae039)(r, e) || (0, $abc8f1ceefe7f4b4$export$2e2bcd8739ae039)();
}



var $5FkrB = parcelRequire("5FkrB");

var $2nBsU = parcelRequire("2nBsU");
/* popup.tsx generated by @compiled/babel-plugin v2.0.0 */ function $ad3334ed4d142236$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return r;
}


function $ae886ab8e344db9c$export$2e2bcd8739ae039(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}


function $022d83b87ec03a95$export$2e2bcd8739ae039(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}


function $165133c665d57075$export$2e2bcd8739ae039(r, a) {
    if (r) {
        if ("string" == typeof r) return (0, $022d83b87ec03a95$export$2e2bcd8739ae039)(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? (0, $022d83b87ec03a95$export$2e2bcd8739ae039)(r, a) : void 0;
    }
}


function $dc0029423b600534$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}


function $0b8156ac98850b5f$export$2e2bcd8739ae039(r, e) {
    return (0, $ad3334ed4d142236$export$2e2bcd8739ae039)(r) || (0, $ae886ab8e344db9c$export$2e2bcd8739ae039)(r, e) || (0, $165133c665d57075$export$2e2bcd8739ae039)(r, e) || (0, $dc0029423b600534$export$2e2bcd8739ae039)();
}



var $5FkrB = parcelRequire("5FkrB");


/* eslint-disable @repo/internal/react/require-jsdoc */ 
var $5FkrB = parcelRequire("5FkrB");
function $ade6857cb55fa218$export$2e2bcd8739ae039(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}


function $025f0e1807471cfa$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return (0, $ade6857cb55fa218$export$2e2bcd8739ae039)(r);
}


function $2189b400321c3c87$export$2e2bcd8739ae039(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}



function $245f0d2070dc05a5$export$2e2bcd8739ae039(r, a) {
    if (r) {
        if ("string" == typeof r) return (0, $ade6857cb55fa218$export$2e2bcd8739ae039)(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? (0, $ade6857cb55fa218$export$2e2bcd8739ae039)(r, a) : void 0;
    }
}


function $67ceefdb5c32972f$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}


function $7396e2da99bb3bf1$export$2e2bcd8739ae039(r) {
    return (0, $025f0e1807471cfa$export$2e2bcd8739ae039)(r) || (0, $2189b400321c3c87$export$2e2bcd8739ae039)(r) || (0, $245f0d2070dc05a5$export$2e2bcd8739ae039)(r) || (0, $67ceefdb5c32972f$export$2e2bcd8739ae039)();
}


function $0aeace76aa2d3d5a$export$2e2bcd8739ae039(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}


function $e467879c2c97beec$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $e467879c2c97beec$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $e467879c2c97beec$export$2e2bcd8739ae039(o);
}



function $17469e8b8355dcb9$export$2e2bcd8739ae039(t, r) {
    if ("object" != (0, $e467879c2c97beec$export$2e2bcd8739ae039)(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (0, $e467879c2c97beec$export$2e2bcd8739ae039)(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}


function $20c634673e282e0a$export$2e2bcd8739ae039(t) {
    var i = (0, $17469e8b8355dcb9$export$2e2bcd8739ae039)(t, "string");
    return "symbol" == (0, $e467879c2c97beec$export$2e2bcd8739ae039)(i) ? i : i + "";
}


function $dabb4b7dffae233e$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, (0, $20c634673e282e0a$export$2e2bcd8739ae039)(o.key), o);
    }
}
function $dabb4b7dffae233e$export$2e2bcd8739ae039(e, r, t) {
    return r && $dabb4b7dffae233e$var$_defineProperties(e.prototype, r), t && $dabb4b7dffae233e$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}


var $888ec9232a0c31a2$export$da4f61fd78d35243 = /*#__PURE__*/ function() {
    function LayerNode(id, parent) {
        (0, $0aeace76aa2d3d5a$export$2e2bcd8739ae039)(this, LayerNode);
        this.id = id;
        this.childNodes = [];
        this.parent = parent;
    }
    return (0, $dabb4b7dffae233e$export$2e2bcd8739ae039)(LayerNode, [
        {
            key: "addChild",
            value: function addChild(node) {
                this.childNodes.push(node);
            }
        },
        {
            key: "removeChild",
            value: function removeChild(node) {
                this.childNodes = this.childNodes.filter(function(child) {
                    return child.id !== node.id;
                });
            }
        },
        {
            key: "getLevel",
            value: function getLevel() {
                if (!this.parent) return 1;
                return this.parent.getLevel() + 1;
            }
        },
        {
            key: "getHeight",
            value: function getHeight() {
                if (this.childNodes.length === 0) return 1;
                return Math.max.apply(Math, (0, $7396e2da99bb3bf1$export$2e2bcd8739ae039)(this.childNodes.map(function(child) {
                    return child.getHeight();
                }))) + 1;
            }
        }
    ]);
}();


/* eslint-disable @repo/internal/react/require-jsdoc */ 
var $5FkrB = parcelRequire("5FkrB");
var $5c1aee337f1ba1a6$export$650d12d3c2ddb8fc = /*#__PURE__*/ (0, $5FkrB.createContext)(0);


/* eslint-disable @repo/internal/react/require-jsdoc */ 
var $5FkrB = parcelRequire("5FkrB");
var $a405ba4faea0638e$export$18f4d8b5b3a77f59 = /*#__PURE__*/ (0, $5FkrB.createContext)({
    current: null
});


/* eslint-disable @repo/internal/react/require-jsdoc */ 
var $5FkrB = parcelRequire("5FkrB");
var $5439c23b8fed5083$export$fa973f110e8f6ca8 = /*#__PURE__*/ (0, $5FkrB.createContext)({
    current: null
});


var $a9ae8770cf8dda67$var$LevelProvider = function LevelProvider(_ref) {
    var children = _ref.children, currentLevel = _ref.currentLevel, levelNode = _ref.node;
    (0, $5FkrB.useEffect)(function() {
        var levelNodeSafe = levelNode.current;
        var parentNode = levelNodeSafe.parent;
        parentNode === null || parentNode === void 0 || parentNode.addChild(levelNodeSafe);
        return function() {
            parentNode === null || parentNode === void 0 || parentNode.removeChild(levelNodeSafe);
        };
    }, [
        levelNode
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $5c1aee337f1ba1a6$export$650d12d3c2ddb8fc).Provider, {
        value: currentLevel
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $a405ba4faea0638e$export$18f4d8b5b3a77f59).Provider, {
        value: levelNode
    }, children));
};
var $a9ae8770cf8dda67$export$7c885f891c940977 = function Layering(_ref2) {
    var children = _ref2.children, _ref2$isDisabled = _ref2.isDisabled, isDisabled = _ref2$isDisabled === void 0 ? true : _ref2$isDisabled;
    var currentLevel = (0, $5FkrB.useContext)((0, $5c1aee337f1ba1a6$export$650d12d3c2ddb8fc));
    var parentNode = (0, $5FkrB.useContext)((0, $a405ba4faea0638e$export$18f4d8b5b3a77f59));
    // eslint-disable-next-line  @repo/internal/react/disallow-unstable-values
    var newNode = (0, $5FkrB.useRef)(new (0, $888ec9232a0c31a2$export$da4f61fd78d35243)(Math.random().toString(36), parentNode.current));
    if (isDisabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).Fragment, null, children);
    var isNested = currentLevel > 0;
    var content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement($a9ae8770cf8dda67$var$LevelProvider, {
        currentLevel: currentLevel + 1,
        node: newNode
    }, children);
    return isNested ? content : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $5439c23b8fed5083$export$fa973f110e8f6ca8).Provider, {
        value: newNode
    }, content);
};



var $5FkrB = parcelRequire("5FkrB");

var $5FkrB = parcelRequire("5FkrB");
var $fcdc0b4830f2aedd$export$5fbf4d7fae6cdc00 = /*#__PURE__*/ (0, $5FkrB.createContext)(null);



var $5FkrB = parcelRequire("5FkrB");

var $5FkrB = parcelRequire("5FkrB");
var $2390e0a738ab81f9$export$644a49f3b8c50fcd = /*#__PURE__*/ (0, $5FkrB.createContext)(null);


function $1e31b1a2322b2689$export$1d57e79091cc3046() {
    var namespace = (0, $5FkrB.useContext)((0, $2390e0a738ab81f9$export$644a49f3b8c50fcd));
    return namespace;
}


function $dc4b45f7ee6225f5$export$469bb693f11edc7f(_ref) {
    var isOpen = _ref.isOpen, type = _ref.type, onClose = _ref.onClose;
    var context = (0, $5FkrB.useContext)((0, $fcdc0b4830f2aedd$export$5fbf4d7fae6cdc00));
    var namespace = (0, $1e31b1a2322b2689$export$1d57e79091cc3046)();
    (0, $5FkrB.useEffect)(function() {
        /**
     * Registers the `onClose` callback with the OpenLayerObserver.
     */ if (context === null) return;
        if (!isOpen) /**
       * If the layer is not open, we are not registering the `onClose` callback.
       * This is important to prevent the `onClose` from being called for layers that
       * are not open.
       *
       * Some consumers mistakenly pass "toggle" functions to `onClose` callbacks for
       * layer components, as Popup, e.g. `onClose={() => setIsOpen(!isOpen)}`.
       */ return;
        return context.onClose(onClose, {
            namespace: namespace,
            type: type
        });
    }, [
        context,
        isOpen,
        namespace,
        onClose,
        type
    ]);
}


function $d0b7259e6431ce40$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return r;
}


function $7fb0adec5ffe3f46$export$2e2bcd8739ae039(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}


function $fa3e74e83bf9741d$export$2e2bcd8739ae039(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}


function $1317f5a0cc762277$export$2e2bcd8739ae039(r, a) {
    if (r) {
        if ("string" == typeof r) return (0, $fa3e74e83bf9741d$export$2e2bcd8739ae039)(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? (0, $fa3e74e83bf9741d$export$2e2bcd8739ae039)(r, a) : void 0;
    }
}


function $71314d79b43206ec$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}


function $b0c829b9b1926339$export$2e2bcd8739ae039(r, e) {
    return (0, $d0b7259e6431ce40$export$2e2bcd8739ae039)(r) || (0, $7fb0adec5ffe3f46$export$2e2bcd8739ae039)(r, e) || (0, $1317f5a0cc762277$export$2e2bcd8739ae039)(r, e) || (0, $71314d79b43206ec$export$2e2bcd8739ae039)();
}



var $5FkrB = parcelRequire("5FkrB");

var $50U6m = parcelRequire("50U6m");
/**
 * Internally we will be playing with an element that will always have a key defined.
 */ /**
 * Internal data passed to child motions.
 */ // We define empty context here so the object doesn't change.
var $7dce5bdaf433551a$var$emptyContext = {
    // Motions will always appear if not inside a exiting persistence component.
    appear: true,
    isInsideExitingPersistence: false,
    isExiting: false
};
var $7dce5bdaf433551a$export$b9c4904d7a6929e6 = /*#__PURE__*/ (0, $5FkrB.createContext)($7dce5bdaf433551a$var$emptyContext);
/**
 * This method will wrap any React element with a context provider. We're using context (instead of
 * cloneElement) so we can communicate between multiple elements without the need of prop drilling
 * (results in a better API for consumers).
 */ var $7dce5bdaf433551a$var$wrapChildWithContextProvider = function wrapChildWithContextProvider(child) {
    var value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $7dce5bdaf433551a$var$emptyContext;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement($7dce5bdaf433551a$export$b9c4904d7a6929e6.Provider, {
        key: "".concat(child.key, "-provider"),
        value: value
    }, child);
};
/**
 * This function will convert all children types to an array while also filtering out non-valid React elements.
 */ var $7dce5bdaf433551a$var$childrenToArray = function childrenToArray(children) {
    var childrenAsArray = [];
    // We convert children to an array using this helper method as it will add keys to children that do not
    // have them, such as when we have hardcoded children that are conditionally rendered.
    (0, $5FkrB.Children).toArray(children).forEach(function(child) {
        // We ignore any boolean children to make our code a little more simple later on,
        // and also filter out any falsies (empty strings, nulls, and undefined).
        if (typeof child !== 'boolean' && Boolean(child)) // Children WILL have a key after being forced into an array using the React.Children helper.
        childrenAsArray.push(child);
    });
    return childrenAsArray;
};
var $7dce5bdaf433551a$var$spliceNewElementsIntoPrevious = function spliceNewElementsIntoPrevious(current, previous) {
    var splicedChildren = previous.concat([]);
    var previousMap = $7dce5bdaf433551a$var$childrenToObj(previous);
    for(var i = 0; i < current.length; i++){
        var child = current[i];
        var childIsNew = !previousMap[child.key];
        if (childIsNew) // This will insert the new element after the previous element.
        splicedChildren.splice(i + 1, 0, child);
    }
    return splicedChildren;
};
var $7dce5bdaf433551a$var$childrenToObj = function childrenToObj(children) {
    return children.reduce(function(acc, child) {
        acc[child.key] = child;
        return acc;
    }, {});
};
var $7dce5bdaf433551a$var$getMissingKeys = function getMissingKeys(current, previous) {
    var currentMapKeys = new Set(current.map(function(child) {
        return child.key;
    }));
    var missing = new Set();
    for(var i = 0; i < previous.length; i++){
        var element = previous[i];
        var _key = element.key;
        if (!currentMapKeys.has(_key)) missing.add(_key);
    }
    return missing;
};
/**
 * How does this component work?
 *
 * It looks at changes in its children to see what is removed.
 *
 * If a child is removed it clones it and wraps it with context providing an `onFinish` callback.
 *
 * The cloned child will call the `onFinish` when it finishes its exit animation,
 * which lets `ExitingPersistence` know to stop rendering it.
 */ /**
 * __ExitingPersistence__
 *
 * Useful for enabling elements to persist and animate away when they are removed from the DOM.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/motion/docs/entering-motion)
 */ var $7dce5bdaf433551a$var$ExitingPersistence = /*#__PURE__*/ (0, $5FkrB.memo)(function(_ref) {
    var _ref$appear = _ref.appear, appear = _ref$appear === void 0 ? false : _ref$appear, children = _ref.children, exitThenEnter = _ref.exitThenEnter;
    var _useState = (0, $5FkrB.useState)([
        null,
        children
    ]), _useState2 = (0, $b0c829b9b1926339$export$2e2bcd8739ae039)(_useState, 2), stateChildren = _useState2[0], setChildren = _useState2[1];
    var _useState3 = (0, $5FkrB.useState)([]), _useState4 = (0, $b0c829b9b1926339$export$2e2bcd8739ae039)(_useState3, 2), exitingChildren = _useState4[0], setExitingChildren = _useState4[1];
    var _useState5 = (0, $5FkrB.useState)(function() {
        return {
            appear: appear,
            isExiting: false,
            isInsideExitingPersistence: true
        };
    }), _useState6 = (0, $b0c829b9b1926339$export$2e2bcd8739ae039)(_useState5, 2), defaultContext = _useState6[0], setDefaultContext = _useState6[1];
    (0, $5FkrB.useEffect)(function() {
        if (!defaultContext.appear) setDefaultContext({
            appear: true,
            isExiting: false,
            isInsideExitingPersistence: true
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    /**
   * NOTE: This is a workaround for the test case written in Jira where the stateChildren is a boolean value because
   * useState is mocked to return a boolean value.
   */ if (typeof stateChildren === 'boolean') return children;
    var _stateChildren = (0, $b0c829b9b1926339$export$2e2bcd8739ae039)(stateChildren, 2), previousChildren = _stateChildren[0], currentChildren = _stateChildren[1];
    var previous = $7dce5bdaf433551a$var$childrenToArray(previousChildren);
    var current = $7dce5bdaf433551a$var$childrenToArray(currentChildren);
    if (currentChildren !== children) setChildren([
        currentChildren,
        children
    ]);
    var nextChildren = currentChildren !== children ? $7dce5bdaf433551a$var$childrenToArray(children) : current;
    var missingKeys = $7dce5bdaf433551a$var$getMissingKeys(nextChildren, previous);
    var isSomeChildRemoved = !!missingKeys.size;
    var visibleChildren = !isSomeChildRemoved && currentChildren !== children ? nextChildren : current;
    if (isSomeChildRemoved) visibleChildren = $7dce5bdaf433551a$var$spliceNewElementsIntoPrevious(current, previous);
    if (exitThenEnter) {
        if (exitingChildren.length) visibleChildren = (0, $50U6m.fg)('platform-dst-motion-uplift') ? previous : exitingChildren;
        else {
            var nextExitingChildren = visibleChildren.filter(function(child) {
                return missingKeys.has(child.key);
            });
            if (nextExitingChildren.length) setExitingChildren(nextExitingChildren);
        }
    }
    if (missingKeys.size) visibleChildren = visibleChildren.map(function(child) {
        var isExiting = missingKeys.has(child.key);
        return $7dce5bdaf433551a$var$wrapChildWithContextProvider(child, {
            appear: true,
            isInsideExitingPersistence: true,
            isExiting: isExiting,
            onFinish: isExiting ? function() {
                missingKeys.delete(child.key);
                if (missingKeys.size === 0) {
                    setChildren([
                        null,
                        children
                    ]);
                    setExitingChildren([]);
                }
            } : undefined
        });
    });
    else visibleChildren = visibleChildren.map(function(child) {
        return $7dce5bdaf433551a$var$wrapChildWithContextProvider(child, defaultContext);
    });
    return visibleChildren;
});
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$7dce5bdaf433551a$export$2e2bcd8739ae039 = $7dce5bdaf433551a$var$ExitingPersistence;
$7dce5bdaf433551a$var$ExitingPersistence.displayName = 'ExitingPersistence';



var $50U6m = parcelRequire("50U6m");

var $5FkrB = parcelRequire("5FkrB");

var $5FkrB = parcelRequire("5FkrB");
var $cc0477161a7a3c78$export$3dbd3405086fec7b = $5FkrB.createContext();
var $cc0477161a7a3c78$export$cbabb21c2529b130 = $5FkrB.createContext();
function $cc0477161a7a3c78$export$d0d38e7dec7a1a61(_ref) {
    var children = _ref.children;
    var _React$useState = $5FkrB.useState(null), referenceNode = _React$useState[0], setReferenceNode = _React$useState[1];
    var hasUnmounted = $5FkrB.useRef(false);
    $5FkrB.useEffect(function() {
        return function() {
            hasUnmounted.current = true;
        };
    }, []);
    var handleSetReferenceNode = $5FkrB.useCallback(function(node) {
        if (!hasUnmounted.current) setReferenceNode(node);
    }, []);
    return /*#__PURE__*/ $5FkrB.createElement($cc0477161a7a3c78$export$3dbd3405086fec7b.Provider, {
        value: referenceNode
    }, /*#__PURE__*/ $5FkrB.createElement($cc0477161a7a3c78$export$cbabb21c2529b130.Provider, {
        value: handleSetReferenceNode
    }, children));
}



var $5FkrB = parcelRequire("5FkrB");
var $59650a99191b9498$export$8f73317645bb7b8e = /*#__PURE__*/ (0, $5FkrB.createContext)(null);



var $5FkrB = parcelRequire("5FkrB");
var $0d8eb5f51af49ee0$export$804169e6eecdff16 = /*#__PURE__*/ (0, $5FkrB.createContext)(function() {
    return undefined;
});


function $18e36cd0ebae2249$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return r;
}


function $15f7fd633d0dbbdc$export$2e2bcd8739ae039(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}


function $cc615bd93ad23227$export$2e2bcd8739ae039(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}


function $d07a6457af62328b$export$2e2bcd8739ae039(r, a) {
    if (r) {
        if ("string" == typeof r) return (0, $cc615bd93ad23227$export$2e2bcd8739ae039)(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? (0, $cc615bd93ad23227$export$2e2bcd8739ae039)(r, a) : void 0;
    }
}


function $5e010f256fb60921$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}


function $0a1610bce965fec6$export$2e2bcd8739ae039(r, e) {
    return (0, $18e36cd0ebae2249$export$2e2bcd8739ae039)(r) || (0, $15f7fd633d0dbbdc$export$2e2bcd8739ae039)(r, e) || (0, $d07a6457af62328b$export$2e2bcd8739ae039)(r, e) || (0, $5e010f256fb60921$export$2e2bcd8739ae039)();
}



var $5FkrB = parcelRequire("5FkrB");
function $4ff946d970cd17db$export$1b1b50fdcd7ac375() {
    var _useState = (0, $5FkrB.useState)(null), _useState2 = (0, $0a1610bce965fec6$export$2e2bcd8739ae039)(_useState, 2), anchor = _useState2[0], setAnchor = _useState2[1];
    return {
        anchor: anchor,
        setAnchor: setAnchor
    };
}


function $351c41799462e9b8$export$d0d38e7dec7a1a61(_ref) {
    var children = _ref.children;
    // `setAnchor` is the `useState` setter, which React guarantees is stable
    // across renders, so it can be passed straight to the context provider.
    var _useAnchorState = (0, $4ff946d970cd17db$export$1b1b50fdcd7ac375)(), anchor = _useAnchorState.anchor, setAnchor = _useAnchorState.setAnchor;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $cc0477161a7a3c78$export$d0d38e7dec7a1a61), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $0d8eb5f51af49ee0$export$804169e6eecdff16).Provider, {
        value: setAnchor
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $59650a99191b9498$export$8f73317645bb7b8e).Provider, {
        value: anchor
    }, children)));
}



var $5FkrB = parcelRequire("5FkrB");

var $5FkrB = parcelRequire("5FkrB");
var $4e6f8530dbdc4e71$exports = {};
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */ var $4e6f8530dbdc4e71$var$__DEV__ = false;
var $4e6f8530dbdc4e71$var$warning = function() {};
if ($4e6f8530dbdc4e71$var$__DEV__) {
    var $4e6f8530dbdc4e71$var$printWarning = function printWarning(format, args) {
        var len = arguments.length;
        args = new Array(len > 1 ? len - 1 : 0);
        for(var key = 1; key < len; key++)args[key - 1] = arguments[key];
        var argIndex = 0;
        var message = 'Warning: ' + format.replace(/%s/g, function() {
            return args[argIndex++];
        });
        if (typeof console !== 'undefined') console.error(message);
        try {
            // --- Welcome to debugging React ---
            // This error was thrown as a convenience so that you can use this stack
            // to find the callsite that caused this warning to fire.
            throw new Error(message);
        } catch (x) {}
    };
    $4e6f8530dbdc4e71$var$warning = function(condition, format, args) {
        var len = arguments.length;
        args = new Array(len > 2 ? len - 2 : 0);
        for(var key = 2; key < len; key++)args[key - 2] = arguments[key];
        if (format === undefined) throw new Error("`warning(condition, format, ...args)` requires a warning message argument");
        if (!condition) $4e6f8530dbdc4e71$var$printWarning.apply(null, [
            format
        ].concat(args));
    };
}
$4e6f8530dbdc4e71$exports = $4e6f8530dbdc4e71$var$warning;




var $5FkrB = parcelRequire("5FkrB");
var $51ef3a8e2c42379b$export$f52c55943429c8b6 = function unwrapArray(arg) {
    return Array.isArray(arg) ? arg[0] : arg;
};
var $51ef3a8e2c42379b$export$3dfa7c28635fe028 = function safeInvoke(fn) {
    if (typeof fn === 'function') {
        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
        return fn.apply(void 0, args);
    }
};
var $51ef3a8e2c42379b$export$4bb192c7cacf928f = function setRef(ref, node) {
    // if its a function call it
    if (typeof ref === 'function') return $51ef3a8e2c42379b$export$3dfa7c28635fe028(ref, node);
    else if (ref != null) ref.current = node;
};
var $51ef3a8e2c42379b$export$5150077fc2e7c662 = function fromEntries(entries) {
    return entries.reduce(function(acc, _ref) {
        var key = _ref[0], value = _ref[1];
        acc[key] = value;
        return acc;
    }, {});
};
var $51ef3a8e2c42379b$export$700979bc83e7db82 = typeof window !== 'undefined' && window.document && window.document.createElement ? $5FkrB.useLayoutEffect : $5FkrB.useEffect;


function $77963faf785db48a$export$e0be378c32fb70a7(_ref) {
    var children = _ref.children, innerRef = _ref.innerRef;
    var setReferenceNode = $5FkrB.useContext((0, $cc0477161a7a3c78$export$cbabb21c2529b130));
    var refHandler = $5FkrB.useCallback(function(node) {
        (0, $51ef3a8e2c42379b$export$4bb192c7cacf928f)(innerRef, node);
        (0, $51ef3a8e2c42379b$export$3dfa7c28635fe028)(setReferenceNode, node);
    }, [
        innerRef,
        setReferenceNode
    ]); // ran on unmount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    $5FkrB.useEffect(function() {
        return function() {
            return (0, $51ef3a8e2c42379b$export$4bb192c7cacf928f)(innerRef, null);
        };
    }, []);
    $5FkrB.useEffect(function() {
        (0, (/*@__PURE__*/$parcel$interopDefault($4e6f8530dbdc4e71$exports)))(Boolean(setReferenceNode), '`Reference` should not be used outside of a `Manager` component.');
    }, [
        setReferenceNode
    ]);
    return (0, $51ef3a8e2c42379b$export$f52c55943429c8b6)(children)({
        ref: refHandler
    });
}


function $2a21f6571e815fa7$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $2a21f6571e815fa7$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $2a21f6571e815fa7$export$2e2bcd8739ae039(o);
}


function $db13a2f91f6a0f56$export$2e2bcd8739ae039(refs) {
    return function(value) {
        refs.forEach(function(ref) {
            if (typeof ref === 'function') ref(value);
            else if (ref !== null && (0, $2a21f6571e815fa7$export$2e2bcd8739ae039)(ref) === 'object') ref.current = value;
        });
    };
}



var $5FkrB = parcelRequire("5FkrB");

function $8cb9e34f19ae2f0f$export$fcdda419d7091b3() {
    return (0, $5FkrB.useContext)((0, $0d8eb5f51af49ee0$export$804169e6eecdff16));
}


function $cde0d25d074125a2$export$e0be378c32fb70a7(_ref) {
    var children = _ref.children, innerRef = _ref.innerRef;
    var publishAnchor = (0, $8cb9e34f19ae2f0f$export$fcdda419d7091b3)();
    var composedRef = (0, $5FkrB.useMemo)(function() {
        return (0, $db13a2f91f6a0f56$export$2e2bcd8739ae039)([
            publishAnchor,
            innerRef
        ]);
    }, [
        publishAnchor,
        innerRef
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $77963faf785db48a$export$e0be378c32fb70a7), {
        innerRef: composedRef
    }, children);
}



var $5FkrB = parcelRequire("5FkrB");

var $50U6m = parcelRequire("50U6m");

var $5FkrB = parcelRequire("5FkrB");

/* index.tsx generated by @compiled/babel-plugin v2.0.0 */ function $581280dfb2cb8b3f$export$2e2bcd8739ae039() {
    return $581280dfb2cb8b3f$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $581280dfb2cb8b3f$export$2e2bcd8739ae039.apply(null, arguments);
}


function $681551d977ccda12$var$asyncGeneratorStep(n, t, e, r, o, a, c) {
    try {
        var i = n[a](c), u = i.value;
    } catch (n) {
        return void e(n);
    }
    i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function $681551d977ccda12$export$2e2bcd8739ae039(n) {
    return function() {
        var t = this, e = arguments;
        return new Promise(function(r, o) {
            var a = n.apply(t, e);
            function _next(n) {
                $681551d977ccda12$var$asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
            }
            function _throw(n) {
                $681551d977ccda12$var$asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
            }
            _next(void 0);
        });
    };
}



var $6lpBT = parcelRequire("6lpBT");

var $iOWlh = parcelRequire("iOWlh");
/**
 * The length of the value hash portion of an atomic class name.
 * Atomic class names have the format: `_<group><value>`
 * where group is ATOMIC_GROUP_HASH_LENGTH chars and value is ATOMIC_VALUE_HASH_LENGTH chars.
 *
 * We extract the group key using: `className.slice(0, className.length - ATOMIC_VALUE_HASH_LENGTH)`
 *
 * We support both old-format classes (9 chars: `_` + 4 group + 4 value) and
 * new-format classes (11 chars: `_` + 6 group + 4 value) by using length-based
 * extraction rather than a hardcoded offset — old and new format group keys
 * are different lengths so they are structurally disjoint and never alias each other.
 */ const $b02ab0e3a0f362dd$var$ATOMIC_VALUE_HASH_LENGTH = 4;
function $b02ab0e3a0f362dd$export$2e2bcd8739ae039(classNames) {
    // Shortcut: nothing to do
    if (!classNames.length) return;
    // Shortcut: don't need to do anything if we only have a single classname
    if (classNames.length === 1 && classNames[0] && // checking to see if `classNames[0]` is a string that contains other classnames
    !classNames[0].includes(' ')) return classNames[0];
    // Using an object rather than a `Map` as it performed better in our benchmarks.
    // Would be happy to move to `Map` if it proved to be better under real conditions.
    const map = {};
    // Note: using loops to minimize iterations over the collection
    for (const value of classNames){
        // Exclude all falsy values, which leaves us with populated strings
        if (!value) continue;
        // a `value` can contain multiple classnames
        const list = value.split(' ');
        for (const className of list){
            /**
             * For atomic style classnames: the `key` is the `group`
             *
             * - Later atomic classnames with the same `group` will override earlier ones
             *   (which is what we want).
             * - Assumes atomic classnames are the only things that start with `_`
             * - Could use a regex to ensure that atomic classnames are structured how we expect,
             *   but did not add that for now as it did slow things down a bit.
             *
             * For other classnames: the `key` is the whole classname
             * - Okay to remove duplicates as doing so does not impact specificity
             *
             * */ const key = className.startsWith('_') ? className.slice(0, className.length - $b02ab0e3a0f362dd$var$ATOMIC_VALUE_HASH_LENGTH) : className;
            map[key] = className;
        }
    }
    /**
     * We are converting the `map` into a string.
     *
     * The simple way to do this would be `Object.values(map).join(' ')`.
     * However, the approach below performs 10%-20% better in benchmarks.
     *
     * For `ax()` it feels right to squeeze as much runtime performance out as we can.
     */ let result = '';
    for(const key in map)result += map[key] + ' ';
    // If we have an empty string, then our `map` was empty.
    if (!result) return;
    // remove last " " from the result (we added " " at the end of every value)
    return result.trimEnd();
}


var $0d2e6e43daff979d$exports = {};
// TODO(Babel 8): Remove this file.

var $0d2e6e43daff979d$var$runtime = (parcelRequire("ljOJO"))();
$0d2e6e43daff979d$exports = $0d2e6e43daff979d$var$runtime;
// Copied from https://github.com/facebook/regenerator/blob/main/packages/runtime/runtime.js#L736=
try {
    regeneratorRuntime = $0d2e6e43daff979d$var$runtime;
} catch (accidentalStrictMode) {
    if (typeof globalThis === "object") globalThis.regeneratorRuntime = $0d2e6e43daff979d$var$runtime;
    else Function("r", "regeneratorRuntime = r")($0d2e6e43daff979d$var$runtime);
}



var $5FkrB = parcelRequire("5FkrB");


var $6o2jv = parcelRequire("6o2jv");

var $6lpBT = parcelRequire("6lpBT");

var $50U6m = parcelRequire("50U6m");

var $6o2jv = parcelRequire("6o2jv");

var $ltcA1 = parcelRequire("ltcA1");

var $djefD = parcelRequire("djefD");

var $iOWlh = parcelRequire("iOWlh");
var $7b9e1f9ebff48659$export$4a14e169b1de4ee7 = function isColorMode(modeId) {
    return [
        'light',
        'dark',
        'auto'
    ].includes(modeId);
};


/**
 * Theme ids: The value that will be mounted to the DOM as a data attr
 * For example: `data-theme="light:light dark:dark spacing:spacing"
 *
 * These ids must be kebab case
 */ var $cd36553759507965$export$7d43e72a58e3283f = [
    'light-increased-contrast',
    'light',
    'light-future',
    'dark',
    'dark-future',
    'dark-increased-contrast',
    'spacing',
    'shape',
    'typography',
    'motion'
];


var $35445857f88932d4$export$ea35b8958c39dd07 = function isThemeIds(themeId) {
    return (0, $cd36553759507965$export$7d43e72a58e3283f).find(function(id) {
        return id === themeId;
    }) !== undefined;
};


var $a4cdd07e7afdbd92$var$themeKinds = [
    'light',
    'dark',
    'spacing',
    'typography',
    'shape',
    'motion'
];
var $a4cdd07e7afdbd92$export$958fa026be3a263e = function isThemeKind(themeKind) {
    return $a4cdd07e7afdbd92$var$themeKinds.find(function(kind) {
        return kind === themeKind;
    }) !== undefined;
};


var $30a15c2a67071489$var$customThemeOptions = 'UNSAFE_themeOptions';
var $30a15c2a67071489$export$62c37ab81302621a = function themeObjectToString(themeState) {
    return Object.entries(themeState).reduce(function(themeString, _ref) {
        var _ref2 = (0, $iOWlh.default)(_ref, 2), kind = _ref2[0], id = _ref2[1];
        if (// colorMode theme state
        kind === 'colorMode' && typeof id === 'string' && (0, $7b9e1f9ebff48659$export$4a14e169b1de4ee7)(id) || // custom theme state
        kind === $30a15c2a67071489$var$customThemeOptions && (0, $djefD.default)(id) === 'object' || // other theme states
        (0, $a4cdd07e7afdbd92$export$958fa026be3a263e)(kind) && typeof id === 'string' && (0, $35445857f88932d4$export$ea35b8958c39dd07)(id)) return themeString + "".concat(themeString ? ' ' : '') + "".concat(kind, ":").concat((0, $djefD.default)(id) === 'object' ? JSON.stringify(id) : id);
        return themeString;
    }, '');
};



var $7lZkr = parcelRequire("7lZkr");
var $756d56646abc14e3$export$53031ac1ecb71f44 = function isValidBrandHex(hex) {
    return /^#[0-9A-F]{6}$/i.test(hex);
};


function $226f2dc102fc9bfc$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $226f2dc102fc9bfc$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $226f2dc102fc9bfc$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $6lpBT.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $226f2dc102fc9bfc$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $226f2dc102fc9bfc$var$defaultColorMode = 'light';
var $226f2dc102fc9bfc$var$defaultContrastMode = 'no-preference';
var $226f2dc102fc9bfc$export$e1f80cb7a749802f = function getThemeHtmlAttrs() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, _ref$colorMode = _ref.colorMode, colorMode = _ref$colorMode === void 0 ? (0, $ltcA1.themeStateDefaults)['colorMode'] : _ref$colorMode, _ref$dark = _ref.dark, dark = _ref$dark === void 0 ? (0, $ltcA1.themeStateDefaults)['dark'] : _ref$dark, _ref$light = _ref.light, light = _ref$light === void 0 ? (0, $ltcA1.themeStateDefaults)['light'] : _ref$light, _ref$contrastMode = _ref.contrastMode, contrastMode = _ref$contrastMode === void 0 ? (0, $ltcA1.themeStateDefaults)['contrastMode'] : _ref$contrastMode, _ref$motion = _ref.motion, motion = _ref$motion === void 0 ? (0, $ltcA1.themeStateDefaults)['motion']() : _ref$motion, _ref$shape = _ref.shape, shape = _ref$shape === void 0 ? (0, $ltcA1.themeStateDefaults)['shape']() : _ref$shape, _ref$spacing = _ref.spacing, spacing = _ref$spacing === void 0 ? (0, $ltcA1.themeStateDefaults)['spacing'] : _ref$spacing, _ref$typography = _ref.typography, typography = _ref$typography === void 0 ? (0, $ltcA1.themeStateDefaults)['typography'] : _ref$typography, _ref$UNSAFE_themeOpti = _ref.UNSAFE_themeOptions, UNSAFE_themeOptions = _ref$UNSAFE_themeOpti === void 0 ? (0, $ltcA1.themeStateDefaults)['UNSAFE_themeOptions'] : _ref$UNSAFE_themeOpti;
    var themeAttribute = (0, $30a15c2a67071489$export$62c37ab81302621a)({
        dark: dark,
        light: light,
        motion: motion,
        shape: shape,
        spacing: spacing,
        typography: typography
    });
    var result = (0, $6lpBT.default)((0, $6lpBT.default)({}, (0, $6o2jv.THEME_DATA_ATTRIBUTE), themeAttribute), (0, $6o2jv.COLOR_MODE_ATTRIBUTE), colorMode === 'auto' ? $226f2dc102fc9bfc$var$defaultColorMode : colorMode);
    if ((0, $50U6m.fg)('platform_increased-contrast-themes')) result = $226f2dc102fc9bfc$var$_objectSpread($226f2dc102fc9bfc$var$_objectSpread({}, result), {}, (0, $6lpBT.default)({}, (0, $6o2jv.CONTRAST_MODE_ATTRIBUTE), contrastMode === 'auto' ? $226f2dc102fc9bfc$var$defaultContrastMode : contrastMode));
    if (UNSAFE_themeOptions && (0, $756d56646abc14e3$export$53031ac1ecb71f44)(UNSAFE_themeOptions.brandColor)) {
        var optionString = JSON.stringify(UNSAFE_themeOptions);
        var uniqueId = (0, $7lZkr.hash)(optionString);
        result[0, $6o2jv.CUSTOM_THEME_ATTRIBUTE] = uniqueId;
    }
    return result;
};
var $226f2dc102fc9bfc$export$2e2bcd8739ae039 = $226f2dc102fc9bfc$export$e1f80cb7a749802f;



var $6lpBT = parcelRequire("6lpBT");



var $50U6m = parcelRequire("50U6m");

var $6lpBT = parcelRequire("6lpBT");

var $6o2jv = parcelRequire("6o2jv");
/**
 * Theme modes: The general purpose of a theme.
 * This attr is used to apply the appropriate system-preference option
 * It may also be used as a selector for mode-specific overrides such as light/dark images.
 * The idea is there may exist many color themes, but every theme must either fit into light or dark.
 */ var $37a568a16cbd2d13$export$83993de8eb66733 = [
    'light',
    'dark',
    'auto'
];


var $b6d48739444dbcd3$export$fcfb1976c88f9f75 = function isThemeColorMode(colorMode) {
    return (0, $37a568a16cbd2d13$export$83993de8eb66733).find(function(mode) {
        return mode === colorMode;
    }) !== undefined;
};



var $iOWlh = parcelRequire("iOWlh");



var $708fd7ba98fd6157$var$customThemeOptions = 'UNSAFE_themeOptions';
var $708fd7ba98fd6157$export$f19b488f7c0547ee = function themeStringToObject(themeState) {
    return themeState.split(' ').map(function(theme) {
        return theme.split(/:([^]*)/);
    }).reduce(function(themeObject, _ref) {
        var _ref2 = (0, $iOWlh.default)(_ref, 2), kind = _ref2[0], id = _ref2[1];
        if (kind === 'colorMode' && (0, $7b9e1f9ebff48659$export$4a14e169b1de4ee7)(id)) themeObject[kind] = id;
        if ((0, $a4cdd07e7afdbd92$export$958fa026be3a263e)(kind) && (0, $35445857f88932d4$export$ea35b8958c39dd07)(id)) // @ts-expect-error FIXME - this is a valid ts error
        themeObject[kind] = id;
        if (kind === $708fd7ba98fd6157$var$customThemeOptions) try {
            themeObject[$708fd7ba98fd6157$var$customThemeOptions] = JSON.parse(id);
        } catch (_unused) {
            new Error('Invalid custom theme string');
        }
        return themeObject;
    }, {});
};


function $b40bdfcf4a616ca8$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $b40bdfcf4a616ca8$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $b40bdfcf4a616ca8$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $6lpBT.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $b40bdfcf4a616ca8$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $b40bdfcf4a616ca8$export$813ecdf77207a053 = function getGlobalTheme() {
    if (typeof document === 'undefined') return {};
    var element = document.documentElement;
    var colorMode = element.getAttribute((0, $6o2jv.COLOR_MODE_ATTRIBUTE)) || '';
    var theme = element.getAttribute((0, $6o2jv.THEME_DATA_ATTRIBUTE)) || '';
    return $b40bdfcf4a616ca8$var$_objectSpread($b40bdfcf4a616ca8$var$_objectSpread({}, (0, $708fd7ba98fd6157$export$f19b488f7c0547ee)(theme)), (0, $b6d48739444dbcd3$export$fcfb1976c88f9f75)(colorMode) && {
        colorMode: colorMode
    });
};



var $ltcA1 = parcelRequire("ltcA1");

var $iOWlh = parcelRequire("iOWlh");

var $50U6m = parcelRequire("50U6m");


var $6QlWs = parcelRequire("6QlWs");

var $bLKSF = parcelRequire("bLKSF");

var $6lpBT = parcelRequire("6lpBT");


var $6o2jv = parcelRequire("6o2jv");



var $6o2jv = parcelRequire("6o2jv");


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 *
 * This file contains a dynamic import for each theme this package exports.
 * Themes are loaded asynchronously at runtime to minimise the amount of CSS we send to the client.
 * This allows users to compose their themes and only use the tokens that are requested.
 * When a new theme is created, the import should automatically be added to the map
 *
 * @codegen <<SignedSource::66dadd5f50c3e786528bdc742c5ab39e>>
 * @codegenCommand yarn build tokens
 */ 









var $6e5cdf912c2de5d7$export$3a171c49f8c16356 = {
    'light': function light() {
        return (parcelRequire("gFy4Z"));
    },
    'light-future': function lightFuture() {
        return (parcelRequire("6hxgO"));
    },
    'light-increased-contrast': function lightIncreasedContrast() {
        return (parcelRequire("kGGQc"));
    },
    'dark': function dark() {
        return (parcelRequire("1Px1h"));
    },
    'dark-future': function darkFuture() {
        return (parcelRequire("4zl6X"));
    },
    'dark-increased-contrast': function darkIncreasedContrast() {
        return (parcelRequire("g5BOX"));
    },
    'spacing': function spacing() {
        return (parcelRequire("7rzwA"));
    },
    'typography': function typography() {
        return (parcelRequire("exeGs"));
    },
    'shape': function shape() {
        return (parcelRequire("aC2aM"));
    },
    'motion': function motion() {
        return (parcelRequire("cQyB6"));
    }
};
var $6e5cdf912c2de5d7$export$2e2bcd8739ae039 = $6e5cdf912c2de5d7$export$3a171c49f8c16356;


var $3edb2978b32cdce7$export$8a48286ed7df6720 = /*#__PURE__*/ function() {
    var _ref = (0, $681551d977ccda12$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($0d2e6e43daff979d$exports))).mark(function _callee(themeId) {
        var _yield$themeImportMap, themeCss;
        return (0, (/*@__PURE__*/$parcel$interopDefault($0d2e6e43daff979d$exports))).wrap(function(_context) {
            while(true)switch(_context.prev = _context.next){
                case 0:
                    _context.next = 1;
                    return (0, $6e5cdf912c2de5d7$export$2e2bcd8739ae039)[themeId]();
                case 1:
                    _yield$themeImportMap = _context.sent;
                    themeCss = _yield$themeImportMap.default;
                    return _context.abrupt("return", themeCss);
                case 2:
                case "end":
                    return _context.stop();
            }
        }, _callee);
    }));
    return function loadThemeCss(_x) {
        return _ref.apply(this, arguments);
    };
}();


var $15672a0d1f51b1ab$export$26cd7ae85c7144e5 = /*#__PURE__*/ function() {
    var _ref = (0, $681551d977ccda12$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($0d2e6e43daff979d$exports))).mark(function _callee(themeId) {
        var themeCss, style;
        return (0, (/*@__PURE__*/$parcel$interopDefault($0d2e6e43daff979d$exports))).wrap(function(_context) {
            while(true)switch(_context.prev = _context.next){
                case 0:
                    if (!document.head.querySelector("style[".concat((0, $6o2jv.THEME_DATA_ATTRIBUTE), "=\"").concat(themeId, "\"]:not([").concat((0, $6o2jv.CUSTOM_THEME_ATTRIBUTE), "])"))) {
                        _context.next = 1;
                        break;
                    }
                    return _context.abrupt("return");
                case 1:
                    if (themeId) {
                        _context.next = 2;
                        break;
                    }
                    return _context.abrupt("return");
                case 2:
                    _context.next = 3;
                    return (0, $3edb2978b32cdce7$export$8a48286ed7df6720)(themeId);
                case 3:
                    themeCss = _context.sent;
                    style = document.createElement('style');
                    style.textContent = themeCss;
                    style.dataset.theme = themeId;
                    document.head.appendChild(style);
                case 4:
                case "end":
                    return _context.stop();
            }
        }, _callee);
    }));
    return function loadAndAppendThemeCss(_x) {
        return _ref.apply(this, arguments);
    };
}();
var $15672a0d1f51b1ab$export$bb1e815119d30f8b = '(prefers-color-scheme: dark)';
var $15672a0d1f51b1ab$export$8662df6937d86fcb = '(prefers-contrast: more)';


var $13afca741df4945b$var$isMatchMediaAvailable = typeof window !== 'undefined' && 'matchMedia' in window;
/**
 * Updates the current theme when the system theme changes. Should be bound
 * to an event listener listening on the '(prefers-color-scheme: dark)' query
 * @param e The event representing a change in system theme.
 */ function $13afca741df4945b$var$checkNativeListener(e) {
    var element = document.documentElement;
    element.setAttribute((0, $6o2jv.COLOR_MODE_ATTRIBUTE), e.matches ? 'dark' : 'light');
}
var $13afca741df4945b$var$darkModeMql = $13afca741df4945b$var$isMatchMediaAvailable && window.matchMedia((0, $15672a0d1f51b1ab$export$bb1e815119d30f8b));
var $13afca741df4945b$var$ColorModeObserver = /*#__PURE__*/ function() {
    function ColorModeObserver() {
        (0, $6QlWs.default)(this, ColorModeObserver);
        (0, $6lpBT.default)(this, "unbindThemeChangeListener", null);
    }
    return (0, $bLKSF.default)(ColorModeObserver, [
        {
            key: "getColorMode",
            value: function getColorMode() {
                if (!$13afca741df4945b$var$darkModeMql) return 'light';
                return $13afca741df4945b$var$darkModeMql !== null && $13afca741df4945b$var$darkModeMql !== void 0 && $13afca741df4945b$var$darkModeMql.matches ? 'dark' : 'light';
            }
        },
        {
            key: "bind",
            value: function bind() {
                if ($13afca741df4945b$var$darkModeMql && this.unbindThemeChangeListener === null) this.unbindThemeChangeListener = (0, $5b617c1f48263075$exports.bind)($13afca741df4945b$var$darkModeMql, {
                    type: 'change',
                    listener: $13afca741df4945b$var$checkNativeListener
                });
            }
        },
        {
            key: "unbind",
            value: function unbind() {
                if (this.unbindThemeChangeListener) {
                    this.unbindThemeChangeListener();
                    this.unbindThemeChangeListener = null;
                }
            }
        }
    ]);
}();
/**
 * A singleton color mode observer - binds "auto" switching logic to a single `mediaQueryList` listener
 * that can be unbound by any consumer when no longer needed.
 */ var $13afca741df4945b$var$SingletonColorModeObserver = new $13afca741df4945b$var$ColorModeObserver();
var $13afca741df4945b$export$2e2bcd8739ae039 = $13afca741df4945b$var$SingletonColorModeObserver;



var $6QlWs = parcelRequire("6QlWs");

var $bLKSF = parcelRequire("bLKSF");

var $6lpBT = parcelRequire("6lpBT");


var $6o2jv = parcelRequire("6o2jv");

var $3152a7309816bc10$var$isMatchMediaAvailable = typeof window !== 'undefined' && 'matchMedia' in window;
/**
 * Updates the current theme when the system contrast preference changes. Should be bound
 * to an event listener listening on the '(prefers-contrast: more)' query
 * @param e The event representing a change in system theme.
 */ function $3152a7309816bc10$var$checkNativeListener(e) {
    var element = document.documentElement;
    element.setAttribute((0, $6o2jv.CONTRAST_MODE_ATTRIBUTE), e.matches ? 'more' : 'no-preference');
}
var $3152a7309816bc10$var$contrastModeMql = $3152a7309816bc10$var$isMatchMediaAvailable && window.matchMedia((0, $15672a0d1f51b1ab$export$8662df6937d86fcb));
var $3152a7309816bc10$var$ContrastModeObserver = /*#__PURE__*/ function() {
    function ContrastModeObserver() {
        (0, $6QlWs.default)(this, ContrastModeObserver);
        (0, $6lpBT.default)(this, "unbindContrastChangeListener", null);
    }
    return (0, $bLKSF.default)(ContrastModeObserver, [
        {
            key: "getContrastMode",
            value: function getContrastMode() {
                if (!$3152a7309816bc10$var$contrastModeMql) return 'no-preference';
                return $3152a7309816bc10$var$contrastModeMql !== null && $3152a7309816bc10$var$contrastModeMql !== void 0 && $3152a7309816bc10$var$contrastModeMql.matches ? 'more' : 'no-preference';
            }
        },
        {
            key: "bind",
            value: function bind() {
                if ($3152a7309816bc10$var$contrastModeMql && this.unbindContrastChangeListener === null) this.unbindContrastChangeListener = (0, $5b617c1f48263075$exports.bind)($3152a7309816bc10$var$contrastModeMql, {
                    type: 'change',
                    listener: $3152a7309816bc10$var$checkNativeListener
                });
            }
        },
        {
            key: "unbind",
            value: function unbind() {
                if (this.unbindContrastChangeListener) {
                    this.unbindContrastChangeListener();
                    this.unbindContrastChangeListener = null;
                }
            }
        }
    ]);
}();
/**
 * A singleton contrast mode observer - binds "auto" switching logic to a single `mediaQueryList` listener
 * that can be unbound by any consumer when no longer needed.
 */ var $3152a7309816bc10$var$SingletonContrastModeObserver = new $3152a7309816bc10$var$ContrastModeObserver();
var $3152a7309816bc10$export$2e2bcd8739ae039 = $3152a7309816bc10$var$SingletonContrastModeObserver;


function $9e53a9907c3b882c$export$2e2bcd8739ae039(themeState) {
    if (themeState.colorMode === 'auto') {
        // Set colorMode based on the user preference
        themeState.colorMode = (0, $13afca741df4945b$export$2e2bcd8739ae039).getColorMode();
        // Bind a listener (if one doesn't already exist) to keep colorMode updated
        (0, $13afca741df4945b$export$2e2bcd8739ae039).bind();
    } else (0, $13afca741df4945b$export$2e2bcd8739ae039).unbind();
    if ((0, $50U6m.fg)('platform_increased-contrast-themes')) {
        if (themeState.contrastMode === 'auto') {
            // Set contrastMode based on the user preference
            themeState.contrastMode = (0, $3152a7309816bc10$export$2e2bcd8739ae039).getContrastMode();
            // Bind a listener (if one doesn't already exist) to keep contrastMode updated
            (0, $3152a7309816bc10$export$2e2bcd8739ae039).bind();
        } else (0, $3152a7309816bc10$export$2e2bcd8739ae039).unbind();
    }
    var themeAttributes = (0, $226f2dc102fc9bfc$export$2e2bcd8739ae039)(themeState);
    Object.entries(themeAttributes).forEach(function(_ref) {
        var _ref2 = (0, $iOWlh.default)(_ref, 2), key = _ref2[0], value = _ref2[1];
        document.documentElement.setAttribute(key, value);
    });
    return function() {
        (0, $13afca741df4945b$export$2e2bcd8739ae039).unbind();
        if ((0, $50U6m.fg)('platform_increased-contrast-themes')) (0, $3152a7309816bc10$export$2e2bcd8739ae039).unbind();
    };
}



var $6o2jv = parcelRequire("6o2jv");

var $7lZkr = parcelRequire("7lZkr");
function $95306d003f19db75$export$bd1ac9300b0e885a(UNSAFE_themeOptions, mode) {
    var optionString = JSON.stringify(UNSAFE_themeOptions);
    var uniqueId = (0, $7lZkr.hash)(optionString);
    var attrOfMissingCustomStyles = [];
    (mode === 'auto' ? [
        'light',
        'dark'
    ] : [
        mode
    ]).forEach(function(themeId) {
        var element = document.head.querySelector("style[".concat((0, $6o2jv.CUSTOM_THEME_ATTRIBUTE), "=\"").concat(uniqueId, "\"][").concat((0, $6o2jv.THEME_DATA_ATTRIBUTE), "=\"").concat(themeId, "\"]"));
        if (element) // Append the existing custom styles to take precedence over others
        document.head.appendChild(element);
        else attrOfMissingCustomStyles.push(themeId);
    });
    return attrOfMissingCustomStyles;
}



var $Lk5z5 = parcelRequire("Lk5z5");
var $98727e147b429fef$export$5d76d7014f4a5d08 = function getThemeOverridePreferences(_themeState) {
    var themeOverridePreferences = [];
    return (0, $Lk5z5.default)(new Set(themeOverridePreferences));
};



var $Lk5z5 = parcelRequire("Lk5z5");

var $50U6m = parcelRequire("50U6m");

var $iOWlh = parcelRequire("iOWlh");

var $Lk5z5 = parcelRequire("Lk5z5");



var $ltcA1 = parcelRequire("ltcA1");
/**
 * Themes: The internal identifier of a theme.
 * These ids are what the actual theme files/folders are called.
 * style-dictionary will attempt to locate these in the file-system.
 */ /**
 * ThemeOverrides: The internal identifier of a theme override. Which are themes that contain
 * a subset of tokens intended to override an existing theme. These ids are what the actual
 * theme files/folders are called. style-dictionary will attempt to locate these in the file-system.
 * Theme overrides are temporary and there may not be any defined at times.
 */ /**
 * Theme kinds: The type of theme.
 * Some themes are entirely focused on Color, whilst others are purely focused on spacing.
 * In the future other types may be introduced such as typography.
 */ /**
 * Contrast preferences: The system contrast preference
 */ var $7ebbfe53da90c6ed$var$themeContrastModes = [
    'more',
    'no-preference',
    'auto'
];
/**
 * Theme override ids: the equivalent of themeIds for theme overrides.
 * Theme overrides are temporary and there may not be any defined at times.
 */ var $7ebbfe53da90c6ed$var$themeOverrideIds = [];
var $7ebbfe53da90c6ed$export$92ba366331403db2 = [].concat((0, $Lk5z5.default)((0, $cd36553759507965$export$7d43e72a58e3283f)), $7ebbfe53da90c6ed$var$themeOverrideIds);
var $7ebbfe53da90c6ed$export$9d64ff89b6869900 = {
    'atlassian-light': {
        id: 'light',
        displayName: 'Light Theme',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'light'
        }
    },
    'atlassian-light-future': {
        id: 'light-future',
        displayName: 'Future Light Theme',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'light'
        },
        override: 'light'
    },
    'atlassian-light-increased-contrast': {
        id: 'light-increased-contrast',
        displayName: 'Light Theme (increased contrast)',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'light'
        },
        extends: 'light',
        increasesContrastFor: 'light'
    },
    'atlassian-dark': {
        id: 'dark',
        displayName: 'Dark Theme',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'dark'
        }
    },
    'atlassian-dark-future': {
        id: 'dark-future',
        displayName: 'Future Dark Theme',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'dark'
        },
        override: 'light'
    },
    'atlassian-dark-increased-contrast': {
        id: 'dark-increased-contrast',
        displayName: 'Dark Theme (increased contrast)',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'dark'
        },
        extends: 'dark',
        increasesContrastFor: 'dark'
    },
    'atlassian-spacing': {
        id: 'spacing',
        displayName: 'Atlassian Spacing',
        palette: 'spacingScale',
        attributes: {
            type: 'spacing'
        }
    },
    'atlassian-typography': {
        id: 'typography',
        displayName: 'Atlassian Typography',
        palette: 'typographyPalette',
        attributes: {
            type: 'typography'
        }
    },
    'atlassian-shape': {
        id: 'shape',
        displayName: 'Shape',
        palette: 'shapePalette',
        attributes: {
            type: 'shape'
        }
    },
    'atlassian-motion': {
        id: 'motion',
        displayName: 'Motion',
        palette: 'motionPalette',
        attributes: {
            type: 'motion'
        }
    }
};
var /**
 * Represents theme state once mounted to the page
 * (the page doesn't have an "auto" color mode, it's either light or dark)
 */ // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$7ebbfe53da90c6ed$export$2e2bcd8739ae039 = $7ebbfe53da90c6ed$export$9d64ff89b6869900;


function $54d508e0dda84ae7$export$2e2bcd8739ae039(themeId) {
    var _Object$entries$find;
    return (_Object$entries$find = Object.entries((0, $7ebbfe53da90c6ed$export$2e2bcd8739ae039)).find(function(_ref) {
        var _ref2 = (0, $iOWlh.default)(_ref, 2), increasesContrastFor = _ref2[1].increasesContrastFor;
        return increasesContrastFor === themeId;
    })) === null || _Object$entries$find === void 0 ? void 0 : _Object$entries$find[1].id;
}


var $be15edfa1fe1c10f$export$dd6aeb7c823fc03d = function getThemePreferences(themeState) {
    var colorMode = themeState.colorMode, contrastMode = themeState.contrastMode, dark = themeState.dark, light = themeState.light, shape = themeState.shape, spacing = themeState.spacing, typography = themeState.typography, motion = themeState.motion;
    var autoColorModeThemes = [
        light,
        dark
    ];
    var themePreferences = [];
    if (colorMode === 'auto') {
        if (contrastMode !== 'no-preference' && (0, $50U6m.fg)('platform_increased-contrast-themes')) autoColorModeThemes.forEach(function(normalTheme) {
            var increasedContrastTheme = (0, $54d508e0dda84ae7$export$2e2bcd8739ae039)(normalTheme);
            if (increasedContrastTheme) autoColorModeThemes.push(increasedContrastTheme);
        });
        themePreferences.push.apply(themePreferences, autoColorModeThemes);
    } else {
        themePreferences.push(themeState[colorMode]);
        if (contrastMode !== 'no-preference' && (0, $50U6m.fg)('platform_increased-contrast-themes')) {
            var increasedContrastTheme = (0, $54d508e0dda84ae7$export$2e2bcd8739ae039)(themeState[colorMode]);
            if (increasedContrastTheme) themePreferences.push(increasedContrastTheme);
        }
    }
    [
        shape,
        spacing,
        typography,
        motion
    ].forEach(function(themeId) {
        if (themeId) themePreferences.push(themeId);
    });
    return (0, $Lk5z5.default)(new Set(themePreferences));
};




function $e7a39c73da64aa79$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $e7a39c73da64aa79$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $e7a39c73da64aa79$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $e7a39c73da64aa79$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $e7a39c73da64aa79$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $e7a39c73da64aa79$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function $e7a39c73da64aa79$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $e7a39c73da64aa79$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $e7a39c73da64aa79$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $6lpBT.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $e7a39c73da64aa79$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}

/**
 * Sets the theme globally at runtime. This updates the `data-theme` and `data-color-mode` attributes on your page's <html> tag.
 *
 * @param {Object<string, string>} themeState The themes and color mode that should be applied.
 * @param {string} themeState.colorMode Determines which color theme is applied. If set to `auto`, the theme applied will be determined by the OS setting.
 * @param {string} themeState.contrastMode The contrast mode theme to be applied. If set to `auto`, the theme applied will be determined by the OS setting.set to `auto`, the theme applied will be determined by the OS setting.
 * @param {string} themeState.dark The color theme to be applied when the color mode resolves to 'dark'.
 * @param {string} themeState.light The color theme to be applied when the color mode resolves to 'light'.
 * @param {string} themeState.motion The motion theme to be applied.
 * @param {string} themeState.shape The shape theme to be applied.
 * @param {string} themeState.spacing The spacing theme to be applied.
 * @param {string} themeState.typography The typography theme to be applied.
 * @param {Object} themeState.UNSAFE_themeOptions The custom branding options to be used for custom theme generation
 * @param {function} themeLoader Callback function used to override the default theme loading functionality.
 *
 * @returns A Promise of an unbind function, that can be used to stop listening for changes to system theme.
 *
 * @example
 * ```
 * setGlobalTheme({colorMode: 'auto', light: 'light', dark: 'dark', spacing: 'spacing'});
 * ```
 */ var $e7a39c73da64aa79$export$fd7e0dd2b74807f7 = /*#__PURE__*/ function() {
    var _ref = (0, $681551d977ccda12$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($0d2e6e43daff979d$exports))).mark(function _callee3() {
        var nextThemeState, themeLoader, _ref2, _ref2$colorMode, colorMode, _ref2$contrastMode, contrastMode, _ref2$dark, dark, _ref2$light, light, _ref2$shape, shape, _ref2$spacing, spacing, _ref2$typography, typography, _ref2$motion, motion, _ref2$UNSAFE_themeOpt, UNSAFE_themeOptions, themeState, themePreferences, loadingStrategy, loadingTasks, mode, attrOfMissingCustomStyles, themeOverridePreferences, _iterator, _step, themeId, autoUnbind, _args3 = arguments, _t;
        return (0, (/*@__PURE__*/$parcel$interopDefault($0d2e6e43daff979d$exports))).wrap(function(_context3) {
            while(true)switch(_context3.prev = _context3.next){
                case 0:
                    nextThemeState = _args3.length > 0 && _args3[0] !== undefined ? _args3[0] : {};
                    themeLoader = _args3.length > 1 ? _args3[1] : undefined;
                    _ref2 = typeof nextThemeState === 'function' ? nextThemeState($e7a39c73da64aa79$var$_objectSpread($e7a39c73da64aa79$var$_objectSpread({}, (0, $ltcA1.themeStateDefaults)), {}, {
                        typography: (0, $ltcA1.themeStateDefaults)['typography'],
                        shape: (0, $ltcA1.themeStateDefaults)['shape'](),
                        motion: (0, $ltcA1.themeStateDefaults)['motion']()
                    }, (0, $b40bdfcf4a616ca8$export$813ecdf77207a053)())) : nextThemeState, _ref2$colorMode = _ref2.colorMode, colorMode = _ref2$colorMode === void 0 ? (0, $ltcA1.themeStateDefaults)['colorMode'] : _ref2$colorMode, _ref2$contrastMode = _ref2.contrastMode, contrastMode = _ref2$contrastMode === void 0 ? (0, $ltcA1.themeStateDefaults)['contrastMode'] : _ref2$contrastMode, _ref2$dark = _ref2.dark, dark = _ref2$dark === void 0 ? (0, $ltcA1.themeStateDefaults)['dark'] : _ref2$dark, _ref2$light = _ref2.light, light = _ref2$light === void 0 ? (0, $ltcA1.themeStateDefaults)['light'] : _ref2$light, _ref2$shape = _ref2.shape, shape = _ref2$shape === void 0 ? (0, $ltcA1.themeStateDefaults)['shape']() : _ref2$shape, _ref2$spacing = _ref2.spacing, spacing = _ref2$spacing === void 0 ? (0, $ltcA1.themeStateDefaults)['spacing'] : _ref2$spacing, _ref2$typography = _ref2.typography, typography = _ref2$typography === void 0 ? (0, $ltcA1.themeStateDefaults)['typography'] : _ref2$typography, _ref2$motion = _ref2.motion, motion = _ref2$motion === void 0 ? (0, $ltcA1.themeStateDefaults)['motion']() : _ref2$motion, _ref2$UNSAFE_themeOpt = _ref2.UNSAFE_themeOptions, UNSAFE_themeOptions = _ref2$UNSAFE_themeOpt === void 0 ? (0, $ltcA1.themeStateDefaults)['UNSAFE_themeOptions'] : _ref2$UNSAFE_themeOpt; // CLEANUP: Remove. This blocks application of increased contrast themes
                    // without the feature flag enabled.
                    if (!(0, $50U6m.fg)('platform_increased-contrast-themes')) {
                        if (light === 'light-increased-contrast') light = 'light';
                        if (dark === 'dark-increased-contrast') dark = 'dark';
                    }
                    themeState = {
                        colorMode: colorMode,
                        contrastMode: contrastMode,
                        dark: dark,
                        light: light,
                        shape: shape,
                        spacing: spacing,
                        typography: typography,
                        motion: motion,
                        UNSAFE_themeOptions: themeLoader ? undefined : UNSAFE_themeOptions
                    }; // Determine what to load and loading strategy
                    themePreferences = (0, $be15edfa1fe1c10f$export$dd6aeb7c823fc03d)(themeState);
                    loadingStrategy = themeLoader ? themeLoader : (0, $15672a0d1f51b1ab$export$26cd7ae85c7144e5); // Load standard themes
                    loadingTasks = themePreferences.map(/*#__PURE__*/ function() {
                        var _ref3 = (0, $681551d977ccda12$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($0d2e6e43daff979d$exports))).mark(function _callee(themeId) {
                            return (0, (/*@__PURE__*/$parcel$interopDefault($0d2e6e43daff979d$exports))).wrap(function(_context) {
                                while(true)switch(_context.prev = _context.next){
                                    case 0:
                                        _context.next = 1;
                                        return loadingStrategy(themeId);
                                    case 1:
                                        return _context.abrupt("return", _context.sent);
                                    case 2:
                                    case "end":
                                        return _context.stop();
                                }
                            }, _callee);
                        }));
                        return function(_x) {
                            return _ref3.apply(this, arguments);
                        };
                    }()); // Load custom themes if needed
                    if (!themeLoader && UNSAFE_themeOptions && (0, $756d56646abc14e3$export$53031ac1ecb71f44)(UNSAFE_themeOptions === null || UNSAFE_themeOptions === void 0 ? void 0 : UNSAFE_themeOptions.brandColor)) {
                        mode = colorMode || (0, $ltcA1.themeStateDefaults)['colorMode'];
                        attrOfMissingCustomStyles = (0, $95306d003f19db75$export$bd1ac9300b0e885a)(UNSAFE_themeOptions, mode);
                        if (attrOfMissingCustomStyles.length > 0) // Load custom theme styles
                        loadingTasks.push((0, $681551d977ccda12$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($0d2e6e43daff979d$exports))).mark(function _callee2() {
                            var _yield$import, loadAndAppendCustomThemeCss;
                            return (0, (/*@__PURE__*/$parcel$interopDefault($0d2e6e43daff979d$exports))).wrap(function(_context2) {
                                while(true)switch(_context2.prev = _context2.next){
                                    case 0:
                                        _context2.next = 1;
                                        return (parcelRequire("hQcOh"));
                                    case 1:
                                        _yield$import = _context2.sent;
                                        loadAndAppendCustomThemeCss = _yield$import.loadAndAppendCustomThemeCss;
                                        loadAndAppendCustomThemeCss({
                                            colorMode: attrOfMissingCustomStyles.length === 2 ? 'auto' : // only load the missing custom theme styles
                                            attrOfMissingCustomStyles[0],
                                            UNSAFE_themeOptions: UNSAFE_themeOptions
                                        });
                                    case 2:
                                    case "end":
                                        return _context2.stop();
                                }
                            }, _callee2);
                        }))());
                    }
                    _context3.next = 1;
                    return Promise.all(loadingTasks);
                case 1:
                    // Load override themes after standard themes
                    themeOverridePreferences = (0, $98727e147b429fef$export$5d76d7014f4a5d08)(themeState);
                    _iterator = $e7a39c73da64aa79$var$_createForOfIteratorHelper(themeOverridePreferences);
                    _context3.prev = 2;
                    _iterator.s();
                case 3:
                    if ((_step = _iterator.n()).done) {
                        _context3.next = 5;
                        break;
                    }
                    themeId = _step.value;
                    _context3.next = 4;
                    return loadingStrategy(themeId);
                case 4:
                    _context3.next = 3;
                    break;
                case 5:
                    _context3.next = 7;
                    break;
                case 6:
                    _context3.prev = 6;
                    _t = _context3["catch"](2);
                    _iterator.e(_t);
                case 7:
                    _context3.prev = 7;
                    _iterator.f();
                    return _context3.finish(7);
                case 8:
                    autoUnbind = (0, $9e53a9907c3b882c$export$2e2bcd8739ae039)(themeState);
                    return _context3.abrupt("return", autoUnbind);
                case 9:
                case "end":
                    return _context3.stop();
            }
        }, _callee3, null, [
            [
                2,
                6,
                7,
                8
            ]
        ]);
    }));
    return function setGlobalTheme() {
        return _ref.apply(this, arguments);
    };
}();



var $5FkrB = parcelRequire("5FkrB");

var $5FkrB = parcelRequire("5FkrB");
var $fc8e39bf58b08a3f$export$d2def9838ca456c0 = /*#__PURE__*/ (0, $5FkrB.createContext)(false);


var $ba1ba235bf65b49c$export$a782702263f77544 = function useIsAppProviderThemingEnabled() {
    return (0, $5FkrB.useContext)((0, $fc8e39bf58b08a3f$export$d2def9838ca456c0));
};



var $5FkrB = parcelRequire("5FkrB");

var $5FkrB = parcelRequire("5FkrB");
var $6100bc3bbf0b7ac9$export$7981b2444296e410 = /*#__PURE__*/ (0, $5FkrB.createContext)(false);


var $a05d22bc685d9de7$export$26aa23367bfbab0e = function useIsInsideAppProvider() {
    return (0, $5FkrB.useContext)((0, $6100bc3bbf0b7ac9$export$7981b2444296e410));
};



var $5FkrB = parcelRequire("5FkrB");
var $85e016ca147353cc$export$49ddd74a6729fdb0 = /*#__PURE__*/ (0, $5FkrB.createContext)(undefined);



var $5FkrB = parcelRequire("5FkrB");
var $021e9353b06d2882$export$332347eeb335453c = /*#__PURE__*/ (0, $5FkrB.createContext)(false);



var $5FkrB = parcelRequire("5FkrB");
var $0022ec27217363ed$export$b06130bad0bbc70f = /*#__PURE__*/ (0, $5FkrB.createContext)(undefined);



var $5FkrB = parcelRequire("5FkrB");
var $bd3f52c2e3d4f330$export$2c657da244d00bd6 = /*#__PURE__*/ (0, $5FkrB.createContext)(undefined);
var $bd3f52c2e3d4f330$export$f7a97b47760e2a13 = /*#__PURE__*/ (0, $5FkrB.createContext)(undefined);



var $5FkrB = parcelRequire("5FkrB");

var $0a464043c5ac532b$export$7ca11437599d653d = function useIsInsideThemeProvider() {
    var _useContext;
    return (_useContext = (0, $5FkrB.useContext)((0, $021e9353b06d2882$export$332347eeb335453c))) !== null && _useContext !== void 0 ? _useContext : false;
};




var $fc5ac9c99de29fbb$export$f65ca476c09acec0 = function getDocument() {
    if (typeof document !== 'undefined') return document;
    return null;
};





var $6o2jv = parcelRequire("6o2jv");
function $5f58191f17fbe680$export$835a0dc855d02822(themeId) {
    var doc = (0, $fc5ac9c99de29fbb$export$f65ca476c09acec0)();
    if (!doc) return false;
    return doc.head.querySelector("style[".concat((0, $6o2jv.THEME_DATA_ATTRIBUTE), "=\"").concat(themeId, "\"]"));
}


var $0bbb05f64441d8b4$var$loadThemeCss = /*#__PURE__*/ function() {
    var _ref = (0, $681551d977ccda12$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($0d2e6e43daff979d$exports))).mark(function _callee(themeId) {
        var _yield$themeImportMap, themeCss;
        return (0, (/*@__PURE__*/$parcel$interopDefault($0d2e6e43daff979d$exports))).wrap(function(_context) {
            while(true)switch(_context.prev = _context.next){
                case 0:
                    if (!(0, $5f58191f17fbe680$export$835a0dc855d02822)(themeId)) {
                        _context.next = 1;
                        break;
                    }
                    return _context.abrupt("return");
                case 1:
                    if (themeId) {
                        _context.next = 2;
                        break;
                    }
                    return _context.abrupt("return");
                case 2:
                    _context.next = 3;
                    return (0, $6e5cdf912c2de5d7$export$3a171c49f8c16356)[themeId]();
                case 3:
                    _yield$themeImportMap = _context.sent;
                    themeCss = _yield$themeImportMap.default;
                    return _context.abrupt("return", themeCss);
                case 4:
                case "end":
                    return _context.stop();
            }
        }, _callee);
    }));
    return function loadThemeCss(_x) {
        return _ref.apply(this, arguments);
    };
}();
var $0bbb05f64441d8b4$var$mountThemeCss = /*#__PURE__*/ function() {
    var _ref2 = (0, $681551d977ccda12$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($0d2e6e43daff979d$exports))).mark(function _callee2(css, themeId) {
        var doc, style;
        return (0, (/*@__PURE__*/$parcel$interopDefault($0d2e6e43daff979d$exports))).wrap(function(_context2) {
            while(true)switch(_context2.prev = _context2.next){
                case 0:
                    // SSR-safe: Only mount on client side
                    doc = (0, $fc5ac9c99de29fbb$export$f65ca476c09acec0)();
                    if (doc) {
                        _context2.next = 1;
                        break;
                    }
                    return _context2.abrupt("return");
                case 1:
                    style = doc.createElement('style');
                    style.textContent = css;
                    style.dataset.theme = themeId;
                    // Prevent duplicate mounting of themes.
                    // It's possible the theme was already being loaded elsewhere.
                    if (!(0, $5f58191f17fbe680$export$835a0dc855d02822)(themeId)) {
                        _context2.next = 2;
                        break;
                    }
                    return _context2.abrupt("return");
                case 2:
                    doc.head.appendChild(style);
                case 3:
                case "end":
                    return _context2.stop();
            }
        }, _callee2);
    }));
    return function mountThemeCss(_x2, _x3) {
        return _ref2.apply(this, arguments);
    };
}();
var $0bbb05f64441d8b4$var$loadAndMountThemeCss = /*#__PURE__*/ function() {
    var _ref3 = (0, $681551d977ccda12$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($0d2e6e43daff979d$exports))).mark(function _callee3(themeId) {
        var themeCss;
        return (0, (/*@__PURE__*/$parcel$interopDefault($0d2e6e43daff979d$exports))).wrap(function(_context3) {
            while(true)switch(_context3.prev = _context3.next){
                case 0:
                    _context3.next = 1;
                    return $0bbb05f64441d8b4$var$loadThemeCss(themeId);
                case 1:
                    themeCss = _context3.sent;
                    if (themeCss) {
                        _context3.next = 2;
                        break;
                    }
                    return _context3.abrupt("return");
                case 2:
                    $0bbb05f64441d8b4$var$mountThemeCss(themeCss, themeId);
                case 3:
                case "end":
                    return _context3.stop();
            }
        }, _callee3);
    }));
    return function loadAndMountThemeCss(_x4) {
        return _ref3.apply(this, arguments);
    };
}();
var $0bbb05f64441d8b4$export$7d4a7e812d176b24 = /*#__PURE__*/ function() {
    var _ref4 = (0, $681551d977ccda12$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($0d2e6e43daff979d$exports))).mark(function _callee4(theme) {
        var themesToLoad;
        return (0, (/*@__PURE__*/$parcel$interopDefault($0d2e6e43daff979d$exports))).wrap(function(_context4) {
            while(true)switch(_context4.prev = _context4.next){
                case 0:
                    themesToLoad = Object.values(theme).filter(function(themeId) {
                        return !!themeId;
                    });
                    themesToLoad.forEach($0bbb05f64441d8b4$var$loadAndMountThemeCss);
                case 1:
                case "end":
                    return _context4.stop();
            }
        }, _callee4);
    }));
    return function loadAndMountThemes(_x5) {
        return _ref4.apply(this, arguments);
    };
}();


function $3eb646f90832f30b$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $3eb646f90832f30b$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $3eb646f90832f30b$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $6lpBT.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $3eb646f90832f30b$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $3eb646f90832f30b$var$defaultThemeSettings = {
    dark: 'dark',
    light: 'light',
    spacing: 'spacing',
    typography: 'typography'
};
var $3eb646f90832f30b$var$isMatchMediaAvailable = typeof window !== 'undefined' && 'matchMedia' in window;
var $3eb646f90832f30b$var$prefersDarkModeMql = $3eb646f90832f30b$var$isMatchMediaAvailable ? window.matchMedia('(prefers-color-scheme: dark)') : undefined;
// TODO: currently 'auto' color mode will always return 'light' in SSR.
// Additional work required: https://product-fabric.atlassian.net/browse/DSP-9781
function $3eb646f90832f30b$var$getReconciledColorMode(colorMode) {
    if (colorMode === 'auto') return $3eb646f90832f30b$var$prefersDarkModeMql !== null && $3eb646f90832f30b$var$prefersDarkModeMql !== void 0 && $3eb646f90832f30b$var$prefersDarkModeMql.matches ? 'dark' : 'light';
    return colorMode;
}
var $3eb646f90832f30b$var$contentStyles = {
    body: "_1e0c1bgi"
};
function $3eb646f90832f30b$export$d8964aec282183a3(_ref) {
    var children = _ref.children, _ref$defaultColorMode = _ref.defaultColorMode, defaultColorMode = _ref$defaultColorMode === void 0 ? 'auto' : _ref$defaultColorMode, defaultTheme = _ref.defaultTheme;
    var _useState = (0, $5FkrB.useState)(defaultColorMode), _useState2 = (0, $iOWlh.default)(_useState, 2), chosenColorMode = _useState2[0], setChosenColorMode = _useState2[1];
    var _useState3 = (0, $5FkrB.useState)($3eb646f90832f30b$var$getReconciledColorMode(defaultColorMode)), _useState4 = (0, $iOWlh.default)(_useState3, 2), reconciledColorMode = _useState4[0], setReconciledColorMode = _useState4[1];
    var _useState5 = (0, $5FkrB.useState)(function() {
        return $3eb646f90832f30b$var$_objectSpread($3eb646f90832f30b$var$_objectSpread({}, $3eb646f90832f30b$var$defaultThemeSettings), defaultTheme);
    }), _useState6 = (0, $iOWlh.default)(_useState5, 2), theme = _useState6[0], setTheme = _useState6[1];
    var setColorMode = (0, $5FkrB.useCallback)(function(colorMode) {
        setChosenColorMode(colorMode);
        setReconciledColorMode($3eb646f90832f30b$var$getReconciledColorMode(colorMode));
    }, []);
    var setPartialTheme = (0, $5FkrB.useCallback)(function(nextTheme) {
        setTheme(function(theme) {
            return $3eb646f90832f30b$var$_objectSpread($3eb646f90832f30b$var$_objectSpread({}, theme), nextTheme);
        });
    }, []);
    var lastSetGlobalThemePromiseRef = (0, $5FkrB.useRef)(null);
    var isInsideAppProvider = (0, $a05d22bc685d9de7$export$26aa23367bfbab0e)();
    var isAppProviderThemingEnabled = (0, $ba1ba235bf65b49c$export$a782702263f77544)();
    var isInsideThemeProvider = (0, $0a464043c5ac532b$export$7ca11437599d653d)();
    /**
   * A top-level ThemeProvider is detected by being the first ThemeProvider inside an AppProvider.
   *
   * This will not use sub-tree theming but instead set the global theme state using the
   * `@atlaskit/tokens` APIs, as it's required for styling root `html` and `body` elements
   * for compatibility with `@atlaskit/css-reset`.
   *
   * In the future we could consider moving away from DOM mutations and require AppProvider to wrap
   * `html` in order to apply global theme state, which would allow a more consistent approach to
   * theme loading.
   */ var isRootThemeProvider = isInsideAppProvider && !isInsideThemeProvider && isAppProviderThemingEnabled;
    (0, $5FkrB.useEffect)(function() {
        if (isRootThemeProvider) {
            /**
       * We need to wait for any previous `setGlobalTheme` calls to finish before calling it again.
       * This is to prevent race conditions as `setGlobalTheme` is async and mutates the DOM (e.g. sets the
       * `data-color-mode` attribute on the root element).
       *
       * Since we can't safely abort the `setGlobalTheme` execution, we need to wait for it to properly finish before
       * applying the new theme.
       *
       * Without this, we can end up in the following scenario:
       * 1. app loads with the default 'light' theme, kicking off `setGlobalTheme`
       * 2. app switches to 'dark' theme after retrieving value persisted in local storage, calling `setGlobalTheme` again
       * 3. `setGlobalTheme` function execution for `dark` finishes before the initial `light` execution
       * 4. `setGlobalTheme` function execution for `light` then finishes, resulting in the 'light' theme being applied.
       */ var cleanupLastFnCall = /*#__PURE__*/ function() {
                var _ref2 = (0, $681551d977ccda12$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($0d2e6e43daff979d$exports))).mark(function _callee() {
                    var unbindFn;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($0d2e6e43daff979d$exports))).wrap(function(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                if (!lastSetGlobalThemePromiseRef.current) {
                                    _context.next = 2;
                                    break;
                                }
                                _context.next = 1;
                                return lastSetGlobalThemePromiseRef.current;
                            case 1:
                                unbindFn = _context.sent;
                                unbindFn();
                                lastSetGlobalThemePromiseRef.current = null;
                            case 2:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee);
                }));
                return function cleanupLastFnCall() {
                    return _ref2.apply(this, arguments);
                };
            }();
            var safelySetGlobalTheme = /*#__PURE__*/ function() {
                var _ref3 = (0, $681551d977ccda12$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($0d2e6e43daff979d$exports))).mark(function _callee2() {
                    var promise;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($0d2e6e43daff979d$exports))).wrap(function(_context2) {
                        while(true)switch(_context2.prev = _context2.next){
                            case 0:
                                _context2.next = 1;
                                return cleanupLastFnCall();
                            case 1:
                                promise = (0, $e7a39c73da64aa79$export$fd7e0dd2b74807f7)($3eb646f90832f30b$var$_objectSpread($3eb646f90832f30b$var$_objectSpread({}, theme), {}, {
                                    colorMode: reconciledColorMode
                                }));
                                lastSetGlobalThemePromiseRef.current = promise;
                            case 2:
                            case "end":
                                return _context2.stop();
                        }
                    }, _callee2);
                }));
                return function safelySetGlobalTheme() {
                    return _ref3.apply(this, arguments);
                };
            }();
            safelySetGlobalTheme();
            return function cleanup() {
                cleanupLastFnCall();
            };
        } else // For other theme providers (whether outside AppProvider or nested inside a ThemeProvider),
        // we treat them as sub-tree themes that do not load global theme state.
        (0, $0bbb05f64441d8b4$export$7d4a7e812d176b24)(theme);
    }, [
        isInsideAppProvider,
        isInsideThemeProvider,
        isRootThemeProvider,
        reconciledColorMode,
        theme
    ]);
    (0, $5FkrB.useEffect)(function() {
        if (!$3eb646f90832f30b$var$prefersDarkModeMql) return;
        var unbindListener = (0, $5b617c1f48263075$exports.bind)($3eb646f90832f30b$var$prefersDarkModeMql, {
            type: 'change',
            listener: function listener(event) {
                if (chosenColorMode === 'auto') setReconciledColorMode(event.matches ? 'dark' : 'light');
            }
        });
        return unbindListener;
    }, [
        chosenColorMode
    ]);
    var attrs = $3eb646f90832f30b$var$_objectSpread($3eb646f90832f30b$var$_objectSpread({}, (0, $226f2dc102fc9bfc$export$e1f80cb7a749802f)($3eb646f90832f30b$var$_objectSpread($3eb646f90832f30b$var$_objectSpread({}, theme), {}, {
        colorMode: reconciledColorMode
    }))), {}, (0, $6lpBT.default)({}, (0, $6o2jv.SUBTREE_THEME_ATTRIBUTE), true));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $021e9353b06d2882$export$332347eeb335453c).Provider, {
        value: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $85e016ca147353cc$export$49ddd74a6729fdb0).Provider, {
        value: reconciledColorMode
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $0022ec27217363ed$export$b06130bad0bbc70f).Provider, {
        value: setColorMode
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $bd3f52c2e3d4f330$export$2c657da244d00bd6).Provider, {
        value: theme
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $bd3f52c2e3d4f330$export$f7a97b47760e2a13).Provider, {
        value: setPartialTheme
    }, !isRootThemeProvider ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("div", (0, $581280dfb2cb8b3f$export$2e2bcd8739ae039)({}, attrs, {
        className: (0, $b02ab0e3a0f362dd$export$2e2bcd8739ae039)([
            $3eb646f90832f30b$var$contentStyles.body
        ])
    }), children) : children)))));
}



var $iOWlh = parcelRequire("iOWlh");

var $5FkrB = parcelRequire("5FkrB");


var $6QlWs = parcelRequire("6QlWs");

var $bLKSF = parcelRequire("bLKSF");

var $6lpBT = parcelRequire("6lpBT");

var $6o2jv = parcelRequire("6o2jv");

var $f5582289386e0665$export$b741a7c3bcb1c635 = /*#__PURE__*/ function() {
    function ThemeMutationObserver(callback) {
        (0, $6QlWs.default)(this, ThemeMutationObserver);
        (0, $6lpBT.default)(this, "legacyObserver", null);
        this.callback = callback;
        ThemeMutationObserver.callbacks.add(callback);
    }
    return (0, $bLKSF.default)(ThemeMutationObserver, [
        {
            key: "observe",
            value: function observe() {
                if (!ThemeMutationObserver.observer) {
                    ThemeMutationObserver.observer = new MutationObserver(function() {
                        var theme = (0, $b40bdfcf4a616ca8$export$813ecdf77207a053)();
                        ThemeMutationObserver.callbacks.forEach(function(callback) {
                            return callback(theme);
                        });
                    });
                    // Observer only needs to be configured once
                    ThemeMutationObserver.observer.observe(document.documentElement, {
                        attributeFilter: [
                            (0, $6o2jv.THEME_DATA_ATTRIBUTE),
                            (0, $6o2jv.COLOR_MODE_ATTRIBUTE)
                        ]
                    });
                }
            }
        },
        {
            key: "disconnect",
            value: function disconnect() {
                if (this.callback) ThemeMutationObserver.callbacks.delete(this.callback);
                if (ThemeMutationObserver.callbacks.size === 0 && ThemeMutationObserver.observer) {
                    ThemeMutationObserver.observer.disconnect();
                    ThemeMutationObserver.observer = null;
                }
            }
        }
    ]);
}();
(0, $6lpBT.default)($f5582289386e0665$export$b741a7c3bcb1c635, "observer", null);
(0, $6lpBT.default)($f5582289386e0665$export$b741a7c3bcb1c635, "callbacks", new Set());
var $f5582289386e0665$export$2e2bcd8739ae039 = $f5582289386e0665$export$b741a7c3bcb1c635;



function $662c360a0b5c0d7a$export$20f3076712c8dfa() {
    var value = (0, $5FkrB.useContext)((0, $85e016ca147353cc$export$49ddd74a6729fdb0));
    // TODO: This will only return 'light' or 'dark' but never 'auto', which in some cases
    // may be desirable. We should consider returning both the reconciled color mode (e.g. 'light' or 'dark') and the selected color mode ("auto").
    var theme = (0, $b40bdfcf4a616ca8$export$813ecdf77207a053)();
    var _useState = (0, $5FkrB.useState)((theme === null || theme === void 0 ? void 0 : theme.colorMode) || 'light'), _useState2 = (0, $iOWlh.default)(_useState, 2), resolvedColorMode = _useState2[0], setResolvedColorMode = _useState2[1];
    (0, $5FkrB.useEffect)(function() {
        // We are using theme from context so no need to reference the DOM
        if (value) return;
        var observer = new (0, $f5582289386e0665$export$b741a7c3bcb1c635)(function(theme) {
            setResolvedColorMode((theme === null || theme === void 0 ? void 0 : theme.colorMode) || 'light');
        });
        observer.observe();
        return function() {
            return observer.disconnect();
        };
    }, [
        value
    ]);
    return value ? value : resolvedColorMode;
}




var $50U6m = parcelRequire("50U6m");
var $ce35719b8fe24aa7$export$e4c79eb95c23a0da = 'atlaskit-portal-container';
var $ce35719b8fe24aa7$export$72f415121273627e = 'body > .atlaskit-portal-container';
var $ce35719b8fe24aa7$export$13f57c02915787b3 = 'atlaskit-portal';


/**
 * Returns document body element
 * @return {number} - The document body element
 */ var $ef21ab619b0b14e8$export$135b49d4bc2964c6 = function getBody() {
    return document.body;
};


var $ed2d0c26fdd9dc78$var$getPortalParent = function getPortalParent() {
    var parentElement = document.querySelector((0, $ce35719b8fe24aa7$export$72f415121273627e));
    if (!parentElement) {
        var _getBody;
        var parent = document.createElement('div');
        parent.className = (0, $ce35719b8fe24aa7$export$e4c79eb95c23a0da);
        // we are setting display to flex because we want each portal to create a new stacking context
        // See https://developer.mozilla.org/en-US/docs/Web/CSS/CSS_Positioning/Understanding_z_index/The_stacking_context
        parent.style.display = 'flex';
        (_getBody = (0, $ef21ab619b0b14e8$export$135b49d4bc2964c6)()) === null || _getBody === void 0 || _getBody.appendChild(parent);
        return parent;
    }
    return parentElement;
};
var $ed2d0c26fdd9dc78$export$c582005add11e141 = function appendPortalContainerIfNotAppended(container) {
    if (!container.parentElement) $ed2d0c26fdd9dc78$var$getPortalParent().appendChild(container);
};



var $ec564e7f86444039$export$26ae5ca175b4ec5a = function createContainer(zIndex) {
    var container = document.createElement('div');
    container.className = (0, $ce35719b8fe24aa7$export$13f57c02915787b3);
    container.style.zIndex = "".concat(zIndex);
    return container;
};




var $9480b40d0374d071$var$getPortalParent = function getPortalParent() {
    var parentElement = document.querySelector((0, $ce35719b8fe24aa7$export$72f415121273627e));
    if (!parentElement) {
        var _getBody;
        var parent = document.createElement('div');
        parent.className = (0, $ce35719b8fe24aa7$export$e4c79eb95c23a0da);
        // we are setting display to flex because we want each portal to create a new stacking context
        // See https://developer.mozilla.org/en-US/docs/Web/CSS/CSS_Positioning/Understanding_z_index/The_stacking_context
        parent.style.display = 'flex';
        (_getBody = (0, $ef21ab619b0b14e8$export$135b49d4bc2964c6)()) === null || _getBody === void 0 || _getBody.appendChild(parent);
        return parent;
    }
    return parentElement;
};
var $9480b40d0374d071$export$da99f98bf3fe55b3 = function removePortalContainer(container) {
    var parent = $9480b40d0374d071$var$getPortalParent();
    if (parent.contains(container)) parent.removeChild(container);
};


function $407c3f4d80e747f9$export$2e2bcd8739ae039(props) {
    var zIndex = props.zIndex, children = props.children, _props$isClosed = props.isClosed, isClosed = _props$isClosed === void 0 ? false : _props$isClosed;
    var container = (0, $5FkrB.useMemo)(function() {
        return (0, $ec564e7f86444039$export$26ae5ca175b4ec5a)(zIndex);
    }, [
        zIndex
    ]);
    var colorMode = (0, $662c360a0b5c0d7a$export$20f3076712c8dfa)();
    var isInsideThemeProvider = (0, $0a464043c5ac532b$export$7ca11437599d653d)();
    // This is in the render method instead of useEffect so that
    // the portal will be added to the DOM before the children render.
    // For any further changes, ensure that the container does not have a
    // parent besides the portal parent.
    (0, $ed2d0c26fdd9dc78$export$c582005add11e141)(container);
    (0, $5FkrB.useEffect)(function() {
        if ((0, $50U6m.fg)('import_into_jsm_in_template_gallery_killswitch')) {
            if (isClosed) (0, $9480b40d0374d071$export$da99f98bf3fe55b3)(container);
        }
    }, [
        isClosed,
        container
    ]);
    (0, $5FkrB.useEffect)(function() {
        return function() {
            (0, $9480b40d0374d071$export$da99f98bf3fe55b3)(container);
        };
    }, [
        container
    ]);
    return /*#__PURE__*/ (0, $7d59b24134129acf$exports.createPortal)(isInsideThemeProvider ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $3eb646f90832f30b$export$d8964aec282183a3), {
        defaultColorMode: colorMode
    }, children) : children, container);
}


function $a73ff265fe34e1f6$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return r;
}


function $4264630b0025dc98$export$2e2bcd8739ae039(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}


function $51b34d4c54a1ceca$export$2e2bcd8739ae039(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}


function $dc3553b216bc6bde$export$2e2bcd8739ae039(r, a) {
    if (r) {
        if ("string" == typeof r) return (0, $51b34d4c54a1ceca$export$2e2bcd8739ae039)(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? (0, $51b34d4c54a1ceca$export$2e2bcd8739ae039)(r, a) : void 0;
    }
}


function $39575de85158081c$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}


function $b723944cc3e318d5$export$2e2bcd8739ae039(r, e) {
    return (0, $a73ff265fe34e1f6$export$2e2bcd8739ae039)(r) || (0, $4264630b0025dc98$export$2e2bcd8739ae039)(r, e) || (0, $dc3553b216bc6bde$export$2e2bcd8739ae039)(r, e) || (0, $39575de85158081c$export$2e2bcd8739ae039)();
}



var $5FkrB = parcelRequire("5FkrB");





var $50U6m = parcelRequire("50U6m");

var $5FkrB = parcelRequire("5FkrB");
var $accd0c7719cc05e3$export$700979bc83e7db82 = typeof window !== 'undefined' ? (0, $5FkrB.useLayoutEffect) : (0, $5FkrB.useEffect);



var $c743c97e9960c6bd$var$isDocumentDefined = function isDocumentDefined() {
    return document !== undefined;
};
var $c743c97e9960c6bd$export$fef014d7cef9e543 = function createAtlaskitPortal(zIndex) {
    //atlaskit-portal div
    if ($c743c97e9960c6bd$var$isDocumentDefined()) {
        var atlaskitportal = document.createElement('div');
        atlaskitportal.className = (0, $ce35719b8fe24aa7$export$13f57c02915787b3);
        atlaskitportal.style.zIndex = "".concat(zIndex);
        return atlaskitportal;
    }
    return;
};




var $9df34bdaed18272b$var$isDocumentDefined = function isDocumentDefined() {
    return document !== undefined;
};
var $9df34bdaed18272b$export$95029ca7aca2989e = function createPortalParent() {
    //atlaskit-portal-container div
    if ($9df34bdaed18272b$var$isDocumentDefined()) {
        var parentElement = document.querySelector((0, $ce35719b8fe24aa7$export$72f415121273627e));
        if (!parentElement) {
            var _getBody;
            var parent = document.createElement('div');
            parent.className = (0, $ce35719b8fe24aa7$export$e4c79eb95c23a0da);
            parent.style.display = 'flex';
            (_getBody = (0, $ef21ab619b0b14e8$export$135b49d4bc2964c6)()) === null || _getBody === void 0 || _getBody.appendChild(parent);
            return parent;
        }
        return parentElement;
    }
    return;
};



var $c401d4a9022f5424$var$isDocumentDefined = function isDocumentDefined() {
    return document !== undefined;
};
var $c401d4a9022f5424$export$7b20876b2769b301 = function removePortalParent(parentElement) {
    if ($c401d4a9022f5424$var$isDocumentDefined()) {
        if (parentElement) {
            var _getBody;
            (_getBody = (0, $ef21ab619b0b14e8$export$135b49d4bc2964c6)()) === null || _getBody === void 0 || _getBody.removeChild(parentElement);
        }
    }
};


function $294c1ed9b98aa8bc$export$2e2bcd8739ae039(props) {
    var zIndex = props.zIndex, children = props.children, isClosed = props.isClosed;
    var _useState = (0, $5FkrB.useState)(null), _useState2 = (0, $b723944cc3e318d5$export$2e2bcd8739ae039)(_useState, 2), atlaskitPortal = _useState2[0], setAtlaskitPortal = _useState2[1];
    var colorMode = (0, $662c360a0b5c0d7a$export$20f3076712c8dfa)();
    var isInsideThemeProvider = (0, $0a464043c5ac532b$export$7ca11437599d653d)();
    (0, $accd0c7719cc05e3$export$700979bc83e7db82)(function() {
        if ((0, $50U6m.fg)('import_into_jsm_in_template_gallery_killswitch')) {
            if (!isClosed) {
                var tempPortalContainer = (0, $c743c97e9960c6bd$export$fef014d7cef9e543)(zIndex);
                setAtlaskitPortal(tempPortalContainer);
                var portalParent = (0, $9df34bdaed18272b$export$95029ca7aca2989e)();
                if (!tempPortalContainer || !portalParent) return;
                portalParent.appendChild(tempPortalContainer);
                return function() {
                    if (portalParent) {
                        portalParent.removeChild(tempPortalContainer);
                        !portalParent.hasChildNodes() && (0, $c401d4a9022f5424$export$7b20876b2769b301)(portalParent);
                    }
                    setAtlaskitPortal(null);
                };
            }
        } else {
            var _tempPortalContainer = (0, $c743c97e9960c6bd$export$fef014d7cef9e543)(zIndex);
            setAtlaskitPortal(_tempPortalContainer);
            var _portalParent = (0, $9df34bdaed18272b$export$95029ca7aca2989e)();
            if (!_tempPortalContainer || !_portalParent) return;
            _portalParent.appendChild(_tempPortalContainer);
            return function() {
                if (_tempPortalContainer) _portalParent.removeChild(_tempPortalContainer);
                setAtlaskitPortal(null);
            };
        }
    }, [
        zIndex,
        isClosed,
        (0, $50U6m.fg)
    ]);
    /**
   * We wrap portal children with a Suspense boundary because in React 18 concurrent,
   * if you suspend from _within_ a portal to a Suspense boundary _outside_ the portal,
   * our portal gets in an infinite loop of rendering.
   */ var suspendedChildren = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $5FkrB.Suspense), {
        fallback: null
    }, isInsideThemeProvider ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $3eb646f90832f30b$export$d8964aec282183a3), {
        defaultColorMode: colorMode
    }, children) : children);
    return atlaskitPortal ? /*#__PURE__*/ (0, $7d59b24134129acf$exports.createPortal)(suspendedChildren, atlaskitPortal) : null;
}




var $5FkrB = parcelRequire("5FkrB");

var $83d077a9d4e5feff$var$useIsSubsequentRender = function useIsSubsequentRender(mountStrategy) {
    var _useState = (0, $5FkrB.useState)(false), _useState2 = (0, $b723944cc3e318d5$export$2e2bcd8739ae039)(_useState, 2), isSubsequentRender = _useState2[0], setIsSubsequentRender = _useState2[1];
    var _useState3 = (0, $5FkrB.useState)(function() {
        return mountStrategy === 'layoutEffect' ? (0, $accd0c7719cc05e3$export$700979bc83e7db82) : (0, $5FkrB.useEffect);
    }), _useState4 = (0, $b723944cc3e318d5$export$2e2bcd8739ae039)(_useState3, 1), useMountEffect = _useState4[0];
    useMountEffect(function() {
        setIsSubsequentRender(true);
    }, []);
    return isSubsequentRender;
};
var $83d077a9d4e5feff$export$2e2bcd8739ae039 = $83d077a9d4e5feff$var$useIsSubsequentRender;



var $5FkrB = parcelRequire("5FkrB");
var $5e12f7691be82ebc$export$ed5835cc67e87f72 = 'akPortalMount';
var $5e12f7691be82ebc$export$80816bd900e5bd00 = 'akPortalUnmount';


var $13d8b9306358618f$var$zIndexToName = {
    100: 'card',
    200: 'navigation',
    300: 'dialog',
    400: 'layer',
    500: 'blanket',
    510: 'modal',
    600: 'flag',
    700: 'spotlight',
    9999: 'tooltip'
};
/**
 * return layer name in Atlassian design system corresponding to given z-index
 * @param {number} zIndex - z-index value for which layer name is needed
 * @returns {LayerName | null} - The layer name for given z-index. If layer name is not found then null is returned
 */ var $13d8b9306358618f$var$getLayerName = function getLayerName(zIndex) {
    return $13d8b9306358618f$var$zIndexToName.hasOwnProperty(zIndex) ? $13d8b9306358618f$var$zIndexToName[zIndex] : null;
};
/**
 * Creates a PortalEvent object with given eventName, given zIndex and corresponding layer
 * @param {string} eventName - either of Mount or Unmount event name
 * @param {number} zIndex - z-index value which will be included in the event to be dispatched
 * @returns {PortalEvent} - The newly created PortalEvent object
 */ var $13d8b9306358618f$var$getEvent = function getEvent(eventName, zIndex) {
    var detail = {
        layer: $13d8b9306358618f$var$getLayerName(Number(zIndex)),
        zIndex: zIndex
    };
    return new CustomEvent(eventName, {
        detail: detail
    });
};
function $13d8b9306358618f$export$2e2bcd8739ae039(eventName, zIndex) {
    var event = $13d8b9306358618f$var$getEvent(eventName, zIndex);
    window.dispatchEvent(event);
}


var $e2b5db1d8b3115ec$var$useFirePortalEvent = function useFirePortalEvent(zIndex) {
    var zIndexNumber = Number(zIndex);
    (0, $5FkrB.useEffect)(function() {
        (0, $13d8b9306358618f$export$2e2bcd8739ae039)((0, $5e12f7691be82ebc$export$ed5835cc67e87f72), zIndexNumber);
        return function() {
            (0, $13d8b9306358618f$export$2e2bcd8739ae039)((0, $5e12f7691be82ebc$export$80816bd900e5bd00), zIndexNumber);
        };
    }, [
        zIndexNumber
    ]);
};
var $e2b5db1d8b3115ec$export$2e2bcd8739ae039 = $e2b5db1d8b3115ec$var$useFirePortalEvent;


function $b972fda2d5cd73a8$export$2e2bcd8739ae039(_ref) {
    var _ref$zIndex = _ref.zIndex, zIndex = _ref$zIndex === void 0 ? 0 : _ref$zIndex, children = _ref.children, _ref$mountStrategy = _ref.mountStrategy, mountStrategy = _ref$mountStrategy === void 0 ? 'effect' : _ref$mountStrategy, _ref$isClosed = _ref.isClosed, isClosed = _ref$isClosed === void 0 ? false : _ref$isClosed;
    var isSubsequentRender = (0, $83d077a9d4e5feff$export$2e2bcd8739ae039)(mountStrategy);
    (0, $e2b5db1d8b3115ec$export$2e2bcd8739ae039)(zIndex);
    return !(0, $50U6m.fg)('platform_design_system_team_portal_logic_r18_fix') ? isSubsequentRender ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $407c3f4d80e747f9$export$2e2bcd8739ae039), {
        zIndex: zIndex,
        isClosed: isClosed
    }, children) : null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $294c1ed9b98aa8bc$export$2e2bcd8739ae039), {
        zIndex: zIndex,
        isClosed: isClosed
    }, children);
}


/* box.tsx generated by @compiled/babel-plugin v2.0.0 */ function $a98c0fbb1cee895f$export$2e2bcd8739ae039() {
    return $a98c0fbb1cee895f$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $a98c0fbb1cee895f$export$2e2bcd8739ae039.apply(null, arguments);
}


function $3abfb52294d84358$export$2e2bcd8739ae039(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}


function $a9c67d4ab15fb282$export$2e2bcd8739ae039(e, t) {
    if (null == e) return {};
    var o, r, i = (0, $3abfb52294d84358$export$2e2bcd8739ae039)(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}



var $5FkrB = parcelRequire("5FkrB");
/**
 * The length of the value hash portion of an atomic class name.
 * Atomic class names have the format: `_<group><value>`
 * where group is ATOMIC_GROUP_HASH_LENGTH chars and value is ATOMIC_VALUE_HASH_LENGTH chars.
 *
 * We extract the group key using: `className.slice(0, className.length - ATOMIC_VALUE_HASH_LENGTH)`
 *
 * We support both old-format classes (9 chars: `_` + 4 group + 4 value) and
 * new-format classes (11 chars: `_` + 6 group + 4 value) by using length-based
 * extraction rather than a hardcoded offset — old and new format group keys
 * are different lengths so they are structurally disjoint and never alias each other.
 */ const $67c6184bd64e9e07$var$ATOMIC_VALUE_HASH_LENGTH = 4;
function $67c6184bd64e9e07$export$2e2bcd8739ae039(classNames) {
    // Shortcut: nothing to do
    if (!classNames.length) return;
    // Shortcut: don't need to do anything if we only have a single classname
    if (classNames.length === 1 && classNames[0] && // checking to see if `classNames[0]` is a string that contains other classnames
    !classNames[0].includes(' ')) return classNames[0];
    // Using an object rather than a `Map` as it performed better in our benchmarks.
    // Would be happy to move to `Map` if it proved to be better under real conditions.
    const map = {};
    // Note: using loops to minimize iterations over the collection
    for (const value of classNames){
        // Exclude all falsy values, which leaves us with populated strings
        if (!value) continue;
        // a `value` can contain multiple classnames
        const list = value.split(' ');
        for (const className of list){
            /**
             * For atomic style classnames: the `key` is the `group`
             *
             * - Later atomic classnames with the same `group` will override earlier ones
             *   (which is what we want).
             * - Assumes atomic classnames are the only things that start with `_`
             * - Could use a regex to ensure that atomic classnames are structured how we expect,
             *   but did not add that for now as it did slow things down a bit.
             *
             * For other classnames: the `key` is the whole classname
             * - Okay to remove duplicates as doing so does not impact specificity
             *
             * */ const key = className.startsWith('_') ? className.slice(0, className.length - $67c6184bd64e9e07$var$ATOMIC_VALUE_HASH_LENGTH) : className;
            map[key] = className;
        }
    }
    /**
     * We are converting the `map` into a string.
     *
     * The simple way to do this would be `Object.values(map).join(' ')`.
     * However, the approach below performs 10%-20% better in benchmarks.
     *
     * For `ax()` it feels right to squeeze as much runtime performance out as we can.
     */ let result = '';
    for(const key in map)result += map[key] + ' ';
    // If we have an empty string, then our `map` was empty.
    if (!result) return;
    // remove last " " from the result (we added " " at the end of every value)
    return result.trimEnd();
}



var $5FkrB = parcelRequire("5FkrB");
var $80f969ecef0a6dd3$export$1ca2a26fecb070ae = /*#__PURE__*/ (0, $5FkrB.createContext)('elevation.surface');


var $7a49b1df02a75aca$var$_excluded = [
    "as",
    "children",
    "backgroundColor",
    "padding",
    "paddingBlock",
    "paddingBlockStart",
    "paddingBlockEnd",
    "paddingInline",
    "paddingInlineStart",
    "paddingInlineEnd",
    "style",
    "testId",
    "xcss"
], $7a49b1df02a75aca$var$_excluded2 = [
    "className"
];
// Can either Exclude or Extract - here we're excluding all SVG-related elements, <button> elements (handled by Pressable), and <a> elements (handled by Anchor)
// Basically just ElementType but without ComponentType, it makes sense to keep the "Type" suffix
// eslint-disable-next-line @repo/internal/react/consistent-types-definitions
var $7a49b1df02a75aca$var$baseStyles = null;
var $7a49b1df02a75aca$var$backgroundColorMap = {
    'color.background.accent.lime.subtlest': "_bfhkm890",
    'color.background.accent.lime.subtlest.hovered': "_bfhkd4y8",
    'color.background.accent.lime.subtlest.pressed': "_bfhkkuup",
    'color.background.accent.lime.subtler': "_bfhkz2ec",
    'color.background.accent.lime.subtler.hovered': "_bfhk1gf0",
    'color.background.accent.lime.subtler.pressed': "_bfhk2kxc",
    'color.background.accent.lime.subtle': "_bfhkbq5w",
    'color.background.accent.lime.subtle.hovered': "_bfhkfoww",
    'color.background.accent.lime.subtle.pressed': "_bfhk1jbd",
    'color.background.accent.lime.bolder': "_bfhktde4",
    'color.background.accent.lime.bolder.hovered': "_bfhknzpa",
    'color.background.accent.lime.bolder.pressed': "_bfhkh0j0",
    'color.background.accent.red.subtlest': "_bfhk1vk5",
    'color.background.accent.red.subtlest.hovered': "_bfhk1i6i",
    'color.background.accent.red.subtlest.pressed': "_bfhknbir",
    'color.background.accent.red.subtler': "_bfhk1rtt",
    'color.background.accent.red.subtler.hovered': "_bfhkaffd",
    'color.background.accent.red.subtler.pressed': "_bfhk1j5a",
    'color.background.accent.red.subtle': "_bfhkkrt9",
    'color.background.accent.red.subtle.hovered': "_bfhk1sou",
    'color.background.accent.red.subtle.pressed': "_bfhk1fnn",
    'color.background.accent.red.bolder': "_bfhkuibq",
    'color.background.accent.red.bolder.hovered': "_bfhk100f",
    'color.background.accent.red.bolder.pressed': "_bfhk1cl6",
    'color.background.accent.orange.subtlest': "_bfhkf5uh",
    'color.background.accent.orange.subtlest.hovered': "_bfhk19yr",
    'color.background.accent.orange.subtlest.pressed': "_bfhkf90x",
    'color.background.accent.orange.subtler': "_bfhk165s",
    'color.background.accent.orange.subtler.hovered': "_bfhk1ei0",
    'color.background.accent.orange.subtler.pressed': "_bfhkdpo3",
    'color.background.accent.orange.subtle': "_bfhk1kkj",
    'color.background.accent.orange.subtle.hovered': "_bfhk9mfs",
    'color.background.accent.orange.subtle.pressed': "_bfhkaxpp",
    'color.background.accent.orange.bolder': "_bfhk1qg1",
    'color.background.accent.orange.bolder.hovered': "_bfhk12qo",
    'color.background.accent.orange.bolder.pressed': "_bfhk1fyq",
    'color.background.accent.yellow.subtlest': "_bfhkibhp",
    'color.background.accent.yellow.subtlest.hovered': "_bfhkaetg",
    'color.background.accent.yellow.subtlest.pressed': "_bfhk1o1l",
    'color.background.accent.yellow.subtler': "_bfhk1773",
    'color.background.accent.yellow.subtler.hovered': "_bfhk1uw7",
    'color.background.accent.yellow.subtler.pressed': "_bfhk1r9w",
    'color.background.accent.yellow.subtle': "_bfhk8y3s",
    'color.background.accent.yellow.subtle.hovered': "_bfhk819w",
    'color.background.accent.yellow.subtle.pressed': "_bfhk1jx0",
    'color.background.accent.yellow.bolder': "_bfhk1vop",
    'color.background.accent.yellow.bolder.hovered': "_bfhkkjqf",
    'color.background.accent.yellow.bolder.pressed': "_bfhk1okt",
    'color.background.accent.green.subtlest': "_bfhkn729",
    'color.background.accent.green.subtlest.hovered': "_bfhk3utz",
    'color.background.accent.green.subtlest.pressed': "_bfhkyfny",
    'color.background.accent.green.subtler': "_bfhk1wnw",
    'color.background.accent.green.subtler.hovered': "_bfhk1e2h",
    'color.background.accent.green.subtler.pressed': "_bfhkybhx",
    'color.background.accent.green.subtle': "_bfhk1rsu",
    'color.background.accent.green.subtle.hovered': "_bfhk12e3",
    'color.background.accent.green.subtle.pressed': "_bfhk1g86",
    'color.background.accent.green.bolder': "_bfhk1e5c",
    'color.background.accent.green.bolder.hovered': "_bfhka5yi",
    'color.background.accent.green.bolder.pressed': "_bfhk1j68",
    'color.background.accent.teal.subtlest': "_bfhk7xuz",
    'color.background.accent.teal.subtlest.hovered': "_bfhk108c",
    'color.background.accent.teal.subtlest.pressed': "_bfhk1cxp",
    'color.background.accent.teal.subtler': "_bfhk1a17",
    'color.background.accent.teal.subtler.hovered': "_bfhkkwwr",
    'color.background.accent.teal.subtler.pressed': "_bfhk1jb0",
    'color.background.accent.teal.subtle': "_bfhktdv8",
    'color.background.accent.teal.subtle.hovered': "_bfhkzh8h",
    'color.background.accent.teal.subtle.pressed': "_bfhk16zl",
    'color.background.accent.teal.bolder': "_bfhk2c8p",
    'color.background.accent.teal.bolder.hovered': "_bfhkl3ve",
    'color.background.accent.teal.bolder.pressed': "_bfhktor0",
    'color.background.accent.blue.subtlest': "_bfhk1s93",
    'color.background.accent.blue.subtlest.hovered': "_bfhkdaj9",
    'color.background.accent.blue.subtlest.pressed': "_bfhkxm0g",
    'color.background.accent.blue.subtler': "_bfhk1dy8",
    'color.background.accent.blue.subtler.hovered': "_bfhk815t",
    'color.background.accent.blue.subtler.pressed': "_bfhkrwxf",
    'color.background.accent.blue.subtle': "_bfhk115i",
    'color.background.accent.blue.subtle.hovered': "_bfhk9pr4",
    'color.background.accent.blue.subtle.pressed': "_bfhknpx7",
    'color.background.accent.blue.bolder': "_bfhk16e3",
    'color.background.accent.blue.bolder.hovered': "_bfhk1vbm",
    'color.background.accent.blue.bolder.pressed': "_bfhk1xwi",
    'color.background.accent.purple.subtlest': "_bfhkp2ly",
    'color.background.accent.purple.subtlest.hovered': "_bfhkkca2",
    'color.background.accent.purple.subtlest.pressed': "_bfhk1jbm",
    'color.background.accent.purple.subtler': "_bfhk1nm4",
    'color.background.accent.purple.subtler.hovered': "_bfhkattl",
    'color.background.accent.purple.subtler.pressed': "_bfhk3nfk",
    'color.background.accent.purple.subtle': "_bfhk18ah",
    'color.background.accent.purple.subtle.hovered': "_bfhk8bp1",
    'color.background.accent.purple.subtle.pressed': "_bfhk1cd2",
    'color.background.accent.purple.bolder': "_bfhkya33",
    'color.background.accent.purple.bolder.hovered': "_bfhk1af5",
    'color.background.accent.purple.bolder.pressed': "_bfhk6cze",
    'color.background.accent.magenta.subtlest': "_bfhk8tvm",
    'color.background.accent.magenta.subtlest.hovered': "_bfhkr3zd",
    'color.background.accent.magenta.subtlest.pressed': "_bfhk1ckf",
    'color.background.accent.magenta.subtler': "_bfhkv9ra",
    'color.background.accent.magenta.subtler.hovered': "_bfhk1axx",
    'color.background.accent.magenta.subtler.pressed': "_bfhk42ri",
    'color.background.accent.magenta.subtle': "_bfhk1mi6",
    'color.background.accent.magenta.subtle.hovered': "_bfhkrwyz",
    'color.background.accent.magenta.subtle.pressed': "_bfhk6c15",
    'color.background.accent.magenta.bolder': "_bfhkc3uk",
    'color.background.accent.magenta.bolder.hovered': "_bfhk1ok8",
    'color.background.accent.magenta.bolder.pressed': "_bfhkeawv",
    'color.background.accent.gray.subtlest': "_bfhkysee",
    'color.background.accent.gray.subtlest.hovered': "_bfhkwejn",
    'color.background.accent.gray.subtlest.pressed': "_bfhk18ut",
    'color.background.accent.gray.subtler': "_bfhk7qp0",
    'color.background.accent.gray.subtler.hovered': "_bfhk10ef",
    'color.background.accent.gray.subtler.pressed': "_bfhk1rk9",
    'color.background.accent.gray.subtle': "_bfhk18j9",
    'color.background.accent.gray.subtle.hovered': "_bfhk1nv3",
    'color.background.accent.gray.subtle.pressed': "_bfhkq9tj",
    'color.background.accent.gray.bolder': "_bfhk1i45",
    'color.background.accent.gray.bolder.hovered': "_bfhkbyip",
    'color.background.accent.gray.bolder.pressed': "_bfhk1van",
    'color.background.disabled': "_bfhk187o",
    'color.background.input': "_bfhk1j9a",
    'color.background.input.hovered': "_bfhkl4ek",
    'color.background.input.pressed': "_bfhkr01l",
    'color.background.inverse.subtle': "_bfhk1vck",
    'color.background.inverse.subtle.hovered': "_bfhkmpja",
    'color.background.inverse.subtle.pressed': "_bfhk1gii",
    'color.background.neutral': "_bfhki8nm",
    'color.background.neutral.hovered': "_bfhkplhp",
    'color.background.neutral.pressed': "_bfhk1gdz",
    'color.background.neutral.subtle': "_bfhksm61",
    'color.background.neutral.subtle.hovered': "_bfhk1dpa",
    'color.background.neutral.subtle.pressed': "_bfhkfcek",
    'color.background.neutral.bold': "_bfhk1aqn",
    'color.background.neutral.bold.hovered': "_bfhk1ibz",
    'color.background.neutral.bold.pressed': "_bfhkof27",
    'color.background.selected': "_bfhk15s3",
    'color.background.selected.hovered': "_bfhkufnl",
    'color.background.selected.pressed': "_bfhknozp",
    'color.background.selected.bold': "_bfhkjmqp",
    'color.background.selected.bold.hovered': "_bfhk1q28",
    'color.background.selected.bold.pressed': "_bfhk12kk",
    'color.background.brand.subtlest': "_bfhk1gmr",
    'color.background.brand.subtlest.hovered': "_bfhk3v15",
    'color.background.brand.subtlest.pressed': "_bfhku02c",
    'color.background.brand.bold': "_bfhk1856",
    'color.background.brand.bold.hovered': "_bfhkhf2y",
    'color.background.brand.bold.pressed': "_bfhkg6ey",
    'color.background.brand.boldest': "_bfhk1o4i",
    'color.background.brand.boldest.hovered': "_bfhklefx",
    'color.background.brand.boldest.pressed': "_bfhk16k6",
    'color.background.danger': "_bfhk1gly",
    'color.background.danger.hovered': "_bfhk1yvi",
    'color.background.danger.pressed': "_bfhk1r4b",
    'color.background.danger.bold': "_bfhkybec",
    'color.background.danger.bold.hovered': "_bfhks9hg",
    'color.background.danger.bold.pressed': "_bfhk13a9",
    'color.background.warning': "_bfhk1917",
    'color.background.warning.hovered': "_bfhk19zu",
    'color.background.warning.pressed': "_bfhkzr32",
    'color.background.warning.bold': "_bfhk1kmu",
    'color.background.warning.bold.hovered': "_bfhk1spp",
    'color.background.warning.bold.pressed': "_bfhk4m4m",
    'color.background.success': "_bfhk1y9u",
    'color.background.success.hovered': "_bfhk1vfx",
    'color.background.success.pressed': "_bfhk1wl5",
    'color.background.success.bold': "_bfhkkcmj",
    'color.background.success.bold.hovered': "_bfhky7x8",
    'color.background.success.bold.pressed': "_bfhkwcbh",
    'color.background.discovery': "_bfhk6vm6",
    'color.background.discovery.hovered': "_bfhk12eq",
    'color.background.discovery.pressed': "_bfhk18vq",
    'color.background.discovery.bold': "_bfhku5tj",
    'color.background.discovery.bold.hovered': "_bfhkfqeg",
    'color.background.discovery.bold.pressed': "_bfhk1f1m",
    'color.background.information': "_bfhk19ip",
    'color.background.information.hovered': "_bfhk86z5",
    'color.background.information.pressed': "_bfhk1c1j",
    'color.background.information.bold': "_bfhkx4w0",
    'color.background.information.bold.hovered': "_bfhkq2ii",
    'color.background.information.bold.pressed': "_bfhkf89v",
    'color.blanket': "_bfhk1i5c",
    'color.blanket.selected': "_bfhk7wq0",
    'color.blanket.danger': "_bfhkrprw",
    'color.skeleton': "_bfhkizff",
    'color.skeleton.subtle': "_bfhkvkf5",
    'elevation.surface': "_bfhkvuon",
    'elevation.surface.hovered': "_bfhk19i6",
    'elevation.surface.pressed': "_bfhk13ro",
    'elevation.surface.overlay': "_bfhk1bhr",
    'elevation.surface.overlay.hovered': "_bfhk6o2t",
    'elevation.surface.overlay.pressed': "_bfhkm8nx",
    'elevation.surface.raised': "_bfhkhp5a",
    'elevation.surface.raised.hovered': "_bfhk116u",
    'elevation.surface.raised.pressed': "_bfhk14aj",
    'elevation.surface.sunken': "_bfhkhfxm",
    'utility.elevation.surface.current': "_bfhkchd4"
};
var $7a49b1df02a75aca$var$CURRENT_SURFACE_CSS_VAR = "--ds-elevation-surface-current";
var $7a49b1df02a75aca$var$setSurfaceTokenMap = {
    'elevation.surface': "_1q1lvuon",
    'elevation.surface.hovered': "_1q1l19i6",
    'elevation.surface.pressed': "_1q1l13ro",
    'elevation.surface.overlay': "_1q1l1bhr",
    'elevation.surface.overlay.hovered': "_1q1l6o2t",
    'elevation.surface.overlay.pressed': "_1q1lm8nx",
    'elevation.surface.raised': "_1q1lhp5a",
    'elevation.surface.raised.hovered': "_1q1l116u",
    'elevation.surface.raised.pressed': "_1q1l14aj",
    'elevation.surface.sunken': "_1q1lhfxm"
};
var $7a49b1df02a75aca$var$paddingBlockStartMap = {
    'space.0': "_1q51ze3t",
    'space.025': "_1q51v77o",
    'space.050': "_1q511b66",
    'space.075': "_1q5112x7",
    'space.100': "_1q51u2gc",
    'space.150': "_1q51utpp",
    'space.200': "_1q51pxbi",
    'space.250': "_1q51v47k",
    'space.300': "_1q511ejb",
    'space.400': "_1q51xy5q",
    'space.500': "_1q511jfw",
    'space.600': "_1q51oahv",
    'space.800': "_1q51xncg",
    'space.1000': "_1q511epz"
};
var $7a49b1df02a75aca$var$paddingBlockEndMap = {
    'space.0': "_85i5ze3t",
    'space.025': "_85i5v77o",
    'space.050': "_85i51b66",
    'space.075': "_85i512x7",
    'space.100': "_85i5u2gc",
    'space.150': "_85i5utpp",
    'space.200': "_85i5pxbi",
    'space.250': "_85i5v47k",
    'space.300': "_85i51ejb",
    'space.400': "_85i5xy5q",
    'space.500': "_85i51jfw",
    'space.600': "_85i5oahv",
    'space.800': "_85i5xncg",
    'space.1000': "_85i51epz"
};
var $7a49b1df02a75aca$var$paddingInlineStartMap = {
    'space.0': "_bozgze3t",
    'space.025': "_bozgv77o",
    'space.050': "_bozg1b66",
    'space.075': "_bozg12x7",
    'space.100': "_bozgu2gc",
    'space.150': "_bozgutpp",
    'space.200': "_bozgpxbi",
    'space.250': "_bozgv47k",
    'space.300': "_bozg1ejb",
    'space.400': "_bozgxy5q",
    'space.500': "_bozg1jfw",
    'space.600': "_bozgoahv",
    'space.800': "_bozgxncg",
    'space.1000': "_bozg1epz"
};
var $7a49b1df02a75aca$var$paddingInlineEndMap = {
    'space.0': "_y4tize3t",
    'space.025': "_y4tiv77o",
    'space.050': "_y4ti1b66",
    'space.075': "_y4ti12x7",
    'space.100': "_y4tiu2gc",
    'space.150': "_y4tiutpp",
    'space.200': "_y4tipxbi",
    'space.250': "_y4tiv47k",
    'space.300': "_y4ti1ejb",
    'space.400': "_y4tixy5q",
    'space.500': "_y4ti1jfw",
    'space.600': "_y4tioahv",
    'space.800': "_y4tixncg",
    'space.1000': "_y4ti1epz"
};
var $7a49b1df02a75aca$export$e71c4d32a2263218 = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? 'div' : _ref$as, children = _ref.children, backgroundColor = _ref.backgroundColor, padding = _ref.padding, _ref$paddingBlock = _ref.paddingBlock, paddingBlock = _ref$paddingBlock === void 0 ? padding : _ref$paddingBlock, _ref$paddingBlockStar = _ref.paddingBlockStart, paddingBlockStart = _ref$paddingBlockStar === void 0 ? paddingBlock : _ref$paddingBlockStar, _ref$paddingBlockEnd = _ref.paddingBlockEnd, paddingBlockEnd = _ref$paddingBlockEnd === void 0 ? paddingBlock : _ref$paddingBlockEnd, _ref$paddingInline = _ref.paddingInline, paddingInline = _ref$paddingInline === void 0 ? padding : _ref$paddingInline, _ref$paddingInlineSta = _ref.paddingInlineStart, paddingInlineStart = _ref$paddingInlineSta === void 0 ? paddingInline : _ref$paddingInlineSta, _ref$paddingInlineEnd = _ref.paddingInlineEnd, paddingInlineEnd = _ref$paddingInlineEnd === void 0 ? paddingInline : _ref$paddingInlineEnd, style = _ref.style, testId = _ref.testId, xcss = _ref.xcss, htmlAttributes = (0, $a9c67d4ab15fb282$export$2e2bcd8739ae039)(_ref, $7a49b1df02a75aca$var$_excluded);
    // This is to remove className from safeHtmlAttributes
    // @ts-ignore -- not using expect since it causes issues with help-center local consumption - className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    var _spreadClass = htmlAttributes.className, safeHtmlAttributes = (0, $a9c67d4ab15fb282$export$2e2bcd8739ae039)(htmlAttributes, $7a49b1df02a75aca$var$_excluded2);
    var node = /*#__PURE__*/ $5FkrB.createElement(Component, (0, $a98c0fbb1cee895f$export$2e2bcd8739ae039)({
        style: style,
        ref: ref,
        className: (0, $67c6184bd64e9e07$export$2e2bcd8739ae039)([
            "_19itglyw _vchhusvi _r06hglyw",
            backgroundColor && $7a49b1df02a75aca$var$backgroundColorMap[backgroundColor],
            backgroundColor && $7a49b1df02a75aca$var$isSurfaceToken(backgroundColor) && $7a49b1df02a75aca$var$setSurfaceTokenMap[backgroundColor],
            paddingBlockStart && $7a49b1df02a75aca$var$paddingBlockStartMap[paddingBlockStart],
            paddingBlockEnd && $7a49b1df02a75aca$var$paddingBlockEndMap[paddingBlockEnd],
            paddingInlineStart && $7a49b1df02a75aca$var$paddingInlineStartMap[paddingInlineStart],
            paddingInlineEnd && $7a49b1df02a75aca$var$paddingInlineEndMap[paddingInlineEnd],
            xcss
        ])
    }, safeHtmlAttributes, {
        "data-testid": testId
    }), children);
    if (backgroundColor) return /*#__PURE__*/ $5FkrB.createElement((0, $80f969ecef0a6dd3$export$1ca2a26fecb070ae).Provider, {
        value: backgroundColor
    }, node);
    return node;
});
function $7a49b1df02a75aca$var$isSurfaceToken(backgroundColor) {
    return backgroundColor in $7a49b1df02a75aca$var$setSurfaceTokenMap;
}


/* popper-wrapper.tsx generated by @compiled/babel-plugin v2.0.0 */ function $4494f53ee3ee37de$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $4494f53ee3ee37de$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $4494f53ee3ee37de$export$2e2bcd8739ae039(o);
}



function $45bdf8bcd388471c$export$2e2bcd8739ae039(t, r) {
    if ("object" != (0, $4494f53ee3ee37de$export$2e2bcd8739ae039)(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (0, $4494f53ee3ee37de$export$2e2bcd8739ae039)(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}


function $7a62fe6c1b404e60$export$2e2bcd8739ae039(t) {
    var i = (0, $45bdf8bcd388471c$export$2e2bcd8739ae039)(t, "string");
    return "symbol" == (0, $4494f53ee3ee37de$export$2e2bcd8739ae039)(i) ? i : i + "";
}


function $49250faa9cba8c7f$export$2e2bcd8739ae039(e, r, t) {
    return (r = (0, $7a62fe6c1b404e60$export$2e2bcd8739ae039)(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}



function $3d6cdee94a83bb7d$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return (0, $022d83b87ec03a95$export$2e2bcd8739ae039)(r);
}


function $2f3cd89b9aa5c204$export$2e2bcd8739ae039(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}



function $d0bcbbf7e89ebe38$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}


function $6367c63b8ad4bce1$export$2e2bcd8739ae039(r) {
    return (0, $3d6cdee94a83bb7d$export$2e2bcd8739ae039)(r) || (0, $2f3cd89b9aa5c204$export$2e2bcd8739ae039)(r) || (0, $165133c665d57075$export$2e2bcd8739ae039)(r) || (0, $d0bcbbf7e89ebe38$export$2e2bcd8739ae039)();
}



function $7b6033835882f9ff$export$2e2bcd8739ae039() {
    return $7b6033835882f9ff$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $7b6033835882f9ff$export$2e2bcd8739ae039.apply(null, arguments);
}


function $9a391a743fed0f37$export$2e2bcd8739ae039(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}


function $e3e76e60045b1bf0$export$2e2bcd8739ae039(e, t) {
    if (null == e) return {};
    var o, r, i = (0, $9a391a743fed0f37$export$2e2bcd8739ae039)(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}



var $5FkrB = parcelRequire("5FkrB");
/**
 * The length of the value hash portion of an atomic class name.
 * Atomic class names have the format: `_<group><value>`
 * where group is ATOMIC_GROUP_HASH_LENGTH chars and value is ATOMIC_VALUE_HASH_LENGTH chars.
 *
 * We extract the group key using: `className.slice(0, className.length - ATOMIC_VALUE_HASH_LENGTH)`
 *
 * We support both old-format classes (9 chars: `_` + 4 group + 4 value) and
 * new-format classes (11 chars: `_` + 6 group + 4 value) by using length-based
 * extraction rather than a hardcoded offset — old and new format group keys
 * are different lengths so they are structurally disjoint and never alias each other.
 */ const $dbf53395d39974cf$var$ATOMIC_VALUE_HASH_LENGTH = 4;
function $dbf53395d39974cf$export$2e2bcd8739ae039(classNames) {
    // Shortcut: nothing to do
    if (!classNames.length) return;
    // Shortcut: don't need to do anything if we only have a single classname
    if (classNames.length === 1 && classNames[0] && // checking to see if `classNames[0]` is a string that contains other classnames
    !classNames[0].includes(' ')) return classNames[0];
    // Using an object rather than a `Map` as it performed better in our benchmarks.
    // Would be happy to move to `Map` if it proved to be better under real conditions.
    const map = {};
    // Note: using loops to minimize iterations over the collection
    for (const value of classNames){
        // Exclude all falsy values, which leaves us with populated strings
        if (!value) continue;
        // a `value` can contain multiple classnames
        const list = value.split(' ');
        for (const className of list){
            /**
             * For atomic style classnames: the `key` is the `group`
             *
             * - Later atomic classnames with the same `group` will override earlier ones
             *   (which is what we want).
             * - Assumes atomic classnames are the only things that start with `_`
             * - Could use a regex to ensure that atomic classnames are structured how we expect,
             *   but did not add that for now as it did slow things down a bit.
             *
             * For other classnames: the `key` is the whole classname
             * - Okay to remove duplicates as doing so does not impact specificity
             *
             * */ const key = className.startsWith('_') ? className.slice(0, className.length - $dbf53395d39974cf$var$ATOMIC_VALUE_HASH_LENGTH) : className;
            map[key] = className;
        }
    }
    /**
     * We are converting the `map` into a string.
     *
     * The simple way to do this would be `Object.values(map).join(' ')`.
     * However, the approach below performs 10%-20% better in benchmarks.
     *
     * For `ax()` it feels right to squeeze as much runtime performance out as we can.
     */ let result = '';
    for(const key in map)result += map[key] + ' ';
    // If we have an empty string, then our `map` was empty.
    if (!result) return;
    // remove last " " from the result (we added " " at the end of every value)
    return result.trimEnd();
}



var $5FkrB = parcelRequire("5FkrB");



function $7df5ec948c08a88e$export$c8b4d54e03dee6ed() {
    var currentLevel = (0, $5FkrB.useContext)((0, $5c1aee337f1ba1a6$export$650d12d3c2ddb8fc));
    var layerNode = (0, $5FkrB.useContext)((0, $a405ba4faea0638e$export$18f4d8b5b3a77f59));
    var rootNode = (0, $5FkrB.useContext)((0, $5439c23b8fed5083$export$fa973f110e8f6ca8));
    var isLayerDisabled = (0, $5FkrB.useCallback)(function() {
        // This is an impossible case, added for type safety
        if (!(layerNode !== null && layerNode !== void 0 && layerNode.current) || !(rootNode !== null && rootNode !== void 0 && rootNode.current)) return false;
        return layerNode.current.getLevel() < rootNode.current.getHeight();
    }, [
        layerNode,
        rootNode
    ]);
    var getTopLevel = (0, $5FkrB.useCallback)(function() {
        return rootNode !== null && rootNode !== void 0 && rootNode.current ? rootNode.current.getHeight() : null;
    }, [
        rootNode
    ]);
    return {
        currentLevel: currentLevel,
        isLayerDisabled: isLayerDisabled,
        getTopLevel: getTopLevel
    };
}


/* motion.tsx generated by @compiled/babel-plugin v2.0.0 */ function $84cfe10cd5b5b621$export$2e2bcd8739ae039() {
    return $84cfe10cd5b5b621$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $84cfe10cd5b5b621$export$2e2bcd8739ae039.apply(null, arguments);
}


function $4d6009ce5d8df48b$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $4d6009ce5d8df48b$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $4d6009ce5d8df48b$export$2e2bcd8739ae039(o);
}



function $e411c57dfc339153$export$2e2bcd8739ae039(t, r) {
    if ("object" != (0, $4d6009ce5d8df48b$export$2e2bcd8739ae039)(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (0, $4d6009ce5d8df48b$export$2e2bcd8739ae039)(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}


function $35e1f8bae6592a29$export$2e2bcd8739ae039(t) {
    var i = (0, $e411c57dfc339153$export$2e2bcd8739ae039)(t, "string");
    return "symbol" == (0, $4d6009ce5d8df48b$export$2e2bcd8739ae039)(i) ? i : i + "";
}


function $196a2b97ce920dad$export$2e2bcd8739ae039(e, r, t) {
    return (r = (0, $35e1f8bae6592a29$export$2e2bcd8739ae039)(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}



/**
 * The length of the value hash portion of an atomic class name.
 * Atomic class names have the format: `_<group><value>`
 * where group is ATOMIC_GROUP_HASH_LENGTH chars and value is ATOMIC_VALUE_HASH_LENGTH chars.
 *
 * We extract the group key using: `className.slice(0, className.length - ATOMIC_VALUE_HASH_LENGTH)`
 *
 * We support both old-format classes (9 chars: `_` + 4 group + 4 value) and
 * new-format classes (11 chars: `_` + 6 group + 4 value) by using length-based
 * extraction rather than a hardcoded offset — old and new format group keys
 * are different lengths so they are structurally disjoint and never alias each other.
 */ const $18568cedb3bf28ca$var$ATOMIC_VALUE_HASH_LENGTH = 4;
function $18568cedb3bf28ca$export$2e2bcd8739ae039(classNames) {
    // Shortcut: nothing to do
    if (!classNames.length) return;
    // Shortcut: don't need to do anything if we only have a single classname
    if (classNames.length === 1 && classNames[0] && // checking to see if `classNames[0]` is a string that contains other classnames
    !classNames[0].includes(' ')) return classNames[0];
    // Using an object rather than a `Map` as it performed better in our benchmarks.
    // Would be happy to move to `Map` if it proved to be better under real conditions.
    const map = {};
    // Note: using loops to minimize iterations over the collection
    for (const value of classNames){
        // Exclude all falsy values, which leaves us with populated strings
        if (!value) continue;
        // a `value` can contain multiple classnames
        const list = value.split(' ');
        for (const className of list){
            /**
             * For atomic style classnames: the `key` is the `group`
             *
             * - Later atomic classnames with the same `group` will override earlier ones
             *   (which is what we want).
             * - Assumes atomic classnames are the only things that start with `_`
             * - Could use a regex to ensure that atomic classnames are structured how we expect,
             *   but did not add that for now as it did slow things down a bit.
             *
             * For other classnames: the `key` is the whole classname
             * - Okay to remove duplicates as doing so does not impact specificity
             *
             * */ const key = className.startsWith('_') ? className.slice(0, className.length - $18568cedb3bf28ca$var$ATOMIC_VALUE_HASH_LENGTH) : className;
            map[key] = className;
        }
    }
    /**
     * We are converting the `map` into a string.
     *
     * The simple way to do this would be `Object.values(map).join(' ')`.
     * However, the approach below performs 10%-20% better in benchmarks.
     *
     * For `ax()` it feels right to squeeze as much runtime performance out as we can.
     */ let result = '';
    for(const key in map)result += map[key] + ' ';
    // If we have an empty string, then our `map` was empty.
    if (!result) return;
    // remove last " " from the result (we added " " at the end of every value)
    return result.trimEnd();
}



var $5FkrB = parcelRequire("5FkrB");
/* index.tsx generated by @compiled/babel-plugin v2.0.0 */ parcelRequire("5FkrB");

const $d49aa0ab1efae6e3$export$6c9a87045746941d = ()=>{
    return new Error(`
 \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2557}   \u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2557}     \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}
\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}
\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}   \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}  \u{2588}\u{2588}\u{2551}  \u{2588}\u{2588}\u{2551}
\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}   \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}\u{255A}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{255D} \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{255D}  \u{2588}\u{2588}\u{2551}  \u{2588}\u{2588}\u{2551}
\u{255A}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{255A}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551} \u{255A}\u{2550}\u{255D} \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}
 \u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D} \u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D} \u{255A}\u{2550}\u{255D}     \u{255A}\u{2550}\u{255D}\u{255A}\u{2550}\u{255D}     \u{255A}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}

  @compiled/react

  Code was executed when it shouldn't have. This could have happened because:

  1. You haven't configured a transformer yet. Visit https://compiledcssinjs.com/docs/installation and follow the instructions.
  2. You have duplicate versions of React and hooks are blowing up. You need to de-duplicate your dependencies.

  Good luck!
`);
};
const $d49aa0ab1efae6e3$export$c4df1cb0c2b4d77c = ()=>{
    return new Error(`
 \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2557}   \u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2557}     \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}
\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}
\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}   \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}  \u{2588}\u{2588}\u{2551}  \u{2588}\u{2588}\u{2551}
\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}   \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}\u{255A}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{255D} \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{255D}  \u{2588}\u{2588}\u{2551}  \u{2588}\u{2588}\u{2551}
\u{255A}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{255A}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551} \u{255A}\u{2550}\u{255D} \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}
 \u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D} \u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D} \u{255A}\u{2550}\u{255D}     \u{255A}\u{2550}\u{255D}\u{255A}\u{2550}\u{255D}     \u{255A}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}

  @compiled/react

  Code was executed when it shouldn't have. To resolve make sure to:

  1. Set up Compiled.
  2. Configure importSources in your Compiled config to point to the module that exports the output of createStrictAPI().

  For more information visit https://compiledcssinjs.com/docs/installation and follow the instructions.
`);
};


/**
 * The length of the value hash portion of an atomic class name.
 * Atomic class names have the format: `_<group><value>`
 * where group is ATOMIC_GROUP_HASH_LENGTH chars and value is ATOMIC_VALUE_HASH_LENGTH chars.
 *
 * We extract the group key using: `className.slice(0, className.length - ATOMIC_VALUE_HASH_LENGTH)`
 *
 * We support both old-format classes (9 chars: `_` + 4 group + 4 value) and
 * new-format classes (11 chars: `_` + 6 group + 4 value) by using length-based
 * extraction rather than a hardcoded offset — old and new format group keys
 * are different lengths so they are structurally disjoint and never alias each other.
 */ const $f3cea5fc99b17803$var$ATOMIC_VALUE_HASH_LENGTH = 4;
function $f3cea5fc99b17803$export$2e2bcd8739ae039(classNames) {
    // Shortcut: nothing to do
    if (!classNames.length) return;
    // Shortcut: don't need to do anything if we only have a single classname
    if (classNames.length === 1 && classNames[0] && // checking to see if `classNames[0]` is a string that contains other classnames
    !classNames[0].includes(' ')) return classNames[0];
    // Using an object rather than a `Map` as it performed better in our benchmarks.
    // Would be happy to move to `Map` if it proved to be better under real conditions.
    const map = {};
    // Note: using loops to minimize iterations over the collection
    for (const value of classNames){
        // Exclude all falsy values, which leaves us with populated strings
        if (!value) continue;
        // a `value` can contain multiple classnames
        const list = value.split(' ');
        for (const className of list){
            /**
             * For atomic style classnames: the `key` is the `group`
             *
             * - Later atomic classnames with the same `group` will override earlier ones
             *   (which is what we want).
             * - Assumes atomic classnames are the only things that start with `_`
             * - Could use a regex to ensure that atomic classnames are structured how we expect,
             *   but did not add that for now as it did slow things down a bit.
             *
             * For other classnames: the `key` is the whole classname
             * - Okay to remove duplicates as doing so does not impact specificity
             *
             * */ const key = className.startsWith('_') ? className.slice(0, className.length - $f3cea5fc99b17803$var$ATOMIC_VALUE_HASH_LENGTH) : className;
            map[key] = className;
        }
    }
    /**
     * We are converting the `map` into a string.
     *
     * The simple way to do this would be `Object.values(map).join(' ')`.
     * However, the approach below performs 10%-20% better in benchmarks.
     *
     * For `ax()` it feels right to squeeze as much runtime performance out as we can.
     */ let result = '';
    for(const key in map)result += map[key] + ' ';
    // If we have an empty string, then our `map` was empty.
    if (!result) return;
    // remove last " " from the result (we added " " at the end of every value)
    return result.trimEnd();
}


const $9462201cf408aa8a$export$a274e22fb40f762e = (...styles)=>{
    // At runtime TStyles is resolved down to strings, but not at compile time.
    // We circumvent the type system here because of that.
    const actualStyles = styles;
    // The output should be a union type of passed in styles. This ensures the call
    // site of xcss prop can raise violations when disallowed styles have been passed.
    return (0, $f3cea5fc99b17803$export$2e2bcd8739ae039)(actualStyles);
};


function $fbb07374ea60985f$export$39716b4af53f4ad() {
    return {
        css () {
            throw (0, $d49aa0ab1efae6e3$export$c4df1cb0c2b4d77c)();
        },
        cssMap () {
            throw (0, $d49aa0ab1efae6e3$export$c4df1cb0c2b4d77c)();
        },
        cx: $9462201cf408aa8a$export$a274e22fb40f762e,
        XCSSProp () {
            throw (0, $d49aa0ab1efae6e3$export$c4df1cb0c2b4d77c)();
        }
    };
}


var $d01a5d8bb96c5a7e$var$strictApi = (0, $fbb07374ea60985f$export$39716b4af53f4ad)();
var $d01a5d8bb96c5a7e$export$dbf350e5966cf602 = $d01a5d8bb96c5a7e$var$strictApi.css;
var $d01a5d8bb96c5a7e$export$eb1ecd84a24ee424 = $d01a5d8bb96c5a7e$var$strictApi.cssMap;
$d01a5d8bb96c5a7e$var$strictApi.cssMap;
var $d01a5d8bb96c5a7e$export$a274e22fb40f762e = $d01a5d8bb96c5a7e$var$strictApi.cx;
var $d01a5d8bb96c5a7e$var$XCSSProp = $d01a5d8bb96c5a7e$var$strictApi.XCSSProp; // This is to mitigate local TS error TS2315: Type 'StrictXCSSProp' is not generic.
 // Currently for some reason tsc is generating malformed .d.ts in local dev environment, below change fixes it
 /**
 * ## StrictXCSSProp
 *
 * Declare styles your component takes with all other styles marked as violations
 * by the TypeScript compiler. There are two primary use cases for xcss prop:
 *
 * - safe style overrides
 * - inverting style declarations
 *
 * Interverting style declarations is interesting for platform teams as
 * it means apps only pay for styles they use as they're now the ones who declare
 * the styles!
 *
 * The {@link StrictXCSSProp} type has generics two of which must be defined — use to explicitly
 * set what you want to maintain as API. Use {@link XCSSAllProperties} and {@link XCSSAllPseudos}
 * to enable all properties and pseudos.
 *
 * The third generic is used to declare what properties and pseudos should be required.
 *
 * ```tsx
 * interface MyComponentProps {
 *   // Color is accepted, all other properties / pseudos are considered violations.
 *   xcss?: StrictXCSSProp<'color', never>;
 *
 *   // Only background color and hover pseudo are accepted.
 *   xcss?: StrictXCSSProp<'backgroundColor', '&:hover'>;
 *
 *   // All properties are accepted, all pseudos are considered violations.
 *   xcss?: StrictXCSSProp<XCSSAllProperties, never>;
 *
 *   // All properties are accepted, only the hover pseudo is accepted.
 *   xcss?: StrictXCSSProp<XCSSAllProperties, '&:hover'>;
 *
 *   // The xcss prop is required as well as the color property. No pseudos are required.
 *   xcss: StrictXCSSProp<
 *     XCSSAllProperties,
 *     '&:hover',
 *     { requiredProperties: 'color', requiredPseudos: never }
 *   >;
 * }
 *
 * function MyComponent({ xcss }: MyComponentProps) {
 *   return <div css={{ color: 'var(--ds-text-danger)' }} className={xcss} />
 * }
 * ```
 *
 * The xcss prop works with static inline objects and the [cssMap](https://compiledcssinjs.com/docs/api-cssmap) API.
 *
 * ```jsx
 * // Declared as an inline object
 * <Component xcss={{ color: 'var(--ds-text)' }} />
 *
 * // Declared with the cssMap API
 * const styles = cssMap({ text: { color: 'var(--ds-text)' } });
 * <Component xcss={styles.text} />
 * ```
 *
 * To concatenate and conditonally apply styles use the {@link cssMap} and {@link cx} functions.
 */ 




var $50U6m = parcelRequire("50U6m");
var $72511f37856b2e4d$export$75eee42ff540d8ae = function convertToMs(duration) {
    // Use regex to separate the number and the unit
    var matches = duration.match(/^(-?(?:\d+\.?\d*|\.\d+))(s|ms)$/);
    if (!matches) return 0; // Or return for invalid format
    var value = parseFloat(matches[1]);
    var unit = matches[2];
    if (unit === 's') return value * 1000; // Convert seconds to milliseconds
    else return value; // Already in milliseconds
};


var $b33b23c7974e5feb$var$cssTimePattern = /^-?(?:\d+\.?\d*|\.\d+)(?:ms|s)$/;
var $b33b23c7974e5feb$var$toCssList = function toCssList(value) {
    return value.split(',').map(function(item) {
        return item.trim();
    }).filter(Boolean);
};
var $b33b23c7974e5feb$var$toTimeList = function toTimeList(value) {
    return $b33b23c7974e5feb$var$toCssList(value).filter(function(time) {
        return $b33b23c7974e5feb$var$cssTimePattern.test(time);
    }).map((0, $72511f37856b2e4d$export$75eee42ff540d8ae));
};
var $b33b23c7974e5feb$export$dd9b73a7482d05b6 = function getComputedAnimationDurationMs(animationName, animationDuration, animationDelay) {
    var names = $b33b23c7974e5feb$var$toCssList(animationName);
    var durations = $b33b23c7974e5feb$var$toTimeList(animationDuration);
    var delays = $b33b23c7974e5feb$var$toTimeList(animationDelay);
    if (names.length === 0 || durations.length === 0) return 0;
    var longestDuration = 0;
    for(var index = 0; index < names.length; index++){
        if (names[index] === 'none') continue;
        var duration = durations[index % durations.length];
        var delay = delays.length > 0 ? delays[index % delays.length] : 0;
        longestDuration = Math.max(longestDuration, duration + delay);
    }
    return longestDuration;
};



function $bb45ce6dc6a4e224$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return (0, $fa3e74e83bf9741d$export$2e2bcd8739ae039)(r);
}


function $97bcbc825b16ccac$export$2e2bcd8739ae039(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}



function $3fff9f0ff34f2663$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}


function $4d371c11475d0666$export$2e2bcd8739ae039(r) {
    return (0, $bb45ce6dc6a4e224$export$2e2bcd8739ae039)(r) || (0, $97bcbc825b16ccac$export$2e2bcd8739ae039)(r) || (0, $1317f5a0cc762277$export$2e2bcd8739ae039)(r) || (0, $3fff9f0ff34f2663$export$2e2bcd8739ae039)();
}


var $9d1cc891aed71571$export$d0038b6e47881463 = function getDurationMs(animation) {
    var animations = animation.split(/,(?![^()]*\))/).map(function(value) {
        return (0, $4d371c11475d0666$export$2e2bcd8739ae039)(value.trim().matchAll(/(-?\d*\.?\d+)(ms|s)\b/g));
    }).filter(function(matches) {
        return matches.length > 0;
    });
    if (animations.length === 0) return {
        duration: 0,
        delay: 0
    };
    return animations.reduce(function(longest, matches) {
        var toMilliseconds = function toMilliseconds(match) {
            var value = parseFloat(match[1]);
            return match[2] === 's' ? value * 1000 : value;
        };
        var timing = {
            duration: toMilliseconds(matches[0]),
            delay: matches[1] ? toMilliseconds(matches[1]) : 0
        };
        return timing.duration + timing.delay > longest.duration + longest.delay ? timing : longest;
    }, {
        duration: 0,
        delay: 0
    });
};




var $b3a796e781d06578$export$82b92541889a035d = function resolveMotionToken(token) {
    var cssVarMatch = token.match(/var\(\s*(--[^,\s)]+)/);
    var cssVar = cssVarMatch ? cssVarMatch[1] : null;
    if (cssVar) {
        var _getDocument;
        var documentElement = (_getDocument = (0, $fc5ac9c99de29fbb$export$f65ca476c09acec0)()) === null || _getDocument === void 0 ? void 0 : _getDocument.documentElement;
        if (documentElement) return getComputedStyle(documentElement).getPropertyValue(cssVar);
    }
    return '';
};


/**
 * Supported reanimate values.
 * 'enter' will re-enter the animation.
 * 'exit-then-enter' will exit the animation and then enter it again.
 */ var $4e0f5b60b27753be$export$569340a66b14e0dc = /*#__PURE__*/ function(Reanimate) {
    Reanimate["enter"] = "enter";
    Reanimate["exit_then_enter"] = "exit_then_enter";
    Reanimate["exit"] = "exit";
    return Reanimate;
}({});



var $5FkrB = parcelRequire("5FkrB");

var $7859f3cad9bf15af$export$3b6f38abbdcbd000 = function useExitingPersistence() {
    return (0, $5FkrB.useContext)((0, $7dce5bdaf433551a$export$b9c4904d7a6929e6));
};




var $5FkrB = parcelRequire("5FkrB");








var $5FkrB = parcelRequire("5FkrB");
/* eslint-disable @repo/internal/react/disallow-unstable-values */ 
var $5FkrB = parcelRequire("5FkrB");
function $0a47d42961a6a5a3$export$c485849f2e393253() {
    var identifier = (0, $5FkrB.useRef)('');
    if (!identifier.current) identifier.current = '_' + (Number(String(Math.random()).slice(2)) + Date.now() + Math.round(performance.now())).toString(36);
    return identifier.current;
}




var $5FkrB = parcelRequire("5FkrB");


var $5FkrB = parcelRequire("5FkrB");
var $3451ac6466de4e7e$export$e5c5a5f917a5871c = typeof window === 'undefined' ? (0, $5FkrB.useEffect) : (0, $5FkrB.useLayoutEffect);


var $ad83d708a15a323e$export$5e65d7d58ae96ad8 = /*#__PURE__*/ (0, $5FkrB.createContext)(function() {
    return {
        isReady: true,
        delay: 0,
        ref: (0, $adcefb868cf2fc9d$export$2e2bcd8739ae039)
    };
});
/**
 * For a list of elements that need to animate in,
 * this should be used in conjunction with entering components.
 * This does not need Javascript to execute so it will run immediately for any SSR rendered React apps before the JS has executed.
 *
 * Will dynamically add delay to each child entering component.
 * Unfortunately all entering components _NEED_ to be a direct descendant.
 */ var $ad83d708a15a323e$var$StaggeredEntrance = function StaggeredEntrance(_ref) {
    var children = _ref.children, column = _ref.column, _ref$columns = _ref.columns, columns = _ref$columns === void 0 ? 'responsive' : _ref$columns, _ref$delayStep = _ref.delayStep, delayStep = _ref$delayStep === void 0 ? 50 : _ref$delayStep;
    var elementRefs = (0, $5FkrB.useRef)([]);
    var indexes = [];
    var _useState = (0, $5FkrB.useState)(function() {
        if (typeof columns === 'number') // A hardcoded columns is set so bail out and set it to that!
        return columns;
        if (typeof column === 'number') // A hardcoded column is set so we will set actualColumns to be 1.
        return 1;
        // We are in "responsive" mode.
        // So we will be calculating when the Javascript executes on the client how many columns there will be.
        return 0;
    }), _useState2 = (0, $b0c829b9b1926339$export$2e2bcd8739ae039)(_useState, 2), actualColumns = _useState2[0], setActualColumns = _useState2[1];
    (0, $3451ac6466de4e7e$export$e5c5a5f917a5871c)(function() {
        // We want to only run this code when we are in "responsive" mode.
        // It is assumed we are in responsive mode if `columns` is "responsive",
        // we have children element refs ready to be read (i.e. if there are no children this won't run as well)
        // and finally that `actualColumns` is `0` - this is because for the first render cycle `actualColumns` will be `0` (set above)
        // and then after this layout effect runs the value for `actualColumns` will then be calculated and set.
        if (columns === 'responsive' && elementRefs.current.length && actualColumns === 0) {
            var currentTop = 0;
            var numberColumns = 0;
            if (elementRefs.current.length <= 1) {
                setActualColumns(1);
                return;
            }
            // We set the current top to the first elements.
            // We will be comparing this and incrementing the column count
            // until we hit an element that has a different offset top (or we run out of elements).
            currentTop = elementRefs.current[0] ? elementRefs.current[0].offsetTop : 0;
            for(var i = 0; i < elementRefs.current.length; i++){
                var child = elementRefs.current[i];
                if (!child) break;
                if (currentTop === child.offsetTop) {
                    numberColumns += 1;
                    if (elementRefs.current.length - 1 === i) setActualColumns(numberColumns);
                    continue;
                }
                setActualColumns(numberColumns);
                break;
            }
        }
    // We only want this effect to run once - on initial mount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement($ad83d708a15a323e$export$5e65d7d58ae96ad8.Provider, {
        value: function value(id) {
            if (!indexes.includes(id)) indexes.push(id);
            var isReady = actualColumns > 0;
            var index = indexes.indexOf(id);
            var currentColumn = column || index % actualColumns;
            var currentRow = Math.floor(index / actualColumns);
            var distanceFromTopLeftElement = currentRow + currentColumn;
            // We don't want loads of elements to have the same staggered delay as it ends up looking slow for users.
            // To get around that we calculate the logarithm using `distanceFromTopLeftElement` which ends making
            // elements appear faster the further away from the top left element.
            var delay = Math.ceil(Math.log(distanceFromTopLeftElement + 1) * delayStep * 1.5) || 0;
            return {
                delay: delay,
                isReady: isReady,
                ref: function ref(element) {
                    return elementRefs.current[index] = element;
                }
            };
        }
    }, children);
};
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$ad83d708a15a323e$export$2e2bcd8739ae039 = $ad83d708a15a323e$var$StaggeredEntrance;


var $fc97ddeced05433d$export$25c7213fc07ec080 = function useStaggeredEntrance() {
    var identifier = (0, $0a47d42961a6a5a3$export$c485849f2e393253)();
    var context = (0, $5FkrB.useContext)((0, $ad83d708a15a323e$export$5e65d7d58ae96ad8));
    return context(identifier);
};


function $dd343dd5c3c6ec8a$export$2a51cfe9390d36ef() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, onFinishMotion = _ref.onFinish, initialState = _ref.initialState;
    var reducedMotion = (0, $c13dcba1845ee9f2$export$b7baf7667a68d87c)();
    var staggered = (0, $fc97ddeced05433d$export$25c7213fc07ec080)();
    var _useExitingPersistenc = (0, $7859f3cad9bf15af$export$3b6f38abbdcbd000)(), isExiting = _useExitingPersistenc.isExiting, onExitFinished = _useExitingPersistenc.onFinish, appear = _useExitingPersistenc.appear;
    var staggeredDelay = isExiting ? 0 : staggered.delay;
    var staggeredIsReady = staggered.isReady;
    var _useState = (0, $5FkrB.useState)(initialState !== null && initialState !== void 0 ? initialState : appear ? staggeredIsReady && !staggeredDelay ? 'entering' : 'init' : 'visible'), _useState2 = (0, $b0c829b9b1926339$export$2e2bcd8739ae039)(_useState, 2), state = _useState2[0], setState = _useState2[1];
    var elementRef = (0, $5FkrB.useRef)(null);
    var reanimateRef = (0, $5FkrB.useRef)();
    var animationRef = (0, $5FkrB.useRef)();
    var staggeredEntryRef = (0, $5FkrB.useRef)();
    (0, $5FkrB.useEffect)(function() {
        if (isExiting) setState('exiting');
    }, [
        isExiting
    ]);
    /**
   * Updates relevant state.
   * Called when the animation is finished, or immediately with reduced motion.
   */ var onAnimationEnd = (0, $5FkrB.useCallback)(function(currentState, cancelled) {
        // We are done animating, so we set the state to visible
        var newState = 'visible';
        if (currentState === 'exiting') {
            if (!reanimateRef.current) // Updates the `ExitingPersistence` to remove this child
            onExitFinished === null || onExitFinished === void 0 || onExitFinished();
            onFinishMotion === null || onFinishMotion === void 0 || onFinishMotion('exiting');
        }
        if (currentState === 'entering') onFinishMotion === null || onFinishMotion === void 0 || onFinishMotion('entering');
        if (reanimateRef.current === (0, $4e0f5b60b27753be$export$569340a66b14e0dc).exit_then_enter) {
            // We are done exiting, so we set the state to entering
            reanimateRef.current = (0, $4e0f5b60b27753be$export$569340a66b14e0dc).enter;
            newState = 'entering';
        } else if (reanimateRef.current === (0, $4e0f5b60b27753be$export$569340a66b14e0dc).enter) // We are done reanimating, so we clear the reanimate state
        reanimateRef.current = undefined;
        else if (reanimateRef.current === (0, $4e0f5b60b27753be$export$569340a66b14e0dc).exit) {
            // We are done reanimating, so we clear the reanimate state
            reanimateRef.current = undefined;
            newState = 'hidden';
        }
        if (!cancelled) setState(newState);
    // We ignore this for onFinishMotion as consumers could potentially inline the function
    // which would then trigger this effect every re-render.
    // We want to make it easier for consumers so we go down this path unfortunately.
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        onExitFinished
    ]);
    // Handles staggered entry
    (0, $5FkrB.useEffect)(function() {
        if (state !== 'init') return;
        if (reducedMotion) {
            onAnimationEnd('entering', false);
            return;
        }
        // We delay the entry animation by the stagger delay
        staggeredEntryRef.current = setTimeout(function() {
            setState('entering');
        }, staggeredDelay);
        return function() {
            if (staggeredEntryRef.current) clearTimeout(staggeredEntryRef.current);
        };
    }, [
        onAnimationEnd,
        state,
        staggeredIsReady,
        staggeredDelay,
        reducedMotion
    ]);
    (0, $5FkrB.useEffect)(function() {
        // Tracking this to prevent changing state on an unmounted component
        var isCancelled = false;
        if (!staggeredIsReady) return;
        // On initial mount if elements aren't set to animate on appear, we return early and callback
        // This only occurs on initial mount, as appear will be true once the component is mounted
        if (!appear) {
            onFinishMotion && onFinishMotion('entering');
            return;
        }
        // If the state is visible, hidden or init, we don't need to do anything
        if (state === 'visible' || state === 'init' || state === 'hidden') return;
        // If there is reduced motion or no exit animation, we call the onAnimationEnd function immediately
        if (reducedMotion) {
            onAnimationEnd(state, isCancelled);
            return;
        }
        var animationDuration = 0;
        if (state === 'entering' || state === 'exiting') {
            if (elementRef.current) {
                if (elementRef.current.style.animation) {
                    // Motion token
                    var animationTimings = (0, $9d1cc891aed71571$export$d0038b6e47881463)((0, $b3a796e781d06578$export$82b92541889a035d)(elementRef.current.style.animation));
                    animationDuration = animationTimings.duration;
                    animationDuration += animationTimings.delay;
                } else {
                    // Custom motion
                    var computedStyles = window.getComputedStyle(elementRef.current);
                    animationDuration = (0, $b33b23c7974e5feb$export$dd9b73a7482d05b6)(computedStyles.animationName, computedStyles.animationDuration, computedStyles.animationDelay);
                }
            }
        }
        // Queue `onAnimationEnd` for after the animation has finished
        if (state === 'exiting') animationRef.current = setTimeout(function() {
            return onAnimationEnd(state, isCancelled);
        }, animationDuration);
        else if (state === 'entering') animationRef.current = setTimeout(function() {
            return onAnimationEnd(state, isCancelled);
        }, animationDuration);
        return function() {
            isCancelled = true;
            if (animationRef.current) clearTimeout(animationRef.current);
        };
    // We ignore this for onFinishMotion as consumers could potentially inline the function
    // which would then trigger this effect every re-render.
    // We want to make it easier for consumers so we go down this path unfortunately.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        onAnimationEnd,
        state,
        appear,
        staggeredDelay,
        staggeredIsReady,
        reducedMotion
    ]);
    var reanimate = (0, $5FkrB.useCallback)(function(value) {
        animationRef.current && clearTimeout(animationRef.current);
        reanimateRef.current = value;
        if (value === (0, $4e0f5b60b27753be$export$569340a66b14e0dc).exit_then_enter) setState('exiting');
        else if (value === (0, $4e0f5b60b27753be$export$569340a66b14e0dc).enter) setState('entering');
        else if (value === (0, $4e0f5b60b27753be$export$569340a66b14e0dc).exit) setState('exiting');
    }, []);
    var ref = (0, $db13a2f91f6a0f56$export$2e2bcd8739ae039)([
        staggered.ref,
        elementRef
    ]);
    return {
        ref: ref,
        reanimate: reanimate,
        state: state
    };
}



function $d48c6d5755d883e0$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $d48c6d5755d883e0$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $d48c6d5755d883e0$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $196a2b97ce920dad$export$2e2bcd8739ae039)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $d48c6d5755d883e0$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $d48c6d5755d883e0$var$styles = {
    base: "_1y0co91m _1bumglyw _sedtglyw",
    hidden: "_3um015vq"
};
/**
 * Legacy implementation of `Motion` that inlines the animation lifecycle.
 * Used when the `platform-dst-use-motion` feature gate is off.
 */ var $d48c6d5755d883e0$var$MotionLegacy = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function(_ref, ref) {
    var children = _ref.children, enteringAnimation = _ref.enteringAnimation, enteringAnimationXcss = _ref.enteringAnimationXcss, exitingAnimation = _ref.exitingAnimation, exitingAnimationXcss = _ref.exitingAnimationXcss, onFinishMotion = _ref.onFinish, xcss = _ref.xcss, styleProp = _ref.style, testId = _ref.testId;
    var staggered = (0, $fc97ddeced05433d$export$25c7213fc07ec080)();
    var _useExitingPersistenc = (0, $7859f3cad9bf15af$export$3b6f38abbdcbd000)(), isExiting = _useExitingPersistenc.isExiting, onExitFinished = _useExitingPersistenc.onFinish, appear = _useExitingPersistenc.appear;
    var staggeredDelay = isExiting ? 0 : staggered.delay;
    var staggedIsReady = staggered.isReady;
    var _useState = (0, $5FkrB.useState)(appear ? staggedIsReady && !staggeredDelay ? 'entering' : 'init' : 'idle'), _useState2 = (0, $b0c829b9b1926339$export$2e2bcd8739ae039)(_useState, 2), state = _useState2[0], setState = _useState2[1];
    var elementRef = (0, $5FkrB.useRef)(null);
    var reanimateRef = (0, $5FkrB.useRef)();
    var animationRef = (0, $5FkrB.useRef)();
    var staggeredEntryRef = (0, $5FkrB.useRef)();
    (0, $5FkrB.useEffect)(function() {
        if (isExiting) setState('exiting');
    }, [
        isExiting
    ]);
    // Handles staggered entry
    (0, $5FkrB.useEffect)(function() {
        if (state !== 'init') return;
        // We delay the entry animation by the stagger delay
        staggeredEntryRef.current = setTimeout(function() {
            setState('entering');
        }, staggeredDelay);
        return function() {
            if (staggeredEntryRef.current) clearTimeout(staggeredEntryRef.current);
        };
    }, [
        state,
        staggedIsReady,
        staggeredDelay
    ]);
    /**
   * Updates relevant state.
   * Called when the animation is finished, or immediately with reduced motion.
   */ var onAnimationEnd = (0, $5FkrB.useCallback)(function(state, cancelled) {
        // We are done animating, so we set the state to idle
        var newState = 'idle';
        if (state === 'exiting') {
            if (!reanimateRef.current) // Updates the `ExitingPersistence` to remove this child
            onExitFinished === null || onExitFinished === void 0 || onExitFinished();
            onFinishMotion === null || onFinishMotion === void 0 || onFinishMotion('exiting');
        }
        if (state === 'entering') onFinishMotion === null || onFinishMotion === void 0 || onFinishMotion('entering');
        if (reanimateRef.current === (0, $4e0f5b60b27753be$export$569340a66b14e0dc).exit_then_enter) {
            // We are done exiting, so we set the state to entering
            reanimateRef.current = (0, $4e0f5b60b27753be$export$569340a66b14e0dc).enter;
            newState = 'entering';
        } else if (reanimateRef.current) // We are done reanimating, so we clear the reanimate state
        reanimateRef.current = undefined;
        if (!cancelled) setState(newState);
    // We ignore this for onFinishMotion as consumers could potentially inline the function
    // which would then trigger this effect every re-render.
    // We want to make it easier for consumers so we go down this path unfortunately.
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        onExitFinished
    ]);
    (0, $5FkrB.useEffect)(function() {
        // Tracking this to prevent changing state on an unmounted component
        var isCancelled = false;
        if (!staggedIsReady) return;
        // On initial mount if elements aren't set to animate on appear, we return early and callback
        // This only occurs on initial mount, as appear will be true once the component is mounted
        if (!appear) {
            onFinishMotion && onFinishMotion('entering');
            return;
        }
        // If the state is idle or init, we don't need to do anything
        if (state === 'idle' || state === 'init') return;
        // If there is reduced motion or no exit animation, we call the onAnimationEnd function immediately
        if ((0, $c13dcba1845ee9f2$export$b7baf7667a68d87c)() || !exitingAnimation && !exitingAnimationXcss) {
            onAnimationEnd(state, isCancelled);
            return;
        }
        var animationDuration = 0;
        if (state === 'entering' || state === 'exiting') {
            if (elementRef.current) {
                if (elementRef.current.style.animation) {
                    // Motion token
                    var animationTimings = (0, $9d1cc891aed71571$export$d0038b6e47881463)((0, $b3a796e781d06578$export$82b92541889a035d)(elementRef.current.style.animation));
                    animationDuration = animationTimings.duration;
                    animationDuration += animationTimings.delay;
                } else {
                    // Custom motion
                    var _styles = window.getComputedStyle(elementRef.current);
                    animationDuration = (0, $b33b23c7974e5feb$export$dd9b73a7482d05b6)(_styles.animationName, _styles.animationDuration, _styles.animationDelay);
                }
            }
        }
        // Queue `onAnimationEnd` for after the animation has finished
        if (state === 'exiting' && (exitingAnimation || exitingAnimationXcss)) animationRef.current = setTimeout(function() {
            return onAnimationEnd(state, isCancelled);
        }, animationDuration);
        else if (state === 'entering' && (enteringAnimation || enteringAnimationXcss)) animationRef.current = setTimeout(function() {
            return onAnimationEnd(state, isCancelled);
        }, animationDuration);
        return function() {
            isCancelled = true;
            if (animationRef.current) clearTimeout(animationRef.current);
        };
    // We ignore this for onFinishMotion as consumers could potentially inline the function
    // which would then trigger this effect every re-render.
    // We want to make it easier for consumers so we go down this path unfortunately.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        onAnimationEnd,
        state,
        exitingAnimation,
        enteringAnimation,
        exitingAnimationXcss,
        enteringAnimationXcss,
        staggeredDelay,
        staggedIsReady
    ]);
    (0, $5FkrB.useImperativeHandle)(ref, function() {
        return {
            reanimate: function reanimate(value) {
                animationRef.current && clearTimeout(animationRef.current);
                reanimateRef.current = value;
                if (value === (0, $4e0f5b60b27753be$export$569340a66b14e0dc).exit_then_enter) setState('exiting');
                else if (value === (0, $4e0f5b60b27753be$export$569340a66b14e0dc).enter) setState('entering');
            }
        };
    });
    var style = {};
    var customAnimation;
    if (state === 'entering') {
        if (enteringAnimation) style.animation = enteringAnimation;
        else if (enteringAnimationXcss) customAnimation = enteringAnimationXcss;
    } else if (state === 'exiting') {
        if (exitingAnimation) style.animation = exitingAnimation;
        else if (exitingAnimationXcss) customAnimation = exitingAnimationXcss;
    }
    var hasAnimationStyles = state !== 'idle' && state !== 'init';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $18568cedb3bf28ca$export$2e2bcd8739ae039)([
            hasAnimationStyles && $d48c6d5755d883e0$var$styles.base,
            state === 'init' && $d48c6d5755d883e0$var$styles.hidden,
            (0, $d01a5d8bb96c5a7e$export$a274e22fb40f762e)(xcss, customAnimation)
        ]),
        ref: (0, $db13a2f91f6a0f56$export$2e2bcd8739ae039)([
            staggered.ref,
            elementRef
        ]),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: styleProp || hasAnimationStyles ? $d48c6d5755d883e0$var$_objectSpread($d48c6d5755d883e0$var$_objectSpread({}, styleProp), style) : undefined,
        "data-testid": testId
    }, children);
});
/**
 * Implementation of `Motion` built on top of the `useMotion` hook.
 * Used when the `platform-dst-use-motion` feature gate is on.
 */ var $d48c6d5755d883e0$var$MotionNext = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function(_ref2, ref) {
    var children = _ref2.children, enteringAnimation = _ref2.enteringAnimation, enteringAnimationXcss = _ref2.enteringAnimationXcss, exitingAnimation = _ref2.exitingAnimation, exitingAnimationXcss = _ref2.exitingAnimationXcss, onFinishMotion = _ref2.onFinish, xcss = _ref2.xcss, styleProp = _ref2.style, testId = _ref2.testId;
    var _useMotion = (0, $dd343dd5c3c6ec8a$export$2a51cfe9390d36ef)({
        onFinish: onFinishMotion
    }), state = _useMotion.state, motionRef = _useMotion.ref, reanimate = _useMotion.reanimate;
    (0, $5FkrB.useImperativeHandle)(ref, function() {
        return {
            reanimate: reanimate
        };
    }, [
        reanimate
    ]);
    // `xcss` and `style` apply to the wrapper `<div>` the `Motion` component renders,
    // so they are merged here (not in the hook) alongside the hook's animation output.
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $18568cedb3bf28ca$export$2e2bcd8739ae039)([
            state === 'init' && $d48c6d5755d883e0$var$styles.hidden,
            (0, $d01a5d8bb96c5a7e$export$a274e22fb40f762e)(xcss, state === 'entering' && enteringAnimationXcss, state === 'exiting' && exitingAnimationXcss)
        ]),
        ref: motionRef,
        style: $d48c6d5755d883e0$var$_objectSpread($d48c6d5755d883e0$var$_objectSpread({}, styleProp), {}, {
            animation: state === 'entering' ? enteringAnimation : state === 'exiting' ? exitingAnimation : undefined
        }),
        "data-testid": testId
    }, children);
});
/**
 * __Motion__
 *
 * A motion primitive that can be used to animate the entry and exit of components.
 */ var $d48c6d5755d883e0$var$Motion = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function(props, ref) {
    if ((0, $50U6m.fg)('platform-dst-use-motion')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement($d48c6d5755d883e0$var$MotionNext, (0, $84cfe10cd5b5b621$export$2e2bcd8739ae039)({}, props, {
        ref: ref
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement($d48c6d5755d883e0$var$MotionLegacy, (0, $84cfe10cd5b5b621$export$2e2bcd8739ae039)({}, props, {
        ref: ref
    }));
});
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$d48c6d5755d883e0$export$2e2bcd8739ae039 = $d48c6d5755d883e0$var$Motion;



var $50U6m = parcelRequire("50U6m");

function $30c5b5c9fa91b302$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return (0, $cc615bd93ad23227$export$2e2bcd8739ae039)(r);
}


function $5bf7dcada24920c2$export$2e2bcd8739ae039(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}



function $72040973b5fed700$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}


function $ad44204fc1b4beec$export$2e2bcd8739ae039(r) {
    return (0, $30c5b5c9fa91b302$export$2e2bcd8739ae039)(r) || (0, $5bf7dcada24920c2$export$2e2bcd8739ae039)(r) || (0, $d07a6457af62328b$export$2e2bcd8739ae039)(r) || (0, $72040973b5fed700$export$2e2bcd8739ae039)();
}




var $5FkrB = parcelRequire("5FkrB");

var $5FkrB = parcelRequire("5FkrB");



var $5FkrB = parcelRequire("5FkrB");

function $e23a441bbff67a45$export$2e2bcd8739ae039(node) {
    if (node == null) return window;
    if (node.toString() !== '[object Window]') {
        var ownerDocument = node.ownerDocument;
        return ownerDocument ? ownerDocument.defaultView || window : window;
    }
    return node;
}


function $fae30bcfba640a43$export$45a5e7f76e0caa8d(node) {
    var OwnElement = (0, $e23a441bbff67a45$export$2e2bcd8739ae039)(node).Element;
    return node instanceof OwnElement || node instanceof Element;
}
function $fae30bcfba640a43$export$1b3bfaa9684536aa(node) {
    var OwnElement = (0, $e23a441bbff67a45$export$2e2bcd8739ae039)(node).HTMLElement;
    return node instanceof OwnElement || node instanceof HTMLElement;
}
function $fae30bcfba640a43$export$af51f0f06c0f328a(node) {
    // IE 11 has no ShadowRoot
    if (typeof ShadowRoot === 'undefined') return false;
    var OwnElement = (0, $e23a441bbff67a45$export$2e2bcd8739ae039)(node).ShadowRoot;
    return node instanceof OwnElement || node instanceof ShadowRoot;
}


var $f060345502b6b7d0$export$8960430cfd85939f = Math.max;
var $f060345502b6b7d0$export$96ec731ed4dcb222 = Math.min;
var $f060345502b6b7d0$export$2077e0241d6afd3c = Math.round;



function $b440a9b7db95e092$export$2e2bcd8739ae039() {
    var uaData = navigator.userAgentData;
    if (uaData != null && uaData.brands && Array.isArray(uaData.brands)) return uaData.brands.map(function(item) {
        return item.brand + "/" + item.version;
    }).join(' ');
    return navigator.userAgent;
}


function $c3aa63da5ec3538b$export$2e2bcd8739ae039() {
    return !/^((?!chrome|android).)*safari/i.test((0, $b440a9b7db95e092$export$2e2bcd8739ae039)());
}


function $448fca4b88e71bae$export$2e2bcd8739ae039(element, includeScale, isFixedStrategy) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    var clientRect = element.getBoundingClientRect();
    var scaleX = 1;
    var scaleY = 1;
    if (includeScale && (0, $fae30bcfba640a43$export$1b3bfaa9684536aa)(element)) {
        scaleX = element.offsetWidth > 0 ? (0, $f060345502b6b7d0$export$2077e0241d6afd3c)(clientRect.width) / element.offsetWidth || 1 : 1;
        scaleY = element.offsetHeight > 0 ? (0, $f060345502b6b7d0$export$2077e0241d6afd3c)(clientRect.height) / element.offsetHeight || 1 : 1;
    }
    var _ref = (0, $fae30bcfba640a43$export$45a5e7f76e0caa8d)(element) ? (0, $e23a441bbff67a45$export$2e2bcd8739ae039)(element) : window, visualViewport = _ref.visualViewport;
    var addVisualOffsets = !(0, $c3aa63da5ec3538b$export$2e2bcd8739ae039)() && isFixedStrategy;
    var x = (clientRect.left + (addVisualOffsets && visualViewport ? visualViewport.offsetLeft : 0)) / scaleX;
    var y = (clientRect.top + (addVisualOffsets && visualViewport ? visualViewport.offsetTop : 0)) / scaleY;
    var width = clientRect.width / scaleX;
    var height = clientRect.height / scaleY;
    return {
        width: width,
        height: height,
        top: y,
        right: x + width,
        bottom: y + height,
        left: x,
        x: x,
        y: y
    };
}



function $735acd4717b89a9b$export$2e2bcd8739ae039(node) {
    var win = (0, $e23a441bbff67a45$export$2e2bcd8739ae039)(node);
    var scrollLeft = win.pageXOffset;
    var scrollTop = win.pageYOffset;
    return {
        scrollLeft: scrollLeft,
        scrollTop: scrollTop
    };
}




function $fd408f0f7fc6f904$export$2e2bcd8739ae039(element) {
    return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
}


function $cf1ccf76c8705f19$export$2e2bcd8739ae039(node) {
    if (node === (0, $e23a441bbff67a45$export$2e2bcd8739ae039)(node) || !(0, $fae30bcfba640a43$export$1b3bfaa9684536aa)(node)) return (0, $735acd4717b89a9b$export$2e2bcd8739ae039)(node);
    else return (0, $fd408f0f7fc6f904$export$2e2bcd8739ae039)(node);
}


function $87e8112f115e0ba7$export$2e2bcd8739ae039(element) {
    return element ? (element.nodeName || '').toLowerCase() : null;
}





function $1d367e31a7efd199$export$2e2bcd8739ae039(element) {
    // $FlowFixMe[incompatible-return]: assume body is always available
    return (((0, $fae30bcfba640a43$export$45a5e7f76e0caa8d)(element) ? element.ownerDocument : element.document) || window.document).documentElement;
}



function $60b6a422aa1d7c27$export$2e2bcd8739ae039(element) {
    // If <html> has a CSS width greater than the viewport, then this will be
    // incorrect for RTL.
    // Popper 1 is broken in this case and never had a bug report so let's assume
    // it's not an issue. I don't think anyone ever specifies width on <html>
    // anyway.
    // Browsers where the left scrollbar doesn't cause an issue report `0` for
    // this (e.g. Edge 2019, IE11, Safari)
    return (0, $448fca4b88e71bae$export$2e2bcd8739ae039)((0, $1d367e31a7efd199$export$2e2bcd8739ae039)(element)).left + (0, $735acd4717b89a9b$export$2e2bcd8739ae039)(element).scrollLeft;
}




function $cda54693c6d70b8e$export$2e2bcd8739ae039(element) {
    return (0, $e23a441bbff67a45$export$2e2bcd8739ae039)(element).getComputedStyle(element);
}


function $e48536f1c83ff3f8$export$2e2bcd8739ae039(element) {
    // Firefox wants us to check `-x` and `-y` variations as well
    var _getComputedStyle = (0, $cda54693c6d70b8e$export$2e2bcd8739ae039)(element), overflow = _getComputedStyle.overflow, overflowX = _getComputedStyle.overflowX, overflowY = _getComputedStyle.overflowY;
    return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}



function $30ac1953654104c9$var$isElementScaled(element) {
    var rect = element.getBoundingClientRect();
    var scaleX = (0, $f060345502b6b7d0$export$2077e0241d6afd3c)(rect.width) / element.offsetWidth || 1;
    var scaleY = (0, $f060345502b6b7d0$export$2077e0241d6afd3c)(rect.height) / element.offsetHeight || 1;
    return scaleX !== 1 || scaleY !== 1;
} // Returns the composite rect of an element relative to its offsetParent.
function $30ac1953654104c9$export$2e2bcd8739ae039(elementOrVirtualElement, offsetParent, isFixed) {
    if (isFixed === void 0) isFixed = false;
    var isOffsetParentAnElement = (0, $fae30bcfba640a43$export$1b3bfaa9684536aa)(offsetParent);
    var offsetParentIsScaled = (0, $fae30bcfba640a43$export$1b3bfaa9684536aa)(offsetParent) && $30ac1953654104c9$var$isElementScaled(offsetParent);
    var documentElement = (0, $1d367e31a7efd199$export$2e2bcd8739ae039)(offsetParent);
    var rect = (0, $448fca4b88e71bae$export$2e2bcd8739ae039)(elementOrVirtualElement, offsetParentIsScaled, isFixed);
    var scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    var offsets = {
        x: 0,
        y: 0
    };
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $87e8112f115e0ba7$export$2e2bcd8739ae039)(offsetParent) !== 'body' || // https://github.com/popperjs/popper-core/issues/1078
        (0, $e48536f1c83ff3f8$export$2e2bcd8739ae039)(documentElement)) scroll = (0, $cf1ccf76c8705f19$export$2e2bcd8739ae039)(offsetParent);
        if ((0, $fae30bcfba640a43$export$1b3bfaa9684536aa)(offsetParent)) {
            offsets = (0, $448fca4b88e71bae$export$2e2bcd8739ae039)(offsetParent, true);
            offsets.x += offsetParent.clientLeft;
            offsets.y += offsetParent.clientTop;
        } else if (documentElement) offsets.x = (0, $60b6a422aa1d7c27$export$2e2bcd8739ae039)(documentElement);
    }
    return {
        x: rect.left + scroll.scrollLeft - offsets.x,
        y: rect.top + scroll.scrollTop - offsets.y,
        width: rect.width,
        height: rect.height
    };
}



function $940b5b44ec492788$export$2e2bcd8739ae039(element) {
    var clientRect = (0, $448fca4b88e71bae$export$2e2bcd8739ae039)(element); // Use the clientRect sizes if it's not been transformed.
    // Fixes https://github.com/popperjs/popper-core/issues/1223
    var width = element.offsetWidth;
    var height = element.offsetHeight;
    if (Math.abs(clientRect.width - width) <= 1) width = clientRect.width;
    if (Math.abs(clientRect.height - height) <= 1) height = clientRect.height;
    return {
        x: element.offsetLeft,
        y: element.offsetTop,
        width: width,
        height: height
    };
}





function $f854ccb3f447e492$export$2e2bcd8739ae039(element) {
    if ((0, $87e8112f115e0ba7$export$2e2bcd8739ae039)(element) === 'html') return element;
    return(// $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    element.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    element.parentNode || ((0, $fae30bcfba640a43$export$af51f0f06c0f328a)(element) ? element.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    (0, $1d367e31a7efd199$export$2e2bcd8739ae039)(element) // fallback
    );
}





function $a5e33d0134a56fa3$export$2e2bcd8739ae039(node) {
    if ([
        'html',
        'body',
        '#document'
    ].indexOf((0, $87e8112f115e0ba7$export$2e2bcd8739ae039)(node)) >= 0) // $FlowFixMe[incompatible-return]: assume body is always available
    return node.ownerDocument.body;
    if ((0, $fae30bcfba640a43$export$1b3bfaa9684536aa)(node) && (0, $e48536f1c83ff3f8$export$2e2bcd8739ae039)(node)) return node;
    return $a5e33d0134a56fa3$export$2e2bcd8739ae039((0, $f854ccb3f447e492$export$2e2bcd8739ae039)(node));
}





function $c6726702709c9e29$export$2e2bcd8739ae039(element, list) {
    var _element$ownerDocumen;
    if (list === void 0) list = [];
    var scrollParent = (0, $a5e33d0134a56fa3$export$2e2bcd8739ae039)(element);
    var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
    var win = (0, $e23a441bbff67a45$export$2e2bcd8739ae039)(scrollParent);
    var target = isBody ? [
        win
    ].concat(win.visualViewport || [], (0, $e48536f1c83ff3f8$export$2e2bcd8739ae039)(scrollParent) ? scrollParent : []) : scrollParent;
    var updatedList = list.concat(target);
    return isBody ? updatedList : updatedList.concat($c6726702709c9e29$export$2e2bcd8739ae039((0, $f854ccb3f447e492$export$2e2bcd8739ae039)(target)));
}







function $7b5c3e787e434546$export$2e2bcd8739ae039(element) {
    return [
        'table',
        'td',
        'th'
    ].indexOf((0, $87e8112f115e0ba7$export$2e2bcd8739ae039)(element)) >= 0;
}




function $80e068c783f2bee0$var$getTrueOffsetParent(element) {
    if (!(0, $fae30bcfba640a43$export$1b3bfaa9684536aa)(element) || // https://github.com/popperjs/popper-core/issues/837
    (0, $cda54693c6d70b8e$export$2e2bcd8739ae039)(element).position === 'fixed') return null;
    return element.offsetParent;
} // `.offsetParent` reports `null` for fixed elements, while absolute elements
// return the containing block
function $80e068c783f2bee0$var$getContainingBlock(element) {
    var isFirefox = /firefox/i.test((0, $b440a9b7db95e092$export$2e2bcd8739ae039)());
    var isIE = /Trident/i.test((0, $b440a9b7db95e092$export$2e2bcd8739ae039)());
    if (isIE && (0, $fae30bcfba640a43$export$1b3bfaa9684536aa)(element)) {
        // In IE 9, 10 and 11 fixed elements containing block is always established by the viewport
        var elementCss = (0, $cda54693c6d70b8e$export$2e2bcd8739ae039)(element);
        if (elementCss.position === 'fixed') return null;
    }
    var currentNode = (0, $f854ccb3f447e492$export$2e2bcd8739ae039)(element);
    if ((0, $fae30bcfba640a43$export$af51f0f06c0f328a)(currentNode)) currentNode = currentNode.host;
    while((0, $fae30bcfba640a43$export$1b3bfaa9684536aa)(currentNode) && [
        'html',
        'body'
    ].indexOf((0, $87e8112f115e0ba7$export$2e2bcd8739ae039)(currentNode)) < 0){
        var css = (0, $cda54693c6d70b8e$export$2e2bcd8739ae039)(currentNode); // This is non-exhaustive but covers the most common CSS properties that
        // create a containing block.
        // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
        if (css.transform !== 'none' || css.perspective !== 'none' || css.contain === 'paint' || [
            'transform',
            'perspective'
        ].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === 'filter' || isFirefox && css.filter && css.filter !== 'none') return currentNode;
        else currentNode = currentNode.parentNode;
    }
    return null;
} // Gets the closest ancestor positioned element. Handles some edge cases,
function $80e068c783f2bee0$export$2e2bcd8739ae039(element) {
    var window = (0, $e23a441bbff67a45$export$2e2bcd8739ae039)(element);
    var offsetParent = $80e068c783f2bee0$var$getTrueOffsetParent(element);
    while(offsetParent && (0, $7b5c3e787e434546$export$2e2bcd8739ae039)(offsetParent) && (0, $cda54693c6d70b8e$export$2e2bcd8739ae039)(offsetParent).position === 'static')offsetParent = $80e068c783f2bee0$var$getTrueOffsetParent(offsetParent);
    if (offsetParent && ((0, $87e8112f115e0ba7$export$2e2bcd8739ae039)(offsetParent) === 'html' || (0, $87e8112f115e0ba7$export$2e2bcd8739ae039)(offsetParent) === 'body' && (0, $cda54693c6d70b8e$export$2e2bcd8739ae039)(offsetParent).position === 'static')) return window;
    return offsetParent || $80e068c783f2bee0$var$getContainingBlock(element) || window;
}


var $02ac7a7efb891b05$export$1e95b668f3b82d = 'top';
var $02ac7a7efb891b05$export$40e543e69a8b3fbb = 'bottom';
var $02ac7a7efb891b05$export$79ffe56a765070d2 = 'right';
var $02ac7a7efb891b05$export$eabcd2c8791e7bf4 = 'left';
var $02ac7a7efb891b05$export$dfb5619354ba860 = 'auto';
var $02ac7a7efb891b05$export$aec2ce47c367b8c3 = [
    $02ac7a7efb891b05$export$1e95b668f3b82d,
    $02ac7a7efb891b05$export$40e543e69a8b3fbb,
    $02ac7a7efb891b05$export$79ffe56a765070d2,
    $02ac7a7efb891b05$export$eabcd2c8791e7bf4
];
var $02ac7a7efb891b05$export$b3571188c770cc5a = 'start';
var $02ac7a7efb891b05$export$bd5df0f255a350f8 = 'end';
var $02ac7a7efb891b05$export$390fd549c5303b4d = 'clippingParents';
var $02ac7a7efb891b05$export$d7b7311ec04a3e8f = 'viewport';
var $02ac7a7efb891b05$export$ae5ab1c730825774 = 'popper';
var $02ac7a7efb891b05$export$ca50aac9f3ba507f = 'reference';
var $02ac7a7efb891b05$export$368f9a87e87fa4e1 = /*#__PURE__*/ $02ac7a7efb891b05$export$aec2ce47c367b8c3.reduce(function(acc, placement) {
    return acc.concat([
        placement + "-" + $02ac7a7efb891b05$export$b3571188c770cc5a,
        placement + "-" + $02ac7a7efb891b05$export$bd5df0f255a350f8
    ]);
}, []);
var $02ac7a7efb891b05$export$803cd8101b6c182b = /*#__PURE__*/ [].concat($02ac7a7efb891b05$export$aec2ce47c367b8c3, [
    $02ac7a7efb891b05$export$dfb5619354ba860
]).reduce(function(acc, placement) {
    return acc.concat([
        placement,
        placement + "-" + $02ac7a7efb891b05$export$b3571188c770cc5a,
        placement + "-" + $02ac7a7efb891b05$export$bd5df0f255a350f8
    ]);
}, []); // modifiers that need to read the DOM
var $02ac7a7efb891b05$export$421679a7c3d56e = 'beforeRead';
var $02ac7a7efb891b05$export$aafa59e2e03f2942 = 'read';
var $02ac7a7efb891b05$export$6964f6c886723980 = 'afterRead'; // pure-logic modifiers
var $02ac7a7efb891b05$export$c65e99957a05207c = 'beforeMain';
var $02ac7a7efb891b05$export$f22da7240b7add18 = 'main';
var $02ac7a7efb891b05$export$bab79516f2d662fe = 'afterMain'; // modifier with the purpose to write to the DOM (or write into a framework state)
var $02ac7a7efb891b05$export$8d4d2d70e7d46032 = 'beforeWrite';
var $02ac7a7efb891b05$export$68d8715fc104d294 = 'write';
var $02ac7a7efb891b05$export$70a6e5159acce2e6 = 'afterWrite';
var $02ac7a7efb891b05$export$d087d3878fdf71d5 = [
    $02ac7a7efb891b05$export$421679a7c3d56e,
    $02ac7a7efb891b05$export$aafa59e2e03f2942,
    $02ac7a7efb891b05$export$6964f6c886723980,
    $02ac7a7efb891b05$export$c65e99957a05207c,
    $02ac7a7efb891b05$export$f22da7240b7add18,
    $02ac7a7efb891b05$export$bab79516f2d662fe,
    $02ac7a7efb891b05$export$8d4d2d70e7d46032,
    $02ac7a7efb891b05$export$68d8715fc104d294,
    $02ac7a7efb891b05$export$70a6e5159acce2e6
];


function $7f1e9f55695d8404$var$order(modifiers) {
    var map = new Map();
    var visited = new Set();
    var result = [];
    modifiers.forEach(function(modifier) {
        map.set(modifier.name, modifier);
    }); // On visiting object, check for its dependencies and visit them recursively
    function sort(modifier) {
        visited.add(modifier.name);
        var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
        requires.forEach(function(dep) {
            if (!visited.has(dep)) {
                var depModifier = map.get(dep);
                if (depModifier) sort(depModifier);
            }
        });
        result.push(modifier);
    }
    modifiers.forEach(function(modifier) {
        if (!visited.has(modifier.name)) // check for visited object
        sort(modifier);
    });
    return result;
}
function $7f1e9f55695d8404$export$2e2bcd8739ae039(modifiers) {
    // order based on dependencies
    var orderedModifiers = $7f1e9f55695d8404$var$order(modifiers); // order based on phase
    return (0, $02ac7a7efb891b05$export$d087d3878fdf71d5).reduce(function(acc, phase) {
        return acc.concat(orderedModifiers.filter(function(modifier) {
            return modifier.phase === phase;
        }));
    }, []);
}


function $e2024b46b66a297d$export$2e2bcd8739ae039(fn) {
    var pending;
    return function() {
        if (!pending) pending = new Promise(function(resolve) {
            Promise.resolve().then(function() {
                pending = undefined;
                resolve(fn());
            });
        });
        return pending;
    };
}


function $2fb4e4733e092ed9$export$2e2bcd8739ae039(modifiers) {
    var merged = modifiers.reduce(function(merged, current) {
        var existing = merged[current.name];
        merged[current.name] = existing ? Object.assign({}, existing, current, {
            options: Object.assign({}, existing.options, current.options),
            data: Object.assign({}, existing.data, current.data)
        }) : current;
        return merged;
    }, {}); // IE11 does not support Object.values
    return Object.keys(merged).map(function(key) {
        return merged[key];
    });
}




var $bf58442f71e0a59e$var$DEFAULT_OPTIONS = {
    placement: 'bottom',
    modifiers: [],
    strategy: 'absolute'
};
function $bf58442f71e0a59e$var$areValidElements() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return !args.some(function(element) {
        return !(element && typeof element.getBoundingClientRect === 'function');
    });
}
function $bf58442f71e0a59e$export$ed5e13716264f202(generatorOptions) {
    if (generatorOptions === void 0) generatorOptions = {};
    var _generatorOptions = generatorOptions, _generatorOptions$def = _generatorOptions.defaultModifiers, defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def, _generatorOptions$def2 = _generatorOptions.defaultOptions, defaultOptions = _generatorOptions$def2 === void 0 ? $bf58442f71e0a59e$var$DEFAULT_OPTIONS : _generatorOptions$def2;
    return function createPopper(reference, popper, options) {
        if (options === void 0) options = defaultOptions;
        var state = {
            placement: 'bottom',
            orderedModifiers: [],
            options: Object.assign({}, $bf58442f71e0a59e$var$DEFAULT_OPTIONS, defaultOptions),
            modifiersData: {},
            elements: {
                reference: reference,
                popper: popper
            },
            attributes: {},
            styles: {}
        };
        var effectCleanupFns = [];
        var isDestroyed = false;
        var instance = {
            state: state,
            setOptions: function setOptions(setOptionsAction) {
                var options = typeof setOptionsAction === 'function' ? setOptionsAction(state.options) : setOptionsAction;
                cleanupModifierEffects();
                state.options = Object.assign({}, defaultOptions, state.options, options);
                state.scrollParents = {
                    reference: (0, $fae30bcfba640a43$export$45a5e7f76e0caa8d)(reference) ? (0, $c6726702709c9e29$export$2e2bcd8739ae039)(reference) : reference.contextElement ? (0, $c6726702709c9e29$export$2e2bcd8739ae039)(reference.contextElement) : [],
                    popper: (0, $c6726702709c9e29$export$2e2bcd8739ae039)(popper)
                }; // Orders the modifiers based on their dependencies and `phase`
                // properties
                var orderedModifiers = (0, $7f1e9f55695d8404$export$2e2bcd8739ae039)((0, $2fb4e4733e092ed9$export$2e2bcd8739ae039)([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers
                state.orderedModifiers = orderedModifiers.filter(function(m) {
                    return m.enabled;
                });
                runModifierEffects();
                return instance.update();
            },
            // Sync update – it will always be executed, even if not necessary. This
            // is useful for low frequency updates where sync behavior simplifies the
            // logic.
            // For high frequency updates (e.g. `resize` and `scroll` events), always
            // prefer the async Popper#update method
            forceUpdate: function forceUpdate() {
                if (isDestroyed) return;
                var _state$elements = state.elements, reference = _state$elements.reference, popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
                // anymore
                if (!$bf58442f71e0a59e$var$areValidElements(reference, popper)) return;
                 // Store the reference and popper rects to be read by modifiers
                state.rects = {
                    reference: (0, $30ac1953654104c9$export$2e2bcd8739ae039)(reference, (0, $80e068c783f2bee0$export$2e2bcd8739ae039)(popper), state.options.strategy === 'fixed'),
                    popper: (0, $940b5b44ec492788$export$2e2bcd8739ae039)(popper)
                }; // Modifiers have the ability to reset the current update cycle. The
                // most common use case for this is the `flip` modifier changing the
                // placement, which then needs to re-run all the modifiers, because the
                // logic was previously ran for the previous placement and is therefore
                // stale/incorrect
                state.reset = false;
                state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
                // is filled with the initial data specified by the modifier. This means
                // it doesn't persist and is fresh on each update.
                // To ensure persistent data, use `${name}#persistent`
                state.orderedModifiers.forEach(function(modifier) {
                    return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
                });
                for(var index = 0; index < state.orderedModifiers.length; index++){
                    if (state.reset === true) {
                        state.reset = false;
                        index = -1;
                        continue;
                    }
                    var _state$orderedModifie = state.orderedModifiers[index], fn = _state$orderedModifie.fn, _state$orderedModifie2 = _state$orderedModifie.options, _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2, name = _state$orderedModifie.name;
                    if (typeof fn === 'function') state = fn({
                        state: state,
                        options: _options,
                        name: name,
                        instance: instance
                    }) || state;
                }
            },
            // Async and optimistically optimized update – it will not be executed if
            // not necessary (debounced to run at most once-per-tick)
            update: (0, $e2024b46b66a297d$export$2e2bcd8739ae039)(function() {
                return new Promise(function(resolve) {
                    instance.forceUpdate();
                    resolve(state);
                });
            }),
            destroy: function destroy() {
                cleanupModifierEffects();
                isDestroyed = true;
            }
        };
        if (!$bf58442f71e0a59e$var$areValidElements(reference, popper)) return instance;
        instance.setOptions(options).then(function(state) {
            if (!isDestroyed && options.onFirstUpdate) options.onFirstUpdate(state);
        }); // Modifiers have the ability to execute arbitrary code before the first
        // update cycle runs. They will be executed in the same order as the update
        // cycle. This is useful when a modifier adds some persistent data that
        // other modifiers need to use, but the modifier is run after the dependent
        // one.
        function runModifierEffects() {
            state.orderedModifiers.forEach(function(_ref) {
                var name = _ref.name, _ref$options = _ref.options, options = _ref$options === void 0 ? {} : _ref$options, effect = _ref.effect;
                if (typeof effect === 'function') {
                    var cleanupFn = effect({
                        state: state,
                        name: name,
                        instance: instance,
                        options: options
                    });
                    var noopFn = function noopFn() {};
                    effectCleanupFns.push(cleanupFn || noopFn);
                }
            });
        }
        function cleanupModifierEffects() {
            effectCleanupFns.forEach(function(fn) {
                return fn();
            });
            effectCleanupFns = [];
        }
        return instance;
    };
}
var $bf58442f71e0a59e$export$8f7491d57c8f97a9 = /*#__PURE__*/ $bf58442f71e0a59e$export$ed5e13716264f202(); // eslint-disable-next-line import/no-unused-modules



var $06f218a851c306cc$var$passive = {
    passive: true
};
function $06f218a851c306cc$var$effect(_ref) {
    var state = _ref.state, instance = _ref.instance, options = _ref.options;
    var _options$scroll = options.scroll, scroll = _options$scroll === void 0 ? true : _options$scroll, _options$resize = options.resize, resize = _options$resize === void 0 ? true : _options$resize;
    var window = (0, $e23a441bbff67a45$export$2e2bcd8739ae039)(state.elements.popper);
    var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);
    if (scroll) scrollParents.forEach(function(scrollParent) {
        scrollParent.addEventListener('scroll', instance.update, $06f218a851c306cc$var$passive);
    });
    if (resize) window.addEventListener('resize', instance.update, $06f218a851c306cc$var$passive);
    return function() {
        if (scroll) scrollParents.forEach(function(scrollParent) {
            scrollParent.removeEventListener('scroll', instance.update, $06f218a851c306cc$var$passive);
        });
        if (resize) window.removeEventListener('resize', instance.update, $06f218a851c306cc$var$passive);
    };
} // eslint-disable-next-line import/no-unused-modules
var $06f218a851c306cc$export$2e2bcd8739ae039 = {
    name: 'eventListeners',
    enabled: true,
    phase: 'write',
    fn: function fn() {},
    effect: $06f218a851c306cc$var$effect,
    data: {}
};



function $41a74276d1437cf3$export$2e2bcd8739ae039(placement) {
    return placement.split('-')[0];
}


function $dea175e1fbb039f4$export$2e2bcd8739ae039(placement) {
    return placement.split('-')[1];
}


function $73e81d9ee133d820$export$2e2bcd8739ae039(placement) {
    return [
        'top',
        'bottom'
    ].indexOf(placement) >= 0 ? 'x' : 'y';
}



function $3c149818943b8402$export$2e2bcd8739ae039(_ref) {
    var reference = _ref.reference, element = _ref.element, placement = _ref.placement;
    var basePlacement = placement ? (0, $41a74276d1437cf3$export$2e2bcd8739ae039)(placement) : null;
    var variation = placement ? (0, $dea175e1fbb039f4$export$2e2bcd8739ae039)(placement) : null;
    var commonX = reference.x + reference.width / 2 - element.width / 2;
    var commonY = reference.y + reference.height / 2 - element.height / 2;
    var offsets;
    switch(basePlacement){
        case 0, $02ac7a7efb891b05$export$1e95b668f3b82d:
            offsets = {
                x: commonX,
                y: reference.y - element.height
            };
            break;
        case 0, $02ac7a7efb891b05$export$40e543e69a8b3fbb:
            offsets = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 0, $02ac7a7efb891b05$export$79ffe56a765070d2:
            offsets = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 0, $02ac7a7efb891b05$export$eabcd2c8791e7bf4:
            offsets = {
                x: reference.x - element.width,
                y: commonY
            };
            break;
        default:
            offsets = {
                x: reference.x,
                y: reference.y
            };
    }
    var mainAxis = basePlacement ? (0, $73e81d9ee133d820$export$2e2bcd8739ae039)(basePlacement) : null;
    if (mainAxis != null) {
        var len = mainAxis === 'y' ? 'height' : 'width';
        switch(variation){
            case 0, $02ac7a7efb891b05$export$b3571188c770cc5a:
                offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
                break;
            case 0, $02ac7a7efb891b05$export$bd5df0f255a350f8:
                offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
                break;
            default:
        }
    }
    return offsets;
}


function $e0ca49ea984cd711$var$popperOffsets(_ref) {
    var state = _ref.state, name = _ref.name;
    // Offsets are the actual position the popper needs to have to be
    // properly positioned near its reference element
    // This is the most basic placement, and will be adjusted by
    // the modifiers in the next step
    state.modifiersData[name] = (0, $3c149818943b8402$export$2e2bcd8739ae039)({
        reference: state.rects.reference,
        element: state.rects.popper,
        strategy: 'absolute',
        placement: state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $e0ca49ea984cd711$export$2e2bcd8739ae039 = {
    name: 'popperOffsets',
    enabled: true,
    phase: 'read',
    fn: $e0ca49ea984cd711$var$popperOffsets,
    data: {}
};










var $638a36f4ddb5d6c8$var$unsetSides = {
    top: 'auto',
    right: 'auto',
    bottom: 'auto',
    left: 'auto'
}; // Round the offsets to the nearest suitable subpixel based on the DPR.
// Zooming can change the DPR, but it seems to report a value that will
// cleanly divide the values into the appropriate subpixels.
function $638a36f4ddb5d6c8$var$roundOffsetsByDPR(_ref, win) {
    var x = _ref.x, y = _ref.y;
    var dpr = win.devicePixelRatio || 1;
    return {
        x: (0, $f060345502b6b7d0$export$2077e0241d6afd3c)(x * dpr) / dpr || 0,
        y: (0, $f060345502b6b7d0$export$2077e0241d6afd3c)(y * dpr) / dpr || 0
    };
}
function $638a36f4ddb5d6c8$export$378fa78a8fea596f(_ref2) {
    var _Object$assign2;
    var popper = _ref2.popper, popperRect = _ref2.popperRect, placement = _ref2.placement, variation = _ref2.variation, offsets = _ref2.offsets, position = _ref2.position, gpuAcceleration = _ref2.gpuAcceleration, adaptive = _ref2.adaptive, roundOffsets = _ref2.roundOffsets, isFixed = _ref2.isFixed;
    var _offsets$x = offsets.x, x = _offsets$x === void 0 ? 0 : _offsets$x, _offsets$y = offsets.y, y = _offsets$y === void 0 ? 0 : _offsets$y;
    var _ref3 = typeof roundOffsets === 'function' ? roundOffsets({
        x: x,
        y: y
    }) : {
        x: x,
        y: y
    };
    x = _ref3.x;
    y = _ref3.y;
    var hasX = offsets.hasOwnProperty('x');
    var hasY = offsets.hasOwnProperty('y');
    var sideX = (0, $02ac7a7efb891b05$export$eabcd2c8791e7bf4);
    var sideY = (0, $02ac7a7efb891b05$export$1e95b668f3b82d);
    var win = window;
    if (adaptive) {
        var offsetParent = (0, $80e068c783f2bee0$export$2e2bcd8739ae039)(popper);
        var heightProp = 'clientHeight';
        var widthProp = 'clientWidth';
        if (offsetParent === (0, $e23a441bbff67a45$export$2e2bcd8739ae039)(popper)) {
            offsetParent = (0, $1d367e31a7efd199$export$2e2bcd8739ae039)(popper);
            if ((0, $cda54693c6d70b8e$export$2e2bcd8739ae039)(offsetParent).position !== 'static' && position === 'absolute') {
                heightProp = 'scrollHeight';
                widthProp = 'scrollWidth';
            }
        } // $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it
        offsetParent;
        if (placement === (0, $02ac7a7efb891b05$export$1e95b668f3b82d) || (placement === (0, $02ac7a7efb891b05$export$eabcd2c8791e7bf4) || placement === (0, $02ac7a7efb891b05$export$79ffe56a765070d2)) && variation === (0, $02ac7a7efb891b05$export$bd5df0f255a350f8)) {
            sideY = (0, $02ac7a7efb891b05$export$40e543e69a8b3fbb);
            var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : offsetParent[heightProp];
            y -= offsetY - popperRect.height;
            y *= gpuAcceleration ? 1 : -1;
        }
        if (placement === (0, $02ac7a7efb891b05$export$eabcd2c8791e7bf4) || (placement === (0, $02ac7a7efb891b05$export$1e95b668f3b82d) || placement === (0, $02ac7a7efb891b05$export$40e543e69a8b3fbb)) && variation === (0, $02ac7a7efb891b05$export$bd5df0f255a350f8)) {
            sideX = (0, $02ac7a7efb891b05$export$79ffe56a765070d2);
            var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : offsetParent[widthProp];
            x -= offsetX - popperRect.width;
            x *= gpuAcceleration ? 1 : -1;
        }
    }
    var commonStyles = Object.assign({
        position: position
    }, adaptive && $638a36f4ddb5d6c8$var$unsetSides);
    var _ref4 = roundOffsets === true ? $638a36f4ddb5d6c8$var$roundOffsetsByDPR({
        x: x,
        y: y
    }, (0, $e23a441bbff67a45$export$2e2bcd8739ae039)(popper)) : {
        x: x,
        y: y
    };
    x = _ref4.x;
    y = _ref4.y;
    if (gpuAcceleration) {
        var _Object$assign;
        return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? '0' : '', _Object$assign[sideX] = hasX ? '0' : '', _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
    }
    return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : '', _Object$assign2[sideX] = hasX ? x + "px" : '', _Object$assign2.transform = '', _Object$assign2));
}
function $638a36f4ddb5d6c8$var$computeStyles(_ref5) {
    var state = _ref5.state, options = _ref5.options;
    var _options$gpuAccelerat = options.gpuAcceleration, gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat, _options$adaptive = options.adaptive, adaptive = _options$adaptive === void 0 ? true : _options$adaptive, _options$roundOffsets = options.roundOffsets, roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;
    var commonStyles = {
        placement: (0, $41a74276d1437cf3$export$2e2bcd8739ae039)(state.placement),
        variation: (0, $dea175e1fbb039f4$export$2e2bcd8739ae039)(state.placement),
        popper: state.elements.popper,
        popperRect: state.rects.popper,
        gpuAcceleration: gpuAcceleration,
        isFixed: state.options.strategy === 'fixed'
    };
    if (state.modifiersData.popperOffsets != null) state.styles.popper = Object.assign({}, state.styles.popper, $638a36f4ddb5d6c8$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.popperOffsets,
        position: state.options.strategy,
        adaptive: adaptive,
        roundOffsets: roundOffsets
    })));
    if (state.modifiersData.arrow != null) state.styles.arrow = Object.assign({}, state.styles.arrow, $638a36f4ddb5d6c8$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.arrow,
        position: 'absolute',
        adaptive: false,
        roundOffsets: roundOffsets
    })));
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        'data-popper-placement': state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $638a36f4ddb5d6c8$export$2e2bcd8739ae039 = {
    name: 'computeStyles',
    enabled: true,
    phase: 'beforeWrite',
    fn: $638a36f4ddb5d6c8$var$computeStyles,
    data: {}
};




// and applies them to the HTMLElements such as popper and arrow
function $69e846f9616ad096$var$applyStyles(_ref) {
    var state = _ref.state;
    Object.keys(state.elements).forEach(function(name) {
        var style = state.styles[name] || {};
        var attributes = state.attributes[name] || {};
        var element = state.elements[name]; // arrow is optional + virtual elements
        if (!(0, $fae30bcfba640a43$export$1b3bfaa9684536aa)(element) || !(0, $87e8112f115e0ba7$export$2e2bcd8739ae039)(element)) return;
         // Flow doesn't support to extend this property, but it's the most
        // effective way to apply styles to an HTMLElement
        // $FlowFixMe[cannot-write]
        Object.assign(element.style, style);
        Object.keys(attributes).forEach(function(name) {
            var value = attributes[name];
            if (value === false) element.removeAttribute(name);
            else element.setAttribute(name, value === true ? '' : value);
        });
    });
}
function $69e846f9616ad096$var$effect(_ref2) {
    var state = _ref2.state;
    var initialStyles = {
        popper: {
            position: state.options.strategy,
            left: '0',
            top: '0',
            margin: '0'
        },
        arrow: {
            position: 'absolute'
        },
        reference: {}
    };
    Object.assign(state.elements.popper.style, initialStyles.popper);
    state.styles = initialStyles;
    if (state.elements.arrow) Object.assign(state.elements.arrow.style, initialStyles.arrow);
    return function() {
        Object.keys(state.elements).forEach(function(name) {
            var element = state.elements[name];
            var attributes = state.attributes[name] || {};
            var styleProperties = Object.keys(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]); // Set all values to an empty string to unset them
            var style = styleProperties.reduce(function(style, property) {
                style[property] = '';
                return style;
            }, {}); // arrow is optional + virtual elements
            if (!(0, $fae30bcfba640a43$export$1b3bfaa9684536aa)(element) || !(0, $87e8112f115e0ba7$export$2e2bcd8739ae039)(element)) return;
            Object.assign(element.style, style);
            Object.keys(attributes).forEach(function(attribute) {
                element.removeAttribute(attribute);
            });
        });
    };
} // eslint-disable-next-line import/no-unused-modules
var $69e846f9616ad096$export$2e2bcd8739ae039 = {
    name: 'applyStyles',
    enabled: true,
    phase: 'write',
    fn: $69e846f9616ad096$var$applyStyles,
    effect: $69e846f9616ad096$var$effect,
    requires: [
        'computeStyles'
    ]
};




function $f7552b997e91c31f$export$7fa02d8595b015ed(placement, rects, offset) {
    var basePlacement = (0, $41a74276d1437cf3$export$2e2bcd8739ae039)(placement);
    var invertDistance = [
        (0, $02ac7a7efb891b05$export$eabcd2c8791e7bf4),
        (0, $02ac7a7efb891b05$export$1e95b668f3b82d)
    ].indexOf(basePlacement) >= 0 ? -1 : 1;
    var _ref = typeof offset === 'function' ? offset(Object.assign({}, rects, {
        placement: placement
    })) : offset, skidding = _ref[0], distance = _ref[1];
    skidding = skidding || 0;
    distance = (distance || 0) * invertDistance;
    return [
        (0, $02ac7a7efb891b05$export$eabcd2c8791e7bf4),
        (0, $02ac7a7efb891b05$export$79ffe56a765070d2)
    ].indexOf(basePlacement) >= 0 ? {
        x: distance,
        y: skidding
    } : {
        x: skidding,
        y: distance
    };
}
function $f7552b997e91c31f$var$offset(_ref2) {
    var state = _ref2.state, options = _ref2.options, name = _ref2.name;
    var _options$offset = options.offset, offset = _options$offset === void 0 ? [
        0,
        0
    ] : _options$offset;
    var data = (0, $02ac7a7efb891b05$export$803cd8101b6c182b).reduce(function(acc, placement) {
        acc[placement] = $f7552b997e91c31f$export$7fa02d8595b015ed(placement, state.rects, offset);
        return acc;
    }, {});
    var _data$state$placement = data[state.placement], x = _data$state$placement.x, y = _data$state$placement.y;
    if (state.modifiersData.popperOffsets != null) {
        state.modifiersData.popperOffsets.x += x;
        state.modifiersData.popperOffsets.y += y;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $f7552b997e91c31f$export$2e2bcd8739ae039 = {
    name: 'offset',
    enabled: true,
    phase: 'main',
    requires: [
        'popperOffsets'
    ],
    fn: $f7552b997e91c31f$var$offset
};


var $2eeb6ba489107ea4$var$hash = {
    left: 'right',
    right: 'left',
    bottom: 'top',
    top: 'bottom'
};
function $2eeb6ba489107ea4$export$2e2bcd8739ae039(placement) {
    return placement.replace(/left|right|bottom|top/g, function(matched) {
        return $2eeb6ba489107ea4$var$hash[matched];
    });
}



var $5ff3c44405c30b93$var$hash = {
    start: 'end',
    end: 'start'
};
function $5ff3c44405c30b93$export$2e2bcd8739ae039(placement) {
    return placement.replace(/start|end/g, function(matched) {
        return $5ff3c44405c30b93$var$hash[matched];
    });
}







function $965d83c411363a82$export$2e2bcd8739ae039(element, strategy) {
    var win = (0, $e23a441bbff67a45$export$2e2bcd8739ae039)(element);
    var html = (0, $1d367e31a7efd199$export$2e2bcd8739ae039)(element);
    var visualViewport = win.visualViewport;
    var width = html.clientWidth;
    var height = html.clientHeight;
    var x = 0;
    var y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        var layoutViewport = (0, $c3aa63da5ec3538b$export$2e2bcd8739ae039)();
        if (layoutViewport || !layoutViewport && strategy === 'fixed') {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x + (0, $60b6a422aa1d7c27$export$2e2bcd8739ae039)(element),
        y: y
    };
}







function $867d6f9773686e85$export$2e2bcd8739ae039(element) {
    var _element$ownerDocumen;
    var html = (0, $1d367e31a7efd199$export$2e2bcd8739ae039)(element);
    var winScroll = (0, $735acd4717b89a9b$export$2e2bcd8739ae039)(element);
    var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
    var width = (0, $f060345502b6b7d0$export$8960430cfd85939f)(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
    var height = (0, $f060345502b6b7d0$export$8960430cfd85939f)(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
    var x = -winScroll.scrollLeft + (0, $60b6a422aa1d7c27$export$2e2bcd8739ae039)(element);
    var y = -winScroll.scrollTop;
    if ((0, $cda54693c6d70b8e$export$2e2bcd8739ae039)(body || html).direction === 'rtl') x += (0, $f060345502b6b7d0$export$8960430cfd85939f)(html.clientWidth, body ? body.clientWidth : 0) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}










function $f16668aaebdec374$export$2e2bcd8739ae039(parent, child) {
    var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method
    if (parent.contains(child)) return true;
    else if (rootNode && (0, $fae30bcfba640a43$export$af51f0f06c0f328a)(rootNode)) {
        var next = child;
        do {
            if (next && parent.isSameNode(next)) return true;
             // $FlowFixMe[prop-missing]: need a better way to handle this...
            next = next.parentNode || next.host;
        }while (next);
    } // Give up, the result is false
    return false;
}



function $9ddda9cf12580473$export$2e2bcd8739ae039(rect) {
    return Object.assign({}, rect, {
        left: rect.x,
        top: rect.y,
        right: rect.x + rect.width,
        bottom: rect.y + rect.height
    });
}



function $08bb5a68a7569dd1$var$getInnerBoundingClientRect(element, strategy) {
    var rect = (0, $448fca4b88e71bae$export$2e2bcd8739ae039)(element, false, strategy === 'fixed');
    rect.top = rect.top + element.clientTop;
    rect.left = rect.left + element.clientLeft;
    rect.bottom = rect.top + element.clientHeight;
    rect.right = rect.left + element.clientWidth;
    rect.width = element.clientWidth;
    rect.height = element.clientHeight;
    rect.x = rect.left;
    rect.y = rect.top;
    return rect;
}
function $08bb5a68a7569dd1$var$getClientRectFromMixedType(element, clippingParent, strategy) {
    return clippingParent === (0, $02ac7a7efb891b05$export$d7b7311ec04a3e8f) ? (0, $9ddda9cf12580473$export$2e2bcd8739ae039)((0, $965d83c411363a82$export$2e2bcd8739ae039)(element, strategy)) : (0, $fae30bcfba640a43$export$45a5e7f76e0caa8d)(clippingParent) ? $08bb5a68a7569dd1$var$getInnerBoundingClientRect(clippingParent, strategy) : (0, $9ddda9cf12580473$export$2e2bcd8739ae039)((0, $867d6f9773686e85$export$2e2bcd8739ae039)((0, $1d367e31a7efd199$export$2e2bcd8739ae039)(element)));
} // A "clipping parent" is an overflowable container with the characteristic of
// clipping (or hiding) overflowing elements with a position different from
// `initial`
function $08bb5a68a7569dd1$var$getClippingParents(element) {
    var clippingParents = (0, $c6726702709c9e29$export$2e2bcd8739ae039)((0, $f854ccb3f447e492$export$2e2bcd8739ae039)(element));
    var canEscapeClipping = [
        'absolute',
        'fixed'
    ].indexOf((0, $cda54693c6d70b8e$export$2e2bcd8739ae039)(element).position) >= 0;
    var clipperElement = canEscapeClipping && (0, $fae30bcfba640a43$export$1b3bfaa9684536aa)(element) ? (0, $80e068c783f2bee0$export$2e2bcd8739ae039)(element) : element;
    if (!(0, $fae30bcfba640a43$export$45a5e7f76e0caa8d)(clipperElement)) return [];
     // $FlowFixMe[incompatible-return]: https://github.com/facebook/flow/issues/1414
    return clippingParents.filter(function(clippingParent) {
        return (0, $fae30bcfba640a43$export$45a5e7f76e0caa8d)(clippingParent) && (0, $f16668aaebdec374$export$2e2bcd8739ae039)(clippingParent, clipperElement) && (0, $87e8112f115e0ba7$export$2e2bcd8739ae039)(clippingParent) !== 'body';
    });
} // Gets the maximum area that the element is visible in due to any number of
function $08bb5a68a7569dd1$export$2e2bcd8739ae039(element, boundary, rootBoundary, strategy) {
    var mainClippingParents = boundary === 'clippingParents' ? $08bb5a68a7569dd1$var$getClippingParents(element) : [].concat(boundary);
    var clippingParents = [].concat(mainClippingParents, [
        rootBoundary
    ]);
    var firstClippingParent = clippingParents[0];
    var clippingRect = clippingParents.reduce(function(accRect, clippingParent) {
        var rect = $08bb5a68a7569dd1$var$getClientRectFromMixedType(element, clippingParent, strategy);
        accRect.top = (0, $f060345502b6b7d0$export$8960430cfd85939f)(rect.top, accRect.top);
        accRect.right = (0, $f060345502b6b7d0$export$96ec731ed4dcb222)(rect.right, accRect.right);
        accRect.bottom = (0, $f060345502b6b7d0$export$96ec731ed4dcb222)(rect.bottom, accRect.bottom);
        accRect.left = (0, $f060345502b6b7d0$export$8960430cfd85939f)(rect.left, accRect.left);
        return accRect;
    }, $08bb5a68a7569dd1$var$getClientRectFromMixedType(element, firstClippingParent, strategy));
    clippingRect.width = clippingRect.right - clippingRect.left;
    clippingRect.height = clippingRect.bottom - clippingRect.top;
    clippingRect.x = clippingRect.left;
    clippingRect.y = clippingRect.top;
    return clippingRect;
}








function $9f77d3f4875fb909$export$2e2bcd8739ae039() {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    };
}


function $0f8bbf2cee5893df$export$2e2bcd8739ae039(paddingObject) {
    return Object.assign({}, (0, $9f77d3f4875fb909$export$2e2bcd8739ae039)(), paddingObject);
}


function $521ed68a58dda134$export$2e2bcd8739ae039(value, keys) {
    return keys.reduce(function(hashMap, key) {
        hashMap[key] = value;
        return hashMap;
    }, {});
}


function $76513b0dab162e77$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, _options$placement = _options.placement, placement = _options$placement === void 0 ? state.placement : _options$placement, _options$strategy = _options.strategy, strategy = _options$strategy === void 0 ? state.strategy : _options$strategy, _options$boundary = _options.boundary, boundary = _options$boundary === void 0 ? (0, $02ac7a7efb891b05$export$390fd549c5303b4d) : _options$boundary, _options$rootBoundary = _options.rootBoundary, rootBoundary = _options$rootBoundary === void 0 ? (0, $02ac7a7efb891b05$export$d7b7311ec04a3e8f) : _options$rootBoundary, _options$elementConte = _options.elementContext, elementContext = _options$elementConte === void 0 ? (0, $02ac7a7efb891b05$export$ae5ab1c730825774) : _options$elementConte, _options$altBoundary = _options.altBoundary, altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary, _options$padding = _options.padding, padding = _options$padding === void 0 ? 0 : _options$padding;
    var paddingObject = (0, $0f8bbf2cee5893df$export$2e2bcd8739ae039)(typeof padding !== 'number' ? padding : (0, $521ed68a58dda134$export$2e2bcd8739ae039)(padding, (0, $02ac7a7efb891b05$export$aec2ce47c367b8c3)));
    var altContext = elementContext === (0, $02ac7a7efb891b05$export$ae5ab1c730825774) ? (0, $02ac7a7efb891b05$export$ca50aac9f3ba507f) : (0, $02ac7a7efb891b05$export$ae5ab1c730825774);
    var popperRect = state.rects.popper;
    var element = state.elements[altBoundary ? altContext : elementContext];
    var clippingClientRect = (0, $08bb5a68a7569dd1$export$2e2bcd8739ae039)((0, $fae30bcfba640a43$export$45a5e7f76e0caa8d)(element) ? element : element.contextElement || (0, $1d367e31a7efd199$export$2e2bcd8739ae039)(state.elements.popper), boundary, rootBoundary, strategy);
    var referenceClientRect = (0, $448fca4b88e71bae$export$2e2bcd8739ae039)(state.elements.reference);
    var popperOffsets = (0, $3c149818943b8402$export$2e2bcd8739ae039)({
        reference: referenceClientRect,
        element: popperRect,
        strategy: 'absolute',
        placement: placement
    });
    var popperClientRect = (0, $9ddda9cf12580473$export$2e2bcd8739ae039)(Object.assign({}, popperRect, popperOffsets));
    var elementClientRect = elementContext === (0, $02ac7a7efb891b05$export$ae5ab1c730825774) ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
    // 0 or negative = within the clipping rect
    var overflowOffsets = {
        top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
        bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
        left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
        right: elementClientRect.right - clippingClientRect.right + paddingObject.right
    };
    var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element
    if (elementContext === (0, $02ac7a7efb891b05$export$ae5ab1c730825774) && offsetData) {
        var offset = offsetData[placement];
        Object.keys(overflowOffsets).forEach(function(key) {
            var multiply = [
                (0, $02ac7a7efb891b05$export$79ffe56a765070d2),
                (0, $02ac7a7efb891b05$export$40e543e69a8b3fbb)
            ].indexOf(key) >= 0 ? 1 : -1;
            var axis = [
                (0, $02ac7a7efb891b05$export$1e95b668f3b82d),
                (0, $02ac7a7efb891b05$export$40e543e69a8b3fbb)
            ].indexOf(key) >= 0 ? 'y' : 'x';
            overflowOffsets[key] += offset[axis] * multiply;
        });
    }
    return overflowOffsets;
}






function $12122352a478c0c2$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, placement = _options.placement, boundary = _options.boundary, rootBoundary = _options.rootBoundary, padding = _options.padding, flipVariations = _options.flipVariations, _options$allowedAutoP = _options.allowedAutoPlacements, allowedAutoPlacements = _options$allowedAutoP === void 0 ? (0, $02ac7a7efb891b05$export$803cd8101b6c182b) : _options$allowedAutoP;
    var variation = (0, $dea175e1fbb039f4$export$2e2bcd8739ae039)(placement);
    var placements = variation ? flipVariations ? (0, $02ac7a7efb891b05$export$368f9a87e87fa4e1) : (0, $02ac7a7efb891b05$export$368f9a87e87fa4e1).filter(function(placement) {
        return (0, $dea175e1fbb039f4$export$2e2bcd8739ae039)(placement) === variation;
    }) : (0, $02ac7a7efb891b05$export$aec2ce47c367b8c3);
    var allowedPlacements = placements.filter(function(placement) {
        return allowedAutoPlacements.indexOf(placement) >= 0;
    });
    if (allowedPlacements.length === 0) allowedPlacements = placements;
     // $FlowFixMe[incompatible-type]: Flow seems to have problems with two array unions...
    var overflows = allowedPlacements.reduce(function(acc, placement) {
        acc[placement] = (0, $76513b0dab162e77$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding
        })[(0, $41a74276d1437cf3$export$2e2bcd8739ae039)(placement)];
        return acc;
    }, {});
    return Object.keys(overflows).sort(function(a, b) {
        return overflows[a] - overflows[b];
    });
}




function $a8d612a7f4de3fca$var$getExpandedFallbackPlacements(placement) {
    if ((0, $41a74276d1437cf3$export$2e2bcd8739ae039)(placement) === (0, $02ac7a7efb891b05$export$dfb5619354ba860)) return [];
    var oppositePlacement = (0, $2eeb6ba489107ea4$export$2e2bcd8739ae039)(placement);
    return [
        (0, $5ff3c44405c30b93$export$2e2bcd8739ae039)(placement),
        oppositePlacement,
        (0, $5ff3c44405c30b93$export$2e2bcd8739ae039)(oppositePlacement)
    ];
}
function $a8d612a7f4de3fca$var$flip(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    if (state.modifiersData[name]._skip) return;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis, specifiedFallbackPlacements = options.fallbackPlacements, padding = options.padding, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, _options$flipVariatio = options.flipVariations, flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio, allowedAutoPlacements = options.allowedAutoPlacements;
    var preferredPlacement = state.options.placement;
    var basePlacement = (0, $41a74276d1437cf3$export$2e2bcd8739ae039)(preferredPlacement);
    var isBasePlacement = basePlacement === preferredPlacement;
    var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [
        (0, $2eeb6ba489107ea4$export$2e2bcd8739ae039)(preferredPlacement)
    ] : $a8d612a7f4de3fca$var$getExpandedFallbackPlacements(preferredPlacement));
    var placements = [
        preferredPlacement
    ].concat(fallbackPlacements).reduce(function(acc, placement) {
        return acc.concat((0, $41a74276d1437cf3$export$2e2bcd8739ae039)(placement) === (0, $02ac7a7efb891b05$export$dfb5619354ba860) ? (0, $12122352a478c0c2$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding,
            flipVariations: flipVariations,
            allowedAutoPlacements: allowedAutoPlacements
        }) : placement);
    }, []);
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var checksMap = new Map();
    var makeFallbackChecks = true;
    var firstFittingPlacement = placements[0];
    for(var i = 0; i < placements.length; i++){
        var placement = placements[i];
        var _basePlacement = (0, $41a74276d1437cf3$export$2e2bcd8739ae039)(placement);
        var isStartVariation = (0, $dea175e1fbb039f4$export$2e2bcd8739ae039)(placement) === (0, $02ac7a7efb891b05$export$b3571188c770cc5a);
        var isVertical = [
            (0, $02ac7a7efb891b05$export$1e95b668f3b82d),
            (0, $02ac7a7efb891b05$export$40e543e69a8b3fbb)
        ].indexOf(_basePlacement) >= 0;
        var len = isVertical ? 'width' : 'height';
        var overflow = (0, $76513b0dab162e77$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            altBoundary: altBoundary,
            padding: padding
        });
        var mainVariationSide = isVertical ? isStartVariation ? (0, $02ac7a7efb891b05$export$79ffe56a765070d2) : (0, $02ac7a7efb891b05$export$eabcd2c8791e7bf4) : isStartVariation ? (0, $02ac7a7efb891b05$export$40e543e69a8b3fbb) : (0, $02ac7a7efb891b05$export$1e95b668f3b82d);
        if (referenceRect[len] > popperRect[len]) mainVariationSide = (0, $2eeb6ba489107ea4$export$2e2bcd8739ae039)(mainVariationSide);
        var altVariationSide = (0, $2eeb6ba489107ea4$export$2e2bcd8739ae039)(mainVariationSide);
        var checks = [];
        if (checkMainAxis) checks.push(overflow[_basePlacement] <= 0);
        if (checkAltAxis) checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
        if (checks.every(function(check) {
            return check;
        })) {
            firstFittingPlacement = placement;
            makeFallbackChecks = false;
            break;
        }
        checksMap.set(placement, checks);
    }
    if (makeFallbackChecks) {
        // `2` may be desired in some cases – research later
        var numberOfChecks = flipVariations ? 3 : 1;
        var _loop = function _loop(_i) {
            var fittingPlacement = placements.find(function(placement) {
                var checks = checksMap.get(placement);
                if (checks) return checks.slice(0, _i).every(function(check) {
                    return check;
                });
            });
            if (fittingPlacement) {
                firstFittingPlacement = fittingPlacement;
                return "break";
            }
        };
        for(var _i = numberOfChecks; _i > 0; _i--){
            var _ret = _loop(_i);
            if (_ret === "break") break;
        }
    }
    if (state.placement !== firstFittingPlacement) {
        state.modifiersData[name]._skip = true;
        state.placement = firstFittingPlacement;
        state.reset = true;
    }
} // eslint-disable-next-line import/no-unused-modules
var $a8d612a7f4de3fca$export$2e2bcd8739ae039 = {
    name: 'flip',
    enabled: true,
    phase: 'main',
    fn: $a8d612a7f4de3fca$var$flip,
    requiresIfExists: [
        'offset'
    ],
    data: {
        _skip: false
    }
};





function $1d862fcd66e44014$export$2e2bcd8739ae039(axis) {
    return axis === 'x' ? 'y' : 'x';
}



function $8124b495417018b8$export$f28d906d67a997f3(min, value, max) {
    return (0, $f060345502b6b7d0$export$8960430cfd85939f)(min, (0, $f060345502b6b7d0$export$96ec731ed4dcb222)(value, max));
}
function $8124b495417018b8$export$86c8af6d3ef0b4a(min, value, max) {
    var v = $8124b495417018b8$export$f28d906d67a997f3(min, value, max);
    return v > max ? max : v;
}








function $ca1d8fd29157d544$var$preventOverflow(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, padding = options.padding, _options$tether = options.tether, tether = _options$tether === void 0 ? true : _options$tether, _options$tetherOffset = options.tetherOffset, tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
    var overflow = (0, $76513b0dab162e77$export$2e2bcd8739ae039)(state, {
        boundary: boundary,
        rootBoundary: rootBoundary,
        padding: padding,
        altBoundary: altBoundary
    });
    var basePlacement = (0, $41a74276d1437cf3$export$2e2bcd8739ae039)(state.placement);
    var variation = (0, $dea175e1fbb039f4$export$2e2bcd8739ae039)(state.placement);
    var isBasePlacement = !variation;
    var mainAxis = (0, $73e81d9ee133d820$export$2e2bcd8739ae039)(basePlacement);
    var altAxis = (0, $1d862fcd66e44014$export$2e2bcd8739ae039)(mainAxis);
    var popperOffsets = state.modifiersData.popperOffsets;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var tetherOffsetValue = typeof tetherOffset === 'function' ? tetherOffset(Object.assign({}, state.rects, {
        placement: state.placement
    })) : tetherOffset;
    var normalizedTetherOffsetValue = typeof tetherOffsetValue === 'number' ? {
        mainAxis: tetherOffsetValue,
        altAxis: tetherOffsetValue
    } : Object.assign({
        mainAxis: 0,
        altAxis: 0
    }, tetherOffsetValue);
    var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
    var data = {
        x: 0,
        y: 0
    };
    if (!popperOffsets) return;
    if (checkMainAxis) {
        var _offsetModifierState$;
        var mainSide = mainAxis === 'y' ? (0, $02ac7a7efb891b05$export$1e95b668f3b82d) : (0, $02ac7a7efb891b05$export$eabcd2c8791e7bf4);
        var altSide = mainAxis === 'y' ? (0, $02ac7a7efb891b05$export$40e543e69a8b3fbb) : (0, $02ac7a7efb891b05$export$79ffe56a765070d2);
        var len = mainAxis === 'y' ? 'height' : 'width';
        var offset = popperOffsets[mainAxis];
        var min = offset + overflow[mainSide];
        var max = offset - overflow[altSide];
        var additive = tether ? -popperRect[len] / 2 : 0;
        var minLen = variation === (0, $02ac7a7efb891b05$export$b3571188c770cc5a) ? referenceRect[len] : popperRect[len];
        var maxLen = variation === (0, $02ac7a7efb891b05$export$b3571188c770cc5a) ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
        // outside the reference bounds
        var arrowElement = state.elements.arrow;
        var arrowRect = tether && arrowElement ? (0, $940b5b44ec492788$export$2e2bcd8739ae039)(arrowElement) : {
            width: 0,
            height: 0
        };
        var arrowPaddingObject = state.modifiersData['arrow#persistent'] ? state.modifiersData['arrow#persistent'].padding : (0, $9f77d3f4875fb909$export$2e2bcd8739ae039)();
        var arrowPaddingMin = arrowPaddingObject[mainSide];
        var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
        // to include its full size in the calculation. If the reference is small
        // and near the edge of a boundary, the popper can overflow even if the
        // reference is not overflowing as well (e.g. virtual elements with no
        // width or height)
        var arrowLen = (0, $8124b495417018b8$export$f28d906d67a997f3)(0, referenceRect[len], arrowRect[len]);
        var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
        var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
        var arrowOffsetParent = state.elements.arrow && (0, $80e068c783f2bee0$export$2e2bcd8739ae039)(state.elements.arrow);
        var clientOffset = arrowOffsetParent ? mainAxis === 'y' ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
        var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
        var tetherMin = offset + minOffset - offsetModifierValue - clientOffset;
        var tetherMax = offset + maxOffset - offsetModifierValue;
        var preventedOffset = (0, $8124b495417018b8$export$f28d906d67a997f3)(tether ? (0, $f060345502b6b7d0$export$96ec731ed4dcb222)(min, tetherMin) : min, offset, tether ? (0, $f060345502b6b7d0$export$8960430cfd85939f)(max, tetherMax) : max);
        popperOffsets[mainAxis] = preventedOffset;
        data[mainAxis] = preventedOffset - offset;
    }
    if (checkAltAxis) {
        var _offsetModifierState$2;
        var _mainSide = mainAxis === 'x' ? (0, $02ac7a7efb891b05$export$1e95b668f3b82d) : (0, $02ac7a7efb891b05$export$eabcd2c8791e7bf4);
        var _altSide = mainAxis === 'x' ? (0, $02ac7a7efb891b05$export$40e543e69a8b3fbb) : (0, $02ac7a7efb891b05$export$79ffe56a765070d2);
        var _offset = popperOffsets[altAxis];
        var _len = altAxis === 'y' ? 'height' : 'width';
        var _min = _offset + overflow[_mainSide];
        var _max = _offset - overflow[_altSide];
        var isOriginSide = [
            (0, $02ac7a7efb891b05$export$1e95b668f3b82d),
            (0, $02ac7a7efb891b05$export$eabcd2c8791e7bf4)
        ].indexOf(basePlacement) !== -1;
        var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;
        var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;
        var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;
        var _preventedOffset = tether && isOriginSide ? (0, $8124b495417018b8$export$86c8af6d3ef0b4a)(_tetherMin, _offset, _tetherMax) : (0, $8124b495417018b8$export$f28d906d67a997f3)(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);
        popperOffsets[altAxis] = _preventedOffset;
        data[altAxis] = _preventedOffset - _offset;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $ca1d8fd29157d544$export$2e2bcd8739ae039 = {
    name: 'preventOverflow',
    enabled: true,
    phase: 'main',
    fn: $ca1d8fd29157d544$var$preventOverflow,
    requiresIfExists: [
        'offset'
    ]
};











var $14141253d5c51d60$var$toPaddingObject = function toPaddingObject(padding, state) {
    padding = typeof padding === 'function' ? padding(Object.assign({}, state.rects, {
        placement: state.placement
    })) : padding;
    return (0, $0f8bbf2cee5893df$export$2e2bcd8739ae039)(typeof padding !== 'number' ? padding : (0, $521ed68a58dda134$export$2e2bcd8739ae039)(padding, (0, $02ac7a7efb891b05$export$aec2ce47c367b8c3)));
};
function $14141253d5c51d60$var$arrow(_ref) {
    var _state$modifiersData$;
    var state = _ref.state, name = _ref.name, options = _ref.options;
    var arrowElement = state.elements.arrow;
    var popperOffsets = state.modifiersData.popperOffsets;
    var basePlacement = (0, $41a74276d1437cf3$export$2e2bcd8739ae039)(state.placement);
    var axis = (0, $73e81d9ee133d820$export$2e2bcd8739ae039)(basePlacement);
    var isVertical = [
        (0, $02ac7a7efb891b05$export$eabcd2c8791e7bf4),
        (0, $02ac7a7efb891b05$export$79ffe56a765070d2)
    ].indexOf(basePlacement) >= 0;
    var len = isVertical ? 'height' : 'width';
    if (!arrowElement || !popperOffsets) return;
    var paddingObject = $14141253d5c51d60$var$toPaddingObject(options.padding, state);
    var arrowRect = (0, $940b5b44ec492788$export$2e2bcd8739ae039)(arrowElement);
    var minProp = axis === 'y' ? (0, $02ac7a7efb891b05$export$1e95b668f3b82d) : (0, $02ac7a7efb891b05$export$eabcd2c8791e7bf4);
    var maxProp = axis === 'y' ? (0, $02ac7a7efb891b05$export$40e543e69a8b3fbb) : (0, $02ac7a7efb891b05$export$79ffe56a765070d2);
    var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
    var startDiff = popperOffsets[axis] - state.rects.reference[axis];
    var arrowOffsetParent = (0, $80e068c783f2bee0$export$2e2bcd8739ae039)(arrowElement);
    var clientSize = arrowOffsetParent ? axis === 'y' ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
    var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
    // outside of the popper bounds
    var min = paddingObject[minProp];
    var max = clientSize - arrowRect[len] - paddingObject[maxProp];
    var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
    var offset = (0, $8124b495417018b8$export$f28d906d67a997f3)(min, center, max); // Prevents breaking syntax highlighting...
    var axisProp = axis;
    state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
}
function $14141253d5c51d60$var$effect(_ref2) {
    var state = _ref2.state, options = _ref2.options;
    var _options$element = options.element, arrowElement = _options$element === void 0 ? '[data-popper-arrow]' : _options$element;
    if (arrowElement == null) return;
     // CSS selector
    if (typeof arrowElement === 'string') {
        arrowElement = state.elements.popper.querySelector(arrowElement);
        if (!arrowElement) return;
    }
    if (!(0, $f16668aaebdec374$export$2e2bcd8739ae039)(state.elements.popper, arrowElement)) return;
    state.elements.arrow = arrowElement;
} // eslint-disable-next-line import/no-unused-modules
var $14141253d5c51d60$export$2e2bcd8739ae039 = {
    name: 'arrow',
    enabled: true,
    phase: 'main',
    fn: $14141253d5c51d60$var$arrow,
    effect: $14141253d5c51d60$var$effect,
    requires: [
        'popperOffsets'
    ],
    requiresIfExists: [
        'preventOverflow'
    ]
};




function $caae528698324902$var$getSideOffsets(overflow, rect, preventedOffsets) {
    if (preventedOffsets === void 0) preventedOffsets = {
        x: 0,
        y: 0
    };
    return {
        top: overflow.top - rect.height - preventedOffsets.y,
        right: overflow.right - rect.width + preventedOffsets.x,
        bottom: overflow.bottom - rect.height + preventedOffsets.y,
        left: overflow.left - rect.width - preventedOffsets.x
    };
}
function $caae528698324902$var$isAnySideFullyClipped(overflow) {
    return [
        (0, $02ac7a7efb891b05$export$1e95b668f3b82d),
        (0, $02ac7a7efb891b05$export$79ffe56a765070d2),
        (0, $02ac7a7efb891b05$export$40e543e69a8b3fbb),
        (0, $02ac7a7efb891b05$export$eabcd2c8791e7bf4)
    ].some(function(side) {
        return overflow[side] >= 0;
    });
}
function $caae528698324902$var$hide(_ref) {
    var state = _ref.state, name = _ref.name;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var preventedOffsets = state.modifiersData.preventOverflow;
    var referenceOverflow = (0, $76513b0dab162e77$export$2e2bcd8739ae039)(state, {
        elementContext: 'reference'
    });
    var popperAltOverflow = (0, $76513b0dab162e77$export$2e2bcd8739ae039)(state, {
        altBoundary: true
    });
    var referenceClippingOffsets = $caae528698324902$var$getSideOffsets(referenceOverflow, referenceRect);
    var popperEscapeOffsets = $caae528698324902$var$getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
    var isReferenceHidden = $caae528698324902$var$isAnySideFullyClipped(referenceClippingOffsets);
    var hasPopperEscaped = $caae528698324902$var$isAnySideFullyClipped(popperEscapeOffsets);
    state.modifiersData[name] = {
        referenceClippingOffsets: referenceClippingOffsets,
        popperEscapeOffsets: popperEscapeOffsets,
        isReferenceHidden: isReferenceHidden,
        hasPopperEscaped: hasPopperEscaped
    };
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        'data-popper-reference-hidden': isReferenceHidden,
        'data-popper-escaped': hasPopperEscaped
    });
} // eslint-disable-next-line import/no-unused-modules
var $caae528698324902$export$2e2bcd8739ae039 = {
    name: 'hide',
    enabled: true,
    phase: 'main',
    requiresIfExists: [
        'preventOverflow'
    ],
    fn: $caae528698324902$var$hide
};




var $d07b3555e5780154$export$d34966752335dd47 = [
    (0, $06f218a851c306cc$export$2e2bcd8739ae039),
    (0, $e0ca49ea984cd711$export$2e2bcd8739ae039),
    (0, $638a36f4ddb5d6c8$export$2e2bcd8739ae039),
    (0, $69e846f9616ad096$export$2e2bcd8739ae039),
    (0, $f7552b997e91c31f$export$2e2bcd8739ae039),
    (0, $a8d612a7f4de3fca$export$2e2bcd8739ae039),
    (0, $ca1d8fd29157d544$export$2e2bcd8739ae039),
    (0, $14141253d5c51d60$export$2e2bcd8739ae039),
    (0, $caae528698324902$export$2e2bcd8739ae039)
];
var $d07b3555e5780154$export$8f7491d57c8f97a9 = /*#__PURE__*/ (0, $bf58442f71e0a59e$export$ed5e13716264f202)({
    defaultModifiers: $d07b3555e5780154$export$d34966752335dd47
}); // eslint-disable-next-line import/no-unused-modules


var $99c19f4408065da5$exports = {};
/* global Map:readonly, Set:readonly, ArrayBuffer:readonly */ var $99c19f4408065da5$var$hasElementType = typeof Element !== 'undefined';
var $99c19f4408065da5$var$hasMap = typeof Map === 'function';
var $99c19f4408065da5$var$hasSet = typeof Set === 'function';
var $99c19f4408065da5$var$hasArrayBuffer = typeof ArrayBuffer === 'function' && !!ArrayBuffer.isView;
// Note: We **don't** need `envHasBigInt64Array` in fde es6/index.js
function $99c19f4408065da5$var$equal(a, b) {
    // START: fast-deep-equal es6/index.js 3.1.3
    if (a === b) return true;
    if (a && b && typeof a == 'object' && typeof b == 'object') {
        if (a.constructor !== b.constructor) return false;
        var length, i, keys;
        if (Array.isArray(a)) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (!$99c19f4408065da5$var$equal(a[i], b[i])) return false;
            return true;
        }
        // START: Modifications:
        // 1. Extra `has<Type> &&` helpers in initial condition allow es6 code
        //    to co-exist with es5.
        // 2. Replace `for of` with es5 compliant iteration using `for`.
        //    Basically, take:
        //
        //    ```js
        //    for (i of a.entries())
        //      if (!b.has(i[0])) return false;
        //    ```
        //
        //    ... and convert to:
        //
        //    ```js
        //    it = a.entries();
        //    while (!(i = it.next()).done)
        //      if (!b.has(i.value[0])) return false;
        //    ```
        //
        //    **Note**: `i` access switches to `i.value`.
        var it;
        if ($99c19f4408065da5$var$hasMap && a instanceof Map && b instanceof Map) {
            if (a.size !== b.size) return false;
            it = a.entries();
            while(!(i = it.next()).done)if (!b.has(i.value[0])) return false;
            it = a.entries();
            while(!(i = it.next()).done)if (!$99c19f4408065da5$var$equal(i.value[1], b.get(i.value[0]))) return false;
            return true;
        }
        if ($99c19f4408065da5$var$hasSet && a instanceof Set && b instanceof Set) {
            if (a.size !== b.size) return false;
            it = a.entries();
            while(!(i = it.next()).done)if (!b.has(i.value[0])) return false;
            return true;
        }
        // END: Modifications
        if ($99c19f4408065da5$var$hasArrayBuffer && ArrayBuffer.isView(a) && ArrayBuffer.isView(b)) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (a[i] !== b[i]) return false;
            return true;
        }
        if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
        // START: Modifications:
        // Apply guards for `Object.create(null)` handling. See:
        // - https://github.com/FormidableLabs/react-fast-compare/issues/64
        // - https://github.com/epoberezkin/fast-deep-equal/issues/49
        if (a.valueOf !== Object.prototype.valueOf && typeof a.valueOf === 'function' && typeof b.valueOf === 'function') return a.valueOf() === b.valueOf();
        if (a.toString !== Object.prototype.toString && typeof a.toString === 'function' && typeof b.toString === 'function') return a.toString() === b.toString();
        // END: Modifications
        keys = Object.keys(a);
        length = keys.length;
        if (length !== Object.keys(b).length) return false;
        for(i = length; i-- !== 0;)if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
        // END: fast-deep-equal
        // START: react-fast-compare
        // custom handling for DOM elements
        if ($99c19f4408065da5$var$hasElementType && a instanceof Element) return false;
        // custom handling for React/Preact
        for(i = length; i-- !== 0;){
            if ((keys[i] === '_owner' || keys[i] === '__v' || keys[i] === '__o') && a.$$typeof) continue;
            // all other properties should be traversed as usual
            if (!$99c19f4408065da5$var$equal(a[keys[i]], b[keys[i]])) return false;
        }
        // END: react-fast-compare
        // START: fast-deep-equal
        return true;
    }
    return a !== a && b !== b;
}
// end fast-deep-equal
$99c19f4408065da5$exports = function isEqual(a, b) {
    try {
        return $99c19f4408065da5$var$equal(a, b);
    } catch (error) {
        if ((error.message || '').match(/stack|recursion/i)) {
            // warn on circular references, don't crash
            // browsers give this different errors name and messages:
            // chrome/safari: "RangeError", "Maximum call stack size exceeded"
            // firefox: "InternalError", too much recursion"
            // edge: "Error", "Out of stack space"
            console.warn('react-fast-compare cannot handle circular refs');
            return false;
        }
        // some other error. we should definitely know about these
        throw error;
    }
};



var $0ca28497a8a04ea7$var$EMPTY_MODIFIERS = [];
var $0ca28497a8a04ea7$export$f4d5bf230a36dd6e = function usePopper(referenceElement, popperElement, options) {
    if (options === void 0) options = {};
    var prevOptions = $5FkrB.useRef(null);
    var optionsWithDefaults = {
        onFirstUpdate: options.onFirstUpdate,
        placement: options.placement || 'bottom',
        strategy: options.strategy || 'absolute',
        modifiers: options.modifiers || $0ca28497a8a04ea7$var$EMPTY_MODIFIERS
    };
    var _React$useState = $5FkrB.useState({
        styles: {
            popper: {
                position: optionsWithDefaults.strategy,
                left: '0',
                top: '0'
            },
            arrow: {
                position: 'absolute'
            }
        },
        attributes: {}
    }), state = _React$useState[0], setState = _React$useState[1];
    var updateStateModifier = $5FkrB.useMemo(function() {
        return {
            name: 'updateState',
            enabled: true,
            phase: 'write',
            fn: function fn(_ref) {
                var state = _ref.state;
                var elements = Object.keys(state.elements);
                $7d59b24134129acf$exports.flushSync(function() {
                    setState({
                        styles: (0, $51ef3a8e2c42379b$export$5150077fc2e7c662)(elements.map(function(element) {
                            return [
                                element,
                                state.styles[element] || {}
                            ];
                        })),
                        attributes: (0, $51ef3a8e2c42379b$export$5150077fc2e7c662)(elements.map(function(element) {
                            return [
                                element,
                                state.attributes[element]
                            ];
                        }))
                    });
                });
            },
            requires: [
                'computeStyles'
            ]
        };
    }, []);
    var popperOptions = $5FkrB.useMemo(function() {
        var newOptions = {
            onFirstUpdate: optionsWithDefaults.onFirstUpdate,
            placement: optionsWithDefaults.placement,
            strategy: optionsWithDefaults.strategy,
            modifiers: [].concat(optionsWithDefaults.modifiers, [
                updateStateModifier,
                {
                    name: 'applyStyles',
                    enabled: false
                }
            ])
        };
        if ((0, (/*@__PURE__*/$parcel$interopDefault($99c19f4408065da5$exports)))(prevOptions.current, newOptions)) return prevOptions.current || newOptions;
        else {
            prevOptions.current = newOptions;
            return newOptions;
        }
    }, [
        optionsWithDefaults.onFirstUpdate,
        optionsWithDefaults.placement,
        optionsWithDefaults.strategy,
        optionsWithDefaults.modifiers,
        updateStateModifier
    ]);
    var popperInstanceRef = $5FkrB.useRef();
    (0, $51ef3a8e2c42379b$export$700979bc83e7db82)(function() {
        if (popperInstanceRef.current) popperInstanceRef.current.setOptions(popperOptions);
    }, [
        popperOptions
    ]);
    (0, $51ef3a8e2c42379b$export$700979bc83e7db82)(function() {
        if (referenceElement == null || popperElement == null) return;
        var createPopper = options.createPopper || (0, $d07b3555e5780154$export$8f7491d57c8f97a9);
        var popperInstance = createPopper(referenceElement, popperElement, popperOptions);
        popperInstanceRef.current = popperInstance;
        return function() {
            popperInstance.destroy();
            popperInstanceRef.current = null;
        };
    }, [
        referenceElement,
        popperElement,
        options.createPopper
    ]);
    return {
        state: popperInstanceRef.current ? popperInstanceRef.current.state : null,
        styles: state.styles,
        attributes: state.attributes,
        update: popperInstanceRef.current ? popperInstanceRef.current.update : null,
        forceUpdate: popperInstanceRef.current ? popperInstanceRef.current.forceUpdate : null
    };
};


var $f9e8ed8665cc0109$var$NOOP = function NOOP() {
    return void 0;
};
var $f9e8ed8665cc0109$var$NOOP_PROMISE = function NOOP_PROMISE() {
    return Promise.resolve(null);
};
var $f9e8ed8665cc0109$var$EMPTY_MODIFIERS = [];
function $f9e8ed8665cc0109$export$badac9ada3a0bdf9(_ref) {
    var _ref$placement = _ref.placement, placement = _ref$placement === void 0 ? 'bottom' : _ref$placement, _ref$strategy = _ref.strategy, strategy = _ref$strategy === void 0 ? 'absolute' : _ref$strategy, _ref$modifiers = _ref.modifiers, modifiers = _ref$modifiers === void 0 ? $f9e8ed8665cc0109$var$EMPTY_MODIFIERS : _ref$modifiers, referenceElement = _ref.referenceElement, onFirstUpdate = _ref.onFirstUpdate, innerRef = _ref.innerRef, children = _ref.children;
    var referenceNode = $5FkrB.useContext((0, $cc0477161a7a3c78$export$3dbd3405086fec7b));
    var _React$useState = $5FkrB.useState(null), popperElement = _React$useState[0], setPopperElement = _React$useState[1];
    var _React$useState2 = $5FkrB.useState(null), arrowElement = _React$useState2[0], setArrowElement = _React$useState2[1];
    $5FkrB.useEffect(function() {
        (0, $51ef3a8e2c42379b$export$4bb192c7cacf928f)(innerRef, popperElement);
    }, [
        innerRef,
        popperElement
    ]);
    var options = $5FkrB.useMemo(function() {
        return {
            placement: placement,
            strategy: strategy,
            onFirstUpdate: onFirstUpdate,
            modifiers: [].concat(modifiers, [
                {
                    name: 'arrow',
                    enabled: arrowElement != null,
                    options: {
                        element: arrowElement
                    }
                }
            ])
        };
    }, [
        placement,
        strategy,
        onFirstUpdate,
        modifiers,
        arrowElement
    ]);
    var _usePopper = (0, $0ca28497a8a04ea7$export$f4d5bf230a36dd6e)(referenceElement || referenceNode, popperElement, options), state = _usePopper.state, styles = _usePopper.styles, forceUpdate = _usePopper.forceUpdate, update = _usePopper.update;
    var childrenProps = $5FkrB.useMemo(function() {
        return {
            ref: setPopperElement,
            style: styles.popper,
            placement: state ? state.placement : placement,
            hasPopperEscaped: state && state.modifiersData.hide ? state.modifiersData.hide.hasPopperEscaped : null,
            isReferenceHidden: state && state.modifiersData.hide ? state.modifiersData.hide.isReferenceHidden : null,
            arrowProps: {
                style: styles.arrow,
                ref: setArrowElement
            },
            forceUpdate: forceUpdate || $f9e8ed8665cc0109$var$NOOP,
            update: update || $f9e8ed8665cc0109$var$NOOP_PROMISE
        };
    }, [
        setPopperElement,
        setArrowElement,
        placement,
        state,
        styles,
        update,
        forceUpdate
    ]);
    return (0, $51ef3a8e2c42379b$export$f52c55943429c8b6)(children)(childrenProps);
}



var $50U6m = parcelRequire("50U6m");

function $ed28843bb38c002b$export$6d8c2b45c99d6e3f(_ref) {
    var viewportPadding = _ref.viewportPadding;
    return [
        {
            /**
     * Performing DOM measurements in the 'read' phase,
     * which is the convention for popper modifiers
     */ name: 'maxSizeData',
            enabled: true,
            phase: 'read',
            fn: function fn(_ref2) {
                var state = _ref2.state, name = _ref2.name;
                if (!window.visualViewport) return;
                state.modifiersData[name] = {
                    viewport: {
                        width: window.visualViewport.width,
                        height: window.visualViewport.height
                    }
                };
            }
        },
        {
            /**
     * Applying max size CSS
     */ name: 'maxSize',
            enabled: true,
            phase: 'beforeWrite',
            requiresIfExists: [
                'offset',
                'preventOverflow',
                'flip'
            ],
            fn: function fn(_ref3) {
                var _data$viewport, _data$viewport2, _state$modifiersData$2, _state$modifiersData;
                var state = _ref3.state;
                var data = state.modifiersData.maxSizeData;
                if (typeof (data === null || data === void 0 || (_data$viewport = data.viewport) === null || _data$viewport === void 0 ? void 0 : _data$viewport.width) !== 'number' || typeof (data === null || data === void 0 || (_data$viewport2 = data.viewport) === null || _data$viewport2 === void 0 ? void 0 : _data$viewport2.height) !== 'number') // This shouldn't occur in a real browser but might in non-browser test environments
                return;
                var viewport = data.viewport;
                var _state$modifiersData$ = state.modifiersData.popperOffsets, popperOffsets = _state$modifiersData$ === void 0 ? {
                    x: 0,
                    y: 0
                } : _state$modifiersData$;
                var _state$placement$spli = state.placement.split('-'), _state$placement$spli2 = (0, $0a1610bce965fec6$export$2e2bcd8739ae039)(_state$placement$spli, 1), basePlacement = _state$placement$spli2[0];
                var placementOffset = (_state$modifiersData$2 = (_state$modifiersData = state.modifiersData) === null || _state$modifiersData === void 0 || (_state$modifiersData = _state$modifiersData.offset) === null || _state$modifiersData === void 0 ? void 0 : _state$modifiersData[state.placement]) !== null && _state$modifiersData$2 !== void 0 ? _state$modifiersData$2 : {
                    x: 0,
                    y: 0
                };
                // By default we set these to the entire viewport (minus padding)
                // Each placement direction will overwrite one of these
                var maxWidth = viewport.width - 2 * viewportPadding;
                var maxHeight = viewport.height - 2 * viewportPadding;
                if (basePlacement === 'top') maxHeight = state.rects.reference.y + // Viewport-relative position of reference element
                placementOffset.y - // Space between popper and reference
                viewportPadding;
                if (basePlacement === 'bottom') maxHeight = viewport.height - popperOffsets.y - // Viewport-relative position of popper
                viewportPadding;
                if (basePlacement === 'left') maxWidth = state.rects.reference.x + // Viewport-relative position of reference element
                placementOffset.x - // Space between popper and reference
                viewportPadding;
                if (basePlacement === 'right') maxWidth = viewport.width - popperOffsets.x - // Viewport-relative position of popper
                viewportPadding;
                state.styles.popper.maxWidth = "".concat(maxWidth, "px");
                state.styles.popper.maxHeight = "".concat(maxHeight, "px");
            }
        }
    ];
}


/* popper-top-layer.tsx generated by @compiled/babel-plugin v2.0.0 */ 


var $5FkrB = parcelRequire("5FkrB");

function $62332edf1b2ba10e$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $62332edf1b2ba10e$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $62332edf1b2ba10e$export$2e2bcd8739ae039(o);
}



function $d2e80144c75981ce$export$2e2bcd8739ae039(t, r) {
    if ("object" != (0, $62332edf1b2ba10e$export$2e2bcd8739ae039)(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (0, $62332edf1b2ba10e$export$2e2bcd8739ae039)(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}


function $602bbe61538a474f$export$2e2bcd8739ae039(t) {
    var i = (0, $d2e80144c75981ce$export$2e2bcd8739ae039)(t, "string");
    return "symbol" == (0, $62332edf1b2ba10e$export$2e2bcd8739ae039)(i) ? i : i + "";
}


function $a1d7bec1841415cd$export$2e2bcd8739ae039(e, r, t) {
    return (r = (0, $602bbe61538a474f$export$2e2bcd8739ae039)(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}



/**
 * The full mapping record. Internal - use `fromLegacyPlacement` from the
 * public entry-point so the offset-tuple translation is applied consistently.
 *
 * Note: `auto`, `auto-start`, `auto-end` map to `block-end` placements. This
 * is a reduction in expressiveness vs Popper.js (which picked the best
 * placement at runtime). CSS `position-try-fallbacks` flips at the edge but
 * the initial placement is fixed. Migration consumers who relied on Popper's
 * dynamic auto-flip should pick an explicit placement instead.
 */ var $e6499612008a1486$export$27df359c528b7120 = {
    top: {
        axis: 'block',
        edge: 'start',
        align: 'center'
    },
    'top-start': {
        axis: 'block',
        edge: 'start',
        align: 'start'
    },
    'top-center': {
        axis: 'block',
        edge: 'start',
        align: 'center'
    },
    'top-end': {
        axis: 'block',
        edge: 'start',
        align: 'end'
    },
    bottom: {
        axis: 'block',
        edge: 'end',
        align: 'center'
    },
    'bottom-start': {
        axis: 'block',
        edge: 'end',
        align: 'start'
    },
    'bottom-center': {
        axis: 'block',
        edge: 'end',
        align: 'center'
    },
    'bottom-end': {
        axis: 'block',
        edge: 'end',
        align: 'end'
    },
    right: {
        axis: 'inline',
        edge: 'end',
        align: 'center'
    },
    'right-start': {
        axis: 'inline',
        edge: 'end',
        align: 'start'
    },
    'right-end': {
        axis: 'inline',
        edge: 'end',
        align: 'end'
    },
    left: {
        axis: 'inline',
        edge: 'start',
        align: 'center'
    },
    'left-start': {
        axis: 'inline',
        edge: 'start',
        align: 'start'
    },
    'left-end': {
        axis: 'inline',
        edge: 'start',
        align: 'end'
    },
    auto: {
        axis: 'block',
        edge: 'end',
        align: 'center'
    },
    'auto-start': {
        axis: 'block',
        edge: 'end',
        align: 'start'
    },
    'auto-end': {
        axis: 'block',
        edge: 'end',
        align: 'end'
    }
};


function $2ac73d5cb9e11b1f$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $2ac73d5cb9e11b1f$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $2ac73d5cb9e11b1f$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $a1d7bec1841415cd$export$2e2bcd8739ae039)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $2ac73d5cb9e11b1f$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $2ac73d5cb9e11b1f$export$69e99ed50b2534c9(_ref) {
    var legacy = _ref.legacy, offset = _ref.offset;
    var basePlacement = (0, $e6499612008a1486$export$27df359c528b7120)[legacy];
    if (!offset) return basePlacement;
    var _offset = (0, $0a1610bce965fec6$export$2e2bcd8739ae039)(offset, 2), along = _offset[0], away = _offset[1];
    return $2ac73d5cb9e11b1f$var$_objectSpread($2ac73d5cb9e11b1f$var$_objectSpread({}, basePlacement), {}, {
        offset: {
            gap: away,
            crossAxisShift: {
                // Sign is captured in `direction`; `value` is the magnitude.
                value: Math.abs(along),
                direction: along >= 0 ? 'forwards' : 'backwards'
            }
        }
    });
}


/* popover.tsx generated by @compiled/babel-plugin v2.0.0 */ /**
 * The length of the value hash portion of an atomic class name.
 * Atomic class names have the format: `_<group><value>`
 * where group is ATOMIC_GROUP_HASH_LENGTH chars and value is ATOMIC_VALUE_HASH_LENGTH chars.
 *
 * We extract the group key using: `className.slice(0, className.length - ATOMIC_VALUE_HASH_LENGTH)`
 *
 * We support both old-format classes (9 chars: `_` + 4 group + 4 value) and
 * new-format classes (11 chars: `_` + 6 group + 4 value) by using length-based
 * extraction rather than a hardcoded offset — old and new format group keys
 * are different lengths so they are structurally disjoint and never alias each other.
 */ const $7307d36558082be8$var$ATOMIC_VALUE_HASH_LENGTH = 4;
function $7307d36558082be8$export$2e2bcd8739ae039(classNames) {
    // Shortcut: nothing to do
    if (!classNames.length) return;
    // Shortcut: don't need to do anything if we only have a single classname
    if (classNames.length === 1 && classNames[0] && // checking to see if `classNames[0]` is a string that contains other classnames
    !classNames[0].includes(' ')) return classNames[0];
    // Using an object rather than a `Map` as it performed better in our benchmarks.
    // Would be happy to move to `Map` if it proved to be better under real conditions.
    const map = {};
    // Note: using loops to minimize iterations over the collection
    for (const value of classNames){
        // Exclude all falsy values, which leaves us with populated strings
        if (!value) continue;
        // a `value` can contain multiple classnames
        const list = value.split(' ');
        for (const className of list){
            /**
             * For atomic style classnames: the `key` is the `group`
             *
             * - Later atomic classnames with the same `group` will override earlier ones
             *   (which is what we want).
             * - Assumes atomic classnames are the only things that start with `_`
             * - Could use a regex to ensure that atomic classnames are structured how we expect,
             *   but did not add that for now as it did slow things down a bit.
             *
             * For other classnames: the `key` is the whole classname
             * - Okay to remove duplicates as doing so does not impact specificity
             *
             * */ const key = className.startsWith('_') ? className.slice(0, className.length - $7307d36558082be8$var$ATOMIC_VALUE_HASH_LENGTH) : className;
            map[key] = className;
        }
    }
    /**
     * We are converting the `map` into a string.
     *
     * The simple way to do this would be `Object.values(map).join(' ')`.
     * However, the approach below performs 10%-20% better in benchmarks.
     *
     * For `ax()` it feels right to squeeze as much runtime performance out as we can.
     */ let result = '';
    for(const key in map)result += map[key] + ' ';
    // If we have an empty string, then our `map` was empty.
    if (!result) return;
    // remove last " " from the result (we added " " at the end of every value)
    return result.trimEnd();
}



var $5FkrB = parcelRequire("5FkrB");

const $4582e111535cefd2$export$a274e22fb40f762e = (...styles)=>{
    // At runtime TStyles is resolved down to strings, but not at compile time.
    // We circumvent the type system here because of that.
    const actualStyles = styles;
    // The output should be a union type of passed in styles. This ensures the call
    // site of xcss prop can raise violations when disallowed styles have been passed.
    return (0, $7307d36558082be8$export$2e2bcd8739ae039)(actualStyles);
};




/**
 * Creates a new function that will cache the result of it's first call.
 *
 * ```ts
 * function sayHello(name: string): string {
 *   return `Hello ${name}`;
 * }
 * const cached = once(sayHello);
 *
 * cached('Alex'); // returns "Hello Alex"
 * cached('Sam'); // returns "Hello Alex" (underlying `sayHello` function not called)
 * ```
 *
 * **Notes**
 *
 * - If the `onced` function throws, then the return value of the function is not cached
 * - Respects call site context (`this`) when executing the onced function
 */ function $86089df3a0fd54eb$export$2e2bcd8739ae039(fn) {
    var cache = null;
    return function result() {
        if (!cache) {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            cache = {
                value: fn.call.apply(fn, [
                    this
                ].concat(args))
            };
        }
        /**
     * Intentionally not adding `.clear()` function property
     *
     * - We currently have no need for it
     * - We don't want to add a `.clear()` to functions that should never be called twice,
     *   for example: `cleanup` functions.
     * - We can add a `onceWithCleanup` variant as a separate export from ds-lib if the
     *   need arises 🧘
     */ return cache.value;
    };
}



var $5FkrB = parcelRequire("5FkrB");

var $5FkrB = parcelRequire("5FkrB");
var $b1a593a8828d8f20$export$5fbf4d7fae6cdc00 = /*#__PURE__*/ (0, $5FkrB.createContext)(null);



var $5FkrB = parcelRequire("5FkrB");

var $5FkrB = parcelRequire("5FkrB");
var $6280789573ef57cc$export$644a49f3b8c50fcd = /*#__PURE__*/ (0, $5FkrB.createContext)(null);


function $5d9dbe83d025de57$export$1d57e79091cc3046() {
    var namespace = (0, $5FkrB.useContext)((0, $6280789573ef57cc$export$644a49f3b8c50fcd));
    return namespace;
}


function $36867d1ee34deccb$export$469bb693f11edc7f(_ref) {
    var isOpen = _ref.isOpen, type = _ref.type, onClose = _ref.onClose;
    var context = (0, $5FkrB.useContext)((0, $b1a593a8828d8f20$export$5fbf4d7fae6cdc00));
    var namespace = (0, $5d9dbe83d025de57$export$1d57e79091cc3046)();
    (0, $5FkrB.useEffect)(function() {
        /**
     * Registers the `onClose` callback with the OpenLayerObserver.
     */ if (context === null) return;
        if (!isOpen) /**
       * If the layer is not open, we are not registering the `onClose` callback.
       * This is important to prevent the `onClose` from being called for layers that
       * are not open.
       *
       * Some consumers mistakenly pass "toggle" functions to `onClose` callbacks for
       * layer components, as Popup, e.g. `onClose={() => setIsOpen(!isOpen)}`.
       */ return;
        return context.onClose(onClose, {
            namespace: namespace,
            type: type
        });
    }, [
        context,
        isOpen,
        namespace,
        onClose,
        type
    ]);
}


/**
 * Normalizes an offset to a CSS length string. Numbers become `${n}px`;
 * strings pass through. Apply at the API boundary so internal code only
 * deals with strings.
 */ function $1267e01a1a8a4abc$export$63b6b0ff65d84d47(_ref) {
    var value = _ref.value;
    if (typeof value === 'number') return "".concat(value, "px");
    return value;
}


/**
 * Default gap between trigger and popover. Resolves to a design
 * token (`space.100`) so the value follows the design system's spacing
 * scale. Used when `placement.offset.gap` is not provided.
 */ var $7f3555381f07ba25$var$DEFAULT_GAP = "var(--ds-space-100, 8px)";
function $7f3555381f07ba25$export$63044d21bc3d3fa2(_ref) {
    var _placement$offset, _placement$axis, _placement$edge, _placement$align, _placement$offset$cro, _placement$offset2, _placement$offset$cro2, _placement$offset3;
    var placement = _ref.placement;
    var consumerGap = (_placement$offset = placement.offset) === null || _placement$offset === void 0 ? void 0 : _placement$offset.gap;
    return {
        axis: (_placement$axis = placement.axis) !== null && _placement$axis !== void 0 ? _placement$axis : 'block',
        edge: (_placement$edge = placement.edge) !== null && _placement$edge !== void 0 ? _placement$edge : 'end',
        align: (_placement$align = placement.align) !== null && _placement$align !== void 0 ? _placement$align : 'center',
        offset: {
            gap: consumerGap === undefined ? $7f3555381f07ba25$var$DEFAULT_GAP : (0, $1267e01a1a8a4abc$export$63b6b0ff65d84d47)({
                value: consumerGap
            }),
            crossAxisShift: {
                value: (0, $1267e01a1a8a4abc$export$63b6b0ff65d84d47)({
                    value: (_placement$offset$cro = (_placement$offset2 = placement.offset) === null || _placement$offset2 === void 0 || (_placement$offset2 = _placement$offset2.crossAxisShift) === null || _placement$offset2 === void 0 ? void 0 : _placement$offset2.value) !== null && _placement$offset$cro !== void 0 ? _placement$offset$cro : 0
                }),
                direction: (_placement$offset$cro2 = (_placement$offset3 = placement.offset) === null || _placement$offset3 === void 0 || (_placement$offset3 = _placement$offset3.crossAxisShift) === null || _placement$offset3 === void 0 ? void 0 : _placement$offset3.direction) !== null && _placement$offset$cro2 !== void 0 ? _placement$offset$cro2 : 'forwards'
            }
        }
    };
}


var $0c55285f00381bc9$var$rolesThatMoveFocus = new Set([
    'dialog',
    'alertdialog',
    'menu',
    'listbox',
    'tree',
    'grid'
]);
function $0c55285f00381bc9$export$b12adccf56228c71(_ref) {
    var role = _ref.role;
    if (!role) return false;
    return $0c55285f00381bc9$var$rolesThatMoveFocus.has(role);
}




var $5FkrB = parcelRequire("5FkrB");

var $f515cf3607dacec7$export$ff7706047246b98b = (0, $86089df3a0fd54eb$export$2e2bcd8739ae039)(function() {
    if (typeof window === 'undefined' || !('matchMedia' in window)) return false;
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
});


function $93516c96f9a01130$var$runCancellableSettlement(_ref) {
    var schedule = _ref.schedule, onSettled = _ref.onSettled;
    var isCancelled = false;
    schedule(function() {
        if (isCancelled) return;
        onSettled();
    });
    return function() {
        isCancelled = true;
    };
}
/**
 * Fires `onSettled` once all animations currently applied to `element`
 * finish or are cancelled. Returns a cleanup that prevents stale settlement.
 */ function $93516c96f9a01130$var$runOnAnimationsSettled(_ref2) {
    var element = _ref2.element, onSettled = _ref2.onSettled;
    return $93516c96f9a01130$var$runCancellableSettlement({
        onSettled: onSettled,
        schedule: function schedule(settle) {
            var _element$getAnimation, _element$getAnimation2;
            var animations = (_element$getAnimation = (_element$getAnimation2 = element.getAnimations) === null || _element$getAnimation2 === void 0 ? void 0 : _element$getAnimation2.call(element)) !== null && _element$getAnimation !== void 0 ? _element$getAnimation : [];
            Promise.allSettled(animations.map(function(animation) {
                return animation.finished;
            })).then(settle);
        }
    });
}
function $93516c96f9a01130$export$1bccb45daf07907f(_ref3) {
    var isOpen = _ref3.isOpen, shouldAnimate = _ref3.shouldAnimate, elementRef = _ref3.elementRef, onEnterFinish = _ref3.onEnterFinish, onExitFinish = _ref3.onExitFinish;
    var willAnimate = shouldAnimate && !(0, $f515cf3607dacec7$export$ff7706047246b98b)();
    var isNativeClosedRef = (0, $5FkrB.useRef)(false);
    // Promote `closed → entering`/`closed → open` synchronously during
    // render so the host element mounts in the same commit as the open
    // intent. All other transitions are driven by phase-specific effects.
    var _useState = (0, $5FkrB.useState)(function() {
        if (!isOpen) return 'closed';
        return willAnimate ? 'entering' : 'open';
    }), _useState2 = (0, $0a1610bce965fec6$export$2e2bcd8739ae039)(_useState, 2), phase = _useState2[0], setPhase = _useState2[1];
    // Rearm only after controlled state and the native lifecycle have both
    // reached closed. Resetting as soon as `isOpen` becomes false can erase a
    // closing toggle that was handled in the same React batch.
    if (!isOpen && phase === 'closed') isNativeClosedRef.current = false;
    if (isOpen && phase === 'closed' && !isNativeClosedRef.current) setPhase(willAnimate ? 'entering' : 'open');
    if (!isOpen && (phase === 'open' || phase === 'entering')) // Close intent. Move to `exiting` to gate the unmount on either
    // the exit transition (animated) or the closing toggle event
    // (non-animated). Includes interrupted entry (`entering → exiting`).
    setPhase('exiting');
    if (isOpen && phase === 'exiting' && !isNativeClosedRef.current) // Reopen mid-exit. With animation, jump back to `entering` and let
    // the entry transition restart from current visual state. Without
    // animation, jump straight to `open` (the handshake we were waiting
    // for is no longer relevant; the consumer wants the host visible
    // again synchronously).
    setPhase(willAnimate ? 'entering' : 'open');
    // Keep stable refs to the latest callbacks so effects and promise callbacks
    // always call the current callback without needing them in dependency arrays.
    var onEnterFinishRef = (0, $5FkrB.useRef)(onEnterFinish);
    onEnterFinishRef.current = onEnterFinish;
    var onExitFinishRef = (0, $5FkrB.useRef)(onExitFinish);
    onExitFinishRef.current = onExitFinish;
    // Animated entry: wait for all active animations and move to `open`.
    (0, $5FkrB.useEffect)(function() {
        if (phase !== 'entering') return;
        var element = elementRef.current;
        if (!element) return;
        return $93516c96f9a01130$var$runOnAnimationsSettled({
            element: element,
            onSettled: function onSettled() {
                var _onEnterFinishRef$cur;
                // Fire the consumer callback before transitioning phase so any
                // state the consumer reads (refs, DOM nodes) is still attached
                // in the same synchronous tick, regardless of React batching
                // semantics.
                (_onEnterFinishRef$cur = onEnterFinishRef.current) === null || _onEnterFinishRef$cur === void 0 || _onEnterFinishRef$cur.call(onEnterFinishRef);
                setPhase(function(current) {
                    return current === 'entering' ? 'open' : current;
                });
            }
        });
    }, [
        phase,
        elementRef
    ]);
    // Non-animated entry callback. The lifecycle goes `closed → open`
    // directly with no `entering` phase; fire `onEnterFinish` on that jump.
    // A previous-phase ref avoids double-firing on the animated path.
    var prevPhaseForEntryRef = (0, $5FkrB.useRef)('closed');
    (0, $5FkrB.useEffect)(function() {
        var prevPhase = prevPhaseForEntryRef.current;
        prevPhaseForEntryRef.current = phase;
        // Animated entry settle goes through `entering` and already fired
        // onEnterFinish above; only handle the non-animated direct jumps.
        if (prevPhase !== 'open' && phase === 'open' && prevPhase !== 'entering') {
            var _onEnterFinishRef$cur2;
            (_onEnterFinishRef$cur2 = onEnterFinishRef.current) === null || _onEnterFinishRef$cur2 === void 0 || _onEnterFinishRef$cur2.call(onEnterFinishRef);
        }
    }, [
        phase
    ]);
    // Animated exit: wait for all active animations, fire `onExitFinish`,
    // then move to `closed` to unmount the host.
    (0, $5FkrB.useEffect)(function() {
        if (phase !== 'exiting' || !willAnimate) return;
        var element = elementRef.current;
        if (!element) return;
        return $93516c96f9a01130$var$runOnAnimationsSettled({
            element: element,
            onSettled: function onSettled() {
                var _onExitFinishRef$curr;
                // Fire the consumer callback before transitioning phase to
                // `closed`. The phase change drives the host element unmount,
                // and consumers expect to be able to read the element (or a
                // forwarded ref to it) inside `onExitFinish`. Doing this in
                // the safe order avoids relying on React's automatic batching
                // to keep the element attached across the callback.
                (_onExitFinishRef$curr = onExitFinishRef.current) === null || _onExitFinishRef$curr === void 0 || _onExitFinishRef$curr.call(onExitFinishRef);
                setPhase(function(current) {
                    return current === 'exiting' ? 'closed' : current;
                });
            }
        });
    }, [
        phase,
        willAnimate,
        elementRef
    ]);
    // Native dismissal is authoritative. Its toggle can arrive while controlled
    // state still says open, so remember that native state and do not
    // reopen until `isOpen` has first moved to false.
    (0, $5FkrB.useLayoutEffect)(function() {
        if (phase === 'exiting' && !willAnimate && isNativeClosedRef.current) setPhase('closed');
    }, [
        phase,
        willAnimate
    ]);
    var onToggle = (0, $5FkrB.useCallback)(function(event) {
        if (event.newState === 'open') {
            isNativeClosedRef.current = false;
            return;
        }
        if (event.newState !== 'closed') return;
        isNativeClosedRef.current = true;
        setPhase(function(current) {
            if (current === 'open' || current === 'entering') return 'exiting';
            if (current === 'exiting' && !willAnimate) return 'closed';
            return current;
        });
    }, [
        willAnimate
    ]);
    // Non-animated exit callback. There are no animations to wait for, so fire
    // `onExitFinish` on the transition into `exiting` (the unmount itself
    // is gated by the closing toggle handshake above).
    var prevPhaseForExitRef = (0, $5FkrB.useRef)('closed');
    (0, $5FkrB.useEffect)(function() {
        var prevPhase = prevPhaseForExitRef.current;
        prevPhaseForExitRef.current = phase;
        // Only fire on the non-animated transition into `exiting`. The
        // animated path's `exiting → closed` settle already fires
        // `onExitFinish` from `runOnAnimationsSettled`.
        if (prevPhase !== 'exiting' && phase === 'exiting' && !willAnimate) {
            var _onExitFinishRef$curr2;
            (_onExitFinishRef$curr2 = onExitFinishRef.current) === null || _onExitFinishRef$curr2 === void 0 || _onExitFinishRef$curr2.call(onExitFinishRef);
        }
    }, [
        phase,
        willAnimate
    ]);
    return {
        phase: phase,
        onToggle: onToggle
    };
}



var $5FkrB = parcelRequire("5FkrB");

var $5634fc0d1bb51a5d$var$topLayerSelector = '[popover], dialog, [role="dialog"], [role="alertdialog"]';
function $5634fc0d1bb51a5d$export$df8c72c64edc7260(_ref) {
    var element = _ref.element, container = _ref.container;
    return element.closest($5634fc0d1bb51a5d$var$topLayerSelector) === container.closest($5634fc0d1bb51a5d$var$topLayerSelector);
}


var $e0d64299560c5807$export$e1252723db1c541 = function() {
    // Common exclusion filter applied to every selector.
    var not = ':not([tabindex="-1"]):not([aria-disabled="true"]):not([aria-hidden="true"])';
    var notDisabled = ":not([disabled])".concat(not);
    var focusable = [
        "a[href]".concat(not),
        "area[href]".concat(not),
        "input".concat(notDisabled, ":not([type=\"hidden\"])"),
        "select".concat(notDisabled),
        "textarea".concat(notDisabled),
        "button".concat(notDisabled),
        "iframe".concat(not),
        "audio[controls]".concat(not),
        "video[controls]".concat(not),
        "[contenteditable]:not([contenteditable=\"false\"])".concat(not),
        "[tabindex]".concat(notDisabled)
    ];
    return {
        focusable: focusable.join(','),
        // Build the `:focus` selector
        focused: focusable.map(function(selector) {
            return "".concat(selector, ":focus");
        }).join(',')
    };
}();


function $77f4796a5defae13$export$f6768025e418420e(_ref) {
    var container = _ref.container, filter = _ref.filter;
    return Array.from(container.querySelectorAll((0, $e0d64299560c5807$export$e1252723db1c541).focusable)).filter(function(element) {
        return element instanceof HTMLElement;
    }).filter(function(element) {
        return (0, $5634fc0d1bb51a5d$export$df8c72c64edc7260)({
            element: element,
            container: container
        });
    }).filter(function(element) {
        return !filter || filter(element, container);
    });
}


function $8ea25afdbdc75ed4$export$748138f04a69bf21(_ref) {
    var container = _ref.container, filter = _ref.filter;
    var items = (0, $77f4796a5defae13$export$f6768025e418420e)({
        container: container,
        filter: filter
    });
    return items.length > 0 ? items[0] : null;
}



function $76099ada0fdf0007$export$73e81fa65335a75b(_ref) {
    var container = _ref.container, filter = _ref.filter;
    var items = (0, $77f4796a5defae13$export$f6768025e418420e)({
        container: container,
        filter: filter
    });
    return items.length > 0 ? items[items.length - 1] : null;
}


/**
 * Returns the next focusable element in the given direction relative to the
 * currently focused element within the container. Wraps around at both ends.
 *
 * Returns `null` if there is no focused element within the container or if
 * the focused element is not in the list of focusable elements.
 */ 

function $76a1c193db3b7ec3$export$a7db88e6d491b450(_ref) {
    var _all$nextIndex;
    var container = _ref.container, direction = _ref.direction, filter = _ref.filter;
    var all = (0, $77f4796a5defae13$export$f6768025e418420e)({
        container: container,
        filter: filter
    });
    var current = container.querySelector((0, $e0d64299560c5807$export$e1252723db1c541).focused);
    if (!(current instanceof HTMLElement)) return null;
    var index = all.indexOf(current);
    if (index === -1) return null;
    var nextIndex = function() {
        if (direction === 'forwards') return (index + 1) % all.length;
        var proposed = index - 1;
        // if going into negative numbers, loop back to the last item
        return proposed < 0 ? all.length - 1 : proposed;
    }();
    return (_all$nextIndex = all[nextIndex]) !== null && _all$nextIndex !== void 0 ? _all$nextIndex : null;
}




function $ec3c28ef0dd48e61$export$b9590fdfeb5f722f(_ref) {
    var _getDocument;
    var container = _ref.container;
    var focused = (_getDocument = (0, $fc5ac9c99de29fbb$export$f65ca476c09acec0)()) === null || _getDocument === void 0 ? void 0 : _getDocument.activeElement;
    if (!(focused instanceof HTMLElement)) return false;
    // Cannot be in a nested layer if it is not in the container
    if (!container.contains(focused)) return false;
    // If not in the same layer, must be in a nested layer
    return !(0, $5634fc0d1bb51a5d$export$df8c72c64edc7260)({
        element: focused,
        container: container
    });
}


/**
 * Roles that require focus wrapping per WAI-ARIA APG.
 *
 * - `dialog`: https://www.w3.org/WAI/ARIA/apg/patterns/dialog-modal/
 * - `alertdialog`: same keyboard pattern as dialog
 *
 * `menu` is intentionally excluded. Menus are composite widgets
 * (https://www.w3.org/WAI/ARIA/apg/practices/keyboard-interface/#kbd_general_within)
 * that manage their own internal keyboard navigation via arrow keys,
 * not Tab. Tab/Shift+Tab should move focus OUT of a menu entirely.
 *
 * Menu keyboard behavior (arrow keys, Home/End, type-ahead, Enter/Space)
 * is context-dependent. It varies by orientation, nesting depth, item
 * type, and control pattern (menu button vs menubar). This makes it
 * impossible to implement generically here. The consumer component
 * (e.g. `dropdown-menu`) owns all menu keyboard navigation.
 *
 * See: notes/outputs/menu-keyboard-decision.md
 */ function $a7796e9658bdc85c$var$roleRequiresFocusWrap(role) {
    return role === 'dialog' || role === 'alertdialog';
}
function $a7796e9658bdc85c$export$4f6462e86a70abe5(_ref) {
    var elementRef = _ref.elementRef, role = _ref.role, phase = _ref.phase;
    var isVisible = phase !== 'closed';
    (0, $5FkrB.useEffect)(function() {
        var element = elementRef.current;
        if (!element || !$a7796e9658bdc85c$var$roleRequiresFocusWrap(role) || !isVisible) return;
        var unbind = (0, $5b617c1f48263075$exports.bind)(element, {
            type: 'keydown',
            listener: function listener(event) {
                if (event.key !== 'Tab') return;
                // If focus is already in a nested layer, then
                // we continue to let that nested layer own focus
                if ((0, $ec3c28ef0dd48e61$export$b9590fdfeb5f722f)({
                    container: element
                })) return;
                // Prevent the browser giving focus to where it wants to
                // (we will be handling it, including with wrapping)
                event.preventDefault();
                var direction = event.shiftKey ? 'backwards' : 'forwards';
                // Try to move to the next/previous focusable element relative
                // to the currently focused element within the container.
                var next = (0, $76a1c193db3b7ec3$export$a7db88e6d491b450)({
                    container: element,
                    direction: direction
                });
                if (next) {
                    next.focus();
                    return;
                }
                // Nothing is currently focused inside the container (or the
                // focused element is not in the focusable list). Fall back to
                // the first or last focusable element depending on direction.
                var fallback = direction === 'forwards' ? (0, $8ea25afdbdc75ed4$export$748138f04a69bf21)({
                    container: element
                }) : (0, $76099ada0fdf0007$export$73e81fa65335a75b)({
                    container: element
                });
                if (fallback) fallback.focus();
            },
            options: {
                capture: true
            }
        });
        return unbind;
    }, [
        elementRef,
        role,
        isVisible
    ]);
}



var $5FkrB = parcelRequire("5FkrB");

/**
 * Determines the correct element to receive initial focus within a popover,
 * based on its ARIA role.
 *
 * Focus rules by role (per WAI-ARIA APG):
 * - `dialog` / `alertdialog`: first element with `[autofocus]`, or first focusable element
 * - `menu`: first menu item (`[role="menuitem|menuitemcheckbox|menuitemradio"]`)
 * - `listbox`: first selected option (`[aria-selected="true"]`), or first option (`[role="option"]`)
 * - `tooltip`: no focus movement (tooltips are informational)
 * - no role / other roles: no focus movement
 *
 * Note: React 18's `autoFocus` JSX prop does NOT set the HTML `autofocus`
 * attribute - it only calls `.focus()` imperatively during commit, which
 * has no effect on hidden popover content. Consumers must set the native
 * attribute via a ref callback (e.g. `node.setAttribute('autofocus', '')`).
 * React 19+ reflects the JSX prop as the HTML attribute automatically.
 *
 * Combobox pattern exception: if the popup is controlled by a focused
 * combobox-like trigger (its `aria-controls` references this popup),
 * focus stays on the textbox regardless of role. See
 * `isComboboxControllingPopup`.
 */ /**
 * WAI-ARIA APG Combobox Pattern: when a combobox controls a popup (listbox,
 * grid, tree, or menu), DOM focus must remain on the textbox. Subsequent
 * navigation through popup items uses `aria-activedescendant` (or proxied
 * keyboard events), never DOM focus movement.
 *
 * Detects both variants in a single pass:
 * - In-popup combobox: the textbox lives inside the popup `container`
 *   (the popup is rendered as a child of the combobox wrapper).
 * - External combobox: the textbox is rendered OUTSIDE the popup
 *   (`react-select` pattern, where the listbox is portalled separately
 *   from the textbox).
 *
 * Acceptance criteria for the active element:
 * - Role / element-type filter: `role="combobox"`, `role="textbox"`,
 *   `TEXTAREA`, `contentEditable`, or `INPUT` of text-like type
 *   (`text`, `search`, `email`, `url`, `tel`, `password`, or
 *   unspecified). Non-text input types (`button`, `checkbox`, etc.)
 *   are rejected.
 * - Reference filter: `aria-controls` (or legacy `aria-owns`) IDREFS
 *   must resolve to an element that IS or CONTAINS the popup container.
 *
 * See: https://www.w3.org/WAI/ARIA/apg/patterns/combobox/
 */ // `<input>` types treated as text-like for combobox detection.
// Non-text input types (`button`, `checkbox`, `submit`, etc.) are rejected.
// A missing `type` attribute defaults to `text` per the HTML spec, so we
// normalize that case before lookup rather than including an empty string here.
var $2a6e934b81596289$var$TEXT_LIKE_INPUT_TYPES = new Set([
    'text',
    'search',
    'email',
    'url',
    'tel',
    'password'
]);
function $2a6e934b81596289$var$isTextboxLikeElement(element) {
    var role = element.getAttribute('role');
    if (role === 'combobox' || role === 'textbox') return true;
    // `tagName` is uppercase for HTML elements but can be mixed-case for
    // XML/SVG. Normalize once so downstream comparisons stay lowercase.
    var tag = element.tagName.toLowerCase();
    if (tag === 'textarea') return true;
    if (element.isContentEditable) return true;
    if (tag === 'input') {
        var _element$getAttribute;
        var type = ((_element$getAttribute = element.getAttribute('type')) !== null && _element$getAttribute !== void 0 ? _element$getAttribute : 'text').toLowerCase();
        return $2a6e934b81596289$var$TEXT_LIKE_INPUT_TYPES.has(type);
    }
    return false;
}
function $2a6e934b81596289$var$isComboboxControllingPopup(_ref) {
    var _active$getAttribute;
    var container = _ref.container;
    var ownerDocument = container.ownerDocument;
    var active = ownerDocument.activeElement;
    if (!(active instanceof HTMLElement)) return false;
    if (!$2a6e934b81596289$var$isTextboxLikeElement(active)) return false;
    // Accept legacy `aria-owns` in addition to `aria-controls`.
    // `aria-controls` / `aria-owns` are IDREFS (space-separated list of IDs)
    // per the WAI-ARIA spec, so we must split and check membership rather
    // than comparing with strict equality. A combobox that controls both
    // this popup and another element (e.g. a results status region) must
    // still be recognised as controlling this popup.
    var idRefs = (_active$getAttribute = active.getAttribute('aria-controls')) !== null && _active$getAttribute !== void 0 ? _active$getAttribute : active.getAttribute('aria-owns');
    if (!idRefs) return false;
    // Match if any referenced element IS, CONTAINS, or IS CONTAINED BY the
    // popup container. The "contained by" case covers wrapper-style adopters
    // like react-select, where the combobox input's `aria-controls` points at
    // a listbox element that is a descendant of the Popover host (the
    // listbox role lives on a child the wrapped library owns, not on the
    // host we render).
    var referencedIds = idRefs.split(/\s+/).filter(function(id) {
        return id !== '';
    });
    return referencedIds.some(function(id) {
        var referenced = ownerDocument.getElementById(id);
        if (!referenced) return false;
        return referenced === container || referenced.contains(container) || container.contains(referenced);
    });
}
function $2a6e934b81596289$var$getInitialFocusTarget(_ref2) {
    var container = _ref2.container, role = _ref2.role;
    if (role === 'dialog' || role === 'alertdialog') {
        // Prefer element with the native HTML autofocus attribute.
        var autofocusEl = container.querySelector('[autofocus]');
        if (autofocusEl) return autofocusEl;
        // Fall back to first focusable element
        return (0, $8ea25afdbdc75ed4$export$748138f04a69bf21)({
            container: container
        });
    }
    // The combobox carve-out is kept role-specific (menu / listbox) rather
    // than hoisted. Hoisting it over-matched on dialog popups that contain
    // a nested combobox (e.g. datetime-picker's dialog hosts a react-select),
    // where the active combobox's `aria-controls` falsely matched the
    // container and suppressed the dialog's own focus contract.
    if (role === 'menu') {
        if ($2a6e934b81596289$var$isComboboxControllingPopup({
            container: container
        })) return null;
        // Initial focus placement is the extent of what top-layer provides
        // for menus. All subsequent keyboard navigation (arrow keys, Home/End,
        // type-ahead, Enter/Space, submenu coordination) is the responsibility
        // of the consumer component (e.g. dropdown-menu), because menu keyboard
        // behavior varies by context (orientation, nesting, item type, control
        // pattern). See: notes/outputs/menu-keyboard-decision.md
        return (0, $8ea25afdbdc75ed4$export$748138f04a69bf21)({
            container: container
        });
    }
    if (role === 'listbox') {
        // ARIA Combobox Pattern: if a combobox-like textbox owns the popup
        // (in-popup or external e.g. react-select), leave focus on the
        // textbox - navigation is proxied through it.
        if ($2a6e934b81596289$var$isComboboxControllingPopup({
            container: container
        })) return null;
        // Prefer the selected option, then fall back to the first option.
        // We intentionally match by `[role="option"]` rather than by
        // `getFirstFocusable`. The standard WAI-ARIA APG listbox pattern
        // renders options with `tabindex="-1"` (managed via roving
        // tabindex); `getFirstFocusable` excludes `tabindex="-1"` elements
        // and would silently lose initial focus for spec-conformant
        // listboxes. Options remain programmatically focusable.
        var selectedOption = container.querySelector('[role="option"][aria-selected="true"]');
        if (selectedOption) return selectedOption;
        var firstOption = container.querySelector('[role="option"]');
        if (firstOption) return firstOption;
        // Last resort for non-standard listboxes that render no options
        // but do contain a focusable element (e.g. an empty-state action).
        return (0, $8ea25afdbdc75ed4$export$748138f04a69bf21)({
            container: container
        });
    }
    // tooltip, no role, or other roles: no focus movement
    return null;
}
function $2a6e934b81596289$export$e992c40175757a22(_ref3) {
    var elementRef = _ref3.elementRef, phase = _ref3.phase, role = _ref3.role;
    // Track the previous phase so we only focus on transitions into a
    // visible phase from either `'closed'` (fresh mount) or `'exiting'`
    // (mid-exit reopen where the browser has already restored focus to
    // the trigger). Pure `entering → exiting → entering` stutters where
    // the consumer toggles in the same frame are still collapsed.
    var prevPhaseRef = (0, $5FkrB.useRef)('closed');
    (0, $5FkrB.useEffect)(function() {
        var _getInitialFocusTarge;
        var prevPhase = prevPhaseRef.current;
        prevPhaseRef.current = phase;
        // Only focus on transitions into a visible phase from `'closed'`
        // (fresh open) or `'exiting'` (mid-exit reopen).
        if (phase === 'closed') return;
        if (prevPhase !== 'closed' && prevPhase !== 'exiting') return;
        var element = elementRef.current;
        if (!element) return;
        (_getInitialFocusTarge = $2a6e934b81596289$var$getInitialFocusTarget({
            container: element,
            role: role
        })) === null || _getInitialFocusTarge === void 0 || _getInitialFocusTarge.focus();
    }, [
        elementRef,
        phase,
        role
    ]);
}


/**
 * Detects `popover="hint"` support via DOM reflection. SSR-safe, cached.
 */ var $8ad5ab271a034ac0$var$supportsPopoverHint = (0, $86089df3a0fd54eb$export$2e2bcd8739ae039)(function() {
    if (typeof document === 'undefined') return false;
    // eslint-disable-next-line @atlaskit/platform/no-direct-document-usage -- feature detection
    var element = document.createElement('div');
    element.setAttribute('popover', 'hint');
    return element.popover === 'hint';
});
// Surface reset — neutralises inherited interaction and text-layout properties
// (e.g. `pointer-events: none` from an overlaid controls container and
// `white-space: nowrap` from an `@atlaskit/select` option) that leak into a
// top-layer element because, for CSS inheritance, it is still a DOM child of its
// trigger (top-layer promotion is paint/stacking only; the legacy portal path
// avoided this by rendering at `<body>`). Excludes `color`/`font` (theming) and
// `direction`/`unicode-bidi` (RTL must inherit).
//
// KEEP IN SYNC with the identical `surfaceResetStyles` in `dialog/dialog-content.tsx`.
// ADS forbids sharing styles across files (`no-exported-styles` /
// `no-imported-style-values` — Compiled styles are null at runtime), so the reset is
// co-located and duplicated deliberately.
var $8ad5ab271a034ac0$var$surfaceResetStyles = {
    root: "_lcxv1wug _o5724jg8 _1nmz4jg8 _1i4q4jg8 _y3gnv2br _azhwidpf _1p1dglyw"
};
var $8ad5ab271a034ac0$var$styles = {
    root: "_19itglyw _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19pkidpf _2hwxidpf _otyridpf _18u0idpf _1r041wug _1reoewfl _18m9ewfl _bfhk1j28 _4t3i1wug",
    motion: "_k8m011k7 _1oecdn4k _1s9z1a5r _1o511hrf _bl8aglyw _156y147i",
    enter: "_y44v179n",
    exit: "_y44vof1f"
};
// Intentionally using `Record<string, string>` instead of `React.CSSProperties`
// to avoid type errors about the CSS variables not being valid property names
var $8ad5ab271a034ac0$var$popupMotionStyles = {
    block: {
        start: {
            '--ds-popover-motion-enter': "var(--ds-popup-enter-top, 150ms cubic-bezier(0.4, 1, 0.6, 1) SlideInTop8px, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn0to100)",
            '--ds-popover-motion-exit': "var(--ds-popup-exit-top, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) SlideOutTop8px, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)"
        },
        end: {
            '--ds-popover-motion-enter': "var(--ds-popup-enter-bottom, 150ms cubic-bezier(0.4, 1, 0.6, 1) SlideInBottom8px, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn0to100)",
            '--ds-popover-motion-exit': "var(--ds-popup-exit-bottom, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) SlideOutBottom8px, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)"
        }
    },
    inline: {
        start: {
            '--ds-popover-motion-enter': "var(--ds-popup-enter-left, 150ms cubic-bezier(0.4, 1, 0.6, 1) SlideInLeft8px, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn0to100)",
            '--ds-popover-motion-exit': "var(--ds-popup-exit-left, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) SlideOutLeft8px, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)"
        },
        end: {
            '--ds-popover-motion-enter': "var(--ds-popup-enter-right, 150ms cubic-bezier(0.4, 1, 0.6, 1) SlideInRight8px, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn0to100)",
            '--ds-popover-motion-exit': "var(--ds-popup-exit-right, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) SlideOutRight8px, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)"
        }
    }
};
/**
 * Roles registered with the open layer observer as `popup`, so `closeLayers()`
 * dismisses them. `modal` comes from Dialog only; other layer types are unused.
 */ var $8ad5ab271a034ac0$var$POPUP_ROLES = new Set([
    'menu',
    'listbox',
    'dialog',
    'alertdialog',
    'tree',
    'grid'
]);
var $8ad5ab271a034ac0$export$5b6b19405a83ff9d = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function Popover(_ref, ref) {
    var children = _ref.children, _ref$mode = _ref.mode, modeProp = _ref$mode === void 0 ? 'auto' : _ref$mode, onClose = _ref.onClose, onEnterFinish = _ref.onEnterFinish, onExitFinish = _ref.onExitFinish, _ref$shouldAnimate = _ref.shouldAnimate, shouldAnimate = _ref$shouldAnimate === void 0 ? false : _ref$shouldAnimate, placement = _ref.placement, testId = _ref.testId, isOpen = _ref.isOpen, enteringAnimationXcss = _ref.enteringAnimationXcss, exitingAnimationXcss = _ref.exitingAnimationXcss, role = _ref.role, label = _ref.label, labelledBy = _ref.labelledBy, idProp = _ref.id;
    var autoId = (0, $5FkrB.useId)();
    var ownRef = (0, $5FkrB.useRef)(null);
    var combinedRef = (0, $db13a2f91f6a0f56$export$2e2bcd8739ae039)([
        ownRef,
        ref
    ].filter(Boolean));
    // `useId()` colons are invalid in CSS selectors and popover target attributes.
    var popoverId = idProp !== null && idProp !== void 0 ? idProp : "popover-".concat(autoId.replace(/:/g, ''));
    var _useAnimatedVisibilit = (0, $93516c96f9a01130$export$1bccb45daf07907f)({
        isOpen: isOpen,
        shouldAnimate: shouldAnimate,
        elementRef: ownRef,
        onEnterFinish: onEnterFinish,
        onExitFinish: onExitFinish
    }), phase = _useAnimatedVisibilit.phase, onToggle = _useAnimatedVisibilit.onToggle;
    // True while the host element is mounted (any phase except `closed`).
    // Used as a dep so listener-rebind effects re-attach after a remount.
    var isVisible = phase !== 'closed';
    // Focus management: initial focus on entry (role-dependent), Tab cycling
    // for dialog roles. Restoration is native for outermost popovers; nested
    // focus-capturing roles are handled below via the `beforetoggle` snapshot.
    // Passing `phase` keeps `useFocusWrap` attached through the animated-exit
    // window (WCAG 2.4.3 guard). See notes/architecture/focus-restoration.md.
    (0, $a7796e9658bdc85c$export$4f6462e86a70abe5)({
        elementRef: ownRef,
        role: role,
        phase: phase
    });
    (0, $2a6e934b81596289$export$e992c40175757a22)({
        elementRef: ownRef,
        phase: phase,
        role: role
    });
    // Register with open layer observer so `closeLayers()` and open-count
    // subscriptions work. Only popup-like roles register as `popup`; passive
    // roles (tooltip, status, etc.) leave `type` undefined.
    var handleObserverClose = (0, $5FkrB.useCallback)(function() {
        onClose === null || onClose === void 0 || onClose({
            reason: 'programmatic'
        });
    }, [
        onClose
    ]);
    (0, $36867d1ee34deccb$export$469bb693f11edc7f)({
        type: role && $8ad5ab271a034ac0$var$POPUP_ROLES.has(role) ? 'popup' : undefined,
        isOpen: isOpen,
        onClose: handleObserverClose
    });
    // `hint` falls back to `auto` when unsupported: closest behavior (light
    // dismiss works), but `auto` participates in the auto-dismiss stack so it
    // will close other `auto` popovers when opened. Acceptable trade-off given
    // shrinking browser set without `hint` support.
    var mode = modeProp === 'hint' && !$8ad5ab271a034ac0$var$supportsPopoverHint() ? 'auto' : modeProp;
    var popupMotionStyle = (0, $5FkrB.useMemo)(function() {
        if (!placement || !shouldAnimate) return undefined;
        var _resolvePlacement = (0, $7f3555381f07ba25$export$63044d21bc3d3fa2)({
            placement: placement
        }), axis = _resolvePlacement.axis, edge = _resolvePlacement.edge;
        return $8ad5ab271a034ac0$var$popupMotionStyles[axis][edge];
    }, [
        placement,
        shouldAnimate
    ]);
    // Prevents toggle handler from calling onClose for our own hidePopover() calls.
    var programmaticCloseRef = (0, $5FkrB.useRef)(false);
    // Set in capture-phase keydown so the toggle handler knows close reason.
    var closeReasonRef = (0, $5FkrB.useRef)('light-dismiss');
    // Snapshot of pre-open focus, used to restore focus for nested popovers
    // with focus-capturing roles (browser only restores the outermost).
    var previouslyFocusedElementRef = (0, $5FkrB.useRef)(null);
    var handleBeforeToggle = (0, $5FkrB.useCallback)(function(event) {
        if (event.newState !== 'open') return;
        // eslint-disable-next-line @atlaskit/platform/no-direct-document-usage -- need active element snapshot
        var active = document.activeElement;
        previouslyFocusedElementRef.current = active instanceof HTMLElement ? active : null;
    }, []);
    var handleToggle = (0, $5FkrB.useCallback)(function(event) {
        var element = ownRef.current;
        if (event.newState === 'open') {
            onToggle(event);
            return;
        }
        if (event.newState === 'closed') {
            if (element) {
                // Nested-popover focus restoration fallback (browser only
                // restores outermost; Firefox skips nested entirely).
                // Restore only when the role moved focus in on open AND the
                // close was Escape/programmatic. For light dismiss, the
                // click target keeps focus per HTML spec
                // (`focusPreviousElement=false`).
                var previouslyFocused = previouslyFocusedElementRef.current;
                var reason = closeReasonRef.current;
                var isProgrammatic = programmaticCloseRef.current;
                var shouldRestore = previouslyFocused !== null && previouslyFocused.isConnected && (0, $0c55285f00381bc9$export$b12adccf56228c71)({
                    role: role
                }) && (reason === 'escape' || isProgrammatic);
                if (shouldRestore && previouslyFocused) previouslyFocused.focus({
                    preventScroll: true
                });
                previouslyFocusedElementRef.current = null;
            }
            // Programmatic close: consumer already knows.
            if (programmaticCloseRef.current) // Reset reason so a stale 'escape' from a race with Escape keydown
            // does not corrupt the next browser-dismiss cycle.
            closeReasonRef.current = 'light-dismiss';
            else {
                // Browser dismiss (Escape/click-outside).
                var _reason = closeReasonRef.current;
                closeReasonRef.current = 'light-dismiss';
                // Optional: `manual` mode has no `onClose` in the forwarded type.
                onClose === null || onClose === void 0 || onClose({
                    reason: _reason
                });
            }
        }
        onToggle(event);
    }, [
        onClose,
        onToggle,
        role
    ]);
    // Bind via `useLayoutEffect`, and BEFORE the show/hide layout effect
    // below, so listeners are attached when `showPopover()` synchronously
    // dispatches `beforetoggle`. A regular `useEffect` would miss that
    // first dispatch, dropping the `previouslyFocusedElementRef` snapshot
    // and breaking nested-popover focus restoration on close. React runs
    // layout effects in source order on the same commit.
    (0, $5FkrB.useLayoutEffect)(function() {
        var element = ownRef.current;
        if (!element) return;
        // Tag Escape before the browser processes light dismiss.
        var unbindEscape = (0, $5b617c1f48263075$exports.bind)(element, {
            type: 'keydown',
            listener: function listener(event) {
                if (event.key === 'Escape') closeReasonRef.current = 'escape';
            },
            options: {
                capture: true
            }
        });
        var unbindToggle = (0, $5b617c1f48263075$exports.bind)(element, {
            type: 'toggle',
            listener: handleToggle
        });
        // Snapshot `document.activeElement` before `useInitialFocus` moves it.
        var unbindBeforeToggle = (0, $5b617c1f48263075$exports.bind)(element, {
            type: 'beforetoggle',
            listener: handleBeforeToggle
        });
        return function() {
            unbindEscape();
            unbindToggle();
            unbindBeforeToggle();
        };
    }, [
        handleToggle,
        handleBeforeToggle,
        isVisible
    ]);
    // Show/hide based on isOpen. `showPopover`/`hidePopover` are no-ops when
    // already in the target state. Try/catch guards `InvalidStateError` on
    // disconnected elements (StrictMode/concurrent/unmount edge cases).
    (0, $5FkrB.useLayoutEffect)(function() {
        var element = ownRef.current;
        if (!element) return;
        if (isOpen) {
            programmaticCloseRef.current = false;
            // Clear stale 'escape' from a prior cycle: the ref outlives
            // the host element, and the no-animation path unmounts before
            // `handleToggle` can reset it.
            closeReasonRef.current = 'light-dismiss';
            try {
                element.showPopover();
            } catch (_unused) {}
            return function() {
                programmaticCloseRef.current = true;
                try {
                    element.hidePopover();
                } catch (_unused2) {}
            };
        }
        programmaticCloseRef.current = true;
        try {
            element.hidePopover();
        } catch (_unused3) {}
    }, [
        isOpen
    ]);
    // Unmount the host once exit completes so it does not leave an empty
    // `role`/`popover` element in the accessibility tree. The element
    // remounts on the next open; the `popoverId` is stable across opens.
    if (!isVisible) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("div", {
        ref: combinedRef,
        id: popoverId,
        popover: mode,
        role: role,
        "aria-label": label,
        "aria-labelledby": labelledBy,
        "data-testid": testId,
        style: popupMotionStyle,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $7307d36558082be8$export$2e2bcd8739ae039)([
            $8ad5ab271a034ac0$var$styles.root,
            $8ad5ab271a034ac0$var$surfaceResetStyles.root,
            shouldAnimate && phase === 'entering' && $8ad5ab271a034ac0$var$styles.enter,
            shouldAnimate && phase === 'exiting' && $8ad5ab271a034ac0$var$styles.exit,
            shouldAnimate && $8ad5ab271a034ac0$var$styles.motion,
            (0, $4582e111535cefd2$export$a274e22fb40f762e)(shouldAnimate && phase === 'entering' && enteringAnimationXcss, shouldAnimate && phase === 'exiting' && exitingAnimationXcss)
        ])
    }, children);
});



function $a546998630e0c38c$export$2e2bcd8739ae039(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}



function $dd10ac1a5ec860ce$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, (0, $602bbe61538a474f$export$2e2bcd8739ae039)(o.key), o);
    }
}
function $dd10ac1a5ec860ce$export$2e2bcd8739ae039(e, r, t) {
    return r && $dd10ac1a5ec860ce$var$_defineProperties(e.prototype, r), t && $dd10ac1a5ec860ce$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}



var $5FkrB = parcelRequire("5FkrB");

var $2fb72d4a32455831$var$rafSchd = function rafSchd(fn) {
    var lastArgs = [];
    var frameId = null;
    var wrapperFn = function wrapperFn() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        lastArgs = args;
        if (frameId) return;
        frameId = requestAnimationFrame(function() {
            frameId = null;
            fn.apply(void 0, lastArgs);
        });
    };
    wrapperFn.cancel = function() {
        if (!frameId) return;
        cancelAnimationFrame(frameId);
        frameId = null;
    };
    return wrapperFn;
};
var $2fb72d4a32455831$export$2e2bcd8739ae039 = $2fb72d4a32455831$var$rafSchd;




function $c4aab15c1f8ac2e2$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $c4aab15c1f8ac2e2$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $c4aab15c1f8ac2e2$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $a1d7bec1841415cd$export$2e2bcd8739ae039)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $c4aab15c1f8ac2e2$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
/**
 * JS fallback positioning math. Used only when the browser does not
 * support CSS Anchor Positioning (less than 6% of users).
 *
 * Consumer-supplied `offset.gap` and `offset.crossAxisShift` are
 * honored: the caller (`useAnchorPosition`) resolves CSS length strings
 * (tokens, calc, var, etc) to pixels via a DOM probe before passing them
 * in. The caller also keeps the popover hidden (`opacity: 0`) until the
 * first measurement completes, so the popover never paints at the wrong
 * position.
 */ /**
 * A viewport-relative position, in pixels. Physical rather than logical
 * because it is written straight to `top` / `left`.
 */ /**
 * The cross-axis shift with its length already resolved to pixels.
 *
 * Mirrors `TCrossAxisShiftOffset`, whose `value` is an unresolved CSS length
 * string. Only this module needs the pixel form, because only this module does
 * the arithmetic itself.
 */ /**
 * Computes the base {top, left} position based on the primary edge,
 * flipping to the opposite side when there is not enough space.
 *
 * `gap` is applied along the main axis between trigger and popover.
 */ function $c4aab15c1f8ac2e2$var$computeEdgePosition(_ref) {
    var axis = _ref.axis, edge = _ref.edge, triggerRect = _ref.triggerRect, popoverWidth = _ref.popoverWidth, popoverHeight = _ref.popoverHeight, viewport = _ref.viewport, gap = _ref.gap;
    if (axis === 'block' && edge === 'end') {
        // Below trigger
        var spaceBelow = viewport.height - triggerRect.bottom;
        var spaceAbove = triggerRect.top;
        var fitsBelow = spaceBelow >= popoverHeight + gap;
        var useBelow = fitsBelow || spaceBelow >= spaceAbove;
        return {
            top: useBelow ? triggerRect.bottom + gap : triggerRect.top - popoverHeight - gap,
            left: triggerRect.left + triggerRect.width / 2 - popoverWidth / 2
        };
    }
    if (axis === 'block' && edge === 'start') {
        // Above trigger
        var _spaceAbove = triggerRect.top;
        var _spaceBelow = viewport.height - triggerRect.bottom;
        var fitsAbove = _spaceAbove >= popoverHeight + gap;
        var useAbove = fitsAbove || _spaceAbove >= _spaceBelow;
        return {
            top: useAbove ? triggerRect.top - popoverHeight - gap : triggerRect.bottom + gap,
            left: triggerRect.left + triggerRect.width / 2 - popoverWidth / 2
        };
    }
    if (axis === 'inline' && edge === 'end') {
        // Right of trigger
        var spaceRight = viewport.width - triggerRect.right;
        var spaceLeft = triggerRect.left;
        var fitsRight = spaceRight >= popoverWidth + gap;
        var useRight = fitsRight || spaceRight >= spaceLeft;
        return {
            top: triggerRect.top + triggerRect.height / 2 - popoverHeight / 2,
            left: useRight ? triggerRect.right + gap : triggerRect.left - popoverWidth - gap
        };
    }
    if (axis === 'inline' && edge === 'start') {
        // Left of trigger
        var _spaceLeft = triggerRect.left;
        var _spaceRight = viewport.width - triggerRect.right;
        var fitsLeft = _spaceLeft >= popoverWidth + gap;
        var useLeft = fitsLeft || _spaceLeft >= _spaceRight;
        return {
            top: triggerRect.top + triggerRect.height / 2 - popoverHeight / 2,
            left: useLeft ? triggerRect.left - popoverWidth - gap : triggerRect.right + gap
        };
    }
    // Unreachable for valid placements; defaults to below trigger
    return {
        top: triggerRect.bottom + gap,
        left: triggerRect.left + triggerRect.width / 2 - popoverWidth / 2
    };
}
/**
 * Adjusts the base (centered) position for non-center alignments.
 *
 * `align: 'start'` → popover start edge at trigger start edge
 * `align: 'end'`   → popover end edge at trigger end edge
 */ function $c4aab15c1f8ac2e2$var$applyAlignment(_ref2) {
    var position = _ref2.position, axis = _ref2.axis, align = _ref2.align, triggerRect = _ref2.triggerRect, popoverWidth = _ref2.popoverWidth, popoverHeight = _ref2.popoverHeight;
    if (align === 'center') return position;
    if (axis === 'block') {
        // Block-axis placement → cross-axis is inline (left/right)
        if (align === 'start') return $c4aab15c1f8ac2e2$var$_objectSpread($c4aab15c1f8ac2e2$var$_objectSpread({}, position), {}, {
            left: triggerRect.left
        });
        // align === 'end'
        return $c4aab15c1f8ac2e2$var$_objectSpread($c4aab15c1f8ac2e2$var$_objectSpread({}, position), {}, {
            left: triggerRect.right - popoverWidth
        });
    }
    // Inline-axis placement → cross-axis is block (top/bottom)
    if (align === 'start') return $c4aab15c1f8ac2e2$var$_objectSpread($c4aab15c1f8ac2e2$var$_objectSpread({}, position), {}, {
        top: triggerRect.top
    });
    // align === 'end'
    return $c4aab15c1f8ac2e2$var$_objectSpread($c4aab15c1f8ac2e2$var$_objectSpread({}, position), {}, {
        top: triggerRect.bottom - popoverHeight
    });
}
/**
 * Applies the cross-axis shift offset.
 *
 * `forwards` always moves the popover toward the cross-axis END and
 * `backwards` toward the START, for every `align` value. See
 * `notes/decisions/placement-offset.md`.
 *
 * This is a coordinate, so the direction is the sign and nothing else. There
 * is deliberately no per-`align` sign inversion here: the CSS path inverts the
 * sign only because a margin on the END side pushes a box the opposite way to
 * a margin on the START side, which is a property of margins rather than of
 * the shift. Applying that inversion to a coordinate moved `align: 'end'`
 * popovers the wrong way.
 */ function $c4aab15c1f8ac2e2$var$applyCrossAxisShift(_ref3) {
    var position = _ref3.position, axis = _ref3.axis, crossAxisShift = _ref3.crossAxisShift;
    if (crossAxisShift.value === 0) return position;
    var directionSign = crossAxisShift.direction === 'forwards' ? 1 : -1;
    var delta = crossAxisShift.value * directionSign;
    // Cross-axis is the OPPOSITE of the placement axis.
    if (axis === 'block') return $c4aab15c1f8ac2e2$var$_objectSpread($c4aab15c1f8ac2e2$var$_objectSpread({}, position), {}, {
        left: position.left + delta
    });
    return $c4aab15c1f8ac2e2$var$_objectSpread($c4aab15c1f8ac2e2$var$_objectSpread({}, position), {}, {
        top: position.top + delta
    });
}
function $c4aab15c1f8ac2e2$export$d5ef1dac02135664(_ref4) {
    var triggerRect = _ref4.triggerRect, popoverEl = _ref4.popoverEl, placement = _ref4.placement, viewport = _ref4.viewport, gap = _ref4.gap, crossAxisShift = _ref4.crossAxisShift;
    var axis = placement.axis, edge = placement.edge, align = placement.align;
    // Measure popover dimensions. Callers must ensure the popover has
    // laid out before calling this (it should not be `display: none`).
    var popoverWidth = popoverEl.offsetWidth;
    var popoverHeight = popoverEl.offsetHeight;
    var basePosition = $c4aab15c1f8ac2e2$var$computeEdgePosition({
        axis: axis,
        edge: edge,
        triggerRect: triggerRect,
        popoverWidth: popoverWidth,
        popoverHeight: popoverHeight,
        viewport: viewport,
        gap: gap
    });
    var alignedPosition = $c4aab15c1f8ac2e2$var$applyAlignment({
        position: basePosition,
        axis: axis,
        align: align,
        triggerRect: triggerRect,
        popoverWidth: popoverWidth,
        popoverHeight: popoverHeight
    });
    var shiftedPosition = $c4aab15c1f8ac2e2$var$applyCrossAxisShift({
        position: alignedPosition,
        axis: axis,
        crossAxisShift: crossAxisShift
    });
    // Clamp to viewport so the popover is never offscreen
    return {
        top: Math.max(0, Math.min(shiftedPosition.top, viewport.height - popoverHeight)),
        left: Math.max(0, Math.min(shiftedPosition.left, viewport.width - popoverWidth))
    };
}


/**
 * Combine multiple cleanup functions into a single cleanup function.
 *
 * @example
 * ```ts
 * useEffect(() => {
 *   return combine(
 *     bind(window, { type: 'resize', listener: onResize }),
 *     bind(window, { type: 'scroll', listener: onScroll, options: { capture: true } }),
 *   );
 * }, []);
 * ```
 */ function $21ff8a276eb37634$export$1be1fc439b849fdf() {
    for(var _len = arguments.length, cleanupFns = new Array(_len), _key = 0; _key < _len; _key++)cleanupFns[_key] = arguments[_key];
    return function cleanup() {
        cleanupFns.forEach(function(callback) {
            return callback === null || callback === void 0 ? void 0 : callback();
        });
    };
}



function $74ffbe4d2bf46789$export$de49b61f233ddeb9(_ref) {
    var placement = _ref.placement;
    var _resolvePlacement = (0, $7f3555381f07ba25$export$63044d21bc3d3fa2)({
        placement: placement
    }), axis = _resolvePlacement.axis, edge = _resolvePlacement.edge, align = _resolvePlacement.align;
    var edgeValue = "".concat(axis, "-").concat(edge);
    if (align === 'center') return edgeValue;
    // Cross-axis name: block ↔ inline
    var crossAxis = axis === 'block' ? 'inline' : 'block';
    // Invert align → CSS span direction: visual 'start' → span toward 'end'
    var spanDir = align === 'start' ? 'end' : 'start';
    return "".concat(edgeValue, " span-").concat(crossAxis, "-").concat(spanDir);
}



/**
 * A `position-area` primary edge — the placement axis joined to its edge, e.g.
 * `block-end` or `inline-start`. These are the four edges a popover can sit on.
 */ function $f7daed2d34a4002d$var$slideOnEdge(_ref) {
    var align = _ref.align, edgeKey = _ref.edgeKey, crossAxis = _ref.crossAxis;
    if (align === 'center') return [
        "".concat(edgeKey, " span-").concat(crossAxis, "-end"),
        "".concat(edgeKey, " span-").concat(crossAxis, "-start")
    ];
    // For `align: 'start'` the popover expands toward `end`, so the "near"
    // span is `end` and the "far" span is `start`; `align: 'end'` mirrors
    // this. The bare `edgeKey` (re-centered) sits between them.
    var near = align === 'start' ? 'end' : 'start';
    var far = align === 'start' ? 'start' : 'end';
    return [
        "".concat(edgeKey, " span-").concat(crossAxis, "-").concat(near),
        edgeKey,
        "".concat(edgeKey, " span-").concat(crossAxis, "-").concat(far)
    ];
}
function $f7daed2d34a4002d$var$flipDiagonally(_ref2) {
    var axis = _ref2.axis;
    var flipOnMainAxis = axis === 'block' ? 'flip-block' : 'flip-inline';
    var flipToCrossAxis = axis === 'block' ? 'flip-inline' : 'flip-block';
    return "".concat(flipOnMainAxis, " ").concat(flipToCrossAxis);
}
function $f7daed2d34a4002d$export$c4e16947a95d61f1(_ref3) {
    var placement = _ref3.placement;
    /**
   * **Build the fallback list**
   *
   * Each entry is a complete alternative position.
   * The browser tries them _in order_ and uses the _first_ one that fits.
   */ var resolved = (0, $7f3555381f07ba25$export$63044d21bc3d3fa2)({
        placement: placement
    });
    var axis = resolved.axis, edge = resolved.edge, align = resolved.align;
    var crossAxis = axis === 'block' ? 'inline' : 'block';
    var flippedEdge = edge === 'start' ? 'end' : 'start';
    var sameEdgeArea = "".concat(axis, "-").concat(edge);
    var oppositeEdgeArea = "".concat(axis, "-").concat(flippedEdge);
    var flipOnMainAxis = axis === 'block' ? 'flip-block' : 'flip-inline';
    /**
   * **Fallback algorithm**
   *
   * We have two things we can do to keep something visible:
   *
   * 1. _Slide_ along edges
   * 2. _Flip_ to another edge
   *
   * _Centered popover_
   *
   * Desired: Sits in middle of main edge
   *
   * Fallbacks:
   *  1: _Slide_ along main edge on the cross axis
   *  2: _Flip_ on main axis to opposite edge (centered)
   *  3: _Slide_ along opposite edge on the cross axis
   *
   * _Start or end aligned popover_
   *
   * Desired: Sits at start / end of main edge
   *
   * Fallbacks:
   *  1: _Slide_ along main edge on the cross axis
   *  2: _Flip_ on main axis to opposite edge
   *  3: _Flip_ on the diagonal (flip main axis + flip cross axis) into the
   *     opposite corner. For start / end alignment, this is the clean escape
   *     when the popover would otherwise land offscreen on both axes (ie in a
   *     corner). Rule 4 gets the job done, but a slide drops the gap
   *     as named position-area values don't carry margins).
   *     The diagonal flip keeps the gap and the alignment.
   *  4: _Slide_ along opposite edge on the cross axis
   */ return [
        $f7daed2d34a4002d$var$slideOnEdge({
            align: align,
            edgeKey: sameEdgeArea,
            crossAxis: crossAxis
        }),
        flipOnMainAxis,
        align !== 'center' ? $f7daed2d34a4002d$var$flipDiagonally({
            axis: axis
        }) : null,
        $f7daed2d34a4002d$var$slideOnEdge({
            align: align,
            edgeKey: oppositeEdgeArea,
            crossAxis: crossAxis
        })
    ].filter(Boolean).flat().join(', ');
}


var $9641d3abff911a67$var$elementCaches = new WeakMap();
function $9641d3abff911a67$var$canCacheResolvedLength(value) {
    // Custom-property values can be retargeted by inline overrides on the
    // consumer's wrapper, so we cannot prove a cached pixel value is still valid.
    return !value.includes('var(');
}
function $9641d3abff911a67$var$getCachedResolvedLength(_ref) {
    var _cacheForElement$get;
    var element = _ref.element, value = _ref.value;
    if (!$9641d3abff911a67$var$canCacheResolvedLength(value)) return null;
    var cacheForElement = $9641d3abff911a67$var$elementCaches.get(element);
    return (_cacheForElement$get = cacheForElement === null || cacheForElement === void 0 ? void 0 : cacheForElement.get(value)) !== null && _cacheForElement$get !== void 0 ? _cacheForElement$get : null;
}
function $9641d3abff911a67$var$cacheResolvedLength(_ref2) {
    var _elementCaches$get;
    var element = _ref2.element, value = _ref2.value, result = _ref2.result;
    if (!$9641d3abff911a67$var$canCacheResolvedLength(value)) return;
    var cacheForElement = (_elementCaches$get = $9641d3abff911a67$var$elementCaches.get(element)) !== null && _elementCaches$get !== void 0 ? _elementCaches$get : new Map();
    cacheForElement.set(value, result);
    $9641d3abff911a67$var$elementCaches.set(element, cacheForElement);
}
function $9641d3abff911a67$export$98721546d2816d9e(_ref3) {
    var value = _ref3.value, container = _ref3.container;
    if (typeof value === 'number') return value;
    // Fast path: unitless zero is universally zero pixels - accept `'0'` and
    // `'-0'` without a probe. (Consumers occasionally pass `'0'` instead of
    // the number `0`.)
    if (value === '0' || value === '-0') return 0;
    // Fast path: bare `${n}px` strings come from the consumer normalisation
    // in `resolvePlacement`. Avoid a reflow when we can.
    var pxMatch = value.match(/^(-?\d+(?:\.\d+)?)px$/);
    if (pxMatch) return Number(pxMatch[1]);
    var cached = $9641d3abff911a67$var$getCachedResolvedLength({
        element: container,
        value: value
    });
    if (cached !== null) return cached;
    var probe = container.ownerDocument.createElement('div');
    probe.style.position = 'absolute';
    probe.style.visibility = 'hidden';
    probe.style.pointerEvents = 'none';
    probe.style.height = '0';
    probe.style.padding = '0';
    probe.style.border = '0';
    // `width` clamps negatives to 0; use `margin-left` instead so signs are
    // preserved. `getComputedStyle` returns the resolved pixel value for
    // margin-* properties even when the source was a token / calc / var.
    probe.style.marginLeft = value;
    // Hide the probe from assistive tech and event targeting; defensive
    // against `getElementsByTagName('div')` walks in consumer code.
    probe.setAttribute('aria-hidden', 'true');
    probe.setAttribute('inert', '');
    container.appendChild(probe);
    var resolved = parseFloat(getComputedStyle(probe).marginLeft);
    container.removeChild(probe);
    var result = Number.isFinite(resolved) ? resolved : 0;
    $9641d3abff911a67$var$cacheResolvedLength({
        element: container,
        value: value,
        result: result
    });
    return result;
}



/**
 * A single inline style declaration.
 *
 * `TProperty` narrows the property name for callers that write a known, closed
 * set of properties. Narrowing it lets a record keyed on those same names be
 * checked for exhaustiveness at compile time, rather than silently resolving to
 * `undefined` for a name that was never mapped.
 */ /**
 * Sets inline styles on an element and returns a cleanup function that
 * restores the prior inline values (so we do not stomp consumer styles).
 */ function $31cc8a3dab82cc8b$export$37a5fde709c1db82(_ref) {
    var element = _ref.element, styles = _ref.styles;
    // Snapshot the prior inline value (NOT the computed style - we only want
    // to restore values that the consumer/our previous run inlined). An empty
    // string means "no inline value", in which case cleanup uses removeProperty.
    var priorValues = styles.map(function(_ref2) {
        var property = _ref2.property;
        return {
            property: property,
            value: element.style.getPropertyValue(property)
        };
    });
    styles.forEach(function(_ref3) {
        var property = _ref3.property, value = _ref3.value;
        element.style.setProperty(property, value);
    });
    return function cleanup() {
        priorValues.forEach(function(_ref4) {
            var property = _ref4.property, value = _ref4.value;
            if (value === '') {
                element.style.removeProperty(property);
                return;
            }
            element.style.setProperty(property, value);
        });
    };
}


// `resolvePlacement` is intentionally NOT re-exported here - import it directly
// from `./resolve-placement` so search-and-jump lands at the source of truth.
/**
 * Module-scope no-op `ResizeObserver` used in non-DOM jest environments where
 * `ResizeObserver` is `undefined`. Hoisted out of the effect to avoid
 * allocating a new class declaration on every run.
 */ var $eb7612906dd2d851$var$NoopResizeObserver = /*#__PURE__*/ function() {
    function NoopResizeObserver() {
        (0, $a546998630e0c38c$export$2e2bcd8739ae039)(this, NoopResizeObserver);
    }
    return (0, $dd10ac1a5ec860ce$export$2e2bcd8739ae039)(NoopResizeObserver, [
        {
            key: "observe",
            value: function observe() {}
        },
        {
            key: "unobserve",
            value: function unobserve() {}
        },
        {
            key: "disconnect",
            value: function disconnect() {}
        }
    ]);
}();
/**
 * Returns true when the popover is currently open. Wrapped because the
 * `:popover-open` pseudo-class is not implemented in some test environments
 * (e.g. jsdom), where `matches` throws on unknown selectors.
 */ function $eb7612906dd2d851$var$isPopoverOpen(popover) {
    try {
        return popover.matches(':popover-open');
    } catch (_unused) {
        return false;
    }
}
/**
 * Detects whether the browser supports CSS Anchor Positioning.
 * Uses `once()` for lazy evaluation: safe for SSR and avoids hydration mismatches.
 */ var $eb7612906dd2d851$var$supportsAnchorPositioning = (0, $86089df3a0fd54eb$export$2e2bcd8739ae039)(function() {
    if (typeof window === 'undefined' || typeof CSS === 'undefined' || typeof CSS.supports !== 'function') return false;
    return CSS.supports('anchor-name', '--a');
});
/**
 * Every logical margin property this module can write: one per axis, per side.
 *
 * Deriving the union from `TPlacementAxis` and `TPlacementEdge` rather than
 * writing the four names out keeps it in step with the placement model, and
 * makes `CROSS_AXIS_SHIFT_CUSTOM_PROPERTY` below exhaustive by construction.
 */ /**
 * The custom property mirroring each cross-axis shift margin.
 *
 * These are written for the planned named arrow `@position-try` rules. Nothing
 * reads them yet, and the shift no longer depends on them: the antisymmetric
 * margins written by `crossAxisShiftMargins` survive a cross-axis slide on
 * their own.
 *
 * Keyed on `TLogicalMarginProperty` and not on `string`, so a margin property
 * that has no custom property (or a custom property whose margin no longer
 * exists) is a compile error rather than an `undefined` lookup that reaches
 * `setStyle` as `{ property: undefined, value }`.
 */ var $eb7612906dd2d851$var$CROSS_AXIS_SHIFT_CUSTOM_PROPERTY = {
    'margin-inline-start': '--ds-cross-axis-shift-margin-start',
    'margin-inline-end': '--ds-cross-axis-shift-margin-end',
    'margin-block-start': '--ds-cross-axis-shift-margin-block-start',
    'margin-block-end': '--ds-cross-axis-shift-margin-block-end'
};
var $eb7612906dd2d851$var$ZEROED_CROSS_AXIS_SHIFT_CUSTOM_PROPERTIES = Object.values($eb7612906dd2d851$var$CROSS_AXIS_SHIFT_CUSTOM_PROPERTY).map(function(property) {
    return {
        property: property,
        value: '0px'
    };
});
/**
 * Returns the CSS margin declaration that creates a gap between the
 * popover and its trigger on the side facing the anchor.
 *
 * For example, a `block-end` placement (popover below) gets
 * `margin-block-start: 8px` to push it away from the trigger's bottom edge.
 */ function $eb7612906dd2d851$var$edgeMargin(_ref) {
    var placement = _ref.placement, offset = _ref.offset;
    var axis = placement.axis, edge = placement.edge;
    // The gap sits on the side FACING the anchor, which is always the side
    // opposite the placement edge.
    var anchorFacingEdge = edge === 'end' ? 'start' : 'end';
    return {
        property: "margin-".concat(axis, "-").concat(anchorFacingEdge),
        value: offset
    };
}
/**
 * **The cross-axis shift margins.**
 *
 * The shift is written antisymmetrically on BOTH cross-axis sides
 * (`start: +value`, `end: -value`) rather than as a single margin on the side
 * picked from `align`. Two separate behaviours require it:
 *
 * 1. **`align: 'center'` is centered with `anchor-center`, which centers the
 *    popover's MARGIN box on the anchor.** A single-sided margin widens the
 *    margin box, so it displaces the border box by only half its value. An
 *    antisymmetric pair leaves the margin box width unchanged (`+value` and
 *    `-value` sum to zero) while moving its center by the full value.
 * 2. **`position-try-fallbacks` can slide the popover onto the opposite
 *    cross-axis side.** A `<position-area>` fallback keeps the base style's
 *    margins, and margin on the un-anchored side has no effect, so a
 *    single-sided margin is silently dropped once the browser slides across the
 *    cross axis. With both sides written, whichever side ends up anchored moves
 *    the popover the same physical direction.
 *
 * Leaving the margin box width unchanged also means the shift does not move
 * the point at which `position-try-fallbacks` decides the popover overflows.
 *
 * A `<try-tactic>` fallback (`flip-block`, `flip-inline`) behaves differently to
 * a `<position-area>` one: it SWAPS the start and end margins rather than
 * keeping them, which is what preserves the gap through a flip. So a flip across
 * the cross axis mirrors the shift along with the rest of the placement, rather
 * than preserving its physical direction. Only the diagonal fallback does that,
 * and only for `align: 'start' | 'end'`. See `placementToTryFallbacks`.
 *
 * A positive value always moves the popover toward the cross-axis END, so
 * `direction: 'forwards'` means the same thing for every `align` value. See
 * `notes/decisions/placement-offset.md`.
 */ function $eb7612906dd2d851$var$crossAxisShiftMargins(_ref2) {
    var placement = _ref2.placement, crossAxisShiftCssValue = _ref2.crossAxisShiftCssValue, direction = _ref2.direction;
    var crossAxis = placement.axis === 'block' ? 'inline' : 'block';
    // Wrap any string in calc() with the sign factor. CSS handles the math,
    // so opaque values such as design tokens negate correctly.
    var negated = "calc(-1 * ".concat(crossAxisShiftCssValue, ")");
    var isForwards = direction === 'forwards';
    return [
        {
            property: "margin-".concat(crossAxis, "-start"),
            value: isForwards ? crossAxisShiftCssValue : negated
        },
        {
            property: "margin-".concat(crossAxis, "-end"),
            value: isForwards ? negated : crossAxisShiftCssValue
        }
    ];
}
/**
 * Returns a referentially-stable, fully-resolved `TPlacement`. The memo is
 * keyed on the resolved primitive fields so a fresh inline `placement` object
 * (or undefined fields vs explicit defaults) does not produce a fresh result.
 */ function $eb7612906dd2d851$var$useStablePlacement(placement) {
    var resolved = (0, $7f3555381f07ba25$export$63044d21bc3d3fa2)({
        placement: placement
    });
    var axis = resolved.axis;
    var edge = resolved.edge;
    var align = resolved.align;
    var gap = resolved.offset.gap;
    var shiftValue = resolved.offset.crossAxisShift.value;
    var shiftDirection = resolved.offset.crossAxisShift.direction;
    // Rebuild inside the memo from primitive deps so the factory does not
    // close over the outer `resolved` reference and exhaustive-deps can verify.
    return (0, $5FkrB.useMemo)(function() {
        return {
            axis: axis,
            edge: edge,
            align: align,
            offset: {
                gap: gap,
                crossAxisShift: {
                    value: shiftValue,
                    direction: shiftDirection
                }
            }
        };
    }, [
        axis,
        edge,
        align,
        gap,
        shiftValue,
        shiftDirection
    ]);
}
function $eb7612906dd2d851$export$56b02a1e583f953c(_ref3) {
    var anchorRef = _ref3.anchorRef, popoverRef = _ref3.popoverRef, _ref3$placement = _ref3.placement, placement = _ref3$placement === void 0 ? {} : _ref3$placement, _ref3$forceFallbackPo = _ref3.forceFallbackPositioning, forceFallbackPositioning = _ref3$forceFallbackPo === void 0 ? false : _ref3$forceFallbackPo, _ref3$isEnabled = _ref3.isEnabled, isEnabled = _ref3$isEnabled === void 0 ? true : _ref3$isEnabled, isOpen = _ref3.isOpen;
    var id = (0, $5FkrB.useId)();
    var stablePlacement = $eb7612906dd2d851$var$useStablePlacement(placement);
    (0, $5FkrB.useLayoutEffect)(function() {
        if (!isEnabled) return;
        var trigger = anchorRef.current;
        var popover = popoverRef.current;
        if (!trigger || !popover) return;
        var gapCssValue = stablePlacement.offset.gap;
        var crossAxisShiftCssValue = stablePlacement.offset.crossAxisShift.value;
        var shouldForceFallback = Boolean(forceFallbackPositioning);
        if ($eb7612906dd2d851$var$supportsAnchorPositioning() && !shouldForceFallback) {
            // Reuse an existing `anchor-name` if the element already has one.
            // Another popover might already be anchored to the old name.
            var anchorName = trigger.style.getPropertyValue('anchor-name') || "--anchor-".concat(id.replace(/:/g, ''));
            var gap = $eb7612906dd2d851$var$edgeMargin({
                placement: stablePlacement,
                offset: gapCssValue
            });
            // Computed once; also mirrored into the
            // `--ds-cross-axis-shift-margin-*` custom properties below.
            var crossAxisShift = $eb7612906dd2d851$var$crossAxisShiftMargins({
                placement: stablePlacement,
                crossAxisShiftCssValue: crossAxisShiftCssValue,
                direction: stablePlacement.offset.crossAxisShift.direction
            });
            var popoverStyles = [
                {
                    property: 'position-anchor',
                    value: anchorName
                },
                {
                    property: 'position-area',
                    value: (0, $74ffbe4d2bf46789$export$de49b61f233ddeb9)({
                        placement: stablePlacement
                    })
                },
                {
                    property: 'position-try-fallbacks',
                    value: (0, $f7daed2d34a4002d$export$c4e16947a95d61f1)({
                        placement: stablePlacement
                    })
                },
                // Reset browser default popover positioning that conflicts
                // with anchor positioning (UA: `inset: 0; margin: auto;`)
                {
                    property: 'margin',
                    value: '0'
                },
                {
                    property: 'inset',
                    value: 'auto'
                },
                gap
            ].concat((0, $ad44204fc1b4beec$export$2e2bcd8739ae039)(crossAxisShift), (0, $ad44204fc1b4beec$export$2e2bcd8739ae039)($eb7612906dd2d851$var$ZEROED_CROSS_AXIS_SHIFT_CUSTOM_PROPERTIES), (0, $ad44204fc1b4beec$export$2e2bcd8739ae039)(crossAxisShift.map(function(_ref4) {
                var property = _ref4.property, value = _ref4.value;
                return {
                    property: $eb7612906dd2d851$var$CROSS_AXIS_SHIFT_CUSTOM_PROPERTY[property],
                    value: value
                };
            })));
            /**
       * **We are never cleaning up anchor names**
       *
       * _Rationale_
       *
       * - Multiple popovers can share the same anchor element.
       * - Sometimes the `useAnchorPosition` hook and `Popover`
       *   are not in the same component.
       * - There can be times when, even with reference counting, we
       *   could remove the anchor-name while it is still being used
       *   by something else - especially with async react updates
       *   which can cause tearing
       *
       * _More_
       *
       * See `notes/decisions/anchor-name-lifetime.md`
       */ trigger.style.setProperty('anchor-name', anchorName);
            return (0, $31cc8a3dab82cc8b$export$37a5fde709c1db82)({
                element: popover,
                styles: popoverStyles
            });
        }
        // JS fallback. The popover is already in the top layer via
        // popover="auto", so we only reset UA defaults and set top/left
        // based on measurements.
        var cleanupBaseStyles = (0, $31cc8a3dab82cc8b$export$37a5fde709c1db82)({
            element: popover,
            styles: [
                {
                    property: 'margin',
                    value: '0'
                },
                {
                    property: 'inset',
                    value: 'auto'
                }
            ]
        });
        // The popover can be consumer-owned (`@atlaskit/popper`'s `createPopper`),
        // so restore prior inline values rather than removing ours.
        var undoPosition;
        var undoHide;
        // `opacity: 0` not `visibility: hidden`: Firefox skips visibility-hidden
        // elements during `<dialog>` initial-focus traversal.
        function hideUntilPositioned() {
            // Keep the first snapshot, else we capture our own `opacity: 0`.
            // (`!popover` is for TS: narrowing does not reach nested functions.)
            if (!popover || undoHide) return;
            undoHide = (0, $31cc8a3dab82cc8b$export$37a5fde709c1db82)({
                element: popover,
                styles: [
                    {
                        property: 'opacity',
                        value: '0'
                    }
                ]
            });
        }
        function reveal() {
            var _undoHide;
            (_undoHide = undoHide) === null || _undoHide === void 0 || _undoHide();
            undoHide = undefined;
        }
        function restorePosition() {
            var _undoPosition;
            (_undoPosition = undoPosition) === null || _undoPosition === void 0 || _undoPosition();
            undoPosition = undefined;
        }
        function update() {
            if (!trigger || !popover) return;
            var triggerRect = trigger.getBoundingClientRect();
            var viewport = {
                width: window.innerWidth,
                height: window.innerHeight
            };
            // Resolve consumer-supplied CSS length strings (tokens, calc, var,
            // px, rem, etc) to pixels. The probe is mounted INSIDE the popover
            // itself so the resolved length matches the scope a token would
            // resolve against from inside the popover content. (The popover
            // lives in the top layer, not the trigger's DOM tree, so probing
            // at `popover.parentElement` would resolve in a different scope
            // than the consumer's token authoring expects.)
            var gapPx = (0, $9641d3abff911a67$export$98721546d2816d9e)({
                value: gapCssValue,
                container: popover
            });
            var crossAxisShiftPx = (0, $9641d3abff911a67$export$98721546d2816d9e)({
                value: crossAxisShiftCssValue,
                container: popover
            });
            var _computeFallbackPosit = (0, $c4aab15c1f8ac2e2$export$d5ef1dac02135664)({
                triggerRect: triggerRect,
                popoverEl: popover,
                placement: stablePlacement,
                viewport: viewport,
                gap: gapPx,
                crossAxisShift: {
                    value: crossAxisShiftPx,
                    direction: stablePlacement.offset.crossAxisShift.direction
                }
            }), top = _computeFallbackPosit.top, left = _computeFallbackPosit.left;
            // Restore first so the snapshot stays the consumer's value.
            restorePosition();
            undoPosition = (0, $31cc8a3dab82cc8b$export$37a5fde709c1db82)({
                element: popover,
                styles: [
                    {
                        property: 'top',
                        value: "".concat(top, "px")
                    },
                    {
                        property: 'left',
                        value: "".concat(left, "px")
                    }
                ]
            });
            reveal();
        }
        // Throttle scroll/resize updates to one per animation frame
        var scheduledUpdate = (0, $2fb72d4a32455831$export$2e2bcd8739ae039)(update);
        // Wait for the FIRST valid layout before measuring: the popover
        // is `display: none` until `showPopover()`, and some browsers
        // fire `toggle` before layout, so RAF-after-toggle is unreliable.
        // ResizeObserver fires once the browser has real dimensions.
        // Self-disconnects after one valid measurement; ongoing
        // scroll/resize is handled by the window listeners below.
        // `ResizeObserver` is missing in some non-DOM jest environments
        // (e.g. post-office's `node` environment). Fall back to a no-op
        // observer there. The scroll/resize listeners below still keep
        // the popover positioned in the rare case the consumer also
        // polyfilled `showPopover` but not `ResizeObserver`. Real
        // browsers always have it. The `NoopResizeObserver` class is
        // hoisted to module scope (see top of file) so we do not allocate
        // a new constructor on every effect run.
        var ResizeObserverImpl = typeof ResizeObserver !== 'undefined' ? ResizeObserver : $eb7612906dd2d851$var$NoopResizeObserver;
        var resizeObserver = new ResizeObserverImpl(function() {
            if (popover.offsetWidth > 0 && popover.offsetHeight > 0) {
                update();
                resizeObserver.disconnect();
            }
        });
        // If the popover is already open by the time this effect runs (for
        // example, the parent `useAnchorPosition` effect runs after the child
        // `Popover` effect that called `showPopover()`), the initial `toggle`
        // event has already fired and our listener below would miss it. Start
        // observing immediately so the first measurement still happens.
        if ($eb7612906dd2d851$var$isPopoverOpen(popover)) {
            hideUntilPositioned();
            resizeObserver.observe(popover);
        }
        var undoPositioning = (0, $21ff8a276eb37634$export$1be1fc439b849fdf)(cleanupBaseStyles, // Each open needs a fresh measurement, so hide and re-observe.
        (0, $5b617c1f48263075$exports.bind)(popover, {
            type: 'toggle',
            listener: function listener(event) {
                var toggleEvent = event;
                if (toggleEvent.newState === 'open') {
                    hideUntilPositioned();
                    resizeObserver.observe(popover);
                }
            }
        }), function() {
            return resizeObserver.disconnect();
        }, (0, $5b617c1f48263075$exports.bind)(window, {
            type: 'scroll',
            listener: scheduledUpdate,
            options: {
                capture: true,
                passive: true
            }
        }), (0, $5b617c1f48263075$exports.bind)(window, {
            type: 'resize',
            listener: scheduledUpdate,
            options: {
                passive: true
            }
        }), function() {
            scheduledUpdate.cancel();
            restorePosition();
            reveal();
        });
        return undoPositioning;
    }, [
        anchorRef,
        popoverRef,
        stablePlacement,
        forceFallbackPositioning,
        isEnabled,
        id,
        isOpen
    ]);
}



var $5FkrB = parcelRequire("5FkrB");

/**
 * A point in viewport coordinates (CSS pixels) at which the synthetic
 * anchor should be placed.
 *
 * Axis-named (`x`/`y`) rather than edge-named (`left`/`top`) so the
 * shape is unambiguous in RTL writing modes - there is no ambiguity
 * about whether a coordinate is logical (`inline-start`/`block-start`)
 * or physical (`left`/`top`). Viewport coordinates are always
 * physical, so we name them with the physical axis labels.
 */ /**
 * Styles the synthetic anchor as an invisible, zero-size point.
 * Dynamic `inset-*` overrides are written by the positioning effect.
 *
 * Uses `Object.assign` rather than Compiled CSS (element is outside the React tree)
 * or the internal `setStyle` helper (we own this element entirely - it is created
 * and removed by this hook - so the snapshot/restore semantics `setStyle`
 * provides for caller-owned elements would be dead work here).
 */ function $37eb367392e98963$var$applyStaticAnchorStyles(element) {
    Object.assign(element.style, {
        position: 'fixed',
        // `top`/`left` rather than `inset-block-start`/`inset-inline-start`
        // for consistency with the dynamic positioning effect below, which
        // uses physical properties (see comment there for the rationale).
        top: '0',
        left: '0',
        // Zero size - placement decides which side the popover sits on.
        width: '0',
        height: '0',
        // Prevent the overlay from intercepting pointer events.
        pointerEvents: 'none'
    });
}
function $37eb367392e98963$export$6f230729189a5b8a(_ref) {
    var popoverRef = _ref.popoverRef, placement = _ref.placement, getPoint = _ref.getPoint, _ref$isEnabled = _ref.isEnabled, isEnabled = _ref$isEnabled === void 0 ? true : _ref$isEnabled, isOpen = _ref.isOpen;
    var syntheticAnchorRef = (0, $5FkrB.useRef)(null);
    // `getPoint` is kept in a ref so the layout effect can call the
    // latest version without listing it as a dep - that would re-fire
    // on every render and re-latch the point.
    var getPointRef = (0, $5FkrB.useRef)(getPoint);
    getPointRef.current = getPoint;
    // Lazy element creation: the `<div>` is only created when both
    // `isEnabled` is true AND `getPoint()` returns a non-null point.
    // `useLayoutEffect` ensures the element exists before the inner
    // `useAnchorPosition` (also a layout effect) reads the ref.
    (0, $5FkrB.useLayoutEffect)(function() {
        if (!isEnabled) return;
        var point = getPointRef.current();
        if (!point) return;
        var anchor = document.createElement('div');
        anchor.setAttribute('aria-hidden', 'true');
        $37eb367392e98963$var$applyStaticAnchorStyles(anchor);
        // `point.x`/`y` are physical viewport coordinates (from
        // `MouseEvent.clientX/Y`), so map directly onto physical
        // `left`/`top`. This is RTL-safe: `position: fixed` + physical
        // insets is direction-independent. Using logical
        // `inset-inline-start` would need `viewportWidth - point.x` in
        // RTL to land at the same physical pixel.
        anchor.style.top = "".concat(point.y, "px");
        anchor.style.left = "".concat(point.x, "px");
        document.body.appendChild(anchor);
        syntheticAnchorRef.current = anchor;
        return function cleanup() {
            anchor.remove();
            syntheticAnchorRef.current = null;
        };
    }, [
        isEnabled
    ]);
    // Mirror `isEnabled` so both hooks stay in sync - when disabled,
    // neither this hook nor the inner one touches the popover, leaving
    // any other positioning the consumer has set up free to take effect.
    (0, $eb7612906dd2d851$export$56b02a1e583f953c)({
        anchorRef: syntheticAnchorRef,
        popoverRef: popoverRef,
        placement: placement,
        isEnabled: isEnabled,
        isOpen: isOpen
    });
}



function $a357cf5d0bf33cb3$export$9198c6c168be2eeb() {
    // `@atlaskit/ds-lib/use-id` already strips characters that React's
    // `useId` produces (`:`, `«`, `»`) which are invalid in HTML ID
    // tokens. The `popover-` prefix is purely for DOM debug clarity.
    return "popover-".concat((0, $c797bf80d6171378$export$f680877a34711e37)());
}



var $5FkrB = parcelRequire("5FkrB");


/**
 * Probes anchor SIZING, separately from `anchor-name` (see
 * `supportsAnchorPositioning`): some browsers have positioning but not sizing.
 * `once()` for SSR safety.
 */ var $ba07d06cb3944e4d$var$supportsAnchorSize = (0, $86089df3a0fd54eb$export$2e2bcd8739ae039)(function() {
    if (typeof window === 'undefined' || typeof CSS === 'undefined' || typeof CSS.supports !== 'function') return false;
    return CSS.supports('min-inline-size', 'anchor-size(self-inline)');
});
/**
 * The JS fallback's stand-in for `anchor-size(self-inline)`. `offsetWidth` / `offsetHeight` are
 * physical, so the axis is picked from the popover's `writing-mode`. Anything not horizontal is
 * treated as vertical, and an unknown or empty value falls back to `offsetWidth`.
 */ function $ba07d06cb3944e4d$var$getFallbackAnchorInlineSize(_ref) {
    var anchor = _ref.anchor, popover = _ref.popover;
    // `String()` because not every test environment implements `writing-mode`.
    var writingMode = String(getComputedStyle(popover).writingMode);
    var isVertical = writingMode.startsWith('vertical') || writingMode.startsWith('sideways');
    return isVertical ? anchor.offsetHeight : anchor.offsetWidth;
}
function $ba07d06cb3944e4d$export$7071d791a7b131ed(_ref2) {
    var mode = _ref2.mode, popoverRef = _ref2.popoverRef, anchorRef = _ref2.anchorRef, isOpen = _ref2.isOpen;
    (0, $5FkrB.useLayoutEffect)(function() {
        var node = popoverRef.current;
        if (!node) return;
        if (mode === 'match-anchor') {
            // No floor here: it would let the popover grow past the anchor.
            if ($ba07d06cb3944e4d$var$supportsAnchorSize()) return (0, $31cc8a3dab82cc8b$export$37a5fde709c1db82)({
                element: node,
                styles: [
                    {
                        property: 'inline-size',
                        value: 'anchor-size(self-inline)'
                    }
                ]
            });
            var anchor = anchorRef.current;
            if (anchor) return (0, $31cc8a3dab82cc8b$export$37a5fde709c1db82)({
                element: node,
                styles: [
                    {
                        property: 'inline-size',
                        value: "".concat($ba07d06cb3944e4d$var$getFallbackAnchorInlineSize({
                            anchor: anchor,
                            popover: node
                        }), "px")
                    }
                ]
            });
            return;
        }
        if (mode === 'min-anchor') {
            // One floor only. The content floor from mode 'none' deliberately does not also apply
            // here, and cannot: it would need this same property. See the decision note.
            if ($ba07d06cb3944e4d$var$supportsAnchorSize()) return (0, $31cc8a3dab82cc8b$export$37a5fde709c1db82)({
                element: node,
                styles: [
                    {
                        property: 'min-inline-size',
                        value: 'anchor-size(self-inline)'
                    }
                ]
            });
            var _anchor = anchorRef.current;
            if (_anchor) return (0, $31cc8a3dab82cc8b$export$37a5fde709c1db82)({
                element: node,
                styles: [
                    {
                        property: 'min-inline-size',
                        value: "".concat($ba07d06cb3944e4d$var$getFallbackAnchorInlineSize({
                            anchor: _anchor,
                            popover: node
                        }), "px")
                    }
                ]
            });
            // Nothing to measure, so no floor.
            return;
        }
        // Makes a too-narrow span overflow and drive `position-try-fallbacks` instead of wrapping.
        // `@atlaskit/popper` resets this exact property to `0` for its fit-to-viewport mode.
        return (0, $31cc8a3dab82cc8b$export$37a5fde709c1db82)({
            element: node,
            styles: [
                {
                    property: 'min-inline-size',
                    value: 'max-content'
                }
            ]
        });
    }, [
        mode,
        popoverRef,
        anchorRef,
        isOpen
    ]);
}



function $ef6e6bba330bb3cb$export$175375e9a2b5515d() {
    var document = (0, $fc5ac9c99de29fbb$export$f65ca476c09acec0)();
    if (!document) return false;
    return document.dir === 'rtl' || document.body.dir === 'rtl' || document.documentElement.dir === 'rtl';
}


/**
 * Reduces an anchor rect to the single viewport point that, wrapped in a
 * zero-size synthetic anchor, produces the same popover position
 * `useAnchorPosition` would for the given placement. This works because
 * `useAnchorPosition` only reads the edge / alignment corner of the rect,
 * so a coincident zero-size point is geometrically equivalent.
 *
 * RTL is resolved here so the downstream synthetic anchor only sees physical
 * coordinates. Defaults mirror `getPlacement` in
 * `@atlaskit/top-layer/placement-map` (`axis: 'block'`, `edge: 'end'`,
 * `align: 'center'`).
 */ function $ac37252925604701$export$b065aeb850c3e87f(_ref) {
    var _placement$axis, _placement$edge, _placement$align;
    var rect = _ref.rect, placement = _ref.placement, isRtl = _ref.isRtl;
    var axis = (_placement$axis = placement.axis) !== null && _placement$axis !== void 0 ? _placement$axis : 'block';
    var edge = (_placement$edge = placement.edge) !== null && _placement$edge !== void 0 ? _placement$edge : 'end';
    var align = (_placement$align = placement.align) !== null && _placement$align !== void 0 ? _placement$align : 'center';
    if (axis === 'block') {
        // Popover sits above (`edge: 'start'`) or below (`edge: 'end'`)
        // the anchor. Hug the matching horizontal edge; align along x.
        var _y = edge === 'start' ? rect.top : rect.bottom;
        var _x = $ac37252925604701$var$horizontalForAlign({
            rect: rect,
            align: align,
            isRtl: isRtl
        });
        return {
            x: _x,
            y: _y
        };
    }
    // `axis: 'inline'`: popover sits inline-start or inline-end of the
    // anchor. Hug the matching vertical edge; align along y.
    var x = $ac37252925604701$var$inlineEdgeX({
        rect: rect,
        edge: edge,
        isRtl: isRtl
    });
    var y = $ac37252925604701$var$verticalForAlign({
        rect: rect,
        align: align
    });
    return {
        x: x,
        y: y
    };
}
function $ac37252925604701$var$horizontalForAlign(_ref2) {
    var rect = _ref2.rect, align = _ref2.align, isRtl = _ref2.isRtl;
    if (align === 'center') return rect.left + rect.width / 2;
    // `start` / `end` are logical. In LTR, `start` is the left edge.
    // In RTL, `start` is the right edge.
    var isStartLeft = !isRtl;
    if (align === 'start') return isStartLeft ? rect.left : rect.right;
    return isStartLeft ? rect.right : rect.left;
}
function $ac37252925604701$var$verticalForAlign(_ref3) {
    var rect = _ref3.rect, align = _ref3.align;
    if (align === 'center') return rect.top + rect.height / 2;
    if (align === 'start') return rect.top;
    return rect.bottom;
}
function $ac37252925604701$var$inlineEdgeX(_ref4) {
    var rect = _ref4.rect, edge = _ref4.edge, isRtl = _ref4.isRtl;
    var isStartLeft = !isRtl;
    if (edge === 'start') return isStartLeft ? rect.left : rect.right;
    return isStartLeft ? rect.right : rect.left;
}


/**
 * `@popperjs/core`'s `Placement` union is a strict subset of `TLegacyPlacement`
 * (the placement-map adds `top-center` / `bottom-center` on top of popper's
 * enum), so every value popper hands us is a valid legacy placement.
 *
 * The cast keeps the runtime path free of an extra module-level lookup that
 * bundlers can occasionally fail to wire up (observed as `Cannot read
 * properties of undefined (reading 'includes')` in component-test bundles).
 *
 * Shared so the React and imperative popper adapters resolve this identically.
 */ function $9131825d85e58b66$export$e9a6fdb80170ffd(placement) {
    return placement;
}




var $5FkrB = parcelRequire("5FkrB");
/**
 * Sets inline styles on an element and returns a cleanup function that
 * restores the prior inline values (so we do not stomp consumer styles).
 *
 * Copied from `@atlaskit/top-layer`'s internal `setStyle` (not exported there
 * yet); inline here until top-layer exposes it via a subpath export.
 */ function $eb99cdd5a53c0db8$export$37a5fde709c1db82(_ref) {
    var element = _ref.element, styles = _ref.styles;
    // Snapshot the prior inline value (NOT the computed style - we only want
    // to restore values that the consumer/our previous run inlined). An empty
    // string means "no inline value", in which case cleanup uses removeProperty.
    var priorValues = styles.map(function(_ref2) {
        var property = _ref2.property;
        return {
            property: property,
            value: element.style.getPropertyValue(property)
        };
    });
    styles.forEach(function(_ref3) {
        var property = _ref3.property, value = _ref3.value;
        element.style.setProperty(property, value);
    });
    return function cleanup() {
        priorValues.forEach(function(_ref4) {
            var property = _ref4.property, value = _ref4.value;
            if (value === '') {
                element.style.removeProperty(property);
                return;
            }
            element.style.setProperty(property, value);
        });
    };
}


/**
 * Applies the `shouldFitViewport` size caps directly to the
 * `position-area`-anchored popover host. Pure CSS — the browser owns every
 * value, so there is no measurement, no scroll/resize listeners, and no
 * `--ds-popper-anchor-*` custom properties.
 *
 * **Primary (placement) axis** is capped to `calc(100% - 5px - gap)`. Because
 * the host carries `position-area`, its containing block *is* the position-area
 * cell — the region between the anchor edge and the viewport edge — so `100%`
 * resolves to that distance. The popover is pushed `gap` into the cell by its
 * offset margin (`margin-*`, set by `useAnchorPosition`), so the gap is
 * subtracted as well to keep the legacy `viewportPadding = 5` on the far edge.
 * The cap is also more correct than measuring the requested placement: the cell
 * follows whichever side `position-try-fallbacks` actually flips to, so it
 * tracks the flip automatically.
 *
 * **Cross axis** is capped to `calc(100dvw|dvh - 10px)` (viewport, legacy
 * `2 * viewportPadding`). `display: flex` (plus a `min-*-size: 0` reset on the
 * child) lets an oversized child shrink and reflow to the cap. The host stays
 * `overflow: visible` so it never clips the consumer surface's `box-shadow`;
 * scrolling content that cannot reflow is the consumer surface's own
 * responsibility (it owns `overflow`), matching legacy `react-popper`, which
 * applied the cap to the consumer's own element.
 *
 * `min-inline-size` is reset to `0`. `useWidthFromAnchor({ mode: 'none' })`
 * floors the host at `max-content` so a too-narrow span overflows and drives
 * `position-try-fallbacks` rather than wrapping. That floor is the opposite of
 * fitting: when it exceeds a cap, CSS min/max resolution lets the min win and
 * the host overflows the viewport. In fit mode the caps must win, so the floor
 * is neutralised here; `setStyle` restores the prior inline value on cleanup.
 *
 * Verified in Chromium: `max-block-size: calc(100% - …)` on a `position: fixed`
 * + `position-area` element resolves `100%` to the cell, not the viewport.
 */ var $01187bfef3ee88f5$var$CROSS_INLINE_CAP = 'calc(100dvw - 10px)';
var $01187bfef3ee88f5$var$CROSS_BLOCK_CAP = 'calc(100dvh - 10px)';
/**
 * Legacy `viewportPadding` (`preventOverflow` padding) the popover kept from
 * every viewport edge under `react-popper`. The caps above already *reserve*
 * this space (`- 5px` on the primary far edge, `- 10px` = `2 * 5px` on the
 * cross axis), but nothing makes the reservation land on the viewport side:
 * the anchor-side gap is a real margin (`useAnchorPosition`'s `edgeMargin`),
 * the viewport side has none, so a capped popover packs flush against the
 * viewport edge it slid/flipped to. Re-applying the padding as a margin on the
 * three non-anchor sides puts the reserved space back on the viewport side.
 * `position-try` flips mirror margins and slides keep them per-side, so the
 * gap tracks whichever edge the browser settles on.
 */ var $01187bfef3ee88f5$var$VIEWPORT_PADDING = '5px';
/**
 * The popover's three non-anchor margin sides for a given placement axis — the
 * primary *far* side plus both cross sides. The remaining (anchor-facing) side
 * already carries the offset gap from `useAnchorPosition` and is left alone.
 */ var $01187bfef3ee88f5$var$NON_ANCHOR_MARGIN_SIDES = {
    top: [
        'margin-block-start',
        'margin-inline-start',
        'margin-inline-end'
    ],
    bottom: [
        'margin-block-end',
        'margin-inline-start',
        'margin-inline-end'
    ],
    left: [
        'margin-inline-start',
        'margin-block-start',
        'margin-block-end'
    ],
    right: [
        'margin-inline-end',
        'margin-block-start',
        'margin-block-end'
    ]
};
function $01187bfef3ee88f5$export$f16d8ac7373995e1(_ref) {
    var target = _ref.target, placementAxis = _ref.placementAxis, gap = _ref.gap, isEnabled = _ref.isEnabled, isOpen = _ref.isOpen;
    (0, $5FkrB.useLayoutEffect)(function() {
        var element = target.current;
        if (!element || !isEnabled) return;
        var isBlockAxis = placementAxis === 'top' || placementAxis === 'bottom';
        var primaryAxisCap = "calc(100% - 5px - ".concat(gap, ")");
        var cleanupHost = (0, $eb99cdd5a53c0db8$export$37a5fde709c1db82)({
            element: element,
            styles: [
                {
                    property: 'display',
                    value: 'flex'
                },
                // Neutralise `useWidthFromAnchor`'s `min-inline-size: max-content`
                // floor so the caps below win and content reflows. `setStyle`
                // restores the floor on cleanup.
                //
                // This package only uses `mode: 'none'`. Note that `mode: 'min-anchor'`
                // puts its ANCHOR floor on the same property, so pairing this hook with
                // that mode would drop the anchor floor rather than a content floor. See
                // `@atlaskit/top-layer` `notes/decisions/width-from-anchor-floors.md`.
                {
                    property: 'min-inline-size',
                    value: '0'
                },
                isBlockAxis ? {
                    property: 'max-block-size',
                    value: primaryAxisCap
                } : {
                    property: 'max-inline-size',
                    value: primaryAxisCap
                },
                isBlockAxis ? {
                    property: 'max-inline-size',
                    value: $01187bfef3ee88f5$var$CROSS_INLINE_CAP
                } : {
                    property: 'max-block-size',
                    value: $01187bfef3ee88f5$var$CROSS_BLOCK_CAP
                }
            ].concat((0, $ad44204fc1b4beec$export$2e2bcd8739ae039)($01187bfef3ee88f5$var$NON_ANCHOR_MARGIN_SIDES[placementAxis].map(function(property) {
                return {
                    property: property,
                    value: $01187bfef3ee88f5$var$VIEWPORT_PADDING
                };
            })))
        });
        // The host deliberately stays `overflow: visible`. An ancestor with
        // `overflow: auto` clips a descendant's `box-shadow`, so capping and
        // scrolling on the host would strip the elevation shadow from the
        // consumer surface. Instead the host only constrains size; scrolling
        // oversized content is the consumer surface's own responsibility,
        // matching the contract `@atlaskit/top-layer`'s `PopoverSurface` follows
        // (shadow and `overflow` on one element). For that surface (the host's
        // flex child) to be clamped to the cap and scroll its own content, it
        // must be allowed to shrink below its intrinsic size, so reset its
        // min-size floor.
        var child = element.firstElementChild;
        var cleanupChild = child instanceof HTMLElement ? (0, $eb99cdd5a53c0db8$export$37a5fde709c1db82)({
            element: child,
            styles: [
                {
                    property: 'min-block-size',
                    value: '0'
                },
                {
                    property: 'min-inline-size',
                    value: '0'
                }
            ]
        }) : undefined;
        return function() {
            cleanupHost();
            cleanupChild === null || cleanupChild === void 0 || cleanupChild();
        };
    }, [
        target,
        placementAxis,
        gap,
        isEnabled,
        isOpen
    ]);
}



var $5FkrB = parcelRequire("5FkrB");

function $fa3caa28ee3fa48d$export$941a7e8bf0b9eafd() {
    return (0, $5FkrB.useContext)((0, $59650a99191b9498$export$8f73317645bb7b8e));
}




var $5FkrB = parcelRequire("5FkrB");

/**
 * Returns the current viewport size in CSS pixels, preferring the visual
 * viewport (which accounts for pinch-zoom on touch devices) over the
 * layout viewport. Returns `{ width: 0, height: 0 }` in non-DOM
 * environments so callers can use the result unconditionally.
 */ function $cd09d2d12908ffa2$export$64beed533e21f72d() {
    if (typeof window === 'undefined') return {
        width: 0,
        height: 0
    };
    var visual = window.visualViewport;
    if (visual) return {
        width: visual.width,
        height: visual.height
    };
    return {
        width: window.innerWidth,
        height: window.innerHeight
    };
}


var $1521947eb8be1cc3$var$INITIAL = {
    isReferenceHidden: false,
    hasPopperEscaped: false
};
function $1521947eb8be1cc3$var$isFullyOutsideViewport(rect, viewport) {
    if (rect.width === 0 && rect.height === 0) return true;
    if (rect.bottom <= 0) return true;
    if (rect.right <= 0) return true;
    if (rect.top >= viewport.height) return true;
    if (rect.left >= viewport.width) return true;
    return false;
}
function $1521947eb8be1cc3$var$isClippingOverflow(value) {
    return value === 'auto' || value === 'scroll' || value === 'hidden' || value === 'clip';
}
function $1521947eb8be1cc3$var$isClippedByAncestors(element) {
    var rect = element.getBoundingClientRect();
    var parent = element.parentElement;
    while(parent){
        // Read the longhand axis properties directly. The `overflow` shorthand
        // is only populated when both axes share the same value, so reading it
        // alone misses ancestors that set only `overflow-x` or `overflow-y`.
        var style = window.getComputedStyle(parent);
        var clipsHorizontally = $1521947eb8be1cc3$var$isClippingOverflow(style.overflowX);
        var clipsVertically = $1521947eb8be1cc3$var$isClippingOverflow(style.overflowY);
        if (clipsHorizontally || clipsVertically) {
            var parentRect = parent.getBoundingClientRect();
            var horizontallyOutside = rect.right <= parentRect.left || rect.left >= parentRect.right;
            var verticallyOutside = rect.bottom <= parentRect.top || rect.top >= parentRect.bottom;
            if (clipsHorizontally && horizontallyOutside) return true;
            if (clipsVertically && verticallyOutside) return true;
        }
        parent = parent.parentElement;
    }
    return false;
}
function $1521947eb8be1cc3$export$61d36e2b682e92f7(_ref) {
    var anchor = _ref.anchor, popoverRef = _ref.popoverRef;
    var _useState = (0, $5FkrB.useState)($1521947eb8be1cc3$var$INITIAL), _useState2 = (0, $0a1610bce965fec6$export$2e2bcd8739ae039)(_useState, 2), visibility = _useState2[0], setVisibility = _useState2[1];
    var measure = (0, $5FkrB.useCallback)(function() {
        if (!anchor) {
            setVisibility(function(previous) {
                return previous.isReferenceHidden === false && previous.hasPopperEscaped === false ? previous : $1521947eb8be1cc3$var$INITIAL;
            });
            return;
        }
        var viewport = (0, $cd09d2d12908ffa2$export$64beed533e21f72d)();
        var anchorRect = anchor.getBoundingClientRect();
        var isReferenceHidden = $1521947eb8be1cc3$var$isFullyOutsideViewport(anchorRect, viewport) || $1521947eb8be1cc3$var$isClippedByAncestors(anchor);
        var popoverElement = popoverRef.current;
        var hasPopperEscaped = popoverElement ? $1521947eb8be1cc3$var$isFullyOutsideViewport(popoverElement.getBoundingClientRect(), viewport) : false;
        setVisibility(function(previous) {
            if (previous.isReferenceHidden === isReferenceHidden && previous.hasPopperEscaped === hasPopperEscaped) return previous;
            return {
                isReferenceHidden: isReferenceHidden,
                hasPopperEscaped: hasPopperEscaped
            };
        });
    }, [
        anchor,
        popoverRef
    ]);
    (0, $5FkrB.useLayoutEffect)(function() {
        measure();
        if (typeof window === 'undefined') return undefined;
        var cleanups = [];
        // Resize observer on the anchor so layout changes update visibility.
        if (anchor && typeof ResizeObserver !== 'undefined') {
            var observer = new ResizeObserver(function() {
                return measure();
            });
            observer.observe(anchor);
            cleanups.push(function() {
                return observer.disconnect();
            });
        }
        // Scroll + resize: any scroll event in the document can move the
        // anchor in/out of any scrollable ancestor's viewport.
        cleanups.push((0, $5b617c1f48263075$exports.bindAll)(window, [
            {
                type: 'scroll',
                listener: measure,
                options: {
                    capture: true,
                    passive: true
                }
            },
            {
                type: 'resize',
                listener: measure,
                options: {
                    passive: true
                }
            }
        ]));
        var visual = window.visualViewport;
        if (visual) cleanups.push((0, $5b617c1f48263075$exports.bind)(visual, {
            type: 'resize',
            listener: measure,
            options: {
                passive: true
            }
        }));
        return function() {
            cleanups.forEach(function(cleanup) {
                return cleanup();
            });
        };
    }, [
        anchor,
        measure
    ]);
    return visibility;
}


/**
 * Inert render-prop values. The browser owns positioning under CSS Anchor
 * Positioning, so `style` / `ref` / `arrowProps` / `update` / `forceUpdate`
 * are no-ops that consumers can safely spread. Module scope keeps identities
 * stable for effect dep arrays.
 */ var $f01fa1d8348a181d$var$noopStyle = {};
var $f01fa1d8348a181d$var$noopSetRef = (0, $adcefb868cf2fc9d$export$2e2bcd8739ae039);
var $f01fa1d8348a181d$var$noopUpdate = function noopUpdate() {
    return Promise.resolve(null);
};
var $f01fa1d8348a181d$var$noopForceUpdate = function noopForceUpdate() {
    return {};
};
/**
 * `react-popper` stamps `data-popper-arrow` on the arrow element at runtime
 * but does not declare it on `arrowProps`. Widen the type so consumers that
 * rely on the attribute (CSS selectors, snapshots, tests) keep working.
 */ var $f01fa1d8348a181d$var$noopArrowProps = {
    ref: $f01fa1d8348a181d$var$noopSetRef,
    style: $f01fa1d8348a181d$var$noopStyle,
    'data-popper-arrow': true
};
/**
 * Returns the primary axis (`top` / `bottom` / `left` / `right`) of a popper
 * placement, used to pick which axis `useFitViewportMaxSize` caps to the
 * anchor edge.
 */ function $f01fa1d8348a181d$var$getPlacementAxis(placement) {
    if (placement.startsWith('top')) return 'top';
    if (placement.startsWith('bottom')) return 'bottom';
    if (placement.startsWith('left')) return 'left';
    if (placement.startsWith('right')) return 'right';
    // `auto*` placements have no fixed axis. Default to `bottom` to match the
    // `auto -> block-end` mapping in `fromLegacyPlacement`.
    return 'bottom';
}
/**
 * Normalises popper's `[along, away]` offset (which may include `null` or
 * `undefined` entries) into the `[along, away]` number tuple
 * `fromLegacyPlacement` expects.
 */ function $f01fa1d8348a181d$var$popperToTopLayerOffset(offset) {
    if (!offset) return undefined;
    var _offset = (0, $0a1610bce965fec6$export$2e2bcd8739ae039)(offset, 2), along = _offset[0], away = _offset[1];
    if (along == null && away == null) return undefined;
    return [
        along !== null && along !== void 0 ? along : 0,
        away !== null && away !== void 0 ? away : 0
    ];
}
function $f01fa1d8348a181d$export$9802f50720ab826e(_ref) {
    var _ref2;
    var children = _ref.children, offset = _ref.offset, _ref$placement = _ref.placement, placement = _ref$placement === void 0 ? 'bottom-start' : _ref$placement, referenceElement = _ref.referenceElement, _ref$shouldFitViewpor = _ref.shouldFitViewport, shouldFitViewport = _ref$shouldFitViewpor === void 0 ? false : _ref$shouldFitViewpor;
    // `modifiers` and `strategy` are accepted for source compatibility but have
    // no runtime effect; CSS Anchor Positioning + top-layer rendering replaces
    // them. See `top-layer/notes/migrations/popper-migration.md`.
    // Anchor resolution: `referenceElement` prop, then `<Manager>` context.
    var managerAnchor = (0, $fa3caa28ee3fa48d$export$941a7e8bf0b9eafd)();
    var effectiveReference = (_ref2 = referenceElement !== null && referenceElement !== void 0 ? referenceElement : managerAnchor) !== null && _ref2 !== void 0 ? _ref2 : undefined;
    // Real DOM nodes go to `useAnchorPosition`; popper `VirtualElement`s are
    // bridged through `useAnchorPositionAtPoint`, which owns its own synthetic
    // anchor.
    var htmlAnchor = effectiveReference instanceof HTMLElement ? effectiveReference : null;
    var virtualReference = effectiveReference != null && !(effectiveReference instanceof HTMLElement) ? effectiveReference : null;
    var htmlAnchorRef = (0, $5FkrB.useRef)(htmlAnchor);
    htmlAnchorRef.current = htmlAnchor;
    var popoverRef = (0, $5FkrB.useRef)(null);
    var popoverId = (0, $a357cf5d0bf33cb3$export$9198c6c168be2eeb)();
    // Track the resolved DOM anchor in state so visibility / max-size hooks
    // re-run when its identity changes. Virtual anchors do not feed these
    // hooks because their probe is outside the consumer's DOM.
    //
    // Adjust state during render by comparing against the state itself: the
    // conditional guard means `setResolvedAnchor` is skipped once they match,
    // so it converges in one extra render. This is the React-documented pattern
    // and is side-effect-free — no ref mutation during render.
    var _useState = (0, $5FkrB.useState)(htmlAnchor), _useState2 = (0, $0a1610bce965fec6$export$2e2bcd8739ae039)(_useState, 2), resolvedAnchor = _useState2[0], setResolvedAnchor = _useState2[1];
    if (resolvedAnchor !== htmlAnchor) setResolvedAnchor(htmlAnchor);
    var topLayerPlacement = (0, $5FkrB.useMemo)(function() {
        return (0, $2ac73d5cb9e11b1f$export$69e99ed50b2534c9)({
            legacy: (0, $9131825d85e58b66$export$e9a6fdb80170ffd)(placement),
            offset: $f01fa1d8348a181d$var$popperToTopLayerOffset(offset)
        });
    }, [
        placement,
        offset
    ]);
    var isOpen = effectiveReference != null;
    // HTML-element path. No-op when the reference is virtual or absent.
    (0, $eb7612906dd2d851$export$56b02a1e583f953c)({
        anchorRef: htmlAnchorRef,
        popoverRef: popoverRef,
        placement: topLayerPlacement,
        isEnabled: htmlAnchor != null,
        isOpen: isOpen
    });
    // Virtual-element path. `useAnchorPositionAtPoint` owns a synthetic
    // anchor in `document.body` and latches `getPoint` once per
    // `isEnabled` activation. Reading the latest `virtualReference` and
    // `topLayerPlacement` via refs ensures the latched closure always
    // sees the current values rather than the ones captured at first
    // activation, which would otherwise go stale if either prop changes
    // while the popper stays open.
    var virtualReferenceRef = (0, $5FkrB.useRef)(virtualReference);
    virtualReferenceRef.current = virtualReference;
    var topLayerPlacementRef = (0, $5FkrB.useRef)(topLayerPlacement);
    topLayerPlacementRef.current = topLayerPlacement;
    var isVirtualEnabled = virtualReference != null;
    (0, $37eb367392e98963$export$6f230729189a5b8a)({
        popoverRef: popoverRef,
        placement: topLayerPlacement,
        isEnabled: isVirtualEnabled,
        isOpen: isOpen,
        getPoint: function getPoint() {
            var current = virtualReferenceRef.current;
            if (!current) return null;
            return (0, $ac37252925604701$export$b065aeb850c3e87f)({
                rect: current.getBoundingClientRect(),
                placement: topLayerPlacementRef.current,
                isRtl: (0, $ef6e6bba330bb3cb$export$175375e9a2b5515d)()
            });
        }
    });
    var _useReferenceVisibili = (0, $1521947eb8be1cc3$export$61d36e2b682e92f7)({
        anchor: resolvedAnchor,
        popoverRef: popoverRef
    }), isReferenceHidden = _useReferenceVisibili.isReferenceHidden, hasPopperEscaped = _useReferenceVisibili.hasPopperEscaped;
    // Restore legacy `react-popper`'s natural-width behaviour. Under CSS
    // Anchor Positioning the `position-area` grid cell becomes the popover
    // host's containing block, so an auto-width host shrinks to that cell.
    // When the anchor sits near a viewport edge the cell is narrow, so the
    // content wraps far more than it did under `react-popper` (which kept the
    // content's natural width and shifted/flipped to stay on screen).
    // `min-inline-size: max-content` (mode `'none'`) floors the host at its
    // content's intrinsic width, so a too-narrow span overflows the viewport
    // (driving `position-try-fallbacks`) instead of wrapping. This is safe
    // alongside `shouldFitViewport`: the fit caps clamp the host on both axes,
    // so the host never exceeds the viewport / anchor-edge cap.
    (0, $ba07d06cb3944e4d$export$7071d791a7b131ed)({
        mode: 'none',
        popoverRef: popoverRef,
        anchorRef: htmlAnchorRef,
        isOpen: isOpen
    });
    // `shouldFitViewport` caps are applied directly to the `position-area`
    // host, whose containing block is the cell between the anchor edge and the
    // viewport edge — so a pure-CSS `calc(100% - 5px - gap)` reproduces the
    // legacy per-placement anchor-edge cap with no measurement. The gap mirrors
    // `getPlacement`: an omitted offset resolves to `space.100`, otherwise the
    // consumer's `away` value.
    var resolvedOffset = $f01fa1d8348a181d$var$popperToTopLayerOffset(offset);
    var fitGap = resolvedOffset ? "".concat(resolvedOffset[1], "px") : "var(--ds-space-100, 8px)";
    var placementAxis = $f01fa1d8348a181d$var$getPlacementAxis(placement);
    (0, $01187bfef3ee88f5$export$f16d8ac7373995e1)({
        target: popoverRef,
        placementAxis: placementAxis,
        gap: fitGap,
        isEnabled: shouldFitViewport,
        isOpen: isOpen
    });
    var renderChildren = children;
    if (typeof renderChildren !== 'function') return null;
    var renderPropArg = {
        ref: $f01fa1d8348a181d$var$noopSetRef,
        style: $f01fa1d8348a181d$var$noopStyle,
        placement: placement,
        isReferenceHidden: isReferenceHidden,
        hasPopperEscaped: hasPopperEscaped,
        update: $f01fa1d8348a181d$var$noopUpdate,
        forceUpdate: $f01fa1d8348a181d$var$noopForceUpdate,
        arrowProps: $f01fa1d8348a181d$var$noopArrowProps
    };
    var content = renderChildren(renderPropArg);
    // The `shouldFitViewport` size caps live on the `<Popover>` host itself
    // (applied by `useFitViewportMaxSize` above), so the consumer's content is
    // rendered directly with no intermediate wrapper.
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $8ad5ab271a034ac0$export$5b6b19405a83ff9d), {
        ref: popoverRef,
        id: popoverId,
        isOpen: isOpen,
        mode: "manual",
        shouldAnimate: false
    }, content);
}



// Export types from PopperJS / React Popper
var $42e5b75ea169c552$var$viewportPadding = 5;
var $42e5b75ea169c552$var$constantModifiers = [
    {
        name: 'flip',
        options: {
            flipVariations: false,
            padding: $42e5b75ea169c552$var$viewportPadding,
            boundary: 'clippingParents',
            rootBoundary: 'viewport'
        }
    }
];
function $42e5b75ea169c552$var$defaultChildrenFn() {
    return null;
}
var $42e5b75ea169c552$var$defaultOffset = [
    0,
    8
];
function $42e5b75ea169c552$export$badac9ada3a0bdf9(_ref) {
    var children = _ref.children, offset = _ref.offset, placement = _ref.placement, referenceElement = _ref.referenceElement, modifiers = _ref.modifiers, strategy = _ref.strategy, shouldFitViewport = _ref.shouldFitViewport;
    // The FF check sits at the very top of the public Popper so the
    // rest of the function (which has its own hooks) does not violate
    // the rules of hooks. Each branch is its own component with its
    // own complete hook order. Props are forwarded explicitly to
    // satisfy `no-unsafe-spread-props`.
    if ((0, $50U6m.fg)('platform-dst-top-layer')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $f01fa1d8348a181d$export$9802f50720ab826e), {
        children: children,
        offset: offset,
        placement: placement,
        referenceElement: referenceElement,
        modifiers: modifiers,
        strategy: strategy,
        shouldFitViewport: shouldFitViewport
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement($42e5b75ea169c552$var$LegacyPopper, {
        children: children,
        offset: offset,
        placement: placement,
        referenceElement: referenceElement,
        modifiers: modifiers,
        strategy: strategy,
        shouldFitViewport: shouldFitViewport
    });
}
function $42e5b75ea169c552$var$LegacyPopper(_ref2) {
    var _ref2$children = _ref2.children, children = _ref2$children === void 0 ? $42e5b75ea169c552$var$defaultChildrenFn : _ref2$children, _ref2$offset = _ref2.offset, offset = _ref2$offset === void 0 ? $42e5b75ea169c552$var$defaultOffset : _ref2$offset, _ref2$placement = _ref2.placement, placement = _ref2$placement === void 0 ? 'bottom-start' : _ref2$placement, _ref2$referenceElemen = _ref2.referenceElement, referenceElement = _ref2$referenceElemen === void 0 ? undefined : _ref2$referenceElemen, modifiers = _ref2.modifiers, _ref2$strategy = _ref2.strategy, strategy = _ref2$strategy === void 0 ? 'fixed' : _ref2$strategy, _ref2$shouldFitViewpo = _ref2.shouldFitViewport, shouldFitViewport = _ref2$shouldFitViewpo === void 0 ? false : _ref2$shouldFitViewpo;
    var _offset = (0, $0a1610bce965fec6$export$2e2bcd8739ae039)(offset, 2), offsetX = _offset[0], offsetY = _offset[1];
    var internalModifiers = (0, $5FkrB.useMemo)(function() {
        var preventOverflowModifier = {
            name: 'preventOverflow',
            options: {
                padding: $42e5b75ea169c552$var$viewportPadding,
                rootBoundary: shouldFitViewport ? 'viewport' : 'document'
            }
        };
        var offsetModifier = {
            name: 'offset',
            options: {
                offset: [
                    offsetX,
                    offsetY
                ]
            }
        };
        var maxSizeModifiers = shouldFitViewport ? (0, $ed28843bb38c002b$export$6d8c2b45c99d6e3f)({
            viewportPadding: $42e5b75ea169c552$var$viewportPadding
        }) : [];
        return [].concat($42e5b75ea169c552$var$constantModifiers, [
            preventOverflowModifier,
            offsetModifier
        ], (0, $ad44204fc1b4beec$export$2e2bcd8739ae039)(maxSizeModifiers));
    }, [
        offsetX,
        offsetY,
        shouldFitViewport
    ]);
    // Merge custom props and memoize
    var mergedModifiers = (0, $5FkrB.useMemo)(function() {
        if (modifiers == null) return internalModifiers;
        return [].concat((0, $ad44204fc1b4beec$export$2e2bcd8739ae039)(internalModifiers), (0, $ad44204fc1b4beec$export$2e2bcd8739ae039)(modifiers));
    }, [
        internalModifiers,
        modifiers
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $f9e8ed8665cc0109$export$badac9ada3a0bdf9), {
        modifiers: mergedModifiers,
        placement: placement,
        strategy: strategy,
        referenceElement: referenceElement
    }, children);
}



var $5FkrB = parcelRequire("5FkrB");
var $a7edaecb351c1789$export$51eddd7655ca235a = function RepositionOnUpdate(_ref) {
    var children = _ref.children, update = _ref.update;
    // Ref used here to skip update on first render (when refs haven't been set)
    var isFirstRenderRef = (0, $5FkrB.useRef)(true);
    (0, $5FkrB.useLayoutEffect)(function() {
        if (isFirstRenderRef.current) {
            isFirstRenderRef.current = false;
            return;
        }
        // callback function from popper that repositions pop-up on content Update.
        // Guard against `update` being undefined: on Safari the Popper instance may
        // not be fully initialised when this layout effect fires, in which case the
        // render-prop `update` is undefined and calling it throws
        // `TypeError: e.update is not a function`.
        if (typeof update === 'function') update();
    }, [
        update
    ]);
    // wrapping in fragment to make TS happy (known issue with FC returning children)
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $5FkrB.Fragment), null, children);
};


// eslint-disable-next-line no-duplicate-imports

var $5FkrB = parcelRequire("5FkrB");




var $50U6m = parcelRequire("50U6m");
var $864d026677cce2dd$var$interactiveTags = [
    'button',
    'a',
    'input',
    'select',
    'textarea'
];
var $864d026677cce2dd$export$3dee5e4542c672d9 = function isInteractiveElement(element) {
    if ($864d026677cce2dd$var$interactiveTags.includes(element.tagName.toLowerCase())) return true;
    if (element.getAttribute('tabindex') !== null || element.hasAttribute('contenteditable')) return true;
    return false;
};



var $5FkrB = parcelRequire("5FkrB");
var $28deab68320ef15f$export$641fa9c94086b46e = function useAnimationFrame() {
    var animationsRef = (0, $5FkrB.useRef)([]);
    var requestFrame = (0, $5FkrB.useCallback)(function(callback) {
        var id = requestAnimationFrame(callback);
        animationsRef.current.push(id);
        return id;
    }, []);
    var cancelFrame = (0, $5FkrB.useCallback)(function(id) {
        cancelAnimationFrame(id);
        animationsRef.current = animationsRef.current.filter(function(frameId) {
            return frameId !== id;
        });
    }, []);
    var cancelAllFrames = (0, $5FkrB.useCallback)(function() {
        animationsRef.current.forEach(function(id) {
            return cancelAnimationFrame(id);
        });
        animationsRef.current = [];
    }, []);
    return {
        requestFrame: requestFrame,
        cancelFrame: cancelFrame,
        cancelAllFrames: cancelAllFrames
    };
};


var $ead5479bf2690ca1$export$92dae2778ae88f9d = function useCloseManager(_ref) {
    var isOpen = _ref.isOpen, onClose = _ref.onClose, popupRef = _ref.popupRef, triggerRef = _ref.triggerRef, autoFocus = _ref.autoFocus, shouldDisableFocusTrap = _ref.shouldDisableFocusTrap, capture = _ref.shouldUseCaptureOnOutsideClick, shouldIgnoreCloseEvent = _ref.shouldIgnoreCloseEvent, shouldCloseOnTab = _ref.shouldCloseOnTab, shouldRenderToParent = _ref.shouldRenderToParent;
    var _useLayering = (0, $7df5ec948c08a88e$export$c8b4d54e03dee6ed)(), isLayerDisabled = _useLayering.isLayerDisabled, currentLevel = _useLayering.currentLevel;
    var _useAnimationFrame = (0, $28deab68320ef15f$export$641fa9c94086b46e)(), requestFrame = _useAnimationFrame.requestFrame, cancelAllFrames = _useAnimationFrame.cancelAllFrames;
    var mouseDownTarget = (0, $5FkrB.useRef)(null);
    (0, $5FkrB.useEffect)(function() {
        if (!isOpen || !popupRef) return 0, $adcefb868cf2fc9d$export$2e2bcd8739ae039;
        var closePopup = function closePopup(event) {
            if (shouldIgnoreCloseEvent !== null && shouldIgnoreCloseEvent !== void 0 && shouldIgnoreCloseEvent(event) && (0, $50U6m.fg)('cc_blocks_changeboarding')) return;
            if (onClose) {
                var _currentLevel = null;
                if (event.target instanceof HTMLElement) {
                    var _event$target$closest, _event$target$closest2;
                    _currentLevel = (_event$target$closest = (_event$target$closest2 = event.target.closest("[data-ds--level]")) === null || _event$target$closest2 === void 0 ? void 0 : _event$target$closest2.getAttribute('data-ds--level')) !== null && _event$target$closest !== void 0 ? _event$target$closest : null;
                }
                _currentLevel ? onClose(event, Number(_currentLevel)) : onClose(event);
            }
            if (shouldDisableFocusTrap && (0, $50U6m.fg)('platform_dst_popup-disable-focuslock')) // Restoring the normal focus order for trigger.
            requestFrame(function() {
                triggerRef === null || triggerRef === void 0 || triggerRef.setAttribute('tabindex', '0');
                if (popupRef && autoFocus) popupRef.setAttribute('tabindex', '0');
            });
        };
        // This check is required for cases where components like
        // Select or DDM are placed inside a Popup. A click
        // on a MenuItem or Option would close the Popup, without registering
        // a click on DDM/Select.
        // Users would have to call `onClose` manually to close the Popup in these cases.
        // You can see the bug in action here:
        // https://codesandbox.io/s/atlaskitpopup-default-forked-2eb87?file=/example.tsx:0-1788
        var onClick = function onClick(event) {
            var target = event.target;
            var doesDomNodeExist = document.body.contains(target);
            if (!doesDomNodeExist) return;
            if (target instanceof HTMLElement) {
                var _target$closest;
                var layeredElement = (_target$closest = target.closest) === null || _target$closest === void 0 ? void 0 : _target$closest.call(target, "[data-ds--level]");
                if (layeredElement) {
                    var closeType = layeredElement.getAttribute('data-ds--close--type');
                    if (closeType === 'single' && isLayerDisabled()) // if the close type is single, we won't close other disabled layers when clicking outside
                    return;
                    var levelOfClickedLayer = layeredElement.getAttribute('data-ds--level');
                    if (levelOfClickedLayer && Number(levelOfClickedLayer) > currentLevel) // Don't close this popup when the click landed inside a higher-level layer
                    // (e.g. a Drawer or Modal that portals to <body>). Such nodes are not DOM
                    // descendants of popupRef, so the contains() checks below would wrongly
                    // classify them as "outside" clicks and close the popup prematurely.
                    return;
                }
            }
            var isClickOnPopup = popupRef && popupRef.contains(target);
            var isClickOnTrigger = triggerRef && triggerRef.contains(target);
            var didClickStartInsidePopup = popupRef && mouseDownTarget.current instanceof Node && popupRef.contains(mouseDownTarget.current);
            if (!isClickOnPopup && !isClickOnTrigger && !didClickStartInsidePopup) {
                closePopup(event);
                // If there was an outside click on a non-interactive element, the focus should be on the trigger.
                if (document.activeElement && !(0, $864d026677cce2dd$export$3dee5e4542c672d9)(document.activeElement) && (0, $50U6m.fg)('platform_dst_popup-disable-focuslock')) triggerRef === null || triggerRef === void 0 || triggerRef.focus();
            }
        };
        var onMouseDown = function onMouseDown(event) {
            /**
       * Tracking the target of the mouse down event.
       * This is used to prevent the popup from closing when the user mouses down inside the popup, but then
       * moves the mouse outside the popup before releasing the mouse button.
       *
       * This is a common user interaction - users may have mistakenly clicked on something, or changed their mind,
       * so they try to cancel their click by moving their mouse away from what they had moused down on.
       *
       * Blanket uses the same technique.
       */ mouseDownTarget.current = event.target;
        };
        var onKeyDown = function onKeyDown(event) {
            var key = event.key;
            if ((key === 'Escape' || key === 'Esc') && (0, $50U6m.fg)('platform_dst_nested_escape')) {
                var _eventTarget$closest;
                var eventTarget = event.target instanceof HTMLElement ? event.target : null;
                var layeredAncestor = eventTarget === null || eventTarget === void 0 || (_eventTarget$closest = eventTarget.closest) === null || _eventTarget$closest === void 0 ? void 0 : _eventTarget$closest.call(eventTarget, '[data-ds--level]');
                var levelStr = layeredAncestor === null || layeredAncestor === void 0 ? void 0 : layeredAncestor.getAttribute('data-ds--level');
                if (levelStr && Number(levelStr) > currentLevel) return;
            }
            if ((0, $50U6m.fg)('platform_dst_popup-disable-focuslock')) {
                var shiftKey = event.shiftKey;
                if (shiftKey && key === 'Tab' && !shouldRenderToParent) {
                    if (isLayerDisabled()) return;
                    // We need to move the focus to the popup trigger when the popup is displayed in React.Portal.
                    requestFrame(function() {
                        var isPopupFocusOut = popupRef && !popupRef.contains(document.activeElement);
                        if (isPopupFocusOut) {
                            closePopup(event);
                            if (currentLevel === 1) triggerRef === null || triggerRef === void 0 || triggerRef.focus();
                        }
                    });
                    return;
                }
                if (key === 'Tab') {
                    var _document$activeEleme;
                    // We have cases where we need to close the Popup on Tab press.
                    // Example: DropdownMenu
                    if (shouldCloseOnTab) {
                        if (isLayerDisabled()) return;
                        closePopup(event);
                        return;
                    }
                    if (isLayerDisabled() && (_document$activeEleme = document.activeElement) !== null && _document$activeEleme !== void 0 && _document$activeEleme.closest('[aria-modal]')) return;
                    if (shouldDisableFocusTrap) {
                        if (shouldRenderToParent) // We need to move the focus to the previous interactive element before popup trigger
                        requestFrame(function() {
                            var isPopupFocusOut = popupRef && !popupRef.contains(document.activeElement);
                            if (isPopupFocusOut) closePopup(event);
                        });
                        else requestFrame(function() {
                            if (!document.hasFocus()) closePopup(event);
                        });
                        return;
                    }
                }
                if (isLayerDisabled()) return;
                if (key === 'Escape' || key === 'Esc') {
                    if (triggerRef && autoFocus) triggerRef.focus();
                    closePopup(event);
                }
            } else {
                if (isLayerDisabled()) return;
                if (key === 'Escape' || key === 'Esc' || shouldCloseOnTab && key === 'Tab') closePopup(event);
            }
        };
        var unbind = (0, $adcefb868cf2fc9d$export$2e2bcd8739ae039);
        if ((0, $50U6m.fg)('popup-onclose-fix')) setTimeout(function() {
            unbind = (0, $5b617c1f48263075$exports.bindAll)(window, [
                {
                    type: 'click',
                    listener: onClick,
                    options: {
                        capture: capture
                    }
                },
                {
                    type: 'keydown',
                    listener: onKeyDown
                },
                {
                    type: 'mousedown',
                    listener: onMouseDown
                }
            ]);
        }, 0);
        else unbind = (0, $5b617c1f48263075$exports.bindAll)(window, [
            {
                type: 'click',
                listener: onClick,
                options: {
                    capture: capture
                }
            },
            {
                type: 'keydown',
                listener: onKeyDown
            },
            {
                type: 'mousedown',
                listener: onMouseDown
            }
        ]);
        // bind onBlur event listener to fix popup not close when clicking on iframe outside
        var unbindBlur = (0, $adcefb868cf2fc9d$export$2e2bcd8739ae039);
        unbindBlur = (0, $5b617c1f48263075$exports.bind)(window, {
            type: 'blur',
            listener: function onBlur(e) {
                if (isLayerDisabled() || !(document.activeElement instanceof HTMLIFrameElement)) return;
                closePopup(e);
            }
        });
        return function() {
            if ((0, $50U6m.fg)('popup-onclose-fix')) setTimeout(function() {
                unbind();
            }, 0);
            else unbind();
            cancelAllFrames();
            unbindBlur();
        };
    }, [
        isOpen,
        onClose,
        popupRef,
        triggerRef,
        autoFocus,
        shouldDisableFocusTrap,
        capture,
        shouldIgnoreCloseEvent,
        isLayerDisabled,
        shouldCloseOnTab,
        currentLevel,
        shouldRenderToParent,
        requestFrame,
        cancelAllFrames
    ]);
};



var $5FkrB = parcelRequire("5FkrB");
var $8161d9da2c93c765$exports = {};
var $fe654298f8d91f4b$exports = {};
$fe654298f8d91f4b$exports = function(el, options) {
    options = options || {};
    var elementDocument = el.ownerDocument || el;
    var basicTabbables = [];
    var orderedTabbables = [];
    // A node is "available" if
    // - it's computed style
    var isUnavailable = $fe654298f8d91f4b$var$createIsUnavailable(elementDocument);
    var candidateSelectors = [
        'input',
        'select',
        'a[href]',
        'textarea',
        'button',
        '[tabindex]'
    ];
    var candidates = el.querySelectorAll(candidateSelectors.join(','));
    if (options.includeContainer) {
        var matches = Element.prototype.matches || Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;
        if (candidateSelectors.some(function(candidateSelector) {
            return matches.call(el, candidateSelector);
        })) {
            candidates = Array.prototype.slice.apply(candidates);
            candidates.unshift(el);
        }
    }
    var candidate, candidateIndexAttr, candidateIndex;
    for(var i = 0, l = candidates.length; i < l; i++){
        candidate = candidates[i];
        candidateIndexAttr = parseInt(candidate.getAttribute('tabindex'), 10);
        candidateIndex = isNaN(candidateIndexAttr) ? candidate.tabIndex : candidateIndexAttr;
        if (candidateIndex < 0 || candidate.tagName === 'INPUT' && candidate.type === 'hidden' || candidate.disabled || isUnavailable(candidate, elementDocument)) continue;
        if (candidateIndex === 0) basicTabbables.push(candidate);
        else orderedTabbables.push({
            index: i,
            tabIndex: candidateIndex,
            node: candidate
        });
    }
    var tabbableNodes = orderedTabbables.sort(function(a, b) {
        return a.tabIndex === b.tabIndex ? a.index - b.index : a.tabIndex - b.tabIndex;
    }).map(function(a) {
        return a.node;
    });
    Array.prototype.push.apply(tabbableNodes, basicTabbables);
    return tabbableNodes;
};
function $fe654298f8d91f4b$var$createIsUnavailable(elementDocument) {
    // Node cache must be refreshed on every check, in case
    // the content of the element has changed
    var isOffCache = [];
    // "off" means `display: none;`, as opposed to "hidden",
    // which means `visibility: hidden;`. getComputedStyle
    // accurately reflects visiblity in context but not
    // "off" state, so we need to recursively check parents.
    function isOff(node, nodeComputedStyle) {
        if (node === elementDocument.documentElement) return false;
        // Find the cached node (Array.prototype.find not available in IE9)
        for(var i = 0, length = isOffCache.length; i < length; i++){
            if (isOffCache[i][0] === node) return isOffCache[i][1];
        }
        nodeComputedStyle = nodeComputedStyle || elementDocument.defaultView.getComputedStyle(node);
        var result = false;
        if (nodeComputedStyle.display === 'none') result = true;
        else if (node.parentNode) result = isOff(node.parentNode);
        isOffCache.push([
            node,
            result
        ]);
        return result;
    }
    return function isUnavailable(node) {
        if (node === elementDocument.documentElement) return false;
        var computedStyle = elementDocument.defaultView.getComputedStyle(node);
        if (isOff(node, computedStyle)) return true;
        return computedStyle.visibility === 'hidden';
    };
}


var $8161d9da2c93c765$var$listeningFocusTrap = null;
function $8161d9da2c93c765$var$focusTrap(element, userOptions) {
    var tabbableNodes = [];
    var firstTabbableNode = null;
    var lastTabbableNode = null;
    var nodeFocusedBeforeActivation = null;
    var active = false;
    var paused = false;
    var tabEvent = null;
    var container = typeof element === 'string' ? document.querySelector(element) : element;
    var config = userOptions || {};
    config.returnFocusOnDeactivate = userOptions && userOptions.returnFocusOnDeactivate !== undefined ? userOptions.returnFocusOnDeactivate : true;
    config.escapeDeactivates = userOptions && userOptions.escapeDeactivates !== undefined ? userOptions.escapeDeactivates : true;
    var trap = {
        activate: activate,
        deactivate: deactivate,
        pause: pause,
        unpause: unpause
    };
    return trap;
    function activate(activateOptions) {
        if (active) return;
        var defaultedActivateOptions = {
            onActivate: activateOptions && activateOptions.onActivate !== undefined ? activateOptions.onActivate : config.onActivate
        };
        active = true;
        paused = false;
        nodeFocusedBeforeActivation = document.activeElement;
        if (defaultedActivateOptions.onActivate) defaultedActivateOptions.onActivate();
        addListeners();
        return trap;
    }
    function deactivate(deactivateOptions) {
        if (!active) return;
        var defaultedDeactivateOptions = {
            returnFocus: deactivateOptions && deactivateOptions.returnFocus !== undefined ? deactivateOptions.returnFocus : config.returnFocusOnDeactivate,
            onDeactivate: deactivateOptions && deactivateOptions.onDeactivate !== undefined ? deactivateOptions.onDeactivate : config.onDeactivate
        };
        removeListeners();
        if (defaultedDeactivateOptions.onDeactivate) defaultedDeactivateOptions.onDeactivate();
        if (defaultedDeactivateOptions.returnFocus) setTimeout(function() {
            $8161d9da2c93c765$var$tryFocus(nodeFocusedBeforeActivation);
        }, 0);
        active = false;
        paused = false;
        return this;
    }
    function pause() {
        if (paused || !active) return;
        paused = true;
        removeListeners();
    }
    function unpause() {
        if (!paused || !active) return;
        paused = false;
        addListeners();
    }
    function addListeners() {
        if (!active) return;
        // There can be only one listening focus trap at a time
        if ($8161d9da2c93c765$var$listeningFocusTrap) $8161d9da2c93c765$var$listeningFocusTrap.pause();
        $8161d9da2c93c765$var$listeningFocusTrap = trap;
        updateTabbableNodes();
        // Ensure that the focused element doesn't capture the event that caused the focus trap activation
        setTimeout(function() {
            $8161d9da2c93c765$var$tryFocus(firstFocusNode());
        }, 0);
        document.addEventListener('focus', checkFocus, true);
        document.addEventListener('click', checkClick, true);
        document.addEventListener('mousedown', checkPointerDown, true);
        document.addEventListener('touchstart', checkPointerDown, true);
        document.addEventListener('keydown', checkKey, true);
        return trap;
    }
    function removeListeners() {
        if (!active || $8161d9da2c93c765$var$listeningFocusTrap !== trap) return;
        document.removeEventListener('focus', checkFocus, true);
        document.removeEventListener('click', checkClick, true);
        document.removeEventListener('mousedown', checkPointerDown, true);
        document.removeEventListener('touchstart', checkPointerDown, true);
        document.removeEventListener('keydown', checkKey, true);
        $8161d9da2c93c765$var$listeningFocusTrap = null;
        return trap;
    }
    function getNodeForOption(optionName) {
        var optionValue = config[optionName];
        var node = optionValue;
        if (!optionValue) return null;
        if (typeof optionValue === 'string') {
            node = document.querySelector(optionValue);
            if (!node) throw new Error('`' + optionName + '` refers to no known node');
        }
        if (typeof optionValue === 'function') {
            node = optionValue();
            if (!node) throw new Error('`' + optionName + '` did not return a node');
        }
        return node;
    }
    function firstFocusNode() {
        var node;
        if (getNodeForOption('initialFocus') !== null) node = getNodeForOption('initialFocus');
        else if (container.contains(document.activeElement)) node = document.activeElement;
        else node = tabbableNodes[0] || getNodeForOption('fallbackFocus');
        if (!node) throw new Error('You can\'t have a focus-trap without at least one focusable element');
        return node;
    }
    // This needs to be done on mousedown and touchstart instead of click
    // so that it precedes the focus event
    function checkPointerDown(e) {
        if (config.clickOutsideDeactivates && !container.contains(e.target)) deactivate({
            returnFocus: false
        });
    }
    function checkClick(e) {
        if (config.clickOutsideDeactivates) return;
        if (container.contains(e.target)) return;
        e.preventDefault();
        e.stopImmediatePropagation();
    }
    function checkFocus(e) {
        if (container.contains(e.target)) return;
        e.preventDefault();
        e.stopImmediatePropagation();
        // Checking for a blur method here resolves a Firefox issue (#15)
        if (typeof e.target.blur === 'function') e.target.blur();
        if (tabEvent) readjustFocus(tabEvent);
    }
    function checkKey(e) {
        if (e.key === 'Tab' || e.keyCode === 9) handleTab(e);
        if (config.escapeDeactivates !== false && $8161d9da2c93c765$var$isEscapeEvent(e)) deactivate();
    }
    function handleTab(e) {
        updateTabbableNodes();
        if (e.target.hasAttribute('tabindex') && Number(e.target.getAttribute('tabindex')) < 0) return tabEvent = e;
        e.preventDefault();
        var currentFocusIndex = tabbableNodes.indexOf(e.target);
        if (e.shiftKey) {
            if (e.target === firstTabbableNode || tabbableNodes.indexOf(e.target) === -1) return $8161d9da2c93c765$var$tryFocus(lastTabbableNode);
            return $8161d9da2c93c765$var$tryFocus(tabbableNodes[currentFocusIndex - 1]);
        }
        if (e.target === lastTabbableNode) return $8161d9da2c93c765$var$tryFocus(firstTabbableNode);
        $8161d9da2c93c765$var$tryFocus(tabbableNodes[currentFocusIndex + 1]);
    }
    function updateTabbableNodes() {
        tabbableNodes = $fe654298f8d91f4b$exports(container);
        firstTabbableNode = tabbableNodes[0];
        lastTabbableNode = tabbableNodes[tabbableNodes.length - 1];
    }
    function readjustFocus(e) {
        if (e.shiftKey) return $8161d9da2c93c765$var$tryFocus(lastTabbableNode);
        $8161d9da2c93c765$var$tryFocus(firstTabbableNode);
    }
}
function $8161d9da2c93c765$var$isEscapeEvent(e) {
    return e.key === 'Escape' || e.key === 'Esc' || e.keyCode === 27;
}
function $8161d9da2c93c765$var$tryFocus(node) {
    if (!node || !node.focus) return;
    if (node === document.activeElement) return;
    node.focus();
    if (node.tagName.toLowerCase() === 'input') node.select();
}
$8161d9da2c93c765$exports = $8161d9da2c93c765$var$focusTrap;





var $50U6m = parcelRequire("50U6m");

var $984b16538a2886c6$export$10c5169755ce7bd7 = function useFocusManager(_ref) {
    var initialFocusRef = _ref.initialFocusRef, popupRef = _ref.popupRef, triggerRef = _ref.triggerRef, autoFocus = _ref.autoFocus, shouldCloseOnTab = _ref.shouldCloseOnTab, shouldDisableFocusTrap = _ref.shouldDisableFocusTrap, shouldReturnFocus = _ref.shouldReturnFocus, shouldRenderToParent = _ref.shouldRenderToParent;
    var _useAnimationFrame = (0, $28deab68320ef15f$export$641fa9c94086b46e)(), requestFrame = _useAnimationFrame.requestFrame, cancelAllFrames = _useAnimationFrame.cancelAllFrames;
    var _useLayering = (0, $7df5ec948c08a88e$export$c8b4d54e03dee6ed)(), currentLevel = _useLayering.currentLevel;
    (0, $5FkrB.useEffect)(function() {
        if (!popupRef || shouldCloseOnTab) return 0, $adcefb868cf2fc9d$export$2e2bcd8739ae039;
        if (shouldDisableFocusTrap && (0, $50U6m.fg)('platform_dst_popup-disable-focuslock')) {
            var isDropdown = popupRef.matches('[id^=ds--dropdown--]');
            var popups = document.querySelectorAll("[data-ds--level=\"".concat(currentLevel - 1, "\"]"));
            if (!(popups[popups.length - 1] && !shouldRenderToParent && isDropdown)) {
                // Plucking trigger & popup content container from the tab order so that
                // when we Shift+Tab, the focus moves to the element before trigger
                requestFrame(function() {
                    triggerRef === null || triggerRef === void 0 || triggerRef.setAttribute('tabindex', '-1');
                    if (popupRef && autoFocus) popupRef.setAttribute('tabindex', '-1');
                    (initialFocusRef || popupRef).focus();
                });
                return 0, $adcefb868cf2fc9d$export$2e2bcd8739ae039;
            }
        }
        var trapConfig = {
            clickOutsideDeactivates: true,
            escapeDeactivates: (0, $50U6m.fg)('platform_dst_nested_escape') ? false : true,
            initialFocus: initialFocusRef || popupRef,
            fallbackFocus: popupRef,
            returnFocusOnDeactivate: shouldReturnFocus
        };
        var focusTrap = (0, (/*@__PURE__*/$parcel$interopDefault($8161d9da2c93c765$exports)))(popupRef, trapConfig);
        // Wait for the popup to reposition itself before we focus
        requestFrame(function() {
            focusTrap.activate();
        });
        return function() {
            cancelAllFrames();
            focusTrap.deactivate();
            if ((0, $50U6m.fg)('platform_dst-popup-trigger-initial-focus-ref') && shouldReturnFocus) requestFrame(function() {
                if (triggerRef !== null && triggerRef !== void 0 && triggerRef.isConnected && (document.activeElement === document.body || document.activeElement === document.documentElement || !document.activeElement)) triggerRef.focus();
            });
        };
    }, [
        popupRef,
        triggerRef,
        autoFocus,
        initialFocusRef,
        shouldCloseOnTab,
        shouldDisableFocusTrap,
        requestFrame,
        cancelAllFrames,
        shouldReturnFocus,
        shouldRenderToParent,
        currentLevel
    ]);
};


var $01e0383d73d1296a$var$_excluded = [
    "shouldRenderToParent",
    "shouldFitContainer",
    "children",
    "appearance",
    "className",
    "isReferenceHidden",
    "shouldFitViewport"
];
function $01e0383d73d1296a$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $01e0383d73d1296a$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $01e0383d73d1296a$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $49250faa9cba8c7f$export$2e2bcd8739ae039)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $01e0383d73d1296a$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $01e0383d73d1296a$var$LOCAL_CURRENT_SURFACE_CSS_VAR = '--ds-elevation-surface-current';
var $01e0383d73d1296a$var$fullWidthStyles = null;
var $01e0383d73d1296a$var$wrapperStyles = {
    root: "_2rko12b0 _1e0c1ule _vchhusvi _1pby1nn1 _bfhk1bhr _16qs130s _syazi7uo _1q1l1bhr _nt751r31 _49pcglyw _1hvw1o36",
    rootT26Shape: "_2rko1mok",
    fullWidth: "_1bsb1osq",
    motion: "_c71l1kw7 _1e0c1txw"
};
var $01e0383d73d1296a$var$scrollableStyles = null;
var $01e0383d73d1296a$var$blanketStyles = null;
var $01e0383d73d1296a$var$modalStyles = null;
var $01e0383d73d1296a$var$focusRingStyles = {
    root: "_mizu1v1w _1ah3dkaa _ra3xnqa1 _128mdkaa _1cvmnqa1 _4davt94y"
};
var $01e0383d73d1296a$var$placementMap = {
    top: {
        enter: "var(--ds-popup-enter-top, 150ms cubic-bezier(0.4, 1, 0.6, 1) SlideInTop8px, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn0to100)",
        exit: "var(--ds-popup-exit-top, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) SlideOutTop8px, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)"
    },
    'top-start': {
        enter: "var(--ds-popup-enter-top, 150ms cubic-bezier(0.4, 1, 0.6, 1) SlideInTop8px, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn0to100)",
        exit: "var(--ds-popup-exit-top, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) SlideOutTop8px, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)"
    },
    'top-end': {
        enter: "var(--ds-popup-enter-top, 150ms cubic-bezier(0.4, 1, 0.6, 1) SlideInTop8px, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn0to100)",
        exit: "var(--ds-popup-exit-top, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) SlideOutTop8px, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)"
    },
    bottom: {
        enter: "var(--ds-popup-enter-bottom, 150ms cubic-bezier(0.4, 1, 0.6, 1) SlideInBottom8px, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn0to100)",
        exit: "var(--ds-popup-exit-bottom, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) SlideOutBottom8px, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)"
    },
    'bottom-start': {
        enter: "var(--ds-popup-enter-bottom, 150ms cubic-bezier(0.4, 1, 0.6, 1) SlideInBottom8px, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn0to100)",
        exit: "var(--ds-popup-exit-bottom, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) SlideOutBottom8px, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)"
    },
    'bottom-end': {
        enter: "var(--ds-popup-enter-bottom, 150ms cubic-bezier(0.4, 1, 0.6, 1) SlideInBottom8px, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn0to100)",
        exit: "var(--ds-popup-exit-bottom, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) SlideOutBottom8px, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)"
    },
    left: {
        enter: "var(--ds-popup-enter-left, 150ms cubic-bezier(0.4, 1, 0.6, 1) SlideInLeft8px, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn0to100)",
        exit: "var(--ds-popup-exit-left, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) SlideOutLeft8px, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)"
    },
    'left-start': {
        enter: "var(--ds-popup-enter-left, 150ms cubic-bezier(0.4, 1, 0.6, 1) SlideInLeft8px, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn0to100)",
        exit: "var(--ds-popup-exit-left, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) SlideOutLeft8px, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)"
    },
    'left-end': {
        enter: "var(--ds-popup-enter-left, 150ms cubic-bezier(0.4, 1, 0.6, 1) SlideInLeft8px, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn0to100)",
        exit: "var(--ds-popup-exit-left, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) SlideOutLeft8px, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)"
    },
    right: {
        enter: "var(--ds-popup-enter-right, 150ms cubic-bezier(0.4, 1, 0.6, 1) SlideInRight8px, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn0to100)",
        exit: "var(--ds-popup-exit-right, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) SlideOutRight8px, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)"
    },
    'right-start': {
        enter: "var(--ds-popup-enter-right, 150ms cubic-bezier(0.4, 1, 0.6, 1) SlideInRight8px, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn0to100)",
        exit: "var(--ds-popup-exit-right, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) SlideOutRight8px, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)"
    },
    'right-end': {
        enter: "var(--ds-popup-enter-right, 150ms cubic-bezier(0.4, 1, 0.6, 1) SlideInRight8px, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn0to100)",
        exit: "var(--ds-popup-exit-right, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) SlideOutRight8px, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)"
    }
};
var $01e0383d73d1296a$var$DefaultPopupComponent = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function(props, ref) {
    var shouldRenderToParent = props.shouldRenderToParent, shouldFitContainer = props.shouldFitContainer, children = props.children, appearance = props.appearance, className = props.className, _isReferenceHidden = props.isReferenceHidden, shouldFitViewport = props.shouldFitViewport, htmlAttributes = (0, $e3e76e60045b1bf0$export$2e2bcd8739ae039)(props, $01e0383d73d1296a$var$_excluded);
    return /*#__PURE__*/ $5FkrB.createElement("div", (0, $7b6033835882f9ff$export$2e2bcd8739ae039)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $dbf53395d39974cf$export$2e2bcd8739ae039)([
            $01e0383d73d1296a$var$wrapperStyles.root,
            (0, $50U6m.fg)('platform-dst-shape-theme-default') && $01e0383d73d1296a$var$wrapperStyles.rootT26Shape,
            appearance === 'UNSAFE_modal-below-sm' && "_dk5d1b66 _c71l1ei0 _kqsw1n9t _152t1b66",
            (!shouldRenderToParent || shouldFitViewport) && "_1reo1wug _18m91wug",
            shouldFitContainer && "_1bsb1osq",
            className
        ])
    }, htmlAttributes, {
        ref: !(0, $50U6m.fg)('platform-dst-motion-uplift-popup') ? ref : undefined
    }), children);
});
function $01e0383d73d1296a$var$PopperWrapper(_ref) {
    var xcss = _ref.xcss, isOpen = _ref.isOpen, id = _ref.id, offset = _ref.offset, testId = _ref.testId, content = _ref.content, fallbackPlacements = _ref.fallbackPlacements, onClose = _ref.onClose, boundary = _ref.boundary, rootBoundary = _ref.rootBoundary, shouldFlip = _ref.shouldFlip, _ref$placement = _ref.placement, placement = _ref$placement === void 0 ? 'auto' : _ref$placement, _ref$popupComponent = _ref.popupComponent, PopupContainer = _ref$popupComponent === void 0 ? $01e0383d73d1296a$var$DefaultPopupComponent : _ref$popupComponent, _ref$autoFocus = _ref.autoFocus, autoFocus = _ref$autoFocus === void 0 ? true : _ref$autoFocus, triggerRef = _ref.triggerRef, shouldUseCaptureOnOutsideClick = _ref.shouldUseCaptureOnOutsideClick, shouldIgnoreCloseEvent = _ref.shouldIgnoreCloseEvent, shouldRenderToParent = _ref.shouldRenderToParent, shouldFitContainer = _ref.shouldFitContainer, shouldDisableFocusLock = _ref.shouldDisableFocusLock, _ref$shouldReturnFocu = _ref.shouldReturnFocus, shouldReturnFocus = _ref$shouldReturnFocu === void 0 ? true : _ref$shouldReturnFocu, strategy = _ref.strategy, role = _ref.role, label = _ref.label, titleId = _ref.titleId, modifiers = _ref.modifiers, shouldFitViewport = _ref.shouldFitViewport, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'default' : _ref$appearance, zIndex = _ref.zIndex;
    var _useState = (0, $5FkrB.useState)(null), _useState2 = (0, $0b8156ac98850b5f$export$2e2bcd8739ae039)(_useState, 2), popupRef = _useState2[0], setPopupRef = _useState2[1];
    var _useState3 = (0, $5FkrB.useState)(null), _useState4 = (0, $0b8156ac98850b5f$export$2e2bcd8739ae039)(_useState3, 2), initialFocusRef = _useState4[0], setInitialFocusRef = _useState4[1];
    // We have cases where we need to close the Popup on Tab press, e.g. DropdownMenu
    var shouldCloseOnTab = shouldRenderToParent && shouldDisableFocusLock;
    var shouldDisableFocusTrap = role !== 'dialog';
    (0, $984b16538a2886c6$export$10c5169755ce7bd7)({
        initialFocusRef: initialFocusRef,
        popupRef: popupRef,
        shouldCloseOnTab: shouldCloseOnTab,
        triggerRef: triggerRef,
        autoFocus: autoFocus,
        shouldDisableFocusTrap: shouldDisableFocusTrap,
        shouldReturnFocus: shouldReturnFocus
    });
    (0, $ead5479bf2690ca1$export$92dae2778ae88f9d)({
        isOpen: isOpen,
        onClose: onClose,
        popupRef: popupRef,
        triggerRef: triggerRef,
        shouldUseCaptureOnOutsideClick: shouldUseCaptureOnOutsideClick,
        shouldIgnoreCloseEvent: shouldIgnoreCloseEvent,
        shouldCloseOnTab: shouldCloseOnTab,
        autoFocus: autoFocus,
        shouldDisableFocusTrap: shouldDisableFocusTrap,
        shouldRenderToParent: shouldRenderToParent
    });
    var _useLayering = (0, $7df5ec948c08a88e$export$c8b4d54e03dee6ed)(), currentLevel = _useLayering.currentLevel;
    var mergedModifiers = (0, $5FkrB.useMemo)(function() {
        return [
            {
                name: 'flip',
                enabled: shouldFlip,
                options: {
                    rootBoundary: rootBoundary,
                    boundary: boundary,
                    fallbackPlacements: fallbackPlacements
                }
            }
        ].concat((0, $6367c63b8ad4bce1$export$2e2bcd8739ae039)(modifiers || []));
    }, [
        shouldFlip,
        rootBoundary,
        boundary,
        fallbackPlacements,
        modifiers
    ]);
    return /*#__PURE__*/ $5FkrB.createElement((0, $42e5b75ea169c552$export$badac9ada3a0bdf9), {
        placement: placement,
        offset: offset,
        modifiers: mergedModifiers,
        strategy: strategy,
        shouldFitViewport: shouldFitViewport
    }, function(_ref2) {
        var _ref3 = _ref2.ref, style = _ref2.style, placement = _ref2.placement, update = _ref2.update, isReferenceHidden = _ref2.isReferenceHidden;
        var popupContainer = /*#__PURE__*/ $5FkrB.createElement(PopupContainer, {
            className: (0, $dbf53395d39974cf$export$2e2bcd8739ae039)([
                xcss,
                // @ts-expect-error: `ax` is not typed correctly
                !initialFocusRef && (0, $50U6m.fg)('platform-design-system-apply-popup-wrapper-focus') && $01e0383d73d1296a$var$focusRingStyles.root
            ]),
            appearance: appearance,
            id: id,
            "data-ds--level": currentLevel,
            "data-placement": placement,
            "data-testid": testId,
            role: role,
            "aria-label": label,
            "aria-labelledby": titleId,
            ref: !(0, $50U6m.fg)('platform-dst-motion-uplift-popup') ? function(node) {
                if (node) {
                    if (typeof _ref3 === 'function') _ref3(node);
                    else _ref3.current = node;
                    setPopupRef(node);
                }
            } : undefined,
            style: (0, $50U6m.fg)('platform-dst-motion-uplift-popup') || appearance === 'UNSAFE_modal-below-sm' ? {} : style,
            tabIndex: autoFocus ? 0 : undefined,
            shouldRenderToParent: shouldRenderToParent,
            shouldFitContainer: shouldFitContainer,
            shouldFitViewport: shouldFitViewport,
            isReferenceHidden: isReferenceHidden
        }, /*#__PURE__*/ $5FkrB.createElement((0, $a7edaecb351c1789$export$51eddd7655ca235a), {
            update: update
        }, content({
            update: update,
            isOpen: isOpen,
            onClose: onClose,
            setInitialFocusRef: setInitialFocusRef
        })));
        var isAutoPlacement = placement === 'auto' || placement === 'auto-start' || placement === 'auto-end';
        var container = /*#__PURE__*/ $5FkrB.createElement("div", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            style: $01e0383d73d1296a$var$_objectSpread($01e0383d73d1296a$var$_objectSpread({}, style), {}, {
                zIndex: zIndex
            }),
            // using tabIndex={-1} would cause a bug where Safari focuses
            // first on the browser address bar when using keyboard
            ref: function ref(node) {
                if (node) {
                    if (typeof _ref3 === 'function') _ref3(node);
                    else _ref3.current = node;
                    setPopupRef(node);
                }
            },
            "data-testid": "".concat(testId, "--container"),
            className: (0, $dbf53395d39974cf$export$2e2bcd8739ae039)([
                shouldFitContainer && $01e0383d73d1296a$var$wrapperStyles.fullWidth
            ])
        }, /*#__PURE__*/ $5FkrB.createElement((0, $d48c6d5755d883e0$export$2e2bcd8739ae039), {
            enteringAnimation: !isAutoPlacement ? $01e0383d73d1296a$var$placementMap[placement].enter : undefined,
            exitingAnimation: !isAutoPlacement ? $01e0383d73d1296a$var$placementMap[placement].exit : undefined,
            xcss: $01e0383d73d1296a$var$wrapperStyles.motion
        }, popupContainer));
        return /*#__PURE__*/ $5FkrB.createElement((0, $5FkrB.Fragment), null, (0, $50U6m.fg)('platform-dst-motion-uplift-popup') ? container : popupContainer, appearance === 'UNSAFE_modal-below-sm' && /*#__PURE__*/ $5FkrB.createElement("div", {
            className: (0, $dbf53395d39974cf$export$2e2bcd8739ae039)([
                "_1r04idpf _kqsw1n9t _bfhk1i5c"
            ])
        }));
    });
}
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$01e0383d73d1296a$export$2e2bcd8739ae039 = $01e0383d73d1296a$var$PopperWrapper;


/* popup-top-layer.tsx generated by @compiled/babel-plugin v2.0.0 */ 

var $5FkrB = parcelRequire("5FkrB");


/**
 * Roles accepted by `getAriaForTrigger`.
 *
 * Excludes tooltip-family roles (`tooltip`, `note`, `status`, `alert`, `log`)
 * because the correct trigger wiring for those is `aria-describedby`, not
 * `aria-haspopup` / `aria-expanded` / `aria-controls`. Use `aria-describedby`
 * manually for tooltip triggers.
 */ /**
 * Valid values for the `aria-haspopup` attribute.
 *
 * Derived from the HTML spec - maps popover roles to what the trigger
 * announces. `undefined` means the attribute is omitted entirely (used for
 * non-popup roles like `tooltip`/`status`/`alert`/`note`/`log` where
 * `aria-haspopup` would be misleading).
 *
 * `true` is intentionally NOT in the union - the runtime only ever produces
 * the explicit string forms, so widening the type would invite consumers to
 * pass `true` and get an `aria-haspopup="true"` serialisation that the
 * runtime no longer emits.
 */ /**
 * Non-undefined subset of `TAriaHasPopupValue`. Every role accepted by
 * `getAriaForTrigger` maps to a concrete `aria-haspopup` string, so the
 * trigger always receives a defined attribute value.
 */ var $035780a5f3bca592$var$roleToAriaHasPopup = {
    dialog: 'dialog',
    alertdialog: 'dialog',
    menu: 'menu',
    listbox: 'listbox',
    tree: 'tree',
    grid: 'grid'
};
function $035780a5f3bca592$export$9dd1d61dd4d4755(_ref) {
    var role = _ref.role, isOpen = _ref.isOpen, popoverId = _ref.popoverId;
    // `aria-controls` is set to `undefined` while closed. The `Popover` /
    // `Dialog` primitives unmount their host element after the exit
    // animation finishes, so a closed-state `aria-controls` would point
    // at a node that is not in the DOM. Returning `undefined` here means
    // JSX spread renders no `aria-controls` attribute on the trigger
    // until the target exists, avoiding the dangling reference while
    // keeping the relationship live whenever it is meaningful.
    return {
        'aria-haspopup': $035780a5f3bca592$var$roleToAriaHasPopup[role],
        'aria-expanded': isOpen,
        'aria-controls': isOpen ? popoverId : undefined
    };
}




/**
 * The full mapping record. Internal - use `fromLegacyPlacement` from the
 * public entry-point so the offset-tuple translation is applied consistently.
 *
 * Note: `auto`, `auto-start`, `auto-end` map to `block-end` placements. This
 * is a reduction in expressiveness vs Popper.js (which picked the best
 * placement at runtime). CSS `position-try-fallbacks` flips at the edge but
 * the initial placement is fixed. Migration consumers who relied on Popper's
 * dynamic auto-flip should pick an explicit placement instead.
 */ var $ccd670ce09f485ab$export$27df359c528b7120 = {
    top: {
        axis: 'block',
        edge: 'start',
        align: 'center'
    },
    'top-start': {
        axis: 'block',
        edge: 'start',
        align: 'start'
    },
    'top-center': {
        axis: 'block',
        edge: 'start',
        align: 'center'
    },
    'top-end': {
        axis: 'block',
        edge: 'start',
        align: 'end'
    },
    bottom: {
        axis: 'block',
        edge: 'end',
        align: 'center'
    },
    'bottom-start': {
        axis: 'block',
        edge: 'end',
        align: 'start'
    },
    'bottom-center': {
        axis: 'block',
        edge: 'end',
        align: 'center'
    },
    'bottom-end': {
        axis: 'block',
        edge: 'end',
        align: 'end'
    },
    right: {
        axis: 'inline',
        edge: 'end',
        align: 'center'
    },
    'right-start': {
        axis: 'inline',
        edge: 'end',
        align: 'start'
    },
    'right-end': {
        axis: 'inline',
        edge: 'end',
        align: 'end'
    },
    left: {
        axis: 'inline',
        edge: 'start',
        align: 'center'
    },
    'left-start': {
        axis: 'inline',
        edge: 'start',
        align: 'start'
    },
    'left-end': {
        axis: 'inline',
        edge: 'start',
        align: 'end'
    },
    auto: {
        axis: 'block',
        edge: 'end',
        align: 'center'
    },
    'auto-start': {
        axis: 'block',
        edge: 'end',
        align: 'start'
    },
    'auto-end': {
        axis: 'block',
        edge: 'end',
        align: 'end'
    }
};


function $88557954ddf59374$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $88557954ddf59374$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $88557954ddf59374$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $49250faa9cba8c7f$export$2e2bcd8739ae039)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $88557954ddf59374$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $88557954ddf59374$export$69e99ed50b2534c9(_ref) {
    var legacy = _ref.legacy, offset = _ref.offset;
    var basePlacement = (0, $ccd670ce09f485ab$export$27df359c528b7120)[legacy];
    if (!offset) return basePlacement;
    var _offset = (0, $0b8156ac98850b5f$export$2e2bcd8739ae039)(offset, 2), along = _offset[0], away = _offset[1];
    return $88557954ddf59374$var$_objectSpread($88557954ddf59374$var$_objectSpread({}, basePlacement), {}, {
        offset: {
            gap: away,
            crossAxisShift: {
                // Sign is captured in `direction`; `value` is the magnitude.
                value: Math.abs(along),
                direction: along >= 0 ? 'forwards' : 'backwards'
            }
        }
    });
}


/**
 * Creates a synthetic DOM event from a `TPopoverCloseReason`.
 *
 * Useful when bridging the Popover primitive's `onClose({ reason })` callback
 * to a legacy API that expects a native DOM event - for example,
 * `@atlaskit/inline-dialog`'s `onClose(event)` contract.
 *
 * - `'escape'` → `KeyboardEvent('keydown', { key: 'Escape' })`
 * - `'light-dismiss'` → `MouseEvent('click')`
 *
 * For any other reason, a generic `Event('close')` is returned as a fallback.
 *
 * @example
 * ```tsx
 * import { createPopoverCloseEvent, type TPopoverCloseReason } from '@atlaskit/top-layer/popover';
 *
 * function onPopoverClose({ reason }: { reason: TPopoverCloseReason }) {
 *   legacyOnClose(createPopoverCloseEvent({ reason }));
 * }
 * ```
 */ function $5e93135852b41f01$export$27b4de066896ac63(_ref) {
    var reason = _ref.reason;
    if (reason === 'escape') return new KeyboardEvent('keydown', {
        key: 'Escape',
        bubbles: true
    });
    if (reason === 'light-dismiss') return new MouseEvent('click', {
        bubbles: true,
        cancelable: true
    });
    return new Event('close');
}


/* popover.tsx generated by @compiled/babel-plugin v2.0.0 */ 

var $5FkrB = parcelRequire("5FkrB");

const $7b383e1b2d1763a3$export$a274e22fb40f762e = (...styles)=>{
    // At runtime TStyles is resolved down to strings, but not at compile time.
    // We circumvent the type system here because of that.
    const actualStyles = styles;
    // The output should be a union type of passed in styles. This ensures the call
    // site of xcss prop can raise violations when disallowed styles have been passed.
    return (0, $dbf53395d39974cf$export$2e2bcd8739ae039)(actualStyles);
};






var $5FkrB = parcelRequire("5FkrB");

var $5FkrB = parcelRequire("5FkrB");
var $b328aee7e213e353$export$5fbf4d7fae6cdc00 = /*#__PURE__*/ (0, $5FkrB.createContext)(null);



var $5FkrB = parcelRequire("5FkrB");

var $5FkrB = parcelRequire("5FkrB");
var $96292926fee0c0a4$export$644a49f3b8c50fcd = /*#__PURE__*/ (0, $5FkrB.createContext)(null);


function $2a2a1f0dbe9696ca$export$1d57e79091cc3046() {
    var namespace = (0, $5FkrB.useContext)((0, $96292926fee0c0a4$export$644a49f3b8c50fcd));
    return namespace;
}


function $914d64dc0ec49129$export$469bb693f11edc7f(_ref) {
    var isOpen = _ref.isOpen, type = _ref.type, onClose = _ref.onClose;
    var context = (0, $5FkrB.useContext)((0, $b328aee7e213e353$export$5fbf4d7fae6cdc00));
    var namespace = (0, $2a2a1f0dbe9696ca$export$1d57e79091cc3046)();
    (0, $5FkrB.useEffect)(function() {
        /**
     * Registers the `onClose` callback with the OpenLayerObserver.
     */ if (context === null) return;
        if (!isOpen) /**
       * If the layer is not open, we are not registering the `onClose` callback.
       * This is important to prevent the `onClose` from being called for layers that
       * are not open.
       *
       * Some consumers mistakenly pass "toggle" functions to `onClose` callbacks for
       * layer components, as Popup, e.g. `onClose={() => setIsOpen(!isOpen)}`.
       */ return;
        return context.onClose(onClose, {
            namespace: namespace,
            type: type
        });
    }, [
        context,
        isOpen,
        namespace,
        onClose,
        type
    ]);
}


/**
 * Normalizes an offset to a CSS length string. Numbers become `${n}px`;
 * strings pass through. Apply at the API boundary so internal code only
 * deals with strings.
 */ function $e782212d129da460$export$63b6b0ff65d84d47(_ref) {
    var value = _ref.value;
    if (typeof value === 'number') return "".concat(value, "px");
    return value;
}


/**
 * Default gap between trigger and popover. Resolves to a design
 * token (`space.100`) so the value follows the design system's spacing
 * scale. Used when `placement.offset.gap` is not provided.
 */ var $4d4da76463e3fc46$var$DEFAULT_GAP = "var(--ds-space-100, 8px)";
function $4d4da76463e3fc46$export$63044d21bc3d3fa2(_ref) {
    var _placement$offset, _placement$axis, _placement$edge, _placement$align, _placement$offset$cro, _placement$offset2, _placement$offset$cro2, _placement$offset3;
    var placement = _ref.placement;
    var consumerGap = (_placement$offset = placement.offset) === null || _placement$offset === void 0 ? void 0 : _placement$offset.gap;
    return {
        axis: (_placement$axis = placement.axis) !== null && _placement$axis !== void 0 ? _placement$axis : 'block',
        edge: (_placement$edge = placement.edge) !== null && _placement$edge !== void 0 ? _placement$edge : 'end',
        align: (_placement$align = placement.align) !== null && _placement$align !== void 0 ? _placement$align : 'center',
        offset: {
            gap: consumerGap === undefined ? $4d4da76463e3fc46$var$DEFAULT_GAP : (0, $e782212d129da460$export$63b6b0ff65d84d47)({
                value: consumerGap
            }),
            crossAxisShift: {
                value: (0, $e782212d129da460$export$63b6b0ff65d84d47)({
                    value: (_placement$offset$cro = (_placement$offset2 = placement.offset) === null || _placement$offset2 === void 0 || (_placement$offset2 = _placement$offset2.crossAxisShift) === null || _placement$offset2 === void 0 ? void 0 : _placement$offset2.value) !== null && _placement$offset$cro !== void 0 ? _placement$offset$cro : 0
                }),
                direction: (_placement$offset$cro2 = (_placement$offset3 = placement.offset) === null || _placement$offset3 === void 0 || (_placement$offset3 = _placement$offset3.crossAxisShift) === null || _placement$offset3 === void 0 ? void 0 : _placement$offset3.direction) !== null && _placement$offset$cro2 !== void 0 ? _placement$offset$cro2 : 'forwards'
            }
        }
    };
}


var $07b89e7d046a90d2$var$rolesThatMoveFocus = new Set([
    'dialog',
    'alertdialog',
    'menu',
    'listbox',
    'tree',
    'grid'
]);
function $07b89e7d046a90d2$export$b12adccf56228c71(_ref) {
    var role = _ref.role;
    if (!role) return false;
    return $07b89e7d046a90d2$var$rolesThatMoveFocus.has(role);
}




var $5FkrB = parcelRequire("5FkrB");

var $7ae872ecb3ab26e9$export$ff7706047246b98b = (0, $86089df3a0fd54eb$export$2e2bcd8739ae039)(function() {
    if (typeof window === 'undefined' || !('matchMedia' in window)) return false;
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
});


function $4b4af6ac9c2b0d5c$var$runCancellableSettlement(_ref) {
    var schedule = _ref.schedule, onSettled = _ref.onSettled;
    var isCancelled = false;
    schedule(function() {
        if (isCancelled) return;
        onSettled();
    });
    return function() {
        isCancelled = true;
    };
}
/**
 * Fires `onSettled` once all animations currently applied to `element`
 * finish or are cancelled. Returns a cleanup that prevents stale settlement.
 */ function $4b4af6ac9c2b0d5c$var$runOnAnimationsSettled(_ref2) {
    var element = _ref2.element, onSettled = _ref2.onSettled;
    return $4b4af6ac9c2b0d5c$var$runCancellableSettlement({
        onSettled: onSettled,
        schedule: function schedule(settle) {
            var _element$getAnimation, _element$getAnimation2;
            var animations = (_element$getAnimation = (_element$getAnimation2 = element.getAnimations) === null || _element$getAnimation2 === void 0 ? void 0 : _element$getAnimation2.call(element)) !== null && _element$getAnimation !== void 0 ? _element$getAnimation : [];
            Promise.allSettled(animations.map(function(animation) {
                return animation.finished;
            })).then(settle);
        }
    });
}
function $4b4af6ac9c2b0d5c$export$1bccb45daf07907f(_ref3) {
    var isOpen = _ref3.isOpen, shouldAnimate = _ref3.shouldAnimate, elementRef = _ref3.elementRef, onEnterFinish = _ref3.onEnterFinish, onExitFinish = _ref3.onExitFinish;
    var willAnimate = shouldAnimate && !(0, $7ae872ecb3ab26e9$export$ff7706047246b98b)();
    var isNativeClosedRef = (0, $5FkrB.useRef)(false);
    // Promote `closed → entering`/`closed → open` synchronously during
    // render so the host element mounts in the same commit as the open
    // intent. All other transitions are driven by phase-specific effects.
    var _useState = (0, $5FkrB.useState)(function() {
        if (!isOpen) return 'closed';
        return willAnimate ? 'entering' : 'open';
    }), _useState2 = (0, $0b8156ac98850b5f$export$2e2bcd8739ae039)(_useState, 2), phase = _useState2[0], setPhase = _useState2[1];
    // Rearm only after controlled state and the native lifecycle have both
    // reached closed. Resetting as soon as `isOpen` becomes false can erase a
    // closing toggle that was handled in the same React batch.
    if (!isOpen && phase === 'closed') isNativeClosedRef.current = false;
    if (isOpen && phase === 'closed' && !isNativeClosedRef.current) setPhase(willAnimate ? 'entering' : 'open');
    if (!isOpen && (phase === 'open' || phase === 'entering')) // Close intent. Move to `exiting` to gate the unmount on either
    // the exit transition (animated) or the closing toggle event
    // (non-animated). Includes interrupted entry (`entering → exiting`).
    setPhase('exiting');
    if (isOpen && phase === 'exiting' && !isNativeClosedRef.current) // Reopen mid-exit. With animation, jump back to `entering` and let
    // the entry transition restart from current visual state. Without
    // animation, jump straight to `open` (the handshake we were waiting
    // for is no longer relevant; the consumer wants the host visible
    // again synchronously).
    setPhase(willAnimate ? 'entering' : 'open');
    // Keep stable refs to the latest callbacks so effects and promise callbacks
    // always call the current callback without needing them in dependency arrays.
    var onEnterFinishRef = (0, $5FkrB.useRef)(onEnterFinish);
    onEnterFinishRef.current = onEnterFinish;
    var onExitFinishRef = (0, $5FkrB.useRef)(onExitFinish);
    onExitFinishRef.current = onExitFinish;
    // Animated entry: wait for all active animations and move to `open`.
    (0, $5FkrB.useEffect)(function() {
        if (phase !== 'entering') return;
        var element = elementRef.current;
        if (!element) return;
        return $4b4af6ac9c2b0d5c$var$runOnAnimationsSettled({
            element: element,
            onSettled: function onSettled() {
                var _onEnterFinishRef$cur;
                // Fire the consumer callback before transitioning phase so any
                // state the consumer reads (refs, DOM nodes) is still attached
                // in the same synchronous tick, regardless of React batching
                // semantics.
                (_onEnterFinishRef$cur = onEnterFinishRef.current) === null || _onEnterFinishRef$cur === void 0 || _onEnterFinishRef$cur.call(onEnterFinishRef);
                setPhase(function(current) {
                    return current === 'entering' ? 'open' : current;
                });
            }
        });
    }, [
        phase,
        elementRef
    ]);
    // Non-animated entry callback. The lifecycle goes `closed → open`
    // directly with no `entering` phase; fire `onEnterFinish` on that jump.
    // A previous-phase ref avoids double-firing on the animated path.
    var prevPhaseForEntryRef = (0, $5FkrB.useRef)('closed');
    (0, $5FkrB.useEffect)(function() {
        var prevPhase = prevPhaseForEntryRef.current;
        prevPhaseForEntryRef.current = phase;
        // Animated entry settle goes through `entering` and already fired
        // onEnterFinish above; only handle the non-animated direct jumps.
        if (prevPhase !== 'open' && phase === 'open' && prevPhase !== 'entering') {
            var _onEnterFinishRef$cur2;
            (_onEnterFinishRef$cur2 = onEnterFinishRef.current) === null || _onEnterFinishRef$cur2 === void 0 || _onEnterFinishRef$cur2.call(onEnterFinishRef);
        }
    }, [
        phase
    ]);
    // Animated exit: wait for all active animations, fire `onExitFinish`,
    // then move to `closed` to unmount the host.
    (0, $5FkrB.useEffect)(function() {
        if (phase !== 'exiting' || !willAnimate) return;
        var element = elementRef.current;
        if (!element) return;
        return $4b4af6ac9c2b0d5c$var$runOnAnimationsSettled({
            element: element,
            onSettled: function onSettled() {
                var _onExitFinishRef$curr;
                // Fire the consumer callback before transitioning phase to
                // `closed`. The phase change drives the host element unmount,
                // and consumers expect to be able to read the element (or a
                // forwarded ref to it) inside `onExitFinish`. Doing this in
                // the safe order avoids relying on React's automatic batching
                // to keep the element attached across the callback.
                (_onExitFinishRef$curr = onExitFinishRef.current) === null || _onExitFinishRef$curr === void 0 || _onExitFinishRef$curr.call(onExitFinishRef);
                setPhase(function(current) {
                    return current === 'exiting' ? 'closed' : current;
                });
            }
        });
    }, [
        phase,
        willAnimate,
        elementRef
    ]);
    // Native dismissal is authoritative. Its toggle can arrive while controlled
    // state still says open, so remember that native state and do not
    // reopen until `isOpen` has first moved to false.
    (0, $5FkrB.useLayoutEffect)(function() {
        if (phase === 'exiting' && !willAnimate && isNativeClosedRef.current) setPhase('closed');
    }, [
        phase,
        willAnimate
    ]);
    var onToggle = (0, $5FkrB.useCallback)(function(event) {
        if (event.newState === 'open') {
            isNativeClosedRef.current = false;
            return;
        }
        if (event.newState !== 'closed') return;
        isNativeClosedRef.current = true;
        setPhase(function(current) {
            if (current === 'open' || current === 'entering') return 'exiting';
            if (current === 'exiting' && !willAnimate) return 'closed';
            return current;
        });
    }, [
        willAnimate
    ]);
    // Non-animated exit callback. There are no animations to wait for, so fire
    // `onExitFinish` on the transition into `exiting` (the unmount itself
    // is gated by the closing toggle handshake above).
    var prevPhaseForExitRef = (0, $5FkrB.useRef)('closed');
    (0, $5FkrB.useEffect)(function() {
        var prevPhase = prevPhaseForExitRef.current;
        prevPhaseForExitRef.current = phase;
        // Only fire on the non-animated transition into `exiting`. The
        // animated path's `exiting → closed` settle already fires
        // `onExitFinish` from `runOnAnimationsSettled`.
        if (prevPhase !== 'exiting' && phase === 'exiting' && !willAnimate) {
            var _onExitFinishRef$curr2;
            (_onExitFinishRef$curr2 = onExitFinishRef.current) === null || _onExitFinishRef$curr2 === void 0 || _onExitFinishRef$curr2.call(onExitFinishRef);
        }
    }, [
        phase,
        willAnimate
    ]);
    return {
        phase: phase,
        onToggle: onToggle
    };
}



var $5FkrB = parcelRequire("5FkrB");

var $a15d6a03cfa47b73$var$topLayerSelector = '[popover], dialog, [role="dialog"], [role="alertdialog"]';
function $a15d6a03cfa47b73$export$df8c72c64edc7260(_ref) {
    var element = _ref.element, container = _ref.container;
    return element.closest($a15d6a03cfa47b73$var$topLayerSelector) === container.closest($a15d6a03cfa47b73$var$topLayerSelector);
}


var $e0b52706896c71da$export$e1252723db1c541 = function() {
    // Common exclusion filter applied to every selector.
    var not = ':not([tabindex="-1"]):not([aria-disabled="true"]):not([aria-hidden="true"])';
    var notDisabled = ":not([disabled])".concat(not);
    var focusable = [
        "a[href]".concat(not),
        "area[href]".concat(not),
        "input".concat(notDisabled, ":not([type=\"hidden\"])"),
        "select".concat(notDisabled),
        "textarea".concat(notDisabled),
        "button".concat(notDisabled),
        "iframe".concat(not),
        "audio[controls]".concat(not),
        "video[controls]".concat(not),
        "[contenteditable]:not([contenteditable=\"false\"])".concat(not),
        "[tabindex]".concat(notDisabled)
    ];
    return {
        focusable: focusable.join(','),
        // Build the `:focus` selector
        focused: focusable.map(function(selector) {
            return "".concat(selector, ":focus");
        }).join(',')
    };
}();


function $a88f1db9098ec519$export$f6768025e418420e(_ref) {
    var container = _ref.container, filter = _ref.filter;
    return Array.from(container.querySelectorAll((0, $e0b52706896c71da$export$e1252723db1c541).focusable)).filter(function(element) {
        return element instanceof HTMLElement;
    }).filter(function(element) {
        return (0, $a15d6a03cfa47b73$export$df8c72c64edc7260)({
            element: element,
            container: container
        });
    }).filter(function(element) {
        return !filter || filter(element, container);
    });
}


function $2a7ede3bbfccf375$export$748138f04a69bf21(_ref) {
    var container = _ref.container, filter = _ref.filter;
    var items = (0, $a88f1db9098ec519$export$f6768025e418420e)({
        container: container,
        filter: filter
    });
    return items.length > 0 ? items[0] : null;
}



function $458ce9ed11383167$export$73e81fa65335a75b(_ref) {
    var container = _ref.container, filter = _ref.filter;
    var items = (0, $a88f1db9098ec519$export$f6768025e418420e)({
        container: container,
        filter: filter
    });
    return items.length > 0 ? items[items.length - 1] : null;
}


/**
 * Returns the next focusable element in the given direction relative to the
 * currently focused element within the container. Wraps around at both ends.
 *
 * Returns `null` if there is no focused element within the container or if
 * the focused element is not in the list of focusable elements.
 */ 

function $5a4655208d536a2f$export$a7db88e6d491b450(_ref) {
    var _all$nextIndex;
    var container = _ref.container, direction = _ref.direction, filter = _ref.filter;
    var all = (0, $a88f1db9098ec519$export$f6768025e418420e)({
        container: container,
        filter: filter
    });
    var current = container.querySelector((0, $e0b52706896c71da$export$e1252723db1c541).focused);
    if (!(current instanceof HTMLElement)) return null;
    var index = all.indexOf(current);
    if (index === -1) return null;
    var nextIndex = function() {
        if (direction === 'forwards') return (index + 1) % all.length;
        var proposed = index - 1;
        // if going into negative numbers, loop back to the last item
        return proposed < 0 ? all.length - 1 : proposed;
    }();
    return (_all$nextIndex = all[nextIndex]) !== null && _all$nextIndex !== void 0 ? _all$nextIndex : null;
}




function $c023b8f76ff8f0f2$export$b9590fdfeb5f722f(_ref) {
    var _getDocument;
    var container = _ref.container;
    var focused = (_getDocument = (0, $fc5ac9c99de29fbb$export$f65ca476c09acec0)()) === null || _getDocument === void 0 ? void 0 : _getDocument.activeElement;
    if (!(focused instanceof HTMLElement)) return false;
    // Cannot be in a nested layer if it is not in the container
    if (!container.contains(focused)) return false;
    // If not in the same layer, must be in a nested layer
    return !(0, $a15d6a03cfa47b73$export$df8c72c64edc7260)({
        element: focused,
        container: container
    });
}


/**
 * Roles that require focus wrapping per WAI-ARIA APG.
 *
 * - `dialog`: https://www.w3.org/WAI/ARIA/apg/patterns/dialog-modal/
 * - `alertdialog`: same keyboard pattern as dialog
 *
 * `menu` is intentionally excluded. Menus are composite widgets
 * (https://www.w3.org/WAI/ARIA/apg/practices/keyboard-interface/#kbd_general_within)
 * that manage their own internal keyboard navigation via arrow keys,
 * not Tab. Tab/Shift+Tab should move focus OUT of a menu entirely.
 *
 * Menu keyboard behavior (arrow keys, Home/End, type-ahead, Enter/Space)
 * is context-dependent. It varies by orientation, nesting depth, item
 * type, and control pattern (menu button vs menubar). This makes it
 * impossible to implement generically here. The consumer component
 * (e.g. `dropdown-menu`) owns all menu keyboard navigation.
 *
 * See: notes/outputs/menu-keyboard-decision.md
 */ function $24e12333f089bf31$var$roleRequiresFocusWrap(role) {
    return role === 'dialog' || role === 'alertdialog';
}
function $24e12333f089bf31$export$4f6462e86a70abe5(_ref) {
    var elementRef = _ref.elementRef, role = _ref.role, phase = _ref.phase;
    var isVisible = phase !== 'closed';
    (0, $5FkrB.useEffect)(function() {
        var element = elementRef.current;
        if (!element || !$24e12333f089bf31$var$roleRequiresFocusWrap(role) || !isVisible) return;
        var unbind = (0, $5b617c1f48263075$exports.bind)(element, {
            type: 'keydown',
            listener: function listener(event) {
                if (event.key !== 'Tab') return;
                // If focus is already in a nested layer, then
                // we continue to let that nested layer own focus
                if ((0, $c023b8f76ff8f0f2$export$b9590fdfeb5f722f)({
                    container: element
                })) return;
                // Prevent the browser giving focus to where it wants to
                // (we will be handling it, including with wrapping)
                event.preventDefault();
                var direction = event.shiftKey ? 'backwards' : 'forwards';
                // Try to move to the next/previous focusable element relative
                // to the currently focused element within the container.
                var next = (0, $5a4655208d536a2f$export$a7db88e6d491b450)({
                    container: element,
                    direction: direction
                });
                if (next) {
                    next.focus();
                    return;
                }
                // Nothing is currently focused inside the container (or the
                // focused element is not in the focusable list). Fall back to
                // the first or last focusable element depending on direction.
                var fallback = direction === 'forwards' ? (0, $2a7ede3bbfccf375$export$748138f04a69bf21)({
                    container: element
                }) : (0, $458ce9ed11383167$export$73e81fa65335a75b)({
                    container: element
                });
                if (fallback) fallback.focus();
            },
            options: {
                capture: true
            }
        });
        return unbind;
    }, [
        elementRef,
        role,
        isVisible
    ]);
}



var $5FkrB = parcelRequire("5FkrB");

/**
 * Determines the correct element to receive initial focus within a popover,
 * based on its ARIA role.
 *
 * Focus rules by role (per WAI-ARIA APG):
 * - `dialog` / `alertdialog`: first element with `[autofocus]`, or first focusable element
 * - `menu`: first menu item (`[role="menuitem|menuitemcheckbox|menuitemradio"]`)
 * - `listbox`: first selected option (`[aria-selected="true"]`), or first option (`[role="option"]`)
 * - `tooltip`: no focus movement (tooltips are informational)
 * - no role / other roles: no focus movement
 *
 * Note: React 18's `autoFocus` JSX prop does NOT set the HTML `autofocus`
 * attribute - it only calls `.focus()` imperatively during commit, which
 * has no effect on hidden popover content. Consumers must set the native
 * attribute via a ref callback (e.g. `node.setAttribute('autofocus', '')`).
 * React 19+ reflects the JSX prop as the HTML attribute automatically.
 *
 * Combobox pattern exception: if the popup is controlled by a focused
 * combobox-like trigger (its `aria-controls` references this popup),
 * focus stays on the textbox regardless of role. See
 * `isComboboxControllingPopup`.
 */ /**
 * WAI-ARIA APG Combobox Pattern: when a combobox controls a popup (listbox,
 * grid, tree, or menu), DOM focus must remain on the textbox. Subsequent
 * navigation through popup items uses `aria-activedescendant` (or proxied
 * keyboard events), never DOM focus movement.
 *
 * Detects both variants in a single pass:
 * - In-popup combobox: the textbox lives inside the popup `container`
 *   (the popup is rendered as a child of the combobox wrapper).
 * - External combobox: the textbox is rendered OUTSIDE the popup
 *   (`react-select` pattern, where the listbox is portalled separately
 *   from the textbox).
 *
 * Acceptance criteria for the active element:
 * - Role / element-type filter: `role="combobox"`, `role="textbox"`,
 *   `TEXTAREA`, `contentEditable`, or `INPUT` of text-like type
 *   (`text`, `search`, `email`, `url`, `tel`, `password`, or
 *   unspecified). Non-text input types (`button`, `checkbox`, etc.)
 *   are rejected.
 * - Reference filter: `aria-controls` (or legacy `aria-owns`) IDREFS
 *   must resolve to an element that IS or CONTAINS the popup container.
 *
 * See: https://www.w3.org/WAI/ARIA/apg/patterns/combobox/
 */ // `<input>` types treated as text-like for combobox detection.
// Non-text input types (`button`, `checkbox`, `submit`, etc.) are rejected.
// A missing `type` attribute defaults to `text` per the HTML spec, so we
// normalize that case before lookup rather than including an empty string here.
var $7932b0b4500a320e$var$TEXT_LIKE_INPUT_TYPES = new Set([
    'text',
    'search',
    'email',
    'url',
    'tel',
    'password'
]);
function $7932b0b4500a320e$var$isTextboxLikeElement(element) {
    var role = element.getAttribute('role');
    if (role === 'combobox' || role === 'textbox') return true;
    // `tagName` is uppercase for HTML elements but can be mixed-case for
    // XML/SVG. Normalize once so downstream comparisons stay lowercase.
    var tag = element.tagName.toLowerCase();
    if (tag === 'textarea') return true;
    if (element.isContentEditable) return true;
    if (tag === 'input') {
        var _element$getAttribute;
        var type = ((_element$getAttribute = element.getAttribute('type')) !== null && _element$getAttribute !== void 0 ? _element$getAttribute : 'text').toLowerCase();
        return $7932b0b4500a320e$var$TEXT_LIKE_INPUT_TYPES.has(type);
    }
    return false;
}
function $7932b0b4500a320e$var$isComboboxControllingPopup(_ref) {
    var _active$getAttribute;
    var container = _ref.container;
    var ownerDocument = container.ownerDocument;
    var active = ownerDocument.activeElement;
    if (!(active instanceof HTMLElement)) return false;
    if (!$7932b0b4500a320e$var$isTextboxLikeElement(active)) return false;
    // Accept legacy `aria-owns` in addition to `aria-controls`.
    // `aria-controls` / `aria-owns` are IDREFS (space-separated list of IDs)
    // per the WAI-ARIA spec, so we must split and check membership rather
    // than comparing with strict equality. A combobox that controls both
    // this popup and another element (e.g. a results status region) must
    // still be recognised as controlling this popup.
    var idRefs = (_active$getAttribute = active.getAttribute('aria-controls')) !== null && _active$getAttribute !== void 0 ? _active$getAttribute : active.getAttribute('aria-owns');
    if (!idRefs) return false;
    // Match if any referenced element IS, CONTAINS, or IS CONTAINED BY the
    // popup container. The "contained by" case covers wrapper-style adopters
    // like react-select, where the combobox input's `aria-controls` points at
    // a listbox element that is a descendant of the Popover host (the
    // listbox role lives on a child the wrapped library owns, not on the
    // host we render).
    var referencedIds = idRefs.split(/\s+/).filter(function(id) {
        return id !== '';
    });
    return referencedIds.some(function(id) {
        var referenced = ownerDocument.getElementById(id);
        if (!referenced) return false;
        return referenced === container || referenced.contains(container) || container.contains(referenced);
    });
}
function $7932b0b4500a320e$var$getInitialFocusTarget(_ref2) {
    var container = _ref2.container, role = _ref2.role;
    if (role === 'dialog' || role === 'alertdialog') {
        // Prefer element with the native HTML autofocus attribute.
        var autofocusEl = container.querySelector('[autofocus]');
        if (autofocusEl) return autofocusEl;
        // Fall back to first focusable element
        return (0, $2a7ede3bbfccf375$export$748138f04a69bf21)({
            container: container
        });
    }
    // The combobox carve-out is kept role-specific (menu / listbox) rather
    // than hoisted. Hoisting it over-matched on dialog popups that contain
    // a nested combobox (e.g. datetime-picker's dialog hosts a react-select),
    // where the active combobox's `aria-controls` falsely matched the
    // container and suppressed the dialog's own focus contract.
    if (role === 'menu') {
        if ($7932b0b4500a320e$var$isComboboxControllingPopup({
            container: container
        })) return null;
        // Initial focus placement is the extent of what top-layer provides
        // for menus. All subsequent keyboard navigation (arrow keys, Home/End,
        // type-ahead, Enter/Space, submenu coordination) is the responsibility
        // of the consumer component (e.g. dropdown-menu), because menu keyboard
        // behavior varies by context (orientation, nesting, item type, control
        // pattern). See: notes/outputs/menu-keyboard-decision.md
        return (0, $2a7ede3bbfccf375$export$748138f04a69bf21)({
            container: container
        });
    }
    if (role === 'listbox') {
        // ARIA Combobox Pattern: if a combobox-like textbox owns the popup
        // (in-popup or external e.g. react-select), leave focus on the
        // textbox - navigation is proxied through it.
        if ($7932b0b4500a320e$var$isComboboxControllingPopup({
            container: container
        })) return null;
        // Prefer the selected option, then fall back to the first option.
        // We intentionally match by `[role="option"]` rather than by
        // `getFirstFocusable`. The standard WAI-ARIA APG listbox pattern
        // renders options with `tabindex="-1"` (managed via roving
        // tabindex); `getFirstFocusable` excludes `tabindex="-1"` elements
        // and would silently lose initial focus for spec-conformant
        // listboxes. Options remain programmatically focusable.
        var selectedOption = container.querySelector('[role="option"][aria-selected="true"]');
        if (selectedOption) return selectedOption;
        var firstOption = container.querySelector('[role="option"]');
        if (firstOption) return firstOption;
        // Last resort for non-standard listboxes that render no options
        // but do contain a focusable element (e.g. an empty-state action).
        return (0, $2a7ede3bbfccf375$export$748138f04a69bf21)({
            container: container
        });
    }
    // tooltip, no role, or other roles: no focus movement
    return null;
}
function $7932b0b4500a320e$export$e992c40175757a22(_ref3) {
    var elementRef = _ref3.elementRef, phase = _ref3.phase, role = _ref3.role;
    // Track the previous phase so we only focus on transitions into a
    // visible phase from either `'closed'` (fresh mount) or `'exiting'`
    // (mid-exit reopen where the browser has already restored focus to
    // the trigger). Pure `entering → exiting → entering` stutters where
    // the consumer toggles in the same frame are still collapsed.
    var prevPhaseRef = (0, $5FkrB.useRef)('closed');
    (0, $5FkrB.useEffect)(function() {
        var _getInitialFocusTarge;
        var prevPhase = prevPhaseRef.current;
        prevPhaseRef.current = phase;
        // Only focus on transitions into a visible phase from `'closed'`
        // (fresh open) or `'exiting'` (mid-exit reopen).
        if (phase === 'closed') return;
        if (prevPhase !== 'closed' && prevPhase !== 'exiting') return;
        var element = elementRef.current;
        if (!element) return;
        (_getInitialFocusTarge = $7932b0b4500a320e$var$getInitialFocusTarget({
            container: element,
            role: role
        })) === null || _getInitialFocusTarge === void 0 || _getInitialFocusTarge.focus();
    }, [
        elementRef,
        phase,
        role
    ]);
}


/**
 * Detects `popover="hint"` support via DOM reflection. SSR-safe, cached.
 */ var $051a9d50aec333c1$var$supportsPopoverHint = (0, $86089df3a0fd54eb$export$2e2bcd8739ae039)(function() {
    if (typeof document === 'undefined') return false;
    // eslint-disable-next-line @atlaskit/platform/no-direct-document-usage -- feature detection
    var element = document.createElement('div');
    element.setAttribute('popover', 'hint');
    return element.popover === 'hint';
});
// Surface reset — neutralises inherited interaction and text-layout properties
// (e.g. `pointer-events: none` from an overlaid controls container and
// `white-space: nowrap` from an `@atlaskit/select` option) that leak into a
// top-layer element because, for CSS inheritance, it is still a DOM child of its
// trigger (top-layer promotion is paint/stacking only; the legacy portal path
// avoided this by rendering at `<body>`). Excludes `color`/`font` (theming) and
// `direction`/`unicode-bidi` (RTL must inherit).
//
// KEEP IN SYNC with the identical `surfaceResetStyles` in `dialog/dialog-content.tsx`.
// ADS forbids sharing styles across files (`no-exported-styles` /
// `no-imported-style-values` — Compiled styles are null at runtime), so the reset is
// co-located and duplicated deliberately.
var $051a9d50aec333c1$var$surfaceResetStyles = {
    root: "_lcxv1wug _o5724jg8 _1nmz4jg8 _1i4q4jg8 _y3gnv2br _azhwidpf _1p1dglyw"
};
var $051a9d50aec333c1$var$styles = {
    root: "_19itglyw _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19pkidpf _2hwxidpf _otyridpf _18u0idpf _1r041wug _1reoewfl _18m9ewfl _bfhk1j28 _4t3i1wug",
    motion: "_k8m011k7 _1oecdn4k _1s9z1a5r _1o511hrf _bl8aglyw _156y147i",
    enter: "_y44v179n",
    exit: "_y44vof1f"
};
// Intentionally using `Record<string, string>` instead of `React.CSSProperties`
// to avoid type errors about the CSS variables not being valid property names
var $051a9d50aec333c1$var$popupMotionStyles = {
    block: {
        start: {
            '--ds-popover-motion-enter': "var(--ds-popup-enter-top, 150ms cubic-bezier(0.4, 1, 0.6, 1) SlideInTop8px, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn0to100)",
            '--ds-popover-motion-exit': "var(--ds-popup-exit-top, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) SlideOutTop8px, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)"
        },
        end: {
            '--ds-popover-motion-enter': "var(--ds-popup-enter-bottom, 150ms cubic-bezier(0.4, 1, 0.6, 1) SlideInBottom8px, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn0to100)",
            '--ds-popover-motion-exit': "var(--ds-popup-exit-bottom, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) SlideOutBottom8px, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)"
        }
    },
    inline: {
        start: {
            '--ds-popover-motion-enter': "var(--ds-popup-enter-left, 150ms cubic-bezier(0.4, 1, 0.6, 1) SlideInLeft8px, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn0to100)",
            '--ds-popover-motion-exit': "var(--ds-popup-exit-left, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) SlideOutLeft8px, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)"
        },
        end: {
            '--ds-popover-motion-enter': "var(--ds-popup-enter-right, 150ms cubic-bezier(0.4, 1, 0.6, 1) SlideInRight8px, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn0to100)",
            '--ds-popover-motion-exit': "var(--ds-popup-exit-right, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) SlideOutRight8px, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)"
        }
    }
};
/**
 * Roles registered with the open layer observer as `popup`, so `closeLayers()`
 * dismisses them. `modal` comes from Dialog only; other layer types are unused.
 */ var $051a9d50aec333c1$var$POPUP_ROLES = new Set([
    'menu',
    'listbox',
    'dialog',
    'alertdialog',
    'tree',
    'grid'
]);
var $051a9d50aec333c1$export$5b6b19405a83ff9d = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function Popover(_ref, ref) {
    var children = _ref.children, _ref$mode = _ref.mode, modeProp = _ref$mode === void 0 ? 'auto' : _ref$mode, onClose = _ref.onClose, onEnterFinish = _ref.onEnterFinish, onExitFinish = _ref.onExitFinish, _ref$shouldAnimate = _ref.shouldAnimate, shouldAnimate = _ref$shouldAnimate === void 0 ? false : _ref$shouldAnimate, placement = _ref.placement, testId = _ref.testId, isOpen = _ref.isOpen, enteringAnimationXcss = _ref.enteringAnimationXcss, exitingAnimationXcss = _ref.exitingAnimationXcss, role = _ref.role, label = _ref.label, labelledBy = _ref.labelledBy, idProp = _ref.id;
    var autoId = (0, $5FkrB.useId)();
    var ownRef = (0, $5FkrB.useRef)(null);
    var combinedRef = (0, $db13a2f91f6a0f56$export$2e2bcd8739ae039)([
        ownRef,
        ref
    ].filter(Boolean));
    // `useId()` colons are invalid in CSS selectors and popover target attributes.
    var popoverId = idProp !== null && idProp !== void 0 ? idProp : "popover-".concat(autoId.replace(/:/g, ''));
    var _useAnimatedVisibilit = (0, $4b4af6ac9c2b0d5c$export$1bccb45daf07907f)({
        isOpen: isOpen,
        shouldAnimate: shouldAnimate,
        elementRef: ownRef,
        onEnterFinish: onEnterFinish,
        onExitFinish: onExitFinish
    }), phase = _useAnimatedVisibilit.phase, onToggle = _useAnimatedVisibilit.onToggle;
    // True while the host element is mounted (any phase except `closed`).
    // Used as a dep so listener-rebind effects re-attach after a remount.
    var isVisible = phase !== 'closed';
    // Focus management: initial focus on entry (role-dependent), Tab cycling
    // for dialog roles. Restoration is native for outermost popovers; nested
    // focus-capturing roles are handled below via the `beforetoggle` snapshot.
    // Passing `phase` keeps `useFocusWrap` attached through the animated-exit
    // window (WCAG 2.4.3 guard). See notes/architecture/focus-restoration.md.
    (0, $24e12333f089bf31$export$4f6462e86a70abe5)({
        elementRef: ownRef,
        role: role,
        phase: phase
    });
    (0, $7932b0b4500a320e$export$e992c40175757a22)({
        elementRef: ownRef,
        phase: phase,
        role: role
    });
    // Register with open layer observer so `closeLayers()` and open-count
    // subscriptions work. Only popup-like roles register as `popup`; passive
    // roles (tooltip, status, etc.) leave `type` undefined.
    var handleObserverClose = (0, $5FkrB.useCallback)(function() {
        onClose === null || onClose === void 0 || onClose({
            reason: 'programmatic'
        });
    }, [
        onClose
    ]);
    (0, $914d64dc0ec49129$export$469bb693f11edc7f)({
        type: role && $051a9d50aec333c1$var$POPUP_ROLES.has(role) ? 'popup' : undefined,
        isOpen: isOpen,
        onClose: handleObserverClose
    });
    // `hint` falls back to `auto` when unsupported: closest behavior (light
    // dismiss works), but `auto` participates in the auto-dismiss stack so it
    // will close other `auto` popovers when opened. Acceptable trade-off given
    // shrinking browser set without `hint` support.
    var mode = modeProp === 'hint' && !$051a9d50aec333c1$var$supportsPopoverHint() ? 'auto' : modeProp;
    var popupMotionStyle = (0, $5FkrB.useMemo)(function() {
        if (!placement || !shouldAnimate) return undefined;
        var _resolvePlacement = (0, $4d4da76463e3fc46$export$63044d21bc3d3fa2)({
            placement: placement
        }), axis = _resolvePlacement.axis, edge = _resolvePlacement.edge;
        return $051a9d50aec333c1$var$popupMotionStyles[axis][edge];
    }, [
        placement,
        shouldAnimate
    ]);
    // Prevents toggle handler from calling onClose for our own hidePopover() calls.
    var programmaticCloseRef = (0, $5FkrB.useRef)(false);
    // Set in capture-phase keydown so the toggle handler knows close reason.
    var closeReasonRef = (0, $5FkrB.useRef)('light-dismiss');
    // Snapshot of pre-open focus, used to restore focus for nested popovers
    // with focus-capturing roles (browser only restores the outermost).
    var previouslyFocusedElementRef = (0, $5FkrB.useRef)(null);
    var handleBeforeToggle = (0, $5FkrB.useCallback)(function(event) {
        if (event.newState !== 'open') return;
        // eslint-disable-next-line @atlaskit/platform/no-direct-document-usage -- need active element snapshot
        var active = document.activeElement;
        previouslyFocusedElementRef.current = active instanceof HTMLElement ? active : null;
    }, []);
    var handleToggle = (0, $5FkrB.useCallback)(function(event) {
        var element = ownRef.current;
        if (event.newState === 'open') {
            onToggle(event);
            return;
        }
        if (event.newState === 'closed') {
            if (element) {
                // Nested-popover focus restoration fallback (browser only
                // restores outermost; Firefox skips nested entirely).
                // Restore only when the role moved focus in on open AND the
                // close was Escape/programmatic. For light dismiss, the
                // click target keeps focus per HTML spec
                // (`focusPreviousElement=false`).
                var previouslyFocused = previouslyFocusedElementRef.current;
                var reason = closeReasonRef.current;
                var isProgrammatic = programmaticCloseRef.current;
                var shouldRestore = previouslyFocused !== null && previouslyFocused.isConnected && (0, $07b89e7d046a90d2$export$b12adccf56228c71)({
                    role: role
                }) && (reason === 'escape' || isProgrammatic);
                if (shouldRestore && previouslyFocused) previouslyFocused.focus({
                    preventScroll: true
                });
                previouslyFocusedElementRef.current = null;
            }
            // Programmatic close: consumer already knows.
            if (programmaticCloseRef.current) // Reset reason so a stale 'escape' from a race with Escape keydown
            // does not corrupt the next browser-dismiss cycle.
            closeReasonRef.current = 'light-dismiss';
            else {
                // Browser dismiss (Escape/click-outside).
                var _reason = closeReasonRef.current;
                closeReasonRef.current = 'light-dismiss';
                // Optional: `manual` mode has no `onClose` in the forwarded type.
                onClose === null || onClose === void 0 || onClose({
                    reason: _reason
                });
            }
        }
        onToggle(event);
    }, [
        onClose,
        onToggle,
        role
    ]);
    // Bind via `useLayoutEffect`, and BEFORE the show/hide layout effect
    // below, so listeners are attached when `showPopover()` synchronously
    // dispatches `beforetoggle`. A regular `useEffect` would miss that
    // first dispatch, dropping the `previouslyFocusedElementRef` snapshot
    // and breaking nested-popover focus restoration on close. React runs
    // layout effects in source order on the same commit.
    (0, $5FkrB.useLayoutEffect)(function() {
        var element = ownRef.current;
        if (!element) return;
        // Tag Escape before the browser processes light dismiss.
        var unbindEscape = (0, $5b617c1f48263075$exports.bind)(element, {
            type: 'keydown',
            listener: function listener(event) {
                if (event.key === 'Escape') closeReasonRef.current = 'escape';
            },
            options: {
                capture: true
            }
        });
        var unbindToggle = (0, $5b617c1f48263075$exports.bind)(element, {
            type: 'toggle',
            listener: handleToggle
        });
        // Snapshot `document.activeElement` before `useInitialFocus` moves it.
        var unbindBeforeToggle = (0, $5b617c1f48263075$exports.bind)(element, {
            type: 'beforetoggle',
            listener: handleBeforeToggle
        });
        return function() {
            unbindEscape();
            unbindToggle();
            unbindBeforeToggle();
        };
    }, [
        handleToggle,
        handleBeforeToggle,
        isVisible
    ]);
    // Show/hide based on isOpen. `showPopover`/`hidePopover` are no-ops when
    // already in the target state. Try/catch guards `InvalidStateError` on
    // disconnected elements (StrictMode/concurrent/unmount edge cases).
    (0, $5FkrB.useLayoutEffect)(function() {
        var element = ownRef.current;
        if (!element) return;
        if (isOpen) {
            programmaticCloseRef.current = false;
            // Clear stale 'escape' from a prior cycle: the ref outlives
            // the host element, and the no-animation path unmounts before
            // `handleToggle` can reset it.
            closeReasonRef.current = 'light-dismiss';
            try {
                element.showPopover();
            } catch (_unused) {}
            return function() {
                programmaticCloseRef.current = true;
                try {
                    element.hidePopover();
                } catch (_unused2) {}
            };
        }
        programmaticCloseRef.current = true;
        try {
            element.hidePopover();
        } catch (_unused3) {}
    }, [
        isOpen
    ]);
    // Unmount the host once exit completes so it does not leave an empty
    // `role`/`popover` element in the accessibility tree. The element
    // remounts on the next open; the `popoverId` is stable across opens.
    if (!isVisible) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("div", {
        ref: combinedRef,
        id: popoverId,
        popover: mode,
        role: role,
        "aria-label": label,
        "aria-labelledby": labelledBy,
        "data-testid": testId,
        style: popupMotionStyle,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $dbf53395d39974cf$export$2e2bcd8739ae039)([
            $051a9d50aec333c1$var$styles.root,
            $051a9d50aec333c1$var$surfaceResetStyles.root,
            shouldAnimate && phase === 'entering' && $051a9d50aec333c1$var$styles.enter,
            shouldAnimate && phase === 'exiting' && $051a9d50aec333c1$var$styles.exit,
            shouldAnimate && $051a9d50aec333c1$var$styles.motion,
            (0, $7b383e1b2d1763a3$export$a274e22fb40f762e)(shouldAnimate && phase === 'entering' && enteringAnimationXcss, shouldAnimate && phase === 'exiting' && exitingAnimationXcss)
        ])
    }, children);
});


/* popover-surface.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $5FkrB = parcelRequire("5FkrB");

var $90e6fd4ff800cdc4$var$styles = {
    root: "_2rkofajl _1reo1wug _18m91wug _bfhk1bhr _syazi7uo _16qs130s"
};
function $90e6fd4ff800cdc4$export$8b7437164e479115(_ref) {
    var children = _ref.children;
    return /*#__PURE__*/ $5FkrB.createElement("div", {
        className: (0, $dbf53395d39974cf$export$2e2bcd8739ae039)([
            $90e6fd4ff800cdc4$var$styles.root
        ])
    }, children);
}



function $92808d2bde132087$export$2e2bcd8739ae039(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}



function $6c5779c47b0ee166$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, (0, $7a62fe6c1b404e60$export$2e2bcd8739ae039)(o.key), o);
    }
}
function $6c5779c47b0ee166$export$2e2bcd8739ae039(e, r, t) {
    return r && $6c5779c47b0ee166$var$_defineProperties(e.prototype, r), t && $6c5779c47b0ee166$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}



var $5FkrB = parcelRequire("5FkrB");




function $f22a1d974618ba72$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $f22a1d974618ba72$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $f22a1d974618ba72$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $49250faa9cba8c7f$export$2e2bcd8739ae039)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $f22a1d974618ba72$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
/**
 * JS fallback positioning math. Used only when the browser does not
 * support CSS Anchor Positioning (less than 6% of users).
 *
 * Consumer-supplied `offset.gap` and `offset.crossAxisShift` are
 * honored: the caller (`useAnchorPosition`) resolves CSS length strings
 * (tokens, calc, var, etc) to pixels via a DOM probe before passing them
 * in. The caller also keeps the popover hidden (`opacity: 0`) until the
 * first measurement completes, so the popover never paints at the wrong
 * position.
 */ /**
 * A viewport-relative position, in pixels. Physical rather than logical
 * because it is written straight to `top` / `left`.
 */ /**
 * The cross-axis shift with its length already resolved to pixels.
 *
 * Mirrors `TCrossAxisShiftOffset`, whose `value` is an unresolved CSS length
 * string. Only this module needs the pixel form, because only this module does
 * the arithmetic itself.
 */ /**
 * Computes the base {top, left} position based on the primary edge,
 * flipping to the opposite side when there is not enough space.
 *
 * `gap` is applied along the main axis between trigger and popover.
 */ function $f22a1d974618ba72$var$computeEdgePosition(_ref) {
    var axis = _ref.axis, edge = _ref.edge, triggerRect = _ref.triggerRect, popoverWidth = _ref.popoverWidth, popoverHeight = _ref.popoverHeight, viewport = _ref.viewport, gap = _ref.gap;
    if (axis === 'block' && edge === 'end') {
        // Below trigger
        var spaceBelow = viewport.height - triggerRect.bottom;
        var spaceAbove = triggerRect.top;
        var fitsBelow = spaceBelow >= popoverHeight + gap;
        var useBelow = fitsBelow || spaceBelow >= spaceAbove;
        return {
            top: useBelow ? triggerRect.bottom + gap : triggerRect.top - popoverHeight - gap,
            left: triggerRect.left + triggerRect.width / 2 - popoverWidth / 2
        };
    }
    if (axis === 'block' && edge === 'start') {
        // Above trigger
        var _spaceAbove = triggerRect.top;
        var _spaceBelow = viewport.height - triggerRect.bottom;
        var fitsAbove = _spaceAbove >= popoverHeight + gap;
        var useAbove = fitsAbove || _spaceAbove >= _spaceBelow;
        return {
            top: useAbove ? triggerRect.top - popoverHeight - gap : triggerRect.bottom + gap,
            left: triggerRect.left + triggerRect.width / 2 - popoverWidth / 2
        };
    }
    if (axis === 'inline' && edge === 'end') {
        // Right of trigger
        var spaceRight = viewport.width - triggerRect.right;
        var spaceLeft = triggerRect.left;
        var fitsRight = spaceRight >= popoverWidth + gap;
        var useRight = fitsRight || spaceRight >= spaceLeft;
        return {
            top: triggerRect.top + triggerRect.height / 2 - popoverHeight / 2,
            left: useRight ? triggerRect.right + gap : triggerRect.left - popoverWidth - gap
        };
    }
    if (axis === 'inline' && edge === 'start') {
        // Left of trigger
        var _spaceLeft = triggerRect.left;
        var _spaceRight = viewport.width - triggerRect.right;
        var fitsLeft = _spaceLeft >= popoverWidth + gap;
        var useLeft = fitsLeft || _spaceLeft >= _spaceRight;
        return {
            top: triggerRect.top + triggerRect.height / 2 - popoverHeight / 2,
            left: useLeft ? triggerRect.left - popoverWidth - gap : triggerRect.right + gap
        };
    }
    // Unreachable for valid placements; defaults to below trigger
    return {
        top: triggerRect.bottom + gap,
        left: triggerRect.left + triggerRect.width / 2 - popoverWidth / 2
    };
}
/**
 * Adjusts the base (centered) position for non-center alignments.
 *
 * `align: 'start'` → popover start edge at trigger start edge
 * `align: 'end'`   → popover end edge at trigger end edge
 */ function $f22a1d974618ba72$var$applyAlignment(_ref2) {
    var position = _ref2.position, axis = _ref2.axis, align = _ref2.align, triggerRect = _ref2.triggerRect, popoverWidth = _ref2.popoverWidth, popoverHeight = _ref2.popoverHeight;
    if (align === 'center') return position;
    if (axis === 'block') {
        // Block-axis placement → cross-axis is inline (left/right)
        if (align === 'start') return $f22a1d974618ba72$var$_objectSpread($f22a1d974618ba72$var$_objectSpread({}, position), {}, {
            left: triggerRect.left
        });
        // align === 'end'
        return $f22a1d974618ba72$var$_objectSpread($f22a1d974618ba72$var$_objectSpread({}, position), {}, {
            left: triggerRect.right - popoverWidth
        });
    }
    // Inline-axis placement → cross-axis is block (top/bottom)
    if (align === 'start') return $f22a1d974618ba72$var$_objectSpread($f22a1d974618ba72$var$_objectSpread({}, position), {}, {
        top: triggerRect.top
    });
    // align === 'end'
    return $f22a1d974618ba72$var$_objectSpread($f22a1d974618ba72$var$_objectSpread({}, position), {}, {
        top: triggerRect.bottom - popoverHeight
    });
}
/**
 * Applies the cross-axis shift offset.
 *
 * `forwards` always moves the popover toward the cross-axis END and
 * `backwards` toward the START, for every `align` value. See
 * `notes/decisions/placement-offset.md`.
 *
 * This is a coordinate, so the direction is the sign and nothing else. There
 * is deliberately no per-`align` sign inversion here: the CSS path inverts the
 * sign only because a margin on the END side pushes a box the opposite way to
 * a margin on the START side, which is a property of margins rather than of
 * the shift. Applying that inversion to a coordinate moved `align: 'end'`
 * popovers the wrong way.
 */ function $f22a1d974618ba72$var$applyCrossAxisShift(_ref3) {
    var position = _ref3.position, axis = _ref3.axis, crossAxisShift = _ref3.crossAxisShift;
    if (crossAxisShift.value === 0) return position;
    var directionSign = crossAxisShift.direction === 'forwards' ? 1 : -1;
    var delta = crossAxisShift.value * directionSign;
    // Cross-axis is the OPPOSITE of the placement axis.
    if (axis === 'block') return $f22a1d974618ba72$var$_objectSpread($f22a1d974618ba72$var$_objectSpread({}, position), {}, {
        left: position.left + delta
    });
    return $f22a1d974618ba72$var$_objectSpread($f22a1d974618ba72$var$_objectSpread({}, position), {}, {
        top: position.top + delta
    });
}
function $f22a1d974618ba72$export$d5ef1dac02135664(_ref4) {
    var triggerRect = _ref4.triggerRect, popoverEl = _ref4.popoverEl, placement = _ref4.placement, viewport = _ref4.viewport, gap = _ref4.gap, crossAxisShift = _ref4.crossAxisShift;
    var axis = placement.axis, edge = placement.edge, align = placement.align;
    // Measure popover dimensions. Callers must ensure the popover has
    // laid out before calling this (it should not be `display: none`).
    var popoverWidth = popoverEl.offsetWidth;
    var popoverHeight = popoverEl.offsetHeight;
    var basePosition = $f22a1d974618ba72$var$computeEdgePosition({
        axis: axis,
        edge: edge,
        triggerRect: triggerRect,
        popoverWidth: popoverWidth,
        popoverHeight: popoverHeight,
        viewport: viewport,
        gap: gap
    });
    var alignedPosition = $f22a1d974618ba72$var$applyAlignment({
        position: basePosition,
        axis: axis,
        align: align,
        triggerRect: triggerRect,
        popoverWidth: popoverWidth,
        popoverHeight: popoverHeight
    });
    var shiftedPosition = $f22a1d974618ba72$var$applyCrossAxisShift({
        position: alignedPosition,
        axis: axis,
        crossAxisShift: crossAxisShift
    });
    // Clamp to viewport so the popover is never offscreen
    return {
        top: Math.max(0, Math.min(shiftedPosition.top, viewport.height - popoverHeight)),
        left: Math.max(0, Math.min(shiftedPosition.left, viewport.width - popoverWidth))
    };
}


/**
 * Combine multiple cleanup functions into a single cleanup function.
 *
 * @example
 * ```ts
 * useEffect(() => {
 *   return combine(
 *     bind(window, { type: 'resize', listener: onResize }),
 *     bind(window, { type: 'scroll', listener: onScroll, options: { capture: true } }),
 *   );
 * }, []);
 * ```
 */ function $4090ff1f05bf2704$export$1be1fc439b849fdf() {
    for(var _len = arguments.length, cleanupFns = new Array(_len), _key = 0; _key < _len; _key++)cleanupFns[_key] = arguments[_key];
    return function cleanup() {
        cleanupFns.forEach(function(callback) {
            return callback === null || callback === void 0 ? void 0 : callback();
        });
    };
}



function $5d1f63ff8b0dd0d4$export$de49b61f233ddeb9(_ref) {
    var placement = _ref.placement;
    var _resolvePlacement = (0, $4d4da76463e3fc46$export$63044d21bc3d3fa2)({
        placement: placement
    }), axis = _resolvePlacement.axis, edge = _resolvePlacement.edge, align = _resolvePlacement.align;
    var edgeValue = "".concat(axis, "-").concat(edge);
    if (align === 'center') return edgeValue;
    // Cross-axis name: block ↔ inline
    var crossAxis = axis === 'block' ? 'inline' : 'block';
    // Invert align → CSS span direction: visual 'start' → span toward 'end'
    var spanDir = align === 'start' ? 'end' : 'start';
    return "".concat(edgeValue, " span-").concat(crossAxis, "-").concat(spanDir);
}



/**
 * A `position-area` primary edge — the placement axis joined to its edge, e.g.
 * `block-end` or `inline-start`. These are the four edges a popover can sit on.
 */ function $51b15966fa8d11ed$var$slideOnEdge(_ref) {
    var align = _ref.align, edgeKey = _ref.edgeKey, crossAxis = _ref.crossAxis;
    if (align === 'center') return [
        "".concat(edgeKey, " span-").concat(crossAxis, "-end"),
        "".concat(edgeKey, " span-").concat(crossAxis, "-start")
    ];
    // For `align: 'start'` the popover expands toward `end`, so the "near"
    // span is `end` and the "far" span is `start`; `align: 'end'` mirrors
    // this. The bare `edgeKey` (re-centered) sits between them.
    var near = align === 'start' ? 'end' : 'start';
    var far = align === 'start' ? 'start' : 'end';
    return [
        "".concat(edgeKey, " span-").concat(crossAxis, "-").concat(near),
        edgeKey,
        "".concat(edgeKey, " span-").concat(crossAxis, "-").concat(far)
    ];
}
function $51b15966fa8d11ed$var$flipDiagonally(_ref2) {
    var axis = _ref2.axis;
    var flipOnMainAxis = axis === 'block' ? 'flip-block' : 'flip-inline';
    var flipToCrossAxis = axis === 'block' ? 'flip-inline' : 'flip-block';
    return "".concat(flipOnMainAxis, " ").concat(flipToCrossAxis);
}
function $51b15966fa8d11ed$export$c4e16947a95d61f1(_ref3) {
    var placement = _ref3.placement;
    /**
   * **Build the fallback list**
   *
   * Each entry is a complete alternative position.
   * The browser tries them _in order_ and uses the _first_ one that fits.
   */ var resolved = (0, $4d4da76463e3fc46$export$63044d21bc3d3fa2)({
        placement: placement
    });
    var axis = resolved.axis, edge = resolved.edge, align = resolved.align;
    var crossAxis = axis === 'block' ? 'inline' : 'block';
    var flippedEdge = edge === 'start' ? 'end' : 'start';
    var sameEdgeArea = "".concat(axis, "-").concat(edge);
    var oppositeEdgeArea = "".concat(axis, "-").concat(flippedEdge);
    var flipOnMainAxis = axis === 'block' ? 'flip-block' : 'flip-inline';
    /**
   * **Fallback algorithm**
   *
   * We have two things we can do to keep something visible:
   *
   * 1. _Slide_ along edges
   * 2. _Flip_ to another edge
   *
   * _Centered popover_
   *
   * Desired: Sits in middle of main edge
   *
   * Fallbacks:
   *  1: _Slide_ along main edge on the cross axis
   *  2: _Flip_ on main axis to opposite edge (centered)
   *  3: _Slide_ along opposite edge on the cross axis
   *
   * _Start or end aligned popover_
   *
   * Desired: Sits at start / end of main edge
   *
   * Fallbacks:
   *  1: _Slide_ along main edge on the cross axis
   *  2: _Flip_ on main axis to opposite edge
   *  3: _Flip_ on the diagonal (flip main axis + flip cross axis) into the
   *     opposite corner. For start / end alignment, this is the clean escape
   *     when the popover would otherwise land offscreen on both axes (ie in a
   *     corner). Rule 4 gets the job done, but a slide drops the gap
   *     as named position-area values don't carry margins).
   *     The diagonal flip keeps the gap and the alignment.
   *  4: _Slide_ along opposite edge on the cross axis
   */ return [
        $51b15966fa8d11ed$var$slideOnEdge({
            align: align,
            edgeKey: sameEdgeArea,
            crossAxis: crossAxis
        }),
        flipOnMainAxis,
        align !== 'center' ? $51b15966fa8d11ed$var$flipDiagonally({
            axis: axis
        }) : null,
        $51b15966fa8d11ed$var$slideOnEdge({
            align: align,
            edgeKey: oppositeEdgeArea,
            crossAxis: crossAxis
        })
    ].filter(Boolean).flat().join(', ');
}


var $901ca64e7f8a2cb8$var$elementCaches = new WeakMap();
function $901ca64e7f8a2cb8$var$canCacheResolvedLength(value) {
    // Custom-property values can be retargeted by inline overrides on the
    // consumer's wrapper, so we cannot prove a cached pixel value is still valid.
    return !value.includes('var(');
}
function $901ca64e7f8a2cb8$var$getCachedResolvedLength(_ref) {
    var _cacheForElement$get;
    var element = _ref.element, value = _ref.value;
    if (!$901ca64e7f8a2cb8$var$canCacheResolvedLength(value)) return null;
    var cacheForElement = $901ca64e7f8a2cb8$var$elementCaches.get(element);
    return (_cacheForElement$get = cacheForElement === null || cacheForElement === void 0 ? void 0 : cacheForElement.get(value)) !== null && _cacheForElement$get !== void 0 ? _cacheForElement$get : null;
}
function $901ca64e7f8a2cb8$var$cacheResolvedLength(_ref2) {
    var _elementCaches$get;
    var element = _ref2.element, value = _ref2.value, result = _ref2.result;
    if (!$901ca64e7f8a2cb8$var$canCacheResolvedLength(value)) return;
    var cacheForElement = (_elementCaches$get = $901ca64e7f8a2cb8$var$elementCaches.get(element)) !== null && _elementCaches$get !== void 0 ? _elementCaches$get : new Map();
    cacheForElement.set(value, result);
    $901ca64e7f8a2cb8$var$elementCaches.set(element, cacheForElement);
}
function $901ca64e7f8a2cb8$export$98721546d2816d9e(_ref3) {
    var value = _ref3.value, container = _ref3.container;
    if (typeof value === 'number') return value;
    // Fast path: unitless zero is universally zero pixels - accept `'0'` and
    // `'-0'` without a probe. (Consumers occasionally pass `'0'` instead of
    // the number `0`.)
    if (value === '0' || value === '-0') return 0;
    // Fast path: bare `${n}px` strings come from the consumer normalisation
    // in `resolvePlacement`. Avoid a reflow when we can.
    var pxMatch = value.match(/^(-?\d+(?:\.\d+)?)px$/);
    if (pxMatch) return Number(pxMatch[1]);
    var cached = $901ca64e7f8a2cb8$var$getCachedResolvedLength({
        element: container,
        value: value
    });
    if (cached !== null) return cached;
    var probe = container.ownerDocument.createElement('div');
    probe.style.position = 'absolute';
    probe.style.visibility = 'hidden';
    probe.style.pointerEvents = 'none';
    probe.style.height = '0';
    probe.style.padding = '0';
    probe.style.border = '0';
    // `width` clamps negatives to 0; use `margin-left` instead so signs are
    // preserved. `getComputedStyle` returns the resolved pixel value for
    // margin-* properties even when the source was a token / calc / var.
    probe.style.marginLeft = value;
    // Hide the probe from assistive tech and event targeting; defensive
    // against `getElementsByTagName('div')` walks in consumer code.
    probe.setAttribute('aria-hidden', 'true');
    probe.setAttribute('inert', '');
    container.appendChild(probe);
    var resolved = parseFloat(getComputedStyle(probe).marginLeft);
    container.removeChild(probe);
    var result = Number.isFinite(resolved) ? resolved : 0;
    $901ca64e7f8a2cb8$var$cacheResolvedLength({
        element: container,
        value: value,
        result: result
    });
    return result;
}



/**
 * A single inline style declaration.
 *
 * `TProperty` narrows the property name for callers that write a known, closed
 * set of properties. Narrowing it lets a record keyed on those same names be
 * checked for exhaustiveness at compile time, rather than silently resolving to
 * `undefined` for a name that was never mapped.
 */ /**
 * Sets inline styles on an element and returns a cleanup function that
 * restores the prior inline values (so we do not stomp consumer styles).
 */ function $6963e0745334af6c$export$37a5fde709c1db82(_ref) {
    var element = _ref.element, styles = _ref.styles;
    // Snapshot the prior inline value (NOT the computed style - we only want
    // to restore values that the consumer/our previous run inlined). An empty
    // string means "no inline value", in which case cleanup uses removeProperty.
    var priorValues = styles.map(function(_ref2) {
        var property = _ref2.property;
        return {
            property: property,
            value: element.style.getPropertyValue(property)
        };
    });
    styles.forEach(function(_ref3) {
        var property = _ref3.property, value = _ref3.value;
        element.style.setProperty(property, value);
    });
    return function cleanup() {
        priorValues.forEach(function(_ref4) {
            var property = _ref4.property, value = _ref4.value;
            if (value === '') {
                element.style.removeProperty(property);
                return;
            }
            element.style.setProperty(property, value);
        });
    };
}


// `resolvePlacement` is intentionally NOT re-exported here - import it directly
// from `./resolve-placement` so search-and-jump lands at the source of truth.
/**
 * Module-scope no-op `ResizeObserver` used in non-DOM jest environments where
 * `ResizeObserver` is `undefined`. Hoisted out of the effect to avoid
 * allocating a new class declaration on every run.
 */ var $aee8634b6a183a39$var$NoopResizeObserver = /*#__PURE__*/ function() {
    function NoopResizeObserver() {
        (0, $92808d2bde132087$export$2e2bcd8739ae039)(this, NoopResizeObserver);
    }
    return (0, $6c5779c47b0ee166$export$2e2bcd8739ae039)(NoopResizeObserver, [
        {
            key: "observe",
            value: function observe() {}
        },
        {
            key: "unobserve",
            value: function unobserve() {}
        },
        {
            key: "disconnect",
            value: function disconnect() {}
        }
    ]);
}();
/**
 * Returns true when the popover is currently open. Wrapped because the
 * `:popover-open` pseudo-class is not implemented in some test environments
 * (e.g. jsdom), where `matches` throws on unknown selectors.
 */ function $aee8634b6a183a39$var$isPopoverOpen(popover) {
    try {
        return popover.matches(':popover-open');
    } catch (_unused) {
        return false;
    }
}
/**
 * Detects whether the browser supports CSS Anchor Positioning.
 * Uses `once()` for lazy evaluation: safe for SSR and avoids hydration mismatches.
 */ var $aee8634b6a183a39$var$supportsAnchorPositioning = (0, $86089df3a0fd54eb$export$2e2bcd8739ae039)(function() {
    if (typeof window === 'undefined' || typeof CSS === 'undefined' || typeof CSS.supports !== 'function') return false;
    return CSS.supports('anchor-name', '--a');
});
/**
 * Every logical margin property this module can write: one per axis, per side.
 *
 * Deriving the union from `TPlacementAxis` and `TPlacementEdge` rather than
 * writing the four names out keeps it in step with the placement model, and
 * makes `CROSS_AXIS_SHIFT_CUSTOM_PROPERTY` below exhaustive by construction.
 */ /**
 * The custom property mirroring each cross-axis shift margin.
 *
 * These are written for the planned named arrow `@position-try` rules. Nothing
 * reads them yet, and the shift no longer depends on them: the antisymmetric
 * margins written by `crossAxisShiftMargins` survive a cross-axis slide on
 * their own.
 *
 * Keyed on `TLogicalMarginProperty` and not on `string`, so a margin property
 * that has no custom property (or a custom property whose margin no longer
 * exists) is a compile error rather than an `undefined` lookup that reaches
 * `setStyle` as `{ property: undefined, value }`.
 */ var $aee8634b6a183a39$var$CROSS_AXIS_SHIFT_CUSTOM_PROPERTY = {
    'margin-inline-start': '--ds-cross-axis-shift-margin-start',
    'margin-inline-end': '--ds-cross-axis-shift-margin-end',
    'margin-block-start': '--ds-cross-axis-shift-margin-block-start',
    'margin-block-end': '--ds-cross-axis-shift-margin-block-end'
};
var $aee8634b6a183a39$var$ZEROED_CROSS_AXIS_SHIFT_CUSTOM_PROPERTIES = Object.values($aee8634b6a183a39$var$CROSS_AXIS_SHIFT_CUSTOM_PROPERTY).map(function(property) {
    return {
        property: property,
        value: '0px'
    };
});
/**
 * Returns the CSS margin declaration that creates a gap between the
 * popover and its trigger on the side facing the anchor.
 *
 * For example, a `block-end` placement (popover below) gets
 * `margin-block-start: 8px` to push it away from the trigger's bottom edge.
 */ function $aee8634b6a183a39$var$edgeMargin(_ref) {
    var placement = _ref.placement, offset = _ref.offset;
    var axis = placement.axis, edge = placement.edge;
    // The gap sits on the side FACING the anchor, which is always the side
    // opposite the placement edge.
    var anchorFacingEdge = edge === 'end' ? 'start' : 'end';
    return {
        property: "margin-".concat(axis, "-").concat(anchorFacingEdge),
        value: offset
    };
}
/**
 * **The cross-axis shift margins.**
 *
 * The shift is written antisymmetrically on BOTH cross-axis sides
 * (`start: +value`, `end: -value`) rather than as a single margin on the side
 * picked from `align`. Two separate behaviours require it:
 *
 * 1. **`align: 'center'` is centered with `anchor-center`, which centers the
 *    popover's MARGIN box on the anchor.** A single-sided margin widens the
 *    margin box, so it displaces the border box by only half its value. An
 *    antisymmetric pair leaves the margin box width unchanged (`+value` and
 *    `-value` sum to zero) while moving its center by the full value.
 * 2. **`position-try-fallbacks` can slide the popover onto the opposite
 *    cross-axis side.** A `<position-area>` fallback keeps the base style's
 *    margins, and margin on the un-anchored side has no effect, so a
 *    single-sided margin is silently dropped once the browser slides across the
 *    cross axis. With both sides written, whichever side ends up anchored moves
 *    the popover the same physical direction.
 *
 * Leaving the margin box width unchanged also means the shift does not move
 * the point at which `position-try-fallbacks` decides the popover overflows.
 *
 * A `<try-tactic>` fallback (`flip-block`, `flip-inline`) behaves differently to
 * a `<position-area>` one: it SWAPS the start and end margins rather than
 * keeping them, which is what preserves the gap through a flip. So a flip across
 * the cross axis mirrors the shift along with the rest of the placement, rather
 * than preserving its physical direction. Only the diagonal fallback does that,
 * and only for `align: 'start' | 'end'`. See `placementToTryFallbacks`.
 *
 * A positive value always moves the popover toward the cross-axis END, so
 * `direction: 'forwards'` means the same thing for every `align` value. See
 * `notes/decisions/placement-offset.md`.
 */ function $aee8634b6a183a39$var$crossAxisShiftMargins(_ref2) {
    var placement = _ref2.placement, crossAxisShiftCssValue = _ref2.crossAxisShiftCssValue, direction = _ref2.direction;
    var crossAxis = placement.axis === 'block' ? 'inline' : 'block';
    // Wrap any string in calc() with the sign factor. CSS handles the math,
    // so opaque values such as design tokens negate correctly.
    var negated = "calc(-1 * ".concat(crossAxisShiftCssValue, ")");
    var isForwards = direction === 'forwards';
    return [
        {
            property: "margin-".concat(crossAxis, "-start"),
            value: isForwards ? crossAxisShiftCssValue : negated
        },
        {
            property: "margin-".concat(crossAxis, "-end"),
            value: isForwards ? negated : crossAxisShiftCssValue
        }
    ];
}
/**
 * Returns a referentially-stable, fully-resolved `TPlacement`. The memo is
 * keyed on the resolved primitive fields so a fresh inline `placement` object
 * (or undefined fields vs explicit defaults) does not produce a fresh result.
 */ function $aee8634b6a183a39$var$useStablePlacement(placement) {
    var resolved = (0, $4d4da76463e3fc46$export$63044d21bc3d3fa2)({
        placement: placement
    });
    var axis = resolved.axis;
    var edge = resolved.edge;
    var align = resolved.align;
    var gap = resolved.offset.gap;
    var shiftValue = resolved.offset.crossAxisShift.value;
    var shiftDirection = resolved.offset.crossAxisShift.direction;
    // Rebuild inside the memo from primitive deps so the factory does not
    // close over the outer `resolved` reference and exhaustive-deps can verify.
    return (0, $5FkrB.useMemo)(function() {
        return {
            axis: axis,
            edge: edge,
            align: align,
            offset: {
                gap: gap,
                crossAxisShift: {
                    value: shiftValue,
                    direction: shiftDirection
                }
            }
        };
    }, [
        axis,
        edge,
        align,
        gap,
        shiftValue,
        shiftDirection
    ]);
}
function $aee8634b6a183a39$export$56b02a1e583f953c(_ref3) {
    var anchorRef = _ref3.anchorRef, popoverRef = _ref3.popoverRef, _ref3$placement = _ref3.placement, placement = _ref3$placement === void 0 ? {} : _ref3$placement, _ref3$forceFallbackPo = _ref3.forceFallbackPositioning, forceFallbackPositioning = _ref3$forceFallbackPo === void 0 ? false : _ref3$forceFallbackPo, _ref3$isEnabled = _ref3.isEnabled, isEnabled = _ref3$isEnabled === void 0 ? true : _ref3$isEnabled, isOpen = _ref3.isOpen;
    var id = (0, $5FkrB.useId)();
    var stablePlacement = $aee8634b6a183a39$var$useStablePlacement(placement);
    (0, $5FkrB.useLayoutEffect)(function() {
        if (!isEnabled) return;
        var trigger = anchorRef.current;
        var popover = popoverRef.current;
        if (!trigger || !popover) return;
        var gapCssValue = stablePlacement.offset.gap;
        var crossAxisShiftCssValue = stablePlacement.offset.crossAxisShift.value;
        var shouldForceFallback = Boolean(forceFallbackPositioning);
        if ($aee8634b6a183a39$var$supportsAnchorPositioning() && !shouldForceFallback) {
            // Reuse an existing `anchor-name` if the element already has one.
            // Another popover might already be anchored to the old name.
            var anchorName = trigger.style.getPropertyValue('anchor-name') || "--anchor-".concat(id.replace(/:/g, ''));
            var gap = $aee8634b6a183a39$var$edgeMargin({
                placement: stablePlacement,
                offset: gapCssValue
            });
            // Computed once; also mirrored into the
            // `--ds-cross-axis-shift-margin-*` custom properties below.
            var crossAxisShift = $aee8634b6a183a39$var$crossAxisShiftMargins({
                placement: stablePlacement,
                crossAxisShiftCssValue: crossAxisShiftCssValue,
                direction: stablePlacement.offset.crossAxisShift.direction
            });
            var popoverStyles = [
                {
                    property: 'position-anchor',
                    value: anchorName
                },
                {
                    property: 'position-area',
                    value: (0, $5d1f63ff8b0dd0d4$export$de49b61f233ddeb9)({
                        placement: stablePlacement
                    })
                },
                {
                    property: 'position-try-fallbacks',
                    value: (0, $51b15966fa8d11ed$export$c4e16947a95d61f1)({
                        placement: stablePlacement
                    })
                },
                // Reset browser default popover positioning that conflicts
                // with anchor positioning (UA: `inset: 0; margin: auto;`)
                {
                    property: 'margin',
                    value: '0'
                },
                {
                    property: 'inset',
                    value: 'auto'
                },
                gap
            ].concat((0, $6367c63b8ad4bce1$export$2e2bcd8739ae039)(crossAxisShift), (0, $6367c63b8ad4bce1$export$2e2bcd8739ae039)($aee8634b6a183a39$var$ZEROED_CROSS_AXIS_SHIFT_CUSTOM_PROPERTIES), (0, $6367c63b8ad4bce1$export$2e2bcd8739ae039)(crossAxisShift.map(function(_ref4) {
                var property = _ref4.property, value = _ref4.value;
                return {
                    property: $aee8634b6a183a39$var$CROSS_AXIS_SHIFT_CUSTOM_PROPERTY[property],
                    value: value
                };
            })));
            /**
       * **We are never cleaning up anchor names**
       *
       * _Rationale_
       *
       * - Multiple popovers can share the same anchor element.
       * - Sometimes the `useAnchorPosition` hook and `Popover`
       *   are not in the same component.
       * - There can be times when, even with reference counting, we
       *   could remove the anchor-name while it is still being used
       *   by something else - especially with async react updates
       *   which can cause tearing
       *
       * _More_
       *
       * See `notes/decisions/anchor-name-lifetime.md`
       */ trigger.style.setProperty('anchor-name', anchorName);
            return (0, $6963e0745334af6c$export$37a5fde709c1db82)({
                element: popover,
                styles: popoverStyles
            });
        }
        // JS fallback. The popover is already in the top layer via
        // popover="auto", so we only reset UA defaults and set top/left
        // based on measurements.
        var cleanupBaseStyles = (0, $6963e0745334af6c$export$37a5fde709c1db82)({
            element: popover,
            styles: [
                {
                    property: 'margin',
                    value: '0'
                },
                {
                    property: 'inset',
                    value: 'auto'
                }
            ]
        });
        // The popover can be consumer-owned (`@atlaskit/popper`'s `createPopper`),
        // so restore prior inline values rather than removing ours.
        var undoPosition;
        var undoHide;
        // `opacity: 0` not `visibility: hidden`: Firefox skips visibility-hidden
        // elements during `<dialog>` initial-focus traversal.
        function hideUntilPositioned() {
            // Keep the first snapshot, else we capture our own `opacity: 0`.
            // (`!popover` is for TS: narrowing does not reach nested functions.)
            if (!popover || undoHide) return;
            undoHide = (0, $6963e0745334af6c$export$37a5fde709c1db82)({
                element: popover,
                styles: [
                    {
                        property: 'opacity',
                        value: '0'
                    }
                ]
            });
        }
        function reveal() {
            var _undoHide;
            (_undoHide = undoHide) === null || _undoHide === void 0 || _undoHide();
            undoHide = undefined;
        }
        function restorePosition() {
            var _undoPosition;
            (_undoPosition = undoPosition) === null || _undoPosition === void 0 || _undoPosition();
            undoPosition = undefined;
        }
        function update() {
            if (!trigger || !popover) return;
            var triggerRect = trigger.getBoundingClientRect();
            var viewport = {
                width: window.innerWidth,
                height: window.innerHeight
            };
            // Resolve consumer-supplied CSS length strings (tokens, calc, var,
            // px, rem, etc) to pixels. The probe is mounted INSIDE the popover
            // itself so the resolved length matches the scope a token would
            // resolve against from inside the popover content. (The popover
            // lives in the top layer, not the trigger's DOM tree, so probing
            // at `popover.parentElement` would resolve in a different scope
            // than the consumer's token authoring expects.)
            var gapPx = (0, $901ca64e7f8a2cb8$export$98721546d2816d9e)({
                value: gapCssValue,
                container: popover
            });
            var crossAxisShiftPx = (0, $901ca64e7f8a2cb8$export$98721546d2816d9e)({
                value: crossAxisShiftCssValue,
                container: popover
            });
            var _computeFallbackPosit = (0, $f22a1d974618ba72$export$d5ef1dac02135664)({
                triggerRect: triggerRect,
                popoverEl: popover,
                placement: stablePlacement,
                viewport: viewport,
                gap: gapPx,
                crossAxisShift: {
                    value: crossAxisShiftPx,
                    direction: stablePlacement.offset.crossAxisShift.direction
                }
            }), top = _computeFallbackPosit.top, left = _computeFallbackPosit.left;
            // Restore first so the snapshot stays the consumer's value.
            restorePosition();
            undoPosition = (0, $6963e0745334af6c$export$37a5fde709c1db82)({
                element: popover,
                styles: [
                    {
                        property: 'top',
                        value: "".concat(top, "px")
                    },
                    {
                        property: 'left',
                        value: "".concat(left, "px")
                    }
                ]
            });
            reveal();
        }
        // Throttle scroll/resize updates to one per animation frame
        var scheduledUpdate = (0, $2fb72d4a32455831$export$2e2bcd8739ae039)(update);
        // Wait for the FIRST valid layout before measuring: the popover
        // is `display: none` until `showPopover()`, and some browsers
        // fire `toggle` before layout, so RAF-after-toggle is unreliable.
        // ResizeObserver fires once the browser has real dimensions.
        // Self-disconnects after one valid measurement; ongoing
        // scroll/resize is handled by the window listeners below.
        // `ResizeObserver` is missing in some non-DOM jest environments
        // (e.g. post-office's `node` environment). Fall back to a no-op
        // observer there. The scroll/resize listeners below still keep
        // the popover positioned in the rare case the consumer also
        // polyfilled `showPopover` but not `ResizeObserver`. Real
        // browsers always have it. The `NoopResizeObserver` class is
        // hoisted to module scope (see top of file) so we do not allocate
        // a new constructor on every effect run.
        var ResizeObserverImpl = typeof ResizeObserver !== 'undefined' ? ResizeObserver : $aee8634b6a183a39$var$NoopResizeObserver;
        var resizeObserver = new ResizeObserverImpl(function() {
            if (popover.offsetWidth > 0 && popover.offsetHeight > 0) {
                update();
                resizeObserver.disconnect();
            }
        });
        // If the popover is already open by the time this effect runs (for
        // example, the parent `useAnchorPosition` effect runs after the child
        // `Popover` effect that called `showPopover()`), the initial `toggle`
        // event has already fired and our listener below would miss it. Start
        // observing immediately so the first measurement still happens.
        if ($aee8634b6a183a39$var$isPopoverOpen(popover)) {
            hideUntilPositioned();
            resizeObserver.observe(popover);
        }
        var undoPositioning = (0, $4090ff1f05bf2704$export$1be1fc439b849fdf)(cleanupBaseStyles, // Each open needs a fresh measurement, so hide and re-observe.
        (0, $5b617c1f48263075$exports.bind)(popover, {
            type: 'toggle',
            listener: function listener(event) {
                var toggleEvent = event;
                if (toggleEvent.newState === 'open') {
                    hideUntilPositioned();
                    resizeObserver.observe(popover);
                }
            }
        }), function() {
            return resizeObserver.disconnect();
        }, (0, $5b617c1f48263075$exports.bind)(window, {
            type: 'scroll',
            listener: scheduledUpdate,
            options: {
                capture: true,
                passive: true
            }
        }), (0, $5b617c1f48263075$exports.bind)(window, {
            type: 'resize',
            listener: scheduledUpdate,
            options: {
                passive: true
            }
        }), function() {
            scheduledUpdate.cancel();
            restorePosition();
            reveal();
        });
        return undoPositioning;
    }, [
        anchorRef,
        popoverRef,
        stablePlacement,
        forceFallbackPositioning,
        isEnabled,
        id,
        isOpen
    ]);
}



function $0530123d1fc06a55$export$9198c6c168be2eeb() {
    // `@atlaskit/ds-lib/use-id` already strips characters that React's
    // `useId` produces (`:`, `«`, `»`) which are invalid in HTML ID
    // tokens. The `popover-` prefix is purely for DOM debug clarity.
    return "popover-".concat((0, $c797bf80d6171378$export$f680877a34711e37)());
}



var $5FkrB = parcelRequire("5FkrB");


/**
 * Probes anchor SIZING, separately from `anchor-name` (see
 * `supportsAnchorPositioning`): some browsers have positioning but not sizing.
 * `once()` for SSR safety.
 */ var $d0ce4db71890d641$var$supportsAnchorSize = (0, $86089df3a0fd54eb$export$2e2bcd8739ae039)(function() {
    if (typeof window === 'undefined' || typeof CSS === 'undefined' || typeof CSS.supports !== 'function') return false;
    return CSS.supports('min-inline-size', 'anchor-size(self-inline)');
});
/**
 * The JS fallback's stand-in for `anchor-size(self-inline)`. `offsetWidth` / `offsetHeight` are
 * physical, so the axis is picked from the popover's `writing-mode`. Anything not horizontal is
 * treated as vertical, and an unknown or empty value falls back to `offsetWidth`.
 */ function $d0ce4db71890d641$var$getFallbackAnchorInlineSize(_ref) {
    var anchor = _ref.anchor, popover = _ref.popover;
    // `String()` because not every test environment implements `writing-mode`.
    var writingMode = String(getComputedStyle(popover).writingMode);
    var isVertical = writingMode.startsWith('vertical') || writingMode.startsWith('sideways');
    return isVertical ? anchor.offsetHeight : anchor.offsetWidth;
}
function $d0ce4db71890d641$export$7071d791a7b131ed(_ref2) {
    var mode = _ref2.mode, popoverRef = _ref2.popoverRef, anchorRef = _ref2.anchorRef, isOpen = _ref2.isOpen;
    (0, $5FkrB.useLayoutEffect)(function() {
        var node = popoverRef.current;
        if (!node) return;
        if (mode === 'match-anchor') {
            // No floor here: it would let the popover grow past the anchor.
            if ($d0ce4db71890d641$var$supportsAnchorSize()) return (0, $6963e0745334af6c$export$37a5fde709c1db82)({
                element: node,
                styles: [
                    {
                        property: 'inline-size',
                        value: 'anchor-size(self-inline)'
                    }
                ]
            });
            var anchor = anchorRef.current;
            if (anchor) return (0, $6963e0745334af6c$export$37a5fde709c1db82)({
                element: node,
                styles: [
                    {
                        property: 'inline-size',
                        value: "".concat($d0ce4db71890d641$var$getFallbackAnchorInlineSize({
                            anchor: anchor,
                            popover: node
                        }), "px")
                    }
                ]
            });
            return;
        }
        if (mode === 'min-anchor') {
            // One floor only. The content floor from mode 'none' deliberately does not also apply
            // here, and cannot: it would need this same property. See the decision note.
            if ($d0ce4db71890d641$var$supportsAnchorSize()) return (0, $6963e0745334af6c$export$37a5fde709c1db82)({
                element: node,
                styles: [
                    {
                        property: 'min-inline-size',
                        value: 'anchor-size(self-inline)'
                    }
                ]
            });
            var _anchor = anchorRef.current;
            if (_anchor) return (0, $6963e0745334af6c$export$37a5fde709c1db82)({
                element: node,
                styles: [
                    {
                        property: 'min-inline-size',
                        value: "".concat($d0ce4db71890d641$var$getFallbackAnchorInlineSize({
                            anchor: _anchor,
                            popover: node
                        }), "px")
                    }
                ]
            });
            // Nothing to measure, so no floor.
            return;
        }
        // Makes a too-narrow span overflow and drive `position-try-fallbacks` instead of wrapping.
        // `@atlaskit/popper` resets this exact property to `0` for its fit-to-viewport mode.
        return (0, $6963e0745334af6c$export$37a5fde709c1db82)({
            element: node,
            styles: [
                {
                    property: 'min-inline-size',
                    value: 'max-content'
                }
            ]
        });
    }, [
        mode,
        popoverRef,
        anchorRef,
        isOpen
    ]);
}



var $5FkrB = parcelRequire("5FkrB");
function $19260b79c60c8869$export$892580369e97d8b9(_ref) {
    var role = _ref.role, label = _ref.label, titleId = _ref.titleId;
    return (0, $5FkrB.useMemo)(function() {
        if (role === 'dialog' || role === 'alertdialog' || role === 'menu') {
            if (titleId) return {
                role: role,
                labelledBy: titleId
            };
            return {
                role: role,
                label: label !== null && label !== void 0 ? label : 'Popup'
            };
        }
        if (role) return {
            role: role,
            label: label
        };
        // No role supplied: preserve the legacy "no popup semantics" contract.
        return {
            role: undefined,
            label: label
        };
    }, [
        role,
        label,
        titleId
    ]);
}


var $2d7050bf4b301b0f$var$contentOverflowStyles = {
    fitViewport: "_1reo1wug _18m91wug",
    default: ""
};
// Top-layer positioning is handled by CSS Anchor Positioning, not inline styles.
var $2d7050bf4b301b0f$var$EMPTY_STYLE = {};
var $2d7050bf4b301b0f$export$e24b8cb659609dee = /*#__PURE__*/ (0, $5FkrB.memo)(function PopupTopLayer(_ref) {
    var _roleProps$role;
    var xcss = _ref.xcss, isOpen = _ref.isOpen, providedId = _ref.id, offsetProp = _ref.offset, testId = _ref.testId, trigger = _ref.trigger, content = _ref.content, _ref$onClose = _ref.onClose, onClose = _ref$onClose === void 0 ? (0, $adcefb868cf2fc9d$export$2e2bcd8739ae039) : _ref$onClose, _ref$placement = _ref.placement, placement = _ref$placement === void 0 ? 'auto' : _ref$placement, _fallbackPlacements = _ref.fallbackPlacements, _ref$shouldFlip = _ref.shouldFlip, _shouldFlip = _ref$shouldFlip === void 0 ? true : _ref$shouldFlip, PopupContainer = _ref.popupComponent, _ref$autoFocus = _ref.autoFocus, autoFocus = _ref$autoFocus === void 0 ? true : _ref$autoFocus, _ref$shouldFitContain = _ref.shouldFitContainer, shouldFitContainer = _ref$shouldFitContain === void 0 ? false : _ref$shouldFitContain, _ref$shouldReturnFocu = _ref.shouldReturnFocus, _shouldReturnFocus = _ref$shouldReturnFocu === void 0 ? true : _ref$shouldReturnFocu, role = _ref.role, label = _ref.label, titleId = _ref.titleId, _zIndex = _ref.zIndex, _shouldRenderToParent = _ref.shouldRenderToParent, _strategy = _ref.strategy, _modifiers = _ref.modifiers, _boundary = _ref.boundary, _rootBoundary = _ref.rootBoundary, _shouldUseCaptureOnOutsideClick = _ref.shouldUseCaptureOnOutsideClick, _shouldDisableFocusLock = _ref.shouldDisableFocusLock, shouldFitViewport = _ref.shouldFitViewport, _appearance = _ref.appearance;
    var triggerRef = (0, $5FkrB.useRef)(null);
    var popoverRef = (0, $5FkrB.useRef)(null);
    /**
   * Escape hatch for consumer-chosen initial focus target.
   *
   * The legacy `Popup` surfaced `setInitialFocusRef` on the content
   * render prop with a `Dispatch<SetStateAction<HTMLElement | null>>`
   * signature so it could be passed as a React `ref` callback. We
   * keep the same shape for API compatibility, but store the value in
   * a ref rather than component state. Flipping state on every open
   * caused a needless re-render and, more importantly, raced the
   * initial-focus effect below. The ref is read in the open-side
   * effect to override the role-based default focus chosen by
   * `useInitialFocus` inside the underlying `Popover`.
   */ var consumerInitialFocusRef = (0, $5FkrB.useRef)(null);
    var setInitialFocusRef = (0, $5FkrB.useCallback)(function(value) {
        consumerInitialFocusRef.current = typeof value === 'function' ? value(consumerInitialFocusRef.current) : value;
    }, []);
    /**
   * Override the role-based initial focus chosen by the underlying
   * `Popover` (its internal `useInitialFocus`).
   *
   * React flushes child effects before parent effects, so by the time
   * this effect runs the role-based default focus has already moved.
   * We then apply the legacy `Popup` contract:
   *
   * 1. If the consumer wired `setInitialFocusRef`, focus that element
   *    (escape hatch wins).
   * 2. Otherwise, if `autoFocus={false}`, return focus to the trigger.
   *    The `autoFocus` prop on `Popup` opts out of any initial-focus
   *    movement, even for roles like `dialog`.
   *
   * When neither applies the role-based default from the underlying
   * `Popover` stays in place.
   */ (0, $5FkrB.useEffect)(function() {
        if (!isOpen) {
            /**
       * Clear the consumer-supplied focus target on close so a
       * subsequent open does not silently inherit a stale ref from
       * the previous open cycle. The next open will re-collect a
       * target only if the content render prop re-wires
       * `setInitialFocusRef`.
       */ consumerInitialFocusRef.current = null;
            return;
        }
        var consumerTarget = consumerInitialFocusRef.current;
        if (consumerTarget && consumerTarget.isConnected) {
            consumerTarget.focus();
            return;
        }
        if (!autoFocus) {
            var _trigger = triggerRef.current;
            if (_trigger && _trigger.isConnected) _trigger.focus();
        }
    }, [
        isOpen,
        autoFocus
    ]);
    var popoverId = (0, $0530123d1fc06a55$export$9198c6c168be2eeb)();
    // Placement conversion.
    // Legacy `offset` is the popper `[along, away]` tuple; `fromLegacyPlacement`
    // folds it into the new `placement.offset` shape so it travels with placement.
    var topLayerPlacement = (0, $5FkrB.useMemo)(function() {
        return (0, $88557954ddf59374$export$69e99ed50b2534c9)({
            legacy: placement,
            offset: offsetProp
        });
    }, [
        placement,
        offsetProp
    ]);
    (0, $aee8634b6a183a39$export$56b02a1e583f953c)({
        anchorRef: triggerRef,
        popoverRef: popoverRef,
        placement: topLayerPlacement,
        isOpen: isOpen
    });
    (0, $d0ce4db71890d641$export$7071d791a7b131ed)({
        mode: shouldFitContainer ? 'match-anchor' : 'none',
        popoverRef: popoverRef,
        anchorRef: triggerRef,
        isOpen: isOpen
    });
    // onClose bridge.
    // Translates top-layer's { reason: TPopoverCloseReason } into legacy
    // onClose(event, currentLevel?) by synthesizing DOM events.
    //
    // Focus restoration is handled natively by the Popover API:
    //   - Escape: browser restores focus to the trigger automatically
    //   - Click-outside: browser does NOT restore (correct behavior)
    // No manual triggerRef.current?.focus() is needed.
    var handleOnClose = (0, $5FkrB.useCallback)(function(_ref2) {
        var reason = _ref2.reason;
        onClose((0, $5e93135852b41f01$export$27b4de066896ac63)({
            reason: reason
        }));
    }, [
        onClose
    ]);
    // Content render-prop bridge.
    // Legacy content() receives { isOpen, update, setInitialFocusRef, onClose }.
    // update is a no-op because CSS Anchor Positioning self-updates.
    var contentProps = (0, $5FkrB.useMemo)(function() {
        return {
            isOpen: isOpen,
            update: (0, $adcefb868cf2fc9d$export$2e2bcd8739ae039),
            onClose: onClose,
            setInitialFocusRef: setInitialFocusRef
        };
    }, [
        isOpen,
        onClose,
        setInitialFocusRef
    ]);
    // Role mapping.
    // Build the role/label props for Popover.
    // Roles requiring accessible names must have label or labelledBy.
    var roleProps = (0, $19260b79c60c8869$export$892580369e97d8b9)({
        role: role,
        label: label,
        titleId: titleId
    });
    var resolvedPopoverId = providedId !== null && providedId !== void 0 ? providedId : popoverId;
    var ariaAttributes = (0, $035780a5f3bca592$export$9dd1d61dd4d4755)({
        role: (_roleProps$role = roleProps.role) !== null && _roleProps$role !== void 0 ? _roleProps$role : 'dialog',
        isOpen: isOpen,
        popoverId: resolvedPopoverId
    });
    // Narrow to ForwardRefExoticComponent so JSX accepts the ref prop.
    // All popupComponent implementations use forwardRef per the PopupComponentProps contract.
    var Container = PopupContainer;
    // Map to legacy TriggerProps.
    var triggerProps = {
        ref: function ref(node) {
            triggerRef.current = node;
        },
        'aria-controls': ariaAttributes['aria-controls'],
        // `aria-expanded` reflects current open state.
        'aria-expanded': ariaAttributes['aria-expanded'],
        // FUDGE(top-layer-api): cast to the narrow public TriggerProps['aria-haspopup'] union.
        // `getAriaForTrigger` derives `aria-haspopup` from the content's role and types it
        // as the wider WAI-ARIA union (boolean | 'dialog' | 'menu' | 'listbox' | 'tree' | 'grid').
        // We keep the public popup TriggerProps narrow (boolean | 'dialog') because the
        // top-layer API surface is not yet settled. Widening adopter types now would commit
        // us to a public surface we may revisit. The runtime value is unchanged; only the
        // TypeScript-visible type is narrowed at this boundary.
        'aria-haspopup': ariaAttributes['aria-haspopup']
    };
    return /*#__PURE__*/ $5FkrB.createElement((0, $5FkrB.Fragment), null, trigger(triggerProps), /*#__PURE__*/ $5FkrB.createElement((0, $051a9d50aec333c1$export$5b6b19405a83ff9d), (0, $7b6033835882f9ff$export$2e2bcd8739ae039)({
        ref: popoverRef,
        id: resolvedPopoverId
    }, roleProps, {
        isOpen: isOpen,
        onClose: handleOnClose,
        shouldAnimate: true,
        placement: topLayerPlacement,
        testId: testId && "".concat(testId, "--content")
    }), Container ? /*#__PURE__*/ $5FkrB.createElement(Container, {
        style: $2d7050bf4b301b0f$var$EMPTY_STYLE,
        id: providedId,
        "data-placement": placement,
        "data-testid": testId,
        tabIndex: autoFocus ? -1 : undefined,
        xcss: xcss
    }, content(contentProps)) : /*#__PURE__*/ $5FkrB.createElement((0, $90e6fd4ff800cdc4$export$8b7437164e479115), null, /*#__PURE__*/ $5FkrB.createElement("div", {
        className: (0, $dbf53395d39974cf$export$2e2bcd8739ae039)([
            $2d7050bf4b301b0f$var$contentOverflowStyles[shouldFitViewport ? 'fitViewport' : 'default']
        ])
    }, content(contentProps)))));
});




var $5FkrB = parcelRequire("5FkrB");

var $5FkrB = parcelRequire("5FkrB");

/**
 * This is an object of usable media query helpers using our internal breakpoints configuration.
 *
 * When using Compiled CSS-in-JS, please ensure that only a single declaration can take effect at a time.
 * This means that you should avoid multiple breakpoints taking effect at the same time,
 * eg. ```{ [media.above.xs]: { color: 'red' }, [media.above.sm]: { color: 'green' }}```.
 * Instead, make sure that only one breakpoint can take effect at a time,
 * e.g, ```{ [media.only.xs]: { color: 'red' }, [media.above.sm]: { color: 'green' }}```.
 * For more details, please see <https://compiledcssinjs.com/docs/atomic-css#selector-specificity>.
 */ var $2ec84d2d4928089d$export$987d49ffe1b0900f = {
    above: {
        // TODO: Should this even exist, we don't want `css({ [media.above.xxs]: { … } })` because that just adds duplicates styles!
        xxs: '@media all',
        xs: '@media (min-width: 30rem)',
        sm: '@media (min-width: 48rem)',
        md: '@media (min-width: 64rem)',
        lg: '@media (min-width: 90rem)',
        xl: '@media (min-width: 110.5rem)'
    },
    only: {
        xxs: '@media (min-width: 0rem) and (max-width: 29.99rem)',
        xs: '@media (min-width: 30rem) and (max-width: 47.99rem)',
        sm: '@media (min-width: 48rem) and (max-width: 63.99rem)',
        md: '@media (min-width: 64rem) and (max-width: 89.99rem)',
        lg: '@media (min-width: 90rem) and (max-width: 110.49rem)',
        xl: '@media (min-width: 110.5rem)'
    },
    below: {
        xs: '@media not all and (min-width: 30rem)',
        sm: '@media not all and (min-width: 48rem)',
        md: '@media not all and (min-width: 64rem)',
        lg: '@media not all and (min-width: 90rem)',
        xl: '@media not all and (min-width: 110.5rem)'
    }
};


var $6f4f8ac5b81b352b$var$_window, $6f4f8ac5b81b352b$var$_window$matchMedia, $6f4f8ac5b81b352b$var$_window2, $6f4f8ac5b81b352b$var$_window2$matchMedia, $6f4f8ac5b81b352b$var$_window3, $6f4f8ac5b81b352b$var$_window3$matchMedia, $6f4f8ac5b81b352b$var$_window4, $6f4f8ac5b81b352b$var$_window4$matchMedia, $6f4f8ac5b81b352b$var$_window5, $6f4f8ac5b81b352b$var$_window5$matchMedia, $6f4f8ac5b81b352b$var$_window6, $6f4f8ac5b81b352b$var$_window6$matchMedia, $6f4f8ac5b81b352b$var$_window7, $6f4f8ac5b81b352b$var$_window7$matchMedia, $6f4f8ac5b81b352b$var$_window8, $6f4f8ac5b81b352b$var$_window8$matchMedia, $6f4f8ac5b81b352b$var$_window9, $6f4f8ac5b81b352b$var$_window9$matchMedia, $6f4f8ac5b81b352b$var$_window0, $6f4f8ac5b81b352b$var$_window0$matchMedia, $6f4f8ac5b81b352b$var$_window1, $6f4f8ac5b81b352b$var$_window1$matchMedia;
var $6f4f8ac5b81b352b$var$queries = {
    'above.xxs': typeof window === 'undefined' ? undefined : ($6f4f8ac5b81b352b$var$_window = window) === null || $6f4f8ac5b81b352b$var$_window === void 0 || ($6f4f8ac5b81b352b$var$_window$matchMedia = $6f4f8ac5b81b352b$var$_window.matchMedia) === null || $6f4f8ac5b81b352b$var$_window$matchMedia === void 0 ? void 0 : $6f4f8ac5b81b352b$var$_window$matchMedia.call($6f4f8ac5b81b352b$var$_window, (0, $2ec84d2d4928089d$export$987d49ffe1b0900f).above.xxs.replace('@media ', '').trim()),
    'above.xs': typeof window === 'undefined' ? undefined : ($6f4f8ac5b81b352b$var$_window2 = window) === null || $6f4f8ac5b81b352b$var$_window2 === void 0 || ($6f4f8ac5b81b352b$var$_window2$matchMedia = $6f4f8ac5b81b352b$var$_window2.matchMedia) === null || $6f4f8ac5b81b352b$var$_window2$matchMedia === void 0 ? void 0 : $6f4f8ac5b81b352b$var$_window2$matchMedia.call($6f4f8ac5b81b352b$var$_window2, (0, $2ec84d2d4928089d$export$987d49ffe1b0900f).above.xs.replace('@media ', '').trim()),
    'above.sm': typeof window === 'undefined' ? undefined : ($6f4f8ac5b81b352b$var$_window3 = window) === null || $6f4f8ac5b81b352b$var$_window3 === void 0 || ($6f4f8ac5b81b352b$var$_window3$matchMedia = $6f4f8ac5b81b352b$var$_window3.matchMedia) === null || $6f4f8ac5b81b352b$var$_window3$matchMedia === void 0 ? void 0 : $6f4f8ac5b81b352b$var$_window3$matchMedia.call($6f4f8ac5b81b352b$var$_window3, (0, $2ec84d2d4928089d$export$987d49ffe1b0900f).above.sm.replace('@media ', '').trim()),
    'above.md': typeof window === 'undefined' ? undefined : ($6f4f8ac5b81b352b$var$_window4 = window) === null || $6f4f8ac5b81b352b$var$_window4 === void 0 || ($6f4f8ac5b81b352b$var$_window4$matchMedia = $6f4f8ac5b81b352b$var$_window4.matchMedia) === null || $6f4f8ac5b81b352b$var$_window4$matchMedia === void 0 ? void 0 : $6f4f8ac5b81b352b$var$_window4$matchMedia.call($6f4f8ac5b81b352b$var$_window4, (0, $2ec84d2d4928089d$export$987d49ffe1b0900f).above.md.replace('@media ', '').trim()),
    'above.lg': typeof window === 'undefined' ? undefined : ($6f4f8ac5b81b352b$var$_window5 = window) === null || $6f4f8ac5b81b352b$var$_window5 === void 0 || ($6f4f8ac5b81b352b$var$_window5$matchMedia = $6f4f8ac5b81b352b$var$_window5.matchMedia) === null || $6f4f8ac5b81b352b$var$_window5$matchMedia === void 0 ? void 0 : $6f4f8ac5b81b352b$var$_window5$matchMedia.call($6f4f8ac5b81b352b$var$_window5, (0, $2ec84d2d4928089d$export$987d49ffe1b0900f).above.lg.replace('@media ', '').trim()),
    'above.xl': typeof window === 'undefined' ? undefined : ($6f4f8ac5b81b352b$var$_window6 = window) === null || $6f4f8ac5b81b352b$var$_window6 === void 0 || ($6f4f8ac5b81b352b$var$_window6$matchMedia = $6f4f8ac5b81b352b$var$_window6.matchMedia) === null || $6f4f8ac5b81b352b$var$_window6$matchMedia === void 0 ? void 0 : $6f4f8ac5b81b352b$var$_window6$matchMedia.call($6f4f8ac5b81b352b$var$_window6, (0, $2ec84d2d4928089d$export$987d49ffe1b0900f).above.xl.replace('@media ', '').trim()),
    'below.xs': typeof window === 'undefined' ? undefined : ($6f4f8ac5b81b352b$var$_window7 = window) === null || $6f4f8ac5b81b352b$var$_window7 === void 0 || ($6f4f8ac5b81b352b$var$_window7$matchMedia = $6f4f8ac5b81b352b$var$_window7.matchMedia) === null || $6f4f8ac5b81b352b$var$_window7$matchMedia === void 0 ? void 0 : $6f4f8ac5b81b352b$var$_window7$matchMedia.call($6f4f8ac5b81b352b$var$_window7, (0, $2ec84d2d4928089d$export$987d49ffe1b0900f).below.xs.replace('@media ', '').trim()),
    'below.sm': typeof window === 'undefined' ? undefined : ($6f4f8ac5b81b352b$var$_window8 = window) === null || $6f4f8ac5b81b352b$var$_window8 === void 0 || ($6f4f8ac5b81b352b$var$_window8$matchMedia = $6f4f8ac5b81b352b$var$_window8.matchMedia) === null || $6f4f8ac5b81b352b$var$_window8$matchMedia === void 0 ? void 0 : $6f4f8ac5b81b352b$var$_window8$matchMedia.call($6f4f8ac5b81b352b$var$_window8, (0, $2ec84d2d4928089d$export$987d49ffe1b0900f).below.sm.replace('@media ', '').trim()),
    'below.md': typeof window === 'undefined' ? undefined : ($6f4f8ac5b81b352b$var$_window9 = window) === null || $6f4f8ac5b81b352b$var$_window9 === void 0 || ($6f4f8ac5b81b352b$var$_window9$matchMedia = $6f4f8ac5b81b352b$var$_window9.matchMedia) === null || $6f4f8ac5b81b352b$var$_window9$matchMedia === void 0 ? void 0 : $6f4f8ac5b81b352b$var$_window9$matchMedia.call($6f4f8ac5b81b352b$var$_window9, (0, $2ec84d2d4928089d$export$987d49ffe1b0900f).below.md.replace('@media ', '').trim()),
    'below.lg': typeof window === 'undefined' ? undefined : ($6f4f8ac5b81b352b$var$_window0 = window) === null || $6f4f8ac5b81b352b$var$_window0 === void 0 || ($6f4f8ac5b81b352b$var$_window0$matchMedia = $6f4f8ac5b81b352b$var$_window0.matchMedia) === null || $6f4f8ac5b81b352b$var$_window0$matchMedia === void 0 ? void 0 : $6f4f8ac5b81b352b$var$_window0$matchMedia.call($6f4f8ac5b81b352b$var$_window0, (0, $2ec84d2d4928089d$export$987d49ffe1b0900f).below.lg.replace('@media ', '').trim()),
    'below.xl': typeof window === 'undefined' ? undefined : ($6f4f8ac5b81b352b$var$_window1 = window) === null || $6f4f8ac5b81b352b$var$_window1 === void 0 || ($6f4f8ac5b81b352b$var$_window1$matchMedia = $6f4f8ac5b81b352b$var$_window1.matchMedia) === null || $6f4f8ac5b81b352b$var$_window1$matchMedia === void 0 ? void 0 : $6f4f8ac5b81b352b$var$_window1$matchMedia.call($6f4f8ac5b81b352b$var$_window1, (0, $2ec84d2d4928089d$export$987d49ffe1b0900f).below.xl.replace('@media ', '').trim())
};
var $6f4f8ac5b81b352b$export$49e55ae2c03d6045 = function UNSAFE_useMediaQuery(queryString, listener) {
    var listenerRef = (0, $5FkrB.useRef)(listener);
    (0, $5FkrB.useEffect)(function() {
        // Bind the listener if changed so it's called on the next change event; no guarantee on timing.
        listenerRef.current = listener;
    }, [
        listener
    ]);
    /**
   * We explicitly only react to boolean changes for binding our listener
   * Changes to the functional reference are ignored.
   */ var hasListener = !!listener;
    /**
   * The `matchMedia(…)` return value for our breakpoint query.
   */ var mq = $6f4f8ac5b81b352b$var$queries[queryString];
    (0, $5FkrB.useLayoutEffect)(function() {
        listenerRef.current = listener; // Bind the listener now in case the `useEffect` hasn't fired above yet
        if (!mq || !hasListener || !listenerRef.current) return;
        return (0, $5b617c1f48263075$exports.bind)(mq, {
            type: 'change',
            listener: function listener(event) {
                // We explicitly call the current version of the function
                return listenerRef.current(event);
            }
        });
    }, // eslint-disable-next-line react-hooks/exhaustive-deps -- explicitly do not trigger the effect on `listener` reference change, only on a boolean representation of it.
    [
        mq,
        hasListener
    ]);
    return mq || null;
};


function $3a721fa318d8ecb3$export$4065aef1d79a5730(_ref) {
    var _appearance = _ref.appearance, _shouldRenderToParent = _ref.shouldRenderToParent;
    var mq = (0, $6f4f8ac5b81b352b$export$49e55ae2c03d6045)('below.sm', function(e) {
        setIsSmallViewport(!!e.matches);
    });
    var _useState = (0, $5FkrB.useState)(!!(mq !== null && mq !== void 0 && mq.matches)), _useState2 = (0, $0b8156ac98850b5f$export$2e2bcd8739ae039)(_useState, 2), isSmallViewport = _useState2[0], setIsSmallViewport = _useState2[1];
    var appearance = _appearance === 'UNSAFE_modal-below-sm' && isSmallViewport ? 'UNSAFE_modal-below-sm' : 'default';
    var shouldRenderToParent = _shouldRenderToParent && appearance === 'default';
    return {
        appearance: appearance,
        shouldRenderToParent: shouldRenderToParent
    };
}




var $5FkrB = parcelRequire("5FkrB");

var $cvlyC = parcelRequire("cvlyC");
var $e56679fddd3bf8a0$export$7cc5c058dd769dff = function useGetMemoizedMergedTriggerRef() {
    var _useState = (0, $5FkrB.useState)(function() {
        return (0, $cvlyC.default)(function(ref, setTriggerRef, isOpen) {
            return function(node) {
                if (node && isOpen) {
                    if (typeof ref === 'function') ref(node);
                    else if (ref) ref.current = node;
                    setTriggerRef(node);
                }
            };
        });
    }), _useState2 = (0, $0b8156ac98850b5f$export$2e2bcd8739ae039)(_useState, 1), getMemoizedMergedTriggerRef = _useState2[0];
    return getMemoizedMergedTriggerRef;
};




var $5FkrB = parcelRequire("5FkrB");

var $cvlyC = parcelRequire("cvlyC");
var $20ff774fe0ee677f$export$5d3a2de79e07b376 = function useGetMemoizedMergedTriggerRefNew() {
    var _useState = (0, $5FkrB.useState)(function() {
        return (0, $cvlyC.default)(function(ref, setTriggerRef) {
            return function(node) {
                if (node) {
                    if (typeof ref === 'function') ref(node);
                    else if (ref) ref.current = node;
                    setTriggerRef(node);
                }
            };
        });
    }), _useState2 = (0, $0b8156ac98850b5f$export$2e2bcd8739ae039)(_useState, 1), getMemoizedMergedTriggerRefNew = _useState2[0];
    return getMemoizedMergedTriggerRefNew;
};


var $a2b7f495199a9de5$var$defaultLayer = 400;
var $a2b7f495199a9de5$var$wrapperStyles = {
    root: "_kqswh2mm"
};
var $a2b7f495199a9de5$var$PopupLegacy = function PopupLegacy(props) {
    var xcss = props.xcss, _props$appearance = props.appearance, inAppearance = _props$appearance === void 0 ? 'default' : _props$appearance, isOpen = props.isOpen, providedId = props.id, offset = props.offset, testId = props.testId, trigger = props.trigger, content = props.content, onClose = props.onClose, boundary = props.boundary, _props$rootBoundary = props.rootBoundary, rootBoundary = _props$rootBoundary === void 0 ? 'viewport' : _props$rootBoundary, _props$shouldFlip = props.shouldFlip, shouldFlip = _props$shouldFlip === void 0 ? true : _props$shouldFlip, _props$placement = props.placement, placement = _props$placement === void 0 ? 'auto' : _props$placement, fallbackPlacements = props.fallbackPlacements, PopupContainer = props.popupComponent, _props$autoFocus = props.autoFocus, autoFocus = _props$autoFocus === void 0 ? true : _props$autoFocus, _props$zIndex = props.zIndex, zIndex = _props$zIndex === void 0 ? $a2b7f495199a9de5$var$defaultLayer : _props$zIndex, _props$shouldUseCaptu = props.shouldUseCaptureOnOutsideClick, shouldUseCaptureOnOutsideClick = _props$shouldUseCaptu === void 0 ? false : _props$shouldUseCaptu, shouldIgnoreCloseEvent = props.shouldIgnoreCloseEvent, _props$shouldRenderTo = props.shouldRenderToParent, inShouldRenderToParent = _props$shouldRenderTo === void 0 ? false : _props$shouldRenderTo, _props$shouldFitConta = props.shouldFitContainer, shouldFitContainer = _props$shouldFitConta === void 0 ? false : _props$shouldFitConta, _props$shouldDisableF = props.shouldDisableFocusLock, shouldDisableFocusLock = _props$shouldDisableF === void 0 ? false : _props$shouldDisableF, _props$shouldReturnFo = props.shouldReturnFocus, shouldReturnFocus = _props$shouldReturnFo === void 0 ? true : _props$shouldReturnFo, strategy = props.strategy, role = props.role, label = props.label, titleId = props.titleId, modifiers = props.modifiers, shouldFitViewport = props.shouldFitViewport;
    var _useState = (0, $5FkrB.useState)(null), _useState2 = (0, $0b8156ac98850b5f$export$2e2bcd8739ae039)(_useState, 2), triggerRef = _useState2[0], setTriggerRef = _useState2[1];
    var getMergedTriggerRef = (0, $e56679fddd3bf8a0$export$7cc5c058dd769dff)();
    var getMergedTriggerRefNew = (0, $20ff774fe0ee677f$export$5d3a2de79e07b376)();
    var generatedId = (0, $c797bf80d6171378$export$f680877a34711e37)();
    var _usePopupAppearance = (0, $3a721fa318d8ecb3$export$4065aef1d79a5730)({
        appearance: inAppearance,
        shouldRenderToParent: inShouldRenderToParent
    }), appearance = _usePopupAppearance.appearance, shouldRenderToParent = _usePopupAppearance.shouldRenderToParent;
    var id = providedId || generatedId;
    var handleOpenLayerObserverCloseSignal = (0, $5FkrB.useCallback)(function() {
        onClose === null || onClose === void 0 || onClose(null);
    }, [
        onClose
    ]);
    (0, $dc4b45f7ee6225f5$export$469bb693f11edc7f)({
        isOpen: isOpen,
        onClose: handleOpenLayerObserverCloseSignal,
        type: 'popup'
    });
    // `xcss` is part of Popup's public API and is forwarded as-is to
    // the internal PopperWrapper, which rebuilds the inner styles. We
    // re-bind via a property accessor on a stable object so the
    // design-system css-prop lint rule's identifier-shape check no
    // longer flags it (avoiding a ratcheted lint suppression here).
    var xcssPassthrough = {
        value: xcss
    };
    var renderPopperWrapper = /*#__PURE__*/ $5FkrB.createElement((0, $a9ae8770cf8dda67$export$7c885f891c940977), {
        isDisabled: false
    }, /*#__PURE__*/ $5FkrB.createElement((0, $01e0383d73d1296a$export$2e2bcd8739ae039), {
        xcss: xcssPassthrough.value,
        appearance: appearance,
        content: content,
        isOpen: isOpen,
        placement: placement,
        fallbackPlacements: fallbackPlacements,
        boundary: boundary,
        rootBoundary: rootBoundary,
        shouldFlip: shouldFlip,
        offset: offset,
        popupComponent: PopupContainer,
        id: id,
        testId: testId,
        onClose: onClose,
        autoFocus: autoFocus,
        shouldUseCaptureOnOutsideClick: shouldUseCaptureOnOutsideClick,
        shouldIgnoreCloseEvent: shouldIgnoreCloseEvent,
        shouldRenderToParent: shouldRenderToParent || shouldFitContainer,
        shouldFitContainer: shouldFitContainer,
        shouldDisableFocusLock: shouldDisableFocusLock,
        shouldReturnFocus: shouldReturnFocus,
        triggerRef: triggerRef,
        zIndex: zIndex,
        strategy: shouldFitContainer ? 'absolute' : strategy,
        role: role,
        label: label,
        titleId: titleId,
        modifiers: modifiers,
        shouldFitViewport: shouldFitViewport
    }));
    var popupContent = /*#__PURE__*/ $5FkrB.createElement((0, $351c41799462e9b8$export$d0d38e7dec7a1a61), null, /*#__PURE__*/ $5FkrB.createElement((0, $cde0d25d074125a2$export$e0be378c32fb70a7), null, function(_ref) {
        var ref = _ref.ref;
        return trigger({
            ref: !(0, $50U6m.fg)('platform-design-system-popup-ref') ? getMergedTriggerRef(ref, setTriggerRef, isOpen) : getMergedTriggerRefNew(ref, setTriggerRef),
            'aria-controls': isOpen ? id : undefined,
            'aria-expanded': isOpen,
            'aria-haspopup': role === 'dialog' && (0, $50U6m.fg)('platform_dst_popup-disable-focuslock') ? 'dialog' : true
        });
    }), !(0, $50U6m.fg)('platform-dst-motion-uplift-popup') && isOpen && (shouldRenderToParent || shouldFitContainer ? renderPopperWrapper : /*#__PURE__*/ $5FkrB.createElement((0, $b972fda2d5cd73a8$export$2e2bcd8739ae039), {
        zIndex: zIndex
    }, renderPopperWrapper)), (0, $50U6m.fg)('platform-dst-motion-uplift-popup') && /*#__PURE__*/ $5FkrB.createElement((0, $7dce5bdaf433551a$export$2e2bcd8739ae039), {
        appear: true
    }, isOpen && (shouldRenderToParent || shouldFitContainer ? renderPopperWrapper : /*#__PURE__*/ $5FkrB.createElement((0, $b972fda2d5cd73a8$export$2e2bcd8739ae039), {
        zIndex: zIndex
    }, renderPopperWrapper))));
    if (shouldFitContainer) return /*#__PURE__*/ $5FkrB.createElement((0, $7a49b1df02a75aca$export$e71c4d32a2263218), {
        xcss: $a2b7f495199a9de5$var$wrapperStyles.root
    }, popupContent);
    return popupContent;
};
var $a2b7f495199a9de5$export$129a32eedafa97c5 = /*#__PURE__*/ (0, $5FkrB.memo)(function(props) {
    // Choose the rendering implementation at the component boundary rather than
    // gating hooks inside a single component. Each implementation owns its own
    // hooks unconditionally, so a runtime feature-flag change swaps component
    // types (a clean remount) instead of changing the hook order of a mounted
    // component.
    if ((0, $50U6m.fg)('platform-dst-top-layer')) // Pass the original props object to preserve the discriminated union
    // (shouldFitContainer: true vs false) that is lost after destructuring.
    return /*#__PURE__*/ $5FkrB.createElement((0, $2d7050bf4b301b0f$export$e24b8cb659609dee), props);
    return /*#__PURE__*/ $5FkrB.createElement($a2b7f495199a9de5$var$PopupLegacy, props);
});



var $5FkrB = parcelRequire("5FkrB");
function $9e516064abbac8ac$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return r;
}


function $dd06d7bca348739a$export$2e2bcd8739ae039(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}


function $8f3e07d8d031a3c4$export$2e2bcd8739ae039(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}


function $0d163ed5535178dd$export$2e2bcd8739ae039(r, a) {
    if (r) {
        if ("string" == typeof r) return (0, $8f3e07d8d031a3c4$export$2e2bcd8739ae039)(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? (0, $8f3e07d8d031a3c4$export$2e2bcd8739ae039)(r, a) : void 0;
    }
}


function $0e3033405de9bed2$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}


function $a2a615a5a33521e7$export$2e2bcd8739ae039(r, e) {
    return (0, $9e516064abbac8ac$export$2e2bcd8739ae039)(r) || (0, $dd06d7bca348739a$export$2e2bcd8739ae039)(r, e) || (0, $0d163ed5535178dd$export$2e2bcd8739ae039)(r, e) || (0, $0e3033405de9bed2$export$2e2bcd8739ae039)();
}



var $5FkrB = parcelRequire("5FkrB");


var $5FkrB = parcelRequire("5FkrB");
function $cbd0ee50051aaaeb$export$2f62ee6831462844() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var ref = (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).useRef();
    var observerInstance = (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).useRef();
    var _React$useState = (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).useState({
        inView: false,
        entry: undefined,
        target: undefined
    }), _React$useState2 = (0, $a2a615a5a33521e7$export$2e2bcd8739ae039)(_React$useState, 2), state = _React$useState2[0], setState = _React$useState2[1];
    var threshold = options.threshold, root = options.root, rootMargin = options.rootMargin;
    var setRef = (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).useCallback(function(node) {
        observerInstance.current = new IntersectionObserver(function(entries) {
            if (entries && entries.length) {
                var intersection = entries[0];
                var isIntersecting = intersection.isIntersecting, intersectionRatio = intersection.intersectionRatio;
                if (intersectionRatio >= 0) {
                    // Note: `0` will be used here when an array of numbers is passed as the threshold, which doesn't feel right
                    var numericThreshold = typeof threshold === 'number' ? threshold : 0;
                    var inView = intersectionRatio >= numericThreshold;
                    if (isIntersecting !== undefined) inView = inView && isIntersecting;
                    setState({
                        inView: inView,
                        entry: intersection,
                        target: node
                    });
                }
            }
        }, {
            threshold: threshold,
            root: root,
            rootMargin: rootMargin
        });
        if (ref.current) observerInstance.current.unobserve(ref.current);
        if (node) observerInstance.current.observe(node);
        // Store a reference to the node
        ref.current = node;
    }, [
        threshold,
        root,
        rootMargin
    ]);
    /**
   * Unsubscribe IntersectionObserver before unmounting a component.
   */ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).useEffect(function() {
        return function() {
            if (observerInstance.current && ref.current) observerInstance.current.unobserve(ref.current);
        };
    }, []);
    return [
        setRef,
        state.inView,
        state.target,
        state.entry
    ];
}


var $9bffc6fe1a50f729$export$ff983d2a2b6112ea = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).memo(function(_ref) {
    var setWidth = _ref.setWidth, offscreen = _ref.offscreen;
    var _useInView = (0, $cbd0ee50051aaaeb$export$2f62ee6831462844)({
        /* Optional options */ threshold: 0
    }), _useInView2 = (0, $a2a615a5a33521e7$export$2e2bcd8739ae039)(_useInView, 3), inViewRef = _useInView2[0], inView = _useInView2[1], target = _useInView2[2];
    var observer = (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).useRef(function() {
        if (typeof window === 'undefined') return null;
        // https://github.com/DefinitelyTyped/DefinitelyTyped/pull/40909
        return new ResizeObserver(function(entries) {
            if (!Array.isArray(entries) || !entries.length) return;
            var width = entries[0].contentRect.width;
            setWidth(Math.round(width));
        });
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).useEffect(function() {
        var currentObserver = observer.current;
        var resizeObserver = currentObserver();
        if (resizeObserver === null) return;
        if (target) {
            if (inView || offscreen) resizeObserver.observe(target);
            else resizeObserver.unobserve(target);
        }
        return function() {
            resizeObserver.disconnect();
        };
    }, [
        target,
        inView,
        offscreen
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("div", {
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            display: 'block',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            width: '100%',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            position: 'absolute'
        },
        ref: inViewRef
    });
});


var $868076b348d71ed1$export$b2ad68b9bc407b80 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).memo(function(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $9bffc6fe1a50f729$export$ff983d2a2b6112ea), {
        setWidth: props.setWidth,
        offscreen: props.offscreen
    });
});



var $5FkrB = parcelRequire("5FkrB");
/* eslint-disable @repo/internal/react/require-jsdoc */ 
var $5FkrB = parcelRequire("5FkrB");

var $6165343a3bbd10dd$export$79f16dd643143c25 = /*#__PURE__*/ (0, $5FkrB.createContext)({
    isVisible: true,
    openOverflowMenu: (0, $adcefb868cf2fc9d$export$2e2bcd8739ae039),
    closeOverflowMenu: (0, $adcefb868cf2fc9d$export$2e2bcd8739ae039)
});


var $9cea31fc2820a98e$export$a3a2def3937905a0 = function OverflowProvider(_ref) {
    var children = _ref.children, isVisible = _ref.isVisible, openOverflowMenu = _ref.openOverflowMenu, closeOverflowMenu = _ref.closeOverflowMenu;
    var value = (0, $5FkrB.useMemo)(function() {
        return {
            isVisible: isVisible,
            openOverflowMenu: openOverflowMenu,
            closeOverflowMenu: closeOverflowMenu
        };
    }, [
        isVisible,
        openOverflowMenu,
        closeOverflowMenu
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $6165343a3bbd10dd$export$79f16dd643143c25).Provider, {
        value: value
    }, children);
};




var $5FkrB = parcelRequire("5FkrB");
var $2494a48c3c318569$exports = {};
var $ad50c8eeec1f512b$exports = {};
var $fceb7d20fd150820$exports = {};
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $fceb7d20fd150820$var$isObject(value) {
    var type = typeof value;
    return value != null && (type == 'object' || type == 'function');
}
$fceb7d20fd150820$exports = $fceb7d20fd150820$var$isObject;


var $1faf09b77d13e0f6$exports = {};
var $dcd24212e9610d38$exports = {};
var $19ff8c897068d84b$exports = {};
/** Detect free variable `global` from Node.js. */ var $19ff8c897068d84b$var$freeGlobal = typeof $parcel$global == 'object' && $parcel$global && $parcel$global.Object === Object && $parcel$global;
$19ff8c897068d84b$exports = $19ff8c897068d84b$var$freeGlobal;


/** Detect free variable `self`. */ var $dcd24212e9610d38$var$freeSelf = typeof self == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $dcd24212e9610d38$var$root = $19ff8c897068d84b$exports || $dcd24212e9610d38$var$freeSelf || Function('return this')();
$dcd24212e9610d38$exports = $dcd24212e9610d38$var$root;


/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */ var $1faf09b77d13e0f6$var$now = function() {
    return $dcd24212e9610d38$exports.Date.now();
};
$1faf09b77d13e0f6$exports = $1faf09b77d13e0f6$var$now;


var $8a7089fbe4706c31$exports = {};
var $21e8cef54ead7066$exports = {};
var $e1f961ac832bfec6$exports = {};
/** Used to match a single whitespace character. */ var $e1f961ac832bfec6$var$reWhitespace = /\s/;
/**
 * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
 * character of `string`.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {number} Returns the index of the last non-whitespace character.
 */ function $e1f961ac832bfec6$var$trimmedEndIndex(string) {
    var index = string.length;
    while(index-- && $e1f961ac832bfec6$var$reWhitespace.test(string.charAt(index)));
    return index;
}
$e1f961ac832bfec6$exports = $e1f961ac832bfec6$var$trimmedEndIndex;


/** Used to match leading whitespace. */ var $21e8cef54ead7066$var$reTrimStart = /^\s+/;
/**
 * The base implementation of `_.trim`.
 *
 * @private
 * @param {string} string The string to trim.
 * @returns {string} Returns the trimmed string.
 */ function $21e8cef54ead7066$var$baseTrim(string) {
    return string ? string.slice(0, $e1f961ac832bfec6$exports(string) + 1).replace($21e8cef54ead7066$var$reTrimStart, '') : string;
}
$21e8cef54ead7066$exports = $21e8cef54ead7066$var$baseTrim;



var $2856825500e2bbb2$exports = {};
var $5c516ff9b4ec4333$exports = {};
var $b0cdf5f82c284b2b$exports = {};

/** Built-in value references. */ var $b0cdf5f82c284b2b$var$Symbol = $dcd24212e9610d38$exports.Symbol;
$b0cdf5f82c284b2b$exports = $b0cdf5f82c284b2b$var$Symbol;


var $3e8c179708a8a55c$exports = {};

/** Used for built-in method references. */ var $3e8c179708a8a55c$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $3e8c179708a8a55c$var$hasOwnProperty = $3e8c179708a8a55c$var$objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $3e8c179708a8a55c$var$nativeObjectToString = $3e8c179708a8a55c$var$objectProto.toString;
/** Built-in value references. */ var $3e8c179708a8a55c$var$symToStringTag = $b0cdf5f82c284b2b$exports ? $b0cdf5f82c284b2b$exports.toStringTag : undefined;
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function $3e8c179708a8a55c$var$getRawTag(value) {
    var isOwn = $3e8c179708a8a55c$var$hasOwnProperty.call(value, $3e8c179708a8a55c$var$symToStringTag), tag = value[$3e8c179708a8a55c$var$symToStringTag];
    try {
        value[$3e8c179708a8a55c$var$symToStringTag] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = $3e8c179708a8a55c$var$nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[$3e8c179708a8a55c$var$symToStringTag] = tag;
        else delete value[$3e8c179708a8a55c$var$symToStringTag];
    }
    return result;
}
$3e8c179708a8a55c$exports = $3e8c179708a8a55c$var$getRawTag;


var $247a3d9d42b555d0$exports = {};
/** Used for built-in method references. */ var $247a3d9d42b555d0$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $247a3d9d42b555d0$var$nativeObjectToString = $247a3d9d42b555d0$var$objectProto.toString;
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function $247a3d9d42b555d0$var$objectToString(value) {
    return $247a3d9d42b555d0$var$nativeObjectToString.call(value);
}
$247a3d9d42b555d0$exports = $247a3d9d42b555d0$var$objectToString;


/** `Object#toString` result references. */ var $5c516ff9b4ec4333$var$nullTag = '[object Null]', $5c516ff9b4ec4333$var$undefinedTag = '[object Undefined]';
/** Built-in value references. */ var $5c516ff9b4ec4333$var$symToStringTag = $b0cdf5f82c284b2b$exports ? $b0cdf5f82c284b2b$exports.toStringTag : undefined;
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function $5c516ff9b4ec4333$var$baseGetTag(value) {
    if (value == null) return value === undefined ? $5c516ff9b4ec4333$var$undefinedTag : $5c516ff9b4ec4333$var$nullTag;
    return $5c516ff9b4ec4333$var$symToStringTag && $5c516ff9b4ec4333$var$symToStringTag in Object(value) ? $3e8c179708a8a55c$exports(value) : $247a3d9d42b555d0$exports(value);
}
$5c516ff9b4ec4333$exports = $5c516ff9b4ec4333$var$baseGetTag;


var $71ee7875aed49df0$exports = {};
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $71ee7875aed49df0$var$isObjectLike(value) {
    return value != null && typeof value == 'object';
}
$71ee7875aed49df0$exports = $71ee7875aed49df0$var$isObjectLike;


/** `Object#toString` result references. */ var $2856825500e2bbb2$var$symbolTag = '[object Symbol]';
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $2856825500e2bbb2$var$isSymbol(value) {
    return typeof value == 'symbol' || $71ee7875aed49df0$exports(value) && $5c516ff9b4ec4333$exports(value) == $2856825500e2bbb2$var$symbolTag;
}
$2856825500e2bbb2$exports = $2856825500e2bbb2$var$isSymbol;


/** Used as references for various `Number` constants. */ var $8a7089fbe4706c31$var$NAN = 0 / 0;
/** Used to detect bad signed hexadecimal string values. */ var $8a7089fbe4706c31$var$reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
/** Used to detect binary string values. */ var $8a7089fbe4706c31$var$reIsBinary = /^0b[01]+$/i;
/** Used to detect octal string values. */ var $8a7089fbe4706c31$var$reIsOctal = /^0o[0-7]+$/i;
/** Built-in method references without a dependency on `root`. */ var $8a7089fbe4706c31$var$freeParseInt = parseInt;
/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */ function $8a7089fbe4706c31$var$toNumber(value) {
    if (typeof value == 'number') return value;
    if ($2856825500e2bbb2$exports(value)) return $8a7089fbe4706c31$var$NAN;
    if ($fceb7d20fd150820$exports(value)) {
        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
        value = $fceb7d20fd150820$exports(other) ? other + '' : other;
    }
    if (typeof value != 'string') return value === 0 ? value : +value;
    value = $21e8cef54ead7066$exports(value);
    var isBinary = $8a7089fbe4706c31$var$reIsBinary.test(value);
    return isBinary || $8a7089fbe4706c31$var$reIsOctal.test(value) ? $8a7089fbe4706c31$var$freeParseInt(value.slice(2), isBinary ? 2 : 8) : $8a7089fbe4706c31$var$reIsBadHex.test(value) ? $8a7089fbe4706c31$var$NAN : +value;
}
$8a7089fbe4706c31$exports = $8a7089fbe4706c31$var$toNumber;


/** Error message constants. */ var $ad50c8eeec1f512b$var$FUNC_ERROR_TEXT = 'Expected a function';
/* Built-in method references for those with the same name as other `lodash` methods. */ var $ad50c8eeec1f512b$var$nativeMax = Math.max, $ad50c8eeec1f512b$var$nativeMin = Math.min;
/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */ function $ad50c8eeec1f512b$var$debounce(func, wait, options) {
    var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
    if (typeof func != 'function') throw new TypeError($ad50c8eeec1f512b$var$FUNC_ERROR_TEXT);
    wait = $8a7089fbe4706c31$exports(wait) || 0;
    if ($fceb7d20fd150820$exports(options)) {
        leading = !!options.leading;
        maxing = 'maxWait' in options;
        maxWait = maxing ? $ad50c8eeec1f512b$var$nativeMax($8a7089fbe4706c31$exports(options.maxWait) || 0, wait) : maxWait;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
    }
    function invokeFunc(time) {
        var args = lastArgs, thisArg = lastThis;
        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
    }
    function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
    }
    function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, timeWaiting = wait - timeSinceLastCall;
        return maxing ? $ad50c8eeec1f512b$var$nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
    }
    function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
    }
    function timerExpired() {
        var time = $1faf09b77d13e0f6$exports();
        if (shouldInvoke(time)) return trailingEdge(time);
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
    }
    function trailingEdge(time) {
        timerId = undefined;
        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) return invokeFunc(time);
        lastArgs = lastThis = undefined;
        return result;
    }
    function cancel() {
        if (timerId !== undefined) clearTimeout(timerId);
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
    }
    function flush() {
        return timerId === undefined ? result : trailingEdge($1faf09b77d13e0f6$exports());
    }
    function debounced() {
        var time = $1faf09b77d13e0f6$exports(), isInvoking = shouldInvoke(time);
        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;
        if (isInvoking) {
            if (timerId === undefined) return leadingEdge(lastCallTime);
            if (maxing) {
                // Handle invocations in a tight loop.
                clearTimeout(timerId);
                timerId = setTimeout(timerExpired, wait);
                return invokeFunc(lastCallTime);
            }
        }
        if (timerId === undefined) timerId = setTimeout(timerExpired, wait);
        return result;
    }
    debounced.cancel = cancel;
    debounced.flush = flush;
    return debounced;
}
$ad50c8eeec1f512b$exports = $ad50c8eeec1f512b$var$debounce;



/** Error message constants. */ var $2494a48c3c318569$var$FUNC_ERROR_TEXT = 'Expected a function';
/**
 * Creates a throttled function that only invokes `func` at most once per
 * every `wait` milliseconds. The throttled function comes with a `cancel`
 * method to cancel delayed `func` invocations and a `flush` method to
 * immediately invoke them. Provide `options` to indicate whether `func`
 * should be invoked on the leading and/or trailing edge of the `wait`
 * timeout. The `func` is invoked with the last arguments provided to the
 * throttled function. Subsequent calls to the throttled function return the
 * result of the last `func` invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the throttled function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.throttle` and `_.debounce`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to throttle.
 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=true]
 *  Specify invoking on the leading edge of the timeout.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new throttled function.
 * @example
 *
 * // Avoid excessively updating the position while scrolling.
 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
 *
 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
 * jQuery(element).on('click', throttled);
 *
 * // Cancel the trailing throttled invocation.
 * jQuery(window).on('popstate', throttled.cancel);
 */ function $2494a48c3c318569$var$throttle(func, wait, options) {
    var leading = true, trailing = true;
    if (typeof func != 'function') throw new TypeError($2494a48c3c318569$var$FUNC_ERROR_TEXT);
    if ($fceb7d20fd150820$exports(options)) {
        leading = 'leading' in options ? !!options.leading : leading;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
    }
    return $ad50c8eeec1f512b$exports(func, wait, {
        'leading': leading,
        'maxWait': wait,
        'trailing': trailing
    });
}
$2494a48c3c318569$exports = $2494a48c3c318569$var$throttle;


var $55eb5cb6d6f8b3bb$var$THROTTLE_INTERVAL = 64;
var $55eb5cb6d6f8b3bb$var$ITEM_APPROX_MINWIDTH = 70;
var $55eb5cb6d6f8b3bb$var$calculateHash = function calculateHash(w, n) {
    return w + '#' + n;
};
var $55eb5cb6d6f8b3bb$var$updateHashRef = function updateHashRef(currentRef, value) {
    currentRef.unshift(value);
    currentRef.length = 3;
};
var $55eb5cb6d6f8b3bb$export$705aa66a39c35bf7 = function useOverflowController(nodes) {
    var items = (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).Children.toArray(nodes);
    var _useState = (0, $5FkrB.useState)(9999), _useState2 = (0, $8ddf8a10eebb4436$export$2e2bcd8739ae039)(_useState, 2), width = _useState2[0], setWidth = _useState2[1];
    var _useState3 = (0, $5FkrB.useState)(items.length), _useState4 = (0, $8ddf8a10eebb4436$export$2e2bcd8739ae039)(_useState3, 2), itemsLimit = _useState4[0], setItemsLimit = _useState4[1];
    var _useState5 = (0, $5FkrB.useState)({}), _useState6 = (0, $8ddf8a10eebb4436$export$2e2bcd8739ae039)(_useState5, 2), forceEffectValue = _useState6[0], triggerForceEffect = _useState6[1];
    // Storing items approximate width so we can try expanding when there is enough room
    var itemsWidths = (0, $5FkrB.useRef)([]).current;
    // Storing a couple of width + items count in order to stabilize
    var hashRef = (0, $5FkrB.useRef)([]);
    // AFP-2511 TODO: Fix automatic suppressions below
    // eslint-disable-next-line react-hooks/exhaustive-deps
    var throttleSetWidth = (0, $5FkrB.useCallback)((0, (/*@__PURE__*/$parcel$interopDefault($2494a48c3c318569$exports)))(setWidth, $55eb5cb6d6f8b3bb$var$THROTTLE_INTERVAL), [
        setWidth
    ]);
    (0, $5FkrB.useEffect)(function() {
        var lastItemWidth = itemsWidths[itemsLimit] || 0;
        var wasJustLimited = lastItemWidth < 0;
        var currentHash = $55eb5cb6d6f8b3bb$var$calculateHash(width, itemsLimit);
        if (hashRef.current[0] === currentHash) {
            // After removing an item, if width has not changed yet we schedule a force update
            // to handle case where removing an item does not actually trigger width change
            var t = setTimeout(function() {
                $55eb5cb6d6f8b3bb$var$updateHashRef(hashRef.current, '');
                triggerForceEffect({});
            }, $55eb5cb6d6f8b3bb$var$THROTTLE_INTERVAL * 1.5);
            return function() {
                return clearTimeout(t);
            };
        }
        if (wasJustLimited) {
            // Width was updated either via resize or after changing the limit
            // we cap the width between ITEM_APPROX_MINWIDTH and 2*ITEM_APPROX_MINWIDTH
            // because width is throttled as when fast expanding/resizing partialWidth
            // will not be reliable (edge case)
            var partialWidth = Math.max(Math.min(width + lastItemWidth, $55eb5cb6d6f8b3bb$var$ITEM_APPROX_MINWIDTH * 2), $55eb5cb6d6f8b3bb$var$ITEM_APPROX_MINWIDTH);
            itemsWidths[itemsLimit] = partialWidth;
        }
        if (width < $55eb5cb6d6f8b3bb$var$ITEM_APPROX_MINWIDTH * 0.9 && itemsLimit) {
            // If current width is less than an item approx width we remove an item
            // marking the width as negative so we will calculate it on width update
            // plus we set the hash to stabilise and not removing more than one element
            // until we are sure width was updated
            var nextHash = $55eb5cb6d6f8b3bb$var$calculateHash(width, itemsLimit - 1);
            if (hashRef.current.indexOf(nextHash) === -1) {
                setItemsLimit(itemsLimit - 1);
                itemsWidths[itemsLimit - 1] = -(width || 1);
                $55eb5cb6d6f8b3bb$var$updateHashRef(hashRef.current, nextHash);
            }
            return;
        }
        /**
     * This is not necessarily equal to `lastItemWidth` because the
     * ```js
     * if (wasJustLimited) {}
     * ```
     * branch above modifies `itemsWidths`.
     *
     * Using `lastItemWidth` here can cause collapsing behavior to fail,
     * such as the issue reported in DSP-7329.
     */ var currentLastItemWidth = itemsWidths[itemsLimit] || 0;
        if (width - currentLastItemWidth > $55eb5cb6d6f8b3bb$var$ITEM_APPROX_MINWIDTH * 1.1 && itemsLimit < items.length) {
            // If we have enough room to accomodate next item width we increase the limit
            // unless it has been recently removed
            var _nextHash = $55eb5cb6d6f8b3bb$var$calculateHash(width, itemsLimit + 1);
            if (hashRef.current.indexOf(_nextHash) === -1) {
                setItemsLimit(itemsLimit + 1);
                $55eb5cb6d6f8b3bb$var$updateHashRef(hashRef.current, _nextHash);
            }
            return;
        }
        return;
    }, [
        width,
        hashRef,
        itemsLimit,
        itemsWidths,
        forceEffectValue,
        items.length
    ]);
    return {
        visibleItems: items.slice(0, itemsLimit),
        overflowItems: items.slice(itemsLimit),
        updateWidth: throttleSetWidth
    };
};



function $c2cd0f452fdf3991$export$2e2bcd8739ae039(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}


function $1156f3ba78bc1e19$export$2e2bcd8739ae039(e, t) {
    if (null == e) return {};
    var o, r, i = (0, $c2cd0f452fdf3991$export$2e2bcd8739ae039)(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}



var $5FkrB = parcelRequire("5FkrB");

var $2nBsU = parcelRequire("2nBsU");
var $e923ee93b7164642$exports = {};
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6af69c0da1151808644d1b7c1f4d031c>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty($e923ee93b7164642$exports, "__esModule", {
    value: true
});
$e923ee93b7164642$exports.default = void 0;

var $e923ee93b7164642$var$_react = $e923ee93b7164642$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $e923ee93b7164642$var$_baseNew = $e923ee93b7164642$var$_interopRequireDefault((parcelRequire("6qplN")));
function $e923ee93b7164642$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ChevronDown".
 * Category: multi-purpose
 * Location: @atlaskit/icon/core/chevron-down
 * Usage guidance:
 * Do not use 16px chevrons within buttons, icon buttons, or dropdowns to maintain visual cohesion with ADS which uses 12px chevrons.
 * Known uses: Open dropdown menu, expanded tree item, collapse tree item
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $e923ee93b7164642$var$ChevronDownIcon = (props)=>/*#__PURE__*/ $e923ee93b7164642$var$_react.default.createElement($e923ee93b7164642$var$_baseNew.default, Object.assign({
        name: "ChevronDownIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="m14.53 6.03-6 6a.75.75 0 0 1-1.004.052l-.056-.052-6-6 1.06-1.06L8 10.44l5.47-5.47z"/>`
    }, props));
$e923ee93b7164642$var$ChevronDownIcon.displayName = 'ChevronDownIcon';
var $e923ee93b7164642$var$_default = $e923ee93b7164642$exports.default = $e923ee93b7164642$var$ChevronDownIcon;






var $5FkrB = parcelRequire("5FkrB");

var $2nBsU = parcelRequire("2nBsU");
function $bdabb985862bf53b$export$2e2bcd8739ae039() {
    return $bdabb985862bf53b$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $bdabb985862bf53b$export$2e2bcd8739ae039.apply(null, arguments);
}


function $55101787611156c2$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return r;
}


function $3ce84d59cd5d831b$export$2e2bcd8739ae039(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}


function $63f3b26f8173f711$export$2e2bcd8739ae039(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}


function $b22443d271878128$export$2e2bcd8739ae039(r, a) {
    if (r) {
        if ("string" == typeof r) return (0, $63f3b26f8173f711$export$2e2bcd8739ae039)(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? (0, $63f3b26f8173f711$export$2e2bcd8739ae039)(r, a) : void 0;
    }
}


function $0ca985e453a715e8$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}


function $a004a50eecd8ae97$export$2e2bcd8739ae039(r, e) {
    return (0, $55101787611156c2$export$2e2bcd8739ae039)(r) || (0, $3ce84d59cd5d831b$export$2e2bcd8739ae039)(r, e) || (0, $b22443d271878128$export$2e2bcd8739ae039)(r, e) || (0, $0ca985e453a715e8$export$2e2bcd8739ae039)();
}


function $2ca1d3c527e4af60$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $2ca1d3c527e4af60$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $2ca1d3c527e4af60$export$2e2bcd8739ae039(o);
}



function $df7d5b6c09fd7643$export$2e2bcd8739ae039(t, r) {
    if ("object" != (0, $2ca1d3c527e4af60$export$2e2bcd8739ae039)(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (0, $2ca1d3c527e4af60$export$2e2bcd8739ae039)(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}


function $99c88dbaa714c7b3$export$2e2bcd8739ae039(t) {
    var i = (0, $df7d5b6c09fd7643$export$2e2bcd8739ae039)(t, "string");
    return "symbol" == (0, $2ca1d3c527e4af60$export$2e2bcd8739ae039)(i) ? i : i + "";
}


function $bd4a332227205a32$export$2e2bcd8739ae039(e, r, t) {
    return (r = (0, $99c88dbaa714c7b3$export$2e2bcd8739ae039)(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}


function $0cf19974daf70083$export$2e2bcd8739ae039(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}


function $230c1601acfa3177$export$2e2bcd8739ae039(e, t) {
    if (null == e) return {};
    var o, r, i = (0, $0cf19974daf70083$export$2e2bcd8739ae039)(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}



var $5FkrB = parcelRequire("5FkrB");
/* eslint-disable @atlaskit/volt-strict-mode/no-multiple-exports */ function $86c25fe1c26006c6$export$2e2bcd8739ae039(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}


function $fd616174c50677d5$export$2e2bcd8739ae039(e, t) {
    if (null == e) return {};
    var o, r, i = (0, $86c25fe1c26006c6$export$2e2bcd8739ae039)(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}



var $5FkrB = parcelRequire("5FkrB");
var $d55244cb311b88fe$var$_excluded = [
    "children"
];
function $d55244cb311b88fe$export$25d302a5b900a763(defaultGetTokens) {
    var emptyThemeFn = function emptyThemeFn(getTokens, props) {
        return getTokens(props);
    };
    /**
   * Internally, Theme uses React Context, with internal providers and consumers.
   * The React Context passes only a function that gets props, and turns them into tokens. This
   * function gets mixed as more Providers with their own themes are added. This mixed function
   * is ultimately picked up by Consumers, which implement a context consumer internally to fetch
   * the theme.
   */ var ThemeContext = /*#__PURE__*/ (0, $5FkrB.createContext)(defaultGetTokens);
    function useTheme(themeProps) {
        var theme = (0, $5FkrB.useContext)(ThemeContext);
        var themeFn = theme || emptyThemeFn;
        var tokens = themeFn(themeProps);
        return tokens;
    }
    // The Theme Consumer takes a function as its child - this function takes tokens, and the
    // return value is generally a set of nodes with the tokens applied appropriately.
    function Consumer(props) {
        var children = props.children, themeProps = (0, $fd616174c50677d5$export$2e2bcd8739ae039)(props, $d55244cb311b88fe$var$_excluded);
        // @ts-ignore See issue for more info: https://github.com/Microsoft/TypeScript/issues/10727
        // Argument of type 'Pick<ThemeProps & { children: (tokens: ThemeTokens) => ReactNode; }, Exclude<keyof ThemeProps, "children">>' is not assignable to parameter of type 'ThemeProps'.ts(2345)
        var tokens = useTheme(themeProps);
        // We add a fragment to ensure we don't break people upgrading.
        // Previously they may have been able to pass in undefined without things blowing up.
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).Fragment, null, children(tokens));
    }
    /**
   * The Theme Provider takes regular nodes as its children, but also takes a *theme function*
   * - The theme function takes a set of props, as well as a function (getTokens) that can turn props into tokens.
   * - The getTokens function isn't called immediately - instead the props are passed
   *    through a mix of parent theming functions
   * Children of this provider will receive this mixed theme
   */ function Provider(props) {
        var themeFn = (0, $5FkrB.useContext)(ThemeContext);
        var valueFn = props.value || emptyThemeFn;
        var mixedFn = (0, $5FkrB.useCallback)(function(themeProps) {
            return valueFn(themeFn, themeProps);
        }, [
            themeFn,
            valueFn
        ]);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(ThemeContext.Provider, {
            value: mixedFn
        }, props.children);
    }
    return {
        Consumer: Consumer,
        Provider: Provider,
        useTheme: useTheme
    };
}


// Create default global light theme
var $6e1f8f60750fb56d$var$dest = (0, $d55244cb311b88fe$export$25d302a5b900a763)(function() {
    return {
        mode: 'light'
    };
});
var $6e1f8f60750fb56d$var$Provider = $6e1f8f60750fb56d$var$dest.Provider;
var $6e1f8f60750fb56d$var$Consumer = $6e1f8f60750fb56d$var$dest.Consumer;
var $6e1f8f60750fb56d$export$7692396083754928 = $6e1f8f60750fb56d$var$dest.useTheme;
var $6e1f8f60750fb56d$var$Theme = {
    Provider: $6e1f8f60750fb56d$var$Provider,
    Consumer: $6e1f8f60750fb56d$var$Consumer
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$6e1f8f60750fb56d$export$2e2bcd8739ae039 = $6e1f8f60750fb56d$var$Theme;





var $5FkrB = parcelRequire("5FkrB");

var $2nBsU = parcelRequire("2nBsU");


var $5FkrB = parcelRequire("5FkrB");







function $2cd45b3f9d59bec1$export$2e2bcd8739ae039(t, o) {
    for(; !({}).hasOwnProperty.call(t, o) && null !== (t = (0, $c6c7ad7ba578ca39$export$2e2bcd8739ae039)(t)););
    return t;
}


function $7d00f9e12a35a1bf$export$2e2bcd8739ae039() {
    return $7d00f9e12a35a1bf$export$2e2bcd8739ae039 = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function(e, t, r) {
        var p = (0, $2cd45b3f9d59bec1$export$2e2bcd8739ae039)(e, t);
        if (p) {
            var n = Object.getOwnPropertyDescriptor(p, t);
            return n.get ? n.get.call(arguments.length < 3 ? e : r) : n.value;
        }
    }, $7d00f9e12a35a1bf$export$2e2bcd8739ae039.apply(null, arguments);
}





var $50U6m = parcelRequire("50U6m");




function $81ff880d8cb76a60$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $81ff880d8cb76a60$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $81ff880d8cb76a60$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $0b2d8b20b765b25f$export$2e2bcd8739ae039)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $81ff880d8cb76a60$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $81ff880d8cb76a60$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function AnalyticsEvent(props) {
        var _this = this;
        (0, $3ff823f0da4a20b9$export$2e2bcd8739ae039)(this, AnalyticsEvent);
        (0, $0b2d8b20b765b25f$export$2e2bcd8739ae039)(this, "_isAnalyticsEvent", true);
        (0, $0b2d8b20b765b25f$export$2e2bcd8739ae039)(this, "clone", function() {
            // just a shallow clone, don't change sub refs unless you want to
            // affect the original's too
            var payload = $81ff880d8cb76a60$var$_objectSpread({}, _this.payload);
            return new AnalyticsEvent({
                payload: payload
            });
        });
        this.payload = props.payload;
    }
    return (0, $5c543da7f3d6df1a$export$2e2bcd8739ae039)(AnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (typeof updater === 'function') this.payload = updater(this.payload);
                if ((0, $da06783b19ad120c$export$2e2bcd8739ae039)(updater) === 'object') this.payload = $81ff880d8cb76a60$var$_objectSpread($81ff880d8cb76a60$var$_objectSpread({}, this.payload), updater);
                return this;
            }
        }
    ]);
}();


function $0a7b95699500e142$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $0a7b95699500e142$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $0a7b95699500e142$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $0b2d8b20b765b25f$export$2e2bcd8739ae039)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $0a7b95699500e142$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $0a7b95699500e142$var$_callSuper(t, o, e) {
    return o = (0, $c6c7ad7ba578ca39$export$2e2bcd8739ae039)(o), (0, $8cacf05721e5c3d7$export$2e2bcd8739ae039)(t, $0a7b95699500e142$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, $c6c7ad7ba578ca39$export$2e2bcd8739ae039)(t).constructor) : o.apply(t, e));
}
function $0a7b95699500e142$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($0a7b95699500e142$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $0a7b95699500e142$var$_superPropGet(t, o, e, r) {
    var p = (0, $7d00f9e12a35a1bf$export$2e2bcd8739ae039)((0, $c6c7ad7ba578ca39$export$2e2bcd8739ae039)(1 & r ? t.prototype : t), o, e);
    return 2 & r && "function" == typeof p ? function(t) {
        return p.apply(e, t);
    } : p;
}
var $0a7b95699500e142$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_AnalyticsEvent) {
    function UIAnalyticsEvent(props) {
        var _this;
        (0, $3ff823f0da4a20b9$export$2e2bcd8739ae039)(this, UIAnalyticsEvent);
        _this = $0a7b95699500e142$var$_callSuper(this, UIAnalyticsEvent, [
            props
        ]);
        (0, $0b2d8b20b765b25f$export$2e2bcd8739ae039)(_this, "_isUIAnalyticsEvent", true);
        (0, $0b2d8b20b765b25f$export$2e2bcd8739ae039)(_this, "clone", function() {
            if (_this.hasFired) return null;
            var context = (0, $020c6c091d5e971b$export$2e2bcd8739ae039)(_this.context);
            var handlers = (0, $020c6c091d5e971b$export$2e2bcd8739ae039)(_this.handlers);
            var payload = $0a7b95699500e142$var$clonePayload(_this.payload);
            return new UIAnalyticsEvent({
                context: context,
                handlers: handlers,
                payload: payload
            });
        });
        (0, $0b2d8b20b765b25f$export$2e2bcd8739ae039)(_this, "fire", function(channel) {
            if (_this.hasFired) return;
            _this.handlers.forEach(function(handler) {
                try {
                    handler(_this, channel);
                } catch (e) {}
            });
            _this.hasFired = true;
        });
        _this.context = props.context || [];
        _this.handlers = props.handlers || [];
        _this.hasFired = false;
        return _this;
    }
    (0, $0eea87f8e9485d77$export$2e2bcd8739ae039)(UIAnalyticsEvent, _AnalyticsEvent);
    return (0, $5c543da7f3d6df1a$export$2e2bcd8739ae039)(UIAnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (this.hasFired) return this;
                return $0a7b95699500e142$var$_superPropGet(UIAnalyticsEvent, "update", this, 3)([
                    updater
                ]);
            }
        }
    ]);
}((0, $81ff880d8cb76a60$export$2e2bcd8739ae039));
var $0a7b95699500e142$var$clonePayload = function clonePayload(payload) {
    if ((0, $50U6m.fg)('platform-analytics-next-safe-clone')) try {
        return JSON.parse(JSON.stringify(payload));
    } catch (e) {
        // Shallow clone keeps the event usable without crashing the UI.
        return $0a7b95699500e142$var$_objectSpread({}, payload);
    }
    /**
   * A hacky "deep clone" of the object. This is limited in that it wont
   * support functions, regexs, Maps, Sets, etc, but none of those need to
   * be represented in our payload.
   */ return JSON.parse(JSON.stringify(payload));
};



function $879f28ba40c47674$export$5bf35293e545f20c() {
    var analyticsContext = (0, $3a4497eea280292e$export$d1f587f82ad51c4)();
    var createAnalyticsEvent = (0, $a060da77483cc5d3$export$33752cf3ee811995)(function(payload) {
        return new (0, $0a7b95699500e142$export$2e2bcd8739ae039)({
            context: analyticsContext.getAtlaskitAnalyticsContext(),
            handlers: analyticsContext.getAtlaskitAnalyticsEventHandlers(),
            payload: payload
        });
    }, [
        analyticsContext
    ]);
    return {
        createAnalyticsEvent: createAnalyticsEvent
    };
}



function $7d6daf9bcf6c0b57$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $7d6daf9bcf6c0b57$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $7d6daf9bcf6c0b57$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $0b2d8b20b765b25f$export$2e2bcd8739ae039)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $7d6daf9bcf6c0b57$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $7d6daf9bcf6c0b57$export$a4687b0234b40e28(_ref) {
    var fn = _ref.fn, action = _ref.action, componentName = _ref.componentName, actionSubject = _ref.actionSubject, packageName = _ref.packageName, packageVersion = _ref.packageVersion, analyticsData = _ref.analyticsData;
    var _useAnalyticsEvents = (0, $879f28ba40c47674$export$5bf35293e545f20c)(), createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
    // We put analyticsData and fn in a ref so that we don't need to break
    // memoization.
    // Generally these could be defined by consumers inline
    // and so we do this to avoid breaking memoization of useCallback
    var dataRef = (0, $90d091140a6cc984$export$1d27a74659855e44)(analyticsData);
    var fnRef = (0, $90d091140a6cc984$export$1d27a74659855e44)(fn);
    var handler = (0, $5FkrB.useCallback)(function(value) {
        var analyticsEvent = createAnalyticsEvent({
            action: action,
            actionSubject: actionSubject || componentName,
            attributes: {
                componentName: componentName,
                packageName: packageName,
                packageVersion: packageVersion
            }
        });
        // To avoid wrapping this component in AnalyticsContext we manually
        // push the parent context's meta data into the context.
        // Note: this new 'context'
        var context = $7d6daf9bcf6c0b57$var$_objectSpread({
            componentName: componentName,
            packageName: packageName,
            packageVersion: packageVersion
        }, dataRef.current);
        analyticsEvent.context.push(context);
        // fire an event on the atlaskit channel
        var clone = analyticsEvent.clone();
        if (clone) clone.fire('atlaskit');
        fnRef.current(value, analyticsEvent);
    }, [
        // These are strings and won't change
        action,
        componentName,
        actionSubject,
        packageName,
        packageVersion,
        // This function is memoized in the context
        createAnalyticsEvent,
        // these are a stable ref because of the useTrackedRef hook
        dataRef,
        fnRef
    ]);
    return handler;
}




var $5FkrB = parcelRequire("5FkrB");
function $bf3b13d9d73de104$export$2e2bcd8739ae039(ref, autoFocus) {
    var initialMount = (0, $5FkrB.useRef)(true);
    (0, $5FkrB.useEffect)(function() {
        if (ref && initialMount.current && autoFocus && ref.current) ref.current.focus();
        initialMount.current = false;
    }, [
        autoFocus,
        ref
    ]);
}


/**
 * @jsxRuntime classic
 * @jsx jsx
 */ /* eslint-disable @repo/internal/deprecations/deprecation-ticket-required -- LENS1-245 tracks @atlaskit/focus-ring deprecation. */ 
var $5FkrB = parcelRequire("5FkrB");

var $2nBsU = parcelRequire("2nBsU");
var $ae7f66a126864790$var$BORDER_WIDTH = 2;
var $ae7f66a126864790$var$baseFocusOutsideStyles = (0, $2nBsU.css)({
    outline: "var(--ds-border-width-focused, 2px)".concat(" solid ", "var(--ds-border-focused, #4688EC)"),
    outlineOffset: $ae7f66a126864790$var$BORDER_WIDTH
});
var $ae7f66a126864790$var$baseInsetStyles = (0, $2nBsU.css)({
    outlineColor: "var(--ds-border-focused, #4688EC)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    outlineOffset: -$ae7f66a126864790$var$BORDER_WIDTH,
    outlineStyle: 'solid',
    outlineWidth: "var(--ds-border-width-focused, 2px)"
});
var $ae7f66a126864790$var$focusRingStyles = (0, $2nBsU.css)({
    // Focus styles used when :focus-visible isn't supported
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
    '&:focus': $ae7f66a126864790$var$baseFocusOutsideStyles,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
    '&:focus-visible': $ae7f66a126864790$var$baseFocusOutsideStyles,
    // Remove default focus styles for mouse interactions if :focus-visible is supported
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
    '&:focus:not(:focus-visible)': {
        outline: 'none'
    },
    '@media screen and (forced-colors: active), screen and (-ms-high-contrast: active)': {
        '&:focus-visible': {
            outline: "var(--ds-border-width, 1px)".concat(" solid")
        }
    }
});
var $ae7f66a126864790$var$insetFocusRingStyles = (0, $2nBsU.css)({
    // Focus styles used when :focus-visible isn't supported
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
    '&:focus': $ae7f66a126864790$var$baseInsetStyles,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
    '&:focus-visible': $ae7f66a126864790$var$baseInsetStyles,
    // Remove default focus styles for mouse interactions if :focus-visible is supported
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
    '&:focus:not(:focus-visible)': {
        outline: 'none'
    },
    '@media screen and (forced-colors: active), screen and (-ms-high-contrast: active)': {
        '&:focus-visible': {
            outline: "var(--ds-border-width, 1px)".concat(" solid"),
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
            outlineOffset: '-1px'
        }
    }
});
/**
 * __Focus ring__
 *
 * A focus ring visually indicates the currently focused item.
 *
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/focus-ring)
 *
 * @example
 * ```jsx
 * import FocusRing from '@atlaskit/focus-ring';
 *
 * const InteractiveComponent = () => (
 *   <FocusRing>
 *     <button type="button">Hello</button>
 *   </FocusRing>
 * )
 * ```
 *
 * @deprecated FocusRing is deprecated. Use Focusable from @atlaskit/primitives/compiled/focusable instead.
 */ var $ae7f66a126864790$var$FocusRing = /*#__PURE__*/ (0, $5FkrB.memo)(function(_ref) {
    var children = _ref.children, isInset = _ref.isInset, focus = _ref.focus;
    var controlledStyles = isInset ? $ae7f66a126864790$var$baseInsetStyles : $ae7f66a126864790$var$baseFocusOutsideStyles;
    var uncontrolledStyles = isInset ? $ae7f66a126864790$var$insetFocusRingStyles : $ae7f66a126864790$var$focusRingStyles;
    var focusCls = typeof focus === 'undefined' ? uncontrolledStyles : focus === 'on' && controlledStyles;
    return (0, $2nBsU.jsx)((0, $2nBsU.ClassNames), null, function(_ref2) {
        var css = _ref2.css, cx = _ref2.cx;
        return (0, $5FkrB.Children).only(// This may look unwieldy but means we skip applying styles / cloning if no className is applicable
        focusCls ? /*#__PURE__*/ // eslint-disable-next-line @repo/internal/react/no-clone-element
        (0, $5FkrB.cloneElement)(children, {
            className: cx([
                css(focusCls),
                children.props.className
            ])
        }) : children);
    });
});
$ae7f66a126864790$var$FocusRing.displayName = 'FocusRing';
var $ae7f66a126864790$export$2e2bcd8739ae039 = $ae7f66a126864790$var$FocusRing;



var $5FkrB = parcelRequire("5FkrB");
var $153f0305132b5554$var$interactionContext = /*#__PURE__*/ (0, $5FkrB.createContext)(null);
var $153f0305132b5554$export$2e2bcd8739ae039 = $153f0305132b5554$var$interactionContext;


function $af21457669944388$var$abort(event) {
    event.preventDefault();
    event.stopPropagation();
}
var $af21457669944388$var$tabKeyCode = 9;
function $af21457669944388$var$onKey(event) {
    // Allowing tab so that a user can move focus away
    if (event.keyCode === $af21457669944388$var$tabKeyCode) return;
    $af21457669944388$var$abort(event);
}
var $af21457669944388$var$block = {
    onMouseDownCapture: $af21457669944388$var$abort,
    onMouseUpCapture: $af21457669944388$var$abort,
    // because we have tabIndex = -1 when disabled,
    // keyboard events can only occur when there is an overlay
    onKeyDownCapture: $af21457669944388$var$onKey,
    onKeyUpCapture: $af21457669944388$var$onKey,
    onTouchStartCapture: $af21457669944388$var$abort,
    onTouchEndCapture: $af21457669944388$var$abort,
    onPointerDownCapture: $af21457669944388$var$abort,
    onPointerUpCapture: $af21457669944388$var$abort,
    onClickCapture: $af21457669944388$var$abort,
    // Just smashing the existing onClick for good measure
    onClick: $af21457669944388$var$abort
};
var $af21457669944388$var$doNotBlock = {};
function $af21457669944388$export$2e2bcd8739ae039(_ref) {
    var isInteractive = _ref.isInteractive;
    return isInteractive ? $af21457669944388$var$doNotBlock : $af21457669944388$var$block;
}


// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $2nBsU = parcelRequire("2nBsU");
function $e9ed3ba00a3e194a$export$7ad0316cc0dd65a(_ref) {
    var spacing = _ref.spacing;
    return (0, $2nBsU.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        margin: spacing === 'none' ? 0 : '0 2px',
        // content can grow and shrink
        flexGrow: 1,
        flexShrink: 1,
        // ellipsis for overflow text
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap'
    });
}


// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $2nBsU = parcelRequire("2nBsU");
function $5fcca6eb305a9885$export$1b5827d324e945b1(_ref) {
    var hasOverlay = _ref.hasOverlay;
    return (0, $2nBsU.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        opacity: hasOverlay ? 0 : 1,
        transition: 'opacity 0.3s'
    });
}


// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $2nBsU = parcelRequire("2nBsU");
function $6d1c53d12ac7a727$export$864eea3f4ec3368f(_ref) {
    var spacing = _ref.spacing;
    return (0, $2nBsU.css)({
        display: 'flex',
        // icon size cannot grow and shrink
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        margin: spacing === 'none' ? 0 : "0 2px",
        flexGrow: 0,
        flexShrink: 0,
        alignSelf: 'center',
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        fontSize: 0,
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        lineHeight: 0,
        userSelect: 'none'
    });
}



var $5FkrB = parcelRequire("5FkrB");
/* visually-hidden.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $5FkrB = parcelRequire("5FkrB");
/**
 * The length of the value hash portion of an atomic class name.
 * Atomic class names have the format: `_<group><value>`
 * where group is ATOMIC_GROUP_HASH_LENGTH chars and value is ATOMIC_VALUE_HASH_LENGTH chars.
 *
 * We extract the group key using: `className.slice(0, className.length - ATOMIC_VALUE_HASH_LENGTH)`
 *
 * We support both old-format classes (9 chars: `_` + 4 group + 4 value) and
 * new-format classes (11 chars: `_` + 6 group + 4 value) by using length-based
 * extraction rather than a hardcoded offset — old and new format group keys
 * are different lengths so they are structurally disjoint and never alias each other.
 */ const $cca1f515e403790a$var$ATOMIC_VALUE_HASH_LENGTH = 4;
function $cca1f515e403790a$export$2e2bcd8739ae039(classNames) {
    // Shortcut: nothing to do
    if (!classNames.length) return;
    // Shortcut: don't need to do anything if we only have a single classname
    if (classNames.length === 1 && classNames[0] && // checking to see if `classNames[0]` is a string that contains other classnames
    !classNames[0].includes(' ')) return classNames[0];
    // Using an object rather than a `Map` as it performed better in our benchmarks.
    // Would be happy to move to `Map` if it proved to be better under real conditions.
    const map = {};
    // Note: using loops to minimize iterations over the collection
    for (const value of classNames){
        // Exclude all falsy values, which leaves us with populated strings
        if (!value) continue;
        // a `value` can contain multiple classnames
        const list = value.split(' ');
        for (const className of list){
            /**
             * For atomic style classnames: the `key` is the `group`
             *
             * - Later atomic classnames with the same `group` will override earlier ones
             *   (which is what we want).
             * - Assumes atomic classnames are the only things that start with `_`
             * - Could use a regex to ensure that atomic classnames are structured how we expect,
             *   but did not add that for now as it did slow things down a bit.
             *
             * For other classnames: the `key` is the whole classname
             * - Okay to remove duplicates as doing so does not impact specificity
             *
             * */ const key = className.startsWith('_') ? className.slice(0, className.length - $cca1f515e403790a$var$ATOMIC_VALUE_HASH_LENGTH) : className;
            map[key] = className;
        }
    }
    /**
     * We are converting the `map` into a string.
     *
     * The simple way to do this would be `Object.values(map).join(' ')`.
     * However, the approach below performs 10%-20% better in benchmarks.
     *
     * For `ax()` it feels right to squeeze as much runtime performance out as we can.
     */ let result = '';
    for(const key in map)result += map[key] + ' ';
    // If we have an empty string, then our `map` was empty.
    if (!result) return;
    // remove last " " from the result (we added " " at the end of every value)
    return result.trimEnd();
}


var $a4a1a9cdc7bf2d54$var$visuallyHiddenStyles = null;
/**
 * __Visually hidden__
 *
 * A composable element to apply a visually hidden effect to children.
 * Useful for accessibility compliance.
 *
 * @example
 * ```jsx
 * import VisuallyHidden from '@atlaskit/visually-hidden';
 *
 * export default () => (
 *   <div style={{ border: '1px solid black' }}>
 *      There is text hidden between the brackets [
 *      <VisuallyHidden>Can't see me!</VisuallyHidden>]
 *   </div>
 * );
 * ```
 */ var $a4a1a9cdc7bf2d54$var$VisuallyHidden = function VisuallyHidden(_ref) {
    var children = _ref.children, testId = _ref.testId, role = _ref.role, id = _ref.id;
    return /*#__PURE__*/ $5FkrB.createElement("span", {
        id: id,
        "data-testid": testId,
        role: role,
        className: (0, $cca1f515e403790a$export$2e2bcd8739ae039)([
            "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19itidpf _1reo15vq _18m915vq _1bsbt94y _4t3it94y _kqswstnw _ogto7mnp _uiztglyw _o5721q9c"
        ])
    }, children);
};
$a4a1a9cdc7bf2d54$var$VisuallyHidden.displayName = 'VisuallyHidden';
var $a4a1a9cdc7bf2d54$export$2e2bcd8739ae039 = $a4a1a9cdc7bf2d54$var$VisuallyHidden;


var $eb6132b48d587eca$export$20bbd2efb0d734c4 = function getIfVisuallyHiddenChildren(children) {
    return children && /*#__PURE__*/ (0, $5FkrB.isValidElement)(children) && children.type === (0, $a4a1a9cdc7bf2d54$export$2e2bcd8739ae039);
};


// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
var $8bd7c3c4e645b70a$export$1a9fe1b84c876bb5 = {
    // stretching to full width / height of button
    // this is important as we need it to still block
    // event if clicking in the button's own padding
    position: 'absolute',
    left: 0,
    top: 0,
    right: 0,
    bottom: 0,
    // Putting all children in the center
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
};


var $5f7b778c870b53cc$var$_excluded = [
    "analyticsContext",
    "appearance",
    "autoFocus",
    "buttonCss",
    "children",
    "className",
    "href",
    "component",
    "iconAfter",
    "iconBefore",
    "interactionName",
    "isDisabled",
    "isSelected",
    "onBlur",
    "onClick",
    "onFocus",
    "onMouseDown",
    "overlay",
    "shouldFitContainer",
    "spacing",
    "tabIndex",
    "type",
    "testId"
];
// Disabled buttons will still publish events for nested elements in webkit.
// We are disabling pointer events on child elements so that
// the button will always be the target of events
// Note: firefox does not have this behaviour for child elements
var $5f7b778c870b53cc$var$noPointerEventsOnChildrenCss = {
    '> *': {
        pointerEvents: 'none'
    }
};
/**
 * These CSS variables consumed by the new icons, to allow them to have appropriate
 * padding inside Button while also maintaining spacing for the existing icons.
 *
 * These styles can be removed once the new icons are fully rolled out
 * and we bump Button to set padding based on the new icons.
 */ var $5f7b778c870b53cc$var$iconBeforeSpacingFixStyle = (0, $2nBsU.css)({
    '--ds--button--new-icon-padding-end': "var(--ds-space-025, 2px)",
    '--ds--button--new-icon-padding-start': "var(--ds-space-050, 4px)",
    marginInlineStart: "var(--ds-space-negative-025, -2px)"
});
var $5f7b778c870b53cc$var$iconAfterSpacingFixStyle = (0, $2nBsU.css)({
    '--ds--button--new-icon-padding-end': "var(--ds-space-050, 4px)",
    '--ds--button--new-icon-padding-start': "var(--ds-space-025, 2px)",
    marginInlineEnd: "var(--ds-space-negative-025, -2px)"
});
var $5f7b778c870b53cc$var$getSpacingFix = function getSpacingFix(children, spacingStyles) {
    if (!children || (0, $eb6132b48d587eca$export$20bbd2efb0d734c4)(children)) return null;
    return spacingStyles;
};
var $5f7b778c870b53cc$var$getChildren = function getChildren(children, childrenStyles) {
    if ((0, $eb6132b48d587eca$export$20bbd2efb0d734c4)(children)) return children;
    return children ? (0, $2nBsU.jsx)("span", {
        css: childrenStyles
    }, children) : null;
};
var $5f7b778c870b53cc$var$ButtonBase = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).forwardRef(function ButtonBase(props, ref) {
    var analyticsContext = props.analyticsContext, _props$appearance = props.appearance, appearance = _props$appearance === void 0 ? 'default' : _props$appearance, _props$autoFocus = props.autoFocus, autoFocus = _props$autoFocus === void 0 ? false : _props$autoFocus, buttonCss = props.buttonCss, children = props.children, className = props.className, href = props.href, _props$component = props.component, Component = _props$component === void 0 ? href ? 'a' : 'button' : _props$component, iconAfter = props.iconAfter, iconBefore = props.iconBefore, interactionName = props.interactionName, _props$isDisabled = props.isDisabled, isDisabled = _props$isDisabled === void 0 ? false : _props$isDisabled, _props$isSelected = props.isSelected, isSelected = _props$isSelected === void 0 ? false : _props$isSelected, onBlur = props.onBlur, _props$onClick = props.onClick, providedOnClick = _props$onClick === void 0 ? (0, $adcefb868cf2fc9d$export$2e2bcd8739ae039) : _props$onClick, onFocus = props.onFocus, _props$onMouseDown = props.onMouseDown, providedOnMouseDown = _props$onMouseDown === void 0 ? (0, $adcefb868cf2fc9d$export$2e2bcd8739ae039) : _props$onMouseDown, overlay = props.overlay, shouldFitContainer = props.shouldFitContainer, _props$spacing = props.spacing, spacing = _props$spacing === void 0 ? 'default' : _props$spacing, _props$tabIndex = props.tabIndex, tabIndex = _props$tabIndex === void 0 ? 0 : _props$tabIndex, _props$type = props.type, type = _props$type === void 0 ? !href ? 'button' : undefined : _props$type, testId = props.testId, rest = (0, $230c1601acfa3177$export$2e2bcd8739ae039)(props, $5f7b778c870b53cc$var$_excluded);
    var ourRef = (0, $5FkrB.useRef)();
    var setRef = (0, $5FkrB.useCallback)(function(node) {
        ourRef.current = node;
        if (ref == null) return;
        if (typeof ref === 'function') {
            ref(node);
            return;
        }
        // We can write to ref's `current` property, but Typescript does not like it.
        // @ts-ignore
        ref.current = node;
    }, [
        ourRef,
        ref
    ]);
    // Cross browser auto focusing is pretty broken, so we are doing it ourselves
    (0, $bf3b13d9d73de104$export$2e2bcd8739ae039)(ourRef, autoFocus);
    var interactionContext = (0, $5FkrB.useContext)((0, $153f0305132b5554$export$2e2bcd8739ae039));
    var handleClick = (0, $5FkrB.useCallback)(function(e, analyticsEvent) {
        interactionContext && interactionContext.tracePress(interactionName, e.timeStamp);
        providedOnClick(e, analyticsEvent);
    }, [
        providedOnClick,
        interactionContext,
        interactionName
    ]);
    var onClick = (0, $7d6daf9bcf6c0b57$export$a4687b0234b40e28)({
        fn: handleClick,
        action: 'clicked',
        componentName: 'button',
        packageName: "@atlaskit/button",
        packageVersion: "25.2.1",
        analyticsData: analyticsContext
    });
    // Button currently calls preventDefault, which is not standard button behaviour
    var onMouseDown = (0, $5FkrB.useCallback)(function(event) {
        event.preventDefault();
        providedOnMouseDown(event);
    }, [
        providedOnMouseDown
    ]);
    // Lose focus when becoming disabled (standard button behaviour)
    (0, $5FkrB.useEffect)(function() {
        var el = ourRef.current;
        if (isDisabled && el && el === document.activeElement) el.blur();
    }, [
        isDisabled
    ]);
    // we are 'disabling' input with a button when there is an overlay
    var hasOverlay = Boolean(overlay);
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    var fadeStyles = (0, $2nBsU.css)((0, $5fcca6eb305a9885$export$1b5827d324e945b1)({
        hasOverlay: hasOverlay
    }));
    var isInteractive = !isDisabled && !hasOverlay;
    /**
   * HACK: Spinner needs to have different colours in the "new" tokens design compared to the old design.
   * For now, while we support both, these styles reach into Spinner when a theme is set, applies the right color.
   * Ticket to remove: https://product-fabric.atlassian.net/browse/DSP-2067.
   */ var spinnerHackCss = {};
    if (isSelected || isDisabled || appearance === 'warning') spinnerHackCss = {
        '[data-theme] & circle': {
            stroke: "".concat(isSelected || isDisabled ? "var(--ds-icon-subtle, #505258)" : "var(--ds-icon-warning-inverse, #292A2E)", " !important")
        }
    };
    return (0, $2nBsU.jsx)((0, $ae7f66a126864790$export$2e2bcd8739ae039), null, (0, $2nBsU.jsx)(Component, (0, $bdabb985862bf53b$export$2e2bcd8739ae039)({}, rest, {
        ref: setRef,
        className: className,
        css: [
            buttonCss,
            isInteractive ? null : $5f7b778c870b53cc$var$noPointerEventsOnChildrenCss
        ],
        "data-has-overlay": hasOverlay ? true : undefined,
        "data-testid": testId,
        disabled: isDisabled,
        href: isInteractive ? href : undefined,
        onBlur: onBlur,
        onClick: onClick,
        onFocus: onFocus,
        onMouseDown: onMouseDown,
        tabIndex: isDisabled ? -1 : tabIndex,
        type: type
    }, (0, $af21457669944388$export$2e2bcd8739ae039)({
        isInteractive: isInteractive
    })), iconBefore ? (0, $2nBsU.jsx)("span", {
        css: [
            fadeStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $6d1c53d12ac7a727$export$864eea3f4ec3368f)({
                spacing: spacing
            }),
            $5f7b778c870b53cc$var$getSpacingFix(children, $5f7b778c870b53cc$var$iconBeforeSpacingFixStyle)
        ]
    }, iconBefore) : null, $5f7b778c870b53cc$var$getChildren(children, [
        fadeStyles,
        (0, $e9ed3ba00a3e194a$export$7ad0316cc0dd65a)({
            spacing: spacing
        })
    ]), iconAfter ? (0, $2nBsU.jsx)("span", {
        css: [
            fadeStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $6d1c53d12ac7a727$export$864eea3f4ec3368f)({
                spacing: spacing
            }),
            $5f7b778c870b53cc$var$getSpacingFix(children, $5f7b778c870b53cc$var$iconAfterSpacingFixStyle)
        ]
    }, iconAfter) : null, overlay ? (0, $2nBsU.jsx)("span", {
        css: [
            (0, $8bd7c3c4e645b70a$export$1a9fe1b84c876bb5),
            spinnerHackCss
        ]
    }, overlay) : null));
});
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$5f7b778c870b53cc$export$2e2bcd8739ae039 = $5f7b778c870b53cc$var$ButtonBase;



function $4fdd9d09d2bfaab9$export$2e2bcd8739ae039(_ref) {
    var children = _ref.children, iconBefore = _ref.iconBefore, iconAfter = _ref.iconAfter;
    if ((0, $eb6132b48d587eca$export$20bbd2efb0d734c4)(children)) return true;
    if (children) return false;
    if (iconBefore && !iconAfter) return true;
    if (!iconBefore && iconAfter) return true;
    return false;
}



var $5FkrB = parcelRequire("5FkrB");
/* spinner.tsx generated by @compiled/babel-plugin v2.0.0 */ /**
 * The length of the value hash portion of an atomic class name.
 * Atomic class names have the format: `_<group><value>`
 * where group is ATOMIC_GROUP_HASH_LENGTH chars and value is ATOMIC_VALUE_HASH_LENGTH chars.
 *
 * We extract the group key using: `className.slice(0, className.length - ATOMIC_VALUE_HASH_LENGTH)`
 *
 * We support both old-format classes (9 chars: `_` + 4 group + 4 value) and
 * new-format classes (11 chars: `_` + 6 group + 4 value) by using length-based
 * extraction rather than a hardcoded offset — old and new format group keys
 * are different lengths so they are structurally disjoint and never alias each other.
 */ const $1188eb87a0f9b359$var$ATOMIC_VALUE_HASH_LENGTH = 4;
function $1188eb87a0f9b359$export$2e2bcd8739ae039(classNames) {
    // Shortcut: nothing to do
    if (!classNames.length) return;
    // Shortcut: don't need to do anything if we only have a single classname
    if (classNames.length === 1 && classNames[0] && // checking to see if `classNames[0]` is a string that contains other classnames
    !classNames[0].includes(' ')) return classNames[0];
    // Using an object rather than a `Map` as it performed better in our benchmarks.
    // Would be happy to move to `Map` if it proved to be better under real conditions.
    const map = {};
    // Note: using loops to minimize iterations over the collection
    for (const value of classNames){
        // Exclude all falsy values, which leaves us with populated strings
        if (!value) continue;
        // a `value` can contain multiple classnames
        const list = value.split(' ');
        for (const className of list){
            /**
             * For atomic style classnames: the `key` is the `group`
             *
             * - Later atomic classnames with the same `group` will override earlier ones
             *   (which is what we want).
             * - Assumes atomic classnames are the only things that start with `_`
             * - Could use a regex to ensure that atomic classnames are structured how we expect,
             *   but did not add that for now as it did slow things down a bit.
             *
             * For other classnames: the `key` is the whole classname
             * - Okay to remove duplicates as doing so does not impact specificity
             *
             * */ const key = className.startsWith('_') ? className.slice(0, className.length - $1188eb87a0f9b359$var$ATOMIC_VALUE_HASH_LENGTH) : className;
            map[key] = className;
        }
    }
    /**
     * We are converting the `map` into a string.
     *
     * The simple way to do this would be `Object.values(map).join(' ')`.
     * However, the approach below performs 10%-20% better in benchmarks.
     *
     * For `ax()` it feels right to squeeze as much runtime performance out as we can.
     */ let result = '';
    for(const key in map)result += map[key] + ' ';
    // If we have an empty string, then our `map` was empty.
    if (!result) return;
    // remove last " " from the result (we added " " at the end of every value)
    return result.trimEnd();
}



var $5FkrB = parcelRequire("5FkrB");

var $5FkrB = parcelRequire("5FkrB");
var $8ea3a8e972b171d0$var$interactionContext = /*#__PURE__*/ (0, $5FkrB.createContext)(null);
var $8ea3a8e972b171d0$export$2e2bcd8739ae039 = $8ea3a8e972b171d0$var$interactionContext;


var $b77e143823b2f7d8$export$4e9f1640bbe7a1a8 = {
    xsmall: 12,
    small: 16,
    medium: 24,
    large: 48,
    xlarge: 96
};


/**
 * Returns the appropriate circle stroke color.
 */ function $6f7e5f007cf95a87$var$getStrokeColor(appearance) {
    return appearance === 'inherit' ? "var(--ds-icon-subtle, #505258)" : "var(--ds-icon-inverse, #FFFFFF)";
}
var $6f7e5f007cf95a87$var$rotate = null;
/**
 * There are three parts to the load in animation:
 * 1. Accelerated spin
 * 2. Stretch the spinner line
 */ var $6f7e5f007cf95a87$var$loadIn = null;
var $6f7e5f007cf95a87$var$styles = {
    rotateStyles: "_j7hqsf8s _5sag12kz _tip812c5 _1pgl2qsq _8hrz1h6o",
    loadInStyles: "_j7hq1ky6 _5sag9cwz _1pgl1ytf _1o511hrf",
    wrapperStyles: "_1e0c116y _s7n4nkob",
    circleStyles: "_lswuglyw _7ljx1dhp _1snbbs82 _jcxd7g3v _1tjm1onz"
};
/**
 * `useLayoutEffect` is being used in SSR safe form. On the server, this work doesn’t need to run.
 * `useEffect` is used in-place, because `useEffect` is not run on the server and it matches types
 * which makes things simpler than doing an `isServer` check or a `null` check.
 *
 * @see https://hello.atlassian.net/wiki/spaces/DST/pages/2081696628/DSTDACI-010+-+Interaction+Tracing+hooks+in+DS+components
 */ var $6f7e5f007cf95a87$var$useLayoutEffect = typeof window === 'undefined' ? (0, $5FkrB.useEffect) : (0, $5FkrB.useLayoutEffect);
/**
 * __Spinner__
 *
 * A spinner is an animated spinning icon that lets users know content is being loaded.
 *
 * - [Examples](https://atlassian.design/components/spinner/examples)
 * - [Code](https://atlassian.design/components/spinner/code)
 * - [Usage](https://atlassian.design/components/spinner/usage)
 */ var $6f7e5f007cf95a87$var$Spinner = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).forwardRef(function Spinner(_ref, ref) {
    var _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'inherit' : _ref$appearance, _ref$delay = _ref.delay, delay = _ref$delay === void 0 ? 0 : _ref$delay, interactionName = _ref.interactionName, label = _ref.label, _ref$size = _ref.size, providedSize = _ref$size === void 0 ? 'medium' : _ref$size, testId = _ref.testId;
    var size = typeof providedSize === 'number' ? providedSize : (0, $b77e143823b2f7d8$export$4e9f1640bbe7a1a8)[providedSize];
    var animationDelay = "".concat(delay, "ms");
    var stroke = $6f7e5f007cf95a87$var$getStrokeColor(appearance);
    var context = (0, $5FkrB.useContext)((0, $8ea3a8e972b171d0$export$2e2bcd8739ae039));
    $6f7e5f007cf95a87$var$useLayoutEffect(function() {
        if (context != null) return context.hold(interactionName);
    }, [
        context,
        interactionName
    ]);
    /**
   * The Spinner animation uses a combination of two
   * css animations on two separate elements.
   */ return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("span", {
        "data-testid": testId ? "".concat(testId, "-wrapper") : 'spinner-wrapper',
        style: {
            animationDelay: animationDelay,
            width: size,
            height: size
        },
        className: (0, $1188eb87a0f9b359$export$2e2bcd8739ae039)([
            $6f7e5f007cf95a87$var$styles.wrapperStyles,
            $6f7e5f007cf95a87$var$styles.rotateStyles
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("svg", {
        height: size,
        width: size,
        viewBox: "0 0 16 16",
        xmlns: "http://www.w3.org/2000/svg",
        "data-testid": testId,
        ref: ref,
        "aria-label": label || undefined,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            animationDelay: animationDelay
        },
        role: label ? 'img' : 'none',
        className: (0, $1188eb87a0f9b359$export$2e2bcd8739ae039)([
            $6f7e5f007cf95a87$var$styles.loadInStyles
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("circle", {
        cx: "8",
        cy: "8",
        r: "7",
        style: {
            stroke: stroke
        },
        className: (0, $1188eb87a0f9b359$export$2e2bcd8739ae039)([
            $6f7e5f007cf95a87$var$styles.circleStyles
        ])
    })));
}));
var $6f7e5f007cf95a87$export$2e2bcd8739ae039 = $6f7e5f007cf95a87$var$Spinner;


function $5b2cbb3d7b661df7$var$getSpinnerAppearance(_ref) {
    var appearance = _ref.appearance, isDisabled = _ref.isDisabled, isSelected = _ref.isSelected;
    if (isDisabled) return 'inherit';
    if (isSelected) return 'invert';
    if (appearance === 'primary' || appearance === 'danger') return 'invert';
    return 'inherit';
}
function $5b2cbb3d7b661df7$export$2e2bcd8739ae039(_ref2) {
    var appearance = _ref2.appearance, isDisabled = _ref2.isDisabled, isSelected = _ref2.isSelected, _ref2$spacing = _ref2.spacing, spacing = _ref2$spacing === void 0 ? 'default' : _ref2$spacing;
    var size = spacing === 'default' ? 'medium' : 'small';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $6f7e5f007cf95a87$export$2e2bcd8739ae039), {
        size: size,
        label: ", Loading",
        appearance: $5b2cbb3d7b661df7$var$getSpinnerAppearance({
            appearance: appearance,
            isDisabled: isDisabled,
            isSelected: isSelected
        })
    });
}


// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
function $fbb348df5db62d46$export$437a7f77d13d7916(current, values) {
    return current(values);
}


// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
// This styling approach works by generating a 'style' and applying with maximum specificity
// To do this we are overwriting all pseudo selectors
function $2dc3f8bcebb95279$export$643db0b8d8778e(styles) {
    return {
        '&, &:hover, &:active, &:focus, &:focus-visible, &:visited, &:disabled, &[disabled]': styles
    };
}


// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766




var $50U6m = parcelRequire("50U6m");
function $525d107f97649f51$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $525d107f97649f51$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $525d107f97649f51$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $bd4a332227205a32$export$2e2bcd8739ae039)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $525d107f97649f51$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $525d107f97649f51$var$gridSize = 8;
var $525d107f97649f51$var$HAS_DISABLED_BACKGROUND = [
    'default',
    'primary',
    'danger',
    'warning'
];
var $525d107f97649f51$var$heights = {
    default: "".concat(32 / 14, "em"),
    // 32px
    compact: "".concat(24 / 14, "em"),
    none: 'auto'
};
var $525d107f97649f51$var$lineHeights = {
    default: $525d107f97649f51$var$heights.default,
    compact: $525d107f97649f51$var$heights.compact,
    none: 'inherit'
};
var $525d107f97649f51$var$padding = {
    // 10px gutter
    default: "0 ".concat($525d107f97649f51$var$gridSize + $525d107f97649f51$var$gridSize / 4, "px"),
    compact: "0 ".concat($525d107f97649f51$var$gridSize + $525d107f97649f51$var$gridSize / 4, "px"),
    none: '0'
};
var $525d107f97649f51$var$singleIconPadding = {
    // 2px gutter
    compact: "0 ".concat($525d107f97649f51$var$gridSize / 4, "px"),
    default: "0 ".concat($525d107f97649f51$var$gridSize / 4, "px"),
    none: '0'
};
var $525d107f97649f51$var$verticalAlign = {
    default: 'middle',
    compact: 'middle',
    none: 'baseline'
};
var $525d107f97649f51$var$defaultAfterStyles = {
    borderRadius: 'inherit',
    inset: "var(--ds-space-0, 0px)",
    borderStyle: 'solid',
    borderWidth: "var(--ds-border-width, 1px)",
    pointerEvents: 'none',
    position: 'absolute'
};
var $525d107f97649f51$var$defaultStyles = {
    background: "var(--ds-background-neutral-subtle, #00000000)",
    color: "var(--ds-text, #292A2E)",
    '&::after': $525d107f97649f51$var$_objectSpread($525d107f97649f51$var$_objectSpread({}, $525d107f97649f51$var$defaultAfterStyles), {}, {
        content: '""',
        borderColor: "var(--ds-border, #0B120E24)"
    }),
    '&:hover': {
        background: "var(--ds-background-neutral-hovered, #0B120E24)"
    },
    '&:active': {
        background: "var(--ds-background-neutral-pressed, #080F214A)"
    },
    '&[data-has-overlay="true"]:not([disabled]):hover': {
        background: "var(--ds-background-neutral-subtle, #00000000)"
    },
    '&:disabled[disabled]': {
        background: "var(--ds-background-neutral-subtle, #00000000)"
    },
    '&:disabled[disabled]:hover': {
        background: "var(--ds-background-neutral-subtle, #00000000)"
    },
    '&:disabled[disabled]:active': {
        background: "var(--ds-background-neutral-subtle, #00000000)"
    }
};
var $525d107f97649f51$var$primaryStyles = {
    background: "var(--ds-background-brand-bold, #1868DB)",
    color: "var(--ds-text-inverse, #FFFFFF)",
    '&:hover': {
        background: "var(--ds-background-brand-bold-hovered, #1558BC)"
    },
    '&:active': {
        background: "var(--ds-background-brand-bold-pressed, #144794)"
    },
    '&[data-has-overlay="true"]:not([disabled]):hover': {
        background: "var(--ds-background-brand-bold, #1868DB)"
    }
};
var $525d107f97649f51$var$linkStyles = {
    background: 'transparent',
    color: "var(--ds-link, #1868DB)",
    '&:hover': {
        color: "var(--ds-link, #1868DB)",
        textDecoration: 'underline'
    },
    '&:active': {
        color: "var(--ds-link-pressed, #1558BC)",
        textDecoration: 'underline'
    }
};
var $525d107f97649f51$var$subtleStyles = {
    background: 'transparent',
    color: "var(--ds-text-subtle, #505258)",
    '&:hover': {
        background: "var(--ds-background-neutral-subtle-hovered, #0515240F)"
    },
    '&:active': {
        background: "var(--ds-background-neutral-subtle-pressed, #0B120E24)"
    },
    '&[data-has-overlay="true"]:not([disabled]):hover': {
        background: 'transparent'
    }
};
var $525d107f97649f51$var$subtleLinkStyles = {
    background: 'transparent',
    color: "var(--ds-text-subtle, #505258)",
    '&:hover': {
        background: 'transparent',
        color: "var(--ds-text-subtle, #505258)",
        textDecoration: 'underline'
    },
    '&:active': {
        background: 'transparent',
        color: "var(--ds-text, #292A2E)",
        textDecoration: 'underline'
    }
};
var $525d107f97649f51$var$warningStyles = {
    background: "var(--ds-background-warning-bold, #FBC828)",
    color: "var(--ds-text-warning-inverse, #292A2E)",
    '&:hover': {
        background: "var(--ds-background-warning-bold-hovered, #FCA700)"
    },
    '&:active': {
        background: "var(--ds-background-warning-bold-pressed, #F68909)"
    },
    '&[data-has-overlay="true"]:not([disabled]):hover': {
        background: "var(--ds-background-warning-bold, #FBC828)"
    }
};
var $525d107f97649f51$var$dangerStyles = {
    background: "var(--ds-background-danger-bold, #C9372C)",
    color: "var(--ds-text-inverse, #FFFFFF)",
    '&:hover': {
        background: "var(--ds-background-danger-bold-hovered, #AE2E24)"
    },
    '&:active': {
        background: "var(--ds-background-danger-bold-pressed, #872821)"
    },
    '&[data-has-overlay="true"]:not([disabled]):hover': {
        background: "var(--ds-background-danger-bold, #C9372C)"
    }
};
var $525d107f97649f51$var$selectedStyles = {
    background: "var(--ds-background-selected, #E9F2FE)",
    color: "var(--ds-text-selected, #1868DB)",
    '&:not([disabled])::after': $525d107f97649f51$var$_objectSpread($525d107f97649f51$var$_objectSpread({}, $525d107f97649f51$var$defaultAfterStyles), {}, {
        content: '""',
        borderColor: "var(--ds-border-selected, #1868DB)"
    })
};
/**
 * Anchor-text-color variants applied when the legacy `Button` is rendered as
 * an `<a>` (via `href`). Each `<variant>WithAnchorTextColorStyles` is a
 * self-contained appearance object that adds explicit `color` /
 * `text-decoration` on the base, `:hover`, and `:active` states, preventing
 * browser default or ambient anchor styles from overriding the button's
 * intended text color or adding an unwanted underline.
 *
 * Gated by `platform-dst-legacy-button-anchor-text-color` and used *instead*
 * of the base `<variant>Styles`. When cleaning up the gate: delete the base
 * `<variant>Styles` and rename the `WithAnchorTextColor` variant to replace
 * it.
 *
 * Link-like variants (`link`, `subtle-link`) keep their intentional underline
 * on `:hover` / `:active`.
 */ var $525d107f97649f51$var$defaultWithAnchorTextColorStyles = $525d107f97649f51$var$_objectSpread($525d107f97649f51$var$_objectSpread({}, $525d107f97649f51$var$defaultStyles), {}, {
    textDecoration: 'none',
    '&:hover': $525d107f97649f51$var$_objectSpread($525d107f97649f51$var$_objectSpread({}, $525d107f97649f51$var$defaultStyles['&:hover']), {}, {
        color: "var(--ds-text, #292A2E)",
        textDecoration: 'none'
    }),
    '&:active': $525d107f97649f51$var$_objectSpread($525d107f97649f51$var$_objectSpread({}, $525d107f97649f51$var$defaultStyles['&:active']), {}, {
        color: "var(--ds-text, #292A2E)",
        textDecoration: 'none'
    })
});
var $525d107f97649f51$var$primaryWithAnchorTextColorStyles = $525d107f97649f51$var$_objectSpread($525d107f97649f51$var$_objectSpread({}, $525d107f97649f51$var$primaryStyles), {}, {
    textDecoration: 'none',
    '&:hover': $525d107f97649f51$var$_objectSpread($525d107f97649f51$var$_objectSpread({}, $525d107f97649f51$var$primaryStyles['&:hover']), {}, {
        color: "var(--ds-text-inverse, #FFFFFF)",
        textDecoration: 'none'
    }),
    '&:active': $525d107f97649f51$var$_objectSpread($525d107f97649f51$var$_objectSpread({}, $525d107f97649f51$var$primaryStyles['&:active']), {}, {
        color: "var(--ds-text-inverse, #FFFFFF)",
        textDecoration: 'none'
    })
});
var $525d107f97649f51$var$linkWithAnchorTextColorStyles = $525d107f97649f51$var$_objectSpread($525d107f97649f51$var$_objectSpread({}, $525d107f97649f51$var$linkStyles), {}, {
    textDecoration: 'none'
});
var $525d107f97649f51$var$subtleWithAnchorTextColorStyles = $525d107f97649f51$var$_objectSpread($525d107f97649f51$var$_objectSpread({}, $525d107f97649f51$var$subtleStyles), {}, {
    textDecoration: 'none',
    '&:hover': $525d107f97649f51$var$_objectSpread($525d107f97649f51$var$_objectSpread({}, $525d107f97649f51$var$subtleStyles['&:hover']), {}, {
        color: "var(--ds-text-subtle, #505258)",
        textDecoration: 'none'
    }),
    '&:active': $525d107f97649f51$var$_objectSpread($525d107f97649f51$var$_objectSpread({}, $525d107f97649f51$var$subtleStyles['&:active']), {}, {
        color: "var(--ds-text-subtle, #505258)",
        textDecoration: 'none'
    })
});
var $525d107f97649f51$var$subtleLinkWithAnchorTextColorStyles = $525d107f97649f51$var$_objectSpread($525d107f97649f51$var$_objectSpread({}, $525d107f97649f51$var$subtleLinkStyles), {}, {
    textDecoration: 'none'
});
var $525d107f97649f51$var$warningWithAnchorTextColorStyles = $525d107f97649f51$var$_objectSpread($525d107f97649f51$var$_objectSpread({}, $525d107f97649f51$var$warningStyles), {}, {
    textDecoration: 'none',
    '&:hover': $525d107f97649f51$var$_objectSpread($525d107f97649f51$var$_objectSpread({}, $525d107f97649f51$var$warningStyles['&:hover']), {}, {
        color: "var(--ds-text-warning-inverse, #292A2E)",
        textDecoration: 'none'
    }),
    '&:active': $525d107f97649f51$var$_objectSpread($525d107f97649f51$var$_objectSpread({}, $525d107f97649f51$var$warningStyles['&:active']), {}, {
        color: "var(--ds-text-warning-inverse, #292A2E)",
        textDecoration: 'none'
    })
});
var $525d107f97649f51$var$dangerWithAnchorTextColorStyles = $525d107f97649f51$var$_objectSpread($525d107f97649f51$var$_objectSpread({}, $525d107f97649f51$var$dangerStyles), {}, {
    textDecoration: 'none',
    '&:hover': $525d107f97649f51$var$_objectSpread($525d107f97649f51$var$_objectSpread({}, $525d107f97649f51$var$dangerStyles['&:hover']), {}, {
        color: "var(--ds-text-inverse, #FFFFFF)",
        textDecoration: 'none'
    }),
    '&:active': $525d107f97649f51$var$_objectSpread($525d107f97649f51$var$_objectSpread({}, $525d107f97649f51$var$dangerStyles['&:active']), {}, {
        color: "var(--ds-text-inverse, #FFFFFF)",
        textDecoration: 'none'
    })
});
var $525d107f97649f51$var$hasOverlayStyles = {
    '&[data-has-overlay="true"]': {
        cursor: 'default',
        textDecoration: 'none'
    }
};
function $525d107f97649f51$export$955358618f994a11(_ref) {
    var appearance = _ref.appearance, spacing = _ref.spacing, isSelected = _ref.isSelected, shouldFitContainer = _ref.shouldFitContainer, isOnlySingleIcon = _ref.isOnlySingleIcon;
    var appearanceStyles = (0, $50U6m.fg)('platform-dst-legacy-button-anchor-text-color') ? $525d107f97649f51$var$_objectSpread($525d107f97649f51$var$_objectSpread($525d107f97649f51$var$_objectSpread($525d107f97649f51$var$_objectSpread($525d107f97649f51$var$_objectSpread($525d107f97649f51$var$_objectSpread($525d107f97649f51$var$_objectSpread({}, appearance === 'default' && $525d107f97649f51$var$defaultWithAnchorTextColorStyles), appearance === 'primary' && $525d107f97649f51$var$primaryWithAnchorTextColorStyles), appearance === 'link' && $525d107f97649f51$var$linkWithAnchorTextColorStyles), appearance === 'subtle' && $525d107f97649f51$var$subtleWithAnchorTextColorStyles), appearance === 'subtle-link' && $525d107f97649f51$var$subtleLinkWithAnchorTextColorStyles), appearance === 'warning' && $525d107f97649f51$var$warningWithAnchorTextColorStyles), appearance === 'danger' && $525d107f97649f51$var$dangerWithAnchorTextColorStyles) : $525d107f97649f51$var$_objectSpread($525d107f97649f51$var$_objectSpread($525d107f97649f51$var$_objectSpread($525d107f97649f51$var$_objectSpread($525d107f97649f51$var$_objectSpread($525d107f97649f51$var$_objectSpread($525d107f97649f51$var$_objectSpread({}, appearance === 'default' && $525d107f97649f51$var$defaultStyles), appearance === 'primary' && $525d107f97649f51$var$primaryStyles), appearance === 'link' && $525d107f97649f51$var$linkStyles), appearance === 'subtle' && $525d107f97649f51$var$subtleStyles), appearance === 'subtle-link' && $525d107f97649f51$var$subtleLinkStyles), appearance === 'warning' && $525d107f97649f51$var$warningStyles), appearance === 'danger' && $525d107f97649f51$var$dangerStyles);
    var activeStyles = appearanceStyles['&:active'];
    return $525d107f97649f51$var$_objectSpread($525d107f97649f51$var$_objectSpread({
        // 0px margin added to css-reset
        alignItems: 'baseline',
        borderWidth: 0,
        borderRadius: (0, $50U6m.fg)('platform-dst-shape-theme-default') ? "var(--ds-radius-medium, 6px)" : "var(--ds-radius-small, 3px)",
        boxSizing: 'border-box',
        display: 'inline-flex',
        fontSize: 'inherit',
        fontStyle: 'normal',
        // Chrome recently changed button so that they use 'arial' as the font family
        fontFamily: 'inherit',
        fontWeight: "var(--ds-font-weight-medium, 500)",
        // margin for button has been applied to css reset
        maxWidth: '100%',
        // Needed to position overlay
        position: 'relative',
        textAlign: 'center',
        textDecoration: 'none',
        transition: (0, $50U6m.fg)('platform-dst-motion-uplift-button') ? "var(--ds-button-hovered, background-color border-color 150ms cubic-bezier(0.4, 1, 0.6, 1))".concat(", box-shadow 0.15s cubic-bezier(0.47, 0.03, 0.49, 1.38)") : 'background 0.1s ease-out, box-shadow 0.15s cubic-bezier(0.47, 0.03, 0.49, 1.38)',
        whiteSpace: 'nowrap',
        cursor: 'pointer',
        height: $525d107f97649f51$var$heights[spacing],
        lineHeight: $525d107f97649f51$var$lineHeights[spacing],
        padding: isOnlySingleIcon ? $525d107f97649f51$var$singleIconPadding[spacing] : $525d107f97649f51$var$padding[spacing],
        verticalAlign: $525d107f97649f51$var$verticalAlign[spacing],
        width: shouldFitContainer ? '100%' : 'auto',
        // justifyContent required for shouldFitContainer buttons with an icon inside
        justifyContent: 'center'
    }, isSelected ? $525d107f97649f51$var$selectedStyles : $525d107f97649f51$var$_objectSpread($525d107f97649f51$var$_objectSpread($525d107f97649f51$var$_objectSpread({}, appearanceStyles), activeStyles && (0, $50U6m.fg)('platform-dst-motion-uplift-button') && {
        '&:active': $525d107f97649f51$var$_objectSpread($525d107f97649f51$var$_objectSpread({}, activeStyles), {}, {
            transition: "var(--ds-button-pressed, background-color border-color 150ms cubic-bezier(0.4, 1, 0.6, 1))"
        })
    }), {}, {
        '&[disabled]': {
            color: "var(--ds-text-disabled, #080F214A)",
            backgroundColor: $525d107f97649f51$var$HAS_DISABLED_BACKGROUND.includes(appearance) ? "var(--ds-background-disabled, #0515240F)" : 'transparent',
            cursor: 'not-allowed',
            textDecoration: 'none',
            '&:hovered': {
                backgroundColor: $525d107f97649f51$var$HAS_DISABLED_BACKGROUND.includes(appearance) ? "var(--ds-background-disabled, #0515240F)" : 'transparent'
            },
            '&:active': {
                backgroundColor: $525d107f97649f51$var$HAS_DISABLED_BACKGROUND.includes(appearance) ? "var(--ds-background-disabled, #0515240F)" : 'transparent'
            }
        }
    }, $525d107f97649f51$var$hasOverlayStyles)), {}, {
        '&::-moz-focus-inner': {
            border: 0,
            margin: 0,
            padding: 0
        }
    });
}


function $aff16366337b085e$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $aff16366337b085e$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $aff16366337b085e$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $bd4a332227205a32$export$2e2bcd8739ae039)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $aff16366337b085e$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $aff16366337b085e$var$stateToSelectorMap = {
    focus: '&:focus',
    focusSelected: '&:focus',
    hover: '&:hover',
    active: '&:active',
    disabled: '&[disabled]'
};
function $aff16366337b085e$export$31512de7fa606fa4(_ref) {
    var _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'default' : _ref$appearance, _ref$spacing = _ref.spacing, spacing = _ref$spacing === void 0 ? 'default' : _ref$spacing, _ref$isSelected = _ref.isSelected, isSelected = _ref$isSelected === void 0 ? false : _ref$isSelected, _ref$shouldFitContain = _ref.shouldFitContainer, shouldFitContainer = _ref$shouldFitContain === void 0 ? false : _ref$shouldFitContain, _ref$iconIsOnlyChild = _ref.iconIsOnlyChild, iconIsOnlyChild = _ref$iconIsOnlyChild === void 0 ? false : _ref$iconIsOnlyChild, _ref$isLoading = _ref.isLoading, isLoading = _ref$isLoading === void 0 ? false : _ref$isLoading, state = _ref.state;
    var result = (0, $525d107f97649f51$export$955358618f994a11)({
        appearance: appearance,
        spacing: spacing,
        isSelected: isSelected,
        shouldFitContainer: shouldFitContainer,
        isOnlySingleIcon: iconIsOnlyChild
    });
    // we need to disable the default browser focus styles always
    // this is because we are not expressing that we can have two pseudo states at a time
    result.outline = 'none';
    // Pulling relevant styles up to the top level
    var selector = $aff16366337b085e$var$stateToSelectorMap[state];
    if (selector) result = $aff16366337b085e$var$_objectSpread($aff16366337b085e$var$_objectSpread({}, result), result[selector]);
    if (isLoading) result = $aff16366337b085e$var$_objectSpread($aff16366337b085e$var$_objectSpread({}, result), result['&[data-has-overlay="true"]']);
    // Delete all selectors and just keep root styles
    Object.keys(result).forEach(function(key) {
        // want to keep this one
        if (key === '&::-moz-focus-inner') return;
        // Not using .startsWith for ie11
        if (key.indexOf('&') === 0) delete result[key];
    });
    return result;
}


var $a3988abed06d3f6c$var$Theme = (0, $d55244cb311b88fe$export$25d302a5b900a763)(function(themeProps) {
    return {
        buttonStyles: (0, $aff16366337b085e$export$31512de7fa606fa4)(themeProps),
        // No styles being applied directly to spinner by default
        // Keeping this for legacy compat. We could remove it, but given
        // that we are changing theme soon there is no point
        spinnerStyles: {}
    };
});
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$a3988abed06d3f6c$export$2e2bcd8739ae039 = $a3988abed06d3f6c$var$Theme;


var $079ca7802c1bfb5a$var$_excluded = [
    "appearance",
    "autoFocus",
    "isDisabled",
    "isSelected",
    "shouldFitContainer",
    "spacing",
    "isLoading",
    "onMouseEnter",
    "onMouseLeave",
    "onMouseDown",
    "onMouseUp",
    "onFocus",
    "onBlur",
    "theme"
];
function $079ca7802c1bfb5a$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $079ca7802c1bfb5a$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $079ca7802c1bfb5a$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $bd4a332227205a32$export$2e2bcd8739ae039)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $079ca7802c1bfb5a$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $079ca7802c1bfb5a$var$getInteractionState(_ref) {
    var _ref$isDisabled = _ref.isDisabled, isDisabled = _ref$isDisabled === void 0 ? false : _ref$isDisabled, _ref$isActive = _ref.isActive, isActive = _ref$isActive === void 0 ? false : _ref$isActive, _ref$isFocus = _ref.isFocus, isFocus = _ref$isFocus === void 0 ? false : _ref$isFocus, _ref$isHover = _ref.isHover, isHover = _ref$isHover === void 0 ? false : _ref$isHover, _ref$isSelected = _ref.isSelected, isSelected = _ref$isSelected === void 0 ? false : _ref$isSelected, _ref$isLoading = _ref.isLoading, isLoading = _ref$isLoading === void 0 ? false : _ref$isLoading;
    if (isDisabled) return 'disabled';
    if (isSelected && isFocus) return 'focusSelected';
    if (isSelected) return 'selected';
    // not allowing active or focus style changes while loading
    if (!isLoading && isActive) return 'active';
    if (!isLoading && isHover) return 'hover';
    if (isFocus) return 'focus';
    return 'default';
}
var $079ca7802c1bfb5a$var$initial = {
    isHover: false,
    isActive: false,
    isFocus: false
};
/**
 * __Custom theme button__
 *
 * @deprecated Legacy buttons are deprecated and will be removed from `atlaskit/button` in an upcoming major release. Please use `Button` from `@atlaskit/button/default/button`.
 *
 * Please refer to the [migration guide](https://atlassian.design/components/button/button-legacy/migration-guide) for further details.
 *
 * A custom theme button. Avoid using this component. It exists for those already using custom theming, which is hard to use and has performance issues.
 *
 * - [Examples](https://atlassian.design/components/button/examples#custom-theme-button)
 */ var $079ca7802c1bfb5a$var$CustomThemeButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).forwardRef(function CustomThemeButton(_ref2, ref) {
    var _ref2$appearance = _ref2.appearance, appearance = _ref2$appearance === void 0 ? 'default' : _ref2$appearance, _ref2$autoFocus = _ref2.autoFocus, autoFocus = _ref2$autoFocus === void 0 ? false : _ref2$autoFocus, _ref2$isDisabled = _ref2.isDisabled, isDisabled = _ref2$isDisabled === void 0 ? false : _ref2$isDisabled, _ref2$isSelected = _ref2.isSelected, isSelected = _ref2$isSelected === void 0 ? false : _ref2$isSelected, _ref2$shouldFitContai = _ref2.shouldFitContainer, shouldFitContainer = _ref2$shouldFitContai === void 0 ? false : _ref2$shouldFitContai, _ref2$spacing = _ref2.spacing, spacing = _ref2$spacing === void 0 ? 'default' : _ref2$spacing, _ref2$isLoading = _ref2.isLoading, isLoading = _ref2$isLoading === void 0 ? false : _ref2$isLoading, providedOnMouseEnter = _ref2.onMouseEnter, providedOnMouseLeave = _ref2.onMouseLeave, providedOnMouseDown = _ref2.onMouseDown, providedOnMouseUp = _ref2.onMouseUp, providedOnFocus = _ref2.onFocus, providedOnBlur = _ref2.onBlur, _ref2$theme = _ref2.theme, theme = _ref2$theme === void 0 ? (0, $fbb348df5db62d46$export$437a7f77d13d7916) : _ref2$theme, rest = (0, $230c1601acfa3177$export$2e2bcd8739ae039)(_ref2, $079ca7802c1bfb5a$var$_excluded);
    // TODO is there a nicer way to do this?
    // Add default props back into object for spreading
    var restProps = $079ca7802c1bfb5a$var$_objectSpread({
        appearance: appearance,
        autoFocus: autoFocus,
        isDisabled: isDisabled,
        isSelected: isSelected,
        shouldFitContainer: shouldFitContainer,
        spacing: spacing
    }, rest);
    var _useState = (0, $5FkrB.useState)($079ca7802c1bfb5a$var$initial), _useState2 = (0, $a004a50eecd8ae97$export$2e2bcd8739ae039)(_useState, 2), state = _useState2[0], setState = _useState2[1];
    var onMouseEnter = (0, $5FkrB.useCallback)(function(event) {
        setState(function(current) {
            return $079ca7802c1bfb5a$var$_objectSpread($079ca7802c1bfb5a$var$_objectSpread({}, current), {}, {
                isHover: true
            });
        });
        if (providedOnMouseEnter) providedOnMouseEnter(event);
    }, [
        providedOnMouseEnter
    ]);
    var onMouseLeave = (0, $5FkrB.useCallback)(function(event) {
        setState(function(current) {
            return $079ca7802c1bfb5a$var$_objectSpread($079ca7802c1bfb5a$var$_objectSpread({}, current), {}, {
                isHover: false,
                isActive: false
            });
        });
        if (providedOnMouseLeave) providedOnMouseLeave(event);
    }, [
        providedOnMouseLeave
    ]);
    var onMouseDown = (0, $5FkrB.useCallback)(function(event) {
        setState(function(current) {
            return $079ca7802c1bfb5a$var$_objectSpread($079ca7802c1bfb5a$var$_objectSpread({}, current), {}, {
                isActive: true
            });
        });
        if (providedOnMouseDown) providedOnMouseDown(event);
    }, [
        providedOnMouseDown
    ]);
    var onMouseUp = (0, $5FkrB.useCallback)(function(event) {
        setState(function(current) {
            return $079ca7802c1bfb5a$var$_objectSpread($079ca7802c1bfb5a$var$_objectSpread({}, current), {}, {
                isActive: false
            });
        });
        if (providedOnMouseUp) providedOnMouseUp(event);
    }, [
        providedOnMouseUp
    ]);
    var onFocus = (0, $5FkrB.useCallback)(function(event) {
        setState(function(current) {
            return $079ca7802c1bfb5a$var$_objectSpread($079ca7802c1bfb5a$var$_objectSpread({}, current), {}, {
                isFocus: true
            });
        });
        if (providedOnFocus) providedOnFocus(event);
    }, [
        providedOnFocus
    ]);
    var onBlur = (0, $5FkrB.useCallback)(function(event) {
        setState(function(current) {
            return $079ca7802c1bfb5a$var$_objectSpread($079ca7802c1bfb5a$var$_objectSpread({}, current), {}, {
                isFocus: false
            });
        });
        if (providedOnBlur) providedOnBlur(event);
    }, [
        providedOnBlur
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $a3988abed06d3f6c$export$2e2bcd8739ae039).Provider, {
        value: theme
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $6e1f8f60750fb56d$export$2e2bcd8739ae039).Consumer, null, function(_ref3) {
        var mode = _ref3.mode;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $a3988abed06d3f6c$export$2e2bcd8739ae039).Consumer, (0, $bdabb985862bf53b$export$2e2bcd8739ae039)({
            mode: mode,
            state: $079ca7802c1bfb5a$var$getInteractionState($079ca7802c1bfb5a$var$_objectSpread($079ca7802c1bfb5a$var$_objectSpread({}, state), {}, {
                isLoading: isLoading,
                isSelected: restProps.isSelected,
                isDisabled: restProps.isDisabled
            })),
            iconIsOnlyChild: (0, $4fdd9d09d2bfaab9$export$2e2bcd8739ae039)(restProps),
            isLoading: isLoading
        }, restProps), function(_ref4) {
            var buttonStyles = _ref4.buttonStyles;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $5f7b778c870b53cc$export$2e2bcd8739ae039), (0, $bdabb985862bf53b$export$2e2bcd8739ae039)({}, restProps, {
                ref: ref,
                overlay: isLoading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $5b2cbb3d7b661df7$export$2e2bcd8739ae039), restProps) : null,
                "aria-disabled": isLoading || restProps['aria-disabled'],
                onMouseEnter: onMouseEnter,
                onMouseLeave: onMouseLeave,
                onMouseDown: onMouseDown,
                onMouseUp: onMouseUp,
                onFocus: onFocus,
                onBlur: onBlur,
                buttonCss: (0, $2dc3f8bcebb95279$export$643db0b8d8778e)(buttonStyles)
            }));
        });
    }));
}));
// Tools including enzyme rely on components having a display name
$079ca7802c1bfb5a$var$CustomThemeButton.displayName = 'CustomThemeButton';
var $079ca7802c1bfb5a$export$2e2bcd8739ae039 = $079ca7802c1bfb5a$var$CustomThemeButton;


/* tooltip.tsx generated by @compiled/babel-plugin v2.0.0 */ function $00d9cef35b686d13$export$2e2bcd8739ae039() {
    return $00d9cef35b686d13$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $00d9cef35b686d13$export$2e2bcd8739ae039.apply(null, arguments);
}


function $3b92b7ab65ed9350$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return r;
}


function $2182bd6bb14618d6$export$2e2bcd8739ae039(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}


function $99aafda47df47598$export$2e2bcd8739ae039(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}


function $740d51cc152e80e2$export$2e2bcd8739ae039(r, a) {
    if (r) {
        if ("string" == typeof r) return (0, $99aafda47df47598$export$2e2bcd8739ae039)(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? (0, $99aafda47df47598$export$2e2bcd8739ae039)(r, a) : void 0;
    }
}


function $9621393aace7d75c$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}


function $10458117b712c01e$export$2e2bcd8739ae039(r, e) {
    return (0, $3b92b7ab65ed9350$export$2e2bcd8739ae039)(r) || (0, $2182bd6bb14618d6$export$2e2bcd8739ae039)(r, e) || (0, $740d51cc152e80e2$export$2e2bcd8739ae039)(r, e) || (0, $9621393aace7d75c$export$2e2bcd8739ae039)();
}


function $e0da0b6fc92b7de7$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $e0da0b6fc92b7de7$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $e0da0b6fc92b7de7$export$2e2bcd8739ae039(o);
}



function $ebbfb0f561a105ad$export$2e2bcd8739ae039(t, r) {
    if ("object" != (0, $e0da0b6fc92b7de7$export$2e2bcd8739ae039)(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (0, $e0da0b6fc92b7de7$export$2e2bcd8739ae039)(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}


function $03ba24f11b7522e6$export$2e2bcd8739ae039(t) {
    var i = (0, $ebbfb0f561a105ad$export$2e2bcd8739ae039)(t, "string");
    return "symbol" == (0, $e0da0b6fc92b7de7$export$2e2bcd8739ae039)(i) ? i : i + "";
}


function $cafa94341993c43e$export$2e2bcd8739ae039(e, r, t) {
    return (r = (0, $03ba24f11b7522e6$export$2e2bcd8739ae039)(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}




var $5FkrB = parcelRequire("5FkrB");



var $5FkrB = parcelRequire("5FkrB");


function $290fa485630d1395$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $290fa485630d1395$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $290fa485630d1395$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $0b2d8b20b765b25f$export$2e2bcd8739ae039)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $290fa485630d1395$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $290fa485630d1395$export$1a04351537078b55(_ref) {
    var fn = _ref.fn, action = _ref.action, componentName = _ref.componentName, packageName = _ref.packageName, packageVersion = _ref.packageVersion, analyticsData = _ref.analyticsData;
    var _useAnalyticsEvents = (0, $879f28ba40c47674$export$5bf35293e545f20c)(), createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
    // We put analyticsData and fn in a ref so that we don't need to break
    // memoization.
    // Generally these could be defined by consumers inline
    // and so we do this to avoid breaking memoization of useCallback
    var dataRef = (0, $90d091140a6cc984$export$1d27a74659855e44)(analyticsData);
    var fnRef = (0, $90d091140a6cc984$export$1d27a74659855e44)(fn);
    var handler = (0, $5FkrB.useCallback)(function() {
        var analyticsEvent = createAnalyticsEvent({
            action: action,
            actionSubject: componentName,
            attributes: {
                componentName: componentName,
                packageName: packageName,
                packageVersion: packageVersion
            }
        });
        // To avoid wrapping this component in AnalyticsContext we manually
        // push the parent context's meta data into the context.
        // Note: this new 'context'
        var context = $290fa485630d1395$var$_objectSpread({
            componentName: componentName,
            packageName: packageName,
            packageVersion: packageVersion
        }, dataRef.current);
        analyticsEvent.context.push(context);
        // fire an event on the atlaskit channel
        var clone = analyticsEvent.clone();
        if (clone) clone.fire('atlaskit');
        fnRef.current(analyticsEvent);
    }, [
        // These are strings and won't change
        action,
        componentName,
        packageName,
        packageVersion,
        // This function is memoized in the context
        createAnalyticsEvent,
        // these are a stable ref because of the useTrackedRef hook
        dataRef,
        fnRef
    ]);
    return handler;
}




var $5FkrB = parcelRequire("5FkrB");

/**
 * Character key codes which can be used in keyboard events.
 */ var $f8dc452a9f988247$export$390330c10ff2b9a1 = 'ArrowUp';
var $f8dc452a9f988247$export$a80636c6f41931fe = 'ArrowDown';
var $f8dc452a9f988247$export$fc4577f2a2af0ae3 = 'ArrowLeft';
var $f8dc452a9f988247$export$c40f9845adc73fb5 = 'ArrowRight';
var $f8dc452a9f988247$export$4af703091671bc = 'Home';
var $f8dc452a9f988247$export$e2bc30913faa5db7 = 'End';
var $f8dc452a9f988247$export$10f6869ed0a7d75b = 'Tab';
var $f8dc452a9f988247$export$8152f929a25a0ff4 = 'Enter';
var $f8dc452a9f988247$export$e51a3576c045c8d5 = 'Space';
var $f8dc452a9f988247$export$2bb790b9008907b4 = 'Escape';


function $cc68d04423a653c6$export$2e2bcd8739ae039(_ref) {
    var onClose = _ref.onClose, isDisabled = _ref.isDisabled;
    var escapePressed = (0, $5FkrB.useRef)(false);
    var onKeyDown = (0, $5FkrB.useCallback)(function(e) {
        if (isDisabled || escapePressed.current || e.key !== (0, $f8dc452a9f988247$export$2bb790b9008907b4)) // We're either already handling the key down event or it's not escape.
        // Bail early!
        return;
        escapePressed.current = true;
        onClose(e);
    }, [
        onClose,
        isDisabled
    ]);
    var onKeyUp = (0, $5FkrB.useCallback)(function() {
        escapePressed.current = false;
    }, []);
    (0, $5FkrB.useEffect)(function() {
        // Don't attach document event listeners if the hook is disabled
        if (isDisabled) return;
        return (0, $5b617c1f48263075$exports.bindAll)(document, [
            {
                type: 'keydown',
                listener: onKeyDown
            },
            {
                type: 'keyup',
                listener: onKeyUp
            }
        ], {
            capture: false
        });
    }, [
        onKeyDown,
        onKeyUp,
        isDisabled
    ]);
}



var $5FkrB = parcelRequire("5FkrB");
function $2da2c910992d9a40$export$2e2bcd8739ae039(value) {
    var ref = (0, $5FkrB.useRef)(value);
    (0, $5FkrB.useEffect)(function() {
        ref.current = value;
    }, [
        value
    ]);
    return ref;
}





var $5FkrB = parcelRequire("5FkrB");
/* keyframes-motion.tsx generated by @compiled/babel-plugin v2.0.0 */ 

var $5FkrB = parcelRequire("5FkrB");

/**
 * Think of this as the motion equivalent of the @atlaskit/theme `grid()`.
 */ var $a81000281e311a76$export$368bacef0dacbe05 = 25;
var $a81000281e311a76$export$38b928a7167ce124 = {
    none: 0,
    small: 100,
    medium: 350,
    large: 700
};



/**
 * Used to multiply the initial duration for exiting motions.
 */ var $83026a692512f566$var$EXITING_MOTION_MULTIPLIER = 0.5;
var $83026a692512f566$export$30fa1a2e62ae150c = {
    none: (0, $a81000281e311a76$export$38b928a7167ce124).none,
    small: (0, $a81000281e311a76$export$38b928a7167ce124).small * $83026a692512f566$var$EXITING_MOTION_MULTIPLIER,
    medium: (0, $a81000281e311a76$export$38b928a7167ce124).medium * $83026a692512f566$var$EXITING_MOTION_MULTIPLIER,
    large: (0, $a81000281e311a76$export$38b928a7167ce124).large * $83026a692512f566$var$EXITING_MOTION_MULTIPLIER
};




var $5FkrB = parcelRequire("5FkrB");
// Handle both browser and Node.js environments
var $6c96e52e57c436a4$var$getHookDeps = function getHookDeps(opts) {
    switch(opts.cleanup){
        case 'next-effect':
            return undefined;
        case 'unmount':
        default:
            return [];
    }
};
var $6c96e52e57c436a4$export$4f34107a2b00f39c = function useSetTimeout() {
    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        cleanup: 'unmount'
    };
    var timeouts = (0, $5FkrB.useRef)([]);
    (0, $5FkrB.useEffect)(function() {
        return function() {
            if (timeouts.current.length) {
                timeouts.current.forEach(function(id) {
                    return clearTimeout(id);
                });
                timeouts.current = [];
            }
        };
    // We dynamically set this so we either clean up on the next effect - or on unmount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, $6c96e52e57c436a4$var$getHookDeps(opts));
    return (0, $5FkrB.useCallback)(function(handler, timeout) {
        for(var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)args[_key - 2] = arguments[_key];
        var id = setTimeout.apply(void 0, [
            function() {
                timeouts.current = timeouts.current.filter(function(timeoutId) {
                    return timeoutId !== id;
                });
                handler();
            },
            timeout
        ].concat(args));
        timeouts.current.push(id);
    }, []);
};




var $b4f4bca1dbeb6cba$var$zoomIn = null;
var $b4f4bca1dbeb6cba$var$zoomOut = null;
var $b4f4bca1dbeb6cba$var$fadeIn = null;
var $b4f4bca1dbeb6cba$var$fadeOut = null;
var $b4f4bca1dbeb6cba$var$fadeInFromTop = null;
var $b4f4bca1dbeb6cba$var$fadeOutFromTop = null;
var $b4f4bca1dbeb6cba$var$fadeInFromLeft = null;
var $b4f4bca1dbeb6cba$var$fadeOutFromLeft = null;
var $b4f4bca1dbeb6cba$var$fadeInFromBottom = null;
var $b4f4bca1dbeb6cba$var$fadeOutFromBottom = null;
var $b4f4bca1dbeb6cba$var$fadeInFromRight = null;
var $b4f4bca1dbeb6cba$var$fadeOutFromRight = null;
var $b4f4bca1dbeb6cba$var$fadeInFromTopConstant = null;
var $b4f4bca1dbeb6cba$var$fadeOutFromTopConstant = null;
var $b4f4bca1dbeb6cba$var$fadeInFromLeftConstant = null;
var $b4f4bca1dbeb6cba$var$fadeOutFromLeftConstant = null;
var $b4f4bca1dbeb6cba$var$fadeInFromBottomConstant = null;
var $b4f4bca1dbeb6cba$var$fadeOutFromBottomConstant = null;
var $b4f4bca1dbeb6cba$var$fadeInFromRightConstant = null;
var $b4f4bca1dbeb6cba$var$fadeOutFromRightConstant = null;
var $b4f4bca1dbeb6cba$var$slideInFromTop = null;
var $b4f4bca1dbeb6cba$var$slideOutFromTop = null;
var $b4f4bca1dbeb6cba$var$slideInFromRight = null;
var $b4f4bca1dbeb6cba$var$slideOutFromRight = null;
var $b4f4bca1dbeb6cba$var$slideInFromBottom = null;
var $b4f4bca1dbeb6cba$var$slideOutFromBottom = null;
var $b4f4bca1dbeb6cba$var$slideInFromLeft = null;
var $b4f4bca1dbeb6cba$var$slideOutFromLeft = null;
/**
 * These are props that motions should use as their external props for consumers.
 * See [FadeIn](packages/helpers/motion/src/entering/fade-in.tsx) for an example usage.
 */ /**
 * This is the base INTERNAL component used for all other entering motions.
 * This does not need Javascript to execute on the client so it will run immediately
 * for any SSR rendered React apps before the JS has executed.
 */ var $b4f4bca1dbeb6cba$var$EnteringMotion = function EnteringMotion(_ref) {
    var children = _ref.children, animationTimingFunction = _ref.animationTimingFunction, _ref$animationTimingF = _ref.animationTimingFunctionExiting, animationTimingFunctionExiting = _ref$animationTimingF === void 0 ? animationTimingFunction : _ref$animationTimingF, enteringAnimation = _ref.enteringAnimation, _ref$exitingAnimation = _ref.exitingAnimation, exitingAnimation = _ref$exitingAnimation === void 0 ? enteringAnimation : _ref$exitingAnimation, isPaused = _ref.isPaused, onFinishMotion = _ref.onFinish, _ref$duration = _ref.duration, duration = _ref$duration === void 0 ? 'large' : _ref$duration;
    var staggered = (0, $fc97ddeced05433d$export$25c7213fc07ec080)();
    var _useExitingPersistenc = (0, $7859f3cad9bf15af$export$3b6f38abbdcbd000)(), isExiting = _useExitingPersistenc.isExiting, onExitFinished = _useExitingPersistenc.onFinish, appear = _useExitingPersistenc.appear;
    var setTimeout = (0, $6c96e52e57c436a4$export$4f34107a2b00f39c)();
    var paused = isPaused || !staggered.isReady;
    var delay = isExiting ? 0 : staggered.delay;
    var state = isExiting ? 'exiting' : 'entering';
    var _useState = (0, $5FkrB.useState)(appear), _useState2 = (0, $b0c829b9b1926339$export$2e2bcd8739ae039)(_useState, 2), hasAnimationStyles = _useState2[0], setHasAnimationStyles = _useState2[1];
    (0, $5FkrB.useEffect)(function() {
        // Tracking this to prevent changing state on an unmounted component
        var isCancelled = false;
        if (paused) return;
        // On initial mount if elements aren't set to animate on appear, we return early and callback
        if (!appear) {
            onFinishMotion && onFinishMotion(state);
            return;
        }
        /**
     * Updates relevant state.
     * Called when the animation is finished, or immediately with reduced motion.
     */ var onAnimationEnd = function onAnimationEnd() {
            if (state === 'exiting') // Updates the `ExitingPersistence` to remove this child
            onExitFinished === null || onExitFinished === void 0 || onExitFinished();
            if (!isCancelled) setHasAnimationStyles(false);
            onFinishMotion === null || onFinishMotion === void 0 || onFinishMotion(state);
        };
        if ((0, $c13dcba1845ee9f2$export$b7baf7667a68d87c)()) {
            // If there is reduced motion there is no exit animation, so call this immediately
            onAnimationEnd();
            return;
        }
        // Elements may need animation styles back after initial mount (they could animate out)
        setHasAnimationStyles(true);
        // Queue `onAnimationEnd` for after the animation has finished
        setTimeout(onAnimationEnd, isExiting ? (0, $83026a692512f566$export$30fa1a2e62ae150c)[duration] : (0, $a81000281e311a76$export$38b928a7167ce124)[duration] + delay);
        return function() {
            isCancelled = true;
        };
    // We ignore this for onFinishMotion as consumers could potentially inline the function
    // which would then trigger this effect every re-render.
    // We want to make it easier for consumers so we go down this path unfortunately.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        onExitFinished,
        state,
        isExiting,
        duration,
        delay,
        paused,
        setTimeout
    ]);
    return children({
        ref: staggered.ref,
        // @ts-expect-error: `ax` is not typed correctly
        className: hasAnimationStyles ? (0, $18568cedb3bf28ca$export$2e2bcd8739ae039)([
            (0, $18568cedb3bf28ca$export$2e2bcd8739ae039)([
                "_1o51eoah _1y0co91m _1bumglyw _sedtglyw"
            ]),
            paused && (0, $18568cedb3bf28ca$export$2e2bcd8739ae039)([
                "_1y0ctrqk"
            ]),
            duration === 'small' && (0, $18568cedb3bf28ca$export$2e2bcd8739ae039)([
                "_5sag1yx9"
            ]),
            duration === 'medium' && (0, $18568cedb3bf28ca$export$2e2bcd8739ae039)([
                "_5sag1ttt"
            ]),
            duration === 'large' && (0, $18568cedb3bf28ca$export$2e2bcd8739ae039)([
                "_5sagpwmj"
            ]),
            isExiting && duration === 'small' && (0, $18568cedb3bf28ca$export$2e2bcd8739ae039)([
                "_5sag14ed"
            ]),
            isExiting && duration === 'medium' && (0, $18568cedb3bf28ca$export$2e2bcd8739ae039)([
                "_5sagluct"
            ]),
            isExiting && duration === 'large' && (0, $18568cedb3bf28ca$export$2e2bcd8739ae039)([
                "_5sag1ttt"
            ]),
            isExiting && (0, $18568cedb3bf28ca$export$2e2bcd8739ae039)([
                "_ju255cps _1o51q7pw"
            ]),
            !isExiting && animationTimingFunction === 'linear' && (0, $18568cedb3bf28ca$export$2e2bcd8739ae039)([
                "_1pglp3kn"
            ]),
            !isExiting && animationTimingFunction === 'ease-out' && (0, $18568cedb3bf28ca$export$2e2bcd8739ae039)([
                "_1pgldkwg"
            ]),
            !isExiting && animationTimingFunction === 'ease-in' && (0, $18568cedb3bf28ca$export$2e2bcd8739ae039)([
                "_1pgl1nzg"
            ]),
            !isExiting && animationTimingFunction === 'ease-in-40-out' && (0, $18568cedb3bf28ca$export$2e2bcd8739ae039)([
                "_1pgl5y64"
            ]),
            !isExiting && animationTimingFunction === 'ease-in-60-out' && (0, $18568cedb3bf28ca$export$2e2bcd8739ae039)([
                "_1pgl1ddy"
            ]),
            !isExiting && animationTimingFunction === 'ease-in-80-out' && (0, $18568cedb3bf28ca$export$2e2bcd8739ae039)([
                "_1pglannl"
            ]),
            !isExiting && animationTimingFunction === 'ease-in-out' && (0, $18568cedb3bf28ca$export$2e2bcd8739ae039)([
                "_1pgl1fu8"
            ]),
            isExiting && animationTimingFunction === 'linear' && (0, $18568cedb3bf28ca$export$2e2bcd8739ae039)([
                "_1pglp3kn"
            ]),
            isExiting && animationTimingFunctionExiting === 'ease-out' && (0, $18568cedb3bf28ca$export$2e2bcd8739ae039)([
                "_1pgldkwg"
            ]),
            isExiting && animationTimingFunctionExiting === 'ease-in' && (0, $18568cedb3bf28ca$export$2e2bcd8739ae039)([
                "_1pgl1nzg"
            ]),
            isExiting && animationTimingFunctionExiting === 'ease-in-40-out' && (0, $18568cedb3bf28ca$export$2e2bcd8739ae039)([
                "_1pgl5y64"
            ]),
            isExiting && animationTimingFunctionExiting === 'ease-in-60-out' && (0, $18568cedb3bf28ca$export$2e2bcd8739ae039)([
                "_1pgl1ddy"
            ]),
            isExiting && animationTimingFunctionExiting === 'ease-in-80-out' && (0, $18568cedb3bf28ca$export$2e2bcd8739ae039)([
                "_1pglannl"
            ]),
            isExiting && animationTimingFunctionExiting === 'ease-in-out' && (0, $18568cedb3bf28ca$export$2e2bcd8739ae039)([
                "_1pgl1fu8"
            ]),
            (!isExiting && enteringAnimation === 'fade-in' || isExiting && exitingAnimation === 'fade-in') && (0, $18568cedb3bf28ca$export$2e2bcd8739ae039)([
                "_j7hq1cgr"
            ]),
            (!isExiting && enteringAnimation === 'fade-out' || isExiting && exitingAnimation === 'fade-out') && (0, $18568cedb3bf28ca$export$2e2bcd8739ae039)([
                "_j7hq1lln"
            ]),
            (!isExiting && enteringAnimation === 'zoom-in' || isExiting && exitingAnimation === 'zoom-in') && (0, $18568cedb3bf28ca$export$2e2bcd8739ae039)([
                "_j7hqe8p0"
            ]),
            (!isExiting && enteringAnimation === 'zoom-out' || isExiting && exitingAnimation === 'zoom-out') && (0, $18568cedb3bf28ca$export$2e2bcd8739ae039)([
                "_j7hqy6ql"
            ]),
            (!isExiting && enteringAnimation === 'slide-in-from-top' || isExiting && exitingAnimation === 'slide-in-from-top') && (0, $18568cedb3bf28ca$export$2e2bcd8739ae039)([
                "_j7hqqshu"
            ]),
            (!isExiting && enteringAnimation === 'slide-out-from-top' || isExiting && exitingAnimation === 'slide-out-from-top') && (0, $18568cedb3bf28ca$export$2e2bcd8739ae039)([
                "_j7hq7ri4"
            ]),
            (!isExiting && enteringAnimation === 'slide-in-from-right' || isExiting && exitingAnimation === 'slide-in-from-right') && (0, $18568cedb3bf28ca$export$2e2bcd8739ae039)([
                "_j7hqdfjr"
            ]),
            (!isExiting && enteringAnimation === 'slide-out-from-right' || isExiting && exitingAnimation === 'slide-out-from-right') && (0, $18568cedb3bf28ca$export$2e2bcd8739ae039)([
                "_j7hqonfj"
            ]),
            (!isExiting && enteringAnimation === 'slide-in-from-bottom' || isExiting && exitingAnimation === 'slide-in-from-bottom') && (0, $18568cedb3bf28ca$export$2e2bcd8739ae039)([
                "_j7hq1liq"
            ]),
            (!isExiting && enteringAnimation === 'slide-out-from-bottom' || isExiting && exitingAnimation === 'slide-out-from-bottom') && (0, $18568cedb3bf28ca$export$2e2bcd8739ae039)([
                "_j7hqhnf1"
            ]),
            (!isExiting && enteringAnimation === 'slide-in-from-left' || isExiting && exitingAnimation === 'slide-in-from-left') && (0, $18568cedb3bf28ca$export$2e2bcd8739ae039)([
                "_j7hq1bh1"
            ]),
            (!isExiting && enteringAnimation === 'slide-out-from-left' || isExiting && exitingAnimation === 'slide-out-from-left') && (0, $18568cedb3bf28ca$export$2e2bcd8739ae039)([
                "_j7hqj08w"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-top' || isExiting && exitingAnimation === 'fade-in-from-top') && (0, $18568cedb3bf28ca$export$2e2bcd8739ae039)([
                "_j7hq2iua"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-top' || isExiting && exitingAnimation === 'fade-out-from-top') && (0, $18568cedb3bf28ca$export$2e2bcd8739ae039)([
                "_j7hq39va"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-left' || isExiting && exitingAnimation === 'fade-in-from-left') && (0, $18568cedb3bf28ca$export$2e2bcd8739ae039)([
                "_j7hq15m2"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-left' || isExiting && exitingAnimation === 'fade-out-from-left') && (0, $18568cedb3bf28ca$export$2e2bcd8739ae039)([
                "_j7hq1yiv"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-bottom' || isExiting && exitingAnimation === 'fade-in-from-bottom') && (0, $18568cedb3bf28ca$export$2e2bcd8739ae039)([
                "_j7hq1w00"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-bottom' || isExiting && exitingAnimation === 'fade-out-from-bottom') && (0, $18568cedb3bf28ca$export$2e2bcd8739ae039)([
                "_j7hqzy3z"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-right' || isExiting && exitingAnimation === 'fade-in-from-right') && (0, $18568cedb3bf28ca$export$2e2bcd8739ae039)([
                "_j7hqpqak"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-right' || isExiting && exitingAnimation === 'fade-out-from-right') && (0, $18568cedb3bf28ca$export$2e2bcd8739ae039)([
                "_j7hq1ebg"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-top-constant' || isExiting && exitingAnimation === 'fade-in-from-top-constant') && (0, $18568cedb3bf28ca$export$2e2bcd8739ae039)([
                "_j7hqm2e2"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-top-constant' || isExiting && exitingAnimation === 'fade-out-from-top-constant') && (0, $18568cedb3bf28ca$export$2e2bcd8739ae039)([
                "_j7hq97jn"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-left-constant' || isExiting && exitingAnimation === 'fade-in-from-left-constant') && (0, $18568cedb3bf28ca$export$2e2bcd8739ae039)([
                "_j7hqovgq"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-left-constant' || isExiting && exitingAnimation === 'fade-out-from-left-constant') && (0, $18568cedb3bf28ca$export$2e2bcd8739ae039)([
                "_j7hq15do"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-bottom-constant' || isExiting && exitingAnimation === 'fade-in-from-bottom-constant') && (0, $18568cedb3bf28ca$export$2e2bcd8739ae039)([
                "_j7hq797a"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-bottom-constant' || isExiting && exitingAnimation === 'fade-out-from-bottom-constant') && (0, $18568cedb3bf28ca$export$2e2bcd8739ae039)([
                "_j7hqwo7r"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-right-constant' || isExiting && exitingAnimation === 'fade-in-from-right-constant') && (0, $18568cedb3bf28ca$export$2e2bcd8739ae039)([
                "_j7hqt8u5"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-right-constant' || isExiting && exitingAnimation === 'fade-out-from-right-constant') && (0, $18568cedb3bf28ca$export$2e2bcd8739ae039)([
                "_j7hq1pgp"
            ])
        ]) : '',
        style: {
            animationDelay: "".concat(delay, "ms")
        }
    }, state);
};
var $b4f4bca1dbeb6cba$export$2e2bcd8739ae039 = $b4f4bca1dbeb6cba$var$EnteringMotion;


var $faf8d110486344ab$var$invertedDirection = {
    top: 'bottom',
    bottom: 'top',
    left: 'right',
    right: 'left'
};
/**
 * Props for controlling the behavior of the FadeIn animation
 */ /**
 * __FadeIn__
 *
 * Useful for fading in one or more elements.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/motion/docs/entering-motion)
 */ var $faf8d110486344ab$var$FadeIn = function FadeIn(_ref) {
    var children = _ref.children, _ref$duration = _ref.duration, duration = _ref$duration === void 0 ? 'large' : _ref$duration, entranceDirection = _ref.entranceDirection, exitDirection = _ref.exitDirection, _ref$distance = _ref.distance, distance = _ref$distance === void 0 ? 'proportional' : _ref$distance, onFinish = _ref.onFinish, isPaused = _ref.isPaused;
    var invertedEntranceDirection = entranceDirection !== undefined ? $faf8d110486344ab$var$invertedDirection[entranceDirection] : undefined;
    var isExitDirect = Boolean(exitDirection || invertedEntranceDirection) ? "fade-out-from-".concat(exitDirection || invertedEntranceDirection).concat(distance === 'proportional' ? '' : '-constant') : 'fade-out';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $b4f4bca1dbeb6cba$export$2e2bcd8739ae039), {
        duration: duration,
        enteringAnimation: entranceDirection ? "fade-in-from-".concat(entranceDirection).concat(distance === 'proportional' ? '' : '-constant') : 'fade-in',
        exitingAnimation: isExitDirect,
        animationTimingFunction: "ease-in-out",
        onFinish: onFinish,
        isPaused: isPaused
    }, children);
};
var $faf8d110486344ab$export$2e2bcd8739ae039 = $faf8d110486344ab$var$FadeIn;



var $50U6m = parcelRequire("50U6m");


/* eslint-disable @atlaskit/volt-strict-mode/no-multiple-exports */ var $46bf0aae0dfb1de2$export$44ffba16bd48dac6 = '__ATLASKIT_THEME__';
var $46bf0aae0dfb1de2$export$c93026a968943f95 = 'light';
var $46bf0aae0dfb1de2$export$6ba72c8346b4c57e = [
    'light',
    'dark'
];
var $46bf0aae0dfb1de2$export$7be255094ccdc533 = {
    card: function card() {
        return 100;
    },
    navigation: function navigation() {
        return 200;
    },
    dialog: function dialog() {
        return 300;
    },
    layer: function layer() {
        return 400;
    },
    blanket: function blanket() {
        return 500;
    },
    modal: function modal() {
        return 510;
    },
    flag: function flag() {
        return 600;
    },
    spotlight: function spotlight() {
        return 700;
    },
    tooltip: function tooltip() {
        return 9999;
    }
};




/**
 * The full mapping record. Internal - use `fromLegacyPlacement` from the
 * public entry-point so the offset-tuple translation is applied consistently.
 *
 * Note: `auto`, `auto-start`, `auto-end` map to `block-end` placements. This
 * is a reduction in expressiveness vs Popper.js (which picked the best
 * placement at runtime). CSS `position-try-fallbacks` flips at the edge but
 * the initial placement is fixed. Migration consumers who relied on Popper's
 * dynamic auto-flip should pick an explicit placement instead.
 */ var $f3ac98d69f3de1ed$export$27df359c528b7120 = {
    top: {
        axis: 'block',
        edge: 'start',
        align: 'center'
    },
    'top-start': {
        axis: 'block',
        edge: 'start',
        align: 'start'
    },
    'top-center': {
        axis: 'block',
        edge: 'start',
        align: 'center'
    },
    'top-end': {
        axis: 'block',
        edge: 'start',
        align: 'end'
    },
    bottom: {
        axis: 'block',
        edge: 'end',
        align: 'center'
    },
    'bottom-start': {
        axis: 'block',
        edge: 'end',
        align: 'start'
    },
    'bottom-center': {
        axis: 'block',
        edge: 'end',
        align: 'center'
    },
    'bottom-end': {
        axis: 'block',
        edge: 'end',
        align: 'end'
    },
    right: {
        axis: 'inline',
        edge: 'end',
        align: 'center'
    },
    'right-start': {
        axis: 'inline',
        edge: 'end',
        align: 'start'
    },
    'right-end': {
        axis: 'inline',
        edge: 'end',
        align: 'end'
    },
    left: {
        axis: 'inline',
        edge: 'start',
        align: 'center'
    },
    'left-start': {
        axis: 'inline',
        edge: 'start',
        align: 'start'
    },
    'left-end': {
        axis: 'inline',
        edge: 'start',
        align: 'end'
    },
    auto: {
        axis: 'block',
        edge: 'end',
        align: 'center'
    },
    'auto-start': {
        axis: 'block',
        edge: 'end',
        align: 'start'
    },
    'auto-end': {
        axis: 'block',
        edge: 'end',
        align: 'end'
    }
};


function $ff16da3649f6ba73$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $ff16da3649f6ba73$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $ff16da3649f6ba73$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $cafa94341993c43e$export$2e2bcd8739ae039)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $ff16da3649f6ba73$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $ff16da3649f6ba73$export$69e99ed50b2534c9(_ref) {
    var legacy = _ref.legacy, offset = _ref.offset;
    var basePlacement = (0, $f3ac98d69f3de1ed$export$27df359c528b7120)[legacy];
    if (!offset) return basePlacement;
    var _offset = (0, $10458117b712c01e$export$2e2bcd8739ae039)(offset, 2), along = _offset[0], away = _offset[1];
    return $ff16da3649f6ba73$var$_objectSpread($ff16da3649f6ba73$var$_objectSpread({}, basePlacement), {}, {
        offset: {
            gap: away,
            crossAxisShift: {
                // Sign is captured in `direction`; `value` is the magnitude.
                value: Math.abs(along),
                direction: along >= 0 ? 'forwards' : 'backwards'
            }
        }
    });
}


/* popover.tsx generated by @compiled/babel-plugin v2.0.0 */ /**
 * The length of the value hash portion of an atomic class name.
 * Atomic class names have the format: `_<group><value>`
 * where group is ATOMIC_GROUP_HASH_LENGTH chars and value is ATOMIC_VALUE_HASH_LENGTH chars.
 *
 * We extract the group key using: `className.slice(0, className.length - ATOMIC_VALUE_HASH_LENGTH)`
 *
 * We support both old-format classes (9 chars: `_` + 4 group + 4 value) and
 * new-format classes (11 chars: `_` + 6 group + 4 value) by using length-based
 * extraction rather than a hardcoded offset — old and new format group keys
 * are different lengths so they are structurally disjoint and never alias each other.
 */ const $f7c504bd27672c29$var$ATOMIC_VALUE_HASH_LENGTH = 4;
function $f7c504bd27672c29$export$2e2bcd8739ae039(classNames) {
    // Shortcut: nothing to do
    if (!classNames.length) return;
    // Shortcut: don't need to do anything if we only have a single classname
    if (classNames.length === 1 && classNames[0] && // checking to see if `classNames[0]` is a string that contains other classnames
    !classNames[0].includes(' ')) return classNames[0];
    // Using an object rather than a `Map` as it performed better in our benchmarks.
    // Would be happy to move to `Map` if it proved to be better under real conditions.
    const map = {};
    // Note: using loops to minimize iterations over the collection
    for (const value of classNames){
        // Exclude all falsy values, which leaves us with populated strings
        if (!value) continue;
        // a `value` can contain multiple classnames
        const list = value.split(' ');
        for (const className of list){
            /**
             * For atomic style classnames: the `key` is the `group`
             *
             * - Later atomic classnames with the same `group` will override earlier ones
             *   (which is what we want).
             * - Assumes atomic classnames are the only things that start with `_`
             * - Could use a regex to ensure that atomic classnames are structured how we expect,
             *   but did not add that for now as it did slow things down a bit.
             *
             * For other classnames: the `key` is the whole classname
             * - Okay to remove duplicates as doing so does not impact specificity
             *
             * */ const key = className.startsWith('_') ? className.slice(0, className.length - $f7c504bd27672c29$var$ATOMIC_VALUE_HASH_LENGTH) : className;
            map[key] = className;
        }
    }
    /**
     * We are converting the `map` into a string.
     *
     * The simple way to do this would be `Object.values(map).join(' ')`.
     * However, the approach below performs 10%-20% better in benchmarks.
     *
     * For `ax()` it feels right to squeeze as much runtime performance out as we can.
     */ let result = '';
    for(const key in map)result += map[key] + ' ';
    // If we have an empty string, then our `map` was empty.
    if (!result) return;
    // remove last " " from the result (we added " " at the end of every value)
    return result.trimEnd();
}



var $5FkrB = parcelRequire("5FkrB");

const $add6461460daa964$export$a274e22fb40f762e = (...styles)=>{
    // At runtime TStyles is resolved down to strings, but not at compile time.
    // We circumvent the type system here because of that.
    const actualStyles = styles;
    // The output should be a union type of passed in styles. This ensures the call
    // site of xcss prop can raise violations when disallowed styles have been passed.
    return (0, $f7c504bd27672c29$export$2e2bcd8739ae039)(actualStyles);
};






var $5FkrB = parcelRequire("5FkrB");

var $5FkrB = parcelRequire("5FkrB");
var $d086de131da9be54$export$5fbf4d7fae6cdc00 = /*#__PURE__*/ (0, $5FkrB.createContext)(null);



var $5FkrB = parcelRequire("5FkrB");

var $5FkrB = parcelRequire("5FkrB");
var $ff9b03078a3cab10$export$644a49f3b8c50fcd = /*#__PURE__*/ (0, $5FkrB.createContext)(null);


function $c54baf12dcdc41e7$export$1d57e79091cc3046() {
    var namespace = (0, $5FkrB.useContext)((0, $ff9b03078a3cab10$export$644a49f3b8c50fcd));
    return namespace;
}


function $61cf5534c175531d$export$469bb693f11edc7f(_ref) {
    var isOpen = _ref.isOpen, type = _ref.type, onClose = _ref.onClose;
    var context = (0, $5FkrB.useContext)((0, $d086de131da9be54$export$5fbf4d7fae6cdc00));
    var namespace = (0, $c54baf12dcdc41e7$export$1d57e79091cc3046)();
    (0, $5FkrB.useEffect)(function() {
        /**
     * Registers the `onClose` callback with the OpenLayerObserver.
     */ if (context === null) return;
        if (!isOpen) /**
       * If the layer is not open, we are not registering the `onClose` callback.
       * This is important to prevent the `onClose` from being called for layers that
       * are not open.
       *
       * Some consumers mistakenly pass "toggle" functions to `onClose` callbacks for
       * layer components, as Popup, e.g. `onClose={() => setIsOpen(!isOpen)}`.
       */ return;
        return context.onClose(onClose, {
            namespace: namespace,
            type: type
        });
    }, [
        context,
        isOpen,
        namespace,
        onClose,
        type
    ]);
}


/**
 * Normalizes an offset to a CSS length string. Numbers become `${n}px`;
 * strings pass through. Apply at the API boundary so internal code only
 * deals with strings.
 */ function $89f9951b5d6e8b0d$export$63b6b0ff65d84d47(_ref) {
    var value = _ref.value;
    if (typeof value === 'number') return "".concat(value, "px");
    return value;
}


/**
 * Default gap between trigger and popover. Resolves to a design
 * token (`space.100`) so the value follows the design system's spacing
 * scale. Used when `placement.offset.gap` is not provided.
 */ var $f4dcbc342eaa878e$var$DEFAULT_GAP = "var(--ds-space-100, 8px)";
function $f4dcbc342eaa878e$export$63044d21bc3d3fa2(_ref) {
    var _placement$offset, _placement$axis, _placement$edge, _placement$align, _placement$offset$cro, _placement$offset2, _placement$offset$cro2, _placement$offset3;
    var placement = _ref.placement;
    var consumerGap = (_placement$offset = placement.offset) === null || _placement$offset === void 0 ? void 0 : _placement$offset.gap;
    return {
        axis: (_placement$axis = placement.axis) !== null && _placement$axis !== void 0 ? _placement$axis : 'block',
        edge: (_placement$edge = placement.edge) !== null && _placement$edge !== void 0 ? _placement$edge : 'end',
        align: (_placement$align = placement.align) !== null && _placement$align !== void 0 ? _placement$align : 'center',
        offset: {
            gap: consumerGap === undefined ? $f4dcbc342eaa878e$var$DEFAULT_GAP : (0, $89f9951b5d6e8b0d$export$63b6b0ff65d84d47)({
                value: consumerGap
            }),
            crossAxisShift: {
                value: (0, $89f9951b5d6e8b0d$export$63b6b0ff65d84d47)({
                    value: (_placement$offset$cro = (_placement$offset2 = placement.offset) === null || _placement$offset2 === void 0 || (_placement$offset2 = _placement$offset2.crossAxisShift) === null || _placement$offset2 === void 0 ? void 0 : _placement$offset2.value) !== null && _placement$offset$cro !== void 0 ? _placement$offset$cro : 0
                }),
                direction: (_placement$offset$cro2 = (_placement$offset3 = placement.offset) === null || _placement$offset3 === void 0 || (_placement$offset3 = _placement$offset3.crossAxisShift) === null || _placement$offset3 === void 0 ? void 0 : _placement$offset3.direction) !== null && _placement$offset$cro2 !== void 0 ? _placement$offset$cro2 : 'forwards'
            }
        }
    };
}


var $7a1e791aad4460c9$var$rolesThatMoveFocus = new Set([
    'dialog',
    'alertdialog',
    'menu',
    'listbox',
    'tree',
    'grid'
]);
function $7a1e791aad4460c9$export$b12adccf56228c71(_ref) {
    var role = _ref.role;
    if (!role) return false;
    return $7a1e791aad4460c9$var$rolesThatMoveFocus.has(role);
}




var $5FkrB = parcelRequire("5FkrB");

var $253d5be3760099c8$export$ff7706047246b98b = (0, $86089df3a0fd54eb$export$2e2bcd8739ae039)(function() {
    if (typeof window === 'undefined' || !('matchMedia' in window)) return false;
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
});


function $12c5fdfbc1dd5a24$var$runCancellableSettlement(_ref) {
    var schedule = _ref.schedule, onSettled = _ref.onSettled;
    var isCancelled = false;
    schedule(function() {
        if (isCancelled) return;
        onSettled();
    });
    return function() {
        isCancelled = true;
    };
}
/**
 * Fires `onSettled` once all animations currently applied to `element`
 * finish or are cancelled. Returns a cleanup that prevents stale settlement.
 */ function $12c5fdfbc1dd5a24$var$runOnAnimationsSettled(_ref2) {
    var element = _ref2.element, onSettled = _ref2.onSettled;
    return $12c5fdfbc1dd5a24$var$runCancellableSettlement({
        onSettled: onSettled,
        schedule: function schedule(settle) {
            var _element$getAnimation, _element$getAnimation2;
            var animations = (_element$getAnimation = (_element$getAnimation2 = element.getAnimations) === null || _element$getAnimation2 === void 0 ? void 0 : _element$getAnimation2.call(element)) !== null && _element$getAnimation !== void 0 ? _element$getAnimation : [];
            Promise.allSettled(animations.map(function(animation) {
                return animation.finished;
            })).then(settle);
        }
    });
}
function $12c5fdfbc1dd5a24$export$1bccb45daf07907f(_ref3) {
    var isOpen = _ref3.isOpen, shouldAnimate = _ref3.shouldAnimate, elementRef = _ref3.elementRef, onEnterFinish = _ref3.onEnterFinish, onExitFinish = _ref3.onExitFinish;
    var willAnimate = shouldAnimate && !(0, $253d5be3760099c8$export$ff7706047246b98b)();
    var isNativeClosedRef = (0, $5FkrB.useRef)(false);
    // Promote `closed → entering`/`closed → open` synchronously during
    // render so the host element mounts in the same commit as the open
    // intent. All other transitions are driven by phase-specific effects.
    var _useState = (0, $5FkrB.useState)(function() {
        if (!isOpen) return 'closed';
        return willAnimate ? 'entering' : 'open';
    }), _useState2 = (0, $10458117b712c01e$export$2e2bcd8739ae039)(_useState, 2), phase = _useState2[0], setPhase = _useState2[1];
    // Rearm only after controlled state and the native lifecycle have both
    // reached closed. Resetting as soon as `isOpen` becomes false can erase a
    // closing toggle that was handled in the same React batch.
    if (!isOpen && phase === 'closed') isNativeClosedRef.current = false;
    if (isOpen && phase === 'closed' && !isNativeClosedRef.current) setPhase(willAnimate ? 'entering' : 'open');
    if (!isOpen && (phase === 'open' || phase === 'entering')) // Close intent. Move to `exiting` to gate the unmount on either
    // the exit transition (animated) or the closing toggle event
    // (non-animated). Includes interrupted entry (`entering → exiting`).
    setPhase('exiting');
    if (isOpen && phase === 'exiting' && !isNativeClosedRef.current) // Reopen mid-exit. With animation, jump back to `entering` and let
    // the entry transition restart from current visual state. Without
    // animation, jump straight to `open` (the handshake we were waiting
    // for is no longer relevant; the consumer wants the host visible
    // again synchronously).
    setPhase(willAnimate ? 'entering' : 'open');
    // Keep stable refs to the latest callbacks so effects and promise callbacks
    // always call the current callback without needing them in dependency arrays.
    var onEnterFinishRef = (0, $5FkrB.useRef)(onEnterFinish);
    onEnterFinishRef.current = onEnterFinish;
    var onExitFinishRef = (0, $5FkrB.useRef)(onExitFinish);
    onExitFinishRef.current = onExitFinish;
    // Animated entry: wait for all active animations and move to `open`.
    (0, $5FkrB.useEffect)(function() {
        if (phase !== 'entering') return;
        var element = elementRef.current;
        if (!element) return;
        return $12c5fdfbc1dd5a24$var$runOnAnimationsSettled({
            element: element,
            onSettled: function onSettled() {
                var _onEnterFinishRef$cur;
                // Fire the consumer callback before transitioning phase so any
                // state the consumer reads (refs, DOM nodes) is still attached
                // in the same synchronous tick, regardless of React batching
                // semantics.
                (_onEnterFinishRef$cur = onEnterFinishRef.current) === null || _onEnterFinishRef$cur === void 0 || _onEnterFinishRef$cur.call(onEnterFinishRef);
                setPhase(function(current) {
                    return current === 'entering' ? 'open' : current;
                });
            }
        });
    }, [
        phase,
        elementRef
    ]);
    // Non-animated entry callback. The lifecycle goes `closed → open`
    // directly with no `entering` phase; fire `onEnterFinish` on that jump.
    // A previous-phase ref avoids double-firing on the animated path.
    var prevPhaseForEntryRef = (0, $5FkrB.useRef)('closed');
    (0, $5FkrB.useEffect)(function() {
        var prevPhase = prevPhaseForEntryRef.current;
        prevPhaseForEntryRef.current = phase;
        // Animated entry settle goes through `entering` and already fired
        // onEnterFinish above; only handle the non-animated direct jumps.
        if (prevPhase !== 'open' && phase === 'open' && prevPhase !== 'entering') {
            var _onEnterFinishRef$cur2;
            (_onEnterFinishRef$cur2 = onEnterFinishRef.current) === null || _onEnterFinishRef$cur2 === void 0 || _onEnterFinishRef$cur2.call(onEnterFinishRef);
        }
    }, [
        phase
    ]);
    // Animated exit: wait for all active animations, fire `onExitFinish`,
    // then move to `closed` to unmount the host.
    (0, $5FkrB.useEffect)(function() {
        if (phase !== 'exiting' || !willAnimate) return;
        var element = elementRef.current;
        if (!element) return;
        return $12c5fdfbc1dd5a24$var$runOnAnimationsSettled({
            element: element,
            onSettled: function onSettled() {
                var _onExitFinishRef$curr;
                // Fire the consumer callback before transitioning phase to
                // `closed`. The phase change drives the host element unmount,
                // and consumers expect to be able to read the element (or a
                // forwarded ref to it) inside `onExitFinish`. Doing this in
                // the safe order avoids relying on React's automatic batching
                // to keep the element attached across the callback.
                (_onExitFinishRef$curr = onExitFinishRef.current) === null || _onExitFinishRef$curr === void 0 || _onExitFinishRef$curr.call(onExitFinishRef);
                setPhase(function(current) {
                    return current === 'exiting' ? 'closed' : current;
                });
            }
        });
    }, [
        phase,
        willAnimate,
        elementRef
    ]);
    // Native dismissal is authoritative. Its toggle can arrive while controlled
    // state still says open, so remember that native state and do not
    // reopen until `isOpen` has first moved to false.
    (0, $5FkrB.useLayoutEffect)(function() {
        if (phase === 'exiting' && !willAnimate && isNativeClosedRef.current) setPhase('closed');
    }, [
        phase,
        willAnimate
    ]);
    var onToggle = (0, $5FkrB.useCallback)(function(event) {
        if (event.newState === 'open') {
            isNativeClosedRef.current = false;
            return;
        }
        if (event.newState !== 'closed') return;
        isNativeClosedRef.current = true;
        setPhase(function(current) {
            if (current === 'open' || current === 'entering') return 'exiting';
            if (current === 'exiting' && !willAnimate) return 'closed';
            return current;
        });
    }, [
        willAnimate
    ]);
    // Non-animated exit callback. There are no animations to wait for, so fire
    // `onExitFinish` on the transition into `exiting` (the unmount itself
    // is gated by the closing toggle handshake above).
    var prevPhaseForExitRef = (0, $5FkrB.useRef)('closed');
    (0, $5FkrB.useEffect)(function() {
        var prevPhase = prevPhaseForExitRef.current;
        prevPhaseForExitRef.current = phase;
        // Only fire on the non-animated transition into `exiting`. The
        // animated path's `exiting → closed` settle already fires
        // `onExitFinish` from `runOnAnimationsSettled`.
        if (prevPhase !== 'exiting' && phase === 'exiting' && !willAnimate) {
            var _onExitFinishRef$curr2;
            (_onExitFinishRef$curr2 = onExitFinishRef.current) === null || _onExitFinishRef$curr2 === void 0 || _onExitFinishRef$curr2.call(onExitFinishRef);
        }
    }, [
        phase,
        willAnimate
    ]);
    return {
        phase: phase,
        onToggle: onToggle
    };
}



var $5FkrB = parcelRequire("5FkrB");

var $e5bf910ee26c97fe$var$topLayerSelector = '[popover], dialog, [role="dialog"], [role="alertdialog"]';
function $e5bf910ee26c97fe$export$df8c72c64edc7260(_ref) {
    var element = _ref.element, container = _ref.container;
    return element.closest($e5bf910ee26c97fe$var$topLayerSelector) === container.closest($e5bf910ee26c97fe$var$topLayerSelector);
}


var $5cb332ceafedf402$export$e1252723db1c541 = function() {
    // Common exclusion filter applied to every selector.
    var not = ':not([tabindex="-1"]):not([aria-disabled="true"]):not([aria-hidden="true"])';
    var notDisabled = ":not([disabled])".concat(not);
    var focusable = [
        "a[href]".concat(not),
        "area[href]".concat(not),
        "input".concat(notDisabled, ":not([type=\"hidden\"])"),
        "select".concat(notDisabled),
        "textarea".concat(notDisabled),
        "button".concat(notDisabled),
        "iframe".concat(not),
        "audio[controls]".concat(not),
        "video[controls]".concat(not),
        "[contenteditable]:not([contenteditable=\"false\"])".concat(not),
        "[tabindex]".concat(notDisabled)
    ];
    return {
        focusable: focusable.join(','),
        // Build the `:focus` selector
        focused: focusable.map(function(selector) {
            return "".concat(selector, ":focus");
        }).join(',')
    };
}();


function $b229f0b77a5ab951$export$f6768025e418420e(_ref) {
    var container = _ref.container, filter = _ref.filter;
    return Array.from(container.querySelectorAll((0, $5cb332ceafedf402$export$e1252723db1c541).focusable)).filter(function(element) {
        return element instanceof HTMLElement;
    }).filter(function(element) {
        return (0, $e5bf910ee26c97fe$export$df8c72c64edc7260)({
            element: element,
            container: container
        });
    }).filter(function(element) {
        return !filter || filter(element, container);
    });
}


function $b5a07d899983befa$export$748138f04a69bf21(_ref) {
    var container = _ref.container, filter = _ref.filter;
    var items = (0, $b229f0b77a5ab951$export$f6768025e418420e)({
        container: container,
        filter: filter
    });
    return items.length > 0 ? items[0] : null;
}



function $869488cf49d75786$export$73e81fa65335a75b(_ref) {
    var container = _ref.container, filter = _ref.filter;
    var items = (0, $b229f0b77a5ab951$export$f6768025e418420e)({
        container: container,
        filter: filter
    });
    return items.length > 0 ? items[items.length - 1] : null;
}


/**
 * Returns the next focusable element in the given direction relative to the
 * currently focused element within the container. Wraps around at both ends.
 *
 * Returns `null` if there is no focused element within the container or if
 * the focused element is not in the list of focusable elements.
 */ 

function $bf257ac4b1f2b4f2$export$a7db88e6d491b450(_ref) {
    var _all$nextIndex;
    var container = _ref.container, direction = _ref.direction, filter = _ref.filter;
    var all = (0, $b229f0b77a5ab951$export$f6768025e418420e)({
        container: container,
        filter: filter
    });
    var current = container.querySelector((0, $5cb332ceafedf402$export$e1252723db1c541).focused);
    if (!(current instanceof HTMLElement)) return null;
    var index = all.indexOf(current);
    if (index === -1) return null;
    var nextIndex = function() {
        if (direction === 'forwards') return (index + 1) % all.length;
        var proposed = index - 1;
        // if going into negative numbers, loop back to the last item
        return proposed < 0 ? all.length - 1 : proposed;
    }();
    return (_all$nextIndex = all[nextIndex]) !== null && _all$nextIndex !== void 0 ? _all$nextIndex : null;
}




function $d4c1a10403905470$export$b9590fdfeb5f722f(_ref) {
    var _getDocument;
    var container = _ref.container;
    var focused = (_getDocument = (0, $fc5ac9c99de29fbb$export$f65ca476c09acec0)()) === null || _getDocument === void 0 ? void 0 : _getDocument.activeElement;
    if (!(focused instanceof HTMLElement)) return false;
    // Cannot be in a nested layer if it is not in the container
    if (!container.contains(focused)) return false;
    // If not in the same layer, must be in a nested layer
    return !(0, $e5bf910ee26c97fe$export$df8c72c64edc7260)({
        element: focused,
        container: container
    });
}


/**
 * Roles that require focus wrapping per WAI-ARIA APG.
 *
 * - `dialog`: https://www.w3.org/WAI/ARIA/apg/patterns/dialog-modal/
 * - `alertdialog`: same keyboard pattern as dialog
 *
 * `menu` is intentionally excluded. Menus are composite widgets
 * (https://www.w3.org/WAI/ARIA/apg/practices/keyboard-interface/#kbd_general_within)
 * that manage their own internal keyboard navigation via arrow keys,
 * not Tab. Tab/Shift+Tab should move focus OUT of a menu entirely.
 *
 * Menu keyboard behavior (arrow keys, Home/End, type-ahead, Enter/Space)
 * is context-dependent. It varies by orientation, nesting depth, item
 * type, and control pattern (menu button vs menubar). This makes it
 * impossible to implement generically here. The consumer component
 * (e.g. `dropdown-menu`) owns all menu keyboard navigation.
 *
 * See: notes/outputs/menu-keyboard-decision.md
 */ function $2abf1dadebafbd11$var$roleRequiresFocusWrap(role) {
    return role === 'dialog' || role === 'alertdialog';
}
function $2abf1dadebafbd11$export$4f6462e86a70abe5(_ref) {
    var elementRef = _ref.elementRef, role = _ref.role, phase = _ref.phase;
    var isVisible = phase !== 'closed';
    (0, $5FkrB.useEffect)(function() {
        var element = elementRef.current;
        if (!element || !$2abf1dadebafbd11$var$roleRequiresFocusWrap(role) || !isVisible) return;
        var unbind = (0, $5b617c1f48263075$exports.bind)(element, {
            type: 'keydown',
            listener: function listener(event) {
                if (event.key !== 'Tab') return;
                // If focus is already in a nested layer, then
                // we continue to let that nested layer own focus
                if ((0, $d4c1a10403905470$export$b9590fdfeb5f722f)({
                    container: element
                })) return;
                // Prevent the browser giving focus to where it wants to
                // (we will be handling it, including with wrapping)
                event.preventDefault();
                var direction = event.shiftKey ? 'backwards' : 'forwards';
                // Try to move to the next/previous focusable element relative
                // to the currently focused element within the container.
                var next = (0, $bf257ac4b1f2b4f2$export$a7db88e6d491b450)({
                    container: element,
                    direction: direction
                });
                if (next) {
                    next.focus();
                    return;
                }
                // Nothing is currently focused inside the container (or the
                // focused element is not in the focusable list). Fall back to
                // the first or last focusable element depending on direction.
                var fallback = direction === 'forwards' ? (0, $b5a07d899983befa$export$748138f04a69bf21)({
                    container: element
                }) : (0, $869488cf49d75786$export$73e81fa65335a75b)({
                    container: element
                });
                if (fallback) fallback.focus();
            },
            options: {
                capture: true
            }
        });
        return unbind;
    }, [
        elementRef,
        role,
        isVisible
    ]);
}



var $5FkrB = parcelRequire("5FkrB");

/**
 * Determines the correct element to receive initial focus within a popover,
 * based on its ARIA role.
 *
 * Focus rules by role (per WAI-ARIA APG):
 * - `dialog` / `alertdialog`: first element with `[autofocus]`, or first focusable element
 * - `menu`: first menu item (`[role="menuitem|menuitemcheckbox|menuitemradio"]`)
 * - `listbox`: first selected option (`[aria-selected="true"]`), or first option (`[role="option"]`)
 * - `tooltip`: no focus movement (tooltips are informational)
 * - no role / other roles: no focus movement
 *
 * Note: React 18's `autoFocus` JSX prop does NOT set the HTML `autofocus`
 * attribute - it only calls `.focus()` imperatively during commit, which
 * has no effect on hidden popover content. Consumers must set the native
 * attribute via a ref callback (e.g. `node.setAttribute('autofocus', '')`).
 * React 19+ reflects the JSX prop as the HTML attribute automatically.
 *
 * Combobox pattern exception: if the popup is controlled by a focused
 * combobox-like trigger (its `aria-controls` references this popup),
 * focus stays on the textbox regardless of role. See
 * `isComboboxControllingPopup`.
 */ /**
 * WAI-ARIA APG Combobox Pattern: when a combobox controls a popup (listbox,
 * grid, tree, or menu), DOM focus must remain on the textbox. Subsequent
 * navigation through popup items uses `aria-activedescendant` (or proxied
 * keyboard events), never DOM focus movement.
 *
 * Detects both variants in a single pass:
 * - In-popup combobox: the textbox lives inside the popup `container`
 *   (the popup is rendered as a child of the combobox wrapper).
 * - External combobox: the textbox is rendered OUTSIDE the popup
 *   (`react-select` pattern, where the listbox is portalled separately
 *   from the textbox).
 *
 * Acceptance criteria for the active element:
 * - Role / element-type filter: `role="combobox"`, `role="textbox"`,
 *   `TEXTAREA`, `contentEditable`, or `INPUT` of text-like type
 *   (`text`, `search`, `email`, `url`, `tel`, `password`, or
 *   unspecified). Non-text input types (`button`, `checkbox`, etc.)
 *   are rejected.
 * - Reference filter: `aria-controls` (or legacy `aria-owns`) IDREFS
 *   must resolve to an element that IS or CONTAINS the popup container.
 *
 * See: https://www.w3.org/WAI/ARIA/apg/patterns/combobox/
 */ // `<input>` types treated as text-like for combobox detection.
// Non-text input types (`button`, `checkbox`, `submit`, etc.) are rejected.
// A missing `type` attribute defaults to `text` per the HTML spec, so we
// normalize that case before lookup rather than including an empty string here.
var $c3a3a0ebbc5251b1$var$TEXT_LIKE_INPUT_TYPES = new Set([
    'text',
    'search',
    'email',
    'url',
    'tel',
    'password'
]);
function $c3a3a0ebbc5251b1$var$isTextboxLikeElement(element) {
    var role = element.getAttribute('role');
    if (role === 'combobox' || role === 'textbox') return true;
    // `tagName` is uppercase for HTML elements but can be mixed-case for
    // XML/SVG. Normalize once so downstream comparisons stay lowercase.
    var tag = element.tagName.toLowerCase();
    if (tag === 'textarea') return true;
    if (element.isContentEditable) return true;
    if (tag === 'input') {
        var _element$getAttribute;
        var type = ((_element$getAttribute = element.getAttribute('type')) !== null && _element$getAttribute !== void 0 ? _element$getAttribute : 'text').toLowerCase();
        return $c3a3a0ebbc5251b1$var$TEXT_LIKE_INPUT_TYPES.has(type);
    }
    return false;
}
function $c3a3a0ebbc5251b1$var$isComboboxControllingPopup(_ref) {
    var _active$getAttribute;
    var container = _ref.container;
    var ownerDocument = container.ownerDocument;
    var active = ownerDocument.activeElement;
    if (!(active instanceof HTMLElement)) return false;
    if (!$c3a3a0ebbc5251b1$var$isTextboxLikeElement(active)) return false;
    // Accept legacy `aria-owns` in addition to `aria-controls`.
    // `aria-controls` / `aria-owns` are IDREFS (space-separated list of IDs)
    // per the WAI-ARIA spec, so we must split and check membership rather
    // than comparing with strict equality. A combobox that controls both
    // this popup and another element (e.g. a results status region) must
    // still be recognised as controlling this popup.
    var idRefs = (_active$getAttribute = active.getAttribute('aria-controls')) !== null && _active$getAttribute !== void 0 ? _active$getAttribute : active.getAttribute('aria-owns');
    if (!idRefs) return false;
    // Match if any referenced element IS, CONTAINS, or IS CONTAINED BY the
    // popup container. The "contained by" case covers wrapper-style adopters
    // like react-select, where the combobox input's `aria-controls` points at
    // a listbox element that is a descendant of the Popover host (the
    // listbox role lives on a child the wrapped library owns, not on the
    // host we render).
    var referencedIds = idRefs.split(/\s+/).filter(function(id) {
        return id !== '';
    });
    return referencedIds.some(function(id) {
        var referenced = ownerDocument.getElementById(id);
        if (!referenced) return false;
        return referenced === container || referenced.contains(container) || container.contains(referenced);
    });
}
function $c3a3a0ebbc5251b1$var$getInitialFocusTarget(_ref2) {
    var container = _ref2.container, role = _ref2.role;
    if (role === 'dialog' || role === 'alertdialog') {
        // Prefer element with the native HTML autofocus attribute.
        var autofocusEl = container.querySelector('[autofocus]');
        if (autofocusEl) return autofocusEl;
        // Fall back to first focusable element
        return (0, $b5a07d899983befa$export$748138f04a69bf21)({
            container: container
        });
    }
    // The combobox carve-out is kept role-specific (menu / listbox) rather
    // than hoisted. Hoisting it over-matched on dialog popups that contain
    // a nested combobox (e.g. datetime-picker's dialog hosts a react-select),
    // where the active combobox's `aria-controls` falsely matched the
    // container and suppressed the dialog's own focus contract.
    if (role === 'menu') {
        if ($c3a3a0ebbc5251b1$var$isComboboxControllingPopup({
            container: container
        })) return null;
        // Initial focus placement is the extent of what top-layer provides
        // for menus. All subsequent keyboard navigation (arrow keys, Home/End,
        // type-ahead, Enter/Space, submenu coordination) is the responsibility
        // of the consumer component (e.g. dropdown-menu), because menu keyboard
        // behavior varies by context (orientation, nesting, item type, control
        // pattern). See: notes/outputs/menu-keyboard-decision.md
        return (0, $b5a07d899983befa$export$748138f04a69bf21)({
            container: container
        });
    }
    if (role === 'listbox') {
        // ARIA Combobox Pattern: if a combobox-like textbox owns the popup
        // (in-popup or external e.g. react-select), leave focus on the
        // textbox - navigation is proxied through it.
        if ($c3a3a0ebbc5251b1$var$isComboboxControllingPopup({
            container: container
        })) return null;
        // Prefer the selected option, then fall back to the first option.
        // We intentionally match by `[role="option"]` rather than by
        // `getFirstFocusable`. The standard WAI-ARIA APG listbox pattern
        // renders options with `tabindex="-1"` (managed via roving
        // tabindex); `getFirstFocusable` excludes `tabindex="-1"` elements
        // and would silently lose initial focus for spec-conformant
        // listboxes. Options remain programmatically focusable.
        var selectedOption = container.querySelector('[role="option"][aria-selected="true"]');
        if (selectedOption) return selectedOption;
        var firstOption = container.querySelector('[role="option"]');
        if (firstOption) return firstOption;
        // Last resort for non-standard listboxes that render no options
        // but do contain a focusable element (e.g. an empty-state action).
        return (0, $b5a07d899983befa$export$748138f04a69bf21)({
            container: container
        });
    }
    // tooltip, no role, or other roles: no focus movement
    return null;
}
function $c3a3a0ebbc5251b1$export$e992c40175757a22(_ref3) {
    var elementRef = _ref3.elementRef, phase = _ref3.phase, role = _ref3.role;
    // Track the previous phase so we only focus on transitions into a
    // visible phase from either `'closed'` (fresh mount) or `'exiting'`
    // (mid-exit reopen where the browser has already restored focus to
    // the trigger). Pure `entering → exiting → entering` stutters where
    // the consumer toggles in the same frame are still collapsed.
    var prevPhaseRef = (0, $5FkrB.useRef)('closed');
    (0, $5FkrB.useEffect)(function() {
        var _getInitialFocusTarge;
        var prevPhase = prevPhaseRef.current;
        prevPhaseRef.current = phase;
        // Only focus on transitions into a visible phase from `'closed'`
        // (fresh open) or `'exiting'` (mid-exit reopen).
        if (phase === 'closed') return;
        if (prevPhase !== 'closed' && prevPhase !== 'exiting') return;
        var element = elementRef.current;
        if (!element) return;
        (_getInitialFocusTarge = $c3a3a0ebbc5251b1$var$getInitialFocusTarget({
            container: element,
            role: role
        })) === null || _getInitialFocusTarge === void 0 || _getInitialFocusTarge.focus();
    }, [
        elementRef,
        phase,
        role
    ]);
}


/**
 * Detects `popover="hint"` support via DOM reflection. SSR-safe, cached.
 */ var $e852c2f93196e24b$var$supportsPopoverHint = (0, $86089df3a0fd54eb$export$2e2bcd8739ae039)(function() {
    if (typeof document === 'undefined') return false;
    // eslint-disable-next-line @atlaskit/platform/no-direct-document-usage -- feature detection
    var element = document.createElement('div');
    element.setAttribute('popover', 'hint');
    return element.popover === 'hint';
});
// Surface reset — neutralises inherited interaction and text-layout properties
// (e.g. `pointer-events: none` from an overlaid controls container and
// `white-space: nowrap` from an `@atlaskit/select` option) that leak into a
// top-layer element because, for CSS inheritance, it is still a DOM child of its
// trigger (top-layer promotion is paint/stacking only; the legacy portal path
// avoided this by rendering at `<body>`). Excludes `color`/`font` (theming) and
// `direction`/`unicode-bidi` (RTL must inherit).
//
// KEEP IN SYNC with the identical `surfaceResetStyles` in `dialog/dialog-content.tsx`.
// ADS forbids sharing styles across files (`no-exported-styles` /
// `no-imported-style-values` — Compiled styles are null at runtime), so the reset is
// co-located and duplicated deliberately.
var $e852c2f93196e24b$var$surfaceResetStyles = {
    root: "_lcxv1wug _o5724jg8 _1nmz4jg8 _1i4q4jg8 _y3gnv2br _azhwidpf _1p1dglyw"
};
var $e852c2f93196e24b$var$styles = {
    root: "_19itglyw _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19pkidpf _2hwxidpf _otyridpf _18u0idpf _1r041wug _1reoewfl _18m9ewfl _bfhk1j28 _4t3i1wug",
    motion: "_k8m011k7 _1oecdn4k _1s9z1a5r _1o511hrf _bl8aglyw _156y147i",
    enter: "_y44v179n",
    exit: "_y44vof1f"
};
// Intentionally using `Record<string, string>` instead of `React.CSSProperties`
// to avoid type errors about the CSS variables not being valid property names
var $e852c2f93196e24b$var$popupMotionStyles = {
    block: {
        start: {
            '--ds-popover-motion-enter': "var(--ds-popup-enter-top, 150ms cubic-bezier(0.4, 1, 0.6, 1) SlideInTop8px, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn0to100)",
            '--ds-popover-motion-exit': "var(--ds-popup-exit-top, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) SlideOutTop8px, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)"
        },
        end: {
            '--ds-popover-motion-enter': "var(--ds-popup-enter-bottom, 150ms cubic-bezier(0.4, 1, 0.6, 1) SlideInBottom8px, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn0to100)",
            '--ds-popover-motion-exit': "var(--ds-popup-exit-bottom, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) SlideOutBottom8px, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)"
        }
    },
    inline: {
        start: {
            '--ds-popover-motion-enter': "var(--ds-popup-enter-left, 150ms cubic-bezier(0.4, 1, 0.6, 1) SlideInLeft8px, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn0to100)",
            '--ds-popover-motion-exit': "var(--ds-popup-exit-left, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) SlideOutLeft8px, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)"
        },
        end: {
            '--ds-popover-motion-enter': "var(--ds-popup-enter-right, 150ms cubic-bezier(0.4, 1, 0.6, 1) SlideInRight8px, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn0to100)",
            '--ds-popover-motion-exit': "var(--ds-popup-exit-right, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) SlideOutRight8px, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)"
        }
    }
};
/**
 * Roles registered with the open layer observer as `popup`, so `closeLayers()`
 * dismisses them. `modal` comes from Dialog only; other layer types are unused.
 */ var $e852c2f93196e24b$var$POPUP_ROLES = new Set([
    'menu',
    'listbox',
    'dialog',
    'alertdialog',
    'tree',
    'grid'
]);
var $e852c2f93196e24b$export$5b6b19405a83ff9d = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function Popover(_ref, ref) {
    var children = _ref.children, _ref$mode = _ref.mode, modeProp = _ref$mode === void 0 ? 'auto' : _ref$mode, onClose = _ref.onClose, onEnterFinish = _ref.onEnterFinish, onExitFinish = _ref.onExitFinish, _ref$shouldAnimate = _ref.shouldAnimate, shouldAnimate = _ref$shouldAnimate === void 0 ? false : _ref$shouldAnimate, placement = _ref.placement, testId = _ref.testId, isOpen = _ref.isOpen, enteringAnimationXcss = _ref.enteringAnimationXcss, exitingAnimationXcss = _ref.exitingAnimationXcss, role = _ref.role, label = _ref.label, labelledBy = _ref.labelledBy, idProp = _ref.id;
    var autoId = (0, $5FkrB.useId)();
    var ownRef = (0, $5FkrB.useRef)(null);
    var combinedRef = (0, $db13a2f91f6a0f56$export$2e2bcd8739ae039)([
        ownRef,
        ref
    ].filter(Boolean));
    // `useId()` colons are invalid in CSS selectors and popover target attributes.
    var popoverId = idProp !== null && idProp !== void 0 ? idProp : "popover-".concat(autoId.replace(/:/g, ''));
    var _useAnimatedVisibilit = (0, $12c5fdfbc1dd5a24$export$1bccb45daf07907f)({
        isOpen: isOpen,
        shouldAnimate: shouldAnimate,
        elementRef: ownRef,
        onEnterFinish: onEnterFinish,
        onExitFinish: onExitFinish
    }), phase = _useAnimatedVisibilit.phase, onToggle = _useAnimatedVisibilit.onToggle;
    // True while the host element is mounted (any phase except `closed`).
    // Used as a dep so listener-rebind effects re-attach after a remount.
    var isVisible = phase !== 'closed';
    // Focus management: initial focus on entry (role-dependent), Tab cycling
    // for dialog roles. Restoration is native for outermost popovers; nested
    // focus-capturing roles are handled below via the `beforetoggle` snapshot.
    // Passing `phase` keeps `useFocusWrap` attached through the animated-exit
    // window (WCAG 2.4.3 guard). See notes/architecture/focus-restoration.md.
    (0, $2abf1dadebafbd11$export$4f6462e86a70abe5)({
        elementRef: ownRef,
        role: role,
        phase: phase
    });
    (0, $c3a3a0ebbc5251b1$export$e992c40175757a22)({
        elementRef: ownRef,
        phase: phase,
        role: role
    });
    // Register with open layer observer so `closeLayers()` and open-count
    // subscriptions work. Only popup-like roles register as `popup`; passive
    // roles (tooltip, status, etc.) leave `type` undefined.
    var handleObserverClose = (0, $5FkrB.useCallback)(function() {
        onClose === null || onClose === void 0 || onClose({
            reason: 'programmatic'
        });
    }, [
        onClose
    ]);
    (0, $61cf5534c175531d$export$469bb693f11edc7f)({
        type: role && $e852c2f93196e24b$var$POPUP_ROLES.has(role) ? 'popup' : undefined,
        isOpen: isOpen,
        onClose: handleObserverClose
    });
    // `hint` falls back to `auto` when unsupported: closest behavior (light
    // dismiss works), but `auto` participates in the auto-dismiss stack so it
    // will close other `auto` popovers when opened. Acceptable trade-off given
    // shrinking browser set without `hint` support.
    var mode = modeProp === 'hint' && !$e852c2f93196e24b$var$supportsPopoverHint() ? 'auto' : modeProp;
    var popupMotionStyle = (0, $5FkrB.useMemo)(function() {
        if (!placement || !shouldAnimate) return undefined;
        var _resolvePlacement = (0, $f4dcbc342eaa878e$export$63044d21bc3d3fa2)({
            placement: placement
        }), axis = _resolvePlacement.axis, edge = _resolvePlacement.edge;
        return $e852c2f93196e24b$var$popupMotionStyles[axis][edge];
    }, [
        placement,
        shouldAnimate
    ]);
    // Prevents toggle handler from calling onClose for our own hidePopover() calls.
    var programmaticCloseRef = (0, $5FkrB.useRef)(false);
    // Set in capture-phase keydown so the toggle handler knows close reason.
    var closeReasonRef = (0, $5FkrB.useRef)('light-dismiss');
    // Snapshot of pre-open focus, used to restore focus for nested popovers
    // with focus-capturing roles (browser only restores the outermost).
    var previouslyFocusedElementRef = (0, $5FkrB.useRef)(null);
    var handleBeforeToggle = (0, $5FkrB.useCallback)(function(event) {
        if (event.newState !== 'open') return;
        // eslint-disable-next-line @atlaskit/platform/no-direct-document-usage -- need active element snapshot
        var active = document.activeElement;
        previouslyFocusedElementRef.current = active instanceof HTMLElement ? active : null;
    }, []);
    var handleToggle = (0, $5FkrB.useCallback)(function(event) {
        var element = ownRef.current;
        if (event.newState === 'open') {
            onToggle(event);
            return;
        }
        if (event.newState === 'closed') {
            if (element) {
                // Nested-popover focus restoration fallback (browser only
                // restores outermost; Firefox skips nested entirely).
                // Restore only when the role moved focus in on open AND the
                // close was Escape/programmatic. For light dismiss, the
                // click target keeps focus per HTML spec
                // (`focusPreviousElement=false`).
                var previouslyFocused = previouslyFocusedElementRef.current;
                var reason = closeReasonRef.current;
                var isProgrammatic = programmaticCloseRef.current;
                var shouldRestore = previouslyFocused !== null && previouslyFocused.isConnected && (0, $7a1e791aad4460c9$export$b12adccf56228c71)({
                    role: role
                }) && (reason === 'escape' || isProgrammatic);
                if (shouldRestore && previouslyFocused) previouslyFocused.focus({
                    preventScroll: true
                });
                previouslyFocusedElementRef.current = null;
            }
            // Programmatic close: consumer already knows.
            if (programmaticCloseRef.current) // Reset reason so a stale 'escape' from a race with Escape keydown
            // does not corrupt the next browser-dismiss cycle.
            closeReasonRef.current = 'light-dismiss';
            else {
                // Browser dismiss (Escape/click-outside).
                var _reason = closeReasonRef.current;
                closeReasonRef.current = 'light-dismiss';
                // Optional: `manual` mode has no `onClose` in the forwarded type.
                onClose === null || onClose === void 0 || onClose({
                    reason: _reason
                });
            }
        }
        onToggle(event);
    }, [
        onClose,
        onToggle,
        role
    ]);
    // Bind via `useLayoutEffect`, and BEFORE the show/hide layout effect
    // below, so listeners are attached when `showPopover()` synchronously
    // dispatches `beforetoggle`. A regular `useEffect` would miss that
    // first dispatch, dropping the `previouslyFocusedElementRef` snapshot
    // and breaking nested-popover focus restoration on close. React runs
    // layout effects in source order on the same commit.
    (0, $5FkrB.useLayoutEffect)(function() {
        var element = ownRef.current;
        if (!element) return;
        // Tag Escape before the browser processes light dismiss.
        var unbindEscape = (0, $5b617c1f48263075$exports.bind)(element, {
            type: 'keydown',
            listener: function listener(event) {
                if (event.key === 'Escape') closeReasonRef.current = 'escape';
            },
            options: {
                capture: true
            }
        });
        var unbindToggle = (0, $5b617c1f48263075$exports.bind)(element, {
            type: 'toggle',
            listener: handleToggle
        });
        // Snapshot `document.activeElement` before `useInitialFocus` moves it.
        var unbindBeforeToggle = (0, $5b617c1f48263075$exports.bind)(element, {
            type: 'beforetoggle',
            listener: handleBeforeToggle
        });
        return function() {
            unbindEscape();
            unbindToggle();
            unbindBeforeToggle();
        };
    }, [
        handleToggle,
        handleBeforeToggle,
        isVisible
    ]);
    // Show/hide based on isOpen. `showPopover`/`hidePopover` are no-ops when
    // already in the target state. Try/catch guards `InvalidStateError` on
    // disconnected elements (StrictMode/concurrent/unmount edge cases).
    (0, $5FkrB.useLayoutEffect)(function() {
        var element = ownRef.current;
        if (!element) return;
        if (isOpen) {
            programmaticCloseRef.current = false;
            // Clear stale 'escape' from a prior cycle: the ref outlives
            // the host element, and the no-animation path unmounts before
            // `handleToggle` can reset it.
            closeReasonRef.current = 'light-dismiss';
            try {
                element.showPopover();
            } catch (_unused) {}
            return function() {
                programmaticCloseRef.current = true;
                try {
                    element.hidePopover();
                } catch (_unused2) {}
            };
        }
        programmaticCloseRef.current = true;
        try {
            element.hidePopover();
        } catch (_unused3) {}
    }, [
        isOpen
    ]);
    // Unmount the host once exit completes so it does not leave an empty
    // `role`/`popover` element in the accessibility tree. The element
    // remounts on the next open; the `popoverId` is stable across opens.
    if (!isVisible) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("div", {
        ref: combinedRef,
        id: popoverId,
        popover: mode,
        role: role,
        "aria-label": label,
        "aria-labelledby": labelledBy,
        "data-testid": testId,
        style: popupMotionStyle,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $f7c504bd27672c29$export$2e2bcd8739ae039)([
            $e852c2f93196e24b$var$styles.root,
            $e852c2f93196e24b$var$surfaceResetStyles.root,
            shouldAnimate && phase === 'entering' && $e852c2f93196e24b$var$styles.enter,
            shouldAnimate && phase === 'exiting' && $e852c2f93196e24b$var$styles.exit,
            shouldAnimate && $e852c2f93196e24b$var$styles.motion,
            (0, $add6461460daa964$export$a274e22fb40f762e)(shouldAnimate && phase === 'entering' && enteringAnimationXcss, shouldAnimate && phase === 'exiting' && exitingAnimationXcss)
        ])
    }, children);
});



function $a33b0ecf1c143d78$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return (0, $99aafda47df47598$export$2e2bcd8739ae039)(r);
}


function $d011c5492d0f7fbc$export$2e2bcd8739ae039(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}



function $64a5cbd894d9280d$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}


function $700537a07df6e24c$export$2e2bcd8739ae039(r) {
    return (0, $a33b0ecf1c143d78$export$2e2bcd8739ae039)(r) || (0, $d011c5492d0f7fbc$export$2e2bcd8739ae039)(r) || (0, $740d51cc152e80e2$export$2e2bcd8739ae039)(r) || (0, $64a5cbd894d9280d$export$2e2bcd8739ae039)();
}


function $fa83bdb8bda1f588$export$2e2bcd8739ae039(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}



function $4b0243ab8a564108$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, (0, $03ba24f11b7522e6$export$2e2bcd8739ae039)(o.key), o);
    }
}
function $4b0243ab8a564108$export$2e2bcd8739ae039(e, r, t) {
    return r && $4b0243ab8a564108$var$_defineProperties(e.prototype, r), t && $4b0243ab8a564108$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}



var $5FkrB = parcelRequire("5FkrB");




function $77f192d5cd163981$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $77f192d5cd163981$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $77f192d5cd163981$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $cafa94341993c43e$export$2e2bcd8739ae039)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $77f192d5cd163981$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
/**
 * JS fallback positioning math. Used only when the browser does not
 * support CSS Anchor Positioning (less than 6% of users).
 *
 * Consumer-supplied `offset.gap` and `offset.crossAxisShift` are
 * honored: the caller (`useAnchorPosition`) resolves CSS length strings
 * (tokens, calc, var, etc) to pixels via a DOM probe before passing them
 * in. The caller also keeps the popover hidden (`opacity: 0`) until the
 * first measurement completes, so the popover never paints at the wrong
 * position.
 */ /**
 * A viewport-relative position, in pixels. Physical rather than logical
 * because it is written straight to `top` / `left`.
 */ /**
 * The cross-axis shift with its length already resolved to pixels.
 *
 * Mirrors `TCrossAxisShiftOffset`, whose `value` is an unresolved CSS length
 * string. Only this module needs the pixel form, because only this module does
 * the arithmetic itself.
 */ /**
 * Computes the base {top, left} position based on the primary edge,
 * flipping to the opposite side when there is not enough space.
 *
 * `gap` is applied along the main axis between trigger and popover.
 */ function $77f192d5cd163981$var$computeEdgePosition(_ref) {
    var axis = _ref.axis, edge = _ref.edge, triggerRect = _ref.triggerRect, popoverWidth = _ref.popoverWidth, popoverHeight = _ref.popoverHeight, viewport = _ref.viewport, gap = _ref.gap;
    if (axis === 'block' && edge === 'end') {
        // Below trigger
        var spaceBelow = viewport.height - triggerRect.bottom;
        var spaceAbove = triggerRect.top;
        var fitsBelow = spaceBelow >= popoverHeight + gap;
        var useBelow = fitsBelow || spaceBelow >= spaceAbove;
        return {
            top: useBelow ? triggerRect.bottom + gap : triggerRect.top - popoverHeight - gap,
            left: triggerRect.left + triggerRect.width / 2 - popoverWidth / 2
        };
    }
    if (axis === 'block' && edge === 'start') {
        // Above trigger
        var _spaceAbove = triggerRect.top;
        var _spaceBelow = viewport.height - triggerRect.bottom;
        var fitsAbove = _spaceAbove >= popoverHeight + gap;
        var useAbove = fitsAbove || _spaceAbove >= _spaceBelow;
        return {
            top: useAbove ? triggerRect.top - popoverHeight - gap : triggerRect.bottom + gap,
            left: triggerRect.left + triggerRect.width / 2 - popoverWidth / 2
        };
    }
    if (axis === 'inline' && edge === 'end') {
        // Right of trigger
        var spaceRight = viewport.width - triggerRect.right;
        var spaceLeft = triggerRect.left;
        var fitsRight = spaceRight >= popoverWidth + gap;
        var useRight = fitsRight || spaceRight >= spaceLeft;
        return {
            top: triggerRect.top + triggerRect.height / 2 - popoverHeight / 2,
            left: useRight ? triggerRect.right + gap : triggerRect.left - popoverWidth - gap
        };
    }
    if (axis === 'inline' && edge === 'start') {
        // Left of trigger
        var _spaceLeft = triggerRect.left;
        var _spaceRight = viewport.width - triggerRect.right;
        var fitsLeft = _spaceLeft >= popoverWidth + gap;
        var useLeft = fitsLeft || _spaceLeft >= _spaceRight;
        return {
            top: triggerRect.top + triggerRect.height / 2 - popoverHeight / 2,
            left: useLeft ? triggerRect.left - popoverWidth - gap : triggerRect.right + gap
        };
    }
    // Unreachable for valid placements; defaults to below trigger
    return {
        top: triggerRect.bottom + gap,
        left: triggerRect.left + triggerRect.width / 2 - popoverWidth / 2
    };
}
/**
 * Adjusts the base (centered) position for non-center alignments.
 *
 * `align: 'start'` → popover start edge at trigger start edge
 * `align: 'end'`   → popover end edge at trigger end edge
 */ function $77f192d5cd163981$var$applyAlignment(_ref2) {
    var position = _ref2.position, axis = _ref2.axis, align = _ref2.align, triggerRect = _ref2.triggerRect, popoverWidth = _ref2.popoverWidth, popoverHeight = _ref2.popoverHeight;
    if (align === 'center') return position;
    if (axis === 'block') {
        // Block-axis placement → cross-axis is inline (left/right)
        if (align === 'start') return $77f192d5cd163981$var$_objectSpread($77f192d5cd163981$var$_objectSpread({}, position), {}, {
            left: triggerRect.left
        });
        // align === 'end'
        return $77f192d5cd163981$var$_objectSpread($77f192d5cd163981$var$_objectSpread({}, position), {}, {
            left: triggerRect.right - popoverWidth
        });
    }
    // Inline-axis placement → cross-axis is block (top/bottom)
    if (align === 'start') return $77f192d5cd163981$var$_objectSpread($77f192d5cd163981$var$_objectSpread({}, position), {}, {
        top: triggerRect.top
    });
    // align === 'end'
    return $77f192d5cd163981$var$_objectSpread($77f192d5cd163981$var$_objectSpread({}, position), {}, {
        top: triggerRect.bottom - popoverHeight
    });
}
/**
 * Applies the cross-axis shift offset.
 *
 * `forwards` always moves the popover toward the cross-axis END and
 * `backwards` toward the START, for every `align` value. See
 * `notes/decisions/placement-offset.md`.
 *
 * This is a coordinate, so the direction is the sign and nothing else. There
 * is deliberately no per-`align` sign inversion here: the CSS path inverts the
 * sign only because a margin on the END side pushes a box the opposite way to
 * a margin on the START side, which is a property of margins rather than of
 * the shift. Applying that inversion to a coordinate moved `align: 'end'`
 * popovers the wrong way.
 */ function $77f192d5cd163981$var$applyCrossAxisShift(_ref3) {
    var position = _ref3.position, axis = _ref3.axis, crossAxisShift = _ref3.crossAxisShift;
    if (crossAxisShift.value === 0) return position;
    var directionSign = crossAxisShift.direction === 'forwards' ? 1 : -1;
    var delta = crossAxisShift.value * directionSign;
    // Cross-axis is the OPPOSITE of the placement axis.
    if (axis === 'block') return $77f192d5cd163981$var$_objectSpread($77f192d5cd163981$var$_objectSpread({}, position), {}, {
        left: position.left + delta
    });
    return $77f192d5cd163981$var$_objectSpread($77f192d5cd163981$var$_objectSpread({}, position), {}, {
        top: position.top + delta
    });
}
function $77f192d5cd163981$export$d5ef1dac02135664(_ref4) {
    var triggerRect = _ref4.triggerRect, popoverEl = _ref4.popoverEl, placement = _ref4.placement, viewport = _ref4.viewport, gap = _ref4.gap, crossAxisShift = _ref4.crossAxisShift;
    var axis = placement.axis, edge = placement.edge, align = placement.align;
    // Measure popover dimensions. Callers must ensure the popover has
    // laid out before calling this (it should not be `display: none`).
    var popoverWidth = popoverEl.offsetWidth;
    var popoverHeight = popoverEl.offsetHeight;
    var basePosition = $77f192d5cd163981$var$computeEdgePosition({
        axis: axis,
        edge: edge,
        triggerRect: triggerRect,
        popoverWidth: popoverWidth,
        popoverHeight: popoverHeight,
        viewport: viewport,
        gap: gap
    });
    var alignedPosition = $77f192d5cd163981$var$applyAlignment({
        position: basePosition,
        axis: axis,
        align: align,
        triggerRect: triggerRect,
        popoverWidth: popoverWidth,
        popoverHeight: popoverHeight
    });
    var shiftedPosition = $77f192d5cd163981$var$applyCrossAxisShift({
        position: alignedPosition,
        axis: axis,
        crossAxisShift: crossAxisShift
    });
    // Clamp to viewport so the popover is never offscreen
    return {
        top: Math.max(0, Math.min(shiftedPosition.top, viewport.height - popoverHeight)),
        left: Math.max(0, Math.min(shiftedPosition.left, viewport.width - popoverWidth))
    };
}


/**
 * Combine multiple cleanup functions into a single cleanup function.
 *
 * @example
 * ```ts
 * useEffect(() => {
 *   return combine(
 *     bind(window, { type: 'resize', listener: onResize }),
 *     bind(window, { type: 'scroll', listener: onScroll, options: { capture: true } }),
 *   );
 * }, []);
 * ```
 */ function $30bd93d71af75ed8$export$1be1fc439b849fdf() {
    for(var _len = arguments.length, cleanupFns = new Array(_len), _key = 0; _key < _len; _key++)cleanupFns[_key] = arguments[_key];
    return function cleanup() {
        cleanupFns.forEach(function(callback) {
            return callback === null || callback === void 0 ? void 0 : callback();
        });
    };
}



function $047ceb8b37ec202e$export$de49b61f233ddeb9(_ref) {
    var placement = _ref.placement;
    var _resolvePlacement = (0, $f4dcbc342eaa878e$export$63044d21bc3d3fa2)({
        placement: placement
    }), axis = _resolvePlacement.axis, edge = _resolvePlacement.edge, align = _resolvePlacement.align;
    var edgeValue = "".concat(axis, "-").concat(edge);
    if (align === 'center') return edgeValue;
    // Cross-axis name: block ↔ inline
    var crossAxis = axis === 'block' ? 'inline' : 'block';
    // Invert align → CSS span direction: visual 'start' → span toward 'end'
    var spanDir = align === 'start' ? 'end' : 'start';
    return "".concat(edgeValue, " span-").concat(crossAxis, "-").concat(spanDir);
}



/**
 * A `position-area` primary edge — the placement axis joined to its edge, e.g.
 * `block-end` or `inline-start`. These are the four edges a popover can sit on.
 */ function $90094b19b9a65452$var$slideOnEdge(_ref) {
    var align = _ref.align, edgeKey = _ref.edgeKey, crossAxis = _ref.crossAxis;
    if (align === 'center') return [
        "".concat(edgeKey, " span-").concat(crossAxis, "-end"),
        "".concat(edgeKey, " span-").concat(crossAxis, "-start")
    ];
    // For `align: 'start'` the popover expands toward `end`, so the "near"
    // span is `end` and the "far" span is `start`; `align: 'end'` mirrors
    // this. The bare `edgeKey` (re-centered) sits between them.
    var near = align === 'start' ? 'end' : 'start';
    var far = align === 'start' ? 'start' : 'end';
    return [
        "".concat(edgeKey, " span-").concat(crossAxis, "-").concat(near),
        edgeKey,
        "".concat(edgeKey, " span-").concat(crossAxis, "-").concat(far)
    ];
}
function $90094b19b9a65452$var$flipDiagonally(_ref2) {
    var axis = _ref2.axis;
    var flipOnMainAxis = axis === 'block' ? 'flip-block' : 'flip-inline';
    var flipToCrossAxis = axis === 'block' ? 'flip-inline' : 'flip-block';
    return "".concat(flipOnMainAxis, " ").concat(flipToCrossAxis);
}
function $90094b19b9a65452$export$c4e16947a95d61f1(_ref3) {
    var placement = _ref3.placement;
    /**
   * **Build the fallback list**
   *
   * Each entry is a complete alternative position.
   * The browser tries them _in order_ and uses the _first_ one that fits.
   */ var resolved = (0, $f4dcbc342eaa878e$export$63044d21bc3d3fa2)({
        placement: placement
    });
    var axis = resolved.axis, edge = resolved.edge, align = resolved.align;
    var crossAxis = axis === 'block' ? 'inline' : 'block';
    var flippedEdge = edge === 'start' ? 'end' : 'start';
    var sameEdgeArea = "".concat(axis, "-").concat(edge);
    var oppositeEdgeArea = "".concat(axis, "-").concat(flippedEdge);
    var flipOnMainAxis = axis === 'block' ? 'flip-block' : 'flip-inline';
    /**
   * **Fallback algorithm**
   *
   * We have two things we can do to keep something visible:
   *
   * 1. _Slide_ along edges
   * 2. _Flip_ to another edge
   *
   * _Centered popover_
   *
   * Desired: Sits in middle of main edge
   *
   * Fallbacks:
   *  1: _Slide_ along main edge on the cross axis
   *  2: _Flip_ on main axis to opposite edge (centered)
   *  3: _Slide_ along opposite edge on the cross axis
   *
   * _Start or end aligned popover_
   *
   * Desired: Sits at start / end of main edge
   *
   * Fallbacks:
   *  1: _Slide_ along main edge on the cross axis
   *  2: _Flip_ on main axis to opposite edge
   *  3: _Flip_ on the diagonal (flip main axis + flip cross axis) into the
   *     opposite corner. For start / end alignment, this is the clean escape
   *     when the popover would otherwise land offscreen on both axes (ie in a
   *     corner). Rule 4 gets the job done, but a slide drops the gap
   *     as named position-area values don't carry margins).
   *     The diagonal flip keeps the gap and the alignment.
   *  4: _Slide_ along opposite edge on the cross axis
   */ return [
        $90094b19b9a65452$var$slideOnEdge({
            align: align,
            edgeKey: sameEdgeArea,
            crossAxis: crossAxis
        }),
        flipOnMainAxis,
        align !== 'center' ? $90094b19b9a65452$var$flipDiagonally({
            axis: axis
        }) : null,
        $90094b19b9a65452$var$slideOnEdge({
            align: align,
            edgeKey: oppositeEdgeArea,
            crossAxis: crossAxis
        })
    ].filter(Boolean).flat().join(', ');
}


var $5cc3bfe0b31f7ad2$var$elementCaches = new WeakMap();
function $5cc3bfe0b31f7ad2$var$canCacheResolvedLength(value) {
    // Custom-property values can be retargeted by inline overrides on the
    // consumer's wrapper, so we cannot prove a cached pixel value is still valid.
    return !value.includes('var(');
}
function $5cc3bfe0b31f7ad2$var$getCachedResolvedLength(_ref) {
    var _cacheForElement$get;
    var element = _ref.element, value = _ref.value;
    if (!$5cc3bfe0b31f7ad2$var$canCacheResolvedLength(value)) return null;
    var cacheForElement = $5cc3bfe0b31f7ad2$var$elementCaches.get(element);
    return (_cacheForElement$get = cacheForElement === null || cacheForElement === void 0 ? void 0 : cacheForElement.get(value)) !== null && _cacheForElement$get !== void 0 ? _cacheForElement$get : null;
}
function $5cc3bfe0b31f7ad2$var$cacheResolvedLength(_ref2) {
    var _elementCaches$get;
    var element = _ref2.element, value = _ref2.value, result = _ref2.result;
    if (!$5cc3bfe0b31f7ad2$var$canCacheResolvedLength(value)) return;
    var cacheForElement = (_elementCaches$get = $5cc3bfe0b31f7ad2$var$elementCaches.get(element)) !== null && _elementCaches$get !== void 0 ? _elementCaches$get : new Map();
    cacheForElement.set(value, result);
    $5cc3bfe0b31f7ad2$var$elementCaches.set(element, cacheForElement);
}
function $5cc3bfe0b31f7ad2$export$98721546d2816d9e(_ref3) {
    var value = _ref3.value, container = _ref3.container;
    if (typeof value === 'number') return value;
    // Fast path: unitless zero is universally zero pixels - accept `'0'` and
    // `'-0'` without a probe. (Consumers occasionally pass `'0'` instead of
    // the number `0`.)
    if (value === '0' || value === '-0') return 0;
    // Fast path: bare `${n}px` strings come from the consumer normalisation
    // in `resolvePlacement`. Avoid a reflow when we can.
    var pxMatch = value.match(/^(-?\d+(?:\.\d+)?)px$/);
    if (pxMatch) return Number(pxMatch[1]);
    var cached = $5cc3bfe0b31f7ad2$var$getCachedResolvedLength({
        element: container,
        value: value
    });
    if (cached !== null) return cached;
    var probe = container.ownerDocument.createElement('div');
    probe.style.position = 'absolute';
    probe.style.visibility = 'hidden';
    probe.style.pointerEvents = 'none';
    probe.style.height = '0';
    probe.style.padding = '0';
    probe.style.border = '0';
    // `width` clamps negatives to 0; use `margin-left` instead so signs are
    // preserved. `getComputedStyle` returns the resolved pixel value for
    // margin-* properties even when the source was a token / calc / var.
    probe.style.marginLeft = value;
    // Hide the probe from assistive tech and event targeting; defensive
    // against `getElementsByTagName('div')` walks in consumer code.
    probe.setAttribute('aria-hidden', 'true');
    probe.setAttribute('inert', '');
    container.appendChild(probe);
    var resolved = parseFloat(getComputedStyle(probe).marginLeft);
    container.removeChild(probe);
    var result = Number.isFinite(resolved) ? resolved : 0;
    $5cc3bfe0b31f7ad2$var$cacheResolvedLength({
        element: container,
        value: value,
        result: result
    });
    return result;
}



/**
 * A single inline style declaration.
 *
 * `TProperty` narrows the property name for callers that write a known, closed
 * set of properties. Narrowing it lets a record keyed on those same names be
 * checked for exhaustiveness at compile time, rather than silently resolving to
 * `undefined` for a name that was never mapped.
 */ /**
 * Sets inline styles on an element and returns a cleanup function that
 * restores the prior inline values (so we do not stomp consumer styles).
 */ function $263aa0b8aa926efa$export$37a5fde709c1db82(_ref) {
    var element = _ref.element, styles = _ref.styles;
    // Snapshot the prior inline value (NOT the computed style - we only want
    // to restore values that the consumer/our previous run inlined). An empty
    // string means "no inline value", in which case cleanup uses removeProperty.
    var priorValues = styles.map(function(_ref2) {
        var property = _ref2.property;
        return {
            property: property,
            value: element.style.getPropertyValue(property)
        };
    });
    styles.forEach(function(_ref3) {
        var property = _ref3.property, value = _ref3.value;
        element.style.setProperty(property, value);
    });
    return function cleanup() {
        priorValues.forEach(function(_ref4) {
            var property = _ref4.property, value = _ref4.value;
            if (value === '') {
                element.style.removeProperty(property);
                return;
            }
            element.style.setProperty(property, value);
        });
    };
}


// `resolvePlacement` is intentionally NOT re-exported here - import it directly
// from `./resolve-placement` so search-and-jump lands at the source of truth.
/**
 * Module-scope no-op `ResizeObserver` used in non-DOM jest environments where
 * `ResizeObserver` is `undefined`. Hoisted out of the effect to avoid
 * allocating a new class declaration on every run.
 */ var $aba9b20dccd50d88$var$NoopResizeObserver = /*#__PURE__*/ function() {
    function NoopResizeObserver() {
        (0, $fa83bdb8bda1f588$export$2e2bcd8739ae039)(this, NoopResizeObserver);
    }
    return (0, $4b0243ab8a564108$export$2e2bcd8739ae039)(NoopResizeObserver, [
        {
            key: "observe",
            value: function observe() {}
        },
        {
            key: "unobserve",
            value: function unobserve() {}
        },
        {
            key: "disconnect",
            value: function disconnect() {}
        }
    ]);
}();
/**
 * Returns true when the popover is currently open. Wrapped because the
 * `:popover-open` pseudo-class is not implemented in some test environments
 * (e.g. jsdom), where `matches` throws on unknown selectors.
 */ function $aba9b20dccd50d88$var$isPopoverOpen(popover) {
    try {
        return popover.matches(':popover-open');
    } catch (_unused) {
        return false;
    }
}
/**
 * Detects whether the browser supports CSS Anchor Positioning.
 * Uses `once()` for lazy evaluation: safe for SSR and avoids hydration mismatches.
 */ var $aba9b20dccd50d88$var$supportsAnchorPositioning = (0, $86089df3a0fd54eb$export$2e2bcd8739ae039)(function() {
    if (typeof window === 'undefined' || typeof CSS === 'undefined' || typeof CSS.supports !== 'function') return false;
    return CSS.supports('anchor-name', '--a');
});
/**
 * Every logical margin property this module can write: one per axis, per side.
 *
 * Deriving the union from `TPlacementAxis` and `TPlacementEdge` rather than
 * writing the four names out keeps it in step with the placement model, and
 * makes `CROSS_AXIS_SHIFT_CUSTOM_PROPERTY` below exhaustive by construction.
 */ /**
 * The custom property mirroring each cross-axis shift margin.
 *
 * These are written for the planned named arrow `@position-try` rules. Nothing
 * reads them yet, and the shift no longer depends on them: the antisymmetric
 * margins written by `crossAxisShiftMargins` survive a cross-axis slide on
 * their own.
 *
 * Keyed on `TLogicalMarginProperty` and not on `string`, so a margin property
 * that has no custom property (or a custom property whose margin no longer
 * exists) is a compile error rather than an `undefined` lookup that reaches
 * `setStyle` as `{ property: undefined, value }`.
 */ var $aba9b20dccd50d88$var$CROSS_AXIS_SHIFT_CUSTOM_PROPERTY = {
    'margin-inline-start': '--ds-cross-axis-shift-margin-start',
    'margin-inline-end': '--ds-cross-axis-shift-margin-end',
    'margin-block-start': '--ds-cross-axis-shift-margin-block-start',
    'margin-block-end': '--ds-cross-axis-shift-margin-block-end'
};
var $aba9b20dccd50d88$var$ZEROED_CROSS_AXIS_SHIFT_CUSTOM_PROPERTIES = Object.values($aba9b20dccd50d88$var$CROSS_AXIS_SHIFT_CUSTOM_PROPERTY).map(function(property) {
    return {
        property: property,
        value: '0px'
    };
});
/**
 * Returns the CSS margin declaration that creates a gap between the
 * popover and its trigger on the side facing the anchor.
 *
 * For example, a `block-end` placement (popover below) gets
 * `margin-block-start: 8px` to push it away from the trigger's bottom edge.
 */ function $aba9b20dccd50d88$var$edgeMargin(_ref) {
    var placement = _ref.placement, offset = _ref.offset;
    var axis = placement.axis, edge = placement.edge;
    // The gap sits on the side FACING the anchor, which is always the side
    // opposite the placement edge.
    var anchorFacingEdge = edge === 'end' ? 'start' : 'end';
    return {
        property: "margin-".concat(axis, "-").concat(anchorFacingEdge),
        value: offset
    };
}
/**
 * **The cross-axis shift margins.**
 *
 * The shift is written antisymmetrically on BOTH cross-axis sides
 * (`start: +value`, `end: -value`) rather than as a single margin on the side
 * picked from `align`. Two separate behaviours require it:
 *
 * 1. **`align: 'center'` is centered with `anchor-center`, which centers the
 *    popover's MARGIN box on the anchor.** A single-sided margin widens the
 *    margin box, so it displaces the border box by only half its value. An
 *    antisymmetric pair leaves the margin box width unchanged (`+value` and
 *    `-value` sum to zero) while moving its center by the full value.
 * 2. **`position-try-fallbacks` can slide the popover onto the opposite
 *    cross-axis side.** A `<position-area>` fallback keeps the base style's
 *    margins, and margin on the un-anchored side has no effect, so a
 *    single-sided margin is silently dropped once the browser slides across the
 *    cross axis. With both sides written, whichever side ends up anchored moves
 *    the popover the same physical direction.
 *
 * Leaving the margin box width unchanged also means the shift does not move
 * the point at which `position-try-fallbacks` decides the popover overflows.
 *
 * A `<try-tactic>` fallback (`flip-block`, `flip-inline`) behaves differently to
 * a `<position-area>` one: it SWAPS the start and end margins rather than
 * keeping them, which is what preserves the gap through a flip. So a flip across
 * the cross axis mirrors the shift along with the rest of the placement, rather
 * than preserving its physical direction. Only the diagonal fallback does that,
 * and only for `align: 'start' | 'end'`. See `placementToTryFallbacks`.
 *
 * A positive value always moves the popover toward the cross-axis END, so
 * `direction: 'forwards'` means the same thing for every `align` value. See
 * `notes/decisions/placement-offset.md`.
 */ function $aba9b20dccd50d88$var$crossAxisShiftMargins(_ref2) {
    var placement = _ref2.placement, crossAxisShiftCssValue = _ref2.crossAxisShiftCssValue, direction = _ref2.direction;
    var crossAxis = placement.axis === 'block' ? 'inline' : 'block';
    // Wrap any string in calc() with the sign factor. CSS handles the math,
    // so opaque values such as design tokens negate correctly.
    var negated = "calc(-1 * ".concat(crossAxisShiftCssValue, ")");
    var isForwards = direction === 'forwards';
    return [
        {
            property: "margin-".concat(crossAxis, "-start"),
            value: isForwards ? crossAxisShiftCssValue : negated
        },
        {
            property: "margin-".concat(crossAxis, "-end"),
            value: isForwards ? negated : crossAxisShiftCssValue
        }
    ];
}
/**
 * Returns a referentially-stable, fully-resolved `TPlacement`. The memo is
 * keyed on the resolved primitive fields so a fresh inline `placement` object
 * (or undefined fields vs explicit defaults) does not produce a fresh result.
 */ function $aba9b20dccd50d88$var$useStablePlacement(placement) {
    var resolved = (0, $f4dcbc342eaa878e$export$63044d21bc3d3fa2)({
        placement: placement
    });
    var axis = resolved.axis;
    var edge = resolved.edge;
    var align = resolved.align;
    var gap = resolved.offset.gap;
    var shiftValue = resolved.offset.crossAxisShift.value;
    var shiftDirection = resolved.offset.crossAxisShift.direction;
    // Rebuild inside the memo from primitive deps so the factory does not
    // close over the outer `resolved` reference and exhaustive-deps can verify.
    return (0, $5FkrB.useMemo)(function() {
        return {
            axis: axis,
            edge: edge,
            align: align,
            offset: {
                gap: gap,
                crossAxisShift: {
                    value: shiftValue,
                    direction: shiftDirection
                }
            }
        };
    }, [
        axis,
        edge,
        align,
        gap,
        shiftValue,
        shiftDirection
    ]);
}
function $aba9b20dccd50d88$export$56b02a1e583f953c(_ref3) {
    var anchorRef = _ref3.anchorRef, popoverRef = _ref3.popoverRef, _ref3$placement = _ref3.placement, placement = _ref3$placement === void 0 ? {} : _ref3$placement, _ref3$forceFallbackPo = _ref3.forceFallbackPositioning, forceFallbackPositioning = _ref3$forceFallbackPo === void 0 ? false : _ref3$forceFallbackPo, _ref3$isEnabled = _ref3.isEnabled, isEnabled = _ref3$isEnabled === void 0 ? true : _ref3$isEnabled, isOpen = _ref3.isOpen;
    var id = (0, $5FkrB.useId)();
    var stablePlacement = $aba9b20dccd50d88$var$useStablePlacement(placement);
    (0, $5FkrB.useLayoutEffect)(function() {
        if (!isEnabled) return;
        var trigger = anchorRef.current;
        var popover = popoverRef.current;
        if (!trigger || !popover) return;
        var gapCssValue = stablePlacement.offset.gap;
        var crossAxisShiftCssValue = stablePlacement.offset.crossAxisShift.value;
        var shouldForceFallback = Boolean(forceFallbackPositioning);
        if ($aba9b20dccd50d88$var$supportsAnchorPositioning() && !shouldForceFallback) {
            // Reuse an existing `anchor-name` if the element already has one.
            // Another popover might already be anchored to the old name.
            var anchorName = trigger.style.getPropertyValue('anchor-name') || "--anchor-".concat(id.replace(/:/g, ''));
            var gap = $aba9b20dccd50d88$var$edgeMargin({
                placement: stablePlacement,
                offset: gapCssValue
            });
            // Computed once; also mirrored into the
            // `--ds-cross-axis-shift-margin-*` custom properties below.
            var crossAxisShift = $aba9b20dccd50d88$var$crossAxisShiftMargins({
                placement: stablePlacement,
                crossAxisShiftCssValue: crossAxisShiftCssValue,
                direction: stablePlacement.offset.crossAxisShift.direction
            });
            var popoverStyles = [
                {
                    property: 'position-anchor',
                    value: anchorName
                },
                {
                    property: 'position-area',
                    value: (0, $047ceb8b37ec202e$export$de49b61f233ddeb9)({
                        placement: stablePlacement
                    })
                },
                {
                    property: 'position-try-fallbacks',
                    value: (0, $90094b19b9a65452$export$c4e16947a95d61f1)({
                        placement: stablePlacement
                    })
                },
                // Reset browser default popover positioning that conflicts
                // with anchor positioning (UA: `inset: 0; margin: auto;`)
                {
                    property: 'margin',
                    value: '0'
                },
                {
                    property: 'inset',
                    value: 'auto'
                },
                gap
            ].concat((0, $700537a07df6e24c$export$2e2bcd8739ae039)(crossAxisShift), (0, $700537a07df6e24c$export$2e2bcd8739ae039)($aba9b20dccd50d88$var$ZEROED_CROSS_AXIS_SHIFT_CUSTOM_PROPERTIES), (0, $700537a07df6e24c$export$2e2bcd8739ae039)(crossAxisShift.map(function(_ref4) {
                var property = _ref4.property, value = _ref4.value;
                return {
                    property: $aba9b20dccd50d88$var$CROSS_AXIS_SHIFT_CUSTOM_PROPERTY[property],
                    value: value
                };
            })));
            /**
       * **We are never cleaning up anchor names**
       *
       * _Rationale_
       *
       * - Multiple popovers can share the same anchor element.
       * - Sometimes the `useAnchorPosition` hook and `Popover`
       *   are not in the same component.
       * - There can be times when, even with reference counting, we
       *   could remove the anchor-name while it is still being used
       *   by something else - especially with async react updates
       *   which can cause tearing
       *
       * _More_
       *
       * See `notes/decisions/anchor-name-lifetime.md`
       */ trigger.style.setProperty('anchor-name', anchorName);
            return (0, $263aa0b8aa926efa$export$37a5fde709c1db82)({
                element: popover,
                styles: popoverStyles
            });
        }
        // JS fallback. The popover is already in the top layer via
        // popover="auto", so we only reset UA defaults and set top/left
        // based on measurements.
        var cleanupBaseStyles = (0, $263aa0b8aa926efa$export$37a5fde709c1db82)({
            element: popover,
            styles: [
                {
                    property: 'margin',
                    value: '0'
                },
                {
                    property: 'inset',
                    value: 'auto'
                }
            ]
        });
        // The popover can be consumer-owned (`@atlaskit/popper`'s `createPopper`),
        // so restore prior inline values rather than removing ours.
        var undoPosition;
        var undoHide;
        // `opacity: 0` not `visibility: hidden`: Firefox skips visibility-hidden
        // elements during `<dialog>` initial-focus traversal.
        function hideUntilPositioned() {
            // Keep the first snapshot, else we capture our own `opacity: 0`.
            // (`!popover` is for TS: narrowing does not reach nested functions.)
            if (!popover || undoHide) return;
            undoHide = (0, $263aa0b8aa926efa$export$37a5fde709c1db82)({
                element: popover,
                styles: [
                    {
                        property: 'opacity',
                        value: '0'
                    }
                ]
            });
        }
        function reveal() {
            var _undoHide;
            (_undoHide = undoHide) === null || _undoHide === void 0 || _undoHide();
            undoHide = undefined;
        }
        function restorePosition() {
            var _undoPosition;
            (_undoPosition = undoPosition) === null || _undoPosition === void 0 || _undoPosition();
            undoPosition = undefined;
        }
        function update() {
            if (!trigger || !popover) return;
            var triggerRect = trigger.getBoundingClientRect();
            var viewport = {
                width: window.innerWidth,
                height: window.innerHeight
            };
            // Resolve consumer-supplied CSS length strings (tokens, calc, var,
            // px, rem, etc) to pixels. The probe is mounted INSIDE the popover
            // itself so the resolved length matches the scope a token would
            // resolve against from inside the popover content. (The popover
            // lives in the top layer, not the trigger's DOM tree, so probing
            // at `popover.parentElement` would resolve in a different scope
            // than the consumer's token authoring expects.)
            var gapPx = (0, $5cc3bfe0b31f7ad2$export$98721546d2816d9e)({
                value: gapCssValue,
                container: popover
            });
            var crossAxisShiftPx = (0, $5cc3bfe0b31f7ad2$export$98721546d2816d9e)({
                value: crossAxisShiftCssValue,
                container: popover
            });
            var _computeFallbackPosit = (0, $77f192d5cd163981$export$d5ef1dac02135664)({
                triggerRect: triggerRect,
                popoverEl: popover,
                placement: stablePlacement,
                viewport: viewport,
                gap: gapPx,
                crossAxisShift: {
                    value: crossAxisShiftPx,
                    direction: stablePlacement.offset.crossAxisShift.direction
                }
            }), top = _computeFallbackPosit.top, left = _computeFallbackPosit.left;
            // Restore first so the snapshot stays the consumer's value.
            restorePosition();
            undoPosition = (0, $263aa0b8aa926efa$export$37a5fde709c1db82)({
                element: popover,
                styles: [
                    {
                        property: 'top',
                        value: "".concat(top, "px")
                    },
                    {
                        property: 'left',
                        value: "".concat(left, "px")
                    }
                ]
            });
            reveal();
        }
        // Throttle scroll/resize updates to one per animation frame
        var scheduledUpdate = (0, $2fb72d4a32455831$export$2e2bcd8739ae039)(update);
        // Wait for the FIRST valid layout before measuring: the popover
        // is `display: none` until `showPopover()`, and some browsers
        // fire `toggle` before layout, so RAF-after-toggle is unreliable.
        // ResizeObserver fires once the browser has real dimensions.
        // Self-disconnects after one valid measurement; ongoing
        // scroll/resize is handled by the window listeners below.
        // `ResizeObserver` is missing in some non-DOM jest environments
        // (e.g. post-office's `node` environment). Fall back to a no-op
        // observer there. The scroll/resize listeners below still keep
        // the popover positioned in the rare case the consumer also
        // polyfilled `showPopover` but not `ResizeObserver`. Real
        // browsers always have it. The `NoopResizeObserver` class is
        // hoisted to module scope (see top of file) so we do not allocate
        // a new constructor on every effect run.
        var ResizeObserverImpl = typeof ResizeObserver !== 'undefined' ? ResizeObserver : $aba9b20dccd50d88$var$NoopResizeObserver;
        var resizeObserver = new ResizeObserverImpl(function() {
            if (popover.offsetWidth > 0 && popover.offsetHeight > 0) {
                update();
                resizeObserver.disconnect();
            }
        });
        // If the popover is already open by the time this effect runs (for
        // example, the parent `useAnchorPosition` effect runs after the child
        // `Popover` effect that called `showPopover()`), the initial `toggle`
        // event has already fired and our listener below would miss it. Start
        // observing immediately so the first measurement still happens.
        if ($aba9b20dccd50d88$var$isPopoverOpen(popover)) {
            hideUntilPositioned();
            resizeObserver.observe(popover);
        }
        var undoPositioning = (0, $30bd93d71af75ed8$export$1be1fc439b849fdf)(cleanupBaseStyles, // Each open needs a fresh measurement, so hide and re-observe.
        (0, $5b617c1f48263075$exports.bind)(popover, {
            type: 'toggle',
            listener: function listener(event) {
                var toggleEvent = event;
                if (toggleEvent.newState === 'open') {
                    hideUntilPositioned();
                    resizeObserver.observe(popover);
                }
            }
        }), function() {
            return resizeObserver.disconnect();
        }, (0, $5b617c1f48263075$exports.bind)(window, {
            type: 'scroll',
            listener: scheduledUpdate,
            options: {
                capture: true,
                passive: true
            }
        }), (0, $5b617c1f48263075$exports.bind)(window, {
            type: 'resize',
            listener: scheduledUpdate,
            options: {
                passive: true
            }
        }), function() {
            scheduledUpdate.cancel();
            restorePosition();
            reveal();
        });
        return undoPositioning;
    }, [
        anchorRef,
        popoverRef,
        stablePlacement,
        forceFallbackPositioning,
        isEnabled,
        id,
        isOpen
    ]);
}



var $5FkrB = parcelRequire("5FkrB");

/**
 * A point in viewport coordinates (CSS pixels) at which the synthetic
 * anchor should be placed.
 *
 * Axis-named (`x`/`y`) rather than edge-named (`left`/`top`) so the
 * shape is unambiguous in RTL writing modes - there is no ambiguity
 * about whether a coordinate is logical (`inline-start`/`block-start`)
 * or physical (`left`/`top`). Viewport coordinates are always
 * physical, so we name them with the physical axis labels.
 */ /**
 * Styles the synthetic anchor as an invisible, zero-size point.
 * Dynamic `inset-*` overrides are written by the positioning effect.
 *
 * Uses `Object.assign` rather than Compiled CSS (element is outside the React tree)
 * or the internal `setStyle` helper (we own this element entirely - it is created
 * and removed by this hook - so the snapshot/restore semantics `setStyle`
 * provides for caller-owned elements would be dead work here).
 */ function $a5aff0acadf8e7cc$var$applyStaticAnchorStyles(element) {
    Object.assign(element.style, {
        position: 'fixed',
        // `top`/`left` rather than `inset-block-start`/`inset-inline-start`
        // for consistency with the dynamic positioning effect below, which
        // uses physical properties (see comment there for the rationale).
        top: '0',
        left: '0',
        // Zero size - placement decides which side the popover sits on.
        width: '0',
        height: '0',
        // Prevent the overlay from intercepting pointer events.
        pointerEvents: 'none'
    });
}
function $a5aff0acadf8e7cc$export$6f230729189a5b8a(_ref) {
    var popoverRef = _ref.popoverRef, placement = _ref.placement, getPoint = _ref.getPoint, _ref$isEnabled = _ref.isEnabled, isEnabled = _ref$isEnabled === void 0 ? true : _ref$isEnabled, isOpen = _ref.isOpen;
    var syntheticAnchorRef = (0, $5FkrB.useRef)(null);
    // `getPoint` is kept in a ref so the layout effect can call the
    // latest version without listing it as a dep - that would re-fire
    // on every render and re-latch the point.
    var getPointRef = (0, $5FkrB.useRef)(getPoint);
    getPointRef.current = getPoint;
    // Lazy element creation: the `<div>` is only created when both
    // `isEnabled` is true AND `getPoint()` returns a non-null point.
    // `useLayoutEffect` ensures the element exists before the inner
    // `useAnchorPosition` (also a layout effect) reads the ref.
    (0, $5FkrB.useLayoutEffect)(function() {
        if (!isEnabled) return;
        var point = getPointRef.current();
        if (!point) return;
        var anchor = document.createElement('div');
        anchor.setAttribute('aria-hidden', 'true');
        $a5aff0acadf8e7cc$var$applyStaticAnchorStyles(anchor);
        // `point.x`/`y` are physical viewport coordinates (from
        // `MouseEvent.clientX/Y`), so map directly onto physical
        // `left`/`top`. This is RTL-safe: `position: fixed` + physical
        // insets is direction-independent. Using logical
        // `inset-inline-start` would need `viewportWidth - point.x` in
        // RTL to land at the same physical pixel.
        anchor.style.top = "".concat(point.y, "px");
        anchor.style.left = "".concat(point.x, "px");
        document.body.appendChild(anchor);
        syntheticAnchorRef.current = anchor;
        return function cleanup() {
            anchor.remove();
            syntheticAnchorRef.current = null;
        };
    }, [
        isEnabled
    ]);
    // Mirror `isEnabled` so both hooks stay in sync - when disabled,
    // neither this hook nor the inner one touches the popover, leaving
    // any other positioning the consumer has set up free to take effect.
    (0, $aba9b20dccd50d88$export$56b02a1e583f953c)({
        anchorRef: syntheticAnchorRef,
        popoverRef: popoverRef,
        placement: placement,
        isEnabled: isEnabled,
        isOpen: isOpen
    });
}


/* eslint-disable @atlaskit/design-system/no-direct-use-of-web-platform-drag-and-drop */ /**
 * We are listening directly to drag events instead of using a monitor from
 * `@atlaskit/pragmatic-drag-and-drop` to avoid the bundle size cost, as it
 * would affect almost every view in every app.
 *
 * We can reconsider this choice in the future.
 */ 
var $752ab03f37f22fda$var$registrations = new Set();
var $752ab03f37f22fda$var$cleanupEndEventListeners = null;
function $752ab03f37f22fda$var$onDragStart() {
    if ($752ab03f37f22fda$var$cleanupEndEventListeners) // If the cleanup function exists then we've already run this
    return;
    $752ab03f37f22fda$var$cleanupEndEventListeners = (0, $5b617c1f48263075$exports.bindAll)(window, [
        {
            type: 'dragend',
            listener: $752ab03f37f22fda$var$onDragEnd
        },
        {
            type: 'pointerdown',
            listener: $752ab03f37f22fda$var$onDragEnd
        },
        {
            type: 'pointermove',
            listener: function() {
                var callCount = 0;
                return function listener() {
                    // Using 20 as it is far bigger than the most observed (3)
                    if (callCount < 20) {
                        callCount++;
                        return;
                    }
                    $752ab03f37f22fda$var$onDragEnd();
                };
            }()
        }
    ]);
    var clone = Array.from($752ab03f37f22fda$var$registrations);
    clone.forEach(function(subscriber) {
        subscriber.onDragStart();
    });
}
function $752ab03f37f22fda$var$onDragEnd() {
    var _cleanupEndEventListe;
    (_cleanupEndEventListe = $752ab03f37f22fda$var$cleanupEndEventListeners) === null || _cleanupEndEventListe === void 0 || _cleanupEndEventListe();
    $752ab03f37f22fda$var$cleanupEndEventListeners = null;
    var clone = Array.from($752ab03f37f22fda$var$registrations);
    clone.forEach(function(subscriber) {
        subscriber.onDragEnd();
    });
}
function $752ab03f37f22fda$var$bindStartEvents() {
    return (0, $5b617c1f48263075$exports.bindAll)(window, [
        {
            type: 'dragstart',
            listener: $752ab03f37f22fda$var$onDragStart
        },
        {
            type: 'dragenter',
            listener: $752ab03f37f22fda$var$onDragStart
        }
    ]);
}
var $752ab03f37f22fda$var$cleanupStartEventListeners = null;
function $752ab03f37f22fda$export$6503ec6e8aabbaf(registration) {
    // if first registration, bind event listeners
    if (!$752ab03f37f22fda$var$cleanupStartEventListeners) // note: currently never unbinding these event listeners
    $752ab03f37f22fda$var$cleanupStartEventListeners = $752ab03f37f22fda$var$bindStartEvents();
    $752ab03f37f22fda$var$registrations.add(registration);
    /**
   * The reasoning for this behavior is so that if a tooltip mounts during
   * a drag it can still be suppressed.
   *
   * We use a separate callback instead of onDragStart to avoid infinite loops.
   */ registration.onRegister({
        isDragging: $752ab03f37f22fda$var$cleanupEndEventListeners !== null
    });
    return function unregister() {
        $752ab03f37f22fda$var$registrations.delete(registration);
        if ($752ab03f37f22fda$var$registrations.size === 0) {
            var _cleanupStartEventLis;
            (_cleanupStartEventLis = $752ab03f37f22fda$var$cleanupStartEventListeners) === null || _cleanupStartEventLis === void 0 || _cleanupStartEventLis();
            $752ab03f37f22fda$var$cleanupStartEventListeners = null;
        }
    };
}


/**
 * Returns the trigger's X edge for inline-axis placements, or the
 * trigger's horizontal center for block-axis placements.
 *
 * Note: does not account for RTL writing modes.
 */ function $042ebebdf3c8a5b8$var$getTriggerEdgeX(_ref) {
    var triggerRect = _ref.triggerRect, placement = _ref.placement;
    if (placement.axis === 'inline') return placement.edge === 'start' ? triggerRect.left : triggerRect.right;
    return triggerRect.left + triggerRect.width / 2;
}
/**
 * Returns the trigger's Y edge for block-axis placements, or the
 * trigger's vertical center for inline-axis placements.
 */ function $042ebebdf3c8a5b8$var$getTriggerEdgeY(_ref2) {
    var triggerRect = _ref2.triggerRect, placement = _ref2.placement;
    if (placement.axis === 'block') return placement.edge === 'start' ? triggerRect.top : triggerRect.bottom;
    return triggerRect.top + triggerRect.height / 2;
}
function $042ebebdf3c8a5b8$export$d26fd3d066ede49(_ref3) {
    var cursor = _ref3.cursor, triggerRect = _ref3.triggerRect, tooltipPosition = _ref3.tooltipPosition, placement = _ref3.placement;
    if (tooltipPosition === 'mouse-y') return {
        x: $042ebebdf3c8a5b8$var$getTriggerEdgeX({
            triggerRect: triggerRect,
            placement: placement
        }),
        y: cursor.clientY
    };
    if (tooltipPosition === 'mouse-x') return {
        x: cursor.clientX,
        y: $042ebebdf3c8a5b8$var$getTriggerEdgeY({
            triggerRect: triggerRect,
            placement: placement
        })
    };
    // tooltipPosition === 'mouse'
    return {
        x: cursor.clientX,
        y: cursor.clientY
    };
}


function $e8607a2d873b3355$export$2e68479e0a5d8746(mousePos, _ref) {
    var targetElement = _ref.targetElement, tooltipPosition = _ref.tooltipPosition;
    if (tooltipPosition === 'mouse') return {
        getBoundingClientRect: function getBoundingClientRect() {
            return DOMRect.fromRect({
                x: mousePos.clientX,
                y: mousePos.clientY,
                width: 0,
                height: 0
            });
        }
    };
    var targetRect = targetElement.getBoundingClientRect();
    if (tooltipPosition === 'mouse-x') return {
        getBoundingClientRect: function getBoundingClientRect() {
            return DOMRect.fromRect({
                x: mousePos.clientX,
                y: targetRect.top,
                width: 0,
                height: targetRect.height
            });
        }
    };
    if (tooltipPosition === 'mouse-y') return {
        getBoundingClientRect: function getBoundingClientRect() {
            return DOMRect.fromRect({
                x: targetRect.left,
                y: mousePos.clientY,
                width: targetRect.width,
                height: 0
            });
        }
    };
    throw new Error("Invalid tooltip position for virtual element: ".concat(tooltipPosition));
}



var $50U6m = parcelRequire("50U6m");
var $20886030c0da208f$var$delayId = null;
function $20886030c0da208f$var$clearScheduled() {
    if ($20886030c0da208f$var$delayId != null) {
        window.clearTimeout($20886030c0da208f$var$delayId);
        $20886030c0da208f$var$delayId = null;
    }
}
function $20886030c0da208f$var$scheduleTimeout(fn, delay) {
    $20886030c0da208f$var$clearScheduled();
    $20886030c0da208f$var$delayId = window.setTimeout(function() {
        $20886030c0da208f$var$delayId = null;
        fn();
    }, delay);
}
// This file is a singleton for managing tooltips.
//
// Once we roll out top-layer and remove the legacy path, this manager can be simplified:
// - Singleton: Can be removed; the platform (popover="auto" or popover="hint") already enforces
//   only one tooltip open at a time.
// - Phase machine: Can be simplified; drop hide-animating and finishHideAnimation (legacy fade-out).
//   Use e.g. pending-show | visible | pending-hide with immediate hide.
// - API: Can drop or simplify mousePosition/mousePos if no longer needed; keep delay scheduling,
//   keep(), requestHide, abort, and minimal lifecycle.
var $20886030c0da208f$var$active = null;
function $20886030c0da208f$export$57bf213be019eeb0(entry) {
    var phase = 'waiting-to-show';
    function isActive() {
        return Boolean($20886030c0da208f$var$active && $20886030c0da208f$var$active.entry === entry);
    }
    function cleanup() {
        if (isActive()) {
            $20886030c0da208f$var$clearScheduled();
            $20886030c0da208f$var$active = null;
        }
    }
    function done() {
        if (isActive()) entry.done();
        phase = 'done';
        cleanup();
    }
    function immediatelyHideAndDone() {
        if (isActive()) entry.hide({
            isImmediate: true
        });
        done();
    }
    function keep() {
        if (!isActive()) return;
        // aborting a wait to hide
        if (phase === 'waiting-to-hide') {
            phase = 'shown';
            $20886030c0da208f$var$clearScheduled();
            return;
        }
        // aborting hide animation
        if (phase === 'hide-animating') {
            phase = 'shown';
            $20886030c0da208f$var$clearScheduled();
            entry.show({
                isImmediate: false
            });
            return;
        }
    }
    function requestHide(_ref) {
        var isImmediate = _ref.isImmediate;
        if (!isActive()) return;
        // If we were not showing yet anyway; finish straight away
        if (phase === 'waiting-to-show') {
            immediatelyHideAndDone();
            return;
        }
        // already waiting to hide
        // Bug in legacy path: isImmediate hide requests are ignored during waiting-to-hide,
        // meaning Escape/scroll won't instantly dismiss a tooltip that's already fading out.
        // Gated fix: only apply the immediate-hide behavior under the top-layer flag for now.
        if (phase === 'waiting-to-hide') {
            if (isImmediate && (0, $50U6m.fg)('platform-dst-top-layer-tooltip')) immediatelyHideAndDone();
            return;
        }
        if (isImmediate) {
            immediatelyHideAndDone();
            return;
        }
        phase = 'waiting-to-hide';
        $20886030c0da208f$var$scheduleTimeout(function() {
            phase = 'hide-animating';
            entry.hide({
                isImmediate: false
            });
        }, entry.delay);
    }
    function finishHideAnimation() {
        if (isActive() && phase === 'hide-animating') done();
    }
    function isVisible() {
        return phase === 'shown' || phase === 'waiting-to-hide' || phase === 'hide-animating';
    }
    function start() {
        var shouldAlwaysFadeIn = entry.shouldAlwaysFadeIn;
        var showImmediately = Boolean($20886030c0da208f$var$active && $20886030c0da208f$var$active.isVisible()) && !shouldAlwaysFadeIn;
        // If there was an active tooltip; we tell it to remove itself at once!
        if ($20886030c0da208f$var$active) {
            $20886030c0da208f$var$clearScheduled();
            $20886030c0da208f$var$active.entry.hide({
                isImmediate: true
            });
            $20886030c0da208f$var$active.entry.done();
            $20886030c0da208f$var$active = null;
        }
        // this tooltip is now the active tooltip
        $20886030c0da208f$var$active = {
            entry: entry,
            isVisible: isVisible
        };
        function show() {
            phase = 'shown';
            entry.show({
                isImmediate: showImmediately
            });
        }
        if (showImmediately) {
            show();
            return;
        }
        phase = 'waiting-to-show';
        $20886030c0da208f$var$scheduleTimeout(show, entry.delay);
    }
    // let's get started!
    start();
    var result = {
        keep: keep,
        abort: cleanup,
        isActive: isActive,
        requestHide: requestHide,
        finishHideAnimation: finishHideAnimation,
        mousePos: entry.source.type === 'mouse' ? {
            clientX: entry.source.clientX,
            clientY: entry.source.clientY
        } : null
    };
    return result;
}



function $fe7aa1f51e629d74$export$6ee17796e3d70de2() {
    var uid = (0, $c797bf80d6171378$export$f680877a34711e37)();
    return function(id) {
        return "".concat(uid, "-").concat(id.toString());
    };
}


function $e266314cb40581a7$export$2e2bcd8739ae039(prefix, shouldRenderId) {
    var seed = (0, $fe7aa1f51e629d74$export$6ee17796e3d70de2)();
    return shouldRenderId ? "".concat(seed(prefix)) : undefined;
}


/* tooltip-container.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $5FkrB = parcelRequire("5FkrB");

/* tooltip-primitive.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $5FkrB = parcelRequire("5FkrB");

/* tooltip-shortcut.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $5FkrB = parcelRequire("5FkrB");

var $6f4cc550ae8ac983$var$styles = {
    shortcutSegmentsContainer: "_zulpv77o _1e0c1txw _1q511b66 _85i5v77o",
    shortcutSegment: "_11c8wadc _2rkolb4i _1dqonqa1 _189ee4h9 _1h6d1ihb _1e0c1txw _4cvr1h6o _4t3i1k92 _vchhusvi _1q51v77o _85i5v77o _bozg12x7 _y4ti12x7 _16qsn7od _1254n7od _cgnln7od _syazn7od _ahbqn7od _12l2n7od _1pfhn7od _6rthn7od _1ul9n7od _w19jn7od _bfhk261p"
};
var $6f4cc550ae8ac983$export$5bcbc43c84236222 = function TooltipShortcut(_ref) {
    var shortcut = _ref.shortcut;
    return /*#__PURE__*/ $5FkrB.createElement("div", {
        className: (0, $f7c504bd27672c29$export$2e2bcd8739ae039)([
            $6f4cc550ae8ac983$var$styles.shortcutSegmentsContainer
        ])
    }, shortcut.map(function(segment, index) {
        return /*#__PURE__*/ $5FkrB.createElement("kbd", {
            key: "".concat(segment, "-").concat(index),
            className: (0, $f7c504bd27672c29$export$2e2bcd8739ae039)([
                $6f4cc550ae8ac983$var$styles.shortcutSegment
            ])
        }, segment);
    }));
};


var $92a813cf9d41da56$var$primitiveStyles = null;
/**
 * The lower level component for rendering a tooltip.
 */ var $92a813cf9d41da56$var$TooltipPrimitive = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function TooltipPrimitive(_ref, ref) {
    var style = _ref.style, className = _ref.className, children = _ref.children, placement = _ref.placement, testId = _ref.testId, onMouseOut = _ref.onMouseOut, onMouseOver = _ref.onMouseOver, id = _ref.id, shortcut = _ref.shortcut, _ref$role = _ref.role, role = _ref$role === void 0 ? 'tooltip' : _ref$role;
    return /*#__PURE__*/ $5FkrB.createElement("div", {
        ref: ref,
        style: style,
        "data-testid": testId ? "".concat(testId, "--wrapper") : undefined
    }, /*#__PURE__*/ $5FkrB.createElement("div", {
        role: role,
        className: (0, $f7c504bd27672c29$export$2e2bcd8739ae039)([
            "_80om73ad",
            className
        ]),
        onMouseOut: onMouseOut,
        onMouseOver: onMouseOver,
        "data-placement": placement,
        "data-testid": testId,
        id: id
    }, children, shortcut && /*#__PURE__*/ $5FkrB.createElement((0, $6f4cc550ae8ac983$export$5bcbc43c84236222), {
        shortcut: shortcut
    })));
});
$92a813cf9d41da56$var$TooltipPrimitive.displayName = 'TooltipPrimitive';
var $92a813cf9d41da56$export$2e2bcd8739ae039 = $92a813cf9d41da56$var$TooltipPrimitive;


var $08315f6785ccbc22$var$styles = {
    base: "_2rkofajl _11c8wadc _vchhusvi _p12fp3fh _bfhk1aqn _syaz15cr _152tze3t _1e02ze3t _1i4q1hna _1q511b66 _85i51b66 _y4ti12x7 _bozg12x7 _slp31hna",
    truncate: "_1reo15vq _18m915vq _p12f1pna _1bto1l2s _o5721q9c"
};
/**
 * Used as the default tooltip container component for the exported `Tooltip` component.
 * Adds some styles to the tooltip primitive.
 */ var $08315f6785ccbc22$var$TooltipContainer = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function TooltipContainer(_ref, ref) {
    var style = _ref.style, className = _ref.className, children = _ref.children, truncate = _ref.truncate, placement = _ref.placement, testId = _ref.testId, onMouseOut = _ref.onMouseOut, onMouseOver = _ref.onMouseOver, id = _ref.id, shortcut = _ref.shortcut, role = _ref.role;
    return /*#__PURE__*/ $5FkrB.createElement((0, $92a813cf9d41da56$export$2e2bcd8739ae039), {
        ref: ref,
        style: style,
        className: (0, $f7c504bd27672c29$export$2e2bcd8739ae039)([
            $08315f6785ccbc22$var$styles.base,
            truncate && $08315f6785ccbc22$var$styles.truncate,
            className
        ]),
        placement: placement,
        testId: testId,
        id: id,
        onMouseOut: onMouseOut,
        onMouseOver: onMouseOver,
        shortcut: shortcut,
        role: role
    }, children);
});
$08315f6785ccbc22$var$TooltipContainer.displayName = 'TooltipContainer';
var $08315f6785ccbc22$export$2e2bcd8739ae039 = $08315f6785ccbc22$var$TooltipContainer;


function $32d4a3c4842e3ceb$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $32d4a3c4842e3ceb$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $32d4a3c4842e3ceb$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $cafa94341993c43e$export$2e2bcd8739ae039)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $32d4a3c4842e3ceb$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $32d4a3c4842e3ceb$var$tooltipZIndex = (0, $46bf0aae0dfb1de2$export$7be255094ccdc533).tooltip();
var $32d4a3c4842e3ceb$var$analyticsAttributes = {
    componentName: 'tooltip',
    packageName: "@atlaskit/tooltip",
    packageVersion: "24.2.1"
};
// Inverts motion direction
var $32d4a3c4842e3ceb$var$invertedDirection = {
    top: 'bottom',
    bottom: 'top',
    left: 'right',
    right: 'left'
};
/**
 * Converts a Popper placement to it's general direction.
 *
 * @param placement - Popper Placement value, e.g. 'top-start'
 * @returns Popper Direction, e.g. 'top'
 */ var $32d4a3c4842e3ceb$var$getDirectionFromPlacement = function getDirectionFromPlacement(placement) {
    return placement.split('-')[0];
};
/**
 * For the `platform-dst-top-layer-tooltip` path only. Always `false` when that
 * gate is off, so this cannot affect the legacy path even if it gains a caller
 * there.
 *
 * `mouseover` also fires when the pointer crosses boundaries between elements
 * _inside_ the trigger. A `relatedTarget` the trigger does not contain is what
 * distinguishes a real re-entry from one of those.
 */ function $32d4a3c4842e3ceb$var$isTopLayerPointerReEntry(_ref) {
    var trigger = _ref.trigger, relatedTarget = _ref.relatedTarget;
    if (!(0, $50U6m.fg)('platform-dst-top-layer-tooltip')) return false;
    // Missing trigger, or pointer from outside the document. Treat both as an
    // entry so we cannot get stuck suppressed.
    if (!trigger || !(relatedTarget instanceof Node)) return true;
    return !trigger.contains(relatedTarget);
}
/**
 * __Tooltip__
 *
 * A tooltip is a floating, non-actionable label used to explain a user interface element or feature.
 */ function $32d4a3c4842e3ceb$var$Tooltip(_ref2) {
    var children = _ref2.children, _ref2$position = _ref2.position, position = _ref2$position === void 0 ? 'bottom' : _ref2$position, _ref2$mousePosition = _ref2.mousePosition, mousePosition = _ref2$mousePosition === void 0 ? 'bottom' : _ref2$mousePosition, content = _ref2.content, _ref2$truncate = _ref2.truncate, truncate = _ref2$truncate === void 0 ? false : _ref2$truncate, _ref2$component = _ref2.component, Container = _ref2$component === void 0 ? (0, $08315f6785ccbc22$export$2e2bcd8739ae039) : _ref2$component, _ref2$tag = _ref2.tag, TargetContainer = _ref2$tag === void 0 ? 'div' : _ref2$tag, testId = _ref2.testId, _ref2$delay = _ref2.delay, delay = _ref2$delay === void 0 ? 300 : _ref2$delay, _ref2$onShow = _ref2.onShow, onShow = _ref2$onShow === void 0 ? (0, $adcefb868cf2fc9d$export$2e2bcd8739ae039) : _ref2$onShow, _ref2$onHide = _ref2.onHide, onHide = _ref2$onHide === void 0 ? (0, $adcefb868cf2fc9d$export$2e2bcd8739ae039) : _ref2$onHide, canAppear = _ref2.canAppear, _ref2$hideTooltipOnCl = _ref2.hideTooltipOnClick, hideTooltipOnClick = _ref2$hideTooltipOnCl === void 0 ? false : _ref2$hideTooltipOnCl, _ref2$hideTooltipOnMo = _ref2.hideTooltipOnMouseDown, hideTooltipOnMouseDown = _ref2$hideTooltipOnMo === void 0 ? false : _ref2$hideTooltipOnMo, analyticsContext = _ref2.analyticsContext, _ref2$strategy = _ref2.strategy, strategy = _ref2$strategy === void 0 ? 'fixed' : _ref2$strategy, _ref2$ignoreTooltipPo = _ref2.ignoreTooltipPointerEvents, ignoreTooltipPointerEvents = _ref2$ignoreTooltipPo === void 0 ? false : _ref2$ignoreTooltipPo, _ref2$isScreenReaderA = _ref2.isScreenReaderAnnouncementDisabled, isScreenReaderAnnouncementDisabled = _ref2$isScreenReaderA === void 0 ? false : _ref2$isScreenReaderA, shortcut = _ref2.shortcut, _ref2$shouldAlwaysFad = _ref2.shouldAlwaysFadeIn, shouldAlwaysFadeIn = _ref2$shouldAlwaysFad === void 0 ? false : _ref2$shouldAlwaysFad, _ref2$shouldRenderToP = _ref2.shouldRenderToParent, shouldRenderToParent = _ref2$shouldRenderToP === void 0 ? false : _ref2$shouldRenderToP;
    // Not using a gate for this check. When the gate is disabled `mouse-y` and `mouse-x` are treated as `mouse`.
    var isMousePosition = position === 'mouse' || position === 'mouse-y' || position === 'mouse-x';
    var tooltipPosition = isMousePosition ? mousePosition : position;
    var onShowHandler = (0, $290fa485630d1395$export$1a04351537078b55)($32d4a3c4842e3ceb$var$_objectSpread({
        fn: onShow,
        action: 'displayed',
        analyticsData: analyticsContext
    }, $32d4a3c4842e3ceb$var$analyticsAttributes));
    var onHideHandler = (0, $290fa485630d1395$export$1a04351537078b55)($32d4a3c4842e3ceb$var$_objectSpread({
        fn: onHide,
        action: 'hidden',
        analyticsData: analyticsContext
    }, $32d4a3c4842e3ceb$var$analyticsAttributes));
    var apiRef = (0, $5FkrB.useRef)(null);
    var _useState = (0, $5FkrB.useState)('hide'), _useState2 = (0, $10458117b712c01e$export$2e2bcd8739ae039)(_useState, 2), state = _useState2[0], setState = _useState2[1];
    var targetRef = (0, $5FkrB.useRef)(null);
    var containerRef = (0, $5FkrB.useRef)(null);
    // This function is deliberately _not_ memoized as it needs to re-run every render
    // to pick up any child ref changes. If you use render props you don't have this issue.
    var setImplicitRefFromChildren = function setImplicitRefFromChildren(node) {
        containerRef.current = node;
        targetRef.current = node ? node.firstElementChild : null;
    };
    // This is memoized and passed into the render props callback.
    var setDirectRef = (0, $5FkrB.useCallback)(function(node) {
        targetRef.current = node;
    }, []);
    // Putting a few things into refs so that we don't have to break memoization
    var stableState = (0, $2da2c910992d9a40$export$2e2bcd8739ae039)(state);
    // These props are placed in separate refs instead of a single object to reduce memory usage.
    // Placing them in the same object previously caused an increase in the number of JavaScript event listeners
    // before garbage collection.
    var onShowHandlerStable = (0, $2da2c910992d9a40$export$2e2bcd8739ae039)(onShowHandler);
    var onHideHandlerStable = (0, $2da2c910992d9a40$export$2e2bcd8739ae039)(onHideHandler);
    var delayStable = (0, $2da2c910992d9a40$export$2e2bcd8739ae039)(delay);
    var canAppearStable = (0, $2da2c910992d9a40$export$2e2bcd8739ae039)(canAppear);
    var hasCalledShowHandler = (0, $5FkrB.useRef)(false);
    var shouldAlwaysFadeInStable = (0, $2da2c910992d9a40$export$2e2bcd8739ae039)(shouldAlwaysFadeIn);
    var start = (0, $5FkrB.useCallback)(function(api) {
        apiRef.current = api;
        hasCalledShowHandler.current = false;
    }, []);
    var done = (0, $5FkrB.useCallback)(function() {
        if (!apiRef.current) return;
        // Only call onHideHandler if we have called onShowHandler
        if (hasCalledShowHandler.current) onHideHandlerStable.current();
        apiRef.current = null;
        hasCalledShowHandler.current = false;
        // just in case
        setState('hide');
    }, [
        onHideHandlerStable
    ]);
    var abort = (0, $5FkrB.useCallback)(function() {
        if (!apiRef.current) return;
        apiRef.current.abort();
        // Only call onHideHandler if we have called onShowHandler
        if (hasCalledShowHandler.current) onHideHandlerStable.current();
        apiRef.current = null;
    }, [
        onHideHandlerStable
    ]);
    (0, $5FkrB.useEffect)(function mount() {
        return function unmount() {
            if (apiRef.current) abort();
        };
    }, [
        abort
    ]);
    var isDraggingRef = (0, $5FkrB.useRef)(false);
    (0, $5FkrB.useEffect)(function() {
        return (0, $752ab03f37f22fda$export$6503ec6e8aabbaf)({
            onRegister: function onRegister(_ref3) {
                var isDragging = _ref3.isDragging;
                isDraggingRef.current = isDragging;
            },
            onDragStart: function onDragStart() {
                var _apiRef$current;
                /**
         * Hiding any visible tooltips when a drag starts because otherwise it
         * looks janky (disappears and reappears), and is not required.
         */ (_apiRef$current = apiRef.current) === null || _apiRef$current === void 0 || _apiRef$current.requestHide({
                    isImmediate: true
                });
                isDraggingRef.current = true;
            },
            onDragEnd: function onDragEnd() {
                isDraggingRef.current = false;
            }
        });
    }, []);
    // Set while a pointer press has dismissed the tooltip. Every read and write is
    // behind `platform-dst-top-layer-tooltip`, where `popover="hint"` owns pointer
    // dismissal, so the legacy path never sees this.
    var isTopLayerPointerDismissedRef = (0, $5FkrB.useRef)(false);
    var tryShowTooltip = (0, $5FkrB.useCallback)(function(source) {
        var _canAppearStable$curr;
        /**
     * Prevent tooltips from being shown during a drag. This can occur with
     * the native drag and drop API, where some pointer events can fire
     * when they should not and lead to jank with tooltips.
     */ if (isDraggingRef.current) return;
        // Another tooltip is has been active but we still have the old `api`
        // around. We need to finish up the last usage.
        // Note: just being safe - this should not happen
        if (apiRef.current && !apiRef.current.isActive()) abort();
        // This tooltip is already active, we can exit
        if (apiRef.current && apiRef.current.isActive()) {
            apiRef.current.keep();
            return;
        }
        /**
     * Stay dismissed until the trigger is re-entered or blurred. Otherwise
     * light dismiss hides on pointerup and the next `mouseover` from a
     * boundary crossing inside the trigger re-shows it. Deliberately after
     * the "already active" branch, so a held press stays visible.
     */ if (isTopLayerPointerDismissedRef.current && (0, $50U6m.fg)('platform-dst-top-layer-tooltip')) return;
        /**
     * Check if tooltip is allowed to show.
     *
     * Once a tooltip has started, or has scheduled to start
     * we won't be checking `canAppear` again.
     *
     * - We don't want tooltips to disappear once they are shown
     * - For consistency, we start after a single positive `canAppear`.
     *   Otherwise the amount of times we ask consumers would depend on
     *   how many times we get a "mousemove", which _could_ lead to situations
     *   where moving the mouse could result in a different outcome to if
     *   the mouse was not moved.
     */ if (canAppearStable.current && !((_canAppearStable$curr = canAppearStable.current) !== null && _canAppearStable$curr !== void 0 && _canAppearStable$curr.call(canAppearStable))) return;
        var entry = {
            source: source,
            delay: delayStable.current,
            show: function show(_ref4) {
                var isImmediate = _ref4.isImmediate;
                // Call the onShow handler if it hasn't been called yet
                if (!hasCalledShowHandler.current) {
                    hasCalledShowHandler.current = true;
                    onShowHandlerStable.current();
                }
                setState(!isImmediate ? 'fade-in' : 'show-immediate');
            },
            hide: function hide(_ref5) {
                var isImmediate = _ref5.isImmediate;
                if (isImmediate) setState('hide');
                else if ((0, $50U6m.fg)('platform-dst-top-layer-tooltip')) // Top-layer path: set state to 'top-layer-exit'. The component
                // stays mounted and Popover's isOpen prop transitions to
                // false, triggering the CSS exit animation internally.
                // finishHideAnimation is called after a brief delay matching
                // the CSS exit animation duration.
                setState('top-layer-exit');
                else setState('before-fade-out');
            },
            done: done,
            shouldAlwaysFadeIn: shouldAlwaysFadeInStable.current
        };
        var api = (0, $20886030c0da208f$export$57bf213be019eeb0)(entry);
        start(api);
    }, [
        canAppearStable,
        delayStable,
        done,
        start,
        abort,
        onShowHandlerStable,
        shouldAlwaysFadeInStable
    ]);
    var hideTooltipOnEsc = (0, $5FkrB.useCallback)(function() {
        var _apiRef$current2;
        (_apiRef$current2 = apiRef.current) === null || _apiRef$current2 === void 0 || _apiRef$current2.requestHide({
            isImmediate: true
        });
    }, [
        apiRef
    ]);
    // When using top-layer, popover="auto" handles Escape natively
    (0, $cc68d04423a653c6$export$2e2bcd8739ae039)({
        onClose: hideTooltipOnEsc,
        isDisabled: state === 'hide' || state === 'fade-out' || state === 'top-layer-exit' || (0, $50U6m.fg)('platform-dst-top-layer-tooltip')
    });
    // ── Top-layer exit animation lifecycle ──
    // When state is 'top-layer-exit', Popover's isOpen transitions to false and
    // the CSS exit animation plays. The Popover's built-in `transitionend`
    // detection (with timeout fallback) calls `onExitFinish` when the exit
    // animation completes, which triggers the tooltip-manager lifecycle
    // (finishHideAnimation → done → onHide, setState('hide'), cleanup).
    var handleExitFinish = (0, $5FkrB.useCallback)(function() {
        var _apiRef$current3;
        (_apiRef$current3 = apiRef.current) === null || _apiRef$current3 === void 0 || _apiRef$current3.finishHideAnimation();
    }, []);
    // Browser dismiss (light dismiss on pointerup, or Escape). Recorded so we stay
    // hidden until the trigger is re-entered. Only wired up on the top-layer path,
    // but gated anyway to keep every use of the ref flag-checked.
    var handlePopoverClose = (0, $5FkrB.useCallback)(function() {
        var _apiRef$current4;
        if ((0, $50U6m.fg)('platform-dst-top-layer-tooltip')) isTopLayerPointerDismissedRef.current = true;
        (_apiRef$current4 = apiRef.current) === null || _apiRef$current4 === void 0 || _apiRef$current4.requestHide({
            isImmediate: true
        });
    }, []);
    (0, $5FkrB.useEffect)(function() {
        if (state === 'hide') return 0, $adcefb868cf2fc9d$export$2e2bcd8739ae039;
        if (state === 'before-fade-out') setState('fade-out');
        var unbind = (0, $5b617c1f48263075$exports.bind)(window, {
            type: 'scroll',
            listener: function listener() {
                if (apiRef.current) apiRef.current.requestHide({
                    isImmediate: true
                });
            },
            options: {
                capture: true,
                passive: true,
                once: true
            }
        });
        return unbind;
    }, [
        state
    ]);
    var onMouseDown = (0, $5FkrB.useCallback)(function() {
        // Native light dismiss hides on pointerup, not here. Recorded now so the
        // tooltip stays dismissed afterwards.
        if ((0, $50U6m.fg)('platform-dst-top-layer-tooltip')) isTopLayerPointerDismissedRef.current = true;
        // A press inside the show delay never reaches light dismiss, because no
        // popover is open on pointerup. Cancel the pending show so a quick click
        // does not surface a tooltip over content the press just changed.
        var shouldCancelPendingShow = stableState.current === 'hide' && (0, $50U6m.fg)('platform-dst-top-layer-tooltip');
        if ((hideTooltipOnMouseDown || shouldCancelPendingShow) && apiRef.current) apiRef.current.requestHide({
            isImmediate: true
        });
    }, [
        hideTooltipOnMouseDown,
        stableState
    ]);
    var onClick = (0, $5FkrB.useCallback)(function() {
        if (hideTooltipOnClick && apiRef.current) apiRef.current.requestHide({
            isImmediate: true
        });
    }, [
        hideTooltipOnClick
    ]);
    // Ideally we would be using onMouseEnter here, but
    // because we are binding the event to the target parent
    // we need to listen for the mouseover of all sub elements
    // This means when moving along a tooltip we are quickly toggling
    // between api.requestHide and api.keep. This it not ideal
    var onMouseOver = (0, $5FkrB.useCallback)(function(event) {
        // Ignoring events from the container ref
        if (containerRef.current && event.target === containerRef.current) return;
        // Using prevent default as a signal that parent tooltips
        if (event.defaultPrevented) return;
        event.preventDefault();
        // Re-arm on a real re-entry, not on a boundary crossing inside the trigger.
        if ($32d4a3c4842e3ceb$var$isTopLayerPointerReEntry({
            trigger: targetRef.current,
            relatedTarget: event.relatedTarget
        }) && (0, $50U6m.fg)('platform-dst-top-layer-tooltip')) isTopLayerPointerDismissedRef.current = false;
        var source = isMousePosition ? {
            type: 'mouse',
            clientX: event.clientX,
            clientY: event.clientY
        } : {
            type: 'keyboard'
        };
        tryShowTooltip(source);
    }, [
        isMousePosition,
        tryShowTooltip
    ]);
    // Ideally we would be using onMouseEnter here, but
    // because we are binding the event to the target parent
    // we need to listen for the mouseout of all sub elements
    // This means when moving along a tooltip we are quickly toggling
    // between api.requestHide and api.keep. This it not ideal
    var onMouseOut = (0, $5FkrB.useCallback)(function(event) {
        // Ignoring events from the container ref
        if (containerRef.current && event.target === containerRef.current) return;
        // Using prevent default as a signal that parent tooltips
        if (event.defaultPrevented) return;
        event.preventDefault();
        if (apiRef.current) apiRef.current.requestHide({
            isImmediate: false
        });
    }, []);
    var onMouseMove = isMousePosition ? function(event) {
        var _apiRef$current5;
        if ((_apiRef$current5 = apiRef.current) !== null && _apiRef$current5 !== void 0 && _apiRef$current5.isActive()) apiRef.current.mousePos = {
            clientX: event.clientX,
            clientY: event.clientY
        };
    } : undefined;
    var onMouseOverTooltip = (0, $5FkrB.useCallback)(function() {
        if (apiRef.current && apiRef.current.isActive()) {
            apiRef.current.keep();
            return;
        }
    }, []);
    var onFocus = (0, $5FkrB.useCallback)(function(e) {
        // Check if focus-visible
        // Prevents tooltips from showing when focus is not visible,
        // i.e., when focus is moved onto tooltip trigger inside a popup on open
        try {
            if (!e.target.matches(':focus-visible')) return;
        } catch (_unused) {
        // Ignore errors from environments that don't support :focus-visible
        }
        // TODO: this does not play well with `hideTooltipOnMouseDown`
        // as "focus" will occur after the "mousedown".
        tryShowTooltip({
            type: 'keyboard'
        });
    }, [
        tryShowTooltip
    ]);
    var onBlur = (0, $5FkrB.useCallback)(function() {
        // Focus leaving ends the dismissal, so focus coming back can show the tooltip.
        if ((0, $50U6m.fg)('platform-dst-top-layer-tooltip')) isTopLayerPointerDismissedRef.current = false;
        if (apiRef.current) apiRef.current.requestHide({
            isImmediate: false
        });
    }, []);
    var onAnimationFinished = (0, $5FkrB.useCallback)(function(transition) {
        // Using lastState here because motion is not picking up the latest value
        if (transition === 'exiting' && stableState.current === 'fade-out' && apiRef.current) apiRef.current.finishHideAnimation();
    }, [
        stableState
    ]);
    // Doing a cast because typescript is struggling to narrow the type
    var CastTargetContainer = TargetContainer;
    var shouldRenderTooltipPopup = state !== 'hide' && Boolean(content);
    var shouldRenderHiddenContent = !isScreenReaderAnnouncementDisabled && shouldRenderTooltipPopup;
    var shouldRenderTooltipChildren = state !== 'hide' && state !== 'fade-out' && state !== 'top-layer-exit';
    var handleOpenLayerObserverCloseSignal = (0, $5FkrB.useCallback)(function() {
        var _apiRef$current6;
        (_apiRef$current6 = apiRef.current) === null || _apiRef$current6 === void 0 || _apiRef$current6.requestHide({
            isImmediate: true
        });
    }, []);
    // Registered unconditionally so the hook order never depends on the feature
    // flag value. On the top-layer path the Popover primitive (used by
    // TopLayerTooltipPopup) registers with the observer directly, so we pass
    // isOpen: false to avoid double-counting (the hook is a no-op while the
    // layer is not open).
    (0, $dc4b45f7ee6225f5$export$469bb693f11edc7f)({
        // Layer is only visually open if both the tooltip popup (container) and children are rendered.
        isOpen: (0, $50U6m.fg)('platform-dst-top-layer-tooltip') ? false : shouldRenderTooltipPopup && shouldRenderTooltipChildren,
        /**
     * We don't strictly need to provide an onClose callback at this time, as there is
     * already code that handles hiding the tooltip when a drag is started (and the only
     * usage right now is closing all layers when the user resizes the side nav).
     *
     * However, for future-proofing and semantic reasons, it makes sense to close the tooltip
     * whenever the open layer observer requests a close.
     */ onClose: handleOpenLayerObserverCloseSignal
    });
    var getReferenceElement = function getReferenceElement() {
        var _apiRef$current7;
        if (isMousePosition && (_apiRef$current7 = apiRef.current) !== null && _apiRef$current7 !== void 0 && _apiRef$current7.mousePos && targetRef.current) return (0, $e8607a2d873b3355$export$2e68479e0a5d8746)(apiRef.current.mousePos, {
            targetElement: targetRef.current,
            tooltipPosition: position
        });
        return targetRef.current || undefined;
    };
    var tooltipIdForHiddenContent = (0, $e266314cb40581a7$export$2e2bcd8739ae039)('tooltip', shouldRenderHiddenContent);
    var tooltipTriggerProps = {
        onMouseOver: onMouseOver,
        onMouseOut: onMouseOut,
        onMouseMove: onMouseMove,
        onMouseDown: onMouseDown,
        onClick: onClick,
        onFocus: onFocus,
        onBlur: onBlur
    };
    // This useEffect is purely for managing the aria attribute when using the
    // wrapped children approach.
    var isChildrenAFunction = typeof children === 'function';
    (0, $5FkrB.useEffect)(function() {
        if (isChildrenAFunction) return;
        // If `children` is _not_ a function, we are stepping outside of the public
        // API to add a `aria-describedby` attribute.
        var target = targetRef.current;
        if (!target || !tooltipIdForHiddenContent) return;
        target.setAttribute('aria-describedby', tooltipIdForHiddenContent);
        return function() {
            return target.removeAttribute('aria-describedby');
        };
    }, [
        isChildrenAFunction,
        tooltipIdForHiddenContent
    ]);
    var hiddenContent = shouldRenderHiddenContent ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("span", {
        "data-testid": testId ? "".concat(testId, "-hidden") : undefined,
        hidden: true,
        id: tooltipIdForHiddenContent
    }, typeof content === 'function' ? content({}) : content) : null;
    var PopperWrapper = shouldRenderToParent ? (0, $5FkrB.Fragment) : $32d4a3c4842e3ceb$var$TooltipPortal;
    var trigger = typeof children === 'function' ? /*#__PURE__*/ // once we deprecate the wrapped approach, we can put the aria
    // attribute back into the tooltipTriggerProps and make it required
    // instead of optional in `types`
    (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $5FkrB.Fragment), null, children($32d4a3c4842e3ceb$var$_objectSpread($32d4a3c4842e3ceb$var$_objectSpread($32d4a3c4842e3ceb$var$_objectSpread({}, tooltipTriggerProps), testId ? {
        testId: "".concat(testId, "--container")
    } : {}), {}, {
        'aria-describedby': tooltipIdForHiddenContent,
        ref: setDirectRef
    })), hiddenContent) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(CastTargetContainer, (0, $00d9cef35b686d13$export$2e2bcd8739ae039)({}, tooltipTriggerProps, testId ? {
        'data-testid': "".concat(testId, "--container")
    } : undefined, {
        ref: setImplicitRefFromChildren,
        role: "presentation"
    }), children, hiddenContent);
    if ((0, $50U6m.fg)('platform-dst-top-layer-tooltip')) {
        var _apiRef$current$mouse, _apiRef$current8;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $5FkrB.Fragment), null, trigger, shouldRenderTooltipPopup ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement($32d4a3c4842e3ceb$var$TopLayerTooltipPopup, {
            targetRef: targetRef,
            tooltipPosition: tooltipPosition,
            mousePos: (_apiRef$current$mouse = (_apiRef$current8 = apiRef.current) === null || _apiRef$current8 === void 0 ? void 0 : _apiRef$current8.mousePos) !== null && _apiRef$current$mouse !== void 0 ? _apiRef$current$mouse : undefined,
            position: position,
            onMouseOut: onMouseOut,
            onMouseOverTooltip: onMouseOverTooltip,
            ignoreTooltipPointerEvents: ignoreTooltipPointerEvents,
            truncate: truncate,
            testId: testId,
            shortcut: shortcut,
            content: content,
            Container: Container,
            onClose: handlePopoverClose,
            onExitFinish: handleExitFinish,
            isOpen: state !== 'hide' && state !== 'top-layer-exit'
        }) : null);
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $5FkrB.Fragment), null, trigger, shouldRenderTooltipPopup ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(PopperWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $42e5b75ea169c552$export$badac9ada3a0bdf9), {
        placement: tooltipPosition,
        referenceElement: getReferenceElement(),
        strategy: strategy
    }, function(_ref6) {
        var ref = _ref6.ref, style = _ref6.style, update = _ref6.update, placement = _ref6.placement;
        var direction = isMousePosition ? undefined : $32d4a3c4842e3ceb$var$invertedDirection[$32d4a3c4842e3ceb$var$getDirectionFromPlacement(placement)];
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $7dce5bdaf433551a$export$2e2bcd8739ae039), {
            appear: true
        }, shouldRenderTooltipChildren && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $faf8d110486344ab$export$2e2bcd8739ae039), {
            distance: "constant",
            entranceDirection: direction,
            exitDirection: direction,
            onFinish: onAnimationFinished,
            duration: state !== 'show-immediate' ? 'medium' : 'none'
        }, function(_ref7) {
            var className = _ref7.className;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(Container, {
                ref: ref,
                className: "Tooltip ".concat(className),
                style: $32d4a3c4842e3ceb$var$_objectSpread($32d4a3c4842e3ceb$var$_objectSpread({}, style), ignoreTooltipPointerEvents && {
                    pointerEvents: 'none'
                }),
                truncate: truncate,
                placement: tooltipPosition,
                testId: getReferenceElement() ? testId : testId && "".concat(testId, "--unresolved"),
                onMouseOut: onMouseOut,
                onMouseOver: onMouseOverTooltip,
                shortcut: shortcut
            }, typeof content === 'function' ? content({
                update: update
            }) : content);
        }));
    })) : null);
}
var $32d4a3c4842e3ceb$export$2e2bcd8739ae039 = $32d4a3c4842e3ceb$var$Tooltip;
var $32d4a3c4842e3ceb$var$TooltipPortal = function TooltipPortal(_ref8) {
    var children = _ref8.children;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $b972fda2d5cd73a8$export$2e2bcd8739ae039), {
        zIndex: $32d4a3c4842e3ceb$var$tooltipZIndex
    }, children);
};
var $32d4a3c4842e3ceb$var$tooltipMouseAnimationStyles = {
    enter: "_j7hq1bym",
    exit: "_j7hq1a5s"
};
/**
 * Top-layer tooltip popup component.
 *
 * Composes `Popover` (top-layer visibility + animation) with one of two
 * positioning hooks:
 *
 *   - `useAnchorPositionAtPoint` — for cursor-tracking positions
 *     (`mouse`, `mouse-x`, `mouse-y`) when a cursor position is
 *     available (i.e. the popup was activated by a pointer). Positions
 *     the popover relative to a hidden synthetic anchor that follows
 *     the cursor according to the `position` / `mousePosition`
 *     semantics. The synthetic anchor element is rendered as a sibling
 *     of the popover.
 *   - `useAnchorPosition` directly — for non-cursor positions, AND
 *     for cursor positions activated via keyboard focus (where there
 *     is no cursor to track). Anchoring directly to the trigger keeps
 *     keyboard-activated tooltips correctly placed next to the target
 *     instead of rendering in the top-left of the viewport.
 *
 * Exactly one positioning strategy is active at a time: `useAnchorPosition`
 * is wired to the trigger only when the mouse strategy is inactive, and
 * `useAnchorPositionAtPoint` is told `isActive: false` when the direct
 * anchor strategy is active. The other hook is still called (Rules of
 * Hooks) but does no work.
 *
 * Exit animation is handled by `Popover`'s `isOpen` prop. When `isOpen`
 * transitions to `false`, the primitive calls `hidePopover()` internally and
 * the CSS exit animation plays via `allow-discrete`. No glue code needed.
 */ function $32d4a3c4842e3ceb$var$TopLayerTooltipPopup(_ref9) {
    var targetRef = _ref9.targetRef, tooltipPosition = _ref9.tooltipPosition, mousePos = _ref9.mousePos, position = _ref9.position, onMouseOut = _ref9.onMouseOut, onMouseOverTooltip = _ref9.onMouseOverTooltip, ignoreTooltipPointerEvents = _ref9.ignoreTooltipPointerEvents, truncate = _ref9.truncate, testId = _ref9.testId, shortcut = _ref9.shortcut, content = _ref9.content, Container = _ref9.Container, onClose = _ref9.onClose, onExitFinish = _ref9.onExitFinish, isOpen = _ref9.isOpen;
    var popoverRef = (0, $5FkrB.useRef)(null);
    // Translate the legacy Popper-style placement string ("right",
    // "bottom-start", etc.) once and pass the same object to both hooks.
    var placement = (0, $ff16da3649f6ba73$export$69e99ed50b2534c9)({
        legacy: tooltipPosition
    });
    var isMousePosition = position === 'mouse' || position === 'mouse-x' || position === 'mouse-y';
    var isMouseStrategyActive = isMousePosition && Boolean(mousePos);
    // Direct anchor strategy: anchors to the trigger element.
    // Disabled when the mouse strategy is active — both hooks writing
    // to the same popover would fight for positioning ownership.
    (0, $aba9b20dccd50d88$export$56b02a1e583f953c)({
        anchorRef: targetRef,
        popoverRef: popoverRef,
        placement: placement,
        isEnabled: !isMouseStrategyActive,
        isOpen: isOpen
    });
    // Mouse anchor strategy: the hook calls `getPoint()` exactly once
    // per activation and latches the resulting coordinate. The latch is
    // per-show because `TopLayerTooltipPopup` mounts fresh on every
    // show.
    //
    // `getPoint()` returns `null` for keyboard-activated shows (where
    // `mousePos` is undefined) or before the trigger has mounted —
    // leaving the direct strategy above to own positioning.
    //
    // SSR note: `getBoundingClientRect()` is only called here because
    // `TopLayerTooltipPopup` is gated behind client-only state
    // transitions.
    (0, $a5aff0acadf8e7cc$export$6f230729189a5b8a)({
        popoverRef: popoverRef,
        placement: placement,
        isEnabled: isMouseStrategyActive,
        isOpen: isOpen,
        getPoint: function getPoint() {
            if (!mousePos || !targetRef.current || !isMousePosition) return null;
            return (0, $042ebebdf3c8a5b8$export$d26fd3d066ede49)({
                cursor: mousePos,
                triggerRect: targetRef.current.getBoundingClientRect(),
                tooltipPosition: position,
                placement: placement
            });
        }
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $e852c2f93196e24b$export$5b6b19405a83ff9d), {
        ref: popoverRef,
        role: "tooltip",
        mode: "hint",
        isOpen: isOpen,
        onClose: onClose,
        onExitFinish: onExitFinish,
        testId: testId ? "".concat(testId, "--popover") : undefined,
        shouldAnimate: true,
        enteringAnimationXcss: isMouseStrategyActive && $32d4a3c4842e3ceb$var$tooltipMouseAnimationStyles.enter,
        exitingAnimationXcss: isMouseStrategyActive && $32d4a3c4842e3ceb$var$tooltipMouseAnimationStyles.exit,
        placement: placement
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(Container, {
        className: "Tooltip",
        style: ignoreTooltipPointerEvents ? {
            pointerEvents: 'none'
        } : undefined,
        truncate: truncate,
        placement: tooltipPosition,
        testId: testId,
        onMouseOut: onMouseOut,
        onMouseOver: onMouseOverTooltip,
        shortcut: shortcut,
        role: "presentation"
    }, typeof content === 'function' ? content({
        update: (0, $adcefb868cf2fc9d$export$2e2bcd8739ae039)
    }) : content));
}



var $5FkrB = parcelRequire("5FkrB");

var $063f49374ce1ab43$export$93d4e7f90805808f = function useTheme() {
    return (0, $5FkrB.useContext)((0, $dcab9c7966c8b191$export$2c657da244d00bd6));
};



function $1572bef186bf27f4$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $1572bef186bf27f4$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $1572bef186bf27f4$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $d93598d00ce909df$export$2e2bcd8739ae039)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $1572bef186bf27f4$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $1572bef186bf27f4$export$14dd6915caf431fe = function getPrimaryButtonTheme(_ref) {
    var primaryButton = _ref.mode.primaryButton;
    return function(current, props) {
        var _current = current(props), buttonStyles = _current.buttonStyles, spinnerStyles = _current.spinnerStyles;
        return {
            buttonStyles: $1572bef186bf27f4$var$_objectSpread($1572bef186bf27f4$var$_objectSpread($1572bef186bf27f4$var$_objectSpread($1572bef186bf27f4$var$_objectSpread({}, buttonStyles), primaryButton.default), props.isSelected && primaryButton.selected), {}, {
                fontWeight: "var(--ds-font-weight-medium, 500)",
                padding: "0 ".concat("var(--ds-space-050, 4px)"),
                marginLeft: 0,
                marginRight: 0,
                ':hover': props.isSelected ? primaryButton.selectedHover : primaryButton.hover,
                ':focus': primaryButton.focus,
                // :active doesn't work in FF, because we do a
                // e.preventDefault() on mouse down in Button.
                // '&&' is required to add more CSS specificity
                // && it not a valid CSSObject property
                '&&': $1572bef186bf27f4$var$_objectSpread({}, props.state === 'active' && primaryButton.active)
            }),
            spinnerStyles: spinnerStyles
        };
    };
};


var $e8bdf0e0b15b45e3$var$_excluded = [
    "children",
    "component",
    "isHighlighted",
    "isLoading",
    "isSelected",
    "onClick",
    "testId",
    "theme",
    "tooltip",
    "shortcut"
];
var $e8bdf0e0b15b45e3$var$VAR_BUTTON_SELECTED_COLOR = '--button-selected-color';
var $e8bdf0e0b15b45e3$var$VAR_BUTTON_SELECTED_BORDER_COLOR = '--button-selected-border-color';
var $e8bdf0e0b15b45e3$var$buttonBaseStyles = (0, $2nBsU.css)({
    display: 'flex',
    height: '100%',
    position: 'relative',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column'
});
var $e8bdf0e0b15b45e3$var$buttonNoOpStyle = (0, $2nBsU.css)({
    '--noop': 1
});
var $e8bdf0e0b15b45e3$var$buttonHighlightedStyles = (0, $2nBsU.css)({
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '&& > *': {
        color: "var(".concat($e8bdf0e0b15b45e3$var$VAR_BUTTON_SELECTED_COLOR, ")")
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '&:after': {
        height: 3,
        position: 'absolute',
        backgroundColor: "var(".concat($e8bdf0e0b15b45e3$var$VAR_BUTTON_SELECTED_BORDER_COLOR, ")"),
        borderStartEndRadius: "var(--ds-radius-xsmall, 1px)",
        borderStartStartRadius: "var(--ds-radius-xsmall, 1px)",
        content: '""',
        insetBlockEnd: 0,
        insetInlineEnd: "var(--ds-space-050, 4px)",
        insetInlineStart: "var(--ds-space-050, 4px)"
    }
});
var $e8bdf0e0b15b45e3$export$ac16a6a04d9b7c84 = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function(props, ref) {
    var children = props.children, component = props.component, isHighlighted = props.isHighlighted, isLoading = props.isLoading, isSelected = props.isSelected, onClick = props.onClick, testId = props.testId, theme = props.theme, tooltip = props.tooltip, shortcut = props.shortcut, rest = (0, $1156f3ba78bc1e19$export$2e2bcd8739ae039)(props, $e8bdf0e0b15b45e3$var$_excluded);
    var themeFromContext = (0, $063f49374ce1ab43$export$93d4e7f90805808f)();
    var button = (0, $2nBsU.jsx)("div", {
        style: (0, $d93598d00ce909df$export$2e2bcd8739ae039)((0, $d93598d00ce909df$export$2e2bcd8739ae039)({}, $e8bdf0e0b15b45e3$var$VAR_BUTTON_SELECTED_COLOR, themeFromContext.mode.primaryButton.selected.color), $e8bdf0e0b15b45e3$var$VAR_BUTTON_SELECTED_BORDER_COLOR, themeFromContext.mode.primaryButton.selected.borderColor),
        css: [
            $e8bdf0e0b15b45e3$var$buttonBaseStyles,
            isHighlighted && $e8bdf0e0b15b45e3$var$buttonHighlightedStyles
        ],
        role: "listitem",
        "data-vc": "primary-button"
    }, (0, $2nBsU.jsx)((0, $079ca7802c1bfb5a$export$2e2bcd8739ae039), (0, $d029a6002153f8f3$export$2e2bcd8739ae039)({
        appearance: "primary",
        component: component,
        isLoading: isLoading,
        isSelected: isSelected,
        onClick: onClick,
        ref: ref,
        testId: testId,
        theme: theme || (0, $1572bef186bf27f4$export$14dd6915caf431fe)(themeFromContext),
        css: [
            $e8bdf0e0b15b45e3$var$buttonNoOpStyle
        ] // Typescript working for css mismatch error
    }, rest), children));
    if (tooltip) return (0, $2nBsU.jsx)((0, $32d4a3c4842e3ceb$export$2e2bcd8739ae039), {
        content: tooltip,
        hideTooltipOnClick: true,
        shortcut: shortcut
    }, button);
    return button;
});


var $a8c7121eb827a20e$var$_excluded = [
    "component",
    "isHighlighted",
    "isLoading",
    "onClick",
    "testId",
    "theme",
    "tooltip"
];
var $a8c7121eb827a20e$var$buttonNoOpStyle = (0, $2nBsU.css)({
    '--noop': 1
});
var $a8c7121eb827a20e$export$bb3af89fb196520d = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function(props, ref) {
    var component = props.component, isHighlighted = props.isHighlighted, isLoading = props.isLoading, onClick = props.onClick, testId = props.testId, theme = props.theme, tooltip = props.tooltip, rest = (0, $1156f3ba78bc1e19$export$2e2bcd8739ae039)(props, $a8c7121eb827a20e$var$_excluded);
    return (0, $2nBsU.jsx)((0, $e8bdf0e0b15b45e3$export$ac16a6a04d9b7c84), (0, $d029a6002153f8f3$export$2e2bcd8739ae039)({
        component: component,
        iconAfter: (0, $2nBsU.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($e923ee93b7164642$exports))), {
            color: "currentColor",
            label: "",
            size: "small"
        }),
        isHighlighted: isHighlighted,
        isLoading: isLoading,
        onClick: onClick,
        ref: ref,
        testId: testId,
        theme: theme,
        tooltip: tooltip,
        css: [
            $a8c7121eb827a20e$var$buttonNoOpStyle
        ] // Typescript working for css mismatch error
    }, rest));
});


var $ae1bddf578a341f7$var$containerStyles = (0, $2nBsU.css)({
    display: 'flex',
    height: '100%',
    position: 'relative',
    alignItems: 'stretch',
    flexBasis: 0,
    flexGrow: 1,
    flexShrink: 0,
    // Guard excludes top-layer popover siblings (eg the overflow menu / tooltip); :where() keeps specificity.
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '& > *:not(:where([popover], dialog))': {
        margin: "0 ".concat("var(--ds-space-050, 4px)"),
        flexShrink: 0
    }
});
var $ae1bddf578a341f7$var$widthObserverContainerStyles = (0, $2nBsU.css)({
    width: '100%',
    minWidth: '1px',
    margin: '0px',
    position: 'relative',
    flexShrink: 1
});
var $ae1bddf578a341f7$var$overflowItemsStyles = (0, $2nBsU.css)({
    color: "var(--ds-text, #292A2E)"
});
var $ae1bddf578a341f7$export$43e704064d596a9e = function PrimaryItemsContainer(_ref) {
    var moreLabel = _ref.moreLabel, items = _ref.items, Create = _ref.create, testId = _ref.testId;
    var _useState = (0, $5FkrB.useState)(false), _useState2 = (0, $8ddf8a10eebb4436$export$2e2bcd8739ae039)(_useState, 2), isMoreOpen = _useState2[0], setIsMoreOpen = _useState2[1];
    var _useOverflowControlle = (0, $55eb5cb6d6f8b3bb$export$705aa66a39c35bf7)(items), updateWidth = _useOverflowControlle.updateWidth, visibleItems = _useOverflowControlle.visibleItems, overflowItems = _useOverflowControlle.overflowItems;
    var onMoreClick = (0, $5FkrB.useCallback)(function() {
        setIsMoreOpen(!isMoreOpen);
    }, [
        isMoreOpen,
        setIsMoreOpen
    ]);
    var onMoreClose = (0, $5FkrB.useCallback)(function() {
        setIsMoreOpen(false);
    }, []);
    var openOverflowMenu = (0, $5FkrB.useCallback)(function() {
        setIsMoreOpen(true);
    }, []);
    var trigger = (0, $5FkrB.useCallback)(function(triggerProps) {
        return (0, $2nBsU.jsx)((0, $a8c7121eb827a20e$export$bb3af89fb196520d), (0, $d029a6002153f8f3$export$2e2bcd8739ae039)({
            onClick: onMoreClick,
            isSelected: isMoreOpen,
            testId: testId ? "".concat(testId, "-overflow-menu-trigger") : 'overflow-menu-trigger'
        }, triggerProps), moreLabel);
    }, [
        moreLabel,
        onMoreClick,
        isMoreOpen,
        testId
    ]);
    var content = (0, $5FkrB.useCallback)(function() {
        return (0, $2nBsU.jsx)((0, $9cea31fc2820a98e$export$a3a2def3937905a0), {
            isVisible: false,
            openOverflowMenu: openOverflowMenu,
            closeOverflowMenu: onMoreClose
        }, (0, $2nBsU.jsx)("div", {
            css: $ae1bddf578a341f7$var$overflowItemsStyles
        }, overflowItems));
    }, // Overflow items has an unstable reference - so we will only recalculate
    // content if `overflowItems` length changes.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        overflowItems.length,
        openOverflowMenu,
        onMoreClose
    ]);
    return (0, $2nBsU.jsx)("div", {
        css: $ae1bddf578a341f7$var$containerStyles,
        "data-testid": testId && "".concat(testId, "-primary-actions"),
        role: "list"
    }, (0, $2nBsU.jsx)((0, $9cea31fc2820a98e$export$a3a2def3937905a0), {
        isVisible: true,
        openOverflowMenu: openOverflowMenu,
        closeOverflowMenu: onMoreClose
    }, visibleItems), overflowItems.length > 0 && (0, $2nBsU.jsx)((0, $a2b7f495199a9de5$export$129a32eedafa97c5), {
        shouldRenderToParent: true,
        placement: "bottom-start",
        content: content,
        isOpen: isMoreOpen,
        onClose: onMoreClose,
        trigger: trigger,
        testId: testId ? "".concat(testId, "-overflow-menu-popup") : 'overflow-menu-popup'
    }), Create && (0, $2nBsU.jsx)(Create, null), (0, $2nBsU.jsx)("div", {
        css: $ae1bddf578a341f7$var$widthObserverContainerStyles
    }, (0, $2nBsU.jsx)((0, $868076b348d71ed1$export$b2ad68b9bc407b80), {
        offscreen: true,
        setWidth: updateWidth
    })));
};



var $3ZMUU = parcelRequire("3ZMUU");
var $fade497bfa6efef0$var$containerStyles = (0, $2nBsU.css)({
    display: 'flex',
    boxSizing: 'border-box',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    height: (0, $9e0b6f96d7dc4701$export$30fa7cc5f2690a43),
    position: 'relative',
    alignItems: 'center',
    justifyContent: 'space-between',
    flexShrink: 0,
    borderBlockEnd: "var(--ds-border-width, 1px)".concat(" solid ", "var(--ds-border, #0B120E24)"),
    paddingInlineEnd: "var(--ds-space-150, 12px)",
    paddingInlineStart: "var(--ds-space-150, 12px)"
});
var $fade497bfa6efef0$var$leftStyles = (0, $2nBsU.css)({
    display: 'flex',
    minWidth: 0,
    height: 'inherit',
    alignItems: 'center',
    flexGrow: 1,
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '& > *': {
        flexShrink: 0
    }
});
var $fade497bfa6efef0$var$rightStyles = (0, $2nBsU.css)({
    display: 'flex',
    alignItems: 'center',
    flexShrink: 0,
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '& > *': {
        flexShrink: 0,
        marginInlineEnd: "var(--ds-space-050, 4px)"
    }
});
var $fade497bfa6efef0$var$noRightMarginStyles = (0, $2nBsU.css)({
    marginInlineEnd: 0
});
var $fade497bfa6efef0$var$analyticsData = {
    attributes: {
        navigationLayer: 'global'
    },
    componentName: 'atlassianNavigation'
};
var $fade497bfa6efef0$export$f66ccb39f60980e5 = function AtlassianNavigation(props) {
    typeof $3ZMUU;
    var label = props.label, _props$primaryItems = props.primaryItems, primaryItems = _props$primaryItems === void 0 ? [] : _props$primaryItems, AppSwitcher = props.renderAppSwitcher, create = props.renderCreate, Help = props.renderHelp, Notifications = props.renderNotifications, ProductHome = props.renderProductHome, Profile = props.renderProfile, Search = props.renderSearch, SignIn = props.renderSignIn, Settings = props.renderSettings, _props$moreLabel = props.moreLabel, moreLabel = _props$moreLabel === void 0 ? "\u2026" : _props$moreLabel, _props$theme = props.theme, theme = _props$theme === void 0 ? (0, $4692d5c70ecef3eb$export$164de7ab8df77ef0) : _props$theme, testId = props.testId, _props$isServer = props.isServer, isServer = _props$isServer === void 0 ? false : _props$isServer, _props$isSSRPlacehold = props.isSSRPlaceholderEnabled, isSSRPlaceholderEnabled = _props$isSSRPlacehold === void 0 ? false : _props$isSSRPlacehold;
    return (0, $2nBsU.jsx)((0, $0cbbe03340c55ac9$export$d8964aec282183a3), {
        value: theme
    }, (0, $2nBsU.jsx)((0, $fb54a115516e258d$export$d0a82da1a0b94929), {
        data: $fade497bfa6efef0$var$analyticsData
    }, (0, $2nBsU.jsx)("header", (0, $d029a6002153f8f3$export$2e2bcd8739ae039)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: theme.mode.navigation,
        css: $fade497bfa6efef0$var$containerStyles,
        "data-testid": testId && "".concat(testId, "-header"),
        role: "banner",
        "data-vc": "atlassian-navigation".concat(isServer ? '-ssr' : '')
    }, isServer && isSSRPlaceholderEnabled && {
        'data-ssr-placeholder': 'atlassian-navigation-placeholder'
    }, !isServer && isSSRPlaceholderEnabled && {
        'data-ssr-placeholder-replace': 'atlassian-navigation-placeholder'
    }), (0, $2nBsU.jsx)("nav", {
        css: $fade497bfa6efef0$var$leftStyles,
        "aria-label": label
    }, AppSwitcher && (0, $2nBsU.jsx)(AppSwitcher, null), ProductHome && (0, $2nBsU.jsx)(ProductHome, null), (0, $2nBsU.jsx)((0, $ae1bddf578a341f7$export$43e704064d596a9e), {
        testId: testId,
        moreLabel: moreLabel,
        items: primaryItems,
        create: create,
        theme: theme
    })), (0, $2nBsU.jsx)("div", {
        css: $fade497bfa6efef0$var$rightStyles,
        "data-testid": testId && "".concat(testId, "-secondary-actions")
    }, Search && (0, $2nBsU.jsx)(Search, null), (0, $2nBsU.jsx)("div", {
        role: "list",
        css: [
            $fade497bfa6efef0$var$rightStyles,
            $fade497bfa6efef0$var$noRightMarginStyles
        ],
        "data-vc": "atlassian-navigation-secondary-actions"
    }, Notifications && (0, $2nBsU.jsx)(Notifications, null), Help && (0, $2nBsU.jsx)(Help, null), Settings && (0, $2nBsU.jsx)(Settings, null), SignIn && (0, $2nBsU.jsx)(SignIn, null), Profile && (0, $2nBsU.jsx)(Profile, null))))));
};


function $c6779e936c45cab1$export$2e2bcd8739ae039() {
    return $c6779e936c45cab1$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $c6779e936c45cab1$export$2e2bcd8739ae039.apply(null, arguments);
}



var $5FkrB = parcelRequire("5FkrB");
function $1d9435bc967bcf1f$export$2e2bcd8739ae039() {
    return $1d9435bc967bcf1f$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $1d9435bc967bcf1f$export$2e2bcd8739ae039.apply(null, arguments);
}



var $5FkrB = parcelRequire("5FkrB");

var $5FkrB = parcelRequire("5FkrB");

function $27c16ef69decce21$export$2e2bcd8739ae039(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}


function $4331f8efe1ae1766$export$2e2bcd8739ae039(e, t) {
    if (null == e) return {};
    var o, r, i = (0, $27c16ef69decce21$export$2e2bcd8739ae039)(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}



var $5FkrB = parcelRequire("5FkrB");



var $5FkrB = parcelRequire("5FkrB");



var $5FkrB = parcelRequire("5FkrB");

var $5FkrB = parcelRequire("5FkrB");
var $a3bc25181f70f22d$var$defaultTheme = {
    mode: {
        create: {
            active: {
                color: "var(--ds-text-inverse, #FFFFFF)",
                backgroundColor: "var(--ds-background-brand-bold-pressed, #144794)",
                boxShadow: ''
            },
            default: {
                color: "var(--ds-text-inverse, #FFFFFF)",
                backgroundColor: "var(--ds-background-brand-bold, #1868DB)",
                boxShadow: ''
            },
            focus: {
                color: "var(--ds-text-inverse, #FFFFFF)",
                backgroundColor: '',
                boxShadow: ''
            },
            hover: {
                color: "var(--ds-text-inverse, #FFFFFF)",
                backgroundColor: "var(--ds-background-brand-bold-hovered, #1558BC)",
                boxShadow: ''
            },
            selected: {
                color: '',
                backgroundColor: '',
                boxShadow: ''
            }
        },
        iconButton: {
            active: {
                color: "var(--ds-text-subtle, #505258)",
                backgroundColor: "var(--ds-background-neutral-subtle-pressed, #0B120E24)",
                boxShadow: ''
            },
            default: {
                color: "var(--ds-text-subtle, #505258)",
                backgroundColor: 'transparent',
                boxShadow: ''
            },
            focus: {
                color: "var(--ds-text-subtle, #505258)",
                backgroundColor: '',
                boxShadow: ''
            },
            hover: {
                color: "var(--ds-text-subtle, #505258)",
                backgroundColor: "var(--ds-background-neutral-subtle-hovered, #0515240F)",
                boxShadow: ''
            },
            selected: {
                color: "var(--ds-text-selected, #1868DB)",
                backgroundColor: "var(--ds-background-selected, #E9F2FE)",
                boxShadow: ''
            },
            selectedHover: {
                color: "var(--ds-text-selected, #1868DB)",
                backgroundColor: "var(--ds-background-selected-hovered, #CFE1FD)",
                boxShadow: ''
            }
        },
        navigation: {
            backgroundColor: "var(--ds-surface, #FFFFFF)",
            color: "var(--ds-text-subtlest, #6B6E76)"
        },
        productHome: {
            backgroundColor: "var(--ds-text-brand, #1868DB)",
            color: "var(--ds-text, #292A2E)",
            borderRight: "var(--ds-border-width, 1px)".concat(" solid ", "var(--ds-border, #0B120E24)"),
            // TODO: replace with token after brand refresh
            iconColor: '#357DE8',
            textColor: "var(--ds-text, #292A2E)"
        },
        primaryButton: {
            active: {
                color: "var(--ds-text-subtle, #505258)",
                backgroundColor: "var(--ds-background-neutral-subtle-pressed, #0B120E24)",
                boxShadow: ''
            },
            default: {
                color: "var(--ds-text-subtle, #505258)",
                backgroundColor: 'transparent',
                boxShadow: ''
            },
            focus: {
                color: "var(--ds-text-subtle, #505258)",
                backgroundColor: '',
                boxShadow: ''
            },
            hover: {
                color: "var(--ds-text-subtle, #505258)",
                backgroundColor: "var(--ds-background-neutral-subtle-hovered, #0515240F)",
                boxShadow: ''
            },
            selected: {
                color: "var(--ds-text-selected, #1868DB)",
                backgroundColor: "var(--ds-background-selected, #E9F2FE)",
                boxShadow: '',
                borderColor: "var(--ds-border-selected, #1868DB)"
            },
            selectedHover: {
                color: "var(--ds-text-selected, #1868DB)",
                backgroundColor: "var(--ds-background-selected-hovered, #CFE1FD)",
                boxShadow: '',
                borderColor: "var(--ds-border-selected, #1868DB)"
            }
        },
        search: {
            default: {
                backgroundColor: "var(--ds-background-input, #FFFFFF)",
                color: "var(--ds-text-subtlest, #6B6E76)",
                borderColor: "var(--ds-border-input, #8C8F97)"
            },
            focus: {
                borderColor: "var(--ds-border-focused, #4688EC)"
            },
            hover: {
                backgroundColor: "var(--ds-background-input-hovered, #F8F8F8)"
            }
        },
        skeleton: {
            backgroundColor: "var(--ds-background-neutral, #0515240F)",
            opacity: 1
        }
    }
};
// Create deep copy of defaultTheme
var $a3bc25181f70f22d$var$defaultThemeCopy = JSON.parse(JSON.stringify($a3bc25181f70f22d$var$defaultTheme));
// Update iconColor and textColor in defaultThemeBrandRefresh
$a3bc25181f70f22d$var$defaultThemeCopy.mode.productHome.iconColor = undefined;
$a3bc25181f70f22d$var$defaultThemeCopy.mode.productHome.textColor = undefined;
var $a3bc25181f70f22d$export$2491e13b198e597d = 'atlassian';
var $a3bc25181f70f22d$export$2e2bcd8739ae039 = $a3bc25181f70f22d$var$defaultTheme;


function $655126c584434560$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $655126c584434560$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $655126c584434560$export$2e2bcd8739ae039(o);
}



function $e443115dd4032a4a$export$2e2bcd8739ae039(t, r) {
    if ("object" != (0, $655126c584434560$export$2e2bcd8739ae039)(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (0, $655126c584434560$export$2e2bcd8739ae039)(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}


function $ef55033d61d23c45$export$2e2bcd8739ae039(t) {
    var i = (0, $e443115dd4032a4a$export$2e2bcd8739ae039)(t, "string");
    return "symbol" == (0, $655126c584434560$export$2e2bcd8739ae039)(i) ? i : i + "";
}


function $a08c26c0a691d97c$export$2e2bcd8739ae039(e, r, t) {
    return (r = (0, $ef55033d61d23c45$export$2e2bcd8739ae039)(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}




var $84c0f00ba432a446$var$defaultThemeCopy = JSON.parse(JSON.stringify((0, $a3bc25181f70f22d$export$2e2bcd8739ae039)));
var $84c0f00ba432a446$export$77823bc9863eaa03 = $84c0f00ba432a446$var$defaultThemeCopy;



function $9d87232489252eb2$export$2e2bcd8739ae039(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}


function $a8b553e497ed8cbe$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return (0, $9d87232489252eb2$export$2e2bcd8739ae039)(r);
}


function $783b726850620a28$export$2e2bcd8739ae039(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}



function $f34dcfb1025ed756$export$2e2bcd8739ae039(r, a) {
    if (r) {
        if ("string" == typeof r) return (0, $9d87232489252eb2$export$2e2bcd8739ae039)(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? (0, $9d87232489252eb2$export$2e2bcd8739ae039)(r, a) : void 0;
    }
}


function $22c09bcd35aa2451$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}


function $cea0b040ddbe3eaa$export$2e2bcd8739ae039(r) {
    return (0, $a8b553e497ed8cbe$export$2e2bcd8739ae039)(r) || (0, $783b726850620a28$export$2e2bcd8739ae039)(r) || (0, $f34dcfb1025ed756$export$2e2bcd8739ae039)(r) || (0, $22c09bcd35aa2451$export$2e2bcd8739ae039)();
}


var $7126d5cc4e1b1a55$var$hex = '[a-z0-9]';
var $7126d5cc4e1b1a55$var$shortHandHexColorPattern = new RegExp("#(".concat($7126d5cc4e1b1a55$var$hex, ")(").concat($7126d5cc4e1b1a55$var$hex, ")(").concat($7126d5cc4e1b1a55$var$hex, ")"), 'i');
var $7126d5cc4e1b1a55$var$repeat = function repeat(str, times) {
    return (0, $cea0b040ddbe3eaa$export$2e2bcd8739ae039)(Array(times)).map(function() {
        return str;
    }).join('');
};
var $7126d5cc4e1b1a55$var$isShortHexColor = function isShortHexColor(color) {
    return color && color.length === 4;
};
var $7126d5cc4e1b1a55$var$completeHexColor = function completeHexColor(colors) {
    var hex = colors.map(function(color) {
        return $7126d5cc4e1b1a55$var$repeat(color, 2);
    }).join('');
    return "#".concat(hex);
};
var $7126d5cc4e1b1a55$var$completeTriplet = function completeTriplet(colors) {
    return "#".concat($7126d5cc4e1b1a55$var$repeat(colors[1], 6));
};
var $7126d5cc4e1b1a55$var$isTriplet = function isTriplet(colors) {
    return colors[0] === colors[1] && colors[1] === colors[2];
};
var $7126d5cc4e1b1a55$export$db8d2130677f868c = function convertHexShorthand(color) {
    if ($7126d5cc4e1b1a55$var$isShortHexColor(color)) {
        // when color = '#ccc', matches is structured as ['#ccc', 'c', 'c', 'c', ...]
        var matches = color.match($7126d5cc4e1b1a55$var$shortHandHexColorPattern);
        if (matches) {
            var colors = matches.slice(1, 4);
            if ($7126d5cc4e1b1a55$var$isTriplet(colors)) return $7126d5cc4e1b1a55$var$completeTriplet(colors);
            else return $7126d5cc4e1b1a55$var$completeHexColor(colors);
        }
    }
    // return the color as is when it's not hex color shorthand
    return color;
};


var $261e28f4d91f5f60$export$10a10e7cd1193377 = function generateTextColor(color) {
    var converted = (0, $7126d5cc4e1b1a55$export$db8d2130677f868c)(color);
    return (0, $9de014d0ca2dbeda$export$2e2bcd8739ae039).contrastRatio(converted).hex;
};


var $4c2285c374488cf4$export$bba5a971afe05444 = function getBoxShadow(color) {
    return "0 0 0 2px ".concat(color);
};





function $68e965984bcbfa48$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $68e965984bcbfa48$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $68e965984bcbfa48$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $a08c26c0a691d97c$export$2e2bcd8739ae039)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $68e965984bcbfa48$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $68e965984bcbfa48$export$7229be6d7219ee6a = function hexToRGBA(hex) {
    var opacity = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
    var rgba = $68e965984bcbfa48$var$_objectSpread($68e965984bcbfa48$var$_objectSpread({}, (0, $9de014d0ca2dbeda$export$2e2bcd8739ae039).convert(hex).rgb), {}, {
        a: opacity
    });
    return "rgba(".concat(Object.values(rgba).join(', '), ")");
};


var $96406268080a5e70$export$77a1051494882576 = function getContrastColor(contrastValue, opacityValue, color) {
    return (0, $68e965984bcbfa48$export$7229be6d7219ee6a)((0, $9de014d0ca2dbeda$export$2e2bcd8739ae039).contrast(contrastValue, color).hex, opacityValue);
};



function $70bde8c2a6e296bd$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $70bde8c2a6e296bd$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $70bde8c2a6e296bd$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $a08c26c0a691d97c$export$2e2bcd8739ae039)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $70bde8c2a6e296bd$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $70bde8c2a6e296bd$var$generateOpacityValue = function generateOpacityValue(color) {
    return color === '#000000' ? 0.3 : 0.6;
};
// eslint-disable-next-line @repo/internal/react/consistent-types-definitions
var $70bde8c2a6e296bd$var$generateButtonCSSStates = function generateButtonCSSStates(colors, buttonType) {
    var backgroundColor = colors.backgroundColor, color = colors.color, highlightColor = colors.highlightColor;
    // Add less opacity for white text so it is still legible.
    var opacityValue = $70bde8c2a6e296bd$var$generateOpacityValue(color);
    var isCreateButton = buttonType === 'create';
    return {
        active: {
            backgroundColor: isCreateButton ? (0, $68e965984bcbfa48$export$7229be6d7219ee6a)(backgroundColor, 0.65) : (0, $96406268080a5e70$export$77a1051494882576)(0.3, opacityValue, backgroundColor),
            boxShadow: (0, $4c2285c374488cf4$export$bba5a971afe05444)('transparent'),
            color: color
        },
        default: {
            backgroundColor: backgroundColor,
            boxShadow: (0, $4c2285c374488cf4$export$bba5a971afe05444)('transparent'),
            color: color
        },
        focus: {
            boxShadow: 'none',
            color: color,
            backgroundColor: backgroundColor
        },
        hover: {
            backgroundColor: isCreateButton ? (0, $68e965984bcbfa48$export$7229be6d7219ee6a)(backgroundColor, 0.8) : (0, $96406268080a5e70$export$77a1051494882576)(0.1, opacityValue, backgroundColor),
            boxShadow: (0, $4c2285c374488cf4$export$bba5a971afe05444)('transparent'),
            color: color
        },
        selected: {
            color: color,
            backgroundColor: (0, $96406268080a5e70$export$77a1051494882576)(0.3, opacityValue, backgroundColor),
            borderColor: highlightColor,
            boxShadow: (0, $4c2285c374488cf4$export$bba5a971afe05444)('transparent')
        },
        selectedHover: {
            color: color,
            backgroundColor: (0, $96406268080a5e70$export$77a1051494882576)(0.3, opacityValue, backgroundColor),
            borderColor: highlightColor,
            boxShadow: (0, $4c2285c374488cf4$export$bba5a971afe05444)('transparent')
        }
    };
};
var $70bde8c2a6e296bd$var$generateCreateButtonColors = function generateCreateButtonColors(_themeBackground, themeHighlight) {
    return {
        backgroundColor: themeHighlight,
        color: (0, $261e28f4d91f5f60$export$10a10e7cd1193377)(themeHighlight),
        highlightColor: themeHighlight
    };
};
var $70bde8c2a6e296bd$export$2e4ecffaca289a18 = function generateTheme(themeColors) {
    var backgroundColor = themeColors.backgroundColor, highlightColor = themeColors.highlightColor, name = themeColors.name;
    var color = (0, $261e28f4d91f5f60$export$10a10e7cd1193377)(backgroundColor);
    var colors = $70bde8c2a6e296bd$var$_objectSpread($70bde8c2a6e296bd$var$_objectSpread({}, themeColors), {}, {
        color: color
    });
    if (name === (0, $a3bc25181f70f22d$export$2491e13b198e597d)) return 0, $84c0f00ba432a446$export$77823bc9863eaa03;
    return {
        mode: {
            create: $70bde8c2a6e296bd$var$generateButtonCSSStates($70bde8c2a6e296bd$var$generateCreateButtonColors(backgroundColor, highlightColor), 'create'),
            iconButton: $70bde8c2a6e296bd$var$generateButtonCSSStates(colors, 'iconButton'),
            primaryButton: $70bde8c2a6e296bd$var$generateButtonCSSStates(colors, 'primaryButton'),
            navigation: {
                backgroundColor: backgroundColor,
                color: color
            },
            productHome: {
                color: color,
                iconColor: color,
                textColor: color,
                backgroundColor: highlightColor,
                borderRight: "var(--ds-border-width, 1px)".concat(" solid ", (0, $68e965984bcbfa48$export$7229be6d7219ee6a)(color, 0.5))
            },
            search: {
                default: {
                    backgroundColor: backgroundColor,
                    color: color,
                    borderColor: (0, $68e965984bcbfa48$export$7229be6d7219ee6a)(color, 0.5)
                },
                focus: {
                    borderColor: (0, $68e965984bcbfa48$export$7229be6d7219ee6a)(highlightColor, 0.8),
                    boxShadow: (0, $4c2285c374488cf4$export$bba5a971afe05444)((0, $68e965984bcbfa48$export$7229be6d7219ee6a)(highlightColor, 0.5))
                },
                hover: {
                    backgroundColor: (0, $96406268080a5e70$export$77a1051494882576)(0.1, $70bde8c2a6e296bd$var$generateOpacityValue(color), backgroundColor),
                    color: color
                }
            },
            skeleton: {
                backgroundColor: color,
                opacity: 0.08
            }
        }
    };
};


var $d2af5cdf0631be9a$export$eeee8619e1b91cb0 = (0, $70bde8c2a6e296bd$export$2e4ecffaca289a18)({
    name: (0, $a3bc25181f70f22d$export$2491e13b198e597d),
    backgroundColor: '#FFFFFF',
    highlightColor: '#0052CC'
});


var $069768fdf64c1ff7$export$164de7ab8df77ef0 = (0, $d2af5cdf0631be9a$export$eeee8619e1b91cb0);


var $20b5880fd358e311$export$2c657da244d00bd6 = /*#__PURE__*/ (0, $5FkrB.createContext)((0, $069768fdf64c1ff7$export$164de7ab8df77ef0));


var $24522e5d0570a5e9$export$93d4e7f90805808f = function useTheme() {
    return (0, $5FkrB.useContext)((0, $20b5880fd358e311$export$2c657da244d00bd6));
};



function $4bae3648cb0e1261$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $4bae3648cb0e1261$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $4bae3648cb0e1261$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $a08c26c0a691d97c$export$2e2bcd8739ae039)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $4bae3648cb0e1261$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $4bae3648cb0e1261$export$f32bddcb857301f3 = function getIconButtonTheme(_ref) {
    var iconButton = _ref.mode.iconButton;
    return function(current, props) {
        var _current = current(props), buttonStyles = _current.buttonStyles, spinnerStyles = _current.spinnerStyles;
        return {
            buttonStyles: $4bae3648cb0e1261$var$_objectSpread($4bae3648cb0e1261$var$_objectSpread($4bae3648cb0e1261$var$_objectSpread($4bae3648cb0e1261$var$_objectSpread({}, buttonStyles), {}, {
                borderRadius: "var(--ds-radius-full, 100%)",
                display: 'flex',
                margin: "0 ".concat("var(--ds-space-025, 2px)"),
                padding: "var(--ds-space-050, 4px)",
                height: 'auto',
                fontWeight: "var(--ds-font-weight-medium, 500)"
            }, iconButton.default), {}, {
                ':hover': iconButton.hover,
                ':focus': iconButton.focus,
                // :active doesn't work in FF, because we do a
                // e.preventDefault() on mouse down in Button.
                // '&&' is required to add more CSS specificity
                // && it not a valid CSSObject property
                '&&': $4bae3648cb0e1261$var$_objectSpread({}, props.state === 'active' && iconButton.active)
            }, props.state === 'selected' && iconButton.selected), {}, {
                '> span': {
                    margin: 0
                }
            }),
            spinnerStyles: spinnerStyles
        };
    };
};


var $60cdd4970777d5cd$var$_excluded = [
    "icon",
    "label",
    "testId",
    "tooltip",
    "component",
    "href",
    "id",
    "isDisabled",
    "isSelected",
    "onBlur",
    "onClick",
    "onFocus",
    "onMouseDown",
    "onMouseEnter",
    "onMouseLeave",
    "onMouseUp",
    "target",
    "theme",
    "isTooltipAnnouncementDisabled"
];
var $60cdd4970777d5cd$export$c25acd513dcc8062 = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function(props, ref) {
    var icon = props.icon, label = props.label, testId = props.testId, tooltip = props.tooltip, component = props.component, href = props.href, id = props.id, isDisabled = props.isDisabled, isSelected = props.isSelected, onBlur = props.onBlur, onClick = props.onClick, onFocus = props.onFocus, onMouseDown = props.onMouseDown, onMouseEnter = props.onMouseEnter, onMouseLeave = props.onMouseLeave, onMouseUp = props.onMouseUp, target = props.target, theme = props.theme, _props$isTooltipAnnou = props.isTooltipAnnouncementDisabled, isTooltipAnnouncementDisabled = _props$isTooltipAnnou === void 0 ? false : _props$isTooltipAnnou, rest = (0, $4331f8efe1ae1766$export$2e2bcd8739ae039)(props, $60cdd4970777d5cd$var$_excluded);
    var themeFromContext = (0, $24522e5d0570a5e9$export$93d4e7f90805808f)();
    var button = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $079ca7802c1bfb5a$export$2e2bcd8739ae039), (0, $1d9435bc967bcf1f$export$2e2bcd8739ae039)({
        appearance: "primary",
        "aria-label": label,
        component: component,
        href: href,
        iconBefore: icon,
        id: id,
        isDisabled: isDisabled,
        isSelected: isSelected,
        onBlur: onBlur,
        onClick: onClick,
        onFocus: onFocus,
        onMouseDown: onMouseDown,
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
        onMouseUp: onMouseUp,
        ref: ref,
        target: target,
        testId: testId,
        theme: theme || (0, $4bae3648cb0e1261$export$f32bddcb857301f3)(themeFromContext)
    }, rest));
    if (tooltip) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $32d4a3c4842e3ceb$export$2e2bcd8739ae039), {
        content: tooltip,
        hideTooltipOnClick: true,
        isScreenReaderAnnouncementDisabled: isTooltipAnnouncementDisabled
    }, button);
    return button;
});


var $69a0d19a71d7f05d$var$_excluded = [
    "component",
    "href",
    "icon",
    "id",
    "isDisabled",
    "isSelected",
    "label",
    "onBlur",
    "onClick",
    "onFocus",
    "onMouseDown",
    "onMouseEnter",
    "onMouseLeave",
    "onMouseUp",
    "target",
    "testId",
    "theme",
    "tooltip"
];
var $69a0d19a71d7f05d$export$5120f2d0b8d4cab8 = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function(props, ref) {
    var component = props.component, href = props.href, icon = props.icon, id = props.id, isDisabled = props.isDisabled, isSelected = props.isSelected, labelProp = props.label, onBlur = props.onBlur, onClick = props.onClick, onFocus = props.onFocus, onMouseDown = props.onMouseDown, onMouseEnter = props.onMouseEnter, onMouseLeave = props.onMouseLeave, onMouseUp = props.onMouseUp, target = props.target, testId = props.testId, theme = props.theme, tooltip = props.tooltip, rest = (0, $4331f8efe1ae1766$export$2e2bcd8739ae039)(props, $69a0d19a71d7f05d$var$_excluded);
    var label = labelProp || (typeof tooltip === 'string' ? tooltip : 'Your profile and settings');
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("div", {
        role: "listitem"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $60cdd4970777d5cd$export$c25acd513dcc8062), (0, $1d9435bc967bcf1f$export$2e2bcd8739ae039)({
        component: component,
        href: href,
        icon: icon,
        id: id,
        isDisabled: isDisabled,
        isSelected: isSelected,
        label: label,
        onBlur: onBlur,
        onClick: onClick,
        onFocus: onFocus,
        onMouseDown: onMouseDown,
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
        onMouseUp: onMouseUp,
        ref: ref,
        target: target,
        testId: testId,
        theme: theme,
        tooltip: tooltip,
        isTooltipAnnouncementDisabled: true
    }, rest)));
});


var $b01407012f396f67$exports = {};
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::508bd9728f54ab48d8a573901bb484ef>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty($b01407012f396f67$exports, "__esModule", {
    value: true
});
$b01407012f396f67$exports.default = void 0;

var $b01407012f396f67$var$_react = $b01407012f396f67$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $b01407012f396f67$var$_iconNew = $b01407012f396f67$var$_interopRequireDefault((parcelRequire("gDzom")));
function $b01407012f396f67$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "LogIn".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/log-in
 * Usage guidance:
 * Single purpose - Reserved for log in.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $b01407012f396f67$var$LogInIcon = (props)=>/*#__PURE__*/ $b01407012f396f67$var$_react.default.createElement($b01407012f396f67$var$_iconNew.default, Object.assign({
        name: "LogInIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M13 2.5H8V1h5a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H8v-1.5h5a.5.5 0 0 0 .5-.5V3a.5.5 0 0 0-.5-.5M7.44 7.25 5.22 5.03l1.06-1.06 3.5 3.5a.75.75 0 0 1 0 1.06l-3.5 3.5-1.06-1.06 2.22-2.22H1v-1.5z" clip-rule="evenodd"/>`
    }, props));
$b01407012f396f67$var$LogInIcon.displayName = 'LogInIcon';
var $b01407012f396f67$var$_default = $b01407012f396f67$exports.default = $b01407012f396f67$var$LogInIcon;


var $861fb90c15a92ca3$export$515664faa1398f37 = 'navigation';
var $861fb90c15a92ca3$export$3cbe56a0cabcff38 = {
    source: 'atlassianAccountMenu',
    componentName: 'atlassianAccountMenu',
    packageName: "@atlassian/account-menu",
    packageVersion: "1.5.2"
};



var $5FkrB = parcelRequire("5FkrB");

var $bgNpv = parcelRequire("bgNpv");
var $8830ff85b06d2bf6$export$b495e6c63a3a03c1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $bgNpv.default), {
    id: "identity.account-menu.account-menu-logged-out-state.log-in",
    defaultMessage: "Log in",
    description: "Tooltip for log in button when user is logged out"
});


var $6591d79d95f2b3d1$export$5e6158d2118ae4aa = function AccountMenuLoggedOutStateNav3(_ref) {
    var testId = _ref.testId, logInLink = _ref.logInLink;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $69a0d19a71d7f05d$export$5120f2d0b8d4cab8), {
        testId: testId,
        href: logInLink,
        onClick: function onClick(event, analytics) {
            analytics.update({
                actionSubjectId: 'logInLink'
            }).fire((0, $861fb90c15a92ca3$export$515664faa1398f37));
        },
        tooltip: (0, $8830ff85b06d2bf6$export$b495e6c63a3a03c1),
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($b01407012f396f67$exports))), {
            color: "currentColor",
            label: ""
        })
    });
};


/* nav3.tsx generated by @compiled/babel-plugin v3.0.2 */ 

/**
 * The length of the value hash portion of an atomic class name.
 * Atomic class names have the format: `_<group><value>`
 * where group is ATOMIC_GROUP_HASH_LENGTH chars and value is ATOMIC_VALUE_HASH_LENGTH chars.
 *
 * We extract the group key using: `className.slice(0, className.length - ATOMIC_VALUE_HASH_LENGTH)`
 *
 * We support both old-format classes (9 chars: `_` + 4 group + 4 value) and
 * new-format classes (11 chars: `_` + 6 group + 4 value) by using length-based
 * extraction rather than a hardcoded offset — old and new format group keys
 * are different lengths so they are structurally disjoint and never alias each other.
 */ const $9eb596671e88e808$var$ATOMIC_VALUE_HASH_LENGTH = 4;
function $9eb596671e88e808$export$2e2bcd8739ae039(classNames) {
    // Shortcut: nothing to do
    if (!classNames.length) return;
    // Shortcut: don't need to do anything if we only have a single classname
    if (classNames.length === 1 && classNames[0] && // checking to see if `classNames[0]` is a string that contains other classnames
    !classNames[0].includes(' ')) return classNames[0];
    // Using an object rather than a `Map` as it performed better in our benchmarks.
    // Would be happy to move to `Map` if it proved to be better under real conditions.
    const map = {};
    // Note: using loops to minimize iterations over the collection
    for (const value of classNames){
        // Exclude all falsy values, which leaves us with populated strings
        if (!value) continue;
        // a `value` can contain multiple classnames
        const list = value.split(' ');
        for (const className of list){
            /**
             * For atomic style classnames: the `key` is the `group`
             *
             * - Later atomic classnames with the same `group` will override earlier ones
             *   (which is what we want).
             * - Assumes atomic classnames are the only things that start with `_`
             * - Could use a regex to ensure that atomic classnames are structured how we expect,
             *   but did not add that for now as it did slow things down a bit.
             *
             * For other classnames: the `key` is the whole classname
             * - Okay to remove duplicates as doing so does not impact specificity
             *
             * */ const key = className.startsWith('_') ? className.slice(0, className.length - $9eb596671e88e808$var$ATOMIC_VALUE_HASH_LENGTH) : className;
            map[key] = className;
        }
    }
    /**
     * We are converting the `map` into a string.
     *
     * The simple way to do this would be `Object.values(map).join(' ')`.
     * However, the approach below performs 10%-20% better in benchmarks.
     *
     * For `ax()` it feels right to squeeze as much runtime performance out as we can.
     */ let result = '';
    for(const key in map)result += map[key] + ' ';
    // If we have an empty string, then our `map` was empty.
    if (!result) return;
    // remove last " " from the result (we added " " at the end of every value)
    return result.trimEnd();
}



var $5FkrB = parcelRequire("5FkrB");

var $hrVKU = parcelRequire("hrVKU");

var $10e45dcb67c9e60a$exports = {};
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::1823cfe9afabe77ba419bd26f71a4aac>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty($10e45dcb67c9e60a$exports, "__esModule", {
    value: true
});
$10e45dcb67c9e60a$exports.default = void 0;

var $10e45dcb67c9e60a$var$_react = $10e45dcb67c9e60a$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $10e45dcb67c9e60a$var$_iconNew = $10e45dcb67c9e60a$var$_interopRequireDefault((parcelRequire("gDzom")));
function $10e45dcb67c9e60a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "PersonAvatar".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/person-avatar
 * Usage guidance:
 * Single purpose - Reserved for user avatar.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $10e45dcb67c9e60a$var$PersonAvatarIcon = (props)=>/*#__PURE__*/ $10e45dcb67c9e60a$var$_react.default.createElement($10e45dcb67c9e60a$var$_iconNew.default, Object.assign({
        name: "PersonAvatarIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 1.5a6.5 6.5 0 0 0-4.148 11.505A2.75 2.75 0 0 1 6.5 11h3c1.26 0 2.323.848 2.648 2.005A6.5 6.5 0 0 0 8 1.5m2.75 12.392v-.142c0-.69-.56-1.25-1.25-1.25h-3c-.69 0-1.25.56-1.25 1.25v.142l.06.027c.82.373 1.73.581 2.69.581s1.87-.208 2.69-.58q.03-.016.06-.028M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8m8-3.5a2 2 0 1 0 0 4 2 2 0 0 0 0-4m-3.5 2a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0" clip-rule="evenodd"/>`
    }, props));
$10e45dcb67c9e60a$var$PersonAvatarIcon.displayName = 'PersonAvatarIcon';
var $10e45dcb67c9e60a$var$_default = $10e45dcb67c9e60a$exports.default = $10e45dcb67c9e60a$var$PersonAvatarIcon;


function $acd9c80135493c41$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return r;
}


function $118bbf110a1812b8$export$2e2bcd8739ae039(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}



function $4030c3145df053b8$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}


function $045ba0d411b9feb5$export$2e2bcd8739ae039(r, e) {
    return (0, $acd9c80135493c41$export$2e2bcd8739ae039)(r) || (0, $118bbf110a1812b8$export$2e2bcd8739ae039)(r, e) || (0, $f34dcfb1025ed756$export$2e2bcd8739ae039)(r, e) || (0, $4030c3145df053b8$export$2e2bcd8739ae039)();
}



var $5FkrB = parcelRequire("5FkrB");
var $1125196cc466be96$export$2c1df3428fc3264c = function useImageState(src) {
    var _useState = (0, $5FkrB.useState)('pending'), _useState2 = (0, $045ba0d411b9feb5$export$2e2bcd8739ae039)(_useState, 2), state = _useState2[0], setState = _useState2[1];
    var imgRef = (0, $5FkrB.useRef)();
    (0, $5FkrB.useEffect)(function() {
        if (!imgRef.current) {
            imgRef.current = new Image();
            imgRef.current.onload = function() {
                return setState('loaded');
            };
            imgRef.current.onerror = function() {
                return setState('error');
            };
        }
        setState('pending');
        imgRef.current.src = src;
    }, [
        src
    ]);
    return state;
};



var $6bnW7 = parcelRequire("6bnW7");
var $17f1895eeb3f129f$export$defe85febe8b728c = (0, $6bnW7.defineMessages)({
    triggerTooltip: {
        id: 'identity.account-menu.account-menu-popup.skeleton.tooltip',
        defaultMessage: 'Account',
        description: 'Tooltip and alt-text for the account menu item'
    }
});


var $2fa2b19c168c8215$var$_excluded = [
    "picture",
    "email",
    "trustPicture"
];
var $2fa2b19c168c8215$var$imgStyles = null;
var $2fa2b19c168c8215$export$89d857133932d6aa = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).forwardRef(function(_ref, ref) {
    var picture = _ref.picture, email = _ref.email, _ref$trustPicture = _ref.trustPicture, trustPicture = _ref$trustPicture === void 0 ? false : _ref$trustPicture, props = (0, $4331f8efe1ae1766$export$2e2bcd8739ae039)(_ref, $2fa2b19c168c8215$var$_excluded);
    var intl = (0, $hrVKU.default)();
    var state = (0, $1125196cc466be96$export$2c1df3428fc3264c)(picture || '');
    var tooltip = intl.formatMessage((0, $17f1895eeb3f129f$export$defe85febe8b728c).triggerTooltip);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $69a0d19a71d7f05d$export$5120f2d0b8d4cab8), (0, $1d9435bc967bcf1f$export$2e2bcd8739ae039)({}, props, {
        ref: ref,
        tooltip: email || tooltip,
        icon: picture && (trustPicture || state === 'loaded') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("img", {
            src: picture,
            alt: tooltip,
            className: (0, $9eb596671e88e808$export$2e2bcd8739ae039)([
                "_2rko1rr0 _1bsb1ejb _4t3i1ejb"
            ])
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($10e45dcb67c9e60a$exports))), {
            color: "currentColor",
            label: tooltip,
            spacing: "spacious"
        })
    }));
});



var $5FkrB = parcelRequire("5FkrB");


/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 


var $5FkrB = parcelRequire("5FkrB");


var $bgNpv = parcelRequire("bgNpv");
// same types defined in analytics-web-client but avoid creating dependency with that
var $873f7350fa85064d$export$a1562d08625f5d7e = 'ui';
var $873f7350fa85064d$export$947dac6c72b26f81 = 'track';
var $873f7350fa85064d$export$f1d537d508d2945a = 'screen';
var $873f7350fa85064d$export$12346a674644c156 = 'operational';
var $873f7350fa85064d$export$b055de0e665cb20c = 'unknown';



var $5bb1f5651d9a5dad$exports = {};
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::afc1e1afbeb94ec2722cc1d659728d67>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty($5bb1f5651d9a5dad$exports, "__esModule", {
    value: true
});
$5bb1f5651d9a5dad$exports.default = void 0;

var $5bb1f5651d9a5dad$var$_react = $5bb1f5651d9a5dad$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $5bb1f5651d9a5dad$var$_iconNew = $5bb1f5651d9a5dad$var$_interopRequireDefault((parcelRequire("gDzom")));
function $5bb1f5651d9a5dad$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "LogOut".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/log-out
 * Usage guidance:
 * Single purpose - Reserved for log out.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $5bb1f5651d9a5dad$var$LogOutIcon = (props)=>/*#__PURE__*/ $5bb1f5651d9a5dad$var$_react.default.createElement($5bb1f5651d9a5dad$var$_iconNew.default, Object.assign({
        name: "LogOutIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M3 2.5h5V1H3a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h5v-1.5H3a.5.5 0 0 1-.5-.5V3a.5.5 0 0 1 .5-.5m11.78 4.97-3.5-3.5-1.06 1.06 2.22 2.22H6v1.5h6.44l-2.22 2.22 1.06 1.06 3.5-3.5a.75.75 0 0 0 0-1.06" clip-rule="evenodd"/>`
    }, props));
$5bb1f5651d9a5dad$var$LogOutIcon.displayName = 'LogOutIcon';
var $5bb1f5651d9a5dad$var$_default = $5bb1f5651d9a5dad$exports.default = $5bb1f5651d9a5dad$var$LogOutIcon;


var $77184fb3111af523$exports = {};
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e827695d12a93239784734f306ed1225>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty($77184fb3111af523$exports, "__esModule", {
    value: true
});
$77184fb3111af523$exports.default = void 0;

var $77184fb3111af523$var$_react = $77184fb3111af523$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $77184fb3111af523$var$_iconNew = $77184fb3111af523$var$_interopRequireDefault((parcelRequire("gDzom")));
function $77184fb3111af523$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "PeopleGroup".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/people-group
 * Usage guidance:
 * Single purpose - Known uses: representing a group or collection of people or users.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $77184fb3111af523$var$PeopleGroupIcon = (props)=>/*#__PURE__*/ $77184fb3111af523$var$_react.default.createElement($77184fb3111af523$var$_iconNew.default, Object.assign({
        name: "PeopleGroupIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M9 4.5a2 2 0 1 1 4 0 2 2 0 0 1-4 0M11 1a3.5 3.5 0 1 0 0 7 3.5 3.5 0 0 0 0-7M3 5.5a1 1 0 1 1 2 0 1 1 0 0 1-2 0M4 3a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5M2.625 9A2.625 2.625 0 0 0 0 11.625V13h1.5v-1.375c0-.621.504-1.125 1.125-1.125H5V9zM6 12.5A3.5 3.5 0 0 1 9.5 9h3a3.5 3.5 0 0 1 3.5 3.5V14h-1.5v-1.5a2 2 0 0 0-2-2h-3a2 2 0 0 0-2 2V14H6z" clip-rule="evenodd"/>`
    }, props));
$77184fb3111af523$var$PeopleGroupIcon.displayName = 'PeopleGroupIcon';
var $77184fb3111af523$var$_default = $77184fb3111af523$exports.default = $77184fb3111af523$var$PeopleGroupIcon;


var $75a03a788dbb037a$exports = {};
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::44bfe3fda6843e57916c639848bc7fcd>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty($75a03a788dbb037a$exports, "__esModule", {
    value: true
});
$75a03a788dbb037a$exports.default = void 0;

var $75a03a788dbb037a$var$_react = $75a03a788dbb037a$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $75a03a788dbb037a$var$_iconNew = $75a03a788dbb037a$var$_interopRequireDefault((parcelRequire("gDzom")));
function $75a03a788dbb037a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Person".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/person
 * Usage guidance:
 * Single purpose - Known uses: representing a person or user, owner, contributor.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $75a03a788dbb037a$var$PersonIcon = (props)=>/*#__PURE__*/ $75a03a788dbb037a$var$_react.default.createElement($75a03a788dbb037a$var$_iconNew.default, Object.assign({
        name: "PersonIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 1.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5M4 4a4 4 0 1 1 8 0 4 4 0 0 1-8 0m-2 9a3.75 3.75 0 0 1 3.75-3.75h4.5A3.75 3.75 0 0 1 14 13v2h-1.5v-2a2.25 2.25 0 0 0-2.25-2.25h-4.5A2.25 2.25 0 0 0 3.5 13v2H2z" clip-rule="evenodd"/>`
    }, props));
$75a03a788dbb037a$var$PersonIcon.displayName = 'PersonIcon';
var $75a03a788dbb037a$var$_default = $75a03a788dbb037a$exports.default = $75a03a788dbb037a$var$PersonIcon;


var $d4f0228da18a65bb$exports = {};
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::bfb96ac8121d6e86aa07f23b47de6511>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty($d4f0228da18a65bb$exports, "__esModule", {
    value: true
});
$d4f0228da18a65bb$exports.default = void 0;

var $d4f0228da18a65bb$var$_react = $d4f0228da18a65bb$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $d4f0228da18a65bb$var$_iconNew = $d4f0228da18a65bb$var$_interopRequireDefault((parcelRequire("gDzom")));
function $d4f0228da18a65bb$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Settings".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/settings
 * Usage guidance:
 * Single purpose - Reserved for any object or user settings.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $d4f0228da18a65bb$var$SettingsIcon = (props)=>/*#__PURE__*/ $d4f0228da18a65bb$var$_react.default.createElement($d4f0228da18a65bb$var$_iconNew.default, Object.assign({
        name: "SettingsIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6.058.462A.75.75 0 0 1 6.75 0h2.5a.75.75 0 0 1 .692.462l1.026 2.462 2.578-.374a.75.75 0 0 1 .757.367l1.25 2.166a.75.75 0 0 1-.049.824L13.937 8l1.567 2.093c.18.24.2.565.05.825l-1.25 2.165a.75.75 0 0 1-.758.367l-2.578-.374-1.026 2.463A.75.75 0 0 1 9.25 16h-2.5a.75.75 0 0 1-.692-.461l-1.026-2.463-2.578.374a.75.75 0 0 1-.757-.367l-1.25-2.165a.75.75 0 0 1 .049-.825L2.063 8 .496 5.907a.75.75 0 0 1-.05-.824l1.25-2.166a.75.75 0 0 1 .758-.367l2.578.374zM7.25 1.5l-.871 2.09c-.242.58-.845.923-1.467.833l-2.17-.315-.749 1.296L3.32 7.176c.366.488.366 1.16 0 1.648l-1.327 1.772.749 1.296 2.17-.315a1.375 1.375 0 0 1 1.467.832L7.25 14.5h1.5l.871-2.09c.242-.58.845-.923 1.467-.833l2.17.315.749-1.296-1.327-1.772a1.375 1.375 0 0 1 0-1.648l1.327-1.772-.749-1.296-2.17.315A1.375 1.375 0 0 1 9.62 3.59L8.75 1.5zm.75 5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3M5 8a3 3 0 1 1 6 0 3 3 0 0 1-6 0" clip-rule="evenodd"/>`
    }, props));
$d4f0228da18a65bb$var$SettingsIcon.displayName = 'SettingsIcon';
var $d4f0228da18a65bb$var$_default = $d4f0228da18a65bb$exports.default = $d4f0228da18a65bb$var$SettingsIcon;


/* link-item.tsx generated by @compiled/babel-plugin v3.0.2 */ 


var $5FkrB = parcelRequire("5FkrB");


var $5FkrB = parcelRequire("5FkrB");

var $5FkrB = parcelRequire("5FkrB");
var $93233fcd8b0b30c1$export$2931e0ee690eee88 = /*#__PURE__*/ (0, $5FkrB.createContext)({});
/**
 * __RouterLinkProvider__
 *
 * Provides a configured router link component for use
 * within Design System components.
 */ var $93233fcd8b0b30c1$var$RouterLinkProvider = function RouterLinkProvider(_ref) {
    var routerLinkComponent = _ref.routerLinkComponent, children = _ref.children;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement($93233fcd8b0b30c1$export$2931e0ee690eee88.Provider, {
        value: {
            routerLinkComponent: routerLinkComponent
        }
    }, children);
};
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$93233fcd8b0b30c1$export$2e2bcd8739ae039 = $93233fcd8b0b30c1$var$RouterLinkProvider;


var $6511f0f914349fbe$export$6d558eab13290f59 = function useRouterLink() {
    var _useContext = (0, $5FkrB.useContext)((0, $93233fcd8b0b30c1$export$2931e0ee690eee88)), routerLinkComponent = _useContext.routerLinkComponent;
    if (routerLinkComponent) return routerLinkComponent;
    return;
};



var $5FkrB = parcelRequire("5FkrB");
var $0007c9cc7bc46561$var$interactionContext = /*#__PURE__*/ (0, $5FkrB.createContext)(null);
var $0007c9cc7bc46561$export$2e2bcd8739ae039 = $0007c9cc7bc46561$var$interactionContext;


/* menu-item-primitive.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $5FkrB = parcelRequire("5FkrB");


var $50U6m = parcelRequire("50U6m");
/* inline.tsx generated by @compiled/babel-plugin v2.0.0 */ 


var $5FkrB = parcelRequire("5FkrB");


/* flex.tsx generated by @compiled/babel-plugin v2.0.0 */ 


var $5FkrB = parcelRequire("5FkrB");

var $00370acaba4d9627$var$_excluded = [
    "as",
    "role",
    "alignItems",
    "justifyContent",
    "gap",
    "columnGap",
    "rowGap",
    "children",
    "testId",
    "direction",
    "wrap",
    "xcss"
];
var $00370acaba4d9627$var$rowGapMap = {
    'space.0': "_1p57ze3t",
    'space.025': "_1p57v77o",
    'space.050': "_1p571b66",
    'space.075': "_1p5712x7",
    'space.100': "_1p57u2gc",
    'space.150': "_1p57utpp",
    'space.200': "_1p57pxbi",
    'space.250': "_1p57v47k",
    'space.300': "_1p571ejb",
    'space.400': "_1p57xy5q",
    'space.500': "_1p571jfw",
    'space.600': "_1p57oahv",
    'space.800': "_1p57xncg",
    'space.1000': "_1p571epz"
};
var $00370acaba4d9627$var$columnGapMap = {
    'space.0': "_gy1pze3t",
    'space.025': "_gy1pv77o",
    'space.050': "_gy1p1b66",
    'space.075': "_gy1p12x7",
    'space.100': "_gy1pu2gc",
    'space.150': "_gy1putpp",
    'space.200': "_gy1ppxbi",
    'space.250': "_gy1pv47k",
    'space.300': "_gy1p1ejb",
    'space.400': "_gy1pxy5q",
    'space.500': "_gy1p1jfw",
    'space.600': "_gy1poahv",
    'space.800': "_gy1pxncg",
    'space.1000': "_gy1p1epz"
};
var $00370acaba4d9627$var$justifyContentMap = {
    start: "_1bahv2br",
    center: "_1bah1h6o",
    end: "_1bahh9n0",
    'space-between': "_1bah1yb4",
    'space-around': "_1bah1b1v",
    'space-evenly': "_1bahitcz",
    stretch: "_1bah1fhb"
};
var $00370acaba4d9627$var$flexDirectionMap = {
    column: "_2lx21bp4",
    row: "_2lx2vrvc"
};
var $00370acaba4d9627$var$flexWrapMap = {
    wrap: "_1n261g80",
    nowrap: "_1n261q9c"
};
var $00370acaba4d9627$var$alignItemsMap = {
    start: "_4cvrv2br",
    center: "_4cvr1h6o",
    baseline: "_4cvr1q9y",
    end: "_4cvrh9n0",
    stretch: "_4cvr1fhb"
};
var $00370acaba4d9627$var$styles = {
    root: "_1e0c1txw _vchhusvi"
};
var $00370acaba4d9627$export$f51f4c4ede09e011 = /*#__PURE__*/ (0, $5FkrB.memo)(/*#__PURE__*/ (0, $5FkrB.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? 'div' : _ref$as, role = _ref.role, alignItems = _ref.alignItems, justifyContent = _ref.justifyContent, gap = _ref.gap, columnGap = _ref.columnGap, rowGap = _ref.rowGap, children = _ref.children, testId = _ref.testId, direction = _ref.direction, wrap = _ref.wrap, xcss = _ref.xcss, ariaAttributes = (0, $a9c67d4ab15fb282$export$2e2bcd8739ae039)(_ref, $00370acaba4d9627$var$_excluded);
    return /*#__PURE__*/ $5FkrB.createElement(Component, (0, $a98c0fbb1cee895f$export$2e2bcd8739ae039)({}, ariaAttributes, {
        role: role,
        className: (0, $67c6184bd64e9e07$export$2e2bcd8739ae039)([
            $00370acaba4d9627$var$styles.root,
            gap && $00370acaba4d9627$var$columnGapMap[gap],
            columnGap && $00370acaba4d9627$var$columnGapMap[columnGap],
            gap && $00370acaba4d9627$var$rowGapMap[gap],
            rowGap && $00370acaba4d9627$var$rowGapMap[rowGap],
            alignItems && $00370acaba4d9627$var$alignItemsMap[alignItems],
            direction && $00370acaba4d9627$var$flexDirectionMap[direction],
            justifyContent && $00370acaba4d9627$var$justifyContentMap[justifyContent],
            wrap && $00370acaba4d9627$var$flexWrapMap[wrap],
            xcss
        ]),
        "data-testid": testId,
        ref: ref
    }), children);
}));
$00370acaba4d9627$export$f51f4c4ede09e011.displayName = 'Flex';


var $04267de539304abd$var$_excluded = [
    "as",
    "alignInline",
    "alignBlock",
    "shouldWrap",
    "spread",
    "grow",
    "space",
    "rowSpace",
    "separator",
    "xcss",
    "testId",
    "role",
    "children"
];
var $04267de539304abd$var$styles = {
    separator: "_1mouze3t _195g1i6y _syazjjyb _lcxvglyw _uiztglyw",
    hug: "_16jlidpf",
    fill: "_1bsb1osq _16jlkb7n"
};
var $04267de539304abd$var$Separator = function Separator(_ref) {
    var children = _ref.children;
    return /*#__PURE__*/ $5FkrB.createElement("span", {
        className: (0, $67c6184bd64e9e07$export$2e2bcd8739ae039)([
            $04267de539304abd$var$styles.separator
        ])
    }, children);
};
var $04267de539304abd$export$fbae5b5ffd8af05e = /*#__PURE__*/ (0, $5FkrB.memo)(/*#__PURE__*/ (0, $5FkrB.forwardRef)(function(_ref2, ref) {
    var as = _ref2.as, alignInline = _ref2.alignInline, _ref2$alignBlock = _ref2.alignBlock, alignItems = _ref2$alignBlock === void 0 ? 'start' : _ref2$alignBlock, _ref2$shouldWrap = _ref2.shouldWrap, shouldWrap = _ref2$shouldWrap === void 0 ? false : _ref2$shouldWrap, spread = _ref2.spread, grow = _ref2.grow, space = _ref2.space, rowSpace = _ref2.rowSpace, separator = _ref2.separator, xcss = _ref2.xcss, testId = _ref2.testId, role = _ref2.role, rawChildren = _ref2.children, ariaAttributes = (0, $a9c67d4ab15fb282$export$2e2bcd8739ae039)(_ref2, $04267de539304abd$var$_excluded);
    var separatorComponent = typeof separator === 'string' ? /*#__PURE__*/ $5FkrB.createElement($04267de539304abd$var$Separator, null, separator) : separator;
    var children = separatorComponent ? (0, $5FkrB.Children).toArray(rawChildren).filter(Boolean).map(function(child, index) {
        return /*#__PURE__*/ $5FkrB.createElement((0, $5FkrB.Fragment), {
            key: index
        }, separator && index > 0 ? separatorComponent : null, child);
    }) : rawChildren;
    return /*#__PURE__*/ $5FkrB.createElement((0, $00370acaba4d9627$export$f51f4c4ede09e011), (0, $a98c0fbb1cee895f$export$2e2bcd8739ae039)({}, ariaAttributes, {
        as: as,
        role: role,
        alignItems: alignItems,
        justifyContent: spread || alignInline,
        direction: "row",
        gap: space,
        rowGap: rowSpace,
        wrap: shouldWrap ? 'wrap' : undefined,
        xcss: (0, $d01a5d8bb96c5a7e$export$a274e22fb40f762e)(grow === 'hug' && $04267de539304abd$var$styles.hug, grow === 'fill' && $04267de539304abd$var$styles.fill, xcss),
        testId: testId,
        ref: ref
    }), children);
}));
$04267de539304abd$export$fbae5b5ffd8af05e.displayName = 'Inline';



var $5FkrB = parcelRequire("5FkrB");
var $57239b3517b17a58$export$443076ec7ebce042 = /*#__PURE__*/ (0, $5FkrB.createContext)('cozy');



var $5FkrB = parcelRequire("5FkrB");
var $8ebe66d8096f6b8c$export$9ca534b70725964d = /*#__PURE__*/ (0, $5FkrB.createContext)('border');


var $aa6e35b056f777b0$var$renderTitle = function renderTitle(Component, props) {
    return(/*#__PURE__*/ // eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    $5FkrB.createElement(Component, props));
};
var $aa6e35b056f777b0$var$styles = {
    root: "_19itidpf _12ji1r31 _1qu2glyw _12y3idpf _4bfu1r31 _1hmsglyw _ajmmnqa1 _kqswh2mm _1e0c1txw _vchhusvi _1bsb1osq _1tke1ylp _1pfhze3t _12l2ze3t _6rthze3t _ahbqze3t _4cvr1h6o _uiztglyw _80omtlke _ymio1r31 _ypr0glyw _zcxs1o36 _nt751v1w _mizu1v1w _1bg41gjf _1ah31gjf _49pcnqa1 _ra3xnqa1 _1hvwdkaa _128mdkaa _9oik1r31 _1bnxglyw _jf4cnqa1 _1cvmnqa1 _4davt94y",
    beforeAfterElement: "_1e0c1txw _1ul91tcg _1tke1tcg _4cvr1h6o _1bah1h6o _1o9zidpf",
    content: "_12ji1r31 _1qu2glyw _12y31o36 _1reo15vq _18m915vq _1e0c1txw _2lx21bp4 _1bah1h6o _16jlkb7n _y3gn1e5h",
    truncate: "_1reo15vq _18m915vq _1e0c1ule _1bto1l2s _o5721q9c",
    title: "_11c8fhey",
    wordBreak: "_1nmz1hna",
    description: "_11c8wadc _syaz1rpy",
    disabledDescription: "_syaz1gmx",
    unselected: "_bfhksm61 _syaz1r31 _10531r31 _irr31dpa _30l31r31 _1di61dpa _9h8h1r31",
    disabled: "_80om13gf _bfhksm61 _syaz1gmx _irr3sm61 _30l31gmx _1di6sm61 _9h8h1gmx",
    selectedBorder: "_1mp4yh40 _1cs8stnw _1rusq98m _1kt9b3bt _1fkrze3t _iajmze3t _z5wtze3t",
    selectedNotch: "_rfx3bx74 _1mp41y44 _1cs8stnw _1rusq98m _1kt9b3bt _1fkrutpp _iajmutpp _z5wtze3t",
    selected: "_bfhk15s3 _syaz6x5g _10536x5g _irr3ufnl _30l316jw _1di6nozp _9h8h6x5g",
    selectedOld: "_30l36x5g",
    motionUnselected: "_v564hxmd _o7kshxmd _1ggl87vo",
    motionSelected: "_v5641rrn _o7kshxmd"
};
var $aa6e35b056f777b0$var$spacingMapStyles = {
    cozy: "_1rjcu2gc _18zrpxbi",
    compact: "_1rjc1b66 _18zrutpp _1tkezwfg"
};
var $aa6e35b056f777b0$var$gapMap = {
    compact: 'space.100',
    cozy: 'space.150'
};
/**
 * __Menu item primitive__
 *
 * Menu item primitive contains all the styles for menu items,
 * including support for selected, disabled, and interaction states.
 *
 * Using children as function prop you wire up this to your own host element.
 *
 * ```jsx
 * <MenuItemPrimitive>
 *   {({ children, ...props }) => <button {...props}>{children}</button>}
 * </MenuItemPrimitive>
 * ```
 */ var $aa6e35b056f777b0$var$MenuItemPrimitive = function MenuItemPrimitive(_ref) {
    var children = _ref.children, title = _ref.title, description = _ref.description, iconAfter = _ref.iconAfter, iconBefore = _ref.iconBefore, UNSAFE_externalClassName = _ref.className, _ref$shouldTitleWrap = _ref.shouldTitleWrap, shouldTitleWrap = _ref$shouldTitleWrap === void 0 ? false : _ref$shouldTitleWrap, _ref$shouldDescriptio = _ref.shouldDescriptionWrap, shouldDescriptionWrap = _ref$shouldDescriptio === void 0 ? false : _ref$shouldDescriptio, _ref$isDisabled = _ref.isDisabled, isDisabled = _ref$isDisabled === void 0 ? false : _ref$isDisabled, _ref$isSelected = _ref.isSelected, isSelected = _ref$isSelected === void 0 ? false : _ref$isSelected, _ref$isTitleHeading = _ref.isTitleHeading, isTitleHeading = _ref$isTitleHeading === void 0 ? false : _ref$isTitleHeading, testId = _ref.testId;
    var spacing = (0, $5FkrB.useContext)((0, $57239b3517b17a58$export$443076ec7ebce042));
    var selectionStyle = (0, $5FkrB.useContext)((0, $8ebe66d8096f6b8c$export$9ca534b70725964d));
    var UNSAFE_className = UNSAFE_externalClassName;
    return function() {
        return children({
            className: (0, $9eb596671e88e808$export$2e2bcd8739ae039)([
                (0, $9eb596671e88e808$export$2e2bcd8739ae039)([
                    $aa6e35b056f777b0$var$styles.root,
                    $aa6e35b056f777b0$var$spacingMapStyles[spacing],
                    !isDisabled && !isSelected && $aa6e35b056f777b0$var$styles.unselected,
                    !isDisabled && !isSelected && (0, $50U6m.fg)('platform-dst-motion-uplift-list-item') && $aa6e35b056f777b0$var$styles.motionUnselected,
                    !isDisabled && isSelected && $aa6e35b056f777b0$var$styles.selected,
                    !isDisabled && isSelected && (0, $50U6m.fg)('platform-dst-motion-uplift-list-item') && $aa6e35b056f777b0$var$styles.motionSelected,
                    !isDisabled && isSelected && $aa6e35b056f777b0$var$styles.selectedOld,
                    !isDisabled && isSelected && selectionStyle === 'border' && $aa6e35b056f777b0$var$styles.selectedBorder,
                    !isDisabled && isSelected && selectionStyle === 'notch' && $aa6e35b056f777b0$var$styles.selectedNotch,
                    isDisabled && $aa6e35b056f777b0$var$styles.disabled
                ]),
                UNSAFE_className
            ]),
            children: /*#__PURE__*/ $5FkrB.createElement((0, $04267de539304abd$export$fbae5b5ffd8af05e), {
                as: "span",
                spread: "space-between",
                alignBlock: "center",
                space: $aa6e35b056f777b0$var$gapMap[spacing],
                grow: "fill",
                testId: testId && "".concat(testId, "--container")
            }, iconBefore && /*#__PURE__*/ $5FkrB.createElement("span", {
                "data-item-elem-before": true,
                "data-testid": testId && "".concat(testId, "--icon-before"),
                className: (0, $9eb596671e88e808$export$2e2bcd8739ae039)([
                    $aa6e35b056f777b0$var$styles.beforeAfterElement
                ])
            }, iconBefore), title && /*#__PURE__*/ $5FkrB.createElement("div", {
                className: (0, $9eb596671e88e808$export$2e2bcd8739ae039)([
                    $aa6e35b056f777b0$var$styles.content
                ])
            }, $aa6e35b056f777b0$var$renderTitle(isTitleHeading ? 'h2' : 'span', {
                children: title,
                className: (0, $9eb596671e88e808$export$2e2bcd8739ae039)([
                    $aa6e35b056f777b0$var$styles.title,
                    shouldTitleWrap ? $aa6e35b056f777b0$var$styles.wordBreak : $aa6e35b056f777b0$var$styles.truncate
                ]),
                'data-item-title': true
            }), description && /*#__PURE__*/ $5FkrB.createElement("span", {
                "data-item-description": true,
                className: (0, $9eb596671e88e808$export$2e2bcd8739ae039)([
                    $aa6e35b056f777b0$var$styles.description,
                    isDisabled && $aa6e35b056f777b0$var$styles.disabledDescription,
                    shouldDescriptionWrap && $aa6e35b056f777b0$var$styles.wordBreak,
                    !shouldDescriptionWrap && $aa6e35b056f777b0$var$styles.truncate
                ])
            }, description)), iconAfter && /*#__PURE__*/ $5FkrB.createElement("span", {
                "data-item-elem-after": true,
                "data-testid": testId && "".concat(testId, "--icon-after"),
                className: (0, $9eb596671e88e808$export$2e2bcd8739ae039)([
                    $aa6e35b056f777b0$var$styles.beforeAfterElement
                ])
            }, iconAfter))
        });
    }();
};
var $aa6e35b056f777b0$export$2e2bcd8739ae039 = $aa6e35b056f777b0$var$MenuItemPrimitive;


var $08f543ef51158ffe$var$_excluded = [
    "children",
    "href",
    "description",
    "iconAfter",
    "iconBefore",
    "isDisabled",
    "isSelected",
    "onClick",
    "testId",
    "onMouseDown",
    "shouldTitleWrap",
    "shouldDescriptionWrap",
    "className",
    "UNSAFE_shouldDisableRouterLink",
    "UNSAFE_isDraggable",
    "interactionName"
];
var $08f543ef51158ffe$var$IS_EXTERNAL_LINK_REGEX = /^(?:(http|https):\/\/)/;
var $08f543ef51158ffe$var$IS_NON_HTTP_BASED = /^(((mailto|tel|sms):)|(#))/;
var $08f543ef51158ffe$var$preventEvent = function preventEvent(e) {
    e.preventDefault();
};
/**
 * __Link item__
 *
 * A link item is used to populate a menu with items that are links.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/menu/docs/link-item)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/menu)
 */ var $08f543ef51158ffe$var$LinkItem = /*#__PURE__*/ (0, $5FkrB.memo)(/*#__PURE__*/ (0, $5FkrB.forwardRef)(function(props, ref) {
    var children = props.children, href = props.href, description = props.description, iconAfter = props.iconAfter, iconBefore = props.iconBefore, _props$isDisabled = props.isDisabled, isDisabled = _props$isDisabled === void 0 ? false : _props$isDisabled, _props$isSelected = props.isSelected, isSelected = _props$isSelected === void 0 ? false : _props$isSelected, onClick = props.onClick, testId = props.testId, onMouseDown = props.onMouseDown, shouldTitleWrap = props.shouldTitleWrap, shouldDescriptionWrap = props.shouldDescriptionWrap, UNSAFE_className = props.className, UNSAFE_shouldDisableRouterLink = props.UNSAFE_shouldDisableRouterLink, UNSAFE_isDraggable = props.UNSAFE_isDraggable, interactionName = props.interactionName, rest = (0, $4331f8efe1ae1766$export$2e2bcd8739ae039)(props, $08f543ef51158ffe$var$_excluded);
    var onMouseDownHandler = onMouseDown;
    var RouterLink = (0, $6511f0f914349fbe$export$6d558eab13290f59)();
    var interactionContext = (0, $5FkrB.useContext)((0, $0007c9cc7bc46561$export$2e2bcd8739ae039));
    var handleClick = (0, $5FkrB.useCallback)(function(e) {
        interactionContext === null || interactionContext === void 0 || interactionContext.tracePress(interactionName, e.timeStamp);
        onClick === null || onClick === void 0 || onClick(e);
    }, [
        onClick,
        interactionContext,
        interactionName
    ]);
    if (!children) return null;
    var isExternal = typeof href === 'string' && $08f543ef51158ffe$var$IS_EXTERNAL_LINK_REGEX.test(href);
    var isNonHttpBased = typeof href === 'string' && $08f543ef51158ffe$var$IS_NON_HTTP_BASED.test(href);
    var isEmptyHref = href == null || href === '';
    /**
   * Renders a router link if:
   *
   * - a link component is set in the app provider
   * - it's not an external link (starting with `http://` or `https://`)
   * - it's not a non-HTTP-based link (e.g. emails, phone numbers, hash links etc.)
   * - it doesn't have an empty href (e.g. href="" or href={undefined})
   */ var isRouterLink = !UNSAFE_shouldDisableRouterLink && RouterLink && !isExternal && !isNonHttpBased && !isEmptyHref;
    var Component = isRouterLink ? RouterLink : 'a';
    return /*#__PURE__*/ $5FkrB.createElement((0, $aa6e35b056f777b0$export$2e2bcd8739ae039), (0, $1d9435bc967bcf1f$export$2e2bcd8739ae039)({}, rest, {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: UNSAFE_className,
        iconBefore: iconBefore,
        iconAfter: iconAfter,
        isSelected: isSelected,
        isDisabled: isDisabled,
        isTitleHeading: false,
        description: description,
        shouldTitleWrap: shouldTitleWrap,
        shouldDescriptionWrap: shouldDescriptionWrap,
        title: children,
        testId: testId && "".concat(testId, "--primitive")
    }), function(_ref) {
        var children = _ref.children, className = _ref.className;
        return /*#__PURE__*/ $5FkrB.createElement(Component, (0, $1d9435bc967bcf1f$export$2e2bcd8739ae039)({
            "data-testid": testId,
            "data-is-router-link": testId ? isRouterLink ? 'true' : 'false' : undefined,
            "data-vc": "link-item"
        }, rest, {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: className,
            href: isDisabled ? undefined : href
        }, UNSAFE_isDraggable ? {} : {
            draggable: false,
            onDragStart: $08f543ef51158ffe$var$preventEvent
        }, {
            onMouseDown: isDisabled ? $08f543ef51158ffe$var$preventEvent : onMouseDownHandler,
            onClick: isDisabled ? $08f543ef51158ffe$var$preventEvent : handleClick,
            "aria-current": isSelected ? 'page' : undefined,
            "aria-disabled": isDisabled || undefined,
            ref: ref
        }), children);
    });
}));
var $08f543ef51158ffe$export$2e2bcd8739ae039 = $08f543ef51158ffe$var$LinkItem;


/* menu-group.tsx generated by @compiled/babel-plugin v3.0.2 */ 


var $5FkrB = parcelRequire("5FkrB");



var $a4e17e9e7a8d2775$var$_excluded = [
    "isLoading",
    "maxWidth",
    "minWidth",
    "minHeight",
    "maxHeight",
    "testId",
    "role",
    "spacing",
    "menuLabel",
    "className"
];
var $a4e17e9e7a8d2775$var$baseStyles = null;
/**
 * __Menu group__
 *
 * A menu group includes all the actions or items in a menu.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/menu/docs/menu-group)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/menu)
 */ var $a4e17e9e7a8d2775$var$MenuGroup = function MenuGroup(_ref) {
    var isLoading = _ref.isLoading, maxWidth = _ref.maxWidth, minWidth = _ref.minWidth, minHeight = _ref.minHeight, maxHeight = _ref.maxHeight, testId = _ref.testId, role = _ref.role, _ref$spacing = _ref.spacing, spacing = _ref$spacing === void 0 ? 'cozy' : _ref$spacing, menuLabel = _ref.menuLabel, UNSAFE_className = _ref.className, rest = (0, $4331f8efe1ae1766$export$2e2bcd8739ae039)(_ref, $a4e17e9e7a8d2775$var$_excluded);
    return /*#__PURE__*/ $5FkrB.createElement((0, $57239b3517b17a58$export$443076ec7ebce042).Provider, {
        value: spacing
    }, /*#__PURE__*/ $5FkrB.createElement((0, $8ebe66d8096f6b8c$export$9ca534b70725964d).Provider, {
        value: "border"
    }, /*#__PURE__*/ $5FkrB.createElement("div", (0, $1d9435bc967bcf1f$export$2e2bcd8739ae039)({
        "aria-busy": isLoading,
        style: {
            minWidth: minWidth,
            maxWidth: maxWidth,
            minHeight: minHeight,
            maxHeight: maxHeight
        },
        "data-testid": testId,
        role: role,
        className: (0, $9eb596671e88e808$export$2e2bcd8739ae039)([
            "_1reo1wug _18m91wug _1e0c1txw _kqswpfqs _2lx21bp4",
            UNSAFE_className
        ]),
        "aria-label": menuLabel
    }, rest))));
};
var $a4e17e9e7a8d2775$export$2e2bcd8739ae039 = $a4e17e9e7a8d2775$var$MenuGroup;


/* section.tsx generated by @compiled/babel-plugin v3.0.2 */ 


var $5FkrB = parcelRequire("5FkrB");

/* heading-item.tsx generated by @compiled/babel-plugin v3.0.2 */ 


var $5FkrB = parcelRequire("5FkrB");

var $f954a2a88164584a$var$_excluded = [
    "children",
    "testId",
    "headingLevel",
    "id",
    "className"
];
var $f954a2a88164584a$var$headingStyles = null;
/**
 * __Heading item__
 *
 * A heading item is used to describe sibling menu items.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/menu/docs/heading-item)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/menu)
 */ var $f954a2a88164584a$var$HeadingItem = /*#__PURE__*/ (0, $5FkrB.memo)(function(_ref) {
    var children = _ref.children, testId = _ref.testId, _ref$headingLevel = _ref.headingLevel, headingLevel = _ref$headingLevel === void 0 ? 2 : _ref$headingLevel, id = _ref.id, UNSAFE_className = _ref.className, rest = (0, $4331f8efe1ae1766$export$2e2bcd8739ae039)(_ref, $f954a2a88164584a$var$_excluded);
    return /*#__PURE__*/ $5FkrB.createElement("div", (0, $1d9435bc967bcf1f$export$2e2bcd8739ae039)({
        role: "heading",
        "aria-level": headingLevel,
        "data-testid": testId,
        "data-ds--menu--heading-item": true,
        id: id,
        className: (0, $9eb596671e88e808$export$2e2bcd8739ae039)([
            "_11c8i4vh _1rjcze3t _18zrpxbi _syazazsu",
            UNSAFE_className
        ])
    }, rest), children);
});
var $f954a2a88164584a$export$2e2bcd8739ae039 = $f954a2a88164584a$var$HeadingItem;


var $8cf8088017c5287d$var$_excluded = [
    "children",
    "title",
    "titleId",
    "testId",
    "isScrollable",
    "hasSeparator",
    "id",
    "isList",
    "isSideNavSection",
    "label",
    "className"
];
var $8cf8088017c5287d$var$itemHeadingTopMargin = 20;
var $8cf8088017c5287d$var$itemHeadingBottomMargin = 6;
// Skeleton content is slightly shorter than the real content.
// Because of that we slightly increase the top margin to offset this so the
// containing size both real and skeleton always equal approx 30px.
var $8cf8088017c5287d$var$itemHeadingContentHeight = 16; // Originally headingSizes.h100.lineHeight from '@atlaskit/theme/typography'
var $8cf8088017c5287d$var$skeletonHeadingHeight = 8;
var $8cf8088017c5287d$var$skeletonHeadingMarginOffset = 3;
var $8cf8088017c5287d$var$skeletonHeadingTopMargin = $8cf8088017c5287d$var$itemHeadingTopMargin + ($8cf8088017c5287d$var$itemHeadingContentHeight - $8cf8088017c5287d$var$skeletonHeadingHeight) - $8cf8088017c5287d$var$skeletonHeadingMarginOffset;
var $8cf8088017c5287d$var$sectionPaddingTopBottom = 6;
var $8cf8088017c5287d$var$styles = {
    root: "_1ywu1ule _cfu11ule _1qdgi2wt _kfgti2wt _aetrb3bt _1kt9b3bt _1p3hi2wt _1l6bgktf _osbldlk8 _auo4rdoj _hp2110yn _1mfv8jkm _1bg41n1a",
    scrollable: "_1reo1wug _18m91wug _1o9zkb7n",
    unscrollable: "_1o9zidpf",
    thinSeparator: "_mqm2lllh",
    noSeparator: "_n7cnyjp0",
    sideNavSectionHeading: "_18zru2gc"
};
/**
 * __Section__
 *
 * A section includes related actions or items in a menu.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/menu/docs/section)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/menu)
 */ var $8cf8088017c5287d$var$Section = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function(_ref, ref) {
    var children = _ref.children, title = _ref.title, titleId = _ref.titleId, testId = _ref.testId, isScrollable = _ref.isScrollable, hasSeparator = _ref.hasSeparator, id = _ref.id, _ref$isList = _ref.isList, isList = _ref$isList === void 0 ? false : _ref$isList, _ref$isSideNavSection = _ref.isSideNavSection, isSideNavSection = _ref$isSideNavSection === void 0 ? false : _ref$isSideNavSection, label = _ref.label, UNSAFE_className = _ref.className, rest = (0, $4331f8efe1ae1766$export$2e2bcd8739ae039)(_ref, $8cf8088017c5287d$var$_excluded);
    var content = isList ? /*#__PURE__*/ $5FkrB.createElement("ul", {
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            margin: 0,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            padding: 0
        }
    }, (0, $5FkrB.Children).map((0, $5FkrB.Children).toArray(children), function(child, index) {
        return /*#__PURE__*/ $5FkrB.createElement("li", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            style: {
                listStyleType: 'none',
                margin: 0,
                padding: 0
            },
            key: index
        }, child);
    })) : children;
    var childrenMarkup = title !== undefined ? /*#__PURE__*/ $5FkrB.createElement((0, $5FkrB.Fragment), null, /*#__PURE__*/ $5FkrB.createElement((0, $f954a2a88164584a$export$2e2bcd8739ae039), {
        testId: testId && "".concat(testId, "--heading"),
        "aria-hidden": true,
        className: (0, $9eb596671e88e808$export$2e2bcd8739ae039)([
            isSideNavSection && $8cf8088017c5287d$var$styles.sideNavSectionHeading
        ])
    }, title), content) : /*#__PURE__*/ $5FkrB.createElement((0, $5FkrB.Fragment), null, content);
    return /*#__PURE__*/ $5FkrB.createElement("div", (0, $1d9435bc967bcf1f$export$2e2bcd8739ae039)({}, rest, {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $9eb596671e88e808$export$2e2bcd8739ae039)([
            $8cf8088017c5287d$var$styles.root,
            isScrollable ? $8cf8088017c5287d$var$styles.scrollable : $8cf8088017c5287d$var$styles.unscrollable,
            hasSeparator ? $8cf8088017c5287d$var$styles.thinSeparator : $8cf8088017c5287d$var$styles.noSeparator,
            UNSAFE_className
        ]),
        id: id,
        "aria-label": title || label,
        "aria-labelledby": titleId,
        "data-testid": testId,
        role: "group",
        "data-section": true,
        ref: ref
    }), childrenMarkup);
});
var $8cf8088017c5287d$export$2e2bcd8739ae039 = $8cf8088017c5287d$var$Section;



var $50U6m = parcelRequire("50U6m");
function $d3d83eb9e25f7f1c$export$2e2bcd8739ae039() {
    return $d3d83eb9e25f7f1c$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $d3d83eb9e25f7f1c$export$2e2bcd8739ae039.apply(null, arguments);
}


function $fd6785fb31119465$export$2e2bcd8739ae039(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}


function $9782bdcbae553a67$export$2e2bcd8739ae039(e, t) {
    if (null == e) return {};
    var o, r, i = (0, $fd6785fb31119465$export$2e2bcd8739ae039)(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}



var $5FkrB = parcelRequire("5FkrB");

var $6bnW7 = parcelRequire("6bnW7");
var $bgNpv = parcelRequire("bgNpv");
var $hrVKU = parcelRequire("hrVKU");
function $4a7ae0731a7e1583$export$2e2bcd8739ae039() {
    return $4a7ae0731a7e1583$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $4a7ae0731a7e1583$export$2e2bcd8739ae039.apply(null, arguments);
}


function $8afc14c1e2acb4e5$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $8afc14c1e2acb4e5$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $8afc14c1e2acb4e5$export$2e2bcd8739ae039(o);
}



function $3be8579f3e24ac17$export$2e2bcd8739ae039(t, r) {
    if ("object" != (0, $8afc14c1e2acb4e5$export$2e2bcd8739ae039)(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (0, $8afc14c1e2acb4e5$export$2e2bcd8739ae039)(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}


function $7cbac6aa0d654f90$export$2e2bcd8739ae039(t) {
    var i = (0, $3be8579f3e24ac17$export$2e2bcd8739ae039)(t, "string");
    return "symbol" == (0, $8afc14c1e2acb4e5$export$2e2bcd8739ae039)(i) ? i : i + "";
}


function $a48c245bf23e2005$export$2e2bcd8739ae039(e, r, t) {
    return (r = (0, $7cbac6aa0d654f90$export$2e2bcd8739ae039)(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}


function $b84ad113e96a7b5c$export$2e2bcd8739ae039(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}


function $b94f3d2584a27e94$export$2e2bcd8739ae039(e, t) {
    if (null == e) return {};
    var o, r, i = (0, $b84ad113e96a7b5c$export$2e2bcd8739ae039)(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}


function $10429dd35ee629c4$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return r;
}


function $c9611e34cdd1dcff$export$2e2bcd8739ae039(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}


function $7b3afea154547032$export$2e2bcd8739ae039(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}


function $1e7e05e4e5a163d6$export$2e2bcd8739ae039(r, a) {
    if (r) {
        if ("string" == typeof r) return (0, $7b3afea154547032$export$2e2bcd8739ae039)(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? (0, $7b3afea154547032$export$2e2bcd8739ae039)(r, a) : void 0;
    }
}


function $b9188895afec00d5$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}


function $fe9ce0f81f7af2c1$export$2e2bcd8739ae039(r, e) {
    return (0, $10429dd35ee629c4$export$2e2bcd8739ae039)(r) || (0, $c9611e34cdd1dcff$export$2e2bcd8739ae039)(r, e) || (0, $1e7e05e4e5a163d6$export$2e2bcd8739ae039)(r, e) || (0, $b9188895afec00d5$export$2e2bcd8739ae039)();
}



var $5FkrB = parcelRequire("5FkrB");




var $5FkrB = parcelRequire("5FkrB");
/* button-base.tsx generated by @compiled/babel-plugin v2.0.0 */ 

/**
 * The length of the value hash portion of an atomic class name.
 * Atomic class names have the format: `_<group><value>`
 * where group is ATOMIC_GROUP_HASH_LENGTH chars and value is ATOMIC_VALUE_HASH_LENGTH chars.
 *
 * We extract the group key using: `className.slice(0, className.length - ATOMIC_VALUE_HASH_LENGTH)`
 *
 * We support both old-format classes (9 chars: `_` + 4 group + 4 value) and
 * new-format classes (11 chars: `_` + 6 group + 4 value) by using length-based
 * extraction rather than a hardcoded offset — old and new format group keys
 * are different lengths so they are structurally disjoint and never alias each other.
 */ const $1b3f3ddecda00731$var$ATOMIC_VALUE_HASH_LENGTH = 4;
function $1b3f3ddecda00731$export$2e2bcd8739ae039(classNames) {
    // Shortcut: nothing to do
    if (!classNames.length) return;
    // Shortcut: don't need to do anything if we only have a single classname
    if (classNames.length === 1 && classNames[0] && // checking to see if `classNames[0]` is a string that contains other classnames
    !classNames[0].includes(' ')) return classNames[0];
    // Using an object rather than a `Map` as it performed better in our benchmarks.
    // Would be happy to move to `Map` if it proved to be better under real conditions.
    const map = {};
    // Note: using loops to minimize iterations over the collection
    for (const value of classNames){
        // Exclude all falsy values, which leaves us with populated strings
        if (!value) continue;
        // a `value` can contain multiple classnames
        const list = value.split(' ');
        for (const className of list){
            /**
             * For atomic style classnames: the `key` is the `group`
             *
             * - Later atomic classnames with the same `group` will override earlier ones
             *   (which is what we want).
             * - Assumes atomic classnames are the only things that start with `_`
             * - Could use a regex to ensure that atomic classnames are structured how we expect,
             *   but did not add that for now as it did slow things down a bit.
             *
             * For other classnames: the `key` is the whole classname
             * - Okay to remove duplicates as doing so does not impact specificity
             *
             * */ const key = className.startsWith('_') ? className.slice(0, className.length - $1b3f3ddecda00731$var$ATOMIC_VALUE_HASH_LENGTH) : className;
            map[key] = className;
        }
    }
    /**
     * We are converting the `map` into a string.
     *
     * The simple way to do this would be `Object.values(map).join(' ')`.
     * However, the approach below performs 10%-20% better in benchmarks.
     *
     * For `ax()` it feels right to squeeze as much runtime performance out as we can.
     */ let result = '';
    for(const key in map)result += map[key] + ' ';
    // If we have an empty string, then our `map` was empty.
    if (!result) return;
    // remove last " " from the result (we added " " at the end of every value)
    return result.trimEnd();
}



var $5FkrB = parcelRequire("5FkrB");





var $50U6m = parcelRequire("50U6m");
/* pressable.tsx generated by @compiled/babel-plugin v2.0.0 */ 


var $5FkrB = parcelRequire("5FkrB");


const $317d9a8b066b1005$export$a274e22fb40f762e = (...styles)=>{
    // At runtime TStyles is resolved down to strings, but not at compile time.
    // We circumvent the type system here because of that.
    const actualStyles = styles;
    // The output should be a union type of passed in styles. This ensures the call
    // site of xcss prop can raise violations when disallowed styles have been passed.
    return (0, $67c6184bd64e9e07$export$2e2bcd8739ae039)(actualStyles);
};



function $9cdac13a38ee471b$export$95df08bae54cb4df() {
    if (typeof window !== 'undefined' && window.navigator != null) {
        var _window$navigator$use;
        var ua = (_window$navigator$use = window.navigator.userAgent) === null || _window$navigator$use === void 0 ? void 0 : _window$navigator$use.toLowerCase();
        return ua ? ua.includes('safari') && !ua.includes('chrome') : false;
    }
    return false;
}




var $5FkrB = parcelRequire("5FkrB");
var $d1efb683945e3992$var$interactionContext = /*#__PURE__*/ (0, $5FkrB.createContext)(null);
var $d1efb683945e3992$export$2e2bcd8739ae039 = $d1efb683945e3992$var$interactionContext;


/* focusable.tsx generated by @compiled/babel-plugin v2.0.0 */ 


var $5FkrB = parcelRequire("5FkrB");

var $40b2ed289482eab3$var$_excluded = [
    "as",
    "children",
    "isInset",
    "testId",
    "style",
    "xcss"
], $40b2ed289482eab3$var$_excluded2 = [
    "className"
];
var $40b2ed289482eab3$var$focusRingStyles = null;
var $40b2ed289482eab3$var$insetFocusRingStyles = null;
var $40b2ed289482eab3$export$35a3bebf7ef2d934 = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? 'button' : _ref$as, children = _ref.children, isInset = _ref.isInset, testId = _ref.testId, style = _ref.style, xcss = _ref.xcss, htmlAttributes = (0, $a9c67d4ab15fb282$export$2e2bcd8739ae039)(_ref, $40b2ed289482eab3$var$_excluded);
    // This is to remove className from safeHtmlAttributes
    // @ts-ignore -- not using expect since it causes issues with help-center local consumption - className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    var _spreadClass = htmlAttributes.className, safeHtmlAttributes = (0, $a9c67d4ab15fb282$export$2e2bcd8739ae039)(htmlAttributes, $40b2ed289482eab3$var$_excluded2);
    return /*#__PURE__*/ $5FkrB.createElement(Component, (0, $a98c0fbb1cee895f$export$2e2bcd8739ae039)({}, safeHtmlAttributes, {
        // @ts-ignore Expression produces a union type that is too complex to represent. We may be able to narrow the type here but unsure.
        ref: ref,
        className: (0, $67c6184bd64e9e07$export$2e2bcd8739ae039)([
            "_ymio1r31 _ypr0glyw _zcxs1o36 _mizu194a _1ah3dkaa _ra3xnqa1 _128mdkaa _1cvmnqa1 _4davt94y",
            isInset && "_1ah31gjf _2mwq1gjf",
            xcss
        ]),
        style: style,
        "data-testid": testId
    }), children);
});


var $859d1b6c2ad6603b$var$_excluded = [
    "children",
    "isDisabled",
    "type",
    "onClick",
    "interactionName",
    "componentName",
    "analyticsContext",
    "style",
    "testId",
    "xcss",
    "tabIndex"
], $859d1b6c2ad6603b$var$_excluded2 = [
    "className"
];
var $859d1b6c2ad6603b$var$styles = {
    root: "_19itglyw _vchhusvi _r06hglyw _80omtlke",
    disabled: "_80om13gf"
};
var $859d1b6c2ad6603b$export$27c701ed9e449e99 = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function(_ref, ref) {
    var children = _ref.children, isDisabled = _ref.isDisabled, _ref$type = _ref.type, type = _ref$type === void 0 ? 'button' : _ref$type, _ref$onClick = _ref.onClick, providedOnClick = _ref$onClick === void 0 ? (0, $adcefb868cf2fc9d$export$2e2bcd8739ae039) : _ref$onClick, interactionName = _ref.interactionName, componentName = _ref.componentName, analyticsContext = _ref.analyticsContext, style = _ref.style, testId = _ref.testId, xcss = _ref.xcss, tabIndex = _ref.tabIndex, htmlAttributes = (0, $a9c67d4ab15fb282$export$2e2bcd8739ae039)(_ref, $859d1b6c2ad6603b$var$_excluded);
    var interactionContext = (0, $5FkrB.useContext)((0, $d1efb683945e3992$export$2e2bcd8739ae039));
    var handleClick = (0, $5FkrB.useCallback)(function(e, analyticsEvent) {
        interactionContext && interactionContext.tracePress(interactionName, e.timeStamp);
        providedOnClick(e, analyticsEvent);
    }, [
        providedOnClick,
        interactionContext,
        interactionName
    ]);
    var onClick = (0, $7d6daf9bcf6c0b57$export$a4687b0234b40e28)({
        fn: handleClick,
        action: 'clicked',
        componentName: componentName || 'Pressable',
        packageName: "@atlaskit/primitives",
        packageVersion: "22.4.1",
        analyticsData: analyticsContext,
        actionSubject: 'button'
    });
    // This is to remove className from safeHtmlAttributes
    // @ts-expect-error className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    var _spreadClass = htmlAttributes.className, safeHtmlAttributes = (0, $a9c67d4ab15fb282$export$2e2bcd8739ae039)(htmlAttributes, $859d1b6c2ad6603b$var$_excluded2);
    return /*#__PURE__*/ $5FkrB.createElement((0, $40b2ed289482eab3$export$35a3bebf7ef2d934), (0, $a98c0fbb1cee895f$export$2e2bcd8739ae039)({
        as: "button",
        tabIndex: tabIndex !== null && tabIndex !== void 0 ? tabIndex : (0, $9cdac13a38ee471b$export$95df08bae54cb4df)() && !isDisabled ? 0 : undefined,
        style: style
    }, safeHtmlAttributes, {
        type: type,
        onClick: onClick,
        disabled: isDisabled,
        xcss: (0, $317d9a8b066b1005$export$a274e22fb40f762e)($859d1b6c2ad6603b$var$styles.root, isDisabled && $859d1b6c2ad6603b$var$styles.disabled, xcss),
        testId: testId,
        ref: ref
    }), children);
});



/* eslint-disable @repo/internal/react/require-jsdoc */ 
var $5FkrB = parcelRequire("5FkrB");
var $6ce5101b12a1b7f3$export$4b86304b2c0d7e71 = /*#__PURE__*/ (0, $5FkrB.createContext)(undefined);



var $5FkrB = parcelRequire("5FkrB");

var $c4b2f7b93688fa74$export$47e2c6fdb142d947 = function useSplitButtonContext() {
    var context = (0, $5FkrB.useContext)((0, $6ce5101b12a1b7f3$export$4b86304b2c0d7e71));
    if (!context) return undefined;
    if (context.appearance === 'navigation') {
        var newContext = {
            spacing: 'default',
            appearance: 'subtle',
            isDisabled: false,
            isActiveOverSelected: false,
            isNavigationSplitButton: true,
            isHighlighted: context.isHighlighted
        };
        return newContext;
    }
    var splitButtonContext = {
        spacing: context.spacing,
        appearance: context.appearance,
        isDisabled: context.isDisabled,
        isActiveOverSelected: true,
        isNavigationSplitButton: false,
        isHighlighted: false
    };
    return splitButtonContext;
};


function $dd2fd13b7e17523c$var$abort(event) {
    event.preventDefault();
    event.stopPropagation();
}
var $dd2fd13b7e17523c$var$tabKeyCode = 9;
function $dd2fd13b7e17523c$var$onKey(event) {
    // Allowing tab so that a user can move focus away
    if (event.keyCode === $dd2fd13b7e17523c$var$tabKeyCode) return;
    $dd2fd13b7e17523c$var$abort(event);
}
function $dd2fd13b7e17523c$export$2e2bcd8739ae039(shouldBlockEvents, events) {
    return shouldBlockEvents ? {
        onMouseDownCapture: $dd2fd13b7e17523c$var$abort,
        onMouseUpCapture: $dd2fd13b7e17523c$var$abort,
        onKeyDownCapture: $dd2fd13b7e17523c$var$onKey,
        onKeyUpCapture: $dd2fd13b7e17523c$var$onKey,
        onTouchStartCapture: $dd2fd13b7e17523c$var$abort,
        onTouchEndCapture: $dd2fd13b7e17523c$var$abort,
        onPointerDownCapture: $dd2fd13b7e17523c$var$abort,
        onPointerUpCapture: $dd2fd13b7e17523c$var$abort,
        onClickCapture: $dd2fd13b7e17523c$var$abort,
        // Just smashing the existing onClick for good measure
        onClick: $dd2fd13b7e17523c$var$abort
    } : events;
}



var $5FkrB = parcelRequire("5FkrB");

function $8ed64276c2b30505$var$getIconSpacing(spacing) {
    switch(spacing){
        case 'compact':
            return 'small';
        default:
            return 'medium';
    }
}
function $8ed64276c2b30505$var$getSpinnerAppearance(_ref) {
    var appearance = _ref.appearance, isDisabled = _ref.isDisabled, isSelected = _ref.isSelected;
    if (isDisabled || isSelected) return 'inherit';
    if (appearance === 'primary' || appearance === 'rovo' || appearance === 'danger' || appearance === 'discovery') return 'invert';
    return 'inherit';
}
function $8ed64276c2b30505$export$2e2bcd8739ae039(_ref2) {
    var appearance = _ref2.appearance, spacing = _ref2.spacing, isDisabled = _ref2.isDisabled, isSelected = _ref2.isSelected, testId = _ref2.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $6f7e5f007cf95a87$export$2e2bcd8739ae039), {
        size: $8ed64276c2b30505$var$getIconSpacing(spacing),
        appearance: $8ed64276c2b30505$var$getSpinnerAppearance({
            appearance: appearance,
            isDisabled: isDisabled,
            isSelected: isSelected
        }),
        testId: testId ? "".concat(testId, "--loading-spinner") : undefined
    });
}


var $76b58416a5044cb0$var$_excluded = [
    "appearance",
    "autoFocus",
    "isDisabled",
    "isLoading",
    "isSelected",
    "isIconButton",
    "isCircle",
    "hasIconBefore",
    "hasIconAfter",
    "shouldFitContainer",
    "spacing",
    "ariaLabel",
    "ariaLabelledBy",
    "children",
    "interactionName",
    "onClick",
    "onMouseDown",
    "onMouseDownCapture",
    "onMouseUp",
    "onMouseUpCapture",
    "onKeyDown",
    "onKeyDownCapture",
    "onKeyUp",
    "onKeyUpCapture",
    "onTouchStart",
    "onTouchStartCapture",
    "onTouchEnd",
    "onTouchEndCapture",
    "onPointerDown",
    "onPointerDownCapture",
    "onPointerUp",
    "onPointerUpCapture",
    "onClickCapture",
    "testId",
    "analyticsContext",
    "componentName",
    "role",
    "onMouseOver",
    "onMouseOut",
    "onFocus",
    "onBlur",
    "onMouseMove",
    "type"
], $76b58416a5044cb0$var$_excluded2 = [
    "className",
    "css",
    "as",
    "style"
];
var $76b58416a5044cb0$var$LOADING_LABEL = ', Loading';
var $76b58416a5044cb0$var$styles = {
    base: "_2rkofajl _11c8fhey _v5649dqc _189eidpf _1rjc12x7 _1e0c116y _vchhusvi _1bsb1wug _p12f1osq _kqswh2mm _4cvr1q9y _1bah1h6o _gy1p1b66 _1o9zidpf _4t3iviql _k48p1wq8 _y4tiutpp _bozgutpp _y3gn1h6o _s7n4nkob _14mj1kw7 _9v7aze3t _1tv3nqa1 _39yqe4h9 _11fnglyw _18postnw",
    baseT26Shape: "_2rko1qi0",
    interactiveMotion: "_v564k6bl _1ggl5xtf",
    linkDecorationUnset: "_4bfu1r31 _1hmsglyw _ajmmnqa1 _1a3b1r31 _4fprglyw _5goinqa1 _9oik1r31 _1bnxglyw _jf4cnqa1 _1nrm1r31 _c2waglyw _1iohnqa1",
    disabled: "_80om13gf _syaz1gmx _30l31gmx _9h8h1gmx",
    sharedDisabled: "_bfhk187o _irr3187o _1di6187o",
    spacingCompact: "_1rjcv77o _gy1p1b66 _4t3i1k8s _y4tiutpp _bozgutpp _s7n4nkob",
    spacingCompactT26Shape: "_2rko12b0",
    circle: "_2rko1rr0",
    fullWidth: "_1bsb1osq",
    loading: "_80om15jw",
    iconButton: "_4t3iviql _1bsbviql _y4tize3t _bozgze3t",
    iconButtonCompact: "_4t3i1k8s _1bsb1k8s",
    buttonIconBefore: "_bozgutpp _gy1p12x7",
    buttonIconAfter: "_y4tiutpp _gy1p12x7",
    splitButton: "_g0pbb4wl",
    loadingOverlay: "_1reo15vq _18m915vq _1e0c1txw _kqswstnw _4cvr1h6o _1bah1h6o _u7coze3t _152tze3t _rjxpze3t _1e02ze3t",
    navigationSplitButton: "_1bsb1tcg _bfhksm61 _y4ti12x7 _bozg12x7"
};
var $76b58416a5044cb0$var$defaultStyles = {
    root: "_bfhksm61 _syazazsu _8l3m1l7x _aetrb3bt _1053azsu _f8pjazsu _30l3azsu _9h8hazsu",
    interactive: "_irr31dpa _30l3azsu _1di6fcek _9h8hazsu",
    disabled: "_bfhk1j28 _8l3mbk0g _irr31j28 _1di61j28"
};
var $76b58416a5044cb0$var$primaryStyles = {
    root: "_bfhk1856 _syaz15cr _105315cr _f8pj15cr _30l315cr _9h8h15cr",
    interactive: "_30l315cr _irr3hf2y _9h8h15cr _1di6g6ey"
};
var $76b58416a5044cb0$var$rovoStyles = {
    root: "_bfhklqh9 _syaz15cr _105315cr _f8pj15cr _30l315cr _9h8h15cr",
    interactive: "_30l315cr _irr31afz _9h8h15cr _1di61kru"
};
var $76b58416a5044cb0$var$warningStyles = {
    root: "_bfhk1kmu _syaz1yd3 _10531yd3 _f8pj1yd3 _30l31yd3 _9h8h1yd3",
    interactive: "_30l31yd3 _irr31spp _9h8h1yd3 _1di64m4m"
};
var $76b58416a5044cb0$var$dangerStyles = {
    root: "_bfhkybec _syaz15cr _105315cr _f8pj15cr _30l315cr _9h8h15cr",
    interactive: "_30l315cr _irr3s9hg _9h8h15cr _1di613a9"
};
var $76b58416a5044cb0$var$discoveryStyles = {
    root: "_bfhku5tj _syaz15cr _105315cr _f8pj15cr _30l315cr _9h8h15cr",
    interactive: "_30l315cr _irr3fqeg _9h8h15cr _1di61f1m"
};
var $76b58416a5044cb0$var$subtleStyles = {
    root: "_bfhksm61 _syazazsu _1053azsu _f8pjazsu _30l3azsu _9h8hazsu",
    interactive: "_irr31dpa _30l3azsu _1di6fcek _9h8hazsu",
    disabled: "_bfhk1j28 _8l3mbk0g _irr31j28 _1di61j28"
};
var $76b58416a5044cb0$var$selectedStyles = {
    root: "_bfhk15s3 _syaz6x5g _8l3mq98m _aetrb3bt _10536x5g _f8pj6x5g _30l36x5g _9h8h6x5g",
    insideSplitButton: "_1pbycs5v",
    interactive: "_irr3ufnl _30l36x5g _1di6nozp _9h8h6x5g",
    warning: "_bfhk15s3 _syaz6x5g _30l36x5g _irr315s3 _9h8h6x5g _1di615s3",
    danger: "_bfhk15s3 _syaz6x5g _30l36x5g _irr315s3 _9h8h6x5g _1di615s3",
    discovery: "_bfhk15s3 _syaz6x5g _30l36x5g _irr315s3 _9h8h6x5g _1di615s3"
};
/**
 * __button base__
 *
 * - Implements auto focus when enabled.
 * - Appends the `onClick` event with UFO analytics tracking.
 *
 * @private
 */ var $76b58416a5044cb0$var$ButtonBase = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).forwardRef(// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore: to unblock React 18.2.0 -> 18.3.1 version bump in Jira
function(_ref, ref) {
    // React Compiler opt-out: RC-incompatible (memoization breaks runtime behaviour).
    'use no memo';
    var propAppearance = _ref.appearance, _ref$autoFocus = _ref.autoFocus, autoFocus = _ref$autoFocus === void 0 ? false : _ref$autoFocus, _ref$isDisabled = _ref.isDisabled, propIsDisabled = _ref$isDisabled === void 0 ? false : _ref$isDisabled, _ref$isLoading = _ref.isLoading, isLoading = _ref$isLoading === void 0 ? false : _ref$isLoading, _ref$isSelected = _ref.isSelected, propIsSelected = _ref$isSelected === void 0 ? false : _ref$isSelected, _ref$isIconButton = _ref.isIconButton, isIconButton = _ref$isIconButton === void 0 ? false : _ref$isIconButton, _ref$isCircle = _ref.isCircle, isCircle = _ref$isCircle === void 0 ? false : _ref$isCircle, _ref$hasIconBefore = _ref.hasIconBefore, hasIconBefore = _ref$hasIconBefore === void 0 ? false : _ref$hasIconBefore, _ref$hasIconAfter = _ref.hasIconAfter, hasIconAfter = _ref$hasIconAfter === void 0 ? false : _ref$hasIconAfter, _ref$shouldFitContain = _ref.shouldFitContainer, shouldFitContainer = _ref$shouldFitContain === void 0 ? false : _ref$shouldFitContain, _ref$spacing = _ref.spacing, propSpacing = _ref$spacing === void 0 ? 'default' : _ref$spacing, ariaLabel = _ref.ariaLabel, ariaLabelledBy = _ref.ariaLabelledBy, children = _ref.children, interactionName = _ref.interactionName, onClick = _ref.onClick, onMouseDown = _ref.onMouseDown, onMouseDownCapture = _ref.onMouseDownCapture, onMouseUp = _ref.onMouseUp, onMouseUpCapture = _ref.onMouseUpCapture, onKeyDown = _ref.onKeyDown, onKeyDownCapture = _ref.onKeyDownCapture, onKeyUp = _ref.onKeyUp, onKeyUpCapture = _ref.onKeyUpCapture, onTouchStart = _ref.onTouchStart, onTouchStartCapture = _ref.onTouchStartCapture, onTouchEnd = _ref.onTouchEnd, onTouchEndCapture = _ref.onTouchEndCapture, onPointerDown = _ref.onPointerDown, onPointerDownCapture = _ref.onPointerDownCapture, onPointerUp = _ref.onPointerUp, onPointerUpCapture = _ref.onPointerUpCapture, onClickCapture = _ref.onClickCapture, testId = _ref.testId, analyticsContext = _ref.analyticsContext, componentName = _ref.componentName, role = _ref.role, onMouseOver = _ref.onMouseOver, onMouseOut = _ref.onMouseOut, onFocus = _ref.onFocus, onBlur = _ref.onBlur, onMouseMove = _ref.onMouseMove, type = _ref.type, unsafeRest = (0, $230c1601acfa3177$export$2e2bcd8739ae039)(_ref, $76b58416a5044cb0$var$_excluded);
    var localRef = (0, $5FkrB.useRef)(null);
    var splitButtonContext = (0, $c4b2f7b93688fa74$export$47e2c6fdb142d947)();
    var loadingLabelId = (0, $c797bf80d6171378$export$f680877a34711e37)();
    var isSplitButton = Boolean(splitButtonContext);
    var isNavigationSplitButton = (splitButtonContext === null || splitButtonContext === void 0 ? void 0 : splitButtonContext.isNavigationSplitButton) || false;
    var isDefaultAppearanceSplitButton = (splitButtonContext === null || splitButtonContext === void 0 ? void 0 : splitButtonContext.appearance) === 'default';
    var appearance = isDefaultAppearanceSplitButton ? 'subtle' : propAppearance || (splitButtonContext === null || splitButtonContext === void 0 ? void 0 : splitButtonContext.appearance) || 'default';
    var spacing = (splitButtonContext === null || splitButtonContext === void 0 ? void 0 : splitButtonContext.spacing) || propSpacing;
    var isDisabled = (splitButtonContext === null || splitButtonContext === void 0 ? void 0 : splitButtonContext.isDisabled) || propIsDisabled;
    var isInteractive = !isDisabled && !isLoading;
    // Also treat loading buttons as disabled
    var isEffectivelyDisabled = isDisabled || isLoading;
    var isSelected = propIsSelected && !isDisabled;
    (0, $bf3b13d9d73de104$export$2e2bcd8739ae039)(localRef, autoFocus);
    // @ts-expect-error
    var _className = unsafeRest.className, _css = unsafeRest.css, _as = unsafeRest.as, _style = unsafeRest.style, saferRest = (0, $230c1601acfa3177$export$2e2bcd8739ae039)(unsafeRest, $76b58416a5044cb0$var$_excluded2);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $859d1b6c2ad6603b$export$27c701ed9e449e99), (0, $bdabb985862bf53b$export$2e2bcd8739ae039)({}, saferRest, {
        componentName: componentName || 'button',
        analyticsContext: analyticsContext,
        role: role,
        ref: (0, $db13a2f91f6a0f56$export$2e2bcd8739ae039)([
            localRef,
            ref
        ]),
        xcss: (0, $d01a5d8bb96c5a7e$export$a274e22fb40f762e)($76b58416a5044cb0$var$styles.base, (0, $50U6m.fg)('platform-dst-shape-theme-default') && $76b58416a5044cb0$var$styles.baseT26Shape, isInteractive && (0, $50U6m.fg)('platform-dst-motion-uplift-button') && $76b58416a5044cb0$var$styles.interactiveMotion, appearance === 'default' && $76b58416a5044cb0$var$defaultStyles.root, appearance === 'default' && isInteractive && $76b58416a5044cb0$var$defaultStyles.interactive, appearance === 'primary' && $76b58416a5044cb0$var$primaryStyles.root, appearance === 'primary' && isInteractive && $76b58416a5044cb0$var$primaryStyles.interactive, appearance === 'rovo' && $76b58416a5044cb0$var$rovoStyles.root, appearance === 'rovo' && isInteractive && $76b58416a5044cb0$var$rovoStyles.interactive, appearance === 'warning' && $76b58416a5044cb0$var$warningStyles.root, appearance === 'warning' && isInteractive && $76b58416a5044cb0$var$warningStyles.interactive, appearance === 'danger' && $76b58416a5044cb0$var$dangerStyles.root, appearance === 'danger' && isInteractive && $76b58416a5044cb0$var$dangerStyles.interactive, appearance === 'discovery' && $76b58416a5044cb0$var$discoveryStyles.root, appearance === 'discovery' && isInteractive && $76b58416a5044cb0$var$discoveryStyles.interactive, appearance === 'subtle' && $76b58416a5044cb0$var$subtleStyles.root, appearance === 'subtle' && isInteractive && $76b58416a5044cb0$var$subtleStyles.interactive, $76b58416a5044cb0$var$styles.linkDecorationUnset, isSelected && $76b58416a5044cb0$var$selectedStyles.root, isSelected && isSplitButton && $76b58416a5044cb0$var$selectedStyles.insideSplitButton, isSelected && isInteractive && $76b58416a5044cb0$var$selectedStyles.interactive, // TODO: remove me once we kill color fallbacks
        isSelected && appearance === 'danger' && $76b58416a5044cb0$var$selectedStyles.danger, // TODO: remove me once we kill color fallbacks
        isSelected && appearance === 'warning' && $76b58416a5044cb0$var$selectedStyles.warning, // TODO: remove me once we kill color fallbacks
        isSelected && appearance === 'discovery' && $76b58416a5044cb0$var$selectedStyles.discovery, isDisabled && $76b58416a5044cb0$var$styles.disabled, isDisabled && appearance !== 'default' && appearance !== 'subtle' && $76b58416a5044cb0$var$styles.sharedDisabled, isDisabled && appearance === 'default' && $76b58416a5044cb0$var$defaultStyles.disabled, spacing === 'compact' && $76b58416a5044cb0$var$styles.spacingCompact, spacing === 'compact' && (0, $50U6m.fg)('platform-dst-shape-theme-default') && $76b58416a5044cb0$var$styles.spacingCompactT26Shape, // This must come after spacing compact styling as it overrides the border radius
        isCircle && !isSplitButton && $76b58416a5044cb0$var$styles.circle, shouldFitContainer && $76b58416a5044cb0$var$styles.fullWidth, hasIconBefore && $76b58416a5044cb0$var$styles.buttonIconBefore, hasIconAfter && $76b58416a5044cb0$var$styles.buttonIconAfter, isIconButton && $76b58416a5044cb0$var$styles.iconButton, isIconButton && spacing === 'compact' && $76b58416a5044cb0$var$styles.iconButtonCompact, isLoading && $76b58416a5044cb0$var$styles.loading, isSplitButton && $76b58416a5044cb0$var$styles.splitButton, isNavigationSplitButton && $76b58416a5044cb0$var$styles.navigationSplitButton),
        isDisabled: (0, $50U6m.fg)('platform-dst_fix_not_focusable_loading_button') ? isDisabled : isEffectivelyDisabled
    }, (0, $50U6m.fg)('platform-dst_fix_not_focusable_loading_button') && {
        'aria-live': 'polite'
    }, isLoading && (0, $50U6m.fg)('platform-dst_fix_not_focusable_loading_button') && {
        'aria-disabled': true
    }, {
        "aria-label": isLoading && ariaLabel && !ariaLabelledBy ? "".concat(ariaLabel, " ").concat($76b58416a5044cb0$var$LOADING_LABEL) : ariaLabel,
        "aria-labelledby": isLoading && ariaLabelledBy ? "".concat(ariaLabelledBy, " ").concat(loadingLabelId) : ariaLabelledBy,
        onClick: onClick
    }, (0, $dd2fd13b7e17523c$export$2e2bcd8739ae039)(isEffectivelyDisabled, {
        onMouseDownCapture: onMouseDownCapture,
        onMouseUpCapture: onMouseUpCapture,
        onKeyDownCapture: onKeyDownCapture,
        onKeyUpCapture: onKeyUpCapture,
        onTouchStartCapture: onTouchStartCapture,
        onTouchEndCapture: onTouchEndCapture,
        onPointerDownCapture: onPointerDownCapture,
        onPointerUpCapture: onPointerUpCapture,
        onClickCapture: onClickCapture
    }), {
        testId: testId,
        onMouseOver: onMouseOver,
        onFocus: onFocus,
        onMouseMove: onMouseMove,
        onBlur: onBlur,
        type: type,
        interactionName: interactionName,
        onMouseDown: onMouseDown,
        onMouseUp: onMouseUp,
        onKeyDown: onKeyDown,
        onMouseOut: onMouseOut,
        onKeyUp: onKeyUp,
        onTouchStart: onTouchStart,
        onTouchEnd: onTouchEnd,
        onPointerDown: onPointerDown,
        onPointerUp: onPointerUp
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $6ce5101b12a1b7f3$export$4b86304b2c0d7e71).Provider, {
        value: undefined
    }, children, isLoading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("span", {
        className: (0, $1b3f3ddecda00731$export$2e2bcd8739ae039)([
            $76b58416a5044cb0$var$styles.loadingOverlay
        ])
    }, (0, $8ed64276c2b30505$export$2e2bcd8739ae039)({
        spacing: spacing,
        appearance: appearance,
        isDisabled: isDisabled,
        isSelected: isSelected,
        testId: testId
    })), isLoading && (ariaLabelledBy || !ariaLabel) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $a4a1a9cdc7bf2d54$export$2e2bcd8739ae039), {
        id: loadingLabelId
    }, $76b58416a5044cb0$var$LOADING_LABEL)));
});
var $76b58416a5044cb0$export$2e2bcd8739ae039 = $76b58416a5044cb0$var$ButtonBase;


/* content.tsx generated by @compiled/babel-plugin v2.0.0 */ 

var $5FkrB = parcelRequire("5FkrB");
var $8e23f919bcd6960d$var$styles = {
    text: "_1reo15vq _18m915vq _16jlkb7n _1o9zkb7n _1bto1l2s _o5721q9c",
    icon: "_1e0c1txw _16jlidpf _1o9zidpf _1wpz1h6o _1wybidpf _vwz4idpf _uiztglyw",
    common: "_v564g17y",
    fade: "_tzy4idpf"
};
/**
 * __Content__
 *
 * Used for slots within a Button, including icons and text content.
 */ var $8e23f919bcd6960d$var$Content = function Content(_ref) {
    var children = _ref.children, _ref$type = _ref.type, type = _ref$type === void 0 ? 'text' : _ref$type, isLoading = _ref.isLoading;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("span", {
        className: (0, $1b3f3ddecda00731$export$2e2bcd8739ae039)([
            $8e23f919bcd6960d$var$styles.common,
            type === 'text' && $8e23f919bcd6960d$var$styles.text,
            type === 'icon' && $8e23f919bcd6960d$var$styles.icon,
            isLoading && $8e23f919bcd6960d$var$styles.fade
        ])
    }, children);
};
var $8e23f919bcd6960d$export$2e2bcd8739ae039 = $8e23f919bcd6960d$var$Content;



var $5FkrB = parcelRequire("5FkrB");

var $50U6m = parcelRequire("50U6m");
function $bf01465dd7c7d1ef$var$isIconRenderProp(func) {
    return !func.displayName && // most function components and class components have a displayName, negate them
    !func.render && // forwardRef doesn't require a display name, however it does include a render function, negate them
    typeof func === 'function' // at the very least we need to be a function
    ;
}
/**
 * __Icon renderer__
 *
 * Used to support render props with icons.
 *
 */ var $bf01465dd7c7d1ef$var$IconRenderer = function IconRenderer(_ref) {
    // React Compiler opt-out: RC-incompatible (memoization breaks runtime behaviour).
    'use no memo';
    var Icon = _ref.icon;
    var isRenderProp = $bf01465dd7c7d1ef$var$isIconRenderProp(Icon);
    var iconProps = {
        label: '',
        color: 'currentColor',
        size: (0, $50U6m.fg)('platform_dst_button_chevron_sizing') ? function(iconName) {
            return iconName.startsWith('Chevron') ? 'small' : 'medium';
        } : undefined
    };
    // @ts-ignore - TS2322 TypeScript 5.9.2 upgrade
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).Fragment, null, isRenderProp ? Icon(iconProps) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(Icon, iconProps));
};
var $bf01465dd7c7d1ef$export$2e2bcd8739ae039 = $bf01465dd7c7d1ef$var$IconRenderer;


var $a21e01c03a9c4d94$var$_excluded = [
    "analyticsContext",
    "appearance",
    "aria-label",
    "aria-labelledby",
    "autoFocus",
    "children",
    "iconAfter",
    "iconBefore",
    "interactionName",
    "isDisabled",
    "isLoading",
    "isSelected",
    "onClick",
    "onClickCapture",
    "onKeyDownCapture",
    "onKeyUpCapture",
    "onMouseDownCapture",
    "onMouseUpCapture",
    "onPointerDownCapture",
    "onPointerUpCapture",
    "onTouchEndCapture",
    "onTouchStartCapture",
    "shouldFitContainer",
    "spacing",
    "testId",
    "type"
], $a21e01c03a9c4d94$var$_excluded2 = [
    "className",
    "css",
    "as",
    "style"
];
/**
 * __Button__
 *
 * A button triggers an event or action.
 *
 * - [Examples](https://atlassian.design/components/button/examples)
 * - [Code](https://atlassian.design/components/button/code)
 * - [Usage](https://atlassian.design/components/button/usage)
 */ var $a21e01c03a9c4d94$var$Button = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).forwardRef(function Button(_ref, ref) {
    var analyticsContext = _ref.analyticsContext, appearance = _ref.appearance, ariaLabel = _ref['aria-label'], ariaLabelledBy = _ref['aria-labelledby'], autoFocus = _ref.autoFocus, children = _ref.children, iconAfter = _ref.iconAfter, iconBefore = _ref.iconBefore, interactionName = _ref.interactionName, isDisabled = _ref.isDisabled, _ref$isLoading = _ref.isLoading, isLoading = _ref$isLoading === void 0 ? false : _ref$isLoading, isSelected = _ref.isSelected, onClick = _ref.onClick, onClickCapture = _ref.onClickCapture, onKeyDownCapture = _ref.onKeyDownCapture, onKeyUpCapture = _ref.onKeyUpCapture, onMouseDownCapture = _ref.onMouseDownCapture, onMouseUpCapture = _ref.onMouseUpCapture, onPointerDownCapture = _ref.onPointerDownCapture, onPointerUpCapture = _ref.onPointerUpCapture, onTouchEndCapture = _ref.onTouchEndCapture, onTouchStartCapture = _ref.onTouchStartCapture, shouldFitContainer = _ref.shouldFitContainer, spacing = _ref.spacing, testId = _ref.testId, _ref$type = _ref.type, type = _ref$type === void 0 ? 'button' : _ref$type, unsafeRest = (0, $230c1601acfa3177$export$2e2bcd8739ae039)(_ref, $a21e01c03a9c4d94$var$_excluded);
    // @ts-expect-error
    var _className = unsafeRest.className, _css = unsafeRest.css, _as = unsafeRest.as, _style = unsafeRest.style, saferRest = (0, $230c1601acfa3177$export$2e2bcd8739ae039)(unsafeRest, $a21e01c03a9c4d94$var$_excluded2);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $76b58416a5044cb0$export$2e2bcd8739ae039), (0, $bdabb985862bf53b$export$2e2bcd8739ae039)({
        analyticsContext: analyticsContext,
        ref: ref,
        appearance: appearance,
        autoFocus: autoFocus,
        isDisabled: isDisabled,
        isLoading: isLoading,
        isSelected: isSelected,
        hasIconBefore: Boolean(iconBefore),
        hasIconAfter: Boolean(iconAfter),
        shouldFitContainer: shouldFitContainer,
        spacing: spacing,
        ariaLabel: ariaLabel,
        ariaLabelledBy: ariaLabelledBy,
        onClick: onClick,
        onClickCapture: onClickCapture,
        onKeyDownCapture: onKeyDownCapture,
        onKeyUpCapture: onKeyUpCapture,
        onMouseDownCapture: onMouseDownCapture,
        onMouseUpCapture: onMouseUpCapture,
        onPointerDownCapture: onPointerDownCapture,
        onPointerUpCapture: onPointerUpCapture,
        onTouchStartCapture: onTouchStartCapture,
        onTouchEndCapture: onTouchEndCapture,
        testId: testId,
        componentName: "Button",
        type: type,
        interactionName: interactionName
    }, saferRest), iconBefore && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $8e23f919bcd6960d$export$2e2bcd8739ae039), {
        type: "icon",
        position: "before",
        isLoading: isLoading
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $bf01465dd7c7d1ef$export$2e2bcd8739ae039), {
        icon: iconBefore
    })), children && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $8e23f919bcd6960d$export$2e2bcd8739ae039), {
        isLoading: isLoading
    }, children), iconAfter && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $8e23f919bcd6960d$export$2e2bcd8739ae039), {
        type: "icon",
        position: "after",
        isLoading: isLoading
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $bf01465dd7c7d1ef$export$2e2bcd8739ae039), {
        icon: iconAfter
    })));
}));
$a21e01c03a9c4d94$var$Button.displayName = 'Button';
var $a21e01c03a9c4d94$export$2e2bcd8739ae039 = $a21e01c03a9c4d94$var$Button;





function $f0334b469282915f$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return r;
}


function $28cc1e901ff56377$export$2e2bcd8739ae039(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}


function $edb663e9340f0d9a$export$2e2bcd8739ae039(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}


function $1fbdea7d766382c9$export$2e2bcd8739ae039(r, a) {
    if (r) {
        if ("string" == typeof r) return (0, $edb663e9340f0d9a$export$2e2bcd8739ae039)(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? (0, $edb663e9340f0d9a$export$2e2bcd8739ae039)(r, a) : void 0;
    }
}


function $84598ce796f39ecb$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}


function $0a66309fdb337f9c$export$2e2bcd8739ae039(r, e) {
    return (0, $f0334b469282915f$export$2e2bcd8739ae039)(r) || (0, $28cc1e901ff56377$export$2e2bcd8739ae039)(r, e) || (0, $1fbdea7d766382c9$export$2e2bcd8739ae039)(r, e) || (0, $84598ce796f39ecb$export$2e2bcd8739ae039)();
}



var $5FkrB = parcelRequire("5FkrB");
function $1bedb8eb38a3e847$export$2e2bcd8739ae039(propValue) {
    var getDefaultPropValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function() {
        return propValue;
    };
    var isControlled = propValue !== undefined;
    var _useState = (0, $5FkrB.useState)(getDefaultPropValue), _useState2 = (0, $0a66309fdb337f9c$export$2e2bcd8739ae039)(_useState, 2), valueState = _useState2[0], setValue = _useState2[1];
    var isControlledRef = (0, $5FkrB.useRef)(isControlled);
    (0, $5FkrB.useEffect)(function() {
        isControlledRef.current = isControlled;
    }, [
        isControlled
    ]);
    var value = isControlled ? propValue : valueState;
    var setValueIfUncontrolled = (0, $5FkrB.useCallback)(function(newValue) {
        if (!isControlledRef.current) setValue(newValue);
    }, []);
    return [
        value,
        setValueIfUncontrolled
    ];
}




var $5FkrB = parcelRequire("5FkrB");
function $c76ec7f1ca125947$export$2e2bcd8739ae039() {
    var _useState = (0, $5FkrB.useState)(false), _useState2 = (0, $0a66309fdb337f9c$export$2e2bcd8739ae039)(_useState, 2), isFocused = _useState2[0], setIsFocused = _useState2[1];
    // ensure bindFocus has a stable ref
    var bindFocus = (0, $5FkrB.useRef)({
        onFocus: function onFocus() {
            return setIsFocused(true);
        },
        onBlur: function onBlur() {
            return setIsFocused(false);
        }
    });
    (0, $5FkrB.useEffect)(function() {
        // handle the case where a component might
        // unmount while being focused.
        return function() {
            return setIsFocused(false);
        };
    }, []);
    return {
        isFocused: isFocused,
        bindFocus: bindFocus.current
    };
}


var $c63a1832a2581897$exports = {};
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3ceff5ba2cd41cd6899d33441cb75c99>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty($c63a1832a2581897$exports, "__esModule", {
    value: true
});
$c63a1832a2581897$exports.default = void 0;

var $c63a1832a2581897$var$_react = $c63a1832a2581897$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $c63a1832a2581897$var$_iconNew = $c63a1832a2581897$var$_interopRequireDefault((parcelRequire("gDzom")));
function $c63a1832a2581897$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ChevronDown".
 * Category: multi-purpose
 * Location: @atlaskit/icon/core/chevron-down
 * Usage guidance:
 * Do not use 16px chevrons within buttons, icon buttons, or dropdowns to maintain visual cohesion with ADS which uses 12px chevrons.
 * Known uses: Open dropdown menu, expanded tree item, collapse tree item
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c63a1832a2581897$var$ChevronDownIcon = (props)=>/*#__PURE__*/ $c63a1832a2581897$var$_react.default.createElement($c63a1832a2581897$var$_iconNew.default, Object.assign({
        name: "ChevronDownIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="m14.53 6.03-6 6a.75.75 0 0 1-1.004.052l-.056-.052-6-6 1.06-1.06L8 10.44l5.47-5.47z"/>`
    }, props));
$c63a1832a2581897$var$ChevronDownIcon.displayName = 'ChevronDownIcon';
var $c63a1832a2581897$var$_default = $c63a1832a2581897$exports.default = $c63a1832a2581897$var$ChevronDownIcon;




var $50U6m = parcelRequire("50U6m");


/* dropdown-menu-top-layer.tsx generated by @compiled/babel-plugin v3.0.2 */ 



var $5FkrB = parcelRequire("5FkrB");
/**
 * The length of the value hash portion of an atomic class name.
 * Atomic class names have the format: `_<group><value>`
 * where group is ATOMIC_GROUP_HASH_LENGTH chars and value is ATOMIC_VALUE_HASH_LENGTH chars.
 *
 * We extract the group key using: `className.slice(0, className.length - ATOMIC_VALUE_HASH_LENGTH)`
 *
 * We support both old-format classes (9 chars: `_` + 4 group + 4 value) and
 * new-format classes (11 chars: `_` + 6 group + 4 value) by using length-based
 * extraction rather than a hardcoded offset — old and new format group keys
 * are different lengths so they are structurally disjoint and never alias each other.
 */ const $3409454e8e68f10d$var$ATOMIC_VALUE_HASH_LENGTH = 4;
function $3409454e8e68f10d$export$2e2bcd8739ae039(classNames) {
    // Shortcut: nothing to do
    if (!classNames.length) return;
    // Shortcut: don't need to do anything if we only have a single classname
    if (classNames.length === 1 && classNames[0] && // checking to see if `classNames[0]` is a string that contains other classnames
    !classNames[0].includes(' ')) return classNames[0];
    // Using an object rather than a `Map` as it performed better in our benchmarks.
    // Would be happy to move to `Map` if it proved to be better under real conditions.
    const map = {};
    // Note: using loops to minimize iterations over the collection
    for (const value of classNames){
        // Exclude all falsy values, which leaves us with populated strings
        if (!value) continue;
        // a `value` can contain multiple classnames
        const list = value.split(' ');
        for (const className of list){
            /**
             * For atomic style classnames: the `key` is the `group`
             *
             * - Later atomic classnames with the same `group` will override earlier ones
             *   (which is what we want).
             * - Assumes atomic classnames are the only things that start with `_`
             * - Could use a regex to ensure that atomic classnames are structured how we expect,
             *   but did not add that for now as it did slow things down a bit.
             *
             * For other classnames: the `key` is the whole classname
             * - Okay to remove duplicates as doing so does not impact specificity
             *
             * */ const key = className.startsWith('_') ? className.slice(0, className.length - $3409454e8e68f10d$var$ATOMIC_VALUE_HASH_LENGTH) : className;
            map[key] = className;
        }
    }
    /**
     * We are converting the `map` into a string.
     *
     * The simple way to do this would be `Object.values(map).join(' ')`.
     * However, the approach below performs 10%-20% better in benchmarks.
     *
     * For `ax()` it feels right to squeeze as much runtime performance out as we can.
     */ let result = '';
    for(const key in map)result += map[key] + ' ';
    // If we have an empty string, then our `map` was empty.
    if (!result) return;
    // remove last " " from the result (we added " " at the end of every value)
    return result.trimEnd();
}









/* menu-group.tsx generated by @compiled/babel-plugin v3.0.2 */ 


var $5FkrB = parcelRequire("5FkrB");


var $5FkrB = parcelRequire("5FkrB");
var $01cea6fab91f51f7$export$443076ec7ebce042 = /*#__PURE__*/ (0, $5FkrB.createContext)('cozy');



var $5FkrB = parcelRequire("5FkrB");
var $8b50a86dacab0fa0$export$9ca534b70725964d = /*#__PURE__*/ (0, $5FkrB.createContext)('border');


var $4c35f91febbc7ca1$var$_excluded = [
    "isLoading",
    "maxWidth",
    "minWidth",
    "minHeight",
    "maxHeight",
    "testId",
    "role",
    "spacing",
    "menuLabel",
    "className"
];
var $4c35f91febbc7ca1$var$baseStyles = null;
/**
 * __Menu group__
 *
 * A menu group includes all the actions or items in a menu.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/menu/docs/menu-group)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/menu)
 */ var $4c35f91febbc7ca1$var$MenuGroup = function MenuGroup(_ref) {
    var isLoading = _ref.isLoading, maxWidth = _ref.maxWidth, minWidth = _ref.minWidth, minHeight = _ref.minHeight, maxHeight = _ref.maxHeight, testId = _ref.testId, role = _ref.role, _ref$spacing = _ref.spacing, spacing = _ref$spacing === void 0 ? 'cozy' : _ref$spacing, menuLabel = _ref.menuLabel, UNSAFE_className = _ref.className, rest = (0, $b94f3d2584a27e94$export$2e2bcd8739ae039)(_ref, $4c35f91febbc7ca1$var$_excluded);
    return /*#__PURE__*/ $5FkrB.createElement((0, $01cea6fab91f51f7$export$443076ec7ebce042).Provider, {
        value: spacing
    }, /*#__PURE__*/ $5FkrB.createElement((0, $8b50a86dacab0fa0$export$9ca534b70725964d).Provider, {
        value: "border"
    }, /*#__PURE__*/ $5FkrB.createElement("div", (0, $4a7ae0731a7e1583$export$2e2bcd8739ae039)({
        "aria-busy": isLoading,
        style: {
            minWidth: minWidth,
            maxWidth: maxWidth,
            minHeight: minHeight,
            maxHeight: maxHeight
        },
        "data-testid": testId,
        role: role,
        className: (0, $3409454e8e68f10d$export$2e2bcd8739ae039)([
            "_1reo1wug _18m91wug _1e0c1txw _kqswpfqs _2lx21bp4",
            UNSAFE_className
        ]),
        "aria-label": menuLabel
    }, rest))));
};
var $4c35f91febbc7ca1$export$2e2bcd8739ae039 = $4c35f91febbc7ca1$var$MenuGroup;



/**
 * Roles accepted by `getAriaForTrigger`.
 *
 * Excludes tooltip-family roles (`tooltip`, `note`, `status`, `alert`, `log`)
 * because the correct trigger wiring for those is `aria-describedby`, not
 * `aria-haspopup` / `aria-expanded` / `aria-controls`. Use `aria-describedby`
 * manually for tooltip triggers.
 */ /**
 * Maps each supported popover role to its `aria-haspopup` value.
 *
 * Derived from the HTML spec - maps popover roles to what the trigger
 * announces. Roles that do not produce a popup use `undefined` instead (for
 * non-popup roles like `tooltip`/`status`/`alert`/`note`/`log` where
 * `aria-haspopup` would be misleading), so they are intentionally excluded
 * from this mapping and from `getAriaForTrigger`.
 *
 * `true` is intentionally not a value in this mapping. The runtime only ever
 * produces the explicit string forms, so allowing it would invite consumers
 * to pass `true` and get an `aria-haspopup="true"` serialisation that the
 * runtime no longer emits.
 */ var $7c1811553882724a$var$roleToAriaHasPopup = {
    dialog: 'dialog',
    alertdialog: 'dialog',
    menu: 'menu',
    listbox: 'listbox',
    tree: 'tree',
    grid: 'grid'
};
function $7c1811553882724a$export$9dd1d61dd4d4755(_ref) {
    var role = _ref.role, isOpen = _ref.isOpen, popoverId = _ref.popoverId;
    // `aria-controls` is set to `undefined` while closed. The `Popover` /
    // `Dialog` primitives unmount their host element after the exit
    // animation finishes, so a closed-state `aria-controls` would point
    // at a node that is not in the DOM. Returning `undefined` here means
    // JSX spread renders no `aria-controls` attribute on the trigger
    // until the target exists, avoiding the dangling reference while
    // keeping the relationship live whenever it is meaningful.
    return {
        'aria-haspopup': $7c1811553882724a$var$roleToAriaHasPopup[role],
        'aria-expanded': isOpen,
        'aria-controls': isOpen ? popoverId : undefined
    };
}




/**
 * The full mapping record. Internal - use `fromLegacyPlacement` from the
 * public entry-point so the offset-tuple translation is applied consistently.
 *
 * Note: `auto`, `auto-start`, `auto-end` map to `block-end` placements. This
 * is a reduction in expressiveness vs Popper.js (which picked the best
 * placement at runtime). CSS `position-try-fallbacks` flips at the edge but
 * the initial placement is fixed. Migration consumers who relied on Popper's
 * dynamic auto-flip should pick an explicit placement instead.
 */ var $e1a6cd28504a494c$export$27df359c528b7120 = {
    top: {
        axis: 'block',
        edge: 'start',
        align: 'center'
    },
    'top-start': {
        axis: 'block',
        edge: 'start',
        align: 'start'
    },
    'top-center': {
        axis: 'block',
        edge: 'start',
        align: 'center'
    },
    'top-end': {
        axis: 'block',
        edge: 'start',
        align: 'end'
    },
    bottom: {
        axis: 'block',
        edge: 'end',
        align: 'center'
    },
    'bottom-start': {
        axis: 'block',
        edge: 'end',
        align: 'start'
    },
    'bottom-center': {
        axis: 'block',
        edge: 'end',
        align: 'center'
    },
    'bottom-end': {
        axis: 'block',
        edge: 'end',
        align: 'end'
    },
    right: {
        axis: 'inline',
        edge: 'end',
        align: 'center'
    },
    'right-start': {
        axis: 'inline',
        edge: 'end',
        align: 'start'
    },
    'right-end': {
        axis: 'inline',
        edge: 'end',
        align: 'end'
    },
    left: {
        axis: 'inline',
        edge: 'start',
        align: 'center'
    },
    'left-start': {
        axis: 'inline',
        edge: 'start',
        align: 'start'
    },
    'left-end': {
        axis: 'inline',
        edge: 'start',
        align: 'end'
    },
    auto: {
        axis: 'block',
        edge: 'end',
        align: 'center'
    },
    'auto-start': {
        axis: 'block',
        edge: 'end',
        align: 'start'
    },
    'auto-end': {
        axis: 'block',
        edge: 'end',
        align: 'end'
    }
};


function $feede424fdeb9dd7$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $feede424fdeb9dd7$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $feede424fdeb9dd7$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $a48c245bf23e2005$export$2e2bcd8739ae039)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $feede424fdeb9dd7$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $feede424fdeb9dd7$export$69e99ed50b2534c9(_ref) {
    var legacy = _ref.legacy, offset = _ref.offset;
    var basePlacement = (0, $e1a6cd28504a494c$export$27df359c528b7120)[legacy];
    if (!offset) return basePlacement;
    var _offset = (0, $fe9ce0f81f7af2c1$export$2e2bcd8739ae039)(offset, 2), along = _offset[0], away = _offset[1];
    return $feede424fdeb9dd7$var$_objectSpread($feede424fdeb9dd7$var$_objectSpread({}, basePlacement), {}, {
        offset: {
            gap: away,
            crossAxisShift: {
                // Sign is captured in `direction`; `value` is the magnitude.
                value: Math.abs(along),
                direction: along >= 0 ? 'forwards' : 'backwards'
            }
        }
    });
}


/* popover.tsx generated by @compiled/babel-plugin v3.0.2 */ 

var $5FkrB = parcelRequire("5FkrB");

const $730928ba53460d9f$export$a274e22fb40f762e = (...styles)=>{
    // At runtime TStyles is resolved down to strings, but not at compile time.
    // We circumvent the type system here because of that.
    const actualStyles = styles;
    // The output should be a union type of passed in styles. This ensures the call
    // site of xcss prop can raise violations when disallowed styles have been passed.
    return (0, $3409454e8e68f10d$export$2e2bcd8739ae039)(actualStyles);
};






function $881af1e5012c4c5e$export$89b923e18c14644d(_ref) {
    var element = _ref.element;
    if (element instanceof HTMLDialogElement) return element.open;
    // Some DOM implementations throw for unsupported pseudo-classes.
    try {
        return element.matches(':popover-open');
    } catch (_unused) {
        return false;
    }
}


/**
 * Normalizes an offset to a CSS length string. Numbers become `${n}px`;
 * strings pass through. Apply at the API boundary so internal code only
 * deals with strings.
 */ function $8b12289acf867772$export$63b6b0ff65d84d47(_ref) {
    var value = _ref.value;
    if (typeof value === 'number') return "".concat(value, "px");
    return value;
}


/**
 * Default gap between trigger and popover. Resolves to a design
 * token (`space.100`) so the value follows the design system's spacing
 * scale. Used when `placement.offset.gap` is not provided.
 */ var $22e1c0cfc4927867$var$DEFAULT_GAP = "var(--ds-space-100, 8px)";
function $22e1c0cfc4927867$export$63044d21bc3d3fa2(_ref) {
    var _placement$axis, _placement$edge, _placement$align, _placement$offset$gap, _placement$offset, _placement$offset$cro, _placement$offset2, _placement$offset$cro2, _placement$offset3;
    var placement = _ref.placement;
    return {
        axis: (_placement$axis = placement.axis) !== null && _placement$axis !== void 0 ? _placement$axis : 'block',
        edge: (_placement$edge = placement.edge) !== null && _placement$edge !== void 0 ? _placement$edge : 'end',
        align: (_placement$align = placement.align) !== null && _placement$align !== void 0 ? _placement$align : 'center',
        // Not `??`: `undefined` must survive, so "not specified" stays
        // distinguishable from an explicit `0`.
        minSize: placement.minSize === undefined ? undefined : (0, $8b12289acf867772$export$63b6b0ff65d84d47)({
            value: placement.minSize
        }),
        offset: {
            gap: (0, $8b12289acf867772$export$63b6b0ff65d84d47)({
                value: (_placement$offset$gap = (_placement$offset = placement.offset) === null || _placement$offset === void 0 ? void 0 : _placement$offset.gap) !== null && _placement$offset$gap !== void 0 ? _placement$offset$gap : $22e1c0cfc4927867$var$DEFAULT_GAP
            }),
            crossAxisShift: {
                value: (0, $8b12289acf867772$export$63b6b0ff65d84d47)({
                    value: (_placement$offset$cro = (_placement$offset2 = placement.offset) === null || _placement$offset2 === void 0 || (_placement$offset2 = _placement$offset2.crossAxisShift) === null || _placement$offset2 === void 0 ? void 0 : _placement$offset2.value) !== null && _placement$offset$cro !== void 0 ? _placement$offset$cro : 0
                }),
                direction: (_placement$offset$cro2 = (_placement$offset3 = placement.offset) === null || _placement$offset3 === void 0 || (_placement$offset3 = _placement$offset3.crossAxisShift) === null || _placement$offset3 === void 0 ? void 0 : _placement$offset3.direction) !== null && _placement$offset$cro2 !== void 0 ? _placement$offset$cro2 : 'forwards'
            }
        }
    };
}





var $5FkrB = parcelRequire("5FkrB");


var $1bf14c879282be56$export$ff7706047246b98b = (0, $86089df3a0fd54eb$export$2e2bcd8739ae039)(function() {
    if (typeof window === 'undefined' || !('matchMedia' in window)) return false;
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
});


function $925bd4562e5dc5b7$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $925bd4562e5dc5b7$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $925bd4562e5dc5b7$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $a48c245bf23e2005$export$2e2bcd8739ae039)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $925bd4562e5dc5b7$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $925bd4562e5dc5b7$var$runCancellableSettlement(_ref) {
    var schedule = _ref.schedule, onSettled = _ref.onSettled;
    var isCancelled = false;
    schedule(function() {
        if (isCancelled) return;
        onSettled();
    });
    return function() {
        // Prevent an interrupted or unmounted lifecycle from firing a stale callback.
        isCancelled = true;
    };
}
/**
 * Fires `onSettled` once all animations currently applied to `element`
 * finish or are cancelled. Returns a cleanup that prevents stale settlement.
 */ function $925bd4562e5dc5b7$var$runOnAnimationsSettled(_ref2) {
    var element = _ref2.element, onSettled = _ref2.onSettled;
    return $925bd4562e5dc5b7$var$runCancellableSettlement({
        onSettled: onSettled,
        schedule: function schedule(settle) {
            var _element$getAnimation, _element$getAnimation2;
            var animations = (_element$getAnimation = (_element$getAnimation2 = element.getAnimations) === null || _element$getAnimation2 === void 0 ? void 0 : _element$getAnimation2.call(element)) !== null && _element$getAnimation !== void 0 ? _element$getAnimation : [];
            Promise.allSettled(animations.map(function(animation) {
                return animation.finished;
            })).then(settle);
        }
    });
}
/**
 * Visibility lifecycle phase shared between `useAnimatedVisibility`,
 * `useFocusWrap`, `useInitialFocus`, and the `Popover` / `Dialog`
 * components.
 *
 * - `closed`: host element is unmounted. No DOM presence.
 * - `entering`: host element is mounted and the CSS entry transition
 *   is playing. **Only emitted when animation is enabled.** With
 *   animation disabled the lifecycle goes directly `closed → open`.
 * - `open`: host element is mounted and settled. No transition is
 *   playing.
 * - `exiting`: a native close has begun but the host element remains
 *   mounted. Usually this follows `isOpen` changing to `false`, but it can
 *   also begin with a browser-initiated dismissal while controlled intent
 *   is still open. With animation disabled, this phase lasts until the
 *   browser's closed `toggle` fires so native focus restoration can finish.
 *
 * State machine:
 * ```
 *   animation ON:   closed → entering → open → exiting → closed
 *   animation OFF:  closed →            open → exiting → closed
 *   interrupts:     entering → exiting (close mid-entry)
 *                   exiting  → entering (reopen mid-exit, animated)
 *                   exiting  → open     (reopen mid-handshake, non-animated)
 * ```
 */ function $925bd4562e5dc5b7$var$getInitialVisibilityState(_ref3) {
    var isOpen = _ref3.isOpen, willAnimate = _ref3.willAnimate;
    if (!isOpen) return {
        phase: 'closed',
        controlledIntent: 'closed'
    };
    if (willAnimate) return {
        phase: 'entering',
        controlledIntent: 'open'
    };
    return {
        phase: 'open',
        controlledIntent: 'open'
    };
}
/**
 * Applies one lifecycle event to the current visibility phase.
 *
 * Events that are stale for the current phase are ignored. This allows
 * animation callbacks and native close events to settle safely after an
 * interrupted lifecycle.
 */ function $925bd4562e5dc5b7$var$getNextVisibilityState(state, action) {
    if (action.type === 'open-requested') {
        var shouldEnter = state.phase === 'closed' || state.phase === 'exiting' && state.controlledIntent === 'closed';
        if (shouldEnter && action.willAnimate) return {
            phase: 'entering',
            controlledIntent: 'open'
        };
        if (shouldEnter) return {
            phase: 'open',
            controlledIntent: 'open'
        };
        return $925bd4562e5dc5b7$var$_objectSpread($925bd4562e5dc5b7$var$_objectSpread({}, state), {}, {
            controlledIntent: 'open'
        });
    }
    if (action.type === 'close-requested') return $925bd4562e5dc5b7$var$_objectSpread($925bd4562e5dc5b7$var$_objectSpread({}, state), {}, {
        controlledIntent: 'closed'
    });
    if (action.type === 'exit-started') {
        if (state.phase !== 'open' && state.phase !== 'entering') return state;
        return $925bd4562e5dc5b7$var$_objectSpread($925bd4562e5dc5b7$var$_objectSpread({}, state), {}, {
            phase: 'exiting'
        });
    }
    if (action.type === 'entry-settled') {
        if (state.phase !== 'entering') return state;
        return $925bd4562e5dc5b7$var$_objectSpread($925bd4562e5dc5b7$var$_objectSpread({}, state), {}, {
            phase: 'open'
        });
    }
    if (action.type === 'exit-settled') {
        if (state.phase !== 'exiting') return state;
        return $925bd4562e5dc5b7$var$_objectSpread($925bd4562e5dc5b7$var$_objectSpread({}, state), {}, {
            phase: 'closed'
        });
    }
    return state;
}
function $925bd4562e5dc5b7$export$1bccb45daf07907f(_ref4) {
    var isOpen = _ref4.isOpen, shouldAnimate = _ref4.shouldAnimate, elementRef = _ref4.elementRef, onEnterFinish = _ref4.onEnterFinish, onExitFinish = _ref4.onExitFinish;
    var willAnimate = shouldAnimate && !(0, $1bf14c879282be56$export$ff7706047246b98b)();
    var _useReducer = (0, $5FkrB.useReducer)($925bd4562e5dc5b7$var$getNextVisibilityState, {
        isOpen: isOpen,
        willAnimate: willAnimate
    }, $925bd4562e5dc5b7$var$getInitialVisibilityState), _useReducer2 = (0, $fe9ce0f81f7af2c1$export$2e2bcd8739ae039)(_useReducer, 2), visibilityState = _useReducer2[0], dispatch = _useReducer2[1];
    var phase = visibilityState.phase, controlledIntent = visibilityState.controlledIntent;
    // Keep stable refs to the latest callbacks so effects and animation settlement closures
    // always call the current callback without needing them in dependency arrays.
    var onEnterFinishRef = (0, $5FkrB.useRef)(onEnterFinish);
    var onExitFinishRef = (0, $5FkrB.useRef)(onExitFinish);
    var willAnimateRef = (0, $5FkrB.useRef)(willAnimate);
    (0, $5FkrB.useLayoutEffect)(function() {
        onEnterFinishRef.current = onEnterFinish;
        onExitFinishRef.current = onExitFinish;
        willAnimateRef.current = willAnimate;
    }, [
        onEnterFinish,
        onExitFinish,
        willAnimate
    ]);
    // Synchronize controlled intent during render so opening mounts the host in
    // the same commit. Keeping the processed intent in reducer state prevents a
    // browser-driven exit from being mistaken for a new controlled open request.
    if (isOpen && controlledIntent === 'closed') dispatch({
        type: 'open-requested',
        willAnimate: willAnimate
    });
    if (!isOpen && controlledIntent === 'open') dispatch({
        type: 'close-requested'
    });
    // Entry can commit `open` before its callback because the host stays mounted.
    // This ensures consumers observe the settled DOM rather than entering styles.
    // Treat the phase before the initial commit as closed so an initially open host
    // notifies consumers.
    var prevPhaseRef = (0, $5FkrB.useRef)('closed');
    (0, $5FkrB.useEffect)(function() {
        var prevPhase = prevPhaseRef.current;
        prevPhaseRef.current = phase;
        if (prevPhase === phase) return;
        if (phase === 'open') {
            var _onEnterFinishRef$cur;
            (_onEnterFinishRef$cur = onEnterFinishRef.current) === null || _onEnterFinishRef$cur === void 0 || _onEnterFinishRef$cur.call(onEnterFinishRef);
        }
    }, [
        phase
    ]);
    var isMounted = phase !== 'closed';
    var cancelExitSettlementRef = (0, $5FkrB.useRef)(function() {});
    // Exit must notify consumers before `closed` unmounts the host.
    var settleExit = (0, $5FkrB.useCallback)(function() {
        var _onExitFinishRef$curr;
        (_onExitFinishRef$curr = onExitFinishRef.current) === null || _onExitFinishRef$curr === void 0 || _onExitFinishRef$curr.call(onExitFinishRef);
        dispatch({
            type: 'exit-settled'
        });
    }, []);
    // Primitives bind these stable callbacks to their native lifecycle events.
    // This keeps event ownership at the primitive while the hook owns state transitions.
    var onBeforeToggle = (0, $5FkrB.useCallback)(function(event) {
        // Any native transition supersedes a previous exit snapshot. This prevents
        // a stale settlement from closing a host that is reopening or closing again.
        cancelExitSettlementRef.current();
        // Snapshot currentTarget because the DOM clears it after event dispatch.
        var element = event.currentTarget;
        if (event.newState === 'open' && element instanceof HTMLElement) {
            element.removeAttribute('inert');
            element.removeAttribute('aria-hidden');
        }
        if (event.newState === 'closed') {
            if (element instanceof HTMLElement) // We use a microtask to let native focus restoration happen before making the element inert.
            // The browser restores focus after beforetoggle returns, during its close steps.
            queueMicrotask(function() {
                // A controlled close can be interrupted by isOpen changing back to true,
                // which reopens the element before this microtask runs.
                if ((0, $881af1e5012c4c5e$export$89b923e18c14644d)({
                    element: element
                })) return;
                // Exit animations keep closed content rendered, so make it non-interactive and hide it from assistive technology.
                element.setAttribute('inert', '');
                // Tooling does not consistently treat inert content as hidden, even though the browser does.
                element.setAttribute('aria-hidden', 'true');
            });
            dispatch({
                type: 'exit-started'
            });
        }
    }, []);
    var onToggle = (0, $5FkrB.useCallback)(function(event) {
        if (event.newState !== 'closed') return;
        if (!willAnimateRef.current) {
            cancelExitSettlementRef.current = $925bd4562e5dc5b7$var$runCancellableSettlement({
                schedule: queueMicrotask,
                onSettled: settleExit
            });
            return;
        }
        var element = elementRef.current;
        if (!element) return;
        // The closed `toggle` is task-queued after synchronous `beforetoggle`.
        // Snapshot here so the exiting phase styles have committed and the list
        // represents the animations that actually govern exit settlement.
        cancelExitSettlementRef.current = $925bd4562e5dc5b7$var$runOnAnimationsSettled({
            element: element,
            onSettled: settleExit
        });
    }, [
        elementRef,
        settleExit
    ]);
    (0, $5FkrB.useLayoutEffect)(function() {
        return function() {
            // Prevent a pending animation or microtask from notifying after unmount.
            cancelExitSettlementRef.current();
        };
    }, []);
    // Entry settlement only removes entering styles. Its callback runs after the
    // resulting `open` commit in the effect above.
    (0, $5FkrB.useEffect)(function settleEntry() {
        if (phase !== 'entering') return;
        if (!willAnimate) {
            dispatch({
                type: 'entry-settled'
            });
            return;
        }
        var element = elementRef.current;
        if (!element) return;
        return $925bd4562e5dc5b7$var$runOnAnimationsSettled({
            element: element,
            onSettled: function onSettled() {
                dispatch({
                    type: 'entry-settled'
                });
            }
        });
    }, [
        phase,
        willAnimate,
        elementRef
    ]);
    return {
        phase: phase,
        isMounted: isMounted,
        onBeforeToggle: onBeforeToggle,
        onToggle: onToggle
    };
}



var $5FkrB = parcelRequire("5FkrB");

function $e41b156a9767de12$export$3c9385904be131db(_ref) {
    var element = _ref.element;
    return element.closest('[popover], dialog');
}


var $69d23fe834b3fb9c$var$focusableExclusions = [
    '[tabindex="-1"]',
    ':disabled',
    '[aria-disabled="true"]',
    '[aria-hidden="true"]'
];
var $69d23fe834b3fb9c$var$exclusionSelector = $69d23fe834b3fb9c$var$focusableExclusions.map(function(selector) {
    return ":not(".concat(selector, ")");
}).join('');
var $69d23fe834b3fb9c$var$focusableSelector = [
    'a[href]',
    'area[href]',
    'input:not([type="hidden"])',
    'select',
    'textarea',
    'button',
    'iframe',
    'audio[controls]',
    'video[controls]',
    '[contenteditable]:not([contenteditable="false"])',
    '[tabindex]'
].map(function(selector) {
    return "".concat(selector).concat($69d23fe834b3fb9c$var$exclusionSelector);
}).join(',');
function $69d23fe834b3fb9c$var$isVisible(element) {
    // Visibility filtering must not break focus navigation when the API is unsupported.
    if (typeof element.checkVisibility !== 'function') return true;
    try {
        // Exclude elements hidden by display, content-visibility or visibility because
        // they cannot receive focus. Offscreen, occluded and opacity-zero elements can
        // receive focus, so they intentionally remain included.
        return element.checkVisibility({
            checkVisibilityCSS: true
        });
    } catch (_unused) {
        return true;
    }
}
function $69d23fe834b3fb9c$export$f6768025e418420e(_ref) {
    var container = _ref.container, filter = _ref.filter;
    var containerLayer = (0, $e41b156a9767de12$export$3c9385904be131db)({
        element: container
    });
    return Array.from(container.querySelectorAll($69d23fe834b3fb9c$var$focusableSelector)).filter(function(element) {
        if (!(element instanceof HTMLElement)) return false;
        if ((0, $e41b156a9767de12$export$3c9385904be131db)({
            element: element
        }) !== containerLayer) return false;
        if (element.closest('[inert]')) return false;
        if (!$69d23fe834b3fb9c$var$isVisible(element)) return false;
        return !filter || filter(element, container);
    });
}


function $0e5e27f156f9e55c$export$748138f04a69bf21(_ref) {
    var container = _ref.container, filter = _ref.filter;
    var items = (0, $69d23fe834b3fb9c$export$f6768025e418420e)({
        container: container,
        filter: filter
    });
    return items.length > 0 ? items[0] : null;
}



function $438b65b604e8b00d$export$73e81fa65335a75b(_ref) {
    var container = _ref.container, filter = _ref.filter;
    var items = (0, $69d23fe834b3fb9c$export$f6768025e418420e)({
        container: container,
        filter: filter
    });
    return items.length > 0 ? items[items.length - 1] : null;
}


/**
 * Returns the next focusable element in the given direction relative to the
 * currently focused element within the container. Wraps around at both ends.
 *
 * The currently focused element does not need to be tabbable. This prevents
 * navigation from getting stuck on an element that was programmatically or
 * pointer focused with `tabindex="-1"`. Negative-tab-index elements remain
 * excluded as destinations.
 *
 * Returns `null` if there is no focused element within the container.
 */ 
function $2fce1a829520f0be$export$a7db88e6d491b450(_ref) {
    var _all3;
    var container = _ref.container, direction = _ref.direction, filter = _ref.filter;
    var all = (0, $69d23fe834b3fb9c$export$f6768025e418420e)({
        container: container,
        filter: filter
    });
    var first = all[0];
    var last = all[all.length - 1];
    // Checking the elements directly narrows types from `HTMLElement | undefined`.
    if (!first || !last) return null;
    var current = container.ownerDocument.activeElement;
    if (!(current instanceof HTMLElement) || !container.contains(current)) return null;
    var index = all.indexOf(current);
    // The focused element can be absent from `all` when it is non-tabbable or
    // excluded by the filter. Find the first focusable element that follows it in
    // the DOM, which identifies the nearest focusable destination in either direction.
    if (index === -1) {
        var _all;
        var followingIndex = all.findIndex(function(element) {
            return Boolean(current.compareDocumentPosition(element) & current.DOCUMENT_POSITION_FOLLOWING);
        });
        if (direction === 'forwards') {
            var _all$followingIndex;
            // If nothing follows the current element, then wrap to the start.
            return (_all$followingIndex = all[followingIndex]) !== null && _all$followingIndex !== void 0 ? _all$followingIndex : first;
        }
        // The closest preceding element is immediately before the first following one.
        // A missing adjacent entry means the backward sequence wraps to the end.
        return (_all = all[followingIndex - 1]) !== null && _all !== void 0 ? _all : last;
    }
    // The current element is tabbable, so use its adjacent list entry and wrap
    // when it is already at the boundary.
    if (direction === 'forwards') {
        var _all2;
        return (_all2 = all[index + 1]) !== null && _all2 !== void 0 ? _all2 : first;
    }
    return (_all3 = all[index - 1]) !== null && _all3 !== void 0 ? _all3 : last;
}



function $52720adf1c8420fe$export$b9590fdfeb5f722f(_ref) {
    var container = _ref.container;
    var focused = container.ownerDocument.activeElement;
    if (!(focused instanceof HTMLElement)) return false;
    // Cannot be in a nested layer if it is not in the container
    if (!container.contains(focused)) return false;
    // If not in the same layer, must be in a nested layer
    return (0, $e41b156a9767de12$export$3c9385904be131db)({
        element: focused
    }) !== (0, $e41b156a9767de12$export$3c9385904be131db)({
        element: container
    });
}


/**
 * Roles that require focus wrapping per WAI-ARIA APG.
 *
 * - `dialog`: https://www.w3.org/WAI/ARIA/apg/patterns/dialog-modal/
 * - `alertdialog`: same keyboard pattern as dialog
 *
 * `menu` is intentionally excluded. Menus are composite widgets
 * (https://www.w3.org/WAI/ARIA/apg/practices/keyboard-interface/#kbd_general_within)
 * that manage their own internal keyboard navigation via arrow keys,
 * not Tab. Tab/Shift+Tab should move focus OUT of a menu entirely.
 *
 * Menu keyboard behavior (arrow keys, Home/End, type-ahead, Enter/Space)
 * is context-dependent. It varies by orientation, nesting depth, item
 * type, and control pattern (menu button vs menubar). This makes it
 * impossible to implement generically here. The consumer component
 * (e.g. `dropdown-menu`) owns all menu keyboard navigation.
 *
 * See: notes/outputs/menu-keyboard-decision.md
 */ function $765fe5fd152dd74a$var$roleRequiresFocusWrap(role) {
    return role === 'dialog' || role === 'alertdialog';
}
function $765fe5fd152dd74a$export$4f6462e86a70abe5(_ref) {
    var elementRef = _ref.elementRef, role = _ref.role, phase = _ref.phase;
    var isVisible = phase !== 'closed';
    (0, $5FkrB.useEffect)(function() {
        var element = elementRef.current;
        if (!element || !$765fe5fd152dd74a$var$roleRequiresFocusWrap(role) || !isVisible) return;
        var unbind = (0, $5b617c1f48263075$exports.bind)(element, {
            type: 'keydown',
            listener: function listener(event) {
                if (event.key !== 'Tab') return;
                // If focus is already in a nested layer, then
                // we continue to let that nested layer own focus
                if ((0, $52720adf1c8420fe$export$b9590fdfeb5f722f)({
                    container: element
                })) return;
                // Prevent the browser giving focus to where it wants to
                // (we will be handling it, including with wrapping)
                event.preventDefault();
                var direction = event.shiftKey ? 'backwards' : 'forwards';
                // Try to move to the next/previous focusable element relative
                // to the currently focused element within the container.
                var next = (0, $2fce1a829520f0be$export$a7db88e6d491b450)({
                    container: element,
                    direction: direction
                });
                if (next) {
                    next.focus();
                    return;
                }
                // Nothing is currently focused inside the container (or the
                // focused element is not in the focusable list). Fall back to
                // the first or last focusable element depending on direction.
                var fallback = direction === 'forwards' ? (0, $0e5e27f156f9e55c$export$748138f04a69bf21)({
                    container: element
                }) : (0, $438b65b604e8b00d$export$73e81fa65335a75b)({
                    container: element
                });
                if (fallback) fallback.focus();
            },
            options: {
                capture: true
            }
        });
        return unbind;
    }, [
        elementRef,
        role,
        isVisible
    ]);
}



var $5FkrB = parcelRequire("5FkrB");

/**
 * Determines the correct element to receive initial focus within a popover,
 * based on its ARIA role.
 *
 * Focus rules by role (per WAI-ARIA APG):
 * - `dialog` / `alertdialog`: first element with `[autofocus]`, or first focusable element
 * - `menu`: first menu item (`[role="menuitem|menuitemcheckbox|menuitemradio"]`)
 * - `listbox`: first selected option (`[aria-selected="true"]`), or first option (`[role="option"]`)
 * - `tooltip`: no focus movement (tooltips are informational)
 * - no role / other roles: no focus movement
 *
 * Note: React 18's `autoFocus` JSX prop does NOT set the HTML `autofocus`
 * attribute - it only calls `.focus()` imperatively during commit, which
 * has no effect on hidden popover content. Consumers must set the native
 * attribute via a ref callback (e.g. `node.setAttribute('autofocus', '')`).
 * React 19+ reflects the JSX prop as the HTML attribute automatically.
 *
 * Combobox pattern exception: if the popup is controlled by a focused
 * combobox-like trigger (its `aria-controls` references this popup),
 * focus stays on the textbox regardless of role. See
 * `isComboboxControllingPopup`.
 */ /**
 * WAI-ARIA APG Combobox Pattern: when a combobox controls a popup (listbox,
 * grid, tree, or menu), DOM focus must remain on the textbox. Subsequent
 * navigation through popup items uses `aria-activedescendant` (or proxied
 * keyboard events), never DOM focus movement.
 *
 * Detects both variants in a single pass:
 * - In-popup combobox: the textbox lives inside the popup `container`
 *   (the popup is rendered as a child of the combobox wrapper).
 * - External combobox: the textbox is rendered OUTSIDE the popup
 *   (`react-select` pattern, where the listbox is portalled separately
 *   from the textbox).
 *
 * Acceptance criteria for the active element:
 * - Role / element-type filter: `role="combobox"`, `role="textbox"`,
 *   `TEXTAREA`, `contentEditable`, or `INPUT` of text-like type
 *   (`text`, `search`, `email`, `url`, `tel`, `password`, or
 *   unspecified). Non-text input types (`button`, `checkbox`, etc.)
 *   are rejected.
 * - Reference filter: `aria-controls` (or legacy `aria-owns`) IDREFS
 *   must resolve to an element that IS or CONTAINS the popup container.
 *
 * See: https://www.w3.org/WAI/ARIA/apg/patterns/combobox/
 */ // `<input>` types treated as text-like for combobox detection.
// Non-text input types (`button`, `checkbox`, `submit`, etc.) are rejected.
// A missing `type` attribute defaults to `text` per the HTML spec, so we
// normalize that case before lookup rather than including an empty string here.
var $5298b17c822202ac$var$TEXT_LIKE_INPUT_TYPES = new Set([
    'text',
    'search',
    'email',
    'url',
    'tel',
    'password'
]);
function $5298b17c822202ac$var$isTextboxLikeElement(element) {
    var role = element.getAttribute('role');
    if (role === 'combobox' || role === 'textbox') return true;
    // `tagName` is uppercase for HTML elements but can be mixed-case for
    // XML/SVG. Normalize once so downstream comparisons stay lowercase.
    var tag = element.tagName.toLowerCase();
    if (tag === 'textarea') return true;
    if (element.isContentEditable) return true;
    if (tag === 'input') {
        var _element$getAttribute;
        var type = ((_element$getAttribute = element.getAttribute('type')) !== null && _element$getAttribute !== void 0 ? _element$getAttribute : 'text').toLowerCase();
        return $5298b17c822202ac$var$TEXT_LIKE_INPUT_TYPES.has(type);
    }
    return false;
}
function $5298b17c822202ac$var$isComboboxControllingPopup(_ref) {
    var _active$getAttribute;
    var container = _ref.container;
    var ownerDocument = container.ownerDocument;
    var active = ownerDocument.activeElement;
    if (!(active instanceof HTMLElement)) return false;
    if (!$5298b17c822202ac$var$isTextboxLikeElement(active)) return false;
    // Accept legacy `aria-owns` in addition to `aria-controls`.
    // `aria-controls` / `aria-owns` are IDREFS (space-separated list of IDs)
    // per the WAI-ARIA spec, so we must split and check membership rather
    // than comparing with strict equality. A combobox that controls both
    // this popup and another element (e.g. a results status region) must
    // still be recognised as controlling this popup.
    var idRefs = (_active$getAttribute = active.getAttribute('aria-controls')) !== null && _active$getAttribute !== void 0 ? _active$getAttribute : active.getAttribute('aria-owns');
    if (!idRefs) return false;
    // Match if any referenced element IS, CONTAINS, or IS CONTAINED BY the
    // popup container. The "contained by" case covers wrapper-style adopters
    // like react-select, where the combobox input's `aria-controls` points at
    // a listbox element that is a descendant of the Popover host (the
    // listbox role lives on a child the wrapped library owns, not on the
    // host we render).
    var referencedIds = idRefs.split(/\s+/).filter(function(id) {
        return id !== '';
    });
    return referencedIds.some(function(id) {
        var referenced = ownerDocument.getElementById(id);
        if (!referenced) return false;
        return referenced === container || referenced.contains(container) || container.contains(referenced);
    });
}
function $5298b17c822202ac$var$getInitialFocusTarget(_ref2) {
    var container = _ref2.container, role = _ref2.role;
    if (role === 'dialog' || role === 'alertdialog') {
        // Prefer element with the native HTML autofocus attribute.
        var autofocusEl = container.querySelector('[autofocus]');
        if (autofocusEl) return autofocusEl;
        // Fall back to first focusable element
        return (0, $0e5e27f156f9e55c$export$748138f04a69bf21)({
            container: container
        });
    }
    // The combobox carve-out is kept role-specific (menu / listbox) rather
    // than hoisted. Hoisting it over-matched on dialog popups that contain
    // a nested combobox (e.g. datetime-picker's dialog hosts a react-select),
    // where the active combobox's `aria-controls` falsely matched the
    // container and suppressed the dialog's own focus contract.
    if (role === 'menu') {
        if ($5298b17c822202ac$var$isComboboxControllingPopup({
            container: container
        })) return null;
        // Initial focus placement is the extent of what top-layer provides
        // for menus. All subsequent keyboard navigation (arrow keys, Home/End,
        // type-ahead, Enter/Space, submenu coordination) is the responsibility
        // of the consumer component (e.g. dropdown-menu), because menu keyboard
        // behavior varies by context (orientation, nesting, item type, control
        // pattern). See: notes/outputs/menu-keyboard-decision.md
        return (0, $0e5e27f156f9e55c$export$748138f04a69bf21)({
            container: container
        });
    }
    if (role === 'listbox') {
        // ARIA Combobox Pattern: if a combobox-like textbox owns the popup
        // (in-popup or external e.g. react-select), leave focus on the
        // textbox - navigation is proxied through it.
        if ($5298b17c822202ac$var$isComboboxControllingPopup({
            container: container
        })) return null;
        // Prefer the selected option, then fall back to the first option.
        // We intentionally match by `[role="option"]` rather than by
        // `getFirstFocusable`. The standard WAI-ARIA APG listbox pattern
        // renders options with `tabindex="-1"` (managed via roving
        // tabindex); `getFirstFocusable` excludes `tabindex="-1"` elements
        // and would silently lose initial focus for spec-conformant
        // listboxes. Options remain programmatically focusable.
        var selectedOption = container.querySelector('[role="option"][aria-selected="true"]');
        if (selectedOption) return selectedOption;
        var firstOption = container.querySelector('[role="option"]');
        if (firstOption) return firstOption;
        // Last resort for non-standard listboxes that render no options
        // but do contain a focusable element (e.g. an empty-state action).
        return (0, $0e5e27f156f9e55c$export$748138f04a69bf21)({
            container: container
        });
    }
    // tooltip, no role, or other roles: no focus movement
    return null;
}
function $5298b17c822202ac$export$e992c40175757a22(_ref3) {
    var elementRef = _ref3.elementRef, phase = _ref3.phase, role = _ref3.role;
    // Track the previous phase so we only focus on transitions into a
    // visible phase from either `'closed'` (fresh mount) or `'exiting'`
    // (mid-exit reopen where the browser has already restored focus to
    // the trigger). Pure `entering → exiting → entering` stutters where
    // the consumer toggles in the same frame are still collapsed.
    var prevPhaseRef = (0, $5FkrB.useRef)('closed');
    (0, $5FkrB.useEffect)(function() {
        var _getInitialFocusTarge;
        var prevPhase = prevPhaseRef.current;
        prevPhaseRef.current = phase;
        // Only focus on transitions into a visible phase from `'closed'`
        // (fresh open) or `'exiting'` (mid-exit reopen).
        if (phase === 'closed') return;
        if (prevPhase !== 'closed' && prevPhase !== 'exiting') return;
        var element = elementRef.current;
        if (!element) return;
        (_getInitialFocusTarge = $5298b17c822202ac$var$getInitialFocusTarget({
            container: element,
            role: role
        })) === null || _getInitialFocusTarge === void 0 || _getInitialFocusTarge.focus();
    }, [
        elementRef,
        phase,
        role
    ]);
}


/**
 * Native restoration only covers the first popover in an auto/hint stack, not each nested popover.
 * This fallback also supports manual popovers, which have no native restoration target.
 * See https://html.spec.whatwg.org/multipage/popover.html#show-popover (step 15.8).
 */ function $b103fdb0f1d92e4d$var$restoreFocus(_ref) {
    var popover = _ref.popover, focusRestorationTarget = _ref.focusRestorationTarget;
    if (!focusRestorationTarget) return;
    var ownerDocument = popover.ownerDocument;
    // Native restoration has finished. Preserve focus moved outside the popover.
    var activeElementAfterClose = ownerDocument.activeElement;
    // Before close, we checked that focus was inside. Body can now mean focus was lost during close.
    if (activeElementAfterClose === ownerDocument.body || popover.contains(activeElementAfterClose)) // Match native popover restoration, which does not scroll the viewport.
    focusRestorationTarget.focus({
        preventScroll: true
    });
}
/**
 * Detects `popover="hint"` support via DOM reflection. SSR-safe, cached.
 */ var $b103fdb0f1d92e4d$var$supportsPopoverHint = (0, $86089df3a0fd54eb$export$2e2bcd8739ae039)(function() {
    if (typeof document === 'undefined') return false;
    // eslint-disable-next-line @atlaskit/platform/no-direct-document-usage -- feature detection
    var element = document.createElement('div');
    element.setAttribute('popover', 'hint');
    return element.popover === 'hint';
});
// Surface reset — neutralises inherited interaction and text-layout properties
// (e.g. `pointer-events: none` from an overlaid controls container and
// `white-space: nowrap` from an `@atlaskit/select` option) that leak into a
// top-layer element because, for CSS inheritance, it is still a DOM child of its
// trigger (top-layer promotion is paint/stacking only; the legacy portal path
// avoided this by rendering at `<body>`). Excludes `color`/`font` (theming) and
// `direction`/`unicode-bidi` (RTL must inherit).
//
// Not `all: initial`: the target is what `<body>` gave the portal path, not the
// spec initial values (UA serif, black, `color-scheme: normal`), and as an author
// declaration it would also override the UA `[popover]` rules (`position: fixed`,
// `display: none` when closed).
//
// KEEP IN SYNC with the identical `surfaceResetStyles` in `dialog/dialog-content.tsx`.
// ADS forbids sharing styles across files (`no-exported-styles` /
// `no-imported-style-values` — Compiled styles are null at runtime), so the reset is
// co-located and duplicated deliberately. The `satisfies` check below fails the
// build if either copy drifts.
var $b103fdb0f1d92e4d$var$surfaceResetStyles = {
    root: "_lcxv1wug _o5724jg8 _1nmz4jg8 _1i4q4jg8 _y3gnv2br _azhwidpf _1p1dglyw"
};
var $b103fdb0f1d92e4d$var$styles = {
    root: "_19itglyw _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19pkidpf _2hwxidpf _otyridpf _18u0idpf _1r041wug _1reoewfl _18m9ewfl _bfhk1j28 _4t3i1wug _p6861txw _51hckb7n _1yp3idpf _f5r5idpf",
    motion: "_k8m011k7 _1oecdn4k _1s9z1a5r _1o511hrf _bl8aglyw _156y147i",
    enter: "_y44v179n",
    exit: "_y44vof1f"
};
// Intentionally using `Record<string, string>` instead of `React.CSSProperties`
// to avoid type errors about the CSS variables not being valid property names
var $b103fdb0f1d92e4d$var$popupMotionStyles = {
    block: {
        start: {
            '--ds-popover-motion-enter': "var(--ds-popup-enter-top, 150ms cubic-bezier(0.4, 1, 0.6, 1) SlideInTop8px, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn0to100)",
            '--ds-popover-motion-exit': "var(--ds-popup-exit-top, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) SlideOutTop8px, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)"
        },
        end: {
            '--ds-popover-motion-enter': "var(--ds-popup-enter-bottom, 150ms cubic-bezier(0.4, 1, 0.6, 1) SlideInBottom8px, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn0to100)",
            '--ds-popover-motion-exit': "var(--ds-popup-exit-bottom, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) SlideOutBottom8px, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)"
        }
    },
    inline: {
        start: {
            '--ds-popover-motion-enter': "var(--ds-popup-enter-left, 150ms cubic-bezier(0.4, 1, 0.6, 1) SlideInLeft8px, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn0to100)",
            '--ds-popover-motion-exit': "var(--ds-popup-exit-left, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) SlideOutLeft8px, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)"
        },
        end: {
            '--ds-popover-motion-enter': "var(--ds-popup-enter-right, 150ms cubic-bezier(0.4, 1, 0.6, 1) SlideInRight8px, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn0to100)",
            '--ds-popover-motion-exit': "var(--ds-popup-exit-right, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) SlideOutRight8px, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)"
        }
    }
};
/**
 * Roles registered with the open layer observer as `popup`, so `closeLayers()`
 * dismisses them. `modal` comes from Dialog only; other layer types are unused.
 */ var $b103fdb0f1d92e4d$var$POPUP_ROLES = new Set([
    'menu',
    'listbox',
    'dialog',
    'alertdialog',
    'tree',
    'grid'
]);
var $b103fdb0f1d92e4d$export$5b6b19405a83ff9d = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function Popover(_ref2, ref) {
    var children = _ref2.children, _ref2$mode = _ref2.mode, modeProp = _ref2$mode === void 0 ? 'auto' : _ref2$mode, onClose = _ref2.onClose, onEnterFinish = _ref2.onEnterFinish, onExitFinish = _ref2.onExitFinish, _ref2$shouldAnimate = _ref2.shouldAnimate, shouldAnimate = _ref2$shouldAnimate === void 0 ? false : _ref2$shouldAnimate, placement = _ref2.placement, testId = _ref2.testId, isOpen = _ref2.isOpen, enteringAnimationXcss = _ref2.enteringAnimationXcss, exitingAnimationXcss = _ref2.exitingAnimationXcss, role = _ref2.role, label = _ref2.label, labelledBy = _ref2.labelledBy, idProp = _ref2.id;
    var autoId = (0, $5FkrB.useId)();
    var ownRef = (0, $5FkrB.useRef)(null);
    var combinedRef = (0, $db13a2f91f6a0f56$export$2e2bcd8739ae039)([
        ownRef,
        ref
    ].filter(Boolean));
    // `useId()` colons are invalid in CSS selectors and popover target attributes.
    var popoverId = idProp !== null && idProp !== void 0 ? idProp : "popover-".concat(autoId.replace(/:/g, ''));
    // Keep the semantic callback current without rebinding native lifecycle
    // listeners during the same commit that calls showPopover()/hidePopover().
    var onCloseRef = (0, $5FkrB.useRef)(onClose);
    (0, $5FkrB.useLayoutEffect)(function() {
        onCloseRef.current = onClose;
    }, [
        onClose
    ]);
    // Register with open layer observer so `closeLayers()` and open-count
    // subscriptions work. Only popup-like roles register as `popup`; passive
    // roles (tooltip, status, etc.) leave `type` undefined.
    var handleObserverClose = (0, $5FkrB.useCallback)(function() {
        var _onCloseRef$current;
        (_onCloseRef$current = onCloseRef.current) === null || _onCloseRef$current === void 0 || _onCloseRef$current.call(onCloseRef, {
            reason: 'programmatic'
        });
    }, []);
    (0, $dc4b45f7ee6225f5$export$469bb693f11edc7f)({
        type: role && $b103fdb0f1d92e4d$var$POPUP_ROLES.has(role) ? 'popup' : undefined,
        isOpen: isOpen,
        onClose: handleObserverClose
    });
    // `hint` falls back to `auto` when unsupported: closest behavior (light
    // dismiss works), but `auto` participates in the auto-dismiss stack so it
    // will close other `auto` popovers when opened. Acceptable trade-off given
    // shrinking browser set without `hint` support.
    var mode = modeProp === 'hint' && !$b103fdb0f1d92e4d$var$supportsPopoverHint() ? 'auto' : modeProp;
    var popupMotionStyle = (0, $5FkrB.useMemo)(function() {
        if (!placement || !shouldAnimate) return undefined;
        var _resolvePlacement = (0, $22e1c0cfc4927867$export$63044d21bc3d3fa2)({
            placement: placement
        }), axis = _resolvePlacement.axis, edge = _resolvePlacement.edge;
        return $b103fdb0f1d92e4d$var$popupMotionStyles[axis][edge];
    }, [
        placement,
        shouldAnimate
    ]);
    // Tracks the close reason, including our own hidePopover() calls.
    var closeReasonRef = (0, $5FkrB.useRef)('light-dismiss');
    // Pre-open focus target, cleared before close when restoration is not eligible.
    var focusRestorationTargetRef = (0, $5FkrB.useRef)(null);
    var handleBeforeToggle = (0, $5FkrB.useCallback)(function(event) {
        var popover = event.currentTarget;
        if (!(popover instanceof HTMLElement)) return;
        var ownerDocument = popover.ownerDocument;
        var activeElement = ownerDocument.activeElement;
        if (event.newState === 'open') {
            focusRestorationTargetRef.current = activeElement instanceof HTMLElement ? activeElement : null;
            return;
        }
        /**
     * Like native restoration, leave external focus alone and skip light dismiss.
     * Check before closing so focus already on body is not mistaken for focus lost during close.
     * See https://html.spec.whatwg.org/multipage/popover.html#hide-popover-algorithm (step 20.2).
     */ if (closeReasonRef.current === 'light-dismiss' || !popover.contains(activeElement)) focusRestorationTargetRef.current = null;
    }, []);
    var handleToggleClosed = (0, $5FkrB.useCallback)(function(event) {
        var popover = event.currentTarget;
        if (!(popover instanceof HTMLElement)) return;
        var focusRestorationTarget = focusRestorationTargetRef.current;
        focusRestorationTargetRef.current = null;
        var reason = closeReasonRef.current;
        // Reset reason so a stale 'escape' from a race with Escape keydown
        // does not corrupt the next browser-dismiss cycle.
        closeReasonRef.current = 'light-dismiss';
        // Run after native restoration, before notifying the consumer, which may move focus itself.
        $b103fdb0f1d92e4d$var$restoreFocus({
            popover: popover,
            focusRestorationTarget: focusRestorationTarget
        });
        // Programmatic closes are already known to the consumer.
        if (reason !== 'programmatic') {
            var _onCloseRef$current2;
            (_onCloseRef$current2 = onCloseRef.current) === null || _onCloseRef$current2 === void 0 || _onCloseRef$current2.call(onCloseRef, {
                reason: reason
            });
        }
    }, []);
    var _useAnimatedVisibilit = (0, $925bd4562e5dc5b7$export$1bccb45daf07907f)({
        isOpen: isOpen,
        shouldAnimate: shouldAnimate,
        elementRef: ownRef,
        onEnterFinish: onEnterFinish,
        onExitFinish: onExitFinish
    }), phase = _useAnimatedVisibilit.phase, isMounted = _useAnimatedVisibilit.isMounted, onBeforeToggle = _useAnimatedVisibilit.onBeforeToggle, onToggle = _useAnimatedVisibilit.onToggle;
    // Focus management: initial focus on entry (role-dependent), Tab cycling
    // for dialog roles. Restoration is native for outermost popovers; nested
    // popovers are handled above via the `beforetoggle` snapshot.
    // Passing `phase` keeps `useFocusWrap` attached through the animated-exit
    // window (WCAG 2.4.3 guard). See notes/architecture/focus.md.
    (0, $765fe5fd152dd74a$export$4f6462e86a70abe5)({
        elementRef: ownRef,
        role: role,
        phase: phase
    });
    (0, $5298b17c822202ac$export$e992c40175757a22)({
        elementRef: ownRef,
        phase: phase,
        role: role
    });
    // Bind via `useLayoutEffect`, and BEFORE the show/hide layout effect
    // below, so listeners are attached when `showPopover()` synchronously
    // dispatches `beforetoggle`. A regular `useEffect` would miss that
    // first dispatch, dropping the `focusRestorationTargetRef` snapshot
    // and breaking nested-popover focus restoration on close. React runs
    // layout effects in source order on the same commit.
    (0, $5FkrB.useLayoutEffect)(function() {
        var element = ownRef.current;
        if (!element) return;
        // Tag Escape before the browser processes light dismiss.
        var unbindEscape = (0, $5b617c1f48263075$exports.bind)(element, {
            type: 'keydown',
            listener: function listener(event) {
                // Ignore Escape events dispatched after native close.
                if (event.key === 'Escape' && (0, $881af1e5012c4c5e$export$89b923e18c14644d)({
                    element: element
                })) closeReasonRef.current = 'escape';
            },
            options: {
                capture: true
            }
        });
        var unbindToggle = (0, $5b617c1f48263075$exports.bind)(element, {
            type: 'toggle',
            listener: function listener(event) {
                if (event.newState === 'closed') handleToggleClosed(event);
                onToggle(event);
            }
        });
        // Snapshot the active element before `useInitialFocus` moves it,
        // then advance the shared visibility lifecycle.
        var unbindBeforeToggle = (0, $5b617c1f48263075$exports.bind)(element, {
            type: 'beforetoggle',
            listener: function listener(event) {
                handleBeforeToggle(event);
                onBeforeToggle(event);
            }
        });
        return function() {
            unbindEscape();
            unbindToggle();
            unbindBeforeToggle();
        };
    }, [
        handleBeforeToggle,
        handleToggleClosed,
        isMounted,
        onBeforeToggle,
        onToggle
    ]);
    // Show/hide based on isOpen. `showPopover`/`hidePopover` are no-ops when
    // already in the target state. Try/catch guards `InvalidStateError` on
    // disconnected elements (StrictMode/concurrent/unmount edge cases).
    (0, $5FkrB.useLayoutEffect)(function() {
        var element = ownRef.current;
        if (!element) return;
        if (isOpen) {
            // Clear stale 'escape' from a prior cycle: the ref outlives
            // the host element, and interrupted close lifecycles may not reach
            // `handleToggleClosed` to reset it.
            closeReasonRef.current = 'light-dismiss';
            try {
                element.showPopover();
            } catch (_unused) {}
            return function() {
                closeReasonRef.current = 'programmatic';
                try {
                    element.hidePopover();
                } catch (_unused2) {}
            };
        }
        closeReasonRef.current = 'programmatic';
        try {
            element.hidePopover();
        } catch (_unused3) {}
    }, [
        isOpen
    ]);
    // Unmount the host once exit completes so it does not leave an empty
    // `role`/`popover` element in the accessibility tree. The element
    // remounts on the next open; the `popoverId` is stable across opens.
    if (!isMounted) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("div", {
        ref: combinedRef,
        id: popoverId,
        popover: mode,
        role: role,
        "aria-label": label,
        "aria-labelledby": labelledBy,
        "data-testid": testId,
        style: popupMotionStyle,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $3409454e8e68f10d$export$2e2bcd8739ae039)([
            $b103fdb0f1d92e4d$var$styles.root,
            $b103fdb0f1d92e4d$var$surfaceResetStyles.root,
            shouldAnimate && phase === 'entering' && $b103fdb0f1d92e4d$var$styles.enter,
            shouldAnimate && phase === 'exiting' && $b103fdb0f1d92e4d$var$styles.exit,
            shouldAnimate && $b103fdb0f1d92e4d$var$styles.motion,
            (0, $730928ba53460d9f$export$a274e22fb40f762e)(shouldAnimate && phase === 'entering' && enteringAnimationXcss, shouldAnimate && phase === 'exiting' && exitingAnimationXcss)
        ])
    }, children);
});


/* popover-surface.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $5FkrB = parcelRequire("5FkrB");

var $cda0def86655916a$var$styles = {
    root: "_2rkofajl _1reo1wug _18m91wug _bfhk1bhr _syazi7uo _16qs130s"
};
function $cda0def86655916a$export$8b7437164e479115(_ref) {
    var children = _ref.children;
    return /*#__PURE__*/ $5FkrB.createElement("div", {
        className: (0, $3409454e8e68f10d$export$2e2bcd8739ae039)([
            $cda0def86655916a$var$styles.root
        ])
    }, children);
}


/**
 * Positioning AND anchor-relative sizing for top-layer popovers. Anchors an
 * ELEMENT; to anchor a viewport coordinate use `useAnchoredPopoverAtPoint`.
 *
 * Two runtime paths, each a function that applies its styles and returns the
 * cleanup: CSS Anchor Positioning in `./anchor-positioning`, and the JavaScript
 * fallback in `./javascript-fallback`. The path is resolved ONCE, at the top of
 * the hook, and threaded through positioning, sizing and margins.
 *
 * See `notes/architecture/positioning.md` and
 * `notes/decisions/fit-available-space.md`.
 */ 
var $5FkrB = parcelRequire("5FkrB");


function $538018b1c6cb2580$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return (0, $7b3afea154547032$export$2e2bcd8739ae039)(r);
}


function $07abf4dadb8f64a4$export$2e2bcd8739ae039(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}



function $f04c6234140b4f5f$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}


function $b4770e67e780c426$export$2e2bcd8739ae039(r) {
    return (0, $538018b1c6cb2580$export$2e2bcd8739ae039)(r) || (0, $07abf4dadb8f64a4$export$2e2bcd8739ae039)(r) || (0, $1e7e05e4e5a163d6$export$2e2bcd8739ae039)(r) || (0, $f04c6234140b4f5f$export$2e2bcd8739ae039)();
}


/**
 * A single inline style declaration.
 *
 * `TProperty` narrows the property name for callers that write a known, closed
 * set of properties. Narrowing it lets a record keyed on those same names be
 * checked for exhaustiveness at compile time, rather than silently resolving to
 * `undefined` for a name that was never mapped.
 */ /**
 * Sets inline styles on an element and returns a cleanup function that
 * restores the prior inline values (so we do not stomp consumer styles).
 */ function $1e1fef10dc605e8f$export$37a5fde709c1db82(_ref) {
    var element = _ref.element, styles = _ref.styles;
    // Snapshot the prior inline value (NOT the computed style - we only want
    // to restore values that the consumer/our previous run inlined). An empty
    // string means "no inline value", in which case cleanup uses removeProperty.
    var priorValues = styles.map(function(_ref2) {
        var property = _ref2.property;
        return {
            property: property,
            value: element.style.getPropertyValue(property)
        };
    });
    styles.forEach(function(_ref3) {
        var property = _ref3.property, value = _ref3.value;
        element.style.setProperty(property, value);
    });
    return function cleanup() {
        priorValues.forEach(function(_ref4) {
            var property = _ref4.property, value = _ref4.value;
            if (value === '') {
                element.style.removeProperty(property);
                return;
            }
            element.style.setProperty(property, value);
        });
    };
}


/**
 * The cross-axis shift, written antisymmetrically on BOTH cross-axis sides rather
 * than as one margin. Do not collapse it to one side: a single margin widens the
 * margin box, so `anchor-center` displaces the border box by only half the value,
 * a `<position-area>` fallback sliding across the cross axis drops it entirely,
 * and the widened box changes where the popover is judged to overflow.
 *
 * A positive value always moves the popover toward the cross-axis END, so
 * `direction: 'forwards'` means the same thing for every `align` value. See
 * `notes/decisions/placement-offset.md`.
 */ function $2ea5365bb162e2ba$export$f7505ccec0897ae3(_ref) {
    var placement = _ref.placement, crossAxisShiftCssValue = _ref.crossAxisShiftCssValue, direction = _ref.direction;
    var crossAxis = placement.axis === 'block' ? 'inline' : 'block';
    // `calc()` rather than JavaScript math, so opaque values such as design tokens
    // negate correctly.
    var negated = "calc(-1 * ".concat(crossAxisShiftCssValue, ")");
    var isForwards = direction === 'forwards';
    return [
        {
            property: "margin-".concat(crossAxis, "-start"),
            value: isForwards ? crossAxisShiftCssValue : negated
        },
        {
            property: "margin-".concat(crossAxis, "-end"),
            value: isForwards ? negated : crossAxisShiftCssValue
        }
    ];
}


/**
 * The margin that creates the gap between the popover and its anchor.
 */ function $5396def1eca52f22$export$b94d052c6b40496(_ref) {
    var placement = _ref.placement, offset = _ref.offset;
    var axis = placement.axis, edge = placement.edge;
    // The side FACING the anchor is always opposite the placement edge.
    var anchorFacingEdge = edge === 'end' ? 'start' : 'end';
    return {
        property: "margin-".concat(axis, "-").concat(anchorFacingEdge),
        value: offset
    };
}



/**
 * The space kept clear between a popover and the viewport edge. Matches legacy
 * `@atlaskit/popper`'s `preventOverflow` padding of `5`.
 */ var $2c1ebc223ebddfd6$export$9f2fdbacbc62226e = '5px';
var $2c1ebc223ebddfd6$export$32ab78b2bb853a01 = '150px';
/**
 * Which way the POPOVER's inline axis runs; `'vertical'` covers the `vertical-*`
 * and `sideways-*` writing modes. Measured rather than assumed, because every
 * logical property this module writes resolves against the popover's own writing
 * mode, and so must the viewport unit paired with it.
 */ /**
 * The dynamic viewport unit for one of the popover's axes. Not `dvi` / `dvb`:
 * css-values-4 defines those against the ROOT element's writing mode, while the
 * `max-{axis}-size` they are written to follows the popover's, so a popover in a
 * `vertical-rl` subtree of a horizontal document would be capped by the wrong
 * dimension.
 */ function $2c1ebc223ebddfd6$var$viewportUnit(_ref) {
    var axis = _ref.axis, writingMode = _ref.writingMode;
    var isHorizontalAxis = axis === 'inline' === (writingMode === 'horizontal');
    return isHorizontalAxis ? 'dvw' : 'dvh';
}
/**
 * How one axis of an anchored popover is sized. Both axes take these four values
 * under identical rules.
 *
 * - `'content'`: sized by its content. Named after `flex-basis: content`; NOT
 *   `'auto'`, whose CSS meaning for a positioned box is shrink-to-fit, the very
 *   behaviour rule 4 removes.
 * - `'match-anchor'`: exactly the anchor's size on this axis.
 * - `'min-anchor'`: at least the anchor's size on this axis, free to grow.
 * - `'max-available'`: at most the space between the anchor and the viewport
 *   edge, content-sized below that. Capped by the `position-area` cell on the
 *   placement axis and by the viewport on the cross axis (a `span-*` cell is
 *   narrower than the viewport, so capping to it would wrap content that fits on
 *   screen).
 *
 * Four rules apply on top:
 *
 * 1. Fitting one axis fills a `'content'` other axis with `'max-available'` too.
 *    An explicit value is never overridden, so caps stay strictly per-axis.
 * 2. Fitting either axis floors the placement axis, because flipping is a
 *    whole-popover outcome. See `getPlacementAxisFloor`.
 * 3. The viewport cap is unconditional, so a non-fitting axis still cannot
 *    overhang the screen. `'max-available'` and `'content'` are therefore
 *    indistinguishable on the cross axis.
 * 4. A non-anchor-relative inline axis gets `inline-size: max-content`. Under
 *    `position-area` the containing block is the cell, so a CSS `auto` inline
 *    size shrink-to-fits a too-narrow cell and WRAPS into it, never overflowing
 *    and so never sliding to the roomier side. The caps still beat it, because a
 *    max beats a definite size. Not needed on the block axis, which does not
 *    wrap, nor on the JavaScript fallback, whose containing block is the
 *    viewport. Consumers opt out with `shouldPreserveInlineSize`.
 *
 * See `notes/decisions/fit-available-space.md`.
 */ /**
 * Narrowed rather than `string`, so a typo cannot reach `setStyle` as a
 * silently-ignored property name.
 */ /**
 * The anchor's size along each axis, as a CSS length. `null` when nothing needs
 * it, so the measurement is skipped.
 *
 * The CSS path uses the `self-` keywords, whose axes are the POPOVER's, so each
 * value matches the axis of the property it is set on (`anchor-size(inline)` and
 * `anchor-size(width)` are both silently wrong in a vertical writing mode). The
 * JavaScript fallback uses a measured pixel length, because `anchor-size()` needs
 * a `position-anchor` that path never sets. See
 * `notes/decisions/width-from-anchor-floors.md`.
 */ function $2c1ebc223ebddfd6$var$getCrossAxis(axis) {
    return axis === 'block' ? 'inline' : 'block';
}
/**
 * The whole viewport, less the reserved padding on both sides. Rule 3's backstop.
 */ function $2c1ebc223ebddfd6$var$viewportCap(_ref2) {
    var axis = _ref2.axis, writingMode = _ref2.writingMode;
    return "calc(100".concat($2c1ebc223ebddfd6$var$viewportUnit({
        axis: axis,
        writingMode: writingMode
    }), " - 2 * ").concat($2c1ebc223ebddfd6$export$9f2fdbacbc62226e, ")");
}
/**
 * The position-area cell cap, for the placement axis only. The host carries
 * `position-area`, so per css-anchor-position-1 the cell is its containing block:
 * `100%` is the anchor edge to the viewport edge, and it follows whichever side
 * `position-try-fallbacks` settles on. Percentages do not subtract margins, so
 * the gap is subtracted here.
 *
 * Meaningless on the JavaScript fallback, whose containing block is the viewport,
 * so that path gets `viewportCap` on both axes.
 */ function $2c1ebc223ebddfd6$var$cellCap(_ref3) {
    var gap = _ref3.gap;
    return "calc(100% - ".concat($2c1ebc223ebddfd6$export$9f2fdbacbc62226e, " - ").concat(gap, ")");
}
/**
 * The anchor term of the placement-axis floor, and the one place it is capped.
 *
 * `'match-anchor'` earns a floor only where it can flip: a definite size clamps to
 * the cap and shrinks below the anchor instead of flipping.
 *
 * The `canFlip` clamp is deliberate both ways. With no flip in play an unclamped
 * floor beats `max-{axis}-size` (CSS resolves `min` last), making the viewport
 * backstop inert. With a flip in play, clamping would stop the floor exceeding
 * the cell cap, which is what drives the flip.
 */ function $2c1ebc223ebddfd6$var$getPlacementAxisAnchorFloor(_ref4) {
    var placementAxis = _ref4.placementAxis, placementAxisSize = _ref4.placementAxisSize, anchorValue = _ref4.anchorValue, canFlip = _ref4.canFlip, writingMode = _ref4.writingMode;
    var hasAnchorFloor = placementAxisSize === 'min-anchor' || placementAxisSize === 'match-anchor' && canFlip;
    if (!hasAnchorFloor || anchorValue === null) return undefined;
    if (canFlip) return anchorValue;
    return "min(".concat(anchorValue, ", ").concat($2c1ebc223ebddfd6$var$viewportCap({
        axis: placementAxis,
        writingMode: writingMode
    }), ")");
}
/**
 * The default flip floor, clamped so that SOME cell can always hold it.
 *
 * The two cells either side of the anchor add up to the viewport less the anchor,
 * so the roomier one is at least half of that. A floor whose margin box fits
 * inside that half is guaranteed a cell somewhere in the fallback chain.
 * Unclamped, a short viewport with a centred anchor has NO cell that holds
 * 150px: every try-fallback overflows, the browser reverts to the base position,
 * and the floor pushes the popover past the viewport edge.
 *
 * This is NOT the `min(floor, cellCap)` that suppresses flipping: it is relative
 * to the VIEWPORT, so a small base cell still overflows it. `max(0px, …)` states
 * the lower bound for an anchor taller than the viewport.
 */ function $2c1ebc223ebddfd6$var$getDefaultPlacementAxisFloor(_ref5) {
    var placementAxis = _ref5.placementAxis, anchorValue = _ref5.anchorValue, gap = _ref5.gap, writingMode = _ref5.writingMode;
    if (anchorValue === null) return $2c1ebc223ebddfd6$export$32ab78b2bb853a01;
    // The viewport term and the anchor term must measure the SAME axis; see
    // `viewportUnit`.
    var viewport = "100".concat($2c1ebc223ebddfd6$var$viewportUnit({
        axis: placementAxis,
        writingMode: writingMode
    }));
    var halfOfRemainingViewport = "calc((".concat(viewport, " - ").concat(anchorValue, ") / 2 - ").concat(gap, " - ").concat($2c1ebc223ebddfd6$export$9f2fdbacbc62226e, ")");
    return "min(".concat($2c1ebc223ebddfd6$export$32ab78b2bb853a01, ", max(0px, ").concat(halfOfRemainingViewport, "))");
}
/**
 * The placement-axis floor: explicit minimums COMPOSE, the default does not.
 *
 * `placement.minSize` and the anchor term are both explicit requests, so they
 * compose as `max()`. `FALLBACK_MINIMUM_MAIN_AXIS_SIZE` never composes: it only
 * ever won by overriding a size the consumer asked for, and the anchor term drives
 * the flip on its own. Knock-on, intended: `minSize: 0` no longer removes an
 * anchor floor, because `max(0px, anchor)` IS the anchor.
 */ function $2c1ebc223ebddfd6$var$getPlacementAxisFloor(_ref6) {
    var minSize = _ref6.minSize, placementAxis = _ref6.placementAxis, placementAxisSize = _ref6.placementAxisSize, anchorValue = _ref6.anchorValue, gap = _ref6.gap, canFlip = _ref6.canFlip, writingMode = _ref6.writingMode;
    var anchorFloor = $2c1ebc223ebddfd6$var$getPlacementAxisAnchorFloor({
        placementAxis: placementAxis,
        placementAxisSize: placementAxisSize,
        anchorValue: anchorValue,
        canFlip: canFlip,
        writingMode: writingMode
    });
    if (minSize !== undefined) return anchorFloor === undefined ? minSize : "max(".concat(minSize, ", ").concat(anchorFloor, ")");
    if (anchorFloor !== undefined) return anchorFloor;
    if (!canFlip) return undefined;
    return $2c1ebc223ebddfd6$var$getDefaultPlacementAxisFloor({
        placementAxis: placementAxis,
        anchorValue: anchorValue,
        gap: gap,
        writingMode: writingMode
    });
}
function $2c1ebc223ebddfd6$export$860b30329fa0b990(_ref7) {
    var placement = _ref7.placement, inlineSize = _ref7.inlineSize, blockSize = _ref7.blockSize, isUsingCssAnchorPositioning = _ref7.isUsingCssAnchorPositioning, anchorSize = _ref7.anchorSize, writingMode = _ref7.writingMode, _ref7$shouldPreserveI = _ref7.shouldPreserveInlineSize, shouldPreserveInlineSize = _ref7$shouldPreserveI === void 0 ? false : _ref7$shouldPreserveI;
    var placementAxis = placement.axis;
    var crossAxis = $2c1ebc223ebddfd6$var$getCrossAxis(placementAxis);
    // Rule 1. Feeds the per-axis CAPS only.
    var size = {
        inline: inlineSize === 'content' && blockSize === 'max-available' ? 'max-available' : inlineSize,
        block: blockSize === 'content' && inlineSize === 'max-available' ? 'max-available' : blockSize
    };
    // Rule 2 reads the requested values instead, un-mirrored: flipping is a
    // whole-popover outcome, so a fit request on either axis turns the floor on.
    var isFitting = inlineSize === 'max-available' || blockSize === 'max-available';
    // ...but only where the floor is what causes the flip. On the JavaScript
    // fallback a floor only inflates the measured size the side is picked from, so
    // it would flip a popover that fits.
    var canFlip = isFitting && isUsingCssAnchorPositioning;
    var declarations = [
        // Rule 3: both caps are always written. Only the placement axis can take the
        // cell cap.
        {
            property: "max-".concat(placementAxis, "-size"),
            value: size[placementAxis] === 'max-available' && isUsingCssAnchorPositioning ? $2c1ebc223ebddfd6$var$cellCap({
                gap: placement.offset.gap
            }) : $2c1ebc223ebddfd6$var$viewportCap({
                axis: placementAxis,
                writingMode: writingMode
            })
        },
        {
            property: "max-".concat(crossAxis, "-size"),
            value: $2c1ebc223ebddfd6$var$viewportCap({
                axis: crossAxis,
                writingMode: writingMode
            })
        }
    ];
    // Rule 4. Only for a non-anchor-relative inline axis, so `'match-anchor'` below
    // stays the one writer of `inline-size` when it applies. CSS path only: the
    // fallback's containing block is the viewport, where shrink-to-fit already IS
    // the natural width for anything that fits on screen.
    if (isUsingCssAnchorPositioning && !shouldPreserveInlineSize && (size.inline === 'content' || size.inline === 'max-available')) declarations.push({
        property: 'inline-size',
        value: 'max-content'
    });
    // A max beats a definite size, so the caps above still win over this.
    for(var _i = 0, _arr = [
        placementAxis,
        crossAxis
    ]; _i < _arr.length; _i++){
        var axis = _arr[_i];
        var anchorValue = anchorSize[axis];
        if (size[axis] === 'match-anchor' && anchorValue !== null) declarations.push({
            property: "".concat(axis, "-size"),
            value: anchorValue
        });
    }
    var placementAxisFloor = $2c1ebc223ebddfd6$var$getPlacementAxisFloor({
        minSize: placement.minSize,
        placementAxis: placementAxis,
        placementAxisSize: size[placementAxis],
        anchorValue: anchorSize[placementAxis],
        gap: placement.offset.gap,
        canFlip: canFlip,
        writingMode: writingMode
    });
    if (placementAxisFloor !== undefined) declarations.push({
        property: "min-".concat(placementAxis, "-size"),
        value: placementAxisFloor
    });
    // A size contract, not a flip driver, so it is clamped to the cap.
    var crossAxisAnchorValue = anchorSize[crossAxis];
    if (size[crossAxis] === 'min-anchor' && crossAxisAnchorValue !== null) declarations.push({
        property: "min-".concat(crossAxis, "-size"),
        value: "min(".concat(crossAxisAnchorValue, ", ").concat($2c1ebc223ebddfd6$var$viewportCap({
            axis: crossAxis,
            writingMode: writingMode
        }), ")")
    });
    return declarations;
}


/**
 * Every logical margin property the fit recipe can write. Declared here and
 * imported by `edge-margin.tsx` and `cross-axis-shift-margins.tsx`: two
 * structurally identical declarations are interchangeable to the compiler, so a
 * divergence would surface only as a silently-ignored property name at
 * `setStyle`.
 */ /**
 * The cross-axis sides that face the viewport rather than the anchor, and so take
 * the reserved padding.
 *
 * A `span-*` cell aligns the popover's MARGIN box to the anchor's edge, so padding
 * on the anchor-facing side does not reserve space at the viewport: it insets the
 * border box from the edge the consumer asked it to line up with. A centred
 * popover has no anchor-facing side, and padding both keeps the shift pair
 * antisymmetric so `anchor-center` still centres.
 *
 * Known cost: the slide fallbacks do not swap the inline margins the way
 * `flip-inline` does, so a slid popover keeps its padding on the anchor side (or,
 * re-centred, sits 2.5px off centre). Alignment in the requested position wins.
 */ function $e16fdc4c177b843c$var$viewportFacingCrossAxisSides(_ref) {
    var align = _ref.align;
    if (align === 'center') return [
        'start',
        'end'
    ];
    // `align: 'start'` sits on the anchor's start edge and expands toward end.
    return [
        align === 'start' ? 'end' : 'start'
    ];
}
function $e16fdc4c177b843c$export$a7ffde4a856e8d8e(_ref2) {
    var placement = _ref2.placement, crossAxisShiftMargins = _ref2.crossAxisShiftMargins;
    var crossAxis = placement.axis === 'block' ? 'inline' : 'block';
    var paddedProperties = new Set($e16fdc4c177b843c$var$viewportFacingCrossAxisSides({
        align: placement.align
    }).map(function(side) {
        return "margin-".concat(crossAxis, "-").concat(side);
    }));
    return [
        {
            property: "margin-".concat(placement.axis, "-").concat(placement.edge),
            value: (0, $2c1ebc223ebddfd6$export$9f2fdbacbc62226e)
        }
    ].concat((0, $b4770e67e780c426$export$2e2bcd8739ae039)(crossAxisShiftMargins.map(function(_ref3) {
        var property = _ref3.property, value = _ref3.value;
        return paddedProperties.has(property) ? {
            property: property,
            value: "calc(".concat(value, " + ").concat((0, $2c1ebc223ebddfd6$export$9f2fdbacbc62226e), ")")
        } : {
            property: property,
            value: value
        };
    })));
}


/**
 * The `anchor-name` an element already carries, or `null`. Computed as well as
 * inline, so a name set from a STYLESHEET is found: a minted inline name would
 * otherwise override it for every other rule anchored to that element.
 * `anchor-name` is a list and `position-anchor` takes one ident, so the first
 * name is the one to anchor to.
 */ function $35802e1bbc774f60$export$948d15b01d509455(element) {
    var declared = element.style.getPropertyValue('anchor-name') || getComputedStyle(element).getPropertyValue('anchor-name');
    var first = declared.split(',')[0].trim();
    return first !== '' && first !== 'none' ? first : null;
}


/**
 * Resolves a placement to CSS `position-area` syntax.
 *
 * The `align` field represents the *visual* alignment:
 * - `align: 'start'` means "aligned to the trigger's start edge" (left in LTR for block axis)
 * - `align: 'end'` means "aligned to the trigger's end edge"
 * - `align: 'center'` means centered (single-axis position-area)
 *
 * CSS `position-area` uses `span-*` keywords which indicate the *expansion direction*.
 * Visual start-alignment requires `span-{cross-axis}-end` (expand toward end = start-aligned).
 * This function handles the inversion internally.
 *
 * Takes the RESOLVED placement, which the hook threads through positioning,
 * sizing and margins alike, so nothing here can disagree with them.
 *
 * @example
 * // For a `block-end` placement, by `align`:
 * // 'center' → 'block-end'
 * // 'start'  → 'block-end span-inline-end'
 * // 'end'    → 'block-end span-inline-start'
 */ function $580fe2e784f7f09c$export$de49b61f233ddeb9(_ref) {
    var placement = _ref.placement;
    var axis = placement.axis, edge = placement.edge, align = placement.align;
    var edgeValue = "".concat(axis, "-").concat(edge);
    if (align === 'center') return edgeValue;
    // Cross-axis name: block ↔ inline
    var crossAxis = axis === 'block' ? 'inline' : 'block';
    // Invert align → CSS span direction: visual 'start' → span toward 'end'
    var spanDir = align === 'start' ? 'end' : 'start';
    return "".concat(edgeValue, " span-").concat(crossAxis, "-").concat(spanDir);
}


/**
 * The placement axis joined to its edge, e.g. `block-end`.
 */ /**
 * The cells to slide to along one edge, on the cross axis.
 *
 * A try option is only worth listing if its margin box can fit where an earlier
 * one did not, and two options over the SAME cell have the same margin box and
 * the same fit result. That rules out three cells for an aligned placement: the
 * near span on the requested edge IS the base position-area, and on the opposite
 * edge the near and far spans are where `flip-{A}` and the diagonal flip land.
 *
 * A centred placement has no near or far, so it slides to both spans on both
 * edges.
 */ function $d8b4519149c7f271$var$slideOnEdge(_ref) {
    var align = _ref.align, edgeKey = _ref.edgeKey, crossAxis = _ref.crossAxis, isOppositeEdge = _ref.isOppositeEdge;
    if (align === 'center') return [
        "".concat(edgeKey, " span-").concat(crossAxis, "-end"),
        "".concat(edgeKey, " span-").concat(crossAxis, "-start")
    ];
    if (isOppositeEdge) return [
        edgeKey
    ];
    // For `align: 'start'` the popover expands toward `end`, so the far span is
    // `start`; `align: 'end'` mirrors this.
    var far = align === 'start' ? 'start' : 'end';
    return [
        edgeKey,
        "".concat(edgeKey, " span-").concat(crossAxis, "-").concat(far)
    ];
}
function $d8b4519149c7f271$var$flipDiagonally(_ref2) {
    var axis = _ref2.axis;
    var flipOnMainAxis = axis === 'block' ? 'flip-block' : 'flip-inline';
    var flipToCrossAxis = axis === 'block' ? 'flip-inline' : 'flip-block';
    return "".concat(flipOnMainAxis, " ").concat(flipToCrossAxis);
}
function $d8b4519149c7f271$export$c4e16947a95d61f1(_ref3) {
    var placement = _ref3.placement;
    var axis = placement.axis, edge = placement.edge, align = placement.align;
    var crossAxis = axis === 'block' ? 'inline' : 'block';
    var flippedEdge = edge === 'start' ? 'end' : 'start';
    var sameEdgeArea = "".concat(axis, "-").concat(edge);
    var oppositeEdgeArea = "".concat(axis, "-").concat(flippedEdge);
    var flipOnMainAxis = axis === 'block' ? 'flip-block' : 'flip-inline';
    return [
        $d8b4519149c7f271$var$slideOnEdge({
            align: align,
            edgeKey: sameEdgeArea,
            crossAxis: crossAxis,
            isOppositeEdge: false
        }),
        flipOnMainAxis,
        align !== 'center' ? $d8b4519149c7f271$var$flipDiagonally({
            axis: axis
        }) : null,
        $d8b4519149c7f271$var$slideOnEdge({
            align: align,
            edgeKey: oppositeEdgeArea,
            crossAxis: crossAxis,
            isOppositeEdge: true
        })
    ].filter(Boolean).flat().join(', ');
}


function $2a131d5196bd59db$export$50da8074e1408934(_ref) {
    var anchor = _ref.anchor, popover = _ref.popover, placement = _ref.placement, sizeStyles = _ref.sizeStyles, isFitting = _ref.isFitting, fallbackAnchorName = _ref.fallbackAnchorName;
    // Reuse rather than mint: another popover may already be anchored to it, or a
    // CONSUMER may have set it on their own element, as `post-office` does.
    var existingAnchorName = (0, $35802e1bbc774f60$export$948d15b01d509455)(anchor);
    var anchorName = existingAnchorName !== null && existingAnchorName !== void 0 ? existingAnchorName : fallbackAnchorName;
    var gap = (0, $5396def1eca52f22$export$b94d052c6b40496)({
        placement: placement,
        offset: placement.offset.gap
    });
    var crossAxisShift = (0, $2ea5365bb162e2ba$export$f7505ccec0897ae3)({
        placement: placement,
        crossAxisShiftCssValue: placement.offset.crossAxisShift.value,
        direction: placement.offset.crossAxisShift.direction
    });
    var popoverStyles = [
        {
            property: 'position-anchor',
            value: anchorName
        },
        {
            property: 'position-area',
            value: (0, $580fe2e784f7f09c$export$de49b61f233ddeb9)({
                placement: placement
            })
        },
        {
            property: 'position-try-fallbacks',
            value: (0, $d8b4519149c7f271$export$c4e16947a95d61f1)({
                placement: placement
            })
        },
        /**
   * **`position-visibility: always`**
   *
   * `position-visibility` is used to control the visibility of an anchored
   * popover based on the visibility of the element being anchored to (the target).
   *
   * Default `position-visibility` value: `anchors-visible` → hide the anchored
   * popover when the target is fully clipped by an ancestor (eg a scroll container)
   * or is `visibility:hidden`.
   * Sadly this "automatic hiding" does not actually "close" the popover,
   * so things like `:popover-open` are still active, even though the popover
   * is no longer painted and no longer receives pointer input. Chrome keeps it
   * focusable and in the accessibility tree, so keyboard and screen reader users
   * can still land inside a surface that is not painted.
   * Per-engine behaviour: `notes/decisions/position-visibility-always.md`.
   *
   * Generally we have not run into issues with the default (`anchors-visible`)
   *
   * Exceptions:
   *  - Target is intentionally not visible (eg `position:absolute` moving it outside of
   *    its parent's "clipped boundary", or a `visibility:hidden` trigger)
   *  - A trigger is scrolled out of its scroll container while the popover is open.
   *
   * We are switching from `anchors-visible` → `always` _for now_ to force no
   * automatic hiding of the popover. There seems to be no compelling reason to use
   * the default value. If one arises in the future, we could look towards making
   *  this behaviour configurable.
   */ {
            property: 'position-visibility',
            value: 'always'
        },
        // Reset browser default popover positioning that conflicts
        // with anchor positioning (UA: `inset: 0; margin: auto;`)
        {
            property: 'margin',
            value: '0'
        },
        {
            property: 'inset',
            value: 'auto'
        },
        gap
    ].concat((0, $b4770e67e780c426$export$2e2bcd8739ae039)(isFitting ? (0, $e16fdc4c177b843c$export$a7ffde4a856e8d8e)({
        placement: placement,
        crossAxisShiftMargins: crossAxisShift
    }) : crossAxisShift), (0, $b4770e67e780c426$export$2e2bcd8739ae039)(sizeStyles));
    // Anchor names are never cleaned up: multiple popovers can share an anchor,
    // and even with reference counting an async React update could remove the name
    // while something else still uses it. See
    // `notes/decisions/anchor-name-lifetime.md`. Only written when minted: a name
    // from a stylesheet may be a list, which an inline copy of its first entry
    // would collapse.
    if (existingAnchorName === null) anchor.style.setProperty('anchor-name', anchorName);
    return (0, $1e1fef10dc605e8f$export$37a5fde709c1db82)({
        element: popover,
        styles: popoverStyles
    });
}






/**
 * Combine multiple cleanup functions into a single cleanup function.
 *
 * @example
 * ```ts
 * useEffect(() => {
 *   return combine(
 *     bind(window, { type: 'resize', listener: onResize }),
 *     bind(window, { type: 'scroll', listener: onScroll, options: { capture: true } }),
 *   );
 * }, []);
 * ```
 */ function $b477d48968bffe01$export$1be1fc439b849fdf() {
    for(var _len = arguments.length, cleanupFns = new Array(_len), _key = 0; _key < _len; _key++)cleanupFns[_key] = arguments[_key];
    return function cleanup() {
        cleanupFns.forEach(function(callback) {
            return callback === null || callback === void 0 ? void 0 : callback();
        });
    };
}




function $206d486dd19e7e45$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $206d486dd19e7e45$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $206d486dd19e7e45$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $a48c245bf23e2005$export$2e2bcd8739ae039)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $206d486dd19e7e45$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
/**
 * A viewport-relative position, in pixels. Physical rather than logical
 * because it is written straight to `top` / `left`.
 */ /**
 * `TCrossAxisShiftOffset` with its CSS length already resolved to pixels. Only
 * this module needs the pixel form, because only this module does arithmetic.
 */ /**
 * Computes the base {top, left} position based on the primary edge,
 * flipping to the opposite side when there is not enough space.
 *
 * `gap` is applied along the main axis between trigger and popover.
 */ function $206d486dd19e7e45$var$computeEdgePosition(_ref) {
    var axis = _ref.axis, edge = _ref.edge, triggerRect = _ref.triggerRect, popoverWidth = _ref.popoverWidth, popoverHeight = _ref.popoverHeight, viewport = _ref.viewport, gap = _ref.gap;
    if (axis === 'block' && edge === 'end') {
        // Below trigger
        var spaceBelow = viewport.height - triggerRect.bottom;
        var spaceAbove = triggerRect.top;
        var fitsBelow = spaceBelow >= popoverHeight + gap;
        var useBelow = fitsBelow || spaceBelow >= spaceAbove;
        return {
            top: useBelow ? triggerRect.bottom + gap : triggerRect.top - popoverHeight - gap,
            left: triggerRect.left + triggerRect.width / 2 - popoverWidth / 2
        };
    }
    if (axis === 'block' && edge === 'start') {
        // Above trigger
        var _spaceAbove = triggerRect.top;
        var _spaceBelow = viewport.height - triggerRect.bottom;
        var fitsAbove = _spaceAbove >= popoverHeight + gap;
        var useAbove = fitsAbove || _spaceAbove >= _spaceBelow;
        return {
            top: useAbove ? triggerRect.top - popoverHeight - gap : triggerRect.bottom + gap,
            left: triggerRect.left + triggerRect.width / 2 - popoverWidth / 2
        };
    }
    if (axis === 'inline' && edge === 'end') {
        // Right of trigger
        var spaceRight = viewport.width - triggerRect.right;
        var spaceLeft = triggerRect.left;
        var fitsRight = spaceRight >= popoverWidth + gap;
        var useRight = fitsRight || spaceRight >= spaceLeft;
        return {
            top: triggerRect.top + triggerRect.height / 2 - popoverHeight / 2,
            left: useRight ? triggerRect.right + gap : triggerRect.left - popoverWidth - gap
        };
    }
    if (axis === 'inline' && edge === 'start') {
        // Left of trigger
        var _spaceLeft = triggerRect.left;
        var _spaceRight = viewport.width - triggerRect.right;
        var fitsLeft = _spaceLeft >= popoverWidth + gap;
        var useLeft = fitsLeft || _spaceLeft >= _spaceRight;
        return {
            top: triggerRect.top + triggerRect.height / 2 - popoverHeight / 2,
            left: useLeft ? triggerRect.left - popoverWidth - gap : triggerRect.right + gap
        };
    }
    // Unreachable for valid placements; defaults to below trigger
    return {
        top: triggerRect.bottom + gap,
        left: triggerRect.left + triggerRect.width / 2 - popoverWidth / 2
    };
}
/**
 * Adjusts the base (centered) position for non-center alignments.
 *
 * `align: 'start'` → popover start edge at trigger start edge
 * `align: 'end'`   → popover end edge at trigger end edge
 */ function $206d486dd19e7e45$var$applyAlignment(_ref2) {
    var position = _ref2.position, axis = _ref2.axis, align = _ref2.align, triggerRect = _ref2.triggerRect, popoverWidth = _ref2.popoverWidth, popoverHeight = _ref2.popoverHeight;
    if (align === 'center') return position;
    if (axis === 'block') {
        // Block-axis placement → cross-axis is inline (left/right)
        if (align === 'start') return $206d486dd19e7e45$var$_objectSpread($206d486dd19e7e45$var$_objectSpread({}, position), {}, {
            left: triggerRect.left
        });
        // align === 'end'
        return $206d486dd19e7e45$var$_objectSpread($206d486dd19e7e45$var$_objectSpread({}, position), {}, {
            left: triggerRect.right - popoverWidth
        });
    }
    // Inline-axis placement → cross-axis is block (top/bottom)
    if (align === 'start') return $206d486dd19e7e45$var$_objectSpread($206d486dd19e7e45$var$_objectSpread({}, position), {}, {
        top: triggerRect.top
    });
    // align === 'end'
    return $206d486dd19e7e45$var$_objectSpread($206d486dd19e7e45$var$_objectSpread({}, position), {}, {
        top: triggerRect.bottom - popoverHeight
    });
}
/**
 * Applies the cross-axis shift offset. `forwards` always moves the popover
 * toward the cross-axis END, for every `align` value.
 *
 * Do not add a per-`align` sign inversion here. This is a coordinate, so the
 * direction is the sign and nothing else. The CSS path inverts only because an
 * END-side margin pushes a box the opposite way to a START-side one, which is a
 * property of margins.
 */ function $206d486dd19e7e45$var$applyCrossAxisShift(_ref3) {
    var position = _ref3.position, axis = _ref3.axis, crossAxisShift = _ref3.crossAxisShift;
    if (crossAxisShift.value === 0) return position;
    var directionSign = crossAxisShift.direction === 'forwards' ? 1 : -1;
    var delta = crossAxisShift.value * directionSign;
    // Cross-axis is the OPPOSITE of the placement axis.
    if (axis === 'block') return $206d486dd19e7e45$var$_objectSpread($206d486dd19e7e45$var$_objectSpread({}, position), {}, {
        left: position.left + delta
    });
    return $206d486dd19e7e45$var$_objectSpread($206d486dd19e7e45$var$_objectSpread({}, position), {}, {
        top: position.top + delta
    });
}
function $206d486dd19e7e45$export$d5ef1dac02135664(_ref4) {
    var triggerRect = _ref4.triggerRect, popoverEl = _ref4.popoverEl, placement = _ref4.placement, viewport = _ref4.viewport, gap = _ref4.gap, crossAxisShift = _ref4.crossAxisShift;
    var axis = placement.axis, edge = placement.edge, align = placement.align;
    // Measure popover dimensions. Callers must ensure the popover has
    // laid out before calling this (it should not be `display: none`).
    var popoverWidth = popoverEl.offsetWidth;
    var popoverHeight = popoverEl.offsetHeight;
    var basePosition = $206d486dd19e7e45$var$computeEdgePosition({
        axis: axis,
        edge: edge,
        triggerRect: triggerRect,
        popoverWidth: popoverWidth,
        popoverHeight: popoverHeight,
        viewport: viewport,
        gap: gap
    });
    var alignedPosition = $206d486dd19e7e45$var$applyAlignment({
        position: basePosition,
        axis: axis,
        align: align,
        triggerRect: triggerRect,
        popoverWidth: popoverWidth,
        popoverHeight: popoverHeight
    });
    var shiftedPosition = $206d486dd19e7e45$var$applyCrossAxisShift({
        position: alignedPosition,
        axis: axis,
        crossAxisShift: crossAxisShift
    });
    // Clamp to viewport so the popover is never offscreen
    return {
        top: Math.max(0, Math.min(shiftedPosition.top, viewport.height - popoverHeight)),
        left: Math.max(0, Math.min(shiftedPosition.left, viewport.width - popoverWidth))
    };
}



function $3d3dfc165926d794$export$e142245b95267f17(_ref) {
    var error = _ref.error;
    return;
}


/**
 * `null` when the environment cannot measure at all.
 */ function $e3209f3d48f9caf0$var$measureWithProbe(_ref) {
    var value = _ref.value, container = _ref.container;
    // Reached through the container rather than the global, so a popover in
    // another document still measures and one with no view degrades gracefully.
    var view = container.ownerDocument.defaultView;
    if (!view) return null;
    var probe = container.ownerDocument.createElement('div');
    probe.style.position = 'absolute';
    probe.style.visibility = 'hidden';
    probe.style.pointerEvents = 'none';
    probe.style.height = '0';
    probe.style.padding = '0';
    probe.style.border = '0';
    // `width` clamps negatives to 0; use `margin-left` instead so signs are
    // preserved. `getComputedStyle` returns the resolved pixel value for
    // margin-* properties even when the source was a token / calc / var.
    probe.style.marginLeft = value;
    // Hidden from assistive tech and event targeting; defensive against
    // `getElementsByTagName('div')` walks in consumer code.
    probe.setAttribute('aria-hidden', 'true');
    probe.setAttribute('inert', '');
    try {
        container.appendChild(probe);
        var resolved = parseFloat(view.getComputedStyle(probe).marginLeft);
        return Number.isFinite(resolved) ? resolved : 0;
    } catch (error) {
        (0, $3d3dfc165926d794$export$e142245b95267f17)({
            error: error
        });
        return null;
    } finally{
        // `remove()` rather than `removeChild()`: consumer code may already have
        // detached the probe, which must not throw out of a layout effect.
        probe.remove();
    }
}
function $e3209f3d48f9caf0$export$98721546d2816d9e(_ref2) {
    var _measureWithProbe;
    var value = _ref2.value, container = _ref2.container;
    if (typeof value === 'number') return value;
    // Fast path: consumers occasionally pass `'0'` instead of the number `0`.
    if (value === '0' || value === '-0') return 0;
    // Fast path: bare `${n}px` strings come from `resolvePlacement`, so this avoids
    // a reflow for the common case.
    var pxMatch = value.match(/^(-?\d+(?:\.\d+)?)px$/);
    if (pxMatch) return Number(pxMatch[1]);
    return (_measureWithProbe = $e3209f3d48f9caf0$var$measureWithProbe({
        value: value,
        container: container
    })) !== null && _measureWithProbe !== void 0 ? _measureWithProbe : 0;
}



/**
 * Wrapped because jsdom throws on the unknown `:popover-open` selector.
 */ function $4956d5a996113929$var$isPopoverOpen(popover) {
    try {
        return popover.matches(':popover-open');
    } catch (_unused) {
        return false;
    }
}
/**
 * Observes the popover until its first non-zero layout, then self-disconnects;
 * ongoing movement is handled by the scroll and resize listeners. The popover is
 * `display: none` until `showPopover()`, and some browsers fire `toggle` before
 * layout, so RAF-after-toggle is unreliable.
 *
 * `null` where `ResizeObserver` is missing (non-DOM jest environments). There is
 * then no measurement to wait for, so the caller positions immediately and must
 * not hide the popover, because no reveal would follow.
 */ function $4956d5a996113929$var$createFirstLayoutObserver(_ref) {
    var popover = _ref.popover, onFirstLayout = _ref.onFirstLayout;
    if (typeof ResizeObserver === 'undefined') return null;
    try {
        var observer = new ResizeObserver(function() {
            if (popover.offsetWidth > 0 && popover.offsetHeight > 0) {
                onFirstLayout();
                observer.disconnect();
            }
        });
        return observer;
    } catch (error) {
        (0, $3d3dfc165926d794$export$e142245b95267f17)({
            error: error
        });
        return null;
    }
}
function $4956d5a996113929$export$89babc4c2047d2ba(_ref2) {
    var anchor = _ref2.anchor, popover = _ref2.popover, placement = _ref2.placement, sizeStyles = _ref2.sizeStyles;
    // Already in the top layer via the `popover` attribute, so this only resets the
    // UA defaults and writes measured `top` / `left`.
    var cleanupBaseStyles = (0, $1e1fef10dc605e8f$export$37a5fde709c1db82)({
        element: popover,
        styles: [
            {
                property: 'margin',
                value: '0'
            },
            {
                property: 'inset',
                value: 'auto'
            }
        ].concat((0, $b4770e67e780c426$export$2e2bcd8739ae039)(sizeStyles))
    });
    // The popover can be consumer-owned (`@atlaskit/popper`'s `createPopper`),
    // so restore prior inline values rather than removing ours.
    var undoPosition;
    var undoHide;
    // Resolved once per open and per resize, reused across scrolls: resolving is a
    // full style and layout flush, and a scroll cannot change what a CSS length
    // resolves to. A resize can (viewport units), and so can a re-open (a token
    // retargeted while closed).
    var resolvedOffsets = null;
    function invalidateResolvedOffsets() {
        resolvedOffsets = null;
    }
    function getResolvedOffsets() {
        if (resolvedOffsets) return resolvedOffsets;
        // Probed INSIDE the popover: it is in the top layer, not the anchor's DOM
        // tree, so anywhere else resolves a token against a different scope.
        resolvedOffsets = {
            gap: (0, $e3209f3d48f9caf0$export$98721546d2816d9e)({
                value: placement.offset.gap,
                container: popover
            }),
            crossAxisShift: (0, $e3209f3d48f9caf0$export$98721546d2816d9e)({
                value: placement.offset.crossAxisShift.value,
                container: popover
            })
        };
        return resolvedOffsets;
    }
    function reveal() {
        var _undoHide;
        (_undoHide = undoHide) === null || _undoHide === void 0 || _undoHide();
        undoHide = undefined;
    }
    function restorePosition() {
        var _undoPosition;
        (_undoPosition = undoPosition) === null || _undoPosition === void 0 || _undoPosition();
        undoPosition = undefined;
    }
    // `opacity: 0` not `visibility: hidden`: Firefox skips visibility-hidden
    // elements during `<dialog>` initial-focus traversal.
    function hideUntilPositioned() {
        // Keep the first snapshot, else we capture our own `opacity: 0`.
        if (undoHide) return;
        undoHide = (0, $1e1fef10dc605e8f$export$37a5fde709c1db82)({
            element: popover,
            styles: [
                {
                    property: 'opacity',
                    value: '0'
                }
            ]
        });
    }
    /**
   * Last resort. The base styles above reset the UA
   * `[popover] { inset: 0; margin: auto }`, so a popover with no `top` / `left`
   * sits in the viewport corner rather than centred.
   */ function centerInViewport() {
        restorePosition();
        undoPosition = (0, $1e1fef10dc605e8f$export$37a5fde709c1db82)({
            element: popover,
            styles: [
                {
                    property: 'inset',
                    value: '0'
                },
                {
                    property: 'margin',
                    value: 'auto'
                }
            ]
        });
    }
    function update() {
        try {
            var triggerRect = anchor.getBoundingClientRect();
            var viewport = {
                width: window.innerWidth,
                height: window.innerHeight
            };
            var _getResolvedOffsets = getResolvedOffsets(), gap = _getResolvedOffsets.gap, crossAxisShift = _getResolvedOffsets.crossAxisShift;
            var _computeFallbackPosit = (0, $206d486dd19e7e45$export$d5ef1dac02135664)({
                triggerRect: triggerRect,
                popoverEl: popover,
                placement: placement,
                viewport: viewport,
                gap: gap,
                crossAxisShift: {
                    value: crossAxisShift,
                    direction: placement.offset.crossAxisShift.direction
                }
            }), top = _computeFallbackPosit.top, left = _computeFallbackPosit.left;
            // A non-finite coordinate serialises to a declaration the browser drops,
            // landing the popover in the corner just as silently as a throw would.
            if (!Number.isFinite(top) || !Number.isFinite(left)) {
                centerInViewport();
                return;
            }
            // Restore first so the snapshot stays the consumer's value.
            restorePosition();
            undoPosition = (0, $1e1fef10dc605e8f$export$37a5fde709c1db82)({
                element: popover,
                styles: [
                    {
                        property: 'top',
                        value: "".concat(top, "px")
                    },
                    {
                        property: 'left',
                        value: "".concat(left, "px")
                    }
                ]
            });
        } catch (error) {
            (0, $3d3dfc165926d794$export$e142245b95267f17)({
                error: error
            });
            // Anchoring needs the trigger geometry we just failed to get, so the
            // centred position is the only one left to degrade to.
            try {
                centerInViewport();
            } catch (_unused2) {}
        } finally{
            // Unconditional. A popover in the wrong place is recoverable on the
            // next scroll or resize; one left at `opacity: 0` is invisible forever.
            reveal();
        }
    }
    function invalidateAndUpdate() {
        invalidateResolvedOffsets();
        update();
    }
    // One update per animation frame. Scroll reuses the resolved offsets; resize
    // re-resolves them.
    var scheduledScrollUpdate = (0, $2fb72d4a32455831$export$2e2bcd8739ae039)(update);
    var scheduledResizeUpdate = (0, $2fb72d4a32455831$export$2e2bcd8739ae039)(invalidateAndUpdate);
    var firstLayoutObserver = $4956d5a996113929$var$createFirstLayoutObserver({
        popover: popover,
        onFirstLayout: update
    });
    function positionOnNextLayout() {
        // A token can have been retargeted while the popover was closed, so each
        // open re-resolves the offsets.
        invalidateResolvedOffsets();
        // No observer means no measurement is coming: position now, and do not
        // hide, because the reveal would never arrive.
        if (!firstLayoutObserver) {
            update();
            return;
        }
        hideUntilPositioned();
        firstLayoutObserver.observe(popover);
    }
    // The popover can already be open when this runs, in which case the initial
    // `toggle` has fired and the listener below would miss it.
    if ($4956d5a996113929$var$isPopoverOpen(popover)) positionOnNextLayout();
    return (0, $b477d48968bffe01$export$1be1fc439b849fdf)(cleanupBaseStyles, // Each open needs a fresh measurement, so hide and re-observe.
    (0, $5b617c1f48263075$exports.bind)(popover, {
        type: 'toggle',
        listener: function listener(event) {
            var toggleEvent = event;
            if (toggleEvent.newState === 'open') positionOnNextLayout();
        }
    }), function() {
        return firstLayoutObserver === null || firstLayoutObserver === void 0 ? void 0 : firstLayoutObserver.disconnect();
    }, (0, $5b617c1f48263075$exports.bind)(window, {
        type: 'scroll',
        listener: scheduledScrollUpdate,
        options: {
            capture: true,
            passive: true
        }
    }), (0, $5b617c1f48263075$exports.bind)(window, {
        type: 'resize',
        listener: scheduledResizeUpdate,
        options: {
            passive: true
        }
    }), function() {
        scheduledScrollUpdate.cancel();
        scheduledResizeUpdate.cancel();
        restorePosition();
        reveal();
    });
}




function $d4cc896e3f7d6420$export$69de71b4b7c76bad(_ref) {
    var property = _ref.property, value = _ref.value;
    return (0, $86089df3a0fd54eb$export$2e2bcd8739ae039)(function supportsCssDeclaration() {
        if (typeof window === 'undefined' || typeof CSS === 'undefined' || typeof CSS.supports !== 'function') return false;
        return CSS.supports(property, value);
    });
}


var $74ac6c5ed01e5d60$export$7192e63dfa9e8124 = (0, $d4cc896e3f7d6420$export$69de71b4b7c76bad)({
    property: 'anchor-name',
    value: '--a'
});



var $b9c034fbc3dbcf31$export$1c8dd0d1c9df9c6e = (0, $d4cc896e3f7d6420$export$69de71b4b7c76bad)({
    property: 'min-inline-size',
    value: 'anchor-size(self-inline)'
});


/**
 * Which way the popover's inline axis runs. Maps every physical measurement below
 * onto a logical axis: the viewport unit of each cap and the anchor's measured
 * size. A style read, not a layout read, so it is cheap enough to take for every
 * popover.
 */ function $a9a4e179f55dac8b$var$getPopoverWritingMode(_ref) {
    var popover = _ref.popover;
    // `String()` because not every test environment implements `writing-mode`.
    var writingMode = String(getComputedStyle(popover).writingMode);
    var isVertical = writingMode.startsWith('vertical') || writingMode.startsWith('sideways');
    return isVertical ? 'vertical' : 'horizontal';
}
/**
 * Measured stand-in for `anchor-size(self-*)`, used wherever `anchor-size()` is
 * not: the JavaScript fallback, and browsers with anchor positioning but no
 * `anchor-size()`.
 *
 * `offsetWidth` / `offsetHeight` are physical, so the axis is picked from the
 * POPOVER's `writing-mode`. Deliberately not memoized: a cached anchor size is a
 * stale one. Runs once per effect, not per frame.
 */ function $a9a4e179f55dac8b$var$measureAnchorSize(_ref2) {
    var anchor = _ref2.anchor, writingMode = _ref2.writingMode;
    if (writingMode === 'vertical') return {
        inline: "".concat(anchor.offsetHeight, "px"),
        block: "".concat(anchor.offsetWidth, "px")
    };
    return {
        inline: "".concat(anchor.offsetWidth, "px"),
        block: "".concat(anchor.offsetHeight, "px")
    };
}
var $a9a4e179f55dac8b$var$NO_ANCHOR_SIZE = {
    inline: null,
    block: null
};
var $a9a4e179f55dac8b$var$CSS_ANCHOR_SIZE = {
    inline: 'anchor-size(self-inline)',
    block: 'anchor-size(self-block)'
};
function $a9a4e179f55dac8b$var$isAnchorRelative(size) {
    return size === 'match-anchor' || size === 'min-anchor';
}
/**
 * The `anchor-name` written to an anchor that does not already carry one, as a CSS
 * `<dashed-ident>`. `useId()` is the same source as every other id in the design
 * system, including the popover's own `id` that `aria-controls` and `popovertarget`
 * point at, so it is unique exactly where those are and collides exactly where
 * they do. See `useAnchoredPopover` for the one case that needs the host's help.
 *
 * `@atlaskit/ds-lib`'s `useId` already swaps React's `:` and `«»` for `_`. The
 * replace covers a host `identifierPrefix`, which may carry characters a
 * `<dashed-ident>` cannot.
 */ function $a9a4e179f55dac8b$var$useNewAnchorName() {
    var id = (0, $c797bf80d6171378$export$f680877a34711e37)();
    return (0, $5FkrB.useMemo)(function() {
        return "--anchor-".concat(id.replace(/[^A-Za-z0-9_-]/g, '_'));
    }, [
        id
    ]);
}
/**
 * A referentially-stable, fully-resolved `TPlacement`, so a fresh inline
 * `placement` object does not re-run the effect.
 */ function $a9a4e179f55dac8b$var$useStablePlacement(placement) {
    var resolved = (0, $22e1c0cfc4927867$export$63044d21bc3d3fa2)({
        placement: placement
    });
    var axis = resolved.axis;
    var edge = resolved.edge;
    var align = resolved.align;
    var minSize = resolved.minSize;
    var gap = resolved.offset.gap;
    var shiftValue = resolved.offset.crossAxisShift.value;
    var shiftDirection = resolved.offset.crossAxisShift.direction;
    // Rebuilt from primitive deps, so the factory does not close over `resolved`
    // and exhaustive-deps can verify it.
    return (0, $5FkrB.useMemo)(function() {
        return {
            axis: axis,
            edge: edge,
            align: align,
            minSize: minSize,
            offset: {
                gap: gap,
                crossAxisShift: {
                    value: shiftValue,
                    direction: shiftDirection
                }
            }
        };
    }, [
        axis,
        edge,
        align,
        minSize,
        gap,
        shiftValue,
        shiftDirection
    ]);
}
function $a9a4e179f55dac8b$export$147d8888d96bf7a3(_ref3) {
    var anchorRef = _ref3.anchorRef, popoverRef = _ref3.popoverRef, placement = _ref3.placement, isOpen = _ref3.isOpen, _ref3$isEnabled = _ref3.isEnabled, isEnabled = _ref3$isEnabled === void 0 ? true : _ref3$isEnabled, _ref3$inlineSize = _ref3.inlineSize, inlineSize = _ref3$inlineSize === void 0 ? 'content' : _ref3$inlineSize, _ref3$blockSize = _ref3.blockSize, blockSize = _ref3$blockSize === void 0 ? 'content' : _ref3$blockSize, _ref3$shouldPreserveI = _ref3.shouldPreserveInlineSize, shouldPreserveInlineSize = _ref3$shouldPreserveI === void 0 ? false : _ref3$shouldPreserveI, _ref3$forceFallbackPo = _ref3.forceFallbackPositioning, forceFallbackPositioning = _ref3$forceFallbackPo === void 0 ? false : _ref3$forceFallbackPo;
    // Stable for the life of the hook instance, so it follows a replacement anchor
    // element (the point hook remounts its `<div>`).
    var fallbackAnchorName = $a9a4e179f55dac8b$var$useNewAnchorName();
    var stablePlacement = $a9a4e179f55dac8b$var$useStablePlacement(placement);
    (0, $5FkrB.useLayoutEffect)(function() {
        if (!isEnabled) return;
        // Resolved once, so positioning, sizing and margins cannot disagree about it.
        var isUsingCssAnchorPositioning = (0, $74ac6c5ed01e5d60$export$7192e63dfa9e8124)() && !forceFallbackPositioning;
        // BOTH probes: a browser can have positioning without sizing, and
        // `anchor-size()` needs the `position-anchor` only the CSS path writes.
        var canUseAnchorSize = isUsingCssAnchorPositioning && (0, $b9c034fbc3dbcf31$export$1c8dd0d1c9df9c6e)();
        var trigger = anchorRef.current;
        var popover = popoverRef.current;
        if (!trigger || !popover) return;
        // Fitting also reserves padding from the viewport edge as a margin.
        var isFitting = inlineSize === 'max-available' || blockSize === 'max-available';
        // Always read: the viewport caps are always written, and their unit follows
        // the popover's writing mode.
        var writingMode = $a9a4e179f55dac8b$var$getPopoverWritingMode({
            popover: popover
        });
        // Skipped where possible, so a position-only consumer pays no layout read.
        // Fitting on the CSS path needs it to clamp the default flip floor; see
        // `getDefaultPlacementAxisFloor`.
        var needsAnchorSize = $a9a4e179f55dac8b$var$isAnchorRelative(inlineSize) || $a9a4e179f55dac8b$var$isAnchorRelative(blockSize) || isFitting && isUsingCssAnchorPositioning;
        var anchorSize = needsAnchorSize ? canUseAnchorSize ? $a9a4e179f55dac8b$var$CSS_ANCHOR_SIZE : $a9a4e179f55dac8b$var$measureAnchorSize({
            anchor: trigger,
            writingMode: writingMode
        }) : $a9a4e179f55dac8b$var$NO_ANCHOR_SIZE;
        var sizeStyles = (0, $2c1ebc223ebddfd6$export$860b30329fa0b990)({
            placement: stablePlacement,
            inlineSize: inlineSize,
            blockSize: blockSize,
            isUsingCssAnchorPositioning: isUsingCssAnchorPositioning,
            anchorSize: anchorSize,
            writingMode: writingMode,
            shouldPreserveInlineSize: shouldPreserveInlineSize
        });
        if (isUsingCssAnchorPositioning) return (0, $2a131d5196bd59db$export$50da8074e1408934)({
            anchor: trigger,
            popover: popover,
            placement: stablePlacement,
            sizeStyles: sizeStyles,
            isFitting: isFitting,
            fallbackAnchorName: fallbackAnchorName
        });
        return (0, $4956d5a996113929$export$89babc4c2047d2ba)({
            anchor: trigger,
            popover: popover,
            placement: stablePlacement,
            sizeStyles: sizeStyles
        });
    }, [
        isEnabled,
        anchorRef,
        popoverRef,
        stablePlacement,
        inlineSize,
        blockSize,
        shouldPreserveInlineSize,
        fallbackAnchorName,
        forceFallbackPositioning,
        isOpen
    ]);
}


var $1edbb35a3273a726$var$menuScope = '[role="menu"]';
/**
 * Recursively walks from `node` toward `container`, returning `true` when
 * `container` is reached without crossing another `role="menu"` ancestor.
 *
 * Used by `isAtCurrentMenuLevel` (pattern 2) to determine if the
 * `closestMenu` is owned by the wrapper container directly. Recursion
 * avoids a mutable `let parent` walk and keeps the function body linear.
 */ function $1edbb35a3273a726$var$reachesContainerWithoutNestedMenu(node, container) {
    if (!node || node === container) return node === container;
    if (node.getAttribute('role') === 'menu') return false;
    return $1edbb35a3273a726$var$reachesContainerWithoutNestedMenu(node.parentElement, container);
}
function $1edbb35a3273a726$export$f1bba0ef464d60af(element, container) {
    var closestMenu = element.closest($1edbb35a3273a726$var$menuScope);
    // Container itself has role="menu". Element belongs to this level
    // if its closest menu is the container.
    if (container.getAttribute('role') === 'menu') return closestMenu === container;
    // Container is a wrapper without role="menu" (e.g. dropdown-menu
    // wraps a MenuGroup). The element belongs to the top level if its
    // closest role="menu" ancestor is a direct child of the container,
    // i.e. there is no nested role="menu" between them.
    if (closestMenu === null) return true;
    // Walk up from the closest menu to see if it is "owned" by this
    // container without passing through another role="menu" first.
    return $1edbb35a3273a726$var$reachesContainerWithoutNestedMenu(closestMenu.parentElement, container);
}



var $5FkrB = parcelRequire("5FkrB");






var $4023a433327edc3e$var$menuScope = '[role="menu"]';
function $4023a433327edc3e$export$23dfbae28e0cc453(_ref) {
    var containerRef = _ref.containerRef, onClose = _ref.onClose, onNestedOpen = _ref.onNestedOpen, onNestedClose = _ref.onNestedClose, _ref$isEnabled = _ref.isEnabled, isEnabled = _ref$isEnabled === void 0 ? true : _ref$isEnabled, filter = _ref.filter;
    var handleKeyDown = (0, $5FkrB.useCallback)(function(event) {
        var _getDocument;
        var container = containerRef.current;
        if (!container) return;
        // Guard: only handle the event if the currently focused element
        // belongs to this menu level. The focused element's closest
        // [role="menu"] must be this container (not a nested sub-menu).
        // When no filter is provided, fall back to the closest-menu check
        // if the container has role="menu".
        var focused = (_getDocument = (0, $fc5ac9c99de29fbb$export$f65ca476c09acec0)()) === null || _getDocument === void 0 ? void 0 : _getDocument.activeElement;
        if (focused instanceof HTMLElement) {
            if (filter) {
                if (!filter(focused, container)) return;
            }
            if (!filter && container.getAttribute('role') === 'menu' && focused.closest($4023a433327edc3e$var$menuScope) !== container) return;
        }
        if (event.key === (0, $f8dc452a9f988247$export$a80636c6f41931fe)) {
            var _getNextFocusable;
            // Prevent page scroll while navigating menu items.
            event.preventDefault();
            (_getNextFocusable = (0, $2fce1a829520f0be$export$a7db88e6d491b450)({
                container: container,
                direction: 'forwards',
                filter: filter
            })) === null || _getNextFocusable === void 0 || _getNextFocusable.focus();
            return;
        }
        if (event.key === (0, $f8dc452a9f988247$export$390330c10ff2b9a1)) {
            var _getNextFocusable2;
            // Prevent page scroll while navigating menu items.
            event.preventDefault();
            (_getNextFocusable2 = (0, $2fce1a829520f0be$export$a7db88e6d491b450)({
                container: container,
                direction: 'backwards',
                filter: filter
            })) === null || _getNextFocusable2 === void 0 || _getNextFocusable2.focus();
            return;
        }
        if (event.key === (0, $f8dc452a9f988247$export$4af703091671bc)) {
            var _getFirstFocusable;
            // Prevent browser default (e.g. scrolling to top of page).
            event.preventDefault();
            (_getFirstFocusable = (0, $0e5e27f156f9e55c$export$748138f04a69bf21)({
                container: container,
                filter: filter
            })) === null || _getFirstFocusable === void 0 || _getFirstFocusable.focus();
            return;
        }
        if (event.key === (0, $f8dc452a9f988247$export$e2bc30913faa5db7)) {
            var _getLastFocusable;
            // Prevent browser default (e.g. scrolling to bottom of page).
            event.preventDefault();
            (_getLastFocusable = (0, $438b65b604e8b00d$export$73e81fa65335a75b)({
                container: container,
                filter: filter
            })) === null || _getLastFocusable === void 0 || _getLastFocusable.focus();
            return;
        }
        if (event.key === (0, $f8dc452a9f988247$export$10f6869ed0a7d75b)) {
            onClose();
            return;
        }
        // ── Nested menu navigation (WAI-ARIA menu pattern) ──
        // ArrowRight on a menuitem with aria-haspopup opens the submenu.
        if (event.key === 'ArrowRight') {
            if (onNestedOpen && focused instanceof HTMLElement && focused.hasAttribute('aria-haspopup')) {
                event.preventDefault();
                onNestedOpen({
                    trigger: focused
                });
            }
            return;
        }
        // ArrowLeft closes the current menu if it is nested inside a parent menu.
        if (event.key === 'ArrowLeft') {
            if (onNestedClose) {
                var _container$parentElem;
                // Only close if this container is inside another role="menu"
                // (i.e. it is a submenu, not the top-level menu).
                // Walk up from the parent to avoid matching the container itself.
                var isNested = ((_container$parentElem = container.parentElement) === null || _container$parentElem === void 0 ? void 0 : _container$parentElem.closest($4023a433327edc3e$var$menuScope)) !== null;
                if (isNested) {
                    event.preventDefault();
                    onNestedClose();
                }
            }
            return;
        }
    }, [
        containerRef,
        onClose,
        onNestedOpen,
        onNestedClose,
        filter
    ]);
    (0, $5FkrB.useEffect)(function() {
        var container = containerRef.current;
        if (!container || !isEnabled) return;
        return (0, $5b617c1f48263075$exports.bind)(container, {
            type: 'keydown',
            listener: handleKeyDown
        });
    }, [
        containerRef,
        handleKeyDown,
        isEnabled
    ]);
}



function $5402a42f3272ccb8$export$9198c6c168be2eeb() {
    // `@atlaskit/ds-lib/use-id`, not React's `useId`: React's output contains
    // `:`, `«` and `»`, which are invalid in an HTML id token.
    return "popover-".concat((0, $c797bf80d6171378$export$f680877a34711e37)());
}



var $5FkrB = parcelRequire("5FkrB");

var $5FkrB = parcelRequire("5FkrB");

var $e713914be6d6449b$export$756f795847463ebd = /*#__PURE__*/ (0, $5FkrB.createContext)({
    setItemState: (0, $adcefb868cf2fc9d$export$2e2bcd8739ae039),
    getItemState: function getItemState() {
        return undefined;
    },
    setGroupState: (0, $adcefb868cf2fc9d$export$2e2bcd8739ae039),
    getGroupState: function getGroupState() {
        return {};
    }
});


/**
 * Selection store will persist data as long as it remains mounted.
 * It handles the uncontrolled story for dropdown menu when the menu
 * items can be mounted/unmounted depending if the menu is open or closed.
 */ var $0f3fe2fe00d41eb7$var$SelectionStore = function SelectionStore(props) {
    var children = props.children;
    var store = (0, $5FkrB.useRef)({});
    var context = (0, $5FkrB.useMemo)(function() {
        return {
            setItemState: function setItemState(group, id, value) {
                if (!store.current[group]) store.current[group] = {};
                store.current[group][id] = value;
            },
            getItemState: function getItemState(group, id) {
                if (!store.current[group]) return undefined;
                return store.current[group][id];
            },
            setGroupState: function setGroupState(group, value) {
                store.current[group] = value;
            },
            getGroupState: function getGroupState(group) {
                return store.current[group] || {};
            }
        };
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $e713914be6d6449b$export$756f795847463ebd).Provider, {
        value: context
    }, children);
};
var $0f3fe2fe00d41eb7$export$2e2bcd8739ae039 = $0f3fe2fe00d41eb7$var$SelectionStore;


function $6e4b0381575c2ec4$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $6e4b0381575c2ec4$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $6e4b0381575c2ec4$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $a48c245bf23e2005$export$2e2bcd8739ae039)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $6e4b0381575c2ec4$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $6e4b0381575c2ec4$var$MAX_HEIGHT = "calc(100vh - 16px)";
var $6e4b0381575c2ec4$var$styles = {
    spinnerContainer: "_1e0c1txw _1ul91lit _1bah1h6o _1q51v47k _y4tiv47k _85i5v47k _bozgv47k"
};
/**
 * Event types produced by trigger interactions.
 *
 * - `React.MouseEvent<Element>`: from the trigger's `onClick` handler
 * - `React.KeyboardEvent<Element>`: from the trigger's `onClick` when activated via keyboard
 * - `KeyboardEvent`: native event from the ArrowDown `bind(window, ...)` listener
 */ function $6e4b0381575c2ec4$var$getRootMenuPopover(_ref) {
    var _menu$parentElement;
    var menu = _ref.menu;
    var parentMenu = (_menu$parentElement = menu.parentElement) === null || _menu$parentElement === void 0 ? void 0 : _menu$parentElement.closest('[popover][role="menu"]');
    if (!parentMenu) return menu;
    return $6e4b0381575c2ec4$var$getRootMenuPopover({
        menu: parentMenu
    });
}
/**
 * Loading indicator for the dropdown menu.
 */ function $6e4b0381575c2ec4$var$LoadingIndicator(_ref2) {
    var _ref2$statusLabel = _ref2.statusLabel, statusLabel = _ref2$statusLabel === void 0 ? 'Loading' : _ref2$statusLabel, testId = _ref2.testId;
    return /*#__PURE__*/ $5FkrB.createElement("div", {
        role: "menuitem",
        className: (0, $3409454e8e68f10d$export$2e2bcd8739ae039)([
            $6e4b0381575c2ec4$var$styles.spinnerContainer
        ])
    }, /*#__PURE__*/ $5FkrB.createElement((0, $6f7e5f007cf95a87$export$2e2bcd8739ae039), {
        size: "small",
        label: statusLabel,
        testId: testId
    }));
}
/**
 * Top-layer implementation of DropdownMenu.
 *
 * Replaces the legacy `@atlaskit/popup` + `@atlaskit/portal` + `@atlaskit/layering` pipeline
 * with the native Popover API via `@atlaskit/top-layer`.
 *
 * What is no longer needed:
 * - Portal: top layer handles stacking natively
 * - FocusLock / react-focus-lock: popover=auto provides light dismiss
 * - z-index: top layer is always above everything
 * - FocusManager (ref registration): replaced by DOM-query-based `useArrowNavigation`
 * - handle-focus.tsx: replaced by `useArrowNavigation`
 * - Layering context: top layer nesting is handled by the browser
 * - Fallback placements / Popper: CSS Anchor Positioning handles positioning
 */ function $6e4b0381575c2ec4$var$DropdownMenuTopLayer(_ref3) {
    var _ref5;
    var children = _ref3.children, _ref3$defaultOpen = _ref3.defaultOpen, defaultOpen = _ref3$defaultOpen === void 0 ? false : _ref3$defaultOpen, _ref3$isLoading = _ref3.isLoading, isLoading = _ref3$isLoading === void 0 ? false : _ref3$isLoading, isOpenProp = _ref3.isOpen, _ref3$onOpenChange = _ref3.onOpenChange, onOpenChange = _ref3$onOpenChange === void 0 ? (0, $adcefb868cf2fc9d$export$2e2bcd8739ae039) : _ref3$onOpenChange, _ref3$placement = _ref3.placement, placement = _ref3$placement === void 0 ? 'bottom-start' : _ref3$placement, _ref3$shouldFitContai = _ref3.shouldFitContainer, shouldFitContainer = _ref3$shouldFitContai === void 0 ? false : _ref3$shouldFitContai, returnFocusRef = _ref3.returnFocusRef, spacing = _ref3.spacing, statusLabel = _ref3.statusLabel, testId = _ref3.testId, trigger = _ref3.trigger, label = _ref3.label, interactionName = _ref3.interactionName, menuLabel = _ref3.menuLabel;
    var _useControlledState = (0, $1bedb8eb38a3e847$export$2e2bcd8739ae039)(isOpenProp, function() {
        return defaultOpen;
    }), _useControlledState2 = (0, $fe9ce0f81f7af2c1$export$2e2bcd8739ae039)(_useControlledState, 2), isLocalOpen = _useControlledState2[0], setLocalIsOpen = _useControlledState2[1];
    var triggerRef = (0, $5FkrB.useRef)(null);
    var popoverRef = (0, $5FkrB.useRef)(null);
    var popoverId = (0, $5402a42f3272ccb8$export$9198c6c168be2eeb)();
    var topLayerPlacement = (0, $5FkrB.useMemo)(function() {
        return (0, $feede424fdeb9dd7$export$69e99ed50b2534c9)({
            legacy: placement
        });
    }, [
        placement
    ]);
    // DropdownMenu has no `shouldFitViewport` equivalent, so neither axis ever
    // fits and `blockSize` stays `'content'` - `MenuGroup`'s `maxHeight` owns the
    // block axis.
    (0, $a9a4e179f55dac8b$export$147d8888d96bf7a3)({
        anchorRef: triggerRef,
        popoverRef: popoverRef,
        placement: topLayerPlacement,
        isOpen: isLocalOpen,
        inlineSize: shouldFitContainer ? 'min-anchor' : 'content'
    });
    // Close handling.
    // Focus restoration is handled natively by the Popover API:
    //   - Escape: browser restores focus to the trigger automatically
    //   - Click-outside: browser does NOT restore (correct behavior)
    //
    // The only custom focus handling needed is `returnFocusRef`: when provided,
    // we redirect focus to a different element than the trigger. We do this
    // in the onClose callback via rAF, which runs after the browser's native
    // restoration, effectively overriding it.
    var handleOnClose = (0, $5FkrB.useCallback)(function() {
        if (returnFocusRef) requestAnimationFrame(function() {
            var _returnFocusRef$curre;
            (_returnFocusRef$curre = returnFocusRef.current) === null || _returnFocusRef$curre === void 0 || _returnFocusRef$curre.focus();
        });
        setLocalIsOpen(false);
        onOpenChange({
            isOpen: false,
            event: null
        });
    }, [
        onOpenChange,
        returnFocusRef,
        setLocalIsOpen
    ]);
    // Trigger click handling.
    var handleTriggerClicked = (0, $5FkrB.useCallback)(function(event) {
        var nextIsOpen = !isLocalOpen;
        setLocalIsOpen(nextIsOpen);
        // Extract the native DOM event for onOpenChange
        var nativeEvent = 'nativeEvent' in event ? event.nativeEvent : event;
        onOpenChange({
            isOpen: nextIsOpen,
            event: nativeEvent
        });
    }, [
        isLocalOpen,
        setLocalIsOpen,
        onOpenChange
    ]);
    var _useFocus = (0, $c76ec7f1ca125947$export$2e2bcd8739ae039)(), isFocused = _useFocus.isFocused, bindFocus = _useFocus.bindFocus;
    // When trigger is focused, open dropdown on ArrowDown (top-level only).
    // Per WAI-ARIA, ArrowDown opens a menu from a menubar/button trigger,
    // but inside a vertical submenu, ArrowDown navigates between siblings
    // and ArrowRight opens nested menus instead.
    (0, $5FkrB.useEffect)(function() {
        var _triggerRef$current;
        if (!isFocused || isLocalOpen) return;
        // Do not open on ArrowDown if this trigger is inside a parent menu.
        // Nested menus should only be opened via ArrowRight or Enter.
        var isNestedTrigger = Boolean((_triggerRef$current = triggerRef.current) === null || _triggerRef$current === void 0 ? void 0 : _triggerRef$current.closest('[role="menu"]'));
        return (0, $5b617c1f48263075$exports.bind)(window, {
            type: 'keydown',
            listener: function openOnKeyDown(e) {
                if (e.key === (0, $f8dc452a9f988247$export$a80636c6f41931fe) && !isNestedTrigger) {
                    e.preventDefault();
                    handleTriggerClicked(e);
                }
            }
        });
    }, [
        isFocused,
        isLocalOpen,
        handleTriggerClicked
    ]);
    var handleNestedOpen = (0, $5FkrB.useCallback)(function(_ref4) {
        var trigger = _ref4.trigger;
        trigger.click();
    }, []);
    var handleTabClose = (0, $5FkrB.useCallback)(function() {
        var currentMenu = popoverRef.current;
        if (!currentMenu) return;
        // Hiding the root native popover synchronously closes its descendant popovers and restores
        // focus to the root trigger. The browser can then perform the Tab default action from there.
        $6e4b0381575c2ec4$var$getRootMenuPopover({
            menu: currentMenu
        }).hidePopover();
    }, []);
    (0, $4023a433327edc3e$export$23dfbae28e0cc453)({
        containerRef: popoverRef,
        onClose: handleTabClose,
        onNestedOpen: handleNestedOpen,
        onNestedClose: handleOnClose,
        isEnabled: isLocalOpen,
        filter: (0, $1edbb35a3273a726$export$f1bba0ef464d60af)
    });
    // Close on menu item click.
    // Close when a regular menuitem is clicked, but not checkboxes/radios
    // and not nested triggers (items with aria-haspopup).
    var handleMenuClick = (0, $5FkrB.useCallback)(function(e) {
        var _e$target$closest, _e$target;
        if (!(e.target instanceof Element)) return;
        var menuItem = (_e$target$closest = (_e$target = e.target).closest) === null || _e$target$closest === void 0 ? void 0 : _e$target$closest.call(_e$target, '[role="menuitem"], [role="menuitemcheckbox"], [role="menuitemradio"]');
        if (!menuItem) return;
        var isCheckboxOrRadio = menuItem.getAttribute('role') === 'menuitemcheckbox' || menuItem.getAttribute('role') === 'menuitemradio';
        // Do not close the menu when clicking a nested trigger (aria-haspopup).
        // The nested dropdown will handle its own open/close.
        var isNestedTrigger = menuItem.hasAttribute('aria-haspopup');
        if (!isCheckboxOrRadio && !isNestedTrigger) {
            setLocalIsOpen(false);
            onOpenChange({
                isOpen: false,
                event: e.nativeEvent
            });
        }
    }, [
        setLocalIsOpen,
        onOpenChange
    ]);
    var ariaAttributes = (0, $7c1811553882724a$export$9dd1d61dd4d4755)({
        // Intentionally fudging the type here to allow the fudged aria-haspopup cast below,
        // without having to use `as unknown as ...` which would lose even more type safety.
        role: 'menu',
        isOpen: isLocalOpen,
        popoverId: popoverId
    });
    // FUDGE(top-layer-api): cast `aria-haspopup` to the narrow shape that adopter
    // public types expect. `@atlaskit/top-layer` types `aria-haspopup` as the wider
    // WAI-ARIA union, but the public `CustomTriggerProps` (extending `@atlaskit/popup`
    // `TriggerProps`) is intentionally kept narrow (`boolean | 'dialog'`) because the
    // top-layer API surface is not yet settled. The runtime value is unchanged; only
    // the TypeScript-visible type is narrowed at this boundary.
    var narrowAriaAttributes = ariaAttributes;
    /**
   * Custom trigger consumers historically receive a callback ref,
   * and their code assumes it is one.
   * Using this wrapper for compatibility...
   */ var setTriggerRef = (0, $5FkrB.useCallback)(function(node) {
        triggerRef.current = node;
    }, []);
    var renderTrigger = function renderTrigger() {
        if (typeof trigger === 'function') return trigger($6e4b0381575c2ec4$var$_objectSpread($6e4b0381575c2ec4$var$_objectSpread({}, narrowAriaAttributes), {}, {
            onFocus: bindFocus.onFocus,
            onBlur: bindFocus.onBlur,
            triggerRef: setTriggerRef,
            isSelected: isLocalOpen,
            onClick: handleTriggerClicked,
            testId: testId && "".concat(testId, "--trigger")
        }));
        return /*#__PURE__*/ $5FkrB.createElement((0, $a21e01c03a9c4d94$export$2e2bcd8739ae039), (0, $4a7ae0731a7e1583$export$2e2bcd8739ae039)({
            onFocus: bindFocus.onFocus,
            onBlur: bindFocus.onBlur,
            ref: setTriggerRef
        }, narrowAriaAttributes, {
            isSelected: isLocalOpen,
            iconAfter: function iconAfter(iconProps) {
                return /*#__PURE__*/ $5FkrB.createElement((0, (/*@__PURE__*/$parcel$interopDefault($c63a1832a2581897$exports))), (0, $4a7ae0731a7e1583$export$2e2bcd8739ae039)({}, iconProps, {
                    size: "small"
                }));
            },
            onClick: handleTriggerClicked,
            testId: testId && "".concat(testId, "--trigger"),
            "aria-label": label,
            interactionName: interactionName
        }), trigger);
    };
    return /*#__PURE__*/ $5FkrB.createElement((0, $0f3fe2fe00d41eb7$export$2e2bcd8739ae039), null, renderTrigger(), /*#__PURE__*/ $5FkrB.createElement((0, $b103fdb0f1d92e4d$export$5b6b19405a83ff9d), {
        ref: popoverRef,
        id: popoverId,
        role: "menu",
        label: (_ref5 = menuLabel !== null && menuLabel !== void 0 ? menuLabel : label) !== null && _ref5 !== void 0 ? _ref5 : typeof trigger === 'string' ? trigger : 'Menu',
        isOpen: isLocalOpen,
        onClose: handleOnClose,
        shouldAnimate: true,
        placement: topLayerPlacement,
        testId: testId && "".concat(testId, "--content")
    }, /*#__PURE__*/ $5FkrB.createElement((0, $cda0def86655916a$export$8b7437164e479115), null, /*#__PURE__*/ $5FkrB.createElement((0, $4c35f91febbc7ca1$export$2e2bcd8739ae039), {
        maxHeight: $6e4b0381575c2ec4$var$MAX_HEIGHT,
        maxWidth: shouldFitContainer ? undefined : 800,
        onClick: handleMenuClick,
        spacing: spacing,
        testId: testId && "".concat(testId, "--menu-wrapper--menu-group")
    }, isLoading ? /*#__PURE__*/ $5FkrB.createElement($6e4b0381575c2ec4$var$LoadingIndicator, {
        statusLabel: statusLabel,
        testId: testId && "".concat(testId, "--menu-wrapper--loading-indicator")
    }) : children))));
}
var $6e4b0381575c2ec4$export$2e2bcd8739ae039 = $6e4b0381575c2ec4$var$DropdownMenuTopLayer;




var $5FkrB = parcelRequire("5FkrB");





var $50U6m = parcelRequire("50U6m");

var $89062811dcd64d86$export$8a682ae47622dbb9 = 'ds--dropdown--';
function $89062811dcd64d86$export$2e2bcd8739ae039() {
    var id = (0, $c797bf80d6171378$export$f680877a34711e37)();
    return "".concat($89062811dcd64d86$export$8a682ae47622dbb9).concat(id);
}


var $16dd0eba97ba115d$var$actionMap = (0, $a48c245bf23e2005$export$2e2bcd8739ae039)((0, $a48c245bf23e2005$export$2e2bcd8739ae039)((0, $a48c245bf23e2005$export$2e2bcd8739ae039)((0, $a48c245bf23e2005$export$2e2bcd8739ae039)({}, (0, $f8dc452a9f988247$export$a80636c6f41931fe), 'next'), (0, $f8dc452a9f988247$export$390330c10ff2b9a1), 'prev'), (0, $f8dc452a9f988247$export$4af703091671bc), 'first'), (0, $f8dc452a9f988247$export$e2bc30913faa5db7), 'last');
/**
 * `currentFocusedIdx + 1` will not work if the next focusable element
 * is disabled. So, we need to iterate through the following menu items
 * to find one that isn't disabled. If all following elements are disabled,
 * return undefined.
 */ var $16dd0eba97ba115d$var$getNextFocusableElement = function getNextFocusableElement(refs, currentFocusedIdx) {
    for(var i = 0; i < refs.length - 1; i++){
        if (currentFocusedIdx + 1 === refs.length) currentFocusedIdx = 0;
        else currentFocusedIdx++;
        var element = refs[currentFocusedIdx].current;
        var isValid = !!element && !element.hasAttribute('disabled');
        if (isValid) return element;
    }
    return;
};
/**
 * `currentFocusedIdx - 1` will not work if the prev focusable element
 * is disabled. So, we need to iterate through the previous menu items
 * to find one that isn't disabled. If all previous elements are disabled,
 * return undefined.
 */ var $16dd0eba97ba115d$var$getPrevFocusableElement = function getPrevFocusableElement(refs, currentFocusedIdx) {
    for(var i = 0; i < refs.length - 1; i++){
        if (currentFocusedIdx === 0) currentFocusedIdx = refs.length - 1;
        else currentFocusedIdx--;
        var element = refs[currentFocusedIdx].current;
        var isValid = !!element && !element.hasAttribute('disabled');
        if (isValid) return element;
    }
    return;
};
function $16dd0eba97ba115d$export$2e2bcd8739ae039(refs, isLayerDisabled, onClose) {
    var isNestedMenu = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
    return function(e) {
        var _refs$current;
        var currentRefs = (_refs$current = refs.current) !== null && _refs$current !== void 0 ? _refs$current : [];
        var currentFocusedIdx = currentRefs.findIndex(function(_ref) {
            var _document$activeEleme;
            var el = _ref.current;
            return el && ((_document$activeEleme = document.activeElement) === null || _document$activeEleme === void 0 ? void 0 : _document$activeEleme.isSameNode(el));
        });
        if ((0, $50U6m.fg)('platform_dst_popup-disable-focuslock')) {
            var _document$activeEleme2;
            // if we use a popup as a nested dropdown, we must prevent the dropdown from closing.
            var isNestedDropdown = !!((_document$activeEleme2 = document.activeElement) !== null && _document$activeEleme2 !== void 0 && _document$activeEleme2.closest("[id^=".concat((0, $89062811dcd64d86$export$8a682ae47622dbb9), "]")));
            if (isLayerDisabled() && isNestedDropdown) {
                if (e.key === (0, $f8dc452a9f988247$export$10f6869ed0a7d75b) && !e.shiftKey) onClose(e);
                // if it is a nested dropdown and the level of the given dropdown is not the current level,
                // we don't need to have focus on it
                return;
            }
        } else if (isLayerDisabled()) {
            if (e.key === (0, $f8dc452a9f988247$export$10f6869ed0a7d75b) && !e.shiftKey) onClose(e);
            // if it is a nested dropdown and the level of the given dropdown is not the current level,
            // we don't need to have focus on it
            return;
        }
        // Left arrow: only in a submenu — close and return focus to parent. No navigation within menu.
        if (e.key === (0, $f8dc452a9f988247$export$fc4577f2a2af0ae3)) {
            e.preventDefault();
            if (isNestedMenu) onClose(e);
            return;
        }
        // Right arrow: only when item has submenu — open it. No navigation within menu.
        if (e.key === (0, $f8dc452a9f988247$export$c40f9845adc73fb5)) {
            var activeElement = document.activeElement;
            if (activeElement instanceof HTMLElement && (activeElement.getAttribute('aria-haspopup') === 'true' || activeElement.getAttribute('aria-haspopup') === 'menu')) {
                e.preventDefault();
                activeElement.click();
            }
            return;
        }
        var action = $16dd0eba97ba115d$var$actionMap[e.key];
        switch(action){
            case 'next':
                // Always cancelling the event to prevent scrolling
                e.preventDefault();
                var nextFocusableElement = $16dd0eba97ba115d$var$getNextFocusableElement(currentRefs, currentFocusedIdx);
                nextFocusableElement === null || nextFocusableElement === void 0 || nextFocusableElement.focus();
                break;
            case 'prev':
                // Always cancelling the event to prevent scrolling
                e.preventDefault();
                var prevFocusableElement = $16dd0eba97ba115d$var$getPrevFocusableElement(currentRefs, currentFocusedIdx);
                prevFocusableElement === null || prevFocusableElement === void 0 || prevFocusableElement.focus();
                break;
            case 'first':
                e.preventDefault();
                // Search for first non-disabled element if first element is disabled
                var firstFocusableElement = $16dd0eba97ba115d$var$getNextFocusableElement(currentRefs, -1);
                firstFocusableElement === null || firstFocusableElement === void 0 || firstFocusableElement.focus();
                break;
            case 'last':
                e.preventDefault();
                // Search for last non-disabled element if last element is disabled
                var lastFocusableElement = $16dd0eba97ba115d$var$getPrevFocusableElement(currentRefs, currentRefs.length);
                lastFocusableElement === null || lastFocusableElement === void 0 || lastFocusableElement.focus();
                break;
            default:
                return;
        }
    };
}



var $5FkrB = parcelRequire("5FkrB");

var $02945aff112f1d42$export$f18c1d4fc7326096 = /*#__PURE__*/ (0, $5FkrB.createContext)({
    menuItemRefs: [],
    registerRef: (0, $adcefb868cf2fc9d$export$2e2bcd8739ae039)
});


/**
 * Focus manager logic.
 */ var $e09ee412fd2daea2$var$FocusManager = function FocusManager(_ref) {
    var children = _ref.children, onClose = _ref.onClose;
    var menuItemRefs = (0, $5FkrB.useRef)([]);
    // Used to force a re-render only
    var _useState = (0, $5FkrB.useState)(0), _useState2 = (0, $fe9ce0f81f7af2c1$export$2e2bcd8739ae039)(_useState, 2), refresh = _useState2[0], setRefresh = _useState2[1];
    var registerMode = (0, $5FkrB.useRef)('ordered');
    registerMode.current = 'ordered';
    var registerRef = (0, $5FkrB.useCallback)(function(ref) {
        if (menuItemRefs.current.includes(ref)) return;
        switch(registerMode.current){
            case 'ordered':
                menuItemRefs.current.push(ref);
                break;
            case 'unordered':
                // Reset and force a rerender
                registerMode.current = 'regenerate';
                menuItemRefs.current = [];
                setRefresh(refresh + 1);
                break;
            case 'regenerate':
                break;
            default:
                throw new Error("Unexpected case of ".concat(registerMode.current));
        }
    }, // Updating register ref on force reload will cause `useRegisterItemWithFocusManager` to re-register
    [
        refresh
    ]);
    var _useLayering = (0, $7df5ec948c08a88e$export$c8b4d54e03dee6ed)(), isLayerDisabled = _useLayering.isLayerDisabled, currentLevel = _useLayering.currentLevel;
    // Root menu (from a button) is at level 1; first submenu is at level 2. ARIA: Left only closes submenus.
    var isNestedMenu = currentLevel > 1;
    // Intentionally rebinding on each render
    (0, $5FkrB.useEffect)(function() {
        if (registerMode.current === 'ordered') // Use effect is called after rendering is complete and useEffects of the children a called first
        registerMode.current = 'unordered';
    });
    (0, $5FkrB.useEffect)(function() {
        return (0, $5b617c1f48263075$exports.bind)(window, {
            type: 'keydown',
            listener: (0, $16dd0eba97ba115d$export$2e2bcd8739ae039)(menuItemRefs, isLayerDisabled, onClose, isNestedMenu)
        });
    }, [
        isLayerDisabled,
        onClose,
        isNestedMenu
    ]);
    var contextValue = {
        menuItemRefs: menuItemRefs.current,
        registerRef: registerRef
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $02945aff112f1d42$export$f18c1d4fc7326096).Provider, {
        value: contextValue
    }, children);
};
var $e09ee412fd2daea2$export$2e2bcd8739ae039 = $e09ee412fd2daea2$var$FocusManager;


/* menu-wrapper.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $5FkrB = parcelRequire("5FkrB");



var $50U6m = parcelRequire("50U6m");


function $f84c68cb50a7ea6a$export$2e2bcd8739ae039(element) {
    var role = element.getAttribute('role');
    return role === 'checkbox' || role === 'menuitemcheckbox';
}


function $325f5391bd4137c8$export$2e2bcd8739ae039(element) {
    var role = element.getAttribute('role');
    return role === 'radio' || role === 'menuitemradio';
}



var $7e16aec66c845d90$var$styles = {
    spinnerContainer: "_1e0c1txw _1ul91lit _1bah1h6o _1q51v47k _y4tiv47k _85i5v47k _bozgv47k"
};
var $7e16aec66c845d90$var$LoadingIndicator = function LoadingIndicator(_ref) {
    var _ref$statusLabel = _ref.statusLabel, statusLabel = _ref$statusLabel === void 0 ? 'Loading' : _ref$statusLabel, testId = _ref.testId;
    return /*#__PURE__*/ $5FkrB.createElement((0, $7a49b1df02a75aca$export$e71c4d32a2263218), {
        xcss: $7e16aec66c845d90$var$styles.spinnerContainer,
        role: "menuitem"
    }, /*#__PURE__*/ $5FkrB.createElement((0, $6f7e5f007cf95a87$export$2e2bcd8739ae039), {
        size: "small",
        label: statusLabel,
        testId: testId
    }));
};
/**
 *
 * MenuWrapper wraps all the menu items.
 * It handles the logic to close the menu when a MenuItem is clicked, but leaves it open
 * if a CheckboxItem or RadioItem is clicked.
 * It also sets focus to the first menu item when opened.
 */ var $7e16aec66c845d90$var$MenuWrapper = function MenuWrapper(_ref2) {
    var children = _ref2.children, isLoading = _ref2.isLoading, maxHeight = _ref2.maxHeight, maxWidth = _ref2.maxWidth, onClose = _ref2.onClose, onUpdate = _ref2.onUpdate, statusLabel = _ref2.statusLabel, setInitialFocusRef = _ref2.setInitialFocusRef, shouldRenderToParent = _ref2.shouldRenderToParent, spacing = _ref2.spacing, testId = _ref2.testId, isTriggeredUsingKeyboard = _ref2.isTriggeredUsingKeyboard, autoFocus = _ref2.autoFocus, menuLabel = _ref2.menuLabel;
    var _useContext = (0, $5FkrB.useContext)((0, $02945aff112f1d42$export$f18c1d4fc7326096)), menuItemRefs = _useContext.menuItemRefs;
    var closeOnMenuItemClick = function closeOnMenuItemClick(e) {
        var isTargetMenuItemOrDescendant = menuItemRefs.some(function(menuItemRef) {
            var menuItem = menuItemRef.current;
            if (!menuItem) return false;
            var isCheckboxOrRadio = (0, $f84c68cb50a7ea6a$export$2e2bcd8739ae039)(menuItem) || (0, $325f5391bd4137c8$export$2e2bcd8739ae039)(menuItem);
            return menuItem.contains(e.target) && !isCheckboxOrRadio;
        });
        // Close menu if the click is triggered from a MenuItem or
        // its descendant. Don't close the menu if the click is triggered
        // from a MenuItemRadio or MenuItemCheckbox so that the user can
        // select multiple items.
        if (isTargetMenuItemOrDescendant && onClose) onClose(e);
    };
    // Using useEffect here causes a flicker.
    // useLayoutEffect ensures that the update and render happen in the same
    // rAF tick.
    (0, $5FkrB.useLayoutEffect)(function() {
        onUpdate();
    }, [
        isLoading,
        onUpdate
    ]);
    (0, $5FkrB.useEffect)(function() {
        var _menuItemRefs$map$fin;
        var firstFocusableRef = (_menuItemRefs$map$fin = menuItemRefs.map(function(_ref3) {
            var current = _ref3.current;
            return current;
        }).find(function(el) {
            return !!el && !el.hasAttribute('disabled');
        })) !== null && _menuItemRefs$map$fin !== void 0 ? _menuItemRefs$map$fin : null;
        if (((0, $50U6m.fg)('platform_dst_menu_item_focus') || shouldRenderToParent) && (isTriggeredUsingKeyboard || autoFocus)) firstFocusableRef === null || firstFocusableRef === void 0 || firstFocusableRef.focus();
        setInitialFocusRef === null || setInitialFocusRef === void 0 || setInitialFocusRef(firstFocusableRef);
    }, [
        menuItemRefs,
        setInitialFocusRef,
        autoFocus,
        shouldRenderToParent,
        isTriggeredUsingKeyboard
    ]);
    return /*#__PURE__*/ $5FkrB.createElement((0, $4c35f91febbc7ca1$export$2e2bcd8739ae039), {
        isLoading: isLoading,
        maxHeight: maxHeight,
        maxWidth: maxWidth,
        onClick: closeOnMenuItemClick,
        role: "menu",
        spacing: spacing,
        testId: testId && "".concat(testId, "--menu-group"),
        menuLabel: menuLabel
    }, isLoading ? /*#__PURE__*/ $5FkrB.createElement($7e16aec66c845d90$var$LoadingIndicator, {
        statusLabel: statusLabel,
        testId: testId && "".concat(testId, "--loading-indicator")
    }) : children);
};
var $7e16aec66c845d90$export$2e2bcd8739ae039 = $7e16aec66c845d90$var$MenuWrapper;



// eslint-disable-next-line sort-imports

var $5FkrB = parcelRequire("5FkrB");

var $50U6m = parcelRequire("50U6m");

// This function is called whenever a MenuItem mounts.
// The refs stored in the context are used to programmatically
// control focus on a user navigates using the keyboard.
function $1157ce92c724a1fa$var$useRegisterItemWithFocusManager() {
    var hasPopup = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    var _useContext = (0, $5FkrB.useContext)((0, $02945aff112f1d42$export$f18c1d4fc7326096)), registerRef = _useContext.registerRef;
    var itemRef = (0, $5FkrB.useRef)(null);
    (0, $5FkrB.useEffect)(function() {
        if (hasPopup && (0, $50U6m.fg)('select-avoid-duplicated-registered-ref')) return;
        registerRef(itemRef);
    }, [
        registerRef,
        hasPopup
    ]);
    return itemRef;
}
var $1157ce92c724a1fa$export$2e2bcd8739ae039 = $1157ce92c724a1fa$var$useRegisterItemWithFocusManager;



var $efa3e699f80dfb1c$var$_excluded = [
    "ref",
    "aria-controls",
    "aria-expanded",
    "aria-haspopup"
];
function $efa3e699f80dfb1c$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $efa3e699f80dfb1c$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $efa3e699f80dfb1c$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $a48c245bf23e2005$export$2e2bcd8739ae039)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $efa3e699f80dfb1c$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $efa3e699f80dfb1c$var$MAX_HEIGHT = "calc(100vh - 16px)";
var $efa3e699f80dfb1c$var$opposites = {
    top: 'bottom',
    bottom: 'top',
    left: 'right',
    right: 'left',
    start: 'end',
    auto: 'auto',
    end: 'start'
};
var $efa3e699f80dfb1c$var$getFallbackPlacements = function getFallbackPlacements(placement) {
    var placementPieces = placement.split('-');
    var mainAxis = placementPieces[0];
    // Left, right and auto placements can rely on standard popper sliding behaviour
    if (![
        'top',
        'bottom'
    ].includes(mainAxis)) return undefined;
    else if (placementPieces.length === 2 && [
        'start',
        'end'
    ].includes(placementPieces[1])) {
        var crossAxis = placementPieces[1];
        return [
            "".concat(mainAxis),
            "".concat(mainAxis, "-").concat($efa3e699f80dfb1c$var$opposites[crossAxis]),
            "".concat($efa3e699f80dfb1c$var$opposites[mainAxis], "-").concat(crossAxis),
            "".concat($efa3e699f80dfb1c$var$opposites[mainAxis]),
            "".concat($efa3e699f80dfb1c$var$opposites[mainAxis], "-").concat($efa3e699f80dfb1c$var$opposites[crossAxis]),
            'auto'
        ];
    } else return [
        "".concat(mainAxis, "-start"),
        "".concat(mainAxis, "-end"),
        "".concat($efa3e699f80dfb1c$var$opposites[mainAxis]),
        "".concat($efa3e699f80dfb1c$var$opposites[mainAxis], "-start"),
        "".concat($efa3e699f80dfb1c$var$opposites[mainAxis], "-end"),
        "auto"
    ];
};
function $efa3e699f80dfb1c$var$isKeyboardEvent(event) {
    return event !== null && (event instanceof KeyboardEvent || 'nativeEvent' in event && event.nativeEvent instanceof KeyboardEvent);
}
/**
 * Legacy Popper/Popup implementation (hooks run unconditionally when this component mounts).
 */ function $efa3e699f80dfb1c$var$DropdownMenuLegacy(_ref) {
    var _ref$autoFocus = _ref.autoFocus, autoFocus = _ref$autoFocus === void 0 ? false : _ref$autoFocus, children = _ref.children, _ref$defaultOpen = _ref.defaultOpen, defaultOpen = _ref$defaultOpen === void 0 ? false : _ref$defaultOpen, _ref$isLoading = _ref.isLoading, isLoading = _ref$isLoading === void 0 ? false : _ref$isLoading, isOpen = _ref.isOpen, _ref$onOpenChange = _ref.onOpenChange, onOpenChange = _ref$onOpenChange === void 0 ? (0, $adcefb868cf2fc9d$export$2e2bcd8739ae039) : _ref$onOpenChange, _ref$placement = _ref.placement, placement = _ref$placement === void 0 ? 'bottom-start' : _ref$placement, _ref$shouldFitContain = _ref.shouldFitContainer, shouldFitContainer = _ref$shouldFitContain === void 0 ? false : _ref$shouldFitContain, _ref$shouldFlip = _ref.shouldFlip, shouldFlip = _ref$shouldFlip === void 0 ? true : _ref$shouldFlip, _ref$shouldRenderToPa = _ref.shouldRenderToParent, shouldRenderToParent = _ref$shouldRenderToPa === void 0 ? false : _ref$shouldRenderToPa, returnFocusRef = _ref.returnFocusRef, spacing = _ref.spacing, statusLabel = _ref.statusLabel, testId = _ref.testId, _trigger = _ref.trigger, _ref$zIndex = _ref.zIndex, zIndex = _ref$zIndex === void 0 ? (0, $46bf0aae0dfb1de2$export$7be255094ccdc533).modal() : _ref$zIndex, label = _ref.label, interactionName = _ref.interactionName, strategy = _ref.strategy, menuLabel = _ref.menuLabel, _ref$shouldPreventEsc = _ref.shouldPreventEscapePropagation, shouldPreventEscapePropagation = _ref$shouldPreventEsc === void 0 ? false : _ref$shouldPreventEsc, shouldIgnoreCloseEvent = _ref.shouldIgnoreCloseEvent;
    var _useControlledState = (0, $1bedb8eb38a3e847$export$2e2bcd8739ae039)(isOpen, function() {
        return defaultOpen;
    }), _useControlledState2 = (0, $fe9ce0f81f7af2c1$export$2e2bcd8739ae039)(_useControlledState, 2), isLocalOpen = _useControlledState2[0], setLocalIsOpen = _useControlledState2[1];
    var triggerRef = (0, $5FkrB.useRef)(null);
    var _useState = (0, $5FkrB.useState)(false), _useState2 = (0, $fe9ce0f81f7af2c1$export$2e2bcd8739ae039)(_useState, 2), isTriggeredUsingKeyboard = _useState2[0], setTriggeredUsingKeyboard = _useState2[1];
    var id = (0, $89062811dcd64d86$export$2e2bcd8739ae039)();
    var itemRef = (0, $1157ce92c724a1fa$export$2e2bcd8739ae039)();
    var _useLayering = (0, $7df5ec948c08a88e$export$c8b4d54e03dee6ed)(), currentLevel = _useLayering.currentLevel;
    var fallbackPlacements = (0, $5FkrB.useMemo)(function() {
        return $efa3e699f80dfb1c$var$getFallbackPlacements(placement);
    }, [
        placement
    ]);
    var handleTriggerClicked = (0, $5FkrB.useCallback)(// TODO: event is an `any` and is being cast incorrectly
    // This means that the public type for `onOpenChange` is incorrect
    // current: (event: React.MouseEvent | React.KeyboardEvent) => void;
    // correct: (event: React.MouseEvent | KeyboardEvent) => void;
    // https://product-fabric.atlassian.net/browse/DSP-4692
    function(event) {
        var newValue = !isLocalOpen;
        var clientX = event.clientX, clientY = event.clientY, type = event.type, detail = event.detail;
        if (type === 'keydown') setTriggeredUsingKeyboard(true);
        else if (clientX === 0 || clientY === 0) // Hitting enter/space is registered as a click
        // with both clientX and clientY === 0
        setTriggeredUsingKeyboard(true);
        else if (detail === 0) // Fix for Safari. clientX and clientY !== 0 in Safari
        setTriggeredUsingKeyboard(true);
        else {
            var _itemRef$current;
            // The trigger element must be focused to avoid problems with an incorrectly focused element after closing DropdownMenu
            itemRef === null || itemRef === void 0 || (_itemRef$current = itemRef.current) === null || _itemRef$current === void 0 || _itemRef$current.focus();
            setTriggeredUsingKeyboard(false);
        }
        setLocalIsOpen(newValue);
        onOpenChange({
            isOpen: newValue,
            event: event
        });
    }, [
        isLocalOpen,
        setLocalIsOpen,
        onOpenChange,
        itemRef
    ]);
    var handleOnClose = (0, $5FkrB.useCallback)(function(event, currentLevel) {
        var _event$target$closest, _event$target;
        var isTabLeftOrEscapeKey = $efa3e699f80dfb1c$var$isKeyboardEvent(event) && (event.key === 'Tab' || event.key === 'Escape' || event.key === (0, $f8dc452a9f988247$export$fc4577f2a2af0ae3));
        // Stop propagation on ESCAPE or Left arrow if shouldPreventEscapePropagation is true
        if (shouldPreventEscapePropagation && $efa3e699f80dfb1c$var$isKeyboardEvent(event) && (event.key === 'Escape' || event.key === (0, $f8dc452a9f988247$export$fc4577f2a2af0ae3))) event.stopPropagation();
        if (event !== null && !isTabLeftOrEscapeKey && event.target instanceof HTMLElement && (_event$target$closest = (_event$target = event.target).closest) !== null && _event$target$closest !== void 0 && _event$target$closest.call(_event$target, "[id^=".concat((0, $89062811dcd64d86$export$8a682ae47622dbb9), "] [aria-haspopup]"))) {
            var _itemRef$current2;
            // Check if it is within dropdown and it is a trigger button
            // if it is a nested dropdown, clicking trigger won't close the dropdown
            // Dropdown can be closed by pressing Escape, Tab or Shift + Tab
            if (!currentLevel) return;
            // if currentLevel is provided, we will compare with the given item's level
            // when it is available and larger than currentLevel, we will proceed the close behavior
            var toCloseLevel = (_itemRef$current2 = itemRef.current) === null || _itemRef$current2 === void 0 ? void 0 : _itemRef$current2.dataset['ds-Level'];
            if (toCloseLevel && Number(toCloseLevel) < currentLevel) return;
        }
        // transfer focus to the element specified by ref
        // if ref is not provided, use old behavior:
        // focus on trigger when <Esc> or <Shift+Tab> is pressed
        if (returnFocusRef) requestAnimationFrame(function() {
            var _returnFocusRef$curre;
            (_returnFocusRef$curre = returnFocusRef.current) === null || _returnFocusRef$curre === void 0 || _returnFocusRef$curre.focus();
        });
        else if ($efa3e699f80dfb1c$var$isKeyboardEvent(event) && (event.key === 'Tab' && event.shiftKey || event.key === 'Escape' || event.key === (0, $f8dc452a9f988247$export$fc4577f2a2af0ae3))) requestAnimationFrame(function() {
            var _itemRef$current3;
            (_itemRef$current3 = itemRef.current) === null || _itemRef$current3 === void 0 || _itemRef$current3.focus();
        });
        else if (triggerRef.current) {
            var _event$target$closest2, _event$target2;
            // Don't focus the trigger if the click was outside of the menu
            var isClickOutsideMenu = (event === null || event === void 0 ? void 0 : event.target) instanceof HTMLElement && ((_event$target$closest2 = (_event$target2 = event.target).closest) === null || _event$target$closest2 === void 0 ? void 0 : _event$target$closest2.call(_event$target2, '[role="menu"]')) === null;
            var shouldPreventFocus = isClickOutsideMenu && document.activeElement !== document.body; // except if clicking on the body
            if (!shouldPreventFocus) requestAnimationFrame(function() {
                var _triggerRef$current;
                (_triggerRef$current = triggerRef.current) === null || _triggerRef$current === void 0 || _triggerRef$current.focus();
            });
        }
        var newValue = false;
        setLocalIsOpen(newValue);
        onOpenChange({
            isOpen: newValue,
            event: event
        });
    }, [
        itemRef,
        onOpenChange,
        returnFocusRef,
        setLocalIsOpen,
        shouldPreventEscapePropagation
    ]);
    var _useFocus = (0, $c76ec7f1ca125947$export$2e2bcd8739ae039)(), isFocused = _useFocus.isFocused, bindFocus = _useFocus.bindFocus;
    // When a trigger is focused, we want to open the dropdown if
    // the user presses the DownArrow
    (0, $5FkrB.useEffect)(function() {
        // Only need to listen for keydown when focused
        if (!isFocused) return 0, $adcefb868cf2fc9d$export$2e2bcd8739ae039;
        // Being safe: we don't want to open the dropdown if it is already open
        // Note: This shouldn't happen as the trigger should not be able to get focus
        if (isLocalOpen) return 0, $adcefb868cf2fc9d$export$2e2bcd8739ae039;
        return (0, $5b617c1f48263075$exports.bind)(window, {
            type: 'keydown',
            listener: function openOnKeyDown(e) {
                var isNestedTriggerButton;
                if (e.target instanceof HTMLElement) isNestedTriggerButton = e.target.closest("[id^=".concat((0, $89062811dcd64d86$export$8a682ae47622dbb9), "] [aria-haspopup]"));
                if (e.key === (0, $f8dc452a9f988247$export$a80636c6f41931fe) && !isNestedTriggerButton) {
                    // prevent page scroll
                    e.preventDefault();
                    handleTriggerClicked(e);
                } else if ((e.code === (0, $f8dc452a9f988247$export$e51a3576c045c8d5) || e.key === (0, $f8dc452a9f988247$export$8152f929a25a0ff4)) && e.detail === 0) // This allows us to focus on the first element if the dropdown was triggered by a custom trigger with a custom onClick
                setTriggeredUsingKeyboard(true);
                else if (e.key === (0, $f8dc452a9f988247$export$10f6869ed0a7d75b) && isNestedTriggerButton) // This closes dropdown if it is a nested dropdown
                handleOnClose(e);
            }
        });
    }, [
        isFocused,
        isLocalOpen,
        handleTriggerClicked,
        handleOnClose
    ]);
    /*
   * The Popup component requires either:
   * - shouldFitContainer={true} and shouldRenderToParent={true | undefined}
   * or
   * - shouldFitContainer={false | undefined} and shouldRenderToParent={true | false | undefined}
   *
   * But not:
   * - shouldFitContainer={true} and shouldRenderToParent={false}
   *
   * By only including either shouldFitContainer or shouldRenderToParent, we can ensure that the Popup component
   * types are satisfied.
   */ var conditionalProps = shouldFitContainer ? {
        shouldFitContainer: shouldFitContainer,
        // When shouldFitContainer is true, `fixed` positions are not allowed
        strategy: strategy !== 'fixed' ? strategy : undefined
    } : {
        shouldRenderToParent: shouldRenderToParent,
        strategy: strategy
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $0f3fe2fe00d41eb7$export$2e2bcd8739ae039), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $a2b7f495199a9de5$export$129a32eedafa97c5), (0, $4a7ae0731a7e1583$export$2e2bcd8739ae039)({
        id: isLocalOpen ? id : undefined,
        shouldFlip: shouldFlip,
        isOpen: isLocalOpen,
        shouldReturnFocus: // If returnFocusRef is provided, we **don't** want to return focus to the trigger.
        // Otherwise, Popup will focus on the dropdown trigger after the `returnFocusRef` element is focused.
        returnFocusRef === undefined,
        onClose: handleOnClose,
        zIndex: zIndex,
        placement: placement,
        role: shouldRenderToParent && currentLevel > 0 ? 'group' : undefined,
        fallbackPlacements: fallbackPlacements,
        testId: testId && "".concat(testId, "--content"),
        shouldUseCaptureOnOutsideClick: true,
        shouldIgnoreCloseEvent: shouldIgnoreCloseEvent
    }, conditionalProps, {
        shouldDisableFocusLock: true,
        trigger: function trigger(_ref2) {
            var ref = _ref2.ref, ariaControls = _ref2['aria-controls'], ariaExpanded = _ref2['aria-expanded'], ariaHasPopup = _ref2['aria-haspopup'], rest = (0, $b94f3d2584a27e94$export$2e2bcd8739ae039)(_ref2, $efa3e699f80dfb1c$var$_excluded);
            if (typeof _trigger === 'function') return _trigger($efa3e699f80dfb1c$var$_objectSpread($efa3e699f80dfb1c$var$_objectSpread($efa3e699f80dfb1c$var$_objectSpread({
                'aria-controls': ariaControls,
                'aria-expanded': ariaExpanded,
                'aria-haspopup': ariaHasPopup
            }, rest), bindFocus), {}, {
                triggerRef: (0, $db13a2f91f6a0f56$export$2e2bcd8739ae039)([
                    ref,
                    triggerRef,
                    itemRef
                ]),
                isSelected: isLocalOpen,
                onClick: handleTriggerClicked,
                testId: testId && "".concat(testId, "--trigger")
            }));
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $a21e01c03a9c4d94$export$2e2bcd8739ae039), (0, $4a7ae0731a7e1583$export$2e2bcd8739ae039)({}, bindFocus, {
                ref: (0, $db13a2f91f6a0f56$export$2e2bcd8739ae039)([
                    ref,
                    triggerRef,
                    itemRef
                ]),
                "aria-controls": ariaControls,
                "aria-expanded": ariaExpanded,
                "aria-haspopup": ariaHasPopup,
                isSelected: isLocalOpen,
                iconAfter: function iconAfter(iconProps) {
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($c63a1832a2581897$exports))), (0, $4a7ae0731a7e1583$export$2e2bcd8739ae039)({}, iconProps, {
                        size: "small"
                    }));
                },
                onClick: handleTriggerClicked,
                testId: testId && "".concat(testId, "--trigger"),
                "aria-label": label,
                interactionName: interactionName
            }), _trigger);
        },
        content: function content(_ref3) {
            var setInitialFocusRef = _ref3.setInitialFocusRef, update = _ref3.update;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $e09ee412fd2daea2$export$2e2bcd8739ae039), {
                onClose: handleOnClose
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $7e16aec66c845d90$export$2e2bcd8739ae039), {
                spacing: spacing,
                maxHeight: $efa3e699f80dfb1c$var$MAX_HEIGHT,
                maxWidth: shouldFitContainer ? undefined : 800,
                onClose: handleOnClose,
                onUpdate: update,
                isLoading: isLoading,
                statusLabel: statusLabel,
                setInitialFocusRef: isTriggeredUsingKeyboard || autoFocus ? setInitialFocusRef : undefined,
                shouldRenderToParent: shouldRenderToParent || shouldFitContainer,
                isTriggeredUsingKeyboard: isTriggeredUsingKeyboard,
                autoFocus: autoFocus,
                testId: testId && "".concat(testId, "--menu-wrapper"),
                menuLabel: menuLabel
            }, children));
        }
    })));
}
/**
 * __Dropdown menu__
 *
 * A dropdown menu displays a list of actions or options to a user.
 *
 * - [Examples](https://atlassian.design/components/dropdown-menu/examples)
 * - [Code](https://atlassian.design/components/dropdown-menu/code)
 * - [Usage](https://atlassian.design/components/dropdown-menu/usage)
 */ var $efa3e699f80dfb1c$var$DropdownMenu = function DropdownMenu(props) {
    var _props$autoFocus = props.autoFocus, autoFocus = _props$autoFocus === void 0 ? false : _props$autoFocus, children = props.children, _props$defaultOpen = props.defaultOpen, defaultOpen = _props$defaultOpen === void 0 ? false : _props$defaultOpen, _props$isLoading = props.isLoading, isLoading = _props$isLoading === void 0 ? false : _props$isLoading, isOpen = props.isOpen, _props$onOpenChange = props.onOpenChange, onOpenChange = _props$onOpenChange === void 0 ? (0, $adcefb868cf2fc9d$export$2e2bcd8739ae039) : _props$onOpenChange, _props$placement = props.placement, placement = _props$placement === void 0 ? 'bottom-start' : _props$placement, _props$shouldFitConta = props.shouldFitContainer, shouldFitContainer = _props$shouldFitConta === void 0 ? false : _props$shouldFitConta, returnFocusRef = props.returnFocusRef, spacing = props.spacing, statusLabel = props.statusLabel, testId = props.testId, trigger = props.trigger, label = props.label, interactionName = props.interactionName, menuLabel = props.menuLabel;
    if ((0, $50U6m.fg)('platform-dst-top-layer')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $6e4b0381575c2ec4$export$2e2bcd8739ae039), {
        autoFocus: autoFocus,
        children: children,
        defaultOpen: defaultOpen,
        isLoading: isLoading,
        isOpen: isOpen,
        onOpenChange: onOpenChange,
        placement: placement,
        shouldFitContainer: shouldFitContainer,
        returnFocusRef: returnFocusRef,
        spacing: spacing,
        statusLabel: statusLabel,
        testId: testId,
        trigger: trigger,
        label: label,
        interactionName: interactionName,
        menuLabel: menuLabel
    });
    // Forward full public props to the legacy Popper/Popup implementation unchanged.
    // eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props -- wrapper delegates entire DropdownMenuProps API
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement($efa3e699f80dfb1c$var$DropdownMenuLegacy, props);
};
var $efa3e699f80dfb1c$export$2e2bcd8739ae039 = $efa3e699f80dfb1c$var$DropdownMenu;





var $5FkrB = parcelRequire("5FkrB");

/* button-item.tsx generated by @compiled/babel-plugin v3.0.2 */ 


var $5FkrB = parcelRequire("5FkrB");


var $5FkrB = parcelRequire("5FkrB");
var $f8b9b04af0ac0a87$var$interactionContext = /*#__PURE__*/ (0, $5FkrB.createContext)(null);
var $f8b9b04af0ac0a87$export$2e2bcd8739ae039 = $f8b9b04af0ac0a87$var$interactionContext;


/* menu-item-primitive.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $5FkrB = parcelRequire("5FkrB");


var $50U6m = parcelRequire("50U6m");



var $c396d2949306f9df$var$renderTitle = function renderTitle(Component, props) {
    return(/*#__PURE__*/ // eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    $5FkrB.createElement(Component, props));
};
var $c396d2949306f9df$var$styles = {
    root: "_19itidpf _12ji1r31 _1qu2glyw _12y3idpf _4bfu1r31 _1hmsglyw _ajmmnqa1 _kqswh2mm _1e0c1txw _vchhusvi _1bsb1osq _1tke1ylp _1pfhze3t _12l2ze3t _6rthze3t _ahbqze3t _4cvr1h6o _uiztglyw _80omtlke _ymio1r31 _ypr0glyw _zcxs1o36 _nt751v1w _mizu1v1w _1bg41gjf _1ah31gjf _49pcnqa1 _ra3xnqa1 _1hvwdkaa _128mdkaa _9oik1r31 _1bnxglyw _jf4cnqa1 _1cvmnqa1 _4davt94y",
    beforeAfterElement: "_1e0c1txw _1ul91tcg _1tke1tcg _4cvr1h6o _1bah1h6o _1o9zidpf",
    content: "_12ji1r31 _1qu2glyw _12y31o36 _1reo15vq _18m915vq _1e0c1txw _2lx21bp4 _1bah1h6o _16jlkb7n _y3gn1e5h",
    truncate: "_1reo15vq _18m915vq _1e0c1ule _1bto1l2s _o5721q9c",
    title: "_11c8fhey",
    wordBreak: "_1nmz1hna",
    description: "_11c8wadc _syaz1rpy",
    disabledDescription: "_syaz1gmx",
    unselected: "_bfhksm61 _syaz1r31 _10531r31 _irr31dpa _30l31r31 _1di61dpa _9h8h1r31",
    disabled: "_80om13gf _bfhksm61 _syaz1gmx _irr3sm61 _30l31gmx _1di6sm61 _9h8h1gmx",
    selectedBorder: "_1mp4yh40 _1cs8stnw _1rusq98m _1kt9b3bt _1fkrze3t _iajmze3t _z5wtze3t",
    selectedNotch: "_rfx3bx74 _1mp41y44 _1cs8stnw _1rusq98m _1kt9b3bt _1fkrutpp _iajmutpp _z5wtze3t",
    selected: "_bfhk15s3 _syaz6x5g _10536x5g _irr3ufnl _30l316jw _1di6nozp _9h8h6x5g",
    selectedOld: "_30l36x5g",
    motionUnselected: "_v564hxmd _o7kshxmd _1ggl87vo",
    motionSelected: "_v5641rrn _o7kshxmd"
};
var $c396d2949306f9df$var$spacingMapStyles = {
    cozy: "_1rjcu2gc _18zrpxbi",
    compact: "_1rjc1b66 _18zrutpp _1tkezwfg"
};
var $c396d2949306f9df$var$gapMap = {
    compact: 'space.100',
    cozy: 'space.150'
};
/**
 * __Menu item primitive__
 *
 * Menu item primitive contains all the styles for menu items,
 * including support for selected, disabled, and interaction states.
 *
 * Using children as function prop you wire up this to your own host element.
 *
 * ```jsx
 * <MenuItemPrimitive>
 *   {({ children, ...props }) => <button {...props}>{children}</button>}
 * </MenuItemPrimitive>
 * ```
 */ var $c396d2949306f9df$var$MenuItemPrimitive = function MenuItemPrimitive(_ref) {
    var children = _ref.children, title = _ref.title, description = _ref.description, iconAfter = _ref.iconAfter, iconBefore = _ref.iconBefore, UNSAFE_externalClassName = _ref.className, _ref$shouldTitleWrap = _ref.shouldTitleWrap, shouldTitleWrap = _ref$shouldTitleWrap === void 0 ? false : _ref$shouldTitleWrap, _ref$shouldDescriptio = _ref.shouldDescriptionWrap, shouldDescriptionWrap = _ref$shouldDescriptio === void 0 ? false : _ref$shouldDescriptio, _ref$isDisabled = _ref.isDisabled, isDisabled = _ref$isDisabled === void 0 ? false : _ref$isDisabled, _ref$isSelected = _ref.isSelected, isSelected = _ref$isSelected === void 0 ? false : _ref$isSelected, _ref$isTitleHeading = _ref.isTitleHeading, isTitleHeading = _ref$isTitleHeading === void 0 ? false : _ref$isTitleHeading, testId = _ref.testId;
    var spacing = (0, $5FkrB.useContext)((0, $01cea6fab91f51f7$export$443076ec7ebce042));
    var selectionStyle = (0, $5FkrB.useContext)((0, $8b50a86dacab0fa0$export$9ca534b70725964d));
    var UNSAFE_className = UNSAFE_externalClassName;
    return function() {
        return children({
            className: (0, $3409454e8e68f10d$export$2e2bcd8739ae039)([
                (0, $3409454e8e68f10d$export$2e2bcd8739ae039)([
                    $c396d2949306f9df$var$styles.root,
                    $c396d2949306f9df$var$spacingMapStyles[spacing],
                    !isDisabled && !isSelected && $c396d2949306f9df$var$styles.unselected,
                    !isDisabled && !isSelected && (0, $50U6m.fg)('platform-dst-motion-uplift-list-item') && $c396d2949306f9df$var$styles.motionUnselected,
                    !isDisabled && isSelected && $c396d2949306f9df$var$styles.selected,
                    !isDisabled && isSelected && (0, $50U6m.fg)('platform-dst-motion-uplift-list-item') && $c396d2949306f9df$var$styles.motionSelected,
                    !isDisabled && isSelected && $c396d2949306f9df$var$styles.selectedOld,
                    !isDisabled && isSelected && selectionStyle === 'border' && $c396d2949306f9df$var$styles.selectedBorder,
                    !isDisabled && isSelected && selectionStyle === 'notch' && $c396d2949306f9df$var$styles.selectedNotch,
                    isDisabled && $c396d2949306f9df$var$styles.disabled
                ]),
                UNSAFE_className
            ]),
            children: /*#__PURE__*/ $5FkrB.createElement((0, $04267de539304abd$export$fbae5b5ffd8af05e), {
                as: "span",
                spread: "space-between",
                alignBlock: "center",
                space: $c396d2949306f9df$var$gapMap[spacing],
                grow: "fill",
                testId: testId && "".concat(testId, "--container")
            }, iconBefore && /*#__PURE__*/ $5FkrB.createElement("span", {
                "data-item-elem-before": true,
                "data-testid": testId && "".concat(testId, "--icon-before"),
                className: (0, $3409454e8e68f10d$export$2e2bcd8739ae039)([
                    $c396d2949306f9df$var$styles.beforeAfterElement
                ])
            }, iconBefore), title && /*#__PURE__*/ $5FkrB.createElement("div", {
                className: (0, $3409454e8e68f10d$export$2e2bcd8739ae039)([
                    $c396d2949306f9df$var$styles.content
                ])
            }, $c396d2949306f9df$var$renderTitle(isTitleHeading ? 'h2' : 'span', {
                children: title,
                className: (0, $3409454e8e68f10d$export$2e2bcd8739ae039)([
                    $c396d2949306f9df$var$styles.title,
                    shouldTitleWrap ? $c396d2949306f9df$var$styles.wordBreak : $c396d2949306f9df$var$styles.truncate
                ]),
                'data-item-title': true
            }), description && /*#__PURE__*/ $5FkrB.createElement("span", {
                "data-item-description": true,
                className: (0, $3409454e8e68f10d$export$2e2bcd8739ae039)([
                    $c396d2949306f9df$var$styles.description,
                    isDisabled && $c396d2949306f9df$var$styles.disabledDescription,
                    shouldDescriptionWrap && $c396d2949306f9df$var$styles.wordBreak,
                    !shouldDescriptionWrap && $c396d2949306f9df$var$styles.truncate
                ])
            }, description)), iconAfter && /*#__PURE__*/ $5FkrB.createElement("span", {
                "data-item-elem-after": true,
                "data-testid": testId && "".concat(testId, "--icon-after"),
                className: (0, $3409454e8e68f10d$export$2e2bcd8739ae039)([
                    $c396d2949306f9df$var$styles.beforeAfterElement
                ])
            }, iconAfter))
        });
    }();
};
var $c396d2949306f9df$export$2e2bcd8739ae039 = $c396d2949306f9df$var$MenuItemPrimitive;


var $80d344dca8e23c2b$var$_excluded = [
    "children",
    "description",
    "iconAfter",
    "iconBefore",
    "isDisabled",
    "isSelected",
    "onClick",
    "testId",
    "onMouseDown",
    "shouldTitleWrap",
    "shouldDescriptionWrap",
    "className",
    "interactionName"
];
/**
 * __Button item__
 *
 * A button item is used to populate a menu with items that are buttons.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/menu/docs/button-item)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/menu)
 */ var $80d344dca8e23c2b$var$ButtonItem = /*#__PURE__*/ (0, $5FkrB.memo)(/*#__PURE__*/ (0, $5FkrB.forwardRef)(function(props, ref) {
    var children = props.children, description = props.description, iconAfter = props.iconAfter, iconBefore = props.iconBefore, _props$isDisabled = props.isDisabled, isDisabled = _props$isDisabled === void 0 ? false : _props$isDisabled, _props$isSelected = props.isSelected, isSelected = _props$isSelected === void 0 ? false : _props$isSelected, onClick = props.onClick, testId = props.testId, onMouseDown = props.onMouseDown, shouldTitleWrap = props.shouldTitleWrap, shouldDescriptionWrap = props.shouldDescriptionWrap, UNSAFE_className = props.className, interactionName = props.interactionName, rest = (0, $b94f3d2584a27e94$export$2e2bcd8739ae039)(props, $80d344dca8e23c2b$var$_excluded);
    var onMouseDownHandler = onMouseDown;
    var interactionContext = (0, $5FkrB.useContext)((0, $f8b9b04af0ac0a87$export$2e2bcd8739ae039));
    var handleClick = (0, $5FkrB.useCallback)(function(e) {
        interactionContext === null || interactionContext === void 0 || interactionContext.tracePress(interactionName, e.timeStamp);
        onClick === null || onClick === void 0 || onClick(e);
    }, [
        onClick,
        interactionContext,
        interactionName
    ]);
    if (!children) return null;
    return /*#__PURE__*/ $5FkrB.createElement((0, $c396d2949306f9df$export$2e2bcd8739ae039), (0, $4a7ae0731a7e1583$export$2e2bcd8739ae039)({
        className: UNSAFE_className
    }, rest, {
        iconBefore: iconBefore,
        iconAfter: iconAfter,
        isDisabled: isDisabled,
        isSelected: isSelected,
        isTitleHeading: false,
        description: description,
        title: children,
        shouldTitleWrap: shouldTitleWrap,
        shouldDescriptionWrap: shouldDescriptionWrap,
        testId: testId && "".concat(testId, "--primitive")
    }), function(_ref) {
        var children = _ref.children, className = _ref.className;
        return /*#__PURE__*/ $5FkrB.createElement("button", (0, $4a7ae0731a7e1583$export$2e2bcd8739ae039)({
            "data-testid": testId,
            "aria-current": isSelected ? 'true' : undefined
        }, rest, {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: className,
            ref: ref,
            disabled: isDisabled,
            onClick: handleClick,
            onMouseDown: onMouseDownHandler,
            type: "button"
        }), children);
    });
}));
var $80d344dca8e23c2b$export$2e2bcd8739ae039 = $80d344dca8e23c2b$var$ButtonItem;


/* custom-item.tsx generated by @compiled/babel-plugin v3.0.2 */ 


var $5FkrB = parcelRequire("5FkrB");



var $3f0cbea440f9628b$var$_excluded = [
    "component",
    "isDisabled",
    "isSelected",
    "isTitleHeading",
    "onClick",
    "testId",
    "children",
    "description",
    "iconAfter",
    "iconBefore",
    "onMouseDown",
    "shouldTitleWrap",
    "shouldDescriptionWrap",
    "className",
    "UNSAFE_isDraggable",
    "interactionName"
];
var $3f0cbea440f9628b$var$preventEvent = function preventEvent(e) {
    e.preventDefault();
};
// Dirty hack to get generics working with forward ref [1/2]
/**
 * __Custom item__
 *
 * A custom item is used to populate a menu with items that can be any element.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/menu/docs/custom-item)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/menu)
 */ var $3f0cbea440f9628b$var$CustomItem = /*#__PURE__*/ (0, $5FkrB.memo)(/*#__PURE__*/ (0, $5FkrB.forwardRef)(function(_ref, ref) {
    var Component = _ref.component, _ref$isDisabled = _ref.isDisabled, isDisabled = _ref$isDisabled === void 0 ? false : _ref$isDisabled, _ref$isSelected = _ref.isSelected, isSelected = _ref$isSelected === void 0 ? false : _ref$isSelected, _ref$isTitleHeading = _ref.isTitleHeading, isTitleHeading = _ref$isTitleHeading === void 0 ? false : _ref$isTitleHeading, onClick = _ref.onClick, testId = _ref.testId, children = _ref.children, description = _ref.description, iconAfter = _ref.iconAfter, iconBefore = _ref.iconBefore, onMouseDown = _ref.onMouseDown, shouldTitleWrap = _ref.shouldTitleWrap, shouldDescriptionWrap = _ref.shouldDescriptionWrap, UNSAFE_className = _ref.className, UNSAFE_isDraggable = _ref.UNSAFE_isDraggable, interactionName = _ref.interactionName, rest = (0, $b94f3d2584a27e94$export$2e2bcd8739ae039)(_ref, $3f0cbea440f9628b$var$_excluded);
    var onMouseDownHandler = onMouseDown;
    var interactionContext = (0, $5FkrB.useContext)((0, $f8b9b04af0ac0a87$export$2e2bcd8739ae039));
    var handleClick = (0, $5FkrB.useCallback)(function(e) {
        interactionContext === null || interactionContext === void 0 || interactionContext.tracePress(interactionName, e.timeStamp);
        onClick === null || onClick === void 0 || onClick(e);
    }, [
        onClick,
        interactionContext,
        interactionName
    ]);
    if (!Component) return null;
    return /*#__PURE__*/ $5FkrB.createElement((0, $c396d2949306f9df$export$2e2bcd8739ae039), (0, $4a7ae0731a7e1583$export$2e2bcd8739ae039)({
        className: UNSAFE_className
    }, rest, {
        description: description,
        iconAfter: iconAfter,
        title: children,
        iconBefore: iconBefore,
        isSelected: isSelected,
        isDisabled: isDisabled,
        isTitleHeading: isTitleHeading,
        shouldTitleWrap: shouldTitleWrap,
        shouldDescriptionWrap: shouldDescriptionWrap,
        testId: testId && "".concat(testId, "--primitive")
    }), function(_ref2) {
        var children = _ref2.children, className = _ref2.className;
        return /*#__PURE__*/ $5FkrB.createElement(Component, (0, $4a7ae0731a7e1583$export$2e2bcd8739ae039)({
            "data-testid": testId
        }, rest, {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: className,
            ref: ref
        }, UNSAFE_isDraggable ? {} : {
            draggable: false,
            onDragStart: $3f0cbea440f9628b$var$preventEvent
        }, {
            onMouseDown: isDisabled ? $3f0cbea440f9628b$var$preventEvent : onMouseDownHandler,
            onClick: isDisabled ? $3f0cbea440f9628b$var$preventEvent : handleClick,
            tabIndex: isDisabled ? -1 : undefined,
            "aria-disabled": isDisabled || undefined
        }), children);
    });
}));
var $3f0cbea440f9628b$export$2e2bcd8739ae039 = $3f0cbea440f9628b$var$CustomItem;


/* link-item.tsx generated by @compiled/babel-plugin v3.0.2 */ 


var $5FkrB = parcelRequire("5FkrB");


var $5FkrB = parcelRequire("5FkrB");

var $5FkrB = parcelRequire("5FkrB");
var $9a82c0f90aa1e4d5$export$2931e0ee690eee88 = /*#__PURE__*/ (0, $5FkrB.createContext)({});
/**
 * __RouterLinkProvider__
 *
 * Provides a configured router link component for use
 * within Design System components.
 */ var $9a82c0f90aa1e4d5$var$RouterLinkProvider = function RouterLinkProvider(_ref) {
    var routerLinkComponent = _ref.routerLinkComponent, children = _ref.children;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement($9a82c0f90aa1e4d5$export$2931e0ee690eee88.Provider, {
        value: {
            routerLinkComponent: routerLinkComponent
        }
    }, children);
};
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$9a82c0f90aa1e4d5$export$2e2bcd8739ae039 = $9a82c0f90aa1e4d5$var$RouterLinkProvider;


var $3ce59f172dd76f40$export$6d558eab13290f59 = function useRouterLink() {
    var _useContext = (0, $5FkrB.useContext)((0, $9a82c0f90aa1e4d5$export$2931e0ee690eee88)), routerLinkComponent = _useContext.routerLinkComponent;
    if (routerLinkComponent) return routerLinkComponent;
    return;
};




var $805767daeccc2a7c$var$_excluded = [
    "children",
    "href",
    "description",
    "iconAfter",
    "iconBefore",
    "isDisabled",
    "isSelected",
    "onClick",
    "testId",
    "onMouseDown",
    "shouldTitleWrap",
    "shouldDescriptionWrap",
    "className",
    "UNSAFE_shouldDisableRouterLink",
    "UNSAFE_isDraggable",
    "interactionName"
];
var $805767daeccc2a7c$var$IS_EXTERNAL_LINK_REGEX = /^(?:(http|https):\/\/)/;
var $805767daeccc2a7c$var$IS_NON_HTTP_BASED = /^(((mailto|tel|sms):)|(#))/;
var $805767daeccc2a7c$var$preventEvent = function preventEvent(e) {
    e.preventDefault();
};
/**
 * __Link item__
 *
 * A link item is used to populate a menu with items that are links.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/menu/docs/link-item)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/menu)
 */ var $805767daeccc2a7c$var$LinkItem = /*#__PURE__*/ (0, $5FkrB.memo)(/*#__PURE__*/ (0, $5FkrB.forwardRef)(function(props, ref) {
    var children = props.children, href = props.href, description = props.description, iconAfter = props.iconAfter, iconBefore = props.iconBefore, _props$isDisabled = props.isDisabled, isDisabled = _props$isDisabled === void 0 ? false : _props$isDisabled, _props$isSelected = props.isSelected, isSelected = _props$isSelected === void 0 ? false : _props$isSelected, onClick = props.onClick, testId = props.testId, onMouseDown = props.onMouseDown, shouldTitleWrap = props.shouldTitleWrap, shouldDescriptionWrap = props.shouldDescriptionWrap, UNSAFE_className = props.className, UNSAFE_shouldDisableRouterLink = props.UNSAFE_shouldDisableRouterLink, UNSAFE_isDraggable = props.UNSAFE_isDraggable, interactionName = props.interactionName, rest = (0, $b94f3d2584a27e94$export$2e2bcd8739ae039)(props, $805767daeccc2a7c$var$_excluded);
    var onMouseDownHandler = onMouseDown;
    var RouterLink = (0, $3ce59f172dd76f40$export$6d558eab13290f59)();
    var interactionContext = (0, $5FkrB.useContext)((0, $f8b9b04af0ac0a87$export$2e2bcd8739ae039));
    var handleClick = (0, $5FkrB.useCallback)(function(e) {
        interactionContext === null || interactionContext === void 0 || interactionContext.tracePress(interactionName, e.timeStamp);
        onClick === null || onClick === void 0 || onClick(e);
    }, [
        onClick,
        interactionContext,
        interactionName
    ]);
    if (!children) return null;
    var isExternal = typeof href === 'string' && $805767daeccc2a7c$var$IS_EXTERNAL_LINK_REGEX.test(href);
    var isNonHttpBased = typeof href === 'string' && $805767daeccc2a7c$var$IS_NON_HTTP_BASED.test(href);
    var isEmptyHref = href == null || href === '';
    /**
   * Renders a router link if:
   *
   * - a link component is set in the app provider
   * - it's not an external link (starting with `http://` or `https://`)
   * - it's not a non-HTTP-based link (e.g. emails, phone numbers, hash links etc.)
   * - it doesn't have an empty href (e.g. href="" or href={undefined})
   */ var isRouterLink = !UNSAFE_shouldDisableRouterLink && RouterLink && !isExternal && !isNonHttpBased && !isEmptyHref;
    var Component = isRouterLink ? RouterLink : 'a';
    return /*#__PURE__*/ $5FkrB.createElement((0, $c396d2949306f9df$export$2e2bcd8739ae039), (0, $4a7ae0731a7e1583$export$2e2bcd8739ae039)({}, rest, {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: UNSAFE_className,
        iconBefore: iconBefore,
        iconAfter: iconAfter,
        isSelected: isSelected,
        isDisabled: isDisabled,
        isTitleHeading: false,
        description: description,
        shouldTitleWrap: shouldTitleWrap,
        shouldDescriptionWrap: shouldDescriptionWrap,
        title: children,
        testId: testId && "".concat(testId, "--primitive")
    }), function(_ref) {
        var children = _ref.children, className = _ref.className;
        return /*#__PURE__*/ $5FkrB.createElement(Component, (0, $4a7ae0731a7e1583$export$2e2bcd8739ae039)({
            "data-testid": testId,
            "data-is-router-link": testId ? isRouterLink ? 'true' : 'false' : undefined,
            "data-vc": "link-item"
        }, rest, {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: className,
            href: isDisabled ? undefined : href
        }, UNSAFE_isDraggable ? {} : {
            draggable: false,
            onDragStart: $805767daeccc2a7c$var$preventEvent
        }, {
            onMouseDown: isDisabled ? $805767daeccc2a7c$var$preventEvent : onMouseDownHandler,
            onClick: isDisabled ? $805767daeccc2a7c$var$preventEvent : handleClick,
            "aria-current": isSelected ? 'page' : undefined,
            "aria-disabled": isDisabled || undefined,
            ref: ref
        }), children);
    });
}));
var $805767daeccc2a7c$export$2e2bcd8739ae039 = $805767daeccc2a7c$var$LinkItem;



var $50U6m = parcelRequire("50U6m");

var $80616e41d77620e9$var$_excluded = [
    "children",
    "component",
    "description",
    "elemAfter",
    "elemBefore",
    "href",
    "isDisabled",
    "isSelected",
    "onClick",
    "rel",
    "shouldDescriptionWrap",
    "shouldTitleWrap",
    "target",
    "testId",
    "UNSAFE_shouldDisableRouterLink",
    "returnFocusRef",
    "interactionName",
    "role"
];
/**
 * __Dropdown menu item__
 *
 * A dropdown item populates the dropdown menu with items. Every item should be inside a dropdown item group.
 *
 * - [Examples](https://atlassian.design/components/dropdown-menu/dropdown-item/examples)
 * - [Code](https://atlassian.design/components/dropdown-menu/dropdown-item/code)
 * - [Usage](https://atlassian.design/components/dropdown-menu/dropdown-item/usage)
 */ var $80616e41d77620e9$var$DropdownMenuItem = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function(_ref, ref) {
    var children = _ref.children, component = _ref.component, description = _ref.description, elemAfter = _ref.elemAfter, elemBefore = _ref.elemBefore, href = _ref.href, isDisabled = _ref.isDisabled, isSelected = _ref.isSelected, onClick = _ref.onClick, rel = _ref.rel, _ref$shouldDescriptio = _ref.shouldDescriptionWrap, shouldDescriptionWrap = _ref$shouldDescriptio === void 0 ? true : _ref$shouldDescriptio, _ref$shouldTitleWrap = _ref.shouldTitleWrap, shouldTitleWrap = _ref$shouldTitleWrap === void 0 ? true : _ref$shouldTitleWrap, target = _ref.target, testId = _ref.testId, UNSAFE_shouldDisableRouterLink = _ref.UNSAFE_shouldDisableRouterLink, returnFocusRef = _ref.returnFocusRef, interactionName = _ref.interactionName, role = _ref.role, rest = (0, $b94f3d2584a27e94$export$2e2bcd8739ae039)(_ref, $80616e41d77620e9$var$_excluded);
    // if the dropdown item has aria-haspopup, we won't register with focus manager
    // since it is a nested trigger, we have registered inside dropdown-menu
    var isNestedTrigger = !!rest['aria-haspopup'];
    var itemRef = (0, $1157ce92c724a1fa$export$2e2bcd8739ae039)(isNestedTrigger);
    var handleItemClick = (0, $5FkrB.useCallback)(function(event) {
        if (returnFocusRef !== null && returnFocusRef !== void 0 && returnFocusRef.current) returnFocusRef.current.focus();
        if (onClick) onClick(event);
    }, [
        onClick,
        returnFocusRef
    ]);
    if (component) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $3f0cbea440f9628b$export$2e2bcd8739ae039), (0, $4a7ae0731a7e1583$export$2e2bcd8739ae039)({
        component: component,
        description: description,
        iconAfter: elemAfter,
        iconBefore: elemBefore,
        isDisabled: isDisabled,
        isSelected: isSelected,
        onClick: handleItemClick,
        ref: (0, $db13a2f91f6a0f56$export$2e2bcd8739ae039)([
            ref,
            itemRef
        ]),
        shouldDescriptionWrap: shouldDescriptionWrap,
        shouldTitleWrap: shouldTitleWrap,
        testId: testId,
        href: href,
        target: target,
        rel: rel,
        interactionName: interactionName
    }, rest), children);
    else if (href) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $805767daeccc2a7c$export$2e2bcd8739ae039), (0, $4a7ae0731a7e1583$export$2e2bcd8739ae039)({
        description: description,
        href: href,
        iconAfter: elemAfter,
        iconBefore: elemBefore,
        isDisabled: isDisabled,
        isSelected: isSelected,
        onClick: handleItemClick,
        ref: (0, $db13a2f91f6a0f56$export$2e2bcd8739ae039)([
            ref,
            itemRef
        ]),
        rel: rel,
        role: "menuitem",
        shouldDescriptionWrap: shouldDescriptionWrap,
        shouldTitleWrap: shouldTitleWrap,
        target: target,
        testId: testId,
        UNSAFE_shouldDisableRouterLink: UNSAFE_shouldDisableRouterLink,
        interactionName: interactionName
    }, rest), children);
    else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $80d344dca8e23c2b$export$2e2bcd8739ae039), (0, $4a7ae0731a7e1583$export$2e2bcd8739ae039)({
        description: description,
        iconAfter: elemAfter,
        iconBefore: elemBefore,
        isDisabled: isDisabled,
        isSelected: isSelected,
        onClick: handleItemClick,
        ref: (0, $db13a2f91f6a0f56$export$2e2bcd8739ae039)([
            ref,
            itemRef
        ]),
        role: role || 'menuitem',
        shouldDescriptionWrap: shouldDescriptionWrap,
        shouldTitleWrap: shouldTitleWrap,
        testId: testId,
        target: target,
        rel: rel,
        interactionName: interactionName
    }, rest, isNestedTrigger && (0, $50U6m.fg)('platform_dst_dropdown_nested_trigger_aria_current') ? {
        'aria-current': undefined
    } : {}), children);
});
var $80616e41d77620e9$export$2e2bcd8739ae039 = $80616e41d77620e9$var$DropdownMenuItem;





var $5FkrB = parcelRequire("5FkrB");

/* section.tsx generated by @compiled/babel-plugin v3.0.2 */ 


var $5FkrB = parcelRequire("5FkrB");

/* heading-item.tsx generated by @compiled/babel-plugin v3.0.2 */ 


var $5FkrB = parcelRequire("5FkrB");

var $febaf2c5b093b9e1$var$_excluded = [
    "children",
    "testId",
    "headingLevel",
    "id",
    "className"
];
var $febaf2c5b093b9e1$var$headingStyles = null;
/**
 * __Heading item__
 *
 * A heading item is used to describe sibling menu items.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/menu/docs/heading-item)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/menu)
 */ var $febaf2c5b093b9e1$var$HeadingItem = /*#__PURE__*/ (0, $5FkrB.memo)(function(_ref) {
    var children = _ref.children, testId = _ref.testId, _ref$headingLevel = _ref.headingLevel, headingLevel = _ref$headingLevel === void 0 ? 2 : _ref$headingLevel, id = _ref.id, UNSAFE_className = _ref.className, rest = (0, $b94f3d2584a27e94$export$2e2bcd8739ae039)(_ref, $febaf2c5b093b9e1$var$_excluded);
    return /*#__PURE__*/ $5FkrB.createElement("div", (0, $4a7ae0731a7e1583$export$2e2bcd8739ae039)({
        role: "heading",
        "aria-level": headingLevel,
        "data-testid": testId,
        "data-ds--menu--heading-item": true,
        id: id,
        className: (0, $3409454e8e68f10d$export$2e2bcd8739ae039)([
            "_11c8i4vh _1rjcze3t _18zrpxbi _syazazsu",
            UNSAFE_className
        ])
    }, rest), children);
});
var $febaf2c5b093b9e1$export$2e2bcd8739ae039 = $febaf2c5b093b9e1$var$HeadingItem;


var $72430498340681e6$var$_excluded = [
    "children",
    "title",
    "titleId",
    "testId",
    "isScrollable",
    "hasSeparator",
    "id",
    "isList",
    "isSideNavSection",
    "label",
    "className"
];
var $72430498340681e6$var$itemHeadingTopMargin = 20;
var $72430498340681e6$var$itemHeadingBottomMargin = 6;
// Skeleton content is slightly shorter than the real content.
// Because of that we slightly increase the top margin to offset this so the
// containing size both real and skeleton always equal approx 30px.
var $72430498340681e6$var$itemHeadingContentHeight = 16; // Originally headingSizes.h100.lineHeight from '@atlaskit/theme/typography'
var $72430498340681e6$var$skeletonHeadingHeight = 8;
var $72430498340681e6$var$skeletonHeadingMarginOffset = 3;
var $72430498340681e6$var$skeletonHeadingTopMargin = $72430498340681e6$var$itemHeadingTopMargin + ($72430498340681e6$var$itemHeadingContentHeight - $72430498340681e6$var$skeletonHeadingHeight) - $72430498340681e6$var$skeletonHeadingMarginOffset;
var $72430498340681e6$var$sectionPaddingTopBottom = 6;
var $72430498340681e6$var$styles = {
    root: "_1ywu1ule _cfu11ule _1qdgi2wt _kfgti2wt _aetrb3bt _1kt9b3bt _1p3hi2wt _1l6bgktf _osbldlk8 _auo4rdoj _hp2110yn _1mfv8jkm _1bg41n1a",
    scrollable: "_1reo1wug _18m91wug _1o9zkb7n",
    unscrollable: "_1o9zidpf",
    thinSeparator: "_mqm2lllh",
    noSeparator: "_n7cnyjp0",
    sideNavSectionHeading: "_18zru2gc"
};
/**
 * __Section__
 *
 * A section includes related actions or items in a menu.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/menu/docs/section)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/menu)
 */ var $72430498340681e6$var$Section = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function(_ref, ref) {
    var children = _ref.children, title = _ref.title, titleId = _ref.titleId, testId = _ref.testId, isScrollable = _ref.isScrollable, hasSeparator = _ref.hasSeparator, id = _ref.id, _ref$isList = _ref.isList, isList = _ref$isList === void 0 ? false : _ref$isList, _ref$isSideNavSection = _ref.isSideNavSection, isSideNavSection = _ref$isSideNavSection === void 0 ? false : _ref$isSideNavSection, label = _ref.label, UNSAFE_className = _ref.className, rest = (0, $b94f3d2584a27e94$export$2e2bcd8739ae039)(_ref, $72430498340681e6$var$_excluded);
    var content = isList ? /*#__PURE__*/ $5FkrB.createElement("ul", {
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            margin: 0,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            padding: 0
        }
    }, (0, $5FkrB.Children).map((0, $5FkrB.Children).toArray(children), function(child, index) {
        return /*#__PURE__*/ $5FkrB.createElement("li", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            style: {
                listStyleType: 'none',
                margin: 0,
                padding: 0
            },
            key: index
        }, child);
    })) : children;
    var childrenMarkup = title !== undefined ? /*#__PURE__*/ $5FkrB.createElement((0, $5FkrB.Fragment), null, /*#__PURE__*/ $5FkrB.createElement((0, $febaf2c5b093b9e1$export$2e2bcd8739ae039), {
        testId: testId && "".concat(testId, "--heading"),
        "aria-hidden": true,
        className: (0, $3409454e8e68f10d$export$2e2bcd8739ae039)([
            isSideNavSection && $72430498340681e6$var$styles.sideNavSectionHeading
        ])
    }, title), content) : /*#__PURE__*/ $5FkrB.createElement((0, $5FkrB.Fragment), null, content);
    return /*#__PURE__*/ $5FkrB.createElement("div", (0, $4a7ae0731a7e1583$export$2e2bcd8739ae039)({}, rest, {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $3409454e8e68f10d$export$2e2bcd8739ae039)([
            $72430498340681e6$var$styles.root,
            isScrollable ? $72430498340681e6$var$styles.scrollable : $72430498340681e6$var$styles.unscrollable,
            hasSeparator ? $72430498340681e6$var$styles.thinSeparator : $72430498340681e6$var$styles.noSeparator,
            UNSAFE_className
        ]),
        id: id,
        "aria-label": title || label,
        "aria-labelledby": titleId,
        "data-testid": testId,
        role: "group",
        "data-section": true,
        ref: ref
    }), childrenMarkup);
});
var $72430498340681e6$export$2e2bcd8739ae039 = $72430498340681e6$var$Section;


/* group-title.tsx generated by @compiled/babel-plugin v3.0.2 */ 

var $5FkrB = parcelRequire("5FkrB");

var $d5ab8a6d27952d68$var$styles = {
    heading: "_11c8i4vh _1rjcze3t _18zrpxbi _syazazsu"
};
/**
 * __Group title__
 *
 * Used to visually represent the title for DropdownMenu groups.
 *
 * Pre-existing a11y note: uses `role="menuitem"` with `aria-hidden="true"`.
 * WAI-ARIA APG recommends `role="presentation"` for non-interactive group
 * headings, with the group linked via `aria-labelledby`. Out of scope for
 * the top-layer migration — this is legacy behavior.
 *
 * @internal
 */ var $d5ab8a6d27952d68$var$GroupTitle = function GroupTitle(_ref) {
    var id = _ref.id, title = _ref.title;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $7a49b1df02a75aca$export$e71c4d32a2263218), {
        "data-ds--menu--heading-item": true,
        role: "menuitem",
        id: id,
        "aria-hidden": "true",
        xcss: $d5ab8a6d27952d68$var$styles.heading
    }, title);
};
var $d5ab8a6d27952d68$export$2e2bcd8739ae039 = $d5ab8a6d27952d68$var$GroupTitle;


var $a511aba2d268bdcc$var$_excluded = [
    "children",
    "id",
    "isList",
    "isScrollable",
    "title",
    "testId",
    "hasSeparator"
];
/**
 * __Dropdown item checkbox group__
 *
 * A wrapping element for dropdown menu items.
 *
 */ var $a511aba2d268bdcc$var$DropdownMenuItemGroup = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function(_ref, ref) {
    var children = _ref.children, id = _ref.id, isList = _ref.isList, isScrollable = _ref.isScrollable, title = _ref.title, testId = _ref.testId, hasSeparator = _ref.hasSeparator, rest = (0, $b94f3d2584a27e94$export$2e2bcd8739ae039)(_ref, $a511aba2d268bdcc$var$_excluded);
    var uid = (0, $c797bf80d6171378$export$f680877a34711e37)();
    var titleId = "dropdown-menu-item-group-title-".concat(uid);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $72430498340681e6$export$2e2bcd8739ae039), (0, $4a7ae0731a7e1583$export$2e2bcd8739ae039)({
        id: id,
        ref: ref,
        isList: isList,
        isScrollable: isScrollable,
        hasSeparator: hasSeparator,
        testId: testId,
        titleId: title ? titleId : undefined
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $d5ab8a6d27952d68$export$2e2bcd8739ae039), {
        id: titleId,
        title: title
    }), children);
});
var $a511aba2d268bdcc$export$2e2bcd8739ae039 = $a511aba2d268bdcc$var$DropdownMenuItemGroup;






var $5FkrB = parcelRequire("5FkrB");




/* radio-icon.tsx generated by @compiled/babel-plugin v3.0.2 */ 

var $5FkrB = parcelRequire("5FkrB");
var $0849c816eed85fb7$var$svgStyles = null;
/**
 * __Radio icon__
 *
 * Used to visually represent the selected state in DropdownItemRadio
 *
 * @internal
 */ var $0849c816eed85fb7$var$RadioIcon = function RadioIcon(_ref) {
    var checked = _ref.checked;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("svg", {
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            color: checked ? "var(--ds-background-selected-bold, #1868DB)" : "var(--ds-background-input, #FFFFFF)",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            fill: checked ? "var(--ds-icon-inverse, #FFFFFF)" : 'transparent'
        },
        role: "presentation",
        className: (0, $3409454e8e68f10d$export$2e2bcd8739ae039)([
            "_1reo15vq _18m915vq _lswuvuon _lcxvglyw"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("g", {
        fillRule: "evenodd"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("circle", {
        cx: "12",
        cy: "12",
        r: "7.5",
        fill: "currentColor",
        stroke: checked ? "var(--ds-border-selected, #1868DB)" : "var(--ds-border-input, #8C8F97)",
        strokeWidth: "1"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("circle", {
        cx: "12",
        cy: "12",
        r: "3",
        fill: "inherit"
    })));
};
var $0849c816eed85fb7$export$2e2bcd8739ae039 = $0849c816eed85fb7$var$RadioIcon;





var $5FkrB = parcelRequire("5FkrB");

var $5FkrB = parcelRequire("5FkrB");

var $10615679676e7022$export$a79eda4ff50e30b6 = /*#__PURE__*/ (0, $5FkrB.createContext)({
    id: '',
    radioGroupState: {},
    selectRadioItem: (0, $adcefb868cf2fc9d$export$2e2bcd8739ae039)
});



function $67be4ac78e1edcf0$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $67be4ac78e1edcf0$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $67be4ac78e1edcf0$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $a48c245bf23e2005$export$2e2bcd8739ae039)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $67be4ac78e1edcf0$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $67be4ac78e1edcf0$var$useRadioState(_ref) {
    var id = _ref.id, isSelected = _ref.isSelected, defaultSelected = _ref.defaultSelected;
    var _useContext = (0, $5FkrB.useContext)((0, $e713914be6d6449b$export$756f795847463ebd)), setGroupState = _useContext.setGroupState, getGroupState = _useContext.getGroupState;
    var _useContext2 = (0, $5FkrB.useContext)((0, $10615679676e7022$export$a79eda4ff50e30b6)), group = _useContext2.id, radioGroupState = _useContext2.radioGroupState, selectRadioItem = _useContext2.selectRadioItem;
    var persistedIsSelected = radioGroupState[id];
    var _useState = (0, $5FkrB.useState)(function() {
        return persistedIsSelected !== undefined ? persistedIsSelected : defaultSelected || false;
    }), _useState2 = (0, $fe9ce0f81f7af2c1$export$2e2bcd8739ae039)(_useState, 2), localIsSelected = _useState2[0], setLocalIsSelected = _useState2[1];
    var setLocalState = (0, $5FkrB.useCallback)(function(newValue) {
        if (!persistedIsSelected) {
            var nextValue = newValue(persistedIsSelected);
            selectRadioItem(id, nextValue);
            setLocalIsSelected(nextValue);
        }
    }, [
        persistedIsSelected,
        id,
        selectRadioItem
    ]);
    /**
   * - radio state changes any time a radio child is changed
   * - when it changes we want all radio buttons to update their local state
   * - it takes the value from radio group state and applies it locally if it exists which it will only exist, if it is selected
   */ (0, $5FkrB.useEffect)(function() {
        setLocalIsSelected(function() {
            var existing = radioGroupState[id];
            return existing !== undefined ? existing : defaultSelected || false;
        });
    }, [
        radioGroupState,
        group,
        id,
        defaultSelected
    ]);
    if (typeof isSelected === 'boolean') return [
        isSelected,
        function() {
            return false;
        }
    ];
    /**
   * Set the initial state of the context provider's store,
   * if it doesn't already have a persisted value for this id.
   */ if (persistedIsSelected === undefined) {
        var existing = getGroupState(group);
        var newGroupState = $67be4ac78e1edcf0$var$_objectSpread($67be4ac78e1edcf0$var$_objectSpread({}, existing), {}, (0, $a48c245bf23e2005$export$2e2bcd8739ae039)({}, id, defaultSelected || false));
        setGroupState(group, newGroupState);
    }
    return [
        localIsSelected,
        setLocalState
    ];
}
var $67be4ac78e1edcf0$export$2e2bcd8739ae039 = $67be4ac78e1edcf0$var$useRadioState;




var $3ZMUU = parcelRequire("3ZMUU");
var $506b749c17906ee8$var$_excluded = [
    "children",
    "defaultSelected",
    "testId",
    "id",
    "title",
    "description",
    "isDisabled",
    "isSelected",
    "onClick",
    "shouldDescriptionWrap",
    "shouldTitleWrap",
    "interactionName"
];
/**
 * __Dropdown item radio__
 *
 * A dropdown item radio displays groups that have a single selection.
 *
 * - [Examples](https://atlassian.design/components/dropdown-menu/dropdown-item-radio/examples)
 * - [Code](https://atlassian.design/components/dropdown-menu/dropdown-item-radio/code)
 * - [Usage](https://atlassian.design/components/dropdown-menu/dropdown-item-radio/usage)
 */ var $506b749c17906ee8$var$DropdownItemRadio = function DropdownItemRadio(_ref) {
    var children = _ref.children, defaultSelected = _ref.defaultSelected, testId = _ref.testId, id = _ref.id, title = _ref.title, description = _ref.description, isDisabled = _ref.isDisabled, isSelected = _ref.isSelected, _ref$onClick = _ref.onClick, providedOnClick = _ref$onClick === void 0 ? (0, $adcefb868cf2fc9d$export$2e2bcd8739ae039) : _ref$onClick, _ref$shouldDescriptio = _ref.shouldDescriptionWrap, shouldDescriptionWrap = _ref$shouldDescriptio === void 0 ? true : _ref$shouldDescriptio, _ref$shouldTitleWrap = _ref.shouldTitleWrap, shouldTitleWrap = _ref$shouldTitleWrap === void 0 ? true : _ref$shouldTitleWrap, interactionName = _ref.interactionName, rest = (0, $b94f3d2584a27e94$export$2e2bcd8739ae039)(_ref, $506b749c17906ee8$var$_excluded);
    typeof $3ZMUU;
    var _useRadioState = (0, $67be4ac78e1edcf0$export$2e2bcd8739ae039)({
        id: id,
        isSelected: isSelected,
        defaultSelected: defaultSelected
    }), _useRadioState2 = (0, $fe9ce0f81f7af2c1$export$2e2bcd8739ae039)(_useRadioState, 2), selected = _useRadioState2[0], setSelected = _useRadioState2[1];
    var onClickHandler = (0, $5FkrB.useCallback)(function(event) {
        setSelected(function(selected) {
            return !selected;
        });
        providedOnClick(event);
    }, [
        providedOnClick,
        setSelected
    ]);
    var itemRef = (0, $1157ce92c724a1fa$export$2e2bcd8739ae039)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $8b50a86dacab0fa0$export$9ca534b70725964d).Provider, {
        value: "none"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $80d344dca8e23c2b$export$2e2bcd8739ae039), (0, $4a7ae0731a7e1583$export$2e2bcd8739ae039)({
        "aria-checked": selected,
        "aria-describedby": "".concat(id, "-radio"),
        description: description,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $0849c816eed85fb7$export$2e2bcd8739ae039), {
            checked: selected
        }),
        id: id,
        isDisabled: isDisabled,
        isSelected: selected,
        onClick: onClickHandler,
        ref: itemRef,
        role: "menuitemradio",
        shouldDescriptionWrap: shouldDescriptionWrap,
        shouldTitleWrap: shouldTitleWrap,
        testId: testId,
        title: title,
        interactionName: interactionName
    }, rest, {
        // Override ButtonItem's default aria-current, as aria-checked is the correct attribute for menuitemradio (A11Y-37930)
        "aria-current": undefined
    }), children), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $a4a1a9cdc7bf2d54$export$2e2bcd8739ae039), {
        id: "".concat(id, "-radio")
    }, "radio button ", selected));
};
var $506b749c17906ee8$export$2e2bcd8739ae039 = $506b749c17906ee8$var$DropdownItemRadio;


var $7d8ced6060a88250$exports = {};
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::da37f0a43857e8b8e953de1c778f2dc8>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty($7d8ced6060a88250$exports, "__esModule", {
    value: true
});
$7d8ced6060a88250$exports.default = void 0;

var $7d8ced6060a88250$var$_react = $7d8ced6060a88250$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $7d8ced6060a88250$var$_iconNew = $7d8ced6060a88250$var$_interopRequireDefault((parcelRequire("gDzom")));
function $7d8ced6060a88250$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ChevronRight".
 * Category: multi-purpose
 * Location: @atlaskit/icon/core/chevron-right
 * Usage guidance:
 * Do not use 16px chevrons within buttons, icon buttons, or dropdowns to maintain visual cohesion with ADS which uses 12px chevrons.
 * Known uses: Next page of pagination results, collapsed tree item, expand tree item
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $7d8ced6060a88250$var$ChevronRightIcon = (props)=>/*#__PURE__*/ $7d8ced6060a88250$var$_react.default.createElement($7d8ced6060a88250$var$_iconNew.default, Object.assign({
        name: "ChevronRightIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="m6.03 1.47 6 6a.75.75 0 0 1 .052 1.004l-.052.056-6 6-1.06-1.06L10.44 8 4.97 2.53z"/>`
    }, props));
$7d8ced6060a88250$var$ChevronRightIcon.displayName = 'ChevronRightIcon';
var $7d8ced6060a88250$var$_default = $7d8ced6060a88250$exports.default = $7d8ced6060a88250$var$ChevronRightIcon;


var $a7026317cd16a808$exports = {};
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d917ba19410d867502f4eac87befeea4>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty($a7026317cd16a808$exports, "__esModule", {
    value: true
});
$a7026317cd16a808$exports.default = void 0;

var $a7026317cd16a808$var$_react = $a7026317cd16a808$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $a7026317cd16a808$var$_iconNew = $a7026317cd16a808$var$_interopRequireDefault((parcelRequire("gDzom")));
function $a7026317cd16a808$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "LinkExternal".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/link-external
 * Usage guidance:
 * Single purpose - Reserved for links that open up a new tab.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a7026317cd16a808$var$LinkExternalIcon = (props)=>/*#__PURE__*/ $a7026317cd16a808$var$_react.default.createElement($a7026317cd16a808$var$_iconNew.default, Object.assign({
        name: "LinkExternalIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M3 2.5a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5v-3H15v3a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h3v1.5zM10 1h4.25a.75.75 0 0 1 .75.75V6h-1.5V3.56L7.53 9.53 6.47 8.47l5.97-5.97H10z" clip-rule="evenodd"/>`
    }, props));
$a7026317cd16a808$var$LinkExternalIcon.displayName = 'LinkExternalIcon';
var $a7026317cd16a808$var$_default = $a7026317cd16a808$exports.default = $a7026317cd16a808$var$LinkExternalIcon;


var $63d34d3709a410be$exports = {};
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::315758a81f797b033fc6adebe81008e6>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty($63d34d3709a410be$exports, "__esModule", {
    value: true
});
$63d34d3709a410be$exports.default = void 0;

var $63d34d3709a410be$var$_react = $63d34d3709a410be$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $63d34d3709a410be$var$_iconNew = $63d34d3709a410be$var$_interopRequireDefault((parcelRequire("gDzom")));
function $63d34d3709a410be$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Theme".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/theme
 * Usage guidance:
 * Single purpose - Reserved for representing themes and theme switching.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $63d34d3709a410be$var$ThemeIcon = (props)=>/*#__PURE__*/ $63d34d3709a410be$var$_react.default.createElement($63d34d3709a410be$var$_iconNew.default, Object.assign({
        name: "ThemeIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 1.5a6.5 6.5 0 1 0 0 13 6.5 6.5 0 0 0 0-13M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8m7.25-5H8a5 5 0 0 1 0 10h-.75z" clip-rule="evenodd"/>`
    }, props));
$63d34d3709a410be$var$ThemeIcon.displayName = 'ThemeIcon';
var $63d34d3709a410be$var$_default = $63d34d3709a410be$exports.default = $63d34d3709a410be$var$ThemeIcon;


/* index.tsx generated by @compiled/babel-plugin v2.0.0 */ function $706b8ad6de2aea65$export$2e2bcd8739ae039() {
    return $706b8ad6de2aea65$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $706b8ad6de2aea65$export$2e2bcd8739ae039.apply(null, arguments);
}


function $48484c4cef73b429$export$2e2bcd8739ae039(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}


function $99bd6dc382270412$export$2e2bcd8739ae039(e, t) {
    if (null == e) return {};
    var o, r, i = (0, $48484c4cef73b429$export$2e2bcd8739ae039)(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}



var $5FkrB = parcelRequire("5FkrB");
/**
 * The length of the value hash portion of an atomic class name.
 * Atomic class names have the format: `_<group><value>`
 * where group is ATOMIC_GROUP_HASH_LENGTH chars and value is ATOMIC_VALUE_HASH_LENGTH chars.
 *
 * We extract the group key using: `className.slice(0, className.length - ATOMIC_VALUE_HASH_LENGTH)`
 *
 * We support both old-format classes (9 chars: `_` + 4 group + 4 value) and
 * new-format classes (11 chars: `_` + 6 group + 4 value) by using length-based
 * extraction rather than a hardcoded offset — old and new format group keys
 * are different lengths so they are structurally disjoint and never alias each other.
 */ const $2c874d65809f5abe$var$ATOMIC_VALUE_HASH_LENGTH = 4;
function $2c874d65809f5abe$export$2e2bcd8739ae039(classNames) {
    // Shortcut: nothing to do
    if (!classNames.length) return;
    // Shortcut: don't need to do anything if we only have a single classname
    if (classNames.length === 1 && classNames[0] && // checking to see if `classNames[0]` is a string that contains other classnames
    !classNames[0].includes(' ')) return classNames[0];
    // Using an object rather than a `Map` as it performed better in our benchmarks.
    // Would be happy to move to `Map` if it proved to be better under real conditions.
    const map = {};
    // Note: using loops to minimize iterations over the collection
    for (const value of classNames){
        // Exclude all falsy values, which leaves us with populated strings
        if (!value) continue;
        // a `value` can contain multiple classnames
        const list = value.split(' ');
        for (const className of list){
            /**
             * For atomic style classnames: the `key` is the `group`
             *
             * - Later atomic classnames with the same `group` will override earlier ones
             *   (which is what we want).
             * - Assumes atomic classnames are the only things that start with `_`
             * - Could use a regex to ensure that atomic classnames are structured how we expect,
             *   but did not add that for now as it did slow things down a bit.
             *
             * For other classnames: the `key` is the whole classname
             * - Okay to remove duplicates as doing so does not impact specificity
             *
             * */ const key = className.startsWith('_') ? className.slice(0, className.length - $2c874d65809f5abe$var$ATOMIC_VALUE_HASH_LENGTH) : className;
            map[key] = className;
        }
    }
    /**
     * We are converting the `map` into a string.
     *
     * The simple way to do this would be `Object.values(map).join(' ')`.
     * However, the approach below performs 10%-20% better in benchmarks.
     *
     * For `ax()` it feels right to squeeze as much runtime performance out as we can.
     */ let result = '';
    for(const key in map)result += map[key] + ' ';
    // If we have an empty string, then our `map` was empty.
    if (!result) return;
    // remove last " " from the result (we added " " at the end of every value)
    return result.trimEnd();
}



var $5FkrB = parcelRequire("5FkrB");

function $7fe405ebc45106ea$export$ce91654eb9fea460() {
    var value = (0, $5FkrB.useContext)((0, $85e016ca147353cc$export$49ddd74a6729fdb0));
    return value;
}


function $834c83d9b019e2d9$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return r;
}


function $aa9eed3b1a785cb0$export$2e2bcd8739ae039(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}


function $d5b4c3dde10c7176$export$2e2bcd8739ae039(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}


function $3a5b2de5bed559a1$export$2e2bcd8739ae039(r, a) {
    if (r) {
        if ("string" == typeof r) return (0, $d5b4c3dde10c7176$export$2e2bcd8739ae039)(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? (0, $d5b4c3dde10c7176$export$2e2bcd8739ae039)(r, a) : void 0;
    }
}


function $8448a4eeda31e564$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}


function $e49de34856367c81$export$2e2bcd8739ae039(r, e) {
    return (0, $834c83d9b019e2d9$export$2e2bcd8739ae039)(r) || (0, $aa9eed3b1a785cb0$export$2e2bcd8739ae039)(r, e) || (0, $3a5b2de5bed559a1$export$2e2bcd8739ae039)(r, e) || (0, $8448a4eeda31e564$export$2e2bcd8739ae039)();
}



var $5FkrB = parcelRequire("5FkrB");
function $c352b5bed9766f49$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $c352b5bed9766f49$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $c352b5bed9766f49$export$2e2bcd8739ae039(o);
}



function $d2b71417f0d9e287$export$2e2bcd8739ae039(t, r) {
    if ("object" != (0, $c352b5bed9766f49$export$2e2bcd8739ae039)(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (0, $c352b5bed9766f49$export$2e2bcd8739ae039)(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}


function $b21321c9291aa6d4$export$2e2bcd8739ae039(t) {
    var i = (0, $d2b71417f0d9e287$export$2e2bcd8739ae039)(t, "string");
    return "symbol" == (0, $c352b5bed9766f49$export$2e2bcd8739ae039)(i) ? i : i + "";
}


function $d209cb8263945142$export$2e2bcd8739ae039(e, r, t) {
    return (r = (0, $b21321c9291aa6d4$export$2e2bcd8739ae039)(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}


var $b1b6ef2b9cd75d8a$export$4ef52930e33717cd = 'data-theme';
var $b1b6ef2b9cd75d8a$export$cb374d25ded7f6ab = 'data-subtree-theme';
var $b1b6ef2b9cd75d8a$export$a00eac3f8684bcd0 = 'data-color-mode';
var $b1b6ef2b9cd75d8a$export$2112803007239c61 = 'data-contrast-mode';
var $b1b6ef2b9cd75d8a$export$352e418ed5b6193a = 'data-custom-theme';
var $b1b6ef2b9cd75d8a$export$6f0c6fb8c80fcc92 = 'ds';
var $b1b6ef2b9cd75d8a$export$4d0c7bbf80185957 = [
    'opacity',
    'font',
    'space',
    'border',
    'radius'
];
var $b1b6ef2b9cd75d8a$export$dddac1532e822863 = "--".concat($b1b6ef2b9cd75d8a$export$6f0c6fb8c80fcc92, "-token-not-found");
var $b1b6ef2b9cd75d8a$export$9d7b58831ae93caa = "--".concat($b1b6ef2b9cd75d8a$export$6f0c6fb8c80fcc92, "-elevation-surface-current");


/**
 * Theme modes: The general purpose of a theme.
 * This attr is used to apply the appropriate system-preference option
 * It may also be used as a selector for mode-specific overrides such as light/dark images.
 * The idea is there may exist many color themes, but every theme must either fit into light or dark.
 */ var $7c7b2d7e083dd38a$export$83993de8eb66733 = [
    'light',
    'dark',
    'auto'
];


var $96fb1b7e17668b2f$export$fcfb1976c88f9f75 = function isThemeColorMode(colorMode) {
    return (0, $7c7b2d7e083dd38a$export$83993de8eb66733).find(function(mode) {
        return mode === colorMode;
    }) !== undefined;
};



var $463787a6b4663423$export$4a14e169b1de4ee7 = function isColorMode(modeId) {
    return [
        'light',
        'dark',
        'auto'
    ].includes(modeId);
};


/**
 * Theme ids: The value that will be mounted to the DOM as a data attr
 * For example: `data-theme="light:light dark:dark spacing:spacing"
 *
 * These ids must be kebab case
 */ var $5b0947e736793ef5$export$7d43e72a58e3283f = [
    'light-increased-contrast',
    'light',
    'light-future',
    'dark',
    'dark-future',
    'dark-increased-contrast',
    'spacing',
    'shape',
    'typography',
    'motion'
];


var $2c4791fb170ff767$export$ea35b8958c39dd07 = function isThemeIds(themeId) {
    return (0, $5b0947e736793ef5$export$7d43e72a58e3283f).find(function(id) {
        return id === themeId;
    }) !== undefined;
};


var $31fce14279c2e7c8$var$themeKinds = [
    'light',
    'dark',
    'spacing',
    'typography',
    'shape',
    'motion'
];
var $31fce14279c2e7c8$export$958fa026be3a263e = function isThemeKind(themeKind) {
    return $31fce14279c2e7c8$var$themeKinds.find(function(kind) {
        return kind === themeKind;
    }) !== undefined;
};


var $4fe3f83e3f26315c$var$customThemeOptions = 'UNSAFE_themeOptions';
var $4fe3f83e3f26315c$export$f19b488f7c0547ee = function themeStringToObject(themeState) {
    return themeState.split(' ').map(function(theme) {
        return theme.split(/:([^]*)/);
    }).reduce(function(themeObject, _ref) {
        var _ref2 = (0, $e49de34856367c81$export$2e2bcd8739ae039)(_ref, 2), kind = _ref2[0], id = _ref2[1];
        if (kind === 'colorMode' && (0, $463787a6b4663423$export$4a14e169b1de4ee7)(id)) themeObject[kind] = id;
        if ((0, $31fce14279c2e7c8$export$958fa026be3a263e)(kind) && (0, $2c4791fb170ff767$export$ea35b8958c39dd07)(id)) // @ts-expect-error FIXME - this is a valid ts error
        themeObject[kind] = id;
        if (kind === $4fe3f83e3f26315c$var$customThemeOptions) try {
            themeObject[$4fe3f83e3f26315c$var$customThemeOptions] = JSON.parse(id);
        } catch (_unused) {
            new Error('Invalid custom theme string');
        }
        return themeObject;
    }, {});
};


function $0125b01bab24ec2e$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $0125b01bab24ec2e$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $0125b01bab24ec2e$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $d209cb8263945142$export$2e2bcd8739ae039)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $0125b01bab24ec2e$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $0125b01bab24ec2e$export$813ecdf77207a053 = function getGlobalTheme() {
    if (typeof document === 'undefined') return {};
    var element = document.documentElement;
    var colorMode = element.getAttribute((0, $b1b6ef2b9cd75d8a$export$a00eac3f8684bcd0)) || '';
    var theme = element.getAttribute((0, $b1b6ef2b9cd75d8a$export$4ef52930e33717cd)) || '';
    return $0125b01bab24ec2e$var$_objectSpread($0125b01bab24ec2e$var$_objectSpread({}, (0, $4fe3f83e3f26315c$export$f19b488f7c0547ee)(theme)), (0, $96fb1b7e17668b2f$export$fcfb1976c88f9f75)(colorMode) && {
        colorMode: colorMode
    });
};


function $1806ac548c562a4a$export$2e2bcd8739ae039(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}



function $bf59d9447c59f4dc$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, (0, $b21321c9291aa6d4$export$2e2bcd8739ae039)(o.key), o);
    }
}
function $bf59d9447c59f4dc$export$2e2bcd8739ae039(e, r, t) {
    return r && $bf59d9447c59f4dc$var$_defineProperties(e.prototype, r), t && $bf59d9447c59f4dc$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}





var $aa55e0cce7caa27f$export$b741a7c3bcb1c635 = /*#__PURE__*/ function() {
    function ThemeMutationObserver(callback) {
        (0, $1806ac548c562a4a$export$2e2bcd8739ae039)(this, ThemeMutationObserver);
        (0, $d209cb8263945142$export$2e2bcd8739ae039)(this, "legacyObserver", null);
        this.callback = callback;
        ThemeMutationObserver.callbacks.add(callback);
    }
    return (0, $bf59d9447c59f4dc$export$2e2bcd8739ae039)(ThemeMutationObserver, [
        {
            key: "observe",
            value: function observe() {
                if (!ThemeMutationObserver.observer) {
                    ThemeMutationObserver.observer = new MutationObserver(function() {
                        var theme = (0, $0125b01bab24ec2e$export$813ecdf77207a053)();
                        ThemeMutationObserver.callbacks.forEach(function(callback) {
                            return callback(theme);
                        });
                    });
                    // Observer only needs to be configured once
                    ThemeMutationObserver.observer.observe(document.documentElement, {
                        attributeFilter: [
                            (0, $b1b6ef2b9cd75d8a$export$4ef52930e33717cd),
                            (0, $b1b6ef2b9cd75d8a$export$a00eac3f8684bcd0)
                        ]
                    });
                }
            }
        },
        {
            key: "disconnect",
            value: function disconnect() {
                if (this.callback) ThemeMutationObserver.callbacks.delete(this.callback);
                if (ThemeMutationObserver.callbacks.size === 0 && ThemeMutationObserver.observer) {
                    ThemeMutationObserver.observer.disconnect();
                    ThemeMutationObserver.observer = null;
                }
            }
        }
    ]);
}();
(0, $d209cb8263945142$export$2e2bcd8739ae039)($aa55e0cce7caa27f$export$b741a7c3bcb1c635, "observer", null);
(0, $d209cb8263945142$export$2e2bcd8739ae039)($aa55e0cce7caa27f$export$b741a7c3bcb1c635, "callbacks", new Set());
var $aa55e0cce7caa27f$export$2e2bcd8739ae039 = $aa55e0cce7caa27f$export$b741a7c3bcb1c635;


var $686e0093e796a2d3$export$3dd7971102e44fa8 = function useThemeObserver() {
    var _useState = (0, $5FkrB.useState)((0, $0125b01bab24ec2e$export$813ecdf77207a053)()), _useState2 = (0, $e49de34856367c81$export$2e2bcd8739ae039)(_useState, 2), theme = _useState2[0], setTheme = _useState2[1];
    (0, $5FkrB.useEffect)(function() {
        var observer = new (0, $aa55e0cce7caa27f$export$2e2bcd8739ae039)(function(theme) {
            return setTheme(theme);
        });
        observer.observe();
        return function() {
            return observer.disconnect();
        };
    }, []);
    return theme;
};
var $686e0093e796a2d3$export$2e2bcd8739ae039 = $686e0093e796a2d3$export$3dd7971102e44fa8;


var $2eb42266ae7fc1da$var$_excluded = [
    "src",
    "srcDark",
    "alt",
    "testId",
    "className"
];
var $2eb42266ae7fc1da$var$baseImageStyles = null;
function $2eb42266ae7fc1da$export$2e2bcd8739ae039(_ref) {
    var src = _ref.src, srcDark = _ref.srcDark, alt = _ref.alt, testId = _ref.testId, className = _ref.className, props = (0, $99bd6dc382270412$export$2e2bcd8739ae039)(_ref, $2eb42266ae7fc1da$var$_excluded);
    var imgRef = (0, $5FkrB.useRef)(null);
    var providedColorMode = (0, $7fe405ebc45106ea$export$ce91654eb9fea460)();
    var _useThemeObserver = (0, $686e0093e796a2d3$export$3dd7971102e44fa8)(), observedColorMode = _useThemeObserver.colorMode;
    var colorMode = providedColorMode || observedColorMode;
    (0, $5FkrB.useEffect)(function() {
        if (imgRef === null || imgRef.current === null) return;
        if (srcDark && colorMode === 'dark') imgRef.current.src = srcDark;
        else if (src) imgRef.current.src = src;
    }, [
        src,
        srcDark,
        colorMode
    ]);
    return /*#__PURE__*/ $5FkrB.createElement("img", (0, $706b8ad6de2aea65$export$2e2bcd8739ae039)({
        alt: alt,
        "data-testid": testId,
        src: src,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $2c874d65809f5abe$export$2e2bcd8739ae039)([
            "_p12f1osq _4t3i1wug",
            className
        ]),
        ref: imgRef
    }, props));
}


/* button-item.tsx generated by @compiled/babel-plugin v3.0.2 */ 


var $5FkrB = parcelRequire("5FkrB");


var $5FkrB = parcelRequire("5FkrB");
var $3f97f5f255c8dd49$var$interactionContext = /*#__PURE__*/ (0, $5FkrB.createContext)(null);
var $3f97f5f255c8dd49$export$2e2bcd8739ae039 = $3f97f5f255c8dd49$var$interactionContext;


/* menu-item-primitive.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $5FkrB = parcelRequire("5FkrB");
/**
 * The length of the value hash portion of an atomic class name.
 * Atomic class names have the format: `_<group><value>`
 * where group is ATOMIC_GROUP_HASH_LENGTH chars and value is ATOMIC_VALUE_HASH_LENGTH chars.
 *
 * We extract the group key using: `className.slice(0, className.length - ATOMIC_VALUE_HASH_LENGTH)`
 *
 * We support both old-format classes (9 chars: `_` + 4 group + 4 value) and
 * new-format classes (11 chars: `_` + 6 group + 4 value) by using length-based
 * extraction rather than a hardcoded offset — old and new format group keys
 * are different lengths so they are structurally disjoint and never alias each other.
 */ const $ff0b0dede5020ce3$var$ATOMIC_VALUE_HASH_LENGTH = 4;
function $ff0b0dede5020ce3$export$2e2bcd8739ae039(classNames) {
    // Shortcut: nothing to do
    if (!classNames.length) return;
    // Shortcut: don't need to do anything if we only have a single classname
    if (classNames.length === 1 && classNames[0] && // checking to see if `classNames[0]` is a string that contains other classnames
    !classNames[0].includes(' ')) return classNames[0];
    // Using an object rather than a `Map` as it performed better in our benchmarks.
    // Would be happy to move to `Map` if it proved to be better under real conditions.
    const map = {};
    // Note: using loops to minimize iterations over the collection
    for (const value of classNames){
        // Exclude all falsy values, which leaves us with populated strings
        if (!value) continue;
        // a `value` can contain multiple classnames
        const list = value.split(' ');
        for (const className of list){
            /**
             * For atomic style classnames: the `key` is the `group`
             *
             * - Later atomic classnames with the same `group` will override earlier ones
             *   (which is what we want).
             * - Assumes atomic classnames are the only things that start with `_`
             * - Could use a regex to ensure that atomic classnames are structured how we expect,
             *   but did not add that for now as it did slow things down a bit.
             *
             * For other classnames: the `key` is the whole classname
             * - Okay to remove duplicates as doing so does not impact specificity
             *
             * */ const key = className.startsWith('_') ? className.slice(0, className.length - $ff0b0dede5020ce3$var$ATOMIC_VALUE_HASH_LENGTH) : className;
            map[key] = className;
        }
    }
    /**
     * We are converting the `map` into a string.
     *
     * The simple way to do this would be `Object.values(map).join(' ')`.
     * However, the approach below performs 10%-20% better in benchmarks.
     *
     * For `ax()` it feels right to squeeze as much runtime performance out as we can.
     */ let result = '';
    for(const key in map)result += map[key] + ' ';
    // If we have an empty string, then our `map` was empty.
    if (!result) return;
    // remove last " " from the result (we added " " at the end of every value)
    return result.trimEnd();
}



var $50U6m = parcelRequire("50U6m");


var $5FkrB = parcelRequire("5FkrB");
var $68f80bf2faeb628e$export$443076ec7ebce042 = /*#__PURE__*/ (0, $5FkrB.createContext)('cozy');



var $5FkrB = parcelRequire("5FkrB");
var $71d12008a293b11f$export$9ca534b70725964d = /*#__PURE__*/ (0, $5FkrB.createContext)('border');


var $1fb565773019ac9d$var$renderTitle = function renderTitle(Component, props) {
    return(/*#__PURE__*/ // eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    $5FkrB.createElement(Component, props));
};
var $1fb565773019ac9d$var$styles = {
    root: "_19itidpf _12ji1r31 _1qu2glyw _12y3idpf _4bfu1r31 _1hmsglyw _ajmmnqa1 _kqswh2mm _1e0c1txw _vchhusvi _1bsb1osq _1tke1ylp _1pfhze3t _12l2ze3t _6rthze3t _ahbqze3t _4cvr1h6o _uiztglyw _80omtlke _ymio1r31 _ypr0glyw _zcxs1o36 _nt751v1w _mizu1v1w _1bg41gjf _1ah31gjf _49pcnqa1 _ra3xnqa1 _1hvwdkaa _128mdkaa _9oik1r31 _1bnxglyw _jf4cnqa1 _1cvmnqa1 _4davt94y",
    beforeAfterElement: "_1e0c1txw _1ul91tcg _1tke1tcg _4cvr1h6o _1bah1h6o _1o9zidpf",
    content: "_12ji1r31 _1qu2glyw _12y31o36 _1reo15vq _18m915vq _1e0c1txw _2lx21bp4 _1bah1h6o _16jlkb7n _y3gn1e5h",
    truncate: "_1reo15vq _18m915vq _1e0c1ule _1bto1l2s _o5721q9c",
    title: "_11c8fhey",
    wordBreak: "_1nmz1hna",
    description: "_11c8wadc _syaz1rpy",
    disabledDescription: "_syaz1gmx",
    unselected: "_bfhksm61 _syaz1r31 _10531r31 _irr31dpa _30l31r31 _1di61dpa _9h8h1r31",
    disabled: "_80om13gf _bfhksm61 _syaz1gmx _irr3sm61 _30l31gmx _1di6sm61 _9h8h1gmx",
    selectedBorder: "_1mp4yh40 _1cs8stnw _1rusq98m _1kt9b3bt _1fkrze3t _iajmze3t _z5wtze3t",
    selectedNotch: "_rfx3bx74 _1mp41y44 _1cs8stnw _1rusq98m _1kt9b3bt _1fkrutpp _iajmutpp _z5wtze3t",
    selected: "_bfhk15s3 _syaz6x5g _10536x5g _irr3ufnl _30l316jw _1di6nozp _9h8h6x5g",
    selectedOld: "_30l36x5g",
    motionUnselected: "_v564hxmd _o7kshxmd _1ggl87vo",
    motionSelected: "_v5641rrn _o7kshxmd"
};
var $1fb565773019ac9d$var$spacingMapStyles = {
    cozy: "_1rjcu2gc _18zrpxbi",
    compact: "_1rjc1b66 _18zrutpp _1tkezwfg"
};
var $1fb565773019ac9d$var$gapMap = {
    compact: 'space.100',
    cozy: 'space.150'
};
/**
 * __Menu item primitive__
 *
 * Menu item primitive contains all the styles for menu items,
 * including support for selected, disabled, and interaction states.
 *
 * Using children as function prop you wire up this to your own host element.
 *
 * ```jsx
 * <MenuItemPrimitive>
 *   {({ children, ...props }) => <button {...props}>{children}</button>}
 * </MenuItemPrimitive>
 * ```
 */ var $1fb565773019ac9d$var$MenuItemPrimitive = function MenuItemPrimitive(_ref) {
    var children = _ref.children, title = _ref.title, description = _ref.description, iconAfter = _ref.iconAfter, iconBefore = _ref.iconBefore, UNSAFE_externalClassName = _ref.className, _ref$shouldTitleWrap = _ref.shouldTitleWrap, shouldTitleWrap = _ref$shouldTitleWrap === void 0 ? false : _ref$shouldTitleWrap, _ref$shouldDescriptio = _ref.shouldDescriptionWrap, shouldDescriptionWrap = _ref$shouldDescriptio === void 0 ? false : _ref$shouldDescriptio, _ref$isDisabled = _ref.isDisabled, isDisabled = _ref$isDisabled === void 0 ? false : _ref$isDisabled, _ref$isSelected = _ref.isSelected, isSelected = _ref$isSelected === void 0 ? false : _ref$isSelected, _ref$isTitleHeading = _ref.isTitleHeading, isTitleHeading = _ref$isTitleHeading === void 0 ? false : _ref$isTitleHeading, testId = _ref.testId;
    var spacing = (0, $5FkrB.useContext)((0, $68f80bf2faeb628e$export$443076ec7ebce042));
    var selectionStyle = (0, $5FkrB.useContext)((0, $71d12008a293b11f$export$9ca534b70725964d));
    var UNSAFE_className = UNSAFE_externalClassName;
    return function() {
        return children({
            className: (0, $ff0b0dede5020ce3$export$2e2bcd8739ae039)([
                (0, $ff0b0dede5020ce3$export$2e2bcd8739ae039)([
                    $1fb565773019ac9d$var$styles.root,
                    $1fb565773019ac9d$var$spacingMapStyles[spacing],
                    !isDisabled && !isSelected && $1fb565773019ac9d$var$styles.unselected,
                    !isDisabled && !isSelected && (0, $50U6m.fg)('platform-dst-motion-uplift-list-item') && $1fb565773019ac9d$var$styles.motionUnselected,
                    !isDisabled && isSelected && $1fb565773019ac9d$var$styles.selected,
                    !isDisabled && isSelected && (0, $50U6m.fg)('platform-dst-motion-uplift-list-item') && $1fb565773019ac9d$var$styles.motionSelected,
                    !isDisabled && isSelected && $1fb565773019ac9d$var$styles.selectedOld,
                    !isDisabled && isSelected && selectionStyle === 'border' && $1fb565773019ac9d$var$styles.selectedBorder,
                    !isDisabled && isSelected && selectionStyle === 'notch' && $1fb565773019ac9d$var$styles.selectedNotch,
                    isDisabled && $1fb565773019ac9d$var$styles.disabled
                ]),
                UNSAFE_className
            ]),
            children: /*#__PURE__*/ $5FkrB.createElement((0, $04267de539304abd$export$fbae5b5ffd8af05e), {
                as: "span",
                spread: "space-between",
                alignBlock: "center",
                space: $1fb565773019ac9d$var$gapMap[spacing],
                grow: "fill",
                testId: testId && "".concat(testId, "--container")
            }, iconBefore && /*#__PURE__*/ $5FkrB.createElement("span", {
                "data-item-elem-before": true,
                "data-testid": testId && "".concat(testId, "--icon-before"),
                className: (0, $ff0b0dede5020ce3$export$2e2bcd8739ae039)([
                    $1fb565773019ac9d$var$styles.beforeAfterElement
                ])
            }, iconBefore), title && /*#__PURE__*/ $5FkrB.createElement("div", {
                className: (0, $ff0b0dede5020ce3$export$2e2bcd8739ae039)([
                    $1fb565773019ac9d$var$styles.content
                ])
            }, $1fb565773019ac9d$var$renderTitle(isTitleHeading ? 'h2' : 'span', {
                children: title,
                className: (0, $ff0b0dede5020ce3$export$2e2bcd8739ae039)([
                    $1fb565773019ac9d$var$styles.title,
                    shouldTitleWrap ? $1fb565773019ac9d$var$styles.wordBreak : $1fb565773019ac9d$var$styles.truncate
                ]),
                'data-item-title': true
            }), description && /*#__PURE__*/ $5FkrB.createElement("span", {
                "data-item-description": true,
                className: (0, $ff0b0dede5020ce3$export$2e2bcd8739ae039)([
                    $1fb565773019ac9d$var$styles.description,
                    isDisabled && $1fb565773019ac9d$var$styles.disabledDescription,
                    shouldDescriptionWrap && $1fb565773019ac9d$var$styles.wordBreak,
                    !shouldDescriptionWrap && $1fb565773019ac9d$var$styles.truncate
                ])
            }, description)), iconAfter && /*#__PURE__*/ $5FkrB.createElement("span", {
                "data-item-elem-after": true,
                "data-testid": testId && "".concat(testId, "--icon-after"),
                className: (0, $ff0b0dede5020ce3$export$2e2bcd8739ae039)([
                    $1fb565773019ac9d$var$styles.beforeAfterElement
                ])
            }, iconAfter))
        });
    }();
};
var $1fb565773019ac9d$export$2e2bcd8739ae039 = $1fb565773019ac9d$var$MenuItemPrimitive;


var $3f62ad5c3e23b9c1$var$_excluded = [
    "children",
    "description",
    "iconAfter",
    "iconBefore",
    "isDisabled",
    "isSelected",
    "onClick",
    "testId",
    "onMouseDown",
    "shouldTitleWrap",
    "shouldDescriptionWrap",
    "className",
    "interactionName"
];
/**
 * __Button item__
 *
 * A button item is used to populate a menu with items that are buttons.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/menu/docs/button-item)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/menu)
 */ var $3f62ad5c3e23b9c1$var$ButtonItem = /*#__PURE__*/ (0, $5FkrB.memo)(/*#__PURE__*/ (0, $5FkrB.forwardRef)(function(props, ref) {
    var children = props.children, description = props.description, iconAfter = props.iconAfter, iconBefore = props.iconBefore, _props$isDisabled = props.isDisabled, isDisabled = _props$isDisabled === void 0 ? false : _props$isDisabled, _props$isSelected = props.isSelected, isSelected = _props$isSelected === void 0 ? false : _props$isSelected, onClick = props.onClick, testId = props.testId, onMouseDown = props.onMouseDown, shouldTitleWrap = props.shouldTitleWrap, shouldDescriptionWrap = props.shouldDescriptionWrap, UNSAFE_className = props.className, interactionName = props.interactionName, rest = (0, $9782bdcbae553a67$export$2e2bcd8739ae039)(props, $3f62ad5c3e23b9c1$var$_excluded);
    var onMouseDownHandler = onMouseDown;
    var interactionContext = (0, $5FkrB.useContext)((0, $3f97f5f255c8dd49$export$2e2bcd8739ae039));
    var handleClick = (0, $5FkrB.useCallback)(function(e) {
        interactionContext === null || interactionContext === void 0 || interactionContext.tracePress(interactionName, e.timeStamp);
        onClick === null || onClick === void 0 || onClick(e);
    }, [
        onClick,
        interactionContext,
        interactionName
    ]);
    if (!children) return null;
    return /*#__PURE__*/ $5FkrB.createElement((0, $1fb565773019ac9d$export$2e2bcd8739ae039), (0, $d3d83eb9e25f7f1c$export$2e2bcd8739ae039)({
        className: UNSAFE_className
    }, rest, {
        iconBefore: iconBefore,
        iconAfter: iconAfter,
        isDisabled: isDisabled,
        isSelected: isSelected,
        isTitleHeading: false,
        description: description,
        title: children,
        shouldTitleWrap: shouldTitleWrap,
        shouldDescriptionWrap: shouldDescriptionWrap,
        testId: testId && "".concat(testId, "--primitive")
    }), function(_ref) {
        var children = _ref.children, className = _ref.className;
        return /*#__PURE__*/ $5FkrB.createElement("button", (0, $d3d83eb9e25f7f1c$export$2e2bcd8739ae039)({
            "data-testid": testId,
            "aria-current": isSelected ? 'true' : undefined
        }, rest, {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: className,
            ref: ref,
            disabled: isDisabled,
            onClick: handleClick,
            onMouseDown: onMouseDownHandler,
            type: "button"
        }), children);
    });
}));
var $3f62ad5c3e23b9c1$export$2e2bcd8739ae039 = $3f62ad5c3e23b9c1$var$ButtonItem;



var $50U6m = parcelRequire("50U6m");
/* stack.tsx generated by @compiled/babel-plugin v2.0.0 */ 


var $5FkrB = parcelRequire("5FkrB");



var $70988de881688cbc$var$_excluded = [
    "as",
    "alignInline",
    "alignBlock",
    "spread",
    "grow",
    "space",
    "children",
    "testId",
    "xcss",
    "role"
];
var $70988de881688cbc$var$styles = {
    hug: "_16jlidpf",
    fill: "_1bsb1osq _16jlkb7n"
};
var $70988de881688cbc$export$694e0d28c7ffc90c = /*#__PURE__*/ (0, $5FkrB.memo)(/*#__PURE__*/ (0, $5FkrB.forwardRef)(function(_ref, ref) {
    var as = _ref.as, alignItems = _ref.alignInline, _ref$alignBlock = _ref.alignBlock, alignBlock = _ref$alignBlock === void 0 ? 'stretch' : _ref$alignBlock, spread = _ref.spread, grow = _ref.grow, space = _ref.space, children = _ref.children, testId = _ref.testId, xcss = _ref.xcss, role = _ref.role, ariaAttributes = (0, $a9c67d4ab15fb282$export$2e2bcd8739ae039)(_ref, $70988de881688cbc$var$_excluded);
    return /*#__PURE__*/ $5FkrB.createElement((0, $00370acaba4d9627$export$f51f4c4ede09e011), (0, $a98c0fbb1cee895f$export$2e2bcd8739ae039)({}, ariaAttributes, {
        as: as,
        role: role,
        gap: space,
        direction: "column",
        alignItems: alignItems,
        justifyContent: spread || alignBlock,
        xcss: (0, $d01a5d8bb96c5a7e$export$a274e22fb40f762e)(grow === 'hug' && $70988de881688cbc$var$styles.hug, grow === 'fill' && $70988de881688cbc$var$styles.fill, xcss),
        testId: testId,
        ref: ref
    }), children);
}));
$70988de881688cbc$export$694e0d28c7ffc90c.displayName = 'Stack';

/* text.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $5FkrB = parcelRequire("5FkrB");



var $5FkrB = parcelRequire("5FkrB");
var $5f141e5f4d88626f$export$19538d0bfc69c6e0 = /*#__PURE__*/ (0, $5FkrB.createContext)(false);


var $d43805ab09abcfec$export$ae933c6cbe5643ad = (0, $5f141e5f4d88626f$export$19538d0bfc69c6e0).Provider;



var $5FkrB = parcelRequire("5FkrB");

var $6aab085817c2aae8$export$1aeb4f6b93c4540d = function useSurface() {
    return (0, $5FkrB.useContext)((0, $80f969ecef0a6dd3$export$1ca2a26fecb070ae));
};
(0, $80f969ecef0a6dd3$export$1ca2a26fecb070ae).displayName = 'SurfaceProvider';



var $5FkrB = parcelRequire("5FkrB");

var $8d1c21dc53d3f2ff$export$9322276ec105d055 = function useHasTextAncestor() {
    return (0, $5FkrB.useContext)((0, $5f141e5f4d88626f$export$19538d0bfc69c6e0));
};


var $5209c25cc099adfe$var$asAllowlist = [
    'span',
    'p',
    'strong',
    'em'
];
/**
 * Custom hook designed to abstract the parsing of the color props and make it clearer in the future how color is reconciled between themes and tokens.
 */ var $5209c25cc099adfe$var$useColor = function useColor(colorProp, hasTextAncestor) {
    var surface = (0, $6aab085817c2aae8$export$1aeb4f6b93c4540d)();
    if (colorProp === 'inherit') return undefined;
    if (colorProp) return colorProp;
    if (hasTextAncestor) return undefined;
    if ($5209c25cc099adfe$var$inverseColorMap.hasOwnProperty(surface)) return $5209c25cc099adfe$var$inverseColorMap[surface];
    return 'color.text';
};
var $5209c25cc099adfe$var$styles = {
    root: "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _1i4qfg65",
    'as.strong': "_k48pwu06",
    'as.em': "_zg8l1m30",
    'textAlign.center': "_y3gn1h6o",
    'textAlign.end': "_y3gnh9n0",
    'textAlign.start': "_y3gnv2br",
    truncation: "_1reo15vq _18m915vq _1e0ccj1k _sudp1e54",
    breakAll: "_1nmz9jpi"
};
var $5209c25cc099adfe$var$fontSizeMap = {
    medium: "_11c8fhey",
    large: "_11c81d4k",
    small: "_11c8wadc"
};
var $5209c25cc099adfe$var$fontWeightMap = {
    bold: "_k48pwu06",
    medium: "_k48p1wq8",
    regular: "_k48pi7a9",
    semibold: "_k48p1pd9"
};
var $5209c25cc099adfe$var$textColorMap = {
    'color.text': "_syazi7uo",
    'color.text.accent.lime': "_syaz1tco",
    'color.text.accent.lime.bolder': "_syaz1ik3",
    'color.text.accent.red': "_syaz9lu1",
    'color.text.accent.red.bolder': "_syazhwvp",
    'color.text.accent.orange': "_syazp1lv",
    'color.text.accent.orange.bolder': "_syaz7i1p",
    'color.text.accent.yellow': "_syazfb2s",
    'color.text.accent.yellow.bolder': "_syazekll",
    'color.text.accent.green': "_syazh55r",
    'color.text.accent.green.bolder': "_syaz1y78",
    'color.text.accent.teal': "_syaz17qg",
    'color.text.accent.teal.bolder': "_syaz12v7",
    'color.text.accent.blue': "_syaz16jw",
    'color.text.accent.blue.bolder': "_syaz1kyx",
    'color.text.accent.purple': "_syazqmo9",
    'color.text.accent.purple.bolder': "_syaz1mn1",
    'color.text.accent.magenta': "_syaz1s8m",
    'color.text.accent.magenta.bolder': "_syaz1qur",
    'color.text.accent.gray': "_syaz1sqi",
    'color.text.accent.gray.bolder': "_syaz1tmo",
    'color.text.disabled': "_syaz1gmx",
    'color.text.inverse': "_syaz15cr",
    'color.text.selected': "_syaz6x5g",
    'color.text.brand': "_syaz1oa5",
    'color.text.danger': "_syaz1tmw",
    'color.text.warning': "_syaz1xn9",
    'color.text.warning.inverse': "_syaz1yd3",
    'color.text.success': "_syazgsak",
    'color.text.discovery': "_syazdv2p",
    'color.text.information': "_syazu3tg",
    'color.text.subtlest': "_syaz1rpy",
    'color.text.subtle': "_syazazsu",
    'color.link': "_syaz13af",
    'color.link.pressed': "_syaz12zz",
    'color.link.visited': "_syaz1ra0",
    'color.link.visited.pressed': "_syaz17z1"
};
var $5209c25cc099adfe$var$inverseColorMap = {
    'color.background.neutral.bold': 'color.text.inverse',
    'color.background.neutral.bold.hovered': 'color.text.inverse',
    'color.background.neutral.bold.pressed': 'color.text.inverse',
    'color.background.selected.bold': 'color.text.inverse',
    'color.background.selected.bold.hovered': 'color.text.inverse',
    'color.background.selected.bold.pressed': 'color.text.inverse',
    'color.background.brand.bold': 'color.text.inverse',
    'color.background.brand.bold.hovered': 'color.text.inverse',
    'color.background.brand.bold.pressed': 'color.text.inverse',
    'color.background.brand.boldest': 'color.text.inverse',
    'color.background.brand.boldest.hovered': 'color.text.inverse',
    'color.background.brand.boldest.pressed': 'color.text.inverse',
    'color.background.danger.bold': 'color.text.inverse',
    'color.background.danger.bold.hovered': 'color.text.inverse',
    'color.background.danger.bold.pressed': 'color.text.inverse',
    'color.background.warning.bold': 'color.text.warning.inverse',
    'color.background.warning.bold.hovered': 'color.text.warning.inverse',
    'color.background.warning.bold.pressed': 'color.text.warning.inverse',
    'color.background.success.bold': 'color.text.inverse',
    'color.background.success.bold.hovered': 'color.text.inverse',
    'color.background.success.bold.pressed': 'color.text.inverse',
    'color.background.discovery.bold': 'color.text.inverse',
    'color.background.discovery.bold.hovered': 'color.text.inverse',
    'color.background.discovery.bold.pressed': 'color.text.inverse',
    'color.background.information.bold': 'color.text.inverse',
    'color.background.information.bold.hovered': 'color.text.inverse',
    'color.background.information.bold.pressed': 'color.text.inverse'
};
var $5209c25cc099adfe$export$5f1af8db9871e1d6 = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? 'span' : _ref$as, colorProp = _ref.color, align = _ref.align, testId = _ref.testId, id = _ref.id, size = _ref.size, weight = _ref.weight, maxLines = _ref.maxLines, xcss = _ref.xcss, children = _ref.children;
    (0, $fff3f31fc3bd4f88$export$2e2bcd8739ae039)($5209c25cc099adfe$var$asAllowlist.includes(Component), "@atlaskit/primitives: Text received an invalid \"as\" value of \"".concat(Component, "\""));
    var hasTextAncestor = (0, $8d1c21dc53d3f2ff$export$9322276ec105d055)();
    var color = $5209c25cc099adfe$var$useColor(colorProp, hasTextAncestor);
    if (!size && !hasTextAncestor) size = 'medium';
    var component = /*#__PURE__*/ $5FkrB.createElement(Component, {
        id: id,
        className: (0, $67c6184bd64e9e07$export$2e2bcd8739ae039)([
            $5209c25cc099adfe$var$styles.root,
            size && $5209c25cc099adfe$var$fontSizeMap[size],
            color && $5209c25cc099adfe$var$textColorMap[color],
            maxLines && $5209c25cc099adfe$var$styles.truncation,
            maxLines === 1 && $5209c25cc099adfe$var$styles.breakAll,
            align && $5209c25cc099adfe$var$styles["textAlign.".concat(align)],
            weight && $5209c25cc099adfe$var$fontWeightMap[weight],
            Component === 'em' && $5209c25cc099adfe$var$styles['as.em'],
            Component === 'strong' && $5209c25cc099adfe$var$styles['as.strong'],
            xcss
        ]),
        style: {
            WebkitLineClamp: maxLines
        },
        "data-testid": testId,
        ref: ref
    }, children);
    if (hasTextAncestor) // no need to re-apply context if the text is already wrapped
    return component;
    return /*#__PURE__*/ $5FkrB.createElement((0, $d43805ab09abcfec$export$ae933c6cbe5643ad), {
        value: true
    }, component);
});


var $9271b59629b6e688$exports = {};
$9271b59629b6e688$exports = new URL("dark-mode.5b7c09da.svg", import.meta.url).toString();


var $8efe53bd6f71b1cc$exports = {};
$8efe53bd6f71b1cc$exports = new URL("light-mode.7f9eeb32.svg", import.meta.url).toString();


var $11a1d6371eb28ea6$exports = {};
$11a1d6371eb28ea6$exports = new URL("match-browser.cf8cedaf.svg", import.meta.url).toString();


var $555e3ba7b5aa1526$var$_excluded = [
    "triggerRef"
];
var $555e3ba7b5aa1526$var$messages = (0, $6bnW7.defineMessages)({
    appDisplayMode: {
        id: 'design-system.theme-switcher.app-display-mode',
        defaultMessage: 'App display mode',
        description: 'Header for the theme switcher menu options'
    },
    themeButton: {
        id: 'design-system.theme-switcher.theme-button',
        defaultMessage: 'Theme',
        description: 'Label for button to switch to a different theme'
    },
    appearanceButton: {
        id: 'design-system.theme-switcher.appearance-button',
        defaultMessage: 'Appearance',
        description: 'Label for button to switch appearance settings'
    },
    light: {
        id: 'design-system.theme-switcher.light.option',
        defaultMessage: 'Light',
        description: 'Label for the theme switcher light option'
    },
    dark: {
        id: 'design-system.theme-switcher.dark.option',
        defaultMessage: 'Dark',
        description: 'Label for the theme switcher dark option'
    },
    matchBrowser: {
        id: 'design-system.theme-switcher.match-browser.option',
        defaultMessage: 'Match browser',
        description: 'Label for the theme switcher match browser option'
    },
    matchSystem: {
        id: 'design-system.theme-switcher.match-system.option',
        defaultMessage: 'Match system',
        description: 'Label for the theme switcher match system option'
    },
    syncedAcrossApps: {
        id: 'design-system.theme-switcher.synced-across-apps',
        defaultMessage: 'Synced across apps',
        description: 'Indicates the theme option is synced with global account settings across all apps'
    },
    personalize: {
        id: 'design-system.theme-switcher.personalize',
        defaultMessage: 'Customize display settings',
        description: 'Link to personalize settings in the theme switcher menu'
    },
    openInNewTab: {
        id: 'design-system.theme-switcher.open-in-new-tab',
        defaultMessage: ', opens in new tab',
        description: 'Accessible label for the external link icon indicating the link opens in a new browser tab'
    }
});
var $555e3ba7b5aa1526$var$themeOptions = [
    {
        label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $bgNpv.default), $555e3ba7b5aa1526$var$messages.light),
        value: 'light',
        thumbnail: (0, (/*@__PURE__*/$parcel$interopDefault($8efe53bd6f71b1cc$exports)))
    },
    {
        label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $bgNpv.default), $555e3ba7b5aa1526$var$messages.dark),
        value: 'dark',
        thumbnail: (0, (/*@__PURE__*/$parcel$interopDefault($9271b59629b6e688$exports)))
    },
    {
        label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $bgNpv.default), $555e3ba7b5aa1526$var$messages.matchBrowser),
        value: 'auto',
        thumbnail: (0, (/*@__PURE__*/$parcel$interopDefault($11a1d6371eb28ea6$exports)))
    }
];
var $555e3ba7b5aa1526$var$themeOptionsAutoFirst = [
    {
        label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $bgNpv.default), $555e3ba7b5aa1526$var$messages.matchSystem),
        value: 'auto',
        thumbnail: (0, (/*@__PURE__*/$parcel$interopDefault($11a1d6371eb28ea6$exports)))
    },
    {
        label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $bgNpv.default), $555e3ba7b5aa1526$var$messages.light),
        value: 'light',
        thumbnail: (0, (/*@__PURE__*/$parcel$interopDefault($8efe53bd6f71b1cc$exports)))
    },
    {
        label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $bgNpv.default), $555e3ba7b5aa1526$var$messages.dark),
        value: 'dark',
        thumbnail: (0, (/*@__PURE__*/$parcel$interopDefault($9271b59629b6e688$exports)))
    }
];
/**
 * ThemeSwitcher is a dropdown menu component for users to select between light, dark, and auto (match browser) color mode themes.
 */ var $555e3ba7b5aa1526$var$ThemeSwitcher = function ThemeSwitcher(_ref) {
    var testId = _ref.testId, onThemeChange = _ref.onThemeChange, currentColorMode = _ref.currentColorMode, accountColorMode = _ref.accountColorMode, appearancePreferencesLink = _ref.appearancePreferencesLink, onOpenChange = _ref.onOpenChange, _ref$shouldInvokeOnOp = _ref.shouldInvokeOnOpenChangeOnFocusAndMouseEnter, shouldInvokeOnOpenChangeOnFocusAndMouseEnter = _ref$shouldInvokeOnOp === void 0 ? true : _ref$shouldInvokeOnOp;
    var intl = (0, $hrVKU.default)();
    var options = (0, $50U6m.fg)('shared-user-preferences') ? $555e3ba7b5aa1526$var$themeOptionsAutoFirst : $555e3ba7b5aa1526$var$themeOptions;
    var shouldInvokeOnOpenChangeOnFocusAndMouseEnterWithCallback = shouldInvokeOnOpenChangeOnFocusAndMouseEnter && Boolean(onOpenChange);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).Fragment, null, options.map(function(_ref2) {
        var value = _ref2.value, thumbnail = _ref2.thumbnail;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("link", {
            rel: "preload",
            href: thumbnail,
            as: "image",
            key: value
        });
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $efa3e699f80dfb1c$export$2e2bcd8739ae039), {
        testId: testId,
        placement: "auto-start",
        onOpenChange: onOpenChange,
        trigger: function trigger(_ref3) {
            var triggerRef = _ref3.triggerRef, props = (0, $9782bdcbae553a67$export$2e2bcd8739ae039)(_ref3, $555e3ba7b5aa1526$var$_excluded);
            var handleOpenChangeOnFocusOrMouseEnter = function handleOpenChangeOnFocusOrMouseEnter(event) {
                if (!shouldInvokeOnOpenChangeOnFocusAndMouseEnterWithCallback) return;
                onOpenChange === null || onOpenChange === void 0 || onOpenChange({
                    isOpen: true,
                    event: event.nativeEvent
                });
            };
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("span", {
                onMouseEnter: handleOpenChangeOnFocusOrMouseEnter,
                onFocus: handleOpenChangeOnFocusOrMouseEnter
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $3f62ad5c3e23b9c1$export$2e2bcd8739ae039), (0, $d3d83eb9e25f7f1c$export$2e2bcd8739ae039)({
                ref: triggerRef,
                onClick: function onClick(event) {
                    return event.stopPropagation();
                },
                iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($63d34d3709a410be$exports))), {
                    color: "currentColor",
                    label: ""
                }),
                iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7d8ced6060a88250$exports))), {
                    color: "currentColor",
                    label: "",
                    size: "small"
                })
            }, props), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $bgNpv.default), (0, $50U6m.fg)('shared-user-preferences') ? $555e3ba7b5aa1526$var$messages.appearanceButton : $555e3ba7b5aa1526$var$messages.themeButton)));
        },
        shouldRenderToParent: (0, $50U6m.fg)('set-should-render-to-parent-to-true-theme-switcher')
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $a511aba2d268bdcc$export$2e2bcd8739ae039), {
        title: (0, $50U6m.fg)('shared-user-preferences') ? intl.formatMessage($555e3ba7b5aa1526$var$messages.appDisplayMode) : undefined
    }, options.map(function(_ref4) {
        var label = _ref4.label, value = _ref4.value, thumbnail = _ref4.thumbnail;
        var isSynced = accountColorMode !== undefined && accountColorMode === value;
        var isSelected = currentColorMode === value;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $506b749c17906ee8$export$2e2bcd8739ae039), {
            testId: "".concat(testId, "--radio-").concat(value),
            id: value,
            key: value,
            onClick: function onClick() {
                return onThemeChange(value);
            },
            isSelected: isSelected
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $04267de539304abd$export$fbae5b5ffd8af05e), {
            space: "space.150",
            alignBlock: "center"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $2eb42266ae7fc1da$export$2e2bcd8739ae039), {
            src: thumbnail,
            width: 64,
            height: 48,
            alt: ""
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $70988de881688cbc$export$694e0d28c7ffc90c), {
            space: "space.025"
        }, label, isSynced && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $5209c25cc099adfe$export$5f1af8db9871e1d6), {
            size: "small",
            color: "color.text.subtlest"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $bgNpv.default), $555e3ba7b5aa1526$var$messages.syncedAcrossApps)))));
    })), appearancePreferencesLink && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $a511aba2d268bdcc$export$2e2bcd8739ae039), {
        hasSeparator: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $80616e41d77620e9$export$2e2bcd8739ae039), {
        href: appearancePreferencesLink,
        target: "_blank",
        rel: "noopener",
        testId: testId && "".concat(testId, "--personalize"),
        elemAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($a7026317cd16a808$exports))), {
            color: "currentColor",
            label: intl.formatMessage($555e3ba7b5aa1526$var$messages.openInNewTab),
            size: "small"
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $bgNpv.default), $555e3ba7b5aa1526$var$messages.personalize)))));
};
var $555e3ba7b5aa1526$export$2e2bcd8739ae039 = $555e3ba7b5aa1526$var$ThemeSwitcher;



/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 



var $5FkrB = parcelRequire("5FkrB");
/**
 * Returns a CSS custom property value with an optional suffix & prefix.
 * Prefix will only be added if there is a suffix.
 * If the value is undefined a fallback value will be returned to prevent children inheriting parent values.
 *
 * @param value
 * @param suffix
 * @param prefix
 */ function $5d664fa77bbf025f$export$2e2bcd8739ae039(value, suffix, prefix) {
    if (value != undefined) {
        if (suffix) {
            if (prefix) return prefix + value + suffix;
            return value + suffix;
        }
        return value;
    }
    // Currently React trims these values so we can't use a space " " to block the value.
    // Instead we use a CSS variable that doesn't exist which falls back to " ".
    // Bug raised here: https://github.com/facebook/react/issues/20497
    return 'var(--c-, )';
}



var $bgNpv = parcelRequire("bgNpv");


/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ // eslint-disable-next-line no-restricted-imports


var $5FkrB = parcelRequire("5FkrB");

const $54ba2115c14fc6cc$export$a274e22fb40f762e = (...styles)=>{
    // At runtime TStyles is resolved down to strings, but not at compile time.
    // We circumvent the type system here because of that.
    const actualStyles = styles;
    // The output should be a union type of passed in styles. This ensures the call
    // site of xcss prop can raise violations when disallowed styles have been passed.
    return (0, $9eb596671e88e808$export$2e2bcd8739ae039)(actualStyles);
};





var $bdaa79db9c20b544$var$styles = {
    imgContainer: "_1bsbvbgk _4t3ivbgk _mezjvbgk _w8l5vbgk _bna7vbgk _1752vbgk",
    imgContainerSkeleton: "_2rko1rr0 _bfhki8nm",
    img: "_2rko1rr0 _1e0c1ule",
    overlayWrapper: "_kqswh2mm _1e0c1o8l"
};
var $bdaa79db9c20b544$export$2d75367b6e042d67 = function ProfilePicture(_ref) {
    var testId = _ref.testId, src = _ref.src, avatarOverlay = _ref.avatarOverlay;
    var state = (0, $1125196cc466be96$export$2c1df3428fc3264c)(src || '');
    var displayImage = src && state === 'loaded';
    var displayFallback = src && state === 'error';
    var displaySkeleton = !displayImage && !displayFallback;
    return /*#__PURE__*/ $5FkrB.createElement((0, $7a49b1df02a75aca$export$e71c4d32a2263218), {
        xcss: avatarOverlay ? $bdaa79db9c20b544$var$styles.overlayWrapper : undefined
    }, /*#__PURE__*/ $5FkrB.createElement((0, $7a49b1df02a75aca$export$e71c4d32a2263218), {
        testId: testId,
        xcss: (0, $54ba2115c14fc6cc$export$a274e22fb40f762e)($bdaa79db9c20b544$var$styles.imgContainer, displaySkeleton && $bdaa79db9c20b544$var$styles.imgContainerSkeleton)
    }, displayImage && /*#__PURE__*/ $5FkrB.createElement("img", {
        "data-testid": testId && "".concat(testId, "--img"),
        src: src,
        alt: "",
        className: (0, $9eb596671e88e808$export$2e2bcd8739ae039)([
            $bdaa79db9c20b544$var$styles.img
        ])
    }), displayFallback && /*#__PURE__*/ $5FkrB.createElement((0, (/*@__PURE__*/$parcel$interopDefault($10e45dcb67c9e60a$exports))), {
        spacing: "spacious",
        testId: testId && "".concat(testId, "--fallback"),
        label: "",
        color: "var(--ds-text-subtlest, #6B6E76)"
    })), avatarOverlay);
};


/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 


var $5FkrB = parcelRequire("5FkrB");

/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ function $f94440ac60ee9089$export$2e2bcd8739ae039() {
    return $f94440ac60ee9089$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $f94440ac60ee9089$export$2e2bcd8739ae039.apply(null, arguments);
}


function $2c56623588099649$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $2c56623588099649$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $2c56623588099649$export$2e2bcd8739ae039(o);
}



function $bbe823aee97641ce$export$2e2bcd8739ae039(t, r) {
    if ("object" != (0, $2c56623588099649$export$2e2bcd8739ae039)(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (0, $2c56623588099649$export$2e2bcd8739ae039)(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}


function $89d5a14584c389f2$export$2e2bcd8739ae039(t) {
    var i = (0, $bbe823aee97641ce$export$2e2bcd8739ae039)(t, "string");
    return "symbol" == (0, $2c56623588099649$export$2e2bcd8739ae039)(i) ? i : i + "";
}


function $cfb05d39d00b1b61$export$2e2bcd8739ae039(e, r, t) {
    return (r = (0, $89d5a14584c389f2$export$2e2bcd8739ae039)(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}


/**
 * The length of the value hash portion of an atomic class name.
 * Atomic class names have the format: `_<group><value>`
 * where group is ATOMIC_GROUP_HASH_LENGTH chars and value is ATOMIC_VALUE_HASH_LENGTH chars.
 *
 * We extract the group key using: `className.slice(0, className.length - ATOMIC_VALUE_HASH_LENGTH)`
 *
 * We support both old-format classes (9 chars: `_` + 4 group + 4 value) and
 * new-format classes (11 chars: `_` + 6 group + 4 value) by using length-based
 * extraction rather than a hardcoded offset — old and new format group keys
 * are different lengths so they are structurally disjoint and never alias each other.
 */ const $0b40243983036a60$var$ATOMIC_VALUE_HASH_LENGTH = 4;
function $0b40243983036a60$export$2e2bcd8739ae039(classNames) {
    // Shortcut: nothing to do
    if (!classNames.length) return;
    // Shortcut: don't need to do anything if we only have a single classname
    if (classNames.length === 1 && classNames[0] && // checking to see if `classNames[0]` is a string that contains other classnames
    !classNames[0].includes(' ')) return classNames[0];
    // Using an object rather than a `Map` as it performed better in our benchmarks.
    // Would be happy to move to `Map` if it proved to be better under real conditions.
    const map = {};
    // Note: using loops to minimize iterations over the collection
    for (const value of classNames){
        // Exclude all falsy values, which leaves us with populated strings
        if (!value) continue;
        // a `value` can contain multiple classnames
        const list = value.split(' ');
        for (const className of list){
            /**
             * For atomic style classnames: the `key` is the `group`
             *
             * - Later atomic classnames with the same `group` will override earlier ones
             *   (which is what we want).
             * - Assumes atomic classnames are the only things that start with `_`
             * - Could use a regex to ensure that atomic classnames are structured how we expect,
             *   but did not add that for now as it did slow things down a bit.
             *
             * For other classnames: the `key` is the whole classname
             * - Okay to remove duplicates as doing so does not impact specificity
             *
             * */ const key = className.startsWith('_') ? className.slice(0, className.length - $0b40243983036a60$var$ATOMIC_VALUE_HASH_LENGTH) : className;
            map[key] = className;
        }
    }
    /**
     * We are converting the `map` into a string.
     *
     * The simple way to do this would be `Object.values(map).join(' ')`.
     * However, the approach below performs 10%-20% better in benchmarks.
     *
     * For `ax()` it feels right to squeeze as much runtime performance out as we can.
     */ let result = '';
    for(const key in map)result += map[key] + ' ';
    // If we have an empty string, then our `map` was empty.
    if (!result) return;
    // remove last " " from the result (we added " " at the end of every value)
    return result.trimEnd();
}



var $5FkrB = parcelRequire("5FkrB");

var $5FkrB = parcelRequire("5FkrB");
var $45232a30ce3c6353$var$interactionContext = /*#__PURE__*/ (0, $5FkrB.createContext)(null);
var $45232a30ce3c6353$export$2e2bcd8739ae039 = $45232a30ce3c6353$var$interactionContext;



var $50U6m = parcelRequire("50U6m");
var $f2064a4b8643d702$var$shimmerKeyframes = null;
var $f2064a4b8643d702$var$skeletonStyles = null;
var $f2064a4b8643d702$var$activeShimmerStyles = null;
/**
 * `useLayoutEffect` is being used in SSR safe form. On the server, this work doesn’t need to run.
 * `useEffect` is used in-place, because `useEffect` is not run on the server and it matches types
 * which makes things simpler than doing an `isServer` check or a `null` check.
 *
 * @see https://hello.atlassian.net/wiki/spaces/DST/pages/2081696628/DSTDACI-010+-+Interaction+Tracing+hooks+in+DS+components
 */ var $f2064a4b8643d702$var$useLayoutEffect = typeof window === 'undefined' ? (0, $5FkrB.useEffect) : (0, $5FkrB.useLayoutEffect);
/**
 * __Skeleton__
 *
 * A skeleton acts as a placeholder for content, usually while the content loads.
 *
 * - [Examples](https://atlassian.design/components/skeleton/examples)
 * - [Code](https://atlassian.design/components/skeleton/code)
 */ var $f2064a4b8643d702$var$Skeleton = function Skeleton(_ref) {
    var width = _ref.width, height = _ref.height, _ref$borderRadius = _ref.borderRadius, borderRadius = _ref$borderRadius === void 0 ? "var(--ds-radius-small, 4px)" : _ref$borderRadius, color = _ref.color, ShimmeringEndColor = _ref.ShimmeringEndColor, _ref$isShimmering = _ref.isShimmering, isShimmering = _ref$isShimmering === void 0 ? false : _ref$isShimmering, groupName = _ref.groupName, interactionName = _ref.interactionName, testId = _ref.testId;
    var groupDataAttribute = groupName && "data-".concat(groupName);
    var context = (0, $5FkrB.useContext)((0, $45232a30ce3c6353$export$2e2bcd8739ae039));
    $f2064a4b8643d702$var$useLayoutEffect(function() {
        if (context != null && (0, $50U6m.fg)('platform-dst-skeleton-ufo-hold')) return context.hold(interactionName);
    }, [
        context,
        interactionName
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("div", (0, $f94440ac60ee9089$export$2e2bcd8739ae039)({
        "data-testid": testId,
        style: {
            width: width,
            height: height,
            borderRadius: borderRadius,
            backgroundColor: color,
            // Override the keyframes if both colors are provided, otherwise use the CSS variable fallbacks in our keyframes
            '--ds-skeleton-from-color': color && ShimmeringEndColor ? color : undefined,
            '--ds-skeleton-to-color': color && ShimmeringEndColor ? ShimmeringEndColor : undefined
        }
    }, groupDataAttribute && (0, $cfb05d39d00b1b61$export$2e2bcd8739ae039)({}, groupDataAttribute, 'true'), {
        className: (0, $0b40243983036a60$export$2e2bcd8739ae039)([
            "_7hjf1yy8 _5sag12o8 _tip812c5 _1pglp3kn _bfhkizff",
            isShimmering && "",
            isShimmering && "_j7hq1532"
        ])
    }));
};
var $f2064a4b8643d702$export$2e2bcd8739ae039 = $f2064a4b8643d702$var$Skeleton;


var $36f20f204e45d177$var$_excluded = [
    "as",
    "style"
];
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
var $36f20f204e45d177$var$SkeletonWrapper = (0, $5FkrB.forwardRef)(function(_ref, __cmplr) {
    var _ref$as = _ref.as, C = _ref$as === void 0 ? "span" : _ref$as, __cmpls = _ref.style, __cmplp = (0, $4331f8efe1ae1766$export$2e2bcd8739ae039)(_ref, $36f20f204e45d177$var$_excluded);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(C, (0, $1d9435bc967bcf1f$export$2e2bcd8739ae039)({}, __cmplp, {
        style: __cmpls,
        ref: __cmplr,
        className: (0, $9eb596671e88e808$export$2e2bcd8739ae039)([
            "_1e0c1o8l",
            __cmplp.className
        ])
    }));
});
var $36f20f204e45d177$export$cb6ddd830302c2a8 = function SkeletonText(_ref2) {
    var length = _ref2.length;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement($36f20f204e45d177$var$SkeletonWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $f2064a4b8643d702$export$2e2bcd8739ae039), {
        width: length,
        height: "1em",
        borderRadius: "var(--ds-radius-full, 9999px)"
    }));
};


var $0c3f7b861937c858$var$_excluded = [
    "as",
    "style"
], $0c3f7b861937c858$var$_excluded2 = [
    "as",
    "style"
], $0c3f7b861937c858$var$_excluded3 = [
    "as",
    "style"
], $0c3f7b861937c858$var$_excluded4 = [
    "as",
    "style"
], $0c3f7b861937c858$var$_excluded5 = [
    "hasHeader"
], $0c3f7b861937c858$var$_excluded6 = [
    "as",
    "style"
], $0c3f7b861937c858$var$_excluded7 = [
    "as",
    "style"
], $0c3f7b861937c858$var$_excluded8 = [
    "as",
    "style"
];
function $0c3f7b861937c858$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $0c3f7b861937c858$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $0c3f7b861937c858$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $a08c26c0a691d97c$export$2e2bcd8739ae039)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $0c3f7b861937c858$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $0c3f7b861937c858$export$66e04d0aacdb3b2 = function AccountDetails(_ref) {
    var testId = _ref.testId, name = _ref.name, picture = _ref.picture, email = _ref.email, managedBy = _ref.managedBy, avatarOverlay = _ref.avatarOverlay;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement($0c3f7b861937c858$var$Container, {
        "data-testid": testId
    }, managedBy && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement($0c3f7b861937c858$var$ManagedBy, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement($0c3f7b861937c858$var$PersonIconWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($75a03a788dbb037a$exports))), {
        color: "currentColor",
        label: ""
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $bgNpv.default), {
        id: "identity.account-menu.account-menu-details.managed-account",
        defaultMessage: "This account is managed by <b>{managedBy}</b>",
        description: "Label showing the user which organisation manages their Atlassian account",
        values: {
            b: function b(text) {
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $5209c25cc099adfe$export$5f1af8db9871e1d6), {
                    as: "strong",
                    size: "small",
                    color: "inherit"
                }, text);
            },
            managedBy: managedBy
        }
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement($0c3f7b861937c858$var$Content, {
        hasHeader: !!managedBy
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement($0c3f7b861937c858$var$Profile, {
        testId: testId,
        name: name,
        picture: picture,
        email: email,
        avatarOverlay: avatarOverlay
    })));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
var $0c3f7b861937c858$var$Container = (0, $5FkrB.forwardRef)(function(_ref2, __cmplr) {
    var _ref2$as = _ref2.as, C = _ref2$as === void 0 ? "section" : _ref2$as, __cmpls = _ref2.style, __cmplp = (0, $4331f8efe1ae1766$export$2e2bcd8739ae039)(_ref2, $0c3f7b861937c858$var$_excluded);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(C, (0, $1d9435bc967bcf1f$export$2e2bcd8739ae039)({}, __cmplp, {
        style: __cmpls,
        ref: __cmplr,
        className: (0, $9eb596671e88e808$export$2e2bcd8739ae039)([
            "_1e0c1txw _2lx21bp4 _19pkidpf _2hwxu2gc _otyridpf _18u0u2gc",
            __cmplp.className
        ])
    }));
});
var $0c3f7b861937c858$var$ManagedBy = (0, $5FkrB.forwardRef)(function(_ref3, __cmplr) {
    var _ref3$as = _ref3.as, C = _ref3$as === void 0 ? "small" : _ref3$as, __cmpls = _ref3.style, __cmplp = (0, $4331f8efe1ae1766$export$2e2bcd8739ae039)(_ref3, $0c3f7b861937c858$var$_excluded2);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(C, (0, $1d9435bc967bcf1f$export$2e2bcd8739ae039)({}, __cmplp, {
        style: __cmpls,
        ref: __cmplr,
        className: (0, $9eb596671e88e808$export$2e2bcd8739ae039)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _1e0cp8ho _ca0qv77o _u5f3u2gc _n3tdv77o _19bvu2gc _y3gn1h6o _13lifajl _qrwqfajl _mrkbidpf _1o0zidpf _bfhk19ip _syazazsu",
            __cmplp.className
        ])
    }));
});
var $0c3f7b861937c858$var$PersonIconWrapper = (0, $5FkrB.forwardRef)(function(_ref4, __cmplr) {
    var _ref4$as = _ref4.as, C = _ref4$as === void 0 ? "span" : _ref4$as, __cmpls = _ref4.style, __cmplp = (0, $4331f8efe1ae1766$export$2e2bcd8739ae039)(_ref4, $0c3f7b861937c858$var$_excluded3);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(C, (0, $1d9435bc967bcf1f$export$2e2bcd8739ae039)({}, __cmplp, {
        style: __cmpls,
        ref: __cmplr,
        className: (0, $9eb596671e88e808$export$2e2bcd8739ae039)([
            "_2hwx1b66 _nbgx1crf _1f021crf",
            __cmplp.className
        ])
    }));
});
var $0c3f7b861937c858$var$Content = (0, $5FkrB.forwardRef)(function(_ref5, __cmplr) {
    var _ref5$as = _ref5.as, C = _ref5$as === void 0 ? "div" : _ref5$as, __cmpls = _ref5.style, __cmplp = (0, $4331f8efe1ae1766$export$2e2bcd8739ae039)(_ref5, $0c3f7b861937c858$var$_excluded4);
    var hasHeader = __cmplp.hasHeader, __cmpldp = (0, $4331f8efe1ae1766$export$2e2bcd8739ae039)(__cmplp, $0c3f7b861937c858$var$_excluded5);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(C, (0, $1d9435bc967bcf1f$export$2e2bcd8739ae039)({}, __cmpldp, {
        style: $0c3f7b861937c858$var$_objectSpread($0c3f7b861937c858$var$_objectSpread({}, __cmpls), {}, {
            "--_1xsu82h": (0, $5d664fa77bbf025f$export$2e2bcd8739ae039)(__cmplp.hasHeader ? "0 0 ".concat("var(--ds-radius-small, 3px)", " ", "var(--ds-radius-small, 3px)") : "var(--ds-radius-small, 3px)")
        }),
        ref: __cmplr,
        className: (0, $9eb596671e88e808$export$2e2bcd8739ae039)([
            "_2rko107z _1e0c1txw _2lx21bp4 _bfhkhfxm",
            __cmplp.className
        ])
    }));
});
var $0c3f7b861937c858$var$Profile = function Profile(_ref6) {
    var name = _ref6.name, email = _ref6.email, picture = _ref6.picture, testId = _ref6.testId, avatarOverlay = _ref6.avatarOverlay;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement($0c3f7b861937c858$var$ProfileWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $bdaa79db9c20b544$export$2d75367b6e042d67), {
        src: picture,
        testId: testId && "".concat(testId, "--picture"),
        avatarOverlay: avatarOverlay
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement($0c3f7b861937c858$var$NameAndEmail, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $5209c25cc099adfe$export$5f1af8db9871e1d6), {
        size: "large",
        weight: "bold",
        testId: testId && "".concat(testId, "--name")
    }, name || /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $36f20f204e45d177$export$cb6ddd830302c2a8), {
        length: "6em"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement($0c3f7b861937c858$var$EmailAddress, {
        "data-testid": testId && "".concat(testId, "--email")
    }, email || /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $36f20f204e45d177$export$cb6ddd830302c2a8), {
        length: "10em"
    }))));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
var $0c3f7b861937c858$var$ProfileWrapper = (0, $5FkrB.forwardRef)(function(_ref7, __cmplr) {
    var _ref7$as = _ref7.as, C = _ref7$as === void 0 ? "div" : _ref7$as, __cmpls = _ref7.style, __cmplp = (0, $4331f8efe1ae1766$export$2e2bcd8739ae039)(_ref7, $0c3f7b861937c858$var$_excluded6);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(C, (0, $1d9435bc967bcf1f$export$2e2bcd8739ae039)({}, __cmplp, {
        style: __cmpls,
        ref: __cmplr,
        className: (0, $9eb596671e88e808$export$2e2bcd8739ae039)([
            "_1e0c1txw _2lx2vrvc _19pkpxbi _2hwxpxbi _otyrpxbi _18u0pxbi",
            __cmplp.className
        ])
    }));
});
var $0c3f7b861937c858$var$NameAndEmail = (0, $5FkrB.forwardRef)(function(_ref8, __cmplr) {
    var _ref8$as = _ref8.as, C = _ref8$as === void 0 ? "div" : _ref8$as, __cmpls = _ref8.style, __cmplp = (0, $4331f8efe1ae1766$export$2e2bcd8739ae039)(_ref8, $0c3f7b861937c858$var$_excluded7);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(C, (0, $1d9435bc967bcf1f$export$2e2bcd8739ae039)({}, __cmplp, {
        style: __cmpls,
        ref: __cmplr,
        className: (0, $9eb596671e88e808$export$2e2bcd8739ae039)([
            "_1e0c1txw _2lx21bp4 _19pk1wug _2hwxidpf _otyr1wug _18u0pxbi",
            __cmplp.className
        ])
    }));
});
var $0c3f7b861937c858$var$EmailAddress = (0, $5FkrB.forwardRef)(function(_ref9, __cmplr) {
    var _ref9$as = _ref9.as, C = _ref9$as === void 0 ? "p" : _ref9$as, __cmpls = _ref9.style, __cmplp = (0, $4331f8efe1ae1766$export$2e2bcd8739ae039)(_ref9, $0c3f7b861937c858$var$_excluded8);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(C, (0, $1d9435bc967bcf1f$export$2e2bcd8739ae039)({}, __cmplp, {
        style: __cmpls,
        ref: __cmplr,
        className: (0, $9eb596671e88e808$export$2e2bcd8739ae039)([
            "_19pkv77o _syaz1rpy _k48pi7a9",
            __cmplp.className
        ])
    }));
});





var $5FkrB = parcelRequire("5FkrB");

var $6bnW7 = parcelRequire("6bnW7");
var $bgNpv = parcelRequire("bgNpv");







/* button-item.tsx generated by @compiled/babel-plugin v3.0.2 */ 


var $5FkrB = parcelRequire("5FkrB");



var $fbeac1a9994cd1cc$var$_excluded = [
    "children",
    "description",
    "iconAfter",
    "iconBefore",
    "isDisabled",
    "isSelected",
    "onClick",
    "testId",
    "onMouseDown",
    "shouldTitleWrap",
    "shouldDescriptionWrap",
    "className",
    "interactionName"
];
/**
 * __Button item__
 *
 * A button item is used to populate a menu with items that are buttons.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/menu/docs/button-item)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/menu)
 */ var $fbeac1a9994cd1cc$var$ButtonItem = /*#__PURE__*/ (0, $5FkrB.memo)(/*#__PURE__*/ (0, $5FkrB.forwardRef)(function(props, ref) {
    var children = props.children, description = props.description, iconAfter = props.iconAfter, iconBefore = props.iconBefore, _props$isDisabled = props.isDisabled, isDisabled = _props$isDisabled === void 0 ? false : _props$isDisabled, _props$isSelected = props.isSelected, isSelected = _props$isSelected === void 0 ? false : _props$isSelected, onClick = props.onClick, testId = props.testId, onMouseDown = props.onMouseDown, shouldTitleWrap = props.shouldTitleWrap, shouldDescriptionWrap = props.shouldDescriptionWrap, UNSAFE_className = props.className, interactionName = props.interactionName, rest = (0, $4331f8efe1ae1766$export$2e2bcd8739ae039)(props, $fbeac1a9994cd1cc$var$_excluded);
    var onMouseDownHandler = onMouseDown;
    var interactionContext = (0, $5FkrB.useContext)((0, $0007c9cc7bc46561$export$2e2bcd8739ae039));
    var handleClick = (0, $5FkrB.useCallback)(function(e) {
        interactionContext === null || interactionContext === void 0 || interactionContext.tracePress(interactionName, e.timeStamp);
        onClick === null || onClick === void 0 || onClick(e);
    }, [
        onClick,
        interactionContext,
        interactionName
    ]);
    if (!children) return null;
    return /*#__PURE__*/ $5FkrB.createElement((0, $aa6e35b056f777b0$export$2e2bcd8739ae039), (0, $1d9435bc967bcf1f$export$2e2bcd8739ae039)({
        className: UNSAFE_className
    }, rest, {
        iconBefore: iconBefore,
        iconAfter: iconAfter,
        isDisabled: isDisabled,
        isSelected: isSelected,
        isTitleHeading: false,
        description: description,
        title: children,
        shouldTitleWrap: shouldTitleWrap,
        shouldDescriptionWrap: shouldDescriptionWrap,
        testId: testId && "".concat(testId, "--primitive")
    }), function(_ref) {
        var children = _ref.children, className = _ref.className;
        return /*#__PURE__*/ $5FkrB.createElement("button", (0, $1d9435bc967bcf1f$export$2e2bcd8739ae039)({
            "data-testid": testId,
            "aria-current": isSelected ? 'true' : undefined
        }, rest, {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: className,
            ref: ref,
            disabled: isDisabled,
            onClick: handleClick,
            onMouseDown: onMouseDownHandler,
            type: "button"
        }), children);
    });
}));
var $fbeac1a9994cd1cc$export$2e2bcd8739ae039 = $fbeac1a9994cd1cc$var$ButtonItem;



var $8a560013f46dae89$exports = {};
$8a560013f46dae89$exports = new URL("dark-mode.5b7c09da.svg", import.meta.url).toString();


var $58f4de3131f52e7e$exports = {};
$58f4de3131f52e7e$exports = new URL("light-mode.7f9eeb32.svg", import.meta.url).toString();


var $dc84893e9793514f$exports = {};
$dc84893e9793514f$exports = new URL("match-browser.cf8cedaf.svg", import.meta.url).toString();


var $f7ce78bd1b4fde9b$var$_excluded = [
    "triggerRef"
];
var $f7ce78bd1b4fde9b$export$9d63163ee2173b37 = function ThemeSwitcher(_ref) {
    var testId = _ref.testId, onThemeChange = _ref.onThemeChange, currentTheme = _ref.currentTheme, globalColorMode = _ref.globalColorMode, appearancePreferencesLink = _ref.appearancePreferencesLink, onThemeSwitcherOpenChange = _ref.onThemeSwitcherOpenChange;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).Fragment, null, $f7ce78bd1b4fde9b$var$themeOptions.map(function(_ref2) {
        var value = _ref2.value, thumbnail = _ref2.thumbnail;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("link", {
            rel: "preload",
            href: thumbnail,
            as: "image",
            key: value
        });
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $efa3e699f80dfb1c$export$2e2bcd8739ae039), {
        testId: testId,
        placement: "auto-start",
        onOpenChange: onThemeSwitcherOpenChange,
        trigger: function trigger(_ref3) {
            var triggerRef = _ref3.triggerRef, props = (0, $4331f8efe1ae1766$export$2e2bcd8739ae039)(_ref3, $f7ce78bd1b4fde9b$var$_excluded);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $fbeac1a9994cd1cc$export$2e2bcd8739ae039), (0, $1d9435bc967bcf1f$export$2e2bcd8739ae039)({
                ref: triggerRef,
                onClick: function onClick(event) {
                    return event.stopPropagation();
                },
                iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($63d34d3709a410be$exports))), {
                    color: "currentColor",
                    label: ""
                }),
                iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7d8ced6060a88250$exports))), {
                    color: "currentColor",
                    label: "",
                    size: "small"
                })
            }, props), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $bgNpv.default), {
                id: "identity.account-menu.theme-switcher.theme-button",
                defaultMessage: "Theme",
                description: "Label for button in the account menu to switch to a different theme"
            }));
        },
        shouldRenderToParent: false
    }, $f7ce78bd1b4fde9b$var$themeOptions.map(function(_ref4) {
        var label = _ref4.label, value = _ref4.value, thumbnail = _ref4.thumbnail;
        var isSynced = globalColorMode !== undefined && globalColorMode === value;
        var isSelected = currentTheme === value;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $506b749c17906ee8$export$2e2bcd8739ae039), {
            testId: "".concat(testId, "--radio-").concat(value),
            id: value,
            key: value,
            onClick: function onClick() {
                return onThemeChange(value);
            },
            isSelected: isSelected
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $04267de539304abd$export$fbae5b5ffd8af05e), {
            space: "space.150",
            alignBlock: "center"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("img", {
            src: thumbnail,
            width: 64,
            height: 48,
            alt: ""
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $70988de881688cbc$export$694e0d28c7ffc90c), {
            space: "space.025"
        }, label, isSynced && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $5209c25cc099adfe$export$5f1af8db9871e1d6), {
            size: "small",
            color: "color.text.subtlest"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $bgNpv.default), $f7ce78bd1b4fde9b$var$messages.syncedAcrossApps)))));
    }), appearancePreferencesLink && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $a511aba2d268bdcc$export$2e2bcd8739ae039), {
        hasSeparator: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $80616e41d77620e9$export$2e2bcd8739ae039), {
        href: appearancePreferencesLink,
        target: "_blank",
        rel: "noopener",
        testId: testId && "".concat(testId, "--personalize"),
        elemAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($a7026317cd16a808$exports))), {
            color: "currentColor",
            label: "",
            size: "small"
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $bgNpv.default), $f7ce78bd1b4fde9b$var$messages.personalize)))));
};
var $f7ce78bd1b4fde9b$var$messages = (0, $6bnW7.defineMessages)({
    light: {
        id: 'identity.account-menu.theme-switcher.light.option',
        defaultMessage: 'Light',
        description: 'Label for the theme switcher light option'
    },
    dark: {
        id: 'identity.account-menu.theme-switcher.dark.option',
        defaultMessage: 'Dark',
        description: 'Label for the theme switcher dark option'
    },
    matchBrowser: {
        id: 'identity.account-menu.theme-switcher.match-browser.option',
        defaultMessage: 'Match browser',
        description: 'Label for the theme switcher match browser option'
    },
    syncedAcrossApps: {
        id: 'identity.account-menu.theme-switcher.synced-across-apps',
        defaultMessage: 'Synced across apps',
        description: 'Indicates the theme option is synced with global account settings across all apps'
    },
    personalize: {
        id: 'identity.account-menu.theme-switcher.personalize',
        defaultMessage: 'Personalize',
        description: 'Link to personalize settings in the theme switcher menu'
    }
});
var $f7ce78bd1b4fde9b$var$themeOptions = [
    {
        label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $bgNpv.default), $f7ce78bd1b4fde9b$var$messages.light),
        value: 'light',
        thumbnail: (0, (/*@__PURE__*/$parcel$interopDefault($58f4de3131f52e7e$exports)))
    },
    {
        label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $bgNpv.default), $f7ce78bd1b4fde9b$var$messages.dark),
        value: 'dark',
        thumbnail: (0, (/*@__PURE__*/$parcel$interopDefault($8a560013f46dae89$exports)))
    },
    {
        label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $bgNpv.default), $f7ce78bd1b4fde9b$var$messages.matchBrowser),
        value: 'auto',
        thumbnail: (0, (/*@__PURE__*/$parcel$interopDefault($dc84893e9793514f$exports)))
    }
];


var $6d7f0986b882d194$var$_excluded = [
    "as",
    "style"
], $6d7f0986b882d194$var$_excluded2 = [
    "testId",
    "closePopup",
    "icon",
    "href",
    "onClick",
    "actionSubjectId",
    "children"
];
var $6d7f0986b882d194$export$49c2771125e1e9f1 = function AccountMenuContent(_ref) {
    var testId = _ref.testId, closePopup = _ref.closePopup, name = _ref.name, picture = _ref.picture, email = _ref.email, managedBy = _ref.managedBy, manageProfileLink = _ref.manageProfileLink, viewProfileLink = _ref.viewProfileLink, onViewProfileClick = _ref.onViewProfileClick, switchAccountLink = _ref.switchAccountLink, logOutLink = _ref.logOutLink, onThemeChange = _ref.onThemeChange, currentTheme = _ref.currentTheme, globalColorMode = _ref.globalColorMode, _ref$extraMenuItems = _ref.extraMenuItems, extraMenuItems = _ref$extraMenuItems === void 0 ? null : _ref$extraMenuItems, onLogoutClick = _ref.onLogoutClick, onThemeSwitcherOpenChange = _ref.onThemeSwitcherOpenChange, avatarOverlay = _ref.avatarOverlay;
    var themeSwitcherProps = onThemeChange && currentTheme;
    var shouldRenderProfileThemeSwitcherSection = Boolean(viewProfileLink || manageProfileLink || themeSwitcherProps);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement($6d7f0986b882d194$var$Container, {
        "data-testid": testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $a4e17e9e7a8d2775$export$2e2bcd8739ae039), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $8cf8088017c5287d$export$2e2bcd8739ae039), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $0c3f7b861937c858$export$66e04d0aacdb3b2), {
        testId: testId && "".concat(testId, "--details"),
        name: name,
        picture: picture,
        email: email,
        managedBy: managedBy,
        avatarOverlay: avatarOverlay
    })), shouldRenderProfileThemeSwitcherSection && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $8cf8088017c5287d$export$2e2bcd8739ae039), null, viewProfileLink && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement($6d7f0986b882d194$var$ViewProfileLink, {
        onClick: onViewProfileClick,
        testId: testId && "".concat(testId, "--view-profile"),
        href: viewProfileLink,
        closePopup: closePopup
    }), manageProfileLink && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement($6d7f0986b882d194$var$ManageProfileLink, {
        testId: testId && "".concat(testId, "--manage-profile"),
        href: manageProfileLink,
        closePopup: closePopup
    }), themeSwitcherProps && ((0, $50U6m.fg)('replace-account-menu-theme-switcher') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $555e3ba7b5aa1526$export$2e2bcd8739ae039), {
        testId: testId && "".concat(testId, "--theme-switcher"),
        onThemeChange: onThemeChange,
        currentColorMode: currentTheme,
        accountColorMode: globalColorMode !== null && globalColorMode !== void 0 ? globalColorMode : undefined,
        onOpenChange: onThemeSwitcherOpenChange,
        appearancePreferencesLink: globalColorMode !== undefined ? manageProfileLink === null || manageProfileLink === void 0 ? void 0 : manageProfileLink.replace(/(%2F|\/)manage-profile[^&]*/g, '$1manage-profile$1appearance-preferences') : undefined
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $f7ce78bd1b4fde9b$export$9d63163ee2173b37), {
        testId: testId && "".concat(testId, "--theme-switcher"),
        onThemeChange: onThemeChange,
        currentTheme: currentTheme,
        globalColorMode: globalColorMode,
        onThemeSwitcherOpenChange: onThemeSwitcherOpenChange,
        appearancePreferencesLink: globalColorMode !== undefined ? manageProfileLink === null || manageProfileLink === void 0 ? void 0 : manageProfileLink.replace(/(%2F|\/)manage-profile[^&]*/g, '$1manage-profile$1appearance-preferences') : undefined
    }))), extraMenuItems, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $8cf8088017c5287d$export$2e2bcd8739ae039), {
        hasSeparator: shouldRenderProfileThemeSwitcherSection
    }, switchAccountLink && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement($6d7f0986b882d194$var$SwitchAccountLink, {
        testId: testId && "".concat(testId, "--switch-account"),
        href: switchAccountLink,
        closePopup: closePopup
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement($6d7f0986b882d194$var$LogOutLink, {
        testId: testId && "".concat(testId, "--log-out"),
        href: logOutLink,
        closePopup: closePopup,
        onClick: onLogoutClick
    }))));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
var $6d7f0986b882d194$var$Container = (0, $5FkrB.forwardRef)(function(_ref2, __cmplr) {
    var _ref2$as = _ref2.as, C = _ref2$as === void 0 ? "div" : _ref2$as, __cmpls = _ref2.style, __cmplp = (0, $4331f8efe1ae1766$export$2e2bcd8739ae039)(_ref2, $6d7f0986b882d194$var$_excluded);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(C, (0, $1d9435bc967bcf1f$export$2e2bcd8739ae039)({}, __cmplp, {
        style: __cmpls,
        ref: __cmplr,
        className: (0, $9eb596671e88e808$export$2e2bcd8739ae039)([
            "_vchhusvi _1ul9ko4j",
            __cmplp.className
        ])
    }));
});
var $6d7f0986b882d194$var$ViewProfileLink = function ViewProfileLink(_ref3) {
    var testId = _ref3.testId, href = _ref3.href, onClick = _ref3.onClick, closePopup = _ref3.closePopup;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement($6d7f0986b882d194$var$Link, {
        testId: testId,
        href: href,
        onClick: onClick,
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($75a03a788dbb037a$exports))), {
            color: "currentColor",
            label: ""
        }),
        closePopup: closePopup,
        actionSubjectId: "viewProfileLink"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $bgNpv.default), {
        id: "identity.account-menu.account-details.view-profile-tooltip",
        defaultMessage: "Profile",
        description: "Text shown when hovering over profile information"
    }));
};
var $6d7f0986b882d194$var$ManageProfileLink = function ManageProfileLink(_ref4) {
    var testId = _ref4.testId, href = _ref4.href, closePopup = _ref4.closePopup;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement($6d7f0986b882d194$var$Link, {
        testId: testId,
        href: href,
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($d4f0228da18a65bb$exports))), {
            color: "currentColor",
            label: ""
        }),
        closePopup: closePopup,
        actionSubjectId: "manageProfileLink",
        target: "_blank",
        rel: "noopener"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $bgNpv.default), {
        id: "identity.account-menu.account-details.manage-profile-link",
        defaultMessage: "Account settings",
        description: "Text for link to account management page"
    }));
};
var $6d7f0986b882d194$var$SwitchAccountLink = function SwitchAccountLink(_ref5) {
    var testId = _ref5.testId, href = _ref5.href, closePopup = _ref5.closePopup;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement($6d7f0986b882d194$var$Link, {
        testId: testId,
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($77184fb3111af523$exports))), {
            color: "currentColor",
            label: ""
        }),
        href: href,
        closePopup: closePopup,
        actionSubjectId: "switchAccountLink"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $bgNpv.default), {
        id: "identity.account-menu.account-menu-content.switch-account-button",
        defaultMessage: "Switch account",
        description: "Label for button in account menu to switch to another another account"
    }));
};
var $6d7f0986b882d194$var$LogOutLink = function LogOutLink(_ref6) {
    var testId = _ref6.testId, href = _ref6.href, closePopup = _ref6.closePopup, onClick = _ref6.onClick;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement($6d7f0986b882d194$var$Link, {
        testId: testId,
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5bb1f5651d9a5dad$exports))), {
            color: "currentColor",
            label: ""
        }),
        href: href,
        closePopup: closePopup,
        actionSubjectId: "logOutLink",
        onClick: onClick
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $bgNpv.default), {
        id: "identity.account-menu.account-menu-content.log-out-button",
        defaultMessage: "Log out",
        description: "Label for button in account menu to log out"
    }));
};
var $6d7f0986b882d194$var$Link = function Link(_ref7) {
    var testId = _ref7.testId, closePopup = _ref7.closePopup, icon = _ref7.icon, href = _ref7.href, onClick = _ref7.onClick, actionSubjectId = _ref7.actionSubjectId, children = _ref7.children, props = (0, $4331f8efe1ae1766$export$2e2bcd8739ae039)(_ref7, $6d7f0986b882d194$var$_excluded2);
    var _useAnalyticsEvents = (0, $879f28ba40c47674$export$5bf35293e545f20c)(), createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
    var handleClick = (0, $5FkrB.useCallback)(function(event) {
        var analyticsEvent = createAnalyticsEvent({
            eventType: (0, $873f7350fa85064d$export$a1562d08625f5d7e),
            action: 'clicked',
            actionSubject: 'menuLinkItem',
            actionSubjectId: actionSubjectId
        });
        var clone = analyticsEvent.clone();
        if (clone) clone.fire((0, $861fb90c15a92ca3$export$515664faa1398f37));
        onClick === null || onClick === void 0 || onClick(event, analyticsEvent);
        closePopup === null || closePopup === void 0 || closePopup(event);
    }, [
        createAnalyticsEvent,
        onClick,
        closePopup,
        actionSubjectId
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $08f543ef51158ffe$export$2e2bcd8739ae039), (0, $1d9435bc967bcf1f$export$2e2bcd8739ae039)({
        testId: testId,
        iconBefore: icon,
        href: href,
        onClick: handleClick
    }, props), children);
};


function $336c1d74706d2e8f$var$asyncGeneratorStep(n, t, e, r, o, a, c) {
    try {
        var i = n[a](c), u = i.value;
    } catch (n) {
        return void e(n);
    }
    i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function $336c1d74706d2e8f$export$2e2bcd8739ae039(n) {
    return function() {
        var t = this, e = arguments;
        return new Promise(function(r, o) {
            var a = n.apply(t, e);
            function _next(n) {
                $336c1d74706d2e8f$var$asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
            }
            function _throw(n) {
                $336c1d74706d2e8f$var$asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
            }
            _next(void 0);
        });
    };
}



var $db11cd696e7d258a$exports = {};
// TODO(Babel 8): Remove this file.

var $db11cd696e7d258a$var$runtime = (parcelRequire("jglJy"))();
$db11cd696e7d258a$exports = $db11cd696e7d258a$var$runtime;
// Copied from https://github.com/facebook/regenerator/blob/main/packages/runtime/runtime.js#L736=
try {
    regeneratorRuntime = $db11cd696e7d258a$var$runtime;
} catch (accidentalStrictMode) {
    if (typeof globalThis === "object") globalThis.regeneratorRuntime = $db11cd696e7d258a$var$runtime;
    else Function("r", "regeneratorRuntime = r")($db11cd696e7d258a$var$runtime);
}



var $5FkrB = parcelRequire("5FkrB");

var $9Pk7k = parcelRequire("9Pk7k");
var $hrVKU = parcelRequire("hrVKU");
/**
 * NOTE:
 *
 * This file is automatically generated by scripts/generate-i18n-index.ts.
 * DO NOT UPDATE IT BY HAND. Instead, run yarn generate-i18n-index.
 */ 










































var $dca51a067dacb9eb$var$lazyMessages = {
    cs: function cs() {
        return (parcelRequire("haMz6"));
    },
    cs_CZ: function cs_CZ() {
        return (parcelRequire("b5PJM"));
    },
    da: function da() {
        return (parcelRequire("pUh1o"));
    },
    da_DK: function da_DK() {
        return (parcelRequire("hJIz5"));
    },
    de: function de() {
        return (parcelRequire("i5EFq"));
    },
    de_DE: function de_DE() {
        return (parcelRequire("cTOZV"));
    },
    en_GB: function en_GB() {
        return (parcelRequire("eIUU7"));
    },
    en_ZZ: function en_ZZ() {
        return (parcelRequire("4Ob3J"));
    },
    es: function es() {
        return (parcelRequire("6bSAo"));
    },
    fi: function fi() {
        return (parcelRequire("b396J"));
    },
    fi_FI: function fi_FI() {
        return (parcelRequire("98HMn"));
    },
    fr: function fr() {
        return (parcelRequire("lINaI"));
    },
    fr_FR: function fr_FR() {
        return (parcelRequire("5pEXZ"));
    },
    hu: function hu() {
        return (parcelRequire("1pceg"));
    },
    hu_HU: function hu_HU() {
        return (parcelRequire("83GJZ"));
    },
    it: function it() {
        return (parcelRequire("9sDTl"));
    },
    it_IT: function it_IT() {
        return (parcelRequire("fyQBL"));
    },
    ja: function ja() {
        return (parcelRequire("hYjC7"));
    },
    ja_JP: function ja_JP() {
        return (parcelRequire("4URDm"));
    },
    ko: function ko() {
        return (parcelRequire("izPbQ"));
    },
    ko_KR: function ko_KR() {
        return (parcelRequire("iBleh"));
    },
    nb: function nb() {
        return (parcelRequire("hgetp"));
    },
    nb_NO: function nb_NO() {
        return (parcelRequire("dsSdF"));
    },
    nl: function nl() {
        return (parcelRequire("7UCkC"));
    },
    nl_NL: function nl_NL() {
        return (parcelRequire("9Y2YI"));
    },
    pl: function pl() {
        return (parcelRequire("1kaGM"));
    },
    pl_PL: function pl_PL() {
        return (parcelRequire("65kcv"));
    },
    pt_BR: function pt_BR() {
        return (parcelRequire("69Vil"));
    },
    ru: function ru() {
        return (parcelRequire("CXYQs"));
    },
    ru_RU: function ru_RU() {
        return (parcelRequire("LP0zb"));
    },
    sv: function sv() {
        return (parcelRequire("3t9D4"));
    },
    sv_SE: function sv_SE() {
        return (parcelRequire("7CFjR"));
    },
    th: function th() {
        return (parcelRequire("4Vzmc"));
    },
    th_TH: function th_TH() {
        return (parcelRequire("l6gWb"));
    },
    tr: function tr() {
        return (parcelRequire("gRaCK"));
    },
    tr_TR: function tr_TR() {
        return (parcelRequire("fxElF"));
    },
    uk: function uk() {
        return (parcelRequire("2y1Vi"));
    },
    uk_UA: function uk_UA() {
        return (parcelRequire("74BOO"));
    },
    vi: function vi() {
        return (parcelRequire("9zenb"));
    },
    vi_VN: function vi_VN() {
        return (parcelRequire("9RiHi"));
    },
    zh: function zh() {
        return (parcelRequire("jNCUF"));
    },
    zh_CN: function zh_CN() {
        return (parcelRequire("1Psq8"));
    },
    zh_TW: function zh_TW() {
        return (parcelRequire("diOmO"));
    }
};
var $dca51a067dacb9eb$export$2e2bcd8739ae039 = $dca51a067dacb9eb$var$lazyMessages;


/**
 * Code path previously used optional chaining (process?.env?.NODE_ENV) which crashed the townsquare local dev loop
 * This approach removes the chaining, and will fallback if there's any other issues.
 */ function $79eedf084972bf07$var$isDev() {
    try {
        return false;
    } catch (_unused) {
        return false;
    }
}
var $79eedf084972bf07$export$6c1f1571e3dd1b34 = function AccountMenuIntlProvider(_ref) {
    var children = _ref.children;
    var _useIntl = (0, $hrVKU.default)(), locale = _useIntl.locale;
    var messages = $79eedf084972bf07$var$useMessages(locale);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $9Pk7k.default), {
        locale: locale,
        messages: messages,
        onError: function onError(err) {
            // Do not spam local devloop with missing translation errors
            //
            // See: https://github.com/formatjs/formatjs/issues/465#issuecomment-643887472
            // Note the default error handler: https://github.com/formatjs/formatjs/blob/d0b80fd9a814d1427b73577aebb7ccdb80b9ae94/packages/intl/src/utils.ts#L43
            if ($79eedf084972bf07$var$isDev() && (err === null || err === void 0 ? void 0 : err.code) !== 'MISSING_TRANSLATION') // eslint-disable-next-line no-console
            console.error(err);
        }
    }, children);
};
var $79eedf084972bf07$var$useMessages = function useMessages(locale) {
    var _useState = (0, $5FkrB.useState)(), _useState2 = (0, $045ba0d411b9feb5$export$2e2bcd8739ae039)(_useState, 2), messages = _useState2[0], setMessages = _useState2[1];
    (0, $5FkrB.useEffect)(function() {
        if (/^en(-US)?$/i.exec(locale)) // Use fallback messages, which are already US English
        setMessages(undefined);
        else {
            var cancelled = false;
            $79eedf084972bf07$var$loadMessages(locale).catch(function(_error) {
                return undefined;
            }) // TODO: Log error somehow (analytics?)
            .then(function(messages) {
                if (!cancelled) setMessages(messages);
            });
            return function() {
                cancelled = true;
            };
        }
    }, [
        locale,
        setMessages
    ]);
    return messages;
};
var $79eedf084972bf07$var$loadMessages = /*#__PURE__*/ function() {
    var _ref2 = (0, $336c1d74706d2e8f$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($db11cd696e7d258a$exports))).mark(function _callee(locale) {
        var _yield, _ref3;
        var _locale$split, _locale$split2, language, _locale$split2$, region, _t, _t2, _t3;
        return (0, (/*@__PURE__*/$parcel$interopDefault($db11cd696e7d258a$exports))).wrap(function(_context) {
            while(true)switch(_context.prev = _context.next){
                case 0:
                    _locale$split = locale.split('-', 2), _locale$split2 = (0, $045ba0d411b9feb5$export$2e2bcd8739ae039)(_locale$split, 2), language = _locale$split2[0], _locale$split2$ = _locale$split2[1], region = _locale$split2$ === void 0 ? '' : _locale$split2$;
                    language = language.toLowerCase();
                    region = region.toUpperCase();
                    _context.next = 1;
                    return (_ref3 = (0, $dca51a067dacb9eb$export$2e2bcd8739ae039)["".concat(language, "_").concat(region)] || (0, $dca51a067dacb9eb$export$2e2bcd8739ae039)[language]) === null || _ref3 === void 0 ? void 0 : _ref3();
                case 1:
                    _t2 = _yield = _context.sent;
                    _t = _t2 === null;
                    if (_t) {
                        _context.next = 2;
                        break;
                    }
                    _t = _yield === void 0;
                case 2:
                    if (!_t) {
                        _context.next = 3;
                        break;
                    }
                    _t3 = void 0;
                    _context.next = 4;
                    break;
                case 3:
                    _t3 = _yield.default;
                case 4:
                    return _context.abrupt("return", _t3);
                case 5:
                case "end":
                    return _context.stop();
            }
        }, _callee);
    }));
    return function loadMessages(_x) {
        return _ref2.apply(this, arguments);
    };
}();





var $5FkrB = parcelRequire("5FkrB");


var $5FkrB = parcelRequire("5FkrB");


var $9fb6d6a188216314$export$53c2b9c37c40e0d8 = function useCallbackWithAnalytics(method, payload, channel) {
    var _useAnalyticsEvents = (0, $879f28ba40c47674$export$5bf35293e545f20c)(), createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
    var methodRef = (0, $90d091140a6cc984$export$1d27a74659855e44)(method);
    var payloadRef = (0, $90d091140a6cc984$export$1d27a74659855e44)(payload);
    return (0, $5FkrB.useCallback)(function() {
        var pload = typeof payloadRef.current === 'function' ? payloadRef.current.apply(payloadRef, arguments) : payloadRef.current;
        createAnalyticsEvent(pload).fire(channel);
        methodRef.current.apply(methodRef, arguments);
    }, [
        createAnalyticsEvent,
        methodRef,
        payloadRef,
        channel
    ]);
};




var $18a8b6b12f11220d$export$473cb05bf335b0e1 = function AccountMenuPopup(_ref) {
    var testId = _ref.testId, picture = _ref.picture, email = _ref.email, content = _ref.content, _ref$trustPicture = _ref.trustPicture, trustPicture = _ref$trustPicture === void 0 ? false : _ref$trustPicture, AccountMenuTrigger = _ref.AccountMenuTrigger;
    var _useState = (0, $5FkrB.useState)(false), _useState2 = (0, $045ba0d411b9feb5$export$2e2bcd8739ae039)(_useState, 2), isOpen = _useState2[0], setIsOpen = _useState2[1];
    var close = (0, $9fb6d6a188216314$export$53c2b9c37c40e0d8)(function() {
        return setIsOpen(false);
    }, {
        eventType: (0, $873f7350fa85064d$export$a1562d08625f5d7e),
        action: 'closed',
        actionSubject: 'popup',
        actionSubjectId: 'accountMenu'
    }, (0, $861fb90c15a92ca3$export$515664faa1398f37));
    var open = (0, $9fb6d6a188216314$export$53c2b9c37c40e0d8)(function() {
        return setIsOpen(true);
    }, {
        eventType: (0, $873f7350fa85064d$export$a1562d08625f5d7e),
        action: 'opened',
        actionSubject: 'popup',
        actionSubjectId: 'accountMenu'
    }, (0, $861fb90c15a92ca3$export$515664faa1398f37));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $a2b7f495199a9de5$export$129a32eedafa97c5), {
        isOpen: isOpen,
        onClose: close,
        testId: testId,
        placement: "bottom",
        trigger: function trigger(triggerProps) {
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(AccountMenuTrigger, (0, $1d9435bc967bcf1f$export$2e2bcd8739ae039)({
                onClick: isOpen ? close : open,
                testId: testId && "".concat(testId, "--trigger"),
                picture: picture,
                email: email,
                trustPicture: trustPicture
            }, triggerProps));
        },
        content: content
    });
};


var $3820947fe9194e15$export$ff20d75d5eda4388 = function AccountMenu(_ref) {
    var testId = _ref.testId, globalColorMode = _ref.globalColorMode, name = _ref.name, picture = _ref.picture, email = _ref.email, managedBy = _ref.managedBy, manageProfileLink = _ref.manageProfileLink, viewProfileLink = _ref.viewProfileLink, onViewProfileClick = _ref.onViewProfileClick, switchAccountLink = _ref.switchAccountLink, logOutLink = _ref.logOutLink, logInLink = _ref.logInLink, onThemeChange = _ref.onThemeChange, currentTheme = _ref.currentTheme, extraMenuItems = _ref.extraMenuItems, _ref$trustPicture = _ref.trustPicture, trustPicture = _ref$trustPicture === void 0 ? false : _ref$trustPicture, onLogoutClick = _ref.onLogoutClick, onThemeSwitcherOpenChange = _ref.onThemeSwitcherOpenChange, avatarOverlay = _ref.avatarOverlay, AccountMenuLoggedOutState = _ref.AccountMenuLoggedOutState, AccountMenuTrigger = _ref.AccountMenuTrigger;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $fb54a115516e258d$export$d0a82da1a0b94929), {
        data: (0, $861fb90c15a92ca3$export$3cbe56a0cabcff38)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $79eedf084972bf07$export$6c1f1571e3dd1b34), null, logInLink ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(AccountMenuLoggedOutState, {
        testId: testId && "".concat(testId, "--logged-out-state"),
        logInLink: logInLink
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $18a8b6b12f11220d$export$473cb05bf335b0e1), {
        testId: testId,
        picture: picture,
        trustPicture: trustPicture,
        email: email,
        AccountMenuTrigger: AccountMenuTrigger,
        content: function content(_ref2) {
            var closePopup = _ref2.onClose;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $6d7f0986b882d194$export$49c2771125e1e9f1), {
                testId: testId && "".concat(testId, "--content"),
                closePopup: closePopup,
                globalColorMode: globalColorMode,
                name: name,
                picture: picture,
                email: email,
                managedBy: managedBy,
                manageProfileLink: manageProfileLink,
                viewProfileLink: viewProfileLink,
                onViewProfileClick: onViewProfileClick,
                switchAccountLink: switchAccountLink,
                logOutLink: logOutLink,
                onThemeChange: onThemeChange,
                currentTheme: currentTheme,
                extraMenuItems: extraMenuItems,
                onLogoutClick: onLogoutClick,
                onThemeSwitcherOpenChange: onThemeSwitcherOpenChange,
                avatarOverlay: avatarOverlay
            });
        }
    })));
};


var $e4ca26362740a2c5$export$4ff56e5cf713dc64 = function AccountMenuNav3(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $3820947fe9194e15$export$ff20d75d5eda4388), (0, $1d9435bc967bcf1f$export$2e2bcd8739ae039)({}, props, {
        AccountMenuLoggedOutState: (0, $6591d79d95f2b3d1$export$5e6158d2118ae4aa),
        AccountMenuTrigger: (0, $2fa2b19c168c8215$export$89d857133932d6aa)
    }));
};



function $e6c3471df63f777a$export$2e2bcd8739ae039(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}


function $26b207bae9271069$export$2e2bcd8739ae039(e, t) {
    if (null == e) return {};
    var o, r, i = (0, $e6c3471df63f777a$export$2e2bcd8739ae039)(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}



var $5FkrB = parcelRequire("5FkrB");
function $7cf0e143fa49a02e$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return r;
}


function $3839225009c43e01$export$2e2bcd8739ae039(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}


function $959ccc3518686727$export$2e2bcd8739ae039(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}


function $337072f58f1661e8$export$2e2bcd8739ae039(r, a) {
    if (r) {
        if ("string" == typeof r) return (0, $959ccc3518686727$export$2e2bcd8739ae039)(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? (0, $959ccc3518686727$export$2e2bcd8739ae039)(r, a) : void 0;
    }
}


function $68847fae45a6990a$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}


function $1a28b22a075eeee5$export$2e2bcd8739ae039(r, e) {
    return (0, $7cf0e143fa49a02e$export$2e2bcd8739ae039)(r) || (0, $3839225009c43e01$export$2e2bcd8739ae039)(r, e) || (0, $337072f58f1661e8$export$2e2bcd8739ae039)(r, e) || (0, $68847fae45a6990a$export$2e2bcd8739ae039)();
}


/**
 * An Identity environment to integrate with. Either a `"dev"`, `"fedex"`, `"staging"` or
 * `"prod"` for real Identity environments, or an `EnvironmentConfig` object for
 * using a fake environment (e.g. for local dev).
 */ var $f24da19ac526bea6$var$environmentConfigs = {
    dev: {
        baseUrl: 'https://id.dev.internal.atlassian.com'
    },
    fedex: {
        baseUrl: 'https://id.atlassian-fex.com'
    },
    staging: {
        baseUrl: 'https://id.stg.internal.atlassian.com'
    },
    'staging-fedramp-moderate': {
        baseUrl: 'https://id.stg.atlassian-us-gov-mod.com'
    },
    prod: {
        baseUrl: 'https://id.atlassian.com'
    },
    'prod-fedramp-moderate': {
        baseUrl: 'https://id.atlassian-us-gov-mod.com'
    }
};
function $f24da19ac526bea6$export$eabfcea451f48b90(identityEnvironment) {
    if (typeof identityEnvironment === 'string') return $f24da19ac526bea6$var$environmentConfigs[identityEnvironment];
    else return identityEnvironment;
}


/**
 * Helper function to create a string of custom query parameters
 * Returns a string like "&orgId=blah&..." that can be appended to URLs
 */ var $578db00e7b19ae56$var$createCustomParametersString = function createCustomParametersString(customParameters) {
    if (!customParameters || Object.keys(customParameters).length === 0) return '';
    return Object.entries(customParameters).map(function(_ref) {
        var _ref2 = (0, $1a28b22a075eeee5$export$2e2bcd8739ae039)(_ref, 2), key = _ref2[0], value = _ref2[1];
        return "&".concat(encodeURIComponent(key), "=").concat(encodeURIComponent(value));
    }).join('');
};
var $578db00e7b19ae56$var$buildProfileLink = function buildProfileLink(baseUrl, path, applicationParam, email, logInLinkCustomParameters) {
    var profileUrl = "".concat(baseUrl).concat(path);
    if (email) {
        var logInLinkCustomParamsString = $578db00e7b19ae56$var$createCustomParametersString(logInLinkCustomParameters);
        var loginUrl = "".concat(baseUrl, "/login?").concat(applicationParam, "&continue=").concat(encodeURIComponent(profileUrl), "&prompt=none&login_hint=").concat(encodeURIComponent(email)).concat(logInLinkCustomParamsString);
        return loginUrl;
    }
    return profileUrl;
};
function $578db00e7b19ae56$export$2afde6c526be23b9(_ref3) {
    var email = _ref3.email, identityEnvironment = _ref3.identityEnvironment, application = _ref3.application, continueUrl = _ref3.continueUrl, logOutContinueUrl = _ref3.logOutContinueUrl, isLoggedOut = _ref3.isLoggedOut, disableSwitchAccountLink = _ref3.disableSwitchAccountLink, logInLinkCustomParameters = _ref3.logInLinkCustomParameters;
    var _resolveEnvironment = (0, $f24da19ac526bea6$export$eabfcea451f48b90)(identityEnvironment), baseUrl = _resolveEnvironment.baseUrl;
    var applicationParam = "application=".concat(encodeURIComponent(application));
    var continueParam = "continue=".concat(encodeURIComponent(continueUrl));
    var logOutContinueParam = logOutContinueUrl ? "continue=".concat(encodeURIComponent(logOutContinueUrl)) : continueParam;
    var manageProfileLink = $578db00e7b19ae56$var$buildProfileLink(baseUrl, '/manage-profile', applicationParam, email, logInLinkCustomParameters);
    return {
        manageProfileLink: manageProfileLink,
        switchAccountLink: disableSwitchAccountLink ? undefined : "".concat(baseUrl, "/login?").concat(applicationParam, "&").concat(continueParam, "&prompt=select_account").concat($578db00e7b19ae56$var$createCustomParametersString(logInLinkCustomParameters)),
        logOutLink: "".concat(baseUrl, "/logout?").concat(applicationParam, "&").concat(logOutContinueParam) + (disableSwitchAccountLink ? '' : '&prompt=none'),
        logInLink: isLoggedOut ? "".concat(baseUrl, "/login?").concat(applicationParam, "&").concat(continueParam).concat($578db00e7b19ae56$var$createCustomParametersString(logInLinkCustomParameters)) : undefined
    };
}


var $7d4e9c3480839f5b$var$_excluded = [
    "identityEnvironment",
    "application",
    "continueUrl",
    "logOutContinueUrl",
    "isLoggedOut",
    "disableSwitchAccountLink",
    "AccountMenu"
];
var $7d4e9c3480839f5b$export$df97669773647652 = function AccountInternal(_ref) {
    var identityEnvironment = _ref.identityEnvironment, application = _ref.application, continueUrl = _ref.continueUrl, logOutContinueUrl = _ref.logOutContinueUrl, isLoggedOut = _ref.isLoggedOut, disableSwitchAccountLink = _ref.disableSwitchAccountLink, AccountMenu = _ref.AccountMenu, props = (0, $26b207bae9271069$export$2e2bcd8739ae039)(_ref, $7d4e9c3480839f5b$var$_excluded);
    var links = (0, $578db00e7b19ae56$export$2afde6c526be23b9)({
        email: props.email,
        identityEnvironment: identityEnvironment,
        application: application,
        continueUrl: continueUrl,
        logOutContinueUrl: logOutContinueUrl,
        isLoggedOut: isLoggedOut,
        disableSwitchAccountLink: disableSwitchAccountLink
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(AccountMenu, (0, $c6779e936c45cab1$export$2e2bcd8739ae039)({}, props, links));
};


var $683e310356522ed0$export$75dc45130eee4ebb = function AccountNav3(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $7d4e9c3480839f5b$export$df97669773647652), (0, $c6779e936c45cab1$export$2e2bcd8739ae039)({}, props, {
        AccountMenu: (0, $e4ca26362740a2c5$export$4ff56e5cf713dc64)
    }));
};



var $i3UfC = parcelRequire("i3UfC");




var $5FkrB = parcelRequire("5FkrB");

var $2nBsU = parcelRequire("2nBsU");



function $e7524659741051c8$export$e03bb5c7fd72635(obj) {
    return Object.entries(obj).reduce(function(acc, _ref) {
        var _ref2 = (0, $8ddf8a10eebb4436$export$2e2bcd8739ae039)(_ref, 2), key = _ref2[0], value = _ref2[1];
        if (value !== null && value !== undefined && value !== '') acc[key] = value;
        return acc;
    }, {});
}


var $f4c563dd72a7132a$export$dad497fe1f6e27c0 = function getTag(onClick, href) {
    if (href) return 'a';
    if (onClick) return 'button';
    return 'div';
};



var $4c4e598cd6612632$var$_excluded = [
    "aria-label",
    "href",
    "icon",
    "logo",
    "logoMaxWidth",
    "onClick",
    "onMouseDown",
    "siteTitle",
    "testId"
];
var $4c4e598cd6612632$var$VAR_LOGO_MAX_WIDTH = '--logo-max-width';
var $4c4e598cd6612632$var$VAR_PRODUCT_HOME_COLOR_ACTIVE = '--product-home-color-active';
var $4c4e598cd6612632$var$VAR_PRODUCT_HOME_BACKGROUND_COLOR_ACTIVE = '--product-home-bg-color-active';
var $4c4e598cd6612632$var$VAR_PRODUCT_HOME_BOX_SHADOW_ACTIVE = '--product-home-box-shadow-active';
var $4c4e598cd6612632$var$VAR_PRODUCT_HOME_COLOR_FOCUS = '--product-home-color-focus';
var $4c4e598cd6612632$var$VAR_PRODUCT_HOME_BACKGROUND_COLOR_FOCUS = '--product-home-bg-color-focus';
var $4c4e598cd6612632$var$VAR_PRODUCT_HOME_BOX_SHADOW_FOCUS = '--product-home-box-shadow-focus';
var $4c4e598cd6612632$var$VAR_PRODUCT_HOME_COLOR_HOVER = '--product-home-color-hover';
var $4c4e598cd6612632$var$VAR_PRODUCT_HOME_BACKGROUND_COLOR_HOVER = '--product-home-bg-color-hover';
var $4c4e598cd6612632$var$VAR_PRODUCT_HOME_BOX_SHADOW_HOVER = '--product-home-box-shadow-hover';
var $4c4e598cd6612632$var$productHomeButtonStyles = (0, $2nBsU.css)((0, $d93598d00ce909df$export$2e2bcd8739ae039)((0, $d93598d00ce909df$export$2e2bcd8739ae039)({
    display: 'flex',
    padding: "var(--ds-space-050, 4px)",
    alignItems: 'center',
    background: 'none',
    border: 0,
    borderRadius: "var(--ds-radius-small, 3px)",
    color: 'inherit',
    cursor: 'pointer',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '&::-moz-focus-inner': {
        border: 0
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '&:first-of-type': {
        marginInlineStart: 0
    },
    '&:hover': {
        backgroundColor: "var(".concat($4c4e598cd6612632$var$VAR_PRODUCT_HOME_BACKGROUND_COLOR_HOVER, ")"),
        boxShadow: "var(".concat($4c4e598cd6612632$var$VAR_PRODUCT_HOME_BOX_SHADOW_HOVER, ")"),
        color: "var(".concat($4c4e598cd6612632$var$VAR_PRODUCT_HOME_COLOR_HOVER, ")")
    },
    '&:active': {
        backgroundColor: "var(".concat($4c4e598cd6612632$var$VAR_PRODUCT_HOME_BACKGROUND_COLOR_ACTIVE, ")"),
        boxShadow: "var(".concat($4c4e598cd6612632$var$VAR_PRODUCT_HOME_BOX_SHADOW_ACTIVE, ")"),
        color: "var(".concat($4c4e598cd6612632$var$VAR_PRODUCT_HOME_COLOR_ACTIVE, ")")
    },
    '&:focus-visible': {
        backgroundColor: "var(".concat($4c4e598cd6612632$var$VAR_PRODUCT_HOME_BACKGROUND_COLOR_FOCUS, ")"),
        color: "var(".concat($4c4e598cd6612632$var$VAR_PRODUCT_HOME_COLOR_FOCUS, ")"),
        outline: "var(--ds-border-width-focused, 2px)".concat(" solid ", "var(--ds-border-focused, #4688EC)")
    },
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    'div&': {
        pointerEvents: 'none'
    }
}, "@media (max-width: ".concat((0, $9e0b6f96d7dc4701$export$4033a111ca79977d) - 0.1, "px)"), {
    margin: "0 ".concat("var(--ds-space-100, 8px)")
}), "@media (min-width: ".concat((0, $9e0b6f96d7dc4701$export$4033a111ca79977d), "px)"), {
    margin: "0 ".concat("var(--ds-space-200, 16px)")
}));
var $4c4e598cd6612632$var$productLogoStyles = (0, $2nBsU.css)((0, $d93598d00ce909df$export$2e2bcd8739ae039)({
    // Ensure anything passed into
    // productHome is aligned correctly
    display: 'flex',
    maxWidth: "var(".concat($4c4e598cd6612632$var$VAR_LOGO_MAX_WIDTH, ")"),
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '& > *': {
        maxHeight: 24
    },
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '& > span > svg': {
        maxWidth: "var(".concat($4c4e598cd6612632$var$VAR_LOGO_MAX_WIDTH, ")")
    }
}, "@media (max-width: ".concat((0, $9e0b6f96d7dc4701$export$4033a111ca79977d) - 0.1, "px)"), {
    display: 'none'
}));
var $4c4e598cd6612632$var$customMaxHeightStyles = (0, $2nBsU.css)({
    maxHeight: 28
});
var $4c4e598cd6612632$var$productIconStyles = (0, $2nBsU.css)((0, $d93598d00ce909df$export$2e2bcd8739ae039)({
    // Ensure anything passed into
    // productHome is aligned correctly
    display: 'flex',
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '& > *': {
        maxHeight: 24
    }
}, "@media (min-width: ".concat((0, $9e0b6f96d7dc4701$export$4033a111ca79977d), "px)"), {
    display: 'none'
}));
var $4c4e598cd6612632$var$siteTitleStyles = (0, $2nBsU.css)({
    display: 'flex',
    alignItems: 'center',
    marginInlineEnd: "var(--ds-space-050, 4px)",
    marginInlineStart: "var(--ds-space-050, 4px)",
    paddingInlineEnd: "var(--ds-space-200, 16px)"
});
/**
 * __Product home__
 *
 * The ProductHome component displays the product visual identity composed of:
 * logo, icon, and optional text. Values for logo and icon are never displayed
 * at the same time, where icon is used only when space is restricted. Should be
 * passed into `AtlassianNavigation`'s `renderProductHome` prop.
 *
 * - [Examples](https://atlassian.design/components/atlassian-navigation/examples#product-home)
 * - [Code](https://atlassian.design/components/atlassian-navigation/code)
 *
 * @deprecated `@atlaskit/atlassian-navigation` is deprecated. Use `@atlaskit/navigation-system` instead.
 */ var $4c4e598cd6612632$var$ProductHome = function ProductHome(_ref) {
    var ariaLabel = _ref['aria-label'], href = _ref.href, Icon = _ref.icon, Logo = _ref.logo, _ref$logoMaxWidth = _ref.logoMaxWidth, logoMaxWidth = _ref$logoMaxWidth === void 0 ? 260 : _ref$logoMaxWidth, onClick = _ref.onClick, onMouseDown = _ref.onMouseDown, siteTitle = _ref.siteTitle, testId = _ref.testId, rest = (0, $1156f3ba78bc1e19$export$2e2bcd8739ae039)(_ref, $4c4e598cd6612632$var$_excluded);
    var theme = (0, $063f49374ce1ab43$export$93d4e7f90805808f)();
    var primaryButton = theme.mode.primaryButton;
    var _theme$mode$productHo = theme.mode.productHome, _theme$mode$productHo2 = _theme$mode$productHo.iconColor, iconColor = _theme$mode$productHo2 === void 0 ? undefined : _theme$mode$productHo2, _theme$mode$productHo3 = _theme$mode$productHo.textColor, textColor = _theme$mode$productHo3 === void 0 ? undefined : _theme$mode$productHo3;
    // If the theme returns the default Atlassian theme, rely on the Logo default behaviour instead
    if (iconColor === '#357DE8' && textColor === "var(--ds-text, #292A2E)") {
        iconColor = undefined;
        textColor = undefined;
    }
    var Tag = (0, $f4c563dd72a7132a$export$dad497fe1f6e27c0)(onClick, href);
    var preventFocusRing = function preventFocusRing(e) {
        e.preventDefault();
        onMouseDown && onMouseDown(e);
    };
    var productHomeButtonDynamicStyles = (0, $e7524659741051c8$export$e03bb5c7fd72635)((0, $d93598d00ce909df$export$2e2bcd8739ae039)((0, $d93598d00ce909df$export$2e2bcd8739ae039)((0, $d93598d00ce909df$export$2e2bcd8739ae039)((0, $d93598d00ce909df$export$2e2bcd8739ae039)((0, $d93598d00ce909df$export$2e2bcd8739ae039)((0, $d93598d00ce909df$export$2e2bcd8739ae039)((0, $d93598d00ce909df$export$2e2bcd8739ae039)((0, $d93598d00ce909df$export$2e2bcd8739ae039)((0, $d93598d00ce909df$export$2e2bcd8739ae039)((0, $d93598d00ce909df$export$2e2bcd8739ae039)({}, $4c4e598cd6612632$var$VAR_PRODUCT_HOME_COLOR_ACTIVE, primaryButton.active.color), $4c4e598cd6612632$var$VAR_PRODUCT_HOME_BACKGROUND_COLOR_ACTIVE, primaryButton.active.backgroundColor), $4c4e598cd6612632$var$VAR_PRODUCT_HOME_BOX_SHADOW_ACTIVE, primaryButton.active.boxShadow), $4c4e598cd6612632$var$VAR_PRODUCT_HOME_COLOR_FOCUS, primaryButton.focus.color), $4c4e598cd6612632$var$VAR_PRODUCT_HOME_BACKGROUND_COLOR_FOCUS, primaryButton.focus.backgroundColor), $4c4e598cd6612632$var$VAR_PRODUCT_HOME_BOX_SHADOW_FOCUS, primaryButton.focus.boxShadow), $4c4e598cd6612632$var$VAR_PRODUCT_HOME_COLOR_HOVER, primaryButton.hover.color), $4c4e598cd6612632$var$VAR_PRODUCT_HOME_BACKGROUND_COLOR_HOVER, primaryButton.hover.backgroundColor), $4c4e598cd6612632$var$VAR_PRODUCT_HOME_BOX_SHADOW_HOVER, primaryButton.hover.boxShadow), $4c4e598cd6612632$var$VAR_LOGO_MAX_WIDTH, "".concat(logoMaxWidth, "px")));
    return (0, $2nBsU.jsx)((0, $5FkrB.Fragment), null, (0, $2nBsU.jsx)(Tag, (0, $d029a6002153f8f3$export$2e2bcd8739ae039)({
        style: productHomeButtonDynamicStyles,
        css: $4c4e598cd6612632$var$productHomeButtonStyles,
        href: href,
        onClick: onClick,
        onMouseDown: preventFocusRing,
        "data-testid": testId && "".concat(testId, "-container"),
        "aria-label": ariaLabel
    }, rest), (0, $2nBsU.jsx)("div", {
        css: [
            $4c4e598cd6612632$var$customMaxHeightStyles,
            $4c4e598cd6612632$var$productLogoStyles
        ],
        "data-testid": testId && "".concat(testId, "-logo")
    }, (0, $2nBsU.jsx)(Logo, {
        iconColor: iconColor,
        textColor: textColor,
        appearance: iconColor || textColor ? undefined : 'brand'
    })), (0, $2nBsU.jsx)("div", {
        css: [
            $4c4e598cd6612632$var$customMaxHeightStyles,
            $4c4e598cd6612632$var$productIconStyles
        ],
        "data-testid": testId && "".concat(testId, "-icon")
    }, (0, $2nBsU.jsx)(Icon, {
        iconColor: iconColor,
        size: 'small',
        appearance: iconColor || textColor ? undefined : 'brand'
    }))), siteTitle && (0, $2nBsU.jsx)("div", {
        style: {
            borderRight: theme.mode.productHome.borderRight
        },
        css: $4c4e598cd6612632$var$siteTitleStyles,
        "data-testid": testId && "".concat(testId, "-site-title")
    }, siteTitle));
};
var $4c4e598cd6612632$export$2e2bcd8739ae039 = $4c4e598cd6612632$var$ProductHome;



var $5FkrB = parcelRequire("5FkrB");
function $7a5af01531a7e156$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return r;
}


function $bc38236095d00972$export$2e2bcd8739ae039(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}


function $3c0fe8c43494dc85$export$2e2bcd8739ae039(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}


function $2158c0a70df0913b$export$2e2bcd8739ae039(r, a) {
    if (r) {
        if ("string" == typeof r) return (0, $3c0fe8c43494dc85$export$2e2bcd8739ae039)(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? (0, $3c0fe8c43494dc85$export$2e2bcd8739ae039)(r, a) : void 0;
    }
}


function $75f8f75dc1e96176$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}


function $6c4e41adfd3b84fb$export$2e2bcd8739ae039(r, e) {
    return (0, $7a5af01531a7e156$export$2e2bcd8739ae039)(r) || (0, $bc38236095d00972$export$2e2bcd8739ae039)(r, e) || (0, $2158c0a70df0913b$export$2e2bcd8739ae039)(r, e) || (0, $75f8f75dc1e96176$export$2e2bcd8739ae039)();
}



var $5FkrB = parcelRequire("5FkrB");
function $e3613e1564721b55$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $e3613e1564721b55$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $e3613e1564721b55$export$2e2bcd8739ae039(o);
}



function $be9038348f25a041$export$2e2bcd8739ae039(t, r) {
    if ("object" != (0, $e3613e1564721b55$export$2e2bcd8739ae039)(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (0, $e3613e1564721b55$export$2e2bcd8739ae039)(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}


function $26b8904d967b1a34$export$2e2bcd8739ae039(t) {
    var i = (0, $be9038348f25a041$export$2e2bcd8739ae039)(t, "string");
    return "symbol" == (0, $e3613e1564721b55$export$2e2bcd8739ae039)(i) ? i : i + "";
}


function $3aa4c63f586043a7$export$2e2bcd8739ae039(e, r, t) {
    return (r = (0, $26b8904d967b1a34$export$2e2bcd8739ae039)(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}


var $7bd749b634282905$export$4ef52930e33717cd = 'data-theme';
var $7bd749b634282905$export$cb374d25ded7f6ab = 'data-subtree-theme';
var $7bd749b634282905$export$a00eac3f8684bcd0 = 'data-color-mode';
var $7bd749b634282905$export$2112803007239c61 = 'data-contrast-mode';
var $7bd749b634282905$export$352e418ed5b6193a = 'data-custom-theme';
var $7bd749b634282905$export$6f0c6fb8c80fcc92 = 'ds';
var $7bd749b634282905$export$4d0c7bbf80185957 = [
    'opacity',
    'font',
    'space',
    'border',
    'radius'
];
var $7bd749b634282905$export$dddac1532e822863 = "--".concat($7bd749b634282905$export$6f0c6fb8c80fcc92, "-token-not-found");
var $7bd749b634282905$export$9d7b58831ae93caa = "--".concat($7bd749b634282905$export$6f0c6fb8c80fcc92, "-elevation-surface-current");


/**
 * Theme modes: The general purpose of a theme.
 * This attr is used to apply the appropriate system-preference option
 * It may also be used as a selector for mode-specific overrides such as light/dark images.
 * The idea is there may exist many color themes, but every theme must either fit into light or dark.
 */ var $20181d6b959f2849$export$83993de8eb66733 = [
    'light',
    'dark',
    'auto'
];


var $d8e4beedf248c8b6$export$fcfb1976c88f9f75 = function isThemeColorMode(colorMode) {
    return (0, $20181d6b959f2849$export$83993de8eb66733).find(function(mode) {
        return mode === colorMode;
    }) !== undefined;
};



var $54904be5c47f9e25$export$4a14e169b1de4ee7 = function isColorMode(modeId) {
    return [
        'light',
        'dark',
        'auto'
    ].includes(modeId);
};


/**
 * Theme ids: The value that will be mounted to the DOM as a data attr
 * For example: `data-theme="light:light dark:dark spacing:spacing"
 *
 * These ids must be kebab case
 */ var $753d272bf154c489$export$7d43e72a58e3283f = [
    'light-increased-contrast',
    'light',
    'light-future',
    'dark',
    'dark-future',
    'dark-increased-contrast',
    'spacing',
    'shape',
    'typography',
    'motion'
];


var $d32052090c4f55ce$export$ea35b8958c39dd07 = function isThemeIds(themeId) {
    return (0, $753d272bf154c489$export$7d43e72a58e3283f).find(function(id) {
        return id === themeId;
    }) !== undefined;
};


var $c13572cdffd3965e$var$themeKinds = [
    'light',
    'dark',
    'spacing',
    'typography',
    'shape',
    'motion'
];
var $c13572cdffd3965e$export$958fa026be3a263e = function isThemeKind(themeKind) {
    return $c13572cdffd3965e$var$themeKinds.find(function(kind) {
        return kind === themeKind;
    }) !== undefined;
};


var $7ccd4dc160991d61$var$customThemeOptions = 'UNSAFE_themeOptions';
var $7ccd4dc160991d61$export$f19b488f7c0547ee = function themeStringToObject(themeState) {
    return themeState.split(' ').map(function(theme) {
        return theme.split(/:([^]*)/);
    }).reduce(function(themeObject, _ref) {
        var _ref2 = (0, $6c4e41adfd3b84fb$export$2e2bcd8739ae039)(_ref, 2), kind = _ref2[0], id = _ref2[1];
        if (kind === 'colorMode' && (0, $54904be5c47f9e25$export$4a14e169b1de4ee7)(id)) themeObject[kind] = id;
        if ((0, $c13572cdffd3965e$export$958fa026be3a263e)(kind) && (0, $d32052090c4f55ce$export$ea35b8958c39dd07)(id)) // @ts-expect-error FIXME - this is a valid ts error
        themeObject[kind] = id;
        if (kind === $7ccd4dc160991d61$var$customThemeOptions) try {
            themeObject[$7ccd4dc160991d61$var$customThemeOptions] = JSON.parse(id);
        } catch (_unused) {
            new Error('Invalid custom theme string');
        }
        return themeObject;
    }, {});
};


function $a8782ec33073b15d$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $a8782ec33073b15d$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $a8782ec33073b15d$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $3aa4c63f586043a7$export$2e2bcd8739ae039)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $a8782ec33073b15d$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $a8782ec33073b15d$export$813ecdf77207a053 = function getGlobalTheme() {
    if (typeof document === 'undefined') return {};
    var element = document.documentElement;
    var colorMode = element.getAttribute((0, $7bd749b634282905$export$a00eac3f8684bcd0)) || '';
    var theme = element.getAttribute((0, $7bd749b634282905$export$4ef52930e33717cd)) || '';
    return $a8782ec33073b15d$var$_objectSpread($a8782ec33073b15d$var$_objectSpread({}, (0, $7ccd4dc160991d61$export$f19b488f7c0547ee)(theme)), (0, $d8e4beedf248c8b6$export$fcfb1976c88f9f75)(colorMode) && {
        colorMode: colorMode
    });
};


function $ae8f6550fde7c524$export$2e2bcd8739ae039(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}



function $c8374a91b8550358$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, (0, $26b8904d967b1a34$export$2e2bcd8739ae039)(o.key), o);
    }
}
function $c8374a91b8550358$export$2e2bcd8739ae039(e, r, t) {
    return r && $c8374a91b8550358$var$_defineProperties(e.prototype, r), t && $c8374a91b8550358$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}





var $93bcdf5970b55ff7$export$b741a7c3bcb1c635 = /*#__PURE__*/ function() {
    function ThemeMutationObserver(callback) {
        (0, $ae8f6550fde7c524$export$2e2bcd8739ae039)(this, ThemeMutationObserver);
        (0, $3aa4c63f586043a7$export$2e2bcd8739ae039)(this, "legacyObserver", null);
        this.callback = callback;
        ThemeMutationObserver.callbacks.add(callback);
    }
    return (0, $c8374a91b8550358$export$2e2bcd8739ae039)(ThemeMutationObserver, [
        {
            key: "observe",
            value: function observe() {
                if (!ThemeMutationObserver.observer) {
                    ThemeMutationObserver.observer = new MutationObserver(function() {
                        var theme = (0, $a8782ec33073b15d$export$813ecdf77207a053)();
                        ThemeMutationObserver.callbacks.forEach(function(callback) {
                            return callback(theme);
                        });
                    });
                    // Observer only needs to be configured once
                    ThemeMutationObserver.observer.observe(document.documentElement, {
                        attributeFilter: [
                            (0, $7bd749b634282905$export$4ef52930e33717cd),
                            (0, $7bd749b634282905$export$a00eac3f8684bcd0)
                        ]
                    });
                }
            }
        },
        {
            key: "disconnect",
            value: function disconnect() {
                if (this.callback) ThemeMutationObserver.callbacks.delete(this.callback);
                if (ThemeMutationObserver.callbacks.size === 0 && ThemeMutationObserver.observer) {
                    ThemeMutationObserver.observer.disconnect();
                    ThemeMutationObserver.observer = null;
                }
            }
        }
    ]);
}();
(0, $3aa4c63f586043a7$export$2e2bcd8739ae039)($93bcdf5970b55ff7$export$b741a7c3bcb1c635, "observer", null);
(0, $3aa4c63f586043a7$export$2e2bcd8739ae039)($93bcdf5970b55ff7$export$b741a7c3bcb1c635, "callbacks", new Set());
var $93bcdf5970b55ff7$export$2e2bcd8739ae039 = $93bcdf5970b55ff7$export$b741a7c3bcb1c635;


var $b621ed2cc6a05fa8$export$3dd7971102e44fa8 = function useThemeObserver() {
    var _useState = (0, $5FkrB.useState)((0, $a8782ec33073b15d$export$813ecdf77207a053)()), _useState2 = (0, $6c4e41adfd3b84fb$export$2e2bcd8739ae039)(_useState, 2), theme = _useState2[0], setTheme = _useState2[1];
    (0, $5FkrB.useEffect)(function() {
        var observer = new (0, $93bcdf5970b55ff7$export$2e2bcd8739ae039)(function(theme) {
            return setTheme(theme);
        });
        observer.observe();
        return function() {
            return observer.disconnect();
        };
    }, []);
    return theme;
};
var $b621ed2cc6a05fa8$export$2e2bcd8739ae039 = $b621ed2cc6a05fa8$export$3dd7971102e44fa8;


/**
 * These are the default parameters for LogoProps if the user does not specify values.
 */ var $61c2bd5f28c47c3c$export$438460117ae6b7ee = {
    iconColor: 'inherit',
    label: '',
    size: 'medium',
    textColor: 'currentColor'
};
var $61c2bd5f28c47c3c$export$793fba32aed8942a = {
    iconGradientStart: 'inherit',
    iconGradientStop: 'inherit'
}; /**
 * The props for the <Wrapper /> that takes the svg and turns it into a component.
 */ 


/* wrapper.tsx generated by @compiled/babel-plugin v3.0.1 */ function $3305f3b7d3cad1d2$export$2e2bcd8739ae039() {
    return $3305f3b7d3cad1d2$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $3305f3b7d3cad1d2$export$2e2bcd8739ae039.apply(null, arguments);
}



function $ce7df1381311907a$export$2e2bcd8739ae039(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}


function $636d9018b4e7304e$export$2e2bcd8739ae039(e, t) {
    if (null == e) return {};
    var o, r, i = (0, $ce7df1381311907a$export$2e2bcd8739ae039)(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}



var $5FkrB = parcelRequire("5FkrB");
/**
 * The length of the value hash portion of an atomic class name.
 * Atomic class names have the format: `_<group><value>`
 * where group is ATOMIC_GROUP_HASH_LENGTH chars and value is ATOMIC_VALUE_HASH_LENGTH chars.
 *
 * We extract the group key using: `className.slice(0, className.length - ATOMIC_VALUE_HASH_LENGTH)`
 *
 * We support both old-format classes (9 chars: `_` + 4 group + 4 value) and
 * new-format classes (11 chars: `_` + 6 group + 4 value) by using length-based
 * extraction rather than a hardcoded offset — old and new format group keys
 * are different lengths so they are structurally disjoint and never alias each other.
 */ const $9e9cb70903cd7d9b$var$ATOMIC_VALUE_HASH_LENGTH = 4;
function $9e9cb70903cd7d9b$export$2e2bcd8739ae039(classNames) {
    // Shortcut: nothing to do
    if (!classNames.length) return;
    // Shortcut: don't need to do anything if we only have a single classname
    if (classNames.length === 1 && classNames[0] && // checking to see if `classNames[0]` is a string that contains other classnames
    !classNames[0].includes(' ')) return classNames[0];
    // Using an object rather than a `Map` as it performed better in our benchmarks.
    // Would be happy to move to `Map` if it proved to be better under real conditions.
    const map = {};
    // Note: using loops to minimize iterations over the collection
    for (const value of classNames){
        // Exclude all falsy values, which leaves us with populated strings
        if (!value) continue;
        // a `value` can contain multiple classnames
        const list = value.split(' ');
        for (const className of list){
            /**
             * For atomic style classnames: the `key` is the `group`
             *
             * - Later atomic classnames with the same `group` will override earlier ones
             *   (which is what we want).
             * - Assumes atomic classnames are the only things that start with `_`
             * - Could use a regex to ensure that atomic classnames are structured how we expect,
             *   but did not add that for now as it did slow things down a bit.
             *
             * For other classnames: the `key` is the whole classname
             * - Okay to remove duplicates as doing so does not impact specificity
             *
             * */ const key = className.startsWith('_') ? className.slice(0, className.length - $9e9cb70903cd7d9b$var$ATOMIC_VALUE_HASH_LENGTH) : className;
            map[key] = className;
        }
    }
    /**
     * We are converting the `map` into a string.
     *
     * The simple way to do this would be `Object.values(map).join(' ')`.
     * However, the approach below performs 10%-20% better in benchmarks.
     *
     * For `ax()` it feels right to squeeze as much runtime performance out as we can.
     */ let result = '';
    for(const key in map)result += map[key] + ' ';
    // If we have an empty string, then our `map` was empty.
    if (!result) return;
    // remove last " " from the result (we added " " at the end of every value)
    return result.trimEnd();
}


var $96958b5ae3603ec3$var$_excluded = [
    "label",
    "svg",
    "size",
    "appearance",
    "iconColor",
    "textColor",
    "testId"
];
var $96958b5ae3603ec3$var$CSS_VAR_COLOR = '--logo-color';
var $96958b5ae3603ec3$var$CSS_VAR_FILL = '--logo-fill';
var $96958b5ae3603ec3$var$styles = {
    root: "_1e0c1o8l _kqswh2mm _syaz1vry _lswu1xf6 _vwz4kb7n _uiztglyw _o5724jg8 _zbji1osq _3se11kw7",
    stop: "_vc881r31",
    xxsmall: "_4t3i7vkz",
    xsmall: "_4t3igktf",
    small: "_4t3i1tcg",
    medium: "_4t3izwfg",
    large: "_4t3i1ylp",
    xlarge: "_4t3ickbl"
};
/**
 * __Wrapper__
 *
 * An internal component used by `@atlaskit/logo` to render logo SVGs with correct styles.
 */ var $96958b5ae3603ec3$var$Wrapper = function Wrapper(_ref) {
    var label = _ref.label, svg = _ref.svg, size = _ref.size, appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor, userDefinedTestId = _ref.testId, rest = (0, $636d9018b4e7304e$export$2e2bcd8739ae039)(_ref, $96958b5ae3603ec3$var$_excluded);
    // Only required for old logos with gradients, which set gradient values to `inherit` when no appearance is provided
    var shouldApplyStopColor = appearance === undefined;
    var testId = userDefinedTestId && "".concat(userDefinedTestId, "--wrapper");
    return /*#__PURE__*/ $5FkrB.createElement("span", (0, $3305f3b7d3cad1d2$export$2e2bcd8739ae039)({
        "data-testid": testId,
        style: (0, $3aa4c63f586043a7$export$2e2bcd8739ae039)((0, $3aa4c63f586043a7$export$2e2bcd8739ae039)({}, $96958b5ae3603ec3$var$CSS_VAR_COLOR, iconColor), $96958b5ae3603ec3$var$CSS_VAR_FILL, textColor),
        "aria-label": label ? label : undefined,
        role: label ? 'img' : undefined,
        dangerouslySetInnerHTML: {
            __html: svg
        }
    }, rest, {
        className: (0, $9e9cb70903cd7d9b$export$2e2bcd8739ae039)([
            $96958b5ae3603ec3$var$styles.root,
            shouldApplyStopColor && $96958b5ae3603ec3$var$styles.stop,
            size && $96958b5ae3603ec3$var$styles[size]
        ])
    }));
};
var $96958b5ae3603ec3$export$2e2bcd8739ae039 = $96958b5ae3603ec3$var$Wrapper;


var $cc7f4c450b6535cc$export$bbacc3980e0f3029 = function getColorsFromAppearance(appearance, colorMode) {
    var iconColor, textColor, atlassianLogoTextColor;
    if (colorMode === 'dark') switch(appearance){
        case 'brand':
            iconColor = '#357DE8';
            textColor = '#E2E3E4';
            atlassianLogoTextColor = '#357DE8';
            break;
        case 'neutral':
            iconColor = '#96999E';
            textColor = '#BFC1C4';
            atlassianLogoTextColor = '#96999E';
            break;
        case 'inverse':
            iconColor = '#101214';
            textColor = '#101214';
            atlassianLogoTextColor = '#101214';
            break;
    }
    else switch(appearance){
        case 'brand':
            iconColor = '#1868DB';
            textColor = '#101214';
            atlassianLogoTextColor = '#1868DB';
            break;
        case 'neutral':
            iconColor = '#6C6F77';
            textColor = '#3B3D42';
            atlassianLogoTextColor = '#6C6F77';
            break;
        case 'inverse':
            iconColor = '#FFFFFF';
            textColor = '#FFFFFF';
            atlassianLogoTextColor = '#FFFFFF';
            break;
    }
    return {
        iconColor: iconColor,
        textColor: textColor,
        atlassianLogoTextColor: atlassianLogoTextColor
    };
};


var $47d58fd2ef4b1aac$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor;
    var colors = {
        iconColor: iconColor,
        textColor: textColor,
        // We treat the word "Atlassian" differently to normal app logos, it has a bold brand look
        atlassianLogoTextColor: textColor
    };
    if (appearance) colors = (0, $cc7f4c450b6535cc$export$bbacc3980e0f3029)(appearance, colorMode);
    return "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 198 32\" focusable=\"false\" aria-hidden=\"true\" height=\"32\" fill=\"none\">\n      <path fill=".concat(colors.iconColor, " d=\"M22.878 24.378 12.293 3.208c-.208-.458-.416-.541-.666-.541-.209 0-.459.083-.709.5-1.5 2.375-2.167 5.125-2.167 8 0 4.001 2.042 7.752 5.043 13.794.333.667.583.792 1.166.792h7.335c.542 0 .833-.208.833-.625 0-.208-.041-.333-.25-.75M7.501 14.377c-.833-1.25-1.083-1.334-1.292-1.334s-.333.083-.708.834L.208 24.46c-.166.334-.208.459-.208.625 0 .334.292.667.917.667h7.46c.5 0 .874-.416 1.083-1.208.25-1 .333-1.876.333-2.917 0-2.917-1.292-5.751-2.292-7.251z\"/>\n      <path fill=").concat(colors.atlassianLogoTextColor, " d=\"M107.447 10.828c0 2.972 1.345 5.308 6.795 6.37 3.185.707 3.893 1.203 3.893 2.265 0 1.061-.708 1.698-2.973 1.698-2.619 0-5.733-.92-7.785-2.123v4.813c1.627.778 3.751 1.698 7.785 1.698 5.662 0 7.856-2.548 7.856-6.228m0 .07c0-3.538-1.84-5.166-7.148-6.298-2.902-.637-3.61-1.274-3.61-2.194 0-1.133 1.062-1.628 2.973-1.628 2.335 0 4.6.708 6.794 1.698v-4.6c-1.557-.779-3.892-1.345-6.653-1.345-5.237 0-7.927 2.265-7.927 5.945m72.475-5.803v20.17h4.318V9.979l1.769 4.035 6.087 11.324h5.379V5.166h-4.247v13.022l-1.628-3.821-4.883-9.201zm-27.319 0h-4.671v20.17h4.671zm-10.05 14.154c0-3.538-1.841-5.166-7.149-6.298-2.902-.637-3.609-1.274-3.609-2.194 0-1.133 1.061-1.628 2.972-1.628 2.336 0 4.601.708 6.795 1.699v-4.6c-1.557-.78-3.893-1.346-6.653-1.346-5.238 0-7.927 2.265-7.927 5.946 0 2.972 1.344 5.308 6.794 6.37 3.185.707 3.893 1.203 3.893 2.264 0 1.062-.708 1.699-2.973 1.699-2.618 0-5.733-.92-7.785-2.123v4.812c1.628.779 3.751 1.699 7.785 1.699 5.592 0 7.857-2.548 7.857-6.3M71.069 5.166v20.17h9.625l1.486-4.387h-6.44V5.166zm-19.039 0v4.317h5.167v15.854h4.741V9.483h5.592V5.166zm-6.866 0h-6.157L32 25.336h5.379l.99-3.396c1.204.353 2.478.566 3.752.566s2.548-.213 3.751-.567l.991 3.398h5.379c-.07 0-7.078-20.171-7.078-20.171M42.05 18.259c-.92 0-1.77-.141-2.548-.354L42.05 9.13l2.548 8.776a9.6 9.6 0 0 1-2.548.354zM97.326 5.166H91.17l-7.078 20.17h5.38l.99-3.396c1.203.353 2.477.566 3.751.566s2.548-.213 3.751-.567l.991 3.398h5.379zm-3.114 13.093c-.92 0-1.77-.141-2.548-.354l2.548-8.776 2.548 8.776a9.6 9.6 0 0 1-2.548.354m75.306-13.093h-6.157l-7.007 20.17h5.379l.991-3.396c1.203.353 2.477.566 3.751.566s2.548-.213 3.751-.567l.991 3.398h5.379zm-3.043 13.093c-.92 0-1.77-.141-2.548-.354l2.548-8.776 2.548 8.776a10 10 0 0 1-2.548.354\"/>\n    </svg>");
};
var $47d58fd2ef4b1aac$export$765cacec8b0843f3 = function AtlassianLogo(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Atlassian' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $61c2bd5f28c47c3c$export$438460117ae6b7ee).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $61c2bd5f28c47c3c$export$438460117ae6b7ee).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $61c2bd5f28c47c3c$export$438460117ae6b7ee).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $b621ed2cc6a05fa8$export$3dd7971102e44fa8)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $96958b5ae3603ec3$export$2e2bcd8739ae039), {
        appearance: appearance,
        label: label,
        svg: $47d58fd2ef4b1aac$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        iconColor: iconColor,
        size: size,
        testId: testId,
        textColor: textColor
    });
};


const $9f1ff57ff81007c4$var$BlueAtlassianLogo = ()=>{
    return /*#__PURE__*/ (0, $i3UfC.jsx)((0, $47d58fd2ef4b1aac$export$765cacec8b0843f3), {
        appearance: "brand"
    });
};
const $9f1ff57ff81007c4$var$NavLogo = ()=>{
    return /*#__PURE__*/ (0, $i3UfC.jsx)((0, $4c4e598cd6612632$export$2e2bcd8739ae039), {
        icon: $9f1ff57ff81007c4$var$BlueAtlassianLogo,
        logo: $9f1ff57ff81007c4$var$BlueAtlassianLogo
    });
};
var $9f1ff57ff81007c4$export$2e2bcd8739ae039 = $9f1ff57ff81007c4$var$NavLogo;



var $i3UfC = parcelRequire("i3UfC");

/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3ee8292a79b161f2b692708d346bda7d>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");
/* icon-wrapper.tsx generated by @compiled/babel-plugin v3.0.1 */ 
var $5FkrB = parcelRequire("5FkrB");


var $50U6m = parcelRequire("50U6m");

var $9b5b994dd561b600$var$styles = {
    root: "_1e0c1o8l",
    TEMP_assets: "_9aea1fkg"
};
/* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ var $9b5b994dd561b600$var$cloudLightAppearanceMap = {
    brand: "_1b3i18uv _9aea18uv",
    neutral: "_1b3i1e01 _9aea1fkg",
    inverse: "_1b3i5a6q _9aeau67f",
    legacy: "_1b3iu67f _9aeadoyu"
};
/* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ var $9b5b994dd561b600$var$cloudDarkAppearanceMap = {
    brand: "_1b3i18uv _9aea18uv",
    neutral: "_1b3i1gvk _9aea8hz0",
    inverse: "_1b3iu67f _9aea5a6q",
    legacy: "_1b3iu67f _9aeadoyu"
};
/* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ var $9b5b994dd561b600$var$dataCenterLightAppearanceMap = {
    brand: "_1b3idoyu _9aeau67f _3wu01fkg",
    neutral: "_1b3i1e01 _9aea1fkg _3wu01e01",
    inverse: "_1b3iu67f _9aeaqlpt _3wu0u67f",
    legacy: "_1b3idoyu _9aeau67f _3wu01fkg"
};
/* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ var $9b5b994dd561b600$var$dataCenterDarkAppearanceMap = {
    brand: "_1b3idoyu _9aeaqlpt _3wu08hz0",
    neutral: "_1b3i1gvk _9aea8hz0 _3wu01gvk",
    inverse: "_1b3i1501 _9aeau67f _3wu01501",
    legacy: "_1b3idoyu _9aeaqlpt _3wu08hz0"
};
var $9b5b994dd561b600$var$rovoDarkAppearanceMap = {
    brand: "_170318uv _1evo18uv _epb518uv _1osd18uv",
    neutral: "_17031gvk _1evo1gvk _epb51gvk _1osd1gvk",
    inverse: "_1703qlpt _1evoqlpt _epb5qlpt _1osdqlpt",
    legacy: "_1703doyu _1evodoyu _epb5doyu _1osddoyu"
};
var $9b5b994dd561b600$var$rovoLightAppearanceMap = {
    brand: "_170318uv _1evo18uv _epb518uv _1osd18uv",
    neutral: "_17031e01 _1evo1e01 _epb51e01 _1osd1e01",
    inverse: "_1703u67f _1evou67f _epb5u67f _1osdu67f",
    legacy: "_1703doyu _1evodoyu _epb5doyu _1osddoyu"
};
/* eslint-enable @atlaskit/ui-styling-standard/no-imported-style-values */ /* eslint-enable @atlaskit/ui-styling-standard/no-unsafe-values */ var $9b5b994dd561b600$var$sizeMap = {
    xxsmall: "_4t3i7vkz",
    xsmall: "_4t3igktf",
    small: "_4t3i1tcg",
    medium: "_4t3izwfg",
    large: "_4t3i1ylp",
    xlarge: "_4t3ickbl",
    '12': "_4t3i1crf",
    '16': "_4t3i7vkz",
    '20': "_4t3igktf",
    '24': "_4t3i1tcg",
    '32': "_4t3izwfg"
};
function $9b5b994dd561b600$export$be58b4326e23250f(_ref) {
    var _ref$size = _ref.size, size = _ref$size === void 0 ? '20' : _ref$size, label = _ref.label, svg = _ref.svg, customThemeSvg = _ref.customThemeSvg, userDefinedTestId = _ref.testId, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, customIconColor = _ref.iconColor, _ref$isAssets = _ref.isAssets, isAssets = _ref$isAssets === void 0 ? false : _ref$isAssets, _ref$type = _ref.type, type = _ref$type === void 0 ? 'tile' : _ref$type;
    var testId = userDefinedTestId && "".concat(userDefinedTestId, "--wrapper");
    var isCustomThemed = customThemeSvg && customIconColor;
    var _useThemeObserver = (0, $b621ed2cc6a05fa8$export$3dd7971102e44fa8)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ $5FkrB.createElement("span", {
        "data-testid": testId,
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            '--themed-icon-color': customIconColor || 'initial'
        },
        "aria-label": label ? label : undefined,
        role: label ? 'img' : undefined,
        "aria-hidden": label === '' ? true : undefined,
        dangerouslySetInnerHTML: {
            __html: isCustomThemed ? customThemeSvg : svg
        },
        className: (0, $9e9cb70903cd7d9b$export$2e2bcd8739ae039)([
            $9b5b994dd561b600$var$styles.root,
            $9b5b994dd561b600$var$sizeMap[size],
            colorMode === 'dark' ? $9b5b994dd561b600$var$dataCenterDarkAppearanceMap[appearance] : $9b5b994dd561b600$var$dataCenterLightAppearanceMap[appearance],
            type === 'rovo' ? colorMode === 'dark' ? $9b5b994dd561b600$var$rovoDarkAppearanceMap[appearance] : $9b5b994dd561b600$var$rovoLightAppearanceMap[appearance] : colorMode === 'dark' ? $9b5b994dd561b600$var$cloudDarkAppearanceMap[appearance] : $9b5b994dd561b600$var$cloudLightAppearanceMap[appearance],
            isAssets && appearance === 'brand' && ((0, $50U6m.fg)('assets-platform-branding') || (0, $50U6m.fg)('assets-platform-branding-v2')) && $9b5b994dd561b600$var$styles.TEMP_assets
        ])
    });
}


// `height` is set to 100% to allow the SVG to scale with the parent element
var $fdd60fb407482c20$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, #101214)\" fill-rule=\"evenodd\" d=\"M10.444 5h3.111l.98 2.61 2.75-.457 1.555 2.694L17.07 12l1.77 2.153-1.555 2.694-2.75-.457-.979 2.61h-3.11l-.98-2.61-2.75.457-1.555-2.694L6.931 12 5.16 9.847l1.555-2.694 2.75.457zM12 14.625a2.625 2.625 0 1 0 0-5.25 2.625 2.625 0 0 0 0 5.25\" clip-rule=\"evenodd\"/>\n</svg>\n";
function $fdd60fb407482c20$export$ef8e5f836dd989d3(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Admin' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $9b5b994dd561b600$export$be58b4326e23250f), {
        svg: $fdd60fb407482c20$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::cb1b5c1084ec5af5d6446030d431f52c>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");
/* logo-wrapper.tsx generated by @compiled/babel-plugin v3.0.1 */ /* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ 
var $5FkrB = parcelRequire("5FkrB");


var $50U6m = parcelRequire("50U6m");

var $9b7a1b046861a04a$var$styles = {
    root: "_1e0c1o8l _vwz4idpf",
    TEMP_assets: "_9aea1fkg"
};
// These styles set the `color` property so that the child SVG can inherit the correct text color using "currentColor"
var $9b7a1b046861a04a$var$logoTextColorMap = {
    light: "_syazqlpt",
    dark: "_syazz6c6"
};
var $9b7a1b046861a04a$var$sizeMap = {
    xxsmall: "_4t3i7vkz",
    xsmall: "_4t3igktf",
    small: "_4t3i1tcg",
    medium: "_4t3izwfg",
    large: "_4t3i1ylp",
    xlarge: "_4t3ickbl"
};
/* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ var $9b7a1b046861a04a$var$textLightAppearanceMap = {
    brand: "_1wyci7uo",
    neutral: "_1wyc1e01",
    inverse: "_1wycu67f",
    legacy: "_1wycu67f"
};
/* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ var $9b7a1b046861a04a$var$textDarkAppearanceMap = {
    brand: "_1wyci7uo",
    neutral: "_1wyc1gvk",
    inverse: "_1wyc5a6q",
    legacy: "_1wycu67f"
};
/* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ var $9b7a1b046861a04a$var$cloudLightAppearanceMap = {
    brand: "_1b3i18uv _9aea18uv",
    neutral: "_1b3i1e01 _9aea1fkg",
    inverse: "_1b3i5a6q _9aeau67f",
    legacy: "_1b3iu67f _9aeadoyu"
};
/* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ var $9b7a1b046861a04a$var$cloudDarkAppearanceMap = {
    brand: "_1b3i18uv _9aea18uv",
    neutral: "_1b3i1gvk _9aea8hz0",
    inverse: "_1b3iu67f _9aea5a6q",
    legacy: "_1b3iu67f _9aeadoyu"
};
/* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ var $9b7a1b046861a04a$var$dataCenterLightAppearanceMap = {
    brand: "_1b3idoyu _9aeau67f _3wu01fkg",
    neutral: "_1b3i1e01 _9aea1fkg _3wu01e01",
    inverse: "_1b3iu67f _9aeaqlpt _3wu0u67f",
    legacy: "_1b3idoyu _9aeau67f _3wu01fkg"
};
/* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ var $9b7a1b046861a04a$var$dataCenterDarkAppearanceMap = {
    brand: "_1b3idoyu _9aeaqlpt _3wu08hz0",
    neutral: "_1b3i1gvk _9aea8hz0 _3wu01gvk",
    inverse: "_1b3i1501 _9aeau67f _3wu01501",
    legacy: "_1b3idoyu _9aeaqlpt _3wu08hz0"
};
var $9b7a1b046861a04a$var$rovoDarkAppearanceMap = {
    brand: "_1703lrxy _1evoh727 _epb51yy8 _1osdxeun",
    neutral: "_17031gvk _1evo1gvk _epb51gvk _1osd1gvk",
    inverse: "_1703qlpt _1evoqlpt _epb5qlpt _1osdqlpt",
    legacy: "_1703doyu _1evodoyu _epb5doyu _1osddoyu"
};
var $9b7a1b046861a04a$var$rovoLightAppearanceMap = {
    brand: "_170318uv _1evo18uv _epb518uv _1osd18uv",
    neutral: "_17031e01 _1evo1e01 _epb51e01 _1osd1e01",
    inverse: "_1703u67f _1evou67f _epb5u67f _1osdu67f",
    legacy: "_1703doyu _1evodoyu _epb5doyu _1osddoyu"
};
function $9b7a1b046861a04a$export$f827d3c5a9c3f644(_ref) {
    var _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$size = _ref.size, size = _ref$size === void 0 ? 'small' : _ref$size, svg = _ref.svg, customThemeSvg = _ref.customThemeSvg, label = _ref.label, userDefinedTestId = _ref.testId, customIconColor = _ref.iconColor, customTextColor = _ref.textColor, _ref$isAssets = _ref.isAssets, isAssets = _ref$isAssets === void 0 ? false : _ref$isAssets, _ref$type = _ref.type, type = _ref$type === void 0 ? 'tile' : _ref$type;
    var _useThemeObserver = (0, $b621ed2cc6a05fa8$export$3dd7971102e44fa8)(), colorMode = _useThemeObserver.colorMode;
    var testId = userDefinedTestId && "".concat(userDefinedTestId, "--wrapper");
    var isCustomThemed = customThemeSvg && (customIconColor || customTextColor);
    return /*#__PURE__*/ $5FkrB.createElement("span", {
        style: {
            // Nav v3 passes in "inherit" incorrectly for iconColor, so we fall back to textColor when this happens.
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            '--themed-icon-color': customIconColor === 'inherit' ? customTextColor : customIconColor,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            '--themed-text-color': customTextColor || 'inherit'
        },
        "data-testid": testId,
        "aria-label": label ? label : undefined,
        role: label ? 'img' : undefined,
        "aria-hidden": label === '' ? true : undefined,
        dangerouslySetInnerHTML: {
            __html: isCustomThemed ? customThemeSvg : svg
        },
        className: (0, $9e9cb70903cd7d9b$export$2e2bcd8739ae039)([
            $9b7a1b046861a04a$var$styles.root,
            // Setting the color so that the SVG can inherit the correct text color using "currentColor"
            $9b7a1b046861a04a$var$logoTextColorMap[colorMode !== null && colorMode !== void 0 ? colorMode : 'light'],
            $9b7a1b046861a04a$var$sizeMap[size],
            colorMode === 'dark' ? $9b7a1b046861a04a$var$textDarkAppearanceMap[appearance] : $9b7a1b046861a04a$var$textLightAppearanceMap[appearance],
            colorMode === 'dark' ? $9b7a1b046861a04a$var$dataCenterDarkAppearanceMap[appearance] : $9b7a1b046861a04a$var$dataCenterLightAppearanceMap[appearance],
            type === 'rovo' ? colorMode === 'dark' ? $9b7a1b046861a04a$var$rovoDarkAppearanceMap[appearance] : $9b7a1b046861a04a$var$rovoLightAppearanceMap[appearance] : colorMode === 'dark' ? $9b7a1b046861a04a$var$cloudDarkAppearanceMap[appearance] : $9b7a1b046861a04a$var$cloudLightAppearanceMap[appearance],
            isAssets && appearance === 'brand' && ((0, $50U6m.fg)('assets-platform-branding') || (0, $50U6m.fg)('assets-platform-branding-v2')) && $9b7a1b046861a04a$var$styles.TEMP_assets
        ])
    });
}


// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $82e1f1c7094b4744$var$svg = "<svg height=\"100%\" viewBox=\"0 0 126 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M124.84 16.35v8.99h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.51c.98-1.81 2.79-2.82 4.85-2.82 3.53 0 5.55 2.42 5.55 6.66m-20.15-10.4c0-1.17.77-1.84 1.84-1.84s1.84.67 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zm-14.07-8.52v8.53h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.51c.98-1.81 2.79-2.82 4.85-2.82 2.61 0 4.39 1.32 5.15 3.74.86-2.36 2.91-3.74 5.46-3.74 3.44 0 5.34 2.33 5.34 6.66v8.99h-2.64v-8.52c0-3.16-1.1-4.72-3.62-4.72-2.45 0-4.14 1.63-4.14 4.72m-28.32.85c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V3.59h2.64v21.74zm-22.02-4.01c-1.53 0-3.1-.18-4.81-.52l-1.69 4.54h-3.1l7.94-20.15h3.5l7.94 20.15h-3.1l-1.69-4.57c-1.81.37-3.37.55-5 .55m0-2.45c1.29 0 2.61-.15 4.17-.4L49.53 7.43 45.45 18.5c1.5.25 2.76.37 3.99.37\"/>\n    <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, #101214)\" fill-rule=\"evenodd\" d=\"M13.826 6.4h4.255l1.338 3.569 3.76-.626 2.128 3.684-2.422 2.945 2.421 2.943L23.18 22.6l-3.76-.626-1.338 3.57h-4.255l-1.338-3.57-3.76.625L6.6 18.915l2.421-2.943L6.6 13.028l2.127-3.685 3.76.626zm2.128 13.16a3.59 3.59 0 1 0 0-7.178 3.59 3.59 0 0 0 0 7.179\" clip-rule=\"evenodd\"/>\n</svg>\n";
function $82e1f1c7094b4744$export$61afcb38c001e19(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Admin' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $9b7a1b046861a04a$export$f827d3c5a9c3f644), {
        svg: $82e1f1c7094b4744$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d8dc880eda57906914bb7837c5a5c673>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
var $d7c936ff53cc5c33$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#fb9700)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M18.545 18.545a4.49 4.49 0 0 0-4.48-4.48h-4.13v-3.78h-4.48v7.434c0 .576.25.826.826.826zM5.455 5.455a4.454 4.454 0 0 0 4.455 4.48h4.155v3.78h4.48V6.28q0-.825-.826-.826z\"/>\n</svg>\n";
function $d7c936ff53cc5c33$export$70a0c2f5862937b6(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Align' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $9b5b994dd561b600$export$be58b4326e23250f), {
        svg: $d7c936ff53cc5c33$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b50cb2ad76b4dba28f22d4bb555219f7>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $e8c987d7492ee286$var$svg = "<svg height=\"100%\" viewBox=\"0 0 106 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M105.76 16.35v8.99h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.63V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 3.53 0 5.55 2.42 5.55 6.66m-19.6 7.75v-1.53c-.98 2.02-2.82 3.07-5.18 3.07-4.05 0-6.07-3.46-6.07-7.97 0-4.32 2.12-7.97 6.38-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.58v13.95c0 4.51-2.12 7.54-7.61 7.54-2.58 0-3.99-.34-5.46-.83v-2.58c1.69.55 3.43.92 5.34.92 3.83 0 5.15-2.05 5.15-4.91m-8.68-6.44c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52M68.73 5.95c0-1.17.77-1.84 1.84-1.84s1.84.67 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zm-2.54-.03c-.21.06-.67.12-1.35.12-2.51 0-4.11-1.19-4.11-4.02V3.59h2.64V21.1c0 1.38.92 1.87 2.06 1.87.28 0 .46 0 .77-.03zM49.6 21.32c-1.53 0-3.1-.18-4.82-.52l-1.69 4.54H40l7.94-20.15h3.5l7.94 20.15h-3.1l-1.69-4.57c-1.81.37-3.37.55-5 .55m0-2.45c1.29 0 2.61-.15 4.17-.4L49.68 7.43 45.6 18.5c1.5.25 2.76.37 3.99.37\"/>\n    <path fill=\"var(--tile-color,#fb9700)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M23.735 23.735c0-2.928-2.396-5.295-5.295-5.295h-4.88v-4.466H8.265v8.785c0 .68.296.976.976.976zM8.265 8.265c0 2.928 2.337 5.295 5.265 5.295h4.91v4.466h5.295V9.241q0-.976-.976-.976z\"/>\n</svg>\n";
function $e8c987d7492ee286$export$8b5103382c06639c(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Align' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $9b7a1b046861a04a$export$f827d3c5a9c3f644), {
        svg: $e8c987d7492ee286$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::93b4dea5ca940a35aa6da4a3e32efaba>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
var $e1043fa2303698cc$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M14.63 5.88v9.19h3.06v-9.2zM5.88 18.13h11.81v-1.75H5.87zm0-3.07v-4.81h3.06v4.81zm4.37-6.56v6.56h3.06V8.5z\"/>\n</svg>\n";
function $e1043fa2303698cc$export$af3460f51ce3602a(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Analytics' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $9b5b994dd561b600$export$be58b4326e23250f), {
        svg: $e1043fa2303698cc$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::19cf5335c393da35608b01fe889f5c46>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $0be36fd552dc1c99$var$svg = "<svg height=\"100%\" viewBox=\"0 0 161 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M160.66 21.16c0 2.55-1.66 4.48-5.76 4.48-2.3 0-4.17-.52-5.34-1.13v-2.79c1.32.77 3.53 1.5 5.46 1.5 2.02 0 3.07-.83 3.07-2.02 0-1.17-.89-1.84-3.8-2.55-3.4-.83-4.85-2.15-4.85-4.66 0-2.67 2.06-4.29 5.55-4.29 1.99 0 3.8.49 4.94 1.1v2.73c-1.84-.92-3.34-1.41-4.97-1.41-1.93 0-2.97.67-2.97 1.87 0 1.07.74 1.75 3.56 2.42 3.4.83 5.12 2.09 5.12 4.75m-13.6 1.41v2.36c-.92.49-2.33.71-3.74.71-5.46 0-8-3.31-8-8 0-4.63 2.55-7.94 8-7.94 1.38 0 2.45.18 3.65.74v2.45c-.98-.46-2.02-.74-3.47-.74-3.99 0-5.61 2.52-5.61 5.49s1.66 5.49 5.67 5.49c1.56 0 2.55-.21 3.5-.55M129.13 5.95c0-1.16.77-1.84 1.84-1.84s1.84.68 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zm-7.46-4.75c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55c-.46.12-.98.25-1.78.25-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zm-14.12 3.77h-1.72L100.77 10h2.82l4.91 13.13L113.41 10h2.82l-5.8 14.84c-1.72 4.39-2.7 6.66-6.59 6.66-1.32 0-2.05-.12-2.82-.43V28.8c.89.28 1.9.37 2.67.37 2.15 0 3.1-1.47 4.36-4.81m-7.8.94c-.21.06-.67.12-1.35.12-2.51 0-4.11-1.19-4.11-4.02V3.59h2.64V21.1c0 1.38.92 1.87 2.06 1.87.28 0 .46 0 .77-.03zM79.5 17.67c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.47-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zM74.1 16.35v8.99h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.63V10h2.64v2.51c.98-1.81 2.79-2.82 4.85-2.82 3.53 0 5.55 2.42 5.55 6.66m-24.66 4.97c-1.53 0-3.1-.18-4.81-.52l-1.69 4.54h-3.1l7.94-20.15h3.5l7.94 20.15h-3.1l-1.69-4.57c-1.81.37-3.37.55-5 .55m0-2.45c1.29 0 2.61-.15 4.17-.4L49.53 7.43 45.45 18.5c1.5.25 2.76.37 3.99.37\"/>\n    <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M19.5 7.83v12.25h4.08V7.83zM7.83 24.17h15.75v-2.33H7.83zm0-4.09v-6.42h4.08v6.42zm5.84-8.75v8.75h4.08v-8.75z\"/>\n</svg>\n";
function $0be36fd552dc1c99$export$f0bac2b7ac3e3504(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Analytics' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $9b7a1b046861a04a$export$f827d3c5a9c3f644), {
        svg: $0be36fd552dc1c99$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::70585722d0ca9257d878eccc1885f195>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
var $07c282adbd4b5243$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#ffc716)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, #101214)\" fill-rule=\"evenodd\" d=\"M8.34 11.495a3.64 3.64 0 0 0 3.155-3.154h2.3V6.523h-2.537a3.638 3.638 0 1 0-4.735 4.735v2.538H8.34zM7.887 9.25a1.364 1.364 0 1 0 0-2.727 1.364 1.364 0 0 0 0 2.727\" clip-rule=\"evenodd\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M19.25 7.43a2.27 2.27 0 1 1-4.54 0 2.27 2.27 0 0 1 4.55 0M7.43 19.25a2.27 2.27 0 1 0 0-4.54 2.27 2.27 0 0 0 0 4.55m9.55-.01a2.27 2.27 0 1 0 0-4.54 2.27 2.27 0 0 0 0 4.55m-3.18-3.19h-3.18v1.82h3.18zm2.27-5.46v3.18h1.82v-3.18z\"/>\n</svg>\n";
var $07c282adbd4b5243$var$customThemeSvg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--themed-icon-color, currentcolor)\" d=\"M18 0a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6V6a6 6 0 0 1 6-6zM7.432 14.704a2.273 2.273 0 1 0 .001 4.547 2.273 2.273 0 0 0-.001-4.547m9.545 0a2.274 2.274 0 1 0 .001 4.548 2.274 2.274 0 0 0 0-4.548m-6.364 1.364v1.819h3.183v-1.819zM7.887 4.25a3.637 3.637 0 0 0-1.365 7.009v2.537h1.819v-2.302a3.64 3.64 0 0 0 3.153-3.153h2.302V6.522h-2.537A3.64 3.64 0 0 0 7.887 4.25m8.181 6.363v3.183h1.819v-3.183zm.91-5.454a2.273 2.273 0 1 0 0 4.547 2.273 2.273 0 0 0 0-4.547M7.887 6.522a1.364 1.364 0 1 1-.002 2.729 1.364 1.364 0 0 1 .002-2.729\"/>\n</svg>\n";
function $07c282adbd4b5243$export$d89497e7f33ca6f5(_ref) {
    var iconColor = _ref.iconColor, size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Assets' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $9b5b994dd561b600$export$be58b4326e23250f), {
        svg: $07c282adbd4b5243$var$svg,
        customThemeSvg: $07c282adbd4b5243$var$customThemeSvg,
        iconColor: iconColor,
        label: label,
        isAssets: true,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e69fa4e6ed45c9755193e19593b57593>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $67e6f3ace9444edb$var$svg = "<svg height=\"100%\" viewBox=\"0 0 126 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M125.8 21.16c0 2.55-1.66 4.48-5.76 4.48-2.3 0-4.17-.52-5.34-1.13v-2.79c1.32.77 3.53 1.5 5.46 1.5 2.02 0 3.07-.83 3.07-2.02 0-1.16-.89-1.84-3.8-2.54-3.4-.83-4.84-2.15-4.84-4.66 0-2.67 2.06-4.29 5.55-4.29 1.99 0 3.8.49 4.94 1.1v2.73c-1.84-.92-3.34-1.41-4.97-1.41-1.93 0-2.97.67-2.97 1.87 0 1.07.74 1.75 3.56 2.42 3.4.83 5.12 2.09 5.12 4.75m-17.77-.59c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55c-.46.12-.98.25-1.78.25-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zm-13.53-8.5c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.2c.37 2.61 2.05 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-15.13-3.56c0 2.55-1.66 4.48-5.77 4.48-2.3 0-4.17-.52-5.34-1.13v-2.79c1.32.77 3.53 1.5 5.46 1.5 2.02 0 3.07-.83 3.07-2.02 0-1.16-.89-1.84-3.8-2.54-3.4-.83-4.85-2.15-4.85-4.66 0-2.67 2.06-4.29 5.55-4.29 1.99 0 3.8.49 4.94 1.1v2.73c-1.84-.92-3.34-1.41-4.97-1.41-1.93 0-2.97.67-2.97 1.87 0 1.07.74 1.75 3.56 2.42 3.4.83 5.12 2.09 5.12 4.75m-13.63-.01c0 2.55-1.66 4.48-5.76 4.48-2.3 0-4.17-.52-5.34-1.13v-2.79c1.32.77 3.53 1.5 5.46 1.5 2.02 0 3.07-.83 3.07-2.02 0-1.16-.89-1.84-3.8-2.54-3.4-.83-4.84-2.15-4.84-4.66 0-2.67 2.06-4.29 5.55-4.29 1.99 0 3.8.49 4.94 1.1v2.73c-1.84-.92-3.34-1.41-4.97-1.41-1.93 0-2.97.67-2.97 1.87 0 1.07.74 1.75 3.56 2.42 3.4.83 5.12 2.09 5.12 4.75m-22.22.15c-1.53 0-3.1-.18-4.81-.52l-1.69 4.54h-3.1l7.94-20.15h3.5l7.94 20.15h-3.1l-1.69-4.57c-1.81.37-3.37.55-5 .55m0-2.45c1.29 0 2.61-.15 4.17-.4L49.53 7.43 45.45 18.5c1.5.25 2.76.37 3.99.37\"/>\n    <path fill=\"var(--tile-color,#ffc716)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, #101214)\" fill-rule=\"evenodd\" d=\"M11.667 15.425a4.335 4.335 0 0 0 3.758-3.758h2.742V9.5h-3.023A4.335 4.335 0 1 0 9.5 15.144v3.023h2.167zm-.542-2.675a1.625 1.625 0 1 0 0-3.25 1.625 1.625 0 0 0 0 3.25\" clip-rule=\"evenodd\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M24.67 10.58a2.71 2.71 0 1 1-5.42 0 2.71 2.71 0 0 1 5.42 0M10.58 24.67a2.71 2.71 0 1 0 0-5.42 2.71 2.71 0 0 0 0 5.42m11.38 0a2.71 2.71 0 1 0 0-5.42 2.71 2.71 0 0 0 0 5.42m-3.79-3.79h-3.79v2.17h3.79zm2.71-6.5v3.79h2.17v-3.79z\"/>\n</svg>\n";
function $67e6f3ace9444edb$export$81c47abe19675c4c(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Assets' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $9b7a1b046861a04a$export$f827d3c5a9c3f644), {
        svg: $67e6f3ace9444edb$var$svg,
        label: label,
        isAssets: true,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::4355cde32d77e58b21f0c95828a80152>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
var $29a53ab50e0d6e2c$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color, white)\" d=\"M6 .5h12A5.5 5.5 0 0 1 23.5 6v12a5.5 5.5 0 0 1-5.5 5.5H6A5.5 5.5 0 0 1 .5 18V6A5.5 5.5 0 0 1 6 .5\"/>\n    <path fill=\"none\" stroke=\"var(--border-color, #dddee1)\" d=\"M6 .5h12A5.5 5.5 0 0 1 23.5 6v12a5.5 5.5 0 0 1-5.5 5.5H6A5.5 5.5 0 0 1 .5 18V6A5.5 5.5 0 0 1 6 .5Z\"/>\n    <path fill=\"var(--icon-color, #1868db)\" d=\"M9.215 12.652a2.75 2.75 0 0 0 2.749 2.742v4.205a6.964 6.964 0 0 1-6.849-5.727l-.049-.317zm9.26 0a.44.44 0 0 1 .436.468c-.222 3.311-2.783 5.989-6.043 6.414l-.904-4.14a2.75 2.75 0 0 0 2.723-2.37.44.44 0 0 1 .44-.372zM11.963 9.91a2.75 2.75 0 0 0-2.748 2.742H5v-.065c.033-3.495 2.668-6.374 6.059-6.816zm0-5.972a.436.436 0 0 1 .72-.33l4.824 4.138a.436.436 0 0 1 0 .662l-4.823 4.139a.436.436 0 0 1-.72-.331z\"/>\n</svg>\n";
function $29a53ab50e0d6e2c$export$e812398311cab9a3(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Bamboo' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $9b5b994dd561b600$export$be58b4326e23250f), {
        svg: $29a53ab50e0d6e2c$var$svg,
        label: label,
        type: "data-center",
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a8b53caccfaf8935cadc28439cd96493>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $eb65bc71ea217c46$var$svg = "<svg height=\"100%\" viewBox=\"0 0 154 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M146 25.64c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49m-16.68 13.49c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49m-12.07 5.52c0-3.68-1.47-5.52-4.2-5.52-2.36 0-4.48 1.5-4.48 4.91v1.23c0 3.4 1.93 4.91 4.17 4.91 2.98 0 4.51-1.96 4.51-5.52m-3.8 7.97c-2.24 0-3.96-1.01-4.88-3v2.7h-2.64V3.59h2.64v9.17c.98-2.02 2.82-3.07 5.18-3.07 4.08 0 6.13 3.47 6.13 7.97 0 4.32-2.15 7.97-6.44 7.97m-21.58-8.82v8.53h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 2.61 0 4.39 1.32 5.15 3.74.86-2.36 2.91-3.74 5.46-3.74 3.43 0 5.34 2.33 5.34 6.66v8.99h-2.64v-8.52c0-3.16-1.1-4.72-3.62-4.72-2.45 0-4.14 1.63-4.14 4.72m-28.32.84c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-20.23-9.04H45.8v6.29h6.26c2.64 0 3.83-.95 3.83-2.97 0-2.15-1.13-3.31-3.89-3.31m-.89-8.46h-5.3v6.01h5.31c2.61 0 3.68-1.2 3.68-3.13 0-1.96-1.16-2.88-3.68-2.88m-8.06 17.51V5.19h8.43c4.11 0 6.1 2.02 6.1 5.28 0 2.42-1.1 3.93-3.37 4.48 2.97.49 4.45 2.12 4.45 4.97 0 3.22-2.18 5.43-6.68 5.43z\"/>\n    <path fill=\"var(--tile-color, white)\" d=\"M8 .667h16A7.333 7.333 0 0 1 31.333 8v16A7.333 7.333 0 0 1 24 31.333H8A7.333 7.333 0 0 1 .667 24V8A7.333 7.333 0 0 1 8 .667\"/>\n    <path fill=\"none\" stroke=\"var(--border-color, #dddee1)\" stroke-width=\"1.333\" d=\"M8 .667h16A7.333 7.333 0 0 1 31.333 8v16A7.333 7.333 0 0 1 24 31.333H8A7.333 7.333 0 0 1 .667 24V8A7.333 7.333 0 0 1 8 .667Z\"/>\n    <path fill=\"var(--icon-color, #1868db)\" d=\"M12.287 16.869a3.665 3.665 0 0 0 3.665 3.656v5.607c-4.71 0-8.602-3.52-9.196-8.06zm12.347 0a.584.584 0 0 1 .581.624c-.295 4.415-3.71 7.986-8.057 8.554l-1.206-5.521a3.67 3.67 0 0 0 3.63-3.161.59.59 0 0 1 .589-.496zm-8.683-3.656a3.664 3.664 0 0 0-3.665 3.656h-5.62v-.088c.044-4.66 3.557-8.498 8.078-9.088zm0-7.964a.58.58 0 0 1 .96-.44l6.432 5.518c.27.232.27.65 0 .883l-6.431 5.517a.581.581 0 0 1-.96-.44z\"/>\n</svg>\n";
function $eb65bc71ea217c46$export$7c51958462d750e(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Bamboo' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $9b7a1b046861a04a$export$f827d3c5a9c3f644), {
        svg: $eb65bc71ea217c46$var$svg,
        label: label,
        type: "data-center",
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::0a55e042f17bf853ed858530ff13b240>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
var $7d99f03edbd4b9cf$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color, white)\" d=\"M6 .5h12A5.5 5.5 0 0 1 23.5 6v12a5.5 5.5 0 0 1-5.5 5.5H6A5.5 5.5 0 0 1 .5 18V6A5.5 5.5 0 0 1 6 .5\"/>\n    <path fill=\"none\" stroke=\"var(--border-color, #dddee1)\" d=\"M6 .5h12A5.5 5.5 0 0 1 23.5 6v12a5.5 5.5 0 0 1-5.5 5.5H6A5.5 5.5 0 0 1 .5 18V6A5.5 5.5 0 0 1 6 .5Z\"/>\n    <path fill=\"var(--icon-color, #1868db)\" d=\"m17.843 11.763-.986 6.024c-.065.365-.322.58-.686.58H7.81c-.365 0-.622-.215-.686-.58L5.387 7.047c-.064-.364.129-.6.472-.6h12.262c.343 0 .536.236.472.6l-.472 2.83c-.064.407-.3.579-.686.579h-7.374c-.107 0-.172.064-.15.193l.579 3.558c.021.086.085.15.171.15h2.658c.086 0 .15-.064.172-.15l.407-2.572c.043-.322.257-.45.558-.45h2.894c.428 0 .557.214.493.578\"/>\n</svg>\n";
function $7d99f03edbd4b9cf$export$d3ab16bbf4f954ee(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Bitbucket Data Center' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $9b5b994dd561b600$export$be58b4326e23250f), {
        svg: $7d99f03edbd4b9cf$var$svg,
        label: label,
        type: "data-center",
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a6cf1e00141abbc39f2d3b5098a9d63a>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $9517141151b4abf9$var$svg = "<svg height=\"100%\" viewBox=\"0 0 166 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M161.21 20.58c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55c-.46.12-.98.25-1.78.25-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zm-13.53-8.49c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-23.83.6h-2.64V3.59h2.64v13.59l6.6-7.18h3.44l-7.21 7.54 7.51 7.79h-3.59l-6.75-7.18zm-5.64-2.76v2.36c-.92.49-2.33.71-3.74.71-5.46 0-8-3.31-8-8 0-4.63 2.55-7.94 8-7.94 1.38 0 2.45.18 3.65.74v2.45c-.98-.46-2.02-.74-3.47-.74-3.99 0-5.61 2.51-5.61 5.49s1.66 5.49 5.67 5.49c1.56 0 2.55-.21 3.5-.55m-27.85-3.59V10h2.64v9.26c0 2.76 1.1 3.99 3.62 3.99 2.45 0 4.14-1.62 4.14-4.72V10h2.64v15.33h-2.64v-2.51c-.98 1.81-2.79 2.82-4.85 2.82-3.53 0-5.55-2.42-5.55-6.65m-5.39-1.32c0-3.68-1.47-5.52-4.2-5.52-2.36 0-4.48 1.5-4.48 4.91v1.23c0 3.4 1.93 4.91 4.17 4.91 2.98 0 4.51-1.96 4.51-5.52m-3.8 7.97c-2.24 0-3.96-1.01-4.88-3v2.7h-2.64V3.59h2.64v9.17c.98-2.02 2.82-3.07 5.18-3.07 4.08 0 6.13 3.47 6.13 7.97 0 4.32-2.15 7.97-6.44 7.97m-14.96-5.05c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55a6.3 6.3 0 0 1-1.78.25c-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zM61.33 5.95c0-1.16.77-1.84 1.84-1.84s1.84.68 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zm-9.83-9.04H45.8v6.29h6.26c2.64 0 3.83-.95 3.83-2.97 0-2.15-1.13-3.31-3.89-3.31m-.89-8.46h-5.3v6.01h5.31c2.61 0 3.68-1.2 3.68-3.13 0-1.96-1.16-2.88-3.68-2.88m-8.06 17.51V5.19h8.43c4.11 0 6.1 2.02 6.1 5.28 0 2.42-1.1 3.93-3.37 4.48 2.97.49 4.45 2.12 4.45 4.97 0 3.22-2.18 5.43-6.68 5.43z\"/>\n    <path fill=\"var(--tile-color, white)\" d=\"M8 .667h16A7.333 7.333 0 0 1 31.333 8v16A7.333 7.333 0 0 1 24 31.333H8A7.333 7.333 0 0 1 .667 24V8A7.333 7.333 0 0 1 8 .667\"/>\n    <path fill=\"none\" stroke=\"var(--border-color, #dddee1)\" stroke-width=\"1.333\" d=\"M8 .667h16A7.333 7.333 0 0 1 31.333 8v16A7.333 7.333 0 0 1 24 31.333H8A7.333 7.333 0 0 1 .667 24V8A7.333 7.333 0 0 1 8 .667Z\"/>\n    <path fill=\"var(--icon-color, #1868db)\" d=\"m23.79 15.684-1.315 8.032c-.085.486-.428.772-.914.772H10.413c-.486 0-.829-.286-.915-.772L7.183 9.396c-.086-.486.172-.8.629-.8h16.35c.457 0 .714.314.629.8l-.63 3.773c-.085.543-.4.772-.914.772h-9.833c-.143 0-.228.086-.2.257l.772 4.745c.028.114.114.2.229.2h3.544c.114 0 .2-.086.229-.2l.543-3.43c.057-.429.343-.6.743-.6h3.859c.571 0 .743.285.657.771\"/>\n</svg>\n";
function $9517141151b4abf9$export$cc55e2a4c4b40552(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Bitbucket Data Center' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $9b7a1b046861a04a$export$f827d3c5a9c3f644), {
        svg: $9517141151b4abf9$var$svg,
        label: label,
        type: "data-center",
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::83bd991a11895fc697ec86ba4d2d82c2>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
var $53bbed640c6e6632$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#94c748)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"m17.898 11.353-.994 6.064c-.065.367-.324.583-.691.583H7.787c-.367 0-.627-.216-.691-.583L5.346 6.604C5.28 6.237 5.476 6 5.82 6h12.358c.346 0 .54.237.475.604l-.475 2.85c-.065.41-.303.582-.691.582h-7.432c-.109 0-.173.065-.152.194l.584 3.583c.021.086.086.151.172.151h2.68c.086 0 .15-.065.172-.151l.41-2.59c.044-.324.26-.453.563-.453H17.4c.432 0 .562.216.497.582\"/>\n</svg>\n";
var $53bbed640c6e6632$var$customThemeSvg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--themed-icon-color, currentcolor)\" d=\"M18 0a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6V6a6 6 0 0 1 6-6zM5.821 6c-.345 0-.54.238-.475.604l1.75 10.813c.065.367.324.583.691.583h8.426c.367 0 .627-.216.691-.583l.994-6.065c.065-.366-.065-.582-.497-.582h-2.917c-.302 0-.518.13-.561.453l-.41 2.59c-.022.086-.087.15-.173.15h-2.68c-.086 0-.151-.064-.173-.15l-.583-3.583c-.021-.129.044-.194.152-.194h7.431c.39 0 .627-.173.692-.583l.475-2.849c.065-.366-.13-.604-.475-.604z\"/>\n</svg>\n";
function $53bbed640c6e6632$export$5fc1066e677788d4(_ref) {
    var iconColor = _ref.iconColor, size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Bitbucket' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $9b5b994dd561b600$export$be58b4326e23250f), {
        svg: $53bbed640c6e6632$var$svg,
        customThemeSvg: $53bbed640c6e6632$var$customThemeSvg,
        iconColor: iconColor,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::7131ffd6f745f530e9a82fe4842b6a8c>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $20e6a750a55a1c4a$var$svg = "<svg height=\"100%\" viewBox=\"0 0 166 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M161.21 20.58c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55a6.3 6.3 0 0 1-1.78.25c-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zm-13.53-8.49c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.67-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.05 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-23.83.6h-2.64V3.59h2.64v13.59l6.6-7.18h3.44l-7.21 7.54 7.51 7.79h-3.59l-6.75-7.18zm-5.64-2.76v2.36c-.92.49-2.33.71-3.74.71-5.46 0-8-3.31-8-8 0-4.63 2.55-7.94 8-7.94 1.38 0 2.45.18 3.65.74v2.45c-.98-.46-2.02-.74-3.46-.74-3.99 0-5.61 2.52-5.61 5.49s1.66 5.49 5.67 5.49c1.56 0 2.55-.21 3.5-.55m-27.86-3.59V10h2.64v9.26c0 2.76 1.1 3.99 3.62 3.99 2.45 0 4.14-1.63 4.14-4.72V10h2.64v15.33h-2.64v-2.51c-.98 1.81-2.79 2.82-4.84 2.82-3.53 0-5.55-2.42-5.55-6.65m-5.4-1.32c0-3.68-1.47-5.52-4.2-5.52-2.36 0-4.48 1.5-4.48 4.91v1.23c0 3.4 1.93 4.91 4.17 4.91 2.98 0 4.51-1.96 4.51-5.52m-3.8 7.97c-2.24 0-3.96-1.01-4.88-3v2.7h-2.64V3.59h2.64v9.17c.98-2.02 2.82-3.07 5.18-3.07 4.08 0 6.13 3.47 6.13 7.97 0 4.32-2.15 7.97-6.44 7.97m-14.96-5.05c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55c-.46.12-.98.25-1.78.25-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zM61.33 5.95c0-1.16.77-1.84 1.84-1.84s1.84.68 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zm-9.83-9.04H45.8v6.29h6.26c2.64 0 3.83-.95 3.83-2.97 0-2.15-1.13-3.31-3.89-3.31m-.89-8.46h-5.3v6.01h5.31c2.61 0 3.68-1.2 3.68-3.13 0-1.96-1.17-2.88-3.68-2.88m-8.06 17.51V5.19h8.43c4.11 0 6.1 2.02 6.1 5.27 0 2.42-1.1 3.93-3.37 4.48 2.97.49 4.45 2.12 4.45 4.97 0 3.22-2.18 5.43-6.69 5.43z\"/>\n    <path fill=\"var(--tile-color,#94c748)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"m23.79 15.684-1.315 8.032c-.085.486-.428.772-.914.772H10.413c-.486 0-.829-.286-.915-.772L7.183 9.396c-.086-.486.172-.8.629-.8h16.35c.457 0 .714.314.629.8l-.63 3.773c-.085.543-.4.772-.914.772h-9.833c-.143 0-.228.086-.2.257l.772 4.745c.029.114.114.2.229.2h3.544c.114 0 .2-.086.229-.2l.543-3.43c.057-.429.343-.6.743-.6h3.859c.572 0 .743.285.657.771\"/>\n</svg>\n";
function $20e6a750a55a1c4a$export$f7ef5e5488e4b430(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Bitbucket' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $9b7a1b046861a04a$export$f827d3c5a9c3f644), {
        svg: $20e6a750a55a1c4a$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a54a6a33fcca799b58ea8f543b85188b>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
var $ad00fac377c9e40f$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, #101214)\" fill-rule=\"evenodd\" d=\"M18.563 16.688h-8.438L5.438 19.5V5.438h13.125zm-6.83-9.375-.255.647c-.362.92-.543 1.38-.878 1.727-.334.346-.787.543-1.694.938l-.388.17v.535l.388.17c.907.394 1.36.592 1.694.938.335.346.516.807.878 1.727l.255.648h.535l.255-.648c.362-.92.543-1.38.877-1.727.335-.346.788-.544 1.694-.939l.388-.169v-.535l-.388-.17c-.906-.395-1.36-.592-1.694-.938-.334-.347-.515-.807-.877-1.727l-.255-.647z\" clip-rule=\"evenodd\"/>\n</svg>\n";
function $ad00fac377c9e40f$export$52cd484a7ef4f2b9(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Chat' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $9b5b994dd561b600$export$be58b4326e23250f), {
        svg: $ad00fac377c9e40f$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e9242b17d268ccb8686f65219c6ac465>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $d3bc400e03f0c58c$var$svg = "<svg height=\"100%\" viewBox=\"0 0 102 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M97.51 20.58c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55c-.46.12-.98.25-1.78.25-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zm-18.94-2.91c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-14.1-8.98v8.99h-2.64v-8.52c0-3.16-1.1-4.72-3.62-4.72-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V3.59h2.64v8.95c1.01-1.81 2.85-2.85 5.06-2.85 3.44 0 5.34 2.33 5.34 6.66m-16.22 5.43v2.67c-1.26.83-3.25 1.2-5.34 1.2-6.62 0-10.36-3.99-10.36-10.33 0-6.13 3.74-10.43 10.3-10.43 1.96 0 3.93.37 5.37 1.41v2.67c-1.44-.92-3.04-1.41-5.37-1.41-4.72 0-7.54 3.13-7.54 7.76s2.91 7.7 7.7 7.7c2.12 0 3.77-.49 5.24-1.23\"/>\n    <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, #101214)\" fill-rule=\"evenodd\" d=\"M24.75 22.25H13.5L7.25 26V7.25h17.5zm-9.107-12.5-.34.864c-.482 1.226-.724 1.84-1.17 2.302s-1.05.725-2.258 1.251l-.518.226v.714l.518.226c1.209.526 1.813.79 2.259 1.251.445.462.687 1.076 1.17 2.303l.34.863h.714l.34-.864c.482-1.227.724-1.84 1.17-2.302s1.049-.725 2.258-1.251l.517-.226v-.714l-.517-.226c-1.21-.526-1.813-.79-2.259-1.251-.445-.462-.687-1.075-1.17-2.302l-.34-.864z\" clip-rule=\"evenodd\"/>\n</svg>\n";
function $d3bc400e03f0c58c$export$a529e78951cd6709(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Chat' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $9b7a1b046861a04a$export$f827d3c5a9c3f644), {
        svg: $d3bc400e03f0c58c$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3ac62e14826e8b3e1f38977284672c29>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
var $7d2e0cc3e3a950d6$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, #101214)\" fill-rule=\"evenodd\" d=\"M6.75 19V5h10.5v14h-3.937v-3.062h-2.625V19zM9.375 8.063h1.75V6.75h-1.75zm3.5 0h1.75V6.75h-1.75zm-1.75 3.062h-1.75V9.813h1.75zm-1.75 3.063h1.75v-1.313h-1.75zm5.25-3.063h-1.75V9.813h1.75zm-1.75 3.063h1.75v-1.313h-1.75z\" clip-rule=\"evenodd\"/>\n</svg>\n";
function $7d2e0cc3e3a950d6$export$5ef3f25e16249826(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Company Hub' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $9b5b994dd561b600$export$be58b4326e23250f), {
        svg: $7d2e0cc3e3a950d6$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::bcf3d9eaf1759437b869f9901adcacb2>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $1408f1e2ddb10b25$var$svg = "<svg height=\"100%\" viewBox=\"0 0 129 24\">\n    <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, #101214)\" fill-rule=\"evenodd\" d=\"M6.75 19V5h10.5v14h-3.937v-3.062h-2.625V19zM9.375 8.063h1.75V6.75h-1.75zm3.5 0h1.75V6.75h-1.75zm-1.75 3.062h-1.75V9.813h1.75zm-1.75 3.063h1.75v-1.313h-1.75zm5.25-3.063h-1.75V9.813h1.75zm-1.75 3.063h1.75v-1.313h-1.75z\" clip-rule=\"evenodd\"/>\n    <path fill=\"var(--text-color, #292a2e)\" d=\"M124.53 17.13q-.64 0-1.07-.21a2.3 2.3 0 0 1-.7-.53 3 3 0 0 1-.4-.61h-.1V17h-1.89V6.81h1.93v3.82h.07a3 3 0 0 1 .4-.61q.26-.32.69-.54t1.09-.22q.87 0 1.57.44.71.44 1.13 1.32.42.87.42 2.17 0 1.26-.41 2.15-.41.87-1.12 1.33a2.87 2.87 0 0 1-1.6.46m-.56-1.55q.57 0 .95-.31a1.9 1.9 0 0 0 .57-.85q.2-.54.2-1.23t-.2-1.22a1.8 1.8 0 0 0-.57-.83q-.38-.31-.95-.31-.55 0-.94.29-.38.29-.58.83-.2.53-.2 1.24t.2 1.25q.21.54.59.84.39.3.94.3m-9.65 1.52q-.79 0-1.39-.34a2.34 2.34 0 0 1-.92-.98q-.33-.65-.33-1.55V9.37h1.93v4.54q0 .75.38 1.16t1.05.42q.46 0 .81-.19a1.4 1.4 0 0 0 .55-.57q.2-.38.2-.9V9.38h1.93V17h-1.82l-.02-1.9h.12q-.31.98-.93 1.49t-1.56.51m-13.01-.1V6.81h1.96v4.16h4.58V6.81h1.97V17h-1.97v-4.39h-4.58V17zm-11.89 2.71.45-1.47.23.06q.41.11.73.06a.83.83 0 0 0 .52-.27q.2-.22.27-.62l.08-.44-2.88-7.67h2.04l1.34 4.05q.24.75.39 1.49.16.75.34 1.54h-.47l.37-1.54q.18-.75.43-1.49l1.4-4.05h2.02l-3.26 8.58q-.23.62-.59 1.06-.35.44-.88.68-.52.24-1.25.24-.4 0-.74-.06a2.5 2.5 0 0 1-.53-.14m-6.44-7.17V17h-1.93V9.36h1.82l.04 1.9h-.13q.31-.97.92-1.48.62-.51 1.57-.51.79 0 1.37.34.59.34.92.98t.33 1.55V17H86v-4.54q0-.74-.38-1.16t-1.05-.42q-.45 0-.81.2a1.34 1.34 0 0 0-.55.57q-.2.37-.2.9m-7.92 4.58a2.9 2.9 0 0 1-1.59-.46q-.7-.46-1.12-1.33-.41-.88-.41-2.15 0-1.29.42-2.17.42-.87 1.13-1.32a2.9 2.9 0 0 1 1.58-.44q.66 0 1.09.23.43.22.69.54t.4.61h.08V9.36h1.91V17h-1.9v-1.22h-.08a2.6 2.6 0 0 1-.41.61q-.27.32-.7.53t-1.08.21m.57-1.55q.55 0 .94-.3.38-.3.58-.84.21-.54.21-1.25 0-.72-.2-1.25t-.58-.83q-.38-.29-.94-.29-.57 0-.96.3a1.85 1.85 0 0 0-.58.83 3.6 3.6 0 0 0-.19 1.23q0 .69.2 1.23t.58.85q.39.31.95.31M63.5 19.86V9.36h1.89v1.28h.1q.14-.29.4-.61t.69-.54 1.09-.22q.87 0 1.57.44.71.44 1.13 1.32.42.87.42 2.17 0 1.26-.41 2.15-.41.87-1.12 1.33a2.87 2.87 0 0 1-1.6.46q-.64 0-1.07-.21a2.3 2.3 0 0 1-.7-.53 3 3 0 0 1-.4-.61h-.07v4.07zm3.61-4.28q.57 0 .95-.31t.57-.85q.2-.54.2-1.23t-.2-1.22a1.8 1.8 0 0 0-.57-.83q-.38-.31-.95-.31-.56 0-.94.29t-.58.83q-.2.53-.2 1.24t.2 1.25q.21.54.59.84.39.3.94.3M50.8 17V9.36h1.8l.08 1.87h-.14q.17-.7.51-1.13.35-.44.81-.64.47-.21.97-.21.83 0 1.33.52.51.52.73 1.57h-.22q.16-.71.55-1.18.39-.46.91-.69.53-.23 1.12-.23.69 0 1.24.3.56.3.87.88.32.58.32 1.42V17h-1.92v-4.82q0-.67-.37-1a1.32 1.32 0 0 0-.89-.32q-.4 0-.7.18a1.2 1.2 0 0 0-.46.49q-.16.32-.16.73V17h-1.87v-4.89q0-.57-.35-.91-.34-.34-.89-.34-.37 0-.68.17a1.2 1.2 0 0 0-.49.51q-.18.33-.18.81V17zm-5.18.15q-1.13 0-1.97-.49a3.3 3.3 0 0 1-1.28-1.38q-.45-.89-.45-2.06 0-1.18.45-2.07.45-.9 1.28-1.39t1.97-.49 1.96.49q.83.49 1.29 1.39.45.89.45 2.07t-.45 2.07-1.29 1.38q-.83.49-1.96.49m0-1.53q.58 0 .97-.31.39-.32.58-.87a3.7 3.7 0 0 0 .19-1.23 3.7 3.7 0 0 0-.19-1.23 1.87 1.87 0 0 0-.58-.86q-.39-.32-.97-.32t-.97.32q-.38.32-.58.86-.19.54-.19 1.23 0 .68.19 1.23.2.55.58.87.39.31.97.31m-9.25 1.51q-1.35 0-2.41-.62t-1.67-1.79-.61-2.82.62-2.82q.62-1.18 1.68-1.79 1.07-.62 2.4-.62.85 0 1.59.24.75.24 1.32.7t.94 1.12.49 1.51h-1.98a2.2 2.2 0 0 0-.28-.77 2 2 0 0 0-.51-.57q-.3-.24-.69-.36a2.8 2.8 0 0 0-.83-.12q-.81 0-1.43.41-.62.4-.97 1.18-.34.78-.34 1.89 0 1.13.35 1.91.35.77.96 1.17a2.6 2.6 0 0 0 1.43.4q.45 0 .83-.12.39-.12.7-.36.32-.24.52-.57.21-.34.29-.77h1.98q-.09.72-.43 1.36a4.2 4.2 0 0 1-.9 1.15 4.2 4.2 0 0 1-1.32.79q-.76.28-1.69.28\"/>\n</svg>\n";
function $1408f1e2ddb10b25$export$1ab0976b9ea166ae(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Company Hub' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $9b7a1b046861a04a$export$f827d3c5a9c3f644), {
        svg: $1408f1e2ddb10b25$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e5ce5248a23a237688e2341559569305>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
var $4baee89efb80cd04$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#94c748)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M12.75 7.877v-3.37l6.16-.007h.007a.59.59 0 0 1 .583.598v6.147h-3.366V7.877z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M12.75 14.615v-3.37h3.368v6.165a.59.59 0 0 1-.591.59H6.583A.59.59 0 0 1 6 17.402V8.467a.59.59 0 0 1 .591-.59h6.16v3.368H9.373v3.37z\"/>\n</svg>\n";
function $4baee89efb80cd04$export$f7857fe64d7161d9(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Compass' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $9b5b994dd561b600$export$be58b4326e23250f), {
        svg: $4baee89efb80cd04$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::bbcc7f43e0a51fb6caa253b27359fb22>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $6cbfa5dee2ec240d$var$svg = "<svg height=\"100%\" viewBox=\"0 0 162 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M161.79 21.16c0 2.55-1.66 4.48-5.76 4.48-2.3 0-4.17-.52-5.34-1.13v-2.79c1.32.77 3.53 1.5 5.46 1.5 2.02 0 3.07-.83 3.07-2.02 0-1.16-.89-1.84-3.8-2.55-3.4-.83-4.85-2.15-4.85-4.66 0-2.67 2.06-4.29 5.55-4.29 1.99 0 3.8.49 4.94 1.1v2.73c-1.84-.92-3.34-1.41-4.97-1.41-1.93 0-2.97.68-2.97 1.87 0 1.07.74 1.75 3.56 2.42 3.4.83 5.12 2.09 5.12 4.75m-13.63 0c0 2.55-1.66 4.48-5.76 4.48-2.3 0-4.17-.52-5.34-1.13v-2.79c1.32.77 3.53 1.5 5.46 1.5 2.02 0 3.07-.83 3.07-2.02 0-1.16-.89-1.84-3.8-2.55-3.4-.83-4.84-2.15-4.84-4.66 0-2.67 2.06-4.29 5.55-4.29 1.99 0 3.8.49 4.94 1.1v2.73c-1.84-.92-3.34-1.41-4.97-1.41-1.93 0-2.97.68-2.97 1.87 0 1.07.74 1.75 3.56 2.42 3.4.83 5.12 2.09 5.12 4.75m-25.9-3.49c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01v-2.7h2.64v15.33zm-16.09-7.66c0-3.68-1.47-5.52-4.2-5.52-2.36 0-4.48 1.5-4.48 4.91v1.23c0 3.4 1.93 4.91 4.17 4.91 2.98 0 4.51-1.96 4.51-5.52m-3.8 7.97c-2.24 0-3.96-1.01-4.88-3v8.68h-2.64V10h2.64v2.76c.98-2.02 2.82-3.07 5.18-3.07 4.08 0 6.13 3.47 6.13 7.97 0 4.32-2.15 7.97-6.44 7.97M89.5 16.81v8.53h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.51c.98-1.81 2.79-2.82 4.85-2.82 2.61 0 4.39 1.32 5.15 3.74.86-2.36 2.91-3.74 5.46-3.74 3.43 0 5.34 2.33 5.34 6.66v8.99h-2.64v-8.53c0-3.16-1.1-4.72-3.62-4.72-2.45 0-4.14 1.63-4.14 4.72m-23.34 8.83c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49m-9.23 9.63v2.67c-1.26.83-3.25 1.2-5.34 1.2-6.62 0-10.36-3.99-10.36-10.33 0-6.13 3.74-10.43 10.3-10.43 1.96 0 3.93.37 5.37 1.41v2.67c-1.44-.92-3.04-1.41-5.37-1.41-4.72 0-7.54 3.13-7.54 7.76s2.91 7.7 7.7 7.7c2.12 0 3.77-.49 5.24-1.23\"/>\n    <path fill=\"var(--tile-color,#94c748)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M16.69 15.16v4.24h-4.25v-4.24zv-4.24H8.93a.74.74 0 0 0-.74.74v11.25a.74.74 0 0 0 .74.75h11.26a.74.74 0 0 0 .75-.74v-7.76zm0-8.48v4.24h4.26v4.24h4.24V7.42a.74.74 0 0 0-.73-.75h-.01z\"/>\n</svg>\n";
function $6cbfa5dee2ec240d$export$a16f50a81d183ce(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Compass' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $9b7a1b046861a04a$export$f827d3c5a9c3f644), {
        svg: $6cbfa5dee2ec240d$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::79151986eefb0d79ff7389ad5707c136>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
var $1261df2be6b304e0$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color, white)\" d=\"M6 .5h12A5.5 5.5 0 0 1 23.5 6v12a5.5 5.5 0 0 1-5.5 5.5H6A5.5 5.5 0 0 1 .5 18V6A5.5 5.5 0 0 1 6 .5\"/>\n    <path fill=\"none\" stroke=\"var(--border-color, #dddee1)\" d=\"M6 .5h12A5.5 5.5 0 0 1 23.5 6v12a5.5 5.5 0 0 1-5.5 5.5H6A5.5 5.5 0 0 1 .5 18V6A5.5 5.5 0 0 1 6 .5Z\"/>\n    <path fill=\"var(--icon-color, #1868db)\" d=\"M17.37 14.265c-3.704-1.79-4.785-2.058-6.346-2.058-1.83 0-3.391.761-4.785 2.902l-.229.35c-.187.288-.229.39-.229.514s.063.227.292.37l2.35 1.462c.125.083.23.124.333.124.125 0 .208-.062.333-.247l.375-.577c.582-.885 1.102-1.173 1.768-1.173.583 0 1.27.165 2.122.577l2.455 1.152c.25.124.52.062.645-.226l1.165-2.552c.125-.289.042-.474-.25-.618M6.572 9.757c3.703 1.791 4.785 2.059 6.346 2.059 1.83 0 3.39-.762 4.785-2.902l.229-.35c.187-.288.228-.391.228-.515 0-.123-.062-.226-.29-.37l-2.352-1.462c-.125-.082-.229-.123-.333-.123-.125 0-.208.061-.333.247l-.374.576c-.583.885-1.103 1.173-1.769 1.173-.582 0-1.269-.164-2.122-.576L8.132 6.361c-.25-.123-.52-.061-.645.227L6.322 9.14c-.125.288-.041.473.25.617\"/>\n</svg>\n";
function $1261df2be6b304e0$export$53305f1f2855d3be(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Confluence Data Center' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $9b5b994dd561b600$export$be58b4326e23250f), {
        svg: $1261df2be6b304e0$var$svg,
        label: label,
        type: "data-center",
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b0ac4de94f42b3a4050a935e411c6789>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $16ff1b53fcc3594d$var$svg = "<svg height=\"100%\" viewBox=\"0 0 188 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M181.16 12.09c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.2c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-15.1-2.16v2.36c-.92.49-2.33.71-3.74.71-5.46 0-8-3.31-8-8 0-4.63 2.55-7.94 8-7.94 1.38 0 2.45.18 3.65.74v2.45c-.98-.46-2.02-.74-3.47-.74-3.99 0-5.61 2.51-5.61 5.49s1.66 5.49 5.67 5.49c1.56 0 2.55-.21 3.5-.55m-14.5-6.23v8.99h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 3.53 0 5.55 2.42 5.55 6.66m-22.92-4.27c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-29.1-5.74V10h2.64v9.26c0 2.76 1.1 3.99 3.62 3.99 2.45 0 4.14-1.62 4.14-4.72V10h2.64v15.33h-2.64v-2.51c-.98 1.81-2.79 2.82-4.85 2.82-3.53 0-5.55-2.42-5.55-6.65m-2.23 6.31c-.21.06-.67.12-1.35.12-2.51 0-4.11-1.2-4.11-4.02V3.59h2.64V21.1c0 1.38.92 1.87 2.06 1.87.28 0 .46 0 .77-.03zM96.82 8.38V10h3.96v2.45h-3.96v12.88h-2.58V12.45h-2.48V10h2.48V8.31c0-2.85 1.59-4.78 4.88-4.78.8 0 1.32.12 1.78.25V6.2a8.7 8.7 0 0 0-1.66-.15c-1.62 0-2.42.95-2.42 2.33m-7.32 7.97v8.99h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 3.53 0 5.55 2.42 5.55 6.66m-23.34 9.28c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49m-9.23 9.63v2.67c-1.26.83-3.25 1.2-5.34 1.2-6.62 0-10.36-3.99-10.36-10.33 0-6.13 3.74-10.43 10.3-10.43 1.96 0 3.93.37 5.37 1.41v2.67c-1.44-.92-3.04-1.41-5.37-1.41-4.72 0-7.54 3.13-7.54 7.76s2.91 7.7 7.7 7.7c2.12 0 3.77-.49 5.24-1.23\"/>\n    <path fill=\"var(--tile-color, white)\" d=\"M8 .667h16A7.333 7.333 0 0 1 31.333 8v16A7.333 7.333 0 0 1 24 31.333H8A7.333 7.333 0 0 1 .667 24V8A7.333 7.333 0 0 1 8 .667\"/>\n    <path fill=\"none\" stroke=\"var(--border-color, #dddee1)\" stroke-width=\"1.333\" d=\"M8 .667h16A7.333 7.333 0 0 1 31.333 8v16A7.333 7.333 0 0 1 24 31.333H8A7.333 7.333 0 0 1 .667 24V8A7.333 7.333 0 0 1 8 .667Z\"/>\n    <path fill=\"var(--icon-color, #1868db)\" d=\"M23.16 19.02c-4.938-2.387-6.38-2.744-8.461-2.744-2.441 0-4.522 1.015-6.38 3.87l-.306.466c-.25.384-.305.521-.305.686s.084.302.389.494l3.134 1.948c.167.11.306.165.444.165.167 0 .278-.082.444-.33l.5-.768c.776-1.18 1.47-1.564 2.357-1.564.777 0 1.693.22 2.83.768l3.273 1.537c.333.165.694.083.86-.302l1.554-3.403c.166-.384.055-.63-.333-.823M8.762 13.01c4.938 2.388 6.38 2.744 8.461 2.744 2.441 0 4.522-1.015 6.38-3.87l.306-.466c.25-.384.305-.521.305-.686 0-.164-.083-.302-.388-.494L20.69 8.29c-.167-.11-.305-.165-.444-.165-.166 0-.277.082-.444.33l-.5.768c-.776 1.18-1.47 1.564-2.357 1.564-.777 0-1.692-.22-2.83-.768l-3.273-1.537c-.333-.165-.694-.083-.86.302L8.43 12.187c-.167.384-.056.63.332.823\"/>\n</svg>\n";
function $16ff1b53fcc3594d$export$b3e508cb103e1f93(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Confluence Data Center' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $9b7a1b046861a04a$export$f827d3c5a9c3f644), {
        svg: $16ff1b53fcc3594d$var$svg,
        label: label,
        type: "data-center",
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2264fa822c5f74cedf4229a8911c73b4>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
var $bf2cc7f049a6186c$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#1868db)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, white)\" d=\"M17.888 14.461c-4.039-1.953-5.219-2.245-6.92-2.245-1.997 0-3.699.831-5.219 3.165l-.25.382c-.204.314-.249.426-.249.561s.068.247.318.404l2.564 1.594c.136.09.25.135.363.135.136 0 .226-.068.363-.27l.408-.628c.635-.966 1.203-1.28 1.928-1.28.636 0 1.385.18 2.315.629l2.677 1.257c.272.134.567.067.704-.247l1.27-2.783c.136-.315.046-.517-.272-.674M6.112 9.545c4.039 1.953 5.219 2.245 6.92 2.245 1.997 0 3.699-.83 5.219-3.165l.25-.381c.204-.315.249-.427.249-.562 0-.134-.068-.247-.318-.404L15.87 5.685c-.137-.09-.25-.135-.364-.135-.136 0-.226.067-.363.27l-.408.628c-.635.965-1.203 1.28-1.928 1.28-.636 0-1.385-.18-2.315-.63L7.814 5.843c-.272-.135-.567-.068-.703.247L5.84 8.872c-.136.314-.045.516.272.673\"/>\n</svg>\n";
var $bf2cc7f049a6186c$var$customThemeSvg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--themed-icon-color, currentcolor)\" d=\"M18 0a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6V6a6 6 0 0 1 6-6zm-7.032 12.217c-1.997 0-3.699.83-5.219 3.165l-.249.38c-.204.315-.25.427-.25.562s.068.247.317.404l2.565 1.594c.136.09.249.135.362.135.136 0 .227-.068.363-.27l.409-.628c.635-.966 1.202-1.28 1.928-1.28.636 0 1.384.18 2.315.63l2.677 1.256c.273.134.568.067.704-.247l1.27-2.783c.136-.315.045-.517-.272-.674-4.039-1.953-5.219-2.244-6.92-2.244m4.538-6.667c-.136 0-.227.067-.363.27l-.409.628c-.635.965-1.202 1.28-1.928 1.28-.636 0-1.384-.18-2.315-.63L7.813 5.843c-.272-.135-.567-.067-.703.247L5.84 8.872c-.136.314-.045.517.272.674 4.039 1.953 5.219 2.244 6.92 2.244 1.997 0 3.699-.83 5.219-3.165l.249-.382c.204-.314.25-.426.25-.56s-.068-.248-.317-.405l-2.565-1.593c-.136-.09-.249-.135-.362-.135\"/>\n</svg>\n";
function $bf2cc7f049a6186c$export$68f3db7f6af48bcb(_ref) {
    var iconColor = _ref.iconColor, size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Confluence' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $9b5b994dd561b600$export$be58b4326e23250f), {
        svg: $bf2cc7f049a6186c$var$svg,
        customThemeSvg: $bf2cc7f049a6186c$var$customThemeSvg,
        iconColor: iconColor,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::90f8012e577da50adfff14718da1e4b3>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $e6985fb29d7e75d7$var$svg = "<svg height=\"100%\" viewBox=\"0 0 188 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M181.16 12.09c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.2c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-15.1-2.16v2.36c-.92.49-2.33.71-3.74.71-5.46 0-8-3.31-8-8 0-4.63 2.55-7.94 8-7.94 1.38 0 2.45.18 3.65.74v2.45c-.98-.46-2.02-.74-3.46-.74-3.99 0-5.61 2.51-5.61 5.49s1.66 5.49 5.67 5.49c1.56 0 2.55-.21 3.5-.55m-14.51-6.23v8.99h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 3.53 0 5.55 2.42 5.55 6.66m-22.92-4.27c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-29.1-5.74V10h2.64v9.26c0 2.76 1.1 3.99 3.62 3.99 2.45 0 4.14-1.62 4.14-4.72V10h2.64v15.33h-2.64v-2.51c-.98 1.81-2.79 2.82-4.84 2.82-3.53 0-5.55-2.42-5.55-6.65m-2.24 6.31c-.21.06-.67.12-1.35.12-2.51 0-4.11-1.19-4.11-4.02V3.59h2.64V21.1c0 1.38.92 1.87 2.06 1.87.28 0 .46 0 .77-.03zM96.82 8.38V10h3.96v2.45h-3.96v12.88h-2.58V12.45h-2.48V10h2.48V8.31c0-2.85 1.59-4.78 4.88-4.78.8 0 1.32.12 1.78.25V6.2a8.7 8.7 0 0 0-1.66-.15c-1.62 0-2.42.95-2.42 2.33m-7.32 7.97v8.99h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 3.53 0 5.55 2.42 5.55 6.66m-23.34 9.28c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49m-9.23 9.63v2.67c-1.26.83-3.25 1.2-5.34 1.2-6.62 0-10.36-3.99-10.36-10.33 0-6.13 3.74-10.43 10.3-10.43 1.96 0 3.93.37 5.37 1.41v2.67c-1.44-.92-3.04-1.41-5.37-1.41-4.72 0-7.54 3.13-7.54 7.76s2.91 7.7 7.7 7.7c2.12 0 3.77-.49 5.24-1.23\"/>\n    <path fill=\"var(--tile-color,#1868db)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, white)\" d=\"M23.16 19.02c-4.938-2.387-6.38-2.744-8.461-2.744-2.442 0-4.522 1.015-6.38 3.87l-.306.466c-.25.384-.305.521-.305.686s.083.302.388.494l3.135 1.948c.167.11.305.165.444.165.166 0 .277-.082.444-.33l.5-.768c.776-1.18 1.47-1.564 2.357-1.564.777 0 1.692.22 2.83.768l3.273 1.537c.333.165.693.083.86-.302l1.553-3.403c.167-.384.056-.63-.333-.823M8.761 13.01c4.938 2.388 6.38 2.744 8.461 2.744 2.441 0 4.522-1.015 6.38-3.87l.305-.466c.25-.384.305-.521.305-.686 0-.164-.083-.302-.388-.494L20.691 8.29c-.167-.11-.306-.165-.444-.165-.167 0-.278.082-.444.33l-.5.768c-.776 1.18-1.47 1.564-2.357 1.564-.777 0-1.693-.22-2.83-.768l-3.273-1.537c-.333-.165-.694-.083-.86.302l-1.554 3.403c-.166.384-.055.63.333.823\"/>\n</svg>\n";
function $e6985fb29d7e75d7$export$a88b0b0da9ef63ce(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Confluence' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $9b7a1b046861a04a$export$f827d3c5a9c3f644), {
        svg: $e6985fb29d7e75d7$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d471014cf3c5b11585548418a230239b>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
var $9f0bbf9ab4b2a1c5$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color, white)\" d=\"M6 .5h12A5.5 5.5 0 0 1 23.5 6v12a5.5 5.5 0 0 1-5.5 5.5H6A5.5 5.5 0 0 1 .5 18V6A5.5 5.5 0 0 1 6 .5\"/>\n    <path fill=\"none\" stroke=\"var(--border-color, #dddee1)\" d=\"M6 .5h12A5.5 5.5 0 0 1 23.5 6v12a5.5 5.5 0 0 1-5.5 5.5H6A5.5 5.5 0 0 1 .5 18V6A5.5 5.5 0 0 1 6 .5Z\"/>\n    <path fill=\"var(--icon-color, #1868db)\" d=\"M18.71 7.463 12 4.993l-6.71 2.47a.44.44 0 0 0-.29.433l.14 3.807c.103 3.148 1.684 5.489 4.163 7.018a.446.446 0 0 0 .646-.204l1.445-3.412a.22.22 0 0 0-.14-.298 2.585 2.585 0 1 1 1.492 0 .22.22 0 0 0-.14.298l1.446 3.412a.446.446 0 0 0 .645.204c2.48-1.529 4.06-3.87 4.163-7.018L19 7.896a.44.44 0 0 0-.29-.433\"/>\n</svg>\n";
function $9f0bbf9ab4b2a1c5$export$eaf73f391f7103bd(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Crowd' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $9b5b994dd561b600$export$be58b4326e23250f), {
        svg: $9f0bbf9ab4b2a1c5$var$svg,
        label: label,
        type: "data-center",
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::13d7df881302adff1c5de7157bb4b9bb>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $74bdda6b0a46426e$var$svg = "<svg height=\"100%\" viewBox=\"0 0 126 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M113.97 17.67c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V3.59h2.64v21.74zm-17.72 0h-3.37l-2.64-7.42-1.41-4.72-1.41 4.72-2.64 7.42h-3.37L84.45 10h2.91l4.42 13 4.48-13h2.51l4.48 13 4.41-13h2.91zm-28.47.31c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49m-13.77 4.14v9.05h-2.58V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.68-5.43 3.93m-5.76 5.48v2.67c-1.26.83-3.25 1.2-5.34 1.2-6.62 0-10.36-3.99-10.36-10.33 0-6.13 3.74-10.43 10.3-10.43 1.96 0 3.93.37 5.37 1.41v2.67c-1.44-.92-3.04-1.41-5.37-1.41-4.72 0-7.54 3.13-7.54 7.76s2.91 7.7 7.7 7.7c2.12 0 3.77-.49 5.24-1.23\"/>\n    <path fill=\"var(--tile-color, white)\" d=\"M8 .667h16A7.333 7.333 0 0 1 31.333 8v16A7.333 7.333 0 0 1 24 31.333H8A7.333 7.333 0 0 1 .667 24V8A7.333 7.333 0 0 1 8 .667\"/>\n    <path fill=\"none\" stroke=\"var(--border-color, #dddee1)\" stroke-width=\"1.333\" d=\"M8 .667h16A7.333 7.333 0 0 1 31.333 8v16A7.333 7.333 0 0 1 24 31.333H8A7.333 7.333 0 0 1 .667 24V8A7.333 7.333 0 0 1 8 .667Z\"/>\n    <path fill=\"var(--icon-color, #1868db)\" d=\"M24.946 9.951 16 6.657 7.054 9.95a.59.59 0 0 0-.387.577l.187 5.076c.137 4.197 2.245 7.319 5.55 9.357.31.19.719.063.86-.272l1.928-4.55a.294.294 0 0 0-.185-.396 3.447 3.447 0 1 1 1.987 0 .294.294 0 0 0-.185.397l1.927 4.549c.142.335.55.463.86.272 3.305-2.038 5.413-5.16 5.55-9.357l.187-5.076a.59.59 0 0 0-.387-.577\"/>\n</svg>\n";
function $74bdda6b0a46426e$export$3c371bdbcdfcdce(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Crowd' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $9b7a1b046861a04a$export$f827d3c5a9c3f644), {
        svg: $74bdda6b0a46426e$var$svg,
        label: label,
        type: "data-center",
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6a1acdf5e3aacf1ac91c03f0f8d3dcf4>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
var $f5be1548d97162b0$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, #101214)\" fill-rule=\"evenodd\" d=\"M19 12a7 7 0 1 0-14 0 7 7 0 0 0 14 0m-9.37 4.625.026.074a5.26 5.26 0 0 1-2.833-3.824h2.136c.069 1.426.306 2.73.67 3.75m1.08-3.75c.068 1.255.278 2.353.567 3.162.179.5.37.841.54 1.042a.6.6 0 0 0 .183.165.7.7 0 0 0 .183-.165c.17-.2.361-.543.54-1.042.288-.809.498-1.907.566-3.162zm2.58-1.75h-2.58c.068-1.255.278-2.353.567-3.162.179-.5.37-.841.54-1.042A.7.7 0 0 1 12 6.756a.6.6 0 0 1 .183.165c.17.2.361.543.54 1.042.288.809.498 1.907.566 3.162m1.751 1.75c-.069 1.426-.306 2.73-.67 3.75l-.027.074a5.26 5.26 0 0 0 2.833-3.824zm2.136-1.75H15.04c-.069-1.426-.306-2.73-.67-3.75l-.027-.074a5.26 5.26 0 0 1 2.833 3.824m-8.218 0H6.823a5.26 5.26 0 0 1 2.833-3.824l-.027.074c-.364 1.02-.601 2.324-.67 3.75\" clip-rule=\"evenodd\"/>\n</svg>\n";
function $f5be1548d97162b0$export$5efe8561ca252843(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Custom Link' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $9b5b994dd561b600$export$be58b4326e23250f), {
        svg: $f5be1548d97162b0$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::adde776e49635255fd9de5c803442f95>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
var $c1154bc2e76da5bc$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#ffc716)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M16.43 17.42A6.97 6.97 0 0 1 12 19H6.4v-.47l3.84-3.78a3.25 3.25 0 0 0 1.76.52c.65 0 1.25-.19 1.76-.51zm.99-.99A6.97 6.97 0 0 0 19 12a6.97 6.97 0 0 0-1.58-4.43l-2.67 2.67c.33.51.52 1.11.52 1.76s-.19 1.25-.51 1.76zm-.99-9.85-2.67 2.67A3.25 3.25 0 0 0 12 8.73c-.65 0-1.25.19-1.76.52L7.57 6.58A6.97 6.97 0 0 1 12 5c1.68 0 3.22.59 4.43 1.58m-9.85.99A6.97 6.97 0 0 0 5 12c0 1.68.59 3.22 1.58 4.43l2.67-2.67A3.25 3.25 0 0 1 8.73 12c0-.65.19-1.25.52-1.76z\"/>\n</svg>\n";
var $c1154bc2e76da5bc$var$customThemeSvg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--themed-icon-color, currentcolor)\" d=\"M18 0a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6V6a6 6 0 0 1 6-6zm-4.238 14.751a3.25 3.25 0 0 1-1.762.516 3.25 3.25 0 0 1-1.762-.515L6.4 18.533V19H12a6.97 6.97 0 0 0 4.43-1.58zM6.58 7.571A6.97 6.97 0 0 0 5 12a6.97 6.97 0 0 0 1.58 4.43l2.669-2.668A3.25 3.25 0 0 1 8.733 12c0-.649.19-1.253.516-1.762zm8.172 2.667c.326.508.515 1.113.515 1.762s-.189 1.254-.515 1.762l2.668 2.668A6.97 6.97 0 0 0 19 12a6.97 6.97 0 0 0-1.58-4.43zM12 5a6.97 6.97 0 0 0-4.43 1.58l2.668 2.668A3.25 3.25 0 0 1 12 8.733c.649 0 1.253.19 1.762.516L16.43 6.58A6.97 6.97 0 0 0 12 5\"/>\n</svg>\n";
function $c1154bc2e76da5bc$export$6da5aa77c402ba0f(_ref) {
    var iconColor = _ref.iconColor, size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Customer Service Management' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $9b5b994dd561b600$export$be58b4326e23250f), {
        svg: $c1154bc2e76da5bc$var$svg,
        customThemeSvg: $c1154bc2e76da5bc$var$customThemeSvg,
        iconColor: iconColor,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e95354b27dc93f4ad2578de274aa63f2>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $08a10d77ef70bbc8$var$svg = "<svg height=\"100%\" viewBox=\"0 0 456 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M451.86 20.58c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55c-.46.12-.98.25-1.78.25-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zm-7.33-4.23v8.99h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 3.53 0 5.55 2.42 5.55 6.66m-22.92-4.27c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-26.16-7.92v8.53h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 2.61 0 4.39 1.32 5.15 3.74.86-2.36 2.91-3.74 5.46-3.74 3.44 0 5.34 2.33 5.34 6.66v8.99h-2.64v-8.52c0-3.16-1.1-4.72-3.62-4.72-2.45 0-4.14 1.63-4.14 4.72m-22.92-4.74c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-18.64-.62v-1.53c-.98 2.02-2.82 3.07-5.18 3.07-4.05 0-6.07-3.46-6.07-7.97 0-4.32 2.12-7.97 6.38-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.58v13.95c0 4.51-2.12 7.54-7.6 7.54-2.58 0-3.99-.34-5.46-.83v-2.58c1.69.55 3.44.92 5.34.92 3.83 0 5.15-2.05 5.15-4.91m-8.68-6.44c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m-16.96.03c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-14.08-8.98v8.99h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 3.53 0 5.55 2.42 5.55 6.66m-28.33 1.31c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-31.44-11.01-2.76-7.48v18.49h-2.76V5.19h4.78l4.57 11.56 1.87 5.55 1.87-5.55 4.6-11.56h4.45v20.15h-2.76V7.06l-2.36 7.27-4.45 11.01h-2.67zm-21.51-2.23c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-15.1-2.16v2.36c-.92.49-2.33.71-3.74.71-5.46 0-8-3.31-8-8 0-4.63 2.55-7.94 8-7.94 1.38 0 2.45.18 3.65.74v2.45c-.98-.46-2.02-.74-3.47-.74-3.99 0-5.61 2.51-5.61 5.49s1.66 5.49 5.67 5.49c1.56 0 2.55-.21 3.5-.55M234.91 5.95c0-1.16.77-1.84 1.84-1.84s1.84.68 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zm-8.24 0h-3.53L217.69 10h2.76l4.97 13.09L230.36 10h2.76zm-15.45-9.04v9.05h-2.58V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.68-5.43 3.93m-12.46-4.21c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.05 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-15.33-4.95c0 3.5-2.08 5.86-7.08 5.86-3.89 0-5.7-.77-7.27-1.56v-2.82c1.87.98 4.75 1.69 7.42 1.69 3.04 0 4.17-1.2 4.17-2.97 0-1.78-1.1-2.73-4.94-3.65-4.54-1.1-6.56-2.67-6.56-5.98 0-3.13 2.39-5.46 7.08-5.46 2.91 0 4.78.71 6.16 1.47v2.76c-2.02-1.16-4.2-1.53-6.29-1.53-2.64 0-4.2.92-4.2 2.76 0 1.66 1.29 2.48 4.85 3.37 4.26 1.07 6.65 2.45 6.65 6.07m-26.4-3.5v9.05h-2.58V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.68-5.43 3.93m-12.46-4.21c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2H146.5c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-26.15-7.92v8.53h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 2.61 0 4.39 1.32 5.15 3.74.86-2.36 2.91-3.74 5.46-3.74 3.44 0 5.34 2.33 5.34 6.66v8.99h-2.64v-8.52c0-3.16-1.1-4.72-3.62-4.72-2.45 0-4.14 1.63-4.14 4.72m-23.34 8.81c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49M94.1 20.58c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55a6.3 6.3 0 0 1-1.78.25c-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45H94.1zm-6.7.58c0 2.55-1.66 4.48-5.77 4.48-2.3 0-4.17-.52-5.34-1.13v-2.79c1.32.77 3.53 1.5 5.46 1.5 2.02 0 3.07-.83 3.07-2.02 0-1.16-.89-1.84-3.8-2.54-3.4-.83-4.84-2.15-4.84-4.66 0-2.67 2.05-4.29 5.55-4.29 1.99 0 3.8.49 4.94 1.1v2.73c-1.84-.92-3.34-1.41-4.97-1.41-1.93 0-2.97.68-2.97 1.87 0 1.07.74 1.75 3.56 2.42 3.4.83 5.12 2.09 5.12 4.75m-27.6-2.18V10h2.64v9.26c0 2.76 1.1 3.99 3.62 3.99 2.45 0 4.14-1.63 4.14-4.72V10h2.64v15.33h-2.64v-2.51c-.98 1.81-2.79 2.82-4.84 2.82-3.53 0-5.55-2.42-5.55-6.65m-2.89 2.79v2.67c-1.26.83-3.25 1.2-5.34 1.2-6.62 0-10.36-3.99-10.36-10.33 0-6.13 3.74-10.43 10.3-10.43 1.96 0 3.93.37 5.37 1.41v2.67c-1.44-.92-3.04-1.41-5.37-1.41-4.72 0-7.54 3.13-7.54 7.76s2.91 7.7 7.7 7.7c2.12 0 3.77-.49 5.24-1.23\"/>\n    <path fill=\"var(--tile-color,#ffc716)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M21.91 23.23a9.3 9.3 0 0 1-5.91 2.1H8.53v-.62l5.12-5.04a4.34 4.34 0 0 0 2.35.69c.86 0 1.67-.25 2.35-.69zm1.32-1.32a9.3 9.3 0 0 0 2.1-5.91c0-2.24-.79-4.3-2.11-5.91l-3.56 3.56c.43.68.69 1.48.69 2.35s-.25 1.67-.69 2.35zM21.91 8.77l-3.56 3.56a4.34 4.34 0 0 0-2.35-.69c-.86 0-1.67.25-2.35.69l-3.56-3.56A9.3 9.3 0 0 1 16 6.67c2.24 0 4.3.79 5.91 2.11M8.77 10.09A9.3 9.3 0 0 0 6.67 16c0 2.24.79 4.3 2.11 5.91l3.56-3.56a4.34 4.34 0 0 1-.69-2.35c0-.86.25-1.67.69-2.35z\"/>\n</svg>\n";
function $08a10d77ef70bbc8$export$f597f0f7fadce0b9(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Customer Service Management' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $9b7a1b046861a04a$export$f827d3c5a9c3f644), {
        svg: $08a10d77ef70bbc8$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::772abda1b80977ea1535de7e3f60e0fa>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
var $645e97300d058240$var$svg = "<svg height=\"100%\" viewBox=\"0 0 48 48\">\n    <path fill=\"var(--tile-color,#94c748)\" d=\"M0 12C0 5.373 5.373 0 12 0h24c6.627 0 12 5.373 12 12v24c0 6.627-5.373 12-12 12H12C5.373 48 0 42.627 0 36z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"m36.22 26.75 4.9 7.25h-4.78c-.52-.6-1.02-1.31-1.47-1.98-.68-1.02-.68-2.41.03-3.41zm-7.3-5.5L24.02 14h4.78c.52.6 1.02 1.31 1.47 1.98.68 1.02.68 2.41-.02 3.41zm6.98-6.02c.5-.84 1.07-1.16 1.95-1.16l3.9-.07-12.68 19.27a1.46 1.46 0 0 1-1.22.67H23.6c4.07-6.25 8.37-12.37 12.31-18.7M8 33.94h6.89c6.16 0 9.92-3.88 9.92-9.94s-3.76-9.94-9.92-9.94H8l4.28 3.9h-1.76C9.13 17.96 8 19.12 8 20.55v13.38m4.41-3.9V17.96h2.46c3.52 0 5.49 2.38 5.49 6.04 0 3.65-1.97 6.04-5.46 6.04z\"/>\n</svg>\n";
function $645e97300d058240$export$9951d02c2d848122(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Dx' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $9b5b994dd561b600$export$be58b4326e23250f), {
        svg: $645e97300d058240$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2b7db25f7017f6ec5d21f0ae31065359>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
var $7a1b18946ccbad19$var$svg = "<svg height=\"100%\" viewBox=\"0 0 48 48\">\n    <rect width=\"48\" height=\"48\" fill=\"var(--tile-color,#c97cf4)\" rx=\"12\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M20 19h5v11h-5zm7-9h5v28h-5zm7 6h5v16h-5zm-21 0h5v16h-5zm-7 5h5v7H6z\"/>\n</svg>\n";
function $7a1b18946ccbad19$export$34420f0520b19b1d(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Feedback' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $9b5b994dd561b600$export$be58b4326e23250f), {
        svg: $7a1b18946ccbad19$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::fe7d010e7776c61d1ffb49fef9c7dd61>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $c1e8533d1c9e7c7d$var$svg = "<svg height=\"100%\" viewBox=\"0 0 169 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M157.894 25.334h-2.638V3.59h2.638v13.585L164.487 10h3.435l-7.207 7.544 7.513 7.79h-3.588l-6.746-7.177zm-5.648-2.761v2.362c-.92.49-2.331.705-3.742.705-5.458 0-8.004-3.312-8.004-8.004 0-4.63 2.546-7.943 8.004-7.943 1.38 0 2.454.184 3.65.736v2.454c-.982-.46-2.024-.736-3.466-.736-3.986 0-5.612 2.514-5.612 5.489s1.656 5.49 5.674 5.49c1.564 0 2.545-.215 3.496-.553m-26.118-4.906c0 3.68 1.472 5.52 4.201 5.52 2.361 0 4.477-1.503 4.477-4.907v-1.227c0-3.404-1.932-4.906-4.17-4.906-2.975 0-4.508 1.962-4.508 5.52m8.678 7.666v-2.76c-.981 2.024-2.821 3.067-5.182 3.067-4.079 0-6.134-3.465-6.134-7.973 0-4.324 2.147-7.974 6.44-7.974 2.239 0 3.956 1.012 4.876 3.006V10h2.638v15.333zm-16.09-7.666c0-3.68-1.472-5.52-4.201-5.52-2.362 0-4.478 1.502-4.478 4.906v1.227c0 3.404 1.932 4.907 4.171 4.907 2.975 0 4.508-1.963 4.508-5.52m-3.803 7.973c-2.238 0-3.956-1.012-4.876-3.005v2.698H107.4V3.592h2.637v9.17c.982-2.025 2.822-3.068 5.183-3.068 4.079 0 6.133 3.466 6.133 7.974 0 4.324-2.146 7.973-6.44 7.973m-22.806-7.974c0 3.68 1.472 5.52 4.2 5.52 2.362 0 4.478-1.503 4.478-4.907v-1.227c0-3.404-1.932-4.906-4.17-4.906-2.975 0-4.508 1.963-4.508 5.52m8.678 7.666v-2.76c-.981 2.024-2.821 3.067-5.182 3.067-4.08 0-6.134-3.465-6.134-7.973 0-4.324 2.147-7.974 6.44-7.974 2.239 0 3.956 1.013 4.876 3.006V3.59h2.638v21.743zM80.502 12.085c-2.79 0-4.201 1.81-4.477 4.478h8.555c-.153-2.852-1.44-4.478-4.078-4.478M86.39 24.72c-1.258.675-3.19.92-4.754.92-5.734 0-8.249-3.312-8.249-8.004 0-4.63 2.576-7.943 7.237-7.943 4.723 0 6.625 3.282 6.625 7.943v1.196H76.055c.368 2.607 2.055 4.293 5.673 4.293 1.78 0 3.282-.337 4.662-.828zM64.42 12.085c-2.79 0-4.202 1.81-4.477 4.478h8.556c-.154-2.852-1.442-4.478-4.08-4.478m5.888 12.635c-1.258.675-3.19.92-4.754.92-5.734 0-8.249-3.312-8.249-8.004 0-4.63 2.576-7.943 7.238-7.943 4.722 0 6.623 3.282 6.623 7.943v1.196H59.974c.368 2.607 2.055 4.293 5.674 4.293 1.778 0 3.28-.337 4.66-.828zm-15.679-6.9H45.49v7.514h-2.76V5.186h12.94v2.637H45.49v7.36h9.138z\"/>\n    <rect width=\"32\" height=\"32\" fill=\"var(--tile-color,#c97cf4)\" rx=\"8\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M13.333 12.667h3.334V20h-3.334zm4.667-6h3.333v18.666H18zm4.667 4H26v10.666h-3.333zm-14 0H12v10.666H8.667zM4 14h3.333v4.666H4z\"/>\n</svg>\n";
function $c1e8533d1c9e7c7d$export$bbccafb125ebd50c(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Feedback' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $9b7a1b046861a04a$export$f827d3c5a9c3f644), {
        svg: $c1e8533d1c9e7c7d$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c86bc4a90f7eb35fd36ae7c99f20011b>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
var $0c16e5609534a2b0$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#fb9700)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M20.84 12.21a4.29 4.29 0 0 0-6.05 0l-1.394 1.393c-.77.769-2.02.769-2.789 0L9.45 12.445 6.424 15.47l1.158 1.158a6.25 6.25 0 0 0 8.838 0zm-17.68-.418a4.253 4.253 0 0 0 6.034.017l1.412-1.412a1.973 1.973 0 0 1 2.788 0l1.158 1.158 3.026-3.025-1.158-1.158a6.25 6.25 0 0 0-8.838 0l-4.42 4.419z\"/>\n</svg>\n";
function $0c16e5609534a2b0$export$1e02e7298035a77c(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Focus' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $9b5b994dd561b600$export$be58b4326e23250f), {
        svg: $0c16e5609534a2b0$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::7aca4717e5f7edbaa74141430c7d1f8d>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $4de141105e2ca493$var$svg = "<svg height=\"100%\" viewBox=\"0 0 117 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M116.03 21.16c0 2.55-1.66 4.48-5.76 4.48-2.3 0-4.17-.52-5.34-1.13v-2.79c1.32.77 3.53 1.5 5.46 1.5 2.02 0 3.07-.83 3.07-2.02 0-1.16-.89-1.84-3.8-2.54-3.4-.83-4.85-2.15-4.85-4.66 0-2.67 2.06-4.29 5.55-4.29 1.99 0 3.8.49 4.94 1.1v2.73c-1.84-.92-3.34-1.41-4.97-1.41-1.93 0-2.97.68-2.97 1.87 0 1.07.74 1.75 3.56 2.42 3.4.83 5.12 2.09 5.12 4.75m-27.6-2.18V10h2.64v9.26c0 2.76 1.1 3.99 3.62 3.99 2.45 0 4.14-1.62 4.14-4.72V10h2.64v15.33h-2.64v-2.51c-.98 1.81-2.79 2.82-4.85 2.82-3.53 0-5.55-2.42-5.55-6.65m-2.71 3.58v2.36c-.92.49-2.33.71-3.74.71-5.46 0-8-3.31-8-8 0-4.63 2.55-7.94 8-7.94 1.38 0 2.45.18 3.65.74v2.45c-.98-.46-2.02-.74-3.47-.74-3.99 0-5.61 2.51-5.61 5.49s1.66 5.49 5.67 5.49c1.56 0 2.55-.21 3.5-.55M64.6 25.64c-4.6 0-7.3-3.4-7.3-8S60 9.7 64.6 9.7c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49m-9.97 5.67h-9.14v7.51h-2.76V5.19h12.94v2.64H45.49v7.36h9.14z\"/>\n    <path fill=\"var(--tile-color,#fb9700)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M27.607 16.272c-2.176-2.176-5.712-2.152-7.865 0l-1.812 1.812c-1 1-2.625 1-3.625 0L12.8 16.578l-3.933 3.934 1.505 1.505a8.126 8.126 0 0 0 11.49 0zm-22.982-.541c2.176 2.175 5.668 2.196 7.844.02l1.834-1.834c1-1 2.625-1 3.625 0l1.505 1.505 3.934-3.933-1.505-1.505a8.126 8.126 0 0 0-11.49 0l-5.745 5.745z\"/>\n</svg>\n";
function $4de141105e2ca493$export$3a6e8b37e069a69d(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Focus' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $9b7a1b046861a04a$export$f827d3c5a9c3f644), {
        svg: $4de141105e2ca493$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::02833d9738a6774113f222b59b2a94ce>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
var $a91c75e095c80598$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M14.352 12a2.352 2.352 0 1 1-4.704 0 2.352 2.352 0 0 1 4.704 0\"/>\n    <path fill=\"var(--icon-color, #101214)\" fill-rule=\"evenodd\" d=\"M12 18.563a6.562 6.562 0 1 0 0-13.125 6.562 6.562 0 0 0 0 13.125M16.102 12a4.102 4.102 0 1 1-8.204 0 4.102 4.102 0 0 1 8.204 0\" clip-rule=\"evenodd\"/>\n</svg>\n";
function $a91c75e095c80598$export$9eb74917ea768ed4(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Goals' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $9b5b994dd561b600$export$be58b4326e23250f), {
        svg: $a91c75e095c80598$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::56bcd62ca7ac54601202de0d95c6f0a6>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $7d59ddb7b829c48b$var$svg = "<svg height=\"100%\" viewBox=\"0 0 116 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M115.55 21.16c0 2.55-1.66 4.48-5.77 4.48-2.3 0-4.17-.52-5.34-1.13v-2.79c1.32.77 3.53 1.5 5.46 1.5 2.02 0 3.07-.83 3.07-2.02 0-1.16-.89-1.84-3.8-2.54-3.4-.83-4.84-2.15-4.84-4.66 0-2.67 2.05-4.29 5.55-4.29 1.99 0 3.8.49 4.94 1.1v2.73c-1.84-.92-3.34-1.41-4.97-1.41-1.93 0-2.97.68-2.97 1.87 0 1.07.74 1.75 3.56 2.42 3.4.83 5.12 2.09 5.12 4.75m-13.12 4.13c-.21.06-.67.12-1.35.12-2.51 0-4.11-1.19-4.11-4.02V3.59h2.64V21.1c0 1.38.92 1.87 2.06 1.87.28 0 .46 0 .77-.03zm-20.75-7.63c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-20.7.31c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49M58.71 24.2c-1.59.95-4.54 1.44-6.81 1.44-6.93 0-10.67-4.23-10.67-10.33 0-6.56 4.26-10.46 11.44-10.46 1.6 0 3.47.18 5.24.8v2.76c-1.53-.61-3.34-.89-5.21-.89-5.98 0-8.71 2.98-8.71 7.73 0 4.66 2.76 7.76 8.56 7.76.95 0 2.27-.09 3.4-.43v-5.61H50.8v-2.64h7.91z\"/>\n    <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M19.36 16a3.36 3.36 0 1 1-6.72 0 3.36 3.36 0 0 1 6.72 0\"/>\n    <path fill=\"var(--icon-color, #101214)\" fill-rule=\"evenodd\" d=\"M16 25.375a9.375 9.375 0 1 0 0-18.75 9.375 9.375 0 1 0 0 18.75M21.86 16a5.86 5.86 0 1 1-11.72 0 5.86 5.86 0 0 1 11.72 0\" clip-rule=\"evenodd\"/>\n</svg>\n";
function $7d59ddb7b829c48b$export$c527a545aa426db3(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Goals' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $9b7a1b046861a04a$export$f827d3c5a9c3f644), {
        svg: $7d59ddb7b829c48b$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::0276df52cce3ff4af21c51ddcfcd1999>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
var $89e8a96e1e6f33d4$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M5.49 10.87h13.02c.374 0 .574-.2.574-.574V5.907c0-.374-.2-.574-.574-.574h-2.744c-.374 0-.573.2-.573.574v2.22h-1.247v-2.22c0-.374-.2-.574-.574-.574h-2.743c-.374 0-.574.2-.574.574v2.22H8.807v-2.22c0-.374-.2-.574-.573-.574H5.49c-.374 0-.573.2-.573.574v4.39c0 .373.2.573.573.573m.225 3.84a8.7 8.7 0 0 1-.5-2.493c-.024-.324.126-.499.475-.499h12.62c.349 0 .498.15.498.449a8.2 8.2 0 0 1-.523 2.544c-.15.399-.375.573-.799.573H6.513c-.424 0-.649-.174-.798-.573m11.547 2.07C16.065 18.253 14.095 19.2 12 19.2s-4.116-.948-5.288-2.42c-.299-.398-.15-.648.15-.648h10.275c.3 0 .45.25.125.649\"/>\n</svg>\n";
function $89e8a96e1e6f33d4$export$e26e48d31d71c1e1(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Guard Detect' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $9b5b994dd561b600$export$be58b4326e23250f), {
        svg: $89e8a96e1e6f33d4$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::ffc02f6eb51ba8d719155b3e3ac4a088>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $f5375db4b0eca8fb$var$svg = "<svg height=\"100%\" viewBox=\"0 0 121 24\">\n    <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M5.49 10.87h13.02c.374 0 .574-.2.574-.574V5.907c0-.374-.2-.574-.574-.574h-2.744c-.374 0-.573.2-.573.574v2.22h-1.247v-2.22c0-.374-.2-.574-.574-.574h-2.743c-.374 0-.574.2-.574.574v2.22H8.807v-2.22c0-.374-.2-.574-.573-.574H5.49c-.374 0-.573.2-.573.574v4.39c0 .373.2.573.573.573m.225 3.84a8.7 8.7 0 0 1-.5-2.493c-.024-.324.126-.499.475-.499h12.62c.349 0 .498.15.498.449a8.2 8.2 0 0 1-.523 2.544c-.15.399-.375.573-.799.573H6.513c-.424 0-.649-.174-.798-.573m11.547 2.07C16.065 18.253 14.095 19.2 12 19.2s-4.116-.948-5.288-2.42c-.299-.398-.15-.648.15-.648h10.275c.3 0 .45.25.125.649\"/>\n    <path fill=\"var(--text-color, #292a2e)\" d=\"M120.03 9.36v1.48h-4.44V9.36zm-3.38-1.82h1.92v7.27q0 .38.17.57t.56.19a3 3 0 0 0 .32-.03 5 5 0 0 0 .32-.06l.29 1.46a3.4 3.4 0 0 1-.63.13 5 5 0 0 1-.62.04q-1.13 0-1.73-.55-.59-.56-.59-1.59zm-5.13 9.61q-1.13 0-1.96-.49a3.3 3.3 0 0 1-1.28-1.38q-.45-.89-.45-2.06 0-1.18.45-2.07a3.3 3.3 0 0 1 1.28-1.39q.83-.49 1.96-.49.66 0 1.22.17t1 .49.73.78.41 1.03l-1.8.36q-.06-.3-.2-.54a1.5 1.5 0 0 0-.33-.4 1.3 1.3 0 0 0-.44-.26 1.6 1.6 0 0 0-.56-.09q-.58 0-.97.31t-.59.86q-.2.54-.2 1.24t.2 1.24.59.86q.39.31.97.31.32 0 .57-.09.26-.09.46-.27a1.6 1.6 0 0 0 .34-.42q.14-.25.2-.56l1.79.35q-.12.6-.4 1.06t-.73.79a3.3 3.3 0 0 1-1 .51q-.56.17-1.23.17m-8.29-.02q-1.16 0-2-.48a3.26 3.26 0 0 1-1.29-1.37q-.45-.88-.45-2.08 0-1.18.44-2.06a3.4 3.4 0 0 1 1.26-1.39q.82-.5 1.93-.5.73 0 1.36.23.64.23 1.13.71.49.47.77 1.2t.28 1.72v.57h-6.34v-1.25h5.39l-.9.35q0-.62-.19-1.08a1.54 1.54 0 0 0-.57-.72q-.37-.26-.93-.26-.55 0-.94.26t-.59.7-.2.99v.88q0 .69.23 1.17.24.47.66.71t.98.24q.37 0 .68-.11t.53-.31q.22-.21.34-.52l1.75.34q-.18.62-.64 1.09-.45.46-1.13.73-.68.25-1.54.25m-4.67-7.8v1.48h-4.44V9.36zm-3.38-1.82h1.92v7.27q0 .38.17.57t.56.19q.12 0 .32-.03.21-.03.32-.06l.29 1.46q-.31.1-.64.13a5 5 0 0 1-.62.04q-1.13 0-1.73-.55-.59-.56-.59-1.59zm-5.19 9.61q-1.16 0-2-.48a3.26 3.26 0 0 1-1.29-1.37q-.45-.88-.45-2.08 0-1.18.44-2.06A3.4 3.4 0 0 1 88 9.77q.82-.5 1.93-.5.72 0 1.36.23t1.14.71q.49.47.77 1.2t.28 1.72v.57h-6.34v-1.25h5.39l-.9.35a2.8 2.8 0 0 0-.19-1.08 1.55 1.55 0 0 0-.57-.72q-.37-.26-.93-.26-.55 0-.94.26t-.59.7-.2.99v.88q0 .69.23 1.17.24.47.66.71t.98.24q.37 0 .68-.11t.53-.31a1.4 1.4 0 0 0 .34-.52l1.75.34q-.18.62-.64 1.09-.45.46-1.13.73-.68.25-1.54.25M80.08 17h-2.6v-1.69H80q1.02 0 1.71-.37t1.03-1.12q.35-.76.35-1.91t-.35-1.9a2.32 2.32 0 0 0-1.02-1.12q-.68-.37-1.69-.37h-2.61v-1.7h2.71q1.52 0 2.62.61a4.1 4.1 0 0 1 1.69 1.75q.6 1.14.6 2.73t-.59 2.74a4.1 4.1 0 0 1-1.7 1.76q-1.12.59-2.67.59M78.53 6.81V17h-1.96V6.81zM67.1 17.13a2.9 2.9 0 0 1-1.6-.46q-.71-.46-1.12-1.33-.41-.88-.41-2.15 0-1.29.42-2.17.42-.87 1.13-1.32a2.9 2.9 0 0 1 1.57-.44q.66 0 1.09.23.43.22.69.54.27.32.4.61h.07V6.81h1.92V17h-1.89v-1.22h-.1a2.8 2.8 0 0 1-.4.61q-.27.31-.7.53-.43.21-1.07.21m.56-1.55q.55 0 .94-.3.38-.3.58-.84.21-.54.21-1.25 0-.72-.2-1.25t-.59-.83q-.38-.29-.94-.29-.57 0-.95.31a1.85 1.85 0 0 0-.58.83 3.6 3.6 0 0 0-.19 1.22q0 .69.19 1.23.2.54.58.85.39.31.95.31M58.98 17V9.36h1.87v1.31h.08q.2-.68.71-1.05a1.93 1.93 0 0 1 1.16-.36q.15 0 .34.02.18.01.32.04v1.74a2 2 0 0 0-.38-.07 5 5 0 0 0-.48-.03q-.48 0-.86.21a1.5 1.5 0 0 0-.6.57 1.65 1.65 0 0 0-.21.85V17zm-5.98.13a2.9 2.9 0 0 1-1.59-.46q-.7-.46-1.12-1.33-.41-.88-.41-2.15 0-1.29.42-2.17.42-.87 1.14-1.32a2.9 2.9 0 0 1 1.58-.44q.66 0 1.09.23.43.22.69.54t.4.61h.08V9.36h1.91V17h-1.9v-1.22h-.08a2.6 2.6 0 0 1-.41.61q-.27.32-.7.53t-1.08.21m.57-1.55q.56 0 .94-.3t.58-.84q.21-.54.21-1.25 0-.72-.2-1.25t-.58-.83-.94-.29q-.57 0-.96.3a1.85 1.85 0 0 0-.58.83 3.6 3.6 0 0 0-.19 1.23q0 .69.2 1.23t.58.85q.39.31.95.31m-9.43 1.53q-.79 0-1.39-.34a2.34 2.34 0 0 1-.92-.98q-.33-.65-.33-1.55V9.37h1.93v4.54q0 .75.38 1.16t1.05.42q.46 0 .81-.19.35-.2.55-.57t.2-.9V9.38h1.93V17h-1.82l-.02-1.9h.12q-.31.98-.93 1.49t-1.56.51m-8.95.04q-1.29 0-2.32-.64-1.02-.63-1.63-1.8-.6-1.17-.6-2.77 0-1.65.62-2.82t1.68-1.8q1.07-.63 2.41-.63.85 0 1.58.25.74.25 1.31.7.57.46.94 1.09a3.8 3.8 0 0 1 .49 1.37h-2.01a2.3 2.3 0 0 0-.32-.69 2 2 0 0 0-.5-.52 2 2 0 0 0-.66-.33 2.6 2.6 0 0 0-.81-.12q-.81 0-1.43.4T33 10.01q-.35.77-.35 1.89 0 1.11.35 1.89t.98 1.19q.64.4 1.48.4.76 0 1.3-.29a2 2 0 0 0 .83-.83q.29-.55.29-1.29h.42v.85q0 .66-.16 1.26t-.53 1.06q-.35.47-.95.73-.59.27-1.45.27m3.24-.14-.26-2.43v-1.43H35.6v-1.52h4.19V17z\"/>\n</svg>\n";
function $f5375db4b0eca8fb$export$bf5ca9fb70f56bb5(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Guard Detect' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $9b7a1b046861a04a$export$f827d3c5a9c3f644), {
        svg: $f5375db4b0eca8fb$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::9271fe2e99ed03180fc112676167f42e>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
var $3fde30457b2fb8db$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M5.49 10.87h13.02c.374 0 .574-.2.574-.574V5.907c0-.374-.2-.574-.574-.574h-2.744c-.374 0-.573.2-.573.574v2.22h-1.247v-2.22c0-.374-.2-.574-.574-.574h-2.743c-.374 0-.574.2-.574.574v2.22H8.807v-2.22c0-.374-.2-.574-.573-.574H5.49c-.374 0-.573.2-.573.574v4.39c0 .373.2.573.573.573m.225 3.84a8.7 8.7 0 0 1-.5-2.493c-.024-.324.126-.499.475-.499h12.62c.349 0 .498.15.498.449a8.2 8.2 0 0 1-.523 2.544c-.15.399-.375.573-.799.573H6.513c-.424 0-.649-.174-.798-.573m11.547 2.07C16.065 18.253 14.095 19.2 12 19.2s-4.116-.948-5.288-2.42c-.299-.398-.15-.648.15-.648h10.275c.3 0 .45.25.125.649\"/>\n</svg>\n";
function $3fde30457b2fb8db$export$3f95fcfdc25a741d(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Guard' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $9b5b994dd561b600$export$be58b4326e23250f), {
        svg: $3fde30457b2fb8db$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::db6984f13fa8a1f65e3a27814935822a>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $5e873dad6b32a772$var$svg = "<svg height=\"100%\" viewBox=\"0 0 120 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M108.4 17.67c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V3.59h2.64v21.74zm-17.8-9.04v9.05H96.7V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.67-5.43 3.93m-17.86 1.37c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-27.42-6.34V10h2.64v9.26c0 2.76 1.1 3.99 3.62 3.99 2.45 0 4.14-1.62 4.14-4.72V10h2.64v15.33h-2.64v-2.51c-.98 1.81-2.79 2.82-4.84 2.82-3.53 0-5.55-2.42-5.55-6.65m-3.98 5.21c-1.59.95-4.54 1.44-6.81 1.44-6.93 0-10.67-4.23-10.67-10.33 0-6.56 4.26-10.46 11.44-10.46 1.6 0 3.47.18 5.24.8v2.76c-1.53-.61-3.34-.89-5.21-.89-5.98 0-8.71 2.98-8.71 7.73 0 4.66 2.76 7.76 8.56 7.76.95 0 2.27-.09 3.4-.43v-5.61H50.8v-2.64h7.91z\"/>\n    <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M8.188 14.644h15.623c.449 0 .688-.24.688-.688V8.688c0-.449-.24-.688-.688-.688h-3.292c-.45 0-.689.24-.689.688v2.664h-1.496V8.688c0-.449-.24-.688-.688-.688h-3.293c-.448 0-.688.24-.688.688v2.664H12.17V8.688c0-.449-.24-.688-.689-.688H8.188c-.449 0-.688.24-.688.688v5.268c0 .449.24.688.688.688m.27 4.609a10.4 10.4 0 0 1-.599-2.993c-.03-.389.15-.598.569-.598H23.57c.42 0 .599.18.599.538q-.09 1.662-.629 3.053c-.18.479-.448.688-.957.688H9.415c-.508 0-.778-.21-.957-.688m13.856 2.484c-1.436 1.766-3.8 2.903-6.314 2.903s-4.939-1.137-6.345-2.903c-.36-.479-.18-.778.18-.778h12.33c.359 0 .538.3.15.778\"/>\n</svg>\n";
function $5e873dad6b32a772$export$2b896c4d595a4331(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Guard' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $9b7a1b046861a04a$export$f827d3c5a9c3f644), {
        svg: $5e873dad6b32a772$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::978838b36f6aa3744f039bfb1c56d79c>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
var $dfcee9eb5660984d$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M5.875 10.688v7.437h4.375V13.75h3.5v4.375h4.375v-7.437L12 5z\"/>\n</svg>\n";
function $dfcee9eb5660984d$export$92c8767b874048d(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Home' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $9b5b994dd561b600$export$be58b4326e23250f), {
        svg: $dfcee9eb5660984d$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::5bd026d27282a90cddcd834d02167bda>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $6d94cf131d4d8744$var$svg = "<svg height=\"100%\" viewBox=\"0 0 121 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M113.57 12.09c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zM93.3 16.81v8.53h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 2.61 0 4.39 1.32 5.15 3.74.86-2.36 2.91-3.74 5.46-3.74 3.43 0 5.34 2.33 5.34 6.66v8.99h-2.64v-8.52c0-3.16-1.1-4.72-3.62-4.72-2.45 0-4.14 1.63-4.14 4.72m-23.33 8.81c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49M56.41 5.19h2.76v20.15h-2.76v-8.71H45.8v8.71h-2.76V5.19h2.76v8.8h10.61z\"/>\n    <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M7.25 14.125V24.75h6.25V18.5h5v6.25h6.25V14.125L16 6z\"/>\n</svg>\n";
function $6d94cf131d4d8744$export$8b6b7f1b1b2367d3(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Home' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $9b7a1b046861a04a$export$f827d3c5a9c3f644), {
        svg: $6d94cf131d4d8744$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::983ad8fa518509adc011dda491e7edb4>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
var $21530e0c9bf76790$var$svg = "<svg height=\"100%\" viewBox=\"0 0 32 32\">\n    <g clip-path=\"url(#clip0_95164_16219)\">\n        <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n        <g clip-path=\"url(#clip1_95164_16219)\">\n            <path fill=\"var(--icon-color, #101214)\" fill-rule=\"evenodd\" d=\"M9 25.333V6.667h14v18.666h-5.25V21.25h-3.5v4.083zm3.5-14.583h2.333V9H12.5zm4.667 0H19.5V9h-2.333zm-2.334 4.083H12.5v-1.75h2.333zM12.5 18.916h2.333v-1.75H12.5zm7-4.083h-2.333v-1.75H19.5zm-2.333 4.083H19.5v-1.75h-2.333z\" clip-rule=\"evenodd\"/>\n        </g>\n    </g>\n    <defs>\n        <clipPath id=\"clip0_95164_16219\">\n            <path fill=\"var(--icon-color, white)\" d=\"M0 0h32v32H0z\"/>\n        </clipPath>\n        <clipPath id=\"clip1_95164_16219\">\n            <path fill=\"var(--icon-color, white)\" d=\"M2 2h28v28H2z\"/>\n        </clipPath>\n    </defs>\n</svg>\n";
function $21530e0c9bf76790$export$80b8b269d8b5014e(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Hub' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $9b5b994dd561b600$export$be58b4326e23250f), {
        svg: $21530e0c9bf76790$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::525e888921a2eb67ac3477c558f06bd0>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $25e04bc358978974$var$svg = "<svg height=\"100%\" viewBox=\"0 0 95 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M91.61 17.67c0-3.68-1.47-5.52-4.2-5.52-2.36 0-4.48 1.5-4.48 4.91v1.23c0 3.4 1.93 4.91 4.17 4.91 2.98 0 4.51-1.96 4.51-5.52m-3.8 7.97c-2.24 0-3.96-1.01-4.88-3v2.7h-2.64V3.59h2.64v9.17c.98-2.02 2.82-3.07 5.18-3.07 4.08 0 6.13 3.47 6.13 7.97 0 4.32-2.15 7.97-6.44 7.97m-24.52-6.64V10h2.64v9.26c0 2.76 1.1 3.99 3.62 3.99 2.45 0 4.14-1.62 4.14-4.72V10h2.64v15.33h-2.64v-2.51c-.98 1.81-2.79 2.82-4.84 2.82-3.53 0-5.55-2.42-5.55-6.65M56.4 5.19h2.76v20.15H56.4v-8.71H45.79v8.71h-2.76V5.19h2.76v8.8H56.4z\"/>\n    <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, #101214)\" fill-rule=\"evenodd\" d=\"M9 25.333V6.667h14v18.666h-5.25V21.25h-3.5v4.083zm3.5-14.583h2.333V9H12.5zm4.667 0H19.5V9h-2.333zm-2.334 4.083H12.5v-1.75h2.333zM12.5 18.916h2.333v-1.75H12.5zm7-4.083h-2.333v-1.75H19.5zm-2.333 4.083H19.5v-1.75h-2.333z\" clip-rule=\"evenodd\"/>\n</svg>\n";
function $25e04bc358978974$export$7a38180641471460(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Hub' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $9b7a1b046861a04a$export$f827d3c5a9c3f644), {
        svg: $25e04bc358978974$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f238f469c20433ab8ed5a1e4abeae5fe>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
var $0016866d85e6e365$var$svg = "<svg height=\"100%\" viewBox=\"0 0 55 55\">\n    <path fill=\"var(--tile-color,#1868db)\" d=\"M24.519.844a6.3 6.3 0 0 1 6.3 0l18.37 10.601a6.3 6.3 0 0 1 3.15 5.454V38.1c0 2.25-1.2 4.33-3.15 5.454l-18.37 10.601a6.3 6.3 0 0 1-6.3 0l-18.37-10.6a6.3 6.3 0 0 1-3.15-5.454V16.9c0-2.25 1.2-4.33 3.15-5.454z\"/>\n    <path fill=\"var(--icon-color, white)\" d=\"M20.71 34.657h-2.705C13.926 34.657 11 32.16 11 28.5h14.543c.754 0 1.241.536 1.241 1.294v14.634c-3.635 0-6.074-2.944-6.074-7.05zm7.183-7.272h-2.705c-4.079 0-7.005-2.454-7.005-6.113h14.542c.754 0 1.286.491 1.286 1.25v14.634c-3.635 0-6.118-2.945-6.118-7.05zm7.227-7.228h-2.705c-4.079 0-7.005-2.498-7.005-6.157h14.543c.753 0 1.241.535 1.241 1.25v14.633c-3.636 0-6.074-2.944-6.074-7.049z\"/>\n</svg>\n";
function $0016866d85e6e365$export$b12fec207e8537a8(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Jira Coding Agent' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $9b5b994dd561b600$export$be58b4326e23250f), {
        svg: $0016866d85e6e365$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::491a8713d140a4025bae404f0574bce7>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
var $63d5863d2ed13516$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color, white)\" d=\"M6 .5h12A5.5 5.5 0 0 1 23.5 6v12a5.5 5.5 0 0 1-5.5 5.5H6A5.5 5.5 0 0 1 .5 18V6A5.5 5.5 0 0 1 6 .5\"/>\n    <path fill=\"none\" stroke=\"var(--border-color, #dddee1)\" d=\"M6 .5h12A5.5 5.5 0 0 1 23.5 6v12a5.5 5.5 0 0 1-5.5 5.5H6A5.5 5.5 0 0 1 .5 18V6A5.5 5.5 0 0 1 6 .5Z\"/>\n    <path fill=\"var(--icon-color, #1868db)\" d=\"M8.974 15.523H7.62c-2.04 0-3.502-1.249-3.502-3.078h7.271c.377 0 .62.268.62.647v7.317c-1.817 0-3.036-1.472-3.036-3.525zm3.591-3.636h-1.352c-2.04 0-3.503-1.227-3.503-3.056h7.272c.376 0 .642.245.642.625v7.317c-1.817 0-3.059-1.473-3.059-3.525zm3.614-3.614h-1.353c-2.04 0-3.502-1.249-3.502-3.078h7.271c.377 0 .62.268.62.624v7.318c-1.817 0-3.036-1.473-3.036-3.525z\"/>\n</svg>\n";
function $63d5863d2ed13516$export$f8455b5667a3ee0c(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Jira Data Center' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $9b5b994dd561b600$export$be58b4326e23250f), {
        svg: $63d5863d2ed13516$var$svg,
        label: label,
        type: "data-center",
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::97902fae9a5e66613a7ad8ae8ea2e75d>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $ba7c91ea510df47c$var$svg = "<svg height=\"100%\" viewBox=\"0 0 83 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M71.02 17.67c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.98 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.47-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-17.79-9.04v9.05h-2.58V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.67-5.43 3.93M52.22 5.95c0-1.17.77-1.84 1.84-1.84s1.84.67 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zm-6.42-5.95V5.19h2.76V19.2c0 3.71-1.63 6.26-5.43 6.26-1.44 0-2.55-.24-3.31-.52v-2.67c.83.34 1.84.52 2.85.52 2.33 0 3.13-1.41 3.13-3.4\"/>\n    <path fill=\"var(--tile-color, white)\" d=\"M8 .667h16A7.333 7.333 0 0 1 31.333 8v16A7.333 7.333 0 0 1 24 31.333H8A7.333 7.333 0 0 1 .667 24V8A7.333 7.333 0 0 1 8 .667\"/>\n    <path fill=\"none\" stroke=\"var(--border-color, #dddee1)\" stroke-width=\"1.333\" d=\"M8 .667h16A7.333 7.333 0 0 1 31.333 8v16A7.333 7.333 0 0 1 24 31.333H8A7.333 7.333 0 0 1 .667 24V8A7.333 7.333 0 0 1 8 .667Z\"/>\n    <path fill=\"var(--icon-color, #1868db)\" d=\"M11.965 20.699h-1.803c-2.72 0-4.67-1.666-4.67-4.105h9.695c.502 0 .827.357.827.863v9.756c-2.424 0-4.05-1.963-4.05-4.7zm4.788-4.848H14.95c-2.72 0-4.67-1.636-4.67-4.075h9.695c.502 0 .857.327.857.832v9.756c-2.424 0-4.079-1.963-4.079-4.699zm4.818-4.819h-1.803c-2.72 0-4.67-1.666-4.67-4.105h9.695c.503 0 .828.357.828.833v9.756c-2.424 0-4.05-1.963-4.05-4.7z\"/>\n</svg>\n";
function $ba7c91ea510df47c$export$3224b07bc93ef23e(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Jira Data Center' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $9b7a1b046861a04a$export$f827d3c5a9c3f644), {
        svg: $ba7c91ea510df47c$var$svg,
        label: label,
        type: "data-center",
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3b3ec3c590ed89c431e0f979daa3e25e>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
var $2d211468a13d2fb7$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#c97cf4)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M13.467 4.882a9.47 9.47 0 0 0 5.422 0c.159-.035.265.07.23.229-.513 1.85-.513 3.558 0 5.408.035.14-.072.264-.23.211a10.1 10.1 0 0 0-5.422 0c-.142.053-.265-.07-.212-.211.476-1.85.476-3.559 0-5.408-.053-.159.07-.264.212-.23m.724 6.553v.3c0 1.39-.972 2.412-2.173 2.412a2.153 2.153 0 0 1-2.154-2.166c0-1.198.971-2.15 2.331-2.15h.353V5.62c-.176-.017-.353-.017-.53-.017a6.387 6.387 0 0 0-6.393 6.394 6.37 6.37 0 0 0 6.393 6.377c3.533 0 6.411-2.854 6.411-6.377v-.563z\"/>\n</svg>\n";
var $2d211468a13d2fb7$var$customThemeSvg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--themed-icon-color, currentcolor)\" d=\"M18 0a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6V6a6 6 0 0 1 6-6zm-5.981 5.604a6.387 6.387 0 0 0-6.394 6.394 6.373 6.373 0 0 0 6.394 6.377c3.532 0 6.41-2.854 6.41-6.377v-.563H14.19v.3c0 1.39-.97 2.412-2.171 2.413a2.154 2.154 0 0 1-2.156-2.168c0-1.197.973-2.148 2.332-2.148h.353v-4.21c-.177-.018-.353-.018-.53-.018m6.87-.722a9.47 9.47 0 0 1-5.422 0c-.141-.035-.265.07-.212.228.477 1.85.477 3.559 0 5.409-.053.14.07.264.212.211a10.1 10.1 0 0 1 5.422 0c.159.053.265-.07.23-.211-.513-1.85-.513-3.56 0-5.409.034-.158-.072-.263-.23-.228\"/>\n</svg>\n";
function $2d211468a13d2fb7$export$21bfbeb62fdcce8d(_ref) {
    var iconColor = _ref.iconColor, size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Jira Product Discovery' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $9b5b994dd561b600$export$be58b4326e23250f), {
        svg: $2d211468a13d2fb7$var$svg,
        customThemeSvg: $2d211468a13d2fb7$var$customThemeSvg,
        iconColor: iconColor,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c8e2d27dec964efc37c6ed5782c3fe57>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $d84bc94694df07a6$var$svg = "<svg height=\"100%\" viewBox=\"0 0 327 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M317.88 24.35h-1.72L310.62 10h2.82l4.91 13.13 4.9-13.13h2.82l-5.8 14.84c-1.72 4.39-2.7 6.65-6.59 6.65-1.32 0-2.06-.12-2.82-.43v-2.27c.89.28 1.9.37 2.67.37 2.15 0 3.1-1.47 4.36-4.82m-13.25-8.05v9.05h-2.58V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.67-5.43 3.93m-12.47-4.21c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-19.72.6h-3.53L268.87 10h2.76l4.97 13.1 4.93-13.1h2.76zm-17.46.31c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49m-9.39 10.42v2.36c-.92.49-2.33.71-3.74.71-5.46 0-8-3.31-8-8 0-4.63 2.55-7.94 8-7.94 1.38 0 2.45.18 3.65.74v2.45c-.98-.46-2.02-.74-3.46-.74-3.99 0-5.61 2.51-5.61 5.49s1.66 5.49 5.67 5.49c1.56 0 2.55-.21 3.5-.55m-13.88-1.42c0 2.55-1.66 4.48-5.76 4.48-2.3 0-4.17-.52-5.34-1.13v-2.79c1.32.77 3.53 1.5 5.46 1.5 2.02 0 3.07-.83 3.07-2.02 0-1.16-.89-1.84-3.8-2.54-3.4-.83-4.85-2.15-4.85-4.66 0-2.67 2.06-4.29 5.55-4.29 1.99 0 3.8.49 4.94 1.1v2.73c-1.84-.92-3.34-1.41-4.97-1.41-1.93 0-2.97.68-2.97 1.87 0 1.07.74 1.75 3.56 2.42 3.4.83 5.12 2.09 5.12 4.75m-17.7-15.22c0-1.16.77-1.84 1.84-1.84s1.84.68 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zM207.68 7.82h-4.54v14.87h4.69c4.6 0 6.9-2.42 6.9-7.3 0-4.91-2.18-7.57-7.05-7.57m-7.3 17.51V5.19h7.42c6.53 0 9.69 4.08 9.69 10.12 0 6.1-3.19 10.03-9.69 10.03zm-13.41-4.75c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55c-.46.12-.98.25-1.78.25-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zm-6.66 1.99v2.36c-.92.49-2.33.71-3.74.71-5.46 0-8-3.31-8-8 0-4.63 2.55-7.94 8-7.94 1.38 0 2.45.18 3.65.74v2.45c-.98-.46-2.02-.74-3.46-.74-3.99 0-5.61 2.51-5.61 5.49s1.66 5.49 5.67 5.49c1.56 0 2.55-.21 3.5-.55m-27.86-3.59V10h2.64v9.26c0 2.76 1.1 3.99 3.62 3.99 2.45 0 4.14-1.62 4.14-4.72V10h2.64v15.33h-2.64v-2.51c-.98 1.81-2.79 2.82-4.84 2.82-3.53 0-5.55-2.42-5.55-6.65m-14.99-1.32c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V3.59h2.64v21.74zm-20.7.31c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49m-13.78 4.14v9.05h-2.58V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.67-5.43 3.93m-5-4.4c0 4.39-2.45 6.84-7.48 6.84h-4.02v6.59h-2.76V5.19h6.78c5.03 0 7.48 2.58 7.48 6.72m-7.79 4.2c3.56.12 4.94-1.56 4.94-4.14 0-2.45-1.38-4.14-4.94-4.14h-3.71v8.28zm-27.87 1.56c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.98 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-17.79-9.04v9.05h-2.58V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.67-5.43 3.93M52.22 5.95c0-1.16.77-1.84 1.84-1.84s1.84.68 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zm-6.42-5.95V5.19h2.76V19.2c0 3.71-1.63 6.26-5.43 6.26-1.44 0-2.55-.24-3.31-.52v-2.67c.83.34 1.84.52 2.85.52 2.33 0 3.13-1.41 3.13-3.4\"/>\n    <path fill=\"var(--tile-color,#c97cf4)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M17.448 6.967c2.544.746 5.113.746 7.656 0 .225-.05.375.1.325.323-.724 2.612-.724 5.025 0 7.637.05.199-.1.373-.325.298a14.3 14.3 0 0 0-7.656 0c-.2.075-.374-.1-.3-.298.674-2.612.674-5.025 0-7.637-.074-.223.1-.373.3-.323m1.023 9.253v.423c0 1.965-1.372 3.408-3.068 3.408a3.04 3.04 0 0 1-3.043-3.06c0-1.691 1.372-3.034 3.292-3.034h.5V8.012c-.25-.025-.5-.025-.749-.025a9.02 9.02 0 0 0-9.028 9.03c0 4.999 4.04 9.004 9.028 9.004s9.053-4.03 9.053-9.005v-.796z\"/>\n</svg>\n";
function $d84bc94694df07a6$export$602140a6a10b02bf(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Jira Product Discovery' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $9b7a1b046861a04a$export$f827d3c5a9c3f644), {
        svg: $d84bc94694df07a6$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e66626867983712448eb161ec2993046>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
var $7a89adb1474ccf1d$var$svg = "<svg height=\"100%\" viewBox=\"0 0 25 24\">\n    <path fill=\"var(--tile-color, white)\" d=\"M6.417.5h12a5.5 5.5 0 0 1 5.5 5.5v12a5.5 5.5 0 0 1-5.5 5.5h-12a5.5 5.5 0 0 1-5.5-5.5V6a5.5 5.5 0 0 1 5.5-5.5\"/>\n    <path fill=\"none\" stroke=\"var(--border-color, #dddee1)\" d=\"M6.417.5h12a5.5 5.5 0 0 1 5.5 5.5v12a5.5 5.5 0 0 1-5.5 5.5h-12a5.5 5.5 0 0 1-5.5-5.5V6a5.5 5.5 0 0 1 5.5-5.5Z\"/>\n    <path fill=\"var(--icon-color, #1868db)\" d=\"M14.117 10.203h4.464c.67 0 .899.637.49 1.144l-6.98 8.616c-2.257-1.798-2.044-4.643-.393-6.72zm-3.45 3.433H6.205c-.67 0-.899-.638-.49-1.144l6.981-8.617c2.256 1.799 2.011 4.61.376 6.704z\"/>\n</svg>\n";
function $7a89adb1474ccf1d$export$65fae0eaf343f2ca(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Jira Service Management Data Center' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $9b5b994dd561b600$export$be58b4326e23250f), {
        svg: $7a89adb1474ccf1d$var$svg,
        label: label,
        type: "data-center",
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::90317e51e9a9185b7a39157502e3ebed>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $3e1ff0d7c502f7bb$var$svg = "<svg height=\"100%\" viewBox=\"0 0 372 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M367.07 20.58c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55c-.46.12-.98.25-1.78.25-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zm-7.32-4.23v8.99h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 3.53 0 5.55 2.42 5.55 6.66m-22.92-4.27c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-26.16-7.92v8.53h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 2.61 0 4.39 1.32 5.15 3.74.86-2.36 2.91-3.74 5.46-3.74 3.43 0 5.34 2.33 5.34 6.66v8.99h-2.64v-8.52c0-3.16-1.1-4.72-3.62-4.72-2.45 0-4.14 1.63-4.14 4.72m-22.92-4.74c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2H289.2c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-18.64-.62v-1.53c-.98 2.02-2.82 3.07-5.18 3.07-4.05 0-6.07-3.46-6.07-7.97 0-4.32 2.12-7.97 6.38-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.58v13.95c0 4.51-2.12 7.54-7.6 7.54-2.58 0-3.99-.34-5.46-.83v-2.58c1.69.55 3.44.92 5.34.92 3.83 0 5.15-2.05 5.15-4.91m-8.68-6.44c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m-16.97.03c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-14.07-8.98v8.99h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 3.53 0 5.55 2.42 5.55 6.66m-28.33 1.31c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-31.44-11.01-2.76-7.48v18.49h-2.76V5.19h4.78l4.57 11.56 1.87 5.55 1.87-5.55 4.6-11.56h4.45v20.15h-2.76V7.06l-2.36 7.27-4.45 11.01h-2.67zm-21.52-2.23c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.05 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-15.09-2.16v2.36c-.92.49-2.33.71-3.74.71-5.46 0-8-3.31-8-8 0-4.63 2.55-7.94 8-7.94 1.38 0 2.45.18 3.65.74v2.45c-.98-.46-2.02-.74-3.46-.74-3.99 0-5.61 2.51-5.61 5.49s1.66 5.49 5.67 5.49c1.56 0 2.55-.21 3.5-.55M150.12 5.95c0-1.16.77-1.84 1.84-1.84s1.84.68 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zm-8.23 0h-3.53L132.91 10h2.76l4.97 13.1 4.93-13.1h2.76zm-15.45-9.04v9.05h-2.58V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.68-5.43 3.93m-12.47-4.21c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-15.33-4.95c0 3.5-2.08 5.86-7.08 5.86-3.89 0-5.7-.77-7.27-1.56v-2.82c1.87.98 4.75 1.69 7.42 1.69 3.04 0 4.17-1.2 4.17-2.97s-1.1-2.73-4.94-3.65c-4.54-1.1-6.56-2.67-6.56-5.98 0-3.13 2.39-5.46 7.08-5.46 2.91 0 4.78.71 6.16 1.47v2.76c-2.02-1.17-4.2-1.53-6.29-1.53-2.64 0-4.2.92-4.2 2.76 0 1.66 1.29 2.48 4.84 3.37 4.26 1.07 6.66 2.45 6.66 6.07m-33.99-2.12c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-17.79-9.04v9.05h-2.58V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.68-5.43 3.93M52.22 5.95c0-1.16.77-1.84 1.84-1.84s1.84.68 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zm-6.42-5.95V5.19h2.76V19.2c0 3.71-1.63 6.26-5.43 6.26-1.44 0-2.55-.24-3.31-.52v-2.67c.83.34 1.84.52 2.85.52 2.33 0 3.13-1.41 3.13-3.4\"/>\n    <path fill=\"var(--tile-color, white)\" d=\"M8 .667h16A7.333 7.333 0 0 1 31.333 8v16A7.333 7.333 0 0 1 24 31.333H8A7.333 7.333 0 0 1 .667 24V8A7.333 7.333 0 0 1 8 .667\"/>\n    <path fill=\"none\" stroke=\"var(--border-color, #dddee1)\" stroke-width=\"1.333\" d=\"M8 .667h16A7.333 7.333 0 0 1 31.333 8v16A7.333 7.333 0 0 1 24 31.333H8A7.333 7.333 0 0 1 .667 24V8A7.333 7.333 0 0 1 8 .667Z\"/>\n    <path fill=\"var(--icon-color, #1868db)\" d=\"M18.268 13.604h5.95c.895 0 1.2.85.655 1.526l-9.308 11.487c-3.008-2.397-2.725-6.19-.524-8.959zm-4.6 4.577h-5.95c-.895 0-1.2-.85-.655-1.526l9.308-11.488c3.009 2.398 2.682 6.148.502 8.938z\"/>\n</svg>\n";
function $3e1ff0d7c502f7bb$export$f64bc7a7f04428d0(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Jira Service Management Data Center' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $9b7a1b046861a04a$export$f827d3c5a9c3f644), {
        svg: $3e1ff0d7c502f7bb$var$svg,
        label: label,
        type: "data-center",
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::cedb5d68059644a06a093aa74d8e3cc5>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
var $e2db2120f58c7778$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#ffc716)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M13.744 10.156h4.578c.688 0 .922.654.503 1.174l-7.16 8.837c-2.314-1.845-2.096-4.763-.402-6.892zm-3.538 3.521H5.63c-.688 0-.923-.654-.504-1.173l7.16-8.837c2.315 1.844 2.063 4.728.386 6.875z\"/>\n</svg>\n";
var $e2db2120f58c7778$var$customThemeSvg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--themed-icon-color, currentcolor)\" d=\"M18 0a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6V6a6 6 0 0 1 6-6zm-4.256 10.156-2.481 3.12c-1.694 2.129-1.912 5.047.402 6.891l7.16-8.837c.42-.52.185-1.174-.503-1.174zm-8.619 2.348c-.419.52-.183 1.174.504 1.174h4.577l2.465-3.136c1.677-2.146 1.928-5.03-.386-6.875z\"/>\n</svg>\n";
function $e2db2120f58c7778$export$3c6158790f5e01c4(_ref) {
    var iconColor = _ref.iconColor, size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Jira Service Management' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $9b5b994dd561b600$export$be58b4326e23250f), {
        svg: $e2db2120f58c7778$var$svg,
        customThemeSvg: $e2db2120f58c7778$var$customThemeSvg,
        iconColor: iconColor,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::bcf1b6bc0c0712320d6fbdb868500ebb>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $105e244f4782482d$var$svg = "<svg height=\"100%\" viewBox=\"0 0 372 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M367.07 20.58c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55a6.3 6.3 0 0 1-1.78.25c-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zm-7.32-4.23v8.99h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 3.53 0 5.55 2.42 5.55 6.66m-22.92-4.27c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-26.16-7.92v8.53h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 2.61 0 4.39 1.32 5.15 3.74.86-2.36 2.91-3.74 5.46-3.74 3.43 0 5.34 2.33 5.34 6.66v8.99h-2.64v-8.52c0-3.16-1.1-4.72-3.62-4.72-2.45 0-4.14 1.63-4.14 4.72m-22.92-4.74c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2H289.2c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-18.64-.62v-1.53c-.98 2.02-2.82 3.07-5.18 3.07-4.05 0-6.07-3.46-6.07-7.97 0-4.32 2.12-7.97 6.38-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.58v13.95c0 4.51-2.12 7.54-7.6 7.54-2.58 0-3.99-.34-5.46-.83v-2.58c1.69.55 3.44.92 5.34.92 3.83 0 5.15-2.05 5.15-4.91m-8.68-6.44c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m-16.97.03c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-14.07-8.98v8.99h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 3.53 0 5.55 2.42 5.55 6.66m-28.33 1.31c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-31.44-11.01-2.76-7.48v18.49h-2.76V5.19h4.78l4.57 11.56 1.87 5.55 1.87-5.55 4.6-11.56h4.45v20.15h-2.76V7.06l-2.36 7.27-4.45 11.01h-2.67zm-21.52-2.23c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.05 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-15.09-2.16v2.36c-.92.49-2.33.71-3.74.71-5.46 0-8-3.31-8-8 0-4.63 2.55-7.94 8-7.94 1.38 0 2.45.18 3.65.74v2.45c-.98-.46-2.02-.74-3.46-.74-3.99 0-5.61 2.51-5.61 5.49s1.66 5.49 5.67 5.49c1.56 0 2.55-.21 3.5-.55M150.12 5.95c0-1.17.77-1.84 1.84-1.84s1.84.67 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zm-8.23 0h-3.53L132.91 10h2.76l4.97 13.1 4.93-13.1h2.76zm-15.45-9.04v9.05h-2.58V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.67-5.43 3.93m-12.47-4.21c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-15.33-4.95c0 3.5-2.08 5.86-7.08 5.86-3.89 0-5.7-.77-7.27-1.56v-2.82c1.87.98 4.75 1.69 7.42 1.69 3.04 0 4.17-1.2 4.17-2.97 0-1.78-1.1-2.73-4.94-3.65-4.54-1.1-6.56-2.67-6.56-5.98 0-3.13 2.39-5.46 7.08-5.46 2.91 0 4.78.71 6.16 1.47v2.76c-2.02-1.16-4.2-1.53-6.29-1.53-2.64 0-4.2.92-4.2 2.76 0 1.66 1.29 2.48 4.84 3.37 4.26 1.07 6.66 2.45 6.66 6.07m-33.99-2.12c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.98 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-17.79-9.04v9.05h-2.58V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.67-5.43 3.93M52.22 5.95c0-1.17.77-1.84 1.84-1.84s1.84.67 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zm-6.42-5.95V5.19h2.76V19.2c0 3.71-1.63 6.26-5.43 6.26-1.44 0-2.55-.25-3.31-.52v-2.67c.83.34 1.84.52 2.85.52 2.33 0 3.13-1.41 3.13-3.4\"/>\n    <path fill=\"var(--tile-color,#ffc716)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M18.268 13.604h5.951c.894 0 1.199.85.654 1.526l-9.308 11.487c-3.008-2.397-2.725-6.19-.523-8.959zm-4.6 4.577h-5.95c-.894 0-1.2-.85-.655-1.526l9.308-11.488c3.009 2.398 2.682 6.148.502 8.938z\"/>\n</svg>\n";
function $105e244f4782482d$export$de148263c75d2bc1(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Jira Service Management' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $9b7a1b046861a04a$export$f827d3c5a9c3f644), {
        svg: $105e244f4782482d$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b225283860ba91a6c228b8f4fa0e1d39>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
var $7c1c11195d413b75$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#1868db)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, white)\" d=\"M9.051 15.434H7.734c-1.988 0-3.413-1.218-3.413-3h7.085c.367 0 .605.26.605.63v7.13c-1.772 0-2.96-1.435-2.96-3.434zm3.5-3.543h-1.318c-1.987 0-3.413-1.196-3.413-2.978h7.085c.367 0 .627.239.627.608v7.13c-1.772 0-2.981-1.435-2.981-3.434zm3.52-3.522h-1.317c-1.987 0-3.413-1.217-3.413-3h7.085c.367 0 .605.262.605.61v7.129c-1.771 0-2.96-1.435-2.96-3.434z\"/>\n</svg>\n";
var $7c1c11195d413b75$var$customThemeSvg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--themed-icon-color, currentcolor)\" d=\"M18 0a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6V6a6 6 0 0 1 6-6zM4.321 12.434c0 1.782 1.425 3 3.412 3h1.319v1.326c0 2 1.188 3.433 2.959 3.433v-7.129c0-.369-.238-.63-.605-.63zm3.5-3.52c0 1.781 1.425 2.977 3.412 2.977h1.318v1.326c0 2 1.21 3.433 2.98 3.433V9.521c0-.369-.259-.608-.626-.608zm3.52-3.544c0 1.782 1.426 3 3.413 3h1.317v1.304c0 2 1.188 3.433 2.96 3.433V5.98c0-.348-.238-.609-.605-.609z\"/>\n</svg>\n";
function $7c1c11195d413b75$export$c4b5b1f965d8b3eb(_ref) {
    var iconColor = _ref.iconColor, size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Jira' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $9b5b994dd561b600$export$be58b4326e23250f), {
        svg: $7c1c11195d413b75$var$svg,
        customThemeSvg: $7c1c11195d413b75$var$customThemeSvg,
        iconColor: iconColor,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3ed7d2f84cfdfe8bfef2a295bafed6da>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $6e34b13172a5b29b$var$svg = "<svg height=\"100%\" viewBox=\"0 0 83 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M71.02 17.67c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.98 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-17.79-9.04v9.05h-2.58V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.67-5.43 3.93M52.22 5.95c0-1.17.77-1.84 1.84-1.84s1.84.67 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zm-6.42-5.95V5.19h2.76V19.2c0 3.71-1.63 6.26-5.43 6.26-1.44 0-2.55-.25-3.31-.52v-2.67c.83.34 1.84.52 2.85.52 2.33 0 3.13-1.41 3.13-3.4\"/>\n    <path fill=\"var(--tile-color,#1868db)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, white)\" d=\"M11.965 20.698h-1.803c-2.72 0-4.67-1.666-4.67-4.105h9.695c.502 0 .827.357.827.863v9.756c-2.423 0-4.05-1.963-4.05-4.7zm4.788-4.848H14.95c-2.72 0-4.67-1.636-4.67-4.075h9.695c.503 0 .857.327.857.832v9.756c-2.424 0-4.079-1.963-4.079-4.7zm4.818-4.82h-1.803c-2.72 0-4.67-1.665-4.67-4.104h9.695c.503 0 .828.357.828.833v9.756c-2.424 0-4.05-1.963-4.05-4.7z\"/>\n</svg>\n";
function $6e34b13172a5b29b$export$bf4c5f97b468e8d6(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Jira' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $9b7a1b046861a04a$export$f827d3c5a9c3f644), {
        svg: $6e34b13172a5b29b$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::9f5d94b0d7bf822b6ab4c2ad26c21970>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $dbb0fc9f5c20d708$var$svg = "<svg height=\"100%\" viewBox=\"0 0 100 32\">\n    <path fill=\"var(--icon-color, #101214)\" d=\"M66.71 5.11c0 1.08.49 1.93 2.47 2.31 1.16.26 1.41.44 1.41.82 0 .39-.26.62-1.08.62-.95 0-2.08-.33-2.83-.77v1.75c.59.28 1.36.62 2.83.62 2.06 0 2.85-.92 2.85-2.26m0 .03c0-1.28-.67-1.88-2.59-2.29-1.05-.23-1.31-.46-1.31-.8 0-.41.39-.59 1.08-.59.85 0 1.67.26 2.47.62V3.5c-.56-.28-1.41-.49-2.41-.49-1.9 0-2.88.82-2.88 2.16m26.29-2.11v7.32h1.57V4.81l.64 1.46 2.21 4.11h1.95V3.06h-1.54v4.73l-.59-1.39-1.77-3.34zm-9.91 0h-1.7v7.32h1.7zM79.45 8.2c0-1.28-.67-1.88-2.59-2.29-1.05-.23-1.31-.46-1.31-.8 0-.41.39-.59 1.08-.59.85 0 1.67.26 2.47.62V3.47c-.56-.28-1.41-.49-2.41-.49-1.9 0-2.88.82-2.88 2.16 0 1.08.49 1.93 2.47 2.31 1.16.26 1.41.44 1.41.82s-.26.62-1.08.62c-.95 0-2.08-.33-2.83-.77v1.75c.59.28 1.36.62 2.83.62 2.03 0 2.85-.92 2.85-2.29M53.5 3.06v7.32h3.49l.54-1.59h-2.34V3.06zm-6.91 0v1.57h1.88v5.75h1.72V4.63h2.03V3.06zm-2.49 0h-2.24l-2.54 7.32h1.95l.36-1.23c.44.13.9.21 1.36.21s.93-.08 1.36-.21l.36 1.23h1.95c-.03 0-2.57-7.32-2.57-7.32m-1.13 4.75c-.33 0-.64-.05-.93-.13l.93-3.19.93 3.19c-.28.08-.59.13-.92.13m20.06-4.75H60.8l-2.57 7.32h1.95l.36-1.23c.44.13.9.21 1.36.21s.93-.08 1.36-.21l.36 1.23h1.95zM61.9 7.81c-.33 0-.64-.05-.92-.13l.93-3.19.93 3.19c-.28.08-.59.13-.92.13m27.32-4.75h-2.23l-2.54 7.32h1.95l.36-1.23c.44.13.9.21 1.36.21s.93-.08 1.36-.21l.36 1.23h1.95zm-1.11 4.75c-.33 0-.64-.05-.92-.13l.93-3.19.93 3.19a3.7 3.7 0 0 1-.92.13\"/>\n    <path fill=\"var(--tile-color,#1868db)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, white)\" d=\"M25.375 15.31H19.99l4.664-2.693-1.024-1.775-4.664 2.693 2.692-4.664-1.775-1.025-2.692 4.664V7.125h-2.048v5.385l-2.694-4.664-1.774 1.025 2.693 4.663-4.664-2.692-1.024 1.774 4.664 2.693H6.958v2.048h5.385L7.68 20.05l1.024 1.775 4.663-2.693-2.692 4.664 1.774 1.024 2.693-4.664v5.386h2.049v-5.385l2.692 4.663 1.774-1.024-2.692-4.664 4.663 2.693 1.025-1.775-4.664-2.692h5.385zm-9.208 3.81a2.797 2.797 0 1 1 0-5.594 2.797 2.797 0 0 1 0 5.593\"/>\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M39.32 27.74v-13.7h2.52v13.7zm24.13-9.31h2.4v1.14c.51-.91 1.7-1.4 2.72-1.4 1.27 0 2.29.55 2.76 1.55.74-1.14 1.72-1.55 2.95-1.55 1.72 0 3.37 1.04 3.37 3.54v6.04h-2.44v-5.53c0-1-.49-1.76-1.65-1.76-1.08 0-1.72.83-1.72 1.84v5.45h-2.49v-5.53c0-1-.51-1.76-1.65-1.76-1.1 0-1.74.81-1.74 1.84v5.45h-2.52zm-15.93 9.58c-2.83 0-4.89-2.1-4.89-4.93 0-2.78 2.05-4.93 4.89-4.93 2.85 0 4.89 2.17 4.89 4.93 0 2.8-2.05 4.93-4.89 4.93m0-7.58a2.65 2.65 0 0 0-2.65 2.65 2.65 2.65 0 0 0 2.65 2.65c1.46 0 2.65-1.19 2.65-2.65a2.65 2.65 0 0 0-2.65-2.65m10.26 7.58c-2.83 0-4.89-2.1-4.89-4.93 0-2.78 2.05-4.93 4.89-4.93 2.85 0 4.89 2.17 4.89 4.93 0 2.8-2.06 4.93-4.89 4.93m0-7.61a2.69 2.69 0 0 0-2.68 2.68 2.69 2.69 0 0 0 2.68 2.68 2.69 2.69 0 0 0 2.68-2.68 2.69 2.69 0 0 0-2.68-2.68\"/>\n</svg>\n";
function $dbb0fc9f5c20d708$export$68d7391318cdef11(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Loom Attribution' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $9b7a1b046861a04a$export$f827d3c5a9c3f644), {
        svg: $dbb0fc9f5c20d708$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::26f3036375895bf30dc2c16f910588fe>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
var $da79d6616879e497$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#625df5)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, white)\" d=\"M19.083 11.212h-4.142l3.588-2.071-.788-1.365-3.588 2.071 2.07-3.587-1.364-.788-2.071 3.587V4.917h-1.576v4.142L9.141 5.472l-1.365.787 2.071 3.588L6.26 7.776 5.472 9.14l3.587 2.07H4.917v1.577h4.142l-3.587 2.071.788 1.365 3.587-2.07-2.071 3.587 1.365.787 2.07-3.587v4.142h1.577V14.94l2.07 3.587 1.365-.787-2.07-3.588 3.587 2.071.788-1.365-3.587-2.07h4.142zM12 14.143a2.151 2.151 0 1 1 0-4.302 2.151 2.151 0 0 1 0 4.302\"/>\n</svg>\n";
function $da79d6616879e497$export$38c7b37a3e5e8d70(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Loom' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $9b5b994dd561b600$export$be58b4326e23250f), {
        svg: $da79d6616879e497$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::bf5c00a6af1a30f7d2914e27e51f1aff>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $fc01f80024a1e9f7$var$svg = "<svg height=\"100%\" viewBox=\"0 0 103 32\">\n    <path fill=\"var(--tile-color,#625df5)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, white)\" d=\"M25.375 15.31H19.99l4.664-2.693-1.024-1.775-4.664 2.693 2.692-4.663-1.775-1.025-2.692 4.663V7.125h-2.048v5.386l-2.694-4.664-1.774 1.024 2.693 4.664-4.664-2.693-1.024 1.774 4.664 2.693H6.959v2.049h5.384L7.68 20.05l1.024 1.774 4.663-2.692-2.692 4.664 1.774 1.024 2.693-4.664v5.385h2.049v-5.385l2.692 4.664 1.774-1.024-2.692-4.665 4.663 2.693 1.025-1.774-4.664-2.693h5.385zm-9.208 3.81a2.797 2.797 0 1 1 0-5.593 2.797 2.797 0 0 1 0 5.593\"/>\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M42.67 25.34V3.93h3.93v21.41zm37.7-14.55h3.75v1.78c.8-1.42 2.66-2.19 4.26-2.19 1.98 0 3.58.86 4.32 2.43 1.15-1.77 2.69-2.42 4.61-2.42 2.69 0 5.26 1.63 5.26 5.53v9.43h-3.81v-8.63c0-1.57-.77-2.75-2.57-2.75-1.68 0-2.69 1.3-2.69 2.87v8.52h-3.9v-8.63c0-1.57-.8-2.75-2.57-2.75-1.71 0-2.72 1.27-2.72 2.87v8.52h-3.93zM55.48 25.77c-4.43 0-7.63-3.28-7.63-7.7 0-4.34 3.2-7.7 7.64-7.7 4.46 0 7.63 3.39 7.63 7.7 0 4.38-3.21 7.7-7.63 7.7m0-11.84a4.15 4.15 0 0 0-4.14 4.14 4.15 4.15 0 0 0 4.14 4.14 4.15 4.15 0 0 0 4.14-4.14 4.15 4.15 0 0 0-4.14-4.14m16.02 11.84c-4.43 0-7.63-3.28-7.63-7.7 0-4.34 3.2-7.7 7.63-7.7 4.46 0 7.64 3.39 7.64 7.7 0 4.38-3.21 7.7-7.63 7.7m0-11.89c-2.31 0-4.19 1.88-4.19 4.19s1.88 4.19 4.19 4.19 4.19-1.88 4.19-4.19-1.88-4.19-4.19-4.19\"/>\n</svg>\n";
function $fc01f80024a1e9f7$export$71743a944cb62e48(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Loom' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $9b7a1b046861a04a$export$f827d3c5a9c3f644), {
        svg: $fc01f80024a1e9f7$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::568f663154fd35333110385dd0c22e41>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
var $7277bf1ab856c9fb$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#1868db)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, white)\" d=\"M19.083 11.212h-4.142l3.588-2.071-.788-1.365-3.588 2.071 2.07-3.587-1.364-.788-2.071 3.587V4.917h-1.576v4.142L9.141 5.472l-1.365.787 2.071 3.588L6.26 7.776 5.472 9.14l3.587 2.07H4.917v1.577h4.142l-3.587 2.071.788 1.365 3.587-2.07-2.071 3.587 1.365.787 2.07-3.587v4.142h1.577V14.94l2.07 3.587 1.365-.787-2.07-3.588 3.587 2.071.788-1.365-3.587-2.07h4.142zM12 14.143a2.151 2.151 0 1 1 0-4.302 2.151 2.151 0 0 1 0 4.302\"/>\n</svg>\n";
function $7277bf1ab856c9fb$export$8d789f76fde3e05(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Loom' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $9b5b994dd561b600$export$be58b4326e23250f), {
        svg: $7277bf1ab856c9fb$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2d69248f39a87c063a78e83a58b63bd7>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $a9d66750d87e778d$var$svg = "<svg height=\"100%\" viewBox=\"0 0 103 32\">\n    <path fill=\"var(--tile-color,#1868db)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, white)\" d=\"M25.375 15.31H19.99l4.664-2.693-1.024-1.775-4.664 2.693 2.692-4.663-1.775-1.025-2.692 4.663V7.125h-2.048v5.386l-2.694-4.664-1.774 1.024 2.693 4.664-4.664-2.693-1.024 1.774 4.664 2.693H6.959v2.049h5.384L7.68 20.05l1.024 1.774 4.663-2.692-2.692 4.664 1.774 1.024 2.693-4.664v5.385h2.049v-5.385l2.692 4.664 1.774-1.024-2.692-4.665 4.663 2.693 1.025-1.774-4.664-2.693h5.385zm-9.208 3.81a2.797 2.797 0 1 1 0-5.593 2.797 2.797 0 0 1 0 5.593\"/>\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M42.67 25.34V3.93h3.93v21.41zm37.7-14.55h3.75v1.78c.8-1.42 2.66-2.19 4.26-2.19 1.98 0 3.58.86 4.32 2.43 1.15-1.77 2.69-2.42 4.61-2.42 2.69 0 5.26 1.63 5.26 5.53v9.43h-3.81v-8.63c0-1.57-.77-2.75-2.57-2.75-1.68 0-2.69 1.3-2.69 2.87v8.52h-3.9v-8.63c0-1.57-.8-2.75-2.57-2.75-1.71 0-2.72 1.27-2.72 2.87v8.52h-3.93zM55.48 25.77c-4.43 0-7.63-3.28-7.63-7.7 0-4.34 3.2-7.7 7.64-7.7 4.46 0 7.63 3.39 7.63 7.7 0 4.38-3.21 7.7-7.63 7.7m0-11.84a4.15 4.15 0 0 0-4.14 4.14 4.15 4.15 0 0 0 4.14 4.14 4.15 4.15 0 0 0 4.14-4.14 4.15 4.15 0 0 0-4.14-4.14m16.02 11.84c-4.43 0-7.63-3.28-7.63-7.7 0-4.34 3.2-7.7 7.63-7.7 4.46 0 7.64 3.39 7.64 7.7 0 4.38-3.21 7.7-7.63 7.7m0-11.89c-2.31 0-4.19 1.88-4.19 4.19s1.88 4.19 4.19 4.19 4.19-1.88 4.19-4.19-1.88-4.19-4.19-4.19\"/>\n</svg>\n";
function $a9d66750d87e778d$export$78c0b4d8be34c9b2(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Loom' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $9b7a1b046861a04a$export$f827d3c5a9c3f644), {
        svg: $a9d66750d87e778d$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c11df6f0c8182479108e0649acaca190>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
var $ddf42b4cd5986168$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M11.13 5.88H5.88v5.25h5.25zm0 7H5.88v5.25h5.25zm1.75-7h5.25v5.25h-5.25zm5.25 7h-5.25v5.25h5.25z\"/>\n</svg>\n";
function $ddf42b4cd5986168$export$518f48548316ec87(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'More Atlassian Apps' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $9b5b994dd561b600$export$be58b4326e23250f), {
        svg: $ddf42b4cd5986168$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2bf4732a418598faff0fcffc57f4a7b7>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
var $6f107b5a3cdc7c24$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#ffc716)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M12.696 19.45c-.49.361-.749.336-1.24-.026-2.375-1.704-4.57-3.641-6.042-5.655-.155-.207-.078-.49.155-.62l2.685-1.678q.35-.233.62.077c1.033 1.188 2.04 2.35 3.202 3.176 1.162-.826 2.17-1.988 3.202-3.176q.272-.31.62-.078l2.686 1.679c.232.13.31.413.155.62-1.472 2.014-3.667 3.95-6.043 5.68m-.62-7.411c2.118 0 3.874-1.73 3.874-3.848s-1.756-3.9-3.874-3.9c-2.117 0-3.873 1.757-3.873 3.9s1.704 3.848 3.873 3.848\"/>\n</svg>\n";
function $6f107b5a3cdc7c24$export$eeccc49dc7a12d9f(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Opsgenie' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $9b5b994dd561b600$export$be58b4326e23250f), {
        svg: $6f107b5a3cdc7c24$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::032f8fa95ed51413adb506dd076fd343>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $208acfc57f03835f$var$svg = "<svg height=\"100%\" viewBox=\"0 0 164 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M156.69 12.09c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.67-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zM143.39 5.95c0-1.16.77-1.84 1.84-1.84s1.84.68 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zm-3.68-8.98v8.99h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.51c.98-1.81 2.79-2.82 4.85-2.82 3.53 0 5.55 2.42 5.55 6.66m-22.92-4.26c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.67-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-18.64-.62v-1.53c-.98 2.02-2.82 3.07-5.18 3.07-4.05 0-6.07-3.47-6.07-7.97 0-4.32 2.12-7.97 6.38-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.58v13.95c0 4.51-2.12 7.54-7.6 7.54-2.58 0-3.99-.34-5.46-.83v-2.58c1.69.55 3.44.92 5.34.92 3.83 0 5.15-2.06 5.15-4.91m-8.68-6.44c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m-4.72 3.52c0 2.55-1.66 4.48-5.76 4.48-2.3 0-4.17-.52-5.34-1.13v-2.79c1.32.77 3.53 1.5 5.46 1.5 2.02 0 3.07-.83 3.07-2.02 0-1.17-.89-1.84-3.8-2.55-3.4-.83-4.85-2.15-4.85-4.66 0-2.67 2.06-4.29 5.55-4.29 1.99 0 3.8.49 4.94 1.1v2.73c-1.84-.92-3.34-1.41-4.97-1.41-1.93 0-2.97.67-2.97 1.87 0 1.07.74 1.75 3.56 2.42 3.4.83 5.12 2.09 5.12 4.75m-16.29-3.49c0-3.68-1.47-5.52-4.2-5.52-2.36 0-4.48 1.5-4.48 4.91v1.23c0 3.4 1.93 4.91 4.17 4.91 2.98 0 4.51-1.96 4.51-5.52m-3.8 7.97c-2.24 0-3.96-1.01-4.88-3.01v8.68h-2.64V10h2.64v2.76c.98-2.02 2.82-3.07 5.18-3.07 4.08 0 6.13 3.47 6.13 7.97 0 4.32-2.15 7.97-6.44 7.97m-20.11.01c-6.22 0-9.72-4.29-9.72-10.43 0-6.07 3.5-10.33 9.72-10.33 6.2 0 9.69 4.26 9.69 10.34 0 6.13-3.5 10.43-9.69 10.43m0-18.12c-4.97 0-6.96 3.53-6.96 7.7 0 4.26 1.99 7.79 6.96 7.79 4.94 0 6.93-3.53 6.93-7.79 0-4.17-1.99-7.7-6.93-7.7\"/>\n    <path fill=\"var(--tile-color,#ffc716)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M16.905 25.684c-.638.47-.974.437-1.612-.033-3.088-2.216-5.942-4.734-7.855-7.352-.202-.269-.1-.638.201-.806l3.491-2.182q.454-.302.806.1c1.343 1.545 2.652 3.056 4.163 4.13 1.51-1.074 2.82-2.585 4.163-4.13q.352-.402.805-.1l3.491 2.182c.303.168.403.537.202.806-1.914 2.618-4.767 5.136-7.855 7.385m-.806-9.635c2.753 0 5.035-2.249 5.035-5.001s-2.282-5.07-5.035-5.07-5.036 2.283-5.036 5.07c0 2.786 2.216 5.001 5.036 5.001\"/>\n</svg>\n";
function $208acfc57f03835f$export$a5b9122e89b32ad3(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Opsgenie' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $9b7a1b046861a04a$export$f827d3c5a9c3f644), {
        svg: $208acfc57f03835f$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::1c3a56195279b145c83aee2d39dd6918>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
var $41cbf4a689ed8f4f$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, #101214)\" fill-rule=\"evenodd\" d=\"m5.106 14.44 1.856-1.856-1.856-1.856L6.653 9.18h3.712l2.784-2.784h4.332v4.33l-2.785 2.785v3.712L13.15 18.77l-1.857-1.856-1.856 1.856-1.7-1.7 2.784-2.784-.928-.928-2.784 2.784zm10.209-4.331a1.094 1.094 0 1 1-1.547-1.546 1.094 1.094 0 0 1 1.547 1.546\" clip-rule=\"evenodd\"/>\n</svg>\n";
function $41cbf4a689ed8f4f$export$5ed3e1bb3b04fc02(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Projects' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $9b5b994dd561b600$export$be58b4326e23250f), {
        svg: $41cbf4a689ed8f4f$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2700d019c02f76a45bbbdb7e71fedfcb>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $5f3418d4a157010d$var$svg = "<svg height=\"100%\" viewBox=\"0 0 145 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M144.54 21.16c0 2.55-1.66 4.48-5.77 4.48-2.3 0-4.17-.52-5.34-1.13v-2.79c1.32.77 3.53 1.5 5.46 1.5 2.02 0 3.07-.83 3.07-2.02 0-1.17-.89-1.84-3.8-2.55-3.4-.83-4.84-2.15-4.84-4.66 0-2.67 2.05-4.29 5.55-4.29 1.99 0 3.8.49 4.94 1.1v2.73c-1.84-.92-3.34-1.41-4.97-1.41-1.93 0-2.97.67-2.97 1.87 0 1.07.74 1.75 3.56 2.42 3.4.83 5.12 2.09 5.12 4.75m-17.75-.58c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55c-.46.12-.98.25-1.78.25-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zm-6.66 1.99v2.36c-.92.49-2.33.71-3.74.71-5.46 0-8-3.31-8-8 0-4.63 2.55-7.94 8-7.94 1.38 0 2.45.18 3.65.74v2.45c-.98-.46-2.02-.74-3.47-.74-3.99 0-5.61 2.52-5.61 5.49s1.66 5.49 5.67 5.49c1.56 0 2.55-.21 3.5-.55M99.43 12.09c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.67-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.2c.37 2.61 2.05 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zM83.8 31.25v-2.36c.31.03.49.03.77.03 1.13 0 2.05-.49 2.05-1.87V10h2.64v17.36c0 2.82-1.59 4.02-4.11 4.02-.67 0-1.13-.06-1.35-.12m2.3-25.3c0-1.16.77-1.84 1.84-1.84s1.84.68 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84M76.07 25.64c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49M62.3 16.29v9.05h-2.58V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.67-5.43 3.93m-5-4.4c0 4.39-2.45 6.84-7.48 6.84H45.8v6.59h-2.76V5.19h6.78c5.03 0 7.48 2.58 7.48 6.72m-7.79 4.2c3.56.12 4.94-1.56 4.94-4.14 0-2.45-1.38-4.14-4.94-4.14H45.8v8.28z\"/>\n    <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, #101214)\" fill-rule=\"evenodd\" d=\"m6.152 19.486 2.651-2.652-2.651-2.651 2.21-2.21h5.303l3.977-3.977h6.187v6.187l-3.977 3.977v5.304l-2.21 2.21-2.652-2.652-2.651 2.651-2.429-2.428 3.978-3.978-1.326-1.325-3.978 3.977zM20.736 13.3a1.562 1.562 0 1 1-2.21-2.21 1.562 1.562 0 0 1 2.21 2.21\" clip-rule=\"evenodd\"/>\n</svg>\n";
function $5f3418d4a157010d$export$e3d1678155aaab99(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Projects' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $9b7a1b046861a04a$export$f827d3c5a9c3f644), {
        svg: $5f3418d4a157010d$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::694cf9c8d8336e73333c711f4777239b>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
var $4f24c8abb3bfcd10$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#94c748)\" d=\"M10.7.368a2.75 2.75 0 0 1 2.748 0l8.016 4.626a2.75 2.75 0 0 1 1.375 2.38v9.252c0 .982-.524 1.889-1.375 2.38l-8.016 4.626a2.75 2.75 0 0 1-2.749 0l-8.016-4.626a2.75 2.75 0 0 1-1.374-2.38V7.374c0-.982.524-1.889 1.374-2.38z\"/>\n    <path fill=\"var(--icon-color, #101214)\" fill-rule=\"evenodd\" d=\"M10.181 6.096 6.777 8.06a1.53 1.53 0 0 0-.768 1.327v5.229c0 .547.294 1.054.768 1.327l.807.466 3.722 2.149a1.54 1.54 0 0 0 1.508.014l.027-.018a1.54 1.54 0 0 0 .766-1.323v-2.026l-1.97-1.137-.568-.327a2 2 0 0 1-1.006-1.74V6.775a2 2 0 0 1 .118-.678\" clip-rule=\"evenodd\"/>\n    <path fill=\"var(--icon-color, #101214)\" fill-rule=\"evenodd\" d=\"M12.842 5.441a1.54 1.54 0 0 0-1.508-.014l-.028.019a1.54 1.54 0 0 0-.765 1.323v2.025l1.91 1.102.628.362a2 2 0 0 1 1.006 1.74v5.228a2 2 0 0 1-.118.678l3.404-1.965c.476-.273.767-.778.767-1.327V9.383c0-.546-.293-1.054-.767-1.327l-.868-.501z\" clip-rule=\"evenodd\"/>\n</svg>\n";
function $4f24c8abb3bfcd10$export$813cff80931d9dbf(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Rovo Dev Agent' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $9b5b994dd561b600$export$be58b4326e23250f), {
        svg: $4f24c8abb3bfcd10$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3e07b5682123be769fa70cfe7a8367bf>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $f7ab768ff134333e$var$svg = "<svg height=\"100%\" viewBox=\"0 0 160 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M153.94 25.67h-3.53l-5.95-15.33h2.76l4.97 13.1 4.94-13.09h2.76zM136.3 12.42c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.67-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.2c.37 2.61 2.05 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-25.13-16.9h-4.54v14.87h4.69c4.6 0 6.9-2.42 6.9-7.3 0-4.91-2.18-7.57-7.05-7.57m-7.3 17.51V5.52h7.42c6.53 0 9.69 4.08 9.69 10.12 0 6.1-3.19 10.03-9.69 10.03zm-16.25.31c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49M79.49 25.67h-3.53l-5.95-15.33h2.76l4.97 13.1 4.94-13.09h2.76zm-17.46.31c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49M45 8.16h-4.05v7.36H45c3.59 0 4.69-1.38 4.69-3.68 0-2.18-1.13-3.68-4.69-3.68m7.45 3.62c0 3.04-1.29 5.09-3.96 5.95l4.94 7.94h-3.25l-4.45-7.51h-4.78v7.51h-2.76V5.52h7.11c4.82 0 7.15 2.39 7.15 6.26\"/>\n    <path fill=\"var(--tile-color,#94c748)\" d=\"M12.52.49a3.67 3.67 0 0 1 3.666 0l10.688 6.17a3.66 3.66 0 0 1 1.833 3.173v12.336a3.66 3.66 0 0 1-1.833 3.173L16.186 31.51a3.67 3.67 0 0 1-3.665 0L1.833 25.341A3.66 3.66 0 0 1 0 22.168V9.832c0-1.309.7-2.519 1.833-3.173z\"/>\n    <path fill=\"var(--icon-color, #101214)\" fill-rule=\"evenodd\" d=\"m11.83 8.128-4.54 2.62a2.04 2.04 0 0 0-1.022 1.77v6.972c0 .728.39 1.405 1.023 1.77l1.076.62 4.963 2.865a2.05 2.05 0 0 0 2.01.02l.037-.025c.445-.257.771-.67.925-1.146q.094-.297.095-.619v-2.7l-2.627-1.516-.757-.436a2.67 2.67 0 0 1-1.34-2.32v-6.97a2.7 2.7 0 0 1 .157-.904\" clip-rule=\"evenodd\"/>\n    <path fill=\"var(--icon-color, #101214)\" fill-rule=\"evenodd\" d=\"M15.377 7.255a2.05 2.05 0 0 0-2.01-.019l-.038.026c-.445.257-.77.67-.924 1.145a2 2 0 0 0-.095.618v2.7l2.545 1.47.839.483a2.67 2.67 0 0 1 1.34 2.319v6.972a2.7 2.7 0 0 1-.157.903l4.54-2.62a2.04 2.04 0 0 0 1.022-1.77v-6.971c0-.729-.39-1.405-1.023-1.77l-1.157-.668z\" clip-rule=\"evenodd\"/>\n</svg>\n";
function $f7ab768ff134333e$export$58747af448450872(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Rovo Dev Agent' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $9b7a1b046861a04a$export$f827d3c5a9c3f644), {
        svg: $f7ab768ff134333e$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a1131b9b9b6248ab2f320c07042466bf>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
var $197063d63daf10dc$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#94c748)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M11.26 4.71a1.7 1.7 0 0 1 1.666.017l5.006 2.89c.524.302.848.863.848 1.467v5.78a1.69 1.69 0 0 1-.848 1.467l-3.763 2.172.024-.07c.07-.216.107-.445.107-.679v-5.78c0-.794-.423-1.526-1.112-1.922l-2.805-1.62V6.195q.001-.267.08-.512c.126-.395.396-.737.765-.95l.002-.001z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M9.986 5.45 6.223 7.623a1.69 1.69 0 0 0-.848 1.466v5.78c0 .605.324 1.166.848 1.468l5.006 2.89a1.7 1.7 0 0 0 1.666.016l.03-.02c.37-.214.64-.556.768-.95q.078-.247.079-.513v-2.24l-2.805-1.618a2.22 2.22 0 0 1-1.112-1.922V6.2a2.2 2.2 0 0 1 .13-.75\"/>\n</svg>\n";
function $197063d63daf10dc$export$8b784b3227531b3e(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Rovo Dev' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $9b5b994dd561b600$export$be58b4326e23250f), {
        svg: $197063d63daf10dc$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::8e3612ac67ced6c8ac8b271a1aa6aa8b>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $52144500e207f1b9$var$svg = "<svg height=\"100%\" viewBox=\"0 0 165 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M158.79 25.33h-3.53L149.32 10h2.76l4.97 13.1 4.93-13.1h2.76zm-17.64-13.24c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.05 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zM121.91 7.82h-4.54v14.87h4.69c4.6 0 6.9-2.42 6.9-7.3 0-4.91-2.18-7.57-7.05-7.57m-7.3 17.51V5.19h7.42c6.53 0 9.69 4.08 9.69 10.12 0 6.1-3.19 10.03-9.69 10.03zm-16.26.31c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49M84.34 25.33h-3.53L74.86 10h2.76l4.97 13.1L87.53 10h2.76zm-17.46.31c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49M49.84 7.82h-4.05v7.36h4.05c3.59 0 4.69-1.38 4.69-3.68 0-2.18-1.13-3.68-4.69-3.68m7.45 3.62c0 3.04-1.29 5.09-3.96 5.95l4.94 7.94h-3.25l-4.44-7.51H45.8v7.51h-2.76V5.19h7.12c4.81 0 7.15 2.39 7.15 6.26\"/>\n    <path fill=\"var(--tile-color,#94c748)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M15.013 6.281a2.26 2.26 0 0 1 2.222.021l6.674 3.854a2.26 2.26 0 0 1 1.131 1.956v7.707c0 .809-.43 1.553-1.13 1.956l-5.018 2.896.032-.093c.093-.289.142-.594.142-.906v-7.707a2.95 2.95 0 0 0-1.481-2.563l-3.74-2.158V8.258c0-.235.036-.465.105-.682a2.26 2.26 0 0 1 1.021-1.267h.002z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"m13.314 7.267-5.017 2.896a2.25 2.25 0 0 0-1.13 1.956v7.707c0 .806.432 1.553 1.13 1.956l6.675 3.854c.686.396 1.53.403 2.222.02l.04-.026c.493-.284.853-.74 1.023-1.267a2.3 2.3 0 0 0 .105-.683v-2.986l-3.74-2.158a2.96 2.96 0 0 1-1.482-2.563V8.266a3 3 0 0 1 .174-1\"/>\n</svg>\n";
function $52144500e207f1b9$export$4145bd793c9ed1d0(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Rovo Dev' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $9b7a1b046861a04a$export$f827d3c5a9c3f644), {
        svg: $52144500e207f1b9$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a7bd8774a1a483ce4ec625e53d5f111c>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
var $43ecd9ad182aa785$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--rovo-blue-color, #1868db)\" fill-rule=\"evenodd\" d=\"m13.227 16.789-7.154 4.169-3.403-1.96a2.72 2.72 0 0 1-1.362-2.355V7.366c0-.973.518-1.87 1.361-2.354l6.044-3.487-.038.114a3.6 3.6 0 0 0-.172 1.088v9.278c0 1.274.68 2.45 1.786 3.085z\" clip-rule=\"evenodd\"/>\n    <path fill=\"var(--rovo-green-color, #6a9a23)\" fill-rule=\"evenodd\" d=\"m11.296 15.671-7.193 4.153 6.607 3.812a2.73 2.73 0 0 0 2.676.026l.048-.033a2.73 2.73 0 0 0 1.232-1.525 2.7 2.7 0 0 0 .127-.822v-3.594z\" clip-rule=\"evenodd\"/>\n    <path fill=\"var(--rovo-purple-color, #af59e1)\" fill-rule=\"evenodd\" d=\"m21.477 5.003-4.404-2.539-5.904 4.89 2.69 1.556a3.56 3.56 0 0 1 1.785 3.086v9.277a3.6 3.6 0 0 1-.21 1.202l6.044-3.486a2.71 2.71 0 0 0 1.362-2.355V7.357c0-.97-.521-1.87-1.363-2.354\" clip-rule=\"evenodd\"/>\n    <path fill=\"var(--rovo-yellow-color, #fca700)\" fill-rule=\"evenodd\" d=\"M12.74 8.266 9.353 6.312V2.718c0-.283.044-.56.127-.821A2.73 2.73 0 0 1 10.71.372V.37a.4.4 0 0 0 .048-.033 2.73 2.73 0 0 1 2.676.026l6.499 3.75z\" clip-rule=\"evenodd\"/>\n</svg>\n";
function $43ecd9ad182aa785$export$9e62346a60cfb459(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Rovo' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $9b5b994dd561b600$export$be58b4326e23250f), {
        svg: $43ecd9ad182aa785$var$svg,
        label: label,
        type: "rovo",
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::81d74fa5dbe2e1ea12f9e61d6b58e6d8>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $57fe7bba8f3a8d6a$var$svg = "<svg height=\"100%\" viewBox=\"0 0 102 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M93.5 25.97c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49M79.49 25.67h-3.53l-5.95-15.33h2.76l4.97 13.1 4.94-13.09h2.76zm-17.46.3c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49M44.99 8.16h-4.05v7.36h4.05c3.59 0 4.69-1.38 4.69-3.68 0-2.18-1.13-3.68-4.69-3.68m7.45 3.62c0 3.04-1.29 5.09-3.96 5.95l4.94 7.94h-3.25l-4.45-7.51h-4.78v7.51h-2.76V5.52h7.11c4.82 0 7.15 2.39 7.15 6.26\"/>\n    <path fill=\"var(--rovo-blue-color, #1868db)\" fill-rule=\"evenodd\" d=\"m15.892 22.385-9.538 5.559-4.538-2.613A3.63 3.63 0 0 1 0 22.19V9.821C0 8.524.69 7.33 1.816 6.682l8.058-4.649-.052.152a4.7 4.7 0 0 0-.228 1.452v12.37a4.74 4.74 0 0 0 2.38 4.113z\" clip-rule=\"evenodd\"/>\n    <path fill=\"var(--rovo-green-color, #6a9a23)\" fill-rule=\"evenodd\" d=\"m13.318 20.895-9.591 5.538 8.809 5.082a3.64 3.64 0 0 0 3.568.034l.065-.043a3.63 3.63 0 0 0 1.642-2.034c.11-.35.17-.718.17-1.096v-4.792z\" clip-rule=\"evenodd\"/>\n    <path fill=\"var(--rovo-purple-color, #af59e1)\" fill-rule=\"evenodd\" d=\"M26.893 6.67 21.02 3.285l-7.873 6.52 3.587 2.075a4.74 4.74 0 0 1 2.38 4.115v12.369a4.7 4.7 0 0 1-.28 1.603l8.058-4.649a3.62 3.62 0 0 0 1.816-3.139V9.81a3.63 3.63 0 0 0-1.816-3.139\" clip-rule=\"evenodd\"/>\n    <path fill=\"var(--rovo-yellow-color, #fca700)\" fill-rule=\"evenodd\" d=\"m15.244 11.022-4.519-2.606V3.625c0-.378.059-.747.17-1.096a3.63 3.63 0 0 1 1.64-2.033l.002-.001.064-.044a3.64 3.64 0 0 1 3.569.034l8.665 5z\" clip-rule=\"evenodd\"/>\n</svg>\n";
function $57fe7bba8f3a8d6a$export$5e38d02efdb45577(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Rovo' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $9b7a1b046861a04a$export$f827d3c5a9c3f644), {
        svg: $57fe7bba8f3a8d6a$var$svg,
        label: label,
        type: "rovo",
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::4fdd9cdb3dfb222b9beb33bde63bcd67>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
var $c0e81f450057cf06$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#1868db)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, white)\" d=\"M11.057 5.257a1.57 1.57 0 0 1 1.539.015l4.621 2.668c.484.279.783.797.783 1.354v5.336a1.56 1.56 0 0 1-.782 1.355l-3.474 2.005a2 2 0 0 0 .12-.691v-5.337c0-.733-.39-1.409-1.026-1.774l-2.59-1.495V6.626q.001-.246.074-.473c.117-.364.366-.68.707-.877z\"/>\n    <path fill=\"var(--icon-color, white)\" d=\"M9.881 5.94 6.408 7.945A1.56 1.56 0 0 0 5.625 9.3v5.337c0 .557.3 1.075.783 1.354l4.621 2.668c.475.274 1.06.279 1.539.015l.027-.019a1.57 1.57 0 0 0 .781-1.35v-2.067l-2.589-1.495a2.05 2.05 0 0 1-1.026-1.775V6.631a2 2 0 0 1 .12-.691\"/>\n</svg>\n";
function $c0e81f450057cf06$export$e23ae35269442b4f(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Rovo' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $9b5b994dd561b600$export$be58b4326e23250f), {
        svg: $c0e81f450057cf06$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::078cc586ef0207819d6635adebbccf14>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $bd5d466aedec2939$var$svg = "<svg height=\"100%\" viewBox=\"0 0 106 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M98.36 25.64c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49M84.34 25.33h-3.53L74.87 10h2.76l4.97 13.1L87.53 10h2.76zm-17.46.31c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49M49.84 7.82h-4.05v7.36h4.05c3.59 0 4.69-1.38 4.69-3.68 0-2.18-1.13-3.68-4.69-3.68m7.45 3.62c0 3.04-1.29 5.09-3.96 5.95l4.94 7.94h-3.25l-4.44-7.51H45.8v7.51h-2.76V5.19h7.12c4.81 0 7.15 2.39 7.15 6.26\"/>\n    <path fill=\"var(--tile-color,#1868db)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, white)\" d=\"M15.013 6.281a2.26 2.26 0 0 1 2.222.021l6.674 3.854a2.26 2.26 0 0 1 1.131 1.956v7.707c0 .809-.43 1.553-1.13 1.956l-5.018 2.896q.017-.046.032-.093c.093-.289.142-.594.142-.906v-7.707a2.95 2.95 0 0 0-1.481-2.563l-3.74-2.158V8.258c0-.235.036-.465.105-.682.17-.527.529-.983 1.021-1.267h.002z\"/>\n    <path fill=\"var(--icon-color, white)\" d=\"m13.314 7.267-5.017 2.896a2.25 2.25 0 0 0-1.13 1.956v7.707c0 .806.432 1.553 1.13 1.956l6.675 3.854c.686.396 1.53.403 2.222.02l.04-.026c.493-.284.853-.74 1.023-1.267a2.3 2.3 0 0 0 .105-.683v-2.986l-3.74-2.158a2.96 2.96 0 0 1-1.482-2.563V8.266a3 3 0 0 1 .174-1\"/>\n</svg>\n";
function $bd5d466aedec2939$export$b0e15f0a1c9f4c55(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Rovo' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $9b7a1b046861a04a$export$f827d3c5a9c3f644), {
        svg: $bd5d466aedec2939$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e8449a5cf6c2f473179dfe4bd9893163>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
var $0f8b4aaeed3bfd5f$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 6.625a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, #101214)\" fill-rule=\"evenodd\" d=\"M10.76 17.176a5.791 5.791 0 1 1 5.038-2.935l3.403 3.403-2.205 2.204-3.409-3.408a5.77 5.77 0 0 1-2.827.736m-.274-9.37-.242.615c-.344.874-.516 1.312-.833 1.64-.318.33-.749.518-1.61.893l-.37.16v.51l.37.16c.861.376 1.292.563 1.61.893.317.329.49.766.833 1.64l.242.616h.51l.242-.616c.344-.874.516-1.311.834-1.64.317-.33.748-.517 1.61-.893l.368-.16v-.51l-.369-.16c-.861-.375-1.292-.563-1.61-.892-.317-.33-.489-.766-.833-1.64l-.242-.616z\" clip-rule=\"evenodd\"/>\n</svg>\n";
function $0f8b4aaeed3bfd5f$export$82eafebb825fc23f(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Search' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $9b5b994dd561b600$export$be58b4326e23250f), {
        svg: $0f8b4aaeed3bfd5f$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::17e42f012731a68dbb72bc00bc08f838>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $b4bd8937bad3fd8c$var$svg = "<svg height=\"100%\" viewBox=\"0 0 130 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M128.82 16.35v8.99h-2.64v-8.52c0-3.16-1.1-4.72-3.62-4.72-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V3.59h2.64v8.96c1.01-1.81 2.85-2.85 5.06-2.85 3.44 0 5.34 2.33 5.34 6.66m-16.05 6.21v2.36c-.92.49-2.33.71-3.74.71-5.46 0-8-3.31-8-8 0-4.63 2.55-7.94 8-7.94 1.38 0 2.45.18 3.65.74v2.45c-.98-.46-2.02-.74-3.46-.74-3.99 0-5.61 2.52-5.61 5.49s1.66 5.49 5.67 5.49c1.56 0 2.55-.21 3.5-.55m-18.23-6.29v9.05h-2.58V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.67-5.43 3.93m-17.87 1.37c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.47-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zM65.08 12.09c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.67-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.2c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-15.33-4.95c0 3.5-2.08 5.86-7.08 5.86-3.89 0-5.7-.77-7.27-1.56v-2.82c1.87.98 4.75 1.69 7.42 1.69 3.04 0 4.17-1.2 4.17-2.97s-1.1-2.73-4.94-3.65c-4.54-1.1-6.56-2.67-6.56-5.98 0-3.13 2.39-5.46 7.08-5.46 2.91 0 4.78.71 6.16 1.47v2.76c-2.02-1.16-4.2-1.53-6.29-1.53-2.64 0-4.2.92-4.2 2.76 0 1.66 1.29 2.48 4.85 3.37 4.26 1.07 6.66 2.45 6.66 6.07\"/>\n    <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, #101214)\" fill-rule=\"evenodd\" d=\"M14.346 22.068a7.721 7.721 0 1 1 6.718-3.913l4.537 4.536-2.94 2.94-4.545-4.545a7.7 7.7 0 0 1-3.77.982m-.364-12.494-.323.82c-.459 1.167-.688 1.75-1.112 2.188-.423.44-.997.69-2.146 1.19l-.492.214v.68l.492.213c1.149.5 1.723.75 2.146 1.19.424.439.653 1.022 1.112 2.188l.323.82h.679l.323-.82c.459-1.166.688-1.75 1.111-2.188.424-.44.998-.69 2.147-1.19l.491-.214v-.679l-.491-.214c-1.149-.5-1.723-.75-2.147-1.19-.423-.438-.652-1.021-1.111-2.187l-.323-.82z\" clip-rule=\"evenodd\"/>\n</svg>\n";
function $b4bd8937bad3fd8c$export$fa08cbfe393f2a68(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Search' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $9b7a1b046861a04a$export$f827d3c5a9c3f644), {
        svg: $b4bd8937bad3fd8c$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::37c59c3ee979ff8acaf7525e576da094>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
var $29dc00d3e852c298$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#ffc716)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M12 9.796c-1.924 0-3.796.832-5.324 2.118q-.238.227-.475.227c-.132 0-.263-.076-.369-.202L3.908 9.771c-.105-.126-.158-.252-.158-.353 0-.151.08-.277.237-.429C6.307 7.023 9.127 5.914 12 5.914s5.693 1.109 8.013 3.075c.158.152.237.278.237.429 0 .1-.053.227-.158.353l-1.924 2.168c-.106.126-.238.202-.37.202q-.236 0-.474-.227c-1.529-1.286-3.4-2.118-5.324-2.118m0 8.118c-2.135 0-3.875-1.664-3.875-3.68 0-2.018 1.74-3.682 3.875-3.682s3.875 1.64 3.875 3.681-1.74 3.68-3.875 3.68\"/>\n</svg>\n";
function $29dc00d3e852c298$export$f3f5aa321d88adf9(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Statuspage' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $9b5b994dd561b600$export$be58b4326e23250f), {
        svg: $29dc00d3e852c298$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::4e31a509778b74933bf91345a74560c5>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $498a5dc059f68f6e$var$svg = "<svg height=\"100%\" viewBox=\"0 0 192 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M184.96 12.09c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.05 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-18.64-.62v-1.53c-.98 2.02-2.82 3.07-5.18 3.07-4.05 0-6.07-3.46-6.07-7.97 0-4.32 2.12-7.97 6.38-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.58v13.95c0 4.51-2.12 7.54-7.61 7.54-2.58 0-3.99-.34-5.46-.83v-2.58c1.69.55 3.43.92 5.34.92 3.83 0 5.15-2.05 5.15-4.91m-8.68-6.44c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m-16.96.03c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-16.09-7.66c0-3.68-1.47-5.52-4.2-5.52-2.36 0-4.48 1.5-4.48 4.91v1.23c0 3.4 1.93 4.91 4.17 4.91 2.98 0 4.51-1.96 4.51-5.52m-3.8 7.97c-2.24 0-3.96-1.01-4.88-3v8.68h-2.64V10h2.64v2.76c.98-2.02 2.82-3.07 5.18-3.07 4.08 0 6.13 3.47 6.13 7.97 0 4.32-2.15 7.97-6.44 7.97m-10.55-4.47c0 2.55-1.66 4.48-5.77 4.48-2.3 0-4.17-.52-5.34-1.13v-2.79c1.32.77 3.53 1.5 5.46 1.5 2.02 0 3.07-.83 3.07-2.02 0-1.16-.89-1.84-3.8-2.54-3.4-.83-4.84-2.15-4.84-4.66 0-2.67 2.05-4.29 5.55-4.29 1.99 0 3.8.49 4.94 1.1v2.73c-1.84-.92-3.34-1.41-4.97-1.41-1.93 0-2.97.68-2.97 1.87 0 1.07.74 1.75 3.56 2.42 3.4.83 5.12 2.09 5.12 4.75m-27.61-2.18V10h2.64v9.26c0 2.76 1.1 3.99 3.62 3.99 2.45 0 4.14-1.62 4.14-4.72V10h2.64v15.33h-2.64v-2.51c-.98 1.81-2.79 2.82-4.84 2.82-3.53 0-5.55-2.42-5.55-6.65m-7.16 1.59c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55c-.46.12-.98.25-1.78.25-3.28 0-4.88-1.93-4.88-4.78v-8.19H85V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zm-18.95-2.91c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-17.26-4.75c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55c-.46.12-.98.25-1.78.25-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zm-6.89-.8c0 3.5-2.08 5.86-7.08 5.86-3.89 0-5.7-.77-7.27-1.56v-2.82c1.87.98 4.75 1.69 7.42 1.69 3.04 0 4.17-1.2 4.17-2.97s-1.1-2.73-4.94-3.65c-4.54-1.1-6.56-2.67-6.56-5.98 0-3.13 2.39-5.46 7.08-5.46 2.91 0 4.78.71 6.16 1.47v2.76c-2.02-1.16-4.2-1.53-6.29-1.53-2.64 0-4.2.92-4.2 2.76 0 1.66 1.29 2.48 4.84 3.37 4.26 1.07 6.66 2.45 6.66 6.07\"/>\n    <path fill=\"var(--tile-color,#ffc716)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M15.896 13.196c-2.464 0-4.86 1.114-6.817 2.835q-.303.304-.607.304c-.169 0-.338-.102-.473-.27l-2.463-2.902c-.135-.17-.202-.338-.202-.473 0-.202.1-.371.303-.573C8.607 9.484 12.217 8 15.896 8c3.678 0 7.29 1.484 10.259 4.117.202.202.303.37.303.573 0 .135-.067.304-.202.473l-2.463 2.902c-.135.168-.304.27-.473.27q-.303 0-.607-.304c-1.958-1.721-4.353-2.835-6.817-2.835m0 10.867c-2.733 0-4.96-2.228-4.96-4.927 0-2.7 2.227-4.927 4.96-4.927s4.96 2.193 4.96 4.927-2.227 4.927-4.96 4.927\"/>\n</svg>\n";
function $498a5dc059f68f6e$export$2bc88a281410ffa7(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Statuspage' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $9b7a1b046861a04a$export$f827d3c5a9c3f644), {
        svg: $498a5dc059f68f6e$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::547909cc6b5dd84f765ef41fd848647b>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
var $d4a2fbda144b1191$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, #101214)\" fill-rule=\"evenodd\" d=\"M10.594 18.563v-7.97h7.969v7.97zm3.808-6.488-.163.429c-.235.615-.352.922-.572 1.155s-.52.368-1.12.638l-.222.1v.357l.222.099c.6.27.9.405 1.12.638s.337.54.572 1.156l.163.428h.347l.163-.429c.235-.615.352-.922.572-1.155s.52-.368 1.12-.638l.221-.1v-.357l-.22-.1c-.601-.269-.901-.404-1.121-.637s-.337-.54-.572-1.155l-.164-.429z\" clip-rule=\"evenodd\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M14.813 7.195 10.125 4.5 5.438 7.195v5.39l3.75 2.157V9.187h5.625z\"/>\n</svg>\n";
function $d4a2fbda144b1191$export$290a0f24614cde9f(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Studio' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $9b5b994dd561b600$export$be58b4326e23250f), {
        svg: $d4a2fbda144b1191$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::9f55f424cde2b5fe1f1eee28320c6ad8>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $c66fc654b038e593$var$svg = "<svg height=\"100%\" viewBox=\"0 0 124 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M116.71 25.64c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49m-13.48-6.2c0-1.17.77-1.84 1.84-1.84s1.84.67 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zm-15.3-7.66c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.47-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V3.59h2.64v21.74zm-27.41-6.34V10h2.64v9.26c0 2.76 1.1 3.99 3.62 3.99 2.45 0 4.14-1.63 4.14-4.72V10h2.64v15.33h-2.64v-2.51c-.98 1.81-2.79 2.82-4.85 2.82-3.53 0-5.55-2.42-5.55-6.65m-7.16 1.59c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55a6.3 6.3 0 0 1-1.78.25c-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zm-6.89-.8c0 3.5-2.08 5.86-7.08 5.86-3.89 0-5.7-.77-7.27-1.56v-2.82c1.87.98 4.75 1.69 7.42 1.69 3.04 0 4.17-1.2 4.17-2.97s-1.1-2.73-4.94-3.65c-4.54-1.1-6.56-2.67-6.56-5.98 0-3.13 2.39-5.46 7.08-5.46 2.91 0 4.78.71 6.16 1.47v2.76c-2.02-1.16-4.2-1.53-6.29-1.53-2.64 0-4.2.92-4.2 2.76 0 1.66 1.29 2.48 4.85 3.37 4.26 1.07 6.66 2.45 6.66 6.07\"/>\n    <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, #101214)\" fill-rule=\"evenodd\" d=\"M14.125 24.75V14.125H24.75V24.75zm5.078-8.65-.218.571c-.312.82-.469 1.23-.762 1.541s-.694.49-1.494.85l-.295.133v.476l.295.133c.8.36 1.2.54 1.494.85.293.311.45.721.762 1.541l.218.572h.462l.218-.572c.313-.82.469-1.23.762-1.54s.694-.491 1.494-.851l.295-.133v-.476l-.295-.132c-.8-.36-1.2-.54-1.494-.85-.293-.312-.45-.722-.762-1.542l-.218-.571z\" clip-rule=\"evenodd\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M19.75 9.594 13.5 6 7.25 9.594v7.187l5 2.875V12.25h7.5z\"/>\n</svg>\n";
function $c66fc654b038e593$export$273fd56580e523ae(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Studio' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $9b7a1b046861a04a$export$f827d3c5a9c3f644), {
        svg: $c66fc654b038e593$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::548aca21494c6e3d39de8ad380612aed>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
var $7f7edb4e357e2b13$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#fb9700)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, #101214)\" fill-rule=\"evenodd\" d=\"m9.297 8.753 2.277-5.073h.858l2.277 5.073 5.529.598.265.816-4.121 3.734 1.14 5.442-.695.505-4.824-2.766-4.824 2.766-.695-.505 1.14-5.442-4.121-3.733.265-.817zm.777 6.415v-.678a1.857 1.857 0 0 1 3.715 0v.613a3.6 3.6 0 0 1-1.886.548h-.053a3.6 3.6 0 0 1-1.776-.483m1.858-3.134a1.393 1.393 0 1 0 0-2.786 1.393 1.393 0 0 0 0 2.786\" clip-rule=\"evenodd\"/>\n</svg>\n";
function $7f7edb4e357e2b13$export$4b05688514531169(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Talent' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $9b5b994dd561b600$export$be58b4326e23250f), {
        svg: $7f7edb4e357e2b13$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::5789a2ba9d9ad5ee943d0005b148e594>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $1f1b8db51b42626f$var$svg = "<svg height=\"100%\" viewBox=\"0 0 122 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M117.1 20.58c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55c-.46.12-.98.25-1.78.25-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zm-7.33-4.23v8.99h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.51c.98-1.81 2.79-2.82 4.85-2.82 3.53 0 5.55 2.42 5.55 6.66m-22.92-4.26c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.67-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2H82.4c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-14.47.57c-.21.06-.67.12-1.35.12-2.51 0-4.11-1.19-4.11-4.02V3.59h2.64V21.1c0 1.38.92 1.87 2.06 1.87.28 0 .46 0 .77-.03zm-20.75-7.63c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.47-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zM40.28 5.19h15.09v2.64H49.2v17.51h-2.76V7.82h-6.16z\"/>\n    <path fill=\"var(--tile-color,#fb9700)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"m16.577 4.907 3.035 6.763 7.372.797.354 1.09-5.495 4.977 1.52 7.257-.927.672-6.431-3.687-6.433 3.687-.926-.672 1.52-7.257-5.495-4.978.353-1.089 7.372-.797 3.035-6.763zm-.668 11.936a2.476 2.476 0 0 0-2.476 2.477v.904a4.8 4.8 0 0 0 2.369.644h.07a4.8 4.8 0 0 0 2.514-.73v-.818a2.477 2.477 0 0 0-2.477-2.477m0-4.511a1.857 1.857 0 1 0 0 3.714 1.857 1.857 0 0 0 0-3.714\"/>\n</svg>\n";
function $1f1b8db51b42626f$export$1b3979d995ebbc6e(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Talent' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $9b7a1b046861a04a$export$f827d3c5a9c3f644), {
        svg: $1f1b8db51b42626f$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2a7617bb15f45b06b307ddb34a89ff24>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
var $a04a36d44116debe$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M8.06 11.25a2.63 2.63 0 1 0 0-5.25 2.63 2.63 0 0 0 0 5.25m7.88 0a2.63 2.63 0 1 0 0-5.25 2.63 2.63 0 0 0 0 5.25m.17 1.31a2.89 2.89 0 0 1 2.89 2.9V18h-7.22l1.66-3.67a2.89 2.89 0 0 1 2.67-1.77M5 15.63V18h4.81l1.31-2.81a2.63 2.63 0 0 0-2.62-2.63h-.44A3.06 3.06 0 0 0 5 15.63\"/>\n</svg>\n";
function $a04a36d44116debe$export$1bcbc9c337da86da(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Teams' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $9b5b994dd561b600$export$be58b4326e23250f), {
        svg: $a04a36d44116debe$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::767fa2606cdc14e785d5959f2e07c247>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $a982aa43c10022ed$var$svg = "<svg height=\"100%\" viewBox=\"0 0 127 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M126.58 21.16c0 2.55-1.66 4.48-5.77 4.48-2.3 0-4.17-.52-5.34-1.13v-2.79c1.32.77 3.53 1.5 5.46 1.5 2.02 0 3.07-.83 3.07-2.02 0-1.16-.89-1.84-3.8-2.54-3.4-.83-4.84-2.15-4.84-4.66 0-2.67 2.05-4.29 5.55-4.29 1.99 0 3.8.49 4.94 1.1v2.73c-1.84-.92-3.34-1.41-4.97-1.41-1.93 0-2.97.67-2.97 1.87 0 1.07.74 1.75 3.56 2.42 3.4.83 5.12 2.09 5.12 4.75m-24.66-4.36v8.53h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 2.61 0 4.39 1.32 5.15 3.74.86-2.36 2.91-3.74 5.46-3.74 3.44 0 5.34 2.33 5.34 6.66v8.99h-2.64v-8.52c0-3.16-1.1-4.72-3.62-4.72-2.45 0-4.14 1.63-4.14 4.72m-28.33.84c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zM61.99 12.08c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2H57.55c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zM40.28 5.19h15.09v2.64H49.2v17.51h-2.76V7.82h-6.16z\"/>\n    <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M10.75 14.83a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7m10.5 0a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7m.23 1.75a3.86 3.86 0 0 1 3.86 3.86v3.72h-9.62l2.21-5.23a3.86 3.86 0 0 1 3.55-2.35M6.67 20.67v3.5h6.42l1.75-4.08a3.5 3.5 0 0 0-3.5-3.5h-.58a4.08 4.08 0 0 0-4.08 4.08\"/>\n</svg>\n";
function $a982aa43c10022ed$export$bfd8d1c4da84ce71(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Teams' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $9b7a1b046861a04a$export$f827d3c5a9c3f644), {
        svg: $a982aa43c10022ed$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2fc7b25031952cd94704eefaa85d7de4>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
var $846cd6bc1530edeb$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#1558bc)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, white)\" d=\"M9.39 18.23a.95.95 0 0 0 .95-.95V5.38a.95.95 0 0 0-.95-.95H5.38a.95.95 0 0 0-.95.95v11.91c0 .52.42.95.95.95zm9.23-5.46a.95.95 0 0 0 .95-.95V5.38a.95.95 0 0 0-.95-.95h-4.01a.95.95 0 0 0-.95.95v6.44c0 .52.42.95.95.95z\"/>\n</svg>\n";
var $846cd6bc1530edeb$var$customThemeSvg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--themed-icon-color, currentcolor)\" d=\"M18 0a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6V6a6 6 0 0 1 6-6zM5.379 4.43a.95.95 0 0 0-.948.949v11.907c0 .523.424.948.948.948H9.39a.95.95 0 0 0 .947-.948V5.38a.95.95 0 0 0-.947-.948zm9.23 0a.95.95 0 0 0-.947.949v6.44c0 .523.423.948.947.949h4.012a.95.95 0 0 0 .948-.949V5.38a.95.95 0 0 0-.948-.948z\"/>\n</svg>\n";
function $846cd6bc1530edeb$export$4384da9b8b140bf4(_ref) {
    var iconColor = _ref.iconColor, size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Trello' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $9b5b994dd561b600$export$be58b4326e23250f), {
        svg: $846cd6bc1530edeb$var$svg,
        customThemeSvg: $846cd6bc1530edeb$var$customThemeSvg,
        iconColor: iconColor,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b73a20da143650f747e32cb182c99798>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $d346c3580de5e974$var$svg = "<svg height=\"100%\" viewBox=\"0 0 113 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M104.97 25.64c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49M96.21 25.3c-.21.06-.67.12-1.35.12-2.51 0-4.11-1.19-4.11-4.02V3.59h2.64V21.1c0 1.38.92 1.87 2.06 1.87.28 0 .46 0 .77-.03zm-8 0c-.21.06-.67.12-1.35.12-2.51 0-4.11-1.19-4.11-4.02V3.59h2.64V21.1c0 1.38.92 1.87 2.06 1.87.28 0 .46 0 .77-.03zM72.86 12.09c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.67-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2H68.42c.37 2.61 2.05 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-19.48-8.44v9.05h-2.58V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.67-5.43 3.93M40.28 5.19h15.09v2.64H49.2v17.51h-2.76V7.82h-6.16z\"/>\n    <path fill=\"var(--tile-color,#1558bc)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, white)\" d=\"M12.9 24c.62 0 1.13-.49 1.13-1.1V9.1c0-.61-.5-1.1-1.13-1.1H8.13C7.51 8 7 8.49 7 9.1v13.8c0 .61.5 1.1 1.13 1.1zm10.97-6.34c.62 0 1.13-.49 1.13-1.1V9.1c0-.61-.5-1.1-1.13-1.1H19.1c-.62 0-1.13.49-1.13 1.1v7.47c0 .61.5 1.1 1.13 1.1z\"/>\n</svg>\n";
function $d346c3580de5e974$export$1b13139dfc0336af(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Trello' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $9b7a1b046861a04a$export$f827d3c5a9c3f644), {
        svg: $d346c3580de5e974$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}





var $5FkrB = parcelRequire("5FkrB");
var $7752965ed79b5f2a$var$_excluded = [
    "size",
    "shouldUseNewLogoDesign"
];
/**
 * Creates a component that renders the new logo design.
 *
 * @param LegacyComponent - The legacy logo component (no longer used).
 * @param NewComponent - The new logo component.
 * @returns A component that renders the new logo.
 */ var $7752965ed79b5f2a$export$e30d2ddc605f6bb = function createFeatureFlaggedComponent(_LegacyComponent, NewComponent) {
    // Note: textColor and iconColor aren't supported on all new logos
    // These props will be deprecated in the future
    return function(_ref) {
        var size = _ref.size, _shouldUseNewLogoDesign = _ref.shouldUseNewLogoDesign, props = (0, $636d9018b4e7304e$export$2e2bcd8739ae039)(_ref, $7752965ed79b5f2a$var$_excluded);
        // Size defaults need to be set, as the temp library had different defaults
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(NewComponent, (0, $3305f3b7d3cad1d2$export$2e2bcd8739ae039)({
            size: size || 'medium'
        }, props));
    };
};





var $5FkrB = parcelRequire("5FkrB");
var $8d9471b61f79a2a7$var$_excluded = [
    "size",
    "shouldUseNewLogoDesign"
];
/**
 * Creates a component that renders the new logo design.
 *
 * @param LegacyComponent - The legacy logo component (no longer used).
 * @param NewComponent - The new logo component.
 * @returns A component that renders the new logo.
 */ var $8d9471b61f79a2a7$export$436fcf6e31fbacea = function createFeatureFlaggedServiceCollectionComponent(_LegacyComponent, NewComponent) {
    // Note: textColor and iconColor aren't supported on all new logos
    // These props will be deprecated in the future
    return function(_ref) {
        var size = _ref.size, _shouldUseNewLogoDesign = _ref.shouldUseNewLogoDesign, props = (0, $636d9018b4e7304e$export$2e2bcd8739ae039)(_ref, $8d9471b61f79a2a7$var$_excluded);
        // Size defaults need to be set, as the temp library had different defaults
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(NewComponent, (0, $3305f3b7d3cad1d2$export$2e2bcd8739ae039)({
            size: size || 'medium'
        }, props));
    };
};



var $5FkrB = parcelRequire("5FkrB");




var $1c67e9a6f1bb1a6f$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor;
    var colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $cc7f4c450b6535cc$export$bbacc3980e0f3029)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" focusable=\"false\" aria-hidden=\"true\">\n      <path\n        d=\"M27.545 24.378 16.96 3.208c-.208-.458-.417-.541-.667-.541-.208 0-.458.083-.708.5-1.5 2.375-2.167 5.125-2.167 8 0 4.001 2.042 7.752 5.042 13.794.334.667.584.792 1.167.792h7.335c.541 0 .833-.208.833-.625 0-.208-.042-.333-.25-.75M12.168 14.377c-.834-1.25-1.084-1.334-1.292-1.334s-.333.083-.708.834L4.875 24.46c-.167.334-.208.459-.208.625 0 .334.291.667.916.667h7.46c.5 0 .875-.416 1.083-1.208.25-1 .334-1.876.334-2.917 0-2.917-1.292-5.751-2.292-7.251z\"\n        fill=\"".concat(colors.iconColor, "\"\n      />\n    </svg>");
};
var $1c67e9a6f1bb1a6f$export$84109e099492cb5f = function AtlassianAdminIcon(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Atlassian Admin' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $61c2bd5f28c47c3c$export$438460117ae6b7ee).size : _ref2$size, testId = _ref2.testId, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $61c2bd5f28c47c3c$export$438460117ae6b7ee).textColor : _ref2$textColor, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $61c2bd5f28c47c3c$export$438460117ae6b7ee).iconColor : _ref2$iconColor;
    var _useThemeObserver = (0, $b621ed2cc6a05fa8$export$3dd7971102e44fa8)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $96958b5ae3603ec3$export$2e2bcd8739ae039), {
        appearance: appearance,
        svg: $1c67e9a6f1bb1a6f$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        label: label,
        size: size,
        testId: testId,
        textColor: textColor
    });
};



var $5FkrB = parcelRequire("5FkrB");




var $02204c990345b447$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor;
    var colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $cc7f4c450b6535cc$export$bbacc3980e0f3029)(appearance, colorMode);
    return "<svg\n      fill=\"none\"\n      height=\"32\"\n      xmlns=\"http://www.w3.org/2000/svg\"\n      viewBox=\"0 0 295 32\"\n      focusable=\"false\"\n      aria-hidden=\"true\"\n    >\n      <path\n        d=\"M294.31 16.348v8.985h-2.637v-9.261c0-2.76-1.104-3.987-3.619-3.987-2.453 0-4.14 1.626-4.14 4.723v8.525h-2.637V10h2.637v2.515c.982-1.81 2.791-2.822 4.846-2.822 3.526 0 5.55 2.423 5.55 6.655M274.168 5.952c0-1.165.766-1.84 1.84-1.84 1.073 0 1.84.675 1.84 1.84s-.767 1.84-1.84 1.84c-1.074 0-1.84-.675-1.84-1.84m.49 19.381V10h2.638v15.333zm-14.069-8.525v8.525h-2.637v-9.261c0-2.76-1.104-3.987-3.619-3.987-2.453 0-4.14 1.626-4.14 4.723v8.525h-2.637V10h2.637v2.515c.981-1.81 2.791-2.822 4.845-2.822 2.607 0 4.386 1.319 5.152 3.742.859-2.362 2.914-3.742 5.459-3.742 3.435 0 5.336 2.331 5.336 6.655v8.985h-2.637v-8.525c0-3.159-1.104-4.723-3.619-4.723-2.453 0-4.14 1.626-4.14 4.723m-28.327.859c0 3.68 1.472 5.52 4.202 5.52 2.361 0 4.477-1.503 4.477-4.907v-1.227c0-3.404-1.932-4.906-4.171-4.906-2.974 0-4.508 1.962-4.508 5.52m8.679 7.666v-2.76c-.981 2.024-2.821 3.067-5.183 3.067-4.078 0-6.133-3.465-6.133-7.973 0-4.324 2.147-7.974 6.44-7.974 2.239 0 3.956 1.012 4.876 3.006V3.59h2.637v21.742zm-22.021-4.017c-1.533 0-3.097-.184-4.814-.521l-1.687 4.538h-3.097l7.942-20.148h3.496l7.943 20.148h-3.097l-1.687-4.569c-1.809.368-3.373.552-4.999.552m0-2.453c1.288 0 2.607-.154 4.171-.399l-4.079-11.04-4.078 11.07c1.502.246 2.76.369 3.986.369\"\n        fill=\"".concat(colors.textColor, "\"\n      />\n      <path\n        d=\"M107.447 10.828c0 2.972 1.345 5.308 6.795 6.37 3.185.707 3.893 1.203 3.893 2.264 0 1.062-.708 1.699-2.973 1.699-2.619 0-5.733-.92-7.785-2.123v4.812c1.627.779 3.751 1.699 7.785 1.699 5.662 0 7.856-2.548 7.856-6.228m0 .07c0-3.538-1.84-5.166-7.148-6.299-2.902-.637-3.61-1.274-3.61-2.194 0-1.132 1.062-1.628 2.973-1.628 2.335 0 4.6.708 6.794 1.7V6.368c-1.557-.779-3.892-1.345-6.653-1.345-5.237 0-7.927 2.265-7.927 5.945m72.475-5.803v20.172h4.318V9.978l1.769 4.034 6.087 11.325h5.379V5.165h-4.247v13.023l-1.628-3.822-4.883-9.2zm-27.319 0h-4.671v20.172h4.671zm-10.05 14.155c0-3.538-1.841-5.166-7.149-6.298-2.902-.637-3.609-1.274-3.609-2.194 0-1.133 1.061-1.628 2.972-1.628 2.336 0 4.601.707 6.795 1.698v-4.6c-1.557-.779-3.893-1.345-6.653-1.345-5.238 0-7.927 2.265-7.927 5.945 0 2.973 1.345 5.309 6.794 6.37 3.185.708 3.893 1.203 3.893 2.265s-.708 1.699-2.973 1.699c-2.618 0-5.733-.92-7.785-2.124v4.813c1.628.779 3.751 1.699 7.785 1.699 5.592 0 7.857-2.548 7.857-6.3M71.069 5.165v20.172h9.625l1.486-4.389h-6.44V5.165zm-19.039 0v4.318h5.167v15.854h4.741V9.483h5.592V5.165zm-6.866 0h-6.157L32 25.336h5.379l.99-3.397c1.204.354 2.478.566 3.752.566s2.548-.212 3.751-.566l.991 3.397h5.379c-.07 0-7.078-20.17-7.078-20.17zM42.05 18.26c-.92 0-1.77-.142-2.548-.354L42.05 9.13l2.548 8.776a9.6 9.6 0 0 1-2.548.354M97.326 5.165H91.17l-7.08 20.171h5.38l.99-3.397c1.203.354 2.477.566 3.751.566s2.548-.212 3.751-.566l.991 3.397h5.379zM94.212 18.26c-.92 0-1.77-.142-2.548-.354l2.548-8.776 2.548 8.776a9.6 9.6 0 0 1-2.548.354m75.306-13.095h-6.157l-7.007 20.171h5.379l.991-3.397c1.203.354 2.477.566 3.751.566s2.548-.212 3.751-.566l.991 3.397h5.379zm-3.043 13.094c-.92 0-1.77-.142-2.548-.354l2.548-8.776 2.548 8.776a10 10 0 0 1-2.548.354M22.878 24.378 12.293 3.208c-.208-.458-.416-.541-.666-.541-.209 0-.459.083-.709.5-1.5 2.375-2.167 5.125-2.167 8 0 4.001 2.042 7.752 5.043 13.794.333.667.583.792 1.166.792h7.335c.542 0 .833-.208.833-.625 0-.208-.041-.333-.25-.75M7.501 14.377c-.833-1.25-1.083-1.334-1.292-1.334s-.333.083-.708.834L.208 24.46c-.166.334-.208.459-.208.625 0 .334.292.667.917.667h7.46c.5 0 .874-.416 1.083-1.208.25-1 .333-1.876.333-2.917 0-2.917-1.292-5.751-2.292-7.251z\"\n        fill=\"").concat(colors.iconColor, "\"\n      />\n    </svg>");
};
var $02204c990345b447$export$f845d9b9254f0541 = function AtlassianAdminLogo(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Atlassian Admin' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $61c2bd5f28c47c3c$export$438460117ae6b7ee).size : _ref2$size, testId = _ref2.testId, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $61c2bd5f28c47c3c$export$438460117ae6b7ee).textColor : _ref2$textColor, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $61c2bd5f28c47c3c$export$438460117ae6b7ee).iconColor : _ref2$iconColor;
    var _useThemeObserver = (0, $b621ed2cc6a05fa8$export$3dd7971102e44fa8)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $96958b5ae3603ec3$export$2e2bcd8739ae039), {
        appearance: appearance,
        iconColor: iconColor,
        label: label,
        size: size,
        svg: $02204c990345b447$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};



var $5FkrB = parcelRequire("5FkrB");




var $97a4280f75f7a22e$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor;
    var colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $cc7f4c450b6535cc$export$bbacc3980e0f3029)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" focusable=\"false\" aria-hidden=\"true\">\n      <path\n        d=\"M27.545 24.378 16.96 3.208c-.208-.458-.417-.541-.667-.541-.208 0-.458.083-.708.5-1.5 2.375-2.167 5.125-2.167 8 0 4.001 2.042 7.752 5.042 13.794.334.667.584.792 1.167.792h7.335c.541 0 .833-.208.833-.625 0-.208-.042-.333-.25-.75M12.168 14.377c-.834-1.25-1.084-1.334-1.292-1.334s-.333.083-.708.834L4.875 24.46c-.167.334-.208.459-.208.625 0 .334.291.667.916.667h7.46c.5 0 .875-.416 1.083-1.208.25-1 .334-1.876.334-2.917 0-2.917-1.292-5.751-2.292-7.251z\"\n        fill=\"".concat(colors.iconColor, "\"\n      />\n    </svg>");
};
var $97a4280f75f7a22e$export$74517ed253186308 = function AtlassianAdministrationIcon(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Atlassian Administration' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $61c2bd5f28c47c3c$export$438460117ae6b7ee).size : _ref2$size, testId = _ref2.testId, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $61c2bd5f28c47c3c$export$438460117ae6b7ee).textColor : _ref2$textColor, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $61c2bd5f28c47c3c$export$438460117ae6b7ee).iconColor : _ref2$iconColor;
    var _useThemeObserver = (0, $b621ed2cc6a05fa8$export$3dd7971102e44fa8)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $96958b5ae3603ec3$export$2e2bcd8739ae039), {
        appearance: appearance,
        svg: $97a4280f75f7a22e$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        label: label,
        size: size,
        testId: testId,
        textColor: textColor
    });
};



var $5FkrB = parcelRequire("5FkrB");




var $412bfa0d5894b3c6$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor;
    var colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $cc7f4c450b6535cc$export$bbacc3980e0f3029)(appearance, colorMode);
    return "<svg\n      fill=\"none\"\n      height=\"32\"\n      xmlns=\"http://www.w3.org/2000/svg\"\n      viewBox=\"0 0 404 32\"\n      focusable=\"false\"\n      aria-hidden=\"true\"\n    >\n      <path\n        d=\"M403.77 16.348v8.985h-2.637v-9.261c0-2.76-1.104-3.987-3.619-3.987-2.453 0-4.14 1.626-4.14 4.723v8.525h-2.637V10h2.637v2.515c.981-1.81 2.791-2.822 4.845-2.822 3.527 0 5.551 2.423 5.551 6.655m-23.336 9.292c-4.6 0-7.299-3.404-7.299-8.004s2.699-7.943 7.299-7.943c4.57 0 7.237 3.343 7.237 7.943s-2.667 8.004-7.237 8.004m0-13.493c-3.281 0-4.723 2.576-4.723 5.489s1.442 5.55 4.723 5.55c3.251 0 4.661-2.637 4.661-5.55s-1.41-5.49-4.661-5.49zm-13.488-6.195c0-1.165.767-1.84 1.84-1.84 1.074 0 1.84.675 1.84 1.84s-.766 1.84-1.84 1.84c-1.073 0-1.84-.675-1.84-1.84m.491 19.381V10h2.637v15.333zm-7.461-4.753c0 1.35.797 2.27 2.422 2.27.614 0 1.196-.123 1.656-.215v2.545a6.3 6.3 0 0 1-1.778.245c-3.282 0-4.876-1.932-4.876-4.784v-8.188h-2.484V10h2.484V6.75h2.576V10h4.078v2.453h-4.078zm-18.943-2.913c0 3.68 1.472 5.52 4.202 5.52 2.361 0 4.477-1.503 4.477-4.907v-1.227c0-3.404-1.932-4.906-4.171-4.906-2.974 0-4.508 1.962-4.508 5.52m8.679 7.666v-2.76c-.981 2.024-2.821 3.067-5.183 3.067-4.078 0-6.133-3.465-6.133-7.973 0-4.324 2.147-7.974 6.44-7.974 2.239 0 3.956 1.012 4.876 3.006V10h2.637v15.333zm-17.793-9.046v9.046h-2.576V10h2.576v2.699c.89-1.81 2.423-3.098 5.428-2.914v2.576c-3.373-.337-5.428.675-5.428 3.926m-10.037 4.293c0 1.35.797 2.27 2.423 2.27.613 0 1.196-.123 1.656-.215v2.545c-.46.123-.982.245-1.779.245-3.281 0-4.876-1.932-4.876-4.784v-8.188h-2.484V10h2.484V6.75h2.576V10h4.079v2.453h-4.079zm-6.696.583c0 2.545-1.656 4.477-5.765 4.477-2.3 0-4.171-.521-5.336-1.135v-2.79c1.319.766 3.527 1.502 5.459 1.502 2.024 0 3.066-.828 3.066-2.024 0-1.165-.889-1.84-3.802-2.545-3.404-.828-4.846-2.147-4.846-4.661 0-2.668 2.055-4.294 5.551-4.294 1.993 0 3.803.491 4.937 1.104v2.73c-1.84-.92-3.342-1.411-4.968-1.411-1.932 0-2.974.675-2.974 1.87 0 1.074.736 1.749 3.557 2.423 3.404.828 5.121 2.086 5.121 4.754M297.497 5.952c0-1.165.767-1.84 1.84-1.84 1.074 0 1.84.675 1.84 1.84s-.766 1.84-1.84 1.84c-1.073 0-1.84-.675-1.84-1.84m.491 19.381V10h2.637v15.333zm-3.678-8.985v8.985h-2.637v-9.261c0-2.76-1.104-3.987-3.619-3.987-2.453 0-4.14 1.626-4.14 4.723v8.525h-2.637V10h2.637v2.515c.982-1.81 2.791-2.822 4.846-2.822 3.526 0 5.55 2.423 5.55 6.655M274.168 5.952c0-1.165.766-1.84 1.84-1.84 1.073 0 1.84.675 1.84 1.84s-.767 1.84-1.84 1.84c-1.074 0-1.84-.675-1.84-1.84m.49 19.381V10h2.638v15.333zm-14.069-8.525v8.525h-2.637v-9.261c0-2.76-1.104-3.987-3.619-3.987-2.453 0-4.14 1.626-4.14 4.723v8.525h-2.637V10h2.637v2.515c.981-1.81 2.791-2.822 4.845-2.822 2.607 0 4.386 1.319 5.152 3.742.859-2.362 2.914-3.742 5.459-3.742 3.435 0 5.336 2.331 5.336 6.655v8.985h-2.637v-8.525c0-3.159-1.104-4.723-3.619-4.723-2.453 0-4.14 1.626-4.14 4.723m-28.327.859c0 3.68 1.472 5.52 4.202 5.52 2.361 0 4.477-1.503 4.477-4.907v-1.227c0-3.404-1.932-4.906-4.171-4.906-2.974 0-4.508 1.962-4.508 5.52m8.679 7.666v-2.76c-.981 2.024-2.821 3.067-5.183 3.067-4.078 0-6.133-3.465-6.133-7.973 0-4.324 2.147-7.974 6.44-7.974 2.239 0 3.956 1.012 4.876 3.006V3.59h2.637v21.742zm-22.021-4.017c-1.533 0-3.097-.184-4.814-.521l-1.687 4.538h-3.097l7.942-20.148h3.496l7.943 20.148h-3.097l-1.687-4.569c-1.809.368-3.373.552-4.999.552m0-2.453c1.288 0 2.607-.154 4.171-.399l-4.079-11.04-4.078 11.07c1.502.246 2.76.369 3.986.369\"\n        fill=\"".concat(colors.textColor, "\"\n      />\n      <path\n        d=\"M107.447 10.828c0 2.972 1.345 5.308 6.795 6.37 3.185.707 3.893 1.203 3.893 2.264 0 1.062-.708 1.699-2.973 1.699-2.619 0-5.733-.92-7.785-2.123v4.812c1.627.779 3.751 1.699 7.785 1.699 5.662 0 7.856-2.548 7.856-6.228m0 .07c0-3.538-1.84-5.166-7.148-6.299-2.902-.637-3.61-1.274-3.61-2.194 0-1.132 1.062-1.628 2.973-1.628 2.335 0 4.6.708 6.794 1.7V6.368c-1.557-.779-3.892-1.345-6.653-1.345-5.237 0-7.927 2.265-7.927 5.945m72.475-5.803v20.172h4.318V9.978l1.769 4.034 6.087 11.325h5.379V5.165h-4.247v13.023l-1.628-3.822-4.883-9.2zm-27.319 0h-4.671v20.172h4.671zm-10.05 14.155c0-3.538-1.841-5.166-7.149-6.298-2.902-.637-3.609-1.274-3.609-2.194 0-1.133 1.061-1.628 2.972-1.628 2.336 0 4.601.707 6.795 1.698v-4.6c-1.557-.779-3.893-1.345-6.653-1.345-5.238 0-7.927 2.265-7.927 5.945 0 2.973 1.345 5.309 6.794 6.37 3.185.708 3.893 1.203 3.893 2.265s-.708 1.699-2.973 1.699c-2.618 0-5.733-.92-7.785-2.124v4.813c1.628.779 3.751 1.699 7.785 1.699 5.592 0 7.857-2.548 7.857-6.3M71.069 5.165v20.172h9.625l1.486-4.389h-6.44V5.165zm-19.039 0v4.318h5.167v15.854h4.741V9.483h5.592V5.165zm-6.866 0h-6.157L32 25.336h5.379l.99-3.397c1.204.354 2.478.566 3.752.566s2.548-.212 3.751-.566l.991 3.397h5.379c-.07 0-7.078-20.17-7.078-20.17zM42.05 18.26c-.92 0-1.77-.142-2.548-.354L42.05 9.13l2.548 8.776a9.6 9.6 0 0 1-2.548.354M97.326 5.165H91.17l-7.08 20.171h5.38l.99-3.397c1.203.354 2.477.566 3.751.566s2.548-.212 3.751-.566l.991 3.397h5.379zM94.212 18.26c-.92 0-1.77-.142-2.548-.354l2.548-8.776 2.548 8.776a9.6 9.6 0 0 1-2.548.354m75.306-13.095h-6.157l-7.007 20.171h5.379l.991-3.397c1.203.354 2.477.566 3.751.566s2.548-.212 3.751-.566l.991 3.397h5.379zm-3.043 13.094c-.92 0-1.77-.142-2.548-.354l2.548-8.776 2.548 8.776a10 10 0 0 1-2.548.354M22.878 24.378 12.293 3.208c-.208-.458-.416-.541-.666-.541-.209 0-.459.083-.709.5-1.5 2.375-2.167 5.125-2.167 8 0 4.001 2.042 7.752 5.043 13.794.333.667.583.792 1.166.792h7.335c.542 0 .833-.208.833-.625 0-.208-.041-.333-.25-.75M7.501 14.377c-.833-1.25-1.083-1.334-1.292-1.334s-.333.083-.708.834L.208 24.46c-.166.334-.208.459-.208.625 0 .334.292.667.917.667h7.46c.5 0 .874-.416 1.083-1.208.25-1 .333-1.876.333-2.917 0-2.917-1.292-5.751-2.292-7.251z\"\n        fill=\"").concat(colors.iconColor, "\"\n      />\n    </svg>");
};
var $412bfa0d5894b3c6$export$833abe6c2ce5ebfd = function AtlassianAdministrationLogo(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Atlassian Administration' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $61c2bd5f28c47c3c$export$438460117ae6b7ee).size : _ref2$size, testId = _ref2.testId, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $61c2bd5f28c47c3c$export$438460117ae6b7ee).textColor : _ref2$textColor, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $61c2bd5f28c47c3c$export$438460117ae6b7ee).iconColor : _ref2$iconColor;
    var _useThemeObserver = (0, $b621ed2cc6a05fa8$export$3dd7971102e44fa8)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $96958b5ae3603ec3$export$2e2bcd8739ae039), {
        appearance: appearance,
        iconColor: iconColor,
        label: label,
        size: size,
        svg: $412bfa0d5894b3c6$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};



var $5FkrB = parcelRequire("5FkrB");




// TODO: This is where we need to add tokens for all appearance color values
var $8ea89a764ffd4a31$export$362a25f017e2bc8a = function getColorsFromAppearanceOldLogos(appearance, colorMode) {
    var iconGradientStart, iconGradientStop, iconColor, textColor, atlassianLogoTextColor;
    switch(appearance){
        case 'brand':
            iconGradientStart = '#0052CC';
            iconGradientStop = '#2684FF';
            iconColor = '#2684FF';
            textColor = "var(--ds-text, #292A2E)";
            // This is only used for the top level Atlassian wordmark (see AtlassianLogo
            // or AtlassianStartLogo for example), and is only different for the Brand
            // appearance - a bold brand color. For other appearances,
            // atlassianLogoTextColor is the same as textColor.
            atlassianLogoTextColor = '#0052CC';
            break;
        case 'neutral':
            iconGradientStart = '#344563';
            iconGradientStop = '#7A869A';
            iconColor = '#7A869A';
            textColor = '#505F79';
            atlassianLogoTextColor = '#505F79';
            break;
        case 'inverse':
            iconGradientStart = '#FFFFFF66';
            iconGradientStop = '#FFFFFF';
            iconColor = '#FFFFFF';
            textColor = '#FFFFFF';
            atlassianLogoTextColor = '#FFFFFF';
            break;
    }
    if (colorMode === 'dark' && appearance === 'inverse') {
        iconGradientStart = '#161A1D66';
        iconGradientStop = '#161A1D';
        iconColor = '#161A1D';
        textColor = '#161A1D';
        atlassianLogoTextColor = '#161A1D';
    }
    return {
        iconGradientStart: iconGradientStart,
        iconGradientStop: iconGradientStop,
        iconColor: iconColor,
        textColor: textColor,
        atlassianLogoTextColor: atlassianLogoTextColor
    };
};


var $34224b7af8484c42$var$svg = function svg(_ref, colorMode, id) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor;
    var colors = {
        iconGradientStart: iconColor,
        iconGradientStop: iconColor,
        iconColor: iconColor
    };
    if (appearance) colors = (0, $8ea89a764ffd4a31$export$362a25f017e2bc8a)(appearance, colorMode);
    return "<svg height=\"32\" viewBox=\"0 0 48 48\" xmlns=\"http://www.w3.org/2000/svg\">\n  <defs>\n    <linearGradient id=\"".concat(id, "-a\" x1=\"12.595\" x2=\"12.595\" y1=\"40\" y2=\"30\" gradientUnits=\"userSpaceOnUse\">\n      <stop offset=\"0\" stop-color=\"").concat(colors.iconGradientStart, "\"/>\n      <stop offset=\"1\" stop-color=\"").concat(colors.iconGradientStop, "\"/>\n    </linearGradient>\n    <linearGradient id=\"").concat(id, "-b\" x1=\"28.595\" x2=\"28.595\" y1=\"40\" y2=\"27\" gradientUnits=\"userSpaceOnUse\">\n      <stop offset=\"0\" stop-color=\"").concat(colors.iconGradientStart, "\"/>\n      <stop offset=\"1\" stop-color=\"").concat(colors.iconGradientStop, "\"/>\n    </linearGradient>\n    <linearGradient xlink:href=\"#").concat(id, "-b\" id=\"").concat(id, "-c\" x1=\"20.595\" x2=\"20.595\" y2=\"22\"/>\n    <linearGradient xlink:href=\"#").concat(id, "-b\" id=\"").concat(id, "-d\" x1=\"36.595\" x2=\"36.595\" y2=\"20\"/>\n  </defs>\n  <path d=\"M10.595 30h4v10h-4z\" fill=\"url(#").concat(id, "-a)\"/>\n  <path d=\"M26.595 27h4v13h-4z\" fill=\"url(#").concat(id, "-b)\"/>\n  <path d=\"M18.595 22h4v18h-4z\" fill=\"url(#").concat(id, "-c)\"/>\n  <path d=\"M34.595 20h4v20h-4z\" fill=\"url(#").concat(id, "-d)\"/>\n  <path fill=\"").concat(colors.iconColor, "\" d=\"m9.009 25.414-2.828-2.828 10.127-10.128a5 5 0 0 1 6.605-.411l4.471 3.477a1.5 1.5 0 0 0 1.982-.123l9.815-9.815 2.828 2.828-10.127 10.128a5 5 0 0 1-6.605.411l-4.471-3.477a1.5 1.5 0 0 0-1.982.123l-9.815 9.815Z\" />\n</svg>");
};
var $34224b7af8484c42$export$c42ad8a0b925c762 = function AtlassianAnalyticsIcon(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Atlassian Analytics' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $61c2bd5f28c47c3c$export$438460117ae6b7ee).size : _ref2$size, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $61c2bd5f28c47c3c$export$438460117ae6b7ee).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $61c2bd5f28c47c3c$export$438460117ae6b7ee).textColor : _ref2$textColor, testId = _ref2.testId;
    var _useThemeObserver = (0, $b621ed2cc6a05fa8$export$3dd7971102e44fa8)(), colorMode = _useThemeObserver.colorMode;
    var id = (0, $c797bf80d6171378$export$f680877a34711e37)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $96958b5ae3603ec3$export$2e2bcd8739ae039), {
        appearance: appearance,
        label: label,
        svg: $34224b7af8484c42$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode, id),
        iconColor: iconColor,
        textColor: textColor,
        size: size,
        testId: testId
    });
};



var $5FkrB = parcelRequire("5FkrB");





var $7a3a6eb3b1e795cf$var$svg = function svg(_ref, colorMode, id) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor;
    var colors = {
        iconGradientStart: iconColor,
        iconGradientStop: iconColor,
        textColor: textColor,
        iconColor: iconColor,
        // We treat the word "Atlassian" differently to normal app logos, it has a bold brand look
        atlassianLogoTextColor: textColor
    };
    if (appearance) colors = (0, $8ea89a764ffd4a31$export$362a25f017e2bc8a)(appearance, colorMode);
    return "\n  <svg height=\"32\" viewBox=\"0 0 477 48\" xmlns=\"http://www.w3.org/2000/svg\">\n  <defs>\n    <linearGradient id=\"".concat(id, "-a\" x1=\"447.285\" x2=\"447.285\" y1=\"40\" y2=\"30\" gradientUnits=\"userSpaceOnUse\">\n      <stop offset=\"0\" stop-color=\"").concat(colors.iconGradientStart, "\"/>\n      <stop offset=\"1\" stop-color=\"").concat(colors.iconGradientStop, "\"/>\n    </linearGradient>\n    <linearGradient xlink:href=\"#").concat(id, "-a\" id=\"").concat(id, "-b\" x1=\"463.285\" x2=\"463.285\" y2=\"27\"/>\n    <linearGradient xlink:href=\"#").concat(id, "-a\" id=\"").concat(id, "-c\" x1=\"455.285\" x2=\"455.285\" y2=\"22\"/>\n    <linearGradient xlink:href=\"#").concat(id, "-a\" id=\"").concat(id, "-d\" x1=\"471.285\" x2=\"471.285\" y2=\"20\"/>\n  </defs>\n  <g fill=\"").concat(colors.atlassianLogoTextColor, "\">\n    <path d=\"M106.72 18.359c0 4.201 1.949 7.536 9.572 9.008 4.548.953 5.5 1.689 5.5 3.205 0 1.473-.953 2.425-4.158 2.425-3.725 0-8.142-1.256-11.044-2.988v6.843c2.295 1.126 5.327 2.382 10.957 2.382 7.969 0 11.131-3.551 11.131-8.835m0 0c0-4.981-2.642-7.319-10.091-8.922-4.114-.91-5.111-1.819-5.111-3.118 0-1.646 1.473-2.339 4.201-2.339 3.292 0 6.54.996 9.615 2.382v-6.54c-2.166-1.083-5.5-1.949-9.398-1.949-7.363 0-11.174 3.205-11.174 8.445M209.1 10.346v28.455h6.063V17.103l2.556 5.76 8.575 15.938h7.623V10.346h-6.064V28.71l-2.295-5.327-6.886-13.037H209.1zM163.909 10.346h6.626v28.455h-6.626zM156.263 30.399c0-4.981-2.642-7.319-10.091-8.922-4.114-.91-5.111-1.819-5.111-3.118 0-1.646 1.473-2.339 4.201-2.339 3.292 0 6.54.996 9.615 2.382v-6.54c-2.166-1.083-5.5-1.949-9.398-1.949-7.363 0-11.174 3.205-11.174 8.445 0 4.201 1.949 7.536 9.572 9.008 4.548.953 5.5 1.689 5.5 3.205 0 1.473-.953 2.425-4.158 2.425-3.725 0-8.142-1.256-11.044-2.988v6.843c2.295 1.126 5.327 2.382 10.957 2.382 7.969 0 11.131-3.551 11.131-8.835M55.243 10.346v28.455h13.62l2.145-6.15h-9.095V10.346h-6.67zM28.334 10.346v6.15h7.363v22.305h6.67V16.496h7.882v-6.15H28.334zM18.663 10.346h-8.74L0 38.801h7.579l1.407-4.792a18.852 18.852 0 0 0 10.612 0l1.407 4.792h7.579l-9.922-28.455Zm-4.37 18.533c-1.267 0-2.49-.185-3.647-.524l3.647-12.422 3.647 12.422c-1.157.339-2.38.524-3.647.524ZM92.344 10.346h-8.74l-9.922 28.455h7.579l1.407-4.792a18.852 18.852 0 0 0 10.612 0l1.407 4.792h7.579l-9.922-28.455Zm-4.37 18.533c-1.267 0-2.49-.185-3.647-.524l3.647-12.422 3.647 12.422c-1.157.339-2.38.524-3.647.524ZM194.414 10.346h-8.74l-9.922 28.455h7.579l1.407-4.792a18.852 18.852 0 0 0 10.612 0l1.407 4.792h7.579l-9.922-28.455Zm-4.37 18.533c-1.267 0-2.49-.185-3.647-.524l3.647-12.422 3.647 12.422c-1.157.339-2.38.524-3.647.524Z\"/>\n  </g>\n  <g fill=\"").concat(colors.textColor, "\">\n    <path d=\"m254.776 31.987-2.53 6.809H247.6l11.916-30.225h5.244l11.916 30.225h-4.646l-2.53-6.855c-2.714.552-5.061.828-7.499.828-2.3 0-4.646-.276-7.223-.782Zm13.479-3.496-6.119-16.562-6.119 16.608c2.254.368 4.141.552 5.98.552 1.933 0 3.911-.23 6.257-.598ZM298.984 38.796h-3.957V24.902c0-4.141-1.656-5.981-5.428-5.981-3.681 0-6.211 2.438-6.211 7.085v12.79h-3.957V15.794h3.957v3.772c1.472-2.715 4.187-4.232 7.269-4.232 5.291 0 8.327 3.634 8.327 9.983v13.479ZM320.097 34.656c-1.472 3.036-4.232 4.6-7.775 4.6-6.119 0-9.201-5.199-9.201-11.961 0-6.486 3.22-11.961 9.661-11.961 3.358 0 5.935 1.518 7.314 4.508v-4.048h3.957v23.002h-3.957v-4.14Zm-6.717.92c3.542 0 6.717-2.254 6.717-7.361v-1.84c0-5.106-2.898-7.361-6.256-7.361-4.463 0-6.763 2.944-6.763 8.281 0 5.521 2.208 8.281 6.303 8.281ZM336.196 38.935c-3.772 0-6.165-1.794-6.165-6.027V6.179h3.957v26.269c0 2.07 1.38 2.806 3.083 2.806.414 0 .69 0 1.15-.046v3.542c-.322.092-1.012.184-2.024.184ZM347.328 37.324l-8.327-21.53h4.232l7.361 19.69 7.361-19.69h4.232l-8.695 22.267c-2.576 6.579-4.048 9.983-9.891 9.983-1.979 0-3.083-.184-4.232-.644v-3.404c1.334.414 2.852.552 4.002.552 3.22 0 4.646-2.208 6.533-7.223h-2.576ZM374.698 35.07c.92 0 1.794-.185 2.484-.322v3.818c-.69.184-1.472.368-2.668.368-4.923 0-7.315-2.898-7.315-7.177V19.473h-3.727v-3.68h3.727v-4.877h3.864v4.877h6.119v3.68h-6.119v12.191c0 2.024 1.196 3.405 3.635 3.405ZM384.265 6.961c1.61 0 2.76 1.012 2.76 2.76s-1.15 2.76-2.76 2.76-2.76-1.012-2.76-2.76 1.15-2.76 2.76-2.76Zm-2.024 8.833h3.957v23.002h-3.957V15.794ZM408.416 38.198c-1.38.736-3.496 1.058-5.612 1.058-8.189 0-12.007-4.968-12.007-12.007 0-6.947 3.818-11.915 12.007-11.915 2.07 0 3.68.276 5.475 1.104v3.681c-1.472-.69-3.037-1.104-5.199-1.104-5.98 0-8.419 3.772-8.419 8.235s2.484 8.235 8.511 8.235c2.346 0 3.818-.322 5.244-.828v3.542ZM420.144 39.256c-3.451 0-6.257-.782-8.005-1.702v-4.187c1.978 1.15 5.291 2.254 8.188 2.254 3.037 0 4.601-1.242 4.601-3.036 0-1.749-1.334-2.761-5.705-3.818-5.106-1.242-7.269-3.221-7.269-6.993 0-4.002 3.082-6.44 8.327-6.44 2.99 0 5.705.736 7.407 1.656v4.094c-2.76-1.38-5.014-2.117-7.453-2.117-2.898 0-4.462 1.013-4.462 2.807 0 1.61 1.104 2.622 5.336 3.635 5.106 1.242 7.683 3.128 7.683 7.13 0 3.819-2.484 6.717-8.649 6.717Z\"/>\n  </g>\n  <path fill=\"url(#").concat(id, "-a)\" d=\"M445.285 30h4v10h-4z\"/>\n  <path fill=\"url(#").concat(id, "-b)\" d=\"M461.285 27h4v13h-4z\"/>\n  <path fill=\"url(#").concat(id, "-c)\" d=\"M453.285 22h4v18h-4z\"/>\n  <path fill=\"url(#").concat(id, "-d)\" d=\"M469.285 20h4v20h-4z\"/>\n  <path fill=\"").concat(colors.iconColor, "\" d=\"m443.699 25.414-2.828-2.828 10.127-10.128a5 5 0 0 1 6.605-.411l4.471 3.477a1.5 1.5 0 0 0 1.982-.123l9.815-9.815 2.828 2.828-10.127 10.128a5 5 0 0 1-6.605.411l-4.471-3.477a1.5 1.5 0 0 0-1.982.123l-9.815 9.815Z\"/>\n</svg>");
};
var $7a3a6eb3b1e795cf$export$e6470bfc39010cc4 = function AtlassianAnalyticsLogo(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Atlassian Analytics' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $61c2bd5f28c47c3c$export$438460117ae6b7ee).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $61c2bd5f28c47c3c$export$438460117ae6b7ee).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $61c2bd5f28c47c3c$export$438460117ae6b7ee).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $b621ed2cc6a05fa8$export$3dd7971102e44fa8)(), colorMode = _useThemeObserver.colorMode;
    var id = (0, $c797bf80d6171378$export$f680877a34711e37)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $96958b5ae3603ec3$export$2e2bcd8739ae039), {
        appearance: appearance,
        label: label,
        size: size,
        iconColor: iconColor,
        svg: $7a3a6eb3b1e795cf$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode, id),
        testId: testId,
        textColor: textColor
    });
};



var $5FkrB = parcelRequire("5FkrB");




var $4dbba68b0e2d177f$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor;
    var colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $cc7f4c450b6535cc$export$bbacc3980e0f3029)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" viewBox=\"0 0 32 32\" focusable=\"false\" aria-hidden=\"true\" xmlns=\"http://www.w3.org/2000/svg\">\n      <path fill=".concat(colors.iconColor, " d=\"m25.586 15.819-1.618 9.885c-.106.598-.528.95-1.126.95H9.122c-.598 0-1.02-.352-1.126-.95L5.146 8.08c-.105-.598.212-.985.775-.985h20.123c.562 0 .88.387.773.985l-.773 4.644c-.106.668-.493.95-1.126.95H12.816c-.176 0-.282.105-.246.316l.95 5.84c.035.14.14.246.281.246h4.362c.141 0 .246-.105.282-.246l.668-4.222c.07-.527.422-.738.915-.738h4.75c.703 0 .914.351.808.95\"/>\n    </svg>");
};
var $4dbba68b0e2d177f$export$5fc1066e677788d4 = function BitbucketIcon(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Bitbucket' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $61c2bd5f28c47c3c$export$438460117ae6b7ee).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $61c2bd5f28c47c3c$export$438460117ae6b7ee).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $61c2bd5f28c47c3c$export$438460117ae6b7ee).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $b621ed2cc6a05fa8$export$3dd7971102e44fa8)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $96958b5ae3603ec3$export$2e2bcd8739ae039), {
        appearance: appearance,
        label: label,
        svg: $4dbba68b0e2d177f$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        size: size,
        testId: testId,
        textColor: textColor
    });
};



var $5FkrB = parcelRequire("5FkrB");




var $d9b1388a5ad29f00$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor;
    var colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $cc7f4c450b6535cc$export$bbacc3980e0f3029)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" viewBox=\"0 0 158 32\" focusable=\"false\" aria-hidden=\"true\" xmlns=\"http://www.w3.org/2000/svg\">\n        <path fill=".concat(colors.iconColor, " d=\"m20.46 15.152-1.619 9.885c-.105.598-.527.95-1.125.95H3.996c-.599 0-1.02-.352-1.126-.95L.02 7.412c-.105-.598.211-.985.774-.985h20.123c.563 0 .88.387.774.985l-.774 4.644c-.106.668-.493.95-1.126.95H7.69c-.176 0-.281.105-.246.316l.95 5.84c.035.141.14.247.281.247h4.363c.14 0 .246-.106.281-.247l.668-4.221c.07-.528.423-.739.915-.739h4.75c.703 0 .914.352.809.95\"/>\n        <path fill=").concat(colors.textColor, " d=\"M153.212 20.787c0 1.35.797 2.27 2.422 2.27.614 0 1.196-.123 1.656-.215v2.545c-.46.123-.981.245-1.778.245-3.282 0-4.876-1.932-4.876-4.784v-8.187h-2.484v-2.454h2.484v-3.25h2.576v3.25h4.078v2.453h-4.078zm-13.537-8.494c-2.791 0-4.201 1.809-4.477 4.477h8.556c-.154-2.852-1.442-4.477-4.079-4.477m5.888 12.634c-1.257.675-3.189.92-4.753.92-5.735 0-8.25-3.312-8.25-8.004 0-4.63 2.576-7.942 7.238-7.942 4.722 0 6.624 3.281 6.624 7.942v1.196h-11.194c.368 2.607 2.055 4.294 5.674 4.294 1.778 0 3.281-.338 4.661-.828zm-23.82.613h-2.638V3.799h2.638v13.585l6.593-7.176h3.435l-7.207 7.544 7.513 7.79h-3.588l-6.746-7.176zm-5.648-2.76v2.362c-.92.49-2.331.705-3.742.705-5.458 0-8.004-3.312-8.004-8.004 0-4.63 2.546-7.942 8.004-7.942 1.38 0 2.454.184 3.65.736v2.453c-.982-.46-2.024-.736-3.466-.736-3.986 0-5.612 2.515-5.612 5.49s1.656 5.489 5.674 5.489c1.564 0 2.545-.215 3.496-.552m-27.843-3.588v-8.986h2.637v9.262c0 2.76 1.104 3.986 3.619 3.986 2.453 0 4.14-1.625 4.14-4.722v-8.526h2.637v15.334h-2.637v-2.515c-.982 1.81-2.79 2.821-4.846 2.821-3.526 0-5.55-2.422-5.55-6.654m-5.388-1.319c0-3.68-1.472-5.52-4.201-5.52-2.362 0-4.478 1.503-4.478 4.907v1.226c0 3.404 1.932 4.907 4.171 4.907 2.975 0 4.508-1.963 4.508-5.52m-3.803 7.973c-2.238 0-3.956-1.012-4.876-3.005v2.699h-2.637V3.798h2.637v9.17c.982-2.025 2.822-3.067 5.183-3.067 4.079 0 6.133 3.465 6.133 7.973 0 4.324-2.146 7.973-6.44 7.973m-14.974-5.06c0 1.35.797 2.27 2.422 2.27.614 0 1.196-.123 1.656-.215v2.545a6.3 6.3 0 0 1-1.778.245c-3.282 0-4.876-1.932-4.876-4.784v-8.187h-2.484v-2.454h2.484v-3.25h2.576v3.25h4.078v2.453h-4.078zM53.328 6.16c0-1.166.767-1.84 1.84-1.84s1.84.674 1.84 1.84S56.242 8 55.168 8s-1.84-.676-1.84-1.84m.49 19.38V10.207h2.638V25.54zm-9.828-9.046h-6.194v6.287h6.256c2.637 0 3.833-.951 3.833-2.975 0-2.147-1.134-3.312-3.894-3.312m-.889-8.464h-5.305v6.01h5.305c2.607 0 3.68-1.195 3.68-3.127 0-1.963-1.165-2.883-3.68-2.883m-8.065 17.51V5.394h8.433c4.11 0 6.103 2.024 6.103 5.274 0 2.423-1.104 3.926-3.373 4.478 2.974.49 4.446 2.116 4.446 4.968 0 3.22-2.177 5.428-6.685 5.428z\"/>\n      </svg>");
};
var $d9b1388a5ad29f00$export$bd40525f5333524b = function BitbucketLogo(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Bitbucket' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $61c2bd5f28c47c3c$export$438460117ae6b7ee).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $61c2bd5f28c47c3c$export$438460117ae6b7ee).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $61c2bd5f28c47c3c$export$438460117ae6b7ee).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $b621ed2cc6a05fa8$export$3dd7971102e44fa8)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $96958b5ae3603ec3$export$2e2bcd8739ae039), {
        appearance: appearance,
        label: label,
        iconColor: iconColor,
        size: size,
        svg: $d9b1388a5ad29f00$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};



var $5FkrB = parcelRequire("5FkrB");




var $82ec3faa3f0368a6$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor;
    var colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $cc7f4c450b6535cc$export$bbacc3980e0f3029)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" viewBox=\"0 0 32 32\" focusable=\"false\" aria-hidden=\"true\" xmlns=\"http://www.w3.org/2000/svg\">\n      <path fill=\"".concat(colors.iconColor, "\" d=\"M15.667 15.66v5.942H9.713V15.66zV9.722H4.807c-.58.004-1.047.47-1.043 1.04v15.755a1.04 1.04 0 0 0 1.028 1.054h15.771a1.04 1.04 0 0 0 1.042-1.04V15.66zm0-11.88v5.942h5.967v5.938h5.935V4.82a1.04 1.04 0 0 0-1.028-1.053h-.014z\"/>\n      </svg>\n    ");
};
var $82ec3faa3f0368a6$export$f7857fe64d7161d9 = function CompassIcon(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Compass' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $61c2bd5f28c47c3c$export$438460117ae6b7ee).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $61c2bd5f28c47c3c$export$438460117ae6b7ee).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $61c2bd5f28c47c3c$export$438460117ae6b7ee).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $b621ed2cc6a05fa8$export$3dd7971102e44fa8)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $96958b5ae3603ec3$export$2e2bcd8739ae039), {
        appearance: appearance,
        label: label,
        svg: $82ec3faa3f0368a6$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        size: size,
        testId: testId,
        textColor: textColor
    });
};



var $5FkrB = parcelRequire("5FkrB");




var $ec654b9e2387dfd0$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor;
    var colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $cc7f4c450b6535cc$export$bbacc3980e0f3029)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" viewBox=\"0 0 155 32\" focusable=\"false\" aria-hidden=\"true\" xmlns=\"http://www.w3.org/2000/svg\">\n    <path fill=".concat(colors.iconColor, " d=\"M11.903 14.993v5.942H5.95v-5.942zV9.055H1.043c-.58.004-1.047.47-1.043 1.04v15.756a1.04 1.04 0 0 0 1.028 1.054H16.8a1.04 1.04 0 0 0 1.043-1.04V14.993zm0-11.879v5.941h5.967v5.938h5.936V4.153A1.04 1.04 0 0 0 22.778 3.1h-.015z\"/>\n    <path fill=\"").concat(colors.textColor, "\" d=\"M154.46 21.37c0 2.545-1.656 4.477-5.765 4.477-2.3 0-4.171-.521-5.336-1.134v-2.791c1.318.767 3.526 1.503 5.458 1.503 2.024 0 3.067-.828 3.067-2.024 0-1.166-.889-1.84-3.803-2.546-3.404-.828-4.845-2.146-4.845-4.661 0-2.668 2.055-4.293 5.551-4.293 1.993 0 3.802.49 4.937 1.104v2.729c-1.84-.92-3.343-1.41-4.968-1.41-1.932 0-2.975.674-2.975 1.87 0 1.073.736 1.748 3.558 2.423 3.404.828 5.121 2.085 5.121 4.753m-13.626 0c0 2.545-1.656 4.477-5.766 4.477-2.3 0-4.17-.521-5.336-1.134v-2.791c1.319.767 3.527 1.503 5.459 1.503 2.024 0 3.067-.828 3.067-2.024 0-1.166-.89-1.84-3.803-2.546-3.404-.828-4.845-2.146-4.845-4.661 0-2.668 2.054-4.293 5.55-4.293 1.994 0 3.803.49 4.938 1.104v2.729c-1.84-.92-3.343-1.41-4.968-1.41-1.932 0-2.975.674-2.975 1.87 0 1.073.736 1.748 3.557 2.423 3.404.828 5.122 2.085 5.122 4.753m-25.873-3.496c0 3.68 1.472 5.52 4.201 5.52 2.361 0 4.477-1.503 4.477-4.907v-1.226c0-3.404-1.932-4.907-4.17-4.907-2.975 0-4.508 1.963-4.508 5.52m8.678 7.667v-2.76c-.981 2.024-2.821 3.066-5.182 3.066-4.079 0-6.134-3.465-6.134-7.973 0-4.324 2.147-7.973 6.44-7.973 2.239 0 3.956 1.012 4.876 3.005v-2.699h2.638v15.334zm-16.09-7.667c0-3.68-1.472-5.52-4.201-5.52-2.362 0-4.478 1.503-4.478 4.907v1.226c0 3.404 1.932 4.907 4.171 4.907 2.975 0 4.508-1.963 4.508-5.52m-3.803 7.973c-2.238 0-3.956-1.012-4.876-3.005v8.679h-2.637V10.207h2.637v2.76c.982-2.024 2.822-3.066 5.183-3.066 4.079 0 6.133 3.465 6.133 7.973 0 4.324-2.146 7.973-6.44 7.973m-21.583-8.832v8.526h-2.637v-9.262c0-2.76-1.104-3.986-3.619-3.986-2.453 0-4.14 1.625-4.14 4.722v8.526H69.13V10.207h2.637v2.515c.982-1.81 2.791-2.821 4.846-2.821 2.606 0 4.385 1.318 5.152 3.741.858-2.361 2.913-3.741 5.458-3.741 3.435 0 5.336 2.33 5.336 6.654v8.986h-2.637v-8.526c0-3.158-1.104-4.722-3.619-4.722-2.453 0-4.14 1.625-4.14 4.722m-23.335 8.832c-4.6 0-7.299-3.404-7.299-8.004s2.699-7.942 7.299-7.942c4.57 0 7.237 3.342 7.237 7.942s-2.668 8.004-7.237 8.004m0-13.493c-3.282 0-4.723 2.576-4.723 5.49s1.441 5.55 4.723 5.55c3.25 0 4.661-2.637 4.661-5.55s-1.41-5.49-4.661-5.49m-9.233 9.629v2.668c-1.258.828-3.251 1.196-5.336 1.196-6.624 0-10.366-3.986-10.366-10.334 0-6.134 3.742-10.427 10.304-10.427 1.963 0 3.926.368 5.367 1.41v2.669c-1.441-.92-3.036-1.411-5.367-1.411-4.722 0-7.544 3.128-7.544 7.759s2.914 7.697 7.698 7.697c2.116 0 3.772-.49 5.244-1.227\"/>\n  </svg>");
};
var $ec654b9e2387dfd0$export$eb7d748e4f9c9676 = function CompassLogo(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Compass' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $61c2bd5f28c47c3c$export$438460117ae6b7ee).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $61c2bd5f28c47c3c$export$438460117ae6b7ee).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $61c2bd5f28c47c3c$export$438460117ae6b7ee).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $b621ed2cc6a05fa8$export$3dd7971102e44fa8)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $96958b5ae3603ec3$export$2e2bcd8739ae039), {
        appearance: appearance,
        label: label,
        iconColor: iconColor,
        size: size,
        svg: $ec654b9e2387dfd0$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};



var $5FkrB = parcelRequire("5FkrB");




var $167d8239415b0009$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor;
    var colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $cc7f4c450b6535cc$export$bbacc3980e0f3029)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" viewBox=\"0 0 32 32\" focusable=\"false\" aria-hidden=\"true\" xmlns=\"http://www.w3.org/2000/svg\">\n      <path fill=\"".concat(colors.iconColor, "\" d=\"M25.769 20.234c-6.584-3.183-8.507-3.66-11.282-3.66-3.254 0-6.028 1.355-8.507 5.16l-.406.622c-.333.513-.407.696-.407.915s.11.403.517.659l4.18 2.598c.222.146.407.22.592.22.222 0 .37-.11.592-.44l.665-1.024c1.036-1.574 1.96-2.086 3.144-2.086 1.036 0 2.257.293 3.773 1.025l4.365 2.049c.443.22.924.11 1.146-.403l2.071-4.537c.222-.512.074-.842-.444-1.098M6.572 12.22c6.584 3.184 8.507 3.66 11.281 3.66 3.255 0 6.03-1.354 8.507-5.16l.407-.622c.333-.512.407-.695.407-.915s-.11-.402-.518-.658l-4.18-2.598c-.221-.147-.406-.22-.591-.22-.222 0-.37.11-.592.44l-.666 1.024c-1.035 1.573-1.96 2.086-3.144 2.086-1.035 0-2.256-.293-3.772-1.025L9.346 6.183c-.444-.22-.924-.11-1.146.402l-2.072 4.538c-.222.512-.074.841.444 1.098\"/>\n    </svg>");
};
var $167d8239415b0009$export$68f3db7f6af48bcb = function ConfluenceIcon(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Confluence' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $61c2bd5f28c47c3c$export$438460117ae6b7ee).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $61c2bd5f28c47c3c$export$438460117ae6b7ee).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $61c2bd5f28c47c3c$export$438460117ae6b7ee).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $b621ed2cc6a05fa8$export$3dd7971102e44fa8)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $96958b5ae3603ec3$export$2e2bcd8739ae039), {
        appearance: appearance,
        label: label,
        svg: $167d8239415b0009$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        size: size,
        testId: testId,
        textColor: textColor
    });
};



var $5FkrB = parcelRequire("5FkrB");




var $939c0243cabcce21$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor;
    var colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $cc7f4c450b6535cc$export$bbacc3980e0f3029)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" viewBox=\"0 0 180 32\" focusable=\"false\" aria-hidden=\"true\" xmlns=\"http://www.w3.org/2000/svg\">\n      <path fill=\"".concat(colors.iconColor, "\" d=\"M20.602 20.234c-6.584-3.183-8.507-3.66-11.281-3.66-3.255 0-6.03 1.355-8.507 5.16l-.407.622c-.333.513-.407.696-.407.915s.111.403.518.659l4.18 2.598c.221.146.406.22.591.22.222 0 .37-.11.592-.44l.666-1.024c1.035-1.574 1.96-2.086 3.144-2.086 1.035 0 2.256.293 3.772 1.025l4.365 2.049c.444.22.925.11 1.146-.403l2.072-4.537c.222-.512.074-.842-.444-1.098M1.406 12.22c6.583 3.184 8.507 3.66 11.28 3.66 3.256 0 6.03-1.354 8.508-5.16l.407-.622c.332-.512.406-.695.406-.915s-.11-.402-.518-.658L17.31 5.927c-.222-.147-.407-.22-.592-.22-.222 0-.37.11-.592.44l-.665 1.024c-1.036 1.573-1.96 2.086-3.144 2.086-1.036 0-2.257-.293-3.773-1.025L4.18 6.183c-.444-.22-.925-.11-1.147.402L.962 11.123c-.222.512-.074.841.444 1.098\"/>\n      <path fill=\"").concat(colors.textColor, "\" d=\"M172.49 12.293c-2.791 0-4.201 1.809-4.477 4.477h8.556c-.154-2.852-1.442-4.477-4.079-4.477m5.888 12.634c-1.257.675-3.189.92-4.753.92-5.735 0-8.25-3.312-8.25-8.004 0-4.63 2.576-7.942 7.238-7.942 4.722 0 6.624 3.281 6.624 7.942v1.196h-11.194c.368 2.607 2.055 4.294 5.674 4.294 1.778 0 3.281-.338 4.661-.828zm-15.093-2.147v2.362c-.92.49-2.331.705-3.742.705-5.458 0-8.004-3.312-8.004-8.004 0-4.63 2.546-7.942 8.004-7.942 1.38 0 2.454.184 3.65.736v2.453c-.982-.46-2.024-.736-3.466-.736-3.986 0-5.612 2.515-5.612 5.49s1.656 5.489 5.674 5.489c1.564 0 2.545-.215 3.496-.552m-14.503-6.226v8.986h-2.637v-9.262c0-2.76-1.104-3.986-3.619-3.986-2.453 0-4.14 1.625-4.14 4.722v8.526h-2.637V10.207h2.637v2.515c.981-1.81 2.791-2.821 4.845-2.821 3.527 0 5.551 2.422 5.551 6.654m-22.921-4.262c-2.79 0-4.201 1.809-4.477 4.477h8.556c-.154-2.852-1.441-4.477-4.079-4.477m5.888 12.634c-1.257.675-3.189.92-4.753.92-5.735 0-8.249-3.312-8.249-8.004 0-4.63 2.576-7.942 7.237-7.942 4.723 0 6.624 3.281 6.624 7.942v1.196h-11.193c.368 2.607 2.054 4.294 5.673 4.294 1.778 0 3.281-.338 4.661-.828zm-29.1-5.734v-8.986h2.637v9.262c0 2.76 1.104 3.986 3.619 3.986 2.453 0 4.14-1.625 4.14-4.722v-8.526h2.637v15.334h-2.637v-2.515c-.981 1.81-2.791 2.821-4.845 2.821-3.527 0-5.551-2.422-5.551-6.654m-2.231 6.317c-.215.061-.674.122-1.35.122-2.514 0-4.108-1.196-4.108-4.017V3.798h2.637v17.51c0 1.38.92 1.871 2.055 1.871.275 0 .459 0 .766-.03zM88.157 8.582v1.625h3.956v2.454h-3.956v12.88h-2.576V12.66h-2.484v-2.454h2.484V8.521c0-2.852 1.595-4.784 4.876-4.784a6.3 6.3 0 0 1 1.779.245v2.423a8.7 8.7 0 0 0-1.656-.154c-1.626 0-2.423.95-2.423 2.33m-7.327 7.974v8.986h-2.637v-9.262c0-2.76-1.104-3.986-3.619-3.986-2.453 0-4.14 1.625-4.14 4.722v8.526h-2.637V10.207h2.637v2.515c.981-1.81 2.79-2.821 4.845-2.821 3.527 0 5.551 2.422 5.551 6.654m-23.336 9.292c-4.6 0-7.298-3.404-7.298-8.004s2.698-7.942 7.298-7.942c4.57 0 7.238 3.342 7.238 7.942s-2.668 8.004-7.238 8.004m0-13.493c-3.28 0-4.722 2.576-4.722 5.49s1.441 5.55 4.722 5.55c3.251 0 4.662-2.637 4.662-5.55s-1.41-5.49-4.662-5.49m-9.233 9.629v2.668c-1.257.828-3.25 1.196-5.336 1.196-6.624 0-10.365-3.986-10.365-10.334 0-6.134 3.741-10.427 10.304-10.427 1.963 0 3.925.368 5.367 1.41v2.669c-1.442-.92-3.036-1.411-5.367-1.411-4.723 0-7.544 3.128-7.544 7.759s2.913 7.697 7.697 7.697c2.116 0 3.772-.49 5.244-1.227\"/>\n    </svg>\n    ");
};
var $939c0243cabcce21$export$1b2e4fe6ef471556 = function ConfluenceLogo(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Confluence' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $61c2bd5f28c47c3c$export$438460117ae6b7ee).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $61c2bd5f28c47c3c$export$438460117ae6b7ee).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $61c2bd5f28c47c3c$export$438460117ae6b7ee).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $b621ed2cc6a05fa8$export$3dd7971102e44fa8)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $96958b5ae3603ec3$export$2e2bcd8739ae039), {
        appearance: appearance,
        label: label,
        iconColor: iconColor,
        size: size,
        svg: $939c0243cabcce21$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};



var $5FkrB = parcelRequire("5FkrB");




var $3e24df8349650905$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor;
    var colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $cc7f4c450b6535cc$export$bbacc3980e0f3029)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" viewBox=\"0 0 48 48\" focusable=\"false\" aria-hidden=\"true\" xmlns=\"http://www.w3.org/2000/svg\">\n\t\t<path fill=\"".concat(colors.iconColor, "\" d=\"M45.4277 24.5018C41.4108 20.4849 34.8821 20.5276 30.908 24.5018L27.5636 27.8462C25.717 29.6927 22.7177 29.6927 20.8712 27.8462L18.0925 25.0675L10.8309 32.3291L13.6096 35.1078C19.4658 40.9641 28.9654 40.9641 34.8216 35.1078L45.4277 24.5018ZM3 23.5018C7.01684 27.5186 13.4637 27.5578 17.4805 23.5409L20.8676 20.1538C22.7142 18.3073 25.7135 18.3073 27.56 20.1538L30.3387 22.9325L37.6003 15.6709L34.8216 12.8922C28.9654 7.03593 19.4658 7.03593 13.6096 12.8922L3.00356 23.4982L3 23.5018Z\"/>\n\t\t</svg>\n\t\t");
};
var $3e24df8349650905$export$1e02e7298035a77c = function FocusIcon(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Focus' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $61c2bd5f28c47c3c$export$438460117ae6b7ee).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $61c2bd5f28c47c3c$export$438460117ae6b7ee).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $61c2bd5f28c47c3c$export$438460117ae6b7ee).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $b621ed2cc6a05fa8$export$3dd7971102e44fa8)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $96958b5ae3603ec3$export$2e2bcd8739ae039), {
        appearance: appearance,
        label: label,
        svg: $3e24df8349650905$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        size: size,
        testId: testId,
        textColor: textColor
    });
};



var $5FkrB = parcelRequire("5FkrB");




var $c938f2c9202f2b9d$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor;
    var colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $cc7f4c450b6535cc$export$bbacc3980e0f3029)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" viewBox=\"0 0 168 48\" focusable=\"false\" aria-hidden=\"true\" xmlns=\"http://www.w3.org/2000/svg\">\n\t\t<path fill=\"".concat(colors.iconColor, "\" d=\"M42.4277 24.5018C38.4108 20.4849 31.8821 20.5276 27.908 24.5018L24.5636 27.8462C22.717 29.6927 19.7177 29.6927 17.8712 27.8462L15.0925 25.0675L7.83088 32.3291L10.6096 35.1078C16.4658 40.9641 25.9654 40.9641 31.8216 35.1078L42.4277 24.5018ZM0 23.5018C4.01684 27.5186 10.4637 27.5578 14.4805 23.5409L17.8676 20.1538C19.7142 18.3073 22.7135 18.3073 24.56 20.1538L27.3387 22.9325L34.6003 15.6709L31.8216 12.8922C25.9654 7.03593 16.4658 7.03593 10.6096 12.8922L0.00355592 23.4982L0 23.5018Z\"/>\n\t\t<path fill=\"").concat(colors.textColor, "\" d=\"M167.405 31.746C167.405 35.564 164.921 38.462 158.757 38.462C155.307 38.462 152.501 37.68 150.753 36.76V32.574C152.731 33.724 156.043 34.828 158.941 34.828C161.977 34.828 163.541 33.586 163.541 31.792C163.541 30.044 162.207 29.032 157.837 27.974C152.731 26.732 150.569 24.754 150.569 20.982C150.569 16.98 153.651 14.542 158.895 14.542C161.885 14.542 164.599 15.278 166.301 16.198V20.292C163.541 18.912 161.287 18.176 158.849 18.176C155.951 18.176 154.387 19.188 154.387 20.982C154.387 22.592 155.491 23.604 159.723 24.616C164.829 25.858 167.405 27.744 167.405 31.746Z\"/>\n\t\t<path fill=\"").concat(colors.textColor, "\" d=\"M126.009 28.48V15.002H129.965V28.894C129.965 33.034 131.621 34.874 135.393 34.874C139.073 34.874 141.603 32.436 141.603 27.79V15.002H145.559V38.002H141.603V34.23C140.131 36.944 137.417 38.462 134.335 38.462C129.045 38.462 126.009 34.828 126.009 28.48Z\"/>\n\t\t<path fill=\"").concat(colors.textColor, "\" d=\"M121.953 33.862V37.404C120.573 38.14 118.457 38.462 116.341 38.462C108.153 38.462 104.335 33.494 104.335 26.456C104.335 19.51 108.153 14.542 116.341 14.542C118.411 14.542 120.021 14.818 121.815 15.646V19.326C120.343 18.636 118.779 18.222 116.617 18.222C110.637 18.222 108.199 21.994 108.199 26.456C108.199 30.918 110.683 34.69 116.709 34.69C119.055 34.69 120.527 34.368 121.953 33.862Z\"/>\n\t\t<path fill=\"").concat(colors.textColor, "\" d=\"M90.2616 38.462C83.3616 38.462 79.3136 33.356 79.3136 26.456C79.3136 19.556 83.3616 14.542 90.2616 14.542C97.1156 14.542 101.118 19.556 101.118 26.456C101.118 33.356 97.1156 38.462 90.2616 38.462ZM90.2616 18.222C85.3396 18.222 83.1776 22.086 83.1776 26.456C83.1776 30.826 85.3396 34.782 90.2616 34.782C95.1376 34.782 97.2536 30.826 97.2536 26.456C97.2536 22.086 95.1376 18.222 90.2616 18.222Z\"/>\n\t\t<path fill=\"").concat(colors.textColor, "\" d=\"M75.298 26.732H61.59V38.002H57.45V7.78003H76.862V11.736H61.59V22.776H75.298V26.732Z\"/>\n\t\t</svg>\n\t\t");
};
var $c938f2c9202f2b9d$export$33908560ea1b226d = function FocusLogo(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Focus' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $61c2bd5f28c47c3c$export$438460117ae6b7ee).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $61c2bd5f28c47c3c$export$438460117ae6b7ee).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $61c2bd5f28c47c3c$export$438460117ae6b7ee).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $b621ed2cc6a05fa8$export$3dd7971102e44fa8)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $96958b5ae3603ec3$export$2e2bcd8739ae039), {
        appearance: appearance,
        label: label,
        iconColor: iconColor,
        size: size,
        svg: $c938f2c9202f2b9d$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};



var $5FkrB = parcelRequire("5FkrB");




var $f9d366510db8d846$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor;
    var colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $cc7f4c450b6535cc$export$bbacc3980e0f3029)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" focusable=\"false\" aria-hidden=\"true\">\n      <path\n        d=\"M5.584 14.4h20.83c.599 0 .918-.32.918-.918V6.459c0-.599-.319-.918-.918-.918h-4.39c-.598 0-.917.32-.917.918v3.551h-1.995V6.46c0-.599-.32-.918-.918-.918h-4.39c-.598 0-.917.32-.917.918v3.551h-1.995V6.46c0-.599-.32-.918-.918-.918h-4.39c-.598 0-.917.32-.917.918v7.023c0 .599.319.918.917.918zm.36 6.145a13.9 13.9 0 0 1-.798-3.99c-.04-.52.199-.799.758-.799h20.191c.559 0 .798.24.798.719q-.12 2.214-.838 4.07c-.24.638-.598.918-1.277.918H7.221c-.679 0-1.038-.28-1.277-.918m18.475 3.312c-1.915 2.354-5.068 3.87-8.42 3.87s-6.584-1.516-8.46-3.87c-.478-.638-.239-1.038.24-1.038h16.44c.48 0 .719.4.2 1.038\"\n        fill=\"".concat(colors.iconColor, "\"\n      />\n    </svg>");
};
var $f9d366510db8d846$export$3f95fcfdc25a741d = function GuardIcon(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Guard' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $61c2bd5f28c47c3c$export$438460117ae6b7ee).size : _ref2$size, testId = _ref2.testId, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $61c2bd5f28c47c3c$export$438460117ae6b7ee).textColor : _ref2$textColor, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $61c2bd5f28c47c3c$export$438460117ae6b7ee).iconColor : _ref2$iconColor;
    var _useThemeObserver = (0, $b621ed2cc6a05fa8$export$3dd7971102e44fa8)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $96958b5ae3603ec3$export$2e2bcd8739ae039), {
        appearance: appearance,
        svg: $f9d366510db8d846$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        label: label,
        size: size,
        testId: testId,
        textColor: textColor
    });
};



var $5FkrB = parcelRequire("5FkrB");




var $4aaa416bcb06d11e$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor;
    var colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $cc7f4c450b6535cc$export$bbacc3980e0f3029)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 114 32\" focusable=\"false\" aria-hidden=\"true\">\n      <path\n        d=\"M.918 13.733h20.83c.598 0 .918-.32.918-.918V5.792c0-.599-.32-.918-.918-.918h-4.39c-.598 0-.918.32-.918.918v3.551h-1.995V5.792c0-.599-.319-.918-.918-.918H9.139c-.599 0-.918.32-.918.918v3.551H6.225V5.792c0-.599-.32-.918-.918-.918H.917c-.598 0-.917.32-.917.918v7.023c0 .599.32.918.918.918m.359 6.145a13.9 13.9 0 0 1-.798-3.99c-.04-.52.2-.799.758-.799h20.191c.56 0 .799.24.799.719q-.12 2.214-.838 4.07c-.24.638-.599.918-1.277.918H2.554c-.679 0-1.038-.28-1.277-.918m18.476 3.312c-1.916 2.354-5.068 3.87-8.42 3.87s-6.584-1.516-8.46-3.87c-.479-.638-.24-1.038.24-1.038h16.44c.479 0 .718.4.2 1.038\"\n        fill=\"".concat(colors.iconColor, "\"\n      />\n      <path\n        d=\"M102.398 17.874c0 3.68 1.472 5.52 4.202 5.52 2.361 0 4.477-1.502 4.477-4.906V17.26c0-3.404-1.932-4.907-4.171-4.907-2.974 0-4.508 1.963-4.508 5.52zm8.679 7.667v-2.76c-.982 2.024-2.822 3.067-5.183 3.067-4.079 0-6.133-3.466-6.133-7.974 0-4.324 2.146-7.973 6.44-7.973 2.238 0 3.956 1.012 4.876 3.005V3.798h2.637v21.743zm-17.793-9.047v9.047h-2.576V10.208h2.576v2.698c.89-1.809 2.423-3.097 5.428-2.913v2.576c-3.373-.337-5.428.675-5.428 3.925m-17.869 1.381c0 3.68 1.472 5.52 4.201 5.52 2.362 0 4.478-1.503 4.478-4.907v-1.227c0-3.404-1.932-4.906-4.17-4.906-2.976 0-4.509 1.962-4.509 5.52m8.679 7.666v-2.76c-.982 2.024-2.822 3.067-5.183 3.067-4.079 0-6.133-3.465-6.133-7.973 0-4.324 2.146-7.974 6.44-7.974 2.238 0 3.956 1.012 4.876 3.006v-2.699h2.637v15.333zM56.68 19.193v-8.985h2.637v9.261c0 2.76 1.105 3.987 3.62 3.987 2.453 0 4.14-1.625 4.14-4.723v-8.525h2.637v15.333h-2.638v-2.514c-.981 1.809-2.79 2.821-4.845 2.821-3.527 0-5.55-2.423-5.55-6.655zm-3.973 5.213c-1.595.951-4.539 1.442-6.808 1.442-6.931 0-10.672-4.232-10.672-10.335 0-6.563 4.262-10.457 11.438-10.457 1.595 0 3.466.184 5.244.797v2.76c-1.533-.613-3.342-.89-5.213-.89-5.98 0-8.71 2.975-8.71 7.729 0 4.661 2.76 7.758 8.557 7.758.95 0 2.269-.092 3.404-.429v-5.612h-5.152v-2.637h7.912z\"\n        fill=\"").concat(colors.textColor, "\"\n      />\n    </svg>");
};
var $4aaa416bcb06d11e$export$a4a891d202775deb = function GuardLogo(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Guard' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $61c2bd5f28c47c3c$export$438460117ae6b7ee).size : _ref2$size, testId = _ref2.testId, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $61c2bd5f28c47c3c$export$438460117ae6b7ee).textColor : _ref2$textColor, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $61c2bd5f28c47c3c$export$438460117ae6b7ee).iconColor : _ref2$iconColor;
    var _useThemeObserver = (0, $b621ed2cc6a05fa8$export$3dd7971102e44fa8)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $96958b5ae3603ec3$export$2e2bcd8739ae039), {
        appearance: appearance,
        iconColor: iconColor,
        label: label,
        size: size,
        svg: $4aaa416bcb06d11e$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};



var $5FkrB = parcelRequire("5FkrB");




var $a086e675d50d99f5$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor;
    var colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $cc7f4c450b6535cc$export$bbacc3980e0f3029)(appearance, colorMode);
    return "<svg viewBox=\"0 0 32 32\" focusable=\"false\" aria-hidden=\"true\" height=\"32\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n    <path\n      fill=\"".concat(colors.iconColor, "\"\n      d=\"M25.52 25.727c0-3.604-2.949-6.517-6.517-6.517h-6.007v-5.497H6.48v10.813c0 .837.364 1.201 1.201 1.201zM6.48 6.687c0 3.604 2.876 6.517 6.48 6.517h6.043V18.7h6.517V7.888q0-1.2-1.201-1.201z\"\n    />\n  </svg>");
};
var $a086e675d50d99f5$export$407687b2dd89cc68 = function JiraAlignIcon(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Jira Align' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $61c2bd5f28c47c3c$export$438460117ae6b7ee).size : _ref2$size, testId = _ref2.testId, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $61c2bd5f28c47c3c$export$438460117ae6b7ee).textColor : _ref2$textColor, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $61c2bd5f28c47c3c$export$438460117ae6b7ee).iconColor : _ref2$iconColor;
    var _useThemeObserver = (0, $b621ed2cc6a05fa8$export$3dd7971102e44fa8)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $96958b5ae3603ec3$export$2e2bcd8739ae039), {
        appearance: appearance,
        label: label,
        svg: $a086e675d50d99f5$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        size: size,
        testId: testId,
        textColor: textColor
    });
};



var $5FkrB = parcelRequire("5FkrB");




var $0384e43546c82587$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor;
    var colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $cc7f4c450b6535cc$export$bbacc3980e0f3029)(appearance, colorMode);
    return "<svg viewBox=\"0 0 146 32\" focusable=\"false\" aria-hidden=\"true\" height=\"32\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n      <path d=\"M19.04 25.727c0-3.604-2.949-6.517-6.517-6.517H6.517v-5.497H0v10.813c0 .837.364 1.201 1.201 1.201zM0 6.687c0 3.604 2.876 6.517 6.48 6.517h6.043V18.7h6.517V7.888q0-1.2-1.201-1.201z\" fill=\"".concat(colors.iconColor, "\"/>\n      <path d=\"M144.993 16.555v8.985h-2.638v-9.26c0-2.76-1.104-3.988-3.618-3.988-2.454 0-4.14 1.626-4.14 4.723v8.525h-2.638V10.207h2.638v2.515c.981-1.81 2.79-2.822 4.845-2.822 3.527 0 5.551 2.423 5.551 6.655m-19.589 7.759V22.78c-.982 2.024-2.822 3.067-5.183 3.067-4.048 0-6.072-3.465-6.072-7.973 0-4.324 2.116-7.974 6.379-7.974 2.238 0 3.956 1.012 4.876 3.006v-2.699h2.576V24.16c0 4.508-2.116 7.544-7.606 7.544-2.576 0-3.986-.337-5.458-.828V28.3c1.686.552 3.434.92 5.336.92 3.833 0 5.152-2.054 5.152-4.906m-8.679-6.44c0 3.68 1.472 5.52 4.201 5.52 2.362 0 4.478-1.503 4.478-4.907V17.26c0-3.404-1.932-4.906-4.171-4.906-2.975 0-4.508 1.962-4.508 5.52M107.96 6.16c0-1.166.766-1.84 1.84-1.84 1.073 0 1.84.674 1.84 1.84S110.873 8 109.8 8c-1.074 0-1.84-.675-1.84-1.84m.49 19.38V10.208h2.638v15.334h-2.638Zm-2.537-.03c-.215.061-.675.122-1.349.122-2.515 0-4.11-1.196-4.11-4.017V3.798h2.638v17.51c0 1.38.92 1.871 2.054 1.871.276 0 .46 0 .767-.03v2.36ZM88.83 21.523c-1.534 0-3.098-.184-4.815-.521l-1.687 4.539h-3.097l7.942-20.148h3.496l7.943 20.148h-3.097l-1.687-4.57c-1.81.368-3.373.552-4.999.552Zm0-2.453c1.287 0 2.606-.153 4.17-.399l-4.079-11.04-4.078 11.07c1.502.246 2.76.369 3.986.369Zm-27.807-1.196c0 3.68 1.472 5.52 4.202 5.52 2.36 0 4.477-1.503 4.477-4.907V17.26c0-3.404-1.932-4.906-4.17-4.906-2.975 0-4.509 1.962-4.509 5.52m8.679 7.666v-2.76c-.981 2.024-2.822 3.067-5.183 3.067-4.079 0-6.133-3.465-6.133-7.973 0-4.324 2.146-7.974 6.44-7.974 2.239 0 3.956 1.012 4.876 3.006v-2.699h2.637V25.54zM51.91 16.494v9.047h-2.577V10.207h2.576v2.699c.89-1.81 2.423-3.097 5.428-2.913v2.576c-3.373-.338-5.428.674-5.428 3.925ZM42.224 6.16c0-1.166.767-1.84 1.84-1.84s1.84.674 1.84 1.84S45.137 8 44.064 8s-1.84-.675-1.84-1.84m.49 19.38V10.208h2.638v15.334h-2.637Zm-6.427-5.949V5.393h2.76v14.014c0 3.71-1.626 6.256-5.428 6.256-1.442 0-2.546-.245-3.312-.521v-2.668c.828.337 1.84.521 2.852.521 2.33 0 3.128-1.41 3.128-3.404\" fill=\"").concat(colors.textColor, "\"/>\n    </svg>\n  ");
};
var $0384e43546c82587$export$ee11e928d3d045fd = function JiraAlignLogo(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Jira Align' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $61c2bd5f28c47c3c$export$438460117ae6b7ee).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $61c2bd5f28c47c3c$export$438460117ae6b7ee).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $61c2bd5f28c47c3c$export$438460117ae6b7ee).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $b621ed2cc6a05fa8$export$3dd7971102e44fa8)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $96958b5ae3603ec3$export$2e2bcd8739ae039), {
        appearance: appearance,
        label: label,
        iconColor: iconColor,
        size: size,
        svg: $0384e43546c82587$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};



var $5FkrB = parcelRequire("5FkrB");




var $539f53a33632dfac$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor;
    var colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $cc7f4c450b6535cc$export$bbacc3980e0f3029)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" viewBox=\"0 0 32 32\" focusable=\"false\" aria-hidden=\"true\" xmlns=\"http://www.w3.org/2000/svg\">\n      <path fill=\"".concat(colors.iconColor, "\" d=\"M17.655 5.884a15.3 15.3 0 0 0 8.75 0c.257-.056.428.114.37.37-.826 2.985-.826 5.742 0 8.727.058.228-.113.427-.37.342a16.33 16.33 0 0 0-8.75 0c-.228.085-.428-.114-.342-.342.77-2.985.77-5.742 0-8.727-.086-.256.114-.426.342-.37m1.169 10.576v.483c0 2.246-1.568 3.894-3.506 3.894a3.474 3.474 0 0 1-3.477-3.496c0-1.933 1.567-3.468 3.762-3.468h.57V7.078c-.285-.028-.57-.028-.855-.028C9.618 7.05 5 11.655 5 17.37c0 5.713 4.617 10.29 10.318 10.29s10.346-4.605 10.346-10.29v-.91z\"/>\n    </svg>");
};
var $539f53a33632dfac$export$21bfbeb62fdcce8d = function JiraProductDiscoveryIcon(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Jira Product Discovery' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $61c2bd5f28c47c3c$export$438460117ae6b7ee).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $61c2bd5f28c47c3c$export$438460117ae6b7ee).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $61c2bd5f28c47c3c$export$438460117ae6b7ee).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $b621ed2cc6a05fa8$export$3dd7971102e44fa8)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $96958b5ae3603ec3$export$2e2bcd8739ae039), {
        appearance: appearance,
        label: label,
        svg: $539f53a33632dfac$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        size: size,
        testId: testId,
        textColor: textColor
    });
};



var $5FkrB = parcelRequire("5FkrB");




var $3a5dc488d65304f9$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor;
    var colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $cc7f4c450b6535cc$export$bbacc3980e0f3029)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" viewBox=\"0 0 318 32\" focusable=\"false\" aria-hidden=\"true\" xmlns=\"http://www.w3.org/2000/svg\">\n      <path fill=\"".concat(colors.iconColor, "\" d=\"M12.655 5.218a15.3 15.3 0 0 0 8.75 0c.257-.057.428.114.37.37-.826 2.984-.826 5.742 0 8.727.058.227-.113.426-.37.341a16.33 16.33 0 0 0-8.75 0c-.228.085-.428-.114-.342-.341.77-2.985.77-5.743 0-8.727-.086-.256.114-.427.342-.37m1.169 10.575v.483c0 2.246-1.568 3.895-3.506 3.895a3.474 3.474 0 0 1-3.478-3.497c0-1.933 1.568-3.468 3.763-3.468h.57V6.412c-.285-.028-.57-.028-.855-.028C4.618 6.384 0 10.989 0 16.703s4.617 10.29 10.318 10.29 10.346-4.605 10.346-10.29v-.91z\" />\n      <path fill=\"").concat(colors.textColor, "\" d=\"M308.551 24.559h-1.718l-5.55-14.352h2.821l4.907 13.125 4.906-13.125h2.822l-5.796 14.843c-1.718 4.385-2.699 6.654-6.594 6.654-1.318 0-2.054-.122-2.821-.429v-2.27c.889.277 1.901.369 2.668.369 2.147 0 3.097-1.472 4.355-4.815m-13.247-8.065v9.047h-2.576V10.207h2.576v2.699c.889-1.81 2.422-3.097 5.428-2.913v2.576c-3.374-.338-5.428.674-5.428 3.925m-12.464-4.202c-2.79 0-4.201 1.81-4.477 4.478h8.556c-.153-2.852-1.441-4.478-4.079-4.478m5.888 12.635c-1.257.675-3.189.92-4.753.92-5.735 0-8.249-3.312-8.249-8.004 0-4.63 2.576-7.943 7.237-7.943 4.723 0 6.624 3.282 6.624 7.943v1.196h-11.193c.368 2.607 2.054 4.293 5.673 4.293 1.779 0 3.281-.337 4.661-.828zm-19.717.613h-3.527l-5.949-15.333h2.76l4.968 13.095 4.937-13.095h2.76zm-17.462.307c-4.6 0-7.299-3.404-7.299-8.004s2.699-7.943 7.299-7.943c4.569 0 7.237 3.343 7.237 7.943s-2.668 8.004-7.237 8.004m0-13.493c-3.281 0-4.723 2.576-4.723 5.49 0 2.912 1.442 5.55 4.723 5.55 3.251 0 4.661-2.638 4.661-5.55 0-2.914-1.41-5.49-4.661-5.49M242.16 22.78v2.362c-.92.49-2.331.705-3.742.705-5.458 0-8.004-3.312-8.004-8.004 0-4.63 2.546-7.943 8.004-7.943 1.38 0 2.454.184 3.65.736v2.454c-.982-.46-2.024-.736-3.466-.736-3.986 0-5.612 2.514-5.612 5.49 0 2.974 1.656 5.488 5.674 5.488 1.564 0 2.545-.214 3.496-.552m-13.872-1.41c0 2.545-1.656 4.477-5.765 4.477-2.3 0-4.171-.521-5.336-1.135v-2.79c1.319.766 3.527 1.502 5.459 1.502 2.024 0 3.066-.828 3.066-2.024 0-1.165-.889-1.84-3.802-2.545-3.404-.828-4.846-2.147-4.846-4.661 0-2.668 2.055-4.294 5.551-4.294 1.993 0 3.803.491 4.937 1.104v2.73c-1.84-.92-3.342-1.41-4.968-1.41-1.932 0-2.974.674-2.974 1.87 0 1.073.736 1.748 3.557 2.422 3.404.828 5.121 2.086 5.121 4.754M210.599 6.16c0-1.166.767-1.84 1.84-1.84s1.84.674 1.84 1.84-.767 1.84-1.84 1.84-1.84-.675-1.84-1.84m.491 19.38V10.208h2.637v15.334zM198.344 8.03h-4.539v14.873h4.692c4.6 0 6.9-2.422 6.9-7.298 0-4.907-2.177-7.575-7.053-7.575m-7.299 17.51V5.394h7.422c6.532 0 9.69 4.078 9.69 10.12 0 6.102-3.189 10.028-9.69 10.028zm-13.411-4.753c0 1.35.797 2.27 2.422 2.27.614 0 1.196-.123 1.656-.215v2.545c-.46.123-.981.245-1.778.245-3.282 0-4.876-1.932-4.876-4.784v-8.187h-2.484v-2.454h2.484v-3.25h2.576v3.25h4.078v2.453h-4.078zm-6.66 1.993v2.362c-.92.49-2.331.705-3.742.705-5.458 0-8.004-3.312-8.004-8.004 0-4.63 2.546-7.943 8.004-7.943 1.38 0 2.454.184 3.65.736v2.454c-.982-.46-2.024-.736-3.466-.736-3.986 0-5.612 2.514-5.612 5.49 0 2.974 1.656 5.488 5.674 5.488 1.564 0 2.545-.214 3.496-.552m-27.843-3.588v-8.985h2.637v9.261c0 2.76 1.104 3.987 3.619 3.987 2.453 0 4.14-1.625 4.14-4.723v-8.525h2.637V25.54h-2.637v-2.514c-.982 1.809-2.791 2.821-4.846 2.821-3.526 0-5.55-2.423-5.55-6.655m-14.987-1.318c0 3.68 1.472 5.52 4.202 5.52 2.361 0 4.477-1.503 4.477-4.907V17.26c0-3.404-1.932-4.906-4.171-4.906-2.974 0-4.508 1.962-4.508 5.52m8.679 7.667v-2.76c-.981 2.023-2.821 3.066-5.183 3.066-4.078 0-6.133-3.465-6.133-7.973 0-4.324 2.147-7.973 6.44-7.973 2.239 0 3.956 1.012 4.876 3.005V3.798h2.637V25.54zm-20.698.306c-4.6 0-7.299-3.404-7.299-8.004s2.699-7.943 7.299-7.943c4.569 0 7.237 3.343 7.237 7.943s-2.668 8.004-7.237 8.004m0-13.493c-3.282 0-4.723 2.576-4.723 5.49 0 2.912 1.441 5.55 4.723 5.55 3.25 0 4.661-2.638 4.661-5.55 0-2.914-1.411-5.49-4.661-5.49m-13.776 4.14v9.047h-2.576V10.207h2.576v2.699c.89-1.81 2.423-3.097 5.428-2.913v2.576c-3.373-.338-5.428.674-5.428 3.925m-5.002-4.385c0 4.385-2.454 6.838-7.483 6.838h-4.017v6.594h-2.76V5.393h6.777c5.03 0 7.483 2.576 7.483 6.716m-7.79 4.2c3.558.124 4.938-1.563 4.938-4.14 0-2.452-1.38-4.14-4.938-4.14h-3.71v8.28zM61.69 17.874c0 3.68 1.472 5.52 4.201 5.52 2.361 0 4.477-1.503 4.477-4.907V17.26c0-3.404-1.931-4.906-4.17-4.906-2.975 0-4.508 1.962-4.508 5.52m8.679 7.666v-2.76c-.982 2.024-2.822 3.067-5.183 3.067-4.079 0-6.134-3.465-6.134-7.973 0-4.324 2.147-7.974 6.44-7.974 2.24 0 3.957 1.012 4.877 3.006v-2.699h2.637V25.54zm-17.793-9.046v9.047H50V10.207h2.576v2.699c.89-1.81 2.423-3.097 5.428-2.913v2.576c-3.373-.338-5.428.674-5.428 3.925M42.89 6.16c0-1.166.767-1.84 1.84-1.84s1.84.674 1.84 1.84S45.805 8 44.73 8s-1.84-.675-1.84-1.84m.491 19.38V10.208h2.638v15.334zm-6.428-5.949V5.393h2.76v14.014c0 3.71-1.625 6.256-5.428 6.256-1.441 0-2.545-.245-3.312-.521v-2.668c.828.337 1.84.521 2.852.521 2.331 0 3.128-1.41 3.128-3.404\" />\n    </svg>");
};
var $3a5dc488d65304f9$export$c49a2b642fe9eef4 = function JiraProductDiscoveryLogo(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Jira Product Discovery' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $61c2bd5f28c47c3c$export$438460117ae6b7ee).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $61c2bd5f28c47c3c$export$438460117ae6b7ee).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $61c2bd5f28c47c3c$export$438460117ae6b7ee).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $b621ed2cc6a05fa8$export$3dd7971102e44fa8)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $96958b5ae3603ec3$export$2e2bcd8739ae039), {
        appearance: appearance,
        label: label,
        iconColor: iconColor,
        size: size,
        svg: $3a5dc488d65304f9$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};



var $5FkrB = parcelRequire("5FkrB");




var $ab3633d671879ebc$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor;
    var colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $cc7f4c450b6535cc$export$bbacc3980e0f3029)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" viewBox=\"0 0 32 32\" focusable=\"false\" aria-hidden=\"true\" xmlns=\"http://www.w3.org/2000/svg\">\n      <path fill=".concat(colors.iconColor, " d=\"M18.79 13.257h7.325c1.1 0 1.476 1.046.805 1.878L15.464 29.274c-3.702-2.951-3.353-7.62-.644-11.027zm-5.66 5.634H5.806c-1.1 0-1.476-1.046-.805-1.878L16.457 2.874c3.702 2.951 3.3 7.566.617 11z\"/>\n    </svg>");
};
var $ab3633d671879ebc$export$3c6158790f5e01c4 = function JiraServiceManagementIcon(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Jira Service Management' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $61c2bd5f28c47c3c$export$438460117ae6b7ee).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $61c2bd5f28c47c3c$export$438460117ae6b7ee).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $61c2bd5f28c47c3c$export$438460117ae6b7ee).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $b621ed2cc6a05fa8$export$3dd7971102e44fa8)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $96958b5ae3603ec3$export$2e2bcd8739ae039), {
        appearance: appearance,
        label: label,
        svg: $ab3633d671879ebc$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        size: size,
        testId: testId,
        textColor: textColor
    });
};



var $5FkrB = parcelRequire("5FkrB");




var $44f664ec6684700a$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor;
    var colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $cc7f4c450b6535cc$export$bbacc3980e0f3029)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" viewBox=\"0 0 362 32\" focusable=\"false\" aria-hidden=\"true\" xmlns=\"http://www.w3.org/2000/svg\">\n      <path fill=".concat(colors.iconColor, " d=\"M14.124 13.257h7.325c1.1 0 1.475 1.046.804 1.878L10.798 29.274c-3.702-2.951-3.353-7.62-.644-11.027zm-5.66 5.634H1.138c-1.1 0-1.476-1.046-.805-1.878L11.79 2.874c3.703 2.951 3.3 7.566.617 11z\" />\n      <path fill=").concat(colors.textColor, " d=\"M357.074 20.787c0 1.35.797 2.27 2.422 2.27.614 0 1.196-.123 1.656-.215v2.545c-.46.123-.981.245-1.778.245-3.282 0-4.876-1.932-4.876-4.784v-8.187h-2.484v-2.454h2.484v-3.25h2.576v3.25h4.078v2.453h-4.078zm-7.327-4.231v8.985h-2.638V16.28c0-2.76-1.104-3.987-3.618-3.987-2.454 0-4.14 1.625-4.14 4.723v8.525h-2.638V10.208h2.638v2.514c.981-1.81 2.79-2.821 4.845-2.821 3.527 0 5.551 2.423 5.551 6.655m-22.921-4.263c-2.791 0-4.201 1.81-4.477 4.477h8.556c-.154-2.852-1.442-4.477-4.079-4.477m5.888 12.635c-1.257.674-3.189.92-4.753.92-5.735 0-8.25-3.312-8.25-8.004 0-4.631 2.576-7.943 7.238-7.943 4.722 0 6.624 3.281 6.624 7.943v1.196h-11.194c.368 2.606 2.055 4.293 5.674 4.293 1.778 0 3.281-.337 4.661-.828zm-26.152-7.912v8.525h-2.637V16.28c0-2.76-1.104-3.987-3.619-3.987-2.453 0-4.14 1.625-4.14 4.723v8.525h-2.637V10.208h2.637v2.514c.981-1.81 2.79-2.821 4.845-2.821 2.607 0 4.385 1.319 5.152 3.741.859-2.361 2.913-3.741 5.459-3.741 3.434 0 5.336 2.33 5.336 6.655v8.985h-2.638v-8.525c0-3.16-1.104-4.723-3.618-4.723-2.454 0-4.14 1.625-4.14 4.723m-22.921-4.723c-2.79 0-4.201 1.81-4.477 4.477h8.556c-.153-2.852-1.441-4.477-4.079-4.477m5.888 12.635c-1.257.674-3.189.92-4.753.92-5.735 0-8.25-3.312-8.25-8.004 0-4.631 2.577-7.943 7.238-7.943 4.723 0 6.624 3.281 6.624 7.943v1.196h-11.193c.368 2.606 2.054 4.293 5.673 4.293 1.779 0 3.281-.337 4.661-.828zm-18.638-.614v-1.533c-.982 2.024-2.822 3.067-5.183 3.067-4.048 0-6.072-3.466-6.072-7.974 0-4.324 2.116-7.973 6.379-7.973 2.238 0 3.956 1.012 4.876 3.005v-2.698h2.576V24.16c0 4.508-2.116 7.544-7.606 7.544-2.576 0-3.986-.337-5.458-.828V28.3c1.686.552 3.434.92 5.336.92 3.833 0 5.152-2.055 5.152-4.907m-8.679-6.44c0 3.68 1.472 5.52 4.201 5.52 2.362 0 4.478-1.503 4.478-4.906V17.26c0-3.404-1.932-4.907-4.171-4.907-2.975 0-4.508 1.963-4.508 5.52m-16.949.001c0 3.68 1.472 5.52 4.201 5.52 2.361 0 4.477-1.503 4.477-4.906V17.26c0-3.404-1.932-4.907-4.17-4.907-2.975 0-4.508 1.963-4.508 5.52m8.678 7.667v-2.76c-.981 2.024-2.821 3.066-5.182 3.066-4.079 0-6.134-3.465-6.134-7.973 0-4.324 2.147-7.973 6.44-7.973 2.239 0 3.956 1.012 4.876 3.005v-2.699h2.638V25.54zm-14.073-8.984v8.985h-2.638V16.28c0-2.76-1.104-3.987-3.618-3.987-2.454 0-4.14 1.625-4.14 4.723v8.525h-2.638V10.208h2.638v2.514c.981-1.81 2.79-2.821 4.845-2.821 3.527 0 5.551 2.423 5.551 6.655m-28.327 1.318c0 3.68 1.472 5.52 4.202 5.52 2.361 0 4.477-1.503 4.477-4.906V17.26c0-3.404-1.932-4.907-4.171-4.907-2.974 0-4.508 1.963-4.508 5.52m8.679 7.667v-2.76c-.981 2.024-2.821 3.066-5.183 3.066-4.078 0-6.133-3.465-6.133-7.973 0-4.324 2.147-7.973 6.44-7.973 2.239 0 3.956 1.012 4.876 3.005v-2.699h2.637V25.54zm-31.445-11.009-2.76-7.482V25.54h-2.76V5.393h4.784l4.569 11.56 1.871 5.552 1.87-5.551 4.6-11.561h4.447V25.54h-2.76V7.263l-2.361 7.268-4.447 11.01h-2.668zm-21.511-2.238c-2.791 0-4.202 1.81-4.478 4.477h8.556c-.153-2.852-1.441-4.477-4.078-4.477m5.888 12.635c-1.258.674-3.19.92-4.754.92-5.734 0-8.249-3.312-8.249-8.004 0-4.631 2.576-7.943 7.237-7.943 4.723 0 6.624 3.281 6.624 7.943v1.196h-11.193c.368 2.606 2.055 4.293 5.673 4.293 1.779 0 3.282-.337 4.662-.828zm-15.094-2.148v2.362c-.92.49-2.33.705-3.741.705-5.459 0-8.004-3.312-8.004-8.004 0-4.63 2.545-7.942 8.004-7.942 1.38 0 2.453.184 3.649.736v2.453c-.981-.46-2.024-.736-3.465-.736-3.987 0-5.612 2.515-5.612 5.49s1.656 5.489 5.673 5.489c1.564 0 2.546-.215 3.496-.552M140.124 6.16c0-1.166.766-1.84 1.84-1.84 1.073 0 1.84.674 1.84 1.84S143.037 8 141.964 8c-1.074 0-1.84-.675-1.84-1.84m.49 19.38V10.208h2.638v15.334zm-8.233 0h-3.527l-5.949-15.332h2.76l4.968 13.094 4.937-13.094h2.76zm-15.455-9.046v9.047h-2.576V10.207h2.576v2.699c.889-1.81 2.423-3.097 5.428-2.913v2.576c-3.373-.338-5.428.674-5.428 3.925m-12.463-4.201c-2.791 0-4.202 1.81-4.478 4.477h8.556c-.153-2.852-1.441-4.477-4.078-4.477m5.888 12.635c-1.258.674-3.19.92-4.754.92-5.734 0-8.249-3.312-8.249-8.004 0-4.631 2.576-7.943 7.237-7.943 4.723 0 6.624 3.281 6.624 7.943v1.196h-11.193c.368 2.606 2.055 4.293 5.673 4.293 1.779 0 3.282-.337 4.662-.828zM95.024 19.99c0 3.496-2.085 5.857-7.084 5.857-3.894 0-5.704-.766-7.268-1.564v-2.821c1.87.981 4.754 1.687 7.422 1.687 3.036 0 4.17-1.196 4.17-2.975s-1.104-2.73-4.937-3.65c-4.539-1.103-6.563-2.667-6.563-5.98 0-3.127 2.392-5.458 7.084-5.458 2.914 0 4.784.705 6.164 1.472v2.76c-2.024-1.165-4.201-1.533-6.286-1.533-2.638 0-4.202.92-4.202 2.76 0 1.656 1.288 2.484 4.845 3.373 4.263 1.073 6.655 2.453 6.655 6.072m-34.001-2.116c0 3.68 1.472 5.52 4.201 5.52 2.362 0 4.478-1.503 4.478-4.906V17.26c0-3.404-1.932-4.907-4.17-4.907-2.975 0-4.509 1.963-4.509 5.52m8.679 7.667v-2.76c-.981 2.024-2.821 3.066-5.183 3.066-4.078 0-6.133-3.465-6.133-7.973 0-4.324 2.147-7.973 6.44-7.973 2.239 0 3.956 1.012 4.876 3.005v-2.699h2.637V25.54zM51.91 16.494v9.047h-2.577V10.207h2.576v2.699c.89-1.81 2.423-3.097 5.428-2.913v2.576c-3.373-.338-5.428.674-5.428 3.925M42.224 6.16c0-1.166.767-1.84 1.84-1.84s1.84.674 1.84 1.84S45.137 8 44.064 8s-1.84-.675-1.84-1.84m.49 19.38V10.208h2.638v15.334zm-6.427-5.949V5.393h2.76v14.014c0 3.71-1.626 6.256-5.428 6.256-1.442 0-2.546-.245-3.312-.521v-2.668c.828.337 1.84.521 2.852.521 2.33 0 3.128-1.41 3.128-3.404\" />\n    </svg>");
};
var $44f664ec6684700a$export$dabef2be6cd28c20 = function JiraServiceManagementLogo(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Jira Service Management' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $61c2bd5f28c47c3c$export$438460117ae6b7ee).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $61c2bd5f28c47c3c$export$438460117ae6b7ee).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $61c2bd5f28c47c3c$export$438460117ae6b7ee).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $b621ed2cc6a05fa8$export$3dd7971102e44fa8)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $96958b5ae3603ec3$export$2e2bcd8739ae039), {
        appearance: appearance,
        label: label,
        iconColor: iconColor,
        size: size,
        svg: $44f664ec6684700a$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};



var $5FkrB = parcelRequire("5FkrB");




var $0b480349a5d37260$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor;
    var colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $cc7f4c450b6535cc$export$bbacc3980e0f3029)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" viewBox=\"0 0 32 32\" focusable=\"false\" aria-hidden=\"true\" xmlns=\"http://www.w3.org/2000/svg\">\n      <path fill=\"".concat(colors.iconColor, "\" d=\"M11.034 21.99h-2.22c-3.346 0-5.747-2.05-5.747-5.052h11.932c.619 0 1.019.44 1.019 1.062v12.007c-2.983 0-4.984-2.416-4.984-5.784zm5.893-5.967h-2.219c-3.347 0-5.748-2.013-5.748-5.015h11.933c.618 0 1.055.402 1.055 1.025V24.04c-2.983 0-5.02-2.416-5.02-5.784zm5.93-5.93h-2.219c-3.347 0-5.748-2.05-5.748-5.052h11.933c.618 0 1.018.439 1.018 1.025v12.007c-2.983 0-4.984-2.416-4.984-5.784z\"/>\n    </svg>");
};
var $0b480349a5d37260$export$c4b5b1f965d8b3eb = function JiraIcon(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Jira' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $61c2bd5f28c47c3c$export$438460117ae6b7ee).size : _ref2$size, testId = _ref2.testId, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $61c2bd5f28c47c3c$export$438460117ae6b7ee).textColor : _ref2$textColor, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $61c2bd5f28c47c3c$export$438460117ae6b7ee).iconColor : _ref2$iconColor;
    var _useThemeObserver = (0, $b621ed2cc6a05fa8$export$3dd7971102e44fa8)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $96958b5ae3603ec3$export$2e2bcd8739ae039), {
        appearance: appearance,
        label: label,
        svg: $0b480349a5d37260$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        size: size,
        testId: testId,
        textColor: textColor
    });
};



var $5FkrB = parcelRequire("5FkrB");




var $5f3c0cc4476ee39f$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor;
    var colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $cc7f4c450b6535cc$export$bbacc3980e0f3029)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" viewBox=\"0 0 77 32\" focusable=\"false\" aria-hidden=\"true\" xmlns=\"http://www.w3.org/2000/svg\">\n      <path fill=\"".concat(colors.iconColor, "\" d=\"M7.967 21.323H5.748C2.401 21.323 0 19.273 0 16.271h11.933c.618 0 1.018.44 1.018 1.062V29.34c-2.983 0-4.984-2.416-4.984-5.784zm5.894-5.967h-2.22c-3.346 0-5.747-2.013-5.747-5.015h11.932c.618 0 1.055.402 1.055 1.025v12.007c-2.983 0-5.02-2.416-5.02-5.784zm5.93-5.93h-2.22c-3.347 0-5.748-2.05-5.748-5.052h11.933c.618 0 1.019.439 1.019 1.025v12.007c-2.983 0-4.984-2.416-4.984-5.784z\"/>\n      <path fill=\"").concat(colors.textColor, "\" d=\"M65.023 17.874c0 3.68 1.472 5.52 4.202 5.52 2.36 0 4.477-1.503 4.477-4.907V17.26c0-3.404-1.932-4.906-4.17-4.906-2.975 0-4.509 1.962-4.509 5.52m8.679 7.666v-2.76c-.981 2.024-2.821 3.067-5.183 3.067-4.078 0-6.133-3.465-6.133-7.973 0-4.324 2.147-7.974 6.44-7.974 2.239 0 3.956 1.012 4.876 3.006v-2.699h2.637V25.54zM55.91 16.493v9.047h-2.577V10.207h2.576v2.698c.89-1.809 2.423-3.097 5.428-2.913v2.576c-3.373-.337-5.428.675-5.428 3.925M46.224 6.159c0-1.165.767-1.84 1.84-1.84s1.84.675 1.84 1.84-.767 1.84-1.84 1.84-1.84-.675-1.84-1.84m.49 19.381V10.207h2.638V25.54zm-6.427-5.95V5.393h2.76v14.015c0 3.71-1.626 6.256-5.428 6.256-1.442 0-2.546-.246-3.312-.522v-2.668c.828.338 1.84.522 2.852.522 2.33 0 3.128-1.41 3.128-3.404\"/>\n    </svg>");
};
var $5f3c0cc4476ee39f$export$17d3acb0b4379d02 = function JiraLogo(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Jira' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $61c2bd5f28c47c3c$export$438460117ae6b7ee).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $61c2bd5f28c47c3c$export$438460117ae6b7ee).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $61c2bd5f28c47c3c$export$438460117ae6b7ee).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $b621ed2cc6a05fa8$export$3dd7971102e44fa8)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $96958b5ae3603ec3$export$2e2bcd8739ae039), {
        appearance: appearance,
        label: label,
        iconColor: iconColor,
        size: size,
        svg: $5f3c0cc4476ee39f$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};



var $5FkrB = parcelRequire("5FkrB");


var $5FkrB = parcelRequire("5FkrB");




var $61d4fcd56468b2fe$export$7818df200941dbbf = function getColorsForLoom(appearance, colorMode) {
    var iconColor = (0, $cc7f4c450b6535cc$export$bbacc3980e0f3029)(appearance, colorMode).iconColor;
    var textColor = (0, $cc7f4c450b6535cc$export$bbacc3980e0f3029)(appearance, colorMode).textColor;
    if (colorMode === 'dark') switch(appearance){
        case 'brand':
            iconColor = '#625DF5';
            textColor = '#EFF0FF';
            break;
    }
    else switch(appearance){
        case 'brand':
            iconColor = '#625DF5';
            textColor = '#252434';
            break;
    }
    return {
        iconColor: iconColor,
        textColor: textColor
    };
};


var $d3bf053d58aecb39$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor;
    var colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $61d4fcd56468b2fe$export$7818df200941dbbf)(appearance, colorMode);
    return "<svg\n    fill=\"none\"\n    height=\"32\"\n    viewBox=\"0 0 32 32\"\n    xmlns=\"http://www.w3.org/2000/svg\"\n    focusable=\"false\"\n    aria-hidden=\"true\"\n  >\n    <path\n      d=\"M27.333 15.508h-6.628l5.74-3.315-1.26-2.184-5.74 3.314 3.313-5.74-2.184-1.26-3.313 5.74V5.434h-2.522v6.628l-3.314-5.74-2.184 1.26 3.314 5.74-5.74-3.314-1.26 2.184 5.74 3.314H4.667v2.521h6.627l-5.74 3.314 1.261 2.184 5.74-3.313-3.314 5.74 2.184 1.26 3.314-5.74V28.1h2.521v-6.627l3.313 5.74 2.184-1.261-3.314-5.74 5.74 3.313 1.261-2.184-5.74-3.313h6.628zM16 20.198a3.442 3.442 0 1 1 0-6.885 3.442 3.442 0 0 1 0 6.884\"\n      fill=\"".concat(colors.iconColor, "\"\n    />\n  </svg>");
};
var $d3bf053d58aecb39$export$8d789f76fde3e05 = function LoomIcon(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Loom' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $61c2bd5f28c47c3c$export$438460117ae6b7ee).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $61c2bd5f28c47c3c$export$438460117ae6b7ee).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $61c2bd5f28c47c3c$export$438460117ae6b7ee).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $b621ed2cc6a05fa8$export$3dd7971102e44fa8)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $96958b5ae3603ec3$export$2e2bcd8739ae039), {
        appearance: appearance,
        label: label,
        svg: $d3bf053d58aecb39$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        size: size,
        testId: testId,
        textColor: textColor
    });
};


var $24fc4a6d140006a0$export$1bf47cdade1a9fcb = function LoomAttributionIcon(_ref) {
    var appearance = _ref.appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Loom Attribution' : _ref$label, _ref$size = _ref.size, size = _ref$size === void 0 ? (0, $61c2bd5f28c47c3c$export$438460117ae6b7ee).size : _ref$size, testId = _ref.testId, _ref$iconColor = _ref.iconColor, iconColor = _ref$iconColor === void 0 ? (0, $61c2bd5f28c47c3c$export$438460117ae6b7ee).iconColor : _ref$iconColor, _ref$textColor = _ref.textColor, textColor = _ref$textColor === void 0 ? (0, $61c2bd5f28c47c3c$export$438460117ae6b7ee).textColor : _ref$textColor;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $d3bf053d58aecb39$export$8d789f76fde3e05), {
        appearance: appearance,
        label: label,
        size: size,
        testId: testId,
        iconColor: iconColor,
        textColor: textColor
    });
};



var $5FkrB = parcelRequire("5FkrB");




var $550dd97c2a7853ef$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor;
    var colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $61d4fcd56468b2fe$export$7818df200941dbbf)(appearance, colorMode);
    return "<svg\n\t\tfill=\"none\"\n\t\theight=\"32\"\n\t\txmlns=\"http://www.w3.org/2000/svg\"\n\t\tfocusable=\"false\"\n\t\taria-hidden=\"true\"\n\t\tviewBox=\"0 0 88 32\"\n\t>\n\t\t<path\n\t\t\td=\"M29.488 12.765h-8.983l7.78-4.344-1.544-2.585-7.78 4.344 4.492-7.523-2.674-1.493-4.491 7.522V0H13.2v8.687L8.71 1.164 6.035 2.657l4.49 7.522-7.778-4.343L1.204 8.42l7.779 4.344H0v2.986h8.982l-7.778 4.343 1.543 2.585 7.78-4.342-4.492 7.522 2.674 1.493L13.2 19.83v8.687h3.087v-8.873l4.574 7.663 2.507-1.4-4.575-7.663 7.946 4.437 1.544-2.586-7.779-4.343h8.982v-2.986h.001Zm-14.744 5.552c-2.318 0-4.197-1.817-4.197-4.059s1.88-4.059 4.197-4.059 4.198 1.817 4.198 4.06c0 2.24-1.88 4.058-4.198 4.058\"\n\t\t\tfill=\"".concat(colors.iconColor, "\"\n\t\t/>\n\t\t<path\n\t\t\td=\"M38.379 26.847V10.094h3.18v16.753zm30.503-11.79h3.036v1.438c.646-1.15 2.153-1.773 3.444-1.773 1.602 0 2.893.695 3.49 1.964.932-1.438 2.177-1.964 3.731-1.964 2.175 0 4.256 1.318 4.256 4.48v7.642h-3.084V19.85c0-1.27-.623-2.228-2.081-2.228-1.363 0-2.177 1.054-2.177 2.324v6.9h-3.155V19.85c0-1.27-.646-2.228-2.081-2.228-1.387 0-2.2 1.03-2.2 2.324v6.9h-3.18V15.057Zm-20.134 12.13c-3.582 0-6.176-2.66-6.176-6.234 0-3.517 2.585-6.242 6.176-6.242 3.609 0 6.177 2.75 6.177 6.242 0 3.547-2.596 6.234-6.177 6.234m0-9.59a3.357 3.357 0 0 0 0 6.713 3.357 3.357 0 0 0 0-6.713m12.966 9.59c-3.583 0-6.177-2.66-6.177-6.234 0-3.517 2.586-6.242 6.177-6.242 3.608 0 6.176 2.75 6.176 6.242 0 3.547-2.597 6.234-6.176 6.234m0-9.63a3.397 3.397 0 0 0-3.39 3.395 3.397 3.397 0 0 0 3.39 3.395 3.396 3.396 0 0 0 0-6.79M64.933 5.63c0-1.102-.697-1.522-1.983-1.837-.803-.21-1.018-.368-1.018-.63q0-.473.804-.473c.643 0 1.286.21 1.93.473V1.798a4.5 4.5 0 0 0-1.876-.42c-1.447 0-2.25.682-2.25 1.785 0 1.05.696 1.575 1.928 1.838.804.157 1.072.315 1.072.682 0 .263-.215.473-.804.473a4.46 4.46 0 0 1-2.197-.63v1.417c.483.263 1.233.473 2.197.473 1.5.052 2.197-.683 2.197-1.785Zm16.662-4.067v5.988h1.3V3.007l.542 1.23 1.841 3.368h1.626V1.563h-1.3v3.85l-.488-1.123-1.463-2.727zm-8.056 0h-1.465v6.042h1.465zm-23.981 0v6.042h2.863l.432-1.295h-1.945V1.563zm-5.671 0v1.295h1.604v4.747h1.44V2.858h1.715V1.563zm-2.177 0h-1.802l-2.066 6.042h1.59l.317-1.025a4 4 0 0 0 1.113.162q.556 0 1.113-.162l.318 1.025h1.59zm-.9 3.938a3 3 0 0 1-.743-.108l.742-2.643.742 2.643c-.265.054-.477.108-.742.108Zm16.577-3.938H55.53L53.4 7.605h1.638l.328-1.025q.573.162 1.146.162.574 0 1.147-.162l.328 1.025h1.638l-2.24-6.042Zm-.928 3.938c-.273 0-.546-.054-.765-.108l.765-2.643.764 2.643a3.3 3.3 0 0 1-.764.108m21.98-3.938h-1.857l-2.13 6.042h1.638l.328-1.025q.574.162 1.147.162c.573 0 .764-.054 1.146-.162l.328 1.025h1.638zm-.93 3.938c-.272 0-.545-.054-.763-.108l.764-2.643.765 2.643a3.3 3.3 0 0 1-.765.108Zm-6.894.129c0-1.102-.697-1.522-1.983-1.837-.803-.21-1.018-.368-1.018-.63q0-.473.804-.473c.643 0 1.286.21 1.93.473V1.798a4.5 4.5 0 0 0-1.876-.42c-1.447 0-2.25.682-2.25 1.785 0 1.05.696 1.575 1.928 1.838.804.157 1.072.315 1.072.682 0 .263-.215.473-.804.473-.75 0-1.608-.263-2.197-.63v1.417c.482.263 1.233.473 2.197.473 1.447.052 2.197-.683 2.197-1.785Z\"\n\t\t\tfill=\"").concat(colors.textColor, "\"\n\t\t/>\n\t</svg>");
};
var $550dd97c2a7853ef$export$6e87ce8d41eda665 = function LoomAttributionLogo(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Loom Attribution' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $61c2bd5f28c47c3c$export$438460117ae6b7ee).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $61c2bd5f28c47c3c$export$438460117ae6b7ee).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $61c2bd5f28c47c3c$export$438460117ae6b7ee).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $b621ed2cc6a05fa8$export$3dd7971102e44fa8)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $96958b5ae3603ec3$export$2e2bcd8739ae039), {
        appearance: appearance,
        label: label,
        iconColor: iconColor,
        size: size,
        svg: $550dd97c2a7853ef$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};




var $5FkrB = parcelRequire("5FkrB");




var $df29a5258322e53f$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor;
    var colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $61d4fcd56468b2fe$export$7818df200941dbbf)(appearance, colorMode);
    return "<svg\n      fill=\"none\"\n      height=\"32\"\n      xmlns=\"http://www.w3.org/2000/svg\"\n      viewBox=\"0 0 98 32\"\n      focusable=\"false\"\n      aria-hidden=\"true\"\n    >\n      <path\n        d=\"M29.657 13.659h-8.672l7.51-4.337-1.649-2.857-7.51 4.336 4.335-7.51-2.857-1.65-4.336 7.51V.479H13.18v8.672l-4.337-7.51-2.856 1.65 4.336 7.51-7.51-4.336-1.65 2.857 7.51 4.336H0v3.299h8.671l-7.51 4.336 1.65 2.858 7.51-4.336-4.336 7.51 2.857 1.65 4.336-7.511v8.672h3.3v-8.671l4.335 7.51 2.857-1.65-4.336-7.51 7.51 4.336 1.65-2.858-7.51-4.335h8.672v-3.3zM14.83 19.794a4.503 4.503 0 1 1 0-9.006 4.503 4.503 0 0 1 0 9.006\"\n        fill=\"".concat(colors.iconColor, "\"\n      />\n      <path\n        d=\"M37.303 26.155V4.459h3.983v21.696zm38.204-14.743h3.803v1.798c.808-1.438 2.696-2.218 4.313-2.218 2.007 0 3.624.87 4.373 2.457 1.167-1.798 2.726-2.457 4.673-2.457 2.725 0 5.33 1.648 5.33 5.604v9.559h-3.862v-8.75c0-1.588-.78-2.786-2.607-2.786-1.707 0-2.726 1.318-2.726 2.907v8.63H84.85v-8.75c0-1.59-.808-2.787-2.606-2.787-1.738 0-2.757 1.288-2.757 2.907v8.63h-3.981zm-25.219 15.17c-4.487 0-7.737-3.328-7.737-7.798 0-4.4 3.24-7.806 7.737-7.806 4.52 0 7.737 3.439 7.737 7.806 0 4.438-3.251 7.798-7.737 7.798m0-11.996a4.2 4.2 0 0 0-4.197 4.199c0 2.315 1.883 4.199 4.197 4.199s4.196-1.884 4.196-4.2a4.2 4.2 0 0 0-4.196-4.198m16.245 11.996c-4.487 0-7.737-3.328-7.737-7.798 0-4.4 3.24-7.806 7.737-7.806 4.52 0 7.737 3.439 7.737 7.806 0 4.438-3.253 7.798-7.737 7.798m0-12.046c-2.34 0-4.245 1.906-4.245 4.247s1.904 4.247 4.245 4.247a4.25 4.25 0 0 0 4.245-4.247 4.25 4.25 0 0 0-4.245-4.247\"\n        fill=\"").concat(colors.textColor, "\"\n      />\n    </svg>");
};
var $df29a5258322e53f$export$94e206806e36c2ec = function LoomLogo(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Loom' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $61c2bd5f28c47c3c$export$438460117ae6b7ee).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $61c2bd5f28c47c3c$export$438460117ae6b7ee).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $61c2bd5f28c47c3c$export$438460117ae6b7ee).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $b621ed2cc6a05fa8$export$3dd7971102e44fa8)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $96958b5ae3603ec3$export$2e2bcd8739ae039), {
        appearance: appearance,
        label: label,
        iconColor: iconColor,
        size: size,
        svg: $df29a5258322e53f$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};



var $5FkrB = parcelRequire("5FkrB");




var $133343937fec1563$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor;
    var colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $cc7f4c450b6535cc$export$bbacc3980e0f3029)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" viewBox=\"0 0 32 32\" focusable=\"false\" aria-hidden=\"true\" xmlns=\"http://www.w3.org/2000/svg\">\n      <path fill=\"".concat(colors.iconColor, "\" d=\"M17.114 28.127c-.785.578-1.199.537-1.984-.041-3.8-2.727-7.313-5.826-9.668-9.049-.248-.33-.124-.785.248-.991l4.297-2.686q.558-.372.992.124c1.652 1.9 3.264 3.76 5.123 5.082 1.86-1.322 3.47-3.181 5.123-5.082q.434-.495.992-.124l4.297 2.686c.372.206.496.66.248.991-2.355 3.223-5.867 6.322-9.668 9.09m-.992-11.858c3.388 0 6.198-2.768 6.198-6.156s-2.81-6.239-6.198-6.239-6.198 2.81-6.198 6.239c0 3.43 2.727 6.156 6.198 6.156\"/>\n    </svg>");
};
var $133343937fec1563$export$eeccc49dc7a12d9f = function OpsgenieIcon(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Opsgenie' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $61c2bd5f28c47c3c$export$438460117ae6b7ee).size : _ref2$size, testId = _ref2.testId, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $61c2bd5f28c47c3c$export$438460117ae6b7ee).textColor : _ref2$textColor, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $61c2bd5f28c47c3c$export$438460117ae6b7ee).iconColor : _ref2$iconColor;
    var _useThemeObserver = (0, $b621ed2cc6a05fa8$export$3dd7971102e44fa8)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $96958b5ae3603ec3$export$2e2bcd8739ae039), {
        appearance: appearance,
        svg: $133343937fec1563$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        label: label,
        size: size,
        testId: testId,
        textColor: textColor
    });
};



var $5FkrB = parcelRequire("5FkrB");




var $7012d37ccd20defe$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor;
    var colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $cc7f4c450b6535cc$export$bbacc3980e0f3029)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" viewBox=\"0 0 154 32\" focusable=\"false\" aria-hidden=\"true\" xmlns=\"http://www.w3.org/2000/svg\">\n      <path fill=\"".concat(colors.iconColor, "\" d=\"M11.78 28.127c-.785.578-1.198.537-1.983-.041-3.801-2.727-7.313-5.826-9.668-9.049-.248-.33-.124-.785.248-.991l4.297-2.686q.558-.372.991.124c1.653 1.9 3.264 3.76 5.124 5.082 1.859-1.322 3.47-3.181 5.123-5.082q.435-.495.992-.124l4.297 2.686c.371.206.495.66.247.991-2.355 3.223-5.867 6.322-9.668 9.09m-.99-11.857c3.388 0 6.197-2.768 6.197-6.156s-2.81-6.239-6.197-6.239-6.198 2.81-6.198 6.239c0 3.43 2.727 6.156 6.198 6.156\"/>\n      <path fill=\"").concat(colors.textColor, "\" d=\"M146.689 12.293c-2.79 0-4.201 1.81-4.477 4.477h8.556c-.153-2.852-1.441-4.477-4.079-4.477m5.888 12.635c-1.257.674-3.189.92-4.753.92-5.735 0-8.249-3.312-8.249-8.004 0-4.631 2.576-7.943 7.237-7.943 4.723 0 6.624 3.281 6.624 7.943v1.196h-11.193c.368 2.606 2.054 4.293 5.673 4.293 1.779 0 3.281-.337 4.661-.828zM133.385 6.16c0-1.166.767-1.84 1.841-1.84s1.84.674 1.84 1.84-.767 1.84-1.84 1.84c-1.074 0-1.841-.675-1.841-1.84m.491 19.38V10.208h2.638v15.334zm-3.677-8.984v8.985h-2.638V16.28c0-2.76-1.104-3.987-3.618-3.987-2.454 0-4.14 1.625-4.14 4.723v8.525h-2.638V10.208h2.638v2.514c.981-1.81 2.79-2.821 4.845-2.821 3.527 0 5.551 2.423 5.551 6.655m-22.921-4.263c-2.791 0-4.201 1.81-4.477 4.477h8.556c-.154-2.852-1.442-4.477-4.079-4.477m5.888 12.635c-1.257.674-3.189.92-4.753.92-5.735 0-8.25-3.312-8.25-8.004 0-4.631 2.576-7.943 7.238-7.943 4.722 0 6.624 3.281 6.624 7.943v1.196h-11.194c.368 2.606 2.055 4.293 5.674 4.293 1.778 0 3.281-.337 4.661-.828zm-18.639-.614v-1.533c-.981 2.024-2.821 3.067-5.182 3.067-4.048 0-6.072-3.466-6.072-7.974 0-4.324 2.116-7.973 6.378-7.973 2.239 0 3.956 1.012 4.876 3.005v-2.698h2.576V24.16c0 4.508-2.116 7.544-7.605 7.544-2.576 0-3.987-.337-5.459-.828V28.3c1.687.552 3.435.92 5.336.92 3.834 0 5.152-2.055 5.152-4.907m-8.678-6.44c0 3.68 1.472 5.52 4.2 5.52 2.362 0 4.478-1.503 4.478-4.906V17.26c0-3.404-1.932-4.907-4.17-4.907-2.975 0-4.508 1.963-4.508 5.52m-4.703 3.497c0 2.545-1.656 4.477-5.765 4.477-2.3 0-4.17-.52-5.336-1.134v-2.79c1.319.766 3.527 1.502 5.459 1.502 2.024 0 3.066-.828 3.066-2.024 0-1.165-.89-1.84-3.802-2.545-3.404-.829-4.846-2.147-4.846-4.662 0-2.668 2.055-4.293 5.55-4.293 1.994 0 3.804.49 4.938 1.104v2.73c-1.84-.92-3.342-1.411-4.968-1.411-1.932 0-2.974.674-2.974 1.87 0 1.073.736 1.748 3.557 2.423 3.404.828 5.121 2.085 5.121 4.753m-16.274-3.496c0-3.68-1.472-5.52-4.202-5.52-2.36 0-4.477 1.503-4.477 4.907v1.227c0 3.404 1.932 4.906 4.17 4.906 2.975 0 4.509-1.962 4.509-5.52m-3.803 7.974c-2.239 0-3.956-1.013-4.876-3.006v8.679h-2.637V10.207h2.637v2.76c.981-2.024 2.821-3.066 5.183-3.066 4.079 0 6.133 3.465 6.133 7.973 0 4.324-2.147 7.973-6.44 7.973m-20.121 0c-6.225 0-9.721-4.293-9.721-10.426 0-6.072 3.496-10.335 9.721-10.335 6.195 0 9.69 4.263 9.69 10.335 0 6.133-3.495 10.426-9.69 10.426m0-18.124c-4.968 0-6.961 3.527-6.961 7.698 0 4.262 1.993 7.789 6.961 7.789 4.937 0 6.93-3.527 6.93-7.79 0-4.17-1.993-7.697-6.93-7.697\" />\n    </svg>");
};
var $7012d37ccd20defe$export$a1c6484cdecc2c4b = function OpsgenieLogo(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Opsgenie' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $61c2bd5f28c47c3c$export$438460117ae6b7ee).size : _ref2$size, testId = _ref2.testId, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $61c2bd5f28c47c3c$export$438460117ae6b7ee).textColor : _ref2$textColor, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $61c2bd5f28c47c3c$export$438460117ae6b7ee).iconColor : _ref2$iconColor;
    var _useThemeObserver = (0, $b621ed2cc6a05fa8$export$3dd7971102e44fa8)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $96958b5ae3603ec3$export$2e2bcd8739ae039), {
        appearance: appearance,
        iconColor: iconColor,
        label: label,
        size: size,
        svg: $7012d37ccd20defe$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};



var $5FkrB = parcelRequire("5FkrB");




var $96f99918f881107b$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor;
    var colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $cc7f4c450b6535cc$export$bbacc3980e0f3029)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" focusable=\"false\" aria-hidden=\"true\">\n    <g fill=\"".concat(colors.iconColor, "\" fill-rule=\"evenodd\">\n      <path d=\"M17.06 4.246a2.79 2.79 0 0 0-2.736-.026l-.049.033-.002.001c-.605.35-1.048.91-1.256 1.558-.085.268-.13.552-.13.842v3.675l4.603 2.656a3.64 3.64 0 0 1 1.824 3.155v9.487a3.6 3.6 0 0 1-.214 1.23l6.175-3.566a2.77 2.77 0 0 0 1.392-2.407v-9.487c0-.991-.532-1.912-1.392-2.408z\"/>\n      <path d=\"m6.058 9 6.176-3.566a3.7 3.7 0 0 0-.214 1.23v9.486c0 1.303.693 2.505 1.823 3.155l4.604 2.657v3.674c0 .29-.045.575-.13.843a2.8 2.8 0 0 1-1.258 1.558.4.4 0 0 0-.05.033c-.851.47-1.89.461-2.735-.026L6.06 23.301a2.78 2.78 0 0 1-1.392-2.408v-9.486c0-.996.529-1.912 1.391-2.408z\"/>\n    </g>\n  </svg>");
};
var $96f99918f881107b$export$e23ae35269442b4f = function RovoIcon(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Rovo' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $61c2bd5f28c47c3c$export$438460117ae6b7ee).size : _ref2$size, testId = _ref2.testId, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $61c2bd5f28c47c3c$export$438460117ae6b7ee).textColor : _ref2$textColor, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $61c2bd5f28c47c3c$export$438460117ae6b7ee).iconColor : _ref2$iconColor;
    var _useThemeObserver = (0, $b621ed2cc6a05fa8$export$3dd7971102e44fa8)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $96958b5ae3603ec3$export$2e2bcd8739ae039), {
        appearance: appearance,
        svg: $96f99918f881107b$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        label: label,
        size: size,
        testId: testId,
        textColor: textColor
    });
};



var $5FkrB = parcelRequire("5FkrB");




var $93173c7c8bd4c45d$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor;
    var colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $cc7f4c450b6535cc$export$bbacc3980e0f3029)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" viewBox=\"0 0 100 32\" focusable=\"false\" aria-hidden=\"true\" xmlns=\"http://www.w3.org/2000/svg\">\n      <path\n        d=\"M12.393 4.246a2.79 2.79 0 0 0-2.735-.026.4.4 0 0 1-.05.033l-.001.001c-.606.35-1.048.91-1.257 1.558q-.129.404-.13.842v3.675l4.603 2.656a3.64 3.64 0 0 1 1.824 3.155v9.487a3.6 3.6 0 0 1-.214 1.23l6.175-3.566A2.77 2.77 0 0 0 22 20.884v-9.487c0-.991-.532-1.912-1.392-2.408z\"\n        fill=\"".concat(colors.iconColor, "\"\n        fillRule=\"evenodd\"\n      />\n      <path\n        d=\"m1.391 9 6.176-3.566a3.6 3.6 0 0 0-.214 1.23v9.486c0 1.303.693 2.505 1.823 3.155h.001l4.603 2.657v3.674c0 .29-.045.575-.13.843a2.8 2.8 0 0 1-1.258 1.558.4.4 0 0 0-.05.033c-.85.47-1.89.461-2.734-.026l-8.216-4.743A2.78 2.78 0 0 1 0 20.893v-9.486c0-.996.529-1.912 1.391-2.408z\"\n        fill=\"").concat(colors.iconColor, "\"\n        fillRule=\"evenodd\"\n      />\n      <path\n        d=\"M91.688 25.848c-4.6 0-7.298-3.404-7.298-8.004S87.088 9.9 91.688 9.9c4.57 0 7.238 3.342 7.238 7.942s-2.668 8.004-7.238 8.004zm0-13.494c-3.28 0-4.722 2.576-4.722 5.49 0 2.913 1.441 5.55 4.722 5.55 3.251 0 4.662-2.637 4.662-5.55 0-2.914-1.41-5.49-4.662-5.49M77.675 25.54H74.15L68.2 10.208h2.76l4.968 13.094 4.938-13.095h2.76zm-17.462.308c-4.6 0-7.299-3.404-7.299-8.004s2.7-7.943 7.3-7.943c4.568 0 7.236 3.342 7.236 7.942s-2.668 8.004-7.237 8.004zm0-13.494c-3.281 0-4.723 2.576-4.723 5.49 0 2.913 1.442 5.55 4.723 5.55 3.25 0 4.661-2.637 4.661-5.55 0-2.914-1.41-5.49-4.66-5.49zM43.177 8.03H39.13v7.36h4.048c3.588 0 4.692-1.38 4.692-3.68 0-2.177-1.134-3.68-4.692-3.68zm7.452 3.619c0 3.036-1.288 5.09-3.956 5.949l4.938 7.943H48.36l-4.447-7.514H39.13v7.514h-2.76V5.393h7.115c4.815 0 7.145 2.392 7.145 6.256z\"\n        fill=\"").concat(colors.textColor, "\"\n      />\n    </svg>");
};
var $93173c7c8bd4c45d$export$a0f6cb8061290bbb = function RovoLogo(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Rovo' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $61c2bd5f28c47c3c$export$438460117ae6b7ee).size : _ref2$size, testId = _ref2.testId, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $61c2bd5f28c47c3c$export$438460117ae6b7ee).textColor : _ref2$textColor, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $61c2bd5f28c47c3c$export$438460117ae6b7ee).iconColor : _ref2$iconColor;
    var _useThemeObserver = (0, $b621ed2cc6a05fa8$export$3dd7971102e44fa8)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $96958b5ae3603ec3$export$2e2bcd8739ae039), {
        appearance: appearance,
        iconColor: iconColor,
        label: label,
        size: size,
        svg: $93173c7c8bd4c45d$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};



var $5FkrB = parcelRequire("5FkrB");




var $e5090466625d94f8$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor;
    var colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $cc7f4c450b6535cc$export$bbacc3980e0f3029)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" viewBox=\"0 0 32 32\" focusable=\"false\" aria-hidden=\"true\" xmlns=\"http://www.w3.org/2000/svg\">\n      <path fill=\"".concat(colors.iconColor, "\" d=\"M16 12.604c-3.033 0-5.981 1.37-8.39 3.489q-.375.373-.748.373c-.208 0-.415-.124-.581-.332l-3.032-3.572c-.166-.207-.25-.415-.25-.581 0-.25.125-.457.374-.706 3.655-3.24 8.1-5.067 12.627-5.067s8.97 1.827 12.626 5.067c.249.249.374.457.374.706 0 .166-.084.374-.25.581l-3.032 3.572c-.166.208-.373.332-.581.332q-.374 0-.748-.374c-2.409-2.118-5.358-3.488-8.39-3.488m0 13.374c-3.365 0-6.106-2.742-6.106-6.064S12.635 13.85 16 13.85s6.106 2.7 6.106 6.064-2.741 6.063-6.105 6.063\"/>\n    </svg>");
};
var $e5090466625d94f8$export$f3f5aa321d88adf9 = function StatuspageIcon(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Statuspage' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $61c2bd5f28c47c3c$export$438460117ae6b7ee).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $61c2bd5f28c47c3c$export$438460117ae6b7ee).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $61c2bd5f28c47c3c$export$438460117ae6b7ee).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $b621ed2cc6a05fa8$export$3dd7971102e44fa8)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $96958b5ae3603ec3$export$2e2bcd8739ae039), {
        appearance: appearance,
        label: label,
        svg: $e5090466625d94f8$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        size: size,
        testId: testId,
        textColor: textColor
    });
};



var $5FkrB = parcelRequire("5FkrB");




var $a0b9b85073824ba8$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor;
    var colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $cc7f4c450b6535cc$export$bbacc3980e0f3029)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" viewBox=\"0 0 188 32\" focusable=\"false\" aria-hidden=\"true\" xmlns=\"http://www.w3.org/2000/svg\">\n      <path fill=\"".concat(colors.iconColor, "\" d=\"M13 12.604c-3.032 0-5.98 1.37-8.39 3.489q-.373.373-.747.373c-.208 0-.416-.124-.582-.332L.25 12.562c-.167-.207-.25-.415-.25-.581 0-.25.125-.457.374-.706C4.029 8.035 8.473 6.208 13 6.208s8.971 1.827 12.626 5.067c.25.249.374.457.374.706 0 .166-.083.374-.25.581l-3.031 3.572c-.166.208-.374.332-.582.332q-.373 0-.747-.374c-2.41-2.118-5.358-3.488-8.39-3.488m0 13.374c-3.364 0-6.105-2.742-6.105-6.064S9.635 13.85 13 13.85c3.364 0 6.105 2.7 6.105 6.064s-2.74 6.063-6.105 6.063\" />\n      <path fill=\"").concat(colors.textColor, "\" d=\"M180.293 12.293c-2.79 0-4.201 1.81-4.477 4.477h8.556c-.153-2.852-1.441-4.477-4.079-4.477m5.888 12.635c-1.257.674-3.189.92-4.753.92-5.735 0-8.249-3.312-8.249-8.004 0-4.631 2.576-7.943 7.237-7.943 4.723 0 6.624 3.281 6.624 7.943v1.196h-11.193c.368 2.606 2.054 4.293 5.673 4.293 1.779 0 3.281-.337 4.661-.828zm-18.638-.614v-1.533c-.981 2.024-2.821 3.067-5.183 3.067-4.048 0-6.072-3.466-6.072-7.974 0-4.324 2.116-7.973 6.379-7.973 2.239 0 3.956 1.012 4.876 3.005v-2.698h2.576V24.16c0 4.508-2.116 7.544-7.605 7.544-2.576 0-3.987-.337-5.459-.828V28.3c1.687.552 3.435.92 5.336.92 3.833 0 5.152-2.055 5.152-4.907m-8.679-6.44c0 3.68 1.472 5.52 4.202 5.52 2.361 0 4.477-1.503 4.477-4.906V17.26c0-3.404-1.932-4.907-4.171-4.907-2.974 0-4.508 1.963-4.508 5.52m-16.949.001c0 3.68 1.472 5.52 4.201 5.52 2.362 0 4.478-1.503 4.478-4.906V17.26c0-3.404-1.932-4.907-4.171-4.907-2.975 0-4.508 1.963-4.508 5.52m8.679 7.667v-2.76c-.982 2.024-2.822 3.066-5.183 3.066-4.079 0-6.133-3.465-6.133-7.973 0-4.324 2.146-7.973 6.44-7.973 2.238 0 3.956 1.012 4.876 3.005v-2.699h2.637V25.54zm-16.091-7.666c0-3.68-1.472-5.52-4.201-5.52-2.361 0-4.477 1.503-4.477 4.907v1.227c0 3.404 1.932 4.906 4.17 4.906 2.975 0 4.508-1.962 4.508-5.52m-3.802 7.974c-2.239 0-3.956-1.013-4.876-3.006v8.679h-2.638V10.207h2.638v2.76c.981-2.024 2.821-3.066 5.182-3.066 4.079 0 6.134 3.465 6.134 7.973 0 4.324-2.147 7.973-6.44 7.973m-10.56-4.477c0 2.545-1.656 4.477-5.765 4.477-2.3 0-4.171-.52-5.336-1.134v-2.79c1.318.766 3.526 1.502 5.458 1.502 2.024 0 3.067-.828 3.067-2.024 0-1.165-.889-1.84-3.803-2.545-3.404-.829-4.845-2.147-4.845-4.662 0-2.668 2.055-4.293 5.551-4.293 1.993 0 3.802.49 4.937 1.104v2.73c-1.84-.92-3.343-1.411-4.968-1.411-1.932 0-2.975.674-2.975 1.87 0 1.073.736 1.748 3.558 2.423 3.404.828 5.121 2.085 5.121 4.753m-27.598-2.177v-8.985h2.638v9.26c0 2.76 1.104 3.988 3.618 3.988 2.454 0 4.14-1.626 4.14-4.723v-8.525h2.638V25.54h-2.638v-2.515c-.981 1.81-2.79 2.821-4.845 2.821-3.527 0-5.55-2.422-5.55-6.654m-7.155 1.596c0 1.349.797 2.269 2.422 2.269.614 0 1.196-.123 1.656-.215v2.546a6.3 6.3 0 0 1-1.778.245c-3.282 0-4.876-1.932-4.876-4.784v-8.188h-2.484v-2.453h2.484V6.957h2.576v3.25h4.078v2.454H85.39zm-18.943-2.914c0 3.68 1.472 5.52 4.202 5.52 2.361 0 4.477-1.503 4.477-4.906V17.26c0-3.404-1.932-4.907-4.17-4.907-2.975 0-4.509 1.963-4.509 5.52m8.679 7.667v-2.76c-.981 2.024-2.821 3.066-5.183 3.066-4.078 0-6.133-3.465-6.133-7.973 0-4.324 2.147-7.973 6.44-7.973 2.239 0 3.956 1.012 4.876 3.005v-2.699h2.637V25.54zm-17.258-4.752c0 1.349.797 2.269 2.422 2.269.614 0 1.196-.123 1.656-.215v2.546a6.3 6.3 0 0 1-1.778.245c-3.282 0-4.876-1.932-4.876-4.784v-8.188h-2.484v-2.453h2.484V6.957h2.576v3.25h4.078v2.454h-4.078zm-6.894-.798c0 3.496-2.085 5.858-7.084 5.858-3.894 0-5.704-.767-7.268-1.564v-2.822c1.871.982 4.754 1.687 7.422 1.687 3.036 0 4.17-1.196 4.17-2.975 0-1.778-1.104-2.729-4.937-3.649-4.539-1.104-6.563-2.668-6.563-5.98 0-3.128 2.392-5.459 7.084-5.459 2.914 0 4.784.706 6.164 1.472v2.76c-2.024-1.165-4.201-1.533-6.286-1.533-2.638 0-4.202.92-4.202 2.76 0 1.656 1.288 2.484 4.846 3.373 4.262 1.074 6.654 2.454 6.654 6.072\" />\n    </svg>");
};
var $a0b9b85073824ba8$export$bb4ae5b41b43be04 = function StatuspageLogo(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Statuspage' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $61c2bd5f28c47c3c$export$438460117ae6b7ee).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $61c2bd5f28c47c3c$export$438460117ae6b7ee).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $61c2bd5f28c47c3c$export$438460117ae6b7ee).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $b621ed2cc6a05fa8$export$3dd7971102e44fa8)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $96958b5ae3603ec3$export$2e2bcd8739ae039), {
        appearance: appearance,
        label: label,
        iconColor: iconColor,
        size: size,
        svg: $a0b9b85073824ba8$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};



var $5FkrB = parcelRequire("5FkrB");




var $72b24621895b039d$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor;
    var colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $cc7f4c450b6535cc$export$bbacc3980e0f3029)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" viewBox=\"0 0 32 32\" focusable=\"false\" aria-hidden=\"true\" xmlns=\"http://www.w3.org/2000/svg\">\n      <path fill=".concat(colors.iconColor, " clip-rule=\"evenodd\" d=\"M24.286 5.337H7.714a2.585 2.585 0 0 0-2.585 2.585v16.572a2.585 2.585 0 0 0 2.585 2.584h16.572a2.585 2.585 0 0 0 2.585-2.584V7.922a2.585 2.585 0 0 0-2.585-2.585m-9.791 15.66a.86.86 0 0 1-.859.858h-3.634a.86.86 0 0 1-.859-.859V10.21a.86.86 0 0 1 .859-.86h3.634a.86.86 0 0 1 .859.86zm8.362-4.953a.86.86 0 0 1-.859.859h-3.634a.86.86 0 0 1-.859-.859V10.21a.86.86 0 0 1 .859-.86h3.634a.86.86 0 0 1 .859.86z\" fill-rule=\"evenodd\"/>\n    </svg>");
};
var $72b24621895b039d$export$4384da9b8b140bf4 = function TrelloIcon(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Trello' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $61c2bd5f28c47c3c$export$438460117ae6b7ee).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $61c2bd5f28c47c3c$export$438460117ae6b7ee).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $61c2bd5f28c47c3c$export$438460117ae6b7ee).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $b621ed2cc6a05fa8$export$3dd7971102e44fa8)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $96958b5ae3603ec3$export$2e2bcd8739ae039), {
        appearance: appearance,
        label: label,
        svg: $72b24621895b039d$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        size: size,
        testId: testId,
        textColor: textColor
    });
};



var $5FkrB = parcelRequire("5FkrB");




var $77f83b2a64e78b50$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor;
    var colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $cc7f4c450b6535cc$export$bbacc3980e0f3029)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" viewBox=\"0 0 106 32\" focusable=\"false\" aria-hidden=\"true\" xmlns=\"http://www.w3.org/2000/svg\">\n      <path fill=\"".concat(colors.iconColor, "\" clip-rule=\"evenodd\" d=\"M19.157 4.67H2.585A2.585 2.585 0 0 0 0 7.255v16.572a2.585 2.585 0 0 0 2.585 2.585h16.572a2.585 2.585 0 0 0 2.584-2.585V7.255a2.585 2.585 0 0 0-2.584-2.585M9.365 20.33a.86.86 0 0 1-.858.858H4.873a.86.86 0 0 1-.859-.858V9.543c0-.475.385-.859.859-.859h3.634c.474 0 .858.385.858.86zm8.362-4.952a.86.86 0 0 1-.858.858h-3.634a.86.86 0 0 1-.859-.858V9.543c0-.475.385-.859.859-.859h3.634c.474 0 .858.385.858.86z\" fill-rule=\"evenodd\"/>\n      <path fill=\"").concat(colors.textColor, "\" d=\"M97.64 25.848c-4.6 0-7.298-3.404-7.298-8.004S93.04 9.9 97.64 9.9c4.57 0 7.238 3.342 7.238 7.942s-2.668 8.004-7.238 8.004m0-13.494c-3.281 0-4.722 2.576-4.722 5.49 0 2.913 1.44 5.55 4.722 5.55 3.251 0 4.662-2.637 4.662-5.55 0-2.914-1.411-5.49-4.662-5.49M88.874 25.51c-.215.062-.675.123-1.35.123-2.514 0-4.109-1.196-4.109-4.017V3.798h2.637V21.31c0 1.38.92 1.87 2.055 1.87.276 0 .46 0 .767-.03zm-7.996 0c-.215.062-.675.123-1.35.123-2.514 0-4.109-1.196-4.109-4.017V3.798h2.637V21.31c0 1.38.92 1.87 2.055 1.87.276 0 .46 0 .767-.03zM65.532 12.293c-2.79 0-4.202 1.81-4.478 4.477h8.556c-.153-2.852-1.44-4.477-4.078-4.477m5.888 12.635c-1.258.674-3.19.92-4.754.92-5.734 0-8.249-3.312-8.249-8.004 0-4.631 2.576-7.943 7.237-7.943 4.723 0 6.624 3.281 6.624 7.943v1.196H61.085c.368 2.606 2.055 4.293 5.673 4.293 1.78 0 3.282-.337 4.662-.828zm-19.48-8.434v9.047h-2.576V10.208h2.576v2.698c.89-1.809 2.423-3.097 5.428-2.913v2.576c-3.373-.337-5.428.675-5.428 3.925M32.943 5.393H48.03V8.03h-6.164v17.511h-2.76V8.031h-6.164z\"/>\n    </svg>");
};
var $77f83b2a64e78b50$export$60e26212f3b61a28 = function TrelloLogo(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Trello' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $61c2bd5f28c47c3c$export$438460117ae6b7ee).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $61c2bd5f28c47c3c$export$438460117ae6b7ee).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $61c2bd5f28c47c3c$export$438460117ae6b7ee).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $b621ed2cc6a05fa8$export$3dd7971102e44fa8)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $96958b5ae3603ec3$export$2e2bcd8739ae039), {
        appearance: appearance,
        label: label,
        iconColor: iconColor,
        size: size,
        svg: $77f83b2a64e78b50$var$svg({
            appearance: appearance,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};











var $5FkrB = parcelRequire("5FkrB");




var $50101e7733a6b1d7$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor;
    var colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $cc7f4c450b6535cc$export$bbacc3980e0f3029)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" viewBox=\"0 0 32 32\" focusable=\"false\" aria-hidden=\"true\" xmlns=\"http://www.w3.org/2000/svg\">\n      <path fill=\"".concat(colors.iconColor, "\" d=\"M27.545 24.378 16.96 3.208c-.208-.458-.417-.541-.667-.541-.208 0-.458.083-.708.5-1.5 2.375-2.167 5.125-2.167 8 0 4.001 2.042 7.752 5.042 13.795.334.666.584.791 1.167.791h7.335c.541 0 .833-.208.833-.625 0-.208-.042-.333-.25-.75M12.168 14.377c-.834-1.25-1.084-1.334-1.292-1.334s-.333.083-.708.834L4.875 24.46c-.167.334-.208.459-.208.625 0 .334.291.667.916.667h7.46c.5 0 .875-.416 1.083-1.208.25-1 .334-1.876.334-2.917 0-2.917-1.292-5.751-2.292-7.251\"/>\n    </svg>");
};
var $50101e7733a6b1d7$export$8a485e2e7ed91e8f = function AtlassianIcon(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Atlassian' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $61c2bd5f28c47c3c$export$438460117ae6b7ee).size : _ref2$size, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $61c2bd5f28c47c3c$export$438460117ae6b7ee).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $61c2bd5f28c47c3c$export$438460117ae6b7ee).textColor : _ref2$textColor, testId = _ref2.testId;
    var _useThemeObserver = (0, $b621ed2cc6a05fa8$export$3dd7971102e44fa8)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $96958b5ae3603ec3$export$2e2bcd8739ae039), {
        appearance: appearance,
        label: label,
        svg: $50101e7733a6b1d7$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        textColor: textColor,
        size: size,
        testId: testId
    });
};







var $5FkrB = parcelRequire("5FkrB");



var $5FkrB = parcelRequire("5FkrB");
var $1de484d679ff13a5$var$_excluded = [
    "size"
];
/**
 * Creates a wrapper around the new logo or icon component to ensure it receives the correct default (medium) size prop.
 *
 * @param NewComponent - The new logo or icon component.
 */ var $1de484d679ff13a5$export$667425256e2e7296 = function tempSizeWrapper(NewComponent) {
    return function(_ref) {
        var size = _ref.size, props = (0, $636d9018b4e7304e$export$2e2bcd8739ae039)(_ref, $1de484d679ff13a5$var$_excluded);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        var Component = NewComponent;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(Component, (0, $3305f3b7d3cad1d2$export$2e2bcd8739ae039)({
            size: size || 'medium'
        }, props));
    };
};


var $1cf61e15150efda7$var$_excluded = [
    "shouldUseHexLogo"
];
var $1cf61e15150efda7$export$2469203854060337 = function createFeatureFlaggedRovoComponent(_LegacyComponent, _NewComponent, NewHexComponent) {
    var RovoHexWrapped = (0, $1de484d679ff13a5$export$667425256e2e7296)(NewHexComponent);
    return function(_ref) {
        var _shouldUseHexLogo = _ref.shouldUseHexLogo, props = (0, $636d9018b4e7304e$export$2e2bcd8739ae039)(_ref, $1cf61e15150efda7$var$_excluded);
        // Hex logo is now always used (platform-logo-rebrand-rovo-hex fully launched)
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(RovoHexWrapped, props);
    };
};



/**
 * __Admin icon__
 *
 * The Admin icon without an accompanying wordmark.
 *
 * - [Examples](https://atlassian.design/components/logo/examples)
 * - [Code](https://atlassian.design/components/logo/code)
 * - [Usage](https://atlassian.design/components/logo/usage)
 */ var $2d94d3bb9b62d159$export$ef8e5f836dd989d3 = (0, $1de484d679ff13a5$export$667425256e2e7296)((0, $fdd60fb407482c20$export$ef8e5f836dd989d3));
var $2d94d3bb9b62d159$export$ebcd30672e67406 = (0, $1de484d679ff13a5$export$667425256e2e7296)((0, $82e1f1c7094b4744$export$61afcb38c001e19));
var $2d94d3bb9b62d159$export$af3460f51ce3602a = (0, $1de484d679ff13a5$export$667425256e2e7296)((0, $e1043fa2303698cc$export$af3460f51ce3602a));
var $2d94d3bb9b62d159$export$c8415b6abe4a8587 = (0, $1de484d679ff13a5$export$667425256e2e7296)((0, $0be36fd552dc1c99$export$f0bac2b7ac3e3504));
var $2d94d3bb9b62d159$export$d89497e7f33ca6f5 = (0, $1de484d679ff13a5$export$667425256e2e7296)((0, $07c282adbd4b5243$export$d89497e7f33ca6f5));
var $2d94d3bb9b62d159$export$48ca930f3071e3e4 = (0, $1de484d679ff13a5$export$667425256e2e7296)((0, $67e6f3ace9444edb$export$81c47abe19675c4c));
var $2d94d3bb9b62d159$export$52cd484a7ef4f2b9 = (0, $1de484d679ff13a5$export$667425256e2e7296)((0, $ad00fac377c9e40f$export$52cd484a7ef4f2b9));
var $2d94d3bb9b62d159$export$9ca9881809919df8 = (0, $1de484d679ff13a5$export$667425256e2e7296)((0, $d3bc400e03f0c58c$export$a529e78951cd6709));
var $2d94d3bb9b62d159$export$6da5aa77c402ba0f = (0, $1de484d679ff13a5$export$667425256e2e7296)((0, $c1154bc2e76da5bc$export$6da5aa77c402ba0f));
var $2d94d3bb9b62d159$export$abc95e6180bb1d88 = (0, $1de484d679ff13a5$export$667425256e2e7296)((0, $08a10d77ef70bbc8$export$f597f0f7fadce0b9));
var $2d94d3bb9b62d159$export$34420f0520b19b1d = (0, $1de484d679ff13a5$export$667425256e2e7296)((0, $7a1b18946ccbad19$export$34420f0520b19b1d));
var $2d94d3bb9b62d159$export$c9696eb3c34c5a96 = (0, $1de484d679ff13a5$export$667425256e2e7296)((0, $c1e8533d1c9e7c7d$export$bbccafb125ebd50c));
var $2d94d3bb9b62d159$export$9eb74917ea768ed4 = (0, $1de484d679ff13a5$export$667425256e2e7296)((0, $a91c75e095c80598$export$9eb74917ea768ed4));
var $2d94d3bb9b62d159$export$d2577aa28451395f = (0, $1de484d679ff13a5$export$667425256e2e7296)((0, $7d59ddb7b829c48b$export$c527a545aa426db3));
var $2d94d3bb9b62d159$export$92c8767b874048d = (0, $1de484d679ff13a5$export$667425256e2e7296)((0, $dfcee9eb5660984d$export$92c8767b874048d));
var $2d94d3bb9b62d159$export$d5648119d5b68e90 = (0, $1de484d679ff13a5$export$667425256e2e7296)((0, $6d94cf131d4d8744$export$8b6b7f1b1b2367d3));
var $2d94d3bb9b62d159$export$80b8b269d8b5014e = (0, $1de484d679ff13a5$export$667425256e2e7296)((0, $21530e0c9bf76790$export$80b8b269d8b5014e));
var $2d94d3bb9b62d159$export$fc9bd6687b80fe3b = (0, $1de484d679ff13a5$export$667425256e2e7296)((0, $25e04bc358978974$export$7a38180641471460));
var $2d94d3bb9b62d159$export$5ed3e1bb3b04fc02 = (0, $1de484d679ff13a5$export$667425256e2e7296)((0, $41cbf4a689ed8f4f$export$5ed3e1bb3b04fc02));
var $2d94d3bb9b62d159$export$aeefab651bcf2338 = (0, $1de484d679ff13a5$export$667425256e2e7296)((0, $5f3418d4a157010d$export$e3d1678155aaab99));
var $2d94d3bb9b62d159$export$8b784b3227531b3e = (0, $1de484d679ff13a5$export$667425256e2e7296)((0, $197063d63daf10dc$export$8b784b3227531b3e));
var $2d94d3bb9b62d159$export$f0750468d67c6902 = (0, $1de484d679ff13a5$export$667425256e2e7296)((0, $52144500e207f1b9$export$4145bd793c9ed1d0));
var $2d94d3bb9b62d159$export$813cff80931d9dbf = (0, $1de484d679ff13a5$export$667425256e2e7296)((0, $4f24c8abb3bfcd10$export$813cff80931d9dbf));
var $2d94d3bb9b62d159$export$409b7a5b7f180eba = (0, $1de484d679ff13a5$export$667425256e2e7296)((0, $f7ab768ff134333e$export$58747af448450872));
var $2d94d3bb9b62d159$export$b12fec207e8537a8 = (0, $1de484d679ff13a5$export$667425256e2e7296)((0, $0016866d85e6e365$export$b12fec207e8537a8));
var $2d94d3bb9b62d159$export$82eafebb825fc23f = (0, $1de484d679ff13a5$export$667425256e2e7296)((0, $0f8b4aaeed3bfd5f$export$82eafebb825fc23f));
var $2d94d3bb9b62d159$export$e4c5487c9a8ae3b1 = (0, $1de484d679ff13a5$export$667425256e2e7296)((0, $b4bd8937bad3fd8c$export$fa08cbfe393f2a68));
var $2d94d3bb9b62d159$export$290a0f24614cde9f = (0, $1de484d679ff13a5$export$667425256e2e7296)((0, $d4a2fbda144b1191$export$290a0f24614cde9f));
var $2d94d3bb9b62d159$export$8aceb78c659789b6 = (0, $1de484d679ff13a5$export$667425256e2e7296)((0, $c66fc654b038e593$export$273fd56580e523ae));
var $2d94d3bb9b62d159$export$4b05688514531169 = (0, $1de484d679ff13a5$export$667425256e2e7296)((0, $7f7edb4e357e2b13$export$4b05688514531169));
var $2d94d3bb9b62d159$export$4f6453e012279f89 = (0, $1de484d679ff13a5$export$667425256e2e7296)((0, $1f1b8db51b42626f$export$1b3979d995ebbc6e));
var $2d94d3bb9b62d159$export$1bcbc9c337da86da = (0, $1de484d679ff13a5$export$667425256e2e7296)((0, $a04a36d44116debe$export$1bcbc9c337da86da));
var $2d94d3bb9b62d159$export$9b1a0a0c574cec2a = (0, $1de484d679ff13a5$export$667425256e2e7296)((0, $a982aa43c10022ed$export$bfd8d1c4da84ce71));
var $2d94d3bb9b62d159$export$e812398311cab9a3 = (0, $1de484d679ff13a5$export$667425256e2e7296)((0, $29a53ab50e0d6e2c$export$e812398311cab9a3));
var $2d94d3bb9b62d159$export$765f5afcc1a5a7e3 = (0, $1de484d679ff13a5$export$667425256e2e7296)((0, $eb65bc71ea217c46$export$7c51958462d750e));
var $2d94d3bb9b62d159$export$d3ab16bbf4f954ee = (0, $1de484d679ff13a5$export$667425256e2e7296)((0, $7d99f03edbd4b9cf$export$d3ab16bbf4f954ee));
var $2d94d3bb9b62d159$export$36044946916e84a0 = (0, $1de484d679ff13a5$export$667425256e2e7296)((0, $9517141151b4abf9$export$cc55e2a4c4b40552));
var $2d94d3bb9b62d159$export$53305f1f2855d3be = (0, $1de484d679ff13a5$export$667425256e2e7296)((0, $1261df2be6b304e0$export$53305f1f2855d3be));
var $2d94d3bb9b62d159$export$5e06396bce773a3 = (0, $1de484d679ff13a5$export$667425256e2e7296)((0, $16ff1b53fcc3594d$export$b3e508cb103e1f93));
var $2d94d3bb9b62d159$export$eaf73f391f7103bd = (0, $1de484d679ff13a5$export$667425256e2e7296)((0, $9f0bbf9ab4b2a1c5$export$eaf73f391f7103bd));
var $2d94d3bb9b62d159$export$6128b385660fd3c6 = (0, $1de484d679ff13a5$export$667425256e2e7296)((0, $74bdda6b0a46426e$export$3c371bdbcdfcdce));
var $2d94d3bb9b62d159$export$f8455b5667a3ee0c = (0, $1de484d679ff13a5$export$667425256e2e7296)((0, $63d5863d2ed13516$export$f8455b5667a3ee0c));
var $2d94d3bb9b62d159$export$eb152ab3801b2ae3 = (0, $1de484d679ff13a5$export$667425256e2e7296)((0, $ba7c91ea510df47c$export$3224b07bc93ef23e));
var $2d94d3bb9b62d159$export$65fae0eaf343f2ca = (0, $1de484d679ff13a5$export$667425256e2e7296)((0, $7a89adb1474ccf1d$export$65fae0eaf343f2ca));
var $2d94d3bb9b62d159$export$fffc0d480fb1ebf1 = (0, $1de484d679ff13a5$export$667425256e2e7296)((0, $3e1ff0d7c502f7bb$export$f64bc7a7f04428d0));
var $2d94d3bb9b62d159$export$74517ed253186308 = (0, $7752965ed79b5f2a$export$e30d2ddc605f6bb)((0, $97a4280f75f7a22e$export$74517ed253186308), (0, $fdd60fb407482c20$export$ef8e5f836dd989d3));
var $2d94d3bb9b62d159$export$833abe6c2ce5ebfd = (0, $7752965ed79b5f2a$export$e30d2ddc605f6bb)((0, $412bfa0d5894b3c6$export$833abe6c2ce5ebfd), (0, $82e1f1c7094b4744$export$61afcb38c001e19));
var $2d94d3bb9b62d159$export$84109e099492cb5f = (0, $7752965ed79b5f2a$export$e30d2ddc605f6bb)((0, $1c67e9a6f1bb1a6f$export$84109e099492cb5f), (0, $fdd60fb407482c20$export$ef8e5f836dd989d3));
var $2d94d3bb9b62d159$export$f845d9b9254f0541 = (0, $7752965ed79b5f2a$export$e30d2ddc605f6bb)((0, $02204c990345b447$export$f845d9b9254f0541), (0, $82e1f1c7094b4744$export$61afcb38c001e19));
var $2d94d3bb9b62d159$export$c42ad8a0b925c762 = (0, $7752965ed79b5f2a$export$e30d2ddc605f6bb)((0, $34224b7af8484c42$export$c42ad8a0b925c762), (0, $e1043fa2303698cc$export$af3460f51ce3602a));
var $2d94d3bb9b62d159$export$e6470bfc39010cc4 = (0, $7752965ed79b5f2a$export$e30d2ddc605f6bb)((0, $7a3a6eb3b1e795cf$export$e6470bfc39010cc4), (0, $0be36fd552dc1c99$export$f0bac2b7ac3e3504));
var $2d94d3bb9b62d159$export$5fc1066e677788d4 = (0, $7752965ed79b5f2a$export$e30d2ddc605f6bb)((0, $4dbba68b0e2d177f$export$5fc1066e677788d4), (0, $53bbed640c6e6632$export$5fc1066e677788d4));
var $2d94d3bb9b62d159$export$bd40525f5333524b = (0, $7752965ed79b5f2a$export$e30d2ddc605f6bb)((0, $d9b1388a5ad29f00$export$bd40525f5333524b), (0, $20e6a750a55a1c4a$export$f7ef5e5488e4b430));
var $2d94d3bb9b62d159$export$f7857fe64d7161d9 = (0, $7752965ed79b5f2a$export$e30d2ddc605f6bb)((0, $82ec3faa3f0368a6$export$f7857fe64d7161d9), (0, $4baee89efb80cd04$export$f7857fe64d7161d9));
var $2d94d3bb9b62d159$export$eb7d748e4f9c9676 = (0, $7752965ed79b5f2a$export$e30d2ddc605f6bb)((0, $ec654b9e2387dfd0$export$eb7d748e4f9c9676), (0, $6cbfa5dee2ec240d$export$a16f50a81d183ce));
var $2d94d3bb9b62d159$export$9951d02c2d848122 = (0, $1de484d679ff13a5$export$667425256e2e7296)((0, $645e97300d058240$export$9951d02c2d848122));
var $2d94d3bb9b62d159$export$68f3db7f6af48bcb = (0, $7752965ed79b5f2a$export$e30d2ddc605f6bb)((0, $167d8239415b0009$export$68f3db7f6af48bcb), (0, $bf2cc7f049a6186c$export$68f3db7f6af48bcb));
var $2d94d3bb9b62d159$export$1b2e4fe6ef471556 = (0, $7752965ed79b5f2a$export$e30d2ddc605f6bb)((0, $939c0243cabcce21$export$1b2e4fe6ef471556), (0, $e6985fb29d7e75d7$export$a88b0b0da9ef63ce));
var $2d94d3bb9b62d159$export$70a0c2f5862937b6 = (0, $1de484d679ff13a5$export$667425256e2e7296)((0, $d7c936ff53cc5c33$export$70a0c2f5862937b6));
var $2d94d3bb9b62d159$export$1b8596b4b0ef673b = (0, $1de484d679ff13a5$export$667425256e2e7296)((0, $e8c987d7492ee286$export$8b5103382c06639c));
var $2d94d3bb9b62d159$export$407687b2dd89cc68 = (0, $7752965ed79b5f2a$export$e30d2ddc605f6bb)((0, $a086e675d50d99f5$export$407687b2dd89cc68), (0, $d7c936ff53cc5c33$export$70a0c2f5862937b6));
var $2d94d3bb9b62d159$export$ee11e928d3d045fd = (0, $7752965ed79b5f2a$export$e30d2ddc605f6bb)((0, $0384e43546c82587$export$ee11e928d3d045fd), (0, $e8c987d7492ee286$export$8b5103382c06639c));
var $2d94d3bb9b62d159$export$c4b5b1f965d8b3eb = (0, $7752965ed79b5f2a$export$e30d2ddc605f6bb)((0, $0b480349a5d37260$export$c4b5b1f965d8b3eb), (0, $7c1c11195d413b75$export$c4b5b1f965d8b3eb));
var $2d94d3bb9b62d159$export$17d3acb0b4379d02 = (0, $7752965ed79b5f2a$export$e30d2ddc605f6bb)((0, $5f3c0cc4476ee39f$export$17d3acb0b4379d02), (0, $6e34b13172a5b29b$export$bf4c5f97b468e8d6));
var $2d94d3bb9b62d159$export$21bfbeb62fdcce8d = (0, $7752965ed79b5f2a$export$e30d2ddc605f6bb)((0, $539f53a33632dfac$export$21bfbeb62fdcce8d), (0, $2d211468a13d2fb7$export$21bfbeb62fdcce8d));
var $2d94d3bb9b62d159$export$c49a2b642fe9eef4 = (0, $7752965ed79b5f2a$export$e30d2ddc605f6bb)((0, $3a5dc488d65304f9$export$c49a2b642fe9eef4), (0, $d84bc94694df07a6$export$602140a6a10b02bf));
var $2d94d3bb9b62d159$export$3c6158790f5e01c4 = (0, $8d9471b61f79a2a7$export$436fcf6e31fbacea)((0, $ab3633d671879ebc$export$3c6158790f5e01c4), (0, $e2db2120f58c7778$export$3c6158790f5e01c4));
var $2d94d3bb9b62d159$export$dabef2be6cd28c20 = (0, $8d9471b61f79a2a7$export$436fcf6e31fbacea)((0, $44f664ec6684700a$export$dabef2be6cd28c20), (0, $105e244f4782482d$export$de148263c75d2bc1));
var $2d94d3bb9b62d159$export$8d789f76fde3e05 = (0, $7752965ed79b5f2a$export$e30d2ddc605f6bb)((0, $d3bf053d58aecb39$export$8d789f76fde3e05), (0, $7277bf1ab856c9fb$export$8d789f76fde3e05));
var $2d94d3bb9b62d159$export$94e206806e36c2ec = (0, $7752965ed79b5f2a$export$e30d2ddc605f6bb)((0, $df29a5258322e53f$export$94e206806e36c2ec), (0, $a9d66750d87e778d$export$78c0b4d8be34c9b2));
var $2d94d3bb9b62d159$export$1bf47cdade1a9fcb = (0, $7752965ed79b5f2a$export$e30d2ddc605f6bb)((0, $24fc4a6d140006a0$export$1bf47cdade1a9fcb), (0, $7277bf1ab856c9fb$export$8d789f76fde3e05));
var $2d94d3bb9b62d159$export$6e87ce8d41eda665 = (0, $7752965ed79b5f2a$export$e30d2ddc605f6bb)((0, $550dd97c2a7853ef$export$6e87ce8d41eda665), (0, $dbb0fc9f5c20d708$export$68d7391318cdef11));
var $2d94d3bb9b62d159$export$e84e925618e0e5bc = (0, $1de484d679ff13a5$export$667425256e2e7296)((0, $fc01f80024a1e9f7$export$71743a944cb62e48));
var $2d94d3bb9b62d159$export$1940ba72c868b663 = (0, $1de484d679ff13a5$export$667425256e2e7296)((0, $da79d6616879e497$export$38c7b37a3e5e8d70));
var $2d94d3bb9b62d159$export$eeccc49dc7a12d9f = (0, $8d9471b61f79a2a7$export$436fcf6e31fbacea)((0, $133343937fec1563$export$eeccc49dc7a12d9f), (0, $6f107b5a3cdc7c24$export$eeccc49dc7a12d9f));
var $2d94d3bb9b62d159$export$a1c6484cdecc2c4b = (0, $8d9471b61f79a2a7$export$436fcf6e31fbacea)((0, $7012d37ccd20defe$export$a1c6484cdecc2c4b), (0, $208acfc57f03835f$export$a5b9122e89b32ad3));
var $2d94d3bb9b62d159$export$f3f5aa321d88adf9 = (0, $8d9471b61f79a2a7$export$436fcf6e31fbacea)((0, $e5090466625d94f8$export$f3f5aa321d88adf9), (0, $29dc00d3e852c298$export$f3f5aa321d88adf9));
var $2d94d3bb9b62d159$export$bb4ae5b41b43be04 = (0, $8d9471b61f79a2a7$export$436fcf6e31fbacea)((0, $a0b9b85073824ba8$export$bb4ae5b41b43be04), (0, $498a5dc059f68f6e$export$2bc88a281410ffa7));
var $2d94d3bb9b62d159$export$4384da9b8b140bf4 = (0, $7752965ed79b5f2a$export$e30d2ddc605f6bb)((0, $72b24621895b039d$export$4384da9b8b140bf4), (0, $846cd6bc1530edeb$export$4384da9b8b140bf4));
var $2d94d3bb9b62d159$export$60e26212f3b61a28 = (0, $7752965ed79b5f2a$export$e30d2ddc605f6bb)((0, $77f83b2a64e78b50$export$60e26212f3b61a28), (0, $d346c3580de5e974$export$1b13139dfc0336af));
var $2d94d3bb9b62d159$export$e23ae35269442b4f = (0, $1cf61e15150efda7$export$2469203854060337)((0, $96f99918f881107b$export$e23ae35269442b4f), (0, $c0e81f450057cf06$export$e23ae35269442b4f), (0, $43ecd9ad182aa785$export$9e62346a60cfb459));
var $2d94d3bb9b62d159$export$a0f6cb8061290bbb = (0, $1cf61e15150efda7$export$2469203854060337)((0, $93173c7c8bd4c45d$export$a0f6cb8061290bbb), (0, $bd5d466aedec2939$export$b0e15f0a1c9f4c55), (0, $57fe7bba8f3a8d6a$export$5e38d02efdb45577));
var $2d94d3bb9b62d159$export$3f95fcfdc25a741d = (0, $7752965ed79b5f2a$export$e30d2ddc605f6bb)((0, $f9d366510db8d846$export$3f95fcfdc25a741d), (0, $3fde30457b2fb8db$export$3f95fcfdc25a741d));
var $2d94d3bb9b62d159$export$a4a891d202775deb = (0, $7752965ed79b5f2a$export$e30d2ddc605f6bb)((0, $4aaa416bcb06d11e$export$a4a891d202775deb), (0, $5e873dad6b32a772$export$2b896c4d595a4331));
var $2d94d3bb9b62d159$export$1e02e7298035a77c = (0, $7752965ed79b5f2a$export$e30d2ddc605f6bb)((0, $3e24df8349650905$export$1e02e7298035a77c), (0, $0c16e5609534a2b0$export$1e02e7298035a77c));
var $2d94d3bb9b62d159$export$33908560ea1b226d = (0, $7752965ed79b5f2a$export$e30d2ddc605f6bb)((0, $c938f2c9202f2b9d$export$33908560ea1b226d), (0, $4de141105e2ca493$export$3a6e8b37e069a69d));
var $2d94d3bb9b62d159$export$5ef3f25e16249826 = (0, $1de484d679ff13a5$export$667425256e2e7296)((0, $7d2e0cc3e3a950d6$export$5ef3f25e16249826));
var $2d94d3bb9b62d159$export$1ab0976b9ea166ae = (0, $1de484d679ff13a5$export$667425256e2e7296)((0, $1408f1e2ddb10b25$export$1ab0976b9ea166ae));
var $2d94d3bb9b62d159$export$5efe8561ca252843 = (0, $1de484d679ff13a5$export$667425256e2e7296)((0, $f5be1548d97162b0$export$5efe8561ca252843));
var $2d94d3bb9b62d159$export$e26e48d31d71c1e1 = (0, $1de484d679ff13a5$export$667425256e2e7296)((0, $89e8a96e1e6f33d4$export$e26e48d31d71c1e1));
var $2d94d3bb9b62d159$export$bf5ca9fb70f56bb5 = (0, $1de484d679ff13a5$export$667425256e2e7296)((0, $f5375db4b0eca8fb$export$bf5ca9fb70f56bb5));
var $2d94d3bb9b62d159$export$518f48548316ec87 = (0, $1de484d679ff13a5$export$667425256e2e7296)((0, $ddf42b4cd5986168$export$518f48548316ec87));


const $321f9d9910fd85d1$var$BlueTrelloLogo = ()=>{
    return /*#__PURE__*/ (0, $i3UfC.jsx)((0, $2d94d3bb9b62d159$export$60e26212f3b61a28), {
        appearance: "brand"
    });
};
const $321f9d9910fd85d1$var$TrelloLogoComponent = ()=>{
    return /*#__PURE__*/ (0, $i3UfC.jsx)((0, $4c4e598cd6612632$export$2e2bcd8739ae039), {
        icon: $321f9d9910fd85d1$var$BlueTrelloLogo,
        logo: $321f9d9910fd85d1$var$BlueTrelloLogo
    });
};
var $321f9d9910fd85d1$export$2e2bcd8739ae039 = $321f9d9910fd85d1$var$TrelloLogoComponent;



var $f5RPY = parcelRequire("f5RPY");

var $6hgMx = parcelRequire("6hgMx");
const $679012da31643a57$var$NavContents = ()=>{
    const { serviceType: serviceType } = (0, $6hgMx.useToken)();
    return /*#__PURE__*/ (0, $i3UfC.jsx)((0, $fade497bfa6efef0$export$f66ccb39f60980e5), {
        label: "site",
        primaryItems: [],
        renderSignIn: $679012da31643a57$var$Profile,
        renderProductHome: serviceType == 'Trello' ? (0, $321f9d9910fd85d1$export$2e2bcd8739ae039) : (0, $9f1ff57ff81007c4$export$2e2bcd8739ae039)
    });
};
const $679012da31643a57$var$Profile = ()=>{
    const user = (0, $f5RPY.useUser)();
    const switchAccountLink = (0, $f5RPY.useSwitchAccountLink)(false);
    return /*#__PURE__*/ (0, $i3UfC.jsx)((0, $683e310356522ed0$export$75dc45130eee4ebb), {
        testId: "account-menu",
        name: user?.name,
        picture: user?.picture,
        email: user?.email,
        identityEnvironment: $679012da31643a57$var$determineIdentityEnvironment(),
        application: "atlassian-consent-screen",
        continueUrl: switchAccountLink,
        isLoggedOut: !user,
        currentTheme: 'auto'
    });
};
function $679012da31643a57$var$determineIdentityEnvironment() {
    return 'prod';
}
var $679012da31643a57$export$2e2bcd8739ae039 = $679012da31643a57$var$NavContents;


const $105a7c2c89bf6f3c$var$Navigation = ()=>{
    return /*#__PURE__*/ (0, $i3UfC.jsx)((0, $1a90644fef3a8d91$export$2e2bcd8739ae039), {
        children: /*#__PURE__*/ (0, $i3UfC.jsx)((0, $679012da31643a57$export$2e2bcd8739ae039), {})
    });
};
var $105a7c2c89bf6f3c$export$2e2bcd8739ae039 = $105a7c2c89bf6f3c$var$Navigation;



var $6hgMx = parcelRequire("6hgMx");

var $i3UfC = parcelRequire("i3UfC");

var $5FkrB = parcelRequire("5FkrB");



var $5FkrB = parcelRequire("5FkrB");

var $2nBsU = parcelRequire("2nBsU");

// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $caG2g = parcelRequire("caG2g");

var $5olgL = parcelRequire("5olgL");

var $2nBsU = parcelRequire("2nBsU");
var $998f42a130fbeae1$export$ca0f9c2de39ffed7 = function getSerializedStylesMap(cssProperty, tokenMap) {
    return Object.keys(tokenMap).reduce(function(emotionSpacingMap, tokenName) {
        // eslint-disable-next-line @repo/internal/styles/no-exported-styles
        emotionSpacingMap[tokenName] = (0, $2nBsU.css)((0, $5olgL.default)({}, cssProperty, tokenMap[tokenName]));
        return emotionSpacingMap;
    }, {});
};


var $67ab31073ee582e2$export$e7af83bafe7f9e63 = (0, $998f42a130fbeae1$export$ca0f9c2de39ffed7)('backgroundColor', (0, $caG2g.backgroundColorMap));


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::ccc2f8099477ab616059b3ca3af61579>>
 * @codegenCommand yarn workspace @atlaskit/primitives codegen-styles
 * @codegenDependency ../../../tokens/src/artifacts/tokens-raw/atlassian-light.tsx <<SignedSource::4e25079e2363933fae45ad0f1e9c123b>>
 */ var $897e81d2d87bc94a$export$41a358c9c2356760 = {
    'elevation.surface': "var(--ds-surface, #FFFFFF)",
    'elevation.surface.hovered': "var(--ds-surface-hovered, #F0F1F2)",
    'elevation.surface.pressed': "var(--ds-surface-pressed, #DDDEE1)",
    'elevation.surface.container': "var(--ds-surface-container, #17171708)",
    'elevation.surface.container.hovered': "var(--ds-surface-container-hovered, #0515240F)",
    'elevation.surface.container.pressed': "var(--ds-surface-container-pressed, #0B120E24)",
    'elevation.surface.overlay': "var(--ds-surface-overlay, #FFFFFF)",
    'elevation.surface.overlay.hovered': "var(--ds-surface-overlay-hovered, #F0F1F2)",
    'elevation.surface.overlay.pressed': "var(--ds-surface-overlay-pressed, #DDDEE1)",
    'elevation.surface.raised': "var(--ds-surface-raised, #FFFFFF)",
    'elevation.surface.raised.hovered': "var(--ds-surface-raised-hovered, #F0F1F2)",
    'elevation.surface.raised.pressed': "var(--ds-surface-raised-pressed, #DDDEE1)",
    'elevation.surface.sunken': "var(--ds-surface-sunken, #F8F8F8)"
};


var $b2a4f70032c022c9$export$5e65a44e5b6ecadb = function isSurfaceColorToken(color) {
    return (0, $897e81d2d87bc94a$export$41a358c9c2356760)[color] !== undefined;
};


// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $e2d67e15cd1ab1f5$var$spacingProperties = [
    'padding',
    'paddingBlock',
    'paddingBlockStart',
    'paddingBlockEnd',
    'paddingInline',
    'paddingInlineStart',
    'paddingInlineEnd',
    'gap',
    'rowGap',
    'columnGap'
];
var $e2d67e15cd1ab1f5$export$f2bee1f59203ac70 = function createSpacingStylesMap(tokenMap) {
    return $e2d67e15cd1ab1f5$var$spacingProperties.reduce(function(styleMap, spacingProperty) {
        styleMap[spacingProperty] = (0, $998f42a130fbeae1$export$ca0f9c2de39ffed7)(spacingProperty, tokenMap);
        return styleMap;
    }, {});
};



var $aWY4P = parcelRequire("aWY4P");
var $57d9f58cb1b2d3e5$export$e615f061ca585a6c = (0, $e2d67e15cd1ab1f5$export$f2bee1f59203ac70)((0, $aWY4P.positiveSpaceMap));



var $62sEv = parcelRequire("62sEv");
function $e9c1493ced6df5be$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return (0, $62sEv.default)(r);
}


function $5e377b7cd8d8855c$export$2e2bcd8739ae039(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}



var $8UkUQ = parcelRequire("8UkUQ");
function $9dadc70f7fe60d00$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}


function $05828ba174ac1fc0$export$2e2bcd8739ae039(r) {
    return (0, $e9c1493ced6df5be$export$2e2bcd8739ae039)(r) || (0, $5e377b7cd8d8855c$export$2e2bcd8739ae039)(r) || (0, $8UkUQ.default)(r) || (0, $9dadc70f7fe60d00$export$2e2bcd8739ae039)();
}



var $3PTbW = parcelRequire("3PTbW");
function $516eb2651ecf48d7$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $516eb2651ecf48d7$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $516eb2651ecf48d7$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $516eb2651ecf48d7$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $516eb2651ecf48d7$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $516eb2651ecf48d7$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
/**
 * Picks out runtime XCSS objects and build-time XCSS strings. This is needed
 * to supported both Emotion and Compiled styles until we've fully migrated
 * to Compiled.
 *
 * @private
 * @deprecated
 */ // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
var $516eb2651ecf48d7$export$a9c84988c8f81f2d = function parseXcss(args) {
    if (Array.isArray(args)) {
        var emotion = [];
        var staticArr = [];
        var _iterator = $516eb2651ecf48d7$var$_createForOfIteratorHelper(args), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var arg = _step.value;
                var result = $516eb2651ecf48d7$export$a9c84988c8f81f2d(arg);
                if (result.emotion) emotion.push.apply(emotion, (0, $05828ba174ac1fc0$export$2e2bcd8739ae039)(result.emotion));
                if (result.static) staticArr.push(result.static);
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
        return {
            emotion: emotion,
            static: staticArr.join(' ')
        };
    }
    var objArgs = args;
    var _ref = objArgs || {}, styles = _ref[0, $3PTbW.uniqueSymbol];
    if (styles) return {
        emotion: [
            styles
        ]
    };
    if (args) {
        // We use string interpolation here instead of .toString() just
        // in case the resulting object doesn't have the method available.
        var stringifiedArgs = "".concat(args);
        if (stringifiedArgs) return {
            static: stringifiedArgs
        };
    }
    return {};
};


// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled
var $ababf935c1880206$export$4ef52930e33717cd = 'data-theme';
var $ababf935c1880206$export$cb374d25ded7f6ab = 'data-subtree-theme';
var $ababf935c1880206$export$a00eac3f8684bcd0 = 'data-color-mode';
var $ababf935c1880206$export$2112803007239c61 = 'data-contrast-mode';
var $ababf935c1880206$export$352e418ed5b6193a = 'data-custom-theme';
var $ababf935c1880206$export$6f0c6fb8c80fcc92 = 'ds';
var $ababf935c1880206$export$4d0c7bbf80185957 = [
    'opacity',
    'font',
    'space',
    'border',
    'radius'
];
var $ababf935c1880206$export$dddac1532e822863 = "--".concat($ababf935c1880206$export$6f0c6fb8c80fcc92, "-token-not-found");
var $ababf935c1880206$export$9d7b58831ae93caa = "--".concat($ababf935c1880206$export$6f0c6fb8c80fcc92, "-elevation-surface-current");




var $4fd4fd23995134cc$export$ff257d957d48c421 = (0, $998f42a130fbeae1$export$ca0f9c2de39ffed7)((0, $ababf935c1880206$export$9d7b58831ae93caa), (0, $897e81d2d87bc94a$export$41a358c9c2356760));


var $383dd904a5a5e5b0$var$_excluded = [
    "as",
    "children",
    "backgroundColor",
    "padding",
    "paddingBlock",
    "paddingBlockStart",
    "paddingBlockEnd",
    "paddingInline",
    "paddingInlineStart",
    "paddingInlineEnd",
    "style",
    "testId",
    "xcss"
], $383dd904a5a5e5b0$var$_excluded2 = [
    "className"
];
var $383dd904a5a5e5b0$export$e71c4d32a2263218 = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? 'div' : _ref$as, children = _ref.children, backgroundColor = _ref.backgroundColor, padding = _ref.padding, paddingBlock = _ref.paddingBlock, paddingBlockStart = _ref.paddingBlockStart, paddingBlockEnd = _ref.paddingBlockEnd, paddingInline = _ref.paddingInline, paddingInlineStart = _ref.paddingInlineStart, paddingInlineEnd = _ref.paddingInlineEnd, style = _ref.style, testId = _ref.testId, xcss = _ref.xcss, htmlAttributes = (0, $a9c67d4ab15fb282$export$2e2bcd8739ae039)(_ref, $383dd904a5a5e5b0$var$_excluded);
    // This is to remove className from safeHtmlAttributes
    // @ts-ignore -- not using expect since it causes issues with help-center local consumption - className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    var _spreadClass = htmlAttributes.className, safeHtmlAttributes = (0, $a9c67d4ab15fb282$export$2e2bcd8739ae039)(htmlAttributes, $383dd904a5a5e5b0$var$_excluded2);
    var resolvedStyles = (0, $516eb2651ecf48d7$export$a9c84988c8f81f2d)(xcss);
    var node = // @ts-expect-error Expression produces a union type that is too complex to represent. I think this is unavoidable
    (0, $2nBsU.jsx)(Component, (0, $a98c0fbb1cee895f$export$2e2bcd8739ae039)({
        style: style,
        ref: ref,
        className: resolvedStyles.static
    }, safeHtmlAttributes, {
        css: [
            $383dd904a5a5e5b0$var$baseStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            backgroundColor && (0, $67ab31073ee582e2$export$e7af83bafe7f9e63)[backgroundColor],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $b2a4f70032c022c9$export$5e65a44e5b6ecadb)(backgroundColor) && (0, $4fd4fd23995134cc$export$ff257d957d48c421)[backgroundColor],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            padding && (0, $57d9f58cb1b2d3e5$export$e615f061ca585a6c).padding[padding],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlock && (0, $57d9f58cb1b2d3e5$export$e615f061ca585a6c).paddingBlock[paddingBlock],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlockStart && (0, $57d9f58cb1b2d3e5$export$e615f061ca585a6c).paddingBlockStart[paddingBlockStart],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlockEnd && (0, $57d9f58cb1b2d3e5$export$e615f061ca585a6c).paddingBlockEnd[paddingBlockEnd],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInline && (0, $57d9f58cb1b2d3e5$export$e615f061ca585a6c).paddingInline[paddingInline],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInlineStart && (0, $57d9f58cb1b2d3e5$export$e615f061ca585a6c).paddingInlineStart[paddingInlineStart],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInlineEnd && (0, $57d9f58cb1b2d3e5$export$e615f061ca585a6c).paddingInlineEnd[paddingInlineEnd],
            resolvedStyles.emotion
        ],
        "data-testid": testId
    }), children);
    return backgroundColor ? (0, $2nBsU.jsx)((0, $80f969ecef0a6dd3$export$1ca2a26fecb070ae).Provider, {
        value: backgroundColor
    }, node) : node;
});
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$383dd904a5a5e5b0$export$2e2bcd8739ae039 = $383dd904a5a5e5b0$export$e71c4d32a2263218;
var $383dd904a5a5e5b0$var$baseStyles = (0, $2nBsU.css)({
    boxSizing: 'border-box',
    appearance: 'none',
    border: 'none'
});



var $i3UfC = parcelRequire("i3UfC");

var $5FkrB = parcelRequire("5FkrB");

var $6bnW7 = parcelRequire("6bnW7");
var $bgNpv = parcelRequire("bgNpv");
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5FkrB = parcelRequire("5FkrB");

var $2nBsU = parcelRequire("2nBsU");
var $aa5238e80877390a$var$buttonGroupStyles = (0, $2nBsU.css)({
    display: 'inline-flex',
    gap: "var(--ds-space-050, 4px)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '> *': {
        flex: '1 0 auto'
    }
});
function $aa5238e80877390a$export$2e2bcd8739ae039(_ref) {
    var children = _ref.children, testId = _ref.testId, label = _ref.label, titleId = _ref.titleId;
    return (0, $2nBsU.jsx)("div", {
        css: $aa5238e80877390a$var$buttonGroupStyles,
        "data-testid": testId,
        role: "group",
        "aria-label": label,
        "aria-labelledby": titleId
    }, (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).Children.map((0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).Children.toArray(children), function(child, idx) {
        if (!child) return null;
        return (0, $2nBsU.jsx)((0, $5FkrB.Fragment), {
            key: idx
        }, child);
    }));
}





var $5FkrB = parcelRequire("5FkrB");

var $2nBsU = parcelRequire("2nBsU");

// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled


var $aWY4P = parcelRequire("aWY4P");
var $4ec38ba4046986ab$export$bf46c3f9eeafc71f = (0, $e2d67e15cd1ab1f5$export$f2bee1f59203ac70)((0, $aWY4P.positiveSpaceMap));


var $1b254ba6a068f2f1$var$justifyContentMap = {
    start: (0, $2nBsU.css)({
        justifyContent: 'start'
    }),
    center: (0, $2nBsU.css)({
        justifyContent: 'center'
    }),
    end: (0, $2nBsU.css)({
        justifyContent: 'end'
    }),
    'space-between': (0, $2nBsU.css)({
        justifyContent: 'space-between'
    }),
    'space-around': (0, $2nBsU.css)({
        justifyContent: 'space-around'
    }),
    'space-evenly': (0, $2nBsU.css)({
        justifyContent: 'space-evenly'
    }),
    stretch: (0, $2nBsU.css)({
        justifyContent: 'stretch'
    })
};
var $1b254ba6a068f2f1$var$flexDirectionMap = {
    column: (0, $2nBsU.css)({
        flexDirection: 'column'
    }),
    row: (0, $2nBsU.css)({
        flexDirection: 'row'
    })
};
var $1b254ba6a068f2f1$var$flexWrapMap = {
    wrap: (0, $2nBsU.css)({
        flexWrap: 'wrap'
    }),
    nowrap: (0, $2nBsU.css)({
        flexWrap: 'nowrap'
    })
};
var $1b254ba6a068f2f1$var$alignItemsMap = {
    start: (0, $2nBsU.css)({
        alignItems: 'start'
    }),
    center: (0, $2nBsU.css)({
        alignItems: 'center'
    }),
    baseline: (0, $2nBsU.css)({
        alignItems: 'baseline'
    }),
    end: (0, $2nBsU.css)({
        alignItems: 'end'
    }),
    stretch: (0, $2nBsU.css)({
        alignItems: 'stretch'
    })
};
var $1b254ba6a068f2f1$var$baseStyles = (0, $2nBsU.css)({
    display: 'flex',
    boxSizing: 'border-box'
});
var $1b254ba6a068f2f1$export$f51f4c4ede09e011 = /*#__PURE__*/ (0, $5FkrB.memo)(/*#__PURE__*/ (0, $5FkrB.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? 'div' : _ref$as, role = _ref.role, alignItems = _ref.alignItems, justifyContent = _ref.justifyContent, gap = _ref.gap, columnGap = _ref.columnGap, rowGap = _ref.rowGap, children = _ref.children, testId = _ref.testId, direction = _ref.direction, wrap = _ref.wrap, xcss = _ref.xcss, id = _ref.id;
    var resolvedStyles = (0, $516eb2651ecf48d7$export$a9c84988c8f81f2d)(xcss);
    return (0, $2nBsU.jsx)(Component, {
        id: id,
        role: role,
        className: resolvedStyles.static,
        css: [
            $1b254ba6a068f2f1$var$baseStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            gap && (0, $4ec38ba4046986ab$export$bf46c3f9eeafc71f).gap[gap],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            columnGap && (0, $4ec38ba4046986ab$export$bf46c3f9eeafc71f).columnGap[columnGap],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            rowGap && (0, $4ec38ba4046986ab$export$bf46c3f9eeafc71f).rowGap[rowGap],
            alignItems && $1b254ba6a068f2f1$var$alignItemsMap[alignItems],
            direction && $1b254ba6a068f2f1$var$flexDirectionMap[direction],
            justifyContent && $1b254ba6a068f2f1$var$justifyContentMap[justifyContent],
            wrap && $1b254ba6a068f2f1$var$flexWrapMap[wrap]
        ].concat((0, $05828ba174ac1fc0$export$2e2bcd8739ae039)(resolvedStyles.emotion || [])),
        "data-testid": testId,
        ref: ref
    }, children);
}));
$1b254ba6a068f2f1$export$f51f4c4ede09e011.displayName = 'Flex';
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$1b254ba6a068f2f1$export$2e2bcd8739ae039 = $1b254ba6a068f2f1$export$f51f4c4ede09e011;


var $gDiFE = parcelRequire("gDiFE");

var $guDjK = parcelRequire("guDjK");
const $effc8a355c6ced2f$var$messages = (0, $6bnW7.defineMessages)({
    accept: {
        id: 'footer.accept',
        defaultMessage: 'Accept',
        description: 'Button to consent for this app to have the listed permissions'
    },
    cancel: {
        id: 'footer.cancel',
        defaultMessage: 'Cancel',
        description: 'Button to cancel the consent for this app to have the listed permissions'
    }
});
const $effc8a355c6ced2f$var$footerStyle = (0, $gDiFE.xcss)({
    marginTop: 'space.400',
    marginBottom: 'space.400',
    justifyContent: 'end'
});
/** Variant without block margins, for embedding inside a sticky action bar. */ const $effc8a355c6ced2f$var$embeddedFooterStyle = (0, $gDiFE.xcss)({
    justifyContent: 'end'
});
const $effc8a355c6ced2f$export$a06f1c675e846f6f = ({ acceptDisabled: acceptDisabled = false, embedded: embedded = false, reverseOrder: reverseOrder = false })=>{
    const analytics = (0, $guDjK.useAnalytics)();
    const [clickedButton, setClickedButton] = (0, $5FkrB.useState)(null);
    const wrapperRef = (0, $5FkrB.useRef)(null);
    (0, $5FkrB.useEffect)(()=>{
        const form = wrapperRef.current?.closest('form');
        if (!form) return;
        const handleSubmit = (e)=>{
            if (e.defaultPrevented) // Validation blocked the submit — re-enable buttons after the click handler's
            // own setTimeout has fired (which disables them).
            setTimeout(()=>setClickedButton(null), 0);
        };
        form.addEventListener('submit', handleSubmit);
        return ()=>form.removeEventListener('submit', handleSubmit);
    }, []);
    const fireAnalyticEvent = (0, $5FkrB.useCallback)((buttonName, buttonValue)=>()=>{
            analytics.sendButtonClickEvent(buttonName);
            setTimeout(()=>setClickedButton(buttonValue), 0);
        }, [
        analytics
    ]);
    const acceptButton = /*#__PURE__*/ (0, $i3UfC.jsx)((0, $a21e01c03a9c4d94$export$2e2bcd8739ae039), {
        type: "submit",
        appearance: "primary",
        name: "decision",
        value: "accept",
        onClick: fireAnalyticEvent('acceptConsent', 'accept'),
        // isLoading={clickedButton === 'accept'} // TODO: spinner doesn't render correctly
        isDisabled: acceptDisabled || clickedButton !== null,
        children: /*#__PURE__*/ (0, $i3UfC.jsx)((0, $bgNpv.default), {
            ...$effc8a355c6ced2f$var$messages.accept
        })
    });
    const cancelButton = /*#__PURE__*/ (0, $i3UfC.jsx)((0, $a21e01c03a9c4d94$export$2e2bcd8739ae039), {
        type: "submit",
        name: "decision",
        value: "cancel",
        onClick: fireAnalyticEvent('cancelConsent', 'cancel'),
        // isLoading={clickedButton === 'cancel'} // TODO: spinner doesn't render correctly
        isDisabled: clickedButton !== null,
        children: /*#__PURE__*/ (0, $i3UfC.jsx)((0, $bgNpv.default), {
            ...$effc8a355c6ced2f$var$messages.cancel
        })
    });
    return /*#__PURE__*/ (0, $i3UfC.jsx)((0, $1b254ba6a068f2f1$export$f51f4c4ede09e011), {
        xcss: embedded ? $effc8a355c6ced2f$var$embeddedFooterStyle : $effc8a355c6ced2f$var$footerStyle,
        children: /*#__PURE__*/ (0, $i3UfC.jsx)((0, $aa5238e80877390a$export$2e2bcd8739ae039), {
            children: reverseOrder ? /*#__PURE__*/ (0, $i3UfC.jsxs)((0, $i3UfC.Fragment), {
                children: [
                    cancelButton,
                    acceptButton
                ]
            }) : /*#__PURE__*/ (0, $i3UfC.jsxs)((0, $i3UfC.Fragment), {
                children: [
                    acceptButton,
                    cancelButton
                ]
            })
        })
    });
};
var $effc8a355c6ced2f$export$2e2bcd8739ae039 = $effc8a355c6ced2f$export$a06f1c675e846f6f;



var $i3UfC = parcelRequire("i3UfC");

var $i3UfC = parcelRequire("i3UfC");


var $i3UfC = parcelRequire("i3UfC");
/* eslint-disable @repo/internal/react/require-jsdoc */ var $1b26d05f4a4d038a$export$2e2bcd8739ae039 = function(channel) {
    return function(payload) {
        return function(createAnalyticsEvent) {
            var consumerEvent = createAnalyticsEvent(payload);
            var clonedEvent = consumerEvent.clone();
            if (clonedEvent) clonedEvent.fire(channel);
            return consumerEvent;
        };
    };
};

function $63a3d0c6fb21a3ce$export$2e2bcd8739ae039() {
    return $63a3d0c6fb21a3ce$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $63a3d0c6fb21a3ce$export$2e2bcd8739ae039.apply(null, arguments);
}


function $adec1f6aecb10080$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $adec1f6aecb10080$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $adec1f6aecb10080$export$2e2bcd8739ae039(o);
}



function $41515d2328130136$export$2e2bcd8739ae039(t, r) {
    if ("object" != (0, $adec1f6aecb10080$export$2e2bcd8739ae039)(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (0, $adec1f6aecb10080$export$2e2bcd8739ae039)(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}


function $c78289b32262e909$export$2e2bcd8739ae039(t) {
    var i = (0, $41515d2328130136$export$2e2bcd8739ae039)(t, "string");
    return "symbol" == (0, $adec1f6aecb10080$export$2e2bcd8739ae039)(i) ? i : i + "";
}


function $b610cb1610902400$export$2e2bcd8739ae039(e, r, t) {
    return (r = (0, $c78289b32262e909$export$2e2bcd8739ae039)(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}


function $37a77da0019496b8$export$2e2bcd8739ae039(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}


function $f9613085755b341d$export$2e2bcd8739ae039(e, t) {
    if (null == e) return {};
    var o, r, i = (0, $37a77da0019496b8$export$2e2bcd8739ae039)(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}



var $5FkrB = parcelRequire("5FkrB");
function $6e67d1065682db57$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return r;
}


function $b73db435cf4fc0e6$export$2e2bcd8739ae039(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}


function $b69e46acab609c44$export$2e2bcd8739ae039(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}


function $27da1a02ed7b7cbe$export$2e2bcd8739ae039(r, a) {
    if (r) {
        if ("string" == typeof r) return (0, $b69e46acab609c44$export$2e2bcd8739ae039)(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? (0, $b69e46acab609c44$export$2e2bcd8739ae039)(r, a) : void 0;
    }
}


function $78f48d684503c5e8$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}


function $4f293317ede17766$export$2e2bcd8739ae039(r, e) {
    return (0, $6e67d1065682db57$export$2e2bcd8739ae039)(r) || (0, $b73db435cf4fc0e6$export$2e2bcd8739ae039)(r, e) || (0, $27da1a02ed7b7cbe$export$2e2bcd8739ae039)(r, e) || (0, $78f48d684503c5e8$export$2e2bcd8739ae039)();
}



var $5FkrB = parcelRequire("5FkrB");
function $fa4a4ebb2790e034$export$2e2bcd8739ae039(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}



function $ec88b65548eaad36$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, (0, $c78289b32262e909$export$2e2bcd8739ae039)(o.key), o);
    }
}
function $ec88b65548eaad36$export$2e2bcd8739ae039(e, r, t) {
    return r && $ec88b65548eaad36$var$_defineProperties(e.prototype, r), t && $ec88b65548eaad36$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}





function $5e3499efc322ceb9$var$asyncGeneratorStep(n, t, e, r, o, a, c) {
    try {
        var i = n[a](c), u = i.value;
    } catch (n) {
        return void e(n);
    }
    i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function $5e3499efc322ceb9$export$2e2bcd8739ae039(n) {
    return function() {
        var t = this, e = arguments;
        return new Promise(function(r, o) {
            var a = n.apply(t, e);
            function _next(n) {
                $5e3499efc322ceb9$var$asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
            }
            function _throw(n) {
                $5e3499efc322ceb9$var$asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
            }
            _next(void 0);
        });
    };
}





var $145d71e91ce3de54$exports = {};
// TODO(Babel 8): Remove this file.

var $145d71e91ce3de54$var$runtime = (parcelRequire("7Jfiv"))();
$145d71e91ce3de54$exports = $145d71e91ce3de54$var$runtime;
// Copied from https://github.com/facebook/regenerator/blob/main/packages/runtime/runtime.js#L736=
try {
    regeneratorRuntime = $145d71e91ce3de54$var$runtime;
} catch (accidentalStrictMode) {
    if (typeof globalThis === "object") globalThis.regeneratorRuntime = $145d71e91ce3de54$var$runtime;
    else Function("r", "regeneratorRuntime = r")($145d71e91ce3de54$var$runtime);
}



var $iFR7a = parcelRequire("iFR7a");




var $hLfKH = parcelRequire("hLfKH");
function $4af4d075add89120$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $4af4d075add89120$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $4af4d075add89120$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $b610cb1610902400$export$2e2bcd8739ae039)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $4af4d075add89120$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $4af4d075add89120$export$a66cbd9b2289cd78 = '@all-features';
var $4af4d075add89120$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function Subscriptions() {
        (0, $fa4a4ebb2790e034$export$2e2bcd8739ae039)(this, Subscriptions);
        (0, $b610cb1610902400$export$2e2bcd8739ae039)(this, "eventToValue", new Map());
        this.emitter = new (0, (/*@__PURE__*/$parcel$interopDefault($hLfKH)))();
    }
    return (0, $ec88b65548eaad36$export$2e2bcd8739ae039)(Subscriptions, [
        {
            key: "onGateUpdated",
            value: function onGateUpdated(gateName, callback, checkGate, options) {
                var _this = this;
                var value = checkGate(gateName, $4af4d075add89120$var$_objectSpread($4af4d075add89120$var$_objectSpread({}, options), {}, {
                    fireGateExposure: false
                }));
                if (this.eventToValue.get(callback) === undefined) this.eventToValue.set(callback, value);
                var wrapCallback = function wrapCallback() {
                    var value = checkGate(gateName, $4af4d075add89120$var$_objectSpread($4af4d075add89120$var$_objectSpread({}, options), {}, {
                        fireGateExposure: false
                    }));
                    var existingValue = _this.eventToValue.get(callback);
                    if (existingValue !== value) {
                        _this.eventToValue.set(callback, value);
                        callback(value);
                    }
                };
                this.emitter.on(gateName, wrapCallback);
                return function() {
                    _this.emitter.off(gateName, wrapCallback);
                };
            }
        },
        {
            key: "onExperimentValueUpdated",
            value: function onExperimentValueUpdated(experimentName, parameterName, defaultValue, callback, getExperimentValue, options) {
                var _this2 = this;
                var experimentEventName = "".concat(experimentName, ".").concat(parameterName);
                var value = getExperimentValue(experimentName, parameterName, defaultValue, $4af4d075add89120$var$_objectSpread($4af4d075add89120$var$_objectSpread({}, options), {}, {
                    fireExperimentExposure: false
                }));
                if (this.eventToValue.get(callback) === undefined) this.eventToValue.set(callback, value);
                var wrapCallback = function wrapCallback() {
                    var value = getExperimentValue(experimentName, parameterName, defaultValue, $4af4d075add89120$var$_objectSpread($4af4d075add89120$var$_objectSpread({}, options), {}, {
                        fireExperimentExposure: false
                    }));
                    var existingValue = _this2.eventToValue.get(callback);
                    if (existingValue !== value) {
                        _this2.eventToValue.set(callback, value);
                        callback(value);
                    }
                };
                this.emitter.on(experimentEventName, wrapCallback);
                return function() {
                    _this2.emitter.off(experimentEventName, wrapCallback);
                };
            }
        },
        {
            key: "onAnyUpdated",
            value: function onAnyUpdated(callback) {
                var _this3 = this;
                this.emitter.on($4af4d075add89120$export$a66cbd9b2289cd78, callback);
                return function() {
                    _this3.emitter.off($4af4d075add89120$export$a66cbd9b2289cd78, callback);
                };
            }
        },
        {
            key: "anyUpdated",
            value: function anyUpdated() {
                var _this4 = this;
                this.emitter.emit($4af4d075add89120$export$a66cbd9b2289cd78);
                this.emitter.eventNames().filter(function(name) {
                    return name !== $4af4d075add89120$export$a66cbd9b2289cd78;
                }).forEach(function(event) {
                    _this4.emitter.emit(event);
                });
            }
        }
    ]);
}();







function $05d0fd5af8375da0$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return (0, $b69e46acab609c44$export$2e2bcd8739ae039)(r);
}


function $b788bc749c54ee24$export$2e2bcd8739ae039(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}



function $a043d925759334ac$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}


function $d174179afb4ba721$export$2e2bcd8739ae039(r) {
    return (0, $05d0fd5af8375da0$export$2e2bcd8739ae039)(r) || (0, $b788bc749c54ee24$export$2e2bcd8739ae039)(r) || (0, $27da1a02ed7b7cbe$export$2e2bcd8739ae039)(r) || (0, $a043d925759334ac$export$2e2bcd8739ae039)();
}





var $aef606df5f37bd52$export$ce553301d55c2fd8 = 'fedramp-moderate';
var $aef606df5f37bd52$export$f005e2e9f707cb5f = 'commercial';
var $aef606df5f37bd52$export$bd6b5a7802d76127 = 'fedramp-fedex';
var $aef606df5f37bd52$export$a739cd5aac835909 = 'stg';
var $aef606df5f37bd52$export$42dd0cdd351a4a9 = 'prod';
var $aef606df5f37bd52$export$404582bc18fe4d9e = 'dev';


function $21f7ee1dd7aa19b5$export$64d6499adf9b2e51() {
    var _global$location;
    var global = globalThis;
    // MICROS_PERIMETER is already used by few products, so we need to keep it for backward compatibility
    var env = global.MICROS_PERIMETER || global.UNSAFE_ATL_CONTEXT_BOUNDARY;
    if (env) return env === (0, $aef606df5f37bd52$export$ce553301d55c2fd8);
    var matches = (_global$location = global.location) === null || _global$location === void 0 || (_global$location = _global$location.hostname) === null || _global$location === void 0 ? void 0 : _global$location.match(/atlassian-us-gov-mod\.(com|net)|atlassian-us-gov\.(com|net)|atlassian-fex\.(com|net)|atlassian-stg-fedm\.(com|net)/);
    return matches ? matches.length > 0 : false;
}


// Reference: https://github.com/statsig-io/js-lite/blob/main/src/StatsigStore.ts
var $9ea837099c79ccfa$export$c62558b199e46828 = {
    // Order is important since the logic for migrating from a new client reason to an old one
    // returns the first which is a substring of the new client reason
    Error: 'Error',
    LocalOverride: 'LocalOverride',
    Unrecognized: 'Unrecognized',
    Uninitialized: 'Uninitialized',
    NetworkNotModified: 'NetworkNotModified',
    Network: 'Network',
    InvalidBootstrap: 'InvalidBootstrap',
    Bootstrap: 'Bootstrap',
    Cache: 'Cache',
    // For when we could not migrate the reason from the new client
    Unknown: 'Unknown'
}; // Reference: https://github.com/statsig-io/js-lite/blob/main/src/StatsigSDKOptions.ts


/**
 * The identifiers for the user. Options are restricted to the set that is currently supported.
 */ /**
 * Base client options. Does not include any options specific to providers
 * @interface BaseClientOptions
 * @property {FeatureGateEnvironment} environment - The environment for the client.
 * @property {string} targetApp - The target app for the client.
 * @property {AnalyticsWebClient} analyticsWebClient - The analytics web client.
 * @property {PerimeterType} perimeter - The perimeter for the client.
 */ /**
 * The options for the client.
 * @interface ClientOptions
 * @extends {BaseClientOptions}
 * @property {string} apiKey - The API key for the client.
 * @property {fetchTimeoutMs} fetchTimeoutMs - The timeout for the fetch request in milliseconds. Defaults to 5000.
 * @property {boolean} useGatewayURL - Whether to use the gateway URL. Defaults to false.
 */ /**
 * The custom attributes for the user.
 */ var $dd4a72dbf17ec6e1$export$479e7351a733299 = {
    Development: 'development',
    Staging: 'staging',
    Production: 'production'
};
var $dd4a72dbf17ec6e1$export$c42b7bbc5e7ba555 = {
    COMMERCIAL: 'commercial',
    FEDRAMP_MODERATE: 'fedramp-moderate'
};
var $dd4a72dbf17ec6e1$export$42f4885608027d0c = 'non_boolean'; // Type magic to get the JSDoc comments from the Client class methods to appear on the static
 // methods in FeatureGates where the property name and function type are identical


var $f6fe0ba27b648ffb$var$_excluded = [
    "stableId"
], $f6fe0ba27b648ffb$var$_excluded2 = [
    "api",
    "disableCurrentPageLogging",
    "loggingIntervalMillis",
    "loggingBufferMaxSize",
    "localMode",
    "eventLoggingApi",
    "eventLoggingApiForRetries",
    "disableLocalStorage",
    "ignoreWindowUndefined",
    "disableAllLogging",
    "initTimeoutMs",
    "disableNetworkKeepalive",
    "overrideStableID",
    "disableErrorLogging",
    "disableAutoMetricsLogging"
];
function $f6fe0ba27b648ffb$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $f6fe0ba27b648ffb$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $f6fe0ba27b648ffb$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $b610cb1610902400$export$2e2bcd8739ae039)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $f6fe0ba27b648ffb$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $f6fe0ba27b648ffb$export$d119b37e5f788b43 = function getOptionsWithDefaults(options) {
    return $f6fe0ba27b648ffb$var$_objectSpread({
        /**
     * If more federal PerimeterTypes are added in the future, this should be updated so
     * that isFedRamp() === true always returns the strictest perimeter.
     */ perimeter: (0, $21f7ee1dd7aa19b5$export$64d6499adf9b2e51)() ? (0, $dd4a72dbf17ec6e1$export$c42b7bbc5e7ba555).FEDRAMP_MODERATE : (0, $dd4a72dbf17ec6e1$export$c42b7bbc5e7ba555).COMMERCIAL
    }, options);
};
var $f6fe0ba27b648ffb$export$fa1c2bbf4100b8bc = function shallowEquals(objectA, objectB) {
    if (!objectA && !objectB) return true;
    if (!objectA || !objectB) return false;
    var aEntries = Object.entries(objectA);
    var bEntries = Object.entries(objectB);
    if (aEntries.length !== bEntries.length) return false;
    var ascendingKeyOrder = function ascendingKeyOrder(_ref, _ref2) {
        var _ref3 = (0, $4f293317ede17766$export$2e2bcd8739ae039)(_ref, 1), key1 = _ref3[0];
        var _ref4 = (0, $4f293317ede17766$export$2e2bcd8739ae039)(_ref2, 1), key2 = _ref4[0];
        return key1.localeCompare(key2);
    };
    aEntries.sort(ascendingKeyOrder);
    bEntries.sort(ascendingKeyOrder);
    for(var i = 0; i < aEntries.length; i++){
        var _aEntries$i = (0, $4f293317ede17766$export$2e2bcd8739ae039)(aEntries[i], 2), aValue = _aEntries$i[1];
        var _bEntries$i = (0, $4f293317ede17766$export$2e2bcd8739ae039)(bEntries[i], 2), bValue = _bEntries$i[1];
        if (aValue !== bValue) return false;
    }
    return true;
};
var $f6fe0ba27b648ffb$export$3dad1db244472f32 = function toStatsigUser(identifiers, customAttributes) {
    // Re-map `stableId` to `stableID` to match Statsig's native type.
    var stableId = identifiers.stableId, otherIdentifiers = (0, $f9613085755b341d$export$2e2bcd8739ae039)(identifiers, $f6fe0ba27b648ffb$var$_excluded);
    var user = {
        customIDs: $f6fe0ba27b648ffb$var$_objectSpread($f6fe0ba27b648ffb$var$_objectSpread({}, otherIdentifiers), stableId !== undefined ? {
            stableID: stableId
        } : {}),
        custom: customAttributes
    };
    if (identifiers.atlassianAccountId) user.userID = identifiers.atlassianAccountId;
    return user;
};
function $f6fe0ba27b648ffb$export$1148cb79ceecd5fa(target) {
    for(var _len = arguments.length, sources = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)sources[_key - 1] = arguments[_key];
    if (!sources.length) return target;
    var source = sources.shift();
    if (source === undefined || source === null) return $f6fe0ba27b648ffb$export$1148cb79ceecd5fa.apply(void 0, [
        target
    ].concat((0, $d174179afb4ba721$export$2e2bcd8739ae039)(sources)));
    for(var _i = 0, _Object$entries = Object.entries(source); _i < _Object$entries.length; _i++){
        var _Object$entries$_i = (0, $4f293317ede17766$export$2e2bcd8739ae039)(_Object$entries[_i], 2), key = _Object$entries$_i[0], src = _Object$entries$_i[1];
        var dst = target[key];
        var srcIsObj = src && (0, $adec1f6aecb10080$export$2e2bcd8739ae039)(src) === 'object' && !Array.isArray(src);
        var dstIsObj = dst && (0, $adec1f6aecb10080$export$2e2bcd8739ae039)(dst) === 'object' && !Array.isArray(dst);
        if (srcIsObj && dstIsObj) target[key] = $f6fe0ba27b648ffb$export$1148cb79ceecd5fa(dst, src);
        else target[key] = src;
    }
    return $f6fe0ba27b648ffb$export$1148cb79ceecd5fa.apply(void 0, [
        target
    ].concat((0, $d174179afb4ba721$export$2e2bcd8739ae039)(sources)));
}
var $f6fe0ba27b648ffb$export$202946b690d26d22 = function migrateInitializationOptions(options) {
    var api = options.api, disableCurrentPageLogging = options.disableCurrentPageLogging, loggingIntervalMillis = options.loggingIntervalMillis, loggingBufferMaxSize = options.loggingBufferMaxSize, localMode = options.localMode, eventLoggingApi = options.eventLoggingApi, eventLoggingApiForRetries = options.eventLoggingApiForRetries, disableLocalStorage = options.disableLocalStorage, ignoreWindowUndefined = options.ignoreWindowUndefined, disableAllLogging = options.disableAllLogging, _initTimeoutMs = options.initTimeoutMs, _disableNetworkKeepalive = options.disableNetworkKeepalive, _overrideStableID = options.overrideStableID, _disableErrorLogging = options.disableErrorLogging, _disableAutoMetricsLogging = options.disableAutoMetricsLogging, rest = (0, $f9613085755b341d$export$2e2bcd8739ae039)(options, $f6fe0ba27b648ffb$var$_excluded2);
    return $f6fe0ba27b648ffb$var$_objectSpread($f6fe0ba27b648ffb$var$_objectSpread({}, rest), {}, {
        networkConfig: {
            api: api,
            logEventUrl: eventLoggingApi ? eventLoggingApi + 'rgstr' : undefined,
            logEventFallbackUrls: eventLoggingApiForRetries ? [
                eventLoggingApiForRetries
            ] : undefined,
            preventAllNetworkTraffic: localMode || !ignoreWindowUndefined && typeof window === 'undefined'
        },
        includeCurrentPageUrlWithEvents: !disableCurrentPageLogging,
        loggingIntervalMs: loggingIntervalMillis,
        loggingBufferMaxSize: loggingBufferMaxSize,
        disableStorage: disableLocalStorage === undefined ? localMode : disableLocalStorage,
        disableLogging: disableAllLogging === undefined ? localMode : disableAllLogging
    });
};
var $f6fe0ba27b648ffb$var$evaluationReasonMappings = Object.entries((0, $9ea837099c79ccfa$export$c62558b199e46828)).map(function(_ref5) {
    var _ref6 = (0, $4f293317ede17766$export$2e2bcd8739ae039)(_ref5, 2), key = _ref6[0], value = _ref6[1];
    return [
        key.toLowerCase(),
        value
    ];
});
var $f6fe0ba27b648ffb$export$18ad168d3dbac899 = function migrateEvaluationDetails(details) {
    var _evaluationReasonMapp, _evaluationReasonMapp2, _details$receivedAt;
    var reasonLower = details.reason.toLowerCase();
    return {
        reason: (_evaluationReasonMapp = (_evaluationReasonMapp2 = $f6fe0ba27b648ffb$var$evaluationReasonMappings.find(function(_ref7) {
            var _ref8 = (0, $4f293317ede17766$export$2e2bcd8739ae039)(_ref7, 1), key = _ref8[0];
            return reasonLower.includes(key);
        })) === null || _evaluationReasonMapp2 === void 0 ? void 0 : _evaluationReasonMapp2[1]) !== null && _evaluationReasonMapp !== void 0 ? _evaluationReasonMapp : (0, $9ea837099c79ccfa$export$c62558b199e46828).Unknown,
        time: (_details$receivedAt = details.receivedAt) !== null && _details$receivedAt !== void 0 ? _details$receivedAt : Date.now()
    };
};
var $f6fe0ba27b648ffb$export$55fd683752d01e67 = function migrateSecondaryExposures(secondaryExposures) {
    return secondaryExposures.map(function(exposure) {
        if (typeof exposure === 'string') // This should ideally have gateValue and ruleID fields too, but it's not possible for us
        // to determine the correct values for these.
        return {
            gate: exposure
        };
        return exposure;
    });
};


var $6591b796a8a09f36$export$6dc24881a3d96325 = /*#__PURE__*/ function() {
    function DynamicConfig(configName, configValue, ruleID, evaluationDetails) {
        var secondaryExposures = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : [];
        var allocatedExperimentName = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : '';
        var onDefaultValueFallback = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : null;
        (0, $fa4a4ebb2790e034$export$2e2bcd8739ae039)(this, DynamicConfig);
        this.value = configValue;
        this._name = configName;
        this._ruleID = ruleID;
        this._secondaryExposures = secondaryExposures;
        this._allocatedExperimentName = allocatedExperimentName;
        this._evaluationDetails = evaluationDetails;
        this._onDefaultValueFallback = onDefaultValueFallback;
    }
    return (0, $ec88b65548eaad36$export$2e2bcd8739ae039)(DynamicConfig, [
        {
            key: "get",
            value: function get(key, defaultValue, typeGuard) {
                var _this$_onDefaultValue2;
                var val = this.getValue(key, defaultValue);
                if (val == null) return defaultValue;
                var expectedType = Array.isArray(defaultValue) ? 'array' : (0, $adec1f6aecb10080$export$2e2bcd8739ae039)(defaultValue);
                var actualType = Array.isArray(val) ? 'array' : (0, $adec1f6aecb10080$export$2e2bcd8739ae039)(val);
                if (typeGuard) {
                    var _this$_onDefaultValue;
                    if (typeGuard(val)) {
                        this.fireExposure(key);
                        return val;
                    }
                    (_this$_onDefaultValue = this._onDefaultValueFallback) === null || _this$_onDefaultValue === void 0 || _this$_onDefaultValue.call(this, this, key, expectedType, actualType);
                    return defaultValue;
                }
                if (defaultValue == null || expectedType === actualType) {
                    this.fireExposure(key);
                    return val;
                }
                (_this$_onDefaultValue2 = this._onDefaultValueFallback) === null || _this$_onDefaultValue2 === void 0 || _this$_onDefaultValue2.call(this, this, key, expectedType, actualType);
                return defaultValue;
            }
        },
        {
            key: "getValue",
            value: function getValue(key, defaultValue) {
                if (key == null) return this.value;
                if (defaultValue == null) defaultValue = null;
                if (this.value[key] == null) return defaultValue;
                this.fireExposure(key);
                return this.value[key];
            }
        },
        {
            key: "fireExposure",
            value: function fireExposure(key) {
                // Call the wrapped experiment's get method to fire exposure
                if (this.experiment) this.experiment.get(key);
            }
        }
    ], [
        {
            key: "fromExperiment",
            value: function fromExperiment(experiment) {
                var _experiment$__evaluat, _experiment$__evaluat2, _experiment$groupName;
                var config = new DynamicConfig(experiment.name, experiment.value, experiment.ruleID, (0, $f6fe0ba27b648ffb$export$18ad168d3dbac899)(experiment.details), (0, $f6fe0ba27b648ffb$export$55fd683752d01e67)((_experiment$__evaluat = (_experiment$__evaluat2 = experiment.__evaluation) === null || _experiment$__evaluat2 === void 0 ? void 0 : _experiment$__evaluat2.secondary_exposures) !== null && _experiment$__evaluat !== void 0 ? _experiment$__evaluat : []), (_experiment$groupName = experiment.groupName) !== null && _experiment$groupName !== void 0 ? _experiment$groupName : undefined);
                config.experiment = experiment;
                return config;
            }
        }
    ]);
}();






var $32078069de191bb3$export$936d0764594b6eb3 = /*#__PURE__*/ function() {
    function Layer(name, layerValue, ruleID, evaluationDetails) {
        var logParameterFunction = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;
        var secondaryExposures = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : [];
        var undelegatedSecondaryExposures = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : [];
        var allocatedExperimentName = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : '';
        var explicitParameters = arguments.length > 8 && arguments[8] !== undefined ? arguments[8] : [];
        (0, $fa4a4ebb2790e034$export$2e2bcd8739ae039)(this, Layer);
        this._logParameterFunction = logParameterFunction;
        this._name = name;
        this._value = JSON.parse(JSON.stringify(layerValue !== null && layerValue !== void 0 ? layerValue : {}));
        this._ruleID = ruleID !== null && ruleID !== void 0 ? ruleID : '';
        this._evaluationDetails = evaluationDetails;
        this._secondaryExposures = secondaryExposures;
        this._undelegatedSecondaryExposures = undelegatedSecondaryExposures;
        this._allocatedExperimentName = allocatedExperimentName;
        this._explicitParameters = explicitParameters;
    }
    return (0, $ec88b65548eaad36$export$2e2bcd8739ae039)(Layer, [
        {
            key: "get",
            value: function get(key, defaultValue, typeGuard) {
                var _this = this;
                var val = this._value[key];
                if (val == null) return defaultValue;
                var logAndReturn = function logAndReturn() {
                    _this._logLayerParameterExposure(key);
                    return val;
                };
                if (typeGuard) return typeGuard(val) ? logAndReturn() : defaultValue;
                if (defaultValue == null) return logAndReturn();
                if ((0, $adec1f6aecb10080$export$2e2bcd8739ae039)(val) === (0, $adec1f6aecb10080$export$2e2bcd8739ae039)(defaultValue) && Array.isArray(defaultValue) === Array.isArray(val)) return logAndReturn();
                return defaultValue;
            }
        },
        {
            key: "getValue",
            value: function getValue(key, defaultValue) {
                // eslint-disable-next-line eqeqeq
                if (defaultValue == undefined) defaultValue = null;
                var val = this._value[key];
                if (val != null) this._logLayerParameterExposure(key);
                return val !== null && val !== void 0 ? val : defaultValue;
            }
        },
        {
            key: "_logLayerParameterExposure",
            value: function _logLayerParameterExposure(parameterName) {
                var _this$_logParameterFu;
                (_this$_logParameterFu = this._logParameterFunction) === null || _this$_logParameterFu === void 0 || _this$_logParameterFu.call(this, this, parameterName);
            }
        }
    ], [
        {
            key: "fromLayer",
            value: function fromLayer(layer) {
                var _layer$__evaluation$s, _layer$__evaluation, _layer$__evaluation$u, _layer$__evaluation2, _layer$__evaluation3, _layer$__evaluation4;
                var value = new Layer(layer.name, layer.__value, layer.ruleID, (0, $f6fe0ba27b648ffb$export$18ad168d3dbac899)(layer.details), function(_layer, parameterName) {
                    return layer.get(parameterName);
                }, (0, $f6fe0ba27b648ffb$export$55fd683752d01e67)((_layer$__evaluation$s = (_layer$__evaluation = layer.__evaluation) === null || _layer$__evaluation === void 0 ? void 0 : _layer$__evaluation.secondary_exposures) !== null && _layer$__evaluation$s !== void 0 ? _layer$__evaluation$s : []), (0, $f6fe0ba27b648ffb$export$55fd683752d01e67)((_layer$__evaluation$u = (_layer$__evaluation2 = layer.__evaluation) === null || _layer$__evaluation2 === void 0 ? void 0 : _layer$__evaluation2.undelegated_secondary_exposures) !== null && _layer$__evaluation$u !== void 0 ? _layer$__evaluation$u : []), (_layer$__evaluation3 = layer.__evaluation) === null || _layer$__evaluation3 === void 0 ? void 0 : _layer$__evaluation3.allocated_experiment_name, (_layer$__evaluation4 = layer.__evaluation) === null || _layer$__evaluation4 === void 0 ? void 0 : _layer$__evaluation4.explicit_parameters);
                return value;
            }
        }
    ]);
}();









/// <reference types="node" />
var $b65bf9cf2fa81ea9$export$a59f8d67326bd1cb = "5.8.0";





function $2c002ac393147116$export$2e2bcd8739ae039(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
}


function $9aa98131e170ebee$export$2e2bcd8739ae039(t, e) {
    if (e && ("object" == (0, $adec1f6aecb10080$export$2e2bcd8739ae039)(e) || "function" == typeof e)) return e;
    if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
    return (0, $2c002ac393147116$export$2e2bcd8739ae039)(t);
}


function $4490bebe6ed00a04$export$2e2bcd8739ae039(t) {
    return $4490bebe6ed00a04$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
        return t.__proto__ || Object.getPrototypeOf(t);
    }, $4490bebe6ed00a04$export$2e2bcd8739ae039(t);
}


function $111c5e44640675ac$export$2e2bcd8739ae039(t, e) {
    return $111c5e44640675ac$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, $111c5e44640675ac$export$2e2bcd8739ae039(t, e);
}


function $fab6c522048ab9a7$export$2e2bcd8739ae039(t, e) {
    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
    t.prototype = Object.create(e && e.prototype, {
        constructor: {
            value: t,
            writable: !0,
            configurable: !0
        }
    }), Object.defineProperty(t, "prototype", {
        writable: !1
    }), e && (0, $111c5e44640675ac$export$2e2bcd8739ae039)(t, e);
}




function $807ea1745d066978$export$2e2bcd8739ae039(t) {
    try {
        return -1 !== Function.toString.call(t).indexOf("[native code]");
    } catch (n) {
        return "function" == typeof t;
    }
}


function $7f351afb70cefe77$export$2e2bcd8739ae039() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($7f351afb70cefe77$export$2e2bcd8739ae039 = function _isNativeReflectConstruct() {
        return !!t;
    })();
}



function $151e3b9e38c059e4$export$2e2bcd8739ae039(t, e, r) {
    if ((0, $7f351afb70cefe77$export$2e2bcd8739ae039)()) return Reflect.construct.apply(null, arguments);
    var o = [
        null
    ];
    o.push.apply(o, e);
    var p = new (t.bind.apply(t, o))();
    return r && (0, $111c5e44640675ac$export$2e2bcd8739ae039)(p, r.prototype), p;
}


function $fce237ebfe030e25$export$2e2bcd8739ae039(t) {
    var r = "function" == typeof Map ? new Map() : void 0;
    return $fce237ebfe030e25$export$2e2bcd8739ae039 = function _wrapNativeSuper(t) {
        if (null === t || !(0, $807ea1745d066978$export$2e2bcd8739ae039)(t)) return t;
        if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function");
        if (void 0 !== r) {
            if (r.has(t)) return r.get(t);
            r.set(t, Wrapper);
        }
        function Wrapper() {
            return (0, $151e3b9e38c059e4$export$2e2bcd8739ae039)(t, arguments, (0, $4490bebe6ed00a04$export$2e2bcd8739ae039)(this).constructor);
        }
        return Wrapper.prototype = Object.create(t.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: !1,
                writable: !0,
                configurable: !0
            }
        }), (0, $111c5e44640675ac$export$2e2bcd8739ae039)(Wrapper, t);
    }, $fce237ebfe030e25$export$2e2bcd8739ae039(t);
}


function $33dcb9ad48bcf0fb$var$_callSuper(t, o, e) {
    return o = (0, $4490bebe6ed00a04$export$2e2bcd8739ae039)(o), (0, $9aa98131e170ebee$export$2e2bcd8739ae039)(t, $33dcb9ad48bcf0fb$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, $4490bebe6ed00a04$export$2e2bcd8739ae039)(t).constructor) : o.apply(t, e));
}
function $33dcb9ad48bcf0fb$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($33dcb9ad48bcf0fb$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $33dcb9ad48bcf0fb$export$286baf652d0b1206 = /*#__PURE__*/ function(_Error) {
    function ResponseError(message) {
        (0, $fa4a4ebb2790e034$export$2e2bcd8739ae039)(this, ResponseError);
        return $33dcb9ad48bcf0fb$var$_callSuper(this, ResponseError, [
            message
        ]);
    }
    (0, $fab6c522048ab9a7$export$2e2bcd8739ae039)(ResponseError, _Error);
    return (0, $ec88b65548eaad36$export$2e2bcd8739ae039)(ResponseError);
}(/*#__PURE__*/ (0, $fce237ebfe030e25$export$2e2bcd8739ae039)(Error));


function $bd1659229942a780$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $bd1659229942a780$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $bd1659229942a780$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $b610cb1610902400$export$2e2bcd8739ae039)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $bd1659229942a780$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $bd1659229942a780$var$DEFAULT_REQUEST_TIMEOUT_MS = 5000;
var $bd1659229942a780$export$250a58ecde616daa = 'https://api.atlassian.com/flags';
var $bd1659229942a780$export$942ba04389b0d5a2 = 'https://api.stg.atlassian.com/flags';
var $bd1659229942a780$export$f058dbf75c3bc647 = 'https://api.dev.atlassian.com/flags';
var $bd1659229942a780$export$1a401a0da8da3565 = 'https://api.stg.atlassian-us-gov-mod.com/flags';
var $bd1659229942a780$export$18c93900db9358a4 = 'https://api.atlassian-us-gov-mod.com/flags';
var $bd1659229942a780$export$4e8a0415edbfa1f7 = 'https://atlassian-statsig-proxy-archetype.atl-paas.%s.atl-ic.net';
var $bd1659229942a780$export$cb3cd156f70d7e94 = 'oasis-stg.com/flags';
var $bd1659229942a780$export$921fbc6cdfd4eee0 = 'atlassian-isolated.net/flags';
var $bd1659229942a780$export$450bd8fb2a6d7ace = '/gateway/api/flags';
var $bd1659229942a780$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function Fetcher() {
        (0, $fa4a4ebb2790e034$export$2e2bcd8739ae039)(this, Fetcher);
    }
    return (0, $ec88b65548eaad36$export$2e2bcd8739ae039)(Fetcher, null, [
        {
            key: "fetchClientSdk",
            value: function() {
                var _fetchClientSdk = (0, $5e3499efc322ceb9$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($145d71e91ce3de54$exports))).mark(function _callee(fetcherOptions) {
                    var targetApp, url, _t;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($145d71e91ce3de54$exports))).wrap(function(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                targetApp = fetcherOptions.targetApp;
                                url = "/api/v2/frontend/clientSdkKey/".concat(targetApp);
                                _context.prev = 1;
                                _context.next = 2;
                                return this.fetchRequest(url, 'GET', fetcherOptions);
                            case 2:
                                return _context.abrupt("return", _context.sent);
                            case 3:
                                _context.prev = 3;
                                _t = _context["catch"](1);
                                if (!(_t instanceof Error)) {
                                    _context.next = 4;
                                    break;
                                }
                                throw _t;
                            case 4:
                                throw Error('Failed to retrieve client sdk key');
                            case 5:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee, this, [
                        [
                            1,
                            3
                        ]
                    ]);
                }));
                function fetchClientSdk(_x) {
                    return _fetchClientSdk.apply(this, arguments);
                }
                return fetchClientSdk;
            }()
        },
        {
            key: "fetchExperimentValues",
            value: function() {
                var _fetchExperimentValues = (0, $5e3499efc322ceb9$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($145d71e91ce3de54$exports))).mark(function _callee2(fetcherOptions, identifiers, customAttributes) {
                    var requestBody, _t2;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($145d71e91ce3de54$exports))).wrap(function(_context2) {
                        while(true)switch(_context2.prev = _context2.next){
                            case 0:
                                requestBody = {
                                    identifiers: identifiers,
                                    customAttributes: customAttributes,
                                    targetApp: fetcherOptions.targetApp
                                };
                                _context2.prev = 1;
                                _context2.next = 2;
                                return this.fetchRequest('/api/v2/frontend/experimentValues', 'POST', fetcherOptions, requestBody);
                            case 2:
                                return _context2.abrupt("return", _context2.sent);
                            case 3:
                                _context2.prev = 3;
                                _t2 = _context2["catch"](1);
                                if (!(_t2 instanceof Error)) {
                                    _context2.next = 4;
                                    break;
                                }
                                throw _t2;
                            case 4:
                                throw Error('Failed to retrieve experiment values');
                            case 5:
                            case "end":
                                return _context2.stop();
                        }
                    }, _callee2, this, [
                        [
                            1,
                            3
                        ]
                    ]);
                }));
                function fetchExperimentValues(_x2, _x3, _x4) {
                    return _fetchExperimentValues.apply(this, arguments);
                }
                return fetchExperimentValues;
            }()
        },
        {
            key: "handleResponseError",
            value: function() {
                var _handleResponseError = (0, $5e3499efc322ceb9$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($145d71e91ce3de54$exports))).mark(function _callee3(response) {
                    var body;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($145d71e91ce3de54$exports))).wrap(function(_context3) {
                        while(true)switch(_context3.prev = _context3.next){
                            case 0:
                                if (response.ok) {
                                    _context3.next = 2;
                                    break;
                                }
                                _context3.next = 1;
                                return response.text();
                            case 1:
                                body = _context3.sent;
                                throw new (0, $33dcb9ad48bcf0fb$export$286baf652d0b1206)("Non 2xx response status received, status: ".concat(response.status, ", body: ").concat(JSON.stringify(body)));
                            case 2:
                                if (!(response.status === 204)) {
                                    _context3.next = 3;
                                    break;
                                }
                                throw new (0, $33dcb9ad48bcf0fb$export$286baf652d0b1206)('Unexpected 204 response');
                            case 3:
                            case "end":
                                return _context3.stop();
                        }
                    }, _callee3);
                }));
                function handleResponseError(_x5) {
                    return _handleResponseError.apply(this, arguments);
                }
                return handleResponseError;
            }()
        },
        {
            key: "extractResponseBody",
            value: function() {
                var _extractResponseBody = (0, $5e3499efc322ceb9$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($145d71e91ce3de54$exports))).mark(function _callee4(response) {
                    var value;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($145d71e91ce3de54$exports))).wrap(function(_context4) {
                        while(true)switch(_context4.prev = _context4.next){
                            case 0:
                                _context4.next = 1;
                                return response.text();
                            case 1:
                                value = _context4.sent;
                                return _context4.abrupt("return", JSON.parse(value));
                            case 2:
                            case "end":
                                return _context4.stop();
                        }
                    }, _callee4);
                }));
                function extractResponseBody(_x6) {
                    return _extractResponseBody.apply(this, arguments);
                }
                return extractResponseBody;
            }()
        },
        {
            key: "getBaseUrl",
            value: function getBaseUrl(serviceEnv) {
                var useGatewayUrl = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
                var perimeter = arguments.length > 2 ? arguments[2] : undefined;
                var isolationContextId = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
                if (useGatewayUrl) return $bd1659229942a780$export$450bd8fb2a6d7ace;
                if (perimeter === (0, $dd4a72dbf17ec6e1$export$c42b7bbc5e7ba555).FEDRAMP_MODERATE) switch(serviceEnv){
                    case (0, $dd4a72dbf17ec6e1$export$479e7351a733299).Production:
                        return $bd1659229942a780$export$18c93900db9358a4;
                    case (0, $dd4a72dbf17ec6e1$export$479e7351a733299).Staging:
                        return $bd1659229942a780$export$1a401a0da8da3565;
                    default:
                        throw new Error("Invalid environment \"".concat(serviceEnv, "\" for \"").concat(perimeter, "\" perimeter"));
                }
                else if (perimeter === (0, $dd4a72dbf17ec6e1$export$c42b7bbc5e7ba555).COMMERCIAL) switch(serviceEnv){
                    case (0, $dd4a72dbf17ec6e1$export$479e7351a733299).Development:
                        return $bd1659229942a780$export$f058dbf75c3bc647;
                    case (0, $dd4a72dbf17ec6e1$export$479e7351a733299).Staging:
                        var apiUrl = this.getApiUrl(isolationContextId);
                        if (apiUrl !== null) return apiUrl;
                        return $bd1659229942a780$export$942ba04389b0d5a2;
                    default:
                        var prodApiUrl = this.getApiUrl(isolationContextId);
                        if (prodApiUrl !== null) return prodApiUrl;
                        return $bd1659229942a780$export$250a58ecde616daa;
                }
                else throw new Error("Invalid perimeter \"".concat(perimeter, "\""));
            }
        },
        {
            key: "fetchRequest",
            value: function() {
                var _fetchRequest = (0, $5e3499efc322ceb9$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($145d71e91ce3de54$exports))).mark(function _callee5(path, method, fetcherOptions, body) {
                    var baseUrl, fetchTimeout, abortSignal, abortController, response;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($145d71e91ce3de54$exports))).wrap(function(_context5) {
                        while(true)switch(_context5.prev = _context5.next){
                            case 0:
                                baseUrl = Fetcher.getBaseUrl(fetcherOptions.environment, fetcherOptions.useGatewayURL, fetcherOptions.perimeter, fetcherOptions.isolationContextId);
                                fetchTimeout = fetcherOptions.fetchTimeoutMs || $bd1659229942a780$var$DEFAULT_REQUEST_TIMEOUT_MS;
                                if (AbortSignal.timeout) abortSignal = AbortSignal.timeout(fetchTimeout);
                                else if (AbortController) {
                                    abortController = new AbortController();
                                    abortSignal = abortController.signal;
                                    setTimeout(function() {
                                        return abortController.abort();
                                    }, fetchTimeout);
                                }
                                _context5.next = 1;
                                return fetch("".concat(baseUrl).concat(path), $bd1659229942a780$var$_objectSpread({
                                    method: method,
                                    headers: {
                                        'Content-Type': 'application/json',
                                        'X-Client-Name': 'feature-gate-js-client',
                                        'X-Client-Version': (0, $b65bf9cf2fa81ea9$export$a59f8d67326bd1cb),
                                        'X-API-KEY': fetcherOptions.apiKey
                                    },
                                    signal: abortSignal
                                }, body && {
                                    body: JSON.stringify(body)
                                }));
                            case 1:
                                response = _context5.sent;
                                _context5.next = 2;
                                return this.handleResponseError(response);
                            case 2:
                                _context5.next = 3;
                                return this.extractResponseBody(response);
                            case 3:
                                return _context5.abrupt("return", _context5.sent);
                            case 4:
                            case "end":
                                return _context5.stop();
                        }
                    }, _callee5, this);
                }));
                function fetchRequest(_x7, _x8, _x9, _x0) {
                    return _fetchRequest.apply(this, arguments);
                }
                return fetchRequest;
            }()
        },
        {
            key: "getApiUrl",
            value: function getApiUrl(isolationContextId) {
                var window1 = this.getWindowLocation();
                if (window1 === undefined) {
                    //this is needed when this SDK is used for SSR or plugin use cases where secret keys not available to use backend SDKs
                    if (!isolationContextId) return null;
                    return $bd1659229942a780$export$4e8a0415edbfa1f7.replace('%s', isolationContextId);
                }
                var protocol = window1.protocol, hostname = window1.hostname;
                // Match last subdomain fragment before oasis-stg.com
                var oasisMatch = hostname.match(/([^.]+)\.oasis-stg\.com$/);
                if (oasisMatch) return "".concat(protocol, "//api.").concat(oasisMatch[1], ".").concat($bd1659229942a780$export$cb3cd156f70d7e94);
                // Match last subdomain fragment before atlassian-isolated.net
                var isolatedMatch = hostname.match(/([^.]+)\.atlassian-isolated\.net$/);
                if (isolatedMatch) return "".concat(protocol, "//api.").concat(isolatedMatch[1], ".").concat($bd1659229942a780$export$921fbc6cdfd4eee0);
                return null;
            }
        },
        {
            key: "getWindowLocation",
            value: function getWindowLocation() {
                if (typeof window !== 'undefined' && window.location) return window.location;
                return undefined;
            }
        }
    ]);
}();








function $0f85b40cace6b201$export$2e2bcd8739ae039(t, o) {
    for(; !({}).hasOwnProperty.call(t, o) && null !== (t = (0, $4490bebe6ed00a04$export$2e2bcd8739ae039)(t)););
    return t;
}


function $30e2255d05c27cca$export$2e2bcd8739ae039() {
    return $30e2255d05c27cca$export$2e2bcd8739ae039 = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function(e, t, r) {
        var p = (0, $0f85b40cace6b201$export$2e2bcd8739ae039)(e, t);
        if (p) {
            var n = Object.getOwnPropertyDescriptor(p, t);
            return n.get ? n.get.call(arguments.length < 3 ? e : r) : n.value;
        }
    }, $30e2255d05c27cca$export$2e2bcd8739ae039.apply(null, arguments);
}






var $iFR7a = parcelRequire("iFR7a");
function $5843b140d39c02ad$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $5843b140d39c02ad$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $5843b140d39c02ad$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $b610cb1610902400$export$2e2bcd8739ae039)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $5843b140d39c02ad$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $5843b140d39c02ad$var$_callSuper(t, o, e) {
    return o = (0, $4490bebe6ed00a04$export$2e2bcd8739ae039)(o), (0, $9aa98131e170ebee$export$2e2bcd8739ae039)(t, $5843b140d39c02ad$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, $4490bebe6ed00a04$export$2e2bcd8739ae039)(t).constructor) : o.apply(t, e));
}
function $5843b140d39c02ad$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($5843b140d39c02ad$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $5843b140d39c02ad$var$_superPropGet(t, o, e, r) {
    var p = (0, $30e2255d05c27cca$export$2e2bcd8739ae039)((0, $4490bebe6ed00a04$export$2e2bcd8739ae039)(1 & r ? t.prototype : t), o, e);
    return 2 & r && "function" == typeof p ? function(t) {
        return p.apply(e, t);
    } : p;
}
var $5843b140d39c02ad$export$55fffef3474104af = /*#__PURE__*/ function(_DataAdapterCore) {
    function NoFetchDataAdapter() {
        var _this;
        (0, $fa4a4ebb2790e034$export$2e2bcd8739ae039)(this, NoFetchDataAdapter);
        _this = $5843b140d39c02ad$var$_callSuper(this, NoFetchDataAdapter, [
            'NoFetchDataAdapter',
            'nofetch'
        ]);
        (0, $b610cb1610902400$export$2e2bcd8739ae039)(_this, "bootstrapResult", null);
        return _this;
    }
    /**
   * Make sure to call this **before** calling `initializeAsync` or `updateUserAsync` but
   * after the Statsig client has been created!
   */ (0, $fab6c522048ab9a7$export$2e2bcd8739ae039)(NoFetchDataAdapter, _DataAdapterCore);
    return (0, $ec88b65548eaad36$export$2e2bcd8739ae039)(NoFetchDataAdapter, [
        {
            key: "setBootstrapData",
            value: function setBootstrapData(data) {
                this.bootstrapResult = data ? {
                    source: 'Bootstrap',
                    data: JSON.stringify(data),
                    receivedAt: Date.now(),
                    stableID: (0, $iFR7a.StableID).get(this._getSdkKey()),
                    fullUserHash: null
                } : null;
            }
        },
        {
            key: "prefetchData",
            value: function() {
                var _prefetchData = (0, $5e3499efc322ceb9$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($145d71e91ce3de54$exports))).mark(function _callee(_user, _options) {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($145d71e91ce3de54$exports))).wrap(function(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee);
                }));
                function prefetchData(_x, _x2) {
                    return _prefetchData.apply(this, arguments);
                }
                return prefetchData;
            }()
        },
        {
            key: "getDataAsync",
            value: function() {
                var _getDataAsync = (0, $5e3499efc322ceb9$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($145d71e91ce3de54$exports))).mark(function _callee2(_current, user, _options) {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($145d71e91ce3de54$exports))).wrap(function(_context2) {
                        while(true)switch(_context2.prev = _context2.next){
                            case 0:
                                return _context2.abrupt("return", this.bootstrapResult && $5843b140d39c02ad$var$_objectSpread($5843b140d39c02ad$var$_objectSpread({}, this.bootstrapResult), {}, {
                                    fullUserHash: (0, $iFR7a._getFullUserHash)(user)
                                }));
                            case 1:
                            case "end":
                                return _context2.stop();
                        }
                    }, _callee2, this);
                }));
                function getDataAsync(_x3, _x4, _x5) {
                    return _getDataAsync.apply(this, arguments);
                }
                return getDataAsync;
            }()
        },
        {
            key: "getDataSync",
            value: function getDataSync(user) {
                return this.bootstrapResult && $5843b140d39c02ad$var$_objectSpread($5843b140d39c02ad$var$_objectSpread({}, this.bootstrapResult), {}, {
                    fullUserHash: (0, $iFR7a._getFullUserHash)(user)
                });
            }
        },
        {
            key: "_fetchFromNetwork",
            value: function() {
                var _fetchFromNetwork2 = (0, $5e3499efc322ceb9$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($145d71e91ce3de54$exports))).mark(function _callee3(_current, _user, _options) {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($145d71e91ce3de54$exports))).wrap(function(_context3) {
                        while(true)switch(_context3.prev = _context3.next){
                            case 0:
                                return _context3.abrupt("return", null);
                            case 1:
                            case "end":
                                return _context3.stop();
                        }
                    }, _callee3);
                }));
                function _fetchFromNetwork(_x6, _x7, _x8) {
                    return _fetchFromNetwork2.apply(this, arguments);
                }
                return _fetchFromNetwork;
            }()
        },
        {
            key: "_getCacheKey",
            value: function _getCacheKey(user) {
                // Same logic as default data adapter
                // https://github.com/statsig-io/js-client-monorepo/blob/main/packages/js-client/src/StatsigEvaluationsDataAdapter.ts
                var key = (0, $iFR7a._getStorageKey)(this._getSdkKey(), user);
                return "".concat((0, $iFR7a.DataAdapterCachePrefix), ".").concat(this._cacheSuffix, ".").concat(key);
            }
        },
        {
            key: "_isCachedResultValidFor204",
            value: function _isCachedResultValidFor204(_result, _user) {
                return false;
            }
        },
        {
            key: "setDataLegacy",
            value: function setDataLegacy(data, user) {
                $5843b140d39c02ad$var$_superPropGet(NoFetchDataAdapter, "setData", this, 3)([
                    data,
                    user
                ]);
            }
        },
        {
            key: "toJSON",
            value: function toJSON() {
                var result = $5843b140d39c02ad$var$_objectSpread({}, this);
                delete result._options;
                delete result._inMemoryCache;
                delete result.bootstrapResult;
                return result;
            }
        }
    ]);
}((0, $iFR7a.DataAdapterCore));







var $dtn6l = parcelRequire("dtn6l");
function $4451c1f816aaeaec$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $4451c1f816aaeaec$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $4451c1f816aaeaec$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $b610cb1610902400$export$2e2bcd8739ae039)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $4451c1f816aaeaec$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $4451c1f816aaeaec$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $4451c1f816aaeaec$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $4451c1f816aaeaec$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $4451c1f816aaeaec$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $4451c1f816aaeaec$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $4451c1f816aaeaec$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
var $4451c1f816aaeaec$var$LOCAL_OVERRIDE_REASON = 'LocalOverride:Recognized';
var $4451c1f816aaeaec$export$d8474cff104280f3 = 'STATSIG_OVERRIDES';
var $4451c1f816aaeaec$var$LEGACY_LOCAL_STORAGE_KEY = 'STATSIG_JS_LITE_LOCAL_OVERRIDES';
var $4451c1f816aaeaec$var$makeEmptyStore = function makeEmptyStore() {
    return {
        gates: {},
        configs: {},
        layers: {}
    };
};
var $4451c1f816aaeaec$var$djb2MapKey = function djb2MapKey(hash, kind) {
    return kind + ':' + hash;
};
var $4451c1f816aaeaec$export$bcb28fbac1def494 = /*#__PURE__*/ function() {
    function PersistentOverrideAdapter(localStorageKey) {
        (0, $fa4a4ebb2790e034$export$2e2bcd8739ae039)(this, PersistentOverrideAdapter);
        this._overrides = $4451c1f816aaeaec$var$makeEmptyStore();
        this._djb2Map = new Map();
        this._localStorageKey = localStorageKey;
    }
    return (0, $ec88b65548eaad36$export$2e2bcd8739ae039)(PersistentOverrideAdapter, [
        {
            key: "parseStoredOverrides",
            value: function parseStoredOverrides(localStorageKey) {
                try {
                    var json = window.localStorage.getItem(localStorageKey);
                    if (!json) return $4451c1f816aaeaec$var$makeEmptyStore();
                    return JSON.parse(json);
                } catch (_unused) {
                    return $4451c1f816aaeaec$var$makeEmptyStore();
                }
            }
        },
        {
            key: "mergeOverrides",
            value: function mergeOverrides() {
                var merged = $4451c1f816aaeaec$var$makeEmptyStore();
                for(var _len = arguments.length, allOverrides = new Array(_len), _key = 0; _key < _len; _key++)allOverrides[_key] = arguments[_key];
                for(var _i = 0, _allOverrides = allOverrides; _i < _allOverrides.length; _i++){
                    var overrides = _allOverrides[_i];
                    for(var _i2 = 0, _Object$entries = Object.entries((_overrides$gates = overrides.gates) !== null && _overrides$gates !== void 0 ? _overrides$gates : {}); _i2 < _Object$entries.length; _i2++){
                        var _overrides$gates;
                        var _Object$entries$_i = (0, $4f293317ede17766$export$2e2bcd8739ae039)(_Object$entries[_i2], 2), name = _Object$entries$_i[0], value = _Object$entries$_i[1];
                        merged.gates[name] = value;
                    }
                    for(var _i3 = 0, _Object$entries2 = Object.entries((_overrides$configs = overrides.configs) !== null && _overrides$configs !== void 0 ? _overrides$configs : {}); _i3 < _Object$entries2.length; _i3++){
                        var _overrides$configs;
                        var _Object$entries2$_i = (0, $4f293317ede17766$export$2e2bcd8739ae039)(_Object$entries2[_i3], 2), _name = _Object$entries2$_i[0], _value = _Object$entries2$_i[1];
                        merged.configs[_name] = _value;
                    }
                    for(var _i4 = 0, _Object$entries3 = Object.entries((_overrides$layers = overrides.layers) !== null && _overrides$layers !== void 0 ? _overrides$layers : {}); _i4 < _Object$entries3.length; _i4++){
                        var _overrides$layers;
                        var _Object$entries3$_i = (0, $4f293317ede17766$export$2e2bcd8739ae039)(_Object$entries3[_i4], 2), _name2 = _Object$entries3$_i[0], _value2 = _Object$entries3$_i[1];
                        merged.layers[_name2] = _value2;
                    }
                }
                return merged;
            }
        },
        {
            key: "initFromStoredOverrides",
            value: function initFromStoredOverrides() {
                var storedOverrides = this.mergeOverrides(this._overrides, this.parseStoredOverrides($4451c1f816aaeaec$var$LEGACY_LOCAL_STORAGE_KEY), this.parseStoredOverrides(this._localStorageKey));
                // Clear data from legacy local storage key now we've read from it.
                // This prevents things being stuck in there that are always read but never written to.
                try {
                    window.localStorage.removeItem($4451c1f816aaeaec$var$LEGACY_LOCAL_STORAGE_KEY);
                } catch (_unused2) {
                // ignored - window is not defined in non-browser environments, and we don't save things there
                // (things like SSR, etc)
                }
                // In version 4.24.0 we introduced hashes in this override adapter, but had a bug which would cause
                // multiple hashes to continue being created. This code here removes these hashes since we've moved
                // to using a more reliable and easier to maintain map in `_djb2Map`.
                for(var _i5 = 0, _Object$values = Object.values(storedOverrides); _i5 < _Object$values.length; _i5++){
                    var container = _Object$values[_i5];
                    var allKeys = new Set(Object.keys(container));
                    var _iterator = $4451c1f816aaeaec$var$_createForOfIteratorHelper(allKeys), _step;
                    try {
                        for(_iterator.s(); !(_step = _iterator.n()).done;){
                            var name = _step.value;
                            var hash = (0, $dtn6l._DJB2)(name);
                            if (allKeys.has(hash)) delete container[hash];
                        }
                    } catch (err) {
                        _iterator.e(err);
                    } finally{
                        _iterator.f();
                    }
                }
                this.applyOverrides(storedOverrides);
            }
        },
        {
            key: "saveOverrides",
            value: function saveOverrides() {
                try {
                    window.localStorage.setItem(this._localStorageKey, JSON.stringify(this._overrides));
                } catch (_unused3) {
                // ignored - window is not defined in non-browser environments, and we don't save things there
                // (things like SSR, etc)
                }
            }
        },
        {
            key: "getOverrides",
            value: function getOverrides() {
                return this.mergeOverrides(this._overrides);
            }
        },
        {
            key: "applyOverrides",
            value: function applyOverrides(overrides) {
                var newOverrides = $4451c1f816aaeaec$var$_objectSpread($4451c1f816aaeaec$var$_objectSpread({}, $4451c1f816aaeaec$var$makeEmptyStore()), overrides);
                this._djb2Map.clear();
                for(var _i6 = 0, _Object$entries4 = Object.entries(newOverrides); _i6 < _Object$entries4.length; _i6++){
                    var _Object$entries4$_i = (0, $4f293317ede17766$export$2e2bcd8739ae039)(_Object$entries4[_i6], 2), containerName = _Object$entries4$_i[0], container = _Object$entries4$_i[1];
                    for(var _i7 = 0, _Object$entries5 = Object.entries(container); _i7 < _Object$entries5.length; _i7++){
                        var _Object$entries5$_i = (0, $4f293317ede17766$export$2e2bcd8739ae039)(_Object$entries5[_i7], 2), name = _Object$entries5$_i[0], value = _Object$entries5$_i[1];
                        this._djb2Map.set($4451c1f816aaeaec$var$djb2MapKey((0, $dtn6l._DJB2)(name), containerName), value);
                    }
                }
                this._overrides = newOverrides;
            }
        },
        {
            key: "setOverrides",
            value: function setOverrides(overrides) {
                this.applyOverrides(overrides);
                this.saveOverrides();
            }
        },
        {
            key: "overrideGate",
            value: function overrideGate(name, value) {
                this._overrides.gates[name] = value;
                this._djb2Map.set($4451c1f816aaeaec$var$djb2MapKey((0, $dtn6l._DJB2)(name), 'gates'), value);
                this.saveOverrides();
            }
        },
        {
            key: "removeGateOverride",
            value: function removeGateOverride(name) {
                delete this._overrides.gates[name];
                this._djb2Map.delete($4451c1f816aaeaec$var$djb2MapKey((0, $dtn6l._DJB2)(name), 'gates'));
                this.saveOverrides();
            }
        },
        {
            key: "getGateOverride",
            value: function getGateOverride(current, _user) {
                var _this$_overrides$gate;
                var overridden = (_this$_overrides$gate = this._overrides.gates[current.name]) !== null && _this$_overrides$gate !== void 0 ? _this$_overrides$gate : this._djb2Map.get($4451c1f816aaeaec$var$djb2MapKey(current.name, 'gates'));
                if (overridden == null) return null;
                return $4451c1f816aaeaec$var$_objectSpread($4451c1f816aaeaec$var$_objectSpread({}, current), {}, {
                    value: overridden,
                    details: $4451c1f816aaeaec$var$_objectSpread($4451c1f816aaeaec$var$_objectSpread({}, current.details), {}, {
                        reason: $4451c1f816aaeaec$var$LOCAL_OVERRIDE_REASON
                    })
                });
            }
        },
        {
            key: "overrideDynamicConfig",
            value: function overrideDynamicConfig(name, value) {
                this._overrides.configs[name] = value;
                this._djb2Map.set($4451c1f816aaeaec$var$djb2MapKey((0, $dtn6l._DJB2)(name), 'configs'), value);
                this.saveOverrides();
            }
        },
        {
            key: "removeDynamicConfigOverride",
            value: function removeDynamicConfigOverride(name) {
                delete this._overrides.configs[name];
                this._djb2Map.delete($4451c1f816aaeaec$var$djb2MapKey((0, $dtn6l._DJB2)(name), 'configs'));
                this.saveOverrides();
            }
        },
        {
            key: "getDynamicConfigOverride",
            value: function getDynamicConfigOverride(current, _user) {
                return this._getConfigOverride(current, this._overrides.configs);
            }
        },
        {
            key: "overrideExperiment",
            value: function overrideExperiment(name, value) {
                this._overrides.configs[name] = value;
                this._djb2Map.set($4451c1f816aaeaec$var$djb2MapKey((0, $dtn6l._DJB2)(name), 'configs'), value);
                this.saveOverrides();
            }
        },
        {
            key: "removeExperimentOverride",
            value: function removeExperimentOverride(name) {
                delete this._overrides.configs[name];
                this._djb2Map.delete($4451c1f816aaeaec$var$djb2MapKey((0, $dtn6l._DJB2)(name), 'configs'));
                this.saveOverrides();
            }
        },
        {
            key: "getExperimentOverride",
            value: function getExperimentOverride(current, _user) {
                return this._getConfigOverride(current, this._overrides.configs);
            }
        },
        {
            key: "overrideLayer",
            value: function overrideLayer(name, value) {
                this._overrides.layers[name] = value;
                this._djb2Map.set($4451c1f816aaeaec$var$djb2MapKey((0, $dtn6l._DJB2)(name), 'layers'), value);
                this.saveOverrides();
            }
        },
        {
            key: "removeLayerOverride",
            value: function removeLayerOverride(name) {
                delete this._overrides.layers[name];
                this._djb2Map.delete($4451c1f816aaeaec$var$djb2MapKey((0, $dtn6l._DJB2)(name), 'layers'));
                this.saveOverrides();
            }
        },
        {
            key: "removeAllOverrides",
            value: function removeAllOverrides() {
                this._overrides = $4451c1f816aaeaec$var$makeEmptyStore();
                try {
                    window.localStorage.removeItem(this._localStorageKey);
                } catch (_unused4) {
                // ignored - window is not defined in non-browser environments, and we don't save things there
                // (things like SSR, etc)
                }
            }
        },
        {
            key: "getLayerOverride",
            value: function getLayerOverride(current, _user) {
                var _this$_overrides$laye;
                var overridden = (_this$_overrides$laye = this._overrides.layers[current.name]) !== null && _this$_overrides$laye !== void 0 ? _this$_overrides$laye : this._djb2Map.get($4451c1f816aaeaec$var$djb2MapKey(current.name, 'layers'));
                if (overridden == null) return null;
                return $4451c1f816aaeaec$var$_objectSpread($4451c1f816aaeaec$var$_objectSpread({}, current), {}, {
                    __value: overridden,
                    get: (0, $dtn6l._makeTypedGet)(current.name, overridden),
                    details: $4451c1f816aaeaec$var$_objectSpread($4451c1f816aaeaec$var$_objectSpread({}, current.details), {}, {
                        reason: $4451c1f816aaeaec$var$LOCAL_OVERRIDE_REASON
                    })
                });
            }
        },
        {
            key: "_getConfigOverride",
            value: function _getConfigOverride(current, lookup) {
                var _lookup$current$name;
                var overridden = (_lookup$current$name = lookup[current.name]) !== null && _lookup$current$name !== void 0 ? _lookup$current$name : this._djb2Map.get($4451c1f816aaeaec$var$djb2MapKey(current.name, 'configs'));
                if (overridden == null) return null;
                return $4451c1f816aaeaec$var$_objectSpread($4451c1f816aaeaec$var$_objectSpread({}, current), {}, {
                    value: overridden,
                    get: (0, $dtn6l._makeTypedGet)(current.name, overridden),
                    details: $4451c1f816aaeaec$var$_objectSpread($4451c1f816aaeaec$var$_objectSpread({}, current.details), {}, {
                        reason: $4451c1f816aaeaec$var$LOCAL_OVERRIDE_REASON
                    })
                });
            }
        }
    ]);
}();





var $f088b11923ac7a10$var$_excluded = [
    "sdkKey",
    "environment",
    "updateUserCompletionCallback",
    "perimeter"
];
function $f088b11923ac7a10$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $f088b11923ac7a10$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $f088b11923ac7a10$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $b610cb1610902400$export$2e2bcd8739ae039)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $f088b11923ac7a10$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $f088b11923ac7a10$var$DEFAULT_CLIENT_KEY = 'client-default-key';
// default event logging api is Atlassian proxy rather than Statsig's domain, to avoid ad blockers
var $f088b11923ac7a10$var$DEFAULT_EVENT_LOGGING_API = 'https://xp.atlassian.com/v1/rgstr';
var $f088b11923ac7a10$export$1f2bb630327ac4b6 = /*#__PURE__*/ function() {
    function Client() {
        var _this = this;
        var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, _ref$localStorageKey = _ref.localStorageKey, localStorageKey = _ref$localStorageKey === void 0 ? (0, $4451c1f816aaeaec$export$d8474cff104280f3) : _ref$localStorageKey, overrideAdapter = _ref.overrideAdapter;
        (0, $fa4a4ebb2790e034$export$2e2bcd8739ae039)(this, Client);
        (0, $b610cb1610902400$export$2e2bcd8739ae039)(this, "initPromise", null);
        /** True if an initialize method was called and completed successfully. */ (0, $b610cb1610902400$export$2e2bcd8739ae039)(this, "initCompleted", false);
        /**
     * True if an initialize method was called and completed, meaning the client is now usable.
     * However if there was an error during initialization it may have initialized with default
     * values. Use {@link initCompleted} to check for this.
     */ (0, $b610cb1610902400$export$2e2bcd8739ae039)(this, "initWithDefaults", false);
        (0, $b610cb1610902400$export$2e2bcd8739ae039)(this, "hasCheckGateErrorOccurred", false);
        (0, $b610cb1610902400$export$2e2bcd8739ae039)(this, "hasGetExperimentErrorOccurred", false);
        (0, $b610cb1610902400$export$2e2bcd8739ae039)(this, "hasGetExperimentValueErrorOccurred", false);
        (0, $b610cb1610902400$export$2e2bcd8739ae039)(this, "hasGetLayerErrorOccurred", false);
        (0, $b610cb1610902400$export$2e2bcd8739ae039)(this, "hasGetLayerValueErrorOccurred", false);
        (0, $b610cb1610902400$export$2e2bcd8739ae039)(this, "subscriptions", new (0, $4af4d075add89120$export$2e2bcd8739ae039)());
        (0, $b610cb1610902400$export$2e2bcd8739ae039)(this, "dataAdapter", new (0, $5843b140d39c02ad$export$55fffef3474104af)());
        /**
     * Call this if modifying the values being served by the Statsig library since it has its own
     * memoization cache which will not be updated if the values are changed outside of the library.
     */ (0, $b610cb1610902400$export$2e2bcd8739ae039)(this, "statsigValuesUpdated", function() {
            if (_this.user) // Trigger a reset of the memoize cache
            _this.statsigClient.updateUserSync(_this.user, {
                disableBackgroundCacheRefresh: true
            });
            _this.subscriptions.anyUpdated();
        });
        this.overrideAdapter = overrideAdapter || new (0, $4451c1f816aaeaec$export$bcb28fbac1def494)(localStorageKey);
    }
    /**
   * @description
   * This method initializes the client using a network call to fetch the bootstrap values.
   * If the client is inialized with an `analyticsWebClient`, it will send an operational event
   * to GASv3 with the following attributes:
   * - targetApp: the target app of the client
   * - clientVersion: the version of the client
   * - success: whether the initialization was successful
   * - startTime: the time when the initialization started
   * - totalTime: the total time it took to initialize the client
   * - apiKey: the api key used to initialize the client
   * @param clientOptions {ClientOptions}
   * @param identifiers {Identifiers}
   * @param customAttributes {CustomAttributes}
   * @returns {Promise<void>}
   */ return (0, $ec88b65548eaad36$export$2e2bcd8739ae039)(Client, [
        {
            key: "initialize",
            value: function() {
                var _initialize = (0, $5e3499efc322ceb9$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($145d71e91ce3de54$exports))).mark(function _callee(clientOptions, identifiers, customAttributes) {
                    var _this2 = this;
                    var clientOptionsWithDefaults, startTime;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($145d71e91ce3de54$exports))).wrap(function(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                clientOptionsWithDefaults = (0, $f6fe0ba27b648ffb$export$d119b37e5f788b43)(clientOptions);
                                if (!this.initPromise) {
                                    _context.next = 1;
                                    break;
                                }
                                if (!(0, $f6fe0ba27b648ffb$export$fa1c2bbf4100b8bc)(clientOptionsWithDefaults, this.initOptions)) // eslint-disable-next-line no-console
                                console.warn('Feature Gates client already initialized with different options. New options were not applied.');
                                return _context.abrupt("return", this.initPromise);
                            case 1:
                                startTime = performance.now();
                                this.initOptions = clientOptionsWithDefaults;
                                this.initPromise = this.init(clientOptionsWithDefaults, identifiers, customAttributes).then(function() {
                                    _this2.initCompleted = true;
                                    _this2.initWithDefaults = true;
                                }).finally(function() {
                                    var endTime = performance.now();
                                    var totalTime = endTime - startTime;
                                    _this2.fireClientEvent(startTime, totalTime, 'initialize', _this2.initCompleted, clientOptionsWithDefaults.apiKey);
                                });
                                return _context.abrupt("return", this.initPromise);
                            case 2:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee, this);
                }));
                function initialize(_x, _x2, _x3) {
                    return _initialize.apply(this, arguments);
                }
                return initialize;
            }()
        },
        {
            key: "initializeWithProvider",
            value: function() {
                var _initializeWithProvider = (0, $5e3499efc322ceb9$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($145d71e91ce3de54$exports))).mark(function _callee2(clientOptions, provider, identifiers, customAttributes) {
                    var _this3 = this;
                    var clientOptionsWithDefaults, startTime;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($145d71e91ce3de54$exports))).wrap(function(_context2) {
                        while(true)switch(_context2.prev = _context2.next){
                            case 0:
                                clientOptionsWithDefaults = (0, $f6fe0ba27b648ffb$export$d119b37e5f788b43)(clientOptions);
                                if (!this.initPromise) {
                                    _context2.next = 1;
                                    break;
                                }
                                if (!(0, $f6fe0ba27b648ffb$export$fa1c2bbf4100b8bc)(clientOptionsWithDefaults, this.initOptions)) // eslint-disable-next-line no-console
                                console.warn('Feature Gates client already initialized with different options. New options were not applied.');
                                return _context2.abrupt("return", this.initPromise);
                            case 1:
                                startTime = performance.now();
                                this.initOptions = clientOptionsWithDefaults;
                                this.provider = provider;
                                this.provider.setClientVersion((0, $b65bf9cf2fa81ea9$export$a59f8d67326bd1cb));
                                if (this.provider.setApplyUpdateCallback) this.provider.setApplyUpdateCallback(this.applyUpdateCallback.bind(this));
                                this.initPromise = this.initWithProvider(clientOptionsWithDefaults, provider, identifiers, customAttributes).then(function() {
                                    _this3.initCompleted = true;
                                    _this3.initWithDefaults = true;
                                }).finally(function() {
                                    var endTime = performance.now();
                                    var totalTime = endTime - startTime;
                                    _this3.fireClientEvent(startTime, totalTime, 'initializeWithProvider', _this3.initCompleted, provider.getApiKey ? provider.getApiKey() : undefined);
                                });
                                return _context2.abrupt("return", this.initPromise);
                            case 2:
                            case "end":
                                return _context2.stop();
                        }
                    }, _callee2, this);
                }));
                function initializeWithProvider(_x4, _x5, _x6, _x7) {
                    return _initializeWithProvider.apply(this, arguments);
                }
                return initializeWithProvider;
            }()
        },
        {
            key: "applyUpdateCallback",
            value: function applyUpdateCallback(experimentsResult) {
                try {
                    if (this.initCompleted || this.initWithDefaults) {
                        this.assertInitialized(this.statsigClient);
                        this.dataAdapter.setBootstrapData(experimentsResult.experimentValues);
                        this.dataAdapter.setData(JSON.stringify(experimentsResult.experimentValues));
                        this.statsigValuesUpdated();
                    }
                } catch (error) {
                    // eslint-disable-next-line no-console
                    console.warn('Error when attempting to apply update', error);
                }
            }
        },
        {
            key: "fireClientEvent",
            value: function fireClientEvent(startTime, totalTime, action, success) {
                var _analyticsWebClient, _this4 = this;
                var apiKey = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;
                (_analyticsWebClient = this.initOptions.analyticsWebClient) === null || _analyticsWebClient === void 0 || _analyticsWebClient.then(function(analyticsWebClient) {
                    var attributes = $f088b11923ac7a10$var$_objectSpread({
                        targetApp: _this4.initOptions.targetApp,
                        clientVersion: (0, $b65bf9cf2fa81ea9$export$a59f8d67326bd1cb),
                        success: success,
                        startTime: startTime,
                        totalTime: totalTime
                    }, apiKey && {
                        apiKey: apiKey
                    });
                    analyticsWebClient.sendOperationalEvent({
                        action: action,
                        actionSubject: 'featureGatesClient',
                        attributes: attributes,
                        tags: [
                            'measurement'
                        ],
                        source: '@atlaskit/feature-gate-js-client'
                    });
                }).catch(function(err) {
                    if (_this4.initOptions.environment !== (0, $dd4a72dbf17ec6e1$export$479e7351a733299).Production) // eslint-disable-next-line no-console
                    console.error('Analytics web client promise did not resolve', err);
                });
            }
        },
        {
            key: "initializeFromValues",
            value: function() {
                var _initializeFromValues = (0, $5e3499efc322ceb9$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($145d71e91ce3de54$exports))).mark(function _callee3(clientOptions, identifiers, customAttributes) {
                    var _this5 = this;
                    var initializeValues, clientOptionsWithDefaults, startTime, _args3 = arguments;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($145d71e91ce3de54$exports))).wrap(function(_context3) {
                        while(true)switch(_context3.prev = _context3.next){
                            case 0:
                                initializeValues = _args3.length > 3 && _args3[3] !== undefined ? _args3[3] : {};
                                clientOptionsWithDefaults = (0, $f6fe0ba27b648ffb$export$d119b37e5f788b43)(clientOptions);
                                if (!this.initPromise) {
                                    _context3.next = 1;
                                    break;
                                }
                                if (!(0, $f6fe0ba27b648ffb$export$fa1c2bbf4100b8bc)(clientOptionsWithDefaults, this.initOptions)) // eslint-disable-next-line no-console
                                console.warn('Feature Gates client already initialized with different options. New options were not applied.');
                                return _context3.abrupt("return", this.initPromise);
                            case 1:
                                // This makes sure the new Statsig client behaves like the old when bootstrap data is
                                // passed, and `has_updates` isn't specified (which happens a lot in product integration tests).
                                if (!Object.prototype.hasOwnProperty.call(initializeValues, 'has_updates')) initializeValues['has_updates'] = true;
                                startTime = performance.now();
                                this.initOptions = clientOptionsWithDefaults;
                                this.initPromise = this.initFromValues(clientOptionsWithDefaults, identifiers, customAttributes, initializeValues).then(function() {
                                    _this5.initCompleted = true;
                                    _this5.initWithDefaults = true;
                                }).finally(function() {
                                    var endTime = performance.now();
                                    var totalTime = endTime - startTime;
                                    _this5.fireClientEvent(startTime, totalTime, 'initializeFromValues', _this5.initCompleted);
                                });
                                return _context3.abrupt("return", this.initPromise);
                            case 2:
                            case "end":
                                return _context3.stop();
                        }
                    }, _callee3, this);
                }));
                function initializeFromValues(_x8, _x9, _x0) {
                    return _initializeFromValues.apply(this, arguments);
                }
                return initializeFromValues;
            }()
        },
        {
            key: "assertInitialized",
            value: function assertInitialized(statsigClient) {
                if (!statsigClient) throw new Error('Client must be initialized before using this method');
            }
        },
        {
            key: "updateUser",
            value: function() {
                var _updateUser = (0, $5e3499efc322ceb9$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($145d71e91ce3de54$exports))).mark(function _callee4(fetchOptions, identifiers, customAttributes) {
                    var fetchOptionsWithDefaults, initializeValuesProducer;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($145d71e91ce3de54$exports))).wrap(function(_context4) {
                        while(true)switch(_context4.prev = _context4.next){
                            case 0:
                                this.assertInitialized(this.statsigClient);
                                fetchOptionsWithDefaults = (0, $f6fe0ba27b648ffb$export$d119b37e5f788b43)(fetchOptions);
                                initializeValuesProducer = function initializeValuesProducer() {
                                    return (0, $bd1659229942a780$export$2e2bcd8739ae039).fetchExperimentValues(fetchOptionsWithDefaults, identifiers, customAttributes).then(function(_ref2) {
                                        var experimentValues = _ref2.experimentValues, customAttributes = _ref2.customAttributes;
                                        return {
                                            experimentValues: experimentValues,
                                            customAttributesFromFetch: customAttributes
                                        };
                                    });
                                };
                                _context4.next = 1;
                                return this.updateUserUsingInitializeValuesProducer(initializeValuesProducer, identifiers, customAttributes);
                            case 1:
                            case "end":
                                return _context4.stop();
                        }
                    }, _callee4, this);
                }));
                function updateUser(_x1, _x10, _x11) {
                    return _updateUser.apply(this, arguments);
                }
                return updateUser;
            }()
        },
        {
            key: "updateUserWithProvider",
            value: function() {
                var _updateUserWithProvider = (0, $5e3499efc322ceb9$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($145d71e91ce3de54$exports))).mark(function _callee5(identifiers, customAttributes) {
                    var _this6 = this;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($145d71e91ce3de54$exports))).wrap(function(_context5) {
                        while(true)switch(_context5.prev = _context5.next){
                            case 0:
                                this.assertInitialized(this.statsigClient);
                                if (this.provider) {
                                    _context5.next = 1;
                                    break;
                                }
                                throw new Error('Cannot update user using provider as the client was not initialised with a provider');
                            case 1:
                                _context5.next = 2;
                                return this.provider.setProfile(this.initOptions, identifiers, customAttributes);
                            case 2:
                                _context5.next = 3;
                                return this.updateUserUsingInitializeValuesProducer(function() {
                                    return _this6.provider.getExperimentValues();
                                }, identifiers, customAttributes);
                            case 3:
                            case "end":
                                return _context5.stop();
                        }
                    }, _callee5, this);
                }));
                function updateUserWithProvider(_x12, _x13) {
                    return _updateUserWithProvider.apply(this, arguments);
                }
                return updateUserWithProvider;
            }()
        },
        {
            key: "updateUserWithValues",
            value: function() {
                var _updateUserWithValues = (0, $5e3499efc322ceb9$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($145d71e91ce3de54$exports))).mark(function _callee6(identifiers, customAttributes) {
                    var initializeValues, initializeValuesProducer, _args6 = arguments;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($145d71e91ce3de54$exports))).wrap(function(_context6) {
                        while(true)switch(_context6.prev = _context6.next){
                            case 0:
                                initializeValues = _args6.length > 2 && _args6[2] !== undefined ? _args6[2] : {};
                                this.assertInitialized(this.statsigClient);
                                initializeValuesProducer = function initializeValuesProducer() {
                                    return Promise.resolve({
                                        experimentValues: initializeValues,
                                        customAttributesFromFetch: customAttributes
                                    });
                                };
                                _context6.next = 1;
                                return this.updateUserUsingInitializeValuesProducer(initializeValuesProducer, identifiers, customAttributes);
                            case 1:
                            case "end":
                                return _context6.stop();
                        }
                    }, _callee6, this);
                }));
                function updateUserWithValues(_x14, _x15) {
                    return _updateUserWithValues.apply(this, arguments);
                }
                return updateUserWithValues;
            }()
        },
        {
            key: "initializeCalled",
            value: function initializeCalled() {
                return this.initPromise != null;
            }
        },
        {
            key: "initializeCompleted",
            value: function initializeCompleted() {
                return this.initCompleted;
            }
        },
        {
            key: "waitUntilInitializeCompleted",
            value: function() {
                var _waitUntilInitializeCompleted = (0, $5e3499efc322ceb9$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($145d71e91ce3de54$exports))).mark(function _callee7() {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($145d71e91ce3de54$exports))).wrap(function(_context7) {
                        while(true)switch(_context7.prev = _context7.next){
                            case 0:
                                if (this.initPromise) {
                                    _context7.next = 1;
                                    break;
                                }
                                throw new Error('The client must be initialized before you can wait until initialized.');
                            case 1:
                                if (!this.initCompleted) {
                                    _context7.next = 2;
                                    break;
                                }
                                return _context7.abrupt("return");
                            case 2:
                                _context7.next = 3;
                                return this.initPromise;
                            case 3:
                            case "end":
                                return _context7.stop();
                        }
                    }, _callee7, this);
                }));
                function waitUntilInitializeCompleted() {
                    return _waitUntilInitializeCompleted.apply(this, arguments);
                }
                return waitUntilInitializeCompleted;
            }()
        },
        {
            key: "checkGate",
            value: function checkGate(gateName) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                try {
                    this.assertInitialized(this.statsigClient);
                    var _options$fireGateExpo = options.fireGateExposure, fireGateExposure = _options$fireGateExpo === void 0 ? true : _options$fireGateExpo;
                    return this.statsigClient.checkGate(gateName, {
                        disableExposureLog: !fireGateExposure
                    });
                } catch (error) {
                    // Log the first occurrence of the error
                    if (!this.hasCheckGateErrorOccurred) {
                        // eslint-disable-next-line no-console
                        console.warn({
                            msg: 'An error has occurred checking the feature gate. Only the first occurrence of this error is logged.',
                            gateName: gateName,
                            error: error
                        });
                        this.hasCheckGateErrorOccurred = true;
                    }
                    return false;
                }
            }
        },
        {
            key: "isGateExist",
            value: function isGateExist(gateName) {
                try {
                    this.assertInitialized(this.statsigClient);
                    var gate = this.statsigClient.getFeatureGate(gateName, {
                        disableExposureLog: true
                    });
                    return !gate.details.reason.includes('Unrecognized');
                } catch (error) {
                    // eslint-disable-next-line no-console
                    console.error("Error occurred when trying to check FeatureGate: ".concat(error));
                    // in case of error report true to avoid false positives.
                    return true;
                }
            }
        },
        {
            key: "isExperimentExist",
            value: function isExperimentExist(experimentName) {
                try {
                    this.assertInitialized(this.statsigClient);
                    var config = this.statsigClient.getExperiment(experimentName, {
                        disableExposureLog: true
                    });
                    return !config.details.reason.includes('Unrecognized');
                } catch (error) {
                    // eslint-disable-next-line no-console
                    console.error("Error occurred when trying to check Experiment: ".concat(error));
                    // in case of error report true to avoid false positives.
                    return true;
                }
            }
        },
        {
            key: "manuallyLogGateExposure",
            value: function manuallyLogGateExposure(gateName) {
                this.assertInitialized(this.statsigClient);
                // This is the approach recommended in the docs
                // https://docs.statsig.com/client/javascript-sdk/#manual-exposures-
                this.statsigClient.checkGate(gateName);
            }
        },
        {
            key: "getExperiment",
            value: function getExperiment(experimentName) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                try {
                    this.assertInitialized(this.statsigClient);
                    var _options$fireExperime = options.fireExperimentExposure, fireExperimentExposure = _options$fireExperime === void 0 ? true : _options$fireExperime;
                    return (0, $6591b796a8a09f36$export$6dc24881a3d96325).fromExperiment(this.statsigClient.getExperiment(experimentName, {
                        disableExposureLog: !fireExperimentExposure
                    }));
                } catch (error) {
                    // Log the first occurrence of the error
                    if (!this.hasGetExperimentErrorOccurred) {
                        // eslint-disable-next-line no-console
                        console.warn({
                            msg: 'An error has occurred getting the experiment. Only the first occurrence of this error is logged.',
                            experimentName: experimentName,
                            error: error
                        });
                        this.hasGetExperimentErrorOccurred = true;
                    }
                    // Return a default value
                    return new (0, $6591b796a8a09f36$export$6dc24881a3d96325)(experimentName, {}, '', {
                        time: Date.now(),
                        reason: (0, $9ea837099c79ccfa$export$c62558b199e46828).Error
                    });
                }
            }
        },
        {
            key: "getExperimentValue",
            value: function getExperimentValue(experimentName, parameterName, defaultValue) {
                var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var experiment = this.getExperiment(experimentName, options);
                try {
                    var typeGuard = options.typeGuard;
                    return experiment.get(parameterName, defaultValue, typeGuard);
                } catch (error) {
                    // Log the first occurrence of the error
                    if (!this.hasGetExperimentValueErrorOccurred) {
                        // eslint-disable-next-line no-console
                        console.warn({
                            msg: 'An error has occurred getting the experiment value. Only the first occurrence of this error is logged.',
                            experimentName: experimentName,
                            defaultValue: defaultValue,
                            options: options,
                            error: error
                        });
                        this.hasGetExperimentValueErrorOccurred = true;
                    }
                    return defaultValue;
                }
            }
        },
        {
            key: "manuallyLogExperimentExposure",
            value: function manuallyLogExperimentExposure(experimentName) {
                this.assertInitialized(this.statsigClient);
                // This is the approach recommended in the docs
                // https://docs.statsig.com/client/javascript-sdk/#manual-exposures-
                this.statsigClient.getExperiment(experimentName);
            }
        },
        {
            key: "manuallyLogLayerExposure",
            value: function manuallyLogLayerExposure(layerName, parameterName) {
                var _this$statsigClient$g;
                this.assertInitialized(this.statsigClient);
                // This is the approach recommended in the docs
                // https://docs.statsig.com/client/javascript-sdk/#manual-exposures-
                (_this$statsigClient$g = this.statsigClient.getLayer(layerName)) === null || _this$statsigClient$g === void 0 || _this$statsigClient$g.get(parameterName);
            }
        },
        {
            key: "shutdownStatsig",
            value: function shutdownStatsig() {
                this.assertInitialized(this.statsigClient);
                this.statsigClient.shutdown();
            }
        },
        {
            key: "overrideGate",
            value: function overrideGate(gateName, value) {
                this.overrideAdapter.overrideGate(gateName, value);
                // Trigger a reset of the memoized gate value
                if (this.user) {
                    var _this$statsigClient;
                    (_this$statsigClient = this.statsigClient) === null || _this$statsigClient === void 0 || _this$statsigClient.updateUserSync(this.user, {
                        disableBackgroundCacheRefresh: true
                    });
                }
                this.statsigValuesUpdated();
            }
        },
        {
            key: "clearGateOverride",
            value: function clearGateOverride(gateName) {
                this.overrideAdapter.removeGateOverride(gateName);
                this.statsigValuesUpdated();
            }
        },
        {
            key: "overrideConfig",
            value: function overrideConfig(experimentName, values) {
                this.overrideAdapter.overrideDynamicConfig(experimentName, values);
                this.statsigValuesUpdated();
            }
        },
        {
            key: "clearConfigOverride",
            value: function clearConfigOverride(experimentName) {
                this.overrideAdapter.removeDynamicConfigOverride(experimentName);
                this.statsigValuesUpdated();
            }
        },
        {
            key: "setOverrides",
            value: function setOverrides(overrides) {
                this.overrideAdapter.setOverrides(overrides);
                this.statsigValuesUpdated();
            }
        },
        {
            key: "getOverrides",
            value: function getOverrides() {
                return this.overrideAdapter.getOverrides();
            }
        },
        {
            key: "clearAllOverrides",
            value: function clearAllOverrides() {
                this.overrideAdapter.removeAllOverrides();
                this.statsigValuesUpdated();
            }
        },
        {
            key: "isCurrentUser",
            value: function isCurrentUser(identifiers, customAttributes) {
                return (0, $f6fe0ba27b648ffb$export$fa1c2bbf4100b8bc)(this.currentIdentifiers, identifiers) && (0, $f6fe0ba27b648ffb$export$fa1c2bbf4100b8bc)(this.currentAttributes, customAttributes);
            }
        },
        {
            key: "onGateUpdated",
            value: function onGateUpdated(gateName, callback) {
                var _this7 = this;
                var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                var wrapCallback = function wrapCallback(value) {
                    var _options$fireGateExpo2 = options.fireGateExposure, fireGateExposure = _options$fireGateExpo2 === void 0 ? true : _options$fireGateExpo2;
                    if (fireGateExposure) _this7.manuallyLogGateExposure(gateName);
                    try {
                        callback(value);
                    } catch (error) {
                        // eslint-disable-next-line no-console
                        console.warn("Error calling callback for gate ".concat(gateName, " with value ").concat(value), error);
                    }
                };
                return this.subscriptions.onGateUpdated(gateName, wrapCallback, this.checkGate.bind(this), options);
            }
        },
        {
            key: "onExperimentValueUpdated",
            value: function onExperimentValueUpdated(experimentName, parameterName, defaultValue, callback) {
                var _this8 = this;
                var options = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
                var wrapCallback = function wrapCallback(value) {
                    var _options$fireExperime2 = options.fireExperimentExposure, fireExperimentExposure = _options$fireExperime2 === void 0 ? true : _options$fireExperime2;
                    if (fireExperimentExposure) _this8.manuallyLogExperimentExposure(experimentName);
                    try {
                        callback(value);
                    } catch (error) {
                        // eslint-disable-next-line no-console
                        console.warn("Error calling callback for experiment ".concat(experimentName, " with value ").concat(value), error);
                    }
                };
                return this.subscriptions.onExperimentValueUpdated(experimentName, parameterName, defaultValue, wrapCallback, this.getExperimentValue.bind(this), options);
            }
        },
        {
            key: "onAnyUpdated",
            value: function onAnyUpdated(callback) {
                return this.subscriptions.onAnyUpdated(callback);
            }
        },
        {
            key: "init",
            value: function() {
                var _init = (0, $5e3499efc322ceb9$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($145d71e91ce3de54$exports))).mark(function _callee8(clientOptions, identifiers, customAttributes) {
                    var fromValuesClientOptions, experimentValues, customAttributesFromResult, clientSdkKeyPromise, experimentValuesPromise, _yield$Promise$all, _yield$Promise$all2, experimentValuesResult, _t;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($145d71e91ce3de54$exports))).wrap(function(_context8) {
                        while(true)switch(_context8.prev = _context8.next){
                            case 0:
                                fromValuesClientOptions = $f088b11923ac7a10$var$_objectSpread({}, clientOptions);
                                if (!clientOptions.localMode) {
                                    _context8.next = 2;
                                    break;
                                }
                                _context8.next = 1;
                                return this.initFromValues(fromValuesClientOptions, identifiers, customAttributes);
                            case 1:
                                return _context8.abrupt("return");
                            case 2:
                                _context8.prev = 2;
                                // If client sdk key fetch fails, an error would be thrown and handled instead of waiting for
                                // the experiment values request to be settled, and it will fall back to use default values.
                                clientSdkKeyPromise = (0, $bd1659229942a780$export$2e2bcd8739ae039).fetchClientSdk(clientOptions).then(function(value) {
                                    return fromValuesClientOptions.sdkKey = value.clientSdkKey;
                                });
                                experimentValuesPromise = (0, $bd1659229942a780$export$2e2bcd8739ae039).fetchExperimentValues(clientOptions, identifiers, customAttributes); // Only wait for the experiment values request to finish and try to initialise the client
                                // with experiment values if both requests are successful. Else an error would be thrown and
                                // handled by the catch
                                _context8.next = 3;
                                return Promise.all([
                                    clientSdkKeyPromise,
                                    experimentValuesPromise
                                ]);
                            case 3:
                                _yield$Promise$all = _context8.sent;
                                _yield$Promise$all2 = (0, $4f293317ede17766$export$2e2bcd8739ae039)(_yield$Promise$all, 2);
                                experimentValuesResult = _yield$Promise$all2[1];
                                experimentValues = experimentValuesResult.experimentValues;
                                customAttributesFromResult = experimentValuesResult.customAttributes;
                                _context8.next = 6;
                                break;
                            case 4:
                                _context8.prev = 4;
                                _t = _context8["catch"](2);
                                if (_t instanceof Error) // eslint-disable-next-line no-console
                                console.error("Error occurred when trying to fetch the Feature Gates client values, error: ".concat(_t === null || _t === void 0 ? void 0 : _t.message));
                                // eslint-disable-next-line no-console
                                console.warn("Initialising Statsig client without values");
                                _context8.next = 5;
                                return this.initFromValues(fromValuesClientOptions, identifiers, customAttributes);
                            case 5:
                                throw _t;
                            case 6:
                                return _context8.abrupt("return", this.initFromValues(fromValuesClientOptions, identifiers, customAttributesFromResult, experimentValues));
                            case 7:
                            case "end":
                                return _context8.stop();
                        }
                    }, _callee8, this, [
                        [
                            2,
                            4
                        ]
                    ]);
                }));
                function init(_x16, _x17, _x18) {
                    return _init.apply(this, arguments);
                }
                return init;
            }()
        },
        {
            key: "initWithProvider",
            value: function() {
                var _initWithProvider = (0, $5e3499efc322ceb9$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($145d71e91ce3de54$exports))).mark(function _callee9(baseClientOptions, provider, identifiers, customAttributes) {
                    var fromValuesClientOptions, experimentValues, customAttributesFromResult, clientSdkKeyPromise, experimentValuesPromise, _yield$Promise$all3, _yield$Promise$all4, experimentValuesResult, _t2;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($145d71e91ce3de54$exports))).wrap(function(_context9) {
                        while(true)switch(_context9.prev = _context9.next){
                            case 0:
                                fromValuesClientOptions = $f088b11923ac7a10$var$_objectSpread($f088b11923ac7a10$var$_objectSpread({}, baseClientOptions), {}, {
                                    disableCurrentPageLogging: true
                                });
                                _context9.prev = 1;
                                _context9.next = 2;
                                return provider.setProfile(baseClientOptions, identifiers, customAttributes);
                            case 2:
                                // If client sdk key fetch fails, an error would be thrown and handled instead of waiting for
                                // the experiment values request to be settled, and it will fall back to use default values.
                                clientSdkKeyPromise = provider.getClientSdkKey().then(function(value) {
                                    return fromValuesClientOptions.sdkKey = value;
                                });
                                experimentValuesPromise = provider.getExperimentValues(); // Only wait for the experiment values request to finish and try to initialise the client
                                // with experiment values if both requests are successful. Else an error would be thrown and
                                // handled by the catch
                                _context9.next = 3;
                                return Promise.all([
                                    clientSdkKeyPromise,
                                    experimentValuesPromise
                                ]);
                            case 3:
                                _yield$Promise$all3 = _context9.sent;
                                _yield$Promise$all4 = (0, $4f293317ede17766$export$2e2bcd8739ae039)(_yield$Promise$all3, 2);
                                experimentValuesResult = _yield$Promise$all4[1];
                                experimentValues = experimentValuesResult.experimentValues;
                                customAttributesFromResult = experimentValuesResult.customAttributesFromFetch;
                                _context9.next = 6;
                                break;
                            case 4:
                                _context9.prev = 4;
                                _t2 = _context9["catch"](1);
                                if (_t2 instanceof Error) // eslint-disable-next-line no-console
                                console.error("Error occurred when trying to fetch the Feature Gates client values, error: ".concat(_t2 === null || _t2 === void 0 ? void 0 : _t2.message));
                                // eslint-disable-next-line no-console
                                console.warn("Initialising Statsig client without values");
                                _context9.next = 5;
                                return this.initFromValues(fromValuesClientOptions, identifiers, customAttributes);
                            case 5:
                                throw _t2;
                            case 6:
                                return _context9.abrupt("return", this.initFromValues(fromValuesClientOptions, identifiers, customAttributesFromResult, experimentValues));
                            case 7:
                            case "end":
                                return _context9.stop();
                        }
                    }, _callee9, this, [
                        [
                            1,
                            4
                        ]
                    ]);
                }));
                function initWithProvider(_x19, _x20, _x21, _x22) {
                    return _initWithProvider.apply(this, arguments);
                }
                return initWithProvider;
            }()
        },
        {
            key: "initFromValues",
            value: function() {
                var _initFromValues = (0, $5e3499efc322ceb9$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($145d71e91ce3de54$exports))).mark(function _callee0(clientOptions, identifiers, customAttributes) {
                    var _newClientOptions$net;
                    var initializeValues, newClientOptions, sdkKey, environment, _updateUserCompletionCallback, _perimeter, restClientOptions, frontendUser, statsigOptions, _args0 = arguments, _t3;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($145d71e91ce3de54$exports))).wrap(function(_context0) {
                        while(true)switch(_context0.prev = _context0.next){
                            case 0:
                                initializeValues = _args0.length > 3 && _args0[3] !== undefined ? _args0[3] : {};
                                this.overrideAdapter.initFromStoredOverrides();
                                this.currentIdentifiers = identifiers;
                                this.currentAttributes = customAttributes;
                                newClientOptions = (0, $f6fe0ba27b648ffb$export$202946b690d26d22)(clientOptions);
                                if (!newClientOptions.sdkKey) newClientOptions.sdkKey = $f088b11923ac7a10$var$DEFAULT_CLIENT_KEY;
                                if (!((_newClientOptions$net = newClientOptions.networkConfig) !== null && _newClientOptions$net !== void 0 && _newClientOptions$net.logEventUrl)) newClientOptions.networkConfig = $f088b11923ac7a10$var$_objectSpread($f088b11923ac7a10$var$_objectSpread({}, newClientOptions.networkConfig), {}, {
                                    logEventUrl: $f088b11923ac7a10$var$DEFAULT_EVENT_LOGGING_API
                                });
                                if (newClientOptions.perimeter === (0, $dd4a72dbf17ec6e1$export$c42b7bbc5e7ba555).FEDRAMP_MODERATE) // disable all logging in FedRAMP to prevent egress of sensitive data
                                newClientOptions.disableLogging = true;
                                sdkKey = newClientOptions.sdkKey, environment = newClientOptions.environment, _updateUserCompletionCallback = newClientOptions.updateUserCompletionCallback, _perimeter = newClientOptions.perimeter, restClientOptions = (0, $f9613085755b341d$export$2e2bcd8739ae039)(newClientOptions, $f088b11923ac7a10$var$_excluded);
                                frontendUser = (0, $f6fe0ba27b648ffb$export$3dad1db244472f32)(identifiers, customAttributes);
                                this.user = (0, $f6fe0ba27b648ffb$export$1148cb79ceecd5fa)({}, initializeValues.user, frontendUser);
                                statsigOptions = $f088b11923ac7a10$var$_objectSpread($f088b11923ac7a10$var$_objectSpread({}, restClientOptions), {}, {
                                    environment: {
                                        tier: environment
                                    },
                                    includeCurrentPageUrlWithEvents: false,
                                    dataAdapter: this.dataAdapter,
                                    overrideAdapter: this.overrideAdapter,
                                    logEventCompressionMode: (0, $iFR7a.LogEventCompressionMode).Forced
                                }); // Statsig validates the provided stableId against their own cookie, so we either need
                                // to update the cookie to match, or disable the validation completely.
                                if (identifiers.stableId) (0, $iFR7a.StableID).setOverride(identifiers.stableId, sdkKey);
                                else statsigOptions.disableStableID = true;
                                _context0.prev = 1;
                                this.statsigClient = new (0, $iFR7a.StatsigClient)(sdkKey, this.user, statsigOptions);
                                this.dataAdapter.setBootstrapData(initializeValues);
                                _context0.next = 2;
                                return this.statsigClient.initializeAsync();
                            case 2:
                                _context0.next = 5;
                                break;
                            case 3:
                                _context0.prev = 3;
                                _t3 = _context0["catch"](1);
                                if (_t3 instanceof Error) // eslint-disable-next-line no-console
                                console.error("Error occurred when trying to initialise the Statsig client, error: ".concat(_t3 === null || _t3 === void 0 ? void 0 : _t3.message));
                                // eslint-disable-next-line no-console
                                console.warn("Initialising Statsig client with default sdk key and without values");
                                this.statsigClient = new (0, $iFR7a.StatsigClient)($f088b11923ac7a10$var$DEFAULT_CLIENT_KEY, this.user, statsigOptions);
                                this.dataAdapter.setBootstrapData();
                                _context0.next = 4;
                                return this.statsigClient.initializeAsync();
                            case 4:
                                this.initWithDefaults = true;
                                throw _t3;
                            case 5:
                            case "end":
                                return _context0.stop();
                        }
                    }, _callee0, this, [
                        [
                            1,
                            3
                        ]
                    ]);
                }));
                function initFromValues(_x23, _x24, _x25) {
                    return _initFromValues.apply(this, arguments);
                }
                return initFromValues;
            }()
        },
        {
            key: "updateUserUsingInitializeValuesProducer",
            value: function() {
                var _updateUserUsingInitializeValuesProducer = (0, $5e3499efc322ceb9$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($145d71e91ce3de54$exports))).mark(function _callee10(getInitializeValues, identifiers, customAttributes) {
                    var _this9 = this;
                    var originalInitPromise, initializeValuesPromise, updateUserPromise, _t4;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($145d71e91ce3de54$exports))).wrap(function(_context10) {
                        while(true)switch(_context10.prev = _context10.next){
                            case 0:
                                this.assertInitialized(this.statsigClient);
                                if (this.initPromise) {
                                    _context10.next = 1;
                                    break;
                                }
                                throw new Error('The client must be initialized before you can update the user.');
                            case 1:
                                if (!this.isCurrentUser(identifiers, customAttributes)) {
                                    _context10.next = 2;
                                    break;
                                }
                                return _context10.abrupt("return", this.initPromise);
                            case 2:
                                // Wait for the current initialize/update to finish
                                originalInitPromise = this.initPromise;
                                _context10.prev = 3;
                                _context10.next = 4;
                                return this.initPromise;
                            case 4:
                                _context10.next = 6;
                                break;
                            case 5:
                                _context10.prev = 5;
                                _t4 = _context10["catch"](3);
                            case 6:
                                initializeValuesPromise = getInitializeValues();
                                updateUserPromise = this.updateStatsigClientUser(initializeValuesPromise, identifiers, customAttributes); // We replace the init promise here since we are essentially re-initializing the client at this
                                // point. Any subsequent calls to await client.initialize() or client.updateUser()
                                // will now also await this user update.
                                this.initPromise = updateUserPromise.catch(/*#__PURE__*/ (0, $5e3499efc322ceb9$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($145d71e91ce3de54$exports))).mark(function _callee1() {
                                    return (0, (/*@__PURE__*/$parcel$interopDefault($145d71e91ce3de54$exports))).wrap(function(_context1) {
                                        while(true)switch(_context1.prev = _context1.next){
                                            case 0:
                                                // If the update failed then it changed nothing, so revert back to the original promise.
                                                _this9.initPromise = originalInitPromise;
                                                // Set the user profile again to revert back to the current user
                                                if (!_this9.provider) {
                                                    _context1.next = 1;
                                                    break;
                                                }
                                                _context1.next = 1;
                                                return _this9.provider.setProfile(_this9.initOptions, _this9.currentIdentifiers, _this9.currentAttributes);
                                            case 1:
                                            case "end":
                                                return _context1.stop();
                                        }
                                    }, _callee1);
                                })));
                                return _context10.abrupt("return", updateUserPromise);
                            case 7:
                            case "end":
                                return _context10.stop();
                        }
                    }, _callee10, this, [
                        [
                            3,
                            5
                        ]
                    ]);
                }));
                function updateUserUsingInitializeValuesProducer(_x26, _x27, _x28) {
                    return _updateUserUsingInitializeValuesProducer.apply(this, arguments);
                }
                return updateUserUsingInitializeValuesProducer;
            }()
        },
        {
            key: "updateStatsigClientUser",
            value: function() {
                var _updateStatsigClientUser = (0, $5e3499efc322ceb9$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($145d71e91ce3de54$exports))).mark(function _callee11(initializeValuesPromise, identifiers, customAttributes) {
                    var _this$initOptions, _this$initOptions$upd;
                    var initializeValues, user, frontendUser, _updateUserCompletion, _ref4, errMsg, success, errorMessage, _t5, _t6;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($145d71e91ce3de54$exports))).wrap(function(_context11) {
                        while(true)switch(_context11.prev = _context11.next){
                            case 0:
                                this.assertInitialized(this.statsigClient);
                                _context11.prev = 1;
                                _context11.next = 2;
                                return initializeValuesPromise;
                            case 2:
                                initializeValues = _context11.sent;
                                frontendUser = (0, $f6fe0ba27b648ffb$export$3dad1db244472f32)(identifiers, initializeValues.customAttributesFromFetch);
                                user = (0, $f6fe0ba27b648ffb$export$1148cb79ceecd5fa)({}, initializeValues.experimentValues.user, frontendUser);
                                _context11.next = 4;
                                break;
                            case 3:
                                _context11.prev = 3;
                                _t5 = _context11["catch"](1);
                                // Make sure the updateUserCompletionCallback is called for any errors in our custom code.
                                // This is not necessary for the updateUserWithValues call, because the Statsig client will
                                // already invoke the callback itself.
                                errMsg = _t5 instanceof Error ? _t5.message : JSON.stringify(_t5);
                                (_updateUserCompletion = (_ref4 = this.initOptions).updateUserCompletionCallback) === null || _updateUserCompletion === void 0 || _updateUserCompletion.call(_ref4, false, errMsg);
                                throw _t5;
                            case 4:
                                success = true;
                                errorMessage = null;
                                _context11.prev = 5;
                                this.dataAdapter.setBootstrapData(initializeValues.experimentValues);
                                this.user = user;
                                if (!this.user) {
                                    _context11.next = 6;
                                    break;
                                }
                                _context11.next = 6;
                                return this.statsigClient.updateUserAsync(this.user);
                            case 6:
                                _context11.next = 8;
                                break;
                            case 7:
                                _context11.prev = 7;
                                _t6 = _context11["catch"](5);
                                success = false;
                                errorMessage = String(_t6);
                            case 8:
                                (_this$initOptions = this.initOptions) === null || _this$initOptions === void 0 || (_this$initOptions$upd = _this$initOptions.updateUserCompletionCallback) === null || _this$initOptions$upd === void 0 || _this$initOptions$upd.call(_this$initOptions, success, errorMessage);
                                if (!success) {
                                    _context11.next = 9;
                                    break;
                                }
                                this.currentIdentifiers = identifiers;
                                this.currentAttributes = customAttributes;
                                this.subscriptions.anyUpdated();
                                _context11.next = 10;
                                break;
                            case 9:
                                throw new Error('Failed to update user. An unexpected error occured.');
                            case 10:
                            case "end":
                                return _context11.stop();
                        }
                    }, _callee11, this, [
                        [
                            1,
                            3
                        ],
                        [
                            5,
                            7
                        ]
                    ]);
                }));
                function updateStatsigClientUser(_x29, _x30, _x31) {
                    return _updateStatsigClientUser.apply(this, arguments);
                }
                return updateStatsigClientUser;
            }()
        },
        {
            key: "getPackageVersion",
            value: /**
     * @returns string version of the current package in semver style.
     */ function getPackageVersion() {
                return 0, $b65bf9cf2fa81ea9$export$a59f8d67326bd1cb;
            }
        },
        {
            key: "getTargetApp",
            value: function getTargetApp() {
                var _this$initOptions2;
                return (_this$initOptions2 = this.initOptions) === null || _this$initOptions2 === void 0 ? void 0 : _this$initOptions2.targetApp;
            }
        },
        {
            key: "getLayer",
            value: function getLayer(/** The name of the layer */ layerName) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                try {
                    this.assertInitialized(this.statsigClient);
                    var _options$fireLayerExp = options.fireLayerExposure, fireLayerExposure = _options$fireLayerExp === void 0 ? true : _options$fireLayerExp;
                    return (0, $32078069de191bb3$export$936d0764594b6eb3).fromLayer(this.statsigClient.getLayer(layerName, {
                        disableExposureLog: !fireLayerExposure
                    }));
                } catch (error) {
                    // Log the first occurrence of the error
                    if (!this.hasGetLayerErrorOccurred) {
                        // eslint-disable-next-line no-console
                        console.warn({
                            msg: 'An error has occurred getting the layer. Only the first occurrence of this error is logged.',
                            layerName: layerName,
                            error: error
                        });
                        this.hasGetLayerErrorOccurred = true;
                    }
                    // Return a default value
                    return (0, $32078069de191bb3$export$936d0764594b6eb3).fromLayer((0, $iFR7a._makeLayer)(layerName, {
                        reason: 'Error'
                    }, null));
                }
            }
        },
        {
            key: "getLayerValue",
            value: function getLayerValue(layerName, parameterName, defaultValue) {
                var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var layer = this.getLayer(layerName, options);
                try {
                    var typeGuard = options.typeGuard;
                    return layer.get(parameterName, defaultValue, typeGuard);
                } catch (error) {
                    // Log the first occurrence of the error
                    if (!this.hasGetLayerValueErrorOccurred) {
                        // eslint-disable-next-line no-console
                        console.warn({
                            msg: 'An error has occurred getting the layer value. Only the first occurrence of this error is logged.',
                            layerName: layerName,
                            defaultValue: defaultValue,
                            options: options,
                            error: error
                        });
                        this.hasGetLayerValueErrorOccurred = true;
                    }
                    return defaultValue;
                }
            }
        }
    ]);
}();






var $2fca4a116c89e45a$var$_FeatureGates;
/**
 * Access the FeatureGates object via the default export.
 * ```ts
 * import FeatureGates from '@atlaskit/feature-gate-js-client';
 * ```
 */ var $2fca4a116c89e45a$var$FeatureGates = /*#__PURE__*/ function() {
    function FeatureGates() {
        (0, $fa4a4ebb2790e034$export$2e2bcd8739ae039)(this, FeatureGates);
    }
    return (0, $ec88b65548eaad36$export$2e2bcd8739ae039)(FeatureGates, null, [
        {
            key: "isGateExists",
            value: function isGateExists(gateName) {
                return this.client.isGateExist(gateName);
            }
        },
        {
            key: "isExperimentExists",
            value: function isExperimentExists(experimentName) {
                return this.client.isExperimentExist(experimentName);
            }
        }
    ]);
}();
$2fca4a116c89e45a$var$_FeatureGates = $2fca4a116c89e45a$var$FeatureGates;
(0, $b610cb1610902400$export$2e2bcd8739ae039)($2fca4a116c89e45a$var$FeatureGates, "client", new (0, $f088b11923ac7a10$export$1f2bb630327ac4b6)());
(0, $b610cb1610902400$export$2e2bcd8739ae039)($2fca4a116c89e45a$var$FeatureGates, "hasCheckGateErrorOccurred", false);
(0, $b610cb1610902400$export$2e2bcd8739ae039)($2fca4a116c89e45a$var$FeatureGates, "hasGetExperimentValueErrorOccurred", false);
(0, $b610cb1610902400$export$2e2bcd8739ae039)($2fca4a116c89e45a$var$FeatureGates, "checkGate", function(gateName, options) {
    try {
        // Check if the CRITERION override mechanism is available
        if (typeof window !== 'undefined' && window.__CRITERION__ && typeof window.__CRITERION__.getFeatureFlagOverride === 'function') {
            // Attempt to retrieve an override value for the feature gate
            var overrideValue = window.__CRITERION__.getFeatureFlagOverride(gateName);
            // If an override value is found, return it immediately
            if (overrideValue !== undefined) return overrideValue;
        }
    } catch (error) {
        // Log the first occurrence of the error
        if (!$2fca4a116c89e45a$var$_FeatureGates.hasCheckGateErrorOccurred) {
            // eslint-disable-next-line no-console
            console.warn({
                msg: 'An error has occurred checking the feature gate from criterion override. Only the first occurrence of this error is logged.',
                gateName: gateName,
                error: error
            });
            $2fca4a116c89e45a$var$_FeatureGates.hasCheckGateErrorOccurred = true;
        }
    }
    // Proceed with the main logic if no override is found
    return $2fca4a116c89e45a$var$_FeatureGates.client.checkGate(gateName, options);
});
(0, $b610cb1610902400$export$2e2bcd8739ae039)($2fca4a116c89e45a$var$FeatureGates, "getExperimentValue", function(experimentName, parameterName, defaultValue, options) {
    try {
        // Check if the CRITERION override mechanism is available
        if (typeof window !== 'undefined' && window.__CRITERION__ && typeof window.__CRITERION__.getExperimentValueOverride === 'function') {
            var overrideValue = window.__CRITERION__.getExperimentValueOverride(experimentName, parameterName);
            if (overrideValue !== undefined && overrideValue !== null) return overrideValue;
        }
    } catch (error) {
        // Log the first occurrence of the error
        if (!$2fca4a116c89e45a$var$_FeatureGates.hasGetExperimentValueErrorOccurred) {
            // eslint-disable-next-line no-console
            console.warn({
                msg: 'An error has occurred getting the experiment value from criterion override. Only the first occurrence of this error is logged.',
                experimentName: experimentName,
                defaultValue: defaultValue,
                options: options,
                error: error
            });
            $2fca4a116c89e45a$var$_FeatureGates.hasGetExperimentValueErrorOccurred = true;
        }
        return defaultValue;
    }
    // Proceed with the main logic if no override is found
    return $2fca4a116c89e45a$var$_FeatureGates.client.getExperimentValue(experimentName, parameterName, defaultValue, options);
});
(0, $b610cb1610902400$export$2e2bcd8739ae039)($2fca4a116c89e45a$var$FeatureGates, "initializeCalled", $2fca4a116c89e45a$var$_FeatureGates.client.initializeCalled.bind($2fca4a116c89e45a$var$_FeatureGates.client));
(0, $b610cb1610902400$export$2e2bcd8739ae039)($2fca4a116c89e45a$var$FeatureGates, "initializeCompleted", $2fca4a116c89e45a$var$_FeatureGates.client.initializeCompleted.bind($2fca4a116c89e45a$var$_FeatureGates.client));
(0, $b610cb1610902400$export$2e2bcd8739ae039)($2fca4a116c89e45a$var$FeatureGates, "waitUntilInitializeCompleted", $2fca4a116c89e45a$var$_FeatureGates.client.waitUntilInitializeCompleted.bind($2fca4a116c89e45a$var$_FeatureGates.client));
(0, $b610cb1610902400$export$2e2bcd8739ae039)($2fca4a116c89e45a$var$FeatureGates, "initialize", $2fca4a116c89e45a$var$_FeatureGates.client.initialize.bind($2fca4a116c89e45a$var$_FeatureGates.client));
(0, $b610cb1610902400$export$2e2bcd8739ae039)($2fca4a116c89e45a$var$FeatureGates, "initializeWithProvider", $2fca4a116c89e45a$var$_FeatureGates.client.initializeWithProvider.bind($2fca4a116c89e45a$var$_FeatureGates.client));
(0, $b610cb1610902400$export$2e2bcd8739ae039)($2fca4a116c89e45a$var$FeatureGates, "initializeFromValues", $2fca4a116c89e45a$var$_FeatureGates.client.initializeFromValues.bind($2fca4a116c89e45a$var$_FeatureGates.client));
(0, $b610cb1610902400$export$2e2bcd8739ae039)($2fca4a116c89e45a$var$FeatureGates, "manuallyLogGateExposure", $2fca4a116c89e45a$var$_FeatureGates.client.manuallyLogGateExposure.bind($2fca4a116c89e45a$var$_FeatureGates.client));
(0, $b610cb1610902400$export$2e2bcd8739ae039)($2fca4a116c89e45a$var$FeatureGates, "getExperiment", $2fca4a116c89e45a$var$_FeatureGates.client.getExperiment.bind($2fca4a116c89e45a$var$_FeatureGates.client));
(0, $b610cb1610902400$export$2e2bcd8739ae039)($2fca4a116c89e45a$var$FeatureGates, "manuallyLogExperimentExposure", $2fca4a116c89e45a$var$_FeatureGates.client.manuallyLogExperimentExposure.bind($2fca4a116c89e45a$var$_FeatureGates.client));
(0, $b610cb1610902400$export$2e2bcd8739ae039)($2fca4a116c89e45a$var$FeatureGates, "manuallyLogLayerExposure", $2fca4a116c89e45a$var$_FeatureGates.client.manuallyLogLayerExposure.bind($2fca4a116c89e45a$var$_FeatureGates.client));
(0, $b610cb1610902400$export$2e2bcd8739ae039)($2fca4a116c89e45a$var$FeatureGates, "shutdownStatsig", $2fca4a116c89e45a$var$_FeatureGates.client.shutdownStatsig.bind($2fca4a116c89e45a$var$_FeatureGates.client));
(0, $b610cb1610902400$export$2e2bcd8739ae039)($2fca4a116c89e45a$var$FeatureGates, "overrideGate", $2fca4a116c89e45a$var$_FeatureGates.client.overrideGate.bind($2fca4a116c89e45a$var$_FeatureGates.client));
(0, $b610cb1610902400$export$2e2bcd8739ae039)($2fca4a116c89e45a$var$FeatureGates, "clearGateOverride", $2fca4a116c89e45a$var$_FeatureGates.client.clearGateOverride.bind($2fca4a116c89e45a$var$_FeatureGates.client));
(0, $b610cb1610902400$export$2e2bcd8739ae039)($2fca4a116c89e45a$var$FeatureGates, "overrideConfig", $2fca4a116c89e45a$var$_FeatureGates.client.overrideConfig.bind($2fca4a116c89e45a$var$_FeatureGates.client));
(0, $b610cb1610902400$export$2e2bcd8739ae039)($2fca4a116c89e45a$var$FeatureGates, "clearConfigOverride", $2fca4a116c89e45a$var$_FeatureGates.client.clearConfigOverride.bind($2fca4a116c89e45a$var$_FeatureGates.client));
(0, $b610cb1610902400$export$2e2bcd8739ae039)($2fca4a116c89e45a$var$FeatureGates, "setOverrides", $2fca4a116c89e45a$var$_FeatureGates.client.setOverrides.bind($2fca4a116c89e45a$var$_FeatureGates.client));
(0, $b610cb1610902400$export$2e2bcd8739ae039)($2fca4a116c89e45a$var$FeatureGates, "getOverrides", $2fca4a116c89e45a$var$_FeatureGates.client.getOverrides.bind($2fca4a116c89e45a$var$_FeatureGates.client));
(0, $b610cb1610902400$export$2e2bcd8739ae039)($2fca4a116c89e45a$var$FeatureGates, "clearAllOverrides", $2fca4a116c89e45a$var$_FeatureGates.client.clearAllOverrides.bind($2fca4a116c89e45a$var$_FeatureGates.client));
(0, $b610cb1610902400$export$2e2bcd8739ae039)($2fca4a116c89e45a$var$FeatureGates, "isCurrentUser", $2fca4a116c89e45a$var$_FeatureGates.client.isCurrentUser.bind($2fca4a116c89e45a$var$_FeatureGates.client));
(0, $b610cb1610902400$export$2e2bcd8739ae039)($2fca4a116c89e45a$var$FeatureGates, "onGateUpdated", $2fca4a116c89e45a$var$_FeatureGates.client.onGateUpdated.bind($2fca4a116c89e45a$var$_FeatureGates.client));
(0, $b610cb1610902400$export$2e2bcd8739ae039)($2fca4a116c89e45a$var$FeatureGates, "onExperimentValueUpdated", $2fca4a116c89e45a$var$_FeatureGates.client.onExperimentValueUpdated.bind($2fca4a116c89e45a$var$_FeatureGates.client));
(0, $b610cb1610902400$export$2e2bcd8739ae039)($2fca4a116c89e45a$var$FeatureGates, "onAnyUpdated", $2fca4a116c89e45a$var$_FeatureGates.client.onAnyUpdated.bind($2fca4a116c89e45a$var$_FeatureGates.client));
(0, $b610cb1610902400$export$2e2bcd8739ae039)($2fca4a116c89e45a$var$FeatureGates, "updateUser", $2fca4a116c89e45a$var$_FeatureGates.client.updateUser.bind($2fca4a116c89e45a$var$_FeatureGates.client));
(0, $b610cb1610902400$export$2e2bcd8739ae039)($2fca4a116c89e45a$var$FeatureGates, "updateUserWithProvider", $2fca4a116c89e45a$var$_FeatureGates.client.updateUserWithProvider.bind($2fca4a116c89e45a$var$_FeatureGates.client));
(0, $b610cb1610902400$export$2e2bcd8739ae039)($2fca4a116c89e45a$var$FeatureGates, "updateUserWithValues", $2fca4a116c89e45a$var$_FeatureGates.client.updateUserWithValues.bind($2fca4a116c89e45a$var$_FeatureGates.client));
(0, $b610cb1610902400$export$2e2bcd8739ae039)($2fca4a116c89e45a$var$FeatureGates, "getPackageVersion", $2fca4a116c89e45a$var$_FeatureGates.client.getPackageVersion.bind($2fca4a116c89e45a$var$_FeatureGates.client));
(0, $b610cb1610902400$export$2e2bcd8739ae039)($2fca4a116c89e45a$var$FeatureGates, "getTargetApp", $2fca4a116c89e45a$var$_FeatureGates.client.getTargetApp.bind($2fca4a116c89e45a$var$_FeatureGates.client));
(0, $b610cb1610902400$export$2e2bcd8739ae039)($2fca4a116c89e45a$var$FeatureGates, "getLayer", $2fca4a116c89e45a$var$_FeatureGates.client.getLayer.bind($2fca4a116c89e45a$var$_FeatureGates.client));
(0, $b610cb1610902400$export$2e2bcd8739ae039)($2fca4a116c89e45a$var$FeatureGates, "getLayerValue", $2fca4a116c89e45a$var$_FeatureGates.client.getLayerValue.bind($2fca4a116c89e45a$var$_FeatureGates.client));
var $2fca4a116c89e45a$var$boundFGJS = $2fca4a116c89e45a$var$FeatureGates;
// This makes it possible to get a reference to the FeatureGates client at runtime.
// This is important for overriding values in Cypress tests, as there needs to be a
// way to get the exact instance for a window in order to mock some of its methods.
if (typeof window !== 'undefined') {
    if (window.__FEATUREGATES_JS__ === undefined) window.__FEATUREGATES_JS__ = $2fca4a116c89e45a$var$FeatureGates;
    else {
        var $2fca4a116c89e45a$var$_boundFGJS, $2fca4a116c89e45a$var$_boundFGJS$getPackage;
        $2fca4a116c89e45a$var$boundFGJS = window.__FEATUREGATES_JS__;
        var $2fca4a116c89e45a$var$boundVersion = (($2fca4a116c89e45a$var$_boundFGJS = $2fca4a116c89e45a$var$boundFGJS) === null || $2fca4a116c89e45a$var$_boundFGJS === void 0 || ($2fca4a116c89e45a$var$_boundFGJS$getPackage = $2fca4a116c89e45a$var$_boundFGJS.getPackageVersion) === null || $2fca4a116c89e45a$var$_boundFGJS$getPackage === void 0 ? void 0 : $2fca4a116c89e45a$var$_boundFGJS$getPackage.call($2fca4a116c89e45a$var$_boundFGJS)) || '4.10.0 or earlier';
        if ($2fca4a116c89e45a$var$boundVersion !== (0, $b65bf9cf2fa81ea9$export$a59f8d67326bd1cb)) {
            var $2fca4a116c89e45a$var$message = "Multiple versions of FeatureGateClients found on the current page.\n      The currently bound version is ".concat($2fca4a116c89e45a$var$boundVersion, " when module version ").concat((0, $b65bf9cf2fa81ea9$export$a59f8d67326bd1cb), " was loading.");
            // eslint-disable-next-line no-console
            console.warn($2fca4a116c89e45a$var$message);
        }
    }
}
var /**
 * @property {FeatureGates} FeatureGate default export
 */ $2fca4a116c89e45a$export$2e2bcd8739ae039 = $2fca4a116c89e45a$var$boundFGJS;


var $5e6c020a56d76487$var$_process, $5e6c020a56d76487$var$_process2;
// We can't rely on NODE_ENV === 'test' if its value is already configured by the consumer to some other value, so better to use JEST_WORKER_ID
// https://jestjs.io/docs/environment-variables#jest_worker_id
var $5e6c020a56d76487$var$TESTS_MODE = (globalThis === null || globalThis === void 0 || ($5e6c020a56d76487$var$_process = globalThis.process) === null || $5e6c020a56d76487$var$_process === void 0 || ($5e6c020a56d76487$var$_process = $5e6c020a56d76487$var$_process.env) === null || $5e6c020a56d76487$var$_process === void 0 ? void 0 : $5e6c020a56d76487$var$_process.JEST_WORKER_ID) !== undefined;
var $5e6c020a56d76487$var$DEBUG_MODE = !$5e6c020a56d76487$var$TESTS_MODE && (globalThis === null || globalThis === void 0 || ($5e6c020a56d76487$var$_process2 = globalThis.process) === null || $5e6c020a56d76487$var$_process2 === void 0 || ($5e6c020a56d76487$var$_process2 = $5e6c020a56d76487$var$_process2.env) === null || $5e6c020a56d76487$var$_process2 === void 0 ? void 0 : $5e6c020a56d76487$var$_process2.NODE_ENV) !== 'production';
var $5e6c020a56d76487$export$1c9f709888824e05 = function debug() {
    var _console;
    if (!$5e6c020a56d76487$var$DEBUG_MODE) return;
    // eslint-disable-next-line no-console
    (_console = console).debug.apply(_console, arguments);
};



var $3ZMUU = parcelRequire("3ZMUU");
var $288fe21cdb43812c$var$pkgName = '@atlaskit/platform-feature-flags';
var $288fe21cdb43812c$export$7e41b1b2bdee3f98 = '__PLATFORM_FEATURE_FLAGS__';
var $288fe21cdb43812c$var$hasProcessEnv = typeof $3ZMUU !== 'undefined' && typeof $3ZMUU.env !== 'undefined';
// FF global overrides can be configured by test runners or Storybook
var $288fe21cdb43812c$var$ENV_ENABLE_PLATFORM_FF = $288fe21cdb43812c$var$hasProcessEnv ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;
// STORYBOOK_ENABLE_PLATFORM_FF is included as storybook only allows env vars prefixed with STORYBOOK
// https://github.com/storybookjs/storybook/issues/12270
var $288fe21cdb43812c$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF = $288fe21cdb43812c$var$hasProcessEnv ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;
var $288fe21cdb43812c$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE = $288fe21cdb43812c$var$ENV_ENABLE_PLATFORM_FF || $288fe21cdb43812c$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF;
var $288fe21cdb43812c$var$DEFAULT_PFF_GLOBAL = {
    booleanResolver: undefined
};
var $288fe21cdb43812c$var$globalVar = typeof window !== 'undefined' ? window : globalThis;
$288fe21cdb43812c$var$globalVar[$288fe21cdb43812c$export$7e41b1b2bdee3f98] = $288fe21cdb43812c$var$globalVar[$288fe21cdb43812c$export$7e41b1b2bdee3f98] || $288fe21cdb43812c$var$DEFAULT_PFF_GLOBAL;
function $288fe21cdb43812c$export$f2b591175b3e424c(resolver) {
    $288fe21cdb43812c$var$globalVar[$288fe21cdb43812c$export$7e41b1b2bdee3f98].booleanResolver = resolver;
}
function $288fe21cdb43812c$export$6333b6aff9fc6275(flagKey) {
    if ($288fe21cdb43812c$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE) {
        (0, $5e6c020a56d76487$export$1c9f709888824e05)('[%s]: The feature flags were enabled while running tests. The flag "%s" will be always enabled.', $288fe21cdb43812c$var$pkgName, flagKey);
        return true;
    }
    try {
        var _globalVar$PFF_GLOBAL, _globalVar$PFF_GLOBAL2, _globalVar$PFF_GLOBAL3;
        // booleanResolver will be empty for products like Trello, Elevate, Recruit etc.
        // Currently only Confluence, Jira and Bitbucket has set it.
        if (((_globalVar$PFF_GLOBAL = $288fe21cdb43812c$var$globalVar[$288fe21cdb43812c$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL === void 0 ? void 0 : _globalVar$PFF_GLOBAL.booleanResolver) === undefined || ((_globalVar$PFF_GLOBAL2 = $288fe21cdb43812c$var$globalVar[$288fe21cdb43812c$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL2 === void 0 ? void 0 : _globalVar$PFF_GLOBAL2.booleanResolver) === null) // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
        return (0, $2fca4a116c89e45a$export$2e2bcd8739ae039).checkGate(flagKey);
        var result = (_globalVar$PFF_GLOBAL3 = $288fe21cdb43812c$var$globalVar[$288fe21cdb43812c$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL3 === void 0 ? void 0 : _globalVar$PFF_GLOBAL3.booleanResolver(flagKey);
        if (typeof result !== 'boolean') {
            // eslint-disable-next-line no-console
            console.warn("".concat(flagKey, " resolved to a non-boolean value, returning false for safety"));
            return false;
        }
        return result;
    } catch (e) {
        return false;
    }
}


function $ac3bd66bebc4c2f5$export$ba05d765b8392e5e(flagResolver) {
    (0, $288fe21cdb43812c$export$f2b591175b3e424c)(flagResolver);
}
function $ac3bd66bebc4c2f5$export$470e5c2be1411c89(name) {
    return (0, $288fe21cdb43812c$export$6333b6aff9fc6275)(name);
}
function $ac3bd66bebc4c2f5$export$b40ec24ac8275656(name) {
    return (0, $288fe21cdb43812c$export$6333b6aff9fc6275)(name);
}



var $3ZMUU = parcelRequire("3ZMUU");
var $e6196b1a08abaae6$var$_process$env;
/// <reference types="node" />
var $e6196b1a08abaae6$var$_default_1 = typeof $3ZMUU !== 'undefined' && $3ZMUU !== null && (($e6196b1a08abaae6$var$_process$env = {}, $e6196b1a08abaae6$var$_process$env === void 0) ? void 0 : $e6196b1a08abaae6$var$_process$env['ANALYTICS_NEXT_MODERN_CONTEXT']);
var $e6196b1a08abaae6$export$2e2bcd8739ae039 = $e6196b1a08abaae6$var$_default_1;










var $5FkrB = parcelRequire("5FkrB");
var $7970158fd2c73df9$exports = {};
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $7970158fd2c73df9$var$ReactIs, $7970158fd2c73df9$var$throwOnDirectAccess;

// By explicitly using `prop-types` you are opting into new production behavior.
// http://fb.me/prop-types-in-prod
$7970158fd2c73df9$exports = (parcelRequire("2oinO"))();



function $f79c2980677099e0$var$_callSuper(t, o, e) {
    return o = (0, $4490bebe6ed00a04$export$2e2bcd8739ae039)(o), (0, $9aa98131e170ebee$export$2e2bcd8739ae039)(t, $f79c2980677099e0$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, $4490bebe6ed00a04$export$2e2bcd8739ae039)(t).constructor) : o.apply(t, e));
}
function $f79c2980677099e0$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($f79c2980677099e0$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $f79c2980677099e0$var$ContextTypes = {
    getAtlaskitAnalyticsContext: (0, (/*@__PURE__*/$parcel$interopDefault($7970158fd2c73df9$exports))).func,
    getAtlaskitAnalyticsEventHandlers: (0, (/*@__PURE__*/$parcel$interopDefault($7970158fd2c73df9$exports))).func
};
var $f79c2980677099e0$var$noop = function noop() {
    return [];
};
// eslint-disable-next-line @repo/internal/react/no-class-components
var $f79c2980677099e0$var$AnalyticsContext = /*#__PURE__*/ function(_Component) {
    function AnalyticsContext(props) {
        var _this;
        (0, $fa4a4ebb2790e034$export$2e2bcd8739ae039)(this, AnalyticsContext);
        _this = $f79c2980677099e0$var$_callSuper(this, AnalyticsContext, [
            props
        ]);
        (0, $b610cb1610902400$export$2e2bcd8739ae039)(_this, "getChildContext", function() {
            return {
                getAtlaskitAnalyticsContext: _this.getAnalyticsContext
            };
        });
        (0, $b610cb1610902400$export$2e2bcd8739ae039)(_this, "getAnalyticsContext", function() {
            var data = _this.props.data;
            var _this$context$getAtla = _this.context.getAtlaskitAnalyticsContext, getAtlaskitAnalyticsContext = _this$context$getAtla === void 0 ? $f79c2980677099e0$var$noop : _this$context$getAtla;
            return [].concat((0, $d174179afb4ba721$export$2e2bcd8739ae039)(getAtlaskitAnalyticsContext()), [
                data
            ]);
        });
        (0, $b610cb1610902400$export$2e2bcd8739ae039)(_this, "getAnalyticsEventHandlers", function() {
            var _this$context$getAtla2 = _this.context.getAtlaskitAnalyticsEventHandlers, getAtlaskitAnalyticsEventHandlers = _this$context$getAtla2 === void 0 ? $f79c2980677099e0$var$noop : _this$context$getAtla2;
            return getAtlaskitAnalyticsEventHandlers();
        });
        _this.contextValue = {
            getAtlaskitAnalyticsContext: _this.getAnalyticsContext,
            getAtlaskitAnalyticsEventHandlers: _this.getAnalyticsEventHandlers
        };
        return _this;
    }
    (0, $fab6c522048ab9a7$export$2e2bcd8739ae039)(AnalyticsContext, _Component);
    return (0, $ec88b65548eaad36$export$2e2bcd8739ae039)(AnalyticsContext, [
        {
            key: "render",
            value: function render() {
                var children = this.props.children;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $d82667e77467cbe0$export$2e2bcd8739ae039).Provider, {
                    value: this.contextValue
                }, children);
            }
        }
    ]);
}((0, $5FkrB.Component));
(0, $b610cb1610902400$export$2e2bcd8739ae039)($f79c2980677099e0$var$AnalyticsContext, "contextTypes", $f79c2980677099e0$var$ContextTypes);
(0, $b610cb1610902400$export$2e2bcd8739ae039)($f79c2980677099e0$var$AnalyticsContext, "childContextTypes", $f79c2980677099e0$var$ContextTypes);
var $f79c2980677099e0$export$2e2bcd8739ae039 = $f79c2980677099e0$var$AnalyticsContext;




var $5FkrB = parcelRequire("5FkrB");


var $5FkrB = parcelRequire("5FkrB");

var $80daaf53d0509a67$export$d1f587f82ad51c4 = function useAnalyticsContext() {
    return (0, $5FkrB.useContext)((0, $d82667e77467cbe0$export$2e2bcd8739ae039));
};



var $5FkrB = parcelRequire("5FkrB");
var $ff0d3854d9a35b47$export$1d27a74659855e44 = function useTrackedRef(value) {
    var ref = (0, $5FkrB.useRef)(value);
    ref.current = value;
    return ref;
};


var $f5ebd72be6b94bdb$var$AnalyticsContext = function AnalyticsContext(_ref) {
    var data = _ref.data, children = _ref.children;
    var dataRef = (0, $ff0d3854d9a35b47$export$1d27a74659855e44)(data);
    var _useAnalyticsContext = (0, $80daaf53d0509a67$export$d1f587f82ad51c4)(), getAtlaskitAnalyticsEventHandlers = _useAnalyticsContext.getAtlaskitAnalyticsEventHandlers, getOriginalAnalyticsContext = _useAnalyticsContext.getAtlaskitAnalyticsContext;
    var getAtlaskitAnalyticsContext = (0, $5FkrB.useCallback)(function() {
        return [].concat((0, $d174179afb4ba721$export$2e2bcd8739ae039)(getOriginalAnalyticsContext()), [
            dataRef.current
        ]);
    }, [
        getOriginalAnalyticsContext,
        dataRef
    ]);
    var value = (0, $5FkrB.useMemo)(function() {
        return {
            getAtlaskitAnalyticsContext: getAtlaskitAnalyticsContext,
            getAtlaskitAnalyticsEventHandlers: getAtlaskitAnalyticsEventHandlers
        };
    }, [
        getAtlaskitAnalyticsContext,
        getAtlaskitAnalyticsEventHandlers
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $d82667e77467cbe0$export$2e2bcd8739ae039).Provider, {
        value: value
    }, children);
};
var $f5ebd72be6b94bdb$export$2e2bcd8739ae039 = $f5ebd72be6b94bdb$var$AnalyticsContext;


var $389124bba9da7173$var$AnalyticsContext = function AnalyticsContext(props) {
    var computeIsModernContext = function computeIsModernContext() {
        return (0, $e6196b1a08abaae6$export$2e2bcd8739ae039) || (0, $ac3bd66bebc4c2f5$export$b40ec24ac8275656)('analytics-next-use-legacy-context') === false;
    };
    // Gated by analytics-next-lock-context-type: capture the value once at mount so a late gate flip can't swap the component type and remount the subtree. While locked the gate is not re-read on later renders.
    var _React$useState = (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).useState(computeIsModernContext), _React$useState2 = (0, $4f293317ede17766$export$2e2bcd8739ae039)(_React$useState, 1), lockedIsModernContext = _React$useState2[0];
    var isModernContext = (0, $ac3bd66bebc4c2f5$export$b40ec24ac8275656)('analytics-next-lock-context-type') ? lockedIsModernContext : computeIsModernContext();
    return isModernContext ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $f5ebd72be6b94bdb$export$2e2bcd8739ae039), props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $f79c2980677099e0$export$2e2bcd8739ae039), props);
};
var $389124bba9da7173$export$2e2bcd8739ae039 = $389124bba9da7173$var$AnalyticsContext;


var $d7a2017ee54358d6$var$_excluded = [
    "analyticsContext"
];
function $d7a2017ee54358d6$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $d7a2017ee54358d6$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $d7a2017ee54358d6$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $b610cb1610902400$export$2e2bcd8739ae039)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $d7a2017ee54358d6$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $d7a2017ee54358d6$var$withAnalyticsContext = function withAnalyticsContext(defaultData) {
    return function(WrappedComponent) {
        var WithAnalyticsContext = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function(_ref, ref) {
            var analyticsContext = _ref.analyticsContext, rest = (0, $f9613085755b341d$export$2e2bcd8739ae039)(_ref, $d7a2017ee54358d6$var$_excluded);
            var analyticsData = (0, $5FkrB.useMemo)(function() {
                return $d7a2017ee54358d6$var$_objectSpread($d7a2017ee54358d6$var$_objectSpread({}, defaultData), analyticsContext);
            }, [
                analyticsContext
            ]);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $389124bba9da7173$export$2e2bcd8739ae039), {
                data: analyticsData
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(WrappedComponent, (0, $63a3d0c6fb21a3ce$export$2e2bcd8739ae039)({}, rest, {
                ref: ref
            })));
        });
        WithAnalyticsContext.displayName = "WithAnalyticsContext(".concat(WrappedComponent.displayName || WrappedComponent.name, ")");
        return WithAnalyticsContext;
    };
};
var $d7a2017ee54358d6$export$2e2bcd8739ae039 = $d7a2017ee54358d6$var$withAnalyticsContext;



var $5FkrB = parcelRequire("5FkrB");














function $9485b36bc079f877$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $9485b36bc079f877$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $9485b36bc079f877$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $b610cb1610902400$export$2e2bcd8739ae039)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $9485b36bc079f877$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $9485b36bc079f877$export$ad4be5c2ec28cecf = function isAnalyticsEvent(obj) {
    var _obj$constructor;
    return obj instanceof $9485b36bc079f877$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 || (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === 'AnalyticsEvent';
};
// eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
var $9485b36bc079f877$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function AnalyticsEvent(props) {
        var _this = this;
        (0, $fa4a4ebb2790e034$export$2e2bcd8739ae039)(this, AnalyticsEvent);
        (0, $b610cb1610902400$export$2e2bcd8739ae039)(this, "_isAnalyticsEvent", true);
        (0, $b610cb1610902400$export$2e2bcd8739ae039)(this, "clone", function() {
            // just a shallow clone, don't change sub refs unless you want to
            // affect the original's too
            var payload = $9485b36bc079f877$var$_objectSpread({}, _this.payload);
            return new AnalyticsEvent({
                payload: payload
            });
        });
        this.payload = props.payload;
    }
    return (0, $ec88b65548eaad36$export$2e2bcd8739ae039)(AnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (typeof updater === 'function') this.payload = updater(this.payload);
                if ((0, $adec1f6aecb10080$export$2e2bcd8739ae039)(updater) === 'object') this.payload = $9485b36bc079f877$var$_objectSpread($9485b36bc079f877$var$_objectSpread({}, this.payload), updater);
                return this;
            }
        }
    ]);
}();


function $fecb185bb10ef345$var$_callSuper(t, o, e) {
    return o = (0, $4490bebe6ed00a04$export$2e2bcd8739ae039)(o), (0, $9aa98131e170ebee$export$2e2bcd8739ae039)(t, $fecb185bb10ef345$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, $4490bebe6ed00a04$export$2e2bcd8739ae039)(t).constructor) : o.apply(t, e));
}
function $fecb185bb10ef345$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($fecb185bb10ef345$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $fecb185bb10ef345$var$_superPropGet(t, o, e, r) {
    var p = (0, $30e2255d05c27cca$export$2e2bcd8739ae039)((0, $4490bebe6ed00a04$export$2e2bcd8739ae039)(1 & r ? t.prototype : t), o, e);
    return 2 & r && "function" == typeof p ? function(t) {
        return p.apply(e, t);
    } : p;
}
function $fecb185bb10ef345$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $fecb185bb10ef345$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $fecb185bb10ef345$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $b610cb1610902400$export$2e2bcd8739ae039)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $fecb185bb10ef345$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $fecb185bb10ef345$export$35f8383928ba8d7 = function isUIAnalyticsEvent(obj) {
    var _obj$constructor;
    return obj instanceof $fecb185bb10ef345$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isUIAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 || (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === 'UIAnalyticsEvent';
};
/**
 * Produces a deep clone of an event payload.
 *
 * The historic implementation relied on `JSON.parse(JSON.stringify(...))`, a
 * "hacky" deep clone that does not support functions, regexs, Maps, Sets, etc.
 * Crucially, `JSON.stringify` also throws `TypeError: Converting circular
 * structure to JSON` when the payload contains a value with circular
 * references — e.g. a live DOM node carrying React fiber back-references
 * (`__reactFiber$...`). When that throw happens during a React render/commit it
 * escapes into product UI and trips an error boundary (HOT-127428).
 *
 * Analytics must never crash product UI (the same contract `fire` upholds), so
 * behind the `platform-analytics-next-safe-clone` gate we wrap the
 * serialization in a try/catch and fall back to a shallow clone — matching the
 * base `AnalyticsEvent.clone` behaviour — if the deep clone fails.
 *
 * NOTE: this is intentionally a module-scoped function rather than a class
 * member so it does not change the structural type of `UIAnalyticsEvent`, which
 * is hand-mocked across the monorepo.
 */ var $fecb185bb10ef345$var$clonePayload = function clonePayload(payload) {
    if ((0, $ac3bd66bebc4c2f5$export$b40ec24ac8275656)('platform-analytics-next-safe-clone')) try {
        return JSON.parse(JSON.stringify(payload));
    } catch (e) {
        // Shallow clone keeps the event usable without crashing the UI.
        return $fecb185bb10ef345$var$_objectSpread({}, payload);
    }
    /**
   * A hacky "deep clone" of the object. This is limited in that it wont
   * support functions, regexs, Maps, Sets, etc, but none of those need to
   * be represented in our payload.
   */ return JSON.parse(JSON.stringify(payload));
};
// eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
var $fecb185bb10ef345$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_AnalyticsEvent) {
    function UIAnalyticsEvent(props) {
        var _this;
        (0, $fa4a4ebb2790e034$export$2e2bcd8739ae039)(this, UIAnalyticsEvent);
        _this = $fecb185bb10ef345$var$_callSuper(this, UIAnalyticsEvent, [
            props
        ]);
        (0, $b610cb1610902400$export$2e2bcd8739ae039)(_this, "_isUIAnalyticsEvent", true);
        (0, $b610cb1610902400$export$2e2bcd8739ae039)(_this, "clone", function() {
            if (_this.hasFired) return null;
            var context = (0, $d174179afb4ba721$export$2e2bcd8739ae039)(_this.context);
            var handlers = (0, $d174179afb4ba721$export$2e2bcd8739ae039)(_this.handlers);
            var payload = $fecb185bb10ef345$var$clonePayload(_this.payload);
            return new UIAnalyticsEvent({
                context: context,
                handlers: handlers,
                payload: payload
            });
        });
        (0, $b610cb1610902400$export$2e2bcd8739ae039)(_this, "fire", function(channel) {
            if (_this.hasFired) return;
            _this.handlers.forEach(function(handler) {
                try {
                    handler(_this, channel);
                } catch (e) {}
            });
            _this.hasFired = true;
        });
        _this.context = props.context || [];
        _this.handlers = props.handlers || [];
        _this.hasFired = false;
        return _this;
    }
    (0, $fab6c522048ab9a7$export$2e2bcd8739ae039)(UIAnalyticsEvent, _AnalyticsEvent);
    return (0, $ec88b65548eaad36$export$2e2bcd8739ae039)(UIAnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (this.hasFired) return this;
                return $fecb185bb10ef345$var$_superPropGet(UIAnalyticsEvent, "update", this, 3)([
                    updater
                ]);
            }
        }
    ]);
}((0, $9485b36bc079f877$export$2e2bcd8739ae039));



function $011700e902016cd5$export$5bf35293e545f20c() {
    var analyticsContext = (0, $80daaf53d0509a67$export$d1f587f82ad51c4)();
    var createAnalyticsEvent = (0, $a060da77483cc5d3$export$33752cf3ee811995)(function(payload) {
        return new (0, $fecb185bb10ef345$export$2e2bcd8739ae039)({
            context: analyticsContext.getAtlaskitAnalyticsContext(),
            handlers: analyticsContext.getAtlaskitAnalyticsEventHandlers(),
            payload: payload
        });
    }, [
        analyticsContext
    ]);
    return {
        createAnalyticsEvent: createAnalyticsEvent
    };
}





var $5FkrB = parcelRequire("5FkrB");

function $ac25975040ae0632$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $ac25975040ae0632$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $ac25975040ae0632$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $b610cb1610902400$export$2e2bcd8739ae039)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $ac25975040ae0632$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $ac25975040ae0632$export$9ebb5a84d17e5d18() {
    var createEventMap = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var wrappedComponentProps = arguments.length > 1 ? arguments[1] : undefined;
    var _useAnalyticsEvents = (0, $011700e902016cd5$export$5bf35293e545f20c)(), createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
    var handlerCache = (0, $5FkrB.useRef)({});
    var patchedProps = (0, $5FkrB.useMemo)(function() {
        var cache = handlerCache.current;
        // Clean up no longer used handlers in cache
        Object.keys(cache).filter(function(key) {
            return !(key in createEventMap);
        }).forEach(function(key) {
            return delete cache[key];
        });
        return Object.keys(createEventMap).reduce(function(p, k) {
            var eventCreator = createEventMap[k];
            if (![
                'object',
                'function'
            ].includes((0, $adec1f6aecb10080$export$2e2bcd8739ae039)(eventCreator))) return p;
            var propValue = wrappedComponentProps[k];
            if (k in cache && cache[k].eventCreator === eventCreator && cache[k].propValue === propValue) return $ac25975040ae0632$var$_objectSpread($ac25975040ae0632$var$_objectSpread({}, p), {}, (0, $b610cb1610902400$export$2e2bcd8739ae039)({}, k, cache[k].wrappedCallback));
            var wrappedCallback = function wrappedCallback() {
                var analyticsEvent = typeof eventCreator === 'function' ? eventCreator(createAnalyticsEvent, wrappedComponentProps) : createAnalyticsEvent(eventCreator);
                if (propValue && typeof propValue === 'function') {
                    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                    propValue.apply(void 0, args.concat([
                        analyticsEvent
                    ]));
                }
            };
            cache[k] = {
                eventCreator: eventCreator,
                wrappedCallback: wrappedCallback,
                propValue: propValue
            };
            return $ac25975040ae0632$var$_objectSpread($ac25975040ae0632$var$_objectSpread({}, p), {}, (0, $b610cb1610902400$export$2e2bcd8739ae039)({}, k, wrappedCallback));
        }, {});
    }, [
        createEventMap,
        wrappedComponentProps,
        createAnalyticsEvent,
        handlerCache
    ]);
    return {
        patchedEventProps: patchedProps
    };
}


var $65bb486fda6c58bc$var$withAnalyticsEvents = function withAnalyticsEvents() {
    var createEventMap = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return function(WrappedComponent) {
        var WithAnalyticsEvents = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function(props, ref) {
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore: to unblock React 18.2.0 -> 18.3.1 version bump in Jira
            var _usePatchedProps = (0, $ac25975040ae0632$export$9ebb5a84d17e5d18)(createEventMap, props), patchedEventProps = _usePatchedProps.patchedEventProps;
            var _useAnalyticsEvents = (0, $011700e902016cd5$export$5bf35293e545f20c)(), createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(WrappedComponent, (0, $63a3d0c6fb21a3ce$export$2e2bcd8739ae039)({}, props, patchedEventProps, {
                createAnalyticsEvent: createAnalyticsEvent,
                ref: ref
            }));
        });
        WithAnalyticsEvents.displayName = "WithAnalyticsEvents(".concat(WrappedComponent.displayName || WrappedComponent.name, ")");
        return WithAnalyticsEvents;
    };
};
var $65bb486fda6c58bc$export$2e2bcd8739ae039 = $65bb486fda6c58bc$var$withAnalyticsEvents;


function $e7be1629a1f1b709$export$2e2bcd8739ae039() {
    return $e7be1629a1f1b709$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $e7be1629a1f1b709$export$2e2bcd8739ae039.apply(null, arguments);
}



var $5FkrB = parcelRequire("5FkrB");
/* select.tsx generated by @compiled/babel-plugin v2.0.0 */ 
function $da9bd58a47891c77$export$2e2bcd8739ae039(r) {
    throw new TypeError('"' + r + '" is read-only');
}


function $08eb341cc44a6255$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $08eb341cc44a6255$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $08eb341cc44a6255$export$2e2bcd8739ae039(o);
}


function $9ba5074f09554cd6$export$2e2bcd8739ae039(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}




function $a06ba3e5bcafe7f9$export$2e2bcd8739ae039(t, r) {
    if ("object" != (0, $08eb341cc44a6255$export$2e2bcd8739ae039)(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (0, $08eb341cc44a6255$export$2e2bcd8739ae039)(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}


function $f7b38ed90a3a9534$export$2e2bcd8739ae039(t) {
    var i = (0, $a06ba3e5bcafe7f9$export$2e2bcd8739ae039)(t, "string");
    return "symbol" == (0, $08eb341cc44a6255$export$2e2bcd8739ae039)(i) ? i : i + "";
}


function $920934557ff0cee7$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, (0, $f7b38ed90a3a9534$export$2e2bcd8739ae039)(o.key), o);
    }
}
function $920934557ff0cee7$export$2e2bcd8739ae039(e, r, t) {
    return r && $920934557ff0cee7$var$_defineProperties(e.prototype, r), t && $920934557ff0cee7$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}



function $8c8460db7b953203$export$2e2bcd8739ae039(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
}


function $916d1780331a30aa$export$2e2bcd8739ae039(t, e) {
    if (e && ("object" == (0, $08eb341cc44a6255$export$2e2bcd8739ae039)(e) || "function" == typeof e)) return e;
    if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
    return (0, $8c8460db7b953203$export$2e2bcd8739ae039)(t);
}


function $4753b89c96b5d03b$export$2e2bcd8739ae039(t) {
    return $4753b89c96b5d03b$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
        return t.__proto__ || Object.getPrototypeOf(t);
    }, $4753b89c96b5d03b$export$2e2bcd8739ae039(t);
}


function $1609f1dc706fdd9d$export$2e2bcd8739ae039(t, e) {
    return $1609f1dc706fdd9d$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, $1609f1dc706fdd9d$export$2e2bcd8739ae039(t, e);
}


function $908cdaf31c7766dc$export$2e2bcd8739ae039(t, e) {
    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
    t.prototype = Object.create(e && e.prototype, {
        constructor: {
            value: t,
            writable: !0,
            configurable: !0
        }
    }), Object.defineProperty(t, "prototype", {
        writable: !1
    }), e && (0, $1609f1dc706fdd9d$export$2e2bcd8739ae039)(t, e);
}



function $90d31be1abcfa6da$export$2e2bcd8739ae039(e, r, t) {
    return (r = (0, $f7b38ed90a3a9534$export$2e2bcd8739ae039)(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}


function $65128f64fc03d30a$export$2e2bcd8739ae039(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}


function $6a3595f2df2eb68b$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return (0, $65128f64fc03d30a$export$2e2bcd8739ae039)(r);
}


function $11aee5c500faac3f$export$2e2bcd8739ae039(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}



function $98cc7c0db464d08d$export$2e2bcd8739ae039(r, a) {
    if (r) {
        if ("string" == typeof r) return (0, $65128f64fc03d30a$export$2e2bcd8739ae039)(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? (0, $65128f64fc03d30a$export$2e2bcd8739ae039)(r, a) : void 0;
    }
}


function $26e5be248d120058$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}


function $f90c78505475f844$export$2e2bcd8739ae039(r) {
    return (0, $6a3595f2df2eb68b$export$2e2bcd8739ae039)(r) || (0, $11aee5c500faac3f$export$2e2bcd8739ae039)(r) || (0, $98cc7c0db464d08d$export$2e2bcd8739ae039)(r) || (0, $26e5be248d120058$export$2e2bcd8739ae039)();
}



var $lqU89 = parcelRequire("lqU89");

var $5FkrB = parcelRequire("5FkrB");

function $9fe1d61f676e91d7$var$testPlatform(re) {
    var _userAgentData;
    return typeof window !== 'undefined' && window.navigator != null ? re.test(((_userAgentData = window.navigator['userAgentData']) === null || _userAgentData === void 0 ? void 0 : _userAgentData.platform) || window.navigator.platform) : false;
}
function $9fe1d61f676e91d7$var$isIPhone() {
    return $9fe1d61f676e91d7$var$testPlatform(/^iPhone/i);
}
function $9fe1d61f676e91d7$var$isIPad() {
    return $9fe1d61f676e91d7$var$testPlatform(/^iPad/i) || // iPadOS 13 lies and says it's a Mac, but we can distinguish by detecting touch support.
    $9fe1d61f676e91d7$var$isMac() && navigator.maxTouchPoints > 1;
}
function $9fe1d61f676e91d7$var$isMac() {
    return $9fe1d61f676e91d7$var$testPlatform(/^Mac/i);
}
function $9fe1d61f676e91d7$var$isIOS() {
    return $9fe1d61f676e91d7$var$isIPhone() || $9fe1d61f676e91d7$var$isIPad();
}
function $9fe1d61f676e91d7$export$e1865c3bedcd822b() {
    return $9fe1d61f676e91d7$var$isMac() || $9fe1d61f676e91d7$var$isIOS();
}







function $22f6b250f9232c12$export$2e2bcd8739ae039(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}


function $9b3d50432d7c2d71$export$2e2bcd8739ae039(e, t) {
    if (null == e) return {};
    var o, r, i = (0, $22f6b250f9232c12$export$2e2bcd8739ae039)(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}


function $a4199f5578d717d3$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return r;
}


function $5648c2ddf90d0c44$export$2e2bcd8739ae039(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}



function $8197c8ea861ef6a8$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}


function $c99af517edc48a31$export$2e2bcd8739ae039(r, e) {
    return (0, $a4199f5578d717d3$export$2e2bcd8739ae039)(r) || (0, $5648c2ddf90d0c44$export$2e2bcd8739ae039)(r, e) || (0, $98cc7c0db464d08d$export$2e2bcd8739ae039)(r, e) || (0, $8197c8ea861ef6a8$export$2e2bcd8739ae039)();
}


function $d650e45c9b3d04ba$var$asyncGeneratorStep(n, t, e, r, o, a, c) {
    try {
        var i = n[a](c), u = i.value;
    } catch (n) {
        return void e(n);
    }
    i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function $d650e45c9b3d04ba$export$2e2bcd8739ae039(n) {
    return function() {
        var t = this, e = arguments;
        return new Promise(function(r, o) {
            var a = n.apply(t, e);
            function _next(n) {
                $d650e45c9b3d04ba$var$asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
            }
            function _throw(n) {
                $d650e45c9b3d04ba$var$asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
            }
            _next(void 0);
        });
    };
}





var $ff592c69388acc86$exports = {};
// TODO(Babel 8): Remove this file.

var $ff592c69388acc86$var$runtime = (parcelRequire("jGhF1"))();
$ff592c69388acc86$exports = $ff592c69388acc86$var$runtime;
// Copied from https://github.com/facebook/regenerator/blob/main/packages/runtime/runtime.js#L736=
try {
    regeneratorRuntime = $ff592c69388acc86$var$runtime;
} catch (accidentalStrictMode) {
    if (typeof globalThis === "object") globalThis.regeneratorRuntime = $ff592c69388acc86$var$runtime;
    else Function("r", "regeneratorRuntime = r")($ff592c69388acc86$var$runtime);
}



var $iFR7a = parcelRequire("iFR7a");




var $hLfKH = parcelRequire("hLfKH");
function $78d0491b7a524e85$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $78d0491b7a524e85$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $78d0491b7a524e85$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $90d31be1abcfa6da$export$2e2bcd8739ae039)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $78d0491b7a524e85$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $78d0491b7a524e85$export$a66cbd9b2289cd78 = '@all-features';
var $78d0491b7a524e85$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function Subscriptions() {
        (0, $9ba5074f09554cd6$export$2e2bcd8739ae039)(this, Subscriptions);
        (0, $90d31be1abcfa6da$export$2e2bcd8739ae039)(this, "eventToValue", new Map());
        this.emitter = new (0, (/*@__PURE__*/$parcel$interopDefault($hLfKH)))();
    }
    return (0, $920934557ff0cee7$export$2e2bcd8739ae039)(Subscriptions, [
        {
            key: "onGateUpdated",
            value: function onGateUpdated(gateName, callback, checkGate, options) {
                var _this = this;
                var value = checkGate(gateName, $78d0491b7a524e85$var$_objectSpread($78d0491b7a524e85$var$_objectSpread({}, options), {}, {
                    fireGateExposure: false
                }));
                if (this.eventToValue.get(callback) === undefined) this.eventToValue.set(callback, value);
                var wrapCallback = function wrapCallback() {
                    var value = checkGate(gateName, $78d0491b7a524e85$var$_objectSpread($78d0491b7a524e85$var$_objectSpread({}, options), {}, {
                        fireGateExposure: false
                    }));
                    var existingValue = _this.eventToValue.get(callback);
                    if (existingValue !== value) {
                        _this.eventToValue.set(callback, value);
                        callback(value);
                    }
                };
                this.emitter.on(gateName, wrapCallback);
                return function() {
                    _this.emitter.off(gateName, wrapCallback);
                };
            }
        },
        {
            key: "onExperimentValueUpdated",
            value: function onExperimentValueUpdated(experimentName, parameterName, defaultValue, callback, getExperimentValue, options) {
                var _this2 = this;
                var experimentEventName = "".concat(experimentName, ".").concat(parameterName);
                var value = getExperimentValue(experimentName, parameterName, defaultValue, $78d0491b7a524e85$var$_objectSpread($78d0491b7a524e85$var$_objectSpread({}, options), {}, {
                    fireExperimentExposure: false
                }));
                if (this.eventToValue.get(callback) === undefined) this.eventToValue.set(callback, value);
                var wrapCallback = function wrapCallback() {
                    var value = getExperimentValue(experimentName, parameterName, defaultValue, $78d0491b7a524e85$var$_objectSpread($78d0491b7a524e85$var$_objectSpread({}, options), {}, {
                        fireExperimentExposure: false
                    }));
                    var existingValue = _this2.eventToValue.get(callback);
                    if (existingValue !== value) {
                        _this2.eventToValue.set(callback, value);
                        callback(value);
                    }
                };
                this.emitter.on(experimentEventName, wrapCallback);
                return function() {
                    _this2.emitter.off(experimentEventName, wrapCallback);
                };
            }
        },
        {
            key: "onAnyUpdated",
            value: function onAnyUpdated(callback) {
                var _this3 = this;
                this.emitter.on($78d0491b7a524e85$export$a66cbd9b2289cd78, callback);
                return function() {
                    _this3.emitter.off($78d0491b7a524e85$export$a66cbd9b2289cd78, callback);
                };
            }
        },
        {
            key: "anyUpdated",
            value: function anyUpdated() {
                var _this4 = this;
                this.emitter.emit($78d0491b7a524e85$export$a66cbd9b2289cd78);
                this.emitter.eventNames().filter(function(name) {
                    return name !== $78d0491b7a524e85$export$a66cbd9b2289cd78;
                }).forEach(function(event) {
                    _this4.emitter.emit(event);
                });
            }
        }
    ]);
}();










var $029d7e31af990c81$export$ce553301d55c2fd8 = 'fedramp-moderate';
var $029d7e31af990c81$export$f005e2e9f707cb5f = 'commercial';
var $029d7e31af990c81$export$bd6b5a7802d76127 = 'fedramp-fedex';
var $029d7e31af990c81$export$a739cd5aac835909 = 'stg';
var $029d7e31af990c81$export$42dd0cdd351a4a9 = 'prod';
var $029d7e31af990c81$export$404582bc18fe4d9e = 'dev';


function $2334da5faf264836$export$64d6499adf9b2e51() {
    var _global$location;
    var global = globalThis;
    // MICROS_PERIMETER is already used by few products, so we need to keep it for backward compatibility
    var env = global.MICROS_PERIMETER || global.UNSAFE_ATL_CONTEXT_BOUNDARY;
    if (env) return env === (0, $029d7e31af990c81$export$ce553301d55c2fd8);
    var matches = (_global$location = global.location) === null || _global$location === void 0 || (_global$location = _global$location.hostname) === null || _global$location === void 0 ? void 0 : _global$location.match(/atlassian-us-gov-mod\.(com|net)|atlassian-us-gov\.(com|net)|atlassian-fex\.(com|net)|atlassian-stg-fedm\.(com|net)/);
    return matches ? matches.length > 0 : false;
}


// Reference: https://github.com/statsig-io/js-lite/blob/main/src/StatsigStore.ts
var $daed53313d551114$export$c62558b199e46828 = {
    // Order is important since the logic for migrating from a new client reason to an old one
    // returns the first which is a substring of the new client reason
    Error: 'Error',
    LocalOverride: 'LocalOverride',
    Unrecognized: 'Unrecognized',
    Uninitialized: 'Uninitialized',
    NetworkNotModified: 'NetworkNotModified',
    Network: 'Network',
    InvalidBootstrap: 'InvalidBootstrap',
    Bootstrap: 'Bootstrap',
    Cache: 'Cache',
    // For when we could not migrate the reason from the new client
    Unknown: 'Unknown'
}; // Reference: https://github.com/statsig-io/js-lite/blob/main/src/StatsigSDKOptions.ts


/**
 * The identifiers for the user. Options are restricted to the set that is currently supported.
 */ /**
 * Base client options. Does not include any options specific to providers
 * @interface BaseClientOptions
 * @property {FeatureGateEnvironment} environment - The environment for the client.
 * @property {string} targetApp - The target app for the client.
 * @property {AnalyticsWebClient} analyticsWebClient - The analytics web client.
 * @property {PerimeterType} perimeter - The perimeter for the client.
 */ /**
 * The options for the client.
 * @interface ClientOptions
 * @extends {BaseClientOptions}
 * @property {string} apiKey - The API key for the client.
 * @property {fetchTimeoutMs} fetchTimeoutMs - The timeout for the fetch request in milliseconds. Defaults to 5000.
 * @property {boolean} useGatewayURL - Whether to use the gateway URL. Defaults to false.
 */ /**
 * The custom attributes for the user.
 */ var $9b5324b6988a1977$export$479e7351a733299 = {
    Development: 'development',
    Staging: 'staging',
    Production: 'production'
};
var $9b5324b6988a1977$export$c42b7bbc5e7ba555 = {
    COMMERCIAL: 'commercial',
    FEDRAMP_MODERATE: 'fedramp-moderate'
};
var $9b5324b6988a1977$export$42f4885608027d0c = 'non_boolean'; // Type magic to get the JSDoc comments from the Client class methods to appear on the static
 // methods in FeatureGates where the property name and function type are identical


var $fa64713f218e0a46$var$_excluded = [
    "stableId"
], $fa64713f218e0a46$var$_excluded2 = [
    "api",
    "disableCurrentPageLogging",
    "loggingIntervalMillis",
    "loggingBufferMaxSize",
    "localMode",
    "eventLoggingApi",
    "eventLoggingApiForRetries",
    "disableLocalStorage",
    "ignoreWindowUndefined",
    "disableAllLogging",
    "initTimeoutMs",
    "disableNetworkKeepalive",
    "overrideStableID",
    "disableErrorLogging",
    "disableAutoMetricsLogging"
];
function $fa64713f218e0a46$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $fa64713f218e0a46$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $fa64713f218e0a46$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $90d31be1abcfa6da$export$2e2bcd8739ae039)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $fa64713f218e0a46$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $fa64713f218e0a46$export$d119b37e5f788b43 = function getOptionsWithDefaults(options) {
    return $fa64713f218e0a46$var$_objectSpread({
        /**
     * If more federal PerimeterTypes are added in the future, this should be updated so
     * that isFedRamp() === true always returns the strictest perimeter.
     */ perimeter: (0, $2334da5faf264836$export$64d6499adf9b2e51)() ? (0, $9b5324b6988a1977$export$c42b7bbc5e7ba555).FEDRAMP_MODERATE : (0, $9b5324b6988a1977$export$c42b7bbc5e7ba555).COMMERCIAL
    }, options);
};
var $fa64713f218e0a46$export$fa1c2bbf4100b8bc = function shallowEquals(objectA, objectB) {
    if (!objectA && !objectB) return true;
    if (!objectA || !objectB) return false;
    var aEntries = Object.entries(objectA);
    var bEntries = Object.entries(objectB);
    if (aEntries.length !== bEntries.length) return false;
    var ascendingKeyOrder = function ascendingKeyOrder(_ref, _ref2) {
        var _ref3 = (0, $c99af517edc48a31$export$2e2bcd8739ae039)(_ref, 1), key1 = _ref3[0];
        var _ref4 = (0, $c99af517edc48a31$export$2e2bcd8739ae039)(_ref2, 1), key2 = _ref4[0];
        return key1.localeCompare(key2);
    };
    aEntries.sort(ascendingKeyOrder);
    bEntries.sort(ascendingKeyOrder);
    for(var i = 0; i < aEntries.length; i++){
        var _aEntries$i = (0, $c99af517edc48a31$export$2e2bcd8739ae039)(aEntries[i], 2), aValue = _aEntries$i[1];
        var _bEntries$i = (0, $c99af517edc48a31$export$2e2bcd8739ae039)(bEntries[i], 2), bValue = _bEntries$i[1];
        if (aValue !== bValue) return false;
    }
    return true;
};
var $fa64713f218e0a46$export$3dad1db244472f32 = function toStatsigUser(identifiers, customAttributes) {
    // Re-map `stableId` to `stableID` to match Statsig's native type.
    var stableId = identifiers.stableId, otherIdentifiers = (0, $9b3d50432d7c2d71$export$2e2bcd8739ae039)(identifiers, $fa64713f218e0a46$var$_excluded);
    var user = {
        customIDs: $fa64713f218e0a46$var$_objectSpread($fa64713f218e0a46$var$_objectSpread({}, otherIdentifiers), stableId !== undefined ? {
            stableID: stableId
        } : {}),
        custom: customAttributes
    };
    if (identifiers.atlassianAccountId) user.userID = identifiers.atlassianAccountId;
    return user;
};
function $fa64713f218e0a46$export$1148cb79ceecd5fa(target) {
    for(var _len = arguments.length, sources = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)sources[_key - 1] = arguments[_key];
    if (!sources.length) return target;
    var source = sources.shift();
    if (source === undefined || source === null) return $fa64713f218e0a46$export$1148cb79ceecd5fa.apply(void 0, [
        target
    ].concat((0, $f90c78505475f844$export$2e2bcd8739ae039)(sources)));
    for(var _i = 0, _Object$entries = Object.entries(source); _i < _Object$entries.length; _i++){
        var _Object$entries$_i = (0, $c99af517edc48a31$export$2e2bcd8739ae039)(_Object$entries[_i], 2), key = _Object$entries$_i[0], src = _Object$entries$_i[1];
        var dst = target[key];
        var srcIsObj = src && (0, $08eb341cc44a6255$export$2e2bcd8739ae039)(src) === 'object' && !Array.isArray(src);
        var dstIsObj = dst && (0, $08eb341cc44a6255$export$2e2bcd8739ae039)(dst) === 'object' && !Array.isArray(dst);
        if (srcIsObj && dstIsObj) target[key] = $fa64713f218e0a46$export$1148cb79ceecd5fa(dst, src);
        else target[key] = src;
    }
    return $fa64713f218e0a46$export$1148cb79ceecd5fa.apply(void 0, [
        target
    ].concat((0, $f90c78505475f844$export$2e2bcd8739ae039)(sources)));
}
var $fa64713f218e0a46$export$202946b690d26d22 = function migrateInitializationOptions(options) {
    var api = options.api, disableCurrentPageLogging = options.disableCurrentPageLogging, loggingIntervalMillis = options.loggingIntervalMillis, loggingBufferMaxSize = options.loggingBufferMaxSize, localMode = options.localMode, eventLoggingApi = options.eventLoggingApi, eventLoggingApiForRetries = options.eventLoggingApiForRetries, disableLocalStorage = options.disableLocalStorage, ignoreWindowUndefined = options.ignoreWindowUndefined, disableAllLogging = options.disableAllLogging, _initTimeoutMs = options.initTimeoutMs, _disableNetworkKeepalive = options.disableNetworkKeepalive, _overrideStableID = options.overrideStableID, _disableErrorLogging = options.disableErrorLogging, _disableAutoMetricsLogging = options.disableAutoMetricsLogging, rest = (0, $9b3d50432d7c2d71$export$2e2bcd8739ae039)(options, $fa64713f218e0a46$var$_excluded2);
    return $fa64713f218e0a46$var$_objectSpread($fa64713f218e0a46$var$_objectSpread({}, rest), {}, {
        networkConfig: {
            api: api,
            logEventUrl: eventLoggingApi ? eventLoggingApi + 'rgstr' : undefined,
            logEventFallbackUrls: eventLoggingApiForRetries ? [
                eventLoggingApiForRetries
            ] : undefined,
            preventAllNetworkTraffic: localMode || !ignoreWindowUndefined && typeof window === 'undefined'
        },
        includeCurrentPageUrlWithEvents: !disableCurrentPageLogging,
        loggingIntervalMs: loggingIntervalMillis,
        loggingBufferMaxSize: loggingBufferMaxSize,
        disableStorage: disableLocalStorage === undefined ? localMode : disableLocalStorage,
        disableLogging: disableAllLogging === undefined ? localMode : disableAllLogging
    });
};
var $fa64713f218e0a46$var$evaluationReasonMappings = Object.entries((0, $daed53313d551114$export$c62558b199e46828)).map(function(_ref5) {
    var _ref6 = (0, $c99af517edc48a31$export$2e2bcd8739ae039)(_ref5, 2), key = _ref6[0], value = _ref6[1];
    return [
        key.toLowerCase(),
        value
    ];
});
var $fa64713f218e0a46$export$18ad168d3dbac899 = function migrateEvaluationDetails(details) {
    var _evaluationReasonMapp, _evaluationReasonMapp2, _details$receivedAt;
    var reasonLower = details.reason.toLowerCase();
    return {
        reason: (_evaluationReasonMapp = (_evaluationReasonMapp2 = $fa64713f218e0a46$var$evaluationReasonMappings.find(function(_ref7) {
            var _ref8 = (0, $c99af517edc48a31$export$2e2bcd8739ae039)(_ref7, 1), key = _ref8[0];
            return reasonLower.includes(key);
        })) === null || _evaluationReasonMapp2 === void 0 ? void 0 : _evaluationReasonMapp2[1]) !== null && _evaluationReasonMapp !== void 0 ? _evaluationReasonMapp : (0, $daed53313d551114$export$c62558b199e46828).Unknown,
        time: (_details$receivedAt = details.receivedAt) !== null && _details$receivedAt !== void 0 ? _details$receivedAt : Date.now()
    };
};
var $fa64713f218e0a46$export$55fd683752d01e67 = function migrateSecondaryExposures(secondaryExposures) {
    return secondaryExposures.map(function(exposure) {
        if (typeof exposure === 'string') // This should ideally have gateValue and ruleID fields too, but it's not possible for us
        // to determine the correct values for these.
        return {
            gate: exposure
        };
        return exposure;
    });
};


var $e4f57e77fd83c4ca$export$6dc24881a3d96325 = /*#__PURE__*/ function() {
    function DynamicConfig(configName, configValue, ruleID, evaluationDetails) {
        var secondaryExposures = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : [];
        var allocatedExperimentName = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : '';
        var onDefaultValueFallback = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : null;
        (0, $9ba5074f09554cd6$export$2e2bcd8739ae039)(this, DynamicConfig);
        this.value = configValue;
        this._name = configName;
        this._ruleID = ruleID;
        this._secondaryExposures = secondaryExposures;
        this._allocatedExperimentName = allocatedExperimentName;
        this._evaluationDetails = evaluationDetails;
        this._onDefaultValueFallback = onDefaultValueFallback;
    }
    return (0, $920934557ff0cee7$export$2e2bcd8739ae039)(DynamicConfig, [
        {
            key: "get",
            value: function get(key, defaultValue, typeGuard) {
                var _this$_onDefaultValue2;
                var val = this.getValue(key, defaultValue);
                if (val == null) return defaultValue;
                var expectedType = Array.isArray(defaultValue) ? 'array' : (0, $08eb341cc44a6255$export$2e2bcd8739ae039)(defaultValue);
                var actualType = Array.isArray(val) ? 'array' : (0, $08eb341cc44a6255$export$2e2bcd8739ae039)(val);
                if (typeGuard) {
                    var _this$_onDefaultValue;
                    if (typeGuard(val)) {
                        this.fireExposure(key);
                        return val;
                    }
                    (_this$_onDefaultValue = this._onDefaultValueFallback) === null || _this$_onDefaultValue === void 0 || _this$_onDefaultValue.call(this, this, key, expectedType, actualType);
                    return defaultValue;
                }
                if (defaultValue == null || expectedType === actualType) {
                    this.fireExposure(key);
                    return val;
                }
                (_this$_onDefaultValue2 = this._onDefaultValueFallback) === null || _this$_onDefaultValue2 === void 0 || _this$_onDefaultValue2.call(this, this, key, expectedType, actualType);
                return defaultValue;
            }
        },
        {
            key: "getValue",
            value: function getValue(key, defaultValue) {
                if (key == null) return this.value;
                if (defaultValue == null) defaultValue = null;
                if (this.value[key] == null) return defaultValue;
                this.fireExposure(key);
                return this.value[key];
            }
        },
        {
            key: "fireExposure",
            value: function fireExposure(key) {
                // Call the wrapped experiment's get method to fire exposure
                if (this.experiment) this.experiment.get(key);
            }
        }
    ], [
        {
            key: "fromExperiment",
            value: function fromExperiment(experiment) {
                var _experiment$__evaluat, _experiment$__evaluat2, _experiment$groupName;
                var config = new DynamicConfig(experiment.name, experiment.value, experiment.ruleID, (0, $fa64713f218e0a46$export$18ad168d3dbac899)(experiment.details), (0, $fa64713f218e0a46$export$55fd683752d01e67)((_experiment$__evaluat = (_experiment$__evaluat2 = experiment.__evaluation) === null || _experiment$__evaluat2 === void 0 ? void 0 : _experiment$__evaluat2.secondary_exposures) !== null && _experiment$__evaluat !== void 0 ? _experiment$__evaluat : []), (_experiment$groupName = experiment.groupName) !== null && _experiment$groupName !== void 0 ? _experiment$groupName : undefined);
                config.experiment = experiment;
                return config;
            }
        }
    ]);
}();






var $1f2f97b02404f5c6$export$936d0764594b6eb3 = /*#__PURE__*/ function() {
    function Layer(name, layerValue, ruleID, evaluationDetails) {
        var logParameterFunction = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;
        var secondaryExposures = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : [];
        var undelegatedSecondaryExposures = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : [];
        var allocatedExperimentName = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : '';
        var explicitParameters = arguments.length > 8 && arguments[8] !== undefined ? arguments[8] : [];
        (0, $9ba5074f09554cd6$export$2e2bcd8739ae039)(this, Layer);
        this._logParameterFunction = logParameterFunction;
        this._name = name;
        this._value = JSON.parse(JSON.stringify(layerValue !== null && layerValue !== void 0 ? layerValue : {}));
        this._ruleID = ruleID !== null && ruleID !== void 0 ? ruleID : '';
        this._evaluationDetails = evaluationDetails;
        this._secondaryExposures = secondaryExposures;
        this._undelegatedSecondaryExposures = undelegatedSecondaryExposures;
        this._allocatedExperimentName = allocatedExperimentName;
        this._explicitParameters = explicitParameters;
    }
    return (0, $920934557ff0cee7$export$2e2bcd8739ae039)(Layer, [
        {
            key: "get",
            value: function get(key, defaultValue, typeGuard) {
                var _this = this;
                var val = this._value[key];
                if (val == null) return defaultValue;
                var logAndReturn = function logAndReturn() {
                    _this._logLayerParameterExposure(key);
                    return val;
                };
                if (typeGuard) return typeGuard(val) ? logAndReturn() : defaultValue;
                if (defaultValue == null) return logAndReturn();
                if ((0, $08eb341cc44a6255$export$2e2bcd8739ae039)(val) === (0, $08eb341cc44a6255$export$2e2bcd8739ae039)(defaultValue) && Array.isArray(defaultValue) === Array.isArray(val)) return logAndReturn();
                return defaultValue;
            }
        },
        {
            key: "getValue",
            value: function getValue(key, defaultValue) {
                // eslint-disable-next-line eqeqeq
                if (defaultValue == undefined) defaultValue = null;
                var val = this._value[key];
                if (val != null) this._logLayerParameterExposure(key);
                return val !== null && val !== void 0 ? val : defaultValue;
            }
        },
        {
            key: "_logLayerParameterExposure",
            value: function _logLayerParameterExposure(parameterName) {
                var _this$_logParameterFu;
                (_this$_logParameterFu = this._logParameterFunction) === null || _this$_logParameterFu === void 0 || _this$_logParameterFu.call(this, this, parameterName);
            }
        }
    ], [
        {
            key: "fromLayer",
            value: function fromLayer(layer) {
                var _layer$__evaluation$s, _layer$__evaluation, _layer$__evaluation$u, _layer$__evaluation2, _layer$__evaluation3, _layer$__evaluation4;
                var value = new Layer(layer.name, layer.__value, layer.ruleID, (0, $fa64713f218e0a46$export$18ad168d3dbac899)(layer.details), function(_layer, parameterName) {
                    return layer.get(parameterName);
                }, (0, $fa64713f218e0a46$export$55fd683752d01e67)((_layer$__evaluation$s = (_layer$__evaluation = layer.__evaluation) === null || _layer$__evaluation === void 0 ? void 0 : _layer$__evaluation.secondary_exposures) !== null && _layer$__evaluation$s !== void 0 ? _layer$__evaluation$s : []), (0, $fa64713f218e0a46$export$55fd683752d01e67)((_layer$__evaluation$u = (_layer$__evaluation2 = layer.__evaluation) === null || _layer$__evaluation2 === void 0 ? void 0 : _layer$__evaluation2.undelegated_secondary_exposures) !== null && _layer$__evaluation$u !== void 0 ? _layer$__evaluation$u : []), (_layer$__evaluation3 = layer.__evaluation) === null || _layer$__evaluation3 === void 0 ? void 0 : _layer$__evaluation3.allocated_experiment_name, (_layer$__evaluation4 = layer.__evaluation) === null || _layer$__evaluation4 === void 0 ? void 0 : _layer$__evaluation4.explicit_parameters);
                return value;
            }
        }
    ]);
}();









/// <reference types="node" />
var $7115a1d3826eff23$export$a59f8d67326bd1cb = "5.8.0";









function $ec3883b0f432cc61$export$2e2bcd8739ae039(t) {
    try {
        return -1 !== Function.toString.call(t).indexOf("[native code]");
    } catch (n) {
        return "function" == typeof t;
    }
}


function $de6453e4e88c3286$export$2e2bcd8739ae039() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($de6453e4e88c3286$export$2e2bcd8739ae039 = function _isNativeReflectConstruct() {
        return !!t;
    })();
}



function $4d3994eba11cea5d$export$2e2bcd8739ae039(t, e, r) {
    if ((0, $de6453e4e88c3286$export$2e2bcd8739ae039)()) return Reflect.construct.apply(null, arguments);
    var o = [
        null
    ];
    o.push.apply(o, e);
    var p = new (t.bind.apply(t, o))();
    return r && (0, $1609f1dc706fdd9d$export$2e2bcd8739ae039)(p, r.prototype), p;
}


function $9b1a2ab93b341559$export$2e2bcd8739ae039(t) {
    var r = "function" == typeof Map ? new Map() : void 0;
    return $9b1a2ab93b341559$export$2e2bcd8739ae039 = function _wrapNativeSuper(t) {
        if (null === t || !(0, $ec3883b0f432cc61$export$2e2bcd8739ae039)(t)) return t;
        if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function");
        if (void 0 !== r) {
            if (r.has(t)) return r.get(t);
            r.set(t, Wrapper);
        }
        function Wrapper() {
            return (0, $4d3994eba11cea5d$export$2e2bcd8739ae039)(t, arguments, (0, $4753b89c96b5d03b$export$2e2bcd8739ae039)(this).constructor);
        }
        return Wrapper.prototype = Object.create(t.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: !1,
                writable: !0,
                configurable: !0
            }
        }), (0, $1609f1dc706fdd9d$export$2e2bcd8739ae039)(Wrapper, t);
    }, $9b1a2ab93b341559$export$2e2bcd8739ae039(t);
}


function $3cdc3f5dee9e21aa$var$_callSuper(t, o, e) {
    return o = (0, $4753b89c96b5d03b$export$2e2bcd8739ae039)(o), (0, $916d1780331a30aa$export$2e2bcd8739ae039)(t, $3cdc3f5dee9e21aa$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, $4753b89c96b5d03b$export$2e2bcd8739ae039)(t).constructor) : o.apply(t, e));
}
function $3cdc3f5dee9e21aa$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($3cdc3f5dee9e21aa$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $3cdc3f5dee9e21aa$export$286baf652d0b1206 = /*#__PURE__*/ function(_Error) {
    function ResponseError(message) {
        (0, $9ba5074f09554cd6$export$2e2bcd8739ae039)(this, ResponseError);
        return $3cdc3f5dee9e21aa$var$_callSuper(this, ResponseError, [
            message
        ]);
    }
    (0, $908cdaf31c7766dc$export$2e2bcd8739ae039)(ResponseError, _Error);
    return (0, $920934557ff0cee7$export$2e2bcd8739ae039)(ResponseError);
}(/*#__PURE__*/ (0, $9b1a2ab93b341559$export$2e2bcd8739ae039)(Error));


function $fa4dabecf67d548e$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $fa4dabecf67d548e$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $fa4dabecf67d548e$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $90d31be1abcfa6da$export$2e2bcd8739ae039)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $fa4dabecf67d548e$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $fa4dabecf67d548e$var$DEFAULT_REQUEST_TIMEOUT_MS = 5000;
var $fa4dabecf67d548e$export$250a58ecde616daa = 'https://api.atlassian.com/flags';
var $fa4dabecf67d548e$export$942ba04389b0d5a2 = 'https://api.stg.atlassian.com/flags';
var $fa4dabecf67d548e$export$f058dbf75c3bc647 = 'https://api.dev.atlassian.com/flags';
var $fa4dabecf67d548e$export$1a401a0da8da3565 = 'https://api.stg.atlassian-us-gov-mod.com/flags';
var $fa4dabecf67d548e$export$18c93900db9358a4 = 'https://api.atlassian-us-gov-mod.com/flags';
var $fa4dabecf67d548e$export$4e8a0415edbfa1f7 = 'https://atlassian-statsig-proxy-archetype.atl-paas.%s.atl-ic.net';
var $fa4dabecf67d548e$export$cb3cd156f70d7e94 = 'oasis-stg.com/flags';
var $fa4dabecf67d548e$export$921fbc6cdfd4eee0 = 'atlassian-isolated.net/flags';
var $fa4dabecf67d548e$export$450bd8fb2a6d7ace = '/gateway/api/flags';
var $fa4dabecf67d548e$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function Fetcher() {
        (0, $9ba5074f09554cd6$export$2e2bcd8739ae039)(this, Fetcher);
    }
    return (0, $920934557ff0cee7$export$2e2bcd8739ae039)(Fetcher, null, [
        {
            key: "fetchClientSdk",
            value: function() {
                var _fetchClientSdk = (0, $d650e45c9b3d04ba$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ff592c69388acc86$exports))).mark(function _callee(fetcherOptions) {
                    var targetApp, url, _t;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($ff592c69388acc86$exports))).wrap(function(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                targetApp = fetcherOptions.targetApp;
                                url = "/api/v2/frontend/clientSdkKey/".concat(targetApp);
                                _context.prev = 1;
                                _context.next = 2;
                                return this.fetchRequest(url, 'GET', fetcherOptions);
                            case 2:
                                return _context.abrupt("return", _context.sent);
                            case 3:
                                _context.prev = 3;
                                _t = _context["catch"](1);
                                if (!(_t instanceof Error)) {
                                    _context.next = 4;
                                    break;
                                }
                                throw _t;
                            case 4:
                                throw Error('Failed to retrieve client sdk key');
                            case 5:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee, this, [
                        [
                            1,
                            3
                        ]
                    ]);
                }));
                function fetchClientSdk(_x) {
                    return _fetchClientSdk.apply(this, arguments);
                }
                return fetchClientSdk;
            }()
        },
        {
            key: "fetchExperimentValues",
            value: function() {
                var _fetchExperimentValues = (0, $d650e45c9b3d04ba$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ff592c69388acc86$exports))).mark(function _callee2(fetcherOptions, identifiers, customAttributes) {
                    var requestBody, _t2;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($ff592c69388acc86$exports))).wrap(function(_context2) {
                        while(true)switch(_context2.prev = _context2.next){
                            case 0:
                                requestBody = {
                                    identifiers: identifiers,
                                    customAttributes: customAttributes,
                                    targetApp: fetcherOptions.targetApp
                                };
                                _context2.prev = 1;
                                _context2.next = 2;
                                return this.fetchRequest('/api/v2/frontend/experimentValues', 'POST', fetcherOptions, requestBody);
                            case 2:
                                return _context2.abrupt("return", _context2.sent);
                            case 3:
                                _context2.prev = 3;
                                _t2 = _context2["catch"](1);
                                if (!(_t2 instanceof Error)) {
                                    _context2.next = 4;
                                    break;
                                }
                                throw _t2;
                            case 4:
                                throw Error('Failed to retrieve experiment values');
                            case 5:
                            case "end":
                                return _context2.stop();
                        }
                    }, _callee2, this, [
                        [
                            1,
                            3
                        ]
                    ]);
                }));
                function fetchExperimentValues(_x2, _x3, _x4) {
                    return _fetchExperimentValues.apply(this, arguments);
                }
                return fetchExperimentValues;
            }()
        },
        {
            key: "handleResponseError",
            value: function() {
                var _handleResponseError = (0, $d650e45c9b3d04ba$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ff592c69388acc86$exports))).mark(function _callee3(response) {
                    var body;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($ff592c69388acc86$exports))).wrap(function(_context3) {
                        while(true)switch(_context3.prev = _context3.next){
                            case 0:
                                if (response.ok) {
                                    _context3.next = 2;
                                    break;
                                }
                                _context3.next = 1;
                                return response.text();
                            case 1:
                                body = _context3.sent;
                                throw new (0, $3cdc3f5dee9e21aa$export$286baf652d0b1206)("Non 2xx response status received, status: ".concat(response.status, ", body: ").concat(JSON.stringify(body)));
                            case 2:
                                if (!(response.status === 204)) {
                                    _context3.next = 3;
                                    break;
                                }
                                throw new (0, $3cdc3f5dee9e21aa$export$286baf652d0b1206)('Unexpected 204 response');
                            case 3:
                            case "end":
                                return _context3.stop();
                        }
                    }, _callee3);
                }));
                function handleResponseError(_x5) {
                    return _handleResponseError.apply(this, arguments);
                }
                return handleResponseError;
            }()
        },
        {
            key: "extractResponseBody",
            value: function() {
                var _extractResponseBody = (0, $d650e45c9b3d04ba$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ff592c69388acc86$exports))).mark(function _callee4(response) {
                    var value;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($ff592c69388acc86$exports))).wrap(function(_context4) {
                        while(true)switch(_context4.prev = _context4.next){
                            case 0:
                                _context4.next = 1;
                                return response.text();
                            case 1:
                                value = _context4.sent;
                                return _context4.abrupt("return", JSON.parse(value));
                            case 2:
                            case "end":
                                return _context4.stop();
                        }
                    }, _callee4);
                }));
                function extractResponseBody(_x6) {
                    return _extractResponseBody.apply(this, arguments);
                }
                return extractResponseBody;
            }()
        },
        {
            key: "getBaseUrl",
            value: function getBaseUrl(serviceEnv) {
                var useGatewayUrl = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
                var perimeter = arguments.length > 2 ? arguments[2] : undefined;
                var isolationContextId = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
                if (useGatewayUrl) return $fa4dabecf67d548e$export$450bd8fb2a6d7ace;
                if (perimeter === (0, $9b5324b6988a1977$export$c42b7bbc5e7ba555).FEDRAMP_MODERATE) switch(serviceEnv){
                    case (0, $9b5324b6988a1977$export$479e7351a733299).Production:
                        return $fa4dabecf67d548e$export$18c93900db9358a4;
                    case (0, $9b5324b6988a1977$export$479e7351a733299).Staging:
                        return $fa4dabecf67d548e$export$1a401a0da8da3565;
                    default:
                        throw new Error("Invalid environment \"".concat(serviceEnv, "\" for \"").concat(perimeter, "\" perimeter"));
                }
                else if (perimeter === (0, $9b5324b6988a1977$export$c42b7bbc5e7ba555).COMMERCIAL) switch(serviceEnv){
                    case (0, $9b5324b6988a1977$export$479e7351a733299).Development:
                        return $fa4dabecf67d548e$export$f058dbf75c3bc647;
                    case (0, $9b5324b6988a1977$export$479e7351a733299).Staging:
                        var apiUrl = this.getApiUrl(isolationContextId);
                        if (apiUrl !== null) return apiUrl;
                        return $fa4dabecf67d548e$export$942ba04389b0d5a2;
                    default:
                        var prodApiUrl = this.getApiUrl(isolationContextId);
                        if (prodApiUrl !== null) return prodApiUrl;
                        return $fa4dabecf67d548e$export$250a58ecde616daa;
                }
                else throw new Error("Invalid perimeter \"".concat(perimeter, "\""));
            }
        },
        {
            key: "fetchRequest",
            value: function() {
                var _fetchRequest = (0, $d650e45c9b3d04ba$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ff592c69388acc86$exports))).mark(function _callee5(path, method, fetcherOptions, body) {
                    var baseUrl, fetchTimeout, abortSignal, abortController, response;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($ff592c69388acc86$exports))).wrap(function(_context5) {
                        while(true)switch(_context5.prev = _context5.next){
                            case 0:
                                baseUrl = Fetcher.getBaseUrl(fetcherOptions.environment, fetcherOptions.useGatewayURL, fetcherOptions.perimeter, fetcherOptions.isolationContextId);
                                fetchTimeout = fetcherOptions.fetchTimeoutMs || $fa4dabecf67d548e$var$DEFAULT_REQUEST_TIMEOUT_MS;
                                if (AbortSignal.timeout) abortSignal = AbortSignal.timeout(fetchTimeout);
                                else if (AbortController) {
                                    abortController = new AbortController();
                                    abortSignal = abortController.signal;
                                    setTimeout(function() {
                                        return abortController.abort();
                                    }, fetchTimeout);
                                }
                                _context5.next = 1;
                                return fetch("".concat(baseUrl).concat(path), $fa4dabecf67d548e$var$_objectSpread({
                                    method: method,
                                    headers: {
                                        'Content-Type': 'application/json',
                                        'X-Client-Name': 'feature-gate-js-client',
                                        'X-Client-Version': (0, $7115a1d3826eff23$export$a59f8d67326bd1cb),
                                        'X-API-KEY': fetcherOptions.apiKey
                                    },
                                    signal: abortSignal
                                }, body && {
                                    body: JSON.stringify(body)
                                }));
                            case 1:
                                response = _context5.sent;
                                _context5.next = 2;
                                return this.handleResponseError(response);
                            case 2:
                                _context5.next = 3;
                                return this.extractResponseBody(response);
                            case 3:
                                return _context5.abrupt("return", _context5.sent);
                            case 4:
                            case "end":
                                return _context5.stop();
                        }
                    }, _callee5, this);
                }));
                function fetchRequest(_x7, _x8, _x9, _x0) {
                    return _fetchRequest.apply(this, arguments);
                }
                return fetchRequest;
            }()
        },
        {
            key: "getApiUrl",
            value: function getApiUrl(isolationContextId) {
                var window1 = this.getWindowLocation();
                if (window1 === undefined) {
                    //this is needed when this SDK is used for SSR or plugin use cases where secret keys not available to use backend SDKs
                    if (!isolationContextId) return null;
                    return $fa4dabecf67d548e$export$4e8a0415edbfa1f7.replace('%s', isolationContextId);
                }
                var protocol = window1.protocol, hostname = window1.hostname;
                // Match last subdomain fragment before oasis-stg.com
                var oasisMatch = hostname.match(/([^.]+)\.oasis-stg\.com$/);
                if (oasisMatch) return "".concat(protocol, "//api.").concat(oasisMatch[1], ".").concat($fa4dabecf67d548e$export$cb3cd156f70d7e94);
                // Match last subdomain fragment before atlassian-isolated.net
                var isolatedMatch = hostname.match(/([^.]+)\.atlassian-isolated\.net$/);
                if (isolatedMatch) return "".concat(protocol, "//api.").concat(isolatedMatch[1], ".").concat($fa4dabecf67d548e$export$921fbc6cdfd4eee0);
                return null;
            }
        },
        {
            key: "getWindowLocation",
            value: function getWindowLocation() {
                if (typeof window !== 'undefined' && window.location) return window.location;
                return undefined;
            }
        }
    ]);
}();








function $bc873454f15d0611$export$2e2bcd8739ae039(t, o) {
    for(; !({}).hasOwnProperty.call(t, o) && null !== (t = (0, $4753b89c96b5d03b$export$2e2bcd8739ae039)(t)););
    return t;
}


function $72a57512c47d7aa1$export$2e2bcd8739ae039() {
    return $72a57512c47d7aa1$export$2e2bcd8739ae039 = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function(e, t, r) {
        var p = (0, $bc873454f15d0611$export$2e2bcd8739ae039)(e, t);
        if (p) {
            var n = Object.getOwnPropertyDescriptor(p, t);
            return n.get ? n.get.call(arguments.length < 3 ? e : r) : n.value;
        }
    }, $72a57512c47d7aa1$export$2e2bcd8739ae039.apply(null, arguments);
}






var $iFR7a = parcelRequire("iFR7a");
function $a36fd9c13d9e6072$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $a36fd9c13d9e6072$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $a36fd9c13d9e6072$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $90d31be1abcfa6da$export$2e2bcd8739ae039)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $a36fd9c13d9e6072$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $a36fd9c13d9e6072$var$_callSuper(t, o, e) {
    return o = (0, $4753b89c96b5d03b$export$2e2bcd8739ae039)(o), (0, $916d1780331a30aa$export$2e2bcd8739ae039)(t, $a36fd9c13d9e6072$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, $4753b89c96b5d03b$export$2e2bcd8739ae039)(t).constructor) : o.apply(t, e));
}
function $a36fd9c13d9e6072$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($a36fd9c13d9e6072$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $a36fd9c13d9e6072$var$_superPropGet(t, o, e, r) {
    var p = (0, $72a57512c47d7aa1$export$2e2bcd8739ae039)((0, $4753b89c96b5d03b$export$2e2bcd8739ae039)(1 & r ? t.prototype : t), o, e);
    return 2 & r && "function" == typeof p ? function(t) {
        return p.apply(e, t);
    } : p;
}
var $a36fd9c13d9e6072$export$55fffef3474104af = /*#__PURE__*/ function(_DataAdapterCore) {
    function NoFetchDataAdapter() {
        var _this;
        (0, $9ba5074f09554cd6$export$2e2bcd8739ae039)(this, NoFetchDataAdapter);
        _this = $a36fd9c13d9e6072$var$_callSuper(this, NoFetchDataAdapter, [
            'NoFetchDataAdapter',
            'nofetch'
        ]);
        (0, $90d31be1abcfa6da$export$2e2bcd8739ae039)(_this, "bootstrapResult", null);
        return _this;
    }
    /**
   * Make sure to call this **before** calling `initializeAsync` or `updateUserAsync` but
   * after the Statsig client has been created!
   */ (0, $908cdaf31c7766dc$export$2e2bcd8739ae039)(NoFetchDataAdapter, _DataAdapterCore);
    return (0, $920934557ff0cee7$export$2e2bcd8739ae039)(NoFetchDataAdapter, [
        {
            key: "setBootstrapData",
            value: function setBootstrapData(data) {
                this.bootstrapResult = data ? {
                    source: 'Bootstrap',
                    data: JSON.stringify(data),
                    receivedAt: Date.now(),
                    stableID: (0, $iFR7a.StableID).get(this._getSdkKey()),
                    fullUserHash: null
                } : null;
            }
        },
        {
            key: "prefetchData",
            value: function() {
                var _prefetchData = (0, $d650e45c9b3d04ba$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ff592c69388acc86$exports))).mark(function _callee(_user, _options) {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($ff592c69388acc86$exports))).wrap(function(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee);
                }));
                function prefetchData(_x, _x2) {
                    return _prefetchData.apply(this, arguments);
                }
                return prefetchData;
            }()
        },
        {
            key: "getDataAsync",
            value: function() {
                var _getDataAsync = (0, $d650e45c9b3d04ba$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ff592c69388acc86$exports))).mark(function _callee2(_current, user, _options) {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($ff592c69388acc86$exports))).wrap(function(_context2) {
                        while(true)switch(_context2.prev = _context2.next){
                            case 0:
                                return _context2.abrupt("return", this.bootstrapResult && $a36fd9c13d9e6072$var$_objectSpread($a36fd9c13d9e6072$var$_objectSpread({}, this.bootstrapResult), {}, {
                                    fullUserHash: (0, $iFR7a._getFullUserHash)(user)
                                }));
                            case 1:
                            case "end":
                                return _context2.stop();
                        }
                    }, _callee2, this);
                }));
                function getDataAsync(_x3, _x4, _x5) {
                    return _getDataAsync.apply(this, arguments);
                }
                return getDataAsync;
            }()
        },
        {
            key: "getDataSync",
            value: function getDataSync(user) {
                return this.bootstrapResult && $a36fd9c13d9e6072$var$_objectSpread($a36fd9c13d9e6072$var$_objectSpread({}, this.bootstrapResult), {}, {
                    fullUserHash: (0, $iFR7a._getFullUserHash)(user)
                });
            }
        },
        {
            key: "_fetchFromNetwork",
            value: function() {
                var _fetchFromNetwork2 = (0, $d650e45c9b3d04ba$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ff592c69388acc86$exports))).mark(function _callee3(_current, _user, _options) {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($ff592c69388acc86$exports))).wrap(function(_context3) {
                        while(true)switch(_context3.prev = _context3.next){
                            case 0:
                                return _context3.abrupt("return", null);
                            case 1:
                            case "end":
                                return _context3.stop();
                        }
                    }, _callee3);
                }));
                function _fetchFromNetwork(_x6, _x7, _x8) {
                    return _fetchFromNetwork2.apply(this, arguments);
                }
                return _fetchFromNetwork;
            }()
        },
        {
            key: "_getCacheKey",
            value: function _getCacheKey(user) {
                // Same logic as default data adapter
                // https://github.com/statsig-io/js-client-monorepo/blob/main/packages/js-client/src/StatsigEvaluationsDataAdapter.ts
                var key = (0, $iFR7a._getStorageKey)(this._getSdkKey(), user);
                return "".concat((0, $iFR7a.DataAdapterCachePrefix), ".").concat(this._cacheSuffix, ".").concat(key);
            }
        },
        {
            key: "_isCachedResultValidFor204",
            value: function _isCachedResultValidFor204(_result, _user) {
                return false;
            }
        },
        {
            key: "setDataLegacy",
            value: function setDataLegacy(data, user) {
                $a36fd9c13d9e6072$var$_superPropGet(NoFetchDataAdapter, "setData", this, 3)([
                    data,
                    user
                ]);
            }
        },
        {
            key: "toJSON",
            value: function toJSON() {
                var result = $a36fd9c13d9e6072$var$_objectSpread({}, this);
                delete result._options;
                delete result._inMemoryCache;
                delete result.bootstrapResult;
                return result;
            }
        }
    ]);
}((0, $iFR7a.DataAdapterCore));







var $dtn6l = parcelRequire("dtn6l");
function $d9b5811bfafe18be$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $d9b5811bfafe18be$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $d9b5811bfafe18be$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $90d31be1abcfa6da$export$2e2bcd8739ae039)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $d9b5811bfafe18be$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $d9b5811bfafe18be$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $d9b5811bfafe18be$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $d9b5811bfafe18be$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $d9b5811bfafe18be$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $d9b5811bfafe18be$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $d9b5811bfafe18be$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
var $d9b5811bfafe18be$var$LOCAL_OVERRIDE_REASON = 'LocalOverride:Recognized';
var $d9b5811bfafe18be$export$d8474cff104280f3 = 'STATSIG_OVERRIDES';
var $d9b5811bfafe18be$var$LEGACY_LOCAL_STORAGE_KEY = 'STATSIG_JS_LITE_LOCAL_OVERRIDES';
var $d9b5811bfafe18be$var$makeEmptyStore = function makeEmptyStore() {
    return {
        gates: {},
        configs: {},
        layers: {}
    };
};
var $d9b5811bfafe18be$var$djb2MapKey = function djb2MapKey(hash, kind) {
    return kind + ':' + hash;
};
var $d9b5811bfafe18be$export$bcb28fbac1def494 = /*#__PURE__*/ function() {
    function PersistentOverrideAdapter(localStorageKey) {
        (0, $9ba5074f09554cd6$export$2e2bcd8739ae039)(this, PersistentOverrideAdapter);
        this._overrides = $d9b5811bfafe18be$var$makeEmptyStore();
        this._djb2Map = new Map();
        this._localStorageKey = localStorageKey;
    }
    return (0, $920934557ff0cee7$export$2e2bcd8739ae039)(PersistentOverrideAdapter, [
        {
            key: "parseStoredOverrides",
            value: function parseStoredOverrides(localStorageKey) {
                try {
                    var json = window.localStorage.getItem(localStorageKey);
                    if (!json) return $d9b5811bfafe18be$var$makeEmptyStore();
                    return JSON.parse(json);
                } catch (_unused) {
                    return $d9b5811bfafe18be$var$makeEmptyStore();
                }
            }
        },
        {
            key: "mergeOverrides",
            value: function mergeOverrides() {
                var merged = $d9b5811bfafe18be$var$makeEmptyStore();
                for(var _len = arguments.length, allOverrides = new Array(_len), _key = 0; _key < _len; _key++)allOverrides[_key] = arguments[_key];
                for(var _i = 0, _allOverrides = allOverrides; _i < _allOverrides.length; _i++){
                    var overrides = _allOverrides[_i];
                    for(var _i2 = 0, _Object$entries = Object.entries((_overrides$gates = overrides.gates) !== null && _overrides$gates !== void 0 ? _overrides$gates : {}); _i2 < _Object$entries.length; _i2++){
                        var _overrides$gates;
                        var _Object$entries$_i = (0, $c99af517edc48a31$export$2e2bcd8739ae039)(_Object$entries[_i2], 2), name = _Object$entries$_i[0], value = _Object$entries$_i[1];
                        merged.gates[name] = value;
                    }
                    for(var _i3 = 0, _Object$entries2 = Object.entries((_overrides$configs = overrides.configs) !== null && _overrides$configs !== void 0 ? _overrides$configs : {}); _i3 < _Object$entries2.length; _i3++){
                        var _overrides$configs;
                        var _Object$entries2$_i = (0, $c99af517edc48a31$export$2e2bcd8739ae039)(_Object$entries2[_i3], 2), _name = _Object$entries2$_i[0], _value = _Object$entries2$_i[1];
                        merged.configs[_name] = _value;
                    }
                    for(var _i4 = 0, _Object$entries3 = Object.entries((_overrides$layers = overrides.layers) !== null && _overrides$layers !== void 0 ? _overrides$layers : {}); _i4 < _Object$entries3.length; _i4++){
                        var _overrides$layers;
                        var _Object$entries3$_i = (0, $c99af517edc48a31$export$2e2bcd8739ae039)(_Object$entries3[_i4], 2), _name2 = _Object$entries3$_i[0], _value2 = _Object$entries3$_i[1];
                        merged.layers[_name2] = _value2;
                    }
                }
                return merged;
            }
        },
        {
            key: "initFromStoredOverrides",
            value: function initFromStoredOverrides() {
                var storedOverrides = this.mergeOverrides(this._overrides, this.parseStoredOverrides($d9b5811bfafe18be$var$LEGACY_LOCAL_STORAGE_KEY), this.parseStoredOverrides(this._localStorageKey));
                // Clear data from legacy local storage key now we've read from it.
                // This prevents things being stuck in there that are always read but never written to.
                try {
                    window.localStorage.removeItem($d9b5811bfafe18be$var$LEGACY_LOCAL_STORAGE_KEY);
                } catch (_unused2) {
                // ignored - window is not defined in non-browser environments, and we don't save things there
                // (things like SSR, etc)
                }
                // In version 4.24.0 we introduced hashes in this override adapter, but had a bug which would cause
                // multiple hashes to continue being created. This code here removes these hashes since we've moved
                // to using a more reliable and easier to maintain map in `_djb2Map`.
                for(var _i5 = 0, _Object$values = Object.values(storedOverrides); _i5 < _Object$values.length; _i5++){
                    var container = _Object$values[_i5];
                    var allKeys = new Set(Object.keys(container));
                    var _iterator = $d9b5811bfafe18be$var$_createForOfIteratorHelper(allKeys), _step;
                    try {
                        for(_iterator.s(); !(_step = _iterator.n()).done;){
                            var name = _step.value;
                            var hash = (0, $dtn6l._DJB2)(name);
                            if (allKeys.has(hash)) delete container[hash];
                        }
                    } catch (err) {
                        _iterator.e(err);
                    } finally{
                        _iterator.f();
                    }
                }
                this.applyOverrides(storedOverrides);
            }
        },
        {
            key: "saveOverrides",
            value: function saveOverrides() {
                try {
                    window.localStorage.setItem(this._localStorageKey, JSON.stringify(this._overrides));
                } catch (_unused3) {
                // ignored - window is not defined in non-browser environments, and we don't save things there
                // (things like SSR, etc)
                }
            }
        },
        {
            key: "getOverrides",
            value: function getOverrides() {
                return this.mergeOverrides(this._overrides);
            }
        },
        {
            key: "applyOverrides",
            value: function applyOverrides(overrides) {
                var newOverrides = $d9b5811bfafe18be$var$_objectSpread($d9b5811bfafe18be$var$_objectSpread({}, $d9b5811bfafe18be$var$makeEmptyStore()), overrides);
                this._djb2Map.clear();
                for(var _i6 = 0, _Object$entries4 = Object.entries(newOverrides); _i6 < _Object$entries4.length; _i6++){
                    var _Object$entries4$_i = (0, $c99af517edc48a31$export$2e2bcd8739ae039)(_Object$entries4[_i6], 2), containerName = _Object$entries4$_i[0], container = _Object$entries4$_i[1];
                    for(var _i7 = 0, _Object$entries5 = Object.entries(container); _i7 < _Object$entries5.length; _i7++){
                        var _Object$entries5$_i = (0, $c99af517edc48a31$export$2e2bcd8739ae039)(_Object$entries5[_i7], 2), name = _Object$entries5$_i[0], value = _Object$entries5$_i[1];
                        this._djb2Map.set($d9b5811bfafe18be$var$djb2MapKey((0, $dtn6l._DJB2)(name), containerName), value);
                    }
                }
                this._overrides = newOverrides;
            }
        },
        {
            key: "setOverrides",
            value: function setOverrides(overrides) {
                this.applyOverrides(overrides);
                this.saveOverrides();
            }
        },
        {
            key: "overrideGate",
            value: function overrideGate(name, value) {
                this._overrides.gates[name] = value;
                this._djb2Map.set($d9b5811bfafe18be$var$djb2MapKey((0, $dtn6l._DJB2)(name), 'gates'), value);
                this.saveOverrides();
            }
        },
        {
            key: "removeGateOverride",
            value: function removeGateOverride(name) {
                delete this._overrides.gates[name];
                this._djb2Map.delete($d9b5811bfafe18be$var$djb2MapKey((0, $dtn6l._DJB2)(name), 'gates'));
                this.saveOverrides();
            }
        },
        {
            key: "getGateOverride",
            value: function getGateOverride(current, _user) {
                var _this$_overrides$gate;
                var overridden = (_this$_overrides$gate = this._overrides.gates[current.name]) !== null && _this$_overrides$gate !== void 0 ? _this$_overrides$gate : this._djb2Map.get($d9b5811bfafe18be$var$djb2MapKey(current.name, 'gates'));
                if (overridden == null) return null;
                return $d9b5811bfafe18be$var$_objectSpread($d9b5811bfafe18be$var$_objectSpread({}, current), {}, {
                    value: overridden,
                    details: $d9b5811bfafe18be$var$_objectSpread($d9b5811bfafe18be$var$_objectSpread({}, current.details), {}, {
                        reason: $d9b5811bfafe18be$var$LOCAL_OVERRIDE_REASON
                    })
                });
            }
        },
        {
            key: "overrideDynamicConfig",
            value: function overrideDynamicConfig(name, value) {
                this._overrides.configs[name] = value;
                this._djb2Map.set($d9b5811bfafe18be$var$djb2MapKey((0, $dtn6l._DJB2)(name), 'configs'), value);
                this.saveOverrides();
            }
        },
        {
            key: "removeDynamicConfigOverride",
            value: function removeDynamicConfigOverride(name) {
                delete this._overrides.configs[name];
                this._djb2Map.delete($d9b5811bfafe18be$var$djb2MapKey((0, $dtn6l._DJB2)(name), 'configs'));
                this.saveOverrides();
            }
        },
        {
            key: "getDynamicConfigOverride",
            value: function getDynamicConfigOverride(current, _user) {
                return this._getConfigOverride(current, this._overrides.configs);
            }
        },
        {
            key: "overrideExperiment",
            value: function overrideExperiment(name, value) {
                this._overrides.configs[name] = value;
                this._djb2Map.set($d9b5811bfafe18be$var$djb2MapKey((0, $dtn6l._DJB2)(name), 'configs'), value);
                this.saveOverrides();
            }
        },
        {
            key: "removeExperimentOverride",
            value: function removeExperimentOverride(name) {
                delete this._overrides.configs[name];
                this._djb2Map.delete($d9b5811bfafe18be$var$djb2MapKey((0, $dtn6l._DJB2)(name), 'configs'));
                this.saveOverrides();
            }
        },
        {
            key: "getExperimentOverride",
            value: function getExperimentOverride(current, _user) {
                return this._getConfigOverride(current, this._overrides.configs);
            }
        },
        {
            key: "overrideLayer",
            value: function overrideLayer(name, value) {
                this._overrides.layers[name] = value;
                this._djb2Map.set($d9b5811bfafe18be$var$djb2MapKey((0, $dtn6l._DJB2)(name), 'layers'), value);
                this.saveOverrides();
            }
        },
        {
            key: "removeLayerOverride",
            value: function removeLayerOverride(name) {
                delete this._overrides.layers[name];
                this._djb2Map.delete($d9b5811bfafe18be$var$djb2MapKey((0, $dtn6l._DJB2)(name), 'layers'));
                this.saveOverrides();
            }
        },
        {
            key: "removeAllOverrides",
            value: function removeAllOverrides() {
                this._overrides = $d9b5811bfafe18be$var$makeEmptyStore();
                try {
                    window.localStorage.removeItem(this._localStorageKey);
                } catch (_unused4) {
                // ignored - window is not defined in non-browser environments, and we don't save things there
                // (things like SSR, etc)
                }
            }
        },
        {
            key: "getLayerOverride",
            value: function getLayerOverride(current, _user) {
                var _this$_overrides$laye;
                var overridden = (_this$_overrides$laye = this._overrides.layers[current.name]) !== null && _this$_overrides$laye !== void 0 ? _this$_overrides$laye : this._djb2Map.get($d9b5811bfafe18be$var$djb2MapKey(current.name, 'layers'));
                if (overridden == null) return null;
                return $d9b5811bfafe18be$var$_objectSpread($d9b5811bfafe18be$var$_objectSpread({}, current), {}, {
                    __value: overridden,
                    get: (0, $dtn6l._makeTypedGet)(current.name, overridden),
                    details: $d9b5811bfafe18be$var$_objectSpread($d9b5811bfafe18be$var$_objectSpread({}, current.details), {}, {
                        reason: $d9b5811bfafe18be$var$LOCAL_OVERRIDE_REASON
                    })
                });
            }
        },
        {
            key: "_getConfigOverride",
            value: function _getConfigOverride(current, lookup) {
                var _lookup$current$name;
                var overridden = (_lookup$current$name = lookup[current.name]) !== null && _lookup$current$name !== void 0 ? _lookup$current$name : this._djb2Map.get($d9b5811bfafe18be$var$djb2MapKey(current.name, 'configs'));
                if (overridden == null) return null;
                return $d9b5811bfafe18be$var$_objectSpread($d9b5811bfafe18be$var$_objectSpread({}, current), {}, {
                    value: overridden,
                    get: (0, $dtn6l._makeTypedGet)(current.name, overridden),
                    details: $d9b5811bfafe18be$var$_objectSpread($d9b5811bfafe18be$var$_objectSpread({}, current.details), {}, {
                        reason: $d9b5811bfafe18be$var$LOCAL_OVERRIDE_REASON
                    })
                });
            }
        }
    ]);
}();





var $379f34d0db44aade$var$_excluded = [
    "sdkKey",
    "environment",
    "updateUserCompletionCallback",
    "perimeter"
];
function $379f34d0db44aade$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $379f34d0db44aade$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $379f34d0db44aade$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $90d31be1abcfa6da$export$2e2bcd8739ae039)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $379f34d0db44aade$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $379f34d0db44aade$var$DEFAULT_CLIENT_KEY = 'client-default-key';
// default event logging api is Atlassian proxy rather than Statsig's domain, to avoid ad blockers
var $379f34d0db44aade$var$DEFAULT_EVENT_LOGGING_API = 'https://xp.atlassian.com/v1/rgstr';
var $379f34d0db44aade$export$1f2bb630327ac4b6 = /*#__PURE__*/ function() {
    function Client() {
        var _this = this;
        var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, _ref$localStorageKey = _ref.localStorageKey, localStorageKey = _ref$localStorageKey === void 0 ? (0, $d9b5811bfafe18be$export$d8474cff104280f3) : _ref$localStorageKey, overrideAdapter = _ref.overrideAdapter;
        (0, $9ba5074f09554cd6$export$2e2bcd8739ae039)(this, Client);
        (0, $90d31be1abcfa6da$export$2e2bcd8739ae039)(this, "initPromise", null);
        /** True if an initialize method was called and completed successfully. */ (0, $90d31be1abcfa6da$export$2e2bcd8739ae039)(this, "initCompleted", false);
        /**
     * True if an initialize method was called and completed, meaning the client is now usable.
     * However if there was an error during initialization it may have initialized with default
     * values. Use {@link initCompleted} to check for this.
     */ (0, $90d31be1abcfa6da$export$2e2bcd8739ae039)(this, "initWithDefaults", false);
        (0, $90d31be1abcfa6da$export$2e2bcd8739ae039)(this, "hasCheckGateErrorOccurred", false);
        (0, $90d31be1abcfa6da$export$2e2bcd8739ae039)(this, "hasGetExperimentErrorOccurred", false);
        (0, $90d31be1abcfa6da$export$2e2bcd8739ae039)(this, "hasGetExperimentValueErrorOccurred", false);
        (0, $90d31be1abcfa6da$export$2e2bcd8739ae039)(this, "hasGetLayerErrorOccurred", false);
        (0, $90d31be1abcfa6da$export$2e2bcd8739ae039)(this, "hasGetLayerValueErrorOccurred", false);
        (0, $90d31be1abcfa6da$export$2e2bcd8739ae039)(this, "subscriptions", new (0, $78d0491b7a524e85$export$2e2bcd8739ae039)());
        (0, $90d31be1abcfa6da$export$2e2bcd8739ae039)(this, "dataAdapter", new (0, $a36fd9c13d9e6072$export$55fffef3474104af)());
        /**
     * Call this if modifying the values being served by the Statsig library since it has its own
     * memoization cache which will not be updated if the values are changed outside of the library.
     */ (0, $90d31be1abcfa6da$export$2e2bcd8739ae039)(this, "statsigValuesUpdated", function() {
            if (_this.user) // Trigger a reset of the memoize cache
            _this.statsigClient.updateUserSync(_this.user, {
                disableBackgroundCacheRefresh: true
            });
            _this.subscriptions.anyUpdated();
        });
        this.overrideAdapter = overrideAdapter || new (0, $d9b5811bfafe18be$export$bcb28fbac1def494)(localStorageKey);
    }
    /**
   * @description
   * This method initializes the client using a network call to fetch the bootstrap values.
   * If the client is inialized with an `analyticsWebClient`, it will send an operational event
   * to GASv3 with the following attributes:
   * - targetApp: the target app of the client
   * - clientVersion: the version of the client
   * - success: whether the initialization was successful
   * - startTime: the time when the initialization started
   * - totalTime: the total time it took to initialize the client
   * - apiKey: the api key used to initialize the client
   * @param clientOptions {ClientOptions}
   * @param identifiers {Identifiers}
   * @param customAttributes {CustomAttributes}
   * @returns {Promise<void>}
   */ return (0, $920934557ff0cee7$export$2e2bcd8739ae039)(Client, [
        {
            key: "initialize",
            value: function() {
                var _initialize = (0, $d650e45c9b3d04ba$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ff592c69388acc86$exports))).mark(function _callee(clientOptions, identifiers, customAttributes) {
                    var _this2 = this;
                    var clientOptionsWithDefaults, startTime;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($ff592c69388acc86$exports))).wrap(function(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                clientOptionsWithDefaults = (0, $fa64713f218e0a46$export$d119b37e5f788b43)(clientOptions);
                                if (!this.initPromise) {
                                    _context.next = 1;
                                    break;
                                }
                                if (!(0, $fa64713f218e0a46$export$fa1c2bbf4100b8bc)(clientOptionsWithDefaults, this.initOptions)) // eslint-disable-next-line no-console
                                console.warn('Feature Gates client already initialized with different options. New options were not applied.');
                                return _context.abrupt("return", this.initPromise);
                            case 1:
                                startTime = performance.now();
                                this.initOptions = clientOptionsWithDefaults;
                                this.initPromise = this.init(clientOptionsWithDefaults, identifiers, customAttributes).then(function() {
                                    _this2.initCompleted = true;
                                    _this2.initWithDefaults = true;
                                }).finally(function() {
                                    var endTime = performance.now();
                                    var totalTime = endTime - startTime;
                                    _this2.fireClientEvent(startTime, totalTime, 'initialize', _this2.initCompleted, clientOptionsWithDefaults.apiKey);
                                });
                                return _context.abrupt("return", this.initPromise);
                            case 2:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee, this);
                }));
                function initialize(_x, _x2, _x3) {
                    return _initialize.apply(this, arguments);
                }
                return initialize;
            }()
        },
        {
            key: "initializeWithProvider",
            value: function() {
                var _initializeWithProvider = (0, $d650e45c9b3d04ba$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ff592c69388acc86$exports))).mark(function _callee2(clientOptions, provider, identifiers, customAttributes) {
                    var _this3 = this;
                    var clientOptionsWithDefaults, startTime;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($ff592c69388acc86$exports))).wrap(function(_context2) {
                        while(true)switch(_context2.prev = _context2.next){
                            case 0:
                                clientOptionsWithDefaults = (0, $fa64713f218e0a46$export$d119b37e5f788b43)(clientOptions);
                                if (!this.initPromise) {
                                    _context2.next = 1;
                                    break;
                                }
                                if (!(0, $fa64713f218e0a46$export$fa1c2bbf4100b8bc)(clientOptionsWithDefaults, this.initOptions)) // eslint-disable-next-line no-console
                                console.warn('Feature Gates client already initialized with different options. New options were not applied.');
                                return _context2.abrupt("return", this.initPromise);
                            case 1:
                                startTime = performance.now();
                                this.initOptions = clientOptionsWithDefaults;
                                this.provider = provider;
                                this.provider.setClientVersion((0, $7115a1d3826eff23$export$a59f8d67326bd1cb));
                                if (this.provider.setApplyUpdateCallback) this.provider.setApplyUpdateCallback(this.applyUpdateCallback.bind(this));
                                this.initPromise = this.initWithProvider(clientOptionsWithDefaults, provider, identifiers, customAttributes).then(function() {
                                    _this3.initCompleted = true;
                                    _this3.initWithDefaults = true;
                                }).finally(function() {
                                    var endTime = performance.now();
                                    var totalTime = endTime - startTime;
                                    _this3.fireClientEvent(startTime, totalTime, 'initializeWithProvider', _this3.initCompleted, provider.getApiKey ? provider.getApiKey() : undefined);
                                });
                                return _context2.abrupt("return", this.initPromise);
                            case 2:
                            case "end":
                                return _context2.stop();
                        }
                    }, _callee2, this);
                }));
                function initializeWithProvider(_x4, _x5, _x6, _x7) {
                    return _initializeWithProvider.apply(this, arguments);
                }
                return initializeWithProvider;
            }()
        },
        {
            key: "applyUpdateCallback",
            value: function applyUpdateCallback(experimentsResult) {
                try {
                    if (this.initCompleted || this.initWithDefaults) {
                        this.assertInitialized(this.statsigClient);
                        this.dataAdapter.setBootstrapData(experimentsResult.experimentValues);
                        this.dataAdapter.setData(JSON.stringify(experimentsResult.experimentValues));
                        this.statsigValuesUpdated();
                    }
                } catch (error) {
                    // eslint-disable-next-line no-console
                    console.warn('Error when attempting to apply update', error);
                }
            }
        },
        {
            key: "fireClientEvent",
            value: function fireClientEvent(startTime, totalTime, action, success) {
                var _analyticsWebClient, _this4 = this;
                var apiKey = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;
                (_analyticsWebClient = this.initOptions.analyticsWebClient) === null || _analyticsWebClient === void 0 || _analyticsWebClient.then(function(analyticsWebClient) {
                    var attributes = $379f34d0db44aade$var$_objectSpread({
                        targetApp: _this4.initOptions.targetApp,
                        clientVersion: (0, $7115a1d3826eff23$export$a59f8d67326bd1cb),
                        success: success,
                        startTime: startTime,
                        totalTime: totalTime
                    }, apiKey && {
                        apiKey: apiKey
                    });
                    analyticsWebClient.sendOperationalEvent({
                        action: action,
                        actionSubject: 'featureGatesClient',
                        attributes: attributes,
                        tags: [
                            'measurement'
                        ],
                        source: '@atlaskit/feature-gate-js-client'
                    });
                }).catch(function(err) {
                    if (_this4.initOptions.environment !== (0, $9b5324b6988a1977$export$479e7351a733299).Production) // eslint-disable-next-line no-console
                    console.error('Analytics web client promise did not resolve', err);
                });
            }
        },
        {
            key: "initializeFromValues",
            value: function() {
                var _initializeFromValues = (0, $d650e45c9b3d04ba$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ff592c69388acc86$exports))).mark(function _callee3(clientOptions, identifiers, customAttributes) {
                    var _this5 = this;
                    var initializeValues, clientOptionsWithDefaults, startTime, _args3 = arguments;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($ff592c69388acc86$exports))).wrap(function(_context3) {
                        while(true)switch(_context3.prev = _context3.next){
                            case 0:
                                initializeValues = _args3.length > 3 && _args3[3] !== undefined ? _args3[3] : {};
                                clientOptionsWithDefaults = (0, $fa64713f218e0a46$export$d119b37e5f788b43)(clientOptions);
                                if (!this.initPromise) {
                                    _context3.next = 1;
                                    break;
                                }
                                if (!(0, $fa64713f218e0a46$export$fa1c2bbf4100b8bc)(clientOptionsWithDefaults, this.initOptions)) // eslint-disable-next-line no-console
                                console.warn('Feature Gates client already initialized with different options. New options were not applied.');
                                return _context3.abrupt("return", this.initPromise);
                            case 1:
                                // This makes sure the new Statsig client behaves like the old when bootstrap data is
                                // passed, and `has_updates` isn't specified (which happens a lot in product integration tests).
                                if (!Object.prototype.hasOwnProperty.call(initializeValues, 'has_updates')) initializeValues['has_updates'] = true;
                                startTime = performance.now();
                                this.initOptions = clientOptionsWithDefaults;
                                this.initPromise = this.initFromValues(clientOptionsWithDefaults, identifiers, customAttributes, initializeValues).then(function() {
                                    _this5.initCompleted = true;
                                    _this5.initWithDefaults = true;
                                }).finally(function() {
                                    var endTime = performance.now();
                                    var totalTime = endTime - startTime;
                                    _this5.fireClientEvent(startTime, totalTime, 'initializeFromValues', _this5.initCompleted);
                                });
                                return _context3.abrupt("return", this.initPromise);
                            case 2:
                            case "end":
                                return _context3.stop();
                        }
                    }, _callee3, this);
                }));
                function initializeFromValues(_x8, _x9, _x0) {
                    return _initializeFromValues.apply(this, arguments);
                }
                return initializeFromValues;
            }()
        },
        {
            key: "assertInitialized",
            value: function assertInitialized(statsigClient) {
                if (!statsigClient) throw new Error('Client must be initialized before using this method');
            }
        },
        {
            key: "updateUser",
            value: function() {
                var _updateUser = (0, $d650e45c9b3d04ba$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ff592c69388acc86$exports))).mark(function _callee4(fetchOptions, identifiers, customAttributes) {
                    var fetchOptionsWithDefaults, initializeValuesProducer;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($ff592c69388acc86$exports))).wrap(function(_context4) {
                        while(true)switch(_context4.prev = _context4.next){
                            case 0:
                                this.assertInitialized(this.statsigClient);
                                fetchOptionsWithDefaults = (0, $fa64713f218e0a46$export$d119b37e5f788b43)(fetchOptions);
                                initializeValuesProducer = function initializeValuesProducer() {
                                    return (0, $fa4dabecf67d548e$export$2e2bcd8739ae039).fetchExperimentValues(fetchOptionsWithDefaults, identifiers, customAttributes).then(function(_ref2) {
                                        var experimentValues = _ref2.experimentValues, customAttributes = _ref2.customAttributes;
                                        return {
                                            experimentValues: experimentValues,
                                            customAttributesFromFetch: customAttributes
                                        };
                                    });
                                };
                                _context4.next = 1;
                                return this.updateUserUsingInitializeValuesProducer(initializeValuesProducer, identifiers, customAttributes);
                            case 1:
                            case "end":
                                return _context4.stop();
                        }
                    }, _callee4, this);
                }));
                function updateUser(_x1, _x10, _x11) {
                    return _updateUser.apply(this, arguments);
                }
                return updateUser;
            }()
        },
        {
            key: "updateUserWithProvider",
            value: function() {
                var _updateUserWithProvider = (0, $d650e45c9b3d04ba$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ff592c69388acc86$exports))).mark(function _callee5(identifiers, customAttributes) {
                    var _this6 = this;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($ff592c69388acc86$exports))).wrap(function(_context5) {
                        while(true)switch(_context5.prev = _context5.next){
                            case 0:
                                this.assertInitialized(this.statsigClient);
                                if (this.provider) {
                                    _context5.next = 1;
                                    break;
                                }
                                throw new Error('Cannot update user using provider as the client was not initialised with a provider');
                            case 1:
                                _context5.next = 2;
                                return this.provider.setProfile(this.initOptions, identifiers, customAttributes);
                            case 2:
                                _context5.next = 3;
                                return this.updateUserUsingInitializeValuesProducer(function() {
                                    return _this6.provider.getExperimentValues();
                                }, identifiers, customAttributes);
                            case 3:
                            case "end":
                                return _context5.stop();
                        }
                    }, _callee5, this);
                }));
                function updateUserWithProvider(_x12, _x13) {
                    return _updateUserWithProvider.apply(this, arguments);
                }
                return updateUserWithProvider;
            }()
        },
        {
            key: "updateUserWithValues",
            value: function() {
                var _updateUserWithValues = (0, $d650e45c9b3d04ba$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ff592c69388acc86$exports))).mark(function _callee6(identifiers, customAttributes) {
                    var initializeValues, initializeValuesProducer, _args6 = arguments;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($ff592c69388acc86$exports))).wrap(function(_context6) {
                        while(true)switch(_context6.prev = _context6.next){
                            case 0:
                                initializeValues = _args6.length > 2 && _args6[2] !== undefined ? _args6[2] : {};
                                this.assertInitialized(this.statsigClient);
                                initializeValuesProducer = function initializeValuesProducer() {
                                    return Promise.resolve({
                                        experimentValues: initializeValues,
                                        customAttributesFromFetch: customAttributes
                                    });
                                };
                                _context6.next = 1;
                                return this.updateUserUsingInitializeValuesProducer(initializeValuesProducer, identifiers, customAttributes);
                            case 1:
                            case "end":
                                return _context6.stop();
                        }
                    }, _callee6, this);
                }));
                function updateUserWithValues(_x14, _x15) {
                    return _updateUserWithValues.apply(this, arguments);
                }
                return updateUserWithValues;
            }()
        },
        {
            key: "initializeCalled",
            value: function initializeCalled() {
                return this.initPromise != null;
            }
        },
        {
            key: "initializeCompleted",
            value: function initializeCompleted() {
                return this.initCompleted;
            }
        },
        {
            key: "waitUntilInitializeCompleted",
            value: function() {
                var _waitUntilInitializeCompleted = (0, $d650e45c9b3d04ba$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ff592c69388acc86$exports))).mark(function _callee7() {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($ff592c69388acc86$exports))).wrap(function(_context7) {
                        while(true)switch(_context7.prev = _context7.next){
                            case 0:
                                if (this.initPromise) {
                                    _context7.next = 1;
                                    break;
                                }
                                throw new Error('The client must be initialized before you can wait until initialized.');
                            case 1:
                                if (!this.initCompleted) {
                                    _context7.next = 2;
                                    break;
                                }
                                return _context7.abrupt("return");
                            case 2:
                                _context7.next = 3;
                                return this.initPromise;
                            case 3:
                            case "end":
                                return _context7.stop();
                        }
                    }, _callee7, this);
                }));
                function waitUntilInitializeCompleted() {
                    return _waitUntilInitializeCompleted.apply(this, arguments);
                }
                return waitUntilInitializeCompleted;
            }()
        },
        {
            key: "checkGate",
            value: function checkGate(gateName) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                try {
                    this.assertInitialized(this.statsigClient);
                    var _options$fireGateExpo = options.fireGateExposure, fireGateExposure = _options$fireGateExpo === void 0 ? true : _options$fireGateExpo;
                    return this.statsigClient.checkGate(gateName, {
                        disableExposureLog: !fireGateExposure
                    });
                } catch (error) {
                    // Log the first occurrence of the error
                    if (!this.hasCheckGateErrorOccurred) {
                        // eslint-disable-next-line no-console
                        console.warn({
                            msg: 'An error has occurred checking the feature gate. Only the first occurrence of this error is logged.',
                            gateName: gateName,
                            error: error
                        });
                        this.hasCheckGateErrorOccurred = true;
                    }
                    return false;
                }
            }
        },
        {
            key: "isGateExist",
            value: function isGateExist(gateName) {
                try {
                    this.assertInitialized(this.statsigClient);
                    var gate = this.statsigClient.getFeatureGate(gateName, {
                        disableExposureLog: true
                    });
                    return !gate.details.reason.includes('Unrecognized');
                } catch (error) {
                    // eslint-disable-next-line no-console
                    console.error("Error occurred when trying to check FeatureGate: ".concat(error));
                    // in case of error report true to avoid false positives.
                    return true;
                }
            }
        },
        {
            key: "isExperimentExist",
            value: function isExperimentExist(experimentName) {
                try {
                    this.assertInitialized(this.statsigClient);
                    var config = this.statsigClient.getExperiment(experimentName, {
                        disableExposureLog: true
                    });
                    return !config.details.reason.includes('Unrecognized');
                } catch (error) {
                    // eslint-disable-next-line no-console
                    console.error("Error occurred when trying to check Experiment: ".concat(error));
                    // in case of error report true to avoid false positives.
                    return true;
                }
            }
        },
        {
            key: "manuallyLogGateExposure",
            value: function manuallyLogGateExposure(gateName) {
                this.assertInitialized(this.statsigClient);
                // This is the approach recommended in the docs
                // https://docs.statsig.com/client/javascript-sdk/#manual-exposures-
                this.statsigClient.checkGate(gateName);
            }
        },
        {
            key: "getExperiment",
            value: function getExperiment(experimentName) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                try {
                    this.assertInitialized(this.statsigClient);
                    var _options$fireExperime = options.fireExperimentExposure, fireExperimentExposure = _options$fireExperime === void 0 ? true : _options$fireExperime;
                    return (0, $e4f57e77fd83c4ca$export$6dc24881a3d96325).fromExperiment(this.statsigClient.getExperiment(experimentName, {
                        disableExposureLog: !fireExperimentExposure
                    }));
                } catch (error) {
                    // Log the first occurrence of the error
                    if (!this.hasGetExperimentErrorOccurred) {
                        // eslint-disable-next-line no-console
                        console.warn({
                            msg: 'An error has occurred getting the experiment. Only the first occurrence of this error is logged.',
                            experimentName: experimentName,
                            error: error
                        });
                        this.hasGetExperimentErrorOccurred = true;
                    }
                    // Return a default value
                    return new (0, $e4f57e77fd83c4ca$export$6dc24881a3d96325)(experimentName, {}, '', {
                        time: Date.now(),
                        reason: (0, $daed53313d551114$export$c62558b199e46828).Error
                    });
                }
            }
        },
        {
            key: "getExperimentValue",
            value: function getExperimentValue(experimentName, parameterName, defaultValue) {
                var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var experiment = this.getExperiment(experimentName, options);
                try {
                    var typeGuard = options.typeGuard;
                    return experiment.get(parameterName, defaultValue, typeGuard);
                } catch (error) {
                    // Log the first occurrence of the error
                    if (!this.hasGetExperimentValueErrorOccurred) {
                        // eslint-disable-next-line no-console
                        console.warn({
                            msg: 'An error has occurred getting the experiment value. Only the first occurrence of this error is logged.',
                            experimentName: experimentName,
                            defaultValue: defaultValue,
                            options: options,
                            error: error
                        });
                        this.hasGetExperimentValueErrorOccurred = true;
                    }
                    return defaultValue;
                }
            }
        },
        {
            key: "manuallyLogExperimentExposure",
            value: function manuallyLogExperimentExposure(experimentName) {
                this.assertInitialized(this.statsigClient);
                // This is the approach recommended in the docs
                // https://docs.statsig.com/client/javascript-sdk/#manual-exposures-
                this.statsigClient.getExperiment(experimentName);
            }
        },
        {
            key: "manuallyLogLayerExposure",
            value: function manuallyLogLayerExposure(layerName, parameterName) {
                var _this$statsigClient$g;
                this.assertInitialized(this.statsigClient);
                // This is the approach recommended in the docs
                // https://docs.statsig.com/client/javascript-sdk/#manual-exposures-
                (_this$statsigClient$g = this.statsigClient.getLayer(layerName)) === null || _this$statsigClient$g === void 0 || _this$statsigClient$g.get(parameterName);
            }
        },
        {
            key: "shutdownStatsig",
            value: function shutdownStatsig() {
                this.assertInitialized(this.statsigClient);
                this.statsigClient.shutdown();
            }
        },
        {
            key: "overrideGate",
            value: function overrideGate(gateName, value) {
                this.overrideAdapter.overrideGate(gateName, value);
                // Trigger a reset of the memoized gate value
                if (this.user) {
                    var _this$statsigClient;
                    (_this$statsigClient = this.statsigClient) === null || _this$statsigClient === void 0 || _this$statsigClient.updateUserSync(this.user, {
                        disableBackgroundCacheRefresh: true
                    });
                }
                this.statsigValuesUpdated();
            }
        },
        {
            key: "clearGateOverride",
            value: function clearGateOverride(gateName) {
                this.overrideAdapter.removeGateOverride(gateName);
                this.statsigValuesUpdated();
            }
        },
        {
            key: "overrideConfig",
            value: function overrideConfig(experimentName, values) {
                this.overrideAdapter.overrideDynamicConfig(experimentName, values);
                this.statsigValuesUpdated();
            }
        },
        {
            key: "clearConfigOverride",
            value: function clearConfigOverride(experimentName) {
                this.overrideAdapter.removeDynamicConfigOverride(experimentName);
                this.statsigValuesUpdated();
            }
        },
        {
            key: "setOverrides",
            value: function setOverrides(overrides) {
                this.overrideAdapter.setOverrides(overrides);
                this.statsigValuesUpdated();
            }
        },
        {
            key: "getOverrides",
            value: function getOverrides() {
                return this.overrideAdapter.getOverrides();
            }
        },
        {
            key: "clearAllOverrides",
            value: function clearAllOverrides() {
                this.overrideAdapter.removeAllOverrides();
                this.statsigValuesUpdated();
            }
        },
        {
            key: "isCurrentUser",
            value: function isCurrentUser(identifiers, customAttributes) {
                return (0, $fa64713f218e0a46$export$fa1c2bbf4100b8bc)(this.currentIdentifiers, identifiers) && (0, $fa64713f218e0a46$export$fa1c2bbf4100b8bc)(this.currentAttributes, customAttributes);
            }
        },
        {
            key: "onGateUpdated",
            value: function onGateUpdated(gateName, callback) {
                var _this7 = this;
                var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                var wrapCallback = function wrapCallback(value) {
                    var _options$fireGateExpo2 = options.fireGateExposure, fireGateExposure = _options$fireGateExpo2 === void 0 ? true : _options$fireGateExpo2;
                    if (fireGateExposure) _this7.manuallyLogGateExposure(gateName);
                    try {
                        callback(value);
                    } catch (error) {
                        // eslint-disable-next-line no-console
                        console.warn("Error calling callback for gate ".concat(gateName, " with value ").concat(value), error);
                    }
                };
                return this.subscriptions.onGateUpdated(gateName, wrapCallback, this.checkGate.bind(this), options);
            }
        },
        {
            key: "onExperimentValueUpdated",
            value: function onExperimentValueUpdated(experimentName, parameterName, defaultValue, callback) {
                var _this8 = this;
                var options = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
                var wrapCallback = function wrapCallback(value) {
                    var _options$fireExperime2 = options.fireExperimentExposure, fireExperimentExposure = _options$fireExperime2 === void 0 ? true : _options$fireExperime2;
                    if (fireExperimentExposure) _this8.manuallyLogExperimentExposure(experimentName);
                    try {
                        callback(value);
                    } catch (error) {
                        // eslint-disable-next-line no-console
                        console.warn("Error calling callback for experiment ".concat(experimentName, " with value ").concat(value), error);
                    }
                };
                return this.subscriptions.onExperimentValueUpdated(experimentName, parameterName, defaultValue, wrapCallback, this.getExperimentValue.bind(this), options);
            }
        },
        {
            key: "onAnyUpdated",
            value: function onAnyUpdated(callback) {
                return this.subscriptions.onAnyUpdated(callback);
            }
        },
        {
            key: "init",
            value: function() {
                var _init = (0, $d650e45c9b3d04ba$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ff592c69388acc86$exports))).mark(function _callee8(clientOptions, identifiers, customAttributes) {
                    var fromValuesClientOptions, experimentValues, customAttributesFromResult, clientSdkKeyPromise, experimentValuesPromise, _yield$Promise$all, _yield$Promise$all2, experimentValuesResult, _t;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($ff592c69388acc86$exports))).wrap(function(_context8) {
                        while(true)switch(_context8.prev = _context8.next){
                            case 0:
                                fromValuesClientOptions = $379f34d0db44aade$var$_objectSpread({}, clientOptions);
                                if (!clientOptions.localMode) {
                                    _context8.next = 2;
                                    break;
                                }
                                _context8.next = 1;
                                return this.initFromValues(fromValuesClientOptions, identifiers, customAttributes);
                            case 1:
                                return _context8.abrupt("return");
                            case 2:
                                _context8.prev = 2;
                                // If client sdk key fetch fails, an error would be thrown and handled instead of waiting for
                                // the experiment values request to be settled, and it will fall back to use default values.
                                clientSdkKeyPromise = (0, $fa4dabecf67d548e$export$2e2bcd8739ae039).fetchClientSdk(clientOptions).then(function(value) {
                                    return fromValuesClientOptions.sdkKey = value.clientSdkKey;
                                });
                                experimentValuesPromise = (0, $fa4dabecf67d548e$export$2e2bcd8739ae039).fetchExperimentValues(clientOptions, identifiers, customAttributes); // Only wait for the experiment values request to finish and try to initialise the client
                                // with experiment values if both requests are successful. Else an error would be thrown and
                                // handled by the catch
                                _context8.next = 3;
                                return Promise.all([
                                    clientSdkKeyPromise,
                                    experimentValuesPromise
                                ]);
                            case 3:
                                _yield$Promise$all = _context8.sent;
                                _yield$Promise$all2 = (0, $c99af517edc48a31$export$2e2bcd8739ae039)(_yield$Promise$all, 2);
                                experimentValuesResult = _yield$Promise$all2[1];
                                experimentValues = experimentValuesResult.experimentValues;
                                customAttributesFromResult = experimentValuesResult.customAttributes;
                                _context8.next = 6;
                                break;
                            case 4:
                                _context8.prev = 4;
                                _t = _context8["catch"](2);
                                if (_t instanceof Error) // eslint-disable-next-line no-console
                                console.error("Error occurred when trying to fetch the Feature Gates client values, error: ".concat(_t === null || _t === void 0 ? void 0 : _t.message));
                                // eslint-disable-next-line no-console
                                console.warn("Initialising Statsig client without values");
                                _context8.next = 5;
                                return this.initFromValues(fromValuesClientOptions, identifiers, customAttributes);
                            case 5:
                                throw _t;
                            case 6:
                                return _context8.abrupt("return", this.initFromValues(fromValuesClientOptions, identifiers, customAttributesFromResult, experimentValues));
                            case 7:
                            case "end":
                                return _context8.stop();
                        }
                    }, _callee8, this, [
                        [
                            2,
                            4
                        ]
                    ]);
                }));
                function init(_x16, _x17, _x18) {
                    return _init.apply(this, arguments);
                }
                return init;
            }()
        },
        {
            key: "initWithProvider",
            value: function() {
                var _initWithProvider = (0, $d650e45c9b3d04ba$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ff592c69388acc86$exports))).mark(function _callee9(baseClientOptions, provider, identifiers, customAttributes) {
                    var fromValuesClientOptions, experimentValues, customAttributesFromResult, clientSdkKeyPromise, experimentValuesPromise, _yield$Promise$all3, _yield$Promise$all4, experimentValuesResult, _t2;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($ff592c69388acc86$exports))).wrap(function(_context9) {
                        while(true)switch(_context9.prev = _context9.next){
                            case 0:
                                fromValuesClientOptions = $379f34d0db44aade$var$_objectSpread($379f34d0db44aade$var$_objectSpread({}, baseClientOptions), {}, {
                                    disableCurrentPageLogging: true
                                });
                                _context9.prev = 1;
                                _context9.next = 2;
                                return provider.setProfile(baseClientOptions, identifiers, customAttributes);
                            case 2:
                                // If client sdk key fetch fails, an error would be thrown and handled instead of waiting for
                                // the experiment values request to be settled, and it will fall back to use default values.
                                clientSdkKeyPromise = provider.getClientSdkKey().then(function(value) {
                                    return fromValuesClientOptions.sdkKey = value;
                                });
                                experimentValuesPromise = provider.getExperimentValues(); // Only wait for the experiment values request to finish and try to initialise the client
                                // with experiment values if both requests are successful. Else an error would be thrown and
                                // handled by the catch
                                _context9.next = 3;
                                return Promise.all([
                                    clientSdkKeyPromise,
                                    experimentValuesPromise
                                ]);
                            case 3:
                                _yield$Promise$all3 = _context9.sent;
                                _yield$Promise$all4 = (0, $c99af517edc48a31$export$2e2bcd8739ae039)(_yield$Promise$all3, 2);
                                experimentValuesResult = _yield$Promise$all4[1];
                                experimentValues = experimentValuesResult.experimentValues;
                                customAttributesFromResult = experimentValuesResult.customAttributesFromFetch;
                                _context9.next = 6;
                                break;
                            case 4:
                                _context9.prev = 4;
                                _t2 = _context9["catch"](1);
                                if (_t2 instanceof Error) // eslint-disable-next-line no-console
                                console.error("Error occurred when trying to fetch the Feature Gates client values, error: ".concat(_t2 === null || _t2 === void 0 ? void 0 : _t2.message));
                                // eslint-disable-next-line no-console
                                console.warn("Initialising Statsig client without values");
                                _context9.next = 5;
                                return this.initFromValues(fromValuesClientOptions, identifiers, customAttributes);
                            case 5:
                                throw _t2;
                            case 6:
                                return _context9.abrupt("return", this.initFromValues(fromValuesClientOptions, identifiers, customAttributesFromResult, experimentValues));
                            case 7:
                            case "end":
                                return _context9.stop();
                        }
                    }, _callee9, this, [
                        [
                            1,
                            4
                        ]
                    ]);
                }));
                function initWithProvider(_x19, _x20, _x21, _x22) {
                    return _initWithProvider.apply(this, arguments);
                }
                return initWithProvider;
            }()
        },
        {
            key: "initFromValues",
            value: function() {
                var _initFromValues = (0, $d650e45c9b3d04ba$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ff592c69388acc86$exports))).mark(function _callee0(clientOptions, identifiers, customAttributes) {
                    var _newClientOptions$net;
                    var initializeValues, newClientOptions, sdkKey, environment, _updateUserCompletionCallback, _perimeter, restClientOptions, frontendUser, statsigOptions, _args0 = arguments, _t3;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($ff592c69388acc86$exports))).wrap(function(_context0) {
                        while(true)switch(_context0.prev = _context0.next){
                            case 0:
                                initializeValues = _args0.length > 3 && _args0[3] !== undefined ? _args0[3] : {};
                                this.overrideAdapter.initFromStoredOverrides();
                                this.currentIdentifiers = identifiers;
                                this.currentAttributes = customAttributes;
                                newClientOptions = (0, $fa64713f218e0a46$export$202946b690d26d22)(clientOptions);
                                if (!newClientOptions.sdkKey) newClientOptions.sdkKey = $379f34d0db44aade$var$DEFAULT_CLIENT_KEY;
                                if (!((_newClientOptions$net = newClientOptions.networkConfig) !== null && _newClientOptions$net !== void 0 && _newClientOptions$net.logEventUrl)) newClientOptions.networkConfig = $379f34d0db44aade$var$_objectSpread($379f34d0db44aade$var$_objectSpread({}, newClientOptions.networkConfig), {}, {
                                    logEventUrl: $379f34d0db44aade$var$DEFAULT_EVENT_LOGGING_API
                                });
                                if (newClientOptions.perimeter === (0, $9b5324b6988a1977$export$c42b7bbc5e7ba555).FEDRAMP_MODERATE) // disable all logging in FedRAMP to prevent egress of sensitive data
                                newClientOptions.disableLogging = true;
                                sdkKey = newClientOptions.sdkKey, environment = newClientOptions.environment, _updateUserCompletionCallback = newClientOptions.updateUserCompletionCallback, _perimeter = newClientOptions.perimeter, restClientOptions = (0, $9b3d50432d7c2d71$export$2e2bcd8739ae039)(newClientOptions, $379f34d0db44aade$var$_excluded);
                                frontendUser = (0, $fa64713f218e0a46$export$3dad1db244472f32)(identifiers, customAttributes);
                                this.user = (0, $fa64713f218e0a46$export$1148cb79ceecd5fa)({}, initializeValues.user, frontendUser);
                                statsigOptions = $379f34d0db44aade$var$_objectSpread($379f34d0db44aade$var$_objectSpread({}, restClientOptions), {}, {
                                    environment: {
                                        tier: environment
                                    },
                                    includeCurrentPageUrlWithEvents: false,
                                    dataAdapter: this.dataAdapter,
                                    overrideAdapter: this.overrideAdapter,
                                    logEventCompressionMode: (0, $iFR7a.LogEventCompressionMode).Forced
                                }); // Statsig validates the provided stableId against their own cookie, so we either need
                                // to update the cookie to match, or disable the validation completely.
                                if (identifiers.stableId) (0, $iFR7a.StableID).setOverride(identifiers.stableId, sdkKey);
                                else statsigOptions.disableStableID = true;
                                _context0.prev = 1;
                                this.statsigClient = new (0, $iFR7a.StatsigClient)(sdkKey, this.user, statsigOptions);
                                this.dataAdapter.setBootstrapData(initializeValues);
                                _context0.next = 2;
                                return this.statsigClient.initializeAsync();
                            case 2:
                                _context0.next = 5;
                                break;
                            case 3:
                                _context0.prev = 3;
                                _t3 = _context0["catch"](1);
                                if (_t3 instanceof Error) // eslint-disable-next-line no-console
                                console.error("Error occurred when trying to initialise the Statsig client, error: ".concat(_t3 === null || _t3 === void 0 ? void 0 : _t3.message));
                                // eslint-disable-next-line no-console
                                console.warn("Initialising Statsig client with default sdk key and without values");
                                this.statsigClient = new (0, $iFR7a.StatsigClient)($379f34d0db44aade$var$DEFAULT_CLIENT_KEY, this.user, statsigOptions);
                                this.dataAdapter.setBootstrapData();
                                _context0.next = 4;
                                return this.statsigClient.initializeAsync();
                            case 4:
                                this.initWithDefaults = true;
                                throw _t3;
                            case 5:
                            case "end":
                                return _context0.stop();
                        }
                    }, _callee0, this, [
                        [
                            1,
                            3
                        ]
                    ]);
                }));
                function initFromValues(_x23, _x24, _x25) {
                    return _initFromValues.apply(this, arguments);
                }
                return initFromValues;
            }()
        },
        {
            key: "updateUserUsingInitializeValuesProducer",
            value: function() {
                var _updateUserUsingInitializeValuesProducer = (0, $d650e45c9b3d04ba$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ff592c69388acc86$exports))).mark(function _callee10(getInitializeValues, identifiers, customAttributes) {
                    var _this9 = this;
                    var originalInitPromise, initializeValuesPromise, updateUserPromise, _t4;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($ff592c69388acc86$exports))).wrap(function(_context10) {
                        while(true)switch(_context10.prev = _context10.next){
                            case 0:
                                this.assertInitialized(this.statsigClient);
                                if (this.initPromise) {
                                    _context10.next = 1;
                                    break;
                                }
                                throw new Error('The client must be initialized before you can update the user.');
                            case 1:
                                if (!this.isCurrentUser(identifiers, customAttributes)) {
                                    _context10.next = 2;
                                    break;
                                }
                                return _context10.abrupt("return", this.initPromise);
                            case 2:
                                // Wait for the current initialize/update to finish
                                originalInitPromise = this.initPromise;
                                _context10.prev = 3;
                                _context10.next = 4;
                                return this.initPromise;
                            case 4:
                                _context10.next = 6;
                                break;
                            case 5:
                                _context10.prev = 5;
                                _t4 = _context10["catch"](3);
                            case 6:
                                initializeValuesPromise = getInitializeValues();
                                updateUserPromise = this.updateStatsigClientUser(initializeValuesPromise, identifiers, customAttributes); // We replace the init promise here since we are essentially re-initializing the client at this
                                // point. Any subsequent calls to await client.initialize() or client.updateUser()
                                // will now also await this user update.
                                this.initPromise = updateUserPromise.catch(/*#__PURE__*/ (0, $d650e45c9b3d04ba$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ff592c69388acc86$exports))).mark(function _callee1() {
                                    return (0, (/*@__PURE__*/$parcel$interopDefault($ff592c69388acc86$exports))).wrap(function(_context1) {
                                        while(true)switch(_context1.prev = _context1.next){
                                            case 0:
                                                // If the update failed then it changed nothing, so revert back to the original promise.
                                                _this9.initPromise = originalInitPromise;
                                                // Set the user profile again to revert back to the current user
                                                if (!_this9.provider) {
                                                    _context1.next = 1;
                                                    break;
                                                }
                                                _context1.next = 1;
                                                return _this9.provider.setProfile(_this9.initOptions, _this9.currentIdentifiers, _this9.currentAttributes);
                                            case 1:
                                            case "end":
                                                return _context1.stop();
                                        }
                                    }, _callee1);
                                })));
                                return _context10.abrupt("return", updateUserPromise);
                            case 7:
                            case "end":
                                return _context10.stop();
                        }
                    }, _callee10, this, [
                        [
                            3,
                            5
                        ]
                    ]);
                }));
                function updateUserUsingInitializeValuesProducer(_x26, _x27, _x28) {
                    return _updateUserUsingInitializeValuesProducer.apply(this, arguments);
                }
                return updateUserUsingInitializeValuesProducer;
            }()
        },
        {
            key: "updateStatsigClientUser",
            value: function() {
                var _updateStatsigClientUser = (0, $d650e45c9b3d04ba$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ff592c69388acc86$exports))).mark(function _callee11(initializeValuesPromise, identifiers, customAttributes) {
                    var _this$initOptions, _this$initOptions$upd;
                    var initializeValues, user, frontendUser, _updateUserCompletion, _ref4, errMsg, success, errorMessage, _t5, _t6;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($ff592c69388acc86$exports))).wrap(function(_context11) {
                        while(true)switch(_context11.prev = _context11.next){
                            case 0:
                                this.assertInitialized(this.statsigClient);
                                _context11.prev = 1;
                                _context11.next = 2;
                                return initializeValuesPromise;
                            case 2:
                                initializeValues = _context11.sent;
                                frontendUser = (0, $fa64713f218e0a46$export$3dad1db244472f32)(identifiers, initializeValues.customAttributesFromFetch);
                                user = (0, $fa64713f218e0a46$export$1148cb79ceecd5fa)({}, initializeValues.experimentValues.user, frontendUser);
                                _context11.next = 4;
                                break;
                            case 3:
                                _context11.prev = 3;
                                _t5 = _context11["catch"](1);
                                // Make sure the updateUserCompletionCallback is called for any errors in our custom code.
                                // This is not necessary for the updateUserWithValues call, because the Statsig client will
                                // already invoke the callback itself.
                                errMsg = _t5 instanceof Error ? _t5.message : JSON.stringify(_t5);
                                (_updateUserCompletion = (_ref4 = this.initOptions).updateUserCompletionCallback) === null || _updateUserCompletion === void 0 || _updateUserCompletion.call(_ref4, false, errMsg);
                                throw _t5;
                            case 4:
                                success = true;
                                errorMessage = null;
                                _context11.prev = 5;
                                this.dataAdapter.setBootstrapData(initializeValues.experimentValues);
                                this.user = user;
                                if (!this.user) {
                                    _context11.next = 6;
                                    break;
                                }
                                _context11.next = 6;
                                return this.statsigClient.updateUserAsync(this.user);
                            case 6:
                                _context11.next = 8;
                                break;
                            case 7:
                                _context11.prev = 7;
                                _t6 = _context11["catch"](5);
                                success = false;
                                errorMessage = String(_t6);
                            case 8:
                                (_this$initOptions = this.initOptions) === null || _this$initOptions === void 0 || (_this$initOptions$upd = _this$initOptions.updateUserCompletionCallback) === null || _this$initOptions$upd === void 0 || _this$initOptions$upd.call(_this$initOptions, success, errorMessage);
                                if (!success) {
                                    _context11.next = 9;
                                    break;
                                }
                                this.currentIdentifiers = identifiers;
                                this.currentAttributes = customAttributes;
                                this.subscriptions.anyUpdated();
                                _context11.next = 10;
                                break;
                            case 9:
                                throw new Error('Failed to update user. An unexpected error occured.');
                            case 10:
                            case "end":
                                return _context11.stop();
                        }
                    }, _callee11, this, [
                        [
                            1,
                            3
                        ],
                        [
                            5,
                            7
                        ]
                    ]);
                }));
                function updateStatsigClientUser(_x29, _x30, _x31) {
                    return _updateStatsigClientUser.apply(this, arguments);
                }
                return updateStatsigClientUser;
            }()
        },
        {
            key: "getPackageVersion",
            value: /**
     * @returns string version of the current package in semver style.
     */ function getPackageVersion() {
                return 0, $7115a1d3826eff23$export$a59f8d67326bd1cb;
            }
        },
        {
            key: "getTargetApp",
            value: function getTargetApp() {
                var _this$initOptions2;
                return (_this$initOptions2 = this.initOptions) === null || _this$initOptions2 === void 0 ? void 0 : _this$initOptions2.targetApp;
            }
        },
        {
            key: "getLayer",
            value: function getLayer(/** The name of the layer */ layerName) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                try {
                    this.assertInitialized(this.statsigClient);
                    var _options$fireLayerExp = options.fireLayerExposure, fireLayerExposure = _options$fireLayerExp === void 0 ? true : _options$fireLayerExp;
                    return (0, $1f2f97b02404f5c6$export$936d0764594b6eb3).fromLayer(this.statsigClient.getLayer(layerName, {
                        disableExposureLog: !fireLayerExposure
                    }));
                } catch (error) {
                    // Log the first occurrence of the error
                    if (!this.hasGetLayerErrorOccurred) {
                        // eslint-disable-next-line no-console
                        console.warn({
                            msg: 'An error has occurred getting the layer. Only the first occurrence of this error is logged.',
                            layerName: layerName,
                            error: error
                        });
                        this.hasGetLayerErrorOccurred = true;
                    }
                    // Return a default value
                    return (0, $1f2f97b02404f5c6$export$936d0764594b6eb3).fromLayer((0, $iFR7a._makeLayer)(layerName, {
                        reason: 'Error'
                    }, null));
                }
            }
        },
        {
            key: "getLayerValue",
            value: function getLayerValue(layerName, parameterName, defaultValue) {
                var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var layer = this.getLayer(layerName, options);
                try {
                    var typeGuard = options.typeGuard;
                    return layer.get(parameterName, defaultValue, typeGuard);
                } catch (error) {
                    // Log the first occurrence of the error
                    if (!this.hasGetLayerValueErrorOccurred) {
                        // eslint-disable-next-line no-console
                        console.warn({
                            msg: 'An error has occurred getting the layer value. Only the first occurrence of this error is logged.',
                            layerName: layerName,
                            defaultValue: defaultValue,
                            options: options,
                            error: error
                        });
                        this.hasGetLayerValueErrorOccurred = true;
                    }
                    return defaultValue;
                }
            }
        }
    ]);
}();






var $63a5e8a642f98278$var$_FeatureGates;
/**
 * Access the FeatureGates object via the default export.
 * ```ts
 * import FeatureGates from '@atlaskit/feature-gate-js-client';
 * ```
 */ var $63a5e8a642f98278$var$FeatureGates = /*#__PURE__*/ function() {
    function FeatureGates() {
        (0, $9ba5074f09554cd6$export$2e2bcd8739ae039)(this, FeatureGates);
    }
    return (0, $920934557ff0cee7$export$2e2bcd8739ae039)(FeatureGates, null, [
        {
            key: "isGateExists",
            value: function isGateExists(gateName) {
                return this.client.isGateExist(gateName);
            }
        },
        {
            key: "isExperimentExists",
            value: function isExperimentExists(experimentName) {
                return this.client.isExperimentExist(experimentName);
            }
        }
    ]);
}();
$63a5e8a642f98278$var$_FeatureGates = $63a5e8a642f98278$var$FeatureGates;
(0, $90d31be1abcfa6da$export$2e2bcd8739ae039)($63a5e8a642f98278$var$FeatureGates, "client", new (0, $379f34d0db44aade$export$1f2bb630327ac4b6)());
(0, $90d31be1abcfa6da$export$2e2bcd8739ae039)($63a5e8a642f98278$var$FeatureGates, "hasCheckGateErrorOccurred", false);
(0, $90d31be1abcfa6da$export$2e2bcd8739ae039)($63a5e8a642f98278$var$FeatureGates, "hasGetExperimentValueErrorOccurred", false);
(0, $90d31be1abcfa6da$export$2e2bcd8739ae039)($63a5e8a642f98278$var$FeatureGates, "checkGate", function(gateName, options) {
    try {
        // Check if the CRITERION override mechanism is available
        if (typeof window !== 'undefined' && window.__CRITERION__ && typeof window.__CRITERION__.getFeatureFlagOverride === 'function') {
            // Attempt to retrieve an override value for the feature gate
            var overrideValue = window.__CRITERION__.getFeatureFlagOverride(gateName);
            // If an override value is found, return it immediately
            if (overrideValue !== undefined) return overrideValue;
        }
    } catch (error) {
        // Log the first occurrence of the error
        if (!$63a5e8a642f98278$var$_FeatureGates.hasCheckGateErrorOccurred) {
            // eslint-disable-next-line no-console
            console.warn({
                msg: 'An error has occurred checking the feature gate from criterion override. Only the first occurrence of this error is logged.',
                gateName: gateName,
                error: error
            });
            $63a5e8a642f98278$var$_FeatureGates.hasCheckGateErrorOccurred = true;
        }
    }
    // Proceed with the main logic if no override is found
    return $63a5e8a642f98278$var$_FeatureGates.client.checkGate(gateName, options);
});
(0, $90d31be1abcfa6da$export$2e2bcd8739ae039)($63a5e8a642f98278$var$FeatureGates, "getExperimentValue", function(experimentName, parameterName, defaultValue, options) {
    try {
        // Check if the CRITERION override mechanism is available
        if (typeof window !== 'undefined' && window.__CRITERION__ && typeof window.__CRITERION__.getExperimentValueOverride === 'function') {
            var overrideValue = window.__CRITERION__.getExperimentValueOverride(experimentName, parameterName);
            if (overrideValue !== undefined && overrideValue !== null) return overrideValue;
        }
    } catch (error) {
        // Log the first occurrence of the error
        if (!$63a5e8a642f98278$var$_FeatureGates.hasGetExperimentValueErrorOccurred) {
            // eslint-disable-next-line no-console
            console.warn({
                msg: 'An error has occurred getting the experiment value from criterion override. Only the first occurrence of this error is logged.',
                experimentName: experimentName,
                defaultValue: defaultValue,
                options: options,
                error: error
            });
            $63a5e8a642f98278$var$_FeatureGates.hasGetExperimentValueErrorOccurred = true;
        }
        return defaultValue;
    }
    // Proceed with the main logic if no override is found
    return $63a5e8a642f98278$var$_FeatureGates.client.getExperimentValue(experimentName, parameterName, defaultValue, options);
});
(0, $90d31be1abcfa6da$export$2e2bcd8739ae039)($63a5e8a642f98278$var$FeatureGates, "initializeCalled", $63a5e8a642f98278$var$_FeatureGates.client.initializeCalled.bind($63a5e8a642f98278$var$_FeatureGates.client));
(0, $90d31be1abcfa6da$export$2e2bcd8739ae039)($63a5e8a642f98278$var$FeatureGates, "initializeCompleted", $63a5e8a642f98278$var$_FeatureGates.client.initializeCompleted.bind($63a5e8a642f98278$var$_FeatureGates.client));
(0, $90d31be1abcfa6da$export$2e2bcd8739ae039)($63a5e8a642f98278$var$FeatureGates, "waitUntilInitializeCompleted", $63a5e8a642f98278$var$_FeatureGates.client.waitUntilInitializeCompleted.bind($63a5e8a642f98278$var$_FeatureGates.client));
(0, $90d31be1abcfa6da$export$2e2bcd8739ae039)($63a5e8a642f98278$var$FeatureGates, "initialize", $63a5e8a642f98278$var$_FeatureGates.client.initialize.bind($63a5e8a642f98278$var$_FeatureGates.client));
(0, $90d31be1abcfa6da$export$2e2bcd8739ae039)($63a5e8a642f98278$var$FeatureGates, "initializeWithProvider", $63a5e8a642f98278$var$_FeatureGates.client.initializeWithProvider.bind($63a5e8a642f98278$var$_FeatureGates.client));
(0, $90d31be1abcfa6da$export$2e2bcd8739ae039)($63a5e8a642f98278$var$FeatureGates, "initializeFromValues", $63a5e8a642f98278$var$_FeatureGates.client.initializeFromValues.bind($63a5e8a642f98278$var$_FeatureGates.client));
(0, $90d31be1abcfa6da$export$2e2bcd8739ae039)($63a5e8a642f98278$var$FeatureGates, "manuallyLogGateExposure", $63a5e8a642f98278$var$_FeatureGates.client.manuallyLogGateExposure.bind($63a5e8a642f98278$var$_FeatureGates.client));
(0, $90d31be1abcfa6da$export$2e2bcd8739ae039)($63a5e8a642f98278$var$FeatureGates, "getExperiment", $63a5e8a642f98278$var$_FeatureGates.client.getExperiment.bind($63a5e8a642f98278$var$_FeatureGates.client));
(0, $90d31be1abcfa6da$export$2e2bcd8739ae039)($63a5e8a642f98278$var$FeatureGates, "manuallyLogExperimentExposure", $63a5e8a642f98278$var$_FeatureGates.client.manuallyLogExperimentExposure.bind($63a5e8a642f98278$var$_FeatureGates.client));
(0, $90d31be1abcfa6da$export$2e2bcd8739ae039)($63a5e8a642f98278$var$FeatureGates, "manuallyLogLayerExposure", $63a5e8a642f98278$var$_FeatureGates.client.manuallyLogLayerExposure.bind($63a5e8a642f98278$var$_FeatureGates.client));
(0, $90d31be1abcfa6da$export$2e2bcd8739ae039)($63a5e8a642f98278$var$FeatureGates, "shutdownStatsig", $63a5e8a642f98278$var$_FeatureGates.client.shutdownStatsig.bind($63a5e8a642f98278$var$_FeatureGates.client));
(0, $90d31be1abcfa6da$export$2e2bcd8739ae039)($63a5e8a642f98278$var$FeatureGates, "overrideGate", $63a5e8a642f98278$var$_FeatureGates.client.overrideGate.bind($63a5e8a642f98278$var$_FeatureGates.client));
(0, $90d31be1abcfa6da$export$2e2bcd8739ae039)($63a5e8a642f98278$var$FeatureGates, "clearGateOverride", $63a5e8a642f98278$var$_FeatureGates.client.clearGateOverride.bind($63a5e8a642f98278$var$_FeatureGates.client));
(0, $90d31be1abcfa6da$export$2e2bcd8739ae039)($63a5e8a642f98278$var$FeatureGates, "overrideConfig", $63a5e8a642f98278$var$_FeatureGates.client.overrideConfig.bind($63a5e8a642f98278$var$_FeatureGates.client));
(0, $90d31be1abcfa6da$export$2e2bcd8739ae039)($63a5e8a642f98278$var$FeatureGates, "clearConfigOverride", $63a5e8a642f98278$var$_FeatureGates.client.clearConfigOverride.bind($63a5e8a642f98278$var$_FeatureGates.client));
(0, $90d31be1abcfa6da$export$2e2bcd8739ae039)($63a5e8a642f98278$var$FeatureGates, "setOverrides", $63a5e8a642f98278$var$_FeatureGates.client.setOverrides.bind($63a5e8a642f98278$var$_FeatureGates.client));
(0, $90d31be1abcfa6da$export$2e2bcd8739ae039)($63a5e8a642f98278$var$FeatureGates, "getOverrides", $63a5e8a642f98278$var$_FeatureGates.client.getOverrides.bind($63a5e8a642f98278$var$_FeatureGates.client));
(0, $90d31be1abcfa6da$export$2e2bcd8739ae039)($63a5e8a642f98278$var$FeatureGates, "clearAllOverrides", $63a5e8a642f98278$var$_FeatureGates.client.clearAllOverrides.bind($63a5e8a642f98278$var$_FeatureGates.client));
(0, $90d31be1abcfa6da$export$2e2bcd8739ae039)($63a5e8a642f98278$var$FeatureGates, "isCurrentUser", $63a5e8a642f98278$var$_FeatureGates.client.isCurrentUser.bind($63a5e8a642f98278$var$_FeatureGates.client));
(0, $90d31be1abcfa6da$export$2e2bcd8739ae039)($63a5e8a642f98278$var$FeatureGates, "onGateUpdated", $63a5e8a642f98278$var$_FeatureGates.client.onGateUpdated.bind($63a5e8a642f98278$var$_FeatureGates.client));
(0, $90d31be1abcfa6da$export$2e2bcd8739ae039)($63a5e8a642f98278$var$FeatureGates, "onExperimentValueUpdated", $63a5e8a642f98278$var$_FeatureGates.client.onExperimentValueUpdated.bind($63a5e8a642f98278$var$_FeatureGates.client));
(0, $90d31be1abcfa6da$export$2e2bcd8739ae039)($63a5e8a642f98278$var$FeatureGates, "onAnyUpdated", $63a5e8a642f98278$var$_FeatureGates.client.onAnyUpdated.bind($63a5e8a642f98278$var$_FeatureGates.client));
(0, $90d31be1abcfa6da$export$2e2bcd8739ae039)($63a5e8a642f98278$var$FeatureGates, "updateUser", $63a5e8a642f98278$var$_FeatureGates.client.updateUser.bind($63a5e8a642f98278$var$_FeatureGates.client));
(0, $90d31be1abcfa6da$export$2e2bcd8739ae039)($63a5e8a642f98278$var$FeatureGates, "updateUserWithProvider", $63a5e8a642f98278$var$_FeatureGates.client.updateUserWithProvider.bind($63a5e8a642f98278$var$_FeatureGates.client));
(0, $90d31be1abcfa6da$export$2e2bcd8739ae039)($63a5e8a642f98278$var$FeatureGates, "updateUserWithValues", $63a5e8a642f98278$var$_FeatureGates.client.updateUserWithValues.bind($63a5e8a642f98278$var$_FeatureGates.client));
(0, $90d31be1abcfa6da$export$2e2bcd8739ae039)($63a5e8a642f98278$var$FeatureGates, "getPackageVersion", $63a5e8a642f98278$var$_FeatureGates.client.getPackageVersion.bind($63a5e8a642f98278$var$_FeatureGates.client));
(0, $90d31be1abcfa6da$export$2e2bcd8739ae039)($63a5e8a642f98278$var$FeatureGates, "getTargetApp", $63a5e8a642f98278$var$_FeatureGates.client.getTargetApp.bind($63a5e8a642f98278$var$_FeatureGates.client));
(0, $90d31be1abcfa6da$export$2e2bcd8739ae039)($63a5e8a642f98278$var$FeatureGates, "getLayer", $63a5e8a642f98278$var$_FeatureGates.client.getLayer.bind($63a5e8a642f98278$var$_FeatureGates.client));
(0, $90d31be1abcfa6da$export$2e2bcd8739ae039)($63a5e8a642f98278$var$FeatureGates, "getLayerValue", $63a5e8a642f98278$var$_FeatureGates.client.getLayerValue.bind($63a5e8a642f98278$var$_FeatureGates.client));
var $63a5e8a642f98278$var$boundFGJS = $63a5e8a642f98278$var$FeatureGates;
// This makes it possible to get a reference to the FeatureGates client at runtime.
// This is important for overriding values in Cypress tests, as there needs to be a
// way to get the exact instance for a window in order to mock some of its methods.
if (typeof window !== 'undefined') {
    if (window.__FEATUREGATES_JS__ === undefined) window.__FEATUREGATES_JS__ = $63a5e8a642f98278$var$FeatureGates;
    else {
        var $63a5e8a642f98278$var$_boundFGJS, $63a5e8a642f98278$var$_boundFGJS$getPackage;
        $63a5e8a642f98278$var$boundFGJS = window.__FEATUREGATES_JS__;
        var $63a5e8a642f98278$var$boundVersion = (($63a5e8a642f98278$var$_boundFGJS = $63a5e8a642f98278$var$boundFGJS) === null || $63a5e8a642f98278$var$_boundFGJS === void 0 || ($63a5e8a642f98278$var$_boundFGJS$getPackage = $63a5e8a642f98278$var$_boundFGJS.getPackageVersion) === null || $63a5e8a642f98278$var$_boundFGJS$getPackage === void 0 ? void 0 : $63a5e8a642f98278$var$_boundFGJS$getPackage.call($63a5e8a642f98278$var$_boundFGJS)) || '4.10.0 or earlier';
        if ($63a5e8a642f98278$var$boundVersion !== (0, $7115a1d3826eff23$export$a59f8d67326bd1cb)) {
            var $63a5e8a642f98278$var$message = "Multiple versions of FeatureGateClients found on the current page.\n      The currently bound version is ".concat($63a5e8a642f98278$var$boundVersion, " when module version ").concat((0, $7115a1d3826eff23$export$a59f8d67326bd1cb), " was loading.");
            // eslint-disable-next-line no-console
            console.warn($63a5e8a642f98278$var$message);
        }
    }
}
var /**
 * @property {FeatureGates} FeatureGate default export
 */ $63a5e8a642f98278$export$2e2bcd8739ae039 = $63a5e8a642f98278$var$boundFGJS;


var $9b15626a2b0b810e$var$_process, $9b15626a2b0b810e$var$_process2;
// We can't rely on NODE_ENV === 'test' if its value is already configured by the consumer to some other value, so better to use JEST_WORKER_ID
// https://jestjs.io/docs/environment-variables#jest_worker_id
var $9b15626a2b0b810e$var$TESTS_MODE = (globalThis === null || globalThis === void 0 || ($9b15626a2b0b810e$var$_process = globalThis.process) === null || $9b15626a2b0b810e$var$_process === void 0 || ($9b15626a2b0b810e$var$_process = $9b15626a2b0b810e$var$_process.env) === null || $9b15626a2b0b810e$var$_process === void 0 ? void 0 : $9b15626a2b0b810e$var$_process.JEST_WORKER_ID) !== undefined;
var $9b15626a2b0b810e$var$DEBUG_MODE = !$9b15626a2b0b810e$var$TESTS_MODE && (globalThis === null || globalThis === void 0 || ($9b15626a2b0b810e$var$_process2 = globalThis.process) === null || $9b15626a2b0b810e$var$_process2 === void 0 || ($9b15626a2b0b810e$var$_process2 = $9b15626a2b0b810e$var$_process2.env) === null || $9b15626a2b0b810e$var$_process2 === void 0 ? void 0 : $9b15626a2b0b810e$var$_process2.NODE_ENV) !== 'production';
var $9b15626a2b0b810e$export$1c9f709888824e05 = function debug() {
    var _console;
    if (!$9b15626a2b0b810e$var$DEBUG_MODE) return;
    // eslint-disable-next-line no-console
    (_console = console).debug.apply(_console, arguments);
};



var $3ZMUU = parcelRequire("3ZMUU");
var $432dbb44956417f7$export$7e41b1b2bdee3f98 = '__PLATFORM_FEATURE_FLAGS__';
var $432dbb44956417f7$export$407f05df8e3ce9f3 = '@atlaskit/platform-feature-flags';
var $432dbb44956417f7$export$75f4a1454eff2805 = typeof $3ZMUU !== 'undefined' && typeof $3ZMUU.env !== 'undefined';


var $fc388a9f300150ea$export$b574c24e1e6490f5 = (0, $432dbb44956417f7$export$75f4a1454eff2805) ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;



var $54c110cb716304c2$export$92f8b531feaeb23d = (0, $432dbb44956417f7$export$75f4a1454eff2805) ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;



var $2f678b25d1c31a28$var$DEFAULT_PFF_GLOBAL = {
    booleanResolver: undefined
};
var $2f678b25d1c31a28$export$54ea85357b4e0159 = typeof window !== 'undefined' ? window : globalThis;
$2f678b25d1c31a28$export$54ea85357b4e0159[0, $432dbb44956417f7$export$7e41b1b2bdee3f98] = $2f678b25d1c31a28$export$54ea85357b4e0159[0, $432dbb44956417f7$export$7e41b1b2bdee3f98] || $2f678b25d1c31a28$var$DEFAULT_PFF_GLOBAL;



var $3176ddf49936d231$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE = (0, $fc388a9f300150ea$export$b574c24e1e6490f5) || (0, $54c110cb716304c2$export$92f8b531feaeb23d);
function $3176ddf49936d231$export$6333b6aff9fc6275(flagKey) {
    if ($3176ddf49936d231$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE) {
        (0, $9b15626a2b0b810e$export$1c9f709888824e05)('[%s]: The feature flags were enabled while running tests. The flag "%s" will be always enabled.', (0, $432dbb44956417f7$export$407f05df8e3ce9f3), flagKey);
        return true;
    }
    try {
        var _globalVar$PFF_GLOBAL, _globalVar$PFF_GLOBAL2, _globalVar$PFF_GLOBAL3;
        // booleanResolver will be empty for products like Trello, Elevate, Recruit etc.
        // Currently only Confluence, Jira and Bitbucket has set it.
        if (((_globalVar$PFF_GLOBAL = (0, $2f678b25d1c31a28$export$54ea85357b4e0159)[0, $432dbb44956417f7$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL === void 0 ? void 0 : _globalVar$PFF_GLOBAL.booleanResolver) === undefined || ((_globalVar$PFF_GLOBAL2 = (0, $2f678b25d1c31a28$export$54ea85357b4e0159)[0, $432dbb44956417f7$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL2 === void 0 ? void 0 : _globalVar$PFF_GLOBAL2.booleanResolver) === null) // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
        return (0, $63a5e8a642f98278$export$2e2bcd8739ae039).checkGate(flagKey);
        var result = (_globalVar$PFF_GLOBAL3 = (0, $2f678b25d1c31a28$export$54ea85357b4e0159)[0, $432dbb44956417f7$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL3 === void 0 ? void 0 : _globalVar$PFF_GLOBAL3.booleanResolver(flagKey);
        if (typeof result !== 'boolean') {
            // eslint-disable-next-line no-console
            console.warn("".concat(flagKey, " resolved to a non-boolean value, returning false for safety"));
            return false;
        }
        return result;
    } catch (e) {
        return false;
    }
}


function $13a186c4459b8c2a$export$b40ec24ac8275656(name) {
    return (0, $3176ddf49936d231$export$6333b6aff9fc6275)(name);
}



/* indicators-container.tsx generated by @compiled/babel-plugin v2.0.0 */ 

var $5FkrB = parcelRequire("5FkrB");

var $lqU89 = parcelRequire("lqU89");

var $lqU89 = parcelRequire("lqU89");
const $b2896f4f52b4ee15$export$a274e22fb40f762e = (...styles)=>{
    // At runtime TStyles is resolved down to strings, but not at compile time.
    // We circumvent the type system here because of that.
    const actualStyles = styles;
    // The output should be a union type of passed in styles. This ensures the call
    // site of xcss prop can raise violations when disallowed styles have been passed.
    return (0, $lqU89.default)(actualStyles);
};


var $26e98d575ca76ea1$export$26417cabd806a658 = function getStyleProps(props, name, classNamesState) {
    var cx = props.cx, getStyles = props.getStyles, getClassNames = props.getClassNames, className = props.className;
    return {
        css: getStyles(name, props),
        className: cx(classNamesState !== null && classNamesState !== void 0 ? classNamesState : {}, getClassNames(name, props), className)
    };
};


var $c45e5b939479a9d0$var$indicatorContainerStyles = null;
var $c45e5b939479a9d0$export$d0ffd7e649cab6f = function IndicatorsContainer(props) {
    var children = props.children, innerProps = props.innerProps, xcss = props.xcss;
    var _getStyleProps = (0, $26e98d575ca76ea1$export$26417cabd806a658)(props, 'indicatorsContainer', {
        indicators: true
    }), css = _getStyleProps.css, className = _getStyleProps.className;
    return /*#__PURE__*/ $5FkrB.createElement("div", (0, $e7be1629a1f1b709$export$2e2bcd8739ae039)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        className: (0, $lqU89.default)([
            "_1e0c1txw _4cvr1h6o _1o9zidpf _1wpz1fhb _y4ti1b66",
            (0, $b2896f4f52b4ee15$export$a274e22fb40f762e)(className, xcss, '-IndicatorsContainer')
        ])
    }, innerProps), children);
};


/* multi-value-container.tsx generated by @compiled/babel-plugin v2.0.0 */ 

var $5FkrB = parcelRequire("5FkrB");

var $lqU89 = parcelRequire("lqU89");

var $62fb3b183d6a5f7d$var$multiValueStyles = {
    root: "_2rko12b0 _1h6d14je _1dqonqa1 _189ee4h9 _1e0c1txw _1ul9ze3t _1pfhv77o _12l2v77o _6rthv77o _ahbqv77o _bfhk1j9a _p12f1osq _syazi7uo _3yq3glyw",
    disabled: "_syaz1gmx _bfhki8nm",
    focused: "_syaz6x5g _bfhk15s3 _16qs1xv8 _1aewe4h9 _6up51j28 _1xdnnqa1"
};
var $62fb3b183d6a5f7d$export$cf9cf2a30a59265c = function MultiValueContainer(_ref) {
    var children = _ref.children, innerProps = _ref.innerProps, isFocused = _ref.isFocused, isDisabled = _ref.isDisabled, className = _ref.className, xcss = _ref.xcss;
    return /*#__PURE__*/ $5FkrB.createElement("div", (0, $e7be1629a1f1b709$export$2e2bcd8739ae039)({}, innerProps, {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $lqU89.default)([
            $62fb3b183d6a5f7d$var$multiValueStyles.root,
            isDisabled && $62fb3b183d6a5f7d$var$multiValueStyles.disabled,
            isFocused && $62fb3b183d6a5f7d$var$multiValueStyles.focused,
            (0, $b2896f4f52b4ee15$export$a274e22fb40f762e)(className, xcss, '-multiValue')
        ])
    }), children);
};


/* select-container.tsx generated by @compiled/babel-plugin v2.0.0 */ 

var $5FkrB = parcelRequire("5FkrB");

var $lqU89 = parcelRequire("lqU89");


var $9b0e2f2bf4cd39a6$var$containerStyles = {
    default: "_11c81d4k _kqswh2mm _lcxv1rj4 _1tn2fhey",
    rtl: "_1eim1xrj",
    disabled: "_80om13gf"
};
var $9b0e2f2bf4cd39a6$export$446eebadefe1123b = function SelectContainer(props) {
    var children = props.children, innerProps = props.innerProps, isDisabled = props.isDisabled, isRtl = props.isRtl, xcss = props.xcss;
    var _getStyleProps = (0, $26e98d575ca76ea1$export$26417cabd806a658)(props, 'container', {
        '--is-disabled': isDisabled,
        '--is-rtl': isRtl
    }), className = _getStyleProps.className, css = _getStyleProps.css;
    return /*#__PURE__*/ $5FkrB.createElement("div", (0, $e7be1629a1f1b709$export$2e2bcd8739ae039)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $lqU89.default)([
            $9b0e2f2bf4cd39a6$var$containerStyles.default,
            isRtl && $9b0e2f2bf4cd39a6$var$containerStyles.rtl,
            isDisabled && $9b0e2f2bf4cd39a6$var$containerStyles.disabled,
            (0, $b2896f4f52b4ee15$export$a274e22fb40f762e)(className, xcss, '-container')
        ]),
        style: css
    }, innerProps), children);
};


/* value-container.tsx generated by @compiled/babel-plugin v2.0.0 */ 

var $5FkrB = parcelRequire("5FkrB");

var $lqU89 = parcelRequire("lqU89");



var $6aa51e2d4ac8184c$var$valueContainerStyles = {
    default: "_16jlkb7n _1o9zkb7n _i0dlf1ug _1reo15vq _18m915vq _4cvr1h6o _1e0c11p5 _1n261g80 _8am5i4x0 _kqswh2mm _y4ti12x7 _bozg12x7",
    verticalPaddingStandard: "_1q51v77o _85i5v77o",
    verticalPaddingTagUpliftMulti: "_1q511b66 _85i51b66",
    verticalPaddingTagUpliftCompactMulti: "_1q51v77o _85i5v77o",
    verticalPaddingCompactNonUplift: "_1q51ze3t _85i5ze3t",
    flex: "_1e0c1txw",
    flexWithGap: "_zulp1b66 _1e0c1txw _1n261g80"
};
var $6aa51e2d4ac8184c$export$4dc9f58ad9a1a000 = function ValueContainer(props) {
    var children = props.children, innerProps = props.innerProps, isMulti = props.isMulti, hasValue = props.hasValue, isCompact = props.isCompact, xcss = props.xcss, controlShouldRenderValue = props.selectProps.controlShouldRenderValue;
    var _getStyleProps = (0, $26e98d575ca76ea1$export$26417cabd806a658)(props, 'valueContainer', {
        'value-container': true,
        'value-container--is-multi': isMulti,
        'value-container--has-value': hasValue
    }), css = _getStyleProps.css, className = _getStyleProps.className;
    var ffTagUplifts = (0, $13a186c4459b8c2a$export$b40ec24ac8275656)('platform-dst-lozenge-tag-badge-visual-uplifts');
    var tagUpliftMultiVertical = ffTagUplifts && isMulti;
    var tagUpliftChipRow = ffTagUplifts && isMulti && hasValue && controlShouldRenderValue;
    return /*#__PURE__*/ $5FkrB.createElement("div", (0, $e7be1629a1f1b709$export$2e2bcd8739ae039)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $lqU89.default)([
            $6aa51e2d4ac8184c$var$valueContainerStyles.default,
            tagUpliftMultiVertical && isCompact && $6aa51e2d4ac8184c$var$valueContainerStyles.verticalPaddingTagUpliftCompactMulti,
            tagUpliftMultiVertical && !isCompact && $6aa51e2d4ac8184c$var$valueContainerStyles.verticalPaddingTagUpliftMulti,
            !tagUpliftMultiVertical && !isCompact && $6aa51e2d4ac8184c$var$valueContainerStyles.verticalPaddingStandard,
            !tagUpliftMultiVertical && isCompact && $6aa51e2d4ac8184c$var$valueContainerStyles.verticalPaddingCompactNonUplift,
            isMulti && hasValue && controlShouldRenderValue && $6aa51e2d4ac8184c$var$valueContainerStyles.flex,
            tagUpliftChipRow && $6aa51e2d4ac8184c$var$valueContainerStyles.flexWithGap,
            (0, $b2896f4f52b4ee15$export$a274e22fb40f762e)(className, xcss, '-ValueContainer')
        ]),
        style: css
    }, innerProps), children);
};


/* control.tsx generated by @compiled/babel-plugin v2.0.0 */ 

var $5FkrB = parcelRequire("5FkrB");

var $lqU89 = parcelRequire("lqU89");



var $dd4924b13f7e0512$var$styles = {
    default: "_12ji1r31 _1qu2glyw _12y3idpf _2rkofajl _v564r5cv _1h6drsbi _1dqonqa1 _189ee4h9 _4cvr1h6o _80om73ad _1e0c1txw _1n261g80 _1bah1yb4 _kqswh2mm _bfhk1j9a _1tke1ylp _1q51ze3t _y4tize3t _85i5ze3t _bozgze3t _15peftgi _1ke8ftgi _jaboglyw _1u6luvb6 _4cvxrsbi _123byq51 _d0altlke _irr3l4ek _1ogl1caj",
    defaultT26Shape: "_2rko1qi0",
    compact: "_1tkezwfg",
    invalid: "_1h6d1bqt _16qsizbr _1u6lizbr _4cvx1bqt",
    focusedInvalid: "_16qsvyy1",
    disabled: "_1h6d187o _lcxvglyw _bfhk187o _1u6lfrlt",
    focused: "_1h6d1v1w _bfhkr01l _16qsvyy1 _1u6lvyy1 _4cvx1v1w _irr3r01l",
    subtle: "_1h6d1j28 _bfhk1j28 _1u6l3sij",
    subtleFocused: "_bfhkvuon",
    none: "_1h6d1j28 _bfhk1j28 _1u6l3sij _4cvx1j28 _irr31j28"
};
var $dd4924b13f7e0512$var$Control = function Control(props) {
    var children = props.children, appearance = props.appearance, isCompact = props.isCompact, isDisabled = props.isDisabled, isFocused = props.isFocused, isInvalid = props.isInvalid, innerRef = props.innerRef, innerProps = props.innerProps, menuIsOpen = props.menuIsOpen, xcss = props.xcss;
    var _getStyleProps = (0, $26e98d575ca76ea1$export$26417cabd806a658)(props, 'control', {
        control: true,
        'control--is-disabled': isDisabled,
        'control--is-focused': isFocused,
        'control--menu-is-open': menuIsOpen
    }), css = _getStyleProps.css, className = _getStyleProps.className;
    return /*#__PURE__*/ $5FkrB.createElement("div", (0, $e7be1629a1f1b709$export$2e2bcd8739ae039)({
        ref: innerRef,
        className: (0, $lqU89.default)([
            $dd4924b13f7e0512$var$styles.default,
            (0, $13a186c4459b8c2a$export$b40ec24ac8275656)('platform-dst-shape-theme-default') && $dd4924b13f7e0512$var$styles.defaultT26Shape,
            isDisabled && $dd4924b13f7e0512$var$styles.disabled,
            isInvalid && $dd4924b13f7e0512$var$styles.invalid,
            isCompact && $dd4924b13f7e0512$var$styles.compact,
            appearance === 'subtle' && $dd4924b13f7e0512$var$styles.subtle,
            appearance === 'subtle' && isFocused && $dd4924b13f7e0512$var$styles.subtleFocused,
            isFocused && $dd4924b13f7e0512$var$styles.focused,
            appearance === 'none' && $dd4924b13f7e0512$var$styles.none,
            (0, $b2896f4f52b4ee15$export$a274e22fb40f762e)(className, xcss, '-control')
        ]),
        style: css
    }, innerProps, {
        "aria-disabled": (0, $13a186c4459b8c2a$export$b40ec24ac8275656)('platform_dst_select_disabled_a11y_fix') ? undefined : isDisabled || undefined
    }), children);
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$dd4924b13f7e0512$export$2e2bcd8739ae039 = $dd4924b13f7e0512$var$Control;


/* group.tsx generated by @compiled/babel-plugin v2.0.0 */ 

var $5FkrB = parcelRequire("5FkrB");

var $lqU89 = parcelRequire("lqU89");


var $142ec2fb4414ebd5$var$styles = {
    root: "_85i5u2gc _1q51u2gc"
};
var $142ec2fb4414ebd5$var$Group = function Group(props) {
    var children = props.children, builtinCX = props.cx, getStyles = props.getStyles, getClassNames = props.getClassNames, Heading = props.Heading, headingProps = props.headingProps, innerProps = props.innerProps, label = props.label, selectProps = props.selectProps, xcss = props.xcss;
    var _getStyleProps = (0, $26e98d575ca76ea1$export$26417cabd806a658)(props, 'group', {
        group: true
    }), css = _getStyleProps.css, className = _getStyleProps.className;
    return /*#__PURE__*/ $5FkrB.createElement("div", (0, $e7be1629a1f1b709$export$2e2bcd8739ae039)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css
    }, innerProps, {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $lqU89.default)([
            $142ec2fb4414ebd5$var$styles.root,
            (0, $b2896f4f52b4ee15$export$a274e22fb40f762e)(className, xcss, innerProps === null || innerProps === void 0 ? void 0 : innerProps.className, '-Group')
        ])
    }), label && /*#__PURE__*/ $5FkrB.createElement(Heading, (0, $e7be1629a1f1b709$export$2e2bcd8739ae039)({}, headingProps, {
        selectProps: selectProps,
        getStyles: getStyles,
        getClassNames: getClassNames,
        cx: builtinCX
    }), label), /*#__PURE__*/ $5FkrB.createElement("div", null, children));
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$142ec2fb4414ebd5$export$2e2bcd8739ae039 = $142ec2fb4414ebd5$var$Group;


/* group-heading.tsx generated by @compiled/babel-plugin v2.0.0 */ 


var $5FkrB = parcelRequire("5FkrB");

var $lqU89 = parcelRequire("lqU89");




var $79f379f03d71888a$var$_excluded = [
    "className",
    "clearValue",
    "cx",
    "xcss",
    "getStyles",
    "getClassNames",
    "getValue",
    "hasValue",
    "isMulti",
    "isRtl",
    "options",
    "selectOption",
    "selectProps",
    "setValue"
];
function $79f379f03d71888a$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $79f379f03d71888a$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $79f379f03d71888a$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $90d31be1abcfa6da$export$2e2bcd8739ae039)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $79f379f03d71888a$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $79f379f03d71888a$export$8e9fd4287627890c = function cleanCommonProps(props) {
    //className
    var className = props.className, clearValue = props.clearValue, cx = props.cx, xcss = props.xcss, getStyles = props.getStyles, getClassNames = props.getClassNames, getValue = props.getValue, hasValue = props.hasValue, isMulti = props.isMulti, isRtl = props.isRtl, options = props.options, selectOption = props.selectOption, selectProps = props.selectProps, setValue = props.setValue, innerProps = (0, $9b3d50432d7c2d71$export$2e2bcd8739ae039)(props, $79f379f03d71888a$var$_excluded);
    return $79f379f03d71888a$var$_objectSpread({}, innerProps);
};


var $9f4c62aed19cfe1f$var$_excluded = [
    "data"
];
var $9f4c62aed19cfe1f$var$headingStyles = null;
var $9f4c62aed19cfe1f$export$85c8b41a3cd87edc = function GroupHeading(props) {
    var xcss = props.xcss;
    var _cleanCommonProps = (0, $79f379f03d71888a$export$8e9fd4287627890c)(props), data = _cleanCommonProps.data, innerProps = (0, $9b3d50432d7c2d71$export$2e2bcd8739ae039)(_cleanCommonProps, $9f4c62aed19cfe1f$var$_excluded);
    var _getStyleProps = (0, $26e98d575ca76ea1$export$26417cabd806a658)(props, 'groupHeading', {
        'group-heading': true
    }), css = _getStyleProps.css, className = _getStyleProps.className;
    return /*#__PURE__*/ $5FkrB.createElement("div", (0, $e7be1629a1f1b709$export$2e2bcd8739ae039)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $lqU89.default)([
            "_11c8wadc _1e0c1ule _syazazsu _80om73ad _k48pwu06 _6rthpd1z _y4tiutpp _bozgutpp _1p1dglyw",
            (0, $b2896f4f52b4ee15$export$a274e22fb40f762e)(className, xcss, '-group')
        ]),
        style: css
    }, innerProps));
};


/* clear-indicator.tsx generated by @compiled/babel-plugin v2.0.0 */ 

var $5FkrB = parcelRequire("5FkrB");

var $lqU89 = parcelRequire("lqU89");

var $1b97399a8c642560$exports = {};
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3eb90e0e095210547df6d71f04e27a56>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty($1b97399a8c642560$exports, "__esModule", {
    value: true
});
$1b97399a8c642560$exports.default = void 0;

var $1b97399a8c642560$var$_react = $1b97399a8c642560$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $1b97399a8c642560$var$_baseNew = $1b97399a8c642560$var$_interopRequireDefault((parcelRequire("ihrNW")));
function $1b97399a8c642560$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "CrossCircle".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: clear text field, error status.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $1b97399a8c642560$var$CrossCircleIcon = (props)=>/*#__PURE__*/ $1b97399a8c642560$var$_react.default.createElement($1b97399a8c642560$var$_baseNew.default, Object.assign({
        name: "CrossCircleIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 0a8 8 0 1 0 0 16A8 8 0 0 0 8 0m4.03 5.03L9.06 8l2.97 2.97-1.06 1.06L8 9.06l-2.97 2.97-1.06-1.06L6.94 8 3.97 5.03l1.06-1.06L8 6.94l2.97-2.97z" clip-rule="evenodd"/>`
    }, props));
$1b97399a8c642560$var$CrossCircleIcon.displayName = 'CrossCircleIcon';
var $1b97399a8c642560$var$_default = $1b97399a8c642560$exports.default = $1b97399a8c642560$var$CrossCircleIcon;


/* pressable.tsx generated by @compiled/babel-plugin v0.40.0 */ 


var $5FkrB = parcelRequire("5FkrB");




var $5FkrB = parcelRequire("5FkrB");










var $c6973498971bc4e2$var$_process, $c6973498971bc4e2$var$_process2;
// We can't rely on NODE_ENV === 'test' if its value is already configured by the consumer to some other value, so better to use JEST_WORKER_ID
// https://jestjs.io/docs/environment-variables#jest_worker_id
var $c6973498971bc4e2$var$TESTS_MODE = (globalThis === null || globalThis === void 0 || ($c6973498971bc4e2$var$_process = globalThis.process) === null || $c6973498971bc4e2$var$_process === void 0 || ($c6973498971bc4e2$var$_process = $c6973498971bc4e2$var$_process.env) === null || $c6973498971bc4e2$var$_process === void 0 ? void 0 : $c6973498971bc4e2$var$_process.JEST_WORKER_ID) !== undefined;
var $c6973498971bc4e2$var$DEBUG_MODE = !$c6973498971bc4e2$var$TESTS_MODE && (globalThis === null || globalThis === void 0 || ($c6973498971bc4e2$var$_process2 = globalThis.process) === null || $c6973498971bc4e2$var$_process2 === void 0 || ($c6973498971bc4e2$var$_process2 = $c6973498971bc4e2$var$_process2.env) === null || $c6973498971bc4e2$var$_process2 === void 0 ? void 0 : $c6973498971bc4e2$var$_process2.NODE_ENV) !== 'production';
var $c6973498971bc4e2$export$1c9f709888824e05 = function debug() {
    var _console;
    if (!$c6973498971bc4e2$var$DEBUG_MODE) return;
    // eslint-disable-next-line no-console
    (_console = console).debug.apply(_console, arguments);
};



var $3ZMUU = parcelRequire("3ZMUU");
var $56b5a466ade2231f$var$pkgName = '@atlaskit/platform-feature-flags';
var $56b5a466ade2231f$export$7e41b1b2bdee3f98 = '__PLATFORM_FEATURE_FLAGS__';
var $56b5a466ade2231f$var$hasProcessEnv = typeof $3ZMUU !== 'undefined' && typeof $3ZMUU.env !== 'undefined';
// FF global overrides can be configured by test runners or Storybook
var $56b5a466ade2231f$var$ENV_ENABLE_PLATFORM_FF = $56b5a466ade2231f$var$hasProcessEnv ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;
// STORYBOOK_ENABLE_PLATFORM_FF is included as storybook only allows env vars prefixed with STORYBOOK
// https://github.com/storybookjs/storybook/issues/12270
var $56b5a466ade2231f$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF = $56b5a466ade2231f$var$hasProcessEnv ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;
var $56b5a466ade2231f$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE = $56b5a466ade2231f$var$ENV_ENABLE_PLATFORM_FF || $56b5a466ade2231f$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF;
var $56b5a466ade2231f$var$DEFAULT_PFF_GLOBAL = {
    booleanResolver: undefined
};
var $56b5a466ade2231f$var$globalVar = typeof window !== 'undefined' ? window : globalThis;
$56b5a466ade2231f$var$globalVar[$56b5a466ade2231f$export$7e41b1b2bdee3f98] = $56b5a466ade2231f$var$globalVar[$56b5a466ade2231f$export$7e41b1b2bdee3f98] || $56b5a466ade2231f$var$DEFAULT_PFF_GLOBAL;
function $56b5a466ade2231f$export$f2b591175b3e424c(resolver) {
    $56b5a466ade2231f$var$globalVar[$56b5a466ade2231f$export$7e41b1b2bdee3f98].booleanResolver = resolver;
}
function $56b5a466ade2231f$export$6333b6aff9fc6275(flagKey) {
    if ($56b5a466ade2231f$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE) {
        (0, $c6973498971bc4e2$export$1c9f709888824e05)('[%s]: The feature flags were enabled while running tests. The flag "%s" will be always enabled.', $56b5a466ade2231f$var$pkgName, flagKey);
        return true;
    }
    try {
        var _globalVar$PFF_GLOBAL, _globalVar$PFF_GLOBAL2, _globalVar$PFF_GLOBAL3;
        // booleanResolver will be empty for products like Trello, Elevate, Recruit etc.
        // Currently only Confluence, Jira and Bitbucket has set it.
        if (((_globalVar$PFF_GLOBAL = $56b5a466ade2231f$var$globalVar[$56b5a466ade2231f$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL === void 0 ? void 0 : _globalVar$PFF_GLOBAL.booleanResolver) === undefined || ((_globalVar$PFF_GLOBAL2 = $56b5a466ade2231f$var$globalVar[$56b5a466ade2231f$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL2 === void 0 ? void 0 : _globalVar$PFF_GLOBAL2.booleanResolver) === null) // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
        return (0, $63a5e8a642f98278$export$2e2bcd8739ae039).checkGate(flagKey);
        var result = (_globalVar$PFF_GLOBAL3 = $56b5a466ade2231f$var$globalVar[$56b5a466ade2231f$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL3 === void 0 ? void 0 : _globalVar$PFF_GLOBAL3.booleanResolver(flagKey);
        if (typeof result !== 'boolean') {
            // eslint-disable-next-line no-console
            console.warn("".concat(flagKey, " resolved to a non-boolean value, returning false for safety"));
            return false;
        }
        return result;
    } catch (e) {
        return false;
    }
}


function $ade8175626d79f93$export$ba05d765b8392e5e(flagResolver) {
    (0, $56b5a466ade2231f$export$f2b591175b3e424c)(flagResolver);
}
function $ade8175626d79f93$export$470e5c2be1411c89(name) {
    return (0, $56b5a466ade2231f$export$6333b6aff9fc6275)(name);
}
function $ade8175626d79f93$export$b40ec24ac8275656(name) {
    return (0, $56b5a466ade2231f$export$6333b6aff9fc6275)(name);
}






function $e9c4bbbe3b548751$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $e9c4bbbe3b548751$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $e9c4bbbe3b548751$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $90d31be1abcfa6da$export$2e2bcd8739ae039)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $e9c4bbbe3b548751$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $e9c4bbbe3b548751$export$ad4be5c2ec28cecf = function isAnalyticsEvent(obj) {
    var _obj$constructor;
    return obj instanceof $e9c4bbbe3b548751$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 || (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === 'AnalyticsEvent';
};
// eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
var $e9c4bbbe3b548751$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function AnalyticsEvent(props) {
        var _this = this;
        (0, $9ba5074f09554cd6$export$2e2bcd8739ae039)(this, AnalyticsEvent);
        (0, $90d31be1abcfa6da$export$2e2bcd8739ae039)(this, "_isAnalyticsEvent", true);
        (0, $90d31be1abcfa6da$export$2e2bcd8739ae039)(this, "clone", function() {
            // just a shallow clone, don't change sub refs unless you want to
            // affect the original's too
            var payload = $e9c4bbbe3b548751$var$_objectSpread({}, _this.payload);
            return new AnalyticsEvent({
                payload: payload
            });
        });
        this.payload = props.payload;
    }
    return (0, $920934557ff0cee7$export$2e2bcd8739ae039)(AnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (typeof updater === 'function') this.payload = updater(this.payload);
                if ((0, $08eb341cc44a6255$export$2e2bcd8739ae039)(updater) === 'object') this.payload = $e9c4bbbe3b548751$var$_objectSpread($e9c4bbbe3b548751$var$_objectSpread({}, this.payload), updater);
                return this;
            }
        }
    ]);
}();


function $e2707d55314fec37$var$_callSuper(t, o, e) {
    return o = (0, $4753b89c96b5d03b$export$2e2bcd8739ae039)(o), (0, $916d1780331a30aa$export$2e2bcd8739ae039)(t, $e2707d55314fec37$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, $4753b89c96b5d03b$export$2e2bcd8739ae039)(t).constructor) : o.apply(t, e));
}
function $e2707d55314fec37$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($e2707d55314fec37$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $e2707d55314fec37$var$_superPropGet(t, o, e, r) {
    var p = (0, $72a57512c47d7aa1$export$2e2bcd8739ae039)((0, $4753b89c96b5d03b$export$2e2bcd8739ae039)(1 & r ? t.prototype : t), o, e);
    return 2 & r && "function" == typeof p ? function(t) {
        return p.apply(e, t);
    } : p;
}
function $e2707d55314fec37$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $e2707d55314fec37$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $e2707d55314fec37$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $90d31be1abcfa6da$export$2e2bcd8739ae039)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $e2707d55314fec37$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $e2707d55314fec37$export$35f8383928ba8d7 = function isUIAnalyticsEvent(obj) {
    var _obj$constructor;
    return obj instanceof $e2707d55314fec37$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isUIAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 || (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === 'UIAnalyticsEvent';
};
/**
 * Produces a deep clone of an event payload.
 *
 * The historic implementation relied on `JSON.parse(JSON.stringify(...))`, a
 * "hacky" deep clone that does not support functions, regexs, Maps, Sets, etc.
 * Crucially, `JSON.stringify` also throws `TypeError: Converting circular
 * structure to JSON` when the payload contains a value with circular
 * references — e.g. a live DOM node carrying React fiber back-references
 * (`__reactFiber$...`). When that throw happens during a React render/commit it
 * escapes into product UI and trips an error boundary (HOT-127428).
 *
 * Analytics must never crash product UI (the same contract `fire` upholds), so
 * behind the `platform-analytics-next-safe-clone` gate we wrap the
 * serialization in a try/catch and fall back to a shallow clone — matching the
 * base `AnalyticsEvent.clone` behaviour — if the deep clone fails.
 *
 * NOTE: this is intentionally a module-scoped function rather than a class
 * member so it does not change the structural type of `UIAnalyticsEvent`, which
 * is hand-mocked across the monorepo.
 */ var $e2707d55314fec37$var$clonePayload = function clonePayload(payload) {
    if ((0, $ade8175626d79f93$export$b40ec24ac8275656)('platform-analytics-next-safe-clone')) try {
        return JSON.parse(JSON.stringify(payload));
    } catch (e) {
        // Shallow clone keeps the event usable without crashing the UI.
        return $e2707d55314fec37$var$_objectSpread({}, payload);
    }
    /**
   * A hacky "deep clone" of the object. This is limited in that it wont
   * support functions, regexs, Maps, Sets, etc, but none of those need to
   * be represented in our payload.
   */ return JSON.parse(JSON.stringify(payload));
};
// eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
var $e2707d55314fec37$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_AnalyticsEvent) {
    function UIAnalyticsEvent(props) {
        var _this;
        (0, $9ba5074f09554cd6$export$2e2bcd8739ae039)(this, UIAnalyticsEvent);
        _this = $e2707d55314fec37$var$_callSuper(this, UIAnalyticsEvent, [
            props
        ]);
        (0, $90d31be1abcfa6da$export$2e2bcd8739ae039)(_this, "_isUIAnalyticsEvent", true);
        (0, $90d31be1abcfa6da$export$2e2bcd8739ae039)(_this, "clone", function() {
            if (_this.hasFired) return null;
            var context = (0, $f90c78505475f844$export$2e2bcd8739ae039)(_this.context);
            var handlers = (0, $f90c78505475f844$export$2e2bcd8739ae039)(_this.handlers);
            var payload = $e2707d55314fec37$var$clonePayload(_this.payload);
            return new UIAnalyticsEvent({
                context: context,
                handlers: handlers,
                payload: payload
            });
        });
        (0, $90d31be1abcfa6da$export$2e2bcd8739ae039)(_this, "fire", function(channel) {
            if (_this.hasFired) return;
            _this.handlers.forEach(function(handler) {
                try {
                    handler(_this, channel);
                } catch (e) {}
            });
            _this.hasFired = true;
        });
        _this.context = props.context || [];
        _this.handlers = props.handlers || [];
        _this.hasFired = false;
        return _this;
    }
    (0, $908cdaf31c7766dc$export$2e2bcd8739ae039)(UIAnalyticsEvent, _AnalyticsEvent);
    return (0, $920934557ff0cee7$export$2e2bcd8739ae039)(UIAnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (this.hasFired) return this;
                return $e2707d55314fec37$var$_superPropGet(UIAnalyticsEvent, "update", this, 3)([
                    updater
                ]);
            }
        }
    ]);
}((0, $e9c4bbbe3b548751$export$2e2bcd8739ae039));



var $5FkrB = parcelRequire("5FkrB");

var $b90f758928f0a7fe$export$d1f587f82ad51c4 = function useAnalyticsContext() {
    return (0, $5FkrB.useContext)((0, $d82667e77467cbe0$export$2e2bcd8739ae039));
};


function $71a4cbb717843720$export$5bf35293e545f20c() {
    var analyticsContext = (0, $b90f758928f0a7fe$export$d1f587f82ad51c4)();
    var createAnalyticsEvent = (0, $a060da77483cc5d3$export$33752cf3ee811995)(function(payload) {
        return new (0, $e2707d55314fec37$export$2e2bcd8739ae039)({
            context: analyticsContext.getAtlaskitAnalyticsContext(),
            handlers: analyticsContext.getAtlaskitAnalyticsEventHandlers(),
            payload: payload
        });
    }, [
        analyticsContext
    ]);
    return {
        createAnalyticsEvent: createAnalyticsEvent
    };
}



var $5FkrB = parcelRequire("5FkrB");
var $f7705de98ba126d7$export$1d27a74659855e44 = function useTrackedRef(value) {
    var ref = (0, $5FkrB.useRef)(value);
    ref.current = value;
    return ref;
};


function $7d4672308a7535c0$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $7d4672308a7535c0$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $7d4672308a7535c0$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $90d31be1abcfa6da$export$2e2bcd8739ae039)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $7d4672308a7535c0$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $7d4672308a7535c0$export$a4687b0234b40e28(_ref) {
    var fn = _ref.fn, action = _ref.action, componentName = _ref.componentName, actionSubject = _ref.actionSubject, packageName = _ref.packageName, packageVersion = _ref.packageVersion, analyticsData = _ref.analyticsData;
    var _useAnalyticsEvents = (0, $71a4cbb717843720$export$5bf35293e545f20c)(), createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
    // We put analyticsData and fn in a ref so that we don't need to break
    // memoization.
    // Generally these could be defined by consumers inline
    // and so we do this to avoid breaking memoization of useCallback
    var dataRef = (0, $f7705de98ba126d7$export$1d27a74659855e44)(analyticsData);
    var fnRef = (0, $f7705de98ba126d7$export$1d27a74659855e44)(fn);
    var handler = (0, $5FkrB.useCallback)(function(value) {
        var analyticsEvent = createAnalyticsEvent({
            action: action,
            actionSubject: actionSubject || componentName,
            attributes: {
                componentName: componentName,
                packageName: packageName,
                packageVersion: packageVersion
            }
        });
        // To avoid wrapping this component in AnalyticsContext we manually
        // push the parent context's meta data into the context.
        // Note: this new 'context'
        var context = $7d4672308a7535c0$var$_objectSpread({
            componentName: componentName,
            packageName: packageName,
            packageVersion: packageVersion
        }, dataRef.current);
        analyticsEvent.context.push(context);
        // fire an event on the atlaskit channel
        var clone = analyticsEvent.clone();
        if (clone) clone.fire('atlaskit');
        fnRef.current(value, analyticsEvent);
    }, [
        // These are strings and won't change
        action,
        componentName,
        actionSubject,
        packageName,
        packageVersion,
        // This function is memoized in the context
        createAnalyticsEvent,
        // these are a stable ref because of the useTrackedRef hook
        dataRef,
        fnRef
    ]);
    return handler;
}





/* focusable.tsx generated by @compiled/babel-plugin v0.40.0 */ 


var $5FkrB = parcelRequire("5FkrB");

var $lqU89 = parcelRequire("lqU89");
var $89f3ec4349119b11$var$_excluded = [
    "as",
    "children",
    "isInset",
    "testId",
    "style",
    "xcss"
], $89f3ec4349119b11$var$_excluded2 = [
    "className"
];
var $89f3ec4349119b11$var$focusRingStyles = null;
var $89f3ec4349119b11$var$insetFocusRingStyles = null;
var $89f3ec4349119b11$export$35a3bebf7ef2d934 = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? 'button' : _ref$as, children = _ref.children, isInset = _ref.isInset, testId = _ref.testId, style = _ref.style, xcss = _ref.xcss, htmlAttributes = (0, $9b3d50432d7c2d71$export$2e2bcd8739ae039)(_ref, $89f3ec4349119b11$var$_excluded);
    // This is to remove className from safeHtmlAttributes
    // @ts-ignore -- not using expect since it causes issues with help-center local consumption - className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    var _spreadClass = htmlAttributes.className, safeHtmlAttributes = (0, $9b3d50432d7c2d71$export$2e2bcd8739ae039)(htmlAttributes, $89f3ec4349119b11$var$_excluded2);
    return /*#__PURE__*/ $5FkrB.createElement(Component, (0, $e7be1629a1f1b709$export$2e2bcd8739ae039)({}, safeHtmlAttributes, {
        // @ts-ignore Expression produces a union type that is too complex to represent. We may be able to narrow the type here but unsure.
        ref: ref,
        className: (0, $lqU89.default)([
            "_ymio1r31 _ypr0glyw _zcxs1o36 _mizu194a _1ah3dkaa _ra3xnqa1 _128mdkaa _1cvmnqa1 _4davt94y",
            isInset && "_1ah31gjf _2mwq1gjf",
            xcss
        ]),
        style: style,
        "data-testid": testId
    }), children);
});


var $76f5966e2dd79a11$var$_excluded = [
    "children",
    "isDisabled",
    "type",
    "onClick",
    "interactionName",
    "componentName",
    "analyticsContext",
    "style",
    "testId",
    "xcss",
    "tabIndex"
], $76f5966e2dd79a11$var$_excluded2 = [
    "className"
];
var $76f5966e2dd79a11$var$styles = {
    root: "_19itglyw _vchhusvi _r06hglyw _80omtlke",
    disabled: "_80om13gf"
};
var $76f5966e2dd79a11$export$27c701ed9e449e99 = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function(_ref, ref) {
    var children = _ref.children, isDisabled = _ref.isDisabled, _ref$type = _ref.type, type = _ref$type === void 0 ? 'button' : _ref$type, _ref$onClick = _ref.onClick, providedOnClick = _ref$onClick === void 0 ? (0, $adcefb868cf2fc9d$export$2e2bcd8739ae039) : _ref$onClick, interactionName = _ref.interactionName, componentName = _ref.componentName, analyticsContext = _ref.analyticsContext, style = _ref.style, testId = _ref.testId, xcss = _ref.xcss, tabIndex = _ref.tabIndex, htmlAttributes = (0, $9b3d50432d7c2d71$export$2e2bcd8739ae039)(_ref, $76f5966e2dd79a11$var$_excluded);
    var interactionContext = (0, $5FkrB.useContext)((0, $a81fd7e45a8c2ef5$export$2e2bcd8739ae039));
    var handleClick = (0, $5FkrB.useCallback)(function(e, analyticsEvent) {
        interactionContext && interactionContext.tracePress(interactionName, e.timeStamp);
        providedOnClick(e, analyticsEvent);
    }, [
        providedOnClick,
        interactionContext,
        interactionName
    ]);
    var onClick = (0, $7d4672308a7535c0$export$a4687b0234b40e28)({
        fn: handleClick,
        action: 'clicked',
        componentName: componentName || 'Pressable',
        packageName: "@atlaskit/primitives",
        packageVersion: "22.1.1",
        analyticsData: analyticsContext,
        actionSubject: 'button'
    });
    // This is to remove className from safeHtmlAttributes
    // @ts-expect-error className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    var _spreadClass = htmlAttributes.className, safeHtmlAttributes = (0, $9b3d50432d7c2d71$export$2e2bcd8739ae039)(htmlAttributes, $76f5966e2dd79a11$var$_excluded2);
    return /*#__PURE__*/ $5FkrB.createElement((0, $89f3ec4349119b11$export$35a3bebf7ef2d934), (0, $e7be1629a1f1b709$export$2e2bcd8739ae039)({
        as: "button",
        tabIndex: tabIndex !== null && tabIndex !== void 0 ? tabIndex : (0, $9cdac13a38ee471b$export$95df08bae54cb4df)() && !isDisabled ? 0 : undefined,
        style: style
    }, safeHtmlAttributes, {
        type: type,
        onClick: onClick,
        disabled: isDisabled,
        xcss: (0, $b2896f4f52b4ee15$export$a274e22fb40f762e)($76f5966e2dd79a11$var$styles.root, isDisabled && $76f5966e2dd79a11$var$styles.disabled, xcss),
        testId: testId,
        ref: ref
    }), children);
});



var $4910bfbc75b7ff81$var$iconContainerStyles = {
    root: "_kkk2n7od _12ji1r31 _1qu219ly _12y31o36 _1e0c1txw _4cvr1h6o _1bah1h6o _1q51v77o _y4tiv77o _85i5v77o _bozgv77o"
};
var $4910bfbc75b7ff81$var$clearIndicatorStyles = {
    default: "_v564vrg3 _1e0c1txw _syaz1rpy _1q5112x7 _y4tiv77o _85i512x7 _bozgv77o _30l3azsu",
    compact: "_1q51idpf _85i5idpf"
};
var $4910bfbc75b7ff81$export$ecf9cf59142dd54a = function ClearIndicator(props) {
    var innerProps = props.innerProps, _props$clearControlLa = props.clearControlLabel, clearControlLabel = _props$clearControlLa === void 0 ? 'clear' : _props$clearControlLa, isCompact = props.isCompact, xcss = props.xcss;
    var _getStyleProps = (0, $26e98d575ca76ea1$export$26417cabd806a658)(props, 'clearIndicator', {
        indicator: true,
        'clear-indicator': true
    }), css = _getStyleProps.css, className = _getStyleProps.className;
    return /*#__PURE__*/ $5FkrB.createElement("div", (0, $e7be1629a1f1b709$export$2e2bcd8739ae039)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        className: (0, $lqU89.default)([
            $4910bfbc75b7ff81$var$clearIndicatorStyles.default,
            isCompact && $4910bfbc75b7ff81$var$clearIndicatorStyles.compact,
            (0, $b2896f4f52b4ee15$export$a274e22fb40f762e)(className, xcss, '-indicatorContainer')
        ])
    }, innerProps), /*#__PURE__*/ $5FkrB.createElement((0, $76f5966e2dd79a11$export$27c701ed9e449e99), {
        xcss: $4910bfbc75b7ff81$var$iconContainerStyles.root,
        tabIndex: -1,
        "aria-label": clearControlLabel
    }, /*#__PURE__*/ $5FkrB.createElement((0, (/*@__PURE__*/$parcel$interopDefault($1b97399a8c642560$exports))), {
        label: "",
        color: "currentColor",
        size: "small"
    })));
};


/* dropdown-indicator.tsx generated by @compiled/babel-plugin v2.0.0 */ 


var $5FkrB = parcelRequire("5FkrB");

var $lqU89 = parcelRequire("lqU89");

var $1bca3bdfac6f5ca0$exports = {};
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d56e8662eb8a8d2462ec3a39ff3aa40b>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty($1bca3bdfac6f5ca0$exports, "__esModule", {
    value: true
});
$1bca3bdfac6f5ca0$exports.default = void 0;

var $1bca3bdfac6f5ca0$var$_react = $1bca3bdfac6f5ca0$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $1bca3bdfac6f5ca0$var$_baseNew = $1bca3bdfac6f5ca0$var$_interopRequireDefault((parcelRequire("ihrNW")));
function $1bca3bdfac6f5ca0$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ChevronDown".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Do not use 16px chevrons within buttons, icon buttons, or dropdowns to maintain visual cohesion with ADS which uses 12px chevrons.
Known uses: Open dropdown menu, expanded tree item, collapse tree item
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $1bca3bdfac6f5ca0$var$ChevronDownIcon = (props)=>/*#__PURE__*/ $1bca3bdfac6f5ca0$var$_react.default.createElement($1bca3bdfac6f5ca0$var$_baseNew.default, Object.assign({
        name: "ChevronDownIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="m14.53 6.03-6 6a.75.75 0 0 1-1.004.052l-.056-.052-6-6 1.06-1.06L8 10.44l5.47-5.47z"/>`
    }, props));
$1bca3bdfac6f5ca0$var$ChevronDownIcon.displayName = 'ChevronDownIcon';
var $1bca3bdfac6f5ca0$var$_default = $1bca3bdfac6f5ca0$exports.default = $1bca3bdfac6f5ca0$var$ChevronDownIcon;



/* inline.tsx generated by @compiled/babel-plugin v0.40.0 */ 


var $5FkrB = parcelRequire("5FkrB");

var $lqU89 = parcelRequire("lqU89");
/* index.tsx generated by @compiled/babel-plugin v0.39.1 */ parcelRequire("5FkrB");

const $b02a1878bfbd973f$export$6c9a87045746941d = ()=>{
    return new Error(`
 \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2557}   \u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2557}     \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}
\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}
\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}   \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}  \u{2588}\u{2588}\u{2551}  \u{2588}\u{2588}\u{2551}
\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}   \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}\u{255A}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{255D} \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{255D}  \u{2588}\u{2588}\u{2551}  \u{2588}\u{2588}\u{2551}
\u{255A}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{255A}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551} \u{255A}\u{2550}\u{255D} \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}
 \u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D} \u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D} \u{255A}\u{2550}\u{255D}     \u{255A}\u{2550}\u{255D}\u{255A}\u{2550}\u{255D}     \u{255A}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}

  @compiled/react

  Code was executed when it shouldn't have. This could have happened because:

  1. You haven't configured a transformer yet. Visit https://compiledcssinjs.com/docs/installation and follow the instructions.
  2. You have duplicate versions of React and hooks are blowing up. You need to de-duplicate your dependencies.

  Good luck!
`);
};
const $b02a1878bfbd973f$export$c4df1cb0c2b4d77c = ()=>{
    return new Error(`
 \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2557}   \u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2557}     \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}
\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}
\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}   \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}  \u{2588}\u{2588}\u{2551}  \u{2588}\u{2588}\u{2551}
\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}   \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}\u{255A}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{255D} \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{255D}  \u{2588}\u{2588}\u{2551}  \u{2588}\u{2588}\u{2551}
\u{255A}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{255A}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551} \u{255A}\u{2550}\u{255D} \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}
 \u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D} \u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D} \u{255A}\u{2550}\u{255D}     \u{255A}\u{2550}\u{255D}\u{255A}\u{2550}\u{255D}     \u{255A}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}

  @compiled/react

  Code was executed when it shouldn't have. To resolve make sure to:

  1. Set up Compiled.
  2. Configure importSources in your Compiled config to point to the module that exports the output of createStrictAPI().

  For more information visit https://compiledcssinjs.com/docs/installation and follow the instructions.
`);
};


/**
 * This length includes the underscore,
 * e.g. `"_1s4A"` would be a valid atomic group hash.
 */ const $7ddec42bf60d4387$var$ATOMIC_GROUP_LENGTH = 5;
function $7ddec42bf60d4387$export$2e2bcd8739ae039(classNames) {
    // Shortcut: nothing to do
    if (!classNames.length) return;
    // Shortcut: don't need to do anything if we only have a single classname
    if (classNames.length === 1 && classNames[0] && // checking to see if `classNames[0]` is a string that contains other classnames
    !classNames[0].includes(' ')) return classNames[0];
    // Using an object rather than a `Map` as it performed better in our benchmarks.
    // Would be happy to move to `Map` if it proved to be better under real conditions.
    const map = {};
    // Note: using loops to minimize iterations over the collection
    for (const value of classNames){
        // Exclude all falsy values, which leaves us with populated strings
        if (!value) continue;
        // a `value` can contain multiple classnames
        const list = value.split(' ');
        for (const className of list){
            /**
             * For atomic style classnames: the `key` is the `group`
             *
             * - Later atomic classnames with the same `group` will override earlier ones
             *   (which is what we want).
             * - Assumes atomic classnames are the only things that start with `_`
             * - Could use a regex to ensure that atomic classnames are structured how we expect,
             *   but did not add that for now as it did slow things down a bit.
             *
             * For other classnames: the `key` is the whole classname
             * - Okay to remove duplicates as doing so does not impact specificity
             *
             * */ const key = className.startsWith('_') ? className.slice(0, $7ddec42bf60d4387$var$ATOMIC_GROUP_LENGTH) : className;
            map[key] = className;
        }
    }
    /**
     * We are converting the `map` into a string.
     *
     * The simple way to do this would be `Object.values(map).join(' ')`.
     * However, the approach below performs 10%-20% better in benchmarks.
     *
     * For `ax()` it feels right to squeeze as much runtime performance out as we can.
     */ let result = '';
    for(const key in map)result += map[key] + ' ';
    // If we have an empty string, then our `map` was empty.
    if (!result) return;
    // remove last " " from the result (we added " " at the end of every value)
    return result.trimEnd();
}


const $9841f91d91e7684a$export$a274e22fb40f762e = (...styles)=>{
    // At runtime TStyles is resolved down to strings, but not at compile time.
    // We circumvent the type system here because of that.
    const actualStyles = styles;
    // The output should be a union type of passed in styles. This ensures the call
    // site of xcss prop can raise violations when disallowed styles have been passed.
    return (0, $7ddec42bf60d4387$export$2e2bcd8739ae039)(actualStyles);
};


function $9df1008df1a74c7a$export$39716b4af53f4ad() {
    return {
        css () {
            throw (0, $b02a1878bfbd973f$export$c4df1cb0c2b4d77c)();
        },
        cssMap () {
            throw (0, $b02a1878bfbd973f$export$c4df1cb0c2b4d77c)();
        },
        cx: $9841f91d91e7684a$export$a274e22fb40f762e,
        XCSSProp () {
            throw (0, $b02a1878bfbd973f$export$c4df1cb0c2b4d77c)();
        }
    };
}


var $7fb296f9abfc5596$var$strictApi = (0, $9df1008df1a74c7a$export$39716b4af53f4ad)();
var $7fb296f9abfc5596$export$dbf350e5966cf602 = $7fb296f9abfc5596$var$strictApi.css;
var $7fb296f9abfc5596$export$eb1ecd84a24ee424 = $7fb296f9abfc5596$var$strictApi.cssMap;
$7fb296f9abfc5596$var$strictApi.cssMap;
var $7fb296f9abfc5596$export$a274e22fb40f762e = $7fb296f9abfc5596$var$strictApi.cx;
var $7fb296f9abfc5596$var$XCSSProp = $7fb296f9abfc5596$var$strictApi.XCSSProp; // This is to mitigate local TS error TS2315: Type 'StrictXCSSProp' is not generic.
 // Currently for some reason tsc is generating malformed .d.ts in local dev environment, below change fixes it
 /**
 * ## StrictXCSSProp
 *
 * Declare styles your component takes with all other styles marked as violations
 * by the TypeScript compiler. There are two primary use cases for xcss prop:
 *
 * - safe style overrides
 * - inverting style declarations
 *
 * Interverting style declarations is interesting for platform teams as
 * it means apps only pay for styles they use as they're now the ones who declare
 * the styles!
 *
 * The {@link StrictXCSSProp} type has generics two of which must be defined — use to explicitly
 * set what you want to maintain as API. Use {@link XCSSAllProperties} and {@link XCSSAllPseudos}
 * to enable all properties and pseudos.
 *
 * The third generic is used to declare what properties and pseudos should be required.
 *
 * ```tsx
 * interface MyComponentProps {
 *   // Color is accepted, all other properties / pseudos are considered violations.
 *   xcss?: StrictXCSSProp<'color', never>;
 *
 *   // Only background color and hover pseudo are accepted.
 *   xcss?: StrictXCSSProp<'backgroundColor', '&:hover'>;
 *
 *   // All properties are accepted, all pseudos are considered violations.
 *   xcss?: StrictXCSSProp<XCSSAllProperties, never>;
 *
 *   // All properties are accepted, only the hover pseudo is accepted.
 *   xcss?: StrictXCSSProp<XCSSAllProperties, '&:hover'>;
 *
 *   // The xcss prop is required as well as the color property. No pseudos are required.
 *   xcss: StrictXCSSProp<
 *     XCSSAllProperties,
 *     '&:hover',
 *     { requiredProperties: 'color', requiredPseudos: never }
 *   >;
 * }
 *
 * function MyComponent({ xcss }: MyComponentProps) {
 *   return <div css={{ color: 'var(--ds-text-danger)' }} className={xcss} />
 * }
 * ```
 *
 * The xcss prop works with static inline objects and the [cssMap](https://compiledcssinjs.com/docs/api-cssmap) API.
 *
 * ```jsx
 * // Declared as an inline object
 * <Component xcss={{ color: 'var(--ds-text)' }} />
 *
 * // Declared with the cssMap API
 * const styles = cssMap({ text: { color: 'var(--ds-text)' } });
 * <Component xcss={styles.text} />
 * ```
 *
 * To concatenate and conditonally apply styles use the {@link cssMap} and {@link cx} functions.
 */ 


/* flex.tsx generated by @compiled/babel-plugin v0.40.0 */ 


var $5FkrB = parcelRequire("5FkrB");

var $lqU89 = parcelRequire("lqU89");
var $28d42ab61a009ead$var$_excluded = [
    "as",
    "role",
    "alignItems",
    "justifyContent",
    "gap",
    "columnGap",
    "rowGap",
    "children",
    "testId",
    "direction",
    "wrap",
    "xcss"
];
var $28d42ab61a009ead$var$rowGapMap = {
    'space.0': "_1p57ze3t",
    'space.025': "_1p57v77o",
    'space.050': "_1p571b66",
    'space.075': "_1p5712x7",
    'space.100': "_1p57u2gc",
    'space.150': "_1p57utpp",
    'space.200': "_1p57pxbi",
    'space.250': "_1p57v47k",
    'space.300': "_1p571ejb",
    'space.400': "_1p57xy5q",
    'space.500': "_1p571jfw",
    'space.600': "_1p57oahv",
    'space.800': "_1p57xncg",
    'space.1000': "_1p571epz"
};
var $28d42ab61a009ead$var$columnGapMap = {
    'space.0': "_gy1pze3t",
    'space.025': "_gy1pv77o",
    'space.050': "_gy1p1b66",
    'space.075': "_gy1p12x7",
    'space.100': "_gy1pu2gc",
    'space.150': "_gy1putpp",
    'space.200': "_gy1ppxbi",
    'space.250': "_gy1pv47k",
    'space.300': "_gy1p1ejb",
    'space.400': "_gy1pxy5q",
    'space.500': "_gy1p1jfw",
    'space.600': "_gy1poahv",
    'space.800': "_gy1pxncg",
    'space.1000': "_gy1p1epz"
};
var $28d42ab61a009ead$var$justifyContentMap = {
    start: "_1bahv2br",
    center: "_1bah1h6o",
    end: "_1bahh9n0",
    'space-between': "_1bah1yb4",
    'space-around': "_1bah1b1v",
    'space-evenly': "_1bahitcz",
    stretch: "_1bah1fhb"
};
var $28d42ab61a009ead$var$flexDirectionMap = {
    column: "_2lx21bp4",
    row: "_2lx2vrvc"
};
var $28d42ab61a009ead$var$flexWrapMap = {
    wrap: "_1n261g80",
    nowrap: "_1n261q9c"
};
var $28d42ab61a009ead$var$alignItemsMap = {
    start: "_4cvrv2br",
    center: "_4cvr1h6o",
    baseline: "_4cvr1q9y",
    end: "_4cvrh9n0",
    stretch: "_4cvr1fhb"
};
var $28d42ab61a009ead$var$styles = {
    root: "_1e0c1txw _vchhusvi"
};
var $28d42ab61a009ead$export$f51f4c4ede09e011 = /*#__PURE__*/ (0, $5FkrB.memo)(/*#__PURE__*/ (0, $5FkrB.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? 'div' : _ref$as, role = _ref.role, alignItems = _ref.alignItems, justifyContent = _ref.justifyContent, gap = _ref.gap, columnGap = _ref.columnGap, rowGap = _ref.rowGap, children = _ref.children, testId = _ref.testId, direction = _ref.direction, wrap = _ref.wrap, xcss = _ref.xcss, ariaAttributes = (0, $9b3d50432d7c2d71$export$2e2bcd8739ae039)(_ref, $28d42ab61a009ead$var$_excluded);
    return /*#__PURE__*/ $5FkrB.createElement(Component, (0, $e7be1629a1f1b709$export$2e2bcd8739ae039)({}, ariaAttributes, {
        role: role,
        className: (0, $lqU89.default)([
            $28d42ab61a009ead$var$styles.root,
            gap && $28d42ab61a009ead$var$columnGapMap[gap],
            columnGap && $28d42ab61a009ead$var$columnGapMap[columnGap],
            gap && $28d42ab61a009ead$var$rowGapMap[gap],
            rowGap && $28d42ab61a009ead$var$rowGapMap[rowGap],
            alignItems && $28d42ab61a009ead$var$alignItemsMap[alignItems],
            direction && $28d42ab61a009ead$var$flexDirectionMap[direction],
            justifyContent && $28d42ab61a009ead$var$justifyContentMap[justifyContent],
            wrap && $28d42ab61a009ead$var$flexWrapMap[wrap],
            xcss
        ]),
        "data-testid": testId,
        ref: ref
    }), children);
}));
$28d42ab61a009ead$export$f51f4c4ede09e011.displayName = 'Flex';


var $87169be5fba8f640$var$_excluded = [
    "as",
    "alignInline",
    "alignBlock",
    "shouldWrap",
    "spread",
    "grow",
    "space",
    "rowSpace",
    "separator",
    "xcss",
    "testId",
    "role",
    "children"
];
var $87169be5fba8f640$var$styles = {
    separator: "_1mouze3t _195g1i6y _syazjjyb _lcxvglyw _uiztglyw",
    hug: "_16jlidpf",
    fill: "_1bsb1osq _16jlkb7n"
};
var $87169be5fba8f640$var$Separator = function Separator(_ref) {
    var children = _ref.children;
    return /*#__PURE__*/ $5FkrB.createElement("span", {
        className: (0, $lqU89.default)([
            $87169be5fba8f640$var$styles.separator
        ])
    }, children);
};
var $87169be5fba8f640$export$fbae5b5ffd8af05e = /*#__PURE__*/ (0, $5FkrB.memo)(/*#__PURE__*/ (0, $5FkrB.forwardRef)(function(_ref2, ref) {
    var as = _ref2.as, alignInline = _ref2.alignInline, _ref2$alignBlock = _ref2.alignBlock, alignItems = _ref2$alignBlock === void 0 ? 'start' : _ref2$alignBlock, _ref2$shouldWrap = _ref2.shouldWrap, shouldWrap = _ref2$shouldWrap === void 0 ? false : _ref2$shouldWrap, spread = _ref2.spread, grow = _ref2.grow, space = _ref2.space, rowSpace = _ref2.rowSpace, separator = _ref2.separator, xcss = _ref2.xcss, testId = _ref2.testId, role = _ref2.role, rawChildren = _ref2.children, ariaAttributes = (0, $9b3d50432d7c2d71$export$2e2bcd8739ae039)(_ref2, $87169be5fba8f640$var$_excluded);
    var separatorComponent = typeof separator === 'string' ? /*#__PURE__*/ $5FkrB.createElement($87169be5fba8f640$var$Separator, null, separator) : separator;
    var children = separatorComponent ? (0, $5FkrB.Children).toArray(rawChildren).filter(Boolean).map(function(child, index) {
        return /*#__PURE__*/ $5FkrB.createElement((0, $5FkrB.Fragment), {
            key: index
        }, separator && index > 0 ? separatorComponent : null, child);
    }) : rawChildren;
    return /*#__PURE__*/ $5FkrB.createElement((0, $28d42ab61a009ead$export$f51f4c4ede09e011), (0, $e7be1629a1f1b709$export$2e2bcd8739ae039)({}, ariaAttributes, {
        as: as,
        role: role,
        alignItems: alignItems,
        justifyContent: spread || alignInline,
        direction: "row",
        gap: space,
        rowGap: rowSpace,
        wrap: shouldWrap ? 'wrap' : undefined,
        xcss: (0, $7fb296f9abfc5596$export$a274e22fb40f762e)(grow === 'hug' && $87169be5fba8f640$var$styles.hug, grow === 'fill' && $87169be5fba8f640$var$styles.fill, xcss),
        testId: testId,
        ref: ref
    }), children);
}));
$87169be5fba8f640$export$fbae5b5ffd8af05e.displayName = 'Inline';



var $d16ec2087ba58c24$var$_excluded = [
    "aria-hidden"
];
var $d16ec2087ba58c24$var$dropdownWrapperStyles = {
    root: "_1q5112x7 _y4ti12x7 _85i512x7 _bozg12x7"
};
// Reset styles for the voice-control <Pressable> so the chevron renders
// pixel-identical to the gate-off icon-in-a-div. Uses @atlaskit/css cssMap
// (aliased as strictCssMap) because Pressable's xcss prop requires that type.
var $d16ec2087ba58c24$var$voiceControlPressableStyles = {
    root: "_1rjcidpf _18zridpf _1mouidpf _195gidpf _bfhk1j28 _1e0c1txw _4cvr1h6o"
};
// Inline size reset applied as a last resort (see the `style` prop docs on
// @atlaskit/primitives). Consumers ship global element selectors such as
// `& button { min-width: 149px }` (e.g. Jira Plans' hierarchy filter — see
// https://hello.jira.atlassian.cloud/jira/browse/JPO-42328) whose (class +
// element) specificity outranks the atomic single-class styles above, stretching
// this button and pushing the chevron toward the middle of the control. Inline
// styles outrank any selector, so the button always hugs the chevron and stays
// right-aligned like the gate-off icon-in-a-div.
var $d16ec2087ba58c24$var$voiceControlPressableSizeReset = {
    minWidth: 0,
    width: 'auto'
};
var $d16ec2087ba58c24$var$dropdownStyles = {
    default: "_v564vrg3 _1e0c1txw _syazazsu _1q5112x7 _y4tiv77o _85i512x7 _bozgv77o _30l3azsu",
    compact: "_1q51idpf _85i5idpf",
    disabled: "_syaz1gmx"
};
var $d16ec2087ba58c24$export$ec98719d3db7f2e4 = function DropdownIndicator(props) {
    var _props$innerProps = props.innerProps, innerProps = _props$innerProps === void 0 ? {} : _props$innerProps, children = props.children, isDisabled = props.isDisabled, isCompact = props.isCompact, xcss = props.xcss;
    var _getStyleProps = (0, $26e98d575ca76ea1$export$26417cabd806a658)(props, 'dropdownIndicator', {
        indicator: true,
        'dropdown-indicator': true
    }), css = _getStyleProps.css, className = _getStyleProps.className;
    var ariaHidden = innerProps['aria-hidden'], restInnerProps = (0, $9b3d50432d7c2d71$export$2e2bcd8739ae039)(innerProps, $d16ec2087ba58c24$var$_excluded);
    var isVoiceControlAccessible = (0, $13a186c4459b8c2a$export$b40ec24ac8275656)('platform_dst_select_dropdown_voice_control');
    // Stable testid for the hoisted aria-hidden children wrapper (avoids parentElement in tests).
    var wrapperTestId = restInnerProps['data-testid'] ? "".concat(restInnerProps['data-testid'], "-children") : undefined;
    var voiceControlAccessibleIndicator = children ? /*#__PURE__*/ $5FkrB.createElement("div", {
        "aria-hidden": ariaHidden,
        "data-testid": wrapperTestId
    }, children) : /*#__PURE__*/ $5FkrB.createElement((0, $76f5966e2dd79a11$export$27c701ed9e449e99), {
        tabIndex: -1,
        "aria-label": "toggle select menu",
        isDisabled: isDisabled,
        componentName: "DropdownIndicatorVoiceControl",
        xcss: $d16ec2087ba58c24$var$voiceControlPressableStyles.root,
        style: $d16ec2087ba58c24$var$voiceControlPressableSizeReset
    }, /*#__PURE__*/ $5FkrB.createElement((0, $87169be5fba8f640$export$fbae5b5ffd8af05e), {
        as: "span",
        xcss: $d16ec2087ba58c24$var$dropdownWrapperStyles.root
    }, /*#__PURE__*/ $5FkrB.createElement((0, (/*@__PURE__*/$parcel$interopDefault($1bca3bdfac6f5ca0$exports))), {
        color: "currentColor",
        label: "open",
        size: "small"
    })));
    return /*#__PURE__*/ $5FkrB.createElement("div", (0, $e7be1629a1f1b709$export$2e2bcd8739ae039)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        className: (0, $lqU89.default)([
            $d16ec2087ba58c24$var$dropdownStyles.default,
            isDisabled && $d16ec2087ba58c24$var$dropdownStyles.disabled,
            isCompact && $d16ec2087ba58c24$var$dropdownStyles.compact,
            (0, $b2896f4f52b4ee15$export$a274e22fb40f762e)(className, xcss, '-indicatorContainer')
        ])
    }, restInnerProps, {
        "aria-hidden": isVoiceControlAccessible ? undefined : ariaHidden
    }), isVoiceControlAccessible ? voiceControlAccessibleIndicator : children !== null && children !== void 0 ? children : /*#__PURE__*/ $5FkrB.createElement((0, $87169be5fba8f640$export$fbae5b5ffd8af05e), {
        as: "span",
        xcss: $d16ec2087ba58c24$var$dropdownWrapperStyles.root
    }, /*#__PURE__*/ $5FkrB.createElement((0, (/*@__PURE__*/$parcel$interopDefault($1bca3bdfac6f5ca0$exports))), {
        color: "currentColor",
        label: "open",
        size: "small"
    })));
};


/* loading-indicator.tsx generated by @compiled/babel-plugin v2.0.0 */ 



var $5FkrB = parcelRequire("5FkrB");

var $lqU89 = parcelRequire("lqU89");

/* spinner.tsx generated by @compiled/babel-plugin v0.39.1 */ /**
 * This length includes the underscore,
 * e.g. `"_1s4A"` would be a valid atomic group hash.
 */ const $b8d6981bcd6f2d82$var$ATOMIC_GROUP_LENGTH = 5;
function $b8d6981bcd6f2d82$export$2e2bcd8739ae039(classNames) {
    // Shortcut: nothing to do
    if (!classNames.length) return;
    // Shortcut: don't need to do anything if we only have a single classname
    if (classNames.length === 1 && classNames[0] && // checking to see if `classNames[0]` is a string that contains other classnames
    !classNames[0].includes(' ')) return classNames[0];
    // Using an object rather than a `Map` as it performed better in our benchmarks.
    // Would be happy to move to `Map` if it proved to be better under real conditions.
    const map = {};
    // Note: using loops to minimize iterations over the collection
    for (const value of classNames){
        // Exclude all falsy values, which leaves us with populated strings
        if (!value) continue;
        // a `value` can contain multiple classnames
        const list = value.split(' ');
        for (const className of list){
            /**
             * For atomic style classnames: the `key` is the `group`
             *
             * - Later atomic classnames with the same `group` will override earlier ones
             *   (which is what we want).
             * - Assumes atomic classnames are the only things that start with `_`
             * - Could use a regex to ensure that atomic classnames are structured how we expect,
             *   but did not add that for now as it did slow things down a bit.
             *
             * For other classnames: the `key` is the whole classname
             * - Okay to remove duplicates as doing so does not impact specificity
             *
             * */ const key = className.startsWith('_') ? className.slice(0, $b8d6981bcd6f2d82$var$ATOMIC_GROUP_LENGTH) : className;
            map[key] = className;
        }
    }
    /**
     * We are converting the `map` into a string.
     *
     * The simple way to do this would be `Object.values(map).join(' ')`.
     * However, the approach below performs 10%-20% better in benchmarks.
     *
     * For `ax()` it feels right to squeeze as much runtime performance out as we can.
     */ let result = '';
    for(const key in map)result += map[key] + ' ';
    // If we have an empty string, then our `map` was empty.
    if (!result) return;
    // remove last " " from the result (we added " " at the end of every value)
    return result.trimEnd();
}



var $5FkrB = parcelRequire("5FkrB");

var $51f76896335c5af0$export$4e9f1640bbe7a1a8 = {
    xsmall: 12,
    small: 16,
    medium: 24,
    large: 48,
    xlarge: 96
};


/**
 * Returns the appropriate circle stroke color.
 */ function $e94e45e4fb247135$var$getStrokeColor(appearance) {
    return appearance === 'inherit' ? "var(--ds-icon-subtle, #505258)" : "var(--ds-icon-inverse, #FFFFFF)";
}
var $e94e45e4fb247135$var$rotate = null;
/**
 * There are three parts to the load in animation:
 * 1. Accelerated spin
 * 2. Stretch the spinner line
 */ var $e94e45e4fb247135$var$loadIn = null;
var $e94e45e4fb247135$var$styles = {
    rotateStyles: "_j7hqsf8s _5sag12kz _tip812c5 _1pgl2qsq _8hrz1h6o",
    loadInStyles: "_j7hq1ky6 _5sag9cwz _1pgl1ytf _1o51q7pw",
    wrapperStyles: "_1e0c116y _s7n4nkob",
    circleStyles: "_lswuglyw _7ljx1dhp _1snbbs82 _jcxd7g3v _1tjm1onz"
};
/**
 * `useLayoutEffect` is being used in SSR safe form. On the server, this work doesn’t need to run.
 * `useEffect` is used in-place, because `useEffect` is not run on the server and it matches types
 * which makes things simpler than doing an `isServer` check or a `null` check.
 *
 * @see https://hello.atlassian.net/wiki/spaces/DST/pages/2081696628/DSTDACI-010+-+Interaction+Tracing+hooks+in+DS+components
 */ var $e94e45e4fb247135$var$useLayoutEffect = typeof window === 'undefined' ? (0, $5FkrB.useEffect) : (0, $5FkrB.useLayoutEffect);
/**
 * __Spinner__
 *
 * A spinner is an animated spinning icon that lets users know content is being loaded.
 *
 * - [Examples](https://atlassian.design/components/spinner/examples)
 * - [Code](https://atlassian.design/components/spinner/code)
 * - [Usage](https://atlassian.design/components/spinner/usage)
 */ var $e94e45e4fb247135$var$Spinner = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).forwardRef(function Spinner(_ref, ref) {
    var _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'inherit' : _ref$appearance, _ref$delay = _ref.delay, delay = _ref$delay === void 0 ? 0 : _ref$delay, interactionName = _ref.interactionName, label = _ref.label, _ref$size = _ref.size, providedSize = _ref$size === void 0 ? 'medium' : _ref$size, testId = _ref.testId;
    var size = typeof providedSize === 'number' ? providedSize : (0, $51f76896335c5af0$export$4e9f1640bbe7a1a8)[providedSize];
    var animationDelay = "".concat(delay, "ms");
    var stroke = $e94e45e4fb247135$var$getStrokeColor(appearance);
    var context = (0, $5FkrB.useContext)((0, $a81fd7e45a8c2ef5$export$2e2bcd8739ae039));
    $e94e45e4fb247135$var$useLayoutEffect(function() {
        if (context != null) return context.hold(interactionName);
    }, [
        context,
        interactionName
    ]);
    /**
   * The Spinner animation uses a combination of two
   * css animations on two separate elements.
   */ return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("span", {
        "data-testid": testId ? "".concat(testId, "-wrapper") : 'spinner-wrapper',
        style: {
            animationDelay: animationDelay,
            width: size,
            height: size
        },
        className: (0, $b8d6981bcd6f2d82$export$2e2bcd8739ae039)([
            $e94e45e4fb247135$var$styles.wrapperStyles,
            $e94e45e4fb247135$var$styles.rotateStyles
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("svg", {
        height: size,
        width: size,
        viewBox: "0 0 16 16",
        xmlns: "http://www.w3.org/2000/svg",
        "data-testid": testId,
        ref: ref,
        "aria-label": label || undefined,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            animationDelay: animationDelay
        },
        role: label ? 'img' : 'none',
        className: (0, $b8d6981bcd6f2d82$export$2e2bcd8739ae039)([
            $e94e45e4fb247135$var$styles.loadInStyles
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("circle", {
        cx: "8",
        cy: "8",
        r: "7",
        style: {
            stroke: stroke
        },
        className: (0, $b8d6981bcd6f2d82$export$2e2bcd8739ae039)([
            $e94e45e4fb247135$var$styles.circleStyles
        ])
    })));
}));
var $e94e45e4fb247135$export$2e2bcd8739ae039 = $e94e45e4fb247135$var$Spinner;



var $02d2dc1655b5d537$var$_excluded = [
    "innerProps",
    "isRtl",
    "size",
    "isCompact",
    "xcss"
];
function $02d2dc1655b5d537$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $02d2dc1655b5d537$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $02d2dc1655b5d537$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $90d31be1abcfa6da$export$2e2bcd8739ae039)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $02d2dc1655b5d537$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $02d2dc1655b5d537$var$loadingIndicatorStyles = {
    default: "_1q5112x7 _y4tiu2gc _85i512x7 _bozgu2gc",
    compact: "_1q51idpf _85i5idpf"
};
// eslint-disable-next-line @repo/internal/react/require-jsdoc
var $02d2dc1655b5d537$export$7c20be4c1d342248 = function LoadingIndicator(_ref) {
    var innerProps = _ref.innerProps, isRtl = _ref.isRtl, _ref$size = _ref.size, size = _ref$size === void 0 ? 4 : _ref$size, isCompact = _ref.isCompact, xcss = _ref.xcss, restProps = (0, $9b3d50432d7c2d71$export$2e2bcd8739ae039)(_ref, $02d2dc1655b5d537$var$_excluded);
    var _getStyleProps = (0, $26e98d575ca76ea1$export$26417cabd806a658)($02d2dc1655b5d537$var$_objectSpread($02d2dc1655b5d537$var$_objectSpread({}, restProps), {}, {
        innerProps: innerProps,
        isRtl: isRtl,
        size: size
    }), 'loadingIndicator', {
        indicator: true,
        'loading-indicator': true
    }), css = _getStyleProps.css, className = _getStyleProps.className;
    return /*#__PURE__*/ $5FkrB.createElement("div", (0, $e7be1629a1f1b709$export$2e2bcd8739ae039)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        className: (0, $lqU89.default)([
            $02d2dc1655b5d537$var$loadingIndicatorStyles.default,
            isCompact && $02d2dc1655b5d537$var$loadingIndicatorStyles.compact,
            (0, $b2896f4f52b4ee15$export$a274e22fb40f762e)(className, xcss, '-loadingIndicator')
        ])
    }, innerProps), /*#__PURE__*/ $5FkrB.createElement((0, $e94e45e4fb247135$export$2e2bcd8739ae039), {
        size: "small"
    }));
};


/* input.tsx generated by @compiled/babel-plugin v2.0.0 */ 


var $5FkrB = parcelRequire("5FkrB");

var $lqU89 = parcelRequire("lqU89");




var $462391cdd34a9afc$var$_excluded = [
    "innerRef",
    "isDisabled",
    "isHidden",
    "inputClassName",
    "testId"
];
var $462391cdd34a9afc$var$inputStylesOld = {
    root: "_16jlkb7n _1o9zkb7n _i0dl1wug _nd5l1sux _1mouv77o _195gv77o _1rjcv77o _1e0c1n7u _yv0e12qd _syazi7uo _j8d6idpf _1av2idpf _1doyidpf _pfztidpf _uoe3idpf _1recidpf _70xridpf _1k96idpf _eq43idpf _1h9u1kw7 _ckog1yjy _1x651r31 _1nn4glyw _1rzeidpf _1yd8yh40 _aetr11ps _uy7x15vq _1qjlqvpr",
    disabled: "_3um015vq",
    labellingFFStyles: "_11c8wadc _1mouze3t _195gze3t _1rjcze3t"
};
var $462391cdd34a9afc$var$inputStyles = {
    root: "_16jlkb7n _1o9zkb7n _i0dl1wug _nd5l1sux _1mouv77o _195gv77o _1rjcv77o _kqswh2mm _1e0c1txw _yv0e12qd _syazi7uo _j8d6idpf _1av2idpf _1doyidpf _pfztidpf _uoe3idpf _1recidpf _70xridpf _1k96idpf _eq43idpf _1h9u1kw7 _ckog1yjy _1x651r31 _1nn4glyw _1rzeidpf _1yd8yh40 _aetr11ps _uy7x15vq _1qjlqvpr",
    disabled: "_3um015vq",
    labellingFFStyles: "_11c8wadc _1mouze3t _195gze3t _1rjcze3t"
};
var $462391cdd34a9afc$var$nativeInputStylesOld = null;
var $462391cdd34a9afc$var$nativeInputStyles = null;
var $462391cdd34a9afc$var$hidden = null;
var $462391cdd34a9afc$var$Input = function Input(props) {
    var builtinCX = props.cx, value = props.value, xcss = props.xcss, isMulti = props.isMulti;
    var _cleanCommonProps = (0, $79f379f03d71888a$export$8e9fd4287627890c)(props), innerRef = _cleanCommonProps.innerRef, isDisabled = _cleanCommonProps.isDisabled, isHidden = _cleanCommonProps.isHidden, inputClassName = _cleanCommonProps.inputClassName, testId = _cleanCommonProps.testId, innerProps = (0, $9b3d50432d7c2d71$export$2e2bcd8739ae039)(_cleanCommonProps, $462391cdd34a9afc$var$_excluded);
    var dataId = testId ? "".concat(testId, "-select--input") : null;
    var _getStyleProps = (0, $26e98d575ca76ea1$export$26417cabd806a658)(props, 'input', {
        'input-container': true
    }), css = _getStyleProps.css, className = _getStyleProps.className;
    var ffTagUplifts = (0, $13a186c4459b8c2a$export$b40ec24ac8275656)('platform-dst-lozenge-tag-badge-visual-uplifts');
    if ((0, $13a186c4459b8c2a$export$b40ec24ac8275656)('platform_fix_input_component_styling')) return /*#__PURE__*/ $5FkrB.createElement("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        className: (0, $lqU89.default)([
            $462391cdd34a9afc$var$inputStyles.root,
            isMulti && ffTagUplifts && $462391cdd34a9afc$var$inputStyles.labellingFFStyles,
            isDisabled && $462391cdd34a9afc$var$inputStyles.disabled,
            (0, $b2896f4f52b4ee15$export$a274e22fb40f762e)(className, xcss, '-Input')
        ]),
        "data-value": value || '',
        "data-testid": dataId && "".concat(dataId, "-container")
    }, /*#__PURE__*/ $5FkrB.createElement("input", (0, $e7be1629a1f1b709$export$2e2bcd8739ae039)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $lqU89.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1r04idpf _11q7idpf _19itidpf _11c81kw7 _nd5l1yjy _12ji1r31 _1qu2glyw _12y3idpf _1bsb1osq _1ul9yh40 _kqswstnw _syaz1kw7 _tzy4kb7n",
            isHidden && "_tzy4idpf",
            builtinCX({
                input: true
            }, inputClassName, '-input')
        ]),
        ref: innerRef,
        disabled: isDisabled,
        "data-testid": dataId
    }, innerProps)));
    return /*#__PURE__*/ $5FkrB.createElement("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        className: (0, $lqU89.default)([
            $462391cdd34a9afc$var$inputStylesOld.root,
            isMulti && ffTagUplifts && $462391cdd34a9afc$var$inputStylesOld.labellingFFStyles,
            isDisabled && $462391cdd34a9afc$var$inputStylesOld.disabled,
            (0, $b2896f4f52b4ee15$export$a274e22fb40f762e)(className, xcss, '-Input')
        ]),
        "data-value": value || '',
        "data-testid": dataId && "".concat(dataId, "-container")
    }, /*#__PURE__*/ $5FkrB.createElement("input", (0, $e7be1629a1f1b709$export$2e2bcd8739ae039)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $lqU89.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _11q7idpf _19itidpf _11c81kw7 _nd5l1yjy _12ji1r31 _1qu2glyw _12y3idpf _1bsb1osq _1ul9yh40 _syaz1kw7 _tzy4kb7n",
            isHidden && "_tzy4idpf",
            builtinCX({
                input: true
            }, inputClassName, '-input')
        ]),
        ref: innerRef,
        disabled: isDisabled,
        "data-testid": dataId
    }, innerProps)));
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$462391cdd34a9afc$export$2e2bcd8739ae039 = $462391cdd34a9afc$var$Input;


/* menu.tsx generated by @compiled/babel-plugin v2.0.0 */ 

var $5FkrB = parcelRequire("5FkrB");

var $lqU89 = parcelRequire("lqU89");



var $7942bdc462d2e339$var$menuStyles = {
    root: "_2rko12b0 _kqswstnw _1bsb1osq _1pbykb7n _6rthu2gc _1pfhu2gc _bfhk1bhr _16qs130s",
    rootT26Shape: "_2rko1mok",
    bottom: "_152t1osq",
    top: "_u7co1osq"
};
var $7942bdc462d2e339$var$Menu = function Menu(props) {
    var children = props.children, innerRef = props.innerRef, innerProps = props.innerProps, _props$placement = props.placement, placement = _props$placement === void 0 ? 'bottom' : _props$placement, xcss = props.xcss;
    var _getStyleProps = (0, $26e98d575ca76ea1$export$26417cabd806a658)(props, 'menu', {
        menu: true
    }), css = _getStyleProps.css, className = _getStyleProps.className;
    return /*#__PURE__*/ $5FkrB.createElement("div", (0, $e7be1629a1f1b709$export$2e2bcd8739ae039)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $lqU89.default)([
            $7942bdc462d2e339$var$menuStyles.root,
            $7942bdc462d2e339$var$menuStyles[placement],
            (0, $13a186c4459b8c2a$export$b40ec24ac8275656)('platform-dst-shape-theme-default') && $7942bdc462d2e339$var$menuStyles.rootT26Shape,
            (0, $b2896f4f52b4ee15$export$a274e22fb40f762e)(xcss, className, '-menu')
        ]),
        style: css,
        ref: innerRef
    }, innerProps), children);
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$7942bdc462d2e339$export$2e2bcd8739ae039 = $7942bdc462d2e339$var$Menu;


/* menu-list.tsx generated by @compiled/babel-plugin v2.0.0 */ 


var $5FkrB = parcelRequire("5FkrB");

var $lqU89 = parcelRequire("lqU89");


function $02bb287a22d86cb8$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $02bb287a22d86cb8$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $02bb287a22d86cb8$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $90d31be1abcfa6da$export$2e2bcd8739ae039)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $02bb287a22d86cb8$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $02bb287a22d86cb8$var$menuListStyles = null;
var $02bb287a22d86cb8$export$d4c4e98c5044dc8 = function MenuList(props) {
    var children = props.children, innerProps = props.innerProps, innerRef = props.innerRef, isMulti = props.isMulti, maxHeight = props.maxHeight, xcss = props.xcss;
    var _getStyleProps = (0, $26e98d575ca76ea1$export$26417cabd806a658)(props, 'menuList', {
        'menu-list': true,
        'menu-list--is-multi': isMulti
    }), css = _getStyleProps.css, className = _getStyleProps.className;
    return /*#__PURE__*/ $5FkrB.createElement("div", (0, $e7be1629a1f1b709$export$2e2bcd8739ae039)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $lqU89.default)([
            "_kqswh2mm _18m91wug _85i5u2gc _1q51u2gc _8am5i4x0",
            (0, $b2896f4f52b4ee15$export$a274e22fb40f762e)(className, xcss, '-MenuList')
        ]),
        style: $02bb287a22d86cb8$var$_objectSpread($02bb287a22d86cb8$var$_objectSpread({}, css), {}, {
            maxHeight: maxHeight
        }),
        ref: innerRef
    }, innerProps, {
        tabIndex: -1
    }), children);
};


/* menu-loading-message.tsx generated by @compiled/babel-plugin v2.0.0 */ 



var $5FkrB = parcelRequire("5FkrB");

var $lqU89 = parcelRequire("lqU89");

/* text.tsx generated by @compiled/babel-plugin v0.40.0 */ 
var $5FkrB = parcelRequire("5FkrB");

var $lqU89 = parcelRequire("lqU89");


var $5FkrB = parcelRequire("5FkrB");
var $8cfda4210014d2d2$export$19538d0bfc69c6e0 = /*#__PURE__*/ (0, $5FkrB.createContext)(false);


var $1c79155885acd653$export$ae933c6cbe5643ad = (0, $8cfda4210014d2d2$export$19538d0bfc69c6e0).Provider;



var $5FkrB = parcelRequire("5FkrB");

var $5FkrB = parcelRequire("5FkrB");
var $409ea49c369c336c$export$1ca2a26fecb070ae = /*#__PURE__*/ (0, $5FkrB.createContext)('elevation.surface');


var $4236f9f0ba60afa5$export$1aeb4f6b93c4540d = function useSurface() {
    return (0, $5FkrB.useContext)((0, $409ea49c369c336c$export$1ca2a26fecb070ae));
};
(0, $409ea49c369c336c$export$1ca2a26fecb070ae).displayName = 'SurfaceProvider';



var $5FkrB = parcelRequire("5FkrB");

var $245f8eceeb947f97$export$9322276ec105d055 = function useHasTextAncestor() {
    return (0, $5FkrB.useContext)((0, $8cfda4210014d2d2$export$19538d0bfc69c6e0));
};


var $49ba8d69868aa72a$var$asAllowlist = [
    'span',
    'p',
    'strong',
    'em'
];
/**
 * Custom hook designed to abstract the parsing of the color props and make it clearer in the future how color is reconciled between themes and tokens.
 */ var $49ba8d69868aa72a$var$useColor = function useColor(colorProp, hasTextAncestor) {
    var surface = (0, $4236f9f0ba60afa5$export$1aeb4f6b93c4540d)();
    if (colorProp === 'inherit') return undefined;
    if (colorProp) return colorProp;
    if (hasTextAncestor) return undefined;
    if ($49ba8d69868aa72a$var$inverseColorMap.hasOwnProperty(surface)) return $49ba8d69868aa72a$var$inverseColorMap[surface];
    return 'color.text';
};
var $49ba8d69868aa72a$var$styles = {
    root: "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _1i4qfg65",
    'as.strong': "_k48pwu06",
    'as.em': "_zg8l1m30",
    'textAlign.center': "_y3gn1h6o",
    'textAlign.end': "_y3gnh9n0",
    'textAlign.start': "_y3gnv2br",
    truncation: "_1reo15vq _18m915vq _1e0ccj1k _sudp1e54",
    breakAll: "_1nmz9jpi"
};
var $49ba8d69868aa72a$var$fontSizeMap = {
    medium: "_11c8fhey",
    large: "_11c81d4k",
    small: "_11c8wadc"
};
var $49ba8d69868aa72a$var$fontWeightMap = {
    bold: "_k48pwu06",
    medium: "_k48p1wq8",
    regular: "_k48pi7a9",
    semibold: "_k48p1pd9"
};
var $49ba8d69868aa72a$var$textColorMap = {
    'color.text': "_syazi7uo",
    'color.text.accent.lime': "_syaz1tco",
    'color.text.accent.lime.bolder': "_syaz1ik3",
    'color.text.accent.red': "_syaz9lu1",
    'color.text.accent.red.bolder': "_syazhwvp",
    'color.text.accent.orange': "_syazp1lv",
    'color.text.accent.orange.bolder': "_syaz7i1p",
    'color.text.accent.yellow': "_syazfb2s",
    'color.text.accent.yellow.bolder': "_syazekll",
    'color.text.accent.green': "_syazh55r",
    'color.text.accent.green.bolder': "_syaz1y78",
    'color.text.accent.teal': "_syaz17qg",
    'color.text.accent.teal.bolder': "_syaz12v7",
    'color.text.accent.blue': "_syaz16jw",
    'color.text.accent.blue.bolder': "_syaz1kyx",
    'color.text.accent.purple': "_syazqmo9",
    'color.text.accent.purple.bolder': "_syaz1mn1",
    'color.text.accent.magenta': "_syaz1s8m",
    'color.text.accent.magenta.bolder': "_syaz1qur",
    'color.text.accent.gray': "_syaz1sqi",
    'color.text.accent.gray.bolder': "_syaz1tmo",
    'color.text.disabled': "_syaz1gmx",
    'color.text.inverse': "_syaz15cr",
    'color.text.selected': "_syaz6x5g",
    'color.text.brand': "_syaz1oa5",
    'color.text.danger': "_syaz1tmw",
    'color.text.warning': "_syaz1xn9",
    'color.text.warning.inverse': "_syaz1yd3",
    'color.text.success': "_syazgsak",
    'color.text.discovery': "_syazdv2p",
    'color.text.information': "_syazu3tg",
    'color.text.subtlest': "_syaz1rpy",
    'color.text.subtle': "_syazazsu",
    'color.link': "_syaz13af",
    'color.link.pressed': "_syaz12zz",
    'color.link.visited': "_syaz1ra0",
    'color.link.visited.pressed': "_syaz17z1"
};
var $49ba8d69868aa72a$var$inverseColorMap = {
    'color.background.neutral.bold': 'color.text.inverse',
    'color.background.neutral.bold.hovered': 'color.text.inverse',
    'color.background.neutral.bold.pressed': 'color.text.inverse',
    'color.background.selected.bold': 'color.text.inverse',
    'color.background.selected.bold.hovered': 'color.text.inverse',
    'color.background.selected.bold.pressed': 'color.text.inverse',
    'color.background.brand.bold': 'color.text.inverse',
    'color.background.brand.bold.hovered': 'color.text.inverse',
    'color.background.brand.bold.pressed': 'color.text.inverse',
    'color.background.brand.boldest': 'color.text.inverse',
    'color.background.brand.boldest.hovered': 'color.text.inverse',
    'color.background.brand.boldest.pressed': 'color.text.inverse',
    'color.background.danger.bold': 'color.text.inverse',
    'color.background.danger.bold.hovered': 'color.text.inverse',
    'color.background.danger.bold.pressed': 'color.text.inverse',
    'color.background.warning.bold': 'color.text.warning.inverse',
    'color.background.warning.bold.hovered': 'color.text.warning.inverse',
    'color.background.warning.bold.pressed': 'color.text.warning.inverse',
    'color.background.success.bold': 'color.text.inverse',
    'color.background.success.bold.hovered': 'color.text.inverse',
    'color.background.success.bold.pressed': 'color.text.inverse',
    'color.background.discovery.bold': 'color.text.inverse',
    'color.background.discovery.bold.hovered': 'color.text.inverse',
    'color.background.discovery.bold.pressed': 'color.text.inverse',
    'color.background.information.bold': 'color.text.inverse',
    'color.background.information.bold.hovered': 'color.text.inverse',
    'color.background.information.bold.pressed': 'color.text.inverse'
};
var $49ba8d69868aa72a$export$5f1af8db9871e1d6 = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? 'span' : _ref$as, colorProp = _ref.color, align = _ref.align, testId = _ref.testId, id = _ref.id, size = _ref.size, weight = _ref.weight, maxLines = _ref.maxLines, xcss = _ref.xcss, children = _ref.children;
    (0, $fff3f31fc3bd4f88$export$2e2bcd8739ae039)($49ba8d69868aa72a$var$asAllowlist.includes(Component), "@atlaskit/primitives: Text received an invalid \"as\" value of \"".concat(Component, "\""));
    var hasTextAncestor = (0, $245f8eceeb947f97$export$9322276ec105d055)();
    var color = $49ba8d69868aa72a$var$useColor(colorProp, hasTextAncestor);
    if (!size && !hasTextAncestor) size = 'medium';
    var component = /*#__PURE__*/ $5FkrB.createElement(Component, {
        id: id,
        className: (0, $lqU89.default)([
            $49ba8d69868aa72a$var$styles.root,
            size && $49ba8d69868aa72a$var$fontSizeMap[size],
            color && $49ba8d69868aa72a$var$textColorMap[color],
            maxLines && $49ba8d69868aa72a$var$styles.truncation,
            maxLines === 1 && $49ba8d69868aa72a$var$styles.breakAll,
            align && $49ba8d69868aa72a$var$styles["textAlign.".concat(align)],
            weight && $49ba8d69868aa72a$var$fontWeightMap[weight],
            Component === 'em' && $49ba8d69868aa72a$var$styles['as.em'],
            Component === 'strong' && $49ba8d69868aa72a$var$styles['as.strong'],
            xcss
        ]),
        style: {
            WebkitLineClamp: maxLines
        },
        "data-testid": testId,
        ref: ref
    }, children);
    if (hasTextAncestor) // no need to re-apply context if the text is already wrapped
    return component;
    return /*#__PURE__*/ $5FkrB.createElement((0, $1c79155885acd653$export$ae933c6cbe5643ad), {
        value: true
    }, component);
});



var $4afd2f3626226126$var$_excluded = [
    "children",
    "innerProps",
    "xcss"
];
function $4afd2f3626226126$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $4afd2f3626226126$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $4afd2f3626226126$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $90d31be1abcfa6da$export$2e2bcd8739ae039)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $4afd2f3626226126$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $4afd2f3626226126$var$noticeStyles = null;
// eslint-disable-next-line @repo/internal/react/require-jsdoc
var $4afd2f3626226126$export$e928a71d039d3102 = function LoadingMessage(_ref) {
    var _ref$children = _ref.children, children = _ref$children === void 0 ? 'Loading...' : _ref$children, innerProps = _ref.innerProps, xcss = _ref.xcss, restProps = (0, $9b3d50432d7c2d71$export$2e2bcd8739ae039)(_ref, $4afd2f3626226126$var$_excluded);
    var _getStyleProps = (0, $26e98d575ca76ea1$export$26417cabd806a658)($4afd2f3626226126$var$_objectSpread($4afd2f3626226126$var$_objectSpread({}, restProps), {}, {
        children: children,
        innerProps: innerProps
    }), 'loadingMessage', {
        'menu-notice': true,
        'menu-notice--loading': true
    }), css = _getStyleProps.css, className = _getStyleProps.className;
    return /*#__PURE__*/ $5FkrB.createElement("div", (0, $e7be1629a1f1b709$export$2e2bcd8739ae039)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $lqU89.default)([
            "_85i5u2gc _1q51u2gc _y4tiutpp _bozgutpp _y3gn1h6o",
            (0, $b2896f4f52b4ee15$export$a274e22fb40f762e)(className, xcss, '-LoadingMessage')
        ]),
        style: css
    }, innerProps, {
        // eslint-disable-next-line @atlassian/a11y/role-has-required-aria-props
        role: "option"
    }), /*#__PURE__*/ $5FkrB.createElement((0, $49ba8d69868aa72a$export$5f1af8db9871e1d6), {
        color: "color.text.subtle"
    }, children));
};


/* menu-no-options-message.tsx generated by @compiled/babel-plugin v2.0.0 */ 



var $5FkrB = parcelRequire("5FkrB");

var $lqU89 = parcelRequire("lqU89");



var $0a1c7e0a907c8dc7$var$_excluded = [
    "children",
    "innerProps",
    "xcss"
];
function $0a1c7e0a907c8dc7$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $0a1c7e0a907c8dc7$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $0a1c7e0a907c8dc7$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $90d31be1abcfa6da$export$2e2bcd8739ae039)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $0a1c7e0a907c8dc7$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $0a1c7e0a907c8dc7$var$noticeStyles = null;
// eslint-disable-next-line @repo/internal/react/require-jsdoc
var $0a1c7e0a907c8dc7$export$d58b72b7d3c4072c = function NoOptionsMessage(_ref) {
    var _ref$children = _ref.children, children = _ref$children === void 0 ? 'No options' : _ref$children, innerProps = _ref.innerProps, xcss = _ref.xcss, restProps = (0, $9b3d50432d7c2d71$export$2e2bcd8739ae039)(_ref, $0a1c7e0a907c8dc7$var$_excluded);
    var _getStyleProps = (0, $26e98d575ca76ea1$export$26417cabd806a658)($0a1c7e0a907c8dc7$var$_objectSpread($0a1c7e0a907c8dc7$var$_objectSpread({}, restProps), {}, {
        children: children,
        innerProps: innerProps
    }), 'noOptionsMessage', {
        'menu-notice': true,
        'menu-notice--no-options': true
    }), css = _getStyleProps.css, className = _getStyleProps.className;
    return /*#__PURE__*/ $5FkrB.createElement("div", (0, $e7be1629a1f1b709$export$2e2bcd8739ae039)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $lqU89.default)([
            "_85i5u2gc _1q51u2gc _y4tiutpp _bozgutpp _y3gn1h6o",
            (0, $b2896f4f52b4ee15$export$a274e22fb40f762e)(className, xcss, '-NoOptionsMessage')
        ]),
        style: css,
        role: "option"
    }, innerProps), /*#__PURE__*/ $5FkrB.createElement((0, $49ba8d69868aa72a$export$5f1af8db9871e1d6), {
        color: "color.text.subtle"
    }, children));
};


/* menu-portal.tsx generated by @compiled/babel-plugin v2.0.0 */ 



var $5FkrB = parcelRequire("5FkrB");

var $lqU89 = parcelRequire("lqU89");

/**
 * Custom positioning reference element.
 * @see https://floating-ui.com/docs/virtual-elements
 */ const $57450959939ce219$export$832b6fa47fa053d2 = [
    'top',
    'right',
    'bottom',
    'left'
];
const $57450959939ce219$export$27b07d8a310ed8b5 = [
    'start',
    'end'
];
const $57450959939ce219$export$803cd8101b6c182b = /*#__PURE__*/ $57450959939ce219$export$832b6fa47fa053d2.reduce((acc, side)=>acc.concat(side, side + "-" + $57450959939ce219$export$27b07d8a310ed8b5[0], side + "-" + $57450959939ce219$export$27b07d8a310ed8b5[1]), []);
const $57450959939ce219$export$96ec731ed4dcb222 = Math.min;
const $57450959939ce219$export$8960430cfd85939f = Math.max;
const $57450959939ce219$export$2077e0241d6afd3c = Math.round;
const $57450959939ce219$export$a3fe094919f356fd = Math.floor;
const $57450959939ce219$export$a397704b5e280835 = (v)=>({
        x: v,
        y: v
    });
const $57450959939ce219$var$oppositeSideMap = {
    left: 'right',
    right: 'left',
    bottom: 'top',
    top: 'bottom'
};
const $57450959939ce219$var$oppositeAlignmentMap = {
    start: 'end',
    end: 'start'
};
function $57450959939ce219$export$7d15b64cf5a3a4c4(start, value, end) {
    return $57450959939ce219$export$8960430cfd85939f(start, $57450959939ce219$export$96ec731ed4dcb222(value, end));
}
function $57450959939ce219$export$fef61f332f2c0afc(value, param) {
    return typeof value === 'function' ? value(param) : value;
}
function $57450959939ce219$export$3c915306cb7fc97a(placement) {
    return placement.split('-')[0];
}
function $57450959939ce219$export$f0989780f32bfcda(placement) {
    return placement.split('-')[1];
}
function $57450959939ce219$export$8a000a963141ac32(axis) {
    return axis === 'x' ? 'y' : 'x';
}
function $57450959939ce219$export$320bd9d53520c68a(axis) {
    return axis === 'y' ? 'height' : 'width';
}
function $57450959939ce219$export$f28e8f882010718a(placement) {
    return [
        'top',
        'bottom'
    ].includes($57450959939ce219$export$3c915306cb7fc97a(placement)) ? 'y' : 'x';
}
function $57450959939ce219$export$2b57e0052a6d6d4c(placement) {
    return $57450959939ce219$export$8a000a963141ac32($57450959939ce219$export$f28e8f882010718a(placement));
}
function $57450959939ce219$export$be42861551f17911(placement, rects, rtl) {
    if (rtl === void 0) rtl = false;
    const alignment = $57450959939ce219$export$f0989780f32bfcda(placement);
    const alignmentAxis = $57450959939ce219$export$2b57e0052a6d6d4c(placement);
    const length = $57450959939ce219$export$320bd9d53520c68a(alignmentAxis);
    let mainAlignmentSide = alignmentAxis === 'x' ? alignment === (rtl ? 'end' : 'start') ? 'right' : 'left' : alignment === 'start' ? 'bottom' : 'top';
    if (rects.reference[length] > rects.floating[length]) mainAlignmentSide = $57450959939ce219$export$9c5e28bad23365fa(mainAlignmentSide);
    return [
        mainAlignmentSide,
        $57450959939ce219$export$9c5e28bad23365fa(mainAlignmentSide)
    ];
}
function $57450959939ce219$export$496432a3699e50b1(placement) {
    const oppositePlacement = $57450959939ce219$export$9c5e28bad23365fa(placement);
    return [
        $57450959939ce219$export$2b182c584985588b(placement),
        oppositePlacement,
        $57450959939ce219$export$2b182c584985588b(oppositePlacement)
    ];
}
function $57450959939ce219$export$2b182c584985588b(placement) {
    return placement.replace(/start|end/g, (alignment)=>$57450959939ce219$var$oppositeAlignmentMap[alignment]);
}
function $57450959939ce219$var$getSideList(side, isStart, rtl) {
    const lr = [
        'left',
        'right'
    ];
    const rl = [
        'right',
        'left'
    ];
    const tb = [
        'top',
        'bottom'
    ];
    const bt = [
        'bottom',
        'top'
    ];
    switch(side){
        case 'top':
        case 'bottom':
            if (rtl) return isStart ? rl : lr;
            return isStart ? lr : rl;
        case 'left':
        case 'right':
            return isStart ? tb : bt;
        default:
            return [];
    }
}
function $57450959939ce219$export$a9b6fb18fd92c3ec(placement, flipAlignment, direction, rtl) {
    const alignment = $57450959939ce219$export$f0989780f32bfcda(placement);
    let list = $57450959939ce219$var$getSideList($57450959939ce219$export$3c915306cb7fc97a(placement), direction === 'start', rtl);
    if (alignment) {
        list = list.map((side)=>side + "-" + alignment);
        if (flipAlignment) list = list.concat(list.map($57450959939ce219$export$2b182c584985588b));
    }
    return list;
}
function $57450959939ce219$export$9c5e28bad23365fa(placement) {
    return placement.replace(/left|right|bottom|top/g, (side)=>$57450959939ce219$var$oppositeSideMap[side]);
}
function $57450959939ce219$export$1c66dbf1a9e34223(padding) {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        ...padding
    };
}
function $57450959939ce219$export$598c291c29bc2e71(padding) {
    return typeof padding !== 'number' ? $57450959939ce219$export$1c66dbf1a9e34223(padding) : {
        top: padding,
        right: padding,
        bottom: padding,
        left: padding
    };
}
function $57450959939ce219$export$ee05aea0aeecbad4(rect) {
    const { x: x, y: y, width: width, height: height } = rect;
    return {
        width: width,
        height: height,
        top: y,
        left: x,
        right: x + width,
        bottom: y + height,
        x: x,
        y: y
    };
}


function $bf5b7e7f06fad704$var$computeCoordsFromPlacement(_ref, placement, rtl) {
    let { reference: reference, floating: floating } = _ref;
    const sideAxis = (0, $57450959939ce219$export$f28e8f882010718a)(placement);
    const alignmentAxis = (0, $57450959939ce219$export$2b57e0052a6d6d4c)(placement);
    const alignLength = (0, $57450959939ce219$export$320bd9d53520c68a)(alignmentAxis);
    const side = (0, $57450959939ce219$export$3c915306cb7fc97a)(placement);
    const isVertical = sideAxis === 'y';
    const commonX = reference.x + reference.width / 2 - floating.width / 2;
    const commonY = reference.y + reference.height / 2 - floating.height / 2;
    const commonAlign = reference[alignLength] / 2 - floating[alignLength] / 2;
    let coords;
    switch(side){
        case 'top':
            coords = {
                x: commonX,
                y: reference.y - floating.height
            };
            break;
        case 'bottom':
            coords = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 'right':
            coords = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 'left':
            coords = {
                x: reference.x - floating.width,
                y: commonY
            };
            break;
        default:
            coords = {
                x: reference.x,
                y: reference.y
            };
    }
    switch((0, $57450959939ce219$export$f0989780f32bfcda)(placement)){
        case 'start':
            coords[alignmentAxis] -= commonAlign * (rtl && isVertical ? -1 : 1);
            break;
        case 'end':
            coords[alignmentAxis] += commonAlign * (rtl && isVertical ? -1 : 1);
            break;
    }
    return coords;
}
/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a given reference element.
 *
 * This export does not have any `platform` interface logic. You will need to
 * write one for the platform you are using Floating UI with.
 */ const $bf5b7e7f06fad704$export$48a53dcb22e581d0 = async (reference, floating, config)=>{
    const { placement: placement = 'bottom', strategy: strategy = 'absolute', middleware: middleware = [], platform: platform } = config;
    const validMiddleware = middleware.filter(Boolean);
    const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(floating));
    let rects = await platform.getElementRects({
        reference: reference,
        floating: floating,
        strategy: strategy
    });
    let { x: x, y: y } = $bf5b7e7f06fad704$var$computeCoordsFromPlacement(rects, placement, rtl);
    let statefulPlacement = placement;
    let middlewareData = {};
    let resetCount = 0;
    for(let i = 0; i < validMiddleware.length; i++){
        const { name: name, fn: fn } = validMiddleware[i];
        const { x: nextX, y: nextY, data: data, reset: reset } = await fn({
            x: x,
            y: y,
            initialPlacement: placement,
            placement: statefulPlacement,
            strategy: strategy,
            middlewareData: middlewareData,
            rects: rects,
            platform: platform,
            elements: {
                reference: reference,
                floating: floating
            }
        });
        x = nextX != null ? nextX : x;
        y = nextY != null ? nextY : y;
        middlewareData = {
            ...middlewareData,
            [name]: {
                ...middlewareData[name],
                ...data
            }
        };
        if (reset && resetCount <= 50) {
            resetCount++;
            if (typeof reset === 'object') {
                if (reset.placement) statefulPlacement = reset.placement;
                if (reset.rects) rects = reset.rects === true ? await platform.getElementRects({
                    reference: reference,
                    floating: floating,
                    strategy: strategy
                }) : reset.rects;
                ({ x: x, y: y } = $bf5b7e7f06fad704$var$computeCoordsFromPlacement(rects, statefulPlacement, rtl));
            }
            i = -1;
        }
    }
    return {
        x: x,
        y: y,
        placement: statefulPlacement,
        strategy: strategy,
        middlewareData: middlewareData
    };
};
/**
 * Resolves with an object of overflow side offsets that determine how much the
 * element is overflowing a given clipping boundary on each side.
 * - positive = overflowing the boundary by that number of pixels
 * - negative = how many pixels left before it will overflow
 * - 0 = lies flush with the boundary
 * @see https://floating-ui.com/docs/detectOverflow
 */ async function $bf5b7e7f06fad704$export$37b6bde19b108ecc(state, options) {
    var _await$platform$isEle;
    if (options === void 0) options = {};
    const { x: x, y: y, platform: platform, rects: rects, elements: elements, strategy: strategy } = state;
    const { boundary: boundary = 'clippingAncestors', rootBoundary: rootBoundary = 'viewport', elementContext: elementContext = 'floating', altBoundary: altBoundary = false, padding: padding = 0 } = (0, $57450959939ce219$export$fef61f332f2c0afc)(options, state);
    const paddingObject = (0, $57450959939ce219$export$598c291c29bc2e71)(padding);
    const altContext = elementContext === 'floating' ? 'reference' : 'floating';
    const element = elements[altBoundary ? altContext : elementContext];
    const clippingClientRect = (0, $57450959939ce219$export$ee05aea0aeecbad4)(await platform.getClippingRect({
        element: ((_await$platform$isEle = await (platform.isElement == null ? void 0 : platform.isElement(element))) != null ? _await$platform$isEle : true) ? element : element.contextElement || await (platform.getDocumentElement == null ? void 0 : platform.getDocumentElement(elements.floating)),
        boundary: boundary,
        rootBoundary: rootBoundary,
        strategy: strategy
    }));
    const rect = elementContext === 'floating' ? {
        x: x,
        y: y,
        width: rects.floating.width,
        height: rects.floating.height
    } : rects.reference;
    const offsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(elements.floating));
    const offsetScale = await (platform.isElement == null ? void 0 : platform.isElement(offsetParent)) ? await (platform.getScale == null ? void 0 : platform.getScale(offsetParent)) || {
        x: 1,
        y: 1
    } : {
        x: 1,
        y: 1
    };
    const elementClientRect = (0, $57450959939ce219$export$ee05aea0aeecbad4)(platform.convertOffsetParentRelativeRectToViewportRelativeRect ? await platform.convertOffsetParentRelativeRectToViewportRelativeRect({
        elements: elements,
        rect: rect,
        offsetParent: offsetParent,
        strategy: strategy
    }) : rect);
    return {
        top: (clippingClientRect.top - elementClientRect.top + paddingObject.top) / offsetScale.y,
        bottom: (elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom) / offsetScale.y,
        left: (clippingClientRect.left - elementClientRect.left + paddingObject.left) / offsetScale.x,
        right: (elementClientRect.right - clippingClientRect.right + paddingObject.right) / offsetScale.x
    };
}
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * @see https://floating-ui.com/docs/arrow
 */ const $bf5b7e7f06fad704$export$f2120bbfa5450bd2 = (options)=>({
        name: 'arrow',
        options: options,
        async fn (state) {
            const { x: x, y: y, placement: placement, rects: rects, platform: platform, elements: elements, middlewareData: middlewareData } = state;
            // Since `element` is required, we don't Partial<> the type.
            const { element: element, padding: padding = 0 } = (0, $57450959939ce219$export$fef61f332f2c0afc)(options, state) || {};
            if (element == null) return {};
            const paddingObject = (0, $57450959939ce219$export$598c291c29bc2e71)(padding);
            const coords = {
                x: x,
                y: y
            };
            const axis = (0, $57450959939ce219$export$2b57e0052a6d6d4c)(placement);
            const length = (0, $57450959939ce219$export$320bd9d53520c68a)(axis);
            const arrowDimensions = await platform.getDimensions(element);
            const isYAxis = axis === 'y';
            const minProp = isYAxis ? 'top' : 'left';
            const maxProp = isYAxis ? 'bottom' : 'right';
            const clientProp = isYAxis ? 'clientHeight' : 'clientWidth';
            const endDiff = rects.reference[length] + rects.reference[axis] - coords[axis] - rects.floating[length];
            const startDiff = coords[axis] - rects.reference[axis];
            const arrowOffsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(element));
            let clientSize = arrowOffsetParent ? arrowOffsetParent[clientProp] : 0;
            // DOM platform can return `window` as the `offsetParent`.
            if (!clientSize || !await (platform.isElement == null ? void 0 : platform.isElement(arrowOffsetParent))) clientSize = elements.floating[clientProp] || rects.floating[length];
            const centerToReference = endDiff / 2 - startDiff / 2;
            // If the padding is large enough that it causes the arrow to no longer be
            // centered, modify the padding so that it is centered.
            const largestPossiblePadding = clientSize / 2 - arrowDimensions[length] / 2 - 1;
            const minPadding = (0, $57450959939ce219$export$96ec731ed4dcb222)(paddingObject[minProp], largestPossiblePadding);
            const maxPadding = (0, $57450959939ce219$export$96ec731ed4dcb222)(paddingObject[maxProp], largestPossiblePadding);
            // Make sure the arrow doesn't overflow the floating element if the center
            // point is outside the floating element's bounds.
            const min$1 = minPadding;
            const max = clientSize - arrowDimensions[length] - maxPadding;
            const center = clientSize / 2 - arrowDimensions[length] / 2 + centerToReference;
            const offset = (0, $57450959939ce219$export$7d15b64cf5a3a4c4)(min$1, center, max);
            // If the reference is small enough that the arrow's padding causes it to
            // to point to nothing for an aligned placement, adjust the offset of the
            // floating element itself. To ensure `shift()` continues to take action,
            // a single reset is performed when this is true.
            const shouldAddOffset = !middlewareData.arrow && (0, $57450959939ce219$export$f0989780f32bfcda)(placement) != null && center !== offset && rects.reference[length] / 2 - (center < min$1 ? minPadding : maxPadding) - arrowDimensions[length] / 2 < 0;
            const alignmentOffset = shouldAddOffset ? center < min$1 ? center - min$1 : center - max : 0;
            return {
                [axis]: coords[axis] + alignmentOffset,
                data: {
                    [axis]: offset,
                    centerOffset: center - offset - alignmentOffset,
                    ...shouldAddOffset && {
                        alignmentOffset: alignmentOffset
                    }
                },
                reset: shouldAddOffset
            };
        }
    });
function $bf5b7e7f06fad704$var$getPlacementList(alignment, autoAlignment, allowedPlacements) {
    const allowedPlacementsSortedByAlignment = alignment ? [
        ...allowedPlacements.filter((placement)=>(0, $57450959939ce219$export$f0989780f32bfcda)(placement) === alignment),
        ...allowedPlacements.filter((placement)=>(0, $57450959939ce219$export$f0989780f32bfcda)(placement) !== alignment)
    ] : allowedPlacements.filter((placement)=>(0, $57450959939ce219$export$3c915306cb7fc97a)(placement) === placement);
    return allowedPlacementsSortedByAlignment.filter((placement)=>{
        if (alignment) return (0, $57450959939ce219$export$f0989780f32bfcda)(placement) === alignment || (autoAlignment ? (0, $57450959939ce219$export$2b182c584985588b)(placement) !== placement : false);
        return true;
    });
}
/**
 * Optimizes the visibility of the floating element by choosing the placement
 * that has the most space available automatically, without needing to specify a
 * preferred placement. Alternative to `flip`.
 * @see https://floating-ui.com/docs/autoPlacement
 */ const $bf5b7e7f06fad704$export$91fb6ecbd551914 = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'autoPlacement',
        options: options,
        async fn (state) {
            var _middlewareData$autoP, _middlewareData$autoP2, _placementsThatFitOnE;
            const { rects: rects, middlewareData: middlewareData, placement: placement, platform: platform, elements: elements } = state;
            const { crossAxis: crossAxis = false, alignment: alignment, allowedPlacements: allowedPlacements = (0, $57450959939ce219$export$803cd8101b6c182b), autoAlignment: autoAlignment = true, ...detectOverflowOptions } = (0, $57450959939ce219$export$fef61f332f2c0afc)(options, state);
            const placements$1 = alignment !== undefined || allowedPlacements === (0, $57450959939ce219$export$803cd8101b6c182b) ? $bf5b7e7f06fad704$var$getPlacementList(alignment || null, autoAlignment, allowedPlacements) : allowedPlacements;
            const overflow = await $bf5b7e7f06fad704$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const currentIndex = ((_middlewareData$autoP = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP.index) || 0;
            const currentPlacement = placements$1[currentIndex];
            if (currentPlacement == null) return {};
            const alignmentSides = (0, $57450959939ce219$export$be42861551f17911)(currentPlacement, rects, await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)));
            // Make `computeCoords` start from the right place.
            if (placement !== currentPlacement) return {
                reset: {
                    placement: placements$1[0]
                }
            };
            const currentOverflows = [
                overflow[(0, $57450959939ce219$export$3c915306cb7fc97a)(currentPlacement)],
                overflow[alignmentSides[0]],
                overflow[alignmentSides[1]]
            ];
            const allOverflows = [
                ...((_middlewareData$autoP2 = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP2.overflows) || [],
                {
                    placement: currentPlacement,
                    overflows: currentOverflows
                }
            ];
            const nextPlacement = placements$1[currentIndex + 1];
            // There are more placements to check.
            if (nextPlacement) return {
                data: {
                    index: currentIndex + 1,
                    overflows: allOverflows
                },
                reset: {
                    placement: nextPlacement
                }
            };
            const placementsSortedByMostSpace = allOverflows.map((d)=>{
                const alignment = (0, $57450959939ce219$export$f0989780f32bfcda)(d.placement);
                return [
                    d.placement,
                    alignment && crossAxis ? // Check along the mainAxis and main crossAxis side.
                    d.overflows.slice(0, 2).reduce((acc, v)=>acc + v, 0) : // Check only the mainAxis.
                    d.overflows[0],
                    d.overflows
                ];
            }).sort((a, b)=>a[1] - b[1]);
            const placementsThatFitOnEachSide = placementsSortedByMostSpace.filter((d)=>d[2].slice(0, // Aligned placements should not check their opposite crossAxis
                // side.
                (0, $57450959939ce219$export$f0989780f32bfcda)(d[0]) ? 2 : 3).every((v)=>v <= 0));
            const resetPlacement = ((_placementsThatFitOnE = placementsThatFitOnEachSide[0]) == null ? void 0 : _placementsThatFitOnE[0]) || placementsSortedByMostSpace[0][0];
            if (resetPlacement !== placement) return {
                data: {
                    index: currentIndex + 1,
                    overflows: allOverflows
                },
                reset: {
                    placement: resetPlacement
                }
            };
            return {};
        }
    };
};
/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */ const $bf5b7e7f06fad704$export$8a83211c878a3f1f = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'flip',
        options: options,
        async fn (state) {
            var _middlewareData$arrow, _middlewareData$flip;
            const { placement: placement, middlewareData: middlewareData, rects: rects, initialPlacement: initialPlacement, platform: platform, elements: elements } = state;
            const { mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = true, fallbackPlacements: specifiedFallbackPlacements, fallbackStrategy: fallbackStrategy = 'bestFit', fallbackAxisSideDirection: fallbackAxisSideDirection = 'none', flipAlignment: flipAlignment = true, ...detectOverflowOptions } = (0, $57450959939ce219$export$fef61f332f2c0afc)(options, state);
            // If a reset by the arrow was caused due to an alignment offset being
            // added, we should skip any logic now since `flip()` has already done its
            // work.
            // https://github.com/floating-ui/floating-ui/issues/2549#issuecomment-1719601643
            if ((_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) return {};
            const side = (0, $57450959939ce219$export$3c915306cb7fc97a)(placement);
            const initialSideAxis = (0, $57450959939ce219$export$f28e8f882010718a)(initialPlacement);
            const isBasePlacement = (0, $57450959939ce219$export$3c915306cb7fc97a)(initialPlacement) === initialPlacement;
            const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
            const fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipAlignment ? [
                (0, $57450959939ce219$export$9c5e28bad23365fa)(initialPlacement)
            ] : (0, $57450959939ce219$export$496432a3699e50b1)(initialPlacement));
            const hasFallbackAxisSideDirection = fallbackAxisSideDirection !== 'none';
            if (!specifiedFallbackPlacements && hasFallbackAxisSideDirection) fallbackPlacements.push(...(0, $57450959939ce219$export$a9b6fb18fd92c3ec)(initialPlacement, flipAlignment, fallbackAxisSideDirection, rtl));
            const placements = [
                initialPlacement,
                ...fallbackPlacements
            ];
            const overflow = await $bf5b7e7f06fad704$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const overflows = [];
            let overflowsData = ((_middlewareData$flip = middlewareData.flip) == null ? void 0 : _middlewareData$flip.overflows) || [];
            if (checkMainAxis) overflows.push(overflow[side]);
            if (checkCrossAxis) {
                const sides = (0, $57450959939ce219$export$be42861551f17911)(placement, rects, rtl);
                overflows.push(overflow[sides[0]], overflow[sides[1]]);
            }
            overflowsData = [
                ...overflowsData,
                {
                    placement: placement,
                    overflows: overflows
                }
            ];
            // One or more sides is overflowing.
            if (!overflows.every((side)=>side <= 0)) {
                var _middlewareData$flip2, _overflowsData$filter;
                const nextIndex = (((_middlewareData$flip2 = middlewareData.flip) == null ? void 0 : _middlewareData$flip2.index) || 0) + 1;
                const nextPlacement = placements[nextIndex];
                if (nextPlacement) // Try next placement and re-run the lifecycle.
                return {
                    data: {
                        index: nextIndex,
                        overflows: overflowsData
                    },
                    reset: {
                        placement: nextPlacement
                    }
                };
                // First, find the candidates that fit on the mainAxis side of overflow,
                // then find the placement that fits the best on the main crossAxis side.
                let resetPlacement = (_overflowsData$filter = overflowsData.filter((d)=>d.overflows[0] <= 0).sort((a, b)=>a.overflows[1] - b.overflows[1])[0]) == null ? void 0 : _overflowsData$filter.placement;
                // Otherwise fallback.
                if (!resetPlacement) switch(fallbackStrategy){
                    case 'bestFit':
                        {
                            var _overflowsData$filter2;
                            const placement = (_overflowsData$filter2 = overflowsData.filter((d)=>{
                                if (hasFallbackAxisSideDirection) {
                                    const currentSideAxis = (0, $57450959939ce219$export$f28e8f882010718a)(d.placement);
                                    return currentSideAxis === initialSideAxis || // Create a bias to the `y` side axis due to horizontal
                                    // reading directions favoring greater width.
                                    currentSideAxis === 'y';
                                }
                                return true;
                            }).map((d)=>[
                                    d.placement,
                                    d.overflows.filter((overflow)=>overflow > 0).reduce((acc, overflow)=>acc + overflow, 0)
                                ]).sort((a, b)=>a[1] - b[1])[0]) == null ? void 0 : _overflowsData$filter2[0];
                            if (placement) resetPlacement = placement;
                            break;
                        }
                    case 'initialPlacement':
                        resetPlacement = initialPlacement;
                        break;
                }
                if (placement !== resetPlacement) return {
                    reset: {
                        placement: resetPlacement
                    }
                };
            }
            return {};
        }
    };
};
function $bf5b7e7f06fad704$var$getSideOffsets(overflow, rect) {
    return {
        top: overflow.top - rect.height,
        right: overflow.right - rect.width,
        bottom: overflow.bottom - rect.height,
        left: overflow.left - rect.width
    };
}
function $bf5b7e7f06fad704$var$isAnySideFullyClipped(overflow) {
    return (0, $57450959939ce219$export$832b6fa47fa053d2).some((side)=>overflow[side] >= 0);
}
/**
 * Provides data to hide the floating element in applicable situations, such as
 * when it is not in the same clipping context as the reference element.
 * @see https://floating-ui.com/docs/hide
 */ const $bf5b7e7f06fad704$export$fe8985bb6374093c = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'hide',
        options: options,
        async fn (state) {
            const { rects: rects } = state;
            const { strategy: strategy = 'referenceHidden', ...detectOverflowOptions } = (0, $57450959939ce219$export$fef61f332f2c0afc)(options, state);
            switch(strategy){
                case 'referenceHidden':
                    {
                        const overflow = await $bf5b7e7f06fad704$export$37b6bde19b108ecc(state, {
                            ...detectOverflowOptions,
                            elementContext: 'reference'
                        });
                        const offsets = $bf5b7e7f06fad704$var$getSideOffsets(overflow, rects.reference);
                        return {
                            data: {
                                referenceHiddenOffsets: offsets,
                                referenceHidden: $bf5b7e7f06fad704$var$isAnySideFullyClipped(offsets)
                            }
                        };
                    }
                case 'escaped':
                    {
                        const overflow = await $bf5b7e7f06fad704$export$37b6bde19b108ecc(state, {
                            ...detectOverflowOptions,
                            altBoundary: true
                        });
                        const offsets = $bf5b7e7f06fad704$var$getSideOffsets(overflow, rects.floating);
                        return {
                            data: {
                                escapedOffsets: offsets,
                                escaped: $bf5b7e7f06fad704$var$isAnySideFullyClipped(offsets)
                            }
                        };
                    }
                default:
                    return {};
            }
        }
    };
};
function $bf5b7e7f06fad704$var$getBoundingRect(rects) {
    const minX = (0, $57450959939ce219$export$96ec731ed4dcb222)(...rects.map((rect)=>rect.left));
    const minY = (0, $57450959939ce219$export$96ec731ed4dcb222)(...rects.map((rect)=>rect.top));
    const maxX = (0, $57450959939ce219$export$8960430cfd85939f)(...rects.map((rect)=>rect.right));
    const maxY = (0, $57450959939ce219$export$8960430cfd85939f)(...rects.map((rect)=>rect.bottom));
    return {
        x: minX,
        y: minY,
        width: maxX - minX,
        height: maxY - minY
    };
}
function $bf5b7e7f06fad704$var$getRectsByLine(rects) {
    const sortedRects = rects.slice().sort((a, b)=>a.y - b.y);
    const groups = [];
    let prevRect = null;
    for(let i = 0; i < sortedRects.length; i++){
        const rect = sortedRects[i];
        if (!prevRect || rect.y - prevRect.y > prevRect.height / 2) groups.push([
            rect
        ]);
        else groups[groups.length - 1].push(rect);
        prevRect = rect;
    }
    return groups.map((rect)=>(0, $57450959939ce219$export$ee05aea0aeecbad4)($bf5b7e7f06fad704$var$getBoundingRect(rect)));
}
/**
 * Provides improved positioning for inline reference elements that can span
 * over multiple lines, such as hyperlinks or range selections.
 * @see https://floating-ui.com/docs/inline
 */ const $bf5b7e7f06fad704$export$18c8ad048e32c7d5 = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'inline',
        options: options,
        async fn (state) {
            const { placement: placement, elements: elements, rects: rects, platform: platform, strategy: strategy } = state;
            // A MouseEvent's client{X,Y} coords can be up to 2 pixels off a
            // ClientRect's bounds, despite the event listener being triggered. A
            // padding of 2 seems to handle this issue.
            const { padding: padding = 2, x: x, y: y } = (0, $57450959939ce219$export$fef61f332f2c0afc)(options, state);
            const nativeClientRects = Array.from(await (platform.getClientRects == null ? void 0 : platform.getClientRects(elements.reference)) || []);
            const clientRects = $bf5b7e7f06fad704$var$getRectsByLine(nativeClientRects);
            const fallback = (0, $57450959939ce219$export$ee05aea0aeecbad4)($bf5b7e7f06fad704$var$getBoundingRect(nativeClientRects));
            const paddingObject = (0, $57450959939ce219$export$598c291c29bc2e71)(padding);
            function getBoundingClientRect() {
                // There are two rects and they are disjoined.
                if (clientRects.length === 2 && clientRects[0].left > clientRects[1].right && x != null && y != null) // Find the first rect in which the point is fully inside.
                return clientRects.find((rect)=>x > rect.left - paddingObject.left && x < rect.right + paddingObject.right && y > rect.top - paddingObject.top && y < rect.bottom + paddingObject.bottom) || fallback;
                // There are 2 or more connected rects.
                if (clientRects.length >= 2) {
                    if ((0, $57450959939ce219$export$f28e8f882010718a)(placement) === 'y') {
                        const firstRect = clientRects[0];
                        const lastRect = clientRects[clientRects.length - 1];
                        const isTop = (0, $57450959939ce219$export$3c915306cb7fc97a)(placement) === 'top';
                        const top = firstRect.top;
                        const bottom = lastRect.bottom;
                        const left = isTop ? firstRect.left : lastRect.left;
                        const right = isTop ? firstRect.right : lastRect.right;
                        const width = right - left;
                        const height = bottom - top;
                        return {
                            top: top,
                            bottom: bottom,
                            left: left,
                            right: right,
                            width: width,
                            height: height,
                            x: left,
                            y: top
                        };
                    }
                    const isLeftSide = (0, $57450959939ce219$export$3c915306cb7fc97a)(placement) === 'left';
                    const maxRight = (0, $57450959939ce219$export$8960430cfd85939f)(...clientRects.map((rect)=>rect.right));
                    const minLeft = (0, $57450959939ce219$export$96ec731ed4dcb222)(...clientRects.map((rect)=>rect.left));
                    const measureRects = clientRects.filter((rect)=>isLeftSide ? rect.left === minLeft : rect.right === maxRight);
                    const top = measureRects[0].top;
                    const bottom = measureRects[measureRects.length - 1].bottom;
                    const left = minLeft;
                    const right = maxRight;
                    const width = right - left;
                    const height = bottom - top;
                    return {
                        top: top,
                        bottom: bottom,
                        left: left,
                        right: right,
                        width: width,
                        height: height,
                        x: left,
                        y: top
                    };
                }
                return fallback;
            }
            const resetRects = await platform.getElementRects({
                reference: {
                    getBoundingClientRect: getBoundingClientRect
                },
                floating: elements.floating,
                strategy: strategy
            });
            if (rects.reference.x !== resetRects.reference.x || rects.reference.y !== resetRects.reference.y || rects.reference.width !== resetRects.reference.width || rects.reference.height !== resetRects.reference.height) return {
                reset: {
                    rects: resetRects
                }
            };
            return {};
        }
    };
};
// For type backwards-compatibility, the `OffsetOptions` type was also
// Derivable.
async function $bf5b7e7f06fad704$var$convertValueToCoords(state, options) {
    const { placement: placement, platform: platform, elements: elements } = state;
    const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
    const side = (0, $57450959939ce219$export$3c915306cb7fc97a)(placement);
    const alignment = (0, $57450959939ce219$export$f0989780f32bfcda)(placement);
    const isVertical = (0, $57450959939ce219$export$f28e8f882010718a)(placement) === 'y';
    const mainAxisMulti = [
        'left',
        'top'
    ].includes(side) ? -1 : 1;
    const crossAxisMulti = rtl && isVertical ? -1 : 1;
    const rawValue = (0, $57450959939ce219$export$fef61f332f2c0afc)(options, state);
    // eslint-disable-next-line prefer-const
    let { mainAxis: mainAxis, crossAxis: crossAxis, alignmentAxis: alignmentAxis } = typeof rawValue === 'number' ? {
        mainAxis: rawValue,
        crossAxis: 0,
        alignmentAxis: null
    } : {
        mainAxis: rawValue.mainAxis || 0,
        crossAxis: rawValue.crossAxis || 0,
        alignmentAxis: rawValue.alignmentAxis
    };
    if (alignment && typeof alignmentAxis === 'number') crossAxis = alignment === 'end' ? alignmentAxis * -1 : alignmentAxis;
    return isVertical ? {
        x: crossAxis * crossAxisMulti,
        y: mainAxis * mainAxisMulti
    } : {
        x: mainAxis * mainAxisMulti,
        y: crossAxis * crossAxisMulti
    };
}
/**
 * Modifies the placement by translating the floating element along the
 * specified axes.
 * A number (shorthand for `mainAxis` or distance), or an axes configuration
 * object may be passed.
 * @see https://floating-ui.com/docs/offset
 */ const $bf5b7e7f06fad704$export$cc800923e997bb8 = function(options) {
    if (options === void 0) options = 0;
    return {
        name: 'offset',
        options: options,
        async fn (state) {
            var _middlewareData$offse, _middlewareData$arrow;
            const { x: x, y: y, placement: placement, middlewareData: middlewareData } = state;
            const diffCoords = await $bf5b7e7f06fad704$var$convertValueToCoords(state, options);
            // If the placement is the same and the arrow caused an alignment offset
            // then we don't need to change the positioning coordinates.
            if (placement === ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse.placement) && (_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) return {};
            return {
                x: x + diffCoords.x,
                y: y + diffCoords.y,
                data: {
                    ...diffCoords,
                    placement: placement
                }
            };
        }
    };
};
/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */ const $bf5b7e7f06fad704$export$fba63a578e423eb = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'shift',
        options: options,
        async fn (state) {
            const { x: x, y: y, placement: placement } = state;
            const { mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = false, limiter: limiter = {
                fn: (_ref)=>{
                    let { x: x, y: y } = _ref;
                    return {
                        x: x,
                        y: y
                    };
                }
            }, ...detectOverflowOptions } = (0, $57450959939ce219$export$fef61f332f2c0afc)(options, state);
            const coords = {
                x: x,
                y: y
            };
            const overflow = await $bf5b7e7f06fad704$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const crossAxis = (0, $57450959939ce219$export$f28e8f882010718a)((0, $57450959939ce219$export$3c915306cb7fc97a)(placement));
            const mainAxis = (0, $57450959939ce219$export$8a000a963141ac32)(crossAxis);
            let mainAxisCoord = coords[mainAxis];
            let crossAxisCoord = coords[crossAxis];
            if (checkMainAxis) {
                const minSide = mainAxis === 'y' ? 'top' : 'left';
                const maxSide = mainAxis === 'y' ? 'bottom' : 'right';
                const min = mainAxisCoord + overflow[minSide];
                const max = mainAxisCoord - overflow[maxSide];
                mainAxisCoord = (0, $57450959939ce219$export$7d15b64cf5a3a4c4)(min, mainAxisCoord, max);
            }
            if (checkCrossAxis) {
                const minSide = crossAxis === 'y' ? 'top' : 'left';
                const maxSide = crossAxis === 'y' ? 'bottom' : 'right';
                const min = crossAxisCoord + overflow[minSide];
                const max = crossAxisCoord - overflow[maxSide];
                crossAxisCoord = (0, $57450959939ce219$export$7d15b64cf5a3a4c4)(min, crossAxisCoord, max);
            }
            const limitedCoords = limiter.fn({
                ...state,
                [mainAxis]: mainAxisCoord,
                [crossAxis]: crossAxisCoord
            });
            return {
                ...limitedCoords,
                data: {
                    x: limitedCoords.x - x,
                    y: limitedCoords.y - y,
                    enabled: {
                        [mainAxis]: checkMainAxis,
                        [crossAxis]: checkCrossAxis
                    }
                }
            };
        }
    };
};
/**
 * Built-in `limiter` that will stop `shift()` at a certain point.
 */ const $bf5b7e7f06fad704$export$7bf07e38f3dc4b69 = function(options) {
    if (options === void 0) options = {};
    return {
        options: options,
        fn (state) {
            const { x: x, y: y, placement: placement, rects: rects, middlewareData: middlewareData } = state;
            const { offset: offset = 0, mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = true } = (0, $57450959939ce219$export$fef61f332f2c0afc)(options, state);
            const coords = {
                x: x,
                y: y
            };
            const crossAxis = (0, $57450959939ce219$export$f28e8f882010718a)(placement);
            const mainAxis = (0, $57450959939ce219$export$8a000a963141ac32)(crossAxis);
            let mainAxisCoord = coords[mainAxis];
            let crossAxisCoord = coords[crossAxis];
            const rawOffset = (0, $57450959939ce219$export$fef61f332f2c0afc)(offset, state);
            const computedOffset = typeof rawOffset === 'number' ? {
                mainAxis: rawOffset,
                crossAxis: 0
            } : {
                mainAxis: 0,
                crossAxis: 0,
                ...rawOffset
            };
            if (checkMainAxis) {
                const len = mainAxis === 'y' ? 'height' : 'width';
                const limitMin = rects.reference[mainAxis] - rects.floating[len] + computedOffset.mainAxis;
                const limitMax = rects.reference[mainAxis] + rects.reference[len] - computedOffset.mainAxis;
                if (mainAxisCoord < limitMin) mainAxisCoord = limitMin;
                else if (mainAxisCoord > limitMax) mainAxisCoord = limitMax;
            }
            if (checkCrossAxis) {
                var _middlewareData$offse, _middlewareData$offse2;
                const len = mainAxis === 'y' ? 'width' : 'height';
                const isOriginSide = [
                    'top',
                    'left'
                ].includes((0, $57450959939ce219$export$3c915306cb7fc97a)(placement));
                const limitMin = rects.reference[crossAxis] - rects.floating[len] + (isOriginSide ? ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse[crossAxis]) || 0 : 0) + (isOriginSide ? 0 : computedOffset.crossAxis);
                const limitMax = rects.reference[crossAxis] + rects.reference[len] + (isOriginSide ? 0 : ((_middlewareData$offse2 = middlewareData.offset) == null ? void 0 : _middlewareData$offse2[crossAxis]) || 0) - (isOriginSide ? computedOffset.crossAxis : 0);
                if (crossAxisCoord < limitMin) crossAxisCoord = limitMin;
                else if (crossAxisCoord > limitMax) crossAxisCoord = limitMax;
            }
            return {
                [mainAxis]: mainAxisCoord,
                [crossAxis]: crossAxisCoord
            };
        }
    };
};
/**
 * Provides data that allows you to change the size of the floating element —
 * for instance, prevent it from overflowing the clipping boundary or match the
 * width of the reference element.
 * @see https://floating-ui.com/docs/size
 */ const $bf5b7e7f06fad704$export$346677f925de839c = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'size',
        options: options,
        async fn (state) {
            var _state$middlewareData, _state$middlewareData2;
            const { placement: placement, rects: rects, platform: platform, elements: elements } = state;
            const { apply: apply = ()=>{}, ...detectOverflowOptions } = (0, $57450959939ce219$export$fef61f332f2c0afc)(options, state);
            const overflow = await $bf5b7e7f06fad704$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const side = (0, $57450959939ce219$export$3c915306cb7fc97a)(placement);
            const alignment = (0, $57450959939ce219$export$f0989780f32bfcda)(placement);
            const isYAxis = (0, $57450959939ce219$export$f28e8f882010718a)(placement) === 'y';
            const { width: width, height: height } = rects.floating;
            let heightSide;
            let widthSide;
            if (side === 'top' || side === 'bottom') {
                heightSide = side;
                widthSide = alignment === (await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)) ? 'start' : 'end') ? 'left' : 'right';
            } else {
                widthSide = side;
                heightSide = alignment === 'end' ? 'top' : 'bottom';
            }
            const maximumClippingHeight = height - overflow.top - overflow.bottom;
            const maximumClippingWidth = width - overflow.left - overflow.right;
            const overflowAvailableHeight = (0, $57450959939ce219$export$96ec731ed4dcb222)(height - overflow[heightSide], maximumClippingHeight);
            const overflowAvailableWidth = (0, $57450959939ce219$export$96ec731ed4dcb222)(width - overflow[widthSide], maximumClippingWidth);
            const noShift = !state.middlewareData.shift;
            let availableHeight = overflowAvailableHeight;
            let availableWidth = overflowAvailableWidth;
            if ((_state$middlewareData = state.middlewareData.shift) != null && _state$middlewareData.enabled.x) availableWidth = maximumClippingWidth;
            if ((_state$middlewareData2 = state.middlewareData.shift) != null && _state$middlewareData2.enabled.y) availableHeight = maximumClippingHeight;
            if (noShift && !alignment) {
                const xMin = (0, $57450959939ce219$export$8960430cfd85939f)(overflow.left, 0);
                const xMax = (0, $57450959939ce219$export$8960430cfd85939f)(overflow.right, 0);
                const yMin = (0, $57450959939ce219$export$8960430cfd85939f)(overflow.top, 0);
                const yMax = (0, $57450959939ce219$export$8960430cfd85939f)(overflow.bottom, 0);
                if (isYAxis) availableWidth = width - 2 * (xMin !== 0 || xMax !== 0 ? xMin + xMax : (0, $57450959939ce219$export$8960430cfd85939f)(overflow.left, overflow.right));
                else availableHeight = height - 2 * (yMin !== 0 || yMax !== 0 ? yMin + yMax : (0, $57450959939ce219$export$8960430cfd85939f)(overflow.top, overflow.bottom));
            }
            await apply({
                ...state,
                availableWidth: availableWidth,
                availableHeight: availableHeight
            });
            const nextDimensions = await platform.getDimensions(elements.floating);
            if (width !== nextDimensions.width || height !== nextDimensions.height) return {
                reset: {
                    rects: true
                }
            };
            return {};
        }
    };
};



function $b6c7f31735214910$var$hasWindow() {
    return typeof window !== 'undefined';
}
function $b6c7f31735214910$export$651544f548703224(node) {
    if ($b6c7f31735214910$export$8ee0fc9ee280b4ee(node)) return (node.nodeName || '').toLowerCase();
    // Mocked nodes in testing environments may not be instances of Node. By
    // returning `#document` an infinite loop won't occur.
    // https://github.com/floating-ui/floating-ui/issues/2317
    return '#document';
}
function $b6c7f31735214910$export$38b2d434cce3ea22(node) {
    var _node$ownerDocument;
    return (node == null || (_node$ownerDocument = node.ownerDocument) == null ? void 0 : _node$ownerDocument.defaultView) || window;
}
function $b6c7f31735214910$export$e495491855dc5418(node) {
    var _ref;
    return (_ref = ($b6c7f31735214910$export$8ee0fc9ee280b4ee(node) ? node.ownerDocument : node.document) || window.document) == null ? void 0 : _ref.documentElement;
}
function $b6c7f31735214910$export$8ee0fc9ee280b4ee(value) {
    if (!$b6c7f31735214910$var$hasWindow()) return false;
    return value instanceof Node || value instanceof $b6c7f31735214910$export$38b2d434cce3ea22(value).Node;
}
function $b6c7f31735214910$export$45a5e7f76e0caa8d(value) {
    if (!$b6c7f31735214910$var$hasWindow()) return false;
    return value instanceof Element || value instanceof $b6c7f31735214910$export$38b2d434cce3ea22(value).Element;
}
function $b6c7f31735214910$export$1b3bfaa9684536aa(value) {
    if (!$b6c7f31735214910$var$hasWindow()) return false;
    return value instanceof HTMLElement || value instanceof $b6c7f31735214910$export$38b2d434cce3ea22(value).HTMLElement;
}
function $b6c7f31735214910$export$af51f0f06c0f328a(value) {
    if (!$b6c7f31735214910$var$hasWindow() || typeof ShadowRoot === 'undefined') return false;
    return value instanceof ShadowRoot || value instanceof $b6c7f31735214910$export$38b2d434cce3ea22(value).ShadowRoot;
}
function $b6c7f31735214910$export$989e911fa9af580a(element) {
    const { overflow: overflow, overflowX: overflowX, overflowY: overflowY, display: display } = $b6c7f31735214910$export$3735103072e4a80(element);
    return /auto|scroll|overlay|hidden|clip/.test(overflow + overflowY + overflowX) && ![
        'inline',
        'contents'
    ].includes(display);
}
function $b6c7f31735214910$export$71535ffaa902797f(element) {
    return [
        'table',
        'td',
        'th'
    ].includes($b6c7f31735214910$export$651544f548703224(element));
}
function $b6c7f31735214910$export$89e651af02346cd4(element) {
    return [
        ':popover-open',
        ':modal'
    ].some((selector)=>{
        try {
            return element.matches(selector);
        } catch (e) {
            return false;
        }
    });
}
function $b6c7f31735214910$export$d6c4e8150c35fed1(elementOrCss) {
    const webkit = $b6c7f31735214910$export$78551043582a6a98();
    const css = $b6c7f31735214910$export$45a5e7f76e0caa8d(elementOrCss) ? $b6c7f31735214910$export$3735103072e4a80(elementOrCss) : elementOrCss;
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
    // https://drafts.csswg.org/css-transforms-2/#individual-transforms
    return [
        'transform',
        'translate',
        'scale',
        'rotate',
        'perspective'
    ].some((value)=>css[value] ? css[value] !== 'none' : false) || (css.containerType ? css.containerType !== 'normal' : false) || !webkit && (css.backdropFilter ? css.backdropFilter !== 'none' : false) || !webkit && (css.filter ? css.filter !== 'none' : false) || [
        'transform',
        'translate',
        'scale',
        'rotate',
        'perspective',
        'filter'
    ].some((value)=>(css.willChange || '').includes(value)) || [
        'paint',
        'layout',
        'strict',
        'content'
    ].some((value)=>(css.contain || '').includes(value));
}
function $b6c7f31735214910$export$940d8225183e1404(element) {
    let currentNode = $b6c7f31735214910$export$4e12058fc4d51d56(element);
    while($b6c7f31735214910$export$1b3bfaa9684536aa(currentNode) && !$b6c7f31735214910$export$d1162fb0b6d4cd51(currentNode)){
        if ($b6c7f31735214910$export$d6c4e8150c35fed1(currentNode)) return currentNode;
        else if ($b6c7f31735214910$export$89e651af02346cd4(currentNode)) return null;
        currentNode = $b6c7f31735214910$export$4e12058fc4d51d56(currentNode);
    }
    return null;
}
function $b6c7f31735214910$export$78551043582a6a98() {
    if (typeof CSS === 'undefined' || !CSS.supports) return false;
    return CSS.supports('-webkit-backdrop-filter', 'none');
}
function $b6c7f31735214910$export$d1162fb0b6d4cd51(node) {
    return [
        'html',
        'body',
        '#document'
    ].includes($b6c7f31735214910$export$651544f548703224(node));
}
function $b6c7f31735214910$export$3735103072e4a80(element) {
    return $b6c7f31735214910$export$38b2d434cce3ea22(element).getComputedStyle(element);
}
function $b6c7f31735214910$export$dc8fc79fa2800137(element) {
    if ($b6c7f31735214910$export$45a5e7f76e0caa8d(element)) return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
    return {
        scrollLeft: element.scrollX,
        scrollTop: element.scrollY
    };
}
function $b6c7f31735214910$export$4e12058fc4d51d56(node) {
    if ($b6c7f31735214910$export$651544f548703224(node) === 'html') return node;
    const result = // Step into the shadow DOM of the parent of a slotted node.
    node.assignedSlot || // DOM Element detected.
    node.parentNode || // ShadowRoot detected.
    $b6c7f31735214910$export$af51f0f06c0f328a(node) && node.host || // Fallback.
    $b6c7f31735214910$export$e495491855dc5418(node);
    return $b6c7f31735214910$export$af51f0f06c0f328a(result) ? result.host : result;
}
function $b6c7f31735214910$export$7cd01a57c8ca906c(node) {
    const parentNode = $b6c7f31735214910$export$4e12058fc4d51d56(node);
    if ($b6c7f31735214910$export$d1162fb0b6d4cd51(parentNode)) return node.ownerDocument ? node.ownerDocument.body : node.body;
    if ($b6c7f31735214910$export$1b3bfaa9684536aa(parentNode) && $b6c7f31735214910$export$989e911fa9af580a(parentNode)) return parentNode;
    return $b6c7f31735214910$export$7cd01a57c8ca906c(parentNode);
}
function $b6c7f31735214910$export$3b57c1601291186b(node, list, traverseIframes) {
    var _node$ownerDocument2;
    if (list === void 0) list = [];
    if (traverseIframes === void 0) traverseIframes = true;
    const scrollableAncestor = $b6c7f31735214910$export$7cd01a57c8ca906c(node);
    const isBody = scrollableAncestor === ((_node$ownerDocument2 = node.ownerDocument) == null ? void 0 : _node$ownerDocument2.body);
    const win = $b6c7f31735214910$export$38b2d434cce3ea22(scrollableAncestor);
    if (isBody) {
        const frameElement = $b6c7f31735214910$export$7bf1f8740e3e34af(win);
        return list.concat(win, win.visualViewport || [], $b6c7f31735214910$export$989e911fa9af580a(scrollableAncestor) ? scrollableAncestor : [], frameElement && traverseIframes ? $b6c7f31735214910$export$3b57c1601291186b(frameElement) : []);
    }
    return list.concat(scrollableAncestor, $b6c7f31735214910$export$3b57c1601291186b(scrollableAncestor, [], traverseIframes));
}
function $b6c7f31735214910$export$7bf1f8740e3e34af(win) {
    return win.parent && Object.getPrototypeOf(win.parent) ? win.frameElement : null;
}


function $8772434deeb83c74$var$getCssDimensions(element) {
    const css = (0, $b6c7f31735214910$export$3735103072e4a80)(element);
    // In testing environments, the `width` and `height` properties are empty
    // strings for SVG elements, returning NaN. Fallback to `0` in this case.
    let width = parseFloat(css.width) || 0;
    let height = parseFloat(css.height) || 0;
    const hasOffset = (0, $b6c7f31735214910$export$1b3bfaa9684536aa)(element);
    const offsetWidth = hasOffset ? element.offsetWidth : width;
    const offsetHeight = hasOffset ? element.offsetHeight : height;
    const shouldFallback = (0, $57450959939ce219$export$2077e0241d6afd3c)(width) !== offsetWidth || (0, $57450959939ce219$export$2077e0241d6afd3c)(height) !== offsetHeight;
    if (shouldFallback) {
        width = offsetWidth;
        height = offsetHeight;
    }
    return {
        width: width,
        height: height,
        $: shouldFallback
    };
}
function $8772434deeb83c74$var$unwrapElement(element) {
    return !(0, $b6c7f31735214910$export$45a5e7f76e0caa8d)(element) ? element.contextElement : element;
}
function $8772434deeb83c74$var$getScale(element) {
    const domElement = $8772434deeb83c74$var$unwrapElement(element);
    if (!(0, $b6c7f31735214910$export$1b3bfaa9684536aa)(domElement)) return (0, $57450959939ce219$export$a397704b5e280835)(1);
    const rect = domElement.getBoundingClientRect();
    const { width: width, height: height, $: $ } = $8772434deeb83c74$var$getCssDimensions(domElement);
    let x = ($ ? (0, $57450959939ce219$export$2077e0241d6afd3c)(rect.width) : rect.width) / width;
    let y = ($ ? (0, $57450959939ce219$export$2077e0241d6afd3c)(rect.height) : rect.height) / height;
    // 0, NaN, or Infinity should always fallback to 1.
    if (!x || !Number.isFinite(x)) x = 1;
    if (!y || !Number.isFinite(y)) y = 1;
    return {
        x: x,
        y: y
    };
}
const $8772434deeb83c74$var$noOffsets = /*#__PURE__*/ (0, $57450959939ce219$export$a397704b5e280835)(0);
function $8772434deeb83c74$var$getVisualOffsets(element) {
    const win = (0, $b6c7f31735214910$export$38b2d434cce3ea22)(element);
    if (!(0, $b6c7f31735214910$export$78551043582a6a98)() || !win.visualViewport) return $8772434deeb83c74$var$noOffsets;
    return {
        x: win.visualViewport.offsetLeft,
        y: win.visualViewport.offsetTop
    };
}
function $8772434deeb83c74$var$shouldAddVisualOffsets(element, isFixed, floatingOffsetParent) {
    if (isFixed === void 0) isFixed = false;
    if (!floatingOffsetParent || isFixed && floatingOffsetParent !== (0, $b6c7f31735214910$export$38b2d434cce3ea22)(element)) return false;
    return isFixed;
}
function $8772434deeb83c74$var$getBoundingClientRect(element, includeScale, isFixedStrategy, offsetParent) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    const clientRect = element.getBoundingClientRect();
    const domElement = $8772434deeb83c74$var$unwrapElement(element);
    let scale = (0, $57450959939ce219$export$a397704b5e280835)(1);
    if (includeScale) {
        if (offsetParent) {
            if ((0, $b6c7f31735214910$export$45a5e7f76e0caa8d)(offsetParent)) scale = $8772434deeb83c74$var$getScale(offsetParent);
        } else scale = $8772434deeb83c74$var$getScale(element);
    }
    const visualOffsets = $8772434deeb83c74$var$shouldAddVisualOffsets(domElement, isFixedStrategy, offsetParent) ? $8772434deeb83c74$var$getVisualOffsets(domElement) : (0, $57450959939ce219$export$a397704b5e280835)(0);
    let x = (clientRect.left + visualOffsets.x) / scale.x;
    let y = (clientRect.top + visualOffsets.y) / scale.y;
    let width = clientRect.width / scale.x;
    let height = clientRect.height / scale.y;
    if (domElement) {
        const win = (0, $b6c7f31735214910$export$38b2d434cce3ea22)(domElement);
        const offsetWin = offsetParent && (0, $b6c7f31735214910$export$45a5e7f76e0caa8d)(offsetParent) ? (0, $b6c7f31735214910$export$38b2d434cce3ea22)(offsetParent) : offsetParent;
        let currentWin = win;
        let currentIFrame = (0, $b6c7f31735214910$export$7bf1f8740e3e34af)(currentWin);
        while(currentIFrame && offsetParent && offsetWin !== currentWin){
            const iframeScale = $8772434deeb83c74$var$getScale(currentIFrame);
            const iframeRect = currentIFrame.getBoundingClientRect();
            const css = (0, $b6c7f31735214910$export$3735103072e4a80)(currentIFrame);
            const left = iframeRect.left + (currentIFrame.clientLeft + parseFloat(css.paddingLeft)) * iframeScale.x;
            const top = iframeRect.top + (currentIFrame.clientTop + parseFloat(css.paddingTop)) * iframeScale.y;
            x *= iframeScale.x;
            y *= iframeScale.y;
            width *= iframeScale.x;
            height *= iframeScale.y;
            x += left;
            y += top;
            currentWin = (0, $b6c7f31735214910$export$38b2d434cce3ea22)(currentIFrame);
            currentIFrame = (0, $b6c7f31735214910$export$7bf1f8740e3e34af)(currentWin);
        }
    }
    return (0, $57450959939ce219$export$ee05aea0aeecbad4)({
        width: width,
        height: height,
        x: x,
        y: y
    });
}
// If <html> has a CSS width greater than the viewport, then this will be
// incorrect for RTL.
function $8772434deeb83c74$var$getWindowScrollBarX(element, rect) {
    const leftScroll = (0, $b6c7f31735214910$export$dc8fc79fa2800137)(element).scrollLeft;
    if (!rect) return $8772434deeb83c74$var$getBoundingClientRect((0, $b6c7f31735214910$export$e495491855dc5418)(element)).left + leftScroll;
    return rect.left + leftScroll;
}
function $8772434deeb83c74$var$getHTMLOffset(documentElement, scroll, ignoreScrollbarX) {
    if (ignoreScrollbarX === void 0) ignoreScrollbarX = false;
    const htmlRect = documentElement.getBoundingClientRect();
    const x = htmlRect.left + scroll.scrollLeft - (ignoreScrollbarX ? 0 : // RTL <body> scrollbar.
    $8772434deeb83c74$var$getWindowScrollBarX(documentElement, htmlRect));
    const y = htmlRect.top + scroll.scrollTop;
    return {
        x: x,
        y: y
    };
}
function $8772434deeb83c74$var$convertOffsetParentRelativeRectToViewportRelativeRect(_ref) {
    let { elements: elements, rect: rect, offsetParent: offsetParent, strategy: strategy } = _ref;
    const isFixed = strategy === 'fixed';
    const documentElement = (0, $b6c7f31735214910$export$e495491855dc5418)(offsetParent);
    const topLayer = elements ? (0, $b6c7f31735214910$export$89e651af02346cd4)(elements.floating) : false;
    if (offsetParent === documentElement || topLayer && isFixed) return rect;
    let scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    let scale = (0, $57450959939ce219$export$a397704b5e280835)(1);
    const offsets = (0, $57450959939ce219$export$a397704b5e280835)(0);
    const isOffsetParentAnElement = (0, $b6c7f31735214910$export$1b3bfaa9684536aa)(offsetParent);
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $b6c7f31735214910$export$651544f548703224)(offsetParent) !== 'body' || (0, $b6c7f31735214910$export$989e911fa9af580a)(documentElement)) scroll = (0, $b6c7f31735214910$export$dc8fc79fa2800137)(offsetParent);
        if ((0, $b6c7f31735214910$export$1b3bfaa9684536aa)(offsetParent)) {
            const offsetRect = $8772434deeb83c74$var$getBoundingClientRect(offsetParent);
            scale = $8772434deeb83c74$var$getScale(offsetParent);
            offsets.x = offsetRect.x + offsetParent.clientLeft;
            offsets.y = offsetRect.y + offsetParent.clientTop;
        }
    }
    const htmlOffset = documentElement && !isOffsetParentAnElement && !isFixed ? $8772434deeb83c74$var$getHTMLOffset(documentElement, scroll, true) : (0, $57450959939ce219$export$a397704b5e280835)(0);
    return {
        width: rect.width * scale.x,
        height: rect.height * scale.y,
        x: rect.x * scale.x - scroll.scrollLeft * scale.x + offsets.x + htmlOffset.x,
        y: rect.y * scale.y - scroll.scrollTop * scale.y + offsets.y + htmlOffset.y
    };
}
function $8772434deeb83c74$var$getClientRects(element) {
    return Array.from(element.getClientRects());
}
// Gets the entire size of the scrollable document area, even extending outside
// of the `<html>` and `<body>` rect bounds if horizontally scrollable.
function $8772434deeb83c74$var$getDocumentRect(element) {
    const html = (0, $b6c7f31735214910$export$e495491855dc5418)(element);
    const scroll = (0, $b6c7f31735214910$export$dc8fc79fa2800137)(element);
    const body = element.ownerDocument.body;
    const width = (0, $57450959939ce219$export$8960430cfd85939f)(html.scrollWidth, html.clientWidth, body.scrollWidth, body.clientWidth);
    const height = (0, $57450959939ce219$export$8960430cfd85939f)(html.scrollHeight, html.clientHeight, body.scrollHeight, body.clientHeight);
    let x = -scroll.scrollLeft + $8772434deeb83c74$var$getWindowScrollBarX(element);
    const y = -scroll.scrollTop;
    if ((0, $b6c7f31735214910$export$3735103072e4a80)(body).direction === 'rtl') x += (0, $57450959939ce219$export$8960430cfd85939f)(html.clientWidth, body.clientWidth) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
function $8772434deeb83c74$var$getViewportRect(element, strategy) {
    const win = (0, $b6c7f31735214910$export$38b2d434cce3ea22)(element);
    const html = (0, $b6c7f31735214910$export$e495491855dc5418)(element);
    const visualViewport = win.visualViewport;
    let width = html.clientWidth;
    let height = html.clientHeight;
    let x = 0;
    let y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        const visualViewportBased = (0, $b6c7f31735214910$export$78551043582a6a98)();
        if (!visualViewportBased || visualViewportBased && strategy === 'fixed') {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
// Returns the inner client rect, subtracting scrollbars if present.
function $8772434deeb83c74$var$getInnerBoundingClientRect(element, strategy) {
    const clientRect = $8772434deeb83c74$var$getBoundingClientRect(element, true, strategy === 'fixed');
    const top = clientRect.top + element.clientTop;
    const left = clientRect.left + element.clientLeft;
    const scale = (0, $b6c7f31735214910$export$1b3bfaa9684536aa)(element) ? $8772434deeb83c74$var$getScale(element) : (0, $57450959939ce219$export$a397704b5e280835)(1);
    const width = element.clientWidth * scale.x;
    const height = element.clientHeight * scale.y;
    const x = left * scale.x;
    const y = top * scale.y;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
function $8772434deeb83c74$var$getClientRectFromClippingAncestor(element, clippingAncestor, strategy) {
    let rect;
    if (clippingAncestor === 'viewport') rect = $8772434deeb83c74$var$getViewportRect(element, strategy);
    else if (clippingAncestor === 'document') rect = $8772434deeb83c74$var$getDocumentRect((0, $b6c7f31735214910$export$e495491855dc5418)(element));
    else if ((0, $b6c7f31735214910$export$45a5e7f76e0caa8d)(clippingAncestor)) rect = $8772434deeb83c74$var$getInnerBoundingClientRect(clippingAncestor, strategy);
    else {
        const visualOffsets = $8772434deeb83c74$var$getVisualOffsets(element);
        rect = {
            x: clippingAncestor.x - visualOffsets.x,
            y: clippingAncestor.y - visualOffsets.y,
            width: clippingAncestor.width,
            height: clippingAncestor.height
        };
    }
    return (0, $57450959939ce219$export$ee05aea0aeecbad4)(rect);
}
function $8772434deeb83c74$var$hasFixedPositionAncestor(element, stopNode) {
    const parentNode = (0, $b6c7f31735214910$export$4e12058fc4d51d56)(element);
    if (parentNode === stopNode || !(0, $b6c7f31735214910$export$45a5e7f76e0caa8d)(parentNode) || (0, $b6c7f31735214910$export$d1162fb0b6d4cd51)(parentNode)) return false;
    return (0, $b6c7f31735214910$export$3735103072e4a80)(parentNode).position === 'fixed' || $8772434deeb83c74$var$hasFixedPositionAncestor(parentNode, stopNode);
}
// A "clipping ancestor" is an `overflow` element with the characteristic of
// clipping (or hiding) child elements. This returns all clipping ancestors
// of the given element up the tree.
function $8772434deeb83c74$var$getClippingElementAncestors(element, cache) {
    const cachedResult = cache.get(element);
    if (cachedResult) return cachedResult;
    let result = (0, $b6c7f31735214910$export$3b57c1601291186b)(element, [], false).filter((el)=>(0, $b6c7f31735214910$export$45a5e7f76e0caa8d)(el) && (0, $b6c7f31735214910$export$651544f548703224)(el) !== 'body');
    let currentContainingBlockComputedStyle = null;
    const elementIsFixed = (0, $b6c7f31735214910$export$3735103072e4a80)(element).position === 'fixed';
    let currentNode = elementIsFixed ? (0, $b6c7f31735214910$export$4e12058fc4d51d56)(element) : element;
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
    while((0, $b6c7f31735214910$export$45a5e7f76e0caa8d)(currentNode) && !(0, $b6c7f31735214910$export$d1162fb0b6d4cd51)(currentNode)){
        const computedStyle = (0, $b6c7f31735214910$export$3735103072e4a80)(currentNode);
        const currentNodeIsContaining = (0, $b6c7f31735214910$export$d6c4e8150c35fed1)(currentNode);
        if (!currentNodeIsContaining && computedStyle.position === 'fixed') currentContainingBlockComputedStyle = null;
        const shouldDropCurrentNode = elementIsFixed ? !currentNodeIsContaining && !currentContainingBlockComputedStyle : !currentNodeIsContaining && computedStyle.position === 'static' && !!currentContainingBlockComputedStyle && [
            'absolute',
            'fixed'
        ].includes(currentContainingBlockComputedStyle.position) || (0, $b6c7f31735214910$export$989e911fa9af580a)(currentNode) && !currentNodeIsContaining && $8772434deeb83c74$var$hasFixedPositionAncestor(element, currentNode);
        if (shouldDropCurrentNode) // Drop non-containing blocks.
        result = result.filter((ancestor)=>ancestor !== currentNode);
        else // Record last containing block for next iteration.
        currentContainingBlockComputedStyle = computedStyle;
        currentNode = (0, $b6c7f31735214910$export$4e12058fc4d51d56)(currentNode);
    }
    cache.set(element, result);
    return result;
}
// Gets the maximum area that the element is visible in due to any number of
// clipping ancestors.
function $8772434deeb83c74$var$getClippingRect(_ref) {
    let { element: element, boundary: boundary, rootBoundary: rootBoundary, strategy: strategy } = _ref;
    const elementClippingAncestors = boundary === 'clippingAncestors' ? (0, $b6c7f31735214910$export$89e651af02346cd4)(element) ? [] : $8772434deeb83c74$var$getClippingElementAncestors(element, this._c) : [].concat(boundary);
    const clippingAncestors = [
        ...elementClippingAncestors,
        rootBoundary
    ];
    const firstClippingAncestor = clippingAncestors[0];
    const clippingRect = clippingAncestors.reduce((accRect, clippingAncestor)=>{
        const rect = $8772434deeb83c74$var$getClientRectFromClippingAncestor(element, clippingAncestor, strategy);
        accRect.top = (0, $57450959939ce219$export$8960430cfd85939f)(rect.top, accRect.top);
        accRect.right = (0, $57450959939ce219$export$96ec731ed4dcb222)(rect.right, accRect.right);
        accRect.bottom = (0, $57450959939ce219$export$96ec731ed4dcb222)(rect.bottom, accRect.bottom);
        accRect.left = (0, $57450959939ce219$export$8960430cfd85939f)(rect.left, accRect.left);
        return accRect;
    }, $8772434deeb83c74$var$getClientRectFromClippingAncestor(element, firstClippingAncestor, strategy));
    return {
        width: clippingRect.right - clippingRect.left,
        height: clippingRect.bottom - clippingRect.top,
        x: clippingRect.left,
        y: clippingRect.top
    };
}
function $8772434deeb83c74$var$getDimensions(element) {
    const { width: width, height: height } = $8772434deeb83c74$var$getCssDimensions(element);
    return {
        width: width,
        height: height
    };
}
function $8772434deeb83c74$var$getRectRelativeToOffsetParent(element, offsetParent, strategy) {
    const isOffsetParentAnElement = (0, $b6c7f31735214910$export$1b3bfaa9684536aa)(offsetParent);
    const documentElement = (0, $b6c7f31735214910$export$e495491855dc5418)(offsetParent);
    const isFixed = strategy === 'fixed';
    const rect = $8772434deeb83c74$var$getBoundingClientRect(element, true, isFixed, offsetParent);
    let scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    const offsets = (0, $57450959939ce219$export$a397704b5e280835)(0);
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $b6c7f31735214910$export$651544f548703224)(offsetParent) !== 'body' || (0, $b6c7f31735214910$export$989e911fa9af580a)(documentElement)) scroll = (0, $b6c7f31735214910$export$dc8fc79fa2800137)(offsetParent);
        if (isOffsetParentAnElement) {
            const offsetRect = $8772434deeb83c74$var$getBoundingClientRect(offsetParent, true, isFixed, offsetParent);
            offsets.x = offsetRect.x + offsetParent.clientLeft;
            offsets.y = offsetRect.y + offsetParent.clientTop;
        } else if (documentElement) // If the <body> scrollbar appears on the left (e.g. RTL systems). Use
        // Firefox with layout.scrollbar.side = 3 in about:config to test this.
        offsets.x = $8772434deeb83c74$var$getWindowScrollBarX(documentElement);
    }
    const htmlOffset = documentElement && !isOffsetParentAnElement && !isFixed ? $8772434deeb83c74$var$getHTMLOffset(documentElement, scroll) : (0, $57450959939ce219$export$a397704b5e280835)(0);
    const x = rect.left + scroll.scrollLeft - offsets.x - htmlOffset.x;
    const y = rect.top + scroll.scrollTop - offsets.y - htmlOffset.y;
    return {
        x: x,
        y: y,
        width: rect.width,
        height: rect.height
    };
}
function $8772434deeb83c74$var$isStaticPositioned(element) {
    return (0, $b6c7f31735214910$export$3735103072e4a80)(element).position === 'static';
}
function $8772434deeb83c74$var$getTrueOffsetParent(element, polyfill) {
    if (!(0, $b6c7f31735214910$export$1b3bfaa9684536aa)(element) || (0, $b6c7f31735214910$export$3735103072e4a80)(element).position === 'fixed') return null;
    if (polyfill) return polyfill(element);
    let rawOffsetParent = element.offsetParent;
    // Firefox returns the <html> element as the offsetParent if it's non-static,
    // while Chrome and Safari return the <body> element. The <body> element must
    // be used to perform the correct calculations even if the <html> element is
    // non-static.
    if ((0, $b6c7f31735214910$export$e495491855dc5418)(element) === rawOffsetParent) rawOffsetParent = rawOffsetParent.ownerDocument.body;
    return rawOffsetParent;
}
// Gets the closest ancestor positioned element. Handles some edge cases,
// such as table ancestors and cross browser bugs.
function $8772434deeb83c74$var$getOffsetParent(element, polyfill) {
    const win = (0, $b6c7f31735214910$export$38b2d434cce3ea22)(element);
    if ((0, $b6c7f31735214910$export$89e651af02346cd4)(element)) return win;
    if (!(0, $b6c7f31735214910$export$1b3bfaa9684536aa)(element)) {
        let svgOffsetParent = (0, $b6c7f31735214910$export$4e12058fc4d51d56)(element);
        while(svgOffsetParent && !(0, $b6c7f31735214910$export$d1162fb0b6d4cd51)(svgOffsetParent)){
            if ((0, $b6c7f31735214910$export$45a5e7f76e0caa8d)(svgOffsetParent) && !$8772434deeb83c74$var$isStaticPositioned(svgOffsetParent)) return svgOffsetParent;
            svgOffsetParent = (0, $b6c7f31735214910$export$4e12058fc4d51d56)(svgOffsetParent);
        }
        return win;
    }
    let offsetParent = $8772434deeb83c74$var$getTrueOffsetParent(element, polyfill);
    while(offsetParent && (0, $b6c7f31735214910$export$71535ffaa902797f)(offsetParent) && $8772434deeb83c74$var$isStaticPositioned(offsetParent))offsetParent = $8772434deeb83c74$var$getTrueOffsetParent(offsetParent, polyfill);
    if (offsetParent && (0, $b6c7f31735214910$export$d1162fb0b6d4cd51)(offsetParent) && $8772434deeb83c74$var$isStaticPositioned(offsetParent) && !(0, $b6c7f31735214910$export$d6c4e8150c35fed1)(offsetParent)) return win;
    return offsetParent || (0, $b6c7f31735214910$export$940d8225183e1404)(element) || win;
}
const $8772434deeb83c74$var$getElementRects = async function(data) {
    const getOffsetParentFn = this.getOffsetParent || $8772434deeb83c74$var$getOffsetParent;
    const getDimensionsFn = this.getDimensions;
    const floatingDimensions = await getDimensionsFn(data.floating);
    return {
        reference: $8772434deeb83c74$var$getRectRelativeToOffsetParent(data.reference, await getOffsetParentFn(data.floating), data.strategy),
        floating: {
            x: 0,
            y: 0,
            width: floatingDimensions.width,
            height: floatingDimensions.height
        }
    };
};
function $8772434deeb83c74$var$isRTL(element) {
    return (0, $b6c7f31735214910$export$3735103072e4a80)(element).direction === 'rtl';
}
const $8772434deeb83c74$export$722a64dea1b767dc = {
    convertOffsetParentRelativeRectToViewportRelativeRect: $8772434deeb83c74$var$convertOffsetParentRelativeRectToViewportRelativeRect,
    getDocumentElement: $b6c7f31735214910$export$e495491855dc5418,
    getClippingRect: $8772434deeb83c74$var$getClippingRect,
    getOffsetParent: $8772434deeb83c74$var$getOffsetParent,
    getElementRects: $8772434deeb83c74$var$getElementRects,
    getClientRects: $8772434deeb83c74$var$getClientRects,
    getDimensions: $8772434deeb83c74$var$getDimensions,
    getScale: $8772434deeb83c74$var$getScale,
    isElement: $b6c7f31735214910$export$45a5e7f76e0caa8d,
    isRTL: $8772434deeb83c74$var$isRTL
};
function $8772434deeb83c74$var$rectsAreEqual(a, b) {
    return a.x === b.x && a.y === b.y && a.width === b.width && a.height === b.height;
}
// https://samthor.au/2021/observing-dom/
function $8772434deeb83c74$var$observeMove(element, onMove) {
    let io = null;
    let timeoutId;
    const root = (0, $b6c7f31735214910$export$e495491855dc5418)(element);
    function cleanup() {
        var _io;
        clearTimeout(timeoutId);
        (_io = io) == null || _io.disconnect();
        io = null;
    }
    function refresh(skip, threshold) {
        if (skip === void 0) skip = false;
        if (threshold === void 0) threshold = 1;
        cleanup();
        const elementRectForRootMargin = element.getBoundingClientRect();
        const { left: left, top: top, width: width, height: height } = elementRectForRootMargin;
        if (!skip) onMove();
        if (!width || !height) return;
        const insetTop = (0, $57450959939ce219$export$a3fe094919f356fd)(top);
        const insetRight = (0, $57450959939ce219$export$a3fe094919f356fd)(root.clientWidth - (left + width));
        const insetBottom = (0, $57450959939ce219$export$a3fe094919f356fd)(root.clientHeight - (top + height));
        const insetLeft = (0, $57450959939ce219$export$a3fe094919f356fd)(left);
        const rootMargin = -insetTop + "px " + -insetRight + "px " + -insetBottom + "px " + -insetLeft + "px";
        const options = {
            rootMargin: rootMargin,
            threshold: (0, $57450959939ce219$export$8960430cfd85939f)(0, (0, $57450959939ce219$export$96ec731ed4dcb222)(1, threshold)) || 1
        };
        let isFirstUpdate = true;
        function handleObserve(entries) {
            const ratio = entries[0].intersectionRatio;
            if (ratio !== threshold) {
                if (!isFirstUpdate) return refresh();
                if (!ratio) // If the reference is clipped, the ratio is 0. Throttle the refresh
                // to prevent an infinite loop of updates.
                timeoutId = setTimeout(()=>{
                    refresh(false, 1e-7);
                }, 1000);
                else refresh(false, ratio);
            }
            if (ratio === 1 && !$8772434deeb83c74$var$rectsAreEqual(elementRectForRootMargin, element.getBoundingClientRect())) // It's possible that even though the ratio is reported as 1, the
            // element is not actually fully within the IntersectionObserver's root
            // area anymore. This can happen under performance constraints. This may
            // be a bug in the browser's IntersectionObserver implementation. To
            // work around this, we compare the element's bounding rect now with
            // what it was at the time we created the IntersectionObserver. If they
            // are not equal then the element moved, so we refresh.
            refresh();
            isFirstUpdate = false;
        }
        // Older browsers don't support a `document` as the root and will throw an
        // error.
        try {
            io = new IntersectionObserver(handleObserve, {
                ...options,
                // Handle <iframe>s
                root: root.ownerDocument
            });
        } catch (e) {
            io = new IntersectionObserver(handleObserve, options);
        }
        io.observe(element);
    }
    refresh(true);
    return cleanup;
}
/**
 * Automatically updates the position of the floating element when necessary.
 * Should only be called when the floating element is mounted on the DOM or
 * visible on the screen.
 * @returns cleanup function that should be invoked when the floating element is
 * removed from the DOM or hidden from the screen.
 * @see https://floating-ui.com/docs/autoUpdate
 */ function $8772434deeb83c74$export$deee3a793edee05f(reference, floating, update, options) {
    if (options === void 0) options = {};
    const { ancestorScroll: ancestorScroll = true, ancestorResize: ancestorResize = true, elementResize: elementResize = typeof ResizeObserver === 'function', layoutShift: layoutShift = typeof IntersectionObserver === 'function', animationFrame: animationFrame = false } = options;
    const referenceEl = $8772434deeb83c74$var$unwrapElement(reference);
    const ancestors = ancestorScroll || ancestorResize ? [
        ...referenceEl ? (0, $b6c7f31735214910$export$3b57c1601291186b)(referenceEl) : [],
        ...(0, $b6c7f31735214910$export$3b57c1601291186b)(floating)
    ] : [];
    ancestors.forEach((ancestor)=>{
        ancestorScroll && ancestor.addEventListener('scroll', update, {
            passive: true
        });
        ancestorResize && ancestor.addEventListener('resize', update);
    });
    const cleanupIo = referenceEl && layoutShift ? $8772434deeb83c74$var$observeMove(referenceEl, update) : null;
    let reobserveFrame = -1;
    let resizeObserver = null;
    if (elementResize) {
        resizeObserver = new ResizeObserver((_ref)=>{
            let [firstEntry] = _ref;
            if (firstEntry && firstEntry.target === referenceEl && resizeObserver) {
                // Prevent update loops when using the `size` middleware.
                // https://github.com/floating-ui/floating-ui/issues/1740
                resizeObserver.unobserve(floating);
                cancelAnimationFrame(reobserveFrame);
                reobserveFrame = requestAnimationFrame(()=>{
                    var _resizeObserver;
                    (_resizeObserver = resizeObserver) == null || _resizeObserver.observe(floating);
                });
            }
            update();
        });
        if (referenceEl && !animationFrame) resizeObserver.observe(referenceEl);
        resizeObserver.observe(floating);
    }
    let frameId;
    let prevRefRect = animationFrame ? $8772434deeb83c74$var$getBoundingClientRect(reference) : null;
    if (animationFrame) frameLoop();
    function frameLoop() {
        const nextRefRect = $8772434deeb83c74$var$getBoundingClientRect(reference);
        if (prevRefRect && !$8772434deeb83c74$var$rectsAreEqual(prevRefRect, nextRefRect)) update();
        prevRefRect = nextRefRect;
        frameId = requestAnimationFrame(frameLoop);
    }
    update();
    return ()=>{
        var _resizeObserver2;
        ancestors.forEach((ancestor)=>{
            ancestorScroll && ancestor.removeEventListener('scroll', update);
            ancestorResize && ancestor.removeEventListener('resize', update);
        });
        cleanupIo == null || cleanupIo();
        (_resizeObserver2 = resizeObserver) == null || _resizeObserver2.disconnect();
        resizeObserver = null;
        if (animationFrame) cancelAnimationFrame(frameId);
    };
}
/**
 * Resolves with an object of overflow side offsets that determine how much the
 * element is overflowing a given clipping boundary on each side.
 * - positive = overflowing the boundary by that number of pixels
 * - negative = how many pixels left before it will overflow
 * - 0 = lies flush with the boundary
 * @see https://floating-ui.com/docs/detectOverflow
 */ const $8772434deeb83c74$export$37b6bde19b108ecc = (0, $bf5b7e7f06fad704$export$37b6bde19b108ecc);
/**
 * Modifies the placement by translating the floating element along the
 * specified axes.
 * A number (shorthand for `mainAxis` or distance), or an axes configuration
 * object may be passed.
 * @see https://floating-ui.com/docs/offset
 */ const $8772434deeb83c74$export$cc800923e997bb8 = (0, $bf5b7e7f06fad704$export$cc800923e997bb8);
/**
 * Optimizes the visibility of the floating element by choosing the placement
 * that has the most space available automatically, without needing to specify a
 * preferred placement. Alternative to `flip`.
 * @see https://floating-ui.com/docs/autoPlacement
 */ const $8772434deeb83c74$export$91fb6ecbd551914 = (0, $bf5b7e7f06fad704$export$91fb6ecbd551914);
/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */ const $8772434deeb83c74$export$fba63a578e423eb = (0, $bf5b7e7f06fad704$export$fba63a578e423eb);
/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */ const $8772434deeb83c74$export$8a83211c878a3f1f = (0, $bf5b7e7f06fad704$export$8a83211c878a3f1f);
/**
 * Provides data that allows you to change the size of the floating element —
 * for instance, prevent it from overflowing the clipping boundary or match the
 * width of the reference element.
 * @see https://floating-ui.com/docs/size
 */ const $8772434deeb83c74$export$346677f925de839c = (0, $bf5b7e7f06fad704$export$346677f925de839c);
/**
 * Provides data to hide the floating element in applicable situations, such as
 * when it is not in the same clipping context as the reference element.
 * @see https://floating-ui.com/docs/hide
 */ const $8772434deeb83c74$export$fe8985bb6374093c = (0, $bf5b7e7f06fad704$export$fe8985bb6374093c);
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * @see https://floating-ui.com/docs/arrow
 */ const $8772434deeb83c74$export$f2120bbfa5450bd2 = (0, $bf5b7e7f06fad704$export$f2120bbfa5450bd2);
/**
 * Provides improved positioning for inline reference elements that can span
 * over multiple lines, such as hyperlinks or range selections.
 * @see https://floating-ui.com/docs/inline
 */ const $8772434deeb83c74$export$18c8ad048e32c7d5 = (0, $bf5b7e7f06fad704$export$18c8ad048e32c7d5);
/**
 * Built-in `limiter` that will stop `shift()` at a certain point.
 */ const $8772434deeb83c74$export$7bf07e38f3dc4b69 = (0, $bf5b7e7f06fad704$export$7bf07e38f3dc4b69);
/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a given reference element.
 */ const $8772434deeb83c74$export$48a53dcb22e581d0 = (reference, floating, options)=>{
    // This caches the expensive `getClippingElementAncestors` function so that
    // multiple lifecycle resets re-use the same result. It only lives for a
    // single call. If other functions become expensive, we can add them as well.
    const cache = new Map();
    const mergedOptions = {
        platform: $8772434deeb83c74$export$722a64dea1b767dc,
        ...options
    };
    const platformWithCache = {
        ...mergedOptions.platform,
        _c: cache
    };
    return (0, $bf5b7e7f06fad704$export$48a53dcb22e581d0)(reference, floating, {
        ...mergedOptions,
        platform: platformWithCache
    });
};






var $5FkrB = parcelRequire("5FkrB");
var $8518ee13423a8229$export$e001f626511a0ead = /*#__PURE__*/ (0, $5FkrB.createContext)(null);


/* menu-portal-top-layer.tsx generated by @compiled/babel-plugin v2.0.0 */ 


var $5FkrB = parcelRequire("5FkrB");

var $lqU89 = parcelRequire("lqU89");


var $5FkrB = parcelRequire("5FkrB");

var $5FkrB = parcelRequire("5FkrB");
var $fe49d5cc1b441837$export$5fbf4d7fae6cdc00 = /*#__PURE__*/ (0, $5FkrB.createContext)(null);



var $5FkrB = parcelRequire("5FkrB");

var $5FkrB = parcelRequire("5FkrB");
var $97f0905b4f2bf60c$export$644a49f3b8c50fcd = /*#__PURE__*/ (0, $5FkrB.createContext)(null);


function $d08bfbee05be55c8$export$1d57e79091cc3046() {
    var namespace = (0, $5FkrB.useContext)((0, $97f0905b4f2bf60c$export$644a49f3b8c50fcd));
    return namespace;
}


function $1fc181ef4c36ccfd$export$469bb693f11edc7f(_ref) {
    var isOpen = _ref.isOpen, type = _ref.type, onClose = _ref.onClose;
    var context = (0, $5FkrB.useContext)((0, $fe49d5cc1b441837$export$5fbf4d7fae6cdc00));
    var namespace = (0, $d08bfbee05be55c8$export$1d57e79091cc3046)();
    (0, $5FkrB.useEffect)(function() {
        /**
     * Registers the `onClose` callback with the OpenLayerObserver.
     */ if (context === null) return;
        if (!isOpen) /**
       * If the layer is not open, we are not registering the `onClose` callback.
       * This is important to prevent the `onClose` from being called for layers that
       * are not open.
       *
       * Some consumers mistakenly pass "toggle" functions to `onClose` callbacks for
       * layer components, as Popup, e.g. `onClose={() => setIsOpen(!isOpen)}`.
       */ return;
        return context.onClose(onClose, {
            namespace: namespace,
            type: type
        });
    }, [
        context,
        isOpen,
        namespace,
        onClose,
        type
    ]);
}


/* popover.tsx generated by @compiled/babel-plugin v2.0.0 */ /**
 * The length of the value hash portion of an atomic class name.
 * Atomic class names have the format: `_<group><value>`
 * where group is ATOMIC_GROUP_HASH_LENGTH chars and value is ATOMIC_VALUE_HASH_LENGTH chars.
 *
 * We extract the group key using: `className.slice(0, className.length - ATOMIC_VALUE_HASH_LENGTH)`
 *
 * We support both old-format classes (9 chars: `_` + 4 group + 4 value) and
 * new-format classes (11 chars: `_` + 6 group + 4 value) by using length-based
 * extraction rather than a hardcoded offset — old and new format group keys
 * are different lengths so they are structurally disjoint and never alias each other.
 */ const $c68f57b5e85c93a3$var$ATOMIC_VALUE_HASH_LENGTH = 4;
function $c68f57b5e85c93a3$export$2e2bcd8739ae039(classNames) {
    // Shortcut: nothing to do
    if (!classNames.length) return;
    // Shortcut: don't need to do anything if we only have a single classname
    if (classNames.length === 1 && classNames[0] && // checking to see if `classNames[0]` is a string that contains other classnames
    !classNames[0].includes(' ')) return classNames[0];
    // Using an object rather than a `Map` as it performed better in our benchmarks.
    // Would be happy to move to `Map` if it proved to be better under real conditions.
    const map = {};
    // Note: using loops to minimize iterations over the collection
    for (const value of classNames){
        // Exclude all falsy values, which leaves us with populated strings
        if (!value) continue;
        // a `value` can contain multiple classnames
        const list = value.split(' ');
        for (const className of list){
            /**
             * For atomic style classnames: the `key` is the `group`
             *
             * - Later atomic classnames with the same `group` will override earlier ones
             *   (which is what we want).
             * - Assumes atomic classnames are the only things that start with `_`
             * - Could use a regex to ensure that atomic classnames are structured how we expect,
             *   but did not add that for now as it did slow things down a bit.
             *
             * For other classnames: the `key` is the whole classname
             * - Okay to remove duplicates as doing so does not impact specificity
             *
             * */ const key = className.startsWith('_') ? className.slice(0, className.length - $c68f57b5e85c93a3$var$ATOMIC_VALUE_HASH_LENGTH) : className;
            map[key] = className;
        }
    }
    /**
     * We are converting the `map` into a string.
     *
     * The simple way to do this would be `Object.values(map).join(' ')`.
     * However, the approach below performs 10%-20% better in benchmarks.
     *
     * For `ax()` it feels right to squeeze as much runtime performance out as we can.
     */ let result = '';
    for(const key in map)result += map[key] + ' ';
    // If we have an empty string, then our `map` was empty.
    if (!result) return;
    // remove last " " from the result (we added " " at the end of every value)
    return result.trimEnd();
}



var $5FkrB = parcelRequire("5FkrB");

const $0ffa32ceec741bfa$export$a274e22fb40f762e = (...styles)=>{
    // At runtime TStyles is resolved down to strings, but not at compile time.
    // We circumvent the type system here because of that.
    const actualStyles = styles;
    // The output should be a union type of passed in styles. This ensures the call
    // site of xcss prop can raise violations when disallowed styles have been passed.
    return (0, $c68f57b5e85c93a3$export$2e2bcd8739ae039)(actualStyles);
};






var $5FkrB = parcelRequire("5FkrB");

var $5FkrB = parcelRequire("5FkrB");
var $fa9d140c18b5e328$export$5fbf4d7fae6cdc00 = /*#__PURE__*/ (0, $5FkrB.createContext)(null);



var $5FkrB = parcelRequire("5FkrB");

var $5FkrB = parcelRequire("5FkrB");
var $856361fe328bf59e$export$644a49f3b8c50fcd = /*#__PURE__*/ (0, $5FkrB.createContext)(null);


function $3f4c9f00f2392b85$export$1d57e79091cc3046() {
    var namespace = (0, $5FkrB.useContext)((0, $856361fe328bf59e$export$644a49f3b8c50fcd));
    return namespace;
}


function $424c0daf32502f58$export$469bb693f11edc7f(_ref) {
    var isOpen = _ref.isOpen, type = _ref.type, onClose = _ref.onClose;
    var context = (0, $5FkrB.useContext)((0, $fa9d140c18b5e328$export$5fbf4d7fae6cdc00));
    var namespace = (0, $3f4c9f00f2392b85$export$1d57e79091cc3046)();
    (0, $5FkrB.useEffect)(function() {
        /**
     * Registers the `onClose` callback with the OpenLayerObserver.
     */ if (context === null) return;
        if (!isOpen) /**
       * If the layer is not open, we are not registering the `onClose` callback.
       * This is important to prevent the `onClose` from being called for layers that
       * are not open.
       *
       * Some consumers mistakenly pass "toggle" functions to `onClose` callbacks for
       * layer components, as Popup, e.g. `onClose={() => setIsOpen(!isOpen)}`.
       */ return;
        return context.onClose(onClose, {
            namespace: namespace,
            type: type
        });
    }, [
        context,
        isOpen,
        namespace,
        onClose,
        type
    ]);
}


/**
 * Normalizes an offset to a CSS length string. Numbers become `${n}px`;
 * strings pass through. Apply at the API boundary so internal code only
 * deals with strings.
 */ function $1ae86544eb044bcb$export$63b6b0ff65d84d47(_ref) {
    var value = _ref.value;
    if (typeof value === 'number') return "".concat(value, "px");
    return value;
}


/**
 * Default gap between trigger and popover. Resolves to a design
 * token (`space.100`) so the value follows the design system's spacing
 * scale. Used when `placement.offset.gap` is not provided.
 */ var $c0f4a43f9b265e57$var$DEFAULT_GAP = "var(--ds-space-100, 8px)";
function $c0f4a43f9b265e57$export$63044d21bc3d3fa2(_ref) {
    var _placement$offset, _placement$axis, _placement$edge, _placement$align, _placement$offset$cro, _placement$offset2, _placement$offset$cro2, _placement$offset3;
    var placement = _ref.placement;
    var consumerGap = (_placement$offset = placement.offset) === null || _placement$offset === void 0 ? void 0 : _placement$offset.gap;
    return {
        axis: (_placement$axis = placement.axis) !== null && _placement$axis !== void 0 ? _placement$axis : 'block',
        edge: (_placement$edge = placement.edge) !== null && _placement$edge !== void 0 ? _placement$edge : 'end',
        align: (_placement$align = placement.align) !== null && _placement$align !== void 0 ? _placement$align : 'center',
        offset: {
            gap: consumerGap === undefined ? $c0f4a43f9b265e57$var$DEFAULT_GAP : (0, $1ae86544eb044bcb$export$63b6b0ff65d84d47)({
                value: consumerGap
            }),
            crossAxisShift: {
                value: (0, $1ae86544eb044bcb$export$63b6b0ff65d84d47)({
                    value: (_placement$offset$cro = (_placement$offset2 = placement.offset) === null || _placement$offset2 === void 0 || (_placement$offset2 = _placement$offset2.crossAxisShift) === null || _placement$offset2 === void 0 ? void 0 : _placement$offset2.value) !== null && _placement$offset$cro !== void 0 ? _placement$offset$cro : 0
                }),
                direction: (_placement$offset$cro2 = (_placement$offset3 = placement.offset) === null || _placement$offset3 === void 0 || (_placement$offset3 = _placement$offset3.crossAxisShift) === null || _placement$offset3 === void 0 ? void 0 : _placement$offset3.direction) !== null && _placement$offset$cro2 !== void 0 ? _placement$offset$cro2 : 'forwards'
            }
        }
    };
}


/**
 * Valid values for the `aria-haspopup` attribute.
 *
 * Derived from the HTML spec - maps popover roles to what the trigger
 * announces. `undefined` means the attribute is omitted entirely (used for
 * non-popup roles like `tooltip`/`status`/`alert`/`note`/`log` where
 * `aria-haspopup` would be misleading).
 *
 * `true` is intentionally NOT in the union - the runtime only ever produces
 * the explicit string forms, so widening the type would invite consumers to
 * pass `true` and get an `aria-haspopup="true"` serialisation that the
 * runtime no longer emits.
 */ /**
 * Roles that require an accessible name (`label` or `labelledBy`) per WCAG 4.1.2.
 * Without a name, assistive technology cannot identify these landmarks.
 */ /**
 * Roles where the accessible name is derived from content or provided externally
 * (e.g. a combobox labels its listbox, tooltip content IS the accessible name).
 */ // Shared ARIA role discrimination types
//
// These encode the WCAG 4.1.2 constraint: roles like `dialog`, `alertdialog`,
// and `menu` MUST have an accessible name (either `label` or `labelledBy`).
// TypeScript enforces this at compile time via discriminated unions.
/**
 * ARIA role props where a role is always required.
 *
 * Used by `TPopupContentProps`. Popup content must always declare
 * its role so assistive technology can identify the layer.
 */ /**
 * ARIA role props where a role is optional.
 *
 * Used by `TPopoverProps`. The low-level primitive allows omitting
 * the role for cases where it is set externally or not needed.
 */ var $7e296574b5bdc7f9$var$rolesThatMoveFocus = new Set([
    'dialog',
    'alertdialog',
    'menu',
    'listbox',
    'tree',
    'grid'
]);
function $7e296574b5bdc7f9$export$b12adccf56228c71(_ref) {
    var role = _ref.role;
    if (!role) return false;
    return $7e296574b5bdc7f9$var$rolesThatMoveFocus.has(role);
}


function $23145b42c2523325$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return r;
}


function $3707e1f69be881cc$export$2e2bcd8739ae039(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}


function $1e535288ac37221d$export$2e2bcd8739ae039(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}


function $6d9065ee0876b560$export$2e2bcd8739ae039(r, a) {
    if (r) {
        if ("string" == typeof r) return (0, $1e535288ac37221d$export$2e2bcd8739ae039)(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? (0, $1e535288ac37221d$export$2e2bcd8739ae039)(r, a) : void 0;
    }
}


function $6f79f2f14ec4c3f3$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}


function $498719f62abaa9dd$export$2e2bcd8739ae039(r, e) {
    return (0, $23145b42c2523325$export$2e2bcd8739ae039)(r) || (0, $3707e1f69be881cc$export$2e2bcd8739ae039)(r, e) || (0, $6d9065ee0876b560$export$2e2bcd8739ae039)(r, e) || (0, $6f79f2f14ec4c3f3$export$2e2bcd8739ae039)();
}



var $5FkrB = parcelRequire("5FkrB");


var $65229a75d825463b$export$ff7706047246b98b = (0, $86089df3a0fd54eb$export$2e2bcd8739ae039)(function() {
    if (typeof window === 'undefined' || !('matchMedia' in window)) return false;
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
});


/**
 * Using the recommended motion timings for safety net.
 *
 * Not setting these timings on the preset config because they're defined in the CSS,
 * so configuring it in the preset doesn't achieve anything except introduce a potential
 * source of drift.
 *
 * TODO: figure out a way to not need to redeclare these in the future,
 * and keep CSS and JS timings in sync always.
 */ var $883712e9476d07fd$var$safetyNetMsMap = {
    dialog: {
        enter: 250,
        // Corresponds to `motion.duration.long`
        exit: 200 // Corresponds to `motion.duration.medium`
    },
    popover: {
        enter: 150,
        // Corresponds to `motion.duration.short`
        exit: 100 // Corresponds to `motion.duration.xshort`
    }
};
/**
 * Fires `onSettled` once when `transitionend` fires on `element`, or after
 * `safetyNetMs` if the event is swallowed (mid-transition unmount, CSS
 * mismatch, browser quirks). Returns a cleanup that cancels both paths.
 */ function $883712e9476d07fd$var$runOnTransitionEndOrTimeout(_ref) {
    var element = _ref.element, safetyNetMs = _ref.safetyNetMs, onSettled = _ref.onSettled;
    var state = {
        isSettled: false
    };
    function teardown() {
        state.isSettled = true;
        clearTimeout(safetyNetId);
        unbind();
    }
    function settle() {
        if (state.isSettled) return;
        teardown();
        onSettled();
    }
    var unbind = (0, $5b617c1f48263075$exports.bind)(element, {
        type: 'transitionend',
        listener: settle,
        options: {
            once: true
        }
    });
    var safetyNetId = setTimeout(settle, safetyNetMs);
    return teardown;
}
function $883712e9476d07fd$export$1bccb45daf07907f(_ref2) {
    var isOpen = _ref2.isOpen, animationKind = _ref2.animationKind, shouldAnimate = _ref2.shouldAnimate, elementRef = _ref2.elementRef, onEnterFinish = _ref2.onEnterFinish, onExitFinish = _ref2.onExitFinish;
    var willAnimate = shouldAnimate && !(0, $65229a75d825463b$export$ff7706047246b98b)();
    // Promote `closed → entering`/`closed → open` synchronously during
    // render so the host element mounts in the same commit as the open
    // intent. All other transitions are driven by phase-specific effects.
    var _useState = (0, $5FkrB.useState)(function() {
        if (!isOpen) return 'closed';
        return willAnimate ? 'entering' : 'open';
    }), _useState2 = (0, $498719f62abaa9dd$export$2e2bcd8739ae039)(_useState, 2), phase = _useState2[0], setPhase = _useState2[1];
    if (isOpen && phase === 'closed') setPhase(willAnimate ? 'entering' : 'open');
    if (!isOpen && (phase === 'open' || phase === 'entering')) // Close intent. Move to `exiting` to gate the unmount on either
    // the exit transition (animated) or the toggle/close event
    // (non-animated). Includes interrupted entry (`entering → exiting`).
    setPhase('exiting');
    if (isOpen && phase === 'exiting') // Reopen mid-exit. With animation, jump back to `entering` and let
    // the entry transition restart from current visual state. Without
    // animation, jump straight to `open` (the handshake we were waiting
    // for is no longer relevant; the consumer wants the host visible
    // again synchronously).
    setPhase(willAnimate ? 'entering' : 'open');
    // Keep stable refs to the latest callbacks so effects and timeout closures
    // always call the current callback without needing them in dependency arrays.
    var onEnterFinishRef = (0, $5FkrB.useRef)(onEnterFinish);
    onEnterFinishRef.current = onEnterFinish;
    var onExitFinishRef = (0, $5FkrB.useRef)(onExitFinish);
    onExitFinishRef.current = onExitFinish;
    // Animated entry: wait for `transitionend` (or a safety-net timeout) and
    // move to `open`. The fallback guarantees settle on swallowed events
    // (zero-duration, browser quirk, mid-transition unmount).
    (0, $5FkrB.useEffect)(function() {
        if (phase !== 'entering') return;
        var element = elementRef.current;
        if (!element) return;
        return $883712e9476d07fd$var$runOnTransitionEndOrTimeout({
            element: element,
            safetyNetMs: $883712e9476d07fd$var$safetyNetMsMap[animationKind].enter + 50,
            onSettled: function onSettled() {
                var _onEnterFinishRef$cur;
                // Fire the consumer callback before transitioning phase so any
                // state the consumer reads (refs, DOM nodes) is still attached
                // in the same synchronous tick, regardless of React batching
                // semantics.
                (_onEnterFinishRef$cur = onEnterFinishRef.current) === null || _onEnterFinishRef$cur === void 0 || _onEnterFinishRef$cur.call(onEnterFinishRef);
                setPhase(function(current) {
                    return current === 'entering' ? 'open' : current;
                });
            }
        });
    }, [
        phase,
        animationKind,
        elementRef
    ]);
    // Non-animated entry callback. The lifecycle goes `closed → open`
    // directly with no `entering` phase; fire `onEnterFinish` on that jump.
    // A previous-phase ref avoids double-firing on the animated path.
    var prevPhaseForEntryRef = (0, $5FkrB.useRef)('closed');
    (0, $5FkrB.useEffect)(function() {
        var prevPhase = prevPhaseForEntryRef.current;
        prevPhaseForEntryRef.current = phase;
        // Animated entry settle goes through `entering` and already fired
        // onEnterFinish above; only handle the non-animated direct jumps.
        if (prevPhase !== 'open' && phase === 'open' && prevPhase !== 'entering') {
            var _onEnterFinishRef$cur2;
            (_onEnterFinishRef$cur2 = onEnterFinishRef.current) === null || _onEnterFinishRef$cur2 === void 0 || _onEnterFinishRef$cur2.call(onEnterFinishRef);
        }
    }, [
        phase
    ]);
    // Animated exit: wait for `transitionend` (or a safety-net timeout),
    // fire `onExitFinish`, then move to `closed` to unmount the host.
    (0, $5FkrB.useEffect)(function() {
        if (phase !== 'exiting' || !willAnimate) return;
        var element = elementRef.current;
        if (!element) return;
        return $883712e9476d07fd$var$runOnTransitionEndOrTimeout({
            element: element,
            safetyNetMs: $883712e9476d07fd$var$safetyNetMsMap[animationKind].exit + 50,
            onSettled: function onSettled() {
                var _onExitFinishRef$curr;
                // Fire the consumer callback before transitioning phase to
                // `closed`. The phase change drives the host element unmount,
                // and consumers expect to be able to read the element (or a
                // forwarded ref to it) inside `onExitFinish`. Doing this in
                // the safe order avoids relying on React's automatic batching
                // to keep the element attached across the callback.
                (_onExitFinishRef$curr = onExitFinishRef.current) === null || _onExitFinishRef$curr === void 0 || _onExitFinishRef$curr.call(onExitFinishRef);
                setPhase(function(current) {
                    return current === 'exiting' ? 'closed' : current;
                });
            }
        });
    }, [
        phase,
        willAnimate,
        animationKind,
        elementRef
    ]);
    // Non-animated exit: wait for the browser's `toggle` (closed) or
    // `close` event before unmounting, so the consumer's listener (close
    // reason, nested focus restoration, `onClose`) and the browser's
    // native focus restoration both run against the still-attached
    // element. A naive `setTimeout(0)` occasionally beats the `toggle`
    // task in Chromium and drops focus restoration.
    //
    // `useLayoutEffect` so the listener binds in the same commit as the
    // show/hide layout effect that calls `hidePopover()` / `dialog.close()`.
    // The toggle/close event is queued as a task and cannot run until the
    // frame completes. SSR-safe: `phase` starts at `'closed'`.
    //
    // `onExitFinish` is fired separately (see effect below) so consumers
    // observe it the moment `isOpen` flips to `false`.
    (0, $5FkrB.useLayoutEffect)(function() {
        if (phase !== 'exiting' || willAnimate) return;
        var element = elementRef.current;
        if (!element) return;
        function unmount() {
            setPhase(function(current) {
                return current === 'exiting' ? 'closed' : current;
            });
        }
        return (0, $5b617c1f48263075$exports.bindAll)(element, [
            {
                type: 'toggle',
                listener: function listener(event) {
                    if (event.newState === 'closed') unmount();
                }
            },
            {
                type: 'close',
                listener: unmount
            }
        ]);
    }, [
        phase,
        willAnimate,
        elementRef
    ]);
    // Non-animated exit callback. No `transitionend` to wait for, so fire
    // `onExitFinish` on the transition into `exiting` (the unmount itself
    // is gated by the toggle/close handshake above).
    var prevPhaseForExitRef = (0, $5FkrB.useRef)('closed');
    (0, $5FkrB.useEffect)(function() {
        var prevPhase = prevPhaseForExitRef.current;
        prevPhaseForExitRef.current = phase;
        // Only fire on the non-animated transition into `exiting`. The
        // animated path's `exiting → closed` settle already fires
        // `onExitFinish` from `runOnTransitionEndOrTimeout`.
        if (prevPhase !== 'exiting' && phase === 'exiting' && !willAnimate) {
            var _onExitFinishRef$curr2;
            (_onExitFinishRef$curr2 = onExitFinishRef.current) === null || _onExitFinishRef$curr2 === void 0 || _onExitFinishRef$curr2.call(onExitFinishRef);
        }
    }, [
        phase,
        willAnimate
    ]);
    return {
        phase: phase
    };
}



var $5FkrB = parcelRequire("5FkrB");

var $3a57494a3bca49a3$var$topLayerSelector = '[popover], dialog, [role="dialog"], [role="alertdialog"]';
function $3a57494a3bca49a3$export$df8c72c64edc7260(_ref) {
    var element = _ref.element, container = _ref.container;
    var elementLayer = element.closest($3a57494a3bca49a3$var$topLayerSelector);
    var containerLayer = container.closest($3a57494a3bca49a3$var$topLayerSelector);
    // Both elements are in the "document" layer
    if (!elementLayer && !containerLayer) return true;
    return elementLayer === containerLayer;
}


var $05d182eb71ed8b24$export$e1252723db1c541 = function() {
    // Common exclusion filter applied to every selector.
    var not = ':not([tabindex="-1"]):not([aria-disabled="true"]):not([aria-hidden="true"])';
    var notDisabled = ":not([disabled])".concat(not);
    var focusable = [
        "a[href]".concat(not),
        "area[href]".concat(not),
        "input".concat(notDisabled, ":not([type=\"hidden\"])"),
        "select".concat(notDisabled),
        "textarea".concat(notDisabled),
        "button".concat(notDisabled),
        "iframe".concat(not),
        "audio[controls]".concat(not),
        "video[controls]".concat(not),
        "[contenteditable]:not([contenteditable=\"false\"])".concat(not),
        "[tabindex]".concat(notDisabled).concat(not)
    ];
    return {
        focusable: focusable.join(','),
        // Build the `:focus` selector
        focused: focusable.map(function(selector) {
            return "".concat(selector, ":focus");
        }).join(',')
    };
}();


function $299cfa132c9e1828$export$f6768025e418420e(_ref) {
    var container = _ref.container, filter = _ref.filter;
    return Array.from(container.querySelectorAll((0, $05d182eb71ed8b24$export$e1252723db1c541).focusable)).filter(function(element) {
        return element instanceof HTMLElement;
    }).filter(function(element) {
        return (0, $3a57494a3bca49a3$export$df8c72c64edc7260)({
            element: element,
            container: container
        });
    }).filter(function(element) {
        return !filter || filter(element, container);
    });
}


function $3f9c8d151769ee3c$export$748138f04a69bf21(_ref) {
    var container = _ref.container, filter = _ref.filter;
    var items = (0, $299cfa132c9e1828$export$f6768025e418420e)({
        container: container,
        filter: filter
    });
    return items.length > 0 ? items[0] : null;
}



function $ef3349efa77457d0$export$73e81fa65335a75b(_ref) {
    var container = _ref.container, filter = _ref.filter;
    var items = (0, $299cfa132c9e1828$export$f6768025e418420e)({
        container: container,
        filter: filter
    });
    return items.length > 0 ? items[items.length - 1] : null;
}


/**
 * Returns the next focusable element in the given direction relative to the
 * currently focused element within the container. Wraps around at both ends.
 *
 * Returns `null` if there is no focused element within the container or if
 * the focused element is not in the list of focusable elements.
 */ 

function $5fdc32a6b487df5e$export$a7db88e6d491b450(_ref) {
    var _all$nextIndex;
    var container = _ref.container, direction = _ref.direction, filter = _ref.filter;
    var all = (0, $299cfa132c9e1828$export$f6768025e418420e)({
        container: container,
        filter: filter
    });
    var current = container.querySelector((0, $05d182eb71ed8b24$export$e1252723db1c541).focused);
    if (!(current instanceof HTMLElement)) return null;
    var index = all.indexOf(current);
    if (index === -1) return null;
    var nextIndex = function() {
        if (direction === 'forwards') return (index + 1) % all.length;
        var proposed = index - 1;
        // if going into negative numbers, loop back to the last item
        return proposed < 0 ? all.length - 1 : proposed;
    }();
    return (_all$nextIndex = all[nextIndex]) !== null && _all$nextIndex !== void 0 ? _all$nextIndex : null;
}




function $848606d379414d8a$export$b9590fdfeb5f722f(_ref) {
    var _getDocument;
    var container = _ref.container;
    var focused = (_getDocument = (0, $fc5ac9c99de29fbb$export$f65ca476c09acec0)()) === null || _getDocument === void 0 ? void 0 : _getDocument.activeElement;
    if (!(focused instanceof HTMLElement)) return false;
    // Cannot be in a nested layer if it is not in the container
    if (!container.contains(focused)) return false;
    // If not in the same layer, must be in a nested layer
    return !(0, $3a57494a3bca49a3$export$df8c72c64edc7260)({
        element: focused,
        container: container
    });
}


/**
 * Roles that require focus wrapping per WAI-ARIA APG.
 *
 * - `dialog`: https://www.w3.org/WAI/ARIA/apg/patterns/dialog-modal/
 * - `alertdialog`: same keyboard pattern as dialog
 *
 * `menu` is intentionally excluded. Menus are composite widgets
 * (https://www.w3.org/WAI/ARIA/apg/practices/keyboard-interface/#kbd_general_within)
 * that manage their own internal keyboard navigation via arrow keys,
 * not Tab. Tab/Shift+Tab should move focus OUT of a menu entirely.
 *
 * Menu keyboard behavior (arrow keys, Home/End, type-ahead, Enter/Space)
 * is context-dependent. It varies by orientation, nesting depth, item
 * type, and control pattern (menu button vs menubar). This makes it
 * impossible to implement generically here. The consumer component
 * (e.g. `dropdown-menu`) owns all menu keyboard navigation.
 *
 * See: notes/outputs/menu-keyboard-decision.md
 */ function $87087ade644f5fc5$var$roleRequiresFocusWrap(role) {
    return role === 'dialog' || role === 'alertdialog';
}
function $87087ade644f5fc5$export$4f6462e86a70abe5(_ref) {
    var elementRef = _ref.elementRef, role = _ref.role, phase = _ref.phase;
    var isVisible = phase !== 'closed';
    (0, $5FkrB.useEffect)(function() {
        var element = elementRef.current;
        if (!element || !$87087ade644f5fc5$var$roleRequiresFocusWrap(role) || !isVisible) return;
        var unbind = (0, $5b617c1f48263075$exports.bind)(element, {
            type: 'keydown',
            listener: function listener(event) {
                if (event.key !== 'Tab') return;
                // If focus is already in a nested layer, then
                // we continue to let that nested layer own focus
                if ((0, $848606d379414d8a$export$b9590fdfeb5f722f)({
                    container: element
                })) return;
                // Prevent the browser giving focus to where it wants to
                // (we will be handling it, including with wrapping)
                event.preventDefault();
                var direction = event.shiftKey ? 'backwards' : 'forwards';
                // Try to move to the next/previous focusable element relative
                // to the currently focused element within the container.
                var next = (0, $5fdc32a6b487df5e$export$a7db88e6d491b450)({
                    container: element,
                    direction: direction
                });
                if (next) {
                    next.focus();
                    return;
                }
                // Nothing is currently focused inside the container (or the
                // focused element is not in the focusable list). Fall back to
                // the first or last focusable element depending on direction.
                var fallback = direction === 'forwards' ? (0, $3f9c8d151769ee3c$export$748138f04a69bf21)({
                    container: element
                }) : (0, $ef3349efa77457d0$export$73e81fa65335a75b)({
                    container: element
                });
                if (fallback) fallback.focus();
            },
            options: {
                capture: true
            }
        });
        return unbind;
    }, [
        elementRef,
        role,
        isVisible
    ]);
}



var $5FkrB = parcelRequire("5FkrB");

/**
 * Determines the correct element to receive initial focus within a popover,
 * based on its ARIA role.
 *
 * Focus rules by role (per WAI-ARIA APG):
 * - `dialog` / `alertdialog`: first element with `[autofocus]`, or first focusable element
 * - `menu`: first menu item (`[role="menuitem|menuitemcheckbox|menuitemradio"]`)
 * - `listbox`: first selected option (`[aria-selected="true"]`), or first option (`[role="option"]`)
 * - `tooltip`: no focus movement (tooltips are informational)
 * - no role / other roles: no focus movement
 *
 * Note: React 18's `autoFocus` JSX prop does NOT set the HTML `autofocus`
 * attribute - it only calls `.focus()` imperatively during commit, which
 * has no effect on hidden popover content. Consumers must set the native
 * attribute via a ref callback (e.g. `node.setAttribute('autofocus', '')`).
 * React 19+ reflects the JSX prop as the HTML attribute automatically.
 *
 * Combobox pattern exception: if the popup is controlled by a focused
 * combobox-like trigger (its `aria-controls` references this popup),
 * focus stays on the textbox regardless of role. See
 * `isComboboxControllingPopup`.
 */ /**
 * WAI-ARIA APG Combobox Pattern: when a combobox controls a popup (listbox,
 * grid, tree, or menu), DOM focus must remain on the textbox. Subsequent
 * navigation through popup items uses `aria-activedescendant` (or proxied
 * keyboard events), never DOM focus movement.
 *
 * Detects both variants in a single pass:
 * - In-popup combobox: the textbox lives inside the popup `container`
 *   (the popup is rendered as a child of the combobox wrapper).
 * - External combobox: the textbox is rendered OUTSIDE the popup
 *   (`react-select` pattern, where the listbox is portalled separately
 *   from the textbox).
 *
 * Acceptance criteria for the active element:
 * - Role / element-type filter: `role="combobox"`, `role="textbox"`,
 *   `TEXTAREA`, `contentEditable`, or `INPUT` of text-like type
 *   (`text`, `search`, `email`, `url`, `tel`, `password`, or
 *   unspecified). Non-text input types (`button`, `checkbox`, etc.)
 *   are rejected.
 * - Reference filter: `aria-controls` (or legacy `aria-owns`) IDREFS
 *   must resolve to an element that IS or CONTAINS the popup container.
 *
 * See: https://www.w3.org/WAI/ARIA/apg/patterns/combobox/
 */ // `<input>` types treated as text-like for combobox detection.
// Non-text input types (`button`, `checkbox`, `submit`, etc.) are rejected.
// A missing `type` attribute defaults to `text` per the HTML spec, so we
// normalize that case before lookup rather than including an empty string here.
var $7771da85be1872e6$var$TEXT_LIKE_INPUT_TYPES = new Set([
    'text',
    'search',
    'email',
    'url',
    'tel',
    'password'
]);
function $7771da85be1872e6$var$isTextboxLikeElement(element) {
    var role = element.getAttribute('role');
    if (role === 'combobox' || role === 'textbox') return true;
    // `tagName` is uppercase for HTML elements but can be mixed-case for
    // XML/SVG. Normalize once so downstream comparisons stay lowercase.
    var tag = element.tagName.toLowerCase();
    if (tag === 'textarea') return true;
    if (element.isContentEditable) return true;
    if (tag === 'input') {
        var _element$getAttribute;
        var type = ((_element$getAttribute = element.getAttribute('type')) !== null && _element$getAttribute !== void 0 ? _element$getAttribute : 'text').toLowerCase();
        return $7771da85be1872e6$var$TEXT_LIKE_INPUT_TYPES.has(type);
    }
    return false;
}
function $7771da85be1872e6$var$isComboboxControllingPopup(_ref) {
    var _active$getAttribute;
    var container = _ref.container;
    var ownerDocument = container.ownerDocument;
    var active = ownerDocument.activeElement;
    if (!(active instanceof HTMLElement)) return false;
    if (!$7771da85be1872e6$var$isTextboxLikeElement(active)) return false;
    // Accept legacy `aria-owns` in addition to `aria-controls`.
    // `aria-controls` / `aria-owns` are IDREFS (space-separated list of IDs)
    // per the WAI-ARIA spec, so we must split and check membership rather
    // than comparing with strict equality. A combobox that controls both
    // this popup and another element (e.g. a results status region) must
    // still be recognised as controlling this popup.
    var idRefs = (_active$getAttribute = active.getAttribute('aria-controls')) !== null && _active$getAttribute !== void 0 ? _active$getAttribute : active.getAttribute('aria-owns');
    if (!idRefs) return false;
    // Match if any referenced element IS, CONTAINS, or IS CONTAINED BY the
    // popup container. The "contained by" case covers wrapper-style adopters
    // like react-select, where the combobox input's `aria-controls` points at
    // a listbox element that is a descendant of the Popover host (the
    // listbox role lives on a child the wrapped library owns, not on the
    // host we render).
    var referencedIds = idRefs.split(/\s+/).filter(function(id) {
        return id !== '';
    });
    return referencedIds.some(function(id) {
        var referenced = ownerDocument.getElementById(id);
        if (!referenced) return false;
        return referenced === container || referenced.contains(container) || container.contains(referenced);
    });
}
function $7771da85be1872e6$var$getInitialFocusTarget(_ref2) {
    var container = _ref2.container, role = _ref2.role;
    if (role === 'dialog' || role === 'alertdialog') {
        // Prefer element with the native HTML autofocus attribute.
        var autofocusEl = container.querySelector('[autofocus]');
        if (autofocusEl) return autofocusEl;
        // Fall back to first focusable element
        return (0, $3f9c8d151769ee3c$export$748138f04a69bf21)({
            container: container
        });
    }
    // The combobox carve-out is kept role-specific (menu / listbox) rather
    // than hoisted. Hoisting it over-matched on dialog popups that contain
    // a nested combobox (e.g. datetime-picker's dialog hosts a react-select),
    // where the active combobox's `aria-controls` falsely matched the
    // container and suppressed the dialog's own focus contract.
    if (role === 'menu') {
        if ($7771da85be1872e6$var$isComboboxControllingPopup({
            container: container
        })) return null;
        // Initial focus placement is the extent of what top-layer provides
        // for menus. All subsequent keyboard navigation (arrow keys, Home/End,
        // type-ahead, Enter/Space, submenu coordination) is the responsibility
        // of the consumer component (e.g. dropdown-menu), because menu keyboard
        // behavior varies by context (orientation, nesting, item type, control
        // pattern). See: notes/outputs/menu-keyboard-decision.md
        return (0, $3f9c8d151769ee3c$export$748138f04a69bf21)({
            container: container
        });
    }
    if (role === 'listbox') {
        // ARIA Combobox Pattern: if a combobox-like textbox owns the popup
        // (in-popup or external e.g. react-select), leave focus on the
        // textbox - navigation is proxied through it.
        if ($7771da85be1872e6$var$isComboboxControllingPopup({
            container: container
        })) return null;
        // Prefer the selected option, then fall back to the first option.
        // We intentionally match by `[role="option"]` rather than by
        // `getFirstFocusable`. The standard WAI-ARIA APG listbox pattern
        // renders options with `tabindex="-1"` (managed via roving
        // tabindex); `getFirstFocusable` excludes `tabindex="-1"` elements
        // and would silently lose initial focus for spec-conformant
        // listboxes. Options remain programmatically focusable.
        var selectedOption = container.querySelector('[role="option"][aria-selected="true"]');
        if (selectedOption) return selectedOption;
        var firstOption = container.querySelector('[role="option"]');
        if (firstOption) return firstOption;
        // Last resort for non-standard listboxes that render no options
        // but do contain a focusable element (e.g. an empty-state action).
        return (0, $3f9c8d151769ee3c$export$748138f04a69bf21)({
            container: container
        });
    }
    // tooltip, no role, or other roles: no focus movement
    return null;
}
function $7771da85be1872e6$export$e992c40175757a22(_ref3) {
    var elementRef = _ref3.elementRef, phase = _ref3.phase, role = _ref3.role;
    // Track the previous phase so we only focus on transitions into a
    // visible phase from either `'closed'` (fresh mount) or `'exiting'`
    // (mid-exit reopen where the browser has already restored focus to
    // the trigger). Pure `entering → exiting → entering` stutters where
    // the consumer toggles in the same frame are still collapsed.
    var prevPhaseRef = (0, $5FkrB.useRef)('closed');
    (0, $5FkrB.useEffect)(function() {
        var _getInitialFocusTarge;
        var prevPhase = prevPhaseRef.current;
        prevPhaseRef.current = phase;
        // Only focus on transitions into a visible phase from `'closed'`
        // (fresh open) or `'exiting'` (mid-exit reopen).
        if (phase === 'closed') return;
        if (prevPhase !== 'closed' && prevPhase !== 'exiting') return;
        var element = elementRef.current;
        if (!element) return;
        (_getInitialFocusTarge = $7771da85be1872e6$var$getInitialFocusTarget({
            container: element,
            role: role
        })) === null || _getInitialFocusTarge === void 0 || _getInitialFocusTarge.focus();
    }, [
        elementRef,
        phase,
        role
    ]);
}


/**
 * Detects `popover="hint"` support via DOM reflection. SSR-safe, cached.
 */ var $516e5dff5af04da6$var$supportsPopoverHint = (0, $86089df3a0fd54eb$export$2e2bcd8739ae039)(function() {
    if (typeof document === 'undefined') return false;
    // eslint-disable-next-line @atlaskit/platform/no-direct-document-usage -- feature detection
    var element = document.createElement('div');
    element.setAttribute('popover', 'hint');
    return element.popover === 'hint';
});
// Surface reset — neutralises inherited text-layout properties (e.g.
// `white-space: nowrap` from an `@atlaskit/select` option) that leak into a
// top-layer element because, for CSS inheritance, it is still a DOM child of its
// trigger (top-layer promotion is paint/stacking only; the legacy portal path
// avoided this by rendering at `<body>`). Excludes `color`/`font` (theming) and
// `direction`/`unicode-bidi` (RTL must inherit).
//
// KEEP IN SYNC with the identical `surfaceResetStyles` in `dialog/dialog-content.tsx`.
// ADS forbids sharing styles across files (`no-exported-styles` /
// `no-imported-style-values` — Compiled styles are null at runtime), so the reset is
// co-located and duplicated deliberately.
var $516e5dff5af04da6$var$surfaceResetStyles = {
    root: "_o5724jg8 _1nmz4jg8 _1i4q4jg8 _y3gnv2br _azhwidpf _1p1dglyw"
};
var $516e5dff5af04da6$var$styles = {
    root: "_19itglyw _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19pkidpf _2hwxidpf _otyridpf _18u0idpf _1r041wug _1reoewfl _18m9ewfl _bfhk1j28 _4t3i1wug",
    motion: "_k8m011k7 _1oecdn4k _1s9z1a5r _1o511hrf _bl8aglyw _156y147i",
    enter: "_y44v179n",
    exit: "_y44vof1f"
};
// Intentionally using `Record<string, string>` instead of `React.CSSProperties`
// to avoid type errors about the CSS variables not being valid property names
var $516e5dff5af04da6$var$popupMotionStyles = {
    block: {
        start: {
            '--ds-popover-motion-enter': "var(--ds-popup-enter-top, 150ms cubic-bezier(0.4, 1, 0.6, 1) SlideInTop8px, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn0to100)",
            '--ds-popover-motion-exit': "var(--ds-popup-exit-top, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) SlideOutTop8px, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)"
        },
        end: {
            '--ds-popover-motion-enter': "var(--ds-popup-enter-bottom, 150ms cubic-bezier(0.4, 1, 0.6, 1) SlideInBottom8px, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn0to100)",
            '--ds-popover-motion-exit': "var(--ds-popup-exit-bottom, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) SlideOutBottom8px, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)"
        }
    },
    inline: {
        start: {
            '--ds-popover-motion-enter': "var(--ds-popup-enter-left, 150ms cubic-bezier(0.4, 1, 0.6, 1) SlideInLeft8px, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn0to100)",
            '--ds-popover-motion-exit': "var(--ds-popup-exit-left, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) SlideOutLeft8px, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)"
        },
        end: {
            '--ds-popover-motion-enter': "var(--ds-popup-enter-right, 150ms cubic-bezier(0.4, 1, 0.6, 1) SlideInRight8px, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn0to100)",
            '--ds-popover-motion-exit': "var(--ds-popup-exit-right, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) SlideOutRight8px, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)"
        }
    }
};
/**
 * Roles registered with the open layer observer as `popup`, so `closeLayers()`
 * dismisses them. `modal` comes from Dialog only; other layer types are unused.
 */ var $516e5dff5af04da6$var$POPUP_ROLES = new Set([
    'menu',
    'listbox',
    'dialog',
    'alertdialog',
    'tree',
    'grid'
]);
var $516e5dff5af04da6$export$5b6b19405a83ff9d = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function Popover(_ref, ref) {
    var children = _ref.children, _ref$mode = _ref.mode, modeProp = _ref$mode === void 0 ? 'auto' : _ref$mode, onClose = _ref.onClose, onEnterFinish = _ref.onEnterFinish, onExitFinish = _ref.onExitFinish, _ref$shouldAnimate = _ref.shouldAnimate, shouldAnimate = _ref$shouldAnimate === void 0 ? false : _ref$shouldAnimate, placement = _ref.placement, testId = _ref.testId, isOpen = _ref.isOpen, enteringAnimationXcss = _ref.enteringAnimationXcss, exitingAnimationXcss = _ref.exitingAnimationXcss, role = _ref.role, label = _ref.label, labelledBy = _ref.labelledBy, idProp = _ref.id;
    var autoId = (0, $5FkrB.useId)();
    var ownRef = (0, $5FkrB.useRef)(null);
    var combinedRef = (0, $db13a2f91f6a0f56$export$2e2bcd8739ae039)([
        ownRef,
        ref
    ].filter(Boolean));
    // `useId()` colons are invalid in CSS selectors and popover target attributes.
    var popoverId = idProp !== null && idProp !== void 0 ? idProp : "popover-".concat(autoId.replace(/:/g, ''));
    var _useAnimatedVisibilit = (0, $883712e9476d07fd$export$1bccb45daf07907f)({
        isOpen: isOpen,
        animationKind: 'popover',
        shouldAnimate: shouldAnimate,
        elementRef: ownRef,
        onEnterFinish: onEnterFinish,
        onExitFinish: onExitFinish
    }), phase = _useAnimatedVisibilit.phase;
    // True while the host element is mounted (any phase except `closed`).
    // Used as a dep so listener-rebind effects re-attach after a remount.
    var isVisible = phase !== 'closed';
    // Focus management: initial focus on entry (role-dependent), Tab cycling
    // for dialog roles. Restoration is native for outermost popovers; nested
    // focus-capturing roles are handled below via the `beforetoggle` snapshot.
    // Passing `phase` keeps `useFocusWrap` attached through the animated-exit
    // window (WCAG 2.4.3 guard). See notes/architecture/focus-restoration.md.
    (0, $87087ade644f5fc5$export$4f6462e86a70abe5)({
        elementRef: ownRef,
        role: role,
        phase: phase
    });
    (0, $7771da85be1872e6$export$e992c40175757a22)({
        elementRef: ownRef,
        phase: phase,
        role: role
    });
    // Register with open layer observer so `closeLayers()` and open-count
    // subscriptions work. Only popup-like roles register as `popup`; passive
    // roles (tooltip, status, etc.) leave `type` undefined.
    var handleObserverClose = (0, $5FkrB.useCallback)(function() {
        onClose === null || onClose === void 0 || onClose({
            reason: 'programmatic'
        });
    }, [
        onClose
    ]);
    (0, $424c0daf32502f58$export$469bb693f11edc7f)({
        type: role && $516e5dff5af04da6$var$POPUP_ROLES.has(role) ? 'popup' : undefined,
        isOpen: isOpen,
        onClose: handleObserverClose
    });
    // `hint` falls back to `auto` when unsupported: closest behavior (light
    // dismiss works), but `auto` participates in the auto-dismiss stack so it
    // will close other `auto` popovers when opened. Acceptable trade-off given
    // shrinking browser set without `hint` support.
    var mode = modeProp === 'hint' && !$516e5dff5af04da6$var$supportsPopoverHint() ? 'auto' : modeProp;
    var popupMotionStyle = (0, $5FkrB.useMemo)(function() {
        if (!placement || !shouldAnimate) return undefined;
        var _resolvePlacement = (0, $c0f4a43f9b265e57$export$63044d21bc3d3fa2)({
            placement: placement
        }), axis = _resolvePlacement.axis, edge = _resolvePlacement.edge;
        return $516e5dff5af04da6$var$popupMotionStyles[axis][edge];
    }, [
        placement,
        shouldAnimate
    ]);
    // Prevents toggle handler from calling onClose for our own hidePopover() calls.
    var programmaticCloseRef = (0, $5FkrB.useRef)(false);
    // Set in capture-phase keydown so the toggle handler knows close reason.
    var closeReasonRef = (0, $5FkrB.useRef)('light-dismiss');
    // Snapshot of pre-open focus, used to restore focus for nested popovers
    // with focus-capturing roles (browser only restores the outermost).
    var previouslyFocusedElementRef = (0, $5FkrB.useRef)(null);
    var handleBeforeToggle = (0, $5FkrB.useCallback)(function(event) {
        if (event.newState !== 'open') return;
        // eslint-disable-next-line @atlaskit/platform/no-direct-document-usage -- need active element snapshot
        var active = document.activeElement;
        previouslyFocusedElementRef.current = active instanceof HTMLElement ? active : null;
    }, []);
    var handleToggle = (0, $5FkrB.useCallback)(function(event) {
        var element = ownRef.current;
        if (event.newState === 'open') return;
        if (event.newState === 'closed') {
            if (element) {
                // Nested-popover focus restoration fallback (browser only
                // restores outermost; Firefox skips nested entirely).
                // Restore only when the role moved focus in on open AND the
                // close was Escape/programmatic. For light dismiss, the
                // click target keeps focus per HTML spec
                // (`focusPreviousElement=false`).
                var previouslyFocused = previouslyFocusedElementRef.current;
                var _reason = closeReasonRef.current;
                var isProgrammatic = programmaticCloseRef.current;
                var shouldRestore = previouslyFocused !== null && previouslyFocused.isConnected && (0, $7e296574b5bdc7f9$export$b12adccf56228c71)({
                    role: role
                }) && (_reason === 'escape' || isProgrammatic);
                if (shouldRestore && previouslyFocused) previouslyFocused.focus({
                    preventScroll: true
                });
                previouslyFocusedElementRef.current = null;
            }
            // Programmatic close: consumer already knows.
            if (programmaticCloseRef.current) {
                // Reset reason so a stale 'escape' from a race with Escape keydown
                // does not corrupt the next browser-dismiss cycle.
                closeReasonRef.current = 'light-dismiss';
                return;
            }
            // Browser dismiss (Escape/click-outside).
            var reason = closeReasonRef.current;
            closeReasonRef.current = 'light-dismiss';
            // Optional: `manual` mode has no `onClose` in the forwarded type.
            onClose === null || onClose === void 0 || onClose({
                reason: reason
            });
        }
    }, [
        onClose,
        role
    ]);
    // Bind via `useLayoutEffect`, and BEFORE the show/hide layout effect
    // below, so listeners are attached when `showPopover()` synchronously
    // dispatches `beforetoggle`. A regular `useEffect` would miss that
    // first dispatch, dropping the `previouslyFocusedElementRef` snapshot
    // and breaking nested-popover focus restoration on close. React runs
    // layout effects in source order on the same commit.
    (0, $5FkrB.useLayoutEffect)(function() {
        var element = ownRef.current;
        if (!element) return;
        // Tag Escape before the browser processes light dismiss.
        var unbindEscape = (0, $5b617c1f48263075$exports.bind)(element, {
            type: 'keydown',
            listener: function listener(event) {
                if (event.key === 'Escape') closeReasonRef.current = 'escape';
            },
            options: {
                capture: true
            }
        });
        var unbindToggle = (0, $5b617c1f48263075$exports.bind)(element, {
            type: 'toggle',
            listener: handleToggle
        });
        // Snapshot `document.activeElement` before `useInitialFocus` moves it.
        var unbindBeforeToggle = (0, $5b617c1f48263075$exports.bind)(element, {
            type: 'beforetoggle',
            listener: handleBeforeToggle
        });
        return function() {
            unbindEscape();
            unbindToggle();
            unbindBeforeToggle();
        };
    }, [
        handleToggle,
        handleBeforeToggle,
        isVisible
    ]);
    // Show/hide based on isOpen. `showPopover`/`hidePopover` are no-ops when
    // already in the target state. Try/catch guards `InvalidStateError` on
    // disconnected elements (StrictMode/concurrent/unmount edge cases).
    (0, $5FkrB.useLayoutEffect)(function() {
        var element = ownRef.current;
        if (!element) return;
        if (isOpen) {
            programmaticCloseRef.current = false;
            // Clear stale 'escape' from a prior cycle: the ref outlives
            // the host element, and the no-animation path unmounts before
            // `handleToggle` can reset it.
            closeReasonRef.current = 'light-dismiss';
            try {
                element.showPopover();
            } catch (_unused) {}
            return function() {
                programmaticCloseRef.current = true;
                try {
                    element.hidePopover();
                } catch (_unused2) {}
            };
        }
        programmaticCloseRef.current = true;
        try {
            element.hidePopover();
        } catch (_unused3) {}
    }, [
        isOpen
    ]);
    // Unmount the host once exit completes so it does not leave an empty
    // `role`/`popover` element in the accessibility tree. The element
    // remounts on the next open; the `popoverId` is stable across opens.
    if (!isVisible) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("div", {
        ref: combinedRef,
        id: popoverId,
        popover: mode,
        role: role,
        "aria-label": label,
        "aria-labelledby": labelledBy,
        "data-testid": testId,
        style: popupMotionStyle,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $c68f57b5e85c93a3$export$2e2bcd8739ae039)([
            $516e5dff5af04da6$var$styles.root,
            $516e5dff5af04da6$var$surfaceResetStyles.root,
            shouldAnimate && phase === 'entering' && $516e5dff5af04da6$var$styles.enter,
            shouldAnimate && phase === 'exiting' && $516e5dff5af04da6$var$styles.exit,
            shouldAnimate && $516e5dff5af04da6$var$styles.motion,
            (0, $0ffa32ceec741bfa$export$a274e22fb40f762e)(shouldAnimate && phase === 'entering' && enteringAnimationXcss, shouldAnimate && phase === 'exiting' && exitingAnimationXcss)
        ])
    }, children);
});


function $c232f8d62a4f4aa9$export$2e2bcd8739ae039(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}


function $ef7adac3f70546a2$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $ef7adac3f70546a2$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $ef7adac3f70546a2$export$2e2bcd8739ae039(o);
}



function $9b1bfac2cf7374c9$export$2e2bcd8739ae039(t, r) {
    if ("object" != (0, $ef7adac3f70546a2$export$2e2bcd8739ae039)(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (0, $ef7adac3f70546a2$export$2e2bcd8739ae039)(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}


function $ba812ecc18f2f17e$export$2e2bcd8739ae039(t) {
    var i = (0, $9b1bfac2cf7374c9$export$2e2bcd8739ae039)(t, "string");
    return "symbol" == (0, $ef7adac3f70546a2$export$2e2bcd8739ae039)(i) ? i : i + "";
}


function $38e3e575b2a32b90$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, (0, $ba812ecc18f2f17e$export$2e2bcd8739ae039)(o.key), o);
    }
}
function $38e3e575b2a32b90$export$2e2bcd8739ae039(e, r, t) {
    return r && $38e3e575b2a32b90$var$_defineProperties(e.prototype, r), t && $38e3e575b2a32b90$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}



var $5FkrB = parcelRequire("5FkrB");




function $c0cdd0771cd12eed$export$2e2bcd8739ae039(e, r, t) {
    return (r = (0, $ba812ecc18f2f17e$export$2e2bcd8739ae039)(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}


function $3208586af36b975a$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $3208586af36b975a$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $3208586af36b975a$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $c0cdd0771cd12eed$export$2e2bcd8739ae039)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $3208586af36b975a$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
/**
 * JS fallback positioning math. Used only when the browser does not
 * support CSS Anchor Positioning (less than 6% of users).
 *
 * Consumer-supplied `offset.gap` and `offset.crossAxisShift` are
 * honored: the caller (`useAnchorPosition`) resolves CSS length strings
 * (tokens, calc, var, etc) to pixels via a DOM probe before passing them
 * in. The caller also keeps the popover hidden (`opacity: 0`) until the
 * first measurement completes, so the popover never paints at the wrong
 * position.
 */ /**
 * Computes the base {top, left} position based on the primary edge,
 * flipping to the opposite side when there is not enough space.
 *
 * `gap` is applied along the main axis between trigger and popover.
 */ function $3208586af36b975a$var$computeEdgePosition(_ref) {
    var axis = _ref.axis, edge = _ref.edge, triggerRect = _ref.triggerRect, popoverWidth = _ref.popoverWidth, popoverHeight = _ref.popoverHeight, viewport = _ref.viewport, gap = _ref.gap;
    if (axis === 'block' && edge === 'end') {
        // Below trigger
        var spaceBelow = viewport.height - triggerRect.bottom;
        var spaceAbove = triggerRect.top;
        var fitsBelow = spaceBelow >= popoverHeight + gap;
        var useBelow = fitsBelow || spaceBelow >= spaceAbove;
        return {
            top: useBelow ? triggerRect.bottom + gap : triggerRect.top - popoverHeight - gap,
            left: triggerRect.left + triggerRect.width / 2 - popoverWidth / 2
        };
    }
    if (axis === 'block' && edge === 'start') {
        // Above trigger
        var _spaceAbove = triggerRect.top;
        var _spaceBelow = viewport.height - triggerRect.bottom;
        var fitsAbove = _spaceAbove >= popoverHeight + gap;
        var useAbove = fitsAbove || _spaceAbove >= _spaceBelow;
        return {
            top: useAbove ? triggerRect.top - popoverHeight - gap : triggerRect.bottom + gap,
            left: triggerRect.left + triggerRect.width / 2 - popoverWidth / 2
        };
    }
    if (axis === 'inline' && edge === 'end') {
        // Right of trigger
        var spaceRight = viewport.width - triggerRect.right;
        var spaceLeft = triggerRect.left;
        var fitsRight = spaceRight >= popoverWidth + gap;
        var useRight = fitsRight || spaceRight >= spaceLeft;
        return {
            top: triggerRect.top + triggerRect.height / 2 - popoverHeight / 2,
            left: useRight ? triggerRect.right + gap : triggerRect.left - popoverWidth - gap
        };
    }
    if (axis === 'inline' && edge === 'start') {
        // Left of trigger
        var _spaceLeft = triggerRect.left;
        var _spaceRight = viewport.width - triggerRect.right;
        var fitsLeft = _spaceLeft >= popoverWidth + gap;
        var useLeft = fitsLeft || _spaceLeft >= _spaceRight;
        return {
            top: triggerRect.top + triggerRect.height / 2 - popoverHeight / 2,
            left: useLeft ? triggerRect.left - popoverWidth - gap : triggerRect.right + gap
        };
    }
    // Unreachable for valid placements; defaults to below trigger
    return {
        top: triggerRect.bottom + gap,
        left: triggerRect.left + triggerRect.width / 2 - popoverWidth / 2
    };
}
/**
 * Adjusts the base (centered) position for non-center alignments.
 *
 * `align: 'start'` → popover start edge at trigger start edge
 * `align: 'end'`   → popover end edge at trigger end edge
 */ function $3208586af36b975a$var$applyAlignment(_ref2) {
    var position = _ref2.position, axis = _ref2.axis, align = _ref2.align, triggerRect = _ref2.triggerRect, popoverWidth = _ref2.popoverWidth, popoverHeight = _ref2.popoverHeight;
    if (align === 'center') return position;
    if (axis === 'block') {
        // Block-axis placement → cross-axis is inline (left/right)
        if (align === 'start') return $3208586af36b975a$var$_objectSpread($3208586af36b975a$var$_objectSpread({}, position), {}, {
            left: triggerRect.left
        });
        // align === 'end'
        return $3208586af36b975a$var$_objectSpread($3208586af36b975a$var$_objectSpread({}, position), {}, {
            left: triggerRect.right - popoverWidth
        });
    }
    // Inline-axis placement → cross-axis is block (top/bottom)
    if (align === 'start') return $3208586af36b975a$var$_objectSpread($3208586af36b975a$var$_objectSpread({}, position), {}, {
        top: triggerRect.top
    });
    // align === 'end'
    return $3208586af36b975a$var$_objectSpread($3208586af36b975a$var$_objectSpread({}, position), {}, {
        top: triggerRect.bottom - popoverHeight
    });
}
/**
 * Applies the cross-axis shift offset.
 *
 * The sign mirrors the CSS path (see `crossAxisShiftMargin` in
 * `use-anchor-position.tsx`):
 *   - `align: 'start' | 'center'` + `forwards`  → push toward end (positive)
 *   - `align: 'end'`              + `forwards`  → push toward start (negative)
 *   - `backwards` flips the sign in both cases.
 */ function $3208586af36b975a$var$applyCrossAxisShift(_ref3) {
    var position = _ref3.position, axis = _ref3.axis, align = _ref3.align, crossAxisShift = _ref3.crossAxisShift;
    if (crossAxisShift.value === 0) return position;
    var directionSign = crossAxisShift.direction === 'forwards' ? 1 : -1;
    var sideSign = align === 'end' ? -1 : 1;
    var delta = crossAxisShift.value * directionSign * sideSign;
    // Cross-axis is the OPPOSITE of the placement axis.
    if (axis === 'block') return $3208586af36b975a$var$_objectSpread($3208586af36b975a$var$_objectSpread({}, position), {}, {
        left: position.left + delta
    });
    return $3208586af36b975a$var$_objectSpread($3208586af36b975a$var$_objectSpread({}, position), {}, {
        top: position.top + delta
    });
}
function $3208586af36b975a$export$d5ef1dac02135664(_ref4) {
    var triggerRect = _ref4.triggerRect, popoverEl = _ref4.popoverEl, placement = _ref4.placement, viewport = _ref4.viewport, gap = _ref4.gap, crossAxisShift = _ref4.crossAxisShift;
    var axis = placement.axis, edge = placement.edge, align = placement.align;
    // Measure popover dimensions. Callers must ensure the popover has
    // laid out before calling this (it should not be `display: none`).
    var popoverWidth = popoverEl.offsetWidth;
    var popoverHeight = popoverEl.offsetHeight;
    var basePosition = $3208586af36b975a$var$computeEdgePosition({
        axis: axis,
        edge: edge,
        triggerRect: triggerRect,
        popoverWidth: popoverWidth,
        popoverHeight: popoverHeight,
        viewport: viewport,
        gap: gap
    });
    var alignedPosition = $3208586af36b975a$var$applyAlignment({
        position: basePosition,
        axis: axis,
        align: align,
        triggerRect: triggerRect,
        popoverWidth: popoverWidth,
        popoverHeight: popoverHeight
    });
    var shiftedPosition = $3208586af36b975a$var$applyCrossAxisShift({
        position: alignedPosition,
        axis: axis,
        align: align,
        crossAxisShift: crossAxisShift
    });
    // Clamp to viewport so the popover is never offscreen
    return {
        top: Math.max(0, Math.min(shiftedPosition.top, viewport.height - popoverHeight)),
        left: Math.max(0, Math.min(shiftedPosition.left, viewport.width - popoverWidth))
    };
}


/**
 * Combine multiple cleanup functions into a single cleanup function.
 *
 * @example
 * ```ts
 * useEffect(() => {
 *   return combine(
 *     bind(window, { type: 'resize', listener: onResize }),
 *     bind(window, { type: 'scroll', listener: onScroll, options: { capture: true } }),
 *   );
 * }, []);
 * ```
 */ function $271d5bb77bbebdb9$export$1be1fc439b849fdf() {
    for(var _len = arguments.length, cleanupFns = new Array(_len), _key = 0; _key < _len; _key++)cleanupFns[_key] = arguments[_key];
    return function cleanup() {
        cleanupFns.forEach(function(callback) {
            return callback === null || callback === void 0 ? void 0 : callback();
        });
    };
}



function $34d96d9700995371$export$de49b61f233ddeb9(_ref) {
    var placement = _ref.placement;
    var _resolvePlacement = (0, $c0f4a43f9b265e57$export$63044d21bc3d3fa2)({
        placement: placement
    }), axis = _resolvePlacement.axis, edge = _resolvePlacement.edge, align = _resolvePlacement.align;
    var edgeValue = "".concat(axis, "-").concat(edge);
    if (align === 'center') return edgeValue;
    // Cross-axis name: block ↔ inline
    var crossAxis = axis === 'block' ? 'inline' : 'block';
    // Invert align → CSS span direction: visual 'start' → span toward 'end'
    var spanDir = align === 'start' ? 'end' : 'start';
    return "".concat(edgeValue, " span-").concat(crossAxis, "-").concat(spanDir);
}



/**
 * A `position-area` primary edge — the placement axis joined to its edge, e.g.
 * `block-end` or `inline-start`. These are the four edges a popover can sit on.
 */ function $9fb80fb5874ebcad$var$slideOnEdge(_ref) {
    var align = _ref.align, edgeKey = _ref.edgeKey, crossAxis = _ref.crossAxis;
    if (align === 'center') return [
        "".concat(edgeKey, " span-").concat(crossAxis, "-end"),
        "".concat(edgeKey, " span-").concat(crossAxis, "-start")
    ];
    // For `align: 'start'` the popover expands toward `end`, so the "near"
    // span is `end` and the "far" span is `start`; `align: 'end'` mirrors
    // this. The bare `edgeKey` (re-centered) sits between them.
    var near = align === 'start' ? 'end' : 'start';
    var far = align === 'start' ? 'start' : 'end';
    return [
        "".concat(edgeKey, " span-").concat(crossAxis, "-").concat(near),
        edgeKey,
        "".concat(edgeKey, " span-").concat(crossAxis, "-").concat(far)
    ];
}
function $9fb80fb5874ebcad$var$flipDiagonally(_ref2) {
    var axis = _ref2.axis;
    var flipOnMainAxis = axis === 'block' ? 'flip-block' : 'flip-inline';
    var flipToCrossAxis = axis === 'block' ? 'flip-inline' : 'flip-block';
    return "".concat(flipOnMainAxis, " ").concat(flipToCrossAxis);
}
function $9fb80fb5874ebcad$export$c4e16947a95d61f1(_ref3) {
    var placement = _ref3.placement;
    /**
   * **Build the fallback list**
   *
   * Each entry is a complete alternative position.
   * The browser tries them _in order_ and uses the _first_ one that fits.
   */ var resolved = (0, $c0f4a43f9b265e57$export$63044d21bc3d3fa2)({
        placement: placement
    });
    var axis = resolved.axis, edge = resolved.edge, align = resolved.align;
    var crossAxis = axis === 'block' ? 'inline' : 'block';
    var flippedEdge = edge === 'start' ? 'end' : 'start';
    var sameEdgeArea = "".concat(axis, "-").concat(edge);
    var oppositeEdgeArea = "".concat(axis, "-").concat(flippedEdge);
    var flipOnMainAxis = axis === 'block' ? 'flip-block' : 'flip-inline';
    /**
   * **Fallback algorithm**
   *
   * We have two things we can do to keep something visible:
   *
   * 1. _Slide_ along edges
   * 2. _Flip_ to another edge
   *
   * _Centered popover_
   *
   * Desired: Sits in middle of main edge
   *
   * Fallbacks:
   *  1: _Slide_ along main edge on the cross axis
   *  2: _Flip_ on main axis to opposite edge (centered)
   *  3: _Slide_ along opposite edge on the cross axis
   *
   * _Start or end aligned popover_
   *
   * Desired: Sits at start / end of main edge
   *
   * Fallbacks:
   *  1: _Slide_ along main edge on the cross axis
   *  2: _Flip_ on main axis to opposite edge
   *  3: _Flip_ on the diagonal (flip main axis + flip cross axis) into the
   *     opposite corner. For start / end alignment, this is the clean escape
   *     when the popover would otherwise land offscreen on both axes (ie in a
   *     corner). Rule 4 gets the job done, but a slide drops the gap
   *     as named position-area values don't carry margins).
   *     The diagonal flip keeps the gap and the alignment.
   *  4: _Slide_ along opposite edge on the cross axis
   */ return [
        $9fb80fb5874ebcad$var$slideOnEdge({
            align: align,
            edgeKey: sameEdgeArea,
            crossAxis: crossAxis
        }),
        flipOnMainAxis,
        align !== 'center' ? $9fb80fb5874ebcad$var$flipDiagonally({
            axis: axis
        }) : null,
        $9fb80fb5874ebcad$var$slideOnEdge({
            align: align,
            edgeKey: oppositeEdgeArea,
            crossAxis: crossAxis
        })
    ].filter(Boolean).flat().join(', ');
}


var $e786775b1ecd75a1$var$elementCaches = new WeakMap();
function $e786775b1ecd75a1$var$canCacheResolvedLength(value) {
    // Custom-property values can be retargeted by inline overrides on the
    // consumer's wrapper, so we cannot prove a cached pixel value is still valid.
    return !value.includes('var(');
}
function $e786775b1ecd75a1$var$getCachedResolvedLength(_ref) {
    var _cacheForElement$get;
    var element = _ref.element, value = _ref.value;
    if (!$e786775b1ecd75a1$var$canCacheResolvedLength(value)) return null;
    var cacheForElement = $e786775b1ecd75a1$var$elementCaches.get(element);
    return (_cacheForElement$get = cacheForElement === null || cacheForElement === void 0 ? void 0 : cacheForElement.get(value)) !== null && _cacheForElement$get !== void 0 ? _cacheForElement$get : null;
}
function $e786775b1ecd75a1$var$cacheResolvedLength(_ref2) {
    var _elementCaches$get;
    var element = _ref2.element, value = _ref2.value, result = _ref2.result;
    if (!$e786775b1ecd75a1$var$canCacheResolvedLength(value)) return;
    var cacheForElement = (_elementCaches$get = $e786775b1ecd75a1$var$elementCaches.get(element)) !== null && _elementCaches$get !== void 0 ? _elementCaches$get : new Map();
    cacheForElement.set(value, result);
    $e786775b1ecd75a1$var$elementCaches.set(element, cacheForElement);
}
function $e786775b1ecd75a1$export$98721546d2816d9e(_ref3) {
    var value = _ref3.value, container = _ref3.container;
    if (typeof value === 'number') return value;
    // Fast path: unitless zero is universally zero pixels - accept `'0'` and
    // `'-0'` without a probe. (Consumers occasionally pass `'0'` instead of
    // the number `0`.)
    if (value === '0' || value === '-0') return 0;
    // Fast path: bare `${n}px` strings come from the consumer normalisation
    // in `resolvePlacement`. Avoid a reflow when we can.
    var pxMatch = value.match(/^(-?\d+(?:\.\d+)?)px$/);
    if (pxMatch) return Number(pxMatch[1]);
    var cached = $e786775b1ecd75a1$var$getCachedResolvedLength({
        element: container,
        value: value
    });
    if (cached !== null) return cached;
    var probe = container.ownerDocument.createElement('div');
    probe.style.position = 'absolute';
    probe.style.visibility = 'hidden';
    probe.style.pointerEvents = 'none';
    probe.style.height = '0';
    probe.style.padding = '0';
    probe.style.border = '0';
    // `width` clamps negatives to 0; use `margin-left` instead so signs are
    // preserved. `getComputedStyle` returns the resolved pixel value for
    // margin-* properties even when the source was a token / calc / var.
    probe.style.marginLeft = value;
    // Hide the probe from assistive tech and event targeting; defensive
    // against `getElementsByTagName('div')` walks in consumer code.
    probe.setAttribute('aria-hidden', 'true');
    probe.setAttribute('inert', '');
    container.appendChild(probe);
    var resolved = parseFloat(getComputedStyle(probe).marginLeft);
    container.removeChild(probe);
    var result = Number.isFinite(resolved) ? resolved : 0;
    $e786775b1ecd75a1$var$cacheResolvedLength({
        element: container,
        value: value,
        result: result
    });
    return result;
}



/**
 * Sets inline styles on an element and returns a cleanup function that
 * restores the prior inline values (so we do not stomp consumer styles).
 */ function $5da0ee85175e23d7$export$37a5fde709c1db82(_ref) {
    var element = _ref.element, styles = _ref.styles;
    // Snapshot the prior inline value (NOT the computed style - we only want
    // to restore values that the consumer/our previous run inlined). An empty
    // string means "no inline value", in which case cleanup uses removeProperty.
    var priorValues = styles.map(function(_ref2) {
        var property = _ref2.property;
        return {
            property: property,
            value: element.style.getPropertyValue(property)
        };
    });
    styles.forEach(function(_ref3) {
        var property = _ref3.property, value = _ref3.value;
        element.style.setProperty(property, value);
    });
    return function cleanup() {
        priorValues.forEach(function(_ref4) {
            var property = _ref4.property, value = _ref4.value;
            if (value === '') {
                element.style.removeProperty(property);
                return;
            }
            element.style.setProperty(property, value);
        });
    };
}


// `resolvePlacement` is intentionally NOT re-exported here - import it directly
// from `./resolve-placement` so search-and-jump lands at the source of truth.
/**
 * Module-scope no-op `ResizeObserver` used in non-DOM jest environments where
 * `ResizeObserver` is `undefined`. Hoisted out of the effect to avoid
 * allocating a new class declaration on every run.
 */ var $62cae9a51e21bb99$var$NoopResizeObserver = /*#__PURE__*/ function() {
    function NoopResizeObserver() {
        (0, $c232f8d62a4f4aa9$export$2e2bcd8739ae039)(this, NoopResizeObserver);
    }
    return (0, $38e3e575b2a32b90$export$2e2bcd8739ae039)(NoopResizeObserver, [
        {
            key: "observe",
            value: function observe() {}
        },
        {
            key: "unobserve",
            value: function unobserve() {}
        },
        {
            key: "disconnect",
            value: function disconnect() {}
        }
    ]);
}();
/**
 * Returns true when the popover is currently open. Wrapped because the
 * `:popover-open` pseudo-class is not implemented in some test environments
 * (e.g. jsdom), where `matches` throws on unknown selectors.
 */ function $62cae9a51e21bb99$var$isPopoverOpen(popover) {
    try {
        return popover.matches(':popover-open');
    } catch (_unused) {
        return false;
    }
}
/**
 * Detects whether the browser supports CSS Anchor Positioning.
 * Uses `once()` for lazy evaluation: safe for SSR and avoids hydration mismatches.
 */ var $62cae9a51e21bb99$var$supportsAnchorPositioning = (0, $86089df3a0fd54eb$export$2e2bcd8739ae039)(function() {
    if (typeof window === 'undefined' || typeof CSS === 'undefined' || typeof CSS.supports !== 'function') return false;
    return CSS.supports('anchor-name', '--a');
});
/**
 * Returns the CSS margin declaration that creates a gap between the
 * popover and its trigger on the side facing the anchor.
 *
 * For example, a `block-end` placement (popover below) gets
 * `margin-block-start: 8px` to push it away from the trigger's bottom edge.
 */ function $62cae9a51e21bb99$var$edgeMargin(_ref) {
    var placement = _ref.placement, offset = _ref.offset;
    var axis = placement.axis, edge = placement.edge;
    var value = offset;
    if (axis === 'block' && edge === 'end') return {
        property: 'margin-block-start',
        value: value
    };
    if (axis === 'block' && edge === 'start') return {
        property: 'margin-block-end',
        value: value
    };
    if (axis === 'inline' && edge === 'end') return {
        property: 'margin-inline-start',
        value: value
    };
    if (axis === 'inline' && edge === 'start') return {
        property: 'margin-inline-end',
        value: value
    };
    return {
        property: 'margin-block-start',
        value: value
    };
}
/**
 * Cross-axis shift margin. Margin side matches the popover's anchored
 * cross-axis edge: `align: 'start'` uses the START margin, `align: 'end'`
 * uses the END margin with the sign inverted (so `forwards` is always
 * positive), `align: 'center'` uses START. Margin on the un-anchored side
 * has no effect under CSS Anchor Positioning.
 */ function $62cae9a51e21bb99$var$crossAxisShiftMargin(_ref2) {
    var placement = _ref2.placement, crossAxisShiftCssValue = _ref2.crossAxisShiftCssValue, direction = _ref2.direction;
    var axis = placement.axis, align = placement.align;
    var directionSign = direction === 'forwards' ? 1 : -1;
    var crossAxis = axis === 'block' ? 'inline' : 'block';
    var useEndSide = align === 'end';
    var side = useEndSide ? 'end' : 'start';
    var sideSign = useEndSide ? -1 : 1;
    var finalSign = directionSign * sideSign;
    // Wrap any string in calc() with the sign factor. CSS handles the math.
    var value = finalSign === 1 ? crossAxisShiftCssValue : "calc(-1 * ".concat(crossAxisShiftCssValue, ")");
    return {
        property: "margin-".concat(crossAxis, "-").concat(side),
        value: value
    };
}
/**
 * Returns a referentially-stable, fully-resolved `TPlacement`. The memo is
 * keyed on the resolved primitive fields so a fresh inline `placement` object
 * (or undefined fields vs explicit defaults) does not produce a fresh result.
 */ function $62cae9a51e21bb99$var$useStablePlacement(placement) {
    var resolved = (0, $c0f4a43f9b265e57$export$63044d21bc3d3fa2)({
        placement: placement
    });
    var axis = resolved.axis;
    var edge = resolved.edge;
    var align = resolved.align;
    var gap = resolved.offset.gap;
    var shiftValue = resolved.offset.crossAxisShift.value;
    var shiftDirection = resolved.offset.crossAxisShift.direction;
    // Rebuild inside the memo from primitive deps so the factory does not
    // close over the outer `resolved` reference and exhaustive-deps can verify.
    return (0, $5FkrB.useMemo)(function() {
        return {
            axis: axis,
            edge: edge,
            align: align,
            offset: {
                gap: gap,
                crossAxisShift: {
                    value: shiftValue,
                    direction: shiftDirection
                }
            }
        };
    }, [
        axis,
        edge,
        align,
        gap,
        shiftValue,
        shiftDirection
    ]);
}
function $62cae9a51e21bb99$export$56b02a1e583f953c(_ref3) {
    var anchorRef = _ref3.anchorRef, popoverRef = _ref3.popoverRef, _ref3$placement = _ref3.placement, placement = _ref3$placement === void 0 ? {} : _ref3$placement, _ref3$forceFallbackPo = _ref3.forceFallbackPositioning, forceFallbackPositioning = _ref3$forceFallbackPo === void 0 ? false : _ref3$forceFallbackPo, _ref3$isEnabled = _ref3.isEnabled, isEnabled = _ref3$isEnabled === void 0 ? true : _ref3$isEnabled, isOpen = _ref3.isOpen;
    var id = (0, $5FkrB.useId)();
    var stablePlacement = $62cae9a51e21bb99$var$useStablePlacement(placement);
    (0, $5FkrB.useLayoutEffect)(function() {
        if (!isEnabled) return;
        var trigger = anchorRef.current;
        var popover = popoverRef.current;
        if (!trigger || !popover) return;
        var gapCssValue = stablePlacement.offset.gap;
        var crossAxisShiftCssValue = stablePlacement.offset.crossAxisShift.value;
        var shouldForceFallback = Boolean(forceFallbackPositioning);
        if ($62cae9a51e21bb99$var$supportsAnchorPositioning() && !shouldForceFallback) {
            // Reuse an existing `anchor-name` if the element already has one.
            // Another popover might already be anchored to the old name.
            var anchorName = trigger.style.getPropertyValue('anchor-name') || "--anchor-".concat(id.replace(/:/g, ''));
            var gap = $62cae9a51e21bb99$var$edgeMargin({
                placement: stablePlacement,
                offset: gapCssValue
            });
            // Computed once; reused below to populate the active
            // `--ds-cross-axis-shift-margin-*` custom property for the
            // named arrow @position-try rules.
            var crossAxisShift = $62cae9a51e21bb99$var$crossAxisShiftMargin({
                placement: stablePlacement,
                crossAxisShiftCssValue: crossAxisShiftCssValue,
                direction: stablePlacement.offset.crossAxisShift.direction
            });
            var popoverStyles = [
                {
                    property: 'position-anchor',
                    value: anchorName
                },
                {
                    property: 'position-area',
                    value: (0, $34d96d9700995371$export$de49b61f233ddeb9)({
                        placement: stablePlacement
                    })
                },
                {
                    property: 'position-try-fallbacks',
                    value: (0, $9fb80fb5874ebcad$export$c4e16947a95d61f1)({
                        placement: stablePlacement
                    })
                },
                // Reset browser default popover positioning that conflicts
                // with anchor positioning (UA: `inset: 0; margin: auto;`)
                {
                    property: 'margin',
                    value: '0'
                },
                {
                    property: 'inset',
                    value: 'auto'
                },
                {
                    property: gap.property,
                    value: gap.value
                },
                {
                    property: crossAxisShift.property,
                    value: crossAxisShift.value
                }
            ];
            // Expose the active cross-axis shift via custom properties so each
            // named arrow @position-try rule can re-apply it after a flip.
            // One of the four (cross-axis, side) properties is non-zero at a time.
            popoverStyles.push({
                property: '--ds-cross-axis-shift-margin-start',
                value: '0px'
            });
            popoverStyles.push({
                property: '--ds-cross-axis-shift-margin-end',
                value: '0px'
            });
            popoverStyles.push({
                property: '--ds-cross-axis-shift-margin-block-start',
                value: '0px'
            });
            popoverStyles.push({
                property: '--ds-cross-axis-shift-margin-block-end',
                value: '0px'
            });
            // `crossAxisShift` IS the active margin; reuse instead of recomputing.
            var crossAxisShiftActive = crossAxisShift;
            var customPropertyByMarginProperty = {
                'margin-inline-start': '--ds-cross-axis-shift-margin-start',
                'margin-inline-end': '--ds-cross-axis-shift-margin-end',
                'margin-block-start': '--ds-cross-axis-shift-margin-block-start',
                'margin-block-end': '--ds-cross-axis-shift-margin-block-end'
            };
            var crossAxisShiftCustomProperty = customPropertyByMarginProperty[crossAxisShiftActive.property];
            if (crossAxisShiftCustomProperty) popoverStyles.push({
                property: crossAxisShiftCustomProperty,
                value: crossAxisShiftActive.value
            });
            /**
       * **We are never cleaning up anchor names**
       *
       * _Rationale_
       *
       * - Multiple popovers can share the same anchor element.
       * - Sometimes the `useAnchorPosition` hook and `Popover`
       *   are not in the same component.
       * - There can be times when, even with reference counting, we
       *   could remove the anchor-name while it is still being used
       *   by something else - especially with async react updates
       *   which can cause tearing
       *
       * _More_
       *
       * See `notes/decisions/anchor-name-lifetime.md`
       */ trigger.style.setProperty('anchor-name', anchorName);
            var _undoPositioning = (0, $271d5bb77bbebdb9$export$1be1fc439b849fdf)((0, $5da0ee85175e23d7$export$37a5fde709c1db82)({
                element: popover,
                styles: popoverStyles
            }));
            return _undoPositioning;
        }
        // JS fallback. The popover is already in the top layer via
        // popover="auto", so we only reset UA defaults and set top/left
        // based on measurements.
        var cleanupBaseStyles = (0, $5da0ee85175e23d7$export$37a5fde709c1db82)({
            element: popover,
            styles: [
                {
                    property: 'margin',
                    value: '0'
                },
                {
                    property: 'inset',
                    value: 'auto'
                }
            ]
        });
        function update() {
            if (!trigger || !popover) return;
            var triggerRect = trigger.getBoundingClientRect();
            var viewport = {
                width: window.innerWidth,
                height: window.innerHeight
            };
            // Resolve consumer-supplied CSS length strings (tokens, calc, var,
            // px, rem, etc) to pixels. The probe is mounted INSIDE the popover
            // itself so the resolved length matches the scope a token would
            // resolve against from inside the popover content. (The popover
            // lives in the top layer, not the trigger's DOM tree, so probing
            // at `popover.parentElement` would resolve in a different scope
            // than the consumer's token authoring expects.)
            var gapPx = (0, $e786775b1ecd75a1$export$98721546d2816d9e)({
                value: gapCssValue,
                container: popover
            });
            var crossAxisShiftPx = (0, $e786775b1ecd75a1$export$98721546d2816d9e)({
                value: crossAxisShiftCssValue,
                container: popover
            });
            var _computeFallbackPosit = (0, $3208586af36b975a$export$d5ef1dac02135664)({
                triggerRect: triggerRect,
                popoverEl: popover,
                placement: stablePlacement,
                viewport: viewport,
                gap: gapPx,
                crossAxisShift: {
                    value: crossAxisShiftPx,
                    direction: stablePlacement.offset.crossAxisShift.direction
                }
            }), top = _computeFallbackPosit.top, left = _computeFallbackPosit.left;
            popover.style.setProperty('top', "".concat(top, "px"));
            popover.style.setProperty('left', "".concat(left, "px"));
            // Reveal the popover only after it has been positioned.
            // See the toggle listener below for why we hide on open.
            popover.style.removeProperty('opacity');
        }
        // Throttle scroll/resize updates to one per animation frame
        var scheduledUpdate = (0, $2fb72d4a32455831$export$2e2bcd8739ae039)(update);
        // Wait for the FIRST valid layout before measuring: the popover
        // is `display: none` until `showPopover()`, and some browsers
        // fire `toggle` before layout, so RAF-after-toggle is unreliable.
        // ResizeObserver fires once the browser has real dimensions.
        // Self-disconnects after one valid measurement; ongoing
        // scroll/resize is handled by the window listeners below.
        // `ResizeObserver` is missing in some non-DOM jest environments
        // (e.g. post-office's `node` environment). Fall back to a no-op
        // observer there. The scroll/resize listeners below still keep
        // the popover positioned in the rare case the consumer also
        // polyfilled `showPopover` but not `ResizeObserver`. Real
        // browsers always have it. The `NoopResizeObserver` class is
        // hoisted to module scope (see top of file) so we do not allocate
        // a new constructor on every effect run.
        var ResizeObserverImpl = typeof ResizeObserver !== 'undefined' ? ResizeObserver : $62cae9a51e21bb99$var$NoopResizeObserver;
        var resizeObserver = new ResizeObserverImpl(function() {
            if (popover.offsetWidth > 0 && popover.offsetHeight > 0) {
                update();
                resizeObserver.disconnect();
            }
        });
        // If the popover is already open by the time this effect runs (for
        // example, the parent `useAnchorPosition` effect runs after the child
        // `Popover` effect that called `showPopover()`), the initial `toggle`
        // event has already fired and our listener below would miss it. Start
        // observing immediately so the first measurement still happens.
        if ($62cae9a51e21bb99$var$isPopoverOpen(popover)) {
            popover.style.setProperty('opacity', '0');
            resizeObserver.observe(popover);
        }
        var undoPositioning = (0, $271d5bb77bbebdb9$export$1be1fc439b849fdf)(cleanupBaseStyles, // On every open: hide synchronously so the user never sees
        // the UA-default position, then re-observe for a fresh
        // measurement. We use `opacity: 0` rather than
        // `visibility: hidden` because Firefox skips visibility-hidden
        // elements during `<dialog>` initial-focus traversal. See
        // `form-in-popup.spec.tsx` on `desktop-firefox`.
        (0, $5b617c1f48263075$exports.bind)(popover, {
            type: 'toggle',
            listener: function listener(event) {
                var toggleEvent = event;
                if (toggleEvent.newState === 'open') {
                    popover.style.setProperty('opacity', '0');
                    resizeObserver.observe(popover);
                }
            }
        }), function() {
            return resizeObserver.disconnect();
        }, (0, $5b617c1f48263075$exports.bind)(window, {
            type: 'scroll',
            listener: scheduledUpdate,
            options: {
                capture: true,
                passive: true
            }
        }), (0, $5b617c1f48263075$exports.bind)(window, {
            type: 'resize',
            listener: scheduledUpdate,
            options: {
                passive: true
            }
        }), function() {
            scheduledUpdate.cancel();
            popover.style.removeProperty('top');
            popover.style.removeProperty('left');
            popover.style.removeProperty('opacity');
        });
        return undoPositioning;
    }, [
        anchorRef,
        popoverRef,
        stablePlacement,
        forceFallbackPositioning,
        isEnabled,
        id,
        isOpen
    ]);
}



var $5FkrB = parcelRequire("5FkrB");

function $5056e572a5bbe58a$export$7071d791a7b131ed(_ref) {
    var mode = _ref.mode, popoverRef = _ref.popoverRef, anchorRef = _ref.anchorRef, isOpen = _ref.isOpen;
    (0, $5FkrB.useLayoutEffect)(function() {
        var node = popoverRef.current;
        if (!node) return;
        // Feature-detect `anchor-size()` specifically (not just `anchor-name`)
        // so the JS fallback fires correctly in browsers that support anchor
        // positioning but not anchor sizing.
        var supportsAnchorSize = typeof CSS !== 'undefined' && typeof CSS.supports === 'function' && CSS.supports('width', 'anchor-size(width)');
        if (mode === 'match-anchor') {
            // Set an exact width matching the anchor.
            // `min-inline-size` is intentionally NOT set here - it would override the
            // explicit width constraint, allowing the popover to grow past the anchor's width.
            if (supportsAnchorSize) return (0, $5da0ee85175e23d7$export$37a5fde709c1db82)({
                element: node,
                styles: [
                    {
                        property: 'width',
                        value: 'anchor-size(width)'
                    }
                ]
            });
            // JS fallback: one-off read of the anchor's width.
            var anchor = anchorRef.current;
            if (anchor) return (0, $5da0ee85175e23d7$export$37a5fde709c1db82)({
                element: node,
                styles: [
                    {
                        property: 'width',
                        value: "".concat(anchor.offsetWidth, "px")
                    }
                ]
            });
            return;
        }
        // For 'min-anchor' and 'none', apply `min-inline-size: max-content` to ensure
        // correct position-try-fallbacks behaviour (popover margin box overflows the
        // viewport when its span region is too narrow, rather than wrapping content).
        var minInlineSizeStyle = {
            property: 'min-inline-size',
            value: 'max-content'
        };
        if (mode === 'min-anchor') {
            // Set a minimum width matching the anchor. The popover can grow wider
            // if its content requires it.
            if (supportsAnchorSize) return (0, $5da0ee85175e23d7$export$37a5fde709c1db82)({
                element: node,
                styles: [
                    minInlineSizeStyle,
                    {
                        property: 'min-width',
                        value: 'anchor-size(width)'
                    }
                ]
            });
            var _anchor = anchorRef.current;
            if (_anchor) return (0, $5da0ee85175e23d7$export$37a5fde709c1db82)({
                element: node,
                styles: [
                    minInlineSizeStyle,
                    {
                        property: 'min-width',
                        value: "".concat(_anchor.offsetWidth, "px")
                    }
                ]
            });
            // No anchor available in JS fallback - still apply min-inline-size.
            return (0, $5da0ee85175e23d7$export$37a5fde709c1db82)({
                element: node,
                styles: [
                    minInlineSizeStyle
                ]
            });
        }
        // 'none' mode: no explicit width, but still apply `min-inline-size: max-content`.
        return (0, $5da0ee85175e23d7$export$37a5fde709c1db82)({
            element: node,
            styles: [
                minInlineSizeStyle
            ]
        });
    }, [
        mode,
        popoverRef,
        anchorRef,
        isOpen
    ]);
}




var $5FkrB = parcelRequire("5FkrB");
var $84894bad979d29dd$export$a0d5b29fa9affc38 = /*#__PURE__*/ (0, $5FkrB.createContext)(undefined);


function $98d3794a964394e8$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $98d3794a964394e8$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $98d3794a964394e8$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $90d31be1abcfa6da$export$2e2bcd8739ae039)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $98d3794a964394e8$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
// `'auto'` falls through to `'end'`; top-layer's `position-try-fallbacks` flips it if needed.
function $98d3794a964394e8$var$reactSelectEdgeToTopLayerEdge(menuPlacement) {
    return menuPlacement === 'top' ? 'start' : 'end';
}
var $98d3794a964394e8$var$menuPortalStyles = {
    root: "_ofie1496"
};
function $98d3794a964394e8$export$1f5427c7f5364d0b(props) {
    var children = props.children, controlElement = props.controlElement, innerProps = props.innerProps, menuPlacement = props.menuPlacement, menuPosition = props.menuPosition, xcss = props.xcss;
    // Select's "close the menu" callback, distinct from `Popover.onClose`.
    var closeSelect = (0, $5FkrB.useContext)((0, $84894bad979d29dd$export$a0d5b29fa9affc38));
    var popoverRef = (0, $5FkrB.useRef)(null);
    // Top-layer hooks need a RefObject; in-render mutation keeps it in sync
    // with the prop without an effect. The hooks re-read `.current` from
    // `isOpen`-keyed layout effects, so a stable ref identity is fine.
    var anchorRef = (0, $5FkrB.useRef)(null);
    anchorRef.current = controlElement;
    // `controlElement` is null on initial mount / SSR until `Select` mirrors
    // its ref into state. While null, every hook below no-ops to avoid DOM
    // reads or registering an unpositioned popover.
    var isAnchored = controlElement !== null;
    // `gap: 0` matches the legacy MenuPortal (no trigger-to-menu gap; the
    // menu root already declares its own `marginBlockStart`). Without this
    // override `useAnchorPosition`'s default 8px gap would diverge visually
    // from the legacy path.
    (0, $62cae9a51e21bb99$export$56b02a1e583f953c)({
        anchorRef: anchorRef,
        popoverRef: popoverRef,
        placement: {
            axis: 'block',
            edge: $98d3794a964394e8$var$reactSelectEdgeToTopLayerEdge(menuPlacement),
            offset: {
                gap: 0
            }
        },
        isOpen: isAnchored
    });
    (0, $5056e572a5bbe58a$export$7071d791a7b131ed)({
        anchorRef: anchorRef,
        popoverRef: popoverRef,
        mode: 'match-anchor',
        isOpen: isAnchored
    });
    var handlePopoverClose = (0, $5FkrB.useCallback)(function() {
        if (closeSelect) closeSelect();
    }, [
        closeSelect
    ]);
    // Explicit observer registration: the outer Popover is intentionally
    // roleless (see Popover comment below), so Popover cannot auto-register
    // from its role. This lets `closeLayers()` (Modal / Drawer) dismiss us.
    (0, $1fc181ef4c36ccfd$export$469bb693f11edc7f)({
        type: 'popup',
        isOpen: isAnchored,
        onClose: handlePopoverClose
    });
    // Top-layer owns positioning; zero offset/rect preserves the consumer
    // styles call shape.
    var _getStyleProps = (0, $26e98d575ca76ea1$export$26417cabd806a658)($98d3794a964394e8$var$_objectSpread($98d3794a964394e8$var$_objectSpread({}, props), {}, {
        offset: 0,
        position: menuPosition,
        rect: {
            left: 0,
            width: 0
        }
    }), 'menuPortal', {
        'menu-portal': true
    }), className = _getStyleProps.className;
    // Popover stays mounted and is driven by `isOpen` so its layout-effect
    // teardown (`hidePopover`, observer cleanup, position-hook style reset)
    // runs against a live element. Conditional render would skip that path.
    //
    // `mode="manual"` opts out of native light-dismiss: react-select already
    // owns outside-click and Escape via its own handlers, and the combobox
    // trigger lives in a separate DOM subtree that the spec algorithm cannot
    // see. Matches the pattern in `@atlaskit/datetime-picker`'s MenuTopLayer.
    //
    // The Popover host is intentionally roleless: the inner `MenuList`
    // keeps `role="listbox"` and the id referenced by `aria-controls`.
    // Putting the role on the outer host caused Playwright `toBeVisible`
    // and some SR hit-testing to treat it as hidden (zero bounding rect
    // while `styles.root` opts out of UA `[popover]` positioning).
    //
    // TODO: add open / close animation. Select unmounts MenuPortalTopLayer
    // the moment `menuIsOpen` flips false, so Popover's `animate` exit
    // transition never gets a frame. Needs keeping the portal mounted
    // through the exit (`onExitFinish`) on the Select side.
    return /*#__PURE__*/ $5FkrB.createElement((0, $516e5dff5af04da6$export$5b6b19405a83ff9d), {
        ref: popoverRef,
        mode: "manual",
        isOpen: isAnchored,
        onClose: handlePopoverClose
    }, /*#__PURE__*/ $5FkrB.createElement("div", (0, $e7be1629a1f1b709$export$2e2bcd8739ae039)({
        // `className` carries consumer `styles.menuPortal({...})` output,
        // `xcss` carries caller compiled atomic classes, and `-MenuPortal`
        // is a legacy selector hook kept for parity with MenuPortalLegacy.
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss, @typescript-eslint/no-explicit-any
        className: (0, $lqU89.default)([
            $98d3794a964394e8$var$menuPortalStyles.root,
            (0, $b2896f4f52b4ee15$export$a274e22fb40f762e)(className, xcss, '-MenuPortal')
        ])
    }, innerProps), children));
}


function $0a5b922338432e73$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $0a5b922338432e73$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $0a5b922338432e73$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $90d31be1abcfa6da$export$2e2bcd8739ae039)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $0a5b922338432e73$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $0a5b922338432e73$var$getBoundingClientObj(element) {
    var rect = element.getBoundingClientRect();
    return {
        bottom: rect.bottom,
        height: rect.height,
        left: rect.left,
        right: rect.right,
        top: rect.top,
        width: rect.width
    };
}
var $0a5b922338432e73$var$coercePlacement = function coercePlacement(p) {
    return p === 'auto' ? 'bottom' : p;
};
var $0a5b922338432e73$var$menuPortalStyles = {
    root: "_1pbykb7n _1e02a1vk _kqswcp1v _152t1nmo _1bsb1qxj"
};
// eslint-disable-next-line @repo/internal/react/require-jsdoc
function $0a5b922338432e73$var$MenuPortalLegacy(props) {
    var appendTo = props.appendTo, children = props.children, controlElement = props.controlElement, innerProps = props.innerProps, menuPlacement = props.menuPlacement, menuPosition = props.menuPosition, xcss = props.xcss;
    var menuPortalRef = (0, $5FkrB.useRef)(null);
    var cleanupRef = (0, $5FkrB.useRef)(null);
    var _useState = (0, $5FkrB.useState)($0a5b922338432e73$var$coercePlacement(menuPlacement)), _useState2 = (0, $c99af517edc48a31$export$2e2bcd8739ae039)(_useState, 2), placement = _useState2[0], setPortalPlacement = _useState2[1];
    var portalPlacementContext = (0, $5FkrB.useMemo)(function() {
        return {
            setPortalPlacement: setPortalPlacement
        };
    }, []);
    var _useState3 = (0, $5FkrB.useState)(null), _useState4 = (0, $c99af517edc48a31$export$2e2bcd8739ae039)(_useState3, 2), computedPosition = _useState4[0], setComputedPosition = _useState4[1];
    var updateComputedPosition = (0, $5FkrB.useCallback)(function() {
        if (!controlElement) return;
        var rect = $0a5b922338432e73$var$getBoundingClientObj(controlElement);
        var scrollDistance = menuPosition === 'fixed' ? 0 : window.pageYOffset;
        var offset = rect[placement] + scrollDistance;
        if (offset !== (computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.offset) || rect.left !== (computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.left) || rect.width !== (computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.width)) setComputedPosition({
            offset: offset,
            rect: rect
        });
    }, [
        controlElement,
        menuPosition,
        placement,
        computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.offset,
        computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.left,
        computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.width
    ]);
    (0, $5FkrB.useLayoutEffect)(function() {
        updateComputedPosition();
    }, [
        updateComputedPosition
    ]);
    var runAutoUpdate = (0, $5FkrB.useCallback)(function() {
        if (typeof cleanupRef.current === 'function') {
            cleanupRef.current();
            cleanupRef.current = null;
        }
        if (controlElement && menuPortalRef.current) cleanupRef.current = (0, $8772434deeb83c74$export$deee3a793edee05f)(controlElement, menuPortalRef.current, updateComputedPosition, {
            elementResize: 'ResizeObserver' in window
        });
    }, [
        controlElement,
        updateComputedPosition
    ]);
    (0, $5FkrB.useLayoutEffect)(function() {
        runAutoUpdate();
    }, [
        runAutoUpdate
    ]);
    var setMenuPortalElement = (0, $5FkrB.useCallback)(function(menuPortalElement) {
        menuPortalRef.current = menuPortalElement;
        runAutoUpdate();
    }, [
        runAutoUpdate
    ]);
    // Legacy quirk: `computedPosition` is null until the layout effect runs,
    // so the first render returns null even with `defaultMenuIsOpen` set.
    // Synchronous observers (VR snapshots) see a one-frame "closed" state.
    // Left as-is; the top-layer path supersedes this and positions declaratively.
    if (!appendTo && menuPosition !== 'fixed' || !computedPosition) return null;
    var _getStyleProps = (0, $26e98d575ca76ea1$export$26417cabd806a658)($0a5b922338432e73$var$_objectSpread($0a5b922338432e73$var$_objectSpread({}, props), {}, {
        offset: computedPosition.offset,
        position: menuPosition,
        rect: computedPosition.rect
    }), 'menuPortal', {
        'menu-portal': true
    }), css = _getStyleProps.css, className = _getStyleProps.className;
    // same wrapper element whether fixed or portalled
    var menuWrapper = /*#__PURE__*/ $5FkrB.createElement("div", (0, $e7be1629a1f1b709$export$2e2bcd8739ae039)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $lqU89.default)([
            $0a5b922338432e73$var$menuPortalStyles.root,
            (0, $b2896f4f52b4ee15$export$a274e22fb40f762e)(className, xcss, '-MenuPortal')
        ]),
        ref: setMenuPortalElement,
        style: $0a5b922338432e73$var$_objectSpread({
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            '--menu-left': "".concat(computedPosition.rect.left, "px"),
            '--menu-position': menuPosition,
            '--menu-top': "".concat(computedPosition.offset, "px"),
            '--menu-width': "".concat(computedPosition.rect.width, "px")
        }, css)
    }, innerProps), children);
    return /*#__PURE__*/ $5FkrB.createElement((0, $8518ee13423a8229$export$e001f626511a0ead).Provider, {
        value: portalPlacementContext
    }, appendTo ? /*#__PURE__*/ (0, $7d59b24134129acf$exports.createPortal)(menuWrapper, appendTo) : menuWrapper);
}
var $0a5b922338432e73$export$793392f970497feb = function MenuPortal(props) {
    if ((0, $13a186c4459b8c2a$export$b40ec24ac8275656)('platform-dst-top-layer')) // eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    return /*#__PURE__*/ $5FkrB.createElement((0, $98d3794a964394e8$export$1f5427c7f5364d0b), props);
    // eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    return /*#__PURE__*/ $5FkrB.createElement($0a5b922338432e73$var$MenuPortalLegacy, props);
};


/* multi-value.tsx generated by @compiled/babel-plugin v2.0.0 */ 


var $5FkrB = parcelRequire("5FkrB");

var $lqU89 = parcelRequire("lqU89");


/* index.tsx generated by @compiled/babel-plugin v2.0.0 */ function $a9546fe3c34f8734$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $a9546fe3c34f8734$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $a9546fe3c34f8734$export$2e2bcd8739ae039(o);
}



function $321c0261f3844bc3$export$2e2bcd8739ae039(t, r) {
    if ("object" != (0, $a9546fe3c34f8734$export$2e2bcd8739ae039)(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (0, $a9546fe3c34f8734$export$2e2bcd8739ae039)(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}


function $c9f170926c8f7af8$export$2e2bcd8739ae039(t) {
    var i = (0, $321c0261f3844bc3$export$2e2bcd8739ae039)(t, "string");
    return "symbol" == (0, $a9546fe3c34f8734$export$2e2bcd8739ae039)(i) ? i : i + "";
}


function $34bcf16a63c65c03$export$2e2bcd8739ae039(e, r, t) {
    return (r = (0, $c9f170926c8f7af8$export$2e2bcd8739ae039)(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}


function $4d49c99afafded0a$export$2e2bcd8739ae039() {
    return $4d49c99afafded0a$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $4d49c99afafded0a$export$2e2bcd8739ae039.apply(null, arguments);
}


function $881f96a8a937ca1a$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return r;
}


function $ba7c51019b7bff68$export$2e2bcd8739ae039(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}


function $b61a83b6410a96cb$export$2e2bcd8739ae039(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}


function $399f4d24ff9afeeb$export$2e2bcd8739ae039(r, a) {
    if (r) {
        if ("string" == typeof r) return (0, $b61a83b6410a96cb$export$2e2bcd8739ae039)(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? (0, $b61a83b6410a96cb$export$2e2bcd8739ae039)(r, a) : void 0;
    }
}


function $fc183e5f8f59a663$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}


function $1dc579c4de1142c2$export$2e2bcd8739ae039(r, e) {
    return (0, $881f96a8a937ca1a$export$2e2bcd8739ae039)(r) || (0, $ba7c51019b7bff68$export$2e2bcd8739ae039)(r, e) || (0, $399f4d24ff9afeeb$export$2e2bcd8739ae039)(r, e) || (0, $fc183e5f8f59a663$export$2e2bcd8739ae039)();
}


function $98708d6461d58f2e$export$2e2bcd8739ae039(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}


function $f2ca64756a447eb8$export$2e2bcd8739ae039(e, t) {
    if (null == e) return {};
    var o, r, i = (0, $98708d6461d58f2e$export$2e2bcd8739ae039)(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}



var $5FkrB = parcelRequire("5FkrB");

var $jzAQA = parcelRequire("jzAQA");

var $5FkrB = parcelRequire("5FkrB");


function $d3a356c20a99fe92$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return (0, $b61a83b6410a96cb$export$2e2bcd8739ae039)(r);
}


function $7ea58444bfadcd00$export$2e2bcd8739ae039(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}



function $a7e2fdea4992085b$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}


function $b64eb05e0a458fd9$export$2e2bcd8739ae039(r) {
    return (0, $d3a356c20a99fe92$export$2e2bcd8739ae039)(r) || (0, $7ea58444bfadcd00$export$2e2bcd8739ae039)(r) || (0, $399f4d24ff9afeeb$export$2e2bcd8739ae039)(r) || (0, $a7e2fdea4992085b$export$2e2bcd8739ae039)();
}


function $a90d44c71774a73e$export$2e2bcd8739ae039(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}



function $a83b4b1801bd7063$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, (0, $c9f170926c8f7af8$export$2e2bcd8739ae039)(o.key), o);
    }
}
function $a83b4b1801bd7063$export$2e2bcd8739ae039(e, r, t) {
    return r && $a83b4b1801bd7063$var$_defineProperties(e.prototype, r), t && $a83b4b1801bd7063$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}



function $1303d0097a774019$export$2e2bcd8739ae039(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
}


function $c4a414505d241956$export$2e2bcd8739ae039(t, e) {
    if (e && ("object" == (0, $a9546fe3c34f8734$export$2e2bcd8739ae039)(e) || "function" == typeof e)) return e;
    if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
    return (0, $1303d0097a774019$export$2e2bcd8739ae039)(t);
}


function $0738339b6a9f4e57$export$2e2bcd8739ae039(t) {
    return $0738339b6a9f4e57$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
        return t.__proto__ || Object.getPrototypeOf(t);
    }, $0738339b6a9f4e57$export$2e2bcd8739ae039(t);
}



function $c1aeb415c15b16db$export$2e2bcd8739ae039(t, o) {
    for(; !({}).hasOwnProperty.call(t, o) && null !== (t = (0, $0738339b6a9f4e57$export$2e2bcd8739ae039)(t)););
    return t;
}


function $0550eca2bd453b09$export$2e2bcd8739ae039() {
    return $0550eca2bd453b09$export$2e2bcd8739ae039 = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function(e, t, r) {
        var p = (0, $c1aeb415c15b16db$export$2e2bcd8739ae039)(e, t);
        if (p) {
            var n = Object.getOwnPropertyDescriptor(p, t);
            return n.get ? n.get.call(arguments.length < 3 ? e : r) : n.value;
        }
    }, $0550eca2bd453b09$export$2e2bcd8739ae039.apply(null, arguments);
}


function $6a90dcf285e3318e$export$2e2bcd8739ae039(t, e) {
    return $6a90dcf285e3318e$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, $6a90dcf285e3318e$export$2e2bcd8739ae039(t, e);
}


function $56f9760db6bbedd7$export$2e2bcd8739ae039(t, e) {
    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
    t.prototype = Object.create(e && e.prototype, {
        constructor: {
            value: t,
            writable: !0,
            configurable: !0
        }
    }), Object.defineProperty(t, "prototype", {
        writable: !1
    }), e && (0, $6a90dcf285e3318e$export$2e2bcd8739ae039)(t, e);
}








function $b67fad0a126d5f92$var$asyncGeneratorStep(n, t, e, r, o, a, c) {
    try {
        var i = n[a](c), u = i.value;
    } catch (n) {
        return void e(n);
    }
    i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function $b67fad0a126d5f92$export$2e2bcd8739ae039(n) {
    return function() {
        var t = this, e = arguments;
        return new Promise(function(r, o) {
            var a = n.apply(t, e);
            function _next(n) {
                $b67fad0a126d5f92$var$asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
            }
            function _throw(n) {
                $b67fad0a126d5f92$var$asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
            }
            _next(void 0);
        });
    };
}





var $b405b4a0324cf1d2$exports = {};
// TODO(Babel 8): Remove this file.

var $b405b4a0324cf1d2$var$runtime = (parcelRequire("9cXjV"))();
$b405b4a0324cf1d2$exports = $b405b4a0324cf1d2$var$runtime;
// Copied from https://github.com/facebook/regenerator/blob/main/packages/runtime/runtime.js#L736=
try {
    regeneratorRuntime = $b405b4a0324cf1d2$var$runtime;
} catch (accidentalStrictMode) {
    if (typeof globalThis === "object") globalThis.regeneratorRuntime = $b405b4a0324cf1d2$var$runtime;
    else Function("r", "regeneratorRuntime = r")($b405b4a0324cf1d2$var$runtime);
}



var $iFR7a = parcelRequire("iFR7a");




var $hLfKH = parcelRequire("hLfKH");
function $d9dca6217d358e09$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $d9dca6217d358e09$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $d9dca6217d358e09$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $34bcf16a63c65c03$export$2e2bcd8739ae039)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $d9dca6217d358e09$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $d9dca6217d358e09$export$a66cbd9b2289cd78 = '@all-features';
var $d9dca6217d358e09$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function Subscriptions() {
        (0, $a90d44c71774a73e$export$2e2bcd8739ae039)(this, Subscriptions);
        (0, $34bcf16a63c65c03$export$2e2bcd8739ae039)(this, "eventToValue", new Map());
        this.emitter = new (0, (/*@__PURE__*/$parcel$interopDefault($hLfKH)))();
    }
    return (0, $a83b4b1801bd7063$export$2e2bcd8739ae039)(Subscriptions, [
        {
            key: "onGateUpdated",
            value: function onGateUpdated(gateName, callback, checkGate, options) {
                var _this = this;
                var value = checkGate(gateName, $d9dca6217d358e09$var$_objectSpread($d9dca6217d358e09$var$_objectSpread({}, options), {}, {
                    fireGateExposure: false
                }));
                if (this.eventToValue.get(callback) === undefined) this.eventToValue.set(callback, value);
                var wrapCallback = function wrapCallback() {
                    var value = checkGate(gateName, $d9dca6217d358e09$var$_objectSpread($d9dca6217d358e09$var$_objectSpread({}, options), {}, {
                        fireGateExposure: false
                    }));
                    var existingValue = _this.eventToValue.get(callback);
                    if (existingValue !== value) {
                        _this.eventToValue.set(callback, value);
                        callback(value);
                    }
                };
                this.emitter.on(gateName, wrapCallback);
                return function() {
                    _this.emitter.off(gateName, wrapCallback);
                };
            }
        },
        {
            key: "onExperimentValueUpdated",
            value: function onExperimentValueUpdated(experimentName, parameterName, defaultValue, callback, getExperimentValue, options) {
                var _this2 = this;
                var experimentEventName = "".concat(experimentName, ".").concat(parameterName);
                var value = getExperimentValue(experimentName, parameterName, defaultValue, $d9dca6217d358e09$var$_objectSpread($d9dca6217d358e09$var$_objectSpread({}, options), {}, {
                    fireExperimentExposure: false
                }));
                if (this.eventToValue.get(callback) === undefined) this.eventToValue.set(callback, value);
                var wrapCallback = function wrapCallback() {
                    var value = getExperimentValue(experimentName, parameterName, defaultValue, $d9dca6217d358e09$var$_objectSpread($d9dca6217d358e09$var$_objectSpread({}, options), {}, {
                        fireExperimentExposure: false
                    }));
                    var existingValue = _this2.eventToValue.get(callback);
                    if (existingValue !== value) {
                        _this2.eventToValue.set(callback, value);
                        callback(value);
                    }
                };
                this.emitter.on(experimentEventName, wrapCallback);
                return function() {
                    _this2.emitter.off(experimentEventName, wrapCallback);
                };
            }
        },
        {
            key: "onAnyUpdated",
            value: function onAnyUpdated(callback) {
                var _this3 = this;
                this.emitter.on($d9dca6217d358e09$export$a66cbd9b2289cd78, callback);
                return function() {
                    _this3.emitter.off($d9dca6217d358e09$export$a66cbd9b2289cd78, callback);
                };
            }
        },
        {
            key: "anyUpdated",
            value: function anyUpdated() {
                var _this4 = this;
                this.emitter.emit($d9dca6217d358e09$export$a66cbd9b2289cd78);
                this.emitter.eventNames().filter(function(name) {
                    return name !== $d9dca6217d358e09$export$a66cbd9b2289cd78;
                }).forEach(function(event) {
                    _this4.emitter.emit(event);
                });
            }
        }
    ]);
}();










var $1efef4dca0f62866$export$ce553301d55c2fd8 = 'fedramp-moderate';
var $1efef4dca0f62866$export$f005e2e9f707cb5f = 'commercial';
var $1efef4dca0f62866$export$bd6b5a7802d76127 = 'fedramp-fedex';
var $1efef4dca0f62866$export$a739cd5aac835909 = 'stg';
var $1efef4dca0f62866$export$42dd0cdd351a4a9 = 'prod';
var $1efef4dca0f62866$export$404582bc18fe4d9e = 'dev';


function $b52b9a3280ecae2c$export$64d6499adf9b2e51() {
    var _global$location;
    var global = globalThis;
    // MICROS_PERIMETER is already used by few products, so we need to keep it for backward compatibility
    var env = global.MICROS_PERIMETER || global.UNSAFE_ATL_CONTEXT_BOUNDARY;
    if (env) return env === (0, $1efef4dca0f62866$export$ce553301d55c2fd8);
    var matches = (_global$location = global.location) === null || _global$location === void 0 || (_global$location = _global$location.hostname) === null || _global$location === void 0 ? void 0 : _global$location.match(/atlassian-us-gov-mod\.(com|net)|atlassian-us-gov\.(com|net)|atlassian-fex\.(com|net)|atlassian-stg-fedm\.(com|net)/);
    return matches ? matches.length > 0 : false;
}


// Reference: https://github.com/statsig-io/js-lite/blob/main/src/StatsigStore.ts
var $5be6d0aa4a90cba5$export$c62558b199e46828 = {
    // Order is important since the logic for migrating from a new client reason to an old one
    // returns the first which is a substring of the new client reason
    Error: 'Error',
    LocalOverride: 'LocalOverride',
    Unrecognized: 'Unrecognized',
    Uninitialized: 'Uninitialized',
    NetworkNotModified: 'NetworkNotModified',
    Network: 'Network',
    InvalidBootstrap: 'InvalidBootstrap',
    Bootstrap: 'Bootstrap',
    Cache: 'Cache',
    // For when we could not migrate the reason from the new client
    Unknown: 'Unknown'
}; // Reference: https://github.com/statsig-io/js-lite/blob/main/src/StatsigSDKOptions.ts


/**
 * The identifiers for the user. Options are restricted to the set that is currently supported.
 */ /**
 * Base client options. Does not include any options specific to providers
 * @interface BaseClientOptions
 * @property {FeatureGateEnvironment} environment - The environment for the client.
 * @property {string} targetApp - The target app for the client.
 * @property {AnalyticsWebClient} analyticsWebClient - The analytics web client.
 * @property {PerimeterType} perimeter - The perimeter for the client.
 */ /**
 * The options for the client.
 * @interface ClientOptions
 * @extends {BaseClientOptions}
 * @property {string} apiKey - The API key for the client.
 * @property {fetchTimeoutMs} fetchTimeoutMs - The timeout for the fetch request in milliseconds. Defaults to 5000.
 * @property {boolean} useGatewayURL - Whether to use the gateway URL. Defaults to false.
 */ /**
 * The custom attributes for the user.
 */ var $c578c05f082e3c28$export$479e7351a733299 = {
    Development: 'development',
    Staging: 'staging',
    Production: 'production'
};
var $c578c05f082e3c28$export$c42b7bbc5e7ba555 = {
    COMMERCIAL: 'commercial',
    FEDRAMP_MODERATE: 'fedramp-moderate'
};
var $c578c05f082e3c28$export$42f4885608027d0c = 'non_boolean'; // Type magic to get the JSDoc comments from the Client class methods to appear on the static
 // methods in FeatureGates where the property name and function type are identical


var $d16a8fcdfb06c5ab$var$_excluded = [
    "stableId"
], $d16a8fcdfb06c5ab$var$_excluded2 = [
    "api",
    "disableCurrentPageLogging",
    "loggingIntervalMillis",
    "loggingBufferMaxSize",
    "localMode",
    "eventLoggingApi",
    "eventLoggingApiForRetries",
    "disableLocalStorage",
    "ignoreWindowUndefined",
    "disableAllLogging",
    "initTimeoutMs",
    "disableNetworkKeepalive",
    "overrideStableID",
    "disableErrorLogging",
    "disableAutoMetricsLogging"
];
function $d16a8fcdfb06c5ab$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $d16a8fcdfb06c5ab$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $d16a8fcdfb06c5ab$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $34bcf16a63c65c03$export$2e2bcd8739ae039)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $d16a8fcdfb06c5ab$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $d16a8fcdfb06c5ab$export$d119b37e5f788b43 = function getOptionsWithDefaults(options) {
    return $d16a8fcdfb06c5ab$var$_objectSpread({
        /**
     * If more federal PerimeterTypes are added in the future, this should be updated so
     * that isFedRamp() === true always returns the strictest perimeter.
     */ perimeter: (0, $b52b9a3280ecae2c$export$64d6499adf9b2e51)() ? (0, $c578c05f082e3c28$export$c42b7bbc5e7ba555).FEDRAMP_MODERATE : (0, $c578c05f082e3c28$export$c42b7bbc5e7ba555).COMMERCIAL
    }, options);
};
var $d16a8fcdfb06c5ab$export$fa1c2bbf4100b8bc = function shallowEquals(objectA, objectB) {
    if (!objectA && !objectB) return true;
    if (!objectA || !objectB) return false;
    var aEntries = Object.entries(objectA);
    var bEntries = Object.entries(objectB);
    if (aEntries.length !== bEntries.length) return false;
    var ascendingKeyOrder = function ascendingKeyOrder(_ref, _ref2) {
        var _ref3 = (0, $1dc579c4de1142c2$export$2e2bcd8739ae039)(_ref, 1), key1 = _ref3[0];
        var _ref4 = (0, $1dc579c4de1142c2$export$2e2bcd8739ae039)(_ref2, 1), key2 = _ref4[0];
        return key1.localeCompare(key2);
    };
    aEntries.sort(ascendingKeyOrder);
    bEntries.sort(ascendingKeyOrder);
    for(var i = 0; i < aEntries.length; i++){
        var _aEntries$i = (0, $1dc579c4de1142c2$export$2e2bcd8739ae039)(aEntries[i], 2), aValue = _aEntries$i[1];
        var _bEntries$i = (0, $1dc579c4de1142c2$export$2e2bcd8739ae039)(bEntries[i], 2), bValue = _bEntries$i[1];
        if (aValue !== bValue) return false;
    }
    return true;
};
var $d16a8fcdfb06c5ab$export$3dad1db244472f32 = function toStatsigUser(identifiers, customAttributes) {
    // Re-map `stableId` to `stableID` to match Statsig's native type.
    var stableId = identifiers.stableId, otherIdentifiers = (0, $f2ca64756a447eb8$export$2e2bcd8739ae039)(identifiers, $d16a8fcdfb06c5ab$var$_excluded);
    var user = {
        customIDs: $d16a8fcdfb06c5ab$var$_objectSpread($d16a8fcdfb06c5ab$var$_objectSpread({}, otherIdentifiers), stableId !== undefined ? {
            stableID: stableId
        } : {}),
        custom: customAttributes
    };
    if (identifiers.atlassianAccountId) user.userID = identifiers.atlassianAccountId;
    return user;
};
function $d16a8fcdfb06c5ab$export$1148cb79ceecd5fa(target) {
    for(var _len = arguments.length, sources = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)sources[_key - 1] = arguments[_key];
    if (!sources.length) return target;
    var source = sources.shift();
    if (source === undefined || source === null) return $d16a8fcdfb06c5ab$export$1148cb79ceecd5fa.apply(void 0, [
        target
    ].concat((0, $b64eb05e0a458fd9$export$2e2bcd8739ae039)(sources)));
    for(var _i = 0, _Object$entries = Object.entries(source); _i < _Object$entries.length; _i++){
        var _Object$entries$_i = (0, $1dc579c4de1142c2$export$2e2bcd8739ae039)(_Object$entries[_i], 2), key = _Object$entries$_i[0], src = _Object$entries$_i[1];
        var dst = target[key];
        var srcIsObj = src && (0, $a9546fe3c34f8734$export$2e2bcd8739ae039)(src) === 'object' && !Array.isArray(src);
        var dstIsObj = dst && (0, $a9546fe3c34f8734$export$2e2bcd8739ae039)(dst) === 'object' && !Array.isArray(dst);
        if (srcIsObj && dstIsObj) target[key] = $d16a8fcdfb06c5ab$export$1148cb79ceecd5fa(dst, src);
        else target[key] = src;
    }
    return $d16a8fcdfb06c5ab$export$1148cb79ceecd5fa.apply(void 0, [
        target
    ].concat((0, $b64eb05e0a458fd9$export$2e2bcd8739ae039)(sources)));
}
var $d16a8fcdfb06c5ab$export$202946b690d26d22 = function migrateInitializationOptions(options) {
    var api = options.api, disableCurrentPageLogging = options.disableCurrentPageLogging, loggingIntervalMillis = options.loggingIntervalMillis, loggingBufferMaxSize = options.loggingBufferMaxSize, localMode = options.localMode, eventLoggingApi = options.eventLoggingApi, eventLoggingApiForRetries = options.eventLoggingApiForRetries, disableLocalStorage = options.disableLocalStorage, ignoreWindowUndefined = options.ignoreWindowUndefined, disableAllLogging = options.disableAllLogging, _initTimeoutMs = options.initTimeoutMs, _disableNetworkKeepalive = options.disableNetworkKeepalive, _overrideStableID = options.overrideStableID, _disableErrorLogging = options.disableErrorLogging, _disableAutoMetricsLogging = options.disableAutoMetricsLogging, rest = (0, $f2ca64756a447eb8$export$2e2bcd8739ae039)(options, $d16a8fcdfb06c5ab$var$_excluded2);
    return $d16a8fcdfb06c5ab$var$_objectSpread($d16a8fcdfb06c5ab$var$_objectSpread({}, rest), {}, {
        networkConfig: {
            api: api,
            logEventUrl: eventLoggingApi ? eventLoggingApi + 'rgstr' : undefined,
            logEventFallbackUrls: eventLoggingApiForRetries ? [
                eventLoggingApiForRetries
            ] : undefined,
            preventAllNetworkTraffic: localMode || !ignoreWindowUndefined && typeof window === 'undefined'
        },
        includeCurrentPageUrlWithEvents: !disableCurrentPageLogging,
        loggingIntervalMs: loggingIntervalMillis,
        loggingBufferMaxSize: loggingBufferMaxSize,
        disableStorage: disableLocalStorage === undefined ? localMode : disableLocalStorage,
        disableLogging: disableAllLogging === undefined ? localMode : disableAllLogging
    });
};
var $d16a8fcdfb06c5ab$var$evaluationReasonMappings = Object.entries((0, $5be6d0aa4a90cba5$export$c62558b199e46828)).map(function(_ref5) {
    var _ref6 = (0, $1dc579c4de1142c2$export$2e2bcd8739ae039)(_ref5, 2), key = _ref6[0], value = _ref6[1];
    return [
        key.toLowerCase(),
        value
    ];
});
var $d16a8fcdfb06c5ab$export$18ad168d3dbac899 = function migrateEvaluationDetails(details) {
    var _evaluationReasonMapp, _evaluationReasonMapp2, _details$receivedAt;
    var reasonLower = details.reason.toLowerCase();
    return {
        reason: (_evaluationReasonMapp = (_evaluationReasonMapp2 = $d16a8fcdfb06c5ab$var$evaluationReasonMappings.find(function(_ref7) {
            var _ref8 = (0, $1dc579c4de1142c2$export$2e2bcd8739ae039)(_ref7, 1), key = _ref8[0];
            return reasonLower.includes(key);
        })) === null || _evaluationReasonMapp2 === void 0 ? void 0 : _evaluationReasonMapp2[1]) !== null && _evaluationReasonMapp !== void 0 ? _evaluationReasonMapp : (0, $5be6d0aa4a90cba5$export$c62558b199e46828).Unknown,
        time: (_details$receivedAt = details.receivedAt) !== null && _details$receivedAt !== void 0 ? _details$receivedAt : Date.now()
    };
};
var $d16a8fcdfb06c5ab$export$55fd683752d01e67 = function migrateSecondaryExposures(secondaryExposures) {
    return secondaryExposures.map(function(exposure) {
        if (typeof exposure === 'string') // This should ideally have gateValue and ruleID fields too, but it's not possible for us
        // to determine the correct values for these.
        return {
            gate: exposure
        };
        return exposure;
    });
};


var $2fc45f5524794bb4$export$6dc24881a3d96325 = /*#__PURE__*/ function() {
    function DynamicConfig(configName, configValue, ruleID, evaluationDetails) {
        var secondaryExposures = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : [];
        var allocatedExperimentName = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : '';
        var onDefaultValueFallback = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : null;
        (0, $a90d44c71774a73e$export$2e2bcd8739ae039)(this, DynamicConfig);
        this.value = configValue;
        this._name = configName;
        this._ruleID = ruleID;
        this._secondaryExposures = secondaryExposures;
        this._allocatedExperimentName = allocatedExperimentName;
        this._evaluationDetails = evaluationDetails;
        this._onDefaultValueFallback = onDefaultValueFallback;
    }
    return (0, $a83b4b1801bd7063$export$2e2bcd8739ae039)(DynamicConfig, [
        {
            key: "get",
            value: function get(key, defaultValue, typeGuard) {
                var _this$_onDefaultValue2;
                var val = this.getValue(key, defaultValue);
                if (val == null) return defaultValue;
                var expectedType = Array.isArray(defaultValue) ? 'array' : (0, $a9546fe3c34f8734$export$2e2bcd8739ae039)(defaultValue);
                var actualType = Array.isArray(val) ? 'array' : (0, $a9546fe3c34f8734$export$2e2bcd8739ae039)(val);
                if (typeGuard) {
                    var _this$_onDefaultValue;
                    if (typeGuard(val)) {
                        this.fireExposure(key);
                        return val;
                    }
                    (_this$_onDefaultValue = this._onDefaultValueFallback) === null || _this$_onDefaultValue === void 0 || _this$_onDefaultValue.call(this, this, key, expectedType, actualType);
                    return defaultValue;
                }
                if (defaultValue == null || expectedType === actualType) {
                    this.fireExposure(key);
                    return val;
                }
                (_this$_onDefaultValue2 = this._onDefaultValueFallback) === null || _this$_onDefaultValue2 === void 0 || _this$_onDefaultValue2.call(this, this, key, expectedType, actualType);
                return defaultValue;
            }
        },
        {
            key: "getValue",
            value: function getValue(key, defaultValue) {
                if (key == null) return this.value;
                if (defaultValue == null) defaultValue = null;
                if (this.value[key] == null) return defaultValue;
                this.fireExposure(key);
                return this.value[key];
            }
        },
        {
            key: "fireExposure",
            value: function fireExposure(key) {
                // Call the wrapped experiment's get method to fire exposure
                if (this.experiment) this.experiment.get(key);
            }
        }
    ], [
        {
            key: "fromExperiment",
            value: function fromExperiment(experiment) {
                var _experiment$__evaluat, _experiment$__evaluat2, _experiment$groupName;
                var config = new DynamicConfig(experiment.name, experiment.value, experiment.ruleID, (0, $d16a8fcdfb06c5ab$export$18ad168d3dbac899)(experiment.details), (0, $d16a8fcdfb06c5ab$export$55fd683752d01e67)((_experiment$__evaluat = (_experiment$__evaluat2 = experiment.__evaluation) === null || _experiment$__evaluat2 === void 0 ? void 0 : _experiment$__evaluat2.secondary_exposures) !== null && _experiment$__evaluat !== void 0 ? _experiment$__evaluat : []), (_experiment$groupName = experiment.groupName) !== null && _experiment$groupName !== void 0 ? _experiment$groupName : undefined);
                config.experiment = experiment;
                return config;
            }
        }
    ]);
}();






var $1141e1e3afce2b59$export$936d0764594b6eb3 = /*#__PURE__*/ function() {
    function Layer(name, layerValue, ruleID, evaluationDetails) {
        var logParameterFunction = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;
        var secondaryExposures = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : [];
        var undelegatedSecondaryExposures = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : [];
        var allocatedExperimentName = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : '';
        var explicitParameters = arguments.length > 8 && arguments[8] !== undefined ? arguments[8] : [];
        (0, $a90d44c71774a73e$export$2e2bcd8739ae039)(this, Layer);
        this._logParameterFunction = logParameterFunction;
        this._name = name;
        this._value = JSON.parse(JSON.stringify(layerValue !== null && layerValue !== void 0 ? layerValue : {}));
        this._ruleID = ruleID !== null && ruleID !== void 0 ? ruleID : '';
        this._evaluationDetails = evaluationDetails;
        this._secondaryExposures = secondaryExposures;
        this._undelegatedSecondaryExposures = undelegatedSecondaryExposures;
        this._allocatedExperimentName = allocatedExperimentName;
        this._explicitParameters = explicitParameters;
    }
    return (0, $a83b4b1801bd7063$export$2e2bcd8739ae039)(Layer, [
        {
            key: "get",
            value: function get(key, defaultValue, typeGuard) {
                var _this = this;
                var val = this._value[key];
                if (val == null) return defaultValue;
                var logAndReturn = function logAndReturn() {
                    _this._logLayerParameterExposure(key);
                    return val;
                };
                if (typeGuard) return typeGuard(val) ? logAndReturn() : defaultValue;
                if (defaultValue == null) return logAndReturn();
                if ((0, $a9546fe3c34f8734$export$2e2bcd8739ae039)(val) === (0, $a9546fe3c34f8734$export$2e2bcd8739ae039)(defaultValue) && Array.isArray(defaultValue) === Array.isArray(val)) return logAndReturn();
                return defaultValue;
            }
        },
        {
            key: "getValue",
            value: function getValue(key, defaultValue) {
                // eslint-disable-next-line eqeqeq
                if (defaultValue == undefined) defaultValue = null;
                var val = this._value[key];
                if (val != null) this._logLayerParameterExposure(key);
                return val !== null && val !== void 0 ? val : defaultValue;
            }
        },
        {
            key: "_logLayerParameterExposure",
            value: function _logLayerParameterExposure(parameterName) {
                var _this$_logParameterFu;
                (_this$_logParameterFu = this._logParameterFunction) === null || _this$_logParameterFu === void 0 || _this$_logParameterFu.call(this, this, parameterName);
            }
        }
    ], [
        {
            key: "fromLayer",
            value: function fromLayer(layer) {
                var _layer$__evaluation$s, _layer$__evaluation, _layer$__evaluation$u, _layer$__evaluation2, _layer$__evaluation3, _layer$__evaluation4;
                var value = new Layer(layer.name, layer.__value, layer.ruleID, (0, $d16a8fcdfb06c5ab$export$18ad168d3dbac899)(layer.details), function(_layer, parameterName) {
                    return layer.get(parameterName);
                }, (0, $d16a8fcdfb06c5ab$export$55fd683752d01e67)((_layer$__evaluation$s = (_layer$__evaluation = layer.__evaluation) === null || _layer$__evaluation === void 0 ? void 0 : _layer$__evaluation.secondary_exposures) !== null && _layer$__evaluation$s !== void 0 ? _layer$__evaluation$s : []), (0, $d16a8fcdfb06c5ab$export$55fd683752d01e67)((_layer$__evaluation$u = (_layer$__evaluation2 = layer.__evaluation) === null || _layer$__evaluation2 === void 0 ? void 0 : _layer$__evaluation2.undelegated_secondary_exposures) !== null && _layer$__evaluation$u !== void 0 ? _layer$__evaluation$u : []), (_layer$__evaluation3 = layer.__evaluation) === null || _layer$__evaluation3 === void 0 ? void 0 : _layer$__evaluation3.allocated_experiment_name, (_layer$__evaluation4 = layer.__evaluation) === null || _layer$__evaluation4 === void 0 ? void 0 : _layer$__evaluation4.explicit_parameters);
                return value;
            }
        }
    ]);
}();









/// <reference types="node" />
var $eb08f16a4c9618eb$export$a59f8d67326bd1cb = "5.8.0";









function $25cf3903e193381f$export$2e2bcd8739ae039(t) {
    try {
        return -1 !== Function.toString.call(t).indexOf("[native code]");
    } catch (n) {
        return "function" == typeof t;
    }
}


function $61125fd98dacd6bd$export$2e2bcd8739ae039() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($61125fd98dacd6bd$export$2e2bcd8739ae039 = function _isNativeReflectConstruct() {
        return !!t;
    })();
}



function $55d16f9d365b5965$export$2e2bcd8739ae039(t, e, r) {
    if ((0, $61125fd98dacd6bd$export$2e2bcd8739ae039)()) return Reflect.construct.apply(null, arguments);
    var o = [
        null
    ];
    o.push.apply(o, e);
    var p = new (t.bind.apply(t, o))();
    return r && (0, $6a90dcf285e3318e$export$2e2bcd8739ae039)(p, r.prototype), p;
}


function $6e3190e962eeb831$export$2e2bcd8739ae039(t) {
    var r = "function" == typeof Map ? new Map() : void 0;
    return $6e3190e962eeb831$export$2e2bcd8739ae039 = function _wrapNativeSuper(t) {
        if (null === t || !(0, $25cf3903e193381f$export$2e2bcd8739ae039)(t)) return t;
        if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function");
        if (void 0 !== r) {
            if (r.has(t)) return r.get(t);
            r.set(t, Wrapper);
        }
        function Wrapper() {
            return (0, $55d16f9d365b5965$export$2e2bcd8739ae039)(t, arguments, (0, $0738339b6a9f4e57$export$2e2bcd8739ae039)(this).constructor);
        }
        return Wrapper.prototype = Object.create(t.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: !1,
                writable: !0,
                configurable: !0
            }
        }), (0, $6a90dcf285e3318e$export$2e2bcd8739ae039)(Wrapper, t);
    }, $6e3190e962eeb831$export$2e2bcd8739ae039(t);
}


function $4f899fb573e9f6bf$var$_callSuper(t, o, e) {
    return o = (0, $0738339b6a9f4e57$export$2e2bcd8739ae039)(o), (0, $c4a414505d241956$export$2e2bcd8739ae039)(t, $4f899fb573e9f6bf$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, $0738339b6a9f4e57$export$2e2bcd8739ae039)(t).constructor) : o.apply(t, e));
}
function $4f899fb573e9f6bf$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($4f899fb573e9f6bf$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $4f899fb573e9f6bf$export$286baf652d0b1206 = /*#__PURE__*/ function(_Error) {
    function ResponseError(message) {
        (0, $a90d44c71774a73e$export$2e2bcd8739ae039)(this, ResponseError);
        return $4f899fb573e9f6bf$var$_callSuper(this, ResponseError, [
            message
        ]);
    }
    (0, $56f9760db6bbedd7$export$2e2bcd8739ae039)(ResponseError, _Error);
    return (0, $a83b4b1801bd7063$export$2e2bcd8739ae039)(ResponseError);
}(/*#__PURE__*/ (0, $6e3190e962eeb831$export$2e2bcd8739ae039)(Error));


function $5422ff0610ef57b4$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $5422ff0610ef57b4$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $5422ff0610ef57b4$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $34bcf16a63c65c03$export$2e2bcd8739ae039)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $5422ff0610ef57b4$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $5422ff0610ef57b4$var$DEFAULT_REQUEST_TIMEOUT_MS = 5000;
var $5422ff0610ef57b4$export$250a58ecde616daa = 'https://api.atlassian.com/flags';
var $5422ff0610ef57b4$export$942ba04389b0d5a2 = 'https://api.stg.atlassian.com/flags';
var $5422ff0610ef57b4$export$f058dbf75c3bc647 = 'https://api.dev.atlassian.com/flags';
var $5422ff0610ef57b4$export$1a401a0da8da3565 = 'https://api.stg.atlassian-us-gov-mod.com/flags';
var $5422ff0610ef57b4$export$18c93900db9358a4 = 'https://api.atlassian-us-gov-mod.com/flags';
var $5422ff0610ef57b4$export$4e8a0415edbfa1f7 = 'https://atlassian-statsig-proxy-archetype.atl-paas.%s.atl-ic.net';
var $5422ff0610ef57b4$export$cb3cd156f70d7e94 = 'oasis-stg.com/flags';
var $5422ff0610ef57b4$export$921fbc6cdfd4eee0 = 'atlassian-isolated.net/flags';
var $5422ff0610ef57b4$export$450bd8fb2a6d7ace = '/gateway/api/flags';
var $5422ff0610ef57b4$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function Fetcher() {
        (0, $a90d44c71774a73e$export$2e2bcd8739ae039)(this, Fetcher);
    }
    return (0, $a83b4b1801bd7063$export$2e2bcd8739ae039)(Fetcher, null, [
        {
            key: "fetchClientSdk",
            value: function() {
                var _fetchClientSdk = (0, $b67fad0a126d5f92$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($b405b4a0324cf1d2$exports))).mark(function _callee(fetcherOptions) {
                    var targetApp, url, _t;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($b405b4a0324cf1d2$exports))).wrap(function(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                targetApp = fetcherOptions.targetApp;
                                url = "/api/v2/frontend/clientSdkKey/".concat(targetApp);
                                _context.prev = 1;
                                _context.next = 2;
                                return this.fetchRequest(url, 'GET', fetcherOptions);
                            case 2:
                                return _context.abrupt("return", _context.sent);
                            case 3:
                                _context.prev = 3;
                                _t = _context["catch"](1);
                                if (!(_t instanceof Error)) {
                                    _context.next = 4;
                                    break;
                                }
                                throw _t;
                            case 4:
                                throw Error('Failed to retrieve client sdk key');
                            case 5:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee, this, [
                        [
                            1,
                            3
                        ]
                    ]);
                }));
                function fetchClientSdk(_x) {
                    return _fetchClientSdk.apply(this, arguments);
                }
                return fetchClientSdk;
            }()
        },
        {
            key: "fetchExperimentValues",
            value: function() {
                var _fetchExperimentValues = (0, $b67fad0a126d5f92$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($b405b4a0324cf1d2$exports))).mark(function _callee2(fetcherOptions, identifiers, customAttributes) {
                    var requestBody, _t2;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($b405b4a0324cf1d2$exports))).wrap(function(_context2) {
                        while(true)switch(_context2.prev = _context2.next){
                            case 0:
                                requestBody = {
                                    identifiers: identifiers,
                                    customAttributes: customAttributes,
                                    targetApp: fetcherOptions.targetApp
                                };
                                _context2.prev = 1;
                                _context2.next = 2;
                                return this.fetchRequest('/api/v2/frontend/experimentValues', 'POST', fetcherOptions, requestBody);
                            case 2:
                                return _context2.abrupt("return", _context2.sent);
                            case 3:
                                _context2.prev = 3;
                                _t2 = _context2["catch"](1);
                                if (!(_t2 instanceof Error)) {
                                    _context2.next = 4;
                                    break;
                                }
                                throw _t2;
                            case 4:
                                throw Error('Failed to retrieve experiment values');
                            case 5:
                            case "end":
                                return _context2.stop();
                        }
                    }, _callee2, this, [
                        [
                            1,
                            3
                        ]
                    ]);
                }));
                function fetchExperimentValues(_x2, _x3, _x4) {
                    return _fetchExperimentValues.apply(this, arguments);
                }
                return fetchExperimentValues;
            }()
        },
        {
            key: "handleResponseError",
            value: function() {
                var _handleResponseError = (0, $b67fad0a126d5f92$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($b405b4a0324cf1d2$exports))).mark(function _callee3(response) {
                    var body;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($b405b4a0324cf1d2$exports))).wrap(function(_context3) {
                        while(true)switch(_context3.prev = _context3.next){
                            case 0:
                                if (response.ok) {
                                    _context3.next = 2;
                                    break;
                                }
                                _context3.next = 1;
                                return response.text();
                            case 1:
                                body = _context3.sent;
                                throw new (0, $4f899fb573e9f6bf$export$286baf652d0b1206)("Non 2xx response status received, status: ".concat(response.status, ", body: ").concat(JSON.stringify(body)));
                            case 2:
                                if (!(response.status === 204)) {
                                    _context3.next = 3;
                                    break;
                                }
                                throw new (0, $4f899fb573e9f6bf$export$286baf652d0b1206)('Unexpected 204 response');
                            case 3:
                            case "end":
                                return _context3.stop();
                        }
                    }, _callee3);
                }));
                function handleResponseError(_x5) {
                    return _handleResponseError.apply(this, arguments);
                }
                return handleResponseError;
            }()
        },
        {
            key: "extractResponseBody",
            value: function() {
                var _extractResponseBody = (0, $b67fad0a126d5f92$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($b405b4a0324cf1d2$exports))).mark(function _callee4(response) {
                    var value;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($b405b4a0324cf1d2$exports))).wrap(function(_context4) {
                        while(true)switch(_context4.prev = _context4.next){
                            case 0:
                                _context4.next = 1;
                                return response.text();
                            case 1:
                                value = _context4.sent;
                                return _context4.abrupt("return", JSON.parse(value));
                            case 2:
                            case "end":
                                return _context4.stop();
                        }
                    }, _callee4);
                }));
                function extractResponseBody(_x6) {
                    return _extractResponseBody.apply(this, arguments);
                }
                return extractResponseBody;
            }()
        },
        {
            key: "getBaseUrl",
            value: function getBaseUrl(serviceEnv) {
                var useGatewayUrl = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
                var perimeter = arguments.length > 2 ? arguments[2] : undefined;
                var isolationContextId = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
                if (useGatewayUrl) return $5422ff0610ef57b4$export$450bd8fb2a6d7ace;
                if (perimeter === (0, $c578c05f082e3c28$export$c42b7bbc5e7ba555).FEDRAMP_MODERATE) switch(serviceEnv){
                    case (0, $c578c05f082e3c28$export$479e7351a733299).Production:
                        return $5422ff0610ef57b4$export$18c93900db9358a4;
                    case (0, $c578c05f082e3c28$export$479e7351a733299).Staging:
                        return $5422ff0610ef57b4$export$1a401a0da8da3565;
                    default:
                        throw new Error("Invalid environment \"".concat(serviceEnv, "\" for \"").concat(perimeter, "\" perimeter"));
                }
                else if (perimeter === (0, $c578c05f082e3c28$export$c42b7bbc5e7ba555).COMMERCIAL) switch(serviceEnv){
                    case (0, $c578c05f082e3c28$export$479e7351a733299).Development:
                        return $5422ff0610ef57b4$export$f058dbf75c3bc647;
                    case (0, $c578c05f082e3c28$export$479e7351a733299).Staging:
                        var apiUrl = this.getApiUrl(isolationContextId);
                        if (apiUrl !== null) return apiUrl;
                        return $5422ff0610ef57b4$export$942ba04389b0d5a2;
                    default:
                        var prodApiUrl = this.getApiUrl(isolationContextId);
                        if (prodApiUrl !== null) return prodApiUrl;
                        return $5422ff0610ef57b4$export$250a58ecde616daa;
                }
                else throw new Error("Invalid perimeter \"".concat(perimeter, "\""));
            }
        },
        {
            key: "fetchRequest",
            value: function() {
                var _fetchRequest = (0, $b67fad0a126d5f92$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($b405b4a0324cf1d2$exports))).mark(function _callee5(path, method, fetcherOptions, body) {
                    var baseUrl, fetchTimeout, abortSignal, abortController, response;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($b405b4a0324cf1d2$exports))).wrap(function(_context5) {
                        while(true)switch(_context5.prev = _context5.next){
                            case 0:
                                baseUrl = Fetcher.getBaseUrl(fetcherOptions.environment, fetcherOptions.useGatewayURL, fetcherOptions.perimeter, fetcherOptions.isolationContextId);
                                fetchTimeout = fetcherOptions.fetchTimeoutMs || $5422ff0610ef57b4$var$DEFAULT_REQUEST_TIMEOUT_MS;
                                if (AbortSignal.timeout) abortSignal = AbortSignal.timeout(fetchTimeout);
                                else if (AbortController) {
                                    abortController = new AbortController();
                                    abortSignal = abortController.signal;
                                    setTimeout(function() {
                                        return abortController.abort();
                                    }, fetchTimeout);
                                }
                                _context5.next = 1;
                                return fetch("".concat(baseUrl).concat(path), $5422ff0610ef57b4$var$_objectSpread({
                                    method: method,
                                    headers: {
                                        'Content-Type': 'application/json',
                                        'X-Client-Name': 'feature-gate-js-client',
                                        'X-Client-Version': (0, $eb08f16a4c9618eb$export$a59f8d67326bd1cb),
                                        'X-API-KEY': fetcherOptions.apiKey
                                    },
                                    signal: abortSignal
                                }, body && {
                                    body: JSON.stringify(body)
                                }));
                            case 1:
                                response = _context5.sent;
                                _context5.next = 2;
                                return this.handleResponseError(response);
                            case 2:
                                _context5.next = 3;
                                return this.extractResponseBody(response);
                            case 3:
                                return _context5.abrupt("return", _context5.sent);
                            case 4:
                            case "end":
                                return _context5.stop();
                        }
                    }, _callee5, this);
                }));
                function fetchRequest(_x7, _x8, _x9, _x0) {
                    return _fetchRequest.apply(this, arguments);
                }
                return fetchRequest;
            }()
        },
        {
            key: "getApiUrl",
            value: function getApiUrl(isolationContextId) {
                var window1 = this.getWindowLocation();
                if (window1 === undefined) {
                    //this is needed when this SDK is used for SSR or plugin use cases where secret keys not available to use backend SDKs
                    if (!isolationContextId) return null;
                    return $5422ff0610ef57b4$export$4e8a0415edbfa1f7.replace('%s', isolationContextId);
                }
                var protocol = window1.protocol, hostname = window1.hostname;
                // Match last subdomain fragment before oasis-stg.com
                var oasisMatch = hostname.match(/([^.]+)\.oasis-stg\.com$/);
                if (oasisMatch) return "".concat(protocol, "//api.").concat(oasisMatch[1], ".").concat($5422ff0610ef57b4$export$cb3cd156f70d7e94);
                // Match last subdomain fragment before atlassian-isolated.net
                var isolatedMatch = hostname.match(/([^.]+)\.atlassian-isolated\.net$/);
                if (isolatedMatch) return "".concat(protocol, "//api.").concat(isolatedMatch[1], ".").concat($5422ff0610ef57b4$export$921fbc6cdfd4eee0);
                return null;
            }
        },
        {
            key: "getWindowLocation",
            value: function getWindowLocation() {
                if (typeof window !== 'undefined' && window.location) return window.location;
                return undefined;
            }
        }
    ]);
}();












var $iFR7a = parcelRequire("iFR7a");
function $94bd16fe8624b549$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $94bd16fe8624b549$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $94bd16fe8624b549$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $34bcf16a63c65c03$export$2e2bcd8739ae039)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $94bd16fe8624b549$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $94bd16fe8624b549$var$_callSuper(t, o, e) {
    return o = (0, $0738339b6a9f4e57$export$2e2bcd8739ae039)(o), (0, $c4a414505d241956$export$2e2bcd8739ae039)(t, $94bd16fe8624b549$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, $0738339b6a9f4e57$export$2e2bcd8739ae039)(t).constructor) : o.apply(t, e));
}
function $94bd16fe8624b549$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($94bd16fe8624b549$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $94bd16fe8624b549$var$_superPropGet(t, o, e, r) {
    var p = (0, $0550eca2bd453b09$export$2e2bcd8739ae039)((0, $0738339b6a9f4e57$export$2e2bcd8739ae039)(1 & r ? t.prototype : t), o, e);
    return 2 & r && "function" == typeof p ? function(t) {
        return p.apply(e, t);
    } : p;
}
var $94bd16fe8624b549$export$55fffef3474104af = /*#__PURE__*/ function(_DataAdapterCore) {
    function NoFetchDataAdapter() {
        var _this;
        (0, $a90d44c71774a73e$export$2e2bcd8739ae039)(this, NoFetchDataAdapter);
        _this = $94bd16fe8624b549$var$_callSuper(this, NoFetchDataAdapter, [
            'NoFetchDataAdapter',
            'nofetch'
        ]);
        (0, $34bcf16a63c65c03$export$2e2bcd8739ae039)(_this, "bootstrapResult", null);
        return _this;
    }
    /**
   * Make sure to call this **before** calling `initializeAsync` or `updateUserAsync` but
   * after the Statsig client has been created!
   */ (0, $56f9760db6bbedd7$export$2e2bcd8739ae039)(NoFetchDataAdapter, _DataAdapterCore);
    return (0, $a83b4b1801bd7063$export$2e2bcd8739ae039)(NoFetchDataAdapter, [
        {
            key: "setBootstrapData",
            value: function setBootstrapData(data) {
                this.bootstrapResult = data ? {
                    source: 'Bootstrap',
                    data: JSON.stringify(data),
                    receivedAt: Date.now(),
                    stableID: (0, $iFR7a.StableID).get(this._getSdkKey()),
                    fullUserHash: null
                } : null;
            }
        },
        {
            key: "prefetchData",
            value: function() {
                var _prefetchData = (0, $b67fad0a126d5f92$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($b405b4a0324cf1d2$exports))).mark(function _callee(_user, _options) {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($b405b4a0324cf1d2$exports))).wrap(function(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee);
                }));
                function prefetchData(_x, _x2) {
                    return _prefetchData.apply(this, arguments);
                }
                return prefetchData;
            }()
        },
        {
            key: "getDataAsync",
            value: function() {
                var _getDataAsync = (0, $b67fad0a126d5f92$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($b405b4a0324cf1d2$exports))).mark(function _callee2(_current, user, _options) {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($b405b4a0324cf1d2$exports))).wrap(function(_context2) {
                        while(true)switch(_context2.prev = _context2.next){
                            case 0:
                                return _context2.abrupt("return", this.bootstrapResult && $94bd16fe8624b549$var$_objectSpread($94bd16fe8624b549$var$_objectSpread({}, this.bootstrapResult), {}, {
                                    fullUserHash: (0, $iFR7a._getFullUserHash)(user)
                                }));
                            case 1:
                            case "end":
                                return _context2.stop();
                        }
                    }, _callee2, this);
                }));
                function getDataAsync(_x3, _x4, _x5) {
                    return _getDataAsync.apply(this, arguments);
                }
                return getDataAsync;
            }()
        },
        {
            key: "getDataSync",
            value: function getDataSync(user) {
                return this.bootstrapResult && $94bd16fe8624b549$var$_objectSpread($94bd16fe8624b549$var$_objectSpread({}, this.bootstrapResult), {}, {
                    fullUserHash: (0, $iFR7a._getFullUserHash)(user)
                });
            }
        },
        {
            key: "_fetchFromNetwork",
            value: function() {
                var _fetchFromNetwork2 = (0, $b67fad0a126d5f92$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($b405b4a0324cf1d2$exports))).mark(function _callee3(_current, _user, _options) {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($b405b4a0324cf1d2$exports))).wrap(function(_context3) {
                        while(true)switch(_context3.prev = _context3.next){
                            case 0:
                                return _context3.abrupt("return", null);
                            case 1:
                            case "end":
                                return _context3.stop();
                        }
                    }, _callee3);
                }));
                function _fetchFromNetwork(_x6, _x7, _x8) {
                    return _fetchFromNetwork2.apply(this, arguments);
                }
                return _fetchFromNetwork;
            }()
        },
        {
            key: "_getCacheKey",
            value: function _getCacheKey(user) {
                // Same logic as default data adapter
                // https://github.com/statsig-io/js-client-monorepo/blob/main/packages/js-client/src/StatsigEvaluationsDataAdapter.ts
                var key = (0, $iFR7a._getStorageKey)(this._getSdkKey(), user);
                return "".concat((0, $iFR7a.DataAdapterCachePrefix), ".").concat(this._cacheSuffix, ".").concat(key);
            }
        },
        {
            key: "_isCachedResultValidFor204",
            value: function _isCachedResultValidFor204(_result, _user) {
                return false;
            }
        },
        {
            key: "setDataLegacy",
            value: function setDataLegacy(data, user) {
                $94bd16fe8624b549$var$_superPropGet(NoFetchDataAdapter, "setData", this, 3)([
                    data,
                    user
                ]);
            }
        },
        {
            key: "toJSON",
            value: function toJSON() {
                var result = $94bd16fe8624b549$var$_objectSpread({}, this);
                delete result._options;
                delete result._inMemoryCache;
                delete result.bootstrapResult;
                return result;
            }
        }
    ]);
}((0, $iFR7a.DataAdapterCore));







var $dtn6l = parcelRequire("dtn6l");
function $012fa0397b4ea560$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $012fa0397b4ea560$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $012fa0397b4ea560$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $34bcf16a63c65c03$export$2e2bcd8739ae039)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $012fa0397b4ea560$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $012fa0397b4ea560$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $012fa0397b4ea560$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $012fa0397b4ea560$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $012fa0397b4ea560$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $012fa0397b4ea560$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $012fa0397b4ea560$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
var $012fa0397b4ea560$var$LOCAL_OVERRIDE_REASON = 'LocalOverride:Recognized';
var $012fa0397b4ea560$export$d8474cff104280f3 = 'STATSIG_OVERRIDES';
var $012fa0397b4ea560$var$LEGACY_LOCAL_STORAGE_KEY = 'STATSIG_JS_LITE_LOCAL_OVERRIDES';
var $012fa0397b4ea560$var$makeEmptyStore = function makeEmptyStore() {
    return {
        gates: {},
        configs: {},
        layers: {}
    };
};
var $012fa0397b4ea560$var$djb2MapKey = function djb2MapKey(hash, kind) {
    return kind + ':' + hash;
};
var $012fa0397b4ea560$export$bcb28fbac1def494 = /*#__PURE__*/ function() {
    function PersistentOverrideAdapter(localStorageKey) {
        (0, $a90d44c71774a73e$export$2e2bcd8739ae039)(this, PersistentOverrideAdapter);
        this._overrides = $012fa0397b4ea560$var$makeEmptyStore();
        this._djb2Map = new Map();
        this._localStorageKey = localStorageKey;
    }
    return (0, $a83b4b1801bd7063$export$2e2bcd8739ae039)(PersistentOverrideAdapter, [
        {
            key: "parseStoredOverrides",
            value: function parseStoredOverrides(localStorageKey) {
                try {
                    var json = window.localStorage.getItem(localStorageKey);
                    if (!json) return $012fa0397b4ea560$var$makeEmptyStore();
                    return JSON.parse(json);
                } catch (_unused) {
                    return $012fa0397b4ea560$var$makeEmptyStore();
                }
            }
        },
        {
            key: "mergeOverrides",
            value: function mergeOverrides() {
                var merged = $012fa0397b4ea560$var$makeEmptyStore();
                for(var _len = arguments.length, allOverrides = new Array(_len), _key = 0; _key < _len; _key++)allOverrides[_key] = arguments[_key];
                for(var _i = 0, _allOverrides = allOverrides; _i < _allOverrides.length; _i++){
                    var overrides = _allOverrides[_i];
                    for(var _i2 = 0, _Object$entries = Object.entries((_overrides$gates = overrides.gates) !== null && _overrides$gates !== void 0 ? _overrides$gates : {}); _i2 < _Object$entries.length; _i2++){
                        var _overrides$gates;
                        var _Object$entries$_i = (0, $1dc579c4de1142c2$export$2e2bcd8739ae039)(_Object$entries[_i2], 2), name = _Object$entries$_i[0], value = _Object$entries$_i[1];
                        merged.gates[name] = value;
                    }
                    for(var _i3 = 0, _Object$entries2 = Object.entries((_overrides$configs = overrides.configs) !== null && _overrides$configs !== void 0 ? _overrides$configs : {}); _i3 < _Object$entries2.length; _i3++){
                        var _overrides$configs;
                        var _Object$entries2$_i = (0, $1dc579c4de1142c2$export$2e2bcd8739ae039)(_Object$entries2[_i3], 2), _name = _Object$entries2$_i[0], _value = _Object$entries2$_i[1];
                        merged.configs[_name] = _value;
                    }
                    for(var _i4 = 0, _Object$entries3 = Object.entries((_overrides$layers = overrides.layers) !== null && _overrides$layers !== void 0 ? _overrides$layers : {}); _i4 < _Object$entries3.length; _i4++){
                        var _overrides$layers;
                        var _Object$entries3$_i = (0, $1dc579c4de1142c2$export$2e2bcd8739ae039)(_Object$entries3[_i4], 2), _name2 = _Object$entries3$_i[0], _value2 = _Object$entries3$_i[1];
                        merged.layers[_name2] = _value2;
                    }
                }
                return merged;
            }
        },
        {
            key: "initFromStoredOverrides",
            value: function initFromStoredOverrides() {
                var storedOverrides = this.mergeOverrides(this._overrides, this.parseStoredOverrides($012fa0397b4ea560$var$LEGACY_LOCAL_STORAGE_KEY), this.parseStoredOverrides(this._localStorageKey));
                // Clear data from legacy local storage key now we've read from it.
                // This prevents things being stuck in there that are always read but never written to.
                try {
                    window.localStorage.removeItem($012fa0397b4ea560$var$LEGACY_LOCAL_STORAGE_KEY);
                } catch (_unused2) {
                // ignored - window is not defined in non-browser environments, and we don't save things there
                // (things like SSR, etc)
                }
                // In version 4.24.0 we introduced hashes in this override adapter, but had a bug which would cause
                // multiple hashes to continue being created. This code here removes these hashes since we've moved
                // to using a more reliable and easier to maintain map in `_djb2Map`.
                for(var _i5 = 0, _Object$values = Object.values(storedOverrides); _i5 < _Object$values.length; _i5++){
                    var container = _Object$values[_i5];
                    var allKeys = new Set(Object.keys(container));
                    var _iterator = $012fa0397b4ea560$var$_createForOfIteratorHelper(allKeys), _step;
                    try {
                        for(_iterator.s(); !(_step = _iterator.n()).done;){
                            var name = _step.value;
                            var hash = (0, $dtn6l._DJB2)(name);
                            if (allKeys.has(hash)) delete container[hash];
                        }
                    } catch (err) {
                        _iterator.e(err);
                    } finally{
                        _iterator.f();
                    }
                }
                this.applyOverrides(storedOverrides);
            }
        },
        {
            key: "saveOverrides",
            value: function saveOverrides() {
                try {
                    window.localStorage.setItem(this._localStorageKey, JSON.stringify(this._overrides));
                } catch (_unused3) {
                // ignored - window is not defined in non-browser environments, and we don't save things there
                // (things like SSR, etc)
                }
            }
        },
        {
            key: "getOverrides",
            value: function getOverrides() {
                return this.mergeOverrides(this._overrides);
            }
        },
        {
            key: "applyOverrides",
            value: function applyOverrides(overrides) {
                var newOverrides = $012fa0397b4ea560$var$_objectSpread($012fa0397b4ea560$var$_objectSpread({}, $012fa0397b4ea560$var$makeEmptyStore()), overrides);
                this._djb2Map.clear();
                for(var _i6 = 0, _Object$entries4 = Object.entries(newOverrides); _i6 < _Object$entries4.length; _i6++){
                    var _Object$entries4$_i = (0, $1dc579c4de1142c2$export$2e2bcd8739ae039)(_Object$entries4[_i6], 2), containerName = _Object$entries4$_i[0], container = _Object$entries4$_i[1];
                    for(var _i7 = 0, _Object$entries5 = Object.entries(container); _i7 < _Object$entries5.length; _i7++){
                        var _Object$entries5$_i = (0, $1dc579c4de1142c2$export$2e2bcd8739ae039)(_Object$entries5[_i7], 2), name = _Object$entries5$_i[0], value = _Object$entries5$_i[1];
                        this._djb2Map.set($012fa0397b4ea560$var$djb2MapKey((0, $dtn6l._DJB2)(name), containerName), value);
                    }
                }
                this._overrides = newOverrides;
            }
        },
        {
            key: "setOverrides",
            value: function setOverrides(overrides) {
                this.applyOverrides(overrides);
                this.saveOverrides();
            }
        },
        {
            key: "overrideGate",
            value: function overrideGate(name, value) {
                this._overrides.gates[name] = value;
                this._djb2Map.set($012fa0397b4ea560$var$djb2MapKey((0, $dtn6l._DJB2)(name), 'gates'), value);
                this.saveOverrides();
            }
        },
        {
            key: "removeGateOverride",
            value: function removeGateOverride(name) {
                delete this._overrides.gates[name];
                this._djb2Map.delete($012fa0397b4ea560$var$djb2MapKey((0, $dtn6l._DJB2)(name), 'gates'));
                this.saveOverrides();
            }
        },
        {
            key: "getGateOverride",
            value: function getGateOverride(current, _user) {
                var _this$_overrides$gate;
                var overridden = (_this$_overrides$gate = this._overrides.gates[current.name]) !== null && _this$_overrides$gate !== void 0 ? _this$_overrides$gate : this._djb2Map.get($012fa0397b4ea560$var$djb2MapKey(current.name, 'gates'));
                if (overridden == null) return null;
                return $012fa0397b4ea560$var$_objectSpread($012fa0397b4ea560$var$_objectSpread({}, current), {}, {
                    value: overridden,
                    details: $012fa0397b4ea560$var$_objectSpread($012fa0397b4ea560$var$_objectSpread({}, current.details), {}, {
                        reason: $012fa0397b4ea560$var$LOCAL_OVERRIDE_REASON
                    })
                });
            }
        },
        {
            key: "overrideDynamicConfig",
            value: function overrideDynamicConfig(name, value) {
                this._overrides.configs[name] = value;
                this._djb2Map.set($012fa0397b4ea560$var$djb2MapKey((0, $dtn6l._DJB2)(name), 'configs'), value);
                this.saveOverrides();
            }
        },
        {
            key: "removeDynamicConfigOverride",
            value: function removeDynamicConfigOverride(name) {
                delete this._overrides.configs[name];
                this._djb2Map.delete($012fa0397b4ea560$var$djb2MapKey((0, $dtn6l._DJB2)(name), 'configs'));
                this.saveOverrides();
            }
        },
        {
            key: "getDynamicConfigOverride",
            value: function getDynamicConfigOverride(current, _user) {
                return this._getConfigOverride(current, this._overrides.configs);
            }
        },
        {
            key: "overrideExperiment",
            value: function overrideExperiment(name, value) {
                this._overrides.configs[name] = value;
                this._djb2Map.set($012fa0397b4ea560$var$djb2MapKey((0, $dtn6l._DJB2)(name), 'configs'), value);
                this.saveOverrides();
            }
        },
        {
            key: "removeExperimentOverride",
            value: function removeExperimentOverride(name) {
                delete this._overrides.configs[name];
                this._djb2Map.delete($012fa0397b4ea560$var$djb2MapKey((0, $dtn6l._DJB2)(name), 'configs'));
                this.saveOverrides();
            }
        },
        {
            key: "getExperimentOverride",
            value: function getExperimentOverride(current, _user) {
                return this._getConfigOverride(current, this._overrides.configs);
            }
        },
        {
            key: "overrideLayer",
            value: function overrideLayer(name, value) {
                this._overrides.layers[name] = value;
                this._djb2Map.set($012fa0397b4ea560$var$djb2MapKey((0, $dtn6l._DJB2)(name), 'layers'), value);
                this.saveOverrides();
            }
        },
        {
            key: "removeLayerOverride",
            value: function removeLayerOverride(name) {
                delete this._overrides.layers[name];
                this._djb2Map.delete($012fa0397b4ea560$var$djb2MapKey((0, $dtn6l._DJB2)(name), 'layers'));
                this.saveOverrides();
            }
        },
        {
            key: "removeAllOverrides",
            value: function removeAllOverrides() {
                this._overrides = $012fa0397b4ea560$var$makeEmptyStore();
                try {
                    window.localStorage.removeItem(this._localStorageKey);
                } catch (_unused4) {
                // ignored - window is not defined in non-browser environments, and we don't save things there
                // (things like SSR, etc)
                }
            }
        },
        {
            key: "getLayerOverride",
            value: function getLayerOverride(current, _user) {
                var _this$_overrides$laye;
                var overridden = (_this$_overrides$laye = this._overrides.layers[current.name]) !== null && _this$_overrides$laye !== void 0 ? _this$_overrides$laye : this._djb2Map.get($012fa0397b4ea560$var$djb2MapKey(current.name, 'layers'));
                if (overridden == null) return null;
                return $012fa0397b4ea560$var$_objectSpread($012fa0397b4ea560$var$_objectSpread({}, current), {}, {
                    __value: overridden,
                    get: (0, $dtn6l._makeTypedGet)(current.name, overridden),
                    details: $012fa0397b4ea560$var$_objectSpread($012fa0397b4ea560$var$_objectSpread({}, current.details), {}, {
                        reason: $012fa0397b4ea560$var$LOCAL_OVERRIDE_REASON
                    })
                });
            }
        },
        {
            key: "_getConfigOverride",
            value: function _getConfigOverride(current, lookup) {
                var _lookup$current$name;
                var overridden = (_lookup$current$name = lookup[current.name]) !== null && _lookup$current$name !== void 0 ? _lookup$current$name : this._djb2Map.get($012fa0397b4ea560$var$djb2MapKey(current.name, 'configs'));
                if (overridden == null) return null;
                return $012fa0397b4ea560$var$_objectSpread($012fa0397b4ea560$var$_objectSpread({}, current), {}, {
                    value: overridden,
                    get: (0, $dtn6l._makeTypedGet)(current.name, overridden),
                    details: $012fa0397b4ea560$var$_objectSpread($012fa0397b4ea560$var$_objectSpread({}, current.details), {}, {
                        reason: $012fa0397b4ea560$var$LOCAL_OVERRIDE_REASON
                    })
                });
            }
        }
    ]);
}();





var $9d177b33609fde4a$var$_excluded = [
    "sdkKey",
    "environment",
    "updateUserCompletionCallback",
    "perimeter"
];
function $9d177b33609fde4a$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $9d177b33609fde4a$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $9d177b33609fde4a$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $34bcf16a63c65c03$export$2e2bcd8739ae039)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $9d177b33609fde4a$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $9d177b33609fde4a$var$DEFAULT_CLIENT_KEY = 'client-default-key';
// default event logging api is Atlassian proxy rather than Statsig's domain, to avoid ad blockers
var $9d177b33609fde4a$var$DEFAULT_EVENT_LOGGING_API = 'https://xp.atlassian.com/v1/rgstr';
var $9d177b33609fde4a$export$1f2bb630327ac4b6 = /*#__PURE__*/ function() {
    function Client() {
        var _this = this;
        var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, _ref$localStorageKey = _ref.localStorageKey, localStorageKey = _ref$localStorageKey === void 0 ? (0, $012fa0397b4ea560$export$d8474cff104280f3) : _ref$localStorageKey, overrideAdapter = _ref.overrideAdapter;
        (0, $a90d44c71774a73e$export$2e2bcd8739ae039)(this, Client);
        (0, $34bcf16a63c65c03$export$2e2bcd8739ae039)(this, "initPromise", null);
        /** True if an initialize method was called and completed successfully. */ (0, $34bcf16a63c65c03$export$2e2bcd8739ae039)(this, "initCompleted", false);
        /**
     * True if an initialize method was called and completed, meaning the client is now usable.
     * However if there was an error during initialization it may have initialized with default
     * values. Use {@link initCompleted} to check for this.
     */ (0, $34bcf16a63c65c03$export$2e2bcd8739ae039)(this, "initWithDefaults", false);
        (0, $34bcf16a63c65c03$export$2e2bcd8739ae039)(this, "hasCheckGateErrorOccurred", false);
        (0, $34bcf16a63c65c03$export$2e2bcd8739ae039)(this, "hasGetExperimentErrorOccurred", false);
        (0, $34bcf16a63c65c03$export$2e2bcd8739ae039)(this, "hasGetExperimentValueErrorOccurred", false);
        (0, $34bcf16a63c65c03$export$2e2bcd8739ae039)(this, "hasGetLayerErrorOccurred", false);
        (0, $34bcf16a63c65c03$export$2e2bcd8739ae039)(this, "hasGetLayerValueErrorOccurred", false);
        (0, $34bcf16a63c65c03$export$2e2bcd8739ae039)(this, "subscriptions", new (0, $d9dca6217d358e09$export$2e2bcd8739ae039)());
        (0, $34bcf16a63c65c03$export$2e2bcd8739ae039)(this, "dataAdapter", new (0, $94bd16fe8624b549$export$55fffef3474104af)());
        /**
     * Call this if modifying the values being served by the Statsig library since it has its own
     * memoization cache which will not be updated if the values are changed outside of the library.
     */ (0, $34bcf16a63c65c03$export$2e2bcd8739ae039)(this, "statsigValuesUpdated", function() {
            if (_this.user) // Trigger a reset of the memoize cache
            _this.statsigClient.updateUserSync(_this.user, {
                disableBackgroundCacheRefresh: true
            });
            _this.subscriptions.anyUpdated();
        });
        this.overrideAdapter = overrideAdapter || new (0, $012fa0397b4ea560$export$bcb28fbac1def494)(localStorageKey);
    }
    /**
   * @description
   * This method initializes the client using a network call to fetch the bootstrap values.
   * If the client is inialized with an `analyticsWebClient`, it will send an operational event
   * to GASv3 with the following attributes:
   * - targetApp: the target app of the client
   * - clientVersion: the version of the client
   * - success: whether the initialization was successful
   * - startTime: the time when the initialization started
   * - totalTime: the total time it took to initialize the client
   * - apiKey: the api key used to initialize the client
   * @param clientOptions {ClientOptions}
   * @param identifiers {Identifiers}
   * @param customAttributes {CustomAttributes}
   * @returns {Promise<void>}
   */ return (0, $a83b4b1801bd7063$export$2e2bcd8739ae039)(Client, [
        {
            key: "initialize",
            value: function() {
                var _initialize = (0, $b67fad0a126d5f92$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($b405b4a0324cf1d2$exports))).mark(function _callee(clientOptions, identifiers, customAttributes) {
                    var _this2 = this;
                    var clientOptionsWithDefaults, startTime;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($b405b4a0324cf1d2$exports))).wrap(function(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                clientOptionsWithDefaults = (0, $d16a8fcdfb06c5ab$export$d119b37e5f788b43)(clientOptions);
                                if (!this.initPromise) {
                                    _context.next = 1;
                                    break;
                                }
                                if (!(0, $d16a8fcdfb06c5ab$export$fa1c2bbf4100b8bc)(clientOptionsWithDefaults, this.initOptions)) // eslint-disable-next-line no-console
                                console.warn('Feature Gates client already initialized with different options. New options were not applied.');
                                return _context.abrupt("return", this.initPromise);
                            case 1:
                                startTime = performance.now();
                                this.initOptions = clientOptionsWithDefaults;
                                this.initPromise = this.init(clientOptionsWithDefaults, identifiers, customAttributes).then(function() {
                                    _this2.initCompleted = true;
                                    _this2.initWithDefaults = true;
                                }).finally(function() {
                                    var endTime = performance.now();
                                    var totalTime = endTime - startTime;
                                    _this2.fireClientEvent(startTime, totalTime, 'initialize', _this2.initCompleted, clientOptionsWithDefaults.apiKey);
                                });
                                return _context.abrupt("return", this.initPromise);
                            case 2:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee, this);
                }));
                function initialize(_x, _x2, _x3) {
                    return _initialize.apply(this, arguments);
                }
                return initialize;
            }()
        },
        {
            key: "initializeWithProvider",
            value: function() {
                var _initializeWithProvider = (0, $b67fad0a126d5f92$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($b405b4a0324cf1d2$exports))).mark(function _callee2(clientOptions, provider, identifiers, customAttributes) {
                    var _this3 = this;
                    var clientOptionsWithDefaults, startTime;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($b405b4a0324cf1d2$exports))).wrap(function(_context2) {
                        while(true)switch(_context2.prev = _context2.next){
                            case 0:
                                clientOptionsWithDefaults = (0, $d16a8fcdfb06c5ab$export$d119b37e5f788b43)(clientOptions);
                                if (!this.initPromise) {
                                    _context2.next = 1;
                                    break;
                                }
                                if (!(0, $d16a8fcdfb06c5ab$export$fa1c2bbf4100b8bc)(clientOptionsWithDefaults, this.initOptions)) // eslint-disable-next-line no-console
                                console.warn('Feature Gates client already initialized with different options. New options were not applied.');
                                return _context2.abrupt("return", this.initPromise);
                            case 1:
                                startTime = performance.now();
                                this.initOptions = clientOptionsWithDefaults;
                                this.provider = provider;
                                this.provider.setClientVersion((0, $eb08f16a4c9618eb$export$a59f8d67326bd1cb));
                                if (this.provider.setApplyUpdateCallback) this.provider.setApplyUpdateCallback(this.applyUpdateCallback.bind(this));
                                this.initPromise = this.initWithProvider(clientOptionsWithDefaults, provider, identifiers, customAttributes).then(function() {
                                    _this3.initCompleted = true;
                                    _this3.initWithDefaults = true;
                                }).finally(function() {
                                    var endTime = performance.now();
                                    var totalTime = endTime - startTime;
                                    _this3.fireClientEvent(startTime, totalTime, 'initializeWithProvider', _this3.initCompleted, provider.getApiKey ? provider.getApiKey() : undefined);
                                });
                                return _context2.abrupt("return", this.initPromise);
                            case 2:
                            case "end":
                                return _context2.stop();
                        }
                    }, _callee2, this);
                }));
                function initializeWithProvider(_x4, _x5, _x6, _x7) {
                    return _initializeWithProvider.apply(this, arguments);
                }
                return initializeWithProvider;
            }()
        },
        {
            key: "applyUpdateCallback",
            value: function applyUpdateCallback(experimentsResult) {
                try {
                    if (this.initCompleted || this.initWithDefaults) {
                        this.assertInitialized(this.statsigClient);
                        this.dataAdapter.setBootstrapData(experimentsResult.experimentValues);
                        this.dataAdapter.setData(JSON.stringify(experimentsResult.experimentValues));
                        this.statsigValuesUpdated();
                    }
                } catch (error) {
                    // eslint-disable-next-line no-console
                    console.warn('Error when attempting to apply update', error);
                }
            }
        },
        {
            key: "fireClientEvent",
            value: function fireClientEvent(startTime, totalTime, action, success) {
                var _analyticsWebClient, _this4 = this;
                var apiKey = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;
                (_analyticsWebClient = this.initOptions.analyticsWebClient) === null || _analyticsWebClient === void 0 || _analyticsWebClient.then(function(analyticsWebClient) {
                    var attributes = $9d177b33609fde4a$var$_objectSpread({
                        targetApp: _this4.initOptions.targetApp,
                        clientVersion: (0, $eb08f16a4c9618eb$export$a59f8d67326bd1cb),
                        success: success,
                        startTime: startTime,
                        totalTime: totalTime
                    }, apiKey && {
                        apiKey: apiKey
                    });
                    analyticsWebClient.sendOperationalEvent({
                        action: action,
                        actionSubject: 'featureGatesClient',
                        attributes: attributes,
                        tags: [
                            'measurement'
                        ],
                        source: '@atlaskit/feature-gate-js-client'
                    });
                }).catch(function(err) {
                    if (_this4.initOptions.environment !== (0, $c578c05f082e3c28$export$479e7351a733299).Production) // eslint-disable-next-line no-console
                    console.error('Analytics web client promise did not resolve', err);
                });
            }
        },
        {
            key: "initializeFromValues",
            value: function() {
                var _initializeFromValues = (0, $b67fad0a126d5f92$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($b405b4a0324cf1d2$exports))).mark(function _callee3(clientOptions, identifiers, customAttributes) {
                    var _this5 = this;
                    var initializeValues, clientOptionsWithDefaults, startTime, _args3 = arguments;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($b405b4a0324cf1d2$exports))).wrap(function(_context3) {
                        while(true)switch(_context3.prev = _context3.next){
                            case 0:
                                initializeValues = _args3.length > 3 && _args3[3] !== undefined ? _args3[3] : {};
                                clientOptionsWithDefaults = (0, $d16a8fcdfb06c5ab$export$d119b37e5f788b43)(clientOptions);
                                if (!this.initPromise) {
                                    _context3.next = 1;
                                    break;
                                }
                                if (!(0, $d16a8fcdfb06c5ab$export$fa1c2bbf4100b8bc)(clientOptionsWithDefaults, this.initOptions)) // eslint-disable-next-line no-console
                                console.warn('Feature Gates client already initialized with different options. New options were not applied.');
                                return _context3.abrupt("return", this.initPromise);
                            case 1:
                                // This makes sure the new Statsig client behaves like the old when bootstrap data is
                                // passed, and `has_updates` isn't specified (which happens a lot in product integration tests).
                                if (!Object.prototype.hasOwnProperty.call(initializeValues, 'has_updates')) initializeValues['has_updates'] = true;
                                startTime = performance.now();
                                this.initOptions = clientOptionsWithDefaults;
                                this.initPromise = this.initFromValues(clientOptionsWithDefaults, identifiers, customAttributes, initializeValues).then(function() {
                                    _this5.initCompleted = true;
                                    _this5.initWithDefaults = true;
                                }).finally(function() {
                                    var endTime = performance.now();
                                    var totalTime = endTime - startTime;
                                    _this5.fireClientEvent(startTime, totalTime, 'initializeFromValues', _this5.initCompleted);
                                });
                                return _context3.abrupt("return", this.initPromise);
                            case 2:
                            case "end":
                                return _context3.stop();
                        }
                    }, _callee3, this);
                }));
                function initializeFromValues(_x8, _x9, _x0) {
                    return _initializeFromValues.apply(this, arguments);
                }
                return initializeFromValues;
            }()
        },
        {
            key: "assertInitialized",
            value: function assertInitialized(statsigClient) {
                if (!statsigClient) throw new Error('Client must be initialized before using this method');
            }
        },
        {
            key: "updateUser",
            value: function() {
                var _updateUser = (0, $b67fad0a126d5f92$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($b405b4a0324cf1d2$exports))).mark(function _callee4(fetchOptions, identifiers, customAttributes) {
                    var fetchOptionsWithDefaults, initializeValuesProducer;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($b405b4a0324cf1d2$exports))).wrap(function(_context4) {
                        while(true)switch(_context4.prev = _context4.next){
                            case 0:
                                this.assertInitialized(this.statsigClient);
                                fetchOptionsWithDefaults = (0, $d16a8fcdfb06c5ab$export$d119b37e5f788b43)(fetchOptions);
                                initializeValuesProducer = function initializeValuesProducer() {
                                    return (0, $5422ff0610ef57b4$export$2e2bcd8739ae039).fetchExperimentValues(fetchOptionsWithDefaults, identifiers, customAttributes).then(function(_ref2) {
                                        var experimentValues = _ref2.experimentValues, customAttributes = _ref2.customAttributes;
                                        return {
                                            experimentValues: experimentValues,
                                            customAttributesFromFetch: customAttributes
                                        };
                                    });
                                };
                                _context4.next = 1;
                                return this.updateUserUsingInitializeValuesProducer(initializeValuesProducer, identifiers, customAttributes);
                            case 1:
                            case "end":
                                return _context4.stop();
                        }
                    }, _callee4, this);
                }));
                function updateUser(_x1, _x10, _x11) {
                    return _updateUser.apply(this, arguments);
                }
                return updateUser;
            }()
        },
        {
            key: "updateUserWithProvider",
            value: function() {
                var _updateUserWithProvider = (0, $b67fad0a126d5f92$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($b405b4a0324cf1d2$exports))).mark(function _callee5(identifiers, customAttributes) {
                    var _this6 = this;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($b405b4a0324cf1d2$exports))).wrap(function(_context5) {
                        while(true)switch(_context5.prev = _context5.next){
                            case 0:
                                this.assertInitialized(this.statsigClient);
                                if (this.provider) {
                                    _context5.next = 1;
                                    break;
                                }
                                throw new Error('Cannot update user using provider as the client was not initialised with a provider');
                            case 1:
                                _context5.next = 2;
                                return this.provider.setProfile(this.initOptions, identifiers, customAttributes);
                            case 2:
                                _context5.next = 3;
                                return this.updateUserUsingInitializeValuesProducer(function() {
                                    return _this6.provider.getExperimentValues();
                                }, identifiers, customAttributes);
                            case 3:
                            case "end":
                                return _context5.stop();
                        }
                    }, _callee5, this);
                }));
                function updateUserWithProvider(_x12, _x13) {
                    return _updateUserWithProvider.apply(this, arguments);
                }
                return updateUserWithProvider;
            }()
        },
        {
            key: "updateUserWithValues",
            value: function() {
                var _updateUserWithValues = (0, $b67fad0a126d5f92$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($b405b4a0324cf1d2$exports))).mark(function _callee6(identifiers, customAttributes) {
                    var initializeValues, initializeValuesProducer, _args6 = arguments;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($b405b4a0324cf1d2$exports))).wrap(function(_context6) {
                        while(true)switch(_context6.prev = _context6.next){
                            case 0:
                                initializeValues = _args6.length > 2 && _args6[2] !== undefined ? _args6[2] : {};
                                this.assertInitialized(this.statsigClient);
                                initializeValuesProducer = function initializeValuesProducer() {
                                    return Promise.resolve({
                                        experimentValues: initializeValues,
                                        customAttributesFromFetch: customAttributes
                                    });
                                };
                                _context6.next = 1;
                                return this.updateUserUsingInitializeValuesProducer(initializeValuesProducer, identifiers, customAttributes);
                            case 1:
                            case "end":
                                return _context6.stop();
                        }
                    }, _callee6, this);
                }));
                function updateUserWithValues(_x14, _x15) {
                    return _updateUserWithValues.apply(this, arguments);
                }
                return updateUserWithValues;
            }()
        },
        {
            key: "initializeCalled",
            value: function initializeCalled() {
                return this.initPromise != null;
            }
        },
        {
            key: "initializeCompleted",
            value: function initializeCompleted() {
                return this.initCompleted;
            }
        },
        {
            key: "waitUntilInitializeCompleted",
            value: function() {
                var _waitUntilInitializeCompleted = (0, $b67fad0a126d5f92$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($b405b4a0324cf1d2$exports))).mark(function _callee7() {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($b405b4a0324cf1d2$exports))).wrap(function(_context7) {
                        while(true)switch(_context7.prev = _context7.next){
                            case 0:
                                if (this.initPromise) {
                                    _context7.next = 1;
                                    break;
                                }
                                throw new Error('The client must be initialized before you can wait until initialized.');
                            case 1:
                                if (!this.initCompleted) {
                                    _context7.next = 2;
                                    break;
                                }
                                return _context7.abrupt("return");
                            case 2:
                                _context7.next = 3;
                                return this.initPromise;
                            case 3:
                            case "end":
                                return _context7.stop();
                        }
                    }, _callee7, this);
                }));
                function waitUntilInitializeCompleted() {
                    return _waitUntilInitializeCompleted.apply(this, arguments);
                }
                return waitUntilInitializeCompleted;
            }()
        },
        {
            key: "checkGate",
            value: function checkGate(gateName) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                try {
                    this.assertInitialized(this.statsigClient);
                    var _options$fireGateExpo = options.fireGateExposure, fireGateExposure = _options$fireGateExpo === void 0 ? true : _options$fireGateExpo;
                    return this.statsigClient.checkGate(gateName, {
                        disableExposureLog: !fireGateExposure
                    });
                } catch (error) {
                    // Log the first occurrence of the error
                    if (!this.hasCheckGateErrorOccurred) {
                        // eslint-disable-next-line no-console
                        console.warn({
                            msg: 'An error has occurred checking the feature gate. Only the first occurrence of this error is logged.',
                            gateName: gateName,
                            error: error
                        });
                        this.hasCheckGateErrorOccurred = true;
                    }
                    return false;
                }
            }
        },
        {
            key: "isGateExist",
            value: function isGateExist(gateName) {
                try {
                    this.assertInitialized(this.statsigClient);
                    var gate = this.statsigClient.getFeatureGate(gateName, {
                        disableExposureLog: true
                    });
                    return !gate.details.reason.includes('Unrecognized');
                } catch (error) {
                    // eslint-disable-next-line no-console
                    console.error("Error occurred when trying to check FeatureGate: ".concat(error));
                    // in case of error report true to avoid false positives.
                    return true;
                }
            }
        },
        {
            key: "isExperimentExist",
            value: function isExperimentExist(experimentName) {
                try {
                    this.assertInitialized(this.statsigClient);
                    var config = this.statsigClient.getExperiment(experimentName, {
                        disableExposureLog: true
                    });
                    return !config.details.reason.includes('Unrecognized');
                } catch (error) {
                    // eslint-disable-next-line no-console
                    console.error("Error occurred when trying to check Experiment: ".concat(error));
                    // in case of error report true to avoid false positives.
                    return true;
                }
            }
        },
        {
            key: "manuallyLogGateExposure",
            value: function manuallyLogGateExposure(gateName) {
                this.assertInitialized(this.statsigClient);
                // This is the approach recommended in the docs
                // https://docs.statsig.com/client/javascript-sdk/#manual-exposures-
                this.statsigClient.checkGate(gateName);
            }
        },
        {
            key: "getExperiment",
            value: function getExperiment(experimentName) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                try {
                    this.assertInitialized(this.statsigClient);
                    var _options$fireExperime = options.fireExperimentExposure, fireExperimentExposure = _options$fireExperime === void 0 ? true : _options$fireExperime;
                    return (0, $2fc45f5524794bb4$export$6dc24881a3d96325).fromExperiment(this.statsigClient.getExperiment(experimentName, {
                        disableExposureLog: !fireExperimentExposure
                    }));
                } catch (error) {
                    // Log the first occurrence of the error
                    if (!this.hasGetExperimentErrorOccurred) {
                        // eslint-disable-next-line no-console
                        console.warn({
                            msg: 'An error has occurred getting the experiment. Only the first occurrence of this error is logged.',
                            experimentName: experimentName,
                            error: error
                        });
                        this.hasGetExperimentErrorOccurred = true;
                    }
                    // Return a default value
                    return new (0, $2fc45f5524794bb4$export$6dc24881a3d96325)(experimentName, {}, '', {
                        time: Date.now(),
                        reason: (0, $5be6d0aa4a90cba5$export$c62558b199e46828).Error
                    });
                }
            }
        },
        {
            key: "getExperimentValue",
            value: function getExperimentValue(experimentName, parameterName, defaultValue) {
                var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var experiment = this.getExperiment(experimentName, options);
                try {
                    var typeGuard = options.typeGuard;
                    return experiment.get(parameterName, defaultValue, typeGuard);
                } catch (error) {
                    // Log the first occurrence of the error
                    if (!this.hasGetExperimentValueErrorOccurred) {
                        // eslint-disable-next-line no-console
                        console.warn({
                            msg: 'An error has occurred getting the experiment value. Only the first occurrence of this error is logged.',
                            experimentName: experimentName,
                            defaultValue: defaultValue,
                            options: options,
                            error: error
                        });
                        this.hasGetExperimentValueErrorOccurred = true;
                    }
                    return defaultValue;
                }
            }
        },
        {
            key: "manuallyLogExperimentExposure",
            value: function manuallyLogExperimentExposure(experimentName) {
                this.assertInitialized(this.statsigClient);
                // This is the approach recommended in the docs
                // https://docs.statsig.com/client/javascript-sdk/#manual-exposures-
                this.statsigClient.getExperiment(experimentName);
            }
        },
        {
            key: "manuallyLogLayerExposure",
            value: function manuallyLogLayerExposure(layerName, parameterName) {
                var _this$statsigClient$g;
                this.assertInitialized(this.statsigClient);
                // This is the approach recommended in the docs
                // https://docs.statsig.com/client/javascript-sdk/#manual-exposures-
                (_this$statsigClient$g = this.statsigClient.getLayer(layerName)) === null || _this$statsigClient$g === void 0 || _this$statsigClient$g.get(parameterName);
            }
        },
        {
            key: "shutdownStatsig",
            value: function shutdownStatsig() {
                this.assertInitialized(this.statsigClient);
                this.statsigClient.shutdown();
            }
        },
        {
            key: "overrideGate",
            value: function overrideGate(gateName, value) {
                this.overrideAdapter.overrideGate(gateName, value);
                // Trigger a reset of the memoized gate value
                if (this.user) {
                    var _this$statsigClient;
                    (_this$statsigClient = this.statsigClient) === null || _this$statsigClient === void 0 || _this$statsigClient.updateUserSync(this.user, {
                        disableBackgroundCacheRefresh: true
                    });
                }
                this.statsigValuesUpdated();
            }
        },
        {
            key: "clearGateOverride",
            value: function clearGateOverride(gateName) {
                this.overrideAdapter.removeGateOverride(gateName);
                this.statsigValuesUpdated();
            }
        },
        {
            key: "overrideConfig",
            value: function overrideConfig(experimentName, values) {
                this.overrideAdapter.overrideDynamicConfig(experimentName, values);
                this.statsigValuesUpdated();
            }
        },
        {
            key: "clearConfigOverride",
            value: function clearConfigOverride(experimentName) {
                this.overrideAdapter.removeDynamicConfigOverride(experimentName);
                this.statsigValuesUpdated();
            }
        },
        {
            key: "setOverrides",
            value: function setOverrides(overrides) {
                this.overrideAdapter.setOverrides(overrides);
                this.statsigValuesUpdated();
            }
        },
        {
            key: "getOverrides",
            value: function getOverrides() {
                return this.overrideAdapter.getOverrides();
            }
        },
        {
            key: "clearAllOverrides",
            value: function clearAllOverrides() {
                this.overrideAdapter.removeAllOverrides();
                this.statsigValuesUpdated();
            }
        },
        {
            key: "isCurrentUser",
            value: function isCurrentUser(identifiers, customAttributes) {
                return (0, $d16a8fcdfb06c5ab$export$fa1c2bbf4100b8bc)(this.currentIdentifiers, identifiers) && (0, $d16a8fcdfb06c5ab$export$fa1c2bbf4100b8bc)(this.currentAttributes, customAttributes);
            }
        },
        {
            key: "onGateUpdated",
            value: function onGateUpdated(gateName, callback) {
                var _this7 = this;
                var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                var wrapCallback = function wrapCallback(value) {
                    var _options$fireGateExpo2 = options.fireGateExposure, fireGateExposure = _options$fireGateExpo2 === void 0 ? true : _options$fireGateExpo2;
                    if (fireGateExposure) _this7.manuallyLogGateExposure(gateName);
                    try {
                        callback(value);
                    } catch (error) {
                        // eslint-disable-next-line no-console
                        console.warn("Error calling callback for gate ".concat(gateName, " with value ").concat(value), error);
                    }
                };
                return this.subscriptions.onGateUpdated(gateName, wrapCallback, this.checkGate.bind(this), options);
            }
        },
        {
            key: "onExperimentValueUpdated",
            value: function onExperimentValueUpdated(experimentName, parameterName, defaultValue, callback) {
                var _this8 = this;
                var options = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
                var wrapCallback = function wrapCallback(value) {
                    var _options$fireExperime2 = options.fireExperimentExposure, fireExperimentExposure = _options$fireExperime2 === void 0 ? true : _options$fireExperime2;
                    if (fireExperimentExposure) _this8.manuallyLogExperimentExposure(experimentName);
                    try {
                        callback(value);
                    } catch (error) {
                        // eslint-disable-next-line no-console
                        console.warn("Error calling callback for experiment ".concat(experimentName, " with value ").concat(value), error);
                    }
                };
                return this.subscriptions.onExperimentValueUpdated(experimentName, parameterName, defaultValue, wrapCallback, this.getExperimentValue.bind(this), options);
            }
        },
        {
            key: "onAnyUpdated",
            value: function onAnyUpdated(callback) {
                return this.subscriptions.onAnyUpdated(callback);
            }
        },
        {
            key: "init",
            value: function() {
                var _init = (0, $b67fad0a126d5f92$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($b405b4a0324cf1d2$exports))).mark(function _callee8(clientOptions, identifiers, customAttributes) {
                    var fromValuesClientOptions, experimentValues, customAttributesFromResult, clientSdkKeyPromise, experimentValuesPromise, _yield$Promise$all, _yield$Promise$all2, experimentValuesResult, _t;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($b405b4a0324cf1d2$exports))).wrap(function(_context8) {
                        while(true)switch(_context8.prev = _context8.next){
                            case 0:
                                fromValuesClientOptions = $9d177b33609fde4a$var$_objectSpread({}, clientOptions);
                                if (!clientOptions.localMode) {
                                    _context8.next = 2;
                                    break;
                                }
                                _context8.next = 1;
                                return this.initFromValues(fromValuesClientOptions, identifiers, customAttributes);
                            case 1:
                                return _context8.abrupt("return");
                            case 2:
                                _context8.prev = 2;
                                // If client sdk key fetch fails, an error would be thrown and handled instead of waiting for
                                // the experiment values request to be settled, and it will fall back to use default values.
                                clientSdkKeyPromise = (0, $5422ff0610ef57b4$export$2e2bcd8739ae039).fetchClientSdk(clientOptions).then(function(value) {
                                    return fromValuesClientOptions.sdkKey = value.clientSdkKey;
                                });
                                experimentValuesPromise = (0, $5422ff0610ef57b4$export$2e2bcd8739ae039).fetchExperimentValues(clientOptions, identifiers, customAttributes); // Only wait for the experiment values request to finish and try to initialise the client
                                // with experiment values if both requests are successful. Else an error would be thrown and
                                // handled by the catch
                                _context8.next = 3;
                                return Promise.all([
                                    clientSdkKeyPromise,
                                    experimentValuesPromise
                                ]);
                            case 3:
                                _yield$Promise$all = _context8.sent;
                                _yield$Promise$all2 = (0, $1dc579c4de1142c2$export$2e2bcd8739ae039)(_yield$Promise$all, 2);
                                experimentValuesResult = _yield$Promise$all2[1];
                                experimentValues = experimentValuesResult.experimentValues;
                                customAttributesFromResult = experimentValuesResult.customAttributes;
                                _context8.next = 6;
                                break;
                            case 4:
                                _context8.prev = 4;
                                _t = _context8["catch"](2);
                                if (_t instanceof Error) // eslint-disable-next-line no-console
                                console.error("Error occurred when trying to fetch the Feature Gates client values, error: ".concat(_t === null || _t === void 0 ? void 0 : _t.message));
                                // eslint-disable-next-line no-console
                                console.warn("Initialising Statsig client without values");
                                _context8.next = 5;
                                return this.initFromValues(fromValuesClientOptions, identifiers, customAttributes);
                            case 5:
                                throw _t;
                            case 6:
                                return _context8.abrupt("return", this.initFromValues(fromValuesClientOptions, identifiers, customAttributesFromResult, experimentValues));
                            case 7:
                            case "end":
                                return _context8.stop();
                        }
                    }, _callee8, this, [
                        [
                            2,
                            4
                        ]
                    ]);
                }));
                function init(_x16, _x17, _x18) {
                    return _init.apply(this, arguments);
                }
                return init;
            }()
        },
        {
            key: "initWithProvider",
            value: function() {
                var _initWithProvider = (0, $b67fad0a126d5f92$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($b405b4a0324cf1d2$exports))).mark(function _callee9(baseClientOptions, provider, identifiers, customAttributes) {
                    var fromValuesClientOptions, experimentValues, customAttributesFromResult, clientSdkKeyPromise, experimentValuesPromise, _yield$Promise$all3, _yield$Promise$all4, experimentValuesResult, _t2;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($b405b4a0324cf1d2$exports))).wrap(function(_context9) {
                        while(true)switch(_context9.prev = _context9.next){
                            case 0:
                                fromValuesClientOptions = $9d177b33609fde4a$var$_objectSpread($9d177b33609fde4a$var$_objectSpread({}, baseClientOptions), {}, {
                                    disableCurrentPageLogging: true
                                });
                                _context9.prev = 1;
                                _context9.next = 2;
                                return provider.setProfile(baseClientOptions, identifiers, customAttributes);
                            case 2:
                                // If client sdk key fetch fails, an error would be thrown and handled instead of waiting for
                                // the experiment values request to be settled, and it will fall back to use default values.
                                clientSdkKeyPromise = provider.getClientSdkKey().then(function(value) {
                                    return fromValuesClientOptions.sdkKey = value;
                                });
                                experimentValuesPromise = provider.getExperimentValues(); // Only wait for the experiment values request to finish and try to initialise the client
                                // with experiment values if both requests are successful. Else an error would be thrown and
                                // handled by the catch
                                _context9.next = 3;
                                return Promise.all([
                                    clientSdkKeyPromise,
                                    experimentValuesPromise
                                ]);
                            case 3:
                                _yield$Promise$all3 = _context9.sent;
                                _yield$Promise$all4 = (0, $1dc579c4de1142c2$export$2e2bcd8739ae039)(_yield$Promise$all3, 2);
                                experimentValuesResult = _yield$Promise$all4[1];
                                experimentValues = experimentValuesResult.experimentValues;
                                customAttributesFromResult = experimentValuesResult.customAttributesFromFetch;
                                _context9.next = 6;
                                break;
                            case 4:
                                _context9.prev = 4;
                                _t2 = _context9["catch"](1);
                                if (_t2 instanceof Error) // eslint-disable-next-line no-console
                                console.error("Error occurred when trying to fetch the Feature Gates client values, error: ".concat(_t2 === null || _t2 === void 0 ? void 0 : _t2.message));
                                // eslint-disable-next-line no-console
                                console.warn("Initialising Statsig client without values");
                                _context9.next = 5;
                                return this.initFromValues(fromValuesClientOptions, identifiers, customAttributes);
                            case 5:
                                throw _t2;
                            case 6:
                                return _context9.abrupt("return", this.initFromValues(fromValuesClientOptions, identifiers, customAttributesFromResult, experimentValues));
                            case 7:
                            case "end":
                                return _context9.stop();
                        }
                    }, _callee9, this, [
                        [
                            1,
                            4
                        ]
                    ]);
                }));
                function initWithProvider(_x19, _x20, _x21, _x22) {
                    return _initWithProvider.apply(this, arguments);
                }
                return initWithProvider;
            }()
        },
        {
            key: "initFromValues",
            value: function() {
                var _initFromValues = (0, $b67fad0a126d5f92$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($b405b4a0324cf1d2$exports))).mark(function _callee0(clientOptions, identifiers, customAttributes) {
                    var _newClientOptions$net;
                    var initializeValues, newClientOptions, sdkKey, environment, _updateUserCompletionCallback, _perimeter, restClientOptions, frontendUser, statsigOptions, _args0 = arguments, _t3;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($b405b4a0324cf1d2$exports))).wrap(function(_context0) {
                        while(true)switch(_context0.prev = _context0.next){
                            case 0:
                                initializeValues = _args0.length > 3 && _args0[3] !== undefined ? _args0[3] : {};
                                this.overrideAdapter.initFromStoredOverrides();
                                this.currentIdentifiers = identifiers;
                                this.currentAttributes = customAttributes;
                                newClientOptions = (0, $d16a8fcdfb06c5ab$export$202946b690d26d22)(clientOptions);
                                if (!newClientOptions.sdkKey) newClientOptions.sdkKey = $9d177b33609fde4a$var$DEFAULT_CLIENT_KEY;
                                if (!((_newClientOptions$net = newClientOptions.networkConfig) !== null && _newClientOptions$net !== void 0 && _newClientOptions$net.logEventUrl)) newClientOptions.networkConfig = $9d177b33609fde4a$var$_objectSpread($9d177b33609fde4a$var$_objectSpread({}, newClientOptions.networkConfig), {}, {
                                    logEventUrl: $9d177b33609fde4a$var$DEFAULT_EVENT_LOGGING_API
                                });
                                if (newClientOptions.perimeter === (0, $c578c05f082e3c28$export$c42b7bbc5e7ba555).FEDRAMP_MODERATE) // disable all logging in FedRAMP to prevent egress of sensitive data
                                newClientOptions.disableLogging = true;
                                sdkKey = newClientOptions.sdkKey, environment = newClientOptions.environment, _updateUserCompletionCallback = newClientOptions.updateUserCompletionCallback, _perimeter = newClientOptions.perimeter, restClientOptions = (0, $f2ca64756a447eb8$export$2e2bcd8739ae039)(newClientOptions, $9d177b33609fde4a$var$_excluded);
                                frontendUser = (0, $d16a8fcdfb06c5ab$export$3dad1db244472f32)(identifiers, customAttributes);
                                this.user = (0, $d16a8fcdfb06c5ab$export$1148cb79ceecd5fa)({}, initializeValues.user, frontendUser);
                                statsigOptions = $9d177b33609fde4a$var$_objectSpread($9d177b33609fde4a$var$_objectSpread({}, restClientOptions), {}, {
                                    environment: {
                                        tier: environment
                                    },
                                    includeCurrentPageUrlWithEvents: false,
                                    dataAdapter: this.dataAdapter,
                                    overrideAdapter: this.overrideAdapter,
                                    logEventCompressionMode: (0, $iFR7a.LogEventCompressionMode).Forced
                                }); // Statsig validates the provided stableId against their own cookie, so we either need
                                // to update the cookie to match, or disable the validation completely.
                                if (identifiers.stableId) (0, $iFR7a.StableID).setOverride(identifiers.stableId, sdkKey);
                                else statsigOptions.disableStableID = true;
                                _context0.prev = 1;
                                this.statsigClient = new (0, $iFR7a.StatsigClient)(sdkKey, this.user, statsigOptions);
                                this.dataAdapter.setBootstrapData(initializeValues);
                                _context0.next = 2;
                                return this.statsigClient.initializeAsync();
                            case 2:
                                _context0.next = 5;
                                break;
                            case 3:
                                _context0.prev = 3;
                                _t3 = _context0["catch"](1);
                                if (_t3 instanceof Error) // eslint-disable-next-line no-console
                                console.error("Error occurred when trying to initialise the Statsig client, error: ".concat(_t3 === null || _t3 === void 0 ? void 0 : _t3.message));
                                // eslint-disable-next-line no-console
                                console.warn("Initialising Statsig client with default sdk key and without values");
                                this.statsigClient = new (0, $iFR7a.StatsigClient)($9d177b33609fde4a$var$DEFAULT_CLIENT_KEY, this.user, statsigOptions);
                                this.dataAdapter.setBootstrapData();
                                _context0.next = 4;
                                return this.statsigClient.initializeAsync();
                            case 4:
                                this.initWithDefaults = true;
                                throw _t3;
                            case 5:
                            case "end":
                                return _context0.stop();
                        }
                    }, _callee0, this, [
                        [
                            1,
                            3
                        ]
                    ]);
                }));
                function initFromValues(_x23, _x24, _x25) {
                    return _initFromValues.apply(this, arguments);
                }
                return initFromValues;
            }()
        },
        {
            key: "updateUserUsingInitializeValuesProducer",
            value: function() {
                var _updateUserUsingInitializeValuesProducer = (0, $b67fad0a126d5f92$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($b405b4a0324cf1d2$exports))).mark(function _callee10(getInitializeValues, identifiers, customAttributes) {
                    var _this9 = this;
                    var originalInitPromise, initializeValuesPromise, updateUserPromise, _t4;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($b405b4a0324cf1d2$exports))).wrap(function(_context10) {
                        while(true)switch(_context10.prev = _context10.next){
                            case 0:
                                this.assertInitialized(this.statsigClient);
                                if (this.initPromise) {
                                    _context10.next = 1;
                                    break;
                                }
                                throw new Error('The client must be initialized before you can update the user.');
                            case 1:
                                if (!this.isCurrentUser(identifiers, customAttributes)) {
                                    _context10.next = 2;
                                    break;
                                }
                                return _context10.abrupt("return", this.initPromise);
                            case 2:
                                // Wait for the current initialize/update to finish
                                originalInitPromise = this.initPromise;
                                _context10.prev = 3;
                                _context10.next = 4;
                                return this.initPromise;
                            case 4:
                                _context10.next = 6;
                                break;
                            case 5:
                                _context10.prev = 5;
                                _t4 = _context10["catch"](3);
                            case 6:
                                initializeValuesPromise = getInitializeValues();
                                updateUserPromise = this.updateStatsigClientUser(initializeValuesPromise, identifiers, customAttributes); // We replace the init promise here since we are essentially re-initializing the client at this
                                // point. Any subsequent calls to await client.initialize() or client.updateUser()
                                // will now also await this user update.
                                this.initPromise = updateUserPromise.catch(/*#__PURE__*/ (0, $b67fad0a126d5f92$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($b405b4a0324cf1d2$exports))).mark(function _callee1() {
                                    return (0, (/*@__PURE__*/$parcel$interopDefault($b405b4a0324cf1d2$exports))).wrap(function(_context1) {
                                        while(true)switch(_context1.prev = _context1.next){
                                            case 0:
                                                // If the update failed then it changed nothing, so revert back to the original promise.
                                                _this9.initPromise = originalInitPromise;
                                                // Set the user profile again to revert back to the current user
                                                if (!_this9.provider) {
                                                    _context1.next = 1;
                                                    break;
                                                }
                                                _context1.next = 1;
                                                return _this9.provider.setProfile(_this9.initOptions, _this9.currentIdentifiers, _this9.currentAttributes);
                                            case 1:
                                            case "end":
                                                return _context1.stop();
                                        }
                                    }, _callee1);
                                })));
                                return _context10.abrupt("return", updateUserPromise);
                            case 7:
                            case "end":
                                return _context10.stop();
                        }
                    }, _callee10, this, [
                        [
                            3,
                            5
                        ]
                    ]);
                }));
                function updateUserUsingInitializeValuesProducer(_x26, _x27, _x28) {
                    return _updateUserUsingInitializeValuesProducer.apply(this, arguments);
                }
                return updateUserUsingInitializeValuesProducer;
            }()
        },
        {
            key: "updateStatsigClientUser",
            value: function() {
                var _updateStatsigClientUser = (0, $b67fad0a126d5f92$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($b405b4a0324cf1d2$exports))).mark(function _callee11(initializeValuesPromise, identifiers, customAttributes) {
                    var _this$initOptions, _this$initOptions$upd;
                    var initializeValues, user, frontendUser, _updateUserCompletion, _ref4, errMsg, success, errorMessage, _t5, _t6;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($b405b4a0324cf1d2$exports))).wrap(function(_context11) {
                        while(true)switch(_context11.prev = _context11.next){
                            case 0:
                                this.assertInitialized(this.statsigClient);
                                _context11.prev = 1;
                                _context11.next = 2;
                                return initializeValuesPromise;
                            case 2:
                                initializeValues = _context11.sent;
                                frontendUser = (0, $d16a8fcdfb06c5ab$export$3dad1db244472f32)(identifiers, initializeValues.customAttributesFromFetch);
                                user = (0, $d16a8fcdfb06c5ab$export$1148cb79ceecd5fa)({}, initializeValues.experimentValues.user, frontendUser);
                                _context11.next = 4;
                                break;
                            case 3:
                                _context11.prev = 3;
                                _t5 = _context11["catch"](1);
                                // Make sure the updateUserCompletionCallback is called for any errors in our custom code.
                                // This is not necessary for the updateUserWithValues call, because the Statsig client will
                                // already invoke the callback itself.
                                errMsg = _t5 instanceof Error ? _t5.message : JSON.stringify(_t5);
                                (_updateUserCompletion = (_ref4 = this.initOptions).updateUserCompletionCallback) === null || _updateUserCompletion === void 0 || _updateUserCompletion.call(_ref4, false, errMsg);
                                throw _t5;
                            case 4:
                                success = true;
                                errorMessage = null;
                                _context11.prev = 5;
                                this.dataAdapter.setBootstrapData(initializeValues.experimentValues);
                                this.user = user;
                                if (!this.user) {
                                    _context11.next = 6;
                                    break;
                                }
                                _context11.next = 6;
                                return this.statsigClient.updateUserAsync(this.user);
                            case 6:
                                _context11.next = 8;
                                break;
                            case 7:
                                _context11.prev = 7;
                                _t6 = _context11["catch"](5);
                                success = false;
                                errorMessage = String(_t6);
                            case 8:
                                (_this$initOptions = this.initOptions) === null || _this$initOptions === void 0 || (_this$initOptions$upd = _this$initOptions.updateUserCompletionCallback) === null || _this$initOptions$upd === void 0 || _this$initOptions$upd.call(_this$initOptions, success, errorMessage);
                                if (!success) {
                                    _context11.next = 9;
                                    break;
                                }
                                this.currentIdentifiers = identifiers;
                                this.currentAttributes = customAttributes;
                                this.subscriptions.anyUpdated();
                                _context11.next = 10;
                                break;
                            case 9:
                                throw new Error('Failed to update user. An unexpected error occured.');
                            case 10:
                            case "end":
                                return _context11.stop();
                        }
                    }, _callee11, this, [
                        [
                            1,
                            3
                        ],
                        [
                            5,
                            7
                        ]
                    ]);
                }));
                function updateStatsigClientUser(_x29, _x30, _x31) {
                    return _updateStatsigClientUser.apply(this, arguments);
                }
                return updateStatsigClientUser;
            }()
        },
        {
            key: "getPackageVersion",
            value: /**
     * @returns string version of the current package in semver style.
     */ function getPackageVersion() {
                return 0, $eb08f16a4c9618eb$export$a59f8d67326bd1cb;
            }
        },
        {
            key: "getTargetApp",
            value: function getTargetApp() {
                var _this$initOptions2;
                return (_this$initOptions2 = this.initOptions) === null || _this$initOptions2 === void 0 ? void 0 : _this$initOptions2.targetApp;
            }
        },
        {
            key: "getLayer",
            value: function getLayer(/** The name of the layer */ layerName) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                try {
                    this.assertInitialized(this.statsigClient);
                    var _options$fireLayerExp = options.fireLayerExposure, fireLayerExposure = _options$fireLayerExp === void 0 ? true : _options$fireLayerExp;
                    return (0, $1141e1e3afce2b59$export$936d0764594b6eb3).fromLayer(this.statsigClient.getLayer(layerName, {
                        disableExposureLog: !fireLayerExposure
                    }));
                } catch (error) {
                    // Log the first occurrence of the error
                    if (!this.hasGetLayerErrorOccurred) {
                        // eslint-disable-next-line no-console
                        console.warn({
                            msg: 'An error has occurred getting the layer. Only the first occurrence of this error is logged.',
                            layerName: layerName,
                            error: error
                        });
                        this.hasGetLayerErrorOccurred = true;
                    }
                    // Return a default value
                    return (0, $1141e1e3afce2b59$export$936d0764594b6eb3).fromLayer((0, $iFR7a._makeLayer)(layerName, {
                        reason: 'Error'
                    }, null));
                }
            }
        },
        {
            key: "getLayerValue",
            value: function getLayerValue(layerName, parameterName, defaultValue) {
                var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var layer = this.getLayer(layerName, options);
                try {
                    var typeGuard = options.typeGuard;
                    return layer.get(parameterName, defaultValue, typeGuard);
                } catch (error) {
                    // Log the first occurrence of the error
                    if (!this.hasGetLayerValueErrorOccurred) {
                        // eslint-disable-next-line no-console
                        console.warn({
                            msg: 'An error has occurred getting the layer value. Only the first occurrence of this error is logged.',
                            layerName: layerName,
                            defaultValue: defaultValue,
                            options: options,
                            error: error
                        });
                        this.hasGetLayerValueErrorOccurred = true;
                    }
                    return defaultValue;
                }
            }
        }
    ]);
}();






var $bf5e7b91f30b6042$var$_FeatureGates;
/**
 * Access the FeatureGates object via the default export.
 * ```ts
 * import FeatureGates from '@atlaskit/feature-gate-js-client';
 * ```
 */ var $bf5e7b91f30b6042$var$FeatureGates = /*#__PURE__*/ function() {
    function FeatureGates() {
        (0, $a90d44c71774a73e$export$2e2bcd8739ae039)(this, FeatureGates);
    }
    return (0, $a83b4b1801bd7063$export$2e2bcd8739ae039)(FeatureGates, null, [
        {
            key: "isGateExists",
            value: function isGateExists(gateName) {
                return this.client.isGateExist(gateName);
            }
        },
        {
            key: "isExperimentExists",
            value: function isExperimentExists(experimentName) {
                return this.client.isExperimentExist(experimentName);
            }
        }
    ]);
}();
$bf5e7b91f30b6042$var$_FeatureGates = $bf5e7b91f30b6042$var$FeatureGates;
(0, $34bcf16a63c65c03$export$2e2bcd8739ae039)($bf5e7b91f30b6042$var$FeatureGates, "client", new (0, $9d177b33609fde4a$export$1f2bb630327ac4b6)());
(0, $34bcf16a63c65c03$export$2e2bcd8739ae039)($bf5e7b91f30b6042$var$FeatureGates, "hasCheckGateErrorOccurred", false);
(0, $34bcf16a63c65c03$export$2e2bcd8739ae039)($bf5e7b91f30b6042$var$FeatureGates, "hasGetExperimentValueErrorOccurred", false);
(0, $34bcf16a63c65c03$export$2e2bcd8739ae039)($bf5e7b91f30b6042$var$FeatureGates, "checkGate", function(gateName, options) {
    try {
        // Check if the CRITERION override mechanism is available
        if (typeof window !== 'undefined' && window.__CRITERION__ && typeof window.__CRITERION__.getFeatureFlagOverride === 'function') {
            // Attempt to retrieve an override value for the feature gate
            var overrideValue = window.__CRITERION__.getFeatureFlagOverride(gateName);
            // If an override value is found, return it immediately
            if (overrideValue !== undefined) return overrideValue;
        }
    } catch (error) {
        // Log the first occurrence of the error
        if (!$bf5e7b91f30b6042$var$_FeatureGates.hasCheckGateErrorOccurred) {
            // eslint-disable-next-line no-console
            console.warn({
                msg: 'An error has occurred checking the feature gate from criterion override. Only the first occurrence of this error is logged.',
                gateName: gateName,
                error: error
            });
            $bf5e7b91f30b6042$var$_FeatureGates.hasCheckGateErrorOccurred = true;
        }
    }
    // Proceed with the main logic if no override is found
    return $bf5e7b91f30b6042$var$_FeatureGates.client.checkGate(gateName, options);
});
(0, $34bcf16a63c65c03$export$2e2bcd8739ae039)($bf5e7b91f30b6042$var$FeatureGates, "getExperimentValue", function(experimentName, parameterName, defaultValue, options) {
    try {
        // Check if the CRITERION override mechanism is available
        if (typeof window !== 'undefined' && window.__CRITERION__ && typeof window.__CRITERION__.getExperimentValueOverride === 'function') {
            var overrideValue = window.__CRITERION__.getExperimentValueOverride(experimentName, parameterName);
            if (overrideValue !== undefined && overrideValue !== null) return overrideValue;
        }
    } catch (error) {
        // Log the first occurrence of the error
        if (!$bf5e7b91f30b6042$var$_FeatureGates.hasGetExperimentValueErrorOccurred) {
            // eslint-disable-next-line no-console
            console.warn({
                msg: 'An error has occurred getting the experiment value from criterion override. Only the first occurrence of this error is logged.',
                experimentName: experimentName,
                defaultValue: defaultValue,
                options: options,
                error: error
            });
            $bf5e7b91f30b6042$var$_FeatureGates.hasGetExperimentValueErrorOccurred = true;
        }
        return defaultValue;
    }
    // Proceed with the main logic if no override is found
    return $bf5e7b91f30b6042$var$_FeatureGates.client.getExperimentValue(experimentName, parameterName, defaultValue, options);
});
(0, $34bcf16a63c65c03$export$2e2bcd8739ae039)($bf5e7b91f30b6042$var$FeatureGates, "initializeCalled", $bf5e7b91f30b6042$var$_FeatureGates.client.initializeCalled.bind($bf5e7b91f30b6042$var$_FeatureGates.client));
(0, $34bcf16a63c65c03$export$2e2bcd8739ae039)($bf5e7b91f30b6042$var$FeatureGates, "initializeCompleted", $bf5e7b91f30b6042$var$_FeatureGates.client.initializeCompleted.bind($bf5e7b91f30b6042$var$_FeatureGates.client));
(0, $34bcf16a63c65c03$export$2e2bcd8739ae039)($bf5e7b91f30b6042$var$FeatureGates, "waitUntilInitializeCompleted", $bf5e7b91f30b6042$var$_FeatureGates.client.waitUntilInitializeCompleted.bind($bf5e7b91f30b6042$var$_FeatureGates.client));
(0, $34bcf16a63c65c03$export$2e2bcd8739ae039)($bf5e7b91f30b6042$var$FeatureGates, "initialize", $bf5e7b91f30b6042$var$_FeatureGates.client.initialize.bind($bf5e7b91f30b6042$var$_FeatureGates.client));
(0, $34bcf16a63c65c03$export$2e2bcd8739ae039)($bf5e7b91f30b6042$var$FeatureGates, "initializeWithProvider", $bf5e7b91f30b6042$var$_FeatureGates.client.initializeWithProvider.bind($bf5e7b91f30b6042$var$_FeatureGates.client));
(0, $34bcf16a63c65c03$export$2e2bcd8739ae039)($bf5e7b91f30b6042$var$FeatureGates, "initializeFromValues", $bf5e7b91f30b6042$var$_FeatureGates.client.initializeFromValues.bind($bf5e7b91f30b6042$var$_FeatureGates.client));
(0, $34bcf16a63c65c03$export$2e2bcd8739ae039)($bf5e7b91f30b6042$var$FeatureGates, "manuallyLogGateExposure", $bf5e7b91f30b6042$var$_FeatureGates.client.manuallyLogGateExposure.bind($bf5e7b91f30b6042$var$_FeatureGates.client));
(0, $34bcf16a63c65c03$export$2e2bcd8739ae039)($bf5e7b91f30b6042$var$FeatureGates, "getExperiment", $bf5e7b91f30b6042$var$_FeatureGates.client.getExperiment.bind($bf5e7b91f30b6042$var$_FeatureGates.client));
(0, $34bcf16a63c65c03$export$2e2bcd8739ae039)($bf5e7b91f30b6042$var$FeatureGates, "manuallyLogExperimentExposure", $bf5e7b91f30b6042$var$_FeatureGates.client.manuallyLogExperimentExposure.bind($bf5e7b91f30b6042$var$_FeatureGates.client));
(0, $34bcf16a63c65c03$export$2e2bcd8739ae039)($bf5e7b91f30b6042$var$FeatureGates, "manuallyLogLayerExposure", $bf5e7b91f30b6042$var$_FeatureGates.client.manuallyLogLayerExposure.bind($bf5e7b91f30b6042$var$_FeatureGates.client));
(0, $34bcf16a63c65c03$export$2e2bcd8739ae039)($bf5e7b91f30b6042$var$FeatureGates, "shutdownStatsig", $bf5e7b91f30b6042$var$_FeatureGates.client.shutdownStatsig.bind($bf5e7b91f30b6042$var$_FeatureGates.client));
(0, $34bcf16a63c65c03$export$2e2bcd8739ae039)($bf5e7b91f30b6042$var$FeatureGates, "overrideGate", $bf5e7b91f30b6042$var$_FeatureGates.client.overrideGate.bind($bf5e7b91f30b6042$var$_FeatureGates.client));
(0, $34bcf16a63c65c03$export$2e2bcd8739ae039)($bf5e7b91f30b6042$var$FeatureGates, "clearGateOverride", $bf5e7b91f30b6042$var$_FeatureGates.client.clearGateOverride.bind($bf5e7b91f30b6042$var$_FeatureGates.client));
(0, $34bcf16a63c65c03$export$2e2bcd8739ae039)($bf5e7b91f30b6042$var$FeatureGates, "overrideConfig", $bf5e7b91f30b6042$var$_FeatureGates.client.overrideConfig.bind($bf5e7b91f30b6042$var$_FeatureGates.client));
(0, $34bcf16a63c65c03$export$2e2bcd8739ae039)($bf5e7b91f30b6042$var$FeatureGates, "clearConfigOverride", $bf5e7b91f30b6042$var$_FeatureGates.client.clearConfigOverride.bind($bf5e7b91f30b6042$var$_FeatureGates.client));
(0, $34bcf16a63c65c03$export$2e2bcd8739ae039)($bf5e7b91f30b6042$var$FeatureGates, "setOverrides", $bf5e7b91f30b6042$var$_FeatureGates.client.setOverrides.bind($bf5e7b91f30b6042$var$_FeatureGates.client));
(0, $34bcf16a63c65c03$export$2e2bcd8739ae039)($bf5e7b91f30b6042$var$FeatureGates, "getOverrides", $bf5e7b91f30b6042$var$_FeatureGates.client.getOverrides.bind($bf5e7b91f30b6042$var$_FeatureGates.client));
(0, $34bcf16a63c65c03$export$2e2bcd8739ae039)($bf5e7b91f30b6042$var$FeatureGates, "clearAllOverrides", $bf5e7b91f30b6042$var$_FeatureGates.client.clearAllOverrides.bind($bf5e7b91f30b6042$var$_FeatureGates.client));
(0, $34bcf16a63c65c03$export$2e2bcd8739ae039)($bf5e7b91f30b6042$var$FeatureGates, "isCurrentUser", $bf5e7b91f30b6042$var$_FeatureGates.client.isCurrentUser.bind($bf5e7b91f30b6042$var$_FeatureGates.client));
(0, $34bcf16a63c65c03$export$2e2bcd8739ae039)($bf5e7b91f30b6042$var$FeatureGates, "onGateUpdated", $bf5e7b91f30b6042$var$_FeatureGates.client.onGateUpdated.bind($bf5e7b91f30b6042$var$_FeatureGates.client));
(0, $34bcf16a63c65c03$export$2e2bcd8739ae039)($bf5e7b91f30b6042$var$FeatureGates, "onExperimentValueUpdated", $bf5e7b91f30b6042$var$_FeatureGates.client.onExperimentValueUpdated.bind($bf5e7b91f30b6042$var$_FeatureGates.client));
(0, $34bcf16a63c65c03$export$2e2bcd8739ae039)($bf5e7b91f30b6042$var$FeatureGates, "onAnyUpdated", $bf5e7b91f30b6042$var$_FeatureGates.client.onAnyUpdated.bind($bf5e7b91f30b6042$var$_FeatureGates.client));
(0, $34bcf16a63c65c03$export$2e2bcd8739ae039)($bf5e7b91f30b6042$var$FeatureGates, "updateUser", $bf5e7b91f30b6042$var$_FeatureGates.client.updateUser.bind($bf5e7b91f30b6042$var$_FeatureGates.client));
(0, $34bcf16a63c65c03$export$2e2bcd8739ae039)($bf5e7b91f30b6042$var$FeatureGates, "updateUserWithProvider", $bf5e7b91f30b6042$var$_FeatureGates.client.updateUserWithProvider.bind($bf5e7b91f30b6042$var$_FeatureGates.client));
(0, $34bcf16a63c65c03$export$2e2bcd8739ae039)($bf5e7b91f30b6042$var$FeatureGates, "updateUserWithValues", $bf5e7b91f30b6042$var$_FeatureGates.client.updateUserWithValues.bind($bf5e7b91f30b6042$var$_FeatureGates.client));
(0, $34bcf16a63c65c03$export$2e2bcd8739ae039)($bf5e7b91f30b6042$var$FeatureGates, "getPackageVersion", $bf5e7b91f30b6042$var$_FeatureGates.client.getPackageVersion.bind($bf5e7b91f30b6042$var$_FeatureGates.client));
(0, $34bcf16a63c65c03$export$2e2bcd8739ae039)($bf5e7b91f30b6042$var$FeatureGates, "getTargetApp", $bf5e7b91f30b6042$var$_FeatureGates.client.getTargetApp.bind($bf5e7b91f30b6042$var$_FeatureGates.client));
(0, $34bcf16a63c65c03$export$2e2bcd8739ae039)($bf5e7b91f30b6042$var$FeatureGates, "getLayer", $bf5e7b91f30b6042$var$_FeatureGates.client.getLayer.bind($bf5e7b91f30b6042$var$_FeatureGates.client));
(0, $34bcf16a63c65c03$export$2e2bcd8739ae039)($bf5e7b91f30b6042$var$FeatureGates, "getLayerValue", $bf5e7b91f30b6042$var$_FeatureGates.client.getLayerValue.bind($bf5e7b91f30b6042$var$_FeatureGates.client));
var $bf5e7b91f30b6042$var$boundFGJS = $bf5e7b91f30b6042$var$FeatureGates;
// This makes it possible to get a reference to the FeatureGates client at runtime.
// This is important for overriding values in Cypress tests, as there needs to be a
// way to get the exact instance for a window in order to mock some of its methods.
if (typeof window !== 'undefined') {
    if (window.__FEATUREGATES_JS__ === undefined) window.__FEATUREGATES_JS__ = $bf5e7b91f30b6042$var$FeatureGates;
    else {
        var $bf5e7b91f30b6042$var$_boundFGJS, $bf5e7b91f30b6042$var$_boundFGJS$getPackage;
        $bf5e7b91f30b6042$var$boundFGJS = window.__FEATUREGATES_JS__;
        var $bf5e7b91f30b6042$var$boundVersion = (($bf5e7b91f30b6042$var$_boundFGJS = $bf5e7b91f30b6042$var$boundFGJS) === null || $bf5e7b91f30b6042$var$_boundFGJS === void 0 || ($bf5e7b91f30b6042$var$_boundFGJS$getPackage = $bf5e7b91f30b6042$var$_boundFGJS.getPackageVersion) === null || $bf5e7b91f30b6042$var$_boundFGJS$getPackage === void 0 ? void 0 : $bf5e7b91f30b6042$var$_boundFGJS$getPackage.call($bf5e7b91f30b6042$var$_boundFGJS)) || '4.10.0 or earlier';
        if ($bf5e7b91f30b6042$var$boundVersion !== (0, $eb08f16a4c9618eb$export$a59f8d67326bd1cb)) {
            var $bf5e7b91f30b6042$var$message = "Multiple versions of FeatureGateClients found on the current page.\n      The currently bound version is ".concat($bf5e7b91f30b6042$var$boundVersion, " when module version ").concat((0, $eb08f16a4c9618eb$export$a59f8d67326bd1cb), " was loading.");
            // eslint-disable-next-line no-console
            console.warn($bf5e7b91f30b6042$var$message);
        }
    }
}
var /**
 * @property {FeatureGates} FeatureGate default export
 */ $bf5e7b91f30b6042$export$2e2bcd8739ae039 = $bf5e7b91f30b6042$var$boundFGJS;


var $46727925e6977f99$var$_process, $46727925e6977f99$var$_process2;
// We can't rely on NODE_ENV === 'test' if its value is already configured by the consumer to some other value, so better to use JEST_WORKER_ID
// https://jestjs.io/docs/environment-variables#jest_worker_id
var $46727925e6977f99$var$TESTS_MODE = (globalThis === null || globalThis === void 0 || ($46727925e6977f99$var$_process = globalThis.process) === null || $46727925e6977f99$var$_process === void 0 || ($46727925e6977f99$var$_process = $46727925e6977f99$var$_process.env) === null || $46727925e6977f99$var$_process === void 0 ? void 0 : $46727925e6977f99$var$_process.JEST_WORKER_ID) !== undefined;
var $46727925e6977f99$var$DEBUG_MODE = !$46727925e6977f99$var$TESTS_MODE && (globalThis === null || globalThis === void 0 || ($46727925e6977f99$var$_process2 = globalThis.process) === null || $46727925e6977f99$var$_process2 === void 0 || ($46727925e6977f99$var$_process2 = $46727925e6977f99$var$_process2.env) === null || $46727925e6977f99$var$_process2 === void 0 ? void 0 : $46727925e6977f99$var$_process2.NODE_ENV) !== 'production';
var $46727925e6977f99$export$1c9f709888824e05 = function debug() {
    var _console;
    if (!$46727925e6977f99$var$DEBUG_MODE) return;
    // eslint-disable-next-line no-console
    (_console = console).debug.apply(_console, arguments);
};



var $3ZMUU = parcelRequire("3ZMUU");
var $34f71fd5c197f093$var$pkgName = '@atlaskit/platform-feature-flags';
var $34f71fd5c197f093$export$7e41b1b2bdee3f98 = '__PLATFORM_FEATURE_FLAGS__';
var $34f71fd5c197f093$var$hasProcessEnv = typeof $3ZMUU !== 'undefined' && typeof $3ZMUU.env !== 'undefined';
// FF global overrides can be configured by test runners or Storybook
var $34f71fd5c197f093$var$ENV_ENABLE_PLATFORM_FF = $34f71fd5c197f093$var$hasProcessEnv ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;
// STORYBOOK_ENABLE_PLATFORM_FF is included as storybook only allows env vars prefixed with STORYBOOK
// https://github.com/storybookjs/storybook/issues/12270
var $34f71fd5c197f093$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF = $34f71fd5c197f093$var$hasProcessEnv ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;
var $34f71fd5c197f093$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE = $34f71fd5c197f093$var$ENV_ENABLE_PLATFORM_FF || $34f71fd5c197f093$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF;
var $34f71fd5c197f093$var$DEFAULT_PFF_GLOBAL = {
    booleanResolver: undefined
};
var $34f71fd5c197f093$var$globalVar = typeof window !== 'undefined' ? window : globalThis;
$34f71fd5c197f093$var$globalVar[$34f71fd5c197f093$export$7e41b1b2bdee3f98] = $34f71fd5c197f093$var$globalVar[$34f71fd5c197f093$export$7e41b1b2bdee3f98] || $34f71fd5c197f093$var$DEFAULT_PFF_GLOBAL;
function $34f71fd5c197f093$export$f2b591175b3e424c(resolver) {
    $34f71fd5c197f093$var$globalVar[$34f71fd5c197f093$export$7e41b1b2bdee3f98].booleanResolver = resolver;
}
function $34f71fd5c197f093$export$6333b6aff9fc6275(flagKey) {
    if ($34f71fd5c197f093$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE) {
        (0, $46727925e6977f99$export$1c9f709888824e05)('[%s]: The feature flags were enabled while running tests. The flag "%s" will be always enabled.', $34f71fd5c197f093$var$pkgName, flagKey);
        return true;
    }
    try {
        var _globalVar$PFF_GLOBAL, _globalVar$PFF_GLOBAL2, _globalVar$PFF_GLOBAL3;
        // booleanResolver will be empty for products like Trello, Elevate, Recruit etc.
        // Currently only Confluence, Jira and Bitbucket has set it.
        if (((_globalVar$PFF_GLOBAL = $34f71fd5c197f093$var$globalVar[$34f71fd5c197f093$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL === void 0 ? void 0 : _globalVar$PFF_GLOBAL.booleanResolver) === undefined || ((_globalVar$PFF_GLOBAL2 = $34f71fd5c197f093$var$globalVar[$34f71fd5c197f093$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL2 === void 0 ? void 0 : _globalVar$PFF_GLOBAL2.booleanResolver) === null) // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
        return (0, $bf5e7b91f30b6042$export$2e2bcd8739ae039).checkGate(flagKey);
        var result = (_globalVar$PFF_GLOBAL3 = $34f71fd5c197f093$var$globalVar[$34f71fd5c197f093$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL3 === void 0 ? void 0 : _globalVar$PFF_GLOBAL3.booleanResolver(flagKey);
        if (typeof result !== 'boolean') {
            // eslint-disable-next-line no-console
            console.warn("".concat(flagKey, " resolved to a non-boolean value, returning false for safety"));
            return false;
        }
        return result;
    } catch (e) {
        return false;
    }
}


function $dd775f3247424a26$export$ba05d765b8392e5e(flagResolver) {
    (0, $34f71fd5c197f093$export$f2b591175b3e424c)(flagResolver);
}
function $dd775f3247424a26$export$470e5c2be1411c89(name) {
    return (0, $34f71fd5c197f093$export$6333b6aff9fc6275)(name);
}
function $dd775f3247424a26$export$b40ec24ac8275656(name) {
    return (0, $34f71fd5c197f093$export$6333b6aff9fc6275)(name);
}






function $35db1b5c114e5901$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $35db1b5c114e5901$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $35db1b5c114e5901$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $34bcf16a63c65c03$export$2e2bcd8739ae039)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $35db1b5c114e5901$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $35db1b5c114e5901$export$ad4be5c2ec28cecf = function isAnalyticsEvent(obj) {
    var _obj$constructor;
    return obj instanceof $35db1b5c114e5901$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 || (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === 'AnalyticsEvent';
};
// eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
var $35db1b5c114e5901$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function AnalyticsEvent(props) {
        var _this = this;
        (0, $a90d44c71774a73e$export$2e2bcd8739ae039)(this, AnalyticsEvent);
        (0, $34bcf16a63c65c03$export$2e2bcd8739ae039)(this, "_isAnalyticsEvent", true);
        (0, $34bcf16a63c65c03$export$2e2bcd8739ae039)(this, "clone", function() {
            // just a shallow clone, don't change sub refs unless you want to
            // affect the original's too
            var payload = $35db1b5c114e5901$var$_objectSpread({}, _this.payload);
            return new AnalyticsEvent({
                payload: payload
            });
        });
        this.payload = props.payload;
    }
    return (0, $a83b4b1801bd7063$export$2e2bcd8739ae039)(AnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (typeof updater === 'function') this.payload = updater(this.payload);
                if ((0, $a9546fe3c34f8734$export$2e2bcd8739ae039)(updater) === 'object') this.payload = $35db1b5c114e5901$var$_objectSpread($35db1b5c114e5901$var$_objectSpread({}, this.payload), updater);
                return this;
            }
        }
    ]);
}();


function $cd53c3aa63416708$var$_callSuper(t, o, e) {
    return o = (0, $0738339b6a9f4e57$export$2e2bcd8739ae039)(o), (0, $c4a414505d241956$export$2e2bcd8739ae039)(t, $cd53c3aa63416708$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, $0738339b6a9f4e57$export$2e2bcd8739ae039)(t).constructor) : o.apply(t, e));
}
function $cd53c3aa63416708$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($cd53c3aa63416708$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $cd53c3aa63416708$var$_superPropGet(t, o, e, r) {
    var p = (0, $0550eca2bd453b09$export$2e2bcd8739ae039)((0, $0738339b6a9f4e57$export$2e2bcd8739ae039)(1 & r ? t.prototype : t), o, e);
    return 2 & r && "function" == typeof p ? function(t) {
        return p.apply(e, t);
    } : p;
}
function $cd53c3aa63416708$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $cd53c3aa63416708$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $cd53c3aa63416708$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $34bcf16a63c65c03$export$2e2bcd8739ae039)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $cd53c3aa63416708$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $cd53c3aa63416708$export$35f8383928ba8d7 = function isUIAnalyticsEvent(obj) {
    var _obj$constructor;
    return obj instanceof $cd53c3aa63416708$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isUIAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 || (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === 'UIAnalyticsEvent';
};
/**
 * Produces a deep clone of an event payload.
 *
 * The historic implementation relied on `JSON.parse(JSON.stringify(...))`, a
 * "hacky" deep clone that does not support functions, regexs, Maps, Sets, etc.
 * Crucially, `JSON.stringify` also throws `TypeError: Converting circular
 * structure to JSON` when the payload contains a value with circular
 * references — e.g. a live DOM node carrying React fiber back-references
 * (`__reactFiber$...`). When that throw happens during a React render/commit it
 * escapes into product UI and trips an error boundary (HOT-127428).
 *
 * Analytics must never crash product UI (the same contract `fire` upholds), so
 * behind the `platform-analytics-next-safe-clone` gate we wrap the
 * serialization in a try/catch and fall back to a shallow clone — matching the
 * base `AnalyticsEvent.clone` behaviour — if the deep clone fails.
 *
 * NOTE: this is intentionally a module-scoped function rather than a class
 * member so it does not change the structural type of `UIAnalyticsEvent`, which
 * is hand-mocked across the monorepo.
 */ var $cd53c3aa63416708$var$clonePayload = function clonePayload(payload) {
    if ((0, $dd775f3247424a26$export$b40ec24ac8275656)('platform-analytics-next-safe-clone')) try {
        return JSON.parse(JSON.stringify(payload));
    } catch (e) {
        // Shallow clone keeps the event usable without crashing the UI.
        return $cd53c3aa63416708$var$_objectSpread({}, payload);
    }
    /**
   * A hacky "deep clone" of the object. This is limited in that it wont
   * support functions, regexs, Maps, Sets, etc, but none of those need to
   * be represented in our payload.
   */ return JSON.parse(JSON.stringify(payload));
};
// eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
var $cd53c3aa63416708$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_AnalyticsEvent) {
    function UIAnalyticsEvent(props) {
        var _this;
        (0, $a90d44c71774a73e$export$2e2bcd8739ae039)(this, UIAnalyticsEvent);
        _this = $cd53c3aa63416708$var$_callSuper(this, UIAnalyticsEvent, [
            props
        ]);
        (0, $34bcf16a63c65c03$export$2e2bcd8739ae039)(_this, "_isUIAnalyticsEvent", true);
        (0, $34bcf16a63c65c03$export$2e2bcd8739ae039)(_this, "clone", function() {
            if (_this.hasFired) return null;
            var context = (0, $b64eb05e0a458fd9$export$2e2bcd8739ae039)(_this.context);
            var handlers = (0, $b64eb05e0a458fd9$export$2e2bcd8739ae039)(_this.handlers);
            var payload = $cd53c3aa63416708$var$clonePayload(_this.payload);
            return new UIAnalyticsEvent({
                context: context,
                handlers: handlers,
                payload: payload
            });
        });
        (0, $34bcf16a63c65c03$export$2e2bcd8739ae039)(_this, "fire", function(channel) {
            if (_this.hasFired) return;
            _this.handlers.forEach(function(handler) {
                try {
                    handler(_this, channel);
                } catch (e) {}
            });
            _this.hasFired = true;
        });
        _this.context = props.context || [];
        _this.handlers = props.handlers || [];
        _this.hasFired = false;
        return _this;
    }
    (0, $56f9760db6bbedd7$export$2e2bcd8739ae039)(UIAnalyticsEvent, _AnalyticsEvent);
    return (0, $a83b4b1801bd7063$export$2e2bcd8739ae039)(UIAnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (this.hasFired) return this;
                return $cd53c3aa63416708$var$_superPropGet(UIAnalyticsEvent, "update", this, 3)([
                    updater
                ]);
            }
        }
    ]);
}((0, $35db1b5c114e5901$export$2e2bcd8739ae039));



var $5FkrB = parcelRequire("5FkrB");

var $eb7a73e97b56eca6$export$d1f587f82ad51c4 = function useAnalyticsContext() {
    return (0, $5FkrB.useContext)((0, $d82667e77467cbe0$export$2e2bcd8739ae039));
};


function $56a0b6ad5e593ea4$export$5bf35293e545f20c() {
    var analyticsContext = (0, $eb7a73e97b56eca6$export$d1f587f82ad51c4)();
    var createAnalyticsEvent = (0, $a060da77483cc5d3$export$33752cf3ee811995)(function(payload) {
        return new (0, $cd53c3aa63416708$export$2e2bcd8739ae039)({
            context: analyticsContext.getAtlaskitAnalyticsContext(),
            handlers: analyticsContext.getAtlaskitAnalyticsEventHandlers(),
            payload: payload
        });
    }, [
        analyticsContext
    ]);
    return {
        createAnalyticsEvent: createAnalyticsEvent
    };
}



var $5FkrB = parcelRequire("5FkrB");
var $e13b10ce18d01343$export$1d27a74659855e44 = function useTrackedRef(value) {
    var ref = (0, $5FkrB.useRef)(value);
    ref.current = value;
    return ref;
};


var $7c1856e1f951263e$export$53c2b9c37c40e0d8 = function useCallbackWithAnalytics(method, payload, channel) {
    var _useAnalyticsEvents = (0, $56a0b6ad5e593ea4$export$5bf35293e545f20c)(), createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
    var methodRef = (0, $e13b10ce18d01343$export$1d27a74659855e44)(method);
    var payloadRef = (0, $e13b10ce18d01343$export$1d27a74659855e44)(payload);
    return (0, $5FkrB.useCallback)(function() {
        var pload = typeof payloadRef.current === 'function' ? payloadRef.current.apply(payloadRef, arguments) : payloadRef.current;
        createAnalyticsEvent(pload).fire(channel);
        methodRef.current.apply(methodRef, arguments);
    }, [
        createAnalyticsEvent,
        methodRef,
        payloadRef,
        channel
    ]);
};




/* lozenge.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $5FkrB = parcelRequire("5FkrB");

var $jzAQA = parcelRequire("jzAQA");

var $5bb16f869350908d$var$_process, $5bb16f869350908d$var$_process2;
// We can't rely on NODE_ENV === 'test' if its value is already configured by the consumer to some other value, so better to use JEST_WORKER_ID
// https://jestjs.io/docs/environment-variables#jest_worker_id
var $5bb16f869350908d$var$TESTS_MODE = (globalThis === null || globalThis === void 0 || ($5bb16f869350908d$var$_process = globalThis.process) === null || $5bb16f869350908d$var$_process === void 0 || ($5bb16f869350908d$var$_process = $5bb16f869350908d$var$_process.env) === null || $5bb16f869350908d$var$_process === void 0 ? void 0 : $5bb16f869350908d$var$_process.JEST_WORKER_ID) !== undefined;
var $5bb16f869350908d$var$DEBUG_MODE = !$5bb16f869350908d$var$TESTS_MODE && (globalThis === null || globalThis === void 0 || ($5bb16f869350908d$var$_process2 = globalThis.process) === null || $5bb16f869350908d$var$_process2 === void 0 || ($5bb16f869350908d$var$_process2 = $5bb16f869350908d$var$_process2.env) === null || $5bb16f869350908d$var$_process2 === void 0 ? void 0 : $5bb16f869350908d$var$_process2.NODE_ENV) !== 'production';
var $5bb16f869350908d$export$1c9f709888824e05 = function debug() {
    var _console;
    if (!$5bb16f869350908d$var$DEBUG_MODE) return;
    // eslint-disable-next-line no-console
    (_console = console).debug.apply(_console, arguments);
};



var $3ZMUU = parcelRequire("3ZMUU");
var $602f82d75a31a75c$export$7e41b1b2bdee3f98 = '__PLATFORM_FEATURE_FLAGS__';
var $602f82d75a31a75c$export$407f05df8e3ce9f3 = '@atlaskit/platform-feature-flags';
var $602f82d75a31a75c$export$75f4a1454eff2805 = typeof $3ZMUU !== 'undefined' && typeof $3ZMUU.env !== 'undefined';


var $b4df577d2b2507c4$export$b574c24e1e6490f5 = (0, $602f82d75a31a75c$export$75f4a1454eff2805) ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;



var $b89a5164f7fcfe5b$export$92f8b531feaeb23d = (0, $602f82d75a31a75c$export$75f4a1454eff2805) ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;



var $fe8cb0e4f49bf6b6$var$DEFAULT_PFF_GLOBAL = {
    booleanResolver: undefined
};
var $fe8cb0e4f49bf6b6$export$54ea85357b4e0159 = typeof window !== 'undefined' ? window : globalThis;
$fe8cb0e4f49bf6b6$export$54ea85357b4e0159[0, $602f82d75a31a75c$export$7e41b1b2bdee3f98] = $fe8cb0e4f49bf6b6$export$54ea85357b4e0159[0, $602f82d75a31a75c$export$7e41b1b2bdee3f98] || $fe8cb0e4f49bf6b6$var$DEFAULT_PFF_GLOBAL;



var $f36edd5d3321d52f$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE = (0, $b4df577d2b2507c4$export$b574c24e1e6490f5) || (0, $b89a5164f7fcfe5b$export$92f8b531feaeb23d);
function $f36edd5d3321d52f$export$6333b6aff9fc6275(flagKey) {
    if ($f36edd5d3321d52f$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE) {
        (0, $5bb16f869350908d$export$1c9f709888824e05)('[%s]: The feature flags were enabled while running tests. The flag "%s" will be always enabled.', (0, $602f82d75a31a75c$export$407f05df8e3ce9f3), flagKey);
        return true;
    }
    try {
        var _globalVar$PFF_GLOBAL, _globalVar$PFF_GLOBAL2, _globalVar$PFF_GLOBAL3;
        // booleanResolver will be empty for products like Trello, Elevate, Recruit etc.
        // Currently only Confluence, Jira and Bitbucket has set it.
        if (((_globalVar$PFF_GLOBAL = (0, $fe8cb0e4f49bf6b6$export$54ea85357b4e0159)[0, $602f82d75a31a75c$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL === void 0 ? void 0 : _globalVar$PFF_GLOBAL.booleanResolver) === undefined || ((_globalVar$PFF_GLOBAL2 = (0, $fe8cb0e4f49bf6b6$export$54ea85357b4e0159)[0, $602f82d75a31a75c$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL2 === void 0 ? void 0 : _globalVar$PFF_GLOBAL2.booleanResolver) === null) // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
        return (0, $bf5e7b91f30b6042$export$2e2bcd8739ae039).checkGate(flagKey);
        var result = (_globalVar$PFF_GLOBAL3 = (0, $fe8cb0e4f49bf6b6$export$54ea85357b4e0159)[0, $602f82d75a31a75c$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL3 === void 0 ? void 0 : _globalVar$PFF_GLOBAL3.booleanResolver(flagKey);
        if (typeof result !== 'boolean') {
            // eslint-disable-next-line no-console
            console.warn("".concat(flagKey, " resolved to a non-boolean value, returning false for safety"));
            return false;
        }
        return result;
    } catch (e) {
        return false;
    }
}


function $92e43753483f870e$export$b40ec24ac8275656(name) {
    return (0, $f36edd5d3321d52f$export$6333b6aff9fc6275)(name);
}


/* lozenge.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $5FkrB = parcelRequire("5FkrB");

/* lozenge-base.tsx generated by @compiled/babel-plugin v2.0.0 */ 



var $5FkrB = parcelRequire("5FkrB");

var $jzAQA = parcelRequire("jzAQA");
/* badge-new.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $5FkrB = parcelRequire("5FkrB");

var $jzAQA = parcelRequire("jzAQA");
/* text.tsx generated by @compiled/babel-plugin v0.40.0 */ 
var $5FkrB = parcelRequire("5FkrB");

var $jzAQA = parcelRequire("jzAQA");


var $5FkrB = parcelRequire("5FkrB");
var $d39f8466225b64ea$export$19538d0bfc69c6e0 = /*#__PURE__*/ (0, $5FkrB.createContext)(false);


var $2cfd5b2d2f747e18$export$ae933c6cbe5643ad = (0, $d39f8466225b64ea$export$19538d0bfc69c6e0).Provider;



var $5FkrB = parcelRequire("5FkrB");

var $5FkrB = parcelRequire("5FkrB");
var $d5af69dc5a3797ce$export$1ca2a26fecb070ae = /*#__PURE__*/ (0, $5FkrB.createContext)('elevation.surface');


var $2a1b6cdb9988b743$export$1aeb4f6b93c4540d = function useSurface() {
    return (0, $5FkrB.useContext)((0, $d5af69dc5a3797ce$export$1ca2a26fecb070ae));
};
(0, $d5af69dc5a3797ce$export$1ca2a26fecb070ae).displayName = 'SurfaceProvider';



var $5FkrB = parcelRequire("5FkrB");

var $836099bcad0c797b$export$9322276ec105d055 = function useHasTextAncestor() {
    return (0, $5FkrB.useContext)((0, $d39f8466225b64ea$export$19538d0bfc69c6e0));
};


var $8f28566a9ab4b99f$var$asAllowlist = [
    'span',
    'p',
    'strong',
    'em'
];
/**
 * Custom hook designed to abstract the parsing of the color props and make it clearer in the future how color is reconciled between themes and tokens.
 */ var $8f28566a9ab4b99f$var$useColor = function useColor(colorProp, hasTextAncestor) {
    var surface = (0, $2a1b6cdb9988b743$export$1aeb4f6b93c4540d)();
    if (colorProp === 'inherit') return undefined;
    if (colorProp) return colorProp;
    if (hasTextAncestor) return undefined;
    if ($8f28566a9ab4b99f$var$inverseColorMap.hasOwnProperty(surface)) return $8f28566a9ab4b99f$var$inverseColorMap[surface];
    return 'color.text';
};
var $8f28566a9ab4b99f$var$styles = {
    root: "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _1i4qfg65",
    'as.strong': "_k48pwu06",
    'as.em': "_zg8l1m30",
    'textAlign.center': "_y3gn1h6o",
    'textAlign.end': "_y3gnh9n0",
    'textAlign.start': "_y3gnv2br",
    truncation: "_1reo15vq _18m915vq _1e0ccj1k _sudp1e54",
    breakAll: "_1nmz9jpi"
};
var $8f28566a9ab4b99f$var$fontSizeMap = {
    medium: "_11c8fhey",
    large: "_11c81d4k",
    small: "_11c8wadc"
};
var $8f28566a9ab4b99f$var$fontWeightMap = {
    bold: "_k48pwu06",
    medium: "_k48p1wq8",
    regular: "_k48pi7a9",
    semibold: "_k48p1pd9"
};
var $8f28566a9ab4b99f$var$textColorMap = {
    'color.text': "_syazi7uo",
    'color.text.accent.lime': "_syaz1tco",
    'color.text.accent.lime.bolder': "_syaz1ik3",
    'color.text.accent.red': "_syaz9lu1",
    'color.text.accent.red.bolder': "_syazhwvp",
    'color.text.accent.orange': "_syazp1lv",
    'color.text.accent.orange.bolder': "_syaz7i1p",
    'color.text.accent.yellow': "_syazfb2s",
    'color.text.accent.yellow.bolder': "_syazekll",
    'color.text.accent.green': "_syazh55r",
    'color.text.accent.green.bolder': "_syaz1y78",
    'color.text.accent.teal': "_syaz17qg",
    'color.text.accent.teal.bolder': "_syaz12v7",
    'color.text.accent.blue': "_syaz16jw",
    'color.text.accent.blue.bolder': "_syaz1kyx",
    'color.text.accent.purple': "_syazqmo9",
    'color.text.accent.purple.bolder': "_syaz1mn1",
    'color.text.accent.magenta': "_syaz1s8m",
    'color.text.accent.magenta.bolder': "_syaz1qur",
    'color.text.accent.gray': "_syaz1sqi",
    'color.text.accent.gray.bolder': "_syaz1tmo",
    'color.text.disabled': "_syaz1gmx",
    'color.text.inverse': "_syaz15cr",
    'color.text.selected': "_syaz6x5g",
    'color.text.brand': "_syaz1oa5",
    'color.text.danger': "_syaz1tmw",
    'color.text.warning': "_syaz1xn9",
    'color.text.warning.inverse': "_syaz1yd3",
    'color.text.success': "_syazgsak",
    'color.text.discovery': "_syazdv2p",
    'color.text.information': "_syazu3tg",
    'color.text.subtlest': "_syaz1rpy",
    'color.text.subtle': "_syazazsu",
    'color.link': "_syaz13af",
    'color.link.pressed': "_syaz12zz",
    'color.link.visited': "_syaz1ra0",
    'color.link.visited.pressed': "_syaz17z1"
};
var $8f28566a9ab4b99f$var$inverseColorMap = {
    'color.background.neutral.bold': 'color.text.inverse',
    'color.background.neutral.bold.hovered': 'color.text.inverse',
    'color.background.neutral.bold.pressed': 'color.text.inverse',
    'color.background.selected.bold': 'color.text.inverse',
    'color.background.selected.bold.hovered': 'color.text.inverse',
    'color.background.selected.bold.pressed': 'color.text.inverse',
    'color.background.brand.bold': 'color.text.inverse',
    'color.background.brand.bold.hovered': 'color.text.inverse',
    'color.background.brand.bold.pressed': 'color.text.inverse',
    'color.background.brand.boldest': 'color.text.inverse',
    'color.background.brand.boldest.hovered': 'color.text.inverse',
    'color.background.brand.boldest.pressed': 'color.text.inverse',
    'color.background.danger.bold': 'color.text.inverse',
    'color.background.danger.bold.hovered': 'color.text.inverse',
    'color.background.danger.bold.pressed': 'color.text.inverse',
    'color.background.warning.bold': 'color.text.warning.inverse',
    'color.background.warning.bold.hovered': 'color.text.warning.inverse',
    'color.background.warning.bold.pressed': 'color.text.warning.inverse',
    'color.background.success.bold': 'color.text.inverse',
    'color.background.success.bold.hovered': 'color.text.inverse',
    'color.background.success.bold.pressed': 'color.text.inverse',
    'color.background.discovery.bold': 'color.text.inverse',
    'color.background.discovery.bold.hovered': 'color.text.inverse',
    'color.background.discovery.bold.pressed': 'color.text.inverse',
    'color.background.information.bold': 'color.text.inverse',
    'color.background.information.bold.hovered': 'color.text.inverse',
    'color.background.information.bold.pressed': 'color.text.inverse'
};
var $8f28566a9ab4b99f$export$5f1af8db9871e1d6 = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? 'span' : _ref$as, colorProp = _ref.color, align = _ref.align, testId = _ref.testId, id = _ref.id, size = _ref.size, weight = _ref.weight, maxLines = _ref.maxLines, xcss = _ref.xcss, children = _ref.children;
    (0, $fff3f31fc3bd4f88$export$2e2bcd8739ae039)($8f28566a9ab4b99f$var$asAllowlist.includes(Component), "@atlaskit/primitives: Text received an invalid \"as\" value of \"".concat(Component, "\""));
    var hasTextAncestor = (0, $836099bcad0c797b$export$9322276ec105d055)();
    var color = $8f28566a9ab4b99f$var$useColor(colorProp, hasTextAncestor);
    if (!size && !hasTextAncestor) size = 'medium';
    var component = /*#__PURE__*/ $5FkrB.createElement(Component, {
        id: id,
        className: (0, $jzAQA.default)([
            $8f28566a9ab4b99f$var$styles.root,
            size && $8f28566a9ab4b99f$var$fontSizeMap[size],
            color && $8f28566a9ab4b99f$var$textColorMap[color],
            maxLines && $8f28566a9ab4b99f$var$styles.truncation,
            maxLines === 1 && $8f28566a9ab4b99f$var$styles.breakAll,
            align && $8f28566a9ab4b99f$var$styles["textAlign.".concat(align)],
            weight && $8f28566a9ab4b99f$var$fontWeightMap[weight],
            Component === 'em' && $8f28566a9ab4b99f$var$styles['as.em'],
            Component === 'strong' && $8f28566a9ab4b99f$var$styles['as.strong'],
            xcss
        ]),
        style: {
            WebkitLineClamp: maxLines
        },
        "data-testid": testId,
        ref: ref
    }, children);
    if (hasTextAncestor) // no need to re-apply context if the text is already wrapped
    return component;
    return /*#__PURE__*/ $5FkrB.createElement((0, $2cfd5b2d2f747e18$export$ae933c6cbe5643ad), {
        value: true
    }, component);
});




var $5FkrB = parcelRequire("5FkrB");

var $57bba3312c846c2b$export$4ef52930e33717cd = 'data-theme';
var $57bba3312c846c2b$export$cb374d25ded7f6ab = 'data-subtree-theme';
var $57bba3312c846c2b$export$a00eac3f8684bcd0 = 'data-color-mode';
var $57bba3312c846c2b$export$2112803007239c61 = 'data-contrast-mode';
var $57bba3312c846c2b$export$352e418ed5b6193a = 'data-custom-theme';
var $57bba3312c846c2b$export$6f0c6fb8c80fcc92 = 'ds';
var $57bba3312c846c2b$export$4d0c7bbf80185957 = [
    'opacity',
    'font',
    'space',
    'border',
    'radius'
];
var $57bba3312c846c2b$export$dddac1532e822863 = "--".concat($57bba3312c846c2b$export$6f0c6fb8c80fcc92, "-token-not-found");
var $57bba3312c846c2b$export$9d7b58831ae93caa = "--".concat($57bba3312c846c2b$export$6f0c6fb8c80fcc92, "-elevation-surface-current");


/**
 * Theme modes: The general purpose of a theme.
 * This attr is used to apply the appropriate system-preference option
 * It may also be used as a selector for mode-specific overrides such as light/dark images.
 * The idea is there may exist many color themes, but every theme must either fit into light or dark.
 */ var $7bb90b9c4b8e9e7d$export$83993de8eb66733 = [
    'light',
    'dark',
    'auto'
];



var $61822435dec55643$export$4a14e169b1de4ee7 = function isColorMode(modeId) {
    return [
        'light',
        'dark',
        'auto'
    ].includes(modeId);
};


/**
 * Theme ids: The value that will be mounted to the DOM as a data attr
 * For example: `data-theme="light:light dark:dark spacing:spacing"
 *
 * These ids must be kebab case
 */ var $d5d97e047b78c80a$export$7d43e72a58e3283f = [
    'light-increased-contrast',
    'light',
    'light-future',
    'dark',
    'dark-future',
    'dark-increased-contrast',
    'spacing',
    'shape',
    'typography',
    'motion'
];


var $954f0c31652e7bd9$export$ea35b8958c39dd07 = function isThemeIds(themeId) {
    return (0, $d5d97e047b78c80a$export$7d43e72a58e3283f).find(function(id) {
        return id === themeId;
    }) !== undefined;
};


var $3c4747a6e48de63e$var$themeKinds = [
    'light',
    'dark',
    'spacing',
    'typography',
    'shape',
    'motion'
];
var $3c4747a6e48de63e$export$958fa026be3a263e = function isThemeKind(themeKind) {
    return $3c4747a6e48de63e$var$themeKinds.find(function(kind) {
        return kind === themeKind;
    }) !== undefined;
};


var $551fbddb3b7619ac$var$customThemeOptions = 'UNSAFE_themeOptions';
var $551fbddb3b7619ac$export$f19b488f7c0547ee = function themeStringToObject(themeState) {
    return themeState.split(' ')// @ts-ignore - TS1501 TypeScript 5.9.2 upgrade
    .map(function(theme) {
        return theme.split(/:([^]*)/);
    }).reduce(function(themeObject, _ref) {
        var _ref2 = (0, $1dc579c4de1142c2$export$2e2bcd8739ae039)(_ref, 2), kind = _ref2[0], id = _ref2[1];
        if (kind === 'colorMode' && (0, $61822435dec55643$export$4a14e169b1de4ee7)(id)) themeObject[kind] = id;
        if ((0, $3c4747a6e48de63e$export$958fa026be3a263e)(kind) && (0, $954f0c31652e7bd9$export$ea35b8958c39dd07)(id)) // @ts-expect-error FIXME - this is a valid ts error
        themeObject[kind] = id;
        if (kind === $551fbddb3b7619ac$var$customThemeOptions) try {
            themeObject[$551fbddb3b7619ac$var$customThemeOptions] = JSON.parse(id);
        } catch (_unused) {
            new Error('Invalid custom theme string');
        }
        return themeObject;
    }, {});
};


function $9031ce1f90bd94fb$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $9031ce1f90bd94fb$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $9031ce1f90bd94fb$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $34bcf16a63c65c03$export$2e2bcd8739ae039)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $9031ce1f90bd94fb$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $9031ce1f90bd94fb$var$isThemeColorMode = function isThemeColorMode(colorMode) {
    return (0, $7bb90b9c4b8e9e7d$export$83993de8eb66733).find(function(mode) {
        return mode === colorMode;
    }) !== undefined;
};
var $9031ce1f90bd94fb$var$getGlobalTheme = function getGlobalTheme() {
    if (typeof document === 'undefined') return {};
    var element = document.documentElement;
    var colorMode = element.getAttribute((0, $57bba3312c846c2b$export$a00eac3f8684bcd0)) || '';
    var theme = element.getAttribute((0, $57bba3312c846c2b$export$4ef52930e33717cd)) || '';
    return $9031ce1f90bd94fb$var$_objectSpread($9031ce1f90bd94fb$var$_objectSpread({}, (0, $551fbddb3b7619ac$export$f19b488f7c0547ee)(theme)), $9031ce1f90bd94fb$var$isThemeColorMode(colorMode) && {
        colorMode: colorMode
    });
};
var $9031ce1f90bd94fb$export$2e2bcd8739ae039 = $9031ce1f90bd94fb$var$getGlobalTheme;







/**
 * A MutationObserver which watches the `<html>` element for changes to the theme.
 *
 * In React, use the {@link useThemeObserver `useThemeObserver`} hook instead.
 *
 * @param {function} callback - A callback function which fires when the theme changes.
 *
 * @example
 * ```
 * const observer = new ThemeMutationObserver((theme) => {});
 * observer.observe();
 * ```
 */ var $623b026edd444f99$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function ThemeMutationObserver(callback) {
        (0, $a90d44c71774a73e$export$2e2bcd8739ae039)(this, ThemeMutationObserver);
        (0, $34bcf16a63c65c03$export$2e2bcd8739ae039)(this, "legacyObserver", null);
        this.callback = callback;
        ThemeMutationObserver.callbacks.add(callback);
    }
    return (0, $a83b4b1801bd7063$export$2e2bcd8739ae039)(ThemeMutationObserver, [
        {
            key: "observe",
            value: function observe() {
                if (!ThemeMutationObserver.observer) {
                    ThemeMutationObserver.observer = new MutationObserver(function() {
                        var theme = (0, $9031ce1f90bd94fb$export$2e2bcd8739ae039)();
                        ThemeMutationObserver.callbacks.forEach(function(callback) {
                            return callback(theme);
                        });
                    });
                    // Observer only needs to be configured once
                    ThemeMutationObserver.observer.observe(document.documentElement, {
                        attributeFilter: [
                            (0, $57bba3312c846c2b$export$4ef52930e33717cd),
                            (0, $57bba3312c846c2b$export$a00eac3f8684bcd0)
                        ]
                    });
                }
            }
        },
        {
            key: "disconnect",
            value: function disconnect() {
                if (this.callback) ThemeMutationObserver.callbacks.delete(this.callback);
                if (ThemeMutationObserver.callbacks.size === 0 && ThemeMutationObserver.observer) {
                    ThemeMutationObserver.observer.disconnect();
                    ThemeMutationObserver.observer = null;
                }
            }
        }
    ]);
}();
(0, $34bcf16a63c65c03$export$2e2bcd8739ae039)($623b026edd444f99$export$2e2bcd8739ae039, "observer", null);
(0, $34bcf16a63c65c03$export$2e2bcd8739ae039)($623b026edd444f99$export$2e2bcd8739ae039, "callbacks", new Set());


/**
 * A React hook which returns the current themes and color-mode set on `<html>`.
 *
 * @example
 * ```
 * const { colorMode, dark, light, spacing, typography } = useThemeObserver();
 *
 * // Performing side effects when it changes
 * useEffect(() => {
 *   console.log(`The color mode has changed to ${theme.colorMode}`);
 * }, [theme.colorMode]);
 * ```
 */ var $7024545ccf34c1a4$var$useThemeObserver = function useThemeObserver() {
    var _useState = (0, $5FkrB.useState)((0, $9031ce1f90bd94fb$export$2e2bcd8739ae039)()), _useState2 = (0, $1dc579c4de1142c2$export$2e2bcd8739ae039)(_useState, 2), theme = _useState2[0], setTheme = _useState2[1];
    (0, $5FkrB.useEffect)(function() {
        var observer = new (0, $623b026edd444f99$export$2e2bcd8739ae039)(function(theme) {
            return setTheme(theme);
        });
        observer.observe();
        return function() {
            return observer.disconnect();
        };
    }, []);
    return theme;
};
var $7024545ccf34c1a4$export$2e2bcd8739ae039 = $7024545ccf34c1a4$var$useThemeObserver;


function $117a04c40b4f6be5$var$getSafeValue() {
    var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    var numericValue = +value;
    if (numericValue < 0) return 0;
    return value;
}
function $117a04c40b4f6be5$export$7c4d25c0c3217d8c(value, max) {
    var safeValue = $117a04c40b4f6be5$var$getSafeValue(value);
    var safeMax = $117a04c40b4f6be5$var$getSafeValue(max);
    if (safeMax && safeMax < safeValue) return "".concat(safeMax, "+");
    if (safeValue === Infinity) return "\u221E";
    return safeValue.toString();
}


/* eslint-disable @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors */ // Nested selectors with data attributes are required for theme switching
var $0833cc217cf36684$var$stylesNew = {
    root: "_2rkolb4i _18zr1b66 _1rjcidpf _1e0c116y _vchhusvi _1ul91ejb _1bah1h6o _1o9zidpf _1kz6184x",
    success: "_syaz1p1e _bfhk14j0",
    danger: "_syaz1blx _bfhk18wg",
    warning: "_syazmgs1 _bfhk10f4",
    information: "_syaz1qd9 _bfhk8lbg",
    discovery: "_syaz1g72 _bfhke670",
    neutral: "_syazi7uo _bfhk7qp0",
    inverse: "_bfhkvuon _syazi7uo",
    informationBold: "_syaz1qd9 _bfhk9pm7",
    successBold: "_syaz1p1e _bfhk16ib",
    dangerBold: "_syaz1blx _bfhkud63",
    warningBold: "_syazmgs1 _bfhk1kmu",
    warningBoldDark: "_syazmgs1 _bfhkgj02",
    discoveryBold: "_syaz1g72 _bfhk5ly7"
};
/* eslint-enable @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors */ var $0833cc217cf36684$var$badgeValueWithNegativeNumberSupported = function badgeValueWithNegativeNumberSupported(children, max) {
    return typeof children === 'number' && max ? (0, $117a04c40b4f6be5$export$7c4d25c0c3217d8c)(children, max) : children;
};
/**
 * __BadgeNew__
 *
 * New visual refresh implementation of Badge component for the labelling system.
 * This component is used when the 'platform-dst-lozenge-tag-badge-visual-uplifts' feature flag is enabled.
 *
 * Uses new appearance naming convention:
 * - success (green)
 * - danger (red)
 * - neutral (gray)
 * - information (blue)
 * - inverse (inverted colors)
 * - warning (orange/yellow)
 * - discovery (purple)
 * - informationBold (bold blue, color.background.information.subtle)
 * - successBold (bold green, color.background.success.subtle)
 * - dangerBold (bold red, color.background.danger.subtle)
 * - warningBold (bold warning, color.background.warning.bold)
 * - discoveryBold (bold purple, color.background.discovery.subtle)
 */ var $0833cc217cf36684$var$BadgeNew = /*#__PURE__*/ (0, $5FkrB.memo)(function BadgeNew(_ref) {
    var _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'neutral' : _ref$appearance, _ref$children = _ref.children, children = _ref$children === void 0 ? 0 : _ref$children, _ref$max = _ref.max, max = _ref$max === void 0 ? 99 : _ref$max, style = _ref.style, testId = _ref.testId;
    var _useThemeObserver = (0, $7024545ccf34c1a4$export$2e2bcd8739ae039)(), colorMode = _useThemeObserver.colorMode;
    // In dark theme, warningBold needs to swap to a lighter background
    // (color.background.warning.subtle / Orange800) for better contrast against
    // the typical dark surface colors.
    var resolvedAppearance = appearance === 'warningBold' && colorMode === 'dark' ? 'warningBoldDark' : appearance;
    return /*#__PURE__*/ $5FkrB.createElement("span", {
        "data-testid": testId,
        style: {
            background: style === null || style === void 0 ? void 0 : style.backgroundColor,
            color: style === null || style === void 0 ? void 0 : style.color
        },
        className: (0, $jzAQA.default)([
            $0833cc217cf36684$var$stylesNew.root,
            $0833cc217cf36684$var$stylesNew[resolvedAppearance]
        ])
    }, /*#__PURE__*/ $5FkrB.createElement((0, $8f28566a9ab4b99f$export$5f1af8db9871e1d6), {
        size: "small",
        align: "center",
        color: "inherit"
    }, $0833cc217cf36684$var$badgeValueWithNegativeNumberSupported(children, max)));
});
var $0833cc217cf36684$export$2e2bcd8739ae039 = $0833cc217cf36684$var$BadgeNew;


/* index.tsx generated by @compiled/babel-plugin v0.39.1 */ parcelRequire("5FkrB");

const $f99957aff2dd52da$export$6c9a87045746941d = ()=>{
    return new Error(`
 \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2557}   \u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2557}     \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}
\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}
\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}   \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}  \u{2588}\u{2588}\u{2551}  \u{2588}\u{2588}\u{2551}
\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}   \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}\u{255A}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{255D} \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{255D}  \u{2588}\u{2588}\u{2551}  \u{2588}\u{2588}\u{2551}
\u{255A}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{255A}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551} \u{255A}\u{2550}\u{255D} \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}
 \u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D} \u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D} \u{255A}\u{2550}\u{255D}     \u{255A}\u{2550}\u{255D}\u{255A}\u{2550}\u{255D}     \u{255A}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}

  @compiled/react

  Code was executed when it shouldn't have. This could have happened because:

  1. You haven't configured a transformer yet. Visit https://compiledcssinjs.com/docs/installation and follow the instructions.
  2. You have duplicate versions of React and hooks are blowing up. You need to de-duplicate your dependencies.

  Good luck!
`);
};
const $f99957aff2dd52da$export$c4df1cb0c2b4d77c = ()=>{
    return new Error(`
 \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2557}   \u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2557}     \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}
\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}
\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}   \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}  \u{2588}\u{2588}\u{2551}  \u{2588}\u{2588}\u{2551}
\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}   \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}\u{255A}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{255D} \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{255D}  \u{2588}\u{2588}\u{2551}  \u{2588}\u{2588}\u{2551}
\u{255A}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{255A}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551} \u{255A}\u{2550}\u{255D} \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}
 \u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D} \u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D} \u{255A}\u{2550}\u{255D}     \u{255A}\u{2550}\u{255D}\u{255A}\u{2550}\u{255D}     \u{255A}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}

  @compiled/react

  Code was executed when it shouldn't have. To resolve make sure to:

  1. Set up Compiled.
  2. Configure importSources in your Compiled config to point to the module that exports the output of createStrictAPI().

  For more information visit https://compiledcssinjs.com/docs/installation and follow the instructions.
`);
};


/**
 * This length includes the underscore,
 * e.g. `"_1s4A"` would be a valid atomic group hash.
 */ const $36bc5df9d50a625a$var$ATOMIC_GROUP_LENGTH = 5;
function $36bc5df9d50a625a$export$2e2bcd8739ae039(classNames) {
    // Shortcut: nothing to do
    if (!classNames.length) return;
    // Shortcut: don't need to do anything if we only have a single classname
    if (classNames.length === 1 && classNames[0] && // checking to see if `classNames[0]` is a string that contains other classnames
    !classNames[0].includes(' ')) return classNames[0];
    // Using an object rather than a `Map` as it performed better in our benchmarks.
    // Would be happy to move to `Map` if it proved to be better under real conditions.
    const map = {};
    // Note: using loops to minimize iterations over the collection
    for (const value of classNames){
        // Exclude all falsy values, which leaves us with populated strings
        if (!value) continue;
        // a `value` can contain multiple classnames
        const list = value.split(' ');
        for (const className of list){
            /**
             * For atomic style classnames: the `key` is the `group`
             *
             * - Later atomic classnames with the same `group` will override earlier ones
             *   (which is what we want).
             * - Assumes atomic classnames are the only things that start with `_`
             * - Could use a regex to ensure that atomic classnames are structured how we expect,
             *   but did not add that for now as it did slow things down a bit.
             *
             * For other classnames: the `key` is the whole classname
             * - Okay to remove duplicates as doing so does not impact specificity
             *
             * */ const key = className.startsWith('_') ? className.slice(0, $36bc5df9d50a625a$var$ATOMIC_GROUP_LENGTH) : className;
            map[key] = className;
        }
    }
    /**
     * We are converting the `map` into a string.
     *
     * The simple way to do this would be `Object.values(map).join(' ')`.
     * However, the approach below performs 10%-20% better in benchmarks.
     *
     * For `ax()` it feels right to squeeze as much runtime performance out as we can.
     */ let result = '';
    for(const key in map)result += map[key] + ' ';
    // If we have an empty string, then our `map` was empty.
    if (!result) return;
    // remove last " " from the result (we added " " at the end of every value)
    return result.trimEnd();
}


const $f6201189c327b4b0$export$a274e22fb40f762e = (...styles)=>{
    // At runtime TStyles is resolved down to strings, but not at compile time.
    // We circumvent the type system here because of that.
    const actualStyles = styles;
    // The output should be a union type of passed in styles. This ensures the call
    // site of xcss prop can raise violations when disallowed styles have been passed.
    return (0, $36bc5df9d50a625a$export$2e2bcd8739ae039)(actualStyles);
};


function $c78d5a678876881e$export$39716b4af53f4ad() {
    return {
        css () {
            throw (0, $f99957aff2dd52da$export$c4df1cb0c2b4d77c)();
        },
        cssMap () {
            throw (0, $f99957aff2dd52da$export$c4df1cb0c2b4d77c)();
        },
        cx: $f6201189c327b4b0$export$a274e22fb40f762e,
        XCSSProp () {
            throw (0, $f99957aff2dd52da$export$c4df1cb0c2b4d77c)();
        }
    };
}


var $1845bee1a1da9181$var$strictApi = (0, $c78d5a678876881e$export$39716b4af53f4ad)();
var $1845bee1a1da9181$export$dbf350e5966cf602 = $1845bee1a1da9181$var$strictApi.css;
var $1845bee1a1da9181$export$eb1ecd84a24ee424 = $1845bee1a1da9181$var$strictApi.cssMap;
$1845bee1a1da9181$var$strictApi.cssMap;
var $1845bee1a1da9181$export$a274e22fb40f762e = $1845bee1a1da9181$var$strictApi.cx;
var $1845bee1a1da9181$var$XCSSProp = $1845bee1a1da9181$var$strictApi.XCSSProp; // This is to mitigate local TS error TS2315: Type 'StrictXCSSProp' is not generic.
 // Currently for some reason tsc is generating malformed .d.ts in local dev environment, below change fixes it
 /**
 * ## StrictXCSSProp
 *
 * Declare styles your component takes with all other styles marked as violations
 * by the TypeScript compiler. There are two primary use cases for xcss prop:
 *
 * - safe style overrides
 * - inverting style declarations
 *
 * Interverting style declarations is interesting for platform teams as
 * it means apps only pay for styles they use as they're now the ones who declare
 * the styles!
 *
 * The {@link StrictXCSSProp} type has generics two of which must be defined — use to explicitly
 * set what you want to maintain as API. Use {@link XCSSAllProperties} and {@link XCSSAllPseudos}
 * to enable all properties and pseudos.
 *
 * The third generic is used to declare what properties and pseudos should be required.
 *
 * ```tsx
 * interface MyComponentProps {
 *   // Color is accepted, all other properties / pseudos are considered violations.
 *   xcss?: StrictXCSSProp<'color', never>;
 *
 *   // Only background color and hover pseudo are accepted.
 *   xcss?: StrictXCSSProp<'backgroundColor', '&:hover'>;
 *
 *   // All properties are accepted, all pseudos are considered violations.
 *   xcss?: StrictXCSSProp<XCSSAllProperties, never>;
 *
 *   // All properties are accepted, only the hover pseudo is accepted.
 *   xcss?: StrictXCSSProp<XCSSAllProperties, '&:hover'>;
 *
 *   // The xcss prop is required as well as the color property. No pseudos are required.
 *   xcss: StrictXCSSProp<
 *     XCSSAllProperties,
 *     '&:hover',
 *     { requiredProperties: 'color', requiredPseudos: never }
 *   >;
 * }
 *
 * function MyComponent({ xcss }: MyComponentProps) {
 *   return <div css={{ color: 'var(--ds-text-danger)' }} className={xcss} />
 * }
 * ```
 *
 * The xcss prop works with static inline objects and the [cssMap](https://compiledcssinjs.com/docs/api-cssmap) API.
 *
 * ```jsx
 * // Declared as an inline object
 * <Component xcss={{ color: 'var(--ds-text)' }} />
 *
 * // Declared with the cssMap API
 * const styles = cssMap({ text: { color: 'var(--ds-text)' } });
 * <Component xcss={styles.text} />
 * ```
 *
 * To concatenate and conditonally apply styles use the {@link cssMap} and {@link cx} functions.
 */ 


var $b465753bb15ee4c1$exports = {};
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d56e8662eb8a8d2462ec3a39ff3aa40b>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty($b465753bb15ee4c1$exports, "__esModule", {
    value: true
});
$b465753bb15ee4c1$exports.default = void 0;

var $b465753bb15ee4c1$var$_react = $b465753bb15ee4c1$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $b465753bb15ee4c1$var$_baseNew = $b465753bb15ee4c1$var$_interopRequireDefault((parcelRequire("f28qG")));
function $b465753bb15ee4c1$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ChevronDown".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Do not use 16px chevrons within buttons, icon buttons, or dropdowns to maintain visual cohesion with ADS which uses 12px chevrons.
Known uses: Open dropdown menu, expanded tree item, collapse tree item
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $b465753bb15ee4c1$var$ChevronDownIcon = (props)=>/*#__PURE__*/ $b465753bb15ee4c1$var$_react.default.createElement($b465753bb15ee4c1$var$_baseNew.default, Object.assign({
        name: "ChevronDownIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="m14.53 6.03-6 6a.75.75 0 0 1-1.004.052l-.056-.052-6-6 1.06-1.06L8 10.44l5.47-5.47z"/>`
    }, props));
$b465753bb15ee4c1$var$ChevronDownIcon.displayName = 'ChevronDownIcon';
var $b465753bb15ee4c1$var$_default = $b465753bb15ee4c1$exports.default = $b465753bb15ee4c1$var$ChevronDownIcon;




var $5FkrB = parcelRequire("5FkrB");
var $d70cb3a36bcc89c9$export$c5406bd59b374abd = function isMatchMediaAvailable() {
    return typeof window !== 'undefined' && 'matchMedia' in window;
};


var $2186f5b02e737a7a$export$b7baf7667a68d87c = function isReducedMotion() {
    if (!(0, $d70cb3a36bcc89c9$export$c5406bd59b374abd)()) return false;
    var _window$matchMedia = window.matchMedia('(prefers-reduced-motion: reduce)'), matches = _window$matchMedia.matches;
    return matches;
};



var $5FkrB = parcelRequire("5FkrB");
var $68323260754c7b21$export$ff879f35a69d56b7 = function useElementRef() {
    var elementRef = (0, $5FkrB.useRef)(null);
    var setRef = (0, $5FkrB.useCallback)(function(ref) {
        elementRef.current = ref;
    }, []);
    return [
        elementRef.current,
        setRef
    ];
};



var $5FkrB = parcelRequire("5FkrB");
var $bbb553abe3fb900e$export$e5c5a5f917a5871c = typeof window === 'undefined' ? (0, $5FkrB.useEffect) : (0, $5FkrB.useLayoutEffect);



var $5FkrB = parcelRequire("5FkrB");
var $1996deb533127c3f$var$getHookDeps = function getHookDeps(opts) {
    switch(opts.cleanup){
        case 'next-effect':
            return undefined;
        case 'unmount':
        default:
            return [];
    }
};
var $1996deb533127c3f$export$1775f27e7c8051ca = function useRequestAnimationFrame() {
    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        cleanup: 'unmount'
    };
    var frames = (0, $5FkrB.useRef)([]);
    (0, $5FkrB.useEffect)(function() {
        return function() {
            if (frames.current.length) {
                frames.current.forEach(function(id) {
                    return cancelAnimationFrame(id);
                });
                frames.current = [];
            }
        };
    // We dynamically set this so we either clean up on the next effect - or on unmount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, $1996deb533127c3f$var$getHookDeps(opts));
    return (0, $5FkrB.useCallback)(function(handler) {
        var id = requestAnimationFrame(function(time) {
            frames.current = frames.current.filter(function(frameId) {
                return frameId !== id;
            });
            handler(time);
        });
        frames.current.push(id);
    }, []);
};



var $5FkrB = parcelRequire("5FkrB");
// Handle both browser and Node.js environments
var $9c12f4a4f9e5fd5a$var$getHookDeps = function getHookDeps(opts) {
    switch(opts.cleanup){
        case 'next-effect':
            return undefined;
        case 'unmount':
        default:
            return [];
    }
};
var $9c12f4a4f9e5fd5a$export$4f34107a2b00f39c = function useSetTimeout() {
    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        cleanup: 'unmount'
    };
    var timeouts = (0, $5FkrB.useRef)([]);
    (0, $5FkrB.useEffect)(function() {
        return function() {
            if (timeouts.current.length) {
                timeouts.current.forEach(function(id) {
                    return clearTimeout(id);
                });
                timeouts.current = [];
            }
        };
    // We dynamically set this so we either clean up on the next effect - or on unmount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, $9c12f4a4f9e5fd5a$var$getHookDeps(opts));
    return (0, $5FkrB.useCallback)(function(handler, timeout) {
        for(var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)args[_key - 2] = arguments[_key];
        var id = setTimeout.apply(void 0, [
            function() {
                timeouts.current = timeouts.current.filter(function(timeoutId) {
                    return timeoutId !== id;
                });
                handler();
            },
            timeout
        ].concat(args));
        timeouts.current.push(id);
    }, []);
};



var $5FkrB = parcelRequire("5FkrB");

var $bdc9d3462c41b806$export$9e95200239cd148b = function useSnapshotBeforeUpdate(cb) {
    var isFirstRender = (0, $5FkrB.useRef)(true);
    if (!isFirstRender.current) cb();
    (0, $bbb553abe3fb900e$export$e5c5a5f917a5871c)(function() {
        isFirstRender.current = false;
    }, []);
};


/**
 * Which dimension(s) of the element to animate.
 *
 * - `'width'` animates only width changes.
 * - `'height'` animates only height changes.
 * - `'both'` animates width and height changes simultaneously.
 */ /**
 * Parses a CSS time value (e.g. `"0.2s"` or `"200ms"`) and returns milliseconds.
 * Falls back to 0 if the value cannot be parsed.
 */ function $83120f7eb9e62313$var$parseCSSTimeToMs(value) {
    var parsed = parseFloat(value);
    if (Number.isNaN(parsed)) return 0;
    if (value.endsWith('ms')) return parsed;
    return parsed * 1000;
}
/**
 * Returns `true` if any of the dimension(s) being animated have changed
 * between the previous and next measurements.
 */ function $83120f7eb9e62313$var$hasDimensionChanged(dimension, prev, next) {
    if (dimension === 'width') return prev.width !== next.width;
    if (dimension === 'height') return prev.height !== next.height;
    return prev.width !== next.width || prev.height !== next.height;
}
/**
 * Returns the CSS `transition-property` / `will-change` value for the
 * given dimension(s).
 */ function $83120f7eb9e62313$var$getDimensionPropertyList(dimension) {
    if (dimension === 'both') return 'width, height';
    return dimension;
}
var $83120f7eb9e62313$export$a300664a1a230956 = function useResizing(_ref) {
    var dimension = _ref.dimension, duration = _ref.duration, easing = _ref.easing, onFinishMotion = _ref.onFinishMotion;
    var prevDimensions = (0, $5FkrB.useRef)();
    var _useElementRef = (0, $68323260754c7b21$export$ff879f35a69d56b7)(), _useElementRef2 = (0, $1dc579c4de1142c2$export$2e2bcd8739ae039)(_useElementRef, 2), element = _useElementRef2[0], setElementRef = _useElementRef2[1];
    var setTimeout = (0, $9c12f4a4f9e5fd5a$export$4f34107a2b00f39c)({
        cleanup: 'next-effect'
    });
    var requestAnimationFrame = (0, $1996deb533127c3f$export$1775f27e7c8051ca)();
    (0, $bdc9d3462c41b806$export$9e95200239cd148b)(function() {
        if ((0, $2186f5b02e737a7a$export$b7baf7667a68d87c)() || !element) return;
        var rect = element.getBoundingClientRect();
        prevDimensions.current = {
            width: rect.width,
            height: rect.height
        };
    });
    (0, $bbb553abe3fb900e$export$e5c5a5f917a5871c)(function() {
        if ((0, $2186f5b02e737a7a$export$b7baf7667a68d87c)() || !element || !prevDimensions.current) return;
        // We might already be animating.
        // Because of that we need to expand to the destination dimensions first.
        element.setAttribute('style', '');
        var rect = element.getBoundingClientRect();
        var nextDimensions = {
            width: rect.width,
            height: rect.height
        };
        if (!$83120f7eb9e62313$var$hasDimensionChanged(dimension, prevDimensions.current, nextDimensions)) {
            onFinishMotion === null || onFinishMotion === void 0 || onFinishMotion();
            return;
        }
        var propertyList = $83120f7eb9e62313$var$getDimensionPropertyList(dimension);
        var newStyles = {
            willChange: propertyList,
            transitionProperty: propertyList,
            transitionDuration: duration,
            boxSizing: 'border-box',
            transitionTimingFunction: easing
        };
        if (dimension === 'width' || dimension === 'both') newStyles.width = "".concat(prevDimensions.current.width, "px");
        if (dimension === 'height' || dimension === 'both') newStyles.height = "".concat(prevDimensions.current.height, "px");
        Object.assign(element.style, newStyles);
        var resolvedDuration = $83120f7eb9e62313$var$parseCSSTimeToMs(getComputedStyle(element).transitionDuration);
        // We split this over two animation frames so the DOM has enough time to flush the changes.
        // We are deliberately not skipping this frame if another render happens - if we do the motion doesn't finish properly.
        requestAnimationFrame(function() {
            requestAnimationFrame(function() {
                if (!element) return;
                if (dimension === 'width' || dimension === 'both') element.style.width = "".concat(nextDimensions.width, "px");
                if (dimension === 'height' || dimension === 'both') element.style.height = "".concat(nextDimensions.height, "px");
                setTimeout(function() {
                    if (!element) return;
                    element.setAttribute('style', '');
                    onFinishMotion === null || onFinishMotion === void 0 || onFinishMotion();
                }, resolvedDuration);
            });
        });
    });
    return {
        ref: setElementRef
    };
};







var $5FkrB = parcelRequire("5FkrB");

var $2nBsU = parcelRequire("2nBsU");


var $5FkrB = parcelRequire("5FkrB");


function $0a7767b2db2f25f5$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $0a7767b2db2f25f5$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $0a7767b2db2f25f5$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $34bcf16a63c65c03$export$2e2bcd8739ae039)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $0a7767b2db2f25f5$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $0a7767b2db2f25f5$export$a4687b0234b40e28(_ref) {
    var fn = _ref.fn, action = _ref.action, componentName = _ref.componentName, actionSubject = _ref.actionSubject, packageName = _ref.packageName, packageVersion = _ref.packageVersion, analyticsData = _ref.analyticsData;
    var _useAnalyticsEvents = (0, $56a0b6ad5e593ea4$export$5bf35293e545f20c)(), createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
    // We put analyticsData and fn in a ref so that we don't need to break
    // memoization.
    // Generally these could be defined by consumers inline
    // and so we do this to avoid breaking memoization of useCallback
    var dataRef = (0, $e13b10ce18d01343$export$1d27a74659855e44)(analyticsData);
    var fnRef = (0, $e13b10ce18d01343$export$1d27a74659855e44)(fn);
    var handler = (0, $5FkrB.useCallback)(function(value) {
        var analyticsEvent = createAnalyticsEvent({
            action: action,
            actionSubject: actionSubject || componentName,
            attributes: {
                componentName: componentName,
                packageName: packageName,
                packageVersion: packageVersion
            }
        });
        // To avoid wrapping this component in AnalyticsContext we manually
        // push the parent context's meta data into the context.
        // Note: this new 'context'
        var context = $0a7767b2db2f25f5$var$_objectSpread({
            componentName: componentName,
            packageName: packageName,
            packageVersion: packageVersion
        }, dataRef.current);
        analyticsEvent.context.push(context);
        // fire an event on the atlaskit channel
        var clone = analyticsEvent.clone();
        if (clone) clone.fire('atlaskit');
        fnRef.current(value, analyticsEvent);
    }, [
        // These are strings and won't change
        action,
        componentName,
        actionSubject,
        packageName,
        packageVersion,
        // This function is memoized in the context
        createAnalyticsEvent,
        // these are a stable ref because of the useTrackedRef hook
        dataRef,
        fnRef
    ]);
    return handler;
}




// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::74848f30a8ab0264055ca77ebdcac583>>
 * @codegenCommand yarn workspace @atlaskit/primitives codegen-styles
 * @codegenDependency ../../../tokens/src/artifacts/tokens-raw/atlassian-light.tsx <<SignedSource::4e25079e2363933fae45ad0f1e9c123b>>
 */ var $c425c5c09600f673$export$d1d79bf68ac056bd = {
    'color.background.accent.lime.subtlest': "var(--ds-background-accent-lime-subtlest, #EFFFD6)",
    'color.background.accent.lime.subtlest.hovered': "var(--ds-background-accent-lime-subtlest-hovered, #D3F1A7)",
    'color.background.accent.lime.subtlest.pressed': "var(--ds-background-accent-lime-subtlest-pressed, #BDE97C)",
    'color.background.accent.lime.subtler': "var(--ds-background-accent-lime-subtler, #D3F1A7)",
    'color.background.accent.lime.subtler.hovered': "var(--ds-background-accent-lime-subtler-hovered, #BDE97C)",
    'color.background.accent.lime.subtler.pressed': "var(--ds-background-accent-lime-subtler-pressed, #B3DF72)",
    'color.background.accent.lime.subtle': "var(--ds-background-accent-lime-subtle, #94C748)",
    'color.background.accent.lime.subtle.hovered': "var(--ds-background-accent-lime-subtle-hovered, #B3DF72)",
    'color.background.accent.lime.subtle.pressed': "var(--ds-background-accent-lime-subtle-pressed, #BDE97C)",
    'color.background.accent.lime.bolder': "var(--ds-background-accent-lime-bolder, #5B7F24)",
    'color.background.accent.lime.bolder.hovered': "var(--ds-background-accent-lime-bolder-hovered, #4C6B1F)",
    'color.background.accent.lime.bolder.pressed': "var(--ds-background-accent-lime-bolder-pressed, #3F5224)",
    'color.background.accent.red.subtlest': "var(--ds-background-accent-red-subtlest, #FFECEB)",
    'color.background.accent.red.subtlest.hovered': "var(--ds-background-accent-red-subtlest-hovered, #FFD5D2)",
    'color.background.accent.red.subtlest.pressed': "var(--ds-background-accent-red-subtlest-pressed, #FFB8B2)",
    'color.background.accent.red.subtler': "var(--ds-background-accent-red-subtler, #FFD5D2)",
    'color.background.accent.red.subtler.hovered': "var(--ds-background-accent-red-subtler-hovered, #FFB8B2)",
    'color.background.accent.red.subtler.pressed': "var(--ds-background-accent-red-subtler-pressed, #FD9891)",
    'color.background.accent.red.subtle': "var(--ds-background-accent-red-subtle, #F87168)",
    'color.background.accent.red.subtle.hovered': "var(--ds-background-accent-red-subtle-hovered, #FD9891)",
    'color.background.accent.red.subtle.pressed': "var(--ds-background-accent-red-subtle-pressed, #FFB8B2)",
    'color.background.accent.red.bolder': "var(--ds-background-accent-red-bolder, #C9372C)",
    'color.background.accent.red.bolder.hovered': "var(--ds-background-accent-red-bolder-hovered, #AE2E24)",
    'color.background.accent.red.bolder.pressed': "var(--ds-background-accent-red-bolder-pressed, #872821)",
    'color.background.accent.orange.subtlest': "var(--ds-background-accent-orange-subtlest, #FFF5DB)",
    'color.background.accent.orange.subtlest.hovered': "var(--ds-background-accent-orange-subtlest-hovered, #FCE4A6)",
    'color.background.accent.orange.subtlest.pressed': "var(--ds-background-accent-orange-subtlest-pressed, #FBD779)",
    'color.background.accent.orange.subtler': "var(--ds-background-accent-orange-subtler, #FCE4A6)",
    'color.background.accent.orange.subtler.hovered': "var(--ds-background-accent-orange-subtler-hovered, #FBD779)",
    'color.background.accent.orange.subtler.pressed': "var(--ds-background-accent-orange-subtler-pressed, #FBC828)",
    'color.background.accent.orange.subtle': "var(--ds-background-accent-orange-subtle, #FCA700)",
    'color.background.accent.orange.subtle.hovered': "var(--ds-background-accent-orange-subtle-hovered, #FBC828)",
    'color.background.accent.orange.subtle.pressed': "var(--ds-background-accent-orange-subtle-pressed, #FBD779)",
    'color.background.accent.orange.bolder': "var(--ds-background-accent-orange-bolder, #BD5B00)",
    'color.background.accent.orange.bolder.hovered': "var(--ds-background-accent-orange-bolder-hovered, #9E4C00)",
    'color.background.accent.orange.bolder.pressed': "var(--ds-background-accent-orange-bolder-pressed, #7A3B00)",
    'color.background.accent.yellow.subtlest': "var(--ds-background-accent-yellow-subtlest, #FEF7C8)",
    'color.background.accent.yellow.subtlest.hovered': "var(--ds-background-accent-yellow-subtlest-hovered, #F5E989)",
    'color.background.accent.yellow.subtlest.pressed': "var(--ds-background-accent-yellow-subtlest-pressed, #EFDD4E)",
    'color.background.accent.yellow.subtler': "var(--ds-background-accent-yellow-subtler, #F5E989)",
    'color.background.accent.yellow.subtler.hovered': "var(--ds-background-accent-yellow-subtler-hovered, #EFDD4E)",
    'color.background.accent.yellow.subtler.pressed': "var(--ds-background-accent-yellow-subtler-pressed, #EED12B)",
    'color.background.accent.yellow.subtle': "var(--ds-background-accent-yellow-subtle, #EED12B)",
    'color.background.accent.yellow.subtle.hovered': "var(--ds-background-accent-yellow-subtle-hovered, #DDB30E)",
    'color.background.accent.yellow.subtle.pressed': "var(--ds-background-accent-yellow-subtle-pressed, #EFDD4E)",
    'color.background.accent.yellow.bolder': "var(--ds-background-accent-yellow-bolder, #946F00)",
    'color.background.accent.yellow.bolder.hovered': "var(--ds-background-accent-yellow-bolder-hovered, #7F5F01)",
    'color.background.accent.yellow.bolder.pressed': "var(--ds-background-accent-yellow-bolder-pressed, #614A05)",
    'color.background.accent.green.subtlest': "var(--ds-background-accent-green-subtlest, #DCFFF1)",
    'color.background.accent.green.subtlest.hovered': "var(--ds-background-accent-green-subtlest-hovered, #BAF3DB)",
    'color.background.accent.green.subtlest.pressed': "var(--ds-background-accent-green-subtlest-pressed, #97EDC9)",
    'color.background.accent.green.subtler': "var(--ds-background-accent-green-subtler, #BAF3DB)",
    'color.background.accent.green.subtler.hovered': "var(--ds-background-accent-green-subtler-hovered, #97EDC9)",
    'color.background.accent.green.subtler.pressed': "var(--ds-background-accent-green-subtler-pressed, #7EE2B8)",
    'color.background.accent.green.subtle': "var(--ds-background-accent-green-subtle, #4BCE97)",
    'color.background.accent.green.subtle.hovered': "var(--ds-background-accent-green-subtle-hovered, #7EE2B8)",
    'color.background.accent.green.subtle.pressed': "var(--ds-background-accent-green-subtle-pressed, #97EDC9)",
    'color.background.accent.green.bolder': "var(--ds-background-accent-green-bolder, #1F845A)",
    'color.background.accent.green.bolder.hovered': "var(--ds-background-accent-green-bolder-hovered, #216E4E)",
    'color.background.accent.green.bolder.pressed': "var(--ds-background-accent-green-bolder-pressed, #19573D)",
    'color.background.accent.teal.subtlest': "var(--ds-background-accent-teal-subtlest, #E7F9FF)",
    'color.background.accent.teal.subtlest.hovered': "var(--ds-background-accent-teal-subtlest-hovered, #C6EDFB)",
    'color.background.accent.teal.subtlest.pressed': "var(--ds-background-accent-teal-subtlest-pressed, #B1E4F7)",
    'color.background.accent.teal.subtler': "var(--ds-background-accent-teal-subtler, #C6EDFB)",
    'color.background.accent.teal.subtler.hovered': "var(--ds-background-accent-teal-subtler-hovered, #B1E4F7)",
    'color.background.accent.teal.subtler.pressed': "var(--ds-background-accent-teal-subtler-pressed, #9DD9EE)",
    'color.background.accent.teal.subtle': "var(--ds-background-accent-teal-subtle, #6CC3E0)",
    'color.background.accent.teal.subtle.hovered': "var(--ds-background-accent-teal-subtle-hovered, #9DD9EE)",
    'color.background.accent.teal.subtle.pressed': "var(--ds-background-accent-teal-subtle-pressed, #B1E4F7)",
    'color.background.accent.teal.bolder': "var(--ds-background-accent-teal-bolder, #227D9B)",
    'color.background.accent.teal.bolder.hovered': "var(--ds-background-accent-teal-bolder-hovered, #206A83)",
    'color.background.accent.teal.bolder.pressed': "var(--ds-background-accent-teal-bolder-pressed, #1A5265)",
    'color.background.accent.blue.subtlest': "var(--ds-background-accent-blue-subtlest, #E9F2FE)",
    'color.background.accent.blue.subtlest.hovered': "var(--ds-background-accent-blue-subtlest-hovered, #CFE1FD)",
    'color.background.accent.blue.subtlest.pressed': "var(--ds-background-accent-blue-subtlest-pressed, #ADCBFB)",
    'color.background.accent.blue.subtler': "var(--ds-background-accent-blue-subtler, #CFE1FD)",
    'color.background.accent.blue.subtler.hovered': "var(--ds-background-accent-blue-subtler-hovered, #ADCBFB)",
    'color.background.accent.blue.subtler.pressed': "var(--ds-background-accent-blue-subtler-pressed, #8FB8F6)",
    'color.background.accent.blue.subtle': "var(--ds-background-accent-blue-subtle, #669DF1)",
    'color.background.accent.blue.subtle.hovered': "var(--ds-background-accent-blue-subtle-hovered, #8FB8F6)",
    'color.background.accent.blue.subtle.pressed': "var(--ds-background-accent-blue-subtle-pressed, #ADCBFB)",
    'color.background.accent.blue.bolder': "var(--ds-background-accent-blue-bolder, #1868DB)",
    'color.background.accent.blue.bolder.hovered': "var(--ds-background-accent-blue-bolder-hovered, #1558BC)",
    'color.background.accent.blue.bolder.pressed': "var(--ds-background-accent-blue-bolder-pressed, #144794)",
    'color.background.accent.purple.subtlest': "var(--ds-background-accent-purple-subtlest, #F8EEFE)",
    'color.background.accent.purple.subtlest.hovered': "var(--ds-background-accent-purple-subtlest-hovered, #EED7FC)",
    'color.background.accent.purple.subtlest.pressed': "var(--ds-background-accent-purple-subtlest-pressed, #E3BDFA)",
    'color.background.accent.purple.subtler': "var(--ds-background-accent-purple-subtler, #EED7FC)",
    'color.background.accent.purple.subtler.hovered': "var(--ds-background-accent-purple-subtler-hovered, #E3BDFA)",
    'color.background.accent.purple.subtler.pressed': "var(--ds-background-accent-purple-subtler-pressed, #D8A0F7)",
    'color.background.accent.purple.subtle': "var(--ds-background-accent-purple-subtle, #C97CF4)",
    'color.background.accent.purple.subtle.hovered': "var(--ds-background-accent-purple-subtle-hovered, #D8A0F7)",
    'color.background.accent.purple.subtle.pressed': "var(--ds-background-accent-purple-subtle-pressed, #E3BDFA)",
    'color.background.accent.purple.bolder': "var(--ds-background-accent-purple-bolder, #964AC0)",
    'color.background.accent.purple.bolder.hovered': "var(--ds-background-accent-purple-bolder-hovered, #803FA5)",
    'color.background.accent.purple.bolder.pressed': "var(--ds-background-accent-purple-bolder-pressed, #673286)",
    'color.background.accent.magenta.subtlest': "var(--ds-background-accent-magenta-subtlest, #FFECF8)",
    'color.background.accent.magenta.subtlest.hovered': "var(--ds-background-accent-magenta-subtlest-hovered, #FDD0EC)",
    'color.background.accent.magenta.subtlest.pressed': "var(--ds-background-accent-magenta-subtlest-pressed, #FCB6E1)",
    'color.background.accent.magenta.subtler': "var(--ds-background-accent-magenta-subtler, #FDD0EC)",
    'color.background.accent.magenta.subtler.hovered': "var(--ds-background-accent-magenta-subtler-hovered, #FCB6E1)",
    'color.background.accent.magenta.subtler.pressed': "var(--ds-background-accent-magenta-subtler-pressed, #F797D2)",
    'color.background.accent.magenta.subtle': "var(--ds-background-accent-magenta-subtle, #E774BB)",
    'color.background.accent.magenta.subtle.hovered': "var(--ds-background-accent-magenta-subtle-hovered, #F797D2)",
    'color.background.accent.magenta.subtle.pressed': "var(--ds-background-accent-magenta-subtle-pressed, #FCB6E1)",
    'color.background.accent.magenta.bolder': "var(--ds-background-accent-magenta-bolder, #AE4787)",
    'color.background.accent.magenta.bolder.hovered': "var(--ds-background-accent-magenta-bolder-hovered, #943D73)",
    'color.background.accent.magenta.bolder.pressed': "var(--ds-background-accent-magenta-bolder-pressed, #77325B)",
    'color.background.accent.gray.subtlest': "var(--ds-background-accent-gray-subtlest, #F0F1F2)",
    'color.background.accent.gray.subtlest.hovered': "var(--ds-background-accent-gray-subtlest-hovered, #DDDEE1)",
    'color.background.accent.gray.subtlest.pressed': "var(--ds-background-accent-gray-subtlest-pressed, #B7B9BE)",
    'color.background.accent.gray.subtler': "var(--ds-background-accent-gray-subtler, #DDDEE1)",
    'color.background.accent.gray.subtler.hovered': "var(--ds-background-accent-gray-subtler-hovered, #B7B9BE)",
    'color.background.accent.gray.subtler.pressed': "var(--ds-background-accent-gray-subtler-pressed, #8C8F97)",
    'color.background.accent.gray.subtle': "var(--ds-background-accent-gray-subtle, #8C8F97)",
    'color.background.accent.gray.subtle.hovered': "var(--ds-background-accent-gray-subtle-hovered, #B7B9BE)",
    'color.background.accent.gray.subtle.pressed': "var(--ds-background-accent-gray-subtle-pressed, #DDDEE1)",
    'color.background.accent.gray.bolder': "var(--ds-background-accent-gray-bolder, #6B6E76)",
    'color.background.accent.gray.bolder.hovered': "var(--ds-background-accent-gray-bolder-hovered, #505258)",
    'color.background.accent.gray.bolder.pressed': "var(--ds-background-accent-gray-bolder-pressed, #3B3D42)",
    'color.background.code.added.highlight': "var(--ds-background-code-added-highlight, #DCFFF1)",
    'color.background.code.added.line': "var(--ds-background-code-added-line, #BAF3DB66)",
    'color.background.code.default': "var(--ds-background-code-default, #FFFFFF)",
    'color.background.code.gutter': "var(--ds-background-code-gutter, #F0F1F2)",
    'color.background.code.highlight': "var(--ds-background-code-highlight, #F0F1F2)",
    'color.background.code.removed.highlight': "var(--ds-background-code-removed-highlight, #FFECEB)",
    'color.background.code.removed.line': "var(--ds-background-code-removed-line, #FFD5D266)",
    'color.background.disabled': "var(--ds-background-disabled, #0515240F)",
    'color.background.input': "var(--ds-background-input, #FFFFFF)",
    'color.background.input.hovered': "var(--ds-background-input-hovered, #F8F8F8)",
    'color.background.input.pressed': "var(--ds-background-input-pressed, #FFFFFF)",
    'color.background.inverse.subtle': "var(--ds-background-inverse-subtle, #00000029)",
    'color.background.inverse.subtle.hovered': "var(--ds-background-inverse-subtle-hovered, #0000003D)",
    'color.background.inverse.subtle.pressed': "var(--ds-background-inverse-subtle-pressed, #00000052)",
    'color.background.neutral': "var(--ds-background-neutral, #0515240F)",
    'color.background.neutral.hovered': "var(--ds-background-neutral-hovered, #0B120E24)",
    'color.background.neutral.pressed': "var(--ds-background-neutral-pressed, #080F214A)",
    'color.background.neutral.subtle': "var(--ds-background-neutral-subtle, #00000000)",
    'color.background.neutral.subtle.hovered': "var(--ds-background-neutral-subtle-hovered, #0515240F)",
    'color.background.neutral.subtle.pressed': "var(--ds-background-neutral-subtle-pressed, #0B120E24)",
    'color.background.neutral.bold': "var(--ds-background-neutral-bold, #292A2E)",
    'color.background.neutral.bold.hovered': "var(--ds-background-neutral-bold-hovered, #3B3D42)",
    'color.background.neutral.bold.pressed': "var(--ds-background-neutral-bold-pressed, #505258)",
    'color.background.selected': "var(--ds-background-selected, #E9F2FE)",
    'color.background.selected.hovered': "var(--ds-background-selected-hovered, #CFE1FD)",
    'color.background.selected.pressed': "var(--ds-background-selected-pressed, #8FB8F6)",
    'color.background.selected.bold': "var(--ds-background-selected-bold, #1868DB)",
    'color.background.selected.bold.hovered': "var(--ds-background-selected-bold-hovered, #1558BC)",
    'color.background.selected.bold.pressed': "var(--ds-background-selected-bold-pressed, #123263)",
    'color.background.brand.subtlest': "var(--ds-background-brand-subtlest, #E9F2FE)",
    'color.background.brand.subtlest.hovered': "var(--ds-background-brand-subtlest-hovered, #CFE1FD)",
    'color.background.brand.subtlest.pressed': "var(--ds-background-brand-subtlest-pressed, #ADCBFB)",
    'color.background.brand.bold': "var(--ds-background-brand-bold, #1868DB)",
    'color.background.brand.bold.hovered': "var(--ds-background-brand-bold-hovered, #1558BC)",
    'color.background.brand.bold.pressed': "var(--ds-background-brand-bold-pressed, #144794)",
    'color.background.brand.boldest': "var(--ds-background-brand-boldest, #1C2B42)",
    'color.background.brand.boldest.hovered': "var(--ds-background-brand-boldest-hovered, #123263)",
    'color.background.brand.boldest.pressed': "var(--ds-background-brand-boldest-pressed, #144794)",
    'color.background.danger': "var(--ds-background-danger, #FFECEB)",
    'color.background.danger.hovered': "var(--ds-background-danger-hovered, #FFD5D2)",
    'color.background.danger.pressed': "var(--ds-background-danger-pressed, #FFB8B2)",
    'color.background.danger.subtler': "var(--ds-background-danger-subtler, #FFD5D2)",
    'color.background.danger.subtler.hovered': "var(--ds-background-danger-subtler-hovered, #FFB8B2)",
    'color.background.danger.subtler.pressed': "var(--ds-background-danger-subtler-pressed, #FD9891)",
    'color.background.danger.subtle': "var(--ds-background-danger-subtle, #FD9891)",
    'color.background.danger.bold': "var(--ds-background-danger-bold, #C9372C)",
    'color.background.danger.bold.hovered': "var(--ds-background-danger-bold-hovered, #AE2E24)",
    'color.background.danger.bold.pressed': "var(--ds-background-danger-bold-pressed, #872821)",
    'color.background.warning': "var(--ds-background-warning, #FFF5DB)",
    'color.background.warning.hovered': "var(--ds-background-warning-hovered, #FCE4A6)",
    'color.background.warning.pressed': "var(--ds-background-warning-pressed, #FBD779)",
    'color.background.warning.subtler': "var(--ds-background-warning-subtler, #FCE4A6)",
    'color.background.warning.subtler.hovered': "var(--ds-background-warning-subtler-hovered, #FBD779)",
    'color.background.warning.subtler.pressed': "var(--ds-background-warning-subtler-pressed, #FBC828)",
    'color.background.warning.subtle': "var(--ds-background-warning-subtle, #FBD779)",
    'color.background.warning.bold': "var(--ds-background-warning-bold, #FBC828)",
    'color.background.warning.bold.hovered': "var(--ds-background-warning-bold-hovered, #FCA700)",
    'color.background.warning.bold.pressed': "var(--ds-background-warning-bold-pressed, #F68909)",
    'color.background.success': "var(--ds-background-success, #EFFFD6)",
    'color.background.success.hovered': "var(--ds-background-success-hovered, #D3F1A7)",
    'color.background.success.pressed': "var(--ds-background-success-pressed, #BDE97C)",
    'color.background.success.subtler': "var(--ds-background-success-subtler, #D3F1A7)",
    'color.background.success.subtler.hovered': "var(--ds-background-success-subtler-hovered, #BDE97C)",
    'color.background.success.subtler.pressed': "var(--ds-background-success-subtler-pressed, #B3DF72)",
    'color.background.success.subtle': "var(--ds-background-success-subtle, #B3DF72)",
    'color.background.success.bold': "var(--ds-background-success-bold, #5B7F24)",
    'color.background.success.bold.hovered': "var(--ds-background-success-bold-hovered, #4C6B1F)",
    'color.background.success.bold.pressed': "var(--ds-background-success-bold-pressed, #3F5224)",
    'color.background.discovery': "var(--ds-background-discovery, #F8EEFE)",
    'color.background.discovery.hovered': "var(--ds-background-discovery-hovered, #EED7FC)",
    'color.background.discovery.pressed': "var(--ds-background-discovery-pressed, #E3BDFA)",
    'color.background.discovery.subtler': "var(--ds-background-discovery-subtler, #EED7FC)",
    'color.background.discovery.subtler.hovered': "var(--ds-background-discovery-subtler-hovered, #E3BDFA)",
    'color.background.discovery.subtler.pressed': "var(--ds-background-discovery-subtler-pressed, #D8A0F7)",
    'color.background.discovery.subtle': "var(--ds-background-discovery-subtle, #D8A0F7)",
    'color.background.discovery.bold': "var(--ds-background-discovery-bold, #964AC0)",
    'color.background.discovery.bold.hovered': "var(--ds-background-discovery-bold-hovered, #803FA5)",
    'color.background.discovery.bold.pressed': "var(--ds-background-discovery-bold-pressed, #673286)",
    'color.background.information': "var(--ds-background-information, #E9F2FE)",
    'color.background.information.hovered': "var(--ds-background-information-hovered, #CFE1FD)",
    'color.background.information.pressed': "var(--ds-background-information-pressed, #ADCBFB)",
    'color.background.information.subtler': "var(--ds-background-information-subtler, #CFE1FD)",
    'color.background.information.subtler.hovered': "var(--ds-background-information-subtler-hovered, #ADCBFB)",
    'color.background.information.subtler.pressed': "var(--ds-background-information-subtler-pressed, #8FB8F6)",
    'color.background.information.subtle': "var(--ds-background-information-subtle, #8FB8F6)",
    'color.background.information.bold': "var(--ds-background-information-bold, #1868DB)",
    'color.background.information.bold.hovered': "var(--ds-background-information-bold-hovered, #1558BC)",
    'color.background.information.bold.pressed': "var(--ds-background-information-bold-pressed, #144794)",
    'color.skeleton': "var(--ds-skeleton, #0515240F)",
    'color.skeleton.subtle': "var(--ds-skeleton-subtle, #17171708)",
    'color.blanket': "var(--ds-blanket, #050C1F75)",
    'color.blanket.selected': "var(--ds-blanket-selected, #388BFF14)",
    'color.blanket.danger': "var(--ds-blanket-danger, #EF5C4814)",
    'color.rovo.background.brand.bold': "var(--ds-rovo-background-brand-bold, #000000)",
    'color.rovo.background.brand.bold.hovered': "var(--ds-rovo-background-brand-bold-hovered, #1E1F21)",
    'color.rovo.background.brand.bold.pressed': "var(--ds-rovo-background-brand-bold-pressed, #292A2E)",
    'elevation.surface': "var(--ds-surface, #FFFFFF)",
    'elevation.surface.hovered': "var(--ds-surface-hovered, #F0F1F2)",
    'elevation.surface.pressed': "var(--ds-surface-pressed, #DDDEE1)",
    'elevation.surface.container': "var(--ds-surface-container, #17171708)",
    'elevation.surface.container.hovered': "var(--ds-surface-container-hovered, #0515240F)",
    'elevation.surface.container.pressed': "var(--ds-surface-container-pressed, #0B120E24)",
    'elevation.surface.overlay': "var(--ds-surface-overlay, #FFFFFF)",
    'elevation.surface.overlay.hovered': "var(--ds-surface-overlay-hovered, #F0F1F2)",
    'elevation.surface.overlay.pressed': "var(--ds-surface-overlay-pressed, #DDDEE1)",
    'elevation.surface.raised': "var(--ds-surface-raised, #FFFFFF)",
    'elevation.surface.raised.hovered': "var(--ds-surface-raised-hovered, #F0F1F2)",
    'elevation.surface.raised.pressed': "var(--ds-surface-raised-pressed, #DDDEE1)",
    'elevation.surface.sunken': "var(--ds-surface-sunken, #F8F8F8)",
    'utility.elevation.surface.current': "var(--ds-elevation-surface-current, #FFFFFF)"
};




var $2nBsU = parcelRequire("2nBsU");
var $a130e4cbd69d701d$export$ca0f9c2de39ffed7 = function getSerializedStylesMap(cssProperty, tokenMap) {
    return Object.keys(tokenMap).reduce(function(emotionSpacingMap, tokenName) {
        // eslint-disable-next-line @repo/internal/styles/no-exported-styles
        emotionSpacingMap[tokenName] = (0, $2nBsU.css)((0, $34bcf16a63c65c03$export$2e2bcd8739ae039)({}, cssProperty, tokenMap[tokenName]));
        return emotionSpacingMap;
    }, {});
};


var $05a051e2658b5bb6$export$e7af83bafe7f9e63 = (0, $a130e4cbd69d701d$export$ca0f9c2de39ffed7)('backgroundColor', (0, $c425c5c09600f673$export$d1d79bf68ac056bd));


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c2243347101d0284063f83cb3084a0b4>>
 * @codegenCommand yarn workspace @atlaskit/primitives codegen-styles
 * @codegenDependency ../../../tokens/src/artifacts/tokens-raw/atlassian-light.tsx <<SignedSource::4e25079e2363933fae45ad0f1e9c123b>>
 */ var $7b6436300861faac$export$1531ad5bb3fbedac = {
    'color.border': "var(--ds-border, #0B120E24)",
    'color.border.accent.lime': "var(--ds-border-accent-lime, #6A9A23)",
    'color.border.accent.lime.subtle': "var(--ds-border-accent-lime-subtle, #B3DF72)",
    'color.border.accent.red': "var(--ds-border-accent-red, #E2483D)",
    'color.border.accent.red.subtle': "var(--ds-border-accent-red-subtle, #FD9891)",
    'color.border.accent.orange': "var(--ds-border-accent-orange, #E06C00)",
    'color.border.accent.orange.subtle': "var(--ds-border-accent-orange-subtle, #FBC828)",
    'color.border.accent.yellow': "var(--ds-border-accent-yellow, #B38600)",
    'color.border.accent.yellow.subtle': "var(--ds-border-accent-yellow-subtle, #EED12B)",
    'color.border.accent.green': "var(--ds-border-accent-green, #22A06B)",
    'color.border.accent.green.subtle': "var(--ds-border-accent-green-subtle, #7EE2B8)",
    'color.border.accent.teal': "var(--ds-border-accent-teal, #2898BD)",
    'color.border.accent.teal.subtle': "var(--ds-border-accent-teal-subtle, #9DD9EE)",
    'color.border.accent.blue': "var(--ds-border-accent-blue, #357DE8)",
    'color.border.accent.blue.subtle': "var(--ds-border-accent-blue-subtle, #8FB8F6)",
    'color.border.accent.purple': "var(--ds-border-accent-purple, #AF59E1)",
    'color.border.accent.purple.subtle': "var(--ds-border-accent-purple-subtle, #D8A0F7)",
    'color.border.accent.magenta': "var(--ds-border-accent-magenta, #CD519D)",
    'color.border.accent.magenta.subtle': "var(--ds-border-accent-magenta-subtle, #F797D2)",
    'color.border.accent.gray': "var(--ds-border-accent-gray, #7D818A)",
    'color.border.accent.gray.subtle': "var(--ds-border-accent-gray-subtle, #B7B9BE)",
    'color.border.code': "var(--ds-border-code, #0B120E24)",
    'color.border.disabled': "var(--ds-border-disabled, #0515240F)",
    'color.border.focused': "var(--ds-border-focused, #4688EC)",
    'color.border.input': "var(--ds-border-input, #8C8F97)",
    'color.border.inverse': "var(--ds-border-inverse, #FFFFFF)",
    'color.border.selected': "var(--ds-border-selected, #1868DB)",
    'color.border.brand': "var(--ds-border-brand, #1868DB)",
    'color.border.danger': "var(--ds-border-danger, #E2483D)",
    'color.border.danger.subtle': "var(--ds-border-danger-subtle, #FD9891)",
    'color.border.warning': "var(--ds-border-warning, #E06C00)",
    'color.border.warning.subtle': "var(--ds-border-warning-subtle, #FBC828)",
    'color.border.success': "var(--ds-border-success, #6A9A23)",
    'color.border.success.subtle': "var(--ds-border-success-subtle, #B3DF72)",
    'color.border.discovery': "var(--ds-border-discovery, #AF59E1)",
    'color.border.discovery.subtle': "var(--ds-border-discovery-subtle, #D8A0F7)",
    'color.border.information': "var(--ds-border-information, #357DE8)",
    'color.border.information.subtle': "var(--ds-border-information-subtle, #8FB8F6)",
    'color.border.bold': "var(--ds-border-bold, #7D818A)"
};


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2ee12747fee6f7445e430f52ee1f7b86>>
 * @codegenCommand yarn workspace @atlaskit/primitives codegen-styles
 * @codegenDependency ../../../tokens/src/artifacts/tokens-raw/atlassian-shape.tsx <<SignedSource::8817f4073995e5dc9c2bb766316632d6>>
 */ var $9bb1e651f759e89e$export$e1b83c5210c471b8 = {
    'border.width': "var(--ds-border-width, 1px)",
    'border.width.selected': "var(--ds-border-width-selected, 2px)",
    'border.width.focused': "var(--ds-border-width-focused, 2px)"
};


// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $1a04f8c48c2b3302$var$spacingProperties = [
    'padding',
    'paddingBlock',
    'paddingBlockStart',
    'paddingBlockEnd',
    'paddingInline',
    'paddingInlineStart',
    'paddingInlineEnd',
    'gap',
    'rowGap',
    'columnGap'
];
var $1a04f8c48c2b3302$export$f2bee1f59203ac70 = function createSpacingStylesMap(tokenMap) {
    return $1a04f8c48c2b3302$var$spacingProperties.reduce(function(styleMap, spacingProperty) {
        styleMap[spacingProperty] = (0, $a130e4cbd69d701d$export$ca0f9c2de39ffed7)(spacingProperty, tokenMap);
        return styleMap;
    }, {});
};


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::40ae4d14447bdc898f255059f8589afd>>
 * @codegenCommand yarn workspace @atlaskit/primitives codegen-styles
 * @codegenDependency ../../../tokens/src/artifacts/tokens-raw/atlassian-spacing.tsx <<SignedSource::535518e7add48ef24f526d0904f70060>>
 */ var $4fef4cc9c5e4dab9$export$958d0ae7f2977ae4 = {
    'space.0': "var(--ds-space-0, 0px)",
    'space.025': "var(--ds-space-025, 2px)",
    'space.050': "var(--ds-space-050, 4px)",
    'space.075': "var(--ds-space-075, 6px)",
    'space.100': "var(--ds-space-100, 8px)",
    'space.150': "var(--ds-space-150, 12px)",
    'space.200': "var(--ds-space-200, 16px)",
    'space.250': "var(--ds-space-250, 20px)",
    'space.300': "var(--ds-space-300, 24px)",
    'space.400': "var(--ds-space-400, 32px)",
    'space.500': "var(--ds-space-500, 40px)",
    'space.600': "var(--ds-space-600, 48px)",
    'space.800': "var(--ds-space-800, 64px)",
    'space.1000': "var(--ds-space-1000, 80px)"
};


var $16a3bb4eca7030ac$export$e615f061ca585a6c = (0, $1a04f8c48c2b3302$export$f2bee1f59203ac70)((0, $4fef4cc9c5e4dab9$export$958d0ae7f2977ae4));



var $388e5da345529e23$export$43e479c916cb4ada = Symbol('UNSAFE_INTERNAL_styles');


function $8faeb3898dc423fa$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $8faeb3898dc423fa$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $8faeb3898dc423fa$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $8faeb3898dc423fa$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $8faeb3898dc423fa$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $8faeb3898dc423fa$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
/**
 * Picks out runtime XCSS objects and build-time XCSS strings. This is needed
 * to supported both Emotion and Compiled styles until we've fully migrated
 * to Compiled.
 *
 * @private
 * @deprecated
 */ // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
var $8faeb3898dc423fa$export$a9c84988c8f81f2d = function parseXcss(args) {
    if (Array.isArray(args)) {
        var emotion = [];
        var staticArr = [];
        var _iterator = $8faeb3898dc423fa$var$_createForOfIteratorHelper(args), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var arg = _step.value;
                var result = $8faeb3898dc423fa$export$a9c84988c8f81f2d(arg);
                if (result.emotion) emotion.push.apply(emotion, (0, $b64eb05e0a458fd9$export$2e2bcd8739ae039)(result.emotion));
                if (result.static) staticArr.push(result.static);
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
        return {
            emotion: emotion,
            static: staticArr.join(' ')
        };
    }
    var objArgs = args;
    var _ref = objArgs || {}, styles = _ref[0, $388e5da345529e23$export$43e479c916cb4ada];
    if (styles) return {
        emotion: [
            styles
        ]
    };
    if (args) {
        // We use string interpolation here instead of .toString() just
        // in case the resulting object doesn't have the method available.
        var stringifiedArgs = "".concat(args);
        if (stringifiedArgs) return {
            static: stringifiedArgs
        };
    }
    return {};
};



var $5ddb53aa2f521636$var$_excluded = [
    "children",
    "backgroundColor",
    "padding",
    "paddingBlock",
    "paddingBlockStart",
    "paddingBlockEnd",
    "paddingInline",
    "paddingInlineStart",
    "paddingInlineEnd",
    "isDisabled",
    "type",
    "onClick",
    "interactionName",
    "componentName",
    "analyticsContext",
    "style",
    "testId",
    "xcss"
], $5ddb53aa2f521636$var$_excluded2 = [
    "className"
];
// This duplicates FocusRing styles from `@atlaskit/focus-ring`.
var $5ddb53aa2f521636$var$focusRingStyles = (0, $2nBsU.css)({
    '&:focus, &:focus-visible': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        outlineColor: (0, $7b6436300861faac$export$1531ad5bb3fbedac)['color.border.focused'],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        outlineOffset: (0, $4fef4cc9c5e4dab9$export$958d0ae7f2977ae4)['space.025'],
        outlineStyle: 'solid',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        outlineWidth: (0, $9bb1e651f759e89e$export$e1b83c5210c471b8)['border.width.focused']
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
    '&:focus:not(:focus-visible)': {
        outline: 'none'
    },
    '@media screen and (forced-colors: active), screen and (-ms-high-contrast: active)': {
        '&:focus-visible': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
            outline: "".concat((0, $9bb1e651f759e89e$export$e1b83c5210c471b8)['border.width'], " solid")
        }
    }
});
var $5ddb53aa2f521636$var$baseStyles = (0, $2nBsU.css)({
    boxSizing: 'border-box',
    appearance: 'none',
    border: 'none'
});
var $5ddb53aa2f521636$var$enabledStyles = (0, $2nBsU.css)({
    cursor: 'pointer'
});
var $5ddb53aa2f521636$var$disabledStyles = (0, $2nBsU.css)({
    cursor: 'not-allowed'
});
/**
 * __Pressable__
 *
 * A primitive for building custom buttons.
 *
 * - [Examples](https://atlassian.design/components/primitives/pressable/examples)
 * - [Code](https://atlassian.design/components/primitives/pressable/code)
 * - [Usage](https://atlassian.design/components/primitives/pressable/usage)
 */ var $5ddb53aa2f521636$var$Pressable = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function(_ref, ref) {
    var children = _ref.children, backgroundColor = _ref.backgroundColor, padding = _ref.padding, paddingBlock = _ref.paddingBlock, paddingBlockStart = _ref.paddingBlockStart, paddingBlockEnd = _ref.paddingBlockEnd, paddingInline = _ref.paddingInline, paddingInlineStart = _ref.paddingInlineStart, paddingInlineEnd = _ref.paddingInlineEnd, isDisabled = _ref.isDisabled, _ref$type = _ref.type, type = _ref$type === void 0 ? 'button' : _ref$type, _ref$onClick = _ref.onClick, providedOnClick = _ref$onClick === void 0 ? (0, $adcefb868cf2fc9d$export$2e2bcd8739ae039) : _ref$onClick, interactionName = _ref.interactionName, componentName = _ref.componentName, analyticsContext = _ref.analyticsContext, style = _ref.style, testId = _ref.testId, xcss = _ref.xcss, htmlAttributes = (0, $f2ca64756a447eb8$export$2e2bcd8739ae039)(_ref, $5ddb53aa2f521636$var$_excluded);
    var interactionContext = (0, $5FkrB.useContext)((0, $a81fd7e45a8c2ef5$export$2e2bcd8739ae039));
    var handleClick = (0, $5FkrB.useCallback)(function(e, analyticsEvent) {
        interactionContext && interactionContext.tracePress(interactionName, e.timeStamp);
        providedOnClick(e, analyticsEvent);
    }, [
        providedOnClick,
        interactionContext,
        interactionName
    ]);
    var onClick = (0, $0a7767b2db2f25f5$export$a4687b0234b40e28)({
        fn: handleClick,
        action: 'clicked',
        componentName: componentName || 'Pressable',
        packageName: "@atlaskit/primitives",
        packageVersion: "22.1.1",
        analyticsData: analyticsContext,
        actionSubject: 'button'
    });
    // This is to remove className from safeHtmlAttributes
    // @ts-expect-error className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    var _spreadClass = htmlAttributes.className, safeHtmlAttributes = (0, $f2ca64756a447eb8$export$2e2bcd8739ae039)(htmlAttributes, $5ddb53aa2f521636$var$_excluded2);
    var resolvedStyles = (0, $8faeb3898dc423fa$export$a9c84988c8f81f2d)(xcss);
    return (0, $2nBsU.jsx)("button", (0, $4d49c99afafded0a$export$2e2bcd8739ae039)({
        style: style,
        ref: ref,
        className: resolvedStyles.static
    }, safeHtmlAttributes, {
        // eslint-disable-next-line react/button-has-type
        type: type,
        onClick: onClick,
        disabled: isDisabled,
        css: [
            $5ddb53aa2f521636$var$baseStyles,
            $5ddb53aa2f521636$var$focusRingStyles,
            isDisabled ? $5ddb53aa2f521636$var$disabledStyles : $5ddb53aa2f521636$var$enabledStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            backgroundColor && (0, $05a051e2658b5bb6$export$e7af83bafe7f9e63)[backgroundColor],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            padding && (0, $16a3bb4eca7030ac$export$e615f061ca585a6c).padding[padding],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlock && (0, $16a3bb4eca7030ac$export$e615f061ca585a6c).paddingBlock[paddingBlock],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlockStart && (0, $16a3bb4eca7030ac$export$e615f061ca585a6c).paddingBlockStart[paddingBlockStart],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlockEnd && (0, $16a3bb4eca7030ac$export$e615f061ca585a6c).paddingBlockEnd[paddingBlockEnd],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInline && (0, $16a3bb4eca7030ac$export$e615f061ca585a6c).paddingInline[paddingInline],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInlineStart && (0, $16a3bb4eca7030ac$export$e615f061ca585a6c).paddingInlineStart[paddingInlineStart],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInlineEnd && (0, $16a3bb4eca7030ac$export$e615f061ca585a6c).paddingInlineEnd[paddingInlineEnd]
        ].concat((0, $b64eb05e0a458fd9$export$2e2bcd8739ae039)(resolvedStyles.emotion || [])),
        "data-testid": testId
    }), children);
});
var $5ddb53aa2f521636$export$2e2bcd8739ae039 = $5ddb53aa2f521636$var$Pressable;


/* spinner.tsx generated by @compiled/babel-plugin v0.39.1 */ /**
 * This length includes the underscore,
 * e.g. `"_1s4A"` would be a valid atomic group hash.
 */ const $808b7dc07a04c9f2$var$ATOMIC_GROUP_LENGTH = 5;
function $808b7dc07a04c9f2$export$2e2bcd8739ae039(classNames) {
    // Shortcut: nothing to do
    if (!classNames.length) return;
    // Shortcut: don't need to do anything if we only have a single classname
    if (classNames.length === 1 && classNames[0] && // checking to see if `classNames[0]` is a string that contains other classnames
    !classNames[0].includes(' ')) return classNames[0];
    // Using an object rather than a `Map` as it performed better in our benchmarks.
    // Would be happy to move to `Map` if it proved to be better under real conditions.
    const map = {};
    // Note: using loops to minimize iterations over the collection
    for (const value of classNames){
        // Exclude all falsy values, which leaves us with populated strings
        if (!value) continue;
        // a `value` can contain multiple classnames
        const list = value.split(' ');
        for (const className of list){
            /**
             * For atomic style classnames: the `key` is the `group`
             *
             * - Later atomic classnames with the same `group` will override earlier ones
             *   (which is what we want).
             * - Assumes atomic classnames are the only things that start with `_`
             * - Could use a regex to ensure that atomic classnames are structured how we expect,
             *   but did not add that for now as it did slow things down a bit.
             *
             * For other classnames: the `key` is the whole classname
             * - Okay to remove duplicates as doing so does not impact specificity
             *
             * */ const key = className.startsWith('_') ? className.slice(0, $808b7dc07a04c9f2$var$ATOMIC_GROUP_LENGTH) : className;
            map[key] = className;
        }
    }
    /**
     * We are converting the `map` into a string.
     *
     * The simple way to do this would be `Object.values(map).join(' ')`.
     * However, the approach below performs 10%-20% better in benchmarks.
     *
     * For `ax()` it feels right to squeeze as much runtime performance out as we can.
     */ let result = '';
    for(const key in map)result += map[key] + ' ';
    // If we have an empty string, then our `map` was empty.
    if (!result) return;
    // remove last " " from the result (we added " " at the end of every value)
    return result.trimEnd();
}



var $5FkrB = parcelRequire("5FkrB");

var $4ae33ddd337f5582$export$4e9f1640bbe7a1a8 = {
    xsmall: 12,
    small: 16,
    medium: 24,
    large: 48,
    xlarge: 96
};


/**
 * Returns the appropriate circle stroke color.
 */ function $8be4a5516f741779$var$getStrokeColor(appearance) {
    return appearance === 'inherit' ? "var(--ds-icon-subtle, #505258)" : "var(--ds-icon-inverse, #FFFFFF)";
}
var $8be4a5516f741779$var$rotate = null;
/**
 * There are three parts to the load in animation:
 * 1. Accelerated spin
 * 2. Stretch the spinner line
 */ var $8be4a5516f741779$var$loadIn = null;
var $8be4a5516f741779$var$styles = {
    rotateStyles: "_j7hqsf8s _5sag12kz _tip812c5 _1pgl2qsq _8hrz1h6o",
    loadInStyles: "_j7hq1ky6 _5sag9cwz _1pgl1ytf _1o51q7pw",
    wrapperStyles: "_1e0c116y _s7n4nkob",
    circleStyles: "_lswuglyw _7ljx1dhp _1snbbs82 _jcxd7g3v _1tjm1onz"
};
/**
 * `useLayoutEffect` is being used in SSR safe form. On the server, this work doesn’t need to run.
 * `useEffect` is used in-place, because `useEffect` is not run on the server and it matches types
 * which makes things simpler than doing an `isServer` check or a `null` check.
 *
 * @see https://hello.atlassian.net/wiki/spaces/DST/pages/2081696628/DSTDACI-010+-+Interaction+Tracing+hooks+in+DS+components
 */ var $8be4a5516f741779$var$useLayoutEffect = typeof window === 'undefined' ? (0, $5FkrB.useEffect) : (0, $5FkrB.useLayoutEffect);
/**
 * __Spinner__
 *
 * A spinner is an animated spinning icon that lets users know content is being loaded.
 *
 * - [Examples](https://atlassian.design/components/spinner/examples)
 * - [Code](https://atlassian.design/components/spinner/code)
 * - [Usage](https://atlassian.design/components/spinner/usage)
 */ var $8be4a5516f741779$var$Spinner = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).forwardRef(function Spinner(_ref, ref) {
    var _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'inherit' : _ref$appearance, _ref$delay = _ref.delay, delay = _ref$delay === void 0 ? 0 : _ref$delay, interactionName = _ref.interactionName, label = _ref.label, _ref$size = _ref.size, providedSize = _ref$size === void 0 ? 'medium' : _ref$size, testId = _ref.testId;
    var size = typeof providedSize === 'number' ? providedSize : (0, $4ae33ddd337f5582$export$4e9f1640bbe7a1a8)[providedSize];
    var animationDelay = "".concat(delay, "ms");
    var stroke = $8be4a5516f741779$var$getStrokeColor(appearance);
    var context = (0, $5FkrB.useContext)((0, $a81fd7e45a8c2ef5$export$2e2bcd8739ae039));
    $8be4a5516f741779$var$useLayoutEffect(function() {
        if (context != null) return context.hold(interactionName);
    }, [
        context,
        interactionName
    ]);
    /**
   * The Spinner animation uses a combination of two
   * css animations on two separate elements.
   */ return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("span", {
        "data-testid": testId ? "".concat(testId, "-wrapper") : 'spinner-wrapper',
        style: {
            animationDelay: animationDelay,
            width: size,
            height: size
        },
        className: (0, $808b7dc07a04c9f2$export$2e2bcd8739ae039)([
            $8be4a5516f741779$var$styles.wrapperStyles,
            $8be4a5516f741779$var$styles.rotateStyles
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("svg", {
        height: size,
        width: size,
        viewBox: "0 0 16 16",
        xmlns: "http://www.w3.org/2000/svg",
        "data-testid": testId,
        ref: ref,
        "aria-label": label || undefined,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            animationDelay: animationDelay
        },
        role: label ? 'img' : 'none',
        className: (0, $808b7dc07a04c9f2$export$2e2bcd8739ae039)([
            $8be4a5516f741779$var$styles.loadInStyles
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("circle", {
        cx: "8",
        cy: "8",
        r: "7",
        style: {
            stroke: stroke
        },
        className: (0, $808b7dc07a04c9f2$export$2e2bcd8739ae039)([
            $8be4a5516f741779$var$styles.circleStyles
        ])
    })));
}));
var $8be4a5516f741779$export$2e2bcd8739ae039 = $8be4a5516f741779$var$Spinner;


// extract the category and key from the resolved color
var $f847525eb2d7032d$export$a3fc04b8551e006a = function getThemeStyles(resolvedColor) {
    var isAccent = resolvedColor.startsWith('accent-');
    var category = isAccent ? 'accent' : 'semantic';
    var key = isAccent ? resolvedColor.replace('accent-', '') : resolvedColor;
    return {
        category: category,
        key: key
    };
};


/* icon-renderer.tsx generated by @compiled/babel-plugin v2.0.0 */ 

var $5FkrB = parcelRequire("5FkrB");

/* box.tsx generated by @compiled/babel-plugin v0.40.0 */ 


var $5FkrB = parcelRequire("5FkrB");

var $jzAQA = parcelRequire("jzAQA");

var $4308eb16285ed11e$var$_excluded = [
    "as",
    "children",
    "backgroundColor",
    "padding",
    "paddingBlock",
    "paddingBlockStart",
    "paddingBlockEnd",
    "paddingInline",
    "paddingInlineStart",
    "paddingInlineEnd",
    "style",
    "testId",
    "xcss"
], $4308eb16285ed11e$var$_excluded2 = [
    "className"
];
// Can either Exclude or Extract - here we're excluding all SVG-related elements, <button> elements (handled by Pressable), and <a> elements (handled by Anchor)
// Basically just ElementType but without ComponentType, it makes sense to keep the "Type" suffix
// eslint-disable-next-line @repo/internal/react/consistent-types-definitions
var $4308eb16285ed11e$var$baseStyles = null;
var $4308eb16285ed11e$var$backgroundColorMap = {
    'color.background.accent.lime.subtlest': "_bfhkm890",
    'color.background.accent.lime.subtlest.hovered': "_bfhkd4y8",
    'color.background.accent.lime.subtlest.pressed': "_bfhkkuup",
    'color.background.accent.lime.subtler': "_bfhkz2ec",
    'color.background.accent.lime.subtler.hovered': "_bfhk1gf0",
    'color.background.accent.lime.subtler.pressed': "_bfhk2kxc",
    'color.background.accent.lime.subtle': "_bfhkbq5w",
    'color.background.accent.lime.subtle.hovered': "_bfhkfoww",
    'color.background.accent.lime.subtle.pressed': "_bfhk1jbd",
    'color.background.accent.lime.bolder': "_bfhktde4",
    'color.background.accent.lime.bolder.hovered': "_bfhknzpa",
    'color.background.accent.lime.bolder.pressed': "_bfhkh0j0",
    'color.background.accent.red.subtlest': "_bfhk1vk5",
    'color.background.accent.red.subtlest.hovered': "_bfhk1i6i",
    'color.background.accent.red.subtlest.pressed': "_bfhknbir",
    'color.background.accent.red.subtler': "_bfhk1rtt",
    'color.background.accent.red.subtler.hovered': "_bfhkaffd",
    'color.background.accent.red.subtler.pressed': "_bfhk1j5a",
    'color.background.accent.red.subtle': "_bfhkkrt9",
    'color.background.accent.red.subtle.hovered': "_bfhk1sou",
    'color.background.accent.red.subtle.pressed': "_bfhk1fnn",
    'color.background.accent.red.bolder': "_bfhkuibq",
    'color.background.accent.red.bolder.hovered': "_bfhk100f",
    'color.background.accent.red.bolder.pressed': "_bfhk1cl6",
    'color.background.accent.orange.subtlest': "_bfhkf5uh",
    'color.background.accent.orange.subtlest.hovered': "_bfhk19yr",
    'color.background.accent.orange.subtlest.pressed': "_bfhkf90x",
    'color.background.accent.orange.subtler': "_bfhk165s",
    'color.background.accent.orange.subtler.hovered': "_bfhk1ei0",
    'color.background.accent.orange.subtler.pressed': "_bfhkdpo3",
    'color.background.accent.orange.subtle': "_bfhk1kkj",
    'color.background.accent.orange.subtle.hovered': "_bfhk9mfs",
    'color.background.accent.orange.subtle.pressed': "_bfhkaxpp",
    'color.background.accent.orange.bolder': "_bfhk1qg1",
    'color.background.accent.orange.bolder.hovered': "_bfhk12qo",
    'color.background.accent.orange.bolder.pressed': "_bfhk1fyq",
    'color.background.accent.yellow.subtlest': "_bfhkibhp",
    'color.background.accent.yellow.subtlest.hovered': "_bfhkaetg",
    'color.background.accent.yellow.subtlest.pressed': "_bfhk1o1l",
    'color.background.accent.yellow.subtler': "_bfhk1773",
    'color.background.accent.yellow.subtler.hovered': "_bfhk1uw7",
    'color.background.accent.yellow.subtler.pressed': "_bfhk1r9w",
    'color.background.accent.yellow.subtle': "_bfhk8y3s",
    'color.background.accent.yellow.subtle.hovered': "_bfhk819w",
    'color.background.accent.yellow.subtle.pressed': "_bfhk1jx0",
    'color.background.accent.yellow.bolder': "_bfhk1vop",
    'color.background.accent.yellow.bolder.hovered': "_bfhkkjqf",
    'color.background.accent.yellow.bolder.pressed': "_bfhk1okt",
    'color.background.accent.green.subtlest': "_bfhkn729",
    'color.background.accent.green.subtlest.hovered': "_bfhk3utz",
    'color.background.accent.green.subtlest.pressed': "_bfhkyfny",
    'color.background.accent.green.subtler': "_bfhk1wnw",
    'color.background.accent.green.subtler.hovered': "_bfhk1e2h",
    'color.background.accent.green.subtler.pressed': "_bfhkybhx",
    'color.background.accent.green.subtle': "_bfhk1rsu",
    'color.background.accent.green.subtle.hovered': "_bfhk12e3",
    'color.background.accent.green.subtle.pressed': "_bfhk1g86",
    'color.background.accent.green.bolder': "_bfhk1e5c",
    'color.background.accent.green.bolder.hovered': "_bfhka5yi",
    'color.background.accent.green.bolder.pressed': "_bfhk1j68",
    'color.background.accent.teal.subtlest': "_bfhk7xuz",
    'color.background.accent.teal.subtlest.hovered': "_bfhk108c",
    'color.background.accent.teal.subtlest.pressed': "_bfhk1cxp",
    'color.background.accent.teal.subtler': "_bfhk1a17",
    'color.background.accent.teal.subtler.hovered': "_bfhkkwwr",
    'color.background.accent.teal.subtler.pressed': "_bfhk1jb0",
    'color.background.accent.teal.subtle': "_bfhktdv8",
    'color.background.accent.teal.subtle.hovered': "_bfhkzh8h",
    'color.background.accent.teal.subtle.pressed': "_bfhk16zl",
    'color.background.accent.teal.bolder': "_bfhk2c8p",
    'color.background.accent.teal.bolder.hovered': "_bfhkl3ve",
    'color.background.accent.teal.bolder.pressed': "_bfhktor0",
    'color.background.accent.blue.subtlest': "_bfhk1s93",
    'color.background.accent.blue.subtlest.hovered': "_bfhkdaj9",
    'color.background.accent.blue.subtlest.pressed': "_bfhkxm0g",
    'color.background.accent.blue.subtler': "_bfhk1dy8",
    'color.background.accent.blue.subtler.hovered': "_bfhk815t",
    'color.background.accent.blue.subtler.pressed': "_bfhkrwxf",
    'color.background.accent.blue.subtle': "_bfhk115i",
    'color.background.accent.blue.subtle.hovered': "_bfhk9pr4",
    'color.background.accent.blue.subtle.pressed': "_bfhknpx7",
    'color.background.accent.blue.bolder': "_bfhk16e3",
    'color.background.accent.blue.bolder.hovered': "_bfhk1vbm",
    'color.background.accent.blue.bolder.pressed': "_bfhk1xwi",
    'color.background.accent.purple.subtlest': "_bfhkp2ly",
    'color.background.accent.purple.subtlest.hovered': "_bfhkkca2",
    'color.background.accent.purple.subtlest.pressed': "_bfhk1jbm",
    'color.background.accent.purple.subtler': "_bfhk1nm4",
    'color.background.accent.purple.subtler.hovered': "_bfhkattl",
    'color.background.accent.purple.subtler.pressed': "_bfhk3nfk",
    'color.background.accent.purple.subtle': "_bfhk18ah",
    'color.background.accent.purple.subtle.hovered': "_bfhk8bp1",
    'color.background.accent.purple.subtle.pressed': "_bfhk1cd2",
    'color.background.accent.purple.bolder': "_bfhkya33",
    'color.background.accent.purple.bolder.hovered': "_bfhk1af5",
    'color.background.accent.purple.bolder.pressed': "_bfhk6cze",
    'color.background.accent.magenta.subtlest': "_bfhk8tvm",
    'color.background.accent.magenta.subtlest.hovered': "_bfhkr3zd",
    'color.background.accent.magenta.subtlest.pressed': "_bfhk1ckf",
    'color.background.accent.magenta.subtler': "_bfhkv9ra",
    'color.background.accent.magenta.subtler.hovered': "_bfhk1axx",
    'color.background.accent.magenta.subtler.pressed': "_bfhk42ri",
    'color.background.accent.magenta.subtle': "_bfhk1mi6",
    'color.background.accent.magenta.subtle.hovered': "_bfhkrwyz",
    'color.background.accent.magenta.subtle.pressed': "_bfhk6c15",
    'color.background.accent.magenta.bolder': "_bfhkc3uk",
    'color.background.accent.magenta.bolder.hovered': "_bfhk1ok8",
    'color.background.accent.magenta.bolder.pressed': "_bfhkeawv",
    'color.background.accent.gray.subtlest': "_bfhkysee",
    'color.background.accent.gray.subtlest.hovered': "_bfhkwejn",
    'color.background.accent.gray.subtlest.pressed': "_bfhk18ut",
    'color.background.accent.gray.subtler': "_bfhk7qp0",
    'color.background.accent.gray.subtler.hovered': "_bfhk10ef",
    'color.background.accent.gray.subtler.pressed': "_bfhk1rk9",
    'color.background.accent.gray.subtle': "_bfhk18j9",
    'color.background.accent.gray.subtle.hovered': "_bfhk1nv3",
    'color.background.accent.gray.subtle.pressed': "_bfhkq9tj",
    'color.background.accent.gray.bolder': "_bfhk1i45",
    'color.background.accent.gray.bolder.hovered': "_bfhkbyip",
    'color.background.accent.gray.bolder.pressed': "_bfhk1van",
    'color.background.disabled': "_bfhk187o",
    'color.background.input': "_bfhk1j9a",
    'color.background.input.hovered': "_bfhkl4ek",
    'color.background.input.pressed': "_bfhkr01l",
    'color.background.inverse.subtle': "_bfhk1vck",
    'color.background.inverse.subtle.hovered': "_bfhkmpja",
    'color.background.inverse.subtle.pressed': "_bfhk1gii",
    'color.background.neutral': "_bfhki8nm",
    'color.background.neutral.hovered': "_bfhkplhp",
    'color.background.neutral.pressed': "_bfhk1gdz",
    'color.background.neutral.subtle': "_bfhksm61",
    'color.background.neutral.subtle.hovered': "_bfhk1dpa",
    'color.background.neutral.subtle.pressed': "_bfhkfcek",
    'color.background.neutral.bold': "_bfhk1aqn",
    'color.background.neutral.bold.hovered': "_bfhk1ibz",
    'color.background.neutral.bold.pressed': "_bfhkof27",
    'color.background.selected': "_bfhk15s3",
    'color.background.selected.hovered': "_bfhkufnl",
    'color.background.selected.pressed': "_bfhknozp",
    'color.background.selected.bold': "_bfhkjmqp",
    'color.background.selected.bold.hovered': "_bfhk1q28",
    'color.background.selected.bold.pressed': "_bfhk12kk",
    'color.background.brand.subtlest': "_bfhk1gmr",
    'color.background.brand.subtlest.hovered': "_bfhk3v15",
    'color.background.brand.subtlest.pressed': "_bfhku02c",
    'color.background.brand.bold': "_bfhk1856",
    'color.background.brand.bold.hovered': "_bfhkhf2y",
    'color.background.brand.bold.pressed': "_bfhkg6ey",
    'color.background.brand.boldest': "_bfhk1o4i",
    'color.background.brand.boldest.hovered': "_bfhklefx",
    'color.background.brand.boldest.pressed': "_bfhk16k6",
    'color.background.danger': "_bfhk1gly",
    'color.background.danger.hovered': "_bfhk1yvi",
    'color.background.danger.pressed': "_bfhk1r4b",
    'color.background.danger.bold': "_bfhkybec",
    'color.background.danger.bold.hovered': "_bfhks9hg",
    'color.background.danger.bold.pressed': "_bfhk13a9",
    'color.background.warning': "_bfhk1917",
    'color.background.warning.hovered': "_bfhk19zu",
    'color.background.warning.pressed': "_bfhkzr32",
    'color.background.warning.bold': "_bfhk1kmu",
    'color.background.warning.bold.hovered': "_bfhk1spp",
    'color.background.warning.bold.pressed': "_bfhk4m4m",
    'color.background.success': "_bfhk1y9u",
    'color.background.success.hovered': "_bfhk1vfx",
    'color.background.success.pressed': "_bfhk1wl5",
    'color.background.success.bold': "_bfhkkcmj",
    'color.background.success.bold.hovered': "_bfhky7x8",
    'color.background.success.bold.pressed': "_bfhkwcbh",
    'color.background.discovery': "_bfhk6vm6",
    'color.background.discovery.hovered': "_bfhk12eq",
    'color.background.discovery.pressed': "_bfhk18vq",
    'color.background.discovery.bold': "_bfhku5tj",
    'color.background.discovery.bold.hovered': "_bfhkfqeg",
    'color.background.discovery.bold.pressed': "_bfhk1f1m",
    'color.background.information': "_bfhk19ip",
    'color.background.information.hovered': "_bfhk86z5",
    'color.background.information.pressed': "_bfhk1c1j",
    'color.background.information.bold': "_bfhkx4w0",
    'color.background.information.bold.hovered': "_bfhkq2ii",
    'color.background.information.bold.pressed': "_bfhkf89v",
    'color.blanket': "_bfhk1i5c",
    'color.blanket.selected': "_bfhk7wq0",
    'color.blanket.danger': "_bfhkrprw",
    'color.skeleton': "_bfhkizff",
    'color.skeleton.subtle': "_bfhkvkf5",
    'elevation.surface': "_bfhkvuon",
    'elevation.surface.hovered': "_bfhk19i6",
    'elevation.surface.pressed': "_bfhk13ro",
    'elevation.surface.overlay': "_bfhk1bhr",
    'elevation.surface.overlay.hovered': "_bfhk6o2t",
    'elevation.surface.overlay.pressed': "_bfhkm8nx",
    'elevation.surface.raised': "_bfhkhp5a",
    'elevation.surface.raised.hovered': "_bfhk116u",
    'elevation.surface.raised.pressed': "_bfhk14aj",
    'elevation.surface.sunken': "_bfhkhfxm",
    'utility.elevation.surface.current': "_bfhkchd4"
};
var $4308eb16285ed11e$var$CURRENT_SURFACE_CSS_VAR = "--ds-elevation-surface-current";
var $4308eb16285ed11e$var$setSurfaceTokenMap = {
    'elevation.surface': "_1q1lvuon",
    'elevation.surface.hovered': "_1q1l19i6",
    'elevation.surface.pressed': "_1q1l13ro",
    'elevation.surface.overlay': "_1q1l1bhr",
    'elevation.surface.overlay.hovered': "_1q1l6o2t",
    'elevation.surface.overlay.pressed': "_1q1lm8nx",
    'elevation.surface.raised': "_1q1lhp5a",
    'elevation.surface.raised.hovered': "_1q1l116u",
    'elevation.surface.raised.pressed': "_1q1l14aj",
    'elevation.surface.sunken': "_1q1lhfxm"
};
var $4308eb16285ed11e$var$paddingBlockStartMap = {
    'space.0': "_1q51ze3t",
    'space.025': "_1q51v77o",
    'space.050': "_1q511b66",
    'space.075': "_1q5112x7",
    'space.100': "_1q51u2gc",
    'space.150': "_1q51utpp",
    'space.200': "_1q51pxbi",
    'space.250': "_1q51v47k",
    'space.300': "_1q511ejb",
    'space.400': "_1q51xy5q",
    'space.500': "_1q511jfw",
    'space.600': "_1q51oahv",
    'space.800': "_1q51xncg",
    'space.1000': "_1q511epz"
};
var $4308eb16285ed11e$var$paddingBlockEndMap = {
    'space.0': "_85i5ze3t",
    'space.025': "_85i5v77o",
    'space.050': "_85i51b66",
    'space.075': "_85i512x7",
    'space.100': "_85i5u2gc",
    'space.150': "_85i5utpp",
    'space.200': "_85i5pxbi",
    'space.250': "_85i5v47k",
    'space.300': "_85i51ejb",
    'space.400': "_85i5xy5q",
    'space.500': "_85i51jfw",
    'space.600': "_85i5oahv",
    'space.800': "_85i5xncg",
    'space.1000': "_85i51epz"
};
var $4308eb16285ed11e$var$paddingInlineStartMap = {
    'space.0': "_bozgze3t",
    'space.025': "_bozgv77o",
    'space.050': "_bozg1b66",
    'space.075': "_bozg12x7",
    'space.100': "_bozgu2gc",
    'space.150': "_bozgutpp",
    'space.200': "_bozgpxbi",
    'space.250': "_bozgv47k",
    'space.300': "_bozg1ejb",
    'space.400': "_bozgxy5q",
    'space.500': "_bozg1jfw",
    'space.600': "_bozgoahv",
    'space.800': "_bozgxncg",
    'space.1000': "_bozg1epz"
};
var $4308eb16285ed11e$var$paddingInlineEndMap = {
    'space.0': "_y4tize3t",
    'space.025': "_y4tiv77o",
    'space.050': "_y4ti1b66",
    'space.075': "_y4ti12x7",
    'space.100': "_y4tiu2gc",
    'space.150': "_y4tiutpp",
    'space.200': "_y4tipxbi",
    'space.250': "_y4tiv47k",
    'space.300': "_y4ti1ejb",
    'space.400': "_y4tixy5q",
    'space.500': "_y4ti1jfw",
    'space.600': "_y4tioahv",
    'space.800': "_y4tixncg",
    'space.1000': "_y4ti1epz"
};
var $4308eb16285ed11e$export$e71c4d32a2263218 = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? 'div' : _ref$as, children = _ref.children, backgroundColor = _ref.backgroundColor, padding = _ref.padding, _ref$paddingBlock = _ref.paddingBlock, paddingBlock = _ref$paddingBlock === void 0 ? padding : _ref$paddingBlock, _ref$paddingBlockStar = _ref.paddingBlockStart, paddingBlockStart = _ref$paddingBlockStar === void 0 ? paddingBlock : _ref$paddingBlockStar, _ref$paddingBlockEnd = _ref.paddingBlockEnd, paddingBlockEnd = _ref$paddingBlockEnd === void 0 ? paddingBlock : _ref$paddingBlockEnd, _ref$paddingInline = _ref.paddingInline, paddingInline = _ref$paddingInline === void 0 ? padding : _ref$paddingInline, _ref$paddingInlineSta = _ref.paddingInlineStart, paddingInlineStart = _ref$paddingInlineSta === void 0 ? paddingInline : _ref$paddingInlineSta, _ref$paddingInlineEnd = _ref.paddingInlineEnd, paddingInlineEnd = _ref$paddingInlineEnd === void 0 ? paddingInline : _ref$paddingInlineEnd, style = _ref.style, testId = _ref.testId, xcss = _ref.xcss, htmlAttributes = (0, $f2ca64756a447eb8$export$2e2bcd8739ae039)(_ref, $4308eb16285ed11e$var$_excluded);
    // This is to remove className from safeHtmlAttributes
    // @ts-ignore -- not using expect since it causes issues with help-center local consumption - className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    var _spreadClass = htmlAttributes.className, safeHtmlAttributes = (0, $f2ca64756a447eb8$export$2e2bcd8739ae039)(htmlAttributes, $4308eb16285ed11e$var$_excluded2);
    var node = /*#__PURE__*/ $5FkrB.createElement(Component, (0, $4d49c99afafded0a$export$2e2bcd8739ae039)({
        style: style,
        ref: ref,
        className: (0, $jzAQA.default)([
            "_19itglyw _vchhusvi _r06hglyw",
            backgroundColor && $4308eb16285ed11e$var$backgroundColorMap[backgroundColor],
            backgroundColor && $4308eb16285ed11e$var$isSurfaceToken(backgroundColor) && $4308eb16285ed11e$var$setSurfaceTokenMap[backgroundColor],
            paddingBlockStart && $4308eb16285ed11e$var$paddingBlockStartMap[paddingBlockStart],
            paddingBlockEnd && $4308eb16285ed11e$var$paddingBlockEndMap[paddingBlockEnd],
            paddingInlineStart && $4308eb16285ed11e$var$paddingInlineStartMap[paddingInlineStart],
            paddingInlineEnd && $4308eb16285ed11e$var$paddingInlineEndMap[paddingInlineEnd],
            xcss
        ])
    }, safeHtmlAttributes, {
        "data-testid": testId
    }), children);
    if (backgroundColor) return /*#__PURE__*/ $5FkrB.createElement((0, $d5af69dc5a3797ce$export$1ca2a26fecb070ae).Provider, {
        value: backgroundColor
    }, node);
    return node;
});
function $4308eb16285ed11e$var$isSurfaceToken(backgroundColor) {
    return backgroundColor in $4308eb16285ed11e$var$setSurfaceTokenMap;
}


// Map lozenge colors to appropriate icon colors.
//
// We intentionally use `color.text.*.bolder` tokens for icons across all
// colored lozenges (semantic + accent). Text tokens use higher-stop palette
// values (Color700+) which pass 3:1 contrast against subtler backgrounds in
// every interactive state — including pressed where icon Color600 fails for
// most hues. Using text tokens uniformly:
//   - avoids global changes to the `color.icon.*` token ramps
//   - keeps icon and text visually aligned in the lozenge
//   - guarantees ≥3:1 contrast across default/hover/pressed states
//
// Neutral lozenges use `color.text.subtle` to match the neutral text styling
// and remain consistent with their alpha-based backgrounds.
var $3e431e88adee9cc3$var$getIconColor = function getIconColor(color) {
    switch(color){
        // Semantic
        case 'success':
            return "var(--ds-text-success, #4C6B1F)";
        case 'warning':
            return "var(--ds-text-warning, #9E4C00)";
        case 'danger':
            return "var(--ds-text-danger, #AE2E24)";
        case 'information':
            return "var(--ds-text-information, #1558BC)";
        case 'discovery':
            return "var(--ds-text-discovery, #803FA5)";
        case 'neutral':
            return "var(--ds-text-subtle, #505258)";
        // Accent
        case 'accent-red':
            return "var(--ds-text-accent-red, #AE2E24)";
        case 'accent-orange':
            return "var(--ds-text-accent-orange, #9E4C00)";
        case 'accent-yellow':
            return "var(--ds-text-accent-yellow, #7F5F01)";
        case 'accent-lime':
            return "var(--ds-text-accent-lime, #4C6B1F)";
        case 'accent-green':
            return "var(--ds-text-accent-green, #216E4E)";
        case 'accent-teal':
            return "var(--ds-text-accent-teal, #206A83)";
        case 'accent-blue':
            return "var(--ds-text-accent-blue, #1558BC)";
        case 'accent-purple':
            return "var(--ds-text-accent-purple, #803FA5)";
        case 'accent-magenta':
            return "var(--ds-text-accent-magenta, #943D73)";
        case 'accent-gray':
            return "var(--ds-text-subtle, #505258)";
        default:
            return "var(--ds-text-subtle, #505258)";
    }
};
var $3e431e88adee9cc3$var$styles = {
    motion: "_k8m01ylx _1oeci9qs _6fl41d08"
};
/**
 * Icon renderer for lozenge components
 * Handles proper sizing and color theming for icons
 */ var $3e431e88adee9cc3$var$IconRenderer = function IconRenderer(_ref) {
    var Icon = _ref.icon, color = _ref.color, testId = _ref.testId, size = _ref.size;
    var iconColor = $3e431e88adee9cc3$var$getIconColor(color);
    return (0, $92e43753483f870e$export$b40ec24ac8275656)('platform-dst-motion-uplift') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $4308eb16285ed11e$export$e71c4d32a2263218), {
        xcss: $3e431e88adee9cc3$var$styles.motion,
        style: {
            color: iconColor
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(Icon, {
        label: "",
        size: size,
        testId: testId
    })) : /*#__PURE__*/ // Cast required because the lozenge intentionally uses some
    // `color.text.*.bolder` tokens for icons that don't pass 3:1 contrast
    // at their default `color.icon.*` stop. The Icon component types only
    // accept `IconColor`, but text tokens are valid CSS color values and
    // render correctly at runtime.
    (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(Icon, {
        color: iconColor,
        label: "",
        size: size,
        testId: testId
    });
};
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$3e431e88adee9cc3$export$2e2bcd8739ae039 = $3e431e88adee9cc3$var$IconRenderer;


// Map legacy appearance to new color values
var $9322400e5d578b4d$var$legacyAppearanceMap = {
    default: 'neutral',
    removed: 'danger',
    inprogress: 'information',
    new: 'discovery',
    moved: 'warning'
};
var $9322400e5d578b4d$export$acf5d2b7dc999bda = function resolveLozengeColor() {
    var _legacyAppearanceMap$;
    var appearance = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'neutral';
    if (appearance.startsWith('accent-')) return appearance;
    return (_legacyAppearanceMap$ = $9322400e5d578b4d$var$legacyAppearanceMap[appearance]) !== null && _legacyAppearanceMap$ !== void 0 ? _legacyAppearanceMap$ : appearance;
};


function $3096763f14d07b64$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $3096763f14d07b64$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $3096763f14d07b64$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $34bcf16a63c65c03$export$2e2bcd8739ae039)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $3096763f14d07b64$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
// Get the pressed background color for the selected lozenge dropdown trigger
var $3096763f14d07b64$var$pressedBackgroundMapping = {
    success: "var(--ds-background-success-subtler-pressed, #B3DF72)",
    warning: "var(--ds-background-warning-subtler-pressed, #FBC828)",
    danger: "var(--ds-background-danger-subtler-pressed, #FD9891)",
    information: "var(--ds-background-information-subtler-pressed, #8FB8F6)",
    neutral: "var(--ds-background-neutral-pressed, #080F214A)",
    discovery: "var(--ds-background-discovery-subtler-pressed, #D8A0F7)",
    'accent-red': "var(--ds-background-accent-red-subtler-pressed, #FD9891)",
    'accent-orange': "var(--ds-background-accent-orange-subtler-pressed, #FBC828)",
    'accent-yellow': "var(--ds-background-accent-yellow-subtler-pressed, #EED12B)",
    'accent-lime': "var(--ds-background-accent-lime-subtler-pressed, #B3DF72)",
    'accent-green': "var(--ds-background-accent-green-subtler-pressed, #7EE2B8)",
    'accent-teal': "var(--ds-background-accent-teal-subtler-pressed, #9DD9EE)",
    'accent-blue': "var(--ds-background-accent-blue-subtler-pressed, #8FB8F6)",
    'accent-purple': "var(--ds-background-accent-purple-subtler-pressed, #D8A0F7)",
    'accent-magenta': "var(--ds-background-accent-magenta-subtler-pressed, #F797D2)",
    'accent-gray': "var(--ds-background-accent-gray-subtlest-pressed, #B7B9BE)"
};
var $3096763f14d07b64$var$styles = {
    container: "_2rko12b0 _1reo15vq _18m915vq _189ee4h9 _1dqonqa1 _1h6d1j28 _kqswh2mm _1e0c116y _4cvr1h6o _vchhusvi _4t3i1k92 _1q51v77o _85i5v77o _bozg1b66 _y4ti1b66",
    motionContainer: "_k8m01rje _1oeci9qs _6fl41d08",
    containerSpacious: "_2rko1qi0 _1tkeviql _1q511b66 _85i51b66 _bozgutpp _y4tiutpp",
    containerBadgePadding: "_y4ti303w",
    text: "_11c8wadc _1reo15vq _18m915vq _o5721q9c",
    textEllipsis: "_1bto1l2s",
    textClip: "_1btozryt",
    textSpacious: "_11c8fhey _k48p1wq8",
    textSelected: "_syaz6x5g",
    loadingOverlay: "_1reo15vq _18m915vq _1e0c1txw _kqswstnw _4cvr1h6o _1bah1h6o _u7coze3t _152tze3t _rjxpze3t _1e02ze3t _lcxvglyw",
    metricBadgeWrapper: "_1e0c1txw",
    'semantic.success': "_3wu02gvx _bfhk14j0 _syaz1p1e",
    'semantic.warning': "_3wu01wfx _bfhk10f4 _syazmgs1",
    'semantic.danger': "_3wu01mzp _bfhk18wg _syaz1blx",
    'semantic.information': "_3wu0wn4u _bfhk8lbg _syaz1qd9",
    'semantic.neutral': "_3wu01l7x _bfhki8nm _syazi7uo",
    'semantic.discovery': "_3wu019v3 _bfhke670 _syaz1g72",
    'accent.red': "_3wu0n9dc _bfhk1rtt _syazhwvp",
    'accent.orange': "_3wu01ip5 _bfhk165s _syaz7i1p",
    'accent.yellow': "_3wu01s7j _bfhk1773 _syazekll",
    'accent.lime': "_3wu01m7d _bfhkz2ec _syaz1ik3",
    'accent.green': "_3wu05d2u _bfhk1wnw _syaz1y78",
    'accent.teal': "_3wu0131p _bfhk1a17 _syaz12v7",
    'accent.blue': "_3wu018hp _bfhk1dy8 _syaz1kyx",
    'accent.purple': "_3wu0luwt _bfhk1nm4 _syaz1mn1",
    'accent.magenta': "_3wu0132u _bfhkv9ra _syaz1qur",
    'accent.gray': "_3wu01l7x _bfhkysee _syaz1tmo",
    'interactive.semantic.success': "_irr31r82 _1di6d6jc",
    'interactive.semantic.warning': "_irr31yx4 _1di6bkku",
    'interactive.semantic.danger': "_irr370oi _1di6jkmi",
    'interactive.semantic.information': "_irr315aw _1di6ar1y",
    'interactive.semantic.neutral': "_irr3plhp _1di61gdz",
    'interactive.semantic.discovery': "_irr3rumk _1di65usi",
    'interactive.accent.red': "_irr3affd _1di61j5a",
    'interactive.accent.orange': "_irr31ei0 _1di6dpo3",
    'interactive.accent.yellow': "_irr31uw7 _1di61r9w",
    'interactive.accent.lime': "_irr31gf0 _1di62kxc",
    'interactive.accent.green': "_irr31e2h _1di6ybhx",
    'interactive.accent.teal': "_irr3kwwr _1di61jb0",
    'interactive.accent.blue': "_irr3815t _1di6rwxf",
    'interactive.accent.purple': "_irr3attl _1di63nfk",
    'interactive.accent.magenta': "_irr31axx _1di642ri",
    'interactive.accent.gray': "_irr3wejn _1di618ut",
    iconBorderFilter: "_1h6d74of",
    content: "_zulp1b66 _1e0c116y _4cvr1h6o",
    maxWidth: "_p12f1osq",
    contentSpacious: "_zulp12x7",
    loadingContent: "_tzy4idpf",
    containerBadgePressed: "_1axmtoke _17i7toke",
    containerBadgeNeutralAppearance: "_1ftrnkaw _1axmnkaw _17i7nkaw"
};
/**
 * __New Lozenge__
 *
 * A lozenge is a visual indicator used to highlight an item's status for quick recognition.
 * This is the updated version with the new North Star visual language.
 */ var $3096763f14d07b64$var$LozengeBase = /*#__PURE__*/ (0, $5FkrB.memo)(/*#__PURE__*/ (0, $5FkrB.forwardRef)(function(_ref, ref) {
    var children = _ref.children, testId = _ref.testId, appearance = _ref.appearance, iconBefore = _ref.iconBefore, trailingMetric = _ref.trailingMetric, trailingMetricAppearance = _ref.trailingMetricAppearance, _ref$maxWidth = _ref.maxWidth, maxWidth = _ref$maxWidth === void 0 ? 200 : _ref$maxWidth, _ref$spacing = _ref.spacing, spacing = _ref$spacing === void 0 ? 'default' : _ref$spacing, isSelected = _ref.isSelected, _ref$isLoading = _ref.isLoading, isLoading = _ref$isLoading === void 0 ? false : _ref$isLoading, onClick = _ref.onClick, style = _ref.style, analyticsContext = _ref.analyticsContext, interactionName = _ref.interactionName, ariaControls = _ref['aria-controls'], ariaExpanded = _ref['aria-expanded'], ariaHaspopup = _ref['aria-haspopup'], ariaLabel = _ref['aria-label'];
    var _useState = (0, $5FkrB.useState)(false), _useState2 = (0, $1dc579c4de1142c2$export$2e2bcd8739ae039)(_useState, 2), resizing = _useState2[0], setResizing = _useState2[1];
    var onFinishMotion = function onFinishMotion() {
        return setResizing(false);
    };
    var resizingWidth = (0, $83120f7eb9e62313$export$a300664a1a230956)({
        dimension: 'width',
        duration: "var(--ds-duration-medium, 200ms)",
        easing: "var(--ds-easing-inout-bold, cubic-bezier(0.4, 0, 0, 1))",
        onFinishMotion: onFinishMotion
    });
    var isInitialRender = (0, $5FkrB.useRef)(true);
    var isInteractive = typeof onClick === 'function';
    // Determine the effective color, with fallback logic for legacy appearances
    var resolvedColor = (0, $9322400e5d578b4d$export$acf5d2b7dc999bda)(appearance) || 'neutral';
    var _getThemeStyles = (0, $f847525eb2d7032d$export$a3fc04b8551e006a)(resolvedColor), category = _getThemeStyles.category, key = _getThemeStyles.key;
    var colorStyleKey = "".concat(category, ".").concat(key);
    var interactiveStyleKey = "interactive.".concat(category, ".").concat(key);
    var maxWidthValue = typeof maxWidth === 'string' ? maxWidth : "".concat(maxWidth, "px");
    var maxWidthIsPc = typeof maxWidth === 'string' && maxWidth.endsWith('%');
    var resolvedTrailingMetricAppearance = trailingMetricAppearance ? trailingMetricAppearance === 'inverse' ? 'inverse' : (0, $9322400e5d578b4d$export$acf5d2b7dc999bda)(trailingMetricAppearance) : resolvedColor;
    // Map the resolved trailing metric appearance to a Badge appearance.
    // Semantic colors map to their new bold variants (e.g. successBold),
    // which provide sufficient color emphasis on top of the subtler
    // lozenge background. Accent colors and unknown values fall back to
    // the neutral appearance.
    var metricBadgeAppearance = function() {
        if (resolvedTrailingMetricAppearance === 'inverse') return 'inverse';
        if (resolvedTrailingMetricAppearance == null) return 'neutral';
        if (resolvedTrailingMetricAppearance.startsWith('accent-')) return 'neutral';
        switch(resolvedTrailingMetricAppearance){
            case 'success':
                return 'successBold';
            case 'warning':
                return 'warningBold';
            case 'danger':
                return 'dangerBold';
            case 'information':
                return 'informationBold';
            case 'discovery':
                return 'discoveryBold';
            case 'neutral':
            default:
                return 'neutral';
        }
    }();
    var commonStyleOverrides = {
        backgroundColor: style === null || style === void 0 ? void 0 : style.backgroundColor,
        // Constrain the container to the smaller of the explicit maxWidth and 100% of
        // the parent. Using min(...) means the lozenge never overflows its parent,
        // while still honouring the explicit maxWidth prop when the parent is wider.
        maxWidth: maxWidthIsPc ? maxWidth : "min(".concat(maxWidthValue, ", 100%)")
    };
    var hasTrailingMetric = trailingMetric != null && trailingMetric !== '';
    var childrenKey = typeof children === 'string' ? children : undefined;
    (0, $5FkrB.useLayoutEffect)(function() {
        // Ignore initial render
        if (isInitialRender.current) {
            isInitialRender.current = false;
            return;
        }
        setResizing(true);
    }, [
        childrenKey
    ]);
    var enableMotionFG = (0, $92e43753483f870e$export$b40ec24ac8275656)('platform-dst-motion-uplift');
    var innerContent = /*#__PURE__*/ $5FkrB.createElement("span", (0, $4d49c99afafded0a$export$2e2bcd8739ae039)({}, enableMotionFG ? resizingWidth : undefined, {
        className: (0, $jzAQA.default)([
            $3096763f14d07b64$var$styles.content,
            spacing === 'spacious' && $3096763f14d07b64$var$styles.contentSpacious,
            isLoading && $3096763f14d07b64$var$styles.loadingContent,
            // Constrain the content wrapper to its container so text truncation
            // works correctly within the flex layout, regardless of whether maxWidth
            // is a percentage, fixed value, or the parent container is narrower than
            // the explicit maxWidth.
            $3096763f14d07b64$var$styles.maxWidth
        ])
    }), iconBefore && /*#__PURE__*/ $5FkrB.createElement((0, $3e431e88adee9cc3$export$2e2bcd8739ae039), {
        size: spacing === 'spacious' ? 'medium' : 'small',
        icon: iconBefore,
        color: resolvedColor,
        testId: testId && "".concat(testId, "--icon")
    }), /*#__PURE__*/ $5FkrB.createElement("span", {
        style: {
            // The text fills 100% of the inner content wrapper. The container's
            // own max-width (set on the container via commonStyleOverrides) handles
            // the actual size constraint, so the text just needs to fill the available
            // space and truncate when it overflows.
            maxWidth: maxWidthIsPc ? '100%' : "calc(".concat(maxWidthValue, " - ", "var(--ds-space-100, 8px)", ")"),
            color: style === null || style === void 0 ? void 0 : style.color
        },
        "data-testid": testId && "".concat(testId, "--text"),
        className: (0, $jzAQA.default)([
            $3096763f14d07b64$var$styles.text,
            enableMotionFG && resizing && !maxWidth ? $3096763f14d07b64$var$styles.textClip : $3096763f14d07b64$var$styles.textEllipsis,
            spacing === 'spacious' && $3096763f14d07b64$var$styles.textSpacious
        ])
    }, children), hasTrailingMetric && !resolvedColor.startsWith('accent-') && /*#__PURE__*/ $5FkrB.createElement("span", {
        "data-lozenge-metric-wrapper": true,
        "data-testid": testId && "".concat(testId, "--metric"),
        className: (0, $jzAQA.default)([
            $3096763f14d07b64$var$styles.metricBadgeWrapper
        ])
    }, /*#__PURE__*/ $5FkrB.createElement((0, $0833cc217cf36684$export$2e2bcd8739ae039), {
        appearance: metricBadgeAppearance
    }, trailingMetric)), isInteractive && /*#__PURE__*/ $5FkrB.createElement((0, (/*@__PURE__*/$parcel$interopDefault($b465753bb15ee4c1$exports))), {
        label: "",
        size: "small",
        color: 'currentColor',
        testId: testId && "".concat(testId, "--chevron")
    }));
    if (isInteractive) return /*#__PURE__*/ $5FkrB.createElement((0, $5ddb53aa2f521636$export$2e2bcd8739ae039), (0, $4d49c99afafded0a$export$2e2bcd8739ae039)({
        ref: ref,
        xcss: (0, $1845bee1a1da9181$export$a274e22fb40f762e)($3096763f14d07b64$var$styles.container, (0, $92e43753483f870e$export$b40ec24ac8275656)('platform-dst-motion-uplift') && $3096763f14d07b64$var$styles.motionContainer, spacing === 'spacious' && $3096763f14d07b64$var$styles.containerSpacious, !isSelected && $3096763f14d07b64$var$styles.iconBorderFilter, $3096763f14d07b64$var$styles[colorStyleKey], !isLoading && $3096763f14d07b64$var$styles[interactiveStyleKey], hasTrailingMetric && $3096763f14d07b64$var$styles.containerBadgePressed, hasTrailingMetric && resolvedTrailingMetricAppearance === 'neutral' && $3096763f14d07b64$var$styles.containerBadgeNeutralAppearance)
    }, isLoading && {
        'aria-busy': true,
        'aria-disabled': true,
        isDisabled: true
    }, {
        "aria-label": isLoading ? 'Loading' : ariaLabel,
        "aria-controls": ariaControls,
        "aria-expanded": ariaExpanded,
        "aria-haspopup": ariaHaspopup,
        onClick: isLoading ? undefined : onClick,
        style: $3096763f14d07b64$var$_objectSpread($3096763f14d07b64$var$_objectSpread({}, commonStyleOverrides), {}, {
            // Specified because Pressable has a default border:none which overrides the border specified on the container
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            border: "solid ".concat("var(--ds-border-width, 1px)", " ", isSelected ? 'var(--border-color) !important' : 'transparent'),
            backgroundColor: isSelected ? $3096763f14d07b64$var$pressedBackgroundMapping[resolvedColor] : undefined,
            cursor: isLoading ? 'progress' : 'pointer'
        }),
        testId: testId,
        analyticsContext: analyticsContext,
        interactionName: interactionName,
        componentName: "LozengeDropdownTrigger"
    }, isSelected && {
        'data-selected': 'true'
    }), innerContent, isLoading && /*#__PURE__*/ $5FkrB.createElement("span", {
        className: (0, $jzAQA.default)([
            $3096763f14d07b64$var$styles.loadingOverlay
        ])
    }, /*#__PURE__*/ $5FkrB.createElement((0, $8be4a5516f741779$export$2e2bcd8739ae039), {
        size: spacing === 'spacious' ? 'small' : 'xsmall',
        label: ", Loading",
        testId: testId ? "".concat(testId, "--loading-spinner") : undefined
    })));
    return /*#__PURE__*/ $5FkrB.createElement("span", {
        ref: ref,
        style: commonStyleOverrides,
        "data-testid": testId,
        className: (0, $jzAQA.default)([
            $3096763f14d07b64$var$styles.container,
            spacing === 'spacious' && $3096763f14d07b64$var$styles.containerSpacious,
            spacing !== 'spacious' && hasTrailingMetric && $3096763f14d07b64$var$styles.containerBadgePadding,
            $3096763f14d07b64$var$styles[colorStyleKey],
            $3096763f14d07b64$var$styles.iconBorderFilter,
            hasTrailingMetric && resolvedTrailingMetricAppearance === 'neutral' && $3096763f14d07b64$var$styles.containerBadgeNeutralAppearance
        ])
    }, innerContent);
}));
var $3096763f14d07b64$export$2e2bcd8739ae039 = $3096763f14d07b64$var$LozengeBase;


/**
 * __Lozenge__
 *
 * A lozenge is a visual indicator used to highlight an item's status for quick recognition.
 *
 * - [Examples](https://atlassian.design/components/lozenge/examples)
 * - [Code](https://atlassian.design/components/lozenge/code)
 * - [Usage](https://atlassian.design/components/lozenge/usage)
 */ var $0b790190769ec95b$var$Lozenge = function Lozenge(_ref) {
    var _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'neutral' : _ref$appearance, _ref$spacing = _ref.spacing, spacing = _ref$spacing === void 0 ? 'default' : _ref$spacing, _ref$maxWidth = _ref.maxWidth, maxWidth = _ref$maxWidth === void 0 ? 200 : _ref$maxWidth, style = _ref.style, testId = _ref.testId, children = _ref.children, iconBefore = _ref.iconBefore, trailingMetric = _ref.trailingMetric, trailingMetricAppearance = _ref.trailingMetricAppearance;
    var baseProps = {
        appearance: appearance,
        spacing: spacing,
        iconBefore: iconBefore,
        trailingMetric: trailingMetric,
        trailingMetricAppearance: trailingMetricAppearance,
        maxWidth: maxWidth,
        style: style,
        testId: testId,
        children: children
    };
    return /*#__PURE__*/ $5FkrB.createElement((0, $3096763f14d07b64$export$2e2bcd8739ae039), baseProps, children);
};
$0b790190769ec95b$var$Lozenge.displayName = 'Lozenge';
var $0b790190769ec95b$export$2e2bcd8739ae039 = $0b790190769ec95b$var$Lozenge;


/**
 * TODO: We should be using our bounded `cssMap` here, but most of
 * these styles from the visual refresh are not in the Design System.
 */ var $9bc31c28cfd17976$var$styles = {
    container: "_2rkofajl _1reo15vq _18m915vq _1e0c116y _vchhusvi _kqswpfqs _1kz6184x _bozg1b66 _y4ti1b66",
    containerSubtle: "_1cwg1n1a",
    text: "_1reo15vq _18m915vq _ect4ttxp _1wyb1skh _zg8l4jg8 _k48pwu06 _vwz47vkz _1bto1l2s _1p1dangw _o5721q9c",
    customLetterspacing: "_1dyz9vsi",
    'bg.bold.default': "_bfhk1fkg",
    'bg.bold.inprogress': "_bfhk1ymo",
    'bg.bold.moved': "_bfhkxmjf",
    'bg.bold.new': "_bfhkshej",
    'bg.bold.removed': "_bfhk1366",
    'bg.bold.success': "_bfhk3uhp",
    'bg.subtle.default': "_bfhksm61",
    'bg.subtle.inprogress': "_bfhksm61",
    'bg.subtle.moved': "_bfhksm61",
    'bg.subtle.new': "_bfhksm61",
    'bg.subtle.removed': "_bfhksm61",
    'bg.subtle.success': "_bfhksm61",
    'outline.subtle.default': "_12ji14je _1qu2nqa1 _12y3t94y",
    'outline.subtle.inprogress': "_12jiuisw _1qu2nqa1 _12y3t94y",
    'outline.subtle.moved': "_12jih727 _1qu2nqa1 _12y3t94y",
    'outline.subtle.new': "_12ji157s _1qu2nqa1 _12y3t94y",
    'outline.subtle.removed': "_12jia2c0 _1qu2nqa1 _12y3t94y",
    'outline.subtle.success': "_12jin0nx _1qu2nqa1 _12y3t94y",
    'text.subtle': "_syazi7uo",
    'text.bold': "_syazwwip"
};
var $9bc31c28cfd17976$var$appearanceTypes = [
    'default',
    'inprogress',
    'moved',
    'new',
    'removed'
];
var $9bc31c28cfd17976$var$newSemanticColors = [
    'success',
    'discovery',
    'warning',
    'danger',
    'information',
    'neutral'
];
var $9bc31c28cfd17976$var$appearanceMapping = {
    neutral: 'default',
    default: 'default',
    information: 'inprogress',
    inprogress: 'inprogress',
    warning: 'moved',
    moved: 'moved',
    removed: 'removed',
    danger: 'removed',
    success: 'success',
    discovery: 'new',
    new: 'new'
};
/**
 * __Lozenge__
 *
 * A lozenge is a visual indicator used to highlight an item's status for quick recognition.
 *
 * - [Examples](https://atlassian.design/components/lozenge/examples)
 * - [Code](https://atlassian.design/components/lozenge/code)
 * - [Usage](https://atlassian.design/components/lozenge/usage)
 */ var $9bc31c28cfd17976$var$LegacyLozenge = /*#__PURE__*/ (0, $5FkrB.memo)(function(_ref) {
    var children = _ref.children, testId = _ref.testId, _ref$isBold = _ref.isBold, isBold = _ref$isBold === void 0 ? false : _ref$isBold, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'default' : _ref$appearance, _ref$maxWidth = _ref.maxWidth, maxWidth = _ref$maxWidth === void 0 ? 200 : _ref$maxWidth, style = _ref.style;
    var appearanceStyle = isBold ? 'bold' : 'subtle';
    var appearanceType = (0, $5FkrB.useMemo)(function() {
        return $9bc31c28cfd17976$var$appearanceTypes.includes(appearance) || $9bc31c28cfd17976$var$newSemanticColors.includes(appearance) ? $9bc31c28cfd17976$var$appearanceMapping[appearance] : 'default';
    }, [
        appearance
    ]);
    var maxWidthValue = typeof maxWidth === 'string' ? maxWidth : "".concat(maxWidth, "px");
    var maxWidthIsPc = typeof maxWidth === 'string' && /%$/.test(maxWidth);
    return /*#__PURE__*/ $5FkrB.createElement("span", {
        style: {
            backgroundColor: style === null || style === void 0 ? void 0 : style.backgroundColor,
            maxWidth: maxWidthIsPc ? maxWidth : '100%'
        },
        "data-testid": testId,
        className: (0, $jzAQA.default)([
            $9bc31c28cfd17976$var$styles.container,
            $9bc31c28cfd17976$var$styles["bg.".concat(appearanceStyle, ".").concat(appearanceType)],
            appearanceStyle === 'subtle' && $9bc31c28cfd17976$var$styles["outline.subtle.".concat(appearanceType)],
            appearanceStyle === 'subtle' && $9bc31c28cfd17976$var$styles.containerSubtle
        ])
    }, /*#__PURE__*/ $5FkrB.createElement("span", {
        style: {
            color: style === null || style === void 0 ? void 0 : style.color,
            // to negate paddingInline specified on Box above
            maxWidth: maxWidthIsPc ? '100%' : "calc(".concat(maxWidthValue, " - ", "var(--ds-space-100, 8px)", ")")
        },
        "data-testid": testId && "".concat(testId, "--text"),
        className: (0, $jzAQA.default)([
            $9bc31c28cfd17976$var$styles.text,
            (0, $92e43753483f870e$export$b40ec24ac8275656)('platform-lozenge-custom-letterspacing') && $9bc31c28cfd17976$var$styles.customLetterspacing,
            $9bc31c28cfd17976$var$styles["text.".concat(appearanceStyle)]
        ])
    }, children));
});
$9bc31c28cfd17976$var$LegacyLozenge.displayName = 'Lozenge';
/**
 * Wrapper component that switches between old and new Lozenge based on feature flag
 */ var $9bc31c28cfd17976$var$LozengeWrapper = /*#__PURE__*/ (0, $5FkrB.memo)(function(props) {
    if ((0, $92e43753483f870e$export$b40ec24ac8275656)('platform-dst-lozenge-tag-badge-visual-uplifts')) return /*#__PURE__*/ $5FkrB.createElement((0, $0b790190769ec95b$export$2e2bcd8739ae039), props);
    return /*#__PURE__*/ $5FkrB.createElement($9bc31c28cfd17976$var$LegacyLozenge, props);
});
$9bc31c28cfd17976$var$LozengeWrapper.displayName = 'Lozenge';
var $9bc31c28cfd17976$export$2e2bcd8739ae039 = $9bc31c28cfd17976$var$LozengeWrapper;




var $5FkrB = parcelRequire("5FkrB");

/**
 * Internally we will be playing with an element that will always have a key defined.
 */ /**
 * Internal data passed to child motions.
 */ // We define empty context here so the object doesn't change.
var $cf7e1a3a3ae7d555$var$emptyContext = {
    // Motions will always appear if not inside a exiting persistence component.
    appear: true,
    isExiting: false
};
/**
 * __Exiting context__
 *
 * An exiting context.
 */ var $cf7e1a3a3ae7d555$var$ExitingContext = /*#__PURE__*/ (0, $5FkrB.createContext)($cf7e1a3a3ae7d555$var$emptyContext);
/**
 * This method will wrap any React element with a context provider. We're using context (instead of
 * cloneElement) so we can communicate between multiple elements without the need of prop drilling
 * (results in a better API for consumers).
 */ var $cf7e1a3a3ae7d555$var$wrapChildWithContextProvider = function wrapChildWithContextProvider(child) {
    var value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $cf7e1a3a3ae7d555$var$emptyContext;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement($cf7e1a3a3ae7d555$var$ExitingContext.Provider, {
        key: "".concat(child.key, "-provider"),
        value: value
    }, child);
};
/**
 * This function will convert all children types to an array while also filtering out non-valid React elements.
 */ var $cf7e1a3a3ae7d555$var$childrenToArray = function childrenToArray(children) {
    var childrenAsArray = [];
    // We convert children to an array using this helper method as it will add keys to children that do not
    // have them, such as when we have hardcoded children that are conditionally rendered.
    (0, $5FkrB.Children).toArray(children).forEach(function(child) {
        // We ignore any boolean children to make our code a little more simple later on,
        // and also filter out any falsies (empty strings, nulls, and undefined).
        if (typeof child !== 'boolean' && Boolean(child)) // Children WILL have a key after being forced into an array using the React.Children helper.
        childrenAsArray.push(child);
    });
    return childrenAsArray;
};
var $cf7e1a3a3ae7d555$var$spliceNewElementsIntoPrevious = function spliceNewElementsIntoPrevious(current, previous) {
    var splicedChildren = previous.concat([]);
    var previousMap = $cf7e1a3a3ae7d555$var$childrenToObj(previous);
    for(var i = 0; i < current.length; i++){
        var child = current[i];
        var childIsNew = !previousMap[child.key];
        if (childIsNew) // This will insert the new element after the previous element.
        splicedChildren.splice(i + 1, 0, child);
    }
    return splicedChildren;
};
var $cf7e1a3a3ae7d555$var$childrenToObj = function childrenToObj(children) {
    return children.reduce(function(acc, child) {
        acc[child.key] = child;
        return acc;
    }, {});
};
var $cf7e1a3a3ae7d555$var$getMissingKeys = function getMissingKeys(current, previous) {
    var currentMapKeys = new Set(current.map(function(child) {
        return child.key;
    }));
    var missing = new Set();
    for(var i = 0; i < previous.length; i++){
        var element = previous[i];
        var _key = element.key;
        if (!currentMapKeys.has(_key)) missing.add(_key);
    }
    return missing;
};
/**
 * How does this component work?
 *
 * It looks at changes in its children to see what is removed.
 *
 * If a child is removed it clones it and wraps it with context providing an `onFinish` callback.
 *
 * The cloned child will call the `onFinish` when it finishes its exit animation,
 * which lets `ExitingPersistence` know to stop rendering it.
 */ /**
 * __ExitingPersistence__
 *
 * Useful for enabling elements to persist and animate away when they are removed from the DOM.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/motion/docs/entering-motion)
 */ var $cf7e1a3a3ae7d555$var$ExitingPersistence = /*#__PURE__*/ (0, $5FkrB.memo)(function(_ref) {
    var _ref$appear = _ref.appear, appear = _ref$appear === void 0 ? false : _ref$appear, children = _ref.children, exitThenEnter = _ref.exitThenEnter;
    var _useState = (0, $5FkrB.useState)([
        null,
        children
    ]), _useState2 = (0, $1dc579c4de1142c2$export$2e2bcd8739ae039)(_useState, 2), stateChildren = _useState2[0], setChildren = _useState2[1];
    var _useState3 = (0, $5FkrB.useState)([]), _useState4 = (0, $1dc579c4de1142c2$export$2e2bcd8739ae039)(_useState3, 2), exitingChildren = _useState4[0], setExitingChildren = _useState4[1];
    var _useState5 = (0, $5FkrB.useState)(function() {
        return {
            appear: appear,
            isExiting: false
        };
    }), _useState6 = (0, $1dc579c4de1142c2$export$2e2bcd8739ae039)(_useState5, 2), defaultContext = _useState6[0], setDefaultContext = _useState6[1];
    (0, $5FkrB.useEffect)(function() {
        if (!defaultContext.appear) setDefaultContext({
            appear: true,
            isExiting: false
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    /**
   * NOTE: This is a workaround for the test case written in Jira where the stateChildren is a boolean value because
   * useState is mocked to return a boolean value.
   */ if (typeof stateChildren === 'boolean') return children;
    var _stateChildren = (0, $1dc579c4de1142c2$export$2e2bcd8739ae039)(stateChildren, 2), previousChildren = _stateChildren[0], currentChildren = _stateChildren[1];
    var previous = $cf7e1a3a3ae7d555$var$childrenToArray(previousChildren);
    var current = $cf7e1a3a3ae7d555$var$childrenToArray(currentChildren);
    if (currentChildren !== children) setChildren([
        currentChildren,
        children
    ]);
    var nextChildren = currentChildren !== children ? $cf7e1a3a3ae7d555$var$childrenToArray(children) : current;
    var missingKeys = $cf7e1a3a3ae7d555$var$getMissingKeys(nextChildren, previous);
    var isSomeChildRemoved = !!missingKeys.size;
    var visibleChildren = !isSomeChildRemoved && currentChildren !== children ? nextChildren : current;
    if (isSomeChildRemoved) visibleChildren = $cf7e1a3a3ae7d555$var$spliceNewElementsIntoPrevious(current, previous);
    if (exitThenEnter) {
        if (exitingChildren.length) visibleChildren = (0, $92e43753483f870e$export$b40ec24ac8275656)('platform-dst-motion-uplift') ? previous : exitingChildren;
        else {
            var nextExitingChildren = visibleChildren.filter(function(child) {
                return missingKeys.has(child.key);
            });
            if (nextExitingChildren.length) setExitingChildren(nextExitingChildren);
        }
    }
    if (missingKeys.size) visibleChildren = visibleChildren.map(function(child) {
        var isExiting = missingKeys.has(child.key);
        return $cf7e1a3a3ae7d555$var$wrapChildWithContextProvider(child, {
            appear: true,
            isExiting: isExiting,
            onFinish: isExiting ? function() {
                missingKeys.delete(child.key);
                if (missingKeys.size === 0) {
                    setChildren([
                        null,
                        children
                    ]);
                    setExitingChildren([]);
                }
            } : undefined
        });
    });
    else visibleChildren = visibleChildren.map(function(child) {
        return $cf7e1a3a3ae7d555$var$wrapChildWithContextProvider(child, defaultContext);
    });
    return visibleChildren;
});
var $cf7e1a3a3ae7d555$export$3b6f38abbdcbd000 = function useExitingPersistence() {
    return (0, $5FkrB.useContext)($cf7e1a3a3ae7d555$var$ExitingContext);
};
$cf7e1a3a3ae7d555$var$ExitingPersistence.displayName = 'ExitingPersistence';
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$cf7e1a3a3ae7d555$export$2e2bcd8739ae039 = $cf7e1a3a3ae7d555$var$ExitingPersistence;


/**
 * Think of this as the motion equivalent of the @atlaskit/theme `grid()`.
 */ var $f2a04d536af41614$export$368bacef0dacbe05 = 25;
var $f2a04d536af41614$export$38b928a7167ce124 = {
    none: 0,
    small: 100,
    medium: 350,
    large: 700
};








/**
 * __ShrinkOut__
 *
 * Will shrink an element down to nothing when exiting.
 * Works best with flex children as collapsing margins can come with undesired behaviour.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/motion/docs/entering-motion)
 */ var $e8a62e6c3439959e$var$ShrinkOut = function ShrinkOut(_ref) {
    var children = _ref.children, _ref$duration = _ref.duration, duration = _ref$duration === void 0 ? 'small' : _ref$duration, onFinish = _ref.onFinish;
    var _useElementRef = (0, $68323260754c7b21$export$ff879f35a69d56b7)(), _useElementRef2 = (0, $1dc579c4de1142c2$export$2e2bcd8739ae039)(_useElementRef, 2), element = _useElementRef2[0], setElementRef = _useElementRef2[1];
    var exiting = (0, $cf7e1a3a3ae7d555$export$3b6f38abbdcbd000)();
    var requestAnimationFrame = (0, $1996deb533127c3f$export$1775f27e7c8051ca)();
    var setTimeout = (0, $9c12f4a4f9e5fd5a$export$4f34107a2b00f39c)();
    var direction = exiting.isExiting ? 'exiting' : 'entering';
    (0, $bbb553abe3fb900e$export$e5c5a5f917a5871c)(function() {
        if (exiting.isExiting && element) {
            if ((0, $2186f5b02e737a7a$export$b7baf7667a68d87c)()) {
                exiting.onFinish && exiting.onFinish();
                onFinish && onFinish('exiting');
                return;
            }
            var newStyles = {
                // We fix both width and height because when changing box sizing to border-box.
                width: "".concat(element.offsetWidth, "px"),
                height: "".concat(element.offsetHeight, "px"),
                boxSizing: 'border-box',
                willChange: 'width,margin'
            };
            Object.assign(element.style, newStyles);
            requestAnimationFrame(function() {
                requestAnimationFrame(function() {
                    var newStyles = {
                        width: '0px',
                        margin: '0px',
                        // We animate margin down to zero so it doesn't take any space.
                        transitionTimingFunction: 'cubic-bezier(0.8,0,0,0.8)',
                        transitionDuration: (0, $f2a04d536af41614$export$38b928a7167ce124)[duration] + 'ms',
                        transitionProperty: 'width,margin'
                    };
                    Object.assign(element.style, newStyles);
                    setTimeout(function() {
                        exiting.onFinish && exiting.onFinish();
                        onFinish && onFinish('exiting');
                    }, (0, $f2a04d536af41614$export$38b928a7167ce124)[duration]);
                });
            });
        }
    });
    return children({
        ref: setElementRef
    }, direction);
};
var $e8a62e6c3439959e$export$2e2bcd8739ae039 = $e8a62e6c3439959e$var$ShrinkOut;



/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // Color mapping from old color names to new color names
var $cd44423d3f068162$export$3351a8d90bcc13aa = {
    standard: 'gray',
    grey: 'gray',
    blue: 'blue',
    green: 'green',
    red: 'red',
    yellow: 'yellow',
    purple: 'purple',
    lime: 'lime',
    magenta: 'magenta',
    orange: 'orange',
    teal: 'teal',
    // Light variants map to same as their non-light counterparts
    greyLight: 'gray',
    blueLight: 'blue',
    greenLight: 'green',
    redLight: 'red',
    yellowLight: 'yellow',
    purpleLight: 'purple',
    limeLight: 'lime',
    magentaLight: 'magenta',
    orangeLight: 'orange',
    tealLight: 'teal'
};


// Intentionally scoped to the UI-uplifted TagNew implementation.
var $bc9497266815a6b3$export$7d100de1166870f6 = function getTagText(text) {
    return Array.isArray(text) ? text.join('') : text;
};


/* tag-new.tsx generated by @compiled/babel-plugin v2.0.0 */ 


var $5FkrB = parcelRequire("5FkrB");

var $jzAQA = parcelRequire("jzAQA");

var $jzAQA = parcelRequire("jzAQA");
const $05505a8f645500ff$export$a274e22fb40f762e = (...styles)=>{
    // At runtime TStyles is resolved down to strings, but not at compile time.
    // We circumvent the type system here because of that.
    const actualStyles = styles;
    // The output should be a union type of passed in styles. This ensures the call
    // site of xcss prop can raise violations when disallowed styles have been passed.
    return (0, $jzAQA.default)(actualStyles);
};




/* pressable.tsx generated by @compiled/babel-plugin v0.40.0 */ 


var $5FkrB = parcelRequire("5FkrB");






/* focusable.tsx generated by @compiled/babel-plugin v0.40.0 */ 


var $5FkrB = parcelRequire("5FkrB");

var $jzAQA = parcelRequire("jzAQA");
var $805b60b1041c0ec3$var$_excluded = [
    "as",
    "children",
    "isInset",
    "testId",
    "style",
    "xcss"
], $805b60b1041c0ec3$var$_excluded2 = [
    "className"
];
var $805b60b1041c0ec3$var$focusRingStyles = null;
var $805b60b1041c0ec3$var$insetFocusRingStyles = null;
var $805b60b1041c0ec3$export$35a3bebf7ef2d934 = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? 'button' : _ref$as, children = _ref.children, isInset = _ref.isInset, testId = _ref.testId, style = _ref.style, xcss = _ref.xcss, htmlAttributes = (0, $f2ca64756a447eb8$export$2e2bcd8739ae039)(_ref, $805b60b1041c0ec3$var$_excluded);
    // This is to remove className from safeHtmlAttributes
    // @ts-ignore -- not using expect since it causes issues with help-center local consumption - className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    var _spreadClass = htmlAttributes.className, safeHtmlAttributes = (0, $f2ca64756a447eb8$export$2e2bcd8739ae039)(htmlAttributes, $805b60b1041c0ec3$var$_excluded2);
    return /*#__PURE__*/ $5FkrB.createElement(Component, (0, $4d49c99afafded0a$export$2e2bcd8739ae039)({}, safeHtmlAttributes, {
        // @ts-ignore Expression produces a union type that is too complex to represent. We may be able to narrow the type here but unsure.
        ref: ref,
        className: (0, $jzAQA.default)([
            "_ymio1r31 _ypr0glyw _zcxs1o36 _mizu194a _1ah3dkaa _ra3xnqa1 _128mdkaa _1cvmnqa1 _4davt94y",
            isInset && "_1ah31gjf _2mwq1gjf",
            xcss
        ]),
        style: style,
        "data-testid": testId
    }), children);
});


var $c647649c3ca5bb9c$var$_excluded = [
    "children",
    "isDisabled",
    "type",
    "onClick",
    "interactionName",
    "componentName",
    "analyticsContext",
    "style",
    "testId",
    "xcss",
    "tabIndex"
], $c647649c3ca5bb9c$var$_excluded2 = [
    "className"
];
var $c647649c3ca5bb9c$var$styles = {
    root: "_19itglyw _vchhusvi _r06hglyw _80omtlke",
    disabled: "_80om13gf"
};
var $c647649c3ca5bb9c$export$27c701ed9e449e99 = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function(_ref, ref) {
    var children = _ref.children, isDisabled = _ref.isDisabled, _ref$type = _ref.type, type = _ref$type === void 0 ? 'button' : _ref$type, _ref$onClick = _ref.onClick, providedOnClick = _ref$onClick === void 0 ? (0, $adcefb868cf2fc9d$export$2e2bcd8739ae039) : _ref$onClick, interactionName = _ref.interactionName, componentName = _ref.componentName, analyticsContext = _ref.analyticsContext, style = _ref.style, testId = _ref.testId, xcss = _ref.xcss, tabIndex = _ref.tabIndex, htmlAttributes = (0, $f2ca64756a447eb8$export$2e2bcd8739ae039)(_ref, $c647649c3ca5bb9c$var$_excluded);
    var interactionContext = (0, $5FkrB.useContext)((0, $a81fd7e45a8c2ef5$export$2e2bcd8739ae039));
    var handleClick = (0, $5FkrB.useCallback)(function(e, analyticsEvent) {
        interactionContext && interactionContext.tracePress(interactionName, e.timeStamp);
        providedOnClick(e, analyticsEvent);
    }, [
        providedOnClick,
        interactionContext,
        interactionName
    ]);
    var onClick = (0, $0a7767b2db2f25f5$export$a4687b0234b40e28)({
        fn: handleClick,
        action: 'clicked',
        componentName: componentName || 'Pressable',
        packageName: "@atlaskit/primitives",
        packageVersion: "22.1.1",
        analyticsData: analyticsContext,
        actionSubject: 'button'
    });
    // This is to remove className from safeHtmlAttributes
    // @ts-expect-error className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    var _spreadClass = htmlAttributes.className, safeHtmlAttributes = (0, $f2ca64756a447eb8$export$2e2bcd8739ae039)(htmlAttributes, $c647649c3ca5bb9c$var$_excluded2);
    return /*#__PURE__*/ $5FkrB.createElement((0, $805b60b1041c0ec3$export$35a3bebf7ef2d934), (0, $4d49c99afafded0a$export$2e2bcd8739ae039)({
        as: "button",
        tabIndex: tabIndex !== null && tabIndex !== void 0 ? tabIndex : (0, $9cdac13a38ee471b$export$95df08bae54cb4df)() && !isDisabled ? 0 : undefined,
        style: style
    }, safeHtmlAttributes, {
        type: type,
        onClick: onClick,
        disabled: isDisabled,
        xcss: (0, $05505a8f645500ff$export$a274e22fb40f762e)($c647649c3ca5bb9c$var$styles.root, isDisabled && $c647649c3ca5bb9c$var$styles.disabled, xcss),
        testId: testId,
        ref: ref
    }), children);
});






var $5FkrB = parcelRequire("5FkrB");
function $4696b00bc92b22ee$export$ce4b6a469c26f53f(_ref) {
    var isLink = _ref.isLink, href = _ref.href, LinkComponent = _ref.LinkComponent, testId = _ref.testId, children = _ref.children, onClick = _ref.onClick, linkHandlers = _ref.linkHandlers;
    if (isLink && href) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(LinkComponent, {
        href: href,
        testId: testId ? "".concat(testId, "--link") : undefined,
        onClick: onClick,
        onMouseEnter: linkHandlers === null || linkHandlers === void 0 ? void 0 : linkHandlers.onMouseEnter,
        onMouseLeave: linkHandlers === null || linkHandlers === void 0 ? void 0 : linkHandlers.onMouseLeave,
        onMouseDown: linkHandlers === null || linkHandlers === void 0 ? void 0 : linkHandlers.onMouseDown,
        onFocus: linkHandlers === null || linkHandlers === void 0 ? void 0 : linkHandlers.onFocus,
        onBlur: linkHandlers === null || linkHandlers === void 0 ? void 0 : linkHandlers.onBlur
    }, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $5FkrB.Fragment), null, children);
}


/* removable-wrapper.tsx generated by @compiled/babel-plugin v2.0.0 */ /**
 * Shared utilities for TagNew and AvatarTag components.
 * Note: CSS styles cannot be shared due to Compiled CSS static analysis requirements.
 */ 
var $5FkrB = parcelRequire("5FkrB");

var $jzAQA = parcelRequire("jzAQA");

// Tag status enum
var $0ba81b60cc2a960c$export$74452314b63acabc = /*#__PURE__*/ function(TagStatus) {
    TagStatus["Showing"] = "showing";
    TagStatus["Removing"] = "removing";
    TagStatus["Removed"] = "removed";
    return TagStatus;
}({});


/**
 * Stable key so ExitingPersistence can match this child across the remove transition
 * (see ShrinkOut + ExitingPersistence docs in @atlaskit/motion).
 */ var $024f015fe0f4b2f0$var$removableShrinkOutChildKey = 'atlaskit-tag-removable-shrink-out';
var $024f015fe0f4b2f0$var$motionWrapperStyles = null;
function $024f015fe0f4b2f0$export$898a500849bb5cf4(_ref) {
    var isRemovable = _ref.isRemovable, status = _ref.status, onShrinkOutExitComplete = _ref.onShrinkOutExitComplete, children = _ref.children;
    if (isRemovable) return /*#__PURE__*/ $5FkrB.createElement((0, $cf7e1a3a3ae7d555$export$2e2bcd8739ae039), null, !(status === (0, $0ba81b60cc2a960c$export$74452314b63acabc).Removed) && /*#__PURE__*/ $5FkrB.createElement((0, $e8a62e6c3439959e$export$2e2bcd8739ae039), {
        key: $024f015fe0f4b2f0$var$removableShrinkOutChildKey,
        onFinish: onShrinkOutExitComplete ? function(phase) {
            if (phase === 'exiting') onShrinkOutExitComplete();
        } : undefined
    }, function(motion) {
        return /*#__PURE__*/ $5FkrB.createElement("span", {
            ref: motion.ref,
            className: (0, $jzAQA.default)([
                "_1e0c116y"
            ])
        }, children);
    }));
    return children;
}


/* swatch-before.tsx generated by @compiled/babel-plugin v2.0.0 */ 

var $5FkrB = parcelRequire("5FkrB");

var $jzAQA = parcelRequire("jzAQA");

var $ca88d72440d2ac25$var$tagSwatchBeforeStyles = {
    swatch: "_2rkolb4i _1bsboqnp _4t3ioqnp _1o9zidpf"
};
var $ca88d72440d2ac25$var$tagSwatchBeforeColorStyles = {
    gray: "_bfhk18j9",
    blue: "_bfhk115i",
    green: "_bfhk1rsu",
    red: "_bfhkkrt9",
    yellow: "_bfhk8y3s",
    purple: "_bfhk18ah",
    lime: "_bfhkbq5w",
    magenta: "_bfhk1mi6",
    orange: "_bfhk1kkj",
    teal: "_bfhktdv8"
};
function $ca88d72440d2ac25$export$2e2bcd8739ae039(_ref) {
    var colorKey = _ref.colorKey, swatchBefore = _ref.swatchBefore, swatchBeforeLabel = _ref.swatchBeforeLabel, swatchBeforeRole = _ref.swatchBeforeRole;
    if (swatchBefore === undefined || swatchBefore === false) return null;
    if (swatchBefore === true) return /*#__PURE__*/ $5FkrB.createElement("span", (0, $4d49c99afafded0a$export$2e2bcd8739ae039)({}, swatchBeforeLabel && swatchBeforeRole && (0, $92e43753483f870e$export$b40ec24ac8275656)('parent-field-switcher-missing-info-image-text') ? {
        'aria-label': swatchBeforeLabel,
        role: swatchBeforeRole
    } : {}, {
        className: (0, $jzAQA.default)([
            $ca88d72440d2ac25$var$tagSwatchBeforeStyles.swatch,
            $ca88d72440d2ac25$var$tagSwatchBeforeColorStyles[colorKey]
        ])
    }));
    return /*#__PURE__*/ $5FkrB.createElement("span", (0, $4d49c99afafded0a$export$2e2bcd8739ae039)({}, swatchBeforeLabel && swatchBeforeRole && (0, $92e43753483f870e$export$b40ec24ac8275656)('parent-field-switcher-missing-info-image-text') ? {
        'aria-label': swatchBeforeLabel,
        role: swatchBeforeRole
    } : {}, {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: {
            backgroundColor: swatchBefore
        },
        className: (0, $jzAQA.default)([
            $ca88d72440d2ac25$var$tagSwatchBeforeStyles.swatch
        ])
    }));
}




var $5FkrB = parcelRequire("5FkrB");
function $e65e2bfc11ab7f46$export$84acd183858d8235() {
    var _useState = (0, $5FkrB.useState)(false), _useState2 = (0, $1dc579c4de1142c2$export$2e2bcd8739ae039)(_useState, 2), isLinkHovered = _useState2[0], setIsLinkHovered = _useState2[1];
    var _useState3 = (0, $5FkrB.useState)(false), _useState4 = (0, $1dc579c4de1142c2$export$2e2bcd8739ae039)(_useState3, 2), isOverButton = _useState4[0], setIsOverButton = _useState4[1];
    var _useState5 = (0, $5FkrB.useState)(false), _useState6 = (0, $1dc579c4de1142c2$export$2e2bcd8739ae039)(_useState5, 2), isButtonFocused = _useState6[0], setIsButtonFocused = _useState6[1];
    var _useState7 = (0, $5FkrB.useState)(false), _useState8 = (0, $1dc579c4de1142c2$export$2e2bcd8739ae039)(_useState7, 2), isLinkFocused = _useState8[0], setIsLinkFocused = _useState8[1];
    // Track if last interaction was via mouse (to determine keyboard vs mouse focus)
    var hadMouseDownRef = (0, $5FkrB.useRef)(false);
    // Button handlers
    var buttonHandlers = (0, $5FkrB.useMemo)(function() {
        return {
            onMouseEnter: function onMouseEnter() {
                return setIsOverButton(true);
            },
            onMouseLeave: function onMouseLeave() {
                return setIsOverButton(false);
            },
            onMouseDown: function onMouseDown(e) {
                // Prevent the browser from moving focus to the remove button on mousedown.
                // Without this, parent composite widgets (e.g. Select) lose input focus when
                // the user clicks remove, triggering unwanted blur side-effects.
                e === null || e === void 0 || e.preventDefault();
                hadMouseDownRef.current = true;
            },
            onFocus: function onFocus() {
                // Only track keyboard focus for focus ring styles
                // If mousedown happened just before focus, it's mouse focus (not keyboard)
                if (!hadMouseDownRef.current) setIsButtonFocused(true);
                hadMouseDownRef.current = false;
            },
            onBlur: function onBlur() {
                return setIsButtonFocused(false);
            }
        };
    }, []);
    // Link handlers - includes hover tracking
    var linkHandlers = (0, $5FkrB.useMemo)(function() {
        return {
            onMouseEnter: function onMouseEnter() {
                return setIsLinkHovered(true);
            },
            onMouseLeave: function onMouseLeave() {
                return setIsLinkHovered(false);
            },
            onMouseDown: function onMouseDown() {
                hadMouseDownRef.current = true;
            },
            onFocus: function onFocus() {
                // Only track keyboard focus for focus ring styles
                // If mousedown happened just before focus, it's mouse focus (not keyboard)
                if (!hadMouseDownRef.current) setIsLinkFocused(true);
                hadMouseDownRef.current = false;
            },
            onBlur: function onBlur() {
                return setIsLinkFocused(false);
            }
        };
    }, []);
    return {
        isLinkHovered: isLinkHovered,
        isOverButton: isOverButton,
        isButtonFocused: isButtonFocused,
        isLinkFocused: isLinkFocused,
        buttonHandlers: buttonHandlers,
        linkHandlers: linkHandlers
    };
}


/* index.tsx generated by @compiled/babel-plugin v0.40.0 */ 


var $5FkrB = parcelRequire("5FkrB");

var $jzAQA = parcelRequire("jzAQA");


/* anchor.tsx generated by @compiled/babel-plugin v0.40.0 */ 



var $5FkrB = parcelRequire("5FkrB");





var $5FkrB = parcelRequire("5FkrB");

var $5FkrB = parcelRequire("5FkrB");
var $0f1527a14ab207d8$export$2931e0ee690eee88 = /*#__PURE__*/ (0, $5FkrB.createContext)({});
/**
 * __RouterLinkProvider__
 *
 * Provides a configured router link component for use
 * within Design System components.
 */ var $0f1527a14ab207d8$var$RouterLinkProvider = function RouterLinkProvider(_ref) {
    var routerLinkComponent = _ref.routerLinkComponent, children = _ref.children;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement($0f1527a14ab207d8$export$2931e0ee690eee88.Provider, {
        value: {
            routerLinkComponent: routerLinkComponent
        }
    }, children);
};
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$0f1527a14ab207d8$export$2e2bcd8739ae039 = $0f1527a14ab207d8$var$RouterLinkProvider;


/**
 * __useRouterLink()__
 *
 * Hook: Returns app-configured router link component.
 *
 * A generic can be passed to define advanced link configuration:
 * ```
 * type MyRouterLinkConfig = {
 *  to: string;
 *  replace?: boolean;
 * }
 *
 * const RouterLink = useRouterLink<MyRouterLinkConfig>();
 * ```
 */ var $ddde3cd35b57741d$var$useRouterLink = function useRouterLink() {
    var _useContext = (0, $5FkrB.useContext)((0, $0f1527a14ab207d8$export$2931e0ee690eee88)), routerLinkComponent = _useContext.routerLinkComponent;
    if (routerLinkComponent) return routerLinkComponent;
    return;
};
var $ddde3cd35b57741d$export$2e2bcd8739ae039 = $ddde3cd35b57741d$var$useRouterLink;





/* visually-hidden.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $5FkrB = parcelRequire("5FkrB");
/**
 * This length includes the underscore,
 * e.g. `"_1s4A"` would be a valid atomic group hash.
 */ const $26cfa34668e5d007$var$ATOMIC_GROUP_LENGTH = 5;
function $26cfa34668e5d007$export$2e2bcd8739ae039(classNames) {
    // Shortcut: nothing to do
    if (!classNames.length) return;
    // Shortcut: don't need to do anything if we only have a single classname
    if (classNames.length === 1 && classNames[0] && // checking to see if `classNames[0]` is a string that contains other classnames
    !classNames[0].includes(' ')) return classNames[0];
    // Using an object rather than a `Map` as it performed better in our benchmarks.
    // Would be happy to move to `Map` if it proved to be better under real conditions.
    const map = {};
    // Note: using loops to minimize iterations over the collection
    for (const value of classNames){
        // Exclude all falsy values, which leaves us with populated strings
        if (!value) continue;
        // a `value` can contain multiple classnames
        const list = value.split(' ');
        for (const className of list){
            /**
             * For atomic style classnames: the `key` is the `group`
             *
             * - Later atomic classnames with the same `group` will override earlier ones
             *   (which is what we want).
             * - Assumes atomic classnames are the only things that start with `_`
             * - Could use a regex to ensure that atomic classnames are structured how we expect,
             *   but did not add that for now as it did slow things down a bit.
             *
             * For other classnames: the `key` is the whole classname
             * - Okay to remove duplicates as doing so does not impact specificity
             *
             * */ const key = className.startsWith('_') ? className.slice(0, $26cfa34668e5d007$var$ATOMIC_GROUP_LENGTH) : className;
            map[key] = className;
        }
    }
    /**
     * We are converting the `map` into a string.
     *
     * The simple way to do this would be `Object.values(map).join(' ')`.
     * However, the approach below performs 10%-20% better in benchmarks.
     *
     * For `ax()` it feels right to squeeze as much runtime performance out as we can.
     */ let result = '';
    for(const key in map)result += map[key] + ' ';
    // If we have an empty string, then our `map` was empty.
    if (!result) return;
    // remove last " " from the result (we added " " at the end of every value)
    return result.trimEnd();
}


var $8f5ad48a522740cb$var$visuallyHiddenStyles = null;
/**
 * __Visually hidden__
 *
 * A composable element to apply a visually hidden effect to children.
 * Useful for accessibility compliance.
 *
 * @example
 * ```jsx
 * import VisuallyHidden from '@atlaskit/visually-hidden';
 *
 * export default () => (
 *   <div style={{ border: '1px solid black' }}>
 *      There is text hidden between the brackets [
 *      <VisuallyHidden>Can't see me!</VisuallyHidden>]
 *   </div>
 * );
 * ```
 */ var $8f5ad48a522740cb$var$VisuallyHidden = function VisuallyHidden(_ref) {
    var children = _ref.children, testId = _ref.testId, role = _ref.role, id = _ref.id;
    return /*#__PURE__*/ $5FkrB.createElement("span", {
        id: id,
        "data-testid": testId,
        role: role,
        className: (0, $26cfa34668e5d007$export$2e2bcd8739ae039)([
            "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19itidpf _1reo15vq _18m915vq _1bsbt94y _4t3it94y _kqswstnw _ogto7mnp _uiztglyw _o5721q9c"
        ])
    }, children);
};
$8f5ad48a522740cb$var$VisuallyHidden.displayName = 'VisuallyHidden';
var $8f5ad48a522740cb$export$2e2bcd8739ae039 = $8f5ad48a522740cb$var$VisuallyHidden;



var $0c3b75184e24ecd5$var$_excluded = [
    "href",
    "children",
    "onClick",
    "interactionName",
    "componentName",
    "analyticsContext",
    "aria-label",
    "aria-labelledby",
    "style",
    "target",
    "testId",
    "xcss",
    "newWindowLabel"
], $0c3b75184e24ecd5$var$_excluded2 = [
    "className"
];
var $0c3b75184e24ecd5$var$styles = {
    root: "_4bfu1r31 _1hms8stv _ajmmnqa1 _vchhusvi",
    position: "_kqswh2mm"
};
var $0c3b75184e24ecd5$var$IS_EXTERNAL_LINK_REGEX = /^(?:(http|https):\/\/)/;
var $0c3b75184e24ecd5$var$IS_NON_HTTP_BASED = /^(((mailto|tel|sms|blob):)|(#))/;
/**
 * __Anchor__
 *
 * A primitive for building custom anchor links.
 *
 * - [Examples](https://atlassian.design/components/primitives/anchor/examples)
 * - [Code](https://atlassian.design/components/primitives/anchor/code)
 * - [Usage](https://atlassian.design/components/primitives/anchor/usage)
 */ var $0c3b75184e24ecd5$var$AnchorNoRef = function AnchorNoRef(_ref, ref) {
    var href = _ref.href, children = _ref.children, _ref$onClick = _ref.onClick, providedOnClick = _ref$onClick === void 0 ? (0, $adcefb868cf2fc9d$export$2e2bcd8739ae039) : _ref$onClick, interactionName = _ref.interactionName, componentName = _ref.componentName, analyticsContext = _ref.analyticsContext, ariaLabel = _ref['aria-label'], ariaLabelledBy = _ref['aria-labelledby'], style = _ref.style, target = _ref.target, testId = _ref.testId, xcss = _ref.xcss, _ref$newWindowLabel = _ref.newWindowLabel, newWindowLabel = _ref$newWindowLabel === void 0 ? '(opens new window)' : _ref$newWindowLabel, htmlAttributes = (0, $f2ca64756a447eb8$export$2e2bcd8739ae039)(_ref, $0c3b75184e24ecd5$var$_excluded);
    var interactionContext = (0, $5FkrB.useContext)((0, $a81fd7e45a8c2ef5$export$2e2bcd8739ae039));
    var handleClick = (0, $5FkrB.useCallback)(function(e, analyticsEvent) {
        interactionContext && interactionContext.tracePress(interactionName, e.timeStamp);
        providedOnClick(e, analyticsEvent);
    }, [
        providedOnClick,
        interactionContext,
        interactionName
    ]);
    var opensNewWindowLabelId = (0, $c797bf80d6171378$export$f680877a34711e37)();
    var onClick = (0, $0a7767b2db2f25f5$export$a4687b0234b40e28)({
        fn: handleClick,
        action: 'clicked',
        componentName: componentName || 'Anchor',
        packageName: "@atlaskit/primitives",
        packageVersion: "22.1.1",
        analyticsData: analyticsContext,
        actionSubject: 'link'
    });
    // This is to remove className from safeHtmlAttributes
    // @ts-expect-error className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    var _spreadClass = htmlAttributes.className, safeHtmlAttributes = (0, $f2ca64756a447eb8$export$2e2bcd8739ae039)(htmlAttributes, $0c3b75184e24ecd5$var$_excluded2);
    var RouterLink = (0, $ddde3cd35b57741d$export$2e2bcd8739ae039)();
    var isExternal = typeof href === 'string' && $0c3b75184e24ecd5$var$IS_EXTERNAL_LINK_REGEX.test(href);
    var isNonHttpBased = typeof href === 'string' && $0c3b75184e24ecd5$var$IS_NON_HTTP_BASED.test(href);
    /**
   * Renders a router link if:
   *
   * - a link component is set in the app provider
   * - it's not an external link (starting with `http://` or `https://`)
   * - it's not a non-HTTP-based link (e.g. emails, phone numbers, hash links etc.).
   */ var isRouterLink = RouterLink && !isExternal && !isNonHttpBased;
    var hrefObjectUsedWithoutRouterLink = RouterLink === undefined && (0, $a9546fe3c34f8734$export$2e2bcd8739ae039)(href) === 'object';
    (0, $fff3f31fc3bd4f88$export$2e2bcd8739ae039)(!hrefObjectUsedWithoutRouterLink, "@atlaskit/primitives: Anchor primitive cannot pass an object to 'href' unless a router link is configured in the AppProvider");
    var Component = isRouterLink ? RouterLink : 'a';
    return /*#__PURE__*/ $5FkrB.createElement((0, $805b60b1041c0ec3$export$35a3bebf7ef2d934), (0, $4d49c99afafded0a$export$2e2bcd8739ae039)({
        as: Component,
        className: xcss,
        style: style,
        ref: ref
    }, safeHtmlAttributes, {
        href: !isRouterLink && typeof href !== 'string' ? undefined : href,
        target: target,
        onClick: onClick,
        "aria-label": ariaLabel && target === '_blank' && !ariaLabelledBy ? "".concat(ariaLabel, " , ").concat(newWindowLabel) : ariaLabel,
        "aria-labelledby": ariaLabelledBy && target === '_blank' ? "".concat(ariaLabelledBy, " ").concat(opensNewWindowLabelId) : ariaLabelledBy,
        xcss: (0, $05505a8f645500ff$export$a274e22fb40f762e)($0c3b75184e24ecd5$var$styles.root, $0c3b75184e24ecd5$var$styles.position, xcss),
        testId: testId,
        "data-is-router-link": testId ? isRouterLink ? 'true' : 'false' : undefined
    }), children, target === '_blank' && (children && !ariaLabel && !ariaLabelledBy || ariaLabelledBy) && /*#__PURE__*/ $5FkrB.createElement((0, $8f5ad48a522740cb$export$2e2bcd8739ae039), {
        id: opensNewWindowLabelId
    }, ", ".concat(newWindowLabel)));
};
var $0c3b75184e24ecd5$export$b688253958b8dfe7 = /*#__PURE__*/ (0, $5FkrB.forwardRef)($0c3b75184e24ecd5$var$AnchorNoRef);


var $154493e39bc37a2e$var$_excluded = [
    "children",
    "testId",
    "appearance",
    "newWindowLabel",
    "target",
    "className",
    "style"
];
var $154493e39bc37a2e$var$styles = {
    base: "_ect4ttxp",
    baseT26Shape: "_2rkolb4i",
    visitedLink: "_10531ra0 _1ien1ra0 _n0fx1ra0 _1vhv17z1",
    defaultAppearance: "_4bfu1r31 _1hms8stv _ajmmnqa1 _syaz13af _1a3b1r31 _4fpr8stv _5goinqa1 _f8pj13af _9oik1r31 _1bnxglyw _jf4cnqa1 _30l313af _1nrm1r31 _c2waglyw _1iohnqa1 _9h8h12zz",
    defaultAppearanceMotion: "_4bfu1r31 _1hms8stv _ajmmnqa1 _v564hxmd _syaz13af _1a3b1r31 _4fpr8stv _5goinqa1 _f8pj13af _9oik1j28 _1bnx8stv _jf4cnqa1 _o7kshxmd _30l313af _1nrm1j28 _c2wa8stv _1iohnqa1 _1ggl87vo _9h8h12zz",
    subtleAppearance: "_4bfu1r31 _1hmsglyw _ajmmnqa1 _syazazsu _1a3b1r31 _4fprglyw _5goinqa1 _f8pjazsu _9oik1r31 _1bnx8stv _jf4cnqa1 _30l3azsu _1nrm1r31 _c2wa8stv _1iohnqa1 _9h8hi7uo",
    subtleAppearanceMotion: "_4bfu1j28 _1hms8stv _ajmmnqa1 _v564hxmd _syazazsu _1a3b1j28 _4fpr8stv _5goinqa1 _f8pjazsu _9oik1r31 _1bnx8stv _jf4cnqa1 _o7kshxmd _30l3azsu _1nrm1r31 _c2wa8stv _1iohnqa1 _1ggl87vo _9h8hi7uo",
    inverseAppearance: "_4bfu1r31 _1hms8stv _ajmmnqa1 _syaz15cr _105315cr _1a3b1r31 _4fpr8stv _5goinqa1 _f8pj15cr _9oik1r31 _1bnxglyw _jf4cnqa1 _30l315cr _1nrm1r31 _c2waglyw _1iohnqa1 _9h8h15cr",
    inverseAppearanceMotion: "_4bfu1r31 _1hms8stv _ajmmnqa1 _v564hxmd _syaz15cr _105315cr _1a3b1r31 _4fpr8stv _5goinqa1 _f8pj15cr _9oik1j28 _1bnx8stv _jf4cnqa1 _o7kshxmd _30l315cr _1nrm1j28 _c2wa8stv _1iohnqa1 _1ggl87vo _9h8h15cr",
    iconWrapper: "_1e0c1nu9 _o5721q9c _s7n41q9y _kqswh2mm _152ttb3r"
};
var $154493e39bc37a2e$var$iconStyles = null;
var $154493e39bc37a2e$var$LinkWithoutRef = function LinkWithoutRef(_ref, ref) {
    var children = _ref.children, testId = _ref.testId, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'default' : _ref$appearance, newWindowLabel = _ref.newWindowLabel, target = _ref.target, _preventedClassName = _ref.className, _preventedStyle = _ref.style, htmlAttributes = (0, $f2ca64756a447eb8$export$2e2bcd8739ae039)(_ref, $154493e39bc37a2e$var$_excluded);
    return /*#__PURE__*/ $5FkrB.createElement((0, $0c3b75184e24ecd5$export$b688253958b8dfe7), (0, $4d49c99afafded0a$export$2e2bcd8739ae039)({}, htmlAttributes, {
        target: target,
        ref: ref,
        xcss: (0, $1845bee1a1da9181$export$a274e22fb40f762e)($154493e39bc37a2e$var$styles.base, (0, $92e43753483f870e$export$b40ec24ac8275656)('platform-dst-shape-theme-default') && $154493e39bc37a2e$var$styles.baseT26Shape, appearance === 'default' && ((0, $92e43753483f870e$export$b40ec24ac8275656)('platform-dst-motion-uplift-list-item') ? $154493e39bc37a2e$var$styles.defaultAppearanceMotion : $154493e39bc37a2e$var$styles.defaultAppearance), appearance === 'subtle' && ((0, $92e43753483f870e$export$b40ec24ac8275656)('platform-dst-motion-uplift-list-item') ? $154493e39bc37a2e$var$styles.subtleAppearanceMotion : $154493e39bc37a2e$var$styles.subtleAppearance), appearance === 'inverse' && ((0, $92e43753483f870e$export$b40ec24ac8275656)('platform-dst-motion-uplift-list-item') ? $154493e39bc37a2e$var$styles.inverseAppearanceMotion : $154493e39bc37a2e$var$styles.inverseAppearance), // Visited styles are not supported for inverse links due to contrast issues
        appearance !== 'inverse' && $154493e39bc37a2e$var$styles.visitedLink),
        testId: testId,
        componentName: "Link",
        newWindowLabel: newWindowLabel
    }), children, target === '_blank' && /*#__PURE__*/ $5FkrB.createElement((0, $4308eb16285ed11e$export$e71c4d32a2263218), {
        as: "span",
        xcss: $154493e39bc37a2e$var$styles.iconWrapper,
        testId: testId && "".concat(testId, "__icon")
    }, "\uFEFF", /*#__PURE__*/ $5FkrB.createElement("svg", {
        width: "12",
        height: "12",
        viewBox: "0 0 12 12",
        fill: "none",
        className: (0, $jzAQA.default)([
            "_1bsbgm0b _4t3igm0b _ahbqzjw7"
        ])
    }, /*#__PURE__*/ $5FkrB.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M0 1.82609C0 0.817938 0.817938 0 1.82609 0H3.91304V1.04348H1.82609C1.39424 1.04348 1.04348 1.39424 1.04348 1.82609V10.1739C1.04348 10.6058 1.39424 10.9565 1.82609 10.9565H10.1739C10.6058 10.9565 10.9565 10.6058 10.9565 10.1739V8.08696H12V10.1739C12 11.1821 11.1821 12 10.1739 12H1.82609C0.817938 12 0 11.1821 0 10.1739V1.82609ZM7.04348 0H12V4.95652H10.9565V1.78133L6.36893 6.36893L5.63107 5.63107L10.2187 1.04348H7.04348V0Z",
        fill: "currentColor"
    }))));
};
// Workarounds to support generic types with forwardRef
/**
 * __Link__
 *
 * A link is an inline text element that navigates to a new location when clicked.
 *
 * - [Examples](https://atlassian.design/components/primitives/link/examples)
 * - [Code](https://atlassian.design/components/primitives/link/code)
 * - [Usage](https://atlassian.design/components/primitives/link/usage)
 */ var $154493e39bc37a2e$var$Link = /*#__PURE__*/ (0, $5FkrB.forwardRef)($154493e39bc37a2e$var$LinkWithoutRef);
var $154493e39bc37a2e$export$2e2bcd8739ae039 = $154493e39bc37a2e$var$Link;


function $3c51b9421d06fe02$export$dcf14c9974fe2767(href, linkComponent) {
    var isLink = Boolean(href);
    var LinkComponent = linkComponent !== null && linkComponent !== void 0 ? linkComponent : (0, $154493e39bc37a2e$export$2e2bcd8739ae039);
    return {
        isLink: isLink,
        LinkComponent: LinkComponent
    };
}


/**
 * Shared utilities for TagNew and AvatarTag components.
 * Note: CSS styles cannot be shared due to Compiled CSS static analysis requirements.
 */ 
var $5FkrB = parcelRequire("5FkrB");
/* remove-button.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $5FkrB = parcelRequire("5FkrB");


var $1662fb12050f0961$exports = {};
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a6e34d167858ba514f74d5881b8440fc>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty($1662fb12050f0961$exports, "__esModule", {
    value: true
});
$1662fb12050f0961$exports.default = void 0;

var $1662fb12050f0961$var$_react = $1662fb12050f0961$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $1662fb12050f0961$var$_baseNew = $1662fb12050f0961$var$_interopRequireDefault((parcelRequire("f28qG")));
function $1662fb12050f0961$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Cross".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Known uses: closing modals, panels, and transient views; removing tags
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $1662fb12050f0961$var$CrossIcon = (props)=>/*#__PURE__*/ $1662fb12050f0961$var$_react.default.createElement($1662fb12050f0961$var$_baseNew.default, Object.assign({
        name: "CrossIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M13.53 3.53 9.06 8l4.47 4.47-1.06 1.06L8 9.06l-4.47 4.47-1.06-1.06L6.94 8 2.47 3.53l1.06-1.06L8 6.94l4.47-4.47z"/>`
    }, props));
$1662fb12050f0961$var$CrossIcon.displayName = 'CrossIcon';
var $1662fb12050f0961$var$_default = $1662fb12050f0961$exports.default = $1662fb12050f0961$var$CrossIcon;




var $44c2b79ffdcb7cdd$var$removeButtonStyles = {
    root: "_19itglyw _2rkolb4i _195gze3t _1mouze3t _18zrze3t _1rjcze3t _1e0c1txw _4t3i1j6v _1bsb1j6v _rjxpze3t _4cvr1h6o _1bah1h6o _1wpz1h6o _r06hglyw _bfhksm61 _syazi7uo _80omtlke _lcxv1wug _ahbq1i6y _12l21i6y _1ah3idpf _irr31dpa _1di6fcek",
    circle: "_2rko1rr0 _1ah3idpf",
    focusRing: "_1ah3v77o",
    newIcon: "_rjxpv77o"
};
var $44c2b79ffdcb7cdd$var$RemoveButton = function RemoveButton(_ref) {
    var ariaLabel = _ref['aria-label'], onClick = _ref.onClick, onFocus = _ref.onFocus, onBlur = _ref.onBlur, onKeyPress = _ref.onKeyPress, onMouseOver = _ref.onMouseOver, onMouseOut = _ref.onMouseOut, onMouseDown = _ref.onMouseDown, onMouseUp = _ref.onMouseUp, onMouseEnter = _ref.onMouseEnter, onMouseLeave = _ref.onMouseLeave, testId = _ref.testId, _ref$shape = _ref.shape, shape = _ref$shape === void 0 ? 'default' : _ref$shape;
    return /*#__PURE__*/ $5FkrB.createElement((0, $c647649c3ca5bb9c$export$27c701ed9e449e99), {
        xcss: (0, $1845bee1a1da9181$export$a274e22fb40f762e)($44c2b79ffdcb7cdd$var$removeButtonStyles.root, shape === 'circle' && $44c2b79ffdcb7cdd$var$removeButtonStyles.circle, $44c2b79ffdcb7cdd$var$removeButtonStyles.newIcon, (0, $92e43753483f870e$export$b40ec24ac8275656)('platform-dst-lozenge-tag-badge-visual-uplifts') && $44c2b79ffdcb7cdd$var$removeButtonStyles.focusRing),
        "aria-label": ariaLabel,
        onClick: onClick,
        onFocus: onFocus,
        onBlur: onBlur,
        onKeyPress: onKeyPress,
        onMouseOver: onMouseOver,
        onMouseOut: onMouseOut,
        onMouseDown: onMouseDown,
        onMouseUp: onMouseUp,
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
        testId: testId
    }, /*#__PURE__*/ $5FkrB.createElement((0, (/*@__PURE__*/$parcel$interopDefault($1662fb12050f0961$exports))), {
        color: "currentColor",
        label: "",
        size: "small"
    }));
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$44c2b79ffdcb7cdd$export$2e2bcd8739ae039 = $44c2b79ffdcb7cdd$var$RemoveButton;


function $27bd4e0da7349491$export$97d8be09cd53869b(_ref) {
    var isRemovable = _ref.isRemovable, tagText = _ref.tagText, removeButtonLabel = _ref.removeButtonLabel, testId = _ref.testId, handleRemoveRequest = _ref.handleRemoveRequest, removingTag = _ref.removingTag, showingTag = _ref.showingTag, onKeyPress = _ref.onKeyPress, _ref$shape = _ref.shape, shape = _ref$shape === void 0 ? 'default' : _ref$shape, buttonHandlers = _ref.buttonHandlers;
    var handleFocus = (0, $5FkrB.useCallback)(function() {
        removingTag();
        buttonHandlers === null || buttonHandlers === void 0 || buttonHandlers.onFocus();
    }, [
        removingTag,
        buttonHandlers
    ]);
    var handleBlur = (0, $5FkrB.useCallback)(function() {
        showingTag();
        buttonHandlers === null || buttonHandlers === void 0 || buttonHandlers.onBlur();
    }, [
        showingTag,
        buttonHandlers
    ]);
    return (0, $5FkrB.useMemo)(function() {
        if (!isRemovable) return undefined;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $44c2b79ffdcb7cdd$export$2e2bcd8739ae039), {
            "aria-label": "".concat(removeButtonLabel || 'Remove', " ").concat(tagText),
            onClick: handleRemoveRequest,
            onFocus: handleFocus,
            onBlur: handleBlur,
            onKeyPress: onKeyPress,
            onMouseEnter: buttonHandlers === null || buttonHandlers === void 0 ? void 0 : buttonHandlers.onMouseEnter,
            onMouseLeave: buttonHandlers === null || buttonHandlers === void 0 ? void 0 : buttonHandlers.onMouseLeave,
            onMouseDown: buttonHandlers === null || buttonHandlers === void 0 ? void 0 : buttonHandlers.onMouseDown,
            testId: testId ? "close-button-".concat(testId) : undefined,
            shape: shape
        });
    }, [
        isRemovable,
        removeButtonLabel,
        tagText,
        handleRemoveRequest,
        handleFocus,
        handleBlur,
        onKeyPress,
        buttonHandlers,
        testId,
        shape
    ]);
}




var $5FkrB = parcelRequire("5FkrB");
var $f902bd7a1f04fdec$export$279e7025ed114474 = function defaultBeforeRemoveAction() {
    return true;
};



function $0f6067edd7f57835$export$f26019543e9f862f(onBeforeRemoveAction) {
    var _useState = (0, $5FkrB.useState)((0, $0ba81b60cc2a960c$export$74452314b63acabc).Showing), _useState2 = (0, $1dc579c4de1142c2$export$2e2bcd8739ae039)(_useState, 2), status = _useState2[0], setStatus = _useState2[1];
    var handleRemoveRequest = (0, $5FkrB.useCallback)(function() {
        var beforeAction = onBeforeRemoveAction !== null && onBeforeRemoveAction !== void 0 ? onBeforeRemoveAction : (0, $f902bd7a1f04fdec$export$279e7025ed114474);
        if (beforeAction()) // Defer onAfterRemoveAction until ShrinkOut's onFinish so ExitingPersistence can run
        // the exit animation (e.g. in multi-select and user pickers).
        setStatus((0, $0ba81b60cc2a960c$export$74452314b63acabc).Removed);
    }, [
        onBeforeRemoveAction
    ]);
    var onKeyPress = (0, $5FkrB.useCallback)(function(e) {
        var spacebarOrEnter = e.key === ' ' || e.key === 'Enter';
        if (spacebarOrEnter) {
            e.stopPropagation();
            handleRemoveRequest();
        }
    }, [
        handleRemoveRequest
    ]);
    var removingTag = (0, $5FkrB.useCallback)(function() {
        return setStatus((0, $0ba81b60cc2a960c$export$74452314b63acabc).Removing);
    }, []);
    var showingTag = (0, $5FkrB.useCallback)(function() {
        return setStatus((0, $0ba81b60cc2a960c$export$74452314b63acabc).Showing);
    }, []);
    return {
        status: status,
        handleRemoveRequest: handleRemoveRequest,
        onKeyPress: onKeyPress,
        removingTag: removingTag,
        showingTag: showingTag
    };
}


var $16e8b8a7d33ff93c$var$_excluded = [
    "color",
    "text",
    "elemBefore",
    "href",
    "linkComponent",
    "isRemovable",
    "removeButtonLabel",
    "onBeforeRemoveAction",
    "onAfterRemoveAction",
    "testId",
    "maxWidth",
    "hasMargin",
    "onClick",
    "swatchBefore",
    "swatchBeforeLabel",
    "swatchBeforeRole",
    "trailingMetric"
], $16e8b8a7d33ff93c$var$_excluded2 = [
    "color",
    "text",
    "elemBefore",
    "testId",
    "maxWidth",
    "hasMargin",
    "onClick",
    "isSelected",
    "isLoading",
    "analyticsContext",
    "hasChevron",
    "swatchBefore",
    "swatchBeforeLabel",
    "swatchBeforeRole",
    "trailingMetric"
];
var $16e8b8a7d33ff93c$var$styles = {
    baseStyles: "_zulp1b66 _2rko12b0 _11c8wadc _1dqonqa1 _189ee4h9 _1rjcv77o _18zr1mie _1mou1b66 _195g1b66 _1e0c116y _vchhusvi _1ul9idpf _p12ff6dh _4t3i1k92 _kqswh2mm _4cvr1h6o _80om73ad _bfhksm61",
    noMarginStyles: "_1mouze3t _195gze3t",
    removableStyles: "_zulp1b66",
    beforeStyles: "_4bfu1snc _1hmsagmp _ajmmvv82 _1e0c116y _4cvr1h6o _1o9zidpf _syaz125o",
    beforeStylesSelected: "_syazxl6c",
    textStyles: "_1reo15vq _18m915vq _1bto1l2s _o5721q9c _16jlkb7n _1ul9idpf _syazi7uo",
    textStylesSelected: "_syaz6x5g",
    afterStyles: "_1e0c1txw _4cvr1h6o _1o9zidpf _lcxv1wug _kqswh2mm",
    trailingMetric: "_2rkolb4i _11c8wadc _18zr1b66 _1rjcidpf _1e0c116y _vchhusvi _1ul91ejb _1bah1h6o _4cvr1h6o _1o9zidpf _1kz6184x _bfhk1w9g _syazi7uo",
    trailingMetricEndPadding: "_y4ti303w",
    focusRingStyles: "_1ygbdfik _1ah3v77o",
    childFocusRingStyles: "_1a37dfik _1cwgv77o",
    interactiveBaseStyles: "_80omtlke _1all1b66 _qsdj1r31 _17ncglyw _15hpnqa1 _1rg815vq _1yoo15vq _j8j91snc _1afaagmp _gdbt10yn _h5vp116y _1qxz1h6o _8zx0idpf _1km4jdj5 _wc1fagmp _9408jdj5 _usew1snc _ebtnagmp _uvk910yn _10nj1r31 _1xq0glyw _18x1nqa1 _2mpsagmp",
    interactiveHoverStyles: "_17501r31 _qrsc8stv _1wodnqa1 _irr31dpa _rlyhjdj5 _1di6fcek"
};
// For accent borders, we use the new color.border.accent.*.subtle tokens (Color300
// light / Color800 dark) which provide proper decorative-border colours
//
// Icons keep color.icon.accent.* in the default state (vibrant on the plain page
// background) and swap to color.text.accent.* in hovered/pressed states (where the
// Tag picks up a coloured background and needs guaranteed 3:1 icon contrast).
var $16e8b8a7d33ff93c$var$colorStyles = {
    gray: "_119bmsup _1ib21diz _egnk1sqi _17x31sqi _ih6z7qp0",
    blue: "_119b18hp _1ib26txe _egnk16jw _17x316jw _ih6z1dy8",
    green: "_119b5d2u _1ib217hp _egnkh55r _17x3h55r _ih6z1wnw",
    red: "_119bn9dc _1ib2nbxb _egnk9lu1 _17x39lu1 _ih6z1rtt",
    yellow: "_119b1s7j _1ib21oqg _egnkfb2s _17x3fb2s _ih6z1773",
    purple: "_119bluwt _1ib2uq3u _egnkqmo9 _17x3qmo9 _ih6z1nm4",
    lime: "_119b1m7d _1ib28645 _egnk1tco _17x31tco _ih6zz2ec",
    magenta: "_119b132u _1ib2v8hk _egnk1s8m _17x31s8m _ih6zv9ra",
    orange: "_119b1ip5 _1ib21j6y _egnkp1lv _17x3p1lv _ih6z165s",
    teal: "_119b131p _1ib28uof _egnk17qg _17x317qg _ih6z1a17"
};
// Border + icon filter styles - base state.
// Borders use the new color.border.accent.*.subtle tokens directly.
// Icons use the color.icon.accent.* tokens directly in the default state.
var $16e8b8a7d33ff93c$var$borderIconFilterStyles = {
    root: "_1h6dip4g _wi6h9ea2"
};
// Border + icon filter styles - interactive states (hover/pressed).
// Icons swap to the color.text.accent.* tokens for guaranteed 3:1 contrast
// against the coloured interactive backgrounds. Borders stay constant.
var $16e8b8a7d33ff93c$var$borderIconInteractiveFilterStyles = {
    root: "_4cvxip4g _zqoiipvw _q4ztip4g _ba35u0j8"
};
var $16e8b8a7d33ff93c$var$dropdownStyles = {
    interactive: "_irr31dpa _1di6fcek",
    selected: "_1h6dq98m _syaz6x5g _bfhk15s3 _irr3ufnl _1di6nozp",
    content: "_zulp1b66 _1reo15vq _18m915vq _1e0c116y _4cvr1h6o _16jlkb7n _1o9zkb7n _1ul9idpf",
    loadingContent: "_tzy4idpf",
    loadingOverlay: "_1reo15vq _18m915vq _1e0c1txw _kqswstnw _4cvr1h6o _1bah1h6o _u7coze3t _152tze3t _rjxpze3t _1e02ze3t _lcxvglyw"
};
/**
 * __TagNew__
 *
 * TagNew is the visual uplift implementation of Tag
 */ var $16e8b8a7d33ff93c$var$TagNewComponent = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function TagNew(_ref, ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'gray' : _ref$color, text = _ref.text, elemBefore = _ref.elemBefore, href = _ref.href, linkComponent = _ref.linkComponent, _ref$isRemovable = _ref.isRemovable, isRemovable = _ref$isRemovable === void 0 ? true : _ref$isRemovable, removeButtonLabel = _ref.removeButtonLabel, onBeforeRemoveAction = _ref.onBeforeRemoveAction, onAfterRemoveAction = _ref.onAfterRemoveAction, testId = _ref.testId, maxWidth = _ref.maxWidth, _ref$hasMargin = _ref.hasMargin, hasMargin = _ref$hasMargin === void 0 ? true : _ref$hasMargin, onClick = _ref.onClick, swatchBefore = _ref.swatchBefore, swatchBeforeLabel = _ref.swatchBeforeLabel, swatchBeforeRole = _ref.swatchBeforeRole, trailingMetric = _ref.trailingMetric, other = (0, $f2ca64756a447eb8$export$2e2bcd8739ae039)(_ref, $16e8b8a7d33ff93c$var$_excluded);
    var normalizedText = (0, $bc9497266815a6b3$export$7d100de1166870f6)(text);
    var _useTagRemoval = (0, $0f6067edd7f57835$export$f26019543e9f862f)(onBeforeRemoveAction), status = _useTagRemoval.status, handleRemoveRequest = _useTagRemoval.handleRemoveRequest, onKeyPress = _useTagRemoval.onKeyPress, removingTag = _useTagRemoval.removingTag, showingTag = _useTagRemoval.showingTag;
    var onShrinkOutExitComplete = (0, $5FkrB.useCallback)(function() {
        onAfterRemoveAction === null || onAfterRemoveAction === void 0 || onAfterRemoveAction(normalizedText);
    }, [
        normalizedText,
        onAfterRemoveAction
    ]);
    var _useLink = (0, $3c51b9421d06fe02$export$dcf14c9974fe2767)(href, linkComponent), isLink = _useLink.isLink, LinkComponent = _useLink.LinkComponent;
    var _useButtonInteraction = (0, $e65e2bfc11ab7f46$export$84acd183858d8235)(), isLinkHovered = _useButtonInteraction.isLinkHovered, isOverButton = _useButtonInteraction.isOverButton, isButtonFocused = _useButtonInteraction.isButtonFocused, isLinkFocused = _useButtonInteraction.isLinkFocused, buttonHandlers = _useButtonInteraction.buttonHandlers, linkHandlers = _useButtonInteraction.linkHandlers;
    var removeButton = (0, $27bd4e0da7349491$export$97d8be09cd53869b)({
        isRemovable: isRemovable,
        tagText: normalizedText,
        removeButtonLabel: removeButtonLabel,
        testId: testId,
        handleRemoveRequest: handleRemoveRequest,
        removingTag: removingTag,
        showingTag: showingTag,
        onKeyPress: onKeyPress,
        buttonHandlers: buttonHandlers
    });
    var tagContent = /*#__PURE__*/ $5FkrB.createElement("span", (0, $4d49c99afafded0a$export$2e2bcd8739ae039)({}, other, {
        ref: ref,
        "data-testid": testId,
        style: maxWidth !== undefined ? {
            maxWidth: maxWidth
        } : undefined,
        className: (0, $jzAQA.default)([
            $16e8b8a7d33ff93c$var$styles.baseStyles,
            !hasMargin && $16e8b8a7d33ff93c$var$styles.noMarginStyles,
            $16e8b8a7d33ff93c$var$colorStyles[color],
            $16e8b8a7d33ff93c$var$borderIconFilterStyles.root,
            isLink && $16e8b8a7d33ff93c$var$styles.interactiveBaseStyles,
            isLink && $16e8b8a7d33ff93c$var$styles.focusRingStyles,
            isLink && isLinkHovered && !isOverButton && $16e8b8a7d33ff93c$var$borderIconInteractiveFilterStyles.root,
            isLink && isLinkHovered && !isOverButton && $16e8b8a7d33ff93c$var$styles.interactiveHoverStyles,
            isRemovable && $16e8b8a7d33ff93c$var$styles.removableStyles,
            isLinkFocused && !isButtonFocused && $16e8b8a7d33ff93c$var$styles.childFocusRingStyles,
            !isRemovable && trailingMetric != null && trailingMetric !== '' && $16e8b8a7d33ff93c$var$styles.trailingMetricEndPadding
        ])
    }), /*#__PURE__*/ $5FkrB.createElement((0, $4696b00bc92b22ee$export$ce4b6a469c26f53f), {
        isLink: isLink,
        href: href,
        LinkComponent: LinkComponent,
        testId: testId,
        linkHandlers: linkHandlers,
        onClick: onClick
    }, /*#__PURE__*/ $5FkrB.createElement((0, $ca88d72440d2ac25$export$2e2bcd8739ae039), (0, $4d49c99afafded0a$export$2e2bcd8739ae039)({
        colorKey: color,
        swatchBefore: swatchBefore
    }, (0, $92e43753483f870e$export$b40ec24ac8275656)('parent-field-switcher-missing-info-image-text') ? {
        swatchBeforeLabel: swatchBeforeLabel,
        swatchBeforeRole: swatchBeforeRole
    } : {})), elemBefore && /*#__PURE__*/ $5FkrB.createElement("span", {
        className: (0, $jzAQA.default)([
            $16e8b8a7d33ff93c$var$styles.beforeStyles
        ])
    }, elemBefore), /*#__PURE__*/ $5FkrB.createElement("span", {
        "data-tag-text": true,
        className: (0, $jzAQA.default)([
            $16e8b8a7d33ff93c$var$styles.textStyles
        ])
    }, normalizedText), trailingMetric != null && trailingMetric !== '' && /*#__PURE__*/ $5FkrB.createElement("span", {
        "data-testid": testId && "".concat(testId, "--metric"),
        className: (0, $jzAQA.default)([
            $16e8b8a7d33ff93c$var$styles.trailingMetric
        ])
    }, trailingMetric)), removeButton && /*#__PURE__*/ $5FkrB.createElement("span", {
        className: (0, $jzAQA.default)([
            $16e8b8a7d33ff93c$var$styles.afterStyles
        ])
    }, removeButton));
    return /*#__PURE__*/ $5FkrB.createElement((0, $024f015fe0f4b2f0$export$898a500849bb5cf4), {
        isRemovable: isRemovable,
        status: status,
        onShrinkOutExitComplete: isRemovable ? onShrinkOutExitComplete : undefined
    }, tagContent);
});
var $16e8b8a7d33ff93c$export$aba6bd1190e79361 = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function TagDropdownTrigger(_ref2, ref) {
    var _ref2$color = _ref2.color, color = _ref2$color === void 0 ? 'gray' : _ref2$color, text = _ref2.text, elemBefore = _ref2.elemBefore, testId = _ref2.testId, maxWidth = _ref2.maxWidth, _ref2$hasMargin = _ref2.hasMargin, hasMargin = _ref2$hasMargin === void 0 ? true : _ref2$hasMargin, onClick = _ref2.onClick, _ref2$isSelected = _ref2.isSelected, isSelected = _ref2$isSelected === void 0 ? false : _ref2$isSelected, _ref2$isLoading = _ref2.isLoading, isLoading = _ref2$isLoading === void 0 ? false : _ref2$isLoading, _analyticsContext = _ref2.analyticsContext, _ref2$hasChevron = _ref2.hasChevron, hasChevron = _ref2$hasChevron === void 0 ? true : _ref2$hasChevron, swatchBefore = _ref2.swatchBefore, swatchBeforeLabel = _ref2.swatchBeforeLabel, swatchBeforeRole = _ref2.swatchBeforeRole, trailingMetric = _ref2.trailingMetric, other = (0, $f2ca64756a447eb8$export$2e2bcd8739ae039)(_ref2, $16e8b8a7d33ff93c$var$_excluded2);
    var resolvedColor = (0, $cd44423d3f068162$export$3351a8d90bcc13aa)[color] || 'gray';
    return /*#__PURE__*/ $5FkrB.createElement((0, $c647649c3ca5bb9c$export$27c701ed9e449e99), (0, $4d49c99afafded0a$export$2e2bcd8739ae039)({
        ref: ref,
        xcss: (0, $05505a8f645500ff$export$a274e22fb40f762e)($16e8b8a7d33ff93c$var$styles.baseStyles, !hasMargin && $16e8b8a7d33ff93c$var$styles.noMarginStyles, $16e8b8a7d33ff93c$var$colorStyles[resolvedColor], $16e8b8a7d33ff93c$var$borderIconFilterStyles.root, $16e8b8a7d33ff93c$var$dropdownStyles.interactive, $16e8b8a7d33ff93c$var$styles.focusRingStyles, $16e8b8a7d33ff93c$var$borderIconInteractiveFilterStyles.root, isSelected && $16e8b8a7d33ff93c$var$dropdownStyles.selected, // Reduce end padding when trailing metric is the last element (no chevron)
        !hasChevron && trailingMetric != null && trailingMetric !== '' && $16e8b8a7d33ff93c$var$styles.trailingMetricEndPadding),
        onClick: isLoading ? undefined : onClick,
        style: {
            borderColor: isSelected ? "var(--ds-border-selected, #1868DB)" : undefined,
            cursor: isLoading ? 'progress' : 'pointer',
            maxWidth: maxWidth !== undefined ? maxWidth : undefined
        }
    }, isLoading && {
        'aria-busy': true,
        'aria-disabled': true,
        isDisabled: true
    }, {
        testId: testId
    }, other), /*#__PURE__*/ $5FkrB.createElement("span", {
        className: (0, $jzAQA.default)([
            $16e8b8a7d33ff93c$var$dropdownStyles.content,
            isLoading && $16e8b8a7d33ff93c$var$dropdownStyles.loadingContent
        ])
    }, /*#__PURE__*/ $5FkrB.createElement((0, $ca88d72440d2ac25$export$2e2bcd8739ae039), (0, $4d49c99afafded0a$export$2e2bcd8739ae039)({
        colorKey: resolvedColor,
        swatchBefore: swatchBefore
    }, (0, $92e43753483f870e$export$b40ec24ac8275656)('parent-field-switcher-missing-info-image-text') ? {
        swatchBeforeLabel: swatchBeforeLabel,
        swatchBeforeRole: swatchBeforeRole
    } : {})), elemBefore && /*#__PURE__*/ $5FkrB.createElement("span", {
        className: (0, $jzAQA.default)([
            $16e8b8a7d33ff93c$var$styles.beforeStyles,
            isSelected && $16e8b8a7d33ff93c$var$styles.beforeStylesSelected
        ])
    }, elemBefore), /*#__PURE__*/ $5FkrB.createElement("span", {
        "data-tag-text": true,
        className: (0, $jzAQA.default)([
            $16e8b8a7d33ff93c$var$styles.textStyles,
            isSelected && $16e8b8a7d33ff93c$var$styles.textStylesSelected
        ])
    }, (0, $bc9497266815a6b3$export$7d100de1166870f6)(text)), trailingMetric != null && trailingMetric !== '' && /*#__PURE__*/ $5FkrB.createElement("span", {
        "data-testid": testId && "".concat(testId, "--metric"),
        className: (0, $jzAQA.default)([
            $16e8b8a7d33ff93c$var$styles.trailingMetric
        ])
    }, trailingMetric), hasChevron && /*#__PURE__*/ $5FkrB.createElement((0, (/*@__PURE__*/$parcel$interopDefault($b465753bb15ee4c1$exports))), {
        label: "",
        size: "small",
        color: 'currentColor',
        testId: testId && "".concat(testId, "--chevron")
    })), isLoading && /*#__PURE__*/ $5FkrB.createElement("span", {
        className: (0, $jzAQA.default)([
            $16e8b8a7d33ff93c$var$dropdownStyles.loadingOverlay
        ])
    }, /*#__PURE__*/ $5FkrB.createElement((0, $8be4a5516f741779$export$2e2bcd8739ae039), {
        size: 'xsmall',
        label: ", Loading",
        testId: testId ? "".concat(testId, "--loading-spinner") : undefined
    })));
});
/**
 * __Tag new__
 */ var $16e8b8a7d33ff93c$var$TagNew = /*#__PURE__*/ (0, $5FkrB.memo)($16e8b8a7d33ff93c$var$TagNewComponent);
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$16e8b8a7d33ff93c$export$2e2bcd8739ae039 = $16e8b8a7d33ff93c$var$TagNew;


/* base.tsx generated by @compiled/babel-plugin v2.0.0 */ 



var $jzAQA = parcelRequire("jzAQA");

var $5FkrB = parcelRequire("5FkrB");
var $9fd2ecaefbff0e86$var$_excluded = [
    "before",
    "contentElement",
    "after",
    "testId",
    "style",
    "color",
    "href",
    "className"
];
function $9fd2ecaefbff0e86$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $9fd2ecaefbff0e86$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $9fd2ecaefbff0e86$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $34bcf16a63c65c03$export$2e2bcd8739ae039)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $9fd2ecaefbff0e86$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
// Border colors - Hardcoded for Visual Refresh - to be removed with labelling system work
var $9fd2ecaefbff0e86$var$borderColors = {
    standard: "_1h6d14je",
    blue: "_1h6duisw",
    red: "_1h6da2c0",
    yellow: "_1h6deh2r",
    green: "_1h6d18uw",
    teal: "_1h6d1ug6",
    purple: "_1h6d157s",
    lime: "_1h6dn0nx",
    magenta: "_1h6d1lf6",
    orange: "_1h6dh727",
    grey: "_1h6d14je",
    standardLink: "_1h6d14je",
    blueLight: "_1h6duisw",
    redLight: "_1h6da2c0",
    yellowLight: "_1h6deh2r",
    greenLight: "_1h6d18uw",
    tealLight: "_1h6d1ug6",
    purpleLight: "_1h6d157s",
    limeLight: "_1h6dn0nx",
    magentaLight: "_1h6d1lf6",
    orangeLight: "_1h6dh727",
    greyLight: "_1h6d14je"
};
var $9fd2ecaefbff0e86$var$baseStyles = null;
var $9fd2ecaefbff0e86$var$interactiveStyles = null;
var $9fd2ecaefbff0e86$var$focusRingStyles = null;
var $9fd2ecaefbff0e86$var$BaseTag = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).forwardRef(function BaseTag(_ref, ref) {
    var before = _ref.before, contentElement = _ref.contentElement, after = _ref.after, testId = _ref.testId, style = _ref.style, _ref$color = _ref.color, color = _ref$color === void 0 ? 'standard' : _ref$color, href = _ref.href, className = _ref.className, other = (0, $f2ca64756a447eb8$export$2e2bcd8739ae039)(_ref, $9fd2ecaefbff0e86$var$_excluded);
    var isLink = Boolean(href);
    var isRemovable = Boolean(after);
    var isInteractive = isLink || isRemovable;
    if (color === 'gray') // internally we use 'grey' for gray color so that we can make migration easier behind the ff (gray will work with and without ff now)
    color = 'grey';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("span", (0, $4d49c99afafded0a$export$2e2bcd8739ae039)({}, other, {
        ref: ref,
        style: $9fd2ecaefbff0e86$var$_objectSpread({}, style),
        className: (0, $jzAQA.default)([
            "_zulp1b66 _2rko12b0 _1dqonqa1 _189ee4h9 _1mou1b66 _195g1b66 _18zr1b66 _1e0c116y _vchhusvi _1ul9idpf _4t3i1k92 _kqswh2mm _4cvr1h6o _bfhksm61 _syazi7uo _80om73ad",
            isInteractive && "_1e38dfik _7glxv77o",
            isLink && "_irr31dpa _1di6fcek",
            $9fd2ecaefbff0e86$var$borderColors[color],
            className
        ]),
        "data-testid": testId
    }), before, contentElement, after);
});
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$9fd2ecaefbff0e86$export$2e2bcd8739ae039 = $9fd2ecaefbff0e86$var$BaseTag;


/* before.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $5FkrB = parcelRequire("5FkrB");

var $jzAQA = parcelRequire("jzAQA");
var $e58861bcba118e44$var$beforeElementStyles = null;
var $e58861bcba118e44$var$Before = function Before(_ref) {
    var elemBefore = _ref.elemBefore;
    return elemBefore ? /*#__PURE__*/ $5FkrB.createElement("span", {
        className: (0, $jzAQA.default)([
            "_1e0c1txw _4t3i1j6v _4cvr1h6o _1bah1h6o _152tze3t"
        ])
    }, elemBefore) : null;
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$e58861bcba118e44$export$2e2bcd8739ae039 = $e58861bcba118e44$var$Before;


/**
 * Maps Tag color values to Lozenge appearance values.
 * Used for migration_fallback rendering when feature flag is off.
 */ var $a29acea54d1807e2$var$colorToLozengeAppearanceMap = {
    gray: 'default',
    grey: 'default',
    lime: 'success',
    green: 'success',
    blue: 'inprogress',
    red: 'removed',
    purple: 'new',
    yellow: 'moved',
    orange: 'moved',
    magenta: 'new',
    teal: 'inprogress',
    grayLight: 'default',
    greyLight: 'default',
    limeLight: 'success',
    greenLight: 'success',
    blueLight: 'inprogress',
    redLight: 'removed',
    purpleLight: 'new',
    yellowLight: 'moved',
    orangeLight: 'moved',
    magentaLight: 'new',
    tealLight: 'inprogress'
};
function $a29acea54d1807e2$export$4d9e331cafeacb9d(color) {
    return $a29acea54d1807e2$var$colorToLozengeAppearanceMap[color || 'gray'] || 'default';
}


/* content.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $5FkrB = parcelRequire("5FkrB");

var $jzAQA = parcelRequire("jzAQA");

var $533e426ee598fc71$var$baseStyles = null;
var $533e426ee598fc71$var$linkStyles = null;
var $533e426ee598fc71$var$hasAfterStyles = null;
var $533e426ee598fc71$var$Content = function Content(_ref) {
    var _ref$isRemovable = _ref.isRemovable, isRemovable = _ref$isRemovable === void 0 ? true : _ref$isRemovable, _ref$text = _ref.text, text = _ref$text === void 0 ? '' : _ref$text, _ref$color = _ref.color, color = _ref$color === void 0 ? 'standard' : _ref$color, href = _ref.href, linkComponent = _ref.linkComponent, testId = _ref.testId;
    var Link = linkComponent !== null && linkComponent !== void 0 ? linkComponent : 'a';
    var normalizedText = (0, $bc9497266815a6b3$export$7d100de1166870f6)(text);
    if (href) return /*#__PURE__*/ $5FkrB.createElement(Link, {
        href: href,
        "data-color": color,
        "data-testid": testId ? "".concat(testId, "--link") : undefined,
        className: (0, $jzAQA.default)([
            "_11c8fhey _1reo15vq _18m915vq _p12ff6dh _1bto1l2s _o5721q9c",
            "_4bfu1r31 _1hmsglyw _ajmmnqa1 _syazi7uo _lcxv1wug _nt751r31 _49pcglyw _1hvw1o36 _9oik1r31 _1bnx8stv _jf4cnqa1 _30l3i7uo _1nrm1r31 _c2wa8stv _1iohnqa1 _9h8hi7uo",
            isRemovable && "_p12f1lit"
        ])
    }, normalizedText);
    else return /*#__PURE__*/ $5FkrB.createElement("span", {
        className: (0, $jzAQA.default)([
            "_11c8fhey _1reo15vq _18m915vq _p12ff6dh _1bto1l2s _o5721q9c",
            isRemovable && "_p12f1lit"
        ])
    }, normalizedText);
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$533e426ee598fc71$export$2e2bcd8739ae039 = $533e426ee598fc71$var$Content;



var $18d2b661453c9380$var$_excluded = [
    "appearance",
    "elemBefore",
    "isRemovable",
    "text",
    "color",
    "href",
    "removeButtonLabel",
    "testId",
    "onBeforeRemoveAction",
    "onAfterRemoveAction",
    "linkComponent",
    "migration_fallback",
    "maxWidth",
    "hasMargin",
    "swatchBefore",
    "swatchBeforeLabel",
    "swatchBeforeRole"
];
var $18d2b661453c9380$var$textLinkCssVar = '--ds-ctl';
var $18d2b661453c9380$var$textDefaultCssVar = '--ds-ct';
var $18d2b661453c9380$var$textActiveCssVar = '--ds-ctp';
var $18d2b661453c9380$var$backgroundHoverCssVar = '--ds-cbh';
var $18d2b661453c9380$var$backgroundActiveCssVar = '--ds-cba';
var $18d2b661453c9380$var$TagStatus = /*#__PURE__*/ function(TagStatus) {
    TagStatus["Showing"] = "showing";
    TagStatus["Removing"] = "removing";
    TagStatus["Removed"] = "removed";
    return TagStatus;
}($18d2b661453c9380$var$TagStatus || {});
var $18d2b661453c9380$var$packageName = "@atlaskit/tag";
var $18d2b661453c9380$var$packageVersion = "15.4.3";
var $18d2b661453c9380$var$defaultBeforeRemoveAction = function defaultBeforeRemoveAction() {
    return true;
};
/**
 * These hide the focus ring for the tag when its remove button is focused,
 * preventing a double focus ring.
 */ var $18d2b661453c9380$var$removingStyles = null;
var $18d2b661453c9380$var$RemovableTagComponent = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function(_ref, ref) {
    var appearance = _ref.appearance, _ref$elemBefore = _ref.elemBefore, elemBefore = _ref$elemBefore === void 0 ? null : _ref$elemBefore, _ref$isRemovable = _ref.isRemovable, isRemovable = _ref$isRemovable === void 0 ? true : _ref$isRemovable, _ref$text = _ref.text, text = _ref$text === void 0 ? '' : _ref$text, _ref$color = _ref.color, color = _ref$color === void 0 ? 'standard' : _ref$color, href = _ref.href, removeButtonLabel = _ref.removeButtonLabel, testId = _ref.testId, _ref$onBeforeRemoveAc = _ref.onBeforeRemoveAction, onBeforeRemoveAction = _ref$onBeforeRemoveAc === void 0 ? $18d2b661453c9380$var$defaultBeforeRemoveAction : _ref$onBeforeRemoveAc, _ref$onAfterRemoveAct = _ref.onAfterRemoveAction, onAfterRemoveAction = _ref$onAfterRemoveAct === void 0 ? (0, $adcefb868cf2fc9d$export$2e2bcd8739ae039) : _ref$onAfterRemoveAct, linkComponent = _ref.linkComponent, migration_fallback = _ref.migration_fallback, maxWidth = _ref.maxWidth, _ref$hasMargin = _ref.hasMargin, hasMargin = _ref$hasMargin === void 0 ? true : _ref$hasMargin, swatchBefore = _ref.swatchBefore, swatchBeforeLabel = _ref.swatchBeforeLabel, swatchBeforeRole = _ref.swatchBeforeRole, rest = (0, $f2ca64756a447eb8$export$2e2bcd8739ae039)(_ref, $18d2b661453c9380$var$_excluded);
    var _useState = (0, $5FkrB.useState)($18d2b661453c9380$var$TagStatus.Showing), _useState2 = (0, $1dc579c4de1142c2$export$2e2bcd8739ae039)(_useState, 2), status = _useState2[0], setStatus = _useState2[1];
    var _useState3 = (0, $5FkrB.useState)(false), _useState4 = (0, $1dc579c4de1142c2$export$2e2bcd8739ae039)(_useState3, 2), isHoverCloseButton = _useState4[0], setIsHoverCloseButton = _useState4[1];
    var normalizedText = (0, $bc9497266815a6b3$export$7d100de1166870f6)(text);
    var onAfterRemoveActionWithAnalytics = (0, $7c1856e1f951263e$export$53c2b9c37c40e0d8)(onAfterRemoveAction, {
        action: 'removed',
        actionSubject: 'tag',
        attributes: {
            componentName: 'tag',
            packageName: $18d2b661453c9380$var$packageName,
            packageVersion: $18d2b661453c9380$var$packageVersion
        }
    }, 'atlaskit');
    var handleRemoveComplete = (0, $5FkrB.useCallback)(function() {
        setStatus($18d2b661453c9380$var$TagStatus.Removed);
    }, []);
    var handleRemoveRequest = (0, $5FkrB.useCallback)(function() {
        if (onBeforeRemoveAction && onBeforeRemoveAction()) {
            onAfterRemoveActionWithAnalytics(normalizedText);
            handleRemoveComplete();
        }
    }, [
        handleRemoveComplete,
        normalizedText,
        onBeforeRemoveAction,
        onAfterRemoveActionWithAnalytics
    ]);
    var onKeyPress = (0, $5FkrB.useCallback)(function(e) {
        var spacebarOrEnter = e.key === ' ' || e.key === 'Enter';
        if (spacebarOrEnter) {
            e.stopPropagation();
            handleRemoveRequest();
        }
    }, [
        handleRemoveRequest
    ]);
    var removingTag = (0, $5FkrB.useCallback)(function() {
        return setStatus($18d2b661453c9380$var$TagStatus.Removing);
    }, []);
    var showingTag = (0, $5FkrB.useCallback)(function() {
        return setStatus($18d2b661453c9380$var$TagStatus.Showing);
    }, []);
    var handleMouseOver = (0, $5FkrB.useCallback)(function() {
        return setIsHoverCloseButton(true);
    }, []);
    var handleMouseOut = (0, $5FkrB.useCallback)(function() {
        return setIsHoverCloseButton(false);
    }, []);
    var removeButton = isRemovable ? /*#__PURE__*/ $5FkrB.createElement((0, $44c2b79ffdcb7cdd$export$2e2bcd8739ae039), {
        "aria-label": "".concat(removeButtonLabel || 'Remove', " ").concat(normalizedText),
        onClick: handleRemoveRequest,
        onFocus: removingTag,
        onBlur: showingTag,
        onKeyPress: onKeyPress,
        onMouseOver: handleMouseOver,
        onMouseOut: handleMouseOut,
        testId: "close-button-".concat(testId)
    }) : undefined;
    // Handle migration_fallback: render Lozenge when flag is off and migration_fallback is 'lozenge'
    if (migration_fallback === 'lozenge' && !(0, $92e43753483f870e$export$b40ec24ac8275656)('platform-dst-lozenge-tag-badge-visual-uplifts')) {
        var lozengeAppearance = (0, $a29acea54d1807e2$export$4d9e331cafeacb9d)(color);
        return /*#__PURE__*/ $5FkrB.createElement((0, $9bc31c28cfd17976$export$2e2bcd8739ae039), (0, $4d49c99afafded0a$export$2e2bcd8739ae039)({
            appearance: lozengeAppearance,
            isBold: false,
            testId: testId
        }, rest), normalizedText);
    }
    // Use new TagNew component behind feature flag
    // TagNew handles its own animation internally via RemovableWrapper
    if ((0, $92e43753483f870e$export$b40ec24ac8275656)('platform-dst-lozenge-tag-badge-visual-uplifts')) {
        var newColor = (0, $cd44423d3f068162$export$3351a8d90bcc13aa)[color || 'standard'];
        return /*#__PURE__*/ $5FkrB.createElement((0, $16e8b8a7d33ff93c$export$2e2bcd8739ae039), (0, $4d49c99afafded0a$export$2e2bcd8739ae039)({
            ref: ref,
            color: newColor,
            text: normalizedText,
            elemBefore: elemBefore,
            href: href,
            testId: testId,
            isRemovable: isRemovable,
            removeButtonLabel: removeButtonLabel,
            onBeforeRemoveAction: onBeforeRemoveAction,
            onAfterRemoveAction: onAfterRemoveActionWithAnalytics,
            maxWidth: maxWidth,
            hasMargin: hasMargin,
            swatchBefore: swatchBefore
        }, (0, $92e43753483f870e$export$b40ec24ac8275656)('parent-field-switcher-missing-info-image-text') ? {
            swatchBeforeLabel: swatchBeforeLabel,
            swatchBeforeRole: swatchBeforeRole
        } : {}));
    }
    // Original implementation
    var content = /*#__PURE__*/ $5FkrB.createElement((0, $533e426ee598fc71$export$2e2bcd8739ae039), {
        elemBefore: elemBefore,
        isRemovable: isRemovable,
        text: normalizedText,
        color: color,
        href: href,
        linkComponent: linkComponent,
        testId: testId
    });
    var hoverCloseButtonColors = (0, $34bcf16a63c65c03$export$2e2bcd8739ae039)((0, $34bcf16a63c65c03$export$2e2bcd8739ae039)((0, $34bcf16a63c65c03$export$2e2bcd8739ae039)((0, $34bcf16a63c65c03$export$2e2bcd8739ae039)((0, $34bcf16a63c65c03$export$2e2bcd8739ae039)({
        backgroundColor: "var(--ds-background-neutral-subtle, #00000000)"
    }, $18d2b661453c9380$var$backgroundHoverCssVar, undefined), $18d2b661453c9380$var$backgroundActiveCssVar, undefined), $18d2b661453c9380$var$textDefaultCssVar, undefined), $18d2b661453c9380$var$textActiveCssVar, undefined), $18d2b661453c9380$var$textLinkCssVar, undefined);
    return /*#__PURE__*/ $5FkrB.createElement((0, $cf7e1a3a3ae7d555$export$2e2bcd8739ae039), null, !(status === $18d2b661453c9380$var$TagStatus.Removed) && /*#__PURE__*/ $5FkrB.createElement((0, $e8a62e6c3439959e$export$2e2bcd8739ae039), {
        key: "atlaskit-removable-tag-legacy-shrink-out",
        onFinish: handleRemoveComplete
    }, function(motion) {
        return /*#__PURE__*/ $5FkrB.createElement((0, $9fd2ecaefbff0e86$export$2e2bcd8739ae039), {
            ref: (0, $db13a2f91f6a0f56$export$2e2bcd8739ae039)([
                motion.ref,
                ref
            ]),
            appearance: appearance,
            color: color,
            testId: testId,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            style: isHoverCloseButton ? hoverCloseButtonColors : undefined,
            "data-removable": true,
            "data-removing": status === $18d2b661453c9380$var$TagStatus.Removing,
            "data-ishoverclosebutton": isHoverCloseButton,
            href: href,
            before: /*#__PURE__*/ $5FkrB.createElement((0, $e58861bcba118e44$export$2e2bcd8739ae039), {
                elemBefore: elemBefore
            }),
            contentElement: content,
            after: removeButton,
            className: (0, $jzAQA.default)([
                status === $18d2b661453c9380$var$TagStatus.Removing && "_z30c1r31 _twwiglyw _1pka1o36 _bqhtfiwo"
            ])
        });
    }));
});
/**
 * __Removable tag__
 *
 * A tag labels UI objects for quick recognition and navigation.
 *
 * Once a tag has been removed, it cannot be re-rendered. Removable tags are visible in "edit" mode or in multi-select controls.
 *
 */ var $18d2b661453c9380$var$RemovableTag = /*#__PURE__*/ (0, $5FkrB.memo)($18d2b661453c9380$var$RemovableTagComponent);
var $18d2b661453c9380$export$2e2bcd8739ae039 = $18d2b661453c9380$var$RemovableTag;



/**
 * Hook to consume the SelectGetStylesContext.
 *
 * @internal — not part of the public API
 */ 
var $5FkrB = parcelRequire("5FkrB");
/**
 * Internal context used to pass the original Select instance's getStyles function
 * down to components like MultiValue, without polluting the public CommonProps API.
 *
 * This allows MultiValue to detect whether getStyles has been overridden on a
 * component instance (e.g. via a custom component wrapper passing a different
 * getStyles prop), by comparing props.getStyles against the original.
 *
 * @internal — not part of the public API
 */ 
var $5FkrB = parcelRequire("5FkrB");
var $496cc08df8fb5c0d$export$50727c0a52da4015 = /*#__PURE__*/ (0, $5FkrB.createContext)(undefined);


var $6e69921957e046b4$export$2a533455c10aa11f = function useSelectGetStyles() {
    return (0, $5FkrB.useContext)((0, $496cc08df8fb5c0d$export$50727c0a52da4015));
};



/* multi-value-label.tsx generated by @compiled/babel-plugin v2.0.0 */ 

var $5FkrB = parcelRequire("5FkrB");

var $lqU89 = parcelRequire("lqU89");

var $59f13b48c3dc1f50$var$multiValueLabelStyles = {
    root: "_1reo15vq _18m915vq _2rkolb4i _11c8fhey _o5721q9c _y4tiv77o _bozg1b66 _syaz1kw7",
    disabled: "_syaz1gmx",
    ellipsis: "_1bto1l2s"
};
var $59f13b48c3dc1f50$export$544aeea2a5ce08ee = function MultiValueLabel(_ref) {
    var children = _ref.children, innerProps = _ref.innerProps, isDisabled = _ref.isDisabled, hasEllipsis = _ref.hasEllipsis, className = _ref.className, xcss = _ref.xcss;
    return /*#__PURE__*/ $5FkrB.createElement("div", (0, $e7be1629a1f1b709$export$2e2bcd8739ae039)({}, innerProps, {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $lqU89.default)([
            $59f13b48c3dc1f50$var$multiValueLabelStyles.root,
            isDisabled && $59f13b48c3dc1f50$var$multiValueLabelStyles.disabled,
            hasEllipsis && $59f13b48c3dc1f50$var$multiValueLabelStyles.ellipsis,
            (0, $b2896f4f52b4ee15$export$a274e22fb40f762e)(className, xcss, '-MultiValueLabel')
        ])
    }), children);
};


function $50f4796c7e519f48$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $50f4796c7e519f48$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $50f4796c7e519f48$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $90d31be1abcfa6da$export$2e2bcd8739ae039)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $50f4796c7e519f48$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $50f4796c7e519f48$var$multiValueTagWrapperStyles = {
    root: "_16jlidpf _1o9zkb7n _i0dl1wug _1mouze3t _195gze3t _4cvr1h6o _1e0c1txw _1ul9ze3t _zdxokb7n _v5ynkb7n _13lsf1ug _3pxh1h6o _d0dz1txw _1ouwze3t"
};
// Tag-like color styles
var $50f4796c7e519f48$var$tagLikeColorStyles = {
    gray: "_119bmsup",
    blue: "_119b18hp",
    green: "_119b5d2u",
    red: "_119bn9dc",
    yellow: "_119b1s7j",
    purple: "_119bluwt",
    lime: "_119b1m7d",
    magenta: "_119b132u",
    orange: "_119b1ip5",
    teal: "_119b131p"
};
var $50f4796c7e519f48$var$tagLikeBorderFilterStyles = null;
// Tag-like styles for custom content values (not plain text) when FF is on.
// Mirrors the TagNew component's visual appearance (padding, margins, sizing, colors).
// The container uses tag-like styling while Label/Remove sub-components are preserved
// so custom overrides (e.g. custom aria-labels, rendering objects as data) continue to work.
var $50f4796c7e519f48$var$multiValueTagLikeStyles = {
    root: "_1reo15vq _18m915vq _2rko12b0 _11c8wadc _1dqonqa1 _189ee4h9 _1mouze3t _195gze3t _1e0c116y _vchhusvi _kqswh2mm _4cvr1h6o _1wpz1h6o _1ul9ze3t _1o9zkb7n _p12ff6dh _4t3i1k92 _bfhksm61 _syazi7uo _80om73ad _3yq3glyw",
    labelWrapper: "_16jlkb7n _1o9zkb7n _i0dlf1ug _1reo15vq _18m915vq _11c8wadc _1e0c1txw _4cvr1h6o _1ul9ze3t _1tkeidpf _2a9v1kw7",
    disabled: "_syaz1gmx _bfhki8nm",
    focused: "_syaz6x5g _bfhk1dpa _16qs1xv8 _1aewe4h9 _6up51j28 _1xdnnqa1"
};
var $50f4796c7e519f48$var$getMultiValueLabelText = function getMultiValueLabelText(children, data) {
    if (typeof children === 'string') return children;
    var label = data === null || data === void 0 ? void 0 : data.label;
    return typeof label === 'string' ? label : '';
};
var $50f4796c7e519f48$var$MultiValue = function MultiValue(props) {
    var children = props.children, components = props.components, data = props.data, innerProps = props.innerProps, isDisabled = props.isDisabled, isFocused = props.isFocused, removeProps = props.removeProps, selectProps = props.selectProps, cropWithEllipsis = props.cropWithEllipsis;
    var Container = components.Container, Label = components.Label, Remove = components.Remove;
    var labelText = $50f4796c7e519f48$var$getMultiValueLabelText(children, data);
    var isPlainLabel = typeof children === 'string';
    var ffTagUplifts = (0, $13a186c4459b8c2a$export$b40ec24ac8275656)('platform-dst-lozenge-tag-badge-visual-uplifts');
    var _getStyleProps = (0, $26e98d575ca76ea1$export$26417cabd806a658)(props, 'multiValue', {
        'multi-value': true,
        'multi-value--is-disabled': isDisabled
    }), containerCss = _getStyleProps.css, containerClassName = _getStyleProps.className;
    var _getStyleProps2 = (0, $26e98d575ca76ea1$export$26417cabd806a658)(props, 'multiValueLabel', {
        'multi-value__label': true
    }), labelCss = _getStyleProps2.css, labelClassName = _getStyleProps2.className;
    var _getStyleProps3 = (0, $26e98d575ca76ea1$export$26417cabd806a658)(props, 'multiValueRemove', {
        'multi-value__remove': true
    }), removeCss = _getStyleProps3.css, removeClassName = _getStyleProps3.className;
    var hasCustomLabel = Label !== (0, $59f13b48c3dc1f50$export$544aeea2a5ce08ee);
    var hasCustomContainer = Container !== (0, $62fb3b183d6a5f7d$export$cf9cf2a30a59265c);
    var selectStyles = selectProps.styles;
    var hasCustomMultiValueStyles = Boolean((selectStyles === null || selectStyles === void 0 ? void 0 : selectStyles.multiValue) || (selectStyles === null || selectStyles === void 0 ? void 0 : selectStyles.multiValueLabel) || (selectStyles === null || selectStyles === void 0 ? void 0 : selectStyles.multiValueRemove));
    var selectClassNames = selectProps.classNames;
    var hasCustomMultiValueClassNames = Boolean((selectClassNames === null || selectClassNames === void 0 ? void 0 : selectClassNames.multiValue) || (selectClassNames === null || selectClassNames === void 0 ? void 0 : selectClassNames.multiValueLabel) || (selectClassNames === null || selectClassNames === void 0 ? void 0 : selectClassNames.multiValueRemove));
    // Detect if getStyles was overridden directly on this component instance (e.g. via the
    // components prop wrapper passing a custom getStyles). The context holds the original
    // Select instance's getStyles — a reference inequality means a custom override was passed.
    // When context is absent (e.g. in mocked/test contexts), assume no override.
    var selectGetStyles = (0, $6e69921957e046b4$export$2a533455c10aa11f)();
    var hasOverriddenGetStyles = selectGetStyles !== undefined && props.getStyles !== selectGetStyles;
    var hasCustomContainerStyles = hasCustomMultiValueStyles || hasCustomMultiValueClassNames || hasOverriddenGetStyles;
    if (ffTagUplifts && isPlainLabel && !hasCustomLabel && !hasCustomContainer && !hasCustomContainerStyles) {
        var _ref = data !== null && data !== void 0 ? data : {}, elemBefore = _ref.elemBefore, tagColor = _ref.color;
        return /*#__PURE__*/ $5FkrB.createElement("div", (0, $e7be1629a1f1b709$export$2e2bcd8739ae039)({}, innerProps, {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
            className: (0, $lqU89.default)([
                $50f4796c7e519f48$var$multiValueTagWrapperStyles.root,
                (0, $b2896f4f52b4ee15$export$a274e22fb40f762e)(props.className, containerClassName, props.xcss, '-multiValue')
            ])
        }), /*#__PURE__*/ $5FkrB.createElement((0, $18d2b661453c9380$export$2e2bcd8739ae039), {
            text: labelText,
            isRemovable: !isDisabled,
            removeButtonLabel: "".concat(labelText, ", remove"),
            onBeforeRemoveAction: function onBeforeRemoveAction() {
                var _removeProps$onClick;
                (_removeProps$onClick = removeProps.onClick) === null || _removeProps$onClick === void 0 || _removeProps$onClick.call(removeProps, {});
                return false;
            },
            color: tagColor !== null && tagColor !== void 0 ? tagColor : 'gray',
            elemBefore: elemBefore,
            hasMargin: false
        }));
    }
    // FF on + custom content → tag-like path
    if (ffTagUplifts && !hasCustomContainer) {
        var colorKey = data === null || data === void 0 ? void 0 : data.color;
        return /*#__PURE__*/ $5FkrB.createElement("div", (0, $e7be1629a1f1b709$export$2e2bcd8739ae039)({
            "data-multi-value-tag-like": "true"
        }, innerProps, {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- custom styles.multiValue overrides (e.g. colored borders) must be preserved
            style: containerCss,
            className: (0, $lqU89.default)([
                $50f4796c7e519f48$var$multiValueTagLikeStyles.root,
                $50f4796c7e519f48$var$tagLikeColorStyles.gray,
                colorKey === 'blue' && $50f4796c7e519f48$var$tagLikeColorStyles.blue,
                colorKey === 'green' && $50f4796c7e519f48$var$tagLikeColorStyles.green,
                colorKey === 'red' && $50f4796c7e519f48$var$tagLikeColorStyles.red,
                colorKey === 'yellow' && $50f4796c7e519f48$var$tagLikeColorStyles.yellow,
                colorKey === 'purple' && $50f4796c7e519f48$var$tagLikeColorStyles.purple,
                colorKey === 'lime' && $50f4796c7e519f48$var$tagLikeColorStyles.lime,
                colorKey === 'magenta' && $50f4796c7e519f48$var$tagLikeColorStyles.magenta,
                colorKey === 'orange' && $50f4796c7e519f48$var$tagLikeColorStyles.orange,
                colorKey === 'teal' && $50f4796c7e519f48$var$tagLikeColorStyles.teal,
                "_1h6dip4g",
                isDisabled && $50f4796c7e519f48$var$multiValueTagLikeStyles.disabled,
                isFocused && $50f4796c7e519f48$var$multiValueTagLikeStyles.focused,
                (0, $b2896f4f52b4ee15$export$a274e22fb40f762e)(props.className, containerClassName, props.xcss, '-multiValue')
            ])
        }), /*#__PURE__*/ $5FkrB.createElement("div", {
            className: (0, $lqU89.default)([
                $50f4796c7e519f48$var$multiValueTagLikeStyles.labelWrapper
            ])
        }, /*#__PURE__*/ $5FkrB.createElement(Label, {
            data: data,
            innerProps: {
                style: labelCss,
                className: labelClassName
            },
            className: labelClassName,
            hasEllipsis: cropWithEllipsis || cropWithEllipsis === undefined,
            selectProps: selectProps
        }, children)), /*#__PURE__*/ $5FkrB.createElement(Remove, {
            data: data,
            innerProps: $50f4796c7e519f48$var$_objectSpread({
                style: removeCss,
                className: removeClassName,
                role: 'button',
                tabIndex: -1,
                'aria-label': "".concat(labelText || 'option', ", remove")
            }, removeProps),
            className: removeClassName,
            isDisabled: isDisabled,
            selectProps: selectProps
        }));
    }
    // FF off → default styles
    return /*#__PURE__*/ $5FkrB.createElement(Container, {
        data: data,
        innerProps: $50f4796c7e519f48$var$_objectSpread({
            style: containerCss,
            className: containerClassName
        }, innerProps),
        className: containerClassName,
        isFocused: isFocused,
        isDisabled: isDisabled,
        selectProps: selectProps
    }, /*#__PURE__*/ $5FkrB.createElement(Label, {
        data: data,
        innerProps: {
            style: labelCss,
            className: labelClassName
        },
        className: labelClassName,
        hasEllipsis: cropWithEllipsis || cropWithEllipsis === undefined,
        selectProps: selectProps
    }, children), /*#__PURE__*/ $5FkrB.createElement(Remove, {
        data: data,
        innerProps: $50f4796c7e519f48$var$_objectSpread({
            style: removeCss,
            className: removeClassName,
            role: 'button',
            tabIndex: -1,
            'aria-label': "".concat(labelText || 'option', ", remove")
        }, removeProps),
        className: removeClassName,
        isDisabled: isDisabled,
        selectProps: selectProps
    }));
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$50f4796c7e519f48$export$2e2bcd8739ae039 = $50f4796c7e519f48$var$MultiValue;



/* multi-value-remove.tsx generated by @compiled/babel-plugin v2.0.0 */ 

var $5FkrB = parcelRequire("5FkrB");

var $lqU89 = parcelRequire("lqU89");

var $536d263e3fed36e4$exports = {};
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a6e34d167858ba514f74d5881b8440fc>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty($536d263e3fed36e4$exports, "__esModule", {
    value: true
});
$536d263e3fed36e4$exports.default = void 0;

var $536d263e3fed36e4$var$_react = $536d263e3fed36e4$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $536d263e3fed36e4$var$_baseNew = $536d263e3fed36e4$var$_interopRequireDefault((parcelRequire("ihrNW")));
function $536d263e3fed36e4$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Cross".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Known uses: closing modals, panels, and transient views; removing tags
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $536d263e3fed36e4$var$CrossIcon = (props)=>/*#__PURE__*/ $536d263e3fed36e4$var$_react.default.createElement($536d263e3fed36e4$var$_baseNew.default, Object.assign({
        name: "CrossIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M13.53 3.53 9.06 8l4.47 4.47-1.06 1.06L8 9.06l-4.47 4.47-1.06-1.06L6.94 8 2.47 3.53l1.06-1.06L8 6.94l4.47-4.47z"/>`
    }, props));
$536d263e3fed36e4$var$CrossIcon.displayName = 'CrossIcon';
var $536d263e3fed36e4$var$_default = $536d263e3fed36e4$exports.default = $536d263e3fed36e4$var$CrossIcon;


var $656ef6b892d292e2$var$disabledStyles = null;
var $656ef6b892d292e2$var$enabledStyles = null;
var $656ef6b892d292e2$var$multiValueRemoveStyles = {
    focused: "_bfhkb1q9 _lswu6x5g",
    root: "_19itglyw _2rko12b0 _4cvr1h6o _1bah1h6o _1wpz1h6o _r06hglyw _bfhksm61 _syazi7uo _1e0c1txw _lswui7uo _1q51v77o _y4tiv77o _85i5v77o _bozgv77o _12l2v77o _1ah312gs _irr31dpa _13br1tmw _1di6fcek _i5f81tmw"
};
function $656ef6b892d292e2$export$8e1fd1a40e7a2f4a(_ref) {
    var isDisabled = _ref.isDisabled, isFocused = _ref.isFocused, innerProps = _ref.innerProps, className = _ref.className, xcss = _ref.xcss;
    return /*#__PURE__*/ $5FkrB.createElement("div", (0, $e7be1629a1f1b709$export$2e2bcd8739ae039)({}, innerProps, {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $lqU89.default)([
            $656ef6b892d292e2$var$multiValueRemoveStyles.root,
            isFocused && $656ef6b892d292e2$var$multiValueRemoveStyles.focused,
            (0, $b2896f4f52b4ee15$export$a274e22fb40f762e)(className, xcss, '-MultiValueRemove')
        ])
    }), /*#__PURE__*/ $5FkrB.createElement("div", {
        "data-testid": isDisabled ? 'hide-clear-icon' : 'show-clear-icon',
        className: (0, $lqU89.default)([
            isDisabled && "_1e0cglyw",
            !isDisabled && "_1e0c1kw7"
        ])
    }, /*#__PURE__*/ $5FkrB.createElement((0, (/*@__PURE__*/$parcel$interopDefault($536d263e3fed36e4$exports))), {
        label: "",
        color: "currentColor",
        size: "small"
    })));
}


/* option.tsx generated by @compiled/babel-plugin v2.0.0 */ 

var $5FkrB = parcelRequire("5FkrB");

var $lqU89 = parcelRequire("lqU89");



var $65803d9c6df3aab9$var$optionStyles = {
    root: "_1rjc12x7 _18zrutpp _syazi7uo _80om73ad _1e0c1ule _1wyb1kw7 _1bsb1osq _uiztglyw _18ql1j7p _1di6fcek",
    disabled: "_syaz1gmx _80om13gf _bfhk1j28 _16qsglyw _1di61j28 _112eglyw",
    focused: "_bfhk1dpa _16qs1x9r _112e5u6v",
    selected: "_syaz6x5g _bfhk15s3 _16qs1x9r _1di6nozp _112e5u6v",
    focusedSelected: "_bfhkufnl",
    motion: "_v564hxmd _o7kshxmd _1ggl87vo",
    motionSelected: "_v5641rrn _o7kshxmd"
};
var $65803d9c6df3aab9$var$Option = function Option(props) {
    var children = props.children, isDisabled = props.isDisabled, isFocused = props.isFocused, isSelected = props.isSelected, innerRef = props.innerRef, innerProps = props.innerProps, xcss = props.xcss;
    var _getStyleProps = (0, $26e98d575ca76ea1$export$26417cabd806a658)(props, 'option', {
        option: true,
        'option--is-disabled': isDisabled,
        'option--is-focused': isFocused,
        'option--is-selected': isSelected
    }), css = _getStyleProps.css, className = _getStyleProps.className;
    return /*#__PURE__*/ $5FkrB.createElement("div", (0, $e7be1629a1f1b709$export$2e2bcd8739ae039)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        className: (0, $lqU89.default)([
            $65803d9c6df3aab9$var$optionStyles.root,
            !isDisabled && !isSelected && (0, $13a186c4459b8c2a$export$b40ec24ac8275656)('platform-dst-motion-uplift-list-item') && $65803d9c6df3aab9$var$optionStyles.motion,
            isFocused && $65803d9c6df3aab9$var$optionStyles.focused,
            isSelected && $65803d9c6df3aab9$var$optionStyles.selected,
            isFocused && isSelected && $65803d9c6df3aab9$var$optionStyles.focusedSelected,
            !isDisabled && isSelected && (0, $13a186c4459b8c2a$export$b40ec24ac8275656)('platform-dst-motion-uplift-list-item') && $65803d9c6df3aab9$var$optionStyles.motionSelected,
            isDisabled && $65803d9c6df3aab9$var$optionStyles.disabled,
            (0, $b2896f4f52b4ee15$export$a274e22fb40f762e)(className, xcss, '-option')
        ]),
        ref: innerRef
    }, innerProps, {
        tabIndex: -1
    }), children);
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$65803d9c6df3aab9$export$2e2bcd8739ae039 = $65803d9c6df3aab9$var$Option;


/* placeholder.tsx generated by @compiled/babel-plugin v2.0.0 */ 

var $5FkrB = parcelRequire("5FkrB");

var $lqU89 = parcelRequire("lqU89");


var $5210a15e39bd86fe$var$placeholderStyles = {
    root: "_nd5l1sux _1pfhidpf _12l2v77o _6rthidpf _ahbqv77o _syaz1rpy",
    disabled: "_syaz1gmx"
};
var $5210a15e39bd86fe$var$Placeholder = function Placeholder(props) {
    var children = props.children, innerProps = props.innerProps, isDisabled = props.isDisabled, xcss = props.xcss;
    var _getStyleProps = (0, $26e98d575ca76ea1$export$26417cabd806a658)(props, 'placeholder', {
        placeholder: true
    }), css = _getStyleProps.css, className = _getStyleProps.className;
    return /*#__PURE__*/ $5FkrB.createElement("div", (0, $e7be1629a1f1b709$export$2e2bcd8739ae039)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        className: (0, $lqU89.default)([
            $5210a15e39bd86fe$var$placeholderStyles.root,
            isDisabled && $5210a15e39bd86fe$var$placeholderStyles.disabled,
            (0, $b2896f4f52b4ee15$export$a274e22fb40f762e)(className, xcss, '-placeholder')
        ])
    }, innerProps), children);
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$5210a15e39bd86fe$export$2e2bcd8739ae039 = $5210a15e39bd86fe$var$Placeholder;


/* single-value.tsx generated by @compiled/babel-plugin v2.0.0 */ 

var $5FkrB = parcelRequire("5FkrB");

var $lqU89 = parcelRequire("lqU89");


var $053570820ab9911f$var$styles = {
    root: "_nd5l1sux _1reo15vq _18m915vq _p12f1osq _1bto1l2s _o5721q9c _1pfhidpf _12l2v77o _6rthidpf _ahbqv77o _syazi7uo",
    disalbed: "_syaz1gmx"
};
var $053570820ab9911f$var$SingleValue = function SingleValue(props) {
    var children = props.children, isDisabled = props.isDisabled, innerProps = props.innerProps, xcss = props.xcss;
    var _getStyleProps = (0, $26e98d575ca76ea1$export$26417cabd806a658)(props, 'singleValue', {
        'single-value': true,
        'single-value--is-disabled': isDisabled
    }), css = _getStyleProps.css, className = _getStyleProps.className;
    return /*#__PURE__*/ $5FkrB.createElement("div", (0, $e7be1629a1f1b709$export$2e2bcd8739ae039)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        className: (0, $lqU89.default)([
            $053570820ab9911f$var$styles.root,
            isDisabled && $053570820ab9911f$var$styles.disalbed,
            (0, $b2896f4f52b4ee15$export$a274e22fb40f762e)(className, xcss, '-singleValue')
        ])
    }, innerProps), children);
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$053570820ab9911f$export$2e2bcd8739ae039 = $053570820ab9911f$var$SingleValue;


function $525be6c0d6b9e93b$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $525be6c0d6b9e93b$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $525be6c0d6b9e93b$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $90d31be1abcfa6da$export$2e2bcd8739ae039)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $525be6c0d6b9e93b$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $525be6c0d6b9e93b$export$9b5ac10f59f76296 = {
    ClearIndicator: (0, $4910bfbc75b7ff81$export$ecf9cf59142dd54a),
    Control: (0, $dd4924b13f7e0512$export$2e2bcd8739ae039),
    DropdownIndicator: (0, $d16ec2087ba58c24$export$ec98719d3db7f2e4),
    Group: (0, $142ec2fb4414ebd5$export$2e2bcd8739ae039),
    GroupHeading: (0, $9f4c62aed19cfe1f$export$85c8b41a3cd87edc),
    IndicatorsContainer: (0, $c45e5b939479a9d0$export$d0ffd7e649cab6f),
    Input: (0, $462391cdd34a9afc$export$2e2bcd8739ae039),
    LoadingIndicator: (0, $02d2dc1655b5d537$export$7c20be4c1d342248),
    Menu: (0, $7942bdc462d2e339$export$2e2bcd8739ae039),
    MenuList: (0, $02bb287a22d86cb8$export$d4c4e98c5044dc8),
    MenuPortal: (0, $0a5b922338432e73$export$793392f970497feb),
    LoadingMessage: (0, $4afd2f3626226126$export$e928a71d039d3102),
    NoOptionsMessage: (0, $0a1c7e0a907c8dc7$export$d58b72b7d3c4072c),
    MultiValue: (0, $50f4796c7e519f48$export$2e2bcd8739ae039),
    MultiValueContainer: (0, $62fb3b183d6a5f7d$export$cf9cf2a30a59265c),
    MultiValueLabel: (0, $59f13b48c3dc1f50$export$544aeea2a5ce08ee),
    MultiValueRemove: (0, $656ef6b892d292e2$export$8e1fd1a40e7a2f4a),
    Option: (0, $65803d9c6df3aab9$export$2e2bcd8739ae039),
    Placeholder: (0, $5210a15e39bd86fe$export$2e2bcd8739ae039),
    SelectContainer: (0, $9b0e2f2bf4cd39a6$export$446eebadefe1123b),
    SingleValue: (0, $053570820ab9911f$export$2e2bcd8739ae039),
    ValueContainer: (0, $6aa51e2d4ac8184c$export$4dc9f58ad9a1a000)
};
var $525be6c0d6b9e93b$export$71abc632aa29e6fe = function defaultComponents(props) {
    return $525be6c0d6b9e93b$var$_objectSpread($525be6c0d6b9e93b$var$_objectSpread({}, $525be6c0d6b9e93b$export$9b5ac10f59f76296), props.components);
};


/* dummy-input.tsx generated by @compiled/babel-plugin v2.0.0 */ 



var $5FkrB = parcelRequire("5FkrB");

var $lqU89 = parcelRequire("lqU89");
var $d5158de0056cce59$var$_excluded = [
    "innerRef"
];
var $d5158de0056cce59$var$removeProps = function removeProps(propsObj) {
    for(var _len = arguments.length, properties = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)properties[_key - 1] = arguments[_key];
    var propsMap = Object.entries(propsObj).filter(function(_ref) {
        var _ref2 = (0, $c99af517edc48a31$export$2e2bcd8739ae039)(_ref, 1), key = _ref2[0];
        return !properties.includes(key);
    });
    return propsMap.reduce(function(newProps, _ref3) {
        var _ref4 = (0, $c99af517edc48a31$export$2e2bcd8739ae039)(_ref3, 2), key = _ref4[0], val = _ref4[1];
        newProps[key] = val;
        return newProps;
    }, {});
};
var $d5158de0056cce59$var$dummyInputStyles = null;
function $d5158de0056cce59$export$2e2bcd8739ae039(_ref5) {
    var innerRef = _ref5.innerRef, props = (0, $9b3d50432d7c2d71$export$2e2bcd8739ae039)(_ref5, $d5158de0056cce59$var$_excluded);
    // Remove animation props not meant for HTML elements
    var filteredProps = $d5158de0056cce59$var$removeProps(props, 'onExited', 'in', 'enter', 'exit', 'appear');
    // eslint-disable-next-line  @atlaskit/ui-styling-standard/no-classname-prop
    return /*#__PURE__*/ $5FkrB.createElement("input", (0, $e7be1629a1f1b709$export$2e2bcd8739ae039)({
        ref: innerRef,
        className: (0, $lqU89.default)([
            "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _11q7idpf _19itidpf _nd5l1sux _12ji1r31 _1qu2glyw _12y3idpf _1bsbt94y _kqswh2mm _1n5d1j28 _syaz1j28 _1e02p1rm _tzy4idpf _t9ec1kuz",
            "-dummyInput"
        ])
    }, filteredProps));
}




var $5FkrB = parcelRequire("5FkrB");
var $e00580ebd68a0e57$export$a7265767c78f9bae = {
    onChange: function onChange(props) {
        var action = props.action, _props$label = props.label, label = _props$label === void 0 ? '' : _props$label, isDisabled = props.isDisabled;
        switch(action){
            case 'deselect-option':
            case 'pop-value':
            case 'remove-value':
                return label.length ? "option ".concat(label, ", deselected") : '';
            case 'clear':
                return 'All selected options have been cleared.';
            case 'select-option':
                return label.length && !isDisabled ? "option ".concat(label, ", selected.") : '';
            default:
                return '';
        }
    },
    onFilter: function onFilter(props) {
        var inputValue = props.inputValue, resultsMessage = props.resultsMessage;
        return inputValue ? "".concat(resultsMessage, " for search term ").concat(inputValue, ".") : '';
    }
};


/* a11y-text.tsx generated by @compiled/babel-plugin v2.0.0 */ 

var $5FkrB = parcelRequire("5FkrB");

var $lqU89 = parcelRequire("lqU89");
// Assistive text to describe visual elements. Hidden for sighted users.
var $b7981c572abd338f$var$styles = null;
var $b7981c572abd338f$var$A11yText = function A11yText(props) {
    return /*#__PURE__*/ $5FkrB.createElement("span", (0, $e7be1629a1f1b709$export$2e2bcd8739ae039)({
        // eslint-disable-next-line  @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $lqU89.default)([
            "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19itidpf _1reo15vq _18m915vq _1bsbt94y _4t3it94y _kqswstnw _1pbydx66 _ogto7mnp _uiztglyw _o5721q9c",
            "-a11yText"
        ])
    }, props));
};
var $b7981c572abd338f$export$2e2bcd8739ae039 = $b7981c572abd338f$var$A11yText;


function $507ef597f8ab37f9$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $507ef597f8ab37f9$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $507ef597f8ab37f9$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $90d31be1abcfa6da$export$2e2bcd8739ae039)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $507ef597f8ab37f9$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
// ==============================
// Root Container
// ==============================
var $507ef597f8ab37f9$var$LiveRegion = function LiveRegion(props) {
    var ariaSelection = props.ariaSelection, focusableOptions = props.focusableOptions, isFocused = props.isFocused, selectValue = props.selectValue, selectProps = props.selectProps, id = props.id;
    var ariaLiveMessages = selectProps.ariaLiveMessages, getOptionLabel = selectProps.getOptionLabel, inputValue = selectProps.inputValue, isOptionDisabled = selectProps.isOptionDisabled, menuIsOpen = selectProps.menuIsOpen, options = selectProps.options, screenReaderStatus = selectProps.screenReaderStatus, isLoading = selectProps.isLoading;
    var ariaLive = selectProps['aria-live'];
    // Update aria live message configuration when prop changes
    var messages = (0, $5FkrB.useMemo)(function() {
        return $507ef597f8ab37f9$var$_objectSpread($507ef597f8ab37f9$var$_objectSpread({}, (0, $e00580ebd68a0e57$export$a7265767c78f9bae)), ariaLiveMessages);
    }, [
        ariaLiveMessages
    ]);
    // Update aria live selected option when prop changes
    var ariaSelected = (0, $5FkrB.useMemo)(function() {
        var message = '';
        if (menuIsOpen) // we don't need to have selected message when the menu is open
        return '';
        if (ariaSelection && messages.onChange) {
            var option = ariaSelection.option, selectedOptions = ariaSelection.options, removedValue = ariaSelection.removedValue, removedValues = ariaSelection.removedValues, value = ariaSelection.value;
            // select-option when !isMulti does not return option so we assume selected option is value
            var asOption = function asOption(val) {
                return !Array.isArray(val) ? val : null;
            };
            // If there is just one item from the action then get its label
            var selected = removedValue || option || asOption(value);
            var label = selected ? getOptionLabel(selected) : '';
            // If there are multiple items from the action then return an array of labels
            var multiSelected = selectedOptions || removedValues || undefined;
            var labels = multiSelected ? multiSelected.map(getOptionLabel) : [];
            if (!label && !labels.length) // return empty string if no labels provided
            return '';
            var onChangeProps = $507ef597f8ab37f9$var$_objectSpread({
                // multiSelected items are usually items that have already been selected
                // or set by the user as a default value so we assume they are not disabled
                isDisabled: selected && isOptionDisabled(selected, selectValue),
                label: label,
                labels: labels
            }, ariaSelection);
            message = messages.onChange(onChangeProps);
        }
        return message;
    }, [
        ariaSelection,
        messages,
        isOptionDisabled,
        selectValue,
        getOptionLabel,
        menuIsOpen
    ]);
    var ariaResults = (0, $5FkrB.useMemo)(function() {
        var resultsMsg = '';
        if (isLoading) resultsMsg = 'Loading. ';
        if (menuIsOpen && options.length && !isLoading && messages.onFilter) {
            var resultsMessage = screenReaderStatus({
                count: focusableOptions.length
            });
            resultsMsg = messages.onFilter({
                inputValue: inputValue,
                resultsMessage: resultsMessage
            });
        }
        if (options && options.length === 0) resultsMsg = 'No options. ';
        return resultsMsg;
    }, [
        focusableOptions,
        inputValue,
        menuIsOpen,
        messages,
        options,
        screenReaderStatus,
        isLoading
    ]);
    var isInitialFocus = (ariaSelection === null || ariaSelection === void 0 ? void 0 : ariaSelection.action) === 'initial-input-focus';
    var ScreenReaderText = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $5FkrB.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("span", {
        id: "aria-selection"
    }, ariaSelected), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("span", {
        id: "aria-results"
    }, ariaResults));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $5FkrB.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $b7981c572abd338f$export$2e2bcd8739ae039), {
        id: id
    }, isInitialFocus && ScreenReaderText), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $b7981c572abd338f$export$2e2bcd8739ae039), {
        "aria-live": ariaLive // Should be undefined by default unless a specific use case requires it
        ,
        role: "status"
    }, isFocused && !isInitialFocus && ScreenReaderText));
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$507ef597f8ab37f9$export$2e2bcd8739ae039 = $507ef597f8ab37f9$var$LiveRegion;





var $5FkrB = parcelRequire("5FkrB");



function $2b7ed2fe38f50ad4$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $2b7ed2fe38f50ad4$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $2b7ed2fe38f50ad4$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $90d31be1abcfa6da$export$2e2bcd8739ae039)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $2b7ed2fe38f50ad4$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $2b7ed2fe38f50ad4$var$noop = (0, $adcefb868cf2fc9d$export$2e2bcd8739ae039);
function $2b7ed2fe38f50ad4$var$getScrollParent(element) {
    var style = getComputedStyle(element);
    var excludeStaticParent = style.position === 'absolute';
    var overflowRx = /(auto|scroll)/;
    if (style.position === 'fixed') return document.documentElement;
    for(var parent = element; parent = parent.parentElement;){
        style = getComputedStyle(parent);
        if (excludeStaticParent && style.position === 'static') continue;
        if (overflowRx.test(style.overflow + style.overflowY + style.overflowX)) return parent;
    }
    return document.documentElement;
}
function $2b7ed2fe38f50ad4$var$isDocumentElement(el) {
    return [
        document.documentElement,
        document.body,
        window
    ].indexOf(el) > -1;
}
function $2b7ed2fe38f50ad4$var$normalizedHeight(el) {
    if ($2b7ed2fe38f50ad4$var$isDocumentElement(el)) return window.innerHeight;
    return el.clientHeight;
}
function $2b7ed2fe38f50ad4$var$scrollTo(el, top) {
    // with a scroll distance, we perform scroll on the element
    if ($2b7ed2fe38f50ad4$var$isDocumentElement(el)) {
        window.scrollTo(0, top);
        return;
    }
    el.scrollTop = top;
}
function $2b7ed2fe38f50ad4$var$easeOutCubic(t, b, c, d) {
    return c * ((t = t / d - 1) * t * t + 1) + b;
}
function $2b7ed2fe38f50ad4$var$getScrollTop(el) {
    if ($2b7ed2fe38f50ad4$var$isDocumentElement(el)) return window.pageYOffset;
    return el.scrollTop;
}
function $2b7ed2fe38f50ad4$var$animatedScrollTo(element, to) {
    var duration = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 200;
    var callback = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : $2b7ed2fe38f50ad4$var$noop;
    var start = $2b7ed2fe38f50ad4$var$getScrollTop(element);
    var change = to - start;
    var increment = 10;
    var currentTime = 0;
    function animateScroll() {
        currentTime += increment;
        var val = $2b7ed2fe38f50ad4$var$easeOutCubic(currentTime, start, change, duration);
        $2b7ed2fe38f50ad4$var$scrollTo(element, val);
        if (currentTime < duration) window.requestAnimationFrame(animateScroll);
        else callback(element);
    }
    animateScroll();
}
function $2b7ed2fe38f50ad4$var$getMenuPlacement(_ref) {
    var preferredMaxHeight = _ref.maxHeight, menuEl = _ref.menuEl, minHeight = _ref.minHeight, preferredPlacement = _ref.placement, shouldScroll = _ref.shouldScroll, isFixedPosition = _ref.isFixedPosition, controlHeight = _ref.controlHeight;
    var scrollParent = $2b7ed2fe38f50ad4$var$getScrollParent(menuEl);
    var defaultState = {
        placement: 'bottom',
        maxHeight: preferredMaxHeight
    };
    // something went wrong, return default state
    if (!menuEl || !menuEl.offsetParent) return defaultState;
    // we can't trust `scrollParent.scrollHeight` --> it may increase when
    // the menu is rendered
    var _scrollParent$getBoun = scrollParent.getBoundingClientRect(), scrollHeight = _scrollParent$getBoun.height;
    var _menuEl$getBoundingCl = menuEl.getBoundingClientRect(), menuBottom = _menuEl$getBoundingCl.bottom, menuHeight = _menuEl$getBoundingCl.height, menuTop = _menuEl$getBoundingCl.top;
    var _menuEl$offsetParent$ = menuEl.offsetParent.getBoundingClientRect(), containerTop = _menuEl$offsetParent$.top;
    var viewHeight = isFixedPosition ? window.innerHeight : $2b7ed2fe38f50ad4$var$normalizedHeight(scrollParent);
    var scrollTop = $2b7ed2fe38f50ad4$var$getScrollTop(scrollParent);
    var menuTopFromParent = menuTop;
    var marginBottom = parseInt(getComputedStyle(menuEl).marginBottom, 10);
    var marginTop = parseInt(getComputedStyle(menuEl).marginTop, 10);
    var viewSpaceAbove = containerTop - marginTop;
    var viewSpaceBelow = viewHeight - menuTopFromParent;
    var scrollSpaceAbove = viewSpaceAbove + scrollTop;
    var scrollSpaceBelow = scrollHeight - scrollTop - menuTopFromParent;
    var scrollDown = menuBottom - viewHeight + scrollTop + marginBottom;
    var scrollUp = scrollTop + menuTop - marginTop;
    var scrollDuration = 160;
    switch(preferredPlacement){
        case 'auto':
        case 'bottom':
            // 1: the menu will fit, do nothing
            if (viewSpaceBelow >= menuHeight) return {
                placement: 'bottom',
                maxHeight: preferredMaxHeight
            };
            // 2: the menu will fit, if scrolled
            if (scrollSpaceBelow >= menuHeight && !isFixedPosition) {
                if (shouldScroll) $2b7ed2fe38f50ad4$var$animatedScrollTo(scrollParent, scrollDown, scrollDuration);
                return {
                    placement: 'bottom',
                    maxHeight: preferredMaxHeight
                };
            }
            // 3: the menu will fit, if constrained
            if (!isFixedPosition && scrollSpaceBelow >= minHeight || isFixedPosition && viewSpaceBelow >= minHeight) {
                if (shouldScroll) $2b7ed2fe38f50ad4$var$animatedScrollTo(scrollParent, scrollDown, scrollDuration);
                // we want to provide as much of the menu as possible to the user,
                // so give them whatever is available below rather than the minHeight.
                var constrainedHeight = isFixedPosition ? viewSpaceBelow - marginBottom : scrollSpaceBelow - marginBottom;
                return {
                    placement: 'bottom',
                    maxHeight: constrainedHeight
                };
            }
            // 4. Forked beviour when there isn't enough space below
            // AUTO: flip the menu, render above
            if (preferredPlacement === 'auto' || isFixedPosition) {
                // may need to be constrained after flipping
                var _constrainedHeight = preferredMaxHeight;
                var spaceAbove = isFixedPosition ? viewSpaceAbove : scrollSpaceAbove;
                if (spaceAbove >= minHeight) _constrainedHeight = Math.min(spaceAbove - marginBottom - controlHeight, preferredMaxHeight);
                return {
                    placement: 'top',
                    maxHeight: _constrainedHeight
                };
            }
            // BOTTOM: allow browser to increase scrollable area and immediately set scroll
            if (preferredPlacement === 'bottom') {
                if (shouldScroll) $2b7ed2fe38f50ad4$var$scrollTo(scrollParent, scrollDown);
                return {
                    placement: 'bottom',
                    maxHeight: preferredMaxHeight
                };
            }
            break;
        case 'top':
            // 1: the menu will fit, do nothing
            if (viewSpaceAbove >= menuHeight) return {
                placement: 'top',
                maxHeight: preferredMaxHeight
            };
            // 2: the menu will fit, if scrolled
            if (scrollSpaceAbove >= menuHeight && !isFixedPosition) {
                if (shouldScroll) $2b7ed2fe38f50ad4$var$animatedScrollTo(scrollParent, scrollUp, scrollDuration);
                return {
                    placement: 'top',
                    maxHeight: preferredMaxHeight
                };
            }
            // 3: the menu will fit, if constrained
            if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) {
                var _constrainedHeight2 = preferredMaxHeight;
                // we want to provide as much of the menu as possible to the user,
                // so give them whatever is available below rather than the minHeight.
                if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) _constrainedHeight2 = isFixedPosition ? viewSpaceAbove - marginTop : scrollSpaceAbove - marginTop;
                if (shouldScroll) $2b7ed2fe38f50ad4$var$animatedScrollTo(scrollParent, scrollUp, scrollDuration);
                return {
                    placement: 'top',
                    maxHeight: _constrainedHeight2
                };
            }
            // 4. not enough space, the browser WILL NOT increase scrollable area when
            // absolutely positioned element rendered above the viewport (only below).
            // Flip the menu, render below
            return {
                placement: 'bottom',
                maxHeight: preferredMaxHeight
            };
        default:
            throw new Error("Invalid placement provided \"".concat(preferredPlacement, "\"."));
    }
    return defaultState;
}
var $2b7ed2fe38f50ad4$var$coercePlacement = function coercePlacement(p) {
    return p === 'auto' ? 'bottom' : p;
};
// NOTE: internal only
// eslint-disable-next-line @repo/internal/react/require-jsdoc
// TODO: Fill in the component {description} and ensure links point to the correct {packageName} location.
// Remove links that the component does not have (such as usage). If there are no links remove them all.
/**
 * __Menu placer__
 *
 * A menu placer {description}.
 *
 * - [Examples](https://atlassian.design/components/{packageName}/examples)
 * - [Code](https://atlassian.design/components/{packageName}/code)
 * - [Usage](https://atlassian.design/components/{packageName}/usage)
 */ var $2b7ed2fe38f50ad4$var$MenuPlacer = function MenuPlacer(props) {
    var children = props.children, minMenuHeight = props.minMenuHeight, maxMenuHeight = props.maxMenuHeight, menuPlacement = props.menuPlacement, menuPosition = props.menuPosition, menuShouldScrollIntoView = props.menuShouldScrollIntoView;
    var _ref2 = (0, $5FkrB.useContext)((0, $8518ee13423a8229$export$e001f626511a0ead)) || {}, setPortalPlacement = _ref2.setPortalPlacement;
    var ref = (0, $5FkrB.useRef)(null);
    var _useState = (0, $5FkrB.useState)(maxMenuHeight), _useState2 = (0, $c99af517edc48a31$export$2e2bcd8739ae039)(_useState, 2), maxHeight = _useState2[0], setMaxHeight = _useState2[1];
    var _useState3 = (0, $5FkrB.useState)(null), _useState4 = (0, $c99af517edc48a31$export$2e2bcd8739ae039)(_useState3, 2), placement = _useState4[0], setPlacement = _useState4[1];
    // The minimum height of the control
    var controlHeight = 38;
    (0, $5FkrB.useLayoutEffect)(function() {
        // When the menu is hosted in the browser top layer, positioning, flipping
        // and viewport-fit are all handled by `@atlaskit/top-layer`. The placer
        // becomes a pass-through that only forwards `maxMenuHeight` as a cap.
        if ((0, $13a186c4459b8c2a$export$b40ec24ac8275656)('platform-dst-top-layer')) return;
        var menuEl = ref.current;
        if (!menuEl) return;
        // DO NOT scroll if position is fixed
        var isFixedPosition = menuPosition === 'fixed';
        var shouldScroll = menuShouldScrollIntoView && !isFixedPosition;
        var state = $2b7ed2fe38f50ad4$var$getMenuPlacement({
            maxHeight: maxMenuHeight,
            menuEl: menuEl,
            minHeight: minMenuHeight,
            placement: menuPlacement,
            shouldScroll: shouldScroll,
            isFixedPosition: isFixedPosition,
            controlHeight: controlHeight
        });
        setMaxHeight(state.maxHeight);
        setPlacement(state.placement);
        setPortalPlacement === null || setPortalPlacement === void 0 || setPortalPlacement(state.placement);
    }, [
        maxMenuHeight,
        menuPlacement,
        menuPosition,
        menuShouldScrollIntoView,
        minMenuHeight,
        setPortalPlacement,
        controlHeight
    ]);
    return children({
        ref: ref,
        placerProps: $2b7ed2fe38f50ad4$var$_objectSpread($2b7ed2fe38f50ad4$var$_objectSpread({}, props), {}, {
            placement: placement || $2b7ed2fe38f50ad4$var$coercePlacement(menuPlacement),
            maxHeight: maxHeight
        })
    });
};
var $2b7ed2fe38f50ad4$export$2e2bcd8739ae039 = $2b7ed2fe38f50ad4$var$MenuPlacer;




var $cvlyC = parcelRequire("cvlyC");
var $523e2d14b121830d$var$diacritics = [
    {
        base: 'A',
        letters: "A\u24B6\uFF21\xC0\xC1\xC2\u1EA6\u1EA4\u1EAA\u1EA8\xC3\u0100\u0102\u1EB0\u1EAE\u1EB4\u1EB2\u0226\u01E0\xC4\u01DE\u1EA2\xC5\u01FA\u01CD\u0200\u0202\u1EA0\u1EAC\u1EB6\u1E00\u0104\u023A\u2C6F"
    },
    {
        base: 'AA',
        letters: "\uA732"
    },
    {
        base: 'AE',
        letters: "\xC6\u01FC\u01E2"
    },
    {
        base: 'AO',
        letters: "\uA734"
    },
    {
        base: 'AU',
        letters: "\uA736"
    },
    {
        base: 'AV',
        letters: "\uA738\uA73A"
    },
    {
        base: 'AY',
        letters: "\uA73C"
    },
    {
        base: 'B',
        letters: "B\u24B7\uFF22\u1E02\u1E04\u1E06\u0243\u0182\u0181"
    },
    {
        base: 'C',
        letters: "C\u24B8\uFF23\u0106\u0108\u010A\u010C\xC7\u1E08\u0187\u023B\uA73E"
    },
    {
        base: 'D',
        letters: "D\u24B9\uFF24\u1E0A\u010E\u1E0C\u1E10\u1E12\u1E0E\u0110\u018B\u018A\u0189\uA779"
    },
    {
        base: 'DZ',
        letters: "\u01F1\u01C4"
    },
    {
        base: 'Dz',
        letters: "\u01F2\u01C5"
    },
    {
        base: 'E',
        letters: "E\u24BA\uFF25\xC8\xC9\xCA\u1EC0\u1EBE\u1EC4\u1EC2\u1EBC\u0112\u1E14\u1E16\u0114\u0116\xCB\u1EBA\u011A\u0204\u0206\u1EB8\u1EC6\u0228\u1E1C\u0118\u1E18\u1E1A\u0190\u018E"
    },
    {
        base: 'F',
        letters: "F\u24BB\uFF26\u1E1E\u0191\uA77B"
    },
    {
        base: 'G',
        letters: "G\u24BC\uFF27\u01F4\u011C\u1E20\u011E\u0120\u01E6\u0122\u01E4\u0193\uA7A0\uA77D\uA77E"
    },
    {
        base: 'H',
        letters: "H\u24BD\uFF28\u0124\u1E22\u1E26\u021E\u1E24\u1E28\u1E2A\u0126\u2C67\u2C75\uA78D"
    },
    {
        base: 'I',
        letters: "I\u24BE\uFF29\xCC\xCD\xCE\u0128\u012A\u012C\u0130\xCF\u1E2E\u1EC8\u01CF\u0208\u020A\u1ECA\u012E\u1E2C\u0197"
    },
    {
        base: 'J',
        letters: "J\u24BF\uFF2A\u0134\u0248"
    },
    {
        base: 'K',
        letters: "K\u24C0\uFF2B\u1E30\u01E8\u1E32\u0136\u1E34\u0198\u2C69\uA740\uA742\uA744\uA7A2"
    },
    {
        base: 'L',
        letters: "L\u24C1\uFF2C\u013F\u0139\u013D\u1E36\u1E38\u013B\u1E3C\u1E3A\u0141\u023D\u2C62\u2C60\uA748\uA746\uA780"
    },
    {
        base: 'LJ',
        letters: "\u01C7"
    },
    {
        base: 'Lj',
        letters: "\u01C8"
    },
    {
        base: 'M',
        letters: "M\u24C2\uFF2D\u1E3E\u1E40\u1E42\u2C6E\u019C"
    },
    {
        base: 'N',
        letters: "N\u24C3\uFF2E\u01F8\u0143\xD1\u1E44\u0147\u1E46\u0145\u1E4A\u1E48\u0220\u019D\uA790\uA7A4"
    },
    {
        base: 'NJ',
        letters: "\u01CA"
    },
    {
        base: 'Nj',
        letters: "\u01CB"
    },
    {
        base: 'O',
        letters: "O\u24C4\uFF2F\xD2\xD3\xD4\u1ED2\u1ED0\u1ED6\u1ED4\xD5\u1E4C\u022C\u1E4E\u014C\u1E50\u1E52\u014E\u022E\u0230\xD6\u022A\u1ECE\u0150\u01D1\u020C\u020E\u01A0\u1EDC\u1EDA\u1EE0\u1EDE\u1EE2\u1ECC\u1ED8\u01EA\u01EC\xD8\u01FE\u0186\u019F\uA74A\uA74C"
    },
    {
        base: 'OI',
        letters: "\u01A2"
    },
    {
        base: 'OO',
        letters: "\uA74E"
    },
    {
        base: 'OU',
        letters: "\u0222"
    },
    {
        base: 'P',
        letters: "P\u24C5\uFF30\u1E54\u1E56\u01A4\u2C63\uA750\uA752\uA754"
    },
    {
        base: 'Q',
        letters: "Q\u24C6\uFF31\uA756\uA758\u024A"
    },
    {
        base: 'R',
        letters: "R\u24C7\uFF32\u0154\u1E58\u0158\u0210\u0212\u1E5A\u1E5C\u0156\u1E5E\u024C\u2C64\uA75A\uA7A6\uA782"
    },
    {
        base: 'S',
        letters: "S\u24C8\uFF33\u1E9E\u015A\u1E64\u015C\u1E60\u0160\u1E66\u1E62\u1E68\u0218\u015E\u2C7E\uA7A8\uA784"
    },
    {
        base: 'T',
        letters: "T\u24C9\uFF34\u1E6A\u0164\u1E6C\u021A\u0162\u1E70\u1E6E\u0166\u01AC\u01AE\u023E\uA786"
    },
    {
        base: 'TZ',
        letters: "\uA728"
    },
    {
        base: 'U',
        letters: "U\u24CA\uFF35\xD9\xDA\xDB\u0168\u1E78\u016A\u1E7A\u016C\xDC\u01DB\u01D7\u01D5\u01D9\u1EE6\u016E\u0170\u01D3\u0214\u0216\u01AF\u1EEA\u1EE8\u1EEE\u1EEC\u1EF0\u1EE4\u1E72\u0172\u1E76\u1E74\u0244"
    },
    {
        base: 'V',
        letters: "V\u24CB\uFF36\u1E7C\u1E7E\u01B2\uA75E\u0245"
    },
    {
        base: 'VY',
        letters: "\uA760"
    },
    {
        base: 'W',
        letters: "W\u24CC\uFF37\u1E80\u1E82\u0174\u1E86\u1E84\u1E88\u2C72"
    },
    {
        base: 'X',
        letters: "X\u24CD\uFF38\u1E8A\u1E8C"
    },
    {
        base: 'Y',
        letters: "Y\u24CE\uFF39\u1EF2\xDD\u0176\u1EF8\u0232\u1E8E\u0178\u1EF6\u1EF4\u01B3\u024E\u1EFE"
    },
    {
        base: 'Z',
        letters: "Z\u24CF\uFF3A\u0179\u1E90\u017B\u017D\u1E92\u1E94\u01B5\u0224\u2C7F\u2C6B\uA762"
    },
    {
        base: 'a',
        letters: "a\u24D0\uFF41\u1E9A\xE0\xE1\xE2\u1EA7\u1EA5\u1EAB\u1EA9\xE3\u0101\u0103\u1EB1\u1EAF\u1EB5\u1EB3\u0227\u01E1\xE4\u01DF\u1EA3\xE5\u01FB\u01CE\u0201\u0203\u1EA1\u1EAD\u1EB7\u1E01\u0105\u2C65\u0250"
    },
    {
        base: 'aa',
        letters: "\uA733"
    },
    {
        base: 'ae',
        letters: "\xE6\u01FD\u01E3"
    },
    {
        base: 'ao',
        letters: "\uA735"
    },
    {
        base: 'au',
        letters: "\uA737"
    },
    {
        base: 'av',
        letters: "\uA739\uA73B"
    },
    {
        base: 'ay',
        letters: "\uA73D"
    },
    {
        base: 'b',
        letters: "b\u24D1\uFF42\u1E03\u1E05\u1E07\u0180\u0183\u0253"
    },
    {
        base: 'c',
        letters: "c\u24D2\uFF43\u0107\u0109\u010B\u010D\xE7\u1E09\u0188\u023C\uA73F\u2184"
    },
    {
        base: 'd',
        letters: "d\u24D3\uFF44\u1E0B\u010F\u1E0D\u1E11\u1E13\u1E0F\u0111\u018C\u0256\u0257\uA77A"
    },
    {
        base: 'dz',
        letters: "\u01F3\u01C6"
    },
    {
        base: 'e',
        letters: "e\u24D4\uFF45\xE8\xE9\xEA\u1EC1\u1EBF\u1EC5\u1EC3\u1EBD\u0113\u1E15\u1E17\u0115\u0117\xEB\u1EBB\u011B\u0205\u0207\u1EB9\u1EC7\u0229\u1E1D\u0119\u1E19\u1E1B\u0247\u025B\u01DD"
    },
    {
        base: 'f',
        letters: "f\u24D5\uFF46\u1E1F\u0192\uA77C"
    },
    {
        base: 'g',
        letters: "g\u24D6\uFF47\u01F5\u011D\u1E21\u011F\u0121\u01E7\u0123\u01E5\u0260\uA7A1\u1D79\uA77F"
    },
    {
        base: 'h',
        letters: "h\u24D7\uFF48\u0125\u1E23\u1E27\u021F\u1E25\u1E29\u1E2B\u1E96\u0127\u2C68\u2C76\u0265"
    },
    {
        base: 'hv',
        letters: "\u0195"
    },
    {
        base: 'i',
        letters: "i\u24D8\uFF49\xEC\xED\xEE\u0129\u012B\u012D\xEF\u1E2F\u1EC9\u01D0\u0209\u020B\u1ECB\u012F\u1E2D\u0268\u0131"
    },
    {
        base: 'j',
        letters: "j\u24D9\uFF4A\u0135\u01F0\u0249"
    },
    {
        base: 'k',
        letters: "k\u24DA\uFF4B\u1E31\u01E9\u1E33\u0137\u1E35\u0199\u2C6A\uA741\uA743\uA745\uA7A3"
    },
    {
        base: 'l',
        letters: "l\u24DB\uFF4C\u0140\u013A\u013E\u1E37\u1E39\u013C\u1E3D\u1E3B\u017F\u0142\u019A\u026B\u2C61\uA749\uA781\uA747"
    },
    {
        base: 'lj',
        letters: "\u01C9"
    },
    {
        base: 'm',
        letters: "m\u24DC\uFF4D\u1E3F\u1E41\u1E43\u0271\u026F"
    },
    {
        base: 'n',
        letters: "n\u24DD\uFF4E\u01F9\u0144\xF1\u1E45\u0148\u1E47\u0146\u1E4B\u1E49\u019E\u0272\u0149\uA791\uA7A5"
    },
    {
        base: 'nj',
        letters: "\u01CC"
    },
    {
        base: 'o',
        letters: "o\u24DE\uFF4F\xF2\xF3\xF4\u1ED3\u1ED1\u1ED7\u1ED5\xF5\u1E4D\u022D\u1E4F\u014D\u1E51\u1E53\u014F\u022F\u0231\xF6\u022B\u1ECF\u0151\u01D2\u020D\u020F\u01A1\u1EDD\u1EDB\u1EE1\u1EDF\u1EE3\u1ECD\u1ED9\u01EB\u01ED\xF8\u01FF\u0254\uA74B\uA74D\u0275"
    },
    {
        base: 'oi',
        letters: "\u01A3"
    },
    {
        base: 'ou',
        letters: "\u0223"
    },
    {
        base: 'oo',
        letters: "\uA74F"
    },
    {
        base: 'p',
        letters: "p\u24DF\uFF50\u1E55\u1E57\u01A5\u1D7D\uA751\uA753\uA755"
    },
    {
        base: 'q',
        letters: "q\u24E0\uFF51\u024B\uA757\uA759"
    },
    {
        base: 'r',
        letters: "r\u24E1\uFF52\u0155\u1E59\u0159\u0211\u0213\u1E5B\u1E5D\u0157\u1E5F\u024D\u027D\uA75B\uA7A7\uA783"
    },
    {
        base: 's',
        letters: "s\u24E2\uFF53\xDF\u015B\u1E65\u015D\u1E61\u0161\u1E67\u1E63\u1E69\u0219\u015F\u023F\uA7A9\uA785\u1E9B"
    },
    {
        base: 't',
        letters: "t\u24E3\uFF54\u1E6B\u1E97\u0165\u1E6D\u021B\u0163\u1E71\u1E6F\u0167\u01AD\u0288\u2C66\uA787"
    },
    {
        base: 'tz',
        letters: "\uA729"
    },
    {
        base: 'u',
        letters: "u\u24E4\uFF55\xF9\xFA\xFB\u0169\u1E79\u016B\u1E7B\u016D\xFC\u01DC\u01D8\u01D6\u01DA\u1EE7\u016F\u0171\u01D4\u0215\u0217\u01B0\u1EEB\u1EE9\u1EEF\u1EED\u1EF1\u1EE5\u1E73\u0173\u1E77\u1E75\u0289"
    },
    {
        base: 'v',
        letters: "v\u24E5\uFF56\u1E7D\u1E7F\u028B\uA75F\u028C"
    },
    {
        base: 'vy',
        letters: "\uA761"
    },
    {
        base: 'w',
        letters: "w\u24E6\uFF57\u1E81\u1E83\u0175\u1E87\u1E85\u1E98\u1E89\u2C73"
    },
    {
        base: 'x',
        letters: "x\u24E7\uFF58\u1E8B\u1E8D"
    },
    {
        base: 'y',
        letters: "y\u24E8\uFF59\u1EF3\xFD\u0177\u1EF9\u0233\u1E8F\xFF\u1EF7\u1E99\u1EF5\u01B4\u024F\u1EFF"
    },
    {
        base: 'z',
        letters: "z\u24E9\uFF5A\u017A\u1E91\u017C\u017E\u1E93\u1E95\u01B6\u0225\u0240\u2C6C\uA763"
    }
];
var $523e2d14b121830d$var$anyDiacritic = new RegExp('[' + $523e2d14b121830d$var$diacritics.map(function(d) {
    return d.letters;
}).join('') + ']', 'g');
var $523e2d14b121830d$var$diacriticToBase = {};
for(var $523e2d14b121830d$var$i = 0; $523e2d14b121830d$var$i < $523e2d14b121830d$var$diacritics.length; $523e2d14b121830d$var$i++){
    var $523e2d14b121830d$var$diacritic = $523e2d14b121830d$var$diacritics[$523e2d14b121830d$var$i];
    for(var $523e2d14b121830d$var$j = 0; $523e2d14b121830d$var$j < $523e2d14b121830d$var$diacritic.letters.length; $523e2d14b121830d$var$j++)$523e2d14b121830d$var$diacriticToBase[$523e2d14b121830d$var$diacritic.letters[$523e2d14b121830d$var$j]] = $523e2d14b121830d$var$diacritic.base;
}
var $523e2d14b121830d$export$b5bee4b27048330b = function stripDiacritics(str) {
    return str.replace($523e2d14b121830d$var$anyDiacritic, function(match) {
        return $523e2d14b121830d$var$diacriticToBase[match];
    });
};


function $91d82f1fba79798f$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $91d82f1fba79798f$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $91d82f1fba79798f$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $90d31be1abcfa6da$export$2e2bcd8739ae039)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $91d82f1fba79798f$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $91d82f1fba79798f$var$memoizedStripDiacriticsForInput = (0, $cvlyC.default)((0, $523e2d14b121830d$export$b5bee4b27048330b));
var $91d82f1fba79798f$var$trimString = function trimString(str) {
    return str.replace(/^\s+|\s+$/g, '');
};
var $91d82f1fba79798f$var$defaultStringify = function defaultStringify(option) {
    return "".concat(option.label, " ").concat(option.value);
};
var $91d82f1fba79798f$export$5d81789ff4aeccdf = function createFilter(config) {
    return function(option, rawInput) {
        if (option.data.__isNew__) return true;
        var _ignoreCase$ignoreAcc = $91d82f1fba79798f$var$_objectSpread({
            ignoreCase: true,
            ignoreAccents: true,
            stringify: $91d82f1fba79798f$var$defaultStringify,
            trim: true,
            matchFrom: 'any'
        }, config), ignoreCase = _ignoreCase$ignoreAcc.ignoreCase, ignoreAccents = _ignoreCase$ignoreAcc.ignoreAccents, stringify = _ignoreCase$ignoreAcc.stringify, trim = _ignoreCase$ignoreAcc.trim, matchFrom = _ignoreCase$ignoreAcc.matchFrom;
        var input = trim ? $91d82f1fba79798f$var$trimString(rawInput) : rawInput;
        var candidate = trim ? $91d82f1fba79798f$var$trimString(stringify(option)) : stringify(option);
        if (ignoreCase) {
            input = input.toLowerCase();
            candidate = candidate.toLowerCase();
        }
        if (ignoreAccents) {
            input = $91d82f1fba79798f$var$memoizedStripDiacriticsForInput(input);
            candidate = (0, $523e2d14b121830d$export$b5bee4b27048330b)(candidate);
        }
        return matchFrom === 'start' ? candidate.substr(0, input.length) === input : candidate.indexOf(input) > -1;
    };
};


/* eslint-disable @repo/internal/fs/filename-pattern-match */ var $3f51b26d3910379c$export$f4da216a6ca54656 = function formatGroupLabel(group) {
    return group.label;
};


/* eslint-disable @repo/internal/fs/filename-pattern-match */ var $256e8ca70d9dc1dd$export$dac6ace3020563ca = function getOptionLabel(option) {
    return option.label;
};


/* eslint-disable @repo/internal/fs/filename-pattern-match */ var $a4ef18a3f2390baf$export$40be908210c5a79c = function getOptionValue(option) {
    return option.value;
};


/**
 * String representation of component state for styling with class names.
 *
 * Expects an array of strings OR a string/object pair:
 * - className(['comp', 'comp-arg', 'comp-arg-2'])
 * @returns 'react-select__comp react-select__comp-arg react-select__comp-arg-2'
 * - className('comp', { some: true, state: false })
 * @returns 'react-select__comp react-select__comp--some'
 */ function $fc5200fe4d6fc1ee$var$applyPrefixToName(prefix, name) {
    if (!name) return prefix;
    else if (name[0] === '-') return prefix + name;
    else return prefix + '__' + name;
}
function $fc5200fe4d6fc1ee$export$ce4ab0c55987d1ff(prefix, state) {
    for(var _len = arguments.length, classNameList = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)classNameList[_key - 2] = arguments[_key];
    var arr = [].concat(classNameList);
    if (state && prefix) {
        for(var key in state)if (state.hasOwnProperty(key) && state[key]) arr.push("".concat($fc5200fe4d6fc1ee$var$applyPrefixToName(prefix, key)));
    }
    return arr.filter(function(i) {
        return i;
    }).map(function(i) {
        return String(i).trim();
    }).join(' ');
}



var $b963148a95603e14$export$33f062f47f21a01 = function cleanValue(value) {
    if (Array.isArray(value)) return value.filter(Boolean);
    if ((0, $08eb341cc44a6255$export$2e2bcd8739ae039)(value) === 'object' && value !== null) return [
        value
    ];
    return [];
};


function $dd90990edcd0cc98$export$d8a62a489b442872(el) {
    return [
        document.documentElement,
        document.body,
        window
    ].indexOf(el) > -1;
}



function $3d49340fe1bc6067$export$d1ca752ec761b95b(multiValue) {
    return multiValue;
}



function $778ea5d5342e6297$export$17baa7c95b6ba1b8(_ref) {
    var isOpen = _ref.isOpen, onClose = _ref.onClose;
    // @ts-ignore - hot-116676
    (0, $1fc181ef4c36ccfd$export$469bb693f11edc7f)({
        isOpen: isOpen,
        onClose: onClose
    });
    return null;
}


/* required-input.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $5FkrB = parcelRequire("5FkrB");

var $lqU89 = parcelRequire("lqU89");

var $49a988bf6ed17514$var$styles = null;
var $49a988bf6ed17514$var$RequiredInput = function RequiredInput(_ref) {
    var name = _ref.name, onFocus = _ref.onFocus;
    return /*#__PURE__*/ $5FkrB.createElement("input", {
        required: true,
        name: name,
        tabIndex: -1,
        "aria-hidden": "true",
        className: (0, $lqU89.default)([
            "_1bsb1osq _kqswstnw _u7coidpf _rjxpidpf _1e02idpf _tzy4idpf _lcxvglyw",
            "-requiredInput"
        ]),
        onFocus: onFocus,
        // Prevent `Switching from uncontrolled to controlled` error
        value: "",
        onChange: (0, $adcefb868cf2fc9d$export$2e2bcd8739ae039)
    });
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$49a988bf6ed17514$export$2e2bcd8739ae039 = $49a988bf6ed17514$var$RequiredInput;



var $5FkrB = parcelRequire("5FkrB");

var $5FkrB = parcelRequire("5FkrB");
// ==============================
// Passive Event Detector
// ==============================

var $b433fecfd9e3c65e$var$noop = (0, $adcefb868cf2fc9d$export$2e2bcd8739ae039);
// https://github.com/rafgraph/detect-it/blob/main/src/index.ts#L19-L36
var $b433fecfd9e3c65e$var$passiveOptionAccessed = false;
var $b433fecfd9e3c65e$var$options = {
    get passive () {
        return $b433fecfd9e3c65e$var$passiveOptionAccessed = true;
    }
};
// check for SSR
var $b433fecfd9e3c65e$var$w = typeof window !== 'undefined' ? window : {};
if ($b433fecfd9e3c65e$var$w.addEventListener && $b433fecfd9e3c65e$var$w.removeEventListener) {
    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
    $b433fecfd9e3c65e$var$w.addEventListener('p', $b433fecfd9e3c65e$var$noop, $b433fecfd9e3c65e$var$options);
    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
    $b433fecfd9e3c65e$var$w.removeEventListener('p', $b433fecfd9e3c65e$var$noop, false);
}
var $b433fecfd9e3c65e$export$b0622a6911dbeaf5 = $b433fecfd9e3c65e$var$passiveOptionAccessed;


var $ca075aead9c3df17$var$cancelScroll = function cancelScroll(event) {
    if (event.cancelable) event.preventDefault();
    event.stopPropagation();
};
function $ca075aead9c3df17$export$2e2bcd8739ae039(_ref) {
    var isEnabled = _ref.isEnabled, onBottomArrive = _ref.onBottomArrive, onBottomLeave = _ref.onBottomLeave, onTopArrive = _ref.onTopArrive, onTopLeave = _ref.onTopLeave;
    var isBottom = (0, $5FkrB.useRef)(false);
    var isTop = (0, $5FkrB.useRef)(false);
    var touchStart = (0, $5FkrB.useRef)(0);
    var scrollTarget = (0, $5FkrB.useRef)(null);
    var handleEventDelta = (0, $5FkrB.useCallback)(function(event, delta) {
        if (scrollTarget.current === null) return;
        var _scrollTarget$current = scrollTarget.current, scrollTop = _scrollTarget$current.scrollTop, scrollHeight = _scrollTarget$current.scrollHeight, clientHeight = _scrollTarget$current.clientHeight;
        var target = scrollTarget.current;
        var isDeltaPositive = delta > 0;
        var availableScroll = scrollHeight - clientHeight - scrollTop;
        var shouldCancelScroll = false;
        // reset bottom/top flags
        if (availableScroll > delta && isBottom.current) {
            if (onBottomLeave) onBottomLeave(event);
            isBottom.current = false;
        }
        if (isDeltaPositive && isTop.current) {
            if (onTopLeave) onTopLeave(event);
            isTop.current = false;
        }
        // bottom limit
        if (isDeltaPositive && delta > availableScroll) {
            if (onBottomArrive && !isBottom.current) onBottomArrive(event);
            target.scrollTop = scrollHeight;
            shouldCancelScroll = true;
            isBottom.current = true;
        // top limit
        } else if (!isDeltaPositive && -delta > scrollTop) {
            if (onTopArrive && !isTop.current) onTopArrive(event);
            target.scrollTop = 0;
            shouldCancelScroll = true;
            isTop.current = true;
        }
        // cancel scroll
        if (shouldCancelScroll) $ca075aead9c3df17$var$cancelScroll(event);
    }, [
        onBottomArrive,
        onBottomLeave,
        onTopArrive,
        onTopLeave
    ]);
    var onWheel = (0, $5FkrB.useCallback)(function(event) {
        handleEventDelta(event, event.deltaY);
    }, [
        handleEventDelta
    ]);
    var onTouchStart = (0, $5FkrB.useCallback)(function(event) {
        // set touch start so we can calculate touchmove delta
        touchStart.current = event.changedTouches[0].clientY;
    }, []);
    var onTouchMove = (0, $5FkrB.useCallback)(function(event) {
        var deltaY = touchStart.current - event.changedTouches[0].clientY;
        handleEventDelta(event, deltaY);
    }, [
        handleEventDelta
    ]);
    var startListening = (0, $5FkrB.useCallback)(function(el) {
        // bail early if no element is available to attach to
        if (!el) return;
        var notPassive = (0, $b433fecfd9e3c65e$export$b0622a6911dbeaf5) ? {
            passive: false
        } : false;
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        el.addEventListener('wheel', onWheel, notPassive);
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        el.addEventListener('touchstart', onTouchStart, notPassive);
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        el.addEventListener('touchmove', onTouchMove, notPassive);
    }, [
        onTouchMove,
        onTouchStart,
        onWheel
    ]);
    var stopListening = (0, $5FkrB.useCallback)(function(el) {
        // bail early if no element is available to detach from
        if (!el) return;
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        el.removeEventListener('wheel', onWheel, false);
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        el.removeEventListener('touchstart', onTouchStart, false);
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        el.removeEventListener('touchmove', onTouchMove, false);
    }, [
        onTouchMove,
        onTouchStart,
        onWheel
    ]);
    (0, $5FkrB.useEffect)(function() {
        if (!isEnabled) return;
        var element = scrollTarget.current;
        startListening(element);
        return function() {
            stopListening(element);
        };
    }, [
        isEnabled,
        startListening,
        stopListening
    ]);
    return function(element) {
        scrollTarget.current = element;
    };
}



var $5FkrB = parcelRequire("5FkrB");
var $dbd7a8d48c5a4867$var$STYLE_KEYS = [
    'boxSizing',
    'height',
    'overflow',
    'paddingRight',
    'position'
];
var $dbd7a8d48c5a4867$var$LOCK_STYLES = {
    boxSizing: 'border-box',
    // account for possible declaration `width: 100%;` on body
    overflow: 'hidden',
    position: 'relative',
    height: '100%'
};
function $dbd7a8d48c5a4867$var$preventTouchMove(e) {
    e.preventDefault();
}
function $dbd7a8d48c5a4867$var$allowTouchMove(e) {
    e.stopPropagation();
}
function $dbd7a8d48c5a4867$var$preventInertiaScroll() {
    var top = this.scrollTop;
    var totalScroll = this.scrollHeight;
    var currentScroll = top + this.offsetHeight;
    if (top === 0) this.scrollTop = 1;
    else if (currentScroll === totalScroll) this.scrollTop = top - 1;
}
// `ontouchstart` check works on most browsers
// `maxTouchPoints` works on IE10/11 and Surface
function $dbd7a8d48c5a4867$var$isTouchDevice() {
    return 'ontouchstart' in window || navigator.maxTouchPoints;
}
var $dbd7a8d48c5a4867$var$canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
var $dbd7a8d48c5a4867$var$activeScrollLocks = 0;
var $dbd7a8d48c5a4867$var$listenerOptions = {
    capture: false,
    passive: false
};
function $dbd7a8d48c5a4867$export$2e2bcd8739ae039(_ref) {
    var isEnabled = _ref.isEnabled, _ref$accountForScroll = _ref.accountForScrollbars, accountForScrollbars = _ref$accountForScroll === void 0 ? true : _ref$accountForScroll;
    var originalStyles = (0, $5FkrB.useRef)({});
    var scrollTarget = (0, $5FkrB.useRef)(null);
    var addScrollLock = (0, $5FkrB.useCallback)(function(touchScrollTarget) {
        if (!$dbd7a8d48c5a4867$var$canUseDOM) return;
        var target = document.body;
        var targetStyle = target && target.style;
        if (accountForScrollbars) // store any styles already applied to the body
        $dbd7a8d48c5a4867$var$STYLE_KEYS.forEach(function(key) {
            var val = targetStyle && targetStyle[key];
            originalStyles.current[key] = val;
        });
        // apply the lock styles and padding if this is the first scroll lock
        if (accountForScrollbars && $dbd7a8d48c5a4867$var$activeScrollLocks < 1) {
            var currentPadding = parseInt(originalStyles.current.paddingRight, 10) || 0;
            var clientWidth = document.body ? document.body.clientWidth : 0;
            var adjustedPadding = window.innerWidth - clientWidth + currentPadding || 0;
            Object.keys($dbd7a8d48c5a4867$var$LOCK_STYLES).forEach(function(key) {
                var val = $dbd7a8d48c5a4867$var$LOCK_STYLES[key];
                if (targetStyle) targetStyle[key] = val;
            });
            if (targetStyle) targetStyle.paddingRight = "".concat(adjustedPadding, "px");
        }
        // account for touch devices
        if (target && $dbd7a8d48c5a4867$var$isTouchDevice()) {
            // Mobile Safari ignores { overflow: hidden } declaration on the body.
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            target.addEventListener('touchmove', $dbd7a8d48c5a4867$var$preventTouchMove, $dbd7a8d48c5a4867$var$listenerOptions);
            // Allow scroll on provided target
            if (touchScrollTarget) {
                // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                touchScrollTarget.addEventListener('touchstart', $dbd7a8d48c5a4867$var$preventInertiaScroll, $dbd7a8d48c5a4867$var$listenerOptions);
                // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                touchScrollTarget.addEventListener('touchmove', $dbd7a8d48c5a4867$var$allowTouchMove, $dbd7a8d48c5a4867$var$listenerOptions);
            }
        }
        // increment active scroll locks
        $dbd7a8d48c5a4867$var$activeScrollLocks += 1;
    }, [
        accountForScrollbars
    ]);
    var removeScrollLock = (0, $5FkrB.useCallback)(function(touchScrollTarget) {
        if (!$dbd7a8d48c5a4867$var$canUseDOM) return;
        var target = document.body;
        var targetStyle = target && target.style;
        // safely decrement active scroll locks
        $dbd7a8d48c5a4867$var$activeScrollLocks = Math.max($dbd7a8d48c5a4867$var$activeScrollLocks - 1, 0);
        // reapply original body styles, if any
        if (accountForScrollbars && $dbd7a8d48c5a4867$var$activeScrollLocks < 1) $dbd7a8d48c5a4867$var$STYLE_KEYS.forEach(function(key) {
            var val = originalStyles.current[key];
            if (targetStyle) targetStyle[key] = val;
        });
        // remove touch listeners
        if (target && $dbd7a8d48c5a4867$var$isTouchDevice()) {
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            target.removeEventListener('touchmove', $dbd7a8d48c5a4867$var$preventTouchMove, $dbd7a8d48c5a4867$var$listenerOptions);
            if (touchScrollTarget) {
                // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                touchScrollTarget.removeEventListener('touchstart', $dbd7a8d48c5a4867$var$preventInertiaScroll, $dbd7a8d48c5a4867$var$listenerOptions);
                // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                touchScrollTarget.removeEventListener('touchmove', $dbd7a8d48c5a4867$var$allowTouchMove, $dbd7a8d48c5a4867$var$listenerOptions);
            }
        }
    }, [
        accountForScrollbars
    ]);
    (0, $5FkrB.useEffect)(function() {
        if (!isEnabled) return;
        var element = scrollTarget.current;
        addScrollLock(element);
        return function() {
            removeScrollLock(element);
        };
    }, [
        isEnabled,
        addScrollLock,
        removeScrollLock
    ]);
    return function(element) {
        scrollTarget.current = element;
    };
}


var $d119b4910de4cb36$var$blurSelectInput = function blurSelectInput(event) {
    var element = event.target;
    return element.ownerDocument.activeElement && element.ownerDocument.activeElement.blur();
};
function $d119b4910de4cb36$export$2e2bcd8739ae039(_ref) {
    var children = _ref.children, lockEnabled = _ref.lockEnabled, _ref$captureEnabled = _ref.captureEnabled, captureEnabled = _ref$captureEnabled === void 0 ? true : _ref$captureEnabled, onBottomArrive = _ref.onBottomArrive, onBottomLeave = _ref.onBottomLeave, onTopArrive = _ref.onTopArrive, onTopLeave = _ref.onTopLeave;
    var setScrollCaptureTarget = (0, $ca075aead9c3df17$export$2e2bcd8739ae039)({
        isEnabled: captureEnabled,
        onBottomArrive: onBottomArrive,
        onBottomLeave: onBottomLeave,
        onTopArrive: onTopArrive,
        onTopLeave: onTopLeave
    });
    var setScrollLockTarget = (0, $dbd7a8d48c5a4867$export$2e2bcd8739ae039)({
        isEnabled: lockEnabled
    });
    var targetRef = function targetRef(element) {
        setScrollCaptureTarget(element);
        setScrollLockTarget(element);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $5FkrB.Fragment), null, lockEnabled && /*#__PURE__*/ // eslint-disable-next-line @atlassian/a11y/click-events-have-key-events, @atlassian/a11y/interactive-element-not-keyboard-focusable, @atlassian/a11y/no-static-element-interactions
    (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("div", {
        onClick: $d119b4910de4cb36$var$blurSelectInput,
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            position: 'fixed',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            insetBlockEnd: 0,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            insetBlockStart: 0,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            insetInlineEnd: 0,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            insetInlineStart: 0
        }
    }), children(targetRef));
}



function $4fad4c07dbc64f57$export$3f99968195accfaf(el, top) {
    // with a scroll distance, we perform scroll on the element
    if ((0, $dd90990edcd0cc98$export$d8a62a489b442872)(el)) {
        window.scrollTo(0, top);
        return;
    }
    el.scrollTop = top;
}



function $062b1cc3779ffe6c$export$dea4763e29237f4c(singleValue) {
    return singleValue;
}


function $76c057a0598858d5$export$40fb9515c784cc3b(isMulti, multiValue, singleValue) {
    return isMulti ? multiValue : singleValue;
}


/* eslint-disable @repo/internal/fs/filename-pattern-match */ var $082530dc4e36967f$export$56bd0c8d90db075 = function isOptionDisabled(option) {
    return !!option.isDisabled;
};


function $b738ed358e8eabef$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $b738ed358e8eabef$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $b738ed358e8eabef$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $90d31be1abcfa6da$export$2e2bcd8739ae039)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $b738ed358e8eabef$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $b738ed358e8eabef$var$_callSuper(t, o, e) {
    return o = (0, $4753b89c96b5d03b$export$2e2bcd8739ae039)(o), (0, $916d1780331a30aa$export$2e2bcd8739ae039)(t, $b738ed358e8eabef$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, $4753b89c96b5d03b$export$2e2bcd8739ae039)(t).constructor) : o.apply(t, e));
}
function $b738ed358e8eabef$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($b738ed358e8eabef$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $b738ed358e8eabef$var$noop = (0, $adcefb868cf2fc9d$export$2e2bcd8739ae039);
function $b738ed358e8eabef$var$notNullish(item) {
    return item != null;
}
function $b738ed358e8eabef$var$scrollIntoView(menuEl, focusedEl) {
    var menuRect = menuEl.getBoundingClientRect();
    var focusedRect = focusedEl.getBoundingClientRect();
    var overScroll = focusedEl.offsetHeight / 3;
    if (focusedRect.bottom + overScroll > menuRect.bottom) (0, $4fad4c07dbc64f57$export$3f99968195accfaf)(menuEl, Math.min(focusedEl.offsetTop + focusedEl.clientHeight - menuEl.offsetHeight + overScroll, menuEl.scrollHeight));
    else if (focusedRect.top - overScroll < menuRect.top) (0, $4fad4c07dbc64f57$export$3f99968195accfaf)(menuEl, Math.max(focusedEl.offsetTop - overScroll, 0));
}
function $b738ed358e8eabef$var$isMobileDevice() {
    try {
        return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    } catch (_unused) {
        return false;
    }
}
function $b738ed358e8eabef$var$isTouchCapable() {
    try {
        document.createEvent('TouchEvent');
        return true;
    } catch (_unused2) {
        return false;
    }
}
/**
 * Filters out unsupported selectors (e.g., pseudo-classes, complex selectors) from a styles object.
 * @param styles - The styles object to filter.
 * @returns A new object containing only supported styles.
 */ var $b738ed358e8eabef$var$filterUnsupportedSelectors = function filterUnsupportedSelectors(styles) {
    var unsupportedSelectors = [
        ':',
        // pseudo-classes/elements
        '[',
        // attribute selectors
        '>',
        // child combinator
        '+',
        // adjacent sibling combinator
        '~',
        // general sibling combinator
        ' ',
        // descendant combinator
        '*',
        // universal selector
        '#',
        // ID selector
        '.',
        // class selector
        '@',
        // at-rules
        '&',
        // parent selector
        '|',
        // namespace separator
        '^',
        // starts with
        '$',
        // ends with
        '=' // equals
    ];
    return Object.keys(styles).reduce(function(filteredStyles, key) {
        if (!unsupportedSelectors.some(function(selector) {
            return key.includes(selector);
        })) filteredStyles[key] = styles[key];
        return filteredStyles;
    }, {});
};
var $b738ed358e8eabef$var$elemBeforeCSS = null;
var $b738ed358e8eabef$export$9c21a3269931e1e6 = {
    backspaceRemovesValue: true,
    blurInputOnSelect: $b738ed358e8eabef$var$isTouchCapable(),
    captureMenuScroll: !$b738ed358e8eabef$var$isTouchCapable(),
    classNames: {},
    closeMenuOnSelect: true,
    closeMenuOnScroll: false,
    components: {},
    controlShouldRenderValue: true,
    escapeClearsValue: false,
    filterOption: (0, $91d82f1fba79798f$export$5d81789ff4aeccdf)(),
    formatGroupLabel: (0, $3f51b26d3910379c$export$f4da216a6ca54656),
    getOptionLabel: (0, $256e8ca70d9dc1dd$export$dac6ace3020563ca),
    getOptionValue: (0, $a4ef18a3f2390baf$export$40be908210c5a79c),
    isDisabled: false,
    isLoading: false,
    isMulti: false,
    isRtl: false,
    isSearchable: true,
    isOptionDisabled: (0, $082530dc4e36967f$export$56bd0c8d90db075),
    loadingMessage: function loadingMessage() {
        return 'Loading...';
    },
    maxMenuHeight: 300,
    minMenuHeight: 140,
    menuIsOpen: false,
    menuPlacement: 'bottom',
    menuPosition: 'absolute',
    menuShouldBlockScroll: false,
    menuShouldScrollIntoView: !$b738ed358e8eabef$var$isMobileDevice(),
    noOptionsMessage: function noOptionsMessage() {
        return 'No options';
    },
    openMenuOnFocus: false,
    openMenuOnClick: true,
    shouldPreventEscapePropagation: false,
    options: [],
    pageSize: 5,
    screenReaderStatus: function screenReaderStatus(_ref) {
        var count = _ref.count;
        return "".concat(count, " result").concat(count !== 1 ? 's' : '', " available");
    },
    styles: {},
    tabIndex: 0,
    tabSelectsValue: true,
    UNSAFE_is_experimental_generic: false
};
function $b738ed358e8eabef$var$toCategorizedOption(props, option, selectValue, index) {
    var isDisabled = $b738ed358e8eabef$var$_isOptionDisabled(props, option, selectValue);
    var isSelected = $b738ed358e8eabef$var$_isOptionSelected(props, option, selectValue);
    var label = $b738ed358e8eabef$var$getOptionLabel(props, option);
    var value = $b738ed358e8eabef$var$getOptionValue(props, option);
    return {
        type: 'option',
        data: option,
        isDisabled: isDisabled,
        isSelected: isSelected,
        label: label,
        value: value,
        index: index
    };
}
function $b738ed358e8eabef$var$buildCategorizedOptions(props, selectValue) {
    return props.options.map(function(groupOrOption, groupOrOptionIndex) {
        //@ts-ignore
        if ('options' in groupOrOption) {
            var categorizedOptions = groupOrOption.options.map(function(option, optionIndex) {
                return $b738ed358e8eabef$var$toCategorizedOption(props, option, selectValue, optionIndex);
            }).filter(function(categorizedOption) {
                return $b738ed358e8eabef$var$isFocusable(props, categorizedOption);
            });
            return categorizedOptions.length > 0 ? {
                type: 'group',
                data: groupOrOption,
                options: categorizedOptions,
                index: groupOrOptionIndex
            } : undefined;
        }
        var categorizedOption = $b738ed358e8eabef$var$toCategorizedOption(props, groupOrOption, selectValue, groupOrOptionIndex);
        return $b738ed358e8eabef$var$isFocusable(props, categorizedOption) ? categorizedOption : undefined;
    }).filter($b738ed358e8eabef$var$notNullish);
}
function $b738ed358e8eabef$var$buildFocusableOptionsFromCategorizedOptions(categorizedOptions) {
    return categorizedOptions.reduce(function(optionsAccumulator, categorizedOption) {
        if (categorizedOption.type === 'group') optionsAccumulator.push.apply(optionsAccumulator, (0, $f90c78505475f844$export$2e2bcd8739ae039)(categorizedOption.options.map(function(option) {
            return option.data;
        })));
        else optionsAccumulator.push(categorizedOption.data);
        return optionsAccumulator;
    }, []);
}
function $b738ed358e8eabef$var$buildFocusableOptionsWithIds(categorizedOptions, optionId) {
    return categorizedOptions.reduce(function(optionsAccumulator, categorizedOption) {
        if (categorizedOption.type === 'group') optionsAccumulator.push.apply(optionsAccumulator, (0, $f90c78505475f844$export$2e2bcd8739ae039)(categorizedOption.options.map(function(option) {
            return {
                data: option.data,
                id: "".concat(optionId, "-").concat(categorizedOption.index, "-").concat(option.index)
            };
        })));
        else optionsAccumulator.push({
            data: categorizedOption.data,
            id: "".concat(optionId, "-").concat(categorizedOption.index)
        });
        return optionsAccumulator;
    }, []);
}
function $b738ed358e8eabef$var$buildFocusableOptions(props, selectValue) {
    return $b738ed358e8eabef$var$buildFocusableOptionsFromCategorizedOptions($b738ed358e8eabef$var$buildCategorizedOptions(props, selectValue));
}
function $b738ed358e8eabef$var$isFocusable(props, categorizedOption) {
    var _props$inputValue = props.inputValue, inputValue = _props$inputValue === void 0 ? '' : _props$inputValue;
    var data = categorizedOption.data, isSelected = categorizedOption.isSelected, label = categorizedOption.label, value = categorizedOption.value;
    return (!$b738ed358e8eabef$var$shouldHideSelectedOptions(props) || !isSelected) && $b738ed358e8eabef$var$_filterOption(props, {
        label: label,
        value: value,
        data: data
    }, inputValue);
}
function $b738ed358e8eabef$var$getNextFocusedValue(state, nextSelectValue) {
    var focusedValue = state.focusedValue, lastSelectValue = state.selectValue;
    var lastFocusedIndex = lastSelectValue.indexOf(focusedValue);
    if (lastFocusedIndex > -1) {
        var nextFocusedIndex = nextSelectValue.indexOf(focusedValue);
        if (nextFocusedIndex > -1) // the focused value is still in the selectValue, return it
        return focusedValue;
        else if (lastFocusedIndex < nextSelectValue.length) // the focusedValue is not present in the next selectValue array by
        // reference, so return the new value at the same index
        return nextSelectValue[lastFocusedIndex];
    }
    return null;
}
function $b738ed358e8eabef$var$getNextFocusedOption(state, options) {
    var lastFocusedOption = state.focusedOption;
    return lastFocusedOption && options.indexOf(lastFocusedOption) > -1 ? lastFocusedOption : options[0];
}
var $b738ed358e8eabef$var$getFocusedOptionId = function getFocusedOptionId(focusableOptionsWithIds, focusedOption) {
    var _focusableOptionsWith;
    var focusedOptionId = (_focusableOptionsWith = focusableOptionsWithIds.find(function(option) {
        return option.data === focusedOption;
    })) === null || _focusableOptionsWith === void 0 ? void 0 : _focusableOptionsWith.id;
    return focusedOptionId || null;
};
var $b738ed358e8eabef$var$getOptionLabel = function getOptionLabel(props, data) {
    return props.getOptionLabel(data);
};
var $b738ed358e8eabef$var$getOptionValue = function getOptionValue(props, data) {
    return props.getOptionValue(data);
};
function $b738ed358e8eabef$var$_isOptionDisabled(props, option, selectValue) {
    return typeof props.isOptionDisabled === 'function' ? props.isOptionDisabled(option, selectValue) : false;
}
function $b738ed358e8eabef$var$_isOptionSelected(props, option, selectValue) {
    if (selectValue.indexOf(option) > -1) return true;
    if (typeof props.isOptionSelected === 'function') return props.isOptionSelected(option, selectValue);
    var candidate = $b738ed358e8eabef$var$getOptionValue(props, option);
    return selectValue.some(function(i) {
        return $b738ed358e8eabef$var$getOptionValue(props, i) === candidate;
    });
}
function $b738ed358e8eabef$var$_filterOption(props, option, inputValue) {
    return props.filterOption ? props.filterOption(option, inputValue) : true;
}
var $b738ed358e8eabef$var$shouldHideSelectedOptions = function shouldHideSelectedOptions(props) {
    var hideSelectedOptions = props.hideSelectedOptions, isMulti = props.isMulti;
    if (hideSelectedOptions === undefined) return isMulti;
    return hideSelectedOptions;
};
var $b738ed358e8eabef$var$instanceId = 1;
// eslint-disable-next-line @repo/internal/react/no-class-components, @atlaskit/volt-strict-mode/no-multiple-exports
var $b738ed358e8eabef$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_Component) {
    // Lifecycle
    // ------------------------------
    function Select(_props) {
        var _this;
        (0, $9ba5074f09554cd6$export$2e2bcd8739ae039)(this, Select);
        _this = $b738ed358e8eabef$var$_callSuper(this, Select, [
            _props
        ]);
        (0, $90d31be1abcfa6da$export$2e2bcd8739ae039)(_this, "state", {
            ariaSelection: null,
            focusedOption: null,
            focusedOptionId: null,
            focusableOptionsWithIds: [],
            focusedValue: null,
            focusedValueId: null,
            inputIsHidden: false,
            isFocused: false,
            selectValue: [],
            clearFocusValueOnUpdate: false,
            prevWasFocused: false,
            inputIsHiddenAfterUpdate: undefined,
            prevProps: undefined,
            instancePrefix: '',
            controlElement: null
        });
        // Misc. Instance Properties
        // ------------------------------
        (0, $90d31be1abcfa6da$export$2e2bcd8739ae039)(_this, "blockOptionHover", false);
        (0, $90d31be1abcfa6da$export$2e2bcd8739ae039)(_this, "isComposing", false);
        // TODO
        (0, $90d31be1abcfa6da$export$2e2bcd8739ae039)(_this, "initialTouchX", 0);
        (0, $90d31be1abcfa6da$export$2e2bcd8739ae039)(_this, "initialTouchY", 0);
        (0, $90d31be1abcfa6da$export$2e2bcd8739ae039)(_this, "openAfterFocus", false);
        (0, $90d31be1abcfa6da$export$2e2bcd8739ae039)(_this, "scrollToFocusedOptionOnUpdate", false);
        // Cleanup for a pending document `pointerup` listener registered by
        // `openMenuAfterPointerUp`. See that method for the full rationale.
        (0, $90d31be1abcfa6da$export$2e2bcd8739ae039)(_this, "deferredOpenMenuCleanup", null);
        // Refs
        // ------------------------------
        (0, $90d31be1abcfa6da$export$2e2bcd8739ae039)(_this, "controlRef", null);
        (0, $90d31be1abcfa6da$export$2e2bcd8739ae039)(_this, "getControlRef", function(ref) {
            _this.controlRef = ref;
            // Mirror the ref into state on the top-layer path so
            // `MenuPortalTopLayer`'s layout effects react to the anchor attaching.
            // Skip the null-ref (unmount) case: setState during unmount is unsafe
            // and the state is dropped with the instance anyway.
            if (ref === null) return;
            if (_this.state.controlElement !== ref && (0, $13a186c4459b8c2a$export$b40ec24ac8275656)('platform-dst-top-layer')) _this.setState({
                controlElement: ref
            });
        });
        (0, $90d31be1abcfa6da$export$2e2bcd8739ae039)(_this, "focusedOptionRef", null);
        (0, $90d31be1abcfa6da$export$2e2bcd8739ae039)(_this, "getFocusedOptionRef", function(ref) {
            _this.focusedOptionRef = ref;
        });
        (0, $90d31be1abcfa6da$export$2e2bcd8739ae039)(_this, "menuListRef", null);
        (0, $90d31be1abcfa6da$export$2e2bcd8739ae039)(_this, "getMenuListRef", function(ref) {
            _this.menuListRef = ref;
        });
        (0, $90d31be1abcfa6da$export$2e2bcd8739ae039)(_this, "inputRef", null);
        (0, $90d31be1abcfa6da$export$2e2bcd8739ae039)(_this, "getInputRef", function(ref) {
            _this.inputRef = ref;
        });
        // aliased for consumers
        (0, $90d31be1abcfa6da$export$2e2bcd8739ae039)(_this, "focus", _this.focusInput);
        (0, $90d31be1abcfa6da$export$2e2bcd8739ae039)(_this, "blur", _this.blurInput);
        (0, $90d31be1abcfa6da$export$2e2bcd8739ae039)(_this, "onChange", function(newValue, actionMeta) {
            var _this$props = _this.props, onChange = _this$props.onChange, name = _this$props.name;
            actionMeta.name = name;
            _this.ariaOnChange(newValue, actionMeta);
            onChange(newValue, actionMeta);
        });
        (0, $90d31be1abcfa6da$export$2e2bcd8739ae039)(_this, "setValue", function(newValue, action, option) {
            var _this$props2 = _this.props, closeMenuOnSelect = _this$props2.closeMenuOnSelect, isMulti = _this$props2.isMulti, inputValue = _this$props2.inputValue;
            _this.onInputChange('', {
                action: 'set-value',
                prevInputValue: inputValue
            });
            if (closeMenuOnSelect) {
                _this.setState({
                    inputIsHiddenAfterUpdate: !isMulti
                });
                _this.onMenuClose();
            }
            // when the select value should change, we should reset focusedValue
            _this.setState({
                clearFocusValueOnUpdate: true
            });
            _this.onChange(newValue, {
                action: action,
                option: option
            });
        });
        (0, $90d31be1abcfa6da$export$2e2bcd8739ae039)(_this, "selectOption", function(newValue) {
            var _this$props3 = _this.props, blurInputOnSelect = _this$props3.blurInputOnSelect, isMulti = _this$props3.isMulti, name = _this$props3.name;
            var selectValue = _this.state.selectValue;
            var deselected = isMulti && _this.isOptionSelected(newValue, selectValue);
            var isDisabled = _this.isOptionDisabled(newValue, selectValue);
            if (deselected) {
                var candidate = _this.getOptionValue(newValue);
                _this.setValue((0, $3d49340fe1bc6067$export$d1ca752ec761b95b)(selectValue.filter(function(i) {
                    return _this.getOptionValue(i) !== candidate;
                })), 'deselect-option', newValue);
            } else if (!isDisabled) {
                // Select option if option is not disabled
                if (isMulti) _this.setValue((0, $3d49340fe1bc6067$export$d1ca752ec761b95b)([].concat((0, $f90c78505475f844$export$2e2bcd8739ae039)(selectValue), [
                    newValue
                ])), 'select-option', newValue);
                else _this.setValue((0, $062b1cc3779ffe6c$export$dea4763e29237f4c)(newValue), 'select-option');
            } else {
                _this.ariaOnChange((0, $062b1cc3779ffe6c$export$dea4763e29237f4c)(newValue), {
                    action: 'select-option',
                    option: newValue,
                    name: name
                });
                return;
            }
            if (blurInputOnSelect) _this.blurInput();
        });
        (0, $90d31be1abcfa6da$export$2e2bcd8739ae039)(_this, "removeValue", function(removedValue) {
            var isMulti = _this.props.isMulti;
            var selectValue = _this.state.selectValue;
            var candidate = _this.getOptionValue(removedValue);
            var newValueArray = selectValue.filter(function(i) {
                return _this.getOptionValue(i) !== candidate;
            });
            var newValue = (0, $76c057a0598858d5$export$40fb9515c784cc3b)(isMulti, newValueArray, newValueArray[0] || null);
            _this.onChange(newValue, {
                action: 'remove-value',
                removedValue: removedValue
            });
            _this.focusInput();
        });
        (0, $90d31be1abcfa6da$export$2e2bcd8739ae039)(_this, "clearValue", function() {
            var selectValue = _this.state.selectValue;
            _this.onChange((0, $76c057a0598858d5$export$40fb9515c784cc3b)(_this.props.isMulti, [], null), {
                action: 'clear',
                removedValues: selectValue
            });
        });
        (0, $90d31be1abcfa6da$export$2e2bcd8739ae039)(_this, "popValue", function() {
            var isMulti = _this.props.isMulti;
            var selectValue = _this.state.selectValue;
            var lastSelectedValue = selectValue[selectValue.length - 1];
            var newValueArray = selectValue.slice(0, selectValue.length - 1);
            var newValue = (0, $76c057a0598858d5$export$40fb9515c784cc3b)(isMulti, newValueArray, newValueArray[0] || null);
            _this.onChange(newValue, {
                action: 'pop-value',
                removedValue: lastSelectedValue
            });
        });
        // ==============================
        // Getters
        // ==============================
        (0, $90d31be1abcfa6da$export$2e2bcd8739ae039)(_this, "getFocusedOptionId", function(focusedOption) {
            return $b738ed358e8eabef$var$getFocusedOptionId(_this.state.focusableOptionsWithIds, focusedOption);
        });
        (0, $90d31be1abcfa6da$export$2e2bcd8739ae039)(_this, "getFocusableOptionsWithIds", function() {
            return $b738ed358e8eabef$var$buildFocusableOptionsWithIds($b738ed358e8eabef$var$buildCategorizedOptions(_this.props, _this.state.selectValue), _this.getElementId('option'));
        });
        (0, $90d31be1abcfa6da$export$2e2bcd8739ae039)(_this, "getValue", function() {
            return _this.state.selectValue;
        });
        (0, $90d31be1abcfa6da$export$2e2bcd8739ae039)(_this, "cx", function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            return (0, $fc5200fe4d6fc1ee$export$ce4ab0c55987d1ff).apply(void 0, [
                _this.props.classNamePrefix
            ].concat(args));
        });
        (0, $90d31be1abcfa6da$export$2e2bcd8739ae039)(_this, "getOptionLabel", function(data) {
            return $b738ed358e8eabef$var$getOptionLabel(_this.props, data);
        });
        (0, $90d31be1abcfa6da$export$2e2bcd8739ae039)(_this, "getOptionValue", function(data) {
            return $b738ed358e8eabef$var$getOptionValue(_this.props, data);
        });
        (0, $90d31be1abcfa6da$export$2e2bcd8739ae039)(_this, "getStyles", function(key, props) {
            var base = {
                boxSizing: 'border-box'
            };
            var custom = _this.props.styles[key];
            if (custom) return $b738ed358e8eabef$var$filterUnsupportedSelectors(custom(base, props));
            return base;
        });
        (0, $90d31be1abcfa6da$export$2e2bcd8739ae039)(_this, "getClassNames", function(key, props) {
            var _this$props$className, _this$props$className2;
            return (_this$props$className = (_this$props$className2 = _this.props.classNames)[key]) === null || _this$props$className === void 0 ? void 0 : _this$props$className.call(_this$props$className2, props);
        });
        (0, $90d31be1abcfa6da$export$2e2bcd8739ae039)(_this, "getElementId", function(element) {
            return "".concat(_this.state.instancePrefix, "-").concat(element);
        });
        (0, $90d31be1abcfa6da$export$2e2bcd8739ae039)(_this, "getComponents", function() {
            return (0, $525be6c0d6b9e93b$export$71abc632aa29e6fe)(_this.props);
        });
        (0, $90d31be1abcfa6da$export$2e2bcd8739ae039)(_this, "buildCategorizedOptions", function() {
            return $b738ed358e8eabef$var$buildCategorizedOptions(_this.props, _this.state.selectValue);
        });
        (0, $90d31be1abcfa6da$export$2e2bcd8739ae039)(_this, "getCategorizedOptions", function() {
            return _this.props.menuIsOpen ? _this.buildCategorizedOptions() : [];
        });
        (0, $90d31be1abcfa6da$export$2e2bcd8739ae039)(_this, "buildFocusableOptions", function() {
            return $b738ed358e8eabef$var$buildFocusableOptionsFromCategorizedOptions(_this.buildCategorizedOptions());
        });
        (0, $90d31be1abcfa6da$export$2e2bcd8739ae039)(_this, "getFocusableOptions", function() {
            return _this.props.menuIsOpen ? _this.buildFocusableOptions() : [];
        });
        // ==============================
        // Helpers
        // ==============================
        (0, $90d31be1abcfa6da$export$2e2bcd8739ae039)(_this, "ariaOnChange", function(value, actionMeta) {
            _this.setState({
                ariaSelection: $b738ed358e8eabef$var$_objectSpread({
                    value: value
                }, actionMeta)
            });
        });
        // ==============================
        // Mouse Handlers
        // ==============================
        (0, $90d31be1abcfa6da$export$2e2bcd8739ae039)(_this, "onMenuMouseDown", function(event) {
            if (event.button !== 0) return;
            event.stopPropagation();
            event.preventDefault();
            _this.focusInput();
        });
        (0, $90d31be1abcfa6da$export$2e2bcd8739ae039)(_this, "onMenuMouseMove", function(_) {
            _this.blockOptionHover = false;
        });
        (0, $90d31be1abcfa6da$export$2e2bcd8739ae039)(_this, "onControlMouseDown", function(event) {
            // Event captured by dropdown indicator
            if (event.defaultPrevented) {
                var _this$controlRef;
                // react-dnd will fire preventDefault in mouseDown, which make select is not clickable.
                // temp workaround to check if select is within dnd, we don't do the early return.
                if (!((_this$controlRef = _this.controlRef) !== null && _this$controlRef !== void 0 && _this$controlRef.closest('[data-rbd-draggable-context-id]'))) return;
            }
            var openMenuOnClick = _this.props.openMenuOnClick;
            if (!_this.state.isFocused) {
                if (openMenuOnClick) _this.openAfterFocus = true;
                _this.focusInput();
            } else if (!_this.props.menuIsOpen) {
                if (openMenuOnClick) _this.openMenuAfterPointerUp('first');
            } else if (event.target.tagName !== 'INPUT' && event.target.tagName !== 'TEXTAREA') _this.onMenuClose();
            if (event.target.tagName !== 'INPUT' && event.target.tagName !== 'TEXTAREA') event.preventDefault();
        });
        (0, $90d31be1abcfa6da$export$2e2bcd8739ae039)(_this, "onDropdownIndicatorMouseDown", function(event) {
            // ignore mouse events that weren't triggered by the primary button
            if (event && event.type === 'mousedown' && event.button !== 0) return;
            if (_this.props.isDisabled) return;
            var _this$props4 = _this.props, isMulti = _this$props4.isMulti, menuIsOpen = _this$props4.menuIsOpen;
            _this.focusInput();
            if (menuIsOpen) {
                _this.setState({
                    inputIsHiddenAfterUpdate: !isMulti
                });
                _this.onMenuClose();
            } else _this.openMenuAfterPointerUp('first');
            event.preventDefault();
        });
        (0, $90d31be1abcfa6da$export$2e2bcd8739ae039)(_this, "onClearIndicatorMouseDown", function(event) {
            // ignore mouse events that weren't triggered by the primary button
            if (event && event.type === 'mousedown' && event.button !== 0) return;
            _this.clearValue();
            event.preventDefault();
            _this.openAfterFocus = false;
            if (event.type === 'touchend') _this.focusInput();
            else setTimeout(function() {
                return _this.focusInput();
            });
        });
        (0, $90d31be1abcfa6da$export$2e2bcd8739ae039)(_this, "onScroll", function(event) {
            if (typeof _this.props.closeMenuOnScroll === 'boolean') {
                if (event.target instanceof HTMLElement && (0, $dd90990edcd0cc98$export$d8a62a489b442872)(event.target)) _this.props.onMenuClose();
            } else if (typeof _this.props.closeMenuOnScroll === 'function') {
                if (_this.props.closeMenuOnScroll(event)) _this.props.onMenuClose();
            }
        });
        (0, $90d31be1abcfa6da$export$2e2bcd8739ae039)(_this, "onCompositionStart", function() {
            _this.isComposing = true;
        });
        (0, $90d31be1abcfa6da$export$2e2bcd8739ae039)(_this, "onCompositionEnd", function() {
            _this.isComposing = false;
        });
        (0, $90d31be1abcfa6da$export$2e2bcd8739ae039)(_this, "onTouchStart", function(_ref2) {
            var touches = _ref2.touches;
            var touch = touches && touches.item(0);
            if (!touch) return;
            _this.initialTouchX = touch.clientX;
            _this.initialTouchY = touch.clientY;
            _this.userIsDragging = false;
        });
        (0, $90d31be1abcfa6da$export$2e2bcd8739ae039)(_this, "onTouchMove", function(_ref3) {
            var touches = _ref3.touches;
            var touch = touches && touches.item(0);
            if (!touch) return;
            var deltaX = Math.abs(touch.clientX - _this.initialTouchX);
            var deltaY = Math.abs(touch.clientY - _this.initialTouchY);
            var moveThreshold = 5;
            _this.userIsDragging = deltaX > moveThreshold || deltaY > moveThreshold;
        });
        (0, $90d31be1abcfa6da$export$2e2bcd8739ae039)(_this, "onTouchEnd", function(event) {
            if (_this.userIsDragging) return;
            // close the menu if the user taps outside
            // we're checking on event.target here instead of event.currentTarget, because we want to assert information
            // on events on child elements, not the document (which we've attached this handler to).
            if (_this.controlRef && !_this.controlRef.contains(event.target) && _this.menuListRef && !_this.menuListRef.contains(event.target)) _this.blurInput();
            // reset move vars
            _this.initialTouchX = 0;
            _this.initialTouchY = 0;
        });
        (0, $90d31be1abcfa6da$export$2e2bcd8739ae039)(_this, "onControlTouchEnd", function(event) {
            if (_this.userIsDragging) return;
            _this.onControlMouseDown(event);
        });
        (0, $90d31be1abcfa6da$export$2e2bcd8739ae039)(_this, "onClearIndicatorTouchEnd", function(event) {
            if (_this.userIsDragging) return;
            _this.onClearIndicatorMouseDown(event);
        });
        (0, $90d31be1abcfa6da$export$2e2bcd8739ae039)(_this, "onDropdownIndicatorTouchEnd", function(event) {
            if (_this.userIsDragging) return;
            _this.onDropdownIndicatorMouseDown(event);
        });
        // ==============================
        // Focus Handlers
        // ==============================
        (0, $90d31be1abcfa6da$export$2e2bcd8739ae039)(_this, "handleInputChange", function(event) {
            var prevInputValue = _this.props.inputValue;
            var inputValue = event.currentTarget.value;
            _this.setState({
                inputIsHiddenAfterUpdate: false
            });
            _this.onInputChange(inputValue, {
                action: 'input-change',
                prevInputValue: prevInputValue
            });
            if (!_this.props.menuIsOpen) _this.onMenuOpen();
        });
        (0, $90d31be1abcfa6da$export$2e2bcd8739ae039)(_this, "onInputFocus", function(event) {
            if (_this.props.onFocus) _this.props.onFocus(event);
            _this.setState({
                inputIsHiddenAfterUpdate: false,
                isFocused: true
            });
            if (_this.openAfterFocus || _this.props.openMenuOnFocus) {
                // `openAfterFocus` always follows a pointer gesture, so defer past
                // pointerup. `openMenuOnFocus` alone can come from a keyboard tab
                // with no pointer gesture in flight, so open synchronously.
                if (_this.openAfterFocus) _this.openMenuAfterPointerUp('first');
                else _this.openMenu('first');
            }
            _this.openAfterFocus = false;
        });
        (0, $90d31be1abcfa6da$export$2e2bcd8739ae039)(_this, "onInputBlur", function(event) {
            var prevInputValue = _this.props.inputValue;
            if (_this.menuListRef && _this.menuListRef.contains(document.activeElement)) {
                _this.inputRef.focus();
                return;
            }
            if (_this.props.onBlur) _this.props.onBlur(event);
            _this.onInputChange('', {
                action: 'input-blur',
                prevInputValue: prevInputValue
            });
            if ((0, $13a186c4459b8c2a$export$b40ec24ac8275656)('platform_dst_select_menu_close_on_blur')) // when fg is enabled, we only call onMenuClose when this.props.menuIsOpen is true.
            _this.props.menuIsOpen && _this.onMenuClose();
            else _this.onMenuClose();
            _this.setState({
                focusedValue: null,
                isFocused: false
            });
        });
        (0, $90d31be1abcfa6da$export$2e2bcd8739ae039)(_this, "onOptionHover", function(focusedOption) {
            if (_this.blockOptionHover || _this.state.focusedOption === focusedOption) return;
            var options = _this.getFocusableOptions();
            var focusedOptionIndex = options.indexOf(focusedOption);
            _this.setState({
                focusedOption: focusedOption,
                focusedOptionId: focusedOptionIndex > -1 ? _this.getFocusedOptionId(focusedOption) : null
            });
        });
        (0, $90d31be1abcfa6da$export$2e2bcd8739ae039)(_this, "shouldHideSelectedOptions", function() {
            return $b738ed358e8eabef$var$shouldHideSelectedOptions(_this.props);
        });
        // If the hidden input gets focus through form submit,
        // redirect focus to focusable input.
        (0, $90d31be1abcfa6da$export$2e2bcd8739ae039)(_this, "onValueInputFocus", function(e) {
            e.preventDefault();
            e.stopPropagation();
            _this.focus();
        });
        // ==============================
        // Keyboard Handlers
        // ==============================
        (0, $90d31be1abcfa6da$export$2e2bcd8739ae039)(_this, "onKeyDown", function(event) {
            var _this$props5 = _this.props, isMulti = _this$props5.isMulti, backspaceRemovesValue = _this$props5.backspaceRemovesValue, escapeClearsValue = _this$props5.escapeClearsValue, inputValue = _this$props5.inputValue, isClearable = _this$props5.isClearable, isDisabled = _this$props5.isDisabled, menuIsOpen = _this$props5.menuIsOpen, onKeyDown = _this$props5.onKeyDown, tabSelectsValue = _this$props5.tabSelectsValue, openMenuOnFocus = _this$props5.openMenuOnFocus, shouldPreventEscapePropagation = _this$props5.shouldPreventEscapePropagation;
            var _this$state = _this.state, focusedOption = _this$state.focusedOption, focusedValue = _this$state.focusedValue, selectValue = _this$state.selectValue;
            if (isDisabled) return;
            if (typeof onKeyDown === 'function') {
                onKeyDown(event);
                if (event.defaultPrevented) return;
            }
            // Block option hover events when the user has just pressed a key
            _this.blockOptionHover = true;
            switch(event.key){
                case 'ArrowLeft':
                    if (!isMulti || inputValue) return;
                    _this.focusValue('previous');
                    break;
                case 'ArrowRight':
                    if (!isMulti || inputValue) return;
                    _this.focusValue('next');
                    break;
                case 'Delete':
                case 'Backspace':
                    if (inputValue) return;
                    if (focusedValue) _this.removeValue(focusedValue);
                    else {
                        if (!backspaceRemovesValue) return;
                        if (isMulti) _this.popValue();
                        else if (isClearable) _this.clearValue();
                    }
                    break;
                case 'Tab':
                    if (_this.isComposing) return;
                    if (event.shiftKey || !menuIsOpen || !tabSelectsValue || !focusedOption || // don't capture the event if the menu opens on focus and the focused
                    // option is already selected; it breaks the flow of navigation
                    openMenuOnFocus && _this.isOptionSelected(focusedOption, selectValue)) return;
                    _this.selectOption(focusedOption);
                    break;
                case 'Enter':
                    if (event.keyCode === 229) break;
                    if (focusedValue) _this.removeValue(focusedValue);
                    if (menuIsOpen) {
                        if (!focusedOption) return;
                        if (_this.isComposing) return;
                        _this.selectOption(focusedOption);
                        break;
                    }
                    return;
                case 'Escape':
                    if (menuIsOpen) {
                        _this.setState({
                            inputIsHiddenAfterUpdate: false
                        });
                        _this.onInputChange('', {
                            action: 'menu-close',
                            prevInputValue: inputValue
                        });
                        _this.onMenuClose();
                        if (shouldPreventEscapePropagation && event.target instanceof HTMLElement) event.stopPropagation();
                    } else if (isClearable && escapeClearsValue) _this.clearValue();
                    break;
                case ' ':
                    // space
                    if (inputValue) return;
                    if (!menuIsOpen) {
                        _this.openMenu('first');
                        break;
                    }
                    if (!focusedOption) return;
                    _this.selectOption(focusedOption);
                    break;
                case 'ArrowUp':
                    if (menuIsOpen) _this.focusOption('up');
                    else _this.openMenu('last');
                    break;
                case 'ArrowDown':
                    if (menuIsOpen) _this.focusOption('down');
                    else _this.openMenu('first');
                    break;
                case 'PageUp':
                    if (!menuIsOpen) return;
                    _this.focusOption('pageup');
                    break;
                case 'PageDown':
                    if (!menuIsOpen) return;
                    _this.focusOption('pagedown');
                    break;
                case 'Home':
                    if (!menuIsOpen) return;
                    _this.focusOption('first');
                    break;
                case 'End':
                    if (!menuIsOpen) return;
                    _this.focusOption('last');
                    break;
                default:
                    return;
            }
            event.preventDefault();
        });
        (0, $90d31be1abcfa6da$export$2e2bcd8739ae039)(_this, "handleOpenLayerObserverCloseSignal", function() {
            _this.onMenuClose();
        });
        _this.state.instancePrefix = 'react-select-' + (_this.props.instanceId || ++$b738ed358e8eabef$var$instanceId);
        _this.state.selectValue = (0, $b963148a95603e14$export$33f062f47f21a01)(_props.value);
        // Set focusedOption if menuIsOpen is set on init (e.g. defaultMenuIsOpen)
        if (_props.menuIsOpen) {
            var focusableOptionsWithIds = _this.getFocusableOptionsWithIds();
            var focusableOptions = _this.buildFocusableOptions();
            var optionIndex = focusableOptions.indexOf(_this.state.selectValue[0]);
            _this.state.focusableOptionsWithIds = focusableOptionsWithIds;
            _this.state.focusedOption = focusableOptions[optionIndex];
            _this.state.focusedOptionId = $b738ed358e8eabef$var$getFocusedOptionId(focusableOptionsWithIds, focusableOptions[optionIndex]);
        }
        return _this;
    }
    (0, $908cdaf31c7766dc$export$2e2bcd8739ae039)(Select, _Component);
    return (0, $920934557ff0cee7$export$2e2bcd8739ae039)(Select, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                this.startListeningComposition();
                this.startListeningToTouch();
                if (this.props.closeMenuOnScroll && document && document.addEventListener) // Listen to all scroll events, and filter them out inside of 'onScroll'
                // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                document.addEventListener('scroll', this.onScroll, true);
                if (this.props.autoFocus) this.focusInput();
                // Scroll focusedOption into view if menuIsOpen is set on mount (e.g. defaultMenuIsOpen)
                if (this.props.menuIsOpen && this.state.focusedOption && this.menuListRef && this.focusedOptionRef) $b738ed358e8eabef$var$scrollIntoView(this.menuListRef, this.focusedOptionRef);
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps) {
                var _this$props6 = this.props, isDisabled = _this$props6.isDisabled, menuIsOpen = _this$props6.menuIsOpen;
                var isFocused = this.state.isFocused;
                if (// ensure focus is restored correctly when the control becomes enabled
                isFocused && !isDisabled && prevProps.isDisabled || // ensure focus is on the Input when the menu opens
                isFocused && menuIsOpen && !prevProps.menuIsOpen) this.focusInput();
                if (isFocused && isDisabled && !prevProps.isDisabled) // ensure select state gets blurred in case Select is programmatically disabled while focused
                this.setState({
                    isFocused: false
                }, this.onMenuClose);
                else if (!isFocused && !isDisabled && prevProps.isDisabled && this.inputRef === document.activeElement) // ensure select state gets focused in case Select is programatically re-enabled while focused (Firefox)
                this.setState({
                    isFocused: true
                });
                // scroll the focused option into view if necessary
                if (this.menuListRef && this.focusedOptionRef && this.scrollToFocusedOptionOnUpdate) {
                    $b738ed358e8eabef$var$scrollIntoView(this.menuListRef, this.focusedOptionRef);
                    this.scrollToFocusedOptionOnUpdate = false;
                }
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this.stopListeningComposition();
                this.stopListeningToTouch();
                this.cancelDeferredOpenMenu();
                // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                document.removeEventListener('scroll', this.onScroll, true);
            }
        },
        {
            key: "onMenuOpen",
            value: function onMenuOpen() {
                this.props.onMenuOpen();
            }
        },
        {
            key: "onMenuClose",
            value: function onMenuClose() {
                this.onInputChange('', {
                    action: 'menu-close',
                    prevInputValue: this.props.inputValue
                });
                this.props.onMenuClose();
            }
        },
        {
            key: "onInputChange",
            value: function onInputChange(newValue, actionMeta) {
                this.props.onInputChange(newValue, actionMeta);
            }
        },
        {
            key: "focusInput",
            value: function focusInput() {
                if (!this.inputRef) return;
                this.inputRef.focus();
            }
        },
        {
            key: "blurInput",
            value: function blurInput() {
                if (!this.inputRef) return;
                this.inputRef.blur();
            }
        },
        {
            key: "shouldDeferOpenPastPointerUp",
            value: /**
     * Whether to defer the menu open past the in-flight pointer gesture.
     * Any renderer that drives a `popover="auto"` element must, otherwise
     * the browser's light-dismiss runs on the matching `pointerup` and
     * closes the menu immediately. Today only the top-layer path needs it.
     */ function shouldDeferOpenPastPointerUp() {
                return (0, $13a186c4459b8c2a$export$b40ec24ac8275656)('platform-dst-top-layer');
            }
        },
        {
            key: "openMenuAfterPointerUp",
            value: function openMenuAfterPointerUp(focusOption) {
                var _this2 = this;
                if (!this.shouldDeferOpenPastPointerUp()) {
                    this.openMenu(focusOption);
                    return;
                }
                // A second pointerdown can land before the queued pointerup if the
                // user releases and re-clicks very quickly. Replace any pending
                // deferred open with the latest one so we never stack listeners.
                this.cancelDeferredOpenMenu();
                var handlePointerUp = function handlePointerUp() {
                    _this2.deferredOpenMenuCleanup = null;
                    _this2.openMenu(focusOption);
                };
                this.deferredOpenMenuCleanup = (0, $5b617c1f48263075$exports.bind)(document, {
                    type: 'pointerup',
                    listener: handlePointerUp,
                    options: {
                        capture: true,
                        once: true
                    }
                });
            }
        },
        {
            key: "cancelDeferredOpenMenu",
            value: function cancelDeferredOpenMenu() {
                if (this.deferredOpenMenuCleanup) {
                    this.deferredOpenMenuCleanup();
                    this.deferredOpenMenuCleanup = null;
                }
            }
        },
        {
            key: "openMenu",
            value: function openMenu(focusOption) {
                var _this3 = this;
                var _this$state2 = this.state, selectValue = _this$state2.selectValue, isFocused = _this$state2.isFocused;
                var focusableOptions = this.buildFocusableOptions();
                var openAtIndex = focusOption === 'first' ? 0 : focusableOptions.length - 1;
                if (!this.props.isMulti) {
                    var selectedIndex = focusableOptions.indexOf(selectValue[0]);
                    if (selectedIndex > -1) openAtIndex = selectedIndex;
                }
                var focusedOption = focusableOptions[openAtIndex];
                // only scroll if the menu isn't already open
                this.scrollToFocusedOptionOnUpdate = !(isFocused && this.menuListRef);
                this.setState({
                    inputIsHiddenAfterUpdate: false,
                    focusedValue: null,
                    focusedOption: focusedOption,
                    focusedOptionId: this.getFocusedOptionId(focusedOption)
                }, function() {
                    return _this3.onMenuOpen();
                });
                (0, $9cdac13a38ee471b$export$95df08bae54cb4df)() && focusedOption && this.updateInputLabel(this.calculateInputLabel(focusedOption, openAtIndex));
            }
        },
        {
            key: "updateInputLabel",
            value: function updateInputLabel(inputLabel) {
                var _this4 = this;
                if (inputLabel) {
                    var _this$inputRef;
                    (_this$inputRef = this.inputRef) === null || _this$inputRef === void 0 || _this$inputRef.setAttribute('aria-label', inputLabel);
                    setTimeout(function() {
                        var normalizedLabel = _this4.props['aria-label'] || _this4.props.label;
                        if (normalizedLabel) {
                            var _this4$inputRef;
                            (_this4$inputRef = _this4.inputRef) === null || _this4$inputRef === void 0 || _this4$inputRef.setAttribute('aria-label', normalizedLabel);
                        } else {
                            var _this4$inputRef2;
                            (_this4$inputRef2 = _this4.inputRef) === null || _this4$inputRef2 === void 0 || _this4$inputRef2.removeAttribute('aria-label');
                        }
                    }, 500);
                }
            }
        },
        {
            key: "calculateInputLabel",
            value: function calculateInputLabel(focusedOption, optionIndex) {
                var _this5 = this;
                var options = this.props.options;
                var isOptionsGrouped = options === null || options === void 0 ? void 0 : options.every(function(obj) {
                    return (0, $08eb341cc44a6255$export$2e2bcd8739ae039)(obj) === 'object' && obj !== null && 'options' in obj;
                });
                var inputLabel = this.getOptionLabel(focusedOption);
                var isOptionFocused = function isOptionFocused(option) {
                    return _this5.getOptionLabel(option) === inputLabel;
                };
                var groupData = options === null || options === void 0 ? void 0 : options.find(function(option) {
                    var _groupCandidate$optio, _groupCandidate$optio2;
                    var groupCandidate = option;
                    return (_groupCandidate$optio = (_groupCandidate$optio2 = groupCandidate.options) === null || _groupCandidate$optio2 === void 0 ? void 0 : _groupCandidate$optio2.some(isOptionFocused)) !== null && _groupCandidate$optio !== void 0 ? _groupCandidate$optio : false;
                });
                if (isOptionsGrouped) {
                    var _groupData$options$fi;
                    var groupOptionIndex = (_groupData$options$fi = groupData === null || groupData === void 0 ? void 0 : groupData.options.findIndex(isOptionFocused)) !== null && _groupData$options$fi !== void 0 ? _groupData$options$fi : 0;
                    var totalLength = options === null || options === void 0 ? void 0 : options.reduce(function(acc, currentGroup) {
                        var _group$options;
                        var group = currentGroup;
                        acc += group === null || group === void 0 || (_group$options = group.options) === null || _group$options === void 0 ? void 0 : _group$options.length;
                        return acc;
                    }, 0);
                    inputLabel = "".concat(inputLabel, ", ").concat(groupData === null || groupData === void 0 ? void 0 : groupData.label, " (").concat(groupOptionIndex + 1, " of ").concat(totalLength, ")");
                } else inputLabel = "".concat(inputLabel, " (").concat(optionIndex + 1, " of ").concat(options === null || options === void 0 ? void 0 : options.length, ")");
                return inputLabel;
            }
        },
        {
            key: "focusValue",
            value: function focusValue(direction) {
                var _this$state3 = this.state, selectValue = _this$state3.selectValue, focusedValue = _this$state3.focusedValue;
                // Only multiselects support value focusing
                if (!this.props.isMulti) return;
                this.setState({
                    focusedOption: null
                });
                var focusedIndex = selectValue.indexOf(focusedValue);
                if (!focusedValue) focusedIndex = -1;
                var lastIndex = selectValue.length - 1;
                var nextFocus = -1;
                if (!selectValue.length) return;
                switch(direction){
                    case 'previous':
                        if (focusedIndex === 0) // don't cycle from the start to the end
                        nextFocus = 0;
                        else if (focusedIndex === -1) // if nothing is focused, focus the last value first
                        nextFocus = lastIndex;
                        else nextFocus = focusedIndex - 1;
                        break;
                    case 'next':
                        if (focusedIndex > -1 && focusedIndex < lastIndex) nextFocus = focusedIndex + 1;
                        break;
                }
                this.setState({
                    inputIsHidden: nextFocus !== -1,
                    focusedValue: selectValue[nextFocus],
                    focusedValueId: "".concat(this.getElementId('selected-value'), "-").concat(nextFocus, "-remove"),
                    focusedOption: null,
                    focusedOptionId: null
                });
            }
        },
        {
            key: "focusOption",
            value: function focusOption() {
                var direction = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'first';
                var pageSize = this.props.pageSize;
                var focusedOption = this.state.focusedOption;
                var options = this.getFocusableOptions();
                if (!options.length) return;
                var nextFocus = 0; // handles 'first'
                var focusedIndex = options.indexOf(focusedOption);
                if (!focusedOption) focusedIndex = -1;
                if (direction === 'up') nextFocus = focusedIndex > 0 ? focusedIndex - 1 : options.length - 1;
                else if (direction === 'down') nextFocus = (focusedIndex + 1) % options.length;
                else if (direction === 'pageup') {
                    nextFocus = focusedIndex - pageSize;
                    if (nextFocus < 0) nextFocus = 0;
                } else if (direction === 'pagedown') {
                    nextFocus = focusedIndex + pageSize;
                    if (nextFocus > options.length - 1) nextFocus = options.length - 1;
                } else if (direction === 'last') nextFocus = options.length - 1;
                this.scrollToFocusedOptionOnUpdate = true;
                this.setState({
                    focusedOption: options[nextFocus],
                    focusedValue: null,
                    focusedValueId: null,
                    focusedOptionId: this.getFocusedOptionId(options[nextFocus])
                });
            }
        },
        {
            key: "getCommonProps",
            value: function getCommonProps() {
                var clearValue = this.clearValue, cx = this.cx, getStyles = this.getStyles, getClassNames = this.getClassNames, getValue = this.getValue, selectOption = this.selectOption, setValue = this.setValue, props = this.props;
                var isMulti = props.isMulti, isRtl = props.isRtl, options = props.options;
                var hasValue = this.hasValue();
                return {
                    clearValue: clearValue,
                    cx: cx,
                    getStyles: getStyles,
                    getClassNames: getClassNames,
                    getValue: getValue,
                    hasValue: hasValue,
                    isMulti: isMulti,
                    isRtl: isRtl,
                    options: options,
                    selectOption: selectOption,
                    selectProps: props,
                    setValue: setValue
                };
            }
        },
        {
            key: "hasValue",
            value: function hasValue() {
                var selectValue = this.state.selectValue;
                return selectValue.length > 0;
            }
        },
        {
            key: "hasOptions",
            value: function hasOptions() {
                return !!this.getFocusableOptions().length;
            }
        },
        {
            key: "isClearable",
            value: function isClearable() {
                var _this$props7 = this.props, isClearable = _this$props7.isClearable, isMulti = _this$props7.isMulti;
                // single select, by default, IS NOT clearable
                // multi select, by default, IS clearable
                if (isClearable === undefined) return isMulti;
                return isClearable;
            }
        },
        {
            key: "isOptionDisabled",
            value: function isOptionDisabled(option, selectValue) {
                return $b738ed358e8eabef$var$_isOptionDisabled(this.props, option, selectValue);
            }
        },
        {
            key: "isOptionSelected",
            value: function isOptionSelected(option, selectValue) {
                return $b738ed358e8eabef$var$_isOptionSelected(this.props, option, selectValue);
            }
        },
        {
            key: "filterOption",
            value: function filterOption(option, inputValue) {
                return $b738ed358e8eabef$var$_filterOption(this.props, option, inputValue);
            }
        },
        {
            key: "formatOptionLabel",
            value: function formatOptionLabel(data, context) {
                var _this$props$component;
                if (typeof this.props.formatOptionLabel === 'function') {
                    var inputValue = this.props.inputValue;
                    var selectValue = this.state.selectValue;
                    return this.props.formatOptionLabel(data, {
                        context: context,
                        inputValue: inputValue,
                        selectValue: selectValue
                    });
                }
                // Auto-render elemBefore in dropdown menu only if formatOptionLabel is not provided
                // and no custom Option component is provided (custom Option components may already
                // render elemBefore themselves, causing it to appear twice)
                if (context === 'menu' && !this.props.formatOptionLabel && !((_this$props$component = this.props.components) !== null && _this$props$component !== void 0 && _this$props$component.Option) && (0, $13a186c4459b8c2a$export$b40ec24ac8275656)('platform-dst-lozenge-tag-badge-visual-uplifts')) {
                    var elemBefore = data.elemBefore;
                    if (elemBefore) {
                        var label = this.getOptionLabel(data);
                        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("div", {
                            className: (0, $lqU89.default)([
                                "_zulpu2gc _1e0c1txw _4cvr1h6o"
                            ])
                        }, elemBefore, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("span", null, label));
                    }
                }
                return this.getOptionLabel(data);
            }
        },
        {
            key: "formatGroupLabel",
            value: function formatGroupLabel(data) {
                return this.props.formatGroupLabel(data);
            }
        },
        {
            key: "calculateDescription",
            value: function calculateDescription() {
                var descriptionProp = this.props['aria-describedby'] || this.props.descriptionId;
                var isMulti = this.props.isMulti;
                var hasValue = this.state.selectValue.length > 0;
                // Determine base description based on selection state
                var baseDescriptionId = hasValue ? isMulti ? '' : this.getElementId('single-value') : this.getElementId('placeholder');
                // Fast path for single select with no description prop
                if (!isMulti && !descriptionProp) return {
                    'aria-describedby': baseDescriptionId
                };
                // Build the describedby string efficiently
                var describedBy = baseDescriptionId;
                // Add description prop if it exists
                if (descriptionProp) describedBy = describedBy ? "".concat(descriptionProp, " ").concat(describedBy) : descriptionProp;
                // For multi-select, always add multi-message ID
                if (isMulti) {
                    var multiMessage = this.getElementId('multi-message');
                    describedBy = describedBy ? "".concat(describedBy, " ").concat(multiMessage) : multiMessage;
                }
                return {
                    'aria-describedby': describedBy
                };
            }
        },
        {
            key: "startListeningComposition",
            value: // ==============================
            // Composition Handlers
            // ==============================
            function startListeningComposition() {
                if (document && document.addEventListener) {
                    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                    document.addEventListener('compositionstart', this.onCompositionStart, false);
                    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                    document.addEventListener('compositionend', this.onCompositionEnd, false);
                }
            }
        },
        {
            key: "stopListeningComposition",
            value: function stopListeningComposition() {
                if (document && document.removeEventListener) {
                    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                    document.removeEventListener('compositionstart', this.onCompositionStart);
                    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                    document.removeEventListener('compositionend', this.onCompositionEnd);
                }
            }
        },
        {
            key: "startListeningToTouch",
            value: // ==============================
            // Touch Handlers
            // ==============================
            function startListeningToTouch() {
                if (document && document.addEventListener) {
                    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                    document.addEventListener('touchstart', this.onTouchStart, false);
                    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                    document.addEventListener('touchmove', this.onTouchMove, false);
                    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                    document.addEventListener('touchend', this.onTouchEnd, false);
                }
            }
        },
        {
            key: "stopListeningToTouch",
            value: function stopListeningToTouch() {
                if (document && document.removeEventListener) {
                    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                    document.removeEventListener('touchstart', this.onTouchStart);
                    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                    document.removeEventListener('touchmove', this.onTouchMove);
                    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                    document.removeEventListener('touchend', this.onTouchEnd);
                }
            }
        },
        {
            key: "renderInput",
            value: // ==============================
            // Renderers
            // ==============================
            function renderInput() {
                var _this$props8 = this.props, form = _this$props8.form, inputId = _this$props8.inputId, inputValue = _this$props8.inputValue, isDisabled = _this$props8.isDisabled, isInvalid = _this$props8.isInvalid, isRequired = _this$props8.isRequired, isSearchable = _this$props8.isSearchable, label = _this$props8.label, labelId = _this$props8.labelId, menuIsOpen = _this$props8.menuIsOpen, required = _this$props8.required, _this$props8$tabIndex = _this$props8.tabIndex, tabIndex = _this$props8$tabIndex === void 0 ? 0 : _this$props8$tabIndex, testId = _this$props8.testId;
                var _this$getComponents = this.getComponents(), Input = _this$getComponents.Input;
                var inputIsHidden = this.state.inputIsHidden;
                var commonProps = this.commonProps;
                var id = inputId || this.getElementId('input');
                var isDisabledA11yFixEnabled = (0, $13a186c4459b8c2a$export$b40ec24ac8275656)('platform_dst_select_disabled_a11y_fix');
                // aria attributes makes the JSX "noisy", separated for clarity
                var ariaAttributes = $b738ed358e8eabef$var$_objectSpread($b738ed358e8eabef$var$_objectSpread($b738ed358e8eabef$var$_objectSpread($b738ed358e8eabef$var$_objectSpread($b738ed358e8eabef$var$_objectSpread({}, !this.props.isSearchable && (0, $13a186c4459b8c2a$export$b40ec24ac8275656)('platform_fix_autocomplete_aria_for_select') ? {} : {
                    'aria-autocomplete': 'both'
                }), {}, {
                    'aria-errormessage': this.props['aria-errormessage'],
                    'aria-expanded': menuIsOpen,
                    // TODO: aria-haspopup is implied as listbox with role="combobox" and was deprecated for aria 1.2, we still might need to keep it for back compat
                    'aria-haspopup': this.props['UNSAFE_is_experimental_generic'] ? 'dialog' : 'listbox',
                    'aria-invalid': this.props['aria-invalid'] || isInvalid,
                    'aria-label': this.props['aria-label'] || label,
                    'aria-labelledby': this.props['aria-labelledby'] || labelId,
                    'aria-required': required || isRequired,
                    role: 'combobox',
                    'aria-activedescendant': this.props['UNSAFE_is_experimental_generic'] ? undefined : this.state.focusedOptionId || this.state.focusedValueId || undefined
                }, menuIsOpen && {
                    'aria-controls': this.getElementId('listbox')
                }), !isSearchable && !(0, $13a186c4459b8c2a$export$b40ec24ac8275656)('select_issearchable_aria-readonly_fix') && {
                    'aria-readonly': true
                }), isDisabledA11yFixEnabled && {
                    'aria-disabled': isDisabled || undefined
                }), this.calculateDescription());
                var effectiveTabIndex = isDisabledA11yFixEnabled && isDisabled ? -1 : tabIndex;
                if (!isSearchable) // use a dummy input to maintain focus/blur functionality
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $d5158de0056cce59$export$2e2bcd8739ae039), (0, $e7be1629a1f1b709$export$2e2bcd8739ae039)({
                    id: id,
                    innerRef: this.getInputRef,
                    onBlur: this.onInputBlur,
                    onChange: $b738ed358e8eabef$var$noop,
                    onFocus: this.onInputFocus,
                    disabled: isDisabled,
                    tabIndex: effectiveTabIndex,
                    inputMode: "none",
                    form: form,
                    value: "",
                    "data-testid": testId && "".concat(testId, "-select--input")
                }, ariaAttributes));
                // NOTE: Don't add the `name` prop to this Input, `name` is already a prop on the hidden input element that has the value of the select.
                // Adding `name` to this Input will cause unexpected behavior.
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(Input, (0, $e7be1629a1f1b709$export$2e2bcd8739ae039)({}, commonProps, {
                    autoCapitalize: "none",
                    autoComplete: "off",
                    autoCorrect: "off",
                    id: id,
                    testId: testId,
                    innerRef: this.getInputRef,
                    isDisabled: isDisabled,
                    isHidden: inputIsHidden,
                    onBlur: this.onInputBlur,
                    onChange: this.handleInputChange,
                    onFocus: this.onInputFocus,
                    spellCheck: "false",
                    tabIndex: effectiveTabIndex,
                    form: form,
                    type: "text",
                    value: inputValue
                }, ariaAttributes));
            }
        },
        {
            key: "renderPlaceholderOrValue",
            value: function renderPlaceholderOrValue() {
                var _this6 = this;
                var _this$getComponents2 = this.getComponents(), MultiValue = _this$getComponents2.MultiValue, MultiValueContainer = _this$getComponents2.MultiValueContainer, MultiValueLabel = _this$getComponents2.MultiValueLabel, MultiValueRemove = _this$getComponents2.MultiValueRemove, SingleValue = _this$getComponents2.SingleValue, Placeholder = _this$getComponents2.Placeholder;
                var commonProps = this.commonProps;
                var _this$props9 = this.props, controlShouldRenderValue = _this$props9.controlShouldRenderValue, isDisabled = _this$props9.isDisabled, isMulti = _this$props9.isMulti, inputValue = _this$props9.inputValue, placeholder = _this$props9.placeholder, testId = _this$props9.testId;
                var _this$state4 = this.state, selectValue = _this$state4.selectValue, focusedValue = _this$state4.focusedValue, isFocused = _this$state4.isFocused;
                if (!this.hasValue() || !controlShouldRenderValue) return inputValue ? null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(Placeholder, (0, $e7be1629a1f1b709$export$2e2bcd8739ae039)({}, commonProps, {
                    key: "placeholder",
                    isDisabled: isDisabled,
                    isFocused: isFocused,
                    innerProps: $b738ed358e8eabef$var$_objectSpread({
                        id: this.getElementId('placeholder')
                    }, testId && {
                        'data-testid': "".concat(testId, "-select--placeholder")
                    })
                }), placeholder);
                if (isMulti) return selectValue.map(function(opt, index) {
                    var isOptionFocused = opt === focusedValue;
                    var key = "".concat(_this6.getOptionLabel(opt), "-").concat(_this6.getOptionValue(opt));
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(MultiValue, (0, $e7be1629a1f1b709$export$2e2bcd8739ae039)({}, commonProps, {
                        components: {
                            Container: MultiValueContainer,
                            Label: MultiValueLabel,
                            Remove: MultiValueRemove
                        },
                        isFocused: isOptionFocused,
                        isDisabled: isDisabled,
                        key: key,
                        index: index,
                        removeProps: $b738ed358e8eabef$var$_objectSpread($b738ed358e8eabef$var$_objectSpread({
                            onClick: function onClick() {
                                return _this6.removeValue(opt);
                            },
                            onTouchEnd: function onTouchEnd() {
                                return _this6.removeValue(opt);
                            },
                            onMouseDown: function onMouseDown(e) {
                                e.preventDefault();
                            }
                        }, testId && {
                            'data-testid': "".concat(testId, "-select--multivalue-").concat(index, "-remove")
                        }), {}, {
                            id: "".concat(_this6.getElementId('selected-value'), "-").concat(index, "-remove")
                        }),
                        data: opt,
                        innerProps: $b738ed358e8eabef$var$_objectSpread($b738ed358e8eabef$var$_objectSpread({}, testId && {
                            'data-testid': "".concat(testId, "-select--multivalue-").concat(index)
                        }), {}, {
                            id: "".concat(_this6.getElementId('selected-value'), "-").concat(index)
                        })
                    }), _this6.formatOptionLabel(opt, 'value'));
                });
                if (inputValue) return null;
                var singleValue = selectValue[0];
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(SingleValue, (0, $e7be1629a1f1b709$export$2e2bcd8739ae039)({}, commonProps, {
                    data: singleValue,
                    isDisabled: isDisabled,
                    innerProps: $b738ed358e8eabef$var$_objectSpread({
                        id: this.getElementId('single-value')
                    }, isDisabled && (0, $13a186c4459b8c2a$export$b40ec24ac8275656)('platform_dst_select_disabled_a11y_fix') && {
                        'aria-hidden': true
                    })
                }), this.formatOptionLabel(singleValue, 'value'));
            }
        },
        {
            key: "renderClearIndicator",
            value: function renderClearIndicator() {
                var _this$getComponents3 = this.getComponents(), ClearIndicator = _this$getComponents3.ClearIndicator;
                var commonProps = this.commonProps;
                var _this$props0 = this.props, clearControlLabel = _this$props0.clearControlLabel, isDisabled = _this$props0.isDisabled, isLoading = _this$props0.isLoading, spacing = _this$props0.spacing, testId = _this$props0.testId;
                var isFocused = this.state.isFocused;
                if (!this.isClearable() || !ClearIndicator || isDisabled || !this.hasValue() || isLoading) return null;
                var innerProps = $b738ed358e8eabef$var$_objectSpread({
                    onMouseDown: this.onClearIndicatorMouseDown,
                    onTouchEnd: this.onClearIndicatorTouchEnd
                }, testId && {
                    'data-testid': "".concat(testId, "-select--clear-indicator")
                });
                var isCompact = spacing === 'compact';
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(ClearIndicator, (0, $e7be1629a1f1b709$export$2e2bcd8739ae039)({
                    clearControlLabel: clearControlLabel
                }, commonProps, {
                    innerProps: innerProps,
                    isFocused: isFocused,
                    isCompact: isCompact
                }));
            }
        },
        {
            key: "renderLoadingIndicator",
            value: function renderLoadingIndicator() {
                var _this$getComponents4 = this.getComponents(), LoadingIndicator = _this$getComponents4.LoadingIndicator;
                var commonProps = this.commonProps;
                var _this$props1 = this.props, isDisabled = _this$props1.isDisabled, isLoading = _this$props1.isLoading, spacing = _this$props1.spacing, testId = _this$props1.testId;
                var isFocused = this.state.isFocused;
                if (!LoadingIndicator || !isLoading) return null;
                var isCompact = spacing === 'compact';
                var innerProps = {
                    'aria-hidden': 'true'
                };
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(LoadingIndicator, (0, $e7be1629a1f1b709$export$2e2bcd8739ae039)({
                    "data-testid": testId && "".concat(testId, "-select--loading-indicator")
                }, commonProps, {
                    innerProps: innerProps,
                    isDisabled: isDisabled,
                    isFocused: isFocused,
                    isCompact: isCompact
                }));
            }
        },
        {
            key: "renderDropdownIndicator",
            value: function renderDropdownIndicator() {
                var _this$getComponents5 = this.getComponents(), DropdownIndicator = _this$getComponents5.DropdownIndicator;
                if (!DropdownIndicator) return null;
                var commonProps = this.commonProps;
                var _this$props10 = this.props, isDisabled = _this$props10.isDisabled, spacing = _this$props10.spacing, testId = _this$props10.testId;
                var isFocused = this.state.isFocused;
                var isCompact = spacing === 'compact';
                var innerProps = $b738ed358e8eabef$var$_objectSpread({
                    onMouseDown: this.onDropdownIndicatorMouseDown,
                    onTouchEnd: this.onDropdownIndicatorTouchEnd,
                    // Always hidden: DropdownIndicator hoists aria-hidden onto consumer-supplied
                    // children only, keeping the voice-control button visible to AT.
                    'aria-hidden': 'true'
                }, testId && {
                    'data-testid': "".concat(testId, "-select--dropdown-indicator")
                });
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(DropdownIndicator, (0, $e7be1629a1f1b709$export$2e2bcd8739ae039)({}, commonProps, {
                    innerProps: innerProps,
                    isDisabled: isDisabled,
                    isFocused: isFocused,
                    isCompact: isCompact
                }));
            }
        },
        {
            key: "renderMenu",
            value: function renderMenu() {
                var _this7 = this;
                var _this$getComponents6 = this.getComponents(), Group = _this$getComponents6.Group, GroupHeading = _this$getComponents6.GroupHeading, Menu = _this$getComponents6.Menu, MenuList = _this$getComponents6.MenuList, MenuPortal = _this$getComponents6.MenuPortal, LoadingMessage = _this$getComponents6.LoadingMessage, NoOptionsMessage = _this$getComponents6.NoOptionsMessage, Option = _this$getComponents6.Option;
                var commonProps = this.commonProps;
                var focusedOption = this.state.focusedOption;
                var _this$props11 = this.props, captureMenuScroll = _this$props11.captureMenuScroll, inputValue = _this$props11.inputValue, isLoading = _this$props11.isLoading, loadingMessage = _this$props11.loadingMessage, minMenuHeight = _this$props11.minMenuHeight, maxMenuHeight = _this$props11.maxMenuHeight, menuIsOpen = _this$props11.menuIsOpen, menuPlacement = _this$props11.menuPlacement, menuPosition = _this$props11.menuPosition, menuPortalTarget = _this$props11.menuPortalTarget, menuShouldBlockScroll = _this$props11.menuShouldBlockScroll, menuShouldScrollIntoView = _this$props11.menuShouldScrollIntoView, noOptionsMessage = _this$props11.noOptionsMessage, onMenuScrollToTop = _this$props11.onMenuScrollToTop, onMenuScrollToBottom = _this$props11.onMenuScrollToBottom, testId = _this$props11.testId;
                if (!menuIsOpen) return null;
                // TODO: Internal Option Type here
                var render = function render(props, id, headingId) {
                    var type = props.type, data = props.data, isDisabled = props.isDisabled, isSelected = props.isSelected, label = props.label, value = props.value;
                    var isFocused = focusedOption === data;
                    var onHover = isDisabled ? undefined : function() {
                        return _this7.onOptionHover(data);
                    };
                    var onSelect = isDisabled ? undefined : function() {
                        return _this7.selectOption(data);
                    };
                    var optionId = "".concat(_this7.getElementId('option'), "-").concat(id);
                    var innerProps = $b738ed358e8eabef$var$_objectSpread({
                        id: optionId,
                        onClick: onSelect,
                        onMouseMove: onHover,
                        onMouseOver: onHover,
                        role: _this7.props['UNSAFE_is_experimental_generic'] ? 'listitem' : 'option',
                        'aria-selected': _this7.props['UNSAFE_is_experimental_generic'] ? undefined : isSelected,
                        // We don't want aria-disabled if it's false. It's just noisy.
                        'aria-disabled': !isDisabled ? undefined : isDisabled,
                        'aria-describedby': headingId
                    }, testId && {
                        'data-testid': "".concat(testId, "-select--option-").concat(id)
                    });
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(Option, (0, $e7be1629a1f1b709$export$2e2bcd8739ae039)({}, commonProps, {
                        innerProps: innerProps,
                        data: data,
                        isDisabled: isDisabled,
                        isSelected: isSelected,
                        key: optionId,
                        label: label,
                        type: type,
                        value: value,
                        isFocused: isFocused,
                        innerRef: isFocused ? _this7.getFocusedOptionRef : undefined
                    }), _this7.formatOptionLabel(props.data, 'menu'));
                };
                var menuUI;
                if (this.hasOptions()) {
                    var items = this.getCategorizedOptions();
                    menuUI = items.map(function(item) {
                        if (item.type === 'group') {
                            var data = item.data, options = item.options, groupIndex = item.index;
                            var groupId = "".concat(_this7.getElementId('group'), "-").concat(groupIndex);
                            var headingId = "".concat(groupId, "-heading");
                            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(Group, (0, $e7be1629a1f1b709$export$2e2bcd8739ae039)({}, commonProps, {
                                key: groupId,
                                data: data,
                                options: options,
                                Heading: GroupHeading,
                                headingProps: $b738ed358e8eabef$var$_objectSpread({
                                    id: headingId,
                                    data: item.data
                                }, testId && {
                                    'data-testid': "".concat(testId, "-select--group-").concat(groupIndex, "-heading")
                                }),
                                label: _this7.formatGroupLabel(item.data)
                            }), item.options.map(function(option) {
                                return render(option, "".concat(groupIndex, "-").concat(option.index), headingId);
                            }));
                        } else if (item.type === 'option') return render(item, "".concat(item.index));
                        return undefined;
                    });
                } else if (isLoading) {
                    var message = loadingMessage({
                        inputValue: inputValue
                    });
                    if (message === null) return null;
                    menuUI = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(LoadingMessage, commonProps, message);
                } else {
                    var _message = noOptionsMessage({
                        inputValue: inputValue
                    });
                    if (_message === null) return null;
                    menuUI = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(NoOptionsMessage, (0, $e7be1629a1f1b709$export$2e2bcd8739ae039)({}, commonProps, {
                        innerProps: $b738ed358e8eabef$var$_objectSpread($b738ed358e8eabef$var$_objectSpread({}, this.props['UNSAFE_is_experimental_generic'] && {
                            role: 'listitem'
                        }), testId && {
                            'data-testid': "".concat(testId, "-select--no-options")
                        })
                    }), _message);
                }
                var menuPlacementProps = {
                    minMenuHeight: minMenuHeight,
                    maxMenuHeight: maxMenuHeight,
                    menuPlacement: menuPlacement,
                    menuPosition: menuPosition,
                    menuShouldScrollIntoView: menuShouldScrollIntoView
                };
                var menuElement = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $2b7ed2fe38f50ad4$export$2e2bcd8739ae039), (0, $e7be1629a1f1b709$export$2e2bcd8739ae039)({}, commonProps, menuPlacementProps), function(_ref4) {
                    var ref = _ref4.ref, _ref4$placerProps = _ref4.placerProps, placement = _ref4$placerProps.placement, maxHeight = _ref4$placerProps.maxHeight;
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(Menu, (0, $e7be1629a1f1b709$export$2e2bcd8739ae039)({}, commonProps, menuPlacementProps, {
                        innerRef: ref,
                        innerProps: $b738ed358e8eabef$var$_objectSpread({
                            onMouseDown: _this7.onMenuMouseDown,
                            onMouseMove: _this7.onMenuMouseMove,
                            id: _this7.props.components.Menu ? _this7.getElementId('listbox') : undefined
                        }, testId && {
                            'data-testid': "".concat(testId, "-select--listbox-container")
                        }),
                        isLoading: isLoading,
                        placement: placement
                    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $d119b4910de4cb36$export$2e2bcd8739ae039), {
                        captureEnabled: captureMenuScroll,
                        onTopArrive: onMenuScrollToTop,
                        onBottomArrive: onMenuScrollToBottom,
                        lockEnabled: menuShouldBlockScroll
                    }, function(scrollTargetRef) {
                        var _this7$inputRef, _this7$inputRef2;
                        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(MenuList, (0, $e7be1629a1f1b709$export$2e2bcd8739ae039)({}, commonProps, {
                            innerRef: function innerRef(instance) {
                                _this7.getMenuListRef(instance);
                                scrollTargetRef(instance);
                            },
                            innerProps: $b738ed358e8eabef$var$_objectSpread($b738ed358e8eabef$var$_objectSpread($b738ed358e8eabef$var$_objectSpread({
                                role: _this7.props['UNSAFE_is_experimental_generic'] ? 'dialog' : 'listbox'
                            }, _this7.props['UNSAFE_is_experimental_generic'] && {
                                'aria-labelledby': ((_this7$inputRef = _this7.inputRef) === null || _this7$inputRef === void 0 ? void 0 : _this7$inputRef.id) || _this7.getElementId('input')
                            }), {}, {
                                'aria-multiselectable': !commonProps.isMulti || _this7.props['UNSAFE_is_experimental_generic'] ? undefined : commonProps.isMulti,
                                id: _this7.getElementId('listbox')
                            }, testId && {
                                'data-testid': "".concat(testId, "-select--listbox")
                            }), (0, $9cdac13a38ee471b$export$95df08bae54cb4df)() && !_this7.props['UNSAFE_is_experimental_generic'] && {
                                'aria-describedby': ((_this7$inputRef2 = _this7.inputRef) === null || _this7$inputRef2 === void 0 ? void 0 : _this7$inputRef2.id) || _this7.getElementId('input')
                            }),
                            isLoading: isLoading,
                            maxHeight: maxHeight,
                            focusedOption: focusedOption
                        }), _this7.props['UNSAFE_is_experimental_generic'] ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("div", {
                            role: "list"
                        }, menuUI) : menuUI);
                    }));
                });
                // On the top-layer path the menu always portals (into the top layer)
                // regardless of consumer `menuPortalTarget` / `menuPosition`. Off the
                // flag we keep the legacy "portal only when needed" behaviour.
                var shouldPortal = (0, $13a186c4459b8c2a$export$b40ec24ac8275656)('platform-dst-top-layer') || menuPortalTarget || menuPosition === 'fixed';
                if (!shouldPortal) return menuElement;
                // Top-layer path needs the state mirror so MenuPortalTopLayer re-renders
                // when the anchor attaches; legacy path keeps the direct ref read.
                var controlElementForPortal = (0, $13a186c4459b8c2a$export$b40ec24ac8275656)('platform-dst-top-layer') ? this.state.controlElement : this.controlRef;
                var menuPortal = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(MenuPortal, (0, $e7be1629a1f1b709$export$2e2bcd8739ae039)({}, commonProps, {
                    appendTo: menuPortalTarget,
                    controlElement: controlElementForPortal,
                    menuPlacement: menuPlacement,
                    menuPosition: menuPosition
                }), menuElement);
                // The Provider plumbs the close signal to MenuPortalTopLayer; not
                // needed on the legacy path.
                if (!(0, $13a186c4459b8c2a$export$b40ec24ac8275656)('platform-dst-top-layer')) return menuPortal;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $84894bad979d29dd$export$a0d5b29fa9affc38).Provider, {
                    value: this.handleOpenLayerObserverCloseSignal
                }, menuPortal);
            }
        },
        {
            key: "renderFormField",
            value: function renderFormField() {
                var _this8 = this;
                var _this$props12 = this.props, delimiter = _this$props12.delimiter, isDisabled = _this$props12.isDisabled, isMulti = _this$props12.isMulti, required = _this$props12.required, name = _this$props12.name;
                var selectValue = this.state.selectValue;
                if (required && !this.hasValue() && !isDisabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $49a988bf6ed17514$export$2e2bcd8739ae039), {
                    name: name,
                    onFocus: this.onValueInputFocus
                });
                if (!name || isDisabled) return;
                if (isMulti) {
                    if (delimiter) {
                        var value = selectValue.map(function(opt) {
                            return _this8.getOptionValue(opt);
                        }).join(delimiter);
                        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("input", {
                            name: name,
                            type: "hidden",
                            value: value
                        });
                    } else {
                        var input = selectValue.length > 0 ? selectValue.map(function(opt, i) {
                            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("input", {
                                key: "i-".concat(i),
                                name: name,
                                type: "hidden",
                                value: _this8.getOptionValue(opt)
                            });
                        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("input", {
                            name: name,
                            type: "hidden",
                            value: ""
                        });
                        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("div", null, input);
                    }
                } else {
                    var _value = selectValue[0] ? this.getOptionValue(selectValue[0]) : '';
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("input", {
                        name: name,
                        type: "hidden",
                        value: _value
                    });
                }
            }
        },
        {
            key: "renderLiveRegion",
            value: function renderLiveRegion() {
                var commonProps = this.commonProps;
                var _this$state5 = this.state, ariaSelection = _this$state5.ariaSelection, isFocused = _this$state5.isFocused, selectValue = _this$state5.selectValue;
                var focusableOptions = this.getFocusableOptions();
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $507ef597f8ab37f9$export$2e2bcd8739ae039), (0, $e7be1629a1f1b709$export$2e2bcd8739ae039)({}, commonProps, {
                    id: this.getElementId('live-region'),
                    ariaSelection: ariaSelection,
                    isFocused: isFocused,
                    selectValue: selectValue,
                    focusableOptions: focusableOptions
                }));
            }
        },
        {
            key: "renderMultiselectMessage",
            value: function renderMultiselectMessage() {
                // In the future, when we actually support touch devices, we'll need to update this to not be keyboard specific.
                // Also, since this is rendered onscreen, it should be transtlated automatically.
                var msg = ", multiple selections available, ".concat(this.state.selectValue.length ? 'Use left or right arrow keys to navigate selected items' : '');
                return(/*#__PURE__*/ // eslint-disable-next-line @atlaskit/design-system/use-primitives-text
                (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("span", {
                    id: this.getElementId('multi-message'),
                    hidden: true
                }, msg));
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$getComponents7 = this.getComponents(), Control = _this$getComponents7.Control, IndicatorsContainer = _this$getComponents7.IndicatorsContainer, SelectContainer = _this$getComponents7.SelectContainer, ValueContainer = _this$getComponents7.ValueContainer;
                var _this$props13 = this.props, className = _this$props13.className, id = _this$props13.id, isDisabled = _this$props13.isDisabled, menuIsOpen = _this$props13.menuIsOpen, isInvalid = _this$props13.isInvalid, testId = _this$props13.testId, _this$props13$appeara = _this$props13.appearance, appearance = _this$props13$appeara === void 0 ? 'default' : _this$props13$appeara, _this$props13$spacing = _this$props13.spacing, spacing = _this$props13$spacing === void 0 ? 'default' : _this$props13$spacing;
                var isFocused = this.state.isFocused;
                var commonProps = this.commonProps = this.getCommonProps();
                var isCompact = spacing === 'compact';
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $496cc08df8fb5c0d$export$50727c0a52da4015).Provider, {
                    value: this.getStyles
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(SelectContainer, (0, $e7be1629a1f1b709$export$2e2bcd8739ae039)({}, commonProps, {
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
                    className: className,
                    innerProps: $b738ed358e8eabef$var$_objectSpread({
                        id: id,
                        onKeyDown: this.onKeyDown
                    }, testId && {
                        'data-testid': testId && "".concat(testId, "-select--container")
                    }),
                    isDisabled: isDisabled,
                    isFocused: isFocused
                }), this.renderLiveRegion(), commonProps.isMulti && this.renderMultiselectMessage(), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(Control, (0, $e7be1629a1f1b709$export$2e2bcd8739ae039)({}, commonProps, {
                    innerRef: this.getControlRef,
                    innerProps: $b738ed358e8eabef$var$_objectSpread({
                        onMouseDown: this.onControlMouseDown,
                        onTouchEnd: this.onControlTouchEnd
                    }, testId && {
                        'data-testid': "".concat(testId, "-select--control")
                    }),
                    appearance: appearance,
                    isInvalid: isInvalid,
                    isDisabled: isDisabled,
                    isFocused: isFocused,
                    menuIsOpen: menuIsOpen,
                    isCompact: isCompact
                }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(ValueContainer, (0, $e7be1629a1f1b709$export$2e2bcd8739ae039)({}, commonProps, {
                    isDisabled: isDisabled,
                    isCompact: isCompact,
                    innerProps: $b738ed358e8eabef$var$_objectSpread($b738ed358e8eabef$var$_objectSpread({}, testId && {
                        'data-testid': "".concat(testId, "-select--value-container")
                    }), commonProps.isMulti && commonProps.hasValue && !(0, $9fe1d61f676e91d7$export$e1865c3bedcd822b)() && {
                        // Required to keep JAWS from popping out of forms mode when using LEFT/RIGHT arrow keys.
                        // This is Jedi Master level ARIA and not taken lightly. Do not modify without consulting
                        // DST Accessibility.
                        role: 'application'
                    })
                }), this.renderPlaceholderOrValue(), this.renderInput()), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(IndicatorsContainer, (0, $e7be1629a1f1b709$export$2e2bcd8739ae039)({}, commonProps, {
                    isDisabled: isDisabled,
                    innerProps: $b738ed358e8eabef$var$_objectSpread({}, testId && {
                        'data-testid': "".concat(testId, "-select--indicators-container")
                    })
                }), this.renderClearIndicator(), this.renderLoadingIndicator(), this.renderDropdownIndicator())), this.renderMenu(), this.renderFormField(), !(0, $13a186c4459b8c2a$export$b40ec24ac8275656)('platform-dst-top-layer') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $778ea5d5342e6297$export$17baa7c95b6ba1b8), {
                    isOpen: this.props.menuIsOpen,
                    onClose: this.handleOpenLayerObserverCloseSignal
                })));
            }
        }
    ], [
        {
            key: "getDerivedStateFromProps",
            value: function getDerivedStateFromProps(props, state) {
                var prevProps = state.prevProps, clearFocusValueOnUpdate = state.clearFocusValueOnUpdate, inputIsHiddenAfterUpdate = state.inputIsHiddenAfterUpdate, ariaSelection = state.ariaSelection, isFocused = state.isFocused, prevWasFocused = state.prevWasFocused, instancePrefix = state.instancePrefix;
                var options = props.options, value = props.value, menuIsOpen = props.menuIsOpen, inputValue = props.inputValue, isMulti = props.isMulti;
                var selectValue = (0, $b963148a95603e14$export$33f062f47f21a01)(value);
                var newMenuOptionsState = {};
                if (prevProps && (value !== prevProps.value || options !== prevProps.options || menuIsOpen !== prevProps.menuIsOpen || inputValue !== prevProps.inputValue)) {
                    var focusableOptions = menuIsOpen ? $b738ed358e8eabef$var$buildFocusableOptions(props, selectValue) : [];
                    var focusableOptionsWithIds = menuIsOpen ? $b738ed358e8eabef$var$buildFocusableOptionsWithIds($b738ed358e8eabef$var$buildCategorizedOptions(props, selectValue), "".concat(instancePrefix, "-option")) : [];
                    var focusedValue = clearFocusValueOnUpdate ? $b738ed358e8eabef$var$getNextFocusedValue(state, selectValue) : null;
                    var focusedOption = $b738ed358e8eabef$var$getNextFocusedOption(state, focusableOptions);
                    var focusedOptionId = $b738ed358e8eabef$var$getFocusedOptionId(focusableOptionsWithIds, focusedOption);
                    newMenuOptionsState = {
                        selectValue: selectValue,
                        focusedOption: focusedOption,
                        focusedOptionId: focusedOptionId,
                        focusableOptionsWithIds: focusableOptionsWithIds,
                        focusedValue: focusedValue,
                        clearFocusValueOnUpdate: false
                    };
                }
                // some updates should toggle the state of the input visibility
                var newInputIsHiddenState = inputIsHiddenAfterUpdate != null && props !== prevProps ? {
                    inputIsHidden: inputIsHiddenAfterUpdate,
                    inputIsHiddenAfterUpdate: undefined
                } : {};
                var newAriaSelection = ariaSelection;
                var hasKeptFocus = isFocused && prevWasFocused;
                if (isFocused && !hasKeptFocus) {
                    // If `value` or `defaultValue` props are not empty then announce them
                    // when the Select is initially focused
                    newAriaSelection = {
                        value: (0, $76c057a0598858d5$export$40fb9515c784cc3b)(isMulti, selectValue, selectValue[0] || null),
                        options: selectValue,
                        action: 'initial-input-focus'
                    };
                    hasKeptFocus = !prevWasFocused;
                }
                // If the 'initial-input-focus' action has been set already
                // then reset the ariaSelection to null
                if ((ariaSelection === null || ariaSelection === void 0 ? void 0 : ariaSelection.action) === 'initial-input-focus') newAriaSelection = null;
                return $b738ed358e8eabef$var$_objectSpread($b738ed358e8eabef$var$_objectSpread($b738ed358e8eabef$var$_objectSpread({}, newMenuOptionsState), newInputIsHiddenState), {}, {
                    prevProps: props,
                    ariaSelection: newAriaSelection,
                    prevWasFocused: hasKeptFocus
                });
            }
        }
    ]);
}((0, $5FkrB.Component));
(0, $90d31be1abcfa6da$export$2e2bcd8739ae039)($b738ed358e8eabef$export$2e2bcd8739ae039, "defaultProps", $b738ed358e8eabef$export$9c21a3269931e1e6);






var $5FkrB = parcelRequire("5FkrB");
var $2e56d54505363406$var$_excluded = [
    "defaultOptions",
    "cacheOptions",
    "loadOptions",
    "options",
    "isLoading",
    "onInputChange",
    "filterOption"
];
function $2e56d54505363406$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $2e56d54505363406$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $2e56d54505363406$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $90d31be1abcfa6da$export$2e2bcd8739ae039)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $2e56d54505363406$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $2e56d54505363406$var$handleInputChange(inputValue, actionMeta, onInputChange) {
    if (onInputChange) {
        var newValue = onInputChange(inputValue, actionMeta);
        if (typeof newValue === 'string') return newValue;
    }
    return inputValue;
}
function $2e56d54505363406$export$2e2bcd8739ae039(_ref) {
    var _ref$defaultOptions = _ref.defaultOptions, propsDefaultOptions = _ref$defaultOptions === void 0 ? false : _ref$defaultOptions, _ref$cacheOptions = _ref.cacheOptions, cacheOptions = _ref$cacheOptions === void 0 ? false : _ref$cacheOptions, propsLoadOptions = _ref.loadOptions, propsOptions = _ref.options, _ref$isLoading = _ref.isLoading, propsIsLoading = _ref$isLoading === void 0 ? false : _ref$isLoading, propsOnInputChange = _ref.onInputChange, _ref$filterOption = _ref.filterOption, filterOption = _ref$filterOption === void 0 ? null : _ref$filterOption, restSelectProps = (0, $9b3d50432d7c2d71$export$2e2bcd8739ae039)(_ref, $2e56d54505363406$var$_excluded);
    var propsInputValue = restSelectProps.inputValue;
    var lastRequest = (0, $5FkrB.useRef)(undefined);
    var mounted = (0, $5FkrB.useRef)(false);
    var _useState = (0, $5FkrB.useState)(Array.isArray(propsDefaultOptions) ? propsDefaultOptions : undefined), _useState2 = (0, $c99af517edc48a31$export$2e2bcd8739ae039)(_useState, 2), defaultOptions = _useState2[0], setDefaultOptions = _useState2[1];
    var _useState3 = (0, $5FkrB.useState)(typeof propsInputValue !== 'undefined' ? propsInputValue : ''), _useState4 = (0, $c99af517edc48a31$export$2e2bcd8739ae039)(_useState3, 2), stateInputValue = _useState4[0], setStateInputValue = _useState4[1];
    var _useState5 = (0, $5FkrB.useState)(propsDefaultOptions === true), _useState6 = (0, $c99af517edc48a31$export$2e2bcd8739ae039)(_useState5, 2), isLoading = _useState6[0], setIsLoading = _useState6[1];
    var _useState7 = (0, $5FkrB.useState)(undefined), _useState8 = (0, $c99af517edc48a31$export$2e2bcd8739ae039)(_useState7, 2), loadedInputValue = _useState8[0], setLoadedInputValue = _useState8[1];
    var _useState9 = (0, $5FkrB.useState)([]), _useState0 = (0, $c99af517edc48a31$export$2e2bcd8739ae039)(_useState9, 2), loadedOptions = _useState0[0], setLoadedOptions = _useState0[1];
    var _useState1 = (0, $5FkrB.useState)(false), _useState10 = (0, $c99af517edc48a31$export$2e2bcd8739ae039)(_useState1, 2), passEmptyOptions = _useState10[0], setPassEmptyOptions = _useState10[1];
    var _useState11 = (0, $5FkrB.useState)({}), _useState12 = (0, $c99af517edc48a31$export$2e2bcd8739ae039)(_useState11, 2), optionsCache = _useState12[0], setOptionsCache = _useState12[1];
    var _useState13 = (0, $5FkrB.useState)(undefined), _useState14 = (0, $c99af517edc48a31$export$2e2bcd8739ae039)(_useState13, 2), prevDefaultOptions = _useState14[0], setPrevDefaultOptions = _useState14[1];
    var _useState15 = (0, $5FkrB.useState)(undefined), _useState16 = (0, $c99af517edc48a31$export$2e2bcd8739ae039)(_useState15, 2), prevCacheOptions = _useState16[0], setPrevCacheOptions = _useState16[1];
    if (cacheOptions !== prevCacheOptions) {
        setOptionsCache({});
        setPrevCacheOptions(cacheOptions);
    }
    if (propsDefaultOptions !== prevDefaultOptions) {
        setDefaultOptions(Array.isArray(propsDefaultOptions) ? propsDefaultOptions : undefined);
        setPrevDefaultOptions(propsDefaultOptions);
    }
    (0, $5FkrB.useEffect)(function() {
        mounted.current = true;
        return function() {
            mounted.current = false;
        };
    }, []);
    var loadOptions = (0, $5FkrB.useCallback)(function(inputValue, callback) {
        if (!propsLoadOptions) return callback();
        var loader = propsLoadOptions(inputValue, callback);
        if (loader && typeof loader.then === 'function') loader.then(callback, function() {
            return callback();
        });
    }, [
        propsLoadOptions
    ]);
    (0, $5FkrB.useEffect)(function() {
        if (propsDefaultOptions === true) loadOptions(stateInputValue, function(options) {
            if (!mounted.current) return;
            setDefaultOptions(options || []);
            setIsLoading(!!lastRequest.current);
        });
    // NOTE: this effect is designed to only run when the component mounts,
    // so we don't want to include any hook dependencies
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    var onInputChange = (0, $5FkrB.useCallback)(function(newValue, actionMeta) {
        var inputValue = $2e56d54505363406$var$handleInputChange(newValue, actionMeta, propsOnInputChange);
        if (!inputValue) {
            lastRequest.current = undefined;
            setStateInputValue('');
            setLoadedInputValue('');
            setLoadedOptions([]);
            setIsLoading(false);
            setPassEmptyOptions(false);
            return;
        }
        if (cacheOptions && optionsCache[inputValue]) {
            setStateInputValue(inputValue);
            setLoadedInputValue(inputValue);
            setLoadedOptions(optionsCache[inputValue]);
            setIsLoading(false);
            setPassEmptyOptions(false);
        } else {
            var request = lastRequest.current = {};
            setStateInputValue(inputValue);
            setIsLoading(true);
            setPassEmptyOptions(!loadedInputValue);
            loadOptions(inputValue, function(options) {
                if (!mounted) return;
                if (request !== lastRequest.current) return;
                lastRequest.current = undefined;
                setIsLoading(false);
                setLoadedInputValue(inputValue);
                setLoadedOptions(options || []);
                setPassEmptyOptions(false);
                setOptionsCache(options ? $2e56d54505363406$var$_objectSpread($2e56d54505363406$var$_objectSpread({}, optionsCache), {}, (0, $90d31be1abcfa6da$export$2e2bcd8739ae039)({}, inputValue, options)) : optionsCache);
            });
        }
    }, [
        cacheOptions,
        loadOptions,
        loadedInputValue,
        optionsCache,
        propsOnInputChange
    ]);
    var options = passEmptyOptions ? [] : stateInputValue && loadedInputValue ? loadedOptions : defaultOptions || [];
    return $2e56d54505363406$var$_objectSpread($2e56d54505363406$var$_objectSpread({}, restSelectProps), {}, {
        options: options,
        isLoading: isLoading || propsIsLoading,
        onInputChange: onInputChange,
        filterOption: filterOption
    });
}






var $5FkrB = parcelRequire("5FkrB");
var $028d8a9078c2ff0c$var$_excluded = [
    "defaultInputValue",
    "defaultMenuIsOpen",
    "defaultValue",
    "inputValue",
    "menuIsOpen",
    "onChange",
    "onInputChange",
    "onMenuClose",
    "onMenuOpen",
    "value"
];
function $028d8a9078c2ff0c$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $028d8a9078c2ff0c$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $028d8a9078c2ff0c$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $90d31be1abcfa6da$export$2e2bcd8739ae039)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $028d8a9078c2ff0c$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $028d8a9078c2ff0c$export$2e2bcd8739ae039(_ref) {
    var _ref$defaultInputValu = _ref.defaultInputValue, defaultInputValue = _ref$defaultInputValu === void 0 ? '' : _ref$defaultInputValu, _ref$defaultMenuIsOpe = _ref.defaultMenuIsOpen, defaultMenuIsOpen = _ref$defaultMenuIsOpe === void 0 ? false : _ref$defaultMenuIsOpe, _ref$defaultValue = _ref.defaultValue, defaultValue = _ref$defaultValue === void 0 ? null : _ref$defaultValue, propsInputValue = _ref.inputValue, propsMenuIsOpen = _ref.menuIsOpen, propsOnChange = _ref.onChange, propsOnInputChange = _ref.onInputChange, propsOnMenuClose = _ref.onMenuClose, propsOnMenuOpen = _ref.onMenuOpen, propsValue = _ref.value, restSelectProps = (0, $9b3d50432d7c2d71$export$2e2bcd8739ae039)(_ref, $028d8a9078c2ff0c$var$_excluded);
    var _useState = (0, $5FkrB.useState)(propsInputValue !== undefined ? propsInputValue : defaultInputValue), _useState2 = (0, $c99af517edc48a31$export$2e2bcd8739ae039)(_useState, 2), stateInputValue = _useState2[0], setStateInputValue = _useState2[1];
    var _useState3 = (0, $5FkrB.useState)(propsMenuIsOpen !== undefined ? propsMenuIsOpen : defaultMenuIsOpen), _useState4 = (0, $c99af517edc48a31$export$2e2bcd8739ae039)(_useState3, 2), stateMenuIsOpen = _useState4[0], setStateMenuIsOpen = _useState4[1];
    var _useState5 = (0, $5FkrB.useState)(propsValue !== undefined ? propsValue : defaultValue), _useState6 = (0, $c99af517edc48a31$export$2e2bcd8739ae039)(_useState5, 2), stateValue = _useState6[0], setStateValue = _useState6[1];
    var onChange = (0, $5FkrB.useCallback)(function(value, actionMeta) {
        if (typeof propsOnChange === 'function') propsOnChange(value, actionMeta);
        setStateValue(value);
    }, [
        propsOnChange
    ]);
    var onInputChange = (0, $5FkrB.useCallback)(function(value, actionMeta) {
        var newValue;
        if (typeof propsOnInputChange === 'function') newValue = propsOnInputChange(value, actionMeta);
        setStateInputValue(newValue !== undefined ? newValue : value);
    }, [
        propsOnInputChange
    ]);
    var onMenuOpen = (0, $5FkrB.useCallback)(function() {
        if (typeof propsOnMenuOpen === 'function') propsOnMenuOpen();
        setStateMenuIsOpen(true);
    }, [
        propsOnMenuOpen
    ]);
    var onMenuClose = (0, $5FkrB.useCallback)(function() {
        if (typeof propsOnMenuClose === 'function') propsOnMenuClose();
        setStateMenuIsOpen(false);
    }, [
        propsOnMenuClose
    ]);
    var inputValue = propsInputValue !== undefined ? propsInputValue : stateInputValue;
    var menuIsOpen = propsMenuIsOpen !== undefined ? propsMenuIsOpen : stateMenuIsOpen;
    var value = propsValue !== undefined ? propsValue : stateValue;
    //@ts-ignore react-select unsupported props
    return $028d8a9078c2ff0c$var$_objectSpread($028d8a9078c2ff0c$var$_objectSpread({}, restSelectProps), {}, {
        inputValue: inputValue,
        menuIsOpen: menuIsOpen,
        onChange: onChange,
        onInputChange: onInputChange,
        onMenuClose: onMenuClose,
        onMenuOpen: onMenuOpen,
        value: value
    });
}


var $6396332b0f9b7c70$var$AsyncSelect = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function(props, ref) {
    // when isAsync is true, options are not provided and async props are used, we will enable async
    var isAsyncEnabledInBaseSelect = props.isAsync && !props.options && (!!props.loadOptions || !!props.defaultOptions);
    var stateManagedProps = (0, $2e56d54505363406$export$2e2bcd8739ae039)(props);
    // when isAsync is falsy or isAsyncEnabledInBaseSelect is true, we use async props, otherwise we use base props
    var selectAsyncProps = !props.isAsync || isAsyncEnabledInBaseSelect ? stateManagedProps : props;
    var selectProps = (0, $028d8a9078c2ff0c$export$2e2bcd8739ae039)(selectAsyncProps);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $b738ed358e8eabef$export$2e2bcd8739ae039), (0, $e7be1629a1f1b709$export$2e2bcd8739ae039)({
        ref: ref
    }, selectProps));
});
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$6396332b0f9b7c70$export$2e2bcd8739ae039 = $6396332b0f9b7c70$var$AsyncSelect;





var $5FkrB = parcelRequire("5FkrB");
var $e0fd45a91eb1a658$var$_excluded = [
    "ariaLiveMessages",
    "isInvalid",
    "onClickPreventDefault",
    "tabSelectsValue",
    "validationState"
];
function $e0fd45a91eb1a658$export$2e2bcd8739ae039(WrappedComponent) {
    var AtlaskitSelect = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function AtlaskitSelect(props, forwardedRef) {
        var ariaLiveMessages = props.ariaLiveMessages, isInvalid = props.isInvalid, _props$onClickPrevent = props.onClickPreventDefault, onClickPreventDefault = _props$onClickPrevent === void 0 ? true : _props$onClickPrevent, _props$tabSelectsValu = props.tabSelectsValue, tabSelectsValue = _props$tabSelectsValu === void 0 ? false : _props$tabSelectsValu, _props$validationStat = props.validationState, validationState = _props$validationStat === void 0 ? 'default' : _props$validationStat, restProps = (0, $f9613085755b341d$export$2e2bcd8739ae039)(props, $e0fd45a91eb1a658$var$_excluded);
        var internalSelectRef = (0, $5FkrB.useRef)(null);
        /**
     * The following `useImperativeHandle` hook exists for the sake of backwards compatibility.
     * This component used to be a class component which set the value of the `ref` prop to object with the properties and value as below.
     * This has lead to slightly odd usage of refs with this component, e.g. `myRef.current.select.select.controlRef` instead of just `myRef.current.select.controlRef`
     * In the next major release, this should removed and the ref should be passed directly to the wrapped component (given users have updated usage)
     * More info https://stash.atlassian.com/projects/ATLASSIAN/repos/atlassian-frontend-monorepo/pull-requests/88021/overview
     */ (0, $5FkrB.useImperativeHandle)(forwardedRef, function() {
            return {
                select: internalSelectRef.current,
                focus: function focus() {
                    var _internalSelectRef$cu;
                    return (_internalSelectRef$cu = internalSelectRef.current) === null || _internalSelectRef$cu === void 0 ? void 0 : _internalSelectRef$cu.focus();
                },
                blur: function blur() {
                    var _internalSelectRef$cu2;
                    return (_internalSelectRef$cu2 = internalSelectRef.current) === null || _internalSelectRef$cu2 === void 0 ? void 0 : _internalSelectRef$cu2.blur();
                }
            };
        }, []);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(WrappedComponent, (0, $63a3d0c6fb21a3ce$export$2e2bcd8739ae039)({
            ref: internalSelectRef,
            ariaLiveMessages: ariaLiveMessages,
            tabSelectsValue: tabSelectsValue,
            onClickPreventDefault: onClickPreventDefault,
            isInvalid: isInvalid || validationState === 'error'
        }, restProps, {
            // indicates react-select to be async by default using the base Select component
            // so that makers can pass all async props on the base select to async load options.
            isAsync: true
        }));
    });
    AtlaskitSelect.displayName = 'AtlaskitSelect';
    return AtlaskitSelect;
}


var $e260f84bd2b3a814$export$d1de3b251ccaa8a3 = (0, $e0fd45a91eb1a658$export$2e2bcd8739ae039)((0, $6396332b0f9b7c70$export$2e2bcd8739ae039));


var $5330bbf7705e7e35$var$packageName = "@atlaskit/select";
var $5330bbf7705e7e35$var$packageVersion = "22.6.2";
var $5330bbf7705e7e35$var$createAndFireEventOnAtlaskit = (0, $1b26d05f4a4d038a$export$2e2bcd8739ae039)('atlaskit');
var $5330bbf7705e7e35$var$Select = (0, $d7a2017ee54358d6$export$2e2bcd8739ae039)({
    componentName: 'select',
    packageName: $5330bbf7705e7e35$var$packageName,
    packageVersion: $5330bbf7705e7e35$var$packageVersion
})((0, $65bb486fda6c58bc$export$2e2bcd8739ae039)({
    onChange: $5330bbf7705e7e35$var$createAndFireEventOnAtlaskit({
        action: 'changed',
        actionSubject: 'option',
        attributes: {
            componentName: 'select',
            packageName: $5330bbf7705e7e35$var$packageName,
            packageVersion: $5330bbf7705e7e35$var$packageVersion
        }
    })
})((0, $e260f84bd2b3a814$export$d1de3b251ccaa8a3)));
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$5330bbf7705e7e35$export$2e2bcd8739ae039 = $5330bbf7705e7e35$var$Select;



var $6bnW7 = parcelRequire("6bnW7");
var $hrVKU = parcelRequire("hrVKU");

var $gDiFE = parcelRequire("gDiFE");
const $d37e54d793f8ad25$var$messages = (0, $6bnW7.defineMessages)({
    siteLabel: {
        id: 'siteSelector.label',
        defaultMessage: 'Use app on',
        description: 'Description for which sites user wants to authorize'
    },
    sitePlaceholder: {
        id: 'siteSelector.sitePlaceholder',
        defaultMessage: 'Choose a site',
        description: 'Placeholder for which sites user wants to authorize'
    }
});
const $d37e54d793f8ad25$var$siteSelectStyles = (0, $gDiFE.xcss)({
    minWidth: '250px'
});
const $d37e54d793f8ad25$var$dummyOptions = [
    {
        label: 'ay11.atlassian.net',
        value: 'ay11.atlassian.net'
    },
    {
        label: 'shipit.atlassian.net',
        value: 'shipit.atlassian.net'
    },
    {
        label: 'trello.atlassian.net',
        value: 'trello.atlassian.net'
    }
];
const $d37e54d793f8ad25$var$SiteSelector = ()=>{
    const { formatMessage: formatMessage } = (0, $hrVKU.default)();
    return /*#__PURE__*/ (0, $i3UfC.jsx)((0, $383dd904a5a5e5b0$export$e71c4d32a2263218), {
        xcss: $d37e54d793f8ad25$var$siteSelectStyles,
        children: /*#__PURE__*/ (0, $i3UfC.jsx)((0, $5330bbf7705e7e35$export$2e2bcd8739ae039), {
            options: $d37e54d793f8ad25$var$dummyOptions,
            placeholder: formatMessage($d37e54d793f8ad25$var$messages.sitePlaceholder)
        })
    });
};
var $d37e54d793f8ad25$export$2e2bcd8739ae039 = $d37e54d793f8ad25$var$SiteSelector;



var $i3UfC = parcelRequire("i3UfC");
/* section-message.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $amAaq = parcelRequire("amAaq");

var $5FkrB = parcelRequire("5FkrB");

var $gKzKW = parcelRequire("gKzKW");
function $d0778aa44ff9fe37$export$2e2bcd8739ae039() {
    return $d0778aa44ff9fe37$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $d0778aa44ff9fe37$export$2e2bcd8739ae039.apply(null, arguments);
}



var $74jTZ = parcelRequire("74jTZ");

var $5FkrB = parcelRequire("5FkrB");

/* tooltip.tsx generated by @compiled/babel-plugin v2.0.0 */ 

var $amAaq = parcelRequire("amAaq");

var $jgyhF = parcelRequire("jgyhF");


var $5FkrB = parcelRequire("5FkrB");


var $jgyhF = parcelRequire("jgyhF");

var $5FkrB = parcelRequire("5FkrB");


var $5MmUg = parcelRequire("5MmUg");

var $cdRUW = parcelRequire("cdRUW");

var $i1Bei = parcelRequire("i1Bei");

var $52fzZ = parcelRequire("52fzZ");

var $hYFGc = parcelRequire("hYFGc");

var $3DHSS = parcelRequire("3DHSS");

var $1Gcz8 = parcelRequire("1Gcz8");

var $jgyhF = parcelRequire("jgyhF");

var $GmDrz = parcelRequire("GmDrz");
var $d22b9ba8856bd28e$var$_process, $d22b9ba8856bd28e$var$_process2;
// We can't rely on NODE_ENV === 'test' if its value is already configured by the consumer to some other value, so better to use JEST_WORKER_ID
// https://jestjs.io/docs/environment-variables#jest_worker_id
var $d22b9ba8856bd28e$var$TESTS_MODE = (globalThis === null || globalThis === void 0 || ($d22b9ba8856bd28e$var$_process = globalThis.process) === null || $d22b9ba8856bd28e$var$_process === void 0 || ($d22b9ba8856bd28e$var$_process = $d22b9ba8856bd28e$var$_process.env) === null || $d22b9ba8856bd28e$var$_process === void 0 ? void 0 : $d22b9ba8856bd28e$var$_process.JEST_WORKER_ID) !== undefined;
var $d22b9ba8856bd28e$var$DEBUG_MODE = !$d22b9ba8856bd28e$var$TESTS_MODE && (globalThis === null || globalThis === void 0 || ($d22b9ba8856bd28e$var$_process2 = globalThis.process) === null || $d22b9ba8856bd28e$var$_process2 === void 0 || ($d22b9ba8856bd28e$var$_process2 = $d22b9ba8856bd28e$var$_process2.env) === null || $d22b9ba8856bd28e$var$_process2 === void 0 ? void 0 : $d22b9ba8856bd28e$var$_process2.NODE_ENV) !== 'production';
var $d22b9ba8856bd28e$export$1c9f709888824e05 = function debug() {
    var _console;
    if (!$d22b9ba8856bd28e$var$DEBUG_MODE) return;
    // eslint-disable-next-line no-console
    (_console = console).debug.apply(_console, arguments);
};



var $3ZMUU = parcelRequire("3ZMUU");
var $651047fb6cd7e946$var$pkgName = '@atlaskit/platform-feature-flags';
var $651047fb6cd7e946$export$7e41b1b2bdee3f98 = '__PLATFORM_FEATURE_FLAGS__';
var $651047fb6cd7e946$var$hasProcessEnv = typeof $3ZMUU !== 'undefined' && typeof $3ZMUU.env !== 'undefined';
// FF global overrides can be configured by test runners or Storybook
var $651047fb6cd7e946$var$ENV_ENABLE_PLATFORM_FF = $651047fb6cd7e946$var$hasProcessEnv ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;
// STORYBOOK_ENABLE_PLATFORM_FF is included as storybook only allows env vars prefixed with STORYBOOK
// https://github.com/storybookjs/storybook/issues/12270
var $651047fb6cd7e946$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF = $651047fb6cd7e946$var$hasProcessEnv ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;
var $651047fb6cd7e946$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE = $651047fb6cd7e946$var$ENV_ENABLE_PLATFORM_FF || $651047fb6cd7e946$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF;
var $651047fb6cd7e946$var$DEFAULT_PFF_GLOBAL = {
    booleanResolver: undefined
};
var $651047fb6cd7e946$var$globalVar = typeof window !== 'undefined' ? window : globalThis;
$651047fb6cd7e946$var$globalVar[$651047fb6cd7e946$export$7e41b1b2bdee3f98] = $651047fb6cd7e946$var$globalVar[$651047fb6cd7e946$export$7e41b1b2bdee3f98] || $651047fb6cd7e946$var$DEFAULT_PFF_GLOBAL;
function $651047fb6cd7e946$export$f2b591175b3e424c(resolver) {
    $651047fb6cd7e946$var$globalVar[$651047fb6cd7e946$export$7e41b1b2bdee3f98].booleanResolver = resolver;
}
function $651047fb6cd7e946$export$6333b6aff9fc6275(flagKey) {
    if ($651047fb6cd7e946$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE) {
        (0, $d22b9ba8856bd28e$export$1c9f709888824e05)('[%s]: The feature flags were enabled while running tests. The flag "%s" will be always enabled.', $651047fb6cd7e946$var$pkgName, flagKey);
        return true;
    }
    try {
        var _globalVar$PFF_GLOBAL, _globalVar$PFF_GLOBAL2, _globalVar$PFF_GLOBAL3;
        // booleanResolver will be empty for products like Trello, Elevate, Recruit etc.
        // Currently only Confluence, Jira and Bitbucket has set it.
        if (((_globalVar$PFF_GLOBAL = $651047fb6cd7e946$var$globalVar[$651047fb6cd7e946$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL === void 0 ? void 0 : _globalVar$PFF_GLOBAL.booleanResolver) === undefined || ((_globalVar$PFF_GLOBAL2 = $651047fb6cd7e946$var$globalVar[$651047fb6cd7e946$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL2 === void 0 ? void 0 : _globalVar$PFF_GLOBAL2.booleanResolver) === null) // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
        return (0, $GmDrz.default).checkGate(flagKey);
        var result = (_globalVar$PFF_GLOBAL3 = $651047fb6cd7e946$var$globalVar[$651047fb6cd7e946$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL3 === void 0 ? void 0 : _globalVar$PFF_GLOBAL3.booleanResolver(flagKey);
        if (typeof result !== 'boolean') {
            // eslint-disable-next-line no-console
            console.warn("".concat(flagKey, " resolved to a non-boolean value, returning false for safety"));
            return false;
        }
        return result;
    } catch (e) {
        return false;
    }
}


function $04c56fc59ca4184b$export$ba05d765b8392e5e(flagResolver) {
    (0, $651047fb6cd7e946$export$f2b591175b3e424c)(flagResolver);
}
function $04c56fc59ca4184b$export$470e5c2be1411c89(name) {
    return (0, $651047fb6cd7e946$export$6333b6aff9fc6275)(name);
}
function $04c56fc59ca4184b$export$b40ec24ac8275656(name) {
    return (0, $651047fb6cd7e946$export$6333b6aff9fc6275)(name);
}



var $hCM0e = parcelRequire("hCM0e");

var $cdRUW = parcelRequire("cdRUW");

var $i1Bei = parcelRequire("i1Bei");

var $jgyhF = parcelRequire("jgyhF");
function $963a3e8bf93037d5$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $963a3e8bf93037d5$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $963a3e8bf93037d5$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $jgyhF.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $963a3e8bf93037d5$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $963a3e8bf93037d5$export$ad4be5c2ec28cecf = function isAnalyticsEvent(obj) {
    var _obj$constructor;
    return obj instanceof $963a3e8bf93037d5$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 || (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === 'AnalyticsEvent';
};
// eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
var $963a3e8bf93037d5$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function AnalyticsEvent(props) {
        var _this = this;
        (0, $cdRUW.default)(this, AnalyticsEvent);
        (0, $jgyhF.default)(this, "_isAnalyticsEvent", true);
        (0, $jgyhF.default)(this, "clone", function() {
            // just a shallow clone, don't change sub refs unless you want to
            // affect the original's too
            var payload = $963a3e8bf93037d5$var$_objectSpread({}, _this.payload);
            return new AnalyticsEvent({
                payload: payload
            });
        });
        this.payload = props.payload;
    }
    return (0, $i1Bei.default)(AnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (typeof updater === 'function') this.payload = updater(this.payload);
                if ((0, $hCM0e.default)(updater) === 'object') this.payload = $963a3e8bf93037d5$var$_objectSpread($963a3e8bf93037d5$var$_objectSpread({}, this.payload), updater);
                return this;
            }
        }
    ]);
}();


function $cdd4371cb8fb2c52$var$_callSuper(t, o, e) {
    return o = (0, $hYFGc.default)(o), (0, $52fzZ.default)(t, $cdd4371cb8fb2c52$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, $hYFGc.default)(t).constructor) : o.apply(t, e));
}
function $cdd4371cb8fb2c52$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($cdd4371cb8fb2c52$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $cdd4371cb8fb2c52$var$_superPropGet(t, o, e, r) {
    var p = (0, $3DHSS.default)((0, $hYFGc.default)(1 & r ? t.prototype : t), o, e);
    return 2 & r && "function" == typeof p ? function(t) {
        return p.apply(e, t);
    } : p;
}
function $cdd4371cb8fb2c52$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $cdd4371cb8fb2c52$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $cdd4371cb8fb2c52$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $jgyhF.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $cdd4371cb8fb2c52$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $cdd4371cb8fb2c52$export$35f8383928ba8d7 = function isUIAnalyticsEvent(obj) {
    var _obj$constructor;
    return obj instanceof $cdd4371cb8fb2c52$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isUIAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 || (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === 'UIAnalyticsEvent';
};
/**
 * Produces a deep clone of an event payload.
 *
 * The historic implementation relied on `JSON.parse(JSON.stringify(...))`, a
 * "hacky" deep clone that does not support functions, regexs, Maps, Sets, etc.
 * Crucially, `JSON.stringify` also throws `TypeError: Converting circular
 * structure to JSON` when the payload contains a value with circular
 * references — e.g. a live DOM node carrying React fiber back-references
 * (`__reactFiber$...`). When that throw happens during a React render/commit it
 * escapes into product UI and trips an error boundary (HOT-127428).
 *
 * Analytics must never crash product UI (the same contract `fire` upholds), so
 * behind the `platform-analytics-next-safe-clone` gate we wrap the
 * serialization in a try/catch and fall back to a shallow clone — matching the
 * base `AnalyticsEvent.clone` behaviour — if the deep clone fails.
 *
 * NOTE: this is intentionally a module-scoped function rather than a class
 * member so it does not change the structural type of `UIAnalyticsEvent`, which
 * is hand-mocked across the monorepo.
 */ var $cdd4371cb8fb2c52$var$clonePayload = function clonePayload(payload) {
    if ((0, $04c56fc59ca4184b$export$b40ec24ac8275656)('platform-analytics-next-safe-clone')) try {
        return JSON.parse(JSON.stringify(payload));
    } catch (e) {
        // Shallow clone keeps the event usable without crashing the UI.
        return $cdd4371cb8fb2c52$var$_objectSpread({}, payload);
    }
    /**
   * A hacky "deep clone" of the object. This is limited in that it wont
   * support functions, regexs, Maps, Sets, etc, but none of those need to
   * be represented in our payload.
   */ return JSON.parse(JSON.stringify(payload));
};
// eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
var $cdd4371cb8fb2c52$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_AnalyticsEvent) {
    function UIAnalyticsEvent(props) {
        var _this;
        (0, $cdRUW.default)(this, UIAnalyticsEvent);
        _this = $cdd4371cb8fb2c52$var$_callSuper(this, UIAnalyticsEvent, [
            props
        ]);
        (0, $jgyhF.default)(_this, "_isUIAnalyticsEvent", true);
        (0, $jgyhF.default)(_this, "clone", function() {
            if (_this.hasFired) return null;
            var context = (0, $5MmUg.default)(_this.context);
            var handlers = (0, $5MmUg.default)(_this.handlers);
            var payload = $cdd4371cb8fb2c52$var$clonePayload(_this.payload);
            return new UIAnalyticsEvent({
                context: context,
                handlers: handlers,
                payload: payload
            });
        });
        (0, $jgyhF.default)(_this, "fire", function(channel) {
            if (_this.hasFired) return;
            _this.handlers.forEach(function(handler) {
                try {
                    handler(_this, channel);
                } catch (e) {}
            });
            _this.hasFired = true;
        });
        _this.context = props.context || [];
        _this.handlers = props.handlers || [];
        _this.hasFired = false;
        return _this;
    }
    (0, $1Gcz8.default)(UIAnalyticsEvent, _AnalyticsEvent);
    return (0, $i1Bei.default)(UIAnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (this.hasFired) return this;
                return $cdd4371cb8fb2c52$var$_superPropGet(UIAnalyticsEvent, "update", this, 3)([
                    updater
                ]);
            }
        }
    ]);
}((0, $963a3e8bf93037d5$export$2e2bcd8739ae039));



var $5FkrB = parcelRequire("5FkrB");

var $cb8c2722202daf65$export$d1f587f82ad51c4 = function useAnalyticsContext() {
    return (0, $5FkrB.useContext)((0, $d82667e77467cbe0$export$2e2bcd8739ae039));
};


function $e8f979d3de6c70c6$export$5bf35293e545f20c() {
    var analyticsContext = (0, $cb8c2722202daf65$export$d1f587f82ad51c4)();
    var createAnalyticsEvent = (0, $a060da77483cc5d3$export$33752cf3ee811995)(function(payload) {
        return new (0, $cdd4371cb8fb2c52$export$2e2bcd8739ae039)({
            context: analyticsContext.getAtlaskitAnalyticsContext(),
            handlers: analyticsContext.getAtlaskitAnalyticsEventHandlers(),
            payload: payload
        });
    }, [
        analyticsContext
    ]);
    return {
        createAnalyticsEvent: createAnalyticsEvent
    };
}



var $5FkrB = parcelRequire("5FkrB");
var $8bc92b0cd5f28aa3$export$1d27a74659855e44 = function useTrackedRef(value) {
    var ref = (0, $5FkrB.useRef)(value);
    ref.current = value;
    return ref;
};


function $58be19d1545a98de$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $58be19d1545a98de$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $58be19d1545a98de$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $jgyhF.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $58be19d1545a98de$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $58be19d1545a98de$export$1a04351537078b55(_ref) {
    var fn = _ref.fn, action = _ref.action, componentName = _ref.componentName, packageName = _ref.packageName, packageVersion = _ref.packageVersion, analyticsData = _ref.analyticsData;
    var _useAnalyticsEvents = (0, $e8f979d3de6c70c6$export$5bf35293e545f20c)(), createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
    // We put analyticsData and fn in a ref so that we don't need to break
    // memoization.
    // Generally these could be defined by consumers inline
    // and so we do this to avoid breaking memoization of useCallback
    var dataRef = (0, $8bc92b0cd5f28aa3$export$1d27a74659855e44)(analyticsData);
    var fnRef = (0, $8bc92b0cd5f28aa3$export$1d27a74659855e44)(fn);
    var handler = (0, $5FkrB.useCallback)(function() {
        var analyticsEvent = createAnalyticsEvent({
            action: action,
            actionSubject: componentName,
            attributes: {
                componentName: componentName,
                packageName: packageName,
                packageVersion: packageVersion
            }
        });
        // To avoid wrapping this component in AnalyticsContext we manually
        // push the parent context's meta data into the context.
        // Note: this new 'context'
        var context = $58be19d1545a98de$var$_objectSpread({
            componentName: componentName,
            packageName: packageName,
            packageVersion: packageVersion
        }, dataRef.current);
        analyticsEvent.context.push(context);
        // fire an event on the atlaskit channel
        var clone = analyticsEvent.clone();
        if (clone) clone.fire('atlaskit');
        fnRef.current(analyticsEvent);
    }, [
        // These are strings and won't change
        action,
        componentName,
        packageName,
        packageVersion,
        // This function is memoized in the context
        createAnalyticsEvent,
        // these are a stable ref because of the useTrackedRef hook
        dataRef,
        fnRef
    ]);
    return handler;
}






var $5FkrB = parcelRequire("5FkrB");

var $5FkrB = parcelRequire("5FkrB");
var $23a93eb63bc05ad5$export$5fbf4d7fae6cdc00 = /*#__PURE__*/ (0, $5FkrB.createContext)(null);



var $5FkrB = parcelRequire("5FkrB");

var $5FkrB = parcelRequire("5FkrB");
var $2359e204261793a7$export$644a49f3b8c50fcd = /*#__PURE__*/ (0, $5FkrB.createContext)(null);


function $02621745464a280f$export$1d57e79091cc3046() {
    var namespace = (0, $5FkrB.useContext)((0, $2359e204261793a7$export$644a49f3b8c50fcd));
    return namespace;
}


function $0d147846786c3387$export$469bb693f11edc7f(_ref) {
    var isOpen = _ref.isOpen, type = _ref.type, onClose = _ref.onClose;
    var context = (0, $5FkrB.useContext)((0, $23a93eb63bc05ad5$export$5fbf4d7fae6cdc00));
    var namespace = (0, $02621745464a280f$export$1d57e79091cc3046)();
    (0, $5FkrB.useEffect)(function() {
        /**
     * Registers the `onClose` callback with the OpenLayerObserver.
     */ if (context === null) return;
        if (!isOpen) /**
       * If the layer is not open, we are not registering the `onClose` callback.
       * This is important to prevent the `onClose` from being called for layers that
       * are not open.
       *
       * Some consumers mistakenly pass "toggle" functions to `onClose` callbacks for
       * layer components, as Popup, e.g. `onClose={() => setIsOpen(!isOpen)}`.
       */ return;
        return context.onClose(onClose, {
            namespace: namespace,
            type: type
        });
    }, [
        context,
        isOpen,
        namespace,
        onClose,
        type
    ]);
}



var $amAaq = parcelRequire("amAaq");

var $5FkrB = parcelRequire("5FkrB");

var $GmDrz = parcelRequire("GmDrz");
var $d0a4263aaf827a97$var$_process, $d0a4263aaf827a97$var$_process2;
// We can't rely on NODE_ENV === 'test' if its value is already configured by the consumer to some other value, so better to use JEST_WORKER_ID
// https://jestjs.io/docs/environment-variables#jest_worker_id
var $d0a4263aaf827a97$var$TESTS_MODE = (globalThis === null || globalThis === void 0 || ($d0a4263aaf827a97$var$_process = globalThis.process) === null || $d0a4263aaf827a97$var$_process === void 0 || ($d0a4263aaf827a97$var$_process = $d0a4263aaf827a97$var$_process.env) === null || $d0a4263aaf827a97$var$_process === void 0 ? void 0 : $d0a4263aaf827a97$var$_process.JEST_WORKER_ID) !== undefined;
var $d0a4263aaf827a97$var$DEBUG_MODE = !$d0a4263aaf827a97$var$TESTS_MODE && (globalThis === null || globalThis === void 0 || ($d0a4263aaf827a97$var$_process2 = globalThis.process) === null || $d0a4263aaf827a97$var$_process2 === void 0 || ($d0a4263aaf827a97$var$_process2 = $d0a4263aaf827a97$var$_process2.env) === null || $d0a4263aaf827a97$var$_process2 === void 0 ? void 0 : $d0a4263aaf827a97$var$_process2.NODE_ENV) !== 'production';
var $d0a4263aaf827a97$export$1c9f709888824e05 = function debug() {
    var _console;
    if (!$d0a4263aaf827a97$var$DEBUG_MODE) return;
    // eslint-disable-next-line no-console
    (_console = console).debug.apply(_console, arguments);
};



var $3ZMUU = parcelRequire("3ZMUU");
var $95744683ee069baa$export$7e41b1b2bdee3f98 = '__PLATFORM_FEATURE_FLAGS__';
var $95744683ee069baa$export$407f05df8e3ce9f3 = '@atlaskit/platform-feature-flags';
var $95744683ee069baa$export$75f4a1454eff2805 = typeof $3ZMUU !== 'undefined' && typeof $3ZMUU.env !== 'undefined';


var $4449edc979f15fb5$export$b574c24e1e6490f5 = (0, $95744683ee069baa$export$75f4a1454eff2805) ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;



var $b16a943caf58f20c$export$92f8b531feaeb23d = (0, $95744683ee069baa$export$75f4a1454eff2805) ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;



var $c5f8a9ec1f4778e5$var$DEFAULT_PFF_GLOBAL = {
    booleanResolver: undefined
};
var $c5f8a9ec1f4778e5$export$54ea85357b4e0159 = typeof window !== 'undefined' ? window : globalThis;
$c5f8a9ec1f4778e5$export$54ea85357b4e0159[0, $95744683ee069baa$export$7e41b1b2bdee3f98] = $c5f8a9ec1f4778e5$export$54ea85357b4e0159[0, $95744683ee069baa$export$7e41b1b2bdee3f98] || $c5f8a9ec1f4778e5$var$DEFAULT_PFF_GLOBAL;



var $5369b9b0a5feaa4a$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE = (0, $4449edc979f15fb5$export$b574c24e1e6490f5) || (0, $b16a943caf58f20c$export$92f8b531feaeb23d);
function $5369b9b0a5feaa4a$export$6333b6aff9fc6275(flagKey) {
    if ($5369b9b0a5feaa4a$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE) {
        (0, $d0a4263aaf827a97$export$1c9f709888824e05)('[%s]: The feature flags were enabled while running tests. The flag "%s" will be always enabled.', (0, $95744683ee069baa$export$407f05df8e3ce9f3), flagKey);
        return true;
    }
    try {
        var _globalVar$PFF_GLOBAL, _globalVar$PFF_GLOBAL2, _globalVar$PFF_GLOBAL3;
        // booleanResolver will be empty for products like Trello, Elevate, Recruit etc.
        // Currently only Confluence, Jira and Bitbucket has set it.
        if (((_globalVar$PFF_GLOBAL = (0, $c5f8a9ec1f4778e5$export$54ea85357b4e0159)[0, $95744683ee069baa$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL === void 0 ? void 0 : _globalVar$PFF_GLOBAL.booleanResolver) === undefined || ((_globalVar$PFF_GLOBAL2 = (0, $c5f8a9ec1f4778e5$export$54ea85357b4e0159)[0, $95744683ee069baa$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL2 === void 0 ? void 0 : _globalVar$PFF_GLOBAL2.booleanResolver) === null) // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
        return (0, $GmDrz.default).checkGate(flagKey);
        var result = (_globalVar$PFF_GLOBAL3 = (0, $c5f8a9ec1f4778e5$export$54ea85357b4e0159)[0, $95744683ee069baa$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL3 === void 0 ? void 0 : _globalVar$PFF_GLOBAL3.booleanResolver(flagKey);
        if (typeof result !== 'boolean') {
            // eslint-disable-next-line no-console
            console.warn("".concat(flagKey, " resolved to a non-boolean value, returning false for safety"));
            return false;
        }
        return result;
    } catch (e) {
        return false;
    }
}


function $2fcbb5e4cf9206d1$export$b40ec24ac8275656(name) {
    return (0, $5369b9b0a5feaa4a$export$6333b6aff9fc6275)(name);
}


/**
 * Internally we will be playing with an element that will always have a key defined.
 */ /**
 * Internal data passed to child motions.
 */ // We define empty context here so the object doesn't change.
var $ac89e4e24d91bc0a$var$emptyContext = {
    // Motions will always appear if not inside a exiting persistence component.
    appear: true,
    isExiting: false
};
/**
 * __Exiting context__
 *
 * An exiting context.
 */ var $ac89e4e24d91bc0a$var$ExitingContext = /*#__PURE__*/ (0, $5FkrB.createContext)($ac89e4e24d91bc0a$var$emptyContext);
/**
 * This method will wrap any React element with a context provider. We're using context (instead of
 * cloneElement) so we can communicate between multiple elements without the need of prop drilling
 * (results in a better API for consumers).
 */ var $ac89e4e24d91bc0a$var$wrapChildWithContextProvider = function wrapChildWithContextProvider(child) {
    var value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $ac89e4e24d91bc0a$var$emptyContext;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement($ac89e4e24d91bc0a$var$ExitingContext.Provider, {
        key: "".concat(child.key, "-provider"),
        value: value
    }, child);
};
/**
 * This function will convert all children types to an array while also filtering out non-valid React elements.
 */ var $ac89e4e24d91bc0a$var$childrenToArray = function childrenToArray(children) {
    var childrenAsArray = [];
    // We convert children to an array using this helper method as it will add keys to children that do not
    // have them, such as when we have hardcoded children that are conditionally rendered.
    (0, $5FkrB.Children).toArray(children).forEach(function(child) {
        // We ignore any boolean children to make our code a little more simple later on,
        // and also filter out any falsies (empty strings, nulls, and undefined).
        if (typeof child !== 'boolean' && Boolean(child)) // Children WILL have a key after being forced into an array using the React.Children helper.
        childrenAsArray.push(child);
    });
    return childrenAsArray;
};
var $ac89e4e24d91bc0a$var$spliceNewElementsIntoPrevious = function spliceNewElementsIntoPrevious(current, previous) {
    var splicedChildren = previous.concat([]);
    var previousMap = $ac89e4e24d91bc0a$var$childrenToObj(previous);
    for(var i = 0; i < current.length; i++){
        var child = current[i];
        var childIsNew = !previousMap[child.key];
        if (childIsNew) // This will insert the new element after the previous element.
        splicedChildren.splice(i + 1, 0, child);
    }
    return splicedChildren;
};
var $ac89e4e24d91bc0a$var$childrenToObj = function childrenToObj(children) {
    return children.reduce(function(acc, child) {
        acc[child.key] = child;
        return acc;
    }, {});
};
var $ac89e4e24d91bc0a$var$getMissingKeys = function getMissingKeys(current, previous) {
    var currentMapKeys = new Set(current.map(function(child) {
        return child.key;
    }));
    var missing = new Set();
    for(var i = 0; i < previous.length; i++){
        var element = previous[i];
        var _key = element.key;
        if (!currentMapKeys.has(_key)) missing.add(_key);
    }
    return missing;
};
/**
 * How does this component work?
 *
 * It looks at changes in its children to see what is removed.
 *
 * If a child is removed it clones it and wraps it with context providing an `onFinish` callback.
 *
 * The cloned child will call the `onFinish` when it finishes its exit animation,
 * which lets `ExitingPersistence` know to stop rendering it.
 */ /**
 * __ExitingPersistence__
 *
 * Useful for enabling elements to persist and animate away when they are removed from the DOM.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/motion/docs/entering-motion)
 */ var $ac89e4e24d91bc0a$var$ExitingPersistence = /*#__PURE__*/ (0, $5FkrB.memo)(function(_ref) {
    var _ref$appear = _ref.appear, appear = _ref$appear === void 0 ? false : _ref$appear, children = _ref.children, exitThenEnter = _ref.exitThenEnter;
    var _useState = (0, $5FkrB.useState)([
        null,
        children
    ]), _useState2 = (0, $amAaq.default)(_useState, 2), stateChildren = _useState2[0], setChildren = _useState2[1];
    var _useState3 = (0, $5FkrB.useState)([]), _useState4 = (0, $amAaq.default)(_useState3, 2), exitingChildren = _useState4[0], setExitingChildren = _useState4[1];
    var _useState5 = (0, $5FkrB.useState)(function() {
        return {
            appear: appear,
            isExiting: false
        };
    }), _useState6 = (0, $amAaq.default)(_useState5, 2), defaultContext = _useState6[0], setDefaultContext = _useState6[1];
    (0, $5FkrB.useEffect)(function() {
        if (!defaultContext.appear) setDefaultContext({
            appear: true,
            isExiting: false
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    /**
   * NOTE: This is a workaround for the test case written in Jira where the stateChildren is a boolean value because
   * useState is mocked to return a boolean value.
   */ if (typeof stateChildren === 'boolean') return children;
    var _stateChildren = (0, $amAaq.default)(stateChildren, 2), previousChildren = _stateChildren[0], currentChildren = _stateChildren[1];
    var previous = $ac89e4e24d91bc0a$var$childrenToArray(previousChildren);
    var current = $ac89e4e24d91bc0a$var$childrenToArray(currentChildren);
    if (currentChildren !== children) setChildren([
        currentChildren,
        children
    ]);
    var nextChildren = currentChildren !== children ? $ac89e4e24d91bc0a$var$childrenToArray(children) : current;
    var missingKeys = $ac89e4e24d91bc0a$var$getMissingKeys(nextChildren, previous);
    var isSomeChildRemoved = !!missingKeys.size;
    var visibleChildren = !isSomeChildRemoved && currentChildren !== children ? nextChildren : current;
    if (isSomeChildRemoved) visibleChildren = $ac89e4e24d91bc0a$var$spliceNewElementsIntoPrevious(current, previous);
    if (exitThenEnter) {
        if (exitingChildren.length) visibleChildren = (0, $2fcbb5e4cf9206d1$export$b40ec24ac8275656)('platform-dst-motion-uplift') ? previous : exitingChildren;
        else {
            var nextExitingChildren = visibleChildren.filter(function(child) {
                return missingKeys.has(child.key);
            });
            if (nextExitingChildren.length) setExitingChildren(nextExitingChildren);
        }
    }
    if (missingKeys.size) visibleChildren = visibleChildren.map(function(child) {
        var isExiting = missingKeys.has(child.key);
        return $ac89e4e24d91bc0a$var$wrapChildWithContextProvider(child, {
            appear: true,
            isExiting: isExiting,
            onFinish: isExiting ? function() {
                missingKeys.delete(child.key);
                if (missingKeys.size === 0) {
                    setChildren([
                        null,
                        children
                    ]);
                    setExitingChildren([]);
                }
            } : undefined
        });
    });
    else visibleChildren = visibleChildren.map(function(child) {
        return $ac89e4e24d91bc0a$var$wrapChildWithContextProvider(child, defaultContext);
    });
    return visibleChildren;
});
var $ac89e4e24d91bc0a$export$3b6f38abbdcbd000 = function useExitingPersistence() {
    return (0, $5FkrB.useContext)($ac89e4e24d91bc0a$var$ExitingContext);
};
$ac89e4e24d91bc0a$var$ExitingPersistence.displayName = 'ExitingPersistence';
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$ac89e4e24d91bc0a$export$2e2bcd8739ae039 = $ac89e4e24d91bc0a$var$ExitingPersistence;


var $5FkrB = parcelRequire("5FkrB");
/* keyframes-motion.tsx generated by @compiled/babel-plugin v0.40.0 */ 
var $amAaq = parcelRequire("amAaq");

var $5FkrB = parcelRequire("5FkrB");

var $gKzKW = parcelRequire("gKzKW");
/**
 * Think of this as the motion equivalent of the @atlaskit/theme `grid()`.
 */ var $89a1d837b0384605$export$368bacef0dacbe05 = 25;
var $89a1d837b0384605$export$38b928a7167ce124 = {
    none: 0,
    small: 100,
    medium: 350,
    large: 700
};



/**
 * Used to multiply the initial duration for exiting motions.
 */ var $a09103f1513db4ac$var$EXITING_MOTION_MULTIPLIER = 0.5;
var $a09103f1513db4ac$export$30fa1a2e62ae150c = {
    none: (0, $89a1d837b0384605$export$38b928a7167ce124).none,
    small: (0, $89a1d837b0384605$export$38b928a7167ce124).small * $a09103f1513db4ac$var$EXITING_MOTION_MULTIPLIER,
    medium: (0, $89a1d837b0384605$export$38b928a7167ce124).medium * $a09103f1513db4ac$var$EXITING_MOTION_MULTIPLIER,
    large: (0, $89a1d837b0384605$export$38b928a7167ce124).large * $a09103f1513db4ac$var$EXITING_MOTION_MULTIPLIER
};


var $d9b5c568ca63e0ea$export$c5406bd59b374abd = function isMatchMediaAvailable() {
    return typeof window !== 'undefined' && 'matchMedia' in window;
};


var $91aae3ad956e46fd$export$b7baf7667a68d87c = function isReducedMotion() {
    if (!(0, $d9b5c568ca63e0ea$export$c5406bd59b374abd)()) return false;
    var _window$matchMedia = window.matchMedia('(prefers-reduced-motion: reduce)'), matches = _window$matchMedia.matches;
    return matches;
};



var $5FkrB = parcelRequire("5FkrB");
// Handle both browser and Node.js environments
var $6407ba60b9bebfaf$var$getHookDeps = function getHookDeps(opts) {
    switch(opts.cleanup){
        case 'next-effect':
            return undefined;
        case 'unmount':
        default:
            return [];
    }
};
var $6407ba60b9bebfaf$export$4f34107a2b00f39c = function useSetTimeout() {
    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        cleanup: 'unmount'
    };
    var timeouts = (0, $5FkrB.useRef)([]);
    (0, $5FkrB.useEffect)(function() {
        return function() {
            if (timeouts.current.length) {
                timeouts.current.forEach(function(id) {
                    return clearTimeout(id);
                });
                timeouts.current = [];
            }
        };
    // We dynamically set this so we either clean up on the next effect - or on unmount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, $6407ba60b9bebfaf$var$getHookDeps(opts));
    return (0, $5FkrB.useCallback)(function(handler, timeout) {
        for(var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)args[_key - 2] = arguments[_key];
        var id = setTimeout.apply(void 0, [
            function() {
                timeouts.current = timeouts.current.filter(function(timeoutId) {
                    return timeoutId !== id;
                });
                handler();
            },
            timeout
        ].concat(args));
        timeouts.current.push(id);
    }, []);
};




var $amAaq = parcelRequire("amAaq");

var $5FkrB = parcelRequire("5FkrB");


var $5FkrB = parcelRequire("5FkrB");
var $95a93872a3445138$export$e5c5a5f917a5871c = typeof window === 'undefined' ? (0, $5FkrB.useEffect) : (0, $5FkrB.useLayoutEffect);


/* eslint-disable @repo/internal/react/disallow-unstable-values */ 
var $5FkrB = parcelRequire("5FkrB");
function $bd431a1b3c5c8e60$export$c485849f2e393253() {
    var identifier = (0, $5FkrB.useRef)('');
    if (!identifier.current) identifier.current = '_' + (Number(String(Math.random()).slice(2)) + Date.now() + Math.round(performance.now())).toString(36);
    return identifier.current;
}


var $dbc570dbf2ece5f3$var$StaggeredEntranceContext = /*#__PURE__*/ (0, $5FkrB.createContext)(function() {
    return {
        isReady: true,
        delay: 0,
        ref: (0, $adcefb868cf2fc9d$export$2e2bcd8739ae039)
    };
});
var $dbc570dbf2ece5f3$export$25c7213fc07ec080 = function useStaggeredEntrance() {
    var indentifier = (0, $bd431a1b3c5c8e60$export$c485849f2e393253)();
    var context = (0, $5FkrB.useContext)($dbc570dbf2ece5f3$var$StaggeredEntranceContext);
    return context(indentifier);
};
/**
 * For a list of elements that need to animate in,
 * this should be used in conjunction with entering components.
 * This does not need Javascript to execute so it will run immediately for any SSR rendered React apps before the JS has executed.
 *
 * Will dynamically add delay to each child entering component.
 * Unfortunately all entering components _NEED_ to be a direct descendant.
 */ var $dbc570dbf2ece5f3$var$StaggeredEntrance = function StaggeredEntrance(_ref) {
    var children = _ref.children, column = _ref.column, _ref$columns = _ref.columns, columns = _ref$columns === void 0 ? 'responsive' : _ref$columns, _ref$delayStep = _ref.delayStep, delayStep = _ref$delayStep === void 0 ? 50 : _ref$delayStep;
    var elementRefs = (0, $5FkrB.useRef)([]);
    var indexes = [];
    var _useState = (0, $5FkrB.useState)(function() {
        if (typeof columns === 'number') // A hardcoded columns is set so bail out and set it to that!
        return columns;
        if (typeof column === 'number') // A hardcoded column is set so we will set actualColumns to be 1.
        return 1;
        // We are in "responsive" mode.
        // So we will be calculating when the Javascript executes on the client how many columns there will be.
        return 0;
    }), _useState2 = (0, $amAaq.default)(_useState, 2), actualColumns = _useState2[0], setActualColumns = _useState2[1];
    (0, $95a93872a3445138$export$e5c5a5f917a5871c)(function() {
        // We want to only run this code when we are in "responsive" mode.
        // It is assumed we are in responsive mode if `columns` is "responsive",
        // we have children element refs ready to be read (i.e. if there are no children this won't run as well)
        // and finally that `actualColumns` is `0` - this is because for the first render cycle `actualColumns` will be `0` (set above)
        // and then after this layout effect runs the value for `actualColumns` will then be calculated and set.
        if (columns === 'responsive' && elementRefs.current.length && actualColumns === 0) {
            var currentTop = 0;
            var numberColumns = 0;
            if (elementRefs.current.length <= 1) {
                setActualColumns(1);
                return;
            }
            // We set the current top to the first elements.
            // We will be comparing this and incrementing the column count
            // until we hit an element that has a different offset top (or we run out of elements).
            currentTop = elementRefs.current[0] ? elementRefs.current[0].offsetTop : 0;
            for(var i = 0; i < elementRefs.current.length; i++){
                var child = elementRefs.current[i];
                if (!child) break;
                if (currentTop === child.offsetTop) {
                    numberColumns += 1;
                    if (elementRefs.current.length - 1 === i) setActualColumns(numberColumns);
                    continue;
                }
                setActualColumns(numberColumns);
                break;
            }
        }
    // We only want this effect to run once - on initial mount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement($dbc570dbf2ece5f3$var$StaggeredEntranceContext.Provider, {
        value: function value(id) {
            if (!indexes.includes(id)) indexes.push(id);
            var isReady = actualColumns > 0;
            var index = indexes.indexOf(id);
            var currentColumn = column || index % actualColumns;
            var currentRow = Math.floor(index / actualColumns);
            var distanceFromTopLeftElement = currentRow + currentColumn;
            // We don't want loads of elements to have the same staggered delay as it ends up looking slow for users.
            // To get around that we calculate the logarithm using `distanceFromTopLeftElement` which ends making
            // elements appear faster the further away from the top left element.
            var delay = Math.ceil(Math.log(distanceFromTopLeftElement + 1) * delayStep * 1.5) || 0;
            return {
                delay: delay,
                isReady: isReady,
                ref: function ref(element) {
                    return elementRefs.current[index] = element;
                }
            };
        }
    }, children);
};
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$dbc570dbf2ece5f3$export$2e2bcd8739ae039 = $dbc570dbf2ece5f3$var$StaggeredEntrance;


var $9e871f4b2519eb74$var$zoomIn = null;
var $9e871f4b2519eb74$var$zoomOut = null;
var $9e871f4b2519eb74$var$fadeIn = null;
var $9e871f4b2519eb74$var$fadeOut = null;
var $9e871f4b2519eb74$var$fadeInFromTop = null;
var $9e871f4b2519eb74$var$fadeOutFromTop = null;
var $9e871f4b2519eb74$var$fadeInFromLeft = null;
var $9e871f4b2519eb74$var$fadeOutFromLeft = null;
var $9e871f4b2519eb74$var$fadeInFromBottom = null;
var $9e871f4b2519eb74$var$fadeOutFromBottom = null;
var $9e871f4b2519eb74$var$fadeInFromRight = null;
var $9e871f4b2519eb74$var$fadeOutFromRight = null;
var $9e871f4b2519eb74$var$fadeInFromTopConstant = null;
var $9e871f4b2519eb74$var$fadeOutFromTopConstant = null;
var $9e871f4b2519eb74$var$fadeInFromLeftConstant = null;
var $9e871f4b2519eb74$var$fadeOutFromLeftConstant = null;
var $9e871f4b2519eb74$var$fadeInFromBottomConstant = null;
var $9e871f4b2519eb74$var$fadeOutFromBottomConstant = null;
var $9e871f4b2519eb74$var$fadeInFromRightConstant = null;
var $9e871f4b2519eb74$var$fadeOutFromRightConstant = null;
var $9e871f4b2519eb74$var$slideInFromTop = null;
var $9e871f4b2519eb74$var$slideOutFromTop = null;
var $9e871f4b2519eb74$var$slideInFromRight = null;
var $9e871f4b2519eb74$var$slideOutFromRight = null;
var $9e871f4b2519eb74$var$slideInFromBottom = null;
var $9e871f4b2519eb74$var$slideOutFromBottom = null;
var $9e871f4b2519eb74$var$slideInFromLeft = null;
var $9e871f4b2519eb74$var$slideOutFromLeft = null;
/**
 * These are props that motions should use as their external props for consumers.
 * See [FadeIn](packages/helpers/motion/src/entering/fade-in.tsx) for an example usage.
 */ /**
 * This is the base INTERNAL component used for all other entering motions.
 * This does not need Javascript to execute on the client so it will run immediately
 * for any SSR rendered React apps before the JS has executed.
 */ var $9e871f4b2519eb74$var$EnteringMotion = function EnteringMotion(_ref) {
    var children = _ref.children, animationTimingFunction = _ref.animationTimingFunction, _ref$animationTimingF = _ref.animationTimingFunctionExiting, animationTimingFunctionExiting = _ref$animationTimingF === void 0 ? animationTimingFunction : _ref$animationTimingF, enteringAnimation = _ref.enteringAnimation, _ref$exitingAnimation = _ref.exitingAnimation, exitingAnimation = _ref$exitingAnimation === void 0 ? enteringAnimation : _ref$exitingAnimation, isPaused = _ref.isPaused, onFinishMotion = _ref.onFinish, _ref$duration = _ref.duration, duration = _ref$duration === void 0 ? 'large' : _ref$duration;
    var staggered = (0, $dbc570dbf2ece5f3$export$25c7213fc07ec080)();
    var _useExitingPersistenc = (0, $ac89e4e24d91bc0a$export$3b6f38abbdcbd000)(), isExiting = _useExitingPersistenc.isExiting, onExitFinished = _useExitingPersistenc.onFinish, appear = _useExitingPersistenc.appear;
    var setTimeout = (0, $6407ba60b9bebfaf$export$4f34107a2b00f39c)();
    var paused = isPaused || !staggered.isReady;
    var delay = isExiting ? 0 : staggered.delay;
    var state = isExiting ? 'exiting' : 'entering';
    var _useState = (0, $5FkrB.useState)(appear), _useState2 = (0, $amAaq.default)(_useState, 2), hasAnimationStyles = _useState2[0], setHasAnimationStyles = _useState2[1];
    (0, $5FkrB.useEffect)(function() {
        // Tracking this to prevent changing state on an unmounted component
        var isCancelled = false;
        if (paused) return;
        // On initial mount if elements aren't set to animate on appear, we return early and callback
        if (!appear) {
            onFinishMotion && onFinishMotion(state);
            return;
        }
        /**
     * Updates relevant state.
     * Called when the animation is finished, or immediately with reduced motion.
     */ var onAnimationEnd = function onAnimationEnd() {
            if (state === 'exiting') // Updates the `ExitingPersistence` to remove this child
            onExitFinished === null || onExitFinished === void 0 || onExitFinished();
            if (!isCancelled) setHasAnimationStyles(false);
            onFinishMotion === null || onFinishMotion === void 0 || onFinishMotion(state);
        };
        if ((0, $91aae3ad956e46fd$export$b7baf7667a68d87c)()) {
            // If there is reduced motion there is no exit animation, so call this immediately
            onAnimationEnd();
            return;
        }
        // Elements may need animation styles back after initial mount (they could animate out)
        setHasAnimationStyles(true);
        // Queue `onAnimationEnd` for after the animation has finished
        setTimeout(onAnimationEnd, isExiting ? (0, $a09103f1513db4ac$export$30fa1a2e62ae150c)[duration] : (0, $89a1d837b0384605$export$38b928a7167ce124)[duration] + delay);
        return function() {
            isCancelled = true;
        };
    // We ignore this for onFinishMotion as consumers could potentially inline the function
    // which would then trigger this effect every re-render.
    // We want to make it easier for consumers so we go down this path unfortunately.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        onExitFinished,
        state,
        isExiting,
        duration,
        delay,
        paused,
        setTimeout
    ]);
    return children({
        ref: staggered.ref,
        // @ts-expect-error: `ax` is not typed correctly
        className: hasAnimationStyles ? (0, $gKzKW.default)([
            (0, $gKzKW.default)([
                "_1o51eoah _1y0co91m _1bumglyw _sedtglyw"
            ]),
            paused && (0, $gKzKW.default)([
                "_1y0ctrqk"
            ]),
            duration === 'small' && (0, $gKzKW.default)([
                "_5sag1yx9"
            ]),
            duration === 'medium' && (0, $gKzKW.default)([
                "_5sag1ttt"
            ]),
            duration === 'large' && (0, $gKzKW.default)([
                "_5sagpwmj"
            ]),
            isExiting && duration === 'small' && (0, $gKzKW.default)([
                "_5sag14ed"
            ]),
            isExiting && duration === 'medium' && (0, $gKzKW.default)([
                "_5sagluct"
            ]),
            isExiting && duration === 'large' && (0, $gKzKW.default)([
                "_5sag1ttt"
            ]),
            isExiting && (0, $gKzKW.default)([
                "_ju255cps _1o51q7pw"
            ]),
            !isExiting && animationTimingFunction === 'linear' && (0, $gKzKW.default)([
                "_1pglp3kn"
            ]),
            !isExiting && animationTimingFunction === 'ease-out' && (0, $gKzKW.default)([
                "_1pgldkwg"
            ]),
            !isExiting && animationTimingFunction === 'ease-in' && (0, $gKzKW.default)([
                "_1pgl1nzg"
            ]),
            !isExiting && animationTimingFunction === 'ease-in-40-out' && (0, $gKzKW.default)([
                "_1pgl5y64"
            ]),
            !isExiting && animationTimingFunction === 'ease-in-60-out' && (0, $gKzKW.default)([
                "_1pgl1ddy"
            ]),
            !isExiting && animationTimingFunction === 'ease-in-80-out' && (0, $gKzKW.default)([
                "_1pglannl"
            ]),
            !isExiting && animationTimingFunction === 'ease-in-out' && (0, $gKzKW.default)([
                "_1pgl1fu8"
            ]),
            isExiting && animationTimingFunction === 'linear' && (0, $gKzKW.default)([
                "_1pglp3kn"
            ]),
            isExiting && animationTimingFunctionExiting === 'ease-out' && (0, $gKzKW.default)([
                "_1pgldkwg"
            ]),
            isExiting && animationTimingFunctionExiting === 'ease-in' && (0, $gKzKW.default)([
                "_1pgl1nzg"
            ]),
            isExiting && animationTimingFunctionExiting === 'ease-in-40-out' && (0, $gKzKW.default)([
                "_1pgl5y64"
            ]),
            isExiting && animationTimingFunctionExiting === 'ease-in-60-out' && (0, $gKzKW.default)([
                "_1pgl1ddy"
            ]),
            isExiting && animationTimingFunctionExiting === 'ease-in-80-out' && (0, $gKzKW.default)([
                "_1pglannl"
            ]),
            isExiting && animationTimingFunctionExiting === 'ease-in-out' && (0, $gKzKW.default)([
                "_1pgl1fu8"
            ]),
            (!isExiting && enteringAnimation === 'fade-in' || isExiting && exitingAnimation === 'fade-in') && (0, $gKzKW.default)([
                "_j7hq1cgr"
            ]),
            (!isExiting && enteringAnimation === 'fade-out' || isExiting && exitingAnimation === 'fade-out') && (0, $gKzKW.default)([
                "_j7hq1lln"
            ]),
            (!isExiting && enteringAnimation === 'zoom-in' || isExiting && exitingAnimation === 'zoom-in') && (0, $gKzKW.default)([
                "_j7hqe8p0"
            ]),
            (!isExiting && enteringAnimation === 'zoom-out' || isExiting && exitingAnimation === 'zoom-out') && (0, $gKzKW.default)([
                "_j7hqy6ql"
            ]),
            (!isExiting && enteringAnimation === 'slide-in-from-top' || isExiting && exitingAnimation === 'slide-in-from-top') && (0, $gKzKW.default)([
                "_j7hqqshu"
            ]),
            (!isExiting && enteringAnimation === 'slide-out-from-top' || isExiting && exitingAnimation === 'slide-out-from-top') && (0, $gKzKW.default)([
                "_j7hq7ri4"
            ]),
            (!isExiting && enteringAnimation === 'slide-in-from-right' || isExiting && exitingAnimation === 'slide-in-from-right') && (0, $gKzKW.default)([
                "_j7hqdfjr"
            ]),
            (!isExiting && enteringAnimation === 'slide-out-from-right' || isExiting && exitingAnimation === 'slide-out-from-right') && (0, $gKzKW.default)([
                "_j7hqonfj"
            ]),
            (!isExiting && enteringAnimation === 'slide-in-from-bottom' || isExiting && exitingAnimation === 'slide-in-from-bottom') && (0, $gKzKW.default)([
                "_j7hq1liq"
            ]),
            (!isExiting && enteringAnimation === 'slide-out-from-bottom' || isExiting && exitingAnimation === 'slide-out-from-bottom') && (0, $gKzKW.default)([
                "_j7hqhnf1"
            ]),
            (!isExiting && enteringAnimation === 'slide-in-from-left' || isExiting && exitingAnimation === 'slide-in-from-left') && (0, $gKzKW.default)([
                "_j7hq1bh1"
            ]),
            (!isExiting && enteringAnimation === 'slide-out-from-left' || isExiting && exitingAnimation === 'slide-out-from-left') && (0, $gKzKW.default)([
                "_j7hqj08w"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-top' || isExiting && exitingAnimation === 'fade-in-from-top') && (0, $gKzKW.default)([
                "_j7hq2iua"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-top' || isExiting && exitingAnimation === 'fade-out-from-top') && (0, $gKzKW.default)([
                "_j7hq39va"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-left' || isExiting && exitingAnimation === 'fade-in-from-left') && (0, $gKzKW.default)([
                "_j7hq15m2"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-left' || isExiting && exitingAnimation === 'fade-out-from-left') && (0, $gKzKW.default)([
                "_j7hq1yiv"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-bottom' || isExiting && exitingAnimation === 'fade-in-from-bottom') && (0, $gKzKW.default)([
                "_j7hq1w00"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-bottom' || isExiting && exitingAnimation === 'fade-out-from-bottom') && (0, $gKzKW.default)([
                "_j7hqzy3z"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-right' || isExiting && exitingAnimation === 'fade-in-from-right') && (0, $gKzKW.default)([
                "_j7hqpqak"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-right' || isExiting && exitingAnimation === 'fade-out-from-right') && (0, $gKzKW.default)([
                "_j7hq1ebg"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-top-constant' || isExiting && exitingAnimation === 'fade-in-from-top-constant') && (0, $gKzKW.default)([
                "_j7hqm2e2"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-top-constant' || isExiting && exitingAnimation === 'fade-out-from-top-constant') && (0, $gKzKW.default)([
                "_j7hq97jn"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-left-constant' || isExiting && exitingAnimation === 'fade-in-from-left-constant') && (0, $gKzKW.default)([
                "_j7hqovgq"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-left-constant' || isExiting && exitingAnimation === 'fade-out-from-left-constant') && (0, $gKzKW.default)([
                "_j7hq15do"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-bottom-constant' || isExiting && exitingAnimation === 'fade-in-from-bottom-constant') && (0, $gKzKW.default)([
                "_j7hq797a"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-bottom-constant' || isExiting && exitingAnimation === 'fade-out-from-bottom-constant') && (0, $gKzKW.default)([
                "_j7hqwo7r"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-right-constant' || isExiting && exitingAnimation === 'fade-in-from-right-constant') && (0, $gKzKW.default)([
                "_j7hqt8u5"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-right-constant' || isExiting && exitingAnimation === 'fade-out-from-right-constant') && (0, $gKzKW.default)([
                "_j7hq1pgp"
            ])
        ]) : '',
        style: {
            animationDelay: "".concat(delay, "ms")
        }
    }, state);
};
var $9e871f4b2519eb74$export$2e2bcd8739ae039 = $9e871f4b2519eb74$var$EnteringMotion;


var $b93dcd52e5399dad$var$invertedDirection = {
    top: 'bottom',
    bottom: 'top',
    left: 'right',
    right: 'left'
};
/**
 * Props for controlling the behavior of the FadeIn animation
 */ /**
 * __FadeIn__
 *
 * Useful for fading in one or more elements.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/motion/docs/entering-motion)
 */ var $b93dcd52e5399dad$var$FadeIn = function FadeIn(_ref) {
    var children = _ref.children, _ref$duration = _ref.duration, duration = _ref$duration === void 0 ? 'large' : _ref$duration, entranceDirection = _ref.entranceDirection, exitDirection = _ref.exitDirection, _ref$distance = _ref.distance, distance = _ref$distance === void 0 ? 'proportional' : _ref$distance, onFinish = _ref.onFinish, isPaused = _ref.isPaused;
    var invertedEntranceDirection = entranceDirection !== undefined ? $b93dcd52e5399dad$var$invertedDirection[entranceDirection] : undefined;
    var isExitDirect = Boolean(exitDirection || invertedEntranceDirection) ? "fade-out-from-".concat(exitDirection || invertedEntranceDirection).concat(distance === 'proportional' ? '' : '-constant') : 'fade-out';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $9e871f4b2519eb74$export$2e2bcd8739ae039), {
        duration: duration,
        enteringAnimation: entranceDirection ? "fade-in-from-".concat(entranceDirection).concat(distance === 'proportional' ? '' : '-constant') : 'fade-in',
        exitingAnimation: isExitDirect,
        animationTimingFunction: "ease-in-out",
        onFinish: onFinish,
        isPaused: isPaused
    }, children);
};
var $b93dcd52e5399dad$export$2e2bcd8739ae039 = $b93dcd52e5399dad$var$FadeIn;




var $5MmUg = parcelRequire("5MmUg");

var $amAaq = parcelRequire("amAaq");

var $5FkrB = parcelRequire("5FkrB");



var $amAaq = parcelRequire("amAaq");
function $f1b6b8ddda6257f2$export$6d8c2b45c99d6e3f(_ref) {
    var viewportPadding = _ref.viewportPadding;
    return [
        {
            /**
     * Performing DOM measurements in the 'read' phase,
     * which is the convention for popper modifiers
     */ name: 'maxSizeData',
            enabled: true,
            phase: 'read',
            fn: function fn(_ref2) {
                var state = _ref2.state, name = _ref2.name;
                if (!window.visualViewport) return;
                state.modifiersData[name] = {
                    viewport: {
                        width: window.visualViewport.width,
                        height: window.visualViewport.height
                    }
                };
            }
        },
        {
            /**
     * Applying max size CSS
     */ name: 'maxSize',
            enabled: true,
            phase: 'beforeWrite',
            requiresIfExists: [
                'offset',
                'preventOverflow',
                'flip'
            ],
            fn: function fn(_ref3) {
                var _data$viewport, _data$viewport2, _state$modifiersData$2, _state$modifiersData;
                var state = _ref3.state;
                var data = state.modifiersData.maxSizeData;
                if (typeof (data === null || data === void 0 || (_data$viewport = data.viewport) === null || _data$viewport === void 0 ? void 0 : _data$viewport.width) !== 'number' || typeof (data === null || data === void 0 || (_data$viewport2 = data.viewport) === null || _data$viewport2 === void 0 ? void 0 : _data$viewport2.height) !== 'number') // This shouldn't occur in a real browser but might in non-browser test environments
                return;
                var viewport = data.viewport;
                var _state$modifiersData$ = state.modifiersData.popperOffsets, popperOffsets = _state$modifiersData$ === void 0 ? {
                    x: 0,
                    y: 0
                } : _state$modifiersData$;
                var _state$placement$spli = state.placement.split('-'), _state$placement$spli2 = (0, $amAaq.default)(_state$placement$spli, 1), basePlacement = _state$placement$spli2[0];
                var placementOffset = (_state$modifiersData$2 = (_state$modifiersData = state.modifiersData) === null || _state$modifiersData === void 0 || (_state$modifiersData = _state$modifiersData.offset) === null || _state$modifiersData === void 0 ? void 0 : _state$modifiersData[state.placement]) !== null && _state$modifiersData$2 !== void 0 ? _state$modifiersData$2 : {
                    x: 0,
                    y: 0
                };
                // By default we set these to the entire viewport (minus padding)
                // Each placement direction will overwrite one of these
                var maxWidth = viewport.width - 2 * viewportPadding;
                var maxHeight = viewport.height - 2 * viewportPadding;
                if (basePlacement === 'top') maxHeight = state.rects.reference.y + // Viewport-relative position of reference element
                placementOffset.y - // Space between popper and reference
                viewportPadding;
                if (basePlacement === 'bottom') maxHeight = viewport.height - popperOffsets.y - // Viewport-relative position of popper
                viewportPadding;
                if (basePlacement === 'left') maxWidth = state.rects.reference.x + // Viewport-relative position of reference element
                placementOffset.x - // Space between popper and reference
                viewportPadding;
                if (basePlacement === 'right') maxWidth = viewport.width - popperOffsets.x - // Viewport-relative position of popper
                viewportPadding;
                state.styles.popper.maxWidth = "".concat(maxWidth, "px");
                state.styles.popper.maxHeight = "".concat(maxHeight, "px");
            }
        }
    ];
}


/* popper-top-layer.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $amAaq = parcelRequire("amAaq");


var $5FkrB = parcelRequire("5FkrB");




/**
 * The full mapping record. Internal - use `fromLegacyPlacement` from the
 * public entry-point so the offset-tuple translation is applied consistently.
 *
 * Note: `auto`, `auto-start`, `auto-end` map to `block-end` placements. This
 * is a reduction in expressiveness vs Popper.js (which picked the best
 * placement at runtime). CSS `position-try-fallbacks` flips at the edge but
 * the initial placement is fixed. Migration consumers who relied on Popper's
 * dynamic auto-flip should pick an explicit placement instead.
 */ var $d6d38c670a0bb1ec$export$27df359c528b7120 = {
    top: {
        axis: 'block',
        edge: 'start',
        align: 'center'
    },
    'top-start': {
        axis: 'block',
        edge: 'start',
        align: 'start'
    },
    'top-center': {
        axis: 'block',
        edge: 'start',
        align: 'center'
    },
    'top-end': {
        axis: 'block',
        edge: 'start',
        align: 'end'
    },
    bottom: {
        axis: 'block',
        edge: 'end',
        align: 'center'
    },
    'bottom-start': {
        axis: 'block',
        edge: 'end',
        align: 'start'
    },
    'bottom-center': {
        axis: 'block',
        edge: 'end',
        align: 'center'
    },
    'bottom-end': {
        axis: 'block',
        edge: 'end',
        align: 'end'
    },
    right: {
        axis: 'inline',
        edge: 'end',
        align: 'center'
    },
    'right-start': {
        axis: 'inline',
        edge: 'end',
        align: 'start'
    },
    'right-end': {
        axis: 'inline',
        edge: 'end',
        align: 'end'
    },
    left: {
        axis: 'inline',
        edge: 'start',
        align: 'center'
    },
    'left-start': {
        axis: 'inline',
        edge: 'start',
        align: 'start'
    },
    'left-end': {
        axis: 'inline',
        edge: 'start',
        align: 'end'
    },
    auto: {
        axis: 'block',
        edge: 'end',
        align: 'center'
    },
    'auto-start': {
        axis: 'block',
        edge: 'end',
        align: 'start'
    },
    'auto-end': {
        axis: 'block',
        edge: 'end',
        align: 'end'
    }
};


function $36dfe2fd333e00e5$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $36dfe2fd333e00e5$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $36dfe2fd333e00e5$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $c0cdd0771cd12eed$export$2e2bcd8739ae039)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $36dfe2fd333e00e5$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $36dfe2fd333e00e5$export$69e99ed50b2534c9(_ref) {
    var legacy = _ref.legacy, offset = _ref.offset;
    var basePlacement = (0, $d6d38c670a0bb1ec$export$27df359c528b7120)[legacy];
    if (!offset) return basePlacement;
    var _offset = (0, $498719f62abaa9dd$export$2e2bcd8739ae039)(offset, 2), along = _offset[0], away = _offset[1];
    return $36dfe2fd333e00e5$var$_objectSpread($36dfe2fd333e00e5$var$_objectSpread({}, basePlacement), {}, {
        offset: {
            gap: away,
            crossAxisShift: {
                // Sign is captured in `direction`; `value` is the magnitude.
                value: Math.abs(along),
                direction: along >= 0 ? 'forwards' : 'backwards'
            }
        }
    });
}





var $5FkrB = parcelRequire("5FkrB");

/**
 * A point in viewport coordinates (CSS pixels) at which the synthetic
 * anchor should be placed.
 *
 * Axis-named (`x`/`y`) rather than edge-named (`left`/`top`) so the
 * shape is unambiguous in RTL writing modes - there is no ambiguity
 * about whether a coordinate is logical (`inline-start`/`block-start`)
 * or physical (`left`/`top`). Viewport coordinates are always
 * physical, so we name them with the physical axis labels.
 */ /**
 * Styles the synthetic anchor as an invisible, zero-size point.
 * Dynamic `inset-*` overrides are written by the positioning effect.
 *
 * Uses `Object.assign` rather than Compiled CSS (element is outside the React tree)
 * or the internal `setStyle` helper (we own this element entirely - it is created
 * and removed by this hook - so the snapshot/restore semantics `setStyle`
 * provides for caller-owned elements would be dead work here).
 */ function $8e47134217b0f5cd$var$applyStaticAnchorStyles(element) {
    Object.assign(element.style, {
        position: 'fixed',
        // `top`/`left` rather than `inset-block-start`/`inset-inline-start`
        // for consistency with the dynamic positioning effect below, which
        // uses physical properties (see comment there for the rationale).
        top: '0',
        left: '0',
        // Zero size - placement decides which side the popover sits on.
        width: '0',
        height: '0',
        // Prevent the overlay from intercepting pointer events.
        pointerEvents: 'none'
    });
}
function $8e47134217b0f5cd$export$6f230729189a5b8a(_ref) {
    var popoverRef = _ref.popoverRef, placement = _ref.placement, getPoint = _ref.getPoint, _ref$isEnabled = _ref.isEnabled, isEnabled = _ref$isEnabled === void 0 ? true : _ref$isEnabled, isOpen = _ref.isOpen;
    var syntheticAnchorRef = (0, $5FkrB.useRef)(null);
    // `getPoint` is kept in a ref so the layout effect can call the
    // latest version without listing it as a dep - that would re-fire
    // on every render and re-latch the point.
    var getPointRef = (0, $5FkrB.useRef)(getPoint);
    getPointRef.current = getPoint;
    // Lazy element creation: the `<div>` is only created when both
    // `isEnabled` is true AND `getPoint()` returns a non-null point.
    // `useLayoutEffect` ensures the element exists before the inner
    // `useAnchorPosition` (also a layout effect) reads the ref.
    (0, $5FkrB.useLayoutEffect)(function() {
        if (!isEnabled) return;
        var point = getPointRef.current();
        if (!point) return;
        var anchor = document.createElement('div');
        anchor.setAttribute('aria-hidden', 'true');
        $8e47134217b0f5cd$var$applyStaticAnchorStyles(anchor);
        // `point.x`/`y` are physical viewport coordinates (from
        // `MouseEvent.clientX/Y`), so map directly onto physical
        // `left`/`top`. This is RTL-safe: `position: fixed` + physical
        // insets is direction-independent. Using logical
        // `inset-inline-start` would need `viewportWidth - point.x` in
        // RTL to land at the same physical pixel.
        anchor.style.top = "".concat(point.y, "px");
        anchor.style.left = "".concat(point.x, "px");
        document.body.appendChild(anchor);
        syntheticAnchorRef.current = anchor;
        return function cleanup() {
            anchor.remove();
            syntheticAnchorRef.current = null;
        };
    }, [
        isEnabled
    ]);
    // Mirror `isEnabled` so both hooks stay in sync - when disabled,
    // neither this hook nor the inner one touches the popover, leaving
    // any other positioning the consumer has set up free to take effect.
    (0, $62cae9a51e21bb99$export$56b02a1e583f953c)({
        anchorRef: syntheticAnchorRef,
        popoverRef: popoverRef,
        placement: placement,
        isEnabled: isEnabled,
        isOpen: isOpen
    });
}



function $151fa48246cb06c2$export$9198c6c168be2eeb() {
    // `@atlaskit/ds-lib/use-id` already strips characters that React's
    // `useId` produces (`:`, `«`, `»`) which are invalid in HTML ID
    // tokens. The `popover-` prefix is purely for DOM debug clarity.
    return "popover-".concat((0, $c797bf80d6171378$export$f680877a34711e37)());
}



/**
 * Reduces an anchor rect to the single viewport point that, wrapped in a
 * zero-size synthetic anchor, produces the same popover position
 * `useAnchorPosition` would for the given placement. This works because
 * `useAnchorPosition` only reads the edge / alignment corner of the rect,
 * so a coincident zero-size point is geometrically equivalent.
 *
 * RTL is resolved here so the downstream synthetic anchor only sees physical
 * coordinates. Defaults mirror `getPlacement` in
 * `@atlaskit/top-layer/placement-map` (`axis: 'block'`, `edge: 'end'`,
 * `align: 'center'`).
 */ function $19bc0696f5a49dfa$export$b065aeb850c3e87f(_ref) {
    var _placement$axis, _placement$edge, _placement$align;
    var rect = _ref.rect, placement = _ref.placement, isRtl = _ref.isRtl;
    var axis = (_placement$axis = placement.axis) !== null && _placement$axis !== void 0 ? _placement$axis : 'block';
    var edge = (_placement$edge = placement.edge) !== null && _placement$edge !== void 0 ? _placement$edge : 'end';
    var align = (_placement$align = placement.align) !== null && _placement$align !== void 0 ? _placement$align : 'center';
    if (axis === 'block') {
        // Popover sits above (`edge: 'start'`) or below (`edge: 'end'`)
        // the anchor. Hug the matching horizontal edge; align along x.
        var _y = edge === 'start' ? rect.top : rect.bottom;
        var _x = $19bc0696f5a49dfa$var$horizontalForAlign({
            rect: rect,
            align: align,
            isRtl: isRtl
        });
        return {
            x: _x,
            y: _y
        };
    }
    // `axis: 'inline'`: popover sits inline-start or inline-end of the
    // anchor. Hug the matching vertical edge; align along y.
    var x = $19bc0696f5a49dfa$var$inlineEdgeX({
        rect: rect,
        edge: edge,
        isRtl: isRtl
    });
    var y = $19bc0696f5a49dfa$var$verticalForAlign({
        rect: rect,
        align: align
    });
    return {
        x: x,
        y: y
    };
}
function $19bc0696f5a49dfa$var$horizontalForAlign(_ref2) {
    var rect = _ref2.rect, align = _ref2.align, isRtl = _ref2.isRtl;
    if (align === 'center') return rect.left + rect.width / 2;
    // `start` / `end` are logical. In LTR, `start` is the left edge.
    // In RTL, `start` is the right edge.
    var isStartLeft = !isRtl;
    if (align === 'start') return isStartLeft ? rect.left : rect.right;
    return isStartLeft ? rect.right : rect.left;
}
function $19bc0696f5a49dfa$var$verticalForAlign(_ref3) {
    var rect = _ref3.rect, align = _ref3.align;
    if (align === 'center') return rect.top + rect.height / 2;
    if (align === 'start') return rect.top;
    return rect.bottom;
}
function $19bc0696f5a49dfa$var$inlineEdgeX(_ref4) {
    var rect = _ref4.rect, edge = _ref4.edge, isRtl = _ref4.isRtl;
    var isStartLeft = !isRtl;
    if (edge === 'start') return isStartLeft ? rect.left : rect.right;
    return isStartLeft ? rect.right : rect.left;
}



var $5MmUg = parcelRequire("5MmUg");

var $5FkrB = parcelRequire("5FkrB");
/**
 * Sets inline styles on an element and returns a cleanup function that
 * restores the prior inline values (so we do not stomp consumer styles).
 *
 * Copied from `@atlaskit/top-layer`'s internal `setStyle` (not exported there
 * yet); inline here until top-layer exposes it via a subpath export.
 */ function $a745a305154475bf$export$37a5fde709c1db82(_ref) {
    var element = _ref.element, styles = _ref.styles;
    // Snapshot the prior inline value (NOT the computed style - we only want
    // to restore values that the consumer/our previous run inlined). An empty
    // string means "no inline value", in which case cleanup uses removeProperty.
    var priorValues = styles.map(function(_ref2) {
        var property = _ref2.property;
        return {
            property: property,
            value: element.style.getPropertyValue(property)
        };
    });
    styles.forEach(function(_ref3) {
        var property = _ref3.property, value = _ref3.value;
        element.style.setProperty(property, value);
    });
    return function cleanup() {
        priorValues.forEach(function(_ref4) {
            var property = _ref4.property, value = _ref4.value;
            if (value === '') {
                element.style.removeProperty(property);
                return;
            }
            element.style.setProperty(property, value);
        });
    };
}


/**
 * Applies the `shouldFitViewport` size caps directly to the
 * `position-area`-anchored popover host. Pure CSS — the browser owns every
 * value, so there is no measurement, no scroll/resize listeners, and no
 * `--ds-popper-anchor-*` custom properties.
 *
 * **Primary (placement) axis** is capped to `calc(100% - 5px - gap)`. Because
 * the host carries `position-area`, its containing block *is* the position-area
 * cell — the region between the anchor edge and the viewport edge — so `100%`
 * resolves to that distance. The popover is pushed `gap` into the cell by its
 * offset margin (`margin-*`, set by `useAnchorPosition`), so the gap is
 * subtracted as well to keep the legacy `viewportPadding = 5` on the far edge.
 * The cap is also more correct than measuring the requested placement: the cell
 * follows whichever side `position-try-fallbacks` actually flips to, so it
 * tracks the flip automatically.
 *
 * **Cross axis** is capped to `calc(100dvw|dvh - 10px)` (viewport, legacy
 * `2 * viewportPadding`). `display: flex` (plus a `min-*-size: 0` reset on the
 * child) lets an oversized child shrink and reflow to the cap. The host stays
 * `overflow: visible` so it never clips the consumer surface's `box-shadow`;
 * scrolling content that cannot reflow is the consumer surface's own
 * responsibility (it owns `overflow`), matching legacy `react-popper`, which
 * applied the cap to the consumer's own element.
 *
 * `min-inline-size` is reset to `0`. `useWidthFromAnchor({ mode: 'none' })`
 * floors the host at `max-content` so a too-narrow span overflows and drives
 * `position-try-fallbacks` rather than wrapping. That floor is the opposite of
 * fitting: when it exceeds a cap, CSS min/max resolution lets the min win and
 * the host overflows the viewport. In fit mode the caps must win, so the floor
 * is neutralised here; `setStyle` restores the prior inline value on cleanup.
 *
 * Verified in Chromium: `max-block-size: calc(100% - …)` on a `position: fixed`
 * + `position-area` element resolves `100%` to the cell, not the viewport.
 */ var $0ddd7708acc15704$var$CROSS_INLINE_CAP = 'calc(100dvw - 10px)';
var $0ddd7708acc15704$var$CROSS_BLOCK_CAP = 'calc(100dvh - 10px)';
/**
 * Legacy `viewportPadding` (`preventOverflow` padding) the popover kept from
 * every viewport edge under `react-popper`. The caps above already *reserve*
 * this space (`- 5px` on the primary far edge, `- 10px` = `2 * 5px` on the
 * cross axis), but nothing makes the reservation land on the viewport side:
 * the anchor-side gap is a real margin (`useAnchorPosition`'s `edgeMargin`),
 * the viewport side has none, so a capped popover packs flush against the
 * viewport edge it slid/flipped to. Re-applying the padding as a margin on the
 * three non-anchor sides puts the reserved space back on the viewport side.
 * `position-try` flips mirror margins and slides keep them per-side, so the
 * gap tracks whichever edge the browser settles on.
 */ var $0ddd7708acc15704$var$VIEWPORT_PADDING = '5px';
/**
 * The popover's three non-anchor margin sides for a given placement axis — the
 * primary *far* side plus both cross sides. The remaining (anchor-facing) side
 * already carries the offset gap from `useAnchorPosition` and is left alone.
 */ var $0ddd7708acc15704$var$NON_ANCHOR_MARGIN_SIDES = {
    top: [
        'margin-block-start',
        'margin-inline-start',
        'margin-inline-end'
    ],
    bottom: [
        'margin-block-end',
        'margin-inline-start',
        'margin-inline-end'
    ],
    left: [
        'margin-inline-start',
        'margin-block-start',
        'margin-block-end'
    ],
    right: [
        'margin-inline-end',
        'margin-block-start',
        'margin-block-end'
    ]
};
function $0ddd7708acc15704$export$f16d8ac7373995e1(_ref) {
    var target = _ref.target, placementAxis = _ref.placementAxis, gap = _ref.gap, isEnabled = _ref.isEnabled, isOpen = _ref.isOpen;
    (0, $5FkrB.useLayoutEffect)(function() {
        var element = target.current;
        if (!element || !isEnabled) return;
        var isBlockAxis = placementAxis === 'top' || placementAxis === 'bottom';
        var primaryAxisCap = "calc(100% - 5px - ".concat(gap, ")");
        var cleanupHost = (0, $a745a305154475bf$export$37a5fde709c1db82)({
            element: element,
            styles: [
                {
                    property: 'display',
                    value: 'flex'
                },
                // Neutralise `useWidthFromAnchor`'s `min-inline-size: max-content`
                // floor so the caps below win and content reflows. `setStyle`
                // restores the floor on cleanup.
                {
                    property: 'min-inline-size',
                    value: '0'
                },
                isBlockAxis ? {
                    property: 'max-block-size',
                    value: primaryAxisCap
                } : {
                    property: 'max-inline-size',
                    value: primaryAxisCap
                },
                isBlockAxis ? {
                    property: 'max-inline-size',
                    value: $0ddd7708acc15704$var$CROSS_INLINE_CAP
                } : {
                    property: 'max-block-size',
                    value: $0ddd7708acc15704$var$CROSS_BLOCK_CAP
                }
            ].concat((0, $5MmUg.default)($0ddd7708acc15704$var$NON_ANCHOR_MARGIN_SIDES[placementAxis].map(function(property) {
                return {
                    property: property,
                    value: $0ddd7708acc15704$var$VIEWPORT_PADDING
                };
            })))
        });
        // The host deliberately stays `overflow: visible`. An ancestor with
        // `overflow: auto` clips a descendant's `box-shadow`, so capping and
        // scrolling on the host would strip the elevation shadow from the
        // consumer surface. Instead the host only constrains size; scrolling
        // oversized content is the consumer surface's own responsibility,
        // matching the contract `@atlaskit/top-layer`'s `PopoverSurface` follows
        // (shadow and `overflow` on one element). For that surface (the host's
        // flex child) to be clamped to the cap and scroll its own content, it
        // must be allowed to shrink below its intrinsic size, so reset its
        // min-size floor.
        var child = element.firstElementChild;
        var cleanupChild = child instanceof HTMLElement ? (0, $a745a305154475bf$export$37a5fde709c1db82)({
            element: child,
            styles: [
                {
                    property: 'min-block-size',
                    value: '0'
                },
                {
                    property: 'min-inline-size',
                    value: '0'
                }
            ]
        }) : undefined;
        return function() {
            cleanupHost();
            cleanupChild === null || cleanupChild === void 0 || cleanupChild();
        };
    }, [
        target,
        placementAxis,
        gap,
        isEnabled,
        isOpen
    ]);
}



var $5FkrB = parcelRequire("5FkrB");

var $5FkrB = parcelRequire("5FkrB");
var $2eba86ada2b8719a$export$8f73317645bb7b8e = /*#__PURE__*/ (0, $5FkrB.createContext)(null);


function $c393d22c07852abf$export$941a7e8bf0b9eafd() {
    return (0, $5FkrB.useContext)((0, $2eba86ada2b8719a$export$8f73317645bb7b8e));
}



var $amAaq = parcelRequire("amAaq");

var $5FkrB = parcelRequire("5FkrB");

/**
 * Returns the current viewport size in CSS pixels, preferring the visual
 * viewport (which accounts for pinch-zoom on touch devices) over the
 * layout viewport. Returns `{ width: 0, height: 0 }` in non-DOM
 * environments so callers can use the result unconditionally.
 */ function $5cfc96d0de350f98$export$64beed533e21f72d() {
    if (typeof window === 'undefined') return {
        width: 0,
        height: 0
    };
    var visual = window.visualViewport;
    if (visual) return {
        width: visual.width,
        height: visual.height
    };
    return {
        width: window.innerWidth,
        height: window.innerHeight
    };
}


var $a2543115b994f2d4$var$INITIAL = {
    isReferenceHidden: false,
    hasPopperEscaped: false
};
function $a2543115b994f2d4$var$isFullyOutsideViewport(rect, viewport) {
    if (rect.width === 0 && rect.height === 0) return true;
    if (rect.bottom <= 0) return true;
    if (rect.right <= 0) return true;
    if (rect.top >= viewport.height) return true;
    if (rect.left >= viewport.width) return true;
    return false;
}
function $a2543115b994f2d4$var$isClippingOverflow(value) {
    return value === 'auto' || value === 'scroll' || value === 'hidden' || value === 'clip';
}
function $a2543115b994f2d4$var$isClippedByAncestors(element) {
    var rect = element.getBoundingClientRect();
    var parent = element.parentElement;
    while(parent){
        // Read the longhand axis properties directly. The `overflow` shorthand
        // is only populated when both axes share the same value, so reading it
        // alone misses ancestors that set only `overflow-x` or `overflow-y`.
        var style = window.getComputedStyle(parent);
        var clipsHorizontally = $a2543115b994f2d4$var$isClippingOverflow(style.overflowX);
        var clipsVertically = $a2543115b994f2d4$var$isClippingOverflow(style.overflowY);
        if (clipsHorizontally || clipsVertically) {
            var parentRect = parent.getBoundingClientRect();
            var horizontallyOutside = rect.right <= parentRect.left || rect.left >= parentRect.right;
            var verticallyOutside = rect.bottom <= parentRect.top || rect.top >= parentRect.bottom;
            if (clipsHorizontally && horizontallyOutside) return true;
            if (clipsVertically && verticallyOutside) return true;
        }
        parent = parent.parentElement;
    }
    return false;
}
function $a2543115b994f2d4$export$61d36e2b682e92f7(_ref) {
    var anchor = _ref.anchor, popoverRef = _ref.popoverRef;
    var _useState = (0, $5FkrB.useState)($a2543115b994f2d4$var$INITIAL), _useState2 = (0, $amAaq.default)(_useState, 2), visibility = _useState2[0], setVisibility = _useState2[1];
    var measure = (0, $5FkrB.useCallback)(function() {
        if (!anchor) {
            setVisibility(function(previous) {
                return previous.isReferenceHidden === false && previous.hasPopperEscaped === false ? previous : $a2543115b994f2d4$var$INITIAL;
            });
            return;
        }
        var viewport = (0, $5cfc96d0de350f98$export$64beed533e21f72d)();
        var anchorRect = anchor.getBoundingClientRect();
        var isReferenceHidden = $a2543115b994f2d4$var$isFullyOutsideViewport(anchorRect, viewport) || $a2543115b994f2d4$var$isClippedByAncestors(anchor);
        var popoverElement = popoverRef.current;
        var hasPopperEscaped = popoverElement ? $a2543115b994f2d4$var$isFullyOutsideViewport(popoverElement.getBoundingClientRect(), viewport) : false;
        setVisibility(function(previous) {
            if (previous.isReferenceHidden === isReferenceHidden && previous.hasPopperEscaped === hasPopperEscaped) return previous;
            return {
                isReferenceHidden: isReferenceHidden,
                hasPopperEscaped: hasPopperEscaped
            };
        });
    }, [
        anchor,
        popoverRef
    ]);
    (0, $5FkrB.useLayoutEffect)(function() {
        measure();
        if (typeof window === 'undefined') return undefined;
        var cleanups = [];
        // Resize observer on the anchor so layout changes update visibility.
        if (anchor && typeof ResizeObserver !== 'undefined') {
            var observer = new ResizeObserver(function() {
                return measure();
            });
            observer.observe(anchor);
            cleanups.push(function() {
                return observer.disconnect();
            });
        }
        // Scroll + resize: any scroll event in the document can move the
        // anchor in/out of any scrollable ancestor's viewport.
        cleanups.push((0, $5b617c1f48263075$exports.bindAll)(window, [
            {
                type: 'scroll',
                listener: measure,
                options: {
                    capture: true,
                    passive: true
                }
            },
            {
                type: 'resize',
                listener: measure,
                options: {
                    passive: true
                }
            }
        ]));
        var visual = window.visualViewport;
        if (visual) cleanups.push((0, $5b617c1f48263075$exports.bind)(visual, {
            type: 'resize',
            listener: measure,
            options: {
                passive: true
            }
        }));
        return function() {
            cleanups.forEach(function(cleanup) {
                return cleanup();
            });
        };
    }, [
        anchor,
        measure
    ]);
    return visibility;
}


/**
 * Inert render-prop values. The browser owns positioning under CSS Anchor
 * Positioning, so `style` / `ref` / `arrowProps` / `update` / `forceUpdate`
 * are no-ops that consumers can safely spread. Module scope keeps identities
 * stable for effect dep arrays.
 */ var $250bb508c91f5d72$var$noopStyle = {};
var $250bb508c91f5d72$var$noopSetRef = (0, $adcefb868cf2fc9d$export$2e2bcd8739ae039);
var $250bb508c91f5d72$var$noopUpdate = function noopUpdate() {
    return Promise.resolve(null);
};
var $250bb508c91f5d72$var$noopForceUpdate = function noopForceUpdate() {
    return {};
};
/**
 * `react-popper` stamps `data-popper-arrow` on the arrow element at runtime
 * but does not declare it on `arrowProps`. Widen the type so consumers that
 * rely on the attribute (CSS selectors, snapshots, tests) keep working.
 */ var $250bb508c91f5d72$var$noopArrowProps = {
    ref: $250bb508c91f5d72$var$noopSetRef,
    style: $250bb508c91f5d72$var$noopStyle,
    'data-popper-arrow': true
};
/**
 * Returns whether the current page is laid out right-to-left.
 */ function $250bb508c91f5d72$var$isPageRtl() {
    var document = (0, $fc5ac9c99de29fbb$export$f65ca476c09acec0)();
    if (!document) return false;
    return document.dir === 'rtl' || document.body.dir === 'rtl' || document.documentElement.dir === 'rtl';
}
/**
 * `@popperjs/core`'s `Placement` union is a strict subset of
 * `TLegacyPlacement` (the placement-map adds `top-center` /
 * `bottom-center` on top of popper's enum), so every value popper hands
 * us is a valid legacy placement. The cast keeps the runtime path free
 * of an extra module-level lookup that bundlers can occasionally fail
 * to wire up (observed as `Cannot read properties of undefined (reading
 * 'includes')` in component-test bundles).
 */ function $250bb508c91f5d72$var$toLegacyPlacement(placement) {
    return placement;
}
/**
 * Returns the primary axis (`top` / `bottom` / `left` / `right`) of a popper
 * placement, used to pick which axis `useFitViewportMaxSize` caps to the
 * anchor edge.
 */ function $250bb508c91f5d72$var$getPlacementAxis(placement) {
    if (placement.startsWith('top')) return 'top';
    if (placement.startsWith('bottom')) return 'bottom';
    if (placement.startsWith('left')) return 'left';
    if (placement.startsWith('right')) return 'right';
    // `auto*` placements have no fixed axis. Default to `bottom` to match the
    // `auto -> block-end` mapping in `fromLegacyPlacement`.
    return 'bottom';
}
/**
 * Normalises popper's `[along, away]` offset (which may include `null` or
 * `undefined` entries) into the `[along, away]` number tuple
 * `fromLegacyPlacement` expects.
 */ function $250bb508c91f5d72$var$popperToTopLayerOffset(offset) {
    if (!offset) return undefined;
    var _offset = (0, $amAaq.default)(offset, 2), along = _offset[0], away = _offset[1];
    if (along == null && away == null) return undefined;
    return [
        along !== null && along !== void 0 ? along : 0,
        away !== null && away !== void 0 ? away : 0
    ];
}
function $250bb508c91f5d72$export$9802f50720ab826e(_ref) {
    var _ref2;
    var children = _ref.children, offset = _ref.offset, _ref$placement = _ref.placement, placement = _ref$placement === void 0 ? 'bottom-start' : _ref$placement, referenceElement = _ref.referenceElement, _ref$shouldFitViewpor = _ref.shouldFitViewport, shouldFitViewport = _ref$shouldFitViewpor === void 0 ? false : _ref$shouldFitViewpor;
    // `modifiers` and `strategy` are accepted for source compatibility but have
    // no runtime effect; CSS Anchor Positioning + top-layer rendering replaces
    // them. See `top-layer/notes/migrations/popper-migration.md`.
    // Anchor resolution: `referenceElement` prop, then `<Manager>` context.
    var managerAnchor = (0, $c393d22c07852abf$export$941a7e8bf0b9eafd)();
    var effectiveReference = (_ref2 = referenceElement !== null && referenceElement !== void 0 ? referenceElement : managerAnchor) !== null && _ref2 !== void 0 ? _ref2 : undefined;
    // Real DOM nodes go to `useAnchorPosition`; popper `VirtualElement`s are
    // bridged through `useAnchorPositionAtPoint`, which owns its own synthetic
    // anchor.
    var htmlAnchor = effectiveReference instanceof HTMLElement ? effectiveReference : null;
    var virtualReference = effectiveReference != null && !(effectiveReference instanceof HTMLElement) ? effectiveReference : null;
    var htmlAnchorRef = (0, $5FkrB.useRef)(htmlAnchor);
    htmlAnchorRef.current = htmlAnchor;
    var popoverRef = (0, $5FkrB.useRef)(null);
    var popoverId = (0, $151fa48246cb06c2$export$9198c6c168be2eeb)();
    // Track the resolved DOM anchor in state so visibility / max-size hooks
    // re-run when its identity changes. Virtual anchors do not feed these
    // hooks because their probe is outside the consumer's DOM.
    //
    // Adjust state during render by comparing against the state itself: the
    // conditional guard means `setResolvedAnchor` is skipped once they match,
    // so it converges in one extra render. This is the React-documented pattern
    // and is side-effect-free — no ref mutation during render.
    var _useState = (0, $5FkrB.useState)(htmlAnchor), _useState2 = (0, $amAaq.default)(_useState, 2), resolvedAnchor = _useState2[0], setResolvedAnchor = _useState2[1];
    if (resolvedAnchor !== htmlAnchor) setResolvedAnchor(htmlAnchor);
    var topLayerPlacement = (0, $5FkrB.useMemo)(function() {
        return (0, $36dfe2fd333e00e5$export$69e99ed50b2534c9)({
            legacy: $250bb508c91f5d72$var$toLegacyPlacement(placement),
            offset: $250bb508c91f5d72$var$popperToTopLayerOffset(offset)
        });
    }, [
        placement,
        offset
    ]);
    var isOpen = effectiveReference != null;
    // HTML-element path. No-op when the reference is virtual or absent.
    (0, $62cae9a51e21bb99$export$56b02a1e583f953c)({
        anchorRef: htmlAnchorRef,
        popoverRef: popoverRef,
        placement: topLayerPlacement,
        isEnabled: htmlAnchor != null,
        isOpen: isOpen
    });
    // Virtual-element path. `useAnchorPositionAtPoint` owns a synthetic
    // anchor in `document.body` and latches `getPoint` once per
    // `isEnabled` activation. Reading the latest `virtualReference` and
    // `topLayerPlacement` via refs ensures the latched closure always
    // sees the current values rather than the ones captured at first
    // activation, which would otherwise go stale if either prop changes
    // while the popper stays open.
    var virtualReferenceRef = (0, $5FkrB.useRef)(virtualReference);
    virtualReferenceRef.current = virtualReference;
    var topLayerPlacementRef = (0, $5FkrB.useRef)(topLayerPlacement);
    topLayerPlacementRef.current = topLayerPlacement;
    var isVirtualEnabled = virtualReference != null;
    (0, $8e47134217b0f5cd$export$6f230729189a5b8a)({
        popoverRef: popoverRef,
        placement: topLayerPlacement,
        isEnabled: isVirtualEnabled,
        isOpen: isOpen,
        getPoint: function getPoint() {
            var current = virtualReferenceRef.current;
            if (!current) return null;
            return (0, $19bc0696f5a49dfa$export$b065aeb850c3e87f)({
                rect: current.getBoundingClientRect(),
                placement: topLayerPlacementRef.current,
                isRtl: $250bb508c91f5d72$var$isPageRtl()
            });
        }
    });
    var _useReferenceVisibili = (0, $a2543115b994f2d4$export$61d36e2b682e92f7)({
        anchor: resolvedAnchor,
        popoverRef: popoverRef
    }), isReferenceHidden = _useReferenceVisibili.isReferenceHidden, hasPopperEscaped = _useReferenceVisibili.hasPopperEscaped;
    // Restore legacy `react-popper`'s natural-width behaviour. Under CSS
    // Anchor Positioning the `position-area` grid cell becomes the popover
    // host's containing block, so an auto-width host shrinks to that cell.
    // When the anchor sits near a viewport edge the cell is narrow, so the
    // content wraps far more than it did under `react-popper` (which kept the
    // content's natural width and shifted/flipped to stay on screen).
    // `min-inline-size: max-content` (mode `'none'`) floors the host at its
    // content's intrinsic width, so a too-narrow span overflows the viewport
    // (driving `position-try-fallbacks`) instead of wrapping. This is safe
    // alongside `shouldFitViewport`: the fit caps clamp the host on both axes,
    // so the host never exceeds the viewport / anchor-edge cap.
    (0, $5056e572a5bbe58a$export$7071d791a7b131ed)({
        mode: 'none',
        popoverRef: popoverRef,
        anchorRef: htmlAnchorRef,
        isOpen: isOpen
    });
    // `shouldFitViewport` caps are applied directly to the `position-area`
    // host, whose containing block is the cell between the anchor edge and the
    // viewport edge — so a pure-CSS `calc(100% - 5px - gap)` reproduces the
    // legacy per-placement anchor-edge cap with no measurement. The gap mirrors
    // `getPlacement`: an omitted offset resolves to `space.100`, otherwise the
    // consumer's `away` value.
    var resolvedOffset = $250bb508c91f5d72$var$popperToTopLayerOffset(offset);
    var fitGap = resolvedOffset ? "".concat(resolvedOffset[1], "px") : "var(--ds-space-100, 8px)";
    var placementAxis = $250bb508c91f5d72$var$getPlacementAxis(placement);
    (0, $0ddd7708acc15704$export$f16d8ac7373995e1)({
        target: popoverRef,
        placementAxis: placementAxis,
        gap: fitGap,
        isEnabled: shouldFitViewport,
        isOpen: isOpen
    });
    var renderChildren = children;
    if (typeof renderChildren !== 'function') return null;
    var renderPropArg = {
        ref: $250bb508c91f5d72$var$noopSetRef,
        style: $250bb508c91f5d72$var$noopStyle,
        placement: placement,
        isReferenceHidden: isReferenceHidden,
        hasPopperEscaped: hasPopperEscaped,
        update: $250bb508c91f5d72$var$noopUpdate,
        forceUpdate: $250bb508c91f5d72$var$noopForceUpdate,
        arrowProps: $250bb508c91f5d72$var$noopArrowProps
    };
    var content = renderChildren(renderPropArg);
    // The `shouldFitViewport` size caps live on the `<Popover>` host itself
    // (applied by `useFitViewportMaxSize` above), so the consumer's content is
    // rendered directly with no intermediate wrapper.
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $516e5dff5af04da6$export$5b6b19405a83ff9d), {
        ref: popoverRef,
        id: popoverId,
        isOpen: isOpen,
        mode: "manual",
        shouldAnimate: false
    }, content);
}



// Export types from PopperJS / React Popper
var $87203434815760ba$var$viewportPadding = 5;
var $87203434815760ba$var$constantModifiers = [
    {
        name: 'flip',
        options: {
            flipVariations: false,
            padding: $87203434815760ba$var$viewportPadding,
            boundary: 'clippingParents',
            rootBoundary: 'viewport'
        }
    }
];
function $87203434815760ba$var$defaultChildrenFn() {
    return null;
}
var $87203434815760ba$var$defaultOffset = [
    0,
    8
];
function $87203434815760ba$export$badac9ada3a0bdf9(_ref) {
    var children = _ref.children, offset = _ref.offset, placement = _ref.placement, referenceElement = _ref.referenceElement, modifiers = _ref.modifiers, strategy = _ref.strategy, shouldFitViewport = _ref.shouldFitViewport;
    // The FF check sits at the very top of the public Popper so the
    // rest of the function (which has its own hooks) does not violate
    // the rules of hooks. Each branch is its own component with its
    // own complete hook order. Props are forwarded explicitly to
    // satisfy `no-unsafe-spread-props`.
    if ((0, $2fcbb5e4cf9206d1$export$b40ec24ac8275656)('platform-dst-top-layer')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $250bb508c91f5d72$export$9802f50720ab826e), {
        children: children,
        offset: offset,
        placement: placement,
        referenceElement: referenceElement,
        modifiers: modifiers,
        strategy: strategy,
        shouldFitViewport: shouldFitViewport
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement($87203434815760ba$var$LegacyPopper, {
        children: children,
        offset: offset,
        placement: placement,
        referenceElement: referenceElement,
        modifiers: modifiers,
        strategy: strategy,
        shouldFitViewport: shouldFitViewport
    });
}
function $87203434815760ba$var$LegacyPopper(_ref2) {
    var _ref2$children = _ref2.children, children = _ref2$children === void 0 ? $87203434815760ba$var$defaultChildrenFn : _ref2$children, _ref2$offset = _ref2.offset, offset = _ref2$offset === void 0 ? $87203434815760ba$var$defaultOffset : _ref2$offset, _ref2$placement = _ref2.placement, placement = _ref2$placement === void 0 ? 'bottom-start' : _ref2$placement, _ref2$referenceElemen = _ref2.referenceElement, referenceElement = _ref2$referenceElemen === void 0 ? undefined : _ref2$referenceElemen, modifiers = _ref2.modifiers, _ref2$strategy = _ref2.strategy, strategy = _ref2$strategy === void 0 ? 'fixed' : _ref2$strategy, _ref2$shouldFitViewpo = _ref2.shouldFitViewport, shouldFitViewport = _ref2$shouldFitViewpo === void 0 ? false : _ref2$shouldFitViewpo;
    var _offset = (0, $amAaq.default)(offset, 2), offsetX = _offset[0], offsetY = _offset[1];
    var internalModifiers = (0, $5FkrB.useMemo)(function() {
        var preventOverflowModifier = {
            name: 'preventOverflow',
            options: {
                padding: $87203434815760ba$var$viewportPadding,
                rootBoundary: shouldFitViewport ? 'viewport' : 'document'
            }
        };
        var offsetModifier = {
            name: 'offset',
            options: {
                offset: [
                    offsetX,
                    offsetY
                ]
            }
        };
        var maxSizeModifiers = shouldFitViewport ? (0, $f1b6b8ddda6257f2$export$6d8c2b45c99d6e3f)({
            viewportPadding: $87203434815760ba$var$viewportPadding
        }) : [];
        // @ts-ignore Type errors from incompatible @popperjs/core versions between Jira and AFM Platform... we are using ts-ignore here because ts-expect-error will cause an "Unused '@ts-expect-error' directive." error
        return [].concat($87203434815760ba$var$constantModifiers, [
            preventOverflowModifier,
            offsetModifier
        ], (0, $5MmUg.default)(maxSizeModifiers));
    }, [
        offsetX,
        offsetY,
        shouldFitViewport
    ]);
    // Merge custom props and memoize
    var mergedModifiers = (0, $5FkrB.useMemo)(function() {
        if (modifiers == null) return internalModifiers;
        return [].concat((0, $5MmUg.default)(internalModifiers), (0, $5MmUg.default)(modifiers));
    }, [
        internalModifiers,
        modifiers
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $f9e8ed8665cc0109$export$badac9ada3a0bdf9), {
        modifiers: mergedModifiers,
        placement: placement,
        strategy: strategy,
        referenceElement: referenceElement
    }, children);
}



var $5FkrB = parcelRequire("5FkrB");

var $GmDrz = parcelRequire("GmDrz");
var $a8ec57a2938f1112$var$_process, $a8ec57a2938f1112$var$_process2;
// We can't rely on NODE_ENV === 'test' if its value is already configured by the consumer to some other value, so better to use JEST_WORKER_ID
// https://jestjs.io/docs/environment-variables#jest_worker_id
var $a8ec57a2938f1112$var$TESTS_MODE = (globalThis === null || globalThis === void 0 || ($a8ec57a2938f1112$var$_process = globalThis.process) === null || $a8ec57a2938f1112$var$_process === void 0 || ($a8ec57a2938f1112$var$_process = $a8ec57a2938f1112$var$_process.env) === null || $a8ec57a2938f1112$var$_process === void 0 ? void 0 : $a8ec57a2938f1112$var$_process.JEST_WORKER_ID) !== undefined;
var $a8ec57a2938f1112$var$DEBUG_MODE = !$a8ec57a2938f1112$var$TESTS_MODE && (globalThis === null || globalThis === void 0 || ($a8ec57a2938f1112$var$_process2 = globalThis.process) === null || $a8ec57a2938f1112$var$_process2 === void 0 || ($a8ec57a2938f1112$var$_process2 = $a8ec57a2938f1112$var$_process2.env) === null || $a8ec57a2938f1112$var$_process2 === void 0 ? void 0 : $a8ec57a2938f1112$var$_process2.NODE_ENV) !== 'production';
var $a8ec57a2938f1112$export$1c9f709888824e05 = function debug() {
    var _console;
    if (!$a8ec57a2938f1112$var$DEBUG_MODE) return;
    // eslint-disable-next-line no-console
    (_console = console).debug.apply(_console, arguments);
};



var $3ZMUU = parcelRequire("3ZMUU");
var $4e52506a8412985a$var$pkgName = '@atlaskit/platform-feature-flags';
var $4e52506a8412985a$export$7e41b1b2bdee3f98 = '__PLATFORM_FEATURE_FLAGS__';
var $4e52506a8412985a$var$hasProcessEnv = typeof $3ZMUU !== 'undefined' && typeof $3ZMUU.env !== 'undefined';
// FF global overrides can be configured by test runners or Storybook
var $4e52506a8412985a$var$ENV_ENABLE_PLATFORM_FF = $4e52506a8412985a$var$hasProcessEnv ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;
// STORYBOOK_ENABLE_PLATFORM_FF is included as storybook only allows env vars prefixed with STORYBOOK
// https://github.com/storybookjs/storybook/issues/12270
var $4e52506a8412985a$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF = $4e52506a8412985a$var$hasProcessEnv ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;
var $4e52506a8412985a$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE = $4e52506a8412985a$var$ENV_ENABLE_PLATFORM_FF || $4e52506a8412985a$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF;
var $4e52506a8412985a$var$DEFAULT_PFF_GLOBAL = {
    booleanResolver: undefined
};
var $4e52506a8412985a$var$globalVar = typeof window !== 'undefined' ? window : globalThis;
$4e52506a8412985a$var$globalVar[$4e52506a8412985a$export$7e41b1b2bdee3f98] = $4e52506a8412985a$var$globalVar[$4e52506a8412985a$export$7e41b1b2bdee3f98] || $4e52506a8412985a$var$DEFAULT_PFF_GLOBAL;
function $4e52506a8412985a$export$f2b591175b3e424c(resolver) {
    $4e52506a8412985a$var$globalVar[$4e52506a8412985a$export$7e41b1b2bdee3f98].booleanResolver = resolver;
}
function $4e52506a8412985a$export$6333b6aff9fc6275(flagKey) {
    if ($4e52506a8412985a$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE) {
        (0, $a8ec57a2938f1112$export$1c9f709888824e05)('[%s]: The feature flags were enabled while running tests. The flag "%s" will be always enabled.', $4e52506a8412985a$var$pkgName, flagKey);
        return true;
    }
    try {
        var _globalVar$PFF_GLOBAL, _globalVar$PFF_GLOBAL2, _globalVar$PFF_GLOBAL3;
        // booleanResolver will be empty for products like Trello, Elevate, Recruit etc.
        // Currently only Confluence, Jira and Bitbucket has set it.
        if (((_globalVar$PFF_GLOBAL = $4e52506a8412985a$var$globalVar[$4e52506a8412985a$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL === void 0 ? void 0 : _globalVar$PFF_GLOBAL.booleanResolver) === undefined || ((_globalVar$PFF_GLOBAL2 = $4e52506a8412985a$var$globalVar[$4e52506a8412985a$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL2 === void 0 ? void 0 : _globalVar$PFF_GLOBAL2.booleanResolver) === null) // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
        return (0, $GmDrz.default).checkGate(flagKey);
        var result = (_globalVar$PFF_GLOBAL3 = $4e52506a8412985a$var$globalVar[$4e52506a8412985a$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL3 === void 0 ? void 0 : _globalVar$PFF_GLOBAL3.booleanResolver(flagKey);
        if (typeof result !== 'boolean') {
            // eslint-disable-next-line no-console
            console.warn("".concat(flagKey, " resolved to a non-boolean value, returning false for safety"));
            return false;
        }
        return result;
    } catch (e) {
        return false;
    }
}


function $e42e4fc8d6dbdb34$export$ba05d765b8392e5e(flagResolver) {
    (0, $4e52506a8412985a$export$f2b591175b3e424c)(flagResolver);
}
function $e42e4fc8d6dbdb34$export$470e5c2be1411c89(name) {
    return (0, $4e52506a8412985a$export$6333b6aff9fc6275)(name);
}
function $e42e4fc8d6dbdb34$export$b40ec24ac8275656(name) {
    return (0, $4e52506a8412985a$export$6333b6aff9fc6275)(name);
}



var $5FkrB = parcelRequire("5FkrB");

/* index.tsx generated by @compiled/babel-plugin v0.39.1 */ 

var $dZJgY = parcelRequire("dZJgY");

var $jgyhF = parcelRequire("jgyhF");

var $amAaq = parcelRequire("amAaq");

var $gKzKW = parcelRequire("gKzKW");

var $emmWV = parcelRequire("emmWV");

var $5FkrB = parcelRequire("5FkrB");


var $jgyhF = parcelRequire("jgyhF");

var $iC6d4 = parcelRequire("iC6d4");

var $4lL0s = parcelRequire("4lL0s");

var $guClf = parcelRequire("guClf");

var $hCM0e = parcelRequire("hCM0e");

var $amAaq = parcelRequire("amAaq");
var $c242bf1d7e4a5dc6$export$4a14e169b1de4ee7 = function isColorMode(modeId) {
    return [
        'light',
        'dark',
        'auto'
    ].includes(modeId);
};


/**
 * Theme ids: The value that will be mounted to the DOM as a data attr
 * For example: `data-theme="light:light dark:dark spacing:spacing"
 *
 * These ids must be kebab case
 */ var $089eee41913782ff$export$7d43e72a58e3283f = [
    'light-increased-contrast',
    'light',
    'light-future',
    'dark',
    'dark-future',
    'dark-increased-contrast',
    'spacing',
    'shape',
    'typography',
    'motion'
];


var $7de2124bfdf2f7c9$export$ea35b8958c39dd07 = function isThemeIds(themeId) {
    return (0, $089eee41913782ff$export$7d43e72a58e3283f).find(function(id) {
        return id === themeId;
    }) !== undefined;
};


var $bd26c9e0387e24e6$var$themeKinds = [
    'light',
    'dark',
    'spacing',
    'typography',
    'shape',
    'motion'
];
var $bd26c9e0387e24e6$export$958fa026be3a263e = function isThemeKind(themeKind) {
    return $bd26c9e0387e24e6$var$themeKinds.find(function(kind) {
        return kind === themeKind;
    }) !== undefined;
};


var $d5d8583e08303936$var$customThemeOptions = 'UNSAFE_themeOptions';
var $d5d8583e08303936$export$62c37ab81302621a = function themeObjectToString(themeState) {
    return Object.entries(themeState).reduce(function(themeString, _ref) {
        var _ref2 = (0, $amAaq.default)(_ref, 2), kind = _ref2[0], id = _ref2[1];
        if (// colorMode theme state
        kind === 'colorMode' && typeof id === 'string' && (0, $c242bf1d7e4a5dc6$export$4a14e169b1de4ee7)(id) || // custom theme state
        kind === $d5d8583e08303936$var$customThemeOptions && (0, $hCM0e.default)(id) === 'object' || // other theme states
        (0, $bd26c9e0387e24e6$export$958fa026be3a263e)(kind) && typeof id === 'string' && (0, $7de2124bfdf2f7c9$export$ea35b8958c39dd07)(id)) return themeString + "".concat(themeString ? ' ' : '') + "".concat(kind, ":").concat((0, $hCM0e.default)(id) === 'object' ? JSON.stringify(id) : id);
        return themeString;
    }, '');
};



var $dNpMm = parcelRequire("dNpMm");
var $50f0f710c6ef331c$export$53031ac1ecb71f44 = function isValidBrandHex(hex) {
    return /^#[0-9A-F]{6}$/i.test(hex);
};


function $fd68ec7ca1e70bad$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $fd68ec7ca1e70bad$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $fd68ec7ca1e70bad$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $jgyhF.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $fd68ec7ca1e70bad$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $fd68ec7ca1e70bad$var$defaultColorMode = 'light';
var $fd68ec7ca1e70bad$var$defaultContrastMode = 'no-preference';
/**
 * Server-side rendering utility. Generates the valid HTML attributes for a given theme.
 * Note: this utility does not handle automatic theme switching.
 *
 * @param {Object<string, string>} themeOptions - Theme options object
 * @param {string} themeState.colorMode Determines which color theme is applied. If set to `auto`, the theme applied will be determined by the OS setting.
 * @param {string} themeState.dark The color theme to be applied when the color mode resolves to 'dark'.
 * @param {string} themeState.light The color theme to be applied when the color mode resolves to 'light'.
 * @param {string} themeState.motion The motion theme to be applied.
 * @param {string} themeState.spacing The spacing theme to be applied.
 * @param {string} themeState.typography The typography theme to be applied.
 * @param {Object} themeState.UNSAFE_themeOptions The custom branding options to be used for custom theme generation
 *
 * @returns {Object} Object of HTML attributes to be applied to the document root
 */ var $fd68ec7ca1e70bad$var$getThemeHtmlAttrs = function getThemeHtmlAttrs() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, _ref$colorMode = _ref.colorMode, colorMode = _ref$colorMode === void 0 ? (0, $guClf.themeStateDefaults)['colorMode'] : _ref$colorMode, _ref$dark = _ref.dark, dark = _ref$dark === void 0 ? (0, $guClf.themeStateDefaults)['dark'] : _ref$dark, _ref$light = _ref.light, light = _ref$light === void 0 ? (0, $guClf.themeStateDefaults)['light'] : _ref$light, _ref$contrastMode = _ref.contrastMode, contrastMode = _ref$contrastMode === void 0 ? (0, $guClf.themeStateDefaults)['contrastMode'] : _ref$contrastMode, _ref$motion = _ref.motion, motion = _ref$motion === void 0 ? (0, $guClf.themeStateDefaults)['motion']() : _ref$motion, _ref$shape = _ref.shape, shape = _ref$shape === void 0 ? (0, $guClf.themeStateDefaults)['shape']() : _ref$shape, _ref$spacing = _ref.spacing, spacing = _ref$spacing === void 0 ? (0, $guClf.themeStateDefaults)['spacing'] : _ref$spacing, _ref$typography = _ref.typography, typography = _ref$typography === void 0 ? (0, $guClf.themeStateDefaults)['typography'] : _ref$typography, _ref$UNSAFE_themeOpti = _ref.UNSAFE_themeOptions, UNSAFE_themeOptions = _ref$UNSAFE_themeOpti === void 0 ? (0, $guClf.themeStateDefaults)['UNSAFE_themeOptions'] : _ref$UNSAFE_themeOpti;
    var themeAttribute = (0, $d5d8583e08303936$export$62c37ab81302621a)({
        dark: dark,
        light: light,
        motion: motion,
        shape: shape,
        spacing: spacing,
        typography: typography
    });
    var result = (0, $jgyhF.default)((0, $jgyhF.default)({}, (0, $4lL0s.THEME_DATA_ATTRIBUTE), themeAttribute), (0, $4lL0s.COLOR_MODE_ATTRIBUTE), colorMode === 'auto' ? $fd68ec7ca1e70bad$var$defaultColorMode : colorMode);
    if ((0, $iC6d4.fg)('platform_increased-contrast-themes')) result = $fd68ec7ca1e70bad$var$_objectSpread($fd68ec7ca1e70bad$var$_objectSpread({}, result), {}, (0, $jgyhF.default)({}, (0, $4lL0s.CONTRAST_MODE_ATTRIBUTE), contrastMode === 'auto' ? $fd68ec7ca1e70bad$var$defaultContrastMode : contrastMode));
    if (UNSAFE_themeOptions && (0, $50f0f710c6ef331c$export$53031ac1ecb71f44)(UNSAFE_themeOptions.brandColor)) {
        var optionString = JSON.stringify(UNSAFE_themeOptions);
        var uniqueId = (0, $dNpMm.hash)(optionString);
        result[0, $4lL0s.CUSTOM_THEME_ATTRIBUTE] = uniqueId;
    }
    return result;
};
var $fd68ec7ca1e70bad$export$2e2bcd8739ae039 = $fd68ec7ca1e70bad$var$getThemeHtmlAttrs;


var $jgyhF = parcelRequire("jgyhF");

var $dZJgY = parcelRequire("dZJgY");

var $emmWV = parcelRequire("emmWV");

var $iC6d4 = parcelRequire("iC6d4");

var $jgyhF = parcelRequire("jgyhF");

var $4lL0s = parcelRequire("4lL0s");
/**
 * Theme modes: The general purpose of a theme.
 * This attr is used to apply the appropriate system-preference option
 * It may also be used as a selector for mode-specific overrides such as light/dark images.
 * The idea is there may exist many color themes, but every theme must either fit into light or dark.
 */ var $edaa8e08187792a6$export$83993de8eb66733 = [
    'light',
    'dark',
    'auto'
];



var $amAaq = parcelRequire("amAaq");



var $088f3eba2f62ce38$var$customThemeOptions = 'UNSAFE_themeOptions';
var $088f3eba2f62ce38$export$f19b488f7c0547ee = function themeStringToObject(themeState) {
    return themeState.split(' ')// @ts-ignore - TS1501 TypeScript 5.9.2 upgrade
    .map(function(theme) {
        return theme.split(/:([^]*)/);
    }).reduce(function(themeObject, _ref) {
        var _ref2 = (0, $amAaq.default)(_ref, 2), kind = _ref2[0], id = _ref2[1];
        if (kind === 'colorMode' && (0, $c242bf1d7e4a5dc6$export$4a14e169b1de4ee7)(id)) themeObject[kind] = id;
        if ((0, $bd26c9e0387e24e6$export$958fa026be3a263e)(kind) && (0, $7de2124bfdf2f7c9$export$ea35b8958c39dd07)(id)) // @ts-expect-error FIXME - this is a valid ts error
        themeObject[kind] = id;
        if (kind === $088f3eba2f62ce38$var$customThemeOptions) try {
            themeObject[$088f3eba2f62ce38$var$customThemeOptions] = JSON.parse(id);
        } catch (_unused) {
            new Error('Invalid custom theme string');
        }
        return themeObject;
    }, {});
};


function $1fed8c4230004f10$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $1fed8c4230004f10$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $1fed8c4230004f10$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $jgyhF.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $1fed8c4230004f10$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $1fed8c4230004f10$var$isThemeColorMode = function isThemeColorMode(colorMode) {
    return (0, $edaa8e08187792a6$export$83993de8eb66733).find(function(mode) {
        return mode === colorMode;
    }) !== undefined;
};
var $1fed8c4230004f10$var$getGlobalTheme = function getGlobalTheme() {
    if (typeof document === 'undefined') return {};
    var element = document.documentElement;
    var colorMode = element.getAttribute((0, $4lL0s.COLOR_MODE_ATTRIBUTE)) || '';
    var theme = element.getAttribute((0, $4lL0s.THEME_DATA_ATTRIBUTE)) || '';
    return $1fed8c4230004f10$var$_objectSpread($1fed8c4230004f10$var$_objectSpread({}, (0, $088f3eba2f62ce38$export$f19b488f7c0547ee)(theme)), $1fed8c4230004f10$var$isThemeColorMode(colorMode) && {
        colorMode: colorMode
    });
};
var $1fed8c4230004f10$export$2e2bcd8739ae039 = $1fed8c4230004f10$var$getGlobalTheme;



var $guClf = parcelRequire("guClf");

var $amAaq = parcelRequire("amAaq");

var $iC6d4 = parcelRequire("iC6d4");


var $cdRUW = parcelRequire("cdRUW");

var $i1Bei = parcelRequire("i1Bei");

var $jgyhF = parcelRequire("jgyhF");


var $4lL0s = parcelRequire("4lL0s");

var $dZJgY = parcelRequire("dZJgY");

var $emmWV = parcelRequire("emmWV");

var $4lL0s = parcelRequire("4lL0s");

var $dZJgY = parcelRequire("dZJgY");

var $emmWV = parcelRequire("emmWV");
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 *
 * This file contains a dynamic import for each theme this package exports.
 * Themes are loaded asynchronously at runtime to minimise the amount of CSS we send to the client.
 * This allows users to compose their themes and only use the tokens that are requested.
 * When a new theme is created, the import should automatically be added to the map
 *
 * @codegen <<SignedSource::a20c72d683b08b594c5be4160eec5f78>>
 * @codegenCommand yarn build tokens
 */ 









var $cfabd87273d3d79f$var$themeImportsMap = {
    'light': function light() {
        return (parcelRequire("axgie"));
    },
    'light-future': function lightFuture() {
        return (parcelRequire("g9rJF"));
    },
    'light-increased-contrast': function lightIncreasedContrast() {
        return (parcelRequire("kT0v0"));
    },
    'dark': function dark() {
        return (parcelRequire("4AHXc"));
    },
    'dark-future': function darkFuture() {
        return (parcelRequire("2WA54"));
    },
    'dark-increased-contrast': function darkIncreasedContrast() {
        return (parcelRequire("mQdOo"));
    },
    'spacing': function spacing() {
        return (parcelRequire("hWclh"));
    },
    'typography': function typography() {
        return (parcelRequire("e7KbB"));
    },
    'shape': function shape() {
        return (parcelRequire("cc6bl"));
    },
    'motion': function motion() {
        return (parcelRequire("lEhau"));
    }
};
var $cfabd87273d3d79f$export$2e2bcd8739ae039 = $cfabd87273d3d79f$var$themeImportsMap;


var $11eb3b41833f1cbc$export$8a48286ed7df6720 = /*#__PURE__*/ function() {
    var _ref = (0, $dZJgY.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($emmWV))).mark(function _callee(themeId) {
        var _yield$themeImportMap, themeCss;
        return (0, (/*@__PURE__*/$parcel$interopDefault($emmWV))).wrap(function(_context) {
            while(true)switch(_context.prev = _context.next){
                case 0:
                    _context.next = 1;
                    return (0, $cfabd87273d3d79f$export$2e2bcd8739ae039)[themeId]();
                case 1:
                    _yield$themeImportMap = _context.sent;
                    themeCss = _yield$themeImportMap.default;
                    return _context.abrupt("return", themeCss);
                case 2:
                case "end":
                    return _context.stop();
            }
        }, _callee);
    }));
    return function loadThemeCss(_x) {
        return _ref.apply(this, arguments);
    };
}();


var $5fa2fadf4b4f06d0$export$26cd7ae85c7144e5 = /*#__PURE__*/ function() {
    var _ref = (0, $dZJgY.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($emmWV))).mark(function _callee(themeId) {
        var themeCss, style;
        return (0, (/*@__PURE__*/$parcel$interopDefault($emmWV))).wrap(function(_context) {
            while(true)switch(_context.prev = _context.next){
                case 0:
                    if (!document.head.querySelector("style[".concat((0, $4lL0s.THEME_DATA_ATTRIBUTE), "=\"").concat(themeId, "\"]:not([").concat((0, $4lL0s.CUSTOM_THEME_ATTRIBUTE), "])"))) {
                        _context.next = 1;
                        break;
                    }
                    return _context.abrupt("return");
                case 1:
                    if (themeId) {
                        _context.next = 2;
                        break;
                    }
                    return _context.abrupt("return");
                case 2:
                    _context.next = 3;
                    return (0, $11eb3b41833f1cbc$export$8a48286ed7df6720)(themeId);
                case 3:
                    themeCss = _context.sent;
                    style = document.createElement('style');
                    style.textContent = themeCss;
                    style.dataset.theme = themeId;
                    document.head.appendChild(style);
                case 4:
                case "end":
                    return _context.stop();
            }
        }, _callee);
    }));
    return function loadAndAppendThemeCss(_x) {
        return _ref.apply(this, arguments);
    };
}();
var $5fa2fadf4b4f06d0$export$bb1e815119d30f8b = '(prefers-color-scheme: dark)';
var $5fa2fadf4b4f06d0$export$8662df6937d86fcb = '(prefers-contrast: more)';


var $7dbaf5b57f83b9a1$var$isMatchMediaAvailable = typeof window !== 'undefined' && 'matchMedia' in window;
/**
 * Updates the current theme when the system theme changes. Should be bound
 * to an event listener listening on the '(prefers-color-scheme: dark)' query
 * @param e The event representing a change in system theme.
 */ function $7dbaf5b57f83b9a1$var$checkNativeListener(e) {
    var element = document.documentElement;
    element.setAttribute((0, $4lL0s.COLOR_MODE_ATTRIBUTE), e.matches ? 'dark' : 'light');
}
var $7dbaf5b57f83b9a1$var$darkModeMql = $7dbaf5b57f83b9a1$var$isMatchMediaAvailable && window.matchMedia((0, $5fa2fadf4b4f06d0$export$bb1e815119d30f8b));
var $7dbaf5b57f83b9a1$var$ColorModeObserver = /*#__PURE__*/ function() {
    function ColorModeObserver() {
        (0, $cdRUW.default)(this, ColorModeObserver);
        (0, $jgyhF.default)(this, "unbindThemeChangeListener", null);
    }
    return (0, $i1Bei.default)(ColorModeObserver, [
        {
            key: "getColorMode",
            value: function getColorMode() {
                if (!$7dbaf5b57f83b9a1$var$darkModeMql) return 'light';
                return $7dbaf5b57f83b9a1$var$darkModeMql !== null && $7dbaf5b57f83b9a1$var$darkModeMql !== void 0 && $7dbaf5b57f83b9a1$var$darkModeMql.matches ? 'dark' : 'light';
            }
        },
        {
            key: "bind",
            value: function bind() {
                if ($7dbaf5b57f83b9a1$var$darkModeMql && this.unbindThemeChangeListener === null) this.unbindThemeChangeListener = (0, $5b617c1f48263075$exports.bind)($7dbaf5b57f83b9a1$var$darkModeMql, {
                    type: 'change',
                    listener: $7dbaf5b57f83b9a1$var$checkNativeListener
                });
            }
        },
        {
            key: "unbind",
            value: function unbind() {
                if (this.unbindThemeChangeListener) {
                    this.unbindThemeChangeListener();
                    this.unbindThemeChangeListener = null;
                }
            }
        }
    ]);
}();
/**
 * A singleton color mode observer - binds "auto" switching logic to a single `mediaQueryList` listener
 * that can be unbound by any consumer when no longer needed.
 */ var $7dbaf5b57f83b9a1$var$SingletonColorModeObserver = new $7dbaf5b57f83b9a1$var$ColorModeObserver();
var $7dbaf5b57f83b9a1$export$2e2bcd8739ae039 = $7dbaf5b57f83b9a1$var$SingletonColorModeObserver;



var $cdRUW = parcelRequire("cdRUW");

var $i1Bei = parcelRequire("i1Bei");

var $jgyhF = parcelRequire("jgyhF");


var $4lL0s = parcelRequire("4lL0s");

var $540d39f79a636d78$var$isMatchMediaAvailable = typeof window !== 'undefined' && 'matchMedia' in window;
/**
 * Updates the current theme when the system contrast preference changes. Should be bound
 * to an event listener listening on the '(prefers-contrast: more)' query
 * @param e The event representing a change in system theme.
 */ function $540d39f79a636d78$var$checkNativeListener(e) {
    var element = document.documentElement;
    element.setAttribute((0, $4lL0s.CONTRAST_MODE_ATTRIBUTE), e.matches ? 'more' : 'no-preference');
}
var $540d39f79a636d78$var$contrastModeMql = $540d39f79a636d78$var$isMatchMediaAvailable && window.matchMedia((0, $5fa2fadf4b4f06d0$export$8662df6937d86fcb));
var $540d39f79a636d78$var$ContrastModeObserver = /*#__PURE__*/ function() {
    function ContrastModeObserver() {
        (0, $cdRUW.default)(this, ContrastModeObserver);
        (0, $jgyhF.default)(this, "unbindContrastChangeListener", null);
    }
    return (0, $i1Bei.default)(ContrastModeObserver, [
        {
            key: "getContrastMode",
            value: function getContrastMode() {
                if (!$540d39f79a636d78$var$contrastModeMql) return 'no-preference';
                return $540d39f79a636d78$var$contrastModeMql !== null && $540d39f79a636d78$var$contrastModeMql !== void 0 && $540d39f79a636d78$var$contrastModeMql.matches ? 'more' : 'no-preference';
            }
        },
        {
            key: "bind",
            value: function bind() {
                if ($540d39f79a636d78$var$contrastModeMql && this.unbindContrastChangeListener === null) this.unbindContrastChangeListener = (0, $5b617c1f48263075$exports.bind)($540d39f79a636d78$var$contrastModeMql, {
                    type: 'change',
                    listener: $540d39f79a636d78$var$checkNativeListener
                });
            }
        },
        {
            key: "unbind",
            value: function unbind() {
                if (this.unbindContrastChangeListener) {
                    this.unbindContrastChangeListener();
                    this.unbindContrastChangeListener = null;
                }
            }
        }
    ]);
}();
/**
 * A singleton contrast mode observer - binds "auto" switching logic to a single `mediaQueryList` listener
 * that can be unbound by any consumer when no longer needed.
 */ var $540d39f79a636d78$var$SingletonContrastModeObserver = new $540d39f79a636d78$var$ContrastModeObserver();
var $540d39f79a636d78$export$2e2bcd8739ae039 = $540d39f79a636d78$var$SingletonContrastModeObserver;


function $f4b77aa2f7f5786e$export$2e2bcd8739ae039(themeState) {
    if (themeState.colorMode === 'auto') {
        // Set colorMode based on the user preference
        themeState.colorMode = (0, $7dbaf5b57f83b9a1$export$2e2bcd8739ae039).getColorMode();
        // Bind a listener (if one doesn't already exist) to keep colorMode updated
        (0, $7dbaf5b57f83b9a1$export$2e2bcd8739ae039).bind();
    } else (0, $7dbaf5b57f83b9a1$export$2e2bcd8739ae039).unbind();
    if ((0, $iC6d4.fg)('platform_increased-contrast-themes')) {
        if (themeState.contrastMode === 'auto') {
            // Set contrastMode based on the user preference
            themeState.contrastMode = (0, $540d39f79a636d78$export$2e2bcd8739ae039).getContrastMode();
            // Bind a listener (if one doesn't already exist) to keep contrastMode updated
            (0, $540d39f79a636d78$export$2e2bcd8739ae039).bind();
        } else (0, $540d39f79a636d78$export$2e2bcd8739ae039).unbind();
    }
    var themeAttributes = (0, $fd68ec7ca1e70bad$export$2e2bcd8739ae039)(themeState);
    Object.entries(themeAttributes).forEach(function(_ref) {
        var _ref2 = (0, $amAaq.default)(_ref, 2), key = _ref2[0], value = _ref2[1];
        document.documentElement.setAttribute(key, value);
    });
    return function() {
        (0, $7dbaf5b57f83b9a1$export$2e2bcd8739ae039).unbind();
        if ((0, $iC6d4.fg)('platform_increased-contrast-themes')) (0, $540d39f79a636d78$export$2e2bcd8739ae039).unbind();
    };
}



var $4lL0s = parcelRequire("4lL0s");

var $dNpMm = parcelRequire("dNpMm");
function $c32a1c8209ed238f$export$bd1ac9300b0e885a(UNSAFE_themeOptions, mode) {
    var optionString = JSON.stringify(UNSAFE_themeOptions);
    var uniqueId = (0, $dNpMm.hash)(optionString);
    var attrOfMissingCustomStyles = [];
    (mode === 'auto' ? [
        'light',
        'dark'
    ] : [
        mode
    ]).forEach(function(themeId) {
        var element = document.head.querySelector("style[".concat((0, $4lL0s.CUSTOM_THEME_ATTRIBUTE), "=\"").concat(uniqueId, "\"][").concat((0, $4lL0s.THEME_DATA_ATTRIBUTE), "=\"").concat(themeId, "\"]"));
        if (element) // Append the existing custom styles to take precedence over others
        document.head.appendChild(element);
        else attrOfMissingCustomStyles.push(themeId);
    });
    return attrOfMissingCustomStyles;
}



var $5MmUg = parcelRequire("5MmUg");
var $bddf968e7bfbd0fd$export$5d76d7014f4a5d08 = function getThemeOverridePreferences(_themeState) {
    var themeOverridePreferences = [];
    return (0, $5MmUg.default)(new Set(themeOverridePreferences));
};



var $5MmUg = parcelRequire("5MmUg");

var $iC6d4 = parcelRequire("iC6d4");

var $amAaq = parcelRequire("amAaq");

var $5MmUg = parcelRequire("5MmUg");



var $guClf = parcelRequire("guClf");
/**
 * Themes: The internal identifier of a theme.
 * These ids are what the actual theme files/folders are called.
 * style-dictionary will attempt to locate these in the file-system.
 */ /**
 * ThemeOverrides: The internal identifier of a theme override. Which are themes that contain
 * a subset of tokens intended to override an existing theme. These ids are what the actual
 * theme files/folders are called. style-dictionary will attempt to locate these in the file-system.
 * Theme overrides are temporary and there may not be any defined at times.
 */ /**
 * Theme kinds: The type of theme.
 * Some themes are entirely focused on Color, whilst others are purely focused on spacing.
 * In the future other types may be introduced such as typography.
 */ /**
 * Contrast preferences: The system contrast preference
 */ var $58197d2804903d7c$var$themeContrastModes = [
    'more',
    'no-preference',
    'auto'
];
/**
 * Theme override ids: the equivalent of themeIds for theme overrides.
 * Theme overrides are temporary and there may not be any defined at times.
 */ var $58197d2804903d7c$var$themeOverrideIds = [];
var $58197d2804903d7c$export$92ba366331403db2 = [].concat((0, $5MmUg.default)((0, $089eee41913782ff$export$7d43e72a58e3283f)), $58197d2804903d7c$var$themeOverrideIds);
/**
 * Theme to use a base. This will create the theme as
 * an extension with all token values marked as optional
 * to allow tokens to be overridden as required.
 */ /**
 * Palettes: The set of base tokens a given theme may be populated with.
 * For example: legacy light & dark themes use the "legacyPalette" containing colors from our
 * previous color set.
 */ /**
 * ThemeConfig: the source of truth for all theme meta-data.
 * This object should be used whenever interfacing with themes.
 */ var $58197d2804903d7c$var$themeConfig = {
    'atlassian-light': {
        id: 'light',
        displayName: 'Light Theme',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'light'
        }
    },
    'atlassian-light-future': {
        id: 'light-future',
        displayName: 'Future Light Theme',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'light'
        },
        override: 'light'
    },
    'atlassian-light-increased-contrast': {
        id: 'light-increased-contrast',
        displayName: 'Light Theme (increased contrast)',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'light'
        },
        extends: 'light',
        increasesContrastFor: 'light'
    },
    'atlassian-dark': {
        id: 'dark',
        displayName: 'Dark Theme',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'dark'
        }
    },
    'atlassian-dark-future': {
        id: 'dark-future',
        displayName: 'Future Dark Theme',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'dark'
        },
        override: 'light'
    },
    'atlassian-dark-increased-contrast': {
        id: 'dark-increased-contrast',
        displayName: 'Dark Theme (increased contrast)',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'dark'
        },
        extends: 'dark',
        increasesContrastFor: 'dark'
    },
    'atlassian-spacing': {
        id: 'spacing',
        displayName: 'Atlassian Spacing',
        palette: 'spacingScale',
        attributes: {
            type: 'spacing'
        }
    },
    'atlassian-typography': {
        id: 'typography',
        displayName: 'Atlassian Typography',
        palette: 'typographyPalette',
        attributes: {
            type: 'typography'
        }
    },
    'atlassian-shape': {
        id: 'shape',
        displayName: 'Shape',
        palette: 'shapePalette',
        attributes: {
            type: 'shape'
        }
    },
    'atlassian-motion': {
        id: 'motion',
        displayName: 'Motion',
        palette: 'motionPalette',
        attributes: {
            type: 'motion'
        }
    }
};
var /**
 * Represents theme state once mounted to the page
 * (the page doesn't have an "auto" color mode, it's either light or dark)
 */ // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$58197d2804903d7c$export$2e2bcd8739ae039 = $58197d2804903d7c$var$themeConfig;


function $57ae7ea78c91d2da$export$2e2bcd8739ae039(themeId) {
    var _Object$entries$find;
    return (_Object$entries$find = Object.entries((0, $58197d2804903d7c$export$2e2bcd8739ae039)).find(function(_ref) {
        var _ref2 = (0, $amAaq.default)(_ref, 2), increasesContrastFor = _ref2[1].increasesContrastFor;
        return increasesContrastFor === themeId;
    })) === null || _Object$entries$find === void 0 ? void 0 : _Object$entries$find[1].id;
}



var $737db715193a2aa8$export$dd6aeb7c823fc03d = function getThemePreferences(themeState) {
    var colorMode = themeState.colorMode, contrastMode = themeState.contrastMode, dark = themeState.dark, light = themeState.light, shape = themeState.shape, spacing = themeState.spacing, typography = themeState.typography, motion = themeState.motion;
    var autoColorModeThemes = [
        light,
        dark
    ];
    var themePreferences = [];
    if (colorMode === 'auto') {
        if (contrastMode !== 'no-preference' && (0, $iC6d4.fg)('platform_increased-contrast-themes')) autoColorModeThemes.forEach(function(normalTheme) {
            var increasedContrastTheme = (0, $57ae7ea78c91d2da$export$2e2bcd8739ae039)(normalTheme);
            if (increasedContrastTheme) autoColorModeThemes.push(increasedContrastTheme);
        });
        themePreferences.push.apply(themePreferences, autoColorModeThemes);
    } else {
        themePreferences.push(themeState[colorMode]);
        if (contrastMode !== 'no-preference' && (0, $iC6d4.fg)('platform_increased-contrast-themes')) {
            var increasedContrastTheme = (0, $57ae7ea78c91d2da$export$2e2bcd8739ae039)(themeState[colorMode]);
            if (increasedContrastTheme) themePreferences.push(increasedContrastTheme);
        }
    }
    [
        shape,
        spacing,
        typography,
        motion
    ].forEach(function(themeId) {
        if (themeId) themePreferences.push(themeId);
    });
    return (0, $5MmUg.default)(new Set(themePreferences));
};




function $8bf1aef1fc38591e$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $8bf1aef1fc38591e$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $8bf1aef1fc38591e$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $8bf1aef1fc38591e$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $8bf1aef1fc38591e$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $8bf1aef1fc38591e$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function $8bf1aef1fc38591e$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $8bf1aef1fc38591e$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $8bf1aef1fc38591e$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $jgyhF.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $8bf1aef1fc38591e$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}

/**
 * Sets the theme globally at runtime. This updates the `data-theme` and `data-color-mode` attributes on your page's <html> tag.
 *
 * @param {Object<string, string>} themeState The themes and color mode that should be applied.
 * @param {string} themeState.colorMode Determines which color theme is applied. If set to `auto`, the theme applied will be determined by the OS setting.
 * @param {string} themeState.contrastMode The contrast mode theme to be applied. If set to `auto`, the theme applied will be determined by the OS setting.set to `auto`, the theme applied will be determined by the OS setting.
 * @param {string} themeState.dark The color theme to be applied when the color mode resolves to 'dark'.
 * @param {string} themeState.light The color theme to be applied when the color mode resolves to 'light'.
 * @param {string} themeState.motion The motion theme to be applied.
 * @param {string} themeState.shape The shape theme to be applied.
 * @param {string} themeState.spacing The spacing theme to be applied.
 * @param {string} themeState.typography The typography theme to be applied.
 * @param {Object} themeState.UNSAFE_themeOptions The custom branding options to be used for custom theme generation
 * @param {function} themeLoader Callback function used to override the default theme loading functionality.
 *
 * @returns A Promise of an unbind function, that can be used to stop listening for changes to system theme.
 *
 * @example
 * ```
 * setGlobalTheme({colorMode: 'auto', light: 'light', dark: 'dark', spacing: 'spacing'});
 * ```
 */ var $8bf1aef1fc38591e$var$setGlobalTheme = /*#__PURE__*/ function() {
    var _ref = (0, $dZJgY.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($emmWV))).mark(function _callee3() {
        var nextThemeState, themeLoader, _ref2, _ref2$colorMode, colorMode, _ref2$contrastMode, contrastMode, _ref2$dark, dark, _ref2$light, light, _ref2$shape, shape, _ref2$spacing, spacing, _ref2$typography, typography, _ref2$motion, motion, _ref2$UNSAFE_themeOpt, UNSAFE_themeOptions, themeState, themePreferences, loadingStrategy, loadingTasks, mode, attrOfMissingCustomStyles, themeOverridePreferences, _iterator, _step, themeId, autoUnbind, _args3 = arguments, _t;
        return (0, (/*@__PURE__*/$parcel$interopDefault($emmWV))).wrap(function(_context3) {
            while(true)switch(_context3.prev = _context3.next){
                case 0:
                    nextThemeState = _args3.length > 0 && _args3[0] !== undefined ? _args3[0] : {};
                    themeLoader = _args3.length > 1 ? _args3[1] : undefined;
                    _ref2 = typeof nextThemeState === 'function' ? nextThemeState($8bf1aef1fc38591e$var$_objectSpread($8bf1aef1fc38591e$var$_objectSpread({}, (0, $guClf.themeStateDefaults)), {}, {
                        typography: (0, $guClf.themeStateDefaults)['typography'],
                        shape: (0, $guClf.themeStateDefaults)['shape'](),
                        motion: (0, $guClf.themeStateDefaults)['motion']()
                    }, (0, $1fed8c4230004f10$export$2e2bcd8739ae039)())) : nextThemeState, _ref2$colorMode = _ref2.colorMode, colorMode = _ref2$colorMode === void 0 ? (0, $guClf.themeStateDefaults)['colorMode'] : _ref2$colorMode, _ref2$contrastMode = _ref2.contrastMode, contrastMode = _ref2$contrastMode === void 0 ? (0, $guClf.themeStateDefaults)['contrastMode'] : _ref2$contrastMode, _ref2$dark = _ref2.dark, dark = _ref2$dark === void 0 ? (0, $guClf.themeStateDefaults)['dark'] : _ref2$dark, _ref2$light = _ref2.light, light = _ref2$light === void 0 ? (0, $guClf.themeStateDefaults)['light'] : _ref2$light, _ref2$shape = _ref2.shape, shape = _ref2$shape === void 0 ? (0, $guClf.themeStateDefaults)['shape']() : _ref2$shape, _ref2$spacing = _ref2.spacing, spacing = _ref2$spacing === void 0 ? (0, $guClf.themeStateDefaults)['spacing'] : _ref2$spacing, _ref2$typography = _ref2.typography, typography = _ref2$typography === void 0 ? (0, $guClf.themeStateDefaults)['typography'] : _ref2$typography, _ref2$motion = _ref2.motion, motion = _ref2$motion === void 0 ? (0, $guClf.themeStateDefaults)['motion']() : _ref2$motion, _ref2$UNSAFE_themeOpt = _ref2.UNSAFE_themeOptions, UNSAFE_themeOptions = _ref2$UNSAFE_themeOpt === void 0 ? (0, $guClf.themeStateDefaults)['UNSAFE_themeOptions'] : _ref2$UNSAFE_themeOpt; // CLEANUP: Remove. This blocks application of increased contrast themes
                    // without the feature flag enabled.
                    if (!(0, $iC6d4.fg)('platform_increased-contrast-themes')) {
                        if (light === 'light-increased-contrast') light = 'light';
                        if (dark === 'dark-increased-contrast') dark = 'dark';
                    }
                    themeState = {
                        colorMode: colorMode,
                        contrastMode: contrastMode,
                        dark: dark,
                        light: light,
                        shape: shape,
                        spacing: spacing,
                        typography: typography,
                        motion: motion,
                        UNSAFE_themeOptions: themeLoader ? undefined : UNSAFE_themeOptions
                    }; // Determine what to load and loading strategy
                    themePreferences = (0, $737db715193a2aa8$export$dd6aeb7c823fc03d)(themeState);
                    loadingStrategy = themeLoader ? themeLoader : (0, $5fa2fadf4b4f06d0$export$26cd7ae85c7144e5); // Load standard themes
                    loadingTasks = themePreferences.map(/*#__PURE__*/ function() {
                        var _ref3 = (0, $dZJgY.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($emmWV))).mark(function _callee(themeId) {
                            return (0, (/*@__PURE__*/$parcel$interopDefault($emmWV))).wrap(function(_context) {
                                while(true)switch(_context.prev = _context.next){
                                    case 0:
                                        _context.next = 1;
                                        return loadingStrategy(themeId);
                                    case 1:
                                        return _context.abrupt("return", _context.sent);
                                    case 2:
                                    case "end":
                                        return _context.stop();
                                }
                            }, _callee);
                        }));
                        return function(_x) {
                            return _ref3.apply(this, arguments);
                        };
                    }()); // Load custom themes if needed
                    if (!themeLoader && UNSAFE_themeOptions && (0, $50f0f710c6ef331c$export$53031ac1ecb71f44)(UNSAFE_themeOptions === null || UNSAFE_themeOptions === void 0 ? void 0 : UNSAFE_themeOptions.brandColor)) {
                        mode = colorMode || (0, $guClf.themeStateDefaults)['colorMode'];
                        attrOfMissingCustomStyles = (0, $c32a1c8209ed238f$export$bd1ac9300b0e885a)(UNSAFE_themeOptions, mode);
                        if (attrOfMissingCustomStyles.length > 0) // Load custom theme styles
                        loadingTasks.push((0, $dZJgY.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($emmWV))).mark(function _callee2() {
                            var _yield$import, loadAndAppendCustomThemeCss;
                            return (0, (/*@__PURE__*/$parcel$interopDefault($emmWV))).wrap(function(_context2) {
                                while(true)switch(_context2.prev = _context2.next){
                                    case 0:
                                        _context2.next = 1;
                                        return (parcelRequire("k181C"));
                                    case 1:
                                        _yield$import = _context2.sent;
                                        loadAndAppendCustomThemeCss = _yield$import.loadAndAppendCustomThemeCss;
                                        loadAndAppendCustomThemeCss({
                                            colorMode: attrOfMissingCustomStyles.length === 2 ? 'auto' : // only load the missing custom theme styles
                                            attrOfMissingCustomStyles[0],
                                            UNSAFE_themeOptions: UNSAFE_themeOptions
                                        });
                                    case 2:
                                    case "end":
                                        return _context2.stop();
                                }
                            }, _callee2);
                        }))());
                    }
                    _context3.next = 1;
                    return Promise.all(loadingTasks);
                case 1:
                    // Load override themes after standard themes
                    themeOverridePreferences = (0, $bddf968e7bfbd0fd$export$5d76d7014f4a5d08)(themeState);
                    _iterator = $8bf1aef1fc38591e$var$_createForOfIteratorHelper(themeOverridePreferences);
                    _context3.prev = 2;
                    _iterator.s();
                case 3:
                    if ((_step = _iterator.n()).done) {
                        _context3.next = 5;
                        break;
                    }
                    themeId = _step.value;
                    _context3.next = 4;
                    return loadingStrategy(themeId);
                case 4:
                    _context3.next = 3;
                    break;
                case 5:
                    _context3.next = 7;
                    break;
                case 6:
                    _context3.prev = 6;
                    _t = _context3["catch"](2);
                    _iterator.e(_t);
                case 7:
                    _context3.prev = 7;
                    _iterator.f();
                    return _context3.finish(7);
                case 8:
                    autoUnbind = (0, $f4b77aa2f7f5786e$export$2e2bcd8739ae039)(themeState);
                    return _context3.abrupt("return", autoUnbind);
                case 9:
                case "end":
                    return _context3.stop();
            }
        }, _callee3, null, [
            [
                2,
                6,
                7,
                8
            ]
        ]);
    }));
    return function setGlobalTheme() {
        return _ref.apply(this, arguments);
    };
}();
var $8bf1aef1fc38591e$export$2e2bcd8739ae039 = $8bf1aef1fc38591e$var$setGlobalTheme;


var $4lL0s = parcelRequire("4lL0s");

var $5FkrB = parcelRequire("5FkrB");

var $5FkrB = parcelRequire("5FkrB");
var $68cd4dbde731b5ad$export$d2def9838ca456c0 = /*#__PURE__*/ (0, $5FkrB.createContext)(false);


var $55fde8f193bc2a9c$export$a782702263f77544 = function useIsAppProviderThemingEnabled() {
    return (0, $5FkrB.useContext)((0, $68cd4dbde731b5ad$export$d2def9838ca456c0));
};



var $5FkrB = parcelRequire("5FkrB");

var $5FkrB = parcelRequire("5FkrB");
var $9086157d46ac3faa$export$7981b2444296e410 = /*#__PURE__*/ (0, $5FkrB.createContext)(false);


var $9bdfa91c59ce8021$export$26aa23367bfbab0e = function useIsInsideAppProvider() {
    return (0, $5FkrB.useContext)((0, $9086157d46ac3faa$export$7981b2444296e410));
};



var $5FkrB = parcelRequire("5FkrB");
var $3cdde9c69a3931ec$export$49ddd74a6729fdb0 = /*#__PURE__*/ (0, $5FkrB.createContext)(undefined);



var $5FkrB = parcelRequire("5FkrB");
var $fb433ed4309ac975$export$332347eeb335453c = /*#__PURE__*/ (0, $5FkrB.createContext)(false);



var $5FkrB = parcelRequire("5FkrB");
var $d6b9509e96d41a61$export$b06130bad0bbc70f = /*#__PURE__*/ (0, $5FkrB.createContext)(undefined);



var $5FkrB = parcelRequire("5FkrB");
var $97e5deb61c45172a$export$2c657da244d00bd6 = /*#__PURE__*/ (0, $5FkrB.createContext)(undefined);
var $97e5deb61c45172a$export$f7a97b47760e2a13 = /*#__PURE__*/ (0, $5FkrB.createContext)(undefined);



var $5FkrB = parcelRequire("5FkrB");

var $86aaa3ac32e1953e$export$7ca11437599d653d = function useIsInsideThemeProvider() {
    var _useContext;
    return (_useContext = (0, $5FkrB.useContext)((0, $fb433ed4309ac975$export$332347eeb335453c))) !== null && _useContext !== void 0 ? _useContext : false;
};



var $dZJgY = parcelRequire("dZJgY");

var $emmWV = parcelRequire("emmWV");
var $34484a9ce248712c$export$f65ca476c09acec0 = function getDocument() {
    if (typeof document !== 'undefined') return document;
    return null;
};





var $4lL0s = parcelRequire("4lL0s");
function $349924b0a1819cd7$export$835a0dc855d02822(themeId) {
    var doc = (0, $34484a9ce248712c$export$f65ca476c09acec0)();
    if (!doc) return false;
    return doc.head.querySelector("style[".concat((0, $4lL0s.THEME_DATA_ATTRIBUTE), "=\"").concat(themeId, "\"]"));
}


var $3629639b24ebc51e$var$loadThemeCss = /*#__PURE__*/ function() {
    var _ref = (0, $dZJgY.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($emmWV))).mark(function _callee(themeId) {
        var _yield$themeImportMap, themeCss;
        return (0, (/*@__PURE__*/$parcel$interopDefault($emmWV))).wrap(function(_context) {
            while(true)switch(_context.prev = _context.next){
                case 0:
                    if (!(0, $349924b0a1819cd7$export$835a0dc855d02822)(themeId)) {
                        _context.next = 1;
                        break;
                    }
                    return _context.abrupt("return");
                case 1:
                    if (themeId) {
                        _context.next = 2;
                        break;
                    }
                    return _context.abrupt("return");
                case 2:
                    _context.next = 3;
                    return (0, $cfabd87273d3d79f$export$2e2bcd8739ae039)[themeId]();
                case 3:
                    _yield$themeImportMap = _context.sent;
                    themeCss = _yield$themeImportMap.default;
                    return _context.abrupt("return", themeCss);
                case 4:
                case "end":
                    return _context.stop();
            }
        }, _callee);
    }));
    return function loadThemeCss(_x) {
        return _ref.apply(this, arguments);
    };
}();
var $3629639b24ebc51e$var$mountThemeCss = /*#__PURE__*/ function() {
    var _ref2 = (0, $dZJgY.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($emmWV))).mark(function _callee2(css, themeId) {
        var doc, style;
        return (0, (/*@__PURE__*/$parcel$interopDefault($emmWV))).wrap(function(_context2) {
            while(true)switch(_context2.prev = _context2.next){
                case 0:
                    // SSR-safe: Only mount on client side
                    doc = (0, $34484a9ce248712c$export$f65ca476c09acec0)();
                    if (doc) {
                        _context2.next = 1;
                        break;
                    }
                    return _context2.abrupt("return");
                case 1:
                    style = doc.createElement('style');
                    style.textContent = css;
                    style.dataset.theme = themeId;
                    // Prevent duplicate mounting of themes.
                    // It's possible the theme was already being loaded elsewhere.
                    if (!(0, $349924b0a1819cd7$export$835a0dc855d02822)(themeId)) {
                        _context2.next = 2;
                        break;
                    }
                    return _context2.abrupt("return");
                case 2:
                    doc.head.appendChild(style);
                case 3:
                case "end":
                    return _context2.stop();
            }
        }, _callee2);
    }));
    return function mountThemeCss(_x2, _x3) {
        return _ref2.apply(this, arguments);
    };
}();
var $3629639b24ebc51e$var$loadAndMountThemeCss = /*#__PURE__*/ function() {
    var _ref3 = (0, $dZJgY.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($emmWV))).mark(function _callee3(themeId) {
        var themeCss;
        return (0, (/*@__PURE__*/$parcel$interopDefault($emmWV))).wrap(function(_context3) {
            while(true)switch(_context3.prev = _context3.next){
                case 0:
                    _context3.next = 1;
                    return $3629639b24ebc51e$var$loadThemeCss(themeId);
                case 1:
                    themeCss = _context3.sent;
                    if (themeCss) {
                        _context3.next = 2;
                        break;
                    }
                    return _context3.abrupt("return");
                case 2:
                    $3629639b24ebc51e$var$mountThemeCss(themeCss, themeId);
                case 3:
                case "end":
                    return _context3.stop();
            }
        }, _callee3);
    }));
    return function loadAndMountThemeCss(_x4) {
        return _ref3.apply(this, arguments);
    };
}();
var $3629639b24ebc51e$export$7d4a7e812d176b24 = /*#__PURE__*/ function() {
    var _ref4 = (0, $dZJgY.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($emmWV))).mark(function _callee4(theme) {
        var themesToLoad;
        return (0, (/*@__PURE__*/$parcel$interopDefault($emmWV))).wrap(function(_context4) {
            while(true)switch(_context4.prev = _context4.next){
                case 0:
                    themesToLoad = Object.values(theme).filter(function(themeId) {
                        return !!themeId;
                    });
                    themesToLoad.forEach($3629639b24ebc51e$var$loadAndMountThemeCss);
                case 1:
                case "end":
                    return _context4.stop();
            }
        }, _callee4);
    }));
    return function loadAndMountThemes(_x5) {
        return _ref4.apply(this, arguments);
    };
}();


function $9db461ddf8060a9d$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $9db461ddf8060a9d$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $9db461ddf8060a9d$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $jgyhF.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $9db461ddf8060a9d$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $9db461ddf8060a9d$var$defaultThemeSettings = {
    dark: 'dark',
    light: 'light',
    spacing: 'spacing',
    typography: 'typography'
};
var $9db461ddf8060a9d$var$isMatchMediaAvailable = typeof window !== 'undefined' && 'matchMedia' in window;
var $9db461ddf8060a9d$var$prefersDarkModeMql = $9db461ddf8060a9d$var$isMatchMediaAvailable ? window.matchMedia('(prefers-color-scheme: dark)') : undefined;
// TODO: currently 'auto' color mode will always return 'light' in SSR.
// Additional work required: https://product-fabric.atlassian.net/browse/DSP-9781
function $9db461ddf8060a9d$var$getReconciledColorMode(colorMode) {
    if (colorMode === 'auto') return $9db461ddf8060a9d$var$prefersDarkModeMql !== null && $9db461ddf8060a9d$var$prefersDarkModeMql !== void 0 && $9db461ddf8060a9d$var$prefersDarkModeMql.matches ? 'dark' : 'light';
    return colorMode;
}
var $9db461ddf8060a9d$var$contentStyles = {
    body: "_1e0c1bgi"
};
/**
 * __Theme provider__
 *
 * Provides global theming configuration.
 */ function $9db461ddf8060a9d$var$ThemeProvider(_ref) {
    var children = _ref.children, _ref$defaultColorMode = _ref.defaultColorMode, defaultColorMode = _ref$defaultColorMode === void 0 ? 'auto' : _ref$defaultColorMode, defaultTheme = _ref.defaultTheme;
    var _useState = (0, $5FkrB.useState)(defaultColorMode), _useState2 = (0, $amAaq.default)(_useState, 2), chosenColorMode = _useState2[0], setChosenColorMode = _useState2[1];
    var _useState3 = (0, $5FkrB.useState)($9db461ddf8060a9d$var$getReconciledColorMode(defaultColorMode)), _useState4 = (0, $amAaq.default)(_useState3, 2), reconciledColorMode = _useState4[0], setReconciledColorMode = _useState4[1];
    var _useState5 = (0, $5FkrB.useState)(function() {
        return $9db461ddf8060a9d$var$_objectSpread($9db461ddf8060a9d$var$_objectSpread({}, $9db461ddf8060a9d$var$defaultThemeSettings), defaultTheme);
    }), _useState6 = (0, $amAaq.default)(_useState5, 2), theme = _useState6[0], setTheme = _useState6[1];
    var setColorMode = (0, $5FkrB.useCallback)(function(colorMode) {
        setChosenColorMode(colorMode);
        setReconciledColorMode($9db461ddf8060a9d$var$getReconciledColorMode(colorMode));
    }, []);
    var setPartialTheme = (0, $5FkrB.useCallback)(function(nextTheme) {
        setTheme(function(theme) {
            return $9db461ddf8060a9d$var$_objectSpread($9db461ddf8060a9d$var$_objectSpread({}, theme), nextTheme);
        });
    }, []);
    var lastSetGlobalThemePromiseRef = (0, $5FkrB.useRef)(null);
    var isInsideAppProvider = (0, $9bdfa91c59ce8021$export$26aa23367bfbab0e)();
    var isAppProviderThemingEnabled = (0, $55fde8f193bc2a9c$export$a782702263f77544)();
    var isInsideThemeProvider = (0, $86aaa3ac32e1953e$export$7ca11437599d653d)();
    /**
   * A top-level ThemeProvider is detected by being the first ThemeProvider inside an AppProvider.
   *
   * This will not use sub-tree theming but instead set the global theme state using the
   * `@atlaskit/tokens` APIs, as it's required for styling root `html` and `body` elements
   * for compatibility with `@atlaskit/css-reset`.
   *
   * In the future we could consider moving away from DOM mutations and require AppProvider to wrap
   * `html` in order to apply global theme state, which would allow a more consistent approach to
   * theme loading.
   */ var isRootThemeProvider = isInsideAppProvider && !isInsideThemeProvider && isAppProviderThemingEnabled;
    (0, $5FkrB.useEffect)(function() {
        if (isRootThemeProvider) {
            /**
       * We need to wait for any previous `setGlobalTheme` calls to finish before calling it again.
       * This is to prevent race conditions as `setGlobalTheme` is async and mutates the DOM (e.g. sets the
       * `data-color-mode` attribute on the root element).
       *
       * Since we can't safely abort the `setGlobalTheme` execution, we need to wait for it to properly finish before
       * applying the new theme.
       *
       * Without this, we can end up in the following scenario:
       * 1. app loads with the default 'light' theme, kicking off `setGlobalTheme`
       * 2. app switches to 'dark' theme after retrieving value persisted in local storage, calling `setGlobalTheme` again
       * 3. `setGlobalTheme` function execution for `dark` finishes before the initial `light` execution
       * 4. `setGlobalTheme` function execution for `light` then finishes, resulting in the 'light' theme being applied.
       */ var cleanupLastFnCall = /*#__PURE__*/ function() {
                var _ref2 = (0, $dZJgY.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($emmWV))).mark(function _callee() {
                    var unbindFn;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($emmWV))).wrap(function(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                if (!lastSetGlobalThemePromiseRef.current) {
                                    _context.next = 2;
                                    break;
                                }
                                _context.next = 1;
                                return lastSetGlobalThemePromiseRef.current;
                            case 1:
                                unbindFn = _context.sent;
                                unbindFn();
                                lastSetGlobalThemePromiseRef.current = null;
                            case 2:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee);
                }));
                return function cleanupLastFnCall() {
                    return _ref2.apply(this, arguments);
                };
            }();
            var safelySetGlobalTheme = /*#__PURE__*/ function() {
                var _ref3 = (0, $dZJgY.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($emmWV))).mark(function _callee2() {
                    var promise;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($emmWV))).wrap(function(_context2) {
                        while(true)switch(_context2.prev = _context2.next){
                            case 0:
                                _context2.next = 1;
                                return cleanupLastFnCall();
                            case 1:
                                promise = (0, $8bf1aef1fc38591e$export$2e2bcd8739ae039)($9db461ddf8060a9d$var$_objectSpread($9db461ddf8060a9d$var$_objectSpread({}, theme), {}, {
                                    colorMode: reconciledColorMode
                                }));
                                lastSetGlobalThemePromiseRef.current = promise;
                            case 2:
                            case "end":
                                return _context2.stop();
                        }
                    }, _callee2);
                }));
                return function safelySetGlobalTheme() {
                    return _ref3.apply(this, arguments);
                };
            }();
            safelySetGlobalTheme();
            return function cleanup() {
                cleanupLastFnCall();
            };
        } else // For other theme providers (whether outside AppProvider or nested inside a ThemeProvider),
        // we treat them as sub-tree themes that do not load global theme state.
        (0, $3629639b24ebc51e$export$7d4a7e812d176b24)(theme);
    }, [
        isInsideAppProvider,
        isInsideThemeProvider,
        isRootThemeProvider,
        reconciledColorMode,
        theme
    ]);
    (0, $5FkrB.useEffect)(function() {
        if (!$9db461ddf8060a9d$var$prefersDarkModeMql) return;
        var unbindListener = (0, $5b617c1f48263075$exports.bind)($9db461ddf8060a9d$var$prefersDarkModeMql, {
            type: 'change',
            listener: function listener(event) {
                if (chosenColorMode === 'auto') setReconciledColorMode(event.matches ? 'dark' : 'light');
            }
        });
        return unbindListener;
    }, [
        chosenColorMode
    ]);
    var attrs = $9db461ddf8060a9d$var$_objectSpread($9db461ddf8060a9d$var$_objectSpread({}, (0, $fd68ec7ca1e70bad$export$2e2bcd8739ae039)($9db461ddf8060a9d$var$_objectSpread($9db461ddf8060a9d$var$_objectSpread({}, theme), {}, {
        colorMode: reconciledColorMode
    }))), {}, (0, $jgyhF.default)({}, (0, $4lL0s.SUBTREE_THEME_ATTRIBUTE), true));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $fb433ed4309ac975$export$332347eeb335453c).Provider, {
        value: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $3cdde9c69a3931ec$export$49ddd74a6729fdb0).Provider, {
        value: reconciledColorMode
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $d6b9509e96d41a61$export$b06130bad0bbc70f).Provider, {
        value: setColorMode
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $97e5deb61c45172a$export$2c657da244d00bd6).Provider, {
        value: theme
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $97e5deb61c45172a$export$f7a97b47760e2a13).Provider, {
        value: setPartialTheme
    }, !isRootThemeProvider ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("div", (0, $d0778aa44ff9fe37$export$2e2bcd8739ae039)({}, attrs, {
        className: (0, $gKzKW.default)([
            $9db461ddf8060a9d$var$contentStyles.body
        ])
    }), children) : children)))));
}
var $9db461ddf8060a9d$export$2e2bcd8739ae039 = $9db461ddf8060a9d$var$ThemeProvider;


var $amAaq = parcelRequire("amAaq");

var $5FkrB = parcelRequire("5FkrB");

var $cdRUW = parcelRequire("cdRUW");

var $i1Bei = parcelRequire("i1Bei");

var $jgyhF = parcelRequire("jgyhF");

var $4lL0s = parcelRequire("4lL0s");

/**
 * A MutationObserver which watches the `<html>` element for changes to the theme.
 *
 * In React, use the {@link useThemeObserver `useThemeObserver`} hook instead.
 *
 * @param {function} callback - A callback function which fires when the theme changes.
 *
 * @example
 * ```
 * const observer = new ThemeMutationObserver((theme) => {});
 * observer.observe();
 * ```
 */ var $1e494173ff35d546$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function ThemeMutationObserver(callback) {
        (0, $cdRUW.default)(this, ThemeMutationObserver);
        (0, $jgyhF.default)(this, "legacyObserver", null);
        this.callback = callback;
        ThemeMutationObserver.callbacks.add(callback);
    }
    return (0, $i1Bei.default)(ThemeMutationObserver, [
        {
            key: "observe",
            value: function observe() {
                if (!ThemeMutationObserver.observer) {
                    ThemeMutationObserver.observer = new MutationObserver(function() {
                        var theme = (0, $1fed8c4230004f10$export$2e2bcd8739ae039)();
                        ThemeMutationObserver.callbacks.forEach(function(callback) {
                            return callback(theme);
                        });
                    });
                    // Observer only needs to be configured once
                    ThemeMutationObserver.observer.observe(document.documentElement, {
                        attributeFilter: [
                            (0, $4lL0s.THEME_DATA_ATTRIBUTE),
                            (0, $4lL0s.COLOR_MODE_ATTRIBUTE)
                        ]
                    });
                }
            }
        },
        {
            key: "disconnect",
            value: function disconnect() {
                if (this.callback) ThemeMutationObserver.callbacks.delete(this.callback);
                if (ThemeMutationObserver.callbacks.size === 0 && ThemeMutationObserver.observer) {
                    ThemeMutationObserver.observer.disconnect();
                    ThemeMutationObserver.observer = null;
                }
            }
        }
    ]);
}();
(0, $jgyhF.default)($1e494173ff35d546$export$2e2bcd8739ae039, "observer", null);
(0, $jgyhF.default)($1e494173ff35d546$export$2e2bcd8739ae039, "callbacks", new Set());



function $07f455a3a4bbfece$export$20f3076712c8dfa() {
    var value = (0, $5FkrB.useContext)((0, $3cdde9c69a3931ec$export$49ddd74a6729fdb0));
    // TODO: This will only return 'light' or 'dark' but never 'auto', which in some cases
    // may be desirable. We should consider returning both the reconciled color mode (e.g. 'light' or 'dark') and the selected color mode ("auto").
    var theme = (0, $1fed8c4230004f10$export$2e2bcd8739ae039)();
    var _useState = (0, $5FkrB.useState)((theme === null || theme === void 0 ? void 0 : theme.colorMode) || 'light'), _useState2 = (0, $amAaq.default)(_useState, 2), resolvedColorMode = _useState2[0], setResolvedColorMode = _useState2[1];
    (0, $5FkrB.useEffect)(function() {
        // We are using theme from context so no need to reference the DOM
        if (value) return;
        var observer = new (0, $1e494173ff35d546$export$2e2bcd8739ae039)(function(theme) {
            setResolvedColorMode((theme === null || theme === void 0 ? void 0 : theme.colorMode) || 'light');
        });
        observer.observe();
        return function() {
            return observer.disconnect();
        };
    }, [
        value
    ]);
    return value ? value : resolvedColorMode;
}




var $04f78804ccfa51ad$export$e4c79eb95c23a0da = 'atlaskit-portal-container';
var $04f78804ccfa51ad$export$72f415121273627e = 'body > .atlaskit-portal-container';
var $04f78804ccfa51ad$export$13f57c02915787b3 = 'atlaskit-portal';


/**
 * Returns document body element
 * @return {number} - The document body element
 */ var $a1e5795ef426d158$export$135b49d4bc2964c6 = function getBody() {
    return document.body;
};


var $8f403e055fe46d44$var$getPortalParent = function getPortalParent() {
    var parentElement = document.querySelector((0, $04f78804ccfa51ad$export$72f415121273627e));
    if (!parentElement) {
        var _getBody;
        var parent = document.createElement('div');
        parent.className = (0, $04f78804ccfa51ad$export$e4c79eb95c23a0da);
        // we are setting display to flex because we want each portal to create a new stacking context
        // See https://developer.mozilla.org/en-US/docs/Web/CSS/CSS_Positioning/Understanding_z_index/The_stacking_context
        parent.style.display = 'flex';
        (_getBody = (0, $a1e5795ef426d158$export$135b49d4bc2964c6)()) === null || _getBody === void 0 || _getBody.appendChild(parent);
        return parent;
    }
    return parentElement;
};
var $8f403e055fe46d44$export$c582005add11e141 = function appendPortalContainerIfNotAppended(container) {
    if (!container.parentElement) $8f403e055fe46d44$var$getPortalParent().appendChild(container);
};



var $d67101300eea6778$export$26ae5ca175b4ec5a = function createContainer(zIndex) {
    var container = document.createElement('div');
    container.className = (0, $04f78804ccfa51ad$export$13f57c02915787b3);
    container.style.zIndex = "".concat(zIndex);
    return container;
};




var $4f122bb59086132b$var$getPortalParent = function getPortalParent() {
    var parentElement = document.querySelector((0, $04f78804ccfa51ad$export$72f415121273627e));
    if (!parentElement) {
        var _getBody;
        var parent = document.createElement('div');
        parent.className = (0, $04f78804ccfa51ad$export$e4c79eb95c23a0da);
        // we are setting display to flex because we want each portal to create a new stacking context
        // See https://developer.mozilla.org/en-US/docs/Web/CSS/CSS_Positioning/Understanding_z_index/The_stacking_context
        parent.style.display = 'flex';
        (_getBody = (0, $a1e5795ef426d158$export$135b49d4bc2964c6)()) === null || _getBody === void 0 || _getBody.appendChild(parent);
        return parent;
    }
    return parentElement;
};
var $4f122bb59086132b$export$da99f98bf3fe55b3 = function removePortalContainer(container) {
    var parent = $4f122bb59086132b$var$getPortalParent();
    if (parent.contains(container)) parent.removeChild(container);
};


function $e239581e474b306c$export$2e2bcd8739ae039(props) {
    var zIndex = props.zIndex, children = props.children, _props$isClosed = props.isClosed, isClosed = _props$isClosed === void 0 ? false : _props$isClosed;
    var container = (0, $5FkrB.useMemo)(function() {
        return (0, $d67101300eea6778$export$26ae5ca175b4ec5a)(zIndex);
    }, [
        zIndex
    ]);
    var colorMode = (0, $07f455a3a4bbfece$export$20f3076712c8dfa)();
    var isInsideThemeProvider = (0, $86aaa3ac32e1953e$export$7ca11437599d653d)();
    // This is in the render method instead of useEffect so that
    // the portal will be added to the DOM before the children render.
    // For any further changes, ensure that the container does not have a
    // parent besides the portal parent.
    (0, $8f403e055fe46d44$export$c582005add11e141)(container);
    (0, $5FkrB.useEffect)(function() {
        if ((0, $e42e4fc8d6dbdb34$export$b40ec24ac8275656)('import_into_jsm_in_template_gallery_killswitch')) {
            if (isClosed) (0, $4f122bb59086132b$export$da99f98bf3fe55b3)(container);
        }
    }, [
        isClosed,
        container
    ]);
    (0, $5FkrB.useEffect)(function() {
        return function() {
            (0, $4f122bb59086132b$export$da99f98bf3fe55b3)(container);
        };
    }, [
        container
    ]);
    return /*#__PURE__*/ (0, $7d59b24134129acf$exports.createPortal)(isInsideThemeProvider ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $9db461ddf8060a9d$export$2e2bcd8739ae039), {
        defaultColorMode: colorMode
    }, children) : children, container);
}



var $amAaq = parcelRequire("amAaq");

var $5FkrB = parcelRequire("5FkrB");





var $5FkrB = parcelRequire("5FkrB");
var $94e580704bd00dcf$export$700979bc83e7db82 = typeof window !== 'undefined' ? (0, $5FkrB.useLayoutEffect) : (0, $5FkrB.useEffect);



var $77bb8720ad6c9034$var$isDocumentDefined = function isDocumentDefined() {
    return document !== undefined;
};
var $77bb8720ad6c9034$export$fef014d7cef9e543 = function createAtlaskitPortal(zIndex) {
    //atlaskit-portal div
    if ($77bb8720ad6c9034$var$isDocumentDefined()) {
        var atlaskitportal = document.createElement('div');
        atlaskitportal.className = (0, $04f78804ccfa51ad$export$13f57c02915787b3);
        atlaskitportal.style.zIndex = "".concat(zIndex);
        return atlaskitportal;
    }
    return;
};




var $81e99c447ed116d2$var$isDocumentDefined = function isDocumentDefined() {
    return document !== undefined;
};
var $81e99c447ed116d2$export$95029ca7aca2989e = function createPortalParent() {
    //atlaskit-portal-container div
    if ($81e99c447ed116d2$var$isDocumentDefined()) {
        var parentElement = document.querySelector((0, $04f78804ccfa51ad$export$72f415121273627e));
        if (!parentElement) {
            var _getBody;
            var parent = document.createElement('div');
            parent.className = (0, $04f78804ccfa51ad$export$e4c79eb95c23a0da);
            parent.style.display = 'flex';
            (_getBody = (0, $a1e5795ef426d158$export$135b49d4bc2964c6)()) === null || _getBody === void 0 || _getBody.appendChild(parent);
            return parent;
        }
        return parentElement;
    }
    return;
};



var $8626938e88cbcda7$var$isDocumentDefined = function isDocumentDefined() {
    return document !== undefined;
};
var $8626938e88cbcda7$export$7b20876b2769b301 = function removePortalParent(parentElement) {
    if ($8626938e88cbcda7$var$isDocumentDefined()) {
        if (parentElement) {
            var _getBody;
            (_getBody = (0, $a1e5795ef426d158$export$135b49d4bc2964c6)()) === null || _getBody === void 0 || _getBody.removeChild(parentElement);
        }
    }
};


function $fa724c68b8d6867c$export$2e2bcd8739ae039(props) {
    var zIndex = props.zIndex, children = props.children, isClosed = props.isClosed;
    var _useState = (0, $5FkrB.useState)(null), _useState2 = (0, $amAaq.default)(_useState, 2), atlaskitPortal = _useState2[0], setAtlaskitPortal = _useState2[1];
    var colorMode = (0, $07f455a3a4bbfece$export$20f3076712c8dfa)();
    var isInsideThemeProvider = (0, $86aaa3ac32e1953e$export$7ca11437599d653d)();
    (0, $94e580704bd00dcf$export$700979bc83e7db82)(function() {
        if ((0, $e42e4fc8d6dbdb34$export$b40ec24ac8275656)('import_into_jsm_in_template_gallery_killswitch')) {
            if (!isClosed) {
                var tempPortalContainer = (0, $77bb8720ad6c9034$export$fef014d7cef9e543)(zIndex);
                setAtlaskitPortal(tempPortalContainer);
                var portalParent = (0, $81e99c447ed116d2$export$95029ca7aca2989e)();
                if (!tempPortalContainer || !portalParent) return;
                portalParent.appendChild(tempPortalContainer);
                return function() {
                    if (portalParent) {
                        portalParent.removeChild(tempPortalContainer);
                        !portalParent.hasChildNodes() && (0, $8626938e88cbcda7$export$7b20876b2769b301)(portalParent);
                    }
                    setAtlaskitPortal(null);
                };
            }
        } else {
            var _tempPortalContainer = (0, $77bb8720ad6c9034$export$fef014d7cef9e543)(zIndex);
            setAtlaskitPortal(_tempPortalContainer);
            var _portalParent = (0, $81e99c447ed116d2$export$95029ca7aca2989e)();
            if (!_tempPortalContainer || !_portalParent) return;
            _portalParent.appendChild(_tempPortalContainer);
            return function() {
                if (_tempPortalContainer) _portalParent.removeChild(_tempPortalContainer);
                setAtlaskitPortal(null);
            };
        }
    }, [
        zIndex,
        isClosed,
        (0, $e42e4fc8d6dbdb34$export$b40ec24ac8275656)
    ]);
    /**
   * We wrap portal children with a Suspense boundary because in React 18 concurrent,
   * if you suspend from _within_ a portal to a Suspense boundary _outside_ the portal,
   * our portal gets in an infinite loop of rendering.
   */ var suspendedChildren = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $5FkrB.Suspense), {
        fallback: null
    }, isInsideThemeProvider ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $9db461ddf8060a9d$export$2e2bcd8739ae039), {
        defaultColorMode: colorMode
    }, children) : children);
    return atlaskitPortal ? /*#__PURE__*/ (0, $7d59b24134129acf$exports.createPortal)(suspendedChildren, atlaskitPortal) : null;
}



var $amAaq = parcelRequire("amAaq");

var $5FkrB = parcelRequire("5FkrB");

var $14658ce96c5d5b62$var$useIsSubsequentRender = function useIsSubsequentRender(mountStrategy) {
    var _useState = (0, $5FkrB.useState)(false), _useState2 = (0, $amAaq.default)(_useState, 2), isSubsequentRender = _useState2[0], setIsSubsequentRender = _useState2[1];
    var _useState3 = (0, $5FkrB.useState)(function() {
        return mountStrategy === 'layoutEffect' ? (0, $94e580704bd00dcf$export$700979bc83e7db82) : (0, $5FkrB.useEffect);
    }), _useState4 = (0, $amAaq.default)(_useState3, 1), useMountEffect = _useState4[0];
    useMountEffect(function() {
        setIsSubsequentRender(true);
    }, []);
    return isSubsequentRender;
};
var $14658ce96c5d5b62$export$2e2bcd8739ae039 = $14658ce96c5d5b62$var$useIsSubsequentRender;



var $5FkrB = parcelRequire("5FkrB");
var $b37cd4097799068f$export$ed5835cc67e87f72 = 'akPortalMount';
var $b37cd4097799068f$export$80816bd900e5bd00 = 'akPortalUnmount';


var $f3ca9f5a61c58db8$var$zIndexToName = {
    100: 'card',
    200: 'navigation',
    300: 'dialog',
    400: 'layer',
    500: 'blanket',
    510: 'modal',
    600: 'flag',
    700: 'spotlight',
    9999: 'tooltip'
};
/**
 * return layer name in Atlassian design system corresponding to given z-index
 * @param {number} zIndex - z-index value for which layer name is needed
 * @returns {LayerName | null} - The layer name for given z-index. If layer name is not found then null is returned
 */ var $f3ca9f5a61c58db8$var$getLayerName = function getLayerName(zIndex) {
    return $f3ca9f5a61c58db8$var$zIndexToName.hasOwnProperty(zIndex) ? $f3ca9f5a61c58db8$var$zIndexToName[zIndex] : null;
};
/**
 * Creates a PortalEvent object with given eventName, given zIndex and corresponding layer
 * @param {string} eventName - either of Mount or Unmount event name
 * @param {number} zIndex - z-index value which will be included in the event to be dispatched
 * @returns {PortalEvent} - The newly created PortalEvent object
 */ var $f3ca9f5a61c58db8$var$getEvent = function getEvent(eventName, zIndex) {
    var detail = {
        layer: $f3ca9f5a61c58db8$var$getLayerName(Number(zIndex)),
        zIndex: zIndex
    };
    return new CustomEvent(eventName, {
        detail: detail
    });
};
function $f3ca9f5a61c58db8$export$2e2bcd8739ae039(eventName, zIndex) {
    var event = $f3ca9f5a61c58db8$var$getEvent(eventName, zIndex);
    window.dispatchEvent(event);
}


var $26d5483fbac7b84e$var$useFirePortalEvent = function useFirePortalEvent(zIndex) {
    var zIndexNumber = Number(zIndex);
    (0, $5FkrB.useEffect)(function() {
        (0, $f3ca9f5a61c58db8$export$2e2bcd8739ae039)((0, $b37cd4097799068f$export$ed5835cc67e87f72), zIndexNumber);
        return function() {
            (0, $f3ca9f5a61c58db8$export$2e2bcd8739ae039)((0, $b37cd4097799068f$export$80816bd900e5bd00), zIndexNumber);
        };
    }, [
        zIndexNumber
    ]);
};
var $26d5483fbac7b84e$export$2e2bcd8739ae039 = $26d5483fbac7b84e$var$useFirePortalEvent;


function $a620f5b671fe1301$export$2e2bcd8739ae039(_ref) {
    var _ref$zIndex = _ref.zIndex, zIndex = _ref$zIndex === void 0 ? 0 : _ref$zIndex, children = _ref.children, _ref$mountStrategy = _ref.mountStrategy, mountStrategy = _ref$mountStrategy === void 0 ? 'effect' : _ref$mountStrategy, _ref$isClosed = _ref.isClosed, isClosed = _ref$isClosed === void 0 ? false : _ref$isClosed;
    var isSubsequentRender = (0, $14658ce96c5d5b62$export$2e2bcd8739ae039)(mountStrategy);
    (0, $26d5483fbac7b84e$export$2e2bcd8739ae039)(zIndex);
    return !(0, $e42e4fc8d6dbdb34$export$b40ec24ac8275656)('platform_design_system_team_portal_logic_r18_fix') ? isSubsequentRender ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $e239581e474b306c$export$2e2bcd8739ae039), {
        zIndex: zIndex,
        isClosed: isClosed
    }, children) : null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $fa724c68b8d6867c$export$2e2bcd8739ae039), {
        zIndex: zIndex,
        isClosed: isClosed
    }, children);
}


/* eslint-disable @atlaskit/volt-strict-mode/no-multiple-exports */ /* eslint-disable no-console */ var $f2f4a868e548940a$var$printed = {};
function $f2f4a868e548940a$export$2e2bcd8739ae039(message) {
    if ($f2f4a868e548940a$var$printed[message]) return;
    $f2f4a868e548940a$var$printed[message] = true;
    if (typeof window !== 'undefined') console.warn(message);
}


function $ef3aa319a548c3c6$export$2e2bcd8739ae039(packageName, api, additionalMessage) {
    (0, $f2f4a868e548940a$export$2e2bcd8739ae039)("[".concat(packageName, "]: The ").concat(api, " is deprecated.").concat(additionalMessage && " ".concat(additionalMessage)));
}


var $c0a194344ea2dc83$export$44ffba16bd48dac6 = '__ATLASKIT_THEME__';
var $c0a194344ea2dc83$export$c93026a968943f95 = 'light';
var $c0a194344ea2dc83$export$6ba72c8346b4c57e = [
    'light',
    'dark'
];
var $c0a194344ea2dc83$export$8e24544ddba725ee = function focusRing() {
    var color = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "var(--ds-border-focused, #4688EC)";
    var outlineWidth = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
    (0, $ef3aa319a548c3c6$export$2e2bcd8739ae039)('@atlaskit/theme', 'focus ring mixin', 'Please use `@atlaskit/focus-ring` instead.');
    return "\n  &:focus {\n    outline: none;\n    box-shadow: 0px 0px 0px ".concat(outlineWidth, "px ").concat(color, ";\n  }\n");
};
var $c0a194344ea2dc83$export$c0dd343266bc3261 = function noFocusRing() {
    return "\n  box-shadow: none;\n";
};
var $c0a194344ea2dc83$export$7be255094ccdc533 = {
    card: function card() {
        return 100;
    },
    navigation: function navigation() {
        return 200;
    },
    dialog: function dialog() {
        return 300;
    },
    layer: function layer() {
        return 400;
    },
    blanket: function blanket() {
        return 500;
    },
    modal: function modal() {
        return 510;
    },
    flag: function flag() {
        return 600;
    },
    spotlight: function spotlight() {
        return 700;
    },
    tooltip: function tooltip() {
        return 9999;
    }
};
var $c0a194344ea2dc83$export$a1b3edb637fb4f35 = function visuallyHidden() {
    (0, $ef3aa319a548c3c6$export$2e2bcd8739ae039)('@atlaskit/theme', 'visually hidden mixin', 'Please use `@atlaskit/visually-hidden` instead.');
    return {
        border: '0 !important',
        clip: 'rect(1px, 1px, 1px, 1px) !important',
        height: '1px !important',
        overflow: 'hidden !important',
        padding: '0 !important',
        position: 'absolute !important',
        width: '1px !important',
        whiteSpace: 'nowrap !important'
    };
};
var $c0a194344ea2dc83$export$ba1d834b86d72a09 = $c0a194344ea2dc83$export$a1b3edb637fb4f35;






/* eslint-disable @atlaskit/design-system/no-direct-use-of-web-platform-drag-and-drop */ /**
 * We are listening directly to drag events instead of using a monitor from
 * `@atlaskit/pragmatic-drag-and-drop` to avoid the bundle size cost, as it
 * would affect almost every view in every app.
 *
 * We can reconsider this choice in the future.
 */ 
var $74888a052401d677$var$registrations = new Set();
var $74888a052401d677$var$cleanupEndEventListeners = null;
function $74888a052401d677$var$onDragStart() {
    if ($74888a052401d677$var$cleanupEndEventListeners) // If the cleanup function exists then we've already run this
    return;
    $74888a052401d677$var$cleanupEndEventListeners = (0, $5b617c1f48263075$exports.bindAll)(window, [
        {
            type: 'dragend',
            listener: $74888a052401d677$var$onDragEnd
        },
        {
            type: 'pointerdown',
            listener: $74888a052401d677$var$onDragEnd
        },
        {
            type: 'pointermove',
            listener: function() {
                var callCount = 0;
                return function listener() {
                    // Using 20 as it is far bigger than the most observed (3)
                    if (callCount < 20) {
                        callCount++;
                        return;
                    }
                    $74888a052401d677$var$onDragEnd();
                };
            }()
        }
    ]);
    var clone = Array.from($74888a052401d677$var$registrations);
    clone.forEach(function(subscriber) {
        subscriber.onDragStart();
    });
}
function $74888a052401d677$var$onDragEnd() {
    var _cleanupEndEventListe;
    (_cleanupEndEventListe = $74888a052401d677$var$cleanupEndEventListeners) === null || _cleanupEndEventListe === void 0 || _cleanupEndEventListe();
    $74888a052401d677$var$cleanupEndEventListeners = null;
    var clone = Array.from($74888a052401d677$var$registrations);
    clone.forEach(function(subscriber) {
        subscriber.onDragEnd();
    });
}
function $74888a052401d677$var$bindStartEvents() {
    return (0, $5b617c1f48263075$exports.bindAll)(window, [
        {
            type: 'dragstart',
            listener: $74888a052401d677$var$onDragStart
        },
        {
            type: 'dragenter',
            listener: $74888a052401d677$var$onDragStart
        }
    ]);
}
var $74888a052401d677$var$cleanupStartEventListeners = null;
function $74888a052401d677$export$6503ec6e8aabbaf(registration) {
    // if first registration, bind event listeners
    if (!$74888a052401d677$var$cleanupStartEventListeners) // note: currently never unbinding these event listeners
    $74888a052401d677$var$cleanupStartEventListeners = $74888a052401d677$var$bindStartEvents();
    $74888a052401d677$var$registrations.add(registration);
    /**
   * The reasoning for this behavior is so that if a tooltip mounts during
   * a drag it can still be suppressed.
   *
   * We use a separate callback instead of onDragStart to avoid infinite loops.
   */ registration.onRegister({
        isDragging: $74888a052401d677$var$cleanupEndEventListeners !== null
    });
    return function unregister() {
        $74888a052401d677$var$registrations.delete(registration);
        if ($74888a052401d677$var$registrations.size === 0) {
            var _cleanupStartEventLis;
            (_cleanupStartEventLis = $74888a052401d677$var$cleanupStartEventListeners) === null || _cleanupStartEventLis === void 0 || _cleanupStartEventLis();
            $74888a052401d677$var$cleanupStartEventListeners = null;
        }
    };
}


/**
 * Returns the trigger's X edge for inline-axis placements, or the
 * trigger's horizontal center for block-axis placements.
 *
 * Note: does not account for RTL writing modes.
 */ function $c62b55b85bb21165$var$getTriggerEdgeX(_ref) {
    var triggerRect = _ref.triggerRect, placement = _ref.placement;
    if (placement.axis === 'inline') return placement.edge === 'start' ? triggerRect.left : triggerRect.right;
    return triggerRect.left + triggerRect.width / 2;
}
/**
 * Returns the trigger's Y edge for block-axis placements, or the
 * trigger's vertical center for inline-axis placements.
 */ function $c62b55b85bb21165$var$getTriggerEdgeY(_ref2) {
    var triggerRect = _ref2.triggerRect, placement = _ref2.placement;
    if (placement.axis === 'block') return placement.edge === 'start' ? triggerRect.top : triggerRect.bottom;
    return triggerRect.top + triggerRect.height / 2;
}
function $c62b55b85bb21165$export$d26fd3d066ede49(_ref3) {
    var cursor = _ref3.cursor, triggerRect = _ref3.triggerRect, tooltipPosition = _ref3.tooltipPosition, placement = _ref3.placement;
    if (tooltipPosition === 'mouse-y') return {
        x: $c62b55b85bb21165$var$getTriggerEdgeX({
            triggerRect: triggerRect,
            placement: placement
        }),
        y: cursor.clientY
    };
    if (tooltipPosition === 'mouse-x') return {
        x: cursor.clientX,
        y: $c62b55b85bb21165$var$getTriggerEdgeY({
            triggerRect: triggerRect,
            placement: placement
        })
    };
    // tooltipPosition === 'mouse'
    return {
        x: cursor.clientX,
        y: cursor.clientY
    };
}


function $0a145a13d52c0daa$export$2e68479e0a5d8746(mousePos, _ref) {
    var targetElement = _ref.targetElement, tooltipPosition = _ref.tooltipPosition;
    if (tooltipPosition === 'mouse') return {
        getBoundingClientRect: function getBoundingClientRect() {
            return DOMRect.fromRect({
                x: mousePos.clientX,
                y: mousePos.clientY,
                width: 0,
                height: 0
            });
        }
    };
    var targetRect = targetElement.getBoundingClientRect();
    if (tooltipPosition === 'mouse-x') return {
        getBoundingClientRect: function getBoundingClientRect() {
            return DOMRect.fromRect({
                x: mousePos.clientX,
                y: targetRect.top,
                width: 0,
                height: targetRect.height
            });
        }
    };
    if (tooltipPosition === 'mouse-y') return {
        getBoundingClientRect: function getBoundingClientRect() {
            return DOMRect.fromRect({
                x: targetRect.left,
                y: mousePos.clientY,
                width: targetRect.width,
                height: 0
            });
        }
    };
    throw new Error("Invalid tooltip position for virtual element: ".concat(tooltipPosition));
}



var $c685a299994bed13$var$delayId = null;
function $c685a299994bed13$var$clearScheduled() {
    if ($c685a299994bed13$var$delayId != null) {
        window.clearTimeout($c685a299994bed13$var$delayId);
        $c685a299994bed13$var$delayId = null;
    }
}
function $c685a299994bed13$var$scheduleTimeout(fn, delay) {
    $c685a299994bed13$var$clearScheduled();
    $c685a299994bed13$var$delayId = window.setTimeout(function() {
        $c685a299994bed13$var$delayId = null;
        fn();
    }, delay);
}
// This file is a singleton for managing tooltips.
//
// Once we roll out top-layer and remove the legacy path, this manager can be simplified:
// - Singleton: Can be removed; the platform (popover="auto" or popover="hint") already enforces
//   only one tooltip open at a time.
// - Phase machine: Can be simplified; drop hide-animating and finishHideAnimation (legacy fade-out).
//   Use e.g. pending-show | visible | pending-hide with immediate hide.
// - API: Can drop or simplify mousePosition/mousePos if no longer needed; keep delay scheduling,
//   keep(), requestHide, abort, and minimal lifecycle.
var $c685a299994bed13$var$active = null;
function $c685a299994bed13$export$57bf213be019eeb0(entry) {
    var phase = 'waiting-to-show';
    function isActive() {
        return Boolean($c685a299994bed13$var$active && $c685a299994bed13$var$active.entry === entry);
    }
    function cleanup() {
        if (isActive()) {
            $c685a299994bed13$var$clearScheduled();
            $c685a299994bed13$var$active = null;
        }
    }
    function done() {
        if (isActive()) entry.done();
        phase = 'done';
        cleanup();
    }
    function immediatelyHideAndDone() {
        if (isActive()) entry.hide({
            isImmediate: true
        });
        done();
    }
    function keep() {
        if (!isActive()) return;
        // aborting a wait to hide
        if (phase === 'waiting-to-hide') {
            phase = 'shown';
            $c685a299994bed13$var$clearScheduled();
            return;
        }
        // aborting hide animation
        if (phase === 'hide-animating') {
            phase = 'shown';
            $c685a299994bed13$var$clearScheduled();
            entry.show({
                isImmediate: false
            });
            return;
        }
    }
    function requestHide(_ref) {
        var isImmediate = _ref.isImmediate;
        if (!isActive()) return;
        // If we were not showing yet anyway; finish straight away
        if (phase === 'waiting-to-show') {
            immediatelyHideAndDone();
            return;
        }
        // already waiting to hide
        // Bug in legacy path: isImmediate hide requests are ignored during waiting-to-hide,
        // meaning Escape/scroll won't instantly dismiss a tooltip that's already fading out.
        // Gated fix: only apply the immediate-hide behavior under the top-layer flag for now.
        if (phase === 'waiting-to-hide') {
            if (isImmediate && (0, $2fcbb5e4cf9206d1$export$b40ec24ac8275656)('platform-dst-top-layer-tooltip')) immediatelyHideAndDone();
            return;
        }
        if (isImmediate) {
            immediatelyHideAndDone();
            return;
        }
        phase = 'waiting-to-hide';
        $c685a299994bed13$var$scheduleTimeout(function() {
            phase = 'hide-animating';
            entry.hide({
                isImmediate: false
            });
        }, entry.delay);
    }
    function finishHideAnimation() {
        if (isActive() && phase === 'hide-animating') done();
    }
    function isVisible() {
        return phase === 'shown' || phase === 'waiting-to-hide' || phase === 'hide-animating';
    }
    function start() {
        var shouldAlwaysFadeIn = entry.shouldAlwaysFadeIn;
        var showImmediately = Boolean($c685a299994bed13$var$active && $c685a299994bed13$var$active.isVisible()) && !shouldAlwaysFadeIn;
        // If there was an active tooltip; we tell it to remove itself at once!
        if ($c685a299994bed13$var$active) {
            $c685a299994bed13$var$clearScheduled();
            $c685a299994bed13$var$active.entry.hide({
                isImmediate: true
            });
            $c685a299994bed13$var$active.entry.done();
            $c685a299994bed13$var$active = null;
        }
        // this tooltip is now the active tooltip
        $c685a299994bed13$var$active = {
            entry: entry,
            isVisible: isVisible
        };
        function show() {
            phase = 'shown';
            entry.show({
                isImmediate: showImmediately
            });
        }
        if (showImmediately) {
            show();
            return;
        }
        phase = 'waiting-to-show';
        $c685a299994bed13$var$scheduleTimeout(show, entry.delay);
    }
    // let's get started!
    start();
    var result = {
        keep: keep,
        abort: cleanup,
        isActive: isActive,
        requestHide: requestHide,
        finishHideAnimation: finishHideAnimation,
        mousePos: entry.source.type === 'mouse' ? {
            clientX: entry.source.clientX,
            clientY: entry.source.clientY
        } : null
    };
    return result;
}



function $b5cf4e0d57245932$export$2e2bcd8739ae039(prefix, shouldRenderId) {
    var seed = (0, $fe7aa1f51e629d74$export$6ee17796e3d70de2)();
    return shouldRenderId ? "".concat(seed(prefix)) : undefined;
}


/* tooltip-container.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $5FkrB = parcelRequire("5FkrB");

var $gKzKW = parcelRequire("gKzKW");
/* tooltip-primitive.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $5FkrB = parcelRequire("5FkrB");

var $gKzKW = parcelRequire("gKzKW");
/* tooltip-shortcut.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $5FkrB = parcelRequire("5FkrB");

var $gKzKW = parcelRequire("gKzKW");
var $c097968232e427b0$var$styles = {
    shortcutSegmentsContainer: "_zulpv77o _1e0c1txw _1q511b66 _85i5v77o",
    shortcutSegment: "_11c8wadc _2rkolb4i _1dqonqa1 _189ee4h9 _1h6d1ihb _1e0c1txw _4cvr1h6o _4t3i1k92 _vchhusvi _1q51v77o _85i5v77o _bozg12x7 _y4ti12x7 _16qsn7od _1254n7od _cgnln7od _syazn7od _ahbqn7od _12l2n7od _1pfhn7od _6rthn7od _1ul9n7od _w19jn7od _bfhk261p"
};
var $c097968232e427b0$export$5bcbc43c84236222 = function TooltipShortcut(_ref) {
    var shortcut = _ref.shortcut;
    return /*#__PURE__*/ $5FkrB.createElement("div", {
        className: (0, $gKzKW.default)([
            $c097968232e427b0$var$styles.shortcutSegmentsContainer
        ])
    }, shortcut.map(function(segment, index) {
        return /*#__PURE__*/ $5FkrB.createElement("kbd", {
            key: "".concat(segment, "-").concat(index),
            className: (0, $gKzKW.default)([
                $c097968232e427b0$var$styles.shortcutSegment
            ])
        }, segment);
    }));
};


var $cfc3c6dde6ad6471$var$primitiveStyles = null;
/**
 * The lower level component for rendering a tooltip.
 */ var $cfc3c6dde6ad6471$var$TooltipPrimitive = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function TooltipPrimitive(_ref, ref) {
    var style = _ref.style, className = _ref.className, children = _ref.children, placement = _ref.placement, testId = _ref.testId, onMouseOut = _ref.onMouseOut, onMouseOver = _ref.onMouseOver, id = _ref.id, shortcut = _ref.shortcut, _ref$role = _ref.role, role = _ref$role === void 0 ? 'tooltip' : _ref$role;
    return /*#__PURE__*/ $5FkrB.createElement("div", {
        ref: ref,
        style: style,
        "data-testid": testId ? "".concat(testId, "--wrapper") : undefined
    }, /*#__PURE__*/ $5FkrB.createElement("div", {
        role: role,
        className: (0, $gKzKW.default)([
            "_80om73ad",
            className
        ]),
        onMouseOut: onMouseOut,
        onMouseOver: onMouseOver,
        "data-placement": placement,
        "data-testid": testId,
        id: id
    }, children, shortcut && /*#__PURE__*/ $5FkrB.createElement((0, $c097968232e427b0$export$5bcbc43c84236222), {
        shortcut: shortcut
    })));
});
$cfc3c6dde6ad6471$var$TooltipPrimitive.displayName = 'TooltipPrimitive';
var $cfc3c6dde6ad6471$export$2e2bcd8739ae039 = $cfc3c6dde6ad6471$var$TooltipPrimitive;


var $d124dac7cfac29f1$var$styles = {
    base: "_2rkofajl _11c8wadc _vchhusvi _p12fp3fh _bfhk1aqn _syaz15cr _152tze3t _1e02ze3t _1i4q1hna _1q511b66 _85i51b66 _y4ti12x7 _bozg12x7 _slp31hna",
    truncate: "_1reo15vq _18m915vq _p12f1pna _1bto1l2s _o5721q9c"
};
/**
 * Used as the default tooltip container component for the exported `Tooltip` component.
 * Adds some styles to the tooltip primitive.
 */ var $d124dac7cfac29f1$var$TooltipContainer = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function TooltipContainer(_ref, ref) {
    var style = _ref.style, className = _ref.className, children = _ref.children, truncate = _ref.truncate, placement = _ref.placement, testId = _ref.testId, onMouseOut = _ref.onMouseOut, onMouseOver = _ref.onMouseOver, id = _ref.id, shortcut = _ref.shortcut, role = _ref.role;
    return /*#__PURE__*/ $5FkrB.createElement((0, $cfc3c6dde6ad6471$export$2e2bcd8739ae039), {
        ref: ref,
        style: style,
        className: (0, $gKzKW.default)([
            $d124dac7cfac29f1$var$styles.base,
            truncate && $d124dac7cfac29f1$var$styles.truncate,
            className
        ]),
        placement: placement,
        testId: testId,
        id: id,
        onMouseOut: onMouseOut,
        onMouseOver: onMouseOver,
        shortcut: shortcut,
        role: role
    }, children);
});
$d124dac7cfac29f1$var$TooltipContainer.displayName = 'TooltipContainer';
var $d124dac7cfac29f1$export$2e2bcd8739ae039 = $d124dac7cfac29f1$var$TooltipContainer;


function $e7f9abe788af764f$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $e7f9abe788af764f$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $e7f9abe788af764f$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $jgyhF.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $e7f9abe788af764f$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $e7f9abe788af764f$var$tooltipZIndex = (0, $c0a194344ea2dc83$export$7be255094ccdc533).tooltip();
var $e7f9abe788af764f$var$analyticsAttributes = {
    componentName: 'tooltip',
    packageName: "@atlaskit/tooltip",
    packageVersion: "24.0.1"
};
// Inverts motion direction
var $e7f9abe788af764f$var$invertedDirection = {
    top: 'bottom',
    bottom: 'top',
    left: 'right',
    right: 'left'
};
/**
 * Converts a Popper placement to it's general direction.
 *
 * @param placement - Popper Placement value, e.g. 'top-start'
 * @returns Popper Direction, e.g. 'top'
 */ var $e7f9abe788af764f$var$getDirectionFromPlacement = function getDirectionFromPlacement(placement) {
    return placement.split('-')[0];
};
/**
 * __Tooltip__
 *
 * A tooltip is a floating, non-actionable label used to explain a user interface element or feature.
 */ function $e7f9abe788af764f$var$Tooltip(_ref) {
    var children = _ref.children, _ref$position = _ref.position, position = _ref$position === void 0 ? 'bottom' : _ref$position, _ref$mousePosition = _ref.mousePosition, mousePosition = _ref$mousePosition === void 0 ? 'bottom' : _ref$mousePosition, content = _ref.content, _ref$truncate = _ref.truncate, truncate = _ref$truncate === void 0 ? false : _ref$truncate, _ref$component = _ref.component, Container = _ref$component === void 0 ? (0, $d124dac7cfac29f1$export$2e2bcd8739ae039) : _ref$component, _ref$tag = _ref.tag, TargetContainer = _ref$tag === void 0 ? 'div' : _ref$tag, testId = _ref.testId, _ref$delay = _ref.delay, delay = _ref$delay === void 0 ? 300 : _ref$delay, _ref$onShow = _ref.onShow, onShow = _ref$onShow === void 0 ? (0, $adcefb868cf2fc9d$export$2e2bcd8739ae039) : _ref$onShow, _ref$onHide = _ref.onHide, onHide = _ref$onHide === void 0 ? (0, $adcefb868cf2fc9d$export$2e2bcd8739ae039) : _ref$onHide, canAppear = _ref.canAppear, _ref$hideTooltipOnCli = _ref.hideTooltipOnClick, hideTooltipOnClick = _ref$hideTooltipOnCli === void 0 ? false : _ref$hideTooltipOnCli, _ref$hideTooltipOnMou = _ref.hideTooltipOnMouseDown, hideTooltipOnMouseDown = _ref$hideTooltipOnMou === void 0 ? false : _ref$hideTooltipOnMou, analyticsContext = _ref.analyticsContext, _ref$strategy = _ref.strategy, strategy = _ref$strategy === void 0 ? 'fixed' : _ref$strategy, _ref$ignoreTooltipPoi = _ref.ignoreTooltipPointerEvents, ignoreTooltipPointerEvents = _ref$ignoreTooltipPoi === void 0 ? false : _ref$ignoreTooltipPoi, _ref$isScreenReaderAn = _ref.isScreenReaderAnnouncementDisabled, isScreenReaderAnnouncementDisabled = _ref$isScreenReaderAn === void 0 ? false : _ref$isScreenReaderAn, shortcut = _ref.shortcut, _ref$shouldAlwaysFade = _ref.shouldAlwaysFadeIn, shouldAlwaysFadeIn = _ref$shouldAlwaysFade === void 0 ? false : _ref$shouldAlwaysFade, _ref$shouldRenderToPa = _ref.shouldRenderToParent, shouldRenderToParent = _ref$shouldRenderToPa === void 0 ? false : _ref$shouldRenderToPa;
    // Not using a gate for this check. When the gate is disabled `mouse-y` and `mouse-x` are treated as `mouse`.
    var isMousePosition = position === 'mouse' || position === 'mouse-y' || position === 'mouse-x';
    var tooltipPosition = isMousePosition ? mousePosition : position;
    var onShowHandler = (0, $58be19d1545a98de$export$1a04351537078b55)($e7f9abe788af764f$var$_objectSpread({
        fn: onShow,
        action: 'displayed',
        analyticsData: analyticsContext
    }, $e7f9abe788af764f$var$analyticsAttributes));
    var onHideHandler = (0, $58be19d1545a98de$export$1a04351537078b55)($e7f9abe788af764f$var$_objectSpread({
        fn: onHide,
        action: 'hidden',
        analyticsData: analyticsContext
    }, $e7f9abe788af764f$var$analyticsAttributes));
    var apiRef = (0, $5FkrB.useRef)(null);
    var _useState = (0, $5FkrB.useState)('hide'), _useState2 = (0, $amAaq.default)(_useState, 2), state = _useState2[0], setState = _useState2[1];
    var targetRef = (0, $5FkrB.useRef)(null);
    var containerRef = (0, $5FkrB.useRef)(null);
    // This function is deliberately _not_ memoized as it needs to re-run every render
    // to pick up any child ref changes. If you use render props you don't have this issue.
    var setImplicitRefFromChildren = function setImplicitRefFromChildren(node) {
        containerRef.current = node;
        targetRef.current = node ? node.firstElementChild : null;
    };
    // This is memoized and passed into the render props callback.
    var setDirectRef = (0, $5FkrB.useCallback)(function(node) {
        targetRef.current = node;
    }, []);
    // Putting a few things into refs so that we don't have to break memoization
    var stableState = (0, $2da2c910992d9a40$export$2e2bcd8739ae039)(state);
    // These props are placed in separate refs instead of a single object to reduce memory usage.
    // Placing them in the same object previously caused an increase in the number of JavaScript event listeners
    // before garbage collection.
    var onShowHandlerStable = (0, $2da2c910992d9a40$export$2e2bcd8739ae039)(onShowHandler);
    var onHideHandlerStable = (0, $2da2c910992d9a40$export$2e2bcd8739ae039)(onHideHandler);
    var delayStable = (0, $2da2c910992d9a40$export$2e2bcd8739ae039)(delay);
    var canAppearStable = (0, $2da2c910992d9a40$export$2e2bcd8739ae039)(canAppear);
    var hasCalledShowHandler = (0, $5FkrB.useRef)(false);
    var shouldAlwaysFadeInStable = (0, $2da2c910992d9a40$export$2e2bcd8739ae039)(shouldAlwaysFadeIn);
    var start = (0, $5FkrB.useCallback)(function(api) {
        apiRef.current = api;
        hasCalledShowHandler.current = false;
    }, []);
    var done = (0, $5FkrB.useCallback)(function() {
        if (!apiRef.current) return;
        // Only call onHideHandler if we have called onShowHandler
        if (hasCalledShowHandler.current) onHideHandlerStable.current();
        apiRef.current = null;
        hasCalledShowHandler.current = false;
        // just in case
        setState('hide');
    }, [
        onHideHandlerStable
    ]);
    var abort = (0, $5FkrB.useCallback)(function() {
        if (!apiRef.current) return;
        apiRef.current.abort();
        // Only call onHideHandler if we have called onShowHandler
        if (hasCalledShowHandler.current) onHideHandlerStable.current();
        apiRef.current = null;
    }, [
        onHideHandlerStable
    ]);
    (0, $5FkrB.useEffect)(function mount() {
        return function unmount() {
            if (apiRef.current) abort();
        };
    }, [
        abort
    ]);
    var isDraggingRef = (0, $5FkrB.useRef)(false);
    (0, $5FkrB.useEffect)(function() {
        return (0, $74888a052401d677$export$6503ec6e8aabbaf)({
            onRegister: function onRegister(_ref2) {
                var isDragging = _ref2.isDragging;
                isDraggingRef.current = isDragging;
            },
            onDragStart: function onDragStart() {
                var _apiRef$current;
                /**
         * Hiding any visible tooltips when a drag starts because otherwise it
         * looks janky (disappears and reappears), and is not required.
         */ (_apiRef$current = apiRef.current) === null || _apiRef$current === void 0 || _apiRef$current.requestHide({
                    isImmediate: true
                });
                isDraggingRef.current = true;
            },
            onDragEnd: function onDragEnd() {
                isDraggingRef.current = false;
            }
        });
    }, []);
    var tryShowTooltip = (0, $5FkrB.useCallback)(function(source) {
        var _canAppearStable$curr;
        /**
     * Prevent tooltips from being shown during a drag. This can occur with
     * the native drag and drop API, where some pointer events can fire
     * when they should not and lead to jank with tooltips.
     */ if (isDraggingRef.current) return;
        // Another tooltip is has been active but we still have the old `api`
        // around. We need to finish up the last usage.
        // Note: just being safe - this should not happen
        if (apiRef.current && !apiRef.current.isActive()) abort();
        // This tooltip is already active, we can exit
        if (apiRef.current && apiRef.current.isActive()) {
            apiRef.current.keep();
            return;
        }
        /**
     * Check if tooltip is allowed to show.
     *
     * Once a tooltip has started, or has scheduled to start
     * we won't be checking `canAppear` again.
     *
     * - We don't want tooltips to disappear once they are shown
     * - For consistency, we start after a single positive `canAppear`.
     *   Otherwise the amount of times we ask consumers would depend on
     *   how many times we get a "mousemove", which _could_ lead to situations
     *   where moving the mouse could result in a different outcome to if
     *   the mouse was not moved.
     */ if (canAppearStable.current && !((_canAppearStable$curr = canAppearStable.current) !== null && _canAppearStable$curr !== void 0 && _canAppearStable$curr.call(canAppearStable))) return;
        var entry = {
            source: source,
            delay: delayStable.current,
            show: function show(_ref3) {
                var isImmediate = _ref3.isImmediate;
                // Call the onShow handler if it hasn't been called yet
                if (!hasCalledShowHandler.current) {
                    hasCalledShowHandler.current = true;
                    onShowHandlerStable.current();
                }
                setState(!isImmediate ? 'fade-in' : 'show-immediate');
            },
            hide: function hide(_ref4) {
                var isImmediate = _ref4.isImmediate;
                if (isImmediate) setState('hide');
                else if ((0, $2fcbb5e4cf9206d1$export$b40ec24ac8275656)('platform-dst-top-layer-tooltip')) // Top-layer path: set state to 'top-layer-exit'. The component
                // stays mounted and Popover's isOpen prop transitions to
                // false, triggering the CSS exit animation internally.
                // finishHideAnimation is called after a brief delay matching
                // the CSS exit animation duration.
                setState('top-layer-exit');
                else setState('before-fade-out');
            },
            done: done,
            shouldAlwaysFadeIn: shouldAlwaysFadeInStable.current
        };
        var api = (0, $c685a299994bed13$export$57bf213be019eeb0)(entry);
        start(api);
    }, [
        canAppearStable,
        delayStable,
        done,
        start,
        abort,
        onShowHandlerStable,
        shouldAlwaysFadeInStable
    ]);
    var hideTooltipOnEsc = (0, $5FkrB.useCallback)(function() {
        var _apiRef$current2;
        (_apiRef$current2 = apiRef.current) === null || _apiRef$current2 === void 0 || _apiRef$current2.requestHide({
            isImmediate: true
        });
    }, [
        apiRef
    ]);
    // When using top-layer, popover="auto" handles Escape natively
    (0, $cc68d04423a653c6$export$2e2bcd8739ae039)({
        onClose: hideTooltipOnEsc,
        isDisabled: state === 'hide' || state === 'fade-out' || state === 'top-layer-exit' || (0, $2fcbb5e4cf9206d1$export$b40ec24ac8275656)('platform-dst-top-layer-tooltip')
    });
    // ── Top-layer exit animation lifecycle ──
    // When state is 'top-layer-exit', Popover's isOpen transitions to false and
    // the CSS exit animation plays. The Popover's built-in `transitionend`
    // detection (with timeout fallback) calls `onExitFinish` when the exit
    // animation completes, which triggers the tooltip-manager lifecycle
    // (finishHideAnimation → done → onHide, setState('hide'), cleanup).
    var handleExitFinish = (0, $5FkrB.useCallback)(function() {
        var _apiRef$current3;
        (_apiRef$current3 = apiRef.current) === null || _apiRef$current3 === void 0 || _apiRef$current3.finishHideAnimation();
    }, []);
    (0, $5FkrB.useEffect)(function() {
        if (state === 'hide') return 0, $adcefb868cf2fc9d$export$2e2bcd8739ae039;
        if (state === 'before-fade-out') setState('fade-out');
        var unbind = (0, $5b617c1f48263075$exports.bind)(window, {
            type: 'scroll',
            listener: function listener() {
                if (apiRef.current) apiRef.current.requestHide({
                    isImmediate: true
                });
            },
            options: {
                capture: true,
                passive: true,
                once: true
            }
        });
        return unbind;
    }, [
        state
    ]);
    var onMouseDown = (0, $5FkrB.useCallback)(function() {
        if (hideTooltipOnMouseDown && apiRef.current) apiRef.current.requestHide({
            isImmediate: true
        });
    }, [
        hideTooltipOnMouseDown
    ]);
    var onClick = (0, $5FkrB.useCallback)(function() {
        if (hideTooltipOnClick && apiRef.current) apiRef.current.requestHide({
            isImmediate: true
        });
    }, [
        hideTooltipOnClick
    ]);
    // Ideally we would be using onMouseEnter here, but
    // because we are binding the event to the target parent
    // we need to listen for the mouseover of all sub elements
    // This means when moving along a tooltip we are quickly toggling
    // between api.requestHide and api.keep. This it not ideal
    var onMouseOver = (0, $5FkrB.useCallback)(function(event) {
        // Ignoring events from the container ref
        if (containerRef.current && event.target === containerRef.current) return;
        // Using prevent default as a signal that parent tooltips
        if (event.defaultPrevented) return;
        event.preventDefault();
        var source = isMousePosition ? {
            type: 'mouse',
            clientX: event.clientX,
            clientY: event.clientY
        } : {
            type: 'keyboard'
        };
        tryShowTooltip(source);
    }, [
        isMousePosition,
        tryShowTooltip
    ]);
    // Ideally we would be using onMouseEnter here, but
    // because we are binding the event to the target parent
    // we need to listen for the mouseout of all sub elements
    // This means when moving along a tooltip we are quickly toggling
    // between api.requestHide and api.keep. This it not ideal
    var onMouseOut = (0, $5FkrB.useCallback)(function(event) {
        // Ignoring events from the container ref
        if (containerRef.current && event.target === containerRef.current) return;
        // Using prevent default as a signal that parent tooltips
        if (event.defaultPrevented) return;
        event.preventDefault();
        if (apiRef.current) apiRef.current.requestHide({
            isImmediate: false
        });
    }, []);
    var onMouseMove = isMousePosition ? function(event) {
        var _apiRef$current4;
        if ((_apiRef$current4 = apiRef.current) !== null && _apiRef$current4 !== void 0 && _apiRef$current4.isActive()) apiRef.current.mousePos = {
            clientX: event.clientX,
            clientY: event.clientY
        };
    } : undefined;
    var onMouseOverTooltip = (0, $5FkrB.useCallback)(function() {
        if (apiRef.current && apiRef.current.isActive()) {
            apiRef.current.keep();
            return;
        }
    }, []);
    var onFocus = (0, $5FkrB.useCallback)(function(e) {
        // Check if focus-visible
        // Prevents tooltips from showing when focus is not visible,
        // i.e., when focus is moved onto tooltip trigger inside a popup on open
        try {
            if (!e.target.matches(':focus-visible')) return;
        } catch (_unused) {
        // Ignore errors from environments that don't support :focus-visible
        }
        // TODO: this does not play well with `hideTooltipOnMouseDown`
        // as "focus" will occur after the "mousedown".
        tryShowTooltip({
            type: 'keyboard'
        });
    }, [
        tryShowTooltip
    ]);
    var onBlur = (0, $5FkrB.useCallback)(function() {
        if (apiRef.current) apiRef.current.requestHide({
            isImmediate: false
        });
    }, []);
    var onAnimationFinished = (0, $5FkrB.useCallback)(function(transition) {
        // Using lastState here because motion is not picking up the latest value
        if (transition === 'exiting' && stableState.current === 'fade-out' && apiRef.current) apiRef.current.finishHideAnimation();
    }, [
        stableState
    ]);
    // Doing a cast because typescript is struggling to narrow the type
    var CastTargetContainer = TargetContainer;
    var shouldRenderTooltipPopup = state !== 'hide' && Boolean(content);
    var shouldRenderHiddenContent = !isScreenReaderAnnouncementDisabled && shouldRenderTooltipPopup;
    var shouldRenderTooltipChildren = state !== 'hide' && state !== 'fade-out' && state !== 'top-layer-exit';
    var handleOpenLayerObserverCloseSignal = (0, $5FkrB.useCallback)(function() {
        var _apiRef$current5;
        (_apiRef$current5 = apiRef.current) === null || _apiRef$current5 === void 0 || _apiRef$current5.requestHide({
            isImmediate: true
        });
    }, []);
    // Registered unconditionally so the hook order never depends on the feature
    // flag value. On the top-layer path the Popover primitive (used by
    // TopLayerTooltipPopup) registers with the observer directly, so we pass
    // isOpen: false to avoid double-counting (the hook is a no-op while the
    // layer is not open).
    (0, $0d147846786c3387$export$469bb693f11edc7f)({
        // Layer is only visually open if both the tooltip popup (container) and children are rendered.
        isOpen: (0, $2fcbb5e4cf9206d1$export$b40ec24ac8275656)('platform-dst-top-layer-tooltip') ? false : shouldRenderTooltipPopup && shouldRenderTooltipChildren,
        /**
     * We don't strictly need to provide an onClose callback at this time, as there is
     * already code that handles hiding the tooltip when a drag is started (and the only
     * usage right now is closing all layers when the user resizes the side nav).
     *
     * However, for future-proofing and semantic reasons, it makes sense to close the tooltip
     * whenever the open layer observer requests a close.
     */ onClose: handleOpenLayerObserverCloseSignal
    });
    var getReferenceElement = function getReferenceElement() {
        var _apiRef$current6;
        if (isMousePosition && (_apiRef$current6 = apiRef.current) !== null && _apiRef$current6 !== void 0 && _apiRef$current6.mousePos && targetRef.current) return (0, $0a145a13d52c0daa$export$2e68479e0a5d8746)(apiRef.current.mousePos, {
            targetElement: targetRef.current,
            tooltipPosition: position
        });
        return targetRef.current || undefined;
    };
    var tooltipIdForHiddenContent = (0, $b5cf4e0d57245932$export$2e2bcd8739ae039)('tooltip', shouldRenderHiddenContent);
    var tooltipTriggerProps = {
        onMouseOver: onMouseOver,
        onMouseOut: onMouseOut,
        onMouseMove: onMouseMove,
        onMouseDown: onMouseDown,
        onClick: onClick,
        onFocus: onFocus,
        onBlur: onBlur
    };
    // This useEffect is purely for managing the aria attribute when using the
    // wrapped children approach.
    var isChildrenAFunction = typeof children === 'function';
    (0, $5FkrB.useEffect)(function() {
        if (isChildrenAFunction) return;
        // If `children` is _not_ a function, we are stepping outside of the public
        // API to add a `aria-describedby` attribute.
        var target = targetRef.current;
        if (!target || !tooltipIdForHiddenContent) return;
        target.setAttribute('aria-describedby', tooltipIdForHiddenContent);
        return function() {
            return target.removeAttribute('aria-describedby');
        };
    }, [
        isChildrenAFunction,
        tooltipIdForHiddenContent
    ]);
    var hiddenContent = shouldRenderHiddenContent ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("span", {
        "data-testid": testId ? "".concat(testId, "-hidden") : undefined,
        hidden: true,
        id: tooltipIdForHiddenContent
    }, typeof content === 'function' ? content({}) : content) : null;
    var PopperWrapper = shouldRenderToParent ? (0, $5FkrB.Fragment) : $e7f9abe788af764f$var$TooltipPortal;
    var trigger = typeof children === 'function' ? /*#__PURE__*/ // once we deprecate the wrapped approach, we can put the aria
    // attribute back into the tooltipTriggerProps and make it required
    // instead of optional in `types`
    (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $5FkrB.Fragment), null, children($e7f9abe788af764f$var$_objectSpread($e7f9abe788af764f$var$_objectSpread($e7f9abe788af764f$var$_objectSpread({}, tooltipTriggerProps), testId ? {
        testId: "".concat(testId, "--container")
    } : {}), {}, {
        'aria-describedby': tooltipIdForHiddenContent,
        ref: setDirectRef
    })), hiddenContent) : /*#__PURE__*/ // @ts-ignore
    (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(CastTargetContainer, (0, $d0778aa44ff9fe37$export$2e2bcd8739ae039)({}, tooltipTriggerProps, testId ? {
        'data-testid': "".concat(testId, "--container")
    } : undefined, {
        ref: setImplicitRefFromChildren,
        role: "presentation"
    }), children, hiddenContent);
    if ((0, $2fcbb5e4cf9206d1$export$b40ec24ac8275656)('platform-dst-top-layer-tooltip')) {
        var _apiRef$current$mouse, _apiRef$current7;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $5FkrB.Fragment), null, trigger, shouldRenderTooltipPopup ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement($e7f9abe788af764f$var$TopLayerTooltipPopup, {
            targetRef: targetRef,
            tooltipPosition: tooltipPosition,
            mousePos: (_apiRef$current$mouse = (_apiRef$current7 = apiRef.current) === null || _apiRef$current7 === void 0 ? void 0 : _apiRef$current7.mousePos) !== null && _apiRef$current$mouse !== void 0 ? _apiRef$current$mouse : undefined,
            position: position,
            onMouseOut: onMouseOut,
            onMouseOverTooltip: onMouseOverTooltip,
            ignoreTooltipPointerEvents: ignoreTooltipPointerEvents,
            truncate: truncate,
            testId: testId,
            shortcut: shortcut,
            content: content,
            Container: Container,
            onClose: function onClose() {
                var _apiRef$current8;
                return (_apiRef$current8 = apiRef.current) === null || _apiRef$current8 === void 0 ? void 0 : _apiRef$current8.requestHide({
                    isImmediate: true
                });
            },
            onExitFinish: handleExitFinish,
            isOpen: state !== 'hide' && state !== 'top-layer-exit'
        }) : null);
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $5FkrB.Fragment), null, trigger, shouldRenderTooltipPopup ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(PopperWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $87203434815760ba$export$badac9ada3a0bdf9), {
        placement: tooltipPosition,
        referenceElement: getReferenceElement(),
        strategy: strategy
    }, function(_ref5) {
        var ref = _ref5.ref, style = _ref5.style, update = _ref5.update, placement = _ref5.placement;
        var direction = isMousePosition ? undefined : $e7f9abe788af764f$var$invertedDirection[$e7f9abe788af764f$var$getDirectionFromPlacement(placement)];
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $ac89e4e24d91bc0a$export$2e2bcd8739ae039), {
            appear: true
        }, shouldRenderTooltipChildren && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $b93dcd52e5399dad$export$2e2bcd8739ae039), {
            distance: "constant",
            entranceDirection: direction,
            exitDirection: direction,
            onFinish: onAnimationFinished,
            duration: state !== 'show-immediate' ? 'medium' : 'none'
        }, function(_ref6) {
            var className = _ref6.className;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(Container, {
                ref: ref,
                className: "Tooltip ".concat(className),
                style: $e7f9abe788af764f$var$_objectSpread($e7f9abe788af764f$var$_objectSpread({}, style), ignoreTooltipPointerEvents && {
                    pointerEvents: 'none'
                }),
                truncate: truncate,
                placement: tooltipPosition,
                testId: getReferenceElement() ? testId : testId && "".concat(testId, "--unresolved"),
                onMouseOut: onMouseOut,
                onMouseOver: onMouseOverTooltip,
                shortcut: shortcut
            }, typeof content === 'function' ? content({
                update: update
            }) : content);
        }));
    })) : null);
}
var $e7f9abe788af764f$export$2e2bcd8739ae039 = $e7f9abe788af764f$var$Tooltip;
var $e7f9abe788af764f$var$TooltipPortal = function TooltipPortal(_ref7) {
    var children = _ref7.children;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $a620f5b671fe1301$export$2e2bcd8739ae039), {
        zIndex: $e7f9abe788af764f$var$tooltipZIndex
    }, children);
};
var $e7f9abe788af764f$var$tooltipMouseAnimationStyles = {
    enter: "_j7hq1bym",
    exit: "_j7hq1a5s"
};
/**
 * Top-layer tooltip popup component.
 *
 * Composes `Popover` (top-layer visibility + animation) with one of two
 * positioning hooks:
 *
 *   - `useAnchorPositionAtPoint` — for cursor-tracking positions
 *     (`mouse`, `mouse-x`, `mouse-y`) when a cursor position is
 *     available (i.e. the popup was activated by a pointer). Positions
 *     the popover relative to a hidden synthetic anchor that follows
 *     the cursor according to the `position` / `mousePosition`
 *     semantics. The synthetic anchor element is rendered as a sibling
 *     of the popover.
 *   - `useAnchorPosition` directly — for non-cursor positions, AND
 *     for cursor positions activated via keyboard focus (where there
 *     is no cursor to track). Anchoring directly to the trigger keeps
 *     keyboard-activated tooltips correctly placed next to the target
 *     instead of rendering in the top-left of the viewport.
 *
 * Exactly one positioning strategy is active at a time: `useAnchorPosition`
 * is wired to the trigger only when the mouse strategy is inactive, and
 * `useAnchorPositionAtPoint` is told `isActive: false` when the direct
 * anchor strategy is active. The other hook is still called (Rules of
 * Hooks) but does no work.
 *
 * Exit animation is handled by `Popover`'s `isOpen` prop. When `isOpen`
 * transitions to `false`, the primitive calls `hidePopover()` internally and
 * the CSS exit animation plays via `allow-discrete`. No glue code needed.
 */ function $e7f9abe788af764f$var$TopLayerTooltipPopup(_ref8) {
    var targetRef = _ref8.targetRef, tooltipPosition = _ref8.tooltipPosition, mousePos = _ref8.mousePos, position = _ref8.position, onMouseOut = _ref8.onMouseOut, onMouseOverTooltip = _ref8.onMouseOverTooltip, ignoreTooltipPointerEvents = _ref8.ignoreTooltipPointerEvents, truncate = _ref8.truncate, testId = _ref8.testId, shortcut = _ref8.shortcut, content = _ref8.content, Container = _ref8.Container, onClose = _ref8.onClose, onExitFinish = _ref8.onExitFinish, isOpen = _ref8.isOpen;
    var popoverRef = (0, $5FkrB.useRef)(null);
    // Translate the legacy Popper-style placement string ("right",
    // "bottom-start", etc.) once and pass the same object to both hooks.
    var placement = (0, $36dfe2fd333e00e5$export$69e99ed50b2534c9)({
        legacy: tooltipPosition
    });
    var isMousePosition = position === 'mouse' || position === 'mouse-x' || position === 'mouse-y';
    var isMouseStrategyActive = isMousePosition && Boolean(mousePos);
    // Direct anchor strategy: anchors to the trigger element.
    // Disabled when the mouse strategy is active — both hooks writing
    // to the same popover would fight for positioning ownership.
    (0, $62cae9a51e21bb99$export$56b02a1e583f953c)({
        anchorRef: targetRef,
        popoverRef: popoverRef,
        placement: placement,
        isEnabled: !isMouseStrategyActive,
        isOpen: isOpen
    });
    // Mouse anchor strategy: the hook calls `getPoint()` exactly once
    // per activation and latches the resulting coordinate. The latch is
    // per-show because `TopLayerTooltipPopup` mounts fresh on every
    // show.
    //
    // `getPoint()` returns `null` for keyboard-activated shows (where
    // `mousePos` is undefined) or before the trigger has mounted —
    // leaving the direct strategy above to own positioning.
    //
    // SSR note: `getBoundingClientRect()` is only called here because
    // `TopLayerTooltipPopup` is gated behind client-only state
    // transitions.
    (0, $8e47134217b0f5cd$export$6f230729189a5b8a)({
        popoverRef: popoverRef,
        placement: placement,
        isEnabled: isMouseStrategyActive,
        isOpen: isOpen,
        getPoint: function getPoint() {
            if (!mousePos || !targetRef.current || !isMousePosition) return null;
            return (0, $c62b55b85bb21165$export$d26fd3d066ede49)({
                cursor: mousePos,
                triggerRect: targetRef.current.getBoundingClientRect(),
                tooltipPosition: position,
                placement: placement
            });
        }
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $516e5dff5af04da6$export$5b6b19405a83ff9d), {
        ref: popoverRef,
        role: "tooltip",
        mode: "hint",
        isOpen: isOpen,
        onClose: onClose,
        onExitFinish: onExitFinish,
        testId: testId ? "".concat(testId, "--popover") : undefined,
        shouldAnimate: true,
        enteringAnimationXcss: isMouseStrategyActive && $e7f9abe788af764f$var$tooltipMouseAnimationStyles.enter,
        exitingAnimationXcss: isMouseStrategyActive && $e7f9abe788af764f$var$tooltipMouseAnimationStyles.exit,
        placement: placement
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(Container, {
        className: "Tooltip",
        style: ignoreTooltipPointerEvents ? {
            pointerEvents: 'none'
        } : undefined,
        truncate: truncate,
        placement: tooltipPosition,
        testId: testId,
        onMouseOut: onMouseOut,
        onMouseOver: onMouseOverTooltip,
        shortcut: shortcut,
        role: "presentation"
    }, typeof content === 'function' ? content({
        update: (0, $adcefb868cf2fc9d$export$2e2bcd8739ae039)
    }) : content));
}


/* visually-hidden.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $5FkrB = parcelRequire("5FkrB");
/**
 * This length includes the underscore,
 * e.g. `"_1s4A"` would be a valid atomic group hash.
 */ const $ddc8d5a68561b148$var$ATOMIC_GROUP_LENGTH = 5;
function $ddc8d5a68561b148$export$2e2bcd8739ae039(classNames) {
    // Shortcut: nothing to do
    if (!classNames.length) return;
    // Shortcut: don't need to do anything if we only have a single classname
    if (classNames.length === 1 && classNames[0] && // checking to see if `classNames[0]` is a string that contains other classnames
    !classNames[0].includes(' ')) return classNames[0];
    // Using an object rather than a `Map` as it performed better in our benchmarks.
    // Would be happy to move to `Map` if it proved to be better under real conditions.
    const map = {};
    // Note: using loops to minimize iterations over the collection
    for (const value of classNames){
        // Exclude all falsy values, which leaves us with populated strings
        if (!value) continue;
        // a `value` can contain multiple classnames
        const list = value.split(' ');
        for (const className of list){
            /**
             * For atomic style classnames: the `key` is the `group`
             *
             * - Later atomic classnames with the same `group` will override earlier ones
             *   (which is what we want).
             * - Assumes atomic classnames are the only things that start with `_`
             * - Could use a regex to ensure that atomic classnames are structured how we expect,
             *   but did not add that for now as it did slow things down a bit.
             *
             * For other classnames: the `key` is the whole classname
             * - Okay to remove duplicates as doing so does not impact specificity
             *
             * */ const key = className.startsWith('_') ? className.slice(0, $ddc8d5a68561b148$var$ATOMIC_GROUP_LENGTH) : className;
            map[key] = className;
        }
    }
    /**
     * We are converting the `map` into a string.
     *
     * The simple way to do this would be `Object.values(map).join(' ')`.
     * However, the approach below performs 10%-20% better in benchmarks.
     *
     * For `ax()` it feels right to squeeze as much runtime performance out as we can.
     */ let result = '';
    for(const key in map)result += map[key] + ' ';
    // If we have an empty string, then our `map` was empty.
    if (!result) return;
    // remove last " " from the result (we added " " at the end of every value)
    return result.trimEnd();
}


var $3fb4db4d25367976$var$visuallyHiddenStyles = null;
/**
 * __Visually hidden__
 *
 * A composable element to apply a visually hidden effect to children.
 * Useful for accessibility compliance.
 *
 * @example
 * ```jsx
 * import VisuallyHidden from '@atlaskit/visually-hidden';
 *
 * export default () => (
 *   <div style={{ border: '1px solid black' }}>
 *      There is text hidden between the brackets [
 *      <VisuallyHidden>Can't see me!</VisuallyHidden>]
 *   </div>
 * );
 * ```
 */ var $3fb4db4d25367976$var$VisuallyHidden = function VisuallyHidden(_ref) {
    var children = _ref.children, testId = _ref.testId, role = _ref.role, id = _ref.id;
    return /*#__PURE__*/ $5FkrB.createElement("span", {
        id: id,
        "data-testid": testId,
        role: role,
        className: (0, $ddc8d5a68561b148$export$2e2bcd8739ae039)([
            "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19itidpf _1reo15vq _18m915vq _1bsbt94y _4t3it94y _kqswstnw _ogto7mnp _uiztglyw _o5721q9c"
        ])
    }, children);
};
$3fb4db4d25367976$var$VisuallyHidden.displayName = 'VisuallyHidden';
var $3fb4db4d25367976$export$2e2bcd8739ae039 = $3fb4db4d25367976$var$VisuallyHidden;


/* button-base.tsx generated by @compiled/babel-plugin v2.0.0 */ 

var $74jTZ = parcelRequire("74jTZ");

var $gKzKW = parcelRequire("gKzKW");

var $5FkrB = parcelRequire("5FkrB");
/* index.tsx generated by @compiled/babel-plugin v0.39.1 */ parcelRequire("5FkrB");

const $f0b2925e260105fe$export$6c9a87045746941d = ()=>{
    return new Error(`
 \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2557}   \u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2557}     \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}
\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}
\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}   \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}  \u{2588}\u{2588}\u{2551}  \u{2588}\u{2588}\u{2551}
\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}   \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}\u{255A}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{255D} \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{255D}  \u{2588}\u{2588}\u{2551}  \u{2588}\u{2588}\u{2551}
\u{255A}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{255A}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551} \u{255A}\u{2550}\u{255D} \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}
 \u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D} \u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D} \u{255A}\u{2550}\u{255D}     \u{255A}\u{2550}\u{255D}\u{255A}\u{2550}\u{255D}     \u{255A}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}

  @compiled/react

  Code was executed when it shouldn't have. This could have happened because:

  1. You haven't configured a transformer yet. Visit https://compiledcssinjs.com/docs/installation and follow the instructions.
  2. You have duplicate versions of React and hooks are blowing up. You need to de-duplicate your dependencies.

  Good luck!
`);
};
const $f0b2925e260105fe$export$c4df1cb0c2b4d77c = ()=>{
    return new Error(`
 \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2557}   \u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2557}     \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}
\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}
\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}   \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}  \u{2588}\u{2588}\u{2551}  \u{2588}\u{2588}\u{2551}
\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}   \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}\u{255A}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{255D} \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{255D}  \u{2588}\u{2588}\u{2551}  \u{2588}\u{2588}\u{2551}
\u{255A}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{255A}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551} \u{255A}\u{2550}\u{255D} \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}
 \u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D} \u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D} \u{255A}\u{2550}\u{255D}     \u{255A}\u{2550}\u{255D}\u{255A}\u{2550}\u{255D}     \u{255A}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}

  @compiled/react

  Code was executed when it shouldn't have. To resolve make sure to:

  1. Set up Compiled.
  2. Configure importSources in your Compiled config to point to the module that exports the output of createStrictAPI().

  For more information visit https://compiledcssinjs.com/docs/installation and follow the instructions.
`);
};


/**
 * This length includes the underscore,
 * e.g. `"_1s4A"` would be a valid atomic group hash.
 */ const $1a0f1d4d6c0beacd$var$ATOMIC_GROUP_LENGTH = 5;
function $1a0f1d4d6c0beacd$export$2e2bcd8739ae039(classNames) {
    // Shortcut: nothing to do
    if (!classNames.length) return;
    // Shortcut: don't need to do anything if we only have a single classname
    if (classNames.length === 1 && classNames[0] && // checking to see if `classNames[0]` is a string that contains other classnames
    !classNames[0].includes(' ')) return classNames[0];
    // Using an object rather than a `Map` as it performed better in our benchmarks.
    // Would be happy to move to `Map` if it proved to be better under real conditions.
    const map = {};
    // Note: using loops to minimize iterations over the collection
    for (const value of classNames){
        // Exclude all falsy values, which leaves us with populated strings
        if (!value) continue;
        // a `value` can contain multiple classnames
        const list = value.split(' ');
        for (const className of list){
            /**
             * For atomic style classnames: the `key` is the `group`
             *
             * - Later atomic classnames with the same `group` will override earlier ones
             *   (which is what we want).
             * - Assumes atomic classnames are the only things that start with `_`
             * - Could use a regex to ensure that atomic classnames are structured how we expect,
             *   but did not add that for now as it did slow things down a bit.
             *
             * For other classnames: the `key` is the whole classname
             * - Okay to remove duplicates as doing so does not impact specificity
             *
             * */ const key = className.startsWith('_') ? className.slice(0, $1a0f1d4d6c0beacd$var$ATOMIC_GROUP_LENGTH) : className;
            map[key] = className;
        }
    }
    /**
     * We are converting the `map` into a string.
     *
     * The simple way to do this would be `Object.values(map).join(' ')`.
     * However, the approach below performs 10%-20% better in benchmarks.
     *
     * For `ax()` it feels right to squeeze as much runtime performance out as we can.
     */ let result = '';
    for(const key in map)result += map[key] + ' ';
    // If we have an empty string, then our `map` was empty.
    if (!result) return;
    // remove last " " from the result (we added " " at the end of every value)
    return result.trimEnd();
}


const $90db491af581304b$export$a274e22fb40f762e = (...styles)=>{
    // At runtime TStyles is resolved down to strings, but not at compile time.
    // We circumvent the type system here because of that.
    const actualStyles = styles;
    // The output should be a union type of passed in styles. This ensures the call
    // site of xcss prop can raise violations when disallowed styles have been passed.
    return (0, $1a0f1d4d6c0beacd$export$2e2bcd8739ae039)(actualStyles);
};


function $33d42806c8bc0ec6$export$39716b4af53f4ad() {
    return {
        css () {
            throw (0, $f0b2925e260105fe$export$c4df1cb0c2b4d77c)();
        },
        cssMap () {
            throw (0, $f0b2925e260105fe$export$c4df1cb0c2b4d77c)();
        },
        cx: $90db491af581304b$export$a274e22fb40f762e,
        XCSSProp () {
            throw (0, $f0b2925e260105fe$export$c4df1cb0c2b4d77c)();
        }
    };
}


var $b5cd78e10bc362b2$var$strictApi = (0, $33d42806c8bc0ec6$export$39716b4af53f4ad)();
var $b5cd78e10bc362b2$export$dbf350e5966cf602 = $b5cd78e10bc362b2$var$strictApi.css;
var $b5cd78e10bc362b2$export$eb1ecd84a24ee424 = $b5cd78e10bc362b2$var$strictApi.cssMap;
$b5cd78e10bc362b2$var$strictApi.cssMap;
var $b5cd78e10bc362b2$export$a274e22fb40f762e = $b5cd78e10bc362b2$var$strictApi.cx;
var $b5cd78e10bc362b2$var$XCSSProp = $b5cd78e10bc362b2$var$strictApi.XCSSProp; // This is to mitigate local TS error TS2315: Type 'StrictXCSSProp' is not generic.
 // Currently for some reason tsc is generating malformed .d.ts in local dev environment, below change fixes it
 /**
 * ## StrictXCSSProp
 *
 * Declare styles your component takes with all other styles marked as violations
 * by the TypeScript compiler. There are two primary use cases for xcss prop:
 *
 * - safe style overrides
 * - inverting style declarations
 *
 * Interverting style declarations is interesting for platform teams as
 * it means apps only pay for styles they use as they're now the ones who declare
 * the styles!
 *
 * The {@link StrictXCSSProp} type has generics two of which must be defined — use to explicitly
 * set what you want to maintain as API. Use {@link XCSSAllProperties} and {@link XCSSAllPseudos}
 * to enable all properties and pseudos.
 *
 * The third generic is used to declare what properties and pseudos should be required.
 *
 * ```tsx
 * interface MyComponentProps {
 *   // Color is accepted, all other properties / pseudos are considered violations.
 *   xcss?: StrictXCSSProp<'color', never>;
 *
 *   // Only background color and hover pseudo are accepted.
 *   xcss?: StrictXCSSProp<'backgroundColor', '&:hover'>;
 *
 *   // All properties are accepted, all pseudos are considered violations.
 *   xcss?: StrictXCSSProp<XCSSAllProperties, never>;
 *
 *   // All properties are accepted, only the hover pseudo is accepted.
 *   xcss?: StrictXCSSProp<XCSSAllProperties, '&:hover'>;
 *
 *   // The xcss prop is required as well as the color property. No pseudos are required.
 *   xcss: StrictXCSSProp<
 *     XCSSAllProperties,
 *     '&:hover',
 *     { requiredProperties: 'color', requiredPseudos: never }
 *   >;
 * }
 *
 * function MyComponent({ xcss }: MyComponentProps) {
 *   return <div css={{ color: 'var(--ds-text-danger)' }} className={xcss} />
 * }
 * ```
 *
 * The xcss prop works with static inline objects and the [cssMap](https://compiledcssinjs.com/docs/api-cssmap) API.
 *
 * ```jsx
 * // Declared as an inline object
 * <Component xcss={{ color: 'var(--ds-text)' }} />
 *
 * // Declared with the cssMap API
 * const styles = cssMap({ text: { color: 'var(--ds-text)' } });
 * <Component xcss={styles.text} />
 * ```
 *
 * To concatenate and conditonally apply styles use the {@link cssMap} and {@link cx} functions.
 */ 






/* pressable.tsx generated by @compiled/babel-plugin v0.40.0 */ 

var $74jTZ = parcelRequire("74jTZ");

var $5FkrB = parcelRequire("5FkrB");


var $gKzKW = parcelRequire("gKzKW");
const $e758eaf3163bf949$export$a274e22fb40f762e = (...styles)=>{
    // At runtime TStyles is resolved down to strings, but not at compile time.
    // We circumvent the type system here because of that.
    const actualStyles = styles;
    // The output should be a union type of passed in styles. This ensures the call
    // site of xcss prop can raise violations when disallowed styles have been passed.
    return (0, $gKzKW.default)(actualStyles);
};



var $jgyhF = parcelRequire("jgyhF");

var $5FkrB = parcelRequire("5FkrB");


function $75b909bb27e39354$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $75b909bb27e39354$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $75b909bb27e39354$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $jgyhF.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $75b909bb27e39354$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $75b909bb27e39354$export$a4687b0234b40e28(_ref) {
    var fn = _ref.fn, action = _ref.action, componentName = _ref.componentName, actionSubject = _ref.actionSubject, packageName = _ref.packageName, packageVersion = _ref.packageVersion, analyticsData = _ref.analyticsData;
    var _useAnalyticsEvents = (0, $e8f979d3de6c70c6$export$5bf35293e545f20c)(), createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
    // We put analyticsData and fn in a ref so that we don't need to break
    // memoization.
    // Generally these could be defined by consumers inline
    // and so we do this to avoid breaking memoization of useCallback
    var dataRef = (0, $8bc92b0cd5f28aa3$export$1d27a74659855e44)(analyticsData);
    var fnRef = (0, $8bc92b0cd5f28aa3$export$1d27a74659855e44)(fn);
    var handler = (0, $5FkrB.useCallback)(function(value) {
        var analyticsEvent = createAnalyticsEvent({
            action: action,
            actionSubject: actionSubject || componentName,
            attributes: {
                componentName: componentName,
                packageName: packageName,
                packageVersion: packageVersion
            }
        });
        // To avoid wrapping this component in AnalyticsContext we manually
        // push the parent context's meta data into the context.
        // Note: this new 'context'
        var context = $75b909bb27e39354$var$_objectSpread({
            componentName: componentName,
            packageName: packageName,
            packageVersion: packageVersion
        }, dataRef.current);
        analyticsEvent.context.push(context);
        // fire an event on the atlaskit channel
        var clone = analyticsEvent.clone();
        if (clone) clone.fire('atlaskit');
        fnRef.current(value, analyticsEvent);
    }, [
        // These are strings and won't change
        action,
        componentName,
        actionSubject,
        packageName,
        packageVersion,
        // This function is memoized in the context
        createAnalyticsEvent,
        // these are a stable ref because of the useTrackedRef hook
        dataRef,
        fnRef
    ]);
    return handler;
}





/* focusable.tsx generated by @compiled/babel-plugin v0.40.0 */ 

var $74jTZ = parcelRequire("74jTZ");

var $5FkrB = parcelRequire("5FkrB");

var $gKzKW = parcelRequire("gKzKW");
var $0013faf18cfa29e2$var$_excluded = [
    "as",
    "children",
    "isInset",
    "testId",
    "style",
    "xcss"
], $0013faf18cfa29e2$var$_excluded2 = [
    "className"
];
var $0013faf18cfa29e2$var$focusRingStyles = null;
var $0013faf18cfa29e2$var$insetFocusRingStyles = null;
var $0013faf18cfa29e2$export$35a3bebf7ef2d934 = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? 'button' : _ref$as, children = _ref.children, isInset = _ref.isInset, testId = _ref.testId, style = _ref.style, xcss = _ref.xcss, htmlAttributes = (0, $74jTZ.default)(_ref, $0013faf18cfa29e2$var$_excluded);
    // This is to remove className from safeHtmlAttributes
    // @ts-ignore -- not using expect since it causes issues with help-center local consumption - className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    var _spreadClass = htmlAttributes.className, safeHtmlAttributes = (0, $74jTZ.default)(htmlAttributes, $0013faf18cfa29e2$var$_excluded2);
    return /*#__PURE__*/ $5FkrB.createElement(Component, (0, $d0778aa44ff9fe37$export$2e2bcd8739ae039)({}, safeHtmlAttributes, {
        // @ts-ignore Expression produces a union type that is too complex to represent. We may be able to narrow the type here but unsure.
        ref: ref,
        className: (0, $gKzKW.default)([
            "_ymio1r31 _ypr0glyw _zcxs1o36 _mizu194a _1ah3dkaa _ra3xnqa1 _128mdkaa _1cvmnqa1 _4davt94y",
            isInset && "_1ah31gjf _2mwq1gjf",
            xcss
        ]),
        style: style,
        "data-testid": testId
    }), children);
});


var $605ff0fe25231d2b$var$_excluded = [
    "children",
    "isDisabled",
    "type",
    "onClick",
    "interactionName",
    "componentName",
    "analyticsContext",
    "style",
    "testId",
    "xcss",
    "tabIndex"
], $605ff0fe25231d2b$var$_excluded2 = [
    "className"
];
var $605ff0fe25231d2b$var$styles = {
    root: "_19itglyw _vchhusvi _r06hglyw _80omtlke",
    disabled: "_80om13gf"
};
var $605ff0fe25231d2b$export$27c701ed9e449e99 = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function(_ref, ref) {
    var children = _ref.children, isDisabled = _ref.isDisabled, _ref$type = _ref.type, type = _ref$type === void 0 ? 'button' : _ref$type, _ref$onClick = _ref.onClick, providedOnClick = _ref$onClick === void 0 ? (0, $adcefb868cf2fc9d$export$2e2bcd8739ae039) : _ref$onClick, interactionName = _ref.interactionName, componentName = _ref.componentName, analyticsContext = _ref.analyticsContext, style = _ref.style, testId = _ref.testId, xcss = _ref.xcss, tabIndex = _ref.tabIndex, htmlAttributes = (0, $74jTZ.default)(_ref, $605ff0fe25231d2b$var$_excluded);
    var interactionContext = (0, $5FkrB.useContext)((0, $a81fd7e45a8c2ef5$export$2e2bcd8739ae039));
    var handleClick = (0, $5FkrB.useCallback)(function(e, analyticsEvent) {
        interactionContext && interactionContext.tracePress(interactionName, e.timeStamp);
        providedOnClick(e, analyticsEvent);
    }, [
        providedOnClick,
        interactionContext,
        interactionName
    ]);
    var onClick = (0, $75b909bb27e39354$export$a4687b0234b40e28)({
        fn: handleClick,
        action: 'clicked',
        componentName: componentName || 'Pressable',
        packageName: "@atlaskit/primitives",
        packageVersion: "22.1.1",
        analyticsData: analyticsContext,
        actionSubject: 'button'
    });
    // This is to remove className from safeHtmlAttributes
    // @ts-expect-error className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    var _spreadClass = htmlAttributes.className, safeHtmlAttributes = (0, $74jTZ.default)(htmlAttributes, $605ff0fe25231d2b$var$_excluded2);
    return /*#__PURE__*/ $5FkrB.createElement((0, $0013faf18cfa29e2$export$35a3bebf7ef2d934), (0, $d0778aa44ff9fe37$export$2e2bcd8739ae039)({
        as: "button",
        tabIndex: tabIndex !== null && tabIndex !== void 0 ? tabIndex : (0, $9cdac13a38ee471b$export$95df08bae54cb4df)() && !isDisabled ? 0 : undefined,
        style: style
    }, safeHtmlAttributes, {
        type: type,
        onClick: onClick,
        disabled: isDisabled,
        xcss: (0, $e758eaf3163bf949$export$a274e22fb40f762e)($605ff0fe25231d2b$var$styles.root, isDisabled && $605ff0fe25231d2b$var$styles.disabled, xcss),
        testId: testId,
        ref: ref
    }), children);
});



/* eslint-disable @repo/internal/react/require-jsdoc */ 
var $5FkrB = parcelRequire("5FkrB");
var $8d566bfb3d418dc9$export$4b86304b2c0d7e71 = /*#__PURE__*/ (0, $5FkrB.createContext)(undefined);



var $5FkrB = parcelRequire("5FkrB");

var $83e4e22b6f86ce29$export$47e2c6fdb142d947 = function useSplitButtonContext() {
    var context = (0, $5FkrB.useContext)((0, $8d566bfb3d418dc9$export$4b86304b2c0d7e71));
    if (!context) return undefined;
    if (context.appearance === 'navigation') {
        var newContext = {
            spacing: 'default',
            appearance: 'subtle',
            isDisabled: false,
            isActiveOverSelected: false,
            isNavigationSplitButton: true,
            isHighlighted: context.isHighlighted
        };
        return newContext;
    }
    var splitButtonContext = {
        spacing: context.spacing,
        appearance: context.appearance,
        isDisabled: context.isDisabled,
        isActiveOverSelected: true,
        isNavigationSplitButton: false,
        isHighlighted: false
    };
    return splitButtonContext;
};


function $3fddbbdc41d2331c$var$abort(event) {
    event.preventDefault();
    event.stopPropagation();
}
var $3fddbbdc41d2331c$var$tabKeyCode = 9;
function $3fddbbdc41d2331c$var$onKey(event) {
    // Allowing tab so that a user can move focus away
    if (event.keyCode === $3fddbbdc41d2331c$var$tabKeyCode) return;
    $3fddbbdc41d2331c$var$abort(event);
}
function $3fddbbdc41d2331c$export$2e2bcd8739ae039(shouldBlockEvents, events) {
    return shouldBlockEvents ? {
        onMouseDownCapture: $3fddbbdc41d2331c$var$abort,
        onMouseUpCapture: $3fddbbdc41d2331c$var$abort,
        onKeyDownCapture: $3fddbbdc41d2331c$var$onKey,
        onKeyUpCapture: $3fddbbdc41d2331c$var$onKey,
        onTouchStartCapture: $3fddbbdc41d2331c$var$abort,
        onTouchEndCapture: $3fddbbdc41d2331c$var$abort,
        onPointerDownCapture: $3fddbbdc41d2331c$var$abort,
        onPointerUpCapture: $3fddbbdc41d2331c$var$abort,
        onClickCapture: $3fddbbdc41d2331c$var$abort,
        // Just smashing the existing onClick for good measure
        onClick: $3fddbbdc41d2331c$var$abort
    } : events;
}



var $5FkrB = parcelRequire("5FkrB");
/* spinner.tsx generated by @compiled/babel-plugin v0.39.1 */ /**
 * This length includes the underscore,
 * e.g. `"_1s4A"` would be a valid atomic group hash.
 */ const $1935b0dcb7b89056$var$ATOMIC_GROUP_LENGTH = 5;
function $1935b0dcb7b89056$export$2e2bcd8739ae039(classNames) {
    // Shortcut: nothing to do
    if (!classNames.length) return;
    // Shortcut: don't need to do anything if we only have a single classname
    if (classNames.length === 1 && classNames[0] && // checking to see if `classNames[0]` is a string that contains other classnames
    !classNames[0].includes(' ')) return classNames[0];
    // Using an object rather than a `Map` as it performed better in our benchmarks.
    // Would be happy to move to `Map` if it proved to be better under real conditions.
    const map = {};
    // Note: using loops to minimize iterations over the collection
    for (const value of classNames){
        // Exclude all falsy values, which leaves us with populated strings
        if (!value) continue;
        // a `value` can contain multiple classnames
        const list = value.split(' ');
        for (const className of list){
            /**
             * For atomic style classnames: the `key` is the `group`
             *
             * - Later atomic classnames with the same `group` will override earlier ones
             *   (which is what we want).
             * - Assumes atomic classnames are the only things that start with `_`
             * - Could use a regex to ensure that atomic classnames are structured how we expect,
             *   but did not add that for now as it did slow things down a bit.
             *
             * For other classnames: the `key` is the whole classname
             * - Okay to remove duplicates as doing so does not impact specificity
             *
             * */ const key = className.startsWith('_') ? className.slice(0, $1935b0dcb7b89056$var$ATOMIC_GROUP_LENGTH) : className;
            map[key] = className;
        }
    }
    /**
     * We are converting the `map` into a string.
     *
     * The simple way to do this would be `Object.values(map).join(' ')`.
     * However, the approach below performs 10%-20% better in benchmarks.
     *
     * For `ax()` it feels right to squeeze as much runtime performance out as we can.
     */ let result = '';
    for(const key in map)result += map[key] + ' ';
    // If we have an empty string, then our `map` was empty.
    if (!result) return;
    // remove last " " from the result (we added " " at the end of every value)
    return result.trimEnd();
}



var $5FkrB = parcelRequire("5FkrB");

var $020d0e0280746cbe$export$4e9f1640bbe7a1a8 = {
    xsmall: 12,
    small: 16,
    medium: 24,
    large: 48,
    xlarge: 96
};


/**
 * Returns the appropriate circle stroke color.
 */ function $e1a091bdcbe2aeb8$var$getStrokeColor(appearance) {
    return appearance === 'inherit' ? "var(--ds-icon-subtle, #505258)" : "var(--ds-icon-inverse, #FFFFFF)";
}
var $e1a091bdcbe2aeb8$var$rotate = null;
/**
 * There are three parts to the load in animation:
 * 1. Accelerated spin
 * 2. Stretch the spinner line
 */ var $e1a091bdcbe2aeb8$var$loadIn = null;
var $e1a091bdcbe2aeb8$var$styles = {
    rotateStyles: "_j7hqsf8s _5sag12kz _tip812c5 _1pgl2qsq _8hrz1h6o",
    loadInStyles: "_j7hq1ky6 _5sag9cwz _1pgl1ytf _1o51q7pw",
    wrapperStyles: "_1e0c116y _s7n4nkob",
    circleStyles: "_lswuglyw _7ljx1dhp _1snbbs82 _jcxd7g3v _1tjm1onz"
};
/**
 * `useLayoutEffect` is being used in SSR safe form. On the server, this work doesn’t need to run.
 * `useEffect` is used in-place, because `useEffect` is not run on the server and it matches types
 * which makes things simpler than doing an `isServer` check or a `null` check.
 *
 * @see https://hello.atlassian.net/wiki/spaces/DST/pages/2081696628/DSTDACI-010+-+Interaction+Tracing+hooks+in+DS+components
 */ var $e1a091bdcbe2aeb8$var$useLayoutEffect = typeof window === 'undefined' ? (0, $5FkrB.useEffect) : (0, $5FkrB.useLayoutEffect);
/**
 * __Spinner__
 *
 * A spinner is an animated spinning icon that lets users know content is being loaded.
 *
 * - [Examples](https://atlassian.design/components/spinner/examples)
 * - [Code](https://atlassian.design/components/spinner/code)
 * - [Usage](https://atlassian.design/components/spinner/usage)
 */ var $e1a091bdcbe2aeb8$var$Spinner = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).forwardRef(function Spinner(_ref, ref) {
    var _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'inherit' : _ref$appearance, _ref$delay = _ref.delay, delay = _ref$delay === void 0 ? 0 : _ref$delay, interactionName = _ref.interactionName, label = _ref.label, _ref$size = _ref.size, providedSize = _ref$size === void 0 ? 'medium' : _ref$size, testId = _ref.testId;
    var size = typeof providedSize === 'number' ? providedSize : (0, $020d0e0280746cbe$export$4e9f1640bbe7a1a8)[providedSize];
    var animationDelay = "".concat(delay, "ms");
    var stroke = $e1a091bdcbe2aeb8$var$getStrokeColor(appearance);
    var context = (0, $5FkrB.useContext)((0, $a81fd7e45a8c2ef5$export$2e2bcd8739ae039));
    $e1a091bdcbe2aeb8$var$useLayoutEffect(function() {
        if (context != null) return context.hold(interactionName);
    }, [
        context,
        interactionName
    ]);
    /**
   * The Spinner animation uses a combination of two
   * css animations on two separate elements.
   */ return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("span", {
        "data-testid": testId ? "".concat(testId, "-wrapper") : 'spinner-wrapper',
        style: {
            animationDelay: animationDelay,
            width: size,
            height: size
        },
        className: (0, $1935b0dcb7b89056$export$2e2bcd8739ae039)([
            $e1a091bdcbe2aeb8$var$styles.wrapperStyles,
            $e1a091bdcbe2aeb8$var$styles.rotateStyles
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("svg", {
        height: size,
        width: size,
        viewBox: "0 0 16 16",
        xmlns: "http://www.w3.org/2000/svg",
        "data-testid": testId,
        ref: ref,
        "aria-label": label || undefined,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            animationDelay: animationDelay
        },
        role: label ? 'img' : 'none',
        className: (0, $1935b0dcb7b89056$export$2e2bcd8739ae039)([
            $e1a091bdcbe2aeb8$var$styles.loadInStyles
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("circle", {
        cx: "8",
        cy: "8",
        r: "7",
        style: {
            stroke: stroke
        },
        className: (0, $1935b0dcb7b89056$export$2e2bcd8739ae039)([
            $e1a091bdcbe2aeb8$var$styles.circleStyles
        ])
    })));
}));
var $e1a091bdcbe2aeb8$export$2e2bcd8739ae039 = $e1a091bdcbe2aeb8$var$Spinner;


function $93af073d0c768ed4$var$getIconSpacing(spacing) {
    switch(spacing){
        case 'compact':
            return 'small';
        default:
            return 'medium';
    }
}
function $93af073d0c768ed4$var$getSpinnerAppearance(_ref) {
    var appearance = _ref.appearance, isDisabled = _ref.isDisabled, isSelected = _ref.isSelected;
    if (isDisabled || isSelected) return 'inherit';
    if (appearance === 'primary' || appearance === 'rovo' || appearance === 'danger' || appearance === 'discovery') return 'invert';
    return 'inherit';
}
function $93af073d0c768ed4$export$2e2bcd8739ae039(_ref2) {
    var appearance = _ref2.appearance, spacing = _ref2.spacing, isDisabled = _ref2.isDisabled, isSelected = _ref2.isSelected, testId = _ref2.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $e1a091bdcbe2aeb8$export$2e2bcd8739ae039), {
        size: $93af073d0c768ed4$var$getIconSpacing(spacing),
        appearance: $93af073d0c768ed4$var$getSpinnerAppearance({
            appearance: appearance,
            isDisabled: isDisabled,
            isSelected: isSelected
        }),
        testId: testId ? "".concat(testId, "--loading-spinner") : undefined
    });
}


var $bbe32644ff853566$var$_excluded = [
    "appearance",
    "autoFocus",
    "isDisabled",
    "isLoading",
    "isSelected",
    "isIconButton",
    "isCircle",
    "hasIconBefore",
    "hasIconAfter",
    "shouldFitContainer",
    "spacing",
    "ariaLabel",
    "ariaLabelledBy",
    "children",
    "interactionName",
    "onClick",
    "onMouseDown",
    "onMouseDownCapture",
    "onMouseUp",
    "onMouseUpCapture",
    "onKeyDown",
    "onKeyDownCapture",
    "onKeyUp",
    "onKeyUpCapture",
    "onTouchStart",
    "onTouchStartCapture",
    "onTouchEnd",
    "onTouchEndCapture",
    "onPointerDown",
    "onPointerDownCapture",
    "onPointerUp",
    "onPointerUpCapture",
    "onClickCapture",
    "testId",
    "analyticsContext",
    "componentName",
    "role",
    "onMouseOver",
    "onMouseOut",
    "onFocus",
    "onBlur",
    "onMouseMove",
    "type"
], $bbe32644ff853566$var$_excluded2 = [
    "className",
    "css",
    "as",
    "style"
];
var $bbe32644ff853566$var$LOADING_LABEL = ', Loading';
var $bbe32644ff853566$var$styles = {
    base: "_2rkofajl _11c8fhey _v5649dqc _189eidpf _1rjc12x7 _1e0c116y _vchhusvi _1bsb1wug _p12f1osq _kqswh2mm _4cvr1q9y _1bah1h6o _gy1p1b66 _1o9zidpf _4t3iviql _k48p1wq8 _y4tiutpp _bozgutpp _y3gn1h6o _s7n4nkob _14mj1kw7 _9v7aze3t _1tv3nqa1 _39yqe4h9 _11fnglyw _18postnw",
    baseT26Shape: "_2rko1qi0",
    interactiveMotion: "_v564o1g2 _1gglat8s",
    linkDecorationUnset: "_4bfu1r31 _1hmsglyw _ajmmnqa1 _1a3b1r31 _4fprglyw _5goinqa1 _9oik1r31 _1bnxglyw _jf4cnqa1 _1nrm1r31 _c2waglyw _1iohnqa1",
    disabled: "_80om13gf _syaz1gmx _30l31gmx _9h8h1gmx",
    sharedDisabled: "_bfhk187o _irr3187o _1di6187o",
    spacingCompact: "_1rjcv77o _gy1p1b66 _4t3i1k8s _y4tiutpp _bozgutpp _s7n4nkob",
    spacingCompactT26Shape: "_2rko12b0",
    circle: "_2rko1rr0",
    fullWidth: "_1bsb1osq",
    loading: "_80om15jw",
    iconButton: "_4t3iviql _1bsbviql _y4tize3t _bozgze3t",
    iconButtonCompact: "_4t3i1k8s _1bsb1k8s",
    buttonIconBefore: "_bozgutpp _gy1p12x7",
    buttonIconAfter: "_y4tiutpp _gy1p12x7",
    splitButton: "_g0pbb4wl",
    loadingOverlay: "_1reo15vq _18m915vq _1e0c1txw _kqswstnw _4cvr1h6o _1bah1h6o _u7coze3t _152tze3t _rjxpze3t _1e02ze3t",
    navigationSplitButton: "_1bsb1tcg _bfhksm61 _y4ti12x7 _bozg12x7"
};
var $bbe32644ff853566$var$defaultStyles = {
    root: "_bfhksm61 _syazazsu _8l3m1l7x _aetrb3bt _1053azsu _f8pjazsu _30l3azsu _9h8hazsu",
    interactive: "_irr31dpa _30l3azsu _1di6fcek _9h8hazsu",
    disabled: "_bfhk1j28 _8l3mbk0g _irr31j28 _1di61j28"
};
var $bbe32644ff853566$var$primaryStyles = {
    root: "_bfhk1856 _syaz15cr _105315cr _f8pj15cr _30l315cr _9h8h15cr",
    interactive: "_30l315cr _irr3hf2y _9h8h15cr _1di6g6ey"
};
var $bbe32644ff853566$var$rovoStyles = {
    root: "_bfhklqh9 _syaz15cr _105315cr _f8pj15cr _30l315cr _9h8h15cr",
    interactive: "_30l315cr _irr31afz _9h8h15cr _1di61kru"
};
var $bbe32644ff853566$var$warningStyles = {
    root: "_bfhk1kmu _syaz1yd3 _10531yd3 _f8pj1yd3 _30l31yd3 _9h8h1yd3",
    interactive: "_30l31yd3 _irr31spp _9h8h1yd3 _1di64m4m"
};
var $bbe32644ff853566$var$dangerStyles = {
    root: "_bfhkybec _syaz15cr _105315cr _f8pj15cr _30l315cr _9h8h15cr",
    interactive: "_30l315cr _irr3s9hg _9h8h15cr _1di613a9"
};
var $bbe32644ff853566$var$discoveryStyles = {
    root: "_bfhku5tj _syaz15cr _105315cr _f8pj15cr _30l315cr _9h8h15cr",
    interactive: "_30l315cr _irr3fqeg _9h8h15cr _1di61f1m"
};
var $bbe32644ff853566$var$subtleStyles = {
    root: "_bfhksm61 _syazazsu _1053azsu _f8pjazsu _30l3azsu _9h8hazsu",
    interactive: "_irr31dpa _30l3azsu _1di6fcek _9h8hazsu",
    disabled: "_bfhk1j28 _8l3mbk0g _irr31j28 _1di61j28"
};
var $bbe32644ff853566$var$selectedStyles = {
    root: "_bfhk15s3 _syaz6x5g _8l3mq98m _aetrb3bt _10536x5g _f8pj6x5g _30l36x5g _9h8h6x5g",
    insideSplitButton: "_1pbycs5v",
    interactive: "_irr3ufnl _30l36x5g _1di6nozp _9h8h6x5g",
    warning: "_bfhk15s3 _syaz6x5g _30l36x5g _irr315s3 _9h8h6x5g _1di615s3",
    danger: "_bfhk15s3 _syaz6x5g _30l36x5g _irr315s3 _9h8h6x5g _1di615s3",
    discovery: "_bfhk15s3 _syaz6x5g _30l36x5g _irr315s3 _9h8h6x5g _1di615s3"
};
/**
 * __button base__
 *
 * - Implements auto focus when enabled.
 * - Appends the `onClick` event with UFO analytics tracking.
 *
 * @private
 */ var $bbe32644ff853566$var$ButtonBase = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).forwardRef(// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore: to unblock React 18.2.0 -> 18.3.1 version bump in Jira
function(_ref, ref) {
    // React Compiler opt-out: RC-incompatible (memoization breaks runtime behaviour).
    'use no memo';
    var propAppearance = _ref.appearance, _ref$autoFocus = _ref.autoFocus, autoFocus = _ref$autoFocus === void 0 ? false : _ref$autoFocus, _ref$isDisabled = _ref.isDisabled, propIsDisabled = _ref$isDisabled === void 0 ? false : _ref$isDisabled, _ref$isLoading = _ref.isLoading, isLoading = _ref$isLoading === void 0 ? false : _ref$isLoading, _ref$isSelected = _ref.isSelected, propIsSelected = _ref$isSelected === void 0 ? false : _ref$isSelected, _ref$isIconButton = _ref.isIconButton, isIconButton = _ref$isIconButton === void 0 ? false : _ref$isIconButton, _ref$isCircle = _ref.isCircle, isCircle = _ref$isCircle === void 0 ? false : _ref$isCircle, _ref$hasIconBefore = _ref.hasIconBefore, hasIconBefore = _ref$hasIconBefore === void 0 ? false : _ref$hasIconBefore, _ref$hasIconAfter = _ref.hasIconAfter, hasIconAfter = _ref$hasIconAfter === void 0 ? false : _ref$hasIconAfter, _ref$shouldFitContain = _ref.shouldFitContainer, shouldFitContainer = _ref$shouldFitContain === void 0 ? false : _ref$shouldFitContain, _ref$spacing = _ref.spacing, propSpacing = _ref$spacing === void 0 ? 'default' : _ref$spacing, ariaLabel = _ref.ariaLabel, ariaLabelledBy = _ref.ariaLabelledBy, children = _ref.children, interactionName = _ref.interactionName, onClick = _ref.onClick, onMouseDown = _ref.onMouseDown, onMouseDownCapture = _ref.onMouseDownCapture, onMouseUp = _ref.onMouseUp, onMouseUpCapture = _ref.onMouseUpCapture, onKeyDown = _ref.onKeyDown, onKeyDownCapture = _ref.onKeyDownCapture, onKeyUp = _ref.onKeyUp, onKeyUpCapture = _ref.onKeyUpCapture, onTouchStart = _ref.onTouchStart, onTouchStartCapture = _ref.onTouchStartCapture, onTouchEnd = _ref.onTouchEnd, onTouchEndCapture = _ref.onTouchEndCapture, onPointerDown = _ref.onPointerDown, onPointerDownCapture = _ref.onPointerDownCapture, onPointerUp = _ref.onPointerUp, onPointerUpCapture = _ref.onPointerUpCapture, onClickCapture = _ref.onClickCapture, testId = _ref.testId, analyticsContext = _ref.analyticsContext, componentName = _ref.componentName, role = _ref.role, onMouseOver = _ref.onMouseOver, onMouseOut = _ref.onMouseOut, onFocus = _ref.onFocus, onBlur = _ref.onBlur, onMouseMove = _ref.onMouseMove, type = _ref.type, unsafeRest = (0, $74jTZ.default)(_ref, $bbe32644ff853566$var$_excluded);
    var localRef = (0, $5FkrB.useRef)(null);
    var splitButtonContext = (0, $83e4e22b6f86ce29$export$47e2c6fdb142d947)();
    var loadingLabelId = (0, $c797bf80d6171378$export$f680877a34711e37)();
    var isSplitButton = Boolean(splitButtonContext);
    var isNavigationSplitButton = (splitButtonContext === null || splitButtonContext === void 0 ? void 0 : splitButtonContext.isNavigationSplitButton) || false;
    var isDefaultAppearanceSplitButton = (splitButtonContext === null || splitButtonContext === void 0 ? void 0 : splitButtonContext.appearance) === 'default';
    var appearance = isDefaultAppearanceSplitButton ? 'subtle' : propAppearance || (splitButtonContext === null || splitButtonContext === void 0 ? void 0 : splitButtonContext.appearance) || 'default';
    var spacing = (splitButtonContext === null || splitButtonContext === void 0 ? void 0 : splitButtonContext.spacing) || propSpacing;
    var isDisabled = (splitButtonContext === null || splitButtonContext === void 0 ? void 0 : splitButtonContext.isDisabled) || propIsDisabled;
    var isInteractive = !isDisabled && !isLoading;
    // Also treat loading buttons as disabled
    var isEffectivelyDisabled = isDisabled || isLoading;
    var isSelected = propIsSelected && !isDisabled;
    (0, $bf3b13d9d73de104$export$2e2bcd8739ae039)(localRef, autoFocus);
    // @ts-expect-error
    var _className = unsafeRest.className, _css = unsafeRest.css, _as = unsafeRest.as, _style = unsafeRest.style, saferRest = (0, $74jTZ.default)(unsafeRest, $bbe32644ff853566$var$_excluded2);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $605ff0fe25231d2b$export$27c701ed9e449e99), (0, $d0778aa44ff9fe37$export$2e2bcd8739ae039)({}, saferRest, {
        componentName: componentName || 'button',
        analyticsContext: analyticsContext,
        role: role,
        ref: (0, $db13a2f91f6a0f56$export$2e2bcd8739ae039)([
            localRef,
            ref
        ]),
        xcss: (0, $b5cd78e10bc362b2$export$a274e22fb40f762e)($bbe32644ff853566$var$styles.base, (0, $2fcbb5e4cf9206d1$export$b40ec24ac8275656)('platform-dst-shape-theme-default') && $bbe32644ff853566$var$styles.baseT26Shape, isInteractive && (0, $2fcbb5e4cf9206d1$export$b40ec24ac8275656)('platform-dst-motion-uplift-button') && $bbe32644ff853566$var$styles.interactiveMotion, appearance === 'default' && $bbe32644ff853566$var$defaultStyles.root, appearance === 'default' && isInteractive && $bbe32644ff853566$var$defaultStyles.interactive, appearance === 'primary' && $bbe32644ff853566$var$primaryStyles.root, appearance === 'primary' && isInteractive && $bbe32644ff853566$var$primaryStyles.interactive, appearance === 'rovo' && $bbe32644ff853566$var$rovoStyles.root, appearance === 'rovo' && isInteractive && $bbe32644ff853566$var$rovoStyles.interactive, appearance === 'warning' && $bbe32644ff853566$var$warningStyles.root, appearance === 'warning' && isInteractive && $bbe32644ff853566$var$warningStyles.interactive, appearance === 'danger' && $bbe32644ff853566$var$dangerStyles.root, appearance === 'danger' && isInteractive && $bbe32644ff853566$var$dangerStyles.interactive, appearance === 'discovery' && $bbe32644ff853566$var$discoveryStyles.root, appearance === 'discovery' && isInteractive && $bbe32644ff853566$var$discoveryStyles.interactive, appearance === 'subtle' && $bbe32644ff853566$var$subtleStyles.root, appearance === 'subtle' && isInteractive && $bbe32644ff853566$var$subtleStyles.interactive, $bbe32644ff853566$var$styles.linkDecorationUnset, isSelected && $bbe32644ff853566$var$selectedStyles.root, isSelected && isSplitButton && $bbe32644ff853566$var$selectedStyles.insideSplitButton, isSelected && isInteractive && $bbe32644ff853566$var$selectedStyles.interactive, // TODO: remove me once we kill color fallbacks
        isSelected && appearance === 'danger' && $bbe32644ff853566$var$selectedStyles.danger, // TODO: remove me once we kill color fallbacks
        isSelected && appearance === 'warning' && $bbe32644ff853566$var$selectedStyles.warning, // TODO: remove me once we kill color fallbacks
        isSelected && appearance === 'discovery' && $bbe32644ff853566$var$selectedStyles.discovery, isDisabled && $bbe32644ff853566$var$styles.disabled, isDisabled && appearance !== 'default' && appearance !== 'subtle' && $bbe32644ff853566$var$styles.sharedDisabled, isDisabled && appearance === 'default' && $bbe32644ff853566$var$defaultStyles.disabled, spacing === 'compact' && $bbe32644ff853566$var$styles.spacingCompact, spacing === 'compact' && (0, $2fcbb5e4cf9206d1$export$b40ec24ac8275656)('platform-dst-shape-theme-default') && $bbe32644ff853566$var$styles.spacingCompactT26Shape, // This must come after spacing compact styling as it overrides the border radius
        isCircle && !isSplitButton && $bbe32644ff853566$var$styles.circle, shouldFitContainer && $bbe32644ff853566$var$styles.fullWidth, hasIconBefore && $bbe32644ff853566$var$styles.buttonIconBefore, hasIconAfter && $bbe32644ff853566$var$styles.buttonIconAfter, isIconButton && $bbe32644ff853566$var$styles.iconButton, isIconButton && spacing === 'compact' && $bbe32644ff853566$var$styles.iconButtonCompact, isLoading && $bbe32644ff853566$var$styles.loading, isSplitButton && $bbe32644ff853566$var$styles.splitButton, isNavigationSplitButton && $bbe32644ff853566$var$styles.navigationSplitButton),
        isDisabled: (0, $2fcbb5e4cf9206d1$export$b40ec24ac8275656)('platform-dst_fix_not_focusable_loading_button') ? isDisabled : isEffectivelyDisabled
    }, (0, $2fcbb5e4cf9206d1$export$b40ec24ac8275656)('platform-dst_fix_not_focusable_loading_button') && {
        'aria-live': 'polite'
    }, isLoading && (0, $2fcbb5e4cf9206d1$export$b40ec24ac8275656)('platform-dst_fix_not_focusable_loading_button') && {
        'aria-disabled': true
    }, {
        "aria-label": isLoading && ariaLabel && !ariaLabelledBy ? "".concat(ariaLabel, " ").concat($bbe32644ff853566$var$LOADING_LABEL) : ariaLabel,
        "aria-labelledby": isLoading && ariaLabelledBy ? "".concat(ariaLabelledBy, " ").concat(loadingLabelId) : ariaLabelledBy,
        onClick: onClick
    }, (0, $3fddbbdc41d2331c$export$2e2bcd8739ae039)(isEffectivelyDisabled, {
        onMouseDownCapture: onMouseDownCapture,
        onMouseUpCapture: onMouseUpCapture,
        onKeyDownCapture: onKeyDownCapture,
        onKeyUpCapture: onKeyUpCapture,
        onTouchStartCapture: onTouchStartCapture,
        onTouchEndCapture: onTouchEndCapture,
        onPointerDownCapture: onPointerDownCapture,
        onPointerUpCapture: onPointerUpCapture,
        onClickCapture: onClickCapture
    }), {
        testId: testId,
        onMouseOver: onMouseOver,
        onFocus: onFocus,
        onMouseMove: onMouseMove,
        onBlur: onBlur,
        type: type,
        interactionName: interactionName,
        onMouseDown: onMouseDown,
        onMouseUp: onMouseUp,
        onKeyDown: onKeyDown,
        onMouseOut: onMouseOut,
        onKeyUp: onKeyUp,
        onTouchStart: onTouchStart,
        onTouchEnd: onTouchEnd,
        onPointerDown: onPointerDown,
        onPointerUp: onPointerUp
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $8d566bfb3d418dc9$export$4b86304b2c0d7e71).Provider, {
        value: undefined
    }, children, isLoading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("span", {
        className: (0, $gKzKW.default)([
            $bbe32644ff853566$var$styles.loadingOverlay
        ])
    }, (0, $93af073d0c768ed4$export$2e2bcd8739ae039)({
        spacing: spacing,
        appearance: appearance,
        isDisabled: isDisabled,
        isSelected: isSelected,
        testId: testId
    })), isLoading && (ariaLabelledBy || !ariaLabel) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $3fb4db4d25367976$export$2e2bcd8739ae039), {
        id: loadingLabelId
    }, $bbe32644ff853566$var$LOADING_LABEL)));
});
var $bbe32644ff853566$export$2e2bcd8739ae039 = $bbe32644ff853566$var$ButtonBase;


/* content.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $gKzKW = parcelRequire("gKzKW");

var $5FkrB = parcelRequire("5FkrB");
var $56193979d51cd3c8$var$styles = {
    text: "_1reo15vq _18m915vq _16jlkb7n _1o9zkb7n _1bto1l2s _o5721q9c",
    icon: "_1e0c1txw _16jlidpf _1o9zidpf _1wpz1h6o _1wybidpf _vwz4idpf _uiztglyw",
    common: "_v564g17y",
    fade: "_tzy4idpf"
};
/**
 * __Content__
 *
 * Used for slots within a Button, including icons and text content.
 */ var $56193979d51cd3c8$var$Content = function Content(_ref) {
    var children = _ref.children, _ref$type = _ref.type, type = _ref$type === void 0 ? 'text' : _ref$type, isLoading = _ref.isLoading;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("span", {
        className: (0, $gKzKW.default)([
            $56193979d51cd3c8$var$styles.common,
            type === 'text' && $56193979d51cd3c8$var$styles.text,
            type === 'icon' && $56193979d51cd3c8$var$styles.icon,
            isLoading && $56193979d51cd3c8$var$styles.fade
        ])
    }, children);
};
var $56193979d51cd3c8$export$2e2bcd8739ae039 = $56193979d51cd3c8$var$Content;



var $5FkrB = parcelRequire("5FkrB");

function $13336f84b82b1516$var$isIconRenderProp(func) {
    return !func.displayName && // most function components and class components have a displayName, negate them
    !func.render && // forwardRef doesn't require a display name, however it does include a render function, negate them
    typeof func === 'function' // at the very least we need to be a function
    ;
}
/**
 * __Icon renderer__
 *
 * Used to support render props with icons.
 *
 */ var $13336f84b82b1516$var$IconRenderer = function IconRenderer(_ref) {
    // React Compiler opt-out: RC-incompatible (memoization breaks runtime behaviour).
    'use no memo';
    var Icon = _ref.icon;
    var isRenderProp = $13336f84b82b1516$var$isIconRenderProp(Icon);
    var iconProps = {
        label: '',
        color: 'currentColor',
        size: (0, $2fcbb5e4cf9206d1$export$b40ec24ac8275656)('platform_dst_button_chevron_sizing') ? function(iconName) {
            return iconName.startsWith('Chevron') ? 'small' : 'medium';
        } : undefined
    };
    // @ts-ignore - TS2322 TypeScript 5.9.2 upgrade
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).Fragment, null, isRenderProp ? Icon(iconProps) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(Icon, iconProps));
};
var $13336f84b82b1516$export$2e2bcd8739ae039 = $13336f84b82b1516$var$IconRenderer;


var $00ca4e839c919457$var$_excluded = [
    "aria-label",
    "aria-labelledby",
    "analyticsContext",
    "appearance",
    "autoFocus",
    "icon",
    "interactionName",
    "isDisabled",
    "isLoading",
    "isSelected",
    "isTooltipDisabled",
    "label",
    "onClick",
    "onClickCapture",
    "onKeyDownCapture",
    "onKeyUpCapture",
    "onMouseDownCapture",
    "onMouseUpCapture",
    "onPointerDownCapture",
    "onPointerUpCapture",
    "onTouchEndCapture",
    "onTouchStartCapture",
    "shape",
    "spacing",
    "testId",
    "tooltip",
    "type"
], $00ca4e839c919457$var$_excluded2 = [
    "className",
    "css",
    "as",
    "style"
];
/**
 * __Icon Button__
 *
 * Renders an icon-only button lets people take a common and recognizable action where space is limited.
 *
 * - [Examples](https://atlassian.design/components/button/icon-button/examples)
 * - [Code](https://atlassian.design/components/button/icon-button/code)
 * - [Usage](https://atlassian.design/components/button/icon-button/usage)
 */ var $00ca4e839c919457$var$IconButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).forwardRef(function Button(_ref, ref) {
    var _tooltip$content;
    var preventedAriaLabel = _ref['aria-label'], ariaLabelledBy = _ref['aria-labelledby'], analyticsContext = _ref.analyticsContext, appearance = _ref.appearance, autoFocus = _ref.autoFocus, icon = _ref.icon, interactionName = _ref.interactionName, isDisabled = _ref.isDisabled, _ref$isLoading = _ref.isLoading, isLoading = _ref$isLoading === void 0 ? false : _ref$isLoading, isSelected = _ref.isSelected, _ref$isTooltipDisable = _ref.isTooltipDisabled, isTooltipDisabled = _ref$isTooltipDisable === void 0 ? true : _ref$isTooltipDisable, label = _ref.label, _onClick = _ref.onClick, onClickCapture = _ref.onClickCapture, onKeyDownCapture = _ref.onKeyDownCapture, onKeyUpCapture = _ref.onKeyUpCapture, onMouseDownCapture = _ref.onMouseDownCapture, onMouseUpCapture = _ref.onMouseUpCapture, onPointerDownCapture = _ref.onPointerDownCapture, onPointerUpCapture = _ref.onPointerUpCapture, onTouchEndCapture = _ref.onTouchEndCapture, onTouchStartCapture = _ref.onTouchStartCapture, shape = _ref.shape, spacing = _ref.spacing, testId = _ref.testId, tooltip = _ref.tooltip, _ref$type = _ref.type, type = _ref$type === void 0 ? 'button' : _ref$type, unsafeRest = (0, $74jTZ.default)(_ref, $00ca4e839c919457$var$_excluded);
    // @ts-expect-error
    var _className = unsafeRest.className, _css = unsafeRest.css, _as = unsafeRest.as, _style = unsafeRest.style, saferRest = (0, $74jTZ.default)(unsafeRest, $00ca4e839c919457$var$_excluded2);
    if (isTooltipDisabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $bbe32644ff853566$export$2e2bcd8739ae039), (0, $d0778aa44ff9fe37$export$2e2bcd8739ae039)({}, saferRest, {
        ref: ref,
        appearance: appearance,
        autoFocus: autoFocus,
        isDisabled: isDisabled,
        isLoading: isLoading,
        isSelected: isSelected,
        isIconButton: true,
        isCircle: shape === 'circle',
        hasIconBefore: !!icon,
        spacing: spacing,
        ariaLabelledBy: ariaLabelledBy,
        onClick: _onClick,
        onClickCapture: onClickCapture,
        onKeyDownCapture: onKeyDownCapture,
        onKeyUpCapture: onKeyUpCapture,
        onMouseDownCapture: onMouseDownCapture,
        onMouseUpCapture: onMouseUpCapture,
        onPointerDownCapture: onPointerDownCapture,
        onPointerUpCapture: onPointerUpCapture,
        onTouchStartCapture: onTouchStartCapture,
        onTouchEndCapture: onTouchEndCapture,
        testId: testId,
        componentName: "IconButton",
        analyticsContext: analyticsContext,
        type: type,
        interactionName: interactionName
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $56193979d51cd3c8$export$2e2bcd8739ae039), {
        type: "icon",
        isLoading: isLoading
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $13336f84b82b1516$export$2e2bcd8739ae039), {
        icon: icon
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $3fb4db4d25367976$export$2e2bcd8739ae039), null, label)));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $e7f9abe788af764f$export$2e2bcd8739ae039), {
        content: (_tooltip$content = tooltip === null || tooltip === void 0 ? void 0 : tooltip.content) !== null && _tooltip$content !== void 0 ? _tooltip$content : label,
        testId: tooltip === null || tooltip === void 0 ? void 0 : tooltip.testId,
        position: tooltip === null || tooltip === void 0 ? void 0 : tooltip.position,
        delay: tooltip === null || tooltip === void 0 ? void 0 : tooltip.delay,
        onShow: tooltip === null || tooltip === void 0 ? void 0 : tooltip.onShow,
        onHide: tooltip === null || tooltip === void 0 ? void 0 : tooltip.onHide,
        mousePosition: tooltip === null || tooltip === void 0 ? void 0 : tooltip.mousePosition,
        analyticsContext: tooltip === null || tooltip === void 0 ? void 0 : tooltip.analyticsContext,
        strategy: tooltip === null || tooltip === void 0 ? void 0 : tooltip.strategy,
        tag: tooltip === null || tooltip === void 0 ? void 0 : tooltip.tag,
        truncate: tooltip === null || tooltip === void 0 ? void 0 : tooltip.truncate,
        component: tooltip === null || tooltip === void 0 ? void 0 : tooltip.component,
        hideTooltipOnClick: tooltip === null || tooltip === void 0 ? void 0 : tooltip.hideTooltipOnClick,
        hideTooltipOnMouseDown: tooltip === null || tooltip === void 0 ? void 0 : tooltip.hideTooltipOnMouseDown,
        ignoreTooltipPointerEvents: tooltip === null || tooltip === void 0 ? void 0 : tooltip.ignoreTooltipPointerEvents,
        shortcut: tooltip === null || tooltip === void 0 ? void 0 : tooltip.shortcut
    }, function(triggerProps) {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $bbe32644ff853566$export$2e2bcd8739ae039), (0, $d0778aa44ff9fe37$export$2e2bcd8739ae039)({}, saferRest, {
            appearance: appearance,
            autoFocus: autoFocus,
            isDisabled: isDisabled,
            isLoading: isLoading,
            isSelected: isSelected,
            isIconButton: true,
            isCircle: shape === 'circle',
            hasIconBefore: false,
            spacing: spacing,
            ariaLabelledBy: ariaLabelledBy,
            onClick: function onClick(e, analyticsEvent) {
                var _triggerProps$onClick;
                _onClick === null || _onClick === void 0 || _onClick(e, analyticsEvent);
                (_triggerProps$onClick = triggerProps.onClick) === null || _triggerProps$onClick === void 0 || _triggerProps$onClick.call(triggerProps, e);
            },
            onMouseOver: function onMouseOver(e) {
                var _triggerProps$onMouse, _saferRest$onMouseOve;
                (_triggerProps$onMouse = triggerProps.onMouseOver) === null || _triggerProps$onMouse === void 0 || _triggerProps$onMouse.call(triggerProps, e);
                (_saferRest$onMouseOve = saferRest.onMouseOver) === null || _saferRest$onMouseOve === void 0 || _saferRest$onMouseOve.call(saferRest, e);
            },
            onMouseOut: function onMouseOut(e) {
                var _triggerProps$onMouse2, _saferRest$onMouseOut;
                (_triggerProps$onMouse2 = triggerProps.onMouseOut) === null || _triggerProps$onMouse2 === void 0 || _triggerProps$onMouse2.call(triggerProps, e);
                (_saferRest$onMouseOut = saferRest.onMouseOut) === null || _saferRest$onMouseOut === void 0 || _saferRest$onMouseOut.call(saferRest, e);
            },
            onMouseMove: function onMouseMove(e) {
                var _triggerProps$onMouse3, _saferRest$onMouseMov;
                (_triggerProps$onMouse3 = triggerProps.onMouseMove) === null || _triggerProps$onMouse3 === void 0 || _triggerProps$onMouse3.call(triggerProps, e);
                (_saferRest$onMouseMov = saferRest.onMouseMove) === null || _saferRest$onMouseMov === void 0 || _saferRest$onMouseMov.call(saferRest, e);
            },
            onMouseDown: function onMouseDown(e) {
                var _triggerProps$onMouse4, _saferRest$onMouseDow;
                (_triggerProps$onMouse4 = triggerProps.onMouseDown) === null || _triggerProps$onMouse4 === void 0 || _triggerProps$onMouse4.call(triggerProps, e);
                (_saferRest$onMouseDow = saferRest.onMouseDown) === null || _saferRest$onMouseDow === void 0 || _saferRest$onMouseDow.call(saferRest, e);
            },
            onFocus: function onFocus(e) {
                var _triggerProps$onFocus, _saferRest$onFocus;
                (_triggerProps$onFocus = triggerProps.onFocus) === null || _triggerProps$onFocus === void 0 || _triggerProps$onFocus.call(triggerProps, e);
                (_saferRest$onFocus = saferRest.onFocus) === null || _saferRest$onFocus === void 0 || _saferRest$onFocus.call(saferRest, e);
            },
            onBlur: function onBlur(e) {
                var _triggerProps$onBlur, _saferRest$onBlur;
                (_triggerProps$onBlur = triggerProps.onBlur) === null || _triggerProps$onBlur === void 0 || _triggerProps$onBlur.call(triggerProps, e);
                (_saferRest$onBlur = saferRest.onBlur) === null || _saferRest$onBlur === void 0 || _saferRest$onBlur.call(saferRest, e);
            },
            ref: (0, $db13a2f91f6a0f56$export$2e2bcd8739ae039)([
                ref,
                triggerProps === null || triggerProps === void 0 ? void 0 : triggerProps.ref
            ].filter(Boolean)),
            onMouseDownCapture: onMouseDownCapture,
            onMouseUpCapture: onMouseUpCapture,
            onKeyDownCapture: onKeyDownCapture,
            onKeyUpCapture: onKeyUpCapture,
            onTouchStartCapture: onTouchStartCapture,
            onTouchEndCapture: onTouchEndCapture,
            onPointerDownCapture: onPointerDownCapture,
            onPointerUpCapture: onPointerUpCapture,
            onClickCapture: onClickCapture,
            type: type,
            testId: testId,
            analyticsContext: analyticsContext,
            interactionName: interactionName,
            componentName: "IconButton"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $56193979d51cd3c8$export$2e2bcd8739ae039), {
            type: "icon",
            isLoading: isLoading
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $13336f84b82b1516$export$2e2bcd8739ae039), {
            icon: icon
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $3fb4db4d25367976$export$2e2bcd8739ae039), null, label)));
    });
}));
$00ca4e839c919457$var$IconButton.displayName = 'IconButton';
var $00ca4e839c919457$export$2e2bcd8739ae039 = $00ca4e839c919457$var$IconButton;


/* heading.tsx generated by @compiled/babel-plugin v0.40.0 */ 
var $amAaq = parcelRequire("amAaq");

var $5FkrB = parcelRequire("5FkrB");

var $gKzKW = parcelRequire("gKzKW");
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::828feee5f551f4f72139928d095ef0f9>>
 * @codegenCommand yarn workspace @atlaskit/primitives codegen-styles
 * @codegenDependency ../../../tokens/src/artifacts/tokens-raw/atlassian-light.tsx <<SignedSource::4e25079e2363933fae45ad0f1e9c123b>>
 */ var $9ec3a11af649c640$export$2185ce37f9bdd963 = {
    'color.background.neutral.bold': 'color.text.inverse',
    'color.background.neutral.bold.hovered': 'color.text.inverse',
    'color.background.neutral.bold.pressed': 'color.text.inverse',
    'color.background.selected.bold': 'color.text.inverse',
    'color.background.selected.bold.hovered': 'color.text.inverse',
    'color.background.selected.bold.pressed': 'color.text.inverse',
    'color.background.brand.bold': 'color.text.inverse',
    'color.background.brand.bold.hovered': 'color.text.inverse',
    'color.background.brand.bold.pressed': 'color.text.inverse',
    'color.background.brand.boldest': 'color.text.inverse',
    'color.background.brand.boldest.hovered': 'color.text.inverse',
    'color.background.brand.boldest.pressed': 'color.text.inverse',
    'color.background.danger.bold': 'color.text.inverse',
    'color.background.danger.bold.hovered': 'color.text.inverse',
    'color.background.danger.bold.pressed': 'color.text.inverse',
    'color.background.warning.bold': 'color.text.warning.inverse',
    'color.background.warning.bold.hovered': 'color.text.warning.inverse',
    'color.background.warning.bold.pressed': 'color.text.warning.inverse',
    'color.background.success.bold': 'color.text.inverse',
    'color.background.success.bold.hovered': 'color.text.inverse',
    'color.background.success.bold.pressed': 'color.text.inverse',
    'color.background.discovery.bold': 'color.text.inverse',
    'color.background.discovery.bold.hovered': 'color.text.inverse',
    'color.background.discovery.bold.pressed': 'color.text.inverse',
    'color.background.information.bold': 'color.text.inverse',
    'color.background.information.bold.hovered': 'color.text.inverse',
    'color.background.information.bold.pressed': 'color.text.inverse',
    'color.rovo.background.brand.bold': 'color.text.inverse',
    'color.rovo.background.brand.bold.hovered': 'color.text.inverse',
    'color.rovo.background.brand.bold.pressed': 'color.text.inverse'
};



var $5FkrB = parcelRequire("5FkrB");

var $5FkrB = parcelRequire("5FkrB");
var $fb15455aaac7771d$export$1ca2a26fecb070ae = /*#__PURE__*/ (0, $5FkrB.createContext)('elevation.surface');


var $82d2614f68639fbf$export$1aeb4f6b93c4540d = function useSurface() {
    return (0, $5FkrB.useContext)((0, $fb15455aaac7771d$export$1ca2a26fecb070ae));
};
(0, $fb15455aaac7771d$export$1ca2a26fecb070ae).displayName = 'SurfaceProvider';



var $5FkrB = parcelRequire("5FkrB");

var $5FkrB = parcelRequire("5FkrB");
var $d5feb91794df3429$export$d1fa8a19e192bc63 = /*#__PURE__*/ (0, $5FkrB.createContext)(0);


var $2576bf3f3605e1db$export$6a64a1e2d0bbbf75 = function useHeadingLevel() {
    return (0, $5FkrB.useContext)((0, $d5feb91794df3429$export$d1fa8a19e192bc63));
};


var $e36faaa305cb62b6$export$97a37b1befbbf9b1 = function useHeading(fallback) {
    var hLevel = (0, $2576bf3f3605e1db$export$6a64a1e2d0bbbf75)();
    /**
   * Order here is important, we for now apply
   * 1. inferred a11y level (this only applies if context is present)
   * 2. default final fallback
   */ return [
        hLevel,
        hLevel && (hLevel > 6 ? 'div' : "h".concat(hLevel)) || fallback
    ];
};



var $3ZMUU = parcelRequire("3ZMUU");
var $3125392203c599f4$var$sizeTagMap = {
    xxlarge: 'h1',
    xlarge: 'h1',
    large: 'h2',
    medium: 'h3',
    small: 'h4',
    xsmall: 'h5',
    xxsmall: 'h6'
};
/**
 * Using '&&' here to increase specificity of Heading styles such that app styles like ".wiki-content h4" cannot override this component.
 */ var $3125392203c599f4$var$styles = {
    reset: "_dxsyidpf _1i144jg8 _nmk4glyw"
};
/**
 * Using '&&' here to increase specificity of Heading styles such that app styles like ".wiki-content h4" cannot override this component.
 */ var $3125392203c599f4$var$headingColorStyles = {
    'color.text': "_1w90i7uo",
    'color.text.inverse': "_1w9015cr",
    'color.text.warning.inverse': "_1w901yd3"
};
/**
 * Using '&&' here to increase specificity of Heading styles such that app styles like ".wiki-content h4" cannot override this component.
 */ var $3125392203c599f4$var$headingSizeStyles = {
    xxlarge: "_fqox1iff",
    xlarge: "_fqox12ln",
    large: "_fqox10sd",
    medium: "_fqox1af2",
    small: "_fqox1e3o",
    xsmall: "_fqox1qyo",
    xxsmall: "_fqoxi4vh"
};
/**
 * @codegenEnd
 */ var $3125392203c599f4$var$useColor = function useColor(colorProp) {
    var surface = (0, $82d2614f68639fbf$export$1aeb4f6b93c4540d)();
    if (colorProp) return colorProp;
    if ((0, $9ec3a11af649c640$export$2185ce37f9bdd963).hasOwnProperty(surface)) return (0, $9ec3a11af649c640$export$2185ce37f9bdd963)[surface];
    return 'color.text';
};
/**
 * __Heading__
 *
 * Heading is a typography component used to display text in defined sizes and styles.
 *
 * @example
 *
 * ```jsx
 * <Heading size="xxlarge">Page title</Heading>
 * ```
 */ var $3125392203c599f4$var$Heading = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function(props, ref) {
    var children = props.children, size = props.size, id = props.id, testId = props.testId, as = props.as, colorProp = props.color;
    typeof $3ZMUU;
    var _useHeading = (0, $e36faaa305cb62b6$export$97a37b1befbbf9b1)($3125392203c599f4$var$sizeTagMap[size]), _useHeading2 = (0, $amAaq.default)(_useHeading, 2), hLevel = _useHeading2[0], inferredElement = _useHeading2[1];
    var Component = as || inferredElement;
    var needsAriaRole = Component === 'div' && hLevel;
    var color = $3125392203c599f4$var$useColor(colorProp);
    return /*#__PURE__*/ $5FkrB.createElement(Component, {
        id: id,
        ref: ref,
        "data-testid": testId,
        role: needsAriaRole ? 'heading' : undefined,
        "aria-level": needsAriaRole ? hLevel : undefined,
        className: (0, $gKzKW.default)([
            $3125392203c599f4$var$styles.reset,
            $3125392203c599f4$var$headingSizeStyles[size],
            $3125392203c599f4$var$headingColorStyles[color]
        ])
    }, children);
});
var $3125392203c599f4$export$2e2bcd8739ae039 = $3125392203c599f4$var$Heading;


var $c9fbc4ca33451d4e$exports = {};
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a6e34d167858ba514f74d5881b8440fc>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty($c9fbc4ca33451d4e$exports, "__esModule", {
    value: true
});
$c9fbc4ca33451d4e$exports.default = void 0;

var $c9fbc4ca33451d4e$var$_react = $c9fbc4ca33451d4e$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $c9fbc4ca33451d4e$var$_baseNew = $c9fbc4ca33451d4e$var$_interopRequireDefault((parcelRequire("8HikK")));
function $c9fbc4ca33451d4e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Cross".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Known uses: closing modals, panels, and transient views; removing tags
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c9fbc4ca33451d4e$var$CrossIcon = (props)=>/*#__PURE__*/ $c9fbc4ca33451d4e$var$_react.default.createElement($c9fbc4ca33451d4e$var$_baseNew.default, Object.assign({
        name: "CrossIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M13.53 3.53 9.06 8l4.47 4.47-1.06 1.06L8 9.06l-4.47 4.47-1.06-1.06L6.94 8 2.47 3.53l1.06-1.06L8 6.94l4.47-4.47z"/>`
    }, props));
$c9fbc4ca33451d4e$var$CrossIcon.displayName = 'CrossIcon';
var $c9fbc4ca33451d4e$var$_default = $c9fbc4ca33451d4e$exports.default = $c9fbc4ca33451d4e$var$CrossIcon;



/* inline.tsx generated by @compiled/babel-plugin v0.40.0 */ 

var $74jTZ = parcelRequire("74jTZ");

var $5FkrB = parcelRequire("5FkrB");

var $gKzKW = parcelRequire("gKzKW");

/* flex.tsx generated by @compiled/babel-plugin v0.40.0 */ 

var $74jTZ = parcelRequire("74jTZ");

var $5FkrB = parcelRequire("5FkrB");

var $gKzKW = parcelRequire("gKzKW");
var $87d7e898dee4d9f1$var$_excluded = [
    "as",
    "role",
    "alignItems",
    "justifyContent",
    "gap",
    "columnGap",
    "rowGap",
    "children",
    "testId",
    "direction",
    "wrap",
    "xcss"
];
var $87d7e898dee4d9f1$var$rowGapMap = {
    'space.0': "_1p57ze3t",
    'space.025': "_1p57v77o",
    'space.050': "_1p571b66",
    'space.075': "_1p5712x7",
    'space.100': "_1p57u2gc",
    'space.150': "_1p57utpp",
    'space.200': "_1p57pxbi",
    'space.250': "_1p57v47k",
    'space.300': "_1p571ejb",
    'space.400': "_1p57xy5q",
    'space.500': "_1p571jfw",
    'space.600': "_1p57oahv",
    'space.800': "_1p57xncg",
    'space.1000': "_1p571epz"
};
var $87d7e898dee4d9f1$var$columnGapMap = {
    'space.0': "_gy1pze3t",
    'space.025': "_gy1pv77o",
    'space.050': "_gy1p1b66",
    'space.075': "_gy1p12x7",
    'space.100': "_gy1pu2gc",
    'space.150': "_gy1putpp",
    'space.200': "_gy1ppxbi",
    'space.250': "_gy1pv47k",
    'space.300': "_gy1p1ejb",
    'space.400': "_gy1pxy5q",
    'space.500': "_gy1p1jfw",
    'space.600': "_gy1poahv",
    'space.800': "_gy1pxncg",
    'space.1000': "_gy1p1epz"
};
var $87d7e898dee4d9f1$var$justifyContentMap = {
    start: "_1bahv2br",
    center: "_1bah1h6o",
    end: "_1bahh9n0",
    'space-between': "_1bah1yb4",
    'space-around': "_1bah1b1v",
    'space-evenly': "_1bahitcz",
    stretch: "_1bah1fhb"
};
var $87d7e898dee4d9f1$var$flexDirectionMap = {
    column: "_2lx21bp4",
    row: "_2lx2vrvc"
};
var $87d7e898dee4d9f1$var$flexWrapMap = {
    wrap: "_1n261g80",
    nowrap: "_1n261q9c"
};
var $87d7e898dee4d9f1$var$alignItemsMap = {
    start: "_4cvrv2br",
    center: "_4cvr1h6o",
    baseline: "_4cvr1q9y",
    end: "_4cvrh9n0",
    stretch: "_4cvr1fhb"
};
var $87d7e898dee4d9f1$var$styles = {
    root: "_1e0c1txw _vchhusvi"
};
var $87d7e898dee4d9f1$export$f51f4c4ede09e011 = /*#__PURE__*/ (0, $5FkrB.memo)(/*#__PURE__*/ (0, $5FkrB.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? 'div' : _ref$as, role = _ref.role, alignItems = _ref.alignItems, justifyContent = _ref.justifyContent, gap = _ref.gap, columnGap = _ref.columnGap, rowGap = _ref.rowGap, children = _ref.children, testId = _ref.testId, direction = _ref.direction, wrap = _ref.wrap, xcss = _ref.xcss, ariaAttributes = (0, $74jTZ.default)(_ref, $87d7e898dee4d9f1$var$_excluded);
    return /*#__PURE__*/ $5FkrB.createElement(Component, (0, $d0778aa44ff9fe37$export$2e2bcd8739ae039)({}, ariaAttributes, {
        role: role,
        className: (0, $gKzKW.default)([
            $87d7e898dee4d9f1$var$styles.root,
            gap && $87d7e898dee4d9f1$var$columnGapMap[gap],
            columnGap && $87d7e898dee4d9f1$var$columnGapMap[columnGap],
            gap && $87d7e898dee4d9f1$var$rowGapMap[gap],
            rowGap && $87d7e898dee4d9f1$var$rowGapMap[rowGap],
            alignItems && $87d7e898dee4d9f1$var$alignItemsMap[alignItems],
            direction && $87d7e898dee4d9f1$var$flexDirectionMap[direction],
            justifyContent && $87d7e898dee4d9f1$var$justifyContentMap[justifyContent],
            wrap && $87d7e898dee4d9f1$var$flexWrapMap[wrap],
            xcss
        ]),
        "data-testid": testId,
        ref: ref
    }), children);
}));
$87d7e898dee4d9f1$export$f51f4c4ede09e011.displayName = 'Flex';


var $719ce0f2ce4e24d3$var$_excluded = [
    "as",
    "alignInline",
    "alignBlock",
    "shouldWrap",
    "spread",
    "grow",
    "space",
    "rowSpace",
    "separator",
    "xcss",
    "testId",
    "role",
    "children"
];
var $719ce0f2ce4e24d3$var$styles = {
    separator: "_1mouze3t _195g1i6y _syazjjyb _lcxvglyw _uiztglyw",
    hug: "_16jlidpf",
    fill: "_1bsb1osq _16jlkb7n"
};
var $719ce0f2ce4e24d3$var$Separator = function Separator(_ref) {
    var children = _ref.children;
    return /*#__PURE__*/ $5FkrB.createElement("span", {
        className: (0, $gKzKW.default)([
            $719ce0f2ce4e24d3$var$styles.separator
        ])
    }, children);
};
var $719ce0f2ce4e24d3$export$fbae5b5ffd8af05e = /*#__PURE__*/ (0, $5FkrB.memo)(/*#__PURE__*/ (0, $5FkrB.forwardRef)(function(_ref2, ref) {
    var as = _ref2.as, alignInline = _ref2.alignInline, _ref2$alignBlock = _ref2.alignBlock, alignItems = _ref2$alignBlock === void 0 ? 'start' : _ref2$alignBlock, _ref2$shouldWrap = _ref2.shouldWrap, shouldWrap = _ref2$shouldWrap === void 0 ? false : _ref2$shouldWrap, spread = _ref2.spread, grow = _ref2.grow, space = _ref2.space, rowSpace = _ref2.rowSpace, separator = _ref2.separator, xcss = _ref2.xcss, testId = _ref2.testId, role = _ref2.role, rawChildren = _ref2.children, ariaAttributes = (0, $74jTZ.default)(_ref2, $719ce0f2ce4e24d3$var$_excluded);
    var separatorComponent = typeof separator === 'string' ? /*#__PURE__*/ $5FkrB.createElement($719ce0f2ce4e24d3$var$Separator, null, separator) : separator;
    var children = separatorComponent ? (0, $5FkrB.Children).toArray(rawChildren).filter(Boolean).map(function(child, index) {
        return /*#__PURE__*/ $5FkrB.createElement((0, $5FkrB.Fragment), {
            key: index
        }, separator && index > 0 ? separatorComponent : null, child);
    }) : rawChildren;
    return /*#__PURE__*/ $5FkrB.createElement((0, $87d7e898dee4d9f1$export$f51f4c4ede09e011), (0, $d0778aa44ff9fe37$export$2e2bcd8739ae039)({}, ariaAttributes, {
        as: as,
        role: role,
        alignItems: alignItems,
        justifyContent: spread || alignInline,
        direction: "row",
        gap: space,
        rowGap: rowSpace,
        wrap: shouldWrap ? 'wrap' : undefined,
        xcss: (0, $b5cd78e10bc362b2$export$a274e22fb40f762e)(grow === 'hug' && $719ce0f2ce4e24d3$var$styles.hug, grow === 'fill' && $719ce0f2ce4e24d3$var$styles.fill, xcss),
        testId: testId,
        ref: ref
    }), children);
}));
$719ce0f2ce4e24d3$export$fbae5b5ffd8af05e.displayName = 'Inline';

/* stack.tsx generated by @compiled/babel-plugin v0.40.0 */ 

var $74jTZ = parcelRequire("74jTZ");

var $5FkrB = parcelRequire("5FkrB");



var $9a09eaae6de1b673$var$_excluded = [
    "as",
    "alignInline",
    "alignBlock",
    "spread",
    "grow",
    "space",
    "children",
    "testId",
    "xcss",
    "role"
];
var $9a09eaae6de1b673$var$styles = {
    hug: "_16jlidpf",
    fill: "_1bsb1osq _16jlkb7n"
};
var $9a09eaae6de1b673$export$694e0d28c7ffc90c = /*#__PURE__*/ (0, $5FkrB.memo)(/*#__PURE__*/ (0, $5FkrB.forwardRef)(function(_ref, ref) {
    var as = _ref.as, alignItems = _ref.alignInline, _ref$alignBlock = _ref.alignBlock, alignBlock = _ref$alignBlock === void 0 ? 'stretch' : _ref$alignBlock, spread = _ref.spread, grow = _ref.grow, space = _ref.space, children = _ref.children, testId = _ref.testId, xcss = _ref.xcss, role = _ref.role, ariaAttributes = (0, $74jTZ.default)(_ref, $9a09eaae6de1b673$var$_excluded);
    return /*#__PURE__*/ $5FkrB.createElement((0, $87d7e898dee4d9f1$export$f51f4c4ede09e011), (0, $d0778aa44ff9fe37$export$2e2bcd8739ae039)({}, ariaAttributes, {
        as: as,
        role: role,
        gap: space,
        direction: "column",
        alignItems: alignItems,
        justifyContent: spread || alignBlock,
        xcss: (0, $b5cd78e10bc362b2$export$a274e22fb40f762e)(grow === 'hug' && $9a09eaae6de1b673$var$styles.hug, grow === 'fill' && $9a09eaae6de1b673$var$styles.fill, xcss),
        testId: testId,
        ref: ref
    }), children);
}));
$9a09eaae6de1b673$export$694e0d28c7ffc90c.displayName = 'Stack';



var $jgyhF = parcelRequire("jgyhF");

var $5FkrB = parcelRequire("5FkrB");
var $5cb87c22f4243697$exports = {};
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::4b3613c7e18556761a1c0b5ad2c9a88f>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty($5cb87c22f4243697$exports, "__esModule", {
    value: true
});
$5cb87c22f4243697$exports.default = void 0;

var $5cb87c22f4243697$var$_react = $5cb87c22f4243697$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $5cb87c22f4243697$var$_baseNew = $5cb87c22f4243697$var$_interopRequireDefault((parcelRequire("8HikK")));
function $5cb87c22f4243697$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "StatusDiscovery".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for discovery statuses and messaging.
Filled status icons provide higher visual contrast to draw attention to important information.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $5cb87c22f4243697$var$StatusDiscoveryIcon = (props)=>/*#__PURE__*/ $5cb87c22f4243697$var$_react.default.createElement($5cb87c22f4243697$var$_baseNew.default, Object.assign({
        name: "StatusDiscoveryIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M10.5 15.06v-3.81a.75.75 0 0 1 .75-.75h3.81z"/><path fill="currentcolor" fill-rule="evenodd" d="M13 1a2 2 0 0 1 2 2v6h-4.75C9.56 9 9 9.56 9 10.25V15H3a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2zM4 9h3V7.5H4zm0-5v1.5h7V4z" clip-rule="evenodd"/>`
    }, props));
$5cb87c22f4243697$var$StatusDiscoveryIcon.displayName = 'StatusDiscoveryIcon';
var $5cb87c22f4243697$var$_default = $5cb87c22f4243697$exports.default = $5cb87c22f4243697$var$StatusDiscoveryIcon;


var $36527535e5aeac16$exports = {};
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3f93f06e22108e36edaead143b4f646b>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty($36527535e5aeac16$exports, "__esModule", {
    value: true
});
$36527535e5aeac16$exports.default = void 0;

var $36527535e5aeac16$var$_react = $36527535e5aeac16$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $36527535e5aeac16$var$_baseNew = $36527535e5aeac16$var$_interopRequireDefault((parcelRequire("8HikK")));
function $36527535e5aeac16$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "StatusError".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for error statuses and messaging.
Filled status icons provide higher visual contrast to draw attention to important information.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $36527535e5aeac16$var$StatusErrorIcon = (props)=>/*#__PURE__*/ $36527535e5aeac16$var$_react.default.createElement($36527535e5aeac16$var$_baseNew.default, Object.assign({
        name: "StatusErrorIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6.586.603a2 2 0 0 1 2.828 0l5.983 5.983a2 2 0 0 1 0 2.828l-5.983 5.982a2 2 0 0 1-2.828 0L.604 9.414a2 2 0 0 1 0-2.828zM8 10.25a1 1 0 1 0 0 2 1 1 0 0 0 0-2m-.75-6.5V9h1.5V3.75z" clip-rule="evenodd"/>`
    }, props));
$36527535e5aeac16$var$StatusErrorIcon.displayName = 'StatusErrorIcon';
var $36527535e5aeac16$var$_default = $36527535e5aeac16$exports.default = $36527535e5aeac16$var$StatusErrorIcon;


var $373170da76267fe0$exports = {};
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::456639fbdc991aefe1af05acf697365d>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty($373170da76267fe0$exports, "__esModule", {
    value: true
});
$373170da76267fe0$exports.default = void 0;

var $373170da76267fe0$var$_react = $373170da76267fe0$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $373170da76267fe0$var$_baseNew = $373170da76267fe0$var$_interopRequireDefault((parcelRequire("8HikK")));
function $373170da76267fe0$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "StatusInformation".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for information statuses and messaging. 
Filled status icons provide higher visual contrast to draw attention to important information.
For information tooltips, use the unfilled 'information circle' icon.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $373170da76267fe0$var$StatusInformationIcon = (props)=>/*#__PURE__*/ $373170da76267fe0$var$_react.default.createElement($373170da76267fe0$var$_baseNew.default, Object.assign({
        name: "StatusInformationIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0M6.5 6.75v1.5h.75v4.25h1.5v-5A.75.75 0 0 0 8 6.75zM8 3.5a1 1 0 1 0 0 2 1 1 0 0 0 0-2" clip-rule="evenodd"/>`
    }, props));
$373170da76267fe0$var$StatusInformationIcon.displayName = 'StatusInformationIcon';
var $373170da76267fe0$var$_default = $373170da76267fe0$exports.default = $373170da76267fe0$var$StatusInformationIcon;


var $788f3d8639ed25b2$exports = {};
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::174472a7e38932dc7a97866e0be8034a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty($788f3d8639ed25b2$exports, "__esModule", {
    value: true
});
$788f3d8639ed25b2$exports.default = void 0;

var $788f3d8639ed25b2$var$_react = $788f3d8639ed25b2$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $788f3d8639ed25b2$var$_baseNew = $788f3d8639ed25b2$var$_interopRequireDefault((parcelRequire("8HikK")));
function $788f3d8639ed25b2$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "StatusSuccess".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for success statuses and messaging. Filled status icons provide higher visual contrast to draw attention to important information.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $788f3d8639ed25b2$var$StatusSuccessIcon = (props)=>/*#__PURE__*/ $788f3d8639ed25b2$var$_react.default.createElement($788f3d8639ed25b2$var$_baseNew.default, Object.assign({
        name: "StatusSuccessIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0M6.75 9.828 4.826 7.52l-1.152.96 2.5 3a.75.75 0 0 0 1.152 0l5-6-1.152-.96z" clip-rule="evenodd"/>`
    }, props));
$788f3d8639ed25b2$var$StatusSuccessIcon.displayName = 'StatusSuccessIcon';
var $788f3d8639ed25b2$var$_default = $788f3d8639ed25b2$exports.default = $788f3d8639ed25b2$var$StatusSuccessIcon;


var $184be8ed7704fb9e$exports = {};
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2ee7b3f114c675eea0f953c33a485bcf>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty($184be8ed7704fb9e$exports, "__esModule", {
    value: true
});
$184be8ed7704fb9e$exports.default = void 0;

var $184be8ed7704fb9e$var$_react = $184be8ed7704fb9e$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $184be8ed7704fb9e$var$_baseNew = $184be8ed7704fb9e$var$_interopRequireDefault((parcelRequire("8HikK")));
function $184be8ed7704fb9e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "StatusWarning".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for warning statuses.
Filled status icons provide higher visual contrast to draw attention to important information.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $184be8ed7704fb9e$var$StatusWarningIcon = (props)=>/*#__PURE__*/ $184be8ed7704fb9e$var$_react.default.createElement($184be8ed7704fb9e$var$_baseNew.default, Object.assign({
        name: "StatusWarningIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6.242 1.168c.756-1.395 2.76-1.395 3.516 0l5.9 10.878c.723 1.333-.242 2.953-1.758 2.953H2.1C.584 15-.38 13.38.342 12.046zM8 10.75a1 1 0 1 0 0 2.001 1 1 0 0 0 0-2M7.25 4.5v5h1.5v-5z" clip-rule="evenodd"/>`
    }, props));
$184be8ed7704fb9e$var$StatusWarningIcon.displayName = 'StatusWarningIcon';
var $184be8ed7704fb9e$var$_default = $184be8ed7704fb9e$exports.default = $184be8ed7704fb9e$var$StatusWarningIcon;


function $321e0bf4d8386b43$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $321e0bf4d8386b43$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $321e0bf4d8386b43$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $jgyhF.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $321e0bf4d8386b43$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $321e0bf4d8386b43$var$appearanceIconSchema = {
    information: {
        backgroundColor: "var(--ds-background-information, #E9F2FE)",
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($373170da76267fe0$exports))),
        primaryIconColor: "var(--ds-icon-information, #357DE8)"
    },
    warning: {
        backgroundColor: "var(--ds-background-warning, #FFF5DB)",
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($184be8ed7704fb9e$exports))),
        primaryIconColor: "var(--ds-icon-warning, #E06C00)"
    },
    error: {
        backgroundColor: "var(--ds-background-danger, #FFECEB)",
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($36527535e5aeac16$exports))),
        primaryIconColor: "var(--ds-icon-danger, #C9372C)"
    },
    success: {
        backgroundColor: "var(--ds-background-success, #EFFFD6)",
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($788f3d8639ed25b2$exports))),
        primaryIconColor: "var(--ds-icon-success, #6A9A23)"
    },
    discovery: {
        backgroundColor: "var(--ds-background-discovery, #F8EEFE)",
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($5cb87c22f4243697$exports))),
        primaryIconColor: "var(--ds-icon-discovery, #AF59E1)"
    }
};
function $321e0bf4d8386b43$export$e9b82d2e21ac0c1f(appearance, icon) {
    var appearanceIconStyles = $321e0bf4d8386b43$var$appearanceIconSchema[appearance] || $321e0bf4d8386b43$var$appearanceIconSchema.information;
    var AppearanceIcon = function AppearanceIcon(_ref) {
        var primaryColor = _ref.primaryColor;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(appearanceIconStyles.Icon, {
            color: primaryColor,
            spacing: "spacious",
            label: appearance
        });
    };
    var Icon = icon || AppearanceIcon;
    return $321e0bf4d8386b43$var$_objectSpread($321e0bf4d8386b43$var$_objectSpread({}, appearanceIconStyles), {}, {
        Icon: Icon
    });
}


var $ac2404b057b8688e$var$sectionMessageStyles = {
    container: "_2rko12b0 _1rjcpxbi _18zrpxbi _1nmz1hna",
    containerT26Shape: "_2rko1mok",
    iconContainer: "_1mou1i6y _1e0c1txw",
    contentContainer: "_16jlkb7n",
    content: "_11c8fhey _syazi7uo",
    actionsContainer: "_11c8fhey",
    dismissButtonContainer: "_1pfh1i6y"
};
var $ac2404b057b8688e$var$appearanceStyles = {
    information: "_bfhk19ip",
    warning: "_bfhk1917",
    error: "_bfhk1gly",
    success: "_bfhk1y9u",
    discovery: "_bfhk6vm6"
};
/**
 * __Section message__
 *
 * A section message is used to alert users to a particular section of the screen.
 *
 * - [Examples](https://atlassian.design/components/section-message/examples)
 * - [Code](https://atlassian.design/components/section-message/code)
 * - [Usage](https://atlassian.design/components/section-message/usage)
 */ var $ac2404b057b8688e$var$SectionMessage = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function SectionMessage(_ref, ref) {
    var children = _ref.children, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'information' : _ref$appearance, actions = _ref.actions, title = _ref.title, _ref$headingLevel = _ref.headingLevel, headingLevel = _ref$headingLevel === void 0 ? 'h2' : _ref$headingLevel, icon = _ref.icon, isDismissible = _ref.isDismissible, onDismiss = _ref.onDismiss, testId = _ref.testId;
    var _useState = (0, $5FkrB.useState)(false), _useState2 = (0, $amAaq.default)(_useState, 2), dismissed = _useState2[0], setDismissed = _useState2[1];
    var handleDismiss = (0, $5FkrB.useCallback)(function() {
        onDismiss === null || onDismiss === void 0 || onDismiss();
        setDismissed(true);
    }, [
        onDismiss
    ]);
    var _getAppearanceIconSty = (0, $321e0bf4d8386b43$export$e9b82d2e21ac0c1f)(appearance, icon), primaryColor = _getAppearanceIconSty.primaryIconColor, secondaryColor = _getAppearanceIconSty.backgroundColor, Icon = _getAppearanceIconSty.Icon;
    var actionElements = actions && actions.type === (0, $5FkrB.Fragment) ? actions.props.children : actions;
    var actionsArray = (0, $5FkrB.Children).toArray(actionElements);
    return isDismissible && dismissed ? null : /*#__PURE__*/ $5FkrB.createElement("section", {
        "data-testid": testId,
        ref: ref,
        className: (0, $gKzKW.default)([
            $ac2404b057b8688e$var$sectionMessageStyles.container,
            (0, $2fcbb5e4cf9206d1$export$b40ec24ac8275656)('platform-dst-shape-theme-default') && $ac2404b057b8688e$var$sectionMessageStyles.containerT26Shape,
            $ac2404b057b8688e$var$appearanceStyles[appearance]
        ])
    }, /*#__PURE__*/ $5FkrB.createElement((0, $719ce0f2ce4e24d3$export$fbae5b5ffd8af05e), {
        space: "space.200",
        alignBlock: "stretch"
    }, /*#__PURE__*/ $5FkrB.createElement("div", {
        className: (0, $gKzKW.default)([
            $ac2404b057b8688e$var$sectionMessageStyles.iconContainer
        ])
    }, /*#__PURE__*/ $5FkrB.createElement(Icon, {
        size: "medium",
        primaryColor: primaryColor,
        secondaryColor: secondaryColor,
        color: primaryColor,
        spacing: "spacious"
    })), /*#__PURE__*/ $5FkrB.createElement((0, $9a09eaae6de1b673$export$694e0d28c7ffc90c), {
        space: "space.100",
        testId: testId && "".concat(testId, "--content"),
        xcss: $ac2404b057b8688e$var$sectionMessageStyles.contentContainer
    }, !!title && /*#__PURE__*/ $5FkrB.createElement((0, $3125392203c599f4$export$2e2bcd8739ae039), {
        as: headingLevel,
        size: "small"
    }, title), /*#__PURE__*/ $5FkrB.createElement("div", {
        className: (0, $gKzKW.default)([
            $ac2404b057b8688e$var$sectionMessageStyles.content
        ])
    }, children), actionsArray.length > 0 && /*#__PURE__*/ $5FkrB.createElement((0, $719ce0f2ce4e24d3$export$fbae5b5ffd8af05e), {
        shouldWrap: true,
        testId: testId && "".concat(testId, "--actions"),
        separator: "\xB7",
        space: "space.100",
        rowSpace: "space.0",
        role: actionsArray.length > 1 ? 'list' : undefined,
        xcss: $ac2404b057b8688e$var$sectionMessageStyles.actionsContainer
    }, actionsArray.map(function(action, id) {
        return(/*#__PURE__*/ // Only use a listitem role if more than one action is present
        $5FkrB.createElement((0, $719ce0f2ce4e24d3$export$fbae5b5ffd8af05e), {
            role: actionsArray.length > 1 ? 'listitem' : undefined,
            key: id
        }, action));
    }))), isDismissible && /*#__PURE__*/ $5FkrB.createElement("div", {
        className: (0, $gKzKW.default)([
            $ac2404b057b8688e$var$sectionMessageStyles.dismissButtonContainer
        ])
    }, /*#__PURE__*/ $5FkrB.createElement((0, $00ca4e839c919457$export$2e2bcd8739ae039), {
        testId: testId && "".concat(testId, "--dismiss-button"),
        label: "Dismiss",
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($c9fbc4ca33451d4e$exports))),
        appearance: "subtle",
        onClick: handleDismiss,
        spacing: "compact"
    }))));
});
$ac2404b057b8688e$var$SectionMessage.displayName = 'SectionMessage';
var $ac2404b057b8688e$export$2e2bcd8739ae039 = $ac2404b057b8688e$var$SectionMessage;

/* section-message-action.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $5FkrB = parcelRequire("5FkrB");

var $gKzKW = parcelRequire("gKzKW");


var $amAaq = parcelRequire("amAaq");

var $74jTZ = parcelRequire("74jTZ");

var $5FkrB = parcelRequire("5FkrB");



var $74jTZ = parcelRequire("74jTZ");

var $5FkrB = parcelRequire("5FkrB");

var $2nBsU = parcelRequire("2nBsU");



/**
 * @jsxRuntime classic
 * @jsx jsx
 */ /* eslint-disable @repo/internal/deprecations/deprecation-ticket-required -- LENS1-245 tracks @atlaskit/focus-ring deprecation. */ 
var $5FkrB = parcelRequire("5FkrB");

var $2nBsU = parcelRequire("2nBsU");
var $ca6b552753d60c9a$var$BORDER_WIDTH = 2;
var $ca6b552753d60c9a$var$baseFocusOutsideStyles = (0, $2nBsU.css)({
    outline: "var(--ds-border-width-focused, 2px)".concat(" solid ", "var(--ds-border-focused, #4688EC)"),
    outlineOffset: $ca6b552753d60c9a$var$BORDER_WIDTH
});
var $ca6b552753d60c9a$var$baseInsetStyles = (0, $2nBsU.css)({
    outlineColor: "var(--ds-border-focused, #4688EC)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    outlineOffset: -$ca6b552753d60c9a$var$BORDER_WIDTH,
    outlineStyle: 'solid',
    outlineWidth: "var(--ds-border-width-focused, 2px)"
});
var $ca6b552753d60c9a$var$focusRingStyles = (0, $2nBsU.css)({
    // Focus styles used when :focus-visible isn't supported
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
    '&:focus': $ca6b552753d60c9a$var$baseFocusOutsideStyles,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
    '&:focus-visible': $ca6b552753d60c9a$var$baseFocusOutsideStyles,
    // Remove default focus styles for mouse interactions if :focus-visible is supported
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
    '&:focus:not(:focus-visible)': {
        outline: 'none'
    },
    '@media screen and (forced-colors: active), screen and (-ms-high-contrast: active)': {
        '&:focus-visible': {
            outline: "var(--ds-border-width, 1px)".concat(" solid")
        }
    }
});
var $ca6b552753d60c9a$var$insetFocusRingStyles = (0, $2nBsU.css)({
    // Focus styles used when :focus-visible isn't supported
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
    '&:focus': $ca6b552753d60c9a$var$baseInsetStyles,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
    '&:focus-visible': $ca6b552753d60c9a$var$baseInsetStyles,
    // Remove default focus styles for mouse interactions if :focus-visible is supported
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
    '&:focus:not(:focus-visible)': {
        outline: 'none'
    },
    '@media screen and (forced-colors: active), screen and (-ms-high-contrast: active)': {
        '&:focus-visible': {
            outline: "var(--ds-border-width, 1px)".concat(" solid"),
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
            outlineOffset: '-1px'
        }
    }
});
/**
 * __Focus ring__
 *
 * A focus ring visually indicates the currently focused item.
 *
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/focus-ring)
 *
 * @example
 * ```jsx
 * import FocusRing from '@atlaskit/focus-ring';
 *
 * const InteractiveComponent = () => (
 *   <FocusRing>
 *     <button type="button">Hello</button>
 *   </FocusRing>
 * )
 * ```
 *
 * @deprecated FocusRing is deprecated. Use Focusable from @atlaskit/primitives/compiled/focusable instead.
 */ var $ca6b552753d60c9a$var$FocusRing = /*#__PURE__*/ (0, $5FkrB.memo)(function(_ref) {
    var children = _ref.children, isInset = _ref.isInset, focus = _ref.focus;
    var controlledStyles = isInset ? $ca6b552753d60c9a$var$baseInsetStyles : $ca6b552753d60c9a$var$baseFocusOutsideStyles;
    var uncontrolledStyles = isInset ? $ca6b552753d60c9a$var$insetFocusRingStyles : $ca6b552753d60c9a$var$focusRingStyles;
    var focusCls = typeof focus === 'undefined' ? uncontrolledStyles : focus === 'on' && controlledStyles;
    return (0, $2nBsU.jsx)((0, $2nBsU.ClassNames), null, function(_ref2) {
        var css = _ref2.css, cx = _ref2.cx;
        return (0, $5FkrB.Children).only(// This may look unwieldy but means we skip applying styles / cloning if no className is applicable
        focusCls ? /*#__PURE__*/ // eslint-disable-next-line @repo/internal/react/no-clone-element
        (0, $5FkrB.cloneElement)(children, {
            className: cx([
                css(focusCls),
                children.props.className
            ])
        }) : children);
    });
});
$ca6b552753d60c9a$var$FocusRing.displayName = 'FocusRing';
var $ca6b552753d60c9a$export$2e2bcd8739ae039 = $ca6b552753d60c9a$var$FocusRing;



function $021d24840bd9d15c$var$abort(event) {
    event.preventDefault();
    event.stopPropagation();
}
var $021d24840bd9d15c$var$tabKeyCode = 9;
function $021d24840bd9d15c$var$onKey(event) {
    // Allowing tab so that a user can move focus away
    if (event.keyCode === $021d24840bd9d15c$var$tabKeyCode) return;
    $021d24840bd9d15c$var$abort(event);
}
var $021d24840bd9d15c$var$block = {
    onMouseDownCapture: $021d24840bd9d15c$var$abort,
    onMouseUpCapture: $021d24840bd9d15c$var$abort,
    // because we have tabIndex = -1 when disabled,
    // keyboard events can only occur when there is an overlay
    onKeyDownCapture: $021d24840bd9d15c$var$onKey,
    onKeyUpCapture: $021d24840bd9d15c$var$onKey,
    onTouchStartCapture: $021d24840bd9d15c$var$abort,
    onTouchEndCapture: $021d24840bd9d15c$var$abort,
    onPointerDownCapture: $021d24840bd9d15c$var$abort,
    onPointerUpCapture: $021d24840bd9d15c$var$abort,
    onClickCapture: $021d24840bd9d15c$var$abort,
    // Just smashing the existing onClick for good measure
    onClick: $021d24840bd9d15c$var$abort
};
var $021d24840bd9d15c$var$doNotBlock = {};
function $021d24840bd9d15c$export$2e2bcd8739ae039(_ref) {
    var isInteractive = _ref.isInteractive;
    return isInteractive ? $021d24840bd9d15c$var$doNotBlock : $021d24840bd9d15c$var$block;
}


// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $2nBsU = parcelRequire("2nBsU");
function $111c9f2402df83ae$export$7ad0316cc0dd65a(_ref) {
    var spacing = _ref.spacing;
    return (0, $2nBsU.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        margin: spacing === 'none' ? 0 : '0 2px',
        // content can grow and shrink
        flexGrow: 1,
        flexShrink: 1,
        // ellipsis for overflow text
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap'
    });
}


// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $2nBsU = parcelRequire("2nBsU");
function $01ebcbcdc8a8c185$export$1b5827d324e945b1(_ref) {
    var hasOverlay = _ref.hasOverlay;
    return (0, $2nBsU.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        opacity: hasOverlay ? 0 : 1,
        transition: 'opacity 0.3s'
    });
}


// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $2nBsU = parcelRequire("2nBsU");
function $e0afe2384d0ee452$export$864eea3f4ec3368f(_ref) {
    var spacing = _ref.spacing;
    return (0, $2nBsU.css)({
        display: 'flex',
        // icon size cannot grow and shrink
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        margin: spacing === 'none' ? 0 : "0 2px",
        flexGrow: 0,
        flexShrink: 0,
        alignSelf: 'center',
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        fontSize: 0,
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        lineHeight: 0,
        userSelect: 'none'
    });
}



var $5FkrB = parcelRequire("5FkrB");

var $0f8fdda3fb25763e$export$20bbd2efb0d734c4 = function getIfVisuallyHiddenChildren(children) {
    return children && /*#__PURE__*/ (0, $5FkrB.isValidElement)(children) && children.type === (0, $3fb4db4d25367976$export$2e2bcd8739ae039);
};


// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
var $2315f5f1e9edc129$export$1a9fe1b84c876bb5 = {
    // stretching to full width / height of button
    // this is important as we need it to still block
    // event if clicking in the button's own padding
    position: 'absolute',
    left: 0,
    top: 0,
    right: 0,
    bottom: 0,
    // Putting all children in the center
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
};


var $284f71d3e3220e16$var$_excluded = [
    "analyticsContext",
    "appearance",
    "autoFocus",
    "buttonCss",
    "children",
    "className",
    "href",
    "component",
    "iconAfter",
    "iconBefore",
    "interactionName",
    "isDisabled",
    "isSelected",
    "onBlur",
    "onClick",
    "onFocus",
    "onMouseDown",
    "overlay",
    "shouldFitContainer",
    "spacing",
    "tabIndex",
    "type",
    "testId"
];
// Disabled buttons will still publish events for nested elements in webkit.
// We are disabling pointer events on child elements so that
// the button will always be the target of events
// Note: firefox does not have this behaviour for child elements
var $284f71d3e3220e16$var$noPointerEventsOnChildrenCss = {
    '> *': {
        pointerEvents: 'none'
    }
};
/**
 * These CSS variables consumed by the new icons, to allow them to have appropriate
 * padding inside Button while also maintaining spacing for the existing icons.
 *
 * These styles can be removed once the new icons are fully rolled out
 * and we bump Button to set padding based on the new icons.
 */ var $284f71d3e3220e16$var$iconBeforeSpacingFixStyle = (0, $2nBsU.css)({
    '--ds--button--new-icon-padding-end': "var(--ds-space-025, 2px)",
    '--ds--button--new-icon-padding-start': "var(--ds-space-050, 4px)",
    marginInlineStart: "var(--ds-space-negative-025, -2px)"
});
var $284f71d3e3220e16$var$iconAfterSpacingFixStyle = (0, $2nBsU.css)({
    '--ds--button--new-icon-padding-end': "var(--ds-space-050, 4px)",
    '--ds--button--new-icon-padding-start': "var(--ds-space-025, 2px)",
    marginInlineEnd: "var(--ds-space-negative-025, -2px)"
});
var $284f71d3e3220e16$var$getSpacingFix = function getSpacingFix(children, spacingStyles) {
    if (!children || (0, $0f8fdda3fb25763e$export$20bbd2efb0d734c4)(children)) return null;
    return spacingStyles;
};
var $284f71d3e3220e16$var$getChildren = function getChildren(children, childrenStyles) {
    if ((0, $0f8fdda3fb25763e$export$20bbd2efb0d734c4)(children)) return children;
    return children ? (0, $2nBsU.jsx)("span", {
        css: childrenStyles
    }, children) : null;
};
var $284f71d3e3220e16$var$ButtonBase = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).forwardRef(function ButtonBase(props, ref) {
    var analyticsContext = props.analyticsContext, _props$appearance = props.appearance, appearance = _props$appearance === void 0 ? 'default' : _props$appearance, _props$autoFocus = props.autoFocus, autoFocus = _props$autoFocus === void 0 ? false : _props$autoFocus, buttonCss = props.buttonCss, children = props.children, className = props.className, href = props.href, _props$component = props.component, Component = _props$component === void 0 ? href ? 'a' : 'button' : _props$component, iconAfter = props.iconAfter, iconBefore = props.iconBefore, interactionName = props.interactionName, _props$isDisabled = props.isDisabled, isDisabled = _props$isDisabled === void 0 ? false : _props$isDisabled, _props$isSelected = props.isSelected, isSelected = _props$isSelected === void 0 ? false : _props$isSelected, onBlur = props.onBlur, _props$onClick = props.onClick, providedOnClick = _props$onClick === void 0 ? (0, $adcefb868cf2fc9d$export$2e2bcd8739ae039) : _props$onClick, onFocus = props.onFocus, _props$onMouseDown = props.onMouseDown, providedOnMouseDown = _props$onMouseDown === void 0 ? (0, $adcefb868cf2fc9d$export$2e2bcd8739ae039) : _props$onMouseDown, overlay = props.overlay, shouldFitContainer = props.shouldFitContainer, _props$spacing = props.spacing, spacing = _props$spacing === void 0 ? 'default' : _props$spacing, _props$tabIndex = props.tabIndex, tabIndex = _props$tabIndex === void 0 ? 0 : _props$tabIndex, _props$type = props.type, type = _props$type === void 0 ? !href ? 'button' : undefined : _props$type, testId = props.testId, rest = (0, $74jTZ.default)(props, $284f71d3e3220e16$var$_excluded);
    var ourRef = (0, $5FkrB.useRef)();
    var setRef = (0, $5FkrB.useCallback)(function(node) {
        ourRef.current = node;
        if (ref == null) return;
        if (typeof ref === 'function') {
            ref(node);
            return;
        }
        // We can write to ref's `current` property, but Typescript does not like it.
        // @ts-ignore
        ref.current = node;
    }, [
        ourRef,
        ref
    ]);
    // Cross browser auto focusing is pretty broken, so we are doing it ourselves
    (0, $bf3b13d9d73de104$export$2e2bcd8739ae039)(ourRef, autoFocus);
    var interactionContext = (0, $5FkrB.useContext)((0, $a81fd7e45a8c2ef5$export$2e2bcd8739ae039));
    var handleClick = (0, $5FkrB.useCallback)(function(e, analyticsEvent) {
        interactionContext && interactionContext.tracePress(interactionName, e.timeStamp);
        providedOnClick(e, analyticsEvent);
    }, [
        providedOnClick,
        interactionContext,
        interactionName
    ]);
    var onClick = (0, $75b909bb27e39354$export$a4687b0234b40e28)({
        fn: handleClick,
        action: 'clicked',
        componentName: 'button',
        packageName: "@atlaskit/button",
        packageVersion: "24.3.9",
        analyticsData: analyticsContext
    });
    // Button currently calls preventDefault, which is not standard button behaviour
    var onMouseDown = (0, $5FkrB.useCallback)(function(event) {
        event.preventDefault();
        providedOnMouseDown(event);
    }, [
        providedOnMouseDown
    ]);
    // Lose focus when becoming disabled (standard button behaviour)
    (0, $5FkrB.useEffect)(function() {
        var el = ourRef.current;
        if (isDisabled && el && el === document.activeElement) el.blur();
    }, [
        isDisabled
    ]);
    // we are 'disabling' input with a button when there is an overlay
    var hasOverlay = Boolean(overlay);
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    var fadeStyles = (0, $2nBsU.css)((0, $01ebcbcdc8a8c185$export$1b5827d324e945b1)({
        hasOverlay: hasOverlay
    }));
    var isInteractive = !isDisabled && !hasOverlay;
    /**
   * HACK: Spinner needs to have different colours in the "new" tokens design compared to the old design.
   * For now, while we support both, these styles reach into Spinner when a theme is set, applies the right color.
   * Ticket to remove: https://product-fabric.atlassian.net/browse/DSP-2067.
   */ var spinnerHackCss = {};
    if (isSelected || isDisabled || appearance === 'warning') spinnerHackCss = {
        '[data-theme] & circle': {
            stroke: "".concat(isSelected || isDisabled ? "var(--ds-icon-subtle, #505258)" : "var(--ds-icon-warning-inverse, #292A2E)", " !important")
        }
    };
    return (0, $2nBsU.jsx)((0, $ca6b552753d60c9a$export$2e2bcd8739ae039), null, (0, $2nBsU.jsx)(Component, (0, $d0778aa44ff9fe37$export$2e2bcd8739ae039)({}, rest, {
        ref: setRef,
        className: className,
        css: [
            buttonCss,
            isInteractive ? null : $284f71d3e3220e16$var$noPointerEventsOnChildrenCss
        ],
        "data-has-overlay": hasOverlay ? true : undefined,
        "data-testid": testId,
        disabled: isDisabled,
        href: isInteractive ? href : undefined,
        onBlur: onBlur,
        onClick: onClick,
        onFocus: onFocus,
        onMouseDown: onMouseDown,
        tabIndex: isDisabled ? -1 : tabIndex,
        type: type
    }, (0, $021d24840bd9d15c$export$2e2bcd8739ae039)({
        isInteractive: isInteractive
    })), iconBefore ? (0, $2nBsU.jsx)("span", {
        css: [
            fadeStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $e0afe2384d0ee452$export$864eea3f4ec3368f)({
                spacing: spacing
            }),
            $284f71d3e3220e16$var$getSpacingFix(children, $284f71d3e3220e16$var$iconBeforeSpacingFixStyle)
        ]
    }, iconBefore) : null, $284f71d3e3220e16$var$getChildren(children, [
        fadeStyles,
        (0, $111c9f2402df83ae$export$7ad0316cc0dd65a)({
            spacing: spacing
        })
    ]), iconAfter ? (0, $2nBsU.jsx)("span", {
        css: [
            fadeStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $e0afe2384d0ee452$export$864eea3f4ec3368f)({
                spacing: spacing
            }),
            $284f71d3e3220e16$var$getSpacingFix(children, $284f71d3e3220e16$var$iconAfterSpacingFixStyle)
        ]
    }, iconAfter) : null, overlay ? (0, $2nBsU.jsx)("span", {
        css: [
            (0, $2315f5f1e9edc129$export$1a9fe1b84c876bb5),
            spinnerHackCss
        ]
    }, overlay) : null));
});
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$284f71d3e3220e16$export$2e2bcd8739ae039 = $284f71d3e3220e16$var$ButtonBase;



var $jgyhF = parcelRequire("jgyhF");

function $838f151bfdeb423e$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $838f151bfdeb423e$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $838f151bfdeb423e$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $jgyhF.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $838f151bfdeb423e$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $838f151bfdeb423e$var$gridSize = 8;
var $838f151bfdeb423e$var$HAS_DISABLED_BACKGROUND = [
    'default',
    'primary',
    'danger',
    'warning'
];
var $838f151bfdeb423e$var$heights = {
    default: "".concat(32 / 14, "em"),
    // 32px
    compact: "".concat(24 / 14, "em"),
    none: 'auto'
};
var $838f151bfdeb423e$var$lineHeights = {
    default: $838f151bfdeb423e$var$heights.default,
    compact: $838f151bfdeb423e$var$heights.compact,
    none: 'inherit'
};
var $838f151bfdeb423e$var$padding = {
    // 10px gutter
    default: "0 ".concat($838f151bfdeb423e$var$gridSize + $838f151bfdeb423e$var$gridSize / 4, "px"),
    compact: "0 ".concat($838f151bfdeb423e$var$gridSize + $838f151bfdeb423e$var$gridSize / 4, "px"),
    none: '0'
};
var $838f151bfdeb423e$var$singleIconPadding = {
    // 2px gutter
    compact: "0 ".concat($838f151bfdeb423e$var$gridSize / 4, "px"),
    default: "0 ".concat($838f151bfdeb423e$var$gridSize / 4, "px"),
    none: '0'
};
var $838f151bfdeb423e$var$verticalAlign = {
    default: 'middle',
    compact: 'middle',
    none: 'baseline'
};
var $838f151bfdeb423e$var$defaultAfterStyles = {
    borderRadius: 'inherit',
    inset: "var(--ds-space-0, 0px)",
    borderStyle: 'solid',
    borderWidth: "var(--ds-border-width, 1px)",
    pointerEvents: 'none',
    position: 'absolute'
};
var $838f151bfdeb423e$var$defaultStyles = {
    background: "var(--ds-background-neutral-subtle, #00000000)",
    color: "var(--ds-text, #292A2E)",
    '&::after': $838f151bfdeb423e$var$_objectSpread($838f151bfdeb423e$var$_objectSpread({}, $838f151bfdeb423e$var$defaultAfterStyles), {}, {
        content: '""',
        borderColor: "var(--ds-border, #0B120E24)"
    }),
    '&:hover': {
        background: "var(--ds-background-neutral-hovered, #0B120E24)"
    },
    '&:active': {
        background: "var(--ds-background-neutral-pressed, #080F214A)"
    },
    '&[data-has-overlay="true"]:not([disabled]):hover': {
        background: "var(--ds-background-neutral-subtle, #00000000)"
    },
    '&:disabled[disabled]': {
        background: "var(--ds-background-neutral-subtle, #00000000)"
    },
    '&:disabled[disabled]:hover': {
        background: "var(--ds-background-neutral-subtle, #00000000)"
    },
    '&:disabled[disabled]:active': {
        background: "var(--ds-background-neutral-subtle, #00000000)"
    }
};
var $838f151bfdeb423e$var$primaryStyles = {
    background: "var(--ds-background-brand-bold, #1868DB)",
    color: "var(--ds-text-inverse, #FFFFFF)",
    '&:hover': {
        background: "var(--ds-background-brand-bold-hovered, #1558BC)"
    },
    '&:active': {
        background: "var(--ds-background-brand-bold-pressed, #144794)"
    },
    '&[data-has-overlay="true"]:not([disabled]):hover': {
        background: "var(--ds-background-brand-bold, #1868DB)"
    }
};
var $838f151bfdeb423e$var$linkStyles = {
    background: 'transparent',
    color: "var(--ds-link, #1868DB)",
    '&:hover': {
        color: "var(--ds-link, #1868DB)",
        textDecoration: 'underline'
    },
    '&:active': {
        color: "var(--ds-link-pressed, #1558BC)",
        textDecoration: 'underline'
    }
};
var $838f151bfdeb423e$var$subtleStyles = {
    background: 'transparent',
    color: "var(--ds-text-subtle, #505258)",
    '&:hover': {
        background: "var(--ds-background-neutral-subtle-hovered, #0515240F)"
    },
    '&:active': {
        background: "var(--ds-background-neutral-subtle-pressed, #0B120E24)"
    },
    '&[data-has-overlay="true"]:not([disabled]):hover': {
        background: 'transparent'
    }
};
var $838f151bfdeb423e$var$subtleLinkStyles = {
    background: 'transparent',
    color: "var(--ds-text-subtle, #505258)",
    '&:hover': {
        background: 'transparent',
        color: "var(--ds-text-subtle, #505258)",
        textDecoration: 'underline'
    },
    '&:active': {
        background: 'transparent',
        color: "var(--ds-text, #292A2E)",
        textDecoration: 'underline'
    }
};
var $838f151bfdeb423e$var$warningStyles = {
    background: "var(--ds-background-warning-bold, #FBC828)",
    color: "var(--ds-text-warning-inverse, #292A2E)",
    '&:hover': {
        background: "var(--ds-background-warning-bold-hovered, #FCA700)"
    },
    '&:active': {
        background: "var(--ds-background-warning-bold-pressed, #F68909)"
    },
    '&[data-has-overlay="true"]:not([disabled]):hover': {
        background: "var(--ds-background-warning-bold, #FBC828)"
    }
};
var $838f151bfdeb423e$var$dangerStyles = {
    background: "var(--ds-background-danger-bold, #C9372C)",
    color: "var(--ds-text-inverse, #FFFFFF)",
    '&:hover': {
        background: "var(--ds-background-danger-bold-hovered, #AE2E24)"
    },
    '&:active': {
        background: "var(--ds-background-danger-bold-pressed, #872821)"
    },
    '&[data-has-overlay="true"]:not([disabled]):hover': {
        background: "var(--ds-background-danger-bold, #C9372C)"
    }
};
var $838f151bfdeb423e$var$selectedStyles = {
    background: "var(--ds-background-selected, #E9F2FE)",
    color: "var(--ds-text-selected, #1868DB)",
    '&:not([disabled])::after': $838f151bfdeb423e$var$_objectSpread($838f151bfdeb423e$var$_objectSpread({}, $838f151bfdeb423e$var$defaultAfterStyles), {}, {
        content: '""',
        borderColor: "var(--ds-border-selected, #1868DB)"
    })
};
/**
 * Anchor-text-color variants applied when the legacy `Button` is rendered as
 * an `<a>` (via `href`). Each `<variant>WithAnchorTextColorStyles` is a
 * self-contained appearance object that adds explicit `color` /
 * `text-decoration` on the base, `:hover`, and `:active` states, preventing
 * browser default or ambient anchor styles from overriding the button's
 * intended text color or adding an unwanted underline.
 *
 * Gated by `platform-dst-legacy-button-anchor-text-color` and used *instead*
 * of the base `<variant>Styles`. When cleaning up the gate: delete the base
 * `<variant>Styles` and rename the `WithAnchorTextColor` variant to replace
 * it.
 *
 * Link-like variants (`link`, `subtle-link`) keep their intentional underline
 * on `:hover` / `:active`.
 */ var $838f151bfdeb423e$var$defaultWithAnchorTextColorStyles = $838f151bfdeb423e$var$_objectSpread($838f151bfdeb423e$var$_objectSpread({}, $838f151bfdeb423e$var$defaultStyles), {}, {
    textDecoration: 'none',
    '&:hover': $838f151bfdeb423e$var$_objectSpread($838f151bfdeb423e$var$_objectSpread({}, $838f151bfdeb423e$var$defaultStyles['&:hover']), {}, {
        color: "var(--ds-text, #292A2E)",
        textDecoration: 'none'
    }),
    '&:active': $838f151bfdeb423e$var$_objectSpread($838f151bfdeb423e$var$_objectSpread({}, $838f151bfdeb423e$var$defaultStyles['&:active']), {}, {
        color: "var(--ds-text, #292A2E)",
        textDecoration: 'none'
    })
});
var $838f151bfdeb423e$var$primaryWithAnchorTextColorStyles = $838f151bfdeb423e$var$_objectSpread($838f151bfdeb423e$var$_objectSpread({}, $838f151bfdeb423e$var$primaryStyles), {}, {
    textDecoration: 'none',
    '&:hover': $838f151bfdeb423e$var$_objectSpread($838f151bfdeb423e$var$_objectSpread({}, $838f151bfdeb423e$var$primaryStyles['&:hover']), {}, {
        color: "var(--ds-text-inverse, #FFFFFF)",
        textDecoration: 'none'
    }),
    '&:active': $838f151bfdeb423e$var$_objectSpread($838f151bfdeb423e$var$_objectSpread({}, $838f151bfdeb423e$var$primaryStyles['&:active']), {}, {
        color: "var(--ds-text-inverse, #FFFFFF)",
        textDecoration: 'none'
    })
});
var $838f151bfdeb423e$var$linkWithAnchorTextColorStyles = $838f151bfdeb423e$var$_objectSpread($838f151bfdeb423e$var$_objectSpread({}, $838f151bfdeb423e$var$linkStyles), {}, {
    textDecoration: 'none'
});
var $838f151bfdeb423e$var$subtleWithAnchorTextColorStyles = $838f151bfdeb423e$var$_objectSpread($838f151bfdeb423e$var$_objectSpread({}, $838f151bfdeb423e$var$subtleStyles), {}, {
    textDecoration: 'none',
    '&:hover': $838f151bfdeb423e$var$_objectSpread($838f151bfdeb423e$var$_objectSpread({}, $838f151bfdeb423e$var$subtleStyles['&:hover']), {}, {
        color: "var(--ds-text-subtle, #505258)",
        textDecoration: 'none'
    }),
    '&:active': $838f151bfdeb423e$var$_objectSpread($838f151bfdeb423e$var$_objectSpread({}, $838f151bfdeb423e$var$subtleStyles['&:active']), {}, {
        color: "var(--ds-text-subtle, #505258)",
        textDecoration: 'none'
    })
});
var $838f151bfdeb423e$var$subtleLinkWithAnchorTextColorStyles = $838f151bfdeb423e$var$_objectSpread($838f151bfdeb423e$var$_objectSpread({}, $838f151bfdeb423e$var$subtleLinkStyles), {}, {
    textDecoration: 'none'
});
var $838f151bfdeb423e$var$warningWithAnchorTextColorStyles = $838f151bfdeb423e$var$_objectSpread($838f151bfdeb423e$var$_objectSpread({}, $838f151bfdeb423e$var$warningStyles), {}, {
    textDecoration: 'none',
    '&:hover': $838f151bfdeb423e$var$_objectSpread($838f151bfdeb423e$var$_objectSpread({}, $838f151bfdeb423e$var$warningStyles['&:hover']), {}, {
        color: "var(--ds-text-warning-inverse, #292A2E)",
        textDecoration: 'none'
    }),
    '&:active': $838f151bfdeb423e$var$_objectSpread($838f151bfdeb423e$var$_objectSpread({}, $838f151bfdeb423e$var$warningStyles['&:active']), {}, {
        color: "var(--ds-text-warning-inverse, #292A2E)",
        textDecoration: 'none'
    })
});
var $838f151bfdeb423e$var$dangerWithAnchorTextColorStyles = $838f151bfdeb423e$var$_objectSpread($838f151bfdeb423e$var$_objectSpread({}, $838f151bfdeb423e$var$dangerStyles), {}, {
    textDecoration: 'none',
    '&:hover': $838f151bfdeb423e$var$_objectSpread($838f151bfdeb423e$var$_objectSpread({}, $838f151bfdeb423e$var$dangerStyles['&:hover']), {}, {
        color: "var(--ds-text-inverse, #FFFFFF)",
        textDecoration: 'none'
    }),
    '&:active': $838f151bfdeb423e$var$_objectSpread($838f151bfdeb423e$var$_objectSpread({}, $838f151bfdeb423e$var$dangerStyles['&:active']), {}, {
        color: "var(--ds-text-inverse, #FFFFFF)",
        textDecoration: 'none'
    })
});
var $838f151bfdeb423e$var$hasOverlayStyles = {
    '&[data-has-overlay="true"]': {
        cursor: 'default',
        textDecoration: 'none'
    }
};
function $838f151bfdeb423e$export$955358618f994a11(_ref) {
    var appearance = _ref.appearance, spacing = _ref.spacing, isSelected = _ref.isSelected, shouldFitContainer = _ref.shouldFitContainer, isOnlySingleIcon = _ref.isOnlySingleIcon;
    return $838f151bfdeb423e$var$_objectSpread($838f151bfdeb423e$var$_objectSpread({
        // 0px margin added to css-reset
        alignItems: 'baseline',
        borderWidth: 0,
        borderRadius: (0, $2fcbb5e4cf9206d1$export$b40ec24ac8275656)('platform-dst-shape-theme-default') ? "var(--ds-radius-medium, 6px)" : "var(--ds-radius-small, 3px)",
        boxSizing: 'border-box',
        display: 'inline-flex',
        fontSize: 'inherit',
        fontStyle: 'normal',
        // Chrome recently changed button so that they use 'arial' as the font family
        fontFamily: 'inherit',
        fontWeight: "var(--ds-font-weight-medium, 500)",
        // margin for button has been applied to css reset
        maxWidth: '100%',
        // Needed to position overlay
        position: 'relative',
        textAlign: 'center',
        textDecoration: 'none',
        transition: (0, $2fcbb5e4cf9206d1$export$b40ec24ac8275656)('platform-dst-motion-uplift-button') ? "var(--ds-button-hovered, background-color 150ms cubic-bezier(0.4, 1, 0.6, 1))".concat(", box-shadow 0.15s cubic-bezier(0.47, 0.03, 0.49, 1.38)") : 'background 0.1s ease-out, box-shadow 0.15s cubic-bezier(0.47, 0.03, 0.49, 1.38)',
        whiteSpace: 'nowrap',
        cursor: 'pointer',
        height: $838f151bfdeb423e$var$heights[spacing],
        lineHeight: $838f151bfdeb423e$var$lineHeights[spacing],
        padding: isOnlySingleIcon ? $838f151bfdeb423e$var$singleIconPadding[spacing] : $838f151bfdeb423e$var$padding[spacing],
        verticalAlign: $838f151bfdeb423e$var$verticalAlign[spacing],
        width: shouldFitContainer ? '100%' : 'auto',
        // justifyContent required for shouldFitContainer buttons with an icon inside
        justifyContent: 'center'
    }, isSelected ? $838f151bfdeb423e$var$selectedStyles : $838f151bfdeb423e$var$_objectSpread($838f151bfdeb423e$var$_objectSpread({}, (0, $2fcbb5e4cf9206d1$export$b40ec24ac8275656)('platform-dst-legacy-button-anchor-text-color') ? $838f151bfdeb423e$var$_objectSpread($838f151bfdeb423e$var$_objectSpread($838f151bfdeb423e$var$_objectSpread($838f151bfdeb423e$var$_objectSpread($838f151bfdeb423e$var$_objectSpread($838f151bfdeb423e$var$_objectSpread($838f151bfdeb423e$var$_objectSpread({}, appearance === 'default' && $838f151bfdeb423e$var$defaultWithAnchorTextColorStyles), appearance === 'primary' && $838f151bfdeb423e$var$primaryWithAnchorTextColorStyles), appearance === 'link' && $838f151bfdeb423e$var$linkWithAnchorTextColorStyles), appearance === 'subtle' && $838f151bfdeb423e$var$subtleWithAnchorTextColorStyles), appearance === 'subtle-link' && $838f151bfdeb423e$var$subtleLinkWithAnchorTextColorStyles), appearance === 'warning' && $838f151bfdeb423e$var$warningWithAnchorTextColorStyles), appearance === 'danger' && $838f151bfdeb423e$var$dangerWithAnchorTextColorStyles) : $838f151bfdeb423e$var$_objectSpread($838f151bfdeb423e$var$_objectSpread($838f151bfdeb423e$var$_objectSpread($838f151bfdeb423e$var$_objectSpread($838f151bfdeb423e$var$_objectSpread($838f151bfdeb423e$var$_objectSpread($838f151bfdeb423e$var$_objectSpread({}, appearance === 'default' && $838f151bfdeb423e$var$defaultStyles), appearance === 'primary' && $838f151bfdeb423e$var$primaryStyles), appearance === 'link' && $838f151bfdeb423e$var$linkStyles), appearance === 'subtle' && $838f151bfdeb423e$var$subtleStyles), appearance === 'subtle-link' && $838f151bfdeb423e$var$subtleLinkStyles), appearance === 'warning' && $838f151bfdeb423e$var$warningStyles), appearance === 'danger' && $838f151bfdeb423e$var$dangerStyles)), {}, {
        '&[disabled]': {
            color: "var(--ds-text-disabled, #080F214A)",
            backgroundColor: $838f151bfdeb423e$var$HAS_DISABLED_BACKGROUND.includes(appearance) ? "var(--ds-background-disabled, #0515240F)" : 'transparent',
            cursor: 'not-allowed',
            textDecoration: 'none',
            '&:hovered': {
                backgroundColor: $838f151bfdeb423e$var$HAS_DISABLED_BACKGROUND.includes(appearance) ? "var(--ds-background-disabled, #0515240F)" : 'transparent'
            },
            '&:active': {
                backgroundColor: $838f151bfdeb423e$var$HAS_DISABLED_BACKGROUND.includes(appearance) ? "var(--ds-background-disabled, #0515240F)" : 'transparent'
            }
        }
    }, $838f151bfdeb423e$var$hasOverlayStyles)), {}, {
        '&::-moz-focus-inner': {
            border: 0,
            margin: 0,
            padding: 0
        }
    });
}



function $8fa9a5f090da09f2$export$2e2bcd8739ae039(_ref) {
    var children = _ref.children, iconBefore = _ref.iconBefore, iconAfter = _ref.iconAfter;
    if ((0, $0f8fdda3fb25763e$export$20bbd2efb0d734c4)(children)) return true;
    if (children) return false;
    if (iconBefore && !iconAfter) return true;
    if (!iconBefore && iconAfter) return true;
    return false;
}


var $7fdc7055b6e0a177$var$_excluded = [
    "appearance",
    "children",
    "iconBefore",
    "iconAfter",
    "isSelected",
    "onMouseDown",
    "onMouseUp",
    "shouldFitContainer",
    "spacing"
];
var $7fdc7055b6e0a177$var$isFirefox = typeof navigator !== 'undefined' && navigator.userAgent.toLowerCase().indexOf('firefox') > -1;
/**
 * __Button__
 *
 * @deprecated Legacy buttons are deprecated and will be removed from `atlaskit/button` in an upcoming major release. Please use the new Button components from `@atlaskit/button/new`
 *
 * Please refer to the [migration guide](https://atlassian.design/components/button/button-legacy/migration-guide) for further details.
 *
 * A button triggers an event or action. They let users know what will happen next.
 *
 * - [Examples](https://atlassian.design/components/button/button-legacy/examples)
 * - [Code](https://atlassian.design/components/button/button-legacy/code)
 * - [Usage](https://atlassian.design/components/button/button-legacy/usage)
 */ var $7fdc7055b6e0a177$var$Button = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).forwardRef(function Button(_ref, ref) {
    var _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'default' : _ref$appearance, children = _ref.children, iconBefore = _ref.iconBefore, iconAfter = _ref.iconAfter, _ref$isSelected = _ref.isSelected, isSelected = _ref$isSelected === void 0 ? false : _ref$isSelected, _ref$onMouseDown = _ref.onMouseDown, providedOnMouseDown = _ref$onMouseDown === void 0 ? (0, $adcefb868cf2fc9d$export$2e2bcd8739ae039) : _ref$onMouseDown, _ref$onMouseUp = _ref.onMouseUp, providedOnMouseUp = _ref$onMouseUp === void 0 ? (0, $adcefb868cf2fc9d$export$2e2bcd8739ae039) : _ref$onMouseUp, _ref$shouldFitContain = _ref.shouldFitContainer, shouldFitContainer = _ref$shouldFitContain === void 0 ? false : _ref$shouldFitContain, _ref$spacing = _ref.spacing, spacing = _ref$spacing === void 0 ? 'default' : _ref$spacing, rest = (0, $74jTZ.default)(_ref, $7fdc7055b6e0a177$var$_excluded);
    var isOnlySingleIcon = (0, $8fa9a5f090da09f2$export$2e2bcd8739ae039)({
        children: children,
        iconBefore: iconBefore,
        iconAfter: iconAfter
    });
    var _useState = (0, $5FkrB.useState)(false), _useState2 = (0, $amAaq.default)(_useState, 2), isActive = _useState2[0], setIsActive = _useState2[1];
    // Wrap onMouseDown / onMouseUp to manually trigger active state
    // in Firefox
    var onMouseDown = (0, $5FkrB.useCallback)(function(event) {
        providedOnMouseDown(event);
        if ($7fdc7055b6e0a177$var$isFirefox) setIsActive(true);
    }, [
        providedOnMouseDown,
        setIsActive
    ]);
    var onMouseUp = (0, $5FkrB.useCallback)(function(event) {
        providedOnMouseUp(event);
        if ($7fdc7055b6e0a177$var$isFirefox) setIsActive(false);
    }, [
        providedOnMouseUp,
        setIsActive
    ]);
    var buttonCss = (0, $5FkrB.useMemo)(function() {
        return (0, $838f151bfdeb423e$export$955358618f994a11)({
            appearance: appearance,
            spacing: spacing,
            isSelected: isSelected,
            shouldFitContainer: shouldFitContainer,
            isOnlySingleIcon: isOnlySingleIcon
        });
    }, [
        appearance,
        spacing,
        isSelected,
        shouldFitContainer,
        isOnlySingleIcon
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $284f71d3e3220e16$export$2e2bcd8739ae039), (0, $d0778aa44ff9fe37$export$2e2bcd8739ae039)({}, rest, {
        ref: ref,
        appearance: appearance,
        buttonCss: buttonCss,
        children: children,
        "data-firefox-is-active": isActive ? true : undefined,
        iconAfter: iconAfter,
        iconBefore: iconBefore,
        isSelected: isSelected,
        onMouseDown: onMouseDown,
        onMouseUp: onMouseUp,
        spacing: spacing
    }));
}));
// Tools including enzyme rely on components having a display name
$7fdc7055b6e0a177$var$Button.displayName = 'Button';
var $7fdc7055b6e0a177$export$2e2bcd8739ae039 = $7fdc7055b6e0a177$var$Button;



/* index.tsx generated by @compiled/babel-plugin v0.40.0 */ 

var $74jTZ = parcelRequire("74jTZ");

var $5FkrB = parcelRequire("5FkrB");

var $gKzKW = parcelRequire("gKzKW");


/* anchor.tsx generated by @compiled/babel-plugin v0.40.0 */ 

var $hCM0e = parcelRequire("hCM0e");

var $74jTZ = parcelRequire("74jTZ");

var $5FkrB = parcelRequire("5FkrB");





var $5FkrB = parcelRequire("5FkrB");

var $5FkrB = parcelRequire("5FkrB");
var $1bc0380b43b287f3$export$2931e0ee690eee88 = /*#__PURE__*/ (0, $5FkrB.createContext)({});
/**
 * __RouterLinkProvider__
 *
 * Provides a configured router link component for use
 * within Design System components.
 */ var $1bc0380b43b287f3$var$RouterLinkProvider = function RouterLinkProvider(_ref) {
    var routerLinkComponent = _ref.routerLinkComponent, children = _ref.children;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement($1bc0380b43b287f3$export$2931e0ee690eee88.Provider, {
        value: {
            routerLinkComponent: routerLinkComponent
        }
    }, children);
};
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$1bc0380b43b287f3$export$2e2bcd8739ae039 = $1bc0380b43b287f3$var$RouterLinkProvider;


/**
 * __useRouterLink()__
 *
 * Hook: Returns app-configured router link component.
 *
 * A generic can be passed to define advanced link configuration:
 * ```
 * type MyRouterLinkConfig = {
 *  to: string;
 *  replace?: boolean;
 * }
 *
 * const RouterLink = useRouterLink<MyRouterLinkConfig>();
 * ```
 */ var $d5bb4ddc0a0a73ba$var$useRouterLink = function useRouterLink() {
    var _useContext = (0, $5FkrB.useContext)((0, $1bc0380b43b287f3$export$2931e0ee690eee88)), routerLinkComponent = _useContext.routerLinkComponent;
    if (routerLinkComponent) return routerLinkComponent;
    return;
};
var $d5bb4ddc0a0a73ba$export$2e2bcd8739ae039 = $d5bb4ddc0a0a73ba$var$useRouterLink;







var $f7402c8717b4416e$var$_excluded = [
    "href",
    "children",
    "onClick",
    "interactionName",
    "componentName",
    "analyticsContext",
    "aria-label",
    "aria-labelledby",
    "style",
    "target",
    "testId",
    "xcss",
    "newWindowLabel"
], $f7402c8717b4416e$var$_excluded2 = [
    "className"
];
var $f7402c8717b4416e$var$styles = {
    root: "_4bfu1r31 _1hms8stv _ajmmnqa1 _vchhusvi",
    position: "_kqswh2mm"
};
var $f7402c8717b4416e$var$IS_EXTERNAL_LINK_REGEX = /^(?:(http|https):\/\/)/;
var $f7402c8717b4416e$var$IS_NON_HTTP_BASED = /^(((mailto|tel|sms|blob):)|(#))/;
/**
 * __Anchor__
 *
 * A primitive for building custom anchor links.
 *
 * - [Examples](https://atlassian.design/components/primitives/anchor/examples)
 * - [Code](https://atlassian.design/components/primitives/anchor/code)
 * - [Usage](https://atlassian.design/components/primitives/anchor/usage)
 */ var $f7402c8717b4416e$var$AnchorNoRef = function AnchorNoRef(_ref, ref) {
    var href = _ref.href, children = _ref.children, _ref$onClick = _ref.onClick, providedOnClick = _ref$onClick === void 0 ? (0, $adcefb868cf2fc9d$export$2e2bcd8739ae039) : _ref$onClick, interactionName = _ref.interactionName, componentName = _ref.componentName, analyticsContext = _ref.analyticsContext, ariaLabel = _ref['aria-label'], ariaLabelledBy = _ref['aria-labelledby'], style = _ref.style, target = _ref.target, testId = _ref.testId, xcss = _ref.xcss, _ref$newWindowLabel = _ref.newWindowLabel, newWindowLabel = _ref$newWindowLabel === void 0 ? '(opens new window)' : _ref$newWindowLabel, htmlAttributes = (0, $74jTZ.default)(_ref, $f7402c8717b4416e$var$_excluded);
    var interactionContext = (0, $5FkrB.useContext)((0, $a81fd7e45a8c2ef5$export$2e2bcd8739ae039));
    var handleClick = (0, $5FkrB.useCallback)(function(e, analyticsEvent) {
        interactionContext && interactionContext.tracePress(interactionName, e.timeStamp);
        providedOnClick(e, analyticsEvent);
    }, [
        providedOnClick,
        interactionContext,
        interactionName
    ]);
    var opensNewWindowLabelId = (0, $c797bf80d6171378$export$f680877a34711e37)();
    var onClick = (0, $75b909bb27e39354$export$a4687b0234b40e28)({
        fn: handleClick,
        action: 'clicked',
        componentName: componentName || 'Anchor',
        packageName: "@atlaskit/primitives",
        packageVersion: "22.1.1",
        analyticsData: analyticsContext,
        actionSubject: 'link'
    });
    // This is to remove className from safeHtmlAttributes
    // @ts-expect-error className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    var _spreadClass = htmlAttributes.className, safeHtmlAttributes = (0, $74jTZ.default)(htmlAttributes, $f7402c8717b4416e$var$_excluded2);
    var RouterLink = (0, $d5bb4ddc0a0a73ba$export$2e2bcd8739ae039)();
    var isExternal = typeof href === 'string' && $f7402c8717b4416e$var$IS_EXTERNAL_LINK_REGEX.test(href);
    var isNonHttpBased = typeof href === 'string' && $f7402c8717b4416e$var$IS_NON_HTTP_BASED.test(href);
    /**
   * Renders a router link if:
   *
   * - a link component is set in the app provider
   * - it's not an external link (starting with `http://` or `https://`)
   * - it's not a non-HTTP-based link (e.g. emails, phone numbers, hash links etc.).
   */ var isRouterLink = RouterLink && !isExternal && !isNonHttpBased;
    var hrefObjectUsedWithoutRouterLink = RouterLink === undefined && (0, $hCM0e.default)(href) === 'object';
    (0, $fff3f31fc3bd4f88$export$2e2bcd8739ae039)(!hrefObjectUsedWithoutRouterLink, "@atlaskit/primitives: Anchor primitive cannot pass an object to 'href' unless a router link is configured in the AppProvider");
    var Component = isRouterLink ? RouterLink : 'a';
    return /*#__PURE__*/ $5FkrB.createElement((0, $0013faf18cfa29e2$export$35a3bebf7ef2d934), (0, $d0778aa44ff9fe37$export$2e2bcd8739ae039)({
        as: Component,
        className: xcss,
        style: style,
        ref: ref
    }, safeHtmlAttributes, {
        href: !isRouterLink && typeof href !== 'string' ? undefined : href,
        target: target,
        onClick: onClick,
        "aria-label": ariaLabel && target === '_blank' && !ariaLabelledBy ? "".concat(ariaLabel, " , ").concat(newWindowLabel) : ariaLabel,
        "aria-labelledby": ariaLabelledBy && target === '_blank' ? "".concat(ariaLabelledBy, " ").concat(opensNewWindowLabelId) : ariaLabelledBy,
        xcss: (0, $e758eaf3163bf949$export$a274e22fb40f762e)($f7402c8717b4416e$var$styles.root, $f7402c8717b4416e$var$styles.position, xcss),
        testId: testId,
        "data-is-router-link": testId ? isRouterLink ? 'true' : 'false' : undefined
    }), children, target === '_blank' && (children && !ariaLabel && !ariaLabelledBy || ariaLabelledBy) && /*#__PURE__*/ $5FkrB.createElement((0, $3fb4db4d25367976$export$2e2bcd8739ae039), {
        id: opensNewWindowLabelId
    }, ", ".concat(newWindowLabel)));
};
var $f7402c8717b4416e$export$b688253958b8dfe7 = /*#__PURE__*/ (0, $5FkrB.forwardRef)($f7402c8717b4416e$var$AnchorNoRef);

/* box.tsx generated by @compiled/babel-plugin v0.40.0 */ 

var $74jTZ = parcelRequire("74jTZ");

var $5FkrB = parcelRequire("5FkrB");

var $gKzKW = parcelRequire("gKzKW");

var $f3b0d8b8c6613242$var$_excluded = [
    "as",
    "children",
    "backgroundColor",
    "padding",
    "paddingBlock",
    "paddingBlockStart",
    "paddingBlockEnd",
    "paddingInline",
    "paddingInlineStart",
    "paddingInlineEnd",
    "style",
    "testId",
    "xcss"
], $f3b0d8b8c6613242$var$_excluded2 = [
    "className"
];
// Can either Exclude or Extract - here we're excluding all SVG-related elements, <button> elements (handled by Pressable), and <a> elements (handled by Anchor)
// Basically just ElementType but without ComponentType, it makes sense to keep the "Type" suffix
// eslint-disable-next-line @repo/internal/react/consistent-types-definitions
var $f3b0d8b8c6613242$var$baseStyles = null;
var $f3b0d8b8c6613242$var$backgroundColorMap = {
    'color.background.accent.lime.subtlest': "_bfhkm890",
    'color.background.accent.lime.subtlest.hovered': "_bfhkd4y8",
    'color.background.accent.lime.subtlest.pressed': "_bfhkkuup",
    'color.background.accent.lime.subtler': "_bfhkz2ec",
    'color.background.accent.lime.subtler.hovered': "_bfhk1gf0",
    'color.background.accent.lime.subtler.pressed': "_bfhk2kxc",
    'color.background.accent.lime.subtle': "_bfhkbq5w",
    'color.background.accent.lime.subtle.hovered': "_bfhkfoww",
    'color.background.accent.lime.subtle.pressed': "_bfhk1jbd",
    'color.background.accent.lime.bolder': "_bfhktde4",
    'color.background.accent.lime.bolder.hovered': "_bfhknzpa",
    'color.background.accent.lime.bolder.pressed': "_bfhkh0j0",
    'color.background.accent.red.subtlest': "_bfhk1vk5",
    'color.background.accent.red.subtlest.hovered': "_bfhk1i6i",
    'color.background.accent.red.subtlest.pressed': "_bfhknbir",
    'color.background.accent.red.subtler': "_bfhk1rtt",
    'color.background.accent.red.subtler.hovered': "_bfhkaffd",
    'color.background.accent.red.subtler.pressed': "_bfhk1j5a",
    'color.background.accent.red.subtle': "_bfhkkrt9",
    'color.background.accent.red.subtle.hovered': "_bfhk1sou",
    'color.background.accent.red.subtle.pressed': "_bfhk1fnn",
    'color.background.accent.red.bolder': "_bfhkuibq",
    'color.background.accent.red.bolder.hovered': "_bfhk100f",
    'color.background.accent.red.bolder.pressed': "_bfhk1cl6",
    'color.background.accent.orange.subtlest': "_bfhkf5uh",
    'color.background.accent.orange.subtlest.hovered': "_bfhk19yr",
    'color.background.accent.orange.subtlest.pressed': "_bfhkf90x",
    'color.background.accent.orange.subtler': "_bfhk165s",
    'color.background.accent.orange.subtler.hovered': "_bfhk1ei0",
    'color.background.accent.orange.subtler.pressed': "_bfhkdpo3",
    'color.background.accent.orange.subtle': "_bfhk1kkj",
    'color.background.accent.orange.subtle.hovered': "_bfhk9mfs",
    'color.background.accent.orange.subtle.pressed': "_bfhkaxpp",
    'color.background.accent.orange.bolder': "_bfhk1qg1",
    'color.background.accent.orange.bolder.hovered': "_bfhk12qo",
    'color.background.accent.orange.bolder.pressed': "_bfhk1fyq",
    'color.background.accent.yellow.subtlest': "_bfhkibhp",
    'color.background.accent.yellow.subtlest.hovered': "_bfhkaetg",
    'color.background.accent.yellow.subtlest.pressed': "_bfhk1o1l",
    'color.background.accent.yellow.subtler': "_bfhk1773",
    'color.background.accent.yellow.subtler.hovered': "_bfhk1uw7",
    'color.background.accent.yellow.subtler.pressed': "_bfhk1r9w",
    'color.background.accent.yellow.subtle': "_bfhk8y3s",
    'color.background.accent.yellow.subtle.hovered': "_bfhk819w",
    'color.background.accent.yellow.subtle.pressed': "_bfhk1jx0",
    'color.background.accent.yellow.bolder': "_bfhk1vop",
    'color.background.accent.yellow.bolder.hovered': "_bfhkkjqf",
    'color.background.accent.yellow.bolder.pressed': "_bfhk1okt",
    'color.background.accent.green.subtlest': "_bfhkn729",
    'color.background.accent.green.subtlest.hovered': "_bfhk3utz",
    'color.background.accent.green.subtlest.pressed': "_bfhkyfny",
    'color.background.accent.green.subtler': "_bfhk1wnw",
    'color.background.accent.green.subtler.hovered': "_bfhk1e2h",
    'color.background.accent.green.subtler.pressed': "_bfhkybhx",
    'color.background.accent.green.subtle': "_bfhk1rsu",
    'color.background.accent.green.subtle.hovered': "_bfhk12e3",
    'color.background.accent.green.subtle.pressed': "_bfhk1g86",
    'color.background.accent.green.bolder': "_bfhk1e5c",
    'color.background.accent.green.bolder.hovered': "_bfhka5yi",
    'color.background.accent.green.bolder.pressed': "_bfhk1j68",
    'color.background.accent.teal.subtlest': "_bfhk7xuz",
    'color.background.accent.teal.subtlest.hovered': "_bfhk108c",
    'color.background.accent.teal.subtlest.pressed': "_bfhk1cxp",
    'color.background.accent.teal.subtler': "_bfhk1a17",
    'color.background.accent.teal.subtler.hovered': "_bfhkkwwr",
    'color.background.accent.teal.subtler.pressed': "_bfhk1jb0",
    'color.background.accent.teal.subtle': "_bfhktdv8",
    'color.background.accent.teal.subtle.hovered': "_bfhkzh8h",
    'color.background.accent.teal.subtle.pressed': "_bfhk16zl",
    'color.background.accent.teal.bolder': "_bfhk2c8p",
    'color.background.accent.teal.bolder.hovered': "_bfhkl3ve",
    'color.background.accent.teal.bolder.pressed': "_bfhktor0",
    'color.background.accent.blue.subtlest': "_bfhk1s93",
    'color.background.accent.blue.subtlest.hovered': "_bfhkdaj9",
    'color.background.accent.blue.subtlest.pressed': "_bfhkxm0g",
    'color.background.accent.blue.subtler': "_bfhk1dy8",
    'color.background.accent.blue.subtler.hovered': "_bfhk815t",
    'color.background.accent.blue.subtler.pressed': "_bfhkrwxf",
    'color.background.accent.blue.subtle': "_bfhk115i",
    'color.background.accent.blue.subtle.hovered': "_bfhk9pr4",
    'color.background.accent.blue.subtle.pressed': "_bfhknpx7",
    'color.background.accent.blue.bolder': "_bfhk16e3",
    'color.background.accent.blue.bolder.hovered': "_bfhk1vbm",
    'color.background.accent.blue.bolder.pressed': "_bfhk1xwi",
    'color.background.accent.purple.subtlest': "_bfhkp2ly",
    'color.background.accent.purple.subtlest.hovered': "_bfhkkca2",
    'color.background.accent.purple.subtlest.pressed': "_bfhk1jbm",
    'color.background.accent.purple.subtler': "_bfhk1nm4",
    'color.background.accent.purple.subtler.hovered': "_bfhkattl",
    'color.background.accent.purple.subtler.pressed': "_bfhk3nfk",
    'color.background.accent.purple.subtle': "_bfhk18ah",
    'color.background.accent.purple.subtle.hovered': "_bfhk8bp1",
    'color.background.accent.purple.subtle.pressed': "_bfhk1cd2",
    'color.background.accent.purple.bolder': "_bfhkya33",
    'color.background.accent.purple.bolder.hovered': "_bfhk1af5",
    'color.background.accent.purple.bolder.pressed': "_bfhk6cze",
    'color.background.accent.magenta.subtlest': "_bfhk8tvm",
    'color.background.accent.magenta.subtlest.hovered': "_bfhkr3zd",
    'color.background.accent.magenta.subtlest.pressed': "_bfhk1ckf",
    'color.background.accent.magenta.subtler': "_bfhkv9ra",
    'color.background.accent.magenta.subtler.hovered': "_bfhk1axx",
    'color.background.accent.magenta.subtler.pressed': "_bfhk42ri",
    'color.background.accent.magenta.subtle': "_bfhk1mi6",
    'color.background.accent.magenta.subtle.hovered': "_bfhkrwyz",
    'color.background.accent.magenta.subtle.pressed': "_bfhk6c15",
    'color.background.accent.magenta.bolder': "_bfhkc3uk",
    'color.background.accent.magenta.bolder.hovered': "_bfhk1ok8",
    'color.background.accent.magenta.bolder.pressed': "_bfhkeawv",
    'color.background.accent.gray.subtlest': "_bfhkysee",
    'color.background.accent.gray.subtlest.hovered': "_bfhkwejn",
    'color.background.accent.gray.subtlest.pressed': "_bfhk18ut",
    'color.background.accent.gray.subtler': "_bfhk7qp0",
    'color.background.accent.gray.subtler.hovered': "_bfhk10ef",
    'color.background.accent.gray.subtler.pressed': "_bfhk1rk9",
    'color.background.accent.gray.subtle': "_bfhk18j9",
    'color.background.accent.gray.subtle.hovered': "_bfhk1nv3",
    'color.background.accent.gray.subtle.pressed': "_bfhkq9tj",
    'color.background.accent.gray.bolder': "_bfhk1i45",
    'color.background.accent.gray.bolder.hovered': "_bfhkbyip",
    'color.background.accent.gray.bolder.pressed': "_bfhk1van",
    'color.background.disabled': "_bfhk187o",
    'color.background.input': "_bfhk1j9a",
    'color.background.input.hovered': "_bfhkl4ek",
    'color.background.input.pressed': "_bfhkr01l",
    'color.background.inverse.subtle': "_bfhk1vck",
    'color.background.inverse.subtle.hovered': "_bfhkmpja",
    'color.background.inverse.subtle.pressed': "_bfhk1gii",
    'color.background.neutral': "_bfhki8nm",
    'color.background.neutral.hovered': "_bfhkplhp",
    'color.background.neutral.pressed': "_bfhk1gdz",
    'color.background.neutral.subtle': "_bfhksm61",
    'color.background.neutral.subtle.hovered': "_bfhk1dpa",
    'color.background.neutral.subtle.pressed': "_bfhkfcek",
    'color.background.neutral.bold': "_bfhk1aqn",
    'color.background.neutral.bold.hovered': "_bfhk1ibz",
    'color.background.neutral.bold.pressed': "_bfhkof27",
    'color.background.selected': "_bfhk15s3",
    'color.background.selected.hovered': "_bfhkufnl",
    'color.background.selected.pressed': "_bfhknozp",
    'color.background.selected.bold': "_bfhkjmqp",
    'color.background.selected.bold.hovered': "_bfhk1q28",
    'color.background.selected.bold.pressed': "_bfhk12kk",
    'color.background.brand.subtlest': "_bfhk1gmr",
    'color.background.brand.subtlest.hovered': "_bfhk3v15",
    'color.background.brand.subtlest.pressed': "_bfhku02c",
    'color.background.brand.bold': "_bfhk1856",
    'color.background.brand.bold.hovered': "_bfhkhf2y",
    'color.background.brand.bold.pressed': "_bfhkg6ey",
    'color.background.brand.boldest': "_bfhk1o4i",
    'color.background.brand.boldest.hovered': "_bfhklefx",
    'color.background.brand.boldest.pressed': "_bfhk16k6",
    'color.background.danger': "_bfhk1gly",
    'color.background.danger.hovered': "_bfhk1yvi",
    'color.background.danger.pressed': "_bfhk1r4b",
    'color.background.danger.bold': "_bfhkybec",
    'color.background.danger.bold.hovered': "_bfhks9hg",
    'color.background.danger.bold.pressed': "_bfhk13a9",
    'color.background.warning': "_bfhk1917",
    'color.background.warning.hovered': "_bfhk19zu",
    'color.background.warning.pressed': "_bfhkzr32",
    'color.background.warning.bold': "_bfhk1kmu",
    'color.background.warning.bold.hovered': "_bfhk1spp",
    'color.background.warning.bold.pressed': "_bfhk4m4m",
    'color.background.success': "_bfhk1y9u",
    'color.background.success.hovered': "_bfhk1vfx",
    'color.background.success.pressed': "_bfhk1wl5",
    'color.background.success.bold': "_bfhkkcmj",
    'color.background.success.bold.hovered': "_bfhky7x8",
    'color.background.success.bold.pressed': "_bfhkwcbh",
    'color.background.discovery': "_bfhk6vm6",
    'color.background.discovery.hovered': "_bfhk12eq",
    'color.background.discovery.pressed': "_bfhk18vq",
    'color.background.discovery.bold': "_bfhku5tj",
    'color.background.discovery.bold.hovered': "_bfhkfqeg",
    'color.background.discovery.bold.pressed': "_bfhk1f1m",
    'color.background.information': "_bfhk19ip",
    'color.background.information.hovered': "_bfhk86z5",
    'color.background.information.pressed': "_bfhk1c1j",
    'color.background.information.bold': "_bfhkx4w0",
    'color.background.information.bold.hovered': "_bfhkq2ii",
    'color.background.information.bold.pressed': "_bfhkf89v",
    'color.blanket': "_bfhk1i5c",
    'color.blanket.selected': "_bfhk7wq0",
    'color.blanket.danger': "_bfhkrprw",
    'color.skeleton': "_bfhkizff",
    'color.skeleton.subtle': "_bfhkvkf5",
    'elevation.surface': "_bfhkvuon",
    'elevation.surface.hovered': "_bfhk19i6",
    'elevation.surface.pressed': "_bfhk13ro",
    'elevation.surface.overlay': "_bfhk1bhr",
    'elevation.surface.overlay.hovered': "_bfhk6o2t",
    'elevation.surface.overlay.pressed': "_bfhkm8nx",
    'elevation.surface.raised': "_bfhkhp5a",
    'elevation.surface.raised.hovered': "_bfhk116u",
    'elevation.surface.raised.pressed': "_bfhk14aj",
    'elevation.surface.sunken': "_bfhkhfxm",
    'utility.elevation.surface.current': "_bfhkchd4"
};
var $f3b0d8b8c6613242$var$CURRENT_SURFACE_CSS_VAR = "--ds-elevation-surface-current";
var $f3b0d8b8c6613242$var$setSurfaceTokenMap = {
    'elevation.surface': "_1q1lvuon",
    'elevation.surface.hovered': "_1q1l19i6",
    'elevation.surface.pressed': "_1q1l13ro",
    'elevation.surface.overlay': "_1q1l1bhr",
    'elevation.surface.overlay.hovered': "_1q1l6o2t",
    'elevation.surface.overlay.pressed': "_1q1lm8nx",
    'elevation.surface.raised': "_1q1lhp5a",
    'elevation.surface.raised.hovered': "_1q1l116u",
    'elevation.surface.raised.pressed': "_1q1l14aj",
    'elevation.surface.sunken': "_1q1lhfxm"
};
var $f3b0d8b8c6613242$var$paddingBlockStartMap = {
    'space.0': "_1q51ze3t",
    'space.025': "_1q51v77o",
    'space.050': "_1q511b66",
    'space.075': "_1q5112x7",
    'space.100': "_1q51u2gc",
    'space.150': "_1q51utpp",
    'space.200': "_1q51pxbi",
    'space.250': "_1q51v47k",
    'space.300': "_1q511ejb",
    'space.400': "_1q51xy5q",
    'space.500': "_1q511jfw",
    'space.600': "_1q51oahv",
    'space.800': "_1q51xncg",
    'space.1000': "_1q511epz"
};
var $f3b0d8b8c6613242$var$paddingBlockEndMap = {
    'space.0': "_85i5ze3t",
    'space.025': "_85i5v77o",
    'space.050': "_85i51b66",
    'space.075': "_85i512x7",
    'space.100': "_85i5u2gc",
    'space.150': "_85i5utpp",
    'space.200': "_85i5pxbi",
    'space.250': "_85i5v47k",
    'space.300': "_85i51ejb",
    'space.400': "_85i5xy5q",
    'space.500': "_85i51jfw",
    'space.600': "_85i5oahv",
    'space.800': "_85i5xncg",
    'space.1000': "_85i51epz"
};
var $f3b0d8b8c6613242$var$paddingInlineStartMap = {
    'space.0': "_bozgze3t",
    'space.025': "_bozgv77o",
    'space.050': "_bozg1b66",
    'space.075': "_bozg12x7",
    'space.100': "_bozgu2gc",
    'space.150': "_bozgutpp",
    'space.200': "_bozgpxbi",
    'space.250': "_bozgv47k",
    'space.300': "_bozg1ejb",
    'space.400': "_bozgxy5q",
    'space.500': "_bozg1jfw",
    'space.600': "_bozgoahv",
    'space.800': "_bozgxncg",
    'space.1000': "_bozg1epz"
};
var $f3b0d8b8c6613242$var$paddingInlineEndMap = {
    'space.0': "_y4tize3t",
    'space.025': "_y4tiv77o",
    'space.050': "_y4ti1b66",
    'space.075': "_y4ti12x7",
    'space.100': "_y4tiu2gc",
    'space.150': "_y4tiutpp",
    'space.200': "_y4tipxbi",
    'space.250': "_y4tiv47k",
    'space.300': "_y4ti1ejb",
    'space.400': "_y4tixy5q",
    'space.500': "_y4ti1jfw",
    'space.600': "_y4tioahv",
    'space.800': "_y4tixncg",
    'space.1000': "_y4ti1epz"
};
var $f3b0d8b8c6613242$export$e71c4d32a2263218 = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? 'div' : _ref$as, children = _ref.children, backgroundColor = _ref.backgroundColor, padding = _ref.padding, _ref$paddingBlock = _ref.paddingBlock, paddingBlock = _ref$paddingBlock === void 0 ? padding : _ref$paddingBlock, _ref$paddingBlockStar = _ref.paddingBlockStart, paddingBlockStart = _ref$paddingBlockStar === void 0 ? paddingBlock : _ref$paddingBlockStar, _ref$paddingBlockEnd = _ref.paddingBlockEnd, paddingBlockEnd = _ref$paddingBlockEnd === void 0 ? paddingBlock : _ref$paddingBlockEnd, _ref$paddingInline = _ref.paddingInline, paddingInline = _ref$paddingInline === void 0 ? padding : _ref$paddingInline, _ref$paddingInlineSta = _ref.paddingInlineStart, paddingInlineStart = _ref$paddingInlineSta === void 0 ? paddingInline : _ref$paddingInlineSta, _ref$paddingInlineEnd = _ref.paddingInlineEnd, paddingInlineEnd = _ref$paddingInlineEnd === void 0 ? paddingInline : _ref$paddingInlineEnd, style = _ref.style, testId = _ref.testId, xcss = _ref.xcss, htmlAttributes = (0, $74jTZ.default)(_ref, $f3b0d8b8c6613242$var$_excluded);
    // This is to remove className from safeHtmlAttributes
    // @ts-ignore -- not using expect since it causes issues with help-center local consumption - className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    var _spreadClass = htmlAttributes.className, safeHtmlAttributes = (0, $74jTZ.default)(htmlAttributes, $f3b0d8b8c6613242$var$_excluded2);
    var node = /*#__PURE__*/ $5FkrB.createElement(Component, (0, $d0778aa44ff9fe37$export$2e2bcd8739ae039)({
        style: style,
        ref: ref,
        className: (0, $gKzKW.default)([
            "_19itglyw _vchhusvi _r06hglyw",
            backgroundColor && $f3b0d8b8c6613242$var$backgroundColorMap[backgroundColor],
            backgroundColor && $f3b0d8b8c6613242$var$isSurfaceToken(backgroundColor) && $f3b0d8b8c6613242$var$setSurfaceTokenMap[backgroundColor],
            paddingBlockStart && $f3b0d8b8c6613242$var$paddingBlockStartMap[paddingBlockStart],
            paddingBlockEnd && $f3b0d8b8c6613242$var$paddingBlockEndMap[paddingBlockEnd],
            paddingInlineStart && $f3b0d8b8c6613242$var$paddingInlineStartMap[paddingInlineStart],
            paddingInlineEnd && $f3b0d8b8c6613242$var$paddingInlineEndMap[paddingInlineEnd],
            xcss
        ])
    }, safeHtmlAttributes, {
        "data-testid": testId
    }), children);
    if (backgroundColor) return /*#__PURE__*/ $5FkrB.createElement((0, $fb15455aaac7771d$export$1ca2a26fecb070ae).Provider, {
        value: backgroundColor
    }, node);
    return node;
});
function $f3b0d8b8c6613242$var$isSurfaceToken(backgroundColor) {
    return backgroundColor in $f3b0d8b8c6613242$var$setSurfaceTokenMap;
}


var $5ab605e96ac109d3$var$_excluded = [
    "children",
    "testId",
    "appearance",
    "newWindowLabel",
    "target",
    "className",
    "style"
];
var $5ab605e96ac109d3$var$styles = {
    base: "_ect4ttxp",
    baseT26Shape: "_2rkolb4i",
    visitedLink: "_10531ra0 _1ien1ra0 _n0fx1ra0 _1vhv17z1",
    defaultAppearance: "_4bfu1r31 _1hms8stv _ajmmnqa1 _syaz13af _1a3b1r31 _4fpr8stv _5goinqa1 _f8pj13af _9oik1r31 _1bnxglyw _jf4cnqa1 _30l313af _1nrm1r31 _c2waglyw _1iohnqa1 _9h8h12zz",
    defaultAppearanceMotion: "_4bfu1r31 _1hms8stv _ajmmnqa1 _v564hxmd _syaz13af _1a3b1r31 _4fpr8stv _5goinqa1 _f8pj13af _9oik1j28 _1bnx8stv _jf4cnqa1 _o7kshxmd _30l313af _1nrm1j28 _c2wa8stv _1iohnqa1 _1ggl87vo _9h8h12zz",
    subtleAppearance: "_4bfu1r31 _1hmsglyw _ajmmnqa1 _syazazsu _1a3b1r31 _4fprglyw _5goinqa1 _f8pjazsu _9oik1r31 _1bnx8stv _jf4cnqa1 _30l3azsu _1nrm1r31 _c2wa8stv _1iohnqa1 _9h8hi7uo",
    subtleAppearanceMotion: "_4bfu1j28 _1hms8stv _ajmmnqa1 _v564hxmd _syazazsu _1a3b1j28 _4fpr8stv _5goinqa1 _f8pjazsu _9oik1r31 _1bnx8stv _jf4cnqa1 _o7kshxmd _30l3azsu _1nrm1r31 _c2wa8stv _1iohnqa1 _1ggl87vo _9h8hi7uo",
    inverseAppearance: "_4bfu1r31 _1hms8stv _ajmmnqa1 _syaz15cr _105315cr _1a3b1r31 _4fpr8stv _5goinqa1 _f8pj15cr _9oik1r31 _1bnxglyw _jf4cnqa1 _30l315cr _1nrm1r31 _c2waglyw _1iohnqa1 _9h8h15cr",
    inverseAppearanceMotion: "_4bfu1r31 _1hms8stv _ajmmnqa1 _v564hxmd _syaz15cr _105315cr _1a3b1r31 _4fpr8stv _5goinqa1 _f8pj15cr _9oik1j28 _1bnx8stv _jf4cnqa1 _o7kshxmd _30l315cr _1nrm1j28 _c2wa8stv _1iohnqa1 _1ggl87vo _9h8h15cr",
    iconWrapper: "_1e0c1nu9 _o5721q9c _s7n41q9y _kqswh2mm _152ttb3r"
};
var $5ab605e96ac109d3$var$iconStyles = null;
var $5ab605e96ac109d3$var$LinkWithoutRef = function LinkWithoutRef(_ref, ref) {
    var children = _ref.children, testId = _ref.testId, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'default' : _ref$appearance, newWindowLabel = _ref.newWindowLabel, target = _ref.target, _preventedClassName = _ref.className, _preventedStyle = _ref.style, htmlAttributes = (0, $74jTZ.default)(_ref, $5ab605e96ac109d3$var$_excluded);
    return /*#__PURE__*/ $5FkrB.createElement((0, $f7402c8717b4416e$export$b688253958b8dfe7), (0, $d0778aa44ff9fe37$export$2e2bcd8739ae039)({}, htmlAttributes, {
        target: target,
        ref: ref,
        xcss: (0, $b5cd78e10bc362b2$export$a274e22fb40f762e)($5ab605e96ac109d3$var$styles.base, (0, $2fcbb5e4cf9206d1$export$b40ec24ac8275656)('platform-dst-shape-theme-default') && $5ab605e96ac109d3$var$styles.baseT26Shape, appearance === 'default' && ((0, $2fcbb5e4cf9206d1$export$b40ec24ac8275656)('platform-dst-motion-uplift-list-item') ? $5ab605e96ac109d3$var$styles.defaultAppearanceMotion : $5ab605e96ac109d3$var$styles.defaultAppearance), appearance === 'subtle' && ((0, $2fcbb5e4cf9206d1$export$b40ec24ac8275656)('platform-dst-motion-uplift-list-item') ? $5ab605e96ac109d3$var$styles.subtleAppearanceMotion : $5ab605e96ac109d3$var$styles.subtleAppearance), appearance === 'inverse' && ((0, $2fcbb5e4cf9206d1$export$b40ec24ac8275656)('platform-dst-motion-uplift-list-item') ? $5ab605e96ac109d3$var$styles.inverseAppearanceMotion : $5ab605e96ac109d3$var$styles.inverseAppearance), // Visited styles are not supported for inverse links due to contrast issues
        appearance !== 'inverse' && $5ab605e96ac109d3$var$styles.visitedLink),
        testId: testId,
        componentName: "Link",
        newWindowLabel: newWindowLabel
    }), children, target === '_blank' && /*#__PURE__*/ $5FkrB.createElement((0, $f3b0d8b8c6613242$export$e71c4d32a2263218), {
        as: "span",
        xcss: $5ab605e96ac109d3$var$styles.iconWrapper,
        testId: testId && "".concat(testId, "__icon")
    }, "\uFEFF", /*#__PURE__*/ $5FkrB.createElement("svg", {
        width: "12",
        height: "12",
        viewBox: "0 0 12 12",
        fill: "none",
        className: (0, $gKzKW.default)([
            "_1bsbgm0b _4t3igm0b _ahbqzjw7"
        ])
    }, /*#__PURE__*/ $5FkrB.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M0 1.82609C0 0.817938 0.817938 0 1.82609 0H3.91304V1.04348H1.82609C1.39424 1.04348 1.04348 1.39424 1.04348 1.82609V10.1739C1.04348 10.6058 1.39424 10.9565 1.82609 10.9565H10.1739C10.6058 10.9565 10.9565 10.6058 10.9565 10.1739V8.08696H12V10.1739C12 11.1821 11.1821 12 10.1739 12H1.82609C0.817938 12 0 11.1821 0 10.1739V1.82609ZM7.04348 0H12V4.95652H10.9565V1.78133L6.36893 6.36893L5.63107 5.63107L10.2187 1.04348H7.04348V0Z",
        fill: "currentColor"
    }))));
};
// Workarounds to support generic types with forwardRef
/**
 * __Link__
 *
 * A link is an inline text element that navigates to a new location when clicked.
 *
 * - [Examples](https://atlassian.design/components/primitives/link/examples)
 * - [Code](https://atlassian.design/components/primitives/link/code)
 * - [Usage](https://atlassian.design/components/primitives/link/usage)
 */ var $5ab605e96ac109d3$var$Link = /*#__PURE__*/ (0, $5FkrB.forwardRef)($5ab605e96ac109d3$var$LinkWithoutRef);
var $5ab605e96ac109d3$export$2e2bcd8739ae039 = $5ab605e96ac109d3$var$Link;




var $3fe662b077bc761a$var$styles = {
    common: "_11c8fhey",
    anchor: "_k48pi7a9",
    pressable: "_syaz13af _k48p1wq8 _bfhk1j28 _1q51ze3t _y4tize3t _85i5ze3t _bozgze3t _9oik1r31 _1bnx8stv _jf4cnqa1 _30l313af _9h8h12zz",
    pressableT26Shape: "_2rkolb4i"
};
/**
 * __Section message action__
 *
 * A section message action is designed to work with the `action` prop from
 * `SectionMessage`. It renders either a button or a link depending on whether
 * an `onClick` or `href` prop is supplied, with a dot separator in between actions.
 *
 * - [Examples](https://atlassian.design/components/section-message/examples#actions)
 */ var $3fe662b077bc761a$var$SectionMessageAction = /*#__PURE__*/ (0, $5FkrB.memo)(/*#__PURE__*/ (0, $5FkrB.forwardRef)(function SectionMessageAction(_ref, ref) {
    var children = _ref.children, onClick = _ref.onClick, href = _ref.href, testId = _ref.testId, linkComponent = _ref.linkComponent, target = _ref.target;
    if (!linkComponent) {
        if (href) return /*#__PURE__*/ $5FkrB.createElement("span", {
            className: (0, $gKzKW.default)([
                $3fe662b077bc761a$var$styles.common,
                $3fe662b077bc761a$var$styles.anchor
            ])
        }, /*#__PURE__*/ $5FkrB.createElement((0, $5ab605e96ac109d3$export$2e2bcd8739ae039), {
            testId: testId,
            onClick: onClick,
            href: href,
            target: target,
            ref: ref
        }, children));
        if (onClick) return /*#__PURE__*/ $5FkrB.createElement((0, $605ff0fe25231d2b$export$27c701ed9e449e99), {
            testId: testId,
            onClick: onClick,
            xcss: (0, $b5cd78e10bc362b2$export$a274e22fb40f762e)($3fe662b077bc761a$var$styles.common, $3fe662b077bc761a$var$styles.pressable, (0, $2fcbb5e4cf9206d1$export$b40ec24ac8275656)('platform-dst-shape-theme-default') && $3fe662b077bc761a$var$styles.pressableT26Shape),
            ref: ref
        }, children);
        return /*#__PURE__*/ $5FkrB.createElement((0, $f3b0d8b8c6613242$export$e71c4d32a2263218), {
            as: "span",
            testId: testId,
            xcss: $3fe662b077bc761a$var$styles.common,
            ref: ref
        }, children);
    }
    // TODO: Remove this once the deprecated `linkComponent` prop is removed.
    return onClick || href ? /*#__PURE__*/ $5FkrB.createElement((0, $7fdc7055b6e0a177$export$2e2bcd8739ae039), {
        testId: testId,
        appearance: "link",
        spacing: "none",
        onClick: onClick,
        href: href,
        component: href ? linkComponent : undefined,
        ref: ref
    }, children) : /*#__PURE__*/ $5FkrB.createElement((0, $5FkrB.Fragment), null, children);
}));
$3fe662b077bc761a$var$SectionMessageAction.displayName = 'SectionMessageAction';
var $3fe662b077bc761a$export$2e2bcd8739ae039 = $3fe662b077bc761a$var$SectionMessageAction;



var $6bnW7 = parcelRequire("6bnW7");
var $bgNpv = parcelRequire("bgNpv");
var $hrVKU = parcelRequire("hrVKU");
parcelRequire("5FkrB");
const $8b2e252b2574531c$var$messages = (0, $6bnW7.defineMessages)({
    description: {
        id: 'auth-section-description',
        defaultMessage: "We've changed how permissions work, so apps can now request only the information they need.",
        description: 'Description for oauth explanation of permissions change'
    },
    learnMore: {
        id: 'auth-section-learn-more',
        defaultMessage: 'Learn more',
        description: 'Link to learn more about oauth'
    },
    title: {
        id: 'auth-section-title',
        defaultMessage: 'Apps are becoming more transparent',
        description: 'Title for the auth section message'
    }
});
const $8b2e252b2574531c$var$AuthMessage = ()=>{
    const { formatMessage: formatMessage } = (0, $hrVKU.default)();
    return /*#__PURE__*/ (0, $i3UfC.jsx)((0, $ac2404b057b8688e$export$2e2bcd8739ae039), {
        title: formatMessage($8b2e252b2574531c$var$messages.title),
        actions: [
            /*#__PURE__*/ (0, $i3UfC.jsx)((0, $3fe662b077bc761a$export$2e2bcd8739ae039), {
                href: "https://www.atlassian.com/legal/privacy-policy#what-this-policy-covers",
                children: formatMessage($8b2e252b2574531c$var$messages.learnMore)
            }, 'test')
        ],
        children: /*#__PURE__*/ (0, $i3UfC.jsx)((0, $bgNpv.default), {
            ...$8b2e252b2574531c$var$messages.description,
            tagName: "p"
        })
    });
};
var $8b2e252b2574531c$export$2e2bcd8739ae039 = $8b2e252b2574531c$var$AuthMessage;



var $i3UfC = parcelRequire("i3UfC");

var $6bnW7 = parcelRequire("6bnW7");
var $bgNpv = parcelRequire("bgNpv");


var $gDiFE = parcelRequire("gDiFE");
const $bced07e497c74911$var$messages = (0, $6bnW7.defineMessages)({
    agreementHeader: {
        id: 'ooauth.bestPracticesHeader',
        defaultMessage: 'By accepting this app, you:',
        description: 'The header for oath legal terms'
    },
    agreementBulletOne: {
        id: 'oauth.bestPracticesBulletOne',
        defaultMessage: 'Grant the app access to your data in all places you can access where the app is installed.',
        description: 'First oauth terms of agreement'
    },
    agreementBulletTwo: {
        id: 'oauth.bestPracticesBulletTwo',
        defaultMessage: 'Agree to the {privacyPolicyLink} and {termsOfUseLink}',
        description: 'Second oath terms of agreement. The privacyPolicyLink and termsOfUseLink are replaced with actual links in the UI.'
    },
    privacyPolicy: {
        id: 'oauth.privacyPolicy',
        defaultMessage: 'privacy policy',
        description: 'Text for the privacy policy link'
    },
    termsOfUse: {
        id: 'oauth.termsOfUse',
        defaultMessage: 'terms of use',
        description: 'Text for the terms of use link'
    },
    usersConsented: {
        id: 'oauth.usersConsented',
        defaultMessage: '{numOfUsersConsented} {numOfUsersConsented, plural, one {user has} other {users have}} consented to using test oauth',
        description: 'How many users have already consented'
    }
});
const $bced07e497c74911$var$disclaimerStyle = (0, $gDiFE.xcss)({
    color: 'color.text.subtle',
    font: 'font.body.small'
});
const $bced07e497c74911$var$NUM_USERS_CONSENTED = 0;
const $bced07e497c74911$var$LegalDisclaimer = ()=>{
    const privacyPolicyLink = /*#__PURE__*/ (0, $i3UfC.jsx)((0, $64e95b69a05329e9$export$2e2bcd8739ae039), {
        href: "https://www.atlassian.com/legal/privacy-policy#what-this-policy-covers",
        children: /*#__PURE__*/ (0, $i3UfC.jsx)((0, $bgNpv.default), {
            ...$bced07e497c74911$var$messages.privacyPolicy
        })
    });
    const termsOfUseLink = /*#__PURE__*/ (0, $i3UfC.jsx)((0, $64e95b69a05329e9$export$2e2bcd8739ae039), {
        href: "https://www.atlassian.com/legal/atlassian-customer-agreement#intro",
        children: /*#__PURE__*/ (0, $i3UfC.jsx)((0, $bgNpv.default), {
            ...$bced07e497c74911$var$messages.termsOfUse
        })
    });
    return /*#__PURE__*/ (0, $i3UfC.jsxs)((0, $383dd904a5a5e5b0$export$e71c4d32a2263218), {
        xcss: $bced07e497c74911$var$disclaimerStyle,
        children: [
            /*#__PURE__*/ (0, $i3UfC.jsx)((0, $bgNpv.default), {
                ...$bced07e497c74911$var$messages.agreementHeader,
                tagName: "p"
            }),
            /*#__PURE__*/ (0, $i3UfC.jsxs)("ul", {
                children: [
                    /*#__PURE__*/ (0, $i3UfC.jsx)("li", {
                        children: /*#__PURE__*/ (0, $i3UfC.jsx)((0, $bgNpv.default), {
                            ...$bced07e497c74911$var$messages.agreementBulletOne
                        })
                    }),
                    /*#__PURE__*/ (0, $i3UfC.jsx)("li", {
                        children: /*#__PURE__*/ (0, $i3UfC.jsx)((0, $bgNpv.default), {
                            ...$bced07e497c74911$var$messages.agreementBulletTwo,
                            values: {
                                privacyPolicyLink: privacyPolicyLink,
                                termsOfUseLink: termsOfUseLink
                            }
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $i3UfC.jsx)((0, $bgNpv.default), {
                ...$bced07e497c74911$var$messages.usersConsented,
                values: {
                    numOfUsersConsented: $bced07e497c74911$var$NUM_USERS_CONSENTED
                },
                tagName: "p"
            })
        ]
    });
};
var $bced07e497c74911$export$2e2bcd8739ae039 = $bced07e497c74911$var$LegalDisclaimer;



var $i3UfC = parcelRequire("i3UfC");
/* main.tsx generated by @compiled/babel-plugin v0.39.1 */ function $5c16b2e388e82771$export$2e2bcd8739ae039(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}


function $acfcd5b984b7c9cb$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return (0, $5c16b2e388e82771$export$2e2bcd8739ae039)(r);
}


function $19e377bf2211345b$export$2e2bcd8739ae039(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}



function $87a445a73c2edbeb$export$2e2bcd8739ae039(r, a) {
    if (r) {
        if ("string" == typeof r) return (0, $5c16b2e388e82771$export$2e2bcd8739ae039)(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? (0, $5c16b2e388e82771$export$2e2bcd8739ae039)(r, a) : void 0;
    }
}


function $7c3b1818ff0e3b27$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}


function $4a517cd18e4d856d$export$2e2bcd8739ae039(r) {
    return (0, $acfcd5b984b7c9cb$export$2e2bcd8739ae039)(r) || (0, $19e377bf2211345b$export$2e2bcd8739ae039)(r) || (0, $87a445a73c2edbeb$export$2e2bcd8739ae039)(r) || (0, $7c3b1818ff0e3b27$export$2e2bcd8739ae039)();
}


function $39cd338b0da6756c$export$2e2bcd8739ae039() {
    return $39cd338b0da6756c$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $39cd338b0da6756c$export$2e2bcd8739ae039.apply(null, arguments);
}


function $0b523edb8529c7db$export$2e2bcd8739ae039(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}


function $b45e4aa52a06dd77$export$2e2bcd8739ae039(e, t) {
    if (null == e) return {};
    var o, r, i = (0, $0b523edb8529c7db$export$2e2bcd8739ae039)(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}


function $0c869c4d357d4538$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return r;
}


function $cb94034f50b5d347$export$2e2bcd8739ae039(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}



function $d23e5f095c51ea69$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}


function $958636c847d8b316$export$2e2bcd8739ae039(r, e) {
    return (0, $0c869c4d357d4538$export$2e2bcd8739ae039)(r) || (0, $cb94034f50b5d347$export$2e2bcd8739ae039)(r, e) || (0, $87a445a73c2edbeb$export$2e2bcd8739ae039)(r, e) || (0, $d23e5f095c51ea69$export$2e2bcd8739ae039)();
}


/**
 * This length includes the underscore,
 * e.g. `"_1s4A"` would be a valid atomic group hash.
 */ const $c4f3fc62d4a10748$var$ATOMIC_GROUP_LENGTH = 5;
function $c4f3fc62d4a10748$export$2e2bcd8739ae039(classNames) {
    // Shortcut: nothing to do
    if (!classNames.length) return;
    // Shortcut: don't need to do anything if we only have a single classname
    if (classNames.length === 1 && classNames[0] && // checking to see if `classNames[0]` is a string that contains other classnames
    !classNames[0].includes(' ')) return classNames[0];
    // Using an object rather than a `Map` as it performed better in our benchmarks.
    // Would be happy to move to `Map` if it proved to be better under real conditions.
    const map = {};
    // Note: using loops to minimize iterations over the collection
    for (const value of classNames){
        // Exclude all falsy values, which leaves us with populated strings
        if (!value) continue;
        // a `value` can contain multiple classnames
        const list = value.split(' ');
        for (const className of list){
            /**
             * For atomic style classnames: the `key` is the `group`
             *
             * - Later atomic classnames with the same `group` will override earlier ones
             *   (which is what we want).
             * - Assumes atomic classnames are the only things that start with `_`
             * - Could use a regex to ensure that atomic classnames are structured how we expect,
             *   but did not add that for now as it did slow things down a bit.
             *
             * For other classnames: the `key` is the whole classname
             * - Okay to remove duplicates as doing so does not impact specificity
             *
             * */ const key = className.startsWith('_') ? className.slice(0, $c4f3fc62d4a10748$var$ATOMIC_GROUP_LENGTH) : className;
            map[key] = className;
        }
    }
    /**
     * We are converting the `map` into a string.
     *
     * The simple way to do this would be `Object.values(map).join(' ')`.
     * However, the approach below performs 10%-20% better in benchmarks.
     *
     * For `ax()` it feels right to squeeze as much runtime performance out as we can.
     */ let result = '';
    for(const key in map)result += map[key] + ' ';
    // If we have an empty string, then our `map` was empty.
    if (!result) return;
    // remove last " " from the result (we added " " at the end of every value)
    return result.trimEnd();
}



var $5FkrB = parcelRequire("5FkrB");

var $5FkrB = parcelRequire("5FkrB");

var $5FkrB = parcelRequire("5FkrB");
/**
 * generates a UID factory
 * @internal
 * @example
 * const uid = generateUID();
 * uid(object) = 1;
 * uid(object) = 1;
 * uid(anotherObject) = 2;
 */ var $e9ce486011a08a46$export$bdbb4cbb3078e58d = function() {
    var counter = 1;
    var map = new WeakMap();
    /**
     * @borrows {uid}
     */ var uid = function(item, index) {
        if (typeof item === 'number' || typeof item === 'string') return index ? "idx-".concat(index) : "val-".concat(item);
        if (!map.has(item)) {
            map.set(item, counter++);
            return uid(item);
        }
        return 'uid' + map.get(item);
    };
    return uid;
};
var $e9ce486011a08a46$export$e2a22331486dcca0 = $e9ce486011a08a46$export$bdbb4cbb3078e58d();


var $878686cdae50c4f9$export$1921362e86c73c88 = function(prefix) {
    if (prefix === void 0) prefix = '';
    return {
        value: 1,
        prefix: prefix,
        uid: (0, $e9ce486011a08a46$export$bdbb4cbb3078e58d)()
    };
};
var $878686cdae50c4f9$export$e575061ef2a070eb = $878686cdae50c4f9$export$1921362e86c73c88();
var $878686cdae50c4f9$export$b4d5da5f34fb77ad = $5FkrB.createContext($878686cdae50c4f9$export$1921362e86c73c88());
var $878686cdae50c4f9$export$218c8c3169c024d2 = function(source) {
    return source.value++;
};
var $878686cdae50c4f9$export$36e24695f02d4503 = function(source) {
    return source ? source.prefix : '';
};


var $8120b68af314e225$var$generateUID = function(context) {
    var quartz = context || (0, $878686cdae50c4f9$export$e575061ef2a070eb);
    var prefix = (0, $878686cdae50c4f9$export$36e24695f02d4503)(quartz);
    var id = (0, $878686cdae50c4f9$export$218c8c3169c024d2)(quartz);
    var uid = prefix + id;
    var gen = function(item) {
        return uid + quartz.uid(item);
    };
    return {
        uid: uid,
        gen: gen
    };
};
var $8120b68af314e225$var$useUIDState = function() {
    var context = (0, $5FkrB.useContext)((0, $878686cdae50c4f9$export$b4d5da5f34fb77ad));
    var uid = (0, $5FkrB.useState)(function() {
        return $8120b68af314e225$var$generateUID(context);
    })[0];
    return uid;
};
var $8120b68af314e225$export$87d05f07e65211f1 = function() {
    var uid = $8120b68af314e225$var$useUIDState().uid;
    return uid;
};
var $8120b68af314e225$export$bb5ca5fba6fb4f1f = function() {
    var gen = $8120b68af314e225$var$useUIDState().gen;
    return gen;
};






var $5FkrB = parcelRequire("5FkrB");




var $5FkrB = parcelRequire("5FkrB");

var $2nBsU = parcelRequire("2nBsU");
function $93e95126a5cec975$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $93e95126a5cec975$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $93e95126a5cec975$export$2e2bcd8739ae039(o);
}



function $8e07d0de6fa68edd$export$2e2bcd8739ae039(t, r) {
    if ("object" != (0, $93e95126a5cec975$export$2e2bcd8739ae039)(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (0, $93e95126a5cec975$export$2e2bcd8739ae039)(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}


function $19402567eb729fc8$export$2e2bcd8739ae039(t) {
    var i = (0, $8e07d0de6fa68edd$export$2e2bcd8739ae039)(t, "string");
    return "symbol" == (0, $93e95126a5cec975$export$2e2bcd8739ae039)(i) ? i : i + "";
}


function $5bc9a370f4de45ae$export$2e2bcd8739ae039(e, r, t) {
    return (r = (0, $19402567eb729fc8$export$2e2bcd8739ae039)(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}



var $5FkrB = parcelRequire("5FkrB");


function $ad05016a8a78b31b$export$2e2bcd8739ae039(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}



function $7ee2b561172d79b0$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, (0, $19402567eb729fc8$export$2e2bcd8739ae039)(o.key), o);
    }
}
function $7ee2b561172d79b0$export$2e2bcd8739ae039(e, r, t) {
    return r && $7ee2b561172d79b0$var$_defineProperties(e.prototype, r), t && $7ee2b561172d79b0$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}



function $f7cc8fc6d3449d1d$export$2e2bcd8739ae039(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
}


function $9582c8784cf8b6c8$export$2e2bcd8739ae039(t, e) {
    if (e && ("object" == (0, $93e95126a5cec975$export$2e2bcd8739ae039)(e) || "function" == typeof e)) return e;
    if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
    return (0, $f7cc8fc6d3449d1d$export$2e2bcd8739ae039)(t);
}


function $8b393915e29091af$export$2e2bcd8739ae039(t) {
    return $8b393915e29091af$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
        return t.__proto__ || Object.getPrototypeOf(t);
    }, $8b393915e29091af$export$2e2bcd8739ae039(t);
}



function $a7fb000a70d6ee92$export$2e2bcd8739ae039(t, o) {
    for(; !({}).hasOwnProperty.call(t, o) && null !== (t = (0, $8b393915e29091af$export$2e2bcd8739ae039)(t)););
    return t;
}


function $761b44f0bf5ccff0$export$2e2bcd8739ae039() {
    return $761b44f0bf5ccff0$export$2e2bcd8739ae039 = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function(e, t, r) {
        var p = (0, $a7fb000a70d6ee92$export$2e2bcd8739ae039)(e, t);
        if (p) {
            var n = Object.getOwnPropertyDescriptor(p, t);
            return n.get ? n.get.call(arguments.length < 3 ? e : r) : n.value;
        }
    }, $761b44f0bf5ccff0$export$2e2bcd8739ae039.apply(null, arguments);
}


function $6fc3cab695171a3b$export$2e2bcd8739ae039(t, e) {
    return $6fc3cab695171a3b$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, $6fc3cab695171a3b$export$2e2bcd8739ae039(t, e);
}


function $269fa44e33e7cdcd$export$2e2bcd8739ae039(t, e) {
    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
    t.prototype = Object.create(e && e.prototype, {
        constructor: {
            value: t,
            writable: !0,
            configurable: !0
        }
    }), Object.defineProperty(t, "prototype", {
        writable: !1
    }), e && (0, $6fc3cab695171a3b$export$2e2bcd8739ae039)(t, e);
}







function $c554c7047b9b7885$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $c554c7047b9b7885$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $c554c7047b9b7885$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $5bc9a370f4de45ae$export$2e2bcd8739ae039)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $c554c7047b9b7885$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $c554c7047b9b7885$export$ad4be5c2ec28cecf = function isAnalyticsEvent(obj) {
    var _obj$constructor;
    return obj instanceof $c554c7047b9b7885$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 || (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === 'AnalyticsEvent';
};
// eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
var $c554c7047b9b7885$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function AnalyticsEvent(props) {
        var _this = this;
        (0, $ad05016a8a78b31b$export$2e2bcd8739ae039)(this, AnalyticsEvent);
        (0, $5bc9a370f4de45ae$export$2e2bcd8739ae039)(this, "_isAnalyticsEvent", true);
        (0, $5bc9a370f4de45ae$export$2e2bcd8739ae039)(this, "clone", function() {
            // just a shallow clone, don't change sub refs unless you want to
            // affect the original's too
            var payload = $c554c7047b9b7885$var$_objectSpread({}, _this.payload);
            return new AnalyticsEvent({
                payload: payload
            });
        });
        this.payload = props.payload;
    }
    return (0, $7ee2b561172d79b0$export$2e2bcd8739ae039)(AnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (typeof updater === 'function') this.payload = updater(this.payload);
                if ((0, $93e95126a5cec975$export$2e2bcd8739ae039)(updater) === 'object') this.payload = $c554c7047b9b7885$var$_objectSpread($c554c7047b9b7885$var$_objectSpread({}, this.payload), updater);
                return this;
            }
        }
    ]);
}();


function $0398c79bc23e3317$var$_callSuper(t, o, e) {
    return o = (0, $8b393915e29091af$export$2e2bcd8739ae039)(o), (0, $9582c8784cf8b6c8$export$2e2bcd8739ae039)(t, $0398c79bc23e3317$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, $8b393915e29091af$export$2e2bcd8739ae039)(t).constructor) : o.apply(t, e));
}
function $0398c79bc23e3317$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($0398c79bc23e3317$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $0398c79bc23e3317$var$_superPropGet(t, o, e, r) {
    var p = (0, $761b44f0bf5ccff0$export$2e2bcd8739ae039)((0, $8b393915e29091af$export$2e2bcd8739ae039)(1 & r ? t.prototype : t), o, e);
    return 2 & r && "function" == typeof p ? function(t) {
        return p.apply(e, t);
    } : p;
}
var $0398c79bc23e3317$export$35f8383928ba8d7 = function isUIAnalyticsEvent(obj) {
    var _obj$constructor;
    return obj instanceof $0398c79bc23e3317$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isUIAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 || (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === 'UIAnalyticsEvent';
};
// eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
var $0398c79bc23e3317$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_AnalyticsEvent) {
    function UIAnalyticsEvent(props) {
        var _this;
        (0, $ad05016a8a78b31b$export$2e2bcd8739ae039)(this, UIAnalyticsEvent);
        _this = $0398c79bc23e3317$var$_callSuper(this, UIAnalyticsEvent, [
            props
        ]);
        (0, $5bc9a370f4de45ae$export$2e2bcd8739ae039)(_this, "_isUIAnalyticsEvent", true);
        (0, $5bc9a370f4de45ae$export$2e2bcd8739ae039)(_this, "clone", function() {
            if (_this.hasFired) return null;
            var context = (0, $4a517cd18e4d856d$export$2e2bcd8739ae039)(_this.context);
            var handlers = (0, $4a517cd18e4d856d$export$2e2bcd8739ae039)(_this.handlers);
            /**
       * A hacky "deep clone" of the object. This is limited in that it wont
       * support functions, regexs, Maps, Sets, etc, but none of those need to
       * be represented in our payload.
       */ var payload = JSON.parse(JSON.stringify(_this.payload));
            return new UIAnalyticsEvent({
                context: context,
                handlers: handlers,
                payload: payload
            });
        });
        (0, $5bc9a370f4de45ae$export$2e2bcd8739ae039)(_this, "fire", function(channel) {
            if (_this.hasFired) return;
            _this.handlers.forEach(function(handler) {
                try {
                    handler(_this, channel);
                } catch (e) {}
            });
            _this.hasFired = true;
        });
        _this.context = props.context || [];
        _this.handlers = props.handlers || [];
        _this.hasFired = false;
        return _this;
    }
    (0, $269fa44e33e7cdcd$export$2e2bcd8739ae039)(UIAnalyticsEvent, _AnalyticsEvent);
    return (0, $7ee2b561172d79b0$export$2e2bcd8739ae039)(UIAnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (this.hasFired) return this;
                return $0398c79bc23e3317$var$_superPropGet(UIAnalyticsEvent, "update", this, 3)([
                    updater
                ]);
            }
        }
    ]);
}((0, $c554c7047b9b7885$export$2e2bcd8739ae039));



var $5FkrB = parcelRequire("5FkrB");

var $a19e0afdc0b0adbb$export$d1f587f82ad51c4 = function useAnalyticsContext() {
    return (0, $5FkrB.useContext)((0, $d82667e77467cbe0$export$2e2bcd8739ae039));
};


function $1e9ee7def79e1108$export$5bf35293e545f20c() {
    var analyticsContext = (0, $a19e0afdc0b0adbb$export$d1f587f82ad51c4)();
    var createAnalyticsEvent = (0, $a060da77483cc5d3$export$33752cf3ee811995)(function(payload) {
        return new (0, $0398c79bc23e3317$export$2e2bcd8739ae039)({
            context: analyticsContext.getAtlaskitAnalyticsContext(),
            handlers: analyticsContext.getAtlaskitAnalyticsEventHandlers(),
            payload: payload
        });
    }, [
        analyticsContext
    ]);
    return {
        createAnalyticsEvent: createAnalyticsEvent
    };
}



var $5FkrB = parcelRequire("5FkrB");
var $d0ce7595c7311072$export$1d27a74659855e44 = function useTrackedRef(value) {
    var ref = (0, $5FkrB.useRef)(value);
    ref.current = value;
    return ref;
};


function $14957ca320230412$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $14957ca320230412$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $14957ca320230412$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $5bc9a370f4de45ae$export$2e2bcd8739ae039)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $14957ca320230412$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $14957ca320230412$export$a4687b0234b40e28(_ref) {
    var fn = _ref.fn, action = _ref.action, componentName = _ref.componentName, actionSubject = _ref.actionSubject, packageName = _ref.packageName, packageVersion = _ref.packageVersion, analyticsData = _ref.analyticsData;
    var _useAnalyticsEvents = (0, $1e9ee7def79e1108$export$5bf35293e545f20c)(), createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
    // We put analyticsData and fn in a ref so that we don't need to break
    // memoization.
    // Generally these could be defined by consumers inline
    // and so we do this to avoid breaking memoization of useCallback
    var dataRef = (0, $d0ce7595c7311072$export$1d27a74659855e44)(analyticsData);
    var fnRef = (0, $d0ce7595c7311072$export$1d27a74659855e44)(fn);
    var handler = (0, $5FkrB.useCallback)(function(value) {
        var analyticsEvent = createAnalyticsEvent({
            action: action,
            actionSubject: actionSubject || componentName,
            attributes: {
                componentName: componentName,
                packageName: packageName,
                packageVersion: packageVersion
            }
        });
        // To avoid wrapping this component in AnalyticsContext we manually
        // push the parent context's meta data into the context.
        // Note: this new 'context'
        var context = $14957ca320230412$var$_objectSpread({
            componentName: componentName,
            packageName: packageName,
            packageVersion: packageVersion
        }, dataRef.current);
        analyticsEvent.context.push(context);
        // fire an event on the atlaskit channel
        var clone = analyticsEvent.clone();
        if (clone) clone.fire('atlaskit');
        fnRef.current(value, analyticsEvent);
    }, [
        // These are strings and won't change
        action,
        componentName,
        actionSubject,
        packageName,
        packageVersion,
        // This function is memoized in the context
        createAnalyticsEvent,
        // these are a stable ref because of the useTrackedRef hook
        dataRef,
        fnRef
    ]);
    return handler;
}




/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5FkrB = parcelRequire("5FkrB");

var $2nBsU = parcelRequire("2nBsU");
var $21e2204184769b87$var$BORDER_WIDTH = 2;
var $21e2204184769b87$var$baseFocusOutsideStyles = (0, $2nBsU.css)({
    outline: "var(--ds-border-width-focused, 2px)".concat(" solid ", "var(--ds-border-focused, #4688EC)"),
    outlineOffset: $21e2204184769b87$var$BORDER_WIDTH
});
var $21e2204184769b87$var$baseInsetStyles = (0, $2nBsU.css)({
    outlineColor: "var(--ds-border-focused, #4688EC)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    outlineOffset: -$21e2204184769b87$var$BORDER_WIDTH,
    outlineStyle: 'solid',
    outlineWidth: "var(--ds-border-width-focused, 2px)"
});
var $21e2204184769b87$var$focusRingStyles = (0, $2nBsU.css)({
    // Focus styles used when :focus-visible isn't supported
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
    '&:focus': $21e2204184769b87$var$baseFocusOutsideStyles,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
    '&:focus-visible': $21e2204184769b87$var$baseFocusOutsideStyles,
    // Remove default focus styles for mouse interactions if :focus-visible is supported
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
    '&:focus:not(:focus-visible)': {
        outline: 'none'
    },
    '@media screen and (forced-colors: active), screen and (-ms-high-contrast: active)': {
        '&:focus-visible': {
            outline: "var(--ds-border-width, 1px)".concat(" solid")
        }
    }
});
var $21e2204184769b87$var$insetFocusRingStyles = (0, $2nBsU.css)({
    // Focus styles used when :focus-visible isn't supported
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
    '&:focus': $21e2204184769b87$var$baseInsetStyles,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
    '&:focus-visible': $21e2204184769b87$var$baseInsetStyles,
    // Remove default focus styles for mouse interactions if :focus-visible is supported
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
    '&:focus:not(:focus-visible)': {
        outline: 'none'
    },
    '@media screen and (forced-colors: active), screen and (-ms-high-contrast: active)': {
        '&:focus-visible': {
            outline: "var(--ds-border-width, 1px)".concat(" solid"),
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
            outlineOffset: '-1px'
        }
    }
});
/**
 * __Focus ring__
 *
 * A focus ring visually indicates the currently focused item.
 *
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/focus-ring)
 *
 * @example
 * ```jsx
 * import FocusRing from '@atlaskit/focus-ring';
 *
 * const InteractiveComponent = () => (
 *   <FocusRing>
 *     <button type="button">Hello</button>
 *   </FocusRing>
 * )
 * ```
 */ var $21e2204184769b87$var$FocusRing = /*#__PURE__*/ (0, $5FkrB.memo)(function(_ref) {
    var children = _ref.children, isInset = _ref.isInset, focus = _ref.focus;
    var controlledStyles = isInset ? $21e2204184769b87$var$baseInsetStyles : $21e2204184769b87$var$baseFocusOutsideStyles;
    var uncontrolledStyles = isInset ? $21e2204184769b87$var$insetFocusRingStyles : $21e2204184769b87$var$focusRingStyles;
    var focusCls = typeof focus === 'undefined' ? uncontrolledStyles : focus === 'on' && controlledStyles;
    return (0, $2nBsU.jsx)((0, $2nBsU.ClassNames), null, function(_ref2) {
        var css = _ref2.css, cx = _ref2.cx;
        return (0, $5FkrB.Children).only(// This may look unwieldy but means we skip applying styles / cloning if no className is applicable
        focusCls ? /*#__PURE__*/ // eslint-disable-next-line @repo/internal/react/no-clone-element
        (0, $5FkrB.cloneElement)(children, {
            className: cx([
                css(focusCls),
                children.props.className
            ])
        }) : children);
    });
});
$21e2204184769b87$var$FocusRing.displayName = 'FocusRing';
var $21e2204184769b87$export$2e2bcd8739ae039 = $21e2204184769b87$var$FocusRing;



function $fbd2a99807a9c396$var$abort(event) {
    event.preventDefault();
    event.stopPropagation();
}
var $fbd2a99807a9c396$var$tabKeyCode = 9;
function $fbd2a99807a9c396$var$onKey(event) {
    // Allowing tab so that a user can move focus away
    if (event.keyCode === $fbd2a99807a9c396$var$tabKeyCode) return;
    $fbd2a99807a9c396$var$abort(event);
}
var $fbd2a99807a9c396$var$block = {
    onMouseDownCapture: $fbd2a99807a9c396$var$abort,
    onMouseUpCapture: $fbd2a99807a9c396$var$abort,
    // because we have tabIndex = -1 when disabled,
    // keyboard events can only occur when there is an overlay
    onKeyDownCapture: $fbd2a99807a9c396$var$onKey,
    onKeyUpCapture: $fbd2a99807a9c396$var$onKey,
    onTouchStartCapture: $fbd2a99807a9c396$var$abort,
    onTouchEndCapture: $fbd2a99807a9c396$var$abort,
    onPointerDownCapture: $fbd2a99807a9c396$var$abort,
    onPointerUpCapture: $fbd2a99807a9c396$var$abort,
    onClickCapture: $fbd2a99807a9c396$var$abort,
    // Just smashing the existing onClick for good measure
    onClick: $fbd2a99807a9c396$var$abort
};
var $fbd2a99807a9c396$var$doNotBlock = {};
function $fbd2a99807a9c396$export$2e2bcd8739ae039(_ref) {
    var isInteractive = _ref.isInteractive;
    return isInteractive ? $fbd2a99807a9c396$var$doNotBlock : $fbd2a99807a9c396$var$block;
}


// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $2nBsU = parcelRequire("2nBsU");
function $971e8da5f3be68d0$export$7ad0316cc0dd65a(_ref) {
    var spacing = _ref.spacing;
    return (0, $2nBsU.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        margin: spacing === 'none' ? 0 : '0 2px',
        // content can grow and shrink
        flexGrow: 1,
        flexShrink: 1,
        // ellipsis for overflow text
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap'
    });
}


// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $2nBsU = parcelRequire("2nBsU");
function $ad87abd01fa5f8cd$export$1b5827d324e945b1(_ref) {
    var hasOverlay = _ref.hasOverlay;
    return (0, $2nBsU.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        opacity: hasOverlay ? 0 : 1,
        transition: 'opacity 0.3s'
    });
}


// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $2nBsU = parcelRequire("2nBsU");
function $133ac92d90c63d45$export$864eea3f4ec3368f(_ref) {
    var spacing = _ref.spacing;
    return (0, $2nBsU.css)({
        display: 'flex',
        // icon size cannot grow and shrink
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        margin: spacing === 'none' ? 0 : "0 2px",
        flexGrow: 0,
        flexShrink: 0,
        alignSelf: 'center',
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        fontSize: 0,
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        lineHeight: 0,
        userSelect: 'none'
    });
}



var $5FkrB = parcelRequire("5FkrB");
/* visually-hidden.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $5FkrB = parcelRequire("5FkrB");

var $2bb018ecc2c43f10$var$visuallyHiddenStyles = null;
/**
 * __Visually hidden__
 *
 * A composable element to apply a visually hidden effect to children.
 * Useful for accessibility compliance.
 *
 * @example
 * ```jsx
 * import VisuallyHidden from '@atlaskit/visually-hidden';
 *
 * export default () => (
 *   <div style={{ border: '1px solid black' }}>
 *      There is text hidden between the brackets [
 *      <VisuallyHidden>Can't see me!</VisuallyHidden>]
 *   </div>
 * );
 * ```
 */ var $2bb018ecc2c43f10$var$VisuallyHidden = function VisuallyHidden(_ref) {
    var children = _ref.children, testId = _ref.testId, role = _ref.role, id = _ref.id;
    return /*#__PURE__*/ $5FkrB.createElement("span", {
        id: id,
        "data-testid": testId,
        role: role,
        className: (0, $c4f3fc62d4a10748$export$2e2bcd8739ae039)([
            "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19itidpf _1reo15vq _18m915vq _1bsbt94y _4t3it94y _kqswstnw _ogto7mnp _uiztglyw _o5721q9c"
        ])
    }, children);
};
$2bb018ecc2c43f10$var$VisuallyHidden.displayName = 'VisuallyHidden';
var $2bb018ecc2c43f10$export$2e2bcd8739ae039 = $2bb018ecc2c43f10$var$VisuallyHidden;


var $8d5406764a72913d$export$20bbd2efb0d734c4 = function getIfVisuallyHiddenChildren(children) {
    return children && /*#__PURE__*/ (0, $5FkrB.isValidElement)(children) && children.type === (0, $2bb018ecc2c43f10$export$2e2bcd8739ae039);
};


// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
var $4c2aee64de485732$export$1a9fe1b84c876bb5 = {
    // stretching to full width / height of button
    // this is important as we need it to still block
    // event if clicking in the button's own padding
    position: 'absolute',
    left: 0,
    top: 0,
    right: 0,
    bottom: 0,
    // Putting all children in the center
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
};


var $01cec818d83ffd40$var$_excluded = [
    "analyticsContext",
    "appearance",
    "autoFocus",
    "buttonCss",
    "children",
    "className",
    "href",
    "component",
    "iconAfter",
    "iconBefore",
    "interactionName",
    "isDisabled",
    "isSelected",
    "onBlur",
    "onClick",
    "onFocus",
    "onMouseDown",
    "overlay",
    "shouldFitContainer",
    "spacing",
    "tabIndex",
    "type",
    "testId"
];
// Disabled buttons will still publish events for nested elements in webkit.
// We are disabling pointer events on child elements so that
// the button will always be the target of events
// Note: firefox does not have this behaviour for child elements
var $01cec818d83ffd40$var$noPointerEventsOnChildrenCss = {
    '> *': {
        pointerEvents: 'none'
    }
};
/**
 * These CSS variables consumed by the new icons, to allow them to have appropriate
 * padding inside Button while also maintaining spacing for the existing icons.
 *
 * These styles can be removed once the new icons are fully rolled out, feature flag
 * platform-visual-refresh-icons is cleaned up,
 * and we bump Button to set padding based on the new icons.
 */ var $01cec818d83ffd40$var$iconBeforeSpacingFixStyle = (0, $2nBsU.css)({
    '--ds--button--new-icon-padding-end': "var(--ds-space-025, 2px)",
    '--ds--button--new-icon-padding-start': "var(--ds-space-050, 4px)",
    marginInlineStart: "var(--ds-space-negative-025, -2px)"
});
var $01cec818d83ffd40$var$iconAfterSpacingFixStyle = (0, $2nBsU.css)({
    '--ds--button--new-icon-padding-end': "var(--ds-space-050, 4px)",
    '--ds--button--new-icon-padding-start': "var(--ds-space-025, 2px)",
    marginInlineEnd: "var(--ds-space-negative-025, -2px)"
});
var $01cec818d83ffd40$var$getSpacingFix = function getSpacingFix(children, spacingStyles) {
    if (!children || (0, $8d5406764a72913d$export$20bbd2efb0d734c4)(children)) return null;
    return spacingStyles;
};
var $01cec818d83ffd40$var$getChildren = function getChildren(children, childrenStyles) {
    if ((0, $8d5406764a72913d$export$20bbd2efb0d734c4)(children)) return children;
    return children ? (0, $2nBsU.jsx)("span", {
        css: childrenStyles
    }, children) : null;
};
var $01cec818d83ffd40$var$ButtonBase = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).forwardRef(function ButtonBase(props, ref) {
    var analyticsContext = props.analyticsContext, _props$appearance = props.appearance, appearance = _props$appearance === void 0 ? 'default' : _props$appearance, _props$autoFocus = props.autoFocus, autoFocus = _props$autoFocus === void 0 ? false : _props$autoFocus, buttonCss = props.buttonCss, children = props.children, className = props.className, href = props.href, _props$component = props.component, Component = _props$component === void 0 ? href ? 'a' : 'button' : _props$component, iconAfter = props.iconAfter, iconBefore = props.iconBefore, interactionName = props.interactionName, _props$isDisabled = props.isDisabled, isDisabled = _props$isDisabled === void 0 ? false : _props$isDisabled, _props$isSelected = props.isSelected, isSelected = _props$isSelected === void 0 ? false : _props$isSelected, onBlur = props.onBlur, _props$onClick = props.onClick, providedOnClick = _props$onClick === void 0 ? (0, $adcefb868cf2fc9d$export$2e2bcd8739ae039) : _props$onClick, onFocus = props.onFocus, _props$onMouseDown = props.onMouseDown, providedOnMouseDown = _props$onMouseDown === void 0 ? (0, $adcefb868cf2fc9d$export$2e2bcd8739ae039) : _props$onMouseDown, overlay = props.overlay, shouldFitContainer = props.shouldFitContainer, _props$spacing = props.spacing, spacing = _props$spacing === void 0 ? 'default' : _props$spacing, _props$tabIndex = props.tabIndex, tabIndex = _props$tabIndex === void 0 ? 0 : _props$tabIndex, _props$type = props.type, type = _props$type === void 0 ? !href ? 'button' : undefined : _props$type, testId = props.testId, rest = (0, $b45e4aa52a06dd77$export$2e2bcd8739ae039)(props, $01cec818d83ffd40$var$_excluded);
    var ourRef = (0, $5FkrB.useRef)();
    var setRef = (0, $5FkrB.useCallback)(function(node) {
        ourRef.current = node;
        if (ref == null) return;
        if (typeof ref === 'function') {
            ref(node);
            return;
        }
        // We can write to ref's `current` property, but Typescript does not like it.
        // @ts-ignore
        ref.current = node;
    }, [
        ourRef,
        ref
    ]);
    // Cross browser auto focusing is pretty broken, so we are doing it ourselves
    (0, $bf3b13d9d73de104$export$2e2bcd8739ae039)(ourRef, autoFocus);
    var interactionContext = (0, $5FkrB.useContext)((0, $a81fd7e45a8c2ef5$export$2e2bcd8739ae039));
    var handleClick = (0, $5FkrB.useCallback)(function(e, analyticsEvent) {
        interactionContext && interactionContext.tracePress(interactionName, e.timeStamp);
        providedOnClick(e, analyticsEvent);
    }, [
        providedOnClick,
        interactionContext,
        interactionName
    ]);
    var onClick = (0, $14957ca320230412$export$a4687b0234b40e28)({
        fn: handleClick,
        action: 'clicked',
        componentName: 'button',
        packageName: "@atlaskit/button",
        packageVersion: "24.2.0",
        analyticsData: analyticsContext
    });
    // Button currently calls preventDefault, which is not standard button behaviour
    var onMouseDown = (0, $5FkrB.useCallback)(function(event) {
        event.preventDefault();
        providedOnMouseDown(event);
    }, [
        providedOnMouseDown
    ]);
    // Lose focus when becoming disabled (standard button behaviour)
    (0, $5FkrB.useEffect)(function() {
        var el = ourRef.current;
        if (isDisabled && el && el === document.activeElement) el.blur();
    }, [
        isDisabled
    ]);
    // we are 'disabling' input with a button when there is an overlay
    var hasOverlay = Boolean(overlay);
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    var fadeStyles = (0, $2nBsU.css)((0, $ad87abd01fa5f8cd$export$1b5827d324e945b1)({
        hasOverlay: hasOverlay
    }));
    var isInteractive = !isDisabled && !hasOverlay;
    /**
   * HACK: Spinner needs to have different colours in the "new" tokens design compared to the old design.
   * For now, while we support both, these styles reach into Spinner when a theme is set, applies the right color.
   * Ticket to remove: https://product-fabric.atlassian.net/browse/DSP-2067.
   */ var spinnerHackCss = {};
    if (isSelected || isDisabled || appearance === 'warning') spinnerHackCss = {
        '[data-theme] & circle': {
            stroke: "".concat(isSelected || isDisabled ? "var(--ds-icon-subtle, #505258)" : "var(--ds-icon-warning-inverse, #292A2E)", " !important")
        }
    };
    return (0, $2nBsU.jsx)((0, $21e2204184769b87$export$2e2bcd8739ae039), null, (0, $2nBsU.jsx)(Component, (0, $39cd338b0da6756c$export$2e2bcd8739ae039)({}, rest, {
        ref: setRef,
        className: className,
        css: [
            buttonCss,
            isInteractive ? null : $01cec818d83ffd40$var$noPointerEventsOnChildrenCss
        ],
        "data-has-overlay": hasOverlay ? true : undefined,
        "data-testid": testId,
        disabled: isDisabled,
        href: isInteractive ? href : undefined,
        onBlur: onBlur,
        onClick: onClick,
        onFocus: onFocus,
        onMouseDown: onMouseDown,
        tabIndex: isDisabled ? -1 : tabIndex,
        type: type
    }, (0, $fbd2a99807a9c396$export$2e2bcd8739ae039)({
        isInteractive: isInteractive
    })), iconBefore ? (0, $2nBsU.jsx)("span", {
        css: [
            fadeStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $133ac92d90c63d45$export$864eea3f4ec3368f)({
                spacing: spacing
            }),
            $01cec818d83ffd40$var$getSpacingFix(children, $01cec818d83ffd40$var$iconBeforeSpacingFixStyle)
        ]
    }, iconBefore) : null, $01cec818d83ffd40$var$getChildren(children, [
        fadeStyles,
        (0, $971e8da5f3be68d0$export$7ad0316cc0dd65a)({
            spacing: spacing
        })
    ]), iconAfter ? (0, $2nBsU.jsx)("span", {
        css: [
            fadeStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $133ac92d90c63d45$export$864eea3f4ec3368f)({
                spacing: spacing
            }),
            $01cec818d83ffd40$var$getSpacingFix(children, $01cec818d83ffd40$var$iconAfterSpacingFixStyle)
        ]
    }, iconAfter) : null, overlay ? (0, $2nBsU.jsx)("span", {
        css: [
            (0, $4c2aee64de485732$export$1a9fe1b84c876bb5),
            spinnerHackCss
        ]
    }, overlay) : null));
});
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$01cec818d83ffd40$export$2e2bcd8739ae039 = $01cec818d83ffd40$var$ButtonBase;








function $149f9a5148f3c87f$var$asyncGeneratorStep(n, t, e, r, o, a, c) {
    try {
        var i = n[a](c), u = i.value;
    } catch (n) {
        return void e(n);
    }
    i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function $149f9a5148f3c87f$export$2e2bcd8739ae039(n) {
    return function() {
        var t = this, e = arguments;
        return new Promise(function(r, o) {
            var a = n.apply(t, e);
            function _next(n) {
                $149f9a5148f3c87f$var$asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
            }
            function _throw(n) {
                $149f9a5148f3c87f$var$asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
            }
            _next(void 0);
        });
    };
}





var $c99432794f8a5953$exports = {};
// TODO(Babel 8): Remove this file.

var $c99432794f8a5953$var$runtime = (parcelRequire("6qJuP"))();
$c99432794f8a5953$exports = $c99432794f8a5953$var$runtime;
// Copied from https://github.com/facebook/regenerator/blob/main/packages/runtime/runtime.js#L736=
try {
    regeneratorRuntime = $c99432794f8a5953$var$runtime;
} catch (accidentalStrictMode) {
    if (typeof globalThis === "object") globalThis.regeneratorRuntime = $c99432794f8a5953$var$runtime;
    else Function("r", "regeneratorRuntime = r")($c99432794f8a5953$var$runtime);
}



var $iFR7a = parcelRequire("iFR7a");




var $hLfKH = parcelRequire("hLfKH");
function $b07b19f6569a1fad$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $b07b19f6569a1fad$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $b07b19f6569a1fad$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $5bc9a370f4de45ae$export$2e2bcd8739ae039)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $b07b19f6569a1fad$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $b07b19f6569a1fad$export$a66cbd9b2289cd78 = '@all-features';
var $b07b19f6569a1fad$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function Subscriptions() {
        (0, $ad05016a8a78b31b$export$2e2bcd8739ae039)(this, Subscriptions);
        (0, $5bc9a370f4de45ae$export$2e2bcd8739ae039)(this, "eventToValue", new Map());
        this.emitter = new (0, (/*@__PURE__*/$parcel$interopDefault($hLfKH)))();
    }
    return (0, $7ee2b561172d79b0$export$2e2bcd8739ae039)(Subscriptions, [
        {
            key: "onGateUpdated",
            value: function onGateUpdated(gateName, callback, checkGate, options) {
                var _this = this;
                var value = checkGate(gateName, $b07b19f6569a1fad$var$_objectSpread($b07b19f6569a1fad$var$_objectSpread({}, options), {}, {
                    fireGateExposure: false
                }));
                if (this.eventToValue.get(callback) === undefined) this.eventToValue.set(callback, value);
                var wrapCallback = function wrapCallback() {
                    var value = checkGate(gateName, $b07b19f6569a1fad$var$_objectSpread($b07b19f6569a1fad$var$_objectSpread({}, options), {}, {
                        fireGateExposure: false
                    }));
                    var existingValue = _this.eventToValue.get(callback);
                    if (existingValue !== value) {
                        _this.eventToValue.set(callback, value);
                        callback(value);
                    }
                };
                this.emitter.on(gateName, wrapCallback);
                return function() {
                    _this.emitter.off(gateName, wrapCallback);
                };
            }
        },
        {
            key: "onExperimentValueUpdated",
            value: function onExperimentValueUpdated(experimentName, parameterName, defaultValue, callback, getExperimentValue, options) {
                var _this2 = this;
                var experimentEventName = "".concat(experimentName, ".").concat(parameterName);
                var value = getExperimentValue(experimentName, parameterName, defaultValue, $b07b19f6569a1fad$var$_objectSpread($b07b19f6569a1fad$var$_objectSpread({}, options), {}, {
                    fireExperimentExposure: false
                }));
                if (this.eventToValue.get(callback) === undefined) this.eventToValue.set(callback, value);
                var wrapCallback = function wrapCallback() {
                    var value = getExperimentValue(experimentName, parameterName, defaultValue, $b07b19f6569a1fad$var$_objectSpread($b07b19f6569a1fad$var$_objectSpread({}, options), {}, {
                        fireExperimentExposure: false
                    }));
                    var existingValue = _this2.eventToValue.get(callback);
                    if (existingValue !== value) {
                        _this2.eventToValue.set(callback, value);
                        callback(value);
                    }
                };
                this.emitter.on(experimentEventName, wrapCallback);
                return function() {
                    _this2.emitter.off(experimentEventName, wrapCallback);
                };
            }
        },
        {
            key: "onAnyUpdated",
            value: function onAnyUpdated(callback) {
                var _this3 = this;
                this.emitter.on($b07b19f6569a1fad$export$a66cbd9b2289cd78, callback);
                return function() {
                    _this3.emitter.off($b07b19f6569a1fad$export$a66cbd9b2289cd78, callback);
                };
            }
        },
        {
            key: "anyUpdated",
            value: function anyUpdated() {
                var _this4 = this;
                this.emitter.emit($b07b19f6569a1fad$export$a66cbd9b2289cd78);
                this.emitter.eventNames().filter(function(name) {
                    return name !== $b07b19f6569a1fad$export$a66cbd9b2289cd78;
                }).forEach(function(event) {
                    _this4.emitter.emit(event);
                });
            }
        }
    ]);
}();










var $f9e0dbd4c283a70e$export$ce553301d55c2fd8 = 'fedramp-moderate';
var $f9e0dbd4c283a70e$export$f005e2e9f707cb5f = 'commercial';
var $f9e0dbd4c283a70e$export$bd6b5a7802d76127 = 'fedramp-fedex';
var $f9e0dbd4c283a70e$export$a739cd5aac835909 = 'stg';
var $f9e0dbd4c283a70e$export$42dd0cdd351a4a9 = 'prod';
var $f9e0dbd4c283a70e$export$404582bc18fe4d9e = 'dev';


function $3edb1379df683f47$export$64d6499adf9b2e51() {
    var _global$location;
    var global = globalThis;
    // MICROS_PERIMETER is already used by few products, so we need to keep it for backward compatibility
    var env = global.MICROS_PERIMETER || global.UNSAFE_ATL_CONTEXT_BOUNDARY;
    if (env) return env === (0, $f9e0dbd4c283a70e$export$ce553301d55c2fd8);
    var matches = (_global$location = global.location) === null || _global$location === void 0 || (_global$location = _global$location.hostname) === null || _global$location === void 0 ? void 0 : _global$location.match(/atlassian-us-gov-mod\.(com|net)|atlassian-us-gov\.(com|net)|atlassian-fex\.(com|net)|atlassian-stg-fedm\.(com|net)/);
    return matches ? matches.length > 0 : false;
}


// Reference: https://github.com/statsig-io/js-lite/blob/main/src/StatsigStore.ts
var $a7c68762f727da9c$export$c62558b199e46828 = {
    // Order is important since the logic for migrating from a new client reason to an old one
    // returns the first which is a substring of the new client reason
    Error: 'Error',
    LocalOverride: 'LocalOverride',
    Unrecognized: 'Unrecognized',
    Uninitialized: 'Uninitialized',
    NetworkNotModified: 'NetworkNotModified',
    Network: 'Network',
    InvalidBootstrap: 'InvalidBootstrap',
    Bootstrap: 'Bootstrap',
    Cache: 'Cache',
    // For when we could not migrate the reason from the new client
    Unknown: 'Unknown'
}; // Reference: https://github.com/statsig-io/js-lite/blob/main/src/StatsigSDKOptions.ts


/**
 * The identifiers for the user. Options are restricted to the set that is currently supported.
 */ /**
 * Base client options. Does not include any options specific to providers
 * @interface BaseClientOptions
 * @property {FeatureGateEnvironment} environment - The environment for the client.
 * @property {string} targetApp - The target app for the client.
 * @property {AnalyticsWebClient} analyticsWebClient - The analytics web client.
 * @property {PerimeterType} perimeter - The perimeter for the client.
 */ /**
 * The options for the client.
 * @interface ClientOptions
 * @extends {BaseClientOptions}
 * @property {string} apiKey - The API key for the client.
 * @property {fetchTimeoutMs} fetchTimeoutMs - The timeout for the fetch request in milliseconds. Defaults to 5000.
 * @property {boolean} useGatewayURL - Whether to use the gateway URL. Defaults to false.
 */ /**
 * The custom attributes for the user.
 */ var $85ad0eea8eb928fe$export$479e7351a733299 = {
    Development: 'development',
    Staging: 'staging',
    Production: 'production'
};
var $85ad0eea8eb928fe$export$c42b7bbc5e7ba555 = {
    COMMERCIAL: 'commercial',
    FEDRAMP_MODERATE: 'fedramp-moderate'
};
var $85ad0eea8eb928fe$export$42f4885608027d0c = 'non_boolean'; // Type magic to get the JSDoc comments from the Client class methods to appear on the static
 // methods in FeatureGates where the property name and function type are identical


var $4ae5b0ef62bf70c0$var$_excluded = [
    "stableId"
], $4ae5b0ef62bf70c0$var$_excluded2 = [
    "api",
    "disableCurrentPageLogging",
    "loggingIntervalMillis",
    "loggingBufferMaxSize",
    "localMode",
    "eventLoggingApi",
    "eventLoggingApiForRetries",
    "disableLocalStorage",
    "ignoreWindowUndefined",
    "disableAllLogging",
    "initTimeoutMs",
    "disableNetworkKeepalive",
    "overrideStableID",
    "disableErrorLogging",
    "disableAutoMetricsLogging"
];
function $4ae5b0ef62bf70c0$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $4ae5b0ef62bf70c0$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $4ae5b0ef62bf70c0$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $5bc9a370f4de45ae$export$2e2bcd8739ae039)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $4ae5b0ef62bf70c0$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $4ae5b0ef62bf70c0$export$d119b37e5f788b43 = function getOptionsWithDefaults(options) {
    return $4ae5b0ef62bf70c0$var$_objectSpread({
        /**
     * If more federal PerimeterTypes are added in the future, this should be updated so
     * that isFedRamp() === true always returns the strictest perimeter.
     */ perimeter: (0, $3edb1379df683f47$export$64d6499adf9b2e51)() ? (0, $85ad0eea8eb928fe$export$c42b7bbc5e7ba555).FEDRAMP_MODERATE : (0, $85ad0eea8eb928fe$export$c42b7bbc5e7ba555).COMMERCIAL
    }, options);
};
var $4ae5b0ef62bf70c0$export$fa1c2bbf4100b8bc = function shallowEquals(objectA, objectB) {
    if (!objectA && !objectB) return true;
    if (!objectA || !objectB) return false;
    var aEntries = Object.entries(objectA);
    var bEntries = Object.entries(objectB);
    if (aEntries.length !== bEntries.length) return false;
    var ascendingKeyOrder = function ascendingKeyOrder(_ref, _ref2) {
        var _ref3 = (0, $958636c847d8b316$export$2e2bcd8739ae039)(_ref, 1), key1 = _ref3[0];
        var _ref4 = (0, $958636c847d8b316$export$2e2bcd8739ae039)(_ref2, 1), key2 = _ref4[0];
        return key1.localeCompare(key2);
    };
    aEntries.sort(ascendingKeyOrder);
    bEntries.sort(ascendingKeyOrder);
    for(var i = 0; i < aEntries.length; i++){
        var _aEntries$i = (0, $958636c847d8b316$export$2e2bcd8739ae039)(aEntries[i], 2), aValue = _aEntries$i[1];
        var _bEntries$i = (0, $958636c847d8b316$export$2e2bcd8739ae039)(bEntries[i], 2), bValue = _bEntries$i[1];
        if (aValue !== bValue) return false;
    }
    return true;
};
var $4ae5b0ef62bf70c0$export$3dad1db244472f32 = function toStatsigUser(identifiers, customAttributes) {
    // Re-map `stableId` to `stableID` to match Statsig's native type.
    var stableId = identifiers.stableId, otherIdentifiers = (0, $b45e4aa52a06dd77$export$2e2bcd8739ae039)(identifiers, $4ae5b0ef62bf70c0$var$_excluded);
    var user = {
        customIDs: $4ae5b0ef62bf70c0$var$_objectSpread($4ae5b0ef62bf70c0$var$_objectSpread({}, otherIdentifiers), stableId !== undefined ? {
            stableID: stableId
        } : {}),
        custom: customAttributes
    };
    if (identifiers.atlassianAccountId) user.userID = identifiers.atlassianAccountId;
    return user;
};
function $4ae5b0ef62bf70c0$export$1148cb79ceecd5fa(target) {
    for(var _len = arguments.length, sources = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)sources[_key - 1] = arguments[_key];
    if (!sources.length) return target;
    var source = sources.shift();
    if (source === undefined || source === null) return $4ae5b0ef62bf70c0$export$1148cb79ceecd5fa.apply(void 0, [
        target
    ].concat((0, $4a517cd18e4d856d$export$2e2bcd8739ae039)(sources)));
    for(var _i = 0, _Object$entries = Object.entries(source); _i < _Object$entries.length; _i++){
        var _Object$entries$_i = (0, $958636c847d8b316$export$2e2bcd8739ae039)(_Object$entries[_i], 2), key = _Object$entries$_i[0], src = _Object$entries$_i[1];
        var dst = target[key];
        var srcIsObj = src && (0, $93e95126a5cec975$export$2e2bcd8739ae039)(src) === 'object' && !Array.isArray(src);
        var dstIsObj = dst && (0, $93e95126a5cec975$export$2e2bcd8739ae039)(dst) === 'object' && !Array.isArray(dst);
        if (srcIsObj && dstIsObj) target[key] = $4ae5b0ef62bf70c0$export$1148cb79ceecd5fa(dst, src);
        else target[key] = src;
    }
    return $4ae5b0ef62bf70c0$export$1148cb79ceecd5fa.apply(void 0, [
        target
    ].concat((0, $4a517cd18e4d856d$export$2e2bcd8739ae039)(sources)));
}
var $4ae5b0ef62bf70c0$export$202946b690d26d22 = function migrateInitializationOptions(options) {
    var api = options.api, disableCurrentPageLogging = options.disableCurrentPageLogging, loggingIntervalMillis = options.loggingIntervalMillis, loggingBufferMaxSize = options.loggingBufferMaxSize, localMode = options.localMode, eventLoggingApi = options.eventLoggingApi, eventLoggingApiForRetries = options.eventLoggingApiForRetries, disableLocalStorage = options.disableLocalStorage, ignoreWindowUndefined = options.ignoreWindowUndefined, disableAllLogging = options.disableAllLogging, _initTimeoutMs = options.initTimeoutMs, _disableNetworkKeepalive = options.disableNetworkKeepalive, _overrideStableID = options.overrideStableID, _disableErrorLogging = options.disableErrorLogging, _disableAutoMetricsLogging = options.disableAutoMetricsLogging, rest = (0, $b45e4aa52a06dd77$export$2e2bcd8739ae039)(options, $4ae5b0ef62bf70c0$var$_excluded2);
    return $4ae5b0ef62bf70c0$var$_objectSpread($4ae5b0ef62bf70c0$var$_objectSpread({}, rest), {}, {
        networkConfig: {
            api: api,
            logEventUrl: eventLoggingApi ? eventLoggingApi + 'rgstr' : undefined,
            logEventFallbackUrls: eventLoggingApiForRetries ? [
                eventLoggingApiForRetries
            ] : undefined,
            preventAllNetworkTraffic: localMode || !ignoreWindowUndefined && typeof window === 'undefined'
        },
        includeCurrentPageUrlWithEvents: !disableCurrentPageLogging,
        loggingIntervalMs: loggingIntervalMillis,
        loggingBufferMaxSize: loggingBufferMaxSize,
        disableStorage: disableLocalStorage === undefined ? localMode : disableLocalStorage,
        disableLogging: disableAllLogging === undefined ? localMode : disableAllLogging
    });
};
var $4ae5b0ef62bf70c0$var$evaluationReasonMappings = Object.entries((0, $a7c68762f727da9c$export$c62558b199e46828)).map(function(_ref5) {
    var _ref6 = (0, $958636c847d8b316$export$2e2bcd8739ae039)(_ref5, 2), key = _ref6[0], value = _ref6[1];
    return [
        key.toLowerCase(),
        value
    ];
});
var $4ae5b0ef62bf70c0$export$18ad168d3dbac899 = function migrateEvaluationDetails(details) {
    var _evaluationReasonMapp, _evaluationReasonMapp2, _details$receivedAt;
    var reasonLower = details.reason.toLowerCase();
    return {
        reason: (_evaluationReasonMapp = (_evaluationReasonMapp2 = $4ae5b0ef62bf70c0$var$evaluationReasonMappings.find(function(_ref7) {
            var _ref8 = (0, $958636c847d8b316$export$2e2bcd8739ae039)(_ref7, 1), key = _ref8[0];
            return reasonLower.includes(key);
        })) === null || _evaluationReasonMapp2 === void 0 ? void 0 : _evaluationReasonMapp2[1]) !== null && _evaluationReasonMapp !== void 0 ? _evaluationReasonMapp : (0, $a7c68762f727da9c$export$c62558b199e46828).Unknown,
        time: (_details$receivedAt = details.receivedAt) !== null && _details$receivedAt !== void 0 ? _details$receivedAt : Date.now()
    };
};
var $4ae5b0ef62bf70c0$export$55fd683752d01e67 = function migrateSecondaryExposures(secondaryExposures) {
    return secondaryExposures.map(function(exposure) {
        if (typeof exposure === 'string') // This should ideally have gateValue and ruleID fields too, but it's not possible for us
        // to determine the correct values for these.
        return {
            gate: exposure
        };
        return exposure;
    });
};


var $bfe3e8d5767a36a7$export$6dc24881a3d96325 = /*#__PURE__*/ function() {
    function DynamicConfig(configName, configValue, ruleID, evaluationDetails) {
        var secondaryExposures = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : [];
        var allocatedExperimentName = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : '';
        var onDefaultValueFallback = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : null;
        (0, $ad05016a8a78b31b$export$2e2bcd8739ae039)(this, DynamicConfig);
        this.value = configValue;
        this._name = configName;
        this._ruleID = ruleID;
        this._secondaryExposures = secondaryExposures;
        this._allocatedExperimentName = allocatedExperimentName;
        this._evaluationDetails = evaluationDetails;
        this._onDefaultValueFallback = onDefaultValueFallback;
    }
    return (0, $7ee2b561172d79b0$export$2e2bcd8739ae039)(DynamicConfig, [
        {
            key: "get",
            value: function get(key, defaultValue, typeGuard) {
                var _this$_onDefaultValue2;
                var val = this.getValue(key, defaultValue);
                if (val == null) return defaultValue;
                var expectedType = Array.isArray(defaultValue) ? 'array' : (0, $93e95126a5cec975$export$2e2bcd8739ae039)(defaultValue);
                var actualType = Array.isArray(val) ? 'array' : (0, $93e95126a5cec975$export$2e2bcd8739ae039)(val);
                if (typeGuard) {
                    var _this$_onDefaultValue;
                    if (typeGuard(val)) {
                        this.fireExposure(key);
                        return val;
                    }
                    (_this$_onDefaultValue = this._onDefaultValueFallback) === null || _this$_onDefaultValue === void 0 || _this$_onDefaultValue.call(this, this, key, expectedType, actualType);
                    return defaultValue;
                }
                if (defaultValue == null || expectedType === actualType) {
                    this.fireExposure(key);
                    return val;
                }
                (_this$_onDefaultValue2 = this._onDefaultValueFallback) === null || _this$_onDefaultValue2 === void 0 || _this$_onDefaultValue2.call(this, this, key, expectedType, actualType);
                return defaultValue;
            }
        },
        {
            key: "getValue",
            value: function getValue(key, defaultValue) {
                if (key == null) return this.value;
                if (defaultValue == null) defaultValue = null;
                if (this.value[key] == null) return defaultValue;
                this.fireExposure(key);
                return this.value[key];
            }
        },
        {
            key: "fireExposure",
            value: function fireExposure(key) {
                // Call the wrapped experiment's get method to fire exposure
                if (this.experiment) this.experiment.get(key);
            }
        }
    ], [
        {
            key: "fromExperiment",
            value: function fromExperiment(experiment) {
                var _experiment$__evaluat, _experiment$__evaluat2, _experiment$groupName;
                var config = new DynamicConfig(experiment.name, experiment.value, experiment.ruleID, (0, $4ae5b0ef62bf70c0$export$18ad168d3dbac899)(experiment.details), (0, $4ae5b0ef62bf70c0$export$55fd683752d01e67)((_experiment$__evaluat = (_experiment$__evaluat2 = experiment.__evaluation) === null || _experiment$__evaluat2 === void 0 ? void 0 : _experiment$__evaluat2.secondary_exposures) !== null && _experiment$__evaluat !== void 0 ? _experiment$__evaluat : []), (_experiment$groupName = experiment.groupName) !== null && _experiment$groupName !== void 0 ? _experiment$groupName : undefined);
                config.experiment = experiment;
                return config;
            }
        }
    ]);
}();






var $036f8c4b31c67236$export$936d0764594b6eb3 = /*#__PURE__*/ function() {
    function Layer(name, layerValue, ruleID, evaluationDetails) {
        var logParameterFunction = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;
        var secondaryExposures = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : [];
        var undelegatedSecondaryExposures = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : [];
        var allocatedExperimentName = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : '';
        var explicitParameters = arguments.length > 8 && arguments[8] !== undefined ? arguments[8] : [];
        (0, $ad05016a8a78b31b$export$2e2bcd8739ae039)(this, Layer);
        this._logParameterFunction = logParameterFunction;
        this._name = name;
        this._value = JSON.parse(JSON.stringify(layerValue !== null && layerValue !== void 0 ? layerValue : {}));
        this._ruleID = ruleID !== null && ruleID !== void 0 ? ruleID : '';
        this._evaluationDetails = evaluationDetails;
        this._secondaryExposures = secondaryExposures;
        this._undelegatedSecondaryExposures = undelegatedSecondaryExposures;
        this._allocatedExperimentName = allocatedExperimentName;
        this._explicitParameters = explicitParameters;
    }
    return (0, $7ee2b561172d79b0$export$2e2bcd8739ae039)(Layer, [
        {
            key: "get",
            value: function get(key, defaultValue, typeGuard) {
                var _this = this;
                var val = this._value[key];
                if (val == null) return defaultValue;
                var logAndReturn = function logAndReturn() {
                    _this._logLayerParameterExposure(key);
                    return val;
                };
                if (typeGuard) return typeGuard(val) ? logAndReturn() : defaultValue;
                if (defaultValue == null) return logAndReturn();
                if ((0, $93e95126a5cec975$export$2e2bcd8739ae039)(val) === (0, $93e95126a5cec975$export$2e2bcd8739ae039)(defaultValue) && Array.isArray(defaultValue) === Array.isArray(val)) return logAndReturn();
                return defaultValue;
            }
        },
        {
            key: "getValue",
            value: function getValue(key, defaultValue) {
                // eslint-disable-next-line eqeqeq
                if (defaultValue == undefined) defaultValue = null;
                var val = this._value[key];
                if (val != null) this._logLayerParameterExposure(key);
                return val !== null && val !== void 0 ? val : defaultValue;
            }
        },
        {
            key: "_logLayerParameterExposure",
            value: function _logLayerParameterExposure(parameterName) {
                var _this$_logParameterFu;
                (_this$_logParameterFu = this._logParameterFunction) === null || _this$_logParameterFu === void 0 || _this$_logParameterFu.call(this, this, parameterName);
            }
        }
    ], [
        {
            key: "fromLayer",
            value: function fromLayer(layer) {
                var _layer$__evaluation$s, _layer$__evaluation, _layer$__evaluation$u, _layer$__evaluation2, _layer$__evaluation3, _layer$__evaluation4;
                var value = new Layer(layer.name, layer.__value, layer.ruleID, (0, $4ae5b0ef62bf70c0$export$18ad168d3dbac899)(layer.details), function(_layer, parameterName) {
                    return layer.get(parameterName);
                }, (0, $4ae5b0ef62bf70c0$export$55fd683752d01e67)((_layer$__evaluation$s = (_layer$__evaluation = layer.__evaluation) === null || _layer$__evaluation === void 0 ? void 0 : _layer$__evaluation.secondary_exposures) !== null && _layer$__evaluation$s !== void 0 ? _layer$__evaluation$s : []), (0, $4ae5b0ef62bf70c0$export$55fd683752d01e67)((_layer$__evaluation$u = (_layer$__evaluation2 = layer.__evaluation) === null || _layer$__evaluation2 === void 0 ? void 0 : _layer$__evaluation2.undelegated_secondary_exposures) !== null && _layer$__evaluation$u !== void 0 ? _layer$__evaluation$u : []), (_layer$__evaluation3 = layer.__evaluation) === null || _layer$__evaluation3 === void 0 ? void 0 : _layer$__evaluation3.allocated_experiment_name, (_layer$__evaluation4 = layer.__evaluation) === null || _layer$__evaluation4 === void 0 ? void 0 : _layer$__evaluation4.explicit_parameters);
                return value;
            }
        }
    ]);
}();









/// <reference types="node" />
var $daebafeb0bbc8260$export$a59f8d67326bd1cb = "5.8.0";









function $eb4ea8fe90e8126c$export$2e2bcd8739ae039(t) {
    try {
        return -1 !== Function.toString.call(t).indexOf("[native code]");
    } catch (n) {
        return "function" == typeof t;
    }
}


function $19a822040b271821$export$2e2bcd8739ae039() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($19a822040b271821$export$2e2bcd8739ae039 = function _isNativeReflectConstruct() {
        return !!t;
    })();
}



function $3c7a3fe0bb7127be$export$2e2bcd8739ae039(t, e, r) {
    if ((0, $19a822040b271821$export$2e2bcd8739ae039)()) return Reflect.construct.apply(null, arguments);
    var o = [
        null
    ];
    o.push.apply(o, e);
    var p = new (t.bind.apply(t, o))();
    return r && (0, $6fc3cab695171a3b$export$2e2bcd8739ae039)(p, r.prototype), p;
}


function $84977fc2ed4bbc29$export$2e2bcd8739ae039(t) {
    var r = "function" == typeof Map ? new Map() : void 0;
    return $84977fc2ed4bbc29$export$2e2bcd8739ae039 = function _wrapNativeSuper(t) {
        if (null === t || !(0, $eb4ea8fe90e8126c$export$2e2bcd8739ae039)(t)) return t;
        if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function");
        if (void 0 !== r) {
            if (r.has(t)) return r.get(t);
            r.set(t, Wrapper);
        }
        function Wrapper() {
            return (0, $3c7a3fe0bb7127be$export$2e2bcd8739ae039)(t, arguments, (0, $8b393915e29091af$export$2e2bcd8739ae039)(this).constructor);
        }
        return Wrapper.prototype = Object.create(t.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: !1,
                writable: !0,
                configurable: !0
            }
        }), (0, $6fc3cab695171a3b$export$2e2bcd8739ae039)(Wrapper, t);
    }, $84977fc2ed4bbc29$export$2e2bcd8739ae039(t);
}


function $547fd1aa4b48d875$var$_callSuper(t, o, e) {
    return o = (0, $8b393915e29091af$export$2e2bcd8739ae039)(o), (0, $9582c8784cf8b6c8$export$2e2bcd8739ae039)(t, $547fd1aa4b48d875$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, $8b393915e29091af$export$2e2bcd8739ae039)(t).constructor) : o.apply(t, e));
}
function $547fd1aa4b48d875$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($547fd1aa4b48d875$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $547fd1aa4b48d875$export$286baf652d0b1206 = /*#__PURE__*/ function(_Error) {
    function ResponseError(message) {
        (0, $ad05016a8a78b31b$export$2e2bcd8739ae039)(this, ResponseError);
        return $547fd1aa4b48d875$var$_callSuper(this, ResponseError, [
            message
        ]);
    }
    (0, $269fa44e33e7cdcd$export$2e2bcd8739ae039)(ResponseError, _Error);
    return (0, $7ee2b561172d79b0$export$2e2bcd8739ae039)(ResponseError);
}(/*#__PURE__*/ (0, $84977fc2ed4bbc29$export$2e2bcd8739ae039)(Error));


function $867e1b8128863989$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $867e1b8128863989$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $867e1b8128863989$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $5bc9a370f4de45ae$export$2e2bcd8739ae039)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $867e1b8128863989$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $867e1b8128863989$var$DEFAULT_REQUEST_TIMEOUT_MS = 5000;
var $867e1b8128863989$export$250a58ecde616daa = 'https://api.atlassian.com/flags';
var $867e1b8128863989$export$942ba04389b0d5a2 = 'https://api.stg.atlassian.com/flags';
var $867e1b8128863989$export$f058dbf75c3bc647 = 'https://api.dev.atlassian.com/flags';
var $867e1b8128863989$export$1a401a0da8da3565 = 'https://api.stg.atlassian-us-gov-mod.com/flags';
var $867e1b8128863989$export$18c93900db9358a4 = 'https://api.atlassian-us-gov-mod.com/flags';
var $867e1b8128863989$export$4e8a0415edbfa1f7 = 'https://atlassian-statsig-proxy-archetype.atl-paas.%s.atl-ic.net';
var $867e1b8128863989$export$cb3cd156f70d7e94 = 'oasis-stg.com/flags';
var $867e1b8128863989$export$921fbc6cdfd4eee0 = 'atlassian-isolated.net/flags';
var $867e1b8128863989$export$450bd8fb2a6d7ace = '/gateway/api/flags';
var $867e1b8128863989$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function Fetcher() {
        (0, $ad05016a8a78b31b$export$2e2bcd8739ae039)(this, Fetcher);
    }
    return (0, $7ee2b561172d79b0$export$2e2bcd8739ae039)(Fetcher, null, [
        {
            key: "fetchClientSdk",
            value: function() {
                var _fetchClientSdk = (0, $149f9a5148f3c87f$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($c99432794f8a5953$exports))).mark(function _callee(fetcherOptions) {
                    var targetApp, url, _t;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($c99432794f8a5953$exports))).wrap(function(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                targetApp = fetcherOptions.targetApp;
                                url = "/api/v2/frontend/clientSdkKey/".concat(targetApp);
                                _context.prev = 1;
                                _context.next = 2;
                                return this.fetchRequest(url, 'GET', fetcherOptions);
                            case 2:
                                return _context.abrupt("return", _context.sent);
                            case 3:
                                _context.prev = 3;
                                _t = _context["catch"](1);
                                if (!(_t instanceof Error)) {
                                    _context.next = 4;
                                    break;
                                }
                                throw _t;
                            case 4:
                                throw Error('Failed to retrieve client sdk key');
                            case 5:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee, this, [
                        [
                            1,
                            3
                        ]
                    ]);
                }));
                function fetchClientSdk(_x) {
                    return _fetchClientSdk.apply(this, arguments);
                }
                return fetchClientSdk;
            }()
        },
        {
            key: "fetchExperimentValues",
            value: function() {
                var _fetchExperimentValues = (0, $149f9a5148f3c87f$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($c99432794f8a5953$exports))).mark(function _callee2(fetcherOptions, identifiers, customAttributes) {
                    var requestBody, _t2;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($c99432794f8a5953$exports))).wrap(function(_context2) {
                        while(true)switch(_context2.prev = _context2.next){
                            case 0:
                                requestBody = {
                                    identifiers: identifiers,
                                    customAttributes: customAttributes,
                                    targetApp: fetcherOptions.targetApp
                                };
                                _context2.prev = 1;
                                _context2.next = 2;
                                return this.fetchRequest('/api/v2/frontend/experimentValues', 'POST', fetcherOptions, requestBody);
                            case 2:
                                return _context2.abrupt("return", _context2.sent);
                            case 3:
                                _context2.prev = 3;
                                _t2 = _context2["catch"](1);
                                if (!(_t2 instanceof Error)) {
                                    _context2.next = 4;
                                    break;
                                }
                                throw _t2;
                            case 4:
                                throw Error('Failed to retrieve experiment values');
                            case 5:
                            case "end":
                                return _context2.stop();
                        }
                    }, _callee2, this, [
                        [
                            1,
                            3
                        ]
                    ]);
                }));
                function fetchExperimentValues(_x2, _x3, _x4) {
                    return _fetchExperimentValues.apply(this, arguments);
                }
                return fetchExperimentValues;
            }()
        },
        {
            key: "handleResponseError",
            value: function() {
                var _handleResponseError = (0, $149f9a5148f3c87f$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($c99432794f8a5953$exports))).mark(function _callee3(response) {
                    var body;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($c99432794f8a5953$exports))).wrap(function(_context3) {
                        while(true)switch(_context3.prev = _context3.next){
                            case 0:
                                if (response.ok) {
                                    _context3.next = 2;
                                    break;
                                }
                                _context3.next = 1;
                                return response.text();
                            case 1:
                                body = _context3.sent;
                                throw new (0, $547fd1aa4b48d875$export$286baf652d0b1206)("Non 2xx response status received, status: ".concat(response.status, ", body: ").concat(JSON.stringify(body)));
                            case 2:
                                if (!(response.status === 204)) {
                                    _context3.next = 3;
                                    break;
                                }
                                throw new (0, $547fd1aa4b48d875$export$286baf652d0b1206)('Unexpected 204 response');
                            case 3:
                            case "end":
                                return _context3.stop();
                        }
                    }, _callee3);
                }));
                function handleResponseError(_x5) {
                    return _handleResponseError.apply(this, arguments);
                }
                return handleResponseError;
            }()
        },
        {
            key: "extractResponseBody",
            value: function() {
                var _extractResponseBody = (0, $149f9a5148f3c87f$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($c99432794f8a5953$exports))).mark(function _callee4(response) {
                    var value;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($c99432794f8a5953$exports))).wrap(function(_context4) {
                        while(true)switch(_context4.prev = _context4.next){
                            case 0:
                                _context4.next = 1;
                                return response.text();
                            case 1:
                                value = _context4.sent;
                                return _context4.abrupt("return", JSON.parse(value));
                            case 2:
                            case "end":
                                return _context4.stop();
                        }
                    }, _callee4);
                }));
                function extractResponseBody(_x6) {
                    return _extractResponseBody.apply(this, arguments);
                }
                return extractResponseBody;
            }()
        },
        {
            key: "getBaseUrl",
            value: function getBaseUrl(serviceEnv) {
                var useGatewayUrl = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
                var perimeter = arguments.length > 2 ? arguments[2] : undefined;
                var isolationContextId = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
                if (useGatewayUrl) return $867e1b8128863989$export$450bd8fb2a6d7ace;
                if (perimeter === (0, $85ad0eea8eb928fe$export$c42b7bbc5e7ba555).FEDRAMP_MODERATE) switch(serviceEnv){
                    case (0, $85ad0eea8eb928fe$export$479e7351a733299).Production:
                        return $867e1b8128863989$export$18c93900db9358a4;
                    case (0, $85ad0eea8eb928fe$export$479e7351a733299).Staging:
                        return $867e1b8128863989$export$1a401a0da8da3565;
                    default:
                        throw new Error("Invalid environment \"".concat(serviceEnv, "\" for \"").concat(perimeter, "\" perimeter"));
                }
                else if (perimeter === (0, $85ad0eea8eb928fe$export$c42b7bbc5e7ba555).COMMERCIAL) switch(serviceEnv){
                    case (0, $85ad0eea8eb928fe$export$479e7351a733299).Development:
                        return $867e1b8128863989$export$f058dbf75c3bc647;
                    case (0, $85ad0eea8eb928fe$export$479e7351a733299).Staging:
                        var apiUrl = this.getApiUrl(isolationContextId);
                        if (apiUrl !== null) return apiUrl;
                        return $867e1b8128863989$export$942ba04389b0d5a2;
                    default:
                        var prodApiUrl = this.getApiUrl(isolationContextId);
                        if (prodApiUrl !== null) return prodApiUrl;
                        return $867e1b8128863989$export$250a58ecde616daa;
                }
                else throw new Error("Invalid perimeter \"".concat(perimeter, "\""));
            }
        },
        {
            key: "fetchRequest",
            value: function() {
                var _fetchRequest = (0, $149f9a5148f3c87f$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($c99432794f8a5953$exports))).mark(function _callee5(path, method, fetcherOptions, body) {
                    var baseUrl, fetchTimeout, abortSignal, abortController, response;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($c99432794f8a5953$exports))).wrap(function(_context5) {
                        while(true)switch(_context5.prev = _context5.next){
                            case 0:
                                baseUrl = Fetcher.getBaseUrl(fetcherOptions.environment, fetcherOptions.useGatewayURL, fetcherOptions.perimeter, fetcherOptions.isolationContextId);
                                fetchTimeout = fetcherOptions.fetchTimeoutMs || $867e1b8128863989$var$DEFAULT_REQUEST_TIMEOUT_MS;
                                if (AbortSignal.timeout) abortSignal = AbortSignal.timeout(fetchTimeout);
                                else if (AbortController) {
                                    abortController = new AbortController();
                                    abortSignal = abortController.signal;
                                    setTimeout(function() {
                                        return abortController.abort();
                                    }, fetchTimeout);
                                }
                                _context5.next = 1;
                                return fetch("".concat(baseUrl).concat(path), $867e1b8128863989$var$_objectSpread({
                                    method: method,
                                    headers: {
                                        'Content-Type': 'application/json',
                                        'X-Client-Name': 'feature-gate-js-client',
                                        'X-Client-Version': (0, $daebafeb0bbc8260$export$a59f8d67326bd1cb),
                                        'X-API-KEY': fetcherOptions.apiKey
                                    },
                                    signal: abortSignal
                                }, body && {
                                    body: JSON.stringify(body)
                                }));
                            case 1:
                                response = _context5.sent;
                                _context5.next = 2;
                                return this.handleResponseError(response);
                            case 2:
                                _context5.next = 3;
                                return this.extractResponseBody(response);
                            case 3:
                                return _context5.abrupt("return", _context5.sent);
                            case 4:
                            case "end":
                                return _context5.stop();
                        }
                    }, _callee5, this);
                }));
                function fetchRequest(_x7, _x8, _x9, _x0) {
                    return _fetchRequest.apply(this, arguments);
                }
                return fetchRequest;
            }()
        },
        {
            key: "getApiUrl",
            value: function getApiUrl(isolationContextId) {
                var window1 = this.getWindowLocation();
                if (window1 === undefined) {
                    //this is needed when this SDK is used for SSR or plugin use cases where secret keys not available to use backend SDKs
                    if (!isolationContextId) return null;
                    return $867e1b8128863989$export$4e8a0415edbfa1f7.replace('%s', isolationContextId);
                }
                var protocol = window1.protocol, hostname = window1.hostname;
                // Match last subdomain fragment before oasis-stg.com
                var oasisMatch = hostname.match(/([^.]+)\.oasis-stg\.com$/);
                if (oasisMatch) return "".concat(protocol, "//api.").concat(oasisMatch[1], ".").concat($867e1b8128863989$export$cb3cd156f70d7e94);
                // Match last subdomain fragment before atlassian-isolated.net
                var isolatedMatch = hostname.match(/([^.]+)\.atlassian-isolated\.net$/);
                if (isolatedMatch) return "".concat(protocol, "//api.").concat(isolatedMatch[1], ".").concat($867e1b8128863989$export$921fbc6cdfd4eee0);
                return null;
            }
        },
        {
            key: "getWindowLocation",
            value: function getWindowLocation() {
                if (typeof window !== 'undefined' && window.location) return window.location;
                return undefined;
            }
        }
    ]);
}();












var $iFR7a = parcelRequire("iFR7a");
function $d31f983a2f547cf6$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $d31f983a2f547cf6$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $d31f983a2f547cf6$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $5bc9a370f4de45ae$export$2e2bcd8739ae039)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $d31f983a2f547cf6$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $d31f983a2f547cf6$var$_callSuper(t, o, e) {
    return o = (0, $8b393915e29091af$export$2e2bcd8739ae039)(o), (0, $9582c8784cf8b6c8$export$2e2bcd8739ae039)(t, $d31f983a2f547cf6$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, $8b393915e29091af$export$2e2bcd8739ae039)(t).constructor) : o.apply(t, e));
}
function $d31f983a2f547cf6$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($d31f983a2f547cf6$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $d31f983a2f547cf6$var$_superPropGet(t, o, e, r) {
    var p = (0, $761b44f0bf5ccff0$export$2e2bcd8739ae039)((0, $8b393915e29091af$export$2e2bcd8739ae039)(1 & r ? t.prototype : t), o, e);
    return 2 & r && "function" == typeof p ? function(t) {
        return p.apply(e, t);
    } : p;
}
var $d31f983a2f547cf6$export$55fffef3474104af = /*#__PURE__*/ function(_DataAdapterCore) {
    function NoFetchDataAdapter() {
        var _this;
        (0, $ad05016a8a78b31b$export$2e2bcd8739ae039)(this, NoFetchDataAdapter);
        _this = $d31f983a2f547cf6$var$_callSuper(this, NoFetchDataAdapter, [
            'NoFetchDataAdapter',
            'nofetch'
        ]);
        (0, $5bc9a370f4de45ae$export$2e2bcd8739ae039)(_this, "bootstrapResult", null);
        return _this;
    }
    /**
   * Make sure to call this **before** calling `initializeAsync` or `updateUserAsync` but
   * after the Statsig client has been created!
   */ (0, $269fa44e33e7cdcd$export$2e2bcd8739ae039)(NoFetchDataAdapter, _DataAdapterCore);
    return (0, $7ee2b561172d79b0$export$2e2bcd8739ae039)(NoFetchDataAdapter, [
        {
            key: "setBootstrapData",
            value: function setBootstrapData(data) {
                this.bootstrapResult = data ? {
                    source: 'Bootstrap',
                    data: JSON.stringify(data),
                    receivedAt: Date.now(),
                    stableID: (0, $iFR7a.StableID).get(this._getSdkKey()),
                    fullUserHash: null
                } : null;
            }
        },
        {
            key: "prefetchData",
            value: function() {
                var _prefetchData = (0, $149f9a5148f3c87f$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($c99432794f8a5953$exports))).mark(function _callee(_user, _options) {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($c99432794f8a5953$exports))).wrap(function(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee);
                }));
                function prefetchData(_x, _x2) {
                    return _prefetchData.apply(this, arguments);
                }
                return prefetchData;
            }()
        },
        {
            key: "getDataAsync",
            value: function() {
                var _getDataAsync = (0, $149f9a5148f3c87f$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($c99432794f8a5953$exports))).mark(function _callee2(_current, user, _options) {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($c99432794f8a5953$exports))).wrap(function(_context2) {
                        while(true)switch(_context2.prev = _context2.next){
                            case 0:
                                return _context2.abrupt("return", this.bootstrapResult && $d31f983a2f547cf6$var$_objectSpread($d31f983a2f547cf6$var$_objectSpread({}, this.bootstrapResult), {}, {
                                    fullUserHash: (0, $iFR7a._getFullUserHash)(user)
                                }));
                            case 1:
                            case "end":
                                return _context2.stop();
                        }
                    }, _callee2, this);
                }));
                function getDataAsync(_x3, _x4, _x5) {
                    return _getDataAsync.apply(this, arguments);
                }
                return getDataAsync;
            }()
        },
        {
            key: "getDataSync",
            value: function getDataSync(user) {
                return this.bootstrapResult && $d31f983a2f547cf6$var$_objectSpread($d31f983a2f547cf6$var$_objectSpread({}, this.bootstrapResult), {}, {
                    fullUserHash: (0, $iFR7a._getFullUserHash)(user)
                });
            }
        },
        {
            key: "_fetchFromNetwork",
            value: function() {
                var _fetchFromNetwork2 = (0, $149f9a5148f3c87f$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($c99432794f8a5953$exports))).mark(function _callee3(_current, _user, _options) {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($c99432794f8a5953$exports))).wrap(function(_context3) {
                        while(true)switch(_context3.prev = _context3.next){
                            case 0:
                                return _context3.abrupt("return", null);
                            case 1:
                            case "end":
                                return _context3.stop();
                        }
                    }, _callee3);
                }));
                function _fetchFromNetwork(_x6, _x7, _x8) {
                    return _fetchFromNetwork2.apply(this, arguments);
                }
                return _fetchFromNetwork;
            }()
        },
        {
            key: "_getCacheKey",
            value: function _getCacheKey(user) {
                // Same logic as default data adapter
                // https://github.com/statsig-io/js-client-monorepo/blob/main/packages/js-client/src/StatsigEvaluationsDataAdapter.ts
                var key = (0, $iFR7a._getStorageKey)(this._getSdkKey(), user);
                return "".concat((0, $iFR7a.DataAdapterCachePrefix), ".").concat(this._cacheSuffix, ".").concat(key);
            }
        },
        {
            key: "_isCachedResultValidFor204",
            value: function _isCachedResultValidFor204(_result, _user) {
                return false;
            }
        },
        {
            key: "setDataLegacy",
            value: function setDataLegacy(data, user) {
                $d31f983a2f547cf6$var$_superPropGet(NoFetchDataAdapter, "setData", this, 3)([
                    data,
                    user
                ]);
            }
        },
        {
            key: "toJSON",
            value: function toJSON() {
                var result = $d31f983a2f547cf6$var$_objectSpread({}, this);
                delete result._options;
                delete result._inMemoryCache;
                delete result.bootstrapResult;
                return result;
            }
        }
    ]);
}((0, $iFR7a.DataAdapterCore));







var $dtn6l = parcelRequire("dtn6l");
function $cc03770895d4ab2a$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $cc03770895d4ab2a$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $cc03770895d4ab2a$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $5bc9a370f4de45ae$export$2e2bcd8739ae039)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $cc03770895d4ab2a$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $cc03770895d4ab2a$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $cc03770895d4ab2a$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $cc03770895d4ab2a$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $cc03770895d4ab2a$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $cc03770895d4ab2a$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $cc03770895d4ab2a$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
var $cc03770895d4ab2a$var$LOCAL_OVERRIDE_REASON = 'LocalOverride:Recognized';
var $cc03770895d4ab2a$export$d8474cff104280f3 = 'STATSIG_OVERRIDES';
var $cc03770895d4ab2a$var$LEGACY_LOCAL_STORAGE_KEY = 'STATSIG_JS_LITE_LOCAL_OVERRIDES';
var $cc03770895d4ab2a$var$makeEmptyStore = function makeEmptyStore() {
    return {
        gates: {},
        configs: {},
        layers: {}
    };
};
var $cc03770895d4ab2a$var$djb2MapKey = function djb2MapKey(hash, kind) {
    return kind + ':' + hash;
};
var $cc03770895d4ab2a$export$bcb28fbac1def494 = /*#__PURE__*/ function() {
    function PersistentOverrideAdapter(localStorageKey) {
        (0, $ad05016a8a78b31b$export$2e2bcd8739ae039)(this, PersistentOverrideAdapter);
        this._overrides = $cc03770895d4ab2a$var$makeEmptyStore();
        this._djb2Map = new Map();
        this._localStorageKey = localStorageKey;
    }
    return (0, $7ee2b561172d79b0$export$2e2bcd8739ae039)(PersistentOverrideAdapter, [
        {
            key: "parseStoredOverrides",
            value: function parseStoredOverrides(localStorageKey) {
                try {
                    var json = window.localStorage.getItem(localStorageKey);
                    if (!json) return $cc03770895d4ab2a$var$makeEmptyStore();
                    return JSON.parse(json);
                } catch (_unused) {
                    return $cc03770895d4ab2a$var$makeEmptyStore();
                }
            }
        },
        {
            key: "mergeOverrides",
            value: function mergeOverrides() {
                var merged = $cc03770895d4ab2a$var$makeEmptyStore();
                for(var _len = arguments.length, allOverrides = new Array(_len), _key = 0; _key < _len; _key++)allOverrides[_key] = arguments[_key];
                for(var _i = 0, _allOverrides = allOverrides; _i < _allOverrides.length; _i++){
                    var overrides = _allOverrides[_i];
                    for(var _i2 = 0, _Object$entries = Object.entries((_overrides$gates = overrides.gates) !== null && _overrides$gates !== void 0 ? _overrides$gates : {}); _i2 < _Object$entries.length; _i2++){
                        var _overrides$gates;
                        var _Object$entries$_i = (0, $958636c847d8b316$export$2e2bcd8739ae039)(_Object$entries[_i2], 2), name = _Object$entries$_i[0], value = _Object$entries$_i[1];
                        merged.gates[name] = value;
                    }
                    for(var _i3 = 0, _Object$entries2 = Object.entries((_overrides$configs = overrides.configs) !== null && _overrides$configs !== void 0 ? _overrides$configs : {}); _i3 < _Object$entries2.length; _i3++){
                        var _overrides$configs;
                        var _Object$entries2$_i = (0, $958636c847d8b316$export$2e2bcd8739ae039)(_Object$entries2[_i3], 2), _name = _Object$entries2$_i[0], _value = _Object$entries2$_i[1];
                        merged.configs[_name] = _value;
                    }
                    for(var _i4 = 0, _Object$entries3 = Object.entries((_overrides$layers = overrides.layers) !== null && _overrides$layers !== void 0 ? _overrides$layers : {}); _i4 < _Object$entries3.length; _i4++){
                        var _overrides$layers;
                        var _Object$entries3$_i = (0, $958636c847d8b316$export$2e2bcd8739ae039)(_Object$entries3[_i4], 2), _name2 = _Object$entries3$_i[0], _value2 = _Object$entries3$_i[1];
                        merged.layers[_name2] = _value2;
                    }
                }
                return merged;
            }
        },
        {
            key: "initFromStoredOverrides",
            value: function initFromStoredOverrides() {
                var storedOverrides = this.mergeOverrides(this._overrides, this.parseStoredOverrides($cc03770895d4ab2a$var$LEGACY_LOCAL_STORAGE_KEY), this.parseStoredOverrides(this._localStorageKey));
                // Clear data from legacy local storage key now we've read from it.
                // This prevents things being stuck in there that are always read but never written to.
                try {
                    window.localStorage.removeItem($cc03770895d4ab2a$var$LEGACY_LOCAL_STORAGE_KEY);
                } catch (_unused2) {
                // ignored - window is not defined in non-browser environments, and we don't save things there
                // (things like SSR, etc)
                }
                // In version 4.24.0 we introduced hashes in this override adapter, but had a bug which would cause
                // multiple hashes to continue being created. This code here removes these hashes since we've moved
                // to using a more reliable and easier to maintain map in `_djb2Map`.
                for(var _i5 = 0, _Object$values = Object.values(storedOverrides); _i5 < _Object$values.length; _i5++){
                    var container = _Object$values[_i5];
                    var allKeys = new Set(Object.keys(container));
                    var _iterator = $cc03770895d4ab2a$var$_createForOfIteratorHelper(allKeys), _step;
                    try {
                        for(_iterator.s(); !(_step = _iterator.n()).done;){
                            var name = _step.value;
                            var hash = (0, $dtn6l._DJB2)(name);
                            if (allKeys.has(hash)) delete container[hash];
                        }
                    } catch (err) {
                        _iterator.e(err);
                    } finally{
                        _iterator.f();
                    }
                }
                this.applyOverrides(storedOverrides);
            }
        },
        {
            key: "saveOverrides",
            value: function saveOverrides() {
                try {
                    window.localStorage.setItem(this._localStorageKey, JSON.stringify(this._overrides));
                } catch (_unused3) {
                // ignored - window is not defined in non-browser environments, and we don't save things there
                // (things like SSR, etc)
                }
            }
        },
        {
            key: "getOverrides",
            value: function getOverrides() {
                return this.mergeOverrides(this._overrides);
            }
        },
        {
            key: "applyOverrides",
            value: function applyOverrides(overrides) {
                var newOverrides = $cc03770895d4ab2a$var$_objectSpread($cc03770895d4ab2a$var$_objectSpread({}, $cc03770895d4ab2a$var$makeEmptyStore()), overrides);
                this._djb2Map.clear();
                for(var _i6 = 0, _Object$entries4 = Object.entries(newOverrides); _i6 < _Object$entries4.length; _i6++){
                    var _Object$entries4$_i = (0, $958636c847d8b316$export$2e2bcd8739ae039)(_Object$entries4[_i6], 2), containerName = _Object$entries4$_i[0], container = _Object$entries4$_i[1];
                    for(var _i7 = 0, _Object$entries5 = Object.entries(container); _i7 < _Object$entries5.length; _i7++){
                        var _Object$entries5$_i = (0, $958636c847d8b316$export$2e2bcd8739ae039)(_Object$entries5[_i7], 2), name = _Object$entries5$_i[0], value = _Object$entries5$_i[1];
                        this._djb2Map.set($cc03770895d4ab2a$var$djb2MapKey((0, $dtn6l._DJB2)(name), containerName), value);
                    }
                }
                this._overrides = newOverrides;
            }
        },
        {
            key: "setOverrides",
            value: function setOverrides(overrides) {
                this.applyOverrides(overrides);
                this.saveOverrides();
            }
        },
        {
            key: "overrideGate",
            value: function overrideGate(name, value) {
                this._overrides.gates[name] = value;
                this._djb2Map.set($cc03770895d4ab2a$var$djb2MapKey((0, $dtn6l._DJB2)(name), 'gates'), value);
                this.saveOverrides();
            }
        },
        {
            key: "removeGateOverride",
            value: function removeGateOverride(name) {
                delete this._overrides.gates[name];
                this._djb2Map.delete($cc03770895d4ab2a$var$djb2MapKey((0, $dtn6l._DJB2)(name), 'gates'));
                this.saveOverrides();
            }
        },
        {
            key: "getGateOverride",
            value: function getGateOverride(current, _user) {
                var _this$_overrides$gate;
                var overridden = (_this$_overrides$gate = this._overrides.gates[current.name]) !== null && _this$_overrides$gate !== void 0 ? _this$_overrides$gate : this._djb2Map.get($cc03770895d4ab2a$var$djb2MapKey(current.name, 'gates'));
                if (overridden == null) return null;
                return $cc03770895d4ab2a$var$_objectSpread($cc03770895d4ab2a$var$_objectSpread({}, current), {}, {
                    value: overridden,
                    details: $cc03770895d4ab2a$var$_objectSpread($cc03770895d4ab2a$var$_objectSpread({}, current.details), {}, {
                        reason: $cc03770895d4ab2a$var$LOCAL_OVERRIDE_REASON
                    })
                });
            }
        },
        {
            key: "overrideDynamicConfig",
            value: function overrideDynamicConfig(name, value) {
                this._overrides.configs[name] = value;
                this._djb2Map.set($cc03770895d4ab2a$var$djb2MapKey((0, $dtn6l._DJB2)(name), 'configs'), value);
                this.saveOverrides();
            }
        },
        {
            key: "removeDynamicConfigOverride",
            value: function removeDynamicConfigOverride(name) {
                delete this._overrides.configs[name];
                this._djb2Map.delete($cc03770895d4ab2a$var$djb2MapKey((0, $dtn6l._DJB2)(name), 'configs'));
                this.saveOverrides();
            }
        },
        {
            key: "getDynamicConfigOverride",
            value: function getDynamicConfigOverride(current, _user) {
                return this._getConfigOverride(current, this._overrides.configs);
            }
        },
        {
            key: "overrideExperiment",
            value: function overrideExperiment(name, value) {
                this._overrides.configs[name] = value;
                this._djb2Map.set($cc03770895d4ab2a$var$djb2MapKey((0, $dtn6l._DJB2)(name), 'configs'), value);
                this.saveOverrides();
            }
        },
        {
            key: "removeExperimentOverride",
            value: function removeExperimentOverride(name) {
                delete this._overrides.configs[name];
                this._djb2Map.delete($cc03770895d4ab2a$var$djb2MapKey((0, $dtn6l._DJB2)(name), 'configs'));
                this.saveOverrides();
            }
        },
        {
            key: "getExperimentOverride",
            value: function getExperimentOverride(current, _user) {
                return this._getConfigOverride(current, this._overrides.configs);
            }
        },
        {
            key: "overrideLayer",
            value: function overrideLayer(name, value) {
                this._overrides.layers[name] = value;
                this._djb2Map.set($cc03770895d4ab2a$var$djb2MapKey((0, $dtn6l._DJB2)(name), 'layers'), value);
                this.saveOverrides();
            }
        },
        {
            key: "removeLayerOverride",
            value: function removeLayerOverride(name) {
                delete this._overrides.layers[name];
                this._djb2Map.delete($cc03770895d4ab2a$var$djb2MapKey((0, $dtn6l._DJB2)(name), 'layers'));
                this.saveOverrides();
            }
        },
        {
            key: "removeAllOverrides",
            value: function removeAllOverrides() {
                this._overrides = $cc03770895d4ab2a$var$makeEmptyStore();
                try {
                    window.localStorage.removeItem(this._localStorageKey);
                } catch (_unused4) {
                // ignored - window is not defined in non-browser environments, and we don't save things there
                // (things like SSR, etc)
                }
            }
        },
        {
            key: "getLayerOverride",
            value: function getLayerOverride(current, _user) {
                var _this$_overrides$laye;
                var overridden = (_this$_overrides$laye = this._overrides.layers[current.name]) !== null && _this$_overrides$laye !== void 0 ? _this$_overrides$laye : this._djb2Map.get($cc03770895d4ab2a$var$djb2MapKey(current.name, 'layers'));
                if (overridden == null) return null;
                return $cc03770895d4ab2a$var$_objectSpread($cc03770895d4ab2a$var$_objectSpread({}, current), {}, {
                    __value: overridden,
                    get: (0, $dtn6l._makeTypedGet)(current.name, overridden),
                    details: $cc03770895d4ab2a$var$_objectSpread($cc03770895d4ab2a$var$_objectSpread({}, current.details), {}, {
                        reason: $cc03770895d4ab2a$var$LOCAL_OVERRIDE_REASON
                    })
                });
            }
        },
        {
            key: "_getConfigOverride",
            value: function _getConfigOverride(current, lookup) {
                var _lookup$current$name;
                var overridden = (_lookup$current$name = lookup[current.name]) !== null && _lookup$current$name !== void 0 ? _lookup$current$name : this._djb2Map.get($cc03770895d4ab2a$var$djb2MapKey(current.name, 'configs'));
                if (overridden == null) return null;
                return $cc03770895d4ab2a$var$_objectSpread($cc03770895d4ab2a$var$_objectSpread({}, current), {}, {
                    value: overridden,
                    get: (0, $dtn6l._makeTypedGet)(current.name, overridden),
                    details: $cc03770895d4ab2a$var$_objectSpread($cc03770895d4ab2a$var$_objectSpread({}, current.details), {}, {
                        reason: $cc03770895d4ab2a$var$LOCAL_OVERRIDE_REASON
                    })
                });
            }
        }
    ]);
}();





var $19b38a6452791af6$var$_excluded = [
    "sdkKey",
    "environment",
    "updateUserCompletionCallback",
    "perimeter"
];
function $19b38a6452791af6$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $19b38a6452791af6$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $19b38a6452791af6$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $5bc9a370f4de45ae$export$2e2bcd8739ae039)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $19b38a6452791af6$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $19b38a6452791af6$var$DEFAULT_CLIENT_KEY = 'client-default-key';
// default event logging api is Atlassian proxy rather than Statsig's domain, to avoid ad blockers
var $19b38a6452791af6$var$DEFAULT_EVENT_LOGGING_API = 'https://xp.atlassian.com/v1/rgstr';
var $19b38a6452791af6$export$1f2bb630327ac4b6 = /*#__PURE__*/ function() {
    function Client() {
        var _this = this;
        var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, _ref$localStorageKey = _ref.localStorageKey, localStorageKey = _ref$localStorageKey === void 0 ? (0, $cc03770895d4ab2a$export$d8474cff104280f3) : _ref$localStorageKey, overrideAdapter = _ref.overrideAdapter;
        (0, $ad05016a8a78b31b$export$2e2bcd8739ae039)(this, Client);
        (0, $5bc9a370f4de45ae$export$2e2bcd8739ae039)(this, "initPromise", null);
        /** True if an initialize method was called and completed successfully. */ (0, $5bc9a370f4de45ae$export$2e2bcd8739ae039)(this, "initCompleted", false);
        /**
     * True if an initialize method was called and completed, meaning the client is now usable.
     * However if there was an error during initialization it may have initialized with default
     * values. Use {@link initCompleted} to check for this.
     */ (0, $5bc9a370f4de45ae$export$2e2bcd8739ae039)(this, "initWithDefaults", false);
        (0, $5bc9a370f4de45ae$export$2e2bcd8739ae039)(this, "hasCheckGateErrorOccurred", false);
        (0, $5bc9a370f4de45ae$export$2e2bcd8739ae039)(this, "hasGetExperimentErrorOccurred", false);
        (0, $5bc9a370f4de45ae$export$2e2bcd8739ae039)(this, "hasGetExperimentValueErrorOccurred", false);
        (0, $5bc9a370f4de45ae$export$2e2bcd8739ae039)(this, "hasGetLayerErrorOccurred", false);
        (0, $5bc9a370f4de45ae$export$2e2bcd8739ae039)(this, "hasGetLayerValueErrorOccurred", false);
        (0, $5bc9a370f4de45ae$export$2e2bcd8739ae039)(this, "subscriptions", new (0, $b07b19f6569a1fad$export$2e2bcd8739ae039)());
        (0, $5bc9a370f4de45ae$export$2e2bcd8739ae039)(this, "dataAdapter", new (0, $d31f983a2f547cf6$export$55fffef3474104af)());
        /**
     * Call this if modifying the values being served by the Statsig library since it has its own
     * memoization cache which will not be updated if the values are changed outside of the library.
     */ (0, $5bc9a370f4de45ae$export$2e2bcd8739ae039)(this, "statsigValuesUpdated", function() {
            if (_this.user) // Trigger a reset of the memoize cache
            _this.statsigClient.updateUserSync(_this.user, {
                disableBackgroundCacheRefresh: true
            });
            _this.subscriptions.anyUpdated();
        });
        this.overrideAdapter = overrideAdapter || new (0, $cc03770895d4ab2a$export$bcb28fbac1def494)(localStorageKey);
    }
    /**
   * @description
   * This method initializes the client using a network call to fetch the bootstrap values.
   * If the client is inialized with an `analyticsWebClient`, it will send an operational event
   * to GASv3 with the following attributes:
   * - targetApp: the target app of the client
   * - clientVersion: the version of the client
   * - success: whether the initialization was successful
   * - startTime: the time when the initialization started
   * - totalTime: the total time it took to initialize the client
   * - apiKey: the api key used to initialize the client
   * @param clientOptions {ClientOptions}
   * @param identifiers {Identifiers}
   * @param customAttributes {CustomAttributes}
   * @returns {Promise<void>}
   */ return (0, $7ee2b561172d79b0$export$2e2bcd8739ae039)(Client, [
        {
            key: "initialize",
            value: function() {
                var _initialize = (0, $149f9a5148f3c87f$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($c99432794f8a5953$exports))).mark(function _callee(clientOptions, identifiers, customAttributes) {
                    var _this2 = this;
                    var clientOptionsWithDefaults, startTime;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($c99432794f8a5953$exports))).wrap(function(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                clientOptionsWithDefaults = (0, $4ae5b0ef62bf70c0$export$d119b37e5f788b43)(clientOptions);
                                if (!this.initPromise) {
                                    _context.next = 1;
                                    break;
                                }
                                if (!(0, $4ae5b0ef62bf70c0$export$fa1c2bbf4100b8bc)(clientOptionsWithDefaults, this.initOptions)) // eslint-disable-next-line no-console
                                console.warn('Feature Gates client already initialized with different options. New options were not applied.');
                                return _context.abrupt("return", this.initPromise);
                            case 1:
                                startTime = performance.now();
                                this.initOptions = clientOptionsWithDefaults;
                                this.initPromise = this.init(clientOptionsWithDefaults, identifiers, customAttributes).then(function() {
                                    _this2.initCompleted = true;
                                    _this2.initWithDefaults = true;
                                }).finally(function() {
                                    var endTime = performance.now();
                                    var totalTime = endTime - startTime;
                                    _this2.fireClientEvent(startTime, totalTime, 'initialize', _this2.initCompleted, clientOptionsWithDefaults.apiKey);
                                });
                                return _context.abrupt("return", this.initPromise);
                            case 2:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee, this);
                }));
                function initialize(_x, _x2, _x3) {
                    return _initialize.apply(this, arguments);
                }
                return initialize;
            }()
        },
        {
            key: "initializeWithProvider",
            value: function() {
                var _initializeWithProvider = (0, $149f9a5148f3c87f$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($c99432794f8a5953$exports))).mark(function _callee2(clientOptions, provider, identifiers, customAttributes) {
                    var _this3 = this;
                    var clientOptionsWithDefaults, startTime;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($c99432794f8a5953$exports))).wrap(function(_context2) {
                        while(true)switch(_context2.prev = _context2.next){
                            case 0:
                                clientOptionsWithDefaults = (0, $4ae5b0ef62bf70c0$export$d119b37e5f788b43)(clientOptions);
                                if (!this.initPromise) {
                                    _context2.next = 1;
                                    break;
                                }
                                if (!(0, $4ae5b0ef62bf70c0$export$fa1c2bbf4100b8bc)(clientOptionsWithDefaults, this.initOptions)) // eslint-disable-next-line no-console
                                console.warn('Feature Gates client already initialized with different options. New options were not applied.');
                                return _context2.abrupt("return", this.initPromise);
                            case 1:
                                startTime = performance.now();
                                this.initOptions = clientOptionsWithDefaults;
                                this.provider = provider;
                                this.provider.setClientVersion((0, $daebafeb0bbc8260$export$a59f8d67326bd1cb));
                                if (this.provider.setApplyUpdateCallback) this.provider.setApplyUpdateCallback(this.applyUpdateCallback.bind(this));
                                this.initPromise = this.initWithProvider(clientOptionsWithDefaults, provider, identifiers, customAttributes).then(function() {
                                    _this3.initCompleted = true;
                                    _this3.initWithDefaults = true;
                                }).finally(function() {
                                    var endTime = performance.now();
                                    var totalTime = endTime - startTime;
                                    _this3.fireClientEvent(startTime, totalTime, 'initializeWithProvider', _this3.initCompleted, provider.getApiKey ? provider.getApiKey() : undefined);
                                });
                                return _context2.abrupt("return", this.initPromise);
                            case 2:
                            case "end":
                                return _context2.stop();
                        }
                    }, _callee2, this);
                }));
                function initializeWithProvider(_x4, _x5, _x6, _x7) {
                    return _initializeWithProvider.apply(this, arguments);
                }
                return initializeWithProvider;
            }()
        },
        {
            key: "applyUpdateCallback",
            value: function applyUpdateCallback(experimentsResult) {
                try {
                    if (this.initCompleted || this.initWithDefaults) {
                        this.assertInitialized(this.statsigClient);
                        this.dataAdapter.setBootstrapData(experimentsResult.experimentValues);
                        this.dataAdapter.setData(JSON.stringify(experimentsResult.experimentValues));
                        this.statsigValuesUpdated();
                    }
                } catch (error) {
                    // eslint-disable-next-line no-console
                    console.warn('Error when attempting to apply update', error);
                }
            }
        },
        {
            key: "fireClientEvent",
            value: function fireClientEvent(startTime, totalTime, action, success) {
                var _analyticsWebClient, _this4 = this;
                var apiKey = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;
                (_analyticsWebClient = this.initOptions.analyticsWebClient) === null || _analyticsWebClient === void 0 || _analyticsWebClient.then(function(analyticsWebClient) {
                    var attributes = $19b38a6452791af6$var$_objectSpread({
                        targetApp: _this4.initOptions.targetApp,
                        clientVersion: (0, $daebafeb0bbc8260$export$a59f8d67326bd1cb),
                        success: success,
                        startTime: startTime,
                        totalTime: totalTime
                    }, apiKey && {
                        apiKey: apiKey
                    });
                    analyticsWebClient.sendOperationalEvent({
                        action: action,
                        actionSubject: 'featureGatesClient',
                        attributes: attributes,
                        tags: [
                            'measurement'
                        ],
                        source: '@atlaskit/feature-gate-js-client'
                    });
                }).catch(function(err) {
                    if (_this4.initOptions.environment !== (0, $85ad0eea8eb928fe$export$479e7351a733299).Production) // eslint-disable-next-line no-console
                    console.error('Analytics web client promise did not resolve', err);
                });
            }
        },
        {
            key: "initializeFromValues",
            value: function() {
                var _initializeFromValues = (0, $149f9a5148f3c87f$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($c99432794f8a5953$exports))).mark(function _callee3(clientOptions, identifiers, customAttributes) {
                    var _this5 = this;
                    var initializeValues, clientOptionsWithDefaults, startTime, _args3 = arguments;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($c99432794f8a5953$exports))).wrap(function(_context3) {
                        while(true)switch(_context3.prev = _context3.next){
                            case 0:
                                initializeValues = _args3.length > 3 && _args3[3] !== undefined ? _args3[3] : {};
                                clientOptionsWithDefaults = (0, $4ae5b0ef62bf70c0$export$d119b37e5f788b43)(clientOptions);
                                if (!this.initPromise) {
                                    _context3.next = 1;
                                    break;
                                }
                                if (!(0, $4ae5b0ef62bf70c0$export$fa1c2bbf4100b8bc)(clientOptionsWithDefaults, this.initOptions)) // eslint-disable-next-line no-console
                                console.warn('Feature Gates client already initialized with different options. New options were not applied.');
                                return _context3.abrupt("return", this.initPromise);
                            case 1:
                                // This makes sure the new Statsig client behaves like the old when bootstrap data is
                                // passed, and `has_updates` isn't specified (which happens a lot in product integration tests).
                                if (!Object.prototype.hasOwnProperty.call(initializeValues, 'has_updates')) initializeValues['has_updates'] = true;
                                startTime = performance.now();
                                this.initOptions = clientOptionsWithDefaults;
                                this.initPromise = this.initFromValues(clientOptionsWithDefaults, identifiers, customAttributes, initializeValues).then(function() {
                                    _this5.initCompleted = true;
                                    _this5.initWithDefaults = true;
                                }).finally(function() {
                                    var endTime = performance.now();
                                    var totalTime = endTime - startTime;
                                    _this5.fireClientEvent(startTime, totalTime, 'initializeFromValues', _this5.initCompleted);
                                });
                                return _context3.abrupt("return", this.initPromise);
                            case 2:
                            case "end":
                                return _context3.stop();
                        }
                    }, _callee3, this);
                }));
                function initializeFromValues(_x8, _x9, _x0) {
                    return _initializeFromValues.apply(this, arguments);
                }
                return initializeFromValues;
            }()
        },
        {
            key: "assertInitialized",
            value: function assertInitialized(statsigClient) {
                if (!statsigClient) throw new Error('Client must be initialized before using this method');
            }
        },
        {
            key: "updateUser",
            value: function() {
                var _updateUser = (0, $149f9a5148f3c87f$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($c99432794f8a5953$exports))).mark(function _callee4(fetchOptions, identifiers, customAttributes) {
                    var fetchOptionsWithDefaults, initializeValuesProducer;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($c99432794f8a5953$exports))).wrap(function(_context4) {
                        while(true)switch(_context4.prev = _context4.next){
                            case 0:
                                this.assertInitialized(this.statsigClient);
                                fetchOptionsWithDefaults = (0, $4ae5b0ef62bf70c0$export$d119b37e5f788b43)(fetchOptions);
                                initializeValuesProducer = function initializeValuesProducer() {
                                    return (0, $867e1b8128863989$export$2e2bcd8739ae039).fetchExperimentValues(fetchOptionsWithDefaults, identifiers, customAttributes).then(function(_ref2) {
                                        var experimentValues = _ref2.experimentValues, customAttributes = _ref2.customAttributes;
                                        return {
                                            experimentValues: experimentValues,
                                            customAttributesFromFetch: customAttributes
                                        };
                                    });
                                };
                                _context4.next = 1;
                                return this.updateUserUsingInitializeValuesProducer(initializeValuesProducer, identifiers, customAttributes);
                            case 1:
                            case "end":
                                return _context4.stop();
                        }
                    }, _callee4, this);
                }));
                function updateUser(_x1, _x10, _x11) {
                    return _updateUser.apply(this, arguments);
                }
                return updateUser;
            }()
        },
        {
            key: "updateUserWithProvider",
            value: function() {
                var _updateUserWithProvider = (0, $149f9a5148f3c87f$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($c99432794f8a5953$exports))).mark(function _callee5(identifiers, customAttributes) {
                    var _this6 = this;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($c99432794f8a5953$exports))).wrap(function(_context5) {
                        while(true)switch(_context5.prev = _context5.next){
                            case 0:
                                this.assertInitialized(this.statsigClient);
                                if (this.provider) {
                                    _context5.next = 1;
                                    break;
                                }
                                throw new Error('Cannot update user using provider as the client was not initialised with a provider');
                            case 1:
                                _context5.next = 2;
                                return this.provider.setProfile(this.initOptions, identifiers, customAttributes);
                            case 2:
                                _context5.next = 3;
                                return this.updateUserUsingInitializeValuesProducer(function() {
                                    return _this6.provider.getExperimentValues();
                                }, identifiers, customAttributes);
                            case 3:
                            case "end":
                                return _context5.stop();
                        }
                    }, _callee5, this);
                }));
                function updateUserWithProvider(_x12, _x13) {
                    return _updateUserWithProvider.apply(this, arguments);
                }
                return updateUserWithProvider;
            }()
        },
        {
            key: "updateUserWithValues",
            value: function() {
                var _updateUserWithValues = (0, $149f9a5148f3c87f$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($c99432794f8a5953$exports))).mark(function _callee6(identifiers, customAttributes) {
                    var initializeValues, initializeValuesProducer, _args6 = arguments;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($c99432794f8a5953$exports))).wrap(function(_context6) {
                        while(true)switch(_context6.prev = _context6.next){
                            case 0:
                                initializeValues = _args6.length > 2 && _args6[2] !== undefined ? _args6[2] : {};
                                this.assertInitialized(this.statsigClient);
                                initializeValuesProducer = function initializeValuesProducer() {
                                    return Promise.resolve({
                                        experimentValues: initializeValues,
                                        customAttributesFromFetch: customAttributes
                                    });
                                };
                                _context6.next = 1;
                                return this.updateUserUsingInitializeValuesProducer(initializeValuesProducer, identifiers, customAttributes);
                            case 1:
                            case "end":
                                return _context6.stop();
                        }
                    }, _callee6, this);
                }));
                function updateUserWithValues(_x14, _x15) {
                    return _updateUserWithValues.apply(this, arguments);
                }
                return updateUserWithValues;
            }()
        },
        {
            key: "initializeCalled",
            value: function initializeCalled() {
                return this.initPromise != null;
            }
        },
        {
            key: "initializeCompleted",
            value: function initializeCompleted() {
                return this.initCompleted;
            }
        },
        {
            key: "waitUntilInitializeCompleted",
            value: function() {
                var _waitUntilInitializeCompleted = (0, $149f9a5148f3c87f$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($c99432794f8a5953$exports))).mark(function _callee7() {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($c99432794f8a5953$exports))).wrap(function(_context7) {
                        while(true)switch(_context7.prev = _context7.next){
                            case 0:
                                if (this.initPromise) {
                                    _context7.next = 1;
                                    break;
                                }
                                throw new Error('The client must be initialized before you can wait until initialized.');
                            case 1:
                                if (!this.initCompleted) {
                                    _context7.next = 2;
                                    break;
                                }
                                return _context7.abrupt("return");
                            case 2:
                                _context7.next = 3;
                                return this.initPromise;
                            case 3:
                            case "end":
                                return _context7.stop();
                        }
                    }, _callee7, this);
                }));
                function waitUntilInitializeCompleted() {
                    return _waitUntilInitializeCompleted.apply(this, arguments);
                }
                return waitUntilInitializeCompleted;
            }()
        },
        {
            key: "checkGate",
            value: function checkGate(gateName) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                try {
                    this.assertInitialized(this.statsigClient);
                    var _options$fireGateExpo = options.fireGateExposure, fireGateExposure = _options$fireGateExpo === void 0 ? true : _options$fireGateExpo;
                    return this.statsigClient.checkGate(gateName, {
                        disableExposureLog: !fireGateExposure
                    });
                } catch (error) {
                    // Log the first occurrence of the error
                    if (!this.hasCheckGateErrorOccurred) {
                        // eslint-disable-next-line no-console
                        console.warn({
                            msg: 'An error has occurred checking the feature gate. Only the first occurrence of this error is logged.',
                            gateName: gateName,
                            error: error
                        });
                        this.hasCheckGateErrorOccurred = true;
                    }
                    return false;
                }
            }
        },
        {
            key: "isGateExist",
            value: function isGateExist(gateName) {
                try {
                    this.assertInitialized(this.statsigClient);
                    var gate = this.statsigClient.getFeatureGate(gateName, {
                        disableExposureLog: true
                    });
                    return !gate.details.reason.includes('Unrecognized');
                } catch (error) {
                    // eslint-disable-next-line no-console
                    console.error("Error occurred when trying to check FeatureGate: ".concat(error));
                    // in case of error report true to avoid false positives.
                    return true;
                }
            }
        },
        {
            key: "isExperimentExist",
            value: function isExperimentExist(experimentName) {
                try {
                    this.assertInitialized(this.statsigClient);
                    var config = this.statsigClient.getExperiment(experimentName, {
                        disableExposureLog: true
                    });
                    return !config.details.reason.includes('Unrecognized');
                } catch (error) {
                    // eslint-disable-next-line no-console
                    console.error("Error occurred when trying to check Experiment: ".concat(error));
                    // in case of error report true to avoid false positives.
                    return true;
                }
            }
        },
        {
            key: "manuallyLogGateExposure",
            value: function manuallyLogGateExposure(gateName) {
                this.assertInitialized(this.statsigClient);
                // This is the approach recommended in the docs
                // https://docs.statsig.com/client/javascript-sdk/#manual-exposures-
                this.statsigClient.checkGate(gateName);
            }
        },
        {
            key: "getExperiment",
            value: function getExperiment(experimentName) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                try {
                    this.assertInitialized(this.statsigClient);
                    var _options$fireExperime = options.fireExperimentExposure, fireExperimentExposure = _options$fireExperime === void 0 ? true : _options$fireExperime;
                    return (0, $bfe3e8d5767a36a7$export$6dc24881a3d96325).fromExperiment(this.statsigClient.getExperiment(experimentName, {
                        disableExposureLog: !fireExperimentExposure
                    }));
                } catch (error) {
                    // Log the first occurrence of the error
                    if (!this.hasGetExperimentErrorOccurred) {
                        // eslint-disable-next-line no-console
                        console.warn({
                            msg: 'An error has occurred getting the experiment. Only the first occurrence of this error is logged.',
                            experimentName: experimentName,
                            error: error
                        });
                        this.hasGetExperimentErrorOccurred = true;
                    }
                    // Return a default value
                    return new (0, $bfe3e8d5767a36a7$export$6dc24881a3d96325)(experimentName, {}, '', {
                        time: Date.now(),
                        reason: (0, $a7c68762f727da9c$export$c62558b199e46828).Error
                    });
                }
            }
        },
        {
            key: "getExperimentValue",
            value: function getExperimentValue(experimentName, parameterName, defaultValue) {
                var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var experiment = this.getExperiment(experimentName, options);
                try {
                    var typeGuard = options.typeGuard;
                    return experiment.get(parameterName, defaultValue, typeGuard);
                } catch (error) {
                    // Log the first occurrence of the error
                    if (!this.hasGetExperimentValueErrorOccurred) {
                        // eslint-disable-next-line no-console
                        console.warn({
                            msg: 'An error has occurred getting the experiment value. Only the first occurrence of this error is logged.',
                            experimentName: experimentName,
                            defaultValue: defaultValue,
                            options: options,
                            error: error
                        });
                        this.hasGetExperimentValueErrorOccurred = true;
                    }
                    return defaultValue;
                }
            }
        },
        {
            key: "manuallyLogExperimentExposure",
            value: function manuallyLogExperimentExposure(experimentName) {
                this.assertInitialized(this.statsigClient);
                // This is the approach recommended in the docs
                // https://docs.statsig.com/client/javascript-sdk/#manual-exposures-
                this.statsigClient.getExperiment(experimentName);
            }
        },
        {
            key: "manuallyLogLayerExposure",
            value: function manuallyLogLayerExposure(layerName, parameterName) {
                var _this$statsigClient$g;
                this.assertInitialized(this.statsigClient);
                // This is the approach recommended in the docs
                // https://docs.statsig.com/client/javascript-sdk/#manual-exposures-
                (_this$statsigClient$g = this.statsigClient.getLayer(layerName)) === null || _this$statsigClient$g === void 0 || _this$statsigClient$g.get(parameterName);
            }
        },
        {
            key: "shutdownStatsig",
            value: function shutdownStatsig() {
                this.assertInitialized(this.statsigClient);
                this.statsigClient.shutdown();
            }
        },
        {
            key: "overrideGate",
            value: function overrideGate(gateName, value) {
                this.overrideAdapter.overrideGate(gateName, value);
                // Trigger a reset of the memoized gate value
                if (this.user) {
                    var _this$statsigClient;
                    (_this$statsigClient = this.statsigClient) === null || _this$statsigClient === void 0 || _this$statsigClient.updateUserSync(this.user, {
                        disableBackgroundCacheRefresh: true
                    });
                }
                this.statsigValuesUpdated();
            }
        },
        {
            key: "clearGateOverride",
            value: function clearGateOverride(gateName) {
                this.overrideAdapter.removeGateOverride(gateName);
                this.statsigValuesUpdated();
            }
        },
        {
            key: "overrideConfig",
            value: function overrideConfig(experimentName, values) {
                this.overrideAdapter.overrideDynamicConfig(experimentName, values);
                this.statsigValuesUpdated();
            }
        },
        {
            key: "clearConfigOverride",
            value: function clearConfigOverride(experimentName) {
                this.overrideAdapter.removeDynamicConfigOverride(experimentName);
                this.statsigValuesUpdated();
            }
        },
        {
            key: "setOverrides",
            value: function setOverrides(overrides) {
                this.overrideAdapter.setOverrides(overrides);
                this.statsigValuesUpdated();
            }
        },
        {
            key: "getOverrides",
            value: function getOverrides() {
                return this.overrideAdapter.getOverrides();
            }
        },
        {
            key: "clearAllOverrides",
            value: function clearAllOverrides() {
                this.overrideAdapter.removeAllOverrides();
                this.statsigValuesUpdated();
            }
        },
        {
            key: "isCurrentUser",
            value: function isCurrentUser(identifiers, customAttributes) {
                return (0, $4ae5b0ef62bf70c0$export$fa1c2bbf4100b8bc)(this.currentIdentifiers, identifiers) && (0, $4ae5b0ef62bf70c0$export$fa1c2bbf4100b8bc)(this.currentAttributes, customAttributes);
            }
        },
        {
            key: "onGateUpdated",
            value: function onGateUpdated(gateName, callback) {
                var _this7 = this;
                var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                var wrapCallback = function wrapCallback(value) {
                    var _options$fireGateExpo2 = options.fireGateExposure, fireGateExposure = _options$fireGateExpo2 === void 0 ? true : _options$fireGateExpo2;
                    if (fireGateExposure) _this7.manuallyLogGateExposure(gateName);
                    try {
                        callback(value);
                    } catch (error) {
                        // eslint-disable-next-line no-console
                        console.warn("Error calling callback for gate ".concat(gateName, " with value ").concat(value), error);
                    }
                };
                return this.subscriptions.onGateUpdated(gateName, wrapCallback, this.checkGate.bind(this), options);
            }
        },
        {
            key: "onExperimentValueUpdated",
            value: function onExperimentValueUpdated(experimentName, parameterName, defaultValue, callback) {
                var _this8 = this;
                var options = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
                var wrapCallback = function wrapCallback(value) {
                    var _options$fireExperime2 = options.fireExperimentExposure, fireExperimentExposure = _options$fireExperime2 === void 0 ? true : _options$fireExperime2;
                    if (fireExperimentExposure) _this8.manuallyLogExperimentExposure(experimentName);
                    try {
                        callback(value);
                    } catch (error) {
                        // eslint-disable-next-line no-console
                        console.warn("Error calling callback for experiment ".concat(experimentName, " with value ").concat(value), error);
                    }
                };
                return this.subscriptions.onExperimentValueUpdated(experimentName, parameterName, defaultValue, wrapCallback, this.getExperimentValue.bind(this), options);
            }
        },
        {
            key: "onAnyUpdated",
            value: function onAnyUpdated(callback) {
                return this.subscriptions.onAnyUpdated(callback);
            }
        },
        {
            key: "init",
            value: function() {
                var _init = (0, $149f9a5148f3c87f$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($c99432794f8a5953$exports))).mark(function _callee8(clientOptions, identifiers, customAttributes) {
                    var fromValuesClientOptions, experimentValues, customAttributesFromResult, clientSdkKeyPromise, experimentValuesPromise, _yield$Promise$all, _yield$Promise$all2, experimentValuesResult, _t;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($c99432794f8a5953$exports))).wrap(function(_context8) {
                        while(true)switch(_context8.prev = _context8.next){
                            case 0:
                                fromValuesClientOptions = $19b38a6452791af6$var$_objectSpread({}, clientOptions);
                                if (!clientOptions.localMode) {
                                    _context8.next = 2;
                                    break;
                                }
                                _context8.next = 1;
                                return this.initFromValues(fromValuesClientOptions, identifiers, customAttributes);
                            case 1:
                                return _context8.abrupt("return");
                            case 2:
                                _context8.prev = 2;
                                // If client sdk key fetch fails, an error would be thrown and handled instead of waiting for
                                // the experiment values request to be settled, and it will fall back to use default values.
                                clientSdkKeyPromise = (0, $867e1b8128863989$export$2e2bcd8739ae039).fetchClientSdk(clientOptions).then(function(value) {
                                    return fromValuesClientOptions.sdkKey = value.clientSdkKey;
                                });
                                experimentValuesPromise = (0, $867e1b8128863989$export$2e2bcd8739ae039).fetchExperimentValues(clientOptions, identifiers, customAttributes); // Only wait for the experiment values request to finish and try to initialise the client
                                // with experiment values if both requests are successful. Else an error would be thrown and
                                // handled by the catch
                                _context8.next = 3;
                                return Promise.all([
                                    clientSdkKeyPromise,
                                    experimentValuesPromise
                                ]);
                            case 3:
                                _yield$Promise$all = _context8.sent;
                                _yield$Promise$all2 = (0, $958636c847d8b316$export$2e2bcd8739ae039)(_yield$Promise$all, 2);
                                experimentValuesResult = _yield$Promise$all2[1];
                                experimentValues = experimentValuesResult.experimentValues;
                                customAttributesFromResult = experimentValuesResult.customAttributes;
                                _context8.next = 6;
                                break;
                            case 4:
                                _context8.prev = 4;
                                _t = _context8["catch"](2);
                                if (_t instanceof Error) // eslint-disable-next-line no-console
                                console.error("Error occurred when trying to fetch the Feature Gates client values, error: ".concat(_t === null || _t === void 0 ? void 0 : _t.message));
                                // eslint-disable-next-line no-console
                                console.warn("Initialising Statsig client without values");
                                _context8.next = 5;
                                return this.initFromValues(fromValuesClientOptions, identifiers, customAttributes);
                            case 5:
                                throw _t;
                            case 6:
                                return _context8.abrupt("return", this.initFromValues(fromValuesClientOptions, identifiers, customAttributesFromResult, experimentValues));
                            case 7:
                            case "end":
                                return _context8.stop();
                        }
                    }, _callee8, this, [
                        [
                            2,
                            4
                        ]
                    ]);
                }));
                function init(_x16, _x17, _x18) {
                    return _init.apply(this, arguments);
                }
                return init;
            }()
        },
        {
            key: "initWithProvider",
            value: function() {
                var _initWithProvider = (0, $149f9a5148f3c87f$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($c99432794f8a5953$exports))).mark(function _callee9(baseClientOptions, provider, identifiers, customAttributes) {
                    var fromValuesClientOptions, experimentValues, customAttributesFromResult, clientSdkKeyPromise, experimentValuesPromise, _yield$Promise$all3, _yield$Promise$all4, experimentValuesResult, _t2;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($c99432794f8a5953$exports))).wrap(function(_context9) {
                        while(true)switch(_context9.prev = _context9.next){
                            case 0:
                                fromValuesClientOptions = $19b38a6452791af6$var$_objectSpread($19b38a6452791af6$var$_objectSpread({}, baseClientOptions), {}, {
                                    disableCurrentPageLogging: true
                                });
                                _context9.prev = 1;
                                _context9.next = 2;
                                return provider.setProfile(baseClientOptions, identifiers, customAttributes);
                            case 2:
                                // If client sdk key fetch fails, an error would be thrown and handled instead of waiting for
                                // the experiment values request to be settled, and it will fall back to use default values.
                                clientSdkKeyPromise = provider.getClientSdkKey().then(function(value) {
                                    return fromValuesClientOptions.sdkKey = value;
                                });
                                experimentValuesPromise = provider.getExperimentValues(); // Only wait for the experiment values request to finish and try to initialise the client
                                // with experiment values if both requests are successful. Else an error would be thrown and
                                // handled by the catch
                                _context9.next = 3;
                                return Promise.all([
                                    clientSdkKeyPromise,
                                    experimentValuesPromise
                                ]);
                            case 3:
                                _yield$Promise$all3 = _context9.sent;
                                _yield$Promise$all4 = (0, $958636c847d8b316$export$2e2bcd8739ae039)(_yield$Promise$all3, 2);
                                experimentValuesResult = _yield$Promise$all4[1];
                                experimentValues = experimentValuesResult.experimentValues;
                                customAttributesFromResult = experimentValuesResult.customAttributesFromFetch;
                                _context9.next = 6;
                                break;
                            case 4:
                                _context9.prev = 4;
                                _t2 = _context9["catch"](1);
                                if (_t2 instanceof Error) // eslint-disable-next-line no-console
                                console.error("Error occurred when trying to fetch the Feature Gates client values, error: ".concat(_t2 === null || _t2 === void 0 ? void 0 : _t2.message));
                                // eslint-disable-next-line no-console
                                console.warn("Initialising Statsig client without values");
                                _context9.next = 5;
                                return this.initFromValues(fromValuesClientOptions, identifiers, customAttributes);
                            case 5:
                                throw _t2;
                            case 6:
                                return _context9.abrupt("return", this.initFromValues(fromValuesClientOptions, identifiers, customAttributesFromResult, experimentValues));
                            case 7:
                            case "end":
                                return _context9.stop();
                        }
                    }, _callee9, this, [
                        [
                            1,
                            4
                        ]
                    ]);
                }));
                function initWithProvider(_x19, _x20, _x21, _x22) {
                    return _initWithProvider.apply(this, arguments);
                }
                return initWithProvider;
            }()
        },
        {
            key: "initFromValues",
            value: function() {
                var _initFromValues = (0, $149f9a5148f3c87f$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($c99432794f8a5953$exports))).mark(function _callee0(clientOptions, identifiers, customAttributes) {
                    var _newClientOptions$net;
                    var initializeValues, newClientOptions, sdkKey, environment, _updateUserCompletionCallback, _perimeter, restClientOptions, frontendUser, statsigOptions, _args0 = arguments, _t3;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($c99432794f8a5953$exports))).wrap(function(_context0) {
                        while(true)switch(_context0.prev = _context0.next){
                            case 0:
                                initializeValues = _args0.length > 3 && _args0[3] !== undefined ? _args0[3] : {};
                                this.overrideAdapter.initFromStoredOverrides();
                                this.currentIdentifiers = identifiers;
                                this.currentAttributes = customAttributes;
                                newClientOptions = (0, $4ae5b0ef62bf70c0$export$202946b690d26d22)(clientOptions);
                                if (!newClientOptions.sdkKey) newClientOptions.sdkKey = $19b38a6452791af6$var$DEFAULT_CLIENT_KEY;
                                if (!((_newClientOptions$net = newClientOptions.networkConfig) !== null && _newClientOptions$net !== void 0 && _newClientOptions$net.logEventUrl)) newClientOptions.networkConfig = $19b38a6452791af6$var$_objectSpread($19b38a6452791af6$var$_objectSpread({}, newClientOptions.networkConfig), {}, {
                                    logEventUrl: $19b38a6452791af6$var$DEFAULT_EVENT_LOGGING_API
                                });
                                if (newClientOptions.perimeter === (0, $85ad0eea8eb928fe$export$c42b7bbc5e7ba555).FEDRAMP_MODERATE) // disable all logging in FedRAMP to prevent egress of sensitive data
                                newClientOptions.disableLogging = true;
                                sdkKey = newClientOptions.sdkKey, environment = newClientOptions.environment, _updateUserCompletionCallback = newClientOptions.updateUserCompletionCallback, _perimeter = newClientOptions.perimeter, restClientOptions = (0, $b45e4aa52a06dd77$export$2e2bcd8739ae039)(newClientOptions, $19b38a6452791af6$var$_excluded);
                                frontendUser = (0, $4ae5b0ef62bf70c0$export$3dad1db244472f32)(identifiers, customAttributes);
                                this.user = (0, $4ae5b0ef62bf70c0$export$1148cb79ceecd5fa)({}, initializeValues.user, frontendUser);
                                statsigOptions = $19b38a6452791af6$var$_objectSpread($19b38a6452791af6$var$_objectSpread({}, restClientOptions), {}, {
                                    environment: {
                                        tier: environment
                                    },
                                    includeCurrentPageUrlWithEvents: false,
                                    dataAdapter: this.dataAdapter,
                                    overrideAdapter: this.overrideAdapter,
                                    logEventCompressionMode: (0, $iFR7a.LogEventCompressionMode).Forced
                                }); // Statsig validates the provided stableId against their own cookie, so we either need
                                // to update the cookie to match, or disable the validation completely.
                                if (identifiers.stableId) (0, $iFR7a.StableID).setOverride(identifiers.stableId, sdkKey);
                                else statsigOptions.disableStableID = true;
                                _context0.prev = 1;
                                this.statsigClient = new (0, $iFR7a.StatsigClient)(sdkKey, this.user, statsigOptions);
                                this.dataAdapter.setBootstrapData(initializeValues);
                                _context0.next = 2;
                                return this.statsigClient.initializeAsync();
                            case 2:
                                _context0.next = 5;
                                break;
                            case 3:
                                _context0.prev = 3;
                                _t3 = _context0["catch"](1);
                                if (_t3 instanceof Error) // eslint-disable-next-line no-console
                                console.error("Error occurred when trying to initialise the Statsig client, error: ".concat(_t3 === null || _t3 === void 0 ? void 0 : _t3.message));
                                // eslint-disable-next-line no-console
                                console.warn("Initialising Statsig client with default sdk key and without values");
                                this.statsigClient = new (0, $iFR7a.StatsigClient)($19b38a6452791af6$var$DEFAULT_CLIENT_KEY, this.user, statsigOptions);
                                this.dataAdapter.setBootstrapData();
                                _context0.next = 4;
                                return this.statsigClient.initializeAsync();
                            case 4:
                                this.initWithDefaults = true;
                                throw _t3;
                            case 5:
                            case "end":
                                return _context0.stop();
                        }
                    }, _callee0, this, [
                        [
                            1,
                            3
                        ]
                    ]);
                }));
                function initFromValues(_x23, _x24, _x25) {
                    return _initFromValues.apply(this, arguments);
                }
                return initFromValues;
            }()
        },
        {
            key: "updateUserUsingInitializeValuesProducer",
            value: function() {
                var _updateUserUsingInitializeValuesProducer = (0, $149f9a5148f3c87f$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($c99432794f8a5953$exports))).mark(function _callee10(getInitializeValues, identifiers, customAttributes) {
                    var _this9 = this;
                    var originalInitPromise, initializeValuesPromise, updateUserPromise, _t4;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($c99432794f8a5953$exports))).wrap(function(_context10) {
                        while(true)switch(_context10.prev = _context10.next){
                            case 0:
                                this.assertInitialized(this.statsigClient);
                                if (this.initPromise) {
                                    _context10.next = 1;
                                    break;
                                }
                                throw new Error('The client must be initialized before you can update the user.');
                            case 1:
                                if (!this.isCurrentUser(identifiers, customAttributes)) {
                                    _context10.next = 2;
                                    break;
                                }
                                return _context10.abrupt("return", this.initPromise);
                            case 2:
                                // Wait for the current initialize/update to finish
                                originalInitPromise = this.initPromise;
                                _context10.prev = 3;
                                _context10.next = 4;
                                return this.initPromise;
                            case 4:
                                _context10.next = 6;
                                break;
                            case 5:
                                _context10.prev = 5;
                                _t4 = _context10["catch"](3);
                            case 6:
                                initializeValuesPromise = getInitializeValues();
                                updateUserPromise = this.updateStatsigClientUser(initializeValuesPromise, identifiers, customAttributes); // We replace the init promise here since we are essentially re-initializing the client at this
                                // point. Any subsequent calls to await client.initialize() or client.updateUser()
                                // will now also await this user update.
                                this.initPromise = updateUserPromise.catch(/*#__PURE__*/ (0, $149f9a5148f3c87f$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($c99432794f8a5953$exports))).mark(function _callee1() {
                                    return (0, (/*@__PURE__*/$parcel$interopDefault($c99432794f8a5953$exports))).wrap(function(_context1) {
                                        while(true)switch(_context1.prev = _context1.next){
                                            case 0:
                                                // If the update failed then it changed nothing, so revert back to the original promise.
                                                _this9.initPromise = originalInitPromise;
                                                // Set the user profile again to revert back to the current user
                                                if (!_this9.provider) {
                                                    _context1.next = 1;
                                                    break;
                                                }
                                                _context1.next = 1;
                                                return _this9.provider.setProfile(_this9.initOptions, _this9.currentIdentifiers, _this9.currentAttributes);
                                            case 1:
                                            case "end":
                                                return _context1.stop();
                                        }
                                    }, _callee1);
                                })));
                                return _context10.abrupt("return", updateUserPromise);
                            case 7:
                            case "end":
                                return _context10.stop();
                        }
                    }, _callee10, this, [
                        [
                            3,
                            5
                        ]
                    ]);
                }));
                function updateUserUsingInitializeValuesProducer(_x26, _x27, _x28) {
                    return _updateUserUsingInitializeValuesProducer.apply(this, arguments);
                }
                return updateUserUsingInitializeValuesProducer;
            }()
        },
        {
            key: "updateStatsigClientUser",
            value: function() {
                var _updateStatsigClientUser = (0, $149f9a5148f3c87f$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($c99432794f8a5953$exports))).mark(function _callee11(initializeValuesPromise, identifiers, customAttributes) {
                    var _this$initOptions, _this$initOptions$upd;
                    var initializeValues, user, frontendUser, _updateUserCompletion, _ref4, errMsg, success, errorMessage, _t5, _t6;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($c99432794f8a5953$exports))).wrap(function(_context11) {
                        while(true)switch(_context11.prev = _context11.next){
                            case 0:
                                this.assertInitialized(this.statsigClient);
                                _context11.prev = 1;
                                _context11.next = 2;
                                return initializeValuesPromise;
                            case 2:
                                initializeValues = _context11.sent;
                                frontendUser = (0, $4ae5b0ef62bf70c0$export$3dad1db244472f32)(identifiers, initializeValues.customAttributesFromFetch);
                                user = (0, $4ae5b0ef62bf70c0$export$1148cb79ceecd5fa)({}, initializeValues.experimentValues.user, frontendUser);
                                _context11.next = 4;
                                break;
                            case 3:
                                _context11.prev = 3;
                                _t5 = _context11["catch"](1);
                                // Make sure the updateUserCompletionCallback is called for any errors in our custom code.
                                // This is not necessary for the updateUserWithValues call, because the Statsig client will
                                // already invoke the callback itself.
                                errMsg = _t5 instanceof Error ? _t5.message : JSON.stringify(_t5);
                                (_updateUserCompletion = (_ref4 = this.initOptions).updateUserCompletionCallback) === null || _updateUserCompletion === void 0 || _updateUserCompletion.call(_ref4, false, errMsg);
                                throw _t5;
                            case 4:
                                success = true;
                                errorMessage = null;
                                _context11.prev = 5;
                                this.dataAdapter.setBootstrapData(initializeValues.experimentValues);
                                this.user = user;
                                if (!this.user) {
                                    _context11.next = 6;
                                    break;
                                }
                                _context11.next = 6;
                                return this.statsigClient.updateUserAsync(this.user);
                            case 6:
                                _context11.next = 8;
                                break;
                            case 7:
                                _context11.prev = 7;
                                _t6 = _context11["catch"](5);
                                success = false;
                                errorMessage = String(_t6);
                            case 8:
                                (_this$initOptions = this.initOptions) === null || _this$initOptions === void 0 || (_this$initOptions$upd = _this$initOptions.updateUserCompletionCallback) === null || _this$initOptions$upd === void 0 || _this$initOptions$upd.call(_this$initOptions, success, errorMessage);
                                if (!success) {
                                    _context11.next = 9;
                                    break;
                                }
                                this.currentIdentifiers = identifiers;
                                this.currentAttributes = customAttributes;
                                this.subscriptions.anyUpdated();
                                _context11.next = 10;
                                break;
                            case 9:
                                throw new Error('Failed to update user. An unexpected error occured.');
                            case 10:
                            case "end":
                                return _context11.stop();
                        }
                    }, _callee11, this, [
                        [
                            1,
                            3
                        ],
                        [
                            5,
                            7
                        ]
                    ]);
                }));
                function updateStatsigClientUser(_x29, _x30, _x31) {
                    return _updateStatsigClientUser.apply(this, arguments);
                }
                return updateStatsigClientUser;
            }()
        },
        {
            key: "getPackageVersion",
            value: /**
     * @returns string version of the current package in semver style.
     */ function getPackageVersion() {
                return 0, $daebafeb0bbc8260$export$a59f8d67326bd1cb;
            }
        },
        {
            key: "getTargetApp",
            value: function getTargetApp() {
                var _this$initOptions2;
                return (_this$initOptions2 = this.initOptions) === null || _this$initOptions2 === void 0 ? void 0 : _this$initOptions2.targetApp;
            }
        },
        {
            key: "getLayer",
            value: function getLayer(/** The name of the layer */ layerName) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                try {
                    this.assertInitialized(this.statsigClient);
                    var _options$fireLayerExp = options.fireLayerExposure, fireLayerExposure = _options$fireLayerExp === void 0 ? true : _options$fireLayerExp;
                    return (0, $036f8c4b31c67236$export$936d0764594b6eb3).fromLayer(this.statsigClient.getLayer(layerName, {
                        disableExposureLog: !fireLayerExposure
                    }));
                } catch (error) {
                    // Log the first occurrence of the error
                    if (!this.hasGetLayerErrorOccurred) {
                        // eslint-disable-next-line no-console
                        console.warn({
                            msg: 'An error has occurred getting the layer. Only the first occurrence of this error is logged.',
                            layerName: layerName,
                            error: error
                        });
                        this.hasGetLayerErrorOccurred = true;
                    }
                    // Return a default value
                    return (0, $036f8c4b31c67236$export$936d0764594b6eb3).fromLayer((0, $iFR7a._makeLayer)(layerName, {
                        reason: 'Error'
                    }, null));
                }
            }
        },
        {
            key: "getLayerValue",
            value: function getLayerValue(layerName, parameterName, defaultValue) {
                var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var layer = this.getLayer(layerName, options);
                try {
                    var typeGuard = options.typeGuard;
                    return layer.get(parameterName, defaultValue, typeGuard);
                } catch (error) {
                    // Log the first occurrence of the error
                    if (!this.hasGetLayerValueErrorOccurred) {
                        // eslint-disable-next-line no-console
                        console.warn({
                            msg: 'An error has occurred getting the layer value. Only the first occurrence of this error is logged.',
                            layerName: layerName,
                            defaultValue: defaultValue,
                            options: options,
                            error: error
                        });
                        this.hasGetLayerValueErrorOccurred = true;
                    }
                    return defaultValue;
                }
            }
        }
    ]);
}();






var $322a7dc3529f9dc2$var$_FeatureGates;
/**
 * Access the FeatureGates object via the default export.
 * ```ts
 * import FeatureGates from '@atlaskit/feature-gate-js-client';
 * ```
 */ var $322a7dc3529f9dc2$var$FeatureGates = /*#__PURE__*/ function() {
    function FeatureGates() {
        (0, $ad05016a8a78b31b$export$2e2bcd8739ae039)(this, FeatureGates);
    }
    return (0, $7ee2b561172d79b0$export$2e2bcd8739ae039)(FeatureGates, null, [
        {
            key: "isGateExists",
            value: function isGateExists(gateName) {
                return this.client.isGateExist(gateName);
            }
        },
        {
            key: "isExperimentExists",
            value: function isExperimentExists(experimentName) {
                return this.client.isExperimentExist(experimentName);
            }
        }
    ]);
}();
$322a7dc3529f9dc2$var$_FeatureGates = $322a7dc3529f9dc2$var$FeatureGates;
(0, $5bc9a370f4de45ae$export$2e2bcd8739ae039)($322a7dc3529f9dc2$var$FeatureGates, "client", new (0, $19b38a6452791af6$export$1f2bb630327ac4b6)());
(0, $5bc9a370f4de45ae$export$2e2bcd8739ae039)($322a7dc3529f9dc2$var$FeatureGates, "hasCheckGateErrorOccurred", false);
(0, $5bc9a370f4de45ae$export$2e2bcd8739ae039)($322a7dc3529f9dc2$var$FeatureGates, "hasGetExperimentValueErrorOccurred", false);
(0, $5bc9a370f4de45ae$export$2e2bcd8739ae039)($322a7dc3529f9dc2$var$FeatureGates, "checkGate", function(gateName, options) {
    try {
        // Check if the CRITERION override mechanism is available
        if (typeof window !== 'undefined' && window.__CRITERION__ && typeof window.__CRITERION__.getFeatureFlagOverride === 'function') {
            // Attempt to retrieve an override value for the feature gate
            var overrideValue = window.__CRITERION__.getFeatureFlagOverride(gateName);
            // If an override value is found, return it immediately
            if (overrideValue !== undefined) return overrideValue;
        }
    } catch (error) {
        // Log the first occurrence of the error
        if (!$322a7dc3529f9dc2$var$_FeatureGates.hasCheckGateErrorOccurred) {
            // eslint-disable-next-line no-console
            console.warn({
                msg: 'An error has occurred checking the feature gate from criterion override. Only the first occurrence of this error is logged.',
                gateName: gateName,
                error: error
            });
            $322a7dc3529f9dc2$var$_FeatureGates.hasCheckGateErrorOccurred = true;
        }
    }
    // Proceed with the main logic if no override is found
    return $322a7dc3529f9dc2$var$_FeatureGates.client.checkGate(gateName, options);
});
(0, $5bc9a370f4de45ae$export$2e2bcd8739ae039)($322a7dc3529f9dc2$var$FeatureGates, "getExperimentValue", function(experimentName, parameterName, defaultValue, options) {
    try {
        // Check if the CRITERION override mechanism is available
        if (typeof window !== 'undefined' && window.__CRITERION__ && typeof window.__CRITERION__.getExperimentValueOverride === 'function') {
            var overrideValue = window.__CRITERION__.getExperimentValueOverride(experimentName, parameterName);
            if (overrideValue !== undefined && overrideValue !== null) return overrideValue;
        }
    } catch (error) {
        // Log the first occurrence of the error
        if (!$322a7dc3529f9dc2$var$_FeatureGates.hasGetExperimentValueErrorOccurred) {
            // eslint-disable-next-line no-console
            console.warn({
                msg: 'An error has occurred getting the experiment value from criterion override. Only the first occurrence of this error is logged.',
                experimentName: experimentName,
                defaultValue: defaultValue,
                options: options,
                error: error
            });
            $322a7dc3529f9dc2$var$_FeatureGates.hasGetExperimentValueErrorOccurred = true;
        }
        return defaultValue;
    }
    // Proceed with the main logic if no override is found
    return $322a7dc3529f9dc2$var$_FeatureGates.client.getExperimentValue(experimentName, parameterName, defaultValue, options);
});
(0, $5bc9a370f4de45ae$export$2e2bcd8739ae039)($322a7dc3529f9dc2$var$FeatureGates, "initializeCalled", $322a7dc3529f9dc2$var$_FeatureGates.client.initializeCalled.bind($322a7dc3529f9dc2$var$_FeatureGates.client));
(0, $5bc9a370f4de45ae$export$2e2bcd8739ae039)($322a7dc3529f9dc2$var$FeatureGates, "initializeCompleted", $322a7dc3529f9dc2$var$_FeatureGates.client.initializeCompleted.bind($322a7dc3529f9dc2$var$_FeatureGates.client));
(0, $5bc9a370f4de45ae$export$2e2bcd8739ae039)($322a7dc3529f9dc2$var$FeatureGates, "waitUntilInitializeCompleted", $322a7dc3529f9dc2$var$_FeatureGates.client.waitUntilInitializeCompleted.bind($322a7dc3529f9dc2$var$_FeatureGates.client));
(0, $5bc9a370f4de45ae$export$2e2bcd8739ae039)($322a7dc3529f9dc2$var$FeatureGates, "initialize", $322a7dc3529f9dc2$var$_FeatureGates.client.initialize.bind($322a7dc3529f9dc2$var$_FeatureGates.client));
(0, $5bc9a370f4de45ae$export$2e2bcd8739ae039)($322a7dc3529f9dc2$var$FeatureGates, "initializeWithProvider", $322a7dc3529f9dc2$var$_FeatureGates.client.initializeWithProvider.bind($322a7dc3529f9dc2$var$_FeatureGates.client));
(0, $5bc9a370f4de45ae$export$2e2bcd8739ae039)($322a7dc3529f9dc2$var$FeatureGates, "initializeFromValues", $322a7dc3529f9dc2$var$_FeatureGates.client.initializeFromValues.bind($322a7dc3529f9dc2$var$_FeatureGates.client));
(0, $5bc9a370f4de45ae$export$2e2bcd8739ae039)($322a7dc3529f9dc2$var$FeatureGates, "manuallyLogGateExposure", $322a7dc3529f9dc2$var$_FeatureGates.client.manuallyLogGateExposure.bind($322a7dc3529f9dc2$var$_FeatureGates.client));
(0, $5bc9a370f4de45ae$export$2e2bcd8739ae039)($322a7dc3529f9dc2$var$FeatureGates, "getExperiment", $322a7dc3529f9dc2$var$_FeatureGates.client.getExperiment.bind($322a7dc3529f9dc2$var$_FeatureGates.client));
(0, $5bc9a370f4de45ae$export$2e2bcd8739ae039)($322a7dc3529f9dc2$var$FeatureGates, "manuallyLogExperimentExposure", $322a7dc3529f9dc2$var$_FeatureGates.client.manuallyLogExperimentExposure.bind($322a7dc3529f9dc2$var$_FeatureGates.client));
(0, $5bc9a370f4de45ae$export$2e2bcd8739ae039)($322a7dc3529f9dc2$var$FeatureGates, "manuallyLogLayerExposure", $322a7dc3529f9dc2$var$_FeatureGates.client.manuallyLogLayerExposure.bind($322a7dc3529f9dc2$var$_FeatureGates.client));
(0, $5bc9a370f4de45ae$export$2e2bcd8739ae039)($322a7dc3529f9dc2$var$FeatureGates, "shutdownStatsig", $322a7dc3529f9dc2$var$_FeatureGates.client.shutdownStatsig.bind($322a7dc3529f9dc2$var$_FeatureGates.client));
(0, $5bc9a370f4de45ae$export$2e2bcd8739ae039)($322a7dc3529f9dc2$var$FeatureGates, "overrideGate", $322a7dc3529f9dc2$var$_FeatureGates.client.overrideGate.bind($322a7dc3529f9dc2$var$_FeatureGates.client));
(0, $5bc9a370f4de45ae$export$2e2bcd8739ae039)($322a7dc3529f9dc2$var$FeatureGates, "clearGateOverride", $322a7dc3529f9dc2$var$_FeatureGates.client.clearGateOverride.bind($322a7dc3529f9dc2$var$_FeatureGates.client));
(0, $5bc9a370f4de45ae$export$2e2bcd8739ae039)($322a7dc3529f9dc2$var$FeatureGates, "overrideConfig", $322a7dc3529f9dc2$var$_FeatureGates.client.overrideConfig.bind($322a7dc3529f9dc2$var$_FeatureGates.client));
(0, $5bc9a370f4de45ae$export$2e2bcd8739ae039)($322a7dc3529f9dc2$var$FeatureGates, "clearConfigOverride", $322a7dc3529f9dc2$var$_FeatureGates.client.clearConfigOverride.bind($322a7dc3529f9dc2$var$_FeatureGates.client));
(0, $5bc9a370f4de45ae$export$2e2bcd8739ae039)($322a7dc3529f9dc2$var$FeatureGates, "setOverrides", $322a7dc3529f9dc2$var$_FeatureGates.client.setOverrides.bind($322a7dc3529f9dc2$var$_FeatureGates.client));
(0, $5bc9a370f4de45ae$export$2e2bcd8739ae039)($322a7dc3529f9dc2$var$FeatureGates, "getOverrides", $322a7dc3529f9dc2$var$_FeatureGates.client.getOverrides.bind($322a7dc3529f9dc2$var$_FeatureGates.client));
(0, $5bc9a370f4de45ae$export$2e2bcd8739ae039)($322a7dc3529f9dc2$var$FeatureGates, "clearAllOverrides", $322a7dc3529f9dc2$var$_FeatureGates.client.clearAllOverrides.bind($322a7dc3529f9dc2$var$_FeatureGates.client));
(0, $5bc9a370f4de45ae$export$2e2bcd8739ae039)($322a7dc3529f9dc2$var$FeatureGates, "isCurrentUser", $322a7dc3529f9dc2$var$_FeatureGates.client.isCurrentUser.bind($322a7dc3529f9dc2$var$_FeatureGates.client));
(0, $5bc9a370f4de45ae$export$2e2bcd8739ae039)($322a7dc3529f9dc2$var$FeatureGates, "onGateUpdated", $322a7dc3529f9dc2$var$_FeatureGates.client.onGateUpdated.bind($322a7dc3529f9dc2$var$_FeatureGates.client));
(0, $5bc9a370f4de45ae$export$2e2bcd8739ae039)($322a7dc3529f9dc2$var$FeatureGates, "onExperimentValueUpdated", $322a7dc3529f9dc2$var$_FeatureGates.client.onExperimentValueUpdated.bind($322a7dc3529f9dc2$var$_FeatureGates.client));
(0, $5bc9a370f4de45ae$export$2e2bcd8739ae039)($322a7dc3529f9dc2$var$FeatureGates, "onAnyUpdated", $322a7dc3529f9dc2$var$_FeatureGates.client.onAnyUpdated.bind($322a7dc3529f9dc2$var$_FeatureGates.client));
(0, $5bc9a370f4de45ae$export$2e2bcd8739ae039)($322a7dc3529f9dc2$var$FeatureGates, "updateUser", $322a7dc3529f9dc2$var$_FeatureGates.client.updateUser.bind($322a7dc3529f9dc2$var$_FeatureGates.client));
(0, $5bc9a370f4de45ae$export$2e2bcd8739ae039)($322a7dc3529f9dc2$var$FeatureGates, "updateUserWithProvider", $322a7dc3529f9dc2$var$_FeatureGates.client.updateUserWithProvider.bind($322a7dc3529f9dc2$var$_FeatureGates.client));
(0, $5bc9a370f4de45ae$export$2e2bcd8739ae039)($322a7dc3529f9dc2$var$FeatureGates, "updateUserWithValues", $322a7dc3529f9dc2$var$_FeatureGates.client.updateUserWithValues.bind($322a7dc3529f9dc2$var$_FeatureGates.client));
(0, $5bc9a370f4de45ae$export$2e2bcd8739ae039)($322a7dc3529f9dc2$var$FeatureGates, "getPackageVersion", $322a7dc3529f9dc2$var$_FeatureGates.client.getPackageVersion.bind($322a7dc3529f9dc2$var$_FeatureGates.client));
(0, $5bc9a370f4de45ae$export$2e2bcd8739ae039)($322a7dc3529f9dc2$var$FeatureGates, "getTargetApp", $322a7dc3529f9dc2$var$_FeatureGates.client.getTargetApp.bind($322a7dc3529f9dc2$var$_FeatureGates.client));
(0, $5bc9a370f4de45ae$export$2e2bcd8739ae039)($322a7dc3529f9dc2$var$FeatureGates, "getLayer", $322a7dc3529f9dc2$var$_FeatureGates.client.getLayer.bind($322a7dc3529f9dc2$var$_FeatureGates.client));
(0, $5bc9a370f4de45ae$export$2e2bcd8739ae039)($322a7dc3529f9dc2$var$FeatureGates, "getLayerValue", $322a7dc3529f9dc2$var$_FeatureGates.client.getLayerValue.bind($322a7dc3529f9dc2$var$_FeatureGates.client));
var $322a7dc3529f9dc2$var$boundFGJS = $322a7dc3529f9dc2$var$FeatureGates;
// This makes it possible to get a reference to the FeatureGates client at runtime.
// This is important for overriding values in Cypress tests, as there needs to be a
// way to get the exact instance for a window in order to mock some of its methods.
if (typeof window !== 'undefined') {
    if (window.__FEATUREGATES_JS__ === undefined) window.__FEATUREGATES_JS__ = $322a7dc3529f9dc2$var$FeatureGates;
    else {
        var $322a7dc3529f9dc2$var$_boundFGJS, $322a7dc3529f9dc2$var$_boundFGJS$getPackage;
        $322a7dc3529f9dc2$var$boundFGJS = window.__FEATUREGATES_JS__;
        var $322a7dc3529f9dc2$var$boundVersion = (($322a7dc3529f9dc2$var$_boundFGJS = $322a7dc3529f9dc2$var$boundFGJS) === null || $322a7dc3529f9dc2$var$_boundFGJS === void 0 || ($322a7dc3529f9dc2$var$_boundFGJS$getPackage = $322a7dc3529f9dc2$var$_boundFGJS.getPackageVersion) === null || $322a7dc3529f9dc2$var$_boundFGJS$getPackage === void 0 ? void 0 : $322a7dc3529f9dc2$var$_boundFGJS$getPackage.call($322a7dc3529f9dc2$var$_boundFGJS)) || '4.10.0 or earlier';
        if ($322a7dc3529f9dc2$var$boundVersion !== (0, $daebafeb0bbc8260$export$a59f8d67326bd1cb)) {
            var $322a7dc3529f9dc2$var$message = "Multiple versions of FeatureGateClients found on the current page.\n      The currently bound version is ".concat($322a7dc3529f9dc2$var$boundVersion, " when module version ").concat((0, $daebafeb0bbc8260$export$a59f8d67326bd1cb), " was loading.");
            // eslint-disable-next-line no-console
            console.warn($322a7dc3529f9dc2$var$message);
        }
    }
}
var /**
 * @property {FeatureGates} FeatureGate default export
 */ $322a7dc3529f9dc2$export$2e2bcd8739ae039 = $322a7dc3529f9dc2$var$boundFGJS;


var $3f265738c511e15f$var$_process, $3f265738c511e15f$var$_process2;
// We can't rely on NODE_ENV === 'test' if its value is already configured by the consumer to some other value, so better to use JEST_WORKER_ID
// https://jestjs.io/docs/environment-variables#jest_worker_id
var $3f265738c511e15f$var$TESTS_MODE = (globalThis === null || globalThis === void 0 || ($3f265738c511e15f$var$_process = globalThis.process) === null || $3f265738c511e15f$var$_process === void 0 || ($3f265738c511e15f$var$_process = $3f265738c511e15f$var$_process.env) === null || $3f265738c511e15f$var$_process === void 0 ? void 0 : $3f265738c511e15f$var$_process.JEST_WORKER_ID) !== undefined;
var $3f265738c511e15f$var$DEBUG_MODE = !$3f265738c511e15f$var$TESTS_MODE && (globalThis === null || globalThis === void 0 || ($3f265738c511e15f$var$_process2 = globalThis.process) === null || $3f265738c511e15f$var$_process2 === void 0 || ($3f265738c511e15f$var$_process2 = $3f265738c511e15f$var$_process2.env) === null || $3f265738c511e15f$var$_process2 === void 0 ? void 0 : $3f265738c511e15f$var$_process2.NODE_ENV) !== 'production';
var $3f265738c511e15f$export$1c9f709888824e05 = function debug() {
    var _console;
    if (!$3f265738c511e15f$var$DEBUG_MODE) return;
    // eslint-disable-next-line no-console
    (_console = console).debug.apply(_console, arguments);
};



var $3ZMUU = parcelRequire("3ZMUU");
var $ffd4f0a40f29f687$var$pkgName = '@atlaskit/platform-feature-flags';
var $ffd4f0a40f29f687$export$7e41b1b2bdee3f98 = '__PLATFORM_FEATURE_FLAGS__';
var $ffd4f0a40f29f687$var$hasProcessEnv = typeof $3ZMUU !== 'undefined' && typeof $3ZMUU.env !== 'undefined';
// FF global overrides can be configured by test runners or Storybook
var $ffd4f0a40f29f687$var$ENV_ENABLE_PLATFORM_FF = $ffd4f0a40f29f687$var$hasProcessEnv ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;
// STORYBOOK_ENABLE_PLATFORM_FF is included as storybook only allows env vars prefixed with STORYBOOK
// https://github.com/storybookjs/storybook/issues/12270
var $ffd4f0a40f29f687$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF = $ffd4f0a40f29f687$var$hasProcessEnv ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;
var $ffd4f0a40f29f687$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE = $ffd4f0a40f29f687$var$ENV_ENABLE_PLATFORM_FF || $ffd4f0a40f29f687$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF;
var $ffd4f0a40f29f687$var$DEFAULT_PFF_GLOBAL = {
    booleanResolver: undefined
};
var $ffd4f0a40f29f687$var$globalVar = typeof window !== 'undefined' ? window : globalThis;
$ffd4f0a40f29f687$var$globalVar[$ffd4f0a40f29f687$export$7e41b1b2bdee3f98] = $ffd4f0a40f29f687$var$globalVar[$ffd4f0a40f29f687$export$7e41b1b2bdee3f98] || $ffd4f0a40f29f687$var$DEFAULT_PFF_GLOBAL;
function $ffd4f0a40f29f687$export$f2b591175b3e424c(resolver) {
    $ffd4f0a40f29f687$var$globalVar[$ffd4f0a40f29f687$export$7e41b1b2bdee3f98].booleanResolver = resolver;
}
function $ffd4f0a40f29f687$export$6333b6aff9fc6275(flagKey) {
    if ($ffd4f0a40f29f687$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE) {
        (0, $3f265738c511e15f$export$1c9f709888824e05)('[%s]: The feature flags were enabled while running tests. The flag "%s" will be always enabled.', $ffd4f0a40f29f687$var$pkgName, flagKey);
        return true;
    }
    try {
        var _globalVar$PFF_GLOBAL, _globalVar$PFF_GLOBAL2, _globalVar$PFF_GLOBAL3;
        // booleanResolver will be empty for products like Trello, Elevate, Recruit etc.
        // Currently only Confluence, Jira and Bitbucket has set it.
        if (((_globalVar$PFF_GLOBAL = $ffd4f0a40f29f687$var$globalVar[$ffd4f0a40f29f687$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL === void 0 ? void 0 : _globalVar$PFF_GLOBAL.booleanResolver) === undefined || ((_globalVar$PFF_GLOBAL2 = $ffd4f0a40f29f687$var$globalVar[$ffd4f0a40f29f687$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL2 === void 0 ? void 0 : _globalVar$PFF_GLOBAL2.booleanResolver) === null) // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
        return (0, $322a7dc3529f9dc2$export$2e2bcd8739ae039).checkGate(flagKey);
        var result = (_globalVar$PFF_GLOBAL3 = $ffd4f0a40f29f687$var$globalVar[$ffd4f0a40f29f687$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL3 === void 0 ? void 0 : _globalVar$PFF_GLOBAL3.booleanResolver(flagKey);
        if (typeof result !== 'boolean') {
            // eslint-disable-next-line no-console
            console.warn("".concat(flagKey, " resolved to a non-boolean value, returning false for safety"));
            return false;
        }
        return result;
    } catch (e) {
        return false;
    }
}


function $851f0a53539df6b2$export$ba05d765b8392e5e(flagResolver) {
    (0, $ffd4f0a40f29f687$export$f2b591175b3e424c)(flagResolver);
}
function $851f0a53539df6b2$export$470e5c2be1411c89(name) {
    return (0, $ffd4f0a40f29f687$export$6333b6aff9fc6275)(name);
}
function $851f0a53539df6b2$export$b40ec24ac8275656(name) {
    return (0, $ffd4f0a40f29f687$export$6333b6aff9fc6275)(name);
}


function $7f6aff2f61af179e$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $7f6aff2f61af179e$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $7f6aff2f61af179e$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $5bc9a370f4de45ae$export$2e2bcd8739ae039)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $7f6aff2f61af179e$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $7f6aff2f61af179e$var$gridSize = 8;
var $7f6aff2f61af179e$var$HAS_DISABLED_BACKGROUND = [
    'default',
    'primary',
    'danger',
    'warning'
];
var $7f6aff2f61af179e$var$heights = {
    default: "".concat(32 / 14, "em"),
    // 32px
    compact: "".concat(24 / 14, "em"),
    none: 'auto'
};
var $7f6aff2f61af179e$var$lineHeights = {
    default: $7f6aff2f61af179e$var$heights.default,
    compact: $7f6aff2f61af179e$var$heights.compact,
    none: 'inherit'
};
var $7f6aff2f61af179e$var$padding = {
    // 10px gutter
    default: "0 ".concat($7f6aff2f61af179e$var$gridSize + $7f6aff2f61af179e$var$gridSize / 4, "px"),
    compact: "0 ".concat($7f6aff2f61af179e$var$gridSize + $7f6aff2f61af179e$var$gridSize / 4, "px"),
    none: '0'
};
var $7f6aff2f61af179e$var$singleIconPadding = {
    // 2px gutter
    compact: "0 ".concat($7f6aff2f61af179e$var$gridSize / 4, "px"),
    default: "0 ".concat($7f6aff2f61af179e$var$gridSize / 4, "px"),
    none: '0'
};
var $7f6aff2f61af179e$var$verticalAlign = {
    default: 'middle',
    compact: 'middle',
    none: 'baseline'
};
var $7f6aff2f61af179e$var$defaultAfterStyles = {
    borderRadius: 'inherit',
    inset: "var(--ds-space-0, 0px)",
    borderStyle: 'solid',
    borderWidth: "var(--ds-border-width, 1px)",
    pointerEvents: 'none',
    position: 'absolute'
};
var $7f6aff2f61af179e$var$defaultStyles = {
    background: "var(--ds-background-neutral-subtle, #00000000)",
    color: "var(--ds-text, #292A2E)",
    '&::after': $7f6aff2f61af179e$var$_objectSpread($7f6aff2f61af179e$var$_objectSpread({}, $7f6aff2f61af179e$var$defaultAfterStyles), {}, {
        content: '""',
        borderColor: "var(--ds-border, #0B120E24)"
    }),
    '&:hover': {
        background: "var(--ds-background-neutral-hovered, #0B120E24)"
    },
    '&:active': {
        background: "var(--ds-background-neutral-pressed, #080F214A)"
    },
    '&[data-has-overlay="true"]:not([disabled]):hover': {
        background: "var(--ds-background-neutral-subtle, #00000000)"
    },
    '&:disabled[disabled]': {
        background: "var(--ds-background-neutral-subtle, #00000000)"
    },
    '&:disabled[disabled]:hover': {
        background: "var(--ds-background-neutral-subtle, #00000000)"
    },
    '&:disabled[disabled]:active': {
        background: "var(--ds-background-neutral-subtle, #00000000)"
    }
};
var $7f6aff2f61af179e$var$primaryStyles = {
    background: "var(--ds-background-brand-bold, #1868DB)",
    color: "var(--ds-text-inverse, #FFFFFF)",
    '&:hover': {
        background: "var(--ds-background-brand-bold-hovered, #1558BC)"
    },
    '&:active': {
        background: "var(--ds-background-brand-bold-pressed, #144794)"
    },
    '&[data-has-overlay="true"]:not([disabled]):hover': {
        background: "var(--ds-background-brand-bold, #1868DB)"
    }
};
var $7f6aff2f61af179e$var$linkStyles = {
    background: 'transparent',
    color: "var(--ds-link, #1868DB)",
    '&:hover': {
        color: "var(--ds-link, #1868DB)",
        textDecoration: 'underline'
    },
    '&:active': {
        color: "var(--ds-link-pressed, #1558BC)",
        textDecoration: 'underline'
    }
};
var $7f6aff2f61af179e$var$subtleStyles = {
    background: 'transparent',
    color: "var(--ds-text-subtle, #505258)",
    '&:hover': {
        background: "var(--ds-background-neutral-subtle-hovered, #0515240F)"
    },
    '&:active': {
        background: "var(--ds-background-neutral-subtle-pressed, #0B120E24)"
    },
    '&[data-has-overlay="true"]:not([disabled]):hover': {
        background: 'transparent'
    }
};
var $7f6aff2f61af179e$var$subtleLinkStyles = {
    background: 'transparent',
    color: "var(--ds-text-subtle, #505258)",
    '&:hover': {
        background: 'transparent',
        color: "var(--ds-text-subtle, #505258)",
        textDecoration: 'underline'
    },
    '&:active': {
        background: 'transparent',
        color: "var(--ds-text, #292A2E)",
        textDecoration: 'underline'
    }
};
var $7f6aff2f61af179e$var$warningStyles = {
    background: "var(--ds-background-warning-bold, #FBC828)",
    color: "var(--ds-text-warning-inverse, #292A2E)",
    '&:hover': {
        background: "var(--ds-background-warning-bold-hovered, #FCA700)"
    },
    '&:active': {
        background: "var(--ds-background-warning-bold-pressed, #F68909)"
    },
    '&[data-has-overlay="true"]:not([disabled]):hover': {
        background: "var(--ds-background-warning-bold, #FBC828)"
    }
};
var $7f6aff2f61af179e$var$dangerStyles = {
    background: "var(--ds-background-danger-bold, #C9372C)",
    color: "var(--ds-text-inverse, #FFFFFF)",
    '&:hover': {
        background: "var(--ds-background-danger-bold-hovered, #AE2E24)"
    },
    '&:active': {
        background: "var(--ds-background-danger-bold-pressed, #872821)"
    },
    '&[data-has-overlay="true"]:not([disabled]):hover': {
        background: "var(--ds-background-danger-bold, #C9372C)"
    }
};
var $7f6aff2f61af179e$var$selectedStyles = {
    background: "var(--ds-background-selected, #E9F2FE)",
    color: "var(--ds-text-selected, #1868DB)",
    '&:not([disabled])::after': $7f6aff2f61af179e$var$_objectSpread($7f6aff2f61af179e$var$_objectSpread({}, $7f6aff2f61af179e$var$defaultAfterStyles), {}, {
        content: '""',
        borderColor: "var(--ds-border-selected, #1868DB)"
    })
};
var $7f6aff2f61af179e$var$hasOverlayStyles = {
    '&[data-has-overlay="true"]': {
        cursor: 'default',
        textDecoration: 'none'
    }
};
function $7f6aff2f61af179e$export$955358618f994a11(_ref) {
    var appearance = _ref.appearance, spacing = _ref.spacing, isSelected = _ref.isSelected, shouldFitContainer = _ref.shouldFitContainer, isOnlySingleIcon = _ref.isOnlySingleIcon;
    return $7f6aff2f61af179e$var$_objectSpread($7f6aff2f61af179e$var$_objectSpread({
        // 0px margin added to css-reset
        alignItems: 'baseline',
        borderWidth: 0,
        borderRadius: (0, $851f0a53539df6b2$export$b40ec24ac8275656)('platform-dst-shape-theme-default') ? "var(--ds-radius-medium, 6px)" : "var(--ds-radius-small, 3px)",
        boxSizing: 'border-box',
        display: 'inline-flex',
        fontSize: 'inherit',
        fontStyle: 'normal',
        // Chrome recently changed button so that they use 'arial' as the font family
        fontFamily: 'inherit',
        fontWeight: "var(--ds-font-weight-medium, 500)",
        // margin for button has been applied to css reset
        maxWidth: '100%',
        // Needed to position overlay
        position: 'relative',
        textAlign: 'center',
        textDecoration: 'none',
        transition: (0, $851f0a53539df6b2$export$b40ec24ac8275656)('platform-dst-motion-uplift-button') ? "var(--ds-button-hovered, background-color 150ms cubic-bezier(0.4, 1, 0.6, 1))".concat(", box-shadow 0.15s cubic-bezier(0.47, 0.03, 0.49, 1.38)") : 'background 0.1s ease-out, box-shadow 0.15s cubic-bezier(0.47, 0.03, 0.49, 1.38)',
        whiteSpace: 'nowrap',
        cursor: 'pointer',
        height: $7f6aff2f61af179e$var$heights[spacing],
        lineHeight: $7f6aff2f61af179e$var$lineHeights[spacing],
        padding: isOnlySingleIcon ? $7f6aff2f61af179e$var$singleIconPadding[spacing] : $7f6aff2f61af179e$var$padding[spacing],
        verticalAlign: $7f6aff2f61af179e$var$verticalAlign[spacing],
        width: shouldFitContainer ? '100%' : 'auto',
        // justifyContent required for shouldFitContainer buttons with an icon inside
        justifyContent: 'center'
    }, isSelected ? $7f6aff2f61af179e$var$selectedStyles : $7f6aff2f61af179e$var$_objectSpread($7f6aff2f61af179e$var$_objectSpread($7f6aff2f61af179e$var$_objectSpread($7f6aff2f61af179e$var$_objectSpread($7f6aff2f61af179e$var$_objectSpread($7f6aff2f61af179e$var$_objectSpread($7f6aff2f61af179e$var$_objectSpread($7f6aff2f61af179e$var$_objectSpread({}, appearance === 'default' && $7f6aff2f61af179e$var$defaultStyles), appearance === 'primary' && $7f6aff2f61af179e$var$primaryStyles), appearance === 'link' && $7f6aff2f61af179e$var$linkStyles), appearance === 'subtle' && $7f6aff2f61af179e$var$subtleStyles), appearance === 'subtle-link' && $7f6aff2f61af179e$var$subtleLinkStyles), appearance === 'warning' && $7f6aff2f61af179e$var$warningStyles), appearance === 'danger' && $7f6aff2f61af179e$var$dangerStyles), {}, {
        '&[disabled]': {
            color: "var(--ds-text-disabled, #080F214A)",
            backgroundColor: $7f6aff2f61af179e$var$HAS_DISABLED_BACKGROUND.includes(appearance) ? "var(--ds-background-disabled, #0515240F)" : 'transparent',
            cursor: 'not-allowed',
            textDecoration: 'none',
            '&:hovered': {
                backgroundColor: $7f6aff2f61af179e$var$HAS_DISABLED_BACKGROUND.includes(appearance) ? "var(--ds-background-disabled, #0515240F)" : 'transparent'
            },
            '&:active': {
                backgroundColor: $7f6aff2f61af179e$var$HAS_DISABLED_BACKGROUND.includes(appearance) ? "var(--ds-background-disabled, #0515240F)" : 'transparent'
            }
        }
    }, $7f6aff2f61af179e$var$hasOverlayStyles)), {}, {
        '&::-moz-focus-inner': {
            border: 0,
            margin: 0,
            padding: 0
        }
    });
}



function $5284b7a13db2c09f$export$2e2bcd8739ae039(_ref) {
    var children = _ref.children, iconBefore = _ref.iconBefore, iconAfter = _ref.iconAfter;
    if ((0, $8d5406764a72913d$export$20bbd2efb0d734c4)(children)) return true;
    if (children) return false;
    if (iconBefore && !iconAfter) return true;
    if (!iconBefore && iconAfter) return true;
    return false;
}


var $57aa7996868f4b18$var$_excluded = [
    "appearance",
    "children",
    "iconBefore",
    "iconAfter",
    "isSelected",
    "onMouseDown",
    "onMouseUp",
    "shouldFitContainer",
    "spacing"
];
var $57aa7996868f4b18$var$isFirefox = typeof navigator !== 'undefined' && navigator.userAgent.toLowerCase().indexOf('firefox') > -1;
/**
 * __Button__
 *
 * @deprecated Legacy buttons are deprecated and will be removed from `atlaskit/button` in an upcoming major release. Please use the new Button components from `@atlaskit/button/new`
 *
 * Please refer to the [migration guide](https://atlassian.design/components/button/button-legacy/migration-guide) for further details.
 *
 * A button triggers an event or action. They let users know what will happen next.
 *
 * - [Examples](https://atlassian.design/components/button/button-legacy/examples)
 * - [Code](https://atlassian.design/components/button/button-legacy/code)
 * - [Usage](https://atlassian.design/components/button/button-legacy/usage)
 */ var $57aa7996868f4b18$var$Button = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).forwardRef(function Button(_ref, ref) {
    var _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'default' : _ref$appearance, children = _ref.children, iconBefore = _ref.iconBefore, iconAfter = _ref.iconAfter, _ref$isSelected = _ref.isSelected, isSelected = _ref$isSelected === void 0 ? false : _ref$isSelected, _ref$onMouseDown = _ref.onMouseDown, providedOnMouseDown = _ref$onMouseDown === void 0 ? (0, $adcefb868cf2fc9d$export$2e2bcd8739ae039) : _ref$onMouseDown, _ref$onMouseUp = _ref.onMouseUp, providedOnMouseUp = _ref$onMouseUp === void 0 ? (0, $adcefb868cf2fc9d$export$2e2bcd8739ae039) : _ref$onMouseUp, _ref$shouldFitContain = _ref.shouldFitContainer, shouldFitContainer = _ref$shouldFitContain === void 0 ? false : _ref$shouldFitContain, _ref$spacing = _ref.spacing, spacing = _ref$spacing === void 0 ? 'default' : _ref$spacing, rest = (0, $b45e4aa52a06dd77$export$2e2bcd8739ae039)(_ref, $57aa7996868f4b18$var$_excluded);
    var isOnlySingleIcon = (0, $5284b7a13db2c09f$export$2e2bcd8739ae039)({
        children: children,
        iconBefore: iconBefore,
        iconAfter: iconAfter
    });
    var _useState = (0, $5FkrB.useState)(false), _useState2 = (0, $958636c847d8b316$export$2e2bcd8739ae039)(_useState, 2), isActive = _useState2[0], setIsActive = _useState2[1];
    // Wrap onMouseDown / onMouseUp to manually trigger active state
    // in Firefox
    var onMouseDown = (0, $5FkrB.useCallback)(function(event) {
        providedOnMouseDown(event);
        if ($57aa7996868f4b18$var$isFirefox) setIsActive(true);
    }, [
        providedOnMouseDown,
        setIsActive
    ]);
    var onMouseUp = (0, $5FkrB.useCallback)(function(event) {
        providedOnMouseUp(event);
        if ($57aa7996868f4b18$var$isFirefox) setIsActive(false);
    }, [
        providedOnMouseUp,
        setIsActive
    ]);
    var buttonCss = (0, $5FkrB.useMemo)(function() {
        return (0, $7f6aff2f61af179e$export$955358618f994a11)({
            appearance: appearance,
            spacing: spacing,
            isSelected: isSelected,
            shouldFitContainer: shouldFitContainer,
            isOnlySingleIcon: isOnlySingleIcon
        });
    }, [
        appearance,
        spacing,
        isSelected,
        shouldFitContainer,
        isOnlySingleIcon
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $01cec818d83ffd40$export$2e2bcd8739ae039), (0, $39cd338b0da6756c$export$2e2bcd8739ae039)({}, rest, {
        ref: ref,
        appearance: appearance,
        buttonCss: buttonCss,
        children: children,
        "data-firefox-is-active": isActive ? true : undefined,
        iconAfter: iconAfter,
        iconBefore: iconBefore,
        isSelected: isSelected,
        onMouseDown: onMouseDown,
        onMouseUp: onMouseUp,
        spacing: spacing
    }));
}));
// Tools including enzyme rely on components having a display name
$57aa7996868f4b18$var$Button.displayName = 'Button';
var $57aa7996868f4b18$export$2e2bcd8739ae039 = $57aa7996868f4b18$var$Button;


var $e4fc98ef5a8fd645$exports = {};
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::fbc9eb298cfdac722b50cf5246108693>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty($e4fc98ef5a8fd645$exports, "__esModule", {
    value: true
});
$e4fc98ef5a8fd645$exports.default = void 0;

var $e4fc98ef5a8fd645$var$_react = $e4fc98ef5a8fd645$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $e4fc98ef5a8fd645$var$_baseNew = $e4fc98ef5a8fd645$var$_interopRequireDefault((parcelRequire("iT3Yw")));
function $e4fc98ef5a8fd645$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ChevronRight".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Do not use 16px chevrons within buttons, icon buttons, or dropdowns to maintain visual cohesion with ADS which uses 12px chevrons.
Known uses: Next page of pagination results, collapsed tree item, expand tree item
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $e4fc98ef5a8fd645$var$ChevronRightIcon = (props)=>/*#__PURE__*/ $e4fc98ef5a8fd645$var$_react.default.createElement($e4fc98ef5a8fd645$var$_baseNew.default, Object.assign({
        name: "ChevronRightIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="m6.03 1.47 6 6a.75.75 0 0 1 .052 1.004l-.052.056-6 6-1.06-1.06L10.44 8 4.97 2.53z"/>`
    }, props));
$e4fc98ef5a8fd645$var$ChevronRightIcon.displayName = 'ChevronRightIcon';
var $e4fc98ef5a8fd645$var$_default = $e4fc98ef5a8fd645$exports.default = $e4fc98ef5a8fd645$var$ChevronRightIcon;


var $1adac64b26b6e361$exports = {};
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e4a75f30383a815136b76433b9d7ec6c>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty($1adac64b26b6e361$exports, "__esModule", {
    value: true
});
$1adac64b26b6e361$exports.default = void 0;

var $1adac64b26b6e361$var$_react = $1adac64b26b6e361$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $1adac64b26b6e361$var$_baseNew = $1adac64b26b6e361$var$_interopRequireDefault((parcelRequire("iT3Yw")));
function $1adac64b26b6e361$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Globe".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: public link in Confluence share dialog, global rules in Automation.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $1adac64b26b6e361$var$GlobeIcon = (props)=>/*#__PURE__*/ $1adac64b26b6e361$var$_react.default.createElement($1adac64b26b6e361$var$_baseNew.default, Object.assign({
        name: "GlobeIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1.543 7.25h2.722c.073-1.784.403-3.413.92-4.663q.123-.294.26-.566A6.5 6.5 0 0 0 1.544 7.25M8 0a8 8 0 1 0 0 16A8 8 0 0 0 8 0m0 1.5c-.151 0-.364.07-.632.344-.27.276-.547.714-.796 1.316-.432 1.043-.733 2.47-.805 4.09h4.466c-.072-1.62-.373-3.047-.805-4.09-.249-.602-.526-1.04-.796-1.316C8.364 1.571 8.15 1.5 8 1.5m3.735 5.75c-.073-1.784-.403-3.413-.92-4.663a8 8 0 0 0-.26-.566 6.5 6.5 0 0 1 3.902 5.229zm-1.502 1.5H5.767c.072 1.62.373 3.047.805 4.09.249.602.526 1.04.796 1.316.268.273.481.344.632.344s.364-.07.632-.344c.27-.276.547-.714.796-1.316.432-1.043.733-2.47.805-4.09m.321 5.229q.14-.272.26-.566c.518-1.25.848-2.879.92-4.663h2.723a6.5 6.5 0 0 1-3.903 5.229m-5.108 0q-.14-.272-.26-.566c-.518-1.25-.848-2.879-.92-4.663H1.542a6.5 6.5 0 0 0 3.903 5.229" clip-rule="evenodd"/>`
    }, props));
$1adac64b26b6e361$var$GlobeIcon.displayName = 'GlobeIcon';
var $1adac64b26b6e361$var$_default = $1adac64b26b6e361$exports.default = $1adac64b26b6e361$var$GlobeIcon;


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3ee8292a79b161f2b692708d346bda7d>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");
/* icon-wrapper.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $5FkrB = parcelRequire("5FkrB");




var $5FkrB = parcelRequire("5FkrB");

var $aa49e4c0deeeb8d8$export$4ef52930e33717cd = 'data-theme';
var $aa49e4c0deeeb8d8$export$cb374d25ded7f6ab = 'data-subtree-theme';
var $aa49e4c0deeeb8d8$export$a00eac3f8684bcd0 = 'data-color-mode';
var $aa49e4c0deeeb8d8$export$2112803007239c61 = 'data-contrast-mode';
var $aa49e4c0deeeb8d8$export$352e418ed5b6193a = 'data-custom-theme';
var $aa49e4c0deeeb8d8$export$6f0c6fb8c80fcc92 = 'ds';
var $aa49e4c0deeeb8d8$export$4d0c7bbf80185957 = [
    'opacity',
    'font',
    'space',
    'border',
    'radius'
];
var $aa49e4c0deeeb8d8$export$dddac1532e822863 = "--".concat($aa49e4c0deeeb8d8$export$6f0c6fb8c80fcc92, "-token-not-found");
var $aa49e4c0deeeb8d8$export$9d7b58831ae93caa = "--".concat($aa49e4c0deeeb8d8$export$6f0c6fb8c80fcc92, "-elevation-surface-current");


/**
 * Theme modes: The general purpose of a theme.
 * This attr is used to apply the appropriate system-preference option
 * It may also be used as a selector for mode-specific overrides such as light/dark images.
 * The idea is there may exist many color themes, but every theme must either fit into light or dark.
 */ var $5bd79894282b6708$export$83993de8eb66733 = [
    'light',
    'dark',
    'auto'
];



var $95f1305668475586$export$4a14e169b1de4ee7 = function isColorMode(modeId) {
    return [
        'light',
        'dark',
        'auto'
    ].includes(modeId);
};


/**
 * Theme ids: The value that will be mounted to the DOM as a data attr
 * For example: `data-theme="light:light dark:dark spacing:spacing"
 *
 * These ids must be kebab case
 */ var $cb032f84287f1116$export$7d43e72a58e3283f = [
    'light-increased-contrast',
    'light',
    'light-future',
    'dark',
    'dark-future',
    'dark-increased-contrast',
    'spacing',
    'shape',
    'typography',
    'motion'
];


var $8774fb872c747811$export$ea35b8958c39dd07 = function isThemeIds(themeId) {
    return (0, $cb032f84287f1116$export$7d43e72a58e3283f).find(function(id) {
        return id === themeId;
    }) !== undefined;
};


var $3fbb2711e05ac56f$var$themeKinds = [
    'light',
    'dark',
    'spacing',
    'typography',
    'shape',
    'motion'
];
var $3fbb2711e05ac56f$export$958fa026be3a263e = function isThemeKind(themeKind) {
    return $3fbb2711e05ac56f$var$themeKinds.find(function(kind) {
        return kind === themeKind;
    }) !== undefined;
};


var $8ddd5b476f6a4eb4$var$customThemeOptions = 'UNSAFE_themeOptions';
var $8ddd5b476f6a4eb4$export$f19b488f7c0547ee = function themeStringToObject(themeState) {
    return themeState.split(' ')// @ts-ignore - TS1501 TypeScript 5.9.2 upgrade
    .map(function(theme) {
        return theme.split(/:([^]*)/);
    }).reduce(function(themeObject, _ref) {
        var _ref2 = (0, $958636c847d8b316$export$2e2bcd8739ae039)(_ref, 2), kind = _ref2[0], id = _ref2[1];
        if (kind === 'colorMode' && (0, $95f1305668475586$export$4a14e169b1de4ee7)(id)) themeObject[kind] = id;
        if ((0, $3fbb2711e05ac56f$export$958fa026be3a263e)(kind) && (0, $8774fb872c747811$export$ea35b8958c39dd07)(id)) // @ts-expect-error FIXME - this is a valid ts error
        themeObject[kind] = id;
        if (kind === $8ddd5b476f6a4eb4$var$customThemeOptions) try {
            themeObject[$8ddd5b476f6a4eb4$var$customThemeOptions] = JSON.parse(id);
        } catch (_unused) {
            new Error('Invalid custom theme string');
        }
        return themeObject;
    }, {});
};


function $fdb8de170d378fe1$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $fdb8de170d378fe1$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $fdb8de170d378fe1$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $5bc9a370f4de45ae$export$2e2bcd8739ae039)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $fdb8de170d378fe1$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $fdb8de170d378fe1$var$isThemeColorMode = function isThemeColorMode(colorMode) {
    return (0, $5bd79894282b6708$export$83993de8eb66733).find(function(mode) {
        return mode === colorMode;
    }) !== undefined;
};
var $fdb8de170d378fe1$var$getGlobalTheme = function getGlobalTheme() {
    if (typeof document === 'undefined') return {};
    var element = document.documentElement;
    var colorMode = element.getAttribute((0, $aa49e4c0deeeb8d8$export$a00eac3f8684bcd0)) || '';
    var theme = element.getAttribute((0, $aa49e4c0deeeb8d8$export$4ef52930e33717cd)) || '';
    return $fdb8de170d378fe1$var$_objectSpread($fdb8de170d378fe1$var$_objectSpread({}, (0, $8ddd5b476f6a4eb4$export$f19b488f7c0547ee)(theme)), $fdb8de170d378fe1$var$isThemeColorMode(colorMode) && {
        colorMode: colorMode
    });
};
var $fdb8de170d378fe1$export$2e2bcd8739ae039 = $fdb8de170d378fe1$var$getGlobalTheme;







/**
 * A MutationObserver which watches the `<html>` element for changes to the theme.
 *
 * In React, use the {@link useThemeObserver `useThemeObserver`} hook instead.
 *
 * @param {function} callback - A callback function which fires when the theme changes.
 *
 * @example
 * ```
 * const observer = new ThemeMutationObserver((theme) => {});
 * observer.observe();
 * ```
 */ var $22d676c673d4e30f$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function ThemeMutationObserver(callback) {
        (0, $ad05016a8a78b31b$export$2e2bcd8739ae039)(this, ThemeMutationObserver);
        (0, $5bc9a370f4de45ae$export$2e2bcd8739ae039)(this, "legacyObserver", null);
        this.callback = callback;
        ThemeMutationObserver.callbacks.add(callback);
    }
    return (0, $7ee2b561172d79b0$export$2e2bcd8739ae039)(ThemeMutationObserver, [
        {
            key: "observe",
            value: function observe() {
                if (!ThemeMutationObserver.observer) {
                    ThemeMutationObserver.observer = new MutationObserver(function() {
                        var theme = (0, $fdb8de170d378fe1$export$2e2bcd8739ae039)();
                        ThemeMutationObserver.callbacks.forEach(function(callback) {
                            return callback(theme);
                        });
                    });
                    // Observer only needs to be configured once
                    ThemeMutationObserver.observer.observe(document.documentElement, {
                        attributeFilter: [
                            (0, $aa49e4c0deeeb8d8$export$4ef52930e33717cd),
                            (0, $aa49e4c0deeeb8d8$export$a00eac3f8684bcd0)
                        ]
                    });
                }
            }
        },
        {
            key: "disconnect",
            value: function disconnect() {
                if (this.callback) ThemeMutationObserver.callbacks.delete(this.callback);
                if (ThemeMutationObserver.callbacks.size === 0 && ThemeMutationObserver.observer) {
                    ThemeMutationObserver.observer.disconnect();
                    ThemeMutationObserver.observer = null;
                }
            }
        }
    ]);
}();
(0, $5bc9a370f4de45ae$export$2e2bcd8739ae039)($22d676c673d4e30f$export$2e2bcd8739ae039, "observer", null);
(0, $5bc9a370f4de45ae$export$2e2bcd8739ae039)($22d676c673d4e30f$export$2e2bcd8739ae039, "callbacks", new Set());


/**
 * A React hook which returns the current themes and color-mode set on `<html>`.
 *
 * @example
 * ```
 * const { colorMode, dark, light, spacing, typography } = useThemeObserver();
 *
 * // Performing side effects when it changes
 * useEffect(() => {
 *   console.log(`The color mode has changed to ${theme.colorMode}`);
 * }, [theme.colorMode]);
 * ```
 */ var $233cd94b869ba248$var$useThemeObserver = function useThemeObserver() {
    var _useState = (0, $5FkrB.useState)((0, $fdb8de170d378fe1$export$2e2bcd8739ae039)()), _useState2 = (0, $958636c847d8b316$export$2e2bcd8739ae039)(_useState, 2), theme = _useState2[0], setTheme = _useState2[1];
    (0, $5FkrB.useEffect)(function() {
        var observer = new (0, $22d676c673d4e30f$export$2e2bcd8739ae039)(function(theme) {
            return setTheme(theme);
        });
        observer.observe();
        return function() {
            return observer.disconnect();
        };
    }, []);
    return theme;
};
var $233cd94b869ba248$export$2e2bcd8739ae039 = $233cd94b869ba248$var$useThemeObserver;


var $ea406245305817b7$var$styles = {
    root: "_1e0c1o8l",
    TEMP_assets: "_9aea1fkg"
};
/* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ var $ea406245305817b7$var$cloudLightAppearanceMap = {
    brand: "_1b3i18uv _9aea18uv",
    neutral: "_1b3i1e01 _9aea1fkg",
    inverse: "_1b3i5a6q _9aeau67f",
    legacy: "_1b3iu67f _9aeadoyu"
};
/* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ var $ea406245305817b7$var$cloudDarkAppearanceMap = {
    brand: "_1b3i18uv _9aea18uv",
    neutral: "_1b3i1gvk _9aea8hz0",
    inverse: "_1b3iu67f _9aea5a6q",
    legacy: "_1b3iu67f _9aeadoyu"
};
/* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ var $ea406245305817b7$var$dataCenterLightAppearanceMap = {
    brand: "_1b3idoyu _9aeau67f _3wu01fkg",
    neutral: "_1b3i1e01 _9aea1fkg _3wu01e01",
    inverse: "_1b3iu67f _9aeaqlpt _3wu0u67f",
    legacy: "_1b3idoyu _9aeau67f _3wu01fkg"
};
/* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ var $ea406245305817b7$var$dataCenterDarkAppearanceMap = {
    brand: "_1b3idoyu _9aeaqlpt _3wu08hz0",
    neutral: "_1b3i1gvk _9aea8hz0 _3wu01gvk",
    inverse: "_1b3i1501 _9aeau67f _3wu01501",
    legacy: "_1b3idoyu _9aeaqlpt _3wu08hz0"
};
var $ea406245305817b7$var$rovoDarkAppearanceMap = {
    brand: "_170318uv _1evo18uv _epb518uv _1osd18uv",
    neutral: "_17031gvk _1evo1gvk _epb51gvk _1osd1gvk",
    inverse: "_1703qlpt _1evoqlpt _epb5qlpt _1osdqlpt",
    legacy: "_1703doyu _1evodoyu _epb5doyu _1osddoyu"
};
var $ea406245305817b7$var$rovoLightAppearanceMap = {
    brand: "_170318uv _1evo18uv _epb518uv _1osd18uv",
    neutral: "_17031e01 _1evo1e01 _epb51e01 _1osd1e01",
    inverse: "_1703u67f _1evou67f _epb5u67f _1osdu67f",
    legacy: "_1703doyu _1evodoyu _epb5doyu _1osddoyu"
};
/* eslint-enable @atlaskit/ui-styling-standard/no-imported-style-values */ /* eslint-enable @atlaskit/ui-styling-standard/no-unsafe-values */ var $ea406245305817b7$var$sizeMap = {
    xxsmall: "_4t3i7vkz",
    xsmall: "_4t3igktf",
    small: "_4t3i1tcg",
    medium: "_4t3izwfg",
    large: "_4t3i1ylp",
    xlarge: "_4t3ickbl",
    '12': "_4t3i1crf",
    '16': "_4t3i7vkz",
    '20': "_4t3igktf",
    '24': "_4t3i1tcg",
    '32': "_4t3izwfg"
};
function $ea406245305817b7$export$be58b4326e23250f(_ref) {
    var _ref$size = _ref.size, size = _ref$size === void 0 ? '20' : _ref$size, label = _ref.label, svg = _ref.svg, customThemeSvg = _ref.customThemeSvg, userDefinedTestId = _ref.testId, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, customIconColor = _ref.iconColor, _ref$isAssets = _ref.isAssets, isAssets = _ref$isAssets === void 0 ? false : _ref$isAssets, _ref$type = _ref.type, type = _ref$type === void 0 ? 'tile' : _ref$type;
    var testId = userDefinedTestId && "".concat(userDefinedTestId, "--wrapper");
    var isCustomThemed = customThemeSvg && customIconColor;
    var _useThemeObserver = (0, $233cd94b869ba248$export$2e2bcd8739ae039)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ $5FkrB.createElement("span", {
        "data-testid": testId,
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            '--themed-icon-color': customIconColor || 'initial'
        },
        "aria-label": label ? label : undefined,
        role: label ? 'img' : undefined,
        "aria-hidden": label === '' ? true : undefined,
        dangerouslySetInnerHTML: {
            __html: isCustomThemed ? customThemeSvg : svg
        },
        className: (0, $c4f3fc62d4a10748$export$2e2bcd8739ae039)([
            $ea406245305817b7$var$styles.root,
            $ea406245305817b7$var$sizeMap[size],
            colorMode === 'dark' ? $ea406245305817b7$var$dataCenterDarkAppearanceMap[appearance] : $ea406245305817b7$var$dataCenterLightAppearanceMap[appearance],
            type === 'rovo' ? colorMode === 'dark' ? $ea406245305817b7$var$rovoDarkAppearanceMap[appearance] : $ea406245305817b7$var$rovoLightAppearanceMap[appearance] : colorMode === 'dark' ? $ea406245305817b7$var$cloudDarkAppearanceMap[appearance] : $ea406245305817b7$var$cloudLightAppearanceMap[appearance],
            isAssets && appearance === 'brand' && ((0, $851f0a53539df6b2$export$b40ec24ac8275656)('assets-platform-branding') || (0, $851f0a53539df6b2$export$b40ec24ac8275656)('assets-platform-branding-with-confluence')) && $ea406245305817b7$var$styles.TEMP_assets
        ])
    });
}


// `height` is set to 100% to allow the SVG to scale with the parent element
var $4e9ffb95cdb5dd3a$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, #101214)\" fill-rule=\"evenodd\" d=\"M10.444 5h3.111l.98 2.61 2.75-.457 1.555 2.694L17.07 12l1.77 2.153-1.555 2.694-2.75-.457-.979 2.61h-3.11l-.98-2.61-2.75.457-1.555-2.694L6.931 12 5.16 9.847l1.555-2.694 2.75.457zM12 14.625a2.625 2.625 0 1 0 0-5.25 2.625 2.625 0 0 0 0 5.25\" clip-rule=\"evenodd\"/>\n</svg>\n";
function $4e9ffb95cdb5dd3a$export$ef8e5f836dd989d3(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Admin' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $ea406245305817b7$export$be58b4326e23250f), {
        svg: $4e9ffb95cdb5dd3a$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::cb1b5c1084ec5af5d6446030d431f52c>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");
/* logo-wrapper.tsx generated by @compiled/babel-plugin v0.39.1 */ /* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ 
var $5FkrB = parcelRequire("5FkrB");



var $e41bbd286dd6d71c$var$styles = {
    root: "_1e0c1o8l _vwz4idpf",
    TEMP_assets: "_9aea1fkg"
};
// These styles set the `color` property so that the child SVG can inherit the correct text color using "currentColor"
var $e41bbd286dd6d71c$var$logoTextColorMap = {
    light: "_syazqlpt",
    dark: "_syazz6c6"
};
var $e41bbd286dd6d71c$var$sizeMap = {
    xxsmall: "_4t3i7vkz",
    xsmall: "_4t3igktf",
    small: "_4t3i1tcg",
    medium: "_4t3izwfg",
    large: "_4t3i1ylp",
    xlarge: "_4t3ickbl"
};
/* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ var $e41bbd286dd6d71c$var$textLightAppearanceMap = {
    brand: "_1wyci7uo",
    neutral: "_1wyc1e01",
    inverse: "_1wycu67f",
    legacy: "_1wycu67f"
};
/* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ var $e41bbd286dd6d71c$var$textDarkAppearanceMap = {
    brand: "_1wyci7uo",
    neutral: "_1wyc1gvk",
    inverse: "_1wyc5a6q",
    legacy: "_1wycu67f"
};
/* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ var $e41bbd286dd6d71c$var$cloudLightAppearanceMap = {
    brand: "_1b3i18uv _9aea18uv",
    neutral: "_1b3i1e01 _9aea1fkg",
    inverse: "_1b3i5a6q _9aeau67f",
    legacy: "_1b3iu67f _9aeadoyu"
};
/* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ var $e41bbd286dd6d71c$var$cloudDarkAppearanceMap = {
    brand: "_1b3i18uv _9aea18uv",
    neutral: "_1b3i1gvk _9aea8hz0",
    inverse: "_1b3iu67f _9aea5a6q",
    legacy: "_1b3iu67f _9aeadoyu"
};
/* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ var $e41bbd286dd6d71c$var$dataCenterLightAppearanceMap = {
    brand: "_1b3idoyu _9aeau67f _3wu01fkg",
    neutral: "_1b3i1e01 _9aea1fkg _3wu01e01",
    inverse: "_1b3iu67f _9aeaqlpt _3wu0u67f",
    legacy: "_1b3idoyu _9aeau67f _3wu01fkg"
};
/* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ var $e41bbd286dd6d71c$var$dataCenterDarkAppearanceMap = {
    brand: "_1b3idoyu _9aeaqlpt _3wu08hz0",
    neutral: "_1b3i1gvk _9aea8hz0 _3wu01gvk",
    inverse: "_1b3i1501 _9aeau67f _3wu01501",
    legacy: "_1b3idoyu _9aeaqlpt _3wu08hz0"
};
var $e41bbd286dd6d71c$var$rovoDarkAppearanceMap = {
    brand: "_1703lrxy _1evoh727 _epb51yy8 _1osdxeun",
    neutral: "_17031gvk _1evo1gvk _epb51gvk _1osd1gvk",
    inverse: "_1703qlpt _1evoqlpt _epb5qlpt _1osdqlpt",
    legacy: "_1703doyu _1evodoyu _epb5doyu _1osddoyu"
};
var $e41bbd286dd6d71c$var$rovoLightAppearanceMap = {
    brand: "_170318uv _1evo18uv _epb518uv _1osd18uv",
    neutral: "_17031e01 _1evo1e01 _epb51e01 _1osd1e01",
    inverse: "_1703u67f _1evou67f _epb5u67f _1osdu67f",
    legacy: "_1703doyu _1evodoyu _epb5doyu _1osddoyu"
};
function $e41bbd286dd6d71c$export$f827d3c5a9c3f644(_ref) {
    var _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$size = _ref.size, size = _ref$size === void 0 ? 'small' : _ref$size, svg = _ref.svg, customThemeSvg = _ref.customThemeSvg, label = _ref.label, userDefinedTestId = _ref.testId, customIconColor = _ref.iconColor, customTextColor = _ref.textColor, _ref$isAssets = _ref.isAssets, isAssets = _ref$isAssets === void 0 ? false : _ref$isAssets, _ref$type = _ref.type, type = _ref$type === void 0 ? 'tile' : _ref$type;
    var _useThemeObserver = (0, $233cd94b869ba248$export$2e2bcd8739ae039)(), colorMode = _useThemeObserver.colorMode;
    var testId = userDefinedTestId && "".concat(userDefinedTestId, "--wrapper");
    var isCustomThemed = customThemeSvg && (customIconColor || customTextColor);
    return /*#__PURE__*/ $5FkrB.createElement("span", {
        style: {
            // Nav v3 passes in "inherit" incorrectly for iconColor, so we fall back to textColor when this happens.
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            '--themed-icon-color': customIconColor === 'inherit' ? customTextColor : customIconColor,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            '--themed-text-color': customTextColor || 'inherit'
        },
        "data-testid": testId,
        "aria-label": label ? label : undefined,
        role: label ? 'img' : undefined,
        "aria-hidden": label === '' ? true : undefined,
        dangerouslySetInnerHTML: {
            __html: isCustomThemed ? customThemeSvg : svg
        },
        className: (0, $c4f3fc62d4a10748$export$2e2bcd8739ae039)([
            $e41bbd286dd6d71c$var$styles.root,
            // Setting the color so that the SVG can inherit the correct text color using "currentColor"
            $e41bbd286dd6d71c$var$logoTextColorMap[colorMode !== null && colorMode !== void 0 ? colorMode : 'light'],
            $e41bbd286dd6d71c$var$sizeMap[size],
            colorMode === 'dark' ? $e41bbd286dd6d71c$var$textDarkAppearanceMap[appearance] : $e41bbd286dd6d71c$var$textLightAppearanceMap[appearance],
            colorMode === 'dark' ? $e41bbd286dd6d71c$var$dataCenterDarkAppearanceMap[appearance] : $e41bbd286dd6d71c$var$dataCenterLightAppearanceMap[appearance],
            type === 'rovo' ? colorMode === 'dark' ? $e41bbd286dd6d71c$var$rovoDarkAppearanceMap[appearance] : $e41bbd286dd6d71c$var$rovoLightAppearanceMap[appearance] : colorMode === 'dark' ? $e41bbd286dd6d71c$var$cloudDarkAppearanceMap[appearance] : $e41bbd286dd6d71c$var$cloudLightAppearanceMap[appearance],
            isAssets && appearance === 'brand' && ((0, $851f0a53539df6b2$export$b40ec24ac8275656)('assets-platform-branding') || (0, $851f0a53539df6b2$export$b40ec24ac8275656)('assets-platform-branding-with-confluence')) && $e41bbd286dd6d71c$var$styles.TEMP_assets
        ])
    });
}


// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $a82d2b8e723df418$var$svg = "<svg height=\"100%\" viewBox=\"0 0 126 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M124.84 16.35v8.99h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.51c.98-1.81 2.79-2.82 4.85-2.82 3.53 0 5.55 2.42 5.55 6.66m-20.15-10.4c0-1.17.77-1.84 1.84-1.84s1.84.67 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zm-14.07-8.52v8.53h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.51c.98-1.81 2.79-2.82 4.85-2.82 2.61 0 4.39 1.32 5.15 3.74.86-2.36 2.91-3.74 5.46-3.74 3.44 0 5.34 2.33 5.34 6.66v8.99h-2.64v-8.52c0-3.16-1.1-4.72-3.62-4.72-2.45 0-4.14 1.63-4.14 4.72m-28.32.85c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V3.59h2.64v21.74zm-22.02-4.01c-1.53 0-3.1-.18-4.81-.52l-1.69 4.54h-3.1l7.94-20.15h3.5l7.94 20.15h-3.1l-1.69-4.57c-1.81.37-3.37.55-5 .55m0-2.45c1.29 0 2.61-.15 4.17-.4L49.53 7.43 45.45 18.5c1.5.25 2.76.37 3.99.37\"/>\n    <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, #101214)\" fill-rule=\"evenodd\" d=\"M13.826 6.4h4.255l1.338 3.569 3.76-.626 2.128 3.684-2.422 2.945 2.421 2.943L23.18 22.6l-3.76-.626-1.338 3.57h-4.255l-1.338-3.57-3.76.625L6.6 18.915l2.421-2.943L6.6 13.028l2.127-3.685 3.76.626zm2.128 13.16a3.59 3.59 0 1 0 0-7.178 3.59 3.59 0 0 0 0 7.179\" clip-rule=\"evenodd\"/>\n</svg>\n";
function $a82d2b8e723df418$export$61afcb38c001e19(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Admin' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $e41bbd286dd6d71c$export$f827d3c5a9c3f644), {
        svg: $a82d2b8e723df418$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d8dc880eda57906914bb7837c5a5c673>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
var $157197922b699817$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#fb9700)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M18.545 18.545a4.49 4.49 0 0 0-4.48-4.48h-4.13v-3.78h-4.48v7.434c0 .576.25.826.826.826zM5.455 5.455a4.454 4.454 0 0 0 4.455 4.48h4.155v3.78h4.48V6.28q0-.825-.826-.826z\"/>\n</svg>\n";
function $157197922b699817$export$70a0c2f5862937b6(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Align' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $ea406245305817b7$export$be58b4326e23250f), {
        svg: $157197922b699817$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b50cb2ad76b4dba28f22d4bb555219f7>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $ba7fec4b6bc063e4$var$svg = "<svg height=\"100%\" viewBox=\"0 0 106 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M105.76 16.35v8.99h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.63V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 3.53 0 5.55 2.42 5.55 6.66m-19.6 7.75v-1.53c-.98 2.02-2.82 3.07-5.18 3.07-4.05 0-6.07-3.46-6.07-7.97 0-4.32 2.12-7.97 6.38-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.58v13.95c0 4.51-2.12 7.54-7.61 7.54-2.58 0-3.99-.34-5.46-.83v-2.58c1.69.55 3.43.92 5.34.92 3.83 0 5.15-2.05 5.15-4.91m-8.68-6.44c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52M68.73 5.95c0-1.17.77-1.84 1.84-1.84s1.84.67 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zm-2.54-.03c-.21.06-.67.12-1.35.12-2.51 0-4.11-1.19-4.11-4.02V3.59h2.64V21.1c0 1.38.92 1.87 2.06 1.87.28 0 .46 0 .77-.03zM49.6 21.32c-1.53 0-3.1-.18-4.82-.52l-1.69 4.54H40l7.94-20.15h3.5l7.94 20.15h-3.1l-1.69-4.57c-1.81.37-3.37.55-5 .55m0-2.45c1.29 0 2.61-.15 4.17-.4L49.68 7.43 45.6 18.5c1.5.25 2.76.37 3.99.37\"/>\n    <path fill=\"var(--tile-color,#fb9700)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M23.735 23.735c0-2.928-2.396-5.295-5.295-5.295h-4.88v-4.466H8.265v8.785c0 .68.296.976.976.976zM8.265 8.265c0 2.928 2.337 5.295 5.265 5.295h4.91v4.466h5.295V9.241q0-.976-.976-.976z\"/>\n</svg>\n";
function $ba7fec4b6bc063e4$export$8b5103382c06639c(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Align' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $e41bbd286dd6d71c$export$f827d3c5a9c3f644), {
        svg: $ba7fec4b6bc063e4$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::93b4dea5ca940a35aa6da4a3e32efaba>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
var $7dbc9112440dccfc$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M14.63 5.88v9.19h3.06v-9.2zM5.88 18.13h11.81v-1.75H5.87zm0-3.07v-4.81h3.06v4.81zm4.37-6.56v6.56h3.06V8.5z\"/>\n</svg>\n";
function $7dbc9112440dccfc$export$af3460f51ce3602a(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Analytics' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $ea406245305817b7$export$be58b4326e23250f), {
        svg: $7dbc9112440dccfc$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::19cf5335c393da35608b01fe889f5c46>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $40467a94c49e82c6$var$svg = "<svg height=\"100%\" viewBox=\"0 0 161 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M160.66 21.16c0 2.55-1.66 4.48-5.76 4.48-2.3 0-4.17-.52-5.34-1.13v-2.79c1.32.77 3.53 1.5 5.46 1.5 2.02 0 3.07-.83 3.07-2.02 0-1.17-.89-1.84-3.8-2.55-3.4-.83-4.85-2.15-4.85-4.66 0-2.67 2.06-4.29 5.55-4.29 1.99 0 3.8.49 4.94 1.1v2.73c-1.84-.92-3.34-1.41-4.97-1.41-1.93 0-2.97.67-2.97 1.87 0 1.07.74 1.75 3.56 2.42 3.4.83 5.12 2.09 5.12 4.75m-13.6 1.41v2.36c-.92.49-2.33.71-3.74.71-5.46 0-8-3.31-8-8 0-4.63 2.55-7.94 8-7.94 1.38 0 2.45.18 3.65.74v2.45c-.98-.46-2.02-.74-3.47-.74-3.99 0-5.61 2.52-5.61 5.49s1.66 5.49 5.67 5.49c1.56 0 2.55-.21 3.5-.55M129.13 5.95c0-1.16.77-1.84 1.84-1.84s1.84.68 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zm-7.46-4.75c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55c-.46.12-.98.25-1.78.25-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zm-14.12 3.77h-1.72L100.77 10h2.82l4.91 13.13L113.41 10h2.82l-5.8 14.84c-1.72 4.39-2.7 6.66-6.59 6.66-1.32 0-2.05-.12-2.82-.43V28.8c.89.28 1.9.37 2.67.37 2.15 0 3.1-1.47 4.36-4.81m-7.8.94c-.21.06-.67.12-1.35.12-2.51 0-4.11-1.19-4.11-4.02V3.59h2.64V21.1c0 1.38.92 1.87 2.06 1.87.28 0 .46 0 .77-.03zM79.5 17.67c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.47-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zM74.1 16.35v8.99h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.63V10h2.64v2.51c.98-1.81 2.79-2.82 4.85-2.82 3.53 0 5.55 2.42 5.55 6.66m-24.66 4.97c-1.53 0-3.1-.18-4.81-.52l-1.69 4.54h-3.1l7.94-20.15h3.5l7.94 20.15h-3.1l-1.69-4.57c-1.81.37-3.37.55-5 .55m0-2.45c1.29 0 2.61-.15 4.17-.4L49.53 7.43 45.45 18.5c1.5.25 2.76.37 3.99.37\"/>\n    <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M19.5 7.83v12.25h4.08V7.83zM7.83 24.17h15.75v-2.33H7.83zm0-4.09v-6.42h4.08v6.42zm5.84-8.75v8.75h4.08v-8.75z\"/>\n</svg>\n";
function $40467a94c49e82c6$export$f0bac2b7ac3e3504(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Analytics' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $e41bbd286dd6d71c$export$f827d3c5a9c3f644), {
        svg: $40467a94c49e82c6$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::70585722d0ca9257d878eccc1885f195>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
var $c52d6d824e754bef$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#ffc716)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, #101214)\" fill-rule=\"evenodd\" d=\"M8.34 11.495a3.64 3.64 0 0 0 3.155-3.154h2.3V6.523h-2.537a3.638 3.638 0 1 0-4.735 4.735v2.538H8.34zM7.887 9.25a1.364 1.364 0 1 0 0-2.727 1.364 1.364 0 0 0 0 2.727\" clip-rule=\"evenodd\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M19.25 7.43a2.27 2.27 0 1 1-4.54 0 2.27 2.27 0 0 1 4.55 0M7.43 19.25a2.27 2.27 0 1 0 0-4.54 2.27 2.27 0 0 0 0 4.55m9.55-.01a2.27 2.27 0 1 0 0-4.54 2.27 2.27 0 0 0 0 4.55m-3.18-3.19h-3.18v1.82h3.18zm2.27-5.46v3.18h1.82v-3.18z\"/>\n</svg>\n";
var $c52d6d824e754bef$var$customThemeSvg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--themed-icon-color, currentcolor)\" d=\"M18 0a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6V6a6 6 0 0 1 6-6zM7.432 14.704a2.273 2.273 0 1 0 .001 4.547 2.273 2.273 0 0 0-.001-4.547m9.545 0a2.274 2.274 0 1 0 .001 4.548 2.274 2.274 0 0 0 0-4.548m-6.364 1.364v1.819h3.183v-1.819zM7.887 4.25a3.637 3.637 0 0 0-1.365 7.009v2.537h1.819v-2.302a3.64 3.64 0 0 0 3.153-3.153h2.302V6.522h-2.537A3.64 3.64 0 0 0 7.887 4.25m8.181 6.363v3.183h1.819v-3.183zm.91-5.454a2.273 2.273 0 1 0 0 4.547 2.273 2.273 0 0 0 0-4.547M7.887 6.522a1.364 1.364 0 1 1-.002 2.729 1.364 1.364 0 0 1 .002-2.729\"/>\n</svg>\n";
function $c52d6d824e754bef$export$d89497e7f33ca6f5(_ref) {
    var iconColor = _ref.iconColor, size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Assets' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $ea406245305817b7$export$be58b4326e23250f), {
        svg: $c52d6d824e754bef$var$svg,
        customThemeSvg: $c52d6d824e754bef$var$customThemeSvg,
        iconColor: iconColor,
        label: label,
        isAssets: true,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e69fa4e6ed45c9755193e19593b57593>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $61590386808e05f8$var$svg = "<svg height=\"100%\" viewBox=\"0 0 126 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M125.8 21.16c0 2.55-1.66 4.48-5.76 4.48-2.3 0-4.17-.52-5.34-1.13v-2.79c1.32.77 3.53 1.5 5.46 1.5 2.02 0 3.07-.83 3.07-2.02 0-1.16-.89-1.84-3.8-2.54-3.4-.83-4.84-2.15-4.84-4.66 0-2.67 2.06-4.29 5.55-4.29 1.99 0 3.8.49 4.94 1.1v2.73c-1.84-.92-3.34-1.41-4.97-1.41-1.93 0-2.97.67-2.97 1.87 0 1.07.74 1.75 3.56 2.42 3.4.83 5.12 2.09 5.12 4.75m-17.77-.59c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55c-.46.12-.98.25-1.78.25-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zm-13.53-8.5c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.2c.37 2.61 2.05 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-15.13-3.56c0 2.55-1.66 4.48-5.77 4.48-2.3 0-4.17-.52-5.34-1.13v-2.79c1.32.77 3.53 1.5 5.46 1.5 2.02 0 3.07-.83 3.07-2.02 0-1.16-.89-1.84-3.8-2.54-3.4-.83-4.85-2.15-4.85-4.66 0-2.67 2.06-4.29 5.55-4.29 1.99 0 3.8.49 4.94 1.1v2.73c-1.84-.92-3.34-1.41-4.97-1.41-1.93 0-2.97.67-2.97 1.87 0 1.07.74 1.75 3.56 2.42 3.4.83 5.12 2.09 5.12 4.75m-13.63-.01c0 2.55-1.66 4.48-5.76 4.48-2.3 0-4.17-.52-5.34-1.13v-2.79c1.32.77 3.53 1.5 5.46 1.5 2.02 0 3.07-.83 3.07-2.02 0-1.16-.89-1.84-3.8-2.54-3.4-.83-4.84-2.15-4.84-4.66 0-2.67 2.06-4.29 5.55-4.29 1.99 0 3.8.49 4.94 1.1v2.73c-1.84-.92-3.34-1.41-4.97-1.41-1.93 0-2.97.67-2.97 1.87 0 1.07.74 1.75 3.56 2.42 3.4.83 5.12 2.09 5.12 4.75m-22.22.15c-1.53 0-3.1-.18-4.81-.52l-1.69 4.54h-3.1l7.94-20.15h3.5l7.94 20.15h-3.1l-1.69-4.57c-1.81.37-3.37.55-5 .55m0-2.45c1.29 0 2.61-.15 4.17-.4L49.53 7.43 45.45 18.5c1.5.25 2.76.37 3.99.37\"/>\n    <path fill=\"var(--tile-color,#ffc716)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, #101214)\" fill-rule=\"evenodd\" d=\"M11.667 15.425a4.335 4.335 0 0 0 3.758-3.758h2.742V9.5h-3.023A4.335 4.335 0 1 0 9.5 15.144v3.023h2.167zm-.542-2.675a1.625 1.625 0 1 0 0-3.25 1.625 1.625 0 0 0 0 3.25\" clip-rule=\"evenodd\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M24.67 10.58a2.71 2.71 0 1 1-5.42 0 2.71 2.71 0 0 1 5.42 0M10.58 24.67a2.71 2.71 0 1 0 0-5.42 2.71 2.71 0 0 0 0 5.42m11.38 0a2.71 2.71 0 1 0 0-5.42 2.71 2.71 0 0 0 0 5.42m-3.79-3.79h-3.79v2.17h3.79zm2.71-6.5v3.79h2.17v-3.79z\"/>\n</svg>\n";
function $61590386808e05f8$export$81c47abe19675c4c(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Assets' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $e41bbd286dd6d71c$export$f827d3c5a9c3f644), {
        svg: $61590386808e05f8$var$svg,
        label: label,
        isAssets: true,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::4355cde32d77e58b21f0c95828a80152>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
var $0fc8b6c4028cfcc8$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color, white)\" d=\"M6 .5h12A5.5 5.5 0 0 1 23.5 6v12a5.5 5.5 0 0 1-5.5 5.5H6A5.5 5.5 0 0 1 .5 18V6A5.5 5.5 0 0 1 6 .5\"/>\n    <path fill=\"none\" stroke=\"var(--border-color, #dddee1)\" d=\"M6 .5h12A5.5 5.5 0 0 1 23.5 6v12a5.5 5.5 0 0 1-5.5 5.5H6A5.5 5.5 0 0 1 .5 18V6A5.5 5.5 0 0 1 6 .5Z\"/>\n    <path fill=\"var(--icon-color, #1868db)\" d=\"M9.215 12.652a2.75 2.75 0 0 0 2.749 2.742v4.205a6.964 6.964 0 0 1-6.849-5.727l-.049-.317zm9.26 0a.44.44 0 0 1 .436.468c-.222 3.311-2.783 5.989-6.043 6.414l-.904-4.14a2.75 2.75 0 0 0 2.723-2.37.44.44 0 0 1 .44-.372zM11.963 9.91a2.75 2.75 0 0 0-2.748 2.742H5v-.065c.033-3.495 2.668-6.374 6.059-6.816zm0-5.972a.436.436 0 0 1 .72-.33l4.824 4.138a.436.436 0 0 1 0 .662l-4.823 4.139a.436.436 0 0 1-.72-.331z\"/>\n</svg>\n";
function $0fc8b6c4028cfcc8$export$e812398311cab9a3(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Bamboo' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $ea406245305817b7$export$be58b4326e23250f), {
        svg: $0fc8b6c4028cfcc8$var$svg,
        label: label,
        type: "data-center",
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a8b53caccfaf8935cadc28439cd96493>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $40af6e70025eaf25$var$svg = "<svg height=\"100%\" viewBox=\"0 0 154 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M146 25.64c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49m-16.68 13.49c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49m-12.07 5.52c0-3.68-1.47-5.52-4.2-5.52-2.36 0-4.48 1.5-4.48 4.91v1.23c0 3.4 1.93 4.91 4.17 4.91 2.98 0 4.51-1.96 4.51-5.52m-3.8 7.97c-2.24 0-3.96-1.01-4.88-3v2.7h-2.64V3.59h2.64v9.17c.98-2.02 2.82-3.07 5.18-3.07 4.08 0 6.13 3.47 6.13 7.97 0 4.32-2.15 7.97-6.44 7.97m-21.58-8.82v8.53h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 2.61 0 4.39 1.32 5.15 3.74.86-2.36 2.91-3.74 5.46-3.74 3.43 0 5.34 2.33 5.34 6.66v8.99h-2.64v-8.52c0-3.16-1.1-4.72-3.62-4.72-2.45 0-4.14 1.63-4.14 4.72m-28.32.84c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-20.23-9.04H45.8v6.29h6.26c2.64 0 3.83-.95 3.83-2.97 0-2.15-1.13-3.31-3.89-3.31m-.89-8.46h-5.3v6.01h5.31c2.61 0 3.68-1.2 3.68-3.13 0-1.96-1.16-2.88-3.68-2.88m-8.06 17.51V5.19h8.43c4.11 0 6.1 2.02 6.1 5.28 0 2.42-1.1 3.93-3.37 4.48 2.97.49 4.45 2.12 4.45 4.97 0 3.22-2.18 5.43-6.68 5.43z\"/>\n    <path fill=\"var(--tile-color, white)\" d=\"M8 .667h16A7.333 7.333 0 0 1 31.333 8v16A7.333 7.333 0 0 1 24 31.333H8A7.333 7.333 0 0 1 .667 24V8A7.333 7.333 0 0 1 8 .667\"/>\n    <path fill=\"none\" stroke=\"var(--border-color, #dddee1)\" stroke-width=\"1.333\" d=\"M8 .667h16A7.333 7.333 0 0 1 31.333 8v16A7.333 7.333 0 0 1 24 31.333H8A7.333 7.333 0 0 1 .667 24V8A7.333 7.333 0 0 1 8 .667Z\"/>\n    <path fill=\"var(--icon-color, #1868db)\" d=\"M12.287 16.869a3.665 3.665 0 0 0 3.665 3.656v5.607c-4.71 0-8.602-3.52-9.196-8.06zm12.347 0a.584.584 0 0 1 .581.624c-.295 4.415-3.71 7.986-8.057 8.554l-1.206-5.521a3.67 3.67 0 0 0 3.63-3.161.59.59 0 0 1 .589-.496zm-8.683-3.656a3.664 3.664 0 0 0-3.665 3.656h-5.62v-.088c.044-4.66 3.557-8.498 8.078-9.088zm0-7.964a.58.58 0 0 1 .96-.44l6.432 5.518c.27.232.27.65 0 .883l-6.431 5.517a.581.581 0 0 1-.96-.44z\"/>\n</svg>\n";
function $40af6e70025eaf25$export$7c51958462d750e(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Bamboo' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $e41bbd286dd6d71c$export$f827d3c5a9c3f644), {
        svg: $40af6e70025eaf25$var$svg,
        label: label,
        type: "data-center",
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::0a55e042f17bf853ed858530ff13b240>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
var $40fd1d0f44448bda$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color, white)\" d=\"M6 .5h12A5.5 5.5 0 0 1 23.5 6v12a5.5 5.5 0 0 1-5.5 5.5H6A5.5 5.5 0 0 1 .5 18V6A5.5 5.5 0 0 1 6 .5\"/>\n    <path fill=\"none\" stroke=\"var(--border-color, #dddee1)\" d=\"M6 .5h12A5.5 5.5 0 0 1 23.5 6v12a5.5 5.5 0 0 1-5.5 5.5H6A5.5 5.5 0 0 1 .5 18V6A5.5 5.5 0 0 1 6 .5Z\"/>\n    <path fill=\"var(--icon-color, #1868db)\" d=\"m17.843 11.763-.986 6.024c-.065.365-.322.58-.686.58H7.81c-.365 0-.622-.215-.686-.58L5.387 7.047c-.064-.364.129-.6.472-.6h12.262c.343 0 .536.236.472.6l-.472 2.83c-.064.407-.3.579-.686.579h-7.374c-.107 0-.172.064-.15.193l.579 3.558c.021.086.085.15.171.15h2.658c.086 0 .15-.064.172-.15l.407-2.572c.043-.322.257-.45.558-.45h2.894c.428 0 .557.214.493.578\"/>\n</svg>\n";
function $40fd1d0f44448bda$export$d3ab16bbf4f954ee(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Bitbucket Data Center' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $ea406245305817b7$export$be58b4326e23250f), {
        svg: $40fd1d0f44448bda$var$svg,
        label: label,
        type: "data-center",
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a6cf1e00141abbc39f2d3b5098a9d63a>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $41419f040867fd8d$var$svg = "<svg height=\"100%\" viewBox=\"0 0 166 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M161.21 20.58c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55c-.46.12-.98.25-1.78.25-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zm-13.53-8.49c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-23.83.6h-2.64V3.59h2.64v13.59l6.6-7.18h3.44l-7.21 7.54 7.51 7.79h-3.59l-6.75-7.18zm-5.64-2.76v2.36c-.92.49-2.33.71-3.74.71-5.46 0-8-3.31-8-8 0-4.63 2.55-7.94 8-7.94 1.38 0 2.45.18 3.65.74v2.45c-.98-.46-2.02-.74-3.47-.74-3.99 0-5.61 2.51-5.61 5.49s1.66 5.49 5.67 5.49c1.56 0 2.55-.21 3.5-.55m-27.85-3.59V10h2.64v9.26c0 2.76 1.1 3.99 3.62 3.99 2.45 0 4.14-1.62 4.14-4.72V10h2.64v15.33h-2.64v-2.51c-.98 1.81-2.79 2.82-4.85 2.82-3.53 0-5.55-2.42-5.55-6.65m-5.39-1.32c0-3.68-1.47-5.52-4.2-5.52-2.36 0-4.48 1.5-4.48 4.91v1.23c0 3.4 1.93 4.91 4.17 4.91 2.98 0 4.51-1.96 4.51-5.52m-3.8 7.97c-2.24 0-3.96-1.01-4.88-3v2.7h-2.64V3.59h2.64v9.17c.98-2.02 2.82-3.07 5.18-3.07 4.08 0 6.13 3.47 6.13 7.97 0 4.32-2.15 7.97-6.44 7.97m-14.96-5.05c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55a6.3 6.3 0 0 1-1.78.25c-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zM61.33 5.95c0-1.16.77-1.84 1.84-1.84s1.84.68 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zm-9.83-9.04H45.8v6.29h6.26c2.64 0 3.83-.95 3.83-2.97 0-2.15-1.13-3.31-3.89-3.31m-.89-8.46h-5.3v6.01h5.31c2.61 0 3.68-1.2 3.68-3.13 0-1.96-1.16-2.88-3.68-2.88m-8.06 17.51V5.19h8.43c4.11 0 6.1 2.02 6.1 5.28 0 2.42-1.1 3.93-3.37 4.48 2.97.49 4.45 2.12 4.45 4.97 0 3.22-2.18 5.43-6.68 5.43z\"/>\n    <path fill=\"var(--tile-color, white)\" d=\"M8 .667h16A7.333 7.333 0 0 1 31.333 8v16A7.333 7.333 0 0 1 24 31.333H8A7.333 7.333 0 0 1 .667 24V8A7.333 7.333 0 0 1 8 .667\"/>\n    <path fill=\"none\" stroke=\"var(--border-color, #dddee1)\" stroke-width=\"1.333\" d=\"M8 .667h16A7.333 7.333 0 0 1 31.333 8v16A7.333 7.333 0 0 1 24 31.333H8A7.333 7.333 0 0 1 .667 24V8A7.333 7.333 0 0 1 8 .667Z\"/>\n    <path fill=\"var(--icon-color, #1868db)\" d=\"m23.79 15.684-1.315 8.032c-.085.486-.428.772-.914.772H10.413c-.486 0-.829-.286-.915-.772L7.183 9.396c-.086-.486.172-.8.629-.8h16.35c.457 0 .714.314.629.8l-.63 3.773c-.085.543-.4.772-.914.772h-9.833c-.143 0-.228.086-.2.257l.772 4.745c.028.114.114.2.229.2h3.544c.114 0 .2-.086.229-.2l.543-3.43c.057-.429.343-.6.743-.6h3.859c.571 0 .743.285.657.771\"/>\n</svg>\n";
function $41419f040867fd8d$export$cc55e2a4c4b40552(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Bitbucket Data Center' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $e41bbd286dd6d71c$export$f827d3c5a9c3f644), {
        svg: $41419f040867fd8d$var$svg,
        label: label,
        type: "data-center",
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::83bd991a11895fc697ec86ba4d2d82c2>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
var $39f8da7ca94c04d3$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#94c748)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"m17.898 11.353-.994 6.064c-.065.367-.324.583-.691.583H7.787c-.367 0-.627-.216-.691-.583L5.346 6.604C5.28 6.237 5.476 6 5.82 6h12.358c.346 0 .54.237.475.604l-.475 2.85c-.065.41-.303.582-.691.582h-7.432c-.109 0-.173.065-.152.194l.584 3.583c.021.086.086.151.172.151h2.68c.086 0 .15-.065.172-.151l.41-2.59c.044-.324.26-.453.563-.453H17.4c.432 0 .562.216.497.582\"/>\n</svg>\n";
var $39f8da7ca94c04d3$var$customThemeSvg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--themed-icon-color, currentcolor)\" d=\"M18 0a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6V6a6 6 0 0 1 6-6zM5.821 6c-.345 0-.54.238-.475.604l1.75 10.813c.065.367.324.583.691.583h8.426c.367 0 .627-.216.691-.583l.994-6.065c.065-.366-.065-.582-.497-.582h-2.917c-.302 0-.518.13-.561.453l-.41 2.59c-.022.086-.087.15-.173.15h-2.68c-.086 0-.151-.064-.173-.15l-.583-3.583c-.021-.129.044-.194.152-.194h7.431c.39 0 .627-.173.692-.583l.475-2.849c.065-.366-.13-.604-.475-.604z\"/>\n</svg>\n";
function $39f8da7ca94c04d3$export$5fc1066e677788d4(_ref) {
    var iconColor = _ref.iconColor, size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Bitbucket' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $ea406245305817b7$export$be58b4326e23250f), {
        svg: $39f8da7ca94c04d3$var$svg,
        customThemeSvg: $39f8da7ca94c04d3$var$customThemeSvg,
        iconColor: iconColor,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::7131ffd6f745f530e9a82fe4842b6a8c>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $2340da16fbcc93af$var$svg = "<svg height=\"100%\" viewBox=\"0 0 166 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M161.21 20.58c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55a6.3 6.3 0 0 1-1.78.25c-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zm-13.53-8.49c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.67-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.05 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-23.83.6h-2.64V3.59h2.64v13.59l6.6-7.18h3.44l-7.21 7.54 7.51 7.79h-3.59l-6.75-7.18zm-5.64-2.76v2.36c-.92.49-2.33.71-3.74.71-5.46 0-8-3.31-8-8 0-4.63 2.55-7.94 8-7.94 1.38 0 2.45.18 3.65.74v2.45c-.98-.46-2.02-.74-3.46-.74-3.99 0-5.61 2.52-5.61 5.49s1.66 5.49 5.67 5.49c1.56 0 2.55-.21 3.5-.55m-27.86-3.59V10h2.64v9.26c0 2.76 1.1 3.99 3.62 3.99 2.45 0 4.14-1.63 4.14-4.72V10h2.64v15.33h-2.64v-2.51c-.98 1.81-2.79 2.82-4.84 2.82-3.53 0-5.55-2.42-5.55-6.65m-5.4-1.32c0-3.68-1.47-5.52-4.2-5.52-2.36 0-4.48 1.5-4.48 4.91v1.23c0 3.4 1.93 4.91 4.17 4.91 2.98 0 4.51-1.96 4.51-5.52m-3.8 7.97c-2.24 0-3.96-1.01-4.88-3v2.7h-2.64V3.59h2.64v9.17c.98-2.02 2.82-3.07 5.18-3.07 4.08 0 6.13 3.47 6.13 7.97 0 4.32-2.15 7.97-6.44 7.97m-14.96-5.05c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55c-.46.12-.98.25-1.78.25-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zM61.33 5.95c0-1.16.77-1.84 1.84-1.84s1.84.68 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zm-9.83-9.04H45.8v6.29h6.26c2.64 0 3.83-.95 3.83-2.97 0-2.15-1.13-3.31-3.89-3.31m-.89-8.46h-5.3v6.01h5.31c2.61 0 3.68-1.2 3.68-3.13 0-1.96-1.17-2.88-3.68-2.88m-8.06 17.51V5.19h8.43c4.11 0 6.1 2.02 6.1 5.27 0 2.42-1.1 3.93-3.37 4.48 2.97.49 4.45 2.12 4.45 4.97 0 3.22-2.18 5.43-6.69 5.43z\"/>\n    <path fill=\"var(--tile-color,#94c748)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"m23.79 15.684-1.315 8.032c-.085.486-.428.772-.914.772H10.413c-.486 0-.829-.286-.915-.772L7.183 9.396c-.086-.486.172-.8.629-.8h16.35c.457 0 .714.314.629.8l-.63 3.773c-.085.543-.4.772-.914.772h-9.833c-.143 0-.228.086-.2.257l.772 4.745c.029.114.114.2.229.2h3.544c.114 0 .2-.086.229-.2l.543-3.43c.057-.429.343-.6.743-.6h3.859c.572 0 .743.285.657.771\"/>\n</svg>\n";
function $2340da16fbcc93af$export$f7ef5e5488e4b430(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Bitbucket' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $e41bbd286dd6d71c$export$f827d3c5a9c3f644), {
        svg: $2340da16fbcc93af$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a54a6a33fcca799b58ea8f543b85188b>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
var $47281b3797a0e1e6$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, #101214)\" fill-rule=\"evenodd\" d=\"M18.563 16.688h-8.438L5.438 19.5V5.438h13.125zm-6.83-9.375-.255.647c-.362.92-.543 1.38-.878 1.727-.334.346-.787.543-1.694.938l-.388.17v.535l.388.17c.907.394 1.36.592 1.694.938.335.346.516.807.878 1.727l.255.648h.535l.255-.648c.362-.92.543-1.38.877-1.727.335-.346.788-.544 1.694-.939l.388-.169v-.535l-.388-.17c-.906-.395-1.36-.592-1.694-.938-.334-.347-.515-.807-.877-1.727l-.255-.647z\" clip-rule=\"evenodd\"/>\n</svg>\n";
function $47281b3797a0e1e6$export$52cd484a7ef4f2b9(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Chat' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $ea406245305817b7$export$be58b4326e23250f), {
        svg: $47281b3797a0e1e6$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e9242b17d268ccb8686f65219c6ac465>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $3fcca48502ec19ca$var$svg = "<svg height=\"100%\" viewBox=\"0 0 102 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M97.51 20.58c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55c-.46.12-.98.25-1.78.25-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zm-18.94-2.91c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-14.1-8.98v8.99h-2.64v-8.52c0-3.16-1.1-4.72-3.62-4.72-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V3.59h2.64v8.95c1.01-1.81 2.85-2.85 5.06-2.85 3.44 0 5.34 2.33 5.34 6.66m-16.22 5.43v2.67c-1.26.83-3.25 1.2-5.34 1.2-6.62 0-10.36-3.99-10.36-10.33 0-6.13 3.74-10.43 10.3-10.43 1.96 0 3.93.37 5.37 1.41v2.67c-1.44-.92-3.04-1.41-5.37-1.41-4.72 0-7.54 3.13-7.54 7.76s2.91 7.7 7.7 7.7c2.12 0 3.77-.49 5.24-1.23\"/>\n    <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, #101214)\" fill-rule=\"evenodd\" d=\"M24.75 22.25H13.5L7.25 26V7.25h17.5zm-9.107-12.5-.34.864c-.482 1.226-.724 1.84-1.17 2.302s-1.05.725-2.258 1.251l-.518.226v.714l.518.226c1.209.526 1.813.79 2.259 1.251.445.462.687 1.076 1.17 2.303l.34.863h.714l.34-.864c.482-1.227.724-1.84 1.17-2.302s1.049-.725 2.258-1.251l.517-.226v-.714l-.517-.226c-1.21-.526-1.813-.79-2.259-1.251-.445-.462-.687-1.075-1.17-2.302l-.34-.864z\" clip-rule=\"evenodd\"/>\n</svg>\n";
function $3fcca48502ec19ca$export$a529e78951cd6709(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Chat' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $e41bbd286dd6d71c$export$f827d3c5a9c3f644), {
        svg: $3fcca48502ec19ca$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3ac62e14826e8b3e1f38977284672c29>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
var $3261fc8266090e6c$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, #101214)\" fill-rule=\"evenodd\" d=\"M6.75 19V5h10.5v14h-3.937v-3.062h-2.625V19zM9.375 8.063h1.75V6.75h-1.75zm3.5 0h1.75V6.75h-1.75zm-1.75 3.062h-1.75V9.813h1.75zm-1.75 3.063h1.75v-1.313h-1.75zm5.25-3.063h-1.75V9.813h1.75zm-1.75 3.063h1.75v-1.313h-1.75z\" clip-rule=\"evenodd\"/>\n</svg>\n";
function $3261fc8266090e6c$export$5ef3f25e16249826(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Company Hub' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $ea406245305817b7$export$be58b4326e23250f), {
        svg: $3261fc8266090e6c$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::bcf3d9eaf1759437b869f9901adcacb2>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $50b8810a291d2f4a$var$svg = "<svg height=\"100%\" viewBox=\"0 0 129 24\">\n    <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, #101214)\" fill-rule=\"evenodd\" d=\"M6.75 19V5h10.5v14h-3.937v-3.062h-2.625V19zM9.375 8.063h1.75V6.75h-1.75zm3.5 0h1.75V6.75h-1.75zm-1.75 3.062h-1.75V9.813h1.75zm-1.75 3.063h1.75v-1.313h-1.75zm5.25-3.063h-1.75V9.813h1.75zm-1.75 3.063h1.75v-1.313h-1.75z\" clip-rule=\"evenodd\"/>\n    <path fill=\"var(--text-color, #292a2e)\" d=\"M124.53 17.13q-.64 0-1.07-.21a2.3 2.3 0 0 1-.7-.53 3 3 0 0 1-.4-.61h-.1V17h-1.89V6.81h1.93v3.82h.07a3 3 0 0 1 .4-.61q.26-.32.69-.54t1.09-.22q.87 0 1.57.44.71.44 1.13 1.32.42.87.42 2.17 0 1.26-.41 2.15-.41.87-1.12 1.33a2.87 2.87 0 0 1-1.6.46m-.56-1.55q.57 0 .95-.31a1.9 1.9 0 0 0 .57-.85q.2-.54.2-1.23t-.2-1.22a1.8 1.8 0 0 0-.57-.83q-.38-.31-.95-.31-.55 0-.94.29-.38.29-.58.83-.2.53-.2 1.24t.2 1.25q.21.54.59.84.39.3.94.3m-9.65 1.52q-.79 0-1.39-.34a2.34 2.34 0 0 1-.92-.98q-.33-.65-.33-1.55V9.37h1.93v4.54q0 .75.38 1.16t1.05.42q.46 0 .81-.19a1.4 1.4 0 0 0 .55-.57q.2-.38.2-.9V9.38h1.93V17h-1.82l-.02-1.9h.12q-.31.98-.93 1.49t-1.56.51m-13.01-.1V6.81h1.96v4.16h4.58V6.81h1.97V17h-1.97v-4.39h-4.58V17zm-11.89 2.71.45-1.47.23.06q.41.11.73.06a.83.83 0 0 0 .52-.27q.2-.22.27-.62l.08-.44-2.88-7.67h2.04l1.34 4.05q.24.75.39 1.49.16.75.34 1.54h-.47l.37-1.54q.18-.75.43-1.49l1.4-4.05h2.02l-3.26 8.58q-.23.62-.59 1.06-.35.44-.88.68-.52.24-1.25.24-.4 0-.74-.06a2.5 2.5 0 0 1-.53-.14m-6.44-7.17V17h-1.93V9.36h1.82l.04 1.9h-.13q.31-.97.92-1.48.62-.51 1.57-.51.79 0 1.37.34.59.34.92.98t.33 1.55V17H86v-4.54q0-.74-.38-1.16t-1.05-.42q-.45 0-.81.2a1.34 1.34 0 0 0-.55.57q-.2.37-.2.9m-7.92 4.58a2.9 2.9 0 0 1-1.59-.46q-.7-.46-1.12-1.33-.41-.88-.41-2.15 0-1.29.42-2.17.42-.87 1.13-1.32a2.9 2.9 0 0 1 1.58-.44q.66 0 1.09.23.43.22.69.54t.4.61h.08V9.36h1.91V17h-1.9v-1.22h-.08a2.6 2.6 0 0 1-.41.61q-.27.32-.7.53t-1.08.21m.57-1.55q.55 0 .94-.3.38-.3.58-.84.21-.54.21-1.25 0-.72-.2-1.25t-.58-.83q-.38-.29-.94-.29-.57 0-.96.3a1.85 1.85 0 0 0-.58.83 3.6 3.6 0 0 0-.19 1.23q0 .69.2 1.23t.58.85q.39.31.95.31M63.5 19.86V9.36h1.89v1.28h.1q.14-.29.4-.61t.69-.54 1.09-.22q.87 0 1.57.44.71.44 1.13 1.32.42.87.42 2.17 0 1.26-.41 2.15-.41.87-1.12 1.33a2.87 2.87 0 0 1-1.6.46q-.64 0-1.07-.21a2.3 2.3 0 0 1-.7-.53 3 3 0 0 1-.4-.61h-.07v4.07zm3.61-4.28q.57 0 .95-.31t.57-.85q.2-.54.2-1.23t-.2-1.22a1.8 1.8 0 0 0-.57-.83q-.38-.31-.95-.31-.56 0-.94.29t-.58.83q-.2.53-.2 1.24t.2 1.25q.21.54.59.84.39.3.94.3M50.8 17V9.36h1.8l.08 1.87h-.14q.17-.7.51-1.13.35-.44.81-.64.47-.21.97-.21.83 0 1.33.52.51.52.73 1.57h-.22q.16-.71.55-1.18.39-.46.91-.69.53-.23 1.12-.23.69 0 1.24.3.56.3.87.88.32.58.32 1.42V17h-1.92v-4.82q0-.67-.37-1a1.32 1.32 0 0 0-.89-.32q-.4 0-.7.18a1.2 1.2 0 0 0-.46.49q-.16.32-.16.73V17h-1.87v-4.89q0-.57-.35-.91-.34-.34-.89-.34-.37 0-.68.17a1.2 1.2 0 0 0-.49.51q-.18.33-.18.81V17zm-5.18.15q-1.13 0-1.97-.49a3.3 3.3 0 0 1-1.28-1.38q-.45-.89-.45-2.06 0-1.18.45-2.07.45-.9 1.28-1.39t1.97-.49 1.96.49q.83.49 1.29 1.39.45.89.45 2.07t-.45 2.07-1.29 1.38q-.83.49-1.96.49m0-1.53q.58 0 .97-.31.39-.32.58-.87a3.7 3.7 0 0 0 .19-1.23 3.7 3.7 0 0 0-.19-1.23 1.87 1.87 0 0 0-.58-.86q-.39-.32-.97-.32t-.97.32q-.38.32-.58.86-.19.54-.19 1.23 0 .68.19 1.23.2.55.58.87.39.31.97.31m-9.25 1.51q-1.35 0-2.41-.62t-1.67-1.79-.61-2.82.62-2.82q.62-1.18 1.68-1.79 1.07-.62 2.4-.62.85 0 1.59.24.75.24 1.32.7t.94 1.12.49 1.51h-1.98a2.2 2.2 0 0 0-.28-.77 2 2 0 0 0-.51-.57q-.3-.24-.69-.36a2.8 2.8 0 0 0-.83-.12q-.81 0-1.43.41-.62.4-.97 1.18-.34.78-.34 1.89 0 1.13.35 1.91.35.77.96 1.17a2.6 2.6 0 0 0 1.43.4q.45 0 .83-.12.39-.12.7-.36.32-.24.52-.57.21-.34.29-.77h1.98q-.09.72-.43 1.36a4.2 4.2 0 0 1-.9 1.15 4.2 4.2 0 0 1-1.32.79q-.76.28-1.69.28\"/>\n</svg>\n";
function $50b8810a291d2f4a$export$1ab0976b9ea166ae(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Company Hub' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $e41bbd286dd6d71c$export$f827d3c5a9c3f644), {
        svg: $50b8810a291d2f4a$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e5ce5248a23a237688e2341559569305>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
var $e14115ed39115a71$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#94c748)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M12.75 7.877v-3.37l6.16-.007h.007a.59.59 0 0 1 .583.598v6.147h-3.366V7.877z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M12.75 14.615v-3.37h3.368v6.165a.59.59 0 0 1-.591.59H6.583A.59.59 0 0 1 6 17.402V8.467a.59.59 0 0 1 .591-.59h6.16v3.368H9.373v3.37z\"/>\n</svg>\n";
function $e14115ed39115a71$export$f7857fe64d7161d9(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Compass' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $ea406245305817b7$export$be58b4326e23250f), {
        svg: $e14115ed39115a71$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::bbcc7f43e0a51fb6caa253b27359fb22>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $2d1ebc110ee41c8a$var$svg = "<svg height=\"100%\" viewBox=\"0 0 162 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M161.79 21.16c0 2.55-1.66 4.48-5.76 4.48-2.3 0-4.17-.52-5.34-1.13v-2.79c1.32.77 3.53 1.5 5.46 1.5 2.02 0 3.07-.83 3.07-2.02 0-1.16-.89-1.84-3.8-2.55-3.4-.83-4.85-2.15-4.85-4.66 0-2.67 2.06-4.29 5.55-4.29 1.99 0 3.8.49 4.94 1.1v2.73c-1.84-.92-3.34-1.41-4.97-1.41-1.93 0-2.97.68-2.97 1.87 0 1.07.74 1.75 3.56 2.42 3.4.83 5.12 2.09 5.12 4.75m-13.63 0c0 2.55-1.66 4.48-5.76 4.48-2.3 0-4.17-.52-5.34-1.13v-2.79c1.32.77 3.53 1.5 5.46 1.5 2.02 0 3.07-.83 3.07-2.02 0-1.16-.89-1.84-3.8-2.55-3.4-.83-4.84-2.15-4.84-4.66 0-2.67 2.06-4.29 5.55-4.29 1.99 0 3.8.49 4.94 1.1v2.73c-1.84-.92-3.34-1.41-4.97-1.41-1.93 0-2.97.68-2.97 1.87 0 1.07.74 1.75 3.56 2.42 3.4.83 5.12 2.09 5.12 4.75m-25.9-3.49c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01v-2.7h2.64v15.33zm-16.09-7.66c0-3.68-1.47-5.52-4.2-5.52-2.36 0-4.48 1.5-4.48 4.91v1.23c0 3.4 1.93 4.91 4.17 4.91 2.98 0 4.51-1.96 4.51-5.52m-3.8 7.97c-2.24 0-3.96-1.01-4.88-3v8.68h-2.64V10h2.64v2.76c.98-2.02 2.82-3.07 5.18-3.07 4.08 0 6.13 3.47 6.13 7.97 0 4.32-2.15 7.97-6.44 7.97M89.5 16.81v8.53h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.51c.98-1.81 2.79-2.82 4.85-2.82 2.61 0 4.39 1.32 5.15 3.74.86-2.36 2.91-3.74 5.46-3.74 3.43 0 5.34 2.33 5.34 6.66v8.99h-2.64v-8.53c0-3.16-1.1-4.72-3.62-4.72-2.45 0-4.14 1.63-4.14 4.72m-23.34 8.83c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49m-9.23 9.63v2.67c-1.26.83-3.25 1.2-5.34 1.2-6.62 0-10.36-3.99-10.36-10.33 0-6.13 3.74-10.43 10.3-10.43 1.96 0 3.93.37 5.37 1.41v2.67c-1.44-.92-3.04-1.41-5.37-1.41-4.72 0-7.54 3.13-7.54 7.76s2.91 7.7 7.7 7.7c2.12 0 3.77-.49 5.24-1.23\"/>\n    <path fill=\"var(--tile-color,#94c748)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M16.69 15.16v4.24h-4.25v-4.24zv-4.24H8.93a.74.74 0 0 0-.74.74v11.25a.74.74 0 0 0 .74.75h11.26a.74.74 0 0 0 .75-.74v-7.76zm0-8.48v4.24h4.26v4.24h4.24V7.42a.74.74 0 0 0-.73-.75h-.01z\"/>\n</svg>\n";
function $2d1ebc110ee41c8a$export$a16f50a81d183ce(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Compass' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $e41bbd286dd6d71c$export$f827d3c5a9c3f644), {
        svg: $2d1ebc110ee41c8a$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::79151986eefb0d79ff7389ad5707c136>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
var $763361ebc176be58$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color, white)\" d=\"M6 .5h12A5.5 5.5 0 0 1 23.5 6v12a5.5 5.5 0 0 1-5.5 5.5H6A5.5 5.5 0 0 1 .5 18V6A5.5 5.5 0 0 1 6 .5\"/>\n    <path fill=\"none\" stroke=\"var(--border-color, #dddee1)\" d=\"M6 .5h12A5.5 5.5 0 0 1 23.5 6v12a5.5 5.5 0 0 1-5.5 5.5H6A5.5 5.5 0 0 1 .5 18V6A5.5 5.5 0 0 1 6 .5Z\"/>\n    <path fill=\"var(--icon-color, #1868db)\" d=\"M17.37 14.265c-3.704-1.79-4.785-2.058-6.346-2.058-1.83 0-3.391.761-4.785 2.902l-.229.35c-.187.288-.229.39-.229.514s.063.227.292.37l2.35 1.462c.125.083.23.124.333.124.125 0 .208-.062.333-.247l.375-.577c.582-.885 1.102-1.173 1.768-1.173.583 0 1.27.165 2.122.577l2.455 1.152c.25.124.52.062.645-.226l1.165-2.552c.125-.289.042-.474-.25-.618M6.572 9.757c3.703 1.791 4.785 2.059 6.346 2.059 1.83 0 3.39-.762 4.785-2.902l.229-.35c.187-.288.228-.391.228-.515 0-.123-.062-.226-.29-.37l-2.352-1.462c-.125-.082-.229-.123-.333-.123-.125 0-.208.061-.333.247l-.374.576c-.583.885-1.103 1.173-1.769 1.173-.582 0-1.269-.164-2.122-.576L8.132 6.361c-.25-.123-.52-.061-.645.227L6.322 9.14c-.125.288-.041.473.25.617\"/>\n</svg>\n";
function $763361ebc176be58$export$53305f1f2855d3be(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Confluence Data Center' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $ea406245305817b7$export$be58b4326e23250f), {
        svg: $763361ebc176be58$var$svg,
        label: label,
        type: "data-center",
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b0ac4de94f42b3a4050a935e411c6789>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $5cb9c7f1699f35d1$var$svg = "<svg height=\"100%\" viewBox=\"0 0 188 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M181.16 12.09c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.2c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-15.1-2.16v2.36c-.92.49-2.33.71-3.74.71-5.46 0-8-3.31-8-8 0-4.63 2.55-7.94 8-7.94 1.38 0 2.45.18 3.65.74v2.45c-.98-.46-2.02-.74-3.47-.74-3.99 0-5.61 2.51-5.61 5.49s1.66 5.49 5.67 5.49c1.56 0 2.55-.21 3.5-.55m-14.5-6.23v8.99h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 3.53 0 5.55 2.42 5.55 6.66m-22.92-4.27c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-29.1-5.74V10h2.64v9.26c0 2.76 1.1 3.99 3.62 3.99 2.45 0 4.14-1.62 4.14-4.72V10h2.64v15.33h-2.64v-2.51c-.98 1.81-2.79 2.82-4.85 2.82-3.53 0-5.55-2.42-5.55-6.65m-2.23 6.31c-.21.06-.67.12-1.35.12-2.51 0-4.11-1.2-4.11-4.02V3.59h2.64V21.1c0 1.38.92 1.87 2.06 1.87.28 0 .46 0 .77-.03zM96.82 8.38V10h3.96v2.45h-3.96v12.88h-2.58V12.45h-2.48V10h2.48V8.31c0-2.85 1.59-4.78 4.88-4.78.8 0 1.32.12 1.78.25V6.2a8.7 8.7 0 0 0-1.66-.15c-1.62 0-2.42.95-2.42 2.33m-7.32 7.97v8.99h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 3.53 0 5.55 2.42 5.55 6.66m-23.34 9.28c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49m-9.23 9.63v2.67c-1.26.83-3.25 1.2-5.34 1.2-6.62 0-10.36-3.99-10.36-10.33 0-6.13 3.74-10.43 10.3-10.43 1.96 0 3.93.37 5.37 1.41v2.67c-1.44-.92-3.04-1.41-5.37-1.41-4.72 0-7.54 3.13-7.54 7.76s2.91 7.7 7.7 7.7c2.12 0 3.77-.49 5.24-1.23\"/>\n    <path fill=\"var(--tile-color, white)\" d=\"M8 .667h16A7.333 7.333 0 0 1 31.333 8v16A7.333 7.333 0 0 1 24 31.333H8A7.333 7.333 0 0 1 .667 24V8A7.333 7.333 0 0 1 8 .667\"/>\n    <path fill=\"none\" stroke=\"var(--border-color, #dddee1)\" stroke-width=\"1.333\" d=\"M8 .667h16A7.333 7.333 0 0 1 31.333 8v16A7.333 7.333 0 0 1 24 31.333H8A7.333 7.333 0 0 1 .667 24V8A7.333 7.333 0 0 1 8 .667Z\"/>\n    <path fill=\"var(--icon-color, #1868db)\" d=\"M23.16 19.02c-4.938-2.387-6.38-2.744-8.461-2.744-2.441 0-4.522 1.015-6.38 3.87l-.306.466c-.25.384-.305.521-.305.686s.084.302.389.494l3.134 1.948c.167.11.306.165.444.165.167 0 .278-.082.444-.33l.5-.768c.776-1.18 1.47-1.564 2.357-1.564.777 0 1.693.22 2.83.768l3.273 1.537c.333.165.694.083.86-.302l1.554-3.403c.166-.384.055-.63-.333-.823M8.762 13.01c4.938 2.388 6.38 2.744 8.461 2.744 2.441 0 4.522-1.015 6.38-3.87l.306-.466c.25-.384.305-.521.305-.686 0-.164-.083-.302-.388-.494L20.69 8.29c-.167-.11-.305-.165-.444-.165-.166 0-.277.082-.444.33l-.5.768c-.776 1.18-1.47 1.564-2.357 1.564-.777 0-1.692-.22-2.83-.768l-3.273-1.537c-.333-.165-.694-.083-.86.302L8.43 12.187c-.167.384-.056.63.332.823\"/>\n</svg>\n";
function $5cb9c7f1699f35d1$export$b3e508cb103e1f93(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Confluence Data Center' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $e41bbd286dd6d71c$export$f827d3c5a9c3f644), {
        svg: $5cb9c7f1699f35d1$var$svg,
        label: label,
        type: "data-center",
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2264fa822c5f74cedf4229a8911c73b4>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
var $c187de04d1151cf2$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#1868db)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, white)\" d=\"M17.888 14.461c-4.039-1.953-5.219-2.245-6.92-2.245-1.997 0-3.699.831-5.219 3.165l-.25.382c-.204.314-.249.426-.249.561s.068.247.318.404l2.564 1.594c.136.09.25.135.363.135.136 0 .226-.068.363-.27l.408-.628c.635-.966 1.203-1.28 1.928-1.28.636 0 1.385.18 2.315.629l2.677 1.257c.272.134.567.067.704-.247l1.27-2.783c.136-.315.046-.517-.272-.674M6.112 9.545c4.039 1.953 5.219 2.245 6.92 2.245 1.997 0 3.699-.83 5.219-3.165l.25-.381c.204-.315.249-.427.249-.562 0-.134-.068-.247-.318-.404L15.87 5.685c-.137-.09-.25-.135-.364-.135-.136 0-.226.067-.363.27l-.408.628c-.635.965-1.203 1.28-1.928 1.28-.636 0-1.385-.18-2.315-.63L7.814 5.843c-.272-.135-.567-.068-.703.247L5.84 8.872c-.136.314-.045.516.272.673\"/>\n</svg>\n";
var $c187de04d1151cf2$var$customThemeSvg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--themed-icon-color, currentcolor)\" d=\"M18 0a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6V6a6 6 0 0 1 6-6zm-7.032 12.217c-1.997 0-3.699.83-5.219 3.165l-.249.38c-.204.315-.25.427-.25.562s.068.247.317.404l2.565 1.594c.136.09.249.135.362.135.136 0 .227-.068.363-.27l.409-.628c.635-.966 1.202-1.28 1.928-1.28.636 0 1.384.18 2.315.63l2.677 1.256c.273.134.568.067.704-.247l1.27-2.783c.136-.315.045-.517-.272-.674-4.039-1.953-5.219-2.244-6.92-2.244m4.538-6.667c-.136 0-.227.067-.363.27l-.409.628c-.635.965-1.202 1.28-1.928 1.28-.636 0-1.384-.18-2.315-.63L7.813 5.843c-.272-.135-.567-.067-.703.247L5.84 8.872c-.136.314-.045.517.272.674 4.039 1.953 5.219 2.244 6.92 2.244 1.997 0 3.699-.83 5.219-3.165l.249-.382c.204-.314.25-.426.25-.56s-.068-.248-.317-.405l-2.565-1.593c-.136-.09-.249-.135-.362-.135\"/>\n</svg>\n";
function $c187de04d1151cf2$export$68f3db7f6af48bcb(_ref) {
    var iconColor = _ref.iconColor, size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Confluence' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $ea406245305817b7$export$be58b4326e23250f), {
        svg: $c187de04d1151cf2$var$svg,
        customThemeSvg: $c187de04d1151cf2$var$customThemeSvg,
        iconColor: iconColor,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::90f8012e577da50adfff14718da1e4b3>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $340ac1500a67e4aa$var$svg = "<svg height=\"100%\" viewBox=\"0 0 188 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M181.16 12.09c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.2c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-15.1-2.16v2.36c-.92.49-2.33.71-3.74.71-5.46 0-8-3.31-8-8 0-4.63 2.55-7.94 8-7.94 1.38 0 2.45.18 3.65.74v2.45c-.98-.46-2.02-.74-3.46-.74-3.99 0-5.61 2.51-5.61 5.49s1.66 5.49 5.67 5.49c1.56 0 2.55-.21 3.5-.55m-14.51-6.23v8.99h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 3.53 0 5.55 2.42 5.55 6.66m-22.92-4.27c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-29.1-5.74V10h2.64v9.26c0 2.76 1.1 3.99 3.62 3.99 2.45 0 4.14-1.62 4.14-4.72V10h2.64v15.33h-2.64v-2.51c-.98 1.81-2.79 2.82-4.84 2.82-3.53 0-5.55-2.42-5.55-6.65m-2.24 6.31c-.21.06-.67.12-1.35.12-2.51 0-4.11-1.19-4.11-4.02V3.59h2.64V21.1c0 1.38.92 1.87 2.06 1.87.28 0 .46 0 .77-.03zM96.82 8.38V10h3.96v2.45h-3.96v12.88h-2.58V12.45h-2.48V10h2.48V8.31c0-2.85 1.59-4.78 4.88-4.78.8 0 1.32.12 1.78.25V6.2a8.7 8.7 0 0 0-1.66-.15c-1.62 0-2.42.95-2.42 2.33m-7.32 7.97v8.99h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 3.53 0 5.55 2.42 5.55 6.66m-23.34 9.28c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49m-9.23 9.63v2.67c-1.26.83-3.25 1.2-5.34 1.2-6.62 0-10.36-3.99-10.36-10.33 0-6.13 3.74-10.43 10.3-10.43 1.96 0 3.93.37 5.37 1.41v2.67c-1.44-.92-3.04-1.41-5.37-1.41-4.72 0-7.54 3.13-7.54 7.76s2.91 7.7 7.7 7.7c2.12 0 3.77-.49 5.24-1.23\"/>\n    <path fill=\"var(--tile-color,#1868db)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, white)\" d=\"M23.16 19.02c-4.938-2.387-6.38-2.744-8.461-2.744-2.442 0-4.522 1.015-6.38 3.87l-.306.466c-.25.384-.305.521-.305.686s.083.302.388.494l3.135 1.948c.167.11.305.165.444.165.166 0 .277-.082.444-.33l.5-.768c.776-1.18 1.47-1.564 2.357-1.564.777 0 1.692.22 2.83.768l3.273 1.537c.333.165.693.083.86-.302l1.553-3.403c.167-.384.056-.63-.333-.823M8.761 13.01c4.938 2.388 6.38 2.744 8.461 2.744 2.441 0 4.522-1.015 6.38-3.87l.305-.466c.25-.384.305-.521.305-.686 0-.164-.083-.302-.388-.494L20.691 8.29c-.167-.11-.306-.165-.444-.165-.167 0-.278.082-.444.33l-.5.768c-.776 1.18-1.47 1.564-2.357 1.564-.777 0-1.693-.22-2.83-.768l-3.273-1.537c-.333-.165-.694-.083-.86.302l-1.554 3.403c-.166.384-.055.63.333.823\"/>\n</svg>\n";
function $340ac1500a67e4aa$export$a88b0b0da9ef63ce(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Confluence' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $e41bbd286dd6d71c$export$f827d3c5a9c3f644), {
        svg: $340ac1500a67e4aa$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d471014cf3c5b11585548418a230239b>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
var $4adf67e057567a89$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color, white)\" d=\"M6 .5h12A5.5 5.5 0 0 1 23.5 6v12a5.5 5.5 0 0 1-5.5 5.5H6A5.5 5.5 0 0 1 .5 18V6A5.5 5.5 0 0 1 6 .5\"/>\n    <path fill=\"none\" stroke=\"var(--border-color, #dddee1)\" d=\"M6 .5h12A5.5 5.5 0 0 1 23.5 6v12a5.5 5.5 0 0 1-5.5 5.5H6A5.5 5.5 0 0 1 .5 18V6A5.5 5.5 0 0 1 6 .5Z\"/>\n    <path fill=\"var(--icon-color, #1868db)\" d=\"M18.71 7.463 12 4.993l-6.71 2.47a.44.44 0 0 0-.29.433l.14 3.807c.103 3.148 1.684 5.489 4.163 7.018a.446.446 0 0 0 .646-.204l1.445-3.412a.22.22 0 0 0-.14-.298 2.585 2.585 0 1 1 1.492 0 .22.22 0 0 0-.14.298l1.446 3.412a.446.446 0 0 0 .645.204c2.48-1.529 4.06-3.87 4.163-7.018L19 7.896a.44.44 0 0 0-.29-.433\"/>\n</svg>\n";
function $4adf67e057567a89$export$eaf73f391f7103bd(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Crowd' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $ea406245305817b7$export$be58b4326e23250f), {
        svg: $4adf67e057567a89$var$svg,
        label: label,
        type: "data-center",
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::13d7df881302adff1c5de7157bb4b9bb>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $2168c7de1a871d93$var$svg = "<svg height=\"100%\" viewBox=\"0 0 126 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M113.97 17.67c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V3.59h2.64v21.74zm-17.72 0h-3.37l-2.64-7.42-1.41-4.72-1.41 4.72-2.64 7.42h-3.37L84.45 10h2.91l4.42 13 4.48-13h2.51l4.48 13 4.41-13h2.91zm-28.47.31c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49m-13.77 4.14v9.05h-2.58V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.68-5.43 3.93m-5.76 5.48v2.67c-1.26.83-3.25 1.2-5.34 1.2-6.62 0-10.36-3.99-10.36-10.33 0-6.13 3.74-10.43 10.3-10.43 1.96 0 3.93.37 5.37 1.41v2.67c-1.44-.92-3.04-1.41-5.37-1.41-4.72 0-7.54 3.13-7.54 7.76s2.91 7.7 7.7 7.7c2.12 0 3.77-.49 5.24-1.23\"/>\n    <path fill=\"var(--tile-color, white)\" d=\"M8 .667h16A7.333 7.333 0 0 1 31.333 8v16A7.333 7.333 0 0 1 24 31.333H8A7.333 7.333 0 0 1 .667 24V8A7.333 7.333 0 0 1 8 .667\"/>\n    <path fill=\"none\" stroke=\"var(--border-color, #dddee1)\" stroke-width=\"1.333\" d=\"M8 .667h16A7.333 7.333 0 0 1 31.333 8v16A7.333 7.333 0 0 1 24 31.333H8A7.333 7.333 0 0 1 .667 24V8A7.333 7.333 0 0 1 8 .667Z\"/>\n    <path fill=\"var(--icon-color, #1868db)\" d=\"M24.946 9.951 16 6.657 7.054 9.95a.59.59 0 0 0-.387.577l.187 5.076c.137 4.197 2.245 7.319 5.55 9.357.31.19.719.063.86-.272l1.928-4.55a.294.294 0 0 0-.185-.396 3.447 3.447 0 1 1 1.987 0 .294.294 0 0 0-.185.397l1.927 4.549c.142.335.55.463.86.272 3.305-2.038 5.413-5.16 5.55-9.357l.187-5.076a.59.59 0 0 0-.387-.577\"/>\n</svg>\n";
function $2168c7de1a871d93$export$3c371bdbcdfcdce(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Crowd' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $e41bbd286dd6d71c$export$f827d3c5a9c3f644), {
        svg: $2168c7de1a871d93$var$svg,
        label: label,
        type: "data-center",
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6a1acdf5e3aacf1ac91c03f0f8d3dcf4>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
var $2849aa7d84d6b6ae$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, #101214)\" fill-rule=\"evenodd\" d=\"M19 12a7 7 0 1 0-14 0 7 7 0 0 0 14 0m-9.37 4.625.026.074a5.26 5.26 0 0 1-2.833-3.824h2.136c.069 1.426.306 2.73.67 3.75m1.08-3.75c.068 1.255.278 2.353.567 3.162.179.5.37.841.54 1.042a.6.6 0 0 0 .183.165.7.7 0 0 0 .183-.165c.17-.2.361-.543.54-1.042.288-.809.498-1.907.566-3.162zm2.58-1.75h-2.58c.068-1.255.278-2.353.567-3.162.179-.5.37-.841.54-1.042A.7.7 0 0 1 12 6.756a.6.6 0 0 1 .183.165c.17.2.361.543.54 1.042.288.809.498 1.907.566 3.162m1.751 1.75c-.069 1.426-.306 2.73-.67 3.75l-.027.074a5.26 5.26 0 0 0 2.833-3.824zm2.136-1.75H15.04c-.069-1.426-.306-2.73-.67-3.75l-.027-.074a5.26 5.26 0 0 1 2.833 3.824m-8.218 0H6.823a5.26 5.26 0 0 1 2.833-3.824l-.027.074c-.364 1.02-.601 2.324-.67 3.75\" clip-rule=\"evenodd\"/>\n</svg>\n";
function $2849aa7d84d6b6ae$export$5efe8561ca252843(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Custom Link' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $ea406245305817b7$export$be58b4326e23250f), {
        svg: $2849aa7d84d6b6ae$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::adde776e49635255fd9de5c803442f95>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
var $b23ffead7b9336b3$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#ffc716)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M16.43 17.42A6.97 6.97 0 0 1 12 19H6.4v-.47l3.84-3.78a3.25 3.25 0 0 0 1.76.52c.65 0 1.25-.19 1.76-.51zm.99-.99A6.97 6.97 0 0 0 19 12a6.97 6.97 0 0 0-1.58-4.43l-2.67 2.67c.33.51.52 1.11.52 1.76s-.19 1.25-.51 1.76zm-.99-9.85-2.67 2.67A3.25 3.25 0 0 0 12 8.73c-.65 0-1.25.19-1.76.52L7.57 6.58A6.97 6.97 0 0 1 12 5c1.68 0 3.22.59 4.43 1.58m-9.85.99A6.97 6.97 0 0 0 5 12c0 1.68.59 3.22 1.58 4.43l2.67-2.67A3.25 3.25 0 0 1 8.73 12c0-.65.19-1.25.52-1.76z\"/>\n</svg>\n";
var $b23ffead7b9336b3$var$customThemeSvg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--themed-icon-color, currentcolor)\" d=\"M18 0a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6V6a6 6 0 0 1 6-6zm-4.238 14.751a3.25 3.25 0 0 1-1.762.516 3.25 3.25 0 0 1-1.762-.515L6.4 18.533V19H12a6.97 6.97 0 0 0 4.43-1.58zM6.58 7.571A6.97 6.97 0 0 0 5 12a6.97 6.97 0 0 0 1.58 4.43l2.669-2.668A3.25 3.25 0 0 1 8.733 12c0-.649.19-1.253.516-1.762zm8.172 2.667c.326.508.515 1.113.515 1.762s-.189 1.254-.515 1.762l2.668 2.668A6.97 6.97 0 0 0 19 12a6.97 6.97 0 0 0-1.58-4.43zM12 5a6.97 6.97 0 0 0-4.43 1.58l2.668 2.668A3.25 3.25 0 0 1 12 8.733c.649 0 1.253.19 1.762.516L16.43 6.58A6.97 6.97 0 0 0 12 5\"/>\n</svg>\n";
function $b23ffead7b9336b3$export$6da5aa77c402ba0f(_ref) {
    var iconColor = _ref.iconColor, size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Customer Service Management' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $ea406245305817b7$export$be58b4326e23250f), {
        svg: $b23ffead7b9336b3$var$svg,
        customThemeSvg: $b23ffead7b9336b3$var$customThemeSvg,
        iconColor: iconColor,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e95354b27dc93f4ad2578de274aa63f2>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $7df20a17e30779c9$var$svg = "<svg height=\"100%\" viewBox=\"0 0 456 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M451.86 20.58c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55c-.46.12-.98.25-1.78.25-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zm-7.33-4.23v8.99h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 3.53 0 5.55 2.42 5.55 6.66m-22.92-4.27c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-26.16-7.92v8.53h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 2.61 0 4.39 1.32 5.15 3.74.86-2.36 2.91-3.74 5.46-3.74 3.44 0 5.34 2.33 5.34 6.66v8.99h-2.64v-8.52c0-3.16-1.1-4.72-3.62-4.72-2.45 0-4.14 1.63-4.14 4.72m-22.92-4.74c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-18.64-.62v-1.53c-.98 2.02-2.82 3.07-5.18 3.07-4.05 0-6.07-3.46-6.07-7.97 0-4.32 2.12-7.97 6.38-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.58v13.95c0 4.51-2.12 7.54-7.6 7.54-2.58 0-3.99-.34-5.46-.83v-2.58c1.69.55 3.44.92 5.34.92 3.83 0 5.15-2.05 5.15-4.91m-8.68-6.44c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m-16.96.03c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-14.08-8.98v8.99h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 3.53 0 5.55 2.42 5.55 6.66m-28.33 1.31c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-31.44-11.01-2.76-7.48v18.49h-2.76V5.19h4.78l4.57 11.56 1.87 5.55 1.87-5.55 4.6-11.56h4.45v20.15h-2.76V7.06l-2.36 7.27-4.45 11.01h-2.67zm-21.51-2.23c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-15.1-2.16v2.36c-.92.49-2.33.71-3.74.71-5.46 0-8-3.31-8-8 0-4.63 2.55-7.94 8-7.94 1.38 0 2.45.18 3.65.74v2.45c-.98-.46-2.02-.74-3.47-.74-3.99 0-5.61 2.51-5.61 5.49s1.66 5.49 5.67 5.49c1.56 0 2.55-.21 3.5-.55M234.91 5.95c0-1.16.77-1.84 1.84-1.84s1.84.68 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zm-8.24 0h-3.53L217.69 10h2.76l4.97 13.09L230.36 10h2.76zm-15.45-9.04v9.05h-2.58V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.68-5.43 3.93m-12.46-4.21c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.05 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-15.33-4.95c0 3.5-2.08 5.86-7.08 5.86-3.89 0-5.7-.77-7.27-1.56v-2.82c1.87.98 4.75 1.69 7.42 1.69 3.04 0 4.17-1.2 4.17-2.97 0-1.78-1.1-2.73-4.94-3.65-4.54-1.1-6.56-2.67-6.56-5.98 0-3.13 2.39-5.46 7.08-5.46 2.91 0 4.78.71 6.16 1.47v2.76c-2.02-1.16-4.2-1.53-6.29-1.53-2.64 0-4.2.92-4.2 2.76 0 1.66 1.29 2.48 4.85 3.37 4.26 1.07 6.65 2.45 6.65 6.07m-26.4-3.5v9.05h-2.58V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.68-5.43 3.93m-12.46-4.21c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2H146.5c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-26.15-7.92v8.53h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 2.61 0 4.39 1.32 5.15 3.74.86-2.36 2.91-3.74 5.46-3.74 3.44 0 5.34 2.33 5.34 6.66v8.99h-2.64v-8.52c0-3.16-1.1-4.72-3.62-4.72-2.45 0-4.14 1.63-4.14 4.72m-23.34 8.81c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49M94.1 20.58c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55a6.3 6.3 0 0 1-1.78.25c-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45H94.1zm-6.7.58c0 2.55-1.66 4.48-5.77 4.48-2.3 0-4.17-.52-5.34-1.13v-2.79c1.32.77 3.53 1.5 5.46 1.5 2.02 0 3.07-.83 3.07-2.02 0-1.16-.89-1.84-3.8-2.54-3.4-.83-4.84-2.15-4.84-4.66 0-2.67 2.05-4.29 5.55-4.29 1.99 0 3.8.49 4.94 1.1v2.73c-1.84-.92-3.34-1.41-4.97-1.41-1.93 0-2.97.68-2.97 1.87 0 1.07.74 1.75 3.56 2.42 3.4.83 5.12 2.09 5.12 4.75m-27.6-2.18V10h2.64v9.26c0 2.76 1.1 3.99 3.62 3.99 2.45 0 4.14-1.63 4.14-4.72V10h2.64v15.33h-2.64v-2.51c-.98 1.81-2.79 2.82-4.84 2.82-3.53 0-5.55-2.42-5.55-6.65m-2.89 2.79v2.67c-1.26.83-3.25 1.2-5.34 1.2-6.62 0-10.36-3.99-10.36-10.33 0-6.13 3.74-10.43 10.3-10.43 1.96 0 3.93.37 5.37 1.41v2.67c-1.44-.92-3.04-1.41-5.37-1.41-4.72 0-7.54 3.13-7.54 7.76s2.91 7.7 7.7 7.7c2.12 0 3.77-.49 5.24-1.23\"/>\n    <path fill=\"var(--tile-color,#ffc716)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M21.91 23.23a9.3 9.3 0 0 1-5.91 2.1H8.53v-.62l5.12-5.04a4.34 4.34 0 0 0 2.35.69c.86 0 1.67-.25 2.35-.69zm1.32-1.32a9.3 9.3 0 0 0 2.1-5.91c0-2.24-.79-4.3-2.11-5.91l-3.56 3.56c.43.68.69 1.48.69 2.35s-.25 1.67-.69 2.35zM21.91 8.77l-3.56 3.56a4.34 4.34 0 0 0-2.35-.69c-.86 0-1.67.25-2.35.69l-3.56-3.56A9.3 9.3 0 0 1 16 6.67c2.24 0 4.3.79 5.91 2.11M8.77 10.09A9.3 9.3 0 0 0 6.67 16c0 2.24.79 4.3 2.11 5.91l3.56-3.56a4.34 4.34 0 0 1-.69-2.35c0-.86.25-1.67.69-2.35z\"/>\n</svg>\n";
function $7df20a17e30779c9$export$f597f0f7fadce0b9(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Customer Service Management' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $e41bbd286dd6d71c$export$f827d3c5a9c3f644), {
        svg: $7df20a17e30779c9$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::772abda1b80977ea1535de7e3f60e0fa>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
var $24e0920c6d566bcc$var$svg = "<svg height=\"100%\" viewBox=\"0 0 48 48\">\n    <path fill=\"var(--tile-color,#94c748)\" d=\"M0 12C0 5.373 5.373 0 12 0h24c6.627 0 12 5.373 12 12v24c0 6.627-5.373 12-12 12H12C5.373 48 0 42.627 0 36z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"m36.22 26.75 4.9 7.25h-4.78c-.52-.6-1.02-1.31-1.47-1.98-.68-1.02-.68-2.41.03-3.41zm-7.3-5.5L24.02 14h4.78c.52.6 1.02 1.31 1.47 1.98.68 1.02.68 2.41-.02 3.41zm6.98-6.02c.5-.84 1.07-1.16 1.95-1.16l3.9-.07-12.68 19.27a1.46 1.46 0 0 1-1.22.67H23.6c4.07-6.25 8.37-12.37 12.31-18.7M8 33.94h6.89c6.16 0 9.92-3.88 9.92-9.94s-3.76-9.94-9.92-9.94H8l4.28 3.9h-1.76C9.13 17.96 8 19.12 8 20.55v13.38m4.41-3.9V17.96h2.46c3.52 0 5.49 2.38 5.49 6.04 0 3.65-1.97 6.04-5.46 6.04z\"/>\n</svg>\n";
function $24e0920c6d566bcc$export$9951d02c2d848122(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Dx' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $ea406245305817b7$export$be58b4326e23250f), {
        svg: $24e0920c6d566bcc$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2b7db25f7017f6ec5d21f0ae31065359>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
var $37ce8314fa16f648$var$svg = "<svg height=\"100%\" viewBox=\"0 0 48 48\">\n    <rect width=\"48\" height=\"48\" fill=\"var(--tile-color,#c97cf4)\" rx=\"12\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M20 19h5v11h-5zm7-9h5v28h-5zm7 6h5v16h-5zm-21 0h5v16h-5zm-7 5h5v7H6z\"/>\n</svg>\n";
function $37ce8314fa16f648$export$34420f0520b19b1d(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Feedback' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $ea406245305817b7$export$be58b4326e23250f), {
        svg: $37ce8314fa16f648$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::fe7d010e7776c61d1ffb49fef9c7dd61>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $c3380cdd733c29de$var$svg = "<svg height=\"100%\" viewBox=\"0 0 169 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M157.894 25.334h-2.638V3.59h2.638v13.585L164.487 10h3.435l-7.207 7.544 7.513 7.79h-3.588l-6.746-7.177zm-5.648-2.761v2.362c-.92.49-2.331.705-3.742.705-5.458 0-8.004-3.312-8.004-8.004 0-4.63 2.546-7.943 8.004-7.943 1.38 0 2.454.184 3.65.736v2.454c-.982-.46-2.024-.736-3.466-.736-3.986 0-5.612 2.514-5.612 5.489s1.656 5.49 5.674 5.49c1.564 0 2.545-.215 3.496-.553m-26.118-4.906c0 3.68 1.472 5.52 4.201 5.52 2.361 0 4.477-1.503 4.477-4.907v-1.227c0-3.404-1.932-4.906-4.17-4.906-2.975 0-4.508 1.962-4.508 5.52m8.678 7.666v-2.76c-.981 2.024-2.821 3.067-5.182 3.067-4.079 0-6.134-3.465-6.134-7.973 0-4.324 2.147-7.974 6.44-7.974 2.239 0 3.956 1.012 4.876 3.006V10h2.638v15.333zm-16.09-7.666c0-3.68-1.472-5.52-4.201-5.52-2.362 0-4.478 1.502-4.478 4.906v1.227c0 3.404 1.932 4.907 4.171 4.907 2.975 0 4.508-1.963 4.508-5.52m-3.803 7.973c-2.238 0-3.956-1.012-4.876-3.005v2.698H107.4V3.592h2.637v9.17c.982-2.025 2.822-3.068 5.183-3.068 4.079 0 6.133 3.466 6.133 7.974 0 4.324-2.146 7.973-6.44 7.973m-22.806-7.974c0 3.68 1.472 5.52 4.2 5.52 2.362 0 4.478-1.503 4.478-4.907v-1.227c0-3.404-1.932-4.906-4.17-4.906-2.975 0-4.508 1.963-4.508 5.52m8.678 7.666v-2.76c-.981 2.024-2.821 3.067-5.182 3.067-4.08 0-6.134-3.465-6.134-7.973 0-4.324 2.147-7.974 6.44-7.974 2.239 0 3.956 1.013 4.876 3.006V3.59h2.638v21.743zM80.502 12.085c-2.79 0-4.201 1.81-4.477 4.478h8.555c-.153-2.852-1.44-4.478-4.078-4.478M86.39 24.72c-1.258.675-3.19.92-4.754.92-5.734 0-8.249-3.312-8.249-8.004 0-4.63 2.576-7.943 7.237-7.943 4.723 0 6.625 3.282 6.625 7.943v1.196H76.055c.368 2.607 2.055 4.293 5.673 4.293 1.78 0 3.282-.337 4.662-.828zM64.42 12.085c-2.79 0-4.202 1.81-4.477 4.478h8.556c-.154-2.852-1.442-4.478-4.08-4.478m5.888 12.635c-1.258.675-3.19.92-4.754.92-5.734 0-8.249-3.312-8.249-8.004 0-4.63 2.576-7.943 7.238-7.943 4.722 0 6.623 3.282 6.623 7.943v1.196H59.974c.368 2.607 2.055 4.293 5.674 4.293 1.778 0 3.28-.337 4.66-.828zm-15.679-6.9H45.49v7.514h-2.76V5.186h12.94v2.637H45.49v7.36h9.138z\"/>\n    <rect width=\"32\" height=\"32\" fill=\"var(--tile-color,#c97cf4)\" rx=\"8\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M13.333 12.667h3.334V20h-3.334zm4.667-6h3.333v18.666H18zm4.667 4H26v10.666h-3.333zm-14 0H12v10.666H8.667zM4 14h3.333v4.666H4z\"/>\n</svg>\n";
function $c3380cdd733c29de$export$bbccafb125ebd50c(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Feedback' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $e41bbd286dd6d71c$export$f827d3c5a9c3f644), {
        svg: $c3380cdd733c29de$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c86bc4a90f7eb35fd36ae7c99f20011b>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
var $7ea5c20c74834294$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#fb9700)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M20.84 12.21a4.29 4.29 0 0 0-6.05 0l-1.394 1.393c-.77.769-2.02.769-2.789 0L9.45 12.445 6.424 15.47l1.158 1.158a6.25 6.25 0 0 0 8.838 0zm-17.68-.418a4.253 4.253 0 0 0 6.034.017l1.412-1.412a1.973 1.973 0 0 1 2.788 0l1.158 1.158 3.026-3.025-1.158-1.158a6.25 6.25 0 0 0-8.838 0l-4.42 4.419z\"/>\n</svg>\n";
function $7ea5c20c74834294$export$1e02e7298035a77c(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Focus' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $ea406245305817b7$export$be58b4326e23250f), {
        svg: $7ea5c20c74834294$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::7aca4717e5f7edbaa74141430c7d1f8d>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $9560cc7a04e1393c$var$svg = "<svg height=\"100%\" viewBox=\"0 0 117 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M116.03 21.16c0 2.55-1.66 4.48-5.76 4.48-2.3 0-4.17-.52-5.34-1.13v-2.79c1.32.77 3.53 1.5 5.46 1.5 2.02 0 3.07-.83 3.07-2.02 0-1.16-.89-1.84-3.8-2.54-3.4-.83-4.85-2.15-4.85-4.66 0-2.67 2.06-4.29 5.55-4.29 1.99 0 3.8.49 4.94 1.1v2.73c-1.84-.92-3.34-1.41-4.97-1.41-1.93 0-2.97.68-2.97 1.87 0 1.07.74 1.75 3.56 2.42 3.4.83 5.12 2.09 5.12 4.75m-27.6-2.18V10h2.64v9.26c0 2.76 1.1 3.99 3.62 3.99 2.45 0 4.14-1.62 4.14-4.72V10h2.64v15.33h-2.64v-2.51c-.98 1.81-2.79 2.82-4.85 2.82-3.53 0-5.55-2.42-5.55-6.65m-2.71 3.58v2.36c-.92.49-2.33.71-3.74.71-5.46 0-8-3.31-8-8 0-4.63 2.55-7.94 8-7.94 1.38 0 2.45.18 3.65.74v2.45c-.98-.46-2.02-.74-3.47-.74-3.99 0-5.61 2.51-5.61 5.49s1.66 5.49 5.67 5.49c1.56 0 2.55-.21 3.5-.55M64.6 25.64c-4.6 0-7.3-3.4-7.3-8S60 9.7 64.6 9.7c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49m-9.97 5.67h-9.14v7.51h-2.76V5.19h12.94v2.64H45.49v7.36h9.14z\"/>\n    <path fill=\"var(--tile-color,#fb9700)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M27.607 16.272c-2.176-2.176-5.712-2.152-7.865 0l-1.812 1.812c-1 1-2.625 1-3.625 0L12.8 16.578l-3.933 3.934 1.505 1.505a8.126 8.126 0 0 0 11.49 0zm-22.982-.541c2.176 2.175 5.668 2.196 7.844.02l1.834-1.834c1-1 2.625-1 3.625 0l1.505 1.505 3.934-3.933-1.505-1.505a8.126 8.126 0 0 0-11.49 0l-5.745 5.745z\"/>\n</svg>\n";
function $9560cc7a04e1393c$export$3a6e8b37e069a69d(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Focus' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $e41bbd286dd6d71c$export$f827d3c5a9c3f644), {
        svg: $9560cc7a04e1393c$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::02833d9738a6774113f222b59b2a94ce>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
var $4f908832c395be7c$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M14.352 12a2.352 2.352 0 1 1-4.704 0 2.352 2.352 0 0 1 4.704 0\"/>\n    <path fill=\"var(--icon-color, #101214)\" fill-rule=\"evenodd\" d=\"M12 18.563a6.562 6.562 0 1 0 0-13.125 6.562 6.562 0 0 0 0 13.125M16.102 12a4.102 4.102 0 1 1-8.204 0 4.102 4.102 0 0 1 8.204 0\" clip-rule=\"evenodd\"/>\n</svg>\n";
function $4f908832c395be7c$export$9eb74917ea768ed4(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Goals' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $ea406245305817b7$export$be58b4326e23250f), {
        svg: $4f908832c395be7c$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::56bcd62ca7ac54601202de0d95c6f0a6>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $c9212a79c7c11017$var$svg = "<svg height=\"100%\" viewBox=\"0 0 116 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M115.55 21.16c0 2.55-1.66 4.48-5.77 4.48-2.3 0-4.17-.52-5.34-1.13v-2.79c1.32.77 3.53 1.5 5.46 1.5 2.02 0 3.07-.83 3.07-2.02 0-1.16-.89-1.84-3.8-2.54-3.4-.83-4.84-2.15-4.84-4.66 0-2.67 2.05-4.29 5.55-4.29 1.99 0 3.8.49 4.94 1.1v2.73c-1.84-.92-3.34-1.41-4.97-1.41-1.93 0-2.97.68-2.97 1.87 0 1.07.74 1.75 3.56 2.42 3.4.83 5.12 2.09 5.12 4.75m-13.12 4.13c-.21.06-.67.12-1.35.12-2.51 0-4.11-1.19-4.11-4.02V3.59h2.64V21.1c0 1.38.92 1.87 2.06 1.87.28 0 .46 0 .77-.03zm-20.75-7.63c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-20.7.31c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49M58.71 24.2c-1.59.95-4.54 1.44-6.81 1.44-6.93 0-10.67-4.23-10.67-10.33 0-6.56 4.26-10.46 11.44-10.46 1.6 0 3.47.18 5.24.8v2.76c-1.53-.61-3.34-.89-5.21-.89-5.98 0-8.71 2.98-8.71 7.73 0 4.66 2.76 7.76 8.56 7.76.95 0 2.27-.09 3.4-.43v-5.61H50.8v-2.64h7.91z\"/>\n    <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M19.36 16a3.36 3.36 0 1 1-6.72 0 3.36 3.36 0 0 1 6.72 0\"/>\n    <path fill=\"var(--icon-color, #101214)\" fill-rule=\"evenodd\" d=\"M16 25.375a9.375 9.375 0 1 0 0-18.75 9.375 9.375 0 1 0 0 18.75M21.86 16a5.86 5.86 0 1 1-11.72 0 5.86 5.86 0 0 1 11.72 0\" clip-rule=\"evenodd\"/>\n</svg>\n";
function $c9212a79c7c11017$export$c527a545aa426db3(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Goals' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $e41bbd286dd6d71c$export$f827d3c5a9c3f644), {
        svg: $c9212a79c7c11017$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::0276df52cce3ff4af21c51ddcfcd1999>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
var $738e873508995cbd$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M5.49 10.87h13.02c.374 0 .574-.2.574-.574V5.907c0-.374-.2-.574-.574-.574h-2.744c-.374 0-.573.2-.573.574v2.22h-1.247v-2.22c0-.374-.2-.574-.574-.574h-2.743c-.374 0-.574.2-.574.574v2.22H8.807v-2.22c0-.374-.2-.574-.573-.574H5.49c-.374 0-.573.2-.573.574v4.39c0 .373.2.573.573.573m.225 3.84a8.7 8.7 0 0 1-.5-2.493c-.024-.324.126-.499.475-.499h12.62c.349 0 .498.15.498.449a8.2 8.2 0 0 1-.523 2.544c-.15.399-.375.573-.799.573H6.513c-.424 0-.649-.174-.798-.573m11.547 2.07C16.065 18.253 14.095 19.2 12 19.2s-4.116-.948-5.288-2.42c-.299-.398-.15-.648.15-.648h10.275c.3 0 .45.25.125.649\"/>\n</svg>\n";
function $738e873508995cbd$export$e26e48d31d71c1e1(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Guard Detect' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $ea406245305817b7$export$be58b4326e23250f), {
        svg: $738e873508995cbd$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::ffc02f6eb51ba8d719155b3e3ac4a088>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $cd4e8d286a470e42$var$svg = "<svg height=\"100%\" viewBox=\"0 0 121 24\">\n    <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M5.49 10.87h13.02c.374 0 .574-.2.574-.574V5.907c0-.374-.2-.574-.574-.574h-2.744c-.374 0-.573.2-.573.574v2.22h-1.247v-2.22c0-.374-.2-.574-.574-.574h-2.743c-.374 0-.574.2-.574.574v2.22H8.807v-2.22c0-.374-.2-.574-.573-.574H5.49c-.374 0-.573.2-.573.574v4.39c0 .373.2.573.573.573m.225 3.84a8.7 8.7 0 0 1-.5-2.493c-.024-.324.126-.499.475-.499h12.62c.349 0 .498.15.498.449a8.2 8.2 0 0 1-.523 2.544c-.15.399-.375.573-.799.573H6.513c-.424 0-.649-.174-.798-.573m11.547 2.07C16.065 18.253 14.095 19.2 12 19.2s-4.116-.948-5.288-2.42c-.299-.398-.15-.648.15-.648h10.275c.3 0 .45.25.125.649\"/>\n    <path fill=\"var(--text-color, #292a2e)\" d=\"M120.03 9.36v1.48h-4.44V9.36zm-3.38-1.82h1.92v7.27q0 .38.17.57t.56.19a3 3 0 0 0 .32-.03 5 5 0 0 0 .32-.06l.29 1.46a3.4 3.4 0 0 1-.63.13 5 5 0 0 1-.62.04q-1.13 0-1.73-.55-.59-.56-.59-1.59zm-5.13 9.61q-1.13 0-1.96-.49a3.3 3.3 0 0 1-1.28-1.38q-.45-.89-.45-2.06 0-1.18.45-2.07a3.3 3.3 0 0 1 1.28-1.39q.83-.49 1.96-.49.66 0 1.22.17t1 .49.73.78.41 1.03l-1.8.36q-.06-.3-.2-.54a1.5 1.5 0 0 0-.33-.4 1.3 1.3 0 0 0-.44-.26 1.6 1.6 0 0 0-.56-.09q-.58 0-.97.31t-.59.86q-.2.54-.2 1.24t.2 1.24.59.86q.39.31.97.31.32 0 .57-.09.26-.09.46-.27a1.6 1.6 0 0 0 .34-.42q.14-.25.2-.56l1.79.35q-.12.6-.4 1.06t-.73.79a3.3 3.3 0 0 1-1 .51q-.56.17-1.23.17m-8.29-.02q-1.16 0-2-.48a3.26 3.26 0 0 1-1.29-1.37q-.45-.88-.45-2.08 0-1.18.44-2.06a3.4 3.4 0 0 1 1.26-1.39q.82-.5 1.93-.5.73 0 1.36.23.64.23 1.13.71.49.47.77 1.2t.28 1.72v.57h-6.34v-1.25h5.39l-.9.35q0-.62-.19-1.08a1.54 1.54 0 0 0-.57-.72q-.37-.26-.93-.26-.55 0-.94.26t-.59.7-.2.99v.88q0 .69.23 1.17.24.47.66.71t.98.24q.37 0 .68-.11t.53-.31q.22-.21.34-.52l1.75.34q-.18.62-.64 1.09-.45.46-1.13.73-.68.25-1.54.25m-4.67-7.8v1.48h-4.44V9.36zm-3.38-1.82h1.92v7.27q0 .38.17.57t.56.19q.12 0 .32-.03.21-.03.32-.06l.29 1.46q-.31.1-.64.13a5 5 0 0 1-.62.04q-1.13 0-1.73-.55-.59-.56-.59-1.59zm-5.19 9.61q-1.16 0-2-.48a3.26 3.26 0 0 1-1.29-1.37q-.45-.88-.45-2.08 0-1.18.44-2.06A3.4 3.4 0 0 1 88 9.77q.82-.5 1.93-.5.72 0 1.36.23t1.14.71q.49.47.77 1.2t.28 1.72v.57h-6.34v-1.25h5.39l-.9.35a2.8 2.8 0 0 0-.19-1.08 1.55 1.55 0 0 0-.57-.72q-.37-.26-.93-.26-.55 0-.94.26t-.59.7-.2.99v.88q0 .69.23 1.17.24.47.66.71t.98.24q.37 0 .68-.11t.53-.31a1.4 1.4 0 0 0 .34-.52l1.75.34q-.18.62-.64 1.09-.45.46-1.13.73-.68.25-1.54.25M80.08 17h-2.6v-1.69H80q1.02 0 1.71-.37t1.03-1.12q.35-.76.35-1.91t-.35-1.9a2.32 2.32 0 0 0-1.02-1.12q-.68-.37-1.69-.37h-2.61v-1.7h2.71q1.52 0 2.62.61a4.1 4.1 0 0 1 1.69 1.75q.6 1.14.6 2.73t-.59 2.74a4.1 4.1 0 0 1-1.7 1.76q-1.12.59-2.67.59M78.53 6.81V17h-1.96V6.81zM67.1 17.13a2.9 2.9 0 0 1-1.6-.46q-.71-.46-1.12-1.33-.41-.88-.41-2.15 0-1.29.42-2.17.42-.87 1.13-1.32a2.9 2.9 0 0 1 1.57-.44q.66 0 1.09.23.43.22.69.54.27.32.4.61h.07V6.81h1.92V17h-1.89v-1.22h-.1a2.8 2.8 0 0 1-.4.61q-.27.31-.7.53-.43.21-1.07.21m.56-1.55q.55 0 .94-.3.38-.3.58-.84.21-.54.21-1.25 0-.72-.2-1.25t-.59-.83q-.38-.29-.94-.29-.57 0-.95.31a1.85 1.85 0 0 0-.58.83 3.6 3.6 0 0 0-.19 1.22q0 .69.19 1.23.2.54.58.85.39.31.95.31M58.98 17V9.36h1.87v1.31h.08q.2-.68.71-1.05a1.93 1.93 0 0 1 1.16-.36q.15 0 .34.02.18.01.32.04v1.74a2 2 0 0 0-.38-.07 5 5 0 0 0-.48-.03q-.48 0-.86.21a1.5 1.5 0 0 0-.6.57 1.65 1.65 0 0 0-.21.85V17zm-5.98.13a2.9 2.9 0 0 1-1.59-.46q-.7-.46-1.12-1.33-.41-.88-.41-2.15 0-1.29.42-2.17.42-.87 1.14-1.32a2.9 2.9 0 0 1 1.58-.44q.66 0 1.09.23.43.22.69.54t.4.61h.08V9.36h1.91V17h-1.9v-1.22h-.08a2.6 2.6 0 0 1-.41.61q-.27.32-.7.53t-1.08.21m.57-1.55q.56 0 .94-.3t.58-.84q.21-.54.21-1.25 0-.72-.2-1.25t-.58-.83-.94-.29q-.57 0-.96.3a1.85 1.85 0 0 0-.58.83 3.6 3.6 0 0 0-.19 1.23q0 .69.2 1.23t.58.85q.39.31.95.31m-9.43 1.53q-.79 0-1.39-.34a2.34 2.34 0 0 1-.92-.98q-.33-.65-.33-1.55V9.37h1.93v4.54q0 .75.38 1.16t1.05.42q.46 0 .81-.19.35-.2.55-.57t.2-.9V9.38h1.93V17h-1.82l-.02-1.9h.12q-.31.98-.93 1.49t-1.56.51m-8.95.04q-1.29 0-2.32-.64-1.02-.63-1.63-1.8-.6-1.17-.6-2.77 0-1.65.62-2.82t1.68-1.8q1.07-.63 2.41-.63.85 0 1.58.25.74.25 1.31.7.57.46.94 1.09a3.8 3.8 0 0 1 .49 1.37h-2.01a2.3 2.3 0 0 0-.32-.69 2 2 0 0 0-.5-.52 2 2 0 0 0-.66-.33 2.6 2.6 0 0 0-.81-.12q-.81 0-1.43.4T33 10.01q-.35.77-.35 1.89 0 1.11.35 1.89t.98 1.19q.64.4 1.48.4.76 0 1.3-.29a2 2 0 0 0 .83-.83q.29-.55.29-1.29h.42v.85q0 .66-.16 1.26t-.53 1.06q-.35.47-.95.73-.59.27-1.45.27m3.24-.14-.26-2.43v-1.43H35.6v-1.52h4.19V17z\"/>\n</svg>\n";
function $cd4e8d286a470e42$export$bf5ca9fb70f56bb5(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Guard Detect' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $e41bbd286dd6d71c$export$f827d3c5a9c3f644), {
        svg: $cd4e8d286a470e42$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::9271fe2e99ed03180fc112676167f42e>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
var $6a78ffaee3a1392f$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M5.49 10.87h13.02c.374 0 .574-.2.574-.574V5.907c0-.374-.2-.574-.574-.574h-2.744c-.374 0-.573.2-.573.574v2.22h-1.247v-2.22c0-.374-.2-.574-.574-.574h-2.743c-.374 0-.574.2-.574.574v2.22H8.807v-2.22c0-.374-.2-.574-.573-.574H5.49c-.374 0-.573.2-.573.574v4.39c0 .373.2.573.573.573m.225 3.84a8.7 8.7 0 0 1-.5-2.493c-.024-.324.126-.499.475-.499h12.62c.349 0 .498.15.498.449a8.2 8.2 0 0 1-.523 2.544c-.15.399-.375.573-.799.573H6.513c-.424 0-.649-.174-.798-.573m11.547 2.07C16.065 18.253 14.095 19.2 12 19.2s-4.116-.948-5.288-2.42c-.299-.398-.15-.648.15-.648h10.275c.3 0 .45.25.125.649\"/>\n</svg>\n";
function $6a78ffaee3a1392f$export$3f95fcfdc25a741d(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Guard' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $ea406245305817b7$export$be58b4326e23250f), {
        svg: $6a78ffaee3a1392f$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::db6984f13fa8a1f65e3a27814935822a>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $0e59fe96d5359d31$var$svg = "<svg height=\"100%\" viewBox=\"0 0 120 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M108.4 17.67c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V3.59h2.64v21.74zm-17.8-9.04v9.05H96.7V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.67-5.43 3.93m-17.86 1.37c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-27.42-6.34V10h2.64v9.26c0 2.76 1.1 3.99 3.62 3.99 2.45 0 4.14-1.62 4.14-4.72V10h2.64v15.33h-2.64v-2.51c-.98 1.81-2.79 2.82-4.84 2.82-3.53 0-5.55-2.42-5.55-6.65m-3.98 5.21c-1.59.95-4.54 1.44-6.81 1.44-6.93 0-10.67-4.23-10.67-10.33 0-6.56 4.26-10.46 11.44-10.46 1.6 0 3.47.18 5.24.8v2.76c-1.53-.61-3.34-.89-5.21-.89-5.98 0-8.71 2.98-8.71 7.73 0 4.66 2.76 7.76 8.56 7.76.95 0 2.27-.09 3.4-.43v-5.61H50.8v-2.64h7.91z\"/>\n    <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M8.188 14.644h15.623c.449 0 .688-.24.688-.688V8.688c0-.449-.24-.688-.688-.688h-3.292c-.45 0-.689.24-.689.688v2.664h-1.496V8.688c0-.449-.24-.688-.688-.688h-3.293c-.448 0-.688.24-.688.688v2.664H12.17V8.688c0-.449-.24-.688-.689-.688H8.188c-.449 0-.688.24-.688.688v5.268c0 .449.24.688.688.688m.27 4.609a10.4 10.4 0 0 1-.599-2.993c-.03-.389.15-.598.569-.598H23.57c.42 0 .599.18.599.538q-.09 1.662-.629 3.053c-.18.479-.448.688-.957.688H9.415c-.508 0-.778-.21-.957-.688m13.856 2.484c-1.436 1.766-3.8 2.903-6.314 2.903s-4.939-1.137-6.345-2.903c-.36-.479-.18-.778.18-.778h12.33c.359 0 .538.3.15.778\"/>\n</svg>\n";
function $0e59fe96d5359d31$export$2b896c4d595a4331(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Guard' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $e41bbd286dd6d71c$export$f827d3c5a9c3f644), {
        svg: $0e59fe96d5359d31$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::978838b36f6aa3744f039bfb1c56d79c>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
var $a4dc7739dd58916d$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M5.875 10.688v7.437h4.375V13.75h3.5v4.375h4.375v-7.437L12 5z\"/>\n</svg>\n";
function $a4dc7739dd58916d$export$92c8767b874048d(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Home' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $ea406245305817b7$export$be58b4326e23250f), {
        svg: $a4dc7739dd58916d$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::5bd026d27282a90cddcd834d02167bda>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $ab3d1b934911a5be$var$svg = "<svg height=\"100%\" viewBox=\"0 0 121 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M113.57 12.09c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zM93.3 16.81v8.53h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 2.61 0 4.39 1.32 5.15 3.74.86-2.36 2.91-3.74 5.46-3.74 3.43 0 5.34 2.33 5.34 6.66v8.99h-2.64v-8.52c0-3.16-1.1-4.72-3.62-4.72-2.45 0-4.14 1.63-4.14 4.72m-23.33 8.81c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49M56.41 5.19h2.76v20.15h-2.76v-8.71H45.8v8.71h-2.76V5.19h2.76v8.8h10.61z\"/>\n    <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M7.25 14.125V24.75h6.25V18.5h5v6.25h6.25V14.125L16 6z\"/>\n</svg>\n";
function $ab3d1b934911a5be$export$8b6b7f1b1b2367d3(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Home' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $e41bbd286dd6d71c$export$f827d3c5a9c3f644), {
        svg: $ab3d1b934911a5be$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::983ad8fa518509adc011dda491e7edb4>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
var $0e4a211368ae3d84$var$svg = "<svg height=\"100%\" viewBox=\"0 0 32 32\">\n    <g clip-path=\"url(#clip0_95164_16219)\">\n        <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n        <g clip-path=\"url(#clip1_95164_16219)\">\n            <path fill=\"var(--icon-color, #101214)\" fill-rule=\"evenodd\" d=\"M9 25.333V6.667h14v18.666h-5.25V21.25h-3.5v4.083zm3.5-14.583h2.333V9H12.5zm4.667 0H19.5V9h-2.333zm-2.334 4.083H12.5v-1.75h2.333zM12.5 18.916h2.333v-1.75H12.5zm7-4.083h-2.333v-1.75H19.5zm-2.333 4.083H19.5v-1.75h-2.333z\" clip-rule=\"evenodd\"/>\n        </g>\n    </g>\n    <defs>\n        <clipPath id=\"clip0_95164_16219\">\n            <path fill=\"var(--icon-color, white)\" d=\"M0 0h32v32H0z\"/>\n        </clipPath>\n        <clipPath id=\"clip1_95164_16219\">\n            <path fill=\"var(--icon-color, white)\" d=\"M2 2h28v28H2z\"/>\n        </clipPath>\n    </defs>\n</svg>\n";
function $0e4a211368ae3d84$export$80b8b269d8b5014e(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Hub' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $ea406245305817b7$export$be58b4326e23250f), {
        svg: $0e4a211368ae3d84$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::525e888921a2eb67ac3477c558f06bd0>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $2079e45d1c518afa$var$svg = "<svg height=\"100%\" viewBox=\"0 0 95 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M91.61 17.67c0-3.68-1.47-5.52-4.2-5.52-2.36 0-4.48 1.5-4.48 4.91v1.23c0 3.4 1.93 4.91 4.17 4.91 2.98 0 4.51-1.96 4.51-5.52m-3.8 7.97c-2.24 0-3.96-1.01-4.88-3v2.7h-2.64V3.59h2.64v9.17c.98-2.02 2.82-3.07 5.18-3.07 4.08 0 6.13 3.47 6.13 7.97 0 4.32-2.15 7.97-6.44 7.97m-24.52-6.64V10h2.64v9.26c0 2.76 1.1 3.99 3.62 3.99 2.45 0 4.14-1.62 4.14-4.72V10h2.64v15.33h-2.64v-2.51c-.98 1.81-2.79 2.82-4.84 2.82-3.53 0-5.55-2.42-5.55-6.65M56.4 5.19h2.76v20.15H56.4v-8.71H45.79v8.71h-2.76V5.19h2.76v8.8H56.4z\"/>\n    <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, #101214)\" fill-rule=\"evenodd\" d=\"M9 25.333V6.667h14v18.666h-5.25V21.25h-3.5v4.083zm3.5-14.583h2.333V9H12.5zm4.667 0H19.5V9h-2.333zm-2.334 4.083H12.5v-1.75h2.333zM12.5 18.916h2.333v-1.75H12.5zm7-4.083h-2.333v-1.75H19.5zm-2.333 4.083H19.5v-1.75h-2.333z\" clip-rule=\"evenodd\"/>\n</svg>\n";
function $2079e45d1c518afa$export$7a38180641471460(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Hub' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $e41bbd286dd6d71c$export$f827d3c5a9c3f644), {
        svg: $2079e45d1c518afa$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f238f469c20433ab8ed5a1e4abeae5fe>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
var $55c557126d4b3583$var$svg = "<svg height=\"100%\" viewBox=\"0 0 55 55\">\n    <path fill=\"var(--tile-color,#1868db)\" d=\"M24.519.844a6.3 6.3 0 0 1 6.3 0l18.37 10.601a6.3 6.3 0 0 1 3.15 5.454V38.1c0 2.25-1.2 4.33-3.15 5.454l-18.37 10.601a6.3 6.3 0 0 1-6.3 0l-18.37-10.6a6.3 6.3 0 0 1-3.15-5.454V16.9c0-2.25 1.2-4.33 3.15-5.454z\"/>\n    <path fill=\"var(--icon-color, white)\" d=\"M20.71 34.657h-2.705C13.926 34.657 11 32.16 11 28.5h14.543c.754 0 1.241.536 1.241 1.294v14.634c-3.635 0-6.074-2.944-6.074-7.05zm7.183-7.272h-2.705c-4.079 0-7.005-2.454-7.005-6.113h14.542c.754 0 1.286.491 1.286 1.25v14.634c-3.635 0-6.118-2.945-6.118-7.05zm7.227-7.228h-2.705c-4.079 0-7.005-2.498-7.005-6.157h14.543c.753 0 1.241.535 1.241 1.25v14.633c-3.636 0-6.074-2.944-6.074-7.049z\"/>\n</svg>\n";
function $55c557126d4b3583$export$b12fec207e8537a8(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Jira Coding Agent' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $ea406245305817b7$export$be58b4326e23250f), {
        svg: $55c557126d4b3583$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::491a8713d140a4025bae404f0574bce7>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
var $62e8a66eaf360812$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color, white)\" d=\"M6 .5h12A5.5 5.5 0 0 1 23.5 6v12a5.5 5.5 0 0 1-5.5 5.5H6A5.5 5.5 0 0 1 .5 18V6A5.5 5.5 0 0 1 6 .5\"/>\n    <path fill=\"none\" stroke=\"var(--border-color, #dddee1)\" d=\"M6 .5h12A5.5 5.5 0 0 1 23.5 6v12a5.5 5.5 0 0 1-5.5 5.5H6A5.5 5.5 0 0 1 .5 18V6A5.5 5.5 0 0 1 6 .5Z\"/>\n    <path fill=\"var(--icon-color, #1868db)\" d=\"M8.974 15.523H7.62c-2.04 0-3.502-1.249-3.502-3.078h7.271c.377 0 .62.268.62.647v7.317c-1.817 0-3.036-1.472-3.036-3.525zm3.591-3.636h-1.352c-2.04 0-3.503-1.227-3.503-3.056h7.272c.376 0 .642.245.642.625v7.317c-1.817 0-3.059-1.473-3.059-3.525zm3.614-3.614h-1.353c-2.04 0-3.502-1.249-3.502-3.078h7.271c.377 0 .62.268.62.624v7.318c-1.817 0-3.036-1.473-3.036-3.525z\"/>\n</svg>\n";
function $62e8a66eaf360812$export$f8455b5667a3ee0c(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Jira Data Center' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $ea406245305817b7$export$be58b4326e23250f), {
        svg: $62e8a66eaf360812$var$svg,
        label: label,
        type: "data-center",
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::97902fae9a5e66613a7ad8ae8ea2e75d>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $a52fbe5d781bb8ee$var$svg = "<svg height=\"100%\" viewBox=\"0 0 83 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M71.02 17.67c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.98 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.47-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-17.79-9.04v9.05h-2.58V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.67-5.43 3.93M52.22 5.95c0-1.17.77-1.84 1.84-1.84s1.84.67 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zm-6.42-5.95V5.19h2.76V19.2c0 3.71-1.63 6.26-5.43 6.26-1.44 0-2.55-.24-3.31-.52v-2.67c.83.34 1.84.52 2.85.52 2.33 0 3.13-1.41 3.13-3.4\"/>\n    <path fill=\"var(--tile-color, white)\" d=\"M8 .667h16A7.333 7.333 0 0 1 31.333 8v16A7.333 7.333 0 0 1 24 31.333H8A7.333 7.333 0 0 1 .667 24V8A7.333 7.333 0 0 1 8 .667\"/>\n    <path fill=\"none\" stroke=\"var(--border-color, #dddee1)\" stroke-width=\"1.333\" d=\"M8 .667h16A7.333 7.333 0 0 1 31.333 8v16A7.333 7.333 0 0 1 24 31.333H8A7.333 7.333 0 0 1 .667 24V8A7.333 7.333 0 0 1 8 .667Z\"/>\n    <path fill=\"var(--icon-color, #1868db)\" d=\"M11.965 20.699h-1.803c-2.72 0-4.67-1.666-4.67-4.105h9.695c.502 0 .827.357.827.863v9.756c-2.424 0-4.05-1.963-4.05-4.7zm4.788-4.848H14.95c-2.72 0-4.67-1.636-4.67-4.075h9.695c.502 0 .857.327.857.832v9.756c-2.424 0-4.079-1.963-4.079-4.699zm4.818-4.819h-1.803c-2.72 0-4.67-1.666-4.67-4.105h9.695c.503 0 .828.357.828.833v9.756c-2.424 0-4.05-1.963-4.05-4.7z\"/>\n</svg>\n";
function $a52fbe5d781bb8ee$export$3224b07bc93ef23e(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Jira Data Center' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $e41bbd286dd6d71c$export$f827d3c5a9c3f644), {
        svg: $a52fbe5d781bb8ee$var$svg,
        label: label,
        type: "data-center",
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3b3ec3c590ed89c431e0f979daa3e25e>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
var $33f47f6f2d3ad2c9$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#c97cf4)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M13.467 4.882a9.47 9.47 0 0 0 5.422 0c.159-.035.265.07.23.229-.513 1.85-.513 3.558 0 5.408.035.14-.072.264-.23.211a10.1 10.1 0 0 0-5.422 0c-.142.053-.265-.07-.212-.211.476-1.85.476-3.559 0-5.408-.053-.159.07-.264.212-.23m.724 6.553v.3c0 1.39-.972 2.412-2.173 2.412a2.153 2.153 0 0 1-2.154-2.166c0-1.198.971-2.15 2.331-2.15h.353V5.62c-.176-.017-.353-.017-.53-.017a6.387 6.387 0 0 0-6.393 6.394 6.37 6.37 0 0 0 6.393 6.377c3.533 0 6.411-2.854 6.411-6.377v-.563z\"/>\n</svg>\n";
var $33f47f6f2d3ad2c9$var$customThemeSvg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--themed-icon-color, currentcolor)\" d=\"M18 0a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6V6a6 6 0 0 1 6-6zm-5.981 5.604a6.387 6.387 0 0 0-6.394 6.394 6.373 6.373 0 0 0 6.394 6.377c3.532 0 6.41-2.854 6.41-6.377v-.563H14.19v.3c0 1.39-.97 2.412-2.171 2.413a2.154 2.154 0 0 1-2.156-2.168c0-1.197.973-2.148 2.332-2.148h.353v-4.21c-.177-.018-.353-.018-.53-.018m6.87-.722a9.47 9.47 0 0 1-5.422 0c-.141-.035-.265.07-.212.228.477 1.85.477 3.559 0 5.409-.053.14.07.264.212.211a10.1 10.1 0 0 1 5.422 0c.159.053.265-.07.23-.211-.513-1.85-.513-3.56 0-5.409.034-.158-.072-.263-.23-.228\"/>\n</svg>\n";
function $33f47f6f2d3ad2c9$export$21bfbeb62fdcce8d(_ref) {
    var iconColor = _ref.iconColor, size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Jira Product Discovery' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $ea406245305817b7$export$be58b4326e23250f), {
        svg: $33f47f6f2d3ad2c9$var$svg,
        customThemeSvg: $33f47f6f2d3ad2c9$var$customThemeSvg,
        iconColor: iconColor,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c8e2d27dec964efc37c6ed5782c3fe57>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $6023d3d1da91d408$var$svg = "<svg height=\"100%\" viewBox=\"0 0 327 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M317.88 24.35h-1.72L310.62 10h2.82l4.91 13.13 4.9-13.13h2.82l-5.8 14.84c-1.72 4.39-2.7 6.65-6.59 6.65-1.32 0-2.06-.12-2.82-.43v-2.27c.89.28 1.9.37 2.67.37 2.15 0 3.1-1.47 4.36-4.82m-13.25-8.05v9.05h-2.58V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.67-5.43 3.93m-12.47-4.21c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-19.72.6h-3.53L268.87 10h2.76l4.97 13.1 4.93-13.1h2.76zm-17.46.31c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49m-9.39 10.42v2.36c-.92.49-2.33.71-3.74.71-5.46 0-8-3.31-8-8 0-4.63 2.55-7.94 8-7.94 1.38 0 2.45.18 3.65.74v2.45c-.98-.46-2.02-.74-3.46-.74-3.99 0-5.61 2.51-5.61 5.49s1.66 5.49 5.67 5.49c1.56 0 2.55-.21 3.5-.55m-13.88-1.42c0 2.55-1.66 4.48-5.76 4.48-2.3 0-4.17-.52-5.34-1.13v-2.79c1.32.77 3.53 1.5 5.46 1.5 2.02 0 3.07-.83 3.07-2.02 0-1.16-.89-1.84-3.8-2.54-3.4-.83-4.85-2.15-4.85-4.66 0-2.67 2.06-4.29 5.55-4.29 1.99 0 3.8.49 4.94 1.1v2.73c-1.84-.92-3.34-1.41-4.97-1.41-1.93 0-2.97.68-2.97 1.87 0 1.07.74 1.75 3.56 2.42 3.4.83 5.12 2.09 5.12 4.75m-17.7-15.22c0-1.16.77-1.84 1.84-1.84s1.84.68 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zM207.68 7.82h-4.54v14.87h4.69c4.6 0 6.9-2.42 6.9-7.3 0-4.91-2.18-7.57-7.05-7.57m-7.3 17.51V5.19h7.42c6.53 0 9.69 4.08 9.69 10.12 0 6.1-3.19 10.03-9.69 10.03zm-13.41-4.75c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55c-.46.12-.98.25-1.78.25-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zm-6.66 1.99v2.36c-.92.49-2.33.71-3.74.71-5.46 0-8-3.31-8-8 0-4.63 2.55-7.94 8-7.94 1.38 0 2.45.18 3.65.74v2.45c-.98-.46-2.02-.74-3.46-.74-3.99 0-5.61 2.51-5.61 5.49s1.66 5.49 5.67 5.49c1.56 0 2.55-.21 3.5-.55m-27.86-3.59V10h2.64v9.26c0 2.76 1.1 3.99 3.62 3.99 2.45 0 4.14-1.62 4.14-4.72V10h2.64v15.33h-2.64v-2.51c-.98 1.81-2.79 2.82-4.84 2.82-3.53 0-5.55-2.42-5.55-6.65m-14.99-1.32c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V3.59h2.64v21.74zm-20.7.31c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49m-13.78 4.14v9.05h-2.58V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.67-5.43 3.93m-5-4.4c0 4.39-2.45 6.84-7.48 6.84h-4.02v6.59h-2.76V5.19h6.78c5.03 0 7.48 2.58 7.48 6.72m-7.79 4.2c3.56.12 4.94-1.56 4.94-4.14 0-2.45-1.38-4.14-4.94-4.14h-3.71v8.28zm-27.87 1.56c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.98 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-17.79-9.04v9.05h-2.58V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.67-5.43 3.93M52.22 5.95c0-1.16.77-1.84 1.84-1.84s1.84.68 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zm-6.42-5.95V5.19h2.76V19.2c0 3.71-1.63 6.26-5.43 6.26-1.44 0-2.55-.24-3.31-.52v-2.67c.83.34 1.84.52 2.85.52 2.33 0 3.13-1.41 3.13-3.4\"/>\n    <path fill=\"var(--tile-color,#c97cf4)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M17.448 6.967c2.544.746 5.113.746 7.656 0 .225-.05.375.1.325.323-.724 2.612-.724 5.025 0 7.637.05.199-.1.373-.325.298a14.3 14.3 0 0 0-7.656 0c-.2.075-.374-.1-.3-.298.674-2.612.674-5.025 0-7.637-.074-.223.1-.373.3-.323m1.023 9.253v.423c0 1.965-1.372 3.408-3.068 3.408a3.04 3.04 0 0 1-3.043-3.06c0-1.691 1.372-3.034 3.292-3.034h.5V8.012c-.25-.025-.5-.025-.749-.025a9.02 9.02 0 0 0-9.028 9.03c0 4.999 4.04 9.004 9.028 9.004s9.053-4.03 9.053-9.005v-.796z\"/>\n</svg>\n";
function $6023d3d1da91d408$export$602140a6a10b02bf(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Jira Product Discovery' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $e41bbd286dd6d71c$export$f827d3c5a9c3f644), {
        svg: $6023d3d1da91d408$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e66626867983712448eb161ec2993046>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
var $65e87a79bfc0c809$var$svg = "<svg height=\"100%\" viewBox=\"0 0 25 24\">\n    <path fill=\"var(--tile-color, white)\" d=\"M6.417.5h12a5.5 5.5 0 0 1 5.5 5.5v12a5.5 5.5 0 0 1-5.5 5.5h-12a5.5 5.5 0 0 1-5.5-5.5V6a5.5 5.5 0 0 1 5.5-5.5\"/>\n    <path fill=\"none\" stroke=\"var(--border-color, #dddee1)\" d=\"M6.417.5h12a5.5 5.5 0 0 1 5.5 5.5v12a5.5 5.5 0 0 1-5.5 5.5h-12a5.5 5.5 0 0 1-5.5-5.5V6a5.5 5.5 0 0 1 5.5-5.5Z\"/>\n    <path fill=\"var(--icon-color, #1868db)\" d=\"M14.117 10.203h4.464c.67 0 .899.637.49 1.144l-6.98 8.616c-2.257-1.798-2.044-4.643-.393-6.72zm-3.45 3.433H6.205c-.67 0-.899-.638-.49-1.144l6.981-8.617c2.256 1.799 2.011 4.61.376 6.704z\"/>\n</svg>\n";
function $65e87a79bfc0c809$export$65fae0eaf343f2ca(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Jira Service Management Data Center' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $ea406245305817b7$export$be58b4326e23250f), {
        svg: $65e87a79bfc0c809$var$svg,
        label: label,
        type: "data-center",
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::90317e51e9a9185b7a39157502e3ebed>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $5c6d87fc5526de52$var$svg = "<svg height=\"100%\" viewBox=\"0 0 372 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M367.07 20.58c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55c-.46.12-.98.25-1.78.25-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zm-7.32-4.23v8.99h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 3.53 0 5.55 2.42 5.55 6.66m-22.92-4.27c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-26.16-7.92v8.53h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 2.61 0 4.39 1.32 5.15 3.74.86-2.36 2.91-3.74 5.46-3.74 3.43 0 5.34 2.33 5.34 6.66v8.99h-2.64v-8.52c0-3.16-1.1-4.72-3.62-4.72-2.45 0-4.14 1.63-4.14 4.72m-22.92-4.74c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2H289.2c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-18.64-.62v-1.53c-.98 2.02-2.82 3.07-5.18 3.07-4.05 0-6.07-3.46-6.07-7.97 0-4.32 2.12-7.97 6.38-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.58v13.95c0 4.51-2.12 7.54-7.6 7.54-2.58 0-3.99-.34-5.46-.83v-2.58c1.69.55 3.44.92 5.34.92 3.83 0 5.15-2.05 5.15-4.91m-8.68-6.44c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m-16.97.03c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-14.07-8.98v8.99h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 3.53 0 5.55 2.42 5.55 6.66m-28.33 1.31c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-31.44-11.01-2.76-7.48v18.49h-2.76V5.19h4.78l4.57 11.56 1.87 5.55 1.87-5.55 4.6-11.56h4.45v20.15h-2.76V7.06l-2.36 7.27-4.45 11.01h-2.67zm-21.52-2.23c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.05 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-15.09-2.16v2.36c-.92.49-2.33.71-3.74.71-5.46 0-8-3.31-8-8 0-4.63 2.55-7.94 8-7.94 1.38 0 2.45.18 3.65.74v2.45c-.98-.46-2.02-.74-3.46-.74-3.99 0-5.61 2.51-5.61 5.49s1.66 5.49 5.67 5.49c1.56 0 2.55-.21 3.5-.55M150.12 5.95c0-1.16.77-1.84 1.84-1.84s1.84.68 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zm-8.23 0h-3.53L132.91 10h2.76l4.97 13.1 4.93-13.1h2.76zm-15.45-9.04v9.05h-2.58V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.68-5.43 3.93m-12.47-4.21c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-15.33-4.95c0 3.5-2.08 5.86-7.08 5.86-3.89 0-5.7-.77-7.27-1.56v-2.82c1.87.98 4.75 1.69 7.42 1.69 3.04 0 4.17-1.2 4.17-2.97s-1.1-2.73-4.94-3.65c-4.54-1.1-6.56-2.67-6.56-5.98 0-3.13 2.39-5.46 7.08-5.46 2.91 0 4.78.71 6.16 1.47v2.76c-2.02-1.17-4.2-1.53-6.29-1.53-2.64 0-4.2.92-4.2 2.76 0 1.66 1.29 2.48 4.84 3.37 4.26 1.07 6.66 2.45 6.66 6.07m-33.99-2.12c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-17.79-9.04v9.05h-2.58V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.68-5.43 3.93M52.22 5.95c0-1.16.77-1.84 1.84-1.84s1.84.68 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zm-6.42-5.95V5.19h2.76V19.2c0 3.71-1.63 6.26-5.43 6.26-1.44 0-2.55-.24-3.31-.52v-2.67c.83.34 1.84.52 2.85.52 2.33 0 3.13-1.41 3.13-3.4\"/>\n    <path fill=\"var(--tile-color, white)\" d=\"M8 .667h16A7.333 7.333 0 0 1 31.333 8v16A7.333 7.333 0 0 1 24 31.333H8A7.333 7.333 0 0 1 .667 24V8A7.333 7.333 0 0 1 8 .667\"/>\n    <path fill=\"none\" stroke=\"var(--border-color, #dddee1)\" stroke-width=\"1.333\" d=\"M8 .667h16A7.333 7.333 0 0 1 31.333 8v16A7.333 7.333 0 0 1 24 31.333H8A7.333 7.333 0 0 1 .667 24V8A7.333 7.333 0 0 1 8 .667Z\"/>\n    <path fill=\"var(--icon-color, #1868db)\" d=\"M18.268 13.604h5.95c.895 0 1.2.85.655 1.526l-9.308 11.487c-3.008-2.397-2.725-6.19-.524-8.959zm-4.6 4.577h-5.95c-.895 0-1.2-.85-.655-1.526l9.308-11.488c3.009 2.398 2.682 6.148.502 8.938z\"/>\n</svg>\n";
function $5c6d87fc5526de52$export$f64bc7a7f04428d0(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Jira Service Management Data Center' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $e41bbd286dd6d71c$export$f827d3c5a9c3f644), {
        svg: $5c6d87fc5526de52$var$svg,
        label: label,
        type: "data-center",
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::cedb5d68059644a06a093aa74d8e3cc5>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
var $379ce3c7b9d6f514$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#ffc716)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M13.744 10.156h4.578c.688 0 .922.654.503 1.174l-7.16 8.837c-2.314-1.845-2.096-4.763-.402-6.892zm-3.538 3.521H5.63c-.688 0-.923-.654-.504-1.173l7.16-8.837c2.315 1.844 2.063 4.728.386 6.875z\"/>\n</svg>\n";
var $379ce3c7b9d6f514$var$customThemeSvg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--themed-icon-color, currentcolor)\" d=\"M18 0a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6V6a6 6 0 0 1 6-6zm-4.256 10.156-2.481 3.12c-1.694 2.129-1.912 5.047.402 6.891l7.16-8.837c.42-.52.185-1.174-.503-1.174zm-8.619 2.348c-.419.52-.183 1.174.504 1.174h4.577l2.465-3.136c1.677-2.146 1.928-5.03-.386-6.875z\"/>\n</svg>\n";
function $379ce3c7b9d6f514$export$3c6158790f5e01c4(_ref) {
    var iconColor = _ref.iconColor, size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Jira Service Management' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $ea406245305817b7$export$be58b4326e23250f), {
        svg: $379ce3c7b9d6f514$var$svg,
        customThemeSvg: $379ce3c7b9d6f514$var$customThemeSvg,
        iconColor: iconColor,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::bcf1b6bc0c0712320d6fbdb868500ebb>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $1b4ab5bad63b4fb0$var$svg = "<svg height=\"100%\" viewBox=\"0 0 372 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M367.07 20.58c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55a6.3 6.3 0 0 1-1.78.25c-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zm-7.32-4.23v8.99h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 3.53 0 5.55 2.42 5.55 6.66m-22.92-4.27c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-26.16-7.92v8.53h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 2.61 0 4.39 1.32 5.15 3.74.86-2.36 2.91-3.74 5.46-3.74 3.43 0 5.34 2.33 5.34 6.66v8.99h-2.64v-8.52c0-3.16-1.1-4.72-3.62-4.72-2.45 0-4.14 1.63-4.14 4.72m-22.92-4.74c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2H289.2c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-18.64-.62v-1.53c-.98 2.02-2.82 3.07-5.18 3.07-4.05 0-6.07-3.46-6.07-7.97 0-4.32 2.12-7.97 6.38-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.58v13.95c0 4.51-2.12 7.54-7.6 7.54-2.58 0-3.99-.34-5.46-.83v-2.58c1.69.55 3.44.92 5.34.92 3.83 0 5.15-2.05 5.15-4.91m-8.68-6.44c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m-16.97.03c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-14.07-8.98v8.99h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 3.53 0 5.55 2.42 5.55 6.66m-28.33 1.31c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-31.44-11.01-2.76-7.48v18.49h-2.76V5.19h4.78l4.57 11.56 1.87 5.55 1.87-5.55 4.6-11.56h4.45v20.15h-2.76V7.06l-2.36 7.27-4.45 11.01h-2.67zm-21.52-2.23c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.05 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-15.09-2.16v2.36c-.92.49-2.33.71-3.74.71-5.46 0-8-3.31-8-8 0-4.63 2.55-7.94 8-7.94 1.38 0 2.45.18 3.65.74v2.45c-.98-.46-2.02-.74-3.46-.74-3.99 0-5.61 2.51-5.61 5.49s1.66 5.49 5.67 5.49c1.56 0 2.55-.21 3.5-.55M150.12 5.95c0-1.17.77-1.84 1.84-1.84s1.84.67 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zm-8.23 0h-3.53L132.91 10h2.76l4.97 13.1 4.93-13.1h2.76zm-15.45-9.04v9.05h-2.58V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.67-5.43 3.93m-12.47-4.21c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-15.33-4.95c0 3.5-2.08 5.86-7.08 5.86-3.89 0-5.7-.77-7.27-1.56v-2.82c1.87.98 4.75 1.69 7.42 1.69 3.04 0 4.17-1.2 4.17-2.97 0-1.78-1.1-2.73-4.94-3.65-4.54-1.1-6.56-2.67-6.56-5.98 0-3.13 2.39-5.46 7.08-5.46 2.91 0 4.78.71 6.16 1.47v2.76c-2.02-1.16-4.2-1.53-6.29-1.53-2.64 0-4.2.92-4.2 2.76 0 1.66 1.29 2.48 4.84 3.37 4.26 1.07 6.66 2.45 6.66 6.07m-33.99-2.12c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.98 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-17.79-9.04v9.05h-2.58V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.67-5.43 3.93M52.22 5.95c0-1.17.77-1.84 1.84-1.84s1.84.67 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zm-6.42-5.95V5.19h2.76V19.2c0 3.71-1.63 6.26-5.43 6.26-1.44 0-2.55-.25-3.31-.52v-2.67c.83.34 1.84.52 2.85.52 2.33 0 3.13-1.41 3.13-3.4\"/>\n    <path fill=\"var(--tile-color,#ffc716)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M18.268 13.604h5.951c.894 0 1.199.85.654 1.526l-9.308 11.487c-3.008-2.397-2.725-6.19-.523-8.959zm-4.6 4.577h-5.95c-.894 0-1.2-.85-.655-1.526l9.308-11.488c3.009 2.398 2.682 6.148.502 8.938z\"/>\n</svg>\n";
function $1b4ab5bad63b4fb0$export$de148263c75d2bc1(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Jira Service Management' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $e41bbd286dd6d71c$export$f827d3c5a9c3f644), {
        svg: $1b4ab5bad63b4fb0$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b225283860ba91a6c228b8f4fa0e1d39>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
var $f3d3a88cf6cc6374$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#1868db)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, white)\" d=\"M9.051 15.434H7.734c-1.988 0-3.413-1.218-3.413-3h7.085c.367 0 .605.26.605.63v7.13c-1.772 0-2.96-1.435-2.96-3.434zm3.5-3.543h-1.318c-1.987 0-3.413-1.196-3.413-2.978h7.085c.367 0 .627.239.627.608v7.13c-1.772 0-2.981-1.435-2.981-3.434zm3.52-3.522h-1.317c-1.987 0-3.413-1.217-3.413-3h7.085c.367 0 .605.262.605.61v7.129c-1.771 0-2.96-1.435-2.96-3.434z\"/>\n</svg>\n";
var $f3d3a88cf6cc6374$var$customThemeSvg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--themed-icon-color, currentcolor)\" d=\"M18 0a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6V6a6 6 0 0 1 6-6zM4.321 12.434c0 1.782 1.425 3 3.412 3h1.319v1.326c0 2 1.188 3.433 2.959 3.433v-7.129c0-.369-.238-.63-.605-.63zm3.5-3.52c0 1.781 1.425 2.977 3.412 2.977h1.318v1.326c0 2 1.21 3.433 2.98 3.433V9.521c0-.369-.259-.608-.626-.608zm3.52-3.544c0 1.782 1.426 3 3.413 3h1.317v1.304c0 2 1.188 3.433 2.96 3.433V5.98c0-.348-.238-.609-.605-.609z\"/>\n</svg>\n";
function $f3d3a88cf6cc6374$export$c4b5b1f965d8b3eb(_ref) {
    var iconColor = _ref.iconColor, size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Jira' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $ea406245305817b7$export$be58b4326e23250f), {
        svg: $f3d3a88cf6cc6374$var$svg,
        customThemeSvg: $f3d3a88cf6cc6374$var$customThemeSvg,
        iconColor: iconColor,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3ed7d2f84cfdfe8bfef2a295bafed6da>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $b8427b7cd125f4a4$var$svg = "<svg height=\"100%\" viewBox=\"0 0 83 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M71.02 17.67c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.98 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-17.79-9.04v9.05h-2.58V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.67-5.43 3.93M52.22 5.95c0-1.17.77-1.84 1.84-1.84s1.84.67 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zm-6.42-5.95V5.19h2.76V19.2c0 3.71-1.63 6.26-5.43 6.26-1.44 0-2.55-.25-3.31-.52v-2.67c.83.34 1.84.52 2.85.52 2.33 0 3.13-1.41 3.13-3.4\"/>\n    <path fill=\"var(--tile-color,#1868db)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, white)\" d=\"M11.965 20.698h-1.803c-2.72 0-4.67-1.666-4.67-4.105h9.695c.502 0 .827.357.827.863v9.756c-2.423 0-4.05-1.963-4.05-4.7zm4.788-4.848H14.95c-2.72 0-4.67-1.636-4.67-4.075h9.695c.503 0 .857.327.857.832v9.756c-2.424 0-4.079-1.963-4.079-4.7zm4.818-4.82h-1.803c-2.72 0-4.67-1.665-4.67-4.104h9.695c.503 0 .828.357.828.833v9.756c-2.424 0-4.05-1.963-4.05-4.7z\"/>\n</svg>\n";
function $b8427b7cd125f4a4$export$bf4c5f97b468e8d6(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Jira' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $e41bbd286dd6d71c$export$f827d3c5a9c3f644), {
        svg: $b8427b7cd125f4a4$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::9f5d94b0d7bf822b6ab4c2ad26c21970>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $ea3a5a23799cf5fe$var$svg = "<svg height=\"100%\" viewBox=\"0 0 100 32\">\n    <path fill=\"var(--icon-color, #101214)\" d=\"M66.71 5.11c0 1.08.49 1.93 2.47 2.31 1.16.26 1.41.44 1.41.82 0 .39-.26.62-1.08.62-.95 0-2.08-.33-2.83-.77v1.75c.59.28 1.36.62 2.83.62 2.06 0 2.85-.92 2.85-2.26m0 .03c0-1.28-.67-1.88-2.59-2.29-1.05-.23-1.31-.46-1.31-.8 0-.41.39-.59 1.08-.59.85 0 1.67.26 2.47.62V3.5c-.56-.28-1.41-.49-2.41-.49-1.9 0-2.88.82-2.88 2.16m26.29-2.11v7.32h1.57V4.81l.64 1.46 2.21 4.11h1.95V3.06h-1.54v4.73l-.59-1.39-1.77-3.34zm-9.91 0h-1.7v7.32h1.7zM79.45 8.2c0-1.28-.67-1.88-2.59-2.29-1.05-.23-1.31-.46-1.31-.8 0-.41.39-.59 1.08-.59.85 0 1.67.26 2.47.62V3.47c-.56-.28-1.41-.49-2.41-.49-1.9 0-2.88.82-2.88 2.16 0 1.08.49 1.93 2.47 2.31 1.16.26 1.41.44 1.41.82s-.26.62-1.08.62c-.95 0-2.08-.33-2.83-.77v1.75c.59.28 1.36.62 2.83.62 2.03 0 2.85-.92 2.85-2.29M53.5 3.06v7.32h3.49l.54-1.59h-2.34V3.06zm-6.91 0v1.57h1.88v5.75h1.72V4.63h2.03V3.06zm-2.49 0h-2.24l-2.54 7.32h1.95l.36-1.23c.44.13.9.21 1.36.21s.93-.08 1.36-.21l.36 1.23h1.95c-.03 0-2.57-7.32-2.57-7.32m-1.13 4.75c-.33 0-.64-.05-.93-.13l.93-3.19.93 3.19c-.28.08-.59.13-.92.13m20.06-4.75H60.8l-2.57 7.32h1.95l.36-1.23c.44.13.9.21 1.36.21s.93-.08 1.36-.21l.36 1.23h1.95zM61.9 7.81c-.33 0-.64-.05-.92-.13l.93-3.19.93 3.19c-.28.08-.59.13-.92.13m27.32-4.75h-2.23l-2.54 7.32h1.95l.36-1.23c.44.13.9.21 1.36.21s.93-.08 1.36-.21l.36 1.23h1.95zm-1.11 4.75c-.33 0-.64-.05-.92-.13l.93-3.19.93 3.19a3.7 3.7 0 0 1-.92.13\"/>\n    <path fill=\"var(--tile-color,#1868db)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, white)\" d=\"M25.375 15.31H19.99l4.664-2.693-1.024-1.775-4.664 2.693 2.692-4.664-1.775-1.025-2.692 4.664V7.125h-2.048v5.385l-2.694-4.664-1.774 1.025 2.693 4.663-4.664-2.692-1.024 1.774 4.664 2.693H6.958v2.048h5.385L7.68 20.05l1.024 1.775 4.663-2.693-2.692 4.664 1.774 1.024 2.693-4.664v5.386h2.049v-5.385l2.692 4.663 1.774-1.024-2.692-4.664 4.663 2.693 1.025-1.775-4.664-2.692h5.385zm-9.208 3.81a2.797 2.797 0 1 1 0-5.594 2.797 2.797 0 0 1 0 5.593\"/>\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M39.32 27.74v-13.7h2.52v13.7zm24.13-9.31h2.4v1.14c.51-.91 1.7-1.4 2.72-1.4 1.27 0 2.29.55 2.76 1.55.74-1.14 1.72-1.55 2.95-1.55 1.72 0 3.37 1.04 3.37 3.54v6.04h-2.44v-5.53c0-1-.49-1.76-1.65-1.76-1.08 0-1.72.83-1.72 1.84v5.45h-2.49v-5.53c0-1-.51-1.76-1.65-1.76-1.1 0-1.74.81-1.74 1.84v5.45h-2.52zm-15.93 9.58c-2.83 0-4.89-2.1-4.89-4.93 0-2.78 2.05-4.93 4.89-4.93 2.85 0 4.89 2.17 4.89 4.93 0 2.8-2.05 4.93-4.89 4.93m0-7.58a2.65 2.65 0 0 0-2.65 2.65 2.65 2.65 0 0 0 2.65 2.65c1.46 0 2.65-1.19 2.65-2.65a2.65 2.65 0 0 0-2.65-2.65m10.26 7.58c-2.83 0-4.89-2.1-4.89-4.93 0-2.78 2.05-4.93 4.89-4.93 2.85 0 4.89 2.17 4.89 4.93 0 2.8-2.06 4.93-4.89 4.93m0-7.61a2.69 2.69 0 0 0-2.68 2.68 2.69 2.69 0 0 0 2.68 2.68 2.69 2.69 0 0 0 2.68-2.68 2.69 2.69 0 0 0-2.68-2.68\"/>\n</svg>\n";
function $ea3a5a23799cf5fe$export$68d7391318cdef11(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Loom Attribution' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $e41bbd286dd6d71c$export$f827d3c5a9c3f644), {
        svg: $ea3a5a23799cf5fe$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::26f3036375895bf30dc2c16f910588fe>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
var $0037dccf1a2ffc9b$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#625df5)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, white)\" d=\"M19.083 11.212h-4.142l3.588-2.071-.788-1.365-3.588 2.071 2.07-3.587-1.364-.788-2.071 3.587V4.917h-1.576v4.142L9.141 5.472l-1.365.787 2.071 3.588L6.26 7.776 5.472 9.14l3.587 2.07H4.917v1.577h4.142l-3.587 2.071.788 1.365 3.587-2.07-2.071 3.587 1.365.787 2.07-3.587v4.142h1.577V14.94l2.07 3.587 1.365-.787-2.07-3.588 3.587 2.071.788-1.365-3.587-2.07h4.142zM12 14.143a2.151 2.151 0 1 1 0-4.302 2.151 2.151 0 0 1 0 4.302\"/>\n</svg>\n";
function $0037dccf1a2ffc9b$export$38c7b37a3e5e8d70(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Loom' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $ea406245305817b7$export$be58b4326e23250f), {
        svg: $0037dccf1a2ffc9b$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::bf5c00a6af1a30f7d2914e27e51f1aff>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $cae5ef80681b4ec4$var$svg = "<svg height=\"100%\" viewBox=\"0 0 103 32\">\n    <path fill=\"var(--tile-color,#625df5)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, white)\" d=\"M25.375 15.31H19.99l4.664-2.693-1.024-1.775-4.664 2.693 2.692-4.663-1.775-1.025-2.692 4.663V7.125h-2.048v5.386l-2.694-4.664-1.774 1.024 2.693 4.664-4.664-2.693-1.024 1.774 4.664 2.693H6.959v2.049h5.384L7.68 20.05l1.024 1.774 4.663-2.692-2.692 4.664 1.774 1.024 2.693-4.664v5.385h2.049v-5.385l2.692 4.664 1.774-1.024-2.692-4.665 4.663 2.693 1.025-1.774-4.664-2.693h5.385zm-9.208 3.81a2.797 2.797 0 1 1 0-5.593 2.797 2.797 0 0 1 0 5.593\"/>\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M42.67 25.34V3.93h3.93v21.41zm37.7-14.55h3.75v1.78c.8-1.42 2.66-2.19 4.26-2.19 1.98 0 3.58.86 4.32 2.43 1.15-1.77 2.69-2.42 4.61-2.42 2.69 0 5.26 1.63 5.26 5.53v9.43h-3.81v-8.63c0-1.57-.77-2.75-2.57-2.75-1.68 0-2.69 1.3-2.69 2.87v8.52h-3.9v-8.63c0-1.57-.8-2.75-2.57-2.75-1.71 0-2.72 1.27-2.72 2.87v8.52h-3.93zM55.48 25.77c-4.43 0-7.63-3.28-7.63-7.7 0-4.34 3.2-7.7 7.64-7.7 4.46 0 7.63 3.39 7.63 7.7 0 4.38-3.21 7.7-7.63 7.7m0-11.84a4.15 4.15 0 0 0-4.14 4.14 4.15 4.15 0 0 0 4.14 4.14 4.15 4.15 0 0 0 4.14-4.14 4.15 4.15 0 0 0-4.14-4.14m16.02 11.84c-4.43 0-7.63-3.28-7.63-7.7 0-4.34 3.2-7.7 7.63-7.7 4.46 0 7.64 3.39 7.64 7.7 0 4.38-3.21 7.7-7.63 7.7m0-11.89c-2.31 0-4.19 1.88-4.19 4.19s1.88 4.19 4.19 4.19 4.19-1.88 4.19-4.19-1.88-4.19-4.19-4.19\"/>\n</svg>\n";
function $cae5ef80681b4ec4$export$71743a944cb62e48(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Loom' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $e41bbd286dd6d71c$export$f827d3c5a9c3f644), {
        svg: $cae5ef80681b4ec4$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::568f663154fd35333110385dd0c22e41>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
var $9ba54b7379c689ca$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#1868db)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, white)\" d=\"M19.083 11.212h-4.142l3.588-2.071-.788-1.365-3.588 2.071 2.07-3.587-1.364-.788-2.071 3.587V4.917h-1.576v4.142L9.141 5.472l-1.365.787 2.071 3.588L6.26 7.776 5.472 9.14l3.587 2.07H4.917v1.577h4.142l-3.587 2.071.788 1.365 3.587-2.07-2.071 3.587 1.365.787 2.07-3.587v4.142h1.577V14.94l2.07 3.587 1.365-.787-2.07-3.588 3.587 2.071.788-1.365-3.587-2.07h4.142zM12 14.143a2.151 2.151 0 1 1 0-4.302 2.151 2.151 0 0 1 0 4.302\"/>\n</svg>\n";
function $9ba54b7379c689ca$export$8d789f76fde3e05(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Loom' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $ea406245305817b7$export$be58b4326e23250f), {
        svg: $9ba54b7379c689ca$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2d69248f39a87c063a78e83a58b63bd7>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $7374062c1ee90a71$var$svg = "<svg height=\"100%\" viewBox=\"0 0 103 32\">\n    <path fill=\"var(--tile-color,#1868db)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, white)\" d=\"M25.375 15.31H19.99l4.664-2.693-1.024-1.775-4.664 2.693 2.692-4.663-1.775-1.025-2.692 4.663V7.125h-2.048v5.386l-2.694-4.664-1.774 1.024 2.693 4.664-4.664-2.693-1.024 1.774 4.664 2.693H6.959v2.049h5.384L7.68 20.05l1.024 1.774 4.663-2.692-2.692 4.664 1.774 1.024 2.693-4.664v5.385h2.049v-5.385l2.692 4.664 1.774-1.024-2.692-4.665 4.663 2.693 1.025-1.774-4.664-2.693h5.385zm-9.208 3.81a2.797 2.797 0 1 1 0-5.593 2.797 2.797 0 0 1 0 5.593\"/>\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M42.67 25.34V3.93h3.93v21.41zm37.7-14.55h3.75v1.78c.8-1.42 2.66-2.19 4.26-2.19 1.98 0 3.58.86 4.32 2.43 1.15-1.77 2.69-2.42 4.61-2.42 2.69 0 5.26 1.63 5.26 5.53v9.43h-3.81v-8.63c0-1.57-.77-2.75-2.57-2.75-1.68 0-2.69 1.3-2.69 2.87v8.52h-3.9v-8.63c0-1.57-.8-2.75-2.57-2.75-1.71 0-2.72 1.27-2.72 2.87v8.52h-3.93zM55.48 25.77c-4.43 0-7.63-3.28-7.63-7.7 0-4.34 3.2-7.7 7.64-7.7 4.46 0 7.63 3.39 7.63 7.7 0 4.38-3.21 7.7-7.63 7.7m0-11.84a4.15 4.15 0 0 0-4.14 4.14 4.15 4.15 0 0 0 4.14 4.14 4.15 4.15 0 0 0 4.14-4.14 4.15 4.15 0 0 0-4.14-4.14m16.02 11.84c-4.43 0-7.63-3.28-7.63-7.7 0-4.34 3.2-7.7 7.63-7.7 4.46 0 7.64 3.39 7.64 7.7 0 4.38-3.21 7.7-7.63 7.7m0-11.89c-2.31 0-4.19 1.88-4.19 4.19s1.88 4.19 4.19 4.19 4.19-1.88 4.19-4.19-1.88-4.19-4.19-4.19\"/>\n</svg>\n";
function $7374062c1ee90a71$export$78c0b4d8be34c9b2(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Loom' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $e41bbd286dd6d71c$export$f827d3c5a9c3f644), {
        svg: $7374062c1ee90a71$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c11df6f0c8182479108e0649acaca190>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
var $9790da1506d41a4c$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M11.13 5.88H5.88v5.25h5.25zm0 7H5.88v5.25h5.25zm1.75-7h5.25v5.25h-5.25zm5.25 7h-5.25v5.25h5.25z\"/>\n</svg>\n";
function $9790da1506d41a4c$export$518f48548316ec87(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'More Atlassian Apps' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $ea406245305817b7$export$be58b4326e23250f), {
        svg: $9790da1506d41a4c$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2bf4732a418598faff0fcffc57f4a7b7>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
var $56e6725c26e2a528$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#ffc716)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M12.696 19.45c-.49.361-.749.336-1.24-.026-2.375-1.704-4.57-3.641-6.042-5.655-.155-.207-.078-.49.155-.62l2.685-1.678q.35-.233.62.077c1.033 1.188 2.04 2.35 3.202 3.176 1.162-.826 2.17-1.988 3.202-3.176q.272-.31.62-.078l2.686 1.679c.232.13.31.413.155.62-1.472 2.014-3.667 3.95-6.043 5.68m-.62-7.411c2.118 0 3.874-1.73 3.874-3.848s-1.756-3.9-3.874-3.9c-2.117 0-3.873 1.757-3.873 3.9s1.704 3.848 3.873 3.848\"/>\n</svg>\n";
function $56e6725c26e2a528$export$eeccc49dc7a12d9f(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Opsgenie' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $ea406245305817b7$export$be58b4326e23250f), {
        svg: $56e6725c26e2a528$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::032f8fa95ed51413adb506dd076fd343>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $e25b2b9203237613$var$svg = "<svg height=\"100%\" viewBox=\"0 0 164 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M156.69 12.09c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.67-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zM143.39 5.95c0-1.16.77-1.84 1.84-1.84s1.84.68 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zm-3.68-8.98v8.99h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.51c.98-1.81 2.79-2.82 4.85-2.82 3.53 0 5.55 2.42 5.55 6.66m-22.92-4.26c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.67-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-18.64-.62v-1.53c-.98 2.02-2.82 3.07-5.18 3.07-4.05 0-6.07-3.47-6.07-7.97 0-4.32 2.12-7.97 6.38-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.58v13.95c0 4.51-2.12 7.54-7.6 7.54-2.58 0-3.99-.34-5.46-.83v-2.58c1.69.55 3.44.92 5.34.92 3.83 0 5.15-2.06 5.15-4.91m-8.68-6.44c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m-4.72 3.52c0 2.55-1.66 4.48-5.76 4.48-2.3 0-4.17-.52-5.34-1.13v-2.79c1.32.77 3.53 1.5 5.46 1.5 2.02 0 3.07-.83 3.07-2.02 0-1.17-.89-1.84-3.8-2.55-3.4-.83-4.85-2.15-4.85-4.66 0-2.67 2.06-4.29 5.55-4.29 1.99 0 3.8.49 4.94 1.1v2.73c-1.84-.92-3.34-1.41-4.97-1.41-1.93 0-2.97.67-2.97 1.87 0 1.07.74 1.75 3.56 2.42 3.4.83 5.12 2.09 5.12 4.75m-16.29-3.49c0-3.68-1.47-5.52-4.2-5.52-2.36 0-4.48 1.5-4.48 4.91v1.23c0 3.4 1.93 4.91 4.17 4.91 2.98 0 4.51-1.96 4.51-5.52m-3.8 7.97c-2.24 0-3.96-1.01-4.88-3.01v8.68h-2.64V10h2.64v2.76c.98-2.02 2.82-3.07 5.18-3.07 4.08 0 6.13 3.47 6.13 7.97 0 4.32-2.15 7.97-6.44 7.97m-20.11.01c-6.22 0-9.72-4.29-9.72-10.43 0-6.07 3.5-10.33 9.72-10.33 6.2 0 9.69 4.26 9.69 10.34 0 6.13-3.5 10.43-9.69 10.43m0-18.12c-4.97 0-6.96 3.53-6.96 7.7 0 4.26 1.99 7.79 6.96 7.79 4.94 0 6.93-3.53 6.93-7.79 0-4.17-1.99-7.7-6.93-7.7\"/>\n    <path fill=\"var(--tile-color,#ffc716)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M16.905 25.684c-.638.47-.974.437-1.612-.033-3.088-2.216-5.942-4.734-7.855-7.352-.202-.269-.1-.638.201-.806l3.491-2.182q.454-.302.806.1c1.343 1.545 2.652 3.056 4.163 4.13 1.51-1.074 2.82-2.585 4.163-4.13q.352-.402.805-.1l3.491 2.182c.303.168.403.537.202.806-1.914 2.618-4.767 5.136-7.855 7.385m-.806-9.635c2.753 0 5.035-2.249 5.035-5.001s-2.282-5.07-5.035-5.07-5.036 2.283-5.036 5.07c0 2.786 2.216 5.001 5.036 5.001\"/>\n</svg>\n";
function $e25b2b9203237613$export$a5b9122e89b32ad3(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Opsgenie' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $e41bbd286dd6d71c$export$f827d3c5a9c3f644), {
        svg: $e25b2b9203237613$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::1c3a56195279b145c83aee2d39dd6918>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
var $edb3306bd5797c7e$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, #101214)\" fill-rule=\"evenodd\" d=\"m5.106 14.44 1.856-1.856-1.856-1.856L6.653 9.18h3.712l2.784-2.784h4.332v4.33l-2.785 2.785v3.712L13.15 18.77l-1.857-1.856-1.856 1.856-1.7-1.7 2.784-2.784-.928-.928-2.784 2.784zm10.209-4.331a1.094 1.094 0 1 1-1.547-1.546 1.094 1.094 0 0 1 1.547 1.546\" clip-rule=\"evenodd\"/>\n</svg>\n";
function $edb3306bd5797c7e$export$5ed3e1bb3b04fc02(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Projects' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $ea406245305817b7$export$be58b4326e23250f), {
        svg: $edb3306bd5797c7e$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2700d019c02f76a45bbbdb7e71fedfcb>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $6f2a7674410f41a5$var$svg = "<svg height=\"100%\" viewBox=\"0 0 145 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M144.54 21.16c0 2.55-1.66 4.48-5.77 4.48-2.3 0-4.17-.52-5.34-1.13v-2.79c1.32.77 3.53 1.5 5.46 1.5 2.02 0 3.07-.83 3.07-2.02 0-1.17-.89-1.84-3.8-2.55-3.4-.83-4.84-2.15-4.84-4.66 0-2.67 2.05-4.29 5.55-4.29 1.99 0 3.8.49 4.94 1.1v2.73c-1.84-.92-3.34-1.41-4.97-1.41-1.93 0-2.97.67-2.97 1.87 0 1.07.74 1.75 3.56 2.42 3.4.83 5.12 2.09 5.12 4.75m-17.75-.58c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55c-.46.12-.98.25-1.78.25-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zm-6.66 1.99v2.36c-.92.49-2.33.71-3.74.71-5.46 0-8-3.31-8-8 0-4.63 2.55-7.94 8-7.94 1.38 0 2.45.18 3.65.74v2.45c-.98-.46-2.02-.74-3.47-.74-3.99 0-5.61 2.52-5.61 5.49s1.66 5.49 5.67 5.49c1.56 0 2.55-.21 3.5-.55M99.43 12.09c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.67-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.2c.37 2.61 2.05 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zM83.8 31.25v-2.36c.31.03.49.03.77.03 1.13 0 2.05-.49 2.05-1.87V10h2.64v17.36c0 2.82-1.59 4.02-4.11 4.02-.67 0-1.13-.06-1.35-.12m2.3-25.3c0-1.16.77-1.84 1.84-1.84s1.84.68 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84M76.07 25.64c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49M62.3 16.29v9.05h-2.58V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.67-5.43 3.93m-5-4.4c0 4.39-2.45 6.84-7.48 6.84H45.8v6.59h-2.76V5.19h6.78c5.03 0 7.48 2.58 7.48 6.72m-7.79 4.2c3.56.12 4.94-1.56 4.94-4.14 0-2.45-1.38-4.14-4.94-4.14H45.8v8.28z\"/>\n    <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, #101214)\" fill-rule=\"evenodd\" d=\"m6.152 19.486 2.651-2.652-2.651-2.651 2.21-2.21h5.303l3.977-3.977h6.187v6.187l-3.977 3.977v5.304l-2.21 2.21-2.652-2.652-2.651 2.651-2.429-2.428 3.978-3.978-1.326-1.325-3.978 3.977zM20.736 13.3a1.562 1.562 0 1 1-2.21-2.21 1.562 1.562 0 0 1 2.21 2.21\" clip-rule=\"evenodd\"/>\n</svg>\n";
function $6f2a7674410f41a5$export$e3d1678155aaab99(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Projects' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $e41bbd286dd6d71c$export$f827d3c5a9c3f644), {
        svg: $6f2a7674410f41a5$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::694cf9c8d8336e73333c711f4777239b>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
var $060c38b32af8b408$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#94c748)\" d=\"M10.7.368a2.75 2.75 0 0 1 2.748 0l8.016 4.626a2.75 2.75 0 0 1 1.375 2.38v9.252c0 .982-.524 1.889-1.375 2.38l-8.016 4.626a2.75 2.75 0 0 1-2.749 0l-8.016-4.626a2.75 2.75 0 0 1-1.374-2.38V7.374c0-.982.524-1.889 1.374-2.38z\"/>\n    <path fill=\"var(--icon-color, #101214)\" fill-rule=\"evenodd\" d=\"M10.181 6.096 6.777 8.06a1.53 1.53 0 0 0-.768 1.327v5.229c0 .547.294 1.054.768 1.327l.807.466 3.722 2.149a1.54 1.54 0 0 0 1.508.014l.027-.018a1.54 1.54 0 0 0 .766-1.323v-2.026l-1.97-1.137-.568-.327a2 2 0 0 1-1.006-1.74V6.775a2 2 0 0 1 .118-.678\" clip-rule=\"evenodd\"/>\n    <path fill=\"var(--icon-color, #101214)\" fill-rule=\"evenodd\" d=\"M12.842 5.441a1.54 1.54 0 0 0-1.508-.014l-.028.019a1.54 1.54 0 0 0-.765 1.323v2.025l1.91 1.102.628.362a2 2 0 0 1 1.006 1.74v5.228a2 2 0 0 1-.118.678l3.404-1.965c.476-.273.767-.778.767-1.327V9.383c0-.546-.293-1.054-.767-1.327l-.868-.501z\" clip-rule=\"evenodd\"/>\n</svg>\n";
function $060c38b32af8b408$export$813cff80931d9dbf(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Rovo Dev Agent' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $ea406245305817b7$export$be58b4326e23250f), {
        svg: $060c38b32af8b408$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3e07b5682123be769fa70cfe7a8367bf>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $d3f159e3e0f2a2f6$var$svg = "<svg height=\"100%\" viewBox=\"0 0 160 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M153.94 25.67h-3.53l-5.95-15.33h2.76l4.97 13.1 4.94-13.09h2.76zM136.3 12.42c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.67-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.2c.37 2.61 2.05 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-25.13-16.9h-4.54v14.87h4.69c4.6 0 6.9-2.42 6.9-7.3 0-4.91-2.18-7.57-7.05-7.57m-7.3 17.51V5.52h7.42c6.53 0 9.69 4.08 9.69 10.12 0 6.1-3.19 10.03-9.69 10.03zm-16.25.31c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49M79.49 25.67h-3.53l-5.95-15.33h2.76l4.97 13.1 4.94-13.09h2.76zm-17.46.31c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49M45 8.16h-4.05v7.36H45c3.59 0 4.69-1.38 4.69-3.68 0-2.18-1.13-3.68-4.69-3.68m7.45 3.62c0 3.04-1.29 5.09-3.96 5.95l4.94 7.94h-3.25l-4.45-7.51h-4.78v7.51h-2.76V5.52h7.11c4.82 0 7.15 2.39 7.15 6.26\"/>\n    <path fill=\"var(--tile-color,#94c748)\" d=\"M12.52.49a3.67 3.67 0 0 1 3.666 0l10.688 6.17a3.66 3.66 0 0 1 1.833 3.173v12.336a3.66 3.66 0 0 1-1.833 3.173L16.186 31.51a3.67 3.67 0 0 1-3.665 0L1.833 25.341A3.66 3.66 0 0 1 0 22.168V9.832c0-1.309.7-2.519 1.833-3.173z\"/>\n    <path fill=\"var(--icon-color, #101214)\" fill-rule=\"evenodd\" d=\"m11.83 8.128-4.54 2.62a2.04 2.04 0 0 0-1.022 1.77v6.972c0 .728.39 1.405 1.023 1.77l1.076.62 4.963 2.865a2.05 2.05 0 0 0 2.01.02l.037-.025c.445-.257.771-.67.925-1.146q.094-.297.095-.619v-2.7l-2.627-1.516-.757-.436a2.67 2.67 0 0 1-1.34-2.32v-6.97a2.7 2.7 0 0 1 .157-.904\" clip-rule=\"evenodd\"/>\n    <path fill=\"var(--icon-color, #101214)\" fill-rule=\"evenodd\" d=\"M15.377 7.255a2.05 2.05 0 0 0-2.01-.019l-.038.026c-.445.257-.77.67-.924 1.145a2 2 0 0 0-.095.618v2.7l2.545 1.47.839.483a2.67 2.67 0 0 1 1.34 2.319v6.972a2.7 2.7 0 0 1-.157.903l4.54-2.62a2.04 2.04 0 0 0 1.022-1.77v-6.971c0-.729-.39-1.405-1.023-1.77l-1.157-.668z\" clip-rule=\"evenodd\"/>\n</svg>\n";
function $d3f159e3e0f2a2f6$export$58747af448450872(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Rovo Dev Agent' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $e41bbd286dd6d71c$export$f827d3c5a9c3f644), {
        svg: $d3f159e3e0f2a2f6$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a1131b9b9b6248ab2f320c07042466bf>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
var $691163a2b70932c4$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#94c748)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M11.26 4.71a1.7 1.7 0 0 1 1.666.017l5.006 2.89c.524.302.848.863.848 1.467v5.78a1.69 1.69 0 0 1-.848 1.467l-3.763 2.172.024-.07c.07-.216.107-.445.107-.679v-5.78c0-.794-.423-1.526-1.112-1.922l-2.805-1.62V6.195q.001-.267.08-.512c.126-.395.396-.737.765-.95l.002-.001z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M9.986 5.45 6.223 7.623a1.69 1.69 0 0 0-.848 1.466v5.78c0 .605.324 1.166.848 1.468l5.006 2.89a1.7 1.7 0 0 0 1.666.016l.03-.02c.37-.214.64-.556.768-.95q.078-.247.079-.513v-2.24l-2.805-1.618a2.22 2.22 0 0 1-1.112-1.922V6.2a2.2 2.2 0 0 1 .13-.75\"/>\n</svg>\n";
function $691163a2b70932c4$export$8b784b3227531b3e(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Rovo Dev' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $ea406245305817b7$export$be58b4326e23250f), {
        svg: $691163a2b70932c4$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::8e3612ac67ced6c8ac8b271a1aa6aa8b>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $742d58e4c2d2955f$var$svg = "<svg height=\"100%\" viewBox=\"0 0 165 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M158.79 25.33h-3.53L149.32 10h2.76l4.97 13.1 4.93-13.1h2.76zm-17.64-13.24c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.05 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zM121.91 7.82h-4.54v14.87h4.69c4.6 0 6.9-2.42 6.9-7.3 0-4.91-2.18-7.57-7.05-7.57m-7.3 17.51V5.19h7.42c6.53 0 9.69 4.08 9.69 10.12 0 6.1-3.19 10.03-9.69 10.03zm-16.26.31c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49M84.34 25.33h-3.53L74.86 10h2.76l4.97 13.1L87.53 10h2.76zm-17.46.31c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49M49.84 7.82h-4.05v7.36h4.05c3.59 0 4.69-1.38 4.69-3.68 0-2.18-1.13-3.68-4.69-3.68m7.45 3.62c0 3.04-1.29 5.09-3.96 5.95l4.94 7.94h-3.25l-4.44-7.51H45.8v7.51h-2.76V5.19h7.12c4.81 0 7.15 2.39 7.15 6.26\"/>\n    <path fill=\"var(--tile-color,#94c748)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M15.013 6.281a2.26 2.26 0 0 1 2.222.021l6.674 3.854a2.26 2.26 0 0 1 1.131 1.956v7.707c0 .809-.43 1.553-1.13 1.956l-5.018 2.896.032-.093c.093-.289.142-.594.142-.906v-7.707a2.95 2.95 0 0 0-1.481-2.563l-3.74-2.158V8.258c0-.235.036-.465.105-.682a2.26 2.26 0 0 1 1.021-1.267h.002z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"m13.314 7.267-5.017 2.896a2.25 2.25 0 0 0-1.13 1.956v7.707c0 .806.432 1.553 1.13 1.956l6.675 3.854c.686.396 1.53.403 2.222.02l.04-.026c.493-.284.853-.74 1.023-1.267a2.3 2.3 0 0 0 .105-.683v-2.986l-3.74-2.158a2.96 2.96 0 0 1-1.482-2.563V8.266a3 3 0 0 1 .174-1\"/>\n</svg>\n";
function $742d58e4c2d2955f$export$4145bd793c9ed1d0(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Rovo Dev' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $e41bbd286dd6d71c$export$f827d3c5a9c3f644), {
        svg: $742d58e4c2d2955f$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a7bd8774a1a483ce4ec625e53d5f111c>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
var $a234058df5e65e66$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--rovo-blue-color, #1868db)\" fill-rule=\"evenodd\" d=\"m13.227 16.789-7.154 4.169-3.403-1.96a2.72 2.72 0 0 1-1.362-2.355V7.366c0-.973.518-1.87 1.361-2.354l6.044-3.487-.038.114a3.6 3.6 0 0 0-.172 1.088v9.278c0 1.274.68 2.45 1.786 3.085z\" clip-rule=\"evenodd\"/>\n    <path fill=\"var(--rovo-green-color, #6a9a23)\" fill-rule=\"evenodd\" d=\"m11.296 15.671-7.193 4.153 6.607 3.812a2.73 2.73 0 0 0 2.676.026l.048-.033a2.73 2.73 0 0 0 1.232-1.525 2.7 2.7 0 0 0 .127-.822v-3.594z\" clip-rule=\"evenodd\"/>\n    <path fill=\"var(--rovo-purple-color, #af59e1)\" fill-rule=\"evenodd\" d=\"m21.477 5.003-4.404-2.539-5.904 4.89 2.69 1.556a3.56 3.56 0 0 1 1.785 3.086v9.277a3.6 3.6 0 0 1-.21 1.202l6.044-3.486a2.71 2.71 0 0 0 1.362-2.355V7.357c0-.97-.521-1.87-1.363-2.354\" clip-rule=\"evenodd\"/>\n    <path fill=\"var(--rovo-yellow-color, #fca700)\" fill-rule=\"evenodd\" d=\"M12.74 8.266 9.353 6.312V2.718c0-.283.044-.56.127-.821A2.73 2.73 0 0 1 10.71.372V.37a.4.4 0 0 0 .048-.033 2.73 2.73 0 0 1 2.676.026l6.499 3.75z\" clip-rule=\"evenodd\"/>\n</svg>\n";
function $a234058df5e65e66$export$9e62346a60cfb459(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Rovo' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $ea406245305817b7$export$be58b4326e23250f), {
        svg: $a234058df5e65e66$var$svg,
        label: label,
        type: "rovo",
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::81d74fa5dbe2e1ea12f9e61d6b58e6d8>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $5a769e9664562a1b$var$svg = "<svg height=\"100%\" viewBox=\"0 0 102 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M93.5 25.97c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49M79.49 25.67h-3.53l-5.95-15.33h2.76l4.97 13.1 4.94-13.09h2.76zm-17.46.3c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49M44.99 8.16h-4.05v7.36h4.05c3.59 0 4.69-1.38 4.69-3.68 0-2.18-1.13-3.68-4.69-3.68m7.45 3.62c0 3.04-1.29 5.09-3.96 5.95l4.94 7.94h-3.25l-4.45-7.51h-4.78v7.51h-2.76V5.52h7.11c4.82 0 7.15 2.39 7.15 6.26\"/>\n    <path fill=\"var(--rovo-blue-color, #1868db)\" fill-rule=\"evenodd\" d=\"m15.892 22.385-9.538 5.559-4.538-2.613A3.63 3.63 0 0 1 0 22.19V9.821C0 8.524.69 7.33 1.816 6.682l8.058-4.649-.052.152a4.7 4.7 0 0 0-.228 1.452v12.37a4.74 4.74 0 0 0 2.38 4.113z\" clip-rule=\"evenodd\"/>\n    <path fill=\"var(--rovo-green-color, #6a9a23)\" fill-rule=\"evenodd\" d=\"m13.318 20.895-9.591 5.538 8.809 5.082a3.64 3.64 0 0 0 3.568.034l.065-.043a3.63 3.63 0 0 0 1.642-2.034c.11-.35.17-.718.17-1.096v-4.792z\" clip-rule=\"evenodd\"/>\n    <path fill=\"var(--rovo-purple-color, #af59e1)\" fill-rule=\"evenodd\" d=\"M26.893 6.67 21.02 3.285l-7.873 6.52 3.587 2.075a4.74 4.74 0 0 1 2.38 4.115v12.369a4.7 4.7 0 0 1-.28 1.603l8.058-4.649a3.62 3.62 0 0 0 1.816-3.139V9.81a3.63 3.63 0 0 0-1.816-3.139\" clip-rule=\"evenodd\"/>\n    <path fill=\"var(--rovo-yellow-color, #fca700)\" fill-rule=\"evenodd\" d=\"m15.244 11.022-4.519-2.606V3.625c0-.378.059-.747.17-1.096a3.63 3.63 0 0 1 1.64-2.033l.002-.001.064-.044a3.64 3.64 0 0 1 3.569.034l8.665 5z\" clip-rule=\"evenodd\"/>\n</svg>\n";
function $5a769e9664562a1b$export$5e38d02efdb45577(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Rovo' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $e41bbd286dd6d71c$export$f827d3c5a9c3f644), {
        svg: $5a769e9664562a1b$var$svg,
        label: label,
        type: "rovo",
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::4fdd9cdb3dfb222b9beb33bde63bcd67>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
var $95f5787f042884e2$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#1868db)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, white)\" d=\"M11.057 5.257a1.57 1.57 0 0 1 1.539.015l4.621 2.668c.484.279.783.797.783 1.354v5.336a1.56 1.56 0 0 1-.782 1.355l-3.474 2.005a2 2 0 0 0 .12-.691v-5.337c0-.733-.39-1.409-1.026-1.774l-2.59-1.495V6.626q.001-.246.074-.473c.117-.364.366-.68.707-.877z\"/>\n    <path fill=\"var(--icon-color, white)\" d=\"M9.881 5.94 6.408 7.945A1.56 1.56 0 0 0 5.625 9.3v5.337c0 .557.3 1.075.783 1.354l4.621 2.668c.475.274 1.06.279 1.539.015l.027-.019a1.57 1.57 0 0 0 .781-1.35v-2.067l-2.589-1.495a2.05 2.05 0 0 1-1.026-1.775V6.631a2 2 0 0 1 .12-.691\"/>\n</svg>\n";
function $95f5787f042884e2$export$e23ae35269442b4f(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Rovo' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $ea406245305817b7$export$be58b4326e23250f), {
        svg: $95f5787f042884e2$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::078cc586ef0207819d6635adebbccf14>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $711e7e8829bebe36$var$svg = "<svg height=\"100%\" viewBox=\"0 0 106 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M98.36 25.64c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49M84.34 25.33h-3.53L74.87 10h2.76l4.97 13.1L87.53 10h2.76zm-17.46.31c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49M49.84 7.82h-4.05v7.36h4.05c3.59 0 4.69-1.38 4.69-3.68 0-2.18-1.13-3.68-4.69-3.68m7.45 3.62c0 3.04-1.29 5.09-3.96 5.95l4.94 7.94h-3.25l-4.44-7.51H45.8v7.51h-2.76V5.19h7.12c4.81 0 7.15 2.39 7.15 6.26\"/>\n    <path fill=\"var(--tile-color,#1868db)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, white)\" d=\"M15.013 6.281a2.26 2.26 0 0 1 2.222.021l6.674 3.854a2.26 2.26 0 0 1 1.131 1.956v7.707c0 .809-.43 1.553-1.13 1.956l-5.018 2.896q.017-.046.032-.093c.093-.289.142-.594.142-.906v-7.707a2.95 2.95 0 0 0-1.481-2.563l-3.74-2.158V8.258c0-.235.036-.465.105-.682.17-.527.529-.983 1.021-1.267h.002z\"/>\n    <path fill=\"var(--icon-color, white)\" d=\"m13.314 7.267-5.017 2.896a2.25 2.25 0 0 0-1.13 1.956v7.707c0 .806.432 1.553 1.13 1.956l6.675 3.854c.686.396 1.53.403 2.222.02l.04-.026c.493-.284.853-.74 1.023-1.267a2.3 2.3 0 0 0 .105-.683v-2.986l-3.74-2.158a2.96 2.96 0 0 1-1.482-2.563V8.266a3 3 0 0 1 .174-1\"/>\n</svg>\n";
function $711e7e8829bebe36$export$b0e15f0a1c9f4c55(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Rovo' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $e41bbd286dd6d71c$export$f827d3c5a9c3f644), {
        svg: $711e7e8829bebe36$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e8449a5cf6c2f473179dfe4bd9893163>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
var $bed70d726c9e412c$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 6.625a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, #101214)\" fill-rule=\"evenodd\" d=\"M10.76 17.176a5.791 5.791 0 1 1 5.038-2.935l3.403 3.403-2.205 2.204-3.409-3.408a5.77 5.77 0 0 1-2.827.736m-.274-9.37-.242.615c-.344.874-.516 1.312-.833 1.64-.318.33-.749.518-1.61.893l-.37.16v.51l.37.16c.861.376 1.292.563 1.61.893.317.329.49.766.833 1.64l.242.616h.51l.242-.616c.344-.874.516-1.311.834-1.64.317-.33.748-.517 1.61-.893l.368-.16v-.51l-.369-.16c-.861-.375-1.292-.563-1.61-.892-.317-.33-.489-.766-.833-1.64l-.242-.616z\" clip-rule=\"evenodd\"/>\n</svg>\n";
function $bed70d726c9e412c$export$82eafebb825fc23f(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Search' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $ea406245305817b7$export$be58b4326e23250f), {
        svg: $bed70d726c9e412c$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::17e42f012731a68dbb72bc00bc08f838>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $00d48bb4f32e535d$var$svg = "<svg height=\"100%\" viewBox=\"0 0 130 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M128.82 16.35v8.99h-2.64v-8.52c0-3.16-1.1-4.72-3.62-4.72-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V3.59h2.64v8.96c1.01-1.81 2.85-2.85 5.06-2.85 3.44 0 5.34 2.33 5.34 6.66m-16.05 6.21v2.36c-.92.49-2.33.71-3.74.71-5.46 0-8-3.31-8-8 0-4.63 2.55-7.94 8-7.94 1.38 0 2.45.18 3.65.74v2.45c-.98-.46-2.02-.74-3.46-.74-3.99 0-5.61 2.52-5.61 5.49s1.66 5.49 5.67 5.49c1.56 0 2.55-.21 3.5-.55m-18.23-6.29v9.05h-2.58V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.67-5.43 3.93m-17.87 1.37c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.47-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zM65.08 12.09c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.67-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.2c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-15.33-4.95c0 3.5-2.08 5.86-7.08 5.86-3.89 0-5.7-.77-7.27-1.56v-2.82c1.87.98 4.75 1.69 7.42 1.69 3.04 0 4.17-1.2 4.17-2.97s-1.1-2.73-4.94-3.65c-4.54-1.1-6.56-2.67-6.56-5.98 0-3.13 2.39-5.46 7.08-5.46 2.91 0 4.78.71 6.16 1.47v2.76c-2.02-1.16-4.2-1.53-6.29-1.53-2.64 0-4.2.92-4.2 2.76 0 1.66 1.29 2.48 4.85 3.37 4.26 1.07 6.66 2.45 6.66 6.07\"/>\n    <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, #101214)\" fill-rule=\"evenodd\" d=\"M14.346 22.068a7.721 7.721 0 1 1 6.718-3.913l4.537 4.536-2.94 2.94-4.545-4.545a7.7 7.7 0 0 1-3.77.982m-.364-12.494-.323.82c-.459 1.167-.688 1.75-1.112 2.188-.423.44-.997.69-2.146 1.19l-.492.214v.68l.492.213c1.149.5 1.723.75 2.146 1.19.424.439.653 1.022 1.112 2.188l.323.82h.679l.323-.82c.459-1.166.688-1.75 1.111-2.188.424-.44.998-.69 2.147-1.19l.491-.214v-.679l-.491-.214c-1.149-.5-1.723-.75-2.147-1.19-.423-.438-.652-1.021-1.111-2.187l-.323-.82z\" clip-rule=\"evenodd\"/>\n</svg>\n";
function $00d48bb4f32e535d$export$fa08cbfe393f2a68(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Search' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $e41bbd286dd6d71c$export$f827d3c5a9c3f644), {
        svg: $00d48bb4f32e535d$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::37c59c3ee979ff8acaf7525e576da094>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
var $8422bde50b1e1e04$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#ffc716)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M12 9.796c-1.924 0-3.796.832-5.324 2.118q-.238.227-.475.227c-.132 0-.263-.076-.369-.202L3.908 9.771c-.105-.126-.158-.252-.158-.353 0-.151.08-.277.237-.429C6.307 7.023 9.127 5.914 12 5.914s5.693 1.109 8.013 3.075c.158.152.237.278.237.429 0 .1-.053.227-.158.353l-1.924 2.168c-.106.126-.238.202-.37.202q-.236 0-.474-.227c-1.529-1.286-3.4-2.118-5.324-2.118m0 8.118c-2.135 0-3.875-1.664-3.875-3.68 0-2.018 1.74-3.682 3.875-3.682s3.875 1.64 3.875 3.681-1.74 3.68-3.875 3.68\"/>\n</svg>\n";
function $8422bde50b1e1e04$export$f3f5aa321d88adf9(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Statuspage' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $ea406245305817b7$export$be58b4326e23250f), {
        svg: $8422bde50b1e1e04$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::4e31a509778b74933bf91345a74560c5>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $7dcb795c3c180a2b$var$svg = "<svg height=\"100%\" viewBox=\"0 0 192 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M184.96 12.09c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.05 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-18.64-.62v-1.53c-.98 2.02-2.82 3.07-5.18 3.07-4.05 0-6.07-3.46-6.07-7.97 0-4.32 2.12-7.97 6.38-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.58v13.95c0 4.51-2.12 7.54-7.61 7.54-2.58 0-3.99-.34-5.46-.83v-2.58c1.69.55 3.43.92 5.34.92 3.83 0 5.15-2.05 5.15-4.91m-8.68-6.44c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m-16.96.03c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-16.09-7.66c0-3.68-1.47-5.52-4.2-5.52-2.36 0-4.48 1.5-4.48 4.91v1.23c0 3.4 1.93 4.91 4.17 4.91 2.98 0 4.51-1.96 4.51-5.52m-3.8 7.97c-2.24 0-3.96-1.01-4.88-3v8.68h-2.64V10h2.64v2.76c.98-2.02 2.82-3.07 5.18-3.07 4.08 0 6.13 3.47 6.13 7.97 0 4.32-2.15 7.97-6.44 7.97m-10.55-4.47c0 2.55-1.66 4.48-5.77 4.48-2.3 0-4.17-.52-5.34-1.13v-2.79c1.32.77 3.53 1.5 5.46 1.5 2.02 0 3.07-.83 3.07-2.02 0-1.16-.89-1.84-3.8-2.54-3.4-.83-4.84-2.15-4.84-4.66 0-2.67 2.05-4.29 5.55-4.29 1.99 0 3.8.49 4.94 1.1v2.73c-1.84-.92-3.34-1.41-4.97-1.41-1.93 0-2.97.68-2.97 1.87 0 1.07.74 1.75 3.56 2.42 3.4.83 5.12 2.09 5.12 4.75m-27.61-2.18V10h2.64v9.26c0 2.76 1.1 3.99 3.62 3.99 2.45 0 4.14-1.62 4.14-4.72V10h2.64v15.33h-2.64v-2.51c-.98 1.81-2.79 2.82-4.84 2.82-3.53 0-5.55-2.42-5.55-6.65m-7.16 1.59c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55c-.46.12-.98.25-1.78.25-3.28 0-4.88-1.93-4.88-4.78v-8.19H85V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zm-18.95-2.91c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-17.26-4.75c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55c-.46.12-.98.25-1.78.25-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zm-6.89-.8c0 3.5-2.08 5.86-7.08 5.86-3.89 0-5.7-.77-7.27-1.56v-2.82c1.87.98 4.75 1.69 7.42 1.69 3.04 0 4.17-1.2 4.17-2.97s-1.1-2.73-4.94-3.65c-4.54-1.1-6.56-2.67-6.56-5.98 0-3.13 2.39-5.46 7.08-5.46 2.91 0 4.78.71 6.16 1.47v2.76c-2.02-1.16-4.2-1.53-6.29-1.53-2.64 0-4.2.92-4.2 2.76 0 1.66 1.29 2.48 4.84 3.37 4.26 1.07 6.66 2.45 6.66 6.07\"/>\n    <path fill=\"var(--tile-color,#ffc716)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M15.896 13.196c-2.464 0-4.86 1.114-6.817 2.835q-.303.304-.607.304c-.169 0-.338-.102-.473-.27l-2.463-2.902c-.135-.17-.202-.338-.202-.473 0-.202.1-.371.303-.573C8.607 9.484 12.217 8 15.896 8c3.678 0 7.29 1.484 10.259 4.117.202.202.303.37.303.573 0 .135-.067.304-.202.473l-2.463 2.902c-.135.168-.304.27-.473.27q-.303 0-.607-.304c-1.958-1.721-4.353-2.835-6.817-2.835m0 10.867c-2.733 0-4.96-2.228-4.96-4.927 0-2.7 2.227-4.927 4.96-4.927s4.96 2.193 4.96 4.927-2.227 4.927-4.96 4.927\"/>\n</svg>\n";
function $7dcb795c3c180a2b$export$2bc88a281410ffa7(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Statuspage' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $e41bbd286dd6d71c$export$f827d3c5a9c3f644), {
        svg: $7dcb795c3c180a2b$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::547909cc6b5dd84f765ef41fd848647b>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
var $075ace437f1f714d$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, #101214)\" fill-rule=\"evenodd\" d=\"M10.594 18.563v-7.97h7.969v7.97zm3.808-6.488-.163.429c-.235.615-.352.922-.572 1.155s-.52.368-1.12.638l-.222.1v.357l.222.099c.6.27.9.405 1.12.638s.337.54.572 1.156l.163.428h.347l.163-.429c.235-.615.352-.922.572-1.155s.52-.368 1.12-.638l.221-.1v-.357l-.22-.1c-.601-.269-.901-.404-1.121-.637s-.337-.54-.572-1.155l-.164-.429z\" clip-rule=\"evenodd\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M14.813 7.195 10.125 4.5 5.438 7.195v5.39l3.75 2.157V9.187h5.625z\"/>\n</svg>\n";
function $075ace437f1f714d$export$290a0f24614cde9f(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Studio' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $ea406245305817b7$export$be58b4326e23250f), {
        svg: $075ace437f1f714d$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::9f55f424cde2b5fe1f1eee28320c6ad8>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $a3665a3ce5d2eec1$var$svg = "<svg height=\"100%\" viewBox=\"0 0 124 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M116.71 25.64c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49m-13.48-6.2c0-1.17.77-1.84 1.84-1.84s1.84.67 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zm-15.3-7.66c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.47-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V3.59h2.64v21.74zm-27.41-6.34V10h2.64v9.26c0 2.76 1.1 3.99 3.62 3.99 2.45 0 4.14-1.63 4.14-4.72V10h2.64v15.33h-2.64v-2.51c-.98 1.81-2.79 2.82-4.85 2.82-3.53 0-5.55-2.42-5.55-6.65m-7.16 1.59c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55a6.3 6.3 0 0 1-1.78.25c-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zm-6.89-.8c0 3.5-2.08 5.86-7.08 5.86-3.89 0-5.7-.77-7.27-1.56v-2.82c1.87.98 4.75 1.69 7.42 1.69 3.04 0 4.17-1.2 4.17-2.97s-1.1-2.73-4.94-3.65c-4.54-1.1-6.56-2.67-6.56-5.98 0-3.13 2.39-5.46 7.08-5.46 2.91 0 4.78.71 6.16 1.47v2.76c-2.02-1.16-4.2-1.53-6.29-1.53-2.64 0-4.2.92-4.2 2.76 0 1.66 1.29 2.48 4.85 3.37 4.26 1.07 6.66 2.45 6.66 6.07\"/>\n    <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, #101214)\" fill-rule=\"evenodd\" d=\"M14.125 24.75V14.125H24.75V24.75zm5.078-8.65-.218.571c-.312.82-.469 1.23-.762 1.541s-.694.49-1.494.85l-.295.133v.476l.295.133c.8.36 1.2.54 1.494.85.293.311.45.721.762 1.541l.218.572h.462l.218-.572c.313-.82.469-1.23.762-1.54s.694-.491 1.494-.851l.295-.133v-.476l-.295-.132c-.8-.36-1.2-.54-1.494-.85-.293-.312-.45-.722-.762-1.542l-.218-.571z\" clip-rule=\"evenodd\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M19.75 9.594 13.5 6 7.25 9.594v7.187l5 2.875V12.25h7.5z\"/>\n</svg>\n";
function $a3665a3ce5d2eec1$export$273fd56580e523ae(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Studio' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $e41bbd286dd6d71c$export$f827d3c5a9c3f644), {
        svg: $a3665a3ce5d2eec1$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::548aca21494c6e3d39de8ad380612aed>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
var $7b305dd743a0e043$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#fb9700)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, #101214)\" fill-rule=\"evenodd\" d=\"m9.297 8.753 2.277-5.073h.858l2.277 5.073 5.529.598.265.816-4.121 3.734 1.14 5.442-.695.505-4.824-2.766-4.824 2.766-.695-.505 1.14-5.442-4.121-3.733.265-.817zm.777 6.415v-.678a1.857 1.857 0 0 1 3.715 0v.613a3.6 3.6 0 0 1-1.886.548h-.053a3.6 3.6 0 0 1-1.776-.483m1.858-3.134a1.393 1.393 0 1 0 0-2.786 1.393 1.393 0 0 0 0 2.786\" clip-rule=\"evenodd\"/>\n</svg>\n";
function $7b305dd743a0e043$export$4b05688514531169(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Talent' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $ea406245305817b7$export$be58b4326e23250f), {
        svg: $7b305dd743a0e043$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::5789a2ba9d9ad5ee943d0005b148e594>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $6653fbd31258d1d0$var$svg = "<svg height=\"100%\" viewBox=\"0 0 122 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M117.1 20.58c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55c-.46.12-.98.25-1.78.25-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zm-7.33-4.23v8.99h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.51c.98-1.81 2.79-2.82 4.85-2.82 3.53 0 5.55 2.42 5.55 6.66m-22.92-4.26c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.67-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2H82.4c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-14.47.57c-.21.06-.67.12-1.35.12-2.51 0-4.11-1.19-4.11-4.02V3.59h2.64V21.1c0 1.38.92 1.87 2.06 1.87.28 0 .46 0 .77-.03zm-20.75-7.63c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.47-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zM40.28 5.19h15.09v2.64H49.2v17.51h-2.76V7.82h-6.16z\"/>\n    <path fill=\"var(--tile-color,#fb9700)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"m16.577 4.907 3.035 6.763 7.372.797.354 1.09-5.495 4.977 1.52 7.257-.927.672-6.431-3.687-6.433 3.687-.926-.672 1.52-7.257-5.495-4.978.353-1.089 7.372-.797 3.035-6.763zm-.668 11.936a2.476 2.476 0 0 0-2.476 2.477v.904a4.8 4.8 0 0 0 2.369.644h.07a4.8 4.8 0 0 0 2.514-.73v-.818a2.477 2.477 0 0 0-2.477-2.477m0-4.511a1.857 1.857 0 1 0 0 3.714 1.857 1.857 0 0 0 0-3.714\"/>\n</svg>\n";
function $6653fbd31258d1d0$export$1b3979d995ebbc6e(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Talent' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $e41bbd286dd6d71c$export$f827d3c5a9c3f644), {
        svg: $6653fbd31258d1d0$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2a7617bb15f45b06b307ddb34a89ff24>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
var $8f6772f4842893a9$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M8.06 11.25a2.63 2.63 0 1 0 0-5.25 2.63 2.63 0 0 0 0 5.25m7.88 0a2.63 2.63 0 1 0 0-5.25 2.63 2.63 0 0 0 0 5.25m.17 1.31a2.89 2.89 0 0 1 2.89 2.9V18h-7.22l1.66-3.67a2.89 2.89 0 0 1 2.67-1.77M5 15.63V18h4.81l1.31-2.81a2.63 2.63 0 0 0-2.62-2.63h-.44A3.06 3.06 0 0 0 5 15.63\"/>\n</svg>\n";
function $8f6772f4842893a9$export$1bcbc9c337da86da(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Teams' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $ea406245305817b7$export$be58b4326e23250f), {
        svg: $8f6772f4842893a9$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::767fa2606cdc14e785d5959f2e07c247>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $a7277a46fce927f7$var$svg = "<svg height=\"100%\" viewBox=\"0 0 127 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M126.58 21.16c0 2.55-1.66 4.48-5.77 4.48-2.3 0-4.17-.52-5.34-1.13v-2.79c1.32.77 3.53 1.5 5.46 1.5 2.02 0 3.07-.83 3.07-2.02 0-1.16-.89-1.84-3.8-2.54-3.4-.83-4.84-2.15-4.84-4.66 0-2.67 2.05-4.29 5.55-4.29 1.99 0 3.8.49 4.94 1.1v2.73c-1.84-.92-3.34-1.41-4.97-1.41-1.93 0-2.97.67-2.97 1.87 0 1.07.74 1.75 3.56 2.42 3.4.83 5.12 2.09 5.12 4.75m-24.66-4.36v8.53h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 2.61 0 4.39 1.32 5.15 3.74.86-2.36 2.91-3.74 5.46-3.74 3.44 0 5.34 2.33 5.34 6.66v8.99h-2.64v-8.52c0-3.16-1.1-4.72-3.62-4.72-2.45 0-4.14 1.63-4.14 4.72m-28.33.84c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zM61.99 12.08c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2H57.55c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zM40.28 5.19h15.09v2.64H49.2v17.51h-2.76V7.82h-6.16z\"/>\n    <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M10.75 14.83a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7m10.5 0a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7m.23 1.75a3.86 3.86 0 0 1 3.86 3.86v3.72h-9.62l2.21-5.23a3.86 3.86 0 0 1 3.55-2.35M6.67 20.67v3.5h6.42l1.75-4.08a3.5 3.5 0 0 0-3.5-3.5h-.58a4.08 4.08 0 0 0-4.08 4.08\"/>\n</svg>\n";
function $a7277a46fce927f7$export$bfd8d1c4da84ce71(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Teams' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $e41bbd286dd6d71c$export$f827d3c5a9c3f644), {
        svg: $a7277a46fce927f7$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2fc7b25031952cd94704eefaa85d7de4>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
var $b9841bc1a3fb0032$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#1558bc)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, white)\" d=\"M9.39 18.23a.95.95 0 0 0 .95-.95V5.38a.95.95 0 0 0-.95-.95H5.38a.95.95 0 0 0-.95.95v11.91c0 .52.42.95.95.95zm9.23-5.46a.95.95 0 0 0 .95-.95V5.38a.95.95 0 0 0-.95-.95h-4.01a.95.95 0 0 0-.95.95v6.44c0 .52.42.95.95.95z\"/>\n</svg>\n";
var $b9841bc1a3fb0032$var$customThemeSvg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--themed-icon-color, currentcolor)\" d=\"M18 0a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6V6a6 6 0 0 1 6-6zM5.379 4.43a.95.95 0 0 0-.948.949v11.907c0 .523.424.948.948.948H9.39a.95.95 0 0 0 .947-.948V5.38a.95.95 0 0 0-.947-.948zm9.23 0a.95.95 0 0 0-.947.949v6.44c0 .523.423.948.947.949h4.012a.95.95 0 0 0 .948-.949V5.38a.95.95 0 0 0-.948-.948z\"/>\n</svg>\n";
function $b9841bc1a3fb0032$export$4384da9b8b140bf4(_ref) {
    var iconColor = _ref.iconColor, size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Trello' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $ea406245305817b7$export$be58b4326e23250f), {
        svg: $b9841bc1a3fb0032$var$svg,
        customThemeSvg: $b9841bc1a3fb0032$var$customThemeSvg,
        iconColor: iconColor,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b73a20da143650f747e32cb182c99798>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $5FkrB = parcelRequire("5FkrB");

// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $622eacd01ebed9e9$var$svg = "<svg height=\"100%\" viewBox=\"0 0 113 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M104.97 25.64c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49M96.21 25.3c-.21.06-.67.12-1.35.12-2.51 0-4.11-1.19-4.11-4.02V3.59h2.64V21.1c0 1.38.92 1.87 2.06 1.87.28 0 .46 0 .77-.03zm-8 0c-.21.06-.67.12-1.35.12-2.51 0-4.11-1.19-4.11-4.02V3.59h2.64V21.1c0 1.38.92 1.87 2.06 1.87.28 0 .46 0 .77-.03zM72.86 12.09c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.67-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2H68.42c.37 2.61 2.05 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-19.48-8.44v9.05h-2.58V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.67-5.43 3.93M40.28 5.19h15.09v2.64H49.2v17.51h-2.76V7.82h-6.16z\"/>\n    <path fill=\"var(--tile-color,#1558bc)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, white)\" d=\"M12.9 24c.62 0 1.13-.49 1.13-1.1V9.1c0-.61-.5-1.1-1.13-1.1H8.13C7.51 8 7 8.49 7 9.1v13.8c0 .61.5 1.1 1.13 1.1zm10.97-6.34c.62 0 1.13-.49 1.13-1.1V9.1c0-.61-.5-1.1-1.13-1.1H19.1c-.62 0-1.13.49-1.13 1.1v7.47c0 .61.5 1.1 1.13 1.1z\"/>\n</svg>\n";
function $622eacd01ebed9e9$export$1b13139dfc0336af(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Trello' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $e41bbd286dd6d71c$export$f827d3c5a9c3f644), {
        svg: $622eacd01ebed9e9$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}





var $5FkrB = parcelRequire("5FkrB");
var $14541882247a86cc$var$_excluded = [
    "size",
    "shouldUseNewLogoDesign"
];
/**
 * Creates a component that renders the new logo design.
 *
 * @param LegacyComponent - The legacy logo component (no longer used).
 * @param NewComponent - The new logo component.
 * @returns A component that renders the new logo.
 */ var $14541882247a86cc$export$e30d2ddc605f6bb = function createFeatureFlaggedComponent(_LegacyComponent, NewComponent) {
    // Note: textColor and iconColor aren't supported on all new logos
    // These props will be deprecated in the future
    return function(_ref) {
        var size = _ref.size, _shouldUseNewLogoDesign = _ref.shouldUseNewLogoDesign, props = (0, $b45e4aa52a06dd77$export$2e2bcd8739ae039)(_ref, $14541882247a86cc$var$_excluded);
        // Size defaults need to be set, as the temp library had different defaults
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(NewComponent, (0, $39cd338b0da6756c$export$2e2bcd8739ae039)({
            size: size || 'medium'
        }, props));
    };
};





var $5FkrB = parcelRequire("5FkrB");
var $4376af1a160897d5$var$_excluded = [
    "size",
    "shouldUseNewLogoDesign"
];
/**
 * Creates a component that renders the new logo design.
 *
 * @param LegacyComponent - The legacy logo component (no longer used).
 * @param NewComponent - The new logo component.
 * @returns A component that renders the new logo.
 */ var $4376af1a160897d5$export$436fcf6e31fbacea = function createFeatureFlaggedServiceCollectionComponent(_LegacyComponent, NewComponent) {
    // Note: textColor and iconColor aren't supported on all new logos
    // These props will be deprecated in the future
    return function(_ref) {
        var size = _ref.size, _shouldUseNewLogoDesign = _ref.shouldUseNewLogoDesign, props = (0, $b45e4aa52a06dd77$export$2e2bcd8739ae039)(_ref, $4376af1a160897d5$var$_excluded);
        // Size defaults need to be set, as the temp library had different defaults
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(NewComponent, (0, $39cd338b0da6756c$export$2e2bcd8739ae039)({
            size: size || 'medium'
        }, props));
    };
};



var $5FkrB = parcelRequire("5FkrB");

/**
 * These are the default parameters for LogoProps if the user does not specify values.
 */ var $293a60c0ae776fbb$export$438460117ae6b7ee = {
    iconColor: 'inherit',
    label: '',
    size: 'medium',
    textColor: 'currentColor'
};
var $293a60c0ae776fbb$export$793fba32aed8942a = {
    iconGradientStart: 'inherit',
    iconGradientStop: 'inherit'
}; /**
 * The props for the <Wrapper /> that takes the svg and turns it into a component.
 */ 


/* wrapper.tsx generated by @compiled/babel-plugin v0.39.1 */ 



var $5FkrB = parcelRequire("5FkrB");

var $f2142a8b85819ba3$var$_excluded = [
    "label",
    "svg",
    "size",
    "appearance",
    "iconColor",
    "textColor",
    "testId"
];
var $f2142a8b85819ba3$var$CSS_VAR_COLOR = '--logo-color';
var $f2142a8b85819ba3$var$CSS_VAR_FILL = '--logo-fill';
var $f2142a8b85819ba3$var$styles = {
    root: "_1e0c1o8l _kqswh2mm _syaz1vry _lswu1xf6 _vwz4kb7n _uiztglyw _o5724jg8 _zbji1osq _3se11kw7",
    stop: "_vc881r31",
    xxsmall: "_4t3i7vkz",
    xsmall: "_4t3igktf",
    small: "_4t3i1tcg",
    medium: "_4t3izwfg",
    large: "_4t3i1ylp",
    xlarge: "_4t3ickbl"
};
/**
 * __Wrapper__
 *
 * An internal component used by `@atlaskit/logo` to render logo SVGs with correct styles.
 */ var $f2142a8b85819ba3$var$Wrapper = function Wrapper(_ref) {
    var label = _ref.label, svg = _ref.svg, size = _ref.size, appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor, userDefinedTestId = _ref.testId, rest = (0, $b45e4aa52a06dd77$export$2e2bcd8739ae039)(_ref, $f2142a8b85819ba3$var$_excluded);
    // Only required for old logos with gradients, which set gradient values to `inherit` when no appearance is provided
    var shouldApplyStopColor = appearance === undefined;
    var testId = userDefinedTestId && "".concat(userDefinedTestId, "--wrapper");
    return /*#__PURE__*/ $5FkrB.createElement("span", (0, $39cd338b0da6756c$export$2e2bcd8739ae039)({
        "data-testid": testId,
        style: (0, $5bc9a370f4de45ae$export$2e2bcd8739ae039)((0, $5bc9a370f4de45ae$export$2e2bcd8739ae039)({}, $f2142a8b85819ba3$var$CSS_VAR_COLOR, iconColor), $f2142a8b85819ba3$var$CSS_VAR_FILL, textColor),
        "aria-label": label ? label : undefined,
        role: label ? 'img' : undefined,
        dangerouslySetInnerHTML: {
            __html: svg
        }
    }, rest, {
        className: (0, $c4f3fc62d4a10748$export$2e2bcd8739ae039)([
            $f2142a8b85819ba3$var$styles.root,
            shouldApplyStopColor && $f2142a8b85819ba3$var$styles.stop,
            size && $f2142a8b85819ba3$var$styles[size]
        ])
    }));
};
var $f2142a8b85819ba3$export$2e2bcd8739ae039 = $f2142a8b85819ba3$var$Wrapper;


var $28050253965a3cad$export$bbacc3980e0f3029 = function getColorsFromAppearance(appearance, colorMode) {
    var iconColor, textColor, atlassianLogoTextColor;
    if (colorMode === 'dark') switch(appearance){
        case 'brand':
            iconColor = '#357DE8';
            textColor = '#E2E3E4';
            atlassianLogoTextColor = '#357DE8';
            break;
        case 'neutral':
            iconColor = '#96999E';
            textColor = '#BFC1C4';
            atlassianLogoTextColor = '#96999E';
            break;
        case 'inverse':
            iconColor = '#101214';
            textColor = '#101214';
            atlassianLogoTextColor = '#101214';
            break;
    }
    else switch(appearance){
        case 'brand':
            iconColor = '#1868DB';
            textColor = '#101214';
            atlassianLogoTextColor = '#1868DB';
            break;
        case 'neutral':
            iconColor = '#6C6F77';
            textColor = '#3B3D42';
            atlassianLogoTextColor = '#6C6F77';
            break;
        case 'inverse':
            iconColor = '#FFFFFF';
            textColor = '#FFFFFF';
            atlassianLogoTextColor = '#FFFFFF';
            break;
    }
    return {
        iconColor: iconColor,
        textColor: textColor,
        atlassianLogoTextColor: atlassianLogoTextColor
    };
};


var $dde6c132b66ddaee$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor;
    var colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $28050253965a3cad$export$bbacc3980e0f3029)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" focusable=\"false\" aria-hidden=\"true\">\n      <path\n        d=\"M27.545 24.378 16.96 3.208c-.208-.458-.417-.541-.667-.541-.208 0-.458.083-.708.5-1.5 2.375-2.167 5.125-2.167 8 0 4.001 2.042 7.752 5.042 13.794.334.667.584.792 1.167.792h7.335c.541 0 .833-.208.833-.625 0-.208-.042-.333-.25-.75M12.168 14.377c-.834-1.25-1.084-1.334-1.292-1.334s-.333.083-.708.834L4.875 24.46c-.167.334-.208.459-.208.625 0 .334.291.667.916.667h7.46c.5 0 .875-.416 1.083-1.208.25-1 .334-1.876.334-2.917 0-2.917-1.292-5.751-2.292-7.251z\"\n        fill=\"".concat(colors.iconColor, "\"\n      />\n    </svg>");
};
var $dde6c132b66ddaee$export$84109e099492cb5f = function AtlassianAdminIcon(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Atlassian Admin' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $293a60c0ae776fbb$export$438460117ae6b7ee).size : _ref2$size, testId = _ref2.testId, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $293a60c0ae776fbb$export$438460117ae6b7ee).textColor : _ref2$textColor, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $293a60c0ae776fbb$export$438460117ae6b7ee).iconColor : _ref2$iconColor;
    var _useThemeObserver = (0, $233cd94b869ba248$export$2e2bcd8739ae039)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $f2142a8b85819ba3$export$2e2bcd8739ae039), {
        appearance: appearance,
        svg: $dde6c132b66ddaee$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        label: label,
        size: size,
        testId: testId,
        textColor: textColor
    });
};


var $5FkrB = parcelRequire("5FkrB");




var $b79cc89e0a214a27$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor;
    var colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $28050253965a3cad$export$bbacc3980e0f3029)(appearance, colorMode);
    return "<svg\n      fill=\"none\"\n      height=\"32\"\n      xmlns=\"http://www.w3.org/2000/svg\"\n      viewBox=\"0 0 295 32\"\n      focusable=\"false\"\n      aria-hidden=\"true\"\n    >\n      <path\n        d=\"M294.31 16.348v8.985h-2.637v-9.261c0-2.76-1.104-3.987-3.619-3.987-2.453 0-4.14 1.626-4.14 4.723v8.525h-2.637V10h2.637v2.515c.982-1.81 2.791-2.822 4.846-2.822 3.526 0 5.55 2.423 5.55 6.655M274.168 5.952c0-1.165.766-1.84 1.84-1.84 1.073 0 1.84.675 1.84 1.84s-.767 1.84-1.84 1.84c-1.074 0-1.84-.675-1.84-1.84m.49 19.381V10h2.638v15.333zm-14.069-8.525v8.525h-2.637v-9.261c0-2.76-1.104-3.987-3.619-3.987-2.453 0-4.14 1.626-4.14 4.723v8.525h-2.637V10h2.637v2.515c.981-1.81 2.791-2.822 4.845-2.822 2.607 0 4.386 1.319 5.152 3.742.859-2.362 2.914-3.742 5.459-3.742 3.435 0 5.336 2.331 5.336 6.655v8.985h-2.637v-8.525c0-3.159-1.104-4.723-3.619-4.723-2.453 0-4.14 1.626-4.14 4.723m-28.327.859c0 3.68 1.472 5.52 4.202 5.52 2.361 0 4.477-1.503 4.477-4.907v-1.227c0-3.404-1.932-4.906-4.171-4.906-2.974 0-4.508 1.962-4.508 5.52m8.679 7.666v-2.76c-.981 2.024-2.821 3.067-5.183 3.067-4.078 0-6.133-3.465-6.133-7.973 0-4.324 2.147-7.974 6.44-7.974 2.239 0 3.956 1.012 4.876 3.006V3.59h2.637v21.742zm-22.021-4.017c-1.533 0-3.097-.184-4.814-.521l-1.687 4.538h-3.097l7.942-20.148h3.496l7.943 20.148h-3.097l-1.687-4.569c-1.809.368-3.373.552-4.999.552m0-2.453c1.288 0 2.607-.154 4.171-.399l-4.079-11.04-4.078 11.07c1.502.246 2.76.369 3.986.369\"\n        fill=\"".concat(colors.textColor, "\"\n      />\n      <path\n        d=\"M107.447 10.828c0 2.972 1.345 5.308 6.795 6.37 3.185.707 3.893 1.203 3.893 2.264 0 1.062-.708 1.699-2.973 1.699-2.619 0-5.733-.92-7.785-2.123v4.812c1.627.779 3.751 1.699 7.785 1.699 5.662 0 7.856-2.548 7.856-6.228m0 .07c0-3.538-1.84-5.166-7.148-6.299-2.902-.637-3.61-1.274-3.61-2.194 0-1.132 1.062-1.628 2.973-1.628 2.335 0 4.6.708 6.794 1.7V6.368c-1.557-.779-3.892-1.345-6.653-1.345-5.237 0-7.927 2.265-7.927 5.945m72.475-5.803v20.172h4.318V9.978l1.769 4.034 6.087 11.325h5.379V5.165h-4.247v13.023l-1.628-3.822-4.883-9.2zm-27.319 0h-4.671v20.172h4.671zm-10.05 14.155c0-3.538-1.841-5.166-7.149-6.298-2.902-.637-3.609-1.274-3.609-2.194 0-1.133 1.061-1.628 2.972-1.628 2.336 0 4.601.707 6.795 1.698v-4.6c-1.557-.779-3.893-1.345-6.653-1.345-5.238 0-7.927 2.265-7.927 5.945 0 2.973 1.345 5.309 6.794 6.37 3.185.708 3.893 1.203 3.893 2.265s-.708 1.699-2.973 1.699c-2.618 0-5.733-.92-7.785-2.124v4.813c1.628.779 3.751 1.699 7.785 1.699 5.592 0 7.857-2.548 7.857-6.3M71.069 5.165v20.172h9.625l1.486-4.389h-6.44V5.165zm-19.039 0v4.318h5.167v15.854h4.741V9.483h5.592V5.165zm-6.866 0h-6.157L32 25.336h5.379l.99-3.397c1.204.354 2.478.566 3.752.566s2.548-.212 3.751-.566l.991 3.397h5.379c-.07 0-7.078-20.17-7.078-20.17zM42.05 18.26c-.92 0-1.77-.142-2.548-.354L42.05 9.13l2.548 8.776a9.6 9.6 0 0 1-2.548.354M97.326 5.165H91.17l-7.08 20.171h5.38l.99-3.397c1.203.354 2.477.566 3.751.566s2.548-.212 3.751-.566l.991 3.397h5.379zM94.212 18.26c-.92 0-1.77-.142-2.548-.354l2.548-8.776 2.548 8.776a9.6 9.6 0 0 1-2.548.354m75.306-13.095h-6.157l-7.007 20.171h5.379l.991-3.397c1.203.354 2.477.566 3.751.566s2.548-.212 3.751-.566l.991 3.397h5.379zm-3.043 13.094c-.92 0-1.77-.142-2.548-.354l2.548-8.776 2.548 8.776a10 10 0 0 1-2.548.354M22.878 24.378 12.293 3.208c-.208-.458-.416-.541-.666-.541-.209 0-.459.083-.709.5-1.5 2.375-2.167 5.125-2.167 8 0 4.001 2.042 7.752 5.043 13.794.333.667.583.792 1.166.792h7.335c.542 0 .833-.208.833-.625 0-.208-.041-.333-.25-.75M7.501 14.377c-.833-1.25-1.083-1.334-1.292-1.334s-.333.083-.708.834L.208 24.46c-.166.334-.208.459-.208.625 0 .334.292.667.917.667h7.46c.5 0 .874-.416 1.083-1.208.25-1 .333-1.876.333-2.917 0-2.917-1.292-5.751-2.292-7.251z\"\n        fill=\"").concat(colors.iconColor, "\"\n      />\n    </svg>");
};
var $b79cc89e0a214a27$export$f845d9b9254f0541 = function AtlassianAdminLogo(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Atlassian Admin' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $293a60c0ae776fbb$export$438460117ae6b7ee).size : _ref2$size, testId = _ref2.testId, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $293a60c0ae776fbb$export$438460117ae6b7ee).textColor : _ref2$textColor, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $293a60c0ae776fbb$export$438460117ae6b7ee).iconColor : _ref2$iconColor;
    var _useThemeObserver = (0, $233cd94b869ba248$export$2e2bcd8739ae039)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $f2142a8b85819ba3$export$2e2bcd8739ae039), {
        appearance: appearance,
        iconColor: iconColor,
        label: label,
        size: size,
        svg: $b79cc89e0a214a27$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};



var $5FkrB = parcelRequire("5FkrB");




var $c76cbe01b5f15be2$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor;
    var colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $28050253965a3cad$export$bbacc3980e0f3029)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" focusable=\"false\" aria-hidden=\"true\">\n      <path\n        d=\"M27.545 24.378 16.96 3.208c-.208-.458-.417-.541-.667-.541-.208 0-.458.083-.708.5-1.5 2.375-2.167 5.125-2.167 8 0 4.001 2.042 7.752 5.042 13.794.334.667.584.792 1.167.792h7.335c.541 0 .833-.208.833-.625 0-.208-.042-.333-.25-.75M12.168 14.377c-.834-1.25-1.084-1.334-1.292-1.334s-.333.083-.708.834L4.875 24.46c-.167.334-.208.459-.208.625 0 .334.291.667.916.667h7.46c.5 0 .875-.416 1.083-1.208.25-1 .334-1.876.334-2.917 0-2.917-1.292-5.751-2.292-7.251z\"\n        fill=\"".concat(colors.iconColor, "\"\n      />\n    </svg>");
};
var $c76cbe01b5f15be2$export$74517ed253186308 = function AtlassianAdministrationIcon(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Atlassian Administration' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $293a60c0ae776fbb$export$438460117ae6b7ee).size : _ref2$size, testId = _ref2.testId, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $293a60c0ae776fbb$export$438460117ae6b7ee).textColor : _ref2$textColor, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $293a60c0ae776fbb$export$438460117ae6b7ee).iconColor : _ref2$iconColor;
    var _useThemeObserver = (0, $233cd94b869ba248$export$2e2bcd8739ae039)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $f2142a8b85819ba3$export$2e2bcd8739ae039), {
        appearance: appearance,
        svg: $c76cbe01b5f15be2$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        label: label,
        size: size,
        testId: testId,
        textColor: textColor
    });
};


var $5FkrB = parcelRequire("5FkrB");




var $fa26fed8d4db5210$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor;
    var colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $28050253965a3cad$export$bbacc3980e0f3029)(appearance, colorMode);
    return "<svg\n      fill=\"none\"\n      height=\"32\"\n      xmlns=\"http://www.w3.org/2000/svg\"\n      viewBox=\"0 0 404 32\"\n      focusable=\"false\"\n      aria-hidden=\"true\"\n    >\n      <path\n        d=\"M403.77 16.348v8.985h-2.637v-9.261c0-2.76-1.104-3.987-3.619-3.987-2.453 0-4.14 1.626-4.14 4.723v8.525h-2.637V10h2.637v2.515c.981-1.81 2.791-2.822 4.845-2.822 3.527 0 5.551 2.423 5.551 6.655m-23.336 9.292c-4.6 0-7.299-3.404-7.299-8.004s2.699-7.943 7.299-7.943c4.57 0 7.237 3.343 7.237 7.943s-2.667 8.004-7.237 8.004m0-13.493c-3.281 0-4.723 2.576-4.723 5.489s1.442 5.55 4.723 5.55c3.251 0 4.661-2.637 4.661-5.55s-1.41-5.49-4.661-5.49zm-13.488-6.195c0-1.165.767-1.84 1.84-1.84 1.074 0 1.84.675 1.84 1.84s-.766 1.84-1.84 1.84c-1.073 0-1.84-.675-1.84-1.84m.491 19.381V10h2.637v15.333zm-7.461-4.753c0 1.35.797 2.27 2.422 2.27.614 0 1.196-.123 1.656-.215v2.545a6.3 6.3 0 0 1-1.778.245c-3.282 0-4.876-1.932-4.876-4.784v-8.188h-2.484V10h2.484V6.75h2.576V10h4.078v2.453h-4.078zm-18.943-2.913c0 3.68 1.472 5.52 4.202 5.52 2.361 0 4.477-1.503 4.477-4.907v-1.227c0-3.404-1.932-4.906-4.171-4.906-2.974 0-4.508 1.962-4.508 5.52m8.679 7.666v-2.76c-.981 2.024-2.821 3.067-5.183 3.067-4.078 0-6.133-3.465-6.133-7.973 0-4.324 2.147-7.974 6.44-7.974 2.239 0 3.956 1.012 4.876 3.006V10h2.637v15.333zm-17.793-9.046v9.046h-2.576V10h2.576v2.699c.89-1.81 2.423-3.098 5.428-2.914v2.576c-3.373-.337-5.428.675-5.428 3.926m-10.037 4.293c0 1.35.797 2.27 2.423 2.27.613 0 1.196-.123 1.656-.215v2.545c-.46.123-.982.245-1.779.245-3.281 0-4.876-1.932-4.876-4.784v-8.188h-2.484V10h2.484V6.75h2.576V10h4.079v2.453h-4.079zm-6.696.583c0 2.545-1.656 4.477-5.765 4.477-2.3 0-4.171-.521-5.336-1.135v-2.79c1.319.766 3.527 1.502 5.459 1.502 2.024 0 3.066-.828 3.066-2.024 0-1.165-.889-1.84-3.802-2.545-3.404-.828-4.846-2.147-4.846-4.661 0-2.668 2.055-4.294 5.551-4.294 1.993 0 3.803.491 4.937 1.104v2.73c-1.84-.92-3.342-1.411-4.968-1.411-1.932 0-2.974.675-2.974 1.87 0 1.074.736 1.749 3.557 2.423 3.404.828 5.121 2.086 5.121 4.754M297.497 5.952c0-1.165.767-1.84 1.84-1.84 1.074 0 1.84.675 1.84 1.84s-.766 1.84-1.84 1.84c-1.073 0-1.84-.675-1.84-1.84m.491 19.381V10h2.637v15.333zm-3.678-8.985v8.985h-2.637v-9.261c0-2.76-1.104-3.987-3.619-3.987-2.453 0-4.14 1.626-4.14 4.723v8.525h-2.637V10h2.637v2.515c.982-1.81 2.791-2.822 4.846-2.822 3.526 0 5.55 2.423 5.55 6.655M274.168 5.952c0-1.165.766-1.84 1.84-1.84 1.073 0 1.84.675 1.84 1.84s-.767 1.84-1.84 1.84c-1.074 0-1.84-.675-1.84-1.84m.49 19.381V10h2.638v15.333zm-14.069-8.525v8.525h-2.637v-9.261c0-2.76-1.104-3.987-3.619-3.987-2.453 0-4.14 1.626-4.14 4.723v8.525h-2.637V10h2.637v2.515c.981-1.81 2.791-2.822 4.845-2.822 2.607 0 4.386 1.319 5.152 3.742.859-2.362 2.914-3.742 5.459-3.742 3.435 0 5.336 2.331 5.336 6.655v8.985h-2.637v-8.525c0-3.159-1.104-4.723-3.619-4.723-2.453 0-4.14 1.626-4.14 4.723m-28.327.859c0 3.68 1.472 5.52 4.202 5.52 2.361 0 4.477-1.503 4.477-4.907v-1.227c0-3.404-1.932-4.906-4.171-4.906-2.974 0-4.508 1.962-4.508 5.52m8.679 7.666v-2.76c-.981 2.024-2.821 3.067-5.183 3.067-4.078 0-6.133-3.465-6.133-7.973 0-4.324 2.147-7.974 6.44-7.974 2.239 0 3.956 1.012 4.876 3.006V3.59h2.637v21.742zm-22.021-4.017c-1.533 0-3.097-.184-4.814-.521l-1.687 4.538h-3.097l7.942-20.148h3.496l7.943 20.148h-3.097l-1.687-4.569c-1.809.368-3.373.552-4.999.552m0-2.453c1.288 0 2.607-.154 4.171-.399l-4.079-11.04-4.078 11.07c1.502.246 2.76.369 3.986.369\"\n        fill=\"".concat(colors.textColor, "\"\n      />\n      <path\n        d=\"M107.447 10.828c0 2.972 1.345 5.308 6.795 6.37 3.185.707 3.893 1.203 3.893 2.264 0 1.062-.708 1.699-2.973 1.699-2.619 0-5.733-.92-7.785-2.123v4.812c1.627.779 3.751 1.699 7.785 1.699 5.662 0 7.856-2.548 7.856-6.228m0 .07c0-3.538-1.84-5.166-7.148-6.299-2.902-.637-3.61-1.274-3.61-2.194 0-1.132 1.062-1.628 2.973-1.628 2.335 0 4.6.708 6.794 1.7V6.368c-1.557-.779-3.892-1.345-6.653-1.345-5.237 0-7.927 2.265-7.927 5.945m72.475-5.803v20.172h4.318V9.978l1.769 4.034 6.087 11.325h5.379V5.165h-4.247v13.023l-1.628-3.822-4.883-9.2zm-27.319 0h-4.671v20.172h4.671zm-10.05 14.155c0-3.538-1.841-5.166-7.149-6.298-2.902-.637-3.609-1.274-3.609-2.194 0-1.133 1.061-1.628 2.972-1.628 2.336 0 4.601.707 6.795 1.698v-4.6c-1.557-.779-3.893-1.345-6.653-1.345-5.238 0-7.927 2.265-7.927 5.945 0 2.973 1.345 5.309 6.794 6.37 3.185.708 3.893 1.203 3.893 2.265s-.708 1.699-2.973 1.699c-2.618 0-5.733-.92-7.785-2.124v4.813c1.628.779 3.751 1.699 7.785 1.699 5.592 0 7.857-2.548 7.857-6.3M71.069 5.165v20.172h9.625l1.486-4.389h-6.44V5.165zm-19.039 0v4.318h5.167v15.854h4.741V9.483h5.592V5.165zm-6.866 0h-6.157L32 25.336h5.379l.99-3.397c1.204.354 2.478.566 3.752.566s2.548-.212 3.751-.566l.991 3.397h5.379c-.07 0-7.078-20.17-7.078-20.17zM42.05 18.26c-.92 0-1.77-.142-2.548-.354L42.05 9.13l2.548 8.776a9.6 9.6 0 0 1-2.548.354M97.326 5.165H91.17l-7.08 20.171h5.38l.99-3.397c1.203.354 2.477.566 3.751.566s2.548-.212 3.751-.566l.991 3.397h5.379zM94.212 18.26c-.92 0-1.77-.142-2.548-.354l2.548-8.776 2.548 8.776a9.6 9.6 0 0 1-2.548.354m75.306-13.095h-6.157l-7.007 20.171h5.379l.991-3.397c1.203.354 2.477.566 3.751.566s2.548-.212 3.751-.566l.991 3.397h5.379zm-3.043 13.094c-.92 0-1.77-.142-2.548-.354l2.548-8.776 2.548 8.776a10 10 0 0 1-2.548.354M22.878 24.378 12.293 3.208c-.208-.458-.416-.541-.666-.541-.209 0-.459.083-.709.5-1.5 2.375-2.167 5.125-2.167 8 0 4.001 2.042 7.752 5.043 13.794.333.667.583.792 1.166.792h7.335c.542 0 .833-.208.833-.625 0-.208-.041-.333-.25-.75M7.501 14.377c-.833-1.25-1.083-1.334-1.292-1.334s-.333.083-.708.834L.208 24.46c-.166.334-.208.459-.208.625 0 .334.292.667.917.667h7.46c.5 0 .874-.416 1.083-1.208.25-1 .333-1.876.333-2.917 0-2.917-1.292-5.751-2.292-7.251z\"\n        fill=\"").concat(colors.iconColor, "\"\n      />\n    </svg>");
};
var $fa26fed8d4db5210$export$833abe6c2ce5ebfd = function AtlassianAdministrationLogo(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Atlassian Administration' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $293a60c0ae776fbb$export$438460117ae6b7ee).size : _ref2$size, testId = _ref2.testId, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $293a60c0ae776fbb$export$438460117ae6b7ee).textColor : _ref2$textColor, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $293a60c0ae776fbb$export$438460117ae6b7ee).iconColor : _ref2$iconColor;
    var _useThemeObserver = (0, $233cd94b869ba248$export$2e2bcd8739ae039)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $f2142a8b85819ba3$export$2e2bcd8739ae039), {
        appearance: appearance,
        iconColor: iconColor,
        label: label,
        size: size,
        svg: $fa26fed8d4db5210$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};



var $5FkrB = parcelRequire("5FkrB");




// TODO: This is where we need to add tokens for all appearance color values
var $eb95a14c9987fdaf$export$362a25f017e2bc8a = function getColorsFromAppearanceOldLogos(appearance, colorMode) {
    var iconGradientStart, iconGradientStop, iconColor, textColor, atlassianLogoTextColor;
    switch(appearance){
        case 'brand':
            iconGradientStart = '#0052CC';
            iconGradientStop = '#2684FF';
            iconColor = '#2684FF';
            textColor = "var(--ds-text, #292A2E)";
            // This is only used for the top level Atlassian wordmark (see AtlassianLogo
            // or AtlassianStartLogo for example), and is only different for the Brand
            // appearance - a bold brand color. For other appearances,
            // atlassianLogoTextColor is the same as textColor.
            atlassianLogoTextColor = '#0052CC';
            break;
        case 'neutral':
            iconGradientStart = '#344563';
            iconGradientStop = '#7A869A';
            iconColor = '#7A869A';
            textColor = '#505F79';
            atlassianLogoTextColor = '#505F79';
            break;
        case 'inverse':
            iconGradientStart = '#FFFFFF66';
            iconGradientStop = '#FFFFFF';
            iconColor = '#FFFFFF';
            textColor = '#FFFFFF';
            atlassianLogoTextColor = '#FFFFFF';
            break;
    }
    if (colorMode === 'dark' && appearance === 'inverse') {
        iconGradientStart = '#161A1D66';
        iconGradientStop = '#161A1D';
        iconColor = '#161A1D';
        textColor = '#161A1D';
        atlassianLogoTextColor = '#161A1D';
    }
    return {
        iconGradientStart: iconGradientStart,
        iconGradientStop: iconGradientStop,
        iconColor: iconColor,
        textColor: textColor,
        atlassianLogoTextColor: atlassianLogoTextColor
    };
};


var $1cb10910e01e10d0$var$svg = function svg(_ref, colorMode, id) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor;
    var colors = {
        iconGradientStart: iconColor,
        iconGradientStop: iconColor,
        iconColor: iconColor
    };
    if (appearance) colors = (0, $eb95a14c9987fdaf$export$362a25f017e2bc8a)(appearance, colorMode);
    return "<svg height=\"32\" viewBox=\"0 0 48 48\" xmlns=\"http://www.w3.org/2000/svg\">\n  <defs>\n    <linearGradient id=\"".concat(id, "-a\" x1=\"12.595\" x2=\"12.595\" y1=\"40\" y2=\"30\" gradientUnits=\"userSpaceOnUse\">\n      <stop offset=\"0\" stop-color=\"").concat(colors.iconGradientStart, "\"/>\n      <stop offset=\"1\" stop-color=\"").concat(colors.iconGradientStop, "\"/>\n    </linearGradient>\n    <linearGradient id=\"").concat(id, "-b\" x1=\"28.595\" x2=\"28.595\" y1=\"40\" y2=\"27\" gradientUnits=\"userSpaceOnUse\">\n      <stop offset=\"0\" stop-color=\"").concat(colors.iconGradientStart, "\"/>\n      <stop offset=\"1\" stop-color=\"").concat(colors.iconGradientStop, "\"/>\n    </linearGradient>\n    <linearGradient xlink:href=\"#").concat(id, "-b\" id=\"").concat(id, "-c\" x1=\"20.595\" x2=\"20.595\" y2=\"22\"/>\n    <linearGradient xlink:href=\"#").concat(id, "-b\" id=\"").concat(id, "-d\" x1=\"36.595\" x2=\"36.595\" y2=\"20\"/>\n  </defs>\n  <path d=\"M10.595 30h4v10h-4z\" fill=\"url(#").concat(id, "-a)\"/>\n  <path d=\"M26.595 27h4v13h-4z\" fill=\"url(#").concat(id, "-b)\"/>\n  <path d=\"M18.595 22h4v18h-4z\" fill=\"url(#").concat(id, "-c)\"/>\n  <path d=\"M34.595 20h4v20h-4z\" fill=\"url(#").concat(id, "-d)\"/>\n  <path fill=\"").concat(colors.iconColor, "\" d=\"m9.009 25.414-2.828-2.828 10.127-10.128a5 5 0 0 1 6.605-.411l4.471 3.477a1.5 1.5 0 0 0 1.982-.123l9.815-9.815 2.828 2.828-10.127 10.128a5 5 0 0 1-6.605.411l-4.471-3.477a1.5 1.5 0 0 0-1.982.123l-9.815 9.815Z\" />\n</svg>");
};
var $1cb10910e01e10d0$export$c42ad8a0b925c762 = function AtlassianAnalyticsIcon(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Atlassian Analytics' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $293a60c0ae776fbb$export$438460117ae6b7ee).size : _ref2$size, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $293a60c0ae776fbb$export$438460117ae6b7ee).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $293a60c0ae776fbb$export$438460117ae6b7ee).textColor : _ref2$textColor, testId = _ref2.testId;
    var _useThemeObserver = (0, $233cd94b869ba248$export$2e2bcd8739ae039)(), colorMode = _useThemeObserver.colorMode;
    var id = (0, $c797bf80d6171378$export$f680877a34711e37)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $f2142a8b85819ba3$export$2e2bcd8739ae039), {
        appearance: appearance,
        label: label,
        svg: $1cb10910e01e10d0$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode, id),
        iconColor: iconColor,
        textColor: textColor,
        size: size,
        testId: testId
    });
};


var $5FkrB = parcelRequire("5FkrB");





var $a50d66907d59a53c$var$svg = function svg(_ref, colorMode, id) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor;
    var colors = {
        iconGradientStart: iconColor,
        iconGradientStop: iconColor,
        textColor: textColor,
        iconColor: iconColor,
        // We treat the word "Atlassian" differently to normal app logos, it has a bold brand look
        atlassianLogoTextColor: textColor
    };
    if (appearance) colors = (0, $eb95a14c9987fdaf$export$362a25f017e2bc8a)(appearance, colorMode);
    return "\n  <svg height=\"32\" viewBox=\"0 0 477 48\" xmlns=\"http://www.w3.org/2000/svg\">\n  <defs>\n    <linearGradient id=\"".concat(id, "-a\" x1=\"447.285\" x2=\"447.285\" y1=\"40\" y2=\"30\" gradientUnits=\"userSpaceOnUse\">\n      <stop offset=\"0\" stop-color=\"").concat(colors.iconGradientStart, "\"/>\n      <stop offset=\"1\" stop-color=\"").concat(colors.iconGradientStop, "\"/>\n    </linearGradient>\n    <linearGradient xlink:href=\"#").concat(id, "-a\" id=\"").concat(id, "-b\" x1=\"463.285\" x2=\"463.285\" y2=\"27\"/>\n    <linearGradient xlink:href=\"#").concat(id, "-a\" id=\"").concat(id, "-c\" x1=\"455.285\" x2=\"455.285\" y2=\"22\"/>\n    <linearGradient xlink:href=\"#").concat(id, "-a\" id=\"").concat(id, "-d\" x1=\"471.285\" x2=\"471.285\" y2=\"20\"/>\n  </defs>\n  <g fill=\"").concat(colors.atlassianLogoTextColor, "\">\n    <path d=\"M106.72 18.359c0 4.201 1.949 7.536 9.572 9.008 4.548.953 5.5 1.689 5.5 3.205 0 1.473-.953 2.425-4.158 2.425-3.725 0-8.142-1.256-11.044-2.988v6.843c2.295 1.126 5.327 2.382 10.957 2.382 7.969 0 11.131-3.551 11.131-8.835m0 0c0-4.981-2.642-7.319-10.091-8.922-4.114-.91-5.111-1.819-5.111-3.118 0-1.646 1.473-2.339 4.201-2.339 3.292 0 6.54.996 9.615 2.382v-6.54c-2.166-1.083-5.5-1.949-9.398-1.949-7.363 0-11.174 3.205-11.174 8.445M209.1 10.346v28.455h6.063V17.103l2.556 5.76 8.575 15.938h7.623V10.346h-6.064V28.71l-2.295-5.327-6.886-13.037H209.1zM163.909 10.346h6.626v28.455h-6.626zM156.263 30.399c0-4.981-2.642-7.319-10.091-8.922-4.114-.91-5.111-1.819-5.111-3.118 0-1.646 1.473-2.339 4.201-2.339 3.292 0 6.54.996 9.615 2.382v-6.54c-2.166-1.083-5.5-1.949-9.398-1.949-7.363 0-11.174 3.205-11.174 8.445 0 4.201 1.949 7.536 9.572 9.008 4.548.953 5.5 1.689 5.5 3.205 0 1.473-.953 2.425-4.158 2.425-3.725 0-8.142-1.256-11.044-2.988v6.843c2.295 1.126 5.327 2.382 10.957 2.382 7.969 0 11.131-3.551 11.131-8.835M55.243 10.346v28.455h13.62l2.145-6.15h-9.095V10.346h-6.67zM28.334 10.346v6.15h7.363v22.305h6.67V16.496h7.882v-6.15H28.334zM18.663 10.346h-8.74L0 38.801h7.579l1.407-4.792a18.852 18.852 0 0 0 10.612 0l1.407 4.792h7.579l-9.922-28.455Zm-4.37 18.533c-1.267 0-2.49-.185-3.647-.524l3.647-12.422 3.647 12.422c-1.157.339-2.38.524-3.647.524ZM92.344 10.346h-8.74l-9.922 28.455h7.579l1.407-4.792a18.852 18.852 0 0 0 10.612 0l1.407 4.792h7.579l-9.922-28.455Zm-4.37 18.533c-1.267 0-2.49-.185-3.647-.524l3.647-12.422 3.647 12.422c-1.157.339-2.38.524-3.647.524ZM194.414 10.346h-8.74l-9.922 28.455h7.579l1.407-4.792a18.852 18.852 0 0 0 10.612 0l1.407 4.792h7.579l-9.922-28.455Zm-4.37 18.533c-1.267 0-2.49-.185-3.647-.524l3.647-12.422 3.647 12.422c-1.157.339-2.38.524-3.647.524Z\"/>\n  </g>\n  <g fill=\"").concat(colors.textColor, "\">\n    <path d=\"m254.776 31.987-2.53 6.809H247.6l11.916-30.225h5.244l11.916 30.225h-4.646l-2.53-6.855c-2.714.552-5.061.828-7.499.828-2.3 0-4.646-.276-7.223-.782Zm13.479-3.496-6.119-16.562-6.119 16.608c2.254.368 4.141.552 5.98.552 1.933 0 3.911-.23 6.257-.598ZM298.984 38.796h-3.957V24.902c0-4.141-1.656-5.981-5.428-5.981-3.681 0-6.211 2.438-6.211 7.085v12.79h-3.957V15.794h3.957v3.772c1.472-2.715 4.187-4.232 7.269-4.232 5.291 0 8.327 3.634 8.327 9.983v13.479ZM320.097 34.656c-1.472 3.036-4.232 4.6-7.775 4.6-6.119 0-9.201-5.199-9.201-11.961 0-6.486 3.22-11.961 9.661-11.961 3.358 0 5.935 1.518 7.314 4.508v-4.048h3.957v23.002h-3.957v-4.14Zm-6.717.92c3.542 0 6.717-2.254 6.717-7.361v-1.84c0-5.106-2.898-7.361-6.256-7.361-4.463 0-6.763 2.944-6.763 8.281 0 5.521 2.208 8.281 6.303 8.281ZM336.196 38.935c-3.772 0-6.165-1.794-6.165-6.027V6.179h3.957v26.269c0 2.07 1.38 2.806 3.083 2.806.414 0 .69 0 1.15-.046v3.542c-.322.092-1.012.184-2.024.184ZM347.328 37.324l-8.327-21.53h4.232l7.361 19.69 7.361-19.69h4.232l-8.695 22.267c-2.576 6.579-4.048 9.983-9.891 9.983-1.979 0-3.083-.184-4.232-.644v-3.404c1.334.414 2.852.552 4.002.552 3.22 0 4.646-2.208 6.533-7.223h-2.576ZM374.698 35.07c.92 0 1.794-.185 2.484-.322v3.818c-.69.184-1.472.368-2.668.368-4.923 0-7.315-2.898-7.315-7.177V19.473h-3.727v-3.68h3.727v-4.877h3.864v4.877h6.119v3.68h-6.119v12.191c0 2.024 1.196 3.405 3.635 3.405ZM384.265 6.961c1.61 0 2.76 1.012 2.76 2.76s-1.15 2.76-2.76 2.76-2.76-1.012-2.76-2.76 1.15-2.76 2.76-2.76Zm-2.024 8.833h3.957v23.002h-3.957V15.794ZM408.416 38.198c-1.38.736-3.496 1.058-5.612 1.058-8.189 0-12.007-4.968-12.007-12.007 0-6.947 3.818-11.915 12.007-11.915 2.07 0 3.68.276 5.475 1.104v3.681c-1.472-.69-3.037-1.104-5.199-1.104-5.98 0-8.419 3.772-8.419 8.235s2.484 8.235 8.511 8.235c2.346 0 3.818-.322 5.244-.828v3.542ZM420.144 39.256c-3.451 0-6.257-.782-8.005-1.702v-4.187c1.978 1.15 5.291 2.254 8.188 2.254 3.037 0 4.601-1.242 4.601-3.036 0-1.749-1.334-2.761-5.705-3.818-5.106-1.242-7.269-3.221-7.269-6.993 0-4.002 3.082-6.44 8.327-6.44 2.99 0 5.705.736 7.407 1.656v4.094c-2.76-1.38-5.014-2.117-7.453-2.117-2.898 0-4.462 1.013-4.462 2.807 0 1.61 1.104 2.622 5.336 3.635 5.106 1.242 7.683 3.128 7.683 7.13 0 3.819-2.484 6.717-8.649 6.717Z\"/>\n  </g>\n  <path fill=\"url(#").concat(id, "-a)\" d=\"M445.285 30h4v10h-4z\"/>\n  <path fill=\"url(#").concat(id, "-b)\" d=\"M461.285 27h4v13h-4z\"/>\n  <path fill=\"url(#").concat(id, "-c)\" d=\"M453.285 22h4v18h-4z\"/>\n  <path fill=\"url(#").concat(id, "-d)\" d=\"M469.285 20h4v20h-4z\"/>\n  <path fill=\"").concat(colors.iconColor, "\" d=\"m443.699 25.414-2.828-2.828 10.127-10.128a5 5 0 0 1 6.605-.411l4.471 3.477a1.5 1.5 0 0 0 1.982-.123l9.815-9.815 2.828 2.828-10.127 10.128a5 5 0 0 1-6.605.411l-4.471-3.477a1.5 1.5 0 0 0-1.982.123l-9.815 9.815Z\"/>\n</svg>");
};
var $a50d66907d59a53c$export$e6470bfc39010cc4 = function AtlassianAnalyticsLogo(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Atlassian Analytics' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $293a60c0ae776fbb$export$438460117ae6b7ee).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $293a60c0ae776fbb$export$438460117ae6b7ee).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $293a60c0ae776fbb$export$438460117ae6b7ee).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $233cd94b869ba248$export$2e2bcd8739ae039)(), colorMode = _useThemeObserver.colorMode;
    var id = (0, $c797bf80d6171378$export$f680877a34711e37)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $f2142a8b85819ba3$export$2e2bcd8739ae039), {
        appearance: appearance,
        label: label,
        size: size,
        iconColor: iconColor,
        svg: $a50d66907d59a53c$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode, id),
        testId: testId,
        textColor: textColor
    });
};



var $5FkrB = parcelRequire("5FkrB");




var $fb6f2ed4dbc293a5$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor;
    var colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $28050253965a3cad$export$bbacc3980e0f3029)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" viewBox=\"0 0 32 32\" focusable=\"false\" aria-hidden=\"true\" xmlns=\"http://www.w3.org/2000/svg\">\n      <path fill=".concat(colors.iconColor, " d=\"m25.586 15.819-1.618 9.885c-.106.598-.528.95-1.126.95H9.122c-.598 0-1.02-.352-1.126-.95L5.146 8.08c-.105-.598.212-.985.775-.985h20.123c.562 0 .88.387.773.985l-.773 4.644c-.106.668-.493.95-1.126.95H12.816c-.176 0-.282.105-.246.316l.95 5.84c.035.14.14.246.281.246h4.362c.141 0 .246-.105.282-.246l.668-4.222c.07-.527.422-.738.915-.738h4.75c.703 0 .914.351.808.95\"/>\n    </svg>");
};
var $fb6f2ed4dbc293a5$export$5fc1066e677788d4 = function BitbucketIcon(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Bitbucket' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $293a60c0ae776fbb$export$438460117ae6b7ee).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $293a60c0ae776fbb$export$438460117ae6b7ee).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $293a60c0ae776fbb$export$438460117ae6b7ee).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $233cd94b869ba248$export$2e2bcd8739ae039)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $f2142a8b85819ba3$export$2e2bcd8739ae039), {
        appearance: appearance,
        label: label,
        svg: $fb6f2ed4dbc293a5$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        size: size,
        testId: testId,
        textColor: textColor
    });
};


var $5FkrB = parcelRequire("5FkrB");




var $daf3395e352ba399$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor;
    var colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $28050253965a3cad$export$bbacc3980e0f3029)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" viewBox=\"0 0 158 32\" focusable=\"false\" aria-hidden=\"true\" xmlns=\"http://www.w3.org/2000/svg\">\n        <path fill=".concat(colors.iconColor, " d=\"m20.46 15.152-1.619 9.885c-.105.598-.527.95-1.125.95H3.996c-.599 0-1.02-.352-1.126-.95L.02 7.412c-.105-.598.211-.985.774-.985h20.123c.563 0 .88.387.774.985l-.774 4.644c-.106.668-.493.95-1.126.95H7.69c-.176 0-.281.105-.246.316l.95 5.84c.035.141.14.247.281.247h4.363c.14 0 .246-.106.281-.247l.668-4.221c.07-.528.423-.739.915-.739h4.75c.703 0 .914.352.809.95\"/>\n        <path fill=").concat(colors.textColor, " d=\"M153.212 20.787c0 1.35.797 2.27 2.422 2.27.614 0 1.196-.123 1.656-.215v2.545c-.46.123-.981.245-1.778.245-3.282 0-4.876-1.932-4.876-4.784v-8.187h-2.484v-2.454h2.484v-3.25h2.576v3.25h4.078v2.453h-4.078zm-13.537-8.494c-2.791 0-4.201 1.809-4.477 4.477h8.556c-.154-2.852-1.442-4.477-4.079-4.477m5.888 12.634c-1.257.675-3.189.92-4.753.92-5.735 0-8.25-3.312-8.25-8.004 0-4.63 2.576-7.942 7.238-7.942 4.722 0 6.624 3.281 6.624 7.942v1.196h-11.194c.368 2.607 2.055 4.294 5.674 4.294 1.778 0 3.281-.338 4.661-.828zm-23.82.613h-2.638V3.799h2.638v13.585l6.593-7.176h3.435l-7.207 7.544 7.513 7.79h-3.588l-6.746-7.176zm-5.648-2.76v2.362c-.92.49-2.331.705-3.742.705-5.458 0-8.004-3.312-8.004-8.004 0-4.63 2.546-7.942 8.004-7.942 1.38 0 2.454.184 3.65.736v2.453c-.982-.46-2.024-.736-3.466-.736-3.986 0-5.612 2.515-5.612 5.49s1.656 5.489 5.674 5.489c1.564 0 2.545-.215 3.496-.552m-27.843-3.588v-8.986h2.637v9.262c0 2.76 1.104 3.986 3.619 3.986 2.453 0 4.14-1.625 4.14-4.722v-8.526h2.637v15.334h-2.637v-2.515c-.982 1.81-2.79 2.821-4.846 2.821-3.526 0-5.55-2.422-5.55-6.654m-5.388-1.319c0-3.68-1.472-5.52-4.201-5.52-2.362 0-4.478 1.503-4.478 4.907v1.226c0 3.404 1.932 4.907 4.171 4.907 2.975 0 4.508-1.963 4.508-5.52m-3.803 7.973c-2.238 0-3.956-1.012-4.876-3.005v2.699h-2.637V3.798h2.637v9.17c.982-2.025 2.822-3.067 5.183-3.067 4.079 0 6.133 3.465 6.133 7.973 0 4.324-2.146 7.973-6.44 7.973m-14.974-5.06c0 1.35.797 2.27 2.422 2.27.614 0 1.196-.123 1.656-.215v2.545a6.3 6.3 0 0 1-1.778.245c-3.282 0-4.876-1.932-4.876-4.784v-8.187h-2.484v-2.454h2.484v-3.25h2.576v3.25h4.078v2.453h-4.078zM53.328 6.16c0-1.166.767-1.84 1.84-1.84s1.84.674 1.84 1.84S56.242 8 55.168 8s-1.84-.676-1.84-1.84m.49 19.38V10.207h2.638V25.54zm-9.828-9.046h-6.194v6.287h6.256c2.637 0 3.833-.951 3.833-2.975 0-2.147-1.134-3.312-3.894-3.312m-.889-8.464h-5.305v6.01h5.305c2.607 0 3.68-1.195 3.68-3.127 0-1.963-1.165-2.883-3.68-2.883m-8.065 17.51V5.394h8.433c4.11 0 6.103 2.024 6.103 5.274 0 2.423-1.104 3.926-3.373 4.478 2.974.49 4.446 2.116 4.446 4.968 0 3.22-2.177 5.428-6.685 5.428z\"/>\n      </svg>");
};
var $daf3395e352ba399$export$bd40525f5333524b = function BitbucketLogo(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Bitbucket' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $293a60c0ae776fbb$export$438460117ae6b7ee).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $293a60c0ae776fbb$export$438460117ae6b7ee).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $293a60c0ae776fbb$export$438460117ae6b7ee).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $233cd94b869ba248$export$2e2bcd8739ae039)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $f2142a8b85819ba3$export$2e2bcd8739ae039), {
        appearance: appearance,
        label: label,
        iconColor: iconColor,
        size: size,
        svg: $daf3395e352ba399$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};



var $5FkrB = parcelRequire("5FkrB");




var $8766aaddeb74cb66$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor;
    var colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $28050253965a3cad$export$bbacc3980e0f3029)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" viewBox=\"0 0 32 32\" focusable=\"false\" aria-hidden=\"true\" xmlns=\"http://www.w3.org/2000/svg\">\n      <path fill=\"".concat(colors.iconColor, "\" d=\"M15.667 15.66v5.942H9.713V15.66zV9.722H4.807c-.58.004-1.047.47-1.043 1.04v15.755a1.04 1.04 0 0 0 1.028 1.054h15.771a1.04 1.04 0 0 0 1.042-1.04V15.66zm0-11.88v5.942h5.967v5.938h5.935V4.82a1.04 1.04 0 0 0-1.028-1.053h-.014z\"/>\n      </svg>\n    ");
};
var $8766aaddeb74cb66$export$f7857fe64d7161d9 = function CompassIcon(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Compass' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $293a60c0ae776fbb$export$438460117ae6b7ee).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $293a60c0ae776fbb$export$438460117ae6b7ee).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $293a60c0ae776fbb$export$438460117ae6b7ee).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $233cd94b869ba248$export$2e2bcd8739ae039)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $f2142a8b85819ba3$export$2e2bcd8739ae039), {
        appearance: appearance,
        label: label,
        svg: $8766aaddeb74cb66$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        size: size,
        testId: testId,
        textColor: textColor
    });
};


var $5FkrB = parcelRequire("5FkrB");




var $7b83e08f5c39155d$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor;
    var colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $28050253965a3cad$export$bbacc3980e0f3029)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" viewBox=\"0 0 155 32\" focusable=\"false\" aria-hidden=\"true\" xmlns=\"http://www.w3.org/2000/svg\">\n    <path fill=".concat(colors.iconColor, " d=\"M11.903 14.993v5.942H5.95v-5.942zV9.055H1.043c-.58.004-1.047.47-1.043 1.04v15.756a1.04 1.04 0 0 0 1.028 1.054H16.8a1.04 1.04 0 0 0 1.043-1.04V14.993zm0-11.879v5.941h5.967v5.938h5.936V4.153A1.04 1.04 0 0 0 22.778 3.1h-.015z\"/>\n    <path fill=\"").concat(colors.textColor, "\" d=\"M154.46 21.37c0 2.545-1.656 4.477-5.765 4.477-2.3 0-4.171-.521-5.336-1.134v-2.791c1.318.767 3.526 1.503 5.458 1.503 2.024 0 3.067-.828 3.067-2.024 0-1.166-.889-1.84-3.803-2.546-3.404-.828-4.845-2.146-4.845-4.661 0-2.668 2.055-4.293 5.551-4.293 1.993 0 3.802.49 4.937 1.104v2.729c-1.84-.92-3.343-1.41-4.968-1.41-1.932 0-2.975.674-2.975 1.87 0 1.073.736 1.748 3.558 2.423 3.404.828 5.121 2.085 5.121 4.753m-13.626 0c0 2.545-1.656 4.477-5.766 4.477-2.3 0-4.17-.521-5.336-1.134v-2.791c1.319.767 3.527 1.503 5.459 1.503 2.024 0 3.067-.828 3.067-2.024 0-1.166-.89-1.84-3.803-2.546-3.404-.828-4.845-2.146-4.845-4.661 0-2.668 2.054-4.293 5.55-4.293 1.994 0 3.803.49 4.938 1.104v2.729c-1.84-.92-3.343-1.41-4.968-1.41-1.932 0-2.975.674-2.975 1.87 0 1.073.736 1.748 3.557 2.423 3.404.828 5.122 2.085 5.122 4.753m-25.873-3.496c0 3.68 1.472 5.52 4.201 5.52 2.361 0 4.477-1.503 4.477-4.907v-1.226c0-3.404-1.932-4.907-4.17-4.907-2.975 0-4.508 1.963-4.508 5.52m8.678 7.667v-2.76c-.981 2.024-2.821 3.066-5.182 3.066-4.079 0-6.134-3.465-6.134-7.973 0-4.324 2.147-7.973 6.44-7.973 2.239 0 3.956 1.012 4.876 3.005v-2.699h2.638v15.334zm-16.09-7.667c0-3.68-1.472-5.52-4.201-5.52-2.362 0-4.478 1.503-4.478 4.907v1.226c0 3.404 1.932 4.907 4.171 4.907 2.975 0 4.508-1.963 4.508-5.52m-3.803 7.973c-2.238 0-3.956-1.012-4.876-3.005v8.679h-2.637V10.207h2.637v2.76c.982-2.024 2.822-3.066 5.183-3.066 4.079 0 6.133 3.465 6.133 7.973 0 4.324-2.146 7.973-6.44 7.973m-21.583-8.832v8.526h-2.637v-9.262c0-2.76-1.104-3.986-3.619-3.986-2.453 0-4.14 1.625-4.14 4.722v8.526H69.13V10.207h2.637v2.515c.982-1.81 2.791-2.821 4.846-2.821 2.606 0 4.385 1.318 5.152 3.741.858-2.361 2.913-3.741 5.458-3.741 3.435 0 5.336 2.33 5.336 6.654v8.986h-2.637v-8.526c0-3.158-1.104-4.722-3.619-4.722-2.453 0-4.14 1.625-4.14 4.722m-23.335 8.832c-4.6 0-7.299-3.404-7.299-8.004s2.699-7.942 7.299-7.942c4.57 0 7.237 3.342 7.237 7.942s-2.668 8.004-7.237 8.004m0-13.493c-3.282 0-4.723 2.576-4.723 5.49s1.441 5.55 4.723 5.55c3.25 0 4.661-2.637 4.661-5.55s-1.41-5.49-4.661-5.49m-9.233 9.629v2.668c-1.258.828-3.251 1.196-5.336 1.196-6.624 0-10.366-3.986-10.366-10.334 0-6.134 3.742-10.427 10.304-10.427 1.963 0 3.926.368 5.367 1.41v2.669c-1.441-.92-3.036-1.411-5.367-1.411-4.722 0-7.544 3.128-7.544 7.759s2.914 7.697 7.698 7.697c2.116 0 3.772-.49 5.244-1.227\"/>\n  </svg>");
};
var $7b83e08f5c39155d$export$eb7d748e4f9c9676 = function CompassLogo(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Compass' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $293a60c0ae776fbb$export$438460117ae6b7ee).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $293a60c0ae776fbb$export$438460117ae6b7ee).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $293a60c0ae776fbb$export$438460117ae6b7ee).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $233cd94b869ba248$export$2e2bcd8739ae039)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $f2142a8b85819ba3$export$2e2bcd8739ae039), {
        appearance: appearance,
        label: label,
        iconColor: iconColor,
        size: size,
        svg: $7b83e08f5c39155d$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};



var $5FkrB = parcelRequire("5FkrB");




var $5bf2c707e48e8a07$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor;
    var colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $28050253965a3cad$export$bbacc3980e0f3029)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" viewBox=\"0 0 32 32\" focusable=\"false\" aria-hidden=\"true\" xmlns=\"http://www.w3.org/2000/svg\">\n      <path fill=\"".concat(colors.iconColor, "\" d=\"M25.769 20.234c-6.584-3.183-8.507-3.66-11.282-3.66-3.254 0-6.028 1.355-8.507 5.16l-.406.622c-.333.513-.407.696-.407.915s.11.403.517.659l4.18 2.598c.222.146.407.22.592.22.222 0 .37-.11.592-.44l.665-1.024c1.036-1.574 1.96-2.086 3.144-2.086 1.036 0 2.257.293 3.773 1.025l4.365 2.049c.443.22.924.11 1.146-.403l2.071-4.537c.222-.512.074-.842-.444-1.098M6.572 12.22c6.584 3.184 8.507 3.66 11.281 3.66 3.255 0 6.03-1.354 8.507-5.16l.407-.622c.333-.512.407-.695.407-.915s-.11-.402-.518-.658l-4.18-2.598c-.221-.147-.406-.22-.591-.22-.222 0-.37.11-.592.44l-.666 1.024c-1.035 1.573-1.96 2.086-3.144 2.086-1.035 0-2.256-.293-3.772-1.025L9.346 6.183c-.444-.22-.924-.11-1.146.402l-2.072 4.538c-.222.512-.074.841.444 1.098\"/>\n    </svg>");
};
var $5bf2c707e48e8a07$export$68f3db7f6af48bcb = function ConfluenceIcon(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Confluence' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $293a60c0ae776fbb$export$438460117ae6b7ee).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $293a60c0ae776fbb$export$438460117ae6b7ee).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $293a60c0ae776fbb$export$438460117ae6b7ee).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $233cd94b869ba248$export$2e2bcd8739ae039)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $f2142a8b85819ba3$export$2e2bcd8739ae039), {
        appearance: appearance,
        label: label,
        svg: $5bf2c707e48e8a07$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        size: size,
        testId: testId,
        textColor: textColor
    });
};


var $5FkrB = parcelRequire("5FkrB");




var $228d07068f21c9cd$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor;
    var colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $28050253965a3cad$export$bbacc3980e0f3029)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" viewBox=\"0 0 180 32\" focusable=\"false\" aria-hidden=\"true\" xmlns=\"http://www.w3.org/2000/svg\">\n      <path fill=\"".concat(colors.iconColor, "\" d=\"M20.602 20.234c-6.584-3.183-8.507-3.66-11.281-3.66-3.255 0-6.03 1.355-8.507 5.16l-.407.622c-.333.513-.407.696-.407.915s.111.403.518.659l4.18 2.598c.221.146.406.22.591.22.222 0 .37-.11.592-.44l.666-1.024c1.035-1.574 1.96-2.086 3.144-2.086 1.035 0 2.256.293 3.772 1.025l4.365 2.049c.444.22.925.11 1.146-.403l2.072-4.537c.222-.512.074-.842-.444-1.098M1.406 12.22c6.583 3.184 8.507 3.66 11.28 3.66 3.256 0 6.03-1.354 8.508-5.16l.407-.622c.332-.512.406-.695.406-.915s-.11-.402-.518-.658L17.31 5.927c-.222-.147-.407-.22-.592-.22-.222 0-.37.11-.592.44l-.665 1.024c-1.036 1.573-1.96 2.086-3.144 2.086-1.036 0-2.257-.293-3.773-1.025L4.18 6.183c-.444-.22-.925-.11-1.147.402L.962 11.123c-.222.512-.074.841.444 1.098\"/>\n      <path fill=\"").concat(colors.textColor, "\" d=\"M172.49 12.293c-2.791 0-4.201 1.809-4.477 4.477h8.556c-.154-2.852-1.442-4.477-4.079-4.477m5.888 12.634c-1.257.675-3.189.92-4.753.92-5.735 0-8.25-3.312-8.25-8.004 0-4.63 2.576-7.942 7.238-7.942 4.722 0 6.624 3.281 6.624 7.942v1.196h-11.194c.368 2.607 2.055 4.294 5.674 4.294 1.778 0 3.281-.338 4.661-.828zm-15.093-2.147v2.362c-.92.49-2.331.705-3.742.705-5.458 0-8.004-3.312-8.004-8.004 0-4.63 2.546-7.942 8.004-7.942 1.38 0 2.454.184 3.65.736v2.453c-.982-.46-2.024-.736-3.466-.736-3.986 0-5.612 2.515-5.612 5.49s1.656 5.489 5.674 5.489c1.564 0 2.545-.215 3.496-.552m-14.503-6.226v8.986h-2.637v-9.262c0-2.76-1.104-3.986-3.619-3.986-2.453 0-4.14 1.625-4.14 4.722v8.526h-2.637V10.207h2.637v2.515c.981-1.81 2.791-2.821 4.845-2.821 3.527 0 5.551 2.422 5.551 6.654m-22.921-4.262c-2.79 0-4.201 1.809-4.477 4.477h8.556c-.154-2.852-1.441-4.477-4.079-4.477m5.888 12.634c-1.257.675-3.189.92-4.753.92-5.735 0-8.249-3.312-8.249-8.004 0-4.63 2.576-7.942 7.237-7.942 4.723 0 6.624 3.281 6.624 7.942v1.196h-11.193c.368 2.607 2.054 4.294 5.673 4.294 1.778 0 3.281-.338 4.661-.828zm-29.1-5.734v-8.986h2.637v9.262c0 2.76 1.104 3.986 3.619 3.986 2.453 0 4.14-1.625 4.14-4.722v-8.526h2.637v15.334h-2.637v-2.515c-.981 1.81-2.791 2.821-4.845 2.821-3.527 0-5.551-2.422-5.551-6.654m-2.231 6.317c-.215.061-.674.122-1.35.122-2.514 0-4.108-1.196-4.108-4.017V3.798h2.637v17.51c0 1.38.92 1.871 2.055 1.871.275 0 .459 0 .766-.03zM88.157 8.582v1.625h3.956v2.454h-3.956v12.88h-2.576V12.66h-2.484v-2.454h2.484V8.521c0-2.852 1.595-4.784 4.876-4.784a6.3 6.3 0 0 1 1.779.245v2.423a8.7 8.7 0 0 0-1.656-.154c-1.626 0-2.423.95-2.423 2.33m-7.327 7.974v8.986h-2.637v-9.262c0-2.76-1.104-3.986-3.619-3.986-2.453 0-4.14 1.625-4.14 4.722v8.526h-2.637V10.207h2.637v2.515c.981-1.81 2.79-2.821 4.845-2.821 3.527 0 5.551 2.422 5.551 6.654m-23.336 9.292c-4.6 0-7.298-3.404-7.298-8.004s2.698-7.942 7.298-7.942c4.57 0 7.238 3.342 7.238 7.942s-2.668 8.004-7.238 8.004m0-13.493c-3.28 0-4.722 2.576-4.722 5.49s1.441 5.55 4.722 5.55c3.251 0 4.662-2.637 4.662-5.55s-1.41-5.49-4.662-5.49m-9.233 9.629v2.668c-1.257.828-3.25 1.196-5.336 1.196-6.624 0-10.365-3.986-10.365-10.334 0-6.134 3.741-10.427 10.304-10.427 1.963 0 3.925.368 5.367 1.41v2.669c-1.442-.92-3.036-1.411-5.367-1.411-4.723 0-7.544 3.128-7.544 7.759s2.913 7.697 7.697 7.697c2.116 0 3.772-.49 5.244-1.227\"/>\n    </svg>\n    ");
};
var $228d07068f21c9cd$export$1b2e4fe6ef471556 = function ConfluenceLogo(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Confluence' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $293a60c0ae776fbb$export$438460117ae6b7ee).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $293a60c0ae776fbb$export$438460117ae6b7ee).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $293a60c0ae776fbb$export$438460117ae6b7ee).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $233cd94b869ba248$export$2e2bcd8739ae039)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $f2142a8b85819ba3$export$2e2bcd8739ae039), {
        appearance: appearance,
        label: label,
        iconColor: iconColor,
        size: size,
        svg: $228d07068f21c9cd$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};



var $5FkrB = parcelRequire("5FkrB");




var $2d51a09fdc6dbd6f$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor;
    var colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $28050253965a3cad$export$bbacc3980e0f3029)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" viewBox=\"0 0 48 48\" focusable=\"false\" aria-hidden=\"true\" xmlns=\"http://www.w3.org/2000/svg\">\n\t\t<path fill=\"".concat(colors.iconColor, "\" d=\"M45.4277 24.5018C41.4108 20.4849 34.8821 20.5276 30.908 24.5018L27.5636 27.8462C25.717 29.6927 22.7177 29.6927 20.8712 27.8462L18.0925 25.0675L10.8309 32.3291L13.6096 35.1078C19.4658 40.9641 28.9654 40.9641 34.8216 35.1078L45.4277 24.5018ZM3 23.5018C7.01684 27.5186 13.4637 27.5578 17.4805 23.5409L20.8676 20.1538C22.7142 18.3073 25.7135 18.3073 27.56 20.1538L30.3387 22.9325L37.6003 15.6709L34.8216 12.8922C28.9654 7.03593 19.4658 7.03593 13.6096 12.8922L3.00356 23.4982L3 23.5018Z\"/>\n\t\t</svg>\n\t\t");
};
var $2d51a09fdc6dbd6f$export$1e02e7298035a77c = function FocusIcon(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Focus' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $293a60c0ae776fbb$export$438460117ae6b7ee).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $293a60c0ae776fbb$export$438460117ae6b7ee).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $293a60c0ae776fbb$export$438460117ae6b7ee).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $233cd94b869ba248$export$2e2bcd8739ae039)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $f2142a8b85819ba3$export$2e2bcd8739ae039), {
        appearance: appearance,
        label: label,
        svg: $2d51a09fdc6dbd6f$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        size: size,
        testId: testId,
        textColor: textColor
    });
};


var $5FkrB = parcelRequire("5FkrB");




var $43c1294a9c6a0e6c$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor;
    var colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $28050253965a3cad$export$bbacc3980e0f3029)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" viewBox=\"0 0 168 48\" focusable=\"false\" aria-hidden=\"true\" xmlns=\"http://www.w3.org/2000/svg\">\n\t\t<path fill=\"".concat(colors.iconColor, "\" d=\"M42.4277 24.5018C38.4108 20.4849 31.8821 20.5276 27.908 24.5018L24.5636 27.8462C22.717 29.6927 19.7177 29.6927 17.8712 27.8462L15.0925 25.0675L7.83088 32.3291L10.6096 35.1078C16.4658 40.9641 25.9654 40.9641 31.8216 35.1078L42.4277 24.5018ZM0 23.5018C4.01684 27.5186 10.4637 27.5578 14.4805 23.5409L17.8676 20.1538C19.7142 18.3073 22.7135 18.3073 24.56 20.1538L27.3387 22.9325L34.6003 15.6709L31.8216 12.8922C25.9654 7.03593 16.4658 7.03593 10.6096 12.8922L0.00355592 23.4982L0 23.5018Z\"/>\n\t\t<path fill=\"").concat(colors.textColor, "\" d=\"M167.405 31.746C167.405 35.564 164.921 38.462 158.757 38.462C155.307 38.462 152.501 37.68 150.753 36.76V32.574C152.731 33.724 156.043 34.828 158.941 34.828C161.977 34.828 163.541 33.586 163.541 31.792C163.541 30.044 162.207 29.032 157.837 27.974C152.731 26.732 150.569 24.754 150.569 20.982C150.569 16.98 153.651 14.542 158.895 14.542C161.885 14.542 164.599 15.278 166.301 16.198V20.292C163.541 18.912 161.287 18.176 158.849 18.176C155.951 18.176 154.387 19.188 154.387 20.982C154.387 22.592 155.491 23.604 159.723 24.616C164.829 25.858 167.405 27.744 167.405 31.746Z\"/>\n\t\t<path fill=\"").concat(colors.textColor, "\" d=\"M126.009 28.48V15.002H129.965V28.894C129.965 33.034 131.621 34.874 135.393 34.874C139.073 34.874 141.603 32.436 141.603 27.79V15.002H145.559V38.002H141.603V34.23C140.131 36.944 137.417 38.462 134.335 38.462C129.045 38.462 126.009 34.828 126.009 28.48Z\"/>\n\t\t<path fill=\"").concat(colors.textColor, "\" d=\"M121.953 33.862V37.404C120.573 38.14 118.457 38.462 116.341 38.462C108.153 38.462 104.335 33.494 104.335 26.456C104.335 19.51 108.153 14.542 116.341 14.542C118.411 14.542 120.021 14.818 121.815 15.646V19.326C120.343 18.636 118.779 18.222 116.617 18.222C110.637 18.222 108.199 21.994 108.199 26.456C108.199 30.918 110.683 34.69 116.709 34.69C119.055 34.69 120.527 34.368 121.953 33.862Z\"/>\n\t\t<path fill=\"").concat(colors.textColor, "\" d=\"M90.2616 38.462C83.3616 38.462 79.3136 33.356 79.3136 26.456C79.3136 19.556 83.3616 14.542 90.2616 14.542C97.1156 14.542 101.118 19.556 101.118 26.456C101.118 33.356 97.1156 38.462 90.2616 38.462ZM90.2616 18.222C85.3396 18.222 83.1776 22.086 83.1776 26.456C83.1776 30.826 85.3396 34.782 90.2616 34.782C95.1376 34.782 97.2536 30.826 97.2536 26.456C97.2536 22.086 95.1376 18.222 90.2616 18.222Z\"/>\n\t\t<path fill=\"").concat(colors.textColor, "\" d=\"M75.298 26.732H61.59V38.002H57.45V7.78003H76.862V11.736H61.59V22.776H75.298V26.732Z\"/>\n\t\t</svg>\n\t\t");
};
var $43c1294a9c6a0e6c$export$33908560ea1b226d = function FocusLogo(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Focus' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $293a60c0ae776fbb$export$438460117ae6b7ee).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $293a60c0ae776fbb$export$438460117ae6b7ee).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $293a60c0ae776fbb$export$438460117ae6b7ee).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $233cd94b869ba248$export$2e2bcd8739ae039)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $f2142a8b85819ba3$export$2e2bcd8739ae039), {
        appearance: appearance,
        label: label,
        iconColor: iconColor,
        size: size,
        svg: $43c1294a9c6a0e6c$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};



var $5FkrB = parcelRequire("5FkrB");




var $c06feaf9d9aa6a56$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor;
    var colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $28050253965a3cad$export$bbacc3980e0f3029)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" focusable=\"false\" aria-hidden=\"true\">\n      <path\n        d=\"M5.584 14.4h20.83c.599 0 .918-.32.918-.918V6.459c0-.599-.319-.918-.918-.918h-4.39c-.598 0-.917.32-.917.918v3.551h-1.995V6.46c0-.599-.32-.918-.918-.918h-4.39c-.598 0-.917.32-.917.918v3.551h-1.995V6.46c0-.599-.32-.918-.918-.918h-4.39c-.598 0-.917.32-.917.918v7.023c0 .599.319.918.917.918zm.36 6.145a13.9 13.9 0 0 1-.798-3.99c-.04-.52.199-.799.758-.799h20.191c.559 0 .798.24.798.719q-.12 2.214-.838 4.07c-.24.638-.598.918-1.277.918H7.221c-.679 0-1.038-.28-1.277-.918m18.475 3.312c-1.915 2.354-5.068 3.87-8.42 3.87s-6.584-1.516-8.46-3.87c-.478-.638-.239-1.038.24-1.038h16.44c.48 0 .719.4.2 1.038\"\n        fill=\"".concat(colors.iconColor, "\"\n      />\n    </svg>");
};
var $c06feaf9d9aa6a56$export$3f95fcfdc25a741d = function GuardIcon(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Guard' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $293a60c0ae776fbb$export$438460117ae6b7ee).size : _ref2$size, testId = _ref2.testId, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $293a60c0ae776fbb$export$438460117ae6b7ee).textColor : _ref2$textColor, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $293a60c0ae776fbb$export$438460117ae6b7ee).iconColor : _ref2$iconColor;
    var _useThemeObserver = (0, $233cd94b869ba248$export$2e2bcd8739ae039)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $f2142a8b85819ba3$export$2e2bcd8739ae039), {
        appearance: appearance,
        svg: $c06feaf9d9aa6a56$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        label: label,
        size: size,
        testId: testId,
        textColor: textColor
    });
};


var $5FkrB = parcelRequire("5FkrB");




var $9e38f3206f1da36d$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor;
    var colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $28050253965a3cad$export$bbacc3980e0f3029)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 114 32\" focusable=\"false\" aria-hidden=\"true\">\n      <path\n        d=\"M.918 13.733h20.83c.598 0 .918-.32.918-.918V5.792c0-.599-.32-.918-.918-.918h-4.39c-.598 0-.918.32-.918.918v3.551h-1.995V5.792c0-.599-.319-.918-.918-.918H9.139c-.599 0-.918.32-.918.918v3.551H6.225V5.792c0-.599-.32-.918-.918-.918H.917c-.598 0-.917.32-.917.918v7.023c0 .599.32.918.918.918m.359 6.145a13.9 13.9 0 0 1-.798-3.99c-.04-.52.2-.799.758-.799h20.191c.56 0 .799.24.799.719q-.12 2.214-.838 4.07c-.24.638-.599.918-1.277.918H2.554c-.679 0-1.038-.28-1.277-.918m18.476 3.312c-1.916 2.354-5.068 3.87-8.42 3.87s-6.584-1.516-8.46-3.87c-.479-.638-.24-1.038.24-1.038h16.44c.479 0 .718.4.2 1.038\"\n        fill=\"".concat(colors.iconColor, "\"\n      />\n      <path\n        d=\"M102.398 17.874c0 3.68 1.472 5.52 4.202 5.52 2.361 0 4.477-1.502 4.477-4.906V17.26c0-3.404-1.932-4.907-4.171-4.907-2.974 0-4.508 1.963-4.508 5.52zm8.679 7.667v-2.76c-.982 2.024-2.822 3.067-5.183 3.067-4.079 0-6.133-3.466-6.133-7.974 0-4.324 2.146-7.973 6.44-7.973 2.238 0 3.956 1.012 4.876 3.005V3.798h2.637v21.743zm-17.793-9.047v9.047h-2.576V10.208h2.576v2.698c.89-1.809 2.423-3.097 5.428-2.913v2.576c-3.373-.337-5.428.675-5.428 3.925m-17.869 1.381c0 3.68 1.472 5.52 4.201 5.52 2.362 0 4.478-1.503 4.478-4.907v-1.227c0-3.404-1.932-4.906-4.17-4.906-2.976 0-4.509 1.962-4.509 5.52m8.679 7.666v-2.76c-.982 2.024-2.822 3.067-5.183 3.067-4.079 0-6.133-3.465-6.133-7.973 0-4.324 2.146-7.974 6.44-7.974 2.238 0 3.956 1.012 4.876 3.006v-2.699h2.637v15.333zM56.68 19.193v-8.985h2.637v9.261c0 2.76 1.105 3.987 3.62 3.987 2.453 0 4.14-1.625 4.14-4.723v-8.525h2.637v15.333h-2.638v-2.514c-.981 1.809-2.79 2.821-4.845 2.821-3.527 0-5.55-2.423-5.55-6.655zm-3.973 5.213c-1.595.951-4.539 1.442-6.808 1.442-6.931 0-10.672-4.232-10.672-10.335 0-6.563 4.262-10.457 11.438-10.457 1.595 0 3.466.184 5.244.797v2.76c-1.533-.613-3.342-.89-5.213-.89-5.98 0-8.71 2.975-8.71 7.729 0 4.661 2.76 7.758 8.557 7.758.95 0 2.269-.092 3.404-.429v-5.612h-5.152v-2.637h7.912z\"\n        fill=\"").concat(colors.textColor, "\"\n      />\n    </svg>");
};
var $9e38f3206f1da36d$export$a4a891d202775deb = function GuardLogo(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Guard' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $293a60c0ae776fbb$export$438460117ae6b7ee).size : _ref2$size, testId = _ref2.testId, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $293a60c0ae776fbb$export$438460117ae6b7ee).textColor : _ref2$textColor, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $293a60c0ae776fbb$export$438460117ae6b7ee).iconColor : _ref2$iconColor;
    var _useThemeObserver = (0, $233cd94b869ba248$export$2e2bcd8739ae039)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $f2142a8b85819ba3$export$2e2bcd8739ae039), {
        appearance: appearance,
        iconColor: iconColor,
        label: label,
        size: size,
        svg: $9e38f3206f1da36d$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};



var $5FkrB = parcelRequire("5FkrB");




var $483fe67496eddb47$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor;
    var colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $28050253965a3cad$export$bbacc3980e0f3029)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" viewBox=\"0 0 32 32\" focusable=\"false\" aria-hidden=\"true\" xmlns=\"http://www.w3.org/2000/svg\">\n      <path fill=\"".concat(colors.iconColor, "\" d=\"M11.034 21.99h-2.22c-3.346 0-5.747-2.05-5.747-5.052h11.932c.619 0 1.019.44 1.019 1.062v12.007c-2.983 0-4.984-2.416-4.984-5.784zm5.893-5.967h-2.219c-3.347 0-5.748-2.013-5.748-5.015h11.933c.618 0 1.055.402 1.055 1.025V24.04c-2.983 0-5.02-2.416-5.02-5.784zm5.93-5.93h-2.219c-3.347 0-5.748-2.05-5.748-5.052h11.933c.618 0 1.018.439 1.018 1.025v12.007c-2.983 0-4.984-2.416-4.984-5.784z\"/>\n    </svg>");
};
var $483fe67496eddb47$export$c4b5b1f965d8b3eb = function JiraIcon(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Jira' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $293a60c0ae776fbb$export$438460117ae6b7ee).size : _ref2$size, testId = _ref2.testId, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $293a60c0ae776fbb$export$438460117ae6b7ee).textColor : _ref2$textColor, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $293a60c0ae776fbb$export$438460117ae6b7ee).iconColor : _ref2$iconColor;
    var _useThemeObserver = (0, $233cd94b869ba248$export$2e2bcd8739ae039)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $f2142a8b85819ba3$export$2e2bcd8739ae039), {
        appearance: appearance,
        label: label,
        svg: $483fe67496eddb47$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        size: size,
        testId: testId,
        textColor: textColor
    });
};


var $5FkrB = parcelRequire("5FkrB");




var $8b124443f34f90de$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor;
    var colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $28050253965a3cad$export$bbacc3980e0f3029)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" viewBox=\"0 0 77 32\" focusable=\"false\" aria-hidden=\"true\" xmlns=\"http://www.w3.org/2000/svg\">\n      <path fill=\"".concat(colors.iconColor, "\" d=\"M7.967 21.323H5.748C2.401 21.323 0 19.273 0 16.271h11.933c.618 0 1.018.44 1.018 1.062V29.34c-2.983 0-4.984-2.416-4.984-5.784zm5.894-5.967h-2.22c-3.346 0-5.747-2.013-5.747-5.015h11.932c.618 0 1.055.402 1.055 1.025v12.007c-2.983 0-5.02-2.416-5.02-5.784zm5.93-5.93h-2.22c-3.347 0-5.748-2.05-5.748-5.052h11.933c.618 0 1.019.439 1.019 1.025v12.007c-2.983 0-4.984-2.416-4.984-5.784z\"/>\n      <path fill=\"").concat(colors.textColor, "\" d=\"M65.023 17.874c0 3.68 1.472 5.52 4.202 5.52 2.36 0 4.477-1.503 4.477-4.907V17.26c0-3.404-1.932-4.906-4.17-4.906-2.975 0-4.509 1.962-4.509 5.52m8.679 7.666v-2.76c-.981 2.024-2.821 3.067-5.183 3.067-4.078 0-6.133-3.465-6.133-7.973 0-4.324 2.147-7.974 6.44-7.974 2.239 0 3.956 1.012 4.876 3.006v-2.699h2.637V25.54zM55.91 16.493v9.047h-2.577V10.207h2.576v2.698c.89-1.809 2.423-3.097 5.428-2.913v2.576c-3.373-.337-5.428.675-5.428 3.925M46.224 6.159c0-1.165.767-1.84 1.84-1.84s1.84.675 1.84 1.84-.767 1.84-1.84 1.84-1.84-.675-1.84-1.84m.49 19.381V10.207h2.638V25.54zm-6.427-5.95V5.393h2.76v14.015c0 3.71-1.626 6.256-5.428 6.256-1.442 0-2.546-.246-3.312-.522v-2.668c.828.338 1.84.522 2.852.522 2.33 0 3.128-1.41 3.128-3.404\"/>\n    </svg>");
};
var $8b124443f34f90de$export$17d3acb0b4379d02 = function JiraLogo(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Jira' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $293a60c0ae776fbb$export$438460117ae6b7ee).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $293a60c0ae776fbb$export$438460117ae6b7ee).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $293a60c0ae776fbb$export$438460117ae6b7ee).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $233cd94b869ba248$export$2e2bcd8739ae039)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $f2142a8b85819ba3$export$2e2bcd8739ae039), {
        appearance: appearance,
        label: label,
        iconColor: iconColor,
        size: size,
        svg: $8b124443f34f90de$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};



var $5FkrB = parcelRequire("5FkrB");




var $4ce496c177031001$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor;
    var colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $28050253965a3cad$export$bbacc3980e0f3029)(appearance, colorMode);
    return "<svg viewBox=\"0 0 32 32\" focusable=\"false\" aria-hidden=\"true\" height=\"32\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n    <path\n      fill=\"".concat(colors.iconColor, "\"\n      d=\"M25.52 25.727c0-3.604-2.949-6.517-6.517-6.517h-6.007v-5.497H6.48v10.813c0 .837.364 1.201 1.201 1.201zM6.48 6.687c0 3.604 2.876 6.517 6.48 6.517h6.043V18.7h6.517V7.888q0-1.2-1.201-1.201z\"\n    />\n  </svg>");
};
var $4ce496c177031001$export$407687b2dd89cc68 = function JiraAlignIcon(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Jira Align' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $293a60c0ae776fbb$export$438460117ae6b7ee).size : _ref2$size, testId = _ref2.testId, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $293a60c0ae776fbb$export$438460117ae6b7ee).textColor : _ref2$textColor, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $293a60c0ae776fbb$export$438460117ae6b7ee).iconColor : _ref2$iconColor;
    var _useThemeObserver = (0, $233cd94b869ba248$export$2e2bcd8739ae039)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $f2142a8b85819ba3$export$2e2bcd8739ae039), {
        appearance: appearance,
        label: label,
        svg: $4ce496c177031001$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        size: size,
        testId: testId,
        textColor: textColor
    });
};


var $5FkrB = parcelRequire("5FkrB");




var $246cd7570ed6cefd$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor;
    var colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $28050253965a3cad$export$bbacc3980e0f3029)(appearance, colorMode);
    return "<svg viewBox=\"0 0 146 32\" focusable=\"false\" aria-hidden=\"true\" height=\"32\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n      <path d=\"M19.04 25.727c0-3.604-2.949-6.517-6.517-6.517H6.517v-5.497H0v10.813c0 .837.364 1.201 1.201 1.201zM0 6.687c0 3.604 2.876 6.517 6.48 6.517h6.043V18.7h6.517V7.888q0-1.2-1.201-1.201z\" fill=\"".concat(colors.iconColor, "\"/>\n      <path d=\"M144.993 16.555v8.985h-2.638v-9.26c0-2.76-1.104-3.988-3.618-3.988-2.454 0-4.14 1.626-4.14 4.723v8.525h-2.638V10.207h2.638v2.515c.981-1.81 2.79-2.822 4.845-2.822 3.527 0 5.551 2.423 5.551 6.655m-19.589 7.759V22.78c-.982 2.024-2.822 3.067-5.183 3.067-4.048 0-6.072-3.465-6.072-7.973 0-4.324 2.116-7.974 6.379-7.974 2.238 0 3.956 1.012 4.876 3.006v-2.699h2.576V24.16c0 4.508-2.116 7.544-7.606 7.544-2.576 0-3.986-.337-5.458-.828V28.3c1.686.552 3.434.92 5.336.92 3.833 0 5.152-2.054 5.152-4.906m-8.679-6.44c0 3.68 1.472 5.52 4.201 5.52 2.362 0 4.478-1.503 4.478-4.907V17.26c0-3.404-1.932-4.906-4.171-4.906-2.975 0-4.508 1.962-4.508 5.52M107.96 6.16c0-1.166.766-1.84 1.84-1.84 1.073 0 1.84.674 1.84 1.84S110.873 8 109.8 8c-1.074 0-1.84-.675-1.84-1.84m.49 19.38V10.208h2.638v15.334h-2.638Zm-2.537-.03c-.215.061-.675.122-1.349.122-2.515 0-4.11-1.196-4.11-4.017V3.798h2.638v17.51c0 1.38.92 1.871 2.054 1.871.276 0 .46 0 .767-.03v2.36ZM88.83 21.523c-1.534 0-3.098-.184-4.815-.521l-1.687 4.539h-3.097l7.942-20.148h3.496l7.943 20.148h-3.097l-1.687-4.57c-1.81.368-3.373.552-4.999.552Zm0-2.453c1.287 0 2.606-.153 4.17-.399l-4.079-11.04-4.078 11.07c1.502.246 2.76.369 3.986.369Zm-27.807-1.196c0 3.68 1.472 5.52 4.202 5.52 2.36 0 4.477-1.503 4.477-4.907V17.26c0-3.404-1.932-4.906-4.17-4.906-2.975 0-4.509 1.962-4.509 5.52m8.679 7.666v-2.76c-.981 2.024-2.822 3.067-5.183 3.067-4.079 0-6.133-3.465-6.133-7.973 0-4.324 2.146-7.974 6.44-7.974 2.239 0 3.956 1.012 4.876 3.006v-2.699h2.637V25.54zM51.91 16.494v9.047h-2.577V10.207h2.576v2.699c.89-1.81 2.423-3.097 5.428-2.913v2.576c-3.373-.338-5.428.674-5.428 3.925ZM42.224 6.16c0-1.166.767-1.84 1.84-1.84s1.84.674 1.84 1.84S45.137 8 44.064 8s-1.84-.675-1.84-1.84m.49 19.38V10.208h2.638v15.334h-2.637Zm-6.427-5.949V5.393h2.76v14.014c0 3.71-1.626 6.256-5.428 6.256-1.442 0-2.546-.245-3.312-.521v-2.668c.828.337 1.84.521 2.852.521 2.33 0 3.128-1.41 3.128-3.404\" fill=\"").concat(colors.textColor, "\"/>\n    </svg>\n  ");
};
var $246cd7570ed6cefd$export$ee11e928d3d045fd = function JiraAlignLogo(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Jira Align' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $293a60c0ae776fbb$export$438460117ae6b7ee).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $293a60c0ae776fbb$export$438460117ae6b7ee).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $293a60c0ae776fbb$export$438460117ae6b7ee).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $233cd94b869ba248$export$2e2bcd8739ae039)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $f2142a8b85819ba3$export$2e2bcd8739ae039), {
        appearance: appearance,
        label: label,
        iconColor: iconColor,
        size: size,
        svg: $246cd7570ed6cefd$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};



var $5FkrB = parcelRequire("5FkrB");




var $5d364345d1f29d0f$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor;
    var colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $28050253965a3cad$export$bbacc3980e0f3029)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" viewBox=\"0 0 32 32\" focusable=\"false\" aria-hidden=\"true\" xmlns=\"http://www.w3.org/2000/svg\">\n      <path fill=\"".concat(colors.iconColor, "\" d=\"M17.655 5.884a15.3 15.3 0 0 0 8.75 0c.257-.056.428.114.37.37-.826 2.985-.826 5.742 0 8.727.058.228-.113.427-.37.342a16.33 16.33 0 0 0-8.75 0c-.228.085-.428-.114-.342-.342.77-2.985.77-5.742 0-8.727-.086-.256.114-.426.342-.37m1.169 10.576v.483c0 2.246-1.568 3.894-3.506 3.894a3.474 3.474 0 0 1-3.477-3.496c0-1.933 1.567-3.468 3.762-3.468h.57V7.078c-.285-.028-.57-.028-.855-.028C9.618 7.05 5 11.655 5 17.37c0 5.713 4.617 10.29 10.318 10.29s10.346-4.605 10.346-10.29v-.91z\"/>\n    </svg>");
};
var $5d364345d1f29d0f$export$21bfbeb62fdcce8d = function JiraProductDiscoveryIcon(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Jira Product Discovery' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $293a60c0ae776fbb$export$438460117ae6b7ee).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $293a60c0ae776fbb$export$438460117ae6b7ee).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $293a60c0ae776fbb$export$438460117ae6b7ee).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $233cd94b869ba248$export$2e2bcd8739ae039)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $f2142a8b85819ba3$export$2e2bcd8739ae039), {
        appearance: appearance,
        label: label,
        svg: $5d364345d1f29d0f$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        size: size,
        testId: testId,
        textColor: textColor
    });
};


var $5FkrB = parcelRequire("5FkrB");




var $d27aafd60d42f29e$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor;
    var colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $28050253965a3cad$export$bbacc3980e0f3029)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" viewBox=\"0 0 318 32\" focusable=\"false\" aria-hidden=\"true\" xmlns=\"http://www.w3.org/2000/svg\">\n      <path fill=\"".concat(colors.iconColor, "\" d=\"M12.655 5.218a15.3 15.3 0 0 0 8.75 0c.257-.057.428.114.37.37-.826 2.984-.826 5.742 0 8.727.058.227-.113.426-.37.341a16.33 16.33 0 0 0-8.75 0c-.228.085-.428-.114-.342-.341.77-2.985.77-5.743 0-8.727-.086-.256.114-.427.342-.37m1.169 10.575v.483c0 2.246-1.568 3.895-3.506 3.895a3.474 3.474 0 0 1-3.478-3.497c0-1.933 1.568-3.468 3.763-3.468h.57V6.412c-.285-.028-.57-.028-.855-.028C4.618 6.384 0 10.989 0 16.703s4.617 10.29 10.318 10.29 10.346-4.605 10.346-10.29v-.91z\" />\n      <path fill=\"").concat(colors.textColor, "\" d=\"M308.551 24.559h-1.718l-5.55-14.352h2.821l4.907 13.125 4.906-13.125h2.822l-5.796 14.843c-1.718 4.385-2.699 6.654-6.594 6.654-1.318 0-2.054-.122-2.821-.429v-2.27c.889.277 1.901.369 2.668.369 2.147 0 3.097-1.472 4.355-4.815m-13.247-8.065v9.047h-2.576V10.207h2.576v2.699c.889-1.81 2.422-3.097 5.428-2.913v2.576c-3.374-.338-5.428.674-5.428 3.925m-12.464-4.202c-2.79 0-4.201 1.81-4.477 4.478h8.556c-.153-2.852-1.441-4.478-4.079-4.478m5.888 12.635c-1.257.675-3.189.92-4.753.92-5.735 0-8.249-3.312-8.249-8.004 0-4.63 2.576-7.943 7.237-7.943 4.723 0 6.624 3.282 6.624 7.943v1.196h-11.193c.368 2.607 2.054 4.293 5.673 4.293 1.779 0 3.281-.337 4.661-.828zm-19.717.613h-3.527l-5.949-15.333h2.76l4.968 13.095 4.937-13.095h2.76zm-17.462.307c-4.6 0-7.299-3.404-7.299-8.004s2.699-7.943 7.299-7.943c4.569 0 7.237 3.343 7.237 7.943s-2.668 8.004-7.237 8.004m0-13.493c-3.281 0-4.723 2.576-4.723 5.49 0 2.912 1.442 5.55 4.723 5.55 3.251 0 4.661-2.638 4.661-5.55 0-2.914-1.41-5.49-4.661-5.49M242.16 22.78v2.362c-.92.49-2.331.705-3.742.705-5.458 0-8.004-3.312-8.004-8.004 0-4.63 2.546-7.943 8.004-7.943 1.38 0 2.454.184 3.65.736v2.454c-.982-.46-2.024-.736-3.466-.736-3.986 0-5.612 2.514-5.612 5.49 0 2.974 1.656 5.488 5.674 5.488 1.564 0 2.545-.214 3.496-.552m-13.872-1.41c0 2.545-1.656 4.477-5.765 4.477-2.3 0-4.171-.521-5.336-1.135v-2.79c1.319.766 3.527 1.502 5.459 1.502 2.024 0 3.066-.828 3.066-2.024 0-1.165-.889-1.84-3.802-2.545-3.404-.828-4.846-2.147-4.846-4.661 0-2.668 2.055-4.294 5.551-4.294 1.993 0 3.803.491 4.937 1.104v2.73c-1.84-.92-3.342-1.41-4.968-1.41-1.932 0-2.974.674-2.974 1.87 0 1.073.736 1.748 3.557 2.422 3.404.828 5.121 2.086 5.121 4.754M210.599 6.16c0-1.166.767-1.84 1.84-1.84s1.84.674 1.84 1.84-.767 1.84-1.84 1.84-1.84-.675-1.84-1.84m.491 19.38V10.208h2.637v15.334zM198.344 8.03h-4.539v14.873h4.692c4.6 0 6.9-2.422 6.9-7.298 0-4.907-2.177-7.575-7.053-7.575m-7.299 17.51V5.394h7.422c6.532 0 9.69 4.078 9.69 10.12 0 6.102-3.189 10.028-9.69 10.028zm-13.411-4.753c0 1.35.797 2.27 2.422 2.27.614 0 1.196-.123 1.656-.215v2.545c-.46.123-.981.245-1.778.245-3.282 0-4.876-1.932-4.876-4.784v-8.187h-2.484v-2.454h2.484v-3.25h2.576v3.25h4.078v2.453h-4.078zm-6.66 1.993v2.362c-.92.49-2.331.705-3.742.705-5.458 0-8.004-3.312-8.004-8.004 0-4.63 2.546-7.943 8.004-7.943 1.38 0 2.454.184 3.65.736v2.454c-.982-.46-2.024-.736-3.466-.736-3.986 0-5.612 2.514-5.612 5.49 0 2.974 1.656 5.488 5.674 5.488 1.564 0 2.545-.214 3.496-.552m-27.843-3.588v-8.985h2.637v9.261c0 2.76 1.104 3.987 3.619 3.987 2.453 0 4.14-1.625 4.14-4.723v-8.525h2.637V25.54h-2.637v-2.514c-.982 1.809-2.791 2.821-4.846 2.821-3.526 0-5.55-2.423-5.55-6.655m-14.987-1.318c0 3.68 1.472 5.52 4.202 5.52 2.361 0 4.477-1.503 4.477-4.907V17.26c0-3.404-1.932-4.906-4.171-4.906-2.974 0-4.508 1.962-4.508 5.52m8.679 7.667v-2.76c-.981 2.023-2.821 3.066-5.183 3.066-4.078 0-6.133-3.465-6.133-7.973 0-4.324 2.147-7.973 6.44-7.973 2.239 0 3.956 1.012 4.876 3.005V3.798h2.637V25.54zm-20.698.306c-4.6 0-7.299-3.404-7.299-8.004s2.699-7.943 7.299-7.943c4.569 0 7.237 3.343 7.237 7.943s-2.668 8.004-7.237 8.004m0-13.493c-3.282 0-4.723 2.576-4.723 5.49 0 2.912 1.441 5.55 4.723 5.55 3.25 0 4.661-2.638 4.661-5.55 0-2.914-1.411-5.49-4.661-5.49m-13.776 4.14v9.047h-2.576V10.207h2.576v2.699c.89-1.81 2.423-3.097 5.428-2.913v2.576c-3.373-.338-5.428.674-5.428 3.925m-5.002-4.385c0 4.385-2.454 6.838-7.483 6.838h-4.017v6.594h-2.76V5.393h6.777c5.03 0 7.483 2.576 7.483 6.716m-7.79 4.2c3.558.124 4.938-1.563 4.938-4.14 0-2.452-1.38-4.14-4.938-4.14h-3.71v8.28zM61.69 17.874c0 3.68 1.472 5.52 4.201 5.52 2.361 0 4.477-1.503 4.477-4.907V17.26c0-3.404-1.931-4.906-4.17-4.906-2.975 0-4.508 1.962-4.508 5.52m8.679 7.666v-2.76c-.982 2.024-2.822 3.067-5.183 3.067-4.079 0-6.134-3.465-6.134-7.973 0-4.324 2.147-7.974 6.44-7.974 2.24 0 3.957 1.012 4.877 3.006v-2.699h2.637V25.54zm-17.793-9.046v9.047H50V10.207h2.576v2.699c.89-1.81 2.423-3.097 5.428-2.913v2.576c-3.373-.338-5.428.674-5.428 3.925M42.89 6.16c0-1.166.767-1.84 1.84-1.84s1.84.674 1.84 1.84S45.805 8 44.73 8s-1.84-.675-1.84-1.84m.491 19.38V10.208h2.638v15.334zm-6.428-5.949V5.393h2.76v14.014c0 3.71-1.625 6.256-5.428 6.256-1.441 0-2.545-.245-3.312-.521v-2.668c.828.337 1.84.521 2.852.521 2.331 0 3.128-1.41 3.128-3.404\" />\n    </svg>");
};
var $d27aafd60d42f29e$export$c49a2b642fe9eef4 = function JiraProductDiscoveryLogo(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Jira Product Discovery' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $293a60c0ae776fbb$export$438460117ae6b7ee).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $293a60c0ae776fbb$export$438460117ae6b7ee).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $293a60c0ae776fbb$export$438460117ae6b7ee).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $233cd94b869ba248$export$2e2bcd8739ae039)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $f2142a8b85819ba3$export$2e2bcd8739ae039), {
        appearance: appearance,
        label: label,
        iconColor: iconColor,
        size: size,
        svg: $d27aafd60d42f29e$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};



var $5FkrB = parcelRequire("5FkrB");




var $c4f969561c41b722$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor;
    var colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $28050253965a3cad$export$bbacc3980e0f3029)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" viewBox=\"0 0 32 32\" focusable=\"false\" aria-hidden=\"true\" xmlns=\"http://www.w3.org/2000/svg\">\n      <path fill=".concat(colors.iconColor, " d=\"M18.79 13.257h7.325c1.1 0 1.476 1.046.805 1.878L15.464 29.274c-3.702-2.951-3.353-7.62-.644-11.027zm-5.66 5.634H5.806c-1.1 0-1.476-1.046-.805-1.878L16.457 2.874c3.702 2.951 3.3 7.566.617 11z\"/>\n    </svg>");
};
var $c4f969561c41b722$export$3c6158790f5e01c4 = function JiraServiceManagementIcon(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Jira Service Management' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $293a60c0ae776fbb$export$438460117ae6b7ee).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $293a60c0ae776fbb$export$438460117ae6b7ee).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $293a60c0ae776fbb$export$438460117ae6b7ee).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $233cd94b869ba248$export$2e2bcd8739ae039)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $f2142a8b85819ba3$export$2e2bcd8739ae039), {
        appearance: appearance,
        label: label,
        svg: $c4f969561c41b722$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        size: size,
        testId: testId,
        textColor: textColor
    });
};


var $5FkrB = parcelRequire("5FkrB");




var $601abda24c4b9b43$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor;
    var colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $28050253965a3cad$export$bbacc3980e0f3029)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" viewBox=\"0 0 362 32\" focusable=\"false\" aria-hidden=\"true\" xmlns=\"http://www.w3.org/2000/svg\">\n      <path fill=".concat(colors.iconColor, " d=\"M14.124 13.257h7.325c1.1 0 1.475 1.046.804 1.878L10.798 29.274c-3.702-2.951-3.353-7.62-.644-11.027zm-5.66 5.634H1.138c-1.1 0-1.476-1.046-.805-1.878L11.79 2.874c3.703 2.951 3.3 7.566.617 11z\" />\n      <path fill=").concat(colors.textColor, " d=\"M357.074 20.787c0 1.35.797 2.27 2.422 2.27.614 0 1.196-.123 1.656-.215v2.545c-.46.123-.981.245-1.778.245-3.282 0-4.876-1.932-4.876-4.784v-8.187h-2.484v-2.454h2.484v-3.25h2.576v3.25h4.078v2.453h-4.078zm-7.327-4.231v8.985h-2.638V16.28c0-2.76-1.104-3.987-3.618-3.987-2.454 0-4.14 1.625-4.14 4.723v8.525h-2.638V10.208h2.638v2.514c.981-1.81 2.79-2.821 4.845-2.821 3.527 0 5.551 2.423 5.551 6.655m-22.921-4.263c-2.791 0-4.201 1.81-4.477 4.477h8.556c-.154-2.852-1.442-4.477-4.079-4.477m5.888 12.635c-1.257.674-3.189.92-4.753.92-5.735 0-8.25-3.312-8.25-8.004 0-4.631 2.576-7.943 7.238-7.943 4.722 0 6.624 3.281 6.624 7.943v1.196h-11.194c.368 2.606 2.055 4.293 5.674 4.293 1.778 0 3.281-.337 4.661-.828zm-26.152-7.912v8.525h-2.637V16.28c0-2.76-1.104-3.987-3.619-3.987-2.453 0-4.14 1.625-4.14 4.723v8.525h-2.637V10.208h2.637v2.514c.981-1.81 2.79-2.821 4.845-2.821 2.607 0 4.385 1.319 5.152 3.741.859-2.361 2.913-3.741 5.459-3.741 3.434 0 5.336 2.33 5.336 6.655v8.985h-2.638v-8.525c0-3.16-1.104-4.723-3.618-4.723-2.454 0-4.14 1.625-4.14 4.723m-22.921-4.723c-2.79 0-4.201 1.81-4.477 4.477h8.556c-.153-2.852-1.441-4.477-4.079-4.477m5.888 12.635c-1.257.674-3.189.92-4.753.92-5.735 0-8.25-3.312-8.25-8.004 0-4.631 2.577-7.943 7.238-7.943 4.723 0 6.624 3.281 6.624 7.943v1.196h-11.193c.368 2.606 2.054 4.293 5.673 4.293 1.779 0 3.281-.337 4.661-.828zm-18.638-.614v-1.533c-.982 2.024-2.822 3.067-5.183 3.067-4.048 0-6.072-3.466-6.072-7.974 0-4.324 2.116-7.973 6.379-7.973 2.238 0 3.956 1.012 4.876 3.005v-2.698h2.576V24.16c0 4.508-2.116 7.544-7.606 7.544-2.576 0-3.986-.337-5.458-.828V28.3c1.686.552 3.434.92 5.336.92 3.833 0 5.152-2.055 5.152-4.907m-8.679-6.44c0 3.68 1.472 5.52 4.201 5.52 2.362 0 4.478-1.503 4.478-4.906V17.26c0-3.404-1.932-4.907-4.171-4.907-2.975 0-4.508 1.963-4.508 5.52m-16.949.001c0 3.68 1.472 5.52 4.201 5.52 2.361 0 4.477-1.503 4.477-4.906V17.26c0-3.404-1.932-4.907-4.17-4.907-2.975 0-4.508 1.963-4.508 5.52m8.678 7.667v-2.76c-.981 2.024-2.821 3.066-5.182 3.066-4.079 0-6.134-3.465-6.134-7.973 0-4.324 2.147-7.973 6.44-7.973 2.239 0 3.956 1.012 4.876 3.005v-2.699h2.638V25.54zm-14.073-8.984v8.985h-2.638V16.28c0-2.76-1.104-3.987-3.618-3.987-2.454 0-4.14 1.625-4.14 4.723v8.525h-2.638V10.208h2.638v2.514c.981-1.81 2.79-2.821 4.845-2.821 3.527 0 5.551 2.423 5.551 6.655m-28.327 1.318c0 3.68 1.472 5.52 4.202 5.52 2.361 0 4.477-1.503 4.477-4.906V17.26c0-3.404-1.932-4.907-4.171-4.907-2.974 0-4.508 1.963-4.508 5.52m8.679 7.667v-2.76c-.981 2.024-2.821 3.066-5.183 3.066-4.078 0-6.133-3.465-6.133-7.973 0-4.324 2.147-7.973 6.44-7.973 2.239 0 3.956 1.012 4.876 3.005v-2.699h2.637V25.54zm-31.445-11.009-2.76-7.482V25.54h-2.76V5.393h4.784l4.569 11.56 1.871 5.552 1.87-5.551 4.6-11.561h4.447V25.54h-2.76V7.263l-2.361 7.268-4.447 11.01h-2.668zm-21.511-2.238c-2.791 0-4.202 1.81-4.478 4.477h8.556c-.153-2.852-1.441-4.477-4.078-4.477m5.888 12.635c-1.258.674-3.19.92-4.754.92-5.734 0-8.249-3.312-8.249-8.004 0-4.631 2.576-7.943 7.237-7.943 4.723 0 6.624 3.281 6.624 7.943v1.196h-11.193c.368 2.606 2.055 4.293 5.673 4.293 1.779 0 3.282-.337 4.662-.828zm-15.094-2.148v2.362c-.92.49-2.33.705-3.741.705-5.459 0-8.004-3.312-8.004-8.004 0-4.63 2.545-7.942 8.004-7.942 1.38 0 2.453.184 3.649.736v2.453c-.981-.46-2.024-.736-3.465-.736-3.987 0-5.612 2.515-5.612 5.49s1.656 5.489 5.673 5.489c1.564 0 2.546-.215 3.496-.552M140.124 6.16c0-1.166.766-1.84 1.84-1.84 1.073 0 1.84.674 1.84 1.84S143.037 8 141.964 8c-1.074 0-1.84-.675-1.84-1.84m.49 19.38V10.208h2.638v15.334zm-8.233 0h-3.527l-5.949-15.332h2.76l4.968 13.094 4.937-13.094h2.76zm-15.455-9.046v9.047h-2.576V10.207h2.576v2.699c.889-1.81 2.423-3.097 5.428-2.913v2.576c-3.373-.338-5.428.674-5.428 3.925m-12.463-4.201c-2.791 0-4.202 1.81-4.478 4.477h8.556c-.153-2.852-1.441-4.477-4.078-4.477m5.888 12.635c-1.258.674-3.19.92-4.754.92-5.734 0-8.249-3.312-8.249-8.004 0-4.631 2.576-7.943 7.237-7.943 4.723 0 6.624 3.281 6.624 7.943v1.196h-11.193c.368 2.606 2.055 4.293 5.673 4.293 1.779 0 3.282-.337 4.662-.828zM95.024 19.99c0 3.496-2.085 5.857-7.084 5.857-3.894 0-5.704-.766-7.268-1.564v-2.821c1.87.981 4.754 1.687 7.422 1.687 3.036 0 4.17-1.196 4.17-2.975s-1.104-2.73-4.937-3.65c-4.539-1.103-6.563-2.667-6.563-5.98 0-3.127 2.392-5.458 7.084-5.458 2.914 0 4.784.705 6.164 1.472v2.76c-2.024-1.165-4.201-1.533-6.286-1.533-2.638 0-4.202.92-4.202 2.76 0 1.656 1.288 2.484 4.845 3.373 4.263 1.073 6.655 2.453 6.655 6.072m-34.001-2.116c0 3.68 1.472 5.52 4.201 5.52 2.362 0 4.478-1.503 4.478-4.906V17.26c0-3.404-1.932-4.907-4.17-4.907-2.975 0-4.509 1.963-4.509 5.52m8.679 7.667v-2.76c-.981 2.024-2.821 3.066-5.183 3.066-4.078 0-6.133-3.465-6.133-7.973 0-4.324 2.147-7.973 6.44-7.973 2.239 0 3.956 1.012 4.876 3.005v-2.699h2.637V25.54zM51.91 16.494v9.047h-2.577V10.207h2.576v2.699c.89-1.81 2.423-3.097 5.428-2.913v2.576c-3.373-.338-5.428.674-5.428 3.925M42.224 6.16c0-1.166.767-1.84 1.84-1.84s1.84.674 1.84 1.84S45.137 8 44.064 8s-1.84-.675-1.84-1.84m.49 19.38V10.208h2.638v15.334zm-6.427-5.949V5.393h2.76v14.014c0 3.71-1.626 6.256-5.428 6.256-1.442 0-2.546-.245-3.312-.521v-2.668c.828.337 1.84.521 2.852.521 2.33 0 3.128-1.41 3.128-3.404\" />\n    </svg>");
};
var $601abda24c4b9b43$export$dabef2be6cd28c20 = function JiraServiceManagementLogo(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Jira Service Management' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $293a60c0ae776fbb$export$438460117ae6b7ee).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $293a60c0ae776fbb$export$438460117ae6b7ee).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $293a60c0ae776fbb$export$438460117ae6b7ee).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $233cd94b869ba248$export$2e2bcd8739ae039)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $f2142a8b85819ba3$export$2e2bcd8739ae039), {
        appearance: appearance,
        label: label,
        iconColor: iconColor,
        size: size,
        svg: $601abda24c4b9b43$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};



var $5FkrB = parcelRequire("5FkrB");





var $984c512202e2c599$export$7818df200941dbbf = function getColorsForLoom(appearance, colorMode) {
    var iconColor = (0, $28050253965a3cad$export$bbacc3980e0f3029)(appearance, colorMode).iconColor;
    var textColor = (0, $28050253965a3cad$export$bbacc3980e0f3029)(appearance, colorMode).textColor;
    if (colorMode === 'dark') switch(appearance){
        case 'brand':
            iconColor = '#625DF5';
            textColor = '#EFF0FF';
            break;
    }
    else switch(appearance){
        case 'brand':
            iconColor = '#625DF5';
            textColor = '#252434';
            break;
    }
    return {
        iconColor: iconColor,
        textColor: textColor
    };
};


var $fe09b83164667699$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor;
    var colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $984c512202e2c599$export$7818df200941dbbf)(appearance, colorMode);
    return "<svg\n    fill=\"none\"\n    height=\"32\"\n    viewBox=\"0 0 32 32\"\n    xmlns=\"http://www.w3.org/2000/svg\"\n    focusable=\"false\"\n    aria-hidden=\"true\"\n  >\n    <path\n      d=\"M27.333 15.508h-6.628l5.74-3.315-1.26-2.184-5.74 3.314 3.313-5.74-2.184-1.26-3.313 5.74V5.434h-2.522v6.628l-3.314-5.74-2.184 1.26 3.314 5.74-5.74-3.314-1.26 2.184 5.74 3.314H4.667v2.521h6.627l-5.74 3.314 1.261 2.184 5.74-3.313-3.314 5.74 2.184 1.26 3.314-5.74V28.1h2.521v-6.627l3.313 5.74 2.184-1.261-3.314-5.74 5.74 3.313 1.261-2.184-5.74-3.313h6.628zM16 20.198a3.442 3.442 0 1 1 0-6.885 3.442 3.442 0 0 1 0 6.884\"\n      fill=\"".concat(colors.iconColor, "\"\n    />\n  </svg>");
};
var $fe09b83164667699$export$8d789f76fde3e05 = function LoomIcon(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Loom' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $293a60c0ae776fbb$export$438460117ae6b7ee).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $293a60c0ae776fbb$export$438460117ae6b7ee).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $293a60c0ae776fbb$export$438460117ae6b7ee).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $233cd94b869ba248$export$2e2bcd8739ae039)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $f2142a8b85819ba3$export$2e2bcd8739ae039), {
        appearance: appearance,
        label: label,
        svg: $fe09b83164667699$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        size: size,
        testId: testId,
        textColor: textColor
    });
};


var $5FkrB = parcelRequire("5FkrB");




var $50434fde8d57c329$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor;
    var colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $984c512202e2c599$export$7818df200941dbbf)(appearance, colorMode);
    return "<svg\n      fill=\"none\"\n      height=\"32\"\n      xmlns=\"http://www.w3.org/2000/svg\"\n      viewBox=\"0 0 98 32\"\n      focusable=\"false\"\n      aria-hidden=\"true\"\n    >\n      <path\n        d=\"M29.657 13.659h-8.672l7.51-4.337-1.649-2.857-7.51 4.336 4.335-7.51-2.857-1.65-4.336 7.51V.479H13.18v8.672l-4.337-7.51-2.856 1.65 4.336 7.51-7.51-4.336-1.65 2.857 7.51 4.336H0v3.299h8.671l-7.51 4.336 1.65 2.858 7.51-4.336-4.336 7.51 2.857 1.65 4.336-7.511v8.672h3.3v-8.671l4.335 7.51 2.857-1.65-4.336-7.51 7.51 4.336 1.65-2.858-7.51-4.335h8.672v-3.3zM14.83 19.794a4.503 4.503 0 1 1 0-9.006 4.503 4.503 0 0 1 0 9.006\"\n        fill=\"".concat(colors.iconColor, "\"\n      />\n      <path\n        d=\"M37.303 26.155V4.459h3.983v21.696zm38.204-14.743h3.803v1.798c.808-1.438 2.696-2.218 4.313-2.218 2.007 0 3.624.87 4.373 2.457 1.167-1.798 2.726-2.457 4.673-2.457 2.725 0 5.33 1.648 5.33 5.604v9.559h-3.862v-8.75c0-1.588-.78-2.786-2.607-2.786-1.707 0-2.726 1.318-2.726 2.907v8.63H84.85v-8.75c0-1.59-.808-2.787-2.606-2.787-1.738 0-2.757 1.288-2.757 2.907v8.63h-3.981zm-25.219 15.17c-4.487 0-7.737-3.328-7.737-7.798 0-4.4 3.24-7.806 7.737-7.806 4.52 0 7.737 3.439 7.737 7.806 0 4.438-3.251 7.798-7.737 7.798m0-11.996a4.2 4.2 0 0 0-4.197 4.199c0 2.315 1.883 4.199 4.197 4.199s4.196-1.884 4.196-4.2a4.2 4.2 0 0 0-4.196-4.198m16.245 11.996c-4.487 0-7.737-3.328-7.737-7.798 0-4.4 3.24-7.806 7.737-7.806 4.52 0 7.737 3.439 7.737 7.806 0 4.438-3.253 7.798-7.737 7.798m0-12.046c-2.34 0-4.245 1.906-4.245 4.247s1.904 4.247 4.245 4.247a4.25 4.25 0 0 0 4.245-4.247 4.25 4.25 0 0 0-4.245-4.247\"\n        fill=\"").concat(colors.textColor, "\"\n      />\n    </svg>");
};
var $50434fde8d57c329$export$94e206806e36c2ec = function LoomLogo(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Loom' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $293a60c0ae776fbb$export$438460117ae6b7ee).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $293a60c0ae776fbb$export$438460117ae6b7ee).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $293a60c0ae776fbb$export$438460117ae6b7ee).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $233cd94b869ba248$export$2e2bcd8739ae039)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $f2142a8b85819ba3$export$2e2bcd8739ae039), {
        appearance: appearance,
        label: label,
        iconColor: iconColor,
        size: size,
        svg: $50434fde8d57c329$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};



var $5FkrB = parcelRequire("5FkrB");


var $4580a29361507e76$export$1bf47cdade1a9fcb = function LoomAttributionIcon(_ref) {
    var appearance = _ref.appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Loom Attribution' : _ref$label, _ref$size = _ref.size, size = _ref$size === void 0 ? (0, $293a60c0ae776fbb$export$438460117ae6b7ee).size : _ref$size, testId = _ref.testId, _ref$iconColor = _ref.iconColor, iconColor = _ref$iconColor === void 0 ? (0, $293a60c0ae776fbb$export$438460117ae6b7ee).iconColor : _ref$iconColor, _ref$textColor = _ref.textColor, textColor = _ref$textColor === void 0 ? (0, $293a60c0ae776fbb$export$438460117ae6b7ee).textColor : _ref$textColor;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $fe09b83164667699$export$8d789f76fde3e05), {
        appearance: appearance,
        label: label,
        size: size,
        testId: testId,
        iconColor: iconColor,
        textColor: textColor
    });
};


var $5FkrB = parcelRequire("5FkrB");




var $d994d8a838fb92ca$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor;
    var colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $984c512202e2c599$export$7818df200941dbbf)(appearance, colorMode);
    return "<svg\n\t\tfill=\"none\"\n\t\theight=\"32\"\n\t\txmlns=\"http://www.w3.org/2000/svg\"\n\t\tfocusable=\"false\"\n\t\taria-hidden=\"true\"\n\t\tviewBox=\"0 0 88 32\"\n\t>\n\t\t<path\n\t\t\td=\"M29.488 12.765h-8.983l7.78-4.344-1.544-2.585-7.78 4.344 4.492-7.523-2.674-1.493-4.491 7.522V0H13.2v8.687L8.71 1.164 6.035 2.657l4.49 7.522-7.778-4.343L1.204 8.42l7.779 4.344H0v2.986h8.982l-7.778 4.343 1.543 2.585 7.78-4.342-4.492 7.522 2.674 1.493L13.2 19.83v8.687h3.087v-8.873l4.574 7.663 2.507-1.4-4.575-7.663 7.946 4.437 1.544-2.586-7.779-4.343h8.982v-2.986h.001Zm-14.744 5.552c-2.318 0-4.197-1.817-4.197-4.059s1.88-4.059 4.197-4.059 4.198 1.817 4.198 4.06c0 2.24-1.88 4.058-4.198 4.058\"\n\t\t\tfill=\"".concat(colors.iconColor, "\"\n\t\t/>\n\t\t<path\n\t\t\td=\"M38.379 26.847V10.094h3.18v16.753zm30.503-11.79h3.036v1.438c.646-1.15 2.153-1.773 3.444-1.773 1.602 0 2.893.695 3.49 1.964.932-1.438 2.177-1.964 3.731-1.964 2.175 0 4.256 1.318 4.256 4.48v7.642h-3.084V19.85c0-1.27-.623-2.228-2.081-2.228-1.363 0-2.177 1.054-2.177 2.324v6.9h-3.155V19.85c0-1.27-.646-2.228-2.081-2.228-1.387 0-2.2 1.03-2.2 2.324v6.9h-3.18V15.057Zm-20.134 12.13c-3.582 0-6.176-2.66-6.176-6.234 0-3.517 2.585-6.242 6.176-6.242 3.609 0 6.177 2.75 6.177 6.242 0 3.547-2.596 6.234-6.177 6.234m0-9.59a3.357 3.357 0 0 0 0 6.713 3.357 3.357 0 0 0 0-6.713m12.966 9.59c-3.583 0-6.177-2.66-6.177-6.234 0-3.517 2.586-6.242 6.177-6.242 3.608 0 6.176 2.75 6.176 6.242 0 3.547-2.597 6.234-6.176 6.234m0-9.63a3.397 3.397 0 0 0-3.39 3.395 3.397 3.397 0 0 0 3.39 3.395 3.396 3.396 0 0 0 0-6.79M64.933 5.63c0-1.102-.697-1.522-1.983-1.837-.803-.21-1.018-.368-1.018-.63q0-.473.804-.473c.643 0 1.286.21 1.93.473V1.798a4.5 4.5 0 0 0-1.876-.42c-1.447 0-2.25.682-2.25 1.785 0 1.05.696 1.575 1.928 1.838.804.157 1.072.315 1.072.682 0 .263-.215.473-.804.473a4.46 4.46 0 0 1-2.197-.63v1.417c.483.263 1.233.473 2.197.473 1.5.052 2.197-.683 2.197-1.785Zm16.662-4.067v5.988h1.3V3.007l.542 1.23 1.841 3.368h1.626V1.563h-1.3v3.85l-.488-1.123-1.463-2.727zm-8.056 0h-1.465v6.042h1.465zm-23.981 0v6.042h2.863l.432-1.295h-1.945V1.563zm-5.671 0v1.295h1.604v4.747h1.44V2.858h1.715V1.563zm-2.177 0h-1.802l-2.066 6.042h1.59l.317-1.025a4 4 0 0 0 1.113.162q.556 0 1.113-.162l.318 1.025h1.59zm-.9 3.938a3 3 0 0 1-.743-.108l.742-2.643.742 2.643c-.265.054-.477.108-.742.108Zm16.577-3.938H55.53L53.4 7.605h1.638l.328-1.025q.573.162 1.146.162.574 0 1.147-.162l.328 1.025h1.638l-2.24-6.042Zm-.928 3.938c-.273 0-.546-.054-.765-.108l.765-2.643.764 2.643a3.3 3.3 0 0 1-.764.108m21.98-3.938h-1.857l-2.13 6.042h1.638l.328-1.025q.574.162 1.147.162c.573 0 .764-.054 1.146-.162l.328 1.025h1.638zm-.93 3.938c-.272 0-.545-.054-.763-.108l.764-2.643.765 2.643a3.3 3.3 0 0 1-.765.108Zm-6.894.129c0-1.102-.697-1.522-1.983-1.837-.803-.21-1.018-.368-1.018-.63q0-.473.804-.473c.643 0 1.286.21 1.93.473V1.798a4.5 4.5 0 0 0-1.876-.42c-1.447 0-2.25.682-2.25 1.785 0 1.05.696 1.575 1.928 1.838.804.157 1.072.315 1.072.682 0 .263-.215.473-.804.473-.75 0-1.608-.263-2.197-.63v1.417c.482.263 1.233.473 2.197.473 1.447.052 2.197-.683 2.197-1.785Z\"\n\t\t\tfill=\"").concat(colors.textColor, "\"\n\t\t/>\n\t</svg>");
};
var $d994d8a838fb92ca$export$6e87ce8d41eda665 = function LoomAttributionLogo(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Loom Attribution' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $293a60c0ae776fbb$export$438460117ae6b7ee).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $293a60c0ae776fbb$export$438460117ae6b7ee).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $293a60c0ae776fbb$export$438460117ae6b7ee).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $233cd94b869ba248$export$2e2bcd8739ae039)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $f2142a8b85819ba3$export$2e2bcd8739ae039), {
        appearance: appearance,
        label: label,
        iconColor: iconColor,
        size: size,
        svg: $d994d8a838fb92ca$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};



var $5FkrB = parcelRequire("5FkrB");




var $903d4aa684eb7470$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor;
    var colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $28050253965a3cad$export$bbacc3980e0f3029)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" viewBox=\"0 0 32 32\" focusable=\"false\" aria-hidden=\"true\" xmlns=\"http://www.w3.org/2000/svg\">\n      <path fill=\"".concat(colors.iconColor, "\" d=\"M17.114 28.127c-.785.578-1.199.537-1.984-.041-3.8-2.727-7.313-5.826-9.668-9.049-.248-.33-.124-.785.248-.991l4.297-2.686q.558-.372.992.124c1.652 1.9 3.264 3.76 5.123 5.082 1.86-1.322 3.47-3.181 5.123-5.082q.434-.495.992-.124l4.297 2.686c.372.206.496.66.248.991-2.355 3.223-5.867 6.322-9.668 9.09m-.992-11.858c3.388 0 6.198-2.768 6.198-6.156s-2.81-6.239-6.198-6.239-6.198 2.81-6.198 6.239c0 3.43 2.727 6.156 6.198 6.156\"/>\n    </svg>");
};
var $903d4aa684eb7470$export$eeccc49dc7a12d9f = function OpsgenieIcon(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Opsgenie' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $293a60c0ae776fbb$export$438460117ae6b7ee).size : _ref2$size, testId = _ref2.testId, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $293a60c0ae776fbb$export$438460117ae6b7ee).textColor : _ref2$textColor, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $293a60c0ae776fbb$export$438460117ae6b7ee).iconColor : _ref2$iconColor;
    var _useThemeObserver = (0, $233cd94b869ba248$export$2e2bcd8739ae039)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $f2142a8b85819ba3$export$2e2bcd8739ae039), {
        appearance: appearance,
        svg: $903d4aa684eb7470$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        label: label,
        size: size,
        testId: testId,
        textColor: textColor
    });
};


var $5FkrB = parcelRequire("5FkrB");




var $49fcfcf292337a44$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor;
    var colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $28050253965a3cad$export$bbacc3980e0f3029)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" viewBox=\"0 0 154 32\" focusable=\"false\" aria-hidden=\"true\" xmlns=\"http://www.w3.org/2000/svg\">\n      <path fill=\"".concat(colors.iconColor, "\" d=\"M11.78 28.127c-.785.578-1.198.537-1.983-.041-3.801-2.727-7.313-5.826-9.668-9.049-.248-.33-.124-.785.248-.991l4.297-2.686q.558-.372.991.124c1.653 1.9 3.264 3.76 5.124 5.082 1.859-1.322 3.47-3.181 5.123-5.082q.435-.495.992-.124l4.297 2.686c.371.206.495.66.247.991-2.355 3.223-5.867 6.322-9.668 9.09m-.99-11.857c3.388 0 6.197-2.768 6.197-6.156s-2.81-6.239-6.197-6.239-6.198 2.81-6.198 6.239c0 3.43 2.727 6.156 6.198 6.156\"/>\n      <path fill=\"").concat(colors.textColor, "\" d=\"M146.689 12.293c-2.79 0-4.201 1.81-4.477 4.477h8.556c-.153-2.852-1.441-4.477-4.079-4.477m5.888 12.635c-1.257.674-3.189.92-4.753.92-5.735 0-8.249-3.312-8.249-8.004 0-4.631 2.576-7.943 7.237-7.943 4.723 0 6.624 3.281 6.624 7.943v1.196h-11.193c.368 2.606 2.054 4.293 5.673 4.293 1.779 0 3.281-.337 4.661-.828zM133.385 6.16c0-1.166.767-1.84 1.841-1.84s1.84.674 1.84 1.84-.767 1.84-1.84 1.84c-1.074 0-1.841-.675-1.841-1.84m.491 19.38V10.208h2.638v15.334zm-3.677-8.984v8.985h-2.638V16.28c0-2.76-1.104-3.987-3.618-3.987-2.454 0-4.14 1.625-4.14 4.723v8.525h-2.638V10.208h2.638v2.514c.981-1.81 2.79-2.821 4.845-2.821 3.527 0 5.551 2.423 5.551 6.655m-22.921-4.263c-2.791 0-4.201 1.81-4.477 4.477h8.556c-.154-2.852-1.442-4.477-4.079-4.477m5.888 12.635c-1.257.674-3.189.92-4.753.92-5.735 0-8.25-3.312-8.25-8.004 0-4.631 2.576-7.943 7.238-7.943 4.722 0 6.624 3.281 6.624 7.943v1.196h-11.194c.368 2.606 2.055 4.293 5.674 4.293 1.778 0 3.281-.337 4.661-.828zm-18.639-.614v-1.533c-.981 2.024-2.821 3.067-5.182 3.067-4.048 0-6.072-3.466-6.072-7.974 0-4.324 2.116-7.973 6.378-7.973 2.239 0 3.956 1.012 4.876 3.005v-2.698h2.576V24.16c0 4.508-2.116 7.544-7.605 7.544-2.576 0-3.987-.337-5.459-.828V28.3c1.687.552 3.435.92 5.336.92 3.834 0 5.152-2.055 5.152-4.907m-8.678-6.44c0 3.68 1.472 5.52 4.2 5.52 2.362 0 4.478-1.503 4.478-4.906V17.26c0-3.404-1.932-4.907-4.17-4.907-2.975 0-4.508 1.963-4.508 5.52m-4.703 3.497c0 2.545-1.656 4.477-5.765 4.477-2.3 0-4.17-.52-5.336-1.134v-2.79c1.319.766 3.527 1.502 5.459 1.502 2.024 0 3.066-.828 3.066-2.024 0-1.165-.89-1.84-3.802-2.545-3.404-.829-4.846-2.147-4.846-4.662 0-2.668 2.055-4.293 5.55-4.293 1.994 0 3.804.49 4.938 1.104v2.73c-1.84-.92-3.342-1.411-4.968-1.411-1.932 0-2.974.674-2.974 1.87 0 1.073.736 1.748 3.557 2.423 3.404.828 5.121 2.085 5.121 4.753m-16.274-3.496c0-3.68-1.472-5.52-4.202-5.52-2.36 0-4.477 1.503-4.477 4.907v1.227c0 3.404 1.932 4.906 4.17 4.906 2.975 0 4.509-1.962 4.509-5.52m-3.803 7.974c-2.239 0-3.956-1.013-4.876-3.006v8.679h-2.637V10.207h2.637v2.76c.981-2.024 2.821-3.066 5.183-3.066 4.079 0 6.133 3.465 6.133 7.973 0 4.324-2.147 7.973-6.44 7.973m-20.121 0c-6.225 0-9.721-4.293-9.721-10.426 0-6.072 3.496-10.335 9.721-10.335 6.195 0 9.69 4.263 9.69 10.335 0 6.133-3.495 10.426-9.69 10.426m0-18.124c-4.968 0-6.961 3.527-6.961 7.698 0 4.262 1.993 7.789 6.961 7.789 4.937 0 6.93-3.527 6.93-7.79 0-4.17-1.993-7.697-6.93-7.697\" />\n    </svg>");
};
var $49fcfcf292337a44$export$a1c6484cdecc2c4b = function OpsgenieLogo(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Opsgenie' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $293a60c0ae776fbb$export$438460117ae6b7ee).size : _ref2$size, testId = _ref2.testId, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $293a60c0ae776fbb$export$438460117ae6b7ee).textColor : _ref2$textColor, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $293a60c0ae776fbb$export$438460117ae6b7ee).iconColor : _ref2$iconColor;
    var _useThemeObserver = (0, $233cd94b869ba248$export$2e2bcd8739ae039)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $f2142a8b85819ba3$export$2e2bcd8739ae039), {
        appearance: appearance,
        iconColor: iconColor,
        label: label,
        size: size,
        svg: $49fcfcf292337a44$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};



var $5FkrB = parcelRequire("5FkrB");




var $5d3ead8641e635fc$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor;
    var colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $28050253965a3cad$export$bbacc3980e0f3029)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" focusable=\"false\" aria-hidden=\"true\">\n    <g fill=\"".concat(colors.iconColor, "\" fill-rule=\"evenodd\">\n      <path d=\"M17.06 4.246a2.79 2.79 0 0 0-2.736-.026l-.049.033-.002.001c-.605.35-1.048.91-1.256 1.558-.085.268-.13.552-.13.842v3.675l4.603 2.656a3.64 3.64 0 0 1 1.824 3.155v9.487a3.6 3.6 0 0 1-.214 1.23l6.175-3.566a2.77 2.77 0 0 0 1.392-2.407v-9.487c0-.991-.532-1.912-1.392-2.408z\"/>\n      <path d=\"m6.058 9 6.176-3.566a3.7 3.7 0 0 0-.214 1.23v9.486c0 1.303.693 2.505 1.823 3.155l4.604 2.657v3.674c0 .29-.045.575-.13.843a2.8 2.8 0 0 1-1.258 1.558.4.4 0 0 0-.05.033c-.851.47-1.89.461-2.735-.026L6.06 23.301a2.78 2.78 0 0 1-1.392-2.408v-9.486c0-.996.529-1.912 1.391-2.408z\"/>\n    </g>\n  </svg>");
};
var $5d3ead8641e635fc$export$e23ae35269442b4f = function RovoIcon(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Rovo' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $293a60c0ae776fbb$export$438460117ae6b7ee).size : _ref2$size, testId = _ref2.testId, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $293a60c0ae776fbb$export$438460117ae6b7ee).textColor : _ref2$textColor, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $293a60c0ae776fbb$export$438460117ae6b7ee).iconColor : _ref2$iconColor;
    var _useThemeObserver = (0, $233cd94b869ba248$export$2e2bcd8739ae039)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $f2142a8b85819ba3$export$2e2bcd8739ae039), {
        appearance: appearance,
        svg: $5d3ead8641e635fc$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        label: label,
        size: size,
        testId: testId,
        textColor: textColor
    });
};


var $5FkrB = parcelRequire("5FkrB");




var $f14233a7f3e78670$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor;
    var colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $28050253965a3cad$export$bbacc3980e0f3029)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" viewBox=\"0 0 100 32\" focusable=\"false\" aria-hidden=\"true\" xmlns=\"http://www.w3.org/2000/svg\">\n      <path\n        d=\"M12.393 4.246a2.79 2.79 0 0 0-2.735-.026.4.4 0 0 1-.05.033l-.001.001c-.606.35-1.048.91-1.257 1.558q-.129.404-.13.842v3.675l4.603 2.656a3.64 3.64 0 0 1 1.824 3.155v9.487a3.6 3.6 0 0 1-.214 1.23l6.175-3.566A2.77 2.77 0 0 0 22 20.884v-9.487c0-.991-.532-1.912-1.392-2.408z\"\n        fill=\"".concat(colors.iconColor, "\"\n        fillRule=\"evenodd\"\n      />\n      <path\n        d=\"m1.391 9 6.176-3.566a3.6 3.6 0 0 0-.214 1.23v9.486c0 1.303.693 2.505 1.823 3.155h.001l4.603 2.657v3.674c0 .29-.045.575-.13.843a2.8 2.8 0 0 1-1.258 1.558.4.4 0 0 0-.05.033c-.85.47-1.89.461-2.734-.026l-8.216-4.743A2.78 2.78 0 0 1 0 20.893v-9.486c0-.996.529-1.912 1.391-2.408z\"\n        fill=\"").concat(colors.iconColor, "\"\n        fillRule=\"evenodd\"\n      />\n      <path\n        d=\"M91.688 25.848c-4.6 0-7.298-3.404-7.298-8.004S87.088 9.9 91.688 9.9c4.57 0 7.238 3.342 7.238 7.942s-2.668 8.004-7.238 8.004zm0-13.494c-3.28 0-4.722 2.576-4.722 5.49 0 2.913 1.441 5.55 4.722 5.55 3.251 0 4.662-2.637 4.662-5.55 0-2.914-1.41-5.49-4.662-5.49M77.675 25.54H74.15L68.2 10.208h2.76l4.968 13.094 4.938-13.095h2.76zm-17.462.308c-4.6 0-7.299-3.404-7.299-8.004s2.7-7.943 7.3-7.943c4.568 0 7.236 3.342 7.236 7.942s-2.668 8.004-7.237 8.004zm0-13.494c-3.281 0-4.723 2.576-4.723 5.49 0 2.913 1.442 5.55 4.723 5.55 3.25 0 4.661-2.637 4.661-5.55 0-2.914-1.41-5.49-4.66-5.49zM43.177 8.03H39.13v7.36h4.048c3.588 0 4.692-1.38 4.692-3.68 0-2.177-1.134-3.68-4.692-3.68zm7.452 3.619c0 3.036-1.288 5.09-3.956 5.949l4.938 7.943H48.36l-4.447-7.514H39.13v7.514h-2.76V5.393h7.115c4.815 0 7.145 2.392 7.145 6.256z\"\n        fill=\"").concat(colors.textColor, "\"\n      />\n    </svg>");
};
var $f14233a7f3e78670$export$a0f6cb8061290bbb = function RovoLogo(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Rovo' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $293a60c0ae776fbb$export$438460117ae6b7ee).size : _ref2$size, testId = _ref2.testId, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $293a60c0ae776fbb$export$438460117ae6b7ee).textColor : _ref2$textColor, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $293a60c0ae776fbb$export$438460117ae6b7ee).iconColor : _ref2$iconColor;
    var _useThemeObserver = (0, $233cd94b869ba248$export$2e2bcd8739ae039)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $f2142a8b85819ba3$export$2e2bcd8739ae039), {
        appearance: appearance,
        iconColor: iconColor,
        label: label,
        size: size,
        svg: $f14233a7f3e78670$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};



var $5FkrB = parcelRequire("5FkrB");




var $aa6181e4f2b1fe79$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor;
    var colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $28050253965a3cad$export$bbacc3980e0f3029)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" viewBox=\"0 0 32 32\" focusable=\"false\" aria-hidden=\"true\" xmlns=\"http://www.w3.org/2000/svg\">\n      <path fill=\"".concat(colors.iconColor, "\" d=\"M16 12.604c-3.033 0-5.981 1.37-8.39 3.489q-.375.373-.748.373c-.208 0-.415-.124-.581-.332l-3.032-3.572c-.166-.207-.25-.415-.25-.581 0-.25.125-.457.374-.706 3.655-3.24 8.1-5.067 12.627-5.067s8.97 1.827 12.626 5.067c.249.249.374.457.374.706 0 .166-.084.374-.25.581l-3.032 3.572c-.166.208-.373.332-.581.332q-.374 0-.748-.374c-2.409-2.118-5.358-3.488-8.39-3.488m0 13.374c-3.365 0-6.106-2.742-6.106-6.064S12.635 13.85 16 13.85s6.106 2.7 6.106 6.064-2.741 6.063-6.105 6.063\"/>\n    </svg>");
};
var $aa6181e4f2b1fe79$export$f3f5aa321d88adf9 = function StatuspageIcon(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Statuspage' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $293a60c0ae776fbb$export$438460117ae6b7ee).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $293a60c0ae776fbb$export$438460117ae6b7ee).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $293a60c0ae776fbb$export$438460117ae6b7ee).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $233cd94b869ba248$export$2e2bcd8739ae039)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $f2142a8b85819ba3$export$2e2bcd8739ae039), {
        appearance: appearance,
        label: label,
        svg: $aa6181e4f2b1fe79$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        size: size,
        testId: testId,
        textColor: textColor
    });
};


var $5FkrB = parcelRequire("5FkrB");




var $a74cdca3a777c86b$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor;
    var colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $28050253965a3cad$export$bbacc3980e0f3029)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" viewBox=\"0 0 188 32\" focusable=\"false\" aria-hidden=\"true\" xmlns=\"http://www.w3.org/2000/svg\">\n      <path fill=\"".concat(colors.iconColor, "\" d=\"M13 12.604c-3.032 0-5.98 1.37-8.39 3.489q-.373.373-.747.373c-.208 0-.416-.124-.582-.332L.25 12.562c-.167-.207-.25-.415-.25-.581 0-.25.125-.457.374-.706C4.029 8.035 8.473 6.208 13 6.208s8.971 1.827 12.626 5.067c.25.249.374.457.374.706 0 .166-.083.374-.25.581l-3.031 3.572c-.166.208-.374.332-.582.332q-.373 0-.747-.374c-2.41-2.118-5.358-3.488-8.39-3.488m0 13.374c-3.364 0-6.105-2.742-6.105-6.064S9.635 13.85 13 13.85c3.364 0 6.105 2.7 6.105 6.064s-2.74 6.063-6.105 6.063\" />\n      <path fill=\"").concat(colors.textColor, "\" d=\"M180.293 12.293c-2.79 0-4.201 1.81-4.477 4.477h8.556c-.153-2.852-1.441-4.477-4.079-4.477m5.888 12.635c-1.257.674-3.189.92-4.753.92-5.735 0-8.249-3.312-8.249-8.004 0-4.631 2.576-7.943 7.237-7.943 4.723 0 6.624 3.281 6.624 7.943v1.196h-11.193c.368 2.606 2.054 4.293 5.673 4.293 1.779 0 3.281-.337 4.661-.828zm-18.638-.614v-1.533c-.981 2.024-2.821 3.067-5.183 3.067-4.048 0-6.072-3.466-6.072-7.974 0-4.324 2.116-7.973 6.379-7.973 2.239 0 3.956 1.012 4.876 3.005v-2.698h2.576V24.16c0 4.508-2.116 7.544-7.605 7.544-2.576 0-3.987-.337-5.459-.828V28.3c1.687.552 3.435.92 5.336.92 3.833 0 5.152-2.055 5.152-4.907m-8.679-6.44c0 3.68 1.472 5.52 4.202 5.52 2.361 0 4.477-1.503 4.477-4.906V17.26c0-3.404-1.932-4.907-4.171-4.907-2.974 0-4.508 1.963-4.508 5.52m-16.949.001c0 3.68 1.472 5.52 4.201 5.52 2.362 0 4.478-1.503 4.478-4.906V17.26c0-3.404-1.932-4.907-4.171-4.907-2.975 0-4.508 1.963-4.508 5.52m8.679 7.667v-2.76c-.982 2.024-2.822 3.066-5.183 3.066-4.079 0-6.133-3.465-6.133-7.973 0-4.324 2.146-7.973 6.44-7.973 2.238 0 3.956 1.012 4.876 3.005v-2.699h2.637V25.54zm-16.091-7.666c0-3.68-1.472-5.52-4.201-5.52-2.361 0-4.477 1.503-4.477 4.907v1.227c0 3.404 1.932 4.906 4.17 4.906 2.975 0 4.508-1.962 4.508-5.52m-3.802 7.974c-2.239 0-3.956-1.013-4.876-3.006v8.679h-2.638V10.207h2.638v2.76c.981-2.024 2.821-3.066 5.182-3.066 4.079 0 6.134 3.465 6.134 7.973 0 4.324-2.147 7.973-6.44 7.973m-10.56-4.477c0 2.545-1.656 4.477-5.765 4.477-2.3 0-4.171-.52-5.336-1.134v-2.79c1.318.766 3.526 1.502 5.458 1.502 2.024 0 3.067-.828 3.067-2.024 0-1.165-.889-1.84-3.803-2.545-3.404-.829-4.845-2.147-4.845-4.662 0-2.668 2.055-4.293 5.551-4.293 1.993 0 3.802.49 4.937 1.104v2.73c-1.84-.92-3.343-1.411-4.968-1.411-1.932 0-2.975.674-2.975 1.87 0 1.073.736 1.748 3.558 2.423 3.404.828 5.121 2.085 5.121 4.753m-27.598-2.177v-8.985h2.638v9.26c0 2.76 1.104 3.988 3.618 3.988 2.454 0 4.14-1.626 4.14-4.723v-8.525h2.638V25.54h-2.638v-2.515c-.981 1.81-2.79 2.821-4.845 2.821-3.527 0-5.55-2.422-5.55-6.654m-7.155 1.596c0 1.349.797 2.269 2.422 2.269.614 0 1.196-.123 1.656-.215v2.546a6.3 6.3 0 0 1-1.778.245c-3.282 0-4.876-1.932-4.876-4.784v-8.188h-2.484v-2.453h2.484V6.957h2.576v3.25h4.078v2.454H85.39zm-18.943-2.914c0 3.68 1.472 5.52 4.202 5.52 2.361 0 4.477-1.503 4.477-4.906V17.26c0-3.404-1.932-4.907-4.17-4.907-2.975 0-4.509 1.963-4.509 5.52m8.679 7.667v-2.76c-.981 2.024-2.821 3.066-5.183 3.066-4.078 0-6.133-3.465-6.133-7.973 0-4.324 2.147-7.973 6.44-7.973 2.239 0 3.956 1.012 4.876 3.005v-2.699h2.637V25.54zm-17.258-4.752c0 1.349.797 2.269 2.422 2.269.614 0 1.196-.123 1.656-.215v2.546a6.3 6.3 0 0 1-1.778.245c-3.282 0-4.876-1.932-4.876-4.784v-8.188h-2.484v-2.453h2.484V6.957h2.576v3.25h4.078v2.454h-4.078zm-6.894-.798c0 3.496-2.085 5.858-7.084 5.858-3.894 0-5.704-.767-7.268-1.564v-2.822c1.871.982 4.754 1.687 7.422 1.687 3.036 0 4.17-1.196 4.17-2.975 0-1.778-1.104-2.729-4.937-3.649-4.539-1.104-6.563-2.668-6.563-5.98 0-3.128 2.392-5.459 7.084-5.459 2.914 0 4.784.706 6.164 1.472v2.76c-2.024-1.165-4.201-1.533-6.286-1.533-2.638 0-4.202.92-4.202 2.76 0 1.656 1.288 2.484 4.846 3.373 4.262 1.074 6.654 2.454 6.654 6.072\" />\n    </svg>");
};
var $a74cdca3a777c86b$export$bb4ae5b41b43be04 = function StatuspageLogo(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Statuspage' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $293a60c0ae776fbb$export$438460117ae6b7ee).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $293a60c0ae776fbb$export$438460117ae6b7ee).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $293a60c0ae776fbb$export$438460117ae6b7ee).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $233cd94b869ba248$export$2e2bcd8739ae039)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $f2142a8b85819ba3$export$2e2bcd8739ae039), {
        appearance: appearance,
        label: label,
        iconColor: iconColor,
        size: size,
        svg: $a74cdca3a777c86b$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};



var $5FkrB = parcelRequire("5FkrB");




var $ef0990d180ef68b7$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor;
    var colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $28050253965a3cad$export$bbacc3980e0f3029)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" viewBox=\"0 0 32 32\" focusable=\"false\" aria-hidden=\"true\" xmlns=\"http://www.w3.org/2000/svg\">\n      <path fill=".concat(colors.iconColor, " clip-rule=\"evenodd\" d=\"M24.286 5.337H7.714a2.585 2.585 0 0 0-2.585 2.585v16.572a2.585 2.585 0 0 0 2.585 2.584h16.572a2.585 2.585 0 0 0 2.585-2.584V7.922a2.585 2.585 0 0 0-2.585-2.585m-9.791 15.66a.86.86 0 0 1-.859.858h-3.634a.86.86 0 0 1-.859-.859V10.21a.86.86 0 0 1 .859-.86h3.634a.86.86 0 0 1 .859.86zm8.362-4.953a.86.86 0 0 1-.859.859h-3.634a.86.86 0 0 1-.859-.859V10.21a.86.86 0 0 1 .859-.86h3.634a.86.86 0 0 1 .859.86z\" fill-rule=\"evenodd\"/>\n    </svg>");
};
var $ef0990d180ef68b7$export$4384da9b8b140bf4 = function TrelloIcon(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Trello' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $293a60c0ae776fbb$export$438460117ae6b7ee).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $293a60c0ae776fbb$export$438460117ae6b7ee).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $293a60c0ae776fbb$export$438460117ae6b7ee).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $233cd94b869ba248$export$2e2bcd8739ae039)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $f2142a8b85819ba3$export$2e2bcd8739ae039), {
        appearance: appearance,
        label: label,
        svg: $ef0990d180ef68b7$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        size: size,
        testId: testId,
        textColor: textColor
    });
};


var $5FkrB = parcelRequire("5FkrB");




var $7e5395f1b7378384$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor;
    var colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $28050253965a3cad$export$bbacc3980e0f3029)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" viewBox=\"0 0 106 32\" focusable=\"false\" aria-hidden=\"true\" xmlns=\"http://www.w3.org/2000/svg\">\n      <path fill=\"".concat(colors.iconColor, "\" clip-rule=\"evenodd\" d=\"M19.157 4.67H2.585A2.585 2.585 0 0 0 0 7.255v16.572a2.585 2.585 0 0 0 2.585 2.585h16.572a2.585 2.585 0 0 0 2.584-2.585V7.255a2.585 2.585 0 0 0-2.584-2.585M9.365 20.33a.86.86 0 0 1-.858.858H4.873a.86.86 0 0 1-.859-.858V9.543c0-.475.385-.859.859-.859h3.634c.474 0 .858.385.858.86zm8.362-4.952a.86.86 0 0 1-.858.858h-3.634a.86.86 0 0 1-.859-.858V9.543c0-.475.385-.859.859-.859h3.634c.474 0 .858.385.858.86z\" fill-rule=\"evenodd\"/>\n      <path fill=\"").concat(colors.textColor, "\" d=\"M97.64 25.848c-4.6 0-7.298-3.404-7.298-8.004S93.04 9.9 97.64 9.9c4.57 0 7.238 3.342 7.238 7.942s-2.668 8.004-7.238 8.004m0-13.494c-3.281 0-4.722 2.576-4.722 5.49 0 2.913 1.44 5.55 4.722 5.55 3.251 0 4.662-2.637 4.662-5.55 0-2.914-1.411-5.49-4.662-5.49M88.874 25.51c-.215.062-.675.123-1.35.123-2.514 0-4.109-1.196-4.109-4.017V3.798h2.637V21.31c0 1.38.92 1.87 2.055 1.87.276 0 .46 0 .767-.03zm-7.996 0c-.215.062-.675.123-1.35.123-2.514 0-4.109-1.196-4.109-4.017V3.798h2.637V21.31c0 1.38.92 1.87 2.055 1.87.276 0 .46 0 .767-.03zM65.532 12.293c-2.79 0-4.202 1.81-4.478 4.477h8.556c-.153-2.852-1.44-4.477-4.078-4.477m5.888 12.635c-1.258.674-3.19.92-4.754.92-5.734 0-8.249-3.312-8.249-8.004 0-4.631 2.576-7.943 7.237-7.943 4.723 0 6.624 3.281 6.624 7.943v1.196H61.085c.368 2.606 2.055 4.293 5.673 4.293 1.78 0 3.282-.337 4.662-.828zm-19.48-8.434v9.047h-2.576V10.208h2.576v2.698c.89-1.809 2.423-3.097 5.428-2.913v2.576c-3.373-.337-5.428.675-5.428 3.925M32.943 5.393H48.03V8.03h-6.164v17.511h-2.76V8.031h-6.164z\"/>\n    </svg>");
};
var $7e5395f1b7378384$export$60e26212f3b61a28 = function TrelloLogo(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Trello' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $293a60c0ae776fbb$export$438460117ae6b7ee).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $293a60c0ae776fbb$export$438460117ae6b7ee).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $293a60c0ae776fbb$export$438460117ae6b7ee).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $233cd94b869ba248$export$2e2bcd8739ae039)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $f2142a8b85819ba3$export$2e2bcd8739ae039), {
        appearance: appearance,
        label: label,
        iconColor: iconColor,
        size: size,
        svg: $7e5395f1b7378384$var$svg({
            appearance: appearance,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};







var $5FkrB = parcelRequire("5FkrB");




var $8615bffe2d1537f6$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor;
    var colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $28050253965a3cad$export$bbacc3980e0f3029)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" viewBox=\"0 0 32 32\" focusable=\"false\" aria-hidden=\"true\" xmlns=\"http://www.w3.org/2000/svg\">\n      <path fill=\"".concat(colors.iconColor, "\" d=\"M27.545 24.378 16.96 3.208c-.208-.458-.417-.541-.667-.541-.208 0-.458.083-.708.5-1.5 2.375-2.167 5.125-2.167 8 0 4.001 2.042 7.752 5.042 13.795.334.666.584.791 1.167.791h7.335c.541 0 .833-.208.833-.625 0-.208-.042-.333-.25-.75M12.168 14.377c-.834-1.25-1.084-1.334-1.292-1.334s-.333.083-.708.834L4.875 24.46c-.167.334-.208.459-.208.625 0 .334.291.667.916.667h7.46c.5 0 .875-.416 1.083-1.208.25-1 .334-1.876.334-2.917 0-2.917-1.292-5.751-2.292-7.251\"/>\n    </svg>");
};
var $8615bffe2d1537f6$export$8a485e2e7ed91e8f = function AtlassianIcon(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Atlassian' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $293a60c0ae776fbb$export$438460117ae6b7ee).size : _ref2$size, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $293a60c0ae776fbb$export$438460117ae6b7ee).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $293a60c0ae776fbb$export$438460117ae6b7ee).textColor : _ref2$textColor, testId = _ref2.testId;
    var _useThemeObserver = (0, $233cd94b869ba248$export$2e2bcd8739ae039)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $f2142a8b85819ba3$export$2e2bcd8739ae039), {
        appearance: appearance,
        label: label,
        svg: $8615bffe2d1537f6$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        textColor: textColor,
        size: size,
        testId: testId
    });
};



var $5FkrB = parcelRequire("5FkrB");





var $cf8b1509548178c1$var$svg = function svg(_ref, colorMode, id) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor;
    var colors = {
        iconGradientStart: (0, $293a60c0ae776fbb$export$793fba32aed8942a).iconGradientStart,
        iconGradientStop: (0, $293a60c0ae776fbb$export$793fba32aed8942a).iconGradientStart,
        iconColor: iconColor
    };
    if (appearance) colors = (0, $eb95a14c9987fdaf$export$362a25f017e2bc8a)(appearance, colorMode);
    return "\n  <svg viewBox=\"0 0 32 32\" height=\"32\" xmlns=\"http://www.w3.org/2000/svg\" focusable=\"false\" aria-hidden=\"true\">\n    <defs>\n      <linearGradient x1=\"108.695%\" x2=\"12.439%\" y1=\"-14.936%\" y2=\"45.215%\" id=\"".concat(id, "-1\">\n        <stop stop-color=\"").concat(colors.iconGradientStart, "\" ").concat(colors.iconGradientStart === 'inherit' ? 'stop-opacity="0.4"' : '', " offset=\"0%\"></stop>\n        <stop stop-color=\"").concat(colors.iconGradientStop, "\" offset=\"100%\"></stop>\n      </linearGradient>\n      <linearGradient x1=\"0%\" x2=\"91.029%\" y1=\"118.55%\" y2=\"63.971%\" id=\"").concat(id, "-2\">\n        <stop stop-color=\"").concat(colors.iconGradientStart, "\" ").concat(colors.iconGradientStart === 'inherit' ? 'stop-opacity="0.4"' : '', " offset=\"0%\"></stop>\n        <stop stop-color=\"").concat(colors.iconGradientStop, "\" offset=\"100%\"></stop>\n      </linearGradient>\n    </defs>\n    <g stroke=\"none\" stroke-width=\"1\" fill-rule=\"nonzero\">\n      <path fill=\"").concat(colors.iconColor, "\" d=\"M15.9669691 29.3616152C17.2195568 28.1097726 17.9233158 26.4114623 17.9233158 24.6405626 17.9233158 22.8696629 17.2195568 21.1713527 15.9669691 19.91951L7.26805808 11.2489111 3.31143376 15.2055354C2.89743442 15.6200502 2.89743442 16.291565 3.31143376 16.7060799L15.9669691 29.3616152zM28.6225045 15.2055354L15.9669691 2.55 15.9280399 2.58892922C13.3485687 5.19994003 13.3612164 9.40374108 15.9563521 11.9991833L24.6623412 20.6662432 28.6225045 16.7060799C29.0365039 16.291565 29.0365039 15.6200502 28.6225045 15.2055354z\" />\n      <path fill=\"url(#").concat(id, "-1\" d=\"M15.9669691,11.9921053 C13.3718335,9.39666304 13.3591857,5.19286199 15.938657,2.58185118 L6.91061706,11.6063521 L11.6316697,16.3274047 L15.9669691,11.9921053 Z\" />\n      <path fill=\"url(#").concat(id, "-2\" d=\"M20.2951906,15.5912886 L15.9669691,19.91951 C17.2195568,21.1713527 17.9233158,22.8696629 17.9233158,24.6405626 C17.9233158,26.4114623 17.2195568,28.1097726 15.9669691,29.3616152 L25.0162432,20.3123412 L20.2951906,15.5912886 Z\" />\n    </g>\n  </svg>");
};
var $cf8b1509548178c1$export$c3835feba2a66e67 = function JiraSoftwareIcon(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Jira Software' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $293a60c0ae776fbb$export$438460117ae6b7ee).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $293a60c0ae776fbb$export$438460117ae6b7ee).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $293a60c0ae776fbb$export$438460117ae6b7ee).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $233cd94b869ba248$export$2e2bcd8739ae039)(), colorMode = _useThemeObserver.colorMode;
    var id = (0, $c797bf80d6171378$export$f680877a34711e37)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $f2142a8b85819ba3$export$2e2bcd8739ae039), {
        appearance: appearance,
        label: label,
        svg: $cf8b1509548178c1$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode, id),
        iconColor: iconColor,
        size: size,
        testId: testId,
        textColor: textColor
    });
};




var $5FkrB = parcelRequire("5FkrB");



var $5FkrB = parcelRequire("5FkrB");
var $5d66b35db7bebba9$var$_excluded = [
    "size"
];
/**
 * Creates a wrapper around the new logo or icon component to ensure it receives the correct default (medium) size prop.
 *
 * @param NewComponent - The new logo or icon component.
 */ var $5d66b35db7bebba9$export$667425256e2e7296 = function tempSizeWrapper(NewComponent) {
    return function(_ref) {
        var size = _ref.size, props = (0, $b45e4aa52a06dd77$export$2e2bcd8739ae039)(_ref, $5d66b35db7bebba9$var$_excluded);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        var Component = NewComponent;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(Component, (0, $39cd338b0da6756c$export$2e2bcd8739ae039)({
            size: size || 'medium'
        }, props));
    };
};





var $d6d36c5f939695fa$var$_excluded = [
    "shouldUseHexLogo"
];
var $d6d36c5f939695fa$export$2469203854060337 = function createFeatureFlaggedRovoComponent(_LegacyComponent, _NewComponent, NewHexComponent) {
    var RovoHexWrapped = (0, $5d66b35db7bebba9$export$667425256e2e7296)(NewHexComponent);
    return function(_ref) {
        var _shouldUseHexLogo = _ref.shouldUseHexLogo, props = (0, $b45e4aa52a06dd77$export$2e2bcd8739ae039)(_ref, $d6d36c5f939695fa$var$_excluded);
        // Hex logo is now always used (platform-logo-rebrand-rovo-hex fully launched)
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(RovoHexWrapped, props);
    };
};



/**
 * __Admin icon__
 *
 * The Admin icon without an accompanying wordmark.
 *
 * - [Examples](https://atlassian.design/components/logo/examples)
 * - [Code](https://atlassian.design/components/logo/code)
 * - [Usage](https://atlassian.design/components/logo/usage)
 */ var $142d7f6a932ec35d$export$ef8e5f836dd989d3 = (0, $5d66b35db7bebba9$export$667425256e2e7296)((0, $4e9ffb95cdb5dd3a$export$ef8e5f836dd989d3));
var $142d7f6a932ec35d$export$ebcd30672e67406 = (0, $5d66b35db7bebba9$export$667425256e2e7296)((0, $a82d2b8e723df418$export$61afcb38c001e19));
var $142d7f6a932ec35d$export$af3460f51ce3602a = (0, $5d66b35db7bebba9$export$667425256e2e7296)((0, $7dbc9112440dccfc$export$af3460f51ce3602a));
var $142d7f6a932ec35d$export$c8415b6abe4a8587 = (0, $5d66b35db7bebba9$export$667425256e2e7296)((0, $40467a94c49e82c6$export$f0bac2b7ac3e3504));
var $142d7f6a932ec35d$export$d89497e7f33ca6f5 = (0, $5d66b35db7bebba9$export$667425256e2e7296)((0, $c52d6d824e754bef$export$d89497e7f33ca6f5));
var $142d7f6a932ec35d$export$48ca930f3071e3e4 = (0, $5d66b35db7bebba9$export$667425256e2e7296)((0, $61590386808e05f8$export$81c47abe19675c4c));
var $142d7f6a932ec35d$export$52cd484a7ef4f2b9 = (0, $5d66b35db7bebba9$export$667425256e2e7296)((0, $47281b3797a0e1e6$export$52cd484a7ef4f2b9));
var $142d7f6a932ec35d$export$9ca9881809919df8 = (0, $5d66b35db7bebba9$export$667425256e2e7296)((0, $3fcca48502ec19ca$export$a529e78951cd6709));
var $142d7f6a932ec35d$export$6da5aa77c402ba0f = (0, $5d66b35db7bebba9$export$667425256e2e7296)((0, $b23ffead7b9336b3$export$6da5aa77c402ba0f));
var $142d7f6a932ec35d$export$abc95e6180bb1d88 = (0, $5d66b35db7bebba9$export$667425256e2e7296)((0, $7df20a17e30779c9$export$f597f0f7fadce0b9));
var $142d7f6a932ec35d$export$34420f0520b19b1d = (0, $5d66b35db7bebba9$export$667425256e2e7296)((0, $37ce8314fa16f648$export$34420f0520b19b1d));
var $142d7f6a932ec35d$export$c9696eb3c34c5a96 = (0, $5d66b35db7bebba9$export$667425256e2e7296)((0, $c3380cdd733c29de$export$bbccafb125ebd50c));
var $142d7f6a932ec35d$export$9eb74917ea768ed4 = (0, $5d66b35db7bebba9$export$667425256e2e7296)((0, $4f908832c395be7c$export$9eb74917ea768ed4));
var $142d7f6a932ec35d$export$d2577aa28451395f = (0, $5d66b35db7bebba9$export$667425256e2e7296)((0, $c9212a79c7c11017$export$c527a545aa426db3));
var $142d7f6a932ec35d$export$92c8767b874048d = (0, $5d66b35db7bebba9$export$667425256e2e7296)((0, $a4dc7739dd58916d$export$92c8767b874048d));
var $142d7f6a932ec35d$export$d5648119d5b68e90 = (0, $5d66b35db7bebba9$export$667425256e2e7296)((0, $ab3d1b934911a5be$export$8b6b7f1b1b2367d3));
var $142d7f6a932ec35d$export$80b8b269d8b5014e = (0, $5d66b35db7bebba9$export$667425256e2e7296)((0, $0e4a211368ae3d84$export$80b8b269d8b5014e));
var $142d7f6a932ec35d$export$fc9bd6687b80fe3b = (0, $5d66b35db7bebba9$export$667425256e2e7296)((0, $2079e45d1c518afa$export$7a38180641471460));
var $142d7f6a932ec35d$export$5ed3e1bb3b04fc02 = (0, $5d66b35db7bebba9$export$667425256e2e7296)((0, $edb3306bd5797c7e$export$5ed3e1bb3b04fc02));
var $142d7f6a932ec35d$export$aeefab651bcf2338 = (0, $5d66b35db7bebba9$export$667425256e2e7296)((0, $6f2a7674410f41a5$export$e3d1678155aaab99));
var $142d7f6a932ec35d$export$8b784b3227531b3e = (0, $5d66b35db7bebba9$export$667425256e2e7296)((0, $691163a2b70932c4$export$8b784b3227531b3e));
var $142d7f6a932ec35d$export$f0750468d67c6902 = (0, $5d66b35db7bebba9$export$667425256e2e7296)((0, $742d58e4c2d2955f$export$4145bd793c9ed1d0));
var $142d7f6a932ec35d$export$813cff80931d9dbf = (0, $5d66b35db7bebba9$export$667425256e2e7296)((0, $060c38b32af8b408$export$813cff80931d9dbf));
var $142d7f6a932ec35d$export$409b7a5b7f180eba = (0, $5d66b35db7bebba9$export$667425256e2e7296)((0, $d3f159e3e0f2a2f6$export$58747af448450872));
var $142d7f6a932ec35d$export$b12fec207e8537a8 = (0, $5d66b35db7bebba9$export$667425256e2e7296)((0, $55c557126d4b3583$export$b12fec207e8537a8));
var $142d7f6a932ec35d$export$82eafebb825fc23f = (0, $5d66b35db7bebba9$export$667425256e2e7296)((0, $bed70d726c9e412c$export$82eafebb825fc23f));
var $142d7f6a932ec35d$export$e4c5487c9a8ae3b1 = (0, $5d66b35db7bebba9$export$667425256e2e7296)((0, $00d48bb4f32e535d$export$fa08cbfe393f2a68));
var $142d7f6a932ec35d$export$290a0f24614cde9f = (0, $5d66b35db7bebba9$export$667425256e2e7296)((0, $075ace437f1f714d$export$290a0f24614cde9f));
var $142d7f6a932ec35d$export$8aceb78c659789b6 = (0, $5d66b35db7bebba9$export$667425256e2e7296)((0, $a3665a3ce5d2eec1$export$273fd56580e523ae));
var $142d7f6a932ec35d$export$4b05688514531169 = (0, $5d66b35db7bebba9$export$667425256e2e7296)((0, $7b305dd743a0e043$export$4b05688514531169));
var $142d7f6a932ec35d$export$4f6453e012279f89 = (0, $5d66b35db7bebba9$export$667425256e2e7296)((0, $6653fbd31258d1d0$export$1b3979d995ebbc6e));
var $142d7f6a932ec35d$export$1bcbc9c337da86da = (0, $5d66b35db7bebba9$export$667425256e2e7296)((0, $8f6772f4842893a9$export$1bcbc9c337da86da));
var $142d7f6a932ec35d$export$9b1a0a0c574cec2a = (0, $5d66b35db7bebba9$export$667425256e2e7296)((0, $a7277a46fce927f7$export$bfd8d1c4da84ce71));
var $142d7f6a932ec35d$export$e812398311cab9a3 = (0, $5d66b35db7bebba9$export$667425256e2e7296)((0, $0fc8b6c4028cfcc8$export$e812398311cab9a3));
var $142d7f6a932ec35d$export$765f5afcc1a5a7e3 = (0, $5d66b35db7bebba9$export$667425256e2e7296)((0, $40af6e70025eaf25$export$7c51958462d750e));
var $142d7f6a932ec35d$export$d3ab16bbf4f954ee = (0, $5d66b35db7bebba9$export$667425256e2e7296)((0, $40fd1d0f44448bda$export$d3ab16bbf4f954ee));
var $142d7f6a932ec35d$export$36044946916e84a0 = (0, $5d66b35db7bebba9$export$667425256e2e7296)((0, $41419f040867fd8d$export$cc55e2a4c4b40552));
var $142d7f6a932ec35d$export$53305f1f2855d3be = (0, $5d66b35db7bebba9$export$667425256e2e7296)((0, $763361ebc176be58$export$53305f1f2855d3be));
var $142d7f6a932ec35d$export$5e06396bce773a3 = (0, $5d66b35db7bebba9$export$667425256e2e7296)((0, $5cb9c7f1699f35d1$export$b3e508cb103e1f93));
var $142d7f6a932ec35d$export$eaf73f391f7103bd = (0, $5d66b35db7bebba9$export$667425256e2e7296)((0, $4adf67e057567a89$export$eaf73f391f7103bd));
var $142d7f6a932ec35d$export$6128b385660fd3c6 = (0, $5d66b35db7bebba9$export$667425256e2e7296)((0, $2168c7de1a871d93$export$3c371bdbcdfcdce));
var $142d7f6a932ec35d$export$f8455b5667a3ee0c = (0, $5d66b35db7bebba9$export$667425256e2e7296)((0, $62e8a66eaf360812$export$f8455b5667a3ee0c));
var $142d7f6a932ec35d$export$eb152ab3801b2ae3 = (0, $5d66b35db7bebba9$export$667425256e2e7296)((0, $a52fbe5d781bb8ee$export$3224b07bc93ef23e));
var $142d7f6a932ec35d$export$65fae0eaf343f2ca = (0, $5d66b35db7bebba9$export$667425256e2e7296)((0, $65e87a79bfc0c809$export$65fae0eaf343f2ca));
var $142d7f6a932ec35d$export$fffc0d480fb1ebf1 = (0, $5d66b35db7bebba9$export$667425256e2e7296)((0, $5c6d87fc5526de52$export$f64bc7a7f04428d0));
var $142d7f6a932ec35d$export$74517ed253186308 = (0, $14541882247a86cc$export$e30d2ddc605f6bb)((0, $c76cbe01b5f15be2$export$74517ed253186308), (0, $4e9ffb95cdb5dd3a$export$ef8e5f836dd989d3));
var $142d7f6a932ec35d$export$833abe6c2ce5ebfd = (0, $14541882247a86cc$export$e30d2ddc605f6bb)((0, $fa26fed8d4db5210$export$833abe6c2ce5ebfd), (0, $a82d2b8e723df418$export$61afcb38c001e19));
var $142d7f6a932ec35d$export$84109e099492cb5f = (0, $14541882247a86cc$export$e30d2ddc605f6bb)((0, $dde6c132b66ddaee$export$84109e099492cb5f), (0, $4e9ffb95cdb5dd3a$export$ef8e5f836dd989d3));
var $142d7f6a932ec35d$export$f845d9b9254f0541 = (0, $14541882247a86cc$export$e30d2ddc605f6bb)((0, $b79cc89e0a214a27$export$f845d9b9254f0541), (0, $a82d2b8e723df418$export$61afcb38c001e19));
var $142d7f6a932ec35d$export$c42ad8a0b925c762 = (0, $14541882247a86cc$export$e30d2ddc605f6bb)((0, $1cb10910e01e10d0$export$c42ad8a0b925c762), (0, $7dbc9112440dccfc$export$af3460f51ce3602a));
var $142d7f6a932ec35d$export$e6470bfc39010cc4 = (0, $14541882247a86cc$export$e30d2ddc605f6bb)((0, $a50d66907d59a53c$export$e6470bfc39010cc4), (0, $40467a94c49e82c6$export$f0bac2b7ac3e3504));
var $142d7f6a932ec35d$export$5fc1066e677788d4 = (0, $14541882247a86cc$export$e30d2ddc605f6bb)((0, $fb6f2ed4dbc293a5$export$5fc1066e677788d4), (0, $39f8da7ca94c04d3$export$5fc1066e677788d4));
var $142d7f6a932ec35d$export$bd40525f5333524b = (0, $14541882247a86cc$export$e30d2ddc605f6bb)((0, $daf3395e352ba399$export$bd40525f5333524b), (0, $2340da16fbcc93af$export$f7ef5e5488e4b430));
var $142d7f6a932ec35d$export$f7857fe64d7161d9 = (0, $14541882247a86cc$export$e30d2ddc605f6bb)((0, $8766aaddeb74cb66$export$f7857fe64d7161d9), (0, $e14115ed39115a71$export$f7857fe64d7161d9));
var $142d7f6a932ec35d$export$eb7d748e4f9c9676 = (0, $14541882247a86cc$export$e30d2ddc605f6bb)((0, $7b83e08f5c39155d$export$eb7d748e4f9c9676), (0, $2d1ebc110ee41c8a$export$a16f50a81d183ce));
var $142d7f6a932ec35d$export$9951d02c2d848122 = (0, $5d66b35db7bebba9$export$667425256e2e7296)((0, $24e0920c6d566bcc$export$9951d02c2d848122));
var $142d7f6a932ec35d$export$68f3db7f6af48bcb = (0, $14541882247a86cc$export$e30d2ddc605f6bb)((0, $5bf2c707e48e8a07$export$68f3db7f6af48bcb), (0, $c187de04d1151cf2$export$68f3db7f6af48bcb));
var $142d7f6a932ec35d$export$1b2e4fe6ef471556 = (0, $14541882247a86cc$export$e30d2ddc605f6bb)((0, $228d07068f21c9cd$export$1b2e4fe6ef471556), (0, $340ac1500a67e4aa$export$a88b0b0da9ef63ce));
var $142d7f6a932ec35d$export$70a0c2f5862937b6 = (0, $5d66b35db7bebba9$export$667425256e2e7296)((0, $157197922b699817$export$70a0c2f5862937b6));
var $142d7f6a932ec35d$export$1b8596b4b0ef673b = (0, $5d66b35db7bebba9$export$667425256e2e7296)((0, $ba7fec4b6bc063e4$export$8b5103382c06639c));
var $142d7f6a932ec35d$export$407687b2dd89cc68 = (0, $14541882247a86cc$export$e30d2ddc605f6bb)((0, $4ce496c177031001$export$407687b2dd89cc68), (0, $157197922b699817$export$70a0c2f5862937b6));
var $142d7f6a932ec35d$export$ee11e928d3d045fd = (0, $14541882247a86cc$export$e30d2ddc605f6bb)((0, $246cd7570ed6cefd$export$ee11e928d3d045fd), (0, $ba7fec4b6bc063e4$export$8b5103382c06639c));
var $142d7f6a932ec35d$export$c4b5b1f965d8b3eb = (0, $14541882247a86cc$export$e30d2ddc605f6bb)((0, $483fe67496eddb47$export$c4b5b1f965d8b3eb), (0, $f3d3a88cf6cc6374$export$c4b5b1f965d8b3eb));
var $142d7f6a932ec35d$export$17d3acb0b4379d02 = (0, $14541882247a86cc$export$e30d2ddc605f6bb)((0, $8b124443f34f90de$export$17d3acb0b4379d02), (0, $b8427b7cd125f4a4$export$bf4c5f97b468e8d6));
var $142d7f6a932ec35d$export$21bfbeb62fdcce8d = (0, $14541882247a86cc$export$e30d2ddc605f6bb)((0, $5d364345d1f29d0f$export$21bfbeb62fdcce8d), (0, $33f47f6f2d3ad2c9$export$21bfbeb62fdcce8d));
var $142d7f6a932ec35d$export$c49a2b642fe9eef4 = (0, $14541882247a86cc$export$e30d2ddc605f6bb)((0, $d27aafd60d42f29e$export$c49a2b642fe9eef4), (0, $6023d3d1da91d408$export$602140a6a10b02bf));
var $142d7f6a932ec35d$export$3c6158790f5e01c4 = (0, $4376af1a160897d5$export$436fcf6e31fbacea)((0, $c4f969561c41b722$export$3c6158790f5e01c4), (0, $379ce3c7b9d6f514$export$3c6158790f5e01c4));
var $142d7f6a932ec35d$export$dabef2be6cd28c20 = (0, $4376af1a160897d5$export$436fcf6e31fbacea)((0, $601abda24c4b9b43$export$dabef2be6cd28c20), (0, $1b4ab5bad63b4fb0$export$de148263c75d2bc1));
var $142d7f6a932ec35d$export$8d789f76fde3e05 = (0, $14541882247a86cc$export$e30d2ddc605f6bb)((0, $fe09b83164667699$export$8d789f76fde3e05), (0, $9ba54b7379c689ca$export$8d789f76fde3e05));
var $142d7f6a932ec35d$export$94e206806e36c2ec = (0, $14541882247a86cc$export$e30d2ddc605f6bb)((0, $50434fde8d57c329$export$94e206806e36c2ec), (0, $7374062c1ee90a71$export$78c0b4d8be34c9b2));
var $142d7f6a932ec35d$export$1bf47cdade1a9fcb = (0, $14541882247a86cc$export$e30d2ddc605f6bb)((0, $4580a29361507e76$export$1bf47cdade1a9fcb), (0, $9ba54b7379c689ca$export$8d789f76fde3e05));
var $142d7f6a932ec35d$export$6e87ce8d41eda665 = (0, $14541882247a86cc$export$e30d2ddc605f6bb)((0, $d994d8a838fb92ca$export$6e87ce8d41eda665), (0, $ea3a5a23799cf5fe$export$68d7391318cdef11));
var $142d7f6a932ec35d$export$e84e925618e0e5bc = (0, $5d66b35db7bebba9$export$667425256e2e7296)((0, $cae5ef80681b4ec4$export$71743a944cb62e48));
var $142d7f6a932ec35d$export$1940ba72c868b663 = (0, $5d66b35db7bebba9$export$667425256e2e7296)((0, $0037dccf1a2ffc9b$export$38c7b37a3e5e8d70));
var $142d7f6a932ec35d$export$eeccc49dc7a12d9f = (0, $4376af1a160897d5$export$436fcf6e31fbacea)((0, $903d4aa684eb7470$export$eeccc49dc7a12d9f), (0, $56e6725c26e2a528$export$eeccc49dc7a12d9f));
var $142d7f6a932ec35d$export$a1c6484cdecc2c4b = (0, $4376af1a160897d5$export$436fcf6e31fbacea)((0, $49fcfcf292337a44$export$a1c6484cdecc2c4b), (0, $e25b2b9203237613$export$a5b9122e89b32ad3));
var $142d7f6a932ec35d$export$f3f5aa321d88adf9 = (0, $4376af1a160897d5$export$436fcf6e31fbacea)((0, $aa6181e4f2b1fe79$export$f3f5aa321d88adf9), (0, $8422bde50b1e1e04$export$f3f5aa321d88adf9));
var $142d7f6a932ec35d$export$bb4ae5b41b43be04 = (0, $4376af1a160897d5$export$436fcf6e31fbacea)((0, $a74cdca3a777c86b$export$bb4ae5b41b43be04), (0, $7dcb795c3c180a2b$export$2bc88a281410ffa7));
var $142d7f6a932ec35d$export$4384da9b8b140bf4 = (0, $14541882247a86cc$export$e30d2ddc605f6bb)((0, $ef0990d180ef68b7$export$4384da9b8b140bf4), (0, $b9841bc1a3fb0032$export$4384da9b8b140bf4));
var $142d7f6a932ec35d$export$60e26212f3b61a28 = (0, $14541882247a86cc$export$e30d2ddc605f6bb)((0, $7e5395f1b7378384$export$60e26212f3b61a28), (0, $622eacd01ebed9e9$export$1b13139dfc0336af));
var $142d7f6a932ec35d$export$e23ae35269442b4f = (0, $d6d36c5f939695fa$export$2469203854060337)((0, $5d3ead8641e635fc$export$e23ae35269442b4f), (0, $95f5787f042884e2$export$e23ae35269442b4f), (0, $a234058df5e65e66$export$9e62346a60cfb459));
var $142d7f6a932ec35d$export$a0f6cb8061290bbb = (0, $d6d36c5f939695fa$export$2469203854060337)((0, $f14233a7f3e78670$export$a0f6cb8061290bbb), (0, $711e7e8829bebe36$export$b0e15f0a1c9f4c55), (0, $5a769e9664562a1b$export$5e38d02efdb45577));
var $142d7f6a932ec35d$export$3f95fcfdc25a741d = (0, $14541882247a86cc$export$e30d2ddc605f6bb)((0, $c06feaf9d9aa6a56$export$3f95fcfdc25a741d), (0, $6a78ffaee3a1392f$export$3f95fcfdc25a741d));
var $142d7f6a932ec35d$export$a4a891d202775deb = (0, $14541882247a86cc$export$e30d2ddc605f6bb)((0, $9e38f3206f1da36d$export$a4a891d202775deb), (0, $0e59fe96d5359d31$export$2b896c4d595a4331));
var $142d7f6a932ec35d$export$1e02e7298035a77c = (0, $14541882247a86cc$export$e30d2ddc605f6bb)((0, $2d51a09fdc6dbd6f$export$1e02e7298035a77c), (0, $7ea5c20c74834294$export$1e02e7298035a77c));
var $142d7f6a932ec35d$export$33908560ea1b226d = (0, $14541882247a86cc$export$e30d2ddc605f6bb)((0, $43c1294a9c6a0e6c$export$33908560ea1b226d), (0, $9560cc7a04e1393c$export$3a6e8b37e069a69d));
var $142d7f6a932ec35d$export$5ef3f25e16249826 = (0, $5d66b35db7bebba9$export$667425256e2e7296)((0, $3261fc8266090e6c$export$5ef3f25e16249826));
var $142d7f6a932ec35d$export$1ab0976b9ea166ae = (0, $5d66b35db7bebba9$export$667425256e2e7296)((0, $50b8810a291d2f4a$export$1ab0976b9ea166ae));
var $142d7f6a932ec35d$export$5efe8561ca252843 = (0, $5d66b35db7bebba9$export$667425256e2e7296)((0, $2849aa7d84d6b6ae$export$5efe8561ca252843));
var $142d7f6a932ec35d$export$e26e48d31d71c1e1 = (0, $5d66b35db7bebba9$export$667425256e2e7296)((0, $738e873508995cbd$export$e26e48d31d71c1e1));
var $142d7f6a932ec35d$export$bf5ca9fb70f56bb5 = (0, $5d66b35db7bebba9$export$667425256e2e7296)((0, $cd4e8d286a470e42$export$bf5ca9fb70f56bb5));
var $142d7f6a932ec35d$export$518f48548316ec87 = (0, $5d66b35db7bebba9$export$667425256e2e7296)((0, $9790da1506d41a4c$export$518f48548316ec87));






/**
 * __Confluence icon__
 *
 * The Confluence icon without an accompanying wordmark.
 *
 * - [Examples](https://atlassian.design/components/logo/examples)
 * - [Code](https://atlassian.design/components/logo/code)
 * - [Usage](https://atlassian.design/components/logo/usage)
 */ var $eed13112ef66c96f$export$68f3db7f6af48bcb = (0, $14541882247a86cc$export$e30d2ddc605f6bb)((0, $5bf2c707e48e8a07$export$68f3db7f6af48bcb), (0, $c187de04d1151cf2$export$68f3db7f6af48bcb));




/* box.tsx generated by @compiled/babel-plugin v0.39.1 */ 


var $5FkrB = parcelRequire("5FkrB");


var $5FkrB = parcelRequire("5FkrB");
var $fb554c12edb18215$export$1ca2a26fecb070ae = /*#__PURE__*/ (0, $5FkrB.createContext)('elevation.surface');


var $13ab488c4f477874$var$_excluded = [
    "as",
    "children",
    "backgroundColor",
    "padding",
    "paddingBlock",
    "paddingBlockStart",
    "paddingBlockEnd",
    "paddingInline",
    "paddingInlineStart",
    "paddingInlineEnd",
    "style",
    "testId",
    "xcss"
], $13ab488c4f477874$var$_excluded2 = [
    "className"
];
// Can either Exclude or Extract - here we're excluding all SVG-related elements, <button> elements (handled by Pressable), and <a> elements (handled by Anchor)
// Basically just ElementType but without ComponentType, it makes sense to keep the "Type" suffix
// eslint-disable-next-line @repo/internal/react/consistent-types-definitions
var $13ab488c4f477874$var$baseStyles = null;
var $13ab488c4f477874$var$backgroundColorMap = {
    'color.background.accent.lime.subtlest': "_bfhkm890",
    'color.background.accent.lime.subtlest.hovered': "_bfhkd4y8",
    'color.background.accent.lime.subtlest.pressed': "_bfhkkuup",
    'color.background.accent.lime.subtler': "_bfhkz2ec",
    'color.background.accent.lime.subtler.hovered': "_bfhk1gf0",
    'color.background.accent.lime.subtler.pressed': "_bfhk2kxc",
    'color.background.accent.lime.subtle': "_bfhkbq5w",
    'color.background.accent.lime.subtle.hovered': "_bfhkfoww",
    'color.background.accent.lime.subtle.pressed': "_bfhk1jbd",
    'color.background.accent.lime.bolder': "_bfhktde4",
    'color.background.accent.lime.bolder.hovered': "_bfhknzpa",
    'color.background.accent.lime.bolder.pressed': "_bfhkh0j0",
    'color.background.accent.red.subtlest': "_bfhk1vk5",
    'color.background.accent.red.subtlest.hovered': "_bfhk1i6i",
    'color.background.accent.red.subtlest.pressed': "_bfhknbir",
    'color.background.accent.red.subtler': "_bfhk1rtt",
    'color.background.accent.red.subtler.hovered': "_bfhkaffd",
    'color.background.accent.red.subtler.pressed': "_bfhk1j5a",
    'color.background.accent.red.subtle': "_bfhkkrt9",
    'color.background.accent.red.subtle.hovered': "_bfhk1sou",
    'color.background.accent.red.subtle.pressed': "_bfhk1fnn",
    'color.background.accent.red.bolder': "_bfhkuibq",
    'color.background.accent.red.bolder.hovered': "_bfhk100f",
    'color.background.accent.red.bolder.pressed': "_bfhk1cl6",
    'color.background.accent.orange.subtlest': "_bfhkf5uh",
    'color.background.accent.orange.subtlest.hovered': "_bfhk19yr",
    'color.background.accent.orange.subtlest.pressed': "_bfhkf90x",
    'color.background.accent.orange.subtler': "_bfhk165s",
    'color.background.accent.orange.subtler.hovered': "_bfhk1ei0",
    'color.background.accent.orange.subtler.pressed': "_bfhkdpo3",
    'color.background.accent.orange.subtle': "_bfhk1kkj",
    'color.background.accent.orange.subtle.hovered': "_bfhk9mfs",
    'color.background.accent.orange.subtle.pressed': "_bfhkaxpp",
    'color.background.accent.orange.bolder': "_bfhk1qg1",
    'color.background.accent.orange.bolder.hovered': "_bfhk12qo",
    'color.background.accent.orange.bolder.pressed': "_bfhk1fyq",
    'color.background.accent.yellow.subtlest': "_bfhkibhp",
    'color.background.accent.yellow.subtlest.hovered': "_bfhkaetg",
    'color.background.accent.yellow.subtlest.pressed': "_bfhk1o1l",
    'color.background.accent.yellow.subtler': "_bfhk1773",
    'color.background.accent.yellow.subtler.hovered': "_bfhk1uw7",
    'color.background.accent.yellow.subtler.pressed': "_bfhk1r9w",
    'color.background.accent.yellow.subtle': "_bfhk8y3s",
    'color.background.accent.yellow.subtle.hovered': "_bfhk819w",
    'color.background.accent.yellow.subtle.pressed': "_bfhk1jx0",
    'color.background.accent.yellow.bolder': "_bfhk1vop",
    'color.background.accent.yellow.bolder.hovered': "_bfhkkjqf",
    'color.background.accent.yellow.bolder.pressed': "_bfhk1okt",
    'color.background.accent.green.subtlest': "_bfhkn729",
    'color.background.accent.green.subtlest.hovered': "_bfhk3utz",
    'color.background.accent.green.subtlest.pressed': "_bfhkyfny",
    'color.background.accent.green.subtler': "_bfhk1wnw",
    'color.background.accent.green.subtler.hovered': "_bfhk1e2h",
    'color.background.accent.green.subtler.pressed': "_bfhkybhx",
    'color.background.accent.green.subtle': "_bfhk1rsu",
    'color.background.accent.green.subtle.hovered': "_bfhk12e3",
    'color.background.accent.green.subtle.pressed': "_bfhk1g86",
    'color.background.accent.green.bolder': "_bfhk1e5c",
    'color.background.accent.green.bolder.hovered': "_bfhka5yi",
    'color.background.accent.green.bolder.pressed': "_bfhk1j68",
    'color.background.accent.teal.subtlest': "_bfhk7xuz",
    'color.background.accent.teal.subtlest.hovered': "_bfhk108c",
    'color.background.accent.teal.subtlest.pressed': "_bfhk1cxp",
    'color.background.accent.teal.subtler': "_bfhk1a17",
    'color.background.accent.teal.subtler.hovered': "_bfhkkwwr",
    'color.background.accent.teal.subtler.pressed': "_bfhk1jb0",
    'color.background.accent.teal.subtle': "_bfhktdv8",
    'color.background.accent.teal.subtle.hovered': "_bfhkzh8h",
    'color.background.accent.teal.subtle.pressed': "_bfhk16zl",
    'color.background.accent.teal.bolder': "_bfhk2c8p",
    'color.background.accent.teal.bolder.hovered': "_bfhkl3ve",
    'color.background.accent.teal.bolder.pressed': "_bfhktor0",
    'color.background.accent.blue.subtlest': "_bfhk1s93",
    'color.background.accent.blue.subtlest.hovered': "_bfhkdaj9",
    'color.background.accent.blue.subtlest.pressed': "_bfhkxm0g",
    'color.background.accent.blue.subtler': "_bfhk1dy8",
    'color.background.accent.blue.subtler.hovered': "_bfhk815t",
    'color.background.accent.blue.subtler.pressed': "_bfhkrwxf",
    'color.background.accent.blue.subtle': "_bfhk115i",
    'color.background.accent.blue.subtle.hovered': "_bfhk9pr4",
    'color.background.accent.blue.subtle.pressed': "_bfhknpx7",
    'color.background.accent.blue.bolder': "_bfhk16e3",
    'color.background.accent.blue.bolder.hovered': "_bfhk1vbm",
    'color.background.accent.blue.bolder.pressed': "_bfhk1xwi",
    'color.background.accent.purple.subtlest': "_bfhkp2ly",
    'color.background.accent.purple.subtlest.hovered': "_bfhkkca2",
    'color.background.accent.purple.subtlest.pressed': "_bfhk1jbm",
    'color.background.accent.purple.subtler': "_bfhk1nm4",
    'color.background.accent.purple.subtler.hovered': "_bfhkattl",
    'color.background.accent.purple.subtler.pressed': "_bfhk3nfk",
    'color.background.accent.purple.subtle': "_bfhk18ah",
    'color.background.accent.purple.subtle.hovered': "_bfhk8bp1",
    'color.background.accent.purple.subtle.pressed': "_bfhk1cd2",
    'color.background.accent.purple.bolder': "_bfhkya33",
    'color.background.accent.purple.bolder.hovered': "_bfhk1af5",
    'color.background.accent.purple.bolder.pressed': "_bfhk6cze",
    'color.background.accent.magenta.subtlest': "_bfhk8tvm",
    'color.background.accent.magenta.subtlest.hovered': "_bfhkr3zd",
    'color.background.accent.magenta.subtlest.pressed': "_bfhk1ckf",
    'color.background.accent.magenta.subtler': "_bfhkv9ra",
    'color.background.accent.magenta.subtler.hovered': "_bfhk1axx",
    'color.background.accent.magenta.subtler.pressed': "_bfhk42ri",
    'color.background.accent.magenta.subtle': "_bfhk1mi6",
    'color.background.accent.magenta.subtle.hovered': "_bfhkrwyz",
    'color.background.accent.magenta.subtle.pressed': "_bfhk6c15",
    'color.background.accent.magenta.bolder': "_bfhkc3uk",
    'color.background.accent.magenta.bolder.hovered': "_bfhk1ok8",
    'color.background.accent.magenta.bolder.pressed': "_bfhkeawv",
    'color.background.accent.gray.subtlest': "_bfhkysee",
    'color.background.accent.gray.subtlest.hovered': "_bfhkwejn",
    'color.background.accent.gray.subtlest.pressed': "_bfhk18ut",
    'color.background.accent.gray.subtler': "_bfhk7qp0",
    'color.background.accent.gray.subtler.hovered': "_bfhk10ef",
    'color.background.accent.gray.subtler.pressed': "_bfhk1rk9",
    'color.background.accent.gray.subtle': "_bfhk18j9",
    'color.background.accent.gray.subtle.hovered': "_bfhk1nv3",
    'color.background.accent.gray.subtle.pressed': "_bfhkq9tj",
    'color.background.accent.gray.bolder': "_bfhk1i45",
    'color.background.accent.gray.bolder.hovered': "_bfhkbyip",
    'color.background.accent.gray.bolder.pressed': "_bfhk1van",
    'color.background.disabled': "_bfhk187o",
    'color.background.input': "_bfhk1j9a",
    'color.background.input.hovered': "_bfhkl4ek",
    'color.background.input.pressed': "_bfhkr01l",
    'color.background.inverse.subtle': "_bfhk1vck",
    'color.background.inverse.subtle.hovered': "_bfhkmpja",
    'color.background.inverse.subtle.pressed': "_bfhk1gii",
    'color.background.neutral': "_bfhki8nm",
    'color.background.neutral.hovered': "_bfhkplhp",
    'color.background.neutral.pressed': "_bfhk1gdz",
    'color.background.neutral.subtle': "_bfhksm61",
    'color.background.neutral.subtle.hovered': "_bfhk1dpa",
    'color.background.neutral.subtle.pressed': "_bfhkfcek",
    'color.background.neutral.bold': "_bfhk1aqn",
    'color.background.neutral.bold.hovered': "_bfhk1ibz",
    'color.background.neutral.bold.pressed': "_bfhkof27",
    'color.background.selected': "_bfhk15s3",
    'color.background.selected.hovered': "_bfhkufnl",
    'color.background.selected.pressed': "_bfhknozp",
    'color.background.selected.bold': "_bfhkjmqp",
    'color.background.selected.bold.hovered': "_bfhk1q28",
    'color.background.selected.bold.pressed': "_bfhk12kk",
    'color.background.brand.subtlest': "_bfhk1gmr",
    'color.background.brand.subtlest.hovered': "_bfhk3v15",
    'color.background.brand.subtlest.pressed': "_bfhku02c",
    'color.background.brand.bold': "_bfhk1856",
    'color.background.brand.bold.hovered': "_bfhkhf2y",
    'color.background.brand.bold.pressed': "_bfhkg6ey",
    'color.background.brand.boldest': "_bfhk1o4i",
    'color.background.brand.boldest.hovered': "_bfhklefx",
    'color.background.brand.boldest.pressed': "_bfhk16k6",
    'color.background.danger': "_bfhk1gly",
    'color.background.danger.hovered': "_bfhk1yvi",
    'color.background.danger.pressed': "_bfhk1r4b",
    'color.background.danger.bold': "_bfhkybec",
    'color.background.danger.bold.hovered': "_bfhks9hg",
    'color.background.danger.bold.pressed': "_bfhk13a9",
    'color.background.warning': "_bfhk1917",
    'color.background.warning.hovered': "_bfhk19zu",
    'color.background.warning.pressed': "_bfhkzr32",
    'color.background.warning.bold': "_bfhk1kmu",
    'color.background.warning.bold.hovered': "_bfhk1spp",
    'color.background.warning.bold.pressed': "_bfhk4m4m",
    'color.background.success': "_bfhk1y9u",
    'color.background.success.hovered': "_bfhk1vfx",
    'color.background.success.pressed': "_bfhk1wl5",
    'color.background.success.bold': "_bfhkkcmj",
    'color.background.success.bold.hovered': "_bfhky7x8",
    'color.background.success.bold.pressed': "_bfhkwcbh",
    'color.background.discovery': "_bfhk6vm6",
    'color.background.discovery.hovered': "_bfhk12eq",
    'color.background.discovery.pressed': "_bfhk18vq",
    'color.background.discovery.bold': "_bfhku5tj",
    'color.background.discovery.bold.hovered': "_bfhkfqeg",
    'color.background.discovery.bold.pressed': "_bfhk1f1m",
    'color.background.information': "_bfhk19ip",
    'color.background.information.hovered': "_bfhk86z5",
    'color.background.information.pressed': "_bfhk1c1j",
    'color.background.information.bold': "_bfhkx4w0",
    'color.background.information.bold.hovered': "_bfhkq2ii",
    'color.background.information.bold.pressed': "_bfhkf89v",
    'color.blanket': "_bfhk1i5c",
    'color.blanket.selected': "_bfhk7wq0",
    'color.blanket.danger': "_bfhkrprw",
    'color.skeleton': "_bfhkizff",
    'color.skeleton.subtle': "_bfhkvkf5",
    'elevation.surface': "_bfhkvuon",
    'elevation.surface.hovered': "_bfhk19i6",
    'elevation.surface.pressed': "_bfhk13ro",
    'elevation.surface.overlay': "_bfhk1bhr",
    'elevation.surface.overlay.hovered': "_bfhk6o2t",
    'elevation.surface.overlay.pressed': "_bfhkm8nx",
    'elevation.surface.raised': "_bfhkhp5a",
    'elevation.surface.raised.hovered': "_bfhk116u",
    'elevation.surface.raised.pressed': "_bfhk14aj",
    'elevation.surface.sunken': "_bfhkhfxm",
    'utility.elevation.surface.current': "_bfhkchd4"
};
var $13ab488c4f477874$var$CURRENT_SURFACE_CSS_VAR = "--ds-elevation-surface-current";
var $13ab488c4f477874$var$setSurfaceTokenMap = {
    'elevation.surface': "_1q1lvuon",
    'elevation.surface.hovered': "_1q1l19i6",
    'elevation.surface.pressed': "_1q1l13ro",
    'elevation.surface.overlay': "_1q1l1bhr",
    'elevation.surface.overlay.hovered': "_1q1l6o2t",
    'elevation.surface.overlay.pressed': "_1q1lm8nx",
    'elevation.surface.raised': "_1q1lhp5a",
    'elevation.surface.raised.hovered': "_1q1l116u",
    'elevation.surface.raised.pressed': "_1q1l14aj",
    'elevation.surface.sunken': "_1q1lhfxm"
};
var $13ab488c4f477874$var$paddingBlockStartMap = {
    'space.0': "_1q51ze3t",
    'space.025': "_1q51v77o",
    'space.050': "_1q511b66",
    'space.075': "_1q5112x7",
    'space.100': "_1q51u2gc",
    'space.150': "_1q51utpp",
    'space.200': "_1q51pxbi",
    'space.250': "_1q51v47k",
    'space.300': "_1q511ejb",
    'space.400': "_1q51xy5q",
    'space.500': "_1q511jfw",
    'space.600': "_1q51oahv",
    'space.800': "_1q51xncg",
    'space.1000': "_1q511epz"
};
var $13ab488c4f477874$var$paddingBlockEndMap = {
    'space.0': "_85i5ze3t",
    'space.025': "_85i5v77o",
    'space.050': "_85i51b66",
    'space.075': "_85i512x7",
    'space.100': "_85i5u2gc",
    'space.150': "_85i5utpp",
    'space.200': "_85i5pxbi",
    'space.250': "_85i5v47k",
    'space.300': "_85i51ejb",
    'space.400': "_85i5xy5q",
    'space.500': "_85i51jfw",
    'space.600': "_85i5oahv",
    'space.800': "_85i5xncg",
    'space.1000': "_85i51epz"
};
var $13ab488c4f477874$var$paddingInlineStartMap = {
    'space.0': "_bozgze3t",
    'space.025': "_bozgv77o",
    'space.050': "_bozg1b66",
    'space.075': "_bozg12x7",
    'space.100': "_bozgu2gc",
    'space.150': "_bozgutpp",
    'space.200': "_bozgpxbi",
    'space.250': "_bozgv47k",
    'space.300': "_bozg1ejb",
    'space.400': "_bozgxy5q",
    'space.500': "_bozg1jfw",
    'space.600': "_bozgoahv",
    'space.800': "_bozgxncg",
    'space.1000': "_bozg1epz"
};
var $13ab488c4f477874$var$paddingInlineEndMap = {
    'space.0': "_y4tize3t",
    'space.025': "_y4tiv77o",
    'space.050': "_y4ti1b66",
    'space.075': "_y4ti12x7",
    'space.100': "_y4tiu2gc",
    'space.150': "_y4tiutpp",
    'space.200': "_y4tipxbi",
    'space.250': "_y4tiv47k",
    'space.300': "_y4ti1ejb",
    'space.400': "_y4tixy5q",
    'space.500': "_y4ti1jfw",
    'space.600': "_y4tioahv",
    'space.800': "_y4tixncg",
    'space.1000': "_y4ti1epz"
};
/**
 * __Box__
 *
 * A Box is a primitive component that has the design decisions of the Atlassian Design System baked in.
 * Renders a `div` by default.
 *
 * - [Examples](https://atlassian.design/components/primitives/box/examples)
 * - [Code](https://atlassian.design/components/primitives/box/code)
 * - [Usage](https://atlassian.design/components/primitives/box/usage)
 */ var $13ab488c4f477874$var$Box = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? 'div' : _ref$as, children = _ref.children, backgroundColor = _ref.backgroundColor, padding = _ref.padding, _ref$paddingBlock = _ref.paddingBlock, paddingBlock = _ref$paddingBlock === void 0 ? padding : _ref$paddingBlock, _ref$paddingBlockStar = _ref.paddingBlockStart, paddingBlockStart = _ref$paddingBlockStar === void 0 ? paddingBlock : _ref$paddingBlockStar, _ref$paddingBlockEnd = _ref.paddingBlockEnd, paddingBlockEnd = _ref$paddingBlockEnd === void 0 ? paddingBlock : _ref$paddingBlockEnd, _ref$paddingInline = _ref.paddingInline, paddingInline = _ref$paddingInline === void 0 ? padding : _ref$paddingInline, _ref$paddingInlineSta = _ref.paddingInlineStart, paddingInlineStart = _ref$paddingInlineSta === void 0 ? paddingInline : _ref$paddingInlineSta, _ref$paddingInlineEnd = _ref.paddingInlineEnd, paddingInlineEnd = _ref$paddingInlineEnd === void 0 ? paddingInline : _ref$paddingInlineEnd, style = _ref.style, testId = _ref.testId, xcss = _ref.xcss, htmlAttributes = (0, $b45e4aa52a06dd77$export$2e2bcd8739ae039)(_ref, $13ab488c4f477874$var$_excluded);
    // This is to remove className from safeHtmlAttributes
    // @ts-ignore -- not using expect since it causes issues with help-center local consumption - className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    var _spreadClass = htmlAttributes.className, safeHtmlAttributes = (0, $b45e4aa52a06dd77$export$2e2bcd8739ae039)(htmlAttributes, $13ab488c4f477874$var$_excluded2);
    var node = /*#__PURE__*/ $5FkrB.createElement(Component, (0, $39cd338b0da6756c$export$2e2bcd8739ae039)({
        style: style,
        ref: ref,
        className: (0, $c4f3fc62d4a10748$export$2e2bcd8739ae039)([
            "_19itglyw _vchhusvi _r06hglyw",
            backgroundColor && $13ab488c4f477874$var$backgroundColorMap[backgroundColor],
            backgroundColor && $13ab488c4f477874$var$isSurfaceToken(backgroundColor) && $13ab488c4f477874$var$setSurfaceTokenMap[backgroundColor],
            paddingBlockStart && $13ab488c4f477874$var$paddingBlockStartMap[paddingBlockStart],
            paddingBlockEnd && $13ab488c4f477874$var$paddingBlockEndMap[paddingBlockEnd],
            paddingInlineStart && $13ab488c4f477874$var$paddingInlineStartMap[paddingInlineStart],
            paddingInlineEnd && $13ab488c4f477874$var$paddingInlineEndMap[paddingInlineEnd],
            xcss
        ])
    }, safeHtmlAttributes, {
        "data-testid": testId
    }), children);
    if (backgroundColor) return /*#__PURE__*/ $5FkrB.createElement((0, $fb554c12edb18215$export$1ca2a26fecb070ae).Provider, {
        value: backgroundColor
    }, node);
    return node;
});
var $13ab488c4f477874$export$2e2bcd8739ae039 = $13ab488c4f477874$var$Box;
function $13ab488c4f477874$var$isSurfaceToken(backgroundColor) {
    return backgroundColor in $13ab488c4f477874$var$setSurfaceTokenMap;
}

/* text.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $5FkrB = parcelRequire("5FkrB");



var $5FkrB = parcelRequire("5FkrB");
var $f91e899f7870e2bd$var$HasTextAncestorContext = /*#__PURE__*/ (0, $5FkrB.createContext)(false);
var $f91e899f7870e2bd$export$9322276ec105d055 = function useHasTextAncestor() {
    return (0, $5FkrB.useContext)($f91e899f7870e2bd$var$HasTextAncestorContext);
};
var $f91e899f7870e2bd$export$ae933c6cbe5643ad = $f91e899f7870e2bd$var$HasTextAncestorContext.Provider;



var $5FkrB = parcelRequire("5FkrB");

var $52e527e74f3a7932$export$1aeb4f6b93c4540d = function useSurface() {
    return (0, $5FkrB.useContext)((0, $fb554c12edb18215$export$1ca2a26fecb070ae));
};
(0, $fb554c12edb18215$export$1ca2a26fecb070ae).displayName = 'SurfaceProvider';


var $d7d9260459e6fa9f$var$asAllowlist = [
    'span',
    'p',
    'strong',
    'em'
];
/**
 * Custom hook designed to abstract the parsing of the color props and make it clearer in the future how color is reconciled between themes and tokens.
 */ var $d7d9260459e6fa9f$var$useColor = function useColor(colorProp, hasTextAncestor) {
    var surface = (0, $52e527e74f3a7932$export$1aeb4f6b93c4540d)();
    if (colorProp === 'inherit') return undefined;
    if (colorProp) return colorProp;
    if (hasTextAncestor) return undefined;
    if ($d7d9260459e6fa9f$export$2185ce37f9bdd963.hasOwnProperty(surface)) return $d7d9260459e6fa9f$export$2185ce37f9bdd963[surface];
    return 'color.text';
};
var $d7d9260459e6fa9f$var$styles = {
    root: "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _1i4qfg65",
    'as.strong': "_k48pwu06",
    'as.em': "_zg8l1m30",
    'textAlign.center': "_y3gn1h6o",
    'textAlign.end': "_y3gnh9n0",
    'textAlign.start': "_y3gnv2br",
    truncation: "_1reo15vq _18m915vq _1e0ccj1k _sudp1e54",
    breakAll: "_1nmz9jpi"
};
var $d7d9260459e6fa9f$var$fontSizeMap = {
    medium: "_11c8fhey",
    large: "_11c81d4k",
    small: "_11c8wadc"
};
var $d7d9260459e6fa9f$var$fontWeightMap = {
    bold: "_k48pwu06",
    medium: "_k48p1wq8",
    regular: "_k48pi7a9",
    semibold: "_k48p1pd9"
};
var $d7d9260459e6fa9f$var$textColorMap = {
    'color.text': "_syazi7uo",
    'color.text.accent.lime': "_syaz1tco",
    'color.text.accent.lime.bolder': "_syaz1ik3",
    'color.text.accent.red': "_syaz9lu1",
    'color.text.accent.red.bolder': "_syazhwvp",
    'color.text.accent.orange': "_syazp1lv",
    'color.text.accent.orange.bolder': "_syaz7i1p",
    'color.text.accent.yellow': "_syazfb2s",
    'color.text.accent.yellow.bolder': "_syazekll",
    'color.text.accent.green': "_syazh55r",
    'color.text.accent.green.bolder': "_syaz1y78",
    'color.text.accent.teal': "_syaz17qg",
    'color.text.accent.teal.bolder': "_syaz12v7",
    'color.text.accent.blue': "_syaz16jw",
    'color.text.accent.blue.bolder': "_syaz1kyx",
    'color.text.accent.purple': "_syazqmo9",
    'color.text.accent.purple.bolder': "_syaz1mn1",
    'color.text.accent.magenta': "_syaz1s8m",
    'color.text.accent.magenta.bolder': "_syaz1qur",
    'color.text.accent.gray': "_syaz1sqi",
    'color.text.accent.gray.bolder': "_syaz1tmo",
    'color.text.disabled': "_syaz1gmx",
    'color.text.inverse': "_syaz15cr",
    'color.text.selected': "_syaz6x5g",
    'color.text.brand': "_syaz1oa5",
    'color.text.danger': "_syaz1tmw",
    'color.text.warning': "_syaz1xn9",
    'color.text.warning.inverse': "_syaz1yd3",
    'color.text.success': "_syazgsak",
    'color.text.discovery': "_syazdv2p",
    'color.text.information': "_syazu3tg",
    'color.text.subtlest': "_syaz1rpy",
    'color.text.subtle': "_syazazsu",
    'color.link': "_syaz13af",
    'color.link.pressed': "_syaz12zz",
    'color.link.visited': "_syaz1ra0",
    'color.link.visited.pressed': "_syaz17z1"
};
var $d7d9260459e6fa9f$export$2185ce37f9bdd963 = {
    'color.background.neutral.bold': 'color.text.inverse',
    'color.background.neutral.bold.hovered': 'color.text.inverse',
    'color.background.neutral.bold.pressed': 'color.text.inverse',
    'color.background.selected.bold': 'color.text.inverse',
    'color.background.selected.bold.hovered': 'color.text.inverse',
    'color.background.selected.bold.pressed': 'color.text.inverse',
    'color.background.brand.bold': 'color.text.inverse',
    'color.background.brand.bold.hovered': 'color.text.inverse',
    'color.background.brand.bold.pressed': 'color.text.inverse',
    'color.background.brand.boldest': 'color.text.inverse',
    'color.background.brand.boldest.hovered': 'color.text.inverse',
    'color.background.brand.boldest.pressed': 'color.text.inverse',
    'color.background.danger.bold': 'color.text.inverse',
    'color.background.danger.bold.hovered': 'color.text.inverse',
    'color.background.danger.bold.pressed': 'color.text.inverse',
    'color.background.warning.bold': 'color.text.warning.inverse',
    'color.background.warning.bold.hovered': 'color.text.warning.inverse',
    'color.background.warning.bold.pressed': 'color.text.warning.inverse',
    'color.background.success.bold': 'color.text.inverse',
    'color.background.success.bold.hovered': 'color.text.inverse',
    'color.background.success.bold.pressed': 'color.text.inverse',
    'color.background.discovery.bold': 'color.text.inverse',
    'color.background.discovery.bold.hovered': 'color.text.inverse',
    'color.background.discovery.bold.pressed': 'color.text.inverse',
    'color.background.information.bold': 'color.text.inverse',
    'color.background.information.bold.hovered': 'color.text.inverse',
    'color.background.information.bold.pressed': 'color.text.inverse'
};
/**
 * __Text__
 *
 * Text is a primitive component that has the Atlassian Design System's design guidelines baked in.
 * This includes considerations for text attributes such as color, font size, font weight, and line height.
 * It renders a `span` by default.
 *
 * @internal
 */ var $d7d9260459e6fa9f$var$Text = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? 'span' : _ref$as, colorProp = _ref.color, align = _ref.align, testId = _ref.testId, id = _ref.id, size = _ref.size, weight = _ref.weight, maxLines = _ref.maxLines, xcss = _ref.xcss, children = _ref.children;
    (0, $fff3f31fc3bd4f88$export$2e2bcd8739ae039)($d7d9260459e6fa9f$var$asAllowlist.includes(Component), "@atlaskit/primitives: Text received an invalid \"as\" value of \"".concat(Component, "\""));
    var hasTextAncestor = (0, $f91e899f7870e2bd$export$9322276ec105d055)();
    var color = $d7d9260459e6fa9f$var$useColor(colorProp, hasTextAncestor);
    if (!size && !hasTextAncestor) size = 'medium';
    var component = /*#__PURE__*/ $5FkrB.createElement(Component, {
        id: id,
        className: (0, $c4f3fc62d4a10748$export$2e2bcd8739ae039)([
            $d7d9260459e6fa9f$var$styles.root,
            size && $d7d9260459e6fa9f$var$fontSizeMap[size],
            color && $d7d9260459e6fa9f$var$textColorMap[color],
            maxLines && $d7d9260459e6fa9f$var$styles.truncation,
            maxLines === 1 && $d7d9260459e6fa9f$var$styles.breakAll,
            align && $d7d9260459e6fa9f$var$styles["textAlign.".concat(align)],
            weight && $d7d9260459e6fa9f$var$fontWeightMap[weight],
            Component === 'em' && $d7d9260459e6fa9f$var$styles['as.em'],
            Component === 'strong' && $d7d9260459e6fa9f$var$styles['as.strong'],
            xcss
        ]),
        style: {
            WebkitLineClamp: maxLines
        },
        "data-testid": testId,
        ref: ref
    }, children);
    if (hasTextAncestor) // no need to re-apply context if the text is already wrapped
    return component;
    return /*#__PURE__*/ $5FkrB.createElement((0, $f91e899f7870e2bd$export$ae933c6cbe5643ad), {
        value: true
    }, component);
});
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$d7d9260459e6fa9f$export$2e2bcd8739ae039 = $d7d9260459e6fa9f$var$Text;


/* styled.tsx generated by @compiled/babel-plugin v0.39.1 */ 


var $5FkrB = parcelRequire("5FkrB");

var $7f774e76693038bc$var$_excluded = [
    "as",
    "style"
], $7f774e76693038bc$var$_excluded2 = [
    "as",
    "style"
], $7f774e76693038bc$var$_excluded3 = [
    "as",
    "style"
], $7f774e76693038bc$var$_excluded4 = [
    "as",
    "style"
], $7f774e76693038bc$var$_excluded5 = [
    "as",
    "style"
], $7f774e76693038bc$var$_excluded6 = [
    "as",
    "style"
], $7f774e76693038bc$var$_excluded7 = [
    "as",
    "style"
], $7f774e76693038bc$var$_excluded8 = [
    "as",
    "style"
], $7f774e76693038bc$var$_excluded9 = [
    "as",
    "style"
], $7f774e76693038bc$var$_excluded0 = [
    "as",
    "style"
], $7f774e76693038bc$var$_excluded1 = [
    "as",
    "style"
];
var $7f774e76693038bc$export$960a49cc3d27a090 = (0, $5FkrB.forwardRef)(function(_ref, __cmplr) {
    var _ref$as = _ref.as, C = _ref$as === void 0 ? "div" : _ref$as, __cmpls = _ref.style, __cmplp = (0, $b45e4aa52a06dd77$export$2e2bcd8739ae039)(_ref, $7f774e76693038bc$var$_excluded);
    return /*#__PURE__*/ $5FkrB.createElement(C, (0, $39cd338b0da6756c$export$2e2bcd8739ae039)({}, __cmplp, {
        style: __cmpls,
        ref: __cmplr,
        className: (0, $c4f3fc62d4a10748$export$2e2bcd8739ae039)([
            "_1e0c1txw _2lx2vrvc _1n261g80 _19pk1b66",
            __cmplp.className
        ])
    }));
});
var $7f774e76693038bc$export$585a3b23e887288b = (0, $5FkrB.forwardRef)(function(_ref2, __cmplr) {
    var _ref2$as = _ref2.as, C = _ref2$as === void 0 ? "span" : _ref2$as, __cmpls = _ref2.style, __cmplp = (0, $b45e4aa52a06dd77$export$2e2bcd8739ae039)(_ref2, $7f774e76693038bc$var$_excluded2);
    return /*#__PURE__*/ $5FkrB.createElement(C, (0, $39cd338b0da6756c$export$2e2bcd8739ae039)({}, __cmplp, {
        style: __cmpls,
        ref: __cmplr,
        className: (0, $c4f3fc62d4a10748$export$2e2bcd8739ae039)([
            "_11c81d4k _k48p1wq8 _vwz4gktf _y3gn1h6o _18u0u2gc _syazi7uo",
            __cmplp.className
        ])
    }));
});
var $7f774e76693038bc$export$696c00d897d9c72 = (0, $5FkrB.forwardRef)(function(_ref3, __cmplr) {
    var _ref3$as = _ref3.as, C = _ref3$as === void 0 ? "div" : _ref3$as, __cmpls = _ref3.style, __cmplp = (0, $b45e4aa52a06dd77$export$2e2bcd8739ae039)(_ref3, $7f774e76693038bc$var$_excluded3);
    return /*#__PURE__*/ $5FkrB.createElement(C, (0, $39cd338b0da6756c$export$2e2bcd8739ae039)({}, __cmplp, {
        style: __cmpls,
        ref: __cmplr,
        className: (0, $c4f3fc62d4a10748$export$2e2bcd8739ae039)([
            "_2lx2vrvc _i0dl1wug _syazi7uo _k48pi7a9",
            __cmplp.className
        ])
    }));
});
var $7f774e76693038bc$export$ab5d8615fe61a2fe = (0, $5FkrB.forwardRef)(function(_ref4, __cmplr) {
    var _ref4$as = _ref4.as, C = _ref4$as === void 0 ? "div" : _ref4$as, __cmpls = _ref4.style, __cmplp = (0, $b45e4aa52a06dd77$export$2e2bcd8739ae039)(_ref4, $7f774e76693038bc$var$_excluded4);
    return /*#__PURE__*/ $5FkrB.createElement(C, (0, $39cd338b0da6756c$export$2e2bcd8739ae039)({}, __cmplp, {
        style: __cmpls,
        ref: __cmplr,
        className: (0, $c4f3fc62d4a10748$export$2e2bcd8739ae039)([
            "_11c8fhey _syazazsu _k48p1wq8 _18u0xy5q",
            __cmplp.className
        ])
    }));
});
var $7f774e76693038bc$export$b74d34d7f4f81437 = (0, $5FkrB.forwardRef)(function(_ref5, __cmplr) {
    var _ref5$as = _ref5.as, C = _ref5$as === void 0 ? "div" : _ref5$as, __cmpls = _ref5.style, __cmplp = (0, $b45e4aa52a06dd77$export$2e2bcd8739ae039)(_ref5, $7f774e76693038bc$var$_excluded5);
    return /*#__PURE__*/ $5FkrB.createElement(C, (0, $39cd338b0da6756c$export$2e2bcd8739ae039)({}, __cmplp, {
        style: __cmpls,
        ref: __cmplr,
        className: (0, $c4f3fc62d4a10748$export$2e2bcd8739ae039)([
            "_1e0c1txw _2lx2vrvc _2hwx1b66 _1ep11lk2 _172p12x7",
            __cmplp.className
        ])
    }));
});
var $7f774e76693038bc$export$2d14d9a827f64bff = (0, $5FkrB.forwardRef)(function(_ref6, __cmplr) {
    var _ref6$as = _ref6.as, C = _ref6$as === void 0 ? "div" : _ref6$as, __cmpls = _ref6.style, __cmplp = (0, $b45e4aa52a06dd77$export$2e2bcd8739ae039)(_ref6, $7f774e76693038bc$var$_excluded6);
    return /*#__PURE__*/ $5FkrB.createElement(C, (0, $39cd338b0da6756c$export$2e2bcd8739ae039)({}, __cmplp, {
        style: __cmpls,
        ref: __cmplr,
        className: (0, $c4f3fc62d4a10748$export$2e2bcd8739ae039)([
            "_19pkpxbi _otyrpxbi",
            __cmplp.className
        ])
    }));
});
var $7f774e76693038bc$export$a2d061c2618a4908 = (0, $5FkrB.forwardRef)(function(_ref7, __cmplr) {
    var _ref7$as = _ref7.as, C = _ref7$as === void 0 ? "div" : _ref7$as, __cmpls = _ref7.style, __cmplp = (0, $b45e4aa52a06dd77$export$2e2bcd8739ae039)(_ref7, $7f774e76693038bc$var$_excluded7);
    return /*#__PURE__*/ $5FkrB.createElement(C, (0, $39cd338b0da6756c$export$2e2bcd8739ae039)({}, __cmplp, {
        style: __cmpls,
        ref: __cmplr,
        className: (0, $c4f3fc62d4a10748$export$2e2bcd8739ae039)([
            "_18u0u2gc",
            __cmplp.className
        ])
    }));
});
var $7f774e76693038bc$export$a1d70406c7c51a07 = (0, $5FkrB.forwardRef)(function(_ref8, __cmplr) {
    var _ref8$as = _ref8.as, C = _ref8$as === void 0 ? "ul" : _ref8$as, __cmpls = _ref8.style, __cmplp = (0, $b45e4aa52a06dd77$export$2e2bcd8739ae039)(_ref8, $7f774e76693038bc$var$_excluded8);
    return /*#__PURE__*/ $5FkrB.createElement(C, (0, $39cd338b0da6756c$export$2e2bcd8739ae039)({}, __cmplp, {
        style: __cmpls,
        ref: __cmplr,
        className: (0, $c4f3fc62d4a10748$export$2e2bcd8739ae039)([
            "_11cpu2gc _pnmbi7uo _1kepi7a9",
            __cmplp.className
        ])
    }));
});
var $7f774e76693038bc$export$ddac45c7d3a8e529 = (0, $5FkrB.forwardRef)(function(_ref9, __cmplr) {
    var _ref9$as = _ref9.as, C = _ref9$as === void 0 ? "div" : _ref9$as, __cmpls = _ref9.style, __cmplp = (0, $b45e4aa52a06dd77$export$2e2bcd8739ae039)(_ref9, $7f774e76693038bc$var$_excluded9);
    return /*#__PURE__*/ $5FkrB.createElement(C, (0, $39cd338b0da6756c$export$2e2bcd8739ae039)({}, __cmplp, {
        style: __cmpls,
        ref: __cmplr,
        className: (0, $c4f3fc62d4a10748$export$2e2bcd8739ae039)([
            "_ca0qu2gc _u5f3pxbi _19bvpxbi _y3gn1e5h",
            __cmplp.className
        ])
    }));
});
var $7f774e76693038bc$export$17d680238e50603e = (0, $5FkrB.forwardRef)(function(_ref0, __cmplr) {
    var _ref0$as = _ref0.as, C = _ref0$as === void 0 ? "hr" : _ref0$as, __cmpls = _ref0.style, __cmplp = (0, $b45e4aa52a06dd77$export$2e2bcd8739ae039)(_ref0, $7f774e76693038bc$var$_excluded0);
    return /*#__PURE__*/ $5FkrB.createElement(C, (0, $39cd338b0da6756c$export$2e2bcd8739ae039)({}, __cmplp, {
        style: __cmpls,
        ref: __cmplr,
        className: (0, $c4f3fc62d4a10748$export$2e2bcd8739ae039)([
            "_kqswstnw _1bsb1oh5 _4t3it94y _18u0ze3t _otyrxy5q _bfhk1l7x",
            __cmplp.className
        ])
    }));
});
var $7f774e76693038bc$export$588b9ad42f4f69ea = (0, $5FkrB.forwardRef)(function(_ref1, __cmplr) {
    var _ref1$as = _ref1.as, C = _ref1$as === void 0 ? "div" : _ref1$as, __cmpls = _ref1.style, __cmplp = (0, $b45e4aa52a06dd77$export$2e2bcd8739ae039)(_ref1, $7f774e76693038bc$var$_excluded1);
    return /*#__PURE__*/ $5FkrB.createElement(C, (0, $39cd338b0da6756c$export$2e2bcd8739ae039)({}, __cmplp, {
        style: __cmpls,
        ref: __cmplr,
        className: (0, $c4f3fc62d4a10748$export$2e2bcd8739ae039)([
            "_18u01b66 _19pkpxbi _otyrpxbi",
            __cmplp.className
        ])
    }));
});


var $2a7e5455add2565c$var$_excluded = [
    "id",
    "children",
    "svgBase64"
], $2a7e5455add2565c$var$_excluded2 = [
    "addresses"
];
var $2a7e5455add2565c$var$CSS_VAR_SMALL_DURATION = '--small-duration-ms';
var $2a7e5455add2565c$var$styles = {
    expanded: "_v5641py5 _t9ec14w8",
    button: "_ca0qu2gc _n3tdu2gc"
};
var $2a7e5455add2565c$var$titleStyles = null;
var $2a7e5455add2565c$var$permissionDetailsStyles = null;
var $2a7e5455add2565c$export$bddbba65b6fc456 = function DescriptionList(_ref) {
    var descriptions = _ref.descriptions;
    var listItems = descriptions.map(function(description) {
        var index = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("li", {
            key: index++
        }, " ", description);
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $7f774e76693038bc$export$a1d70406c7c51a07), null, listItems);
};
var $2a7e5455add2565c$export$157a117c5a4edc4 = function LineComponent() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $7f774e76693038bc$export$17d680238e50603e), {
        role: "presentation"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("br", null));
};
var $2a7e5455add2565c$export$9a20b1ab8f22ef92 = function PermissionsGroup(_ref2) {
    var icon = _ref2.icon, _ref2$defaultIsExpand = _ref2.defaultIsExpanded, defaultIsExpanded = _ref2$defaultIsExpand === void 0 ? false : _ref2$defaultIsExpand, _onClick = _ref2.onClick, action = _ref2.action, descriptions = _ref2.descriptions, children = _ref2.children, title = _ref2.title;
    var _useState = (0, $5FkrB.useState)(defaultIsExpanded), _useState2 = (0, $958636c847d8b316$export$2e2bcd8739ae039)(_useState, 2), isExpanded = _useState2[0], setIsExpanded = _useState2[1];
    var uid = (0, $8120b68af314e225$export$87d05f07e65211f1)();
    var ariaLabel = "".concat(typeof action === 'string' && action ? "".concat(action, ": ") : '').concat(title || 'Expand Permissions');
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $7f774e76693038bc$export$ab5d8615fe61a2fe), null, action, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $7f774e76693038bc$export$696c00d897d9c72), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $7f774e76693038bc$export$b74d34d7f4f81437), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $57aa7996868f4b18$export$2e2bcd8739ae039), {
        testId: "permission-button",
        "aria-expanded": isExpanded,
        "aria-label": ariaLabel,
        "aria-controls": "permission-expander-".concat(uid),
        id: "permission-btn-".concat(uid),
        appearance: "subtle",
        iconBefore: icon,
        onClick: function onClick(e) {
            setIsExpanded(!isExpanded);
            if (_onClick) _onClick(e, !isExpanded);
        },
        iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $13ab488c4f477874$export$2e2bcd8739ae039), {
            as: "span",
            xcss: isExpanded && $2a7e5455add2565c$var$styles.expanded
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($e4fc98ef5a8fd645$exports))), {
            color: "currentColor",
            spacing: "spacious",
            label: "",
            size: "small"
        }))
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("div", null, children)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $7f774e76693038bc$export$a2d061c2618a4908), {
        "data-testid": "permission-details",
        "aria-hidden": !isExpanded,
        id: "permission-expander-".concat(uid),
        "aria-labelledby": "permission-btn-".concat(uid)
    }, isExpanded ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $7f774e76693038bc$export$ddac45c7d3a8e529), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement($2a7e5455add2565c$export$bddbba65b6fc456, {
        descriptions: descriptions
    })) : null)));
};
var $2a7e5455add2565c$export$5b338f9f41e1d1d9 = function ProductPermission(_ref3) {
    var service = _ref3.service, scopes = _ref3.scopes, svgBase64 = _ref3.svgBase64, onClick = _ref3.onClick;
    var Icon = $2a7e5455add2565c$export$ae918fb479a8569f(service);
    var icon = svgBase64 ? /*#__PURE__*/ // eslint-disable-next-line @atlassian/a11y/alt-text
    (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("img", {
        src: svgBase64,
        style: {
            width: '24px'
        },
        "aria-hidden": true,
        "data-testid": "".concat(service, "-icon"),
        id: "".concat(service, "-icon")
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(Icon, {
        label: "",
        size: "small",
        appearance: "brand"
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $7f774e76693038bc$export$2d14d9a827f64bff), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $7f774e76693038bc$export$960a49cc3d27a090), null, icon, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $7f774e76693038bc$export$585a3b23e887288b), null, "In ", $2a7e5455add2565c$var$convertFirstCharToUpperCase(service), ", it would like to:")), scopes.map(function(entry) {
        var index = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
        var title = entry.entities.join(', ');
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement($2a7e5455add2565c$export$9a20b1ab8f22ef92, {
            action: $2a7e5455add2565c$export$1d2a3f0ca3c37a64(entry.action),
            descriptions: entry.descriptions,
            key: index++,
            children: title,
            onClick: onClick,
            title: title
        });
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement($2a7e5455add2565c$export$157a117c5a4edc4, null));
};
var $2a7e5455add2565c$export$b92654cb91befde = function isSingleWildCardDomain(domains) {
    return domains.findIndex(function(n) {
        return n === '*';
    }) >= 0;
};
var $2a7e5455add2565c$export$8022fa18b5d96c35 = function getEgressPermissionHeaderMessage(app, noun, domains) {
    if (domains.length === 0) return "".concat(app, " cannot send data to any location");
    return $2a7e5455add2565c$export$b92654cb91befde(domains) ? "".concat(app, " can send data to any domain") : "".concat(app, " can send data to the following ").concat(noun, ":");
};
var $2a7e5455add2565c$export$72d8f009a0e9a42b = function pluralizeWord(count, noun) {
    var suffix = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 's';
    return "".concat(noun).concat(count > 1 ? suffix : '');
};
var $2a7e5455add2565c$export$81c2233c26f0f49f = function EgressPermission(_ref4) {
    var app = _ref4.app, addresses = _ref4.addresses;
    var domainList = addresses && addresses.length ? $2a7e5455add2565c$export$5740265f783609a2(addresses) : [];
    var domainNoun = $2a7e5455add2565c$export$72d8f009a0e9a42b(domainList.length, 'domain');
    var message = "".concat(domainList.length, " external ").concat(domainNoun);
    var headerMessage = $2a7e5455add2565c$export$8022fa18b5d96c35(app, domainNoun, addresses);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $7f774e76693038bc$export$588b9ad42f4f69ea), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $7f774e76693038bc$export$960a49cc3d27a090), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $7f774e76693038bc$export$585a3b23e887288b), null, headerMessage)), addresses.length > 0 && !$2a7e5455add2565c$export$b92654cb91befde(addresses) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement($2a7e5455add2565c$export$9a20b1ab8f22ef92, {
        descriptions: domainList,
        action: "",
        children: message,
        title: message
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement($2a7e5455add2565c$export$157a117c5a4edc4, null));
};
var $2a7e5455add2565c$export$a461eaf23bef603e = function Permission(_ref5) {
    var title = _ref5.title, icon = _ref5.icon, children = _ref5.children, _ref5$defaultIsExpand = _ref5.defaultIsExpanded, defaultIsExpanded = _ref5$defaultIsExpand === void 0 ? false : _ref5$defaultIsExpand, _onClick2 = _ref5.onClick;
    var _useState3 = (0, $5FkrB.useState)(defaultIsExpanded), _useState4 = (0, $958636c847d8b316$export$2e2bcd8739ae039)(_useState3, 2), isExpanded = _useState4[0], setIsExpanded = _useState4[1];
    var uid = (0, $8120b68af314e225$export$87d05f07e65211f1)();
    var ariaLabel = "".concat(typeof title === 'string' && title ? title : 'Expand scope');
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $13ab488c4f477874$export$2e2bcd8739ae039), {
        xcss: $2a7e5455add2565c$var$styles.button
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $57aa7996868f4b18$export$2e2bcd8739ae039), {
        testId: "permission-button",
        "aria-expanded": isExpanded,
        "aria-label": ariaLabel,
        "aria-controls": "permission-expander-".concat(uid),
        appearance: "subtle",
        shouldFitContainer: true,
        iconBefore: icon,
        id: "permission-btn-".concat(uid),
        onClick: function onClick(e) {
            setIsExpanded(!isExpanded);
            if (_onClick2) _onClick2(e, !isExpanded);
        },
        iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $13ab488c4f477874$export$2e2bcd8739ae039), {
            as: "span",
            xcss: isExpanded && $2a7e5455add2565c$var$styles.expanded
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($e4fc98ef5a8fd645$exports))), {
            color: "currentColor",
            spacing: "spacious",
            label: "",
            size: "small"
        }))
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("div", {
        className: (0, $c4f3fc62d4a10748$export$2e2bcd8739ae039)([
            "_u5f3u2gc _19bvu2gc _y3gn1e5h"
        ])
    }, title)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("div", {
        "data-testid": "permission-details",
        "aria-hidden": !isExpanded,
        id: "permission-expander-".concat(uid),
        "aria-labelledby": "permission-btn-".concat(uid)
    }, isExpanded ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("div", {
        className: (0, $c4f3fc62d4a10748$export$2e2bcd8739ae039)([
            "_ca0qu2gc _19bvoahv _u5f3oahv _y3gn1e5h"
        ])
    }, children) : null));
};
var $2a7e5455add2565c$export$775b6bb06e53a214 = function Scope(_ref6) {
    var id = _ref6.id, children = _ref6.children, svgBase64 = _ref6.svgBase64, others = (0, $b45e4aa52a06dd77$export$2e2bcd8739ae039)(_ref6, $2a7e5455add2565c$var$_excluded);
    var Icon = function() {
        if (id.indexOf('confluence') !== -1) return 0, $eed13112ef66c96f$export$68f3db7f6af48bcb;
        if (id.indexOf('compass') !== -1) return 0, $142d7f6a932ec35d$export$f7857fe64d7161d9;
        if (id.indexOf('jira-software') !== -1) return 0, $cf8b1509548178c1$export$c3835feba2a66e67;
        if (id.indexOf('jira') !== -1) return 0, $142d7f6a932ec35d$export$c4b5b1f965d8b3eb;
        return 0, $8615bffe2d1537f6$export$8a485e2e7ed91e8f;
    }();
    var icon = svgBase64 ? /*#__PURE__*/ // eslint-disable-next-line @atlassian/a11y/alt-text
    (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("img", {
        src: svgBase64,
        style: {
            width: '24px'
        },
        "aria-hidden": true,
        "data-testid": id,
        id: id
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(Icon, {
        label: "",
        size: "small",
        appearance: "brand"
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement($2a7e5455add2565c$export$a461eaf23bef603e, (0, $39cd338b0da6756c$export$2e2bcd8739ae039)({
        icon: icon
    }, others), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $d7d9260459e6fa9f$export$2e2bcd8739ae039), {
        as: "p"
    }, children));
};
var $2a7e5455add2565c$export$5740265f783609a2 = function addSubdomainMessage(domains) {
    var wildcarded = domains.filter(function(domain) {
        return domain.startsWith('*');
    });
    var specific = new Set(domains.filter(function(domain) {
        return !domain.startsWith('*');
    }));
    var domainList = [];
    wildcarded.forEach(function(domain) {
        if (specific.has(domain.substring(2))) {
            domainList.push("".concat(domain.substring(2), " and any of its subdomains"));
            specific.delete(domain.substring(2));
        } else if (domain !== '*') domainList.push("only subdomains of ".concat(domain.substring(2)));
    });
    domainList.push.apply(domainList, (0, $4a517cd18e4d856d$export$2e2bcd8739ae039)(specific));
    return domainList;
};
var $2a7e5455add2565c$export$cf682fd62a8d6c6f = function getEgressPermissionTitle(domains) {
    return domains.includes('*') ? "Share data with unlimited locations outside of Atlassian." : "Share data with ".concat(domains.length, " domain").concat(domains.length === 1 ? '' : 's', " outside of Atlassian.");
};
var $2a7e5455add2565c$export$31ad2db69838e72c = function getEgressPermissionDescription(domains) {
    return domains.includes('*') ? 'The app may share personal data outside of Atlassian cloud to unlimited locations on the internet. This may be required for the app to fetch data from user-defined sources, though this can put your data privacy at risk.' : 'This allows the app to share personal data outside of Atlassian cloud via the following domains:';
};
var $2a7e5455add2565c$export$47c3fa86df51710a = function Egress(_ref7) {
    var addresses = _ref7.addresses, others = (0, $b45e4aa52a06dd77$export$2e2bcd8739ae039)(_ref7, $2a7e5455add2565c$var$_excluded2);
    var title = $2a7e5455add2565c$export$cf682fd62a8d6c6f(addresses);
    var domainList = addresses && addresses.length ? $2a7e5455add2565c$export$5740265f783609a2(addresses) : [];
    return addresses.length > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement($2a7e5455add2565c$export$a461eaf23bef603e, (0, $39cd338b0da6756c$export$2e2bcd8739ae039)({
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1adac64b26b6e361$exports))), {
            color: "currentColor",
            label: ""
        }),
        title: title
    }, others), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $d7d9260459e6fa9f$export$2e2bcd8739ae039), {
        as: "p"
    }, $2a7e5455add2565c$export$31ad2db69838e72c(addresses)), !addresses.includes('*') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("ul", null, domainList.map(function(egressDomain, index) {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("li", {
            key: index.toString()
        }, egressDomain);
    })) : null) : null;
};
var $2a7e5455add2565c$export$ae918fb479a8569f = function typeofIcon(id) {
    if (id.indexOf('confluence') !== -1) return 0, $eed13112ef66c96f$export$68f3db7f6af48bcb;
    if (id.indexOf('compass') !== -1) return 0, $142d7f6a932ec35d$export$f7857fe64d7161d9;
    if (id.indexOf('jira-software') !== -1) return 0, $cf8b1509548178c1$export$c3835feba2a66e67;
    if (id.indexOf('jira') !== -1) return 0, $142d7f6a932ec35d$export$c4b5b1f965d8b3eb;
    return 0, $8615bffe2d1537f6$export$8a485e2e7ed91e8f;
};
var $2a7e5455add2565c$export$1d2a3f0ca3c37a64 = function typeofAction(action) {
    switch(action){
        case 'read':
            return 'View';
        case 'write':
            return 'Update';
        case 'global':
            return 'Update';
        default:
            return $2a7e5455add2565c$var$convertFirstCharToUpperCase(action);
    }
};
var $2a7e5455add2565c$var$convertFirstCharToUpperCase = function convertFirstCharToUpperCase(input) {
    return input.charAt(0).toUpperCase() + input.slice(1);
};



const $8c15e6225feca7b4$var$Scopes = ()=>{
    const groupScopes = [
        {
            service: 'testservice',
            scopes: [
                {
                    action: 'read',
                    entities: [
                        'entity1',
                        'entity2'
                    ],
                    descriptions: [
                        'Read access to entity1',
                        'Read access to entity2'
                    ]
                },
                {
                    action: 'write',
                    entities: [
                        'entity3'
                    ],
                    descriptions: [
                        'Write access to entity3'
                    ]
                }
            ],
            serviceDisplayName: 'Test Service'
        }
    ];
    return /*#__PURE__*/ (0, $i3UfC.jsx)((0, $383dd904a5a5e5b0$export$e71c4d32a2263218), {
        children: /*#__PURE__*/ (0, $i3UfC.jsx)((0, $2a7e5455add2565c$export$5b338f9f41e1d1d9), {
            service: 'Example service',
            scopes: groupScopes[0].scopes
        })
    });
};
var $8c15e6225feca7b4$export$2e2bcd8739ae039 = $8c15e6225feca7b4$var$Scopes;



var $i3UfC = parcelRequire("i3UfC");

var $i3UfC = parcelRequire("i3UfC");

/* Logo.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $i3UfC = parcelRequire("i3UfC");
parcelRequire("5FkrB");

var $5FkrB = parcelRequire("5FkrB");

/**
 * @see https://github.com/jsdom/jsdom/releases/tag/12.0.0
 * @see https://github.com/jsdom/jsdom/issues/1537
 */ 
var $3ZMUU = parcelRequire("3ZMUU");
const $4b30ae76ef8348df$var$isJsDomEnvironment = ()=>window.name === 'nodejs' || (navigator === null || navigator === void 0 ? void 0 : navigator.userAgent.includes('Node.js')) || (navigator === null || navigator === void 0 ? void 0 : navigator.userAgent.includes('jsdom'));
const $4b30ae76ef8348df$export$455cc18296abe008 = ()=>{
    if (typeof window === 'undefined' || typeof $3ZMUU !== 'undefined' && $3ZMUU.versions != null && $3ZMUU.versions.node != null) return true;
    if ($4b30ae76ef8348df$var$isJsDomEnvironment()) return true;
    return false;
};


/**
 * Cache to hold already used styles.
 * React Context on the server - singleton object on the client.
 */ const $dbdf44c207cf40e4$var$Cache = (0, $4b30ae76ef8348df$export$455cc18296abe008)() ? (0, $5FkrB.createContext)(null) : {};
if (!(0, $4b30ae76ef8348df$export$455cc18296abe008)() && typeof document !== 'undefined') {
    /**
     * Iterates through all found style elements generated when server side rendering.
     *
     * @param cb
     */ const ssrStyles = document.querySelectorAll('style[data-cmpld]');
    for(let i = 0; i < ssrStyles.length; i++)// Move all found server-side rendered style elements to the head before React hydration happens.
    document.head.appendChild(ssrStyles[i]);
}
const $dbdf44c207cf40e4$export$c6e89b6bb9436bc0 = ()=>{
    if ((0, $4b30ae76ef8348df$export$455cc18296abe008)()) // On the server we use React Context to we don't leak the cache between SSR calls.
    // During runtime this hook isn't conditionally called - it is at build time that the flow gets decided.
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return (0, $5FkrB.useContext)($dbdf44c207cf40e4$var$Cache) || {};
    // On the client we use the object singleton.
    return $dbdf44c207cf40e4$var$Cache;
};
/**
 * On the server this ensures the minimal amount of styles will be rendered
 * safely using React Context.
 *
 * On the browser this turns into a fragment with no React Context.
 */ const $dbdf44c207cf40e4$var$StyleCacheProvider = (props)=>{
    if ((0, $4b30ae76ef8348df$export$455cc18296abe008)()) {
        // This code path isn't conditionally called at build time - safe to ignore.
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const inserted = $dbdf44c207cf40e4$export$c6e89b6bb9436bc0();
        return $5FkrB.createElement($dbdf44c207cf40e4$var$Cache.Provider, {
            value: inserted
        }, props.children);
    }
    return props.children;
};
var $dbdf44c207cf40e4$export$2e2bcd8739ae039 = $dbdf44c207cf40e4$var$StyleCacheProvider;


var $5FkrB = parcelRequire("5FkrB");



// Copied from packages/utils/src/shorthand.ts so that we avoid
// inflating the bundle size of @compiled/react/runtime with the contents
// of @compiled/utils
//
// Keep this `shorthandBuckets` in sync with the `shorthandBuckets` defined in
// packages/utils/src/shorthand.ts
const $9e2ee413d6194e52$var$shorthandBuckets = {
    all: 0,
    animation: 1,
    'animation-range': 1,
    background: 1,
    border: 1,
    'border-color': 2,
    'border-style': 2,
    'border-width': 2,
    'border-block': 3,
    'border-inline': 3,
    'border-top': 4,
    'border-right': 4,
    'border-bottom': 4,
    'border-left': 4,
    'border-block-start': 5,
    'border-block-end': 5,
    'border-inline-start': 5,
    'border-inline-end': 5,
    'border-image': 1,
    'border-radius': 1,
    'column-rule': 1,
    columns: 1,
    'contain-intrinsic-size': 1,
    container: 1,
    flex: 1,
    'flex-flow': 1,
    font: 1,
    'font-synthesis': 1,
    'font-variant': 2,
    gap: 1,
    grid: 1,
    'grid-area': 1,
    'grid-column': 2,
    'grid-row': 2,
    'grid-template': 2,
    inset: 1,
    'inset-block': 2,
    'inset-inline': 2,
    'list-style': 1,
    margin: 1,
    'margin-block': 2,
    'margin-inline': 2,
    mask: 1,
    'mask-border': 1,
    offset: 1,
    outline: 1,
    overflow: 1,
    'overscroll-behavior': 1,
    padding: 1,
    'padding-block': 2,
    'padding-inline': 2,
    'place-content': 1,
    'place-items': 1,
    'place-self': 1,
    'position-try': 1,
    'scroll-margin': 1,
    'scroll-margin-block': 2,
    'scroll-margin-inline': 2,
    'scroll-padding': 1,
    'scroll-padding-block': 2,
    'scroll-padding-inline': 2,
    'scroll-timeline': 1,
    'text-decoration': 1,
    'text-emphasis': 1,
    'text-wrap': 1,
    transition: 1,
    'view-timeline': 1
};
const $9e2ee413d6194e52$export$b08836c779543dbf = (shorthand)=>{
    var _a;
    return (_a = $9e2ee413d6194e52$var$shorthandBuckets[shorthand]) !== null && _a !== void 0 ? _a : null;
};


const $3e0ff02e8fb4cba2$export$8394bdfbee416ca4 = [
    // shorthand properties
    's-0',
    's-1',
    's-2',
    's-3',
    's-4',
    's-5',
    // catch-all
    '',
    // link
    'l',
    // visited
    'v',
    // focus-within
    'w',
    // focus
    'f',
    // focus-visible
    'i',
    // hover
    'h',
    // active
    'a',
    // at-rules
    'm',
    // non-atomic `cssMapScoped` (`.cc-…`) rules — MUST live in a dedicated
    // `<style>` element (never shared with the atomic catch-all `''` bucket
    // or any other atomic bucket). In production, atomic rules are injected
    // via `sheet.insertRule()` (CSSOM-only, `textContent` stays empty).
    // Non-atomic rules are injected via `Text.appendData()` on the same node,
    // which — if it were the same element — would force the browser to reparse
    // the sheet from text and DISCARD every previously `insertRule`-inserted
    // rule (a full style wipe). Keeping `cc` in its own bucket guarantees the
    // two insertion strategies never target the same DOM node. Placed last so
    // `.cc-` rules cascade after all atomic rules (matches previous behaviour
    // where they were appended to the shared catch-all bucket).
    'cc'
];
/**
 * Holds all style buckets in memory that have been added to the head.
 */ const $3e0ff02e8fb4cba2$var$styleBucketsInHead = {};
/**
 * Maps the long pseudo name to the short pseudo name.
 * Pseudos that match here will be ordered,
 * everything else will make their way to the catch all style bucket.
 * We reduce the pseudo name to save bundlesize.
 * Thankfully there aren't any overlaps, see: https://developer.mozilla.org/en-US/docs/Web/CSS/Pseudo-classes.
 */ const $3e0ff02e8fb4cba2$var$pseudosMap = {
    // link
    k: 'l',
    // visited
    ited: 'v',
    // focus-within
    'us-within': 'w',
    // focus
    us: 'f',
    // focus-visible
    'us-visible': 'i',
    // hover
    er: 'h',
    // active
    ive: 'a'
};
/**
 * Holds style buckets per custom container (e.g. a ShadowRoot), keyed by the
 * container DOM node. Uses WeakMap so entries are garbage collected when the
 * container is removed from the page.
 */ const $3e0ff02e8fb4cba2$var$styleBucketsByContainer = new WeakMap();
/**
 * Lazily adds a `<style>` bucket to a container, defaulting to `the `<head>`
 * when no container is provided in opts. Ensures style buckets are inserted in
 * the correct order regardless of the target container.
 *
 * Each custom container (e.g. a ShadowRoot) gets its own independent set of
 * buckets via the WeakMap — the main document singleton is unaffected.
 *
 * @param bucketName Bucket to insert into the container.
 * @param opts StyleSheetOpts optionally including a custom container.
 */ function $3e0ff02e8fb4cba2$var$lazyAddStyleBucketToContainer(bucketName, opts) {
    var _a;
    const target = (_a = opts.container) !== null && _a !== void 0 ? _a : document.head;
    let buckets;
    if (opts.container) {
        if (!$3e0ff02e8fb4cba2$var$styleBucketsByContainer.has(opts.container)) $3e0ff02e8fb4cba2$var$styleBucketsByContainer.set(opts.container, {});
        buckets = $3e0ff02e8fb4cba2$var$styleBucketsByContainer.get(opts.container);
    } else buckets = $3e0ff02e8fb4cba2$var$styleBucketsInHead;
    if (!buckets[bucketName]) {
        let currentBucketIndex = $3e0ff02e8fb4cba2$export$8394bdfbee416ca4.indexOf(bucketName) + 1;
        let nextBucketFromCache = null;
        // Find the next bucket which we will add our new style bucket before.
        for(; currentBucketIndex < $3e0ff02e8fb4cba2$export$8394bdfbee416ca4.length; currentBucketIndex++){
            const nextBucket = buckets[$3e0ff02e8fb4cba2$export$8394bdfbee416ca4[currentBucketIndex]];
            if (nextBucket) {
                nextBucketFromCache = nextBucket;
                break;
            }
        }
        const tag = document.createElement('style');
        opts.nonce && tag.setAttribute('nonce', opts.nonce);
        tag.appendChild(document.createTextNode(''));
        target.insertBefore(tag, nextBucketFromCache);
        buckets[bucketName] = tag;
    }
    return buckets[bucketName];
}
/**
 * Returns true when `characterCode` is a CSS selector delimiter that can appear
 * immediately after an atomic class name — i.e. a character that marks the end of
 * the class token. Covers the declaration block (`{`), pseudo (`:`), attribute
 * (`[`), class/id qualifiers (`.`/`#`), combinators (space/`>`/`+`/`~`), and the
 * selector-list separator (`,`). Operates on character codes (not substrings) to
 * stay allocation-free on the runtime hot path.
 */ const $3e0ff02e8fb4cba2$var$isClassBoundary = (characterCode)=>characterCode === 58 /* ":" */  || characterCode === 123 /* "{" */  || characterCode === 91 /* "[" */  || characterCode === 46 /* "." */  || characterCode === 35 /* "#" */  || characterCode === 32 /* " " */  || characterCode === 62 /* ">" */  || characterCode === 43 /* "+" */  || characterCode === 126 /* "~" */  || characterCode === 44; /* "," */ 
const $3e0ff02e8fb4cba2$export$d90f6836ea1aee93 = (sheet)=>{
    // We are grouping all the at-rules like @media, @supports etc under `m` bucket.
    if (sheet.charCodeAt(0) === 64 /* "@" */ ) return 'm';
    const firstBracket = sheet.indexOf('{');
    /**
     * Atomic class names are either 9 chars (legacy hash: `_` + 8) or 11 chars
     * (collisionResistantHash: `_` + 10). We only need to know where the class token
     * ends so the pseudo (if any) can be read relative to that boundary.
     *
     * Since exactly two widths exist, inspecting index 10 is sufficient: if it holds
     * a CSS selector delimiter, the class ended at 9 chars; otherwise index 10 is
     * still a hash character and the class is the 11-char form (boundary at index 12).
     *
     * We test for a delimiter (`isClassBoundary`) rather than the hash alphabet: the
     * question is "did the class token end?", not "which characters did the hasher
     * emit?". This keeps the legacy 9-char path correct for every continuation
     * (`:`, `{`, `[`, `.`, `#`, space, `>`, `+`, `~`, `,`), where a delimiter-poor
     * check would misread e.g. `._legacyhsh a:visited` as an 11-char class.
     */ const classEnd = $3e0ff02e8fb4cba2$var$isClassBoundary(sheet.charCodeAt(10)) ? 10 : 12;
    if (sheet.charCodeAt(classEnd) === 58 /* ":" */ ) {
        // We send through a subset of the string instead of the full pseudo name:
        // drop the colon plus the first three characters, e.g. `"focus-visible"`
        // becomes `"us-visible"`. Compound selectors slice an unmapped fragment
        // (e.g. `"ited:hover"`) and so fall through to the catch-all bucket, matching
        // the legacy behavior. Return a mapped pseudo else the default catch all bucket.
        const mapped = $3e0ff02e8fb4cba2$var$pseudosMap[sheet.slice(classEnd + 4, firstBracket)];
        if (mapped) return mapped;
    }
    const property = sheet.slice(firstBracket + 1, sheet.indexOf(':', firstBracket)).trim();
    const shorthandDepth = (0, $9e2ee413d6194e52$export$b08836c779543dbf)(property);
    if (typeof shorthandDepth === 'number') return `s-${shorthandDepth}`;
    // Return default catch all bucket
    return '';
};
function $3e0ff02e8fb4cba2$export$2e2bcd8739ae039(css, opts) {
    const bucketName = $3e0ff02e8fb4cba2$export$d90f6836ea1aee93(css);
    const style = $3e0ff02e8fb4cba2$var$lazyAddStyleBucketToContainer(bucketName, opts);
    const sheet = style.sheet;
    // Used to avoid unhandled exceptions across browsers with prefixed selectors such as -moz-placeholder.
    try {
        sheet.insertRule(css, sheet.cssRules.length);
    } catch (_a) {}
}
function $3e0ff02e8fb4cba2$export$2f01f8749482f7ab(css, opts) {
    // Use the dedicated 'cc' bucket to (a) preserve source-order cascade for the
    // multi-rule `cssMapScoped` payload, and (b) guarantee we never mutate the text
    // node of any atomic bucket's `<style>` element. `insertRule` only accepts a
    // single rule per call, so we use `Text.appendData` — it appends to an existing
    // text node in a single DOM mutation (no new text node creation, no parsing
    // limits, accepts multi-rule strings).
    const style = $3e0ff02e8fb4cba2$var$lazyAddStyleBucketToContainer('cc', opts);
    const text = style.firstChild;
    if (text) text.appendData(css);
    else style.appendChild(document.createTextNode(css));
}




var $5FkrB = parcelRequire("5FkrB");

let $096268d0d43c76e0$export$1c617ef0fac4c274 = null;
const $096268d0d43c76e0$export$27c28af7c58fc6b4 = ()=>{
    return $096268d0d43c76e0$export$1c617ef0fac4c274;
};
function $096268d0d43c76e0$export$c2e7cf7518b34f16({ container: container, cacheKey: cacheKey, children: children }) {
    if ((0, $4b30ae76ef8348df$export$455cc18296abe008)()) return children;
    // On the client, set the singleton synchronously during the render phase via
    // useMemo so CS children pick it up immediately.
    // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).useMemo(()=>{
        $096268d0d43c76e0$export$1c617ef0fac4c274 = {
            container: container,
            cacheKey: cacheKey
        };
    }, [
        container,
        cacheKey
    ]);
    // Clear the singleton when this provider unmounts.
    // Note: nested StyleContainerProviders are not supported. If an inner provider
    // unmounts, this will clear clientStyleContainer to null rather than restoring
    // the outer provider's value. This is an acceptable limitation for the intended
    // use case of a single provider wrapping a shadow DOM subtree.
    // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).useEffect(()=>{
        return ()=>{
            $096268d0d43c76e0$export$1c617ef0fac4c274 = null;
        };
    }, []);
    return children;
}


/**
 * Returns true if the CSS sheet string is a non-atomic rule generated by
 * `cssMapScoped`. Non-atomic rules use the `cc-` class prefix.
 * Uses `includes` rather than `startsWith` to also match at-rule-wrapped
 * non-atomic rules like `@media{.cc-xxx{...}}` or `@container{.cc-xxx{...}}`.
 */ const $c179d2a16dc49323$var$isNonAtomicSheet = (sheet)=>sheet.includes('.cc-');
function $c179d2a16dc49323$export$2e2bcd8739ae039(props) {
    const inserted = (0, $dbdf44c207cf40e4$export$c6e89b6bb9436bc0)();
    const styleContainer = (0, $096268d0d43c76e0$export$27c28af7c58fc6b4)();
    if (props.children.length) {
        if ((0, $4b30ae76ef8348df$export$455cc18296abe008)()) {
            const bucketedSheets = {};
            let hasSheets = false;
            for(let i = 0; i < props.children.length; i++){
                const sheet = props.children[i];
                if (inserted[sheet]) continue;
                else {
                    inserted[sheet] = true;
                    hasSheets = true;
                }
                // Non-atomic rules (cc- prefix from cssMapScoped) go into a
                // dedicated 'cc' bucket. Keeping them in their own bucket:
                //   1. Preserves source-order cascade for the multi-rule payload
                //      (the bucket is text-appended in insertion order).
                //   2. On the client, guarantees the runtime never mixes CSSOM
                //      `insertRule` (atomic buckets, production) with `Text.appendData`
                //      (non-atomic bucket) on the same `<style>` element — the mixing
                //      that causes a full style wipe when a large `.cc-` sheet is
                //      injected after atomic rules. See sheet.ts `insertNonAtomicRule`.
                // On the server, the isolation matters less (we render into a single
                // `<style>`), but we keep the same bucket key so SSR and CSR agree.
                const bucketName = $c179d2a16dc49323$var$isNonAtomicSheet(sheet) ? 'cc' : (0, $3e0ff02e8fb4cba2$export$d90f6836ea1aee93)(sheet);
                bucketedSheets[bucketName] = (bucketedSheets[bucketName] || '') + sheet;
            }
            if (!hasSheets) return null;
            return (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("style", {
                "data-cmpld": true,
                nonce: props.nonce,
                dangerouslySetInnerHTML: {
                    __html: (0, $3e0ff02e8fb4cba2$export$8394bdfbee416ca4).map((bucket)=>bucketedSheets[bucket]).join('')
                }
            });
        } else {
            const opts = styleContainer ? Object.assign(Object.assign({}, props), {
                container: styleContainer.container,
                cacheKey: styleContainer.cacheKey
            }) : props;
            for(let i = 0; i < props.children.length; i++){
                const sheet = props.children[i];
                // When a container is active, namespace the cache key so this container's
                // inserted records are tracked independently from the main document cache.
                const cacheKey = styleContainer ? `${styleContainer.cacheKey}:${sheet}` : sheet;
                if (inserted[cacheKey]) continue;
                inserted[cacheKey] = true;
                // Non-atomic rules (cc- prefix from cssMapScoped) must bypass the
                // shorthand bucket sorting logic — they contain multiple declarations per rule
                // and must preserve source-order cascade within the catch-all bucket.
                if ($c179d2a16dc49323$var$isNonAtomicSheet(sheet)) (0, $3e0ff02e8fb4cba2$export$2f01f8749482f7ab)(sheet, opts);
                else (0, $3e0ff02e8fb4cba2$export$2e2bcd8739ae039)(sheet, opts);
            }
        }
    }
    return null;
}


const $6246c410b8633576$var$_2 = "._1bsbckbl{width:3pc}";
const $6246c410b8633576$var$_ = "._2rkolb4i{border-radius:var(--ds-radius-xsmall,2px)}";
const $6246c410b8633576$var$AVATAR_URL = 'https://cdn.jim-nielsen.com/ios/512/facebook-2019-05-21.png?rf=1024';
const $6246c410b8633576$var$styles = {
    image: "_2rkolb4i _1bsbckbl"
};
const $6246c410b8633576$var$Logo = ()=>/*#__PURE__*/ (0, $i3UfC.jsxs)((0, $dbdf44c207cf40e4$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $i3UfC.jsx)((0, $c179d2a16dc49323$export$2e2bcd8739ae039), {
                children: [
                    $6246c410b8633576$var$_,
                    $6246c410b8633576$var$_2
                ]
            }),
            /*#__PURE__*/ (0, $i3UfC.jsx)("img", {
                src: $6246c410b8633576$var$AVATAR_URL,
                className: (0, $b02ab0e3a0f362dd$export$2e2bcd8739ae039)([
                    $6246c410b8633576$var$styles.image
                ])
            })
        ]
    });
var $6246c410b8633576$export$2e2bcd8739ae039 = $6246c410b8633576$var$Logo;


/* Arrows.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $i3UfC = parcelRequire("i3UfC");
parcelRequire("5FkrB");

var $dbb66ba1f61af10a$exports = {};
$dbb66ba1f61af10a$exports = new URL("arrow.91c625e6.svg", import.meta.url).toString();




var $5FkrB = parcelRequire("5FkrB");

var $2nBsU = parcelRequire("2nBsU");

var $gDiFE = parcelRequire("gDiFE");

var $c8dbef6c41cfa689$var$flexGrowMap = {
    hug: (0, $gDiFE.xcss)({
        flexGrow: 0
    }),
    fill: (0, $gDiFE.xcss)({
        width: '100%',
        flexGrow: 1
    })
};
var $c8dbef6c41cfa689$export$694e0d28c7ffc90c = /*#__PURE__*/ (0, $5FkrB.memo)(/*#__PURE__*/ (0, $5FkrB.forwardRef)(function(_ref, ref) {
    var as = _ref.as, alignItems = _ref.alignInline, _ref$alignBlock = _ref.alignBlock, alignBlock = _ref$alignBlock === void 0 ? 'stretch' : _ref$alignBlock, spread = _ref.spread, grow = _ref.grow, space = _ref.space, children = _ref.children, testId = _ref.testId, xcss = _ref.xcss, role = _ref.role, id = _ref.id;
    var justifyContent = spread || alignBlock;
    // We're type coercing this as Compiled styles in an array isn't supported by the types
    // But the runtime accepts it none-the-wiser. We can remove this entire block and replace
    // it with cx(defaultStyles, focusRingStyles, xcssStyles) when we've moved away from Emotion.
    var styles = grow ? [
        $c8dbef6c41cfa689$var$flexGrowMap[grow]
    ].concat((0, $05828ba174ac1fc0$export$2e2bcd8739ae039)(Array.isArray(xcss) ? xcss : [
        xcss
    ])) : xcss;
    return (0, $2nBsU.jsx)((0, $1b254ba6a068f2f1$export$f51f4c4ede09e011), {
        id: id,
        as: as,
        role: role,
        gap: space,
        direction: "column",
        alignItems: alignItems,
        justifyContent: justifyContent,
        xcss: styles,
        testId: testId,
        ref: ref
    }, children);
}));
$c8dbef6c41cfa689$export$694e0d28c7ffc90c.displayName = 'Stack';
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$c8dbef6c41cfa689$export$2e2bcd8739ae039 = $c8dbef6c41cfa689$export$694e0d28c7ffc90c;


const $187eceff84f1477d$var$_ = "._t9ec1sub{transform:rotate(180deg)}";
const $187eceff84f1477d$var$styles = {
    flip: "_t9ec1sub"
};
const $187eceff84f1477d$export$b6e350ab9915297a = ()=>{
    return /*#__PURE__*/ (0, $i3UfC.jsxs)((0, $c8dbef6c41cfa689$export$694e0d28c7ffc90c), {
        space: 'space.100',
        children: [
            /*#__PURE__*/ (0, $i3UfC.jsxs)((0, $dbdf44c207cf40e4$export$2e2bcd8739ae039), {
                children: [
                    /*#__PURE__*/ (0, $i3UfC.jsx)((0, $c179d2a16dc49323$export$2e2bcd8739ae039), {
                        children: [
                            $187eceff84f1477d$var$_
                        ]
                    }),
                    /*#__PURE__*/ (0, $i3UfC.jsx)("img", {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($dbb66ba1f61af10a$exports))),
                        alt: '',
                        className: (0, $b02ab0e3a0f362dd$export$2e2bcd8739ae039)([
                            $187eceff84f1477d$var$styles.flip
                        ])
                    })
                ]
            }),
            /*#__PURE__*/ (0, $i3UfC.jsx)("img", {
                src: (0, (/*@__PURE__*/$parcel$interopDefault($dbb66ba1f61af10a$exports))),
                alt: ''
            })
        ]
    });
};
var $187eceff84f1477d$export$2e2bcd8739ae039 = $187eceff84f1477d$export$b6e350ab9915297a;


/* AtlassianUserIcon.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $i3UfC = parcelRequire("i3UfC");
parcelRequire("5FkrB");


/* avatar.tsx generated by @compiled/babel-plugin v2.0.0 */ function $ef8378342e6abc3a$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $ef8378342e6abc3a$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $ef8378342e6abc3a$export$2e2bcd8739ae039(o);
}



function $17ea0cf9a2768583$export$2e2bcd8739ae039(t, r) {
    if ("object" != (0, $ef8378342e6abc3a$export$2e2bcd8739ae039)(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (0, $ef8378342e6abc3a$export$2e2bcd8739ae039)(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}


function $5e6c373950cc1961$export$2e2bcd8739ae039(t) {
    var i = (0, $17ea0cf9a2768583$export$2e2bcd8739ae039)(t, "string");
    return "symbol" == (0, $ef8378342e6abc3a$export$2e2bcd8739ae039)(i) ? i : i + "";
}


function $33a84553b8c8a5c7$export$2e2bcd8739ae039(e, r, t) {
    return (r = (0, $5e6c373950cc1961$export$2e2bcd8739ae039)(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}



var $5FkrB = parcelRequire("5FkrB");

var $bwjNt = parcelRequire("bwjNt");



var $50U6m = parcelRequire("50U6m");
/* avatar-content.tsx generated by @compiled/babel-plugin v2.0.0 */ function $0999b6e3b4df9b86$export$2e2bcd8739ae039() {
    return $0999b6e3b4df9b86$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $0999b6e3b4df9b86$export$2e2bcd8739ae039.apply(null, arguments);
}




var $5FkrB = parcelRequire("5FkrB");

var $bwjNt = parcelRequire("bwjNt");

var $50U6m = parcelRequire("50U6m");

var $5FkrB = parcelRequire("5FkrB");
var $35cc7bbed4ac268c$var$defaultAvatarContentProps = {
    as: 'span',
    appearance: 'circle',
    avatarImage: null,
    ref: null,
    size: 'medium'
};
var $35cc7bbed4ac268c$export$b983474ddd0b6d28 = /*#__PURE__*/ (0, $5FkrB.createContext)($35cc7bbed4ac268c$var$defaultAvatarContentProps);



var $5FkrB = parcelRequire("5FkrB");

var $5FkrB = parcelRequire("5FkrB");
var $2ab21e0b1d25bb4f$export$6b4cbd90d24955ad = /*#__PURE__*/ (0, $5FkrB.createContext)(false);


var $1e772d9f336e5cb4$export$7db5c57474082dd9 = function useEnsureIsInsideAvatar() {
    var context = (0, $5FkrB.useContext)((0, $2ab21e0b1d25bb4f$export$6b4cbd90d24955ad));
    if (!context) throw new Error('Avatar sub-components must be used within a Avatar component.');
};


var $d14288790f4b809c$var$boxShadowCssVar = '--avatar-box-shadow';
var $d14288790f4b809c$var$bgColorCssVar = '--avatar-bg-color';
var $d14288790f4b809c$var$styles = {
    root: "_19itglyw _12ji1r31 _1qu2glyw _12y31o36 _1reo15vq _18m915vq _v564ieh6 _1e0c1txw _kqswpfqs _4cvr1fhb _1bah1h6o _2lx21bp4 _80om1kw7 _6rthv77o _1pfhv77o _12l2v77o _ahbqv77o _85i5ze3t _1q51ze3t _y4tize3t _bozgze3t _t9ec1aqe _9v7aze3t _qc5o1p41 _z0ai1osq _18postnw _1hfk1j28 _aetrf705 _1peqidpf _11fnglyw _1ejjglyw _mizu1v1w _1ah3v77o _ra3xnqa1 _128mdkaa _4dave4h9",
    circle: "_2rko1qll _14mj1qll",
    square: "_2rkol0p1",
    positionRelative: "_kqswh2mm",
    disabled: "_80om13gf _1hfkvuon _1peq2wxo"
};
var $d14288790f4b809c$var$unboundStyles = {
    rootCustomBorder: "_11q7cxp3",
    root: "_vchh1ntv _bfhkcxp3 _16qs1nhn",
    hexagonFocusContainer: "_1rjc1wgn _18zr1dm9 _1mou5h37 _195g1ksc _bfhk1j28 _mkrz1k6g _1o9o1v1w",
    hexagonBorderContainerCustomBorder: "_11q7cxp3",
    hexagonBorderContainer: "_1rjcf6hp _18zruxly _1mou18m8 _195gzwb8 _bfhkcxp3 _mkrz1kw7 _1o9ovuon",
    hexagon: "_2rkoidpf _mkrz1kw7 _16qsn7od _14mjidpf _1ejjn7od _128midpf _4davidpf",
    interactive: "_80omtlke _4tpu1f0r _ez1ykb7n _gcm1jer9 _eeh8kb7n _jlxit94y",
    interactiveMotion: "_v5641krm _1llweo6y"
};
var $d14288790f4b809c$var$hexagonBorderFixStyles = {
    hexagonBorderContainer: "_85i5pe44 _1q51pe44 _y4tipe44 _bozgpe44 _6rthn6b1 _1pfhn6b1 _12l2n6b1 _ahbqn6b1",
    hexagonFocusContainer: "_85i5i44o _1q51i44o _y4tii44o _bozgi44o _6rthnlpx _1pfhnlpx _12l2nlpx _ahbqnlpx"
};
var $d14288790f4b809c$var$widthHeightMap = {
    xxsmall: "_1bsb7vkz _4t3i7vkz",
    xsmall: "_1bsb7vkz _4t3i7vkz",
    UNSAFE_xsmall: "_1bsbgktf _4t3igktf",
    small: "_1bsb1tcg _4t3i1tcg",
    medium: "_1bsbzwfg _4t3izwfg",
    large: "_1bsb1ylp _4t3i1ylp",
    xlarge: "_1bsb16xz _4t3i16xz",
    xxlarge: "_1bsb1qr7 _4t3i1qr7"
};
var $d14288790f4b809c$export$47fbc0b44cae5559 = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function(_ref, ref) {
    var children = _ref.children;
    (0, $1e772d9f336e5cb4$export$7db5c57474082dd9)();
    var _useContext = (0, $5FkrB.useContext)((0, $35cc7bbed4ac268c$export$b983474ddd0b6d28)), Container = _useContext.as, appearance = _useContext.appearance, avatarImage = _useContext.avatarImage, _useContext$borderCol = _useContext.borderColor, borderColor = _useContext$borderCol === void 0 ? "var(--ds-surface, #FFFFFF)" : _useContext$borderCol, href = _useContext.href, isDisabled = _useContext.isDisabled, label = _useContext.label, onClick = _useContext.onClick, contextRef = _useContext.ref, tabIndex = _useContext.tabIndex, target = _useContext.target, testId = _useContext.testId, size = _useContext.size, stackIndex = _useContext.stackIndex, ariaControls = _useContext['aria-controls'], ariaExpanded = _useContext['aria-expanded'], ariaHasPopup = _useContext['aria-haspopup'];
    var isInteractive = Boolean(onClick || href || isDisabled || ariaHasPopup);
    var renderedContent = /*#__PURE__*/ $5FkrB.createElement(Container, (0, $0999b6e3b4df9b86$export$2e2bcd8739ae039)({
        style: (0, $33a84553b8c8a5c7$export$2e2bcd8739ae039)((0, $33a84553b8c8a5c7$export$2e2bcd8739ae039)({}, $d14288790f4b809c$var$bgColorCssVar, borderColor), $d14288790f4b809c$var$boxShadowCssVar, "0 0 0 2px ".concat(borderColor)),
        ref: ref || contextRef,
        "aria-label": isInteractive ? label : undefined,
        "aria-controls": ariaControls,
        "aria-expanded": ariaExpanded,
        "aria-haspopup": ariaHasPopup,
        onClick: onClick,
        tabIndex: tabIndex,
        "data-testid": testId,
        disabled: isDisabled,
        type: Container === 'button' ? 'button' : undefined
    }, href && {
        href: href,
        target: target,
        rel: target === '_blank' ? 'noopener noreferrer' : undefined
    }, {
        className: (0, $bwjNt.default)([
            $d14288790f4b809c$var$unboundStyles.root,
            (0, $50U6m.fg)('avatar-custom-border') && $d14288790f4b809c$var$unboundStyles.rootCustomBorder,
            $d14288790f4b809c$var$styles.root,
            appearance === 'square' && $d14288790f4b809c$var$styles.square,
            appearance === 'circle' && $d14288790f4b809c$var$styles.circle,
            appearance === 'hexagon' && $d14288790f4b809c$var$unboundStyles.hexagon,
            $d14288790f4b809c$var$widthHeightMap[size],
            stackIndex !== undefined && $d14288790f4b809c$var$styles.positionRelative,
            isInteractive && !isDisabled && $d14288790f4b809c$var$unboundStyles.interactive,
            isInteractive && !isDisabled && appearance !== 'hexagon' && (0, $50U6m.fg)('platform-dst-motion-uplift') && $d14288790f4b809c$var$unboundStyles.interactiveMotion,
            isDisabled && $d14288790f4b809c$var$styles.disabled
        ])
    }), children || avatarImage);
    if (appearance !== 'hexagon') return renderedContent;
    // For a Hexagon Avatar in order to have hexagonal "border" and "outline", we have to
    // layer multiple elements and use their background colors to create the different layers.
    return /*#__PURE__*/ $5FkrB.createElement("div", {
        style: (0, $33a84553b8c8a5c7$export$2e2bcd8739ae039)((0, $33a84553b8c8a5c7$export$2e2bcd8739ae039)({}, $d14288790f4b809c$var$bgColorCssVar, borderColor), $d14288790f4b809c$var$boxShadowCssVar, "0 0 0 2px ".concat(borderColor)),
        "data-testid": testId ? "".concat(testId, "-hexagon-focus-container") : 'hexagon-focus-container',
        className: (0, $bwjNt.default)([
            $d14288790f4b809c$var$unboundStyles.hexagonFocusContainer,
            isInteractive && !isDisabled && (0, $50U6m.fg)('platform-dst-motion-uplift') && $d14288790f4b809c$var$unboundStyles.interactiveMotion,
            (0, $50U6m.fg)('platform_editor_agent_mentions_drop_one_fixes') && $d14288790f4b809c$var$hexagonBorderFixStyles.hexagonFocusContainer
        ])
    }, /*#__PURE__*/ $5FkrB.createElement("div", {
        "data-testid": testId ? "".concat(testId, "-hexagon-border-container") : 'hexagon-border-container',
        className: (0, $bwjNt.default)([
            $d14288790f4b809c$var$unboundStyles.hexagonBorderContainer,
            (0, $50U6m.fg)('avatar-custom-border') && $d14288790f4b809c$var$unboundStyles.hexagonBorderContainerCustomBorder,
            (0, $50U6m.fg)('platform_editor_agent_mentions_drop_one_fixes') && $d14288790f4b809c$var$hexagonBorderFixStyles.hexagonBorderContainer
        ])
    }, renderedContent));
});


/* avatar-image.tsx generated by @compiled/babel-plugin v2.0.0 */ function $546471c99432c8f6$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return r;
}


function $3e47aca38580d265$export$2e2bcd8739ae039(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}


function $b20c9339ff562a99$export$2e2bcd8739ae039(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}


function $1a6c91a4c2dab823$export$2e2bcd8739ae039(r, a) {
    if (r) {
        if ("string" == typeof r) return (0, $b20c9339ff562a99$export$2e2bcd8739ae039)(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? (0, $b20c9339ff562a99$export$2e2bcd8739ae039)(r, a) : void 0;
    }
}


function $df57791634e038d2$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}


function $e612363e5f30bdc7$export$2e2bcd8739ae039(r, e) {
    return (0, $546471c99432c8f6$export$2e2bcd8739ae039)(r) || (0, $3e47aca38580d265$export$2e2bcd8739ae039)(r, e) || (0, $1a6c91a4c2dab823$export$2e2bcd8739ae039)(r, e) || (0, $df57791634e038d2$export$2e2bcd8739ae039)();
}



var $5FkrB = parcelRequire("5FkrB");

var $bwjNt = parcelRequire("bwjNt");
var $be12f7806c1902d7$exports = {};
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::15792c49648e2841f6e4efe1792e8bd0>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty($be12f7806c1902d7$exports, "__esModule", {
    value: true
});
$be12f7806c1902d7$exports.default = void 0;

var $be12f7806c1902d7$var$_react = $be12f7806c1902d7$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $be12f7806c1902d7$var$_baseNew = $be12f7806c1902d7$var$_interopRequireDefault((parcelRequire("kWLEF")));
function $be12f7806c1902d7$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "AiAgent".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/ai-agent
 * Usage guidance:
 * Single purpose - Reserved for Rovo Agent.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $be12f7806c1902d7$var$AiAgentIcon = (props)=>/*#__PURE__*/ $be12f7806c1902d7$var$_react.default.createElement($be12f7806c1902d7$var$_baseNew.default, Object.assign({
        name: "AiAgentIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6.971.493a2 2 0 0 1 2.058 0l5 3A2 2 0 0 1 15 5.208v5.584a2 2 0 0 1-.971 1.715l-5 3a2 2 0 0 1-2.058 0l-5-3A2 2 0 0 1 1 10.792V5.208a2 2 0 0 1 .971-1.715zm1.286 1.286a.5.5 0 0 0-.514 0l-5 3a.5.5 0 0 0-.243.429v5.584a.5.5 0 0 0 .243.429l1.098.66a4.25 4.25 0 1 1 8.318 0l1.098-.66a.5.5 0 0 0 .243-.429V5.208a.5.5 0 0 0-.243-.429zM8 8.25a2.75 2.75 0 1 0 0 5.5 2.75 2.75 0 0 0 0-5.5" clip-rule="evenodd"/>`
    }, props));
$be12f7806c1902d7$var$AiAgentIcon.displayName = 'AiAgentIcon';
var $be12f7806c1902d7$var$_default = $be12f7806c1902d7$exports.default = $be12f7806c1902d7$var$AiAgentIcon;


var $a27b6c6774585604$exports = {};
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::78e29a42ae04e7de3faf9cb14ac698bd>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty($a27b6c6774585604$exports, "__esModule", {
    value: true
});
$a27b6c6774585604$exports.default = void 0;

var $a27b6c6774585604$var$_react = $a27b6c6774585604$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $a27b6c6774585604$var$_baseNew = $a27b6c6774585604$var$_interopRequireDefault((parcelRequire("kWLEF")));
function $a27b6c6774585604$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Person".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/person
 * Usage guidance:
 * Single purpose - Known uses: representing a person or user, owner, contributor.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a27b6c6774585604$var$PersonIcon = (props)=>/*#__PURE__*/ $a27b6c6774585604$var$_react.default.createElement($a27b6c6774585604$var$_baseNew.default, Object.assign({
        name: "PersonIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 1.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5M4 4a4 4 0 1 1 8 0 4 4 0 0 1-8 0m-2 9a3.75 3.75 0 0 1 3.75-3.75h4.5A3.75 3.75 0 0 1 14 13v2h-1.5v-2a2.25 2.25 0 0 0-2.25-2.25h-4.5A2.25 2.25 0 0 0 3.5 13v2H2z" clip-rule="evenodd"/>`
    }, props));
$a27b6c6774585604$var$PersonIcon.displayName = 'PersonIcon';
var $a27b6c6774585604$var$_default = $a27b6c6774585604$exports.default = $a27b6c6774585604$var$PersonIcon;


var $fce7bbcb7786bf00$exports = {};
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::928742519cfd34b83d7a7734b1ec08a2>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty($fce7bbcb7786bf00$exports, "__esModule", {
    value: true
});
$fce7bbcb7786bf00$exports.default = void 0;

var $fce7bbcb7786bf00$var$_react = $fce7bbcb7786bf00$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $fce7bbcb7786bf00$var$_baseNew = $fce7bbcb7786bf00$var$_interopRequireDefault((parcelRequire("kWLEF")));
function $fce7bbcb7786bf00$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Release".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/release
 * Usage guidance:
 * Single purpose - Reserved for releases in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $fce7bbcb7786bf00$var$ReleaseIcon = (props)=>/*#__PURE__*/ $fce7bbcb7786bf00$var$_react.default.createElement($fce7bbcb7786bf00$var$_baseNew.default, Object.assign({
        name: "ReleaseIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M4 2h3v2h2a.75.75 0 0 1 .648.372L11.18 7h4.069a.75.75 0 0 1 .646 1.132l-2.887 4.886a2 2 0 0 1-1.722.982H2a2 2 0 0 1-2-2V7.75A.75.75 0 0 1 .75 7H2V4.75A.75.75 0 0 1 2.75 4H4zm-.5 5h5.944L8.57 5.5H3.5zm-2 1.5V12a.5.5 0 0 0 .5.5h9.287a.5.5 0 0 0 .43-.246L13.936 8.5z" clip-rule="evenodd"/>`
    }, props));
$fce7bbcb7786bf00$var$ReleaseIcon.displayName = 'ReleaseIcon';
var $fce7bbcb7786bf00$var$_default = $fce7bbcb7786bf00$exports.default = $fce7bbcb7786bf00$var$ReleaseIcon;


var $852f18092c195180$var$styles = {
    image: "_16jlkb7n _1o9zkb7n _i0dl1osq _1e0c1txw _1bsb1osq _4t3i1osq",
    icon: "_1e0c1txw _1bsb1osq _4t3i1osq _bfhk7qp0",
    circle: "_2rko1rr0",
    hexagon: "_mkrz1k6g"
};
var $852f18092c195180$var$borderRadiusMap = {
    xxsmall: "_2rkolb4i",
    xsmall: "_2rkolb4i",
    UNSAFE_xsmall: "_2rkolb4i",
    small: "_2rkolb4i",
    medium: "_2rko12b0",
    large: "_2rko12b0",
    xlarge: "_2rko1qi0",
    xxlarge: "_2rkopb1k"
};
var $852f18092c195180$var$nestedSvgStylesMap = {
    xxsmall: "_w8l57vkz _17527vkz",
    xsmall: "_w8l57vkz _17527vkz",
    UNSAFE_xsmall: "_w8l5gktf _1752gktf",
    small: "_w8l51tcg _17521tcg",
    medium: "_w8l5zwfg _1752zwfg",
    large: "_w8l51ylp _17521ylp",
    xlarge: "_w8l516xz _175216xz",
    xxlarge: "_w8l51qr7 _17521qr7"
};
/**
 * __Avatar image__
 *
 * An avatar image is an internal component used to control the rendering phases of an image.
 */ var $852f18092c195180$var$AvatarImage = function AvatarImage(_ref) {
    var _ref$alt = _ref.alt, alt = _ref$alt === void 0 ? '' : _ref$alt, src = _ref.src, appearance = _ref.appearance, size = _ref.size, testId = _ref.testId, imgLoading = _ref.imgLoading;
    var _useState = (0, $5FkrB.useState)(false), _useState2 = (0, $e612363e5f30bdc7$export$2e2bcd8739ae039)(_useState, 2), hasImageErrored = _useState2[0], setHasImageErrored = _useState2[1];
    // If src changes, reset state
    (0, $5FkrB.useEffect)(function() {
        setHasImageErrored(false);
    }, [
        src
    ]);
    if (!src || hasImageErrored) {
        var renderedIcon;
        switch(appearance){
            case 'circle':
                renderedIcon = /*#__PURE__*/ $5FkrB.createElement((0, (/*@__PURE__*/$parcel$interopDefault($a27b6c6774585604$exports))), {
                    label: alt,
                    color: "var(--ds-icon-subtle, #505258)",
                    testId: testId && "".concat(testId, "--person"),
                    spacing: "spacious"
                });
                break;
            case 'hexagon':
                renderedIcon = /*#__PURE__*/ $5FkrB.createElement((0, (/*@__PURE__*/$parcel$interopDefault($be12f7806c1902d7$exports))), {
                    label: alt,
                    color: "var(--ds-icon-subtle, #505258)",
                    testId: testId && "".concat(testId, "--agent"),
                    spacing: "spacious"
                });
                break;
            default:
            case 'square':
                renderedIcon = /*#__PURE__*/ $5FkrB.createElement((0, (/*@__PURE__*/$parcel$interopDefault($fce7bbcb7786bf00$exports))), {
                    label: alt,
                    color: "var(--ds-icon-subtle, #505258)",
                    testId: testId && "".concat(testId, "--ship"),
                    spacing: "spacious"
                });
                break;
        }
        return /*#__PURE__*/ $5FkrB.createElement("span", {
            className: (0, $bwjNt.default)([
                $852f18092c195180$var$styles.icon,
                $852f18092c195180$var$nestedSvgStylesMap[size]
            ])
        }, renderedIcon);
    }
    return /*#__PURE__*/ $5FkrB.createElement("img", {
        loading: imgLoading,
        src: src,
        alt: alt,
        "data-testid": testId && "".concat(testId, "--image"),
        onError: function onError() {
            return setHasImageErrored(true);
        },
        "aria-hidden": !alt ? true : undefined,
        "data-vc": testId ? "".concat(testId, "--image") : 'avatar-image',
        "data-ssr-placeholder-ignored": true,
        className: (0, $bwjNt.default)([
            $852f18092c195180$var$styles.image,
            $852f18092c195180$var$borderRadiusMap[size],
            appearance === 'circle' && $852f18092c195180$var$styles.circle,
            appearance === 'hexagon' && $852f18092c195180$var$styles.hexagon
        ])
    });
};
var $852f18092c195180$export$2e2bcd8739ae039 = $852f18092c195180$var$AvatarImage;




var $d1e2c337c2315020$var$getCustomElement = function getCustomElement(isDisabled, href, onClick, ariaHasPopup) {
    if (href && !isDisabled) return 'a';
    if (onClick || isDisabled || ariaHasPopup) return 'button';
    return 'span';
};
var $d1e2c337c2315020$export$2e2bcd8739ae039 = $d1e2c337c2315020$var$getCustomElement;


/* presence-wrapper.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $5FkrB = parcelRequire("5FkrB");

var $bwjNt = parcelRequire("bwjNt");
/* presence.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $5FkrB = parcelRequire("5FkrB");

/* icon-wrapper.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $5FkrB = parcelRequire("5FkrB");

var $bwjNt = parcelRequire("bwjNt");
var $6099e21f4ede430f$var$styles = {
    root: "_2rko1qll _1reo15vq _18m915vq _189e1dm9 _1dqonqa1 _1e0c1txw _vchhusvi _1bsb1osq _4t3i1osq _4cvr1h6o _ae4v1h6o _bfhk1bhr"
};
var $6099e21f4ede430f$var$unboundStyles = {
    root: "_1h6d1bhr"
};
/**
 * __Icon wrapper__
 *
 * An icon wrapper is used internally only.
 */ var $6099e21f4ede430f$var$IconWrapper = function IconWrapper(_ref) {
    var bgColor = _ref.bgColor, children = _ref.children;
    return /*#__PURE__*/ $5FkrB.createElement("span", {
        role: "presentation",
        style: {
            borderColor: bgColor,
            backgroundColor: bgColor
        },
        className: (0, $bwjNt.default)([
            $6099e21f4ede430f$var$styles.root,
            $6099e21f4ede430f$var$unboundStyles.root
        ])
    }, children);
};
var $6099e21f4ede430f$export$2e2bcd8739ae039 = $6099e21f4ede430f$var$IconWrapper;


var $13f75d5d657b548d$var$BusyIndicator = /*#__PURE__*/ $5FkrB.createElement((0, $5FkrB.Fragment), null, /*#__PURE__*/ $5FkrB.createElement("circle", {
    fill: "var(--ds-icon-danger, #C9372C)",
    cx: "4",
    cy: "4",
    r: "4"
}), /*#__PURE__*/ $5FkrB.createElement("path", {
    fill: "var(--ds-surface-overlay, #FFFFFF)",
    d: "M3.3,1.9l2.8,2.8c0.2,0.2,0.2,0.5,0,0.7L5.4,6.1c-0.2,0.2-0.5,0.2-0.7,0L1.9,3.3c-0.2-0.2-0.2-0.5,0-0.7l0.7-0.7C2.8,1.7,3.1,1.7,3.3,1.9z"
}));
var $13f75d5d657b548d$var$FocusIndicator = /*#__PURE__*/ $5FkrB.createElement((0, $5FkrB.Fragment), null, /*#__PURE__*/ $5FkrB.createElement("path", {
    fill: "var(--ds-icon-discovery, #AF59E1)",
    d: "M4,8 C1.790861,8 0,6.209139 0,4 C0,1.790861 1.790861,0 4,0 C6.209139,0 8,1.790861 8,4 C8,6.209139 6.209139,8 4,8 Z M4,6.66666667 C5.47275933,6.66666667 6.66666667,5.47275933 6.66666667,4 C6.66666667,2.52724067 5.47275933,1.33333333 4,1.33333333 C2.52724067,1.33333333 1.33333333,2.52724067 1.33333333,4 C1.33333333,5.47275933 2.52724067,6.66666667 4,6.66666667 Z M4,5.33333333 C3.26362033,5.33333333 2.66666667,4.73637967 2.66666667,4 C2.66666667,3.26362033 3.26362033,2.66666667 4,2.66666667 C4.73637967,2.66666667 5.33333333,3.26362033 5.33333333,4 C5.33333333,4.73637967 4.73637967,5.33333333 4,5.33333333 Z"
}));
var $13f75d5d657b548d$var$OfflineIndicator = /*#__PURE__*/ $5FkrB.createElement((0, $5FkrB.Fragment), null, /*#__PURE__*/ $5FkrB.createElement("path", {
    fill: "var(--ds-text-subtlest, #6B6E76)",
    d: "M4,8 C6.209139,8 8,6.209139 8,4 C8,1.790861 6.209139,0 4,0 C1.790861,0 0,1.790861 0,4 C0,6.209139 1.790861,8 4,8 Z M4,6 C5.1045695,6 6,5.1045695 6,4 C6,2.8954305 5.1045695,2 4,2 C2.8954305,2 2,2.8954305 2,4 C2,5.1045695 2.8954305,6 4,6 Z"
}), /*#__PURE__*/ $5FkrB.createElement("path", {
    fill: "var(--ds-surface-overlay, #FFFFFF)",
    d: "M4,6 C5.1045695,6 6,5.1045695 6,4 C6,2.8954305 5.1045695,2 4,2 C2.8954305,2 2,2.8954305 2,4 C2,5.1045695 2.8954305,6 4,6 Z"
}));
var $13f75d5d657b548d$var$OnlineIndicator = /*#__PURE__*/ $5FkrB.createElement("circle", {
    fill: "var(--ds-icon-success, #6A9A23)",
    cx: "4",
    cy: "4",
    r: "4"
});
function $13f75d5d657b548d$var$getPresence(presence) {
    switch(presence){
        case 'busy':
            return $13f75d5d657b548d$var$BusyIndicator;
        case 'focus':
            return $13f75d5d657b548d$var$FocusIndicator;
        case 'offline':
            return $13f75d5d657b548d$var$OfflineIndicator;
        case 'online':
            return $13f75d5d657b548d$var$OnlineIndicator;
    }
}
/**
 * __Avatar presence__
 *
 * A presence shows an avatar’s availability.
 *
 * - [Examples](https://atlassian.design/components/avatar/avatar-presence/examples)
 * - [Code](https://atlassian.design/components/avatar/avatar-presence/code)
 * - [Usage](https://atlassian.design/components/avatar/avatar-presence/usage)
 */ var $13f75d5d657b548d$var$AvatarPresence = function AvatarPresence(_ref) {
    var borderColor = _ref.borderColor, children = _ref.children, presence = _ref.presence;
    return /*#__PURE__*/ $5FkrB.createElement((0, $6099e21f4ede430f$export$2e2bcd8739ae039), {
        bgColor: borderColor
    }, presence ? /*#__PURE__*/ $5FkrB.createElement("svg", {
        height: "100%",
        version: "1.1",
        viewBox: "0 0 8 8",
        width: "100%",
        xmlns: "http://www.w3.org/2000/svg"
    }, $13f75d5d657b548d$var$getPresence(presence)) : children);
};
var $13f75d5d657b548d$export$2e2bcd8739ae039 = $13f75d5d657b548d$var$AvatarPresence;


var $6e9bed4c4211bcf6$var$styles = {
    root: "_kqswstnw _lcxvglyw"
};
var $6e9bed4c4211bcf6$var$iconSizeMap = {
    small: "_4t3i1crf _1bsb1crf",
    medium: "_4t3idlk8 _1bsbdlk8",
    large: "_4t3io7ao _1bsbo7ao",
    xlarge: "_4t3if6fq _1bsbf6fq"
};
var $6e9bed4c4211bcf6$var$circleIconOffsetMap = {
    small: "_94n5idpf _1xi2idpf",
    medium: "_94n5idpf _1xi2idpf",
    large: "_94n5t94y _1xi2t94y",
    xlarge: "_94n51v6z _1xi21v6z"
};
var $6e9bed4c4211bcf6$var$squareIconOffsetMap = {
    root: "_94n5myb0 _1xi2myb0"
};
var $6e9bed4c4211bcf6$var$hexagonIconOffsetMap = {
    small: "_94n51n1a _1xi21n1a",
    medium: "_94n51n1a _1xi21n1a",
    large: "_94n51y44 _1xi2myb0",
    xlarge: "_94n5l52n _1xi21lpd"
};
/**
 * __Presence wrapper__
 *
 * A presence wrapper is used internally to position presence ontop of the avatar.
 */ var $6e9bed4c4211bcf6$var$PresenceWrapper = function PresenceWrapper(_ref) {
    var size = _ref.size, appearance = _ref.appearance, children = _ref.children, borderColor = _ref.borderColor, presence = _ref.presence, testId = _ref.testId;
    return /*#__PURE__*/ $5FkrB.createElement("span", {
        "aria-hidden": "true",
        "data-testid": testId && "".concat(testId, "--presence"),
        className: (0, $bwjNt.default)([
            $6e9bed4c4211bcf6$var$styles.root,
            $6e9bed4c4211bcf6$var$iconSizeMap[size],
            $6e9bed4c4211bcf6$var$circleIconOffsetMap[size],
            appearance === 'square' && $6e9bed4c4211bcf6$var$squareIconOffsetMap.root,
            appearance === 'hexagon' && $6e9bed4c4211bcf6$var$hexagonIconOffsetMap[size]
        ])
    }, /*#__PURE__*/ $5FkrB.createElement((0, $13f75d5d657b548d$export$2e2bcd8739ae039), {
        borderColor: borderColor,
        presence: !children ? presence : undefined
    }, children));
};
var $6e9bed4c4211bcf6$export$2e2bcd8739ae039 = $6e9bed4c4211bcf6$var$PresenceWrapper;


/* status-wrapper.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $5FkrB = parcelRequire("5FkrB");

var $bwjNt = parcelRequire("bwjNt");
/* status.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $5FkrB = parcelRequire("5FkrB");


var $f08d8032eb3b69c7$var$ApprovedIndicator = /*#__PURE__*/ $5FkrB.createElement((0, $5FkrB.Fragment), null, /*#__PURE__*/ $5FkrB.createElement("circle", {
    fill: "var(--ds-icon-success, #6A9A23)",
    cx: "4",
    cy: "4",
    r: "4"
}), /*#__PURE__*/ $5FkrB.createElement("path", {
    fill: "var(--ds-surface-overlay, #FFFFFF)",
    d: "M2.47140452,3.52859548 C2.21105499,3.26824595 1.78894501,3.26824595 1.52859548,3.52859548 C1.26824595,3.78894501 1.26824595,4.21105499 1.52859548,4.47140452 L2.86192881,5.80473785 C3.12227834,6.06508738 3.54438833,6.06508738 3.80473785,5.80473785 L6.47140452,3.13807119 C6.73175405,2.87772166 6.73175405,2.45561167 6.47140452,2.19526215 C6.21105499,1.93491262 5.78894501,1.93491262 5.52859548,2.19526215 L3.33333333,4.39052429 L2.47140452,3.52859548 Z"
}));
var $f08d8032eb3b69c7$var$DeclinedIndicator = /*#__PURE__*/ $5FkrB.createElement((0, $5FkrB.Fragment), null, /*#__PURE__*/ $5FkrB.createElement("circle", {
    fill: "var(--ds-icon-danger, #C9372C)",
    cx: "4",
    cy: "4",
    r: "4"
}), /*#__PURE__*/ $5FkrB.createElement("path", {
    fill: "var(--ds-surface-overlay, #FFFFFF)",
    d: "M4.890661,4.0088336 L5.81806461,3.07802178 C6.06167933,2.83351177 6.06048933,2.43826992 5.81540668,2.19522442 C5.57032402,1.95217891 5.17415651,1.95336612 4.93054179,2.19787613 L4.00765946,3.12415007 L3.06906871,2.18377143 C2.82523777,1.93947602 2.42906937,1.93863765 2.18420182,2.18189887 C1.93933427,2.42516008 1.93849394,2.82040282 2.18232488,3.06469822 L3.12544091,4.00961077 L2.20275024,4.93569234 C1.95913552,5.18020236 1.96032551,5.5754442 2.20540817,5.81848971 C2.45049083,6.06153521 2.84665833,6.060348 3.09027306,5.81583799 L4.00844245,4.89429431 L4.9092123,5.79678001 C5.15304324,6.04107541 5.54921164,6.04191379 5.79407919,5.79865257 C6.03894674,5.55539135 6.03978708,5.16014862 5.79595614,4.91585321 L4.890661,4.0088336 Z"
}));
var $f08d8032eb3b69c7$var$LockedIndicator = /*#__PURE__*/ $5FkrB.createElement((0, $5FkrB.Fragment), null, /*#__PURE__*/ $5FkrB.createElement("circle", {
    fill: "var(--ds-text-subtlest, #6B6E76)",
    cx: "4",
    cy: "4",
    r: "4"
}), /*#__PURE__*/ $5FkrB.createElement("path", {
    fill: "var(--ds-surface-overlay, #FFFFFF)",
    d: "M4.13074827,1.21766493 L4.10368158,1.21766493 C3.36340745,1.21766493 2.76388015,1.80793503 2.76388015,2.5367787 L2.76388015,3.21632216 L3.44054754,3.21632216 L3.44054754,2.54344089 C3.44054754,2.17901906 3.74031119,1.88388401 4.11044825,1.88388401 L4.1239816,1.88388401 C4.49411866,1.88388401 4.79388232,2.17901906 4.79388232,2.54344089 L4.79388232,3.21632216 L5.47054971,3.21632216 L5.47054971,2.5367787 C5.47054971,1.80793503 4.8710224,1.21766493 4.13074827,1.21766493 M2.76388015,3.21632216 L3.44054754,3.21632216 L3.44054754,3.88254123 L2.76388015,3.88254123 L2.76388015,3.21632216 Z M4.79388232,3.21632216 L5.47054971,3.21632216 L5.47054971,3.88254123 L4.79388232,3.88254123 L4.79388232,3.21632216 Z M4.79401765,3.88254123 L3.44068287,3.88254123 L2.76401548,3.88254123 C2.39049508,3.88254123 2.08734809,4.18100738 2.08734809,4.54876031 L2.08734809,5.54808892 C2.08734809,6.10000287 2.53735205,6.54741753 3.09094491,6.54741753 L5.14375561,6.54741753 C5.69802683,6.54741753 6.14735243,6.10385072 6.14735243,5.54808892 L6.14735243,4.54876031 C6.14735243,4.18100738 5.84420544,3.88254123 5.47068504,3.88254123 L4.79401765,3.88254123 Z"
}));
var $f08d8032eb3b69c7$var$WarningIndicator = /*#__PURE__*/ $5FkrB.createElement((0, $5FkrB.Fragment), null, /*#__PURE__*/ $5FkrB.createElement("circle", {
    fill: "var(--ds-icon-warning, #E06C00)",
    cx: "4",
    cy: "4",
    r: "4"
}), /*#__PURE__*/ $5FkrB.createElement("path", {
    fill: "var(--ds-surface-overlay, #FFFFFF)",
    d: "M4,1.33333333 C4.36918944,1.33333333 4.66666667,1.63081056 4.66666667,2 L4.66666667,4 C4.66666667,4.36918944 4.36918944,4.66666667 4,4.66666667 C3.63081056,4.66666667 3.33333333,4.36918944 3.33333333,4 L3.33333333,2 C3.33333333,1.63081056 3.63081056,1.33333333 4,1.33333333 Z M4,5.33333333 C4.36918944,5.33333333 4.66666667,5.63081056 4.66666667,6 C4.66666667,6.36918944 4.36918944,6.66666667 4,6.66666667 C3.63081056,6.66666667 3.33333333,6.36918944 3.33333333,6 C3.33333333,5.63081056 3.63081056,5.33333333 4,5.33333333 Z"
}));
function $f08d8032eb3b69c7$var$getStatus(status) {
    switch(status){
        case 'approved':
            return $f08d8032eb3b69c7$var$ApprovedIndicator;
        case 'declined':
            return $f08d8032eb3b69c7$var$DeclinedIndicator;
        case 'locked':
            return $f08d8032eb3b69c7$var$LockedIndicator;
        case 'warning':
            return $f08d8032eb3b69c7$var$WarningIndicator;
    }
}
/**
 * __Avatar status__
 *
 * An avatar status shows contextual information, such as if someone approves or declines something.
 *
 * - [Examples](https://atlassian.design/components/avatar/avatar-status/examples)
 * - [Code](https://atlassian.design/components/avatar/avatar-status/code)
 */ var $f08d8032eb3b69c7$var$AvatarStatus = function AvatarStatus(_ref) {
    var borderColor = _ref.borderColor, children = _ref.children, status = _ref.status;
    return /*#__PURE__*/ $5FkrB.createElement((0, $6099e21f4ede430f$export$2e2bcd8739ae039), {
        bgColor: borderColor
    }, status ? /*#__PURE__*/ $5FkrB.createElement("svg", {
        height: "100%",
        version: "1.1",
        viewBox: "0 0 8 8",
        width: "100%",
        xmlns: "http://www.w3.org/2000/svg"
    }, $f08d8032eb3b69c7$var$getStatus(status)) : children);
};
var $f08d8032eb3b69c7$export$2e2bcd8739ae039 = $f08d8032eb3b69c7$var$AvatarStatus;


var $ab9b93b2f7220925$var$styles = {
    root: "_kqswstnw"
};
var $ab9b93b2f7220925$var$iconSizeMap = {
    small: "_4t3i1crf _1bsb1crf",
    medium: "_4t3idlk8 _1bsbdlk8",
    large: "_4t3io7ao _1bsbo7ao",
    xlarge: "_4t3if6fq _1bsbf6fq"
};
var $ab9b93b2f7220925$var$circleIconOffsetMap = {
    small: "_rjxpidpf _152tidpf",
    medium: "_rjxpidpf _152tidpf",
    large: "_rjxpt94y _152tt94y",
    xlarge: "_rjxp1v6z _152t1v6z"
};
var $ab9b93b2f7220925$var$squareIconOffsetMap = {
    root: "_rjxpidpf _152tidpf"
};
var $ab9b93b2f7220925$var$hexagonIconOffsetMap = {
    small: "_rjxp1n1a _152t1n1a",
    medium: "_rjxp1n1a _152t1n1a",
    large: "_rjxpmyb0 _152t1y44",
    xlarge: "_rjxp1lpd _152tl52n"
};
/**
 * __Status wrapper__
 *
 * A status wrapper is used internally to position status on top of the avatar.
 */ var $ab9b93b2f7220925$var$StatusWrapper = function StatusWrapper(_ref) {
    var size = _ref.size, status = _ref.status, appearance = _ref.appearance, borderColor = _ref.borderColor, children = _ref.children, testId = _ref.testId;
    return /*#__PURE__*/ $5FkrB.createElement("span", {
        "aria-hidden": "true",
        "data-testid": testId && "".concat(testId, "--status"),
        className: (0, $bwjNt.default)([
            $ab9b93b2f7220925$var$styles.root,
            $ab9b93b2f7220925$var$iconSizeMap[size],
            $ab9b93b2f7220925$var$circleIconOffsetMap[size],
            appearance === 'square' && $ab9b93b2f7220925$var$squareIconOffsetMap.root,
            appearance === 'hexagon' && $ab9b93b2f7220925$var$hexagonIconOffsetMap[size]
        ])
    }, /*#__PURE__*/ $5FkrB.createElement((0, $f08d8032eb3b69c7$export$2e2bcd8739ae039), {
        borderColor: borderColor,
        status: !children ? status : undefined
    }, children));
};
var $ab9b93b2f7220925$export$2e2bcd8739ae039 = $ab9b93b2f7220925$var$StatusWrapper;



var $5FkrB = parcelRequire("5FkrB");

var $5FkrB = parcelRequire("5FkrB");
var $3cc69d076eb107aa$export$a20dad690e1279e2 = /*#__PURE__*/ (0, $5FkrB.createContext)(undefined);


var $2da6413653cffbc7$export$b50b87a1c4086b23 = function useAvatarContext() {
    return (0, $5FkrB.useContext)((0, $3cc69d076eb107aa$export$a20dad690e1279e2));
};


function $467b7370bd97bdfa$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $467b7370bd97bdfa$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $467b7370bd97bdfa$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $33a84553b8c8a5c7$export$2e2bcd8739ae039)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $467b7370bd97bdfa$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $467b7370bd97bdfa$var$packageName = "@atlaskit/avatar";
var $467b7370bd97bdfa$var$packageVersion = "28.0.0";
var $467b7370bd97bdfa$var$containerStyles = null;
var $467b7370bd97bdfa$var$normalizeAvatarSize = function normalizeAvatarSize(size) {
    return size === 'xsmall' && !(0, $50U6m.fg)('platform_design-system-team_avatar-remove-xsmall') ? 'xxsmall' : size;
};
// eslint-disable-next-line @repo/internal/react/consistent-types-definitions
/**
 * __Avatar__
 *
 * An avatar is a visual representation of a user or entity.
 *
 * - [Examples](https://atlassian.design/components/avatar/examples)
 * - [Code](https://atlassian.design/components/avatar/code)
 * - [Usage](https://atlassian.design/components/avatar/usage)
 */ var $467b7370bd97bdfa$var$Avatar = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function(_ref, ref) {
    var analyticsContext = _ref.analyticsContext, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'circle' : _ref$appearance, label = _ref.label, borderColor = _ref.borderColor, children = _ref.children, href = _ref.href, isDisabled = _ref.isDisabled, name = _ref.name, onClick = _ref.onClick, presence = _ref.presence, sizeProp = _ref.size, src = _ref.src, stackIndex = _ref.stackIndex, status = _ref.status, target = _ref.target, testId = _ref.testId, _ref$as = _ref.as, AvatarContainer = _ref$as === void 0 ? 'div' : _ref$as, imgLoading = _ref.imgLoading, ariaControls = _ref['aria-controls'], ariaExpanded = _ref['aria-expanded'], ariaHasPopup = _ref['aria-haspopup'];
    var _useAnalyticsEvents = (0, $879f28ba40c47674$export$5bf35293e545f20c)(), createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
    var context = (0, $2da6413653cffbc7$export$b50b87a1c4086b23)();
    var size = $467b7370bd97bdfa$var$normalizeAvatarSize(sizeProp || (context === null || context === void 0 ? void 0 : context.size) || 'medium');
    var customPresenceNode = /*#__PURE__*/ (0, $5FkrB.isValidElement)(presence) ? presence : null;
    var customStatusNode = /*#__PURE__*/ (0, $5FkrB.isValidElement)(status) ? status : null;
    var isValidIconSize = size !== 'xxlarge' && size !== 'xxsmall' && size !== 'xsmall';
    // Presence/status indicators are only defined for `IndicatorSizeType`
    // (small, medium, large, xlarge). Compute `indicatorSize` only for sizes
    // that support an indicator (`isValidIconSize`), so the value is
    // structurally guaranteed to be a valid `IndicatorSizeType` rather than
    // relying on the guard at each call site. The `UNSAFE_xsmall` (20px) size
    // reuses the `small` indicator sizing as its nearest supported neighbor;
    // unsupported sizes (`xxsmall`/`xsmall`/`xxlarge`) fall back to `small` and are never
    // actually rendered because `isPresence`/`isStatus` also guard on
    // `isValidIconSize`.
    var indicatorSize = !isValidIconSize ? 'small' : size === 'UNSAFE_xsmall' ? 'small' : size;
    var lastAnalytics = (0, $5FkrB.useRef)(analyticsContext);
    var labelId = (0, $c797bf80d6171378$export$f680877a34711e37)();
    (0, $5FkrB.useEffect)(function() {
        lastAnalytics.current = analyticsContext;
    }, [
        analyticsContext
    ]);
    var onClickHandler = (0, $5FkrB.useCallback)(function(event) {
        if (isDisabled || typeof onClick !== 'function') return;
        var analyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'avatar',
            attributes: {
                componentName: 'avatar',
                packageName: $467b7370bd97bdfa$var$packageName,
                packageVersion: $467b7370bd97bdfa$var$packageVersion
            }
        });
        /**
     * To avoid wrapping this component in AnalyticsContext we manually
     * push the parent context's meta data into the context.
     */ var context = $467b7370bd97bdfa$var$_objectSpread({
            componentName: 'avatar',
            packageName: $467b7370bd97bdfa$var$packageName,
            packageVersion: $467b7370bd97bdfa$var$packageVersion
        }, lastAnalytics.current);
        analyticsEvent.context.push(context);
        /**
     * Replicating the logic in the `withAnalyticsEvents` HOC.
     */ var clone = analyticsEvent.clone();
        if (clone) clone.fire('atlaskit');
        onClick(event, analyticsEvent);
    }, [
        createAnalyticsEvent,
        isDisabled,
        onClick
    ]);
    var isPresence = isValidIconSize && presence && !status;
    var isStatus = isValidIconSize && status;
    // add presence or status to the label by default if presence and status are passed as a string
    // if status or presence are nodes this is not added to the label by default
    var defaultLabel = [
        name,
        isStatus && !customStatusNode && "(".concat(status, ")"),
        isPresence && !customPresenceNode && "(".concat(presence, ")")
    ].filter(Boolean).join(' ');
    var isInteractive = onClick || href || isDisabled || ariaHasPopup;
    var containerShouldBeImage = Boolean(!isInteractive && defaultLabel);
    return /*#__PURE__*/ $5FkrB.createElement((0, $2ab21e0b1d25bb4f$export$6b4cbd90d24955ad).Provider, {
        value: true
    }, /*#__PURE__*/ $5FkrB.createElement(AvatarContainer, {
        "data-testid": testId,
        role: containerShouldBeImage ? 'img' : undefined,
        "aria-labelledby": containerShouldBeImage ? labelId : undefined,
        style: {
            zIndex: stackIndex
        },
        className: (0, $bwjNt.default)([
            "_12ji1r31 _1qu2glyw _12y3idpf _1e0c1o8l _kqswh2mm"
        ])
    }, /*#__PURE__*/ $5FkrB.createElement((0, $35cc7bbed4ac268c$export$b983474ddd0b6d28).Provider, {
        value: {
            as: (0, $d1e2c337c2315020$export$2e2bcd8739ae039)(isDisabled, href, onClick, ariaHasPopup),
            appearance: appearance,
            borderColor: borderColor,
            href: href,
            isDisabled: isDisabled,
            label: label || defaultLabel,
            onClick: isInteractive ? onClickHandler : undefined,
            ref: ref,
            size: size,
            stackIndex: stackIndex,
            target: target,
            testId: testId ? "".concat(testId, "--inner") : undefined,
            'aria-controls': ariaControls,
            'aria-expanded': ariaExpanded,
            'aria-haspopup': ariaHasPopup,
            avatarImage: /*#__PURE__*/ $5FkrB.createElement((0, $852f18092c195180$export$2e2bcd8739ae039), {
                alt: !containerShouldBeImage && src ? name : undefined,
                src: src,
                appearance: appearance,
                size: size,
                testId: testId,
                imgLoading: imgLoading
            })
        }
    }, children || /*#__PURE__*/ $5FkrB.createElement((0, $d14288790f4b809c$export$47fbc0b44cae5559), null)), isPresence && /*#__PURE__*/ $5FkrB.createElement((0, $6e9bed4c4211bcf6$export$2e2bcd8739ae039), {
        appearance: appearance,
        size: indicatorSize,
        presence: typeof presence === 'string' ? presence : undefined,
        testId: testId
    }, customPresenceNode), isStatus && /*#__PURE__*/ $5FkrB.createElement((0, $ab9b93b2f7220925$export$2e2bcd8739ae039), {
        appearance: appearance,
        size: indicatorSize,
        borderColor: borderColor,
        status: typeof status === 'string' ? status : undefined,
        testId: testId
    }, customStatusNode), containerShouldBeImage ? /*#__PURE__*/ $5FkrB.createElement("span", {
        "data-testid": testId && "".concat(testId, "--label"),
        id: labelId,
        hidden: true
    }, defaultLabel) : undefined));
});
$467b7370bd97bdfa$var$Avatar.displayName = 'Avatar';
var $467b7370bd97bdfa$export$2e2bcd8739ae039 = $467b7370bd97bdfa$var$Avatar;



var $f5RPY = parcelRequire("f5RPY");

const $a74c2ca6eadd068f$var$_2 = "._18u0mgjw{margin-left:var(--ds-space-negative-200,-1pc)}";
const $a74c2ca6eadd068f$var$_ = "._1wpz1y6m{align-self:flex-start}";
const $a74c2ca6eadd068f$var$styles = {
    avatarStyle: "_1wpz1y6m _18u0mgjw"
};
const $a74c2ca6eadd068f$var$AtlassianUserIcon = ()=>{
    const user = (0, $f5RPY.useUser)();
    return /*#__PURE__*/ (0, $i3UfC.jsxs)((0, $04267de539304abd$export$fbae5b5ffd8af05e), {
        alignInline: 'center',
        children: [
            /*#__PURE__*/ (0, $i3UfC.jsx)((0, $50101e7733a6b1d7$export$8a485e2e7ed91e8f), {
                size: "xlarge",
                appearance: 'brand'
            }),
            /*#__PURE__*/ (0, $i3UfC.jsx)((0, $467b7370bd97bdfa$export$2e2bcd8739ae039), {
                size: "small",
                src: user?.picture,
                // apply styling to put the avatar in the top-right corner
                as: ({ children: children, ...props })=>/*#__PURE__*/ (0, $i3UfC.jsxs)((0, $dbdf44c207cf40e4$export$2e2bcd8739ae039), {
                        children: [
                            /*#__PURE__*/ (0, $i3UfC.jsx)((0, $c179d2a16dc49323$export$2e2bcd8739ae039), {
                                children: [
                                    $a74c2ca6eadd068f$var$_,
                                    $a74c2ca6eadd068f$var$_2
                                ]
                            }),
                            /*#__PURE__*/ (0, $i3UfC.jsx)("div", {
                                ...props,
                                className: (0, $b02ab0e3a0f362dd$export$2e2bcd8739ae039)([
                                    $a74c2ca6eadd068f$var$styles.avatarStyle
                                ]),
                                children: children
                            })
                        ]
                    })
            })
        ]
    });
};
var $a74c2ca6eadd068f$export$2e2bcd8739ae039 = $a74c2ca6eadd068f$var$AtlassianUserIcon;


const $8c131f63768e3e1e$var$AppLogos = ()=>/*#__PURE__*/ (0, $i3UfC.jsxs)((0, $04267de539304abd$export$fbae5b5ffd8af05e), {
        alignBlock: "center",
        space: 'space.250',
        children: [
            /*#__PURE__*/ (0, $i3UfC.jsx)((0, $6246c410b8633576$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $i3UfC.jsx)((0, $187eceff84f1477d$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $i3UfC.jsx)((0, $a74c2ca6eadd068f$export$2e2bcd8739ae039), {})
        ]
    });
var $8c131f63768e3e1e$export$2e2bcd8739ae039 = $8c131f63768e3e1e$var$AppLogos;



var $i3UfC = parcelRequire("i3UfC");

var $gDiFE = parcelRequire("gDiFE");

var $6bnW7 = parcelRequire("6bnW7");
var $bgNpv = parcelRequire("bgNpv");
const $e515f5506072f67a$var$centeredContentStyles = (0, $gDiFE.xcss)({
    textAlign: 'center'
});
const $e515f5506072f67a$var$messages = (0, $6bnW7.defineMessages)({
    title: {
        id: 'heading',
        defaultMessage: 'Someone is requesting access to your Atlassian account',
        description: 'Heading for oauth'
    }
});
const $e515f5506072f67a$var$Header = ()=>/*#__PURE__*/ (0, $i3UfC.jsx)((0, $383dd904a5a5e5b0$export$e71c4d32a2263218), {
        xcss: $e515f5506072f67a$var$centeredContentStyles,
        children: /*#__PURE__*/ (0, $i3UfC.jsx)((0, $bgNpv.default), {
            ...$e515f5506072f67a$var$messages.title,
            tagName: "h1"
        })
    });
var $e515f5506072f67a$export$2e2bcd8739ae039 = $e515f5506072f67a$var$Header;


const $4f2debdb1bd98654$var$Headline = ()=>{
    return /*#__PURE__*/ (0, $i3UfC.jsxs)((0, $i3UfC.Fragment), {
        children: [
            /*#__PURE__*/ (0, $i3UfC.jsx)((0, $8c131f63768e3e1e$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $i3UfC.jsx)((0, $e515f5506072f67a$export$2e2bcd8739ae039), {})
        ]
    });
};
var $4f2debdb1bd98654$export$2e2bcd8739ae039 = $4f2debdb1bd98654$var$Headline;


const $c83aa9613c11c042$var$EcoSystem = ()=>{
    return /*#__PURE__*/ (0, $i3UfC.jsxs)((0, $1b254ba6a068f2f1$export$f51f4c4ede09e011), {
        gap: "space.400",
        direction: "column",
        wrap: "wrap",
        alignItems: "start",
        children: [
            /*#__PURE__*/ (0, $i3UfC.jsx)((0, $1b254ba6a068f2f1$export$f51f4c4ede09e011), {
                alignItems: "center",
                direction: "column",
                gap: "space.400",
                children: /*#__PURE__*/ (0, $i3UfC.jsx)((0, $4f2debdb1bd98654$export$2e2bcd8739ae039), {})
            }),
            /*#__PURE__*/ (0, $i3UfC.jsx)((0, $d37e54d793f8ad25$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $i3UfC.jsx)((0, $8c15e6225feca7b4$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $i3UfC.jsx)((0, $8b2e252b2574531c$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $i3UfC.jsx)((0, $bced07e497c74911$export$2e2bcd8739ae039), {})
        ]
    });
};
var $c83aa9613c11c042$export$2e2bcd8739ae039 = $c83aa9613c11c042$var$EcoSystem;



var $i3UfC = parcelRequire("i3UfC");


var $i3UfC = parcelRequire("i3UfC");
/* AppLogos.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $i3UfC = parcelRequire("i3UfC");
parcelRequire("5FkrB");



var $5FkrB = parcelRequire("5FkrB");

var $2nBsU = parcelRequire("2nBsU");

var $gDiFE = parcelRequire("gDiFE");

var $10b0af967ce59e29$var$flexGrowMap = {
    hug: (0, $gDiFE.xcss)({
        flexGrow: 0
    }),
    fill: (0, $gDiFE.xcss)({
        width: '100%',
        flexGrow: 1
    })
};
var $10b0af967ce59e29$var$separatorStyles = (0, $2nBsU.css)({
    color: "var(--ds-text-subtle, #42526E)",
    marginBlock: "var(--ds-space-0, 0px)",
    marginInline: "var(--ds-space-negative-025, -2px)",
    pointerEvents: 'none',
    userSelect: 'none'
});
var $10b0af967ce59e29$var$Separator = function Separator(_ref) {
    var children = _ref.children;
    return (0, $2nBsU.jsx)("span", {
        css: $10b0af967ce59e29$var$separatorStyles
    }, children);
};
var $10b0af967ce59e29$export$fbae5b5ffd8af05e = /*#__PURE__*/ (0, $5FkrB.memo)(/*#__PURE__*/ (0, $5FkrB.forwardRef)(function(_ref2, ref) {
    var as = _ref2.as, alignInline = _ref2.alignInline, _ref2$alignBlock = _ref2.alignBlock, alignItems = _ref2$alignBlock === void 0 ? 'start' : _ref2$alignBlock, _ref2$shouldWrap = _ref2.shouldWrap, shouldWrap = _ref2$shouldWrap === void 0 ? false : _ref2$shouldWrap, spread = _ref2.spread, grow = _ref2.grow, space = _ref2.space, rowSpace = _ref2.rowSpace, separator = _ref2.separator, xcss = _ref2.xcss, testId = _ref2.testId, role = _ref2.role, id = _ref2.id, rawChildren = _ref2.children;
    var separatorComponent = typeof separator === 'string' ? (0, $2nBsU.jsx)($10b0af967ce59e29$var$Separator, null, separator) : separator;
    var children = separatorComponent ? (0, $5FkrB.Children).toArray(rawChildren).filter(Boolean).map(function(child, index) {
        return (0, $2nBsU.jsx)((0, $5FkrB.Fragment), {
            key: index
        }, separator && index > 0 ? separatorComponent : null, child);
    }) : rawChildren;
    var justifyContent = spread || alignInline;
    // We're type coercing this as Compiled styles in an array isn't supported by the types
    // But the runtime accepts it none-the-wiser. We can remove this entire block and replace
    // it with cx(defaultStyles, focusRingStyles, xcssStyles) when we've moved away from Emotion.
    var styles = grow ? [
        $10b0af967ce59e29$var$flexGrowMap[grow]
    ].concat((0, $05828ba174ac1fc0$export$2e2bcd8739ae039)(Array.isArray(xcss) ? xcss : [
        xcss
    ])) : xcss;
    return (0, $2nBsU.jsx)((0, $1b254ba6a068f2f1$export$f51f4c4ede09e011), {
        id: id,
        as: as,
        role: role,
        alignItems: alignItems,
        justifyContent: justifyContent,
        direction: "row",
        gap: space,
        rowGap: rowSpace,
        wrap: shouldWrap ? 'wrap' : undefined,
        xcss: styles,
        testId: testId,
        ref: ref
    }, children);
}));
$10b0af967ce59e29$export$fbae5b5ffd8af05e.displayName = 'Inline';
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$10b0af967ce59e29$export$2e2bcd8739ae039 = $10b0af967ce59e29$export$fbae5b5ffd8af05e;


var $94d2f5c76a2afb62$exports = {};
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::86e4cb0cec8e9e12166c70b4519c936c>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty($94d2f5c76a2afb62$exports, "__esModule", {
    value: true
});
$94d2f5c76a2afb62$exports.default = void 0;

var $94d2f5c76a2afb62$var$_react = $94d2f5c76a2afb62$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $94d2f5c76a2afb62$var$_iconNew = $94d2f5c76a2afb62$var$_interopRequireDefault((parcelRequire("gDzom")));
function $94d2f5c76a2afb62$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Changes".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/changes
 * Usage guidance:
 * Single purpose - Reserved for changes in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $94d2f5c76a2afb62$var$ChangesIcon = (props)=>/*#__PURE__*/ $94d2f5c76a2afb62$var$_react.default.createElement($94d2f5c76a2afb62$var$_iconNew.default, Object.assign({
        name: "ChangesIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M14.78 4.22 11.53.97l-1.06 1.06L12.44 4H2v1.5h10.44l-1.97 1.97 1.06 1.06 3.25-3.25a.75.75 0 0 0 0-1.06M3.56 10.5l1.97-1.97-1.06-1.06-3.25 3.25a.75.75 0 0 0 0 1.06l3.25 3.25 1.06-1.06L3.56 12H14v-1.5z" clip-rule="evenodd"/>`
    }, props));
$94d2f5c76a2afb62$var$ChangesIcon.displayName = 'ChangesIcon';
var $94d2f5c76a2afb62$var$_default = $94d2f5c76a2afb62$exports.default = $94d2f5c76a2afb62$var$ChangesIcon;


/* Logo.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $i3UfC = parcelRequire("i3UfC");
parcelRequire("5FkrB");

/* tile.tsx generated by @compiled/babel-plugin v2.0.0 */ /* eslint-disable @atlaskit/ui-styling-standard/no-important-styles */ 
var $5FkrB = parcelRequire("5FkrB");
/**
 * The length of the value hash portion of an atomic class name.
 * Atomic class names have the format: `_<group><value>`
 * where group is ATOMIC_GROUP_HASH_LENGTH chars and value is ATOMIC_VALUE_HASH_LENGTH chars.
 *
 * We extract the group key using: `className.slice(0, className.length - ATOMIC_VALUE_HASH_LENGTH)`
 *
 * We support both old-format classes (9 chars: `_` + 4 group + 4 value) and
 * new-format classes (11 chars: `_` + 6 group + 4 value) by using length-based
 * extraction rather than a hardcoded offset — old and new format group keys
 * are different lengths so they are structurally disjoint and never alias each other.
 */ const $07491f51e5b0a24e$var$ATOMIC_VALUE_HASH_LENGTH = 4;
function $07491f51e5b0a24e$export$2e2bcd8739ae039(classNames) {
    // Shortcut: nothing to do
    if (!classNames.length) return;
    // Shortcut: don't need to do anything if we only have a single classname
    if (classNames.length === 1 && classNames[0] && // checking to see if `classNames[0]` is a string that contains other classnames
    !classNames[0].includes(' ')) return classNames[0];
    // Using an object rather than a `Map` as it performed better in our benchmarks.
    // Would be happy to move to `Map` if it proved to be better under real conditions.
    const map = {};
    // Note: using loops to minimize iterations over the collection
    for (const value of classNames){
        // Exclude all falsy values, which leaves us with populated strings
        if (!value) continue;
        // a `value` can contain multiple classnames
        const list = value.split(' ');
        for (const className of list){
            /**
             * For atomic style classnames: the `key` is the `group`
             *
             * - Later atomic classnames with the same `group` will override earlier ones
             *   (which is what we want).
             * - Assumes atomic classnames are the only things that start with `_`
             * - Could use a regex to ensure that atomic classnames are structured how we expect,
             *   but did not add that for now as it did slow things down a bit.
             *
             * For other classnames: the `key` is the whole classname
             * - Okay to remove duplicates as doing so does not impact specificity
             *
             * */ const key = className.startsWith('_') ? className.slice(0, className.length - $07491f51e5b0a24e$var$ATOMIC_VALUE_HASH_LENGTH) : className;
            map[key] = className;
        }
    }
    /**
     * We are converting the `map` into a string.
     *
     * The simple way to do this would be `Object.values(map).join(' ')`.
     * However, the approach below performs 10%-20% better in benchmarks.
     *
     * For `ax()` it feels right to squeeze as much runtime performance out as we can.
     */ let result = '';
    for(const key in map)result += map[key] + ' ';
    // If we have an empty string, then our `map` was empty.
    if (!result) return;
    // remove last " " from the result (we added " " at the end of every value)
    return result.trimEnd();
}



// Pixel sizes per tile size, used for retina validation
var $0020f204f1f5986b$var$tileSizePx = {
    xxsmall: 16,
    xsmall: 20,
    small: 24,
    medium: 32,
    large: 40,
    xlarge: 48
};
var $0020f204f1f5986b$var$styles = {
    root: "_2rkol0p1 _1reo15vq _18m915vq _kqswh2mm _1e0c116y _vchhusvi _4cvr1h6o _1bah1h6o _1o9zidpf _16jlidpf _1ul9idpf _1tkeidpf _s7n4nkob",
    border: "_189ee4h9 _1dqonqa1 _1h6d1l7x",
    inset: "_1iia1wug _bna71wug _1xjx1wug _17521wug",
    nonInset: "_1qwg1osq _mezj1osq _e2oo1osq _w8l51osq _1iia1osq _bna71osq _1xjx1osq _17521osq _1jpx1dfr"
};
var $0020f204f1f5986b$var$sizeMap = {
    xxsmall: "_1bsb7vkz _4t3i7vkz _1wyb19bv",
    xsmall: "_1bsbgktf _4t3igktf _1wyb1crf",
    small: "_1bsb1tcg _4t3i1tcg _1wybdlk8",
    medium: "_1bsbzwfg _4t3izwfg _1wyb7vkz",
    large: "_1bsb1ylp _4t3i1ylp _1wybgktf",
    xlarge: "_1bsbckbl _4t3ickbl _1wyb1tcg"
};
var $0020f204f1f5986b$var$insetSizeMap = {
    xxsmall: "_1qwg19bv _mezj19bv _e2oo19bv _w8l519bv _5ile19el _1hdc19el _1pc719el _pkax19el",
    xsmall: "_1qwg1crf _mezj1crf _e2oo1crf _w8l51crf _5ilemccc _1hdcmccc _1pc7mccc _pkaxmccc",
    small: "_1qwgdlk8 _mezjdlk8 _e2oodlk8 _w8l5dlk8 _5ilewk7l _1hdcwk7l _1pc7wk7l _pkaxwk7l",
    medium: "_1qwg7vkz _mezj7vkz _e2oo7vkz _w8l57vkz _5ile1gpt _1hdc1gpt _1pc71gpt _pkax1gpt",
    large: "_1qwggktf _mezjgktf _e2oogktf _w8l5gktf _5ile1txs _1hdc1txs _1pc71txs _pkax1txs",
    xlarge: "_1qwg1tcg _mezj1tcg _e2oo1tcg _w8l51tcg _5ilea982 _1hdca982 _1pc7a982 _pkaxa982"
};
var $0020f204f1f5986b$var$backgroundColorMap = {
    white: "_bfhku67f",
    black: "_bfhkr3uz",
    transparent: "_bfhk1j28",
    'color.background.accent.lime.subtlest': "_bfhkm890",
    'color.background.accent.lime.subtler': "_bfhkz2ec",
    'color.background.accent.lime.subtle': "_bfhkbq5w",
    'color.background.accent.lime.bolder': "_bfhktde4",
    'color.background.accent.red.subtlest': "_bfhk1vk5",
    'color.background.accent.red.subtler': "_bfhk1rtt",
    'color.background.accent.red.subtle': "_bfhkkrt9",
    'color.background.accent.red.bolder': "_bfhkuibq",
    'color.background.accent.orange.subtlest': "_bfhkf5uh",
    'color.background.accent.orange.subtler': "_bfhk165s",
    'color.background.accent.orange.subtle': "_bfhk1kkj",
    'color.background.accent.orange.bolder': "_bfhk1qg1",
    'color.background.accent.yellow.subtlest': "_bfhkibhp",
    'color.background.accent.yellow.subtler': "_bfhk1773",
    'color.background.accent.yellow.subtle': "_bfhk8y3s",
    'color.background.accent.yellow.bolder': "_bfhk1vop",
    'color.background.accent.green.subtlest': "_bfhkn729",
    'color.background.accent.green.subtler': "_bfhk1wnw",
    'color.background.accent.green.subtle': "_bfhk1rsu",
    'color.background.accent.green.bolder': "_bfhk1e5c",
    'color.background.accent.teal.subtlest': "_bfhk7xuz",
    'color.background.accent.teal.subtler': "_bfhk1a17",
    'color.background.accent.teal.subtle': "_bfhktdv8",
    'color.background.accent.teal.bolder': "_bfhk2c8p",
    'color.background.accent.blue.subtlest': "_bfhk1s93",
    'color.background.accent.blue.subtler': "_bfhk1dy8",
    'color.background.accent.blue.subtle': "_bfhk115i",
    'color.background.accent.blue.bolder': "_bfhk16e3",
    'color.background.accent.purple.subtlest': "_bfhkp2ly",
    'color.background.accent.purple.subtler': "_bfhk1nm4",
    'color.background.accent.purple.subtle': "_bfhk18ah",
    'color.background.accent.purple.bolder': "_bfhkya33",
    'color.background.accent.magenta.subtlest': "_bfhk8tvm",
    'color.background.accent.magenta.subtler': "_bfhkv9ra",
    'color.background.accent.magenta.subtle': "_bfhk1mi6",
    'color.background.accent.magenta.bolder': "_bfhkc3uk",
    'color.background.accent.gray.subtlest': "_bfhkysee",
    'color.background.accent.gray.subtler': "_bfhk7qp0",
    'color.background.accent.gray.subtle': "_bfhk18j9",
    'color.background.accent.gray.bolder': "_bfhk1i45",
    'color.background.inverse.subtle': "_bfhk1vck",
    'color.background.neutral': "_bfhki8nm",
    'color.background.neutral.bold': "_bfhk1aqn",
    'color.background.brand.subtlest': "_bfhk1gmr",
    'color.background.brand.bold': "_bfhk1856",
    'color.background.brand.boldest': "_bfhk1o4i",
    'color.background.danger': "_bfhk1gly",
    'color.background.danger.bold': "_bfhkybec",
    'color.background.warning': "_bfhk1917",
    'color.background.warning.bold': "_bfhk1kmu",
    'color.background.success': "_bfhk1y9u",
    'color.background.success.bold': "_bfhkkcmj",
    'color.background.discovery': "_bfhk6vm6",
    'color.background.discovery.bold': "_bfhku5tj",
    'color.background.information': "_bfhk19ip",
    'color.background.information.bold': "_bfhkx4w0"
};
function $0020f204f1f5986b$export$2e2bcd8739ae039(props) {
    var children = props.children, label = props.label, _props$size = props.size, size = _props$size === void 0 ? 'medium' : _props$size, backgroundColor = props.backgroundColor, hasBorder = props.hasBorder, _props$isInset = props.isInset, isInset = _props$isInset === void 0 ? true : _props$isInset, testId = props.testId;
    var containerRef = (0, $5FkrB.useRef)(null);
    // Dev-mode only: validate that raster images passed into the tile
    // are square and retina-compatible (at least 2x the rendered tile size).
    (0, $5FkrB.useEffect)(function() {
        var _tileSizePx$size;
        var container, images, defaultSizePx, tilePx, unbinds;
        return;
    }, [
        children,
        size
    ]);
    return /*#__PURE__*/ $5FkrB.createElement("span", {
        ref: containerRef,
        "data-testid": testId,
        "aria-label": label !== '' ? label : undefined,
        role: label !== '' ? 'img' : undefined,
        className: (0, $07491f51e5b0a24e$export$2e2bcd8739ae039)([
            $0020f204f1f5986b$var$styles.root,
            $0020f204f1f5986b$var$sizeMap[size],
            isInset ? $0020f204f1f5986b$var$styles.inset : $0020f204f1f5986b$var$styles.nonInset,
            isInset && $0020f204f1f5986b$var$insetSizeMap[size],
            $0020f204f1f5986b$var$backgroundColorMap[backgroundColor || 'color.background.neutral'],
            hasBorder && $0020f204f1f5986b$var$styles.border
        ])
    }, children);
}


/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5FkrB = parcelRequire("5FkrB");

var $2nBsU = parcelRequire("2nBsU");




/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::828feee5f551f4f72139928d095ef0f9>>
 * @codegenCommand yarn workspace @atlaskit/primitives codegen-styles
 * @codegenDependency ../../../tokens/src/artifacts/tokens-raw/atlassian-light.tsx <<SignedSource::4e25079e2363933fae45ad0f1e9c123b>>
 */ var $75372494f37b0909$export$2185ce37f9bdd963 = {
    'color.background.neutral.bold': 'color.text.inverse',
    'color.background.neutral.bold.hovered': 'color.text.inverse',
    'color.background.neutral.bold.pressed': 'color.text.inverse',
    'color.background.selected.bold': 'color.text.inverse',
    'color.background.selected.bold.hovered': 'color.text.inverse',
    'color.background.selected.bold.pressed': 'color.text.inverse',
    'color.background.brand.bold': 'color.text.inverse',
    'color.background.brand.bold.hovered': 'color.text.inverse',
    'color.background.brand.bold.pressed': 'color.text.inverse',
    'color.background.brand.boldest': 'color.text.inverse',
    'color.background.brand.boldest.hovered': 'color.text.inverse',
    'color.background.brand.boldest.pressed': 'color.text.inverse',
    'color.background.danger.bold': 'color.text.inverse',
    'color.background.danger.bold.hovered': 'color.text.inverse',
    'color.background.danger.bold.pressed': 'color.text.inverse',
    'color.background.warning.bold': 'color.text.warning.inverse',
    'color.background.warning.bold.hovered': 'color.text.warning.inverse',
    'color.background.warning.bold.pressed': 'color.text.warning.inverse',
    'color.background.success.bold': 'color.text.inverse',
    'color.background.success.bold.hovered': 'color.text.inverse',
    'color.background.success.bold.pressed': 'color.text.inverse',
    'color.background.discovery.bold': 'color.text.inverse',
    'color.background.discovery.bold.hovered': 'color.text.inverse',
    'color.background.discovery.bold.pressed': 'color.text.inverse',
    'color.background.information.bold': 'color.text.inverse',
    'color.background.information.bold.hovered': 'color.text.inverse',
    'color.background.information.bold.pressed': 'color.text.inverse',
    'color.rovo.background.brand.bold': 'color.text.inverse',
    'color.rovo.background.brand.bold.hovered': 'color.text.inverse',
    'color.rovo.background.brand.bold.pressed': 'color.text.inverse'
};


// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled


var $6jMrz = parcelRequire("6jMrz");
var $fbca0cfef91c3ba3$export$3a1bcba60b23d7f0 = (0, $998f42a130fbeae1$export$ca0f9c2de39ffed7)('color', (0, $6jMrz.textColorMap));


// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled

/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::610f7a87b5183bc177338e33463cac82>>
 * @codegenCommand yarn workspace @atlaskit/primitives codegen-styles
 * @codegenDependency ../../scripts/codegen-file-templates/dimensions.tsx <<SignedSource::cc9b3f12104c6ede803da6a42daac0b0>>
 * @codegenDependency ../../scripts/codegen-file-templates/layer.tsx <<SignedSource::92793ca02dbfdad66e53ffbe9f0baa0a>>
 */ var $c9a6511ed0151e9a$export$236bfe3a33ef1292 = {
    medium: "var(--ds-font-body, normal 400 14px/20px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    large: "var(--ds-font-body-large, normal 400 16px/24px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    small: "var(--ds-font-body-small, normal 400 12px/16px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
};


var $bb858d9269c98c26$export$219d364c0da35ae4 = (0, $998f42a130fbeae1$export$ca0f9c2de39ffed7)('font', (0, $c9a6511ed0151e9a$export$236bfe3a33ef1292));


// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled

/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::771460ab0c298bfffbf486012c7cfab6>>
 * @codegenCommand yarn workspace @atlaskit/primitives codegen-styles
 * @codegenDependency ../../scripts/codegen-file-templates/dimensions.tsx <<SignedSource::cc9b3f12104c6ede803da6a42daac0b0>>
 * @codegenDependency ../../scripts/codegen-file-templates/layer.tsx <<SignedSource::92793ca02dbfdad66e53ffbe9f0baa0a>>
 */ var $cb1302c29e5dd03b$export$855cfd311192d666 = {
    bold: "var(--ds-font-weight-bold, 653)",
    medium: "var(--ds-font-weight-medium, 500)",
    regular: "var(--ds-font-weight-regular, 400)",
    semibold: "var(--ds-font-weight-semibold, 600)"
};


var $6bbc4b7537635055$export$38845ca010b93505 = (0, $998f42a130fbeae1$export$ca0f9c2de39ffed7)('fontWeight', (0, $cb1302c29e5dd03b$export$855cfd311192d666));


var $d48daa9a522ca942$var$asAllowlist = [
    'span',
    'p',
    'strong',
    'em'
];
// We're doing this because our CSS reset can add top margins to elements such as `p` which is totally insane.
// Long term we should remove those instances from the reset - it should be a reset to 0.
// For now, at least we know <Text> will be unaffected by this.
var $d48daa9a522ca942$var$resetStyles = (0, $2nBsU.css)({
    margin: 0,
    overflowWrap: 'anywhere'
});
var $d48daa9a522ca942$var$strongStyles = (0, $2nBsU.css)({
    fontWeight: "var(--ds-font-weight-bold, 653)"
});
var $d48daa9a522ca942$var$emStyles = (0, $2nBsU.css)({
    fontStyle: 'italic'
});
var $d48daa9a522ca942$var$textAlignMap = {
    center: (0, $2nBsU.css)({
        textAlign: 'center'
    }),
    end: (0, $2nBsU.css)({
        textAlign: 'end'
    }),
    start: (0, $2nBsU.css)({
        textAlign: 'start'
    })
};
var $d48daa9a522ca942$var$truncationStyles = (0, $2nBsU.css)({
    display: '-webkit-box',
    overflow: 'hidden',
    WebkitBoxOrient: 'vertical'
});
var $d48daa9a522ca942$var$wordBreakMap = {
    breakAll: (0, $2nBsU.css)({
        wordBreak: 'break-all'
    })
};
/**
 * Custom hook designed to abstract the parsing of the color props and make it clearer in the future how color is reconciled between themes and tokens.
 */ var $d48daa9a522ca942$var$useColor = function useColor(colorProp, hasTextAncestor) {
    var surface = (0, $6aab085817c2aae8$export$1aeb4f6b93c4540d)();
    if (colorProp === 'inherit') return undefined;
    if (colorProp) return colorProp;
    if (hasTextAncestor) return undefined;
    if ((0, $75372494f37b0909$export$2185ce37f9bdd963).hasOwnProperty(surface)) return (0, $75372494f37b0909$export$2185ce37f9bdd963)[surface];
    return 'color.text';
};
var $d48daa9a522ca942$export$5f1af8db9871e1d6 = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? 'span' : _ref$as, colorProp = _ref.color, align = _ref.align, testId = _ref.testId, id = _ref.id, size = _ref.size, weight = _ref.weight, maxLines = _ref.maxLines, children = _ref.children;
    (0, $fff3f31fc3bd4f88$export$2e2bcd8739ae039)($d48daa9a522ca942$var$asAllowlist.includes(Component), "@atlaskit/primitives: Text received an invalid \"as\" value of \"".concat(Component, "\""));
    var hasTextAncestor = (0, $8d1c21dc53d3f2ff$export$9322276ec105d055)();
    var color = $d48daa9a522ca942$var$useColor(colorProp, hasTextAncestor);
    if (!size && !hasTextAncestor) size = 'medium';
    var component = (0, $2nBsU.jsx)(Component, {
        ref: ref,
        css: [
            $d48daa9a522ca942$var$resetStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            size && (0, $bb858d9269c98c26$export$219d364c0da35ae4)[size],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            color && (0, $fbca0cfef91c3ba3$export$3a1bcba60b23d7f0)[color],
            maxLines && $d48daa9a522ca942$var$truncationStyles,
            maxLines === 1 && $d48daa9a522ca942$var$wordBreakMap.breakAll,
            align && $d48daa9a522ca942$var$textAlignMap[align],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            weight && (0, $6bbc4b7537635055$export$38845ca010b93505)[weight],
            Component === 'em' && $d48daa9a522ca942$var$emStyles,
            Component === 'strong' && $d48daa9a522ca942$var$strongStyles
        ],
        style: {
            WebkitLineClamp: maxLines
        },
        "data-testid": testId,
        id: id
    }, children);
    return hasTextAncestor ? // no need to re-apply context if the text is already wrapped
    component : (0, $2nBsU.jsx)((0, $d43805ab09abcfec$export$ae933c6cbe5643ad), {
        value: true
    }, component);
});
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$d48daa9a522ca942$export$2e2bcd8739ae039 = $d48daa9a522ca942$export$5f1af8db9871e1d6;


var $gDiFE = parcelRequire("gDiFE");

var $6hgMx = parcelRequire("6hgMx");
const $9deb9ea8930e5f38$var$_3 = "._u5f31b66{padding-right:var(--ds-space-050,4px)}";
const $9deb9ea8930e5f38$var$_2 = "._1bsbckbl{width:3pc}";
const $9deb9ea8930e5f38$var$_ = "._2rkolb4i{border-radius:var(--ds-radius-xsmall,2px)}";
const $9deb9ea8930e5f38$var$styles = {
    image: "_2rkolb4i _1bsbckbl _u5f31b66"
};
const $9deb9ea8930e5f38$var$initialStyle = (0, $gDiFE.xcss)({
    font: 'font.heading.xlarge'
});
const $9deb9ea8930e5f38$var$Logo = ()=>{
    const { clientLogoUrl: clientLogoUrl, clientName: clientName } = (0, $6hgMx.useToken)();
    if (clientLogoUrl) return /*#__PURE__*/ (0, $i3UfC.jsxs)((0, $dbdf44c207cf40e4$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $i3UfC.jsx)((0, $c179d2a16dc49323$export$2e2bcd8739ae039), {
                children: [
                    $9deb9ea8930e5f38$var$_,
                    $9deb9ea8930e5f38$var$_2,
                    $9deb9ea8930e5f38$var$_3
                ]
            }),
            /*#__PURE__*/ (0, $i3UfC.jsx)("img", {
                src: clientLogoUrl,
                alt: clientName ?? undefined,
                className: (0, $b02ab0e3a0f362dd$export$2e2bcd8739ae039)([
                    $9deb9ea8930e5f38$var$styles.image
                ])
            })
        ]
    });
    const initial = (clientName?.trim() || '?').charAt(0).toUpperCase();
    return /*#__PURE__*/ (0, $i3UfC.jsx)((0, $0020f204f1f5986b$export$2e2bcd8739ae039), {
        label: clientName ?? '',
        size: "xlarge",
        backgroundColor: "color.background.neutral",
        hasBorder: true,
        children: /*#__PURE__*/ (0, $i3UfC.jsx)((0, $d48daa9a522ca942$export$5f1af8db9871e1d6), {
            weight: "bold",
            color: "color.text.subtlest",
            align: "center",
            children: /*#__PURE__*/ (0, $i3UfC.jsx)((0, $383dd904a5a5e5b0$export$e71c4d32a2263218), {
                as: "span",
                xcss: $9deb9ea8930e5f38$var$initialStyle,
                children: initial
            })
        })
    });
};
var $9deb9ea8930e5f38$export$2e2bcd8739ae039 = $9deb9ea8930e5f38$var$Logo;


/* AtlassianUserIcon.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $i3UfC = parcelRequire("i3UfC");
parcelRequire("5FkrB");




var $f5RPY = parcelRequire("f5RPY");

var $gDiFE = parcelRequire("gDiFE");
const $94d90931aefefaf1$var$_2 = "._18u0mgjw{margin-left:var(--ds-space-negative-200,-1pc)}";
const $94d90931aefefaf1$var$_ = "._1wpz1y6m{align-self:flex-start}";
const $94d90931aefefaf1$var$styles = {
    avatarStyle: "_1wpz1y6m _18u0mgjw"
};
const $94d90931aefefaf1$var$atlassianIconSizeStyle = (0, $gDiFE.xcss)({
    width: 'space.600',
    height: 'space.600',
    overflow: 'hidden',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
});
const $94d90931aefefaf1$var$AtlassianUserIcon = ()=>{
    const user = (0, $f5RPY.useUser)();
    return /*#__PURE__*/ (0, $i3UfC.jsxs)((0, $10b0af967ce59e29$export$fbae5b5ffd8af05e), {
        alignInline: 'center',
        children: [
            /*#__PURE__*/ (0, $i3UfC.jsx)((0, $383dd904a5a5e5b0$export$e71c4d32a2263218), {
                xcss: $94d90931aefefaf1$var$atlassianIconSizeStyle,
                children: /*#__PURE__*/ (0, $i3UfC.jsx)((0, $50101e7733a6b1d7$export$8a485e2e7ed91e8f), {
                    size: "xlarge",
                    appearance: 'brand'
                })
            }),
            /*#__PURE__*/ (0, $i3UfC.jsx)((0, $467b7370bd97bdfa$export$2e2bcd8739ae039), {
                size: "small",
                src: user?.picture,
                // apply styling to put the avatar in the top-right corner
                as: ({ children: children, ...props })=>/*#__PURE__*/ (0, $i3UfC.jsxs)((0, $dbdf44c207cf40e4$export$2e2bcd8739ae039), {
                        children: [
                            /*#__PURE__*/ (0, $i3UfC.jsx)((0, $c179d2a16dc49323$export$2e2bcd8739ae039), {
                                children: [
                                    $94d90931aefefaf1$var$_,
                                    $94d90931aefefaf1$var$_2
                                ]
                            }),
                            /*#__PURE__*/ (0, $i3UfC.jsx)("div", {
                                ...props,
                                className: (0, $b02ab0e3a0f362dd$export$2e2bcd8739ae039)([
                                    $94d90931aefefaf1$var$styles.avatarStyle
                                ]),
                                children: children
                            })
                        ]
                    })
            })
        ]
    });
};
var $94d90931aefefaf1$export$2e2bcd8739ae039 = $94d90931aefefaf1$var$AtlassianUserIcon;


const $74bdf394cb21c0c9$var$_6 = "._17521tcg svg{height:24px}";
const $74bdf394cb21c0c9$var$_5 = "._w8l51tcg svg{width:24px}";
const $74bdf394cb21c0c9$var$_4 = "._1o9zidpf{flex-shrink:0}";
const $74bdf394cb21c0c9$var$_3 = "._1bah1h6o{justify-content:center}";
const $74bdf394cb21c0c9$var$_2 = "._4cvr1h6o{align-items:center}";
const $74bdf394cb21c0c9$var$_ = "._1e0c1txw{display:flex}";
const $74bdf394cb21c0c9$var$styles = {
    iconWrapper: "_1e0c1txw _4cvr1h6o _1bah1h6o _1o9zidpf _w8l51tcg _17521tcg"
};
const $74bdf394cb21c0c9$var$AppLogos = ()=>{
    return /*#__PURE__*/ (0, $i3UfC.jsxs)((0, $10b0af967ce59e29$export$fbae5b5ffd8af05e), {
        alignBlock: "center",
        alignInline: "center",
        space: 'space.200',
        children: [
            /*#__PURE__*/ (0, $i3UfC.jsx)((0, $9deb9ea8930e5f38$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $i3UfC.jsxs)((0, $dbdf44c207cf40e4$export$2e2bcd8739ae039), {
                children: [
                    /*#__PURE__*/ (0, $i3UfC.jsx)((0, $c179d2a16dc49323$export$2e2bcd8739ae039), {
                        children: [
                            $74bdf394cb21c0c9$var$_,
                            $74bdf394cb21c0c9$var$_2,
                            $74bdf394cb21c0c9$var$_3,
                            $74bdf394cb21c0c9$var$_4,
                            $74bdf394cb21c0c9$var$_5,
                            $74bdf394cb21c0c9$var$_6
                        ]
                    }),
                    /*#__PURE__*/ (0, $i3UfC.jsx)("span", {
                        className: (0, $b02ab0e3a0f362dd$export$2e2bcd8739ae039)([
                            $74bdf394cb21c0c9$var$styles.iconWrapper
                        ]),
                        children: /*#__PURE__*/ (0, $i3UfC.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($94d2f5c76a2afb62$exports))), {
                            label: ""
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $i3UfC.jsx)((0, $94d90931aefefaf1$export$2e2bcd8739ae039), {})
        ]
    });
};
var $74bdf394cb21c0c9$export$2e2bcd8739ae039 = $74bdf394cb21c0c9$var$AppLogos;



var $i3UfC = parcelRequire("i3UfC");

var $gDiFE = parcelRequire("gDiFE");

var $6bnW7 = parcelRequire("6bnW7");
var $bgNpv = parcelRequire("bgNpv");

var $6hgMx = parcelRequire("6hgMx");
const $70df7a3e2a18a353$var$centeredContentStyles = (0, $gDiFE.xcss)({
    textAlign: 'center'
});
const $70df7a3e2a18a353$var$messages = (0, $6bnW7.defineMessages)({
    title: {
        id: 'heading',
        defaultMessage: '{clientName} is requesting access to your Atlassian account',
        description: 'Heading for Rovo Consent'
    }
});
const $70df7a3e2a18a353$var$Header = ()=>{
    const { clientName: clientName } = (0, $6hgMx.useToken)();
    return /*#__PURE__*/ (0, $i3UfC.jsx)((0, $383dd904a5a5e5b0$export$e71c4d32a2263218), {
        xcss: $70df7a3e2a18a353$var$centeredContentStyles,
        children: /*#__PURE__*/ (0, $i3UfC.jsx)((0, $bgNpv.default), {
            ...$70df7a3e2a18a353$var$messages.title,
            values: {
                clientName: clientName
            },
            tagName: "h1"
        })
    });
};
var $70df7a3e2a18a353$export$2e2bcd8739ae039 = $70df7a3e2a18a353$var$Header;


const $d161e9943379375b$var$Headline = ()=>{
    return /*#__PURE__*/ (0, $i3UfC.jsxs)((0, $i3UfC.Fragment), {
        children: [
            /*#__PURE__*/ (0, $i3UfC.jsx)((0, $74bdf394cb21c0c9$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $i3UfC.jsx)((0, $70df7a3e2a18a353$export$2e2bcd8739ae039), {})
        ]
    });
};
var $d161e9943379375b$export$2e2bcd8739ae039 = $d161e9943379375b$var$Headline;



var $i3UfC = parcelRequire("i3UfC");

var $5FkrB = parcelRequire("5FkrB");

var $2gmBL = parcelRequire("2gmBL");



var $gDiFE = parcelRequire("gDiFE");

var $6bnW7 = parcelRequire("6bnW7");
var $hrVKU = parcelRequire("hrVKU");

var $1eXBn = parcelRequire("1eXBn");

var $6hgMx = parcelRequire("6hgMx");

var $leM9a = parcelRequire("leM9a");
// Hardcoded — this is intentionally a temporary internal workaround component.
const $f42c7abbba86ed92$var$BYPASS_SITE = (0, $1eXBn.getEnv)() === 'prod' || (0, $1eXBn.getEnv)() === 'prod-fedm' ? 'hello.atlassian.net' : 'pug.jira-dev.com';
const $f42c7abbba86ed92$var$messages = (0, $6bnW7.defineMessages)({
    warningTitle: {
        id: 'oauth.siteSelectorBypass.warning.title',
        defaultMessage: "Internal workaround \u2014 not for production use",
        description: 'Title of the warning banner shown to internal users when the site bypass is available'
    },
    warningDescription: {
        id: 'oauth.siteSelectorBypass.warning.description',
        defaultMessage: 'Your site list could not be loaded, likely due to a timeout. Enter a site below to bypass. This is an internal workaround only.',
        description: 'Body of the bypass warning banner shown to internal users'
    },
    siteInputLabel: {
        id: 'oauth.siteSelectorBypass.input.label',
        defaultMessage: 'Site',
        description: 'Label for the site input field in the bypass banner'
    },
    confirmButton: {
        id: 'oauth.siteSelectorBypass.confirm',
        defaultMessage: 'Use this site',
        description: 'Button label to confirm the bypass site selection'
    }
});
const $f42c7abbba86ed92$var$wrapperStyles = (0, $gDiFE.xcss)({
    marginBlockEnd: 'space.200'
});
const $f42c7abbba86ed92$var$inputStyles = (0, $gDiFE.xcss)({
    borderRadius: 'radius.small',
    borderWidth: 'border.width',
    borderStyle: 'solid',
    borderColor: 'color.border',
    paddingInline: 'space.100',
    paddingBlock: 'space.075',
    font: 'font.body',
    backgroundColor: 'color.background.input',
    color: 'color.text',
    width: '100%'
});
/**
 * Internal-only bypass banner shown when the feature gate is enabled.
 * Allows internal users to manually select a site when the site list fails to load.
 *
 * ⚠️ This is NOT intended for production end-users. Gate access appropriately.
 */ const $f42c7abbba86ed92$var$SiteBypassBanner = ()=>{
    const bypassEnabled = (0, $2gmBL.useFeatureGate)((0, $leM9a.OAuthConsentFeatureGate).SITE_SELECTOR_BYPASS);
    const { setSelectedWorkspace: setSelectedWorkspace } = (0, $6hgMx.useSelectedWorkspace)();
    const { formatMessage: formatMessage } = (0, $hrVKU.default)();
    const [inputValue, setInputValue] = (0, $5FkrB.useState)($f42c7abbba86ed92$var$BYPASS_SITE);
    if (!bypassEnabled) return null;
    return /*#__PURE__*/ (0, $i3UfC.jsx)((0, $383dd904a5a5e5b0$export$e71c4d32a2263218), {
        xcss: $f42c7abbba86ed92$var$wrapperStyles,
        children: /*#__PURE__*/ (0, $i3UfC.jsx)((0, $ac2404b057b8688e$export$2e2bcd8739ae039), {
            appearance: "warning",
            title: formatMessage($f42c7abbba86ed92$var$messages.warningTitle),
            children: /*#__PURE__*/ (0, $i3UfC.jsxs)((0, $c8dbef6c41cfa689$export$694e0d28c7ffc90c), {
                space: "space.150",
                children: [
                    /*#__PURE__*/ (0, $i3UfC.jsx)((0, $d48daa9a522ca942$export$5f1af8db9871e1d6), {
                        as: "p",
                        children: formatMessage($f42c7abbba86ed92$var$messages.warningDescription)
                    }),
                    /*#__PURE__*/ (0, $i3UfC.jsxs)((0, $c8dbef6c41cfa689$export$694e0d28c7ffc90c), {
                        space: "space.075",
                        children: [
                            /*#__PURE__*/ (0, $i3UfC.jsx)("label", {
                                htmlFor: "oauth-consent-site-bypass-input",
                                children: /*#__PURE__*/ (0, $i3UfC.jsx)((0, $d48daa9a522ca942$export$5f1af8db9871e1d6), {
                                    size: "small",
                                    weight: "medium",
                                    children: formatMessage($f42c7abbba86ed92$var$messages.siteInputLabel)
                                })
                            }),
                            /*#__PURE__*/ (0, $i3UfC.jsx)((0, $383dd904a5a5e5b0$export$e71c4d32a2263218), {
                                as: "input",
                                id: "oauth-consent-site-bypass-input",
                                xcss: $f42c7abbba86ed92$var$inputStyles,
                                value: inputValue,
                                onChange: (e)=>setInputValue(e.target.value)
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $i3UfC.jsx)((0, $10b0af967ce59e29$export$fbae5b5ffd8af05e), {
                        children: /*#__PURE__*/ (0, $i3UfC.jsx)((0, $a21e01c03a9c4d94$export$2e2bcd8739ae039), {
                            appearance: "primary",
                            isDisabled: !inputValue.trim(),
                            onClick: ()=>setSelectedWorkspace(inputValue.trim()),
                            children: formatMessage($f42c7abbba86ed92$var$messages.confirmButton)
                        })
                    })
                ]
            })
        })
    });
};
var $f42c7abbba86ed92$export$2e2bcd8739ae039 = $f42c7abbba86ed92$var$SiteBypassBanner;



var $i3UfC = parcelRequire("i3UfC");

var $5FkrB = parcelRequire("5FkrB");

// src/errors.ts
var $07fac4a24490da55$export$2191b9da168c6cf0 = class extends Error {
};


// src/core/rules/platform-qualifier.ts
function $2e9d97018bf6825a$export$4f6e8fa90a16fdc4(qualifier) {
    if (qualifier !== "cloud" && qualifier !== "third-party") throw new (0, $07fac4a24490da55$export$2191b9da168c6cf0)(`Identifier must have a qualifier of 'cloud' or 'third-party'. Received: ${qualifier}`);
}
// src/core/rules/qualifier.ts
function $2e9d97018bf6825a$export$da331df28ad1f3d9(qualifier) {
    if (qualifier !== "ati") throw new (0, $07fac4a24490da55$export$2191b9da168c6cf0)(`ATI must have a qualifier of 'ati'. Received: ${qualifier}`);
}
function $2e9d97018bf6825a$export$822bcd2b6f6774a1(qualifier) {
    if (qualifier !== "ari") throw new (0, $07fac4a24490da55$export$2191b9da168c6cf0)(`ARI must have a qualifier of 'ari'. Received: ${qualifier}`);
}
function $2e9d97018bf6825a$export$277c2bbc487e609d(qualifier) {
    if (qualifier !== "arm") throw new (0, $07fac4a24490da55$export$2191b9da168c6cf0)(`ARM must have a qualifier of 'arm'. Received: ${qualifier}`);
}
// src/core/parser/base.ts
var $2e9d97018bf6825a$var$NUMBER_OF_BASE_SEGMENTS = 5, $2e9d97018bf6825a$var$SEGMENT_SEPARATOR = ":", $2e9d97018bf6825a$export$3d09a5c28ff3e040 = class {
    static getIdentifierSegments(inputStr, numberOfSegmentsRequired) {
        let allSegments = inputStr.split($2e9d97018bf6825a$var$SEGMENT_SEPARATOR);
        if (allSegments.length < numberOfSegmentsRequired) throw new (0, $07fac4a24490da55$export$2191b9da168c6cf0)(`Input string must have ${numberOfSegmentsRequired} segments.`);
        if (allSegments.length > numberOfSegmentsRequired) {
            let segments = allSegments.slice(0, $2e9d97018bf6825a$var$NUMBER_OF_BASE_SEGMENTS - 1), segmentsForResourceId = allSegments.slice($2e9d97018bf6825a$var$NUMBER_OF_BASE_SEGMENTS - 1, allSegments.length);
            return [
                ...segments,
                segmentsForResourceId.join($2e9d97018bf6825a$var$SEGMENT_SEPARATOR)
            ];
        }
        return allSegments;
    }
};



// src/core/rules/cloud-id.ts
function $784712d91e782262$var$validateCloudId(cloudId, format = new RegExp("^[a-zA-Z0-9_\\-.]{0,255}$")) {
    if (!cloudId.match(format)) throw new (0, $07fac4a24490da55$export$2191b9da168c6cf0)(`Invalid cloud ID, expected ID of format ${format}.`);
}
// src/core/rules/resource-id.ts
function $784712d91e782262$var$validateResourceId(id, format = new RegExp("[!a-zA-Z0-9\\-_.~@:;{}=]+(/[!a-zA-Z0-9\\-_.~@:;{}=]+)*" /* ANY_RESOURCE_ID */ ), key = "resourceId") {
    let formatWithCarets = new RegExp(`^${format.source}$`);
    if (!id.match(formatWithCarets)) throw new (0, $07fac4a24490da55$export$2191b9da168c6cf0)(`Invalid ${key} - ${id}, expected ID of format ${formatWithCarets}.`);
}
// src/core/rules/resource-id-segments.ts
function $784712d91e782262$var$validateResourceIdSegments(resourceIdSegmentValues, resourceIdSegmentFormats) {
    Object.entries(resourceIdSegmentValues).forEach(([resourceIdKey, resourceIdValue])=>{
        $784712d91e782262$var$validateResourceId(resourceIdValue, resourceIdSegmentFormats == null ? void 0 : resourceIdSegmentFormats[resourceIdKey], resourceIdKey);
    });
}
// src/core/rules/resource-owner.ts
function $784712d91e782262$var$validateResourceOwner(owner, expectedResourceOwner) {
    if (expectedResourceOwner && owner !== expectedResourceOwner) throw new (0, $07fac4a24490da55$export$2191b9da168c6cf0)(`Invalid resource owner - ${owner}, expected ${expectedResourceOwner}.`);
}
// src/core/rules/resource-type.ts
function $784712d91e782262$var$validateResourceType(type, expectedResourceType) {
    if (expectedResourceType && type !== expectedResourceType) throw new (0, $07fac4a24490da55$export$2191b9da168c6cf0)(`Invalid resource type - ${type}, expected ${expectedResourceType}.`);
}
// src/core/parser/ari.ts
var $784712d91e782262$var$NUMBER_OF_ARI_SEGMENTS = 5, $784712d91e782262$export$4c3a8cde7a55740b = class extends (0, $2e9d97018bf6825a$export$3d09a5c28ff3e040) {
    static fromString(maybeAri, ariProperties) {
        let segments = this.getIdentifierSegments(maybeAri, $784712d91e782262$var$NUMBER_OF_ARI_SEGMENTS), [qualifier, platformQualifier, resourceOwner, cloudId, resourceTypeAndId] = segments, [resourceType, ...resourceIdSegments] = resourceTypeAndId.split("/"), maybeAriDerivedProperties = {
            qualifier: qualifier,
            platformQualifier: platformQualifier,
            cloudId: cloudId,
            resourceOwner: resourceOwner,
            resourceType: resourceType,
            resourceId: resourceIdSegments.join("/"),
            resourceIdSegmentValues: ariProperties != null && ariProperties.resourceIdSlug ? this.ariSegmentValuesFromSlug(ariProperties.resourceIdSlug, resourceIdSegments.join("/"), Object.keys(ariProperties.resourceIdSegmentFormats)) : {}
        };
        return this.fromOpts(maybeAriDerivedProperties, ariProperties);
    }
    static fromOpts(maybeAriOpts, ariProperties) {
        let { qualifier: qualifier = "ari", platformQualifier: platformQualifier = "cloud", resourceOwner: resourceOwner, cloudId: cloudId, resourceId: resourceId, resourceIdSegmentValues: resourceIdSegmentValues, resourceType: resourceType } = maybeAriOpts;
        return (0, $2e9d97018bf6825a$export$822bcd2b6f6774a1)(qualifier), (0, $2e9d97018bf6825a$export$4f6e8fa90a16fdc4)(platformQualifier), $784712d91e782262$var$validateCloudId(maybeAriOpts.cloudId || "", ariProperties == null ? void 0 : ariProperties.cloudId), $784712d91e782262$var$validateResourceOwner(resourceOwner, ariProperties == null ? void 0 : ariProperties.resourceOwner), $784712d91e782262$var$validateResourceType(resourceType, ariProperties == null ? void 0 : ariProperties.resourceType), $784712d91e782262$var$validateResourceIdSegments(resourceIdSegmentValues, ariProperties == null ? void 0 : ariProperties.resourceIdSegmentFormats), {
            qualifier: qualifier,
            resourceOwner: resourceOwner,
            resourceType: resourceType,
            platformQualifier: platformQualifier,
            cloudId: cloudId,
            resourceId: resourceId,
            resourceIdSegmentValues: resourceIdSegmentValues
        };
    }
    static ariSegmentValuesFromSlug(slug, incomingSegments, expectedKeys) {
        let regexpResult = new RegExp("^" + slug.replace(/\{(.*?)\}/g, "(?<$1>.*?)") + "$").exec(incomingSegments);
        if (!regexpResult) throw new (0, $07fac4a24490da55$export$2191b9da168c6cf0)(`Segment '${incomingSegments}' don't match expected slug: ${slug}`);
        return expectedKeys.forEach((expectedKey)=>{
            var _a;
            if (!((_a = regexpResult.groups) != null && _a[expectedKey])) throw new (0, $07fac4a24490da55$export$2191b9da168c6cf0)(`No value supplied for '${expectedKey}' based on slug ${slug}`);
        }), regexpResult.groups || {};
    }
};
// src/core/parser/ati.ts
var $784712d91e782262$var$NUMBER_OF_ATI_SEGMENTS = 4, $784712d91e782262$var$AtiParser = class extends (0, $2e9d97018bf6825a$export$3d09a5c28ff3e040) {
    static fromString(inputStr, atiOpts) {
        let segments = this.getIdentifierSegments(inputStr, $784712d91e782262$var$NUMBER_OF_ATI_SEGMENTS), [qualifier = "ati", platformQualifier = "cloud", resourceOwner, resourceType] = segments;
        return (0, $2e9d97018bf6825a$export$da331df28ad1f3d9)(qualifier), (0, $2e9d97018bf6825a$export$4f6e8fa90a16fdc4)(platformQualifier), $784712d91e782262$var$validateResourceOwner(resourceOwner, atiOpts == null ? void 0 : atiOpts.resourceOwner), $784712d91e782262$var$validateResourceType(resourceType, atiOpts == null ? void 0 : atiOpts.resourceType), {
            platformQualifier: platformQualifier,
            resourceOwner: resourceOwner,
            resourceType: resourceType
        };
    }
    static fromOpts(maybeAtiOpts, atiOpts) {
        let { qualifier: qualifier, platformQualifier: platformQualifier, resourceOwner: resourceOwner, resourceType: resourceType } = maybeAtiOpts;
        return (0, $2e9d97018bf6825a$export$da331df28ad1f3d9)(qualifier), (0, $2e9d97018bf6825a$export$4f6e8fa90a16fdc4)(platformQualifier), $784712d91e782262$var$validateResourceOwner(resourceOwner, atiOpts == null ? void 0 : atiOpts.resourceOwner), $784712d91e782262$var$validateResourceType(resourceType, atiOpts == null ? void 0 : atiOpts.resourceType), {
            platformQualifier: platformQualifier,
            resourceOwner: resourceOwner,
            resourceType: resourceType
        };
    }
};
// src/ati.ts
var $784712d91e782262$export$ab4b293d0121b8ee = class _Ati {
    constructor(platformQualifier, resourceOwner, resourceType){
        this._platformQualifier = platformQualifier, this._resourceOwner = resourceOwner, this._resourceType = resourceType;
    }
    get platformQualifier() {
        return this._platformQualifier;
    }
    get resourceOwner() {
        return this._resourceOwner;
    }
    get resourceType() {
        return this._resourceType;
    }
    static create(opts) {
        return new _Ati(opts.platformQualifier || "cloud", opts.resourceOwner, opts.resourceType);
    }
    static parse(maybeAti, atiOpts) {
        let opts = $784712d91e782262$var$AtiParser.fromString(maybeAti, atiOpts);
        return new _Ati(opts.platformQualifier, opts.resourceOwner, opts.resourceType);
    }
    toString() {
        return `ati:${this.platformQualifier}:${this.resourceOwner}:${this.resourceType}`;
    }
    toJSON() {
        return this.toString();
    }
    toOpts() {
        return {
            platformQualifier: this._platformQualifier,
            resourceOwner: this._resourceOwner,
            resourceType: this._resourceType
        };
    }
};


// src/core/ari.ts
var $2b94537363720eb1$export$3a4885701291260b = class {
    constructor(opts){
        this._ati = (0, $784712d91e782262$export$ab4b293d0121b8ee).create({
            platformQualifier: opts.platformQualifier || "cloud",
            resourceOwner: opts.resourceOwner,
            resourceType: opts.resourceType
        }), this._cloudId = opts.cloudId !== "" ? opts.cloudId : void 0, this._resourceId = opts.resourceId;
    }
    get platformQualifier() {
        return this._ati.platformQualifier;
    }
    get cloudId() {
        return this._cloudId;
    }
    get resourceOwner() {
        return this._ati.resourceOwner;
    }
    get resourceType() {
        return this._ati.resourceType;
    }
    get resourceId() {
        return this._resourceId;
    }
    get ati() {
        return this._ati;
    }
    equals(other) {
        return this.toString() === other.toString();
    }
    toString() {
        return `ari:${this.platformQualifier}:${this.resourceOwner}:${this.cloudId || ""}:${this.resourceType}/${this.resourceId}`;
    }
    toJSON() {
        return this.toString();
    }
    toOpts() {
        return {
            platformQualifier: this.platformQualifier,
            resourceOwner: this.resourceOwner,
            cloudId: this.cloudId,
            resourceType: this.resourceType,
            resourceId: this.resourceId
        };
    }
};
// src/any-ari.ts
var $2b94537363720eb1$export$44a7af7122933d6b = class _AnyAri extends $2b94537363720eb1$export$3a4885701291260b {
    constructor(opts){
        super(opts);
    }
    static create(ariOpts, ariStaticOpts) {
        let ariOptsWithDefaults = {
            ...ariOpts,
            resourceIdSegmentValues: {}
        }, validatedOpts = (0, $784712d91e782262$export$4c3a8cde7a55740b).fromOpts(ariOptsWithDefaults, ariStaticOpts);
        return new _AnyAri(validatedOpts);
    }
    static parse(maybeAri, ariStaticOpts) {
        let validatedOpts = (0, $784712d91e782262$export$4c3a8cde7a55740b).fromString(maybeAri, ariStaticOpts);
        return new _AnyAri(validatedOpts);
    }
    static check(maybeAri) {
        try {
            return _AnyAri.parse(maybeAri.toString()), !0;
        } catch (err) {
            return !1;
        }
    }
    asAnyAri() {
        return this;
    }
};



var $6bnW7 = parcelRequire("6bnW7");
var $hrVKU = parcelRequire("hrVKU");

var $gDiFE = parcelRequire("gDiFE");


var $bNmp1 = parcelRequire("bNmp1");

var $9AP5g = parcelRequire("9AP5g");

var $3ZMUU = parcelRequire("3ZMUU");
function $37190500189da037$export$9e1725a4cfeada27(path, fallback) {
    var token = (0, $bNmp1.default)[path];
    typeof $3ZMUU;
    // if the token is not found - replacing it with variable name without any value, to avoid it being undefined which would result in invalid css
    if (!token) token = (0, $9AP5g.TOKEN_NOT_FOUND_CSS_VAR);
    var tokenCall = fallback ? "var(".concat(token, ", ").concat(fallback, ")") : "var(".concat(token, ")");
    return tokenCall;
}



var $6hgMx = parcelRequire("6hgMx");

var $i3UfC = parcelRequire("i3UfC");

var $5FkrB = parcelRequire("5FkrB");

let $aa88e83ef73ff002$var$avatarManagementEnv;
$aa88e83ef73ff002$var$avatarManagementEnv = 'prod';
const $aa88e83ef73ff002$var$avatarManagementUrl = `https://avatar-management--avatars.us-west-2.${$aa88e83ef73ff002$var$avatarManagementEnv}.public.atl-paas.net`;
const $aa88e83ef73ff002$var$randomAvatarIndex = Math.floor(Math.random() * 7);
const $aa88e83ef73ff002$var$DEFAULT_AVATAR_SUFFIX = '/default-avatar.png';
const $aa88e83ef73ff002$export$3c0b7a175ee69aeb = 'https://settings-cdn-bifrost.stg-east.frontend.public.atl-paas.net/assets/avatars/240/site.png';
function $aa88e83ef73ff002$var$getInitials(name) {
    return name.split(' ').filter((word)=>word.length > 0 && isNaN(Number.parseInt(word[0]))).slice(0, 2).map((word)=>word.at(0)?.toUpperCase()).join('');
}
function $aa88e83ef73ff002$export$73dca5321b609ec4(name) {
    const initials = $aa88e83ef73ff002$var$getInitials(name);
    return initials && `${$aa88e83ef73ff002$var$avatarManagementUrl}/initials/${initials}-${$aa88e83ef73ff002$var$randomAvatarIndex}.png` || `${$aa88e83ef73ff002$var$avatarManagementUrl}${$aa88e83ef73ff002$var$DEFAULT_AVATAR_SUFFIX}`;
}
function $aa88e83ef73ff002$export$e7fa821bd07cfe0d(url) {
    return url.endsWith($aa88e83ef73ff002$var$DEFAULT_AVATAR_SUFFIX);
}



var $i3UfC = parcelRequire("i3UfC");


/**
 * Ported from Trello web so a workspace without a logo looks the same here as
 * it does in Trello:
 * trello/web packages/workspace-logo/src/WorkspaceDefaultLogo.tsx
 *
 * The package is private to that monorepo and cannot be depended on, so the
 * algorithm and palette are duplicated. trello-ios carries a third copy in
 * TrelloUIKit/Avatars/AvatarGradient.swift. Keep the order of GRADIENT_NAMES
 * and the palette in step with those, or the same workspace will render a
 * different colour on each platform.
 */ const $4d395ed39a9e516f$var$GRADIENT_NAMES = [
    'teal',
    'green',
    'blue',
    'pink',
    'orange'
];
function $4d395ed39a9e516f$export$affb8053eda1fddf(name) {
    const sum = name.split('').reduce((total, character)=>total + character.charCodeAt(0), 0);
    return $4d395ed39a9e516f$var$GRADIENT_NAMES[sum % $4d395ed39a9e516f$var$GRADIENT_NAMES.length];
}
const $4d395ed39a9e516f$export$b7cadda71bdc3a69 = {
    // color.background.accent.blue.bolder -> .teal.bolder
    teal: 'linear-gradient(#1868DB, #227D9B)',
    // color.background.accent.green.bolder -> .green.subtle
    green: 'linear-gradient(#1F845A, #4BCE97)',
    // color.background.accent.purple.bolder -> .blue.bolder
    blue: 'linear-gradient(#964AC0, #1868DB)',
    // color.background.accent.magenta.bolder -> .magenta.subtle
    pink: 'linear-gradient(#AE4787, #E774BB)',
    // color.background.accent.red.bolder -> .orange.subtle
    orange: 'linear-gradient(#C9372C, #FCA700)'
};
function $4d395ed39a9e516f$export$3fc3a253ff70abd6(name) {
    return name.trim().substring(0, 1).toUpperCase();
}


/** Trello's default logo font size, from WorkspaceDefaultLogo.module.less. */ const $72b8ec02f9cd8ad0$var$INITIAL_FONT_SIZE = '20px';
/**
 * Fixed white rather than `color.text.inverse`.
 *
 * Trello uses the inverse token, but that flips with colour mode while these
 * gradients do not: every one of them is dark in both themes, so the inverse
 * token renders near-black text on a dark tile in dark mode.
 */ const $72b8ec02f9cd8ad0$var$INITIAL_COLOR = '#ffffff';
const $72b8ec02f9cd8ad0$var$LetterTile = ({ name: name })=>/*#__PURE__*/ (0, $i3UfC.jsx)((0, $0020f204f1f5986b$export$2e2bcd8739ae039), {
        label: "",
        size: "medium",
        isInset: false,
        children: /*#__PURE__*/ (0, $i3UfC.jsx)("div", {
            style: {
                alignItems: 'center',
                background: (0, $4d395ed39a9e516f$export$b7cadda71bdc3a69)[(0, $4d395ed39a9e516f$export$affb8053eda1fddf)(name)],
                color: $72b8ec02f9cd8ad0$var$INITIAL_COLOR,
                display: 'flex',
                fontSize: $72b8ec02f9cd8ad0$var$INITIAL_FONT_SIZE,
                fontWeight: (0, $37190500189da037$export$9e1725a4cfeada27)('font.weight.bold', '700'),
                height: '100%',
                justifyContent: 'center',
                lineHeight: 1,
                width: '100%'
            },
            children: (0, $4d395ed39a9e516f$export$3fc3a253ff70abd6)(name)
        })
    });
var $72b8ec02f9cd8ad0$export$2e2bcd8739ae039 = $72b8ec02f9cd8ad0$var$LetterTile;


const $ebae6d75f4c9721e$var$SiteTile = ({ avatarUrl: avatarUrl, name: name })=>{
    const [hasFailed, setHasFailed] = (0, $5FkrB.useState)(false);
    const src = avatarUrl && !hasFailed ? avatarUrl : null;
    if (!src) return name?.trim() ? /*#__PURE__*/ (0, $i3UfC.jsx)((0, $72b8ec02f9cd8ad0$export$2e2bcd8739ae039), {
        name: name
    }) : /*#__PURE__*/ (0, $i3UfC.jsx)((0, $0020f204f1f5986b$export$2e2bcd8739ae039), {
        label: "",
        size: "medium",
        isInset: false,
        children: /*#__PURE__*/ (0, $i3UfC.jsx)("img", {
            src: (0, $aa88e83ef73ff002$export$3c0b7a175ee69aeb),
            alt: ""
        })
    });
    return /*#__PURE__*/ (0, $i3UfC.jsx)((0, $0020f204f1f5986b$export$2e2bcd8739ae039), {
        label: "",
        size: "medium",
        isInset: false,
        children: /*#__PURE__*/ (0, $i3UfC.jsx)("img", {
            src: src,
            alt: "",
            onError: ()=>setHasFailed(true)
        })
    });
};
var $ebae6d75f4c9721e$export$2e2bcd8739ae039 = $ebae6d75f4c9721e$var$SiteTile;


/**
 * Deterministic colour palette for site tiles. This mirrors the app switcher
 * org unit avatar: sum the display name's char codes, then pick from
 * [purple, blue, lime, yellow].
 *
 * Each entry holds both the token *paths* (for `@atlaskit/tile` / `@atlaskit/text`,
 * which resolve tokens internally) and the *resolved* CSS values (for places
 * that need raw colours). `token()` is only ever called with string literals so
 * static extraction is preserved.
 */ 
const $75748f21d6184a53$export$6b1a2b07ad04beea = {
    red: {
        backgroundToken: 'color.background.accent.red.subtler',
        foregroundToken: 'color.text.accent.red.bolder',
        background: (0, $37190500189da037$export$9e1725a4cfeada27)('color.background.accent.red.subtler'),
        foreground: (0, $37190500189da037$export$9e1725a4cfeada27)('color.text.accent.red.bolder'),
        border: (0, $37190500189da037$export$9e1725a4cfeada27)('color.border.accent.red')
    },
    yellow: {
        backgroundToken: 'color.background.accent.yellow.subtler',
        foregroundToken: 'color.text.accent.yellow.bolder',
        background: (0, $37190500189da037$export$9e1725a4cfeada27)('color.background.accent.yellow.subtler'),
        foreground: (0, $37190500189da037$export$9e1725a4cfeada27)('color.text.accent.yellow.bolder'),
        border: (0, $37190500189da037$export$9e1725a4cfeada27)('color.border.accent.yellow')
    },
    lime: {
        backgroundToken: 'color.background.accent.lime.subtler',
        foregroundToken: 'color.text.accent.lime.bolder',
        background: (0, $37190500189da037$export$9e1725a4cfeada27)('color.background.accent.lime.subtler'),
        foreground: (0, $37190500189da037$export$9e1725a4cfeada27)('color.text.accent.lime.bolder'),
        border: (0, $37190500189da037$export$9e1725a4cfeada27)('color.border.accent.lime')
    },
    green: {
        backgroundToken: 'color.background.accent.green.subtler',
        foregroundToken: 'color.text.accent.green.bolder',
        background: (0, $37190500189da037$export$9e1725a4cfeada27)('color.background.accent.green.subtler'),
        foreground: (0, $37190500189da037$export$9e1725a4cfeada27)('color.text.accent.green.bolder'),
        border: (0, $37190500189da037$export$9e1725a4cfeada27)('color.border.accent.green')
    },
    teal: {
        backgroundToken: 'color.background.accent.teal.subtler',
        foregroundToken: 'color.text.accent.teal.bolder',
        background: (0, $37190500189da037$export$9e1725a4cfeada27)('color.background.accent.teal.subtler'),
        foreground: (0, $37190500189da037$export$9e1725a4cfeada27)('color.text.accent.teal.bolder'),
        border: (0, $37190500189da037$export$9e1725a4cfeada27)('color.border.accent.teal')
    },
    blue: {
        backgroundToken: 'color.background.accent.blue.subtler',
        foregroundToken: 'color.text.accent.blue.bolder',
        background: (0, $37190500189da037$export$9e1725a4cfeada27)('color.background.accent.blue.subtler'),
        foreground: (0, $37190500189da037$export$9e1725a4cfeada27)('color.text.accent.blue.bolder'),
        border: (0, $37190500189da037$export$9e1725a4cfeada27)('color.border.accent.blue')
    },
    purple: {
        backgroundToken: 'color.background.accent.purple.subtler',
        foregroundToken: 'color.text.accent.purple.bolder',
        background: (0, $37190500189da037$export$9e1725a4cfeada27)('color.background.accent.purple.subtler'),
        foreground: (0, $37190500189da037$export$9e1725a4cfeada27)('color.text.accent.purple.bolder'),
        border: (0, $37190500189da037$export$9e1725a4cfeada27)('color.border.accent.purple')
    },
    gray: {
        backgroundToken: 'color.background.accent.gray.subtler',
        foregroundToken: 'color.text.accent.gray.bolder',
        background: (0, $37190500189da037$export$9e1725a4cfeada27)('color.background.accent.gray.subtler'),
        foreground: (0, $37190500189da037$export$9e1725a4cfeada27)('color.text.accent.gray.bolder'),
        border: (0, $37190500189da037$export$9e1725a4cfeada27)('color.border.accent.gray')
    }
};
/** App switcher name-hash palette — order is significant. */ const $75748f21d6184a53$var$SITE_TILE_COLORS = [
    $75748f21d6184a53$export$6b1a2b07ad04beea.purple,
    $75748f21d6184a53$export$6b1a2b07ad04beea.blue,
    $75748f21d6184a53$export$6b1a2b07ad04beea.lime,
    $75748f21d6184a53$export$6b1a2b07ad04beea.yellow
];
const $75748f21d6184a53$var$getColorIndex = (value, paletteLength)=>{
    const charCodeSum = value.split('').reduce((sum, char)=>{
        return sum + char.charCodeAt(0);
    }, 0);
    return charCodeSum % paletteLength;
};
const $75748f21d6184a53$export$bfe779d9e415bcd1 = (value)=>$75748f21d6184a53$var$SITE_TILE_COLORS[$75748f21d6184a53$var$getColorIndex(value, $75748f21d6184a53$var$SITE_TILE_COLORS.length)];
/** Maps each site avatar icon name to its background accent colour. */ const $75748f21d6184a53$var$AVATAR_ICON_COLOR = {
    compass: $75748f21d6184a53$export$6b1a2b07ad04beea.red,
    cup: $75748f21d6184a53$export$6b1a2b07ad04beea.yellow,
    flag: $75748f21d6184a53$export$6b1a2b07ad04beea.yellow,
    triangle: $75748f21d6184a53$export$6b1a2b07ad04beea.yellow,
    rings: $75748f21d6184a53$export$6b1a2b07ad04beea.green,
    trophy: $75748f21d6184a53$export$6b1a2b07ad04beea.green,
    globe: $75748f21d6184a53$export$6b1a2b07ad04beea.teal,
    lightbulb: $75748f21d6184a53$export$6b1a2b07ad04beea.teal,
    pencilmarker: $75748f21d6184a53$export$6b1a2b07ad04beea.teal,
    site: $75748f21d6184a53$export$6b1a2b07ad04beea.teal,
    koala: $75748f21d6184a53$export$6b1a2b07ad04beea.blue,
    star: $75748f21d6184a53$export$6b1a2b07ad04beea.blue,
    jersey: $75748f21d6184a53$export$6b1a2b07ad04beea.purple,
    rocket: $75748f21d6184a53$export$6b1a2b07ad04beea.purple,
    invalid: $75748f21d6184a53$export$6b1a2b07ad04beea.gray
};
const $75748f21d6184a53$var$PNG_EXTENSION = '.png';
const $75748f21d6184a53$export$49dcd04836c46b94 = (avatarUrl)=>{
    if (!avatarUrl) return undefined;
    let pathname;
    try {
        pathname = new URL(avatarUrl).pathname;
    } catch  {
        return undefined;
    }
    const fileName = pathname.split('/').pop()?.toLowerCase() ?? '';
    if (!fileName.endsWith($75748f21d6184a53$var$PNG_EXTENSION)) return undefined;
    return fileName.slice(0, -$75748f21d6184a53$var$PNG_EXTENSION.length) || undefined;
};
const $75748f21d6184a53$export$5f8ff7cb3b9550d1 = (avatarUrl)=>{
    const name = $75748f21d6184a53$export$49dcd04836c46b94(avatarUrl);
    return name ? $75748f21d6184a53$var$AVATAR_ICON_COLOR[name] : undefined;
};


/**
 * @generated SignedSource<<4da14bccaf5157477688b6aaedce9f29>>
 * @lightSyntaxTransform
 * @nogrep
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $f803ebc4221a154e$var$node = function() {
    var v0 = [
        {
            "kind": "Literal",
            "name": "filter",
            "value": {
                "arguments": {
                    "objectTypes": [
                        "issue",
                        "page",
                        "blogpost"
                    ],
                    "products": [
                        "Confluence",
                        "Jira"
                    ]
                }
            }
        },
        {
            "kind": "Literal",
            "name": "first",
            "value": 50
        }
    ], v1 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "rootContainerId",
        "storageKey": null
    }, v2 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
    };
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "metadata": null,
            "name": "mostUsedSitesQuery",
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "Activity",
                    "kind": "LinkedField",
                    "name": "activity",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "MyActivity",
                            "kind": "LinkedField",
                            "name": "myActivity",
                            "plural": false,
                            "selections": [
                                {
                                    "alias": null,
                                    "args": v0 /*: any*/ ,
                                    "concreteType": "ActivityConnection",
                                    "kind": "LinkedField",
                                    "name": "viewed",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "ActivityItemEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "ActivityNode",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": "ActivityObject",
                                                            "kind": "LinkedField",
                                                            "name": "object",
                                                            "plural": false,
                                                            "selections": [
                                                                v1 /*: any*/ 
                                                            ],
                                                            "storageKey": null
                                                        }
                                                    ],
                                                    "storageKey": null
                                                }
                                            ],
                                            "storageKey": null
                                        }
                                    ],
                                    "storageKey": "viewed(filter:{\"arguments\":{\"objectTypes\":[\"issue\",\"page\",\"blogpost\"],\"products\":[\"Confluence\",\"Jira\"]}},first:50)"
                                }
                            ],
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                }
            ],
            "type": "Query",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "mostUsedSitesQuery",
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "Activity",
                    "kind": "LinkedField",
                    "name": "activity",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "MyActivity",
                            "kind": "LinkedField",
                            "name": "myActivity",
                            "plural": false,
                            "selections": [
                                {
                                    "alias": null,
                                    "args": v0 /*: any*/ ,
                                    "concreteType": "ActivityConnection",
                                    "kind": "LinkedField",
                                    "name": "viewed",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "ActivityItemEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "ActivityNode",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": "ActivityObject",
                                                            "kind": "LinkedField",
                                                            "name": "object",
                                                            "plural": false,
                                                            "selections": [
                                                                v1 /*: any*/ ,
                                                                v2 /*: any*/ 
                                                            ],
                                                            "storageKey": null
                                                        },
                                                        v2 /*: any*/ 
                                                    ],
                                                    "storageKey": null
                                                }
                                            ],
                                            "storageKey": null
                                        }
                                    ],
                                    "storageKey": "viewed(filter:{\"arguments\":{\"objectTypes\":[\"issue\",\"page\",\"blogpost\"],\"products\":[\"Confluence\",\"Jira\"]}},first:50)"
                                }
                            ],
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                }
            ]
        },
        "params": {
            "cacheID": "e32bf66a70731d9faa64209385ec1c1a",
            "id": null,
            "metadata": {},
            "name": "mostUsedSitesQuery",
            "operationKind": "query",
            "text": "query mostUsedSitesQuery {\n  activity {\n    myActivity {\n      viewed(first: 50, filter: {arguments: {products: [\"Confluence\", \"Jira\"], objectTypes: [\"issue\", \"page\", \"blogpost\"]}}) {\n        edges {\n          node {\n            object {\n              rootContainerId\n              id\n            }\n            id\n          }\n        }\n      }\n    }\n  }\n}\n"
        }
    };
}();
$f803ebc4221a154e$var$node.hash = "56416d8667a1a2a2cd820c313a54f2d5";
var $f803ebc4221a154e$export$2e2bcd8739ae039 = $f803ebc4221a154e$var$node;



var $5FkrB = parcelRequire("5FkrB");

var $5T6u3 = parcelRequire("5T6u3");

var $7eKmg = parcelRequire("7eKmg");
// src/platform/site/types.ts
var $fec3383a926856f7$export$2866935ccba4694c = "platform", $fec3383a926856f7$export$c9ae8b227ea4b550 = "site";



// src/core/registered-ari.ts
var $025929b3d8150a09$export$579ee78b1dcf0a11 = class extends (0, $2b94537363720eb1$export$3a4885701291260b) {
    static check(maybeAri) {
        try {
            return this.parse(maybeAri.toString()), !0;
        } catch (err) {
            return !1;
        }
    }
    asAnyAri() {
        return (0, $2b94537363720eb1$export$44a7af7122933d6b).parse(this.toString());
    }
};



// src/platform/site/manifest.ts
var $e743b2e4929fde20$var$platformSiteAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^$"),
    resourceOwner: (0, $fec3383a926856f7$export$2866935ccba4694c),
    resourceType: (0, $fec3383a926856f7$export$c9ae8b227ea4b550),
    resourceIdSlug: "{siteId}",
    resourceIdSegmentFormats: {
        siteId: /[a-zA-Z0-9_\-.]{1,255}/
    }
};
// src/platform/site/index.ts
var $e743b2e4929fde20$export$62388e9e87e2e1c9 = class _PlatformSiteAri extends (0, $025929b3d8150a09$export$579ee78b1dcf0a11) {
    constructor(opts){
        super(opts), this._siteId = opts.resourceIdSegmentValues.siteId;
    }
    get siteId() {
        return this._siteId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $e743b2e4929fde20$var$platformSiteAriStaticOpts.qualifier,
            platformQualifier: $e743b2e4929fde20$var$platformSiteAriStaticOpts.platformQualifier,
            cloudId: void 0,
            resourceOwner: $e743b2e4929fde20$var$platformSiteAriStaticOpts.resourceOwner,
            resourceType: $e743b2e4929fde20$var$platformSiteAriStaticOpts.resourceType,
            resourceId: `${opts.siteId}`,
            resourceIdSegmentValues: {
                siteId: opts.siteId
            }
        }, ariOpts = (0, $784712d91e782262$export$4c3a8cde7a55740b).fromOpts(derivedOpts, $e743b2e4929fde20$var$platformSiteAriStaticOpts);
        return new _PlatformSiteAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $784712d91e782262$export$4c3a8cde7a55740b).fromString(maybeAri, $e743b2e4929fde20$var$platformSiteAriStaticOpts);
        return new _PlatformSiteAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId
        };
    }
};


function $31f5972de3423603$var$toSiteId(siteAri) {
    try {
        return (0, $e743b2e4929fde20$export$62388e9e87e2e1c9).parse(siteAri).siteId;
    } catch  {
        return null;
    }
}
function $31f5972de3423603$export$744c20aa8d4e5722(rootContainerIds) {
    const sitesBySiteAri = new Map();
    for (const siteAri of rootContainerIds){
        if (!siteAri) continue;
        const siteId = $31f5972de3423603$var$toSiteId(siteAri);
        if (siteId == null) continue;
        const existingSite = sitesBySiteAri.get(siteAri);
        sitesBySiteAri.set(siteAri, {
            siteId: siteId,
            viewCount: (existingSite?.viewCount ?? 0) + 1
        });
    }
    return Array.from(sitesBySiteAri.entries()).map(([siteAri, site])=>({
            siteId: site.siteId,
            siteAri: siteAri,
            viewCount: site.viewCount
        })).sort((left, right)=>{
        if (right.viewCount !== left.viewCount) return right.viewCount - left.viewCount;
        return left.siteId.localeCompare(right.siteId);
    });
}


const $900f6cd841b8b4f9$var$query = (0, $f803ebc4221a154e$export$2e2bcd8739ae039);
function $900f6cd841b8b4f9$export$d97e404b91fca70d(enabled) {
    const environment = (0, $5T6u3.useRelayEnvironment)();
    const [mostUsedSites, setMostUsedSites] = (0, $5FkrB.useState)([]);
    const [isLoading, setIsLoading] = (0, $5FkrB.useState)(false);
    (0, $5FkrB.useEffect)(()=>{
        if (!enabled) {
            setMostUsedSites([]);
            setIsLoading(false);
            return;
        }
        setIsLoading(true);
        const subscription = (0, $7eKmg.fetchQuery)(environment, $900f6cd841b8b4f9$var$query, {}, {
            fetchPolicy: 'store-or-network'
        }).subscribe({
            next: (data)=>{
                const edges = data.activity?.myActivity?.viewed.edges ?? [];
                setMostUsedSites((0, $31f5972de3423603$export$744c20aa8d4e5722)(edges.map(({ node: { object: object } })=>object.rootContainerId)));
            },
            error: ()=>{
                setMostUsedSites([]);
                setIsLoading(false);
            },
            complete: ()=>{
                setIsLoading(false);
            }
        });
        return ()=>{
            subscription.unsubscribe();
        };
    }, [
        enabled,
        environment
    ]);
    return {
        mostUsedSites: mostUsedSites,
        isLoading: isLoading
    };
}


/* Label.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $i3UfC = parcelRequire("i3UfC");
parcelRequire("5FkrB");

const $f83946e67ea94c3a$var$_4 = "._6rth1b66{margin-block-end:var(--ds-space-050,4px)}";
const $f83946e67ea94c3a$var$_3 = "._syaz1sqi{color:var(--ds-text-accent-gray,#505258)}";
const $f83946e67ea94c3a$var$_2 = "._1e0c1ule{display:block}";
const $f83946e67ea94c3a$var$_ = "._11c8wadc{font:var(--ds-font-body-small,normal 400 9pt/1pc \"Atlassian Sans\",ui-sans-serif,-apple-system,BlinkMacSystemFont,\"Segoe UI\",Ubuntu,\"Helvetica Neue\",sans-serif)}";
const $f83946e67ea94c3a$var$styles = {
    label: "_11c8wadc _1e0c1ule _syaz1sqi _6rth1b66"
};
const $f83946e67ea94c3a$var$Label = ({ children: children, htmlFor: htmlFor })=>{
    if (htmlFor) return /*#__PURE__*/ (0, $i3UfC.jsxs)((0, $dbdf44c207cf40e4$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $i3UfC.jsx)((0, $c179d2a16dc49323$export$2e2bcd8739ae039), {
                children: [
                    $f83946e67ea94c3a$var$_,
                    $f83946e67ea94c3a$var$_2,
                    $f83946e67ea94c3a$var$_3,
                    $f83946e67ea94c3a$var$_4
                ]
            }),
            /*#__PURE__*/ (0, $i3UfC.jsx)("label", {
                htmlFor: htmlFor,
                className: (0, $b02ab0e3a0f362dd$export$2e2bcd8739ae039)([
                    $f83946e67ea94c3a$var$styles.label
                ]),
                children: children
            })
        ]
    });
    return /*#__PURE__*/ (0, $i3UfC.jsxs)((0, $dbdf44c207cf40e4$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $i3UfC.jsx)((0, $c179d2a16dc49323$export$2e2bcd8739ae039), {
                children: [
                    $f83946e67ea94c3a$var$_,
                    $f83946e67ea94c3a$var$_2,
                    $f83946e67ea94c3a$var$_3,
                    $f83946e67ea94c3a$var$_4
                ]
            }),
            /*#__PURE__*/ (0, $i3UfC.jsx)("span", {
                className: (0, $b02ab0e3a0f362dd$export$2e2bcd8739ae039)([
                    $f83946e67ea94c3a$var$styles.label
                ]),
                children: children
            })
        ]
    });
};
var $f83946e67ea94c3a$export$2e2bcd8739ae039 = $f83946e67ea94c3a$var$Label;


const $a60e3e8390fa58ee$var$messages = (0, $6bnW7.defineMessages)({
    sitePlaceholder: {
        id: 'siteSelector.sitePlaceholder',
        defaultMessage: 'Select',
        description: 'Placeholder for which sites user wants to authorize'
    },
    recentGroupLabel: {
        id: 'siteSelector.recentGroupLabel',
        defaultMessage: 'Recently used',
        description: 'Group label for sites the user has used recently'
    },
    allSitesGroupLabel: {
        id: 'siteSelector.allSitesGroupLabel',
        defaultMessage: 'All',
        description: 'Group label for all sites the user can authorize'
    },
    siteLabelCount: {
        id: 'siteSelector.refreshed.label',
        defaultMessage: '{count, plural, one {Site} other {Sites}}',
        description: 'Field label shown above the site selector, pluralised based on the number of selected sites'
    }
});
const $a60e3e8390fa58ee$var$wrapperStyles = (0, $gDiFE.xcss)({
    width: '100%',
    alignSelf: 'stretch'
});
const $a60e3e8390fa58ee$var$stackStyles = (0, $gDiFE.xcss)({
    width: '100%'
});
const $a60e3e8390fa58ee$var$groupLabelStyles = (0, $gDiFE.xcss)({
    paddingBlock: 'space.050',
    paddingInline: 'space.025'
});
/**
 * Derive a human-friendly display name from a bare site URL by taking the first
 * DNS label and capitalising it, e.g. `mario.atlassian.net` -> `Mario`. Falls
 * back to the original string if there is no recognisable subdomain.
 */ const $a60e3e8390fa58ee$var$deriveNameFromUrl = (url)=>{
    const firstLabel = url.split('.')[0]?.trim();
    if (!firstLabel) return url;
    return firstLabel.charAt(0).toUpperCase() + firstLabel.slice(1);
};
/**
 * Workspaces may arrive as `name|url` (e.g. `Hello|hello.atlassian.net`) or as a
 * bare URL (e.g. `mario.atlassian.net`). When an explicit `name|url` is given,
 * split on the first `|`. Otherwise derive the display name from the URL's
 * subdomain so both the name and the URL can be shown.
 */ const $a60e3e8390fa58ee$var$parseWorkspace = (workspace)=>{
    const separatorIndex = workspace.indexOf('|');
    if (separatorIndex === -1) return {
        name: $a60e3e8390fa58ee$var$deriveNameFromUrl(workspace),
        url: workspace
    };
    return {
        name: workspace.slice(0, separatorIndex),
        url: workspace.slice(separatorIndex + 1)
    };
};
function $a60e3e8390fa58ee$var$getSiteIdFromSiteMappingKey(siteMappingKey) {
    try {
        const ari = (0, $2b94537363720eb1$export$44a7af7122933d6b).parse(siteMappingKey);
        if (ari.resourceType === 'site') return ari.resourceId;
    } catch  {
        return siteMappingKey;
    }
    return siteMappingKey;
}
function $a60e3e8390fa58ee$var$getSiteIdsByWorkspace(siteMapping) {
    const siteIdsByWorkspace = new Map();
    for (const [siteMappingKey, workspace] of Object.entries(siteMapping ?? {})){
        const siteId = $a60e3e8390fa58ee$var$getSiteIdFromSiteMappingKey(siteMappingKey);
        siteIdsByWorkspace.set(workspace, siteId);
    }
    return siteIdsByWorkspace;
}
function $a60e3e8390fa58ee$var$getSiteInfoByWorkspace(availableSites, siteMapping) {
    const result = new Map();
    if (availableSites && availableSites.length > 0) {
        for (const site of availableSites){
            const siteId = $a60e3e8390fa58ee$var$getSiteIdFromSiteMappingKey(site.ari);
            result.set(site.url, {
                siteId: siteId,
                avatar: site.avatar || undefined
            });
        }
        return result;
    }
    // Fallback: siteMapping only (no avatar)
    for (const [siteMappingKey, workspace] of Object.entries(siteMapping ?? {})){
        const siteId = $a60e3e8390fa58ee$var$getSiteIdFromSiteMappingKey(siteMappingKey);
        result.set(workspace, {
            siteId: siteId
        });
    }
    return result;
}
function $a60e3e8390fa58ee$var$getWorkspaceSiteId(workspace, siteIdsByWorkspace) {
    const parsedWorkspace = $a60e3e8390fa58ee$var$parseWorkspace(workspace);
    return siteIdsByWorkspace.get(workspace) ?? siteIdsByWorkspace.get(parsedWorkspace.url) ?? siteIdsByWorkspace.get(parsedWorkspace.name) ?? null;
}
const $a60e3e8390fa58ee$var$toOption = (workspace, siteIdsByWorkspace, siteInfoByWorkspace)=>{
    const parsedWorkspace = $a60e3e8390fa58ee$var$parseWorkspace(workspace);
    const siteInfo = siteInfoByWorkspace?.get(workspace) ?? siteInfoByWorkspace?.get(parsedWorkspace.url) ?? siteInfoByWorkspace?.get(parsedWorkspace.name);
    return {
        value: workspace,
        label: parsedWorkspace.name,
        siteId: siteInfo?.siteId ?? $a60e3e8390fa58ee$var$getWorkspaceSiteId(workspace, siteIdsByWorkspace),
        workspace: workspace,
        avatarUrl: siteInfo?.avatar
    };
};
function $a60e3e8390fa58ee$var$groupWorkspaceOptionsByMostUsedSites({ options: options, mostUsedSites: mostUsedSites, recentLabel: recentLabel, allSitesLabel: allSitesLabel }) {
    if (mostUsedSites.length === 0) return options;
    const optionsBySiteId = new Map();
    for (const option of options){
        if (!option.siteId) continue;
        optionsBySiteId.set(option.siteId, [
            ...optionsBySiteId.get(option.siteId) ?? [],
            option
        ]);
    }
    // Keep duplicated recent/all rows as distinct option objects so focus/hover
    // styling only applies to the row the user is actually interacting with.
    const mostUsedOptions = mostUsedSites.flatMap((site)=>(optionsBySiteId.get(site.siteId) ?? []).map((option)=>({
                ...option,
                value: `recent:${option.workspace}`
            })));
    if (mostUsedOptions.length === 0) return options;
    return [
        {
            label: recentLabel,
            options: mostUsedOptions
        },
        {
            label: allSitesLabel,
            options: options
        }
    ];
}
function $a60e3e8390fa58ee$var$isWorkspaceOptionGroup(optionOrGroup) {
    return Array.isArray(optionOrGroup.options);
}
const $a60e3e8390fa58ee$var$Option = (props)=>{
    const workspace = props.data.workspace;
    const { name: name, url: url } = $a60e3e8390fa58ee$var$parseWorkspace(workspace);
    const isSelected = props.isWorkspaceSelected ?? props.isSelected;
    return /*#__PURE__*/ (0, $i3UfC.jsx)((0, $525be6c0d6b9e93b$export$9b5ac10f59f76296).Option, {
        ...props,
        isSelected: isSelected,
        children: /*#__PURE__*/ (0, $i3UfC.jsxs)((0, $10b0af967ce59e29$export$fbae5b5ffd8af05e), {
            space: "space.100",
            alignBlock: "center",
            children: [
                /*#__PURE__*/ (0, $i3UfC.jsx)("input", {
                    type: "checkbox",
                    checked: isSelected,
                    readOnly: true,
                    tabIndex: -1,
                    "aria-hidden": true
                }),
                /*#__PURE__*/ (0, $i3UfC.jsx)((0, $ebae6d75f4c9721e$export$2e2bcd8739ae039), {
                    avatarUrl: props.data.avatarUrl
                }),
                /*#__PURE__*/ (0, $i3UfC.jsxs)((0, $c8dbef6c41cfa689$export$694e0d28c7ffc90c), {
                    children: [
                        /*#__PURE__*/ (0, $i3UfC.jsx)((0, $d48daa9a522ca942$export$5f1af8db9871e1d6), {
                            weight: "medium",
                            children: name
                        }),
                        url !== name && /*#__PURE__*/ (0, $i3UfC.jsx)((0, $d48daa9a522ca942$export$5f1af8db9871e1d6), {
                            size: "small",
                            color: "color.text.subtlest",
                            children: url
                        })
                    ]
                })
            ]
        })
    });
};
const $a60e3e8390fa58ee$var$chipColor = (option)=>{
    const avatarUrl = option.avatarUrl;
    return (0, $75748f21d6184a53$export$5f8ff7cb3b9550d1)(avatarUrl) ?? (0, $75748f21d6184a53$export$6b1a2b07ad04beea).teal;
};
const $a60e3e8390fa58ee$var$MultiValueLabel = (props)=>{
    const { name: name, url: url } = $a60e3e8390fa58ee$var$parseWorkspace(String(props.data.workspace ?? props.data.value));
    return /*#__PURE__*/ (0, $i3UfC.jsx)((0, $525be6c0d6b9e93b$export$9b5ac10f59f76296).MultiValueLabel, {
        ...props,
        children: url !== name ? `${name} | ${url}` : name
    });
};
const $a60e3e8390fa58ee$var$multiValueStyles = {
    multiValue: (base, state)=>{
        const color = $a60e3e8390fa58ee$var$chipColor(state.data);
        return {
            ...base,
            backgroundColor: color.background,
            borderColor: color.border,
            borderStyle: 'solid',
            borderWidth: (0, $37190500189da037$export$9e1725a4cfeada27)('border.width', '1px')
        };
    },
    multiValueLabel: (base, state)=>({
            ...base,
            color: $a60e3e8390fa58ee$var$chipColor(state.data).foreground
        }),
    multiValueRemove: (base, state)=>({
            ...base,
            color: $a60e3e8390fa58ee$var$chipColor(state.data).foreground
        })
};
const $a60e3e8390fa58ee$var$formatGroupLabel = (group)=>/*#__PURE__*/ (0, $i3UfC.jsx)((0, $383dd904a5a5e5b0$export$e71c4d32a2263218), {
        xcss: $a60e3e8390fa58ee$var$groupLabelStyles,
        children: /*#__PURE__*/ (0, $i3UfC.jsx)((0, $d48daa9a522ca942$export$5f1af8db9871e1d6), {
            size: "small",
            color: "color.text.subtlest",
            weight: "bold",
            children: group.label
        })
    });
function $a60e3e8390fa58ee$var$useWorkspaceOptions(availableWorkspaces, siteMapping, availableSites) {
    const siteIdsByWorkspace = (0, $5FkrB.useMemo)(()=>$a60e3e8390fa58ee$var$getSiteIdsByWorkspace(siteMapping), [
        siteMapping
    ]);
    const siteInfoByWorkspace = (0, $5FkrB.useMemo)(()=>$a60e3e8390fa58ee$var$getSiteInfoByWorkspace(availableSites, siteMapping), [
        availableSites,
        siteMapping
    ]);
    return (0, $5FkrB.useMemo)(()=>availableWorkspaces.map((workspace)=>$a60e3e8390fa58ee$var$toOption(workspace, siteIdsByWorkspace, siteInfoByWorkspace)), [
        availableWorkspaces,
        siteIdsByWorkspace,
        siteInfoByWorkspace
    ]);
}
function $a60e3e8390fa58ee$var$useSelectedWorkspaceValues(selectedWorkspace) {
    return (0, $5FkrB.useMemo)(()=>new Set(selectedWorkspace?.split(',').map((workspace)=>workspace.trim()).filter(Boolean) ?? []), [
        selectedWorkspace
    ]);
}
function $a60e3e8390fa58ee$var$getWorkspaceFromOption(option) {
    return String(option.workspace ?? option.value);
}
function $a60e3e8390fa58ee$var$serializeWorkspaceValues(workspaces) {
    const uniqueWorkspaces = Array.from(new Set(workspaces)).filter(Boolean);
    return uniqueWorkspaces.length > 0 ? uniqueWorkspaces.join(',') : null;
}
function $a60e3e8390fa58ee$var$serializeSelectedOptions(options) {
    return options && options.length > 0 ? $a60e3e8390fa58ee$var$serializeWorkspaceValues(options.map($a60e3e8390fa58ee$var$getWorkspaceFromOption)) : null;
}
function $a60e3e8390fa58ee$var$serializeSelectionChange(options, actionMeta, selectedWorkspaceValues) {
    const option = actionMeta.option;
    if ((actionMeta.action === 'select-option' || actionMeta.action === 'deselect-option') && option?.workspace && selectedWorkspaceValues.has(option.workspace)) {
        const nextSelectedWorkspaceValues = new Set(selectedWorkspaceValues);
        nextSelectedWorkspaceValues.delete(option.workspace);
        return $a60e3e8390fa58ee$var$serializeWorkspaceValues(nextSelectedWorkspaceValues);
    }
    return $a60e3e8390fa58ee$var$serializeSelectedOptions(options);
}
const $a60e3e8390fa58ee$var$INPUT_ID = 'oauth-consent-rovo-site-select';
const $a60e3e8390fa58ee$export$89b19fc670db9847 = ({ availableWorkspaces: availableWorkspaces, siteMapping: siteMapping, availableSites: availableSites, selectedWorkspace: selectedWorkspace, setSelectedWorkspace: setSelectedWorkspace, mostUsedSites: mostUsedSites = [], shouldGroupMostUsedSites: shouldGroupMostUsedSites = false })=>{
    const { formatMessage: formatMessage } = (0, $hrVKU.default)();
    const workspaceOptions = $a60e3e8390fa58ee$var$useWorkspaceOptions(availableWorkspaces, siteMapping, availableSites);
    const selectedWorkspaceValues = $a60e3e8390fa58ee$var$useSelectedWorkspaceValues(selectedWorkspace);
    const allSorted = (0, $5FkrB.useMemo)(()=>[
            ...workspaceOptions
        ].sort((a, b)=>a.label.localeCompare(b.label)), [
        workspaceOptions
    ]);
    const groupedOptions = (0, $5FkrB.useMemo)(()=>{
        const groupedWorkspaceOptions = shouldGroupMostUsedSites && mostUsedSites.length > 0 ? $a60e3e8390fa58ee$var$groupWorkspaceOptionsByMostUsedSites({
            options: allSorted,
            mostUsedSites: mostUsedSites,
            recentLabel: formatMessage($a60e3e8390fa58ee$var$messages.recentGroupLabel),
            allSitesLabel: formatMessage($a60e3e8390fa58ee$var$messages.allSitesGroupLabel)
        }) : [
            {
                label: formatMessage($a60e3e8390fa58ee$var$messages.allSitesGroupLabel),
                options: allSorted
            }
        ];
        const ungroupedOptions = [];
        const groups = [];
        for (const optionOrGroup of groupedWorkspaceOptions)if ($a60e3e8390fa58ee$var$isWorkspaceOptionGroup(optionOrGroup)) groups.push(optionOrGroup);
        else ungroupedOptions.push(optionOrGroup);
        return ungroupedOptions.length > 0 ? [
            ...groups,
            {
                label: formatMessage($a60e3e8390fa58ee$var$messages.allSitesGroupLabel),
                options: ungroupedOptions
            }
        ] : groups;
    }, [
        allSorted,
        formatMessage,
        mostUsedSites,
        shouldGroupMostUsedSites
    ]);
    const selectedOptions = workspaceOptions.filter((option)=>selectedWorkspaceValues.has(String(option.value)));
    const SiteSelectorOption = (0, $5FkrB.useMemo)(()=>(props)=>/*#__PURE__*/ (0, $i3UfC.jsx)($a60e3e8390fa58ee$var$Option, {
                ...props,
                isWorkspaceSelected: selectedWorkspaceValues.has(props.data.workspace)
            }), [
        selectedWorkspaceValues
    ]);
    return /*#__PURE__*/ (0, $i3UfC.jsx)((0, $383dd904a5a5e5b0$export$e71c4d32a2263218), {
        xcss: $a60e3e8390fa58ee$var$wrapperStyles,
        children: /*#__PURE__*/ (0, $i3UfC.jsxs)((0, $c8dbef6c41cfa689$export$694e0d28c7ffc90c), {
            space: "space.050",
            xcss: $a60e3e8390fa58ee$var$stackStyles,
            children: [
                /*#__PURE__*/ (0, $i3UfC.jsx)((0, $f83946e67ea94c3a$export$2e2bcd8739ae039), {
                    htmlFor: $a60e3e8390fa58ee$var$INPUT_ID,
                    children: formatMessage($a60e3e8390fa58ee$var$messages.siteLabelCount, {
                        count: selectedOptions.length
                    })
                }),
                /*#__PURE__*/ (0, $i3UfC.jsx)((0, $5330bbf7705e7e35$export$2e2bcd8739ae039), {
                    inputId: $a60e3e8390fa58ee$var$INPUT_ID,
                    options: groupedOptions,
                    isMulti: true,
                    isSearchable: true,
                    closeMenuOnSelect: false,
                    hideSelectedOptions: false,
                    placeholder: formatMessage($a60e3e8390fa58ee$var$messages.sitePlaceholder),
                    value: selectedOptions,
                    components: {
                        Option: SiteSelectorOption,
                        MultiValueLabel: $a60e3e8390fa58ee$var$MultiValueLabel
                    },
                    formatGroupLabel: $a60e3e8390fa58ee$var$formatGroupLabel,
                    styles: $a60e3e8390fa58ee$var$multiValueStyles,
                    onChange: (options, actionMeta)=>{
                        setSelectedWorkspace($a60e3e8390fa58ee$var$serializeSelectionChange(options ?? [], actionMeta, selectedWorkspaceValues));
                    }
                })
            ]
        })
    });
};
const $a60e3e8390fa58ee$var$SiteSelector = ()=>{
    const { selectedWorkspace: selectedWorkspace, setSelectedWorkspace: setSelectedWorkspace } = (0, $6hgMx.useSelectedWorkspace)();
    const { availableWorkspaces: availableWorkspaces, siteMapping: siteMapping, availableSites: availableSites } = (0, $6hgMx.useInfo)();
    const workspaces = availableWorkspaces ?? [];
    const shouldFetchMostUsedSites = workspaces.length > 3;
    const { mostUsedSites: mostUsedSites } = (0, $900f6cd841b8b4f9$export$d97e404b91fca70d)(shouldFetchMostUsedSites);
    const props = {
        availableWorkspaces: workspaces,
        siteMapping: siteMapping,
        availableSites: availableSites,
        selectedWorkspace: selectedWorkspace ?? null,
        setSelectedWorkspace: (workspace)=>setSelectedWorkspace?.(workspace),
        mostUsedSites: mostUsedSites,
        shouldGroupMostUsedSites: shouldFetchMostUsedSites
    };
    return /*#__PURE__*/ (0, $i3UfC.jsx)($a60e3e8390fa58ee$export$89b19fc670db9847, {
        ...props
    });
};
var $a60e3e8390fa58ee$export$2e2bcd8739ae039 = $a60e3e8390fa58ee$var$SiteSelector;



var $i3UfC = parcelRequire("i3UfC");

var $6bnW7 = parcelRequire("6bnW7");
var $bgNpv = parcelRequire("bgNpv");
var $60d92d5137838590$exports = {};
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::790216e1b1c39b618aa630400c4ea535>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty($60d92d5137838590$exports, "__esModule", {
    value: true
});
$60d92d5137838590$exports.default = void 0;

var $60d92d5137838590$var$_react = $60d92d5137838590$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $60d92d5137838590$var$_iconNew = $60d92d5137838590$var$_interopRequireDefault((parcelRequire("gDzom")));
function $60d92d5137838590$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "CheckCircle".
 * Category: multi-purpose
 * Location: @atlaskit/icon/core/check-circle
 * Usage guidance:
 * Known uses: completed items, productivity emoji category. Completed task work type in JSM Calendar view.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $60d92d5137838590$var$CheckCircleIcon = (props)=>/*#__PURE__*/ $60d92d5137838590$var$_react.default.createElement($60d92d5137838590$var$_iconNew.default, Object.assign({
        name: "CheckCircleIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M14.5 8a6.5 6.5 0 1 0-13 0 6.5 6.5 0 0 0 13 0m-2.174-2.52-5 6a.75.75 0 0 1-1.152 0l-2.5-3 1.152-.96L6.75 9.828l4.424-5.308zM16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0"/>`
    }, props));
$60d92d5137838590$var$CheckCircleIcon.displayName = 'CheckCircleIcon';
var $60d92d5137838590$var$_default = $60d92d5137838590$exports.default = $60d92d5137838590$var$CheckCircleIcon;



var $gDiFE = parcelRequire("gDiFE");


var $6hgMx = parcelRequire("6hgMx");

const $e7570a702a68ad7d$var$messages = (0, $6bnW7.defineMessages)({
    header: {
        id: 'oauth.rovo.permissions.header',
        defaultMessage: '{appName} will be able to read your data and act on your behalf in Atlassian products.',
        description: 'Header describing permissions'
    },
    permissionsHeading: {
        id: 'oauth.rovo.permissions.heading',
        defaultMessage: 'Permissions',
        description: 'Heading shown above the permissions card'
    }
});
const $e7570a702a68ad7d$var$cardStyle = (0, $gDiFE.xcss)({
    borderRadius: 'radius.xxlarge',
    borderWidth: 'border.width',
    borderStyle: 'solid',
    borderColor: 'color.border',
    paddingBlock: 'space.200',
    paddingInline: 'space.100'
});
const $e7570a702a68ad7d$var$PermissionsBullets = ()=>{
    const { clientName: clientName } = (0, $6hgMx.useToken)();
    return /*#__PURE__*/ (0, $i3UfC.jsxs)((0, $c8dbef6c41cfa689$export$694e0d28c7ffc90c), {
        space: "space.050",
        children: [
            /*#__PURE__*/ (0, $i3UfC.jsx)((0, $f83946e67ea94c3a$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $i3UfC.jsx)((0, $bgNpv.default), {
                    ...$e7570a702a68ad7d$var$messages.permissionsHeading
                })
            }),
            /*#__PURE__*/ (0, $i3UfC.jsx)((0, $383dd904a5a5e5b0$export$e71c4d32a2263218), {
                xcss: $e7570a702a68ad7d$var$cardStyle,
                children: /*#__PURE__*/ (0, $i3UfC.jsxs)((0, $10b0af967ce59e29$export$fbae5b5ffd8af05e), {
                    space: "space.100",
                    alignBlock: "start",
                    children: [
                        /*#__PURE__*/ (0, $i3UfC.jsx)((0, $383dd904a5a5e5b0$export$e71c4d32a2263218), {
                            paddingInline: "space.050",
                            children: /*#__PURE__*/ (0, $i3UfC.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($60d92d5137838590$exports))), {
                                label: "",
                                size: "medium",
                                color: (0, $37190500189da037$export$9e1725a4cfeada27)('color.text')
                            })
                        }),
                        /*#__PURE__*/ (0, $i3UfC.jsx)((0, $d48daa9a522ca942$export$5f1af8db9871e1d6), {
                            as: "p",
                            children: /*#__PURE__*/ (0, $i3UfC.jsx)((0, $bgNpv.default), {
                                ...$e7570a702a68ad7d$var$messages.header,
                                values: {
                                    appName: /*#__PURE__*/ (0, $i3UfC.jsx)("strong", {
                                        children: clientName
                                    })
                                }
                            })
                        })
                    ]
                })
            })
        ]
    });
};
var $e7570a702a68ad7d$export$2e2bcd8739ae039 = $e7570a702a68ad7d$var$PermissionsBullets;



var $i3UfC = parcelRequire("i3UfC");


var $6bnW7 = parcelRequire("6bnW7");
var $bgNpv = parcelRequire("bgNpv");
const $e4d5ed4c3be8b08d$export$2299b20f44bd5075 = [
    'openid'
];
const $e4d5ed4c3be8b08d$export$c20a6294f98225f = [
    'profile',
    'email'
];
const $e4d5ed4c3be8b08d$export$d94e82b48aabe5 = [
    ...$e4d5ed4c3be8b08d$export$2299b20f44bd5075,
    ...$e4d5ed4c3be8b08d$export$c20a6294f98225f
];
const $e4d5ed4c3be8b08d$export$717e4e7ae83869f1 = {
    openid: {
        name: 'Log in to your account via Atlassian',
        description: 'Log in to your account via Atlassian, which permits access to your account ID and any personal information requested on this screen.'
    },
    profile: {
        name: 'View your profile',
        description: 'View all profile information for your Atlassian account, regardless of your profile visibility settings. For example, your full name, public name, and avatar.'
    },
    email: {
        name: 'View your email address',
        description: 'View your email address for your Atlassian account.'
    }
};



var $6hgMx = parcelRequire("6hgMx");
const $87f18b0c9657181e$var$messages = (0, $6bnW7.defineMessages)({
    scopeTitle: {
        id: 'kaizen.scopeTitle',
        defaultMessage: 'This will allow {clientName} to:',
        description: 'Heading for Kaizen scope list'
    }
});
const $87f18b0c9657181e$var$Scopes = ()=>{
    const { clientName: clientName, scopes: scopes } = (0, $6hgMx.useToken)();
    const knownScopes = scopes.map((s)=>(0, $e4d5ed4c3be8b08d$export$717e4e7ae83869f1)[s]).filter(Boolean);
    if (knownScopes.length === 0) return null;
    return /*#__PURE__*/ (0, $i3UfC.jsxs)((0, $i3UfC.Fragment), {
        children: [
            /*#__PURE__*/ (0, $i3UfC.jsx)((0, $bgNpv.default), {
                ...$87f18b0c9657181e$var$messages.scopeTitle,
                values: {
                    clientName: clientName
                },
                tagName: "h3"
            }),
            knownScopes.map((scope)=>/*#__PURE__*/ (0, $i3UfC.jsx)((0, $2a7e5455add2565c$export$775b6bb06e53a214), {
                    id: scope.name,
                    title: scope.name,
                    defaultIsExpanded: true,
                    children: scope.description
                }, scope.name))
        ]
    });
};
var $87f18b0c9657181e$export$2e2bcd8739ae039 = $87f18b0c9657181e$var$Scopes;


const $d6c3101ab27d1214$var$Kaizen = ()=>{
    return /*#__PURE__*/ (0, $i3UfC.jsxs)((0, $1b254ba6a068f2f1$export$f51f4c4ede09e011), {
        gap: "space.400",
        direction: "column",
        wrap: "wrap",
        alignItems: "start",
        children: [
            /*#__PURE__*/ (0, $i3UfC.jsx)((0, $1b254ba6a068f2f1$export$f51f4c4ede09e011), {
                alignItems: "center",
                direction: "column",
                gap: "space.400",
                children: /*#__PURE__*/ (0, $i3UfC.jsx)((0, $d161e9943379375b$export$2e2bcd8739ae039), {})
            }),
            /*#__PURE__*/ (0, $i3UfC.jsx)((0, $f42c7abbba86ed92$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $i3UfC.jsx)((0, $a60e3e8390fa58ee$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $i3UfC.jsx)((0, $e7570a702a68ad7d$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $i3UfC.jsx)((0, $87f18b0c9657181e$export$2e2bcd8739ae039), {})
        ]
    });
};
var $d6c3101ab27d1214$export$2e2bcd8739ae039 = $d6c3101ab27d1214$var$Kaizen;



var $i3UfC = parcelRequire("i3UfC");


var $i3UfC = parcelRequire("i3UfC");

var $i3UfC = parcelRequire("i3UfC");

const $63f0e832ece95500$var$AppLogo = ({ logoUrl: logoUrl })=>/*#__PURE__*/ (0, $i3UfC.jsx)("img", {
        src: logoUrl,
        style: {
            borderRadius: '4px',
            width: `${(0, $37190500189da037$export$9e1725a4cfeada27)('space.600', '48px')}`
        }
    });
var $63f0e832ece95500$export$2e2bcd8739ae039 = $63f0e832ece95500$var$AppLogo;



var $i3UfC = parcelRequire("i3UfC");

var $gDiFE = parcelRequire("gDiFE");

var $6bnW7 = parcelRequire("6bnW7");
var $bgNpv = parcelRequire("bgNpv");
const $562dbe57fad9e642$var$centeredContentStyles = (0, $gDiFE.xcss)({
    textAlign: 'center'
});
const $562dbe57fad9e642$var$messages = (0, $6bnW7.defineMessages)({
    title: {
        id: 'heading',
        defaultMessage: '{appName} would like access to your Atlassian account',
        description: 'Heading for oauth'
    }
});
const $562dbe57fad9e642$var$Header = ({ appName: appName })=>/*#__PURE__*/ (0, $i3UfC.jsx)((0, $383dd904a5a5e5b0$export$e71c4d32a2263218), {
        xcss: $562dbe57fad9e642$var$centeredContentStyles,
        children: /*#__PURE__*/ (0, $i3UfC.jsx)((0, $bgNpv.default), {
            ...$562dbe57fad9e642$var$messages.title,
            tagName: "h1",
            values: {
                appName: appName
            }
        })
    });
var $562dbe57fad9e642$export$2e2bcd8739ae039 = $562dbe57fad9e642$var$Header;




var $6hgMx = parcelRequire("6hgMx");
const $a5ddf6d9d4d3b807$var$Headline = ()=>{
    const { clientLogoUrl: clientLogoUrl, clientName: clientName } = (0, $6hgMx.useToken)();
    return /*#__PURE__*/ (0, $i3UfC.jsxs)((0, $i3UfC.Fragment), {
        children: [
            /*#__PURE__*/ (0, $i3UfC.jsx)((0, $63f0e832ece95500$export$2e2bcd8739ae039), {
                logoUrl: $a5ddf6d9d4d3b807$var$getAvatarUrl(clientLogoUrl, clientName ?? '')
            }),
            /*#__PURE__*/ (0, $i3UfC.jsx)((0, $562dbe57fad9e642$export$2e2bcd8739ae039), {
                appName: clientName ?? ''
            })
        ]
    });
};
function $a5ddf6d9d4d3b807$var$getAvatarUrl(url, name) {
    if (url == undefined || (0, $aa88e83ef73ff002$export$e7fa821bd07cfe0d)(url)) return (0, $aa88e83ef73ff002$export$73dca5321b609ec4)(name);
    return url;
}
var $a5ddf6d9d4d3b807$export$2e2bcd8739ae039 = $a5ddf6d9d4d3b807$var$Headline;



var $i3UfC = parcelRequire("i3UfC");


var $6bnW7 = parcelRequire("6bnW7");
var $bgNpv = parcelRequire("bgNpv");


var $6hgMx = parcelRequire("6hgMx");
const $c982bd38f94d328f$var$messages = (0, $6bnW7.defineMessages)({
    scopeTitle: {
        id: 'scopeTitle',
        defaultMessage: 'This will allow {clientName} to:',
        description: 'Heading for oauth'
    }
});
const $c982bd38f94d328f$var$Scopes = ()=>{
    const { clientName: clientName, scopes: scopes } = (0, $6hgMx.useToken)();
    return /*#__PURE__*/ (0, $i3UfC.jsxs)((0, $i3UfC.Fragment), {
        children: [
            /*#__PURE__*/ (0, $i3UfC.jsx)((0, $bgNpv.default), {
                ...$c982bd38f94d328f$var$messages.scopeTitle,
                values: {
                    clientName: clientName
                },
                tagName: "h3"
            }),
            scopes.map((s)=>(0, $e4d5ed4c3be8b08d$export$717e4e7ae83869f1)[s]).map((scope)=>/*#__PURE__*/ (0, $i3UfC.jsx)((0, $2a7e5455add2565c$export$775b6bb06e53a214), {
                    id: scope.name,
                    title: scope.name,
                    defaultIsExpanded: true,
                    children: scope.description
                }, scope.name))
        ]
    });
};
var $c982bd38f94d328f$export$2e2bcd8739ae039 = $c982bd38f94d328f$var$Scopes;


const $dd4b8a594ab429d4$var$OIDC = ()=>/*#__PURE__*/ (0, $i3UfC.jsxs)((0, $1b254ba6a068f2f1$export$f51f4c4ede09e011), {
        gap: "space.400",
        direction: "column",
        wrap: "wrap",
        alignItems: "start",
        children: [
            /*#__PURE__*/ (0, $i3UfC.jsx)((0, $1b254ba6a068f2f1$export$f51f4c4ede09e011), {
                alignItems: "center",
                direction: "column",
                gap: "space.400",
                children: /*#__PURE__*/ (0, $i3UfC.jsx)((0, $a5ddf6d9d4d3b807$export$2e2bcd8739ae039), {})
            }),
            /*#__PURE__*/ (0, $i3UfC.jsx)((0, $c982bd38f94d328f$export$2e2bcd8739ae039), {})
        ]
    });
var $dd4b8a594ab429d4$export$2e2bcd8739ae039 = $dd4b8a594ab429d4$var$OIDC;


/* Trello.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $i3UfC = parcelRequire("i3UfC");
parcelRequire("5FkrB");



var $5FkrB = parcelRequire("5FkrB");

var $hrVKU = parcelRequire("hrVKU");

var $6hgMx = parcelRequire("6hgMx");
function $7e29612a9bf13cda$export$2e2bcd8739ae039() {
    const { clientName: clientName } = (0, $6hgMx.useToken)();
    const intl = (0, $hrVKU.default)();
    (0, $5FkrB.useEffect)(()=>{
        document.title = intl.formatMessage({
            id: 'trello.documentTitle',
            defaultMessage: 'Authorize App | {appName}'
        }, {
            appName: clientName
        });
    }, [
        clientName,
        intl
    ]);
    return null;
}



var $i3UfC = parcelRequire("i3UfC");

var $i3UfC = parcelRequire("i3UfC");
/* heading.tsx generated by @compiled/babel-plugin v2.0.0 */ function $bc9c5d0ffd8720b3$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return r;
}


function $029efedbf0efd88a$export$2e2bcd8739ae039(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}


function $adf321ce34b28401$export$2e2bcd8739ae039(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}


function $0b796a67e706afc6$export$2e2bcd8739ae039(r, a) {
    if (r) {
        if ("string" == typeof r) return (0, $adf321ce34b28401$export$2e2bcd8739ae039)(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? (0, $adf321ce34b28401$export$2e2bcd8739ae039)(r, a) : void 0;
    }
}


function $fac098b233386d18$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}


function $eecdc3a1c47d7546$export$2e2bcd8739ae039(r, e) {
    return (0, $bc9c5d0ffd8720b3$export$2e2bcd8739ae039)(r) || (0, $029efedbf0efd88a$export$2e2bcd8739ae039)(r, e) || (0, $0b796a67e706afc6$export$2e2bcd8739ae039)(r, e) || (0, $fac098b233386d18$export$2e2bcd8739ae039)();
}



var $5FkrB = parcelRequire("5FkrB");
/**
 * The length of the value hash portion of an atomic class name.
 * Atomic class names have the format: `_<group><value>`
 * where group is ATOMIC_GROUP_HASH_LENGTH chars and value is ATOMIC_VALUE_HASH_LENGTH chars.
 *
 * We extract the group key using: `className.slice(0, className.length - ATOMIC_VALUE_HASH_LENGTH)`
 *
 * We support both old-format classes (9 chars: `_` + 4 group + 4 value) and
 * new-format classes (11 chars: `_` + 6 group + 4 value) by using length-based
 * extraction rather than a hardcoded offset — old and new format group keys
 * are different lengths so they are structurally disjoint and never alias each other.
 */ const $c6c07939b537da39$var$ATOMIC_VALUE_HASH_LENGTH = 4;
function $c6c07939b537da39$export$2e2bcd8739ae039(classNames) {
    // Shortcut: nothing to do
    if (!classNames.length) return;
    // Shortcut: don't need to do anything if we only have a single classname
    if (classNames.length === 1 && classNames[0] && // checking to see if `classNames[0]` is a string that contains other classnames
    !classNames[0].includes(' ')) return classNames[0];
    // Using an object rather than a `Map` as it performed better in our benchmarks.
    // Would be happy to move to `Map` if it proved to be better under real conditions.
    const map = {};
    // Note: using loops to minimize iterations over the collection
    for (const value of classNames){
        // Exclude all falsy values, which leaves us with populated strings
        if (!value) continue;
        // a `value` can contain multiple classnames
        const list = value.split(' ');
        for (const className of list){
            /**
             * For atomic style classnames: the `key` is the `group`
             *
             * - Later atomic classnames with the same `group` will override earlier ones
             *   (which is what we want).
             * - Assumes atomic classnames are the only things that start with `_`
             * - Could use a regex to ensure that atomic classnames are structured how we expect,
             *   but did not add that for now as it did slow things down a bit.
             *
             * For other classnames: the `key` is the whole classname
             * - Okay to remove duplicates as doing so does not impact specificity
             *
             * */ const key = className.startsWith('_') ? className.slice(0, className.length - $c6c07939b537da39$var$ATOMIC_VALUE_HASH_LENGTH) : className;
            map[key] = className;
        }
    }
    /**
     * We are converting the `map` into a string.
     *
     * The simple way to do this would be `Object.values(map).join(' ')`.
     * However, the approach below performs 10%-20% better in benchmarks.
     *
     * For `ax()` it feels right to squeeze as much runtime performance out as we can.
     */ let result = '';
    for(const key in map)result += map[key] + ' ';
    // If we have an empty string, then our `map` was empty.
    if (!result) return;
    // remove last " " from the result (we added " " at the end of every value)
    return result.trimEnd();
}





var $5FkrB = parcelRequire("5FkrB");

var $5FkrB = parcelRequire("5FkrB");
var $aa0a4395fbca7551$export$d1fa8a19e192bc63 = /*#__PURE__*/ (0, $5FkrB.createContext)(0);


var $466c505f5338113d$export$6a64a1e2d0bbbf75 = function useHeadingLevel() {
    return (0, $5FkrB.useContext)((0, $aa0a4395fbca7551$export$d1fa8a19e192bc63));
};


var $8602c3fdf0fab40c$export$97a37b1befbbf9b1 = function useHeading(fallback) {
    var hLevel = (0, $466c505f5338113d$export$6a64a1e2d0bbbf75)();
    /**
   * Order here is important, we for now apply
   * 1. inferred a11y level (this only applies if context is present)
   * 2. default final fallback
   */ return [
        hLevel,
        hLevel && (hLevel > 6 ? 'div' : "h".concat(hLevel)) || fallback
    ];
};



var $3ZMUU = parcelRequire("3ZMUU");
var $82315a19372f332f$var$sizeTagMap = {
    xxlarge: 'h1',
    xlarge: 'h1',
    large: 'h2',
    medium: 'h3',
    small: 'h4',
    xsmall: 'h5',
    xxsmall: 'h6'
};
/**
 * Using '&&' here to increase specificity of Heading styles such that app styles like ".wiki-content h4" cannot override this component.
 */ var $82315a19372f332f$var$styles = {
    reset: "_dxsyidpf _1i144jg8 _nmk4glyw"
};
/**
 * Using '&&' here to increase specificity of Heading styles such that app styles like ".wiki-content h4" cannot override this component.
 */ var $82315a19372f332f$var$headingColorStyles = {
    'color.text': "_1w90i7uo",
    'color.text.inverse': "_1w9015cr",
    'color.text.warning.inverse': "_1w901yd3"
};
/**
 * Using '&&' here to increase specificity of Heading styles such that app styles like ".wiki-content h4" cannot override this component.
 */ var $82315a19372f332f$var$headingSizeStyles = {
    xxlarge: "_fqox1iff",
    xlarge: "_fqox12ln",
    large: "_fqox10sd",
    medium: "_fqox1af2",
    small: "_fqox1e3o",
    xsmall: "_fqox1qyo",
    xxsmall: "_fqoxi4vh"
};
/**
 * @codegenEnd
 */ var $82315a19372f332f$var$useColor = function useColor(colorProp) {
    var surface = (0, $6aab085817c2aae8$export$1aeb4f6b93c4540d)();
    if (colorProp) return colorProp;
    if ((0, $75372494f37b0909$export$2185ce37f9bdd963).hasOwnProperty(surface)) return (0, $75372494f37b0909$export$2185ce37f9bdd963)[surface];
    return 'color.text';
};
/**
 * __Heading__
 *
 * Heading is a typography component used to display text in defined sizes and styles.
 *
 * @example
 *
 * ```jsx
 * <Heading size="xxlarge">Page title</Heading>
 * ```
 */ var $82315a19372f332f$var$Heading = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function(props, ref) {
    var children = props.children, size = props.size, id = props.id, testId = props.testId, as = props.as, colorProp = props.color;
    typeof $3ZMUU;
    var _useHeading = (0, $8602c3fdf0fab40c$export$97a37b1befbbf9b1)($82315a19372f332f$var$sizeTagMap[size]), _useHeading2 = (0, $eecdc3a1c47d7546$export$2e2bcd8739ae039)(_useHeading, 2), hLevel = _useHeading2[0], inferredElement = _useHeading2[1];
    var Component = as || inferredElement;
    var needsAriaRole = Component === 'div' && hLevel;
    var color = $82315a19372f332f$var$useColor(colorProp);
    return /*#__PURE__*/ $5FkrB.createElement(Component, {
        id: id,
        ref: ref,
        "data-testid": testId,
        role: needsAriaRole ? 'heading' : undefined,
        "aria-level": needsAriaRole ? hLevel : undefined,
        className: (0, $c6c07939b537da39$export$2e2bcd8739ae039)([
            $82315a19372f332f$var$styles.reset,
            $82315a19372f332f$var$headingSizeStyles[size],
            $82315a19372f332f$var$headingColorStyles[color]
        ])
    }, children);
});
var $82315a19372f332f$export$2e2bcd8739ae039 = $82315a19372f332f$var$Heading;



var $gDiFE = parcelRequire("gDiFE");

var $6bnW7 = parcelRequire("6bnW7");
var $bgNpv = parcelRequire("bgNpv");
const $18343412b88b803e$var$centeredContentStyles = (0, $gDiFE.xcss)({
    textAlign: 'center'
});
const $18343412b88b803e$var$messages = (0, $6bnW7.defineMessages)({
    title: {
        id: 'trello.heading',
        defaultMessage: 'Would you like to give the following application access to your account?',
        description: 'Heading for trello consent page'
    }
});
const $18343412b88b803e$var$Header = ()=>/*#__PURE__*/ (0, $i3UfC.jsx)((0, $383dd904a5a5e5b0$export$e71c4d32a2263218), {
        xcss: $18343412b88b803e$var$centeredContentStyles,
        children: /*#__PURE__*/ (0, $i3UfC.jsx)((0, $82315a19372f332f$export$2e2bcd8739ae039), {
            size: "xlarge",
            children: /*#__PURE__*/ (0, $i3UfC.jsx)((0, $bgNpv.default), {
                ...$18343412b88b803e$var$messages.title
            })
        })
    });
var $18343412b88b803e$export$2e2bcd8739ae039 = $18343412b88b803e$var$Header;



var $i3UfC = parcelRequire("i3UfC");

var $i3UfC = parcelRequire("i3UfC");


var $6hgMx = parcelRequire("6hgMx");
const $72568900e4943399$var$Logo = ()=>{
    const { client: client } = (0, $6hgMx.useInfo)();
    return /*#__PURE__*/ (0, $i3UfC.jsx)((0, $467b7370bd97bdfa$export$2e2bcd8739ae039), {
        src: client?.appLogoUrl,
        size: "xxlarge"
    });
};
var $72568900e4943399$export$2e2bcd8739ae039 = $72568900e4943399$var$Logo;


var $5442b84608c3f299$exports = {};
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::ebc4bea7a21bb938bbd28f877d975c6e>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty($5442b84608c3f299$exports, "__esModule", {
    value: true
});
$5442b84608c3f299$exports.default = void 0;

var $5442b84608c3f299$var$_react = $5442b84608c3f299$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $5442b84608c3f299$var$_baseNew = $5442b84608c3f299$var$_interopRequireDefault((parcelRequire("cdkZR")));
function $5442b84608c3f299$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Sync".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab/core/sync
 * Usage guidance:
 * Reserved for syncing changes and save operations.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $5442b84608c3f299$var$SyncIcon = (props)=>/*#__PURE__*/ $5442b84608c3f299$var$_react.default.createElement($5442b84608c3f299$var$_baseNew.default, Object.assign({
        name: "SyncIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2 .5h4.25a.75.75 0 0 1 .75.75V5.5H5.5V2.941a9 9 0 0 0-1.094.916C3.42 4.83 2.5 6.214 2.5 8c0 1.813.817 3.18 1.871 4.11 1.079.95 2.346 1.39 3.129 1.39V15c-1.217 0-2.825-.623-4.121-1.765C2.058 12.07 1 10.312 1 8c0-2.339 1.21-4.084 2.354-5.211.308-.304.615-.567.9-.789H2zm10.621 2.266C13.942 3.93 15 5.688 15 8c0 2.338-1.204 4.079-2.344 5.201-.304.3-.607.56-.889.78H14v1.5H9.75a.75.75 0 0 1-.75-.75v-4.25h1.5v2.573a9 9 0 0 0 1.104-.921C12.584 11.166 13.5 9.787 13.5 8c0-1.813-.817-3.18-1.871-4.11C10.551 2.94 9.283 2.5 8.5 2.5V1c1.217 0 2.825.623 4.121 1.766" clip-rule="evenodd"/>`
    }, props));
$5442b84608c3f299$var$SyncIcon.displayName = 'SyncIcon';
var $5442b84608c3f299$var$_default = $5442b84608c3f299$exports.default = $5442b84608c3f299$var$SyncIcon;



var $i3UfC = parcelRequire("i3UfC");


var $f5RPY = parcelRequire("f5RPY");
const $bba1b0c69c248ed1$var$AtlassianUserIcon = ()=>{
    const user = (0, $f5RPY.useUser)();
    return /*#__PURE__*/ (0, $i3UfC.jsx)((0, $467b7370bd97bdfa$export$2e2bcd8739ae039), {
        size: "xxlarge",
        src: user?.picture
    });
};
var $bba1b0c69c248ed1$export$2e2bcd8739ae039 = $bba1b0c69c248ed1$var$AtlassianUserIcon;




const $58ee34bc2cab63f1$var$AppLogos = ()=>{
    return /*#__PURE__*/ (0, $i3UfC.jsxs)((0, $10b0af967ce59e29$export$fbae5b5ffd8af05e), {
        alignBlock: "center",
        space: "space.100",
        children: [
            /*#__PURE__*/ (0, $i3UfC.jsx)((0, $bba1b0c69c248ed1$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $i3UfC.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5442b84608c3f299$exports))), {
                label: "",
                color: (0, $37190500189da037$export$9e1725a4cfeada27)('color.icon')
            }),
            /*#__PURE__*/ (0, $i3UfC.jsx)((0, $72568900e4943399$export$2e2bcd8739ae039), {})
        ]
    });
};
var $58ee34bc2cab63f1$export$2e2bcd8739ae039 = $58ee34bc2cab63f1$var$AppLogos;



var $i3UfC = parcelRequire("i3UfC");

var $gDiFE = parcelRequire("gDiFE");


var $6hgMx = parcelRequire("6hgMx");
const $8fcc38049a830856$var$centeredContentStyles = (0, $gDiFE.xcss)({
    textAlign: 'center'
});
const $8fcc38049a830856$var$AppName = ()=>{
    const { client: client } = (0, $6hgMx.useInfo)();
    return /*#__PURE__*/ (0, $i3UfC.jsx)((0, $383dd904a5a5e5b0$export$e71c4d32a2263218), {
        xcss: $8fcc38049a830856$var$centeredContentStyles,
        children: /*#__PURE__*/ (0, $i3UfC.jsx)((0, $82315a19372f332f$export$2e2bcd8739ae039), {
            size: "large",
            children: client?.name
        })
    });
};
var $8fcc38049a830856$export$2e2bcd8739ae039 = $8fcc38049a830856$var$AppName;



var $i3UfC = parcelRequire("i3UfC");



var $6bnW7 = parcelRequire("6bnW7");
var $bgNpv = parcelRequire("bgNpv");

var $f5RPY = parcelRequire("f5RPY");
const $8b2d8dc99d1a8336$var$messages = (0, $6bnW7.defineMessages)({
    title: {
        id: 'trello.login.title',
        defaultMessage: 'You are logged in as:',
        description: 'Heading for where you are logged in as'
    },
    name: {
        id: 'trello.login.name',
        defaultMessage: 'Name',
        description: 'Heading for full name'
    },
    username: {
        id: 'trello.login.username',
        defaultMessage: 'Username',
        description: 'Heading for username'
    }
});
const $8b2d8dc99d1a8336$var$LoginDetails = ()=>{
    const user = (0, $f5RPY.useUser)();
    const switchAccountLink = (0, $f5RPY.useSwitchAccountLink)();
    return /*#__PURE__*/ (0, $i3UfC.jsxs)((0, $c8dbef6c41cfa689$export$694e0d28c7ffc90c), {
        alignInline: "center",
        space: "space.200",
        children: [
            /*#__PURE__*/ (0, $i3UfC.jsx)((0, $bgNpv.default), {
                ...$8b2d8dc99d1a8336$var$messages.title
            }),
            /*#__PURE__*/ (0, $i3UfC.jsxs)((0, $c8dbef6c41cfa689$export$694e0d28c7ffc90c), {
                alignInline: "center",
                children: [
                    /*#__PURE__*/ (0, $i3UfC.jsx)((0, $bgNpv.default), {
                        ...$8b2d8dc99d1a8336$var$messages.name
                    }),
                    /*#__PURE__*/ (0, $i3UfC.jsx)("strong", {
                        children: user?.name
                    })
                ]
            }),
            /*#__PURE__*/ (0, $i3UfC.jsxs)((0, $c8dbef6c41cfa689$export$694e0d28c7ffc90c), {
                alignInline: "center",
                children: [
                    /*#__PURE__*/ (0, $i3UfC.jsx)((0, $bgNpv.default), {
                        ...$8b2d8dc99d1a8336$var$messages.username
                    }),
                    /*#__PURE__*/ (0, $i3UfC.jsx)("strong", {
                        children: user?.email
                    })
                ]
            }),
            /*#__PURE__*/ (0, $i3UfC.jsx)((0, $64e95b69a05329e9$export$2e2bcd8739ae039), {
                href: switchAccountLink,
                children: "Switch Account"
            })
        ]
    });
};
var $8b2d8dc99d1a8336$export$2e2bcd8739ae039 = $8b2d8dc99d1a8336$var$LoginDetails;


const $48e45b7ab9243772$var$Summary = ()=>{
    return /*#__PURE__*/ (0, $i3UfC.jsxs)((0, $i3UfC.Fragment), {
        children: [
            /*#__PURE__*/ (0, $i3UfC.jsx)((0, $18343412b88b803e$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $i3UfC.jsx)((0, $8fcc38049a830856$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $i3UfC.jsx)((0, $58ee34bc2cab63f1$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $i3UfC.jsx)((0, $8b2d8dc99d1a8336$export$2e2bcd8739ae039), {})
        ]
    });
};
var $48e45b7ab9243772$export$2e2bcd8739ae039 = $48e45b7ab9243772$var$Summary;



var $i3UfC = parcelRequire("i3UfC");


var $i3UfC = parcelRequire("i3UfC");

var $bgNpv = parcelRequire("bgNpv");
var $aecea8ea0a156e53$exports = {};
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::25beeb938e2095144b397a819675b531>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty($aecea8ea0a156e53$exports, "__esModule", {
    value: true
});
$aecea8ea0a156e53$exports.default = void 0;

var $aecea8ea0a156e53$var$_react = $aecea8ea0a156e53$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $aecea8ea0a156e53$var$_iconNew = $aecea8ea0a156e53$var$_interopRequireDefault((parcelRequire("gDzom")));
function $aecea8ea0a156e53$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Warning".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/warning
 * Usage guidance:
 * Reserved for warning statuses.
 * Filled status icons provide higher visual contrast to draw attention to important information.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $aecea8ea0a156e53$var$WarningIcon = (props)=>/*#__PURE__*/ $aecea8ea0a156e53$var$_react.default.createElement($aecea8ea0a156e53$var$_iconNew.default, Object.assign({
        name: "WarningIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6.242 1.169c.757-1.396 2.76-1.396 3.516 0l5.9 10.878C16.381 13.379 15.416 15 13.9 15H2.1C.584 15-.38 13.38.342 12.047zM7.25 9.5v-5h1.5v5zM8 12.75a1 1 0 1 0 0-2 1 1 0 0 0 0 2" clip-rule="evenodd"/>`
    }, props));
$aecea8ea0a156e53$var$WarningIcon.displayName = 'WarningIcon';
var $aecea8ea0a156e53$var$_default = $aecea8ea0a156e53$exports.default = $aecea8ea0a156e53$var$WarningIcon;


var $6d28b924707499d5$exports = {};
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b1e1f94344c8d27fc4c7fb696b371a5e>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty($6d28b924707499d5$exports, "__esModule", {
    value: true
});
$6d28b924707499d5$exports.default = void 0;

var $6d28b924707499d5$var$_react = $6d28b924707499d5$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $6d28b924707499d5$var$_iconNew = $6d28b924707499d5$var$_interopRequireDefault((parcelRequire("gDzom")));
function $6d28b924707499d5$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "LockLocked".
 * Category: multi-purpose
 * Location: @atlaskit/icon/core/lock-locked
 * Usage guidance:
 * Multi purpose - Known uses: secure password in textfields, locked page in Confluence.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $6d28b924707499d5$var$LockLockedIcon = (props)=>/*#__PURE__*/ $6d28b924707499d5$var$_react.default.createElement($6d28b924707499d5$var$_iconNew.default, Object.assign({
        name: "LockLockedIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 1.5A2.5 2.5 0 0 0 5.5 4v3h5V4A2.5 2.5 0 0 0 8 1.5M12 7V4a4 4 0 0 0-8 0v3a2 2 0 0 0-2 2v5a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2M4 8.5a.5.5 0 0 0-.5.5v5a.5.5 0 0 0 .5.5h8a.5.5 0 0 0 .5-.5V9a.5.5 0 0 0-.5-.5zM7.25 13v-3h1.5v3z" clip-rule="evenodd"/>`
    }, props));
$6d28b924707499d5$var$LockLockedIcon.displayName = 'LockLockedIcon';
var $6d28b924707499d5$var$_default = $6d28b924707499d5$exports.default = $6d28b924707499d5$var$LockLockedIcon;



/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $5FkrB = parcelRequire("5FkrB");

var $5Ejvu = parcelRequire("5Ejvu");

// Icon color mapping for Tile-based icons
var $bffb6f610480e6bf$var$iconColorMap = {
    blue: "_syaz6txe",
    blueBold: "_syaz1q3r",
    gray: "_syazdgkc",
    grayBold: "_syaz5w2r",
    green: "_syaz17hp",
    greenBold: "_syaz1q3r",
    lime: "_syaz8645",
    limeBold: "_syaz1q3r",
    magenta: "_syazv8hk",
    magentaBold: "_syaz1q3r",
    orange: "_syaz1j6y",
    orangeBold: "_syaz1q3r",
    purple: "_syazuq3u",
    purpleBold: "_syaz1q3r",
    red: "_syaznbxb",
    redBold: "_syaz1q3r",
    teal: "_syaz8uof",
    tealBold: "_syaz1q3r",
    yellow: "_syaz1oqg",
    yellowBold: "_syaz1q3r"
};
var $bffb6f610480e6bf$var$iconWrapperStyles = {
    root: "_vwz4idpf"
};
// Background color mapping for Tile component
var $bffb6f610480e6bf$var$backgroundColorMap = {
    blue: undefined,
    blueBold: 'color.background.accent.blue.subtle',
    gray: undefined,
    grayBold: 'color.background.neutral.bold',
    green: undefined,
    greenBold: 'color.background.accent.green.subtle',
    lime: undefined,
    limeBold: 'color.background.accent.lime.subtle',
    magenta: undefined,
    magentaBold: 'color.background.accent.magenta.subtle',
    orange: undefined,
    orangeBold: 'color.background.accent.orange.subtle',
    purple: undefined,
    purpleBold: 'color.background.accent.purple.subtle',
    red: undefined,
    redBold: 'color.background.accent.red.subtle',
    teal: undefined,
    tealBold: 'color.background.accent.teal.subtle',
    yellow: undefined,
    yellowBold: 'color.background.accent.yellow.subtle'
};
function $bffb6f610480e6bf$export$2e2bcd8739ae039(props) {
    var Icon = props.icon, label = props.label, appearance = props.appearance, _props$size = props.size, size = _props$size === void 0 ? 'medium' : _props$size, testId = props.testId;
    var ExpandedIcon = Icon;
    return /*#__PURE__*/ $5FkrB.createElement((0, $0020f204f1f5986b$export$2e2bcd8739ae039), {
        size: size,
        backgroundColor: $bffb6f610480e6bf$var$backgroundColorMap[appearance],
        label: label,
        testId: testId
    }, /*#__PURE__*/ $5FkrB.createElement("span", {
        className: (0, $5Ejvu.default)([
            $bffb6f610480e6bf$var$iconColorMap[appearance],
            $bffb6f610480e6bf$var$iconWrapperStyles.root
        ])
    }, /*#__PURE__*/ $5FkrB.createElement(ExpandedIcon, {
        color: "currentColor",
        label: "",
        shouldScale: true
    })));
}



var $i3UfC = parcelRequire("i3UfC");

const $b12736584e34aeee$var$IconWithContent = ({ icon: icon, text: text })=>{
    return /*#__PURE__*/ (0, $i3UfC.jsxs)((0, $10b0af967ce59e29$export$fbae5b5ffd8af05e), {
        space: "space.200",
        alignBlock: "center",
        children: [
            icon,
            /*#__PURE__*/ (0, $i3UfC.jsx)("span", {
                children: text
            })
        ]
    });
};
var $b12736584e34aeee$export$2e2bcd8739ae039 = $b12736584e34aeee$var$IconWithContent;



var $6hgMx = parcelRequire("6hgMx");
const $07157ac842a32849$var$PrivacyPolicy = ()=>{
    const { client: client } = (0, $6hgMx.useInfo)();
    const hasPrivacyPolicy = !!client?.appPrivacyPolicyLink;
    const Icon = hasPrivacyPolicy ? (0, (/*@__PURE__*/$parcel$interopDefault($6d28b924707499d5$exports))) : (0, (/*@__PURE__*/$parcel$interopDefault($aecea8ea0a156e53$exports)));
    return /*#__PURE__*/ (0, $i3UfC.jsx)((0, $b12736584e34aeee$export$2e2bcd8739ae039), {
        text: /*#__PURE__*/ (0, $i3UfC.jsxs)("span", {
            children: [
                /*#__PURE__*/ (0, $i3UfC.jsx)((0, $bgNpv.default), {
                    id: "trello.privacyPolicy.atlassianObligation",
                    defaultMessage: "Atlassian's privacy policy is not applicable to the use of this app.",
                    description: "Notice that Atlassian's privacy policy doesn't apply"
                }),
                /*#__PURE__*/ (0, $i3UfC.jsx)("br", {}),
                hasPrivacyPolicy ? /*#__PURE__*/ (0, $i3UfC.jsx)((0, $bgNpv.default), {
                    id: "trello.privacyPolicy.policyLink",
                    defaultMessage: "Refer to the app developer's <policyLink>privacy policy</policyLink>.",
                    description: "Links to the third party app's privacy policy link",
                    values: {
                        policyLink: (text)=>/*#__PURE__*/ (0, $i3UfC.jsx)((0, $64e95b69a05329e9$export$2e2bcd8739ae039), {
                                href: client?.appPrivacyPolicyLink,
                                children: text
                            })
                    }
                }) : /*#__PURE__*/ (0, $i3UfC.jsx)((0, $bgNpv.default), {
                    id: "trello.privacyPolicy.noPolicyLink",
                    defaultMessage: "The app developer has not attached a privacy policy.",
                    description: "The third party app did not provide a privacy policy"
                })
            ]
        }),
        icon: /*#__PURE__*/ (0, $i3UfC.jsx)((0, $bffb6f610480e6bf$export$2e2bcd8739ae039), {
            icon: Icon,
            label: "",
            appearance: "gray",
            size: "medium"
        })
    });
};
var $07157ac842a32849$export$2e2bcd8739ae039 = $07157ac842a32849$var$PrivacyPolicy;



var $i3UfC = parcelRequire("i3UfC");

var $bgNpv = parcelRequire("bgNpv");




var $6hgMx = parcelRequire("6hgMx");
const $0b9c1685129b3f4d$var$PrivacyCompliance = ()=>{
    const { client: client } = (0, $6hgMx.useInfo)();
    const pollsPrivacyApi = client?.lastGdprPollTime && Date.now() < client.lastGdprPollTime + 1209600000;
    // If the developer has not answered whether they store user data
    // OR if the app does store user data and has not been polling the privacy API
    if (client?.appStoresUserData == null || client.appStoresUserData && !pollsPrivacyApi) return /*#__PURE__*/ (0, $i3UfC.jsx)((0, $b12736584e34aeee$export$2e2bcd8739ae039), {
        icon: /*#__PURE__*/ (0, $i3UfC.jsx)((0, $bffb6f610480e6bf$export$2e2bcd8739ae039), {
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($aecea8ea0a156e53$exports))),
            label: "",
            appearance: "gray",
            size: "medium"
        }),
        text: /*#__PURE__*/ (0, $i3UfC.jsx)((0, $bgNpv.default), {
            id: "trello.vendor.privacyGuidelinesWarning",
            defaultMessage: "This app does not follow Atlassian\u2019s privacy guidelines. By authorizing access <strong>you may be putting your personal data at risk</strong>.",
            description: "Warning about not following privacy guidelines",
            values: {
                strong: (text)=>/*#__PURE__*/ (0, $i3UfC.jsx)("strong", {
                        children: text
                    })
            }
        })
    });
    return /*#__PURE__*/ (0, $i3UfC.jsx)((0, $i3UfC.Fragment), {});
};
var $0b9c1685129b3f4d$export$2e2bcd8739ae039 = $0b9c1685129b3f4d$var$PrivacyCompliance;



var $i3UfC = parcelRequire("i3UfC");

var $bgNpv = parcelRequire("bgNpv");




var $6hgMx = parcelRequire("6hgMx");
const $05b249cd8b207aea$var$Vendor = ()=>{
    const { client: client } = (0, $6hgMx.useInfo)();
    const company = client?.appVendorName ?? '<COMPANY>';
    return /*#__PURE__*/ (0, $i3UfC.jsx)((0, $b12736584e34aeee$export$2e2bcd8739ae039), {
        text: /*#__PURE__*/ (0, $i3UfC.jsx)((0, $bgNpv.default), {
            id: "trello.vendor.main",
            defaultMessage: "Operated by {company}",
            description: "Compliance disclaimer.",
            values: {
                company: /*#__PURE__*/ (0, $i3UfC.jsx)("strong", {
                    children: company
                })
            }
        }),
        icon: /*#__PURE__*/ (0, $i3UfC.jsx)((0, $bffb6f610480e6bf$export$2e2bcd8739ae039), {
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($60d92d5137838590$exports))),
            label: "",
            appearance: "gray",
            size: "medium"
        })
    });
};
var $05b249cd8b207aea$export$2e2bcd8739ae039 = $05b249cd8b207aea$var$Vendor;



var $i3UfC = parcelRequire("i3UfC");

var $bgNpv = parcelRequire("bgNpv");
var $0dcec71ac857133b$exports = {};
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d2795fc1ebee30d2a3977d5783012a5a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty($0dcec71ac857133b$exports, "__esModule", {
    value: true
});
$0dcec71ac857133b$exports.default = void 0;

var $0dcec71ac857133b$var$_react = $0dcec71ac857133b$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $0dcec71ac857133b$var$_iconNew = $0dcec71ac857133b$var$_interopRequireDefault((parcelRequire("gDzom")));
function $0dcec71ac857133b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Link".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/link
 * Usage guidance:
 * Single purpose - Reserved for links, urls, or copy link.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $0dcec71ac857133b$var$LinkIcon = (props)=>/*#__PURE__*/ $0dcec71ac857133b$var$_react.default.createElement($0dcec71ac857133b$var$_iconNew.default, Object.assign({
        name: "LinkIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8.22 2.22a3.932 3.932 0 1 1 5.56 5.56l-2.25 2.25-1.06-1.06 2.25-2.25a2.432 2.432 0 0 0-3.44-3.44L7.03 5.53 5.97 4.47zm3.06 3.56-5.5 5.5-1.06-1.06 5.5-5.5zM2.22 8.22l2.25-2.25 1.06 1.06-2.25 2.25a2.432 2.432 0 0 0 3.44 3.44l2.25-2.25 1.06 1.06-2.25 2.25a3.932 3.932 0 1 1-5.56-5.56" clip-rule="evenodd"/>`
    }, props));
$0dcec71ac857133b$var$LinkIcon.displayName = 'LinkIcon';
var $0dcec71ac857133b$var$_default = $0dcec71ac857133b$exports.default = $0dcec71ac857133b$var$LinkIcon;





var $6hgMx = parcelRequire("6hgMx");

const $dd4c7b878bc16122$var$RedirectURL = ()=>{
    const { redirectUrl: redirectUrl } = (0, $6hgMx.useToken)();
    return /*#__PURE__*/ (0, $i3UfC.jsx)((0, $b12736584e34aeee$export$2e2bcd8739ae039), {
        icon: /*#__PURE__*/ (0, $i3UfC.jsx)((0, $bffb6f610480e6bf$export$2e2bcd8739ae039), {
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($0dcec71ac857133b$exports))),
            label: '',
            appearance: "gray",
            size: "medium"
        }),
        text: /*#__PURE__*/ (0, $i3UfC.jsx)((0, $bgNpv.default), {
            id: 'trello.redirectUrl',
            defaultMessage: 'Redirect URL: {url}',
            values: {
                url: /*#__PURE__*/ (0, $i3UfC.jsx)((0, $64e95b69a05329e9$export$2e2bcd8739ae039), {
                    href: '#',
                    children: redirectUrl?.callback
                })
            }
        })
    });
};
var $dd4c7b878bc16122$export$2e2bcd8739ae039 = $dd4c7b878bc16122$var$RedirectURL;



var $i3UfC = parcelRequire("i3UfC");
/**
 * @generated SignedSource<<4df81efbdb4b64085881feb50d1c3add>>
 * @lightSyntaxTransform
 * @nogrep
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $548e032ca9c2ffb0$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "clientId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "maxUserCount"
        }
    ], v1 = [
        {
            "alias": null,
            "args": null,
            "concreteType": "OAuthClientsQuery",
            "kind": "LinkedField",
            "name": "oauthClients",
            "plural": false,
            "selections": [
                {
                    "alias": null,
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "id",
                            "variableName": "clientId"
                        }
                    ],
                    "concreteType": "OAuthClientsClient",
                    "kind": "LinkedField",
                    "name": "client",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": [
                                {
                                    "kind": "Variable",
                                    "name": "max",
                                    "variableName": "maxUserCount"
                                }
                            ],
                            "kind": "ScalarField",
                            "name": "consentedUserCount",
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                }
            ],
            "storageKey": null
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "metadata": null,
            "name": "NumberOfPeopleQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "NumberOfPeopleQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "6387ccc8becc20f998df7ebc7ce30e14",
            "id": null,
            "metadata": {},
            "name": "NumberOfPeopleQuery",
            "operationKind": "query",
            "text": "query NumberOfPeopleQuery(\n  $clientId: ID!\n  $maxUserCount: Int!\n) {\n  oauthClients {\n    client(id: $clientId) {\n      consentedUserCount(max: $maxUserCount)\n    }\n  }\n}\n"
        }
    };
}();
$548e032ca9c2ffb0$var$node.hash = "0205a465ed8095c89ce547ce4caca8dc";
var $548e032ca9c2ffb0$export$2e2bcd8739ae039 = $548e032ca9c2ffb0$var$node;






var $bgNpv = parcelRequire("bgNpv");

var $5T6u3 = parcelRequire("5T6u3");

var $6hgMx = parcelRequire("6hgMx");
// There's a backend limitation that stops us from displaying numbers higher than 1,000 users
// This is the highest the backend will allow us to query for
const $548776d2bb7a93fd$var$MAX_USER_COUNT = 1000;
const $548776d2bb7a93fd$export$6174bb165a21c404 = ()=>{
    const { clientId: clientId } = (0, $6hgMx.useToken)();
    const data = (0, $5T6u3.useLazyLoadQuery)($548776d2bb7a93fd$var$query, {
        clientId: clientId ?? '',
        maxUserCount: $548776d2bb7a93fd$var$MAX_USER_COUNT
    }, {
        fetchKey: clientId ?? ''
    });
    const userCount = data?.oauthClients?.client?.consentedUserCount ?? 0;
    return /*#__PURE__*/ (0, $i3UfC.jsx)((0, $b12736584e34aeee$export$2e2bcd8739ae039), {
        icon: /*#__PURE__*/ (0, $i3UfC.jsx)((0, $bffb6f610480e6bf$export$2e2bcd8739ae039), {
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($77184fb3111af523$exports))),
            label: '',
            appearance: "gray",
            size: "medium"
        }),
        text: /*#__PURE__*/ (0, $i3UfC.jsx)((0, $bgNpv.default), {
            id: "trello.consentedUsers.main",
            defaultMessage: "Used by {consentedUserCount}{moreThanIndicator, select, true {+} other {}} members",
            description: "Number of users that have consented to this app. Used as a trust score to inform the user on whether they wish to trust this app. moreThanIndicator indicates that real number is more than what is shown.",
            values: {
                consentedUserCount: userCount ?? '',
                moreThanIndicator: userCount === $548776d2bb7a93fd$var$MAX_USER_COUNT
            }
        })
    });
};
const $548776d2bb7a93fd$var$query = (0, $548e032ca9c2ffb0$export$2e2bcd8739ae039);



var $i3UfC = parcelRequire("i3UfC");

var $5FkrB = parcelRequire("5FkrB");

var $bgNpv = parcelRequire("bgNpv");
var $kPiFO = parcelRequire("kPiFO");
var $37829b461192a4b5$exports = {};
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f9c38bfa054ce139eb4eb1d828621cdf>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty($37829b461192a4b5$exports, "__esModule", {
    value: true
});
$37829b461192a4b5$exports.default = void 0;

var $37829b461192a4b5$var$_react = $37829b461192a4b5$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $37829b461192a4b5$var$_iconNew = $37829b461192a4b5$var$_interopRequireDefault((parcelRequire("gDzom")));
function $37829b461192a4b5$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Clock".
 * Category: multi-purpose
 * Location: @atlaskit/icon/core/clock
 * Usage guidance:
 * Known uses: recent, time input, sprint time remaining, overdue task work type status.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $37829b461192a4b5$var$ClockIcon = (props)=>/*#__PURE__*/ $37829b461192a4b5$var$_react.default.createElement($37829b461192a4b5$var$_iconNew.default, Object.assign({
        name: "ClockIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M14.5 8a6.5 6.5 0 1 0-13 0 6.5 6.5 0 0 0 13 0M8.75 3.25v4.389l2.219 1.775-.938 1.172-2.5-2-.281-.226V3.25zM16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0"/>`
    }, props));
$37829b461192a4b5$var$ClockIcon.displayName = 'ClockIcon';
var $37829b461192a4b5$var$_default = $37829b461192a4b5$exports.default = $37829b461192a4b5$var$ClockIcon;





var $6hgMx = parcelRequire("6hgMx");
const $5ab8632407404568$export$7e6b81aef0c4534a = ()=>{
    const { client: client } = (0, $6hgMx.useInfo)();
    const messageValues = (0, $5FkrB.useMemo)(()=>$5ab8632407404568$export$d5cac9e57e1bf94d(client?.createdAt), [
        client?.createdAt
    ]);
    if (!messageValues) return /*#__PURE__*/ (0, $i3UfC.jsx)((0, $i3UfC.Fragment), {});
    return /*#__PURE__*/ (0, $i3UfC.jsx)((0, $b12736584e34aeee$export$2e2bcd8739ae039), {
        icon: /*#__PURE__*/ (0, $i3UfC.jsx)((0, $bffb6f610480e6bf$export$2e2bcd8739ae039), {
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($37829b461192a4b5$exports))),
            label: '',
            appearance: "gray",
            size: "medium"
        }),
        text: messageValues.value === 0 && messageValues.unit === 'day' ? /*#__PURE__*/ (0, $i3UfC.jsx)((0, $bgNpv.default), {
            id: "trello.appAge.createdToday",
            defaultMessage: "Created today",
            description: "Notifies the user that this app had only been created today"
        }) : /*#__PURE__*/ (0, $i3UfC.jsx)((0, $bgNpv.default), {
            id: "trello.appAge",
            defaultMessage: "Created {time}",
            description: "A trust indicator which conveys to the user how long this app has existed. The time parameter will be something along the lines of '2 years ago' or '3 months ago'",
            values: {
                time: /*#__PURE__*/ (0, $i3UfC.jsx)((0, $kPiFO.default), {
                    ...messageValues
                })
            }
        })
    });
};
function $5ab8632407404568$export$d5cac9e57e1bf94d(createdAt) {
    if (createdAt == null) {
        console.warn('No creation timestamp provided, skipping...');
        return null;
    }
    const currentTime = Date.now();
    const secondDiff = Math.floor((currentTime - createdAt) / 1000);
    if (secondDiff <= 0) {
        console.warn('Created timestamp is after current time');
        return null;
    }
    const dayDiff = Math.floor(secondDiff / 86400);
    if (dayDiff <= 28) return {
        value: -dayDiff,
        unit: 'day'
    };
    const monthDiff = Math.floor(dayDiff / 28);
    if (dayDiff < 365) return {
        value: -monthDiff,
        unit: 'month'
    };
    const yearDiff = Math.floor(dayDiff / 365);
    return {
        value: -yearDiff,
        unit: 'year'
    };
}



var $i3UfC = parcelRequire("i3UfC");


var $ArAzU = parcelRequire("ArAzU");

var $49b5t = parcelRequire("49b5t");

var $7eKmg = parcelRequire("7eKmg");
const $e9034d91cf7487a7$var$fetchGraphQL = async (request, variables)=>{
    const resp = await fetch((0, $49b5t.withForwardedEnv)('/gateway/api/graphql'), {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            query: request.text,
            variables: variables
        })
    });
    if (!resp.ok) throw new $e9034d91cf7487a7$export$223dce4f73b3e9c3('GraphQL error occurred');
    return await resp.json();
};
class $e9034d91cf7487a7$export$223dce4f73b3e9c3 extends Error {
}
const $e9034d91cf7487a7$export$57570b1603cf6adb = ()=>new (0, $7eKmg.Environment)({
        store: new (0, $7eKmg.Store)(new (0, $7eKmg.RecordSource)({})),
        network: (0, $7eKmg.Network).create($e9034d91cf7487a7$var$fetchGraphQL)
    });



const $ff639965fbc870f3$export$16568267c3bac20d = ({ children: children, errorText: errorText })=>/*#__PURE__*/ (0, $i3UfC.jsx)($ff639965fbc870f3$export$a29a1036b4203d0c, {
        fallback: /*#__PURE__*/ (0, $i3UfC.jsx)((0, $1b254ba6a068f2f1$export$f51f4c4ede09e011), {
            alignItems: "center",
            justifyContent: "center",
            children: /*#__PURE__*/ (0, $i3UfC.jsx)("div", {
                style: {
                    flex: 1
                },
                children: /*#__PURE__*/ (0, $i3UfC.jsx)((0, $ac2404b057b8688e$export$2e2bcd8739ae039), {
                    appearance: "error",
                    title: errorText,
                    children: "Failed to load GraphQL"
                })
            })
        }),
        children: children
    });
function $ff639965fbc870f3$export$a29a1036b4203d0c({ children: children, fallback: fallback }) {
    return /*#__PURE__*/ (0, $i3UfC.jsx)((0, $ArAzU.ErrorBoundary), {
        fallbackRender: (error)=>{
            if (!(error.error instanceof (0, $e9034d91cf7487a7$export$223dce4f73b3e9c3))) {
                console.log('Not a graphql connection error, throwing up', error.error);
                throw error.error;
            }
            return fallback;
        },
        children: children
    });
}


const $c7c47d605fdbf962$var$Highlights = ()=>{
    return /*#__PURE__*/ (0, $i3UfC.jsxs)((0, $c8dbef6c41cfa689$export$694e0d28c7ffc90c), {
        space: 'space.250',
        children: [
            /*#__PURE__*/ (0, $i3UfC.jsx)((0, $07157ac842a32849$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $i3UfC.jsx)((0, $0b9c1685129b3f4d$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $i3UfC.jsx)((0, $05b249cd8b207aea$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $i3UfC.jsx)((0, $ff639965fbc870f3$export$16568267c3bac20d), {
                errorText: "Failed to retrieve number of people",
                children: /*#__PURE__*/ (0, $i3UfC.jsx)((0, $548776d2bb7a93fd$export$6174bb165a21c404), {})
            }),
            /*#__PURE__*/ (0, $i3UfC.jsx)((0, $5ab8632407404568$export$7e6b81aef0c4534a), {}),
            /*#__PURE__*/ (0, $i3UfC.jsx)((0, $dd4c7b878bc16122$export$2e2bcd8739ae039), {})
        ]
    });
};
var $c7c47d605fdbf962$export$2e2bcd8739ae039 = $c7c47d605fdbf962$var$Highlights;



var $i3UfC = parcelRequire("i3UfC");

var $6bnW7 = parcelRequire("6bnW7");
var $bgNpv = parcelRequire("bgNpv");


var $6hgMx = parcelRequire("6hgMx");

var $6bnW7 = parcelRequire("6bnW7");
const $9232082677d3097f$export$117b66c3ae2ec106 = (scopes)=>scopes.filter((scope)=>!$9232082677d3097f$export$36591008fe6bae6.has(scope));
const $9232082677d3097f$export$36591008fe6bae6 = new Set([
    'offline_access'
]);
const $9232082677d3097f$export$16b5018e3fb64253 = (0, $6bnW7.defineMessages)({
    'read:board:trello': {
        id: 'oauth.scopes.read-board-trello',
        defaultMessage: 'Read cards, lists, and comments in boards.',
        description: 'Scope description for read:board:trello - reading board data'
    },
    'read:enterprise:trello': {
        id: 'oauth.scopes.read-enterprise-trello',
        defaultMessage: 'Read enterprises.',
        description: 'Scope description for read:enterprise:trello - reading enterprise data'
    },
    'read:member:trello': {
        id: 'oauth.scopes.read-member-trello',
        defaultMessage: 'Read email address, public name, public avatar, and memberships of boards, workspaces, and enterprises.',
        description: 'Scope description for read:member:trello - reading member profile and membership data'
    },
    'read:organization:trello': {
        id: 'oauth.scopes.read-organization-trello',
        defaultMessage: 'Read workspaces.',
        description: 'Scope description for read:organization:trello - reading workspace and power-up data'
    },
    'write:board:trello': {
        id: 'oauth.scopes.write-board-trello',
        defaultMessage: 'Create and update cards, lists, and comments in boards.',
        description: 'Scope description for write:board:trello - creating and updating board content including cards, lists, and comments'
    },
    'write:board:membership:trello': {
        id: 'oauth.scopes.write-board-membership-trello',
        defaultMessage: 'Add, remove, or modify memberships on boards.',
        description: 'Scope description for write:board:membership:trello - adding and updating board memberships'
    },
    'write:enterprise:trello': {
        id: 'oauth.scopes.write-enterprise-trello',
        defaultMessage: 'Update and manage enterprises.',
        description: 'Scope description for write:enterprise:trello - updating and managing enterprise settings'
    },
    'write:member:trello': {
        id: 'oauth.scopes.write-member-trello',
        defaultMessage: 'Upload custom emojis and stickers, star boards, and save searches.',
        description: 'Scope description for write:member:trello - updating member settings and joining boards/organizations'
    },
    'write:organization:trello': {
        id: 'oauth.scopes.write-organization-trello',
        defaultMessage: 'Update workspaces.',
        description: 'Scope description for write:organization:trello - updating workspace settings and creating workspaces'
    },
    'write:organization:membership:trello': {
        id: 'oauth.scopes.write-organization-membership-trello',
        defaultMessage: 'Add, remove, or modify memberships on workspaces.',
        description: 'Scope description for write:organization:membership:trello - add and update workspace memberships'
    },
    'read:member.inbox:trello': {
        id: 'oauth.scopes.read-member-inbox-trello',
        defaultMessage: 'Read inbox.',
        description: "Scope description for read:member.inbox:trello - reading the user's inbox"
    },
    'write:member.inbox:trello': {
        id: 'oauth.scopes.write-member-inbox-trello',
        defaultMessage: 'Update and manage inbox.',
        description: "Scope description for write:member.inbox:trello - writing to the user's inbox"
    },
    'read:member.planner:trello': {
        id: 'oauth.scopes.read-member-planner-trello',
        defaultMessage: 'Read planner.',
        description: "Scope description for read:member.planner:trello - reading the user's planner"
    },
    'write:member.planner:trello': {
        id: 'oauth.scopes.write-member-planner-trello',
        defaultMessage: 'Update and manage planner.',
        description: "Scope description for write:member.planner:trello - writing to the user's planner"
    }
});


const $73546ffbb54c27ac$var$headers = (0, $6bnW7.defineMessages)({
    header: {
        id: 'trello.permissions.header',
        defaultMessage: '{appName} will be able to',
        description: 'Header describing permissions'
    }
});
const $73546ffbb54c27ac$var$PermissionsBullets = ()=>{
    const { scopes: scopes, clientName: clientName } = (0, $6hgMx.useToken)();
    return /*#__PURE__*/ (0, $i3UfC.jsxs)((0, $383dd904a5a5e5b0$export$e71c4d32a2263218), {
        children: [
            /*#__PURE__*/ (0, $i3UfC.jsx)((0, $bgNpv.default), {
                ...$73546ffbb54c27ac$var$headers.header,
                values: {
                    appName: /*#__PURE__*/ (0, $i3UfC.jsx)("strong", {
                        children: clientName
                    })
                }
            }),
            /*#__PURE__*/ (0, $i3UfC.jsx)("ul", {
                children: (0, $9232082677d3097f$export$117b66c3ae2ec106)(scopes).map((scope)=>/*#__PURE__*/ (0, $i3UfC.jsx)("li", {
                        children: scope in (0, $9232082677d3097f$export$16b5018e3fb64253) ? /*#__PURE__*/ (0, $i3UfC.jsx)((0, $bgNpv.default), {
                            ...(0, $9232082677d3097f$export$16b5018e3fb64253)[scope]
                        }) : /*#__PURE__*/ (0, $i3UfC.jsx)("code", {
                            children: scope
                        })
                    }, scope))
            })
        ]
    });
};
var $73546ffbb54c27ac$export$2e2bcd8739ae039 = $73546ffbb54c27ac$var$PermissionsBullets;



var $i3UfC = parcelRequire("i3UfC");

var $6bnW7 = parcelRequire("6bnW7");
var $bgNpv = parcelRequire("bgNpv");


var $6hgMx = parcelRequire("6hgMx");
const $43ae1cf45fd62282$var$headers = (0, $6bnW7.defineMessages)({
    header: {
        id: 'trello.nonpermissions.header',
        defaultMessage: '{appName} will not be able to',
        description: 'Header describing permissions'
    }
});
const $43ae1cf45fd62282$var$messages = (0, $6bnW7.defineMessages)({
    bulletOne: {
        id: 'trello.nonpermissions.bulletOne',
        defaultMessage: 'See your Trello password',
        description: 'Bullet describing non-permissions'
    }
});
const $43ae1cf45fd62282$var$messagesArray = Object.values($43ae1cf45fd62282$var$messages);
const $43ae1cf45fd62282$var$NonPermissionsBullets = ()=>{
    const { clientName: clientName } = (0, $6hgMx.useToken)();
    return /*#__PURE__*/ (0, $i3UfC.jsxs)((0, $383dd904a5a5e5b0$export$e71c4d32a2263218), {
        children: [
            /*#__PURE__*/ (0, $i3UfC.jsx)((0, $bgNpv.default), {
                ...$43ae1cf45fd62282$var$headers.header,
                values: {
                    appName: /*#__PURE__*/ (0, $i3UfC.jsx)("strong", {
                        children: clientName
                    })
                }
            }),
            /*#__PURE__*/ (0, $i3UfC.jsx)("ul", {
                children: $43ae1cf45fd62282$var$messagesArray.map((message)=>/*#__PURE__*/ (0, $i3UfC.jsx)("li", {
                        children: /*#__PURE__*/ (0, $i3UfC.jsx)((0, $bgNpv.default), {
                            ...message
                        })
                    }, message.id))
            })
        ]
    });
};
var $43ae1cf45fd62282$export$2e2bcd8739ae039 = $43ae1cf45fd62282$var$NonPermissionsBullets;



var $i3UfC = parcelRequire("i3UfC");

var $6bnW7 = parcelRequire("6bnW7");
var $bgNpv = parcelRequire("bgNpv");


var $6hgMx = parcelRequire("6hgMx");

var $i3UfC = parcelRequire("i3UfC");

var $5FkrB = parcelRequire("5FkrB");

var $bgNpv = parcelRequire("bgNpv");


var $i3UfC = parcelRequire("i3UfC");
var $9ba212b3d1d84755$exports = {};
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::43bf53b902c7760c7d34ab2f73c7faf8>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty($9ba212b3d1d84755$exports, "__esModule", {
    value: true
});
$9ba212b3d1d84755$exports.default = void 0;

var $9ba212b3d1d84755$var$_react = $9ba212b3d1d84755$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $9ba212b3d1d84755$var$_iconNew = $9ba212b3d1d84755$var$_interopRequireDefault((parcelRequire("gDzom")));
function $9ba212b3d1d84755$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Board".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/board
 * Usage guidance:
 * Single purpose - Reserved for boards in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $9ba212b3d1d84755$var$BoardIcon = (props)=>/*#__PURE__*/ $9ba212b3d1d84755$var$_react.default.createElement($9ba212b3d1d84755$var$_iconNew.default, Object.assign({
        name: "BoardIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2 3.5a.5.5 0 0 0-.5.5v8a.5.5 0 0 0 .5.5h2.833v-9zm4.333 0v9h3.334v-9zm4.834 0v9H14a.5.5 0 0 0 .5-.5V4a.5.5 0 0 0-.5-.5zM0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2z" clip-rule="evenodd"/>`
    }, props));
$9ba212b3d1d84755$var$BoardIcon.displayName = 'BoardIcon';
var $9ba212b3d1d84755$var$_default = $9ba212b3d1d84755$exports.default = $9ba212b3d1d84755$var$BoardIcon;



function $efba611f751655a8$export$2e2bcd8739ae039({ name: name, boardCount: boardCount }) {
    return /*#__PURE__*/ (0, $i3UfC.jsxs)((0, $10b0af967ce59e29$export$fbae5b5ffd8af05e), {
        alignBlock: "center",
        children: [
            /*#__PURE__*/ (0, $i3UfC.jsx)((0, $10b0af967ce59e29$export$fbae5b5ffd8af05e), {
                grow: "fill",
                alignBlock: "center",
                children: name
            }),
            /*#__PURE__*/ (0, $i3UfC.jsxs)((0, $10b0af967ce59e29$export$fbae5b5ffd8af05e), {
                grow: "fill",
                space: "space.100",
                alignBlock: "center",
                children: [
                    /*#__PURE__*/ (0, $i3UfC.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($9ba212b3d1d84755$exports))), {
                        label: ""
                    }),
                    boardCount ?? 0,
                    " Boards"
                ]
            })
        ]
    });
}



/**
 * @generated SignedSource<<f13aef91f5ab6f63d168554989d6dea8>>
 * @lightSyntaxTransform
 * @nogrep
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $7b044ceb36e15121$var$node = function() {
    var v0 = [
        {
            "alias": null,
            "args": null,
            "concreteType": "TrelloQueryApi",
            "kind": "LinkedField",
            "name": "trello",
            "plural": false,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "TrelloUserUnrestrictedAccessSummary",
                    "kind": "LinkedField",
                    "name": "userUnrestrictedAccessSummary",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "TrelloWorkspaceAccessSummary",
                            "kind": "LinkedField",
                            "name": "topWorkspaces",
                            "plural": true,
                            "selections": [
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "id",
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "displayName",
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "displayBoardCount",
                                    "storageKey": null
                                }
                            ],
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "totalWorkspaces",
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                }
            ],
            "storageKey": null
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "metadata": null,
            "name": "getUserUnrestrictedAccessSummaryQuery",
            "selections": v0 /*: any*/ ,
            "type": "Query",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "getUserUnrestrictedAccessSummaryQuery",
            "selections": v0 /*: any*/ 
        },
        "params": {
            "cacheID": "1d8d3d0add4b92f96c6dd68f42a75567",
            "id": null,
            "metadata": {},
            "name": "getUserUnrestrictedAccessSummaryQuery",
            "operationKind": "query",
            "text": "query getUserUnrestrictedAccessSummaryQuery {\n  trello {\n    userUnrestrictedAccessSummary @optIn(to: \"TrelloUserUnrestrictedAccessSummary\") {\n      topWorkspaces {\n        id\n        displayName\n        displayBoardCount\n      }\n      totalWorkspaces\n    }\n  }\n}\n"
        }
    };
}();
$7b044ceb36e15121$var$node.hash = "b14c762a998c1c6a75430f1b9a4242bb";
var $7b044ceb36e15121$export$2e2bcd8739ae039 = $7b044ceb36e15121$var$node;



var $5T6u3 = parcelRequire("5T6u3");

var $6hgMx = parcelRequire("6hgMx");
function $8594aabd2f33409c$export$56ad1a7f3627eb19() {
    const { userId: userId } = (0, $6hgMx.useToken)();
    const response = (0, $5T6u3.useLazyLoadQuery)($8594aabd2f33409c$var$query, {}, {
        fetchKey: userId
    });
    return response.trello?.userUnrestrictedAccessSummary ?? null;
}
const $8594aabd2f33409c$var$query = (0, $7b044ceb36e15121$export$2e2bcd8739ae039);


const $f8b20b484edeaa77$var$initialWorkspaceLimit = 3;
const $f8b20b484edeaa77$var$expandedWorkspaceLimit = 10;
function $f8b20b484edeaa77$export$2e2bcd8739ae039() {
    const accessSummary = (0, $8594aabd2f33409c$export$56ad1a7f3627eb19)();
    const [limit, setLimit] = (0, $5FkrB.useState)($f8b20b484edeaa77$var$initialWorkspaceLimit);
    const [expanded, setExpanded] = (0, $5FkrB.useState)(false);
    const numberLeft = (accessSummary?.totalWorkspaces ?? 0) - limit;
    return /*#__PURE__*/ (0, $i3UfC.jsxs)((0, $i3UfC.Fragment), {
        children: [
            (accessSummary?.topWorkspaces ?? []).slice(0, limit).map(({ displayName: displayName, displayBoardCount: displayBoardCount }, i)=>/*#__PURE__*/ (0, $i3UfC.jsx)((0, $efba611f751655a8$export$2e2bcd8739ae039), {
                    name: displayName ?? '',
                    boardCount: displayBoardCount ?? 0
                }, displayName ?? i)),
            !expanded && numberLeft > 0 && /*#__PURE__*/ (0, $i3UfC.jsx)((0, $64e95b69a05329e9$export$2e2bcd8739ae039), {
                href: '',
                onClick: (e)=>{
                    e.preventDefault();
                    setLimit($f8b20b484edeaa77$var$expandedWorkspaceLimit);
                    setExpanded(true);
                },
                children: /*#__PURE__*/ (0, $i3UfC.jsx)((0, $bgNpv.default), {
                    id: "trello.workspaces.showMoreWorkspacesAndBoards",
                    defaultMessage: "Show more Workspaces and boards",
                    description: "Show more workspaces and boards link"
                })
            }),
            expanded && numberLeft > 0 && /*#__PURE__*/ (0, $i3UfC.jsx)((0, $d48daa9a522ca942$export$5f1af8db9871e1d6), {
                weight: "bold",
                children: /*#__PURE__*/ (0, $i3UfC.jsx)((0, $bgNpv.default), {
                    id: "trello.workspaces.andAllOtherWorkspacesAndBoards",
                    defaultMessage: "And {numberLeft, plural, one {other Workspace and boards} other {# other Workspaces and boards}}",
                    description: "Show the remaining workspaces not shown in the current list",
                    values: {
                        numberLeft: numberLeft
                    }
                })
            })
        ]
    });
}



var $i3UfC = parcelRequire("i3UfC");

/**
 * @generated SignedSource<<3cf52cb7790510c2b25724c767781ae2>>
 * @lightSyntaxTransform
 * @nogrep
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $52d2a1fcb2f6228d$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "shouldSkip"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "workspaceAri"
    }, v2 = [
        {
            "alias": null,
            "args": null,
            "concreteType": "TrelloQueryApi",
            "kind": "LinkedField",
            "name": "trello",
            "plural": false,
            "selections": [
                {
                    "condition": "shouldSkip",
                    "kind": "Condition",
                    "passingValue": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": [
                                {
                                    "kind": "Variable",
                                    "name": "workspaceId",
                                    "variableName": "workspaceAri"
                                }
                            ],
                            "concreteType": "TrelloWorkspaceAccessSummary",
                            "kind": "LinkedField",
                            "name": "userWorkspaceAccessSummary",
                            "plural": false,
                            "selections": [
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "id",
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "displayName",
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "displayBoardCount",
                                    "storageKey": null
                                }
                            ],
                            "storageKey": null
                        }
                    ]
                }
            ],
            "storageKey": null
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Fragment",
            "metadata": null,
            "name": "getUserWorkspaceAccessSummaryQuery",
            "selections": v2 /*: any*/ ,
            "type": "Query",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "getUserWorkspaceAccessSummaryQuery",
            "selections": v2 /*: any*/ 
        },
        "params": {
            "cacheID": "2b93b07ab2b199c8f36cbe23fff94dde",
            "id": null,
            "metadata": {},
            "name": "getUserWorkspaceAccessSummaryQuery",
            "operationKind": "query",
            "text": "query getUserWorkspaceAccessSummaryQuery(\n  $workspaceAri: ID!\n  $shouldSkip: Boolean!\n) {\n  trello {\n    userWorkspaceAccessSummary(workspaceId: $workspaceAri) @skip(if: $shouldSkip) @optIn(to: \"TrelloUserWorkspaceAccessSummary\") {\n      id\n      displayName\n      displayBoardCount\n    }\n  }\n}\n"
        }
    };
}();
$52d2a1fcb2f6228d$var$node.hash = "3dc4854fd11cd66cc3c744bc254b29e7";
var $52d2a1fcb2f6228d$export$2e2bcd8739ae039 = $52d2a1fcb2f6228d$var$node;



var $5T6u3 = parcelRequire("5T6u3");

var $6hgMx = parcelRequire("6hgMx");
const $7a20943a083baa6c$export$4816faf9d173ec06 = ()=>{
    const { resources: resources } = (0, $6hgMx.useToken)();
    const resource = resources?.at(0);
    const response = (0, $5T6u3.useLazyLoadQuery)($7a20943a083baa6c$var$query, // We'll skip this query if there's no workspace so it's safe to assume this is a string
    {
        workspaceAri: resource,
        shouldSkip: !resource
    }, {
        fetchKey: resource
    });
    const workspaceSummary = response.trello?.userWorkspaceAccessSummary;
    return {
        displayName: workspaceSummary?.displayName ?? '',
        displayBoardCount: workspaceSummary?.displayBoardCount ?? 0
    };
};
const $7a20943a083baa6c$var$query = (0, $52d2a1fcb2f6228d$export$2e2bcd8739ae039);


function $d45cdb061c33a521$export$94cb11f80a21693() {
    const { displayName: displayName, displayBoardCount: displayBoardCount } = (0, $7a20943a083baa6c$export$4816faf9d173ec06)();
    return /*#__PURE__*/ (0, $i3UfC.jsx)((0, $efba611f751655a8$export$2e2bcd8739ae039), {
        name: displayName,
        boardCount: displayBoardCount ?? 0
    });
}




var $i3UfC = parcelRequire("i3UfC");

var $bgNpv = parcelRequire("bgNpv");


const $204a36e6901b6961$export$7e4dcdc2fb5a93d9 = ({ hasRestrictedWorkspace: hasRestrictedWorkspace, clientName: clientName })=>/*#__PURE__*/ (0, $i3UfC.jsx)((0, $i3UfC.Fragment), {
        children: hasRestrictedWorkspace ? /*#__PURE__*/ (0, $i3UfC.jsx)((0, $ff639965fbc870f3$export$a29a1036b4203d0c), {
            fallback: /*#__PURE__*/ (0, $i3UfC.jsx)($204a36e6901b6961$var$RestrictedWorkspaceFooterComponent, {
                clientName: clientName,
                displayName: "???"
            }),
            children: /*#__PURE__*/ (0, $i3UfC.jsx)($204a36e6901b6961$var$RestrictedWorkspaceFooter, {
                clientName: clientName
            })
        }) : /*#__PURE__*/ (0, $i3UfC.jsx)((0, $bgNpv.default), {
            id: "trello.permissions.footer.unrestrictedWorkspace",
            defaultMessage: "Additionally, {appName} will have access to any boards and Workspaces you gain access to in the future",
            description: "Disclaimer detailing that not only will the app have access to the current boards and workspaces but also any new ones that the user is added to",
            values: {
                appName: /*#__PURE__*/ (0, $i3UfC.jsx)("strong", {
                    children: clientName
                })
            }
        })
    });
function $204a36e6901b6961$var$RestrictedWorkspaceFooter({ clientName: clientName }) {
    const { displayName: displayName } = (0, $7a20943a083baa6c$export$4816faf9d173ec06)();
    return /*#__PURE__*/ (0, $i3UfC.jsx)($204a36e6901b6961$var$RestrictedWorkspaceFooterComponent, {
        clientName: clientName,
        displayName: displayName
    });
}
const $204a36e6901b6961$var$RestrictedWorkspaceFooterComponent = ({ clientName: clientName, displayName: displayName })=>/*#__PURE__*/ (0, $i3UfC.jsx)((0, $bgNpv.default), {
        id: "trello.permissions.footer.restrictedWorkspace",
        defaultMessage: "Additionally, {appName} will have access to any new boards added to {workspace} in the future",
        description: "Disclaimer detailing that not only will the app have access to the current boards in the workspaces but also any new ones that the user is added to in the specific workspace",
        values: {
            appName: /*#__PURE__*/ (0, $i3UfC.jsx)("strong", {
                children: clientName
            }),
            workspace: /*#__PURE__*/ (0, $i3UfC.jsx)("strong", {
                children: displayName
            })
        }
    });


const $35212942944aa30a$var$messages = (0, $6bnW7.defineMessages)({
    headerRestrictedWorkspace: {
        id: 'trello.workspaces.header.restrictedWorkspace',
        defaultMessage: '{appName} will have access to <strong>this Workspace and its boards</strong>:',
        description: 'Header describing that consenting to this application allows the app to access the following workspaces and the boards in it'
    },
    headerUnrestrictedWorkspace: {
        id: 'trello.workspaces.header.unrestrictedWorkspace',
        defaultMessage: '{appName} will have access to <strong>all Workspaces and boards</strong> you\'re a member of <strong>and</strong> have access to:',
        description: 'Header describing boards and workspaces'
    }
});
const $35212942944aa30a$var$BoardsAndWorkspaces = ()=>{
    const { clientName: clientName, resources: resources } = (0, $6hgMx.useToken)();
    const hasRestrictedWorkspace = resources?.length === 1;
    return /*#__PURE__*/ (0, $i3UfC.jsxs)((0, $c8dbef6c41cfa689$export$694e0d28c7ffc90c), {
        space: "space.400",
        children: [
            /*#__PURE__*/ (0, $i3UfC.jsxs)((0, $c8dbef6c41cfa689$export$694e0d28c7ffc90c), {
                space: "space.200",
                children: [
                    /*#__PURE__*/ (0, $i3UfC.jsx)((0, $383dd904a5a5e5b0$export$e71c4d32a2263218), {
                        children: /*#__PURE__*/ (0, $i3UfC.jsx)((0, $bgNpv.default), {
                            ...hasRestrictedWorkspace ? $35212942944aa30a$var$messages.headerRestrictedWorkspace : $35212942944aa30a$var$messages.headerUnrestrictedWorkspace,
                            values: {
                                appName: /*#__PURE__*/ (0, $i3UfC.jsx)("strong", {
                                    children: clientName
                                }),
                                strong: (chunk)=>/*#__PURE__*/ (0, $i3UfC.jsx)("strong", {
                                        children: chunk
                                    })
                            }
                        })
                    }),
                    /*#__PURE__*/ (0, $i3UfC.jsx)((0, $ff639965fbc870f3$export$16568267c3bac20d), {
                        errorText: "Failed to retrieve workspace information",
                        children: hasRestrictedWorkspace ? /*#__PURE__*/ (0, $i3UfC.jsx)((0, $d45cdb061c33a521$export$94cb11f80a21693), {}) : /*#__PURE__*/ (0, $i3UfC.jsx)((0, $f8b20b484edeaa77$export$2e2bcd8739ae039), {})
                    })
                ]
            }),
            /*#__PURE__*/ (0, $i3UfC.jsx)((0, $383dd904a5a5e5b0$export$e71c4d32a2263218), {
                children: /*#__PURE__*/ (0, $i3UfC.jsx)((0, $204a36e6901b6961$export$7e4dcdc2fb5a93d9), {
                    hasRestrictedWorkspace: hasRestrictedWorkspace,
                    clientName: clientName ?? ''
                })
            })
        ]
    });
};
var $35212942944aa30a$export$2e2bcd8739ae039 = $35212942944aa30a$var$BoardsAndWorkspaces;



var $i3UfC = parcelRequire("i3UfC");

var $2gmBL = parcelRequire("2gmBL");

var $leM9a = parcelRequire("leM9a");
/**
 * @generated SignedSource<<1617d1b508a1f613f1a468444ec906b4>>
 * @lightSyntaxTransform
 * @nogrep
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $2112f3ecfa0c4f36$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "appId"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "appId"
        }
    ], v2 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
    }, v3 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "accountId",
        "storageKey": null
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "metadata": null,
            "name": "getPluginCollaboratorsQuery",
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "TrelloQueryApi",
                    "kind": "LinkedField",
                    "name": "trello",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": v1 /*: any*/ ,
                            "concreteType": "TrelloApplication",
                            "kind": "LinkedField",
                            "name": "application",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "TrelloMember",
                                    "kind": "LinkedField",
                                    "name": "collaborators",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": null,
                                            "kind": "LinkedField",
                                            "name": "user",
                                            "plural": false,
                                            "selections": [
                                                v3 /*: any*/ 
                                            ],
                                            "storageKey": null
                                        }
                                    ],
                                    "storageKey": null
                                }
                            ],
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                }
            ],
            "type": "Query",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "getPluginCollaboratorsQuery",
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "TrelloQueryApi",
                    "kind": "LinkedField",
                    "name": "trello",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": v1 /*: any*/ ,
                            "concreteType": "TrelloApplication",
                            "kind": "LinkedField",
                            "name": "application",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "TrelloMember",
                                    "kind": "LinkedField",
                                    "name": "collaborators",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": null,
                                            "kind": "LinkedField",
                                            "name": "user",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "__typename",
                                                    "storageKey": null
                                                },
                                                v3 /*: any*/ ,
                                                v2 /*: any*/ 
                                            ],
                                            "storageKey": null
                                        },
                                        v2 /*: any*/ 
                                    ],
                                    "storageKey": null
                                }
                            ],
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                }
            ]
        },
        "params": {
            "cacheID": "a2d88e23d2809cbc3876066c29a85a85",
            "id": null,
            "metadata": {},
            "name": "getPluginCollaboratorsQuery",
            "operationKind": "query",
            "text": "query getPluginCollaboratorsQuery(\n  $appId: ID!\n) {\n  trello {\n    application(id: $appId) @optIn(to: \"TrelloApplication\") {\n      id\n      collaborators {\n        user {\n          __typename\n          accountId\n          id\n        }\n        id\n      }\n    }\n  }\n}\n"
        }
    };
}();
$2112f3ecfa0c4f36$var$node.hash = "a67728d2ad223d2a02c419b8a62f65bc";
var $2112f3ecfa0c4f36$export$2e2bcd8739ae039 = $2112f3ecfa0c4f36$var$node;



var $5T6u3 = parcelRequire("5T6u3");

var $6hgMx = parcelRequire("6hgMx");
const $5755f8ef81c463fa$var$query = (0, $2112f3ecfa0c4f36$export$2e2bcd8739ae039);
const $5755f8ef81c463fa$var$toAppAri = (appId)=>`ari:cloud:trello::application/${appId}`;
function $5755f8ef81c463fa$export$7f7eda15d4f7bca() {
    const { userId: userId } = (0, $6hgMx.useToken)();
    const info = (0, $6hgMx.useInfo)();
    // appId is guaranteed to be set by AccessGate before this hook is called
    const appId = info.client.appId;
    const appAri = $5755f8ef81c463fa$var$toAppAri(appId);
    const response = (0, $5T6u3.useLazyLoadQuery)($5755f8ef81c463fa$var$query, {
        appId: appAri
    }, {
        fetchKey: appAri
    });
    const application = response.trello?.application;
    if (!application) return false;
    return (application.collaborators ?? []).some((collaborator)=>collaborator.user?.accountId === userId);
}



var $6hgMx = parcelRequire("6hgMx");

var $3VQxn = parcelRequire("3VQxn");
/**
 * Restricts the Trello consent screen to app authors and collaborators
 * when the contributor gate feature flag is enabled.
 */ const $2ce0f5b0d57f06d8$var$AccessGateInner = ({ children: children })=>{
    const hasAccess = (0, $5755f8ef81c463fa$export$7f7eda15d4f7bca)();
    if (!hasAccess) throw 0, $3VQxn.noAccessError;
    return /*#__PURE__*/ (0, $i3UfC.jsx)((0, $i3UfC.Fragment), {
        children: children
    });
};
const $2ce0f5b0d57f06d8$var$AccessGate = ({ children: children })=>{
    const isContributorGateEnabled = (0, $2gmBL.useFeatureGate)((0, $leM9a.OAuthConsentFeatureGate).TRELLO_CONTRIBUTOR_GATE);
    const info = (0, $6hgMx.useInfo)();
    const appId = info.client?.appId;
    // Skip the gate if the feature flag is off or if there's no appId
    // (the collaborator query requires a valid appId).
    if (!isContributorGateEnabled || !appId) return /*#__PURE__*/ (0, $i3UfC.jsx)((0, $i3UfC.Fragment), {
        children: children
    });
    return /*#__PURE__*/ (0, $i3UfC.jsx)($2ce0f5b0d57f06d8$var$AccessGateInner, {
        children: children
    });
};
var $2ce0f5b0d57f06d8$export$2e2bcd8739ae039 = $2ce0f5b0d57f06d8$var$AccessGate;


const $032f59b166f07d41$var$_2 = "._1bsb1osq{width:100%}";
const $032f59b166f07d41$var$_ = "._1h6d1l7x{border-color:var(--ds-border,#0b120e24)}";
const $032f59b166f07d41$var$Trello = ()=>{
    return /*#__PURE__*/ (0, $i3UfC.jsxs)((0, $2ce0f5b0d57f06d8$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $i3UfC.jsx)((0, $7e29612a9bf13cda$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $i3UfC.jsxs)((0, $c8dbef6c41cfa689$export$694e0d28c7ffc90c), {
                alignInline: "center",
                space: "space.200",
                children: [
                    /*#__PURE__*/ (0, $i3UfC.jsx)((0, $48e45b7ab9243772$export$2e2bcd8739ae039), {
                        logoUrl: ''
                    }),
                    /*#__PURE__*/ (0, $i3UfC.jsx)($032f59b166f07d41$var$Separator, {}),
                    /*#__PURE__*/ (0, $i3UfC.jsx)((0, $c7c47d605fdbf962$export$2e2bcd8739ae039), {}),
                    /*#__PURE__*/ (0, $i3UfC.jsx)($032f59b166f07d41$var$Separator, {}),
                    /*#__PURE__*/ (0, $i3UfC.jsxs)((0, $c8dbef6c41cfa689$export$694e0d28c7ffc90c), {
                        space: "space.400",
                        children: [
                            /*#__PURE__*/ (0, $i3UfC.jsx)((0, $73546ffbb54c27ac$export$2e2bcd8739ae039), {}),
                            /*#__PURE__*/ (0, $i3UfC.jsx)((0, $43ae1cf45fd62282$export$2e2bcd8739ae039), {}),
                            /*#__PURE__*/ (0, $i3UfC.jsx)((0, $35212942944aa30a$export$2e2bcd8739ae039), {})
                        ]
                    }),
                    /*#__PURE__*/ (0, $i3UfC.jsx)($032f59b166f07d41$var$Separator, {})
                ]
            })
        ]
    });
};
const $032f59b166f07d41$var$separatorStyle = null;
const $032f59b166f07d41$var$Separator = ()=>/*#__PURE__*/ (0, $i3UfC.jsxs)((0, $dbdf44c207cf40e4$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $i3UfC.jsx)((0, $c179d2a16dc49323$export$2e2bcd8739ae039), {
                children: [
                    $032f59b166f07d41$var$_,
                    $032f59b166f07d41$var$_2
                ]
            }),
            /*#__PURE__*/ (0, $i3UfC.jsx)("hr", {
                role: "presentation",
                className: (0, $b02ab0e3a0f362dd$export$2e2bcd8739ae039)([
                    "_1h6d1l7x _1bsb1osq"
                ])
            })
        ]
    });
var $032f59b166f07d41$export$2e2bcd8739ae039 = $032f59b166f07d41$var$Trello;



var $i3UfC = parcelRequire("i3UfC");


var $5FkrB = parcelRequire("5FkrB");

var $i3UfC = parcelRequire("i3UfC");

var $6bnW7 = parcelRequire("6bnW7");
var $bgNpv = parcelRequire("bgNpv");
const $b54557f95fa73b88$var$messages = (0, $6bnW7.defineMessages)({
    title: {
        id: 'applinks.heading',
        defaultMessage: 'Welcome to {customer}',
        description: 'Heading for applinks, welcoming the user to the customer app (Jira or Confluence)'
    }
});
const $b54557f95fa73b88$var$Header = ({ appName: appName })=>{
    return /*#__PURE__*/ (0, $i3UfC.jsx)((0, $bgNpv.default), {
        ...$b54557f95fa73b88$var$messages.title,
        values: {
            customer: appName
        },
        tagName: "h1"
    });
};
var $b54557f95fa73b88$export$2e2bcd8739ae039 = $b54557f95fa73b88$var$Header;



var $i3UfC = parcelRequire("i3UfC");

var $gDiFE = parcelRequire("gDiFE");

var $6bnW7 = parcelRequire("6bnW7");
var $bgNpv = parcelRequire("bgNpv");
const $e115e5d96bda1625$var$centeredContentStyles = (0, $gDiFE.xcss)({
    textAlign: 'center'
});
const $e115e5d96bda1625$var$messages = (0, $6bnW7.defineMessages)({
    description: {
        id: 'applinks.description',
        defaultMessage: 'The application {appName} would like to have read and write access to your data on {url}. The application will be allowed to use your credentials to authenticate as you ({userFullName}) in the future.',
        description: 'Description for applinks describing that the app (Jira or Confluence) would like to have permissions to read and write on behalf of the user on the provided site'
    }
});
const $e115e5d96bda1625$var$Description = ({ clientName: clientName, url: url, userFullName: userFullName })=>/*#__PURE__*/ (0, $i3UfC.jsx)((0, $383dd904a5a5e5b0$export$e71c4d32a2263218), {
        xcss: $e115e5d96bda1625$var$centeredContentStyles,
        children: /*#__PURE__*/ (0, $i3UfC.jsx)((0, $bgNpv.default), {
            ...$e115e5d96bda1625$var$messages.description,
            values: {
                appName: /*#__PURE__*/ (0, $i3UfC.jsx)("strong", {
                    children: clientName
                }),
                url: /*#__PURE__*/ (0, $i3UfC.jsx)("strong", {
                    children: url
                }),
                userFullName: /*#__PURE__*/ (0, $i3UfC.jsx)("strong", {
                    children: userFullName
                })
            }
        })
    });
var $e115e5d96bda1625$export$2e2bcd8739ae039 = $e115e5d96bda1625$var$Description;



var $i3UfC = parcelRequire("i3UfC");

var $6bnW7 = parcelRequire("6bnW7");
var $bgNpv = parcelRequire("bgNpv");

const $543a4f5de3f63892$var$messages = (0, $6bnW7.defineMessages)({
    warningFirstLine: {
        id: 'applinks.warning.v2',
        defaultMessage: 'By allowing this, you can use {appName} without storing your {appName} password in {clientName}.',
        description: 'Warning for applinks that ensures the user knows what accepting this consent will do'
    }
});
const $543a4f5de3f63892$var$Warning = ({ clientName: clientName, appName: appName })=>/*#__PURE__*/ (0, $i3UfC.jsxs)((0, $ac2404b057b8688e$export$2e2bcd8739ae039), {
        appearance: "warning",
        children: [
            /*#__PURE__*/ (0, $i3UfC.jsx)("p", {}),
            /*#__PURE__*/ (0, $i3UfC.jsx)((0, $bgNpv.default), {
                ...$543a4f5de3f63892$var$messages.warningFirstLine,
                values: {
                    clientName: /*#__PURE__*/ (0, $i3UfC.jsx)("strong", {
                        children: clientName
                    }),
                    appName: /*#__PURE__*/ (0, $i3UfC.jsx)("strong", {
                        children: appName
                    })
                }
            })
        ]
    });
var $543a4f5de3f63892$export$2e2bcd8739ae039 = $543a4f5de3f63892$var$Warning;



var $6hgMx = parcelRequire("6hgMx");

var $f5RPY = parcelRequire("f5RPY");

var $6bnW7 = parcelRequire("6bnW7");
var $hrVKU = parcelRequire("hrVKU");
const $01cd1c011e00a683$var$AppLinks = ()=>{
    const { customer: rawAppName, cloudId: cloudId, clientId: clientId, clientName: rawClientName } = (0, $6hgMx.useToken)();
    const { siteName: siteName } = (0, $6hgMx.useInfo)();
    const user = (0, $f5RPY.useUser)();
    const intl = (0, $hrVKU.default)();
    const appName = $01cd1c011e00a683$var$determineAppName(rawAppName);
    const clientName = rawClientName ?? clientId ?? intl.formatMessage($01cd1c011e00a683$var$messages.unknownApplication);
    (0, $5FkrB.useEffect)(()=>{
        document.title = intl.formatMessage($01cd1c011e00a683$var$messages.documentTitle, {
            customerName: appName,
            clientName: clientName
        });
    }, [
        appName,
        clientName,
        intl
    ]);
    return /*#__PURE__*/ (0, $i3UfC.jsx)((0, $1b254ba6a068f2f1$export$f51f4c4ede09e011), {
        gap: "space.400",
        direction: "column",
        wrap: "wrap",
        alignItems: "start",
        children: /*#__PURE__*/ (0, $i3UfC.jsxs)((0, $1b254ba6a068f2f1$export$f51f4c4ede09e011), {
            alignItems: "center",
            direction: "column",
            gap: "space.400",
            children: [
                /*#__PURE__*/ (0, $i3UfC.jsx)((0, $b54557f95fa73b88$export$2e2bcd8739ae039), {
                    appName: appName
                }),
                /*#__PURE__*/ (0, $i3UfC.jsx)((0, $e115e5d96bda1625$export$2e2bcd8739ae039), {
                    url: siteName ?? `<${cloudId}>`,
                    userFullName: user?.name || 'null',
                    clientName: clientName
                }),
                /*#__PURE__*/ (0, $i3UfC.jsx)((0, $543a4f5de3f63892$export$2e2bcd8739ae039), {
                    clientName: clientName,
                    appName: appName
                })
            ]
        })
    });
};
function $01cd1c011e00a683$var$determineAppName(rawAppName) {
    switch(rawAppName){
        case 'jira':
            return 'Jira';
        case 'confluence':
            return 'Confluence';
        default:
            return 'Unknown';
    }
}
const $01cd1c011e00a683$var$messages = (0, $6bnW7.defineMessages)({
    documentTitle: {
        id: 'applinks.documentTitle',
        defaultMessage: 'Welcome to {customerName} - {clientName}',
        description: 'The document title that acts as the tab name. {customerName} is either Confluence or Jira.'
    },
    unknownApplication: {
        id: 'applinks.unknownApplication',
        defaultMessage: 'An unknown application',
        description: 'Fallback shown in place of the requesting application name when the consent token carries neither a client name nor a client id'
    }
});
var $01cd1c011e00a683$export$2e2bcd8739ae039 = $01cd1c011e00a683$var$AppLinks;



var $6hgMx = parcelRequire("6hgMx");

var $i3UfC = parcelRequire("i3UfC");


var $i3UfC = parcelRequire("i3UfC");

var $5FkrB = parcelRequire("5FkrB");

var $2gmBL = parcelRequire("2gmBL");

var $leM9a = parcelRequire("leM9a");



var $6bnW7 = parcelRequire("6bnW7");
var $hrVKU = parcelRequire("hrVKU");

var $gDiFE = parcelRequire("gDiFE");


var $6hgMx = parcelRequire("6hgMx");




const $4bddcf4e49215fd4$var$messages = (0, $6bnW7.defineMessages)({
    siteLabel: {
        id: 'siteSelector.rovo.singleSiteLabel',
        defaultMessage: 'Site',
        description: 'Field label for the single site to authorize'
    },
    sitePlaceholder: {
        id: 'siteSelector.sitePlaceholder',
        defaultMessage: 'Select',
        description: 'Placeholder for which sites user wants to authorize'
    },
    recentGroupLabel: {
        id: 'siteSelector.recentGroupLabel',
        defaultMessage: 'Recently used',
        description: 'Group label for sites the user has used recently'
    },
    allSitesGroupLabel: {
        id: 'siteSelector.allSitesGroupLabel',
        defaultMessage: 'All',
        description: 'Group label for all sites the user can authorize'
    },
    siteLabelCount: {
        id: 'siteSelector.refreshed.label',
        defaultMessage: '{count, plural, one {Site} other {Sites}}',
        description: 'Field label shown above the site selector, pluralised based on the number of selected sites'
    }
});
const $4bddcf4e49215fd4$var$wrapperStyles = (0, $gDiFE.xcss)({
    width: '100%',
    alignSelf: 'stretch'
});
const $4bddcf4e49215fd4$var$stackStyles = (0, $gDiFE.xcss)({
    width: '100%'
});
const $4bddcf4e49215fd4$var$groupLabelStyles = (0, $gDiFE.xcss)({
    paddingBlock: 'space.050',
    paddingInline: 'space.025'
});
/**
 * Derive a human-friendly display name from a bare site URL by taking the first
 * DNS label and capitalising it, e.g. `mario.atlassian.net` -> `Mario`. Falls
 * back to the original string if there is no recognisable subdomain.
 */ const $4bddcf4e49215fd4$var$deriveNameFromUrl = (url)=>{
    const firstLabel = url.split('.')[0]?.trim();
    if (!firstLabel) return url;
    return firstLabel.charAt(0).toUpperCase() + firstLabel.slice(1);
};
/**
 * Workspaces may arrive as `name|url` (e.g. `Hello|hello.atlassian.net`) or as a
 * bare URL (e.g. `mario.atlassian.net`). When an explicit `name|url` is given,
 * split on the first `|`. Otherwise derive the display name from the URL's
 * subdomain so both the name and the URL can be shown.
 */ const $4bddcf4e49215fd4$var$parseWorkspace = (workspace)=>{
    const separatorIndex = workspace.indexOf('|');
    if (separatorIndex === -1) return {
        name: $4bddcf4e49215fd4$var$deriveNameFromUrl(workspace),
        url: workspace
    };
    return {
        name: workspace.slice(0, separatorIndex),
        url: workspace.slice(separatorIndex + 1)
    };
};
function $4bddcf4e49215fd4$var$getSiteIdFromSiteMappingKey(siteMappingKey) {
    try {
        const ari = (0, $2b94537363720eb1$export$44a7af7122933d6b).parse(siteMappingKey);
        if (ari.resourceType === 'site') return ari.resourceId;
    } catch  {
        return siteMappingKey;
    }
    return siteMappingKey;
}
function $4bddcf4e49215fd4$var$getSiteIdsByWorkspace(siteMapping) {
    const siteIdsByWorkspace = new Map();
    for (const [siteMappingKey, workspace] of Object.entries(siteMapping ?? {})){
        const siteId = $4bddcf4e49215fd4$var$getSiteIdFromSiteMappingKey(siteMappingKey);
        siteIdsByWorkspace.set(workspace, siteId);
    }
    return siteIdsByWorkspace;
}
function $4bddcf4e49215fd4$var$getSiteInfoByWorkspace(availableSites, siteMapping) {
    const result = new Map();
    if (availableSites && availableSites.length > 0) {
        for (const site of availableSites){
            const siteId = $4bddcf4e49215fd4$var$getSiteIdFromSiteMappingKey(site.ari);
            result.set(site.url, {
                siteId: siteId,
                avatar: site.avatar || undefined
            });
        }
        return result;
    }
    // Fallback: siteMapping only (no avatar)
    for (const [siteMappingKey, workspace] of Object.entries(siteMapping ?? {})){
        const siteId = $4bddcf4e49215fd4$var$getSiteIdFromSiteMappingKey(siteMappingKey);
        result.set(workspace, {
            siteId: siteId
        });
    }
    return result;
}
function $4bddcf4e49215fd4$var$getWorkspaceSiteId(workspace, siteIdsByWorkspace) {
    const parsedWorkspace = $4bddcf4e49215fd4$var$parseWorkspace(workspace);
    return siteIdsByWorkspace.get(workspace) ?? siteIdsByWorkspace.get(parsedWorkspace.url) ?? siteIdsByWorkspace.get(parsedWorkspace.name) ?? null;
}
const $4bddcf4e49215fd4$var$toOption = (workspace, siteIdsByWorkspace, siteInfoByWorkspace)=>{
    const parsedWorkspace = $4bddcf4e49215fd4$var$parseWorkspace(workspace);
    const siteInfo = siteInfoByWorkspace?.get(workspace) ?? siteInfoByWorkspace?.get(parsedWorkspace.url) ?? siteInfoByWorkspace?.get(parsedWorkspace.name);
    return {
        value: workspace,
        label: parsedWorkspace.name,
        siteId: siteInfo?.siteId ?? $4bddcf4e49215fd4$var$getWorkspaceSiteId(workspace, siteIdsByWorkspace),
        workspace: workspace,
        avatarUrl: siteInfo?.avatar
    };
};
function $4bddcf4e49215fd4$var$groupWorkspaceOptionsByMostUsedSites({ options: options, mostUsedSites: mostUsedSites, recentLabel: recentLabel, allSitesLabel: allSitesLabel }) {
    if (mostUsedSites.length === 0) return options;
    const optionsBySiteId = new Map();
    for (const option of options){
        if (!option.siteId) continue;
        optionsBySiteId.set(option.siteId, [
            ...optionsBySiteId.get(option.siteId) ?? [],
            option
        ]);
    }
    // Keep duplicated recent/all rows as distinct option objects so focus/hover
    // styling only applies to the row the user is actually interacting with.
    const mostUsedOptions = mostUsedSites.flatMap((site)=>(optionsBySiteId.get(site.siteId) ?? []).map((option)=>({
                ...option,
                value: `recent:${option.workspace}`
            })));
    if (mostUsedOptions.length === 0) return options;
    return [
        {
            label: recentLabel,
            options: mostUsedOptions
        },
        {
            label: allSitesLabel,
            options: options
        }
    ];
}
function $4bddcf4e49215fd4$var$isWorkspaceOptionGroup(optionOrGroup) {
    return Array.isArray(optionOrGroup.options);
}
const $4bddcf4e49215fd4$var$Option = (props)=>{
    const workspace = props.data.workspace;
    const { name: name, url: url } = $4bddcf4e49215fd4$var$parseWorkspace(workspace);
    const isSelected = props.isWorkspaceSelected ?? props.isSelected;
    return /*#__PURE__*/ (0, $i3UfC.jsx)((0, $525be6c0d6b9e93b$export$9b5ac10f59f76296).Option, {
        ...props,
        isSelected: isSelected,
        children: /*#__PURE__*/ (0, $i3UfC.jsxs)((0, $10b0af967ce59e29$export$fbae5b5ffd8af05e), {
            space: "space.100",
            alignBlock: "center",
            children: [
                props.isMulti && /*#__PURE__*/ (0, $i3UfC.jsx)("input", {
                    type: "checkbox",
                    checked: isSelected,
                    readOnly: true,
                    tabIndex: -1,
                    "aria-hidden": true
                }),
                /*#__PURE__*/ (0, $i3UfC.jsx)((0, $ebae6d75f4c9721e$export$2e2bcd8739ae039), {
                    avatarUrl: props.data.avatarUrl
                }),
                /*#__PURE__*/ (0, $i3UfC.jsxs)((0, $c8dbef6c41cfa689$export$694e0d28c7ffc90c), {
                    children: [
                        /*#__PURE__*/ (0, $i3UfC.jsx)((0, $d48daa9a522ca942$export$5f1af8db9871e1d6), {
                            weight: "medium",
                            children: name
                        }),
                        url !== name && /*#__PURE__*/ (0, $i3UfC.jsx)((0, $d48daa9a522ca942$export$5f1af8db9871e1d6), {
                            size: "small",
                            color: "color.text.subtlest",
                            children: url
                        })
                    ]
                })
            ]
        })
    });
};
const $4bddcf4e49215fd4$var$SingleValue = (props)=>{
    const { name: name, url: url } = $4bddcf4e49215fd4$var$parseWorkspace(String(props.data.workspace ?? props.data.value));
    return /*#__PURE__*/ (0, $i3UfC.jsx)((0, $525be6c0d6b9e93b$export$9b5ac10f59f76296).SingleValue, {
        ...props,
        children: url !== name ? `${name} | ${url}` : name
    });
};
const $4bddcf4e49215fd4$var$chipColor = (option)=>{
    const avatarUrl = option.avatarUrl;
    return (0, $75748f21d6184a53$export$5f8ff7cb3b9550d1)(avatarUrl) ?? (0, $75748f21d6184a53$export$6b1a2b07ad04beea).teal;
};
const $4bddcf4e49215fd4$var$MultiValueLabel = (props)=>{
    const { name: name, url: url } = $4bddcf4e49215fd4$var$parseWorkspace(String(props.data.workspace ?? props.data.value));
    return /*#__PURE__*/ (0, $i3UfC.jsx)((0, $525be6c0d6b9e93b$export$9b5ac10f59f76296).MultiValueLabel, {
        ...props,
        children: url !== name ? `${name} | ${url}` : name
    });
};
const $4bddcf4e49215fd4$var$multiValueStyles = {
    multiValue: (base, state)=>{
        const color = $4bddcf4e49215fd4$var$chipColor(state.data);
        return {
            ...base,
            backgroundColor: color.background,
            borderColor: color.border,
            borderStyle: 'solid',
            borderWidth: (0, $37190500189da037$export$9e1725a4cfeada27)('border.width', '1px')
        };
    },
    multiValueLabel: (base, state)=>({
            ...base,
            color: $4bddcf4e49215fd4$var$chipColor(state.data).foreground
        }),
    multiValueRemove: (base, state)=>({
            ...base,
            color: $4bddcf4e49215fd4$var$chipColor(state.data).foreground
        })
};
const $4bddcf4e49215fd4$var$formatGroupLabel = (group)=>/*#__PURE__*/ (0, $i3UfC.jsx)((0, $383dd904a5a5e5b0$export$e71c4d32a2263218), {
        xcss: $4bddcf4e49215fd4$var$groupLabelStyles,
        children: /*#__PURE__*/ (0, $i3UfC.jsx)((0, $d48daa9a522ca942$export$5f1af8db9871e1d6), {
            size: "small",
            color: "color.text.subtlest",
            weight: "bold",
            children: group.label
        })
    });
function $4bddcf4e49215fd4$var$useWorkspaceOptions(availableWorkspaces, siteMapping, availableSites) {
    const siteIdsByWorkspace = (0, $5FkrB.useMemo)(()=>$4bddcf4e49215fd4$var$getSiteIdsByWorkspace(siteMapping), [
        siteMapping
    ]);
    const siteInfoByWorkspace = (0, $5FkrB.useMemo)(()=>$4bddcf4e49215fd4$var$getSiteInfoByWorkspace(availableSites, siteMapping), [
        availableSites,
        siteMapping
    ]);
    return (0, $5FkrB.useMemo)(()=>availableWorkspaces.map((workspace)=>$4bddcf4e49215fd4$var$toOption(workspace, siteIdsByWorkspace, siteInfoByWorkspace)), [
        availableWorkspaces,
        siteIdsByWorkspace,
        siteInfoByWorkspace
    ]);
}
function $4bddcf4e49215fd4$var$useSelectedWorkspaceValues(selectedWorkspace) {
    return (0, $5FkrB.useMemo)(()=>new Set(selectedWorkspace?.split(',').map((workspace)=>workspace.trim()).filter(Boolean) ?? []), [
        selectedWorkspace
    ]);
}
function $4bddcf4e49215fd4$var$getWorkspaceFromOption(option) {
    return String(option.workspace ?? option.value);
}
function $4bddcf4e49215fd4$var$serializeWorkspaceValues(workspaces) {
    const uniqueWorkspaces = Array.from(new Set(workspaces)).filter(Boolean);
    return uniqueWorkspaces.length > 0 ? uniqueWorkspaces.join(',') : null;
}
function $4bddcf4e49215fd4$var$serializeSelectedOptions(options) {
    return options && options.length > 0 ? $4bddcf4e49215fd4$var$serializeWorkspaceValues(options.map($4bddcf4e49215fd4$var$getWorkspaceFromOption)) : null;
}
function $4bddcf4e49215fd4$var$serializeSelectionChange(options, actionMeta, selectedWorkspaceValues) {
    const option = actionMeta.option;
    if ((actionMeta.action === 'select-option' || actionMeta.action === 'deselect-option') && option?.workspace && selectedWorkspaceValues.has(option.workspace)) {
        const nextSelectedWorkspaceValues = new Set(selectedWorkspaceValues);
        nextSelectedWorkspaceValues.delete(option.workspace);
        return $4bddcf4e49215fd4$var$serializeWorkspaceValues(nextSelectedWorkspaceValues);
    }
    return $4bddcf4e49215fd4$var$serializeSelectedOptions(options);
}
const $4bddcf4e49215fd4$var$INPUT_ID = 'oauth-consent-rovo-site-select';
const $4bddcf4e49215fd4$export$89b19fc670db9847 = ({ availableWorkspaces: availableWorkspaces, siteMapping: siteMapping, availableSites: availableSites, selectedWorkspace: selectedWorkspace, setSelectedWorkspace: setSelectedWorkspace, mostUsedSites: mostUsedSites = [], shouldGroupMostUsedSites: shouldGroupMostUsedSites = false })=>{
    const { formatMessage: formatMessage } = (0, $hrVKU.default)();
    const singleSite = (0, $2gmBL.useFeatureGate)((0, $leM9a.OAuthConsentFeatureGate).ROVO_SINGLE_SITE);
    const workspaceOptions = $4bddcf4e49215fd4$var$useWorkspaceOptions(availableWorkspaces, siteMapping, availableSites);
    const selectedWorkspaceValues = $4bddcf4e49215fd4$var$useSelectedWorkspaceValues(selectedWorkspace);
    const allSorted = (0, $5FkrB.useMemo)(()=>[
            ...workspaceOptions
        ].sort((a, b)=>a.label.localeCompare(b.label)), [
        workspaceOptions
    ]);
    const groupedOptions = (0, $5FkrB.useMemo)(()=>{
        const groupedWorkspaceOptions = shouldGroupMostUsedSites && mostUsedSites.length > 0 ? $4bddcf4e49215fd4$var$groupWorkspaceOptionsByMostUsedSites({
            options: allSorted,
            mostUsedSites: mostUsedSites,
            recentLabel: formatMessage($4bddcf4e49215fd4$var$messages.recentGroupLabel),
            allSitesLabel: formatMessage($4bddcf4e49215fd4$var$messages.allSitesGroupLabel)
        }) : [
            {
                label: formatMessage($4bddcf4e49215fd4$var$messages.allSitesGroupLabel),
                options: allSorted
            }
        ];
        const ungroupedOptions = [];
        const groups = [];
        for (const optionOrGroup of groupedWorkspaceOptions)if ($4bddcf4e49215fd4$var$isWorkspaceOptionGroup(optionOrGroup)) groups.push(optionOrGroup);
        else ungroupedOptions.push(optionOrGroup);
        return ungroupedOptions.length > 0 ? [
            ...groups,
            {
                label: formatMessage($4bddcf4e49215fd4$var$messages.allSitesGroupLabel),
                options: ungroupedOptions
            }
        ] : groups;
    }, [
        allSorted,
        formatMessage,
        mostUsedSites,
        shouldGroupMostUsedSites
    ]);
    const selectedOptions = workspaceOptions.filter((option)=>selectedWorkspaceValues.has(String(option.value)));
    const SiteSelectorOption = (0, $5FkrB.useMemo)(()=>(props)=>/*#__PURE__*/ (0, $i3UfC.jsx)($4bddcf4e49215fd4$var$Option, {
                ...props,
                isWorkspaceSelected: selectedWorkspaceValues.has(props.data.workspace)
            }), [
        selectedWorkspaceValues
    ]);
    return /*#__PURE__*/ (0, $i3UfC.jsx)((0, $383dd904a5a5e5b0$export$e71c4d32a2263218), {
        xcss: $4bddcf4e49215fd4$var$wrapperStyles,
        children: /*#__PURE__*/ (0, $i3UfC.jsxs)((0, $c8dbef6c41cfa689$export$694e0d28c7ffc90c), {
            space: "space.050",
            xcss: $4bddcf4e49215fd4$var$stackStyles,
            children: [
                /*#__PURE__*/ (0, $i3UfC.jsx)((0, $f83946e67ea94c3a$export$2e2bcd8739ae039), {
                    htmlFor: $4bddcf4e49215fd4$var$INPUT_ID,
                    children: singleSite ? formatMessage($4bddcf4e49215fd4$var$messages.siteLabel) : formatMessage($4bddcf4e49215fd4$var$messages.siteLabelCount, {
                        count: selectedOptions.length
                    })
                }),
                /*#__PURE__*/ (0, $i3UfC.jsx)((0, $5330bbf7705e7e35$export$2e2bcd8739ae039), {
                    inputId: $4bddcf4e49215fd4$var$INPUT_ID,
                    options: groupedOptions,
                    isMulti: !singleSite,
                    isClearable: true,
                    isSearchable: true,
                    closeMenuOnSelect: singleSite,
                    hideSelectedOptions: false,
                    placeholder: formatMessage($4bddcf4e49215fd4$var$messages.sitePlaceholder),
                    value: singleSite ? selectedOptions[0] ?? null : selectedOptions,
                    components: {
                        Option: SiteSelectorOption,
                        SingleValue: $4bddcf4e49215fd4$var$SingleValue,
                        MultiValueLabel: $4bddcf4e49215fd4$var$MultiValueLabel
                    },
                    formatGroupLabel: $4bddcf4e49215fd4$var$formatGroupLabel,
                    styles: $4bddcf4e49215fd4$var$multiValueStyles,
                    onChange: (options, actionMeta)=>{
                        if (singleSite) {
                            setSelectedWorkspace(options?.workspace ?? null);
                            return;
                        }
                        setSelectedWorkspace($4bddcf4e49215fd4$var$serializeSelectionChange(options ?? [], actionMeta, selectedWorkspaceValues));
                    }
                })
            ]
        })
    });
};
const $4bddcf4e49215fd4$var$SiteSelector = ()=>{
    const { selectedWorkspace: selectedWorkspace, setSelectedWorkspace: setSelectedWorkspace } = (0, $6hgMx.useSelectedWorkspace)();
    const { availableWorkspaces: availableWorkspaces, siteMapping: siteMapping, availableSites: availableSites } = (0, $6hgMx.useInfo)();
    const workspaces = availableWorkspaces ?? [];
    const shouldFetchMostUsedSites = workspaces.length > 3;
    const { mostUsedSites: mostUsedSites } = (0, $900f6cd841b8b4f9$export$d97e404b91fca70d)(shouldFetchMostUsedSites);
    const props = {
        availableWorkspaces: workspaces,
        siteMapping: siteMapping,
        availableSites: availableSites,
        selectedWorkspace: selectedWorkspace ?? null,
        setSelectedWorkspace: (workspace)=>setSelectedWorkspace?.(workspace),
        mostUsedSites: mostUsedSites,
        shouldGroupMostUsedSites: shouldFetchMostUsedSites
    };
    return /*#__PURE__*/ (0, $i3UfC.jsx)($4bddcf4e49215fd4$export$89b19fc670db9847, {
        ...props
    });
};
var $4bddcf4e49215fd4$export$2e2bcd8739ae039 = $4bddcf4e49215fd4$var$SiteSelector;





const $b37a26f2d7a8957f$var$Rovo = ()=>{
    return /*#__PURE__*/ (0, $i3UfC.jsxs)((0, $1b254ba6a068f2f1$export$f51f4c4ede09e011), {
        gap: "space.400",
        direction: "column",
        wrap: "wrap",
        alignItems: "start",
        children: [
            /*#__PURE__*/ (0, $i3UfC.jsx)((0, $1b254ba6a068f2f1$export$f51f4c4ede09e011), {
                alignItems: "center",
                direction: "column",
                gap: "space.400",
                children: /*#__PURE__*/ (0, $i3UfC.jsx)((0, $d161e9943379375b$export$2e2bcd8739ae039), {})
            }),
            /*#__PURE__*/ (0, $i3UfC.jsx)((0, $f42c7abbba86ed92$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $i3UfC.jsx)((0, $4bddcf4e49215fd4$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $i3UfC.jsx)((0, $e7570a702a68ad7d$export$2e2bcd8739ae039), {})
        ]
    });
};
var $b37a26f2d7a8957f$export$2e2bcd8739ae039 = $b37a26f2d7a8957f$var$Rovo;



var $i3UfC = parcelRequire("i3UfC");


var $i3UfC = parcelRequire("i3UfC");

var $6bnW7 = parcelRequire("6bnW7");
var $bgNpv = parcelRequire("bgNpv");


var $gDiFE = parcelRequire("gDiFE");
const $cbfde4b080d46e38$var$messages = (0, $6bnW7.defineMessages)({
    agreementHeader: {
        id: 'oauth.partnercentral.bestPracticesHeader',
        defaultMessage: 'By accepting this app, you:',
        description: 'The header for oath legal terms'
    },
    agreementBulletTwo: {
        id: 'oauth.partnercentral.bestPracticesBulletTwo',
        defaultMessage: 'Agree to the {privacyPolicyLink} and {termsOfUseLink}',
        description: 'Second oath terms of agreement. The privacyPolicyLink and termsOfUseLink are replaced with actual links in the UI.'
    },
    privacyPolicy: {
        id: 'oauth.partnercentral.privacyPolicy',
        defaultMessage: 'privacy policy',
        description: 'Text for the privacy policy link'
    },
    termsOfUse: {
        id: 'oauth.partnercentral.termsOfUse',
        defaultMessage: 'terms of use',
        description: 'Text for the terms of use link'
    }
});
const $cbfde4b080d46e38$var$disclaimerStyle = (0, $gDiFE.xcss)({
    color: 'color.text.subtle',
    font: 'font.body.small'
});
const $cbfde4b080d46e38$var$LegalDisclaimer = ()=>{
    const privacyPolicyLink = /*#__PURE__*/ (0, $i3UfC.jsx)((0, $64e95b69a05329e9$export$2e2bcd8739ae039), {
        href: "https://www.atlassian.com/legal/privacy-policy#what-this-policy-covers",
        children: /*#__PURE__*/ (0, $i3UfC.jsx)((0, $bgNpv.default), {
            ...$cbfde4b080d46e38$var$messages.privacyPolicy
        })
    });
    const termsOfUseLink = /*#__PURE__*/ (0, $i3UfC.jsx)((0, $64e95b69a05329e9$export$2e2bcd8739ae039), {
        href: "https://www.atlassian.com/legal/atlassian-customer-agreement#intro",
        children: /*#__PURE__*/ (0, $i3UfC.jsx)((0, $bgNpv.default), {
            ...$cbfde4b080d46e38$var$messages.termsOfUse
        })
    });
    return /*#__PURE__*/ (0, $i3UfC.jsxs)((0, $383dd904a5a5e5b0$export$e71c4d32a2263218), {
        xcss: $cbfde4b080d46e38$var$disclaimerStyle,
        children: [
            /*#__PURE__*/ (0, $i3UfC.jsx)((0, $bgNpv.default), {
                ...$cbfde4b080d46e38$var$messages.agreementHeader,
                tagName: "p"
            }),
            /*#__PURE__*/ (0, $i3UfC.jsx)("ul", {
                children: /*#__PURE__*/ (0, $i3UfC.jsx)("li", {
                    children: /*#__PURE__*/ (0, $i3UfC.jsx)((0, $bgNpv.default), {
                        ...$cbfde4b080d46e38$var$messages.agreementBulletTwo,
                        values: {
                            privacyPolicyLink: privacyPolicyLink,
                            termsOfUseLink: termsOfUseLink
                        }
                    })
                })
            })
        ]
    });
};
var $cbfde4b080d46e38$export$2e2bcd8739ae039 = $cbfde4b080d46e38$var$LegalDisclaimer;



var $i3UfC = parcelRequire("i3UfC");

var $i3UfC = parcelRequire("i3UfC");


var $i3UfC = parcelRequire("i3UfC");




var $6hgMx = parcelRequire("6hgMx");
const $7deffd2817da0b74$var$isDefaultAvatar = (logoUrl)=>{
    if (!logoUrl) return true;
    return logoUrl.endsWith('/default-avatar.png');
};
const $7deffd2817da0b74$var$Logo = ()=>{
    const { clientLogoUrl: clientLogoUrl, clientName: clientName } = (0, $6hgMx.useToken)();
    // If custom logo provided and not a default avatar, use it
    if (clientLogoUrl && !$7deffd2817da0b74$var$isDefaultAvatar(clientLogoUrl)) return /*#__PURE__*/ (0, $i3UfC.jsx)((0, $467b7370bd97bdfa$export$2e2bcd8739ae039), {
        src: clientLogoUrl,
        size: "large",
        name: clientName ?? undefined
    });
    // Otherwise, show client name with branded background
    const initials = clientName?.split(' ').map((word)=>word[0]).join('').toUpperCase().slice(0, 2) || '?';
    return /*#__PURE__*/ (0, $i3UfC.jsx)((0, $0020f204f1f5986b$export$2e2bcd8739ae039), {
        label: clientName ?? '',
        size: "large",
        backgroundColor: "color.background.brand.bold",
        children: /*#__PURE__*/ (0, $i3UfC.jsx)((0, $d48daa9a522ca942$export$5f1af8db9871e1d6), {
            align: "center",
            color: "color.text.inverse",
            children: initials
        })
    });
};
var $7deffd2817da0b74$export$2e2bcd8739ae039 = $7deffd2817da0b74$var$Logo;


/* Arrows.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $i3UfC = parcelRequire("i3UfC");
parcelRequire("5FkrB");

var $2123ae04a5889235$exports = {};
$2123ae04a5889235$exports = new URL("arrow.91c625e6.svg", import.meta.url).toString();



const $62c656ee8509afda$var$_ = "._t9ec1sub{transform:rotate(180deg)}";
const $62c656ee8509afda$var$styles = {
    flip: "_t9ec1sub"
};
const $62c656ee8509afda$export$b6e350ab9915297a = ()=>{
    return /*#__PURE__*/ (0, $i3UfC.jsxs)((0, $c8dbef6c41cfa689$export$694e0d28c7ffc90c), {
        space: 'space.100',
        children: [
            /*#__PURE__*/ (0, $i3UfC.jsxs)((0, $dbdf44c207cf40e4$export$2e2bcd8739ae039), {
                children: [
                    /*#__PURE__*/ (0, $i3UfC.jsx)((0, $c179d2a16dc49323$export$2e2bcd8739ae039), {
                        children: [
                            $62c656ee8509afda$var$_
                        ]
                    }),
                    /*#__PURE__*/ (0, $i3UfC.jsx)("img", {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($2123ae04a5889235$exports))),
                        alt: '',
                        className: (0, $b02ab0e3a0f362dd$export$2e2bcd8739ae039)([
                            $62c656ee8509afda$var$styles.flip
                        ])
                    })
                ]
            }),
            /*#__PURE__*/ (0, $i3UfC.jsx)("img", {
                src: (0, (/*@__PURE__*/$parcel$interopDefault($2123ae04a5889235$exports))),
                alt: ''
            })
        ]
    });
};
var $62c656ee8509afda$export$2e2bcd8739ae039 = $62c656ee8509afda$export$b6e350ab9915297a;


/* AtlassianUserIcon.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $i3UfC = parcelRequire("i3UfC");
parcelRequire("5FkrB");




var $f5RPY = parcelRequire("f5RPY");

const $0ca068b327756ae2$var$_2 = "._18u0mgjw{margin-left:var(--ds-space-negative-200,-1pc)}";
const $0ca068b327756ae2$var$_ = "._1wpz1y6m{align-self:flex-start}";
const $0ca068b327756ae2$var$styles = {
    avatarStyle: "_1wpz1y6m _18u0mgjw"
};
const $0ca068b327756ae2$var$AtlassianUserIcon = ()=>{
    const user = (0, $f5RPY.useUser)();
    return /*#__PURE__*/ (0, $i3UfC.jsxs)((0, $04267de539304abd$export$fbae5b5ffd8af05e), {
        alignInline: 'center',
        children: [
            /*#__PURE__*/ (0, $i3UfC.jsx)((0, $50101e7733a6b1d7$export$8a485e2e7ed91e8f), {
                size: "xlarge",
                appearance: 'brand'
            }),
            /*#__PURE__*/ (0, $i3UfC.jsx)((0, $467b7370bd97bdfa$export$2e2bcd8739ae039), {
                size: "small",
                src: user?.picture,
                // apply styling to put the avatar in the top-right corner
                as: ({ children: children, ...props })=>/*#__PURE__*/ (0, $i3UfC.jsxs)((0, $dbdf44c207cf40e4$export$2e2bcd8739ae039), {
                        children: [
                            /*#__PURE__*/ (0, $i3UfC.jsx)((0, $c179d2a16dc49323$export$2e2bcd8739ae039), {
                                children: [
                                    $0ca068b327756ae2$var$_,
                                    $0ca068b327756ae2$var$_2
                                ]
                            }),
                            /*#__PURE__*/ (0, $i3UfC.jsx)("div", {
                                ...props,
                                className: (0, $b02ab0e3a0f362dd$export$2e2bcd8739ae039)([
                                    $0ca068b327756ae2$var$styles.avatarStyle
                                ]),
                                children: children
                            })
                        ]
                    })
            })
        ]
    });
};
var $0ca068b327756ae2$export$2e2bcd8739ae039 = $0ca068b327756ae2$var$AtlassianUserIcon;


const $8c5d8bde84f29d8b$var$AppLogos = ()=>/*#__PURE__*/ (0, $i3UfC.jsxs)((0, $04267de539304abd$export$fbae5b5ffd8af05e), {
        alignBlock: "center",
        space: 'space.250',
        children: [
            /*#__PURE__*/ (0, $i3UfC.jsx)((0, $7deffd2817da0b74$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $i3UfC.jsx)((0, $62c656ee8509afda$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $i3UfC.jsx)((0, $0ca068b327756ae2$export$2e2bcd8739ae039), {})
        ]
    });
var $8c5d8bde84f29d8b$export$2e2bcd8739ae039 = $8c5d8bde84f29d8b$var$AppLogos;



var $i3UfC = parcelRequire("i3UfC");

var $gDiFE = parcelRequire("gDiFE");

var $6bnW7 = parcelRequire("6bnW7");
var $bgNpv = parcelRequire("bgNpv");

var $6hgMx = parcelRequire("6hgMx");
const $3302b7ae31e1f92a$var$centeredContentStyles = (0, $gDiFE.xcss)({
    textAlign: 'center'
});
const $3302b7ae31e1f92a$var$messages = (0, $6bnW7.defineMessages)({
    title: {
        id: 'heading.partnercentral',
        defaultMessage: '{clientName} is requesting access to your Partner Central account',
        description: 'Heading for Partner Central Consent'
    }
});
const $3302b7ae31e1f92a$var$Header = ()=>{
    const { clientName: clientName } = (0, $6hgMx.useToken)();
    return /*#__PURE__*/ (0, $i3UfC.jsx)((0, $383dd904a5a5e5b0$export$e71c4d32a2263218), {
        xcss: $3302b7ae31e1f92a$var$centeredContentStyles,
        children: /*#__PURE__*/ (0, $i3UfC.jsx)((0, $bgNpv.default), {
            ...$3302b7ae31e1f92a$var$messages.title,
            values: {
                clientName: clientName
            },
            tagName: "h1"
        })
    });
};
var $3302b7ae31e1f92a$export$2e2bcd8739ae039 = $3302b7ae31e1f92a$var$Header;


const $b20e898614705261$var$Headline = ()=>{
    return /*#__PURE__*/ (0, $i3UfC.jsxs)((0, $i3UfC.Fragment), {
        children: [
            /*#__PURE__*/ (0, $i3UfC.jsx)((0, $8c5d8bde84f29d8b$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $i3UfC.jsx)((0, $3302b7ae31e1f92a$export$2e2bcd8739ae039), {})
        ]
    });
};
var $b20e898614705261$export$2e2bcd8739ae039 = $b20e898614705261$var$Headline;



var $i3UfC = parcelRequire("i3UfC");

var $6bnW7 = parcelRequire("6bnW7");
var $bgNpv = parcelRequire("bgNpv");


var $6hgMx = parcelRequire("6hgMx");

var $6bnW7 = parcelRequire("6bnW7");
const $8a8391562bc5154c$export$36591008fe6bae6 = new Set([
    'offline_access'
]);
const $8a8391562bc5154c$export$117b66c3ae2ec106 = (scopes)=>scopes.filter((scope)=>!$8a8391562bc5154c$export$36591008fe6bae6.has(scope));
const $8a8391562bc5154c$export$16b5018e3fb64253 = (0, $6bnW7.defineMessages)({
    'read:deal-registration:partnercentral': {
        id: 'oauth.scopes.read-deal-registration-partnercentral',
        defaultMessage: 'Read Deal Registrations',
        description: 'Scope description for read:deal-registration:partnercentral'
    },
    'read:service-registration:partnercentral': {
        id: 'oauth.scopes.read-service-registration-partnercentral',
        defaultMessage: 'Read Service Registrations',
        description: 'Scope description for read:service-registration:partnercentral'
    },
    'read:pvr:partnercentral': {
        id: 'oauth.scopes.read-pvr-partnercentral',
        defaultMessage: 'Read PVR Records',
        description: 'Scope description for read:pvr:partnercentral'
    },
    'search:registration:partnercentral': {
        id: 'oauth.scopes.search-registration-partnercentral',
        defaultMessage: 'Search Registrations',
        description: 'Scope description for search:registration:partnercentral'
    },
    'create:deal-registration:partnercentral': {
        id: 'oauth.scopes.create-deal-registration-partnercentral',
        defaultMessage: 'Create Deal Registrations',
        description: 'Scope description for create:deal-registration:partnercentral'
    },
    'create:service-registration:partnercentral': {
        id: 'oauth.scopes.create-service-registration-partnercentral',
        defaultMessage: 'Create Service Registrations',
        description: 'Scope description for create:service-registration:partnercentral'
    },
    'create:pvr:partnercentral': {
        id: 'oauth.scopes.create-pvr-partnercentral',
        defaultMessage: 'Create PVR Records',
        description: 'Scope description for create:pvr:partnercentral'
    },
    'update:deal-registration:partnercentral': {
        id: 'oauth.scopes.update-deal-registration-partnercentral',
        defaultMessage: 'Update Deal Registrations',
        description: 'Scope description for update:deal-registration:partnercentral'
    },
    'update:service-registration:partnercentral': {
        id: 'oauth.scopes.update-service-registration-partnercentral',
        defaultMessage: 'Update Service Registrations',
        description: 'Scope description for update:service-registration:partnercentral'
    },
    'update:pvr:partnercentral': {
        id: 'oauth.scopes.update-pvr-partnercentral',
        defaultMessage: 'Update PVR Records',
        description: 'Scope description for update:pvr:partnercentral'
    },
    'submit:deal-registration:partnercentral': {
        id: 'oauth.scopes.submit-deal-registration-partnercentral',
        defaultMessage: 'Submit Deal Registrations',
        description: 'Scope description for submit:deal-registration:partnercentral'
    },
    'submit:service-registration:partnercentral': {
        id: 'oauth.scopes.submit-service-registration-partnercentral',
        defaultMessage: 'Submit Service Registrations',
        description: 'Scope description for submit:service-registration:partnercentral'
    },
    'read:partner-accounts:partnercentral': {
        id: 'oauth.scopes.read-partner-accounts-partnercentral',
        defaultMessage: 'Read Partner Accounts',
        description: 'Scope description for read:partner-accounts:partnercentral'
    },
    'read:jobs:partnercentral': {
        id: 'oauth.scopes.read-jobs-partnercentral',
        defaultMessage: 'Read Jobs',
        description: 'Scope description for read:jobs:partnercentral'
    }
});


const $7e62009795c95b0a$var$headers = (0, $6bnW7.defineMessages)({
    header: {
        id: 'partnercentral.permissions.header',
        defaultMessage: '{appName} will be able to',
        description: 'Header describing Partner Central permissions'
    }
});
const $7e62009795c95b0a$var$PermissionsBullets = ()=>{
    const { scopes: scopes, clientName: clientName } = (0, $6hgMx.useToken)();
    return /*#__PURE__*/ (0, $i3UfC.jsxs)((0, $383dd904a5a5e5b0$export$e71c4d32a2263218), {
        children: [
            /*#__PURE__*/ (0, $i3UfC.jsx)((0, $bgNpv.default), {
                ...$7e62009795c95b0a$var$headers.header,
                values: {
                    appName: /*#__PURE__*/ (0, $i3UfC.jsx)("strong", {
                        children: clientName
                    })
                }
            }),
            /*#__PURE__*/ (0, $i3UfC.jsx)("ul", {
                children: (0, $8a8391562bc5154c$export$117b66c3ae2ec106)(scopes).map((scope)=>/*#__PURE__*/ (0, $i3UfC.jsx)("li", {
                        children: scope in (0, $8a8391562bc5154c$export$16b5018e3fb64253) ? /*#__PURE__*/ (0, $i3UfC.jsx)((0, $bgNpv.default), {
                            ...(0, $8a8391562bc5154c$export$16b5018e3fb64253)[scope]
                        }) : /*#__PURE__*/ (0, $i3UfC.jsx)("code", {
                            children: scope
                        })
                    }, scope))
            })
        ]
    });
};
var $7e62009795c95b0a$export$2e2bcd8739ae039 = $7e62009795c95b0a$var$PermissionsBullets;



var $5FkrB = parcelRequire("5FkrB");

var $hrVKU = parcelRequire("hrVKU");

var $6hgMx = parcelRequire("6hgMx");
function $3e983cfd61b73958$export$2e2bcd8739ae039() {
    const { clientName: clientName } = (0, $6hgMx.useToken)();
    const intl = (0, $hrVKU.default)();
    (0, $5FkrB.useEffect)(()=>{
        document.title = intl.formatMessage({
            id: 'partnercentral.documentTitle',
            defaultMessage: 'Authorize App | {appName}'
        }, {
            appName: clientName
        });
    }, [
        clientName,
        intl
    ]);
    return null;
}


const $06a22b8c30d550e2$var$PartnerCentral = ()=>{
    return /*#__PURE__*/ (0, $i3UfC.jsxs)((0, $i3UfC.Fragment), {
        children: [
            /*#__PURE__*/ (0, $i3UfC.jsx)((0, $3e983cfd61b73958$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $i3UfC.jsxs)((0, $1b254ba6a068f2f1$export$f51f4c4ede09e011), {
                gap: "space.400",
                direction: "column",
                wrap: "wrap",
                alignItems: "start",
                children: [
                    /*#__PURE__*/ (0, $i3UfC.jsx)((0, $1b254ba6a068f2f1$export$f51f4c4ede09e011), {
                        alignItems: "center",
                        direction: "column",
                        gap: "space.400",
                        children: /*#__PURE__*/ (0, $i3UfC.jsx)((0, $b20e898614705261$export$2e2bcd8739ae039), {})
                    }),
                    /*#__PURE__*/ (0, $i3UfC.jsx)((0, $7e62009795c95b0a$export$2e2bcd8739ae039), {}),
                    /*#__PURE__*/ (0, $i3UfC.jsx)((0, $cbfde4b080d46e38$export$2e2bcd8739ae039), {})
                ]
            })
        ]
    });
};
var $06a22b8c30d550e2$export$2e2bcd8739ae039 = $06a22b8c30d550e2$var$PartnerCentral;



var $i3UfC = parcelRequire("i3UfC");


var $i3UfC = parcelRequire("i3UfC");

var $gDiFE = parcelRequire("gDiFE");

var $6bnW7 = parcelRequire("6bnW7");
var $bgNpv = parcelRequire("bgNpv");

var $6hgMx = parcelRequire("6hgMx");
const $24f30b15e50c6b0d$var$centeredContentStyles = (0, $gDiFE.xcss)({
    textAlign: 'center'
});
const $24f30b15e50c6b0d$var$messages = (0, $6bnW7.defineMessages)({
    title: {
        id: 'bitbucket.heading',
        defaultMessage: '{clientName} is requesting access to your Atlassian account',
        description: 'Heading for Bitbucket Consent'
    }
});
const $24f30b15e50c6b0d$var$Headline = ()=>{
    const { clientName: clientName } = (0, $6hgMx.useToken)();
    return /*#__PURE__*/ (0, $i3UfC.jsx)((0, $383dd904a5a5e5b0$export$e71c4d32a2263218), {
        xcss: $24f30b15e50c6b0d$var$centeredContentStyles,
        children: /*#__PURE__*/ (0, $i3UfC.jsx)((0, $bgNpv.default), {
            ...$24f30b15e50c6b0d$var$messages.title,
            values: {
                clientName: clientName
            },
            tagName: "h1"
        })
    });
};
var $24f30b15e50c6b0d$export$2e2bcd8739ae039 = $24f30b15e50c6b0d$var$Headline;



var $i3UfC = parcelRequire("i3UfC");

var $5FkrB = parcelRequire("5FkrB");

var $6bnW7 = parcelRequire("6bnW7");
var $bgNpv = parcelRequire("bgNpv");
/* code.tsx generated by @compiled/babel-plugin v2.0.0 */ function $947669e5fa3e55b2$export$2e2bcd8739ae039() {
    return $947669e5fa3e55b2$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $947669e5fa3e55b2$export$2e2bcd8739ae039.apply(null, arguments);
}


function $65e8b26d31b06997$export$2e2bcd8739ae039(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}


function $8922056bc99f51b6$export$2e2bcd8739ae039(e, t) {
    if (null == e) return {};
    var o, r, i = (0, $65e8b26d31b06997$export$2e2bcd8739ae039)(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}


/**
 * The length of the value hash portion of an atomic class name.
 * Atomic class names have the format: `_<group><value>`
 * where group is ATOMIC_GROUP_HASH_LENGTH chars and value is ATOMIC_VALUE_HASH_LENGTH chars.
 *
 * We extract the group key using: `className.slice(0, className.length - ATOMIC_VALUE_HASH_LENGTH)`
 *
 * We support both old-format classes (9 chars: `_` + 4 group + 4 value) and
 * new-format classes (11 chars: `_` + 6 group + 4 value) by using length-based
 * extraction rather than a hardcoded offset — old and new format group keys
 * are different lengths so they are structurally disjoint and never alias each other.
 */ const $329f464d62b36c2c$var$ATOMIC_VALUE_HASH_LENGTH = 4;
function $329f464d62b36c2c$export$2e2bcd8739ae039(classNames) {
    // Shortcut: nothing to do
    if (!classNames.length) return;
    // Shortcut: don't need to do anything if we only have a single classname
    if (classNames.length === 1 && classNames[0] && // checking to see if `classNames[0]` is a string that contains other classnames
    !classNames[0].includes(' ')) return classNames[0];
    // Using an object rather than a `Map` as it performed better in our benchmarks.
    // Would be happy to move to `Map` if it proved to be better under real conditions.
    const map = {};
    // Note: using loops to minimize iterations over the collection
    for (const value of classNames){
        // Exclude all falsy values, which leaves us with populated strings
        if (!value) continue;
        // a `value` can contain multiple classnames
        const list = value.split(' ');
        for (const className of list){
            /**
             * For atomic style classnames: the `key` is the `group`
             *
             * - Later atomic classnames with the same `group` will override earlier ones
             *   (which is what we want).
             * - Assumes atomic classnames are the only things that start with `_`
             * - Could use a regex to ensure that atomic classnames are structured how we expect,
             *   but did not add that for now as it did slow things down a bit.
             *
             * For other classnames: the `key` is the whole classname
             * - Okay to remove duplicates as doing so does not impact specificity
             *
             * */ const key = className.startsWith('_') ? className.slice(0, className.length - $329f464d62b36c2c$var$ATOMIC_VALUE_HASH_LENGTH) : className;
            map[key] = className;
        }
    }
    /**
     * We are converting the `map` into a string.
     *
     * The simple way to do this would be `Object.values(map).join(' ')`.
     * However, the approach below performs 10%-20% better in benchmarks.
     *
     * For `ax()` it feels right to squeeze as much runtime performance out as we can.
     */ let result = '';
    for(const key in map)result += map[key] + ' ';
    // If we have an empty string, then our `map` was empty.
    if (!result) return;
    // remove last " " from the result (we added " " at the end of every value)
    return result.trimEnd();
}



var $5FkrB = parcelRequire("5FkrB");



var $5FkrB = parcelRequire("5FkrB");

/* styled.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $5FkrB = parcelRequire("5FkrB");


var $63d719c16a57aa3a$var$decoration = {
    root: "_kqswh2mm _szplfhey _dsq41wug _1xyt1b66 _123w1b66 _15nnze3t _rxygze3t _1a354jg8 _1j6rzzfg _1uakf6fq _1kt9y7el _is061xn9 _1rus1917 _1cfcvrvc _24gj1h6o _19o61h6o _cfu1116y _1rba1xn9 _1xqc19zu"
};
function $63d719c16a57aa3a$export$a592b67c93d52467(_ref) {
    var bidiCharacter = _ref.bidiCharacter, children = _ref.children, testId = _ref.testId;
    var bidiCharacterCode = $63d719c16a57aa3a$var$getBidiCharacterCode(bidiCharacter);
    return /*#__PURE__*/ $5FkrB.createElement((0, $5FkrB.Fragment), null, /*#__PURE__*/ $5FkrB.createElement("span", {
        "data-testid": testId,
        "data-bidi-character-code": bidiCharacterCode,
        "aria-hidden": "true",
        className: (0, $329f464d62b36c2c$export$2e2bcd8739ae039)([
            $63d719c16a57aa3a$var$decoration.root
        ])
    }, children), /*#__PURE__*/ $5FkrB.createElement((0, $a4a1a9cdc7bf2d54$export$2e2bcd8739ae039), {
        testId: testId && "".concat(testId, "--visually-hidden")
    }, /*#__PURE__*/ $5FkrB.createElement("mark", null, bidiCharacterCode)));
}
function $63d719c16a57aa3a$var$getBidiCharacterCode(bidiCharacter) {
    var _bidiCharacter$codePo;
    var bidiCharacterCode = (_bidiCharacter$codePo = bidiCharacter.codePointAt(0)) === null || _bidiCharacter$codePo === void 0 ? void 0 : _bidiCharacter$codePo.toString(16);
    return "U+".concat(bidiCharacterCode);
}


var $f4fc43d74b7f1cb9$var$_excluded = [
    "children"
];
function $f4fc43d74b7f1cb9$export$2e2bcd8739ae039(_ref) {
    var testId = _ref.testId, bidiCharacter = _ref.bidiCharacter, skipChildren = _ref.skipChildren, shouldSkipChildren = _ref.shouldSkipChildren, tooltipEnabled = _ref.tooltipEnabled, isTooltipEnabled = _ref.isTooltipEnabled, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Bidirectional characters change the order that text is rendered. This could be used to obscure malicious code.' : _ref$label;
    // Use new props if provided, otherwise fall back to deprecated props
    var shouldEnableTooltip = isTooltipEnabled !== undefined ? isTooltipEnabled : tooltipEnabled;
    var shouldSkip = shouldSkipChildren !== undefined ? shouldSkipChildren : skipChildren;
    if (shouldEnableTooltip) return(/*#__PURE__*/ // Following patches, this should be updated to use the render props signature which will provide aria attributes.
    // Note: this should be tested, as initial testing did not see attributes work with current tooltip implementation.
    (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $32d4a3c4842e3ceb$export$2e2bcd8739ae039), {
        content: label,
        tag: $f4fc43d74b7f1cb9$var$CustomizedTagWithRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $63d719c16a57aa3a$export$a592b67c93d52467), {
        testId: testId,
        bidiCharacter: bidiCharacter
    }, shouldSkip ? null : bidiCharacter)));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $63d719c16a57aa3a$export$a592b67c93d52467), {
        testId: testId,
        bidiCharacter: bidiCharacter
    }, shouldSkip ? null : bidiCharacter);
}
var $f4fc43d74b7f1cb9$var$CustomizedTagWithRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).forwardRef(function(props, ref) {
    var children = props.children, rest = (0, $8922056bc99f51b6$export$2e2bcd8739ae039)(props, $f4fc43d74b7f1cb9$var$_excluded);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("span", (0, $947669e5fa3e55b2$export$2e2bcd8739ae039)({}, rest, {
        ref: ref
    }), children);
});


function $711d29ff636bf582$export$2e2bcd8739ae039(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}


function $784cabdc2b746589$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return (0, $711d29ff636bf582$export$2e2bcd8739ae039)(r);
}


function $a1452f19cf654382$export$2e2bcd8739ae039(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}



function $d818afac0a0250b4$export$2e2bcd8739ae039(r, a) {
    if (r) {
        if ("string" == typeof r) return (0, $711d29ff636bf582$export$2e2bcd8739ae039)(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? (0, $711d29ff636bf582$export$2e2bcd8739ae039)(r, a) : void 0;
    }
}


function $343d0a40db54838e$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}


function $d3f8346a6391b622$export$2e2bcd8739ae039(r) {
    return (0, $784cabdc2b746589$export$2e2bcd8739ae039)(r) || (0, $a1452f19cf654382$export$2e2bcd8739ae039)(r) || (0, $d818afac0a0250b4$export$2e2bcd8739ae039)(r) || (0, $343d0a40db54838e$export$2e2bcd8739ae039)();
}


var $e9fa2f8f4bd61d74$export$ecb256e6a1f5ee7e = /[\u202A-\u202E\u2066-\u2069]/g;


function $9a31c9d07fbb1db4$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $9a31c9d07fbb1db4$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $9a31c9d07fbb1db4$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $9a31c9d07fbb1db4$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $9a31c9d07fbb1db4$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $9a31c9d07fbb1db4$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function $9a31c9d07fbb1db4$export$2e2bcd8739ae039(originalText, decorate) {
    var matches = (0, $d3f8346a6391b622$export$2e2bcd8739ae039)(originalText.matchAll((0, $e9fa2f8f4bd61d74$export$ecb256e6a1f5ee7e)));
    if (matches.length === 0) // No matches encountered, so we return the originalText value
    return originalText;
    var children = [];
    var mappedTo = 0;
    var _iterator = $9a31c9d07fbb1db4$var$_createForOfIteratorHelper(matches), _step;
    try {
        for(_iterator.s(); !(_step = _iterator.n()).done;){
            var match = _step.value;
            if (mappedTo !== match.index) // There were unmatched characters prior to this match which haven't been
            // mapped to the children.
            // Add them as plain text.
            children.push(originalText.substring(mappedTo, match.index));
            children.push(decorate({
                bidiCharacter: match[0],
                index: match.index
            }));
            // While index is guaranteed to be present, it needs to be asserted due
            // to a limitation of typescripts regex handling
            //
            // https://github.com/microsoft/TypeScript/issues/36788
            // Decorate bidi character
            mappedTo = match.index + match[0].length;
        }
    } catch (err) {
        _iterator.e(err);
    } finally{
        _iterator.f();
    }
    if (mappedTo !== originalText.length) // There is text following the final match, which needs to be mapped
    // to the children.
    // Added as plain text.
    children.push(originalText.substring(mappedTo, originalText.length));
    // return the mapped children with decorated bidi characters
    return children;
}


var $234d968de5335696$var$_excluded = [
    "testId"
], $234d968de5335696$var$_excluded2 = [
    "children",
    "codeBidiWarnings",
    "hasBidiWarnings",
    "codeBidiWarningLabel",
    "codeBidiWarningTooltipEnabled",
    "isBidiWarningTooltipEnabled"
];
var $234d968de5335696$var$styles = {
    base: "_ca0qyh40 _u5f3m5ip _n3tdyh40 _19bvm5ip _2rkofajl _11c819w5 _1reo1wug _18m91wug _1dqoglyw _1e0c1nu9 _bfhk187e _16d9qvcn _syazi7uo _vwz41kw7 _1i4q1hna _o5721jtm"
};
/**
 * __Code__
 *
 * Code highlights short strings of code snippets inline with body text.
 *
 * - [Examples](https://atlassian.design/components/code/examples)
 * - [Code](https://atlassian.design/components/code/code)
 * - [Usage](https://atlassian.design/components/code/usage)
 */ var $234d968de5335696$var$Code = /*#__PURE__*/ (0, $5FkrB.memo)(/*#__PURE__*/ (0, $5FkrB.forwardRef)(function Code(_ref, ref) {
    var testId = _ref.testId, props = (0, $8922056bc99f51b6$export$2e2bcd8739ae039)(_ref, $234d968de5335696$var$_excluded);
    var children = props.children, _props$codeBidiWarnin = props.codeBidiWarnings, codeBidiWarnings = _props$codeBidiWarnin === void 0 ? true : _props$codeBidiWarnin, hasBidiWarnings = props.hasBidiWarnings, codeBidiWarningLabel = props.codeBidiWarningLabel, _props$codeBidiWarnin2 = props.codeBidiWarningTooltipEnabled, codeBidiWarningTooltipEnabled = _props$codeBidiWarnin2 === void 0 ? true : _props$codeBidiWarnin2, isBidiWarningTooltipEnabled = props.isBidiWarningTooltipEnabled, otherProps = (0, $8922056bc99f51b6$export$2e2bcd8739ae039)(props, $234d968de5335696$var$_excluded2);
    // Use new props if provided, otherwise fall back to deprecated props
    var shouldShowBidiWarnings = hasBidiWarnings !== undefined ? hasBidiWarnings : codeBidiWarnings;
    var shouldEnableTooltip = isBidiWarningTooltipEnabled !== undefined ? isBidiWarningTooltipEnabled : codeBidiWarningTooltipEnabled;
    var decoratedChildren = shouldShowBidiWarnings ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement($234d968de5335696$var$RenderCodeChildrenWithBidiWarnings, {
        codeBidiWarningLabel: codeBidiWarningLabel,
        codeBidiWarningTooltipEnabled: shouldEnableTooltip
    }, children) : children;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("code", (0, $947669e5fa3e55b2$export$2e2bcd8739ae039)({
        ref: ref,
        "data-testid": testId
    }, otherProps, {
        className: (0, $329f464d62b36c2c$export$2e2bcd8739ae039)([
            $234d968de5335696$var$styles.base
        ])
    }), decoratedChildren);
}));
function $234d968de5335696$var$RenderCodeChildrenWithBidiWarnings(_ref2) {
    var children = _ref2.children, codeBidiWarningLabel = _ref2.codeBidiWarningLabel, codeBidiWarningTooltipEnabled = _ref2.codeBidiWarningTooltipEnabled;
    var replacedChildren = (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).Children.map(children, function(childNode) {
        if (typeof childNode === 'string') {
            var decorated = (0, $9a31c9d07fbb1db4$export$2e2bcd8739ae039)(childNode, function(_ref3) {
                var bidiCharacter = _ref3.bidiCharacter, index = _ref3.index;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $f4fc43d74b7f1cb9$export$2e2bcd8739ae039), {
                    bidiCharacter: bidiCharacter,
                    key: index,
                    label: codeBidiWarningLabel,
                    tooltipEnabled: codeBidiWarningTooltipEnabled
                });
            });
            return decorated;
        }
        if ($234d968de5335696$var$isReactElement(childNode) && childNode.props.children) {
            // eslint-disable-next-line @repo/internal/react/no-clone-element
            var newChildNode = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).cloneElement(childNode, {
                children: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement($234d968de5335696$var$RenderCodeChildrenWithBidiWarnings, {
                    codeBidiWarningLabel: codeBidiWarningLabel,
                    codeBidiWarningTooltipEnabled: codeBidiWarningTooltipEnabled
                }, childNode.props.children)
            });
            return newChildNode;
        }
        return childNode;
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).Fragment, null, replacedChildren);
}
function $234d968de5335696$var$isReactElement(child) {
    return !!child.type;
}
$234d968de5335696$var$Code.displayName = 'Code';
var $234d968de5335696$export$2e2bcd8739ae039 = $234d968de5335696$var$Code;





var $gDiFE = parcelRequire("gDiFE");

var $6hgMx = parcelRequire("6hgMx");
const $a8ae348acf49282d$var$headers = (0, $6bnW7.defineMessages)({
    header: {
        id: 'oauth.bitbucket.permissions.header',
        defaultMessage: '{appName} is requesting access to the following:',
        description: 'Header describing permissions'
    }
});
const $a8ae348acf49282d$var$permissionsListContainerStyle = (0, $gDiFE.xcss)({
    marginBlockStart: 'space.150'
});
const $a8ae348acf49282d$var$groupPermissionsListStyle = (0, $gDiFE.xcss)({
    marginBlockStart: 'space.050'
});
const $a8ae348acf49282d$var$otherPermissionsListStyle = (0, $gDiFE.xcss)({
    paddingInlineStart: 'space.200'
});
const $a8ae348acf49282d$var$PermissionsBullets = ()=>{
    const { scopes: scopes, clientName: clientName } = (0, $6hgMx.useToken)();
    const { client: client } = (0, $6hgMx.useInfo)();
    const { appContactLink: appContactLink, scopes: scopeInfo } = client ?? {};
    const permissionsList = (0, $5FkrB.useMemo)(()=>{
        if (!scopeInfo || scopeInfo.length === 0) return /*#__PURE__*/ (0, $i3UfC.jsx)((0, $383dd904a5a5e5b0$export$e71c4d32a2263218), {
            as: "ul",
            xcss: $a8ae348acf49282d$var$otherPermissionsListStyle,
            children: scopes.map((scope)=>/*#__PURE__*/ (0, $i3UfC.jsx)((0, $383dd904a5a5e5b0$export$e71c4d32a2263218), {
                    as: 'li',
                    children: /*#__PURE__*/ (0, $i3UfC.jsx)((0, $234d968de5335696$export$2e2bcd8739ae039), {
                        children: scope
                    })
                }, scope))
        });
        // Group scopes by their group name, which can be undefined
        const scopeInfoByGroup = scopeInfo.reduce((acc, val)=>{
            const groupScopeInfos = acc.get(val.groupName);
            if (!groupScopeInfos) acc.set(val.groupName, [
                val
            ]);
            else groupScopeInfos.push(val);
            return acc;
        }, new Map());
        return scopeInfoByGroup.entries().map(([groupName, groupScopeInfos])=>{
            return groupName ? /*#__PURE__*/ (0, $i3UfC.jsxs)((0, $c8dbef6c41cfa689$export$694e0d28c7ffc90c), {
                children: [
                    /*#__PURE__*/ (0, $i3UfC.jsx)((0, $82315a19372f332f$export$2e2bcd8739ae039), {
                        size: "xsmall",
                        children: groupName
                    }),
                    /*#__PURE__*/ (0, $i3UfC.jsx)((0, $383dd904a5a5e5b0$export$e71c4d32a2263218), {
                        as: "ul",
                        xcss: $a8ae348acf49282d$var$groupPermissionsListStyle,
                        children: groupScopeInfos.map((scope)=>/*#__PURE__*/ (0, $i3UfC.jsx)((0, $383dd904a5a5e5b0$export$e71c4d32a2263218), {
                                as: 'li',
                                children: /*#__PURE__*/ (0, $i3UfC.jsx)((0, $d48daa9a522ca942$export$5f1af8db9871e1d6), {
                                    children: scope.scopeDescription
                                })
                            }, scope.name))
                    })
                ]
            }, groupName) : // Scopes without a group name get grouped together
            /*#__PURE__*/ (0, $i3UfC.jsx)((0, $383dd904a5a5e5b0$export$e71c4d32a2263218), {
                as: "ul",
                xcss: $a8ae348acf49282d$var$otherPermissionsListStyle,
                children: groupScopeInfos.map((scope)=>/*#__PURE__*/ (0, $i3UfC.jsx)((0, $383dd904a5a5e5b0$export$e71c4d32a2263218), {
                        as: 'li',
                        children: /*#__PURE__*/ (0, $i3UfC.jsx)((0, $d48daa9a522ca942$export$5f1af8db9871e1d6), {
                            children: scope.scopeDescription
                        })
                    }, scope.name))
            }, "ungrouped");
        }).toArray();
    }, [
        scopes,
        scopeInfo
    ]);
    return /*#__PURE__*/ (0, $i3UfC.jsxs)((0, $383dd904a5a5e5b0$export$e71c4d32a2263218), {
        children: [
            /*#__PURE__*/ (0, $i3UfC.jsx)((0, $bgNpv.default), {
                ...$a8ae348acf49282d$var$headers.header,
                values: {
                    appName: appContactLink ? /*#__PURE__*/ (0, $i3UfC.jsx)((0, $64e95b69a05329e9$export$2e2bcd8739ae039), {
                        href: appContactLink,
                        target: "_blank",
                        children: clientName
                    }) : /*#__PURE__*/ (0, $i3UfC.jsxs)("strong", {
                        children: [
                            " ",
                            clientName,
                            " "
                        ]
                    })
                }
            }),
            /*#__PURE__*/ (0, $i3UfC.jsx)((0, $c8dbef6c41cfa689$export$694e0d28c7ffc90c), {
                space: "space.050",
                xcss: $a8ae348acf49282d$var$permissionsListContainerStyle,
                children: permissionsList
            })
        ]
    });
};
var $a8ae348acf49282d$export$2e2bcd8739ae039 = $a8ae348acf49282d$var$PermissionsBullets;



var $i3UfC = parcelRequire("i3UfC");

var $6bnW7 = parcelRequire("6bnW7");
var $bgNpv = parcelRequire("bgNpv");



var $6hgMx = parcelRequire("6hgMx");
const $ce1a7b5d802044b9$var$messages = (0, $6bnW7.defineMessages)({
    privacyAndEulaProvided: {
        id: 'oauth.bitbucket.privacyAndEulaProvided',
        defaultMessage: 'By installing the app, you agree to the {privacyPolicyLink} and {termsOfUseLink} provided by {clientName}.',
        description: 'Legal agreement text shown when both privacy policy and terms of use links are provided by the vendor'
    },
    onlyPrivacy: {
        id: 'oauth.bitbucket.onlyPrivacy',
        defaultMessage: 'By installing the app, you agree to the {privacyPolicyLink} provided by {clientName}.',
        description: 'Legal agreement text shown when only the privacy policy link is provided by the vendor'
    },
    onlyEula: {
        id: 'oauth.bitbucket.onlyEula',
        defaultMessage: "This 3rd party vendor has not provided a privacy policy. Atlassian's privacy policy is not applicable to the use of this app. {termsOfUseLink} to see the terms of use provided by {clientName}.",
        description: 'Disclaimer text shown when only the Terms of Use (EULA) link is provided by the vendor'
    },
    noneProvided: {
        id: 'oauth.bitbucket.noneProvided',
        defaultMessage: "This 3rd party vendor has not provided a privacy policy or terms of use. Atlassian's Privacy Policy is not applicable to the use of this app.",
        description: 'Fallback legal disclaimer shown when neither privacy policy nor terms of use links are provided'
    },
    privacyLinkText: {
        id: 'oauth.bitbucket.privacyLinkText',
        defaultMessage: 'privacy policy',
        description: 'The clickable text for the vendor privacy policy link'
    },
    eulaLinkText: {
        id: 'oauth.bitbucket.eulaLinkText',
        defaultMessage: 'terms of use',
        description: 'The clickable text for the vendor terms of use link'
    },
    eulaClickHere: {
        id: 'oauth.bitbucket.eulaClickHere',
        defaultMessage: 'Click here',
        description: 'Alternative link text used to direct users to the vendor terms of use'
    }
});
const $ce1a7b5d802044b9$var$LegalDisclaimer = ()=>{
    const { clientName: clientName } = (0, $6hgMx.useToken)();
    const { client: client } = (0, $6hgMx.useInfo)();
    const { appEulaLink: appEulaLink, appPrivacyPolicyLink: appPrivacyPolicyLink, callbacks: callbacks } = client ?? {};
    const privacyPolicyLink = appPrivacyPolicyLink && /*#__PURE__*/ (0, $i3UfC.jsx)((0, $64e95b69a05329e9$export$2e2bcd8739ae039), {
        href: appPrivacyPolicyLink,
        children: /*#__PURE__*/ (0, $i3UfC.jsx)((0, $bgNpv.default), {
            ...$ce1a7b5d802044b9$var$messages.privacyLinkText
        })
    });
    const renderLegalDisclaimer = ()=>{
        const getLegalMessage = ()=>{
            if (appPrivacyPolicyLink && appEulaLink) return /*#__PURE__*/ (0, $i3UfC.jsx)((0, $bgNpv.default), {
                ...$ce1a7b5d802044b9$var$messages.privacyAndEulaProvided,
                values: {
                    clientName: clientName,
                    privacyPolicyLink: privacyPolicyLink,
                    termsOfUseLink: /*#__PURE__*/ (0, $i3UfC.jsx)((0, $64e95b69a05329e9$export$2e2bcd8739ae039), {
                        href: appEulaLink,
                        children: /*#__PURE__*/ (0, $i3UfC.jsx)((0, $bgNpv.default), {
                            ...$ce1a7b5d802044b9$var$messages.eulaLinkText
                        })
                    })
                }
            });
            if (appPrivacyPolicyLink) return /*#__PURE__*/ (0, $i3UfC.jsx)((0, $bgNpv.default), {
                ...$ce1a7b5d802044b9$var$messages.onlyPrivacy,
                values: {
                    clientName: clientName,
                    privacyPolicyLink: privacyPolicyLink
                }
            });
            if (appEulaLink) return /*#__PURE__*/ (0, $i3UfC.jsx)((0, $bgNpv.default), {
                ...$ce1a7b5d802044b9$var$messages.onlyEula,
                values: {
                    clientName: clientName,
                    termsOfUseLink: /*#__PURE__*/ (0, $i3UfC.jsx)((0, $64e95b69a05329e9$export$2e2bcd8739ae039), {
                        href: appEulaLink,
                        children: /*#__PURE__*/ (0, $i3UfC.jsx)((0, $bgNpv.default), {
                            ...$ce1a7b5d802044b9$var$messages.eulaClickHere
                        })
                    })
                }
            });
            return /*#__PURE__*/ (0, $i3UfC.jsx)((0, $bgNpv.default), {
                ...$ce1a7b5d802044b9$var$messages.noneProvided
            });
        };
        const getCallbackURL = ()=>{
            if (!callbacks || callbacks.length === 0) return null;
            return /*#__PURE__*/ (0, $i3UfC.jsxs)((0, $d48daa9a522ca942$export$5f1af8db9871e1d6), {
                children: [
                    "You will be redirected to: ",
                    callbacks[0]
                ]
            });
        };
        return /*#__PURE__*/ (0, $i3UfC.jsxs)((0, $c8dbef6c41cfa689$export$694e0d28c7ffc90c), {
            children: [
                /*#__PURE__*/ (0, $i3UfC.jsx)((0, $d48daa9a522ca942$export$5f1af8db9871e1d6), {
                    color: "color.text.subtle",
                    children: getLegalMessage()
                }),
                /*#__PURE__*/ (0, $i3UfC.jsx)((0, $d48daa9a522ca942$export$5f1af8db9871e1d6), {
                    color: "color.text.subtle",
                    children: getCallbackURL()
                })
            ]
        });
    };
    return /*#__PURE__*/ (0, $i3UfC.jsx)((0, $383dd904a5a5e5b0$export$e71c4d32a2263218), {
        children: renderLegalDisclaimer()
    });
};
var $ce1a7b5d802044b9$export$2e2bcd8739ae039 = $ce1a7b5d802044b9$var$LegalDisclaimer;



var $i3UfC = parcelRequire("i3UfC");

var $6bnW7 = parcelRequire("6bnW7");
var $bgNpv = parcelRequire("bgNpv");


var $6hgMx = parcelRequire("6hgMx");
const $f956d34c6a6f15c4$var$messages = (0, $6bnW7.defineMessages)({
    aboutHeader: {
        id: 'oauth.bitbucket.description.about',
        defaultMessage: 'About {clientName}',
        description: 'Header for the OAuth Consumer description section'
    }
});
const $f956d34c6a6f15c4$var$Description = ()=>{
    const { clientName: clientName } = (0, $6hgMx.useToken)();
    const { client: client } = (0, $6hgMx.useInfo)();
    const { appDescription: appDescription } = client ?? {};
    if (!appDescription) return null;
    return /*#__PURE__*/ (0, $i3UfC.jsxs)((0, $c8dbef6c41cfa689$export$694e0d28c7ffc90c), {
        space: 'space.200',
        children: [
            /*#__PURE__*/ (0, $i3UfC.jsx)((0, $d48daa9a522ca942$export$5f1af8db9871e1d6), {
                weight: "bold",
                children: /*#__PURE__*/ (0, $i3UfC.jsx)((0, $bgNpv.default), {
                    ...$f956d34c6a6f15c4$var$messages.aboutHeader,
                    values: {
                        clientName: clientName
                    }
                })
            }),
            /*#__PURE__*/ (0, $i3UfC.jsx)((0, $d48daa9a522ca942$export$5f1af8db9871e1d6), {
                color: "color.text.subtle",
                children: appDescription
            })
        ]
    });
};
var $f956d34c6a6f15c4$export$2e2bcd8739ae039 = $f956d34c6a6f15c4$var$Description;


const $a661d5caafe3c23a$var$Bitbucket = ()=>{
    return /*#__PURE__*/ (0, $i3UfC.jsxs)((0, $1b254ba6a068f2f1$export$f51f4c4ede09e011), {
        gap: "space.400",
        direction: "column",
        wrap: "wrap",
        alignItems: "start",
        children: [
            /*#__PURE__*/ (0, $i3UfC.jsx)((0, $24f30b15e50c6b0d$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $i3UfC.jsx)((0, $f956d34c6a6f15c4$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $i3UfC.jsx)((0, $a8ae348acf49282d$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $i3UfC.jsx)((0, $ce1a7b5d802044b9$export$2e2bcd8739ae039), {})
        ]
    });
};
var $a661d5caafe3c23a$export$2e2bcd8739ae039 = $a661d5caafe3c23a$var$Bitbucket;



var $i3UfC = parcelRequire("i3UfC");

var $6bnW7 = parcelRequire("6bnW7");
var $hrVKU = parcelRequire("hrVKU");



var $i3UfC = parcelRequire("i3UfC");

var $5FkrB = parcelRequire("5FkrB");

var $6bnW7 = parcelRequire("6bnW7");
var $bgNpv = parcelRequire("bgNpv");
var $hrVKU = parcelRequire("hrVKU");




var $5FkrB = parcelRequire("5FkrB");




var $e0763a2a29633b85$var$_excluded = [
    "appearance",
    "children",
    "iconBefore",
    "iconAfter",
    "isSelected",
    "onMouseDown",
    "onMouseUp",
    "shouldFitContainer",
    "spacing"
];
var $e0763a2a29633b85$var$isFirefox = typeof navigator !== 'undefined' && navigator.userAgent.toLowerCase().indexOf('firefox') > -1;
/**
 * __Button__
 *
 * @deprecated Legacy buttons are deprecated and will be removed from `atlaskit/button` in an upcoming major release. Please use `Button` from `@atlaskit/button/default/button`.
 *
 * Please refer to the [migration guide](https://atlassian.design/components/button/button-legacy/migration-guide) for further details.
 *
 * A button triggers an event or action. They let users know what will happen next.
 *
 * - [Examples](https://atlassian.design/components/button/button-legacy/examples)
 * - [Code](https://atlassian.design/components/button/button-legacy/code)
 * - [Usage](https://atlassian.design/components/button/button-legacy/usage)
 */ var $e0763a2a29633b85$var$Button = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).forwardRef(function Button(_ref, ref) {
    var _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'default' : _ref$appearance, children = _ref.children, iconBefore = _ref.iconBefore, iconAfter = _ref.iconAfter, _ref$isSelected = _ref.isSelected, isSelected = _ref$isSelected === void 0 ? false : _ref$isSelected, _ref$onMouseDown = _ref.onMouseDown, providedOnMouseDown = _ref$onMouseDown === void 0 ? (0, $adcefb868cf2fc9d$export$2e2bcd8739ae039) : _ref$onMouseDown, _ref$onMouseUp = _ref.onMouseUp, providedOnMouseUp = _ref$onMouseUp === void 0 ? (0, $adcefb868cf2fc9d$export$2e2bcd8739ae039) : _ref$onMouseUp, _ref$shouldFitContain = _ref.shouldFitContainer, shouldFitContainer = _ref$shouldFitContain === void 0 ? false : _ref$shouldFitContain, _ref$spacing = _ref.spacing, spacing = _ref$spacing === void 0 ? 'default' : _ref$spacing, rest = (0, $230c1601acfa3177$export$2e2bcd8739ae039)(_ref, $e0763a2a29633b85$var$_excluded);
    var isOnlySingleIcon = (0, $4fdd9d09d2bfaab9$export$2e2bcd8739ae039)({
        children: children,
        iconBefore: iconBefore,
        iconAfter: iconAfter
    });
    var _useState = (0, $5FkrB.useState)(false), _useState2 = (0, $a004a50eecd8ae97$export$2e2bcd8739ae039)(_useState, 2), isActive = _useState2[0], setIsActive = _useState2[1];
    // Wrap onMouseDown / onMouseUp to manually trigger active state
    // in Firefox
    var onMouseDown = (0, $5FkrB.useCallback)(function(event) {
        providedOnMouseDown(event);
        if ($e0763a2a29633b85$var$isFirefox) setIsActive(true);
    }, [
        providedOnMouseDown,
        setIsActive
    ]);
    var onMouseUp = (0, $5FkrB.useCallback)(function(event) {
        providedOnMouseUp(event);
        if ($e0763a2a29633b85$var$isFirefox) setIsActive(false);
    }, [
        providedOnMouseUp,
        setIsActive
    ]);
    var buttonCss = (0, $5FkrB.useMemo)(function() {
        return (0, $525d107f97649f51$export$955358618f994a11)({
            appearance: appearance,
            spacing: spacing,
            isSelected: isSelected,
            shouldFitContainer: shouldFitContainer,
            isOnlySingleIcon: isOnlySingleIcon
        });
    }, [
        appearance,
        spacing,
        isSelected,
        shouldFitContainer,
        isOnlySingleIcon
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $5f7b778c870b53cc$export$2e2bcd8739ae039), (0, $bdabb985862bf53b$export$2e2bcd8739ae039)({}, rest, {
        ref: ref,
        appearance: appearance,
        buttonCss: buttonCss,
        children: children,
        "data-firefox-is-active": isActive ? true : undefined,
        iconAfter: iconAfter,
        iconBefore: iconBefore,
        isSelected: isSelected,
        onMouseDown: onMouseDown,
        onMouseUp: onMouseUp,
        spacing: spacing
    }));
}));
// Tools including enzyme rely on components having a display name
$e0763a2a29633b85$var$Button.displayName = 'Button';
var $e0763a2a29633b85$export$2e2bcd8739ae039 = $e0763a2a29633b85$var$Button;


/* checkbox.tsx generated by @compiled/babel-plugin v2.0.0 */ function $50b86828abf7136b$export$2e2bcd8739ae039() {
    return $50b86828abf7136b$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $50b86828abf7136b$export$2e2bcd8739ae039.apply(null, arguments);
}


function $92260be303a32ef6$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return r;
}


function $1870f23e88bea5c9$export$2e2bcd8739ae039(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}


function $1f5c68a3a7897f12$export$2e2bcd8739ae039(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}


function $afcf11931e997585$export$2e2bcd8739ae039(r, a) {
    if (r) {
        if ("string" == typeof r) return (0, $1f5c68a3a7897f12$export$2e2bcd8739ae039)(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? (0, $1f5c68a3a7897f12$export$2e2bcd8739ae039)(r, a) : void 0;
    }
}


function $ad31de61c6bb8623$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}


function $e572ede80cc9f568$export$2e2bcd8739ae039(r, e) {
    return (0, $92260be303a32ef6$export$2e2bcd8739ae039)(r) || (0, $1870f23e88bea5c9$export$2e2bcd8739ae039)(r, e) || (0, $afcf11931e997585$export$2e2bcd8739ae039)(r, e) || (0, $ad31de61c6bb8623$export$2e2bcd8739ae039)();
}


function $be18581643f62565$export$2e2bcd8739ae039(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}


function $f708e9c488100c1d$export$2e2bcd8739ae039(e, t) {
    if (null == e) return {};
    var o, r, i = (0, $be18581643f62565$export$2e2bcd8739ae039)(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}



var $5FkrB = parcelRequire("5FkrB");
/**
 * The length of the value hash portion of an atomic class name.
 * Atomic class names have the format: `_<group><value>`
 * where group is ATOMIC_GROUP_HASH_LENGTH chars and value is ATOMIC_VALUE_HASH_LENGTH chars.
 *
 * We extract the group key using: `className.slice(0, className.length - ATOMIC_VALUE_HASH_LENGTH)`
 *
 * We support both old-format classes (9 chars: `_` + 4 group + 4 value) and
 * new-format classes (11 chars: `_` + 6 group + 4 value) by using length-based
 * extraction rather than a hardcoded offset — old and new format group keys
 * are different lengths so they are structurally disjoint and never alias each other.
 */ const $01af0ba52399892d$var$ATOMIC_VALUE_HASH_LENGTH = 4;
function $01af0ba52399892d$export$2e2bcd8739ae039(classNames) {
    // Shortcut: nothing to do
    if (!classNames.length) return;
    // Shortcut: don't need to do anything if we only have a single classname
    if (classNames.length === 1 && classNames[0] && // checking to see if `classNames[0]` is a string that contains other classnames
    !classNames[0].includes(' ')) return classNames[0];
    // Using an object rather than a `Map` as it performed better in our benchmarks.
    // Would be happy to move to `Map` if it proved to be better under real conditions.
    const map = {};
    // Note: using loops to minimize iterations over the collection
    for (const value of classNames){
        // Exclude all falsy values, which leaves us with populated strings
        if (!value) continue;
        // a `value` can contain multiple classnames
        const list = value.split(' ');
        for (const className of list){
            /**
             * For atomic style classnames: the `key` is the `group`
             *
             * - Later atomic classnames with the same `group` will override earlier ones
             *   (which is what we want).
             * - Assumes atomic classnames are the only things that start with `_`
             * - Could use a regex to ensure that atomic classnames are structured how we expect,
             *   but did not add that for now as it did slow things down a bit.
             *
             * For other classnames: the `key` is the whole classname
             * - Okay to remove duplicates as doing so does not impact specificity
             *
             * */ const key = className.startsWith('_') ? className.slice(0, className.length - $01af0ba52399892d$var$ATOMIC_VALUE_HASH_LENGTH) : className;
            map[key] = className;
        }
    }
    /**
     * We are converting the `map` into a string.
     *
     * The simple way to do this would be `Object.values(map).join(' ')`.
     * However, the approach below performs 10%-20% better in benchmarks.
     *
     * For `ax()` it feels right to squeeze as much runtime performance out as we can.
     */ let result = '';
    for(const key in map)result += map[key] + ' ';
    // If we have an empty string, then our `map` was empty.
    if (!result) return;
    // remove last " " from the result (we added " " at the end of every value)
    return result.trimEnd();
}




/* checkbox-icon.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $5FkrB = parcelRequire("5FkrB");

/**
 * Styles for the checkbox icon.
 * CSS custom properties for colors are set by the parent Label element
 * and consumed directly in these styles.
 */ var $2ccca7160d04a198$var$svgStyles = {
    root: "_nd5lfibj _1reo15vq _18m915vq _v5641mn3 _2rko12b0 _1a3742bt _lcxvglyw _syazmov0 _lswu1kgh _1cwg1i6y",
    rect: "_v56411so _1snbe4h9 _1s17hteq"
};
function $2ccca7160d04a198$var$getIcon(isIndeterminate, isChecked) {
    if (isIndeterminate) return /*#__PURE__*/ $5FkrB.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M7.75 12.75H16.25V11.25H7.75V12.75Z",
        fill: "inherit"
    });
    if (isChecked) return /*#__PURE__*/ $5FkrB.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M16.3262 9.48011L15.1738 8.51984L10.75 13.8284L8.82616 11.5198L7.67383 12.4801L10.1738 15.4801C10.3163 15.6511 10.5274 15.75 10.75 15.75C10.9726 15.75 11.1837 15.6511 11.3262 15.4801L16.3262 9.48011Z",
        fill: "inherit"
    });
    // No icon
    return null;
}
/**
 * __Checkbox icon__
 *
 * A checkbox icon is the visual representation of checkbox state,
 * which is shown instead of the native input.
 *
 * @internal
 */ var $2ccca7160d04a198$var$CheckboxIcon = /*#__PURE__*/ (0, $5FkrB.memo)(function(_ref) {
    var isIndeterminate = _ref.isIndeterminate, isChecked = _ref.isChecked;
    var icon = (0, $5FkrB.useMemo)(function() {
        return $2ccca7160d04a198$var$getIcon(isIndeterminate, isChecked);
    }, [
        isIndeterminate,
        isChecked
    ]);
    return /*#__PURE__*/ $5FkrB.createElement("svg", {
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        role: "presentation",
        className: (0, $01af0ba52399892d$export$2e2bcd8739ae039)([
            $2ccca7160d04a198$var$svgStyles.root
        ])
    }, /*#__PURE__*/ $5FkrB.createElement("g", {
        fillRule: "evenodd"
    }, /*#__PURE__*/ $5FkrB.createElement("rect", {
        fill: "currentColor",
        x: "5.5",
        y: "5.5",
        width: "13",
        height: "13",
        rx: "1.5",
        className: (0, $01af0ba52399892d$export$2e2bcd8739ae039)([
            $2ccca7160d04a198$var$svgStyles.rect
        ])
    }), icon));
});
var $2ccca7160d04a198$export$2e2bcd8739ae039 = $2ccca7160d04a198$var$CheckboxIcon;


/* label.tsx generated by @compiled/babel-plugin v2.0.0 */ /**
 * Base state styles with CSS custom properties.
 * Pseudo-selectors (:hover, :focus-within, :active) on the label element
 * update CSS variables that cascade to the CheckboxIcon.
 * This avoids nested sibling selectors.
 *
 * Uses `css` over `cssMap` to work around a bug in Compiled types when
 * using CSS variables in pseudo-selectors.
 */ 
var $5FkrB = parcelRequire("5FkrB");

var $8cd070e8cfc9c0f7$var$baseStyles = null;
var $8cd070e8cfc9c0f7$var$textLabelLayoutStyles = null;
// Checked/Indeterminate state
var $8cd070e8cfc9c0f7$var$checkedStyles = null;
// Invalid state - must override hover/active to maintain red border
var $8cd070e8cfc9c0f7$var$invalidStyles = null;
// Disabled state - must override hover/active to maintain disabled appearance
var $8cd070e8cfc9c0f7$var$disabledStyles = null;
// Disabled + Checked/Indeterminate
var $8cd070e8cfc9c0f7$var$disabledCheckedStyles = null;
function $8cd070e8cfc9c0f7$export$2e2bcd8739ae039(_ref) {
    var children = _ref.children, isDisabled = _ref.isDisabled, isChecked = _ref.isChecked, isIndeterminate = _ref.isIndeterminate, isInvalid = _ref.isInvalid, testId = _ref.testId, label = _ref.label, id = _ref.id, xcss = _ref.xcss;
    return /*#__PURE__*/ $5FkrB.createElement("label", {
        className: (0, $01af0ba52399892d$export$2e2bcd8739ae039)([
            "_11c8fhey _1e0c11p5 _1ejihkll _umai184x _1qwn1j9a _f0grrsbi _1c53glyw _1e9d1j28 _syazi7uo _80om73ad _ljcgdfik _1vj5l4ek _dh4gr01l _cz1u1l7x _jom5wc43 _1s071onz _106f1onz",
            label && "_zulp1nu5 _yv0ey09t",
            (isChecked || isIndeterminate) && "_1qwnjmqp _f0grjmqp _1e9d5w2r _1vj51q28 _q29q1q28 _dh4gr01l _cz1u1l7x _zoo95w2r _jom5wc43 _1s071onz _106f1onz",
            isInvalid && "_f0gr1bqt _q29q1bqt _cz1u1bqt _1s07gir2",
            isDisabled && "_1qwn187o _f0gr187o _syaz1gmx _80om13gf _1vj5187o _q29q187o _dh4g187o _cz1u187o _jom5wc43 _1s0718qt _106f18qt",
            isDisabled && (isChecked || isIndeterminate) && "_1e9d2sac _9js12sac _zoo92sac",
            xcss
        ]),
        "data-testid": testId,
        "data-disabled": isDisabled || undefined,
        id: id
    }, children);
}


/* label-text.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $5FkrB = parcelRequire("5FkrB");

var $986a72fc4ddd96ec$var$labelTextStyles = null;
function $986a72fc4ddd96ec$export$2e2bcd8739ae039(_ref) {
    var children = _ref.children;
    return /*#__PURE__*/ $5FkrB.createElement("span", {
        className: (0, $01af0ba52399892d$export$2e2bcd8739ae039)([
            "_nd5l11ig _1wpz1h6o"
        ])
    }, children);
}


/* required-indicator.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $5FkrB = parcelRequire("5FkrB");

var $a009f31e2434411f$var$requiredIndicatorStyles = null;
function $a009f31e2434411f$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ $5FkrB.createElement("span", {
        "aria-hidden": true,
        className: (0, $01af0ba52399892d$export$2e2bcd8739ae039)([
            "_syaz1tmw _bozgv77o"
        ])
    }, "*");
}


var $fa7b9da54b6e47b4$var$_excluded = [
    "isChecked",
    "isDisabled",
    "isInvalid",
    "defaultChecked",
    "isIndeterminate",
    "onChange",
    "analyticsContext",
    "label",
    "name",
    "value",
    "isRequired",
    "testId",
    "xcss",
    "className"
];
/**
 * The input is visually hidden but remains in the DOM for accessibility.
 * State-based styling is handled by the Label component using CSS custom properties
 * that cascade to the CheckboxIcon, avoiding nested sibling selectors.
 */ var $fa7b9da54b6e47b4$var$checkboxStyles = {
    root: "_19itglyw _nd5lfibj _12ji1r31 _1qu2glyw _12y31o36 _1bsb1osq _4t3i1osq _r06hglyw _6rthze3t _1pfhze3t _12l2ze3t _ahbqze3t _tzy4idpf"
};
var $fa7b9da54b6e47b4$export$48513f6b9f8ce62d = /*#__PURE__*/ (0, $5FkrB.memo)(/*#__PURE__*/ (0, $5FkrB.forwardRef)(function Checkbox(_ref, ref) {
    var isCheckedProp = _ref.isChecked, _ref$isDisabled = _ref.isDisabled, isDisabled = _ref$isDisabled === void 0 ? false : _ref$isDisabled, _ref$isInvalid = _ref.isInvalid, isInvalid = _ref$isInvalid === void 0 ? false : _ref$isInvalid, _ref$defaultChecked = _ref.defaultChecked, defaultChecked = _ref$defaultChecked === void 0 ? false : _ref$defaultChecked, _ref$isIndeterminate = _ref.isIndeterminate, isIndeterminate = _ref$isIndeterminate === void 0 ? false : _ref$isIndeterminate, onChangeProps = _ref.onChange, analyticsContext = _ref.analyticsContext, label = _ref.label, name = _ref.name, value = _ref.value, isRequired = _ref.isRequired, testId = _ref.testId, xcss = _ref.xcss, className = _ref.className, rest = (0, $f708e9c488100c1d$export$2e2bcd8739ae039)(_ref, $fa7b9da54b6e47b4$var$_excluded);
    var _useState = (0, $5FkrB.useState)(isCheckedProp !== undefined ? isCheckedProp : defaultChecked), _useState2 = (0, $e572ede80cc9f568$export$2e2bcd8739ae039)(_useState, 2), isCheckedState = _useState2[0], setIsCheckedState = _useState2[1];
    var onChange = (0, $5FkrB.useCallback)(function(e, analyticsEvent) {
        setIsCheckedState(e.target.checked);
        if (onChangeProps) onChangeProps(e, analyticsEvent);
    }, [
        onChangeProps
    ]);
    var onChangeAnalytics = (0, $7d6daf9bcf6c0b57$export$a4687b0234b40e28)({
        fn: onChange,
        action: 'changed',
        analyticsData: analyticsContext,
        componentName: 'checkbox',
        packageName: "@atlaskit/checkbox",
        packageVersion: "19.1.1"
    });
    var internalRef = (0, $5FkrB.useRef)(null);
    var mergedRefs = (0, $db13a2f91f6a0f56$export$2e2bcd8739ae039)([
        internalRef,
        ref
    ]);
    // Use isChecked from the state if it is controlled
    var isChecked = isCheckedProp === undefined ? isCheckedState : isCheckedProp;
    (0, $5FkrB.useEffect)(function() {
        if (internalRef.current) internalRef.current.indeterminate = isIndeterminate;
    }, [
        isIndeterminate
    ]);
    return /*#__PURE__*/ $5FkrB.createElement((0, $8cd070e8cfc9c0f7$export$2e2bcd8739ae039), {
        isDisabled: isDisabled,
        isChecked: isChecked,
        isIndeterminate: isIndeterminate,
        isInvalid: isInvalid,
        label: label,
        id: rest.id ? "".concat(rest.id, "-label") : undefined,
        testId: testId && "".concat(testId, "--checkbox-label"),
        xcss: xcss
    }, /*#__PURE__*/ $5FkrB.createElement("input", (0, $50b86828abf7136b$export$2e2bcd8739ae039)({
        // It is necessary only for Safari. It allows to render focus styles.
        tabIndex: 0
    }, rest, {
        type: "checkbox",
        ref: mergedRefs,
        disabled: isDisabled,
        checked: isChecked,
        value: value,
        name: name,
        required: isRequired,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $01af0ba52399892d$export$2e2bcd8739ae039)([
            $fa7b9da54b6e47b4$var$checkboxStyles.root,
            className
        ]),
        onChange: onChangeAnalytics,
        "aria-invalid": isInvalid ? 'true' : undefined,
        "data-testid": testId && "".concat(testId, "--hidden-checkbox"),
        "data-invalid": isInvalid ? 'true' : undefined
    })), /*#__PURE__*/ $5FkrB.createElement((0, $2ccca7160d04a198$export$2e2bcd8739ae039), {
        isIndeterminate: isIndeterminate,
        isChecked: isChecked
    }), label && /*#__PURE__*/ $5FkrB.createElement((0, $986a72fc4ddd96ec$export$2e2bcd8739ae039), null, label, isRequired && /*#__PURE__*/ $5FkrB.createElement((0, $a009f31e2434411f$export$2e2bcd8739ae039), null)));
}));
$fa7b9da54b6e47b4$export$48513f6b9f8ce62d.displayName = 'Checkbox';
var // keep the default export for backwards compatibility
$fa7b9da54b6e47b4$export$2e2bcd8739ae039 = $fa7b9da54b6e47b4$export$48513f6b9f8ce62d;


/* flag.tsx generated by @compiled/babel-plugin v2.0.0 */ function $ba40bdae9bf99a27$export$2e2bcd8739ae039() {
    return $ba40bdae9bf99a27$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $ba40bdae9bf99a27$export$2e2bcd8739ae039.apply(null, arguments);
}


function $beffc482493a0ece$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $beffc482493a0ece$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $beffc482493a0ece$export$2e2bcd8739ae039(o);
}



function $f9b357764a3ff56c$export$2e2bcd8739ae039(t, r) {
    if ("object" != (0, $beffc482493a0ece$export$2e2bcd8739ae039)(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (0, $beffc482493a0ece$export$2e2bcd8739ae039)(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}


function $e581912f75bb6331$export$2e2bcd8739ae039(t) {
    var i = (0, $f9b357764a3ff56c$export$2e2bcd8739ae039)(t, "string");
    return "symbol" == (0, $beffc482493a0ece$export$2e2bcd8739ae039)(i) ? i : i + "";
}


function $a9b664628fc883d8$export$2e2bcd8739ae039(e, r, t) {
    return (r = (0, $e581912f75bb6331$export$2e2bcd8739ae039)(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}


function $b69484bf7d509efc$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return r;
}


function $aae88e901f251c3b$export$2e2bcd8739ae039(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}


function $3d558a631a5eb555$export$2e2bcd8739ae039(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}


function $9140fcafffa12f40$export$2e2bcd8739ae039(r, a) {
    if (r) {
        if ("string" == typeof r) return (0, $3d558a631a5eb555$export$2e2bcd8739ae039)(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? (0, $3d558a631a5eb555$export$2e2bcd8739ae039)(r, a) : void 0;
    }
}


function $17c13fe2cab71023$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}


function $4dd2366636a00e12$export$2e2bcd8739ae039(r, e) {
    return (0, $b69484bf7d509efc$export$2e2bcd8739ae039)(r) || (0, $aae88e901f251c3b$export$2e2bcd8739ae039)(r, e) || (0, $9140fcafffa12f40$export$2e2bcd8739ae039)(r, e) || (0, $17c13fe2cab71023$export$2e2bcd8739ae039)();
}



var $5FkrB = parcelRequire("5FkrB");

var $ceTz3 = parcelRequire("ceTz3");/**
 * Returns a CSS custom property value with an optional suffix & prefix.
 * Prefix will only be added if there is a suffix.
 * If the value is undefined a fallback value will be returned to prevent children inheriting parent values.
 *
 * @param value
 * @param suffix
 * @param prefix
 */ function $be5c14d9948a25d1$export$2e2bcd8739ae039(value, suffix, prefix) {
    if (value != undefined) {
        if (suffix) {
            if (prefix) return prefix + value + suffix;
            return value + suffix;
        }
        return value;
    }
    // Currently React trims these values so we can't use a space " " to block the value.
    // Instead we use a CSS variable that doesn't exist which falls back to " ".
    // Bug raised here: https://github.com/facebook/react/issues/20497
    return 'var(--c-, )';
}







var $f8330190f651c5ae$export$d6830277b06edd6 = 'normal';
var $f8330190f651c5ae$export$1eee5ddc4f6d41c5 = 400;


/* flag-actions.tsx generated by @compiled/babel-plugin v2.0.0 */ /* eslint-disable @atlaskit/design-system/no-nested-styles */ 
var $5FkrB = parcelRequire("5FkrB");

var $ceTz3 = parcelRequire("ceTz3");


var $50U6m = parcelRequire("50U6m");

var $d992923be8bc1871$export$7bcfe3cca4dd78b6 = {
    success: "var(--ds-text-inverse, #FFFFFF)",
    info: "var(--ds-text-inverse, #FFFFFF)",
    error: "var(--ds-text-inverse, #FFFFFF)",
    warning: "var(--ds-text-warning-inverse, #292A2E)",
    normal: "var(--ds-link, #1868DB)"
};



// TODO: DSP-2519 Interaction tokens should be used for hovered and pressed states
// https://product-fabric.atlassian.net/browse/DSP-2519






var $612d351ffa94d6d7$export$81ba6b63eedb299f = {
    success: {
        default: "var(--ds-background-inverse-subtle, #00000029)",
        active: "var(--ds-background-inverse-subtle-pressed, #00000052)",
        pressed: "var(--ds-background-inverse-subtle-hovered, #0000003D)"
    },
    info: {
        default: "var(--ds-background-inverse-subtle, #00000029)",
        active: "var(--ds-background-inverse-subtle-pressed, #00000052)",
        pressed: "var(--ds-background-inverse-subtle-hovered, #0000003D)"
    },
    error: {
        default: "var(--ds-background-inverse-subtle, #00000029)",
        active: "var(--ds-background-inverse-subtle-pressed, #00000052)",
        pressed: "var(--ds-background-inverse-subtle-hovered, #0000003D)"
    },
    warning: {
        default: "var(--ds-background-inverse-subtle, #00000029)",
        active: "var(--ds-background-inverse-subtle-pressed, #00000052)",
        pressed: "var(--ds-background-inverse-subtle-hovered, #0000003D)"
    },
    normal: {
        default: 'none',
        active: 'none',
        pressed: 'none'
    }
};


var $de475bb7041a7e09$var$buttonStylesOld = null;
var $de475bb7041a7e09$var$buttonStyles = null;
var $de475bb7041a7e09$var$fontStyles = null;
var $de475bb7041a7e09$var$appearanceNormalButtonStyles = null;
var $de475bb7041a7e09$var$appearanceBoldButtonStyles = null;
var $de475bb7041a7e09$var$appearanceNormalActionsContainerStyles = null;
var $de475bb7041a7e09$var$FlagActions = function FlagActions(props) {
    var _props$appearance = props.appearance, appearance = _props$appearance === void 0 ? (0, $f8330190f651c5ae$export$d6830277b06edd6) : _props$appearance, _props$actions = props.actions, actions = _props$actions === void 0 ? [] : _props$actions, linkComponent = props.linkComponent, testId = props.testId;
    if (!actions.length) return null;
    var isBold = appearance !== (0, $f8330190f651c5ae$export$d6830277b06edd6);
    return /*#__PURE__*/ $5FkrB.createElement("span", {
        className: (0, $ceTz3.default)([
            !isBold && "_1g4l107e _y8dn107e",
            "_11c8fhey"
        ])
    }, /*#__PURE__*/ $5FkrB.createElement((0, $04267de539304abd$export$fbae5b5ffd8af05e), {
        space: "space.100",
        shouldWrap: true,
        alignBlock: "center",
        separator: isBold ? undefined : "\xb7",
        testId: testId && "".concat(testId, "-actions")
    }, actions.map(function(action, index) {
        return (0, $50U6m.fg)('platform_dst_flag_action_padding_fix') ? /*#__PURE__*/ $5FkrB.createElement((0, $079ca7802c1bfb5a$export$2e2bcd8739ae039), {
            onClick: action.onClick,
            href: action.href,
            target: action.target,
            appearance: isBold ? 'default' : 'link',
            component: linkComponent,
            spacing: "compact",
            testId: action.testId,
            key: index,
            style: {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                '--color': (0, $d992923be8bc1871$export$7bcfe3cca4dd78b6)[appearance],
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                '--bg-color': (0, $612d351ffa94d6d7$export$81ba6b63eedb299f)[appearance].default,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                '--bg-color-hover': (0, $612d351ffa94d6d7$export$81ba6b63eedb299f)[appearance].pressed,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                '--bg-color-active': (0, $612d351ffa94d6d7$export$81ba6b63eedb299f)[appearance].active
            },
            className: (0, $ceTz3.default)([
                "_nup91zz4 _u4iq1zz4 _1w901pkf _qkwg1pkf _12r21wq8 _il101wq8 _ow071r31 _1p6b1r31 _8dbm1r31 _77mc1r31 _17rj8stv _1p6m8stv _5kwq8stv _1pd88stv _1iqunqa1 _1ejunqa1 _b6ztnqa1 _1rsgnqa1 _u1mb14jz _10fu17w4",
                isBold ? "_1dltgrf3 _h03xgrf3 _w8sq1a66 _1iys1a66 _fjwrgrf3 _cwkngrf3 _1yxx1a66 _z7cd1a66" : "_1dltgrf3 _h03xgrf3 _w8sqgrf3 _1iysgrf3 _fjwrgrf3 _cwkngrf3 _1yxxgrf3 _z7cdgrf3"
            ])
        }, action.content) : /*#__PURE__*/ $5FkrB.createElement((0, $079ca7802c1bfb5a$export$2e2bcd8739ae039), {
            onClick: action.onClick,
            href: action.href,
            target: action.target,
            appearance: isBold ? 'default' : 'link',
            component: linkComponent,
            spacing: "compact",
            testId: action.testId,
            key: index,
            style: {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                '--color': (0, $d992923be8bc1871$export$7bcfe3cca4dd78b6)[appearance],
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                '--bg-color': (0, $612d351ffa94d6d7$export$81ba6b63eedb299f)[appearance].default,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                '--bg-color-hover': (0, $612d351ffa94d6d7$export$81ba6b63eedb299f)[appearance].pressed,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                '--bg-color-active': (0, $612d351ffa94d6d7$export$81ba6b63eedb299f)[appearance].active
            },
            className: (0, $ceTz3.default)([
                "_nup91zz4 _u4iq1zz4 _1w901pkf _qkwg1pkf _12r21wq8 _il101wq8 _1ku2grf3 _1v8mgrf3 _gbuigrf3 _1dwvgrf3 _1bk61a66 _1wy61a66 _b3g31a66 _eqps1a66 _ow071r31 _1p6b1r31 _8dbm1r31 _77mc1r31 _17rj8stv _1p6m8stv _5kwq8stv _1pd88stv _1iqunqa1 _1ejunqa1 _b6ztnqa1 _1rsgnqa1 _u1mb14jz _10fu17w4",
                !isBold && "_1dltgrf3 _h03xgrf3 _w8sqgrf3 _1iysgrf3 _fjwrgrf3 _cwkngrf3 _1yxxgrf3 _z7cdgrf3"
            ])
        }, action.content);
    })));
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$de475bb7041a7e09$export$2e2bcd8739ae039 = $de475bb7041a7e09$var$FlagActions;


var $5d66367ea54dc41e$export$59e42969c95d314 = {
    error: 'color.background.danger.bold',
    info: 'color.background.neutral.bold',
    normal: 'elevation.surface.overlay',
    success: 'color.background.success.bold',
    warning: 'color.background.warning.bold'
};


var $0a19d60b13e87e43$export$7f70afe2167f8235 = {
    error: "var(--ds-icon-inverse, #FFFFFF)",
    info: "var(--ds-icon-inverse, #FFFFFF)",
    normal: "var(--ds-icon-subtle, #505258)",
    success: "var(--ds-icon-inverse, #FFFFFF)",
    warning: "var(--ds-icon-warning-inverse, #292A2E)"
};



var $5FkrB = parcelRequire("5FkrB");
var $8b467f446b8676d5$exports = {};
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::8eaaa23a968450e17340047f7baad741>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty($8b467f446b8676d5$exports, "__esModule", {
    value: true
});
$8b467f446b8676d5$exports.default = void 0;

var $8b467f446b8676d5$var$_react = $8b467f446b8676d5$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $8b467f446b8676d5$var$_baseNew = $8b467f446b8676d5$var$_interopRequireDefault((parcelRequire("jcbQ2")));
function $8b467f446b8676d5$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "StatusError".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/status-error
 * Usage guidance:
 * Reserved for error statuses and messaging.
 * Filled status icons provide higher visual contrast to draw attention to important information.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $8b467f446b8676d5$var$StatusErrorIcon = (props)=>/*#__PURE__*/ $8b467f446b8676d5$var$_react.default.createElement($8b467f446b8676d5$var$_baseNew.default, Object.assign({
        name: "StatusErrorIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6.586.603a2 2 0 0 1 2.828 0l5.983 5.983a2 2 0 0 1 0 2.828l-5.983 5.982a2 2 0 0 1-2.828 0L.604 9.414a2 2 0 0 1 0-2.828zM8 10.25a1 1 0 1 0 0 2 1 1 0 0 0 0-2m-.75-6.5V9h1.5V3.75z" clip-rule="evenodd"/>`
    }, props));
$8b467f446b8676d5$var$StatusErrorIcon.displayName = 'StatusErrorIcon';
var $8b467f446b8676d5$var$_default = $8b467f446b8676d5$exports.default = $8b467f446b8676d5$var$StatusErrorIcon;


var $7ed5b5ee9d12e24d$exports = {};
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e6464fc3501ef95b4ce0d44356e317be>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty($7ed5b5ee9d12e24d$exports, "__esModule", {
    value: true
});
$7ed5b5ee9d12e24d$exports.default = void 0;

var $7ed5b5ee9d12e24d$var$_react = $7ed5b5ee9d12e24d$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $7ed5b5ee9d12e24d$var$_baseNew = $7ed5b5ee9d12e24d$var$_interopRequireDefault((parcelRequire("jcbQ2")));
function $7ed5b5ee9d12e24d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "StatusInformation".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/status-information
 * Usage guidance:
 * Reserved for information statuses and messaging.
 * Filled status icons provide higher visual contrast to draw attention to important information.
 * For information tooltips, use the unfilled 'information circle' icon.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $7ed5b5ee9d12e24d$var$StatusInformationIcon = (props)=>/*#__PURE__*/ $7ed5b5ee9d12e24d$var$_react.default.createElement($7ed5b5ee9d12e24d$var$_baseNew.default, Object.assign({
        name: "StatusInformationIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0M6.5 6.75v1.5h.75v4.25h1.5v-5A.75.75 0 0 0 8 6.75zM8 3.5a1 1 0 1 0 0 2 1 1 0 0 0 0-2" clip-rule="evenodd"/>`
    }, props));
$7ed5b5ee9d12e24d$var$StatusInformationIcon.displayName = 'StatusInformationIcon';
var $7ed5b5ee9d12e24d$var$_default = $7ed5b5ee9d12e24d$exports.default = $7ed5b5ee9d12e24d$var$StatusInformationIcon;


var $b2231a2905418b60$exports = {};
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::43780b3395052aa320d1077123ecca9b>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty($b2231a2905418b60$exports, "__esModule", {
    value: true
});
$b2231a2905418b60$exports.default = void 0;

var $b2231a2905418b60$var$_react = $b2231a2905418b60$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $b2231a2905418b60$var$_baseNew = $b2231a2905418b60$var$_interopRequireDefault((parcelRequire("jcbQ2")));
function $b2231a2905418b60$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "StatusSuccess".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/status-success
 * Usage guidance:
 * Reserved for success statuses and messaging. Filled status icons provide higher visual contrast to draw attention to important information.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $b2231a2905418b60$var$StatusSuccessIcon = (props)=>/*#__PURE__*/ $b2231a2905418b60$var$_react.default.createElement($b2231a2905418b60$var$_baseNew.default, Object.assign({
        name: "StatusSuccessIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0M6.75 9.828 4.826 7.52l-1.152.96 2.5 3a.75.75 0 0 0 1.152 0l5-6-1.152-.96z" clip-rule="evenodd"/>`
    }, props));
$b2231a2905418b60$var$StatusSuccessIcon.displayName = 'StatusSuccessIcon';
var $b2231a2905418b60$var$_default = $b2231a2905418b60$exports.default = $b2231a2905418b60$var$StatusSuccessIcon;


var $0ae639d136145f3d$exports = {};
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d15ab13bccd5974ddb056f1635cc0800>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty($0ae639d136145f3d$exports, "__esModule", {
    value: true
});
$0ae639d136145f3d$exports.default = void 0;

var $0ae639d136145f3d$var$_react = $0ae639d136145f3d$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $0ae639d136145f3d$var$_baseNew = $0ae639d136145f3d$var$_interopRequireDefault((parcelRequire("jcbQ2")));
function $0ae639d136145f3d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "StatusWarning".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/status-warning
 * Usage guidance:
 * Reserved for warning statuses.
 * Filled status icons provide higher visual contrast to draw attention to important information.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $0ae639d136145f3d$var$StatusWarningIcon = (props)=>/*#__PURE__*/ $0ae639d136145f3d$var$_react.default.createElement($0ae639d136145f3d$var$_baseNew.default, Object.assign({
        name: "StatusWarningIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6.242 1.168c.756-1.395 2.76-1.395 3.516 0l5.9 10.878c.723 1.333-.242 2.953-1.758 2.953H2.1C.584 15-.38 13.38.342 12.046zM8 10.75a1 1 0 1 0 0 2.001 1 1 0 0 0 0-2M7.25 4.5v5h1.5v-5z" clip-rule="evenodd"/>`
    }, props));
$0ae639d136145f3d$var$StatusWarningIcon.displayName = 'StatusWarningIcon';
var $0ae639d136145f3d$var$_default = $0ae639d136145f3d$exports.default = $0ae639d136145f3d$var$StatusWarningIcon;


var $23a4e5dfdf5f7eea$export$73f08aee70487cd4 = {
    error: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8b467f446b8676d5$exports))), {
        label: ""
    }),
    info: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7ed5b5ee9d12e24d$exports))), {
        label: ""
    }),
    normal: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7ed5b5ee9d12e24d$exports))), {
        label: ""
    }),
    success: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($b2231a2905418b60$exports))), {
        label: ""
    }),
    warning: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($0ae639d136145f3d$exports))), {
        label: ""
    })
};


var $73882095ac86360f$export$f50075b2584087f = {
    error: 'color.text.inverse',
    info: 'color.text.inverse',
    normal: 'color.text',
    success: 'color.text.inverse',
    warning: 'color.text.warning.inverse'
};


var $a75ec366da06ccaa$export$13b42cd9d596bfe0 = {
    error: "var(--ds-text-inverse, #FFFFFF)",
    info: "var(--ds-text-inverse, #FFFFFF)",
    normal: "var(--ds-text, #292A2E)",
    success: "var(--ds-text-inverse, #FFFFFF)",
    warning: "var(--ds-text-warning-inverse, #292A2E)"
};




var $5FkrB = parcelRequire("5FkrB");



var $5FkrB = parcelRequire("5FkrB");






var $40ac4214599ec615$var$_excluded = [
    "aria-label",
    "aria-labelledby",
    "analyticsContext",
    "appearance",
    "autoFocus",
    "icon",
    "interactionName",
    "isDisabled",
    "isLoading",
    "isSelected",
    "isTooltipDisabled",
    "label",
    "onClick",
    "onClickCapture",
    "onKeyDownCapture",
    "onKeyUpCapture",
    "onMouseDownCapture",
    "onMouseUpCapture",
    "onPointerDownCapture",
    "onPointerUpCapture",
    "onTouchEndCapture",
    "onTouchStartCapture",
    "shape",
    "spacing",
    "testId",
    "tooltip",
    "type"
], $40ac4214599ec615$var$_excluded2 = [
    "className",
    "css",
    "as",
    "style"
];
/**
 * __Icon Button__
 *
 * Renders an icon-only button lets people take a common and recognizable action where space is limited.
 *
 * - [Examples](https://atlassian.design/components/button/icon-button/examples)
 * - [Code](https://atlassian.design/components/button/icon-button/code)
 * - [Usage](https://atlassian.design/components/button/icon-button/usage)
 */ var $40ac4214599ec615$var$IconButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).forwardRef(function Button(_ref, ref) {
    var _tooltip$content;
    var preventedAriaLabel = _ref['aria-label'], ariaLabelledBy = _ref['aria-labelledby'], analyticsContext = _ref.analyticsContext, appearance = _ref.appearance, autoFocus = _ref.autoFocus, icon = _ref.icon, interactionName = _ref.interactionName, isDisabled = _ref.isDisabled, _ref$isLoading = _ref.isLoading, isLoading = _ref$isLoading === void 0 ? false : _ref$isLoading, isSelected = _ref.isSelected, _ref$isTooltipDisable = _ref.isTooltipDisabled, isTooltipDisabled = _ref$isTooltipDisable === void 0 ? true : _ref$isTooltipDisable, label = _ref.label, _onClick = _ref.onClick, onClickCapture = _ref.onClickCapture, onKeyDownCapture = _ref.onKeyDownCapture, onKeyUpCapture = _ref.onKeyUpCapture, onMouseDownCapture = _ref.onMouseDownCapture, onMouseUpCapture = _ref.onMouseUpCapture, onPointerDownCapture = _ref.onPointerDownCapture, onPointerUpCapture = _ref.onPointerUpCapture, onTouchEndCapture = _ref.onTouchEndCapture, onTouchStartCapture = _ref.onTouchStartCapture, shape = _ref.shape, spacing = _ref.spacing, testId = _ref.testId, tooltip = _ref.tooltip, _ref$type = _ref.type, type = _ref$type === void 0 ? 'button' : _ref$type, unsafeRest = (0, $230c1601acfa3177$export$2e2bcd8739ae039)(_ref, $40ac4214599ec615$var$_excluded);
    // @ts-expect-error
    var _className = unsafeRest.className, _css = unsafeRest.css, _as = unsafeRest.as, _style = unsafeRest.style, saferRest = (0, $230c1601acfa3177$export$2e2bcd8739ae039)(unsafeRest, $40ac4214599ec615$var$_excluded2);
    if (isTooltipDisabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $76b58416a5044cb0$export$2e2bcd8739ae039), (0, $bdabb985862bf53b$export$2e2bcd8739ae039)({}, saferRest, {
        ref: ref,
        appearance: appearance,
        autoFocus: autoFocus,
        isDisabled: isDisabled,
        isLoading: isLoading,
        isSelected: isSelected,
        isIconButton: true,
        isCircle: shape === 'circle',
        hasIconBefore: !!icon,
        spacing: spacing,
        ariaLabelledBy: ariaLabelledBy,
        onClick: _onClick,
        onClickCapture: onClickCapture,
        onKeyDownCapture: onKeyDownCapture,
        onKeyUpCapture: onKeyUpCapture,
        onMouseDownCapture: onMouseDownCapture,
        onMouseUpCapture: onMouseUpCapture,
        onPointerDownCapture: onPointerDownCapture,
        onPointerUpCapture: onPointerUpCapture,
        onTouchStartCapture: onTouchStartCapture,
        onTouchEndCapture: onTouchEndCapture,
        testId: testId,
        componentName: "IconButton",
        analyticsContext: analyticsContext,
        type: type,
        interactionName: interactionName
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $8e23f919bcd6960d$export$2e2bcd8739ae039), {
        type: "icon",
        isLoading: isLoading
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $bf01465dd7c7d1ef$export$2e2bcd8739ae039), {
        icon: icon
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $a4a1a9cdc7bf2d54$export$2e2bcd8739ae039), null, label)));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $32d4a3c4842e3ceb$export$2e2bcd8739ae039), {
        content: (_tooltip$content = tooltip === null || tooltip === void 0 ? void 0 : tooltip.content) !== null && _tooltip$content !== void 0 ? _tooltip$content : label,
        testId: tooltip === null || tooltip === void 0 ? void 0 : tooltip.testId,
        position: tooltip === null || tooltip === void 0 ? void 0 : tooltip.position,
        delay: tooltip === null || tooltip === void 0 ? void 0 : tooltip.delay,
        onShow: tooltip === null || tooltip === void 0 ? void 0 : tooltip.onShow,
        onHide: tooltip === null || tooltip === void 0 ? void 0 : tooltip.onHide,
        mousePosition: tooltip === null || tooltip === void 0 ? void 0 : tooltip.mousePosition,
        analyticsContext: tooltip === null || tooltip === void 0 ? void 0 : tooltip.analyticsContext,
        strategy: tooltip === null || tooltip === void 0 ? void 0 : tooltip.strategy,
        tag: tooltip === null || tooltip === void 0 ? void 0 : tooltip.tag,
        truncate: tooltip === null || tooltip === void 0 ? void 0 : tooltip.truncate,
        component: tooltip === null || tooltip === void 0 ? void 0 : tooltip.component,
        hideTooltipOnClick: tooltip === null || tooltip === void 0 ? void 0 : tooltip.hideTooltipOnClick,
        hideTooltipOnMouseDown: tooltip === null || tooltip === void 0 ? void 0 : tooltip.hideTooltipOnMouseDown,
        ignoreTooltipPointerEvents: tooltip === null || tooltip === void 0 ? void 0 : tooltip.ignoreTooltipPointerEvents,
        shortcut: tooltip === null || tooltip === void 0 ? void 0 : tooltip.shortcut
    }, function(triggerProps) {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $76b58416a5044cb0$export$2e2bcd8739ae039), (0, $bdabb985862bf53b$export$2e2bcd8739ae039)({}, saferRest, {
            appearance: appearance,
            autoFocus: autoFocus,
            isDisabled: isDisabled,
            isLoading: isLoading,
            isSelected: isSelected,
            isIconButton: true,
            isCircle: shape === 'circle',
            hasIconBefore: false,
            spacing: spacing,
            ariaLabelledBy: ariaLabelledBy,
            onClick: function onClick(e, analyticsEvent) {
                var _triggerProps$onClick;
                _onClick === null || _onClick === void 0 || _onClick(e, analyticsEvent);
                (_triggerProps$onClick = triggerProps.onClick) === null || _triggerProps$onClick === void 0 || _triggerProps$onClick.call(triggerProps, e);
            },
            onMouseOver: function onMouseOver(e) {
                var _triggerProps$onMouse, _saferRest$onMouseOve;
                (_triggerProps$onMouse = triggerProps.onMouseOver) === null || _triggerProps$onMouse === void 0 || _triggerProps$onMouse.call(triggerProps, e);
                (_saferRest$onMouseOve = saferRest.onMouseOver) === null || _saferRest$onMouseOve === void 0 || _saferRest$onMouseOve.call(saferRest, e);
            },
            onMouseOut: function onMouseOut(e) {
                var _triggerProps$onMouse2, _saferRest$onMouseOut;
                (_triggerProps$onMouse2 = triggerProps.onMouseOut) === null || _triggerProps$onMouse2 === void 0 || _triggerProps$onMouse2.call(triggerProps, e);
                (_saferRest$onMouseOut = saferRest.onMouseOut) === null || _saferRest$onMouseOut === void 0 || _saferRest$onMouseOut.call(saferRest, e);
            },
            onMouseMove: function onMouseMove(e) {
                var _triggerProps$onMouse3, _saferRest$onMouseMov;
                (_triggerProps$onMouse3 = triggerProps.onMouseMove) === null || _triggerProps$onMouse3 === void 0 || _triggerProps$onMouse3.call(triggerProps, e);
                (_saferRest$onMouseMov = saferRest.onMouseMove) === null || _saferRest$onMouseMov === void 0 || _saferRest$onMouseMov.call(saferRest, e);
            },
            onMouseDown: function onMouseDown(e) {
                var _triggerProps$onMouse4, _saferRest$onMouseDow;
                (_triggerProps$onMouse4 = triggerProps.onMouseDown) === null || _triggerProps$onMouse4 === void 0 || _triggerProps$onMouse4.call(triggerProps, e);
                (_saferRest$onMouseDow = saferRest.onMouseDown) === null || _saferRest$onMouseDow === void 0 || _saferRest$onMouseDow.call(saferRest, e);
            },
            onFocus: function onFocus(e) {
                var _triggerProps$onFocus, _saferRest$onFocus;
                (_triggerProps$onFocus = triggerProps.onFocus) === null || _triggerProps$onFocus === void 0 || _triggerProps$onFocus.call(triggerProps, e);
                (_saferRest$onFocus = saferRest.onFocus) === null || _saferRest$onFocus === void 0 || _saferRest$onFocus.call(saferRest, e);
            },
            onBlur: function onBlur(e) {
                var _triggerProps$onBlur, _saferRest$onBlur;
                (_triggerProps$onBlur = triggerProps.onBlur) === null || _triggerProps$onBlur === void 0 || _triggerProps$onBlur.call(triggerProps, e);
                (_saferRest$onBlur = saferRest.onBlur) === null || _saferRest$onBlur === void 0 || _saferRest$onBlur.call(saferRest, e);
            },
            ref: (0, $db13a2f91f6a0f56$export$2e2bcd8739ae039)([
                ref,
                triggerProps === null || triggerProps === void 0 ? void 0 : triggerProps.ref
            ].filter(Boolean)),
            onMouseDownCapture: onMouseDownCapture,
            onMouseUpCapture: onMouseUpCapture,
            onKeyDownCapture: onKeyDownCapture,
            onKeyUpCapture: onKeyUpCapture,
            onTouchStartCapture: onTouchStartCapture,
            onTouchEndCapture: onTouchEndCapture,
            onPointerDownCapture: onPointerDownCapture,
            onPointerUpCapture: onPointerUpCapture,
            onClickCapture: onClickCapture,
            type: type,
            testId: testId,
            analyticsContext: analyticsContext,
            interactionName: interactionName,
            componentName: "IconButton"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $8e23f919bcd6960d$export$2e2bcd8739ae039), {
            type: "icon",
            isLoading: isLoading
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $bf01465dd7c7d1ef$export$2e2bcd8739ae039), {
            icon: icon
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $a4a1a9cdc7bf2d54$export$2e2bcd8739ae039), null, label)));
    });
}));
$40ac4214599ec615$var$IconButton.displayName = 'IconButton';
var $40ac4214599ec615$export$2e2bcd8739ae039 = $40ac4214599ec615$var$IconButton;


var $1f028fb086bd721f$exports = {};
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6af69c0da1151808644d1b7c1f4d031c>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty($1f028fb086bd721f$exports, "__esModule", {
    value: true
});
$1f028fb086bd721f$exports.default = void 0;

var $1f028fb086bd721f$var$_react = $1f028fb086bd721f$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $1f028fb086bd721f$var$_baseNew = $1f028fb086bd721f$var$_interopRequireDefault((parcelRequire("jcbQ2")));
function $1f028fb086bd721f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ChevronDown".
 * Category: multi-purpose
 * Location: @atlaskit/icon/core/chevron-down
 * Usage guidance:
 * Do not use 16px chevrons within buttons, icon buttons, or dropdowns to maintain visual cohesion with ADS which uses 12px chevrons.
 * Known uses: Open dropdown menu, expanded tree item, collapse tree item
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $1f028fb086bd721f$var$ChevronDownIcon = (props)=>/*#__PURE__*/ $1f028fb086bd721f$var$_react.default.createElement($1f028fb086bd721f$var$_baseNew.default, Object.assign({
        name: "ChevronDownIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="m14.53 6.03-6 6a.75.75 0 0 1-1.004.052l-.056-.052-6-6 1.06-1.06L8 10.44l5.47-5.47z"/>`
    }, props));
$1f028fb086bd721f$var$ChevronDownIcon.displayName = 'ChevronDownIcon';
var $1f028fb086bd721f$var$_default = $1f028fb086bd721f$exports.default = $1f028fb086bd721f$var$ChevronDownIcon;


var $3a0701e7cef3117b$exports = {};
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d43da111d5da2bc4c58e22bdbb274e37>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty($3a0701e7cef3117b$exports, "__esModule", {
    value: true
});
$3a0701e7cef3117b$exports.default = void 0;

var $3a0701e7cef3117b$var$_react = $3a0701e7cef3117b$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $3a0701e7cef3117b$var$_baseNew = $3a0701e7cef3117b$var$_interopRequireDefault((parcelRequire("jcbQ2")));
function $3a0701e7cef3117b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ChevronUp".
 * Category: multi-purpose
 * Location: @atlaskit/icon/core/chevron-up
 * Usage guidance:
 * Do not use 16px chevrons within buttons, icon buttons, or dropdowns to maintain visual cohesion with ADS which uses 12px chevrons.
 * Known uses: Close dropdown menu
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $3a0701e7cef3117b$var$ChevronUpIcon = (props)=>/*#__PURE__*/ $3a0701e7cef3117b$var$_react.default.createElement($3a0701e7cef3117b$var$_baseNew.default, Object.assign({
        name: "ChevronUpIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="m14.53 9.97-6-6a.75.75 0 0 0-1.004-.052l-.056.052-6 6 1.06 1.06L8 5.56l5.47 5.47z"/>`
    }, props));
$3a0701e7cef3117b$var$ChevronUpIcon.displayName = 'ChevronUpIcon';
var $3a0701e7cef3117b$var$_default = $3a0701e7cef3117b$exports.default = $3a0701e7cef3117b$var$ChevronUpIcon;


var $ad984e20c1b94b33$exports = {};
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::cdf99897c5696ca9ecbe3cd832bc46f8>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty($ad984e20c1b94b33$exports, "__esModule", {
    value: true
});
$ad984e20c1b94b33$exports.default = void 0;

var $ad984e20c1b94b33$var$_react = $ad984e20c1b94b33$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $ad984e20c1b94b33$var$_baseNew = $ad984e20c1b94b33$var$_interopRequireDefault((parcelRequire("jcbQ2")));
function $ad984e20c1b94b33$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Cross".
 * Category: multi-purpose
 * Location: @atlaskit/icon/core/cross
 * Usage guidance:
 * Known uses: closing modals, panels, and transient views; removing tags
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $ad984e20c1b94b33$var$CrossIcon = (props)=>/*#__PURE__*/ $ad984e20c1b94b33$var$_react.default.createElement($ad984e20c1b94b33$var$_baseNew.default, Object.assign({
        name: "CrossIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M13.53 3.53 9.06 8l4.47 4.47-1.06 1.06L8 9.06l-4.47 4.47-1.06-1.06L6.94 8 2.47 3.53l1.06-1.06L8 6.94l4.47-4.47z"/>`
    }, props));
$ad984e20c1b94b33$var$CrossIcon.displayName = 'CrossIcon';
var $ad984e20c1b94b33$var$_default = $ad984e20c1b94b33$exports.default = $ad984e20c1b94b33$var$CrossIcon;



var $51873c5421c1a0b2$var$DismissButtonComponent = function DismissButtonComponent(_ref) {
    var appearance = _ref.appearance, onClick = _ref.onClick, isBold = _ref.isBold, isExpanded = _ref.isExpanded, testId = _ref.testId;
    var ButtonIcon = (0, (/*@__PURE__*/$parcel$interopDefault($ad984e20c1b94b33$exports)));
    var buttonLabel = 'Dismiss';
    var buttonTestId = testId && "".concat(testId, "-dismiss");
    if (isBold) {
        ButtonIcon = isExpanded ? (0, (/*@__PURE__*/$parcel$interopDefault($3a0701e7cef3117b$exports))) : (0, (/*@__PURE__*/$parcel$interopDefault($1f028fb086bd721f$exports)));
        buttonLabel = isExpanded ? 'Collapse' : 'Expand';
        buttonTestId = testId && "".concat(testId, "-toggle");
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $40ac4214599ec615$export$2e2bcd8739ae039), {
        icon: function icon(iconProps) {
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(ButtonIcon, (0, $ba40bdae9bf99a27$export$2e2bcd8739ae039)({}, iconProps, {
                size: "small",
                label: "",
                color: (0, $a75ec366da06ccaa$export$13b42cd9d596bfe0)[appearance]
            }));
        },
        appearance: "subtle",
        spacing: "compact",
        label: buttonLabel,
        onClick: onClick,
        "aria-expanded": isBold ? isExpanded : undefined,
        testId: buttonTestId
    });
};
var $51873c5421c1a0b2$var$DismissButton = /*#__PURE__*/ (0, $5FkrB.memo)($51873c5421c1a0b2$var$DismissButtonComponent);
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$51873c5421c1a0b2$export$2e2bcd8739ae039 = $51873c5421c1a0b2$var$DismissButton;


/* expander.tsx generated by @compiled/babel-plugin v2.0.0 */ 

var $5FkrB = parcelRequire("5FkrB");




var $6ccef00473d223b2$var$styles = {
    expander: "_1bsb1osq",
    container: "_v5641xzp"
};
var $6ccef00473d223b2$var$Expander = function Expander(_ref) {
    var children = _ref.children, isExpanded = _ref.isExpanded, testId = _ref.testId;
    // Need to always render the ExpanderInternal otherwise the
    // reveal transition doesn't happen. We can't use CSS animation for
    // the the reveal because we don't know the height of the content.
    return /*#__PURE__*/ $5FkrB.createElement((0, $7a49b1df02a75aca$export$e71c4d32a2263218), {
        xcss: $6ccef00473d223b2$var$styles.expander,
        style: {
            maxHeight: isExpanded ? 150 : 0,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            flex: '1 1 100%',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            minWidth: 0
        },
        "aria-hidden": !isExpanded,
        testId: testId && "".concat(testId, "-expander")
    }, /*#__PURE__*/ $5FkrB.createElement((0, $7dce5bdaf433551a$export$2e2bcd8739ae039), {
        appear: true
    }, isExpanded && /*#__PURE__*/ $5FkrB.createElement((0, $faf8d110486344ab$export$2e2bcd8739ae039), null, function(props) {
        return /*#__PURE__*/ $5FkrB.createElement((0, $7a49b1df02a75aca$export$e71c4d32a2263218), (0, $ba40bdae9bf99a27$export$2e2bcd8739ae039)({
            xcss: $6ccef00473d223b2$var$styles.container
        }, props), /*#__PURE__*/ $5FkrB.createElement((0, $70988de881688cbc$export$694e0d28c7ffc90c), {
            space: "space.100"
        }, children));
    })));
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$6ccef00473d223b2$export$2e2bcd8739ae039 = $6ccef00473d223b2$var$Expander;



var $5FkrB = parcelRequire("5FkrB");

var $5FkrB = parcelRequire("5FkrB");

var $752ba29d1ba270d8$export$643760c4938da30d = {
    onDismissed: (0, $adcefb868cf2fc9d$export$2e2bcd8739ae039),
    isDismissAllowed: false
};


var $fb00836d049bbf24$export$c57ba665aaa722be = /*#__PURE__*/ (0, $5FkrB.createContext)((0, $752ba29d1ba270d8$export$643760c4938da30d));


function $9cf144166b7d1d72$export$e91ea202abb66350() {
    return (0, $5FkrB.useContext)((0, $fb00836d049bbf24$export$c57ba665aaa722be));
}


function $dded6e092963b70b$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $dded6e092963b70b$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $dded6e092963b70b$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $a9b664628fc883d8$export$2e2bcd8739ae039)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $dded6e092963b70b$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $dded6e092963b70b$var$styles = {
    overflowWrap: "_1i4qfg65",
    flag: "_2rko1mok _1reo15vq _18m915vq _v564z97a _16qs130s _1pbyni7l _1bsb1osq"
};
var $dded6e092963b70b$var$CSS_VAR_ICON_COLOR = '--flag-icon-color';
var $dded6e092963b70b$var$descriptionStyles = null;
var $dded6e092963b70b$var$flagWrapperStyles = null;
var $dded6e092963b70b$var$iconWrapperStyles = null;
var $dded6e092963b70b$var$transitionStyles = null;
var $dded6e092963b70b$var$analyticsAttributes = {
    componentName: 'flag',
    packageName: "@atlaskit/flag",
    packageVersion: "18.5.0"
};
/**
 * __Flag__
 *
 * A flag is used for confirmations, alerts, and acknowledgments that require minimal user interaction,
 * often displayed using a flag group.
 *
 * - [Examples](https://atlassian.design/components/flag/examples)
 * - [Code](https://atlassian.design/components/flag/code)
 * - [Usage](https://atlassian.design/components/flag/usage)
 */ var $dded6e092963b70b$var$Flag = function Flag(props) {
    var _props$actions = props.actions, actions = _props$actions === void 0 ? [] : _props$actions, _props$appearance = props.appearance, appearance = _props$appearance === void 0 ? (0, $f8330190f651c5ae$export$d6830277b06edd6) : _props$appearance, icon = props.icon, title = props.title, description = props.description, linkComponent = props.linkComponent, onMouseOver = props.onMouseOver, _props$onFocus = props.onFocus, onFocus = _props$onFocus === void 0 ? (0, $adcefb868cf2fc9d$export$2e2bcd8739ae039) : _props$onFocus, onMouseOut = props.onMouseOut, _props$onBlur = props.onBlur, onBlur = _props$onBlur === void 0 ? (0, $adcefb868cf2fc9d$export$2e2bcd8739ae039) : _props$onBlur, _props$onDismissed = props.onDismissed, onDismissedProp = _props$onDismissed === void 0 ? (0, $adcefb868cf2fc9d$export$2e2bcd8739ae039) : _props$onDismissed, testId = props.testId, id = props.id, analyticsContext = props.analyticsContext, delayAnnouncement = props.delayAnnouncement, _props$headingLevel = props.headingLevel, headingLevel = _props$headingLevel === void 0 ? 2 : _props$headingLevel;
    var _useState = (0, $5FkrB.useState)(false), _useState2 = (0, $4dd2366636a00e12$export$2e2bcd8739ae039)(_useState, 2), isDelayToAnnounce = _useState2[0], setIsDelayToAnnounce = _useState2[1];
    var _useFlagGroup = (0, $9cf144166b7d1d72$export$e91ea202abb66350)(), onDismissedFromFlagGroup = _useFlagGroup.onDismissed, isDismissAllowed = _useFlagGroup.isDismissAllowed;
    var onDismissed = (0, $5FkrB.useCallback)(function(id, analyticsEvent) {
        onDismissedProp(id, analyticsEvent);
        onDismissedFromFlagGroup(id, analyticsEvent);
    }, [
        onDismissedProp,
        onDismissedFromFlagGroup
    ]);
    var _useState3 = (0, $5FkrB.useState)(false), _useState4 = (0, $4dd2366636a00e12$export$2e2bcd8739ae039)(_useState3, 2), isExpanded = _useState4[0], setIsExpanded = _useState4[1];
    var onDismissedAnalytics = (0, $7d6daf9bcf6c0b57$export$a4687b0234b40e28)($dded6e092963b70b$var$_objectSpread({
        fn: onDismissed,
        action: 'dismissed',
        analyticsData: analyticsContext
    }, $dded6e092963b70b$var$analyticsAttributes));
    var isBold = appearance !== (0, $f8330190f651c5ae$export$d6830277b06edd6);
    var toggleExpand = (0, $5FkrB.useCallback)(function() {
        setIsExpanded(function(previous) {
            return !previous;
        });
    }, []);
    var buttonActionCallback = (0, $5FkrB.useCallback)(function() {
        if (isDismissAllowed) onDismissedAnalytics(id);
    }, [
        onDismissedAnalytics,
        id,
        isDismissAllowed
    ]);
    (0, $5FkrB.useEffect)(function() {
        // If buttons are removed as a prop, update isExpanded to be false
        if (isBold && isExpanded && !description && !actions.length) setIsExpanded(false);
    }, [
        actions.length,
        description,
        isBold,
        isExpanded
    ]);
    (0, $5FkrB.useEffect)(function() {
        if (!delayAnnouncement) return;
        setTimeout(function() {
            setIsDelayToAnnounce(true);
        }, delayAnnouncement);
    }, [
        delayAnnouncement
    ]);
    var onFocusAnalytics = (0, $7d6daf9bcf6c0b57$export$a4687b0234b40e28)($dded6e092963b70b$var$_objectSpread({
        fn: onFocus,
        action: 'focused',
        analyticsData: analyticsContext
    }, $dded6e092963b70b$var$analyticsAttributes));
    var onBlurAnalytics = (0, $7d6daf9bcf6c0b57$export$a4687b0234b40e28)($dded6e092963b70b$var$_objectSpread({
        fn: onBlur,
        action: 'blurred',
        analyticsData: analyticsContext
    }, $dded6e092963b70b$var$analyticsAttributes));
    var autoDismissProps = {
        onMouseOver: onMouseOver,
        onFocus: onFocusAnalytics,
        onMouseOut: onMouseOut,
        onBlur: onBlurAnalytics
    };
    var textColor = (0, $73882095ac86360f$export$f50075b2584087f)[appearance];
    var iconColor = (0, $0a19d60b13e87e43$export$7f70afe2167f8235)[appearance];
    var iconGlyph = (0, $23a4e5dfdf5f7eea$export$73f08aee70487cd4)[appearance];
    var isDismissable = isBold || isDismissAllowed;
    var shouldRenderGap = !isBold && (description || actions.length) || isExpanded;
    // when delayAnnouncement is available we will use a hidden content for announcement
    var delayedAnnouncement = delayAnnouncement ? /*#__PURE__*/ $5FkrB.createElement((0, $a4a1a9cdc7bf2d54$export$2e2bcd8739ae039), null, title, description) : undefined;
    // A11y improvement opportunity: all flags currently use role="alert" (assertive),
    // but non-critical flags (e.g. info, success) should use role="status" (polite)
    // to avoid interrupting screen reader users. See WCAG 4.1.3.
    return /*#__PURE__*/ $5FkrB.createElement("div", (0, $ba40bdae9bf99a27$export$2e2bcd8739ae039)({
        role: "alert",
        "data-testid": testId
    }, autoDismissProps, {
        className: (0, $ceTz3.default)([
            "_1bsb1osq"
        ])
    }), /*#__PURE__*/ $5FkrB.createElement((0, $7a49b1df02a75aca$export$e71c4d32a2263218), {
        padding: "space.200",
        backgroundColor: (0, $5d66367ea54dc41e$export$59e42969c95d314)[appearance],
        xcss: $dded6e092963b70b$var$styles.flag
    }, /*#__PURE__*/ $5FkrB.createElement((0, $04267de539304abd$export$fbae5b5ffd8af05e), {
        alignBlock: "start",
        space: "space.200"
    }, /*#__PURE__*/ $5FkrB.createElement("div", {
        "data-testid": testId && "".concat(testId, "-icon-container"),
        className: (0, $ceTz3.default)([
            "_1e0c1txw _1ul91tcg _1tke1tcg _4cvr1h6o _1bah1h6o _1o9zidpf _syaz16r9"
        ]),
        style: $dded6e092963b70b$var$_objectSpread($dded6e092963b70b$var$_objectSpread({}, (0, $a9b664628fc883d8$export$2e2bcd8739ae039)({}, $dded6e092963b70b$var$CSS_VAR_ICON_COLOR, iconColor)), {}, {
            "--_11v68d2": (0, $be5c14d9948a25d1$export$2e2bcd8739ae039)("var(".concat($dded6e092963b70b$var$CSS_VAR_ICON_COLOR, ")"))
        })
    }, icon || iconGlyph), /*#__PURE__*/ $5FkrB.createElement("span", {
        className: (0, $ceTz3.default)([
            "_v5641hdc _1ul9idpf _16jlkb7n"
        ])
    }, /*#__PURE__*/ $5FkrB.createElement((0, $70988de881688cbc$export$694e0d28c7ffc90c), {
        space: shouldRenderGap ? 'space.100' : 'space.0' // Gap exists even when not expanded due to Expander internals always being in the DOM
    }, isDelayToAnnounce && delayedAnnouncement, /*#__PURE__*/ $5FkrB.createElement((0, $04267de539304abd$export$fbae5b5ffd8af05e), {
        alignBlock: "stretch",
        space: "space.100",
        spread: "space-between"
    }, /*#__PURE__*/ $5FkrB.createElement((0, $7a49b1df02a75aca$export$e71c4d32a2263218), {
        paddingBlockStart: "space.050",
        paddingBlockEnd: "space.025",
        xcss: $dded6e092963b70b$var$styles.overflowWrap
    }, /*#__PURE__*/ $5FkrB.createElement((0, $82315a19372f332f$export$2e2bcd8739ae039), {
        as: "h".concat(headingLevel),
        size: "xsmall",
        color: textColor
    }, /*#__PURE__*/ $5FkrB.createElement("span", {
        /* if isDelayToAnnounce is true, we will hide the content form screen reader to avoid duplicate announcement */ "aria-hidden": isDelayToAnnounce
    }, title))), isDismissable ? !(isBold && !description && !actions.length) && /*#__PURE__*/ $5FkrB.createElement((0, $51873c5421c1a0b2$export$2e2bcd8739ae039), {
        testId: testId,
        appearance: appearance,
        isBold: isBold,
        isExpanded: isExpanded,
        onClick: isBold ? toggleExpand : buttonActionCallback
    }) : null), /*#__PURE__*/ $5FkrB.createElement((0, $6ccef00473d223b2$export$2e2bcd8739ae039), {
        isExpanded: !isBold || isExpanded,
        testId: testId
    }, description && /*#__PURE__*/ $5FkrB.createElement("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        style: {
            color: (0, $a75ec366da06ccaa$export$13b42cd9d596bfe0)[appearance]
        },
        "data-testid": testId && "".concat(testId, "-description"),
        "aria-hidden": isDelayToAnnounce,
        className: (0, $ceTz3.default)([
            "_11c8fhey _1reo1wug _18m91wug _c71l53f4 _1i4qfg65"
        ])
    }, description), /*#__PURE__*/ $5FkrB.createElement((0, $de475bb7041a7e09$export$2e2bcd8739ae039), {
        actions: actions,
        appearance: appearance,
        linkComponent: linkComponent,
        testId: testId
    })))))));
};
var $dded6e092963b70b$export$2e2bcd8739ae039 = $dded6e092963b70b$var$Flag;





var $51cda659fee75760$exports = {};
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::fd264112f4a6872d04b33e03dd95c892>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty($51cda659fee75760$exports, "__esModule", {
    value: true
});
$51cda659fee75760$exports.default = void 0;

var $51cda659fee75760$var$_react = $51cda659fee75760$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $51cda659fee75760$var$_iconNew = $51cda659fee75760$var$_interopRequireDefault((parcelRequire("gDzom")));
function $51cda659fee75760$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ChevronUp".
 * Category: multi-purpose
 * Location: @atlaskit/icon/core/chevron-up
 * Usage guidance:
 * Do not use 16px chevrons within buttons, icon buttons, or dropdowns to maintain visual cohesion with ADS which uses 12px chevrons.
 * Known uses: Close dropdown menu
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $51cda659fee75760$var$ChevronUpIcon = (props)=>/*#__PURE__*/ $51cda659fee75760$var$_react.default.createElement($51cda659fee75760$var$_iconNew.default, Object.assign({
        name: "ChevronUpIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="m14.53 9.97-6-6a.75.75 0 0 0-1.004-.052l-.056.052-6 6 1.06 1.06L8 5.56l5.47 5.47z"/>`
    }, props));
$51cda659fee75760$var$ChevronUpIcon.displayName = 'ChevronUpIcon';
var $51cda659fee75760$var$_default = $51cda659fee75760$exports.default = $51cda659fee75760$var$ChevronUpIcon;


var $37990044355ecd18$exports = {};
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d87c4cc25467bfae682c37c89450e49c>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty($37990044355ecd18$exports, "__esModule", {
    value: true
});
$37990044355ecd18$exports.default = void 0;

var $37990044355ecd18$var$_react = $37990044355ecd18$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $37990044355ecd18$var$_iconNew = $37990044355ecd18$var$_interopRequireDefault((parcelRequire("gDzom")));
function $37990044355ecd18$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Information".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/information
 * Usage guidance:
 * Reserved for information statuses and messaging.
 * Filled status icons provide higher visual contrast to draw attention to important information.
 * For information tooltips, use the unfilled 'information circle' icon.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $37990044355ecd18$var$InformationIcon = (props)=>/*#__PURE__*/ $37990044355ecd18$var$_react.default.createElement($37990044355ecd18$var$_iconNew.default, Object.assign({
        name: "InformationIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8m6.5-1.25H8a.75.75 0 0 1 .75.75v5h-1.5V8.25H6.5zM8 5.5a1 1 0 1 0 0-2 1 1 0 0 0 0 2" clip-rule="evenodd"/>`
    }, props));
$37990044355ecd18$var$InformationIcon.displayName = 'InformationIcon';
var $37990044355ecd18$var$_default = $37990044355ecd18$exports.default = $37990044355ecd18$var$InformationIcon;


/* lozenge.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $5FkrB = parcelRequire("5FkrB");

/* lozenge-base.tsx generated by @compiled/babel-plugin v2.0.0 */ function $0a31c80ae20f8513$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $0a31c80ae20f8513$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $0a31c80ae20f8513$export$2e2bcd8739ae039(o);
}



function $c076cf0c057ebe07$export$2e2bcd8739ae039(t, r) {
    if ("object" != (0, $0a31c80ae20f8513$export$2e2bcd8739ae039)(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (0, $0a31c80ae20f8513$export$2e2bcd8739ae039)(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}


function $95064a73d7b48fe7$export$2e2bcd8739ae039(t) {
    var i = (0, $c076cf0c057ebe07$export$2e2bcd8739ae039)(t, "string");
    return "symbol" == (0, $0a31c80ae20f8513$export$2e2bcd8739ae039)(i) ? i : i + "";
}


function $75d779bd85ea9c86$export$2e2bcd8739ae039(e, r, t) {
    return (r = (0, $95064a73d7b48fe7$export$2e2bcd8739ae039)(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}


function $e74e5963bd72a016$export$2e2bcd8739ae039() {
    return $e74e5963bd72a016$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $e74e5963bd72a016$export$2e2bcd8739ae039.apply(null, arguments);
}


function $f95ad898abb2b85f$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return r;
}


function $8a1995f6622d8ed1$export$2e2bcd8739ae039(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}


function $e72dfcf13b86a9b7$export$2e2bcd8739ae039(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}


function $55ee835a067a15a7$export$2e2bcd8739ae039(r, a) {
    if (r) {
        if ("string" == typeof r) return (0, $e72dfcf13b86a9b7$export$2e2bcd8739ae039)(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? (0, $e72dfcf13b86a9b7$export$2e2bcd8739ae039)(r, a) : void 0;
    }
}


function $8e3cde549a5ce16f$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}


function $78cd3f201970b824$export$2e2bcd8739ae039(r, e) {
    return (0, $f95ad898abb2b85f$export$2e2bcd8739ae039)(r) || (0, $8a1995f6622d8ed1$export$2e2bcd8739ae039)(r, e) || (0, $55ee835a067a15a7$export$2e2bcd8739ae039)(r, e) || (0, $8e3cde549a5ce16f$export$2e2bcd8739ae039)();
}



var $5FkrB = parcelRequire("5FkrB");

var $3KUKI = parcelRequire("3KUKI");
/* badge-new.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $5FkrB = parcelRequire("5FkrB");
/**
 * The length of the value hash portion of an atomic class name.
 * Atomic class names have the format: `_<group><value>`
 * where group is ATOMIC_GROUP_HASH_LENGTH chars and value is ATOMIC_VALUE_HASH_LENGTH chars.
 *
 * We extract the group key using: `className.slice(0, className.length - ATOMIC_VALUE_HASH_LENGTH)`
 *
 * We support both old-format classes (9 chars: `_` + 4 group + 4 value) and
 * new-format classes (11 chars: `_` + 6 group + 4 value) by using length-based
 * extraction rather than a hardcoded offset — old and new format group keys
 * are different lengths so they are structurally disjoint and never alias each other.
 */ const $b4a1893327b4f5fe$var$ATOMIC_VALUE_HASH_LENGTH = 4;
function $b4a1893327b4f5fe$export$2e2bcd8739ae039(classNames) {
    // Shortcut: nothing to do
    if (!classNames.length) return;
    // Shortcut: don't need to do anything if we only have a single classname
    if (classNames.length === 1 && classNames[0] && // checking to see if `classNames[0]` is a string that contains other classnames
    !classNames[0].includes(' ')) return classNames[0];
    // Using an object rather than a `Map` as it performed better in our benchmarks.
    // Would be happy to move to `Map` if it proved to be better under real conditions.
    const map = {};
    // Note: using loops to minimize iterations over the collection
    for (const value of classNames){
        // Exclude all falsy values, which leaves us with populated strings
        if (!value) continue;
        // a `value` can contain multiple classnames
        const list = value.split(' ');
        for (const className of list){
            /**
             * For atomic style classnames: the `key` is the `group`
             *
             * - Later atomic classnames with the same `group` will override earlier ones
             *   (which is what we want).
             * - Assumes atomic classnames are the only things that start with `_`
             * - Could use a regex to ensure that atomic classnames are structured how we expect,
             *   but did not add that for now as it did slow things down a bit.
             *
             * For other classnames: the `key` is the whole classname
             * - Okay to remove duplicates as doing so does not impact specificity
             *
             * */ const key = className.startsWith('_') ? className.slice(0, className.length - $b4a1893327b4f5fe$var$ATOMIC_VALUE_HASH_LENGTH) : className;
            map[key] = className;
        }
    }
    /**
     * We are converting the `map` into a string.
     *
     * The simple way to do this would be `Object.values(map).join(' ')`.
     * However, the approach below performs 10%-20% better in benchmarks.
     *
     * For `ax()` it feels right to squeeze as much runtime performance out as we can.
     */ let result = '';
    for(const key in map)result += map[key] + ' ';
    // If we have an empty string, then our `map` was empty.
    if (!result) return;
    // remove last " " from the result (we added " " at the end of every value)
    return result.trimEnd();
}



function $6313cf31cbab2d8e$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return r;
}


function $474a6c325bedecd4$export$2e2bcd8739ae039(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}


function $fbc3d2893ec08ccb$export$2e2bcd8739ae039(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}


function $9333a79af784f3ba$export$2e2bcd8739ae039(r, a) {
    if (r) {
        if ("string" == typeof r) return (0, $fbc3d2893ec08ccb$export$2e2bcd8739ae039)(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? (0, $fbc3d2893ec08ccb$export$2e2bcd8739ae039)(r, a) : void 0;
    }
}


function $7c865ca16c39ff61$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}


function $df73e3e737d205ba$export$2e2bcd8739ae039(r, e) {
    return (0, $6313cf31cbab2d8e$export$2e2bcd8739ae039)(r) || (0, $474a6c325bedecd4$export$2e2bcd8739ae039)(r, e) || (0, $9333a79af784f3ba$export$2e2bcd8739ae039)(r, e) || (0, $7c865ca16c39ff61$export$2e2bcd8739ae039)();
}



var $5FkrB = parcelRequire("5FkrB");
function $286c8ce7568912ce$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $286c8ce7568912ce$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $286c8ce7568912ce$export$2e2bcd8739ae039(o);
}



function $3462d67e5357bbef$export$2e2bcd8739ae039(t, r) {
    if ("object" != (0, $286c8ce7568912ce$export$2e2bcd8739ae039)(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (0, $286c8ce7568912ce$export$2e2bcd8739ae039)(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}


function $30f340f4d628997f$export$2e2bcd8739ae039(t) {
    var i = (0, $3462d67e5357bbef$export$2e2bcd8739ae039)(t, "string");
    return "symbol" == (0, $286c8ce7568912ce$export$2e2bcd8739ae039)(i) ? i : i + "";
}


function $b651461f1779280c$export$2e2bcd8739ae039(e, r, t) {
    return (r = (0, $30f340f4d628997f$export$2e2bcd8739ae039)(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}


var $cdac5406f56ce43a$export$4ef52930e33717cd = 'data-theme';
var $cdac5406f56ce43a$export$cb374d25ded7f6ab = 'data-subtree-theme';
var $cdac5406f56ce43a$export$a00eac3f8684bcd0 = 'data-color-mode';
var $cdac5406f56ce43a$export$2112803007239c61 = 'data-contrast-mode';
var $cdac5406f56ce43a$export$352e418ed5b6193a = 'data-custom-theme';
var $cdac5406f56ce43a$export$6f0c6fb8c80fcc92 = 'ds';
var $cdac5406f56ce43a$export$4d0c7bbf80185957 = [
    'opacity',
    'font',
    'space',
    'border',
    'radius'
];
var $cdac5406f56ce43a$export$dddac1532e822863 = "--".concat($cdac5406f56ce43a$export$6f0c6fb8c80fcc92, "-token-not-found");
var $cdac5406f56ce43a$export$9d7b58831ae93caa = "--".concat($cdac5406f56ce43a$export$6f0c6fb8c80fcc92, "-elevation-surface-current");


/**
 * Theme modes: The general purpose of a theme.
 * This attr is used to apply the appropriate system-preference option
 * It may also be used as a selector for mode-specific overrides such as light/dark images.
 * The idea is there may exist many color themes, but every theme must either fit into light or dark.
 */ var $b618ae213ded1369$export$83993de8eb66733 = [
    'light',
    'dark',
    'auto'
];


var $ab42aa0588c69866$export$fcfb1976c88f9f75 = function isThemeColorMode(colorMode) {
    return (0, $b618ae213ded1369$export$83993de8eb66733).find(function(mode) {
        return mode === colorMode;
    }) !== undefined;
};



var $d5bb2abaafb9f311$export$4a14e169b1de4ee7 = function isColorMode(modeId) {
    return [
        'light',
        'dark',
        'auto'
    ].includes(modeId);
};


/**
 * Theme ids: The value that will be mounted to the DOM as a data attr
 * For example: `data-theme="light:light dark:dark spacing:spacing"
 *
 * These ids must be kebab case
 */ var $6aa4e94230a362b0$export$7d43e72a58e3283f = [
    'light-increased-contrast',
    'light',
    'light-future',
    'dark',
    'dark-future',
    'dark-increased-contrast',
    'spacing',
    'shape',
    'typography',
    'motion'
];


var $69e8c9d3b2a47338$export$ea35b8958c39dd07 = function isThemeIds(themeId) {
    return (0, $6aa4e94230a362b0$export$7d43e72a58e3283f).find(function(id) {
        return id === themeId;
    }) !== undefined;
};


var $e6837b7380834933$var$themeKinds = [
    'light',
    'dark',
    'spacing',
    'typography',
    'shape',
    'motion'
];
var $e6837b7380834933$export$958fa026be3a263e = function isThemeKind(themeKind) {
    return $e6837b7380834933$var$themeKinds.find(function(kind) {
        return kind === themeKind;
    }) !== undefined;
};


var $1f3645e5d1eba508$var$customThemeOptions = 'UNSAFE_themeOptions';
var $1f3645e5d1eba508$export$f19b488f7c0547ee = function themeStringToObject(themeState) {
    return themeState.split(' ').map(function(theme) {
        return theme.split(/:([^]*)/);
    }).reduce(function(themeObject, _ref) {
        var _ref2 = (0, $df73e3e737d205ba$export$2e2bcd8739ae039)(_ref, 2), kind = _ref2[0], id = _ref2[1];
        if (kind === 'colorMode' && (0, $d5bb2abaafb9f311$export$4a14e169b1de4ee7)(id)) themeObject[kind] = id;
        if ((0, $e6837b7380834933$export$958fa026be3a263e)(kind) && (0, $69e8c9d3b2a47338$export$ea35b8958c39dd07)(id)) // @ts-expect-error FIXME - this is a valid ts error
        themeObject[kind] = id;
        if (kind === $1f3645e5d1eba508$var$customThemeOptions) try {
            themeObject[$1f3645e5d1eba508$var$customThemeOptions] = JSON.parse(id);
        } catch (_unused) {
            new Error('Invalid custom theme string');
        }
        return themeObject;
    }, {});
};


function $190213e70a1def0b$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $190213e70a1def0b$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $190213e70a1def0b$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $b651461f1779280c$export$2e2bcd8739ae039)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $190213e70a1def0b$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $190213e70a1def0b$export$813ecdf77207a053 = function getGlobalTheme() {
    if (typeof document === 'undefined') return {};
    var element = document.documentElement;
    var colorMode = element.getAttribute((0, $cdac5406f56ce43a$export$a00eac3f8684bcd0)) || '';
    var theme = element.getAttribute((0, $cdac5406f56ce43a$export$4ef52930e33717cd)) || '';
    return $190213e70a1def0b$var$_objectSpread($190213e70a1def0b$var$_objectSpread({}, (0, $1f3645e5d1eba508$export$f19b488f7c0547ee)(theme)), (0, $ab42aa0588c69866$export$fcfb1976c88f9f75)(colorMode) && {
        colorMode: colorMode
    });
};


function $d0203b934b1d411c$export$2e2bcd8739ae039(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}



function $d7bc55e8204d3b3e$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, (0, $30f340f4d628997f$export$2e2bcd8739ae039)(o.key), o);
    }
}
function $d7bc55e8204d3b3e$export$2e2bcd8739ae039(e, r, t) {
    return r && $d7bc55e8204d3b3e$var$_defineProperties(e.prototype, r), t && $d7bc55e8204d3b3e$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}





var $7ee671b3f95a4454$export$b741a7c3bcb1c635 = /*#__PURE__*/ function() {
    function ThemeMutationObserver(callback) {
        (0, $d0203b934b1d411c$export$2e2bcd8739ae039)(this, ThemeMutationObserver);
        (0, $b651461f1779280c$export$2e2bcd8739ae039)(this, "legacyObserver", null);
        this.callback = callback;
        ThemeMutationObserver.callbacks.add(callback);
    }
    return (0, $d7bc55e8204d3b3e$export$2e2bcd8739ae039)(ThemeMutationObserver, [
        {
            key: "observe",
            value: function observe() {
                if (!ThemeMutationObserver.observer) {
                    ThemeMutationObserver.observer = new MutationObserver(function() {
                        var theme = (0, $190213e70a1def0b$export$813ecdf77207a053)();
                        ThemeMutationObserver.callbacks.forEach(function(callback) {
                            return callback(theme);
                        });
                    });
                    // Observer only needs to be configured once
                    ThemeMutationObserver.observer.observe(document.documentElement, {
                        attributeFilter: [
                            (0, $cdac5406f56ce43a$export$4ef52930e33717cd),
                            (0, $cdac5406f56ce43a$export$a00eac3f8684bcd0)
                        ]
                    });
                }
            }
        },
        {
            key: "disconnect",
            value: function disconnect() {
                if (this.callback) ThemeMutationObserver.callbacks.delete(this.callback);
                if (ThemeMutationObserver.callbacks.size === 0 && ThemeMutationObserver.observer) {
                    ThemeMutationObserver.observer.disconnect();
                    ThemeMutationObserver.observer = null;
                }
            }
        }
    ]);
}();
(0, $b651461f1779280c$export$2e2bcd8739ae039)($7ee671b3f95a4454$export$b741a7c3bcb1c635, "observer", null);
(0, $b651461f1779280c$export$2e2bcd8739ae039)($7ee671b3f95a4454$export$b741a7c3bcb1c635, "callbacks", new Set());
var $7ee671b3f95a4454$export$2e2bcd8739ae039 = $7ee671b3f95a4454$export$b741a7c3bcb1c635;


var $97f376c96e350a96$export$3dd7971102e44fa8 = function useThemeObserver() {
    var _useState = (0, $5FkrB.useState)((0, $190213e70a1def0b$export$813ecdf77207a053)()), _useState2 = (0, $df73e3e737d205ba$export$2e2bcd8739ae039)(_useState, 2), theme = _useState2[0], setTheme = _useState2[1];
    (0, $5FkrB.useEffect)(function() {
        var observer = new (0, $7ee671b3f95a4454$export$2e2bcd8739ae039)(function(theme) {
            return setTheme(theme);
        });
        observer.observe();
        return function() {
            return observer.disconnect();
        };
    }, []);
    return theme;
};
var $97f376c96e350a96$export$2e2bcd8739ae039 = $97f376c96e350a96$export$3dd7971102e44fa8;


function $7365b71a3b911fbf$var$getSafeValue() {
    var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    var numericValue = +value;
    if (numericValue < 0) return 0;
    return value;
}
function $7365b71a3b911fbf$export$7c4d25c0c3217d8c(value, max) {
    var safeValue = $7365b71a3b911fbf$var$getSafeValue(value);
    var safeMax = $7365b71a3b911fbf$var$getSafeValue(max);
    if (safeMax && safeMax < safeValue) return "".concat(safeMax, "+");
    if (safeValue === Infinity) return "\u221E";
    return safeValue.toString();
}


/* eslint-disable @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors */ // Nested selectors with data attributes are required for theme switching
var $0da488f75a4043f8$var$stylesNew = {
    root: "_2rkolb4i _18zr1b66 _1rjcidpf _1e0c116y _vchhusvi _1ul91ejb _1bah1h6o _1o9zidpf _1kz6184x",
    success: "_syaz1p1e _bfhk14j0",
    danger: "_syaz1blx _bfhk18wg",
    warning: "_syazmgs1 _bfhk10f4",
    information: "_syaz1qd9 _bfhk8lbg",
    discovery: "_syaz1g72 _bfhke670",
    neutral: "_syazi7uo _bfhk7qp0",
    inverse: "_bfhkvuon _syazi7uo",
    informationBold: "_syaz1qd9 _bfhk9pm7",
    successBold: "_syaz1p1e _bfhk16ib",
    dangerBold: "_syaz1blx _bfhkud63",
    warningBold: "_syazmgs1 _bfhk1kmu",
    warningBoldDark: "_syazmgs1 _bfhkgj02",
    discoveryBold: "_syaz1g72 _bfhk5ly7"
};
/* eslint-enable @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors */ var $0da488f75a4043f8$var$badgeValueWithNegativeNumberSupported = function badgeValueWithNegativeNumberSupported(children, max) {
    return typeof children === 'number' && max ? (0, $7365b71a3b911fbf$export$7c4d25c0c3217d8c)(children, max) : children;
};
/**
 * __BadgeNew__
 *
 * New visual refresh implementation of Badge component for the labelling system.
 * This component is used when the 'platform-dst-lozenge-tag-badge-visual-uplifts' feature flag is enabled.
 *
 * Uses new appearance naming convention:
 * - success (green)
 * - danger (red)
 * - neutral (gray)
 * - information (blue)
 * - inverse (inverted colors)
 * - warning (orange/yellow)
 * - discovery (purple)
 * - informationBold (bold blue, color.background.information.subtle)
 * - successBold (bold green, color.background.success.subtle)
 * - dangerBold (bold red, color.background.danger.subtle)
 * - warningBold (bold warning, color.background.warning.bold)
 * - discoveryBold (bold purple, color.background.discovery.subtle)
 */ var $0da488f75a4043f8$var$BadgeNew = /*#__PURE__*/ (0, $5FkrB.memo)(function BadgeNew(_ref) {
    var _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'neutral' : _ref$appearance, _ref$children = _ref.children, children = _ref$children === void 0 ? 0 : _ref$children, _ref$max = _ref.max, max = _ref$max === void 0 ? 99 : _ref$max, style = _ref.style, testId = _ref.testId;
    var _useThemeObserver = (0, $97f376c96e350a96$export$3dd7971102e44fa8)(), colorMode = _useThemeObserver.colorMode;
    // In dark theme, warningBold needs to swap to a lighter background
    // (color.background.warning.subtle / Orange800) for better contrast against
    // the typical dark surface colors.
    var resolvedAppearance = appearance === 'warningBold' && colorMode === 'dark' ? 'warningBoldDark' : appearance;
    return /*#__PURE__*/ $5FkrB.createElement("span", {
        "data-testid": testId,
        style: {
            background: style === null || style === void 0 ? void 0 : style.backgroundColor,
            color: style === null || style === void 0 ? void 0 : style.color
        },
        className: (0, $b4a1893327b4f5fe$export$2e2bcd8739ae039)([
            $0da488f75a4043f8$var$stylesNew.root,
            $0da488f75a4043f8$var$stylesNew[resolvedAppearance]
        ])
    }, /*#__PURE__*/ $5FkrB.createElement((0, $5209c25cc099adfe$export$5f1af8db9871e1d6), {
        size: "small",
        align: "center",
        color: "inherit"
    }, $0da488f75a4043f8$var$badgeValueWithNegativeNumberSupported(children, max)));
});
var $0da488f75a4043f8$export$2e2bcd8739ae039 = $0da488f75a4043f8$var$BadgeNew;



var $e40a736c4c08093d$exports = {};
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6af69c0da1151808644d1b7c1f4d031c>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty($e40a736c4c08093d$exports, "__esModule", {
    value: true
});
$e40a736c4c08093d$exports.default = void 0;

var $e40a736c4c08093d$var$_react = $e40a736c4c08093d$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $e40a736c4c08093d$var$_baseNew = $e40a736c4c08093d$var$_interopRequireDefault((parcelRequire("4kNYI")));
function $e40a736c4c08093d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ChevronDown".
 * Category: multi-purpose
 * Location: @atlaskit/icon/core/chevron-down
 * Usage guidance:
 * Do not use 16px chevrons within buttons, icon buttons, or dropdowns to maintain visual cohesion with ADS which uses 12px chevrons.
 * Known uses: Open dropdown menu, expanded tree item, collapse tree item
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $e40a736c4c08093d$var$ChevronDownIcon = (props)=>/*#__PURE__*/ $e40a736c4c08093d$var$_react.default.createElement($e40a736c4c08093d$var$_baseNew.default, Object.assign({
        name: "ChevronDownIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="m14.53 6.03-6 6a.75.75 0 0 1-1.004.052l-.056-.052-6-6 1.06-1.06L8 10.44l5.47-5.47z"/>`
    }, props));
$e40a736c4c08093d$var$ChevronDownIcon.displayName = 'ChevronDownIcon';
var $e40a736c4c08093d$var$_default = $e40a736c4c08093d$exports.default = $e40a736c4c08093d$var$ChevronDownIcon;




var $5FkrB = parcelRequire("5FkrB");


var $5FkrB = parcelRequire("5FkrB");
var $addcccba53dac043$export$ff879f35a69d56b7 = function useElementRef() {
    var elementRef = (0, $5FkrB.useRef)(null);
    var setRef = (0, $5FkrB.useCallback)(function(ref) {
        elementRef.current = ref;
    }, []);
    return [
        elementRef.current,
        setRef
    ];
};




var $5FkrB = parcelRequire("5FkrB");
var $8d3df77d4b5248cd$var$getHookDeps = function getHookDeps(opts) {
    switch(opts.cleanup){
        case 'next-effect':
            return undefined;
        case 'unmount':
        default:
            return [];
    }
};
var $8d3df77d4b5248cd$export$1775f27e7c8051ca = function useRequestAnimationFrame() {
    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        cleanup: 'unmount'
    };
    var frames = (0, $5FkrB.useRef)([]);
    (0, $5FkrB.useEffect)(function() {
        return function() {
            if (frames.current.length) {
                frames.current.forEach(function(id) {
                    return cancelAnimationFrame(id);
                });
                frames.current = [];
            }
        };
    // We dynamically set this so we either clean up on the next effect - or on unmount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, $8d3df77d4b5248cd$var$getHookDeps(opts));
    return (0, $5FkrB.useCallback)(function(handler) {
        var id = requestAnimationFrame(function(time) {
            frames.current = frames.current.filter(function(frameId) {
                return frameId !== id;
            });
            handler(time);
        });
        frames.current.push(id);
    }, []);
};




var $5FkrB = parcelRequire("5FkrB");

var $23ee8466bd1a5787$export$9e95200239cd148b = function useSnapshotBeforeUpdate(cb) {
    var isFirstRender = (0, $5FkrB.useRef)(true);
    if (!isFirstRender.current) cb();
    (0, $3451ac6466de4e7e$export$e5c5a5f917a5871c)(function() {
        isFirstRender.current = false;
    }, []);
};


/**
 * Which dimension(s) of the element to animate.
 *
 * - `'width'` animates only width changes.
 * - `'height'` animates only height changes.
 * - `'both'` animates width and height changes simultaneously.
 */ /**
 * Parses a CSS time value (e.g. `"0.2s"` or `"200ms"`) and returns milliseconds.
 * Falls back to 0 if the value cannot be parsed.
 */ function $d60c798b82ceddb9$var$parseCSSTimeToMs(value) {
    var parsed = parseFloat(value);
    if (Number.isNaN(parsed)) return 0;
    if (value.endsWith('ms')) return parsed;
    return parsed * 1000;
}
/**
 * Returns `true` if any of the dimension(s) being animated have changed
 * between the previous and next measurements.
 */ function $d60c798b82ceddb9$var$hasDimensionChanged(dimension, prev, next) {
    if (dimension === 'width') return prev.width !== next.width;
    if (dimension === 'height') return prev.height !== next.height;
    return prev.width !== next.width || prev.height !== next.height;
}
/**
 * Returns the CSS `transition-property` / `will-change` value for the
 * given dimension(s).
 */ function $d60c798b82ceddb9$var$getDimensionPropertyList(dimension) {
    if (dimension === 'both') return 'width, height';
    return dimension;
}
var $d60c798b82ceddb9$export$a300664a1a230956 = function useResizing(_ref) {
    var dimension = _ref.dimension, duration = _ref.duration, easing = _ref.easing, onFinishMotion = _ref.onFinishMotion;
    var prevDimensions = (0, $5FkrB.useRef)();
    var _useElementRef = (0, $addcccba53dac043$export$ff879f35a69d56b7)(), _useElementRef2 = (0, $b0c829b9b1926339$export$2e2bcd8739ae039)(_useElementRef, 2), element = _useElementRef2[0], setElementRef = _useElementRef2[1];
    var setTimeout = (0, $6c96e52e57c436a4$export$4f34107a2b00f39c)({
        cleanup: 'next-effect'
    });
    var requestAnimationFrame = (0, $8d3df77d4b5248cd$export$1775f27e7c8051ca)();
    (0, $23ee8466bd1a5787$export$9e95200239cd148b)(function() {
        if ((0, $c13dcba1845ee9f2$export$b7baf7667a68d87c)() || !element) return;
        var rect = element.getBoundingClientRect();
        prevDimensions.current = {
            width: rect.width,
            height: rect.height
        };
    });
    (0, $3451ac6466de4e7e$export$e5c5a5f917a5871c)(function() {
        if ((0, $c13dcba1845ee9f2$export$b7baf7667a68d87c)() || !element || !prevDimensions.current) return;
        // We might already be animating.
        // Because of that we need to expand to the destination dimensions first.
        element.setAttribute('style', '');
        var rect = element.getBoundingClientRect();
        var nextDimensions = {
            width: rect.width,
            height: rect.height
        };
        if (!$d60c798b82ceddb9$var$hasDimensionChanged(dimension, prevDimensions.current, nextDimensions)) {
            onFinishMotion === null || onFinishMotion === void 0 || onFinishMotion();
            return;
        }
        var propertyList = $d60c798b82ceddb9$var$getDimensionPropertyList(dimension);
        var newStyles = {
            willChange: propertyList,
            transitionProperty: propertyList,
            transitionDuration: duration,
            boxSizing: 'border-box',
            transitionTimingFunction: easing
        };
        if (dimension === 'width' || dimension === 'both') newStyles.width = "".concat(prevDimensions.current.width, "px");
        if (dimension === 'height' || dimension === 'both') newStyles.height = "".concat(prevDimensions.current.height, "px");
        Object.assign(element.style, newStyles);
        var resolvedDuration = $d60c798b82ceddb9$var$parseCSSTimeToMs(getComputedStyle(element).transitionDuration);
        // We split this over two animation frames so the DOM has enough time to flush the changes.
        // We are deliberately not skipping this frame if another render happens - if we do the motion doesn't finish properly.
        requestAnimationFrame(function() {
            requestAnimationFrame(function() {
                if (!element) return;
                if (dimension === 'width' || dimension === 'both') element.style.width = "".concat(nextDimensions.width, "px");
                if (dimension === 'height' || dimension === 'both') element.style.height = "".concat(nextDimensions.height, "px");
                setTimeout(function() {
                    if (!element) return;
                    element.setAttribute('style', '');
                    onFinishMotion === null || onFinishMotion === void 0 || onFinishMotion();
                }, resolvedDuration);
            });
        });
    });
    return {
        ref: setElementRef
    };
};



var $50U6m = parcelRequire("50U6m");




var $5FkrB = parcelRequire("5FkrB");

var $2nBsU = parcelRequire("2nBsU");





var $jPLJI = parcelRequire("jPLJI");

var $4FBpX = parcelRequire("4FBpX");



var $aWY4P = parcelRequire("aWY4P");
var $d4a7825669dd53f6$var$_excluded = [
    "children",
    "backgroundColor",
    "padding",
    "paddingBlock",
    "paddingBlockStart",
    "paddingBlockEnd",
    "paddingInline",
    "paddingInlineStart",
    "paddingInlineEnd",
    "isDisabled",
    "type",
    "onClick",
    "interactionName",
    "componentName",
    "analyticsContext",
    "style",
    "testId",
    "xcss"
], $d4a7825669dd53f6$var$_excluded2 = [
    "className"
];
// This duplicates FocusRing styles from `@atlaskit/focus-ring`.
var $d4a7825669dd53f6$var$focusRingStyles = (0, $2nBsU.css)({
    '&:focus, &:focus-visible': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        outlineColor: (0, $jPLJI.borderColorMap)['color.border.focused'],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        outlineOffset: (0, $aWY4P.positiveSpaceMap)['space.025'],
        outlineStyle: 'solid',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        outlineWidth: (0, $4FBpX.borderWidthMap)['border.width.focused']
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
    '&:focus:not(:focus-visible)': {
        outline: 'none'
    },
    '@media screen and (forced-colors: active), screen and (-ms-high-contrast: active)': {
        '&:focus-visible': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
            outline: "".concat((0, $4FBpX.borderWidthMap)['border.width'], " solid")
        }
    }
});
var $d4a7825669dd53f6$var$baseStyles = (0, $2nBsU.css)({
    boxSizing: 'border-box',
    appearance: 'none',
    border: 'none'
});
var $d4a7825669dd53f6$var$enabledStyles = (0, $2nBsU.css)({
    cursor: 'pointer'
});
var $d4a7825669dd53f6$var$disabledStyles = (0, $2nBsU.css)({
    cursor: 'not-allowed'
});
var $d4a7825669dd53f6$export$27c701ed9e449e99 = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function(_ref, ref) {
    var children = _ref.children, backgroundColor = _ref.backgroundColor, padding = _ref.padding, paddingBlock = _ref.paddingBlock, paddingBlockStart = _ref.paddingBlockStart, paddingBlockEnd = _ref.paddingBlockEnd, paddingInline = _ref.paddingInline, paddingInlineStart = _ref.paddingInlineStart, paddingInlineEnd = _ref.paddingInlineEnd, isDisabled = _ref.isDisabled, _ref$type = _ref.type, type = _ref$type === void 0 ? 'button' : _ref$type, _ref$onClick = _ref.onClick, providedOnClick = _ref$onClick === void 0 ? (0, $adcefb868cf2fc9d$export$2e2bcd8739ae039) : _ref$onClick, interactionName = _ref.interactionName, componentName = _ref.componentName, analyticsContext = _ref.analyticsContext, style = _ref.style, testId = _ref.testId, xcss = _ref.xcss, htmlAttributes = (0, $a9c67d4ab15fb282$export$2e2bcd8739ae039)(_ref, $d4a7825669dd53f6$var$_excluded);
    var interactionContext = (0, $5FkrB.useContext)((0, $d1efb683945e3992$export$2e2bcd8739ae039));
    var handleClick = (0, $5FkrB.useCallback)(function(e, analyticsEvent) {
        interactionContext && interactionContext.tracePress(interactionName, e.timeStamp);
        providedOnClick(e, analyticsEvent);
    }, [
        providedOnClick,
        interactionContext,
        interactionName
    ]);
    var onClick = (0, $7d6daf9bcf6c0b57$export$a4687b0234b40e28)({
        fn: handleClick,
        action: 'clicked',
        componentName: componentName || 'Pressable',
        packageName: "@atlaskit/primitives",
        packageVersion: "22.4.1",
        analyticsData: analyticsContext,
        actionSubject: 'button'
    });
    // This is to remove className from safeHtmlAttributes
    // @ts-expect-error className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    var _spreadClass = htmlAttributes.className, safeHtmlAttributes = (0, $a9c67d4ab15fb282$export$2e2bcd8739ae039)(htmlAttributes, $d4a7825669dd53f6$var$_excluded2);
    var resolvedStyles = (0, $516eb2651ecf48d7$export$a9c84988c8f81f2d)(xcss);
    return (0, $2nBsU.jsx)("button", (0, $a98c0fbb1cee895f$export$2e2bcd8739ae039)({
        style: style,
        ref: ref,
        className: resolvedStyles.static
    }, safeHtmlAttributes, {
        // eslint-disable-next-line react/button-has-type
        type: type,
        onClick: onClick,
        disabled: isDisabled,
        css: [
            $d4a7825669dd53f6$var$baseStyles,
            $d4a7825669dd53f6$var$focusRingStyles,
            isDisabled ? $d4a7825669dd53f6$var$disabledStyles : $d4a7825669dd53f6$var$enabledStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            backgroundColor && (0, $67ab31073ee582e2$export$e7af83bafe7f9e63)[backgroundColor],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            padding && (0, $57d9f58cb1b2d3e5$export$e615f061ca585a6c).padding[padding],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlock && (0, $57d9f58cb1b2d3e5$export$e615f061ca585a6c).paddingBlock[paddingBlock],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlockStart && (0, $57d9f58cb1b2d3e5$export$e615f061ca585a6c).paddingBlockStart[paddingBlockStart],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlockEnd && (0, $57d9f58cb1b2d3e5$export$e615f061ca585a6c).paddingBlockEnd[paddingBlockEnd],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInline && (0, $57d9f58cb1b2d3e5$export$e615f061ca585a6c).paddingInline[paddingInline],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInlineStart && (0, $57d9f58cb1b2d3e5$export$e615f061ca585a6c).paddingInlineStart[paddingInlineStart],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInlineEnd && (0, $57d9f58cb1b2d3e5$export$e615f061ca585a6c).paddingInlineEnd[paddingInlineEnd]
        ].concat((0, $05828ba174ac1fc0$export$2e2bcd8739ae039)(resolvedStyles.emotion || [])),
        "data-testid": testId
    }), children);
});
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$d4a7825669dd53f6$export$2e2bcd8739ae039 = $d4a7825669dd53f6$export$27c701ed9e449e99;



// extract the category and key from the resolved color
var $9c9175041946e684$export$a3fc04b8551e006a = function getThemeStyles(resolvedColor) {
    var isAccent = resolvedColor.startsWith('accent-');
    var category = isAccent ? 'accent' : 'semantic';
    var key = isAccent ? resolvedColor.replace('accent-', '') : resolvedColor;
    return {
        category: category,
        key: key
    };
};


/* icon-renderer.tsx generated by @compiled/babel-plugin v2.0.0 */ 

var $5FkrB = parcelRequire("5FkrB");

var $50U6m = parcelRequire("50U6m");

// Map lozenge colors to appropriate icon colors.
//
// We intentionally use `color.text.*.bolder` tokens for icons across all
// colored lozenges (semantic + accent). Text tokens use higher-stop palette
// values (Color700+) which pass 3:1 contrast against subtler backgrounds in
// every interactive state — including pressed where icon Color600 fails for
// most hues. Using text tokens uniformly:
//   - avoids global changes to the `color.icon.*` token ramps
//   - keeps icon and text visually aligned in the lozenge
//   - guarantees ≥3:1 contrast across default/hover/pressed states
//
// Neutral lozenges use `color.text.subtle` to match the neutral text styling
// and remain consistent with their alpha-based backgrounds.
var $0db2353ef35514f9$var$getIconColor = function getIconColor(color) {
    switch(color){
        // Semantic
        case 'success':
            return "var(--ds-text-success, #4C6B1F)";
        case 'warning':
            return "var(--ds-text-warning, #9E4C00)";
        case 'danger':
            return "var(--ds-text-danger, #AE2E24)";
        case 'information':
            return "var(--ds-text-information, #1558BC)";
        case 'discovery':
            return "var(--ds-text-discovery, #803FA5)";
        case 'neutral':
            return "var(--ds-text-subtle, #505258)";
        // Accent
        case 'accent-red':
            return "var(--ds-text-accent-red, #AE2E24)";
        case 'accent-orange':
            return "var(--ds-text-accent-orange, #9E4C00)";
        case 'accent-yellow':
            return "var(--ds-text-accent-yellow, #7F5F01)";
        case 'accent-lime':
            return "var(--ds-text-accent-lime, #4C6B1F)";
        case 'accent-green':
            return "var(--ds-text-accent-green, #216E4E)";
        case 'accent-teal':
            return "var(--ds-text-accent-teal, #206A83)";
        case 'accent-blue':
            return "var(--ds-text-accent-blue, #1558BC)";
        case 'accent-purple':
            return "var(--ds-text-accent-purple, #803FA5)";
        case 'accent-magenta':
            return "var(--ds-text-accent-magenta, #943D73)";
        case 'accent-gray':
            return "var(--ds-text-subtle, #505258)";
        default:
            return "var(--ds-text-subtle, #505258)";
    }
};
var $0db2353ef35514f9$var$styles = {
    motion: "_k8m01ylx _1oeci9qs _6fl41d08"
};
/**
 * Icon renderer for lozenge components
 * Handles proper sizing and color theming for icons
 */ var $0db2353ef35514f9$var$IconRenderer = function IconRenderer(_ref) {
    var Icon = _ref.icon, color = _ref.color, testId = _ref.testId, size = _ref.size;
    var iconColor = $0db2353ef35514f9$var$getIconColor(color);
    return (0, $50U6m.fg)('platform-dst-motion-uplift') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $7a49b1df02a75aca$export$e71c4d32a2263218), {
        xcss: $0db2353ef35514f9$var$styles.motion,
        style: {
            color: iconColor
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(Icon, {
        label: "",
        size: size,
        testId: testId
    })) : /*#__PURE__*/ // Cast required because the lozenge intentionally uses some
    // `color.text.*.bolder` tokens for icons that don't pass 3:1 contrast
    // at their default `color.icon.*` stop. The Icon component types only
    // accept `IconColor`, but text tokens are valid CSS color values and
    // render correctly at runtime.
    (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(Icon, {
        color: iconColor,
        label: "",
        size: size,
        testId: testId
    });
};
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$0db2353ef35514f9$export$2e2bcd8739ae039 = $0db2353ef35514f9$var$IconRenderer;


// Map legacy appearance to new color values
var $e4b3890ca43eeb4f$var$legacyAppearanceMap = {
    default: 'neutral',
    removed: 'danger',
    inprogress: 'information',
    new: 'discovery',
    moved: 'warning'
};
var $e4b3890ca43eeb4f$export$acf5d2b7dc999bda = function resolveLozengeColor() {
    var _legacyAppearanceMap$;
    var appearance = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'neutral';
    if (appearance.startsWith('accent-')) return appearance;
    return (_legacyAppearanceMap$ = $e4b3890ca43eeb4f$var$legacyAppearanceMap[appearance]) !== null && _legacyAppearanceMap$ !== void 0 ? _legacyAppearanceMap$ : appearance;
};


function $8c4045cfee3ec217$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $8c4045cfee3ec217$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $8c4045cfee3ec217$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $75d779bd85ea9c86$export$2e2bcd8739ae039)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $8c4045cfee3ec217$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
// Get the pressed background color for the selected lozenge dropdown trigger
var $8c4045cfee3ec217$var$pressedBackgroundMapping = {
    success: "var(--ds-background-success-subtler-pressed, #B3DF72)",
    warning: "var(--ds-background-warning-subtler-pressed, #FBC828)",
    danger: "var(--ds-background-danger-subtler-pressed, #FD9891)",
    information: "var(--ds-background-information-subtler-pressed, #8FB8F6)",
    neutral: "var(--ds-background-neutral-pressed, #080F214A)",
    discovery: "var(--ds-background-discovery-subtler-pressed, #D8A0F7)",
    'accent-red': "var(--ds-background-accent-red-subtler-pressed, #FD9891)",
    'accent-orange': "var(--ds-background-accent-orange-subtler-pressed, #FBC828)",
    'accent-yellow': "var(--ds-background-accent-yellow-subtler-pressed, #EED12B)",
    'accent-lime': "var(--ds-background-accent-lime-subtler-pressed, #B3DF72)",
    'accent-green': "var(--ds-background-accent-green-subtler-pressed, #7EE2B8)",
    'accent-teal': "var(--ds-background-accent-teal-subtler-pressed, #9DD9EE)",
    'accent-blue': "var(--ds-background-accent-blue-subtler-pressed, #8FB8F6)",
    'accent-purple': "var(--ds-background-accent-purple-subtler-pressed, #D8A0F7)",
    'accent-magenta': "var(--ds-background-accent-magenta-subtler-pressed, #F797D2)",
    'accent-gray': "var(--ds-background-accent-gray-subtlest-pressed, #B7B9BE)"
};
var $8c4045cfee3ec217$var$styles = {
    container: "_2rko12b0 _1reo15vq _18m915vq _189ee4h9 _1dqonqa1 _1h6d1j28 _kqswh2mm _1e0c116y _4cvr1h6o _vchhusvi _4t3i1k92 _1q51v77o _85i5v77o _bozg1b66 _y4ti1b66",
    motionContainer: "_k8m01rje _1oeci9qs _6fl41d08",
    containerSpacious: "_2rko1qi0 _1tkeviql _1q511b66 _85i51b66 _bozgutpp _y4tiutpp",
    containerBadgePadding: "_y4ti303w",
    text: "_11c8wadc _1reo15vq _18m915vq _o5721q9c",
    textEllipsis: "_1bto1l2s",
    textClip: "_1btozryt",
    textSpacious: "_11c8fhey _k48p1wq8",
    textSelected: "_syaz6x5g",
    loadingOverlay: "_1reo15vq _18m915vq _1e0c1txw _kqswstnw _4cvr1h6o _1bah1h6o _u7coze3t _152tze3t _rjxpze3t _1e02ze3t _lcxvglyw",
    loadingOverlayMotion: "_j7hq1bym _5sag1ign _1pglindk",
    metricBadgeWrapper: "_1e0c1txw",
    'semantic.success': "_3wu02gvx _bfhk14j0 _syaz1p1e",
    'semantic.warning': "_3wu01wfx _bfhk10f4 _syazmgs1",
    'semantic.danger': "_3wu01mzp _bfhk18wg _syaz1blx",
    'semantic.information': "_3wu0wn4u _bfhk8lbg _syaz1qd9",
    'semantic.neutral': "_3wu01l7x _bfhki8nm _syazi7uo",
    'semantic.discovery': "_3wu019v3 _bfhke670 _syaz1g72",
    'accent.red': "_3wu0n9dc _bfhk1rtt _syazhwvp",
    'accent.orange': "_3wu01ip5 _bfhk165s _syaz7i1p",
    'accent.yellow': "_3wu01s7j _bfhk1773 _syazekll",
    'accent.lime': "_3wu01m7d _bfhkz2ec _syaz1ik3",
    'accent.green': "_3wu05d2u _bfhk1wnw _syaz1y78",
    'accent.teal': "_3wu0131p _bfhk1a17 _syaz12v7",
    'accent.blue': "_3wu018hp _bfhk1dy8 _syaz1kyx",
    'accent.purple': "_3wu0luwt _bfhk1nm4 _syaz1mn1",
    'accent.magenta': "_3wu0132u _bfhkv9ra _syaz1qur",
    'accent.gray': "_3wu01l7x _bfhkysee _syaz1tmo",
    'interactive.semantic.success': "_irr31r82 _1di6d6jc",
    'interactive.semantic.warning': "_irr31yx4 _1di6bkku",
    'interactive.semantic.danger': "_irr370oi _1di6jkmi",
    'interactive.semantic.information': "_irr315aw _1di6ar1y",
    'interactive.semantic.neutral': "_irr3plhp _1di61gdz",
    'interactive.semantic.discovery': "_irr3rumk _1di65usi",
    'interactive.accent.red': "_irr3affd _1di61j5a",
    'interactive.accent.orange': "_irr31ei0 _1di6dpo3",
    'interactive.accent.yellow': "_irr31uw7 _1di61r9w",
    'interactive.accent.lime': "_irr31gf0 _1di62kxc",
    'interactive.accent.green': "_irr31e2h _1di6ybhx",
    'interactive.accent.teal': "_irr3kwwr _1di61jb0",
    'interactive.accent.blue': "_irr3815t _1di6rwxf",
    'interactive.accent.purple': "_irr3attl _1di63nfk",
    'interactive.accent.magenta': "_irr31axx _1di642ri",
    'interactive.accent.gray': "_irr3wejn _1di618ut",
    iconBorderFilter: "_1h6d74of",
    content: "_zulp1b66 _1e0c116y _4cvr1h6o",
    maxWidth: "_p12f1osq",
    contentSpacious: "_zulp12x7",
    loadingContent: "_tzy4idpf",
    loadingMotion: "_k8m0brmi _1oec1ign _6fl4indk",
    containerBadgePressed: "_1axmtoke _17i7toke",
    containerBadgeNeutralAppearance: "_1ftrnkaw _1axmnkaw _17i7nkaw"
};
var $8c4045cfee3ec217$var$interactiveMotionStyles = {
    motion: "_v564k6bl _1ggl5xtf"
};
/**
 * __New Lozenge__
 *
 * A lozenge is a visual indicator used to highlight an item's status for quick recognition.
 * This is the updated version with the new North Star visual language.
 */ var $8c4045cfee3ec217$var$LozengeBase = /*#__PURE__*/ (0, $5FkrB.memo)(/*#__PURE__*/ (0, $5FkrB.forwardRef)(function(_ref, ref) {
    var children = _ref.children, testId = _ref.testId, appearance = _ref.appearance, iconBefore = _ref.iconBefore, trailingMetric = _ref.trailingMetric, trailingMetricAppearance = _ref.trailingMetricAppearance, _ref$maxWidth = _ref.maxWidth, maxWidth = _ref$maxWidth === void 0 ? 200 : _ref$maxWidth, _ref$spacing = _ref.spacing, spacing = _ref$spacing === void 0 ? 'default' : _ref$spacing, isSelected = _ref.isSelected, _ref$isLoading = _ref.isLoading, isLoading = _ref$isLoading === void 0 ? false : _ref$isLoading, onClick = _ref.onClick, style = _ref.style, analyticsContext = _ref.analyticsContext, interactionName = _ref.interactionName, ariaControls = _ref['aria-controls'], ariaExpanded = _ref['aria-expanded'], ariaHaspopup = _ref['aria-haspopup'], ariaLabel = _ref['aria-label'];
    var _useState = (0, $5FkrB.useState)(false), _useState2 = (0, $78cd3f201970b824$export$2e2bcd8739ae039)(_useState, 2), resizing = _useState2[0], setResizing = _useState2[1];
    var onFinishMotion = function onFinishMotion() {
        return setResizing(false);
    };
    var resizingWidth = (0, $d60c798b82ceddb9$export$a300664a1a230956)({
        dimension: 'width',
        duration: "var(--ds-duration-medium, 200ms)",
        easing: "var(--ds-easing-inout-bold, cubic-bezier(0.4, 0, 0, 1))",
        onFinishMotion: onFinishMotion
    });
    var isInitialRender = (0, $5FkrB.useRef)(true);
    var isInteractive = typeof onClick === 'function';
    // Determine the effective color, with fallback logic for legacy appearances
    var resolvedColor = (0, $e4b3890ca43eeb4f$export$acf5d2b7dc999bda)(appearance) || 'neutral';
    var _getThemeStyles = (0, $9c9175041946e684$export$a3fc04b8551e006a)(resolvedColor), category = _getThemeStyles.category, key = _getThemeStyles.key;
    var colorStyleKey = "".concat(category, ".").concat(key);
    var interactiveStyleKey = "interactive.".concat(category, ".").concat(key);
    var maxWidthValue = typeof maxWidth === 'string' ? maxWidth : "".concat(maxWidth, "px");
    var maxWidthIsPc = typeof maxWidth === 'string' && maxWidth.endsWith('%');
    var resolvedTrailingMetricAppearance = trailingMetricAppearance ? trailingMetricAppearance === 'inverse' ? 'inverse' : (0, $e4b3890ca43eeb4f$export$acf5d2b7dc999bda)(trailingMetricAppearance) : resolvedColor;
    // Map the resolved trailing metric appearance to a Badge appearance.
    // Semantic colors map to their new bold variants (e.g. successBold),
    // which provide sufficient color emphasis on top of the subtler
    // lozenge background. Accent colors and unknown values fall back to
    // the neutral appearance.
    var metricBadgeAppearance = function() {
        if (resolvedTrailingMetricAppearance === 'inverse') return 'inverse';
        if (resolvedTrailingMetricAppearance == null) return 'neutral';
        if (resolvedTrailingMetricAppearance.startsWith('accent-')) return 'neutral';
        switch(resolvedTrailingMetricAppearance){
            case 'success':
                return 'successBold';
            case 'warning':
                return 'warningBold';
            case 'danger':
                return 'dangerBold';
            case 'information':
                return 'informationBold';
            case 'discovery':
                return 'discoveryBold';
            case 'neutral':
            default:
                return 'neutral';
        }
    }();
    var commonStyleOverrides = {
        backgroundColor: style === null || style === void 0 ? void 0 : style.backgroundColor,
        // Constrain the container to the smaller of the explicit maxWidth and 100% of
        // the parent. Using min(...) means the lozenge never overflows its parent,
        // while still honouring the explicit maxWidth prop when the parent is wider.
        maxWidth: maxWidthIsPc ? maxWidth : "min(".concat(maxWidthValue, ", 100%)")
    };
    var hasTrailingMetric = trailingMetric != null && trailingMetric !== '';
    var childrenKey = typeof children === 'string' ? children : undefined;
    (0, $5FkrB.useLayoutEffect)(function() {
        // Ignore initial render
        if (isInitialRender.current) {
            isInitialRender.current = false;
            return;
        }
        setResizing(true);
    }, [
        childrenKey
    ]);
    var enableMotionFG = (0, $50U6m.fg)('platform-dst-motion-uplift');
    var enableButtonMotionFG = (0, $50U6m.fg)('platform-dst-motion-uplift-button');
    var innerContent = /*#__PURE__*/ $5FkrB.createElement("span", (0, $e74e5963bd72a016$export$2e2bcd8739ae039)({
        "data-testid": testId ? "".concat(testId, "--content") : undefined
    }, enableMotionFG ? resizingWidth : undefined, {
        className: (0, $3KUKI.default)([
            $8c4045cfee3ec217$var$styles.content,
            spacing === 'spacious' && $8c4045cfee3ec217$var$styles.contentSpacious,
            isInteractive && enableButtonMotionFG && $8c4045cfee3ec217$var$styles.loadingMotion,
            isLoading && $8c4045cfee3ec217$var$styles.loadingContent,
            // Constrain the content wrapper to its container so text truncation
            // works correctly within the flex layout, regardless of whether maxWidth
            // is a percentage, fixed value, or the parent container is narrower than
            // the explicit maxWidth.
            $8c4045cfee3ec217$var$styles.maxWidth
        ])
    }), iconBefore && /*#__PURE__*/ $5FkrB.createElement((0, $0db2353ef35514f9$export$2e2bcd8739ae039), {
        size: spacing === 'spacious' ? 'medium' : 'small',
        icon: iconBefore,
        color: resolvedColor,
        testId: testId && "".concat(testId, "--icon")
    }), /*#__PURE__*/ $5FkrB.createElement("span", {
        style: {
            // The text fills 100% of the inner content wrapper. The container's
            // own max-width (set on the container via commonStyleOverrides) handles
            // the actual size constraint, so the text just needs to fill the available
            // space and truncate when it overflows.
            maxWidth: maxWidthIsPc ? '100%' : "calc(".concat(maxWidthValue, " - ", "var(--ds-space-100, 8px)", ")"),
            color: style === null || style === void 0 ? void 0 : style.color
        },
        "data-testid": testId && "".concat(testId, "--text"),
        className: (0, $3KUKI.default)([
            $8c4045cfee3ec217$var$styles.text,
            enableMotionFG && resizing && !maxWidth ? $8c4045cfee3ec217$var$styles.textClip : $8c4045cfee3ec217$var$styles.textEllipsis,
            spacing === 'spacious' && $8c4045cfee3ec217$var$styles.textSpacious
        ])
    }, children), hasTrailingMetric && !resolvedColor.startsWith('accent-') && /*#__PURE__*/ $5FkrB.createElement("span", {
        "data-lozenge-metric-wrapper": true,
        "data-testid": testId && "".concat(testId, "--metric"),
        className: (0, $3KUKI.default)([
            $8c4045cfee3ec217$var$styles.metricBadgeWrapper
        ])
    }, /*#__PURE__*/ $5FkrB.createElement((0, $0da488f75a4043f8$export$2e2bcd8739ae039), {
        appearance: metricBadgeAppearance
    }, trailingMetric)), isInteractive && /*#__PURE__*/ $5FkrB.createElement((0, (/*@__PURE__*/$parcel$interopDefault($e40a736c4c08093d$exports))), {
        label: "",
        size: "small",
        color: 'currentColor',
        testId: testId && "".concat(testId, "--chevron")
    }));
    if (isInteractive) return /*#__PURE__*/ $5FkrB.createElement((0, $d4a7825669dd53f6$export$2e2bcd8739ae039), (0, $e74e5963bd72a016$export$2e2bcd8739ae039)({
        ref: ref,
        xcss: (0, $d01a5d8bb96c5a7e$export$a274e22fb40f762e)($8c4045cfee3ec217$var$styles.container, !isLoading && enableButtonMotionFG ? $8c4045cfee3ec217$var$interactiveMotionStyles.motion : enableMotionFG && $8c4045cfee3ec217$var$styles.motionContainer, spacing === 'spacious' && $8c4045cfee3ec217$var$styles.containerSpacious, !isSelected && $8c4045cfee3ec217$var$styles.iconBorderFilter, $8c4045cfee3ec217$var$styles[colorStyleKey], !isLoading && $8c4045cfee3ec217$var$styles[interactiveStyleKey], hasTrailingMetric && $8c4045cfee3ec217$var$styles.containerBadgePressed, hasTrailingMetric && resolvedTrailingMetricAppearance === 'neutral' && $8c4045cfee3ec217$var$styles.containerBadgeNeutralAppearance)
    }, isLoading && {
        'aria-busy': true,
        'aria-disabled': true,
        isDisabled: true
    }, {
        "aria-label": isLoading ? 'Loading' : ariaLabel,
        "aria-controls": ariaControls,
        "aria-expanded": ariaExpanded,
        "aria-haspopup": ariaHaspopup,
        onClick: isLoading ? undefined : onClick,
        style: $8c4045cfee3ec217$var$_objectSpread($8c4045cfee3ec217$var$_objectSpread({}, commonStyleOverrides), {}, {
            // Specified because Pressable has a default border:none which overrides the border specified on the container
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            border: "solid ".concat("var(--ds-border-width, 1px)", " ", isSelected ? 'var(--border-color) !important' : 'transparent'),
            backgroundColor: isSelected ? $8c4045cfee3ec217$var$pressedBackgroundMapping[resolvedColor] : undefined,
            cursor: isLoading ? 'progress' : 'pointer'
        }),
        testId: testId,
        analyticsContext: analyticsContext,
        interactionName: interactionName,
        componentName: "LozengeDropdownTrigger"
    }, isSelected && {
        'data-selected': 'true'
    }), innerContent, isLoading && /*#__PURE__*/ $5FkrB.createElement("span", {
        "data-testid": testId ? "".concat(testId, "--loading-overlay") : undefined,
        className: (0, $3KUKI.default)([
            $8c4045cfee3ec217$var$styles.loadingOverlay,
            enableButtonMotionFG && $8c4045cfee3ec217$var$styles.loadingOverlayMotion
        ])
    }, /*#__PURE__*/ $5FkrB.createElement((0, $6f7e5f007cf95a87$export$2e2bcd8739ae039), {
        size: spacing === 'spacious' ? 'small' : 'xsmall',
        label: ", Loading",
        testId: testId ? "".concat(testId, "--loading-spinner") : undefined
    })));
    return /*#__PURE__*/ $5FkrB.createElement("span", {
        ref: ref,
        style: commonStyleOverrides,
        "data-testid": testId,
        className: (0, $3KUKI.default)([
            $8c4045cfee3ec217$var$styles.container,
            spacing === 'spacious' && $8c4045cfee3ec217$var$styles.containerSpacious,
            spacing !== 'spacious' && hasTrailingMetric && $8c4045cfee3ec217$var$styles.containerBadgePadding,
            $8c4045cfee3ec217$var$styles[colorStyleKey],
            $8c4045cfee3ec217$var$styles.iconBorderFilter,
            hasTrailingMetric && resolvedTrailingMetricAppearance === 'neutral' && $8c4045cfee3ec217$var$styles.containerBadgeNeutralAppearance
        ])
    }, innerContent);
}));
var $8c4045cfee3ec217$export$2e2bcd8739ae039 = $8c4045cfee3ec217$var$LozengeBase;


/**
 * __Lozenge__
 *
 * A lozenge is a visual indicator used to highlight an item's status for quick recognition.
 *
 * - [Examples](https://atlassian.design/components/lozenge/examples)
 * - [Code](https://atlassian.design/components/lozenge/code)
 * - [Usage](https://atlassian.design/components/lozenge/usage)
 */ var $2ebefb163f4e3420$var$Lozenge = function Lozenge(_ref) {
    var _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'neutral' : _ref$appearance, _ref$spacing = _ref.spacing, spacing = _ref$spacing === void 0 ? 'default' : _ref$spacing, _ref$maxWidth = _ref.maxWidth, maxWidth = _ref$maxWidth === void 0 ? 200 : _ref$maxWidth, style = _ref.style, testId = _ref.testId, children = _ref.children, iconBefore = _ref.iconBefore, trailingMetric = _ref.trailingMetric, trailingMetricAppearance = _ref.trailingMetricAppearance;
    var baseProps = {
        appearance: appearance,
        spacing: spacing,
        iconBefore: iconBefore,
        trailingMetric: trailingMetric,
        trailingMetricAppearance: trailingMetricAppearance,
        maxWidth: maxWidth,
        style: style,
        testId: testId,
        children: children
    };
    return /*#__PURE__*/ $5FkrB.createElement((0, $8c4045cfee3ec217$export$2e2bcd8739ae039), baseProps, children);
};
$2ebefb163f4e3420$var$Lozenge.displayName = 'Lozenge';
var $2ebefb163f4e3420$export$2e2bcd8739ae039 = $2ebefb163f4e3420$var$Lozenge;



var $gDiFE = parcelRequire("gDiFE");


var $6hgMx = parcelRequire("6hgMx");

var $i3UfC = parcelRequire("i3UfC");

var $5FkrB = parcelRequire("5FkrB");

var $6bnW7 = parcelRequire("6bnW7");
var $bgNpv = parcelRequire("bgNpv");



var $gDiFE = parcelRequire("gDiFE");


var $guDjK = parcelRequire("guDjK");

var $i3UfC = parcelRequire("i3UfC");

var $6bnW7 = parcelRequire("6bnW7");

var $i3UfC = parcelRequire("i3UfC");

var $bgNpv = parcelRequire("bgNpv");


var $gDiFE = parcelRequire("gDiFE");
/**
 * Shared consent URLs — sourced from envConfig so they can vary per environment.
 */ 
var $9KGFe = parcelRequire("9KGFe");
const { consent: $4359e24e53831a74$var$consent } = (0, $9KGFe.getConfig)();
const $4359e24e53831a74$export$7b48aa6f4ad99767 = $4359e24e53831a74$var$consent.privacyPolicyUrl;
const $4359e24e53831a74$export$b694b2b9cca4f698 = $4359e24e53831a74$var$consent.termsOfUseUrl;


const $3b5fda0c5c08534a$var$disclaimerStyle = (0, $gDiFE.xcss)({
    color: 'color.text.subtle',
    font: 'font.body.small'
});
const $3b5fda0c5c08534a$var$compactParagraphStyle = (0, $gDiFE.xcss)({
    margin: 'space.0'
});
const $3b5fda0c5c08534a$var$LegalDisclaimer = ({ messages: messages, product: product })=>{
    const privacyPolicyLink = /*#__PURE__*/ (0, $i3UfC.jsx)((0, $64e95b69a05329e9$export$2e2bcd8739ae039), {
        href: (0, $4359e24e53831a74$export$7b48aa6f4ad99767),
        children: /*#__PURE__*/ (0, $i3UfC.jsx)((0, $bgNpv.default), {
            ...messages.privacyPolicy
        })
    });
    const termsOfUseLink = /*#__PURE__*/ (0, $i3UfC.jsx)((0, $64e95b69a05329e9$export$2e2bcd8739ae039), {
        href: (0, $4359e24e53831a74$export$b694b2b9cca4f698),
        children: /*#__PURE__*/ (0, $i3UfC.jsx)((0, $bgNpv.default), {
            ...messages.termsOfUse
        })
    });
    return /*#__PURE__*/ (0, $i3UfC.jsx)((0, $383dd904a5a5e5b0$export$e71c4d32a2263218), {
        xcss: $3b5fda0c5c08534a$var$disclaimerStyle,
        children: /*#__PURE__*/ (0, $i3UfC.jsxs)((0, $383dd904a5a5e5b0$export$e71c4d32a2263218), {
            as: "p",
            xcss: $3b5fda0c5c08534a$var$compactParagraphStyle,
            children: [
                /*#__PURE__*/ (0, $i3UfC.jsx)((0, $bgNpv.default), {
                    ...messages.agreementHeader,
                    values: {
                        product: product
                    }
                }),
                ' ',
                /*#__PURE__*/ (0, $i3UfC.jsx)((0, $bgNpv.default), {
                    ...messages.agreementLinks,
                    values: {
                        privacyPolicyLink: privacyPolicyLink,
                        termsOfUseLink: termsOfUseLink
                    }
                })
            ]
        })
    });
};
var $3b5fda0c5c08534a$export$2e2bcd8739ae039 = $3b5fda0c5c08534a$var$LegalDisclaimer;


const $8e3072dd985bd6bf$var$messages = (0, $6bnW7.defineMessages)({
    agreementHeader: {
        id: 'oauth.twg.legalDisclaimer.agreementHeader',
        defaultMessage: "By accepting, you agree to Atlassian's",
        description: 'TWG terms agreement line shown in the footer.'
    },
    agreementLinks: {
        id: 'oauth.twg.legalDisclaimer.agreementLinks',
        defaultMessage: '{privacyPolicyLink} and {termsOfUseLink}.',
        description: 'TWG terms agreement links. The privacyPolicyLink and termsOfUseLink are replaced with actual links in the UI.'
    },
    privacyPolicy: {
        id: 'oauth.twg.privacyPolicy',
        defaultMessage: 'privacy policy',
        description: 'Text for the privacy policy link'
    },
    termsOfUse: {
        id: 'oauth.twg.termsOfUse',
        defaultMessage: 'terms of use',
        description: 'Text for the terms of use link'
    }
});
const $8e3072dd985bd6bf$var$LegalDisclaimer = ()=>/*#__PURE__*/ (0, $i3UfC.jsx)((0, $3b5fda0c5c08534a$export$2e2bcd8739ae039), {
        messages: {
            agreementHeader: $8e3072dd985bd6bf$var$messages.agreementHeader,
            agreementLinks: $8e3072dd985bd6bf$var$messages.agreementLinks,
            privacyPolicy: $8e3072dd985bd6bf$var$messages.privacyPolicy,
            termsOfUse: $8e3072dd985bd6bf$var$messages.termsOfUse
        }
    });
var $8e3072dd985bd6bf$export$2e2bcd8739ae039 = $8e3072dd985bd6bf$var$LegalDisclaimer;


const $557e0d777fff2f94$var$messages = (0, $6bnW7.defineMessages)({
    accept: {
        id: 'footer.accept',
        defaultMessage: 'Accept',
        description: 'Button to consent for this app to have the listed permissions'
    },
    cancel: {
        id: 'footer.cancel',
        defaultMessage: 'Cancel',
        description: 'Button to cancel the consent for this app to have the listed permissions'
    },
    permissionsSelected: {
        id: 'oauth.twg.footer.permissionsSelected',
        defaultMessage: '{selectedCount} out of {totalCount, plural, one {# permission} other {# permissions}} selected',
        description: 'Footer count shown while TWG CLI permissions are being edited'
    }
});
const $557e0d777fff2f94$export$4ff79328a91e70a1 = '88px';
const $557e0d777fff2f94$var$footerStyle = (0, $gDiFE.xcss)({
    bottom: 'space.0',
    backgroundColor: 'elevation.surface',
    borderTopColor: 'color.border',
    borderTopStyle: 'solid',
    borderTopWidth: 'border.width',
    boxSizing: 'border-box',
    flexShrink: 0,
    left: 'space.0',
    minHeight: $557e0d777fff2f94$export$4ff79328a91e70a1,
    padding: 'space.300',
    position: 'fixed',
    right: 'space.0',
    width: '100%',
    zIndex: 'navigation'
});
const $557e0d777fff2f94$var$footerInnerStyle = (0, $gDiFE.xcss)({
    margin: '0 auto',
    maxWidth: '1280px',
    width: '100%'
});
const $557e0d777fff2f94$var$disclaimerWideOnlyStyle = (0, $gDiFE.xcss)({
    display: 'none',
    [(0, $2ec84d2d4928089d$export$987d49ffe1b0900f).above.md]: {
        display: 'flex'
    }
});
const $557e0d777fff2f94$var$disclaimerNarrowOnlyStyle = (0, $gDiFE.xcss)({
    display: 'block',
    marginTop: 'space.150',
    textAlign: 'right',
    [(0, $2ec84d2d4928089d$export$987d49ffe1b0900f).above.md]: {
        display: 'none'
    }
});
const $557e0d777fff2f94$var$disclaimerSlotStyle = (0, $gDiFE.xcss)({
    flex: '1 1 280px',
    minWidth: '0'
});
const $557e0d777fff2f94$var$actionsStyle = (0, $gDiFE.xcss)({
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    gap: 'space.200',
    justifyContent: 'flex-end',
    width: '100%',
    [(0, $2ec84d2d4928089d$export$987d49ffe1b0900f).above.md]: {
        gap: 'space.400',
        width: 'auto'
    }
});
const $557e0d777fff2f94$var$TwgFooter = ({ acceptDisabled: acceptDisabled = false, selectedPermissionsSummary: selectedPermissionsSummary })=>{
    const analytics = (0, $guDjK.useAnalytics)();
    const [clickedButton, setClickedButton] = (0, $5FkrB.useState)(null);
    const fireAnalyticEvent = (0, $5FkrB.useCallback)((buttonName, buttonValue)=>()=>{
            analytics.sendButtonClickEvent(buttonName);
            setTimeout(()=>setClickedButton(buttonValue), 0);
        }, [
        analytics
    ]);
    const buttons = /*#__PURE__*/ (0, $i3UfC.jsxs)((0, $aa5238e80877390a$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $i3UfC.jsx)((0, $a21e01c03a9c4d94$export$2e2bcd8739ae039), {
                type: "submit",
                appearance: "subtle",
                name: "decision",
                value: "cancel",
                onClick: fireAnalyticEvent('cancelConsent', 'cancel'),
                isDisabled: clickedButton !== null,
                children: /*#__PURE__*/ (0, $i3UfC.jsx)((0, $bgNpv.default), {
                    ...$557e0d777fff2f94$var$messages.cancel
                })
            }),
            /*#__PURE__*/ (0, $i3UfC.jsx)((0, $a21e01c03a9c4d94$export$2e2bcd8739ae039), {
                type: "submit",
                appearance: "primary",
                name: "decision",
                value: "accept",
                onClick: fireAnalyticEvent('acceptConsent', 'accept'),
                isDisabled: acceptDisabled || clickedButton !== null,
                children: /*#__PURE__*/ (0, $i3UfC.jsx)((0, $bgNpv.default), {
                    ...$557e0d777fff2f94$var$messages.accept
                })
            })
        ]
    });
    return /*#__PURE__*/ (0, $i3UfC.jsxs)((0, $383dd904a5a5e5b0$export$e71c4d32a2263218), {
        xcss: $557e0d777fff2f94$var$footerStyle,
        children: [
            /*#__PURE__*/ (0, $i3UfC.jsxs)((0, $1b254ba6a068f2f1$export$f51f4c4ede09e011), {
                xcss: $557e0d777fff2f94$var$footerInnerStyle,
                direction: "row",
                alignItems: "center",
                justifyContent: "space-between",
                wrap: "wrap",
                gap: "space.400",
                children: [
                    /*#__PURE__*/ (0, $i3UfC.jsx)((0, $383dd904a5a5e5b0$export$e71c4d32a2263218), {
                        xcss: $557e0d777fff2f94$var$disclaimerWideOnlyStyle,
                        children: /*#__PURE__*/ (0, $i3UfC.jsx)((0, $383dd904a5a5e5b0$export$e71c4d32a2263218), {
                            xcss: $557e0d777fff2f94$var$disclaimerSlotStyle,
                            children: /*#__PURE__*/ (0, $i3UfC.jsx)((0, $8e3072dd985bd6bf$export$2e2bcd8739ae039), {})
                        })
                    }),
                    /*#__PURE__*/ (0, $i3UfC.jsxs)((0, $383dd904a5a5e5b0$export$e71c4d32a2263218), {
                        xcss: $557e0d777fff2f94$var$actionsStyle,
                        children: [
                            selectedPermissionsSummary && /*#__PURE__*/ (0, $i3UfC.jsx)((0, $d48daa9a522ca942$export$5f1af8db9871e1d6), {
                                as: "span",
                                color: "color.text.subtle",
                                children: /*#__PURE__*/ (0, $i3UfC.jsx)((0, $bgNpv.default), {
                                    ...$557e0d777fff2f94$var$messages.permissionsSelected,
                                    values: selectedPermissionsSummary
                                })
                            }),
                            buttons
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $i3UfC.jsx)((0, $383dd904a5a5e5b0$export$e71c4d32a2263218), {
                xcss: $557e0d777fff2f94$var$disclaimerNarrowOnlyStyle,
                children: /*#__PURE__*/ (0, $i3UfC.jsx)((0, $8e3072dd985bd6bf$export$2e2bcd8739ae039), {})
            })
        ]
    });
};
var $557e0d777fff2f94$export$2e2bcd8739ae039 = $557e0d777fff2f94$var$TwgFooter;


/**
 * Teamwork Graph CLI OAuth scope catalog.
 * Mirrors the configurable scopes in settings-service / Admin Hub (AFM PR #374724).
 * Grouped into Read, Write and manage, and Delete for display on the consent screen.
 */ const $de1b94c351ae758a$export$529f6de52d5982eb = [
    'offline_access',
    'read:compass:twg-cli'
];
const $de1b94c351ae758a$export$7027cf972b967c1e = new Set($de1b94c351ae758a$export$529f6de52d5982eb);
const $de1b94c351ae758a$var$scopeEntry = (id, label, description, scopes)=>({
        id: id,
        label: label,
        description: description,
        scopes: scopes
    });
const $de1b94c351ae758a$var$VIEW_SCOPES = [
    $de1b94c351ae758a$var$scopeEntry('view-jira', 'Jira', 'Jira platform data and Jira Software work, boards, sprints, and agile planning data.', [
        'read:jira-work',
        'read:jira-platform:twg-cli',
        'read:jsw:twg-cli'
    ]),
    $de1b94c351ae758a$var$scopeEntry('view-confluence', 'Confluence', 'Pages, spaces, comments, and related Confluence content.', [
        'read:confluence:twg-cli'
    ]),
    $de1b94c351ae758a$var$scopeEntry('view-loom', 'Loom', 'Loom videos, transcripts, comments, and related metadata.', [
        'read:loom:twg-cli'
    ]),
    $de1b94c351ae758a$var$scopeEntry('view-jsm', 'Jira Service Management', 'Service desks, help centers, requests, incidents, alerts, and related resources.', [
        'read:jsm:twg-cli'
    ]),
    $de1b94c351ae758a$var$scopeEntry('view-csm', 'Customer Service Management', 'Customer channels, organizations, and service management context.', [
        'read:csm:twg-cli'
    ]),
    $de1b94c351ae758a$var$scopeEntry('view-assets', 'Assets', 'Assets objects, schemas, attributes, and related metadata.', [
        'read:assets:twg-cli'
    ]),
    $de1b94c351ae758a$var$scopeEntry('view-focus-areas', 'Focus areas', 'Focus areas, risks, status updates, and related planning context.', [
        'read:jira-align:twg-cli',
        'read:mercury:twg-cli'
    ]),
    $de1b94c351ae758a$var$scopeEntry('view-talent', 'Talent', 'People, roles, headcount, and workforce planning data.', [
        'read:radar:twg-cli'
    ]),
    $de1b94c351ae758a$var$scopeEntry('view-projects-goals', 'Projects and goals', 'Projects, goals, status, ownership, and related planning details.', [
        'read:goal:townsquare',
        'read:project:townsquare'
    ]),
    $de1b94c351ae758a$var$scopeEntry('view-users-teams', 'Users and teams', 'User profiles, teams, and team memberships.', [
        'read:account',
        'view:membership:teams',
        'view:team:teams'
    ]),
    $de1b94c351ae758a$var$scopeEntry('view-platform-context', 'Platform and context', 'Teamwork Graph context and data from third-party tools connected to your Atlassian workspace.', [
        'read:3p-data:twg-cli',
        'read:teamwork-graph:twg-cli'
    ]),
    $de1b94c351ae758a$var$scopeEntry('view-trello', 'Trello', 'Boards, cards, lists, and related Trello data.', [
        'read:trello:twg-cli'
    ]),
    $de1b94c351ae758a$var$scopeEntry('view-feedback', 'Feedback', 'View feedback records, fields, insights, snippets, sources, customers, and views.', [
        'read:feedback:twg-cli'
    ])
];
const $de1b94c351ae758a$var$WRITE_SCOPES = [
    $de1b94c351ae758a$var$scopeEntry('write-jira', 'Jira', 'Jira platform data and Jira Software work, boards, sprints, and agile planning data.', [
        'write:jira-platform:twg-cli',
        'write:jsw:twg-cli'
    ]),
    $de1b94c351ae758a$var$scopeEntry('write-confluence', 'Confluence', 'Pages, spaces, comments, and related Confluence content.', [
        'write:confluence:twg-cli'
    ]),
    $de1b94c351ae758a$var$scopeEntry('write-loom', 'Loom', 'Loom videos, transcripts, comments, and related metadata.', [
        'write:loom:twg-cli'
    ]),
    $de1b94c351ae758a$var$scopeEntry('write-jsm', 'Jira Service Management', 'Service desks, help centers, requests, incidents, alerts, and related resources.', [
        'write:jsm:twg-cli'
    ]),
    $de1b94c351ae758a$var$scopeEntry('write-assets', 'Assets', 'Assets objects, schemas, attributes, and related metadata.', [
        'write:assets:twg-cli'
    ]),
    $de1b94c351ae758a$var$scopeEntry('write-focus-areas', 'Focus areas', 'Focus areas, risks, status updates, and related planning context.', [
        'write:mercury:twg-cli'
    ]),
    $de1b94c351ae758a$var$scopeEntry('write-talent', 'Talent', 'People, roles, headcount, and workforce planning data.', [
        'write:radar:twg-cli'
    ]),
    $de1b94c351ae758a$var$scopeEntry('write-projects-goals', 'Projects and goals', 'Projects, goals, status, ownership, and related planning details.', [
        'write:goal:townsquare',
        'write:project:townsquare'
    ]),
    $de1b94c351ae758a$var$scopeEntry('write-users-teams', 'Users and teams', 'User profiles, teams, and team memberships.', [
        'write:membership:teams',
        'write:team:teams'
    ]),
    $de1b94c351ae758a$var$scopeEntry('write-platform-context', 'Platform and context', 'Teamwork Graph context and data from third-party tools connected to your Atlassian workspace.', [
        'write:all:twg'
    ]),
    $de1b94c351ae758a$var$scopeEntry('write-trello', 'Trello', 'Boards, cards, lists, and related Trello data.', [
        'write:trello:twg-cli'
    ]),
    $de1b94c351ae758a$var$scopeEntry('write-feedback', 'Feedback', 'Create and update feedback records, fields, insights, snippets, sources, customers, and views.', [
        'write:feedback:twg-cli'
    ])
];
const $de1b94c351ae758a$var$DELETE_SCOPES = [
    $de1b94c351ae758a$var$scopeEntry('delete-jira', 'Jira', 'Jira platform data and Jira Software work, boards, sprints, and agile planning data.', [
        'delete:jira-platform:twg-cli',
        'delete:jsw:twg-cli'
    ]),
    $de1b94c351ae758a$var$scopeEntry('delete-confluence', 'Confluence', 'Pages, spaces, comments, and related Confluence content.', [
        'delete:confluence:twg-cli'
    ]),
    $de1b94c351ae758a$var$scopeEntry('delete-loom', 'Loom', 'Loom videos, transcripts, comments, and related metadata.', [
        'delete:loom:twg-cli'
    ]),
    $de1b94c351ae758a$var$scopeEntry('delete-jsm', 'Jira Service Management', 'Service desks, help centers, requests, incidents, alerts, and related resources.', [
        'delete:jsm:twg-cli'
    ]),
    $de1b94c351ae758a$var$scopeEntry('delete-assets', 'Assets', 'Assets objects, schemas, attributes, and related metadata.', [
        'delete:assets:twg-cli'
    ]),
    $de1b94c351ae758a$var$scopeEntry('delete-focus-areas', 'Focus areas', 'Focus areas, risks, status updates, and related planning context.', [
        'delete:mercury:twg-cli'
    ]),
    $de1b94c351ae758a$var$scopeEntry('delete-feedback', 'Feedback', 'Permanently delete feedback records, insights, and snippets.', [
        'delete:feedback:twg-cli'
    ])
];
// Lookup map: scope string to catalog entry (across all groups)
const $de1b94c351ae758a$var$ALL_SCOPES = [
    ...$de1b94c351ae758a$var$VIEW_SCOPES,
    ...$de1b94c351ae758a$var$WRITE_SCOPES,
    ...$de1b94c351ae758a$var$DELETE_SCOPES
];
const $de1b94c351ae758a$export$2e8ce214a37736e6 = new Map($de1b94c351ae758a$var$ALL_SCOPES.flatMap((entry)=>entry.scopes.map((scope)=>[
            scope,
            entry
        ])));
const $de1b94c351ae758a$export$b1583ba6c2acca6f = [
    {
        id: 'view',
        heading: 'Read',
        groupDescription: 'Allow Teamwork Graph CLI to view and read data from connected apps.',
        scopes: $de1b94c351ae758a$var$VIEW_SCOPES
    },
    {
        id: 'write',
        heading: 'Write and manage',
        groupDescription: 'Allow Teamwork Graph CLI to create, update, and manage data in connected apps.',
        scopes: $de1b94c351ae758a$var$WRITE_SCOPES
    },
    {
        id: 'delete',
        heading: 'Delete',
        groupDescription: 'Allow Teamwork Graph CLI to permanently delete data from connected apps.',
        scopes: $de1b94c351ae758a$var$DELETE_SCOPES
    }
];


const $f40a48e733a91cb2$var$messages = (0, $6bnW7.defineMessages)({
    sectionTitle: {
        id: 'oauth.twg.permissions.sectionTitle',
        defaultMessage: 'Permissions',
        description: 'Section heading for TWG permissions'
    },
    disabledByOrgAdmin: {
        id: 'oauth.twg.permissions.disabledByOrgAdmin',
        defaultMessage: 'Disabled by org admin',
        description: 'Message shown beside a TWG scope that an organization admin has disabled'
    },
    editPermissions: {
        id: 'oauth.twg.permissions.editPermissions',
        defaultMessage: 'Edit permissions',
        description: 'Button shown below TWG permission groups to let users choose individual permissions'
    },
    limitedPermissionsTitle: {
        id: 'oauth.twg.permissions.limitedPermissionsTitle',
        defaultMessage: 'Unselected permissions will limit Teamwork Graph CLI features',
        description: 'Title for the warning flag shown when users deselect TWG CLI permissions'
    },
    limitedPermissionsBody: {
        id: 'oauth.twg.permissions.limitedPermissionsBody',
        defaultMessage: "If you later want to use a feature that requires a permission you didn't grant, you'll need to disconnect and reconnect Teamwork Graph CLI to update your permissions.",
        description: 'Body for the warning flag shown when users deselect TWG CLI permissions'
    },
    limitedPermissionsDismiss: {
        id: 'oauth.twg.permissions.limitedPermissionsDismiss',
        defaultMessage: 'Understood',
        description: 'Button to dismiss the warning flag shown when users deselect TWG CLI permissions'
    }
});
const $f40a48e733a91cb2$var$warningFlagContainerStyle = (0, $gDiFE.xcss)({
    position: 'fixed',
    bottom: `calc(${(0, $557e0d777fff2f94$export$4ff79328a91e70a1)} + var(--ds-space-400, 32px))`,
    left: 'space.400',
    // @ts-expect-error static z-index
    zIndex: 100,
    width: '400px',
    maxWidth: '90vw',
    backgroundColor: 'color.background.warning',
    borderRadius: 'radius.small',
    boxShadow: 'elevation.shadow.overlay'
});
const $f40a48e733a91cb2$var$styles = {
    permissionsRoot: {
        display: 'flex',
        flexDirection: 'column',
        gap: '8px',
        width: '100%'
    },
    groups: {
        display: 'flex',
        flexDirection: 'column',
        gap: '16px',
        width: '100%'
    },
    groupCard: {
        backgroundColor: 'var(--twg-card-bg)',
        borderColor: 'var(--twg-card-border)',
        borderRadius: '8px',
        borderStyle: 'solid',
        borderWidth: '1px',
        boxSizing: 'border-box',
        color: 'var(--twg-card-text)',
        overflow: 'hidden',
        width: '100%'
    },
    groupSummary: {
        paddingBlock: '19px',
        paddingInline: '20px 24px'
    },
    groupSummaryInner: {
        alignItems: 'flex-start',
        display: 'flex',
        gap: '20px',
        justifyContent: 'space-between',
        width: '100%'
    },
    groupCopy: {
        display: 'flex',
        flex: '1 1 auto',
        flexDirection: 'column',
        gap: '4px',
        minWidth: 0
    },
    groupExpandButton: {
        alignItems: 'center',
        backgroundColor: 'transparent',
        border: 0,
        color: 'inherit',
        cursor: 'pointer',
        display: 'flex',
        flex: '1 1 auto',
        font: 'inherit',
        gap: '20px',
        justifyContent: 'space-between',
        minWidth: 0,
        padding: 0,
        textAlign: 'left',
        width: '100%'
    },
    groupHeading: {
        color: 'var(--twg-card-text)',
        fontSize: '16px',
        fontWeight: 700,
        lineHeight: '20px'
    },
    groupDescription: {
        color: 'var(--twg-card-text)',
        fontSize: '14px',
        lineHeight: '20px',
        margin: 0
    },
    collapsedIcon: {
        color: 'var(--twg-card-text)',
        flexShrink: 0,
        paddingTop: '0'
    },
    checkboxCell: {
        flexShrink: 0,
        paddingTop: '0'
    },
    chevronCell: {
        color: 'var(--twg-card-muted)',
        flexShrink: 0,
        marginLeft: 'auto'
    },
    scopeList: {
        display: 'flex',
        flexDirection: 'column',
        gap: '16px',
        paddingBlockEnd: '20px',
        paddingInlineEnd: '28px',
        paddingInlineStart: '76px'
    },
    scopeRow: {
        alignItems: 'flex-start',
        borderRadius: '6px',
        boxSizing: 'border-box',
        cursor: 'pointer',
        display: 'flex',
        gap: '14px',
        marginInlineStart: '-4px',
        paddingBlock: '6px',
        paddingInline: '4px'
    },
    scopeCheckboxCell: {
        flexShrink: 0,
        paddingTop: 0
    },
    scopeRowDisabled: {
        cursor: 'not-allowed',
        opacity: 0.62
    },
    scopeCopy: {
        display: 'flex',
        flex: '1 1 auto',
        flexDirection: 'column',
        gap: '6px',
        minWidth: 0
    },
    scopeLabel: {
        color: 'var(--twg-card-text)',
        fontSize: '14px',
        fontWeight: 500,
        lineHeight: '20px'
    },
    scopeTitleLine: {
        alignItems: 'center',
        display: 'flex',
        flexWrap: 'wrap',
        gap: '8px'
    },
    scopeDescription: {
        color: 'var(--twg-card-muted)',
        fontSize: '14px',
        lineHeight: '20px'
    },
    editButton: {
        marginTop: '16px'
    }
};
const $f40a48e733a91cb2$var$ScopeGroupCard = ({ group: group, allInGroup: allInGroup, enabledGroupScopeValues: enabledGroupScopeValues, allSelected: allSelected, editMode: editMode, isIndeterminate: isIndeterminate, selectedScopesSet: selectedScopesSet, allowedScopesSet: allowedScopesSet, expanded: expanded, onToggleExpanded: onToggleExpanded, onToggleScopes: onToggleScopes, onToggleGroupAll: onToggleGroupAll })=>{
    return /*#__PURE__*/ (0, $i3UfC.jsxs)("div", {
        style: $f40a48e733a91cb2$var$styles.groupCard,
        children: [
            /*#__PURE__*/ (0, $i3UfC.jsx)("div", {
                style: $f40a48e733a91cb2$var$styles.groupSummary,
                children: /*#__PURE__*/ (0, $i3UfC.jsxs)("div", {
                    style: $f40a48e733a91cb2$var$styles.groupSummaryInner,
                    children: [
                        editMode ? /*#__PURE__*/ (0, $i3UfC.jsx)("span", {
                            style: $f40a48e733a91cb2$var$styles.checkboxCell,
                            children: /*#__PURE__*/ (0, $i3UfC.jsx)((0, $fa7b9da54b6e47b4$export$48513f6b9f8ce62d), {
                                isChecked: allSelected,
                                isIndeterminate: isIndeterminate,
                                isDisabled: enabledGroupScopeValues.length === 0,
                                onChange: (event)=>onToggleGroupAll(enabledGroupScopeValues, event.currentTarget.checked),
                                name: `group-${group.id}`,
                                label: "",
                                "aria-label": `Select all ${group.heading} permissions`
                            })
                        }) : /*#__PURE__*/ (0, $i3UfC.jsx)("span", {
                            style: $f40a48e733a91cb2$var$styles.collapsedIcon,
                            "aria-hidden": "true",
                            children: /*#__PURE__*/ (0, $i3UfC.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($60d92d5137838590$exports))), {
                                label: "",
                                size: "medium"
                            })
                        }),
                        editMode ? /*#__PURE__*/ (0, $i3UfC.jsxs)("button", {
                            type: "button",
                            style: $f40a48e733a91cb2$var$styles.groupExpandButton,
                            "aria-expanded": expanded,
                            onClick: onToggleExpanded,
                            children: [
                                /*#__PURE__*/ (0, $i3UfC.jsxs)("span", {
                                    style: $f40a48e733a91cb2$var$styles.groupCopy,
                                    children: [
                                        /*#__PURE__*/ (0, $i3UfC.jsx)("span", {
                                            style: $f40a48e733a91cb2$var$styles.groupHeading,
                                            children: group.heading
                                        }),
                                        /*#__PURE__*/ (0, $i3UfC.jsx)("span", {
                                            style: $f40a48e733a91cb2$var$styles.groupDescription,
                                            children: group.groupDescription
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $i3UfC.jsx)("span", {
                                    style: $f40a48e733a91cb2$var$styles.chevronCell,
                                    "aria-hidden": "true",
                                    children: expanded ? /*#__PURE__*/ (0, $i3UfC.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($51cda659fee75760$exports))), {
                                        label: "",
                                        size: "small"
                                    }) : /*#__PURE__*/ (0, $i3UfC.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($c63a1832a2581897$exports))), {
                                        label: "",
                                        size: "small"
                                    })
                                })
                            ]
                        }) : /*#__PURE__*/ (0, $i3UfC.jsxs)("span", {
                            style: $f40a48e733a91cb2$var$styles.groupCopy,
                            children: [
                                /*#__PURE__*/ (0, $i3UfC.jsx)("span", {
                                    style: $f40a48e733a91cb2$var$styles.groupHeading,
                                    children: group.heading
                                }),
                                /*#__PURE__*/ (0, $i3UfC.jsx)("span", {
                                    style: $f40a48e733a91cb2$var$styles.groupDescription,
                                    children: group.groupDescription
                                })
                            ]
                        })
                    ]
                })
            }),
            editMode && expanded && /*#__PURE__*/ (0, $i3UfC.jsx)("div", {
                style: $f40a48e733a91cb2$var$styles.scopeList,
                children: allInGroup.map((entry)=>{
                    const enabledEntryScopeValues = entry.scopes.filter((scope)=>allowedScopesSet.has(scope));
                    const selectedEnabledEntryScopeValues = enabledEntryScopeValues.filter((scope)=>selectedScopesSet.has(scope));
                    const isAllowed = enabledEntryScopeValues.length > 0;
                    const isSelected = selectedEnabledEntryScopeValues.length > 0;
                    const isIndeterminate = selectedEnabledEntryScopeValues.length > 0 && selectedEnabledEntryScopeValues.length < enabledEntryScopeValues.length;
                    return /*#__PURE__*/ (0, $i3UfC.jsxs)("div", {
                        onClick: (event)=>{
                            if (isAllowed && !(event.target instanceof HTMLInputElement)) onToggleScopes(enabledEntryScopeValues, !isSelected);
                        },
                        style: {
                            ...$f40a48e733a91cb2$var$styles.scopeRow,
                            ...!isAllowed ? $f40a48e733a91cb2$var$styles.scopeRowDisabled : {}
                        },
                        children: [
                            /*#__PURE__*/ (0, $i3UfC.jsx)("span", {
                                style: $f40a48e733a91cb2$var$styles.scopeCheckboxCell,
                                children: /*#__PURE__*/ (0, $i3UfC.jsx)((0, $fa7b9da54b6e47b4$export$48513f6b9f8ce62d), {
                                    "aria-label": entry.label,
                                    isChecked: isSelected,
                                    isIndeterminate: isIndeterminate,
                                    isDisabled: !isAllowed,
                                    onChange: (event)=>onToggleScopes(enabledEntryScopeValues, event.currentTarget.checked),
                                    name: entry.id,
                                    label: ""
                                })
                            }),
                            /*#__PURE__*/ (0, $i3UfC.jsxs)("span", {
                                style: $f40a48e733a91cb2$var$styles.scopeCopy,
                                children: [
                                    /*#__PURE__*/ (0, $i3UfC.jsxs)("span", {
                                        style: $f40a48e733a91cb2$var$styles.scopeTitleLine,
                                        children: [
                                            /*#__PURE__*/ (0, $i3UfC.jsx)("span", {
                                                style: $f40a48e733a91cb2$var$styles.scopeLabel,
                                                children: entry.label
                                            }),
                                            !isAllowed && /*#__PURE__*/ (0, $i3UfC.jsx)("span", {
                                                children: /*#__PURE__*/ (0, $i3UfC.jsx)((0, $2ebefb163f4e3420$export$2e2bcd8739ae039), {
                                                    appearance: "default",
                                                    isBold: true,
                                                    children: /*#__PURE__*/ (0, $i3UfC.jsx)((0, $bgNpv.default), {
                                                        ...$f40a48e733a91cb2$var$messages.disabledByOrgAdmin
                                                    })
                                                })
                                            })
                                        ]
                                    }),
                                    entry.description && /*#__PURE__*/ (0, $i3UfC.jsx)("span", {
                                        style: $f40a48e733a91cb2$var$styles.scopeDescription,
                                        children: entry.description
                                    })
                                ]
                            })
                        ]
                    }, entry.id);
                })
            })
        ]
    });
};
const $f40a48e733a91cb2$var$isUnknownScopeInGroup = (scope, groupId)=>{
    if (groupId === 'write') return scope.startsWith('write:');
    if (groupId === 'delete') return scope.startsWith('delete:');
    return !scope.startsWith('write:') && !scope.startsWith('delete:');
};
const $f40a48e733a91cb2$var$PermissionsBullets = ({ defaultEditMode: defaultEditMode = false, editMode: controlledEditMode, onEditModeChange: onEditModeChange })=>{
    const { scopes: scopes } = (0, $6hgMx.useToken)();
    const { filteredScopes: filteredScopes, disabledScopes: disabledScopes } = (0, $6hgMx.useInfo)();
    const context = (0, $5FkrB.useContext)((0, $6hgMx.ReactConsentContext));
    const { formatMessage: formatMessage } = (0, $hrVKU.default)();
    const [uncontrolledEditMode, setUncontrolledEditMode] = (0, $5FkrB.useState)(defaultEditMode);
    const editMode = controlledEditMode ?? uncontrolledEditMode;
    const setEditMode = (0, $5FkrB.useCallback)((nextEditMode)=>{
        if (controlledEditMode === undefined) setUncontrolledEditMode(nextEditMode);
        onEditModeChange?.(nextEditMode);
    }, [
        controlledEditMode,
        onEditModeChange
    ]);
    const [isWarningDismissed, setIsWarningDismissed] = (0, $5FkrB.useState)(false);
    // Lifted expand state, keyed by group.id so it survives scope selection re-renders.
    const [expandedGroups, setExpandedGroups] = (0, $5FkrB.useState)({
        view: true
    });
    const toggleExpanded = (0, $5FkrB.useCallback)((groupId)=>setExpandedGroups((prev)=>({
                ...prev,
                [groupId]: !prev[groupId]
            })), []);
    // Stable per-group expand callbacks so ScopeGroupCard props don't change on scope selection re-renders.
    const groupToggleCallbacks = (0, $5FkrB.useMemo)(()=>Object.fromEntries((0, $de1b94c351ae758a$export$b1583ba6c2acca6f).map((g)=>[
                g.id,
                ()=>toggleExpanded(g.id)
            ])), [
        toggleExpanded
    ]);
    const userSelectedScopes = context?.selectedScopes ?? [];
    const setSelectedScopes = context?.setSelectedScopes;
    const setAcceptDisabled = context?.setAcceptDisabled;
    const requestedScopesSet = (0, $5FkrB.useMemo)(()=>new Set([
            ...scopes,
            ...filteredScopes ?? [],
            ...disabledScopes ?? []
        ].filter((scope)=>!(0, $de1b94c351ae758a$export$7027cf972b967c1e).has(scope))), [
        disabledScopes,
        filteredScopes,
        scopes
    ]);
    const allowedScopesSet = (0, $5FkrB.useMemo)(()=>new Set((filteredScopes ?? scopes).filter((scope)=>!(0, $de1b94c351ae758a$export$7027cf972b967c1e).has(scope))), [
        filteredScopes,
        scopes
    ]);
    const selectedScopesSet = (0, $5FkrB.useMemo)(()=>new Set(userSelectedScopes), [
        userSelectedScopes
    ]);
    const enabledSelectedScopes = (0, $5FkrB.useMemo)(()=>Array.from(allowedScopesSet).filter((scope)=>selectedScopesSet.has(scope)), [
        allowedScopesSet,
        selectedScopesSet
    ]);
    const showLimitedPermissionsWarning = editMode && !isWarningDismissed && allowedScopesSet.size > 0 && enabledSelectedScopes.length < allowedScopesSet.size;
    // Use a ref to hold setAcceptDisabled so the effect dependency doesn't change
    // on every context re-render (context spreads a new object each time).
    const setAcceptDisabledRef = (0, $5FkrB.useRef)(setAcceptDisabled);
    (0, $5FkrB.useEffect)(()=>{
        setAcceptDisabledRef.current = setAcceptDisabled;
    });
    (0, $5FkrB.useEffect)(()=>{
        setAcceptDisabledRef.current?.(enabledSelectedScopes.length === 0);
        return ()=>setAcceptDisabledRef.current?.(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        enabledSelectedScopes.length
    ]);
    const toggleScopes = (0, $5FkrB.useCallback)((scopesToToggle, checked)=>{
        const enabledScopesToToggle = scopesToToggle.filter((scope)=>allowedScopesSet.has(scope));
        if (!setSelectedScopes || enabledScopesToToggle.length === 0) return;
        setSelectedScopes(checked ? Array.from(new Set([
            ...userSelectedScopes,
            ...enabledScopesToToggle
        ])) : userSelectedScopes.filter((scope)=>!enabledScopesToToggle.includes(scope)));
    }, [
        allowedScopesSet,
        setSelectedScopes,
        userSelectedScopes
    ]);
    const toggleGroupAll = (0, $5FkrB.useCallback)((groupScopes, checked)=>{
        if (!setSelectedScopes) return;
        if (checked) {
            const toAdd = groupScopes.filter((s)=>!selectedScopesSet.has(s));
            setSelectedScopes(Array.from(new Set([
                ...userSelectedScopes,
                ...toAdd
            ])));
        } else {
            const groupSet = new Set(groupScopes);
            setSelectedScopes(userSelectedScopes.filter((s)=>!groupSet.has(s)));
        }
    }, [
        setSelectedScopes,
        userSelectedScopes,
        selectedScopesSet
    ]);
    return /*#__PURE__*/ (0, $i3UfC.jsxs)("div", {
        style: $f40a48e733a91cb2$var$styles.permissionsRoot,
        children: [
            /*#__PURE__*/ (0, $i3UfC.jsx)((0, $82315a19372f332f$export$2e2bcd8739ae039), {
                size: "small",
                children: /*#__PURE__*/ (0, $i3UfC.jsx)((0, $bgNpv.default), {
                    ...$f40a48e733a91cb2$var$messages.sectionTitle
                })
            }),
            /*#__PURE__*/ (0, $i3UfC.jsx)("div", {
                style: $f40a48e733a91cb2$var$styles.groups,
                children: (0, $de1b94c351ae758a$export$b1583ba6c2acca6f).map((group)=>{
                    const knownInGroup = group.scopes.filter((e)=>e.scopes.some((scope)=>requestedScopesSet.has(scope)));
                    const unknownInGroup = Array.from(requestedScopesSet).filter((s)=>!(0, $de1b94c351ae758a$export$2e8ce214a37736e6).has(s) && $f40a48e733a91cb2$var$isUnknownScopeInGroup(s, group.id)).map((s)=>({
                            id: `unknown-${s}`,
                            scopes: [
                                s
                            ],
                            label: s,
                            description: ''
                        }));
                    const allInGroup = [
                        ...knownInGroup,
                        ...unknownInGroup
                    ];
                    if (allInGroup.length === 0) return null;
                    const groupScopeValues = Array.from(new Set(allInGroup.flatMap((e)=>e.scopes)));
                    const enabledGroupScopeValues = groupScopeValues.filter((s)=>allowedScopesSet.has(s));
                    const selectedEnabledInGroup = enabledGroupScopeValues.filter((s)=>selectedScopesSet.has(s));
                    const allSelected = enabledGroupScopeValues.length > 0 && selectedEnabledInGroup.length === enabledGroupScopeValues.length;
                    const noneSelected = selectedEnabledInGroup.length === 0;
                    const isIndeterminate = !allSelected && !noneSelected;
                    return /*#__PURE__*/ (0, $i3UfC.jsx)($f40a48e733a91cb2$var$ScopeGroupCard, {
                        group: group,
                        allInGroup: allInGroup,
                        enabledGroupScopeValues: enabledGroupScopeValues,
                        allSelected: allSelected,
                        editMode: editMode,
                        isIndeterminate: isIndeterminate,
                        selectedScopesSet: selectedScopesSet,
                        allowedScopesSet: allowedScopesSet,
                        expanded: !!expandedGroups[group.id],
                        onToggleExpanded: groupToggleCallbacks[group.id],
                        onToggleScopes: toggleScopes,
                        onToggleGroupAll: toggleGroupAll
                    }, group.id);
                })
            }),
            !editMode && /*#__PURE__*/ (0, $i3UfC.jsx)("div", {
                style: $f40a48e733a91cb2$var$styles.editButton,
                children: /*#__PURE__*/ (0, $i3UfC.jsx)((0, $e0763a2a29633b85$export$2e2bcd8739ae039), {
                    appearance: "link",
                    spacing: "none",
                    type: "button",
                    onClick: ()=>setEditMode(true),
                    children: /*#__PURE__*/ (0, $i3UfC.jsx)((0, $bgNpv.default), {
                        ...$f40a48e733a91cb2$var$messages.editPermissions
                    })
                })
            }),
            showLimitedPermissionsWarning && /*#__PURE__*/ (0, $i3UfC.jsx)((0, $383dd904a5a5e5b0$export$e71c4d32a2263218), {
                xcss: $f40a48e733a91cb2$var$warningFlagContainerStyle,
                children: /*#__PURE__*/ (0, $i3UfC.jsx)((0, $dded6e092963b70b$export$2e2bcd8739ae039), {
                    id: "twg-limited-permissions-warning",
                    icon: /*#__PURE__*/ (0, $i3UfC.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($37990044355ecd18$exports))), {
                        label: "",
                        color: (0, $37190500189da037$export$9e1725a4cfeada27)('color.icon.information')
                    }),
                    title: formatMessage($f40a48e733a91cb2$var$messages.limitedPermissionsTitle),
                    description: formatMessage($f40a48e733a91cb2$var$messages.limitedPermissionsBody),
                    onDismissed: ()=>setIsWarningDismissed(true),
                    actions: [
                        {
                            content: formatMessage($f40a48e733a91cb2$var$messages.limitedPermissionsDismiss),
                            onClick: ()=>setIsWarningDismissed(true)
                        }
                    ]
                })
            })
        ]
    });
};
var $f40a48e733a91cb2$export$2e2bcd8739ae039 = $f40a48e733a91cb2$var$PermissionsBullets;



var $i3UfC = parcelRequire("i3UfC");

var $5FkrB = parcelRequire("5FkrB");


var $6bnW7 = parcelRequire("6bnW7");
var $hrVKU = parcelRequire("hrVKU");


var $gDiFE = parcelRequire("gDiFE");

var $6hgMx = parcelRequire("6hgMx");
const $4f1f3281c07da3d2$var$messages = (0, $6bnW7.defineMessages)({
    siteLabel: {
        id: 'oauth.twg.siteSelector.siteLabel',
        defaultMessage: 'Authorize access for:',
        description: 'Label for which site the user wants to authorize for TWG'
    },
    sitePlaceholder: {
        id: 'oauth.twg.siteSelector.sitePlaceholder',
        defaultMessage: 'Select a site',
        description: 'Placeholder for which sites user wants to authorize for TWG'
    }
});
const $4f1f3281c07da3d2$var$siteSelectStyles = (0, $gDiFE.xcss)({
    maxWidth: '416px',
    width: '100%'
});
const $4f1f3281c07da3d2$var$SiteSelector = ()=>{
    const { formatMessage: formatMessage } = (0, $hrVKU.default)();
    const { selectedWorkspace: selectedWorkspace, setSelectedWorkspace: setSelectedWorkspace } = (0, $6hgMx.useSelectedWorkspace)();
    const { availableOrganizations: availableOrganizations, selectedOrg: selectedOrg, setSelectedOrg: setSelectedOrg } = (0, $6hgMx.useSelectedOrg)();
    // Build a flat sorted list of all sites across all orgs, keeping track of which orgId each belongs to
    const siteToOrgId = (0, $5FkrB.useMemo)(()=>{
        const map = new Map();
        for (const org of availableOrganizations)for (const site of org.availableWorkspaces ?? [])map.set(site, org.orgId);
        return map;
    }, [
        availableOrganizations
    ]);
    const workspaceOptions = (0, $5FkrB.useMemo)(()=>Array.from(siteToOrgId.keys()).sort().map((site)=>({
                label: site,
                value: site
            })), [
        siteToOrgId
    ]);
    // Auto-select when there is exactly one site available
    (0, $5FkrB.useEffect)(()=>{
        if (workspaceOptions.length === 1 && !selectedWorkspace) {
            const site = String(workspaceOptions[0].value);
            const orgId = siteToOrgId.get(site) ?? null;
            setSelectedWorkspace(site);
            if (orgId !== selectedOrg) setSelectedOrg(orgId);
        }
    }, [
        workspaceOptions,
        selectedWorkspace,
        selectedOrg,
        siteToOrgId,
        setSelectedWorkspace,
        setSelectedOrg
    ]);
    // Find the single selected option
    const selectedOption = workspaceOptions.find((o)=>o.value === selectedWorkspace) ?? null;
    const siteSelectorId = 'twg-site-selector';
    return /*#__PURE__*/ (0, $i3UfC.jsx)((0, $383dd904a5a5e5b0$export$e71c4d32a2263218), {
        xcss: $4f1f3281c07da3d2$var$siteSelectStyles,
        children: /*#__PURE__*/ (0, $i3UfC.jsxs)((0, $c8dbef6c41cfa689$export$694e0d28c7ffc90c), {
            space: "space.100",
            children: [
                /*#__PURE__*/ (0, $i3UfC.jsx)((0, $383dd904a5a5e5b0$export$e71c4d32a2263218), {
                    as: "label",
                    htmlFor: siteSelectorId,
                    children: /*#__PURE__*/ (0, $i3UfC.jsx)((0, $82315a19372f332f$export$2e2bcd8739ae039), {
                        size: "small",
                        children: formatMessage($4f1f3281c07da3d2$var$messages.siteLabel)
                    })
                }),
                /*#__PURE__*/ (0, $i3UfC.jsx)((0, $5330bbf7705e7e35$export$2e2bcd8739ae039), {
                    inputId: siteSelectorId,
                    options: workspaceOptions,
                    isSearchable: true,
                    placeholder: formatMessage($4f1f3281c07da3d2$var$messages.sitePlaceholder),
                    value: selectedOption,
                    onChange: (option)=>{
                        const site = option ? String(option.value) : null;
                        if (!site) {
                            setSelectedWorkspace(null);
                            setSelectedOrg(null);
                        } else {
                            const orgId = siteToOrgId.get(site) ?? null;
                            setSelectedWorkspace(site);
                            if (orgId !== selectedOrg) setSelectedOrg(orgId);
                        }
                    }
                })
            ]
        })
    });
};
var $4f1f3281c07da3d2$export$2e2bcd8739ae039 = $4f1f3281c07da3d2$var$SiteSelector;



var $6hgMx = parcelRequire("6hgMx");

var $i3UfC = parcelRequire("i3UfC");


var $6bnW7 = parcelRequire("6bnW7");
var $hrVKU = parcelRequire("hrVKU");
const $e701fc9f19d87432$var$messages = (0, $6bnW7.defineMessages)({
    authorizationTitle: {
        id: 'oauth.twg.authorizationBanner.title',
        defaultMessage: 'Verify this authorization request',
        description: 'Title for the TWG authorization request verification banner'
    },
    authorizationBody: {
        id: 'oauth.twg.authorizationBanner.body',
        defaultMessage: 'Accept only if you created this request while authenticating the Teamwork Graph (twg) CLI on your own device.',
        description: 'Body for the TWG authorization request verification banner'
    }
});
const $e701fc9f19d87432$var$TwgConsentBanners = ()=>{
    const { formatMessage: formatMessage } = (0, $hrVKU.default)();
    return /*#__PURE__*/ (0, $i3UfC.jsx)((0, $ac2404b057b8688e$export$2e2bcd8739ae039), {
        appearance: "warning",
        title: formatMessage($e701fc9f19d87432$var$messages.authorizationTitle),
        children: formatMessage($e701fc9f19d87432$var$messages.authorizationBody)
    });
};
var $e701fc9f19d87432$export$2e2bcd8739ae039 = $e701fc9f19d87432$var$TwgConsentBanners;



var $i3UfC = parcelRequire("i3UfC");



var $6bnW7 = parcelRequire("6bnW7");
var $bgNpv = parcelRequire("bgNpv");

var $6hgMx = parcelRequire("6hgMx");
const $fa0db8468f821111$var$messages = (0, $6bnW7.defineMessages)({
    accessBodyWithOrganization: {
        id: 'oauth.twg.siteAccessNotice.accessBodyWithOrganization',
        defaultMessage: 'Choosing this site ({site}) authorizes Teamwork Graph CLI to access any data that your account can access across all sites in the organization ({organization}).',
        description: 'Notice shown near the TWG accept button explaining that site selection grants organization-wide site access when the selected organization name is known'
    },
    accessBodyWithoutOrganization: {
        id: 'oauth.twg.siteAccessNotice.accessBodyWithoutOrganization',
        defaultMessage: 'Choosing this site ({site}) authorizes Teamwork Graph CLI to access any data that your account can access across all sites in the organization.',
        description: 'Notice shown near the TWG accept button explaining that site selection grants organization-wide site access when the selected organization name is unavailable'
    }
});
const $fa0db8468f821111$var$styles = {
    notice: {
        alignItems: 'flex-start',
        color: 'var(--twg-muted)',
        display: 'flex',
        gap: '8px',
        maxWidth: '772px',
        width: '100%'
    },
    icon: {
        flexShrink: 0,
        marginTop: '2px'
    },
    text: {
        fontSize: '14px',
        fontWeight: 400,
        lineHeight: '20px',
        margin: 0
    }
};
const $fa0db8468f821111$var$getDisplayOrganizationName = (name)=>{
    const trimmedName = name?.trim();
    if (!trimmedName || /^\{\{.*\}\}$/.test(trimmedName)) return undefined;
    return trimmedName;
};
const $fa0db8468f821111$var$TwgSiteAccessNotice = ()=>{
    const { selectedWorkspace: selectedWorkspace } = (0, $6hgMx.useSelectedWorkspace)();
    const consentInfo = (0, $6hgMx.useInfo)();
    if (!selectedWorkspace) return null;
    const displayOrganizationName = $fa0db8468f821111$var$getDisplayOrganizationName(consentInfo.selectedOrgInfo?.name);
    return /*#__PURE__*/ (0, $i3UfC.jsxs)("div", {
        style: $fa0db8468f821111$var$styles.notice,
        children: [
            /*#__PURE__*/ (0, $i3UfC.jsx)("span", {
                style: $fa0db8468f821111$var$styles.icon,
                "aria-hidden": "true",
                children: /*#__PURE__*/ (0, $i3UfC.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($37990044355ecd18$exports))), {
                    label: "",
                    color: (0, $37190500189da037$export$9e1725a4cfeada27)('color.icon.information'),
                    size: "small"
                })
            }),
            /*#__PURE__*/ (0, $i3UfC.jsx)("p", {
                style: $fa0db8468f821111$var$styles.text,
                children: displayOrganizationName ? /*#__PURE__*/ (0, $i3UfC.jsx)((0, $bgNpv.default), {
                    ...$fa0db8468f821111$var$messages.accessBodyWithOrganization,
                    values: {
                        site: /*#__PURE__*/ (0, $i3UfC.jsx)("strong", {
                            children: selectedWorkspace
                        }),
                        organization: /*#__PURE__*/ (0, $i3UfC.jsx)("strong", {
                            children: displayOrganizationName
                        })
                    }
                }) : /*#__PURE__*/ (0, $i3UfC.jsx)((0, $bgNpv.default), {
                    ...$fa0db8468f821111$var$messages.accessBodyWithoutOrganization,
                    values: {
                        site: /*#__PURE__*/ (0, $i3UfC.jsx)("strong", {
                            children: selectedWorkspace
                        })
                    }
                })
            })
        ]
    });
};
var $fa0db8468f821111$export$2e2bcd8739ae039 = $fa0db8468f821111$var$TwgSiteAccessNotice;



var $i3UfC = parcelRequire("i3UfC");

var $6bnW7 = parcelRequire("6bnW7");
var $bgNpv = parcelRequire("bgNpv");
var $hrVKU = parcelRequire("hrVKU");
var $2cb29121ea75d357$exports = {};
$2cb29121ea75d357$exports = new URL("search-failed.4dbd6043.svg", import.meta.url).toString();



var $9KGFe = parcelRequire("9KGFe");
const $fc51540d63e4ad37$export$bf13c4107ff8ff42 = 'https://developer.atlassian.com/cloud/twg-cli/';


const $71aae3dcb8cf1449$var$messages = (0, $6bnW7.defineMessages)({
    blockedHeading: {
        id: 'oauth.twg.emptyState.blocked.heading',
        defaultMessage: 'Permissions are blocked for this site',
        description: 'Heading shown when organization policy blocks TWG permissions for the selected site'
    },
    blockedDescription: {
        id: 'oauth.twg.emptyState.blocked.description',
        defaultMessage: 'Contact your organization admin to request access or see {howPermissionsLink}',
        description: 'Description shown when organization policy blocks TWG permissions'
    },
    howPermissionsManaged: {
        id: 'oauth.twg.emptyState.blocked.link',
        defaultMessage: 'how permissions are managed',
        description: 'Link text for documentation about permission management'
    },
    networkHeading: {
        id: 'oauth.twg.emptyState.network.heading',
        defaultMessage: 'Something went wrong',
        description: 'Heading shown when TWG permissions could not be loaded because of a network failure'
    },
    networkDescription: {
        id: 'oauth.twg.emptyState.network.description',
        defaultMessage: "We're having trouble showing permissions right now. You can try refreshing the page or {supportLink}",
        description: 'Description shown when TWG permissions could not be loaded because of a network failure'
    },
    contactSupport: {
        id: 'oauth.twg.emptyState.network.link',
        defaultMessage: 'contact support',
        description: 'Link text to Atlassian support'
    },
    noSitesHeading: {
        id: 'oauth.twg.emptyState.noSites.heading',
        defaultMessage: 'Supported sites required',
        description: 'Heading shown when the user has no supported sites for Teamwork Graph CLI'
    },
    noSitesDescription: {
        id: 'oauth.twg.emptyState.noSites.description',
        defaultMessage: "Teamwork Graph CLI connects with Atlassian sites that use apps like Jira or Confluence. Your account isn't currently associated with a supported site. {learnMoreLink}",
        description: 'Description shown when the user has no supported sites for Teamwork Graph CLI'
    },
    learnMore: {
        id: 'oauth.twg.emptyState.noSites.link',
        defaultMessage: 'Understand Teamwork Graph CLI',
        description: 'Link text for Teamwork Graph CLI documentation when no supported sites are available'
    }
});
const $71aae3dcb8cf1449$var$styles = {
    root: {
        alignItems: 'center',
        color: 'var(--twg-muted)',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        marginInline: 'auto',
        maxWidth: '640px',
        minHeight: '420px',
        textAlign: 'center',
        width: '100%'
    },
    iconWrap: {
        alignItems: 'center',
        display: 'flex',
        height: '132px',
        justifyContent: 'center',
        marginBottom: '32px',
        width: '132px'
    },
    searchIcon: {
        display: 'block',
        height: '132px',
        width: '132px'
    },
    warningIcon: {
        borderBottomColor: 'var(--twg-empty-icon)',
        borderBottomStyle: 'solid',
        borderBottomWidth: '112px',
        borderLeftColor: 'transparent',
        borderLeftStyle: 'solid',
        borderLeftWidth: '64px',
        borderRightColor: 'transparent',
        borderRightStyle: 'solid',
        borderRightWidth: '64px',
        height: 0,
        position: 'relative',
        width: 0
    },
    warningMark: {
        color: '#ffffff',
        fontSize: '56px',
        fontWeight: 500,
        left: '-8px',
        lineHeight: '56px',
        position: 'absolute',
        top: '38px'
    },
    heading: {
        color: 'var(--twg-text)',
        fontSize: '24px',
        fontWeight: 700,
        lineHeight: '32px',
        marginBlockEnd: '12px',
        marginBlockStart: 0
    },
    description: {
        color: 'var(--twg-muted)',
        fontSize: '16px',
        fontWeight: 600,
        lineHeight: '24px',
        margin: 0
    },
    link: {
        color: 'var(--twg-link)',
        fontWeight: 700,
        textDecoration: 'none'
    }
};
const $71aae3dcb8cf1449$var$WarningTriangle = ()=>/*#__PURE__*/ (0, $i3UfC.jsx)("span", {
        style: $71aae3dcb8cf1449$var$styles.iconWrap,
        "aria-hidden": "true",
        children: /*#__PURE__*/ (0, $i3UfC.jsx)("span", {
            style: $71aae3dcb8cf1449$var$styles.warningIcon,
            children: /*#__PURE__*/ (0, $i3UfC.jsx)("span", {
                style: $71aae3dcb8cf1449$var$styles.warningMark,
                children: "!"
            })
        })
    });
const $71aae3dcb8cf1449$var$StateIcon = ({ variant: variant })=>{
    if (variant === 'blocked') return /*#__PURE__*/ (0, $i3UfC.jsx)("span", {
        style: $71aae3dcb8cf1449$var$styles.iconWrap,
        "aria-hidden": "true",
        children: /*#__PURE__*/ (0, $i3UfC.jsx)("img", {
            src: (0, (/*@__PURE__*/$parcel$interopDefault($2cb29121ea75d357$exports))),
            alt: "",
            style: $71aae3dcb8cf1449$var$styles.searchIcon
        })
    });
    return /*#__PURE__*/ (0, $i3UfC.jsx)($71aae3dcb8cf1449$var$WarningTriangle, {});
};
const $71aae3dcb8cf1449$var$TwgEmptyState = ({ variant: variant })=>{
    const { formatMessage: formatMessage } = (0, $hrVKU.default)();
    const { support: support, twg: twg } = (0, $9KGFe.getConfig)();
    let heading;
    let description;
    if (variant === 'blocked') {
        heading = formatMessage($71aae3dcb8cf1449$var$messages.blockedHeading);
        description = /*#__PURE__*/ (0, $i3UfC.jsx)((0, $bgNpv.default), {
            ...$71aae3dcb8cf1449$var$messages.blockedDescription,
            values: {
                howPermissionsLink: /*#__PURE__*/ (0, $i3UfC.jsx)("a", {
                    href: twg.permissionsManagementDocUrl,
                    target: "_blank",
                    rel: "noopener noreferrer",
                    style: $71aae3dcb8cf1449$var$styles.link,
                    children: formatMessage($71aae3dcb8cf1449$var$messages.howPermissionsManaged)
                })
            }
        });
    } else if (variant === 'network') {
        heading = formatMessage($71aae3dcb8cf1449$var$messages.networkHeading);
        description = /*#__PURE__*/ (0, $i3UfC.jsx)((0, $bgNpv.default), {
            ...$71aae3dcb8cf1449$var$messages.networkDescription,
            values: {
                supportLink: /*#__PURE__*/ (0, $i3UfC.jsx)("a", {
                    href: support.contactSupportUrl,
                    target: "_blank",
                    rel: "noopener noreferrer",
                    style: $71aae3dcb8cf1449$var$styles.link,
                    children: formatMessage($71aae3dcb8cf1449$var$messages.contactSupport)
                })
            }
        });
    } else {
        heading = formatMessage($71aae3dcb8cf1449$var$messages.noSitesHeading);
        description = /*#__PURE__*/ (0, $i3UfC.jsx)((0, $bgNpv.default), {
            ...$71aae3dcb8cf1449$var$messages.noSitesDescription,
            values: {
                learnMoreLink: /*#__PURE__*/ (0, $i3UfC.jsx)("a", {
                    href: (0, $fc51540d63e4ad37$export$bf13c4107ff8ff42),
                    target: "_blank",
                    rel: "noopener noreferrer",
                    style: $71aae3dcb8cf1449$var$styles.link,
                    children: formatMessage($71aae3dcb8cf1449$var$messages.learnMore)
                })
            }
        });
    }
    return /*#__PURE__*/ (0, $i3UfC.jsxs)("div", {
        style: $71aae3dcb8cf1449$var$styles.root,
        children: [
            /*#__PURE__*/ (0, $i3UfC.jsx)($71aae3dcb8cf1449$var$StateIcon, {
                variant: variant
            }),
            /*#__PURE__*/ (0, $i3UfC.jsx)("h2", {
                style: $71aae3dcb8cf1449$var$styles.heading,
                children: heading
            }),
            /*#__PURE__*/ (0, $i3UfC.jsx)("p", {
                style: $71aae3dcb8cf1449$var$styles.description,
                children: description
            })
        ]
    });
};
var $71aae3dcb8cf1449$export$2e2bcd8739ae039 = $71aae3dcb8cf1449$var$TwgEmptyState;


const $4b0b0a8dd164e37c$var$messages = (0, $6bnW7.defineMessages)({
    permissionsHeading: {
        id: 'oauth.twg.permissions.sectionTitle',
        defaultMessage: 'Permissions',
        description: 'Section heading for TWG permissions'
    }
});
const $4b0b0a8dd164e37c$var$styles = {
    root: {
        display: 'flex',
        flexDirection: 'column',
        gap: '36px',
        width: '100%'
    },
    loading: {
        paddingBlockStart: '4px'
    },
    permissionsRegion: {
        display: 'flex',
        flexDirection: 'column',
        gap: '40px'
    }
};
const $4b0b0a8dd164e37c$var$TWG = ({ defaultPermissionsEditMode: defaultPermissionsEditMode = false, permissionsEditMode: permissionsEditMode, onPermissionsEditModeChange: onPermissionsEditModeChange })=>{
    const { availableOrganizations: availableOrganizations = [] } = (0, $6hgMx.useInfo)();
    const { selectedOrg: selectedOrg, isOrgLoading: isOrgLoading, orgError: orgError } = (0, $6hgMx.useSelectedOrg)();
    const { selectedWorkspace: selectedWorkspace } = (0, $6hgMx.useSelectedWorkspace)();
    const { formatMessage: formatMessage } = (0, $hrVKU.default)();
    const hasSites = availableOrganizations.some((org)=>(org.availableWorkspaces ?? []).length > 0);
    const orgSelected = !!selectedOrg && !isOrgLoading && !orgError;
    const permissionsVisible = orgSelected && !!selectedWorkspace;
    const errorVariant = orgError?.error === 'no-scopes' ? 'blocked' : orgError ? 'network' : null;
    if (!hasSites) return /*#__PURE__*/ (0, $i3UfC.jsx)("div", {
        style: $4b0b0a8dd164e37c$var$styles.root,
        children: /*#__PURE__*/ (0, $i3UfC.jsx)((0, $71aae3dcb8cf1449$export$2e2bcd8739ae039), {
            variant: "no-sites"
        })
    });
    return /*#__PURE__*/ (0, $i3UfC.jsxs)("div", {
        style: $4b0b0a8dd164e37c$var$styles.root,
        children: [
            !errorVariant && /*#__PURE__*/ (0, $i3UfC.jsx)((0, $e701fc9f19d87432$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $i3UfC.jsx)((0, $4f1f3281c07da3d2$export$2e2bcd8739ae039), {}),
            !errorVariant && isOrgLoading && /*#__PURE__*/ (0, $i3UfC.jsx)("div", {
                style: $4b0b0a8dd164e37c$var$styles.loading,
                children: /*#__PURE__*/ (0, $i3UfC.jsx)((0, $6f7e5f007cf95a87$export$2e2bcd8739ae039), {
                    size: "medium",
                    label: "Loading permissions",
                    delay: 0
                })
            }),
            errorVariant && /*#__PURE__*/ (0, $i3UfC.jsxs)((0, $i3UfC.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $i3UfC.jsx)((0, $82315a19372f332f$export$2e2bcd8739ae039), {
                        size: "small",
                        children: formatMessage($4b0b0a8dd164e37c$var$messages.permissionsHeading)
                    }),
                    /*#__PURE__*/ (0, $i3UfC.jsx)((0, $71aae3dcb8cf1449$export$2e2bcd8739ae039), {
                        variant: errorVariant
                    })
                ]
            }),
            !errorVariant && /* Keep PermissionsBullets mounted to preserve expand state; hide it until site policy is resolved */ /*#__PURE__*/ (0, $i3UfC.jsxs)("div", {
                style: {
                    ...$4b0b0a8dd164e37c$var$styles.permissionsRegion,
                    display: permissionsVisible ? 'flex' : 'none'
                },
                children: [
                    permissionsVisible && /*#__PURE__*/ (0, $i3UfC.jsx)((0, $fa0db8468f821111$export$2e2bcd8739ae039), {}),
                    /*#__PURE__*/ (0, $i3UfC.jsx)((0, $f40a48e733a91cb2$export$2e2bcd8739ae039), {
                        defaultEditMode: defaultPermissionsEditMode,
                        editMode: permissionsEditMode,
                        onEditModeChange: onPermissionsEditModeChange
                    })
                ]
            })
        ]
    });
};
var $4b0b0a8dd164e37c$export$2e2bcd8739ae039 = $4b0b0a8dd164e37c$var$TWG;



var $i3UfC = parcelRequire("i3UfC");

var $gDiFE = parcelRequire("gDiFE");


var $i3UfC = parcelRequire("i3UfC");

var $gDiFE = parcelRequire("gDiFE");

var $i3UfC = parcelRequire("i3UfC");



var $i3UfC = parcelRequire("i3UfC");


var $gDiFE = parcelRequire("gDiFE");

var $6hgMx = parcelRequire("6hgMx");
const $ce8d3b8a8c9e5b4d$var$initialStyle = (0, $gDiFE.xcss)({
    font: 'font.heading.xlarge'
});
const $ce8d3b8a8c9e5b4d$var$Logo = ()=>{
    const { clientName: clientName } = (0, $6hgMx.useToken)();
    const displayName = clientName?.trim() || '';
    const initial = (displayName || '?').charAt(0).toUpperCase();
    return /*#__PURE__*/ (0, $i3UfC.jsx)((0, $0020f204f1f5986b$export$2e2bcd8739ae039), {
        label: displayName,
        size: "xlarge",
        backgroundColor: "color.background.neutral",
        hasBorder: true,
        children: /*#__PURE__*/ (0, $i3UfC.jsx)((0, $d48daa9a522ca942$export$5f1af8db9871e1d6), {
            weight: "bold",
            color: "color.text.subtlest",
            align: "center",
            children: /*#__PURE__*/ (0, $i3UfC.jsx)((0, $383dd904a5a5e5b0$export$e71c4d32a2263218), {
                as: "span",
                xcss: $ce8d3b8a8c9e5b4d$var$initialStyle,
                children: initial
            })
        })
    });
};
var $ce8d3b8a8c9e5b4d$export$2e2bcd8739ae039 = $ce8d3b8a8c9e5b4d$var$Logo;


/* AtlassianUserIcon.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $i3UfC = parcelRequire("i3UfC");
parcelRequire("5FkrB");





var $f5RPY = parcelRequire("f5RPY");

const $e8ca625e620f9696$var$_4 = "._1yt4u2gc{padding:var(--ds-space-100,8px)}";
const $e8ca625e620f9696$var$_3 = "._19pkxmi2{margin-top:var(--ds-space-negative-150,-9pt)}";
const $e8ca625e620f9696$var$_2 = "._18u0xmi2{margin-left:var(--ds-space-negative-150,-9pt)}";
const $e8ca625e620f9696$var$_ = "._1wpz1y6m{align-self:flex-start}";
const $e8ca625e620f9696$var$styles = {
    avatarStyle: "_1wpz1y6m _18u0xmi2 _19pkxmi2",
    iconStyle: "_1yt4u2gc"
};
const $e8ca625e620f9696$var$AtlassianUserIcon = ({ icon: icon })=>{
    const user = (0, $f5RPY.useUser)();
    return /*#__PURE__*/ (0, $i3UfC.jsxs)((0, $10b0af967ce59e29$export$fbae5b5ffd8af05e), {
        alignInline: 'center',
        children: [
            icon ?? /*#__PURE__*/ (0, $i3UfC.jsx)((0, $0020f204f1f5986b$export$2e2bcd8739ae039), {
                label: "",
                size: "xlarge",
                backgroundColor: "color.background.brand.bold",
                isInset: false,
                children: /*#__PURE__*/ (0, $i3UfC.jsxs)((0, $dbdf44c207cf40e4$export$2e2bcd8739ae039), {
                    children: [
                        /*#__PURE__*/ (0, $i3UfC.jsx)((0, $c179d2a16dc49323$export$2e2bcd8739ae039), {
                            children: [
                                $e8ca625e620f9696$var$_,
                                $e8ca625e620f9696$var$_2,
                                $e8ca625e620f9696$var$_3,
                                $e8ca625e620f9696$var$_4
                            ]
                        }),
                        /*#__PURE__*/ (0, $i3UfC.jsx)((0, $383dd904a5a5e5b0$export$e71c4d32a2263218), {
                            xcss: $e8ca625e620f9696$var$styles.iconStyle,
                            children: /*#__PURE__*/ (0, $i3UfC.jsx)((0, $50101e7733a6b1d7$export$8a485e2e7ed91e8f), {
                                size: "xlarge",
                                appearance: "inverse"
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $i3UfC.jsx)((0, $467b7370bd97bdfa$export$2e2bcd8739ae039), {
                size: "small",
                src: user?.picture,
                // apply styling to put the avatar in the top-right corner
                as: ({ children: children, ...props })=>/*#__PURE__*/ (0, $i3UfC.jsxs)((0, $dbdf44c207cf40e4$export$2e2bcd8739ae039), {
                        children: [
                            /*#__PURE__*/ (0, $i3UfC.jsx)((0, $c179d2a16dc49323$export$2e2bcd8739ae039), {
                                children: [
                                    $e8ca625e620f9696$var$_,
                                    $e8ca625e620f9696$var$_2,
                                    $e8ca625e620f9696$var$_3,
                                    $e8ca625e620f9696$var$_4
                                ]
                            }),
                            /*#__PURE__*/ (0, $i3UfC.jsx)("div", {
                                ...props,
                                className: (0, $b02ab0e3a0f362dd$export$2e2bcd8739ae039)([
                                    $e8ca625e620f9696$var$styles.avatarStyle
                                ]),
                                children: children
                            })
                        ]
                    })
            })
        ]
    });
};
var $e8ca625e620f9696$export$2e2bcd8739ae039 = $e8ca625e620f9696$var$AtlassianUserIcon;


const $46f6010b46892b4b$var$AppLogos = ({ icon: icon })=>/*#__PURE__*/ (0, $i3UfC.jsxs)((0, $04267de539304abd$export$fbae5b5ffd8af05e), {
        alignBlock: "center",
        space: 'space.100',
        children: [
            /*#__PURE__*/ (0, $i3UfC.jsx)((0, $ce8d3b8a8c9e5b4d$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $i3UfC.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($94d2f5c76a2afb62$exports))), {
                label: ""
            }),
            /*#__PURE__*/ (0, $i3UfC.jsx)((0, $e8ca625e620f9696$export$2e2bcd8739ae039), {
                icon: icon
            })
        ]
    });
var $46f6010b46892b4b$export$2e2bcd8739ae039 = $46f6010b46892b4b$var$AppLogos;



var $i3UfC = parcelRequire("i3UfC");

var $gDiFE = parcelRequire("gDiFE");

var $bgNpv = parcelRequire("bgNpv");

var $6hgMx = parcelRequire("6hgMx");

var $fLAke = parcelRequire("fLAke");

var $6bnW7 = parcelRequire("6bnW7");
const $d52e21d402ac3e18$export$665eaadbadd85ff1 = (0, $6bnW7.defineMessages)({
    title: {
        id: 'oauth.shared.headline.redirectHost',
        defaultMessage: '{requestingParty} is requesting access to your {product} account',
        description: 'Consent headline shown at the top of the page; {requestingParty} is the app or host name'
    },
    forgeAppTitle: {
        id: 'oauth.shared.headline.forgeApp',
        defaultMessage: '{requestingParty} is requesting access to {appName}',
        description: 'Forge MCP consent headline; {requestingParty} is the requesting agent and {appName} is the Forge app it wants to access'
    }
});


const $7a1ab7fd34d14274$var$headlineTextStyles = (0, $gDiFE.xcss)({
    margin: 'space.0',
    font: 'font.heading.large',
    color: 'color.text'
});
const $7a1ab7fd34d14274$var$Header = ({ product: product = 'Atlassian' })=>{
    const { clientName: clientName } = (0, $6hgMx.useToken)();
    const info = (0, $6hgMx.useInfo)();
    const forgeAppName = (0, $fLAke.getForgeMcpAppName)(info);
    return /*#__PURE__*/ (0, $i3UfC.jsx)((0, $383dd904a5a5e5b0$export$e71c4d32a2263218), {
        as: "h1",
        xcss: $7a1ab7fd34d14274$var$headlineTextStyles,
        children: /*#__PURE__*/ (0, $i3UfC.jsx)((0, $bgNpv.default), {
            ...forgeAppName ? (0, $d52e21d402ac3e18$export$665eaadbadd85ff1).forgeAppTitle : (0, $d52e21d402ac3e18$export$665eaadbadd85ff1).title,
            values: {
                requestingParty: clientName,
                product: product,
                appName: forgeAppName
            }
        })
    });
};
var $7a1ab7fd34d14274$export$2e2bcd8739ae039 = $7a1ab7fd34d14274$var$Header;


const $355d8bd71a4077ad$var$logosRowStyle = (0, $gDiFE.xcss)({
    width: '100%'
});
const $355d8bd71a4077ad$var$Headline = ({ icon: icon, product: product })=>{
    return /*#__PURE__*/ (0, $i3UfC.jsxs)((0, $1b254ba6a068f2f1$export$f51f4c4ede09e011), {
        direction: "column",
        gap: "space.500",
        children: [
            /*#__PURE__*/ (0, $i3UfC.jsx)((0, $383dd904a5a5e5b0$export$e71c4d32a2263218), {
                xcss: $355d8bd71a4077ad$var$logosRowStyle,
                children: /*#__PURE__*/ (0, $i3UfC.jsx)((0, $46f6010b46892b4b$export$2e2bcd8739ae039), {
                    icon: icon
                })
            }),
            /*#__PURE__*/ (0, $i3UfC.jsx)((0, $7a1ab7fd34d14274$export$2e2bcd8739ae039), {
                product: product
            })
        ]
    });
};
var $355d8bd71a4077ad$export$2e2bcd8739ae039 = $355d8bd71a4077ad$var$Headline;



var $i3UfC = parcelRequire("i3UfC");

var $5FkrB = parcelRequire("5FkrB");

var $6hgMx = parcelRequire("6hgMx");

var $i3UfC = parcelRequire("i3UfC");

var $bgNpv = parcelRequire("bgNpv");


var $gDiFE = parcelRequire("gDiFE");
const $7291219ac426432c$var$detailsHeadingStyle = (0, $gDiFE.xcss)({
    marginBottom: 'space.150'
});
const $7291219ac426432c$var$detailLabelStyle = (0, $gDiFE.xcss)({
    width: 'size.600',
    flexShrink: 0
});
const $7291219ac426432c$var$Details = ({ title: title, entries: entries })=>{
    return /*#__PURE__*/ (0, $i3UfC.jsxs)((0, $c8dbef6c41cfa689$export$694e0d28c7ffc90c), {
        children: [
            /*#__PURE__*/ (0, $i3UfC.jsx)((0, $383dd904a5a5e5b0$export$e71c4d32a2263218), {
                xcss: $7291219ac426432c$var$detailsHeadingStyle,
                children: /*#__PURE__*/ (0, $i3UfC.jsx)((0, $82315a19372f332f$export$2e2bcd8739ae039), {
                    size: "small",
                    children: /*#__PURE__*/ (0, $i3UfC.jsx)((0, $bgNpv.default), {
                        ...title
                    })
                })
            }),
            /*#__PURE__*/ (0, $i3UfC.jsx)((0, $c8dbef6c41cfa689$export$694e0d28c7ffc90c), {
                space: "space.075",
                children: entries.map((entry)=>{
                    const values = Array.isArray(entry.value) ? entry.value : [
                        entry.value
                    ];
                    if (values.length === 0) return null;
                    return /*#__PURE__*/ (0, $i3UfC.jsxs)((0, $1b254ba6a068f2f1$export$f51f4c4ede09e011), {
                        gap: "space.050",
                        children: [
                            /*#__PURE__*/ (0, $i3UfC.jsx)((0, $383dd904a5a5e5b0$export$e71c4d32a2263218), {
                                xcss: $7291219ac426432c$var$detailLabelStyle,
                                children: /*#__PURE__*/ (0, $i3UfC.jsxs)((0, $d48daa9a522ca942$export$5f1af8db9871e1d6), {
                                    as: "span",
                                    weight: entry.useFieldLabelStyle ? 'medium' : 'bold',
                                    color: entry.useFieldLabelStyle ? 'color.text.subtle' : undefined,
                                    children: [
                                        /*#__PURE__*/ (0, $i3UfC.jsx)((0, $bgNpv.default), {
                                            ...entry.label
                                        }),
                                        ':'
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $i3UfC.jsx)((0, $c8dbef6c41cfa689$export$694e0d28c7ffc90c), {
                                space: "space.025",
                                children: values.map((v)=>/*#__PURE__*/ (0, $i3UfC.jsx)((0, $d48daa9a522ca942$export$5f1af8db9871e1d6), {
                                        as: "span",
                                        color: entry.useSubtleValueColor ? 'color.text.subtle' : undefined,
                                        children: v
                                    }, v))
                            })
                        ]
                    }, entry.label.id);
                })
            })
        ]
    });
};
var $7291219ac426432c$export$2e2bcd8739ae039 = $7291219ac426432c$var$Details;



var $6bnW7 = parcelRequire("6bnW7");
const $cae4c5570f2c20a1$export$3296e679653759e = (0, $6bnW7.defineMessages)({
    detailsTitle: {
        id: 'oauth.a2a.details.title',
        defaultMessage: 'Details',
        description: 'Section heading for A2A app details'
    },
    nameLabel: {
        id: 'oauth.a2a.details.nameLabel',
        defaultMessage: 'Name',
        description: 'Label for the app name detail row'
    },
    domainLabel: {
        id: 'oauth.mcp.details.domainLabel',
        defaultMessage: 'Domains',
        description: 'Label for the Domain URL detail row'
    }
});


/**
 * A2A-specific details component.
 * Renders Name and Redirect URL rows.
 */ const $b9bf0509ed783ce4$var$A2ADetails = ()=>{
    const { clientName: clientName, redirectUrl: redirectUrl } = (0, $6hgMx.useToken)();
    const { client: client } = (0, $6hgMx.useInfo)();
    const redirectUrls = (0, $5FkrB.useMemo)(()=>{
        const seen = new Set();
        const urls = [];
        const add = (u)=>{
            const t = u?.trim();
            if (t && !seen.has(t)) {
                seen.add(t);
                urls.push(t);
            }
        };
        add(redirectUrl?.callback);
        (client?.callbacks ?? []).forEach(add);
        return urls;
    }, [
        redirectUrl,
        client?.callbacks
    ]);
    const entries = [
        {
            label: (0, $cae4c5570f2c20a1$export$3296e679653759e).nameLabel,
            value: clientName ?? ''
        },
        ...redirectUrls.length > 0 ? [
            {
                label: (0, $cae4c5570f2c20a1$export$3296e679653759e).domainLabel,
                value: redirectUrls
            }
        ] : []
    ];
    return /*#__PURE__*/ (0, $i3UfC.jsx)((0, $7291219ac426432c$export$2e2bcd8739ae039), {
        title: (0, $cae4c5570f2c20a1$export$3296e679653759e).detailsTitle,
        entries: entries
    });
};
var $b9bf0509ed783ce4$export$2e2bcd8739ae039 = $b9bf0509ed783ce4$var$A2ADetails;



var $i3UfC = parcelRequire("i3UfC");
/* SiteSelector.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $i3UfC = parcelRequire("i3UfC");

var $5FkrB = parcelRequire("5FkrB");



var $5FkrB = parcelRequire("5FkrB");




/* actions-container.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $5FkrB = parcelRequire("5FkrB");
/**
 * The length of the value hash portion of an atomic class name.
 * Atomic class names have the format: `_<group><value>`
 * where group is ATOMIC_GROUP_HASH_LENGTH chars and value is ATOMIC_VALUE_HASH_LENGTH chars.
 *
 * We extract the group key using: `className.slice(0, className.length - ATOMIC_VALUE_HASH_LENGTH)`
 *
 * We support both old-format classes (9 chars: `_` + 4 group + 4 value) and
 * new-format classes (11 chars: `_` + 6 group + 4 value) by using length-based
 * extraction rather than a hardcoded offset — old and new format group keys
 * are different lengths so they are structurally disjoint and never alias each other.
 */ const $25bde311ed7fa5e4$var$ATOMIC_VALUE_HASH_LENGTH = 4;
function $25bde311ed7fa5e4$export$2e2bcd8739ae039(classNames) {
    // Shortcut: nothing to do
    if (!classNames.length) return;
    // Shortcut: don't need to do anything if we only have a single classname
    if (classNames.length === 1 && classNames[0] && // checking to see if `classNames[0]` is a string that contains other classnames
    !classNames[0].includes(' ')) return classNames[0];
    // Using an object rather than a `Map` as it performed better in our benchmarks.
    // Would be happy to move to `Map` if it proved to be better under real conditions.
    const map = {};
    // Note: using loops to minimize iterations over the collection
    for (const value of classNames){
        // Exclude all falsy values, which leaves us with populated strings
        if (!value) continue;
        // a `value` can contain multiple classnames
        const list = value.split(' ');
        for (const className of list){
            /**
             * For atomic style classnames: the `key` is the `group`
             *
             * - Later atomic classnames with the same `group` will override earlier ones
             *   (which is what we want).
             * - Assumes atomic classnames are the only things that start with `_`
             * - Could use a regex to ensure that atomic classnames are structured how we expect,
             *   but did not add that for now as it did slow things down a bit.
             *
             * For other classnames: the `key` is the whole classname
             * - Okay to remove duplicates as doing so does not impact specificity
             *
             * */ const key = className.startsWith('_') ? className.slice(0, className.length - $25bde311ed7fa5e4$var$ATOMIC_VALUE_HASH_LENGTH) : className;
            map[key] = className;
        }
    }
    /**
     * We are converting the `map` into a string.
     *
     * The simple way to do this would be `Object.values(map).join(' ')`.
     * However, the approach below performs 10%-20% better in benchmarks.
     *
     * For `ax()` it feels right to squeeze as much runtime performance out as we can.
     */ let result = '';
    for(const key in map)result += map[key] + ' ';
    // If we have an empty string, then our `map` was empty.
    if (!result) return;
    // remove last " " from the result (we added " " at the end of every value)
    return result.trimEnd();
}


var $44124a981e9227cb$var$actionsStyles = null;
/**
 * __Actions container__
 *
 * A container for actions: primary action, secondary action, and tertiary action.
 *
 * @internal
 */ var $44124a981e9227cb$var$ActionsContainer = function ActionsContainer(_ref) {
    var children = _ref.children;
    return /*#__PURE__*/ $5FkrB.createElement("div", {
        className: (0, $25bde311ed7fa5e4$export$2e2bcd8739ae039)([
            "_1e0c1txw _4cvr1h6o _1bah1h6o _6rthu2gc _bozg1jfw"
        ])
    }, children);
};
var $44124a981e9227cb$export$2e2bcd8739ae039 = $44124a981e9227cb$var$ActionsContainer;


/* container.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $5FkrB = parcelRequire("5FkrB");

var $3a73f390fa3336aa$var$containerStyles = null;
/* Use max-width so the component can shrink on smaller viewports. */ var $3a73f390fa3336aa$var$wideContainerStyles = null;
var $3a73f390fa3336aa$var$narrowContainerStyles = null;
/**
 * __Container__
 *
 * Upper level container for Empty State.
 *
 * @internal
 */ var $3a73f390fa3336aa$var$Container = function Container(_ref) {
    var children = _ref.children, width = _ref.width, testId = _ref.testId;
    return /*#__PURE__*/ $5FkrB.createElement("div", {
        "data-testid": testId,
        className: (0, $25bde311ed7fa5e4$export$2e2bcd8739ae039)([
            "_6rthoahv _1pfhoahv _12l21wug _ahbq1wug _y3gn1h6o",
            width === 'narrow' ? "_p12fko4j" : "_p12f1pl1"
        ])
    }, children);
};
var $3a73f390fa3336aa$export$2e2bcd8739ae039 = $3a73f390fa3336aa$var$Container;


/* image.tsx generated by @compiled/babel-plugin v2.0.0 */ function $01743b5cb49f44f1$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $01743b5cb49f44f1$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $01743b5cb49f44f1$export$2e2bcd8739ae039(o);
}



function $2387985b847e7077$export$2e2bcd8739ae039(t, r) {
    if ("object" != (0, $01743b5cb49f44f1$export$2e2bcd8739ae039)(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (0, $01743b5cb49f44f1$export$2e2bcd8739ae039)(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}


function $0878b3a08500ae45$export$2e2bcd8739ae039(t) {
    var i = (0, $2387985b847e7077$export$2e2bcd8739ae039)(t, "string");
    return "symbol" == (0, $01743b5cb49f44f1$export$2e2bcd8739ae039)(i) ? i : i + "";
}


function $1d11df66e098895d$export$2e2bcd8739ae039(e, r, t) {
    return (r = (0, $0878b3a08500ae45$export$2e2bcd8739ae039)(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}



var $5FkrB = parcelRequire("5FkrB");
/**
 * Returns a CSS custom property value with an optional suffix & prefix.
 * Prefix will only be added if there is a suffix.
 * If the value is undefined a fallback value will be returned to prevent children inheriting parent values.
 *
 * @param value
 * @param suffix
 * @param prefix
 */ function $e467bddc1662addb$export$2e2bcd8739ae039(value, suffix, prefix) {
    if (value != undefined) {
        if (suffix) {
            if (prefix) return prefix + value + suffix;
            return value + suffix;
        }
        return value;
    }
    // Currently React trims these values so we can't use a space " " to block the value.
    // Instead we use a CSS variable that doesn't exist which falls back to " ".
    // Bug raised here: https://github.com/facebook/react/issues/20497
    return 'var(--c-, )';
}


function $3cc2c4b28ad7dbd4$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $3cc2c4b28ad7dbd4$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $3cc2c4b28ad7dbd4$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $1d11df66e098895d$export$2e2bcd8739ae039)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $3cc2c4b28ad7dbd4$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $3cc2c4b28ad7dbd4$var$CSS_VAR_MAX_WIDTH = '--max-width';
var $3cc2c4b28ad7dbd4$var$CSS_VAR_MAX_HEIGHT = '--max-height';
var $3cc2c4b28ad7dbd4$var$imageStyles = null;
/**
 * __Image__
 *
 * Image in Empty State.
 *
 * @internal
 */ var $3cc2c4b28ad7dbd4$var$Image = function Image(_ref) {
    var maxHeight = _ref.maxHeight, maxWidth = _ref.maxWidth, _ref$height = _ref.height, height = _ref$height === void 0 ? 'auto' : _ref$height, _ref$width = _ref.width, width = _ref$width === void 0 ? 'auto' : _ref$width, src = _ref.src;
    return /*#__PURE__*/ $5FkrB.createElement("img", {
        width: width,
        height: height,
        alt: "",
        role: "presentation",
        src: src,
        className: (0, $25bde311ed7fa5e4$export$2e2bcd8739ae039)([
            "_1e0c1ule _p12f163m _c71l649k _6rth1ejb _1pfhidpf _12l21wug _ahbq1wug"
        ]),
        style: $3cc2c4b28ad7dbd4$var$_objectSpread($3cc2c4b28ad7dbd4$var$_objectSpread({}, (0, $1d11df66e098895d$export$2e2bcd8739ae039)((0, $1d11df66e098895d$export$2e2bcd8739ae039)({}, $3cc2c4b28ad7dbd4$var$CSS_VAR_MAX_WIDTH, "".concat(maxWidth, "px")), $3cc2c4b28ad7dbd4$var$CSS_VAR_MAX_HEIGHT, "".concat(maxHeight, "px"))), {}, {
            "--_11x3y0": (0, $e467bddc1662addb$export$2e2bcd8739ae039)("var(".concat($3cc2c4b28ad7dbd4$var$CSS_VAR_MAX_WIDTH, ")")),
            "--_zsxb2b": (0, $e467bddc1662addb$export$2e2bcd8739ae039)("var(".concat($3cc2c4b28ad7dbd4$var$CSS_VAR_MAX_HEIGHT, ")"))
        })
    });
};
var $3cc2c4b28ad7dbd4$export$2e2bcd8739ae039 = $3cc2c4b28ad7dbd4$var$Image;


/* spinner-container.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $5FkrB = parcelRequire("5FkrB");

var $a934e1bd7cb5d22f$var$spinnerContainerStyles = null;
/**
 * __Spinner container__
 *
 * A spinner container for loading state of Empty State.
 *
 * @internal
 */ var $a934e1bd7cb5d22f$var$SpinnerContainer = function SpinnerContainer(_ref) {
    var children = _ref.children;
    return /*#__PURE__*/ $5FkrB.createElement("div", {
        className: (0, $25bde311ed7fa5e4$export$2e2bcd8739ae039)([
            "_1bsb1ejb _ahbqpxbi"
        ])
    }, children);
};
var $a934e1bd7cb5d22f$export$2e2bcd8739ae039 = $a934e1bd7cb5d22f$var$SpinnerContainer;


/**
 * __Empty state__
 *
 * A component used for presenting various empty states.
 * e.g. (no items, empty search, broken link, welcome screen etc.)
 *
 * @example
 * ```tsx
 * import EmptyState from '@atlaskit/empty-state';
 *
 * // An example of a 404 state
 * export default () => {
 *  <EmptyState
 *   header="Page not found"
 *   imageUrl="https://cdn.io/images/404"
 *   description="Looks like you've stumbled off track. Sorry about that! This page either doesn't exist or has been removed."
 *   primaryAction={<Button appearance="primary">Home Page</Button>}
 *   secondaryAction={<Button>Report a problem</Button>}
 *  />;
 * };
 * ```
 */ var $9a28bb334efe6ee5$var$EmptyState = function EmptyState(_ref) {
    var buttonGroupLabel = _ref.buttonGroupLabel, description = _ref.description, header = _ref.header, _ref$headingLevel = _ref.headingLevel, headingLevel = _ref$headingLevel === void 0 ? 4 : _ref$headingLevel, _ref$headingSize = _ref.headingSize, headingSize = _ref$headingSize === void 0 ? 'medium' : _ref$headingSize, imageHeight = _ref.imageHeight, imageUrl = _ref.imageUrl, imageWidth = _ref.imageWidth, isLoading = _ref.isLoading, _ref$maxImageHeight = _ref.maxImageHeight, maxImageHeight = _ref$maxImageHeight === void 0 ? 160 : _ref$maxImageHeight, _ref$maxImageWidth = _ref.maxImageWidth, maxImageWidth = _ref$maxImageWidth === void 0 ? 160 : _ref$maxImageWidth, primaryAction = _ref.primaryAction, renderImage = _ref.renderImage, secondaryAction = _ref.secondaryAction, width = _ref.width, tertiaryAction = _ref.tertiaryAction, testId = _ref.testId;
    var actionsContainer = primaryAction || secondaryAction || isLoading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $44124a981e9227cb$export$2e2bcd8739ae039), null, primaryAction && secondaryAction ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $aa5238e80877390a$export$2e2bcd8739ae039), {
        label: buttonGroupLabel || 'Button group',
        testId: testId && "".concat(testId, "-button-group")
    }, secondaryAction, primaryAction) : primaryAction || secondaryAction, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $a934e1bd7cb5d22f$export$2e2bcd8739ae039), null, isLoading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $6f7e5f007cf95a87$export$2e2bcd8739ae039), {
        testId: "empty-state-spinner"
    }))) : null;
    var tag = "h".concat(headingLevel > 0 && headingLevel < 7 ? headingLevel : headingLevel > 6 ? 6 : 4);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $3a73f390fa3336aa$export$2e2bcd8739ae039), {
        testId: testId,
        width: width || 'wide'
    }, imageUrl ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $3cc2c4b28ad7dbd4$export$2e2bcd8739ae039), {
        src: imageUrl,
        maxWidth: maxImageWidth,
        maxHeight: maxImageHeight,
        width: imageWidth,
        height: imageHeight
    }) : renderImage && renderImage({
        maxImageWidth: maxImageWidth,
        maxImageHeight: maxImageHeight,
        imageWidth: imageWidth,
        imageHeight: imageHeight
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $7a49b1df02a75aca$export$e71c4d32a2263218), {
        paddingBlockEnd: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $82315a19372f332f$export$2e2bcd8739ae039), {
        size: headingSize,
        as: tag
    }, header)), description && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $7a49b1df02a75aca$export$e71c4d32a2263218), {
        paddingBlockEnd: "space.300"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $5209c25cc099adfe$export$5f1af8db9871e1d6), {
        as: "p"
    }, description)), actionsContainer, tertiaryAction);
};
var $9a28bb334efe6ee5$export$2e2bcd8739ae039 = $9a28bb334efe6ee5$var$EmptyState;



var $bgNpv = parcelRequire("bgNpv");
var $hrVKU = parcelRequire("hrVKU");



var $gDiFE = parcelRequire("gDiFE");

var $2gmBL = parcelRequire("2gmBL");

var $6hgMx = parcelRequire("6hgMx");

var $leM9a = parcelRequire("leM9a");
var $c54a367501889f55$exports = {};
$c54a367501889f55$exports = new URL("error.b0f67bec.svg", import.meta.url).toString();


const $12c1ef7d58ba4906$var$_6 = "._bozgv77o{padding-inline-start:var(--ds-space-025,2px)}";
const $12c1ef7d58ba4906$var$_5 = "._ect4ttxp{font-family:var(--ds-font-family-body,\"Atlassian Sans\",ui-sans-serif,-apple-system,BlinkMacSystemFont,\"Segoe UI\",Ubuntu,\"Helvetica Neue\",sans-serif)}";
const $12c1ef7d58ba4906$var$_4 = "._syaz1tmw{color:var(--ds-text-danger,#ae2e24)}";
const $12c1ef7d58ba4906$var$_3 = "._1pfhze3t{margin-block-start:var(--ds-space-0,0)}";
const $12c1ef7d58ba4906$var$_2 = "._6rth1b66{margin-block-end:var(--ds-space-050,4px)}";
const $12c1ef7d58ba4906$var$_ = "._1e0c1o8l{display:inline-block}";
const $12c1ef7d58ba4906$var$siteSelectStackStyles = (0, $gDiFE.xcss)({
    alignSelf: 'stretch'
});
const $12c1ef7d58ba4906$var$siteSelectStyles = (0, $gDiFE.xcss)({
    width: '100%',
    maxWidth: '350px'
});
// Matches the ADS Form Label and RequiredAsterisk styles.
const $12c1ef7d58ba4906$var$requiredLabelStyles = {
    label: "_1e0c1o8l _6rth1b66 _1pfhze3t",
    requiredIndicator: "_syaz1tmw _ect4ttxp _bozgv77o"
};
const $12c1ef7d58ba4906$var$SiteSelector = ({ messages: messages, noWorkspacesLearnMoreUrl: noWorkspacesLearnMoreUrl, inputId: inputId, isRequired: isRequired = false })=>{
    const { formatMessage: formatMessage } = (0, $hrVKU.default)();
    const info = (0, $6hgMx.useInfo)();
    const { selectedWorkspace: selectedWorkspace, setSelectedWorkspace: setSelectedWorkspace } = (0, $6hgMx.useSelectedWorkspace)();
    const shouldSortWorkspaces = (0, $2gmBL.useFeatureGate)((0, $leM9a.OAuthConsentFeatureGate).MCP_SORT_WORKSPACES);
    const workspaces = (0, $5FkrB.useMemo)(()=>{
        const availableWorkspaces = info.availableWorkspaces || [];
        if (!shouldSortWorkspaces) return availableWorkspaces;
        return [
            ...availableWorkspaces
        ].sort();
    }, [
        info.availableWorkspaces,
        shouldSortWorkspaces
    ]);
    // Resolved display name per workspace URL (e.g. loom cloud names), when the
    // backend provides them via availableSites. Falls back to the raw workspace
    // string when a name is absent.
    const siteNamesByUrl = (0, $5FkrB.useMemo)(()=>{
        const names = new Map();
        for (const site of info.availableSites ?? [])if (site.name) names.set(site.url, site.name);
        return names;
    }, [
        info.availableSites
    ]);
    // Auto-select when there is exactly one site available, so the user doesn't
    // have to open a single-option dropdown. Mirrors the Trello workspace
    // prefill. Only fires when nothing is selected yet.
    (0, $5FkrB.useEffect)(()=>{
        if (workspaces.length === 1 && !selectedWorkspace) setSelectedWorkspace?.(workspaces[0]);
    }, [
        workspaces,
        selectedWorkspace,
        setSelectedWorkspace
    ]);
    if (workspaces.length === 0) {
        const learnMoreLink = /*#__PURE__*/ (0, $i3UfC.jsx)((0, $64e95b69a05329e9$export$2e2bcd8739ae039), {
            href: noWorkspacesLearnMoreUrl,
            target: "_blank",
            rel: "noopener noreferrer",
            children: /*#__PURE__*/ (0, $i3UfC.jsx)((0, $bgNpv.default), {
                ...messages.noWorkspacesLearnMore
            })
        });
        return /*#__PURE__*/ (0, $i3UfC.jsx)((0, $9a28bb334efe6ee5$export$2e2bcd8739ae039), {
            header: formatMessage(messages.noWorkspacesHeading),
            description: /*#__PURE__*/ (0, $i3UfC.jsx)((0, $bgNpv.default), {
                ...messages.noWorkspacesDescription,
                values: {
                    learnMoreLink: learnMoreLink
                }
            }),
            imageUrl: (0, (/*@__PURE__*/$parcel$interopDefault($c54a367501889f55$exports)))
        });
    }
    // Convert workspaces array to options format
    const workspaceOptions = workspaces.map((workspace)=>({
            label: siteNamesByUrl.get(workspace) || workspace,
            value: workspace
        }));
    // Find the selected option object from the value
    const selectedOption = workspaceOptions.find((option)=>option.value === selectedWorkspace);
    return /*#__PURE__*/ (0, $i3UfC.jsxs)((0, $c8dbef6c41cfa689$export$694e0d28c7ffc90c), {
        space: isRequired ? 'space.0' : 'space.100',
        xcss: $12c1ef7d58ba4906$var$siteSelectStackStyles,
        children: [
            isRequired ? /*#__PURE__*/ (0, $i3UfC.jsxs)((0, $dbdf44c207cf40e4$export$2e2bcd8739ae039), {
                children: [
                    /*#__PURE__*/ (0, $i3UfC.jsx)((0, $c179d2a16dc49323$export$2e2bcd8739ae039), {
                        children: [
                            $12c1ef7d58ba4906$var$_,
                            $12c1ef7d58ba4906$var$_2,
                            $12c1ef7d58ba4906$var$_3,
                            $12c1ef7d58ba4906$var$_4,
                            $12c1ef7d58ba4906$var$_5,
                            $12c1ef7d58ba4906$var$_6
                        ]
                    }),
                    /*#__PURE__*/ (0, $i3UfC.jsx)("label", {
                        htmlFor: inputId,
                        className: (0, $b02ab0e3a0f362dd$export$2e2bcd8739ae039)([
                            $12c1ef7d58ba4906$var$requiredLabelStyles.label
                        ]),
                        children: /*#__PURE__*/ (0, $i3UfC.jsxs)((0, $d48daa9a522ca942$export$5f1af8db9871e1d6), {
                            weight: "medium",
                            color: "color.text.subtle",
                            children: [
                                formatMessage(messages.siteLabel),
                                /*#__PURE__*/ (0, $i3UfC.jsxs)((0, $dbdf44c207cf40e4$export$2e2bcd8739ae039), {
                                    children: [
                                        /*#__PURE__*/ (0, $i3UfC.jsx)((0, $c179d2a16dc49323$export$2e2bcd8739ae039), {
                                            children: [
                                                $12c1ef7d58ba4906$var$_,
                                                $12c1ef7d58ba4906$var$_2,
                                                $12c1ef7d58ba4906$var$_3,
                                                $12c1ef7d58ba4906$var$_4,
                                                $12c1ef7d58ba4906$var$_5,
                                                $12c1ef7d58ba4906$var$_6
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $i3UfC.jsx)("span", {
                                            "aria-hidden": "true",
                                            title: "required",
                                            className: (0, $b02ab0e3a0f362dd$export$2e2bcd8739ae039)([
                                                $12c1ef7d58ba4906$var$requiredLabelStyles.requiredIndicator
                                            ]),
                                            children: "*"
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                ]
            }) : /*#__PURE__*/ (0, $i3UfC.jsx)((0, $383dd904a5a5e5b0$export$e71c4d32a2263218), {
                as: "label",
                htmlFor: inputId,
                children: /*#__PURE__*/ (0, $i3UfC.jsx)((0, $82315a19372f332f$export$2e2bcd8739ae039), {
                    size: "small",
                    children: formatMessage(messages.siteLabel)
                })
            }),
            /*#__PURE__*/ (0, $i3UfC.jsx)((0, $383dd904a5a5e5b0$export$e71c4d32a2263218), {
                xcss: $12c1ef7d58ba4906$var$siteSelectStyles,
                children: /*#__PURE__*/ (0, $i3UfC.jsx)((0, $5330bbf7705e7e35$export$2e2bcd8739ae039), {
                    inputId: inputId,
                    isRequired: isRequired,
                    options: workspaceOptions,
                    placeholder: formatMessage(messages.sitePlaceholder),
                    value: selectedOption,
                    onChange: (option)=>{
                        if (setSelectedWorkspace) setSelectedWorkspace(option?.value ? String(option.value) : null);
                    }
                })
            })
        ]
    });
};
var $12c1ef7d58ba4906$export$2e2bcd8739ae039 = $12c1ef7d58ba4906$var$SiteSelector;



var $6bnW7 = parcelRequire("6bnW7");
const $9ad666180c2ec5f8$export$4b01f65bacc7fc3e = (0, $6bnW7.defineMessages)({
    siteLabel: {
        id: 'oauth.a2a.siteSelector.label',
        defaultMessage: 'Authorize access for:',
        description: 'Label above the site-picker dropdown'
    },
    sitePlaceholder: {
        id: 'oauth.a2a.siteSelector.placeholder',
        defaultMessage: 'Select a site',
        description: 'Placeholder text inside the site-picker dropdown'
    },
    noWorkspacesHeading: {
        id: 'oauth.a2a.siteSelector.noWorkspaces.heading',
        defaultMessage: 'Supported sites required',
        description: 'Heading shown when the user has no workspaces available in their token'
    },
    noWorkspacesDescription: {
        id: 'oauth.a2a.siteSelector.noWorkspaces.description',
        defaultMessage: 'Atlassian Rovo MCP connects with Atlassian sites that use apps like Jira or Confluence. Your account isn\'t currently associated with a supported site.  {learnMoreLink}',
        description: 'Description shown when the user has no workspaces; {learnMoreLink} is a link to documentation'
    },
    noWorkspacesLearnMore: {
        id: 'oauth.a2a.siteSelector.noWorkspaces.learnMore',
        defaultMessage: 'Learn more',
        description: 'Link text for the documentation shown when no workspaces are available'
    }
});


/**
 * External URLs specific to the A2A consent flow — sourced from envConfig.
 * Shared URLs (privacy policy, terms of use) live in ../shared/urls.ts.
 */ 
var $9KGFe = parcelRequire("9KGFe");
const { a2a: $b428146771afb285$var$a2a } = (0, $9KGFe.getConfig)();
const $b428146771afb285$export$375d2af9f3717691 = $b428146771afb285$var$a2a.docUrl;


const $ad0c7736dd4aff0a$var$A2A_SITE_SELECT_INPUT_ID = 'oauth-consent-a2a-site-select';
const $ad0c7736dd4aff0a$var$SiteSelector = ()=>/*#__PURE__*/ (0, $i3UfC.jsx)((0, $12c1ef7d58ba4906$export$2e2bcd8739ae039), {
        messages: (0, $9ad666180c2ec5f8$export$4b01f65bacc7fc3e),
        noWorkspacesLearnMoreUrl: (0, $b428146771afb285$export$375d2af9f3717691),
        inputId: $ad0c7736dd4aff0a$var$A2A_SITE_SELECT_INPUT_ID
    });
var $ad0c7736dd4aff0a$export$2e2bcd8739ae039 = $ad0c7736dd4aff0a$var$SiteSelector;



var $i3UfC = parcelRequire("i3UfC");

var $bgNpv = parcelRequire("bgNpv");


var $gDiFE = parcelRequire("gDiFE");

var $6hgMx = parcelRequire("6hgMx");
/* PermissionCard.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $i3UfC = parcelRequire("i3UfC");
parcelRequire("5FkrB");



var $gDiFE = parcelRequire("gDiFE");
const $93d4096654a26f38$var$_3 = "._1e0c116y{display:inline-flex}";
const $93d4096654a26f38$var$_2 = "._18zr1b66{padding-inline:var(--ds-space-050,4px)}";
const $93d4096654a26f38$var$_ = "._1rjc1b66{padding-block:var(--ds-space-050,4px)}";
const $93d4096654a26f38$var$cardStyle = (0, $gDiFE.xcss)({
    borderRadius: 'radius.xxlarge',
    borderWidth: 'border.width',
    borderStyle: 'solid',
    borderColor: 'color.border',
    padding: 'space.200'
});
const $93d4096654a26f38$var$iconSpacingStyles = {
    space050: "_1rjc1b66 _18zr1b66 _1e0c116y"
};
/**
 * A read-only permission card with a check-circle icon, bold title, and description.
 * Shared by A2A and MCP (view mode) consent flows.
 */ const $93d4096654a26f38$var$PermissionCard = ({ title: title, description: description })=>{
    return /*#__PURE__*/ (0, $i3UfC.jsx)((0, $383dd904a5a5e5b0$export$e71c4d32a2263218), {
        xcss: $93d4096654a26f38$var$cardStyle,
        children: /*#__PURE__*/ (0, $i3UfC.jsxs)((0, $1b254ba6a068f2f1$export$f51f4c4ede09e011), {
            gap: "space.150",
            alignItems: "start",
            children: [
                /*#__PURE__*/ (0, $i3UfC.jsxs)((0, $dbdf44c207cf40e4$export$2e2bcd8739ae039), {
                    children: [
                        /*#__PURE__*/ (0, $i3UfC.jsx)((0, $c179d2a16dc49323$export$2e2bcd8739ae039), {
                            children: [
                                $93d4096654a26f38$var$_,
                                $93d4096654a26f38$var$_2,
                                $93d4096654a26f38$var$_3
                            ]
                        }),
                        /*#__PURE__*/ (0, $i3UfC.jsx)((0, $383dd904a5a5e5b0$export$e71c4d32a2263218), {
                            xcss: $93d4096654a26f38$var$iconSpacingStyles.space050,
                            "aria-hidden": true,
                            children: /*#__PURE__*/ (0, $i3UfC.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($60d92d5137838590$exports))), {
                                label: "",
                                size: "medium",
                                color: "var(--ds-text, #292A2E)"
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $i3UfC.jsxs)((0, $c8dbef6c41cfa689$export$694e0d28c7ffc90c), {
                    space: "space.100",
                    children: [
                        /*#__PURE__*/ (0, $i3UfC.jsx)((0, $d48daa9a522ca942$export$5f1af8db9871e1d6), {
                            weight: "bold",
                            children: title
                        }),
                        /*#__PURE__*/ (0, $i3UfC.jsx)((0, $d48daa9a522ca942$export$5f1af8db9871e1d6), {
                            as: "p",
                            size: "medium",
                            children: description
                        })
                    ]
                })
            ]
        })
    });
};
var $93d4096654a26f38$export$2e2bcd8739ae039 = $93d4096654a26f38$var$PermissionCard;



var $6bnW7 = parcelRequire("6bnW7");
const $db1e3c62bff5bed4$export$ac92c96104565b0e = (0, $6bnW7.defineMessages)({
    sectionTitle: {
        id: 'oauth.a2a.permission.sectionTitle',
        defaultMessage: 'Permissions',
        description: 'Section heading for A2A permissions'
    },
    rovoChatTitle: {
        id: 'oauth.a2a.permission.rovoChatTitle',
        defaultMessage: 'Rovo Chat',
        description: 'Title for the Rovo Chat permission'
    },
    rovoChatDescription: {
        id: 'oauth.a2a.permission.rovoChatDescription',
        defaultMessage: 'Chat with Rovo and agents to search, create, and manage work across your Atlassian apps (Jira, Confluence, etc.) and other connected apps on your behalf.',
        description: 'Description for the Rovo Chat permission'
    }
});


const $d0e85dd3a28af163$var$stackStyle = (0, $gDiFE.xcss)({
    width: '100%',
    maxWidth: '100%'
});
/**
 * Static permission card for the A2A consent flow.
 * Displays a single, non-editable "Rovo Chat" permission.
 */ const $d0e85dd3a28af163$var$A2APermission = ()=>{
    const { selectedWorkspace: selectedWorkspace } = (0, $6hgMx.useSelectedWorkspace)();
    if (!selectedWorkspace) return null;
    return /*#__PURE__*/ (0, $i3UfC.jsxs)((0, $c8dbef6c41cfa689$export$694e0d28c7ffc90c), {
        xcss: $d0e85dd3a28af163$var$stackStyle,
        space: "space.200",
        children: [
            /*#__PURE__*/ (0, $i3UfC.jsx)((0, $82315a19372f332f$export$2e2bcd8739ae039), {
                size: "small",
                children: /*#__PURE__*/ (0, $i3UfC.jsx)((0, $bgNpv.default), {
                    ...(0, $db1e3c62bff5bed4$export$ac92c96104565b0e).sectionTitle
                })
            }),
            /*#__PURE__*/ (0, $i3UfC.jsx)((0, $93d4096654a26f38$export$2e2bcd8739ae039), {
                title: /*#__PURE__*/ (0, $i3UfC.jsx)((0, $bgNpv.default), {
                    ...(0, $db1e3c62bff5bed4$export$ac92c96104565b0e).rovoChatTitle
                }),
                description: /*#__PURE__*/ (0, $i3UfC.jsx)((0, $bgNpv.default), {
                    ...(0, $db1e3c62bff5bed4$export$ac92c96104565b0e).rovoChatDescription
                })
            })
        ]
    });
};
var $d0e85dd3a28af163$export$2e2bcd8739ae039 = $d0e85dd3a28af163$var$A2APermission;



var $i3UfC = parcelRequire("i3UfC");


var $6bnW7 = parcelRequire("6bnW7");
const $4cdb4deb8aabd876$export$f49d06a9ea8e8d1 = (0, $6bnW7.defineMessages)({
    agreementHeader: {
        id: 'oauth.a2a.bestPracticesHeader',
        defaultMessage: "By accepting, you agree to Atlassian's ",
        description: 'Header for the legal disclaimer agreement'
    },
    agreementLinks: {
        id: 'oauth.a2a.bestPracticesLinks',
        defaultMessage: '{privacyPolicyLink} and {termsOfUseLink}',
        description: 'Legal disclaimer about privacy policy and terms of use'
    },
    privacyPolicy: {
        id: 'oauth.a2a.privacyPolicy',
        defaultMessage: 'privacy policy',
        description: 'Link text for the privacy policy'
    },
    termsOfUse: {
        id: 'oauth.a2a.termsOfUse',
        defaultMessage: 'terms of use',
        description: 'Link text for the terms of use'
    }
});


const $d9522373093bfc8c$var$LegalDisclaimer = ()=>/*#__PURE__*/ (0, $i3UfC.jsx)((0, $3b5fda0c5c08534a$export$2e2bcd8739ae039), {
        messages: {
            agreementHeader: (0, $4cdb4deb8aabd876$export$f49d06a9ea8e8d1).agreementHeader,
            agreementLinks: (0, $4cdb4deb8aabd876$export$f49d06a9ea8e8d1).agreementLinks,
            privacyPolicy: (0, $4cdb4deb8aabd876$export$f49d06a9ea8e8d1).privacyPolicy,
            termsOfUse: (0, $4cdb4deb8aabd876$export$f49d06a9ea8e8d1).termsOfUse
        }
    });
var $d9522373093bfc8c$export$2e2bcd8739ae039 = $d9522373093bfc8c$var$LegalDisclaimer;



var $i3UfC = parcelRequire("i3UfC");

var $5FkrB = parcelRequire("5FkrB");

var $6hgMx = parcelRequire("6hgMx");

var $guDjK = parcelRequire("guDjK");

var $8LFYh = parcelRequire("8LFYh");
const $3377de01f88e7b3e$export$d730e7130714a422 = {
    idle: 'idle',
    loading: 'loading',
    allowed: 'allowed',
    blocked: 'blocked',
    error: 'error',
    a2aRestricted: 'a2aRestricted',
    clientDisabled: 'clientDisabled'
};
const $3377de01f88e7b3e$export$22ff6e19b26300dd = {
    httpOrParse: 'httpOrParse',
    a2aRestricted: 'a2aRestricted',
    infraError: 'infraError',
    policyBlocked: 'policyBlocked',
    clientDisabled: 'clientDisabled'
};
const $3377de01f88e7b3e$export$afec8bcc796819cf = /*#__PURE__*/ (0, $5FkrB.createContext)(null);
const $3377de01f88e7b3e$export$f34ce36ffab96ab6 = ()=>{
    const context = (0, $5FkrB.useContext)($3377de01f88e7b3e$export$afec8bcc796819cf);
    if (!context) throw new Error('useA2AContext must be used within A2AContextProvider');
    return context;
};
function $3377de01f88e7b3e$var$domainReducer(_, action) {
    switch(action.type){
        case 'RESET':
            return {
                status: $3377de01f88e7b3e$export$d730e7130714a422.idle
            };
        case 'LOADING':
            return {
                status: $3377de01f88e7b3e$export$d730e7130714a422.loading
            };
        case 'ALLOWED':
            return {
                status: $3377de01f88e7b3e$export$d730e7130714a422.allowed
            };
        case 'BLOCKED':
            return {
                status: $3377de01f88e7b3e$export$d730e7130714a422.blocked
            };
        case 'ERROR':
            return {
                status: $3377de01f88e7b3e$export$d730e7130714a422.error
            };
        case 'A2A_RESTRICTED':
            return {
                status: $3377de01f88e7b3e$export$d730e7130714a422.a2aRestricted
            };
        case 'CLIENT_DISABLED':
            return {
                status: $3377de01f88e7b3e$export$d730e7130714a422.clientDisabled
            };
    }
}
const $3377de01f88e7b3e$export$8875c6e9ecda9dba = ({ children: children })=>{
    const consentContext = (0, $5FkrB.useContext)((0, $6hgMx.ReactConsentContext));
    if (!consentContext) throw new Error('A2AContextProvider must be used within ConsentContextProvider');
    const { token: token } = consentContext;
    const analyticsClient = (0, $guDjK.useAnalytics)();
    const { selectedWorkspace: selectedWorkspace } = (0, $6hgMx.useSelectedWorkspace)();
    const [domainState, dispatch] = (0, $5FkrB.useReducer)($3377de01f88e7b3e$var$domainReducer, {
        status: $3377de01f88e7b3e$export$d730e7130714a422.idle
    });
    // Keep the shared acceptDisabled flag in sync with the domain-check status
    // so the Footer Accept button is disabled when the domain is not allowed.
    const { setAcceptDisabled: setAcceptDisabled } = consentContext;
    (0, $5FkrB.useEffect)(()=>{
        setAcceptDisabled?.(domainState.status !== $3377de01f88e7b3e$export$d730e7130714a422.allowed);
    }, [
        domainState.status,
        setAcceptDisabled
    ]);
    // Fetch domain check whenever selectedWorkspace changes
    (0, $5FkrB.useEffect)(()=>{
        if (token.serviceType !== 'A2A') return;
        if (!selectedWorkspace) {
            // No workspace selected — either the user hasn't picked one yet
            // or there are none available (empty array / key missing from token).
            // Stay idle so we don't fire a policy fetch that would fail and show
            // a misleading error alongside the SiteSelector's own empty-state.
            dispatch({
                type: 'RESET'
            });
            return;
        }
        const ac = new AbortController();
        dispatch({
            type: 'LOADING'
        });
        (async ()=>{
            try {
                const result = await (0, $8LFYh.fetchWorkspacePolicyCheck)({
                    contextJwt: token.raw,
                    selectedWorkspace: selectedWorkspace
                }, ac.signal);
                if (ac.signal.aborted) return;
                if ((0, $8LFYh.isClientDisabledFailure)(result)) {
                    dispatch({
                        type: 'CLIENT_DISABLED'
                    });
                    analyticsClient.pushTrackEvent({
                        actionSubject: 'a2aDomainCheck',
                        action: 'failed',
                        source: 'oauthConsentScreen',
                        attributes: {
                            reason: $3377de01f88e7b3e$export$22ff6e19b26300dd.clientDisabled
                        }
                    });
                    return;
                }
                if (!result.ok) {
                    dispatch({
                        type: 'ERROR'
                    });
                    analyticsClient.pushTrackEvent({
                        actionSubject: 'a2aDomainCheck',
                        action: 'failed',
                        source: 'oauthConsentScreen',
                        attributes: {
                            reason: $3377de01f88e7b3e$export$22ff6e19b26300dd.httpOrParse
                        }
                    });
                    return;
                }
                // a2aEnabled=false → A2A is restricted by the organization admin
                if (!result.data.a2aEnabled) {
                    dispatch({
                        type: 'A2A_RESTRICTED'
                    });
                    analyticsClient.pushTrackEvent({
                        actionSubject: 'a2aDomainCheck',
                        action: 'failed',
                        source: 'oauthConsentScreen',
                        attributes: {
                            reason: $3377de01f88e7b3e$export$22ff6e19b26300dd.a2aRestricted
                        }
                    });
                    return;
                }
                const { domain: domain } = result.data;
                // domain.allowed=false, domain.error=true → infra error → "Try again"
                if (domain.error) {
                    dispatch({
                        type: 'ERROR'
                    });
                    analyticsClient.pushTrackEvent({
                        actionSubject: 'a2aDomainCheck',
                        action: 'failed',
                        source: 'oauthConsentScreen',
                        attributes: {
                            reason: $3377de01f88e7b3e$export$22ff6e19b26300dd.infraError
                        }
                    });
                    return;
                }
                // domain.allowed=false, domain.error=false → policy blocked → "Contact your admin"
                if (!domain.allowed) {
                    dispatch({
                        type: 'BLOCKED'
                    });
                    analyticsClient.pushTrackEvent({
                        actionSubject: 'a2aDomainCheck',
                        action: 'failed',
                        source: 'oauthConsentScreen',
                        attributes: {
                            reason: $3377de01f88e7b3e$export$22ff6e19b26300dd.policyBlocked
                        }
                    });
                    return;
                }
                // domain.allowed=true, domain.error=false → ✅ allowed
                dispatch({
                    type: 'ALLOWED'
                });
            } catch (e) {
                if (e instanceof DOMException && e.name === 'AbortError' || ac.signal.aborted) return;
                dispatch({
                    type: 'ERROR'
                });
            }
        })();
        return ()=>{
            ac.abort();
        };
    }, [
        token,
        selectedWorkspace,
        analyticsClient
    ]);
    const value = (0, $5FkrB.useMemo)(()=>({
            a2aDomainStatus: domainState.status
        }), [
        domainState
    ]);
    return /*#__PURE__*/ (0, $i3UfC.jsx)($3377de01f88e7b3e$export$afec8bcc796819cf.Provider, {
        value: value,
        children: children
    });
};
var $3377de01f88e7b3e$export$2e2bcd8739ae039 = $3377de01f88e7b3e$export$8875c6e9ecda9dba;



var $i3UfC = parcelRequire("i3UfC");

var $bgNpv = parcelRequire("bgNpv");
var $hrVKU = parcelRequire("hrVKU");



var $9KGFe = parcelRequire("9KGFe");

var $6hgMx = parcelRequire("6hgMx");


var $00739cd751ba828e$exports = {};
$00739cd751ba828e$exports = new URL("restricted.4e21819b.svg", import.meta.url).toString();



var $6bnW7 = parcelRequire("6bnW7");
const $87e216b0cc2fa465$export$4f153f83ecc1dbcc = (0, $6bnW7.defineMessages)({
    blockedTitle: {
        id: 'oauth.a2a.policyAlert.blocked.title',
        defaultMessage: 'Access to this domain is restricted',
        description: 'Error title when admin policy blocks the redirect URL domain'
    },
    blockedBody: {
        id: 'oauth.a2a.policyAlert.blocked.body',
        defaultMessage: 'Your admin has blocked this domain "{redirectUrl}" in your organization\u2019s settings. To request access, contact your organization admin or <allowlistLink>find out about domain restrictions</allowlistLink>.',
        description: 'Error body when admin policy blocks the redirect, with embedded link to the admin allowlist documentation; {redirectUrl} is interpolated'
    },
    errorTitle: {
        id: 'oauth.a2a.policyAlert.error.title',
        defaultMessage: "We couldn't verify permissions for this site",
        description: 'Error title when domain check fails due to an infra error'
    },
    errorBody: {
        id: 'oauth.a2a.policyAlert.error.body',
        defaultMessage: 'We\u2019re having trouble showing permissions right now. You can try refreshing the page or <supportLink>contact support</supportLink>.',
        description: 'Error body when domain check fails due to an infra error, with embedded link to the Atlassian support page'
    },
    siteFallback: {
        id: 'oauth.a2a.policyAlert.siteFallback',
        defaultMessage: 'your Atlassian site',
        description: 'Fallback label used when the site name is not available'
    },
    a2aRestrictedTitle: {
        id: 'oauth.a2a.policyAlert.a2aRestricted.title',
        defaultMessage: 'Access to A2A is restricted',
        description: 'Error title when A2A is restricted by the organization admin'
    },
    clientDisabledTitle: {
        id: 'oauth.a2a.policyAlert.clientDisabled.title',
        defaultMessage: '{appName} is unavailable for this site',
        description: 'Error title when an admin has disabled the app, or its system account, for the organization that owns the selected site; {appName} is the app display name'
    },
    clientDisabledBody: {
        id: 'oauth.a2a.policyAlert.clientDisabled.body',
        defaultMessage: 'An admin has disabled {appName} for "{siteLabel}". Select a different site, or contact the admin of that site to restore access.',
        description: 'Error body when an admin has disabled the app, or its system account, for the organization that owns the selected site; {appName} is the app display name, {siteLabel} is the selected site'
    },
    appFallback: {
        id: 'oauth.a2a.policyAlert.appFallback',
        defaultMessage: 'This app',
        description: 'Fallback label used in place of the app name when it is not available'
    },
    a2aRestrictedBody: {
        id: 'oauth.a2a.policyAlert.a2aRestricted.body',
        defaultMessage: 'Your admin has blocked A2A usage in your organization\u2019s settings. To request access, contact your organization admin or <a2aRestrictedLink>find out about A2A restrictions</a2aRestrictedLink>.',
        description: 'Error body when A2A is restricted by the organization admin, with embedded link to documentation about A2A restrictions'
    }
});


const $ed5b791be5ee8b0d$var$A2APolicyAlerts = ()=>{
    const token = (0, $6hgMx.useToken)();
    const info = (0, $6hgMx.useInfo)();
    const { formatMessage: formatMessage } = (0, $hrVKU.default)();
    const { selectedWorkspace: selectedWorkspace } = (0, $6hgMx.useSelectedWorkspace)();
    const { a2aDomainStatus: a2aDomainStatus } = (0, $3377de01f88e7b3e$export$f34ce36ffab96ab6)();
    if (a2aDomainStatus !== (0, $3377de01f88e7b3e$export$d730e7130714a422).blocked && a2aDomainStatus !== (0, $3377de01f88e7b3e$export$d730e7130714a422).error && a2aDomainStatus !== (0, $3377de01f88e7b3e$export$d730e7130714a422).a2aRestricted && a2aDomainStatus !== (0, $3377de01f88e7b3e$export$d730e7130714a422).clientDisabled) return null;
    // A2A restricted by organization admin
    if (a2aDomainStatus === (0, $3377de01f88e7b3e$export$d730e7130714a422).a2aRestricted) {
        const allowlistGuideUrl = (0, $9KGFe.getConfig)().mcpPolicy.allowlistGuideUrl;
        return /*#__PURE__*/ (0, $i3UfC.jsx)((0, $9a28bb334efe6ee5$export$2e2bcd8739ae039), {
            header: formatMessage((0, $87e216b0cc2fa465$export$4f153f83ecc1dbcc).a2aRestrictedTitle),
            description: /*#__PURE__*/ (0, $i3UfC.jsx)((0, $bgNpv.default), {
                ...(0, $87e216b0cc2fa465$export$4f153f83ecc1dbcc).a2aRestrictedBody,
                values: {
                    a2aRestrictedLink: (text)=>/*#__PURE__*/ (0, $i3UfC.jsx)((0, $64e95b69a05329e9$export$2e2bcd8739ae039), {
                            href: allowlistGuideUrl,
                            target: "_blank",
                            rel: "noopener noreferrer",
                            children: text
                        })
                }
            }),
            imageUrl: (0, (/*@__PURE__*/$parcel$interopDefault($00739cd751ba828e$exports)))
        });
    }
    const redirectUrl = token.redirectUrl?.callback ?? '';
    const siteLabel = selectedWorkspace?.trim() || formatMessage((0, $87e216b0cc2fa465$export$4f153f83ecc1dbcc).siteFallback);
    if (a2aDomainStatus === (0, $3377de01f88e7b3e$export$d730e7130714a422).clientDisabled) {
        const appName = info.client?.name?.trim() || token.clientName?.trim() || formatMessage((0, $87e216b0cc2fa465$export$4f153f83ecc1dbcc).appFallback);
        return /*#__PURE__*/ (0, $i3UfC.jsx)((0, $9a28bb334efe6ee5$export$2e2bcd8739ae039), {
            header: formatMessage((0, $87e216b0cc2fa465$export$4f153f83ecc1dbcc).clientDisabledTitle, {
                appName: appName
            }),
            description: formatMessage((0, $87e216b0cc2fa465$export$4f153f83ecc1dbcc).clientDisabledBody, {
                appName: appName,
                siteLabel: siteLabel
            }),
            imageUrl: (0, (/*@__PURE__*/$parcel$interopDefault($00739cd751ba828e$exports)))
        });
    }
    // domain.allowed=false, domain.error=false → "Contact your admin"
    if (a2aDomainStatus === (0, $3377de01f88e7b3e$export$d730e7130714a422).blocked) {
        const allowlistGuideUrl = (0, $9KGFe.getConfig)().mcpPolicy.allowlistGuideUrl;
        return /*#__PURE__*/ (0, $i3UfC.jsx)((0, $9a28bb334efe6ee5$export$2e2bcd8739ae039), {
            header: formatMessage((0, $87e216b0cc2fa465$export$4f153f83ecc1dbcc).blockedTitle),
            description: /*#__PURE__*/ (0, $i3UfC.jsx)((0, $bgNpv.default), {
                ...(0, $87e216b0cc2fa465$export$4f153f83ecc1dbcc).blockedBody,
                values: {
                    redirectUrl: redirectUrl,
                    siteLabel: siteLabel,
                    allowlistLink: (text)=>/*#__PURE__*/ (0, $i3UfC.jsx)((0, $64e95b69a05329e9$export$2e2bcd8739ae039), {
                            href: allowlistGuideUrl,
                            target: "_blank",
                            rel: "noopener noreferrer",
                            children: text
                        })
                }
            }),
            imageUrl: (0, (/*@__PURE__*/$parcel$interopDefault($00739cd751ba828e$exports)))
        });
    }
    // domain.error=true → "Try again"
    const contactSupportUrl = (0, $9KGFe.getConfig)().support.contactSupportUrl;
    return /*#__PURE__*/ (0, $i3UfC.jsx)((0, $9a28bb334efe6ee5$export$2e2bcd8739ae039), {
        header: formatMessage((0, $87e216b0cc2fa465$export$4f153f83ecc1dbcc).errorTitle),
        description: /*#__PURE__*/ (0, $i3UfC.jsx)((0, $bgNpv.default), {
            ...(0, $87e216b0cc2fa465$export$4f153f83ecc1dbcc).errorBody,
            values: {
                supportLink: (text)=>/*#__PURE__*/ (0, $i3UfC.jsx)((0, $64e95b69a05329e9$export$2e2bcd8739ae039), {
                        href: contactSupportUrl,
                        target: "_blank",
                        rel: "noopener noreferrer",
                        children: text
                    })
            }
        }),
        imageUrl: (0, (/*@__PURE__*/$parcel$interopDefault($c54a367501889f55$exports)))
    });
};
var $ed5b791be5ee8b0d$export$2e2bcd8739ae039 = $ed5b791be5ee8b0d$var$A2APolicyAlerts;



const $5a82c568d39be14d$var$rootStyles = (0, $gDiFE.xcss)({
    width: '100%',
    margin: '0 auto',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'stretch',
    paddingInline: 'space.200',
    paddingBlock: 'space.400'
});
const $5a82c568d39be14d$var$spinnerWrapStyles = (0, $gDiFE.xcss)({
    paddingBlock: 'space.400'
});
/** Reserves roughly the same height as the permission section to prevent layout shift. */ const $5a82c568d39be14d$var$placeholderStyles = (0, $gDiFE.xcss)({
    minHeight: '120px'
});
const $5a82c568d39be14d$export$bc401c7661f6865d = ()=>{
    const { a2aDomainStatus: a2aDomainStatus } = (0, $3377de01f88e7b3e$export$f34ce36ffab96ab6)();
    return /*#__PURE__*/ (0, $i3UfC.jsx)((0, $383dd904a5a5e5b0$export$e71c4d32a2263218), {
        xcss: $5a82c568d39be14d$var$rootStyles,
        children: /*#__PURE__*/ (0, $i3UfC.jsxs)((0, $c8dbef6c41cfa689$export$694e0d28c7ffc90c), {
            space: "space.500",
            children: [
                /*#__PURE__*/ (0, $i3UfC.jsx)((0, $355d8bd71a4077ad$export$2e2bcd8739ae039), {}),
                /*#__PURE__*/ (0, $i3UfC.jsx)((0, $b9bf0509ed783ce4$export$2e2bcd8739ae039), {}),
                /*#__PURE__*/ (0, $i3UfC.jsx)((0, $f42c7abbba86ed92$export$2e2bcd8739ae039), {}),
                /*#__PURE__*/ (0, $i3UfC.jsx)((0, $ad0c7736dd4aff0a$export$2e2bcd8739ae039), {}),
                a2aDomainStatus === (0, $3377de01f88e7b3e$export$d730e7130714a422).loading && /*#__PURE__*/ (0, $i3UfC.jsx)((0, $1b254ba6a068f2f1$export$f51f4c4ede09e011), {
                    xcss: $5a82c568d39be14d$var$spinnerWrapStyles,
                    justifyContent: "center",
                    children: /*#__PURE__*/ (0, $i3UfC.jsx)((0, $6f7e5f007cf95a87$export$2e2bcd8739ae039), {
                        size: "large",
                        label: "Checking permissions\u2026"
                    })
                }),
                a2aDomainStatus === (0, $3377de01f88e7b3e$export$d730e7130714a422).idle && /*#__PURE__*/ (0, $i3UfC.jsx)((0, $383dd904a5a5e5b0$export$e71c4d32a2263218), {
                    xcss: $5a82c568d39be14d$var$placeholderStyles
                }),
                /*#__PURE__*/ (0, $i3UfC.jsx)((0, $ed5b791be5ee8b0d$export$2e2bcd8739ae039), {}),
                a2aDomainStatus === (0, $3377de01f88e7b3e$export$d730e7130714a422).allowed && /*#__PURE__*/ (0, $i3UfC.jsx)((0, $d0e85dd3a28af163$export$2e2bcd8739ae039), {}),
                a2aDomainStatus === (0, $3377de01f88e7b3e$export$d730e7130714a422).allowed && /*#__PURE__*/ (0, $i3UfC.jsx)((0, $d9522373093bfc8c$export$2e2bcd8739ae039), {})
            ]
        })
    });
};
const $5a82c568d39be14d$var$A2A = ()=>/*#__PURE__*/ (0, $i3UfC.jsx)((0, $3377de01f88e7b3e$export$2e2bcd8739ae039), {
        children: /*#__PURE__*/ (0, $i3UfC.jsx)($5a82c568d39be14d$export$bc401c7661f6865d, {})
    });
var $5a82c568d39be14d$export$2e2bcd8739ae039 = $5a82c568d39be14d$var$A2A;



var $i3UfC = parcelRequire("i3UfC");

var $5FkrB = parcelRequire("5FkrB");

var $hrVKU = parcelRequire("hrVKU");



var $6bnW7 = parcelRequire("6bnW7");
const $1bc43498d938dd1b$export$60df530d11b8664f = (0, $6bnW7.defineMessages)({
    userCodeLabel: {
        id: 'oauth.dag.userCode.label',
        defaultMessage: 'Device code',
        description: 'Label for the user-code input field in the device authorization flow'
    },
    userCodeDescription: {
        id: 'oauth.dag.userCode.description',
        defaultMessage: 'Enter the code displayed on your device to authorize it.',
        description: 'Helper text below the user-code input'
    },
    userCodePlaceholder: {
        id: 'oauth.dag.userCode.placeholder',
        defaultMessage: 'e.g. WDJB-MJHT',
        description: 'Placeholder text inside the user-code input field'
    },
    userCodeIncomplete: {
        id: 'oauth.dag.userCode.incomplete',
        defaultMessage: 'Please enter the complete 8-character device code.',
        description: 'Error shown when the user submits without filling all code fields'
    },
    antiphishingWarning: {
        id: 'oauth.dag.userCode.antiphishingWarning',
        defaultMessage: "Enter the code displayed in the app or on the device you're signing in to. Never use a code sent by someone else.",
        description: 'Anti-phishing warning shown below the device code input'
    }
});


const $9d8891dae8fa880b$var$CODE_LENGTH = 8;
const $9d8891dae8fa880b$var$VALID_CHAR = /^[A-Z0-9]$/;
// ---------------------------------------------------------------------------
// Styles
// ---------------------------------------------------------------------------
const $9d8891dae8fa880b$var$boxBase = {
    width: '48px',
    height: '48px',
    textAlign: 'center',
    fontSize: '1.25rem',
    fontWeight: 600,
    fontFamily: 'inherit',
    textTransform: 'uppercase',
    border: `2px solid ${(0, $37190500189da037$export$9e1725a4cfeada27)('color.border', '#ccc')}`,
    borderRadius: (0, $37190500189da037$export$9e1725a4cfeada27)('radius.medium', '0.375rem'),
    background: (0, $37190500189da037$export$9e1725a4cfeada27)('color.background.input', '#fff'),
    color: (0, $37190500189da037$export$9e1725a4cfeada27)('color.text', '#000'),
    outline: 'none',
    caretColor: 'transparent',
    transition: 'border-color 0.15s ease',
    boxSizing: 'border-box'
};
const $9d8891dae8fa880b$var$boxFocused = {
    ...$9d8891dae8fa880b$var$boxBase,
    borderColor: (0, $37190500189da037$export$9e1725a4cfeada27)('color.border.focused', '#388BFF')
};
const $9d8891dae8fa880b$var$boxFilled = {
    ...$9d8891dae8fa880b$var$boxBase,
    borderColor: (0, $37190500189da037$export$9e1725a4cfeada27)('color.border.focused', '#388BFF')
};
const $9d8891dae8fa880b$var$separatorStyle = {
    fontSize: '1.5rem',
    fontWeight: 300,
    color: (0, $37190500189da037$export$9e1725a4cfeada27)('color.text.subtlest', '#8993A5'),
    userSelect: 'none',
    paddingInline: (0, $37190500189da037$export$9e1725a4cfeada27)('space.050', '4px')
};
// ---------------------------------------------------------------------------
// Component
// ---------------------------------------------------------------------------
const $9d8891dae8fa880b$var$DAG = ()=>{
    const { formatMessage: formatMessage } = (0, $hrVKU.default)();
    const [chars, setChars] = (0, $5FkrB.useState)(Array($9d8891dae8fa880b$var$CODE_LENGTH).fill(''));
    const [focusedIndex, setFocusedIndex] = (0, $5FkrB.useState)(null);
    const [showError, setShowError] = (0, $5FkrB.useState)(false);
    const inputRefs = (0, $5FkrB.useRef)([]);
    const wrapperRef = (0, $5FkrB.useRef)(null);
    const userCodeRef = (0, $5FkrB.useRef)('');
    const charsRef = (0, $5FkrB.useRef)(chars);
    const focusAt = (index)=>{
        const clamped = Math.max(0, Math.min($9d8891dae8fa880b$var$CODE_LENGTH - 1, index));
        inputRefs.current[clamped]?.focus();
    };
    const handleKeyDown = (index)=>(e)=>{
            if (e.key === 'Backspace') {
                e.preventDefault();
                if (chars[index]) {
                    const next = [
                        ...chars
                    ];
                    next[index] = '';
                    setChars(next);
                } else focusAt(index - 1);
            } else if (e.key === 'ArrowLeft') {
                e.preventDefault();
                focusAt(index - 1);
            } else if (e.key === 'ArrowRight') {
                e.preventDefault();
                focusAt(index + 1);
            } else if (e.key === 'Delete') {
                e.preventDefault();
                const next = [
                    ...chars
                ];
                next[index] = '';
                setChars(next);
            }
        };
    const handleInput = (index)=>(e)=>{
            const raw = (e.currentTarget.value ?? '').toUpperCase();
            const typed = raw.replace(chars[index], '').slice(-1);
            if (!typed || !$9d8891dae8fa880b$var$VALID_CHAR.test(typed)) {
                e.currentTarget.value = chars[index];
                return;
            }
            const next = [
                ...chars
            ];
            next[index] = typed;
            setChars(next);
            if (index < $9d8891dae8fa880b$var$CODE_LENGTH - 1) focusAt(index + 1);
        };
    const handlePaste = (e)=>{
        e.preventDefault();
        const pasted = e.clipboardData.getData('text').toUpperCase().replace(/[^A-Z0-9]/g, '').slice(0, $9d8891dae8fa880b$var$CODE_LENGTH);
        if (!pasted) return;
        const next = [
            ...chars
        ];
        for(let i = 0; i < pasted.length; i++)next[i] = pasted[i];
        setChars(next);
        focusAt(Math.min(pasted.length, $9d8891dae8fa880b$var$CODE_LENGTH - 1));
    };
    const userCode = `${chars.slice(0, 4).join('')}-${chars.slice(4).join('')}`;
    userCodeRef.current = userCode;
    charsRef.current = chars;
    (0, $5FkrB.useEffect)(()=>{
        const form = wrapperRef.current?.closest('form');
        if (!form) return;
        const handleSubmit = (e)=>{
            if (userCodeRef.current.length < $9d8891dae8fa880b$var$CODE_LENGTH) {
                e.preventDefault();
                setShowError(true);
                const firstEmpty = charsRef.current.findIndex((c)=>!c);
                if (firstEmpty >= 0) inputRefs.current[firstEmpty]?.focus();
            }
        };
        form.addEventListener('submit', handleSubmit);
        return ()=>form.removeEventListener('submit', handleSubmit);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    (0, $5FkrB.useEffect)(()=>{
        if (!chars.includes('')) setShowError(false);
    }, [
        chars
    ]);
    const boxStyle = (index)=>{
        const hasError = showError && !chars[index];
        if (focusedIndex === index) return {
            ...$9d8891dae8fa880b$var$boxFocused,
            ...hasError ? {
                borderColor: (0, $37190500189da037$export$9e1725a4cfeada27)('color.border.danger', '#FF5630')
            } : {}
        };
        if (chars[index]) return $9d8891dae8fa880b$var$boxFilled;
        if (hasError) return {
            ...$9d8891dae8fa880b$var$boxBase,
            borderColor: (0, $37190500189da037$export$9e1725a4cfeada27)('color.border.danger', '#FF5630')
        };
        return $9d8891dae8fa880b$var$boxBase;
    };
    const renderBox = (index)=>/*#__PURE__*/ (0, $i3UfC.jsx)("input", {
            ref: (el)=>{
                inputRefs.current[index] = el;
            },
            type: "text",
            inputMode: "text",
            maxLength: 2,
            value: chars[index],
            style: boxStyle(index),
            onFocus: ()=>{
                setFocusedIndex(index);
                inputRefs.current[index]?.select();
            },
            onBlur: ()=>setFocusedIndex(null),
            onKeyDown: handleKeyDown(index),
            onInput: handleInput(index),
            onPaste: handlePaste,
            autoCapitalize: "characters",
            autoComplete: "off",
            spellCheck: false,
            "aria-label": `Code character ${index + 1}`
        }, index);
    return /*#__PURE__*/ (0, $i3UfC.jsx)((0, $383dd904a5a5e5b0$export$e71c4d32a2263218), {
        ref: wrapperRef,
        style: {
            width: '100%',
            paddingInline: (0, $37190500189da037$export$9e1725a4cfeada27)('space.200'),
            paddingBlock: (0, $37190500189da037$export$9e1725a4cfeada27)('space.400')
        },
        children: /*#__PURE__*/ (0, $i3UfC.jsxs)((0, $c8dbef6c41cfa689$export$694e0d28c7ffc90c), {
            space: "space.300",
            alignInline: "center",
            children: [
                /*#__PURE__*/ (0, $i3UfC.jsxs)((0, $c8dbef6c41cfa689$export$694e0d28c7ffc90c), {
                    space: "space.100",
                    alignInline: "center",
                    children: [
                        /*#__PURE__*/ (0, $i3UfC.jsx)((0, $d48daa9a522ca942$export$5f1af8db9871e1d6), {
                            weight: "bold",
                            size: "large",
                            children: formatMessage((0, $1bc43498d938dd1b$export$60df530d11b8664f).userCodeLabel)
                        }),
                        /*#__PURE__*/ (0, $i3UfC.jsx)((0, $d48daa9a522ca942$export$5f1af8db9871e1d6), {
                            as: "p",
                            size: "medium",
                            color: "color.text.subtle",
                            align: "center",
                            children: formatMessage((0, $1bc43498d938dd1b$export$60df530d11b8664f).userCodeDescription)
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $i3UfC.jsxs)((0, $c8dbef6c41cfa689$export$694e0d28c7ffc90c), {
                    space: "space.100",
                    alignInline: "center",
                    children: [
                        /*#__PURE__*/ (0, $i3UfC.jsxs)((0, $1b254ba6a068f2f1$export$f51f4c4ede09e011), {
                            gap: "space.100",
                            alignItems: "center",
                            justifyContent: "center",
                            children: [
                                Array.from({
                                    length: 4
                                }, (_, i)=>renderBox(i)),
                                /*#__PURE__*/ (0, $i3UfC.jsx)("span", {
                                    style: $9d8891dae8fa880b$var$separatorStyle,
                                    "aria-hidden": true,
                                    children: "\u2013"
                                }),
                                Array.from({
                                    length: 4
                                }, (_, i)=>renderBox(i + 4))
                            ]
                        }),
                        showError && /*#__PURE__*/ (0, $i3UfC.jsx)((0, $d48daa9a522ca942$export$5f1af8db9871e1d6), {
                            as: "p",
                            size: "small",
                            color: "color.text.danger",
                            align: "center",
                            children: formatMessage((0, $1bc43498d938dd1b$export$60df530d11b8664f).userCodeIncomplete)
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $i3UfC.jsx)("input", {
                    type: "hidden",
                    name: "user_code",
                    value: userCode
                }),
                /*#__PURE__*/ (0, $i3UfC.jsx)((0, $d48daa9a522ca942$export$5f1af8db9871e1d6), {
                    as: "p",
                    size: "small",
                    color: "color.text.subtle",
                    align: "center",
                    children: formatMessage((0, $1bc43498d938dd1b$export$60df530d11b8664f).antiphishingWarning)
                })
            ]
        })
    });
};
var $9d8891dae8fa880b$export$2e2bcd8739ae039 = $9d8891dae8fa880b$var$DAG;


const $a7b07bd5558ad8bf$var$MainContent = ()=>{
    const { serviceType: serviceType } = (0, $6hgMx.useToken)();
    switch(serviceType){
        case 'Ecosystem':
            return /*#__PURE__*/ (0, $i3UfC.jsx)((0, $c83aa9613c11c042$export$2e2bcd8739ae039), {});
        case 'Kaizen':
            return /*#__PURE__*/ (0, $i3UfC.jsx)((0, $d6c3101ab27d1214$export$2e2bcd8739ae039), {});
        case 'OIDC':
            return /*#__PURE__*/ (0, $i3UfC.jsx)((0, $dd4b8a594ab429d4$export$2e2bcd8739ae039), {});
        case 'Trello':
            return /*#__PURE__*/ (0, $i3UfC.jsx)((0, $032f59b166f07d41$export$2e2bcd8739ae039), {});
        case 'Applinks':
            return /*#__PURE__*/ (0, $i3UfC.jsx)((0, $01cd1c011e00a683$export$2e2bcd8739ae039), {});
        case 'Rovo':
            return /*#__PURE__*/ (0, $i3UfC.jsx)((0, $b37a26f2d7a8957f$export$2e2bcd8739ae039), {});
        case 'PartnerCentral':
            return /*#__PURE__*/ (0, $i3UfC.jsx)((0, $06a22b8c30d550e2$export$2e2bcd8739ae039), {});
        case 'Bitbucket':
            return /*#__PURE__*/ (0, $i3UfC.jsx)((0, $a661d5caafe3c23a$export$2e2bcd8739ae039), {});
        case 'TWG':
            return /*#__PURE__*/ (0, $i3UfC.jsx)((0, $4b0b0a8dd164e37c$export$2e2bcd8739ae039), {});
        case 'A2A':
            return /*#__PURE__*/ (0, $i3UfC.jsx)((0, $5a82c568d39be14d$export$2e2bcd8739ae039), {});
        case 'DAG':
            return /*#__PURE__*/ (0, $i3UfC.jsx)((0, $9d8891dae8fa880b$export$2e2bcd8739ae039), {});
    }
};
var $a7b07bd5558ad8bf$export$2e2bcd8739ae039 = $a7b07bd5558ad8bf$var$MainContent;



var $i3UfC = parcelRequire("i3UfC");

var $5FkrB = parcelRequire("5FkrB");

var $gDiFE = parcelRequire("gDiFE");

var $i3UfC = parcelRequire("i3UfC");

var $5FkrB = parcelRequire("5FkrB");

var $6bnW7 = parcelRequire("6bnW7");
var $bgNpv = parcelRequire("bgNpv");



var $gDiFE = parcelRequire("gDiFE");


var $guDjK = parcelRequire("guDjK");

var $fLAke = parcelRequire("fLAke");

var $6hgMx = parcelRequire("6hgMx");

var $90MfH = parcelRequire("90MfH");

var $6bnW7 = parcelRequire("6bnW7");
const $96caccbd80113386$export$1c9a60c992b4f3e4 = (0, $6bnW7.defineMessages)({
    sectionTitle: {
        id: 'oauth.mcp.permissions.sectionTitle',
        defaultMessage: 'Permissions',
        description: 'Section heading for MCP permissions'
    },
    forgeAppSummary: {
        id: 'oauth.mcp.permissions.forgeAppSummary',
        defaultMessage: '{appName} will have these permissions on your behalf in Atlassian products: {intents}',
        description: 'Read-only Forge MCP permission summary; {appName} is the Forge app the agent is accessing and {intents} is the policy-provided list of allowed intent labels, left in their original form for translation'
    },
    forgeAppIrreversibleNote: {
        id: 'oauth.mcp.permissions.forgeAppIrreversibleNote',
        defaultMessage: 'This includes permissions with irreversible results.',
        description: 'Shown under the Forge MCP permission summary when the grant includes delete or manage toolsets that standard MCP requires the user to opt into'
    },
    irreversibleResults: {
        id: 'oauth.mcp.permissions.irreversibleResults',
        defaultMessage: 'Irreversible results',
        description: 'Badge on the Delete permission group whose actions cannot be undone'
    },
    worksAcrossOrganization: {
        id: 'oauth.mcp.permissions.worksAcrossOrganization',
        defaultMessage: 'Works across organization',
        description: 'Badge on a toolset whose results/actions range across the whole organization rather than a single resource'
    },
    worksAcrossUnit: {
        id: 'oauth.mcp.permissions.worksAcrossUnit',
        defaultMessage: 'Works across unit',
        description: 'Badge on a toolset whose results/actions range across every connected app in the collaboration unit rather than a single site'
    },
    toolsetsSelected: {
        id: 'oauth.mcp.permissions.toolsetsSelected',
        defaultMessage: '{selected} out of {total} permissions selected',
        description: 'Counter shown in footer when editing permissions; {selected} and {total} are numbers'
    },
    emptyStateHeading: {
        id: 'oauth.mcp.permissions.emptyStateHeading',
        defaultMessage: 'Permissions are blocked for this {productUnit}',
        description: 'Heading when the workspace policy returns no permission toolsets; {productUnit} is "Trello workspace" or "Atlassian site"'
    },
    emptyStateHeadingMultiple: {
        id: 'oauth.mcp.permissions.emptyStateHeadingMultiple',
        defaultMessage: 'Permissions are blocked for these workspaces',
        description: 'Heading when the workspace policy returns no permission toolsets for a multi-workspace Trello selection'
    },
    emptyStateDescription: {
        id: 'oauth.mcp.permissions.emptyStateDescription',
        defaultMessage: 'Contact your organization admin to request access or see <howPermissionsLink>how permissions are managed</howPermissionsLink>',
        description: 'Body copy for blocked permissions empty state, with embedded link to documentation about MCP permission management'
    }
});
const $96caccbd80113386$export$c25eff7563f353c5 = (0, $6bnW7.defineMessages)({
    editWarningTitle: {
        id: 'oauth.mcp.banner.editWarning.title',
        defaultMessage: 'Unselected permissions will limit {product} MCP features',
        description: 'Warning banner title when the user has deselected one or more MCP permission toolsets; {product} is either "Atlassian" or "Trello"'
    },
    editWarningBody: {
        id: 'oauth.mcp.banner.editWarning.body',
        defaultMessage: "If you later want to use a feature that requires a permission you didn't grant, you'll need to disconnect and reconnect {product} MCP to update your permissions.",
        description: 'Warning banner body when the user has deselected one or more MCP permission toolsets; {product} is either "Atlassian" or "Trello"'
    },
    editWarningDismiss: {
        id: 'oauth.mcp.banner.editWarning.dismiss',
        defaultMessage: 'Understood',
        description: 'Dismiss button label on the warning banner when the user has deselected MCP permission toolsets'
    },
    inboxPlannerDisabledMessage: {
        id: 'oauth.mcp.banner.inboxPlannerDisabled.message',
        defaultMessage: 'Inbox and Planner permissions are disabled since this workspace is not owned by your organisation. Permission for this workspace and its boards can still proceed.',
        description: "Info banner shown when inbox/planner scopes are excluded because the selected Trello workspace is outside the user's managing organization"
    },
    noWorkspacesInboxPlannerMessage: {
        id: 'oauth.mcp.banner.noWorkspacesInboxPlanner.message',
        defaultMessage: "You don't have any Trello workspaces, but you can still connect your Inbox and Planner. Boards, cards, and lists won't be available until you join or create a workspace.",
        description: 'Info banner shown when the user has no Trello workspaces but the requested scopes still allow connecting Inbox and Planner'
    },
    inboxPlannerDisabledMultipleMessage: {
        id: 'oauth.mcp.banner.inboxPlannerDisabledMultiple.message',
        defaultMessage: 'Inbox and Planner permissions are disabled for some workspaces since they are not owned by your organisation. Permissions for their boards can still proceed.',
        description: "Info banner shown when inbox/planner scopes are excluded because more than one of the selected Trello workspaces is outside the user's managing organization"
    }
});



var $i3UfC = parcelRequire("i3UfC");


var $6bnW7 = parcelRequire("6bnW7");
var $hrVKU = parcelRequire("hrVKU");

var $90MfH = parcelRequire("90MfH");
const $5110a34c125a0b6b$var$atlassianMessages = (0, $6bnW7.defineMessages)({
    brand: {
        id: 'oauth.mcp.brand.atlassian',
        defaultMessage: 'Atlassian',
        description: 'Brand name in MCP consent copy when Atlassian product scopes are present'
    },
    productUnit: {
        id: 'oauth.mcp.brand.productUnit.atlassian',
        defaultMessage: 'site',
        description: 'Organizational unit name for Atlassian (Atlassian / mixed flows)'
    }
});
const $5110a34c125a0b6b$var$trelloMessages = (0, $6bnW7.defineMessages)({
    brand: {
        id: 'oauth.mcp.brand.trello',
        defaultMessage: 'Trello',
        description: 'Brand name in MCP consent copy when only Trello scopes are present'
    },
    productUnit: {
        id: 'oauth.mcp.brand.productUnit.trello',
        defaultMessage: 'Trello workspace',
        description: 'Organizational unit name for Trello (Trello-only flow)'
    }
});
function $5110a34c125a0b6b$export$a6dedf0f6c9d1a27() {
    const { formatMessage: formatMessage } = (0, $hrVKU.default)();
    return formatMessage($5110a34c125a0b6b$var$atlassianMessages.brand);
}
function $5110a34c125a0b6b$export$67c6d5d2a1a9a362() {
    const { formatMessage: formatMessage } = (0, $hrVKU.default)();
    const { scopeClassification: scopeClassification } = (0, $90MfH.useMcpContext)();
    const isTrelloOnly = scopeClassification.hasTrello && !scopeClassification.hasAtlassian;
    const m = isTrelloOnly ? $5110a34c125a0b6b$var$trelloMessages : $5110a34c125a0b6b$var$atlassianMessages;
    return {
        product: formatMessage(m.brand),
        productUnit: formatMessage(m.productUnit)
    };
}



var $6bnW7 = parcelRequire("6bnW7");
const $e79a28951a3744ac$export$35cd88a60f84f8d = (0, $6bnW7.defineMessages)({
    agreementHeader: {
        id: 'oauth.mcp.bestPracticesHeader',
        defaultMessage: "By accepting, you agree to {product}'s ",
        description: 'Header for the legal disclaimer agreement list; {product} is dynamic based on what is passed in'
    },
    agreementBulletTwo: {
        id: 'oauth.mcp.bestPracticesBulletTwo',
        defaultMessage: '{privacyPolicyLink} and {termsOfUseLink}.',
        description: 'Legal disclaimer bullet about privacy policy and terms of use'
    },
    privacyPolicy: {
        id: 'oauth.mcp.privacyPolicy',
        defaultMessage: 'privacy policy',
        description: 'Link text for the privacy policy'
    },
    termsOfUse: {
        id: 'oauth.mcp.termsOfUse',
        defaultMessage: 'terms of use',
        description: 'Link text for the terms of use'
    }
});


const $f3195510df36cf44$var$LegalDisclaimer = ()=>{
    const product = (0, $5110a34c125a0b6b$export$a6dedf0f6c9d1a27)();
    return /*#__PURE__*/ (0, $i3UfC.jsx)((0, $3b5fda0c5c08534a$export$2e2bcd8739ae039), {
        product: product,
        messages: {
            agreementHeader: (0, $e79a28951a3744ac$export$35cd88a60f84f8d).agreementHeader,
            agreementLinks: (0, $e79a28951a3744ac$export$35cd88a60f84f8d).agreementBulletTwo,
            privacyPolicy: (0, $e79a28951a3744ac$export$35cd88a60f84f8d).privacyPolicy,
            termsOfUse: (0, $e79a28951a3744ac$export$35cd88a60f84f8d).termsOfUse
        }
    });
};
var $f3195510df36cf44$export$2e2bcd8739ae039 = $f3195510df36cf44$var$LegalDisclaimer;



var $Qy2AT = parcelRequire("Qy2AT");
const $9f757c9278478c88$var$mcpBottomBarStyles = (0, $gDiFE.xcss)({
    flexShrink: 0,
    borderTopWidth: 'border.width',
    borderTopStyle: 'solid',
    borderTopColor: 'color.border',
    width: '100%',
    boxSizing: 'border-box',
    position: 'fixed',
    bottom: 'space.0',
    left: 'space.0',
    padding: 'space.300',
    backgroundColor: 'elevation.surface'
});
const $9f757c9278478c88$var$mcpBottomBarInnerStyle = (0, $gDiFE.xcss)({
    maxWidth: '1280px',
    margin: '0 auto',
    width: '100%'
});
const $9f757c9278478c88$var$mcpFooterLayoutStyles = (0, $gDiFE.xcss)({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-end',
    gap: 'space.150',
    width: '100%',
    [(0, $2ec84d2d4928089d$export$987d49ffe1b0900f).above.sm]: {
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'flex-end',
        gap: 'space.400'
    }
});
const $9f757c9278478c88$var$mcpInfoColumnStyles = (0, $gDiFE.xcss)({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-end',
    gap: 'space.050',
    minWidth: '0',
    textAlign: 'right'
});
const $9f757c9278478c88$var$messages = (0, $6bnW7.defineMessages)({
    accept: {
        id: 'footer.accept',
        defaultMessage: 'Accept',
        description: 'Button to consent for this app to have the listed permissions'
    },
    cancel: {
        id: 'footer.cancel',
        defaultMessage: 'Cancel',
        description: 'Button to cancel the consent for this app to have the listed permissions'
    }
});
const $9f757c9278478c88$var$actionsOnlyStyles = (0, $gDiFE.xcss)({
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: 'space.200',
    justifyContent: 'flex-end',
    flexShrink: 0
});
function $9f757c9278478c88$export$20655b1d64055a94(mcpContext) {
    // Still checking — the toolsets on screen may be from the previous selection.
    if (mcpContext.mcpPolicyStatus === (0, $Qy2AT.MCP_POLICY_STATUS).loading) return true;
    // A failed check blocks Accept even when another source succeeded: the
    // failing selection's permissions are unknown, so there is nothing safe to
    // consent to. Each selector reports its own failure inline so the user can
    // change that selection and retry.
    if ((0, $Qy2AT.hasFailedPolicyCheck)(mcpContext.policies, (0, $Qy2AT.getOrderedPolicySources)(mcpContext.scopeClassification))) return true;
    // A site and a Bitbucket workspace from different organizations cannot be
    // granted in one consent. Both checks can still succeed, so this is its own
    // gate; both selectors say so inline.
    if (mcpContext.hasOrgMismatch) return true;
    // Accept turns on when there are permissions to grant and at least one is
    // selected.
    if (mcpContext.mcpByIntent.length === 0) return true;
    if (mcpContext.mcpSelectedToolsetNames.size === 0) return true;
    return false;
}
const $9f757c9278478c88$var$MCPFooter = ()=>{
    const analytics = (0, $guDjK.useAnalytics)();
    const consentContext = (0, $5FkrB.useContext)((0, $6hgMx.ReactConsentContext));
    const mcpContext = (0, $5FkrB.useContext)((0, $90MfH.ReactMcpContext));
    const [clickedButton, setClickedButton] = (0, $5FkrB.useState)(null);
    const fireAnalyticEvent = (0, $5FkrB.useCallback)((buttonName, buttonValue)=>()=>{
            analytics.sendButtonClickEvent(buttonName);
            setTimeout(()=>setClickedButton(buttonValue), 0);
        }, [
        analytics
    ]);
    const recordConsentedTrelloWorkspaces = mcpContext?.recordConsentedTrelloWorkspaces;
    // Runs synchronously: the consent form is a document POST, so the page
    // unloads immediately and a deferred write would be lost.
    const handleAcceptClick = (0, $5FkrB.useCallback)(()=>{
        recordConsentedTrelloWorkspaces?.();
        fireAnalyticEvent('acceptConsent', 'accept')();
    }, [
        recordConsentedTrelloWorkspaces,
        fireAnalyticEvent
    ]);
    const acceptDisabled = (0, $5FkrB.useMemo)(()=>{
        if (!consentContext?.token) return false;
        if (consentContext.token.serviceType === 'MCP') {
            if (!mcpContext) return true;
            return $9f757c9278478c88$export$20655b1d64055a94(mcpContext);
        }
        // For non-MCP service types, no additional disable conditions
        return false;
    }, [
        consentContext,
        mcpContext
    ]);
    const buttons = /*#__PURE__*/ (0, $i3UfC.jsxs)((0, $aa5238e80877390a$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $i3UfC.jsx)((0, $a21e01c03a9c4d94$export$2e2bcd8739ae039), {
                type: "submit",
                appearance: "subtle",
                name: "decision",
                value: "cancel",
                onClick: fireAnalyticEvent('cancelConsent', 'cancel'),
                isDisabled: clickedButton !== null,
                children: /*#__PURE__*/ (0, $i3UfC.jsx)((0, $bgNpv.default), {
                    ...$9f757c9278478c88$var$messages.cancel
                })
            }),
            /*#__PURE__*/ (0, $i3UfC.jsx)((0, $a21e01c03a9c4d94$export$2e2bcd8739ae039), {
                type: "submit",
                appearance: "primary",
                name: "decision",
                value: "accept",
                isDisabled: acceptDisabled || clickedButton !== null,
                onClick: handleAcceptClick,
                children: /*#__PURE__*/ (0, $i3UfC.jsx)((0, $bgNpv.default), {
                    ...$9f757c9278478c88$var$messages.accept
                })
            })
        ]
    });
    // The caption describes the permissions list, so it shows only while that
    // list is on screen — mirroring McpPermissions. Nothing granted yet, or an
    // empty state standing in for the list (a failure panel, or "permissions are
    // blocked"), and the caption would be counting something invisible. An inline
    // message under a selector doesn't replace the list, so it keeps counting —
    // except for a cross-org conflict, which withdraws the list entirely.
    const showToolsetsCount = consentContext?.token.serviceType === 'MCP' && !(0, $fLAke.getForgeMcpAppName)(consentContext.info) && (mcpContext?.mcpByIntent.length ?? 0) > 0 && !mcpContext?.mcpPolicyErrorKind && !mcpContext?.hasOrgMismatch;
    return /*#__PURE__*/ (0, $i3UfC.jsx)((0, $383dd904a5a5e5b0$export$e71c4d32a2263218), {
        xcss: $9f757c9278478c88$var$mcpBottomBarStyles,
        children: /*#__PURE__*/ (0, $i3UfC.jsx)((0, $383dd904a5a5e5b0$export$e71c4d32a2263218), {
            xcss: $9f757c9278478c88$var$mcpBottomBarInnerStyle,
            children: /*#__PURE__*/ (0, $i3UfC.jsxs)((0, $383dd904a5a5e5b0$export$e71c4d32a2263218), {
                xcss: $9f757c9278478c88$var$mcpFooterLayoutStyles,
                children: [
                    /*#__PURE__*/ (0, $i3UfC.jsxs)((0, $383dd904a5a5e5b0$export$e71c4d32a2263218), {
                        xcss: $9f757c9278478c88$var$mcpInfoColumnStyles,
                        children: [
                            showToolsetsCount && mcpContext && /*#__PURE__*/ (0, $i3UfC.jsx)((0, $d48daa9a522ca942$export$5f1af8db9871e1d6), {
                                as: "span",
                                color: "color.text",
                                weight: "medium",
                                children: /*#__PURE__*/ (0, $i3UfC.jsx)((0, $bgNpv.default), {
                                    ...(0, $96caccbd80113386$export$1c9a60c992b4f3e4).toolsetsSelected,
                                    values: {
                                        selected: mcpContext.mcpSelectedToolsetNames.size,
                                        total: mcpContext.mcpByIntent.reduce((n, g)=>n + g.toolsets.length, 0)
                                    }
                                })
                            }),
                            /*#__PURE__*/ (0, $i3UfC.jsx)((0, $f3195510df36cf44$export$2e2bcd8739ae039), {})
                        ]
                    }),
                    /*#__PURE__*/ (0, $i3UfC.jsx)((0, $383dd904a5a5e5b0$export$e71c4d32a2263218), {
                        xcss: $9f757c9278478c88$var$actionsOnlyStyles,
                        children: buttons
                    })
                ]
            })
        })
    });
};
var $9f757c9278478c88$export$2e2bcd8739ae039 = $9f757c9278478c88$var$MCPFooter;



var $i3UfC = parcelRequire("i3UfC");

var $gDiFE = parcelRequire("gDiFE");




var $i3UfC = parcelRequire("i3UfC");

var $5FkrB = parcelRequire("5FkrB");

var $bgNpv = parcelRequire("bgNpv");
var $hrVKU = parcelRequire("hrVKU");


/* flag-group.tsx generated by @compiled/babel-plugin v2.0.0 */ 

var $5FkrB = parcelRequire("5FkrB");

var $ceTz3 = parcelRequire("ceTz3");







var $5FkrB = parcelRequire("5FkrB");

/**
 * __SlideIn__
 *
 * Will slide an element into position, generally used for things that appear from outside of the viewport into view.
 *
 * See [examples](https://atlaskit.atlassian.com/packages/design-system/motion/docs/entering-motion).
 */ var $d840a7361899618f$var$SlideIn = function SlideIn(_ref) {
    var children = _ref.children, enterFrom = _ref.enterFrom, exitTo = _ref.exitTo, _ref$duration = _ref.duration, duration = _ref$duration === void 0 ? 'medium' : _ref$duration, isPaused = _ref.isPaused, onFinish = _ref.onFinish, _ref$animationTimingF = _ref.animationTimingFunction, animationTimingFunction = _ref$animationTimingF === void 0 ? 'ease-out' : _ref$animationTimingF, _ref$animationTimingF2 = _ref.animationTimingFunctionExiting, animationTimingFunctionExiting = _ref$animationTimingF2 === void 0 ? 'ease-in' : _ref$animationTimingF2;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $b4f4bca1dbeb6cba$export$2e2bcd8739ae039), {
        duration: duration,
        enteringAnimation: "slide-in-from-".concat(enterFrom),
        exitingAnimation: "slide-out-from-".concat(exitTo || enterFrom),
        animationTimingFunction: animationTimingFunction,
        animationTimingFunctionExiting: animationTimingFunctionExiting,
        isPaused: isPaused,
        onFinish: onFinish
    }, children);
};
var $d840a7361899618f$export$2e2bcd8739ae039 = $d840a7361899618f$var$SlideIn;




var $50U6m = parcelRequire("50U6m");



/* popover.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $ceTz3 = parcelRequire("ceTz3");

var $5FkrB = parcelRequire("5FkrB");

var $ceTz3 = parcelRequire("ceTz3");
const $867fa27ab54523a6$export$a274e22fb40f762e = (...styles)=>{
    // At runtime TStyles is resolved down to strings, but not at compile time.
    // We circumvent the type system here because of that.
    const actualStyles = styles;
    // The output should be a union type of passed in styles. This ensures the call
    // site of xcss prop can raise violations when disallowed styles have been passed.
    return (0, $ceTz3.default)(actualStyles);
};






var $5FkrB = parcelRequire("5FkrB");

var $5FkrB = parcelRequire("5FkrB");
var $4e9f8d125400f601$export$5fbf4d7fae6cdc00 = /*#__PURE__*/ (0, $5FkrB.createContext)(null);



var $5FkrB = parcelRequire("5FkrB");

var $5FkrB = parcelRequire("5FkrB");
var $d91edcb8301406d1$export$644a49f3b8c50fcd = /*#__PURE__*/ (0, $5FkrB.createContext)(null);


function $dc7ef8644e24b703$export$1d57e79091cc3046() {
    var namespace = (0, $5FkrB.useContext)((0, $d91edcb8301406d1$export$644a49f3b8c50fcd));
    return namespace;
}


function $4ae8e4fc2b927ce4$export$469bb693f11edc7f(_ref) {
    var isOpen = _ref.isOpen, type = _ref.type, onClose = _ref.onClose;
    var context = (0, $5FkrB.useContext)((0, $4e9f8d125400f601$export$5fbf4d7fae6cdc00));
    var namespace = (0, $dc7ef8644e24b703$export$1d57e79091cc3046)();
    (0, $5FkrB.useEffect)(function() {
        /**
     * Registers the `onClose` callback with the OpenLayerObserver.
     */ if (context === null) return;
        if (!isOpen) /**
       * If the layer is not open, we are not registering the `onClose` callback.
       * This is important to prevent the `onClose` from being called for layers that
       * are not open.
       *
       * Some consumers mistakenly pass "toggle" functions to `onClose` callbacks for
       * layer components, as Popup, e.g. `onClose={() => setIsOpen(!isOpen)}`.
       */ return;
        return context.onClose(onClose, {
            namespace: namespace,
            type: type
        });
    }, [
        context,
        isOpen,
        namespace,
        onClose,
        type
    ]);
}


/**
 * Normalizes an offset to a CSS length string. Numbers become `${n}px`;
 * strings pass through. Apply at the API boundary so internal code only
 * deals with strings.
 */ function $17de5a8c72c3918f$export$63b6b0ff65d84d47(_ref) {
    var value = _ref.value;
    if (typeof value === 'number') return "".concat(value, "px");
    return value;
}


/**
 * Default gap between trigger and popover. Resolves to a design
 * token (`space.100`) so the value follows the design system's spacing
 * scale. Used when `placement.offset.gap` is not provided.
 */ var $937a753ee474e40f$var$DEFAULT_GAP = "var(--ds-space-100, 8px)";
function $937a753ee474e40f$export$63044d21bc3d3fa2(_ref) {
    var _placement$offset, _placement$axis, _placement$edge, _placement$align, _placement$offset$cro, _placement$offset2, _placement$offset$cro2, _placement$offset3;
    var placement = _ref.placement;
    var consumerGap = (_placement$offset = placement.offset) === null || _placement$offset === void 0 ? void 0 : _placement$offset.gap;
    return {
        axis: (_placement$axis = placement.axis) !== null && _placement$axis !== void 0 ? _placement$axis : 'block',
        edge: (_placement$edge = placement.edge) !== null && _placement$edge !== void 0 ? _placement$edge : 'end',
        align: (_placement$align = placement.align) !== null && _placement$align !== void 0 ? _placement$align : 'center',
        offset: {
            gap: consumerGap === undefined ? $937a753ee474e40f$var$DEFAULT_GAP : (0, $17de5a8c72c3918f$export$63b6b0ff65d84d47)({
                value: consumerGap
            }),
            crossAxisShift: {
                value: (0, $17de5a8c72c3918f$export$63b6b0ff65d84d47)({
                    value: (_placement$offset$cro = (_placement$offset2 = placement.offset) === null || _placement$offset2 === void 0 || (_placement$offset2 = _placement$offset2.crossAxisShift) === null || _placement$offset2 === void 0 ? void 0 : _placement$offset2.value) !== null && _placement$offset$cro !== void 0 ? _placement$offset$cro : 0
                }),
                direction: (_placement$offset$cro2 = (_placement$offset3 = placement.offset) === null || _placement$offset3 === void 0 || (_placement$offset3 = _placement$offset3.crossAxisShift) === null || _placement$offset3 === void 0 ? void 0 : _placement$offset3.direction) !== null && _placement$offset$cro2 !== void 0 ? _placement$offset$cro2 : 'forwards'
            }
        }
    };
}


var $3e98c027b99b7d1d$var$rolesThatMoveFocus = new Set([
    'dialog',
    'alertdialog',
    'menu',
    'listbox',
    'tree',
    'grid'
]);
function $3e98c027b99b7d1d$export$b12adccf56228c71(_ref) {
    var role = _ref.role;
    if (!role) return false;
    return $3e98c027b99b7d1d$var$rolesThatMoveFocus.has(role);
}




var $5FkrB = parcelRequire("5FkrB");

var $e80781e77f806e41$export$ff7706047246b98b = (0, $86089df3a0fd54eb$export$2e2bcd8739ae039)(function() {
    if (typeof window === 'undefined' || !('matchMedia' in window)) return false;
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
});


function $c43ad4b000ffab41$var$runCancellableSettlement(_ref) {
    var schedule = _ref.schedule, onSettled = _ref.onSettled;
    var isCancelled = false;
    schedule(function() {
        if (isCancelled) return;
        onSettled();
    });
    return function() {
        isCancelled = true;
    };
}
/**
 * Fires `onSettled` once all animations currently applied to `element`
 * finish or are cancelled. Returns a cleanup that prevents stale settlement.
 */ function $c43ad4b000ffab41$var$runOnAnimationsSettled(_ref2) {
    var element = _ref2.element, onSettled = _ref2.onSettled;
    return $c43ad4b000ffab41$var$runCancellableSettlement({
        onSettled: onSettled,
        schedule: function schedule(settle) {
            var _element$getAnimation, _element$getAnimation2;
            var animations = (_element$getAnimation = (_element$getAnimation2 = element.getAnimations) === null || _element$getAnimation2 === void 0 ? void 0 : _element$getAnimation2.call(element)) !== null && _element$getAnimation !== void 0 ? _element$getAnimation : [];
            Promise.allSettled(animations.map(function(animation) {
                return animation.finished;
            })).then(settle);
        }
    });
}
function $c43ad4b000ffab41$export$1bccb45daf07907f(_ref3) {
    var isOpen = _ref3.isOpen, shouldAnimate = _ref3.shouldAnimate, elementRef = _ref3.elementRef, onEnterFinish = _ref3.onEnterFinish, onExitFinish = _ref3.onExitFinish;
    var willAnimate = shouldAnimate && !(0, $e80781e77f806e41$export$ff7706047246b98b)();
    var isNativeClosedRef = (0, $5FkrB.useRef)(false);
    // Promote `closed → entering`/`closed → open` synchronously during
    // render so the host element mounts in the same commit as the open
    // intent. All other transitions are driven by phase-specific effects.
    var _useState = (0, $5FkrB.useState)(function() {
        if (!isOpen) return 'closed';
        return willAnimate ? 'entering' : 'open';
    }), _useState2 = (0, $4dd2366636a00e12$export$2e2bcd8739ae039)(_useState, 2), phase = _useState2[0], setPhase = _useState2[1];
    // Rearm only after controlled state and the native lifecycle have both
    // reached closed. Resetting as soon as `isOpen` becomes false can erase a
    // closing toggle that was handled in the same React batch.
    if (!isOpen && phase === 'closed') isNativeClosedRef.current = false;
    if (isOpen && phase === 'closed' && !isNativeClosedRef.current) setPhase(willAnimate ? 'entering' : 'open');
    if (!isOpen && (phase === 'open' || phase === 'entering')) // Close intent. Move to `exiting` to gate the unmount on either
    // the exit transition (animated) or the closing toggle event
    // (non-animated). Includes interrupted entry (`entering → exiting`).
    setPhase('exiting');
    if (isOpen && phase === 'exiting' && !isNativeClosedRef.current) // Reopen mid-exit. With animation, jump back to `entering` and let
    // the entry transition restart from current visual state. Without
    // animation, jump straight to `open` (the handshake we were waiting
    // for is no longer relevant; the consumer wants the host visible
    // again synchronously).
    setPhase(willAnimate ? 'entering' : 'open');
    // Keep stable refs to the latest callbacks so effects and promise callbacks
    // always call the current callback without needing them in dependency arrays.
    var onEnterFinishRef = (0, $5FkrB.useRef)(onEnterFinish);
    onEnterFinishRef.current = onEnterFinish;
    var onExitFinishRef = (0, $5FkrB.useRef)(onExitFinish);
    onExitFinishRef.current = onExitFinish;
    // Animated entry: wait for all active animations and move to `open`.
    (0, $5FkrB.useEffect)(function() {
        if (phase !== 'entering') return;
        var element = elementRef.current;
        if (!element) return;
        return $c43ad4b000ffab41$var$runOnAnimationsSettled({
            element: element,
            onSettled: function onSettled() {
                var _onEnterFinishRef$cur;
                // Fire the consumer callback before transitioning phase so any
                // state the consumer reads (refs, DOM nodes) is still attached
                // in the same synchronous tick, regardless of React batching
                // semantics.
                (_onEnterFinishRef$cur = onEnterFinishRef.current) === null || _onEnterFinishRef$cur === void 0 || _onEnterFinishRef$cur.call(onEnterFinishRef);
                setPhase(function(current) {
                    return current === 'entering' ? 'open' : current;
                });
            }
        });
    }, [
        phase,
        elementRef
    ]);
    // Non-animated entry callback. The lifecycle goes `closed → open`
    // directly with no `entering` phase; fire `onEnterFinish` on that jump.
    // A previous-phase ref avoids double-firing on the animated path.
    var prevPhaseForEntryRef = (0, $5FkrB.useRef)('closed');
    (0, $5FkrB.useEffect)(function() {
        var prevPhase = prevPhaseForEntryRef.current;
        prevPhaseForEntryRef.current = phase;
        // Animated entry settle goes through `entering` and already fired
        // onEnterFinish above; only handle the non-animated direct jumps.
        if (prevPhase !== 'open' && phase === 'open' && prevPhase !== 'entering') {
            var _onEnterFinishRef$cur2;
            (_onEnterFinishRef$cur2 = onEnterFinishRef.current) === null || _onEnterFinishRef$cur2 === void 0 || _onEnterFinishRef$cur2.call(onEnterFinishRef);
        }
    }, [
        phase
    ]);
    // Animated exit: wait for all active animations, fire `onExitFinish`,
    // then move to `closed` to unmount the host.
    (0, $5FkrB.useEffect)(function() {
        if (phase !== 'exiting' || !willAnimate) return;
        var element = elementRef.current;
        if (!element) return;
        return $c43ad4b000ffab41$var$runOnAnimationsSettled({
            element: element,
            onSettled: function onSettled() {
                var _onExitFinishRef$curr;
                // Fire the consumer callback before transitioning phase to
                // `closed`. The phase change drives the host element unmount,
                // and consumers expect to be able to read the element (or a
                // forwarded ref to it) inside `onExitFinish`. Doing this in
                // the safe order avoids relying on React's automatic batching
                // to keep the element attached across the callback.
                (_onExitFinishRef$curr = onExitFinishRef.current) === null || _onExitFinishRef$curr === void 0 || _onExitFinishRef$curr.call(onExitFinishRef);
                setPhase(function(current) {
                    return current === 'exiting' ? 'closed' : current;
                });
            }
        });
    }, [
        phase,
        willAnimate,
        elementRef
    ]);
    // Native dismissal is authoritative. Its toggle can arrive while controlled
    // state still says open, so remember that native state and do not
    // reopen until `isOpen` has first moved to false.
    (0, $5FkrB.useLayoutEffect)(function() {
        if (phase === 'exiting' && !willAnimate && isNativeClosedRef.current) setPhase('closed');
    }, [
        phase,
        willAnimate
    ]);
    var onToggle = (0, $5FkrB.useCallback)(function(event) {
        if (event.newState === 'open') {
            isNativeClosedRef.current = false;
            return;
        }
        if (event.newState !== 'closed') return;
        isNativeClosedRef.current = true;
        setPhase(function(current) {
            if (current === 'open' || current === 'entering') return 'exiting';
            if (current === 'exiting' && !willAnimate) return 'closed';
            return current;
        });
    }, [
        willAnimate
    ]);
    // Non-animated exit callback. There are no animations to wait for, so fire
    // `onExitFinish` on the transition into `exiting` (the unmount itself
    // is gated by the closing toggle handshake above).
    var prevPhaseForExitRef = (0, $5FkrB.useRef)('closed');
    (0, $5FkrB.useEffect)(function() {
        var prevPhase = prevPhaseForExitRef.current;
        prevPhaseForExitRef.current = phase;
        // Only fire on the non-animated transition into `exiting`. The
        // animated path's `exiting → closed` settle already fires
        // `onExitFinish` from `runOnAnimationsSettled`.
        if (prevPhase !== 'exiting' && phase === 'exiting' && !willAnimate) {
            var _onExitFinishRef$curr2;
            (_onExitFinishRef$curr2 = onExitFinishRef.current) === null || _onExitFinishRef$curr2 === void 0 || _onExitFinishRef$curr2.call(onExitFinishRef);
        }
    }, [
        phase,
        willAnimate
    ]);
    return {
        phase: phase,
        onToggle: onToggle
    };
}



var $5FkrB = parcelRequire("5FkrB");

var $f2476a5872da08af$var$topLayerSelector = '[popover], dialog, [role="dialog"], [role="alertdialog"]';
function $f2476a5872da08af$export$df8c72c64edc7260(_ref) {
    var element = _ref.element, container = _ref.container;
    return element.closest($f2476a5872da08af$var$topLayerSelector) === container.closest($f2476a5872da08af$var$topLayerSelector);
}


var $98e208f1c61de8c0$export$e1252723db1c541 = function() {
    // Common exclusion filter applied to every selector.
    var not = ':not([tabindex="-1"]):not([aria-disabled="true"]):not([aria-hidden="true"])';
    var notDisabled = ":not([disabled])".concat(not);
    var focusable = [
        "a[href]".concat(not),
        "area[href]".concat(not),
        "input".concat(notDisabled, ":not([type=\"hidden\"])"),
        "select".concat(notDisabled),
        "textarea".concat(notDisabled),
        "button".concat(notDisabled),
        "iframe".concat(not),
        "audio[controls]".concat(not),
        "video[controls]".concat(not),
        "[contenteditable]:not([contenteditable=\"false\"])".concat(not),
        "[tabindex]".concat(notDisabled)
    ];
    return {
        focusable: focusable.join(','),
        // Build the `:focus` selector
        focused: focusable.map(function(selector) {
            return "".concat(selector, ":focus");
        }).join(',')
    };
}();


function $f888ff44f9066ad6$export$f6768025e418420e(_ref) {
    var container = _ref.container, filter = _ref.filter;
    return Array.from(container.querySelectorAll((0, $98e208f1c61de8c0$export$e1252723db1c541).focusable)).filter(function(element) {
        return element instanceof HTMLElement;
    }).filter(function(element) {
        return (0, $f2476a5872da08af$export$df8c72c64edc7260)({
            element: element,
            container: container
        });
    }).filter(function(element) {
        return !filter || filter(element, container);
    });
}


function $8103ddffbd9756ec$export$748138f04a69bf21(_ref) {
    var container = _ref.container, filter = _ref.filter;
    var items = (0, $f888ff44f9066ad6$export$f6768025e418420e)({
        container: container,
        filter: filter
    });
    return items.length > 0 ? items[0] : null;
}



function $06a409bcbe29b01d$export$73e81fa65335a75b(_ref) {
    var container = _ref.container, filter = _ref.filter;
    var items = (0, $f888ff44f9066ad6$export$f6768025e418420e)({
        container: container,
        filter: filter
    });
    return items.length > 0 ? items[items.length - 1] : null;
}


/**
 * Returns the next focusable element in the given direction relative to the
 * currently focused element within the container. Wraps around at both ends.
 *
 * Returns `null` if there is no focused element within the container or if
 * the focused element is not in the list of focusable elements.
 */ 

function $7c1fc5354840ed8c$export$a7db88e6d491b450(_ref) {
    var _all$nextIndex;
    var container = _ref.container, direction = _ref.direction, filter = _ref.filter;
    var all = (0, $f888ff44f9066ad6$export$f6768025e418420e)({
        container: container,
        filter: filter
    });
    var current = container.querySelector((0, $98e208f1c61de8c0$export$e1252723db1c541).focused);
    if (!(current instanceof HTMLElement)) return null;
    var index = all.indexOf(current);
    if (index === -1) return null;
    var nextIndex = function() {
        if (direction === 'forwards') return (index + 1) % all.length;
        var proposed = index - 1;
        // if going into negative numbers, loop back to the last item
        return proposed < 0 ? all.length - 1 : proposed;
    }();
    return (_all$nextIndex = all[nextIndex]) !== null && _all$nextIndex !== void 0 ? _all$nextIndex : null;
}




function $55467f84f55f4095$export$b9590fdfeb5f722f(_ref) {
    var _getDocument;
    var container = _ref.container;
    var focused = (_getDocument = (0, $fc5ac9c99de29fbb$export$f65ca476c09acec0)()) === null || _getDocument === void 0 ? void 0 : _getDocument.activeElement;
    if (!(focused instanceof HTMLElement)) return false;
    // Cannot be in a nested layer if it is not in the container
    if (!container.contains(focused)) return false;
    // If not in the same layer, must be in a nested layer
    return !(0, $f2476a5872da08af$export$df8c72c64edc7260)({
        element: focused,
        container: container
    });
}


/**
 * Roles that require focus wrapping per WAI-ARIA APG.
 *
 * - `dialog`: https://www.w3.org/WAI/ARIA/apg/patterns/dialog-modal/
 * - `alertdialog`: same keyboard pattern as dialog
 *
 * `menu` is intentionally excluded. Menus are composite widgets
 * (https://www.w3.org/WAI/ARIA/apg/practices/keyboard-interface/#kbd_general_within)
 * that manage their own internal keyboard navigation via arrow keys,
 * not Tab. Tab/Shift+Tab should move focus OUT of a menu entirely.
 *
 * Menu keyboard behavior (arrow keys, Home/End, type-ahead, Enter/Space)
 * is context-dependent. It varies by orientation, nesting depth, item
 * type, and control pattern (menu button vs menubar). This makes it
 * impossible to implement generically here. The consumer component
 * (e.g. `dropdown-menu`) owns all menu keyboard navigation.
 *
 * See: notes/outputs/menu-keyboard-decision.md
 */ function $ebdc7edf7e2f935e$var$roleRequiresFocusWrap(role) {
    return role === 'dialog' || role === 'alertdialog';
}
function $ebdc7edf7e2f935e$export$4f6462e86a70abe5(_ref) {
    var elementRef = _ref.elementRef, role = _ref.role, phase = _ref.phase;
    var isVisible = phase !== 'closed';
    (0, $5FkrB.useEffect)(function() {
        var element = elementRef.current;
        if (!element || !$ebdc7edf7e2f935e$var$roleRequiresFocusWrap(role) || !isVisible) return;
        var unbind = (0, $5b617c1f48263075$exports.bind)(element, {
            type: 'keydown',
            listener: function listener(event) {
                if (event.key !== 'Tab') return;
                // If focus is already in a nested layer, then
                // we continue to let that nested layer own focus
                if ((0, $55467f84f55f4095$export$b9590fdfeb5f722f)({
                    container: element
                })) return;
                // Prevent the browser giving focus to where it wants to
                // (we will be handling it, including with wrapping)
                event.preventDefault();
                var direction = event.shiftKey ? 'backwards' : 'forwards';
                // Try to move to the next/previous focusable element relative
                // to the currently focused element within the container.
                var next = (0, $7c1fc5354840ed8c$export$a7db88e6d491b450)({
                    container: element,
                    direction: direction
                });
                if (next) {
                    next.focus();
                    return;
                }
                // Nothing is currently focused inside the container (or the
                // focused element is not in the focusable list). Fall back to
                // the first or last focusable element depending on direction.
                var fallback = direction === 'forwards' ? (0, $8103ddffbd9756ec$export$748138f04a69bf21)({
                    container: element
                }) : (0, $06a409bcbe29b01d$export$73e81fa65335a75b)({
                    container: element
                });
                if (fallback) fallback.focus();
            },
            options: {
                capture: true
            }
        });
        return unbind;
    }, [
        elementRef,
        role,
        isVisible
    ]);
}



var $5FkrB = parcelRequire("5FkrB");

/**
 * Determines the correct element to receive initial focus within a popover,
 * based on its ARIA role.
 *
 * Focus rules by role (per WAI-ARIA APG):
 * - `dialog` / `alertdialog`: first element with `[autofocus]`, or first focusable element
 * - `menu`: first menu item (`[role="menuitem|menuitemcheckbox|menuitemradio"]`)
 * - `listbox`: first selected option (`[aria-selected="true"]`), or first option (`[role="option"]`)
 * - `tooltip`: no focus movement (tooltips are informational)
 * - no role / other roles: no focus movement
 *
 * Note: React 18's `autoFocus` JSX prop does NOT set the HTML `autofocus`
 * attribute - it only calls `.focus()` imperatively during commit, which
 * has no effect on hidden popover content. Consumers must set the native
 * attribute via a ref callback (e.g. `node.setAttribute('autofocus', '')`).
 * React 19+ reflects the JSX prop as the HTML attribute automatically.
 *
 * Combobox pattern exception: if the popup is controlled by a focused
 * combobox-like trigger (its `aria-controls` references this popup),
 * focus stays on the textbox regardless of role. See
 * `isComboboxControllingPopup`.
 */ /**
 * WAI-ARIA APG Combobox Pattern: when a combobox controls a popup (listbox,
 * grid, tree, or menu), DOM focus must remain on the textbox. Subsequent
 * navigation through popup items uses `aria-activedescendant` (or proxied
 * keyboard events), never DOM focus movement.
 *
 * Detects both variants in a single pass:
 * - In-popup combobox: the textbox lives inside the popup `container`
 *   (the popup is rendered as a child of the combobox wrapper).
 * - External combobox: the textbox is rendered OUTSIDE the popup
 *   (`react-select` pattern, where the listbox is portalled separately
 *   from the textbox).
 *
 * Acceptance criteria for the active element:
 * - Role / element-type filter: `role="combobox"`, `role="textbox"`,
 *   `TEXTAREA`, `contentEditable`, or `INPUT` of text-like type
 *   (`text`, `search`, `email`, `url`, `tel`, `password`, or
 *   unspecified). Non-text input types (`button`, `checkbox`, etc.)
 *   are rejected.
 * - Reference filter: `aria-controls` (or legacy `aria-owns`) IDREFS
 *   must resolve to an element that IS or CONTAINS the popup container.
 *
 * See: https://www.w3.org/WAI/ARIA/apg/patterns/combobox/
 */ // `<input>` types treated as text-like for combobox detection.
// Non-text input types (`button`, `checkbox`, `submit`, etc.) are rejected.
// A missing `type` attribute defaults to `text` per the HTML spec, so we
// normalize that case before lookup rather than including an empty string here.
var $49bdbbe88d822b1c$var$TEXT_LIKE_INPUT_TYPES = new Set([
    'text',
    'search',
    'email',
    'url',
    'tel',
    'password'
]);
function $49bdbbe88d822b1c$var$isTextboxLikeElement(element) {
    var role = element.getAttribute('role');
    if (role === 'combobox' || role === 'textbox') return true;
    // `tagName` is uppercase for HTML elements but can be mixed-case for
    // XML/SVG. Normalize once so downstream comparisons stay lowercase.
    var tag = element.tagName.toLowerCase();
    if (tag === 'textarea') return true;
    if (element.isContentEditable) return true;
    if (tag === 'input') {
        var _element$getAttribute;
        var type = ((_element$getAttribute = element.getAttribute('type')) !== null && _element$getAttribute !== void 0 ? _element$getAttribute : 'text').toLowerCase();
        return $49bdbbe88d822b1c$var$TEXT_LIKE_INPUT_TYPES.has(type);
    }
    return false;
}
function $49bdbbe88d822b1c$var$isComboboxControllingPopup(_ref) {
    var _active$getAttribute;
    var container = _ref.container;
    var ownerDocument = container.ownerDocument;
    var active = ownerDocument.activeElement;
    if (!(active instanceof HTMLElement)) return false;
    if (!$49bdbbe88d822b1c$var$isTextboxLikeElement(active)) return false;
    // Accept legacy `aria-owns` in addition to `aria-controls`.
    // `aria-controls` / `aria-owns` are IDREFS (space-separated list of IDs)
    // per the WAI-ARIA spec, so we must split and check membership rather
    // than comparing with strict equality. A combobox that controls both
    // this popup and another element (e.g. a results status region) must
    // still be recognised as controlling this popup.
    var idRefs = (_active$getAttribute = active.getAttribute('aria-controls')) !== null && _active$getAttribute !== void 0 ? _active$getAttribute : active.getAttribute('aria-owns');
    if (!idRefs) return false;
    // Match if any referenced element IS, CONTAINS, or IS CONTAINED BY the
    // popup container. The "contained by" case covers wrapper-style adopters
    // like react-select, where the combobox input's `aria-controls` points at
    // a listbox element that is a descendant of the Popover host (the
    // listbox role lives on a child the wrapped library owns, not on the
    // host we render).
    var referencedIds = idRefs.split(/\s+/).filter(function(id) {
        return id !== '';
    });
    return referencedIds.some(function(id) {
        var referenced = ownerDocument.getElementById(id);
        if (!referenced) return false;
        return referenced === container || referenced.contains(container) || container.contains(referenced);
    });
}
function $49bdbbe88d822b1c$var$getInitialFocusTarget(_ref2) {
    var container = _ref2.container, role = _ref2.role;
    if (role === 'dialog' || role === 'alertdialog') {
        // Prefer element with the native HTML autofocus attribute.
        var autofocusEl = container.querySelector('[autofocus]');
        if (autofocusEl) return autofocusEl;
        // Fall back to first focusable element
        return (0, $8103ddffbd9756ec$export$748138f04a69bf21)({
            container: container
        });
    }
    // The combobox carve-out is kept role-specific (menu / listbox) rather
    // than hoisted. Hoisting it over-matched on dialog popups that contain
    // a nested combobox (e.g. datetime-picker's dialog hosts a react-select),
    // where the active combobox's `aria-controls` falsely matched the
    // container and suppressed the dialog's own focus contract.
    if (role === 'menu') {
        if ($49bdbbe88d822b1c$var$isComboboxControllingPopup({
            container: container
        })) return null;
        // Initial focus placement is the extent of what top-layer provides
        // for menus. All subsequent keyboard navigation (arrow keys, Home/End,
        // type-ahead, Enter/Space, submenu coordination) is the responsibility
        // of the consumer component (e.g. dropdown-menu), because menu keyboard
        // behavior varies by context (orientation, nesting, item type, control
        // pattern). See: notes/outputs/menu-keyboard-decision.md
        return (0, $8103ddffbd9756ec$export$748138f04a69bf21)({
            container: container
        });
    }
    if (role === 'listbox') {
        // ARIA Combobox Pattern: if a combobox-like textbox owns the popup
        // (in-popup or external e.g. react-select), leave focus on the
        // textbox - navigation is proxied through it.
        if ($49bdbbe88d822b1c$var$isComboboxControllingPopup({
            container: container
        })) return null;
        // Prefer the selected option, then fall back to the first option.
        // We intentionally match by `[role="option"]` rather than by
        // `getFirstFocusable`. The standard WAI-ARIA APG listbox pattern
        // renders options with `tabindex="-1"` (managed via roving
        // tabindex); `getFirstFocusable` excludes `tabindex="-1"` elements
        // and would silently lose initial focus for spec-conformant
        // listboxes. Options remain programmatically focusable.
        var selectedOption = container.querySelector('[role="option"][aria-selected="true"]');
        if (selectedOption) return selectedOption;
        var firstOption = container.querySelector('[role="option"]');
        if (firstOption) return firstOption;
        // Last resort for non-standard listboxes that render no options
        // but do contain a focusable element (e.g. an empty-state action).
        return (0, $8103ddffbd9756ec$export$748138f04a69bf21)({
            container: container
        });
    }
    // tooltip, no role, or other roles: no focus movement
    return null;
}
function $49bdbbe88d822b1c$export$e992c40175757a22(_ref3) {
    var elementRef = _ref3.elementRef, phase = _ref3.phase, role = _ref3.role;
    // Track the previous phase so we only focus on transitions into a
    // visible phase from either `'closed'` (fresh mount) or `'exiting'`
    // (mid-exit reopen where the browser has already restored focus to
    // the trigger). Pure `entering → exiting → entering` stutters where
    // the consumer toggles in the same frame are still collapsed.
    var prevPhaseRef = (0, $5FkrB.useRef)('closed');
    (0, $5FkrB.useEffect)(function() {
        var _getInitialFocusTarge;
        var prevPhase = prevPhaseRef.current;
        prevPhaseRef.current = phase;
        // Only focus on transitions into a visible phase from `'closed'`
        // (fresh open) or `'exiting'` (mid-exit reopen).
        if (phase === 'closed') return;
        if (prevPhase !== 'closed' && prevPhase !== 'exiting') return;
        var element = elementRef.current;
        if (!element) return;
        (_getInitialFocusTarge = $49bdbbe88d822b1c$var$getInitialFocusTarget({
            container: element,
            role: role
        })) === null || _getInitialFocusTarge === void 0 || _getInitialFocusTarge.focus();
    }, [
        elementRef,
        phase,
        role
    ]);
}


/**
 * Detects `popover="hint"` support via DOM reflection. SSR-safe, cached.
 */ var $1bc9437c28b7512c$var$supportsPopoverHint = (0, $86089df3a0fd54eb$export$2e2bcd8739ae039)(function() {
    if (typeof document === 'undefined') return false;
    // eslint-disable-next-line @atlaskit/platform/no-direct-document-usage -- feature detection
    var element = document.createElement('div');
    element.setAttribute('popover', 'hint');
    return element.popover === 'hint';
});
// Surface reset — neutralises inherited interaction and text-layout properties
// (e.g. `pointer-events: none` from an overlaid controls container and
// `white-space: nowrap` from an `@atlaskit/select` option) that leak into a
// top-layer element because, for CSS inheritance, it is still a DOM child of its
// trigger (top-layer promotion is paint/stacking only; the legacy portal path
// avoided this by rendering at `<body>`). Excludes `color`/`font` (theming) and
// `direction`/`unicode-bidi` (RTL must inherit).
//
// KEEP IN SYNC with the identical `surfaceResetStyles` in `dialog/dialog-content.tsx`.
// ADS forbids sharing styles across files (`no-exported-styles` /
// `no-imported-style-values` — Compiled styles are null at runtime), so the reset is
// co-located and duplicated deliberately.
var $1bc9437c28b7512c$var$surfaceResetStyles = {
    root: "_lcxv1wug _o5724jg8 _1nmz4jg8 _1i4q4jg8 _y3gnv2br _azhwidpf _1p1dglyw"
};
var $1bc9437c28b7512c$var$styles = {
    root: "_19itglyw _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19pkidpf _2hwxidpf _otyridpf _18u0idpf _1r041wug _1reoewfl _18m9ewfl _bfhk1j28 _4t3i1wug",
    motion: "_k8m011k7 _1oecdn4k _1s9z1a5r _1o511hrf _bl8aglyw _156y147i",
    enter: "_y44v179n",
    exit: "_y44vof1f"
};
// Intentionally using `Record<string, string>` instead of `React.CSSProperties`
// to avoid type errors about the CSS variables not being valid property names
var $1bc9437c28b7512c$var$popupMotionStyles = {
    block: {
        start: {
            '--ds-popover-motion-enter': "var(--ds-popup-enter-top, 150ms cubic-bezier(0.4, 1, 0.6, 1) SlideInTop8px, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn0to100)",
            '--ds-popover-motion-exit': "var(--ds-popup-exit-top, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) SlideOutTop8px, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)"
        },
        end: {
            '--ds-popover-motion-enter': "var(--ds-popup-enter-bottom, 150ms cubic-bezier(0.4, 1, 0.6, 1) SlideInBottom8px, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn0to100)",
            '--ds-popover-motion-exit': "var(--ds-popup-exit-bottom, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) SlideOutBottom8px, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)"
        }
    },
    inline: {
        start: {
            '--ds-popover-motion-enter': "var(--ds-popup-enter-left, 150ms cubic-bezier(0.4, 1, 0.6, 1) SlideInLeft8px, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn0to100)",
            '--ds-popover-motion-exit': "var(--ds-popup-exit-left, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) SlideOutLeft8px, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)"
        },
        end: {
            '--ds-popover-motion-enter': "var(--ds-popup-enter-right, 150ms cubic-bezier(0.4, 1, 0.6, 1) SlideInRight8px, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn0to100)",
            '--ds-popover-motion-exit': "var(--ds-popup-exit-right, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) SlideOutRight8px, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)"
        }
    }
};
/**
 * Roles registered with the open layer observer as `popup`, so `closeLayers()`
 * dismisses them. `modal` comes from Dialog only; other layer types are unused.
 */ var $1bc9437c28b7512c$var$POPUP_ROLES = new Set([
    'menu',
    'listbox',
    'dialog',
    'alertdialog',
    'tree',
    'grid'
]);
var $1bc9437c28b7512c$export$5b6b19405a83ff9d = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function Popover(_ref, ref) {
    var children = _ref.children, _ref$mode = _ref.mode, modeProp = _ref$mode === void 0 ? 'auto' : _ref$mode, onClose = _ref.onClose, onEnterFinish = _ref.onEnterFinish, onExitFinish = _ref.onExitFinish, _ref$shouldAnimate = _ref.shouldAnimate, shouldAnimate = _ref$shouldAnimate === void 0 ? false : _ref$shouldAnimate, placement = _ref.placement, testId = _ref.testId, isOpen = _ref.isOpen, enteringAnimationXcss = _ref.enteringAnimationXcss, exitingAnimationXcss = _ref.exitingAnimationXcss, role = _ref.role, label = _ref.label, labelledBy = _ref.labelledBy, idProp = _ref.id;
    var autoId = (0, $5FkrB.useId)();
    var ownRef = (0, $5FkrB.useRef)(null);
    var combinedRef = (0, $db13a2f91f6a0f56$export$2e2bcd8739ae039)([
        ownRef,
        ref
    ].filter(Boolean));
    // `useId()` colons are invalid in CSS selectors and popover target attributes.
    var popoverId = idProp !== null && idProp !== void 0 ? idProp : "popover-".concat(autoId.replace(/:/g, ''));
    var _useAnimatedVisibilit = (0, $c43ad4b000ffab41$export$1bccb45daf07907f)({
        isOpen: isOpen,
        shouldAnimate: shouldAnimate,
        elementRef: ownRef,
        onEnterFinish: onEnterFinish,
        onExitFinish: onExitFinish
    }), phase = _useAnimatedVisibilit.phase, onToggle = _useAnimatedVisibilit.onToggle;
    // True while the host element is mounted (any phase except `closed`).
    // Used as a dep so listener-rebind effects re-attach after a remount.
    var isVisible = phase !== 'closed';
    // Focus management: initial focus on entry (role-dependent), Tab cycling
    // for dialog roles. Restoration is native for outermost popovers; nested
    // focus-capturing roles are handled below via the `beforetoggle` snapshot.
    // Passing `phase` keeps `useFocusWrap` attached through the animated-exit
    // window (WCAG 2.4.3 guard). See notes/architecture/focus-restoration.md.
    (0, $ebdc7edf7e2f935e$export$4f6462e86a70abe5)({
        elementRef: ownRef,
        role: role,
        phase: phase
    });
    (0, $49bdbbe88d822b1c$export$e992c40175757a22)({
        elementRef: ownRef,
        phase: phase,
        role: role
    });
    // Register with open layer observer so `closeLayers()` and open-count
    // subscriptions work. Only popup-like roles register as `popup`; passive
    // roles (tooltip, status, etc.) leave `type` undefined.
    var handleObserverClose = (0, $5FkrB.useCallback)(function() {
        onClose === null || onClose === void 0 || onClose({
            reason: 'programmatic'
        });
    }, [
        onClose
    ]);
    (0, $4ae8e4fc2b927ce4$export$469bb693f11edc7f)({
        type: role && $1bc9437c28b7512c$var$POPUP_ROLES.has(role) ? 'popup' : undefined,
        isOpen: isOpen,
        onClose: handleObserverClose
    });
    // `hint` falls back to `auto` when unsupported: closest behavior (light
    // dismiss works), but `auto` participates in the auto-dismiss stack so it
    // will close other `auto` popovers when opened. Acceptable trade-off given
    // shrinking browser set without `hint` support.
    var mode = modeProp === 'hint' && !$1bc9437c28b7512c$var$supportsPopoverHint() ? 'auto' : modeProp;
    var popupMotionStyle = (0, $5FkrB.useMemo)(function() {
        if (!placement || !shouldAnimate) return undefined;
        var _resolvePlacement = (0, $937a753ee474e40f$export$63044d21bc3d3fa2)({
            placement: placement
        }), axis = _resolvePlacement.axis, edge = _resolvePlacement.edge;
        return $1bc9437c28b7512c$var$popupMotionStyles[axis][edge];
    }, [
        placement,
        shouldAnimate
    ]);
    // Prevents toggle handler from calling onClose for our own hidePopover() calls.
    var programmaticCloseRef = (0, $5FkrB.useRef)(false);
    // Set in capture-phase keydown so the toggle handler knows close reason.
    var closeReasonRef = (0, $5FkrB.useRef)('light-dismiss');
    // Snapshot of pre-open focus, used to restore focus for nested popovers
    // with focus-capturing roles (browser only restores the outermost).
    var previouslyFocusedElementRef = (0, $5FkrB.useRef)(null);
    var handleBeforeToggle = (0, $5FkrB.useCallback)(function(event) {
        if (event.newState !== 'open') return;
        // eslint-disable-next-line @atlaskit/platform/no-direct-document-usage -- need active element snapshot
        var active = document.activeElement;
        previouslyFocusedElementRef.current = active instanceof HTMLElement ? active : null;
    }, []);
    var handleToggle = (0, $5FkrB.useCallback)(function(event) {
        var element = ownRef.current;
        if (event.newState === 'open') {
            onToggle(event);
            return;
        }
        if (event.newState === 'closed') {
            if (element) {
                // Nested-popover focus restoration fallback (browser only
                // restores outermost; Firefox skips nested entirely).
                // Restore only when the role moved focus in on open AND the
                // close was Escape/programmatic. For light dismiss, the
                // click target keeps focus per HTML spec
                // (`focusPreviousElement=false`).
                var previouslyFocused = previouslyFocusedElementRef.current;
                var reason = closeReasonRef.current;
                var isProgrammatic = programmaticCloseRef.current;
                var shouldRestore = previouslyFocused !== null && previouslyFocused.isConnected && (0, $3e98c027b99b7d1d$export$b12adccf56228c71)({
                    role: role
                }) && (reason === 'escape' || isProgrammatic);
                if (shouldRestore && previouslyFocused) previouslyFocused.focus({
                    preventScroll: true
                });
                previouslyFocusedElementRef.current = null;
            }
            // Programmatic close: consumer already knows.
            if (programmaticCloseRef.current) // Reset reason so a stale 'escape' from a race with Escape keydown
            // does not corrupt the next browser-dismiss cycle.
            closeReasonRef.current = 'light-dismiss';
            else {
                // Browser dismiss (Escape/click-outside).
                var _reason = closeReasonRef.current;
                closeReasonRef.current = 'light-dismiss';
                // Optional: `manual` mode has no `onClose` in the forwarded type.
                onClose === null || onClose === void 0 || onClose({
                    reason: _reason
                });
            }
        }
        onToggle(event);
    }, [
        onClose,
        onToggle,
        role
    ]);
    // Bind via `useLayoutEffect`, and BEFORE the show/hide layout effect
    // below, so listeners are attached when `showPopover()` synchronously
    // dispatches `beforetoggle`. A regular `useEffect` would miss that
    // first dispatch, dropping the `previouslyFocusedElementRef` snapshot
    // and breaking nested-popover focus restoration on close. React runs
    // layout effects in source order on the same commit.
    (0, $5FkrB.useLayoutEffect)(function() {
        var element = ownRef.current;
        if (!element) return;
        // Tag Escape before the browser processes light dismiss.
        var unbindEscape = (0, $5b617c1f48263075$exports.bind)(element, {
            type: 'keydown',
            listener: function listener(event) {
                if (event.key === 'Escape') closeReasonRef.current = 'escape';
            },
            options: {
                capture: true
            }
        });
        var unbindToggle = (0, $5b617c1f48263075$exports.bind)(element, {
            type: 'toggle',
            listener: handleToggle
        });
        // Snapshot `document.activeElement` before `useInitialFocus` moves it.
        var unbindBeforeToggle = (0, $5b617c1f48263075$exports.bind)(element, {
            type: 'beforetoggle',
            listener: handleBeforeToggle
        });
        return function() {
            unbindEscape();
            unbindToggle();
            unbindBeforeToggle();
        };
    }, [
        handleToggle,
        handleBeforeToggle,
        isVisible
    ]);
    // Show/hide based on isOpen. `showPopover`/`hidePopover` are no-ops when
    // already in the target state. Try/catch guards `InvalidStateError` on
    // disconnected elements (StrictMode/concurrent/unmount edge cases).
    (0, $5FkrB.useLayoutEffect)(function() {
        var element = ownRef.current;
        if (!element) return;
        if (isOpen) {
            programmaticCloseRef.current = false;
            // Clear stale 'escape' from a prior cycle: the ref outlives
            // the host element, and the no-animation path unmounts before
            // `handleToggle` can reset it.
            closeReasonRef.current = 'light-dismiss';
            try {
                element.showPopover();
            } catch (_unused) {}
            return function() {
                programmaticCloseRef.current = true;
                try {
                    element.hidePopover();
                } catch (_unused2) {}
            };
        }
        programmaticCloseRef.current = true;
        try {
            element.hidePopover();
        } catch (_unused3) {}
    }, [
        isOpen
    ]);
    // Unmount the host once exit completes so it does not leave an empty
    // `role`/`popover` element in the accessibility tree. The element
    // remounts on the next open; the `popoverId` is stable across opens.
    if (!isVisible) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("div", {
        ref: combinedRef,
        id: popoverId,
        popover: mode,
        role: role,
        "aria-label": label,
        "aria-labelledby": labelledBy,
        "data-testid": testId,
        style: popupMotionStyle,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $ceTz3.default)([
            $1bc9437c28b7512c$var$styles.root,
            $1bc9437c28b7512c$var$surfaceResetStyles.root,
            shouldAnimate && phase === 'entering' && $1bc9437c28b7512c$var$styles.enter,
            shouldAnimate && phase === 'exiting' && $1bc9437c28b7512c$var$styles.exit,
            shouldAnimate && $1bc9437c28b7512c$var$styles.motion,
            (0, $867fa27ab54523a6$export$a274e22fb40f762e)(shouldAnimate && phase === 'entering' && enteringAnimationXcss, shouldAnimate && phase === 'exiting' && exitingAnimationXcss)
        ])
    }, children);
});







// transition: none is set on first-of-type to prevent a bug in Firefox
// that causes a broken transition
var $7a83a9b7153d2add$var$groupStyles = {
    root: "_v5641b8g _1bsb1kdj _kqswstnw _u7coidpf _1eqkauwl",
    first: "_v564glyw _t9ec1ygq _1pbyqfx8",
    second: "_1pbyegat",
    nth: "_5sag5cps _t9ec1hw2",
    hidden: "_3um015vq"
};
// transition: none is set on first-of-type to prevent a bug in Firefox
// that causes a broken transition
var $7a83a9b7153d2add$var$groupStylesNew = {
    root: "_v564t8bh _kqswstnw _u7coidpf _1bsb1kdj _1eqkauwl",
    first: "_t9ec1ygq _1pbyqfx8",
    second: "_t9ec1pi4 _1pbyegat",
    nth: "_t9ec15wd",
    hidden: "_3um015vq"
};
// Transform needed to push up while 1st flag is leaving
// Exiting time should match the exiting time of motion so is halved
var $7a83a9b7153d2add$var$dismissAllowedStyles = null;
var $7a83a9b7153d2add$var$flagGroupContainerStyles = null;
// When rendering in top layer, z-index is redundant (top layer stacks above everything).
// Override to avoid leaving an explicit z-index on the container.
var $7a83a9b7153d2add$var$flagGroupContainerStylesTopLayer = null;
// cc_mohiti_flag_anchoring: update left inset from space.1000 (80px) to space.600 (48px)
// to match the bottom inset and produce a symmetric 48px × 48px anchor.
// The 80px left offset was a legacy artefact from the old left-rail nav sidebar.
// The mobile reset is mirrored from the base style so the override is self-contained
// and doesn't depend on @compiled's atomic CSS emit order at the ≤560px breakpoint.
var $7a83a9b7153d2add$var$flagGroupContainerStylesSymmetric = null;
var $7a83a9b7153d2add$export$a2c3479950310d7d = function FlagGroup(props) {
    var id = props.id, _props$label = props.label, label = _props$label === void 0 ? 'Flag notifications' : _props$label, _props$labelTag = props.labelTag, LabelTag = _props$labelTag === void 0 ? 'h2' : _props$labelTag, _props$shouldRenderTo = props.shouldRenderToParent, shouldRenderToParent = _props$shouldRenderTo === void 0 ? false : _props$shouldRenderTo, children = props.children, _props$onDismissed = props.onDismissed, onDismissed = _props$onDismissed === void 0 ? (0, $adcefb868cf2fc9d$export$2e2bcd8739ae039) : _props$onDismissed;
    var hasFlags = Array.isArray(children) ? children.length > 0 : Boolean(children);
    var dismissFlagContext = (0, $5FkrB.useMemo)(function() {
        return {
            onDismissed: onDismissed,
            isDismissAllowed: true
        };
    }, [
        onDismissed
    ]);
    // Keep a stable reference to the latest children, dismiss handler, and
    // analytics creator so the keydown listener never reads stale closures.
    var _useAnalyticsEvents = (0, $879f28ba40c47674$export$5bf35293e545f20c)(), createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
    var latestRef = (0, $5FkrB.useRef)({
        children: children,
        onDismissed: onDismissed,
        createAnalyticsEvent: createAnalyticsEvent
    });
    latestRef.current = {
        children: children,
        onDismissed: onDismissed,
        createAnalyticsEvent: createAnalyticsEvent
    };
    // Accessibility (JRACLOUD-97876): allow keyboard-only and assistive
    // technology users to dismiss the topmost (and only dismissable) flag with
    // the Escape key, without having to tab through the entire page to reach
    // the dismiss button. Behaviour is gated behind a feature flag so it can
    // be rolled out and validated incrementally.
    (0, $5FkrB.useEffect)(function() {
        if (!(0, $50U6m.fg)('platform_dst_flag_keyboard_dismiss')) return;
        if (!hasFlags) return;
        var doc = (0, $fc5ac9c99de29fbb$export$f65ca476c09acec0)();
        if (!doc) return;
        var timeoutIds = new Set();
        var unbind = (0, $5b617c1f48263075$exports.bind)(doc, {
            type: 'keydown',
            listener: function listener(event) {
                var _props;
                if (event.key !== 'Escape' || event.defaultPrevented) return;
                var currentChildren = latestRef.current.children;
                var firstFlag = Array.isArray(currentChildren) ? currentChildren.find(Boolean) : currentChildren;
                if (!firstFlag || (0, $beffc482493a0ece$export$2e2bcd8739ae039)(firstFlag) !== 'object') return;
                var id = (_props = firstFlag.props) === null || _props === void 0 ? void 0 : _props.id;
                if (id === undefined || id === null || id === '') return;
                var analyticsEvent = latestRef.current.createAnalyticsEvent({
                    action: 'dismissed',
                    actionSubject: 'flag',
                    attributes: {
                        dismissedVia: 'keyboardShortcut',
                        key: 'Escape'
                    }
                });
                var timeoutId = setTimeout(function() {
                    var _latestRef$current$on, _latestRef$current;
                    timeoutIds.delete(timeoutId);
                    if (event.defaultPrevented) return;
                    event.preventDefault();
                    (_latestRef$current$on = (_latestRef$current = latestRef.current).onDismissed) === null || _latestRef$current$on === void 0 || _latestRef$current$on.call(_latestRef$current, id, analyticsEvent);
                });
                timeoutIds.add(timeoutId);
            },
            options: {
                capture: true
            }
        });
        return function() {
            unbind();
            timeoutIds.forEach(clearTimeout);
            timeoutIds.clear();
        };
    }, [
        hasFlags
    ]);
    var renderChildren = function renderChildren() {
        return children && (0, $beffc482493a0ece$export$2e2bcd8739ae039)(children) === 'object' ? (0, $5FkrB.Children).map(children, function(flag, index) {
            var isDismissAllowed = index === 0;
            return (0, $50U6m.fg)('platform-dst-motion-uplift') ? /*#__PURE__*/ $5FkrB.createElement((0, $7a49b1df02a75aca$export$e71c4d32a2263218), {
                xcss: (0, $d01a5d8bb96c5a7e$export$a274e22fb40f762e)($7a83a9b7153d2add$var$groupStylesNew.root, index === 0 && $7a83a9b7153d2add$var$groupStylesNew.first, index === 1 && $7a83a9b7153d2add$var$groupStylesNew.second, index >= 2 && $7a83a9b7153d2add$var$groupStylesNew.nth, index >= 3 && $7a83a9b7153d2add$var$groupStylesNew.hidden),
                "data-vc-oob": true
            }, /*#__PURE__*/ $5FkrB.createElement((0, $d48c6d5755d883e0$export$2e2bcd8739ae039), {
                enteringAnimation: "var(--ds-flag-enter, 250ms cubic-bezier(0, 0.4, 0, 1) SlideIn50PercentLeft, 250ms cubic-bezier(0, 0.4, 0, 1) FadeIn0to100)",
                exitingAnimation: "var(--ds-flag-exit, 200ms cubic-bezier(0.6, 0, 0.8, 0.6) SlideOut15PercentLeft, 200ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)"
            }, /*#__PURE__*/ $5FkrB.createElement((0, $fb00836d049bbf24$export$c57ba665aaa722be).Provider, {
                value: // Only the first flag should be able to be dismissed.
                isDismissAllowed ? dismissFlagContext : (0, $752ba29d1ba270d8$export$643760c4938da30d)
            }, flag))) : /*#__PURE__*/ $5FkrB.createElement((0, $d840a7361899618f$export$2e2bcd8739ae039), {
                enterFrom: "left",
                fade: "inout",
                duration: "medium",
                animationTimingFunction: "ease-in"
            }, function(_ref) {
                var className = _ref.className, ref = _ref.ref;
                return /*#__PURE__*/ $5FkrB.createElement("div", {
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                    className: (0, $ceTz3.default)([
                        $7a83a9b7153d2add$var$groupStyles.root,
                        index === 0 && $7a83a9b7153d2add$var$groupStyles.first,
                        index === 1 && $7a83a9b7153d2add$var$groupStyles.second,
                        index >= 1 && $7a83a9b7153d2add$var$groupStyles.nth,
                        index >= 2 && $7a83a9b7153d2add$var$groupStyles.hidden,
                        isDismissAllowed && "_12a7luct",
                        className
                    ]),
                    ref: ref,
                    "data-vc-oob": true
                }, /*#__PURE__*/ $5FkrB.createElement((0, $fb00836d049bbf24$export$c57ba665aaa722be).Provider, {
                    value: // Only the first flag should be able to be dismissed.
                    isDismissAllowed ? dismissFlagContext : (0, $752ba29d1ba270d8$export$643760c4938da30d)
                }, flag));
            });
        }) : false;
    };
    var useTopLayer = (0, $50U6m.fg)('platform-dst-top-layer');
    var useSymmetricAnchor = (0, $50U6m.fg)('cc_mohiti_flag_anchoring');
    var isKeyboardDismissEnabled = (0, $50U6m.fg)('platform_dst_flag_keyboard_dismiss');
    // When the keyboard dismiss shortcut is available, surface it to assistive
    // technology users via the existing visually-hidden landmark heading so they
    // know they can press Escape to dismiss the topmost flag.
    var screenReaderLabel = isKeyboardDismissEnabled ? "".concat(label, ". Press Escape to dismiss.") : label;
    var flags = /*#__PURE__*/ $5FkrB.createElement("div", {
        id: id,
        "data-vc-oob": true,
        className: (0, $ceTz3.default)([
            "_kqsw1n9t _1pbyxejw _u7cooahv _1e021epz _1iafidpf _il0widpf",
            useTopLayer && "_1pby1wug",
            useSymmetricAnchor && "_1e02oahv _il0widpf"
        ])
    }, hasFlags ? /*#__PURE__*/ $5FkrB.createElement((0, $a4a1a9cdc7bf2d54$export$2e2bcd8739ae039), null, /*#__PURE__*/ $5FkrB.createElement(LabelTag, null, screenReaderLabel)) : null, /*#__PURE__*/ $5FkrB.createElement((0, $7dce5bdaf433551a$export$2e2bcd8739ae039), {
        appear: false
    }, renderChildren()));
    if (useTopLayer) return /*#__PURE__*/ $5FkrB.createElement((0, $1bc9437c28b7512c$export$5b6b19405a83ff9d), {
        mode: "manual",
        isOpen: true
    }, flags);
    return shouldRenderToParent ? flags : /*#__PURE__*/ $5FkrB.createElement((0, $b972fda2d5cd73a8$export$2e2bcd8739ae039), {
        zIndex: (0, $46bf0aae0dfb1de2$export$7be255094ccdc533).flag()
    }, flags);
};
var /* eslint-disable-next-line @repo/internal/deprecations/deprecation-ticket-required -- VOLTC-139 tracks removal of these deprecated re-export shims. */ /**
 * @deprecated Use `import { FlagGroup } from '@atlaskit/flag/flag-group'` instead.
 */ // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports -- VOLTC-139 tracks removal of this deprecated default export shim.
$7a83a9b7153d2add$export$2e2bcd8739ae039 = $7a83a9b7153d2add$export$a2c3479950310d7d;






var $gDiFE = parcelRequire("gDiFE");



var $90MfH = parcelRequire("90MfH");

var $6hgMx = parcelRequire("6hgMx");

var $fLAke = parcelRequire("fLAke");

var $bcapr = parcelRequire("bcapr");



var $i3UfC = parcelRequire("i3UfC");

var $bgNpv = parcelRequire("bgNpv");




var $gDiFE = parcelRequire("gDiFE");


var $bcapr = parcelRequire("bcapr");

const $b5e8459a8ab6f0fb$var$cardStyle = (0, $gDiFE.xcss)({
    borderRadius: 'radius.xxlarge',
    borderWidth: 'border.width',
    borderStyle: 'solid',
    borderColor: 'color.border',
    padding: 'space.200'
});
const $b5e8459a8ab6f0fb$var$iconWrapStyle = (0, $gDiFE.xcss)({
    flexShrink: 0
});
const $b5e8459a8ab6f0fb$var$chevronWrapStyle = (0, $gDiFE.xcss)({
    flexShrink: 0,
    marginLeft: 'auto'
});
const $b5e8459a8ab6f0fb$var$dropdownContentStyle = (0, $gDiFE.xcss)({
    paddingTop: 'space.200',
    paddingInline: 'space.0'
});
const $b5e8459a8ab6f0fb$var$checkboxCellStyle = (0, $gDiFE.xcss)({
    paddingBlock: 'space.025'
});
const $b5e8459a8ab6f0fb$var$toolsetsListIndentStyle = (0, $gDiFE.xcss)({
    paddingLeft: 'space.400'
});
const $b5e8459a8ab6f0fb$var$McpIntentPermissionCard = ({ group: group, selectedToolsetNames: selectedToolsetNames, onToggleToolset: onToggleToolset, onToggleSummaryCard: onToggleSummaryCard })=>{
    const { id: id, label: label, description: description, toolsets: toolsets } = group;
    const selectedInCard = toolsets.filter((t)=>selectedToolsetNames.has(t.name)).length;
    const intentFullySelected = toolsets.length > 0 && selectedInCard === toolsets.length;
    const intentPartiallySelected = selectedInCard > 0 && selectedInCard < toolsets.length;
    const summaryId = `mcp-summary-${id}`;
    const showIrreversibleBadge = (0, $bcapr.showsIrreversibleResultsBadge)(id);
    const stopSummaryNavigate = (e)=>{
        const t = e.target;
        if (t.closest('input[type="checkbox"]')) e.stopPropagation();
    };
    return /*#__PURE__*/ (0, $i3UfC.jsx)((0, $383dd904a5a5e5b0$export$e71c4d32a2263218), {
        xcss: $b5e8459a8ab6f0fb$var$cardStyle,
        role: "group",
        "aria-labelledby": `${summaryId}-title`,
        children: /*#__PURE__*/ (0, $i3UfC.jsxs)("details", {
            children: [
                /*#__PURE__*/ (0, $i3UfC.jsx)("summary", {
                    style: {
                        listStyle: 'none',
                        cursor: 'pointer'
                    },
                    onClick: stopSummaryNavigate,
                    children: /*#__PURE__*/ (0, $i3UfC.jsxs)((0, $1b254ba6a068f2f1$export$f51f4c4ede09e011), {
                        gap: "space.200",
                        alignItems: "start",
                        xcss: {
                            width: '100%'
                        },
                        children: [
                            /*#__PURE__*/ (0, $i3UfC.jsx)((0, $383dd904a5a5e5b0$export$e71c4d32a2263218), {
                                xcss: $b5e8459a8ab6f0fb$var$iconWrapStyle,
                                onClick: (e)=>e.stopPropagation(),
                                children: /*#__PURE__*/ (0, $i3UfC.jsx)((0, $fa7b9da54b6e47b4$export$48513f6b9f8ce62d), {
                                    isChecked: intentFullySelected,
                                    isIndeterminate: intentPartiallySelected,
                                    onChange: (e)=>onToggleSummaryCard(e.target.checked),
                                    label: "",
                                    name: "",
                                    "aria-label": `Select all ${label} toolsets`
                                })
                            }),
                            /*#__PURE__*/ (0, $i3UfC.jsxs)((0, $c8dbef6c41cfa689$export$694e0d28c7ffc90c), {
                                space: "space.100",
                                children: [
                                    /*#__PURE__*/ (0, $i3UfC.jsxs)((0, $10b0af967ce59e29$export$fbae5b5ffd8af05e), {
                                        space: "space.100",
                                        alignBlock: "center",
                                        shouldWrap: true,
                                        children: [
                                            /*#__PURE__*/ (0, $i3UfC.jsx)((0, $d48daa9a522ca942$export$5f1af8db9871e1d6), {
                                                weight: "bold",
                                                children: label
                                            }),
                                            showIrreversibleBadge && /*#__PURE__*/ (0, $i3UfC.jsx)((0, $2ebefb163f4e3420$export$2e2bcd8739ae039), {
                                                appearance: "neutral",
                                                children: /*#__PURE__*/ (0, $i3UfC.jsx)((0, $bgNpv.default), {
                                                    ...(0, $96caccbd80113386$export$1c9a60c992b4f3e4).irreversibleResults
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $i3UfC.jsx)((0, $d48daa9a522ca942$export$5f1af8db9871e1d6), {
                                        as: "p",
                                        size: "medium",
                                        children: description
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $i3UfC.jsx)((0, $383dd904a5a5e5b0$export$e71c4d32a2263218), {
                                xcss: $b5e8459a8ab6f0fb$var$chevronWrapStyle,
                                "aria-hidden": true,
                                children: /*#__PURE__*/ (0, $i3UfC.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($c63a1832a2581897$exports))), {
                                    label: "",
                                    size: "medium",
                                    color: (0, $37190500189da037$export$9e1725a4cfeada27)('color.text.subtle')
                                })
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $i3UfC.jsx)((0, $383dd904a5a5e5b0$export$e71c4d32a2263218), {
                    xcss: $b5e8459a8ab6f0fb$var$dropdownContentStyle,
                    children: /*#__PURE__*/ (0, $i3UfC.jsx)((0, $383dd904a5a5e5b0$export$e71c4d32a2263218), {
                        xcss: $b5e8459a8ab6f0fb$var$toolsetsListIndentStyle,
                        children: /*#__PURE__*/ (0, $i3UfC.jsx)((0, $c8dbef6c41cfa689$export$694e0d28c7ffc90c), {
                            space: "space.200",
                            children: toolsets.map((toolset)=>/*#__PURE__*/ (0, $i3UfC.jsxs)((0, $1b254ba6a068f2f1$export$f51f4c4ede09e011), {
                                    gap: "space.200",
                                    alignItems: "start",
                                    children: [
                                        /*#__PURE__*/ (0, $i3UfC.jsx)((0, $383dd904a5a5e5b0$export$e71c4d32a2263218), {
                                            xcss: $b5e8459a8ab6f0fb$var$checkboxCellStyle,
                                            onClick: (e)=>e.stopPropagation(),
                                            children: /*#__PURE__*/ (0, $i3UfC.jsx)((0, $fa7b9da54b6e47b4$export$48513f6b9f8ce62d), {
                                                isChecked: selectedToolsetNames.has(toolset.name),
                                                onChange: (e)=>onToggleToolset(toolset.name, e.target.checked),
                                                label: "",
                                                "aria-label": `${toolset.name}: ${toolset.description}`
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $i3UfC.jsxs)((0, $c8dbef6c41cfa689$export$694e0d28c7ffc90c), {
                                            alignInline: "start",
                                            space: "space.050",
                                            children: [
                                                /*#__PURE__*/ (0, $i3UfC.jsxs)((0, $10b0af967ce59e29$export$fbae5b5ffd8af05e), {
                                                    space: "space.100",
                                                    alignBlock: "center",
                                                    shouldWrap: true,
                                                    children: [
                                                        /*#__PURE__*/ (0, $i3UfC.jsx)((0, $d48daa9a522ca942$export$5f1af8db9871e1d6), {
                                                            as: "span",
                                                            weight: "medium",
                                                            children: toolset.name
                                                        }),
                                                        toolset.container === 'organization' && /*#__PURE__*/ (0, $i3UfC.jsx)((0, $2ebefb163f4e3420$export$2e2bcd8739ae039), {
                                                            appearance: "neutral",
                                                            children: /*#__PURE__*/ (0, $i3UfC.jsx)((0, $bgNpv.default), {
                                                                ...(0, $96caccbd80113386$export$1c9a60c992b4f3e4).worksAcrossOrganization
                                                            })
                                                        }),
                                                        toolset.container === 'unit' && /*#__PURE__*/ (0, $i3UfC.jsx)((0, $2ebefb163f4e3420$export$2e2bcd8739ae039), {
                                                            appearance: "neutral",
                                                            children: /*#__PURE__*/ (0, $i3UfC.jsx)((0, $bgNpv.default), {
                                                                ...(0, $96caccbd80113386$export$1c9a60c992b4f3e4).worksAcrossUnit
                                                            })
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $i3UfC.jsx)((0, $d48daa9a522ca942$export$5f1af8db9871e1d6), {
                                                    as: "span",
                                                    size: "small",
                                                    color: "color.text.subtle",
                                                    children: toolset.description
                                                })
                                            ]
                                        })
                                    ]
                                }, toolset.name))
                        })
                    })
                })
            ]
        })
    });
};
var $b5e8459a8ab6f0fb$export$2e2bcd8739ae039 = $b5e8459a8ab6f0fb$var$McpIntentPermissionCard;



var $5FkrB = parcelRequire("5FkrB");

var $bcapr = parcelRequire("bcapr");
function $4a471d44cc710ce9$export$780b431917cc864d({ selectedWorkspace: selectedWorkspace, mcpByIntent: mcpByIntent, selectedToolsetNames: selectedToolsetNames }) {
    const [everSelectedIrreversible, setEverSelectedIrreversible] = (0, $5FkrB.useState)(()=>new Set());
    (0, $5FkrB.useEffect)(()=>{
        setEverSelectedIrreversible(new Set());
    }, [
        selectedWorkspace
    ]);
    (0, $5FkrB.useEffect)(()=>{
        const irreversibleNames = mcpByIntent.filter((group)=>(0, $bcapr.isIrreversibleIntent)(group.id)).flatMap((group)=>group.toolsets.map((t)=>t.name));
        if (irreversibleNames.length === 0) return;
        setEverSelectedIrreversible((prev)=>{
            let changed = false;
            const next = new Set(prev);
            for (const name of irreversibleNames)if (selectedToolsetNames.has(name) && !next.has(name)) {
                next.add(name);
                changed = true;
            }
            return changed ? next : prev;
        });
    }, [
        mcpByIntent,
        selectedToolsetNames
    ]);
    const hasUnselectedReversible = mcpByIntent.filter((group)=>!(0, $bcapr.isIrreversibleIntent)(group.id)).flatMap((group)=>group.toolsets).some((t)=>!selectedToolsetNames.has(t.name));
    const hasDeselectedIrreversible = mcpByIntent.filter((group)=>(0, $bcapr.isIrreversibleIntent)(group.id)).flatMap((group)=>group.toolsets).some((t)=>everSelectedIrreversible.has(t.name) && !selectedToolsetNames.has(t.name));
    return hasUnselectedReversible || hasDeselectedIrreversible;
}


/**
 * External URLs used across the MCP consent flow.
 * All values are sourced from envConfig.mcpPolicy so they can vary per environment.
 */ 
var $9KGFe = parcelRequire("9KGFe");
const { mcpPolicy: $fe7551cdd4b30cf8$var$mcpPolicy } = (0, $9KGFe.getConfig)();
const $fe7551cdd4b30cf8$export$fe3d54a053c21360 = $fe7551cdd4b30cf8$var$mcpPolicy.rovoDocUrl;
const $fe7551cdd4b30cf8$export$9694d17d763a38f1 = $fe7551cdd4b30cf8$var$mcpPolicy.developerDocUrl;
const $fe7551cdd4b30cf8$export$ed3bb372e6984c60 = 'https://support.atlassian.com/trello/docs/connect-trello-to-ai-assistants-with-trello-mcp/';
const $fe7551cdd4b30cf8$export$420a9148c11203d8 = 'https://support.atlassian.com/trello';
const $fe7551cdd4b30cf8$export$614ed7dbae9ac4bd = $fe7551cdd4b30cf8$var$mcpPolicy.sseMigrationGuideUrl;
const $fe7551cdd4b30cf8$export$b8d77ad8e2bb623e = $fe7551cdd4b30cf8$var$mcpPolicy.permissionsManagementDocUrl;
const $fe7551cdd4b30cf8$export$99e8ac83a6b9bb90 = $fe7551cdd4b30cf8$var$mcpPolicy.deprecatedSseEndpoint; // Shared URLs (privacy policy, terms of use) live in ../shared/agent-consent/urls.ts.



var $Qy2AT = parcelRequire("Qy2AT");
/**
 * Shared cap for the site/workspace selectors and the permissions list, so they
 * share a right edge as the right panel grows and shrinks.
 */ const $0e4d630f20279bd3$export$5d17ef8641481a51 = '550px';


/* FieldLabel.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $i3UfC = parcelRequire("i3UfC");
parcelRequire("5FkrB");

const $f3887589c02620a1$var$_3 = "._k48p1wq8{font-weight:var(--ds-font-weight-medium,500)}";
const $f3887589c02620a1$var$_2 = "._syazazsu{color:var(--ds-text-subtle,#505258)}";
const $f3887589c02620a1$var$_ = "._11c8wadc{font:var(--ds-font-body-small,normal 400 9pt/1pc \"Atlassian Sans\",ui-sans-serif,-apple-system,BlinkMacSystemFont,\"Segoe UI\",Ubuntu,\"Helvetica Neue\",sans-serif)}";
const $f3887589c02620a1$var$styles = {
    label: "_11c8wadc _syazazsu _k48p1wq8"
};
/** Site and Bitbucket field labels: Body/S/Medium + color.text.subtle. */ const $f3887589c02620a1$var$FieldLabel = ({ children: children })=>/*#__PURE__*/ (0, $i3UfC.jsxs)((0, $dbdf44c207cf40e4$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $i3UfC.jsx)((0, $c179d2a16dc49323$export$2e2bcd8739ae039), {
                children: [
                    $f3887589c02620a1$var$_,
                    $f3887589c02620a1$var$_2,
                    $f3887589c02620a1$var$_3
                ]
            }),
            /*#__PURE__*/ (0, $i3UfC.jsx)("span", {
                className: (0, $b02ab0e3a0f362dd$export$2e2bcd8739ae039)([
                    $f3887589c02620a1$var$styles.label
                ]),
                children: children
            })
        ]
    });
var $f3887589c02620a1$export$2e2bcd8739ae039 = $f3887589c02620a1$var$FieldLabel;



var $i3UfC = parcelRequire("i3UfC");

var $bgNpv = parcelRequire("bgNpv");
var $hrVKU = parcelRequire("hrVKU");


var $gDiFE = parcelRequire("gDiFE");


const $e36e63178d9978a4$var$cardStyle = (0, $gDiFE.xcss)({
    borderRadius: 'radius.xxlarge',
    borderWidth: 'border.width',
    borderStyle: 'solid',
    borderColor: 'color.border',
    padding: 'space.200'
});
const $e36e63178d9978a4$var$iconStyle = (0, $gDiFE.xcss)({
    flexShrink: 0,
    paddingBlock: 'space.025'
});
/** Read-only summary shown when every Forge MCP toolset is selected. */ const $e36e63178d9978a4$var$ForgeMcpPermissionSummary = ({ appName: appName, intentLabels: intentLabels, includesIrreversible: includesIrreversible = false })=>{
    const { formatList: formatList } = (0, $hrVKU.default)();
    return /*#__PURE__*/ (0, $i3UfC.jsx)((0, $383dd904a5a5e5b0$export$e71c4d32a2263218), {
        xcss: $e36e63178d9978a4$var$cardStyle,
        children: /*#__PURE__*/ (0, $i3UfC.jsxs)((0, $10b0af967ce59e29$export$fbae5b5ffd8af05e), {
            space: "space.150",
            alignBlock: "start",
            children: [
                /*#__PURE__*/ (0, $i3UfC.jsx)((0, $383dd904a5a5e5b0$export$e71c4d32a2263218), {
                    xcss: $e36e63178d9978a4$var$iconStyle,
                    "aria-hidden": true,
                    children: /*#__PURE__*/ (0, $i3UfC.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($60d92d5137838590$exports))), {
                        label: "",
                        size: "medium",
                        color: (0, $37190500189da037$export$9e1725a4cfeada27)('color.text')
                    })
                }),
                /*#__PURE__*/ (0, $i3UfC.jsxs)((0, $383dd904a5a5e5b0$export$e71c4d32a2263218), {
                    children: [
                        /*#__PURE__*/ (0, $i3UfC.jsx)((0, $d48daa9a522ca942$export$5f1af8db9871e1d6), {
                            as: "p",
                            size: "medium",
                            children: /*#__PURE__*/ (0, $i3UfC.jsx)((0, $bgNpv.default), {
                                ...(0, $96caccbd80113386$export$1c9a60c992b4f3e4).forgeAppSummary,
                                values: {
                                    appName: /*#__PURE__*/ (0, $i3UfC.jsx)("strong", {
                                        children: appName
                                    }),
                                    intents: formatList(intentLabels, {
                                        type: 'conjunction'
                                    })
                                }
                            })
                        }),
                        includesIrreversible && /*#__PURE__*/ (0, $i3UfC.jsx)((0, $d48daa9a522ca942$export$5f1af8db9871e1d6), {
                            as: "p",
                            size: "small",
                            color: "color.text.subtle",
                            children: /*#__PURE__*/ (0, $i3UfC.jsx)((0, $bgNpv.default), {
                                ...(0, $96caccbd80113386$export$1c9a60c992b4f3e4).forgeAppIrreversibleNote
                            })
                        })
                    ]
                })
            ]
        })
    });
};
var $e36e63178d9978a4$export$2e2bcd8739ae039 = $e36e63178d9978a4$var$ForgeMcpPermissionSummary;


// Same cap as the site/workspace selectors: `width: 100%` shrinks with the
// panel; `maxWidth` stops the list outgrowing the fields so they stay aligned.
const $8869c57af01afeb7$var$stackStyle = (0, $gDiFE.xcss)({
    width: '100%',
    maxWidth: (0, $0e4d630f20279bd3$export$5d17ef8641481a51)
});
const $8869c57af01afeb7$var$flagContainerStyle = (0, $gDiFE.xcss)({
    position: 'fixed',
    bottom: 'space.400',
    left: 'space.400',
    // @ts-expect-error static z-index
    zIndex: 100,
    width: '400px',
    maxWidth: '90vw',
    backgroundColor: 'color.background.warning',
    borderRadius: 'radius.small',
    boxShadow: 'elevation.shadow.overlay'
});
const $8869c57af01afeb7$var$McpPermissions = ()=>{
    const { selectedWorkspace: selectedWorkspace } = (0, $6hgMx.useSelectedWorkspace)();
    const forgeAppName = (0, $fLAke.getForgeMcpAppName)((0, $6hgMx.useInfo)());
    const { mcpPolicyStatus: mcpPolicyStatus, mcpPolicyErrorKind: mcpPolicyErrorKind, policies: policies, mcpByIntent: mcpByIntent, mcpSelectedToolsetNames: mcpSelectedToolsetNames, toggleMcpToolset: toggleToolset, selectedTrelloWorkspaces: selectedTrelloWorkspaces, selectedBitbucketWorkspace: selectedBitbucketWorkspace, inboxPlannerScopesDisabled: inboxPlannerScopesDisabled, isTrelloMultiWorkspaceSelectorEnabled: isTrelloMultiWorkspaceSelectorEnabled, availableTrelloWorkspaces: availableTrelloWorkspaces, hasTrelloInboxPlannerScopes: hasTrelloInboxPlannerScopes, scopeClassification: scopeClassification, hasOrgMismatch: hasOrgMismatch } = (0, $90MfH.useMcpContext)();
    const { formatMessage: formatMessage } = (0, $hrVKU.default)();
    const { product: product, productUnit: productUnit } = (0, $5110a34c125a0b6b$export$67c6d5d2a1a9a362)();
    const forgeIntentGroups = mcpByIntent.filter((group)=>group.toolsets.length > 0);
    const forgeIntentLabels = forgeIntentGroups.map((group)=>group.label.trim() || group.id.trim()).filter(Boolean);
    const forgeIncludesIrreversible = forgeIntentGroups.some((group)=>(0, $bcapr.isIrreversibleIntent)(group.id));
    const [flagDismissed, setFlagDismissed] = (0, $5FkrB.useState)(false);
    const selectedSet = mcpSelectedToolsetNames ?? new Set();
    const hasUnselectedToolsets = (0, $4a471d44cc710ce9$export$780b431917cc864d)({
        selectedWorkspace: selectedWorkspace,
        mcpByIntent: mcpByIntent,
        selectedToolsetNames: selectedSet
    });
    const hasUnselected = !forgeAppName && hasUnselectedToolsets;
    (0, $5FkrB.useEffect)(()=>{
        setFlagDismissed(false);
    }, [
        selectedWorkspace
    ]);
    // Inbox and Planner are account level, so a member with no workspaces at all
    // can still grant them — permissions stay visible without a selection.
    const isInboxPlannerOnly = scopeClassification.hasTrello && availableTrelloWorkspaces.length === 0 && hasTrelloInboxPlannerScopes;
    // Don't show permissions until the user has selected a workspace, either an
    // Atlassian site, a Trello workspace, or a Bitbucket workspace.
    if (!selectedWorkspace && selectedTrelloWorkspaces.length === 0 && !selectedBitbucketWorkspace && !isInboxPlannerOnly) return null;
    // The site and Bitbucket selections are in different organizations, so
    // nothing here can be granted as it stands. Listing permissions the user
    // cannot accept — and letting them tick boxes — would read as progress, so
    // the list stays away until one of the two selections changes. Both
    // selectors say why, and Accept is blocked (see mcpAcceptDisabled).
    //
    // Ahead of every branch below, including the spinner and the empty states:
    // the toolsets have usually loaded for both sources, so this is not an
    // absence of data but a refusal to offer it.
    if (hasOrgMismatch) return null;
    // A failed check is shown full-panel by McpPolicyAlerts, which keys off the
    // same field — so this hides whenever that shows, and the two can never
    // compete. Checked before the spinner: a check still in flight elsewhere must
    // not replace an error that has already happened.
    if (mcpPolicyErrorKind) return null;
    // Keep permissions from sources that already resolved visible while another
    // independent source is still loading, rather than replacing them with a
    // skeleton.
    if (mcpByIntent.length === 0 && (mcpPolicyStatus === (0, $Qy2AT.MCP_POLICY_STATUS).loading || mcpPolicyStatus === (0, $Qy2AT.MCP_POLICY_STATUS).idle)) return /*#__PURE__*/ (0, $i3UfC.jsxs)((0, $c8dbef6c41cfa689$export$694e0d28c7ffc90c), {
        xcss: $8869c57af01afeb7$var$stackStyle,
        space: "space.400",
        children: [
            /*#__PURE__*/ (0, $i3UfC.jsx)((0, $10b0af967ce59e29$export$fbae5b5ffd8af05e), {
                alignBlock: "center",
                children: /*#__PURE__*/ (0, $i3UfC.jsx)((0, $f3887589c02620a1$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $i3UfC.jsx)((0, $bgNpv.default), {
                        ...(0, $96caccbd80113386$export$1c9a60c992b4f3e4).sectionTitle
                    })
                })
            }),
            /*#__PURE__*/ (0, $i3UfC.jsx)((0, $6f7e5f007cf95a87$export$2e2bcd8739ae039), {
                size: "large",
                label: "Loading permissions"
            })
        ]
    });
    if (mcpByIntent.length === 0) {
        // The site and Bitbucket selectors report an empty result inline, so the
        // panel-level empty state would just say it again.
        if (!(0, $Qy2AT.needsNoPermissionsEmptyState)(policies)) return null;
        // Unwrapped: EmptyState caps itself at 464px and centres with auto margins,
        // so a 550px box around it cannot clamp anything — it would only re-centre
        // the block in a narrower box.
        return /*#__PURE__*/ (0, $i3UfC.jsx)((0, $9a28bb334efe6ee5$export$2e2bcd8739ae039), {
            header: formatMessage(isTrelloMultiWorkspaceSelectorEnabled ? (0, $96caccbd80113386$export$1c9a60c992b4f3e4).emptyStateHeadingMultiple : (0, $96caccbd80113386$export$1c9a60c992b4f3e4).emptyStateHeading, {
                productUnit: productUnit
            }),
            description: /*#__PURE__*/ (0, $i3UfC.jsx)((0, $bgNpv.default), {
                ...(0, $96caccbd80113386$export$1c9a60c992b4f3e4).emptyStateDescription,
                values: {
                    howPermissionsLink: (text)=>/*#__PURE__*/ (0, $i3UfC.jsx)((0, $64e95b69a05329e9$export$2e2bcd8739ae039), {
                            href: (0, $fe7551cdd4b30cf8$export$b8d77ad8e2bb623e),
                            target: "_blank",
                            rel: "noreferrer",
                            children: text
                        })
                }
            }),
            imageUrl: (0, (/*@__PURE__*/$parcel$interopDefault($2cb29121ea75d357$exports)))
        });
    }
    return /*#__PURE__*/ (0, $i3UfC.jsxs)((0, $c8dbef6c41cfa689$export$694e0d28c7ffc90c), {
        xcss: $8869c57af01afeb7$var$stackStyle,
        space: "space.100",
        children: [
            isInboxPlannerOnly && /*#__PURE__*/ (0, $i3UfC.jsx)((0, $ac2404b057b8688e$export$2e2bcd8739ae039), {
                appearance: "information",
                children: /*#__PURE__*/ (0, $i3UfC.jsx)((0, $d48daa9a522ca942$export$5f1af8db9871e1d6), {
                    as: "p",
                    children: /*#__PURE__*/ (0, $i3UfC.jsx)((0, $bgNpv.default), {
                        ...(0, $96caccbd80113386$export$c25eff7563f353c5).noWorkspacesInboxPlannerMessage
                    })
                })
            }),
            /*#__PURE__*/ (0, $i3UfC.jsx)((0, $10b0af967ce59e29$export$fbae5b5ffd8af05e), {
                alignBlock: "center",
                space: "space.200",
                shouldWrap: true,
                children: /*#__PURE__*/ (0, $i3UfC.jsx)((0, $f3887589c02620a1$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $i3UfC.jsx)((0, $bgNpv.default), {
                        ...(0, $96caccbd80113386$export$1c9a60c992b4f3e4).sectionTitle
                    })
                })
            }),
            hasUnselected && !flagDismissed && /*#__PURE__*/ (0, $i3UfC.jsx)((0, $383dd904a5a5e5b0$export$e71c4d32a2263218), {
                xcss: $8869c57af01afeb7$var$flagContainerStyle,
                children: /*#__PURE__*/ (0, $i3UfC.jsx)((0, $7a83a9b7153d2add$export$2e2bcd8739ae039), {
                    onDismissed: ()=>setFlagDismissed(true),
                    children: /*#__PURE__*/ (0, $i3UfC.jsx)((0, $dded6e092963b70b$export$2e2bcd8739ae039), {
                        id: "mcp-permission-warning",
                        icon: /*#__PURE__*/ (0, $i3UfC.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($37990044355ecd18$exports))), {
                            label: "",
                            color: (0, $37190500189da037$export$9e1725a4cfeada27)('color.icon.information')
                        }),
                        title: formatMessage((0, $96caccbd80113386$export$c25eff7563f353c5).editWarningTitle, {
                            product: product
                        }),
                        description: formatMessage((0, $96caccbd80113386$export$c25eff7563f353c5).editWarningBody, {
                            product: product
                        }),
                        actions: [
                            {
                                content: formatMessage((0, $96caccbd80113386$export$c25eff7563f353c5).editWarningDismiss),
                                href: 'javascript:void(0)',
                                onClick: (e)=>{
                                    e.preventDefault();
                                    setFlagDismissed(true);
                                }
                            }
                        ]
                    })
                })
            }),
            forgeAppName ? /*#__PURE__*/ (0, $i3UfC.jsx)((0, $e36e63178d9978a4$export$2e2bcd8739ae039), {
                appName: forgeAppName,
                intentLabels: forgeIntentLabels,
                includesIrreversible: forgeIncludesIrreversible
            }) : /*#__PURE__*/ (0, $i3UfC.jsx)((0, $c8dbef6c41cfa689$export$694e0d28c7ffc90c), {
                space: "space.200",
                children: mcpByIntent.map((group)=>/*#__PURE__*/ (0, $i3UfC.jsx)((0, $b5e8459a8ab6f0fb$export$2e2bcd8739ae039), {
                        group: group,
                        selectedToolsetNames: selectedSet,
                        onToggleToolset: (name, checked)=>toggleToolset(name, checked),
                        onToggleSummaryCard: (checked)=>group.toolsets.forEach((t)=>toggleToolset(t.name, checked))
                    }, group.id))
            }),
            inboxPlannerScopesDisabled && /*#__PURE__*/ (0, $i3UfC.jsx)((0, $ac2404b057b8688e$export$2e2bcd8739ae039), {
                appearance: "information",
                children: /*#__PURE__*/ (0, $i3UfC.jsx)((0, $d48daa9a522ca942$export$5f1af8db9871e1d6), {
                    as: "p",
                    children: /*#__PURE__*/ (0, $i3UfC.jsx)((0, $bgNpv.default), {
                        ...isTrelloMultiWorkspaceSelectorEnabled ? (0, $96caccbd80113386$export$c25eff7563f353c5).inboxPlannerDisabledMultipleMessage : (0, $96caccbd80113386$export$c25eff7563f353c5).inboxPlannerDisabledMessage
                    })
                })
            })
        ]
    });
};
var $8869c57af01afeb7$export$2e2bcd8739ae039 = $8869c57af01afeb7$var$McpPermissions;



var $i3UfC = parcelRequire("i3UfC");

var $5FkrB = parcelRequire("5FkrB");

var $bgNpv = parcelRequire("bgNpv");
var $hrVKU = parcelRequire("hrVKU");


var $2gmBL = parcelRequire("2gmBL");

var $i3UfC = parcelRequire("i3UfC");
var $94f6aa88698e8a20$exports = {};
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b3cfa183fa168ea8c7cf286e27765b6f>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty($94f6aa88698e8a20$exports, "__esModule", {
    value: true
});
$94f6aa88698e8a20$exports.default = void 0;

var $94f6aa88698e8a20$var$_react = $94f6aa88698e8a20$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $94f6aa88698e8a20$var$_iconNew = $94f6aa88698e8a20$var$_interopRequireDefault((parcelRequire("gDzom")));
function $94f6aa88698e8a20$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "StatusError".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/status-error
 * Usage guidance:
 * Reserved for error statuses and messaging.
 * Filled status icons provide higher visual contrast to draw attention to important information.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $94f6aa88698e8a20$var$StatusErrorIcon = (props)=>/*#__PURE__*/ $94f6aa88698e8a20$var$_react.default.createElement($94f6aa88698e8a20$var$_iconNew.default, Object.assign({
        name: "StatusErrorIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6.586.603a2 2 0 0 1 2.828 0l5.983 5.983a2 2 0 0 1 0 2.828l-5.983 5.982a2 2 0 0 1-2.828 0L.604 9.414a2 2 0 0 1 0-2.828zM8 10.25a1 1 0 1 0 0 2 1 1 0 0 0 0-2m-.75-6.5V9h1.5V3.75z" clip-rule="evenodd"/>`
    }, props));
$94f6aa88698e8a20$var$StatusErrorIcon.displayName = 'StatusErrorIcon';
var $94f6aa88698e8a20$var$_default = $94f6aa88698e8a20$exports.default = $94f6aa88698e8a20$var$StatusErrorIcon;


var $53b3ca20ba4a049e$exports = {};
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::341f1a6f1df1c6bee81376e850857e59>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty($53b3ca20ba4a049e$exports, "__esModule", {
    value: true
});
$53b3ca20ba4a049e$exports.default = void 0;

var $53b3ca20ba4a049e$var$_react = $53b3ca20ba4a049e$var$_interopRequireDefault((parcelRequire("5FkrB")));

var $53b3ca20ba4a049e$var$_iconNew = $53b3ca20ba4a049e$var$_interopRequireDefault((parcelRequire("gDzom")));
function $53b3ca20ba4a049e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "StatusInformation".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/status-information
 * Usage guidance:
 * Reserved for information statuses and messaging.
 * Filled status icons provide higher visual contrast to draw attention to important information.
 * For information tooltips, use the unfilled 'information circle' icon.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $53b3ca20ba4a049e$var$StatusInformationIcon = (props)=>/*#__PURE__*/ $53b3ca20ba4a049e$var$_react.default.createElement($53b3ca20ba4a049e$var$_iconNew.default, Object.assign({
        name: "StatusInformationIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0M6.5 6.75v1.5h.75v4.25h1.5v-5A.75.75 0 0 0 8 6.75zM8 3.5a1 1 0 1 0 0 2 1 1 0 0 0 0-2" clip-rule="evenodd"/>`
    }, props));
$53b3ca20ba4a049e$var$StatusInformationIcon.displayName = 'StatusInformationIcon';
var $53b3ca20ba4a049e$var$_default = $53b3ca20ba4a049e$exports.default = $53b3ca20ba4a049e$var$StatusInformationIcon;




var $gDiFE = parcelRequire("gDiFE");


const $027f75c2eb03d739$var$wrapperStyles = (0, $gDiFE.xcss)({
    width: '100%',
    alignSelf: 'stretch'
});
const $027f75c2eb03d739$var$stackStyles = (0, $gDiFE.xcss)({
    width: '100%'
});
const $027f75c2eb03d739$var$selectStyles = (0, $gDiFE.xcss)({
    width: '100%',
    maxWidth: (0, $0e4d630f20279bd3$export$5d17ef8641481a51)
});
const $027f75c2eb03d739$var$messageStyles = (0, $gDiFE.xcss)({
    maxWidth: (0, $0e4d630f20279bd3$export$5d17ef8641481a51)
});
/** Stable string key for a stored value, used for option identity / matching. */ const $027f75c2eb03d739$var$keyOf = (value)=>String(value);
/** Coerce react-select's onChange payload into a plain array. */ const $027f75c2eb03d739$var$toArray = (value)=>Array.isArray(value) ? value : value ? [
        value
    ] : [];
const $027f75c2eb03d739$export$60e23481c8d90d73 = ({ data: data, controlType: controlType, isSelected: isSelected, isDisabled: isDisabled })=>/*#__PURE__*/ (0, $i3UfC.jsxs)((0, $10b0af967ce59e29$export$fbae5b5ffd8af05e), {
        space: "space.100",
        alignBlock: "center",
        children: [
            /*#__PURE__*/ (0, $i3UfC.jsx)("input", {
                type: controlType,
                checked: isSelected,
                disabled: isDisabled,
                readOnly: true,
                tabIndex: -1,
                "aria-hidden": true
            }),
            data.icon,
            /*#__PURE__*/ (0, $i3UfC.jsxs)((0, $c8dbef6c41cfa689$export$694e0d28c7ffc90c), {
                children: [
                    /*#__PURE__*/ (0, $i3UfC.jsx)((0, $d48daa9a522ca942$export$5f1af8db9871e1d6), {
                        weight: "medium",
                        color: isDisabled ? 'color.text.disabled' : undefined,
                        children: data.label
                    }),
                    data.description && /*#__PURE__*/ (0, $i3UfC.jsx)((0, $d48daa9a522ca942$export$5f1af8db9871e1d6), {
                        size: "small",
                        color: isDisabled ? 'color.text.disabled' : 'color.text.subtlest',
                        children: data.description
                    })
                ]
            })
        ]
    });
/** Stable react-select adapter; presentation mode rides on each option. */ const $027f75c2eb03d739$var$SelectOption = (props)=>/*#__PURE__*/ (0, $i3UfC.jsx)((0, $525be6c0d6b9e93b$export$9b5ac10f59f76296).Option, {
        ...props,
        children: /*#__PURE__*/ (0, $i3UfC.jsx)($027f75c2eb03d739$export$60e23481c8d90d73, {
            data: props.data,
            controlType: props.data.controlType,
            isSelected: props.isSelected,
            isDisabled: props.isDisabled
        })
    });
/**
 * Chip text for the current selection. Prefers the option's `chipLabel` so a
 * chip can read differently from its (multi-line) option row.
 */ const $027f75c2eb03d739$var$ChipLabel = (props)=>{
    const data = props.data;
    return /*#__PURE__*/ (0, $i3UfC.jsx)((0, $525be6c0d6b9e93b$export$9b5ac10f59f76296).MultiValueLabel, {
        ...props,
        children: data.chipLabel ?? data.label
    });
};
/**
 * Chip styling for the current selection. Reads the per-option `chipColor`, so
 * options without one keep react-select's default chip. Module scope keeps a
 * stable identity without memoization.
 *
 * Only the multiValue rules are needed: react-select always runs in multi mode
 * here (see below), so both modes render the selection as a removable chip.
 */ const $027f75c2eb03d739$var$chipStyles = {
    multiValue: (base, state)=>{
        const color = state.data.chipColor;
        return color ? {
            ...base,
            backgroundColor: color.background,
            borderColor: color.border,
            borderStyle: 'solid',
            borderWidth: (0, $37190500189da037$export$9e1725a4cfeada27)('border.width', '1px')
        } : base;
    },
    multiValueLabel: (base, state)=>state.data.chipColor ? {
            ...base,
            color: state.data.chipColor.foreground
        } : base,
    multiValueRemove: (base, state)=>state.data.chipColor ? {
            ...base,
            color: state.data.chipColor.foreground
        } : base
};
/**
 * Presentational single/multi select for a list of items, rendering each
 * selection as a removable chip.
 *
 * Selection is always represented as an array (0–1 entries in single-select), so
 * callers store it uniformly and can hand it straight to a wire format that
 * takes repeated params. The component is intentionally decoupled from consent
 * context — pass data in via props and persist it in `onChange`.
 */ function $027f75c2eb03d739$var$MultiSelect({ items: items, value: value, toValue: toValue, onChange: onChange, getLabel: getLabel, getDescription: getDescription, getIcon: getIcon, getChipColor: getChipColor, getChipLabel: getChipLabel, isMulti: isMulti = false, maxSelected: maxSelected, isItemDisabled: isItemDisabled, inputId: inputId, placeholder: placeholder, renderLabel: renderLabel, isSearchable: isSearchable = true, isClearable: isClearable = true, isDisabled: isDisabled = false, message: message, messageTone: messageTone = 'error' }) {
    const options = items.map((item)=>{
        const storedValue = toValue(item);
        return {
            value: $027f75c2eb03d739$var$keyOf(storedValue),
            label: getLabel(item),
            description: getDescription?.(item),
            icon: getIcon?.(item),
            chipColor: getChipColor?.(item),
            chipLabel: getChipLabel?.(item),
            controlType: isMulti ? 'checkbox' : 'radio',
            item: item,
            storedValue: storedValue
        };
    });
    const optionByKey = new Map(options.map((option)=>[
            option.value,
            option
        ]));
    // A cap only means anything in multi-select, so fold the two conditions into
    // one value rather than re-testing both wherever the cap is read.
    const cap = isMulti ? maxSelected : undefined;
    // Preserve the caller's selection order; drop values no longer available.
    const selectedOptions = value.map((storedValue)=>optionByKey.get($027f75c2eb03d739$var$keyOf(storedValue))).filter((option)=>option != null);
    const handleChange = (newValue, actionMeta)=>{
        // Selected options stay visible in the menu, so in single-select clicking
        // the current pick would otherwise clear the field. Radios don't untoggle,
        // so ignore it — the chip's remove button and the clear icon still do.
        if (!isMulti && actionMeta.action === 'deselect-option') return;
        const all = $027f75c2eb03d739$var$toArray(newValue);
        // react-select is always in multi mode (see below) and appends each pick,
        // so in single-select the last entry is the newest and replaces the rest.
        const chosen = isMulti ? all : all.slice(-1);
        onChange(chosen.map((option)=>option.storedValue), chosen.map((option)=>option.item));
    };
    return /*#__PURE__*/ (0, $i3UfC.jsx)((0, $383dd904a5a5e5b0$export$e71c4d32a2263218), {
        xcss: $027f75c2eb03d739$var$wrapperStyles,
        children: /*#__PURE__*/ (0, $i3UfC.jsxs)((0, $c8dbef6c41cfa689$export$694e0d28c7ffc90c), {
            space: "space.100",
            xcss: $027f75c2eb03d739$var$stackStyles,
            children: [
                /*#__PURE__*/ (0, $i3UfC.jsxs)((0, $c8dbef6c41cfa689$export$694e0d28c7ffc90c), {
                    space: "space.050",
                    children: [
                        renderLabel && /*#__PURE__*/ (0, $i3UfC.jsx)((0, $383dd904a5a5e5b0$export$e71c4d32a2263218), {
                            as: "label",
                            htmlFor: inputId,
                            children: renderLabel({
                                count: selectedOptions.length,
                                total: items.length
                            })
                        }),
                        /*#__PURE__*/ (0, $i3UfC.jsx)((0, $383dd904a5a5e5b0$export$e71c4d32a2263218), {
                            xcss: $027f75c2eb03d739$var$selectStyles,
                            children: /*#__PURE__*/ (0, $i3UfC.jsx)((0, $5330bbf7705e7e35$export$2e2bcd8739ae039), {
                                inputId: inputId,
                                options: options,
                                // Always multi, even for a single-select field: it is what makes
                                // react-select render the selection as a removable chip rather
                                // than bare text. Single selection is capped in handleChange.
                                isMulti: true,
                                isDisabled: isDisabled,
                                isSearchable: isSearchable,
                                isClearable: isClearable,
                                closeMenuOnSelect: !isMulti,
                                // Selected options stay listed in both modes, so the leading
                                // checkbox / radio reads as ticked for the current selection.
                                hideSelectedOptions: false,
                                placeholder: placeholder,
                                value: selectedOptions,
                                isOptionDisabled: isItemDisabled || cap != null ? (option, selectValue)=>Boolean(isItemDisabled?.(option.item)) || // Already-selected options stay enabled at the cap so
                                    // they can still be removed.
                                    cap != null && selectValue.length >= cap && !selectValue.some((selected)=>selected.value === option.value) : undefined,
                                components: {
                                    Option: $027f75c2eb03d739$var$SelectOption,
                                    MultiValueLabel: $027f75c2eb03d739$var$ChipLabel
                                },
                                styles: $027f75c2eb03d739$var$chipStyles,
                                onChange: handleChange
                            })
                        })
                    ]
                }),
                message != null && /*#__PURE__*/ (0, $i3UfC.jsxs)((0, $10b0af967ce59e29$export$fbae5b5ffd8af05e), {
                    space: "space.050",
                    alignBlock: "center",
                    xcss: $027f75c2eb03d739$var$messageStyles,
                    children: [
                        messageTone === 'error' ? /*#__PURE__*/ (0, $i3UfC.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($94f6aa88698e8a20$exports))), {
                            label: "",
                            color: (0, $37190500189da037$export$9e1725a4cfeada27)('color.icon.danger'),
                            spacing: "none",
                            testId: "oauth-consent-field-message-error"
                        }) : /*#__PURE__*/ (0, $i3UfC.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($53b3ca20ba4a049e$exports))), {
                            label: "",
                            color: (0, $37190500189da037$export$9e1725a4cfeada27)('color.icon.information'),
                            spacing: "none",
                            testId: "oauth-consent-field-message-information"
                        }),
                        /*#__PURE__*/ (0, $i3UfC.jsx)((0, $d48daa9a522ca942$export$5f1af8db9871e1d6), {
                            size: "small",
                            color: "color.text.subtlest",
                            children: message
                        })
                    ]
                })
            ]
        })
    });
}
var $027f75c2eb03d739$export$2e2bcd8739ae039 = $027f75c2eb03d739$var$MultiSelect;




var $i3UfC = parcelRequire("i3UfC");


const $90b9a92b59f5b5cf$export$ffa7b4d4363f4c0a = (item)=>/*#__PURE__*/ (0, $i3UfC.jsx)((0, $ebae6d75f4c9721e$export$2e2bcd8739ae039), {
        avatarUrl: item.avatar
    });
const $90b9a92b59f5b5cf$export$c8a4d4180c7a2590 = (item)=>(0, $75748f21d6184a53$export$5f8ff7cb3b9550d1)(item.avatar) ?? (0, $75748f21d6184a53$export$bfe779d9e415bcd1)(item.name);



var $6hgMx = parcelRequire("6hgMx");

var $leM9a = parcelRequire("leM9a");
function $04436d29111cda28$export$25012ca2e8ecc43(info) {
    const sitesByUrl = new Map();
    // Tolerates a missing URL: these come straight off the /consent/info payload,
    // so the declared types are only as good as the response.
    const addSite = (rawUrl, avatar, rawName)=>{
        const url = rawUrl?.trim();
        if (url && !sitesByUrl.has(url)) {
            const name = rawName?.trim();
            sitesByUrl.set(url, {
                url: url,
                ...avatar ? {
                    avatar: avatar
                } : {},
                ...name ? {
                    name: name
                } : {}
            });
        }
    };
    for (const site of info.availableSites ?? [])addSite(site.url, site.avatar, site.name);
    if (sitesByUrl.size > 0) return [
        ...sitesByUrl.values()
    ];
    for (const workspace of info.availableWorkspaces ?? [])addSite(workspace);
    return [
        ...sitesByUrl.values()
    ];
}
function $04436d29111cda28$export$ce98f9e7ba6ce2e4(url) {
    const firstLabel = url.split('.')[0]?.trim();
    if (!firstLabel) return url;
    return firstLabel.charAt(0).toUpperCase() + firstLabel.slice(1);
}



var $Qy2AT = parcelRequire("Qy2AT");

var $gUxXX = parcelRequire("gUxXX");

var $90MfH = parcelRequire("90MfH");

var $6bnW7 = parcelRequire("6bnW7");
const $eb09d1fddeef8ef7$export$57089a3f5c067561 = (0, $6bnW7.defineMessages)({
    siteLabel: {
        id: 'oauth.mcp.siteSelector.label.sites',
        defaultMessage: 'Site (For Jira, Confluence and other tools)',
        description: 'Label above the site-picker dropdown'
    },
    sitePlaceholder: {
        id: 'oauth.mcp.siteSelector.placeholder.plural',
        defaultMessage: 'Select',
        description: 'Placeholder text inside the multi-select site picker'
    },
    noSites: {
        id: 'oauth.mcp.siteSelector.noSites',
        defaultMessage: "Your account isn't associated with a supported site. Rovo MCP connects with Atlassian sites that use apps like Jira or Confluence. {learnMoreLink}",
        description: 'Message below the disabled site picker when the user has no supported sites; {learnMoreLink} links to Rovo MCP documentation'
    },
    noPermissions: {
        id: 'oauth.mcp.siteSelector.noPermissions',
        defaultMessage: 'Permissions are blocked for this site, contact your admin or {learnMoreLink}',
        description: 'Message below the site picker when the permission check succeeded but returned no permissions; {learnMoreLink} links to the admin guide for managing MCP permissions'
    },
    noPermissionsLearnMore: {
        id: 'oauth.mcp.siteSelector.noPermissions.learnMore',
        defaultMessage: 'see how permissions are managed',
        description: 'Link text, inside a sentence, pointing at the admin guide for managing MCP permissions'
    },
    orgConstraint: {
        id: 'oauth.mcp.siteSelector.orgConstraint',
        defaultMessage: 'Only sites from the same organization as the workspace can be selected',
        description: 'Helper below the site picker when a Bitbucket workspace is already selected, so other-org sites are listed but disabled'
    },
    noOrgSites: {
        id: 'oauth.mcp.siteSelector.noOrgSites',
        defaultMessage: 'No sites from the same organization as the selected workspace are available',
        description: 'Helper below the site picker when a Bitbucket workspace is selected and every listed site is in a different organization'
    },
    noWorkspacesLearnMore: {
        id: 'oauth.mcp.siteSelector.noWorkspaces.learnMore',
        defaultMessage: 'Understand Rovo MCP Server',
        description: 'Link text for the Rovo MCP documentation shown when no workspaces are available'
    }
});



var $6bnW7 = parcelRequire("6bnW7");
const $5f59f2c0674ea5a4$export$8d388ee5c6b6a09b = (0, $6bnW7.defineMessages)({
    orgMismatch: {
        id: 'oauth.mcp.orgMismatch',
        defaultMessage: 'Select a site and workspace from the same organization to continue.',
        description: 'Message below the site and Bitbucket workspace pickers when the two selections belong to different Atlassian organizations, which cannot be granted in one consent'
    }
});



const $3ee90eb41e4e6192$var$MCP_SITE_SELECT_INPUT_ID = 'oauth-consent-mcp-site-select';
/**
 * A documentation link to drop into a message's `{learnMoreLink}` slot. Composed
 * rather than handed to an ADS inline message so the link stays clickable — see
 * the `message` prop on MultiSelect.
 */ const $3ee90eb41e4e6192$var$docLink = (href, label)=>/*#__PURE__*/ (0, $i3UfC.jsx)((0, $64e95b69a05329e9$export$2e2bcd8739ae039), {
        href: href,
        target: "_blank",
        rel: "noopener noreferrer",
        children: /*#__PURE__*/ (0, $i3UfC.jsx)((0, $bgNpv.default), {
            ...label
        })
    });
// Pure functions of the item, so they live at module scope rather than being
// rebuilt in the component body.
const $3ee90eb41e4e6192$var$toValue = (site)=>site.url;
const $3ee90eb41e4e6192$var$getLabel = (site)=>site.name;
// The URL is only worth a second line when it differs from the derived name.
const $3ee90eb41e4e6192$var$getDescription = (site)=>site.name === site.url ? null : site.url;
// The chip is a single line, so it carries both parts: "Pug | pug.jira-dev.com".
const $3ee90eb41e4e6192$var$getChipLabel = (site)=>site.name === site.url ? site.url : `${site.name} | ${site.url}`;
/**
 * Atlassian site picker for the MCP consent screen.
 *
 * Single-select: one site is granted per consent, submitted as the
 * `selectedWorkspace` param on Accept (see McpFlowParameters) and policy-checked
 * against `/consent/workspace`. Shares the `MultiSelect` component with the
 * Bitbucket workspace selector, so the two fields read as one — avatar tile,
 * name over URL, and the same removable chip for the selection.
 *
 * A successful check that grants nothing is reported in this field's own
 * message slot, reading only `policies.site` so a Bitbucket result never
 * surfaces here. A failed request is shown full-panel by McpPolicyAlerts.
 */ const $3ee90eb41e4e6192$var$SiteSelector = ()=>{
    const { formatMessage: formatMessage } = (0, $hrVKU.default)();
    const info = (0, $6hgMx.useInfo)();
    const { selectedWorkspace: selectedWorkspace, setSelectedWorkspace: setSelectedWorkspace } = (0, $6hgMx.useSelectedWorkspace)();
    const { policies: policies, hasOrgMismatch: hasOrgMismatch, bitbucketOrgId: bitbucketOrgId, siteOrgIndex: siteOrgIndex } = (0, $90MfH.useMcpContext)();
    const shouldSortWorkspaces = (0, $2gmBL.useFeatureGate)((0, $leM9a.OAuthConsentFeatureGate).MCP_SORT_WORKSPACES);
    const isSiteBypassEnabled = (0, $2gmBL.useFeatureGate)((0, $leM9a.OAuthConsentFeatureGate).SITE_SELECTOR_BYPASS);
    const sites = (0, $5FkrB.useMemo)(()=>{
        const namedSites = (0, $04436d29111cda28$export$25012ca2e8ecc43)(info).map((site)=>({
                ...site,
                // The backend resolves a name only where the URL cannot be read as one
                // (a loom workspace URL is a cloud id), so deriving is the fallback, not
                // the rule — showing "Stage" for stage.loom.com/workspace/cloud/<id>
                // names the wrong thing.
                name: site.name ?? (0, $04436d29111cda28$export$ce98f9e7ba6ce2e4)(site.url)
            }));
        return shouldSortWorkspaces ? namedSites.sort((a, b)=>a.url.localeCompare(b.url)) : namedSites;
    }, [
        info.availableSites,
        info.availableWorkspaces,
        shouldSortWorkspaces
    ]);
    const hasSites = sites.length > 0;
    const availableSiteUrls = (0, $5FkrB.useMemo)(()=>new Set(sites.map((site)=>site.url)), [
        sites
    ]);
    const prefilledSiteUrlRef = (0, $5FkrB.useRef)(null);
    const onlySiteUrl = sites.length === 1 ? sites[0].url : null;
    (0, $5FkrB.useEffect)(()=>{
        if (selectedWorkspace) {
            // A selection the response no longer offers cannot be granted, so it is
            // dropped rather than left to fail its policy check.
            //
            // SiteBypassBanner is the exception, and the reason this reads the bypass
            // gate. It renders directly above this field (see MCP.tsx) and writes a
            // hand-typed host straight into `selectedWorkspace` — a host that is
            // absent from the offered list by definition, since the banner exists for
            // the case where /consent/info returned no sites at all. Sweeping it away
            // leaves an internal user with a "Use this site" button that visibly does
            // nothing, so while the escape hatch is switched on the offered list is
            // not treated as authoritative. That gate is internal-only, so every
            // production consent still gets the sweep — and the banner is in any case
            // the only writer here that can produce an off-list selection, as the
            // field itself only ever stores a site it offered.
            if (!availableSiteUrls.has(selectedWorkspace) && !isSiteBypassEnabled) setSelectedWorkspace?.(null);
            else if (selectedWorkspace === onlySiteUrl) prefilledSiteUrlRef.current = onlySiteUrl;
            return;
        }
        // Prefill a sole option once, but respect the user clearing its chip.
        if (onlySiteUrl && prefilledSiteUrlRef.current !== onlySiteUrl) {
            prefilledSiteUrlRef.current = onlySiteUrl;
            setSelectedWorkspace?.(onlySiteUrl);
        }
    }, [
        availableSiteUrls,
        isSiteBypassEnabled,
        onlySiteUrl,
        selectedWorkspace,
        setSelectedWorkspace
    ]);
    // A selected Bitbucket workspace's org disables other-org sites, so they stay
    // listed but cannot be picked. The message branches below take priority over
    // the helper, so they gate it.
    const { isItemDisabled: isItemDisabled, helpKind: helpKind } = (0, $gUxXX.getOrgOptionState)({
        items: sites,
        otherOrgId: bitbucketOrgId,
        getOrgId: (site)=>(0, $gUxXX.resolveSiteOrgId)(siteOrgIndex, site.url),
        canShowHelp: !selectedWorkspace && hasSites && !hasOrgMismatch && !(0, $Qy2AT.grantedNoPermissions)(policies.site)
    });
    const message = !hasSites ? /*#__PURE__*/ (0, $i3UfC.jsx)((0, $bgNpv.default), {
        ...(0, $eb09d1fddeef8ef7$export$57089a3f5c067561).noSites,
        values: {
            learnMoreLink: $3ee90eb41e4e6192$var$docLink((0, $fe7551cdd4b30cf8$export$fe3d54a053c21360), (0, $eb09d1fddeef8ef7$export$57089a3f5c067561).noWorkspacesLearnMore)
        }
    }) : hasOrgMismatch ? // Ahead of the policy result: the two selections cannot be granted together
    // whatever the check returned, and changing one of them is the only way
    // forward — so that is what the field should say.
    /*#__PURE__*/ (0, $i3UfC.jsx)((0, $bgNpv.default), {
        ...(0, $5f59f2c0674ea5a4$export$8d388ee5c6b6a09b).orgMismatch
    }) : (0, $Qy2AT.grantedNoPermissions)(policies.site) ? // The check succeeded but granted nothing, which in practice means an admin
    // policy blocked it — so point at the guide for managing those policies
    // rather than suggesting another site.
    /*#__PURE__*/ (0, $i3UfC.jsx)((0, $bgNpv.default), {
        ...(0, $eb09d1fddeef8ef7$export$57089a3f5c067561).noPermissions,
        values: {
            learnMoreLink: $3ee90eb41e4e6192$var$docLink((0, $fe7551cdd4b30cf8$export$b8d77ad8e2bb623e), (0, $eb09d1fddeef8ef7$export$57089a3f5c067561).noPermissionsLearnMore)
        }
    }) : helpKind === 'empty' ? /*#__PURE__*/ (0, $i3UfC.jsx)((0, $bgNpv.default), {
        ...(0, $eb09d1fddeef8ef7$export$57089a3f5c067561).noOrgSites
    }) : helpKind === 'constraint' ? /*#__PURE__*/ (0, $i3UfC.jsx)((0, $bgNpv.default), {
        ...(0, $eb09d1fddeef8ef7$export$57089a3f5c067561).orgConstraint
    }) : undefined;
    return /*#__PURE__*/ (0, $i3UfC.jsx)((0, $027f75c2eb03d739$export$2e2bcd8739ae039), {
        inputId: $3ee90eb41e4e6192$var$MCP_SITE_SELECT_INPUT_ID,
        items: sites,
        value: selectedWorkspace ? [
            selectedWorkspace
        ] : [],
        toValue: $3ee90eb41e4e6192$var$toValue,
        getLabel: $3ee90eb41e4e6192$var$getLabel,
        getDescription: $3ee90eb41e4e6192$var$getDescription,
        getIcon: (0, $90b9a92b59f5b5cf$export$ffa7b4d4363f4c0a),
        getChipColor: (0, $90b9a92b59f5b5cf$export$c8a4d4180c7a2590),
        getChipLabel: $3ee90eb41e4e6192$var$getChipLabel,
        isItemDisabled: isItemDisabled,
        isDisabled: !hasSites,
        message: message,
        messageTone: helpKind === 'none' ? 'error' : 'information',
        placeholder: formatMessage((0, $eb09d1fddeef8ef7$export$57089a3f5c067561).sitePlaceholder),
        renderLabel: ()=>/*#__PURE__*/ (0, $i3UfC.jsx)((0, $f3887589c02620a1$export$2e2bcd8739ae039), {
                children: formatMessage((0, $eb09d1fddeef8ef7$export$57089a3f5c067561).siteLabel)
            }),
        onChange: (urls)=>setSelectedWorkspace?.(urls[0] ?? null)
    });
};
var $3ee90eb41e4e6192$export$2e2bcd8739ae039 = $3ee90eb41e4e6192$var$SiteSelector;



var $i3UfC = parcelRequire("i3UfC");

var $hrVKU = parcelRequire("hrVKU");

var $90MfH = parcelRequire("90MfH");

var $6bnW7 = parcelRequire("6bnW7");
const $d53629a8ae73d7f3$export$6dc616a2c07ae02b = (0, $6bnW7.defineMessages)({
    label: {
        id: 'oauth.mcp.bitbucketWorkspaceSelector.label',
        defaultMessage: 'Bitbucket workspace',
        description: 'Label above the Bitbucket workspace picker'
    },
    placeholder: {
        id: 'oauth.mcp.bitbucketWorkspaceSelector.placeholder.workspace',
        defaultMessage: 'Select',
        description: 'Placeholder text inside the Bitbucket workspace picker'
    },
    noPermissions: {
        id: 'oauth.mcp.bitbucketWorkspaceSelector.noPermissions',
        defaultMessage: 'No permissions are available for the selected workspace. Select a different workspace to continue.',
        description: 'Message below the Bitbucket workspace picker when the permission check succeeded but returned no permissions'
    },
    orgConstraint: {
        id: 'oauth.mcp.bitbucketWorkspaceSelector.orgConstraint',
        defaultMessage: 'Only workspaces from the same organization as the site can be selected',
        description: 'Helper below the Bitbucket workspace picker when a site is already selected, so other-org workspaces are listed but disabled'
    },
    noOrgWorkspaces: {
        id: 'oauth.mcp.bitbucketWorkspaceSelector.noOrgWorkspaces',
        defaultMessage: 'No workspaces from the same organization as the selected site are available',
        description: 'Helper below the Bitbucket workspace picker when a site is selected and every listed workspace is in a different organization'
    }
});







var $Qy2AT = parcelRequire("Qy2AT");

var $gUxXX = parcelRequire("gUxXX");
const $ae9ae1d3b2dd36dc$var$BITBUCKET_SELECT_INPUT_ID = 'oauth-consent-mcp-bitbucket-workspace-select';
// Pure functions of the item, so they live at module scope rather than being
// rebuilt in the component body.
const $ae9ae1d3b2dd36dc$var$toValue = (ws)=>ws.ari;
const $ae9ae1d3b2dd36dc$var$getLabel = (ws)=>ws.name;
/**
 * Bitbucket workspace picker for the MCP consent screen.
 *
 * Rendered below the Atlassian site selector whenever /consent/info returned at
 * least one workspace. An empty list hides the field entirely rather than
 * showing one with nothing to pick. There is no
 * `oauth-consent_bitbucket-mcp-workspace` check in this flow — see
 * useBitbucketWorkspaces. The selected workspace's ARI is submitted as
 * an additional `selectedWorkspace` param on Accept (see McpFlowParameters).
 *
 * Hidden as well whenever the Bitbucket check does not speak for the flow, i.e.
 * 'bitbucket' is absent from `getOrderedPolicySources` — which today means a
 * Trello-only token. That list is what the screen aggregates permissions over
 * and what `hasFailedPolicyCheck` / `getPrimaryPolicyErrorSource` are scoped
 * to, so a field rendered outside it would be a target the user can select and
 * submit while every permission it grants is filtered out of the screen, and a
 * failed check for it could reach neither the full-panel alert nor this field's
 * own message slot. The visibility rule is read off that same list rather than
 * off the scopes so the two cannot drift: participation otherwise depends only
 * on /consent/info's workspace list, which knows nothing about scopes.
 *
 * A successful check that grants nothing is reported in this field's own message
 * slot, reading only `policies.bitbucket` so a site result never surfaces here.
 * A *failed* request is shown full-panel by McpPolicyAlerts instead, and the
 * field stays mounted throughout so the selection can be changed and retried.
 */ const $ae9ae1d3b2dd36dc$var$BitbucketWorkspaceSelector = ()=>{
    const { isBitbucketWorkspaceAccessEnabled: isBitbucketWorkspaceAccessEnabled, availableBitbucketWorkspaces: availableBitbucketWorkspaces, selectedBitbucketWorkspace: selectedBitbucketWorkspace, setSelectedBitbucketWorkspace: setSelectedBitbucketWorkspace, policies: policies, hasOrgMismatch: hasOrgMismatch, siteOrgId: siteOrgId, scopeClassification: scopeClassification } = (0, $90MfH.useMcpContext)();
    const { formatMessage: formatMessage } = (0, $hrVKU.default)();
    // A selected site's org disables other-org workspaces, so they stay listed
    // but cannot be picked. The messages below take priority over the helper,
    // so they gate it.
    const { isItemDisabled: isItemDisabled, helpKind: helpKind } = (0, $gUxXX.getOrgOptionState)({
        items: availableBitbucketWorkspaces,
        otherOrgId: siteOrgId,
        getOrgId: (ws)=>ws.orgId ?? null,
        canShowHelp: !selectedBitbucketWorkspace && !hasOrgMismatch && !(0, $Qy2AT.grantedNoPermissions)(policies.bitbucket)
    });
    const message = hasOrgMismatch ? formatMessage((0, $5f59f2c0674ea5a4$export$8d388ee5c6b6a09b).orgMismatch) : (0, $Qy2AT.grantedNoPermissions)(policies.bitbucket) ? formatMessage((0, $d53629a8ae73d7f3$export$6dc616a2c07ae02b).noPermissions) : helpKind === 'empty' ? formatMessage((0, $d53629a8ae73d7f3$export$6dc616a2c07ae02b).noOrgWorkspaces) : helpKind === 'constraint' ? formatMessage((0, $d53629a8ae73d7f3$export$6dc616a2c07ae02b).orgConstraint) : undefined;
    // Hidden unless there is at least one workspace to grant, and unless the
    // Bitbucket check speaks for this flow at all — see the docblock above.
    if (!isBitbucketWorkspaceAccessEnabled || !(0, $Qy2AT.getOrderedPolicySources)(scopeClassification).includes('bitbucket')) return null;
    return /*#__PURE__*/ (0, $i3UfC.jsx)((0, $027f75c2eb03d739$export$2e2bcd8739ae039), {
        inputId: $ae9ae1d3b2dd36dc$var$BITBUCKET_SELECT_INPUT_ID,
        items: availableBitbucketWorkspaces,
        value: selectedBitbucketWorkspace ? [
            selectedBitbucketWorkspace.ari
        ] : [],
        toValue: $ae9ae1d3b2dd36dc$var$toValue,
        getLabel: $ae9ae1d3b2dd36dc$var$getLabel,
        getIcon: (0, $90b9a92b59f5b5cf$export$ffa7b4d4363f4c0a),
        getChipColor: (0, $90b9a92b59f5b5cf$export$c8a4d4180c7a2590),
        isItemDisabled: isItemDisabled,
        message: message,
        messageTone: helpKind === 'none' ? 'error' : 'information',
        placeholder: formatMessage((0, $d53629a8ae73d7f3$export$6dc616a2c07ae02b).placeholder),
        renderLabel: ()=>/*#__PURE__*/ (0, $i3UfC.jsx)((0, $f3887589c02620a1$export$2e2bcd8739ae039), {
                children: formatMessage((0, $d53629a8ae73d7f3$export$6dc616a2c07ae02b).label)
            }),
        onChange: (_aris, items)=>setSelectedBitbucketWorkspace(items[0] ?? null)
    });
};
var $ae9ae1d3b2dd36dc$export$2e2bcd8739ae039 = $ae9ae1d3b2dd36dc$var$BitbucketWorkspaceSelector;



var $i3UfC = parcelRequire("i3UfC");

var $bgNpv = parcelRequire("bgNpv");
var $hrVKU = parcelRequire("hrVKU");


var $gDiFE = parcelRequire("gDiFE");






var $90MfH = parcelRequire("90MfH");

var $i3UfC = parcelRequire("i3UfC");

var $5FkrB = parcelRequire("5FkrB");


var $hrVKU = parcelRequire("hrVKU");

var $gDiFE = parcelRequire("gDiFE");





var $3RbwF = parcelRequire("3RbwF");

var $3UXNA = parcelRequire("3UXNA");


var $6bnW7 = parcelRequire("6bnW7");
const $a9dd951dda0af606$export$c5ba076c6d622e98 = (0, $6bnW7.defineMessages)({
    siteLabel: {
        id: 'mcp.trelloWorkspaceSelector.siteLabel',
        defaultMessage: 'Authorize access for:',
        description: 'Label above the Trello workspace selector when it is the only selector visible'
    },
    placeholder: {
        id: 'mcp.trelloWorkspaceSelector.placeholder',
        defaultMessage: 'Select',
        description: 'Placeholder text for the Trello workspace selector'
    },
    multiSelectLabel: {
        id: 'mcp.trelloWorkspaceSelector.multiSelectLabel',
        defaultMessage: 'Trello workspaces',
        description: 'Field label shown above the Trello multi-workspace selector'
    },
    recentGroupLabel: {
        id: 'mcp.trelloWorkspaceSelector.recentGroupLabel',
        defaultMessage: 'Recently used',
        description: 'Group label for Trello workspaces the user has used recently'
    },
    allGroupLabel: {
        id: 'mcp.trelloWorkspaceSelector.allGroupLabel',
        defaultMessage: 'All',
        description: 'Group label for all Trello workspaces the user can authorize'
    },
    mixedDescription: {
        id: 'mcp.trelloWorkspaceSelector.mixedDescription',
        defaultMessage: 'A Trello workspace is also needed to allow access to your Trello boards and cards.',
        description: 'Help text shown below the Trello workspace selector when both Atlassian site and Trello workspace selectors are visible'
    },
    noWorkspacesHeading: {
        id: 'mcp.trelloWorkspaceSelector.noWorkspacesHeading',
        defaultMessage: 'No Trello workspaces found',
        description: 'Heading for empty state when user has no Trello workspaces'
    },
    noWorkspacesDescription: {
        id: 'mcp.trelloWorkspaceSelector.noWorkspacesDescription',
        defaultMessage: "You might be signed in with an account that doesn't have Trello access. Try {switchAccountLink} or {contactSupportLink}",
        description: 'Description for empty state when no Trello workspaces available, includes switch account and contact support links'
    },
    noWorkspacesSwitchAccount: {
        id: 'mcp.trelloWorkspaceSelector.noWorkspacesSwitchAccount',
        defaultMessage: 'signing in with a different account',
        description: 'Switch account link text in Trello no-workspaces empty state'
    },
    noWorkspacesContactSupport: {
        id: 'mcp.trelloWorkspaceSelector.noWorkspacesContactSupport',
        defaultMessage: 'contact support',
        description: 'Contact support link text in Trello no-workspaces empty state'
    },
    noWorkspaceAvailablePlaceholder: {
        id: 'mcp.trelloWorkspaceSelector.noWorkspaceAvailablePlaceholder',
        defaultMessage: 'No workspace available',
        description: 'Disabled selector placeholder when the user has no Trello workspaces but can still grant Inbox and Planner access'
    },
    selectionLimitHelpText: {
        id: 'mcp.trelloWorkspaceSelector.selectionLimitHelpText',
        defaultMessage: 'You can choose up to {limit, plural, one {# workspace} other {# workspaces}} {clientName} can access',
        description: 'Help text below the Trello multi-workspace selector telling the user how many workspaces the requesting client can be given access to'
    },
    selectionLimitHelpTextNoClient: {
        id: 'mcp.trelloWorkspaceSelector.selectionLimitHelpTextNoClient',
        defaultMessage: 'You can choose up to {limit, plural, one {# workspace} other {# workspaces}}',
        description: 'Help text below the Trello multi-workspace selector when the requesting client name is unknown'
    },
    enterpriseBadge: {
        id: 'mcp.trelloWorkspaceSelector.enterpriseBadge',
        defaultMessage: 'Enterprise',
        description: 'Badge shown next to a Trello workspace that belongs to an Atlassian organization, indicating it can only be combined with workspaces from the same organization'
    },
    enterpriseSelectionHelpText: {
        id: 'mcp.trelloWorkspaceSelector.enterpriseSelectionHelpText',
        defaultMessage: 'For higher Enterprise security, we only allow selecting workspaces all within or all outside of your Enterprise.',
        description: 'Help text shown below the Trello multi-workspace selector for Enterprise users, explaining that Enterprise and non-Enterprise workspaces cannot be combined in one selection. Takes the place of the selection limit help text.'
    },
    loadingMoreWorkspaces: {
        id: 'mcp.trelloWorkspaceSelector.loadingMoreWorkspaces',
        defaultMessage: 'Loading more workspaces\u2026',
        description: 'Shown at the bottom of the Trello workspace dropdown while the next page of workspaces is being fetched'
    },
    noWorkspacesCompact: {
        id: 'mcp.trelloWorkspaceSelector.noWorkspacesCompact',
        defaultMessage: "No Trello workspaces found. You might be signed in with an account that doesn't have Trello access. Try {switchAccountLink} or {contactSupportLink}",
        description: 'Compact message shown in the mixed flow when no Trello workspaces are available'
    }
});


const $f959ea12f2d209e9$export$46ea7dd560633724 = 'oauth-consent-mcp-trello-workspace-multi-select';
const $f959ea12f2d209e9$var$wrapperStyles = (0, $gDiFE.xcss)({
    width: '100%',
    alignSelf: 'stretch'
});
const $f959ea12f2d209e9$var$stackStyles = (0, $gDiFE.xcss)({
    width: '100%'
});
const $f959ea12f2d209e9$var$groupLabelStyles = (0, $gDiFE.xcss)({
    paddingBlock: 'space.050',
    paddingInline: 'space.025'
});
const $f959ea12f2d209e9$var$disabledOptionStyles = (0, $gDiFE.xcss)({
    cursor: 'not-allowed',
    opacity: 0.62
});
const $f959ea12f2d209e9$var$toOption = (workspace)=>({
        value: workspace.id,
        label: workspace.displayName,
        workspaceId: workspace.id,
        workspace: workspace,
        url: (0, $3RbwF.getTrelloWorkspaceUrl)(workspace),
        avatarUrl: workspace.logoUrl ?? undefined
    });
const $f959ea12f2d209e9$var$byWorkspaceName = (options)=>[
        ...options
    ].sort((a, b)=>(0, $3UXNA.compareTrelloWorkspacesByName)(a.workspace, b.workspace));
const $f959ea12f2d209e9$var$byEnterpriseThenWorkspaceName = (options)=>[
        ...options
    ].sort((a, b)=>(0, $3UXNA.compareTrelloWorkspacesByEnterpriseThenName)(a.workspace, b.workspace));
function $f959ea12f2d209e9$export$975a734f80d15164({ options: options, recentWorkspaceIds: recentWorkspaceIds, recentLabel: recentLabel, allLabel: allLabel }) {
    const allGroup = {
        label: allLabel,
        options: $f959ea12f2d209e9$var$byEnterpriseThenWorkspaceName(options)
    };
    if (recentWorkspaceIds.length === 0) return [
        allGroup
    ];
    const optionsById = new Map(options.map((option)=>[
            option.workspaceId,
            option
        ]));
    const recentIds = new Set(recentWorkspaceIds.filter((id)=>optionsById.has(id)));
    if (recentIds.size === 0) return [
        allGroup
    ];
    const recentOptions = $f959ea12f2d209e9$var$byWorkspaceName([
        ...recentIds
    ].map((id)=>optionsById.get(id)));
    const remainingOptions = $f959ea12f2d209e9$var$byEnterpriseThenWorkspaceName(options.filter((option)=>!recentIds.has(option.workspaceId)));
    if (remainingOptions.length === 0) return [
        {
            label: recentLabel,
            options: recentOptions
        }
    ];
    return [
        {
            label: recentLabel,
            options: recentOptions
        },
        {
            label: allLabel,
            options: remainingOptions
        }
    ];
}
const $f959ea12f2d209e9$var$chipColor = (option)=>{
    const { avatarUrl: avatarUrl, label: label } = option;
    return (0, $75748f21d6184a53$export$5f8ff7cb3b9550d1)(avatarUrl) ?? (0, $75748f21d6184a53$export$bfe779d9e415bcd1)(String(label ?? ''));
};
const $f959ea12f2d209e9$var$Option = (props)=>{
    const { formatMessage: formatMessage } = (0, $hrVKU.default)();
    const { label: label, url: url, avatarUrl: avatarUrl, workspace: workspace } = props.data;
    const isSelected = props.isWorkspaceSelected ?? props.isSelected;
    const isEnterprise = workspace.atlassianOrganizationId != null;
    return /*#__PURE__*/ (0, $i3UfC.jsx)((0, $525be6c0d6b9e93b$export$9b5ac10f59f76296).Option, {
        ...props,
        isSelected: isSelected,
        children: /*#__PURE__*/ (0, $i3UfC.jsxs)((0, $10b0af967ce59e29$export$fbae5b5ffd8af05e), {
            space: "space.100",
            alignBlock: "center",
            xcss: props.isDisabled ? $f959ea12f2d209e9$var$disabledOptionStyles : undefined,
            children: [
                /*#__PURE__*/ (0, $i3UfC.jsx)("input", {
                    type: "checkbox",
                    checked: isSelected,
                    disabled: props.isDisabled,
                    readOnly: true,
                    tabIndex: -1,
                    "aria-hidden": true
                }),
                /*#__PURE__*/ (0, $i3UfC.jsx)((0, $ebae6d75f4c9721e$export$2e2bcd8739ae039), {
                    avatarUrl: avatarUrl,
                    name: String(label ?? '')
                }),
                /*#__PURE__*/ (0, $i3UfC.jsxs)((0, $c8dbef6c41cfa689$export$694e0d28c7ffc90c), {
                    children: [
                        /*#__PURE__*/ (0, $i3UfC.jsxs)((0, $10b0af967ce59e29$export$fbae5b5ffd8af05e), {
                            space: "space.075",
                            alignBlock: "center",
                            children: [
                                /*#__PURE__*/ (0, $i3UfC.jsx)((0, $d48daa9a522ca942$export$5f1af8db9871e1d6), {
                                    weight: "medium",
                                    children: label
                                }),
                                isEnterprise && /*#__PURE__*/ (0, $i3UfC.jsx)((0, $2ebefb163f4e3420$export$2e2bcd8739ae039), {
                                    appearance: "neutral",
                                    children: formatMessage((0, $a9dd951dda0af606$export$c5ba076c6d622e98).enterpriseBadge)
                                })
                            ]
                        }),
                        url && /*#__PURE__*/ (0, $i3UfC.jsx)((0, $d48daa9a522ca942$export$5f1af8db9871e1d6), {
                            size: "small",
                            color: "color.text.subtlest",
                            children: url
                        })
                    ]
                })
            ]
        })
    });
};
const $f959ea12f2d209e9$var$MultiValueLabel = (props)=>{
    const { label: label, url: url } = props.data;
    return /*#__PURE__*/ (0, $i3UfC.jsx)((0, $525be6c0d6b9e93b$export$9b5ac10f59f76296).MultiValueLabel, {
        ...props,
        children: url ? `${String(label)} | ${url}` : String(label)
    });
};
const $f959ea12f2d209e9$var$multiValueStyles = {
    multiValue: (base, state)=>{
        const color = $f959ea12f2d209e9$var$chipColor(state.data);
        return {
            ...base,
            backgroundColor: color.background,
            borderColor: color.border,
            borderStyle: 'solid',
            borderWidth: (0, $37190500189da037$export$9e1725a4cfeada27)('border.width', '1px')
        };
    },
    multiValueLabel: (base, state)=>({
            ...base,
            color: $f959ea12f2d209e9$var$chipColor(state.data).foreground
        }),
    multiValueRemove: (base, state)=>({
            ...base,
            color: $f959ea12f2d209e9$var$chipColor(state.data).foreground
        })
};
const $f959ea12f2d209e9$var$formatGroupLabel = (group)=>/*#__PURE__*/ (0, $i3UfC.jsx)((0, $383dd904a5a5e5b0$export$e71c4d32a2263218), {
        xcss: $f959ea12f2d209e9$var$groupLabelStyles,
        children: /*#__PURE__*/ (0, $i3UfC.jsx)((0, $d48daa9a522ca942$export$5f1af8db9871e1d6), {
            size: "small",
            color: "color.text.subtlest",
            weight: "bold",
            children: group.label
        })
    });
/**
 * Multi-workspace selector for the Trello MCP consent screen.
 *
 * Renders grouped, checkbox-style options with workspace avatars and URLs, and
 * shows the current selection as removable chips. Mirrors the Rovo site
 * selector so both consent surfaces stay visually consistent.
 */ const $f959ea12f2d209e9$var$TrelloWorkspaceMultiSelect = ({ availableWorkspaces: availableWorkspaces, selectedWorkspaces: selectedWorkspaces, setSelectedWorkspaces: setSelectedWorkspaces, recentWorkspaceIds: recentWorkspaceIds = [], showHeading: showHeading = false, maxSelectableWorkspaces: maxSelectableWorkspaces = null, clientName: clientName = null, hasMoreWorkspaces: hasMoreWorkspaces = false, isLoadingMoreWorkspaces: isLoadingMoreWorkspaces = false, onLoadMoreWorkspaces: onLoadMoreWorkspaces })=>{
    const { formatMessage: formatMessage } = (0, $hrVKU.default)();
    const selectionLimit = maxSelectableWorkspaces != null && Number.isFinite(maxSelectableWorkspaces) && maxSelectableWorkspaces > 0 ? Math.floor(maxSelectableWorkspaces) : null;
    // The connection has no sort argument, so ordering is applied to the whole
    // accumulated list rather than per page. Later pages are merged into the
    // alphabetical sequence instead of being appended to the bottom.
    const options = (0, $5FkrB.useMemo)(()=>(0, $3UXNA.sortTrelloWorkspacesByName)(availableWorkspaces).map($f959ea12f2d209e9$var$toOption), [
        availableWorkspaces
    ]);
    const groupedOptions = (0, $5FkrB.useMemo)(()=>$f959ea12f2d209e9$export$975a734f80d15164({
            options: options,
            recentWorkspaceIds: recentWorkspaceIds,
            recentLabel: formatMessage((0, $a9dd951dda0af606$export$c5ba076c6d622e98).recentGroupLabel),
            allLabel: formatMessage((0, $a9dd951dda0af606$export$c5ba076c6d622e98).allGroupLabel)
        }), [
        options,
        recentWorkspaceIds,
        formatMessage
    ]);
    const selectedIds = (0, $5FkrB.useMemo)(()=>new Set(selectedWorkspaces.map((workspace)=>workspace.id)), [
        selectedWorkspaces
    ]);
    const selectedOptions = (0, $5FkrB.useMemo)(()=>options.filter((option)=>selectedIds.has(option.workspaceId)), [
        options,
        selectedIds
    ]);
    const TrelloOption = (0, $5FkrB.useMemo)(()=>(props)=>/*#__PURE__*/ (0, $i3UfC.jsx)($f959ea12f2d209e9$var$Option, {
                ...props,
                isWorkspaceSelected: selectedIds.has(props.data.workspaceId)
            }), [
        selectedIds
    ]);
    const isSelectionLimitReached = selectionLimit != null && selectedIds.size >= selectionLimit;
    const isOptionDisabled = (0, $5FkrB.useCallback)((option)=>{
        if (selectedIds.has(option.workspaceId)) return false;
        if (isSelectionLimitReached) return true;
        return !(0, $3UXNA.isTrelloWorkspaceSelectable)({
            workspace: option.workspace,
            selectedWorkspaces: selectedWorkspaces,
            isMultiSelectEnabled: true
        });
    }, [
        isSelectionLimitReached,
        selectedIds,
        selectedWorkspaces
    ]);
    const isEnterpriseMember = (0, $5FkrB.useMemo)(()=>(0, $3UXNA.hasEnterpriseTrelloWorkspace)(availableWorkspaces), [
        availableWorkspaces
    ]);
    const limitHelpText = selectionLimit == null ? null : clientName ? formatMessage((0, $a9dd951dda0af606$export$c5ba076c6d622e98).selectionLimitHelpText, {
        limit: selectionLimit,
        clientName: clientName
    }) : formatMessage((0, $a9dd951dda0af606$export$c5ba076c6d622e98).selectionLimitHelpTextNoClient, {
        limit: selectionLimit
    });
    // Both messages occupy the same slot below the field. Enterprise members are
    // shown the combination rule instead of the limit, since it is the
    // constraint that explains why options are disabled.
    const helpText = isEnterpriseMember ? formatMessage((0, $a9dd951dda0af606$export$c5ba076c6d622e98).enterpriseSelectionHelpText) : limitHelpText;
    return /*#__PURE__*/ (0, $i3UfC.jsx)((0, $383dd904a5a5e5b0$export$e71c4d32a2263218), {
        xcss: $f959ea12f2d209e9$var$wrapperStyles,
        children: /*#__PURE__*/ (0, $i3UfC.jsxs)((0, $c8dbef6c41cfa689$export$694e0d28c7ffc90c), {
            space: "space.050",
            xcss: $f959ea12f2d209e9$var$stackStyles,
            children: [
                showHeading && /*#__PURE__*/ (0, $i3UfC.jsx)((0, $383dd904a5a5e5b0$export$e71c4d32a2263218), {
                    as: "label",
                    htmlFor: $f959ea12f2d209e9$export$46ea7dd560633724,
                    children: /*#__PURE__*/ (0, $i3UfC.jsx)((0, $f3887589c02620a1$export$2e2bcd8739ae039), {
                        children: formatMessage((0, $a9dd951dda0af606$export$c5ba076c6d622e98).multiSelectLabel)
                    })
                }),
                /*#__PURE__*/ (0, $i3UfC.jsx)((0, $5330bbf7705e7e35$export$2e2bcd8739ae039), {
                    inputId: $f959ea12f2d209e9$export$46ea7dd560633724,
                    options: groupedOptions,
                    isMulti: true,
                    isSearchable: true,
                    isClearable: true,
                    closeMenuOnSelect: false,
                    hideSelectedOptions: false,
                    placeholder: formatMessage((0, $a9dd951dda0af606$export$c5ba076c6d622e98).placeholder),
                    value: selectedOptions,
                    components: {
                        Option: TrelloOption,
                        MultiValueLabel: $f959ea12f2d209e9$var$MultiValueLabel
                    },
                    formatGroupLabel: $f959ea12f2d209e9$var$formatGroupLabel,
                    styles: $f959ea12f2d209e9$var$multiValueStyles,
                    isOptionDisabled: isOptionDisabled,
                    onMenuScrollToBottom: ()=>{
                        if (hasMoreWorkspaces && !isLoadingMoreWorkspaces) onLoadMoreWorkspaces?.();
                    },
                    isLoading: isLoadingMoreWorkspaces,
                    loadingMessage: ()=>formatMessage((0, $a9dd951dda0af606$export$c5ba076c6d622e98).loadingMoreWorkspaces),
                    onChange: (nextOptions, actionMeta)=>{
                        const chosen = nextOptions ?? [];
                        const toggled = actionMeta.option;
                        // Selecting an already-selected workspace from the other group
                        // means the user intends to deselect it.
                        if ((actionMeta.action === 'select-option' || actionMeta.action === 'deselect-option') && toggled && selectedIds.has(toggled.workspaceId)) {
                            setSelectedWorkspaces(selectedWorkspaces.filter((workspace)=>workspace.id !== toggled.workspaceId));
                            return;
                        }
                        const uniqueById = new Map(chosen.map((option)=>[
                                option.workspaceId,
                                option.workspace
                            ]));
                        const nextWorkspaces = [
                            ...uniqueById.values()
                        ];
                        setSelectedWorkspaces(selectionLimit == null ? nextWorkspaces : nextWorkspaces.slice(0, selectionLimit));
                    }
                }),
                helpText && /*#__PURE__*/ (0, $i3UfC.jsx)((0, $d48daa9a522ca942$export$5f1af8db9871e1d6), {
                    as: "p",
                    size: "small",
                    color: "color.text.subtle",
                    children: helpText
                })
            ]
        })
    });
};
var $f959ea12f2d209e9$export$2e2bcd8739ae039 = $f959ea12f2d209e9$var$TrelloWorkspaceMultiSelect;





var $f5RPY = parcelRequire("f5RPY");
const $469e36f60ef07b84$var$stackStyle = (0, $gDiFE.xcss)({
    alignSelf: 'stretch'
});
const $469e36f60ef07b84$var$selectStyle = (0, $gDiFE.xcss)({
    width: '100%',
    maxWidth: (0, $0e4d630f20279bd3$export$5d17ef8641481a51)
});
const $469e36f60ef07b84$var$TRELLO_SELECT_INPUT_ID = 'oauth-consent-mcp-trello-workspace-select';
/**
 * Trello workspace selector for the MCP consent screen.
 *
 * When `showHeading` is true (Trello-only flow) the component renders
 * its own "Authorize access for:" heading.  When false (mixed flow) the
 * component assumes it lives under the shared SiteSelector heading and
 * shows a short explanation instead.
 */ const $469e36f60ef07b84$var$TrelloWorkspaceSelector = ({ showHeading: showHeading = false })=>{
    const { availableTrelloWorkspaces: availableTrelloWorkspaces, selectedTrelloWorkspaces: selectedTrelloWorkspaces, setSelectedTrelloWorkspaces: setSelectedTrelloWorkspaces, isTrelloWorkspaceMultiSelectEnabled: isTrelloWorkspaceMultiSelectEnabled, trelloWorkspacesHasMore: trelloWorkspacesHasMore, trelloWorkspacesLoadingMore: trelloWorkspacesLoadingMore, onLoadMoreTrelloWorkspaces: onLoadMoreTrelloWorkspaces, isTrelloMultiWorkspaceSelectorEnabled: isTrelloMultiWorkspaceSelectorEnabled, maxSelectableTrelloWorkspaces: maxSelectableTrelloWorkspaces, clientName: clientName, scopeClassification: scopeClassification, trelloWorkspacesLoading: trelloWorkspacesLoading, hasTrelloInboxPlannerScopes: hasTrelloInboxPlannerScopes, recentTrelloWorkspaceIds: recentTrelloWorkspaceIds } = (0, $90MfH.useMcpContext)();
    const { formatMessage: formatMessage } = (0, $hrVKU.default)();
    const isMixed = scopeClassification.hasAtlassian && scopeClassification.hasTrello;
    const switchAccountUrl = (0, $f5RPY.useSwitchAccountLink)();
    if (trelloWorkspacesLoading) return /*#__PURE__*/ (0, $i3UfC.jsxs)((0, $c8dbef6c41cfa689$export$694e0d28c7ffc90c), {
        space: "space.100",
        alignInline: "center",
        children: [
            showHeading && /*#__PURE__*/ (0, $i3UfC.jsx)((0, $383dd904a5a5e5b0$export$e71c4d32a2263218), {
                as: "label",
                htmlFor: $469e36f60ef07b84$var$TRELLO_SELECT_INPUT_ID,
                children: /*#__PURE__*/ (0, $i3UfC.jsx)((0, $82315a19372f332f$export$2e2bcd8739ae039), {
                    size: "small",
                    children: formatMessage((0, $a9dd951dda0af606$export$c5ba076c6d622e98).siteLabel)
                })
            }),
            /*#__PURE__*/ (0, $i3UfC.jsx)((0, $6f7e5f007cf95a87$export$2e2bcd8739ae039), {
                size: "medium"
            })
        ]
    });
    if (availableTrelloWorkspaces.length === 0) {
        const switchAccountLink = /*#__PURE__*/ (0, $i3UfC.jsx)((0, $64e95b69a05329e9$export$2e2bcd8739ae039), {
            href: switchAccountUrl,
            children: /*#__PURE__*/ (0, $i3UfC.jsx)((0, $bgNpv.default), {
                ...(0, $a9dd951dda0af606$export$c5ba076c6d622e98).noWorkspacesSwitchAccount
            })
        });
        const contactSupportLink = /*#__PURE__*/ (0, $i3UfC.jsx)((0, $64e95b69a05329e9$export$2e2bcd8739ae039), {
            href: "https://support.atlassian.com/trello",
            target: "_blank",
            rel: "noopener noreferrer",
            children: /*#__PURE__*/ (0, $i3UfC.jsx)((0, $bgNpv.default), {
                ...(0, $a9dd951dda0af606$export$c5ba076c6d622e98).noWorkspacesContactSupport
            })
        });
        // In the mixed flow, show a compact inline message so that the
        // Atlassian site permissions remain visible and prominent.
        if (isMixed) return /*#__PURE__*/ (0, $i3UfC.jsx)((0, $d48daa9a522ca942$export$5f1af8db9871e1d6), {
            as: "p",
            size: "small",
            color: "color.text.subtle",
            children: /*#__PURE__*/ (0, $i3UfC.jsx)((0, $bgNpv.default), {
                ...(0, $a9dd951dda0af606$export$c5ba076c6d622e98).noWorkspacesCompact,
                values: {
                    switchAccountLink: switchAccountLink,
                    contactSupportLink: contactSupportLink
                }
            })
        });
        // Inbox and Planner are account level, so the flow stays usable without a
        // workspace. Show a disabled selector rather than a dead-end empty state.
        if (hasTrelloInboxPlannerScopes) return /*#__PURE__*/ (0, $i3UfC.jsxs)((0, $c8dbef6c41cfa689$export$694e0d28c7ffc90c), {
            space: "space.100",
            xcss: $469e36f60ef07b84$var$stackStyle,
            children: [
                showHeading && /*#__PURE__*/ (0, $i3UfC.jsx)((0, $383dd904a5a5e5b0$export$e71c4d32a2263218), {
                    as: "label",
                    htmlFor: $469e36f60ef07b84$var$TRELLO_SELECT_INPUT_ID,
                    children: /*#__PURE__*/ (0, $i3UfC.jsx)((0, $82315a19372f332f$export$2e2bcd8739ae039), {
                        size: "small",
                        children: formatMessage((0, $a9dd951dda0af606$export$c5ba076c6d622e98).multiSelectLabel)
                    })
                }),
                /*#__PURE__*/ (0, $i3UfC.jsx)((0, $383dd904a5a5e5b0$export$e71c4d32a2263218), {
                    xcss: $469e36f60ef07b84$var$selectStyle,
                    children: /*#__PURE__*/ (0, $i3UfC.jsx)((0, $5330bbf7705e7e35$export$2e2bcd8739ae039), {
                        inputId: $469e36f60ef07b84$var$TRELLO_SELECT_INPUT_ID,
                        options: [],
                        value: null,
                        isDisabled: true,
                        placeholder: formatMessage((0, $a9dd951dda0af606$export$c5ba076c6d622e98).noWorkspaceAvailablePlaceholder)
                    })
                })
            ]
        });
        // Trello-only flow: show a full empty state
        return /*#__PURE__*/ (0, $i3UfC.jsx)((0, $9a28bb334efe6ee5$export$2e2bcd8739ae039), {
            header: formatMessage((0, $a9dd951dda0af606$export$c5ba076c6d622e98).noWorkspacesHeading),
            description: /*#__PURE__*/ (0, $i3UfC.jsx)((0, $bgNpv.default), {
                ...(0, $a9dd951dda0af606$export$c5ba076c6d622e98).noWorkspacesDescription,
                values: {
                    switchAccountLink: switchAccountLink,
                    contactSupportLink: contactSupportLink
                }
            }),
            imageUrl: (0, (/*@__PURE__*/$parcel$interopDefault($2cb29121ea75d357$exports)))
        });
    }
    if (isTrelloMultiWorkspaceSelectorEnabled) return /*#__PURE__*/ (0, $i3UfC.jsx)((0, $c8dbef6c41cfa689$export$694e0d28c7ffc90c), {
        space: "space.100",
        xcss: $469e36f60ef07b84$var$stackStyle,
        children: /*#__PURE__*/ (0, $i3UfC.jsx)((0, $f959ea12f2d209e9$export$2e2bcd8739ae039), {
            availableWorkspaces: availableTrelloWorkspaces,
            hasMoreWorkspaces: trelloWorkspacesHasMore,
            isLoadingMoreWorkspaces: trelloWorkspacesLoadingMore,
            onLoadMoreWorkspaces: onLoadMoreTrelloWorkspaces,
            selectedWorkspaces: selectedTrelloWorkspaces,
            setSelectedWorkspaces: setSelectedTrelloWorkspaces,
            showHeading: showHeading,
            maxSelectableWorkspaces: maxSelectableTrelloWorkspaces,
            clientName: clientName,
            recentWorkspaceIds: recentTrelloWorkspaceIds
        })
    });
    const options = availableTrelloWorkspaces.map((ws)=>({
            label: ws.displayName,
            value: ws.id,
            workspace: ws
        }));
    const firstSelectedWorkspace = selectedTrelloWorkspaces[0] ?? null;
    const selectedOption = firstSelectedWorkspace ? options.find((o)=>o.value === firstSelectedWorkspace.id) ?? null : null;
    const selectedOptions = (selectedTrelloWorkspaces ?? []).map((workspace)=>options.find((o)=>o.value === workspace.id)).filter((option)=>option != null);
    return /*#__PURE__*/ (0, $i3UfC.jsxs)((0, $c8dbef6c41cfa689$export$694e0d28c7ffc90c), {
        space: "space.100",
        xcss: $469e36f60ef07b84$var$stackStyle,
        children: [
            showHeading && /*#__PURE__*/ (0, $i3UfC.jsx)((0, $383dd904a5a5e5b0$export$e71c4d32a2263218), {
                as: "label",
                htmlFor: $469e36f60ef07b84$var$TRELLO_SELECT_INPUT_ID,
                children: /*#__PURE__*/ (0, $i3UfC.jsx)((0, $82315a19372f332f$export$2e2bcd8739ae039), {
                    size: "small",
                    children: formatMessage((0, $a9dd951dda0af606$export$c5ba076c6d622e98).siteLabel)
                })
            }),
            /*#__PURE__*/ (0, $i3UfC.jsx)((0, $383dd904a5a5e5b0$export$e71c4d32a2263218), {
                xcss: $469e36f60ef07b84$var$selectStyle,
                children: /*#__PURE__*/ (0, $i3UfC.jsx)((0, $5330bbf7705e7e35$export$2e2bcd8739ae039), {
                    inputId: $469e36f60ef07b84$var$TRELLO_SELECT_INPUT_ID,
                    isMulti: isTrelloWorkspaceMultiSelectEnabled,
                    options: options,
                    value: isTrelloWorkspaceMultiSelectEnabled ? selectedOptions : selectedOption,
                    onChange: (option)=>{
                        if (isTrelloWorkspaceMultiSelectEnabled) {
                            const selectedWorkspaceOptions = Array.isArray(option) ? option : [];
                            setSelectedTrelloWorkspaces(selectedWorkspaceOptions.map((selected)=>selected.workspace));
                            return;
                        }
                        const selectedWorkspace = option?.workspace ?? null;
                        setSelectedTrelloWorkspaces(selectedWorkspace ? [
                            selectedWorkspace
                        ] : []);
                    },
                    placeholder: formatMessage((0, $a9dd951dda0af606$export$c5ba076c6d622e98).placeholder),
                    isClearable: true
                })
            }),
            isMixed && /*#__PURE__*/ (0, $i3UfC.jsx)((0, $d48daa9a522ca942$export$5f1af8db9871e1d6), {
                as: "p",
                size: "small",
                color: "color.text.subtle",
                children: formatMessage((0, $a9dd951dda0af606$export$c5ba076c6d622e98).mixedDescription)
            })
        ]
    });
};
var $469e36f60ef07b84$export$2e2bcd8739ae039 = $469e36f60ef07b84$var$TrelloWorkspaceSelector;




var $i3UfC = parcelRequire("i3UfC");

var $bgNpv = parcelRequire("bgNpv");
var $hrVKU = parcelRequire("hrVKU");


var $gDiFE = parcelRequire("gDiFE");


/* ProductIconsIllustration.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $i3UfC = parcelRequire("i3UfC");
parcelRequire("5FkrB");



var $90MfH = parcelRequire("90MfH");
var $6a8702c4291bc19c$exports = {};
$6a8702c4291bc19c$exports = new URL("atlassian.d8654284.svg", import.meta.url).toString();


var $f5f760a7e15da256$exports = {};
$f5f760a7e15da256$exports = new URL("trello.4bf3f286.svg", import.meta.url).toString();


const $2d9b6c87655d3c11$var$_2 = "._19pk1epz{margin-top:var(--ds-space-1000,5pc)}";
const $2d9b6c87655d3c11$var$_ = "._1bsb1osq{width:100%}";
const $2d9b6c87655d3c11$var$styles = {
    image: "_1bsb1osq _19pk1epz"
};
/** Illustration for the "What is an MCP server?" info card.
 *  Shows the Trello illustration for Trello-only flows, and the
 *  Atlassian illustration otherwise.
 */ const $2d9b6c87655d3c11$var$ProductIconsIllustration = ()=>{
    const { scopeClassification: scopeClassification } = (0, $90MfH.useMcpContext)();
    const isTrelloOnly = scopeClassification.hasTrello && !scopeClassification.hasAtlassian;
    return /*#__PURE__*/ (0, $i3UfC.jsxs)((0, $dbdf44c207cf40e4$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $i3UfC.jsx)((0, $c179d2a16dc49323$export$2e2bcd8739ae039), {
                children: [
                    $2d9b6c87655d3c11$var$_,
                    $2d9b6c87655d3c11$var$_2
                ]
            }),
            /*#__PURE__*/ (0, $i3UfC.jsx)((0, $2eb42266ae7fc1da$export$2e2bcd8739ae039), {
                src: isTrelloOnly ? (0, (/*@__PURE__*/$parcel$interopDefault($f5f760a7e15da256$exports))) : (0, (/*@__PURE__*/$parcel$interopDefault($6a8702c4291bc19c$exports))),
                className: (0, $b02ab0e3a0f362dd$export$2e2bcd8739ae039)([
                    $2d9b6c87655d3c11$var$styles.image
                ])
            })
        ]
    });
};
var $2d9b6c87655d3c11$export$2e2bcd8739ae039 = $2d9b6c87655d3c11$var$ProductIconsIllustration;



var $6bnW7 = parcelRequire("6bnW7");
const $4ad31fdc4c110f62$export$5d04b4aebc10a95b = (0, $6bnW7.defineMessages)({
    title: {
        id: 'oauth.mcp.infoCard.title',
        defaultMessage: 'What is an MCP server?',
        description: 'Title for the MCP informational callout on the consent screen (default/Atlassian flow)'
    },
    body: {
        id: 'oauth.mcp.infoCard.body',
        defaultMessage: 'MCP servers are the new standard way to safely empower agents to access your data. In this step we will help you define exactly what your agent can and cannot do.',
        description: 'Body text explaining MCP servers on the consent screen (default/Atlassian flow)'
    },
    trelloTitle: {
        id: 'oauth.mcp.infoCard.trelloTitle',
        defaultMessage: 'What is a Trello MCP server?',
        description: 'Title for the MCP informational callout on the consent screen (Trello-only flow)'
    },
    trelloBody: {
        id: 'oauth.mcp.infoCard.trelloBody',
        defaultMessage: "A Trello MCP server is the secure way to connect AI agents like Claude or ChatGPT to your Trello data. In this step we'll help you define exactly what your agent can and cannot access.",
        description: 'Body text explaining MCP servers on the consent screen (Trello-only flow)'
    },
    learnMore: {
        id: 'oauth.mcp.infoCard.learnMore',
        defaultMessage: 'Learn more',
        description: 'Link button to documentation about MCP'
    },
    sseMigrationTitle: {
        id: 'oauth.mcp.infoCard.sseMigration.title',
        defaultMessage: 'Migrate to the new endpoint',
        description: 'Title for SSE deprecation banner in MCP consent screen'
    },
    sseMigrationBody: {
        id: 'oauth.mcp.infoCard.sseMigration.body',
        defaultMessage: 'The endpoint {endpoint} is deprecated. To keep your connection to the Atlassian Rovo MCP Server active, update your configuration to the latest version.',
        description: 'Body for SSE deprecation banner; {endpoint} is inline code'
    },
    migrationGuide: {
        id: 'oauth.mcp.infoCard.sseMigration.migrationGuide',
        defaultMessage: 'View migration guide',
        description: 'Link to migration documentation from SSE deprecation banner'
    },
    carouselRegionAriaLabel: {
        id: 'oauth.mcp.infoCard.carousel.regionAriaLabel',
        defaultMessage: 'MCP information',
        description: 'Aria label for the MCP info card carousel region'
    }
});




var $90MfH = parcelRequire("90MfH");
const $16d5f84a53e5faca$var$cardStyle = (0, $gDiFE.xcss)({
    backgroundColor: 'elevation.surface',
    borderRadius: 'radius.xxlarge',
    borderWidth: 'border.width',
    borderStyle: 'solid',
    borderColor: 'color.border',
    padding: 'space.0',
    overflow: 'hidden'
});
const $16d5f84a53e5faca$var$illustrationHideNarrowStyle = (0, $gDiFE.xcss)({
    display: 'none',
    [(0, $2ec84d2d4928089d$export$987d49ffe1b0900f).above.md]: {
        display: 'revert'
    }
});
const $16d5f84a53e5faca$var$illustrationBandStyle = (0, $gDiFE.xcss)({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    boxSizing: 'border-box',
    height: '120px',
    minHeight: '120px',
    borderBottomWidth: 'border.width',
    borderBottomStyle: 'solid',
    borderBottomColor: 'color.border',
    backgroundColor: 'color.background.neutral.subtle',
    paddingInline: 'space.150'
});
const $16d5f84a53e5faca$var$illustrationInnerStyle = (0, $gDiFE.xcss)({
    width: '100%',
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: '0px',
    overflow: 'hidden'
});
const $16d5f84a53e5faca$var$textSectionStyle = (0, $gDiFE.xcss)({
    paddingBlock: 'space.200'
});
const $16d5f84a53e5faca$var$contentStyle = (0, $gDiFE.xcss)({
    paddingInline: 'space.200',
    paddingBottom: 'space.200'
});
const $16d5f84a53e5faca$var$buttonRowStyle = (0, $gDiFE.xcss)({
    marginTop: 'space.0',
    gap: 'space.200',
    flexWrap: 'wrap',
    alignItems: 'center'
});
const $16d5f84a53e5faca$var$McpInfoCard = ()=>{
    const { formatMessage: formatMessage } = (0, $hrVKU.default)();
    const { scopeClassification: scopeClassification } = (0, $90MfH.useMcpContext)();
    const isTrelloOnly = scopeClassification.hasTrello && !scopeClassification.hasAtlassian;
    const learnMoreUrl = scopeClassification.hasTrello ? (0, $fe7551cdd4b30cf8$export$ed3bb372e6984c60) : (0, $fe7551cdd4b30cf8$export$9694d17d763a38f1);
    const titleMessage = isTrelloOnly ? (0, $4ad31fdc4c110f62$export$5d04b4aebc10a95b).trelloTitle : (0, $4ad31fdc4c110f62$export$5d04b4aebc10a95b).title;
    const bodyMessage = isTrelloOnly ? (0, $4ad31fdc4c110f62$export$5d04b4aebc10a95b).trelloBody : (0, $4ad31fdc4c110f62$export$5d04b4aebc10a95b).body;
    return /*#__PURE__*/ (0, $i3UfC.jsxs)((0, $383dd904a5a5e5b0$export$e71c4d32a2263218), {
        xcss: $16d5f84a53e5faca$var$cardStyle,
        role: "region",
        "aria-label": formatMessage((0, $4ad31fdc4c110f62$export$5d04b4aebc10a95b).carouselRegionAriaLabel),
        tabIndex: -1,
        children: [
            /*#__PURE__*/ (0, $i3UfC.jsx)((0, $383dd904a5a5e5b0$export$e71c4d32a2263218), {
                xcss: $16d5f84a53e5faca$var$illustrationHideNarrowStyle,
                children: /*#__PURE__*/ (0, $i3UfC.jsx)((0, $383dd904a5a5e5b0$export$e71c4d32a2263218), {
                    xcss: $16d5f84a53e5faca$var$illustrationBandStyle,
                    children: /*#__PURE__*/ (0, $i3UfC.jsx)((0, $383dd904a5a5e5b0$export$e71c4d32a2263218), {
                        xcss: $16d5f84a53e5faca$var$illustrationInnerStyle,
                        children: /*#__PURE__*/ (0, $i3UfC.jsx)((0, $2d9b6c87655d3c11$export$2e2bcd8739ae039), {})
                    })
                })
            }),
            /*#__PURE__*/ (0, $i3UfC.jsxs)((0, $383dd904a5a5e5b0$export$e71c4d32a2263218), {
                xcss: $16d5f84a53e5faca$var$contentStyle,
                children: [
                    /*#__PURE__*/ (0, $i3UfC.jsx)((0, $383dd904a5a5e5b0$export$e71c4d32a2263218), {
                        xcss: $16d5f84a53e5faca$var$textSectionStyle,
                        children: /*#__PURE__*/ (0, $i3UfC.jsxs)((0, $c8dbef6c41cfa689$export$694e0d28c7ffc90c), {
                            space: "space.200",
                            children: [
                                /*#__PURE__*/ (0, $i3UfC.jsx)((0, $82315a19372f332f$export$2e2bcd8739ae039), {
                                    size: "xsmall",
                                    children: /*#__PURE__*/ (0, $i3UfC.jsx)((0, $bgNpv.default), {
                                        ...titleMessage
                                    })
                                }),
                                /*#__PURE__*/ (0, $i3UfC.jsx)((0, $d48daa9a522ca942$export$5f1af8db9871e1d6), {
                                    as: "p",
                                    size: "small",
                                    color: "color.text",
                                    children: /*#__PURE__*/ (0, $i3UfC.jsx)((0, $bgNpv.default), {
                                        ...bodyMessage
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $i3UfC.jsx)((0, $1b254ba6a068f2f1$export$f51f4c4ede09e011), {
                        xcss: $16d5f84a53e5faca$var$buttonRowStyle,
                        children: /*#__PURE__*/ (0, $i3UfC.jsx)((0, $64e95b69a05329e9$export$2e2bcd8739ae039), {
                            href: learnMoreUrl,
                            target: "_blank",
                            rel: "noopener noreferrer",
                            children: /*#__PURE__*/ (0, $i3UfC.jsx)((0, $bgNpv.default), {
                                ...(0, $4ad31fdc4c110f62$export$5d04b4aebc10a95b).learnMore
                            })
                        })
                    })
                ]
            })
        ]
    });
};
var $16d5f84a53e5faca$export$2e2bcd8739ae039 = $16d5f84a53e5faca$var$McpInfoCard;



var $i3UfC = parcelRequire("i3UfC");

var $5FkrB = parcelRequire("5FkrB");

var $6hgMx = parcelRequire("6hgMx");


var $6bnW7 = parcelRequire("6bnW7");
const $6454e0f98e0fadae$export$19ccb9032ee5f20 = (0, $6bnW7.defineMessages)({
    detailsTitle: {
        id: 'oauth.mcp.details.title',
        defaultMessage: 'Details',
        description: 'Section heading for MCP app details'
    },
    nameLabel: {
        id: 'oauth.mcp.details.nameLabel',
        defaultMessage: 'Name',
        description: 'Label for the app name detail row'
    },
    domainLabel: {
        id: 'oauth.mcp.details.domainLabel',
        defaultMessage: 'Domains',
        description: 'Label for the Domain URL detail row'
    }
});


/**
 * MCP-specific details component.
 * Renders Name and Domains rows.
 */ const $51804676d609eb53$var$McpDetails = ()=>{
    const { clientName: clientName, redirectUrl: redirectUrl } = (0, $6hgMx.useToken)();
    const { client: client } = (0, $6hgMx.useInfo)();
    const redirectUrls = (0, $5FkrB.useMemo)(()=>{
        const seen = new Set();
        const urls = [];
        const add = (u)=>{
            const t = u?.trim();
            if (t && !seen.has(t)) {
                seen.add(t);
                urls.push(t);
            }
        };
        add(redirectUrl?.callback);
        (client?.callbacks ?? []).forEach(add);
        return urls;
    }, [
        redirectUrl,
        client?.callbacks
    ]);
    const entries = [
        {
            label: (0, $6454e0f98e0fadae$export$19ccb9032ee5f20).nameLabel,
            value: clientName ?? '',
            useFieldLabelStyle: true,
            useSubtleValueColor: true
        },
        ...redirectUrls.length > 0 ? [
            {
                label: (0, $6454e0f98e0fadae$export$19ccb9032ee5f20).domainLabel,
                value: redirectUrls,
                useFieldLabelStyle: true,
                useSubtleValueColor: true
            }
        ] : []
    ];
    return /*#__PURE__*/ (0, $i3UfC.jsx)((0, $7291219ac426432c$export$2e2bcd8739ae039), {
        title: (0, $6454e0f98e0fadae$export$19ccb9032ee5f20).detailsTitle,
        entries: entries
    });
};
var $51804676d609eb53$export$2e2bcd8739ae039 = $51804676d609eb53$var$McpDetails;



var $i3UfC = parcelRequire("i3UfC");

var $6hgMx = parcelRequire("6hgMx");

var $i3UfC = parcelRequire("i3UfC");

var $5FkrB = parcelRequire("5FkrB");

var $6bnW7 = parcelRequire("6bnW7");
var $bgNpv = parcelRequire("bgNpv");
var $hrVKU = parcelRequire("hrVKU");




var $gDiFE = parcelRequire("gDiFE");

var $9KGFe = parcelRequire("9KGFe");


const $54c84ff2b422cec0$var$sseBannerMessages = (0, $6bnW7.defineMessages)({
    dismiss: {
        id: 'oauth.mcp.sseBanner.dismiss',
        defaultMessage: 'Dismiss',
        description: 'Button label to dismiss the SSE deprecation banner'
    }
});
const $54c84ff2b422cec0$var$codeInlineStyle = (0, $gDiFE.xcss)({
    fontSize: 'font.body.small',
    backgroundColor: 'color.background.neutral',
    paddingInline: 'space.050',
    paddingBlock: 'space.025',
    borderRadius: 'radius.xsmall'
});
const $54c84ff2b422cec0$var$McpSseBanner = ()=>{
    const { formatMessage: formatMessage } = (0, $hrVKU.default)();
    const showSseBanner = (0, $9KGFe.getConfig)().mcpPolicy.showSseDeprecationBanner;
    const [dismissed, setDismissed] = (0, $5FkrB.useState)(false);
    if (!showSseBanner || dismissed) return null;
    return /*#__PURE__*/ (0, $i3UfC.jsx)((0, $ac2404b057b8688e$export$2e2bcd8739ae039), {
        appearance: "warning",
        title: formatMessage((0, $4ad31fdc4c110f62$export$5d04b4aebc10a95b).sseMigrationTitle),
        children: /*#__PURE__*/ (0, $i3UfC.jsxs)((0, $c8dbef6c41cfa689$export$694e0d28c7ffc90c), {
            space: "space.100",
            children: [
                /*#__PURE__*/ (0, $i3UfC.jsx)((0, $d48daa9a522ca942$export$5f1af8db9871e1d6), {
                    as: "p",
                    children: /*#__PURE__*/ (0, $i3UfC.jsx)((0, $bgNpv.default), {
                        ...(0, $4ad31fdc4c110f62$export$5d04b4aebc10a95b).sseMigrationBody,
                        values: {
                            endpoint: /*#__PURE__*/ (0, $i3UfC.jsx)((0, $383dd904a5a5e5b0$export$e71c4d32a2263218), {
                                as: "code",
                                xcss: $54c84ff2b422cec0$var$codeInlineStyle,
                                children: (0, $fe7551cdd4b30cf8$export$99e8ac83a6b9bb90)
                            })
                        }
                    })
                }),
                /*#__PURE__*/ (0, $i3UfC.jsxs)((0, $10b0af967ce59e29$export$fbae5b5ffd8af05e), {
                    space: "space.200",
                    alignBlock: "center",
                    children: [
                        /*#__PURE__*/ (0, $i3UfC.jsx)((0, $64e95b69a05329e9$export$2e2bcd8739ae039), {
                            href: (0, $fe7551cdd4b30cf8$export$614ed7dbae9ac4bd),
                            target: "_blank",
                            rel: "noopener noreferrer",
                            children: /*#__PURE__*/ (0, $i3UfC.jsx)((0, $bgNpv.default), {
                                ...(0, $4ad31fdc4c110f62$export$5d04b4aebc10a95b).migrationGuide
                            })
                        }),
                        /*#__PURE__*/ (0, $i3UfC.jsx)((0, $a21e01c03a9c4d94$export$2e2bcd8739ae039), {
                            appearance: "subtle",
                            onClick: ()=>setDismissed(true),
                            children: /*#__PURE__*/ (0, $i3UfC.jsx)((0, $bgNpv.default), {
                                ...$54c84ff2b422cec0$var$sseBannerMessages.dismiss
                            })
                        })
                    ]
                })
            ]
        })
    });
};
var $54c84ff2b422cec0$export$2e2bcd8739ae039 = $54c84ff2b422cec0$var$McpSseBanner;


const $864acdb65405416a$var$McpBanners = ()=>{
    const token = (0, $6hgMx.useToken)();
    if (token.serviceType !== 'MCP') return null;
    return /*#__PURE__*/ (0, $i3UfC.jsx)((0, $54c84ff2b422cec0$export$2e2bcd8739ae039), {});
};
var $864acdb65405416a$export$2e2bcd8739ae039 = $864acdb65405416a$var$McpBanners;



var $i3UfC = parcelRequire("i3UfC");

var $bgNpv = parcelRequire("bgNpv");
var $hrVKU = parcelRequire("hrVKU");



var $9KGFe = parcelRequire("9KGFe");

var $6hgMx = parcelRequire("6hgMx");

var $90MfH = parcelRequire("90MfH");






var $6bnW7 = parcelRequire("6bnW7");
const $ba6daa6d0ed4de88$export$3b83668abcc5eb12 = (0, $6bnW7.defineMessages)({
    somethingWentWrongTitle: {
        id: 'oauth.mcp.policyAlert.somethingWentWrong.title',
        defaultMessage: 'Something went wrong',
        description: 'Error title shown whenever the permission check could not be completed, whether the request failed or errored unexpectedly'
    },
    workspaceAccessRevokedTitle: {
        id: 'oauth.mcp.policyAlert.workspaceAccessRevoked.title',
        defaultMessage: 'You no longer have access to this workspace',
        description: 'Error title when the user has been removed from a selected Trello workspace'
    },
    workspaceAccessRevokedBody: {
        id: 'oauth.mcp.policyAlert.workspaceAccessRevoked.body',
        defaultMessage: 'Your access to "{workspaceName}" has been removed. Select a different workspace or contact the workspace admin.',
        description: 'Error body when the user has been removed from a selected Trello workspace; {workspaceName} is the workspace display name'
    },
    clientDisabledTitle: {
        id: 'oauth.mcp.policyAlert.clientDisabled.title',
        defaultMessage: '{appName} is unavailable for this {productUnit}',
        description: 'Error title when an admin has disabled the app, or its system account, for the organization that owns the selected workspace; {appName} is the app display name, {productUnit} is "Trello workspace" or "Atlassian site"'
    },
    clientDisabledBody: {
        id: 'oauth.mcp.policyAlert.clientDisabled.body',
        defaultMessage: 'An admin has disabled {appName} for "{workspaceName}". Select a different {productUnit}, or contact the admin of that {productUnit} to restore access.',
        description: 'Error body when an admin has disabled the app, or its system account, for the organization that owns the selected workspace; {appName} is the app display name, {workspaceName} is the selected site or workspace, {productUnit} is "Trello workspace" or "Atlassian site"'
    },
    unexpectedBody: {
        id: 'oauth.mcp.policyAlert.unexpected.body',
        defaultMessage: "We\u2019re having trouble showing permissions right now. You can try refreshing the page or <supportLink>contact support</supportLink>.",
        description: 'Error body paired with the "Something went wrong" title for any permission check that could not be completed, with embedded link to the Atlassian support page'
    },
    missingRedirectTitle: {
        id: 'oauth.mcp.policyAlert.missingRedirect.title',
        defaultMessage: 'Redirect URL is missing',
        description: 'Error title when redirect URL is not provided by the app'
    },
    missingRedirectBody: {
        id: 'oauth.mcp.policyAlert.missingRedirect.body',
        defaultMessage: 'This app must provide a redirect URL before you can continue. Cancel and contact the app developer.',
        description: 'Error body when redirect URL is not provided by the app'
    },
    domainNotAllowedTitle: {
        id: 'oauth.mcp.policyAlert.redirectNotAllowed.title',
        defaultMessage: 'Access to this domain is restricted',
        description: 'Error title when domain URL is not on the admin allowlist'
    },
    domainNotAllowedBodyLine1: {
        id: 'oauth.mcp.policyAlert.redirectNotAllowed.bodyLine1',
        defaultMessage: 'Your admin has blocked this domain "{redirectUrl}" in your organization\u2019s settings. To request access, contact your organization admin or <allowlistLink>find out about domain restrictions</allowlistLink>.',
        description: 'Error body for redirect-not-allowed with embedded link to the admin allowlist documentation; {redirectUrl} is interpolated'
    }
});



var $Qy2AT = parcelRequire("Qy2AT");
function $e35f98e371306e6e$var$resolveSiteLabel(selectedWorkspace, siteNameFromInfo, productUnit) {
    const trimmed = selectedWorkspace?.trim();
    if (trimmed) return trimmed;
    if (siteNameFromInfo?.trim()) return siteNameFromInfo.trim();
    return productUnit;
}
const $e35f98e371306e6e$var$McpPolicyAlerts = ()=>{
    const token = (0, $6hgMx.useToken)();
    const info = (0, $6hgMx.useInfo)();
    const { formatMessage: formatMessage } = (0, $hrVKU.default)();
    const { selectedWorkspace: selectedWorkspace } = (0, $6hgMx.useSelectedWorkspace)();
    const { mcpPolicyErrorKind: mcpPolicyErrorKind, mcpPolicyErrorWorkspaceName: mcpPolicyErrorWorkspaceName, scopeClassification: scopeClassification } = (0, $90MfH.useMcpContext)();
    const { productUnit: productUnit } = (0, $5110a34c125a0b6b$export$67c6d5d2a1a9a362)();
    const isTrelloOnly = scopeClassification.hasTrello && !scopeClassification.hasAtlassian;
    if (token.serviceType !== 'MCP') return null;
    // Keyed on the failure itself, not the combined status: that reports
    // `loading` whenever any check is in flight, so gating on it would hide an
    // already-failed check the moment the user touches another selector.
    if (!mcpPolicyErrorKind) return null;
    const redirectUrl = token.redirectUrl?.callback ?? '';
    const allowlistGuideUrl = (0, $9KGFe.getConfig)().mcpPolicy.allowlistGuideUrl;
    const siteLabel = $e35f98e371306e6e$var$resolveSiteLabel(selectedWorkspace, info.siteName, productUnit);
    if (mcpPolicyErrorKind === (0, $Qy2AT.MCP_POLICY_ERROR_KIND).redirectNotAllowed) return /*#__PURE__*/ (0, $i3UfC.jsx)((0, $9a28bb334efe6ee5$export$2e2bcd8739ae039), {
        header: formatMessage((0, $ba6daa6d0ed4de88$export$3b83668abcc5eb12).domainNotAllowedTitle),
        description: /*#__PURE__*/ (0, $i3UfC.jsx)((0, $bgNpv.default), {
            ...(0, $ba6daa6d0ed4de88$export$3b83668abcc5eb12).domainNotAllowedBodyLine1,
            values: {
                redirectUrl: redirectUrl,
                siteLabel: siteLabel,
                allowlistLink: (text)=>/*#__PURE__*/ (0, $i3UfC.jsx)((0, $64e95b69a05329e9$export$2e2bcd8739ae039), {
                        href: allowlistGuideUrl,
                        target: "_blank",
                        rel: "noopener noreferrer",
                        children: text
                    })
            }
        }),
        imageUrl: (0, (/*@__PURE__*/$parcel$interopDefault($00739cd751ba828e$exports)))
    });
    const contactSupportUrl = isTrelloOnly ? (0, $fe7551cdd4b30cf8$export$420a9148c11203d8) : (0, $9KGFe.getConfig)().support.contactSupportUrl;
    if (mcpPolicyErrorKind === (0, $Qy2AT.MCP_POLICY_ERROR_KIND).clientDisabled) {
        const appName = info.client?.name?.trim() || token.clientName?.trim() || productUnit;
        const workspaceName = mcpPolicyErrorWorkspaceName?.trim() || siteLabel;
        return /*#__PURE__*/ (0, $i3UfC.jsx)((0, $9a28bb334efe6ee5$export$2e2bcd8739ae039), {
            header: formatMessage((0, $ba6daa6d0ed4de88$export$3b83668abcc5eb12).clientDisabledTitle, {
                appName: appName,
                productUnit: productUnit
            }),
            description: formatMessage((0, $ba6daa6d0ed4de88$export$3b83668abcc5eb12).clientDisabledBody, {
                appName: appName,
                workspaceName: workspaceName,
                productUnit: productUnit
            }),
            imageUrl: (0, (/*@__PURE__*/$parcel$interopDefault($00739cd751ba828e$exports)))
        });
    }
    if (mcpPolicyErrorKind === (0, $Qy2AT.MCP_POLICY_ERROR_KIND).workspaceAccessRevoked) return /*#__PURE__*/ (0, $i3UfC.jsx)((0, $9a28bb334efe6ee5$export$2e2bcd8739ae039), {
        header: formatMessage((0, $ba6daa6d0ed4de88$export$3b83668abcc5eb12).workspaceAccessRevokedTitle),
        description: formatMessage((0, $ba6daa6d0ed4de88$export$3b83668abcc5eb12).workspaceAccessRevokedBody, {
            workspaceName: mcpPolicyErrorWorkspaceName ?? productUnit
        }),
        imageUrl: (0, (/*@__PURE__*/$parcel$interopDefault($2cb29121ea75d357$exports)))
    });
    // Any failed request — a non-OK response or a throw — reads the same to the
    // user: we could not load their permissions. Which of the two it was tells
    // them nothing actionable, so the two kinds are deliberately
    // indistinguishable on screen and share one message (see ./messages).
    if (mcpPolicyErrorKind === (0, $Qy2AT.MCP_POLICY_ERROR_KIND).policyFetchFailed || mcpPolicyErrorKind === (0, $Qy2AT.MCP_POLICY_ERROR_KIND).unexpected) return /*#__PURE__*/ (0, $i3UfC.jsx)((0, $9a28bb334efe6ee5$export$2e2bcd8739ae039), {
        header: formatMessage((0, $ba6daa6d0ed4de88$export$3b83668abcc5eb12).somethingWentWrongTitle),
        description: /*#__PURE__*/ (0, $i3UfC.jsx)((0, $bgNpv.default), {
            ...(0, $ba6daa6d0ed4de88$export$3b83668abcc5eb12).unexpectedBody,
            values: {
                supportLink: (text)=>/*#__PURE__*/ (0, $i3UfC.jsx)((0, $64e95b69a05329e9$export$2e2bcd8739ae039), {
                        href: contactSupportUrl,
                        target: "_blank",
                        rel: "noopener noreferrer",
                        children: text
                    })
            }
        }),
        imageUrl: (0, (/*@__PURE__*/$parcel$interopDefault($c54a367501889f55$exports)))
    });
    if (mcpPolicyErrorKind === (0, $Qy2AT.MCP_POLICY_ERROR_KIND).missingRedirect) return /*#__PURE__*/ (0, $i3UfC.jsx)((0, $9a28bb334efe6ee5$export$2e2bcd8739ae039), {
        header: formatMessage((0, $ba6daa6d0ed4de88$export$3b83668abcc5eb12).missingRedirectTitle),
        description: formatMessage((0, $ba6daa6d0ed4de88$export$3b83668abcc5eb12).missingRedirectBody),
        imageUrl: (0, (/*@__PURE__*/$parcel$interopDefault($c54a367501889f55$exports)))
    });
    return null;
};
var $e35f98e371306e6e$export$2e2bcd8739ae039 = $e35f98e371306e6e$var$McpPolicyAlerts;




var $90MfH = parcelRequire("90MfH");


var $6hgMx = parcelRequire("6hgMx");

var $fLAke = parcelRequire("fLAke");
const $8a60a435593244f2$var$forgeIconImageStyles = (0, $gDiFE.xcss)({
    width: '100%',
    height: '100%',
    objectFit: 'cover',
    display: 'block'
});
const $8a60a435593244f2$var$rootStyles = (0, $gDiFE.xcss)({
    width: '100%',
    maxWidth: '100%',
    margin: '0 auto',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'stretch',
    [(0, $2ec84d2d4928089d$export$987d49ffe1b0900f).above.md]: {
        maxWidth: '1280px'
    }
});
const $8a60a435593244f2$var$panelsRowStyles = (0, $gDiFE.xcss)({
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'stretch',
    flex: '1 1 auto',
    minHeight: '0',
    width: '100%',
    flexWrap: 'wrap',
    [(0, $2ec84d2d4928089d$export$987d49ffe1b0900f).above.sm]: {
        minHeight: 'calc(100vh - 56px)'
    }
});
const $8a60a435593244f2$var$leftPanelStyles = (0, $gDiFE.xcss)({
    boxSizing: 'border-box',
    display: 'flex',
    width: '100%',
    minWidth: '100%',
    flexShrink: 0,
    paddingInline: 'space.200',
    paddingBlockStart: 'space.800',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: 'space.500',
    position: 'static',
    top: 'space.0',
    alignSelf: 'flex-start',
    overflowY: 'visible',
    [(0, $2ec84d2d4928089d$export$987d49ffe1b0900f).above.sm]: {
        padding: 'space.0',
        paddingBlockStart: 'space.400',
        marginInline: 'space.300',
        marginBlockStart: 'space.400',
        marginBlockEnd: 'space.800',
        width: '300px',
        minWidth: 'min(100%, 300px)',
        position: 'sticky',
        maxHeight: '100vh',
        overflowY: 'auto'
    },
    [(0, $2ec84d2d4928089d$export$987d49ffe1b0900f).above.md]: {
        marginInline: 'space.600',
        width: '350px',
        minWidth: 'min(100%, 350px)'
    },
    [(0, $2ec84d2d4928089d$export$987d49ffe1b0900f).above.lg]: {
        marginInline: 'space.800'
    }
});
const $8a60a435593244f2$var$rightPanelStyles = (0, $gDiFE.xcss)({
    height: 'auto',
    boxSizing: 'border-box',
    display: 'flex',
    paddingInline: 'space.200',
    paddingBlockStart: 'space.800',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: 'space.500',
    flex: '1 0 100%',
    width: '100%',
    minWidth: '100%',
    borderLeftWidth: 0,
    borderLeftStyle: 'solid',
    borderLeftColor: 'color.border',
    // @ts-expect-error — 500px is an intentional custom value not in design tokens
    paddingBlockEnd: '500px',
    [(0, $2ec84d2d4928089d$export$987d49ffe1b0900f).above.sm]: {
        paddingInline: 'space.300',
        flex: '1 1 0%',
        minWidth: '0',
        borderLeftWidth: 'border.width',
        // @ts-expect-error — 120px is an intentional custom value not in design tokens
        paddingBlockEnd: '120px'
    },
    [(0, $2ec84d2d4928089d$export$987d49ffe1b0900f).above.md]: {
        paddingInline: 'space.600'
    },
    [(0, $2ec84d2d4928089d$export$987d49ffe1b0900f).above.lg]: {
        paddingInline: 'space.800'
    }
});
const $8a60a435593244f2$var$MCP = ()=>{
    const { forgeMcpConsentTarget: forgeMcpConsentTarget } = (0, $6hgMx.useInfo)();
    const { scopeClassification: scopeClassification, trelloRequestedButNoAccess: trelloRequestedButNoAccess, availableTrelloWorkspaces: availableTrelloWorkspaces, hasTrelloInboxPlannerScopes: hasTrelloInboxPlannerScopes } = (0, $90MfH.useMcpContext)();
    const { product: product } = (0, $5110a34c125a0b6b$export$67c6d5d2a1a9a362)();
    const showTrelloWorkspaceSelector = scopeClassification.hasTrello || trelloRequestedButNoAccess;
    const isTrelloOnly = showTrelloWorkspaceSelector && !scopeClassification.hasAtlassian;
    // Signed in to an account with no Trello workspaces and nothing else to
    // grant: the panel is a dead end, so the app details are noise.
    const isTrelloOnlyDeadEnd = isTrelloOnly && availableTrelloWorkspaces.length === 0 && !hasTrelloInboxPlannerScopes;
    const trelloOnlyIcon = isTrelloOnly ? /*#__PURE__*/ (0, $i3UfC.jsx)((0, $2d94d3bb9b62d159$export$4384da9b8b140bf4), {
        size: "xlarge",
        appearance: "brand",
        shouldUseNewLogoDesign: true
    }) : undefined;
    const forgeAppName = (0, $fLAke.getForgeMcpAppName)({
        forgeMcpConsentTarget: forgeMcpConsentTarget
    });
    const forgeAppIcon = (0, $fLAke.getForgeMcpAppIcon)({
        forgeMcpConsentTarget: forgeMcpConsentTarget
    });
    const targetIcon = forgeAppName ? /*#__PURE__*/ (0, $i3UfC.jsx)((0, $0020f204f1f5986b$export$2e2bcd8739ae039), {
        label: forgeAppName,
        size: "xlarge",
        isInset: false,
        children: forgeAppIcon ? /*#__PURE__*/ (0, $i3UfC.jsx)((0, $383dd904a5a5e5b0$export$e71c4d32a2263218), {
            as: "img",
            src: forgeAppIcon,
            alt: "",
            xcss: $8a60a435593244f2$var$forgeIconImageStyles
        }) : undefined
    }) : trelloOnlyIcon;
    return /*#__PURE__*/ (0, $i3UfC.jsx)((0, $383dd904a5a5e5b0$export$e71c4d32a2263218), {
        xcss: $8a60a435593244f2$var$rootStyles,
        children: /*#__PURE__*/ (0, $i3UfC.jsxs)((0, $383dd904a5a5e5b0$export$e71c4d32a2263218), {
            xcss: $8a60a435593244f2$var$panelsRowStyles,
            children: [
                /*#__PURE__*/ (0, $i3UfC.jsxs)((0, $383dd904a5a5e5b0$export$e71c4d32a2263218), {
                    xcss: $8a60a435593244f2$var$leftPanelStyles,
                    children: [
                        /*#__PURE__*/ (0, $i3UfC.jsx)((0, $355d8bd71a4077ad$export$2e2bcd8739ae039), {
                            icon: targetIcon,
                            product: product
                        }),
                        /*#__PURE__*/ (0, $i3UfC.jsx)((0, $16d5f84a53e5faca$export$2e2bcd8739ae039), {})
                    ]
                }),
                /*#__PURE__*/ (0, $i3UfC.jsxs)((0, $383dd904a5a5e5b0$export$e71c4d32a2263218), {
                    xcss: [
                        $8a60a435593244f2$var$rightPanelStyles
                    ],
                    children: [
                        /*#__PURE__*/ (0, $i3UfC.jsx)((0, $864acdb65405416a$export$2e2bcd8739ae039), {}),
                        !trelloRequestedButNoAccess && !isTrelloOnlyDeadEnd && /*#__PURE__*/ (0, $i3UfC.jsx)((0, $51804676d609eb53$export$2e2bcd8739ae039), {}),
                        /*#__PURE__*/ (0, $i3UfC.jsx)((0, $f42c7abbba86ed92$export$2e2bcd8739ae039), {}),
                        scopeClassification.hasAtlassian && /*#__PURE__*/ (0, $i3UfC.jsx)((0, $3ee90eb41e4e6192$export$2e2bcd8739ae039), {}),
                        /*#__PURE__*/ (0, $i3UfC.jsx)((0, $ae9ae1d3b2dd36dc$export$2e2bcd8739ae039), {}),
                        showTrelloWorkspaceSelector && /*#__PURE__*/ (0, $i3UfC.jsx)((0, $469e36f60ef07b84$export$2e2bcd8739ae039), {
                            showHeading: isTrelloOnly
                        }),
                        /*#__PURE__*/ (0, $i3UfC.jsx)((0, $e35f98e371306e6e$export$2e2bcd8739ae039), {}),
                        /*#__PURE__*/ (0, $i3UfC.jsx)((0, $8869c57af01afeb7$export$2e2bcd8739ae039), {})
                    ]
                })
            ]
        })
    });
};
var $8a60a435593244f2$export$2e2bcd8739ae039 = $8a60a435593244f2$var$MCP;



var $i3UfC = parcelRequire("i3UfC");

var $49b5t = parcelRequire("49b5t");

var $i3UfC = parcelRequire("i3UfC");

var $5FkrB = parcelRequire("5FkrB");

var $6hgMx = parcelRequire("6hgMx");

var $i3UfC = parcelRequire("i3UfC");

var $5FkrB = parcelRequire("5FkrB");

var $6hgMx = parcelRequire("6hgMx");

var $90MfH = parcelRequire("90MfH");
/**
 * MCP consent — form field names and API paths aligned with Identity.
 * Confirm with Identity before release: POST encoding, policy query params, cloudId resolution.
 *
 * Server-side (Identity / resume handler): re-validate JWT, re-run policy or equivalent,
 * and ensure POSTed selectedScopes and selectedToolsets are subsets of JWT ∩ policy.
 * Do not trust the browser POST alone.
 */ const $a68f006752f8628a$export$afc2b246f181c5d9 = {
    /**
   * Space-delimited OAuth scope strings: union of scopes across selected toolsets, deduped.
   * The API already filters toolsets to JWT-authorized scopes — no client-side intersection needed.
   */ selectedScopes: 'selectedScopes',
    /** Comma-separated toolset names: (policy-allowed ∩ user-selected). */ selectedToolsets: 'selectedToolsets'
};
const $a68f006752f8628a$export$339481cce20e21c7 = ','; // The workspace policy API path has moved to shared/agent-consent/domain/policyClient.ts
 // (WORKSPACE_POLICY_PATH). MCP-specific form fields remain here.



var $g1jVQ = parcelRequire("g1jVQ");

var $Qy2AT = parcelRequire("Qy2AT");
const $c8ad8f85e6c8b72b$var$McpFlowParameters = ()=>{
    const mcpContext = (0, $5FkrB.useContext)((0, $90MfH.ReactMcpContext));
    const { selectedWorkspace: selectedWorkspace } = (0, $6hgMx.useSelectedWorkspace)();
    const token = (0, $6hgMx.useToken)();
    const selectedNames = mcpContext?.mcpSelectedToolsetNames ?? new Set();
    const byIntent = mcpContext?.mcpByIntent ?? [];
    const allToolsets = byIntent.flatMap((g)=>g.toolsets);
    // Only post names that are still in the effective toolset list
    const allNames = new Set(allToolsets.map((t)=>t.name));
    const postedNames = [
        ...selectedNames
    ].filter((name)=>allNames.has(name));
    const selectedScopesJoined = (0, $g1jVQ.buildMcpSelectedScopesForPost)(postedNames, allToolsets, token.scopes).join(' ');
    const selectedToolsetsJoined = postedNames.join((0, $a68f006752f8628a$export$339481cce20e21c7));
    // Only submit selections whose policy check completed successfully, and only
    // for sources that speak for this flow. Accept is disabled on any error, and
    // a source outside getOrderedPolicySources is not on screen at all, so both
    // conditions are defense in depth against a selection reaching the wire
    // without the screen having shown what it grants.
    const selectedTrelloWorkspaceIds = mcpContext?.scopeClassification.hasTrello && mcpContext.policies.trello.status === 'success' ? mcpContext.selectedTrelloWorkspaces.map((workspace)=>workspace.id).filter(Boolean) : [];
    // 'bitbucket' is the one source whose participation is decided by
    // /consent/info rather than by the token's scopes, so it is the one that has
    // to ask. ('trello' is always in the list, and the `hasAtlassian` guard on
    // the site branch below coincides with 'site' being in it.)
    const selectedBitbucketWorkspaceIds = mcpContext?.isBitbucketWorkspaceAccessEnabled && (0, $Qy2AT.getOrderedPolicySources)(mcpContext.scopeClassification).includes('bitbucket') && mcpContext.policies.bitbucket.status === 'success' ? [
        mcpContext.selectedBitbucketWorkspace?.ari
    ].filter((ari)=>ari != null) : [];
    // A site and a Bitbucket workspace from different organizations cannot be
    // granted together, so no target is submitted while they disagree — the same
    // defense in depth as above. Accept is already disabled and the permissions
    // list withdrawn (see mcpAcceptDisabled / McpPermissions), so this only
    // matters if the form is ever submitted by some other path.
    const selectedWorkspaceIds = mcpContext?.hasOrgMismatch ? [] : [
        ...mcpContext?.scopeClassification.hasAtlassian && mcpContext.policies.site.status === 'success' && selectedWorkspace ? [
            selectedWorkspace
        ] : [],
        ...selectedTrelloWorkspaceIds,
        ...selectedBitbucketWorkspaceIds
    ];
    return /*#__PURE__*/ (0, $i3UfC.jsxs)((0, $i3UfC.Fragment), {
        children: [
            /*#__PURE__*/ (0, $i3UfC.jsx)("input", {
                type: "hidden",
                name: (0, $a68f006752f8628a$export$afc2b246f181c5d9).selectedScopes,
                value: selectedScopesJoined
            }),
            /*#__PURE__*/ (0, $i3UfC.jsx)("input", {
                type: "hidden",
                name: (0, $a68f006752f8628a$export$afc2b246f181c5d9).selectedToolsets,
                value: selectedToolsetsJoined
            }),
            selectedWorkspaceIds.map((workspaceId)=>/*#__PURE__*/ (0, $i3UfC.jsx)("input", {
                    type: "hidden",
                    name: "selectedWorkspace",
                    value: workspaceId
                }, workspaceId))
        ]
    });
};
var $c8ad8f85e6c8b72b$export$2e2bcd8739ae039 = $c8ad8f85e6c8b72b$var$McpFlowParameters;


/**
 * Hidden form fields for the A2A consent flow.
 *
 * Passes the scopes from the consent token as the selected scopes
 * for the form submission.
 */ 
var $i3UfC = parcelRequire("i3UfC");

var $6hgMx = parcelRequire("6hgMx");
const $38280de182f9aad6$var$A2A_REQUIRED_SCOPES = [
    'read:me',
    'offline_access'
];
const $38280de182f9aad6$var$A2AFlowParameters = ()=>{
    const { scopes: scopes } = (0, $6hgMx.useToken)();
    const allScopes = [
        ...new Set([
            ...scopes,
            ...$38280de182f9aad6$var$A2A_REQUIRED_SCOPES
        ])
    ];
    return /*#__PURE__*/ (0, $i3UfC.jsx)("input", {
        type: "hidden",
        name: "selectedScopes",
        value: allScopes.join(' ')
    });
};
var $38280de182f9aad6$export$2e2bcd8739ae039 = $38280de182f9aad6$var$A2AFlowParameters;



var $i3UfC = parcelRequire("i3UfC");

var $5FkrB = parcelRequire("5FkrB");

var $6hgMx = parcelRequire("6hgMx");
// Renders hidden form fields specific to the TWG consent flow.
// selectedScopes reflects what was shown to the user: filteredScopes from
// /consent/info when present, otherwise the full set from the context token.
// selectedOrg is submitted when the user has selected an organization.
const $4fac73df6ee22eb3$var$TwgFlowParameters = ()=>{
    const context = (0, $5FkrB.useContext)((0, $6hgMx.ReactConsentContext));
    if (!context) throw new Error('TwgFlowParameters must be used within ConsentContextProvider');
    const { token: token, info: info, selectedOrg: selectedOrg, selectedScopes: userSelectedScopes } = context;
    // Undefined means org info has not initialized user selection yet. An empty array
    // is an intentional all-deselect and must submit as an empty value.
    const selectedScopes = (userSelectedScopes ?? info.filteredScopes ?? token.scopes).join(' ');
    return /*#__PURE__*/ (0, $i3UfC.jsxs)((0, $i3UfC.Fragment), {
        children: [
            /*#__PURE__*/ (0, $i3UfC.jsx)("input", {
                type: "hidden",
                name: "selectedScopes",
                value: selectedScopes
            }),
            selectedOrg && /*#__PURE__*/ (0, $i3UfC.jsx)("input", {
                type: "hidden",
                name: "selectedOrg",
                value: selectedOrg
            })
        ]
    });
};
var $4fac73df6ee22eb3$export$2e2bcd8739ae039 = $4fac73df6ee22eb3$var$TwgFlowParameters;


// Additional fields to be included in the POST /resume form action
const $3f6ee534b0dd6765$var$FlowParameters = ()=>{
    const context = (0, $5FkrB.useContext)((0, $6hgMx.ReactConsentContext));
    if (!context) throw new Error('FlowParameters must be used within ConsentContextProvider');
    const { token: token, selectedWorkspace: selectedWorkspace } = context;
    return /*#__PURE__*/ (0, $i3UfC.jsxs)((0, $i3UfC.Fragment), {
        children: [
            /*#__PURE__*/ (0, $i3UfC.jsx)("input", {
                type: "hidden",
                name: "context",
                value: token.raw
            }),
            token.serviceType !== 'MCP' && selectedWorkspace && /*#__PURE__*/ (0, $i3UfC.jsx)("input", {
                type: "hidden",
                name: "selectedWorkspace",
                value: selectedWorkspace
            }),
            token.serviceType === 'MCP' && /*#__PURE__*/ (0, $i3UfC.jsx)((0, $c8ad8f85e6c8b72b$export$2e2bcd8739ae039), {}),
            token.serviceType === 'A2A' && /*#__PURE__*/ (0, $i3UfC.jsx)((0, $38280de182f9aad6$export$2e2bcd8739ae039), {}),
            token.serviceType === 'TWG' && /*#__PURE__*/ (0, $i3UfC.jsx)((0, $4fac73df6ee22eb3$export$2e2bcd8739ae039), {})
        ]
    });
};
var $3f6ee534b0dd6765$export$2e2bcd8739ae039 = $3f6ee534b0dd6765$var$FlowParameters;


const $ad526930cc57d7e6$var$ConsentForm = ({ children: children, action: action = '/authorize/resume', onSubmit: onSubmit })=>{
    return /*#__PURE__*/ (0, $i3UfC.jsxs)("form", {
        action: (0, $49b5t.withForwardedEnv)(action),
        method: "post",
        onSubmit: onSubmit,
        children: [
            /*#__PURE__*/ (0, $i3UfC.jsx)((0, $3f6ee534b0dd6765$export$2e2bcd8739ae039), {}),
            children
        ]
    });
};
var $ad526930cc57d7e6$export$2e2bcd8739ae039 = $ad526930cc57d7e6$var$ConsentForm;



var $90MfH = parcelRequire("90MfH");

var $6hgMx = parcelRequire("6hgMx");

var $h7OTL = parcelRequire("h7OTL");

/**
 * Lazily imported so the AGG/Relay `graphql` tag it pulls in is only evaluated
 * when a Trello token actually renders it. Importing it eagerly would put Relay
 * in the import graph of everything that reaches this module, including consent
 * flows that never touch Trello and the unit tests covering them.
 *
 * The Suspense boundary below already exists for the query itself, so it covers
 * the chunk load too and there is no extra fallback state to design.
 */ const $2056e60c7b716f00$var$TrelloWorkspaceFetcher = /*#__PURE__*/ (0, $5FkrB.lazy)(()=>(parcelRequire("kHgfX")));
const $2056e60c7b716f00$var$mcpConsentMainStyle = (0, $gDiFE.xcss)({
    backgroundColor: 'elevation.surface',
    boxSizing: 'border-box',
    padding: 'space.0',
    flex: '1 1 0%',
    minWidth: '0',
    width: '100%',
    display: 'flex',
    flexDirection: 'column'
});
const $2056e60c7b716f00$var$mcpMainViewportStyle = (0, $gDiFE.xcss)({
    display: 'flex',
    flexDirection: 'column',
    flex: '0 1 auto',
    minHeight: '0',
    width: '100%'
});
const $2056e60c7b716f00$var$mcpFormFlexStyle = (0, $gDiFE.xcss)({
    display: 'flex',
    flexDirection: 'column',
    flex: '0 1 auto',
    minHeight: '0',
    width: '100%'
});
const $2056e60c7b716f00$var$contentGrowStyle = (0, $gDiFE.xcss)({
    flex: '0 1 auto',
    minWidth: '0',
    display: 'flex',
    flexDirection: 'column'
});
const $2056e60c7b716f00$var$ContentGrowWrapper = ({ children: children })=>/*#__PURE__*/ (0, $i3UfC.jsx)((0, $383dd904a5a5e5b0$export$e71c4d32a2263218), {
        xcss: $2056e60c7b716f00$var$contentGrowStyle,
        children: children
    });
/** Inner layout: the consent form, its content, and the fixed footer. */ const $2056e60c7b716f00$var$McpConsentInner = ()=>{
    return /*#__PURE__*/ (0, $i3UfC.jsx)((0, $383dd904a5a5e5b0$export$e71c4d32a2263218), {
        as: "main",
        xcss: [
            $2056e60c7b716f00$var$mcpConsentMainStyle,
            $2056e60c7b716f00$var$mcpMainViewportStyle
        ],
        children: /*#__PURE__*/ (0, $i3UfC.jsx)((0, $383dd904a5a5e5b0$export$e71c4d32a2263218), {
            xcss: $2056e60c7b716f00$var$mcpFormFlexStyle,
            children: /*#__PURE__*/ (0, $i3UfC.jsxs)((0, $ad526930cc57d7e6$export$2e2bcd8739ae039), {
                children: [
                    /*#__PURE__*/ (0, $i3UfC.jsx)($2056e60c7b716f00$var$ContentGrowWrapper, {
                        children: /*#__PURE__*/ (0, $i3UfC.jsx)((0, $8a60a435593244f2$export$2e2bcd8739ae039), {})
                    }),
                    /*#__PURE__*/ (0, $i3UfC.jsx)((0, $9f757c9278478c88$export$2e2bcd8739ae039), {})
                ]
            })
        })
    });
};
const $2056e60c7b716f00$var$McpConsentLayout = ()=>{
    const token = (0, $6hgMx.useToken)();
    const { hasTrello: hasTrello } = (0, $h7OTL.classifyScopes)(token.scopes ?? []);
    if (hasTrello) return /*#__PURE__*/ (0, $i3UfC.jsx)((0, $5FkrB.Suspense), {
        fallback: /*#__PURE__*/ (0, $i3UfC.jsx)((0, $90MfH.McpContextProvider), {
            trelloWorkspacesLoading: true,
            children: /*#__PURE__*/ (0, $i3UfC.jsx)($2056e60c7b716f00$var$McpConsentInner, {})
        }),
        children: /*#__PURE__*/ (0, $i3UfC.jsx)($2056e60c7b716f00$var$TrelloWorkspaceFetcher, {
            children: /*#__PURE__*/ (0, $i3UfC.jsx)($2056e60c7b716f00$var$McpConsentInner, {})
        })
    });
    return /*#__PURE__*/ (0, $i3UfC.jsx)((0, $90MfH.McpContextProvider), {
        children: /*#__PURE__*/ (0, $i3UfC.jsx)($2056e60c7b716f00$var$McpConsentInner, {})
    });
};
var $2056e60c7b716f00$export$2e2bcd8739ae039 = $2056e60c7b716f00$var$McpConsentLayout;



var $i3UfC = parcelRequire("i3UfC");

var $5FkrB = parcelRequire("5FkrB");




var $6hgMx = parcelRequire("6hgMx");


var $i3UfC = parcelRequire("i3UfC");

var $6bnW7 = parcelRequire("6bnW7");
var $bgNpv = parcelRequire("bgNpv");

var $gDiFE = parcelRequire("gDiFE");

var $ac944fd3ad422d6e$exports = {};
$ac944fd3ad422d6e$exports = new URL("teamwork-graph-cli.c9f9b8d4.png", import.meta.url).toString();



var $i3UfC = parcelRequire("i3UfC");

var $i3UfC = parcelRequire("i3UfC");


var $i3UfC = parcelRequire("i3UfC");

var $5FkrB = parcelRequire("5FkrB");
var $d8a4d5f71a68842a$exports = {};
$d8a4d5f71a68842a$exports = new URL("twg_logo.d5de3012.png", import.meta.url).toString();



var $6hgMx = parcelRequire("6hgMx");
const $7f17168b3d23bdbe$var$TWG_LOGO_URL = (0, (/*@__PURE__*/$parcel$interopDefault($d8a4d5f71a68842a$exports)));
const $7f17168b3d23bdbe$var$styles = {
    image: {
        backgroundColor: '#ffffff',
        border: '1px solid rgba(9, 30, 66, 0.14)',
        borderRadius: '10px',
        boxShadow: '0 2px 8px rgba(9, 30, 66, 0.18)',
        boxSizing: 'border-box',
        height: '48px',
        objectFit: 'contain',
        padding: '8px',
        width: '48px'
    }
};
const $7f17168b3d23bdbe$var$Logo = ()=>{
    const { clientLogoUrl: clientLogoUrl, clientName: clientName } = (0, $6hgMx.useToken)();
    const [logoSrc, setLogoSrc] = (0, $5FkrB.useState)(clientLogoUrl || $7f17168b3d23bdbe$var$TWG_LOGO_URL);
    (0, $5FkrB.useEffect)(()=>{
        setLogoSrc(clientLogoUrl || $7f17168b3d23bdbe$var$TWG_LOGO_URL);
    }, [
        clientLogoUrl
    ]);
    return /*#__PURE__*/ (0, $i3UfC.jsx)("img", {
        src: logoSrc,
        alt: clientName ?? undefined,
        onError: ()=>{
            if (logoSrc !== $7f17168b3d23bdbe$var$TWG_LOGO_URL) setLogoSrc($7f17168b3d23bdbe$var$TWG_LOGO_URL);
        },
        style: $7f17168b3d23bdbe$var$styles.image
    });
};
var $7f17168b3d23bdbe$export$2e2bcd8739ae039 = $7f17168b3d23bdbe$var$Logo;



/* AtlassianUserIcon.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $i3UfC = parcelRequire("i3UfC");
parcelRequire("5FkrB");





var $f5RPY = parcelRequire("f5RPY");

const $fa1e44a98fdaef45$var$_4 = "._1yt4u2gc{padding:var(--ds-space-100,8px)}";
const $fa1e44a98fdaef45$var$_3 = "._19pkxmi2{margin-top:var(--ds-space-negative-150,-9pt)}";
const $fa1e44a98fdaef45$var$_2 = "._18u0xmi2{margin-left:var(--ds-space-negative-150,-9pt)}";
const $fa1e44a98fdaef45$var$_ = "._1wpz1y6m{align-self:flex-start}";
const $fa1e44a98fdaef45$var$styles = {
    avatarStyle: "_1wpz1y6m _18u0xmi2 _19pkxmi2",
    iconStyle: "_1yt4u2gc"
};
const $fa1e44a98fdaef45$var$AtlassianUserIcon = ()=>{
    const user = (0, $f5RPY.useUser)();
    return /*#__PURE__*/ (0, $i3UfC.jsxs)((0, $04267de539304abd$export$fbae5b5ffd8af05e), {
        alignInline: 'center',
        children: [
            /*#__PURE__*/ (0, $i3UfC.jsx)((0, $0020f204f1f5986b$export$2e2bcd8739ae039), {
                label: "Atlassian",
                size: "xlarge",
                backgroundColor: "color.background.brand.bold",
                isInset: false,
                children: /*#__PURE__*/ (0, $i3UfC.jsxs)((0, $dbdf44c207cf40e4$export$2e2bcd8739ae039), {
                    children: [
                        /*#__PURE__*/ (0, $i3UfC.jsx)((0, $c179d2a16dc49323$export$2e2bcd8739ae039), {
                            children: [
                                $fa1e44a98fdaef45$var$_,
                                $fa1e44a98fdaef45$var$_2,
                                $fa1e44a98fdaef45$var$_3,
                                $fa1e44a98fdaef45$var$_4
                            ]
                        }),
                        /*#__PURE__*/ (0, $i3UfC.jsx)((0, $7a49b1df02a75aca$export$e71c4d32a2263218), {
                            xcss: $fa1e44a98fdaef45$var$styles.iconStyle,
                            children: /*#__PURE__*/ (0, $i3UfC.jsx)((0, $50101e7733a6b1d7$export$8a485e2e7ed91e8f), {
                                size: "xlarge",
                                appearance: "inverse"
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $i3UfC.jsx)((0, $467b7370bd97bdfa$export$2e2bcd8739ae039), {
                size: "small",
                src: user?.picture,
                // apply styling to put the avatar in the top-right corner
                as: ({ children: children, ...props })=>/*#__PURE__*/ (0, $i3UfC.jsxs)((0, $dbdf44c207cf40e4$export$2e2bcd8739ae039), {
                        children: [
                            /*#__PURE__*/ (0, $i3UfC.jsx)((0, $c179d2a16dc49323$export$2e2bcd8739ae039), {
                                children: [
                                    $fa1e44a98fdaef45$var$_,
                                    $fa1e44a98fdaef45$var$_2,
                                    $fa1e44a98fdaef45$var$_3,
                                    $fa1e44a98fdaef45$var$_4
                                ]
                            }),
                            /*#__PURE__*/ (0, $i3UfC.jsx)("div", {
                                ...props,
                                className: (0, $b02ab0e3a0f362dd$export$2e2bcd8739ae039)([
                                    $fa1e44a98fdaef45$var$styles.avatarStyle
                                ]),
                                children: children
                            })
                        ]
                    })
            })
        ]
    });
};
var $fa1e44a98fdaef45$export$2e2bcd8739ae039 = $fa1e44a98fdaef45$var$AtlassianUserIcon;


const $f126e0db2527cc93$var$AppLogos = ()=>/*#__PURE__*/ (0, $i3UfC.jsxs)((0, $04267de539304abd$export$fbae5b5ffd8af05e), {
        alignBlock: "center",
        space: "space.100",
        children: [
            /*#__PURE__*/ (0, $i3UfC.jsx)((0, $7f17168b3d23bdbe$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $i3UfC.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($94d2f5c76a2afb62$exports))), {
                label: ""
            }),
            /*#__PURE__*/ (0, $i3UfC.jsx)((0, $fa1e44a98fdaef45$export$2e2bcd8739ae039), {})
        ]
    });
var $f126e0db2527cc93$export$2e2bcd8739ae039 = $f126e0db2527cc93$var$AppLogos;



var $i3UfC = parcelRequire("i3UfC");

var $6bnW7 = parcelRequire("6bnW7");
var $bgNpv = parcelRequire("bgNpv");

var $6hgMx = parcelRequire("6hgMx");
const $ec9190fa4007f920$var$messages = (0, $6bnW7.defineMessages)({
    title: {
        id: 'oauth.twg.heading',
        defaultMessage: '{clientName} is requesting access to your Atlassian account',
        description: 'Heading for TWG CLI Consent screen'
    }
});
const $ec9190fa4007f920$var$styles = {
    heading: {
        color: 'var(--twg-heading)',
        fontSize: '24px',
        fontWeight: 700,
        lineHeight: '28px',
        margin: 0,
        maxWidth: '312px'
    }
};
const $ec9190fa4007f920$var$Header = ()=>{
    const { clientName: clientName } = (0, $6hgMx.useToken)();
    return /*#__PURE__*/ (0, $i3UfC.jsx)("h1", {
        style: $ec9190fa4007f920$var$styles.heading,
        children: /*#__PURE__*/ (0, $i3UfC.jsx)((0, $bgNpv.default), {
            ...$ec9190fa4007f920$var$messages.title,
            values: {
                clientName: clientName
            }
        })
    });
};
var $ec9190fa4007f920$export$2e2bcd8739ae039 = $ec9190fa4007f920$var$Header;


const $093a9df5f9ab5b22$var$Headline = ()=>{
    return /*#__PURE__*/ (0, $i3UfC.jsxs)((0, $i3UfC.Fragment), {
        children: [
            /*#__PURE__*/ (0, $i3UfC.jsx)((0, $f126e0db2527cc93$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $i3UfC.jsx)((0, $ec9190fa4007f920$export$2e2bcd8739ae039), {})
        ]
    });
};
var $093a9df5f9ab5b22$export$2e2bcd8739ae039 = $093a9df5f9ab5b22$var$Headline;



const $b2493fbe6bb95576$var$messages = (0, $6bnW7.defineMessages)({
    title: {
        id: 'oauth.twg.adminRail.title',
        defaultMessage: 'What is Teamwork Graph CLI?',
        description: 'Title for the TWG CLI informational rail'
    },
    body: {
        id: 'oauth.twg.adminRail.body',
        defaultMessage: 'Teamwork Graph brings your work context to where you code - the terminal. Analyze massive logs, refine release notes, and debug complex codebases with connected insights across all your applications.',
        description: 'Body text explaining Teamwork Graph CLI on the consent screen'
    },
    learnMore: {
        id: 'oauth.twg.adminRail.learnMore',
        defaultMessage: 'Learn more',
        description: 'Link text for Teamwork Graph CLI documentation'
    }
});
const $b2493fbe6bb95576$var$railStyle = (0, $gDiFE.xcss)({
    width: '100%'
});
const $b2493fbe6bb95576$var$styles = {
    rail: {
        color: 'var(--twg-text)'
    },
    infoCard: {
        borderColor: 'var(--twg-card-border)',
        borderRadius: '8px',
        borderStyle: 'solid',
        borderWidth: '1px',
        boxShadow: 'none',
        overflow: 'hidden',
        width: '100%'
    },
    imageWrap: {
        alignItems: 'center',
        backgroundColor: 'var(--twg-illustration-bg)',
        display: 'flex',
        height: '121px',
        justifyContent: 'center',
        overflow: 'hidden',
        width: '100%'
    },
    illustration: {
        display: 'block',
        height: '100%',
        objectFit: 'cover',
        width: '100%'
    },
    infoBody: {
        backgroundColor: 'var(--twg-info-panel-bg)',
        color: 'var(--twg-info-panel-text)',
        paddingBlock: '16px',
        paddingInline: '16px'
    },
    infoTitle: {
        color: 'var(--twg-info-panel-text)',
        fontSize: '14px',
        fontWeight: 700,
        lineHeight: '20px',
        margin: 0
    },
    infoParagraph: {
        color: 'var(--twg-info-panel-muted)',
        fontSize: '12px',
        lineHeight: '16px',
        margin: 0
    },
    infoActions: {
        margin: 0
    }
};
const $b2493fbe6bb95576$var$TwgAdminRail = ()=>/*#__PURE__*/ (0, $i3UfC.jsxs)((0, $c8dbef6c41cfa689$export$694e0d28c7ffc90c), {
        xcss: $b2493fbe6bb95576$var$railStyle,
        space: "space.500",
        children: [
            /*#__PURE__*/ (0, $i3UfC.jsx)((0, $093a9df5f9ab5b22$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $i3UfC.jsx)("div", {
                style: $b2493fbe6bb95576$var$styles.rail,
                children: /*#__PURE__*/ (0, $i3UfC.jsxs)("div", {
                    style: $b2493fbe6bb95576$var$styles.infoCard,
                    children: [
                        /*#__PURE__*/ (0, $i3UfC.jsx)("div", {
                            style: $b2493fbe6bb95576$var$styles.imageWrap,
                            children: /*#__PURE__*/ (0, $i3UfC.jsx)("img", {
                                src: (0, (/*@__PURE__*/$parcel$interopDefault($ac944fd3ad422d6e$exports))),
                                alt: "",
                                "aria-hidden": "true",
                                style: $b2493fbe6bb95576$var$styles.illustration
                            })
                        }),
                        /*#__PURE__*/ (0, $i3UfC.jsx)("div", {
                            style: $b2493fbe6bb95576$var$styles.infoBody,
                            children: /*#__PURE__*/ (0, $i3UfC.jsxs)((0, $c8dbef6c41cfa689$export$694e0d28c7ffc90c), {
                                space: "space.200",
                                children: [
                                    /*#__PURE__*/ (0, $i3UfC.jsx)("h2", {
                                        style: $b2493fbe6bb95576$var$styles.infoTitle,
                                        children: /*#__PURE__*/ (0, $i3UfC.jsx)((0, $bgNpv.default), {
                                            ...$b2493fbe6bb95576$var$messages.title
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $i3UfC.jsx)("p", {
                                        style: $b2493fbe6bb95576$var$styles.infoParagraph,
                                        children: /*#__PURE__*/ (0, $i3UfC.jsx)((0, $bgNpv.default), {
                                            ...$b2493fbe6bb95576$var$messages.body
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $i3UfC.jsx)("p", {
                                        style: $b2493fbe6bb95576$var$styles.infoActions,
                                        children: /*#__PURE__*/ (0, $i3UfC.jsx)((0, $64e95b69a05329e9$export$2e2bcd8739ae039), {
                                            href: (0, $fc51540d63e4ad37$export$bf13c4107ff8ff42),
                                            target: "_blank",
                                            rel: "noopener noreferrer",
                                            children: /*#__PURE__*/ (0, $i3UfC.jsx)((0, $bgNpv.default), {
                                                ...$b2493fbe6bb95576$var$messages.learnMore
                                            })
                                        })
                                    })
                                ]
                            })
                        })
                    ]
                })
            })
        ]
    });
var $b2493fbe6bb95576$export$2e2bcd8739ae039 = $b2493fbe6bb95576$var$TwgAdminRail;




const $e761d8251e15a6c2$var$themeVars = {
    '--twg-page-bg': (0, $37190500189da037$export$9e1725a4cfeada27)('elevation.surface', '#ffffff'),
    '--twg-rail-bg': (0, $37190500189da037$export$9e1725a4cfeada27)('elevation.surface', '#ffffff'),
    '--twg-pane-bg': (0, $37190500189da037$export$9e1725a4cfeada27)('elevation.surface', '#ffffff'),
    '--twg-divider': (0, $37190500189da037$export$9e1725a4cfeada27)('color.border', '#dcdfe4'),
    '--twg-heading': (0, $37190500189da037$export$9e1725a4cfeada27)('color.text', '#172b4d'),
    '--twg-text': (0, $37190500189da037$export$9e1725a4cfeada27)('color.text', '#172b4d'),
    '--twg-muted': (0, $37190500189da037$export$9e1725a4cfeada27)('color.text.subtle', '#626f86'),
    '--twg-card-bg': (0, $37190500189da037$export$9e1725a4cfeada27)('elevation.surface.raised', '#ffffff'),
    '--twg-card-text': (0, $37190500189da037$export$9e1725a4cfeada27)('color.text', '#172b4d'),
    '--twg-card-muted': (0, $37190500189da037$export$9e1725a4cfeada27)('color.text.subtle', '#44546f'),
    '--twg-card-border': (0, $37190500189da037$export$9e1725a4cfeada27)('color.border', '#dcdfe4'),
    '--twg-card-hover': (0, $37190500189da037$export$9e1725a4cfeada27)('color.background.neutral.subtle.hovered', '#f7f8f9'),
    '--twg-illustration-bg': (0, $37190500189da037$export$9e1725a4cfeada27)('color.background.neutral.bold', '#101214'),
    '--twg-info-panel-bg': (0, $37190500189da037$export$9e1725a4cfeada27)('color.background.neutral', '#ffffff'),
    '--twg-info-panel-text': (0, $37190500189da037$export$9e1725a4cfeada27)('color.text', '#172b4d'),
    '--twg-info-panel-muted': (0, $37190500189da037$export$9e1725a4cfeada27)('color.text.subtle', '#172b4d'),
    '--twg-warning-bg': (0, $37190500189da037$export$9e1725a4cfeada27)('color.background.warning', '#fff7d6'),
    '--twg-warning-text': (0, $37190500189da037$export$9e1725a4cfeada27)('color.text', '#172b4d'),
    '--twg-warning-icon': (0, $37190500189da037$export$9e1725a4cfeada27)('color.icon.warning', '#e56910'),
    '--twg-info-icon': (0, $37190500189da037$export$9e1725a4cfeada27)('color.icon.information', '#bf63f3'),
    '--twg-empty-icon': (0, $37190500189da037$export$9e1725a4cfeada27)('color.border', '#dcdfe4'),
    '--twg-link': (0, $37190500189da037$export$9e1725a4cfeada27)('color.link', '#0c66e4')
};
const $e761d8251e15a6c2$var$styles = {
    page: {
        backgroundColor: 'var(--twg-page-bg)',
        boxSizing: 'border-box',
        color: 'var(--twg-text)',
        minHeight: 'calc(100vh - 48px)',
        minWidth: 0,
        width: '100%'
    },
    shell: {
        backgroundColor: 'var(--twg-pane-bg)',
        boxSizing: 'border-box',
        display: 'flex',
        marginInline: 'auto',
        maxWidth: '1356px',
        minHeight: 'calc(100vh - 48px)',
        minWidth: 0,
        overflow: 'hidden',
        paddingBottom: '88px',
        position: 'relative',
        width: '100%'
    },
    shellNarrow: {
        flexDirection: 'column',
        overflow: 'visible',
        paddingBottom: 0
    },
    leftRail: {
        backgroundColor: 'var(--twg-rail-bg)',
        borderRightColor: 'var(--twg-divider)',
        borderRightStyle: 'solid',
        borderRightWidth: '1px',
        boxSizing: 'border-box',
        flex: '0 0 440px',
        minHeight: 'calc(100vh - 136px)',
        paddingBlock: '64px',
        paddingInline: '64px'
    },
    leftRailNarrow: {
        borderBottomColor: 'var(--twg-divider)',
        borderBottomStyle: 'solid',
        borderBottomWidth: '1px',
        borderRightWidth: 0,
        flex: '0 0 auto',
        minHeight: 0,
        paddingBlock: '64px 40px',
        paddingInline: '16px',
        width: '100%'
    },
    rightPane: {
        backgroundColor: 'var(--twg-pane-bg)',
        boxSizing: 'border-box',
        display: 'flex',
        flex: '1 1 auto',
        flexDirection: 'column',
        minHeight: 0,
        minWidth: 0,
        paddingBlock: '80px',
        paddingInline: '64px 80px',
        position: 'relative',
        width: '100%'
    },
    rightPaneNarrow: {
        paddingBlock: '24px 32px',
        paddingInline: '16px'
    },
    content: {
        maxWidth: '772px',
        width: '100%'
    },
    contentNarrow: {
        maxWidth: 'none'
    }
};
const $e761d8251e15a6c2$var$narrowViewportQuery = '(max-width: 767px)';
const $e761d8251e15a6c2$var$useIsNarrowViewport = ()=>{
    const getInitialValue = ()=>typeof window !== 'undefined' && typeof window.matchMedia === 'function' ? window.matchMedia($e761d8251e15a6c2$var$narrowViewportQuery).matches : false;
    const [isNarrow, setIsNarrow] = (0, $5FkrB.useState)(getInitialValue);
    (0, $5FkrB.useEffect)(()=>{
        if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return undefined;
        const mediaQuery = window.matchMedia($e761d8251e15a6c2$var$narrowViewportQuery);
        const onChange = ()=>setIsNarrow(mediaQuery.matches);
        mediaQuery.addEventListener('change', onChange);
        return ()=>mediaQuery.removeEventListener('change', onChange);
    }, []);
    return isNarrow;
};
const $e761d8251e15a6c2$var$TwgConsentLayout = ({ defaultPermissionsEditMode: defaultPermissionsEditMode = false })=>{
    const consentContext = (0, $5FkrB.useContext)((0, $6hgMx.ReactConsentContext));
    const { scopes: scopes } = (0, $6hgMx.useToken)();
    const { disabledScopes: disabledScopes, filteredScopes: filteredScopes } = (0, $6hgMx.useInfo)();
    const { selectedOrg: selectedOrg, isOrgLoading: isOrgLoading, orgError: orgError } = (0, $6hgMx.useSelectedOrg)();
    const { selectedWorkspace: selectedWorkspace } = (0, $6hgMx.useSelectedWorkspace)();
    const isNarrow = $e761d8251e15a6c2$var$useIsNarrowViewport();
    const [permissionsEditMode, setPermissionsEditMode] = (0, $5FkrB.useState)(defaultPermissionsEditMode);
    const acceptDisabled = !!consentContext?.acceptDisabled || !selectedOrg || !selectedWorkspace || isOrgLoading || !!orgError;
    const selectedScopes = consentContext?.selectedScopes ?? [];
    const requestedScopes = (0, $5FkrB.useMemo)(()=>{
        return new Set([
            ...scopes,
            ...filteredScopes ?? [],
            ...disabledScopes ?? []
        ].filter((scope)=>!(0, $de1b94c351ae758a$export$7027cf972b967c1e).has(scope)));
    }, [
        disabledScopes,
        filteredScopes,
        scopes
    ]);
    const allowedScopes = (0, $5FkrB.useMemo)(()=>{
        return new Set((filteredScopes ?? scopes).filter((scope)=>!(0, $de1b94c351ae758a$export$7027cf972b967c1e).has(scope)));
    }, [
        filteredScopes,
        scopes
    ]);
    const selectedScopeCount = selectedScopes.filter((scope)=>allowedScopes.has(scope)).length;
    const selectedPermissionsSummary = permissionsEditMode && selectedWorkspace && !isOrgLoading && !orgError && requestedScopes.size > 0 ? {
        selectedCount: selectedScopeCount,
        totalCount: requestedScopes.size
    } : undefined;
    (0, $5FkrB.useEffect)(()=>{
        (0, $9a4b3b2d125ade05$export$fd7e0dd2b74807f7)({
            colorMode: 'auto',
            light: 'light',
            dark: 'dark'
        }).catch((e)=>console.warn('Theme failed to load', e));
    }, []);
    return /*#__PURE__*/ (0, $i3UfC.jsx)("main", {
        style: {
            ...$e761d8251e15a6c2$var$themeVars,
            ...$e761d8251e15a6c2$var$styles.page
        },
        children: /*#__PURE__*/ (0, $i3UfC.jsx)((0, $ad526930cc57d7e6$export$2e2bcd8739ae039), {
            children: /*#__PURE__*/ (0, $i3UfC.jsxs)("div", {
                style: {
                    ...$e761d8251e15a6c2$var$styles.shell,
                    ...isNarrow ? $e761d8251e15a6c2$var$styles.shellNarrow : {}
                },
                children: [
                    /*#__PURE__*/ (0, $i3UfC.jsx)("aside", {
                        style: {
                            ...$e761d8251e15a6c2$var$styles.leftRail,
                            ...isNarrow ? $e761d8251e15a6c2$var$styles.leftRailNarrow : {}
                        },
                        children: /*#__PURE__*/ (0, $i3UfC.jsx)((0, $b2493fbe6bb95576$export$2e2bcd8739ae039), {})
                    }),
                    /*#__PURE__*/ (0, $i3UfC.jsx)("section", {
                        style: {
                            ...$e761d8251e15a6c2$var$styles.rightPane,
                            ...isNarrow ? $e761d8251e15a6c2$var$styles.rightPaneNarrow : {}
                        },
                        children: /*#__PURE__*/ (0, $i3UfC.jsx)("div", {
                            style: {
                                ...$e761d8251e15a6c2$var$styles.content,
                                ...isNarrow ? $e761d8251e15a6c2$var$styles.contentNarrow : {}
                            },
                            children: /*#__PURE__*/ (0, $i3UfC.jsx)((0, $4b0b0a8dd164e37c$export$2e2bcd8739ae039), {
                                defaultPermissionsEditMode: defaultPermissionsEditMode,
                                permissionsEditMode: permissionsEditMode,
                                onPermissionsEditModeChange: setPermissionsEditMode
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $i3UfC.jsx)((0, $557e0d777fff2f94$export$2e2bcd8739ae039), {
                        acceptDisabled: acceptDisabled,
                        selectedPermissionsSummary: selectedPermissionsSummary
                    })
                ]
            })
        })
    });
};
var $e761d8251e15a6c2$export$2e2bcd8739ae039 = $e761d8251e15a6c2$var$TwgConsentLayout;



var $i3UfC = parcelRequire("i3UfC");

var $5FkrB = parcelRequire("5FkrB");




var $6hgMx = parcelRequire("6hgMx");

var $i3UfC = parcelRequire("i3UfC");

var $gDiFE = parcelRequire("gDiFE");


var $i3UfC = parcelRequire("i3UfC");

var $6bnW7 = parcelRequire("6bnW7");
var $bgNpv = parcelRequire("bgNpv");


var $gDiFE = parcelRequire("gDiFE");
const $8f871dd6cee178f3$var$messages = (0, $6bnW7.defineMessages)({
    agreementHeader: {
        id: 'oauth.mcp.bestPracticesHeader',
        defaultMessage: 'By accepting this app, you:',
        description: 'The header for oath legal terms'
    },
    agreementBulletTwo: {
        id: 'oauth.mcp.bestPracticesBulletTwo',
        defaultMessage: 'Agree to the {privacyPolicyLink} and {termsOfUseLink}',
        description: 'Second oath terms of agreement. The privacyPolicyLink and termsOfUseLink are replaced with actual links in the UI.'
    },
    agreementInline: {
        id: 'oauth.rovo.legalInline',
        defaultMessage: "By accepting, you agree to Atlassian's {privacyPolicyLink} and {termsOfUseLink}",
        description: 'Single-line legal copy shown in the Rovo sticky action footer. The privacyPolicyLink and termsOfUseLink are replaced with actual links in the UI.'
    },
    privacyPolicy: {
        id: 'oauth.mcp.privacyPolicy',
        defaultMessage: 'privacy policy',
        description: 'Text for the privacy policy link'
    },
    termsOfUse: {
        id: 'oauth.mcp.termsOfUse',
        defaultMessage: 'terms of use',
        description: 'Text for the terms of use link'
    }
});
const $8f871dd6cee178f3$var$disclaimerStyle = (0, $gDiFE.xcss)({
    color: 'color.text.subtle',
    font: 'font.body.small'
});
const $8f871dd6cee178f3$var$PRIVACY_POLICY_HREF = 'https://www.atlassian.com/legal/privacy-policy#what-this-policy-covers';
const $8f871dd6cee178f3$var$TERMS_OF_USE_HREF = 'https://www.atlassian.com/legal/atlassian-customer-agreement#intro';
const $8f871dd6cee178f3$var$privacyPolicyLink = /*#__PURE__*/ (0, $i3UfC.jsx)((0, $64e95b69a05329e9$export$2e2bcd8739ae039), {
    href: $8f871dd6cee178f3$var$PRIVACY_POLICY_HREF,
    children: /*#__PURE__*/ (0, $i3UfC.jsx)((0, $bgNpv.default), {
        ...$8f871dd6cee178f3$var$messages.privacyPolicy
    })
});
const $8f871dd6cee178f3$var$termsOfUseLink = /*#__PURE__*/ (0, $i3UfC.jsx)((0, $64e95b69a05329e9$export$2e2bcd8739ae039), {
    href: $8f871dd6cee178f3$var$TERMS_OF_USE_HREF,
    children: /*#__PURE__*/ (0, $i3UfC.jsx)((0, $bgNpv.default), {
        ...$8f871dd6cee178f3$var$messages.termsOfUse
    })
});
const $8f871dd6cee178f3$var$LegalDisclaimer = ({ variant: variant = 'block' })=>{
    if (variant === 'inline') // Inline variant: a single sentence (\"By accepting, you agree to
    // Atlassian's privacy policy and terms of use\") rendered as subtle small
    // text, with the privacy/terms links interpolated inline. Used in the Rovo
    // sticky action footer, where the legal copy sits on one line next to the
    // Cancel/Accept buttons rather than as the bulleted block below.
    return /*#__PURE__*/ (0, $i3UfC.jsx)((0, $383dd904a5a5e5b0$export$e71c4d32a2263218), {
        xcss: $8f871dd6cee178f3$var$disclaimerStyle,
        children: /*#__PURE__*/ (0, $i3UfC.jsx)((0, $bgNpv.default), {
            ...$8f871dd6cee178f3$var$messages.agreementInline,
            values: {
                privacyPolicyLink: $8f871dd6cee178f3$var$privacyPolicyLink,
                termsOfUseLink: $8f871dd6cee178f3$var$termsOfUseLink
            }
        })
    });
    return /*#__PURE__*/ (0, $i3UfC.jsxs)((0, $383dd904a5a5e5b0$export$e71c4d32a2263218), {
        xcss: $8f871dd6cee178f3$var$disclaimerStyle,
        children: [
            /*#__PURE__*/ (0, $i3UfC.jsx)((0, $bgNpv.default), {
                ...$8f871dd6cee178f3$var$messages.agreementHeader,
                tagName: "p"
            }),
            /*#__PURE__*/ (0, $i3UfC.jsx)("ul", {
                children: /*#__PURE__*/ (0, $i3UfC.jsx)("li", {
                    children: /*#__PURE__*/ (0, $i3UfC.jsx)((0, $bgNpv.default), {
                        ...$8f871dd6cee178f3$var$messages.agreementBulletTwo,
                        values: {
                            privacyPolicyLink: $8f871dd6cee178f3$var$privacyPolicyLink,
                            termsOfUseLink: $8f871dd6cee178f3$var$termsOfUseLink
                        }
                    })
                })
            })
        ]
    });
};
var $8f871dd6cee178f3$export$2e2bcd8739ae039 = $8f871dd6cee178f3$var$LegalDisclaimer;


/**
 * Spacer reserving bottom space so the (fixed) bar never overlaps content.
 * Rendered at the end of the content column.
 */ const $73c177df4a6f11ed$var$spacerStyle = (0, $gDiFE.xcss)({
    height: 'space.800',
    flexShrink: 0
});
const $73c177df4a6f11ed$var$stickyBarStyle = (0, $gDiFE.xcss)({
    position: 'fixed',
    bottom: 'space.0',
    left: 'space.0',
    zIndex: 'navigation',
    width: '100%',
    boxSizing: 'border-box',
    flexShrink: 0,
    borderTopWidth: 'border.width',
    borderTopStyle: 'solid',
    borderTopColor: 'color.border',
    backgroundColor: 'elevation.surface',
    paddingInline: 'space.400',
    paddingBlock: 'space.200'
});
const $73c177df4a6f11ed$var$legalSlotStyle = (0, $gDiFE.xcss)({
    flex: '1 1 240px',
    minWidth: '0'
});
const $73c177df4a6f11ed$var$actionsSlotStyle = (0, $gDiFE.xcss)({
    flexShrink: 0
});
const $73c177df4a6f11ed$export$1a5761776df0ebd0 = ()=>/*#__PURE__*/ (0, $i3UfC.jsx)((0, $383dd904a5a5e5b0$export$e71c4d32a2263218), {
        xcss: $73c177df4a6f11ed$var$spacerStyle,
        "aria-hidden": "true"
    });
const $73c177df4a6f11ed$var$RovoStickyFooter = ({ acceptDisabled: acceptDisabled })=>/*#__PURE__*/ (0, $i3UfC.jsx)((0, $383dd904a5a5e5b0$export$e71c4d32a2263218), {
        xcss: $73c177df4a6f11ed$var$stickyBarStyle,
        children: /*#__PURE__*/ (0, $i3UfC.jsxs)((0, $10b0af967ce59e29$export$fbae5b5ffd8af05e), {
            alignBlock: "center",
            spread: "space-between",
            space: "space.400",
            shouldWrap: true,
            children: [
                /*#__PURE__*/ (0, $i3UfC.jsx)((0, $383dd904a5a5e5b0$export$e71c4d32a2263218), {
                    xcss: $73c177df4a6f11ed$var$legalSlotStyle,
                    children: /*#__PURE__*/ (0, $i3UfC.jsx)((0, $8f871dd6cee178f3$export$2e2bcd8739ae039), {
                        variant: "inline"
                    })
                }),
                /*#__PURE__*/ (0, $i3UfC.jsx)((0, $383dd904a5a5e5b0$export$e71c4d32a2263218), {
                    xcss: $73c177df4a6f11ed$var$actionsSlotStyle,
                    children: /*#__PURE__*/ (0, $i3UfC.jsx)((0, $effc8a355c6ced2f$export$2e2bcd8739ae039), {
                        acceptDisabled: acceptDisabled,
                        embedded: true,
                        reverseOrder: true
                    })
                })
            ]
        })
    });
var $73c177df4a6f11ed$export$2e2bcd8739ae039 = $73c177df4a6f11ed$var$RovoStickyFooter;



var $5FkrB = parcelRequire("5FkrB");

var $2gmBL = parcelRequire("2gmBL");

var $9KGFe = parcelRequire("9KGFe");

var $leM9a = parcelRequire("leM9a");

var $6hgMx = parcelRequire("6hgMx");
const $23c70906ecb46dc2$var$ROVO_SUCCESS_REDIRECT_DELAY_MS = 5000;
const $23c70906ecb46dc2$var$ROVO_SUCCESS_PATH = '/security/dagterminal';
function $23c70906ecb46dc2$export$330ddd5309317e2f(callback) {
    if (!callback) return false;
    try {
        return new URL(callback).protocol === 'rovo-desktop:';
    } catch  {
        return false;
    }
}
const $23c70906ecb46dc2$export$146af1380ebe4bec = ()=>{
    const consentContext = (0, $5FkrB.useContext)((0, $6hgMx.ReactConsentContext));
    const callback = consentContext?.token?.redirectUrl?.callback;
    const enabled = (0, $2gmBL.useFeatureGate)((0, $leM9a.OAuthConsentFeatureGate).ROVO_SUCCESS_REDIRECT);
    return (0, $5FkrB.useCallback)((event)=>{
        const submitter = event.nativeEvent.submitter;
        const callbackMatched = $23c70906ecb46dc2$export$330ddd5309317e2f(callback);
        const accepted = submitter?.value === 'accept';
        const redirectScheduled = enabled && callbackMatched && accepted;
        const destination = `${(0, $9KGFe.getConfig)().identity.baseUrl}${$23c70906ecb46dc2$var$ROVO_SUCCESS_PATH}`;
        if (!redirectScheduled) return;
        // Do not prevent the POST: its redirect launches the native Rovo app.
        setTimeout(()=>window.location.assign(destination), $23c70906ecb46dc2$var$ROVO_SUCCESS_REDIRECT_DELAY_MS);
    }, [
        callback,
        enabled
    ]);
};


const $714031d53816db81$var$RovoConsentLayout = ()=>{
    const consentContext = (0, $5FkrB.useContext)((0, $6hgMx.ReactConsentContext));
    const handleSuccessRedirect = (0, $23c70906ecb46dc2$export$146af1380ebe4bec)();
    return /*#__PURE__*/ (0, $i3UfC.jsx)((0, $383dd904a5a5e5b0$export$e71c4d32a2263218), {
        as: "main",
        xcss: (0, $6hgMx.narrowConsentContentStyle),
        children: /*#__PURE__*/ (0, $i3UfC.jsxs)((0, $ad526930cc57d7e6$export$2e2bcd8739ae039), {
            onSubmit: handleSuccessRedirect,
            children: [
                /*#__PURE__*/ (0, $i3UfC.jsx)((0, $a7b07bd5558ad8bf$export$2e2bcd8739ae039), {}),
                /*#__PURE__*/ (0, $i3UfC.jsx)((0, $73c177df4a6f11ed$export$1a5761776df0ebd0), {}),
                /*#__PURE__*/ (0, $i3UfC.jsx)((0, $73c177df4a6f11ed$export$2e2bcd8739ae039), {
                    acceptDisabled: consentContext?.acceptDisabled
                })
            ]
        })
    });
};
var $714031d53816db81$export$2e2bcd8739ae039 = $714031d53816db81$var$RovoConsentLayout;




var $6hgMx = parcelRequire("6hgMx");
/**
 * Renders consent chrome: `<main>` is always the direct child of page `Content`
 * (same as pre-MCP-redesign), then `<form>`, so the layouts that go through
 * MainContent are unchanged.
 *
 * MCP, TWG and Rovo return ahead of that chrome and own their whole layout —
 * their own form and footer, and for MCP its own context providers too — as
 * their styling differs greatly from the other consent flows. Every other
 * service type is dispatched by MainContent inside the shared chrome.
 */ const $0e3ee9c77d0b46e6$var$ConsentLayout = ()=>{
    const { serviceType: serviceType } = (0, $6hgMx.useToken)();
    const consentContext = (0, $5FkrB.useContext)((0, $6hgMx.ReactConsentContext));
    if (serviceType === 'MCP') return /*#__PURE__*/ (0, $i3UfC.jsx)((0, $2056e60c7b716f00$export$2e2bcd8739ae039), {});
    if (serviceType === 'TWG') return /*#__PURE__*/ (0, $i3UfC.jsx)((0, $e761d8251e15a6c2$export$2e2bcd8739ae039), {});
    if (serviceType === 'Rovo') return /*#__PURE__*/ (0, $i3UfC.jsx)((0, $714031d53816db81$export$2e2bcd8739ae039), {});
    return /*#__PURE__*/ (0, $i3UfC.jsx)((0, $383dd904a5a5e5b0$export$e71c4d32a2263218), {
        as: "main",
        xcss: (0, $6hgMx.narrowConsentContentStyle),
        children: /*#__PURE__*/ (0, $i3UfC.jsxs)((0, $ad526930cc57d7e6$export$2e2bcd8739ae039), {
            action: serviceType === 'DAG' ? '/oauth/activate' : undefined,
            children: [
                /*#__PURE__*/ (0, $i3UfC.jsx)((0, $a7b07bd5558ad8bf$export$2e2bcd8739ae039), {}),
                /*#__PURE__*/ (0, $i3UfC.jsx)((0, $effc8a355c6ced2f$export$2e2bcd8739ae039), {
                    acceptDisabled: consentContext?.acceptDisabled
                })
            ]
        })
    });
};
var $0e3ee9c77d0b46e6$export$2e2bcd8739ae039 = $0e3ee9c77d0b46e6$var$ConsentLayout;



var $i3UfC = parcelRequire("i3UfC");

var $gDiFE = parcelRequire("gDiFE");
const $abc2d3ba24694c46$var$style = (0, $gDiFE.xcss)({
    height: '100vh'
});
const $abc2d3ba24694c46$var$Loading = ()=>/*#__PURE__*/ (0, $i3UfC.jsx)((0, $1b254ba6a068f2f1$export$f51f4c4ede09e011), {
        xcss: $abc2d3ba24694c46$var$style,
        alignItems: "center",
        justifyContent: "center",
        children: /*#__PURE__*/ (0, $i3UfC.jsx)("div", {})
    });
var $abc2d3ba24694c46$export$2e2bcd8739ae039 = $abc2d3ba24694c46$var$Loading;



var $guDjK = parcelRequire("guDjK");

var $i3UfC = parcelRequire("i3UfC");

var $5FkrB = parcelRequire("5FkrB");

var $ArAzU = parcelRequire("ArAzU");

var $i3UfC = parcelRequire("i3UfC");

var $6bnW7 = parcelRequire("6bnW7");
var $hrVKU = parcelRequire("hrVKU");

var $i3UfC = parcelRequire("i3UfC");

var $6bnW7 = parcelRequire("6bnW7");
var $bgNpv = parcelRequire("bgNpv");






const $6d04ecc02ef1e8d0$var$errorMessages = (0, $6bnW7.defineMessages)({
    noSitesHeading: {
        id: 'error.noSites.heading',
        defaultMessage: 'Access denied!',
        description: 'Error message heading denoting that access to the site has been denied'
    },
    noSitesDescription: {
        id: 'error.noSites.description',
        defaultMessage: "This app requires access to a {product} site which you don't have or don't have the permission to access",
        description: "The app needs access to a (Confluence/Jira) site but the user doesn't have access to any"
    },
    noSitesFooter1: {
        id: 'error.noSites.footer1',
        defaultMessage: 'Visit {link} to create a site.',
        description: 'Visit the link to create a new (Confluence/Jira) site so that the app can be installed onto a confluence site'
    },
    noSitesFooter2: {
        id: 'error.noSites.footer2',
        defaultMessage: "Something's not right? <link>Raise a support request</link>",
        description: "The user should raise a support request if they did not understand why they're being shown this error"
    }
});
const $6d04ecc02ef1e8d0$var$NoSitesErrorPage = ({ product: product })=>/*#__PURE__*/ (0, $i3UfC.jsxs)((0, $c8dbef6c41cfa689$export$694e0d28c7ffc90c), {
        alignInline: 'center',
        space: 'space.100',
        children: [
            /*#__PURE__*/ (0, $i3UfC.jsx)((0, $2eb42266ae7fc1da$export$2e2bcd8739ae039), {
                style: (0, $cc7e4bfda48b98b0$export$eaca28ca1e4ffef7),
                src: (0, (/*@__PURE__*/$parcel$interopDefault($c54a367501889f55$exports))),
                alt: "error image"
            }),
            /*#__PURE__*/ (0, $i3UfC.jsx)((0, $82315a19372f332f$export$2e2bcd8739ae039), {
                size: 'large',
                children: /*#__PURE__*/ (0, $i3UfC.jsx)((0, $bgNpv.default), {
                    ...$6d04ecc02ef1e8d0$var$errorMessages.noSitesHeading
                })
            }),
            /*#__PURE__*/ (0, $i3UfC.jsx)((0, $d48daa9a522ca942$export$5f1af8db9871e1d6), {
                align: 'center',
                children: /*#__PURE__*/ (0, $i3UfC.jsx)((0, $bgNpv.default), {
                    ...$6d04ecc02ef1e8d0$var$errorMessages.noSitesDescription,
                    values: {
                        product: product
                    }
                })
            }),
            /*#__PURE__*/ (0, $i3UfC.jsx)((0, $d48daa9a522ca942$export$5f1af8db9871e1d6), {
                align: 'center',
                children: /*#__PURE__*/ (0, $i3UfC.jsx)((0, $bgNpv.default), {
                    ...$6d04ecc02ef1e8d0$var$errorMessages.noSitesFooter1,
                    values: {
                        link: /*#__PURE__*/ (0, $i3UfC.jsx)((0, $64e95b69a05329e9$export$2e2bcd8739ae039), {
                            href: 'https://www.atlassian.com',
                            children: "https://www.atlassian.com"
                        })
                    }
                })
            }),
            /*#__PURE__*/ (0, $i3UfC.jsx)((0, $d48daa9a522ca942$export$5f1af8db9871e1d6), {
                align: 'center',
                children: /*#__PURE__*/ (0, $i3UfC.jsx)((0, $bgNpv.default), {
                    ...$6d04ecc02ef1e8d0$var$errorMessages.noSitesFooter2,
                    values: {
                        link: (text)=>/*#__PURE__*/ (0, $i3UfC.jsx)((0, $64e95b69a05329e9$export$2e2bcd8739ae039), {
                                href: (0, $cc7e4bfda48b98b0$export$2b5a5f1efe80791e),
                                children: text
                            })
                    }
                })
            })
        ]
    });
var $6d04ecc02ef1e8d0$export$2e2bcd8739ae039 = $6d04ecc02ef1e8d0$var$NoSitesErrorPage;



var $i3UfC = parcelRequire("i3UfC");

var $6bnW7 = parcelRequire("6bnW7");
var $bgNpv = parcelRequire("bgNpv");



var $44379d270d1b0869$exports = {};
$44379d270d1b0869$exports = new URL("lock.10ed9279.svg", import.meta.url).toString();



const $b7e051fde4ff0dff$var$errorMessages = (0, $6bnW7.defineMessages)({
    noAccessHeading: {
        id: 'error.noAccess.heading',
        defaultMessage: "You don't have access to this app.",
        description: 'The user does not have permissions to use this app'
    },
    noAccessDescription: {
        id: 'error.noAccess.description',
        defaultMessage: 'This application is in development - only the owner of this application may grant it access to their account',
        description: 'The user does not have permissions to use this app. Only the owner / developer of this application is able to give access to accounts.'
    }
});
const $b7e051fde4ff0dff$var$NoAccessErrorPage = ()=>/*#__PURE__*/ (0, $i3UfC.jsxs)((0, $c8dbef6c41cfa689$export$694e0d28c7ffc90c), {
        alignInline: 'center',
        space: 'space.100',
        children: [
            /*#__PURE__*/ (0, $i3UfC.jsx)((0, $2eb42266ae7fc1da$export$2e2bcd8739ae039), {
                style: (0, $cc7e4bfda48b98b0$export$eaca28ca1e4ffef7),
                src: (0, (/*@__PURE__*/$parcel$interopDefault($44379d270d1b0869$exports))),
                alt: "lock image"
            }),
            /*#__PURE__*/ (0, $i3UfC.jsx)((0, $82315a19372f332f$export$2e2bcd8739ae039), {
                size: 'large',
                children: "You don't have access to this app."
            }),
            /*#__PURE__*/ (0, $i3UfC.jsx)((0, $d48daa9a522ca942$export$5f1af8db9871e1d6), {
                align: 'center',
                color: 'color.text.accent.gray',
                children: /*#__PURE__*/ (0, $i3UfC.jsx)((0, $bgNpv.default), {
                    ...$b7e051fde4ff0dff$var$errorMessages.noAccessDescription
                })
            })
        ]
    });
var $b7e051fde4ff0dff$export$2e2bcd8739ae039 = $b7e051fde4ff0dff$var$NoAccessErrorPage;



var $i3UfC = parcelRequire("i3UfC");

var $6bnW7 = parcelRequire("6bnW7");
var $bgNpv = parcelRequire("bgNpv");






const $212dda4d9b05d015$var$errorMessages = (0, $6bnW7.defineMessages)({
    genericHeading: {
        id: 'error.generic.heading',
        defaultMessage: 'Something went wrong',
        description: 'Vague error message that an issue occurred'
    },
    genericFooter: {
        id: 'error.generic.footer',
        defaultMessage: 'Raise a support request',
        description: 'User should raise a support request'
    },
    genericErrorInformation: {
        id: 'error.generic.information',
        defaultMessage: 'INFORMATION FOR THE OWNER OF {client}'
    }
});
const $212dda4d9b05d015$var$GenericErrorPage = ({ clientName: clientName, description: description })=>{
    const descriptionElement = ()=>{
        if (typeof description === 'string') return description;
        if (description == null) return /*#__PURE__*/ (0, $i3UfC.jsx)((0, $i3UfC.Fragment), {});
        if ($212dda4d9b05d015$var$isMessageDescriptor(description)) return /*#__PURE__*/ (0, $i3UfC.jsx)((0, $bgNpv.default), {
            ...description
        });
        return description;
    };
    return /*#__PURE__*/ (0, $i3UfC.jsxs)((0, $c8dbef6c41cfa689$export$694e0d28c7ffc90c), {
        alignInline: 'center',
        space: 'space.600',
        children: [
            /*#__PURE__*/ (0, $i3UfC.jsxs)((0, $c8dbef6c41cfa689$export$694e0d28c7ffc90c), {
                alignInline: 'center',
                space: 'space.100',
                children: [
                    /*#__PURE__*/ (0, $i3UfC.jsx)((0, $2eb42266ae7fc1da$export$2e2bcd8739ae039), {
                        style: (0, $cc7e4bfda48b98b0$export$eaca28ca1e4ffef7),
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($c54a367501889f55$exports))),
                        alt: "error image"
                    }),
                    /*#__PURE__*/ (0, $i3UfC.jsx)((0, $82315a19372f332f$export$2e2bcd8739ae039), {
                        size: 'large',
                        children: /*#__PURE__*/ (0, $i3UfC.jsx)((0, $bgNpv.default), {
                            ...$212dda4d9b05d015$var$errorMessages.genericHeading
                        })
                    }),
                    /*#__PURE__*/ (0, $i3UfC.jsx)((0, $64e95b69a05329e9$export$2e2bcd8739ae039), {
                        href: (0, $cc7e4bfda48b98b0$export$2b5a5f1efe80791e),
                        children: /*#__PURE__*/ (0, $i3UfC.jsx)((0, $bgNpv.default), {
                            ...$212dda4d9b05d015$var$errorMessages.genericFooter
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $i3UfC.jsxs)((0, $c8dbef6c41cfa689$export$694e0d28c7ffc90c), {
                space: 'space.150',
                children: [
                    clientName && /*#__PURE__*/ (0, $i3UfC.jsx)((0, $d48daa9a522ca942$export$5f1af8db9871e1d6), {
                        weight: "bold",
                        children: /*#__PURE__*/ (0, $i3UfC.jsx)((0, $bgNpv.default), {
                            ...$212dda4d9b05d015$var$errorMessages.genericErrorInformation,
                            values: {
                                client: clientName.toUpperCase()
                            }
                        })
                    }),
                    /*#__PURE__*/ (0, $i3UfC.jsx)((0, $d48daa9a522ca942$export$5f1af8db9871e1d6), {
                        children: descriptionElement()
                    })
                ]
            })
        ]
    });
};
function $212dda4d9b05d015$var$isMessageDescriptor(val) {
    return val && typeof val === 'object' && val.id && val.defaultMessage;
}
var $212dda4d9b05d015$export$2e2bcd8739ae039 = $212dda4d9b05d015$var$GenericErrorPage;



var $gDiFE = parcelRequire("gDiFE");

const $cc7e4bfda48b98b0$var$contentStyle = (0, $gDiFE.xcss)({
    paddingTop: 'space.400',
    margin: '0 auto',
    maxWidth: '550px'
});
const $cc7e4bfda48b98b0$var$ErrorPage = ({ error: error })=>{
    const { formatMessage: formatMessage, formatList: formatList } = (0, $hrVKU.default)();
    console.error('Caught error', error);
    if (!$cc7e4bfda48b98b0$var$isError(error)) {
        console.error('This error cannot be handled by the error page', error);
        throw error;
    }
    const determineErrorPage = ()=>{
        switch(error.error){
            case 'no-sites':
                return /*#__PURE__*/ (0, $i3UfC.jsx)((0, $6d04ecc02ef1e8d0$export$2e2bcd8739ae039), {
                    ...error
                });
            case 'no-access':
                return /*#__PURE__*/ (0, $i3UfC.jsx)((0, $b7e051fde4ff0dff$export$2e2bcd8739ae039), {
                    ...error
                });
            case 'unauthorized-scopes':
                return /*#__PURE__*/ (0, $i3UfC.jsx)((0, $212dda4d9b05d015$export$2e2bcd8739ae039), {
                    ...error,
                    description: formatMessage($cc7e4bfda48b98b0$var$errorMessages.unauthorizedScopesDescription, {
                        scopes: formatList(error.scopes, {
                            type: 'conjunction'
                        }),
                        products: formatList(error.products, {
                            type: 'conjunction'
                        }),
                        link: /*#__PURE__*/ (0, $i3UfC.jsx)($cc7e4bfda48b98b0$var$ConsoleLink, {
                            error: error
                        })
                    })
                });
            case 'no-scopes':
                return /*#__PURE__*/ (0, $i3UfC.jsx)((0, $212dda4d9b05d015$export$2e2bcd8739ae039), {
                    ...error,
                    description: formatMessage($cc7e4bfda48b98b0$var$errorMessages.noScopesDescription)
                });
            case 'unexpected':
                return /*#__PURE__*/ (0, $i3UfC.jsx)((0, $212dda4d9b05d015$export$2e2bcd8739ae039), {
                    ...error
                });
            default:
                console.error('Unexpected error type', error);
                throw error;
        }
    };
    return /*#__PURE__*/ (0, $i3UfC.jsx)((0, $383dd904a5a5e5b0$export$e71c4d32a2263218), {
        xcss: $cc7e4bfda48b98b0$var$contentStyle,
        children: determineErrorPage()
    });
};
function $cc7e4bfda48b98b0$var$isError(error) {
    // If error is not null/undefined, is an object, and has an "error" field string
    return error && typeof error === 'object' && typeof error.error === 'string';
}
const $cc7e4bfda48b98b0$export$eaca28ca1e4ffef7 = {
    width: '100%',
    maxHeight: '300px'
};
const $cc7e4bfda48b98b0$var$errorMessages = (0, $6bnW7.defineMessages)({
    unauthorizedScopesDescription: {
        id: 'error.unauthorizedScopes.description',
        defaultMessage: 'This app has requested {products} scopes that have not been added to the app. Configure the app at {link} and add the following scopes to the app: {scopes}.',
        description: 'The app is requesting {scopes} for the {products} listed that have not been added to the app by the developer.'
    },
    noScopesDescription: {
        id: 'error.noScopes.description',
        defaultMessage: 'This app has not requested any supported Atlassian scopes. Check the authorization URL for your app and ensure that it includes valid scopes.',
        description: "This app has either requested no scopes or all the scopes they have requested aren't valid scopes. One potential cause is the authorization URL used by the app doesn't have valid scopes in the scopes field."
    }
});
const $cc7e4bfda48b98b0$export$2b5a5f1efe80791e = 'https://support.atlassian.com/contact';
const $cc7e4bfda48b98b0$var$ConsoleLink = ({ error: error })=>{
    const link = error.products.length === 1 && 'trello' === error.products.at(0)?.toLowerCase() ? $cc7e4bfda48b98b0$var$getTrelloLink() : $cc7e4bfda48b98b0$export$f3c3ab2a5814281;
    return /*#__PURE__*/ (0, $i3UfC.jsx)((0, $64e95b69a05329e9$export$2e2bcd8739ae039), {
        href: link,
        children: link
    });
};
const $cc7e4bfda48b98b0$export$f3c3ab2a5814281 = 'https://developer.atlassian.com/apps';
const $cc7e4bfda48b98b0$var$getTrelloLink = ()=>{
    return 'https://trello.com/apps/admin';
};
var $cc7e4bfda48b98b0$export$2e2bcd8739ae039 = $cc7e4bfda48b98b0$var$ErrorPage;



var $guDjK = parcelRequire("guDjK");

var $3VQxn = parcelRequire("3VQxn");
const $063a78bab069f1c1$var$JWT_VALIDATION_ERRORS = [
    (0, $3VQxn.ExpiredContextTokenError),
    (0, $3VQxn.InvalidContextToken)
];
const $063a78bab069f1c1$var$Boundary = ({ children: children })=>{
    const analytics = (0, $guDjK.useAnalytics)();
    const errorHandler = (0, $5FkrB.useCallback)((error)=>{
        const failure = $063a78bab069f1c1$var$createFailureEvent(error);
        if (failure) analytics.sendErrorEvent(failure);
    }, [
        analytics
    ]);
    return /*#__PURE__*/ (0, $i3UfC.jsx)((0, $ArAzU.ErrorBoundary), {
        fallbackRender: (props)=>/*#__PURE__*/ (0, $i3UfC.jsx)((0, $cc7e4bfda48b98b0$export$2e2bcd8739ae039), {
                ...props
            }),
        onError: errorHandler,
        children: children
    });
};
function $063a78bab069f1c1$var$createFailureEvent(error) {
    if ((0, $3VQxn.isError)(error)) switch(error.error){
        case 'unexpected':
            // Handle jwt validation errors from the consent token
            if ($063a78bab069f1c1$var$JWT_VALIDATION_ERRORS.includes(error)) return 'jwtValidationError';
            break;
        case 'unauthorized-scopes':
        case 'no-scopes':
            return 'infoInputValidationError';
        // Unused errors
        case 'no-access':
        case 'no-sites':
            break;
        default:
            // Ensures all Errors variants are covered
            return error;
    }
    // Handle unexpected http errors
    if (error instanceof (0, $3VQxn.HttpError)) {
        if (400 <= error.status && error.status < 500) return 'remote4xxError';
        if (500 <= error.status && error.status < 600) return 'remote5xxError';
    }
    return 'other';
}
var $063a78bab069f1c1$export$2e2bcd8739ae039 = $063a78bab069f1c1$var$Boundary;



var $i3UfC = parcelRequire("i3UfC");

var $5FkrB = parcelRequire("5FkrB");

var $9Pk7k = parcelRequire("9Pk7k");

var $f5RPY = parcelRequire("f5RPY");
function $c416c85ddfb75237$export$2e2bcd8739ae039({ children: children }) {
    const [locale, messages] = $c416c85ddfb75237$var$useTranslation();
    return /*#__PURE__*/ (0, $i3UfC.jsx)((0, $9Pk7k.default), {
        defaultLocale: 'en',
        locale: locale,
        messages: messages,
        children: children
    }, locale);
}
function $c416c85ddfb75237$var$useTranslation() {
    const user = (0, $f5RPY.useUser)();
    const [locale, setLocale] = (0, $5FkrB.useState)('en');
    const [messages, setMessages] = (0, $5FkrB.useState)({});
    (0, $5FkrB.useEffect)(()=>{
        const newLocale = user?.locale;
        if (newLocale) $c416c85ddfb75237$var$fetchLanguages(newLocale).then((msg)=>{
            if (msg != null) {
                setMessages(msg);
                setLocale(newLocale);
            } else console.warn('No locale messages found.');
        });
    }, [
        user
    ]);
    return [
        locale,
        messages
    ];
}
async function $c416c85ddfb75237$var$fetchLanguages(locale) {
    try {
        const messages = await $c416c85ddfb75237$var$languageMap[locale]?.();
        if (messages?.default != null) return messages.default;
        return messages;
    } catch (err) {
        console.error(err);
        return null;
    }
}
























const $c416c85ddfb75237$var$languageMap = $c416c85ddfb75237$var$accommodateShortenedLocales({
    'cs-CZ': ()=>(parcelRequire("lRhHj")),
    'da-DK': ()=>(parcelRequire("bvGJV")),
    'de-DE': ()=>(parcelRequire("jae7A")),
    'en-GB': ()=>(parcelRequire("hoPPq")),
    'en-ZZ': ()=>(parcelRequire("dQrN2")),
    es: ()=>(parcelRequire("8aMe7")),
    'fi-FI': ()=>(parcelRequire("dQ0Ca")),
    'fr-FR': ()=>(parcelRequire("90MIr")),
    'hu-HU': ()=>(parcelRequire("8WJXk")),
    'it-IT': ()=>(parcelRequire("d9nPO")),
    'ja-JP': ()=>(parcelRequire("jj0xI")),
    'ko-KR': ()=>(parcelRequire("324GR")),
    'nb-NO': ()=>(parcelRequire("71S74")),
    'nl-NL': ()=>(parcelRequire("jlXqg")),
    'pl-PL': ()=>(parcelRequire("4e5mi")),
    'pt-BR': ()=>(parcelRequire("e4wiJ")),
    'ru-RU': ()=>(parcelRequire("ieemf")),
    'sv-SE': ()=>(parcelRequire("7xzx8")),
    'th-TH': ()=>(parcelRequire("6n0r0")),
    'tr-TR': ()=>(parcelRequire("9nX3d")),
    'uk-UA': ()=>(parcelRequire("7Viz1")),
    'vi-VN': ()=>(parcelRequire("AOvE8")),
    'zh-CN': ()=>(parcelRequire("3rjyv")),
    'zh-TW': ()=>(parcelRequire("jBcYC"))
});
function $c416c85ddfb75237$var$accommodateShortenedLocales(map) {
    return Object.fromEntries(Object.entries(map).flatMap(([localeKey, loader])=>{
        if (localeKey.length <= 2) return [
            [
                localeKey,
                loader
            ]
        ];
        return [
            localeKey,
            localeKey.substring(0, 2)
        ].map((k)=>[
                k,
                loader
            ]);
    }));
}



var $i3UfC = parcelRequire("i3UfC");

var $5T6u3 = parcelRequire("5T6u3");

var $5FkrB = parcelRequire("5FkrB");

function $de866f59adb9a0f9$export$93b27837988a39ef({ children: children }) {
    const environment = (0, $5FkrB.useMemo)((0, $e9034d91cf7487a7$export$57570b1603cf6adb), []);
    return /*#__PURE__*/ (0, $i3UfC.jsx)((0, $i3UfC.Fragment), {
        children: /*#__PURE__*/ (0, $i3UfC.jsx)((0, $5T6u3.RelayEnvironmentProvider), {
            environment: environment,
            children: children
        })
    });
}



var $i3UfC = parcelRequire("i3UfC");

var $5FkrB = parcelRequire("5FkrB");
function $13e0c287295853a9$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $13e0c287295853a9$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $13e0c287295853a9$export$2e2bcd8739ae039(o);
}



function $13ae1b9823870439$export$2e2bcd8739ae039(t, r) {
    if ("object" != (0, $13e0c287295853a9$export$2e2bcd8739ae039)(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (0, $13e0c287295853a9$export$2e2bcd8739ae039)(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}


function $021989bb175f3c6e$export$2e2bcd8739ae039(t) {
    var i = (0, $13ae1b9823870439$export$2e2bcd8739ae039)(t, "string");
    return "symbol" == (0, $13e0c287295853a9$export$2e2bcd8739ae039)(i) ? i : i + "";
}


function $6fbeb86b9c32bffe$export$2e2bcd8739ae039(e, r, t) {
    return (r = (0, $021989bb175f3c6e$export$2e2bcd8739ae039)(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}


function $9ccdc4f4f7ddb8cb$var$asyncGeneratorStep(n, t, e, r, o, a, c) {
    try {
        var i = n[a](c), u = i.value;
    } catch (n) {
        return void e(n);
    }
    i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function $9ccdc4f4f7ddb8cb$export$2e2bcd8739ae039(n) {
    return function() {
        var t = this, e = arguments;
        return new Promise(function(r, o) {
            var a = n.apply(t, e);
            function _next(n) {
                $9ccdc4f4f7ddb8cb$var$asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
            }
            function _throw(n) {
                $9ccdc4f4f7ddb8cb$var$asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
            }
            _next(void 0);
        });
    };
}


function $7b8cfc107c5bc2b0$export$2e2bcd8739ae039(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}



function $b06466c6dea794c2$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, (0, $021989bb175f3c6e$export$2e2bcd8739ae039)(o.key), o);
    }
}
function $b06466c6dea794c2$export$2e2bcd8739ae039(e, r, t) {
    return r && $b06466c6dea794c2$var$_defineProperties(e.prototype, r), t && $b06466c6dea794c2$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}


var $02f82983ae119447$exports = {};
// TODO(Babel 8): Remove this file.

var $02f82983ae119447$var$runtime = (parcelRequire("dtahh"))();
$02f82983ae119447$exports = $02f82983ae119447$var$runtime;
// Copied from https://github.com/facebook/regenerator/blob/main/packages/runtime/runtime.js#L736=
try {
    regeneratorRuntime = $02f82983ae119447$var$runtime;
} catch (accidentalStrictMode) {
    if (typeof globalThis === "object") globalThis.regeneratorRuntime = $02f82983ae119447$var$runtime;
    else Function("r", "regeneratorRuntime = r")($02f82983ae119447$var$runtime);
}


function $2da734712dc84784$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $2da734712dc84784$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $2da734712dc84784$export$2e2bcd8739ae039(o);
}



function $c852d82cf45f6301$export$2e2bcd8739ae039(t, r) {
    if ("object" != (0, $2da734712dc84784$export$2e2bcd8739ae039)(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (0, $2da734712dc84784$export$2e2bcd8739ae039)(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}


function $0a2160655c25d713$export$2e2bcd8739ae039(t) {
    var i = (0, $c852d82cf45f6301$export$2e2bcd8739ae039)(t, "string");
    return "symbol" == (0, $2da734712dc84784$export$2e2bcd8739ae039)(i) ? i : i + "";
}


function $72205d778ee1fb85$export$2e2bcd8739ae039(e, r, t) {
    return (r = (0, $0a2160655c25d713$export$2e2bcd8739ae039)(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}


function $6e21bf621ac7ad52$var$asyncGeneratorStep(n, t, e, r, o, a, c) {
    try {
        var i = n[a](c), u = i.value;
    } catch (n) {
        return void e(n);
    }
    i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function $6e21bf621ac7ad52$export$2e2bcd8739ae039(n) {
    return function() {
        var t = this, e = arguments;
        return new Promise(function(r, o) {
            var a = n.apply(t, e);
            function _next(n) {
                $6e21bf621ac7ad52$var$asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
            }
            function _throw(n) {
                $6e21bf621ac7ad52$var$asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
            }
            _next(void 0);
        });
    };
}


function $f358eeefd21515b7$export$2e2bcd8739ae039(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}



function $d94ce7ec976e4305$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, (0, $0a2160655c25d713$export$2e2bcd8739ae039)(o.key), o);
    }
}
function $d94ce7ec976e4305$export$2e2bcd8739ae039(e, r, t) {
    return r && $d94ce7ec976e4305$var$_defineProperties(e.prototype, r), t && $d94ce7ec976e4305$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}


var $0d38c5f26e39e050$exports = {};
// TODO(Babel 8): Remove this file.

var $0d38c5f26e39e050$var$runtime = (parcelRequire("f3AnC"))();
$0d38c5f26e39e050$exports = $0d38c5f26e39e050$var$runtime;
// Copied from https://github.com/facebook/regenerator/blob/main/packages/runtime/runtime.js#L736=
try {
    regeneratorRuntime = $0d38c5f26e39e050$var$runtime;
} catch (accidentalStrictMode) {
    if (typeof globalThis === "object") globalThis.regeneratorRuntime = $0d38c5f26e39e050$var$runtime;
    else Function("r", "regeneratorRuntime = r")($0d38c5f26e39e050$var$runtime);
}


/**
 * The identifiers for the user. Options are restricted to the set that is currently supported.
 */ /**
 * Base client options. Does not include any options specific to providers
 * @interface BaseClientOptions
 * @property {FeatureGateEnvironment} environment - The environment for the client.
 * @property {string} targetApp - The target app for the client.
 * @property {AnalyticsWebClient} analyticsWebClient - The analytics web client.
 * @property {PerimeterType} perimeter - The perimeter for the client.
 */ /**
 * The options for the client.
 * @interface ClientOptions
 * @extends {BaseClientOptions}
 * @property {string} apiKey - The API key for the client.
 * @property {fetchTimeoutMs} fetchTimeoutMs - The timeout for the fetch request in milliseconds. Defaults to 5000.
 * @property {boolean} useGatewayURL - Whether to use the gateway URL. Defaults to false.
 */ /**
 * The custom attributes for the user.
 */ var $07780b184f7941e6$export$479e7351a733299 = {
    Development: 'development',
    Staging: 'staging',
    Production: 'production'
};
var $07780b184f7941e6$export$c42b7bbc5e7ba555 = {
    COMMERCIAL: 'commercial',
    FEDRAMP_MODERATE: 'fedramp-moderate'
};
var $07780b184f7941e6$export$42f4885608027d0c = 'non_boolean'; // Type magic to get the JSDoc comments from the Client class methods to appear on the static
 // methods in FeatureGates where the property name and function type are identical





function $b2255f44c7627e82$export$2e2bcd8739ae039(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
}


function $02437115e5edc55a$export$2e2bcd8739ae039(t, e) {
    if (e && ("object" == (0, $2da734712dc84784$export$2e2bcd8739ae039)(e) || "function" == typeof e)) return e;
    if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
    return (0, $b2255f44c7627e82$export$2e2bcd8739ae039)(t);
}


function $2611a19754405365$export$2e2bcd8739ae039(t) {
    return $2611a19754405365$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
        return t.__proto__ || Object.getPrototypeOf(t);
    }, $2611a19754405365$export$2e2bcd8739ae039(t);
}


function $732b0daff6e0788f$export$2e2bcd8739ae039(t, e) {
    return $732b0daff6e0788f$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, $732b0daff6e0788f$export$2e2bcd8739ae039(t, e);
}


function $3b57c88604b52261$export$2e2bcd8739ae039(t, e) {
    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
    t.prototype = Object.create(e && e.prototype, {
        constructor: {
            value: t,
            writable: !0,
            configurable: !0
        }
    }), Object.defineProperty(t, "prototype", {
        writable: !1
    }), e && (0, $732b0daff6e0788f$export$2e2bcd8739ae039)(t, e);
}




function $5eb4339e9c462dbf$export$2e2bcd8739ae039(t) {
    try {
        return -1 !== Function.toString.call(t).indexOf("[native code]");
    } catch (n) {
        return "function" == typeof t;
    }
}


function $1ff9c846a6977c29$export$2e2bcd8739ae039() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($1ff9c846a6977c29$export$2e2bcd8739ae039 = function _isNativeReflectConstruct() {
        return !!t;
    })();
}



function $9ac7956d8756dc23$export$2e2bcd8739ae039(t, e, r) {
    if ((0, $1ff9c846a6977c29$export$2e2bcd8739ae039)()) return Reflect.construct.apply(null, arguments);
    var o = [
        null
    ];
    o.push.apply(o, e);
    var p = new (t.bind.apply(t, o))();
    return r && (0, $732b0daff6e0788f$export$2e2bcd8739ae039)(p, r.prototype), p;
}


function $04517c5ead67483d$export$2e2bcd8739ae039(t) {
    var r = "function" == typeof Map ? new Map() : void 0;
    return $04517c5ead67483d$export$2e2bcd8739ae039 = function _wrapNativeSuper(t) {
        if (null === t || !(0, $5eb4339e9c462dbf$export$2e2bcd8739ae039)(t)) return t;
        if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function");
        if (void 0 !== r) {
            if (r.has(t)) return r.get(t);
            r.set(t, Wrapper);
        }
        function Wrapper() {
            return (0, $9ac7956d8756dc23$export$2e2bcd8739ae039)(t, arguments, (0, $2611a19754405365$export$2e2bcd8739ae039)(this).constructor);
        }
        return Wrapper.prototype = Object.create(t.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: !1,
                writable: !0,
                configurable: !0
            }
        }), (0, $732b0daff6e0788f$export$2e2bcd8739ae039)(Wrapper, t);
    }, $04517c5ead67483d$export$2e2bcd8739ae039(t);
}


function $bd02c8853b179d7f$var$_callSuper(t, o, e) {
    return o = (0, $2611a19754405365$export$2e2bcd8739ae039)(o), (0, $02437115e5edc55a$export$2e2bcd8739ae039)(t, $bd02c8853b179d7f$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, $2611a19754405365$export$2e2bcd8739ae039)(t).constructor) : o.apply(t, e));
}
function $bd02c8853b179d7f$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($bd02c8853b179d7f$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $bd02c8853b179d7f$export$286baf652d0b1206 = /*#__PURE__*/ function(_Error) {
    function ResponseError(message, status, body) {
        var _this;
        (0, $f358eeefd21515b7$export$2e2bcd8739ae039)(this, ResponseError);
        _this = $bd02c8853b179d7f$var$_callSuper(this, ResponseError, [
            message
        ]);
        _this._status = status;
        _this._body = body;
        return _this;
    }
    (0, $3b57c88604b52261$export$2e2bcd8739ae039)(ResponseError, _Error);
    return (0, $d94ce7ec976e4305$export$2e2bcd8739ae039)(ResponseError, [
        {
            key: "status",
            get: function get() {
                return this._status;
            }
        },
        {
            key: "body",
            get: function get() {
                return this._body;
            }
        }
    ]);
}(/*#__PURE__*/ (0, $04517c5ead67483d$export$2e2bcd8739ae039)(Error));


function $c9a5c48359ec9830$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $c9a5c48359ec9830$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $c9a5c48359ec9830$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $72205d778ee1fb85$export$2e2bcd8739ae039)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $c9a5c48359ec9830$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $c9a5c48359ec9830$var$DEFAULT_REQUEST_TIMEOUT_MS = 5000;
var $c9a5c48359ec9830$var$PROD_BASE_URL = 'https://api.atlassian.com/flags';
var $c9a5c48359ec9830$var$STAGING_BASE_URL = 'https://api.stg.atlassian.com/flags';
var $c9a5c48359ec9830$export$f058dbf75c3bc647 = 'https://api.dev.atlassian.com/flags';
var $c9a5c48359ec9830$export$1a401a0da8da3565 = 'https://api.stg.atlassian-us-gov-mod.com/flags';
var $c9a5c48359ec9830$export$18c93900db9358a4 = 'https://api.atlassian-us-gov-mod.com/flags';
var $c9a5c48359ec9830$export$450bd8fb2a6d7ace = '/gateway/api/flags';
var $c9a5c48359ec9830$export$1e164866fd37d1a9 = 'v2';
var $c9a5c48359ec9830$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function Fetcher() {
        (0, $f358eeefd21515b7$export$2e2bcd8739ae039)(this, Fetcher);
    }
    return (0, $d94ce7ec976e4305$export$2e2bcd8739ae039)(Fetcher, null, [
        {
            key: "fetchClientSdkKey",
            value: function() {
                var _fetchClientSdkKey = (0, $6e21bf621ac7ad52$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($0d38c5f26e39e050$exports))).mark(function _callee(clientVersion, fetcherOptions) {
                    var targetApp, url, _t;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($0d38c5f26e39e050$exports))).wrap(function(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                targetApp = fetcherOptions.targetApp;
                                url = "/api/v2/frontend/clientSdkKey/".concat(targetApp);
                                _context.prev = 1;
                                _context.next = 2;
                                return this.fetchRequest(clientVersion, url, 'GET', fetcherOptions);
                            case 2:
                                return _context.abrupt("return", _context.sent);
                            case 3:
                                _context.prev = 3;
                                _t = _context["catch"](1);
                                if (!(_t instanceof Error)) {
                                    _context.next = 4;
                                    break;
                                }
                                throw _t;
                            case 4:
                                throw Error('Failed to retrieve client sdk key');
                            case 5:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee, this, [
                        [
                            1,
                            3
                        ]
                    ]);
                }));
                function fetchClientSdkKey(_x, _x2) {
                    return _fetchClientSdkKey.apply(this, arguments);
                }
                return fetchClientSdkKey;
            }()
        },
        {
            key: "fetchExperimentValues",
            value: function() {
                var _fetchExperimentValues = (0, $6e21bf621ac7ad52$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($0d38c5f26e39e050$exports))).mark(function _callee2(clientVersion, fetcherOptions, identifiers, customAttributes) {
                    var requestBody, _t2;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($0d38c5f26e39e050$exports))).wrap(function(_context2) {
                        while(true)switch(_context2.prev = _context2.next){
                            case 0:
                                requestBody = {
                                    identifiers: identifiers,
                                    customAttributes: customAttributes,
                                    targetApp: fetcherOptions.targetApp
                                };
                                _context2.prev = 1;
                                _context2.next = 2;
                                return this.fetchRequest(clientVersion, "/api/".concat($c9a5c48359ec9830$export$1e164866fd37d1a9, "/frontend/experimentValues"), 'POST', fetcherOptions, requestBody);
                            case 2:
                                return _context2.abrupt("return", _context2.sent);
                            case 3:
                                _context2.prev = 3;
                                _t2 = _context2["catch"](1);
                                if (!(_t2 instanceof Error)) {
                                    _context2.next = 4;
                                    break;
                                }
                                throw _t2;
                            case 4:
                                throw Error('Failed to retrieve experiment values');
                            case 5:
                            case "end":
                                return _context2.stop();
                        }
                    }, _callee2, this, [
                        [
                            1,
                            3
                        ]
                    ]);
                }));
                function fetchExperimentValues(_x3, _x4, _x5, _x6) {
                    return _fetchExperimentValues.apply(this, arguments);
                }
                return fetchExperimentValues;
            }()
        },
        {
            key: "handleResponseError",
            value: function() {
                var _handleResponseError = (0, $6e21bf621ac7ad52$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($0d38c5f26e39e050$exports))).mark(function _callee3(response) {
                    var body;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($0d38c5f26e39e050$exports))).wrap(function(_context3) {
                        while(true)switch(_context3.prev = _context3.next){
                            case 0:
                                if (response.ok) {
                                    _context3.next = 2;
                                    break;
                                }
                                _context3.next = 1;
                                return response.text();
                            case 1:
                                body = _context3.sent;
                                throw new (0, $bd02c8853b179d7f$export$286baf652d0b1206)('Non 2xx response status received', response.status, JSON.stringify(body));
                            case 2:
                                if (!(response.status === 204)) {
                                    _context3.next = 3;
                                    break;
                                }
                                throw new (0, $bd02c8853b179d7f$export$286baf652d0b1206)('Unexpected 204 response', response.status, '');
                            case 3:
                            case "end":
                                return _context3.stop();
                        }
                    }, _callee3);
                }));
                function handleResponseError(_x7) {
                    return _handleResponseError.apply(this, arguments);
                }
                return handleResponseError;
            }()
        },
        {
            key: "extractResponseBody",
            value: function() {
                var _extractResponseBody = (0, $6e21bf621ac7ad52$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($0d38c5f26e39e050$exports))).mark(function _callee4(response) {
                    var value;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($0d38c5f26e39e050$exports))).wrap(function(_context4) {
                        while(true)switch(_context4.prev = _context4.next){
                            case 0:
                                _context4.next = 1;
                                return response.text();
                            case 1:
                                value = _context4.sent;
                                return _context4.abrupt("return", JSON.parse(value));
                            case 2:
                            case "end":
                                return _context4.stop();
                        }
                    }, _callee4);
                }));
                function extractResponseBody(_x8) {
                    return _extractResponseBody.apply(this, arguments);
                }
                return extractResponseBody;
            }()
        },
        {
            key: "getBaseUrl",
            value: function getBaseUrl(serviceEnv) {
                var useGatewayUrl = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
                var perimeter = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : (0, $07780b184f7941e6$export$c42b7bbc5e7ba555).COMMERCIAL;
                if (useGatewayUrl) return $c9a5c48359ec9830$export$450bd8fb2a6d7ace;
                if (perimeter === (0, $07780b184f7941e6$export$c42b7bbc5e7ba555).FEDRAMP_MODERATE) switch(serviceEnv){
                    case (0, $07780b184f7941e6$export$479e7351a733299).Production:
                        return $c9a5c48359ec9830$export$18c93900db9358a4;
                    case (0, $07780b184f7941e6$export$479e7351a733299).Staging:
                        return $c9a5c48359ec9830$export$1a401a0da8da3565;
                    default:
                        throw new Error("Invalid environment \"".concat(serviceEnv, "\" for \"").concat(perimeter, "\" perimeter"));
                }
                else if (perimeter === (0, $07780b184f7941e6$export$c42b7bbc5e7ba555).COMMERCIAL) switch(serviceEnv){
                    case (0, $07780b184f7941e6$export$479e7351a733299).Development:
                        return $c9a5c48359ec9830$export$f058dbf75c3bc647;
                    case (0, $07780b184f7941e6$export$479e7351a733299).Staging:
                        return $c9a5c48359ec9830$var$STAGING_BASE_URL;
                    default:
                        return $c9a5c48359ec9830$var$PROD_BASE_URL;
                }
                else throw new Error("Invalid perimeter \"".concat(perimeter, "\""));
            }
        },
        {
            key: "fetchRequest",
            value: function() {
                var _fetchRequest = (0, $6e21bf621ac7ad52$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($0d38c5f26e39e050$exports))).mark(function _callee5(clientVersion, path, method, fetcherOptions, body) {
                    var baseUrl, fetchTimeout, abortSignal, abortController, response;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($0d38c5f26e39e050$exports))).wrap(function(_context5) {
                        while(true)switch(_context5.prev = _context5.next){
                            case 0:
                                baseUrl = Fetcher.getBaseUrl(fetcherOptions.environment, fetcherOptions.useGatewayURL, fetcherOptions.perimeter);
                                fetchTimeout = fetcherOptions.fetchTimeoutMs || $c9a5c48359ec9830$var$DEFAULT_REQUEST_TIMEOUT_MS;
                                if (AbortSignal.timeout) abortSignal = AbortSignal.timeout(fetchTimeout);
                                else if (AbortController) {
                                    abortController = new AbortController();
                                    abortSignal = abortController.signal;
                                    setTimeout(function() {
                                        return abortController.abort();
                                    }, fetchTimeout);
                                }
                                _context5.next = 1;
                                return fetch("".concat(baseUrl).concat(path), $c9a5c48359ec9830$var$_objectSpread({
                                    method: method,
                                    headers: {
                                        'Content-Type': 'application/json',
                                        'X-Client-Name': 'feature-gate-js-client',
                                        'X-Client-Version': clientVersion,
                                        'X-API-KEY': fetcherOptions.apiKey
                                    },
                                    signal: abortSignal
                                }, body && {
                                    body: JSON.stringify(body)
                                }));
                            case 1:
                                response = _context5.sent;
                                _context5.next = 2;
                                return this.handleResponseError(response);
                            case 2:
                                _context5.next = 3;
                                return this.extractResponseBody(response);
                            case 3:
                                return _context5.abrupt("return", _context5.sent);
                            case 4:
                            case "end":
                                return _context5.stop();
                        }
                    }, _callee5, this);
                }));
                function fetchRequest(_x9, _x0, _x1, _x10, _x11) {
                    return _fetchRequest.apply(this, arguments);
                }
                return fetchRequest;
            }()
        }
    ]);
}();


function $307b9299ea24af61$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $307b9299ea24af61$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $307b9299ea24af61$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $6fbeb86b9c32bffe$export$2e2bcd8739ae039)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $307b9299ea24af61$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $307b9299ea24af61$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function SingleFetchProvider(providerOptions) {
        (0, $7b8cfc107c5bc2b0$export$2e2bcd8739ae039)(this, SingleFetchProvider);
        this.providerOptions = providerOptions;
    }
    return (0, $b06466c6dea794c2$export$2e2bcd8739ae039)(SingleFetchProvider, [
        {
            key: "setClientVersion",
            value: function setClientVersion(clientVersion) {
                this.clientVersion = clientVersion;
            }
        },
        {
            key: "setProfile",
            value: function() {
                var _setProfile = (0, $9ccdc4f4f7ddb8cb$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($02f82983ae119447$exports))).mark(function _callee(clientOptions, identifiers, customAttributes) {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($02f82983ae119447$exports))).wrap(function(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                this.clientOptions = clientOptions;
                                this.identifiers = identifiers;
                                this.customAttributes = customAttributes;
                            case 1:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee, this);
                }));
                function setProfile(_x, _x2, _x3) {
                    return _setProfile.apply(this, arguments);
                }
                return setProfile;
            }()
        },
        {
            key: "getExperimentValues",
            value: function() {
                var _getExperimentValues = (0, $9ccdc4f4f7ddb8cb$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($02f82983ae119447$exports))).mark(function _callee2() {
                    var fetcherOptions;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($02f82983ae119447$exports))).wrap(function(_context2) {
                        while(true)switch(_context2.prev = _context2.next){
                            case 0:
                                if (this.clientVersion) {
                                    _context2.next = 1;
                                    break;
                                }
                                throw new Error('Client version has not been set');
                            case 1:
                                if (!(!this.clientOptions || !this.identifiers)) {
                                    _context2.next = 2;
                                    break;
                                }
                                throw new Error('Profile has not been set');
                            case 2:
                                fetcherOptions = $307b9299ea24af61$var$_objectSpread($307b9299ea24af61$var$_objectSpread({}, this.clientOptions), this.providerOptions);
                                _context2.next = 3;
                                return (0, $c9a5c48359ec9830$export$2e2bcd8739ae039).fetchExperimentValues(this.clientVersion, fetcherOptions, this.identifiers, this.customAttributes).then(function(result) {
                                    return {
                                        experimentValues: result.experimentValues,
                                        customAttributesFromFetch: result.customAttributes,
                                        clientSdkKey: result.clientSdkKey
                                    };
                                });
                            case 3:
                                return _context2.abrupt("return", _context2.sent);
                            case 4:
                            case "end":
                                return _context2.stop();
                        }
                    }, _callee2, this);
                }));
                function getExperimentValues() {
                    return _getExperimentValues.apply(this, arguments);
                }
                return getExperimentValues;
            }()
        },
        {
            key: "getClientSdkKey",
            value: function() {
                var _getClientSdkKey = (0, $9ccdc4f4f7ddb8cb$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($02f82983ae119447$exports))).mark(function _callee3() {
                    var fetcherOptions, result;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($02f82983ae119447$exports))).wrap(function(_context3) {
                        while(true)switch(_context3.prev = _context3.next){
                            case 0:
                                if (this.clientVersion) {
                                    _context3.next = 1;
                                    break;
                                }
                                throw new Error('Client version has not been set');
                            case 1:
                                if (this.clientOptions) {
                                    _context3.next = 2;
                                    break;
                                }
                                throw new Error('Profile has not been set');
                            case 2:
                                fetcherOptions = $307b9299ea24af61$var$_objectSpread($307b9299ea24af61$var$_objectSpread({}, this.clientOptions), this.providerOptions);
                                _context3.next = 3;
                                return (0, $c9a5c48359ec9830$export$2e2bcd8739ae039).fetchClientSdkKey(this.clientVersion, fetcherOptions);
                            case 3:
                                result = _context3.sent;
                                return _context3.abrupt("return", result.clientSdkKey);
                            case 4:
                            case "end":
                                return _context3.stop();
                        }
                    }, _callee3, this);
                }));
                function getClientSdkKey() {
                    return _getClientSdkKey.apply(this, arguments);
                }
                return getClientSdkKey;
            }()
        },
        {
            key: "getApiKey",
            value: function getApiKey() {
                return this.providerOptions.apiKey;
            }
        }
    ]);
}();



var $2gmBL = parcelRequire("2gmBL");

var $9KGFe = parcelRequire("9KGFe");

var $6hgMx = parcelRequire("6hgMx");

var $guDjK = parcelRequire("guDjK");
const { statsigApiKey: $4d76345881dceb9a$var$statsigApiKey, featureGateEnvironment: $4d76345881dceb9a$var$featureGateEnvironment, featureGatePerimeter: $4d76345881dceb9a$var$featureGatePerimeter } = (0, $9KGFe.getConfig)();
const $4d76345881dceb9a$var$TARGET_APP = 'oauth-consent_web';
/**
 * Initializes Statsig feature gates for the oauth-consent app.
 *
 * Must be rendered inside ConsentContextProvider so that consent token fields
 * (userId, clientId, profile, customer) are available for Statsig targeting.
 *
 * Uses SingleFetchProvider for efficient single-request gate evaluation.
 *
 * Children are rendered regardless of initialization status — feature gates
 * default to false until initialization completes (fail-safe pattern).
 */ const $4d76345881dceb9a$var$FeatureGateProvider = ({ children: children })=>{
    const token = (0, $6hgMx.useToken)();
    const analytics = (0, $guDjK.useAnalytics)();
    const provider = (0, $5FkrB.useMemo)(()=>new (0, $307b9299ea24af61$export$2e2bcd8739ae039)({
            apiKey: $4d76345881dceb9a$var$statsigApiKey
        }), []);
    const identifiers = (0, $5FkrB.useMemo)(()=>({
            atlassianAccountId: token.userId
        }), [
        token.userId
    ]);
    const customAttributes = (0, $5FkrB.useMemo)(()=>({
            ...token.clientId && {
                clientId: token.clientId
            },
            ...token.profile && {
                profileName: token.profile
            },
            ...token.customer && {
                customerName: token.customer
            }
        }), [
        token.clientId,
        token.customer,
        token.profile
    ]);
    return /*#__PURE__*/ (0, $i3UfC.jsx)((0, $2gmBL.FeatureGatesInitializationWithProvider), {
        enabled: true,
        options: {
            targetApp: $4d76345881dceb9a$var$TARGET_APP,
            environment: $4d76345881dceb9a$var$featureGateEnvironment,
            perimeter: $4d76345881dceb9a$var$featureGatePerimeter,
            analyticsWebClient: Promise.resolve(analytics.getAnalyticsWebClient())
        },
        onReady: (error)=>{
            if (error) console.error('Could not initialise feature flags', error);
        },
        identifiers: identifiers,
        customAttributes: customAttributes,
        provider: provider,
        children: children
    });
};
var $4d76345881dceb9a$export$2e2bcd8739ae039 = $4d76345881dceb9a$var$FeatureGateProvider;



var $f5RPY = parcelRequire("f5RPY");
const $58dbdc05629bdeb7$export$86fbec116b87613f = ()=>{
    (0, $5FkrB.useEffect)(()=>{
        (0, $9a4b3b2d125ade05$export$fd7e0dd2b74807f7)().catch((e)=>console.warn('Theme failed to load', e));
    }, []);
    return /*#__PURE__*/ (0, $i3UfC.jsx)((0, $f5RPY.AccountClientProvider), {
        children: /*#__PURE__*/ (0, $i3UfC.jsx)((0, $c416c85ddfb75237$export$2e2bcd8739ae039), {
            children: /*#__PURE__*/ (0, $i3UfC.jsx)((0, $guDjK.default), {
                loading: /*#__PURE__*/ (0, $i3UfC.jsx)((0, $abc2d3ba24694c46$export$2e2bcd8739ae039), {}),
                children: /*#__PURE__*/ (0, $i3UfC.jsx)((0, $063a78bab069f1c1$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $i3UfC.jsx)((0, $6hgMx.default), {
                        loading: /*#__PURE__*/ (0, $i3UfC.jsx)((0, $abc2d3ba24694c46$export$2e2bcd8739ae039), {}),
                        children: /*#__PURE__*/ (0, $i3UfC.jsx)((0, $4d76345881dceb9a$export$2e2bcd8739ae039), {
                            children: /*#__PURE__*/ (0, $i3UfC.jsx)((0, $de866f59adb9a0f9$export$93b27837988a39ef), {
                                children: /*#__PURE__*/ (0, $i3UfC.jsx)((0, $5FkrB.Suspense), {
                                    fallback: /*#__PURE__*/ (0, $i3UfC.jsx)((0, $abc2d3ba24694c46$export$2e2bcd8739ae039), {}),
                                    children: /*#__PURE__*/ (0, $i3UfC.jsxs)((0, $b550a1f730f79a9b$export$2e2bcd8739ae039), {
                                        children: [
                                            /*#__PURE__*/ (0, $i3UfC.jsx)((0, $105a7c2c89bf6f3c$export$2e2bcd8739ae039), {}),
                                            /*#__PURE__*/ (0, $i3UfC.jsx)((0, $0b354a69a2959049$export$2e2bcd8739ae039), {
                                                children: /*#__PURE__*/ (0, $i3UfC.jsx)((0, $0e3ee9c77d0b46e6$export$2e2bcd8739ae039), {})
                                            })
                                        ]
                                    })
                                })
                            })
                        })
                    })
                })
            })
        })
    });
};


(0, $7d59b24134129acf$exports.render)(/*#__PURE__*/ (0, $i3UfC.jsx)((0, $58dbdc05629bdeb7$export$86fbec116b87613f), {}), document.getElementById('root'));


//# sourceMappingURL=index.d96e527b.js.map
